// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"dP88C":[function(require,module,exports,__globalThis) {
require("ff59bc7b1d73c7b4").register(require("fe40aeb5fc524ad8").getBundleURL('eAbh3'), JSON.parse("[\"eAbh3\",\"index.3d203811.js\",\"6JpH7\",\"gear.0967cf89.png\",\"lQVGs\",\"Roboto-Regular.6958d21f.ttf\",\"hz6Mt\",\"Roboto-Black.06dcdaf2.ttf\",\"1AajJ\",\"checkmark.12d648d8.png\",\"llQnZ\",\"index.ce29d856.css\"]"));

},{"ff59bc7b1d73c7b4":"gSiLw","fe40aeb5fc524ad8":"a2ypy"}],"gSiLw":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"a2ypy":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"3GKxx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _browser = require("./diagnostics/browser");
var _elementClosest = require("element-closest");
var _react = require("external/react");
var _serializeError = require("serialize-error");
var _serializeErrorDefault = parcelHelpers.interopDefault(_serializeError);
var _post = require("./context/post");
var _url = require("./helpers/url");
var _router = require("./router");
var _routerDefault = parcelHelpers.interopDefault(_router);
var _indexStyl = require("./index.styl");
var _store = require("uploads/redux/store");
var _storeDefault = parcelHelpers.interopDefault(_store);
function setScreenHeight() {
    document.querySelector(':root').style.setProperty('--screen-height', `${window.innerHeight}px`);
}
window.addEventListener('resize', setScreenHeight);
window.addEventListener('load', setScreenHeight);
setScreenHeight();
setTimeout(setScreenHeight, 3000);
window.onChatContainer = function(container, pageName) {
    const $chat = document.getElementById('chat');
    if (pageName == 'chat') {
        if (!$chat.src) $chat.src = (0, _url.subdomainLink)('talk');
        $chat.style.display = 'block';
        $chat.style.position = 'absolute';
        $chat.style.top = container.offsetTop + 'px';
        $chat.style.left = container.offsetLeft + 'px';
        $chat.style.width = container.clientWidth + 'px';
        $chat.style.height = container.clientHeight + 'px';
    } else $chat.style.display = 'none';
};
function renderApp(App) {
    const root = (0, _react.createRoot)(document.getElementById('root'));
    root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.HashRouter), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.ReduxProvider), {
            store: (0, _storeDefault.default),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(App, {})
        })
    }));
}
async function goToClassic(error) {
    const environment = "production";
    if (environment != 'development') {
        await (0, _post.switchToClassic)(error ? (0, _serializeErrorDefault.default)(error) : undefined);
        location.replace(`//${(0, _url.subdomainResource)('www')}`);
    } else console.log(error);
}
async function handleLoadingError() {
    const environment = "production";
    if (environment != 'development') try {
        return await (0, _post.logout)();
    } finally{
        return location.replace(`//${(0, _url.subdomainResource)('www')}`);
    }
    else console.log(arguments);
}
(0, _routerDefault.default)().then(renderApp).catch(handleLoadingError);

},{"react/jsx-runtime":"1dlk8","./diagnostics/browser":"15EfF","element-closest":"6LkRG","external/react":"k16GP","serialize-error":"6hdws","./context/post":"8rmpk","./helpers/url":"65SQD","./router":"5VRKp","./index.styl":"aBKOk","uploads/redux/store":"l92tZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1dlk8":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"8eUfv"}],"8eUfv":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"9njXz"}],"9njXz":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"kgZgX"}],"kgZgX":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"15EfF":[function(require,module,exports,__globalThis) {
// Development-only; do not send request bodies or arbitrary console objects.
var event, event1;

},{}],"6LkRG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function polyfill(window) {
    var ElementPrototype = window.Element.prototype;
    if (typeof ElementPrototype.matches !== 'function') ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.webkitMatchesSelector || function matches(selector) {
        var element = this;
        var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
        var index = 0;
        while(elements[index] && elements[index] !== element)++index;
        return Boolean(elements[index]);
    };
    if (typeof ElementPrototype.closest !== 'function') ElementPrototype.closest = function closest(selector) {
        var element = this;
        while(element && element.nodeType === 1){
            if (element.matches(selector)) return element;
            element = element.parentNode;
        }
        return null;
    };
}
exports.default = polyfill;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiucr":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"k16GP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stringifyQueryString", ()=>(0, _queryString.stringify));
parcelHelpers.export(exports, "parseQueryString", ()=>(0, _queryString.parse));
parcelHelpers.export(exports, "createRoot", ()=>(0, _client.createRoot));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouterDom.Redirect));
parcelHelpers.export(exports, "HashRouter", ()=>(0, _reactRouterDom.HashRouter));
parcelHelpers.export(exports, "NavLink", ()=>(0, _reactRouterDom.NavLink));
parcelHelpers.export(exports, "Link", ()=>(0, _reactRouterDom.Link));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouterDom.Switch));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouterDom.Route));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouterDom.useParams));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouterDom.useHistory));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouterDom.matchPath));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouterDom.generatePath));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouterDom.useLocation));
parcelHelpers.export(exports, "React", ()=>(0, _reactDefault.default));
parcelHelpers.export(exports, "useMemo", ()=>(0, _react.useMemo));
parcelHelpers.export(exports, "useCallback", ()=>(0, _react.useCallback));
parcelHelpers.export(exports, "createContext", ()=>(0, _react.createContext));
parcelHelpers.export(exports, "useReducer", ()=>(0, _react.useReducer));
parcelHelpers.export(exports, "createElement", ()=>(0, _react.createElement));
parcelHelpers.export(exports, "createRef", ()=>(0, _react.createRef));
parcelHelpers.export(exports, "forwardRef", ()=>(0, _react.forwardRef));
parcelHelpers.export(exports, "useContext", ()=>(0, _react.useContext));
parcelHelpers.export(exports, "useRef", ()=>(0, _react.useRef));
parcelHelpers.export(exports, "useLayoutEffect", ()=>(0, _react.useLayoutEffect));
parcelHelpers.export(exports, "useEffect", ()=>(0, _react.useEffect));
parcelHelpers.export(exports, "Fragment", ()=>(0, _react.Fragment));
parcelHelpers.export(exports, "useState", ()=>(0, _react.useState));
parcelHelpers.export(exports, "connect", ()=>(0, _reactRedux.connect));
parcelHelpers.export(exports, "ReduxProvider", ()=>(0, _reactRedux.Provider));
parcelHelpers.export(exports, "createStore", ()=>(0, _redux.createStore));
parcelHelpers.export(exports, "applyMiddleware", ()=>(0, _redux.applyMiddleware));
parcelHelpers.export(exports, "compose", ()=>(0, _redux.compose));
parcelHelpers.export(exports, "combineReducers", ()=>(0, _redux.combineReducers));
parcelHelpers.export(exports, "thunk", ()=>(0, _reduxThunkDefault.default));
parcelHelpers.export(exports, "DatePicker", ()=>(0, _reactDatepickerDefault.default));
parcelHelpers.export(exports, "registerDatePickerLocale", ()=>(0, _reactDatepicker.registerLocale));
parcelHelpers.export(exports, "confirmAlert", ()=>(0, _reactConfirmAlert.confirmAlert));
parcelHelpers.export(exports, "Select", ()=>(0, _reactSelectDefault.default));
parcelHelpers.export(exports, "CustomDateInput", ()=>CustomDateInput);
parcelHelpers.export(exports, "autoSet", ()=>autoSet);
parcelHelpers.export(exports, "autoCommand", ()=>autoCommand);
parcelHelpers.export(exports, "useScrollToRefChange", ()=>useScrollToRefChange);
var _queryString = require("query-string");
var _client = require("react-dom/client");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _reduxThunk = require("redux-thunk");
var _reduxThunkDefault = parcelHelpers.interopDefault(_reduxThunk);
var _reactDatepicker = require("react-datepicker");
var _dateFns = require("./date-fns");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactConfirmAlertCss = require("react-confirm-alert/src/react-confirm-alert.css");
var _reactConfirmAlert = require("react-confirm-alert");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
Object.entries((0, _dateFns.locales)).forEach(([key, locale])=>{
    (0, _reactDatepicker.registerLocale)(key, locale);
});
const CustomDateInput = (0, _react.forwardRef)((props, _ref)=>(0, _react.createElement)('div', {
        className: 'date-input',
        onClick: props.onClick
    }, props.value));
function autoSet(value, ...keys) {
    return autoCommand({
        $set: value
    }, ...keys);
}
function autoCommand(command, ...keys) {
    return keys.reduceRight((obj, key)=>({
            $auto: {
                [key]: obj
            }
        }), command);
}
function useScrollToRefChange(scrollOptions = {
    behavior: 'smooth'
}) {
    const ref = (0, _react.useRef)(null);
    const scrollToRef = (0, _react.useMemo)(()=>{
        return ()=>ref.current?.scrollIntoView(scrollOptions);
    }, [
        scrollOptions,
        ref.current
    ]);
    return [
        ref,
        scrollToRef
    ];
}

},{"query-string":"h6dFx","react-dom/client":"hx7eL","react-router-dom":"3uzXR","react":"9njXz","react-redux":"5DyKE","redux":"ikKU1","redux-thunk":"1uf85","react-datepicker":"cGh5X","./date-fns":"kwxNe","react-datepicker/dist/react-datepicker.css":"chsuV","react-confirm-alert/src/react-confirm-alert.css":"63bhO","react-confirm-alert":"dyW9k","react-select":"j36cq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6dFx":[function(require,module,exports,__globalThis) {
'use strict';
const strictUriEncode = require("5752d3663915398f");
const decodeComponent = require("4cbbda34882b91a3");
const splitOnFirst = require("53494decacb36d1b");
const filterObject = require("dfb8fa56cbbad4a5");
const isNullOrUndefined = (value)=>value === null || value === undefined;
function encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '[',
                            encode(index, options),
                            ']=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '[]=',
                            encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            encode(key, options),
                            '=',
                            encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            encode(key, options),
                            '=',
                            encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>decode(item, options)) : value === null ? value : decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function encode(value, options) {
    if (options.encode) return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
    return value;
}
function decode(value, options) {
    if (options.decode) return decodeComponent(value);
    return value;
}
function keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : decode(value, options);
        formatter(decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = parseValue(value[k], options);
        else ret[key] = parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
exports.extract = extract;
exports.parse = parse;
exports.stringify = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return encode(key, options) + '=' + encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
exports.parseUrl = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = splitOnFirst(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: parse(extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: decode(hash, options)
    } : {});
};
exports.stringifyUrl = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
exports.pick = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url, query, fragmentIdentifier } = exports.parseUrl(input, options);
    return exports.stringifyUrl({
        url,
        query: filterObject(query, filter),
        fragmentIdentifier
    }, options);
};
exports.exclude = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return exports.pick(input, exclusionFilter, options);
};

},{"5752d3663915398f":"59xgp","4cbbda34882b91a3":"diofT","53494decacb36d1b":"3Kl5z","dfb8fa56cbbad4a5":"d7zD9"}],"59xgp":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

},{}],"diofT":[function(require,module,exports,__globalThis) {
'use strict';
var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');
function decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}
function decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match(singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = decodeComponents(tokens, i).join('');
            tokens = input.match(singleMatcher) || [];
        }
        return input;
    }
}
function customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return customDecodeURIComponent(encodedURI);
    }
};

},{}],"3Kl5z":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

},{}],"d7zD9":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

},{}],"hx7eL":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"2ApDx"}],"2ApDx":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"3ekrv"}],"3ekrv":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"9njXz","ece50e903283a22f":"fMxFR"}],"fMxFR":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("62f08acde0c8aa34");

},{"62f08acde0c8aa34":"bBoyN"}],"bBoyN":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"3uzXR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Prompt", ()=>(0, _reactRouter.Prompt));
parcelHelpers.export(exports, "Redirect", ()=>(0, _reactRouter.Redirect));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "StaticRouter", ()=>(0, _reactRouter.StaticRouter));
parcelHelpers.export(exports, "Switch", ()=>(0, _reactRouter.Switch));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "useHistory", ()=>(0, _reactRouter.useHistory));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useRouteMatch", ()=>(0, _reactRouter.useRouteMatch));
parcelHelpers.export(exports, "withRouter", ()=>(0, _reactRouter.withRouter));
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
var _reactRouter = require("react-router");
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _history = require("history");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var HashRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, _reactDefault.default).Component);
var resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, _history.createLocation)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim(C) {
    return C;
};
var forwardRef = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef === "undefined") forwardRef = forwardRefShim;
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, _extendsDefault.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history;
        var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, _extendsDefault.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, _history.createPath)(context.location) === (0, _history.createPath)(normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if (forwardRefShim !== forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props);
    });
});
var toType, refType;
var forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var forwardRef$1 = (0, _reactDefault.default).forwardRef;
if (typeof forwardRef$1 === "undefined") forwardRef$1 = forwardRefShim$1;
function joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactRouter.__RouterContext).Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, _reactRouter.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = joinClassnames(className, activeClassName);
            style = (0, _extendsDefault.default)({}, style, activeStyle);
        }
        var props = (0, _extendsDefault.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if (forwardRefShim$1 !== forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Link, props);
    });
});
var ariaCurrentType;

},{"react-router":"hbNjF","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","history":"6go37","prop-types":"bnNSm","tiny-warning":"5e17w","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","tiny-invariant":"cKzLp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbNjF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Prompt", ()=>Prompt);
parcelHelpers.export(exports, "Redirect", ()=>Redirect);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "StaticRouter", ()=>StaticRouter);
parcelHelpers.export(exports, "Switch", ()=>Switch);
parcelHelpers.export(exports, "__HistoryContext", ()=>historyContext);
parcelHelpers.export(exports, "__RouterContext", ()=>context);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "useHistory", ()=>useHistory);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useRouteMatch", ()=>useRouteMatch);
parcelHelpers.export(exports, "withRouter", ()=>withRouter);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _history = require("history");
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _pathToRegexp = require("path-to-regexp");
var _pathToRegexpDefault = parcelHelpers.interopDefault(_pathToRegexp);
var _reactIs = require("react-is");
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var global = arguments[3];
var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof global !== "undefined" ? global // node.js
 : {};
function getUniqueId() {
    var key = "__global_unique_id__";
    return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, _inheritsLooseDefault.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, _reactDefault.default).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, _propTypesDefault.default).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, _inheritsLooseDefault.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, _reactDefault.default).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, _propTypesDefault.default).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var createContext = (0, _reactDefault.default).createContext || createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var createNamedContext = function createNamedContext(name) {
    var context = createContext();
    context.displayName = name;
    return context;
};
var historyContext = /*#__PURE__*/ createNamedContext("Router-History");
var context = /*#__PURE__*/ createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var Router = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(historyContext.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, _reactDefault.default).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var MemoryRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, _history.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, _reactDefault.default).Component);
var Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, _reactDefault.default).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function Prompt(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var messageType;
var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0, _pathToRegexpDefault.default).compile(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function generatePath(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function Redirect(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
        !context && (0, _tinyInvariantDefault.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, _history.createLocation)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0, _extendsDefault.default)({}, to, {
            pathname: generatePath(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, _history.createLocation)(prevProps.to);
                if (!(0, _history.locationsAreEqual)(prevLocation, (0, _extendsDefault.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, _pathToRegexpDefault.default)(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if (cacheCount$1 < cacheLimit$1) {
        pathCache[path] = result;
        cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function matchPath(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function isEmptyChildren(children) {
    return (0, _reactDefault.default).Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var Route = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context$1) {
            !context$1 && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
            var props = (0, _extendsDefault.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, _reactDefault.default).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, _reactDefault.default).Component);
function addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
    if (!basename) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: addLeadingSlash(basename) + location.pathname
    });
}
function stripBasename(basename, location) {
    if (!basename) return location;
    var base = addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, _extendsDefault.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function createURL(location) {
    return typeof location === "string" ? location : (0, _history.createPath)(location);
}
function staticHandler(methodName) {
    return function() {
        (0, _tinyInvariantDefault.default)(false);
    };
}
function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var StaticRouter = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return noop;
        };
        _this.handleBlock = function() {
            return noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = addBasename(basename, (0, _history.createLocation)(location));
        context.url = createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return addLeadingSlash(basename + createURL(path));
            },
            action: "POP",
            location: stripBasename(basename, (0, _history.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: staticHandler("go"),
            goBack: staticHandler("goBack"),
            goForward: staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(Router, (0, _extendsDefault.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, _reactDefault.default).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var Switch = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, _reactDefault.default).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? matchPath(location.pathname, (0, _extendsDefault.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, _reactDefault.default).Component);
/**
 * A public higher-order component to access the imperative API
 */ function withRouter(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(context.Consumer, null, function(context) {
            !context && (0, _tinyInvariantDefault.default)(false);
            return /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, (0, _extendsDefault.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, _hoistNonReactStaticsDefault.default)(C, Component);
}
var useContext = (0, _reactDefault.default).useContext;
function useHistory() {
    return useContext(historyContext);
}
function useLocation() {
    return useContext(context).location;
}
function useParams() {
    var match = useContext(context).match;
    return match ? match.params : {};
}
function useRouteMatch(path) {
    var location = useLocation();
    var match = useContext(context).match;
    return path ? matchPath(location.pathname, path) : match;
}
var global$1, key, buildNames, initialBuildName, secondaryBuildName;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","history":"6go37","tiny-warning":"5e17w","tiny-invariant":"cKzLp","@babel/runtime/helpers/esm/extends":"aAOJb","path-to-regexp":"18Yrh","react-is":"3b6hO","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cnxy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UMxe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnNSm":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"aLk8j"}],"aLk8j":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"di8d9"}],"di8d9":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"6go37":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createLocation", ()=>createLocation);
parcelHelpers.export(exports, "locationsAreEqual", ()=>locationsAreEqual);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "createPath", ()=>createPath);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _resolvePathname = require("resolve-pathname");
var _resolvePathnameDefault = parcelHelpers.interopDefault(_resolvePathname);
var _valueEqual = require("value-equal");
var _valueEqualDefault = parcelHelpers.interopDefault(_valueEqual);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
    return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function createLocation(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = parsePath(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, _extendsDefault.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, _resolvePathnameDefault.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqualDefault.default)(a.state, b.state);
}
function createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';
function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function createBrowserHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canUseHistory = supportsHistory();
    var needsHashChangeListener = !supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = stripBasename(path, basename);
        return createLocation(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if (isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation(getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation(getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + createPath(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener(PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: stripLeadingSlash,
        decodePath: addLeadingSlash
    },
    slash: {
        encodePath: addLeadingSlash,
        decodePath: addLeadingSlash
    }
};
function stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
    window.location.hash = path;
}
function replaceHashPath(path) {
    window.location.replace(stripHash(window.location.href) + '#' + path);
}
function createHashHistory(props) {
    if (props === void 0) props = {};
    !canUseDOM && (0, _tinyInvariantDefault.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath(getHashPath());
        if (basename) path = stripBasename(path, basename);
        return createLocation(path);
    }
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf(createPath(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        createPath(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = stripHash(window.location.href);
        return href + '#' + encodePath(basename + createPath(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf(createPath(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = createPath(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf(createPath(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener(HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function createMemoryHistory(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = createTransitionManager();
    function setState(nextState) {
        (0, _extendsDefault.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = createPath;
    function push(path, state) {
        var action = 'PUSH';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = createLocation(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","resolve-pathname":"2gZcD","value-equal":"jH0rl","tiny-warning":"5e17w","tiny-invariant":"cKzLp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAOJb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2gZcD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && isAbsolute(to);
    var isFromAbs = from && isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') spliceOne(fromParts, i);
        else if (part === '..') {
            spliceOne(fromParts, i);
            up++;
        } else if (up) {
            spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
exports.default = resolvePathname;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jH0rl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = valueOf(a);
        var bValue = valueOf(b);
        if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return valueEqual(a[key], b[key]);
        });
    }
    return false;
}
exports.default = valueEqual;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5e17w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var isProduction = true;
function warning(condition, message) {
    if (!isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
exports.default = warning;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cKzLp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18Yrh":[function(require,module,exports,__globalThis) {
var isarray = require("cf8c389b9beef7f4");
/**
 * Expose `pathToRegexp`.
 */ module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + escapeString(delimiter) + ']+?';
    return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if (isarray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push(pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));
    return attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegExp(parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function tokensToRegExp(tokens, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += escapeString(token);
        else {
            var prefix = escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return attachKeys(new RegExp('^' + route, flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function pathToRegexp(path, keys, options) {
    if (!isarray(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return regexpToRegexp(path, /** @type {!Array} */ keys);
    if (isarray(path)) return arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

},{"cf8c389b9beef7f4":"9lLfI"}],"9lLfI":[function(require,module,exports,__globalThis) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};

},{}],"3b6hO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"easHU"}],"easHU":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"jGdYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Kh2":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"3b6hO"}],"5DyKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", ()=>(0, _reactBatchedUpdates.unstable_batchedUpdates));
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch"); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"./exports":"iw5OK","./utils/reactBatchedUpdates":"czlKX","./utils/batch":"3QbYr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iw5OK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "connectAdvanced", ()=>(0, _connectAdvancedDefault.default));
parcelHelpers.export(exports, "ReactReduxContext", ()=>(0, _context.ReactReduxContext));
parcelHelpers.export(exports, "connect", ()=>(0, _connectDefault.default));
parcelHelpers.export(exports, "useDispatch", ()=>(0, _useDispatch.useDispatch));
parcelHelpers.export(exports, "createDispatchHook", ()=>(0, _useDispatch.createDispatchHook));
parcelHelpers.export(exports, "useSelector", ()=>(0, _useSelector.useSelector));
parcelHelpers.export(exports, "createSelectorHook", ()=>(0, _useSelector.createSelectorHook));
parcelHelpers.export(exports, "useStore", ()=>(0, _useStore.useStore));
parcelHelpers.export(exports, "createStoreHook", ()=>(0, _useStore.createStoreHook));
parcelHelpers.export(exports, "shallowEqual", ()=>(0, _shallowEqualDefault.default));
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connectAdvanced = require("./components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _context = require("./components/Context");
var _connect = require("./connect/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);

},{"./components/Provider":"6Zf6f","./components/connectAdvanced":"CRPbv","./components/Context":"d7pPF","./connect/connect":"gM7QG","./hooks/useDispatch":"b8uv3","./hooks/useSelector":"jdZfi","./hooks/useStore":"2t65h","./utils/shallowEqual":"2ovfJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Zf6f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, _react.useMemo)(function() {
        var subscription = (0, _subscription.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, _react.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, _context.ReactReduxContext);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"9njXz","prop-types":"bnNSm","./Context":"d7pPF","../utils/Subscription":"4gS0I","../utils/useIsomorphicLayoutEffect":"9y2R9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7pPF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ReactReduxContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
exports.default = ReactReduxContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gS0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", ()=>createSubscription);
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    var batch = (0, _batch.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

},{"./batch":"3QbYr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QbYr":[function(require,module,exports,__globalThis) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", ()=>setBatch);
parcelHelpers.export(exports, "getBatch", ()=>getBatch);
function defaultNoopBatch(callback) {
    callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later
var setBatch = function setBatch(newBatch) {
    return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var getBatch = function getBatch() {
    return batch;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9y2R9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CRPbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>connectAdvanced);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIs = require("react-is");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("./Context"); // Define some constant arrays just to avoid re-creating these
var _excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], _excluded2 = [
    "reactReduxForwardedRef"
];
var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function connectAdvanced(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, _context.ReactReduxContext) : _ref2$context, connectOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, _extendsDefault.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, _react.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, _react.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, _react.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)(/*#__PURE__*/ (0, _reactDefault.default).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, _react.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, _react.useMemo)(function() {
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, _react.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, _react.useRef)();
            var lastWrapperProps = (0, _react.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, _react.useRef)();
            var renderIsScheduled = (0, _react.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, _react.useMemo)(function() {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, _react.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, _reactDefault.default).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, _reactDefault.default).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, _reactDefault.default).createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","hoist-non-react-statics":"59Kh2","react":"9njXz","react-is":"halvy","../utils/Subscription":"4gS0I","../utils/useIsomorphicLayoutEffect":"9y2R9","./Context":"d7pPF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"halvy":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c09df6e873313925");

},{"c09df6e873313925":"aIgSz"}],"aIgSz":[function(require,module,exports,__globalThis) {
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var x = Symbol.for;
    b = x("react.element");
    c = x("react.portal");
    d = x("react.fragment");
    e = x("react.strict_mode");
    f = x("react.profiler");
    g = x("react.provider");
    h = x("react.context");
    k = x("react.forward_ref");
    l = x("react.suspense");
    m = x("react.suspense_list");
    n = x("react.memo");
    p = x("react.lazy");
    q = x("react.block");
    r = x("react.server.block");
    u = x("react.fundamental");
    v = x("react.debug_trace_mode");
    w = x("react.legacy_hidden");
}
function y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case l:
                    case m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case h:
                            case k:
                            case p:
                            case n:
                            case g:
                                return a;
                            default:
                                return t;
                        }
                }
            case c:
                return t;
        }
    }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
exports.ContextConsumer = h;
exports.ContextProvider = z;
exports.Element = A;
exports.ForwardRef = B;
exports.Fragment = C;
exports.Lazy = D;
exports.Memo = E;
exports.Portal = F;
exports.Profiler = G;
exports.StrictMode = H;
exports.Suspense = I;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return y(a) === h;
};
exports.isContextProvider = function(a) {
    return y(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return y(a) === k;
};
exports.isFragment = function(a) {
    return y(a) === d;
};
exports.isLazy = function(a) {
    return y(a) === p;
};
exports.isMemo = function(a) {
    return y(a) === n;
};
exports.isPortal = function(a) {
    return y(a) === c;
};
exports.isProfiler = function(a) {
    return y(a) === f;
};
exports.isStrictMode = function(a) {
    return y(a) === e;
};
exports.isSuspense = function(a) {
    return y(a) === l;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? !0 : !1;
};
exports.typeOf = y;

},{}],"gM7QG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// different options opens up some testing and extensibility scenarios
parcelHelpers.export(exports, "createConnect", ()=>createConnect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _connectAdvanced = require("../components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _mapDispatchToProps = require("./mapDispatchToProps");
var _mapDispatchToPropsDefault = parcelHelpers.interopDefault(_mapDispatchToProps);
var _mapStateToProps = require("./mapStateToProps");
var _mapStateToPropsDefault = parcelHelpers.interopDefault(_mapStateToProps);
var _mergeProps = require("./mergeProps");
var _mergePropsDefault = parcelHelpers.interopDefault(_mergeProps);
var _selectorFactory = require("./selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function createConnect(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, _connectAdvancedDefault.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, _mapStateToPropsDefault.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, _mapDispatchToPropsDefault.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, _mergePropsDefault.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, _selectorFactoryDefault.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areMergedPropsE, extraOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref3, _excluded);
        var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, _extendsDefault.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
exports.default = /*#__PURE__*/ createConnect();

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","../components/connectAdvanced":"CRPbv","../utils/shallowEqual":"2ovfJ","./mapDispatchToProps":"fLd6L","./mapStateToProps":"gQxwI","./mergeProps":"5ZrHy","./selectorFactory":"fMozN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ovfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fLd6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsFunction", ()=>whenMapDispatchToPropsIsFunction);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsMissing", ()=>whenMapDispatchToPropsIsMissing);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsObject", ()=>whenMapDispatchToPropsIsObject);
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
exports.default = [
    whenMapDispatchToPropsIsFunction,
    whenMapDispatchToPropsIsMissing,
    whenMapDispatchToPropsIsObject
];

},{"../utils/bindActionCreators":"dPxnl","./wrapMapToProps":"9sZ9X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPxnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bindActionCreators);
function bindActionCreators(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9sZ9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", ()=>wrapMapToPropsConstant) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
parcelHelpers.export(exports, "getDependsOnOwnProps", ()=>getDependsOnOwnProps) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", ()=>wrapMapToPropsFunc);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"fAwaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fAwaf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifyPlainObject);
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

},{"./isPlainObject":"626mb","./warning":"9tQ5l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"626mb":[function(require,module,exports,__globalThis) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPlainObject);
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tQ5l":[function(require,module,exports,__globalThis) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQxwI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapStateToPropsIsFunction", ()=>whenMapStateToPropsIsFunction);
parcelHelpers.export(exports, "whenMapStateToPropsIsMissing", ()=>whenMapStateToPropsIsMissing);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapStateToPropsIsFunction(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
exports.default = [
    whenMapStateToPropsIsFunction,
    whenMapStateToPropsIsMissing
];

},{"./wrapMapToProps":"9sZ9X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ZrHy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", ()=>defaultMergeProps);
parcelHelpers.export(exports, "wrapMergePropsFunc", ()=>wrapMergePropsFunc);
parcelHelpers.export(exports, "whenMergePropsIsFunction", ()=>whenMergePropsIsFunction);
parcelHelpers.export(exports, "whenMergePropsIsOmitted", ()=>whenMergePropsIsOmitted);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function whenMergePropsIsFunction(mergeProps) {
    return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : undefined;
}
exports.default = [
    whenMergePropsIsFunction,
    whenMergePropsIsOmitted
];

},{"@babel/runtime/helpers/esm/extends":"aAOJb","../utils/verifyPlainObject":"fAwaf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMozN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "impureFinalPropsSelectorFactory", ()=>impureFinalPropsSelectorFactory);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", ()=>pureFinalPropsSelectorFactory) // TODO: Add more comments
;
parcelHelpers.export(exports, "default", ()=>finalPropsSelectorFactory);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
var _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, _excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","./verifySubselectors":"g8pTJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g8pTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifySubselectors);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, _warningDefault.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    verify(mapStateToProps, 'mapStateToProps', displayName);
    verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    verify(mergeProps, 'mergeProps', displayName);
}

},{"../utils/warning":"9tQ5l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b8uv3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"d7pPF","./useStore":"2t65h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2t65h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "useStore", ()=>useStore);
var _react = require("react");
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var useStore = /*#__PURE__*/ createStoreHook();

},{"react":"9njXz","../components/Context":"d7pPF","./useReduxContext":"jdjJX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdjJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */ parcelHelpers.export(exports, "useReduxContext", ()=>useReduxContext);
var _react = require("react");
var _context = require("../components/Context");
function useReduxContext() {
    var contextValue = (0, _react.useContext)((0, _context.ReactReduxContext));
    return contextValue;
}

},{"react":"9njXz","../components/Context":"d7pPF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdZfi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _context = require("../components/Context");
var refEquality = function refEquality(a, b) {
    return a === b;
};
function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, _react.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, _react.useMemo)(function() {
        return (0, _subscription.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, _react.useRef)();
    var latestSelector = (0, _react.useRef)();
    var latestStoreState = (0, _react.useRef)();
    var latestSelectedState = (0, _react.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function createSelectorHook(context) {
    if (context === void 0) context = (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : function() {
        return (0, _react.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
var useSelector = /*#__PURE__*/ createSelectorHook();

},{"react":"9njXz","./useReduxContext":"jdjJX","../utils/Subscription":"4gS0I","../utils/useIsomorphicLayoutEffect":"9y2R9","../components/Context":"d7pPF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czlKX":[function(require,module,exports,__globalThis) {
/* eslint-disable import/no-unresolved */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", ()=>(0, _reactDom.unstable_batchedUpdates));
var _reactDom = require("react-dom");

},{"react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikKU1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if (isDate(val)) return 'date';
    if (isError(val)) return 'error';
    var constructorName = ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error(formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error(formatProdErrorMessage(8));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === 'undefined') throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error(formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error(formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59BsR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zOJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61Sn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"la19k","./toPrimitive.js":"cVPci","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"la19k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVPci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"la19k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uf85":[function(require,module,exports,__globalThis) {
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
thunk.withExtraArgument = createThunkMiddleware;
exports.default = thunk;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGh5X":[function(require,module,exports,__globalThis) {
var global = arguments[3];
!function(e, t) {
    t(exports, require("55b400dfb9477df9"), require("6a082dc438cb1ca2"), require("3647656f9c7ebc5e"), require("13c776570732a9da"), require("6553b0b4b603e1c3"), require("d7b993ace1eca80"), require("786b9925c1b6b5ed"), require("4f1b37d05fed00b3"), require("5fc940b8b11b2f30"), require("b78d0278e54da1b4"), require("baecc74d7df402ea"), require("7360dafd9cf06bde"), require("376cbc5302b1ec0d"), require("f011acafa9d72da6"), require("aa659b497503e983"), require("7b7bf8fb2c20e0c7"), require("f501b8cd52ae4ff"), require("9e212fc4b323ed41"), require("e8ff49b0d1cab426"), require("12eec1f6d562e008"), require("72fc20cc52029f11"), require("42e3036b4499153e"), require("5592c752ef1290f4"), require("fa470ac376b26caf"), require("bf3222da2f520817"), require("685dda4962dc82e1"), require("d6dea87c85b53e02"), require("b9a1398c1c94250d"), require("e1fbbdf633f9e5ae"), require("8ac41f1b252a0973"), require("156a522b3b8fd124"), require("f2620442a53b80d6"), require("1b94d4eb34edeca3"), require("47020b485e994171"), require("9818583261d8a102"), require("1a7d4440a348b466"), require("50dce9ec585a5332"), require("a738370d89dd61ec"), require("cdc90b6df52760f"), require("2fdd28e51cf3c8b2"), require("72fb68fdc0d9bca3"), require("964e71bf85841794"), require("38468de993ee0549"), require("ec1866b328e982ea"), require("5c05196fbf6d6b4d"), require("9a6937c0aa7a418e"), require("23c6d2169b7feabe"), require("fda4089c257f1876"), require("b5061c3c95f48e73"), require("f57afb99b9b06613"), require("496ef8c8ed2b34d6"), require("6663b9b2b265a941"), require("c3348d940b830a7f"), require("53a4aaeeb87e1c51"), require("45f66dd8a17e85aa"), require("a3a5398768dc185f"), require("201a807b2e6adc5e"), require("a89a534c753bb4c3"), require("11a993db5effee60"), require("acb830835f9d8af1"));
}(this, function(e, t, r, n, a, o, s, p, i, c, d, l, u, h, f, m, y, w, v, D, g, k, C, _, b, S, M, O, P, E, N, Y, T, x, I, q, L, W, F, B, R, j, H, Q, A, V, K, U, $, z, G, J, X, Z, ee, te, re, ne, ae, oe, se) {
    "use strict";
    function pe(e) {
        return (pe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function ie(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function ce(e, t) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    function de(e, t, r) {
        return t && ce(e.prototype, t), r && ce(e, r), e;
    }
    function le(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function ue() {
        return (ue = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
        }).apply(this, arguments);
    }
    function he(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, n);
        }
        return r;
    }
    function fe(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), t && ye(e, t);
    }
    function me(e) {
        return (me = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function ye(e, t) {
        return (ye = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function we(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function ve(e, t) {
        return !t || "object" != typeof t && "function" != typeof t ? we(e) : t;
    }
    function De(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            case "PPPP":
            default:
                return t.date({
                    width: "full"
                });
        }
    }
    function ge(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            case "pppp":
            default:
                return t.time({
                    width: "full"
                });
        }
    }
    t = t && t.hasOwnProperty("default") ? t.default : t, r = r && r.hasOwnProperty("default") ? r.default : r, n = n && n.hasOwnProperty("default") ? n.default : n, a = a && a.hasOwnProperty("default") ? a.default : a, o = o && o.hasOwnProperty("default") ? o.default : o, s = s && s.hasOwnProperty("default") ? s.default : s, p = p && p.hasOwnProperty("default") ? p.default : p, i = i && i.hasOwnProperty("default") ? i.default : i, c = c && c.hasOwnProperty("default") ? c.default : c, d = d && d.hasOwnProperty("default") ? d.default : d, l = l && l.hasOwnProperty("default") ? l.default : l, u = u && u.hasOwnProperty("default") ? u.default : u, h = h && h.hasOwnProperty("default") ? h.default : h, f = f && f.hasOwnProperty("default") ? f.default : f, m = m && m.hasOwnProperty("default") ? m.default : m, y = y && y.hasOwnProperty("default") ? y.default : y, w = w && w.hasOwnProperty("default") ? w.default : w, v = v && v.hasOwnProperty("default") ? v.default : v, D = D && D.hasOwnProperty("default") ? D.default : D, g = g && g.hasOwnProperty("default") ? g.default : g, k = k && k.hasOwnProperty("default") ? k.default : k, C = C && C.hasOwnProperty("default") ? C.default : C, _ = _ && _.hasOwnProperty("default") ? _.default : _, b = b && b.hasOwnProperty("default") ? b.default : b, S = S && S.hasOwnProperty("default") ? S.default : S, M = M && M.hasOwnProperty("default") ? M.default : M, O = O && O.hasOwnProperty("default") ? O.default : O, P = P && P.hasOwnProperty("default") ? P.default : P, E = E && E.hasOwnProperty("default") ? E.default : E, N = N && N.hasOwnProperty("default") ? N.default : N, Y = Y && Y.hasOwnProperty("default") ? Y.default : Y, T = T && T.hasOwnProperty("default") ? T.default : T, x = x && x.hasOwnProperty("default") ? x.default : x, I = I && I.hasOwnProperty("default") ? I.default : I, q = q && q.hasOwnProperty("default") ? q.default : q, L = L && L.hasOwnProperty("default") ? L.default : L, W = W && W.hasOwnProperty("default") ? W.default : W, F = F && F.hasOwnProperty("default") ? F.default : F, B = B && B.hasOwnProperty("default") ? B.default : B, R = R && R.hasOwnProperty("default") ? R.default : R, j = j && j.hasOwnProperty("default") ? j.default : j, H = H && H.hasOwnProperty("default") ? H.default : H, Q = Q && Q.hasOwnProperty("default") ? Q.default : Q, A = A && A.hasOwnProperty("default") ? A.default : A, V = V && V.hasOwnProperty("default") ? V.default : V, K = K && K.hasOwnProperty("default") ? K.default : K, U = U && U.hasOwnProperty("default") ? U.default : U, $ = $ && $.hasOwnProperty("default") ? $.default : $, z = z && z.hasOwnProperty("default") ? z.default : z, G = G && G.hasOwnProperty("default") ? G.default : G, J = J && J.hasOwnProperty("default") ? J.default : J, X = X && X.hasOwnProperty("default") ? X.default : X, Z = Z && Z.hasOwnProperty("default") ? Z.default : Z, ee = ee && ee.hasOwnProperty("default") ? ee.default : ee, te = te && te.hasOwnProperty("default") ? te.default : te, re = re && re.hasOwnProperty("default") ? re.default : re, ne = ne && ne.hasOwnProperty("default") ? ne.default : ne, ae = ae && ae.hasOwnProperty("default") ? ae.default : ae, oe = oe && oe.hasOwnProperty("default") ? oe.default : oe;
    var ke = {
        p: ge,
        P: function(e, t) {
            var r, n = e.match(/(P+)(p+)?/), a = n[1], o = n[2];
            if (!o) return De(e, t);
            switch(a){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                case "PPPP":
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", De(a, t)).replace("{{time}}", ge(o, t));
        }
    }, Ce = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function _e(e) {
        var t = e ? "string" == typeof e || e instanceof String ? ae(e) : re(e) : new Date;
        return Se(t) ? t : null;
    }
    function be(e, t, r, n) {
        var a = null, o = We(r) || Le(), p = !0;
        return Array.isArray(t) ? (t.forEach(function(t) {
            var r = ne(e, t, new Date, {
                locale: o
            });
            n && (p = Se(r) && e === s(r, t, {
                awareOfUnicodeTokens: !0
            })), Se(r) && p && (a = r);
        }), a) : (a = ne(e, t, new Date, {
            locale: o
        }), n ? p = Se(a) && e === s(a, t, {
            awareOfUnicodeTokens: !0
        }) : Se(a) || (t = t.match(Ce).map(function(e) {
            var t = e[0];
            if ("p" === t || "P" === t) {
                var r = ke[t];
                return o ? r(e, o.formatLong) : t;
            }
            return e;
        }).join(""), e.length > 0 && (a = ne(e, t.slice(0, e.length), new Date)), Se(a) || (a = new Date(e))), Se(a) && p ? a : null);
    }
    function Se(e) {
        return o(e) && Z(e, new Date("1/1/1000"));
    }
    function Me(e, t, r) {
        if ("en" === r) return s(e, t, {
            awareOfUnicodeTokens: !0
        });
        var n = We(r);
        return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && Le() && We(Le()) && (n = We(Le())), s(e, t, {
            locale: n || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Oe(e, t) {
        var r = t.hour, n = void 0 === r ? 0 : r, a = t.minute, o = void 0 === a ? 0 : a, s = t.second;
        return N(E(P(e, void 0 === s ? 0 : s), o), n);
    }
    function Pe(e, t) {
        var r = We(t || Le());
        return j(e, {
            locale: r
        });
    }
    function Ee(e) {
        return H(e);
    }
    function Ne(e, t) {
        return e && t ? J(e, t) : !e && !t;
    }
    function Ye(e, t) {
        return e && t ? G(e, t) : !e && !t;
    }
    function Te(e, t) {
        return e && t ? X(e, t) : !e && !t;
    }
    function xe(e, t) {
        return e && t ? z(e, t) : !e && !t;
    }
    function Ie(e, t) {
        return e && t ? $(e, t) : !e && !t;
    }
    function qe(e, t, r) {
        var n, a = R(t), o = V(r);
        try {
            n = te(e, {
                start: a,
                end: o
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function Le() {
        return ("undefined" != typeof window ? window : global).__localeId__;
    }
    function We(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : global;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Fe(e, t) {
        return Me(Y(_e(), e), "LLL", t);
    }
    function Be(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return Ae(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return xe(e, t);
        }) || o && !o.some(function(t) {
            return xe(e, t);
        }) || s && !s(_e(e)) || !1;
    }
    function Re(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return Ae(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Ye(e, t);
        }) || o && !o.some(function(t) {
            return Ye(e, t);
        }) || s && !s(_e(e)) || !1;
    }
    function je(e, t, r, n) {
        var a = M(e), o = b(e), s = M(t), p = b(t), i = M(n);
        return a === s && a === i ? o <= r && r <= p : a < s ? i === a && o <= r || i === s && p >= r || i < s && i > a : void 0;
    }
    function He(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return Ae(e, {
            minDate: r,
            maxDate: n
        }) || a && a.some(function(t) {
            return Te(e, t);
        }) || o && !o.some(function(t) {
            return Te(e, t);
        }) || s && !s(_e(e)) || !1;
    }
    function Qe(e, t, r, n) {
        var a = M(e), o = S(e), s = M(t), p = S(t), i = M(n);
        return a === s && a === i ? o <= r && r <= p : a < s ? i === a && o <= r || i === s && p >= r || i < s && i > a : void 0;
    }
    function Ae(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.maxDate;
        return r && L(e, r) < 0 || n && L(e, n) > 0;
    }
    function Ve(e, t) {
        for(var r = t.length, n = 0; n < r; n++)if (k(t[n]) === k(e) && g(t[n]) === g(e)) return !0;
        return !1;
    }
    function Ke(e, t) {
        var r = t.minTime, n = t.maxTime;
        if (!r || !n) throw new Error("Both minTime and maxTime props required");
        var a, o = _e(), s = N(E(o, g(e)), k(e)), p = N(E(o, g(r)), k(r)), i = N(E(o, g(n)), k(n));
        try {
            a = !te(s, {
                start: p,
                end: i
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function Ue(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = w(e, 1);
        return r && W(r, a) > 0 || n && n.every(function(e) {
            return W(e, a) > 0;
        }) || !1;
    }
    function $e(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = l(e, 1);
        return r && W(a, r) > 0 || n && n.every(function(e) {
            return W(a, e) > 0;
        }) || !1;
    }
    function ze(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return L(e, t) >= 0;
            });
            return I(n);
        }
        return r ? I(r) : t;
    }
    function Ge(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var n = r.filter(function(e) {
                return L(e, t) <= 0;
            });
            return q(n);
        }
        return r ? q(r) : t;
    }
    function Je() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, n = 0, o = e.length; n < o; n++){
            var s = e[n];
            if (a(s)) {
                var p = Me(s, "MM.dd.yyyy"), i = r.get(p) || [];
                i.includes(t) || (i.push(t), r.set(p, i));
            } else if ("object" === pe(s)) {
                var c = Object.keys(s), d = c[0], l = s[c[0]];
                if ("string" == typeof d && l.constructor === Array) for(var u = 0, h = l.length; u < h; u++){
                    var f = Me(l[u], "MM.dd.yyyy"), m = r.get(f) || [];
                    m.includes(d) || (m.push(d), r.set(f, m));
                }
            }
        }
        return r;
    }
    function Xe(e, t, r, n, a) {
        for(var o = a.length, s = [], c = 0; c < o; c++){
            var d = p(i(e, k(a[c])), g(a[c])), l = p(e, (r + 1) * n);
            Z(d, t) && ee(d, l) && s.push(a[c]);
        }
        return s;
    }
    function Ze(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function et(e, t, r, n) {
        for(var a = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, p = !0;
            r && (p = M(r) <= s), n && p && (p = M(n) >= s), p && a.push(s);
        }
        return a;
    }
    var tt = oe(function(e) {
        function r(e) {
            var n;
            ie(this, r), le(we(n = ve(this, me(r).call(this, e))), "renderOptions", function() {
                var e = n.props.year, r = n.state.yearsList.map(function(r) {
                    return t.createElement("div", {
                        className: e === r ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: r,
                        ref: r,
                        onClick: n.onChange.bind(we(n), r)
                    }, e === r ? t.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", r);
                }), a = n.props.minDate ? M(n.props.minDate) : null, o = n.props.maxDate ? M(n.props.maxDate) : null;
                return o && n.state.yearsList.find(function(e) {
                    return e === o;
                }) || r.unshift(t.createElement("div", {
                    className: "react-datepicker__year-option",
                    ref: "upcoming",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, t.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || r.push(t.createElement("div", {
                    className: "react-datepicker__year-option",
                    ref: "previous",
                    key: "previous",
                    onClick: n.decrementYears
                }, t.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), r;
            }), le(we(n), "onChange", function(e) {
                n.props.onChange(e);
            }), le(we(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), le(we(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), le(we(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), le(we(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var a = e.yearDropdownItemNumber, o = e.scrollableYearDropdown, s = a || (o ? 10 : 5);
            return n.state = {
                yearsList: et(n.props.year, s, n.props.minDate, n.props.maxDate)
            }, n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e = n({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return t.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }()), rt = function(e) {
        function r() {
            var e, n;
            ie(this, r);
            for(var a = arguments.length, o = new Array(a), s = 0; s < a; s++)o[s] = arguments[s];
            return le(we(n = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(o)))), "state", {
                dropdownVisible: !1
            }), le(we(n), "renderSelectOptions", function() {
                for(var e = n.props.minDate ? M(n.props.minDate) : 1900, r = n.props.maxDate ? M(n.props.maxDate) : 2100, a = [], o = e; o <= r; o++)a.push(t.createElement("option", {
                    key: o,
                    value: o
                }, o));
                return a;
            }), le(we(n), "onSelectChange", function(e) {
                n.onChange(e.target.value);
            }), le(we(n), "renderSelectMode", function() {
                return t.createElement("select", {
                    value: n.props.year,
                    className: "react-datepicker__year-select",
                    onChange: n.onSelectChange
                }, n.renderSelectOptions());
            }), le(we(n), "renderReadView", function(e) {
                return t.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(e) {
                        return n.toggleDropdown(e);
                    }
                }, t.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), t.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, n.props.year));
            }), le(we(n), "renderDropdown", function() {
                return t.createElement(tt, {
                    key: "dropdown",
                    ref: "options",
                    year: n.props.year,
                    onChange: n.onChange,
                    onCancel: n.toggleDropdown,
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    scrollableYearDropdown: n.props.scrollableYearDropdown,
                    yearDropdownItemNumber: n.props.yearDropdownItemNumber
                });
            }), le(we(n), "renderScrollMode", function() {
                var e = n.state.dropdownVisible, t = [
                    n.renderReadView(!e)
                ];
                return e && t.unshift(n.renderDropdown()), t;
            }), le(we(n), "onChange", function(e) {
                n.toggleDropdown(), e !== n.props.year && n.props.onChange(e);
            }), le(we(n), "toggleDropdown", function(e) {
                n.setState({
                    dropdownVisible: !n.state.dropdownVisible
                }, function() {
                    n.props.adjustDateOnChange && n.handleYearChange(n.props.date, e);
                });
            }), le(we(n), "handleYearChange", function(e, t) {
                n.onSelect(e, t), n.setOpen();
            }), le(we(n), "onSelect", function(e, t) {
                n.props.onSelect && n.props.onSelect(e, t);
            }), le(we(n), "setOpen", function() {
                n.props.setOpen && n.props.setOpen(!0);
            }), n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return t.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(), nt = oe(function(e) {
        function r() {
            var e, n;
            ie(this, r);
            for(var a = arguments.length, o = new Array(a), s = 0; s < a; s++)o[s] = arguments[s];
            return le(we(n = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(o)))), "renderOptions", function() {
                return n.props.monthNames.map(function(e, r) {
                    return t.createElement("div", {
                        className: n.props.month === r ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: e,
                        ref: e,
                        onClick: n.onChange.bind(we(n), r)
                    }, n.props.month === r ? t.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", e);
                });
            }), le(we(n), "onChange", function(e) {
                return n.props.onChange(e);
            }), le(we(n), "handleClickOutside", function() {
                return n.props.onCancel();
            }), n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    return t.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }()), at = function(e) {
        function r() {
            var e, n;
            ie(this, r);
            for(var a = arguments.length, o = new Array(a), s = 0; s < a; s++)o[s] = arguments[s];
            return le(we(n = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(o)))), "state", {
                dropdownVisible: !1
            }), le(we(n), "renderSelectOptions", function(e) {
                return e.map(function(e, r) {
                    return t.createElement("option", {
                        key: r,
                        value: r
                    }, e);
                });
            }), le(we(n), "renderSelectMode", function(e) {
                return t.createElement("select", {
                    value: n.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(e) {
                        return n.onChange(e.target.value);
                    }
                }, n.renderSelectOptions(e));
            }), le(we(n), "renderReadView", function(e, r) {
                return t.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: n.toggleDropdown
                }, t.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), t.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[n.props.month]));
            }), le(we(n), "renderDropdown", function(e) {
                return t.createElement(nt, {
                    key: "dropdown",
                    ref: "options",
                    month: n.props.month,
                    monthNames: e,
                    onChange: n.onChange,
                    onCancel: n.toggleDropdown
                });
            }), le(we(n), "renderScrollMode", function(e) {
                var t = n.state.dropdownVisible, r = [
                    n.renderReadView(!t, e)
                ];
                return t && r.unshift(n.renderDropdown(e)), r;
            }), le(we(n), "onChange", function(e) {
                n.toggleDropdown(), e !== n.props.month && n.props.onChange(e);
            }), le(we(n), "toggleDropdown", function() {
                return n.setState({
                    dropdownVisible: !n.state.dropdownVisible
                });
            }), n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e, r = this, n = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return Fe(e, r.props.locale);
                    } : function(e) {
                        var t, n;
                        return t = e, n = r.props.locale, Me(Y(_e(), t), "LLLL", n);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(n);
                            break;
                        case "select":
                            e = this.renderSelectMode(n);
                    }
                    return t.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }();
    function ot(e, t) {
        for(var r = [], n = Ee(e), a = Ee(t); !Z(n, a);)r.push(_e(n)), n = l(n, 1);
        return r;
    }
    var st = oe(function(e) {
        function r(e) {
            var n;
            return ie(this, r), le(we(n = ve(this, me(r).call(this, e))), "renderOptions", function() {
                return n.state.monthYearsList.map(function(e) {
                    var r = O(e), a = Ne(n.props.date, e) && Ye(n.props.date, e);
                    return t.createElement("div", {
                        className: a ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
                        key: r,
                        ref: r,
                        onClick: n.onChange.bind(we(n), r)
                    }, a ? t.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Me(e, n.props.dateFormat));
                });
            }), le(we(n), "onChange", function(e) {
                return n.props.onChange(e);
            }), le(we(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), n.state = {
                monthYearsList: ot(n.props.minDate, n.props.maxDate)
            }, n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e = n({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return t.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }()), pt = function(e) {
        function r() {
            var e, n;
            ie(this, r);
            for(var a = arguments.length, o = new Array(a), s = 0; s < a; s++)o[s] = arguments[s];
            return le(we(n = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(o)))), "state", {
                dropdownVisible: !1
            }), le(we(n), "renderSelectOptions", function() {
                for(var e = Ee(n.props.minDate), r = Ee(n.props.maxDate), a = []; !Z(e, r);){
                    var o = O(e);
                    a.push(t.createElement("option", {
                        key: o,
                        value: o
                    }, Me(e, n.props.dateFormat, n.props.locale))), e = l(e, 1);
                }
                return a;
            }), le(we(n), "onSelectChange", function(e) {
                n.onChange(e.target.value);
            }), le(we(n), "renderSelectMode", function() {
                return t.createElement("select", {
                    value: O(Ee(n.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: n.onSelectChange
                }, n.renderSelectOptions());
            }), le(we(n), "renderReadView", function(e) {
                var r = Me(n.props.date, n.props.dateFormat, n.props.locale);
                return t.createElement("div", {
                    key: "read",
                    style: {
                        visibility: e ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(e) {
                        return n.toggleDropdown(e);
                    }
                }, t.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), t.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), le(we(n), "renderDropdown", function() {
                return t.createElement(st, {
                    key: "dropdown",
                    ref: "options",
                    date: n.props.date,
                    dateFormat: n.props.dateFormat,
                    onChange: n.onChange,
                    onCancel: n.toggleDropdown,
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    scrollableMonthYearDropdown: n.props.scrollableMonthYearDropdown
                });
            }), le(we(n), "renderScrollMode", function() {
                var e = n.state.dropdownVisible, t = [
                    n.renderReadView(!e)
                ];
                return e && t.unshift(n.renderDropdown()), t;
            }), le(we(n), "onChange", function(e) {
                n.toggleDropdown();
                var t = _e(parseInt(e));
                Ne(n.props.date, t) && Ye(n.props.date, t) || n.props.onChange(t);
            }), le(we(n), "toggleDropdown", function() {
                return n.setState({
                    dropdownVisible: !n.state.dropdownVisible
                });
            }), n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return t.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(), it = function(e) {
        function r() {
            var e, t;
            ie(this, r);
            for(var a = arguments.length, o = new Array(a), s = 0; s < a; s++)o[s] = arguments[s];
            return le(we(t = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(o)))), "handleClick", function(e) {
                !t.isDisabled() && t.props.onClick && t.props.onClick(e);
            }), le(we(t), "handleMouseEnter", function(e) {
                !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(e);
            }), le(we(t), "isSameDay", function(e) {
                return xe(t.props.day, e);
            }), le(we(t), "isKeyboardSelected", function() {
                return !t.props.disabledKeyboardNavigation && !t.props.inline && !t.isSameDay(t.props.selected) && t.isSameDay(t.props.preSelection);
            }), le(we(t), "isDisabled", function() {
                return Be(t.props.day, t.props);
            }), le(we(t), "isExcluded", function() {
                return function(e) {
                    var t = (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).excludeDates;
                    return t && t.some(function(t) {
                        return xe(e, t);
                    }) || !1;
                }(t.props.day, t.props);
            }), le(we(t), "getHighLightedClass", function(e) {
                var r = t.props, n = r.day, a = r.highlightDates;
                if (!a) return !1;
                var o = Me(n, "MM.dd.yyyy");
                return a.get(o);
            }), le(we(t), "isInRange", function() {
                var e = t.props, r = e.day, n = e.startDate, a = e.endDate;
                return !(!n || !a) && qe(r, n, a);
            }), le(we(t), "isInSelectingRange", function() {
                var e = t.props, r = e.day, n = e.selectsStart, a = e.selectsEnd, o = e.selectingDate, s = e.startDate, p = e.endDate;
                return !(!n && !a || !o || t.isDisabled()) && (n && p && (ee(o, p) || Ie(o, p)) ? qe(r, o, p) : !(!a || !s || !Z(o, s) && !Ie(o, s)) && qe(r, s, o));
            }), le(we(t), "isSelectingRangeStart", function() {
                if (!t.isInSelectingRange()) return !1;
                var e = t.props, r = e.day, n = e.selectingDate, a = e.startDate;
                return xe(r, e.selectsStart ? n : a);
            }), le(we(t), "isSelectingRangeEnd", function() {
                if (!t.isInSelectingRange()) return !1;
                var e = t.props, r = e.day, n = e.selectingDate, a = e.endDate;
                return xe(r, e.selectsEnd ? n : a);
            }), le(we(t), "isRangeStart", function() {
                var e = t.props, r = e.day, n = e.startDate, a = e.endDate;
                return !(!n || !a) && xe(n, r);
            }), le(we(t), "isRangeEnd", function() {
                var e = t.props, r = e.day, n = e.startDate, a = e.endDate;
                return !(!n || !a) && xe(a, r);
            }), le(we(t), "isWeekend", function() {
                var e = C(t.props.day);
                return 0 === e || 6 === e;
            }), le(we(t), "isOutsideMonth", function() {
                return void 0 !== t.props.month && t.props.month !== b(t.props.day);
            }), le(we(t), "getClassNames", function(e) {
                var r, a = t.props.dayClassName ? t.props.dayClassName(e) : void 0;
                return n("react-datepicker__day", a, "react-datepicker__day--" + Me(t.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": t.isDisabled(),
                    "react-datepicker__day--excluded": t.isExcluded(),
                    "react-datepicker__day--selected": t.isSameDay(t.props.selected),
                    "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
                    "react-datepicker__day--range-start": t.isRangeStart(),
                    "react-datepicker__day--range-end": t.isRangeEnd(),
                    "react-datepicker__day--in-range": t.isInRange(),
                    "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
                    "react-datepicker__day--today": t.isSameDay(_e()),
                    "react-datepicker__day--weekend": t.isWeekend(),
                    "react-datepicker__day--outside-month": t.isOutsideMonth()
                }, t.getHighLightedClass("react-datepicker__day--highlighted"));
            }), t;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    return t.createElement("div", {
                        className: this.getClassNames(this.props.day),
                        onClick: this.handleClick,
                        onMouseEnter: this.handleMouseEnter,
                        "aria-label": "day-".concat(_(this.props.day)),
                        role: "option",
                        "aria-disabled": this.isDisabled()
                    }, this.props.renderDayContents ? this.props.renderDayContents(_(this.props.day), this.props.day) : _(this.props.day));
                }
            }
        ]), r;
    }(), ct = function(e) {
        function r() {
            var e, t;
            ie(this, r);
            for(var n = arguments.length, a = new Array(n), o = 0; o < n; o++)a[o] = arguments[o];
            return le(we(t = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(a)))), "handleClick", function(e) {
                t.props.onClick && t.props.onClick(e);
            }), t;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!this.props.onClick
                    };
                    return t.createElement("div", {
                        className: n(e),
                        "aria-label": "week-".concat(this.props.weekNumber),
                        onClick: this.handleClick
                    }, this.props.weekNumber);
                }
            }
        ]), r;
    }(), dt = function(e) {
        function r() {
            var e, n;
            ie(this, r);
            for(var a = arguments.length, o = new Array(a), s = 0; s < a; s++)o[s] = arguments[s];
            return le(we(n = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(o)))), "handleDayClick", function(e, t) {
                n.props.onDayClick && n.props.onDayClick(e, t);
            }), le(we(n), "handleDayMouseEnter", function(e) {
                n.props.onDayMouseEnter && n.props.onDayMouseEnter(e);
            }), le(we(n), "handleWeekClick", function(e, t, r) {
                "function" == typeof n.props.onWeekSelect && n.props.onWeekSelect(e, t, r), n.props.shouldCloseOnSelect && n.props.setOpen(!1);
            }), le(we(n), "formatWeekNumber", function(e) {
                return n.props.formatWeekNumber ? n.props.formatWeekNumber(e) : function(e) {
                    return Ne(K(e), e) ? F(e, A(e)) + 1 : 1;
                }(e);
            }), le(we(n), "renderDays", function() {
                var e = Pe(n.props.day, n.props.locale), r = [], a = n.formatWeekNumber(e);
                if (n.props.showWeekNumber) {
                    var o = n.props.onWeekSelect ? n.handleWeekClick.bind(we(n), e, a) : void 0;
                    r.push(t.createElement(ct, {
                        key: "W",
                        weekNumber: a,
                        onClick: o
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = c(e, r);
                    return t.createElement(it, {
                        key: r,
                        day: a,
                        month: n.props.month,
                        onClick: n.handleDayClick.bind(we(n), a),
                        onMouseEnter: n.handleDayMouseEnter.bind(we(n), a),
                        minDate: n.props.minDate,
                        maxDate: n.props.maxDate,
                        excludeDates: n.props.excludeDates,
                        includeDates: n.props.includeDates,
                        inline: n.props.inline,
                        highlightDates: n.props.highlightDates,
                        selectingDate: n.props.selectingDate,
                        filterDate: n.props.filterDate,
                        preSelection: n.props.preSelection,
                        selected: n.props.selected,
                        selectsStart: n.props.selectsStart,
                        selectsEnd: n.props.selectsEnd,
                        startDate: n.props.startDate,
                        endDate: n.props.endDate,
                        dayClassName: n.props.dayClassName,
                        renderDayContents: n.props.renderDayContents,
                        disabledKeyboardNavigation: n.props.disabledKeyboardNavigation
                    });
                }));
            }), n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    return t.createElement("div", {
                        className: "react-datepicker__week"
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(), lt = 6, ut = function(e) {
        function r() {
            var e, a;
            ie(this, r);
            for(var o = arguments.length, s = new Array(o), p = 0; p < o; p++)s[p] = arguments[p];
            return le(we(a = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(s)))), "handleDayClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t, a.props.orderInDisplay);
            }), le(we(a), "handleDayMouseEnter", function(e) {
                a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), le(we(a), "handleMouseLeave", function() {
                a.props.onMouseLeave && a.props.onMouseLeave();
            }), le(we(a), "isRangeStartMonth", function(e) {
                var t = a.props, r = t.day, n = t.startDate, o = t.endDate;
                return !(!n || !o) && Ye(Y(r, e), n);
            }), le(we(a), "isRangeStartQuarter", function(e) {
                var t = a.props, r = t.day, n = t.startDate, o = t.endDate;
                return !(!n || !o) && Te(T(r, e), n);
            }), le(we(a), "isRangeEndMonth", function(e) {
                var t = a.props, r = t.day, n = t.startDate, o = t.endDate;
                return !(!n || !o) && Ye(Y(r, e), o);
            }), le(we(a), "isRangeEndQuarter", function(e) {
                var t = a.props, r = t.day, n = t.startDate, o = t.endDate;
                return !(!n || !o) && Te(T(r, e), o);
            }), le(we(a), "isWeekInMonth", function(e) {
                var t = a.props.day, r = c(e, 6);
                return Ye(e, t) || Ye(r, t);
            }), le(we(a), "renderWeeks", function() {
                for(var e = [], r = a.props.fixedHeight, n = Pe(Ee(a.props.day), a.props.locale), o = 0, s = !1; e.push(t.createElement(dt, {
                    key: o,
                    day: n,
                    month: b(a.props.day),
                    onDayClick: a.handleDayClick,
                    onDayMouseEnter: a.handleDayMouseEnter,
                    onWeekSelect: a.props.onWeekSelect,
                    formatWeekNumber: a.props.formatWeekNumber,
                    locale: a.props.locale,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    excludeDates: a.props.excludeDates,
                    includeDates: a.props.includeDates,
                    inline: a.props.inline,
                    highlightDates: a.props.highlightDates,
                    selectingDate: a.props.selectingDate,
                    filterDate: a.props.filterDate,
                    preSelection: a.props.preSelection,
                    selected: a.props.selected,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    showWeekNumber: a.props.showWeekNumbers,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    dayClassName: a.props.dayClassName,
                    setOpen: a.props.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderDayContents: a.props.renderDayContents
                })), !s;){
                    o++, n = d(n, 1);
                    var p = r && o >= lt, i = !r && !a.isWeekInMonth(n);
                    if (p || i) {
                        if (!a.props.peekNextMonth) break;
                        s = !0;
                    }
                }
                return e;
            }), le(we(a), "onMonthClick", function(e, t) {
                a.handleDayClick(Ee(Y(a.props.day, t)), e);
            }), le(we(a), "onQuarterClick", function(e, t) {
                var r;
                a.handleDayClick((r = T(a.props.day, t), Q(r)), e);
            }), le(we(a), "getMonthClassNames", function(e) {
                var t = a.props, r = t.day, o = t.startDate, s = t.endDate, p = t.selected, i = t.minDate, c = t.maxDate;
                return n("react-datepicker__month-text", "react-datepicker__month-".concat(e), {
                    "react-datepicker__month--disabled": (i || c) && Re(Y(r, e), a.props),
                    "react-datepicker__month--selected": b(r) === e && M(r) === M(p),
                    "react-datepicker__month--in-range": je(o, s, e, r),
                    "react-datepicker__month--range-start": a.isRangeStartMonth(e),
                    "react-datepicker__month--range-end": a.isRangeEndMonth(e)
                });
            }), le(we(a), "getQuarterClassNames", function(e) {
                var t = a.props, r = t.day, o = t.startDate, s = t.endDate, p = t.selected, i = t.minDate, c = t.maxDate;
                return n("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
                    "react-datepicker__quarter--disabled": (i || c) && He(T(r, e), a.props),
                    "react-datepicker__quarter--selected": S(r) === e && M(r) === M(p),
                    "react-datepicker__quarter--in-range": Qe(o, s, e, r),
                    "react-datepicker__quarter--range-start": a.isRangeStartQuarter(e),
                    "react-datepicker__quarter--range-end": a.isRangeEndQuarter(e)
                });
            }), le(we(a), "renderMonths", function() {
                return [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        3,
                        4,
                        5
                    ],
                    [
                        6,
                        7,
                        8
                    ],
                    [
                        9,
                        10,
                        11
                    ]
                ].map(function(e, r) {
                    return t.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, e.map(function(e, r) {
                        return t.createElement("div", {
                            key: r,
                            onClick: function(t) {
                                a.onMonthClick(t, e);
                            },
                            className: a.getMonthClassNames(e)
                        }, Fe(e, a.props.locale));
                    }));
                });
            }), le(we(a), "renderQuarters", function() {
                return t.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(e, r) {
                    var n, o;
                    return t.createElement("div", {
                        key: r,
                        onClick: function(t) {
                            a.onQuarterClick(t, e);
                        },
                        className: a.getQuarterClassNames(e)
                    }, (n = e, o = a.props.locale, Me(T(_e(), n), "QQQ", o)));
                }));
            }), le(we(a), "getClassNames", function() {
                var e = a.props, t = e.selectingDate, r = e.selectsStart, o = e.selectsEnd, s = e.showMonthYearPicker, p = e.showQuarterYearPicker;
                return n("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": t && (r || o)
                }, {
                    "react-datepicker__monthPicker": s
                }, {
                    "react-datepicker__quarterPicker": p
                });
            }), a;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, r = e.showMonthYearPicker, n = e.showQuarterYearPicker;
                    return t.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        role: "listbox",
                        "aria-label": "month-" + Me(this.props.day, "yyyy-MM")
                    }, r ? this.renderMonths() : n ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(), ht = function(e) {
        function r() {
            var e, n;
            ie(this, r);
            for(var a = arguments.length, o = new Array(a), s = 0; s < a; s++)o[s] = arguments[s];
            return le(we(n = ve(this, (e = me(r)).call.apply(e, [
                this
            ].concat(o)))), "state", {
                height: null
            }), le(we(n), "handleClick", function(e) {
                (n.props.minTime || n.props.maxTime) && Ke(e, n.props) || n.props.excludeTimes && Ve(e, n.props.excludeTimes) || n.props.includeTimes && !Ve(e, n.props.includeTimes) || n.props.onChange(e);
            }), le(we(n), "liClasses", function(e, t, r) {
                var a = [
                    "react-datepicker__time-list-item"
                ];
                return n.props.selected && t === k(e) && r === g(e) && a.push("react-datepicker__time-list-item--selected"), ((n.props.minTime || n.props.maxTime) && Ke(e, n.props) || n.props.excludeTimes && Ve(e, n.props.excludeTimes) || n.props.includeTimes && !Ve(e, n.props.includeTimes)) && a.push("react-datepicker__time-list-item--disabled"), n.props.injectTimes && (60 * k(e) + g(e)) % n.props.intervals != 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
            }), le(we(n), "renderTimes", function() {
                for(var e, r = [], a = n.props.format ? n.props.format : "p", o = n.props.intervals, s = n.props.selected || n.props.openToDate || _e(), i = k(s), c = g(s), d = (e = _e(), R(e)), l = 1440 / o, u = n.props.injectTimes && n.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), h = 0; h < l; h++){
                    var f = p(d, h * o);
                    if (r.push(f), u) {
                        var m = Xe(d, f, h, o, u);
                        r = r.concat(m);
                    }
                }
                return r.map(function(e, r) {
                    return t.createElement("li", {
                        key: r,
                        onClick: n.handleClick.bind(we(n), e),
                        className: n.liClasses(e, i, c),
                        ref: function(t) {
                            i === k(e) && c >= g(e) && (n.centerLi = t);
                        }
                    }, Me(e, a, n.props.locale));
                });
            }), n;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, r = this.state.height;
                    return t.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, t.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time",
                        ref: function(t) {
                            e.header = t;
                        }
                    }, t.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), t.createElement("div", {
                        className: "react-datepicker__time"
                    }, t.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, t.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: r ? {
                            height: r
                        } : {}
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }();
    le(ht, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var ft = function(e) {
        function r(e) {
            var t;
            return ie(this, r), le(we(t = ve(this, me(r).call(this, e))), "onTimeChange", function(e) {
                t.setState({
                    time: e
                });
                var r = new Date;
                r.setHours(e.split(":")[0]), r.setMinutes(e.split(":")[1]), t.props.onChange(r);
            }), t.state = {
                time: t.props.timeString
            }, t;
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e = this, r = this.state.time, n = this.props.timeString;
                    return t.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, t.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), t.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, t.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, t.createElement("input", {
                        type: "time",
                        className: "react-datepicker-time__input",
                        placeholder: "Time",
                        name: "time-input",
                        required: !0,
                        value: r,
                        onChange: function(t) {
                            e.onTimeChange(t.target.value || n);
                        }
                    }))));
                }
            }
        ]), r;
    }();
    function mt(e) {
        var r = e.className, n = e.children, a = e.showPopperArrow, o = e.arrowProps, s = void 0 === o ? {} : o;
        return t.createElement("div", {
            className: r
        }, a && t.createElement("div", ue({
            className: "react-datepicker__triangle"
        }, s)), n);
    }
    var yt = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], wt = function() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = (e.className || "").split(/\s+/);
        return yt.some(function(e) {
            return t.indexOf(e) >= 0;
        });
    }, vt = function(e) {
        function r(e) {
            var n;
            return ie(this, r), le(we(n = ve(this, me(r).call(this, e))), "handleClickOutside", function(e) {
                n.props.onClickOutside(e);
            }), le(we(n), "setClickOutsideRef", function() {
                return n.containerRef.current;
            }), le(we(n), "handleDropdownFocus", function(e) {
                wt(e.target) && n.props.onDropdownFocus();
            }), le(we(n), "getDateInView", function() {
                var e = n.props, t = e.preSelection, r = e.selected, a = e.openToDate, o = ze(n.props), s = Ge(n.props), p = _e(), i = a || r || t;
                return i || (o && ee(p, o) ? o : s && Z(p, s) ? s : p);
            }), le(we(n), "increaseMonth", function() {
                n.setState(function(e) {
                    var t = e.date;
                    return {
                        date: l(t, 1)
                    };
                }, function() {
                    return n.handleMonthChange(n.state.date);
                });
            }), le(we(n), "decreaseMonth", function() {
                n.setState(function(e) {
                    var t = e.date;
                    return {
                        date: w(t, 1)
                    };
                }, function() {
                    return n.handleMonthChange(n.state.date);
                });
            }), le(we(n), "handleDayClick", function(e, t, r) {
                return n.props.onSelect(e, t, r);
            }), le(we(n), "handleDayMouseEnter", function(e) {
                n.setState({
                    selectingDate: e
                }), n.props.onDayMouseEnter && n.props.onDayMouseEnter(e);
            }), le(we(n), "handleMonthMouseLeave", function() {
                n.setState({
                    selectingDate: null
                }), n.props.onMonthMouseLeave && n.props.onMonthMouseLeave();
            }), le(we(n), "handleYearChange", function(e) {
                n.props.onYearChange && n.props.onYearChange(e);
            }), le(we(n), "handleMonthChange", function(e) {
                n.props.onMonthChange && n.props.onMonthChange(e), n.props.adjustDateOnChange && (n.props.onSelect && n.props.onSelect(e), n.props.setOpen && n.props.setOpen(!0));
            }), le(we(n), "handleMonthYearChange", function(e) {
                n.handleYearChange(e), n.handleMonthChange(e);
            }), le(we(n), "changeYear", function(e) {
                n.setState(function(t) {
                    var r = t.date;
                    return {
                        date: x(r, e)
                    };
                }, function() {
                    return n.handleYearChange(n.state.date);
                });
            }), le(we(n), "changeMonth", function(e) {
                n.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Y(r, e)
                    };
                }, function() {
                    return n.handleMonthChange(n.state.date);
                });
            }), le(we(n), "changeMonthYear", function(e) {
                n.setState(function(t) {
                    var r = t.date;
                    return {
                        date: x(Y(r, b(e)), M(e))
                    };
                }, function() {
                    return n.handleMonthYearChange(n.state.date);
                });
            }), le(we(n), "header", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.state.date, r = Pe(e, n.props.locale), a = [];
                return n.props.showWeekNumbers && a.push(t.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, n.props.weekLabel || "#")), a.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var a = c(r, e), o = n.formatWeekday(a, n.props.locale);
                    return t.createElement("div", {
                        key: e,
                        className: "react-datepicker__day-name"
                    }, o);
                }));
            }), le(we(n), "formatWeekday", function(e, t) {
                return n.props.formatWeekDay ? function(e, t, r) {
                    return t(Me(e, "EEEE", r));
                }(e, n.props.formatWeekDay, t) : n.props.useWeekdaysShort ? function(e, t) {
                    return Me(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Me(e, "EEEEEE", t);
                }(e, t);
            }), le(we(n), "decreaseYear", function() {
                n.setState(function(e) {
                    var t = e.date;
                    return {
                        date: v(t, 1)
                    };
                }, function() {
                    return n.handleYearChange(n.state.date);
                });
            }), le(we(n), "renderPreviousButton", function() {
                if (!n.props.renderCustomHeader) {
                    var e = n.props.showMonthYearPicker ? function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, n = t.includeDates, a = v(e, 1);
                        return r && B(r, a) > 0 || n && n.every(function(e) {
                            return B(e, a) > 0;
                        }) || !1;
                    }(n.state.date, n.props) : Ue(n.state.date, n.props);
                    if ((n.props.forceShowMonthNavigation || n.props.showDisabledMonthNavigation || !e) && !n.props.showTimeSelectOnly) {
                        var r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], a = n.decreaseMonth;
                        return (n.props.showMonthYearPicker || n.props.showQuarterYearPicker) && (a = n.decreaseYear), e && n.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--previous--disabled"), a = null), t.createElement("button", {
                            type: "button",
                            className: r.join(" "),
                            onClick: a
                        }, n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? n.props.previousYearButtonLabel : n.props.previousMonthButtonLabel);
                    }
                }
            }), le(we(n), "increaseYear", function() {
                n.setState(function(e) {
                    var t = e.date;
                    return {
                        date: u(t, 1)
                    };
                }, function() {
                    return n.handleYearChange(n.state.date);
                });
            }), le(we(n), "renderNextButton", function() {
                if (!n.props.renderCustomHeader) {
                    var e = n.props.showMonthYearPicker ? function(e) {
                        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, n = t.includeDates, a = u(e, 1);
                        return r && B(a, r) > 0 || n && n.every(function(e) {
                            return B(a, e) > 0;
                        }) || !1;
                    }(n.state.date, n.props) : $e(n.state.date, n.props);
                    if ((n.props.forceShowMonthNavigation || n.props.showDisabledMonthNavigation || !e) && !n.props.showTimeSelectOnly) {
                        var r = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        n.props.showTimeSelect && r.push("react-datepicker__navigation--next--with-time"), n.props.todayButton && r.push("react-datepicker__navigation--next--with-today-button");
                        var a = n.increaseMonth;
                        return (n.props.showMonthYearPicker || n.props.showQuarterYearPicker) && (a = n.increaseYear), e && n.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--next--disabled"), a = null), t.createElement("button", {
                            type: "button",
                            className: r.join(" "),
                            onClick: a
                        }, n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? n.props.nextYearButtonLabel : n.props.nextMonthButtonLabel);
                    }
                }
            }), le(we(n), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.state.date, r = [
                    "react-datepicker__current-month"
                ];
                return n.props.showYearDropdown && r.push("react-datepicker__current-month--hasYearDropdown"), n.props.showMonthDropdown && r.push("react-datepicker__current-month--hasMonthDropdown"), n.props.showMonthYearDropdown && r.push("react-datepicker__current-month--hasMonthYearDropdown"), t.createElement("div", {
                    className: r.join(" ")
                }, Me(e, n.props.dateFormat, n.props.locale));
            }), le(we(n), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (n.props.showYearDropdown && !e) return t.createElement(rt, {
                    adjustDateOnChange: n.props.adjustDateOnChange,
                    date: n.state.date,
                    onSelect: n.props.onSelect,
                    setOpen: n.props.setOpen,
                    dropdownMode: n.props.dropdownMode,
                    onChange: n.changeYear,
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    year: M(n.state.date),
                    scrollableYearDropdown: n.props.scrollableYearDropdown,
                    yearDropdownItemNumber: n.props.yearDropdownItemNumber
                });
            }), le(we(n), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (n.props.showMonthDropdown && !e) return t.createElement(at, {
                    dropdownMode: n.props.dropdownMode,
                    locale: n.props.locale,
                    onChange: n.changeMonth,
                    month: b(n.state.date),
                    useShortMonthInDropdown: n.props.useShortMonthInDropdown
                });
            }), le(we(n), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (n.props.showMonthYearDropdown && !e) return t.createElement(pt, {
                    dropdownMode: n.props.dropdownMode,
                    locale: n.props.locale,
                    dateFormat: n.props.dateFormat,
                    onChange: n.changeMonthYear,
                    minDate: n.props.minDate,
                    maxDate: n.props.maxDate,
                    date: n.state.date,
                    scrollableMonthYearDropdown: n.props.scrollableMonthYearDropdown
                });
            }), le(we(n), "renderTodayButton", function() {
                if (n.props.todayButton && !n.props.showTimeSelectOnly) return t.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return n.props.onSelect(R(_e()), e);
                    }
                }, n.props.todayButton);
            }), le(we(n), "renderDefaultHeader", function(e) {
                var r = e.monthDate, a = e.i;
                return t.createElement("div", {
                    className: "react-datepicker__header"
                }, n.renderCurrentMonth(r), t.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode),
                    onFocus: n.handleDropdownFocus
                }, n.renderMonthDropdown(0 !== a), n.renderMonthYearDropdown(0 !== a), n.renderYearDropdown(0 !== a)), t.createElement("div", {
                    className: "react-datepicker__day-names"
                }, n.header(r)));
            }), le(we(n), "renderCustomHeader", function(e) {
                var r = e.monthDate;
                if (0 !== e.i) return null;
                var a = Ue(n.state.date, n.props), o = $e(n.state.date, n.props);
                return t.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: n.props.onDropdownFocus
                }, n.props.renderCustomHeader(function(e) {
                    for(var t = 1; t < arguments.length; t++){
                        var r = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? he(r, !0).forEach(function(t) {
                            le(e, t, r[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : he(r).forEach(function(t) {
                            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                        });
                    }
                    return e;
                }({}, n.state, {
                    changeMonth: n.changeMonth,
                    changeYear: n.changeYear,
                    decreaseMonth: n.decreaseMonth,
                    increaseMonth: n.increaseMonth,
                    prevMonthButtonDisabled: a,
                    nextMonthButtonDisabled: o
                })), t.createElement("div", {
                    className: "react-datepicker__day-names"
                }, n.header(r)));
            }), le(we(n), "renderYearHeader", function() {
                return t.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, M(n.state.date));
            }), le(we(n), "renderMonths", function() {
                if (!n.props.showTimeSelectOnly) {
                    for(var e = [], r = n.props.showPreviousMonths ? n.props.monthsShown - 1 : 0, a = w(n.state.date, r), o = 0; o < n.props.monthsShown; ++o){
                        var s = o - n.props.monthSelectedIn, p = l(a, s), i = "month-".concat(o);
                        e.push(t.createElement("div", {
                            key: i,
                            ref: function(e) {
                                n.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? n.renderYearHeader({
                            monthDate: p,
                            i: o
                        }) : n.props.renderCustomHeader ? n.renderCustomHeader({
                            monthDate: p,
                            i: o
                        }) : n.renderDefaultHeader({
                            monthDate: p,
                            i: o
                        }), t.createElement(ut, {
                            onChange: n.changeMonthYear,
                            day: p,
                            dayClassName: n.props.dayClassName,
                            onDayClick: n.handleDayClick,
                            onDayMouseEnter: n.handleDayMouseEnter,
                            onMouseLeave: n.handleMonthMouseLeave,
                            onWeekSelect: n.props.onWeekSelect,
                            orderInDisplay: o,
                            formatWeekNumber: n.props.formatWeekNumber,
                            locale: n.props.locale,
                            minDate: n.props.minDate,
                            maxDate: n.props.maxDate,
                            excludeDates: n.props.excludeDates,
                            highlightDates: n.props.highlightDates,
                            selectingDate: n.state.selectingDate,
                            includeDates: n.props.includeDates,
                            inline: n.props.inline,
                            fixedHeight: n.props.fixedHeight,
                            filterDate: n.props.filterDate,
                            preSelection: n.props.preSelection,
                            selected: n.props.selected,
                            selectsStart: n.props.selectsStart,
                            selectsEnd: n.props.selectsEnd,
                            showWeekNumbers: n.props.showWeekNumbers,
                            startDate: n.props.startDate,
                            endDate: n.props.endDate,
                            peekNextMonth: n.props.peekNextMonth,
                            setOpen: n.props.setOpen,
                            shouldCloseOnSelect: n.props.shouldCloseOnSelect,
                            renderDayContents: n.props.renderDayContents,
                            disabledKeyboardNavigation: n.props.disabledKeyboardNavigation,
                            showMonthYearPicker: n.props.showMonthYearPicker,
                            showQuarterYearPicker: n.props.showQuarterYearPicker
                        })));
                    }
                    return e;
                }
            }), le(we(n), "renderTimeSection", function() {
                if (n.props.showTimeSelect && (n.state.monthContainer || n.props.showTimeSelectOnly)) return t.createElement(ht, {
                    selected: n.props.selected,
                    openToDate: n.props.openToDate,
                    onChange: n.props.onTimeChange,
                    format: n.props.timeFormat,
                    includeTimes: n.props.includeTimes,
                    intervals: n.props.timeIntervals,
                    minTime: n.props.minTime,
                    maxTime: n.props.maxTime,
                    excludeTimes: n.props.excludeTimes,
                    timeCaption: n.props.timeCaption,
                    todayButton: n.props.todayButton,
                    showMonthDropdown: n.props.showMonthDropdown,
                    showMonthYearDropdown: n.props.showMonthYearDropdown,
                    showYearDropdown: n.props.showYearDropdown,
                    withPortal: n.props.withPortal,
                    monthRef: n.state.monthContainer,
                    injectTimes: n.props.injectTimes,
                    locale: n.props.locale
                });
            }), le(we(n), "renderInputTimeSection", function() {
                var e = new Date(n.props.selected), r = "".concat(Ze(e.getHours()), ":").concat(Ze(e.getMinutes()));
                if (n.props.showTimeInput) return t.createElement(ft, {
                    timeString: r,
                    timeInputLabel: n.props.timeInputLabel,
                    onChange: n.props.onTimeChange
                });
            }), n.containerRef = t.createRef(), n.state = {
                date: n.getDateInView(),
                selectingDate: null,
                monthContainer: null
            }, n;
        }
        return fe(r, t.Component), de(r, null, [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        monthSelectedIn: 0,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month"
                    };
                }
            }
        ]), de(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.props.preSelection && !xe(this.props.preSelection, e.preSelection) ? this.setState({
                        date: this.props.preSelection
                    }) : this.props.openToDate && !xe(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || mt;
                    return t.createElement("div", {
                        ref: this.containerRef
                    }, t.createElement(e, {
                        className: n("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow
                    }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
                }
            }
        ]), r;
    }(), Dt = function(e) {
        function r() {
            return ie(this, r), ve(this, me(r).apply(this, arguments));
        }
        return fe(r, t.Component), de(r, [
            {
                key: "render",
                value: function() {
                    var e, r = this.props, a = r.className, o = r.wrapperClassName, s = r.hidePopper, p = r.popperComponent, i = r.popperModifiers, c = r.popperPlacement, d = r.popperProps, l = r.targetComponent;
                    if (!s) {
                        var u = n("react-datepicker-popper", a);
                        e = t.createElement(se.Popper, ue({
                            modifiers: i,
                            placement: c
                        }, d), function(e) {
                            var r = e.ref, n = e.style, a = e.placement, o = e.arrowProps;
                            return t.createElement("div", ue({
                                ref: r,
                                style: n
                            }, {
                                className: u,
                                "data-placement": a
                            }), t.cloneElement(p, {
                                arrowProps: o
                            }));
                        });
                    }
                    this.props.popperContainer && (e = t.createElement(this.props.popperContainer, {}, e));
                    var h = n("react-datepicker-wrapper", o);
                    return t.createElement(se.Manager, {
                        className: "react-datepicker-manager"
                    }, t.createElement(se.Reference, null, function(e) {
                        var r = e.ref;
                        return t.createElement("div", {
                            ref: r,
                            className: h
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: {
                            preventOverflow: {
                                enabled: !0,
                                escapeWithReference: !0,
                                boundariesElement: "viewport"
                            }
                        },
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(), gt = "react-datepicker-ignore-onclickoutside", kt = oe(vt);
    var Ct = "Date input not valid.", _t = function(e) {
        function r(e) {
            var o;
            return ie(this, r), le(we(o = ve(this, me(r).call(this, e))), "getPreSelection", function() {
                return o.props.openToDate ? o.props.openToDate : o.props.selectsEnd && o.props.startDate ? o.props.startDate : o.props.selectsStart && o.props.endDate ? o.props.endDate : _e();
            }), le(we(o), "calcInitialState", function() {
                var e = o.getPreSelection(), t = ze(o.props), r = Ge(o.props), n = t && ee(e, t) ? t : r && Z(e, r) ? r : e;
                return {
                    open: o.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: o.props.selected ? o.props.selected : n,
                    highlightDates: Je(o.props.highlightDates),
                    focused: !1
                };
            }), le(we(o), "clearPreventFocusTimeout", function() {
                o.preventFocusTimeout && clearTimeout(o.preventFocusTimeout);
            }), le(we(o), "setFocus", function() {
                o.input && o.input.focus && o.input.focus();
            }), le(we(o), "setBlur", function() {
                o.input && o.input.blur && o.input.blur(), o.cancelFocusInput();
            }), le(we(o), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                o.setState({
                    open: e,
                    preSelection: e && o.state.open ? o.state.preSelection : o.calcInitialState().preSelection,
                    lastPreSelectChange: St
                }, function() {
                    e || o.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && o.setBlur(), o.setState({
                            inputValue: null
                        });
                    });
                });
            }), le(we(o), "inputOk", function() {
                return a(o.state.preSelection);
            }), le(we(o), "isCalendarOpen", function() {
                return void 0 === o.props.open ? o.state.open && !o.props.disabled && !o.props.readOnly : o.props.open;
            }), le(we(o), "handleFocus", function(e) {
                o.state.preventFocus || (o.props.onFocus(e), o.props.preventOpenOnFocus || o.props.readOnly || o.setOpen(!0)), o.setState({
                    focused: !0
                });
            }), le(we(o), "cancelFocusInput", function() {
                clearTimeout(o.inputFocusTimeout), o.inputFocusTimeout = null;
            }), le(we(o), "deferFocusInput", function() {
                o.cancelFocusInput(), o.inputFocusTimeout = setTimeout(function() {
                    return o.setFocus();
                }, 1);
            }), le(we(o), "handleDropdownFocus", function() {
                o.cancelFocusInput();
            }), le(we(o), "handleBlur", function(e) {
                !o.state.open || o.props.withPortal || o.props.showTimeInput ? o.props.onBlur(e) : o.deferFocusInput(), o.setState({
                    focused: !1
                });
            }), le(we(o), "handleCalendarClickOutside", function(e) {
                o.props.inline || o.setOpen(!1), o.props.onClickOutside(e), o.props.withPortal && e.preventDefault();
            }), le(we(o), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!o.props.onChangeRaw || (o.props.onChangeRaw.apply(we(o), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    o.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: bt
                    });
                    var a = be(n.target.value, o.props.dateFormat, o.props.locale, o.props.strictParsing);
                    !a && n.target.value || o.setSelected(a, n, !0);
                }
            }), le(we(o), "handleSelect", function(e, t, r) {
                o.setState({
                    preventFocus: !0
                }, function() {
                    return o.preventFocusTimeout = setTimeout(function() {
                        return o.setState({
                            preventFocus: !1
                        });
                    }, 50), o.preventFocusTimeout;
                }), o.setSelected(e, t, void 0, r), !o.props.shouldCloseOnSelect || o.props.showTimeSelect ? o.setPreSelection(e) : o.props.inline || o.setOpen(!1);
            }), le(we(o), "setSelected", function(e, t, r, n) {
                var a = e;
                if (null === a || !Be(a, o.props)) {
                    if (!Ie(o.props.selected, a) || o.props.allowSameDay) {
                        if (null !== a) {
                            if (o.props.selected) {
                                var s = o.props.selected;
                                r && (s = _e(a)), a = Oe(a, {
                                    hour: k(s),
                                    minute: g(s),
                                    second: D(s)
                                });
                            }
                            o.props.inline || o.setState({
                                preSelection: a
                            }), o.props.inline && o.props.monthsShown > 1 && !o.props.inlineFocusSelectedMonth && o.setState({
                                monthSelectedIn: n
                            });
                        }
                        o.props.onChange(a, t);
                    }
                    o.props.onSelect(a, t), r || o.setState({
                        inputValue: null
                    });
                }
            }), le(we(o), "setPreSelection", function(e) {
                var t = void 0 !== o.props.minDate, r = void 0 !== o.props.maxDate, n = !0;
                e && (t && r ? n = qe(e, o.props.minDate, o.props.maxDate) : t ? n = Z(e, o.props.minDate) : r && (n = ee(e, o.props.maxDate))), n && o.setState({
                    preSelection: e
                });
            }), le(we(o), "handleTimeChange", function(e) {
                var t = Oe(o.props.selected ? o.props.selected : o.getPreSelection(), {
                    hour: k(e),
                    minute: g(e)
                });
                o.setState({
                    preSelection: t
                }), o.props.onChange(t), o.props.shouldCloseOnSelect && o.setOpen(!1), o.props.showTimeInput && o.setOpen(!0), o.setState({
                    inputValue: null
                });
            }), le(we(o), "onInputClick", function() {
                o.props.disabled || o.props.readOnly || o.setOpen(!0), o.props.onInputClick();
            }), le(we(o), "onInputKeyDown", function(e) {
                o.props.onKeyDown(e);
                var t = e.key;
                if (o.state.open || o.props.inline || o.props.preventOpenOnFocus) {
                    var r = _e(o.state.preSelection);
                    if ("Enter" === t) e.preventDefault(), o.inputOk() && o.state.lastPreSelectChange === St ? (o.handleSelect(r, e), !o.props.shouldCloseOnSelect && o.setPreSelection(r)) : o.setOpen(!1);
                    else if ("Escape" === t) e.preventDefault(), o.setOpen(!1), o.inputOk() || o.props.onInputError({
                        code: 1,
                        msg: Ct
                    });
                    else if ("Tab" === t) o.setOpen(!1, !0);
                    else if (!o.props.disabledKeyboardNavigation) {
                        var n;
                        switch(t){
                            case "ArrowLeft":
                                n = m(r, 1);
                                break;
                            case "ArrowRight":
                                n = c(r, 1);
                                break;
                            case "ArrowUp":
                                n = y(r, 1);
                                break;
                            case "ArrowDown":
                                n = d(r, 1);
                                break;
                            case "PageUp":
                                n = w(r, 1);
                                break;
                            case "PageDown":
                                n = l(r, 1);
                                break;
                            case "Home":
                                n = v(r, 1);
                                break;
                            case "End":
                                n = u(r, 1);
                        }
                        if (!n) return void (o.props.onInputError && o.props.onInputError({
                            code: 1,
                            msg: Ct
                        }));
                        e.preventDefault(), o.setState({
                            lastPreSelectChange: St
                        }), o.props.adjustDateOnChange && o.setSelected(n), o.setPreSelection(n);
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t || o.onInputClick();
            }), le(we(o), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), o.props.onChange(null, e), o.setState({
                    inputValue: null
                });
            }), le(we(o), "clear", function() {
                o.onClearClick();
            }), le(we(o), "renderCalendar", function() {
                return o.props.inline || o.isCalendarOpen() ? t.createElement(kt, {
                    ref: function(e) {
                        o.calendar = e;
                    },
                    locale: o.props.locale,
                    adjustDateOnChange: o.props.adjustDateOnChange,
                    setOpen: o.setOpen,
                    shouldCloseOnSelect: o.props.shouldCloseOnSelect,
                    dateFormat: o.props.dateFormatCalendar,
                    useWeekdaysShort: o.props.useWeekdaysShort,
                    formatWeekDay: o.props.formatWeekDay,
                    dropdownMode: o.props.dropdownMode,
                    selected: o.props.selected,
                    preSelection: o.state.preSelection,
                    onSelect: o.handleSelect,
                    onWeekSelect: o.props.onWeekSelect,
                    openToDate: o.props.openToDate,
                    minDate: o.props.minDate,
                    maxDate: o.props.maxDate,
                    selectsStart: o.props.selectsStart,
                    selectsEnd: o.props.selectsEnd,
                    startDate: o.props.startDate,
                    endDate: o.props.endDate,
                    excludeDates: o.props.excludeDates,
                    filterDate: o.props.filterDate,
                    onClickOutside: o.handleCalendarClickOutside,
                    formatWeekNumber: o.props.formatWeekNumber,
                    highlightDates: o.state.highlightDates,
                    includeDates: o.props.includeDates,
                    includeTimes: o.props.includeTimes,
                    injectTimes: o.props.injectTimes,
                    inline: o.props.inline,
                    peekNextMonth: o.props.peekNextMonth,
                    showMonthDropdown: o.props.showMonthDropdown,
                    showPreviousMonths: o.props.showPreviousMonths,
                    useShortMonthInDropdown: o.props.useShortMonthInDropdown,
                    showMonthYearDropdown: o.props.showMonthYearDropdown,
                    showWeekNumbers: o.props.showWeekNumbers,
                    showYearDropdown: o.props.showYearDropdown,
                    withPortal: o.props.withPortal,
                    forceShowMonthNavigation: o.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: o.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: o.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: o.props.scrollableMonthYearDropdown,
                    todayButton: o.props.todayButton,
                    weekLabel: o.props.weekLabel,
                    outsideClickIgnoreClass: gt,
                    fixedHeight: o.props.fixedHeight,
                    monthsShown: o.props.monthsShown,
                    monthSelectedIn: o.state.monthSelectedIn,
                    onDropdownFocus: o.handleDropdownFocus,
                    onMonthChange: o.props.onMonthChange,
                    onYearChange: o.props.onYearChange,
                    dayClassName: o.props.dayClassName,
                    showTimeSelect: o.props.showTimeSelect,
                    showTimeSelectOnly: o.props.showTimeSelectOnly,
                    onTimeChange: o.handleTimeChange,
                    timeFormat: o.props.timeFormat,
                    timeIntervals: o.props.timeIntervals,
                    minTime: o.props.minTime,
                    maxTime: o.props.maxTime,
                    excludeTimes: o.props.excludeTimes,
                    timeCaption: o.props.timeCaption,
                    className: o.props.calendarClassName,
                    container: o.props.calendarContainer,
                    yearDropdownItemNumber: o.props.yearDropdownItemNumber,
                    previousMonthButtonLabel: o.props.previousMonthButtonLabel,
                    nextMonthButtonLabel: o.props.nextMonthButtonLabel,
                    previousYearButtonLabel: o.props.previousYearButtonLabel,
                    nextYearButtonLabel: o.props.nextYearButtonLabel,
                    timeInputLabel: o.props.timeInputLabel,
                    disabledKeyboardNavigation: o.props.disabledKeyboardNavigation,
                    renderCustomHeader: o.props.renderCustomHeader,
                    popperProps: o.props.popperProps,
                    renderDayContents: o.props.renderDayContents,
                    onDayMouseEnter: o.props.onDayMouseEnter,
                    onMonthMouseLeave: o.props.onMonthMouseLeave,
                    showTimeInput: o.props.showTimeInput,
                    showMonthYearPicker: o.props.showMonthYearPicker,
                    showQuarterYearPicker: o.props.showQuarterYearPicker,
                    showPopperArrow: o.props.showPopperArrow
                }, o.props.children) : null;
            }), le(we(o), "renderDateInput", function() {
                var e, r, a, s, p, i = n(o.props.className, le({}, gt, o.state.open)), c = o.props.customInput || t.createElement("input", {
                    type: "text"
                }), d = o.props.customInputRef || "ref", l = "string" == typeof o.props.value ? o.props.value : "string" == typeof o.state.inputValue ? o.state.inputValue : (r = o.props.selected, a = o.props, s = a.dateFormat, p = a.locale, r && Me(r, Array.isArray(s) ? s[0] : s, p) || "");
                return t.cloneElement(c, (le(e = {}, d, function(e) {
                    o.input = e;
                }), le(e, "value", l), le(e, "onBlur", o.handleBlur), le(e, "onChange", o.handleChange), le(e, "onClick", o.onInputClick), le(e, "onFocus", o.handleFocus), le(e, "onKeyDown", o.onInputKeyDown), le(e, "id", o.props.id), le(e, "name", o.props.name), le(e, "autoFocus", o.props.autoFocus), le(e, "placeholder", o.props.placeholderText), le(e, "disabled", o.props.disabled), le(e, "autoComplete", o.props.autoComplete), le(e, "className", n(c.props.className, i)), le(e, "title", o.props.title), le(e, "readOnly", o.props.readOnly), le(e, "required", o.props.required), le(e, "tabIndex", o.props.tabIndex), le(e, "aria-labelledby", o.props.ariaLabelledBy), e));
            }), le(we(o), "renderClearButton", function() {
                return o.props.isClearable && null != o.props.selected ? t.createElement("button", {
                    type: "button",
                    className: "react-datepicker__close-icon",
                    "aria-label": "Close",
                    onClick: o.onClearClick,
                    title: o.props.clearButtonTitle,
                    tabIndex: -1
                }) : null;
            }), o.state = o.calcInitialState(), o;
        }
        return fe(r, t.Component), de(r, null, [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showQuarterYearPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        renderDayContents: function(e) {
                            return e;
                        },
                        inlineFocusSelectedMonth: !1,
                        showPopperArrow: !0
                    };
                }
            }
        ]), de(r, [
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, n;
                    e.inline && (r = e.selected, n = this.props.selected, r && n ? b(r) !== b(n) || M(r) !== M(n) : r !== n) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: Je(this.props.highlightDates)
                    }), t.focused || Ie(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    return this.props.inline && !this.props.withPortal ? e : this.props.withPortal ? t.createElement("div", null, this.props.inline ? null : t.createElement("div", {
                        className: "react-datepicker__input-container"
                    }, this.renderDateInput(), this.renderClearButton()), this.state.open || this.props.inline ? t.createElement("div", {
                        className: "react-datepicker__portal"
                    }, e) : null) : t.createElement(Dt, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: t.createElement("div", {
                            className: "react-datepicker__input-container"
                        }, this.renderDateInput(), this.renderClearButton()),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps
                    });
                }
            }
        ]), r;
    }(), bt = "input", St = "navigate";
    e.CalendarContainer = mt, e.default = _t, e.getDefaultLocale = Le, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : global;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : global).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{"55b400dfb9477df9":"9njXz","6a082dc438cb1ca2":"bnNSm","3647656f9c7ebc5e":"5Een2","13c776570732a9da":"gmfSU","6553b0b4b603e1c3":"l72u5","d7b993ace1eca80":"520Dk","786b9925c1b6b5ed":"2LfIe","4f1b37d05fed00b3":"1WytR","5fc940b8b11b2f30":"fK40q","b78d0278e54da1b4":"6qgbJ","baecc74d7df402ea":"luR8G","7360dafd9cf06bde":"dwe65","376cbc5302b1ec0d":"1QoRD","f011acafa9d72da6":"jSfbp","aa659b497503e983":"0Vpj8","7b7bf8fb2c20e0c7":"c1mfa","f501b8cd52ae4ff":"135UL","9e212fc4b323ed41":"6E2gG","e8ff49b0d1cab426":"bdFXx","12eec1f6d562e008":"FWRfr","72fc20cc52029f11":"1nSRE","42e3036b4499153e":"1tAAj","5592c752ef1290f4":"cIzT5","fa470ac376b26caf":"iIEQj","bf3222da2f520817":"hehyE","685dda4962dc82e1":"cD64I","d6dea87c85b53e02":"3O7In","b9a1398c1c94250d":"4E92Q","e1fbbdf633f9e5ae":"jO4BN","8ac41f1b252a0973":"8Gl2s","156a522b3b8fd124":"5lQsS","f2620442a53b80d6":"8tdvO","1b94d4eb34edeca3":"8eGGa","47020b485e994171":"7SRyU","9818583261d8a102":"jGJ2T","1a7d4440a348b466":"9Dyug","50dce9ec585a5332":"iE73E","a738370d89dd61ec":"75PnZ","cdc90b6df52760f":"3B4AF","2fdd28e51cf3c8b2":"7nCna","72fb68fdc0d9bca3":"3si6M","964e71bf85841794":"blk2u","38468de993ee0549":"jexg9","ec1866b328e982ea":"45KIf","5c05196fbf6d6b4d":"hBRHp","9a6937c0aa7a418e":"7V8st","23c6d2169b7feabe":"9a5Tk","fda4089c257f1876":"53fX5","b5061c3c95f48e73":"i4e28","f57afb99b9b06613":"2bGq4","496ef8c8ed2b34d6":"jauD1","6663b9b2b265a941":"3rxYw","c3348d940b830a7f":"1N23w","53a4aaeeb87e1c51":"joMzA","45f66dd8a17e85aa":"6Kjfz","a3a5398768dc185f":"9koxn","201a807b2e6adc5e":"72XNY","a89a534c753bb4c3":"7FPd2","11a993db5effee60":"dcYJ9","acb830835f9d8af1":"pYnxB"}],"5Een2":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"gmfSU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9bkfg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requiredArgs);
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l72u5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValid);
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"gmfSU","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9koxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toDate);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"520Dk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"l72u5","../subMilliseconds/index.js":"8J3yE","../toDate/index.js":"9koxn","../_lib/format/formatters/index.js":"l17xy","../_lib/format/longFormatters/index.js":"l4aYZ","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/protectedTokens/index.js":"5gdbP","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","../_lib/defaultLocale/index.js":"5kaPu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8J3yE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMilliseconds);
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ueVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMilliseconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKtzz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toInteger);
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l17xy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"aCfY8","../../../_lib/getUTCISOWeek/index.js":"hMWge","../../../_lib/getUTCISOWeekYear/index.js":"brbzX","../../../_lib/getUTCWeek/index.js":"8MUbv","../../../_lib/getUTCWeekYear/index.js":"18XUY","../../addLeadingZeros/index.js":"9Bsa8","../lightFormatters/index.js":"6EcHD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCfY8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCDayOfYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMWge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"9koxn","../startOfUTCISOWeek/index.js":"aTskV","../startOfUTCISOWeekYear/index.js":"37Lio","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aTskV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37Lio":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCISOWeekYear);
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"brbzX","../startOfUTCISOWeek/index.js":"aTskV","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brbzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCISOWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MUbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"9koxn","../startOfUTCWeek/index.js":"20vji","../startOfUTCWeekYear/index.js":"3h6rf","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20vji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeek);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cViP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3h6rf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfUTCWeekYear);
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"18XUY","../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18XUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUTCWeekYear);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Bsa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EcHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"9Bsa8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4aYZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dIoK7":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gdbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "throwProtectedError", ()=>throwProtectedError);
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kaPu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"4vfjK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vfjK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"33ZTo","./_lib/formatLong/index.js":"3snKV","./_lib/formatRelative/index.js":"aDrXK","./_lib/localize/index.js":"cGr1B","./_lib/match/index.js":"gyWiy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"33ZTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3snKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"begpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDrXK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGr1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apnSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyWiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8m1gR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchFn);
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imsfL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LfIe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1WytR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fK40q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addDays);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6qgbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addDays/index.js":"fK40q","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luR8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dwe65":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMonths/index.js":"luR8G","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1QoRD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMinutes);
var _indexJs = require("../addMinutes/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMinutes/index.js":"2LfIe","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jSfbp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subHours);
var _indexJs = require("../addHours/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addHours/index.js":"1WytR","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0Vpj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subDays);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"fK40q","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1mfa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subWeeks);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addWeeks/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addWeeks/index.js":"6qgbJ","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"135UL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subMonths);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMonths/index.js":"luR8G","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6E2gG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subYears);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addYears/index.js":"dwe65","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdFXx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getSeconds);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getSeconds(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"FWRfr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMinutes);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMinutes(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1nSRE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHours);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getHours(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tAAj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIzT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDate);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDate(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iIEQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hehyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getQuarter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cD64I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getFullYear();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3O7In":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getTime);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4E92Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setSeconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setSeconds(dirtyDate, dirtySeconds) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var seconds = (0, _indexJsDefault.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jO4BN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMinutes);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setMinutes(dirtyDate, dirtyMinutes) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var minutes = (0, _indexJsDefault.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Gl2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setHours);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setHours(dirtyDate, dirtyHours) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var hours = (0, _indexJsDefault.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5lQsS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setMonth);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../getDaysInMonth/index.js":"gvmhi","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvmhi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDaysInMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8tdvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setQuarter);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../setMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setQuarter(dirtyDate, dirtyQuarter) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var quarter = (0, _indexJsDefault.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, _indexJsDefault2.default)(date, date.getMonth() + diff * 3);
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../setMonth/index.js":"5lQsS","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8eGGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setYear);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"gKtzz","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SRyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>min);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGJ2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>max);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Dyug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarDays);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../startOfDay/index.js":"7nCna","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7nCna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iE73E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"75PnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarWeeks);
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_WEEK = 604800000;
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfWeekLeft = (0, _indexJsDefault.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, _indexJsDefault.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, _indexJsDefault1.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, _indexJsDefault1.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

},{"../startOfWeek/index.js":"3si6M","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3si6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfWeek);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3B4AF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInCalendarYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blk2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jexg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfQuarter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45KIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>startOfYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hBRHp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfDay);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7V8st":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfWeek);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"1cViP","../toDate/index.js":"9koxn","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9a5Tk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>endOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"53fX5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isEqual);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyLeftDate);
    var dateRight = (0, _indexJsDefault.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4e28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameDay);
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"7nCna","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2bGq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jauD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameYear);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rxYw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameQuarter);
var _indexJs = require("../startOfQuarter/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

},{"../startOfQuarter/index.js":"jexg9","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1N23w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAfter);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"joMzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isBefore);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Kjfz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isWithinInterval);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWithinInterval(dirtyDate, interval) {
    (0, _indexJsDefault1.default)(2, arguments);
    var time = (0, _indexJsDefault.default)(dirtyDate).getTime();
    var startTime = (0, _indexJsDefault.default)(interval.start).getTime();
    var endTime = (0, _indexJsDefault.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72XNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parse);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","@babel/runtime/helpers/esm/createForOfIteratorHelper":"aDWbJ","../_lib/defaultLocale/index.js":"5kaPu","../subMilliseconds/index.js":"8J3yE","../toDate/index.js":"9koxn","../_lib/assign/index.js":"ebaSr","../_lib/format/longFormatters/index.js":"l4aYZ","../_lib/getTimezoneOffsetInMilliseconds/index.js":"dIoK7","../_lib/protectedTokens/index.js":"5gdbP","../_lib/toInteger/index.js":"gKtzz","../_lib/requiredArgs/index.js":"9bkfg","./_lib/Setter.js":"8MMcx","./_lib/parsers/index.js":"7IUvF","../_lib/defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDWbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createForOfIteratorHelper);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, _unsupportedIterableToArrayJsDefault.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"K5PcV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"K5PcV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"enjjy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enjjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ebaSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>assign);
function assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MMcx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", ()=>DateToSystemTimezoneSetter);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/defineProperty":"5zOJa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJtsr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6oM96":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"9UMxe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Qcqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"kxTHC","./isNativeReflectConstruct.js":"3xdRH","./possibleConstructorReturn.js":"gHSsV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxTHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xdRH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHSsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"la19k","./assertThisInitialized.js":"jJtsr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chhAr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3gRhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"61Sn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IUvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"kab4g","./YearParser.js":"99jVP","./LocalWeekYearParser.js":"2ttXC","./ISOWeekYearParser.js":"i0O3C","./ExtendedYearParser.js":"gotWm","./QuarterParser.js":"akkU8","./StandAloneQuarterParser.js":"2H4wl","./MonthParser.js":"7TuPi","./StandAloneMonthParser.js":"99rFP","./LocalWeekParser.js":"25yMP","./ISOWeekParser.js":"lKKiL","./DateParser.js":"aFDfi","./DayOfYearParser.js":"hA8D5","./DayParser.js":"jai6O","./LocalDayParser.js":"gPIfk","./StandAloneLocalDayParser.js":"c3sA0","./ISODayParser.js":"jXlK8","./AMPMParser.js":"6p81p","./AMPMMidnightParser.js":"JSP3I","./DayPeriodParser.js":"3rj7q","./Hour1to12Parser.js":"i0gZf","./Hour0to23Parser.js":"aPngu","./Hour0To11Parser.js":"gMmlD","./Hour1To24Parser.js":"aJEhQ","./MinuteParser.js":"269sd","./SecondParser.js":"e4ZOc","./FractionOfSecondParser.js":"izdK9","./ISOTimezoneWithZParser.js":"1udJV","./ISOTimezoneParser.js":"9DGq4","./TimestampSecondsParser.js":"hZAUb","./TimestampMillisecondsParser.js":"1WTFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kab4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dCP1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/defineProperty":"5zOJa","./Setter.js":"8MMcx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99jVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cJqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"49NaD","./constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49NaD":[function(require,module,exports,__globalThis) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mpGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ttXC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/getUTCWeekYear/index.js":"18XUY","../../../_lib/startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0O3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gotWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akkU8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2H4wl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7TuPi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../utils.js":"1cJqi","../Parser.js":"dCP1D","../constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99rFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"25yMP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","../../../_lib/setUTCWeek/index.js":"lcKkD","../../../_lib/startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcKkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"gKtzz","../../toDate/index.js":"9koxn","../getUTCWeek/index.js":"8MUbv","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lKKiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","../../../_lib/setUTCISOWeek/index.js":"kNScb","../../../_lib/startOfUTCISOWeek/index.js":"aTskV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kNScb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISOWeek);
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"gKtzz","../../toDate/index.js":"9koxn","../getUTCISOWeek/index.js":"hMWge","../requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFDfi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../utils.js":"1cJqi","../Parser.js":"dCP1D","../constants.js":"1mpGj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hA8D5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jai6O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jcEwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCDay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","../defaultOptions/index.js":"1cViP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPIfk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c3sA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCDay/index.js":"jcEwJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXlK8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","../../../_lib/setUTCISODay/index.js":"b0WCQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b0WCQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setUTCISODay);
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"9koxn","../requiredArgs/index.js":"9bkfg","../toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6p81p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"JSP3I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rj7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0gZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aPngu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gMmlD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJEhQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"269sd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4ZOc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"izdK9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1udJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DGq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../constants.js":"1mpGj","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZAUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1WTFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/defineProperty":"5zOJa","../Parser.js":"dCP1D","../utils.js":"1cJqi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7FPd2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseISO);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"49NaD","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dcYJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IGNORE_CLASS_NAME", ()=>IGNORE_CLASS_NAME);
var _react = require("react");
var _reactDom = require("react-dom");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = [
    'touchstart',
    'touchmove'
];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        _inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, _reactDom.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || enabledInstances[_this._uid]) return;
                if (typeof passiveEventSupport === 'undefined') passiveEventSupport = testPassiveEventSupport();
                enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete enabledInstances[_this._uid];
                var fn = handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                    });
                    delete handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = _objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, _react.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, _react.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: IGNORE_CLASS_NAME,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
exports.default = onClickOutsideHOC;

},{"react":"9njXz","react-dom":"2ApDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pYnxB":[function(require,module,exports,__globalThis) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", ()=>(0, _popperDefault.default)) // Public types
;
parcelHelpers.export(exports, "placements", ()=>(0, _popper.placements));
parcelHelpers.export(exports, "Manager", ()=>(0, _managerDefault.default));
parcelHelpers.export(exports, "Reference", ()=>(0, _referenceDefault.default));
var _popper = require("./Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _manager = require("./Manager");
var _managerDefault = parcelHelpers.interopDefault(_manager);
var _reference = require("./Reference");
var _referenceDefault = parcelHelpers.interopDefault(_reference);

},{"./Popper":"kIqmu","./Manager":"hfvQw","./Reference":"jo721","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIqmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InnerPopper", ()=>InnerPopper);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "default", ()=>Popper);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _deepEqual = require("deep-equal");
var _deepEqualDefault = parcelHelpers.interopDefault(_deepEqual);
var _react = require("react");
var _popperJs = require("popper.js");
var _popperJsDefault = parcelHelpers.interopDefault(_popperJs);
var _manager = require("./Manager");
var _utils = require("./utils");
var initialStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    opacity: 0,
    pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InnerPopper, _React$Component);
    function InnerPopper() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "state", {
            data: undefined,
            placement: undefined
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "popperInstance", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "popperNode", null);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "arrowNode", null);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setPopperNode", function(popperNode) {
            if (!popperNode || _this.popperNode === popperNode) return;
            (0, _utils.setRef)(_this.props.innerRef, popperNode);
            _this.popperNode = popperNode;
            _this.updatePopperInstance();
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setArrowNode", function(arrowNode) {
            _this.arrowNode = arrowNode;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "updateStateModifier", {
            enabled: true,
            order: 900,
            fn: function fn(data) {
                var placement = data.placement;
                _this.setState({
                    data: data,
                    placement: placement
                });
                return data;
            }
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getOptions", function() {
            return {
                placement: _this.props.placement,
                eventsEnabled: _this.props.eventsEnabled,
                positionFixed: _this.props.positionFixed,
                modifiers: (0, _extendsDefault.default)({}, _this.props.modifiers, {
                    arrow: (0, _extendsDefault.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
                        enabled: !!_this.arrowNode,
                        element: _this.arrowNode
                    }),
                    applyStyle: {
                        enabled: false
                    },
                    updateStateModifier: _this.updateStateModifier
                })
            };
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getPopperStyle", function() {
            return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extendsDefault.default)({
                position: _this.state.data.offsets.popper.position
            }, _this.state.data.styles);
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getPopperPlacement", function() {
            return !_this.state.data ? undefined : _this.state.placement;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getArrowStyle", function() {
            return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "getOutOfBoundariesState", function() {
            return _this.state.data ? _this.state.data.hide : undefined;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "destroyPopperInstance", function() {
            if (!_this.popperInstance) return;
            _this.popperInstance.destroy();
            _this.popperInstance = null;
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "updatePopperInstance", function() {
            _this.destroyPopperInstance();
            var _assertThisInitialize = (0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), popperNode = _assertThisInitialize.popperNode;
            var referenceElement = _this.props.referenceElement;
            if (!referenceElement || !popperNode) return;
            _this.popperInstance = new (0, _popperJsDefault.default)(referenceElement, popperNode, _this.getOptions());
        });
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "scheduleUpdate", function() {
            if (_this.popperInstance) _this.popperInstance.scheduleUpdate();
        });
        return _this;
    }
    var _proto = InnerPopper.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // If the Popper.js options have changed, update the instance (destroy + create)
        if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqualDefault.default)(this.props.modifiers, prevProps.modifiers, {
            strict: true
        })) this.updatePopperInstance();
        else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
         // A placement difference in state means popper determined a new placement
        // apart from the props value. By the time the popper element is rendered with
        // the new position Popper has already measured it, if the place change triggers
        // a size change it will result in a misaligned popper. So we schedule an update to be sure.
        if (prevState.placement !== this.state.placement) this.scheduleUpdate();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, _utils.setRef)(this.props.innerRef, null);
        this.destroyPopperInstance();
    };
    _proto.render = function render() {
        return (0, _utils.unwrapArray)(this.props.children)({
            ref: this.setPopperNode,
            style: this.getPopperStyle(),
            placement: this.getPopperPlacement(),
            outOfBoundaries: this.getOutOfBoundariesState(),
            scheduleUpdate: this.scheduleUpdate,
            arrowProps: {
                ref: this.setArrowNode,
                style: this.getArrowStyle()
            }
        });
    };
    return InnerPopper;
}(_react.Component);
(0, _definePropertyDefault.default)(InnerPopper, "defaultProps", {
    placement: 'bottom',
    eventsEnabled: true,
    referenceElement: undefined,
    positionFixed: false
});
var placements = (0, _popperJsDefault.default).placements;
function Popper(_ref) {
    var referenceElement = _ref.referenceElement, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "referenceElement"
    ]);
    return _react.createElement((0, _manager.ManagerReferenceNodeContext).Consumer, null, function(referenceNode) {
        return _react.createElement(InnerPopper, (0, _extendsDefault.default)({
            referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
        }, props));
    });
}

},{"@babel/runtime/helpers/objectWithoutPropertiesLoose":"imPRm","@babel/runtime/helpers/extends":"ktcBy","@babel/runtime/helpers/inheritsLoose":"kUsrV","@babel/runtime/helpers/assertThisInitialized":"f0luE","@babel/runtime/helpers/defineProperty":"hjdoh","deep-equal":"bX1wQ","react":"9njXz","popper.js":"1dDyS","./Manager":"hfvQw","./utils":"1Yvps","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imPRm":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"ktcBy":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kUsrV":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("56507d829b6b7d3d");
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, setPrototypeOf(t, o);
}
module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"56507d829b6b7d3d":"iyNOR"}],"iyNOR":[function(require,module,exports,__globalThis) {
function _setPrototypeOf(t, e) {
    return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"f0luE":[function(require,module,exports,__globalThis) {
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"hjdoh":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("29ac19868e7f119");
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"29ac19868e7f119":"6uI3m"}],"6uI3m":[function(require,module,exports,__globalThis) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"979to","2713647ce51d8c75":"3Msou"}],"979to":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"3Msou":[function(require,module,exports,__globalThis) {
var _typeof = require("e0211298897b2d31")["default"];
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"979to"}],"bX1wQ":[function(require,module,exports,__globalThis) {
var objectKeys = require("69b25d5c5741b949");
var isArguments = require("35e168c0757d86dc");
var is = require("4507ab82af52838e");
var isRegex = require("e39d986f72f520d7");
var flags = require("f60a9f85e965c8db");
var isDate = require("51869b400334d972");
var getTime = Date.prototype.getTime;
function deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? is(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? is(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return objEquiv(actual, expected, opts);
}
function isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if (isArguments(a) !== isArguments(b)) return false;
    var aIsRegex = isRegex(a);
    var bIsRegex = isRegex(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && flags(a) === flags(b);
    if (isDate(a) && isDate(b)) return getTime.call(a) === getTime.call(b);
    var aIsBuffer = isBuffer(a);
    var bIsBuffer = isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = objectKeys(a);
        var kb = objectKeys(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = deepEqual;

},{"69b25d5c5741b949":"7AE8b","35e168c0757d86dc":"ikBfj","4507ab82af52838e":"41SFz","e39d986f72f520d7":"YNqlw","f60a9f85e965c8db":"dXFr5","51869b400334d972":"3HCJv"}],"7AE8b":[function(require,module,exports,__globalThis) {
'use strict';
var slice = Array.prototype.slice;
var isArgs = require("93e8460f624c96f4");
var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) {
    return origKeys(o);
} : require("344bb0d7b2568e03");
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if (isArgs(object)) return originalKeys(slice.call(object));
            return originalKeys(object);
        };
    } else Object.keys = keysShim;
    return Object.keys || keysShim;
};
module.exports = keysShim;

},{"93e8460f624c96f4":"hFngz","344bb0d7b2568e03":"5BYnt"}],"hFngz":[function(require,module,exports,__globalThis) {
'use strict';
var toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

},{}],"5BYnt":[function(require,module,exports,__globalThis) {
'use strict';
var keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var has = Object.prototype.hasOwnProperty;
    var toStr = Object.prototype.toString;
    var isArgs = require("b0d8c8b84be91ffd"); // eslint-disable-line global-require
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable.call({
        toString: null
    }, 'toString');
    var hasProtoEnumBug = isEnumerable.call(function() {}, 'prototype');
    var dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !hasAutomationEqualityBug) return equalsConstructorPrototype(o);
        try {
            return equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = toStr.call(object) === '[object Function]';
        var isArguments = isArgs(object);
        var isString = isObject && toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && has.call(object, name)) theKeys.push(String(name));
        }
        if (hasDontEnumBug) {
            var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < dontEnums.length; ++k)if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) theKeys.push(dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = keysShim;

},{"b0d8c8b84be91ffd":"hFngz"}],"ikBfj":[function(require,module,exports,__globalThis) {
'use strict';
var hasToStringTag = require("e2b01ce809f132fb")();
var callBound = require("4a3fd3308cb18520");
var $toString = callBound('Object.prototype.toString');
/** @type {import('.')} */ var isStandardArguments = function isArguments(value) {
    if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var isLegacyArguments = function isArguments(value) {
    if (isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $toString(value) !== '[object Array]' && 'callee' in value && $toString(value.callee) === '[object Function]';
};
var supportsStandardArguments = function() {
    return isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;

},{"e2b01ce809f132fb":"daNF4","4a3fd3308cb18520":"dhWMF"}],"daNF4":[function(require,module,exports,__globalThis) {
'use strict';
var hasSymbols = require("2ef89576d4959bff");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return hasSymbols() && !!Symbol.toStringTag;
};

},{"2ef89576d4959bff":"77zbC"}],"77zbC":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

},{}],"dhWMF":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("90205503fa989ea7");
var callBindBasic = require("79b99f4b8fc521d");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $indexOf = callBindBasic([
    GetIntrinsic('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    // eslint-disable-next-line no-extra-parens
    var intrinsic = /** @type {Parameters<typeof callBindBasic>[0][0]} */ GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBindBasic([
        intrinsic
    ]);
    return intrinsic;
};

},{"90205503fa989ea7":"dRNto","79b99f4b8fc521d":"WMD82"}],"dRNto":[function(require,module,exports,__globalThis) {
'use strict';
var undefined1;
var $Object = require("2664640474097f21");
var $Error = require("ff34c740859aa28e");
var $EvalError = require("349515b7ea9b6cef");
var $RangeError = require("9da01653b2dd9abf");
var $ReferenceError = require("68586abd6b0136da");
var $SyntaxError = require("662263fdbc077fc8");
var $TypeError = require("abdfc34e5f6bb86");
var $URIError = require("daca1f932429e03e");
var abs = require("6a52a0c0ffccac74");
var floor = require("d01cf04757c5320b");
var max = require("a2657a92cb7dae87");
var min = require("6367c0241be1f01");
var pow = require("9bee48b90a8c96d");
var round = require("b5cc049891156ba3");
var sign = require("8d956274d8c0407e");
var $Function = Function;
// eslint-disable-next-line consistent-return
var getEvalledConstructor = function(expressionSyntax) {
    try {
        return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $gOPD = require("7f0abb73c570ef31");
var $defineProperty = require("3cbcb7341b0412ef");
var throwTypeError = function() {
    throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return throwTypeError;
        }
    }
}() : throwTypeError;
var hasSymbols = require("1f00f712d594ccf")();
var getProto = require("89cf41d095fe5a0a");
var $ObjectGPO = require("a5e781ace21741c8");
var $ReflectGPO = require("db08b186beb7f382");
var $apply = require("213af9137f841281");
var $call = require("56d5af438508fcc0");
var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
var INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $Error,
    '%eval%': eval,
    '%EvalError%': $EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $Object,
    '%Object.getOwnPropertyDescriptor%': $gOPD,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $RangeError,
    '%ReferenceError%': $ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $call,
    '%Function.prototype.apply%': $apply,
    '%Object.defineProperty%': $defineProperty,
    '%Object.getPrototypeOf%': $ObjectGPO,
    '%Math.abs%': abs,
    '%Math.floor%': floor,
    '%Math.max%': max,
    '%Math.min%': min,
    '%Math.pow%': pow,
    '%Math.round%': round,
    '%Math.sign%': sign,
    '%Reflect.getPrototypeOf%': $ReflectGPO
};
if (getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var errorProto = getProto(getProto(e));
    INTRINSICS['%Error.prototype%'] = errorProto;
}
var doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && getProto) value = getProto(gen.prototype);
    }
    INTRINSICS[name] = value;
    return value;
};
var LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};
var bind = require("7c5e688e48cd07b0");
var hasOwn = require("af36d49b4b8c6c7c");
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $replace(string, rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
        alias = LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if (hasOwn(INTRINSICS, intrinsicName)) {
        var value = INTRINSICS[intrinsicName];
        if (value === needsEval) value = doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $TypeError('"allowMissing" argument must be a boolean');
    if ($exec(/^%?[^%]*%?$/, name) === null) throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $spliceApply(parts, $concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $strSlice(part, 0, 1);
        var last = $strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $SyntaxError('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if (hasOwn(INTRINSICS, intrinsicRealName)) value = INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gOPD && i + 1 >= parts.length) {
                var desc = $gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = hasOwn(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

},{"2664640474097f21":"jtFM1","ff34c740859aa28e":"7OqOD","349515b7ea9b6cef":"bLeeT","9da01653b2dd9abf":"bX7m3","68586abd6b0136da":"39CPB","662263fdbc077fc8":"kM1J4","abdfc34e5f6bb86":"4FiSx","daca1f932429e03e":"cM9HK","6a52a0c0ffccac74":"77OnN","d01cf04757c5320b":"gJ7BF","a2657a92cb7dae87":"fau6D","6367c0241be1f01":"ahtCb","9bee48b90a8c96d":"6baT2","b5cc049891156ba3":"buQjL","8d956274d8c0407e":"k6rOv","7f0abb73c570ef31":"iyLmA","3cbcb7341b0412ef":"4nWJu","1f00f712d594ccf":"9IzVf","89cf41d095fe5a0a":"8CcHr","a5e781ace21741c8":"hfU1H","db08b186beb7f382":"5MT56","213af9137f841281":"l0B7X","56d5af438508fcc0":"ajLUt","7c5e688e48cd07b0":"jn7fQ","af36d49b4b8c6c7c":"aZ5G0"}],"jtFM1":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

},{}],"7OqOD":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

},{}],"bLeeT":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

},{}],"bX7m3":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

},{}],"39CPB":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

},{}],"kM1J4":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

},{}],"4FiSx":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

},{}],"cM9HK":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

},{}],"77OnN":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

},{}],"gJ7BF":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

},{}],"fau6D":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

},{}],"ahtCb":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

},{}],"6baT2":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

},{}],"buQjL":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

},{}],"k6rOv":[function(require,module,exports,__globalThis) {
'use strict';
var $isNaN = require("d292273fa9eecbef");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($isNaN(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

},{"d292273fa9eecbef":"ku7FW"}],"ku7FW":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

},{}],"iyLmA":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $gOPD = require("2065a078be813600");
if ($gOPD) try {
    $gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $gOPD = null;
}
module.exports = $gOPD;

},{"2065a078be813600":"59Jmk"}],"59Jmk":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

},{}],"4nWJu":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ var $defineProperty = Object.defineProperty || false;
if ($defineProperty) try {
    $defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = false;
}
module.exports = $defineProperty;

},{}],"9IzVf":[function(require,module,exports,__globalThis) {
'use strict';
var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require("3fb25678c62d2fce");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return hasSymbolSham();
};

},{"3fb25678c62d2fce":"77zbC"}],"8CcHr":[function(require,module,exports,__globalThis) {
'use strict';
var reflectGetProto = require("ba0ea764912daf49");
var originalGetProto = require("1bd809a13f9b0f46");
var getDunderProto = require("fbec8086c64f7968");
/** @type {import('.')} */ module.exports = reflectGetProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return reflectGetProto(O);
} : originalGetProto ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return originalGetProto(O);
} : getDunderProto ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return getDunderProto(O);
} : null;

},{"ba0ea764912daf49":"5MT56","1bd809a13f9b0f46":"hfU1H","fbec8086c64f7968":"6qohZ"}],"5MT56":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

},{}],"hfU1H":[function(require,module,exports,__globalThis) {
'use strict';
var $Object = require("23f06d8f004a91fb");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $Object.getPrototypeOf || null;

},{"23f06d8f004a91fb":"jtFM1"}],"6qohZ":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("20202e6273970ec3");
var gOPD = require("6e9e415ed4ed192c");
var hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = desc && typeof desc.get === 'function' ? callBind([
    desc.get
]) : typeof $getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $getPrototypeOf(value == null ? value : $Object(value));
} : false;

},{"20202e6273970ec3":"WMD82","6e9e415ed4ed192c":"iyLmA"}],"WMD82":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("d6d8aee3c61fa381");
var $TypeError = require("3ad70b4ee76fdc3");
var $call = require("79792e7530a25b0e");
var $actualApply = require("1883a23d55f655c3");
/** @type {import('.')} */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $TypeError('a function is required');
    return $actualApply(bind, $call, args);
};

},{"d6d8aee3c61fa381":"jn7fQ","3ad70b4ee76fdc3":"4FiSx","79792e7530a25b0e":"ajLUt","1883a23d55f655c3":"e8fTV"}],"jn7fQ":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("12e173b4dbaee960");
module.exports = Function.prototype.bind || implementation;

},{"12e173b4dbaee960":"3CVeo"}],"3CVeo":[function(require,module,exports,__globalThis) {
'use strict';
/* eslint no-invalid-this: 1 */ var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';
var concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) throw new TypeError(ERROR_MESSAGE + target);
    var args = slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, concatty(args, arguments));
    };
    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

},{}],"ajLUt":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

},{}],"e8fTV":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("ba0cb57b961776b");
var $apply = require("8002d8d4a5e40cd8");
var $call = require("dd5326344bf1485c");
var $reflectApply = require("ddbf3cfadf2f22c");
/** @type {import('./actualApply')} */ module.exports = $reflectApply || bind.call($call, $apply);

},{"ba0cb57b961776b":"jn7fQ","8002d8d4a5e40cd8":"l0B7X","dd5326344bf1485c":"ajLUt","ddbf3cfadf2f22c":"5f1pB"}],"l0B7X":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

},{}],"5f1pB":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],"aZ5G0":[function(require,module,exports,__globalThis) {
'use strict';
var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require("126cb75e62f8e17b");
/** @type {import('.')} */ module.exports = bind.call(call, $hasOwn);

},{"126cb75e62f8e17b":"jn7fQ"}],"41SFz":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("7a0bb7df335a6af");
var callBind = require("794ce1103c4a65ba");
var implementation = require("f52a71fcf365d3bd");
var getPolyfill = require("59addbaef079e040");
var shim = require("c0e8b0f7342ba484");
var polyfill = callBind(getPolyfill(), Object);
define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"7a0bb7df335a6af":"iXqnd","794ce1103c4a65ba":"hMR6y","f52a71fcf365d3bd":"kxFs1","59addbaef079e040":"gpUkX","c0e8b0f7342ba484":"235ds"}],"iXqnd":[function(require,module,exports,__globalThis) {
'use strict';
var keys = require("7ff177585d1618f0");
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = require("84ca194f5a28ce70");
var isFunction = function(fn) {
    return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};
var supportsDescriptors = require("c52d62086511583f")();
var defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!isFunction(predicate) || !predicate()) return;
    }
    if (supportsDescriptors) defineDataProperty(object, name, value, true);
    else defineDataProperty(object, name, value);
};
var defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = keys(map);
    if (hasSymbols) props = concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
defineProperties.supportsDescriptors = !!supportsDescriptors;
module.exports = defineProperties;

},{"7ff177585d1618f0":"7AE8b","84ca194f5a28ce70":"l1706","c52d62086511583f":"gruPM"}],"l1706":[function(require,module,exports,__globalThis) {
'use strict';
var $defineProperty = require("f17fd23367965521");
var $SyntaxError = require("50f12088ee0f6bb");
var $TypeError = require("45c79de2b2f9c949");
var gopd = require("3f9bd39335781ec7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $TypeError('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $TypeError('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $TypeError('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!gopd && gopd(obj, property);
    if ($defineProperty) $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

},{"f17fd23367965521":"4nWJu","50f12088ee0f6bb":"kM1J4","45c79de2b2f9c949":"4FiSx","3f9bd39335781ec7":"iyLmA"}],"gruPM":[function(require,module,exports,__globalThis) {
'use strict';
var $defineProperty = require("1c3b0ce871129f60");
var hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$defineProperty) return null;
    try {
        return $defineProperty([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = hasPropertyDescriptors;

},{"1c3b0ce871129f60":"4nWJu"}],"hMR6y":[function(require,module,exports,__globalThis) {
'use strict';
var setFunctionLength = require("f4b53071c102d4e");
var $defineProperty = require("3426ee59b177cf96");
var callBindBasic = require("48445b01a0d39287");
var applyBind = require("2ccc4afca1db8d27");
module.exports = function callBind(originalFunction) {
    var func = callBindBasic(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return setFunctionLength(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($defineProperty) $defineProperty(module.exports, 'apply', {
    value: applyBind
});
else module.exports.apply = applyBind;

},{"f4b53071c102d4e":"hRIKQ","3426ee59b177cf96":"4nWJu","48445b01a0d39287":"WMD82","2ccc4afca1db8d27":"eTRzy"}],"hRIKQ":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8b1c9107ef1524f2");
var define = require("37dd1486f0f556ef");
var hasDescriptors = require("6a9d2b46085df706")();
var gOPD = require("2d412b0f532d1834");
var $TypeError = require("4352c534d27fe477");
var $floor = GetIntrinsic('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) throw new $TypeError('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && gOPD) {
        var desc = gOPD(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

},{"8b1c9107ef1524f2":"dRNto","37dd1486f0f556ef":"l1706","6a9d2b46085df706":"gruPM","2d412b0f532d1834":"iyLmA","4352c534d27fe477":"4FiSx"}],"eTRzy":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("a42cbe56dcf9275");
var $apply = require("374f458abdeecf5a");
var actualApply = require("5dc0de3ccb73e5d2");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return actualApply(bind, $apply, arguments);
};

},{"a42cbe56dcf9275":"jn7fQ","374f458abdeecf5a":"l0B7X","5dc0de3ccb73e5d2":"e8fTV"}],"kxFs1":[function(require,module,exports,__globalThis) {
'use strict';
var numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if (numberIsNaN(a) && numberIsNaN(b)) return true;
    return false;
};

},{}],"gpUkX":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("ff80ab827617d6fd");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : implementation;
};

},{"ff80ab827617d6fd":"kxFs1"}],"235ds":[function(require,module,exports,__globalThis) {
'use strict';
var getPolyfill = require("f188d636391a5061");
var define = require("155865cffc557cd");
module.exports = function shimObjectIs() {
    var polyfill = getPolyfill();
    define(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

},{"f188d636391a5061":"gpUkX","155865cffc557cd":"iXqnd"}],"YNqlw":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("e8ae6fb50d24c345");
var hasToStringTag = require("a5e890a505b039e5")();
var hasOwn = require("a7c11bfda61a32f");
var gOPD = require("2ad64b17b65049b4");
/** @type {import('.')} */ var fn;
if (hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $exec = callBound('RegExp.prototype.exec');
    /** @type {object} */ var isRegexMarker = {};
    var throwRegexMarker = function() {
        throw isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var badStringifier = {
        toString: throwRegexMarker,
        valueOf: throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') badStringifier[Symbol.toPrimitive] = throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ gOPD(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $exec(value, /** @type {unknown} */ badStringifier);
        } catch (e) {
            return e === isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $toString = callBound('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var regexClass = '[object RegExp]';
    /** @type {import('.')} */ fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $toString(value) === regexClass;
    };
}
module.exports = fn;

},{"e8ae6fb50d24c345":"dhWMF","a5e890a505b039e5":"daNF4","a7c11bfda61a32f":"aZ5G0","2ad64b17b65049b4":"iyLmA"}],"dXFr5":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("234cd2776d15a037");
var callBind = require("6f662a760b1534f2");
var implementation = require("92a1454309a44466");
var getPolyfill = require("3ca514117a836edc");
var shim = require("e153862c910219d2");
var flagsBound = callBind(getPolyfill());
define(flagsBound, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = flagsBound;

},{"234cd2776d15a037":"iXqnd","6f662a760b1534f2":"hMR6y","92a1454309a44466":"hbHj3","3ca514117a836edc":"kUBio","e153862c910219d2":"kJbzx"}],"hbHj3":[function(require,module,exports,__globalThis) {
'use strict';
var setFunctionName = require("73fe2073c023acf2");
var $TypeError = require("426e5953f3236710");
var $Object = Object;
module.exports = setFunctionName(function flags() {
    if (this == null || this !== $Object(this)) throw new $TypeError('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

},{"73fe2073c023acf2":"56KB4","426e5953f3236710":"4FiSx"}],"56KB4":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("151b89e8a715d4f3");
var hasDescriptors = require("e4d428b901bb50")();
var functionsHaveConfigurableNames = require("ff3f0082d0e55515").functionsHaveConfigurableNames();
var $TypeError = require("e7e6dd6b278b3b4f");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $TypeError('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || functionsHaveConfigurableNames) {
        if (hasDescriptors) define(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
        else define(/** @type {Parameters<define>[0]} */ fn, 'name', name);
    }
    return fn;
};

},{"151b89e8a715d4f3":"l1706","e4d428b901bb50":"gruPM","ff3f0082d0e55515":"c55xM","e7e6dd6b278b3b4f":"4FiSx"}],"c55xM":[function(require,module,exports,__globalThis) {
'use strict';
var functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var gOPD = Object.getOwnPropertyDescriptor;
if (gOPD) try {
    gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    gOPD = null;
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!functionsHaveNames() || !gOPD) return false;
    var desc = gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return functionsHaveNames() && typeof $bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = functionsHaveNames;

},{}],"kUBio":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("758a981608e1eeda");
var supportsDescriptors = require("6f5c0dd77da656ca").supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if (supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function() {
                    calls += 'y';
                }
            });
            descriptor.get.call(o);
            if (calls === 'dy') return descriptor.get;
        }
    }
    return implementation;
};

},{"758a981608e1eeda":"hbHj3","6f5c0dd77da656ca":"iXqnd"}],"kJbzx":[function(require,module,exports,__globalThis) {
'use strict';
var supportsDescriptors = require("d860dcb1943639b0").supportsDescriptors;
var getPolyfill = require("cdfc6652a32f035d");
var gOPD = require("d83d77f4bd19dc79");
var defineProperty = Object.defineProperty;
var $TypeError = require("b24365cb4b9e8992");
var getProto = require("190962971f9082da");
var regex = /a/;
module.exports = function shimFlags() {
    if (!supportsDescriptors || !getProto) throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = getPolyfill();
    var proto = getProto(regex);
    var descriptor = gOPD(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

},{"d860dcb1943639b0":"iXqnd","cdfc6652a32f035d":"kUBio","d83d77f4bd19dc79":"iyLmA","b24365cb4b9e8992":"7OqOD","190962971f9082da":"8CcHr"}],"3HCJv":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("f7aa53f619d004c5");
var getDay = callBound('Date.prototype.getDay');
/** @type {import('.')} */ var tryDateObject = function tryDateGetDayCall(value) {
    try {
        getDay(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(value: unknown) => string} */ var toStr = callBound('Object.prototype.toString');
var dateClass = '[object Date]';
var hasToStringTag = require("a0fda07f3b6c493a")();
/** @type {import('.')} */ module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return hasToStringTag ? tryDateObject(value) : toStr(value) === dateClass;
};

},{"f7aa53f619d004c5":"dhWMF","a0fda07f3b6c493a":"daNF4"}],"1dDyS":[function(require,module,exports,__globalThis) {
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, timeoutDuration);
        }
    };
}
var supportsMicroTasks = isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return getScrollParent(getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function isIE(version) {
    if (version === 11) return isIE11;
    if (version === 10) return isIE10;
    return isIE11 || isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') return getOffsetParent(offsetParent);
    return offsetParent;
}
function isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function getRoot(node) {
    if (node.parentNode !== null) return getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if (isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = getRoot(element1);
    if (element1root.host) return findCommonOffsetParent(element1root.host, element2);
    else return findCommonOffsetParent(element1, getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = getScroll(element, 'top');
    var scrollLeft = getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = isIE(10) && getComputedStyle(html);
    return {
        height: getSize('Height', body, html, computedStyle),
        width: getSize('Width', body, html, computedStyle)
    };
}
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function getClientRect(offsets) {
    return _extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if (isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = getScroll(element, 'top');
            var scrollLeft = getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = getStyleComputedProperty(element);
        horizScrollbar -= getBordersSize(styles, 'x');
        vertScrollbar -= getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = getBoundingClientRect(children);
    var parentRect = getBoundingClientRect(parent);
    var scrollParent = getScrollParent(children);
    var styles = getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = includeScroll(offsets, parent);
    return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if (getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = getParentNode(element);
    if (!parentNode) return false;
    return isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = getScrollParent(getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
            var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return _extends({
            key: key
        }, rects[key], {
            area: getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
    return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = getClientRect(data.offsets.popper);
            data.offsets.reference = getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if (isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = getScrollParent(reference);
    attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function removeEventListeners(reference, state) {
    // Remove resize event listener on window
    getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = getOffsetParent(data.instance.popper);
    var offsetParentRect = getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = _extends({}, attributes, data.attributes);
    data.styles = _extends({}, styles, data.styles);
    data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = validPlacements.indexOf(placement);
    var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if (isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case BEHAVIORS.CLOCKWISE:
            flipOrder = clockwise(placement);
            break;
        case BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf(find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if (isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if (isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = _extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: defineProperty({}, side, reference[side]),
            end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function hide(data) {
    if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = getOppositePlacement(placement);
    data.offsets.popper = getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: applyStyle,
        /** @prop {Function} */ onLoad: applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = _extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return _extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
exports.default = Popper;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfvQw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", ()=>ManagerReferenceNodeContext);
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", ()=>ManagerReferenceNodeSetterContext);
parcelHelpers.export(exports, "default", ()=>Manager);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _createReactContext = require("@hypnosphi/create-react-context");
var _createReactContextDefault = parcelHelpers.interopDefault(_createReactContext);
var ManagerReferenceNodeContext = (0, _createReactContextDefault.default)();
var ManagerReferenceNodeSetterContext = (0, _createReactContextDefault.default)();
var Manager = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Manager, _React$Component);
    function Manager() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "referenceNode", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "setReferenceNode", function(newReferenceNode) {
            if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
                _this.referenceNode = newReferenceNode;
                _this.forceUpdate();
            }
        });
        return _this;
    }
    var _proto = Manager.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.referenceNode = null;
    };
    _proto.render = function render() {
        return _react.createElement(ManagerReferenceNodeContext.Provider, {
            value: this.referenceNode
        }, _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
            value: this.setReferenceNode
        }, this.props.children));
    };
    return Manager;
}(_react.Component);

},{"@babel/runtime/helpers/inheritsLoose":"kUsrV","@babel/runtime/helpers/assertThisInitialized":"f0luE","@babel/runtime/helpers/defineProperty":"hjdoh","react":"9njXz","@hypnosphi/create-react-context":"iI4v8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iI4v8":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _react = require("ddac09876d051a09");
var _react2 = _interopRequireDefault(_react);
var _implementation = require("73440850e08f5e9a");
var _implementation2 = _interopRequireDefault(_implementation);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

},{"ddac09876d051a09":"9njXz","73440850e08f5e9a":"kP99i"}],"kP99i":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _react = require("b66096a24343785f");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("9a7f0b75e5abd6be");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _gud = require("c6e18d8274bd2f62");
var _gud2 = _interopRequireDefault(_gud);
var _warning = require("f3c3d30113536d1d");
var _warning2 = _interopRequireDefault(_warning);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
    var Provider = function(_Component) {
        _inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            _classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if (objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }(_react.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        _inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            _classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), _possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }(_react.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
exports.default = createReactContext;
module.exports = exports['default'];

},{"b66096a24343785f":"9njXz","9a7f0b75e5abd6be":"bnNSm","c6e18d8274bd2f62":"ecHJd","f3c3d30113536d1d":"4kUCc"}],"ecHJd":[function(require,module,exports,__globalThis) {
// @flow
var global = arguments[3];
'use strict';
var key = '__global_unique_id__';
module.exports = function() {
    return global[key] = (global[key] || 0) + 1;
};

},{}],"4kUCc":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = false;
var warning = function() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"1Yvps":[function(require,module,exports,__globalThis) {
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", ()=>unwrapArray);
parcelHelpers.export(exports, "safeInvoke", ()=>safeInvoke);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "setRef", ()=>setRef);
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var shallowEqual = function shallowEqual(objA, objB) {
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    if (bKeys.length !== aKeys.length) return false;
    for(var i = 0; i < bKeys.length; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jo721":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Reference);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
var InnerReference = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(InnerReference, _React$Component);
    function InnerReference() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), "refHandler", function(node) {
            (0, _utils.setRef)(_this.props.innerRef, node);
            (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
        });
        return _this;
    }
    var _proto = InnerReference.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, _utils.setRef)(this.props.innerRef, null);
    };
    _proto.render = function render() {
        (0, _warningDefault.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        return (0, _utils.unwrapArray)(this.props.children)({
            ref: this.refHandler
        });
    };
    return InnerReference;
}(_react.Component);
function Reference(props) {
    return _react.createElement((0, _manager.ManagerReferenceNodeSetterContext).Consumer, null, function(setReferenceNode) {
        return _react.createElement(InnerReference, (0, _extendsDefault.default)({
            setReferenceNode: setReferenceNode
        }, props));
    });
}

},{"@babel/runtime/helpers/extends":"ktcBy","@babel/runtime/helpers/inheritsLoose":"kUsrV","@babel/runtime/helpers/assertThisInitialized":"f0luE","@babel/runtime/helpers/defineProperty":"hjdoh","react":"9njXz","warning":"4kUCc","./Manager":"hfvQw","./utils":"1Yvps","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kwxNe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatDuration", ()=>formatDuration);
parcelHelpers.export(exports, "getValue", ()=>getValue);
parcelHelpers.export(exports, "getYear", ()=>getYear);
parcelHelpers.export(exports, "isEqual", ()=>isEqual);
parcelHelpers.export(exports, "isAfter", ()=>isAfter);
parcelHelpers.export(exports, "isBefore", ()=>isBefore);
parcelHelpers.export(exports, "isSameOrAfter", ()=>isSameOrAfter);
parcelHelpers.export(exports, "isSameOrBefore", ()=>isSameOrBefore);
parcelHelpers.export(exports, "isWithinInterval", ()=>isWithinInterval);
parcelHelpers.export(exports, "remainingSeconds", ()=>remainingSeconds);
parcelHelpers.export(exports, "secondsToDate", ()=>secondsToDate);
parcelHelpers.export(exports, "parseDate", ()=>parseDate);
parcelHelpers.export(exports, "subSeconds", ()=>subSeconds);
parcelHelpers.export(exports, "subDays", ()=>subDays);
parcelHelpers.export(exports, "yesterday", ()=>yesterday);
parcelHelpers.export(exports, "format", ()=>(0, _formatDefault.default));
parcelHelpers.export(exports, "parseISO", ()=>(0, _parseISODefault.default));
parcelHelpers.export(exports, "locales", ()=>locales);
parcelHelpers.export(exports, "endOfDay", ()=>(0, _endOfDayDefault.default));
parcelHelpers.export(exports, "isDate", ()=>(0, _isDateDefault.default));
parcelHelpers.export(exports, "formatISO", ()=>(0, _formatISODefault.default));
var _locale = require("date-fns/locale");
var _isDate = require("date-fns/isDate");
var _isDateDefault = parcelHelpers.interopDefault(_isDate);
var _toDate = require("date-fns/toDate");
var _toDateDefault = parcelHelpers.interopDefault(_toDate);
var _intervalToDuration = require("date-fns/intervalToDuration");
var _intervalToDurationDefault = parcelHelpers.interopDefault(_intervalToDuration);
var _format = require("date-fns/format");
var _formatDefault = parcelHelpers.interopDefault(_format);
var _isEqual = require("date-fns/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _isAfter = require("date-fns/isAfter");
var _isAfterDefault = parcelHelpers.interopDefault(_isAfter);
var _isBefore = require("date-fns/isBefore");
var _isBeforeDefault = parcelHelpers.interopDefault(_isBefore);
var _parseISO = require("date-fns/parseISO");
var _parseISODefault = parcelHelpers.interopDefault(_parseISO);
var _formatDuration = require("date-fns/formatDuration");
var _formatDurationDefault = parcelHelpers.interopDefault(_formatDuration);
var _isWithinInterval = require("date-fns/isWithinInterval");
var _isWithinIntervalDefault = parcelHelpers.interopDefault(_isWithinInterval);
var _add = require("date-fns/add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _differenceInSeconds = require("date-fns/differenceInSeconds");
var _differenceInSecondsDefault = parcelHelpers.interopDefault(_differenceInSeconds);
var _endOfDay = require("date-fns/endOfDay");
var _endOfDayDefault = parcelHelpers.interopDefault(_endOfDay);
var _ = require("date-fns/getUnixTime/");
var _Default = parcelHelpers.interopDefault(_);
var _getYear = require("date-fns/getYear");
var _getYearDefault = parcelHelpers.interopDefault(_getYear);
var _subSeconds = require("date-fns/subSeconds");
var _subSecondsDefault = parcelHelpers.interopDefault(_subSeconds);
var _subDays = require("date-fns/subDays");
var _subDaysDefault = parcelHelpers.interopDefault(_subDays);
var _formatISO = require("date-fns/formatISO");
var _formatISODefault = parcelHelpers.interopDefault(_formatISO);
const locales = {
    en: (0, _locale.enUS),
    es: (0, _locale.es)
};
function formatDate(value, dateFormat, language) {
    const locale = locales[language];
    return (0, _formatDefault.default)(parseDate(value), dateFormat, {
        locale
    });
}
function formatDuration(seconds, language) {
    const duration = (0, _intervalToDurationDefault.default)({
        start: (0, _toDateDefault.default)(0),
        end: (0, _toDateDefault.default)(seconds * 1000)
    });
    const locale = locales[language];
    return (0, _formatDurationDefault.default)(duration, {
        locale
    });
}
function getValue(date) {
    return (0, _Default.default)(parseDate(date));
}
function getYear(date) {
    return (0, _getYearDefault.default)(parseDate(date));
}
function isEqual(date, dateToCompare) {
    return (0, _isEqualDefault.default)(parseDate(date), parseDate(dateToCompare));
}
function isAfter(date, dateToCompare) {
    return (0, _isAfterDefault.default)(parseDate(date), parseDate(dateToCompare));
}
function isBefore(date, dateToCompare) {
    return (0, _isBeforeDefault.default)(parseDate(date), parseDate(dateToCompare));
}
function isSameOrAfter(date, dateToCompare) {
    return isAfter(date, dateToCompare) || isEqual(date, dateToCompare);
}
function isSameOrBefore(date, dateToCompare) {
    return isBefore(date, dateToCompare) || isEqual(date, dateToCompare);
}
function isWithinInterval(date, { start, end }) {
    return (0, _isWithinIntervalDefault.default)(parseDate(date), {
        start: parseDate(start),
        end: parseDate(end)
    });
}
function remainingSeconds(started, seconds) {
    const duration = (0, _intervalToDurationDefault.default)({
        start: (0, _toDateDefault.default)(0),
        end: (0, _toDateDefault.default)(seconds * 1000)
    });
    return (0, _differenceInSecondsDefault.default)((0, _addDefault.default)(parseDate(started), duration), new Date());
}
function secondsToDate(target) {
    return (0, _differenceInSecondsDefault.default)(parseDate(target), new Date());
}
function parseDate(value) {
    if ((0, _isDateDefault.default)(value)) return value;
    switch(typeof value){
        case 'number':
            return (0, _toDateDefault.default)(value);
        case 'string':
            return (0, _parseISODefault.default)(value);
        default:
            return false;
    }
}
function subSeconds(value, amount) {
    return (0, _subSecondsDefault.default)(parseDate(value), amount);
}
function subDays(value, amount) {
    return (0, _subDaysDefault.default)(parseDate(value), amount);
}
function yesterday() {
    return subDays(new Date(), 1);
}

},{"date-fns/locale":"dElgW","date-fns/isDate":"gmfSU","date-fns/toDate":"9koxn","date-fns/intervalToDuration":"gGOFv","date-fns/format":"520Dk","date-fns/isEqual":"53fX5","date-fns/isAfter":"1N23w","date-fns/isBefore":"joMzA","date-fns/parseISO":"7FPd2","date-fns/formatDuration":"bHrs0","date-fns/isWithinInterval":"6Kjfz","date-fns/add":"iU8Sh","date-fns/differenceInSeconds":"16fnU","date-fns/endOfDay":false,"date-fns/getUnixTime/":"8mNns","date-fns/getYear":"cD64I","date-fns/subSeconds":"aEu9l","date-fns/subDays":"0Vpj8","date-fns/formatISO":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dElgW":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "af", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "ar", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "arDZ", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "arEG", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "arMA", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "arSA", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "arTN", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "az", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "be", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "beTarask", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "bg", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "bn", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "bs", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "ca", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "cs", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "cy", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "da", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "de", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "deAT", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "el", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "enAU", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "enCA", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "enGB", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "enIE", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "enIN", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "enNZ", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "enUS", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "enZA", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "eo", ()=>(0, _indexJsDefault28.default));
parcelHelpers.export(exports, "es", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "et", ()=>(0, _indexJsDefault30.default));
parcelHelpers.export(exports, "eu", ()=>(0, _indexJsDefault31.default));
parcelHelpers.export(exports, "faIR", ()=>(0, _indexJsDefault32.default));
parcelHelpers.export(exports, "fi", ()=>(0, _indexJsDefault33.default));
parcelHelpers.export(exports, "fr", ()=>(0, _indexJsDefault34.default));
parcelHelpers.export(exports, "frCA", ()=>(0, _indexJsDefault35.default));
parcelHelpers.export(exports, "frCH", ()=>(0, _indexJsDefault36.default));
parcelHelpers.export(exports, "fy", ()=>(0, _indexJsDefault37.default));
parcelHelpers.export(exports, "gd", ()=>(0, _indexJsDefault38.default));
parcelHelpers.export(exports, "gl", ()=>(0, _indexJsDefault39.default));
parcelHelpers.export(exports, "gu", ()=>(0, _indexJsDefault40.default));
parcelHelpers.export(exports, "he", ()=>(0, _indexJsDefault41.default));
parcelHelpers.export(exports, "hi", ()=>(0, _indexJsDefault42.default));
parcelHelpers.export(exports, "hr", ()=>(0, _indexJsDefault43.default));
parcelHelpers.export(exports, "ht", ()=>(0, _indexJsDefault44.default));
parcelHelpers.export(exports, "hu", ()=>(0, _indexJsDefault45.default));
parcelHelpers.export(exports, "hy", ()=>(0, _indexJsDefault46.default));
parcelHelpers.export(exports, "id", ()=>(0, _indexJsDefault47.default));
parcelHelpers.export(exports, "is", ()=>(0, _indexJsDefault48.default));
parcelHelpers.export(exports, "it", ()=>(0, _indexJsDefault49.default));
parcelHelpers.export(exports, "itCH", ()=>(0, _indexJsDefault50.default));
parcelHelpers.export(exports, "ja", ()=>(0, _indexJsDefault51.default));
parcelHelpers.export(exports, "jaHira", ()=>(0, _indexJsDefault52.default));
parcelHelpers.export(exports, "ka", ()=>(0, _indexJsDefault53.default));
parcelHelpers.export(exports, "kk", ()=>(0, _indexJsDefault54.default));
parcelHelpers.export(exports, "km", ()=>(0, _indexJsDefault55.default));
parcelHelpers.export(exports, "kn", ()=>(0, _indexJsDefault56.default));
parcelHelpers.export(exports, "ko", ()=>(0, _indexJsDefault57.default));
parcelHelpers.export(exports, "lb", ()=>(0, _indexJsDefault58.default));
parcelHelpers.export(exports, "lt", ()=>(0, _indexJsDefault59.default));
parcelHelpers.export(exports, "lv", ()=>(0, _indexJsDefault60.default));
parcelHelpers.export(exports, "mk", ()=>(0, _indexJsDefault61.default));
parcelHelpers.export(exports, "mn", ()=>(0, _indexJsDefault62.default));
parcelHelpers.export(exports, "ms", ()=>(0, _indexJsDefault63.default));
parcelHelpers.export(exports, "mt", ()=>(0, _indexJsDefault64.default));
parcelHelpers.export(exports, "nb", ()=>(0, _indexJsDefault65.default));
parcelHelpers.export(exports, "nl", ()=>(0, _indexJsDefault66.default));
parcelHelpers.export(exports, "nlBE", ()=>(0, _indexJsDefault67.default));
parcelHelpers.export(exports, "nn", ()=>(0, _indexJsDefault68.default));
parcelHelpers.export(exports, "oc", ()=>(0, _indexJsDefault69.default));
parcelHelpers.export(exports, "pl", ()=>(0, _indexJsDefault70.default));
parcelHelpers.export(exports, "pt", ()=>(0, _indexJsDefault71.default));
parcelHelpers.export(exports, "ptBR", ()=>(0, _indexJsDefault72.default));
parcelHelpers.export(exports, "ro", ()=>(0, _indexJsDefault73.default));
parcelHelpers.export(exports, "ru", ()=>(0, _indexJsDefault74.default));
parcelHelpers.export(exports, "sk", ()=>(0, _indexJsDefault75.default));
parcelHelpers.export(exports, "sl", ()=>(0, _indexJsDefault76.default));
parcelHelpers.export(exports, "sq", ()=>(0, _indexJsDefault77.default));
parcelHelpers.export(exports, "sr", ()=>(0, _indexJsDefault78.default));
parcelHelpers.export(exports, "srLatn", ()=>(0, _indexJsDefault79.default));
parcelHelpers.export(exports, "sv", ()=>(0, _indexJsDefault80.default));
parcelHelpers.export(exports, "ta", ()=>(0, _indexJsDefault81.default));
parcelHelpers.export(exports, "te", ()=>(0, _indexJsDefault82.default));
parcelHelpers.export(exports, "th", ()=>(0, _indexJsDefault83.default));
parcelHelpers.export(exports, "tr", ()=>(0, _indexJsDefault84.default));
parcelHelpers.export(exports, "ug", ()=>(0, _indexJsDefault85.default));
parcelHelpers.export(exports, "uk", ()=>(0, _indexJsDefault86.default));
parcelHelpers.export(exports, "uz", ()=>(0, _indexJsDefault87.default));
parcelHelpers.export(exports, "uzCyrl", ()=>(0, _indexJsDefault88.default));
parcelHelpers.export(exports, "vi", ()=>(0, _indexJsDefault89.default));
parcelHelpers.export(exports, "zhCN", ()=>(0, _indexJsDefault90.default));
parcelHelpers.export(exports, "zhHK", ()=>(0, _indexJsDefault91.default));
parcelHelpers.export(exports, "zhTW", ()=>(0, _indexJsDefault92.default));
var _indexJs = require("./af/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./ar/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./ar-DZ/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./ar-EG/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./ar-MA/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./ar-SA/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./ar-TN/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./az/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./be/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./be-tarask/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./bg/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./bn/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./bs/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./ca/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./cs/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./cy/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./da/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./de/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./de-AT/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./el/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./en-AU/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./en-CA/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./en-GB/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./en-IE/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./en-IN/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./en-NZ/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./en-US/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./en-ZA/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./eo/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./es/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./et/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./eu/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./fa-IR/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./fi/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./fr/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./fr-CA/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./fr-CH/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./fy/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./gd/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./gl/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./gu/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./he/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./hi/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./hr/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./ht/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./hu/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./hy/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./id/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./is/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./it/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./it-CH/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./ja/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./ja-Hira/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./ka/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./kk/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./km/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./kn/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./ko/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./lb/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./lt/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./lv/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./mk/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./mn/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./ms/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./mt/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./nb/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./nl/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./nl-BE/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./nn/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./oc/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./pl/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./pt/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./pt-BR/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./ro/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./ru/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./sk/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./sl/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./sq/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./sr/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./sr-Latn/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./sv/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./ta/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./te/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./th/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./tr/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./ug/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./uk/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./uz/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./uz-Cyrl/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./vi/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./zh-CN/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./zh-HK/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./zh-TW/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);

},{"./af/index.js":"cIjNY","./ar/index.js":"2yk8H","./ar-DZ/index.js":"btBPS","./ar-EG/index.js":"8X1HB","./ar-MA/index.js":"14nLK","./ar-SA/index.js":"glfFa","./ar-TN/index.js":"dLWPQ","./az/index.js":"l9iX3","./be/index.js":"uj0DW","./be-tarask/index.js":"71wnK","./bg/index.js":"cOZjH","./bn/index.js":"cSkVW","./bs/index.js":"dAlw7","./ca/index.js":"hXrDz","./cs/index.js":"6Za3G","./cy/index.js":"96HkC","./da/index.js":"Wae2W","./de/index.js":"ehZzJ","./de-AT/index.js":"c4wJ8","./el/index.js":"klEaZ","./en-AU/index.js":"blhs2","./en-CA/index.js":"kO2gy","./en-GB/index.js":"5FcFP","./en-IE/index.js":"7ZdBv","./en-IN/index.js":"H6lja","./en-NZ/index.js":"lStYJ","./en-US/index.js":"4vfjK","./en-ZA/index.js":"judpw","./eo/index.js":"gLhnW","./es/index.js":"jCVgz","./et/index.js":"899KZ","./eu/index.js":"3BKqi","./fa-IR/index.js":"4FsED","./fi/index.js":"dGMC6","./fr/index.js":"dEe2x","./fr-CA/index.js":"k4r7J","./fr-CH/index.js":"5JnNz","./fy/index.js":"6HEQq","./gd/index.js":"5gutn","./gl/index.js":"aMwzg","./gu/index.js":"f1ngJ","./he/index.js":"37xwP","./hi/index.js":"70r0G","./hr/index.js":"2nDgv","./ht/index.js":"8WCNE","./hu/index.js":"dFFH1","./hy/index.js":"d3FLD","./id/index.js":"d9iVd","./is/index.js":"7wBfn","./it/index.js":"ecW7F","./it-CH/index.js":"bboAp","./ja/index.js":"9Wocf","./ja-Hira/index.js":"8uqib","./ka/index.js":"1RFqe","./kk/index.js":"kbVuS","./km/index.js":"ief84","./kn/index.js":"6Knme","./ko/index.js":"f4lPo","./lb/index.js":"8f9Yz","./lt/index.js":"9UDJn","./lv/index.js":"gkd7T","./mk/index.js":"2Cvw1","./mn/index.js":"13QbE","./ms/index.js":"gca2E","./mt/index.js":"44qfW","./nb/index.js":"aJ75U","./nl/index.js":"HBIPT","./nl-BE/index.js":"ljPLv","./nn/index.js":"4H3VI","./oc/index.js":"bhYtb","./pl/index.js":"7hSVu","./pt/index.js":"8YsAV","./pt-BR/index.js":"cErTo","./ro/index.js":"loZ7k","./ru/index.js":"an5Rd","./sk/index.js":"ayYqD","./sl/index.js":"lEaez","./sq/index.js":"3XCK6","./sr/index.js":"c4a5E","./sr-Latn/index.js":"4qSpB","./sv/index.js":"8S82i","./ta/index.js":"l6qRR","./te/index.js":"gvwZ5","./th/index.js":"81s8f","./tr/index.js":"3zlpo","./ug/index.js":"crzEv","./uk/index.js":"8oawC","./uz/index.js":"2yIqt","./uz-Cyrl/index.js":"5OQW0","./vi/index.js":"2GiK8","./zh-CN/index.js":"5iego","./zh-HK/index.js":"gI19e","./zh-TW/index.js":"8NIxK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIjNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var locale = {
    code: 'af',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"6vydd","./_lib/formatLong/index.js":"8gXfD","./_lib/formatRelative/index.js":"htx4M","./_lib/localize/index.js":"1c3aP","./_lib/match/index.js":"9Qbjt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vydd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: 'minder as {{count}} sekondes'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekondes'
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: 'minder as {{count}} minute'
    },
    xMinutes: {
        one: "'n minuut",
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} ure'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} ure'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dae'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weke'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weke'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maande'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maande'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer as 1 jaar',
        other: 'meer as {{count}} jaar'
    },
    almostXYears: {
        one: 'byna 1 jaar',
        other: 'byna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oor ' + result;
        else return result + ' gelede';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gXfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htx4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1c3aP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'vC',
        'nC'
    ],
    abbreviated: [
        'vC',
        'nC'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ste kwartaal',
        '2de kwartaal',
        '3de kwartaal',
        '4de kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mrt',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januarie',
        'Februarie',
        'Maart',
        'April',
        'Mei',
        'Junie',
        'Julie',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'W',
        'D',
        'V',
        'S'
    ],
    short: [
        'So',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Sa'
    ],
    abbreviated: [
        'Son',
        'Maa',
        'Din',
        'Woe',
        'Don',
        'Vry',
        'Sat'
    ],
    wide: [
        'Sondag',
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrydag',
        'Saterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + 'ste';
        default:
            return number + 'de';
    }
    return number + 'ste';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Qbjt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2yk8H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var locale = {
    code: 'ar',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"2AIJD","./_lib/formatLong/index.js":"9jwxH","./_lib/formatRelative/index.js":"18x2p","./_lib/localize/index.js":"jNJhE","./_lib/match/index.js":"6XpBA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2AIJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9jwxH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"18x2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var formatRelative = function formatRelative(token) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jNJhE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XpBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBPS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var locale = {
    code: 'ar-DZ',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"6NsRW","./_lib/formatLong/index.js":"7n5XH","./_lib/formatRelative/index.js":"c6g5Q","./_lib/localize/index.js":"f4Uu3","./_lib/match/index.js":"6g5lI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6NsRW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7n5XH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6g5Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f4Uu3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6g5lI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8X1HB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var locale = {
    code: 'ar-EG',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ljaCa","./_lib/formatLong/index.js":"gXZHU","./_lib/formatRelative/index.js":"lv46r","./_lib/localize/index.js":"imzkO","./_lib/match/index.js":"b3lRq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljaCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXZHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'dd/MMM/y',
    short: 'd/MM/y'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lv46r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imzkO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b3lRq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)/;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"14nLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var locale = {
    code: 'ar-MA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"bytSg","./_lib/formatLong/index.js":"feJ6d","./_lib/formatRelative/index.js":"1W0vF","./_lib/localize/index.js":"grmLh","./_lib/match/index.js":"heyJX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bytSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"feJ6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1W0vF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grmLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"heyJX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glfFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var locale = {
    code: 'ar-SA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"LZG5G","./_lib/formatLong/index.js":"3NSWp","./_lib/formatRelative/index.js":"2KUah","./_lib/localize/index.js":"aAPMX","./_lib/match/index.js":"iKCSn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LZG5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NSWp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2KUah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAPMX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iKCSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLWPQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var locale = {
    code: 'ar-TN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"0484J","./_lib/formatLong/index.js":"4eJuS","./_lib/formatRelative/index.js":"4DTHi","./_lib/localize/index.js":"i3kQl","./_lib/match/index.js":"k6VAU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0484J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4eJuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4DTHi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: 'P'
};
var formatRelative = function formatRelative(token) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3kQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6VAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l9iX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var locale = {
    code: 'az',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"45fXe","./_lib/formatLong/index.js":"8Vp64","./_lib/formatRelative/index.js":"hoioy","./_lib/localize/index.js":"j2nT3","./_lib/match/index.js":"3QqlZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45fXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: '1 il',
        other: '{{count}} il'
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Vp64":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hoioy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j2nT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "e.\u0259",
        'b.e'
    ],
    abbreviated: [
        "e.\u0259",
        'b.e'
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        'bizim era'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ci kvartal',
        '2ci kvartal',
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        "\u0130",
        "\u0130",
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avq',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avqust',
        'Sentyabr',
        'Oktyabr',
        'Noyabr',
        'Dekabr'
    ]
};
var dayValues = {
    narrow: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    short: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    abbreviated: [
        'Baz',
        'Baz.e',
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        'Bazar',
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if (suffixes[a]) return suffixes[a];
    else if (suffixes[b]) return suffixes[b];
    else if (c !== null) return suffixes[c];
    return '';
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = getSuffix(number);
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QqlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'narrow'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"uj0DW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var locale = {
    code: 'be',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iv3kj","./_lib/formatLong/index.js":"gODRu","./_lib/formatRelative/index.js":"hpMdL","./_lib/localize/index.js":"1V5QN","./_lib/match/index.js":"eNgqU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iv3kj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gODRu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hpMdL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"btU8f","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btU8f":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "addBusinessDays", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "addDays", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "addHours", ()=>(0, _indexJsDefault3.default));
parcelHelpers.export(exports, "addISOWeekYears", ()=>(0, _indexJsDefault4.default));
parcelHelpers.export(exports, "addMilliseconds", ()=>(0, _indexJsDefault5.default));
parcelHelpers.export(exports, "addMinutes", ()=>(0, _indexJsDefault6.default));
parcelHelpers.export(exports, "addMonths", ()=>(0, _indexJsDefault7.default));
parcelHelpers.export(exports, "addQuarters", ()=>(0, _indexJsDefault8.default));
parcelHelpers.export(exports, "addSeconds", ()=>(0, _indexJsDefault9.default));
parcelHelpers.export(exports, "addWeeks", ()=>(0, _indexJsDefault10.default));
parcelHelpers.export(exports, "addYears", ()=>(0, _indexJsDefault11.default));
parcelHelpers.export(exports, "areIntervalsOverlapping", ()=>(0, _indexJsDefault12.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _indexJsDefault13.default));
parcelHelpers.export(exports, "closestIndexTo", ()=>(0, _indexJsDefault14.default));
parcelHelpers.export(exports, "closestTo", ()=>(0, _indexJsDefault15.default));
parcelHelpers.export(exports, "compareAsc", ()=>(0, _indexJsDefault16.default));
parcelHelpers.export(exports, "compareDesc", ()=>(0, _indexJsDefault17.default));
parcelHelpers.export(exports, "daysToWeeks", ()=>(0, _indexJsDefault18.default));
parcelHelpers.export(exports, "differenceInBusinessDays", ()=>(0, _indexJsDefault19.default));
parcelHelpers.export(exports, "differenceInCalendarDays", ()=>(0, _indexJsDefault20.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", ()=>(0, _indexJsDefault21.default));
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", ()=>(0, _indexJsDefault22.default));
parcelHelpers.export(exports, "differenceInCalendarMonths", ()=>(0, _indexJsDefault23.default));
parcelHelpers.export(exports, "differenceInCalendarQuarters", ()=>(0, _indexJsDefault24.default));
parcelHelpers.export(exports, "differenceInCalendarWeeks", ()=>(0, _indexJsDefault25.default));
parcelHelpers.export(exports, "differenceInCalendarYears", ()=>(0, _indexJsDefault26.default));
parcelHelpers.export(exports, "differenceInDays", ()=>(0, _indexJsDefault27.default));
parcelHelpers.export(exports, "differenceInHours", ()=>(0, _indexJsDefault28.default));
parcelHelpers.export(exports, "differenceInISOWeekYears", ()=>(0, _indexJsDefault29.default));
parcelHelpers.export(exports, "differenceInMilliseconds", ()=>(0, _indexJsDefault30.default));
parcelHelpers.export(exports, "differenceInMinutes", ()=>(0, _indexJsDefault31.default));
parcelHelpers.export(exports, "differenceInMonths", ()=>(0, _indexJsDefault32.default));
parcelHelpers.export(exports, "differenceInQuarters", ()=>(0, _indexJsDefault33.default));
parcelHelpers.export(exports, "differenceInSeconds", ()=>(0, _indexJsDefault34.default));
parcelHelpers.export(exports, "differenceInWeeks", ()=>(0, _indexJsDefault35.default));
parcelHelpers.export(exports, "differenceInYears", ()=>(0, _indexJsDefault36.default));
parcelHelpers.export(exports, "eachDayOfInterval", ()=>(0, _indexJsDefault37.default));
parcelHelpers.export(exports, "eachHourOfInterval", ()=>(0, _indexJsDefault38.default));
parcelHelpers.export(exports, "eachMinuteOfInterval", ()=>(0, _indexJsDefault39.default));
parcelHelpers.export(exports, "eachMonthOfInterval", ()=>(0, _indexJsDefault40.default));
parcelHelpers.export(exports, "eachQuarterOfInterval", ()=>(0, _indexJsDefault41.default));
parcelHelpers.export(exports, "eachWeekOfInterval", ()=>(0, _indexJsDefault42.default));
parcelHelpers.export(exports, "eachWeekendOfInterval", ()=>(0, _indexJsDefault43.default));
parcelHelpers.export(exports, "eachWeekendOfMonth", ()=>(0, _indexJsDefault44.default));
parcelHelpers.export(exports, "eachWeekendOfYear", ()=>(0, _indexJsDefault45.default));
parcelHelpers.export(exports, "eachYearOfInterval", ()=>(0, _indexJsDefault46.default));
parcelHelpers.export(exports, "endOfDay", ()=>(0, _indexJsDefault47.default));
parcelHelpers.export(exports, "endOfDecade", ()=>(0, _indexJsDefault48.default));
parcelHelpers.export(exports, "endOfHour", ()=>(0, _indexJsDefault49.default));
parcelHelpers.export(exports, "endOfISOWeek", ()=>(0, _indexJsDefault50.default));
parcelHelpers.export(exports, "endOfISOWeekYear", ()=>(0, _indexJsDefault51.default));
parcelHelpers.export(exports, "endOfMinute", ()=>(0, _indexJsDefault52.default));
parcelHelpers.export(exports, "endOfMonth", ()=>(0, _indexJsDefault53.default));
parcelHelpers.export(exports, "endOfQuarter", ()=>(0, _indexJsDefault54.default));
parcelHelpers.export(exports, "endOfSecond", ()=>(0, _indexJsDefault55.default));
parcelHelpers.export(exports, "endOfToday", ()=>(0, _indexJsDefault56.default));
parcelHelpers.export(exports, "endOfTomorrow", ()=>(0, _indexJsDefault57.default));
parcelHelpers.export(exports, "endOfWeek", ()=>(0, _indexJsDefault58.default));
parcelHelpers.export(exports, "endOfYear", ()=>(0, _indexJsDefault59.default));
parcelHelpers.export(exports, "endOfYesterday", ()=>(0, _indexJsDefault60.default));
parcelHelpers.export(exports, "format", ()=>(0, _indexJsDefault61.default));
parcelHelpers.export(exports, "formatDistance", ()=>(0, _indexJsDefault62.default));
parcelHelpers.export(exports, "formatDistanceStrict", ()=>(0, _indexJsDefault63.default));
parcelHelpers.export(exports, "formatDistanceToNow", ()=>(0, _indexJsDefault64.default));
parcelHelpers.export(exports, "formatDistanceToNowStrict", ()=>(0, _indexJsDefault65.default));
parcelHelpers.export(exports, "formatDuration", ()=>(0, _indexJsDefault66.default));
parcelHelpers.export(exports, "formatISO", ()=>(0, _indexJsDefault67.default));
parcelHelpers.export(exports, "formatISO9075", ()=>(0, _indexJsDefault68.default));
parcelHelpers.export(exports, "formatISODuration", ()=>(0, _indexJsDefault69.default));
parcelHelpers.export(exports, "formatRFC3339", ()=>(0, _indexJsDefault70.default));
parcelHelpers.export(exports, "formatRFC7231", ()=>(0, _indexJsDefault71.default));
parcelHelpers.export(exports, "formatRelative", ()=>(0, _indexJsDefault72.default));
parcelHelpers.export(exports, "fromUnixTime", ()=>(0, _indexJsDefault73.default));
parcelHelpers.export(exports, "getDate", ()=>(0, _indexJsDefault74.default));
parcelHelpers.export(exports, "getDay", ()=>(0, _indexJsDefault75.default));
parcelHelpers.export(exports, "getDayOfYear", ()=>(0, _indexJsDefault76.default));
parcelHelpers.export(exports, "getDaysInMonth", ()=>(0, _indexJsDefault77.default));
parcelHelpers.export(exports, "getDaysInYear", ()=>(0, _indexJsDefault78.default));
parcelHelpers.export(exports, "getDecade", ()=>(0, _indexJsDefault79.default));
parcelHelpers.export(exports, "getDefaultOptions", ()=>(0, _indexJsDefault80.default));
parcelHelpers.export(exports, "getHours", ()=>(0, _indexJsDefault81.default));
parcelHelpers.export(exports, "getISODay", ()=>(0, _indexJsDefault82.default));
parcelHelpers.export(exports, "getISOWeek", ()=>(0, _indexJsDefault83.default));
parcelHelpers.export(exports, "getISOWeekYear", ()=>(0, _indexJsDefault84.default));
parcelHelpers.export(exports, "getISOWeeksInYear", ()=>(0, _indexJsDefault85.default));
parcelHelpers.export(exports, "getMilliseconds", ()=>(0, _indexJsDefault86.default));
parcelHelpers.export(exports, "getMinutes", ()=>(0, _indexJsDefault87.default));
parcelHelpers.export(exports, "getMonth", ()=>(0, _indexJsDefault88.default));
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", ()=>(0, _indexJsDefault89.default));
parcelHelpers.export(exports, "getQuarter", ()=>(0, _indexJsDefault90.default));
parcelHelpers.export(exports, "getSeconds", ()=>(0, _indexJsDefault91.default));
parcelHelpers.export(exports, "getTime", ()=>(0, _indexJsDefault92.default));
parcelHelpers.export(exports, "getUnixTime", ()=>(0, _indexJsDefault93.default));
parcelHelpers.export(exports, "getWeek", ()=>(0, _indexJsDefault94.default));
parcelHelpers.export(exports, "getWeekOfMonth", ()=>(0, _indexJsDefault95.default));
parcelHelpers.export(exports, "getWeekYear", ()=>(0, _indexJsDefault96.default));
parcelHelpers.export(exports, "getWeeksInMonth", ()=>(0, _indexJsDefault97.default));
parcelHelpers.export(exports, "getYear", ()=>(0, _indexJsDefault98.default));
parcelHelpers.export(exports, "hoursToMilliseconds", ()=>(0, _indexJsDefault99.default));
parcelHelpers.export(exports, "hoursToMinutes", ()=>(0, _indexJsDefault100.default));
parcelHelpers.export(exports, "hoursToSeconds", ()=>(0, _indexJsDefault101.default));
parcelHelpers.export(exports, "intervalToDuration", ()=>(0, _indexJsDefault102.default));
parcelHelpers.export(exports, "intlFormat", ()=>(0, _indexJsDefault103.default));
parcelHelpers.export(exports, "intlFormatDistance", ()=>(0, _indexJsDefault104.default));
parcelHelpers.export(exports, "isAfter", ()=>(0, _indexJsDefault105.default));
parcelHelpers.export(exports, "isBefore", ()=>(0, _indexJsDefault106.default));
parcelHelpers.export(exports, "isDate", ()=>(0, _indexJsDefault107.default));
parcelHelpers.export(exports, "isEqual", ()=>(0, _indexJsDefault108.default));
parcelHelpers.export(exports, "isExists", ()=>(0, _indexJsDefault109.default));
parcelHelpers.export(exports, "isFirstDayOfMonth", ()=>(0, _indexJsDefault110.default));
parcelHelpers.export(exports, "isFriday", ()=>(0, _indexJsDefault111.default));
parcelHelpers.export(exports, "isFuture", ()=>(0, _indexJsDefault112.default));
parcelHelpers.export(exports, "isLastDayOfMonth", ()=>(0, _indexJsDefault113.default));
parcelHelpers.export(exports, "isLeapYear", ()=>(0, _indexJsDefault114.default));
parcelHelpers.export(exports, "isMatch", ()=>(0, _indexJsDefault115.default));
parcelHelpers.export(exports, "isMonday", ()=>(0, _indexJsDefault116.default));
parcelHelpers.export(exports, "isPast", ()=>(0, _indexJsDefault117.default));
parcelHelpers.export(exports, "isSameDay", ()=>(0, _indexJsDefault118.default));
parcelHelpers.export(exports, "isSameHour", ()=>(0, _indexJsDefault119.default));
parcelHelpers.export(exports, "isSameISOWeek", ()=>(0, _indexJsDefault120.default));
parcelHelpers.export(exports, "isSameISOWeekYear", ()=>(0, _indexJsDefault121.default));
parcelHelpers.export(exports, "isSameMinute", ()=>(0, _indexJsDefault122.default));
parcelHelpers.export(exports, "isSameMonth", ()=>(0, _indexJsDefault123.default));
parcelHelpers.export(exports, "isSameQuarter", ()=>(0, _indexJsDefault124.default));
parcelHelpers.export(exports, "isSameSecond", ()=>(0, _indexJsDefault125.default));
parcelHelpers.export(exports, "isSameWeek", ()=>(0, _indexJsDefault126.default));
parcelHelpers.export(exports, "isSameYear", ()=>(0, _indexJsDefault127.default));
parcelHelpers.export(exports, "isSaturday", ()=>(0, _indexJsDefault128.default));
parcelHelpers.export(exports, "isSunday", ()=>(0, _indexJsDefault129.default));
parcelHelpers.export(exports, "isThisHour", ()=>(0, _indexJsDefault130.default));
parcelHelpers.export(exports, "isThisISOWeek", ()=>(0, _indexJsDefault131.default));
parcelHelpers.export(exports, "isThisMinute", ()=>(0, _indexJsDefault132.default));
parcelHelpers.export(exports, "isThisMonth", ()=>(0, _indexJsDefault133.default));
parcelHelpers.export(exports, "isThisQuarter", ()=>(0, _indexJsDefault134.default));
parcelHelpers.export(exports, "isThisSecond", ()=>(0, _indexJsDefault135.default));
parcelHelpers.export(exports, "isThisWeek", ()=>(0, _indexJsDefault136.default));
parcelHelpers.export(exports, "isThisYear", ()=>(0, _indexJsDefault137.default));
parcelHelpers.export(exports, "isThursday", ()=>(0, _indexJsDefault138.default));
parcelHelpers.export(exports, "isToday", ()=>(0, _indexJsDefault139.default));
parcelHelpers.export(exports, "isTomorrow", ()=>(0, _indexJsDefault140.default));
parcelHelpers.export(exports, "isTuesday", ()=>(0, _indexJsDefault141.default));
parcelHelpers.export(exports, "isValid", ()=>(0, _indexJsDefault142.default));
parcelHelpers.export(exports, "isWednesday", ()=>(0, _indexJsDefault143.default));
parcelHelpers.export(exports, "isWeekend", ()=>(0, _indexJsDefault144.default));
parcelHelpers.export(exports, "isWithinInterval", ()=>(0, _indexJsDefault145.default));
parcelHelpers.export(exports, "isYesterday", ()=>(0, _indexJsDefault146.default));
parcelHelpers.export(exports, "lastDayOfDecade", ()=>(0, _indexJsDefault147.default));
parcelHelpers.export(exports, "lastDayOfISOWeek", ()=>(0, _indexJsDefault148.default));
parcelHelpers.export(exports, "lastDayOfISOWeekYear", ()=>(0, _indexJsDefault149.default));
parcelHelpers.export(exports, "lastDayOfMonth", ()=>(0, _indexJsDefault150.default));
parcelHelpers.export(exports, "lastDayOfQuarter", ()=>(0, _indexJsDefault151.default));
parcelHelpers.export(exports, "lastDayOfWeek", ()=>(0, _indexJsDefault152.default));
parcelHelpers.export(exports, "lastDayOfYear", ()=>(0, _indexJsDefault153.default));
parcelHelpers.export(exports, "lightFormat", ()=>(0, _indexJsDefault154.default));
parcelHelpers.export(exports, "max", ()=>(0, _indexJsDefault155.default));
parcelHelpers.export(exports, "milliseconds", ()=>(0, _indexJsDefault156.default));
parcelHelpers.export(exports, "millisecondsToHours", ()=>(0, _indexJsDefault157.default));
parcelHelpers.export(exports, "millisecondsToMinutes", ()=>(0, _indexJsDefault158.default));
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>(0, _indexJsDefault159.default));
parcelHelpers.export(exports, "min", ()=>(0, _indexJsDefault160.default));
parcelHelpers.export(exports, "minutesToHours", ()=>(0, _indexJsDefault161.default));
parcelHelpers.export(exports, "minutesToMilliseconds", ()=>(0, _indexJsDefault162.default));
parcelHelpers.export(exports, "minutesToSeconds", ()=>(0, _indexJsDefault163.default));
parcelHelpers.export(exports, "monthsToQuarters", ()=>(0, _indexJsDefault164.default));
parcelHelpers.export(exports, "monthsToYears", ()=>(0, _indexJsDefault165.default));
parcelHelpers.export(exports, "nextDay", ()=>(0, _indexJsDefault166.default));
parcelHelpers.export(exports, "nextFriday", ()=>(0, _indexJsDefault167.default));
parcelHelpers.export(exports, "nextMonday", ()=>(0, _indexJsDefault168.default));
parcelHelpers.export(exports, "nextSaturday", ()=>(0, _indexJsDefault169.default));
parcelHelpers.export(exports, "nextSunday", ()=>(0, _indexJsDefault170.default));
parcelHelpers.export(exports, "nextThursday", ()=>(0, _indexJsDefault171.default));
parcelHelpers.export(exports, "nextTuesday", ()=>(0, _indexJsDefault172.default));
parcelHelpers.export(exports, "nextWednesday", ()=>(0, _indexJsDefault173.default));
parcelHelpers.export(exports, "parse", ()=>(0, _indexJsDefault174.default));
parcelHelpers.export(exports, "parseISO", ()=>(0, _indexJsDefault175.default));
parcelHelpers.export(exports, "parseJSON", ()=>(0, _indexJsDefault176.default));
parcelHelpers.export(exports, "previousDay", ()=>(0, _indexJsDefault177.default));
parcelHelpers.export(exports, "previousFriday", ()=>(0, _indexJsDefault178.default));
parcelHelpers.export(exports, "previousMonday", ()=>(0, _indexJsDefault179.default));
parcelHelpers.export(exports, "previousSaturday", ()=>(0, _indexJsDefault180.default));
parcelHelpers.export(exports, "previousSunday", ()=>(0, _indexJsDefault181.default));
parcelHelpers.export(exports, "previousThursday", ()=>(0, _indexJsDefault182.default));
parcelHelpers.export(exports, "previousTuesday", ()=>(0, _indexJsDefault183.default));
parcelHelpers.export(exports, "previousWednesday", ()=>(0, _indexJsDefault184.default));
parcelHelpers.export(exports, "quartersToMonths", ()=>(0, _indexJsDefault185.default));
parcelHelpers.export(exports, "quartersToYears", ()=>(0, _indexJsDefault186.default));
parcelHelpers.export(exports, "roundToNearestMinutes", ()=>(0, _indexJsDefault187.default));
parcelHelpers.export(exports, "secondsToHours", ()=>(0, _indexJsDefault188.default));
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>(0, _indexJsDefault189.default));
parcelHelpers.export(exports, "secondsToMinutes", ()=>(0, _indexJsDefault190.default));
parcelHelpers.export(exports, "set", ()=>(0, _indexJsDefault191.default));
parcelHelpers.export(exports, "setDate", ()=>(0, _indexJsDefault192.default));
parcelHelpers.export(exports, "setDay", ()=>(0, _indexJsDefault193.default));
parcelHelpers.export(exports, "setDayOfYear", ()=>(0, _indexJsDefault194.default));
parcelHelpers.export(exports, "setDefaultOptions", ()=>(0, _indexJsDefault195.default));
parcelHelpers.export(exports, "setHours", ()=>(0, _indexJsDefault196.default));
parcelHelpers.export(exports, "setISODay", ()=>(0, _indexJsDefault197.default));
parcelHelpers.export(exports, "setISOWeek", ()=>(0, _indexJsDefault198.default));
parcelHelpers.export(exports, "setISOWeekYear", ()=>(0, _indexJsDefault199.default));
parcelHelpers.export(exports, "setMilliseconds", ()=>(0, _indexJsDefault200.default));
parcelHelpers.export(exports, "setMinutes", ()=>(0, _indexJsDefault201.default));
parcelHelpers.export(exports, "setMonth", ()=>(0, _indexJsDefault202.default));
parcelHelpers.export(exports, "setQuarter", ()=>(0, _indexJsDefault203.default));
parcelHelpers.export(exports, "setSeconds", ()=>(0, _indexJsDefault204.default));
parcelHelpers.export(exports, "setWeek", ()=>(0, _indexJsDefault205.default));
parcelHelpers.export(exports, "setWeekYear", ()=>(0, _indexJsDefault206.default));
parcelHelpers.export(exports, "setYear", ()=>(0, _indexJsDefault207.default));
parcelHelpers.export(exports, "startOfDay", ()=>(0, _indexJsDefault208.default));
parcelHelpers.export(exports, "startOfDecade", ()=>(0, _indexJsDefault209.default));
parcelHelpers.export(exports, "startOfHour", ()=>(0, _indexJsDefault210.default));
parcelHelpers.export(exports, "startOfISOWeek", ()=>(0, _indexJsDefault211.default));
parcelHelpers.export(exports, "startOfISOWeekYear", ()=>(0, _indexJsDefault212.default));
parcelHelpers.export(exports, "startOfMinute", ()=>(0, _indexJsDefault213.default));
parcelHelpers.export(exports, "startOfMonth", ()=>(0, _indexJsDefault214.default));
parcelHelpers.export(exports, "startOfQuarter", ()=>(0, _indexJsDefault215.default));
parcelHelpers.export(exports, "startOfSecond", ()=>(0, _indexJsDefault216.default));
parcelHelpers.export(exports, "startOfToday", ()=>(0, _indexJsDefault217.default));
parcelHelpers.export(exports, "startOfTomorrow", ()=>(0, _indexJsDefault218.default));
parcelHelpers.export(exports, "startOfWeek", ()=>(0, _indexJsDefault219.default));
parcelHelpers.export(exports, "startOfWeekYear", ()=>(0, _indexJsDefault220.default));
parcelHelpers.export(exports, "startOfYear", ()=>(0, _indexJsDefault221.default));
parcelHelpers.export(exports, "startOfYesterday", ()=>(0, _indexJsDefault222.default));
parcelHelpers.export(exports, "sub", ()=>(0, _indexJsDefault223.default));
parcelHelpers.export(exports, "subBusinessDays", ()=>(0, _indexJsDefault224.default));
parcelHelpers.export(exports, "subDays", ()=>(0, _indexJsDefault225.default));
parcelHelpers.export(exports, "subHours", ()=>(0, _indexJsDefault226.default));
parcelHelpers.export(exports, "subISOWeekYears", ()=>(0, _indexJsDefault227.default));
parcelHelpers.export(exports, "subMilliseconds", ()=>(0, _indexJsDefault228.default));
parcelHelpers.export(exports, "subMinutes", ()=>(0, _indexJsDefault229.default));
parcelHelpers.export(exports, "subMonths", ()=>(0, _indexJsDefault230.default));
parcelHelpers.export(exports, "subQuarters", ()=>(0, _indexJsDefault231.default));
parcelHelpers.export(exports, "subSeconds", ()=>(0, _indexJsDefault232.default));
parcelHelpers.export(exports, "subWeeks", ()=>(0, _indexJsDefault233.default));
parcelHelpers.export(exports, "subYears", ()=>(0, _indexJsDefault234.default));
parcelHelpers.export(exports, "toDate", ()=>(0, _indexJsDefault235.default));
parcelHelpers.export(exports, "weeksToDays", ()=>(0, _indexJsDefault236.default));
parcelHelpers.export(exports, "yearsToMonths", ()=>(0, _indexJsDefault237.default));
parcelHelpers.export(exports, "yearsToQuarters", ()=>(0, _indexJsDefault238.default));
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./clamp/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./closestIndexTo/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./compareAsc/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareDesc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./daysToWeeks/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInDays/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInHours/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInMinutes/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInMonths/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInQuarters/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInSeconds/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInWeeks/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInYears/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./eachDayOfInterval/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./eachHourOfInterval/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachYearOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./endOfDay/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./endOfDecade/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./endOfHour/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./endOfISOWeek/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./endOfMinute/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./endOfMonth/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./endOfQuarter/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./endOfSecond/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./endOfToday/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./endOfTomorrow/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfWeek/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfYear/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfYesterday/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./format/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./formatDistance/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./formatDistanceStrict/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./formatDistanceToNow/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./formatDistanceToNowStrict/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./formatDuration/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./formatISO/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./formatISO9075/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./formatISODuration/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./formatRFC3339/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./formatRFC7231/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatRelative/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./fromUnixTime/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./getDate/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./getDay/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./getDayOfYear/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./getDaysInMonth/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./getDaysInYear/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./getDecade/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./getDefaultOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./getHours/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./getISODay/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./getISOWeek/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./getISOWeekYear/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./getMilliseconds/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./getMinutes/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./getMonth/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getQuarter/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getSeconds/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getTime/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getUnixTime/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getWeek/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getWeekOfMonth/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getWeekYear/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getWeeksInMonth/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getYear/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./hoursToMinutes/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./hoursToSeconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./intervalToDuration/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./intlFormat/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./intlFormatDistance/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./isAfter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./isBefore/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./isDate/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./isEqual/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./isExists/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./isFriday/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./isFuture/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./isLeapYear/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./isMatch/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./isMonday/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./isPast/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./isSameDay/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./isSameHour/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./isSameISOWeek/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./isSameMinute/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./isSameMonth/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./isSameQuarter/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isSameSecond/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isSameWeek/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isSameYear/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isSaturday/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isSunday/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isThisHour/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isThisISOWeek/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isThisMinute/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isThisMonth/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isThisQuarter/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isThisSecond/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isThisWeek/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isThisYear/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isThursday/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isToday/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isTomorrow/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isTuesday/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isValid/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isWednesday/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isWeekend/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isWithinInterval/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isYesterday/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./lastDayOfDecade/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./lastDayOfMonth/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./lastDayOfWeek/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./lastDayOfYear/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./lightFormat/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./max/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./milliseconds/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./millisecondsToHours/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./min/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./minutesToHours/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./minutesToSeconds/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./monthsToQuarters/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./monthsToYears/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./nextDay/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./nextFriday/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./nextMonday/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./nextSaturday/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./nextSunday/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./nextThursday/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./nextTuesday/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./nextWednesday/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./parse/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./parseISO/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./parseJSON/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./previousDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./previousFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./previousMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./previousSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./previousSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./previousThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./previousTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./previousWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./quartersToMonths/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./quartersToYears/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./secondsToHours/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./secondsToMinutes/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./set/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./setDate/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./setDay/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./setDayOfYear/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./setDefaultOptions/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./setHours/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./setISODay/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./setISOWeek/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./setISOWeekYear/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./setMilliseconds/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./setMinutes/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./setMonth/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./setQuarter/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./setSeconds/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./setWeek/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setWeekYear/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setYear/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./startOfDay/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./startOfDecade/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./startOfHour/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./startOfISOWeek/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./startOfMinute/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./startOfMonth/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./startOfQuarter/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./startOfSecond/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./startOfToday/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./startOfTomorrow/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./startOfWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./startOfWeekYear/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./startOfYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./startOfYesterday/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./sub/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./subBusinessDays/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./subDays/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./subHours/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./subISOWeekYears/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./subMilliseconds/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./subMinutes/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./subMonths/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./subQuarters/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./subSeconds/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./subWeeks/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./subYears/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./toDate/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./weeksToDays/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./yearsToMonths/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./yearsToQuarters/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs239, exports);

},{"./add/index.js":false,"./addBusinessDays/index.js":false,"./addDays/index.js":false,"./addHours/index.js":false,"./addISOWeekYears/index.js":false,"./addMilliseconds/index.js":false,"./addMinutes/index.js":false,"./addMonths/index.js":false,"./addQuarters/index.js":false,"./addSeconds/index.js":false,"./addWeeks/index.js":false,"./addYears/index.js":false,"./areIntervalsOverlapping/index.js":false,"./clamp/index.js":false,"./closestIndexTo/index.js":false,"./closestTo/index.js":false,"./compareAsc/index.js":false,"./compareDesc/index.js":false,"./daysToWeeks/index.js":false,"./differenceInBusinessDays/index.js":false,"./differenceInCalendarDays/index.js":false,"./differenceInCalendarISOWeekYears/index.js":false,"./differenceInCalendarISOWeeks/index.js":false,"./differenceInCalendarMonths/index.js":false,"./differenceInCalendarQuarters/index.js":false,"./differenceInCalendarWeeks/index.js":false,"./differenceInCalendarYears/index.js":false,"./differenceInDays/index.js":false,"./differenceInHours/index.js":false,"./differenceInISOWeekYears/index.js":false,"./differenceInMilliseconds/index.js":false,"./differenceInMinutes/index.js":false,"./differenceInMonths/index.js":false,"./differenceInQuarters/index.js":false,"./differenceInSeconds/index.js":false,"./differenceInWeeks/index.js":false,"./differenceInYears/index.js":false,"./eachDayOfInterval/index.js":false,"./eachHourOfInterval/index.js":false,"./eachMinuteOfInterval/index.js":false,"./eachMonthOfInterval/index.js":false,"./eachQuarterOfInterval/index.js":false,"./eachWeekOfInterval/index.js":false,"./eachWeekendOfInterval/index.js":false,"./eachWeekendOfMonth/index.js":false,"./eachWeekendOfYear/index.js":false,"./eachYearOfInterval/index.js":false,"./endOfDay/index.js":false,"./endOfDecade/index.js":false,"./endOfHour/index.js":false,"./endOfISOWeek/index.js":false,"./endOfISOWeekYear/index.js":false,"./endOfMinute/index.js":false,"./endOfMonth/index.js":false,"./endOfQuarter/index.js":false,"./endOfSecond/index.js":false,"./endOfToday/index.js":false,"./endOfTomorrow/index.js":false,"./endOfWeek/index.js":false,"./endOfYear/index.js":false,"./endOfYesterday/index.js":false,"./format/index.js":"520Dk","./formatDistance/index.js":false,"./formatDistanceStrict/index.js":false,"./formatDistanceToNow/index.js":false,"./formatDistanceToNowStrict/index.js":false,"./formatDuration/index.js":false,"./formatISO/index.js":"an1FA","./formatISO9075/index.js":false,"./formatISODuration/index.js":false,"./formatRFC3339/index.js":false,"./formatRFC7231/index.js":false,"./formatRelative/index.js":false,"./fromUnixTime/index.js":false,"./getDate/index.js":false,"./getDay/index.js":false,"./getDayOfYear/index.js":false,"./getDaysInMonth/index.js":false,"./getDaysInYear/index.js":false,"./getDecade/index.js":false,"./getDefaultOptions/index.js":false,"./getHours/index.js":false,"./getISODay/index.js":false,"./getISOWeek/index.js":false,"./getISOWeekYear/index.js":false,"./getISOWeeksInYear/index.js":false,"./getMilliseconds/index.js":false,"./getMinutes/index.js":false,"./getMonth/index.js":false,"./getOverlappingDaysInIntervals/index.js":false,"./getQuarter/index.js":false,"./getSeconds/index.js":false,"./getTime/index.js":false,"./getUnixTime/index.js":false,"./getWeek/index.js":false,"./getWeekOfMonth/index.js":false,"./getWeekYear/index.js":false,"./getWeeksInMonth/index.js":false,"./getYear/index.js":false,"./hoursToMilliseconds/index.js":false,"./hoursToMinutes/index.js":false,"./hoursToSeconds/index.js":false,"./intervalToDuration/index.js":false,"./intlFormat/index.js":false,"./intlFormatDistance/index.js":false,"./isAfter/index.js":false,"./isBefore/index.js":false,"./isDate/index.js":false,"./isEqual/index.js":false,"./isExists/index.js":false,"./isFirstDayOfMonth/index.js":false,"./isFriday/index.js":false,"./isFuture/index.js":false,"./isLastDayOfMonth/index.js":false,"./isLeapYear/index.js":false,"./isMatch/index.js":false,"./isMonday/index.js":false,"./isPast/index.js":false,"./isSameDay/index.js":false,"./isSameHour/index.js":false,"./isSameISOWeek/index.js":false,"./isSameISOWeekYear/index.js":false,"./isSameMinute/index.js":false,"./isSameMonth/index.js":false,"./isSameQuarter/index.js":false,"./isSameSecond/index.js":false,"./isSameWeek/index.js":false,"./isSameYear/index.js":false,"./isSaturday/index.js":false,"./isSunday/index.js":false,"./isThisHour/index.js":false,"./isThisISOWeek/index.js":false,"./isThisMinute/index.js":false,"./isThisMonth/index.js":false,"./isThisQuarter/index.js":false,"./isThisSecond/index.js":false,"./isThisWeek/index.js":false,"./isThisYear/index.js":false,"./isThursday/index.js":false,"./isToday/index.js":false,"./isTomorrow/index.js":false,"./isTuesday/index.js":false,"./isValid/index.js":false,"./isWednesday/index.js":false,"./isWeekend/index.js":false,"./isWithinInterval/index.js":false,"./isYesterday/index.js":false,"./lastDayOfDecade/index.js":false,"./lastDayOfISOWeek/index.js":false,"./lastDayOfISOWeekYear/index.js":false,"./lastDayOfMonth/index.js":false,"./lastDayOfQuarter/index.js":false,"./lastDayOfWeek/index.js":false,"./lastDayOfYear/index.js":false,"./lightFormat/index.js":false,"./max/index.js":false,"./milliseconds/index.js":false,"./millisecondsToHours/index.js":false,"./millisecondsToMinutes/index.js":false,"./millisecondsToSeconds/index.js":false,"./min/index.js":false,"./minutesToHours/index.js":false,"./minutesToMilliseconds/index.js":false,"./minutesToSeconds/index.js":false,"./monthsToQuarters/index.js":false,"./monthsToYears/index.js":false,"./nextDay/index.js":false,"./nextFriday/index.js":false,"./nextMonday/index.js":false,"./nextSaturday/index.js":false,"./nextSunday/index.js":false,"./nextThursday/index.js":false,"./nextTuesday/index.js":false,"./nextWednesday/index.js":false,"./parse/index.js":false,"./parseISO/index.js":false,"./parseJSON/index.js":false,"./previousDay/index.js":false,"./previousFriday/index.js":false,"./previousMonday/index.js":false,"./previousSaturday/index.js":false,"./previousSunday/index.js":false,"./previousThursday/index.js":false,"./previousTuesday/index.js":false,"./previousWednesday/index.js":false,"./quartersToMonths/index.js":false,"./quartersToYears/index.js":false,"./roundToNearestMinutes/index.js":false,"./secondsToHours/index.js":false,"./secondsToMilliseconds/index.js":false,"./secondsToMinutes/index.js":false,"./set/index.js":false,"./setDate/index.js":false,"./setDay/index.js":false,"./setDayOfYear/index.js":false,"./setDefaultOptions/index.js":false,"./setHours/index.js":false,"./setISODay/index.js":false,"./setISOWeek/index.js":false,"./setISOWeekYear/index.js":false,"./setMilliseconds/index.js":false,"./setMinutes/index.js":false,"./setMonth/index.js":false,"./setQuarter/index.js":false,"./setSeconds/index.js":false,"./setWeek/index.js":false,"./setWeekYear/index.js":false,"./setYear/index.js":false,"./startOfDay/index.js":false,"./startOfDecade/index.js":false,"./startOfHour/index.js":false,"./startOfISOWeek/index.js":false,"./startOfISOWeekYear/index.js":false,"./startOfMinute/index.js":false,"./startOfMonth/index.js":false,"./startOfQuarter/index.js":false,"./startOfSecond/index.js":false,"./startOfToday/index.js":false,"./startOfTomorrow/index.js":false,"./startOfWeek/index.js":false,"./startOfWeekYear/index.js":false,"./startOfYear/index.js":false,"./startOfYesterday/index.js":false,"./sub/index.js":false,"./subBusinessDays/index.js":false,"./subDays/index.js":false,"./subHours/index.js":false,"./subISOWeekYears/index.js":false,"./subMilliseconds/index.js":false,"./subMinutes/index.js":false,"./subMonths/index.js":false,"./subQuarters/index.js":false,"./subSeconds/index.js":false,"./subWeeks/index.js":false,"./subYears/index.js":false,"./toDate/index.js":"9koxn","./weeksToDays/index.js":false,"./yearsToMonths/index.js":false,"./yearsToQuarters/index.js":false,"./constants/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iU8Sh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>add);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/toInteger/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function add(dirtyDate, duration) {
    (0, _indexJsDefault3.default)(2, arguments);
    if (!duration || (0, _typeofDefault.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, _indexJsDefault4.default)(duration.years) : 0;
    var months = duration.months ? (0, _indexJsDefault4.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, _indexJsDefault4.default)(duration.weeks) : 0;
    var days = duration.days ? (0, _indexJsDefault4.default)(duration.days) : 0;
    var hours = duration.hours ? (0, _indexJsDefault4.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, _indexJsDefault4.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, _indexJsDefault4.default)(duration.seconds) : 0;
    // Add years and months
    var date = (0, _indexJsDefault2.default)(dirtyDate);
    var dateWithMonths = months || years ? (0, _indexJsDefault1.default)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, _indexJsDefault.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}

},{"@babel/runtime/helpers/esm/typeof":"la19k","../addDays/index.js":"fK40q","../addMonths/index.js":"luR8G","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","../_lib/toInteger/index.js":"gKtzz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fr9dc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addSeconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addSeconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 1000);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addMilliseconds/index.js":"2ueVg","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EgNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compareAsc);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function compareAsc(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ayGLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInDays);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js"); // Like `compareAsc` but uses local time not UTC, which is needed
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"9koxn","../differenceInCalendarDays/index.js":"9Dyug","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Me0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInHours);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/roundingMethods/index.js");
function differenceInHours(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / (0, _indexJs.millisecondsInHour);
    return (0, _indexJs3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../constants/index.js":"49NaD","../differenceInMilliseconds/index.js":"iHFMa","../_lib/requiredArgs/index.js":"9bkfg","../_lib/roundingMethods/index.js":"4ejGu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHFMa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMilliseconds);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInMilliseconds(dateLeft, dateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    return (0, _indexJsDefault.default)(dateLeft).getTime() - (0, _indexJsDefault.default)(dateRight).getTime();
}

},{"../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ejGu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", ()=>getRoundingMethod);
var roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
    return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k2Rse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMinutes);
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/roundingMethods/index.js");
function differenceInMinutes(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / (0, _indexJs.millisecondsInMinute);
    return (0, _indexJs3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../constants/index.js":"49NaD","../differenceInMilliseconds/index.js":"iHFMa","../_lib/requiredArgs/index.js":"9bkfg","../_lib/roundingMethods/index.js":"4ejGu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hS4KR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInMonths);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../isLastDayOfMonth/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _indexJsDefault4.default)((0, _indexJsDefault.default)(dirtyDateLeft)) && difference === 1 && (0, _indexJsDefault2.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"9koxn","../differenceInCalendarMonths/index.js":"iE73E","../compareAsc/index.js":"6EgNY","../_lib/requiredArgs/index.js":"9bkfg","../isLastDayOfMonth/index.js":"k8eg9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8eg9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLastDayOfMonth);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../endOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../endOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function isLastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    return (0, _indexJsDefault1.default)(date).getTime() === (0, _indexJsDefault2.default)(date).getTime();
}

},{"../toDate/index.js":"9koxn","../endOfDay/index.js":"hBRHp","../endOfMonth/index.js":"9a5Tk","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16fnU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInSeconds);
var _indexJs = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInSeconds(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 1000;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInMilliseconds/index.js":"iHFMa","../_lib/requiredArgs/index.js":"9bkfg","../_lib/roundingMethods/index.js":"4ejGu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8baro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>differenceInYears);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"9koxn","../differenceInCalendarYears/index.js":"3B4AF","../compareAsc/index.js":"6EgNY","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bHrs0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatDuration);
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var defaultFormat = [
    'years',
    'months',
    'weeks',
    'days',
    'hours',
    'minutes',
    'seconds'
];
function formatDuration(duration, options) {
    var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
    if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
    var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
    var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : ' ';
    if (!locale.formatDistance) return '';
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (typeof value === 'number' && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

},{"../_lib/defaultOptions/index.js":"1cViP","../_lib/defaultLocale/index.js":"5kaPu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"an1FA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatISO);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatISO(date, options) {
    var _options$format, _options$representati;
    (0, _indexJsDefault2.default)(1, arguments);
    var originalDate = (0, _indexJsDefault.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, _indexJsDefault1.default)(originalDate.getDate(), 2);
        var month = (0, _indexJsDefault1.default)(originalDate.getMonth() + 1, 2);
        var year = (0, _indexJsDefault1.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, _indexJsDefault1.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, _indexJsDefault1.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, _indexJsDefault1.default)(originalDate.getHours(), 2);
        var minute = (0, _indexJsDefault1.default)(originalDate.getMinutes(), 2);
        var second = (0, _indexJsDefault1.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

},{"../toDate/index.js":"9koxn","../_lib/addLeadingZeros/index.js":"9Bsa8","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8mNns":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUnixTime);
var _indexJs = require("../getTime/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getUnixTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return Math.floor((0, _indexJsDefault.default)(dirtyDate) / 1000);
}

},{"../getTime/index.js":"3O7In","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gGOFv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>intervalToDuration);
var _indexJs = require("../compareAsc/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../add/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../differenceInDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../differenceInHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../differenceInMinutes/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../differenceInMonths/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../differenceInSeconds/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../differenceInYears/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../toDate/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
function intervalToDuration(interval) {
    (0, _indexJsDefault9.default)(1, arguments);
    var start = (0, _indexJsDefault8.default)(interval.start);
    var end = (0, _indexJsDefault8.default)(interval.end);
    if (isNaN(start.getTime())) throw new RangeError('Start Date is invalid');
    if (isNaN(end.getTime())) throw new RangeError('End Date is invalid');
    var duration = {};
    duration.years = Math.abs((0, _indexJsDefault7.default)(end, start));
    var sign = (0, _indexJsDefault.default)(end, start);
    var remainingMonths = (0, _indexJsDefault1.default)(start, {
        years: sign * duration.years
    });
    duration.months = Math.abs((0, _indexJsDefault5.default)(end, remainingMonths));
    var remainingDays = (0, _indexJsDefault1.default)(remainingMonths, {
        months: sign * duration.months
    });
    duration.days = Math.abs((0, _indexJsDefault2.default)(end, remainingDays));
    var remainingHours = (0, _indexJsDefault1.default)(remainingDays, {
        days: sign * duration.days
    });
    duration.hours = Math.abs((0, _indexJsDefault3.default)(end, remainingHours));
    var remainingMinutes = (0, _indexJsDefault1.default)(remainingHours, {
        hours: sign * duration.hours
    });
    duration.minutes = Math.abs((0, _indexJsDefault4.default)(end, remainingMinutes));
    var remainingSeconds = (0, _indexJsDefault1.default)(remainingMinutes, {
        minutes: sign * duration.minutes
    });
    duration.seconds = Math.abs((0, _indexJsDefault6.default)(end, remainingSeconds));
    return duration;
}

},{"../compareAsc/index.js":"6EgNY","../add/index.js":"iU8Sh","../differenceInDays/index.js":"ayGLu","../differenceInHours/index.js":"8Me0s","../differenceInMinutes/index.js":"k2Rse","../differenceInMonths/index.js":"hS4KR","../differenceInSeconds/index.js":"16fnU","../differenceInYears/index.js":"8baro","../toDate/index.js":"9koxn","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aEu9l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>subSeconds);
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addSeconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subSeconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"gKtzz","../addSeconds/index.js":"fr9dc","../_lib/requiredArgs/index.js":"9bkfg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMkKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isSameUTCWeek);
var _indexJs = require("../requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault.default)(2, arguments);
    var dateLeftStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

},{"../requiredArgs/index.js":"9bkfg","../startOfUTCWeek/index.js":"20vji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1V5QN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNgqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71wnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var locale = {
    code: 'be-tarask',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3mZ97","./_lib/formatLong/index.js":"9n9px","./_lib/formatRelative/index.js":"7vRKo","./_lib/localize/index.js":"gyTmO","./_lib/match/index.js":"eVxuq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3mZ97":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9n9px":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vRKo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"btU8f","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyTmO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eVxuq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOZjH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var locale = {
    code: 'bg',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"lvLgv","./_lib/formatLong/index.js":"coSKc","./_lib/formatRelative/index.js":"2fV1K","./_lib/localize/index.js":"2nicx","./_lib/match/index.js":"3ZrYL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvLgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coSKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2fV1K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
// Adapted from the `ru` translation
var weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function lastWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function thisWeek(day) {
    var weekday = weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function nextWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault1.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault1.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: nextWeekFormatToken,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../toDate/index.js":"9koxn","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2nicx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function isFeminine(unit) {
    return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}
function isNeuter(unit) {
    return unit === 'quarter';
}
function numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
    return number + '-' + suffix;
}
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ZrYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cSkVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var locale = {
    code: 'bn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"bdg71","./_lib/formatLong/index.js":"7496N","./_lib/formatRelative/index.js":"9ZlcO","./_lib/localize/index.js":"9VBVg","./_lib/match/index.js":"jjxkH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdg71":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../localize/index.js");
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, _indexJs.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
exports.default = formatDistance;

},{"../localize/index.js":"9VBVg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9VBVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }
parcelHelpers.export(exports, "numberToLocale", ()=>numberToLocale);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var numberValues = {
    locale: {
        '1': "\u09E7",
        '2': "\u09E8",
        '3': "\u09E9",
        '4': "\u09EA",
        '5': "\u09EB",
        '6': "\u09EC",
        '7': "\u09ED",
        '8': "\u09EE",
        '9': "\u09EF",
        '0': "\u09E6"
    },
    number: {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    }
};
var eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = numberToLocale(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'date') return dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return numberValues.locale[match];
    });
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7496N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZlcO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jjxkH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAlw7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var locale = {
    code: 'bs',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hwfOn","./_lib/formatLong/index.js":"5hDqE","./_lib/formatRelative/index.js":"8AxgY","./_lib/localize/index.js":"93f6z","./_lib/match/index.js":"3TpqU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwfOn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 sedmicu',
            withPrepositionAgo: 'oko 1 sedmicu',
            withPrepositionIn: 'oko 1 sedmicu'
        },
        dual: 'oko {{count}} sedmice',
        other: 'oko {{count}} sedmice'
    },
    xWeeks: {
        one: {
            standalone: '1 sedmicu',
            withPrepositionAgo: '1 sedmicu',
            withPrepositionIn: '1 sedmicu'
        },
        dual: '{{count}} sedmice',
        other: '{{count}} sedmice'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5hDqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8AxgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93f6z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Prije Hrista',
        'Poslije Hrista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3TpqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXrDz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var locale = {
    code: 'ca',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')

},{"./_lib/formatDistance/index.js":"bggDb","./_lib/formatLong/index.js":"i3sRo","./_lib/formatRelative/index.js":"2tRnn","./_lib/localize/index.js":"459Kf","./_lib/match/index.js":"f18We","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bggDb":[function(require,module,exports,__globalThis) {
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: 'menys de {{count}} segons'
    },
    xSeconds: {
        one: '1 segon',
        other: '{{count}} segons'
    },
    halfAMinute: 'mig minut',
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: 'menys de {{count}} minuts'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minuts'
    },
    aboutXHours: {
        one: 'aproximadament una hora',
        other: 'aproximadament {{count}} hores'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} hores'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dies'
    },
    aboutXWeeks: {
        one: 'aproximadament una setmana',
        other: 'aproximadament {{count}} setmanes'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanes'
    },
    aboutXMonths: {
        one: 'aproximadament un mes',
        other: 'aproximadament {{count}} mesos'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} mesos'
    },
    aboutXYears: {
        one: 'aproximadament un any',
        other: 'aproximadament {{count}} anys'
    },
    xYears: {
        one: '1 any',
        other: '{{count}} anys'
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'fa ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3sRo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2tRnn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"459Kf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a. de C.',
        'd. de C.'
    ],
    wide: [
        'abans de Crist',
        "despr\xe9s de Crist"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        '1r trimestre',
        '2n trimestre',
        '3r trimestre',
        '4t trimestre'
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MG',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DS'
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'maig',
        'juny',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'des.'
    ],
    wide: [
        'gener',
        'febrer',
        "mar\xe7",
        'abril',
        'maig',
        'juny',
        'juliol',
        'agost',
        'setembre',
        'octubre',
        'novembre',
        'desembre'
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'diumenge',
        'dilluns',
        'dimarts',
        'dimecres',
        'dijous',
        'divendres',
        'dissabte'
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'r';
        case 2:
            return number + 'n';
        case 3:
            return number + 'r';
        case 4:
            return number + 't';
    }
    return number + "\xe8";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f18We":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Za3G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var locale = {
    code: 'cs',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dfWpq","./_lib/formatLong/index.js":"lR4B0","./_lib/formatRelative/index.js":"hYpDB","./_lib/localize/index.js":"ldoDh","./_lib/match/index.js":"lIax9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dfWpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lR4B0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYpDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ldoDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lIax9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96HkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var locale = {
    code: 'cy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iFcgo","./_lib/formatLong/index.js":"gsVG2","./_lib/formatRelative/index.js":"9mGzL","./_lib/localize/index.js":"hLiTR","./_lib/match/index.js":"633ho","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iFcgo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'llai na eiliad',
        other: 'llai na {{count}} eiliad'
    },
    xSeconds: {
        one: '1 eiliad',
        other: '{{count}} eiliad'
    },
    halfAMinute: 'hanner munud',
    lessThanXMinutes: {
        one: 'llai na munud',
        two: 'llai na 2 funud',
        other: 'llai na {{count}} munud'
    },
    xMinutes: {
        one: '1 munud',
        two: '2 funud',
        other: '{{count}} munud'
    },
    aboutXHours: {
        one: 'tua 1 awr',
        other: 'tua {{count}} awr'
    },
    xHours: {
        one: '1 awr',
        other: '{{count}} awr'
    },
    xDays: {
        one: '1 diwrnod',
        two: '2 ddiwrnod',
        other: '{{count}} diwrnod'
    },
    aboutXWeeks: {
        one: 'tua 1 wythnos',
        two: 'tua pythefnos',
        other: 'tua {{count}} wythnos'
    },
    xWeeks: {
        one: '1 wythnos',
        two: 'pythefnos',
        other: '{{count}} wythnos'
    },
    aboutXMonths: {
        one: 'tua 1 mis',
        two: 'tua 2 fis',
        other: 'tua {{count}} mis'
    },
    xMonths: {
        one: '1 mis',
        two: '2 fis',
        other: '{{count}} mis'
    },
    aboutXYears: {
        one: 'tua 1 flwyddyn',
        two: 'tua 2 flynedd',
        other: 'tua {{count}} mlynedd'
    },
    xYears: {
        one: '1 flwyddyn',
        two: '2 flynedd',
        other: '{{count}} mlynedd'
    },
    overXYears: {
        one: 'dros 1 flwyddyn',
        two: 'dros 2 flynedd',
        other: 'dros {{count}} mlynedd'
    },
    almostXYears: {
        one: 'bron 1 flwyddyn',
        two: 'bron 2 flynedd',
        other: 'bron {{count}} mlynedd'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'mewn ' + result;
        else return result + " yn \xf4l";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsVG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9mGzL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLiTR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'C',
        'O'
    ],
    abbreviated: [
        'CC',
        'OC'
    ],
    wide: [
        'Cyn Crist',
        "Ar \xf4l Crist"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Ch1',
        'Ch2',
        'Ch3',
        'Ch4'
    ],
    wide: [
        'Chwarter 1af',
        '2ail chwarter',
        '3ydd chwarter',
        '4ydd chwarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'I',
        'Ch',
        'Ma',
        'E',
        'Mi',
        'Me',
        'G',
        'A',
        'Md',
        'H',
        'T',
        'Rh'
    ],
    abbreviated: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag'
    ],
    wide: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'Ll',
        'M',
        'M',
        'I',
        'G',
        'S'
    ],
    short: [
        'Su',
        'Ll',
        'Ma',
        'Me',
        'Ia',
        'Gw',
        'Sa'
    ],
    abbreviated: [
        'Sul',
        'Llun',
        'Maw',
        'Mer',
        'Iau',
        'Gwe',
        'Sad'
    ],
    wide: [
        'dydd Sul',
        'dydd Llun',
        'dydd Mawrth',
        'dydd Mercher',
        'dydd Iau',
        'dydd Gwener',
        'dydd Sadwrn'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + 'fed';
        case 1:
            return number + 'af';
        case 2:
            return number + 'ail';
        case 3:
        case 4:
            return number + 'ydd';
        case 5:
        case 6:
            return number + 'ed';
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + 'fed';
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + 'eg';
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + 'fed';
    return number + 'ain';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"633ho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Wae2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var locale = {
    code: 'da',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dUhVJ","./_lib/formatLong/index.js":"gU9Yh","./_lib/formatRelative/index.js":"VCckR","./_lib/localize/index.js":"jHbaC","./_lib/match/index.js":"3MeMB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dUhVJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gU9Yh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"VCckR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jHbaC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3MeMB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehZzJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var locale = {
    code: 'de',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iOOTW","./_lib/formatLong/index.js":"bPJ9N","./_lib/formatRelative/index.js":"8hrIF","./_lib/localize/index.js":"fjTDU","./_lib/match/index.js":"bymdU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOOTW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPJ9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hrIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjTDU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: monthValues.wide
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        formattingValues: formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bymdU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4wJ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../de/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../de/_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../de/_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../de/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
// difference to 'de' locale
var _indexJs4 = require("./_lib/localize/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var locale = {
    code: 'de-AT',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault4.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../de/_lib/formatDistance/index.js":"iOOTW","../de/_lib/formatLong/index.js":"bPJ9N","../de/_lib/formatRelative/index.js":"8hrIF","../de/_lib/match/index.js":"bymdU","./_lib/localize/index.js":"aJO0s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJO0s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        "J\xe4n",
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        "J\xe4nner",
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: monthValues.wide
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        formattingValues: formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klEaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var locale = {
    code: 'el',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"0RHg5","./_lib/formatLong/index.js":"4LED9","./_lib/formatRelative/index.js":"huVlG","./_lib/localize/index.js":"6q3gl","./_lib/match/index.js":"cBwKT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0RHg5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LED9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'd/M/yy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: '{{date}} - {{time}}',
    long: '{{date}} - {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"huVlG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6q3gl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        'T',
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'year' || unit === 'month') suffix = "\u03BF\u03C2";
    else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBwKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blhs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../en-US/_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var locale = {
    code: 'en-AU',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","./_lib/formatLong/index.js":"9Hjjj","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Hjjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kO2gy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/match/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/formatDistance/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var locale = {
    code: 'en-CA',
    formatDistance: (0, _indexJsDefault3.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault.default),
    localize: (0, _indexJsDefault1.default),
    match: (0, _indexJsDefault2.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatDistance/index.js":"cMaLF","./_lib/formatLong/index.js":"j9tex","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMaLF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: 'a second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: 'a minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about an hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: 'an hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: 'a day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about a week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: 'a week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about a month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: 'a month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about a year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: 'a year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over a year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost a year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9tex":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, yyyy',
    long: 'MMMM do, yyyy',
    medium: 'MMM d, yyyy',
    short: 'yyyy-MM-dd'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5FcFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var locale = {
    code: 'en-GB',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"fp4Wt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fp4Wt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ZdBv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../en-GB/_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var locale = {
    code: 'en-IE',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","../en-GB/_lib/formatLong/index.js":"fp4Wt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"H6lja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var locale = {
    code: 'en-IN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"lcbuk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcbuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM, yyyy',
    medium: 'd MMM, yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lStYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var locale = {
    code: 'en-NZ',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"i73Ox","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i73Ox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"judpw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var locale = {
    code: 'en-ZA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"33ZTo","../en-US/_lib/formatRelative/index.js":"aDrXK","../en-US/_lib/localize/index.js":"cGr1B","../en-US/_lib/match/index.js":"gyWiy","./_lib/formatLong/index.js":"evQmH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evQmH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gLhnW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var locale = {
    code: 'eo',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9JUwe","./_lib/formatLong/index.js":"fz9GN","./_lib/formatRelative/index.js":"8H6PU","./_lib/localize/index.js":"6kt5V","./_lib/match/index.js":"hReyj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JUwe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'malpli ol sekundo',
        other: 'malpli ol {{count}} sekundoj'
    },
    xSeconds: {
        one: '1 sekundo',
        other: '{{count}} sekundoj'
    },
    halfAMinute: 'duonminuto',
    lessThanXMinutes: {
        one: 'malpli ol minuto',
        other: 'malpli ol {{count}} minutoj'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutoj'
    },
    aboutXHours: {
        one: 'proksimume 1 horo',
        other: 'proksimume {{count}} horoj'
    },
    xHours: {
        one: '1 horo',
        other: '{{count}} horoj'
    },
    xDays: {
        one: '1 tago',
        other: '{{count}} tagoj'
    },
    aboutXMonths: {
        one: 'proksimume 1 monato',
        other: 'proksimume {{count}} monatoj'
    },
    xWeeks: {
        one: '1 semajno',
        other: '{{count}} semajnoj'
    },
    aboutXWeeks: {
        one: 'proksimume 1 semajno',
        other: 'proksimume {{count}} semajnoj'
    },
    xMonths: {
        one: '1 monato',
        other: '{{count}} monatoj'
    },
    aboutXYears: {
        one: 'proksimume 1 jaro',
        other: 'proksimume {{count}} jaroj'
    },
    xYears: {
        one: '1 jaro',
        other: '{{count}} jaroj'
    },
    overXYears: {
        one: 'pli ol 1 jaro',
        other: 'pli ol {{count}} jaroj'
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return 'post ' + result;
        else return "anta\u016D " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fz9GN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: 'y-MMMM-dd',
    medium: 'y-MMM-dd',
    short: 'yyyy-MM-dd'
};
var timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8H6PU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kt5V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aK',
        'pK'
    ],
    abbreviated: [
        'a.K.E.',
        'p.K.E.'
    ],
    wide: [
        "anta\u016D Komuna Erao",
        'Komuna Erao'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1-a kvaronjaro',
        '2-a kvaronjaro',
        '3-a kvaronjaro',
        '4-a kvaronjaro'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        "a\u016Dg",
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januaro',
        'februaro',
        'marto',
        'aprilo',
        'majo',
        'junio',
        'julio',
        "a\u016Dgusto",
        'septembro',
        'oktobro',
        'novembro',
        'decembro'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        "\u0134",
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        "\u0135a",
        've',
        'sa'
    ],
    abbreviated: [
        'dim',
        'lun',
        'mar',
        'mer',
        "\u0135a\u016D",
        'ven',
        'sab'
    ],
    wide: [
        "diman\u0109o",
        'lundo',
        'mardo',
        'merkredo',
        "\u0135a\u016Ddo",
        'vendredo',
        'sabato'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    abbreviated: {
        am: 'a.t.m.',
        pm: 'p.t.m.',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: 'posttagmeze',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '-a';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hReyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCVgz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var locale = {
    code: 'es',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"doI49","./_lib/formatLong/index.js":"gHxyu","./_lib/formatRelative/index.js":"01w35","./_lib/localize/index.js":"btkQs","./_lib/match/index.js":"bryYA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"doI49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHxyu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01w35":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    else return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btkQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bryYA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"899KZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var locale = {
    code: 'et',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"bkk7A","./_lib/formatLong/index.js":"7Zqv7","./_lib/formatRelative/index.js":"jmUt7","./_lib/localize/index.js":"8GZTM","./_lib/match/index.js":"abvhK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bkk7A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Zqv7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmUt7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8GZTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"abvhK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^\d+\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BKqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var locale = {
    code: 'eu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4cTry","./_lib/formatLong/index.js":"cBDKZ","./_lib/formatRelative/index.js":"h6q8y","./_lib/localize/index.js":"cWW1n","./_lib/match/index.js":"6hN9E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cTry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'segundo bat baino gutxiago',
        other: '{{count}} segundo baino gutxiago'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundo'
    },
    halfAMinute: 'minutu erdi',
    lessThanXMinutes: {
        one: 'minutu bat baino gutxiago',
        other: '{{count}} minutu baino gutxiago'
    },
    xMinutes: {
        one: '1 minutu',
        other: '{{count}} minutu'
    },
    aboutXHours: {
        one: '1 ordu gutxi gorabehera',
        other: '{{count}} ordu gutxi gorabehera'
    },
    xHours: {
        one: '1 ordu',
        other: '{{count}} ordu'
    },
    xDays: {
        one: '1 egun',
        other: '{{count}} egun'
    },
    aboutXWeeks: {
        one: 'aste 1 inguru',
        other: '{{count}} aste inguru'
    },
    xWeeks: {
        one: '1 aste',
        other: '{{count}} astean'
    },
    aboutXMonths: {
        one: '1 hilabete gutxi gorabehera',
        other: '{{count}} hilabete gutxi gorabehera'
    },
    xMonths: {
        one: '1 hilabete',
        other: '{{count}} hilabete'
    },
    aboutXYears: {
        one: '1 urte gutxi gorabehera',
        other: '{{count}} urte gutxi gorabehera'
    },
    xYears: {
        one: '1 urte',
        other: '{{count}} urte'
    },
    overXYears: {
        one: '1 urte baino gehiago',
        other: '{{count}} urte baino gehiago'
    },
    almostXYears: {
        one: 'ia 1 urte',
        other: 'ia {{count}} urte'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'duela ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBDKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: 'y MMM d',
    short: 'yy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6q8y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWW1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'k.a.',
        'k.o.'
    ],
    abbreviated: [
        'k.a.',
        'k.o.'
    ],
    wide: [
        'kristo aurretik',
        'kristo ondoren'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1H',
        '2H',
        '3H',
        '4H'
    ],
    wide: [
        '1. hiruhilekoa',
        '2. hiruhilekoa',
        '3. hiruhilekoa',
        '4. hiruhilekoa'
    ]
};
var monthValues = {
    narrow: [
        'u',
        'o',
        'm',
        'a',
        'm',
        'e',
        'u',
        'a',
        'i',
        'u',
        'a',
        'a'
    ],
    abbreviated: [
        'urt',
        'ots',
        'mar',
        'api',
        'mai',
        'eka',
        'uzt',
        'abu',
        'ira',
        'urr',
        'aza',
        'abe'
    ],
    wide: [
        'urtarrila',
        'otsaila',
        'martxoa',
        'apirila',
        'maiatza',
        'ekaina',
        'uztaila',
        'abuztua',
        'iraila',
        'urria',
        'azaroa',
        'abendua'
    ]
};
var dayValues = {
    narrow: [
        'i',
        'a',
        'a',
        'a',
        'o',
        'o',
        'l'
    ],
    short: [
        'ig',
        'al',
        'as',
        'az',
        'og',
        'or',
        'lr'
    ],
    abbreviated: [
        'iga',
        'ast',
        'ast',
        'ast',
        'ost',
        'ost',
        'lar'
    ],
    wide: [
        'igandea',
        'astelehena',
        'asteartea',
        'asteazkena',
        'osteguna',
        'ostirala',
        'larunbata'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hN9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4FsED":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var locale = {
    code: 'fa-IR',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3eRMy","./_lib/formatLong/index.js":"64nmC","./_lib/formatRelative/index.js":"9Fqwn","./_lib/localize/index.js":"9pCXK","./_lib/match/index.js":"8dNiY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3eRMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"64nmC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Fqwn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9pCXK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8dNiY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGMC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var locale = {
    code: 'fi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"21OHu","./_lib/formatLong/index.js":"dE4i6","./_lib/formatRelative/index.js":"7H9ZJ","./_lib/localize/index.js":"8k0RQ","./_lib/match/index.js":"hkhEW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21OHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: futureYears
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dE4i6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7H9ZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8k0RQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var formattingDayValues = {
    narrow: dayValues.narrow,
    short: dayValues.short,
    abbreviated: dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hkhEW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEe2x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var locale = {
    code: 'fr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"cTXSJ","./_lib/formatLong/index.js":"99R8e","./_lib/formatRelative/index.js":"7SGGp","./_lib/localize/index.js":"6FysQ","./_lib/match/index.js":"flrvi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTXSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99R8e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SGGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FysQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"flrvi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k4r7J":[function(require,module,exports,__globalThis) {
// Same as fr
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../fr/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../fr/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../fr/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../fr/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
// Unique for fr-CA
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var locale = {
    code: 'fr-CA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"../fr/_lib/formatDistance/index.js":"cTXSJ","../fr/_lib/formatRelative/index.js":"7SGGp","../fr/_lib/localize/index.js":"6FysQ","../fr/_lib/match/index.js":"flrvi","./_lib/formatLong/index.js":"01EwZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"01EwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5JnNz":[function(require,module,exports,__globalThis) {
// Same as fr
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../fr/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../fr/_lib/localize/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../fr/_lib/match/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// Unique for fr-CH
var _indexJs3 = require("./_lib/formatLong/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatRelative/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var locale = {
    code: 'fr-CH',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault3.default),
    formatRelative: (0, _indexJsDefault4.default),
    localize: (0, _indexJsDefault1.default),
    match: (0, _indexJsDefault2.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../fr/_lib/formatDistance/index.js":"cTXSJ","../fr/_lib/localize/index.js":"6FysQ","../fr/_lib/match/index.js":"flrvi","./_lib/formatLong/index.js":"lcig0","./_lib/formatRelative/index.js":"imUEr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcig0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"imUEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HEQq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var locale = {
    code: 'fy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dRMIG","./_lib/formatLong/index.js":"c6f0S","./_lib/formatRelative/index.js":"8BiZC","./_lib/localize/index.js":"dYv8A","./_lib/match/index.js":"3H7ux","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dRMIG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder as 1 sekonde',
        other: 'minder as {{count}} sekonden'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekonden'
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: 'minder as {{count}} minuten'
    },
    xMinutes: {
        one: "1 min\xfat",
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'sawat 1 oere',
        other: 'sawat {{count}} oere'
    },
    xHours: {
        one: '1 oere',
        other: '{{count}} oere'
    },
    xDays: {
        one: '1 dei',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'sawat 1 wike',
        other: 'sawat {{count}} wiken'
    },
    xWeeks: {
        one: '1 wike',
        other: '{{count}} wiken'
    },
    aboutXMonths: {
        one: 'sawat 1 moanne',
        other: 'sawat {{count}} moannen'
    },
    xMonths: {
        one: '1 moanne',
        other: '{{count}} moannen'
    },
    aboutXYears: {
        one: 'sawat 1 jier',
        other: 'sawat {{count}} jier'
    },
    xYears: {
        one: '1 jier',
        other: '{{count}} jier'
    },
    overXYears: {
        one: 'mear as 1 jier',
        other: 'mear as {{count}}s jier'
    },
    almostXYears: {
        one: 'hast 1 jier',
        other: 'hast {{count}} jier'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oer ' + result;
        else return result + ' lyn';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6f0S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8BiZC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYv8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.K.',
        'n.K.'
    ],
    abbreviated: [
        'f.Kr.',
        'n.Kr.'
    ],
    wide: [
        'foar Kristus',
        'nei Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e fearnsjier',
        '2e fearnsjier',
        '3e fearnsjier',
        '4e fearnsjier'
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mai.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'jannewaris',
        'febrewaris',
        'maart',
        'april',
        'maaie',
        'juny',
        'july',
        'augustus',
        'septimber',
        'oktober',
        'novimber',
        'desimber'
    ]
};
var dayValues = {
    narrow: [
        's',
        'm',
        't',
        'w',
        't',
        'f',
        's'
    ],
    short: [
        'si',
        'mo',
        'ti',
        'wo',
        'to',
        'fr',
        'so'
    ],
    abbreviated: [
        'snein',
        'moa',
        'tii',
        'woa',
        'ton',
        'fre',
        'sneon'
    ],
    wide: [
        'snein',
        'moandei',
        'tiisdei',
        'woansdei',
        'tongersdei',
        'freed',
        'sneon'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3H7ux":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gutn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var locale = {
    code: 'gd',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"eXerc","./_lib/formatLong/index.js":"6Ta5U","./_lib/formatRelative/index.js":"iVZdl","./_lib/localize/index.js":"5cbvE","./_lib/match/index.js":"cDyJ7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXerc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'nas lugha na diog',
        other: 'nas lugha na {{count}} diogan'
    },
    xSeconds: {
        one: '1 diog',
        two: '2 dhiog',
        twenty: '20 diog',
        other: '{{count}} diogan'
    },
    halfAMinute: 'leth mhionaid',
    lessThanXMinutes: {
        one: 'nas lugha na mionaid',
        other: 'nas lugha na {{count}} mionaidean'
    },
    xMinutes: {
        one: '1 mionaid',
        two: '2 mhionaid',
        twenty: '20 mionaid',
        other: '{{count}} mionaidean'
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: 'mu 1 seachdain',
        other: 'mu {{count}} seachdainean'
    },
    xWeeks: {
        one: '1 seachdain',
        other: '{{count}} seachdainean'
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: 'mu bhliadhna',
        other: 'mu {{count}} bliadhnaichean'
    },
    xYears: {
        one: '1 bhliadhna',
        other: '{{count}} bliadhna'
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'ann an ' + result;
        else return 'o chionn ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Ta5U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iVZdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5cbvE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'R',
        'A'
    ],
    abbreviated: [
        'RC',
        'AD'
    ],
    wide: [
        "ro Chr\xecosta",
        'anno domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'C1',
        'C2',
        'C3',
        'C4'
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        'an treas cairteal',
        'an ceathramh cairteal'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'F',
        'G',
        'M',
        'G',
        'C',
        "\xd2",
        'I',
        'L',
        'S',
        'D',
        'S',
        'D'
    ],
    abbreviated: [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ],
    wide: [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'C',
        'A',
        'H',
        'S'
    ],
    short: [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ],
    abbreviated: [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ],
    wide: [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'd';
        case 2:
            return number + 'na';
    }
    if (rem100 === 12) return number + 'na';
    return number + 'mh';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cDyJ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMwzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var locale = {
    code: 'gl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9ZzMd","./_lib/formatLong/index.js":"3B7OT","./_lib/formatRelative/index.js":"b2RzQ","./_lib/localize/index.js":"1JP4N","./_lib/match/index.js":"3ME5v","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ZzMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos dun segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos dun minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'arredor dunha hora',
        other: 'arredor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'arredor dunha semana',
        other: 'arredor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'arredor de 1 mes',
        other: 'arredor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'arredor dun ano',
        other: 'arredor de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: 'case un ano',
        other: 'case {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hai ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3B7OT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2RzQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1JP4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'despois de cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'xan',
        'feb',
        'mar',
        'abr',
        'mai',
        'xun',
        'xul',
        'ago',
        'set',
        'out',
        'nov',
        'dec'
    ],
    wide: [
        'xaneiro',
        'febreiro',
        'marzo',
        'abril',
        'maio',
        "xu\xf1o",
        'xullo',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'decembro'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'me',
        'xo',
        've',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'xov',
        'ven',
        'sab'
    ],
    wide: [
        'domingo',
        'luns',
        'martes',
        "m\xe9rcores",
        'xoves',
        'venres',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ME5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1ngJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var locale = {
    code: 'gu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"2Hd39","./_lib/formatLong/index.js":"5j9G4","./_lib/formatRelative/index.js":"iX48t","./_lib/localize/index.js":"3bK47","./_lib/match/index.js":"j8DGL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Hd39":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5j9G4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); //Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM, y',
    // CLDR #1825
    long: 'd MMMM, y',
    // CLDR #1826
    medium: 'd MMM, y',
    // CLDR #1827
    short: 'd/M/yy' // CLDR #1828
};
var timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR #1829
    long: 'hh:mm:ss a z',
    // CLDR #1830
    medium: 'hh:mm:ss a',
    // CLDR #1831
    short: 'hh:mm a' // CLDR #1832
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR #1833
    long: '{{date}} {{time}}',
    // CLDR #1834
    medium: '{{date}} {{time}}',
    // CLDR #1835
    short: '{{date}} {{time}}' // CLDR #1836
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iX48t":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: 'eeee p',
    // CLDR #1386
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3bK47":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/gu.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// #1621 - #1630
var eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8DGL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37xwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var locale = {
    code: 'he',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jZWJP","./_lib/formatLong/index.js":"cs94C","./_lib/formatRelative/index.js":"lap2H","./_lib/localize/index.js":"4uJ3c","./_lib/match/index.js":"baLP1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZWJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === 'xDays' && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cs94C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: 'd.M.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lap2H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4uJ3c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        'year',
        'hour',
        'minute',
        'second'
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"baLP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70r0G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var locale = {
    code: 'hi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"b68YW","./_lib/formatLong/index.js":"2WNaU","./_lib/formatRelative/index.js":"a0GID","./_lib/localize/index.js":"6t52l","./_lib/match/index.js":"5Ecph","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b68YW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../localize/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/hi.html
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, _indexJs.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
exports.default = formatDistance;

},{"../localize/index.js":"6t52l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6t52l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localeToNumber", ()=>localeToNumber);
parcelHelpers.export(exports, "numberToLocale", ()=>numberToLocale);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var numberValues = {
    locale: {
        '1': "\u0967",
        '2': "\u0968",
        '3': "\u0969",
        '4': "\u096A",
        '5': "\u096B",
        '6': "\u096C",
        '7': "\u096D",
        '8': "\u096E",
        '9': "\u096F",
        '0': "\u0966"
    },
    number: {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }
};
// CLDR #1585 - #1592
var eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return numberToLocale(number);
};
function localeToNumber(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return numberValues.number[match];
    });
    return Number(enNumber);
}
function numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return numberValues.locale[match];
    });
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2WNaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    // CLDR #1787
    long: 'do MMMM, y',
    // CLDR #1788
    medium: 'd MMM, y',
    // CLDR #1789
    short: 'dd/MM/yyyy' // CLDR #1790
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    // CLDR #1791
    long: 'h:mm:ss a z',
    // CLDR #1792
    medium: 'h:mm:ss a',
    // CLDR #1793
    short: 'h:mm a' // CLDR #1794
};
var dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: '{{date}}, {{time}}',
    // CLDR #1797
    short: '{{date}}, {{time}}' // CLDR #1798
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a0GID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Ecph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../localize/index.js");
var matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (0, _indexJs2.localeToNumber)
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","../localize/index.js":"6t52l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2nDgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var locale = {
    code: 'hr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"booBl","./_lib/formatLong/index.js":"8qOg7","./_lib/formatRelative/index.js":"4Tkwc","./_lib/localize/index.js":"hWRkV","./_lib/match/index.js":"54PL8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"booBl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
        },
        dual: 'oko {{count}} tjedna',
        other: 'oko {{count}} tjedana'
    },
    xWeeks: {
        one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
        },
        dual: '{{count}} tjedna',
        other: '{{count}} tjedana'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8qOg7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM y.',
    long: 'd. MMMM y.',
    medium: 'd. MMM y.',
    short: 'dd. MM. y.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Tkwc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hWRkV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Kr.',
        'po. Kr.'
    ],
    wide: [
        'Prije Krista',
        'Poslije Krista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        'travnja',
        'svibnja',
        'lipnja',
        'srpnja',
        'kolovoza',
        'rujna',
        'listopada',
        'studenog',
        'prosinca'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"54PL8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WCNE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var locale = {
    code: 'ht',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"duLk8","./_lib/formatLong/index.js":"e4m07","./_lib/formatRelative/index.js":"lss5l","./_lib/localize/index.js":"6trvU","./_lib/match/index.js":"1PUJF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"duLk8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mwens pase yon segond',
        other: 'mwens pase {{count}} segond'
    },
    xSeconds: {
        one: '1 segond',
        other: '{{count}} segond'
    },
    halfAMinute: '30 segond',
    lessThanXMinutes: {
        one: 'mwens pase yon minit',
        other: 'mwens pase {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: '1 jou',
        other: '{{count}} jou'
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: 'anviwon 1 mwa',
        other: 'anviwon {{count}} mwa'
    },
    xMonths: {
        one: '1 mwa',
        other: '{{count}} mwa'
    },
    aboutXYears: {
        one: 'anviwon 1 an',
        other: 'anviwon {{count}} an'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} an'
    },
    overXYears: {
        one: 'plis pase 1 an',
        other: 'plis pase {{count}} an'
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'nan ' + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4m07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lss5l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6trvU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'av. J.-K',
        'ap. J.-K'
    ],
    abbreviated: [
        'av. J.-K',
        'ap. J.-K'
    ],
    wide: [
        'anvan Jezi Kris',
        'apre Jezi Kris'
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1ye trim.',
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'fevr.',
        'mas',
        'avr.',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'sept.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'janvye',
        'fevrye',
        'mas',
        'avril',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'septanm',
        "okt\xf2b",
        'novanm',
        'desanm'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'le',
        'ma',
        "m\xe8",
        'je',
        'va',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'len.',
        'mad.',
        "m\xe8k.",
        'jed.',
        'van.',
        'sam.'
    ],
    wide: [
        'dimanch',
        'lendi',
        'madi',
        "m\xe8kredi",
        'jedi',
        'vandredi',
        'samdi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'swa',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'maten',
        afternoon: "apr\xe8midi",
        evening: 'swa',
        night: 'maten'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'nan maten',
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: 'nan maten'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? 'ye' : "y\xe8m";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1PUJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFFH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var locale = {
    code: 'hu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"eULYe","./_lib/formatLong/index.js":"eTFjR","./_lib/formatRelative/index.js":"iFs6h","./_lib/localize/index.js":"cl0PN","./_lib/match/index.js":"g2GCh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eULYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = translations[adv] + ' ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eTFjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iFs6h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function week(isFuture) {
    return function(date) {
        var weekday = accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var formatRelativeLocale = {
    lastWeek: week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: week(true),
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cl0PN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g2GCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3FLD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var locale = {
    code: 'hy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"eeJFg","./_lib/formatLong/index.js":"k6yqJ","./_lib/formatRelative/index.js":"2ZD5R","./_lib/localize/index.js":"a3CYb","./_lib/match/index.js":"ko4sf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eeJFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6yqJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'd MMMM, y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZD5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a3CYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ko4sf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9iVd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var locale = {
    code: 'id',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7LdoC","./_lib/formatLong/index.js":"iWFyG","./_lib/formatRelative/index.js":"4U3VD","./_lib/localize/index.js":"4LmT6","./_lib/match/index.js":"evGhN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LdoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 detik',
        other: 'kurang dari {{count}} detik'
    },
    xSeconds: {
        one: '1 detik',
        other: '{{count}} detik'
    },
    halfAMinute: 'setengah menit',
    lessThanXMinutes: {
        one: 'kurang dari 1 menit',
        other: 'kurang dari {{count}} menit'
    },
    xMinutes: {
        one: '1 menit',
        other: '{{count}} menit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam waktu ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWFyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4U3VD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LmT6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // All data for localization are taken from this page
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/id.html
var eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masehi',
        'Masehi'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        'Kuartal ke-1',
        'Kuartal ke-2',
        'Kuartal ke-3',
        'Kuartal ke-4'
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agt',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var dayValues = {
    narrow: [
        'M',
        'S',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    wide: [
        'Minggu',
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + number;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evGhN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7wBfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var locale = {
    code: 'is',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"kIgeK","./_lib/formatLong/index.js":"dMlTI","./_lib/formatRelative/index.js":"6BOAd","./_lib/localize/index.js":"irRx7","./_lib/match/index.js":"2Fff8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIgeK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dMlTI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BOAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irRx7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Fff8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+(\.)?/i;
var matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecW7F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var locale = {
    code: 'it',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ib50W","./_lib/formatLong/index.js":"kqnWs","./_lib/formatRelative/index.js":"gJUE9","./_lib/localize/index.js":"cRHTX","./_lib/match/index.js":"7P22f","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ib50W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kqnWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJUE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function _lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + weekdays[day] + " scorso alle' p";
    }
}
function thisWeek(day) {
    return "'" + weekdays[day] + " alle' p";
}
function _nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + weekdays[day] + " prossimo alle' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cRHTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7P22f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bboAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../it/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../it/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../it/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../it/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var locale = {
    code: 'it-CH',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../it/_lib/formatDistance/index.js":"ib50W","../it/_lib/formatRelative/index.js":"gJUE9","../it/_lib/localize/index.js":"cRHTX","../it/_lib/match/index.js":"7P22f","./_lib/formatLong/index.js":"lAKy4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lAKy4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Wocf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var locale = {
    code: 'ja',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"lCFcq","./_lib/formatLong/index.js":"drGSS","./_lib/formatRelative/index.js":"6nbYm","./_lib/localize/index.js":"juDbG","./_lib/match/index.js":"gEeRn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCFcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"drGSS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6nbYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"juDbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gEeRn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"imsfL","../../../_lib/buildMatchFn/index.js":"8m1gR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8uqib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var locale = {
    code: 'ja-Hira',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5p79r","./_lib/formatLong/index.js":"870Fj","./_lib/formatRelative/index.js":"ewFhG","./_lib/localize/index.js":"6PGkb","./_lib/match/index.js":"aeyFH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5p79r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"870Fj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewFhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6PGkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u306D\u3093");
        case 'quarter':
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case 'month':
            return "".concat(number, "\u304C\u3064");
        case 'week':
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case 'date':
            return "".concat(number, "\u306B\u3061");
        case 'hour':
            return "".concat(number, "\u3058");
        case 'minute':
            return "".concat(number, "\u3075\u3093");
        case 'second':
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aeyFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1RFqe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var locale = {
    code: 'ka',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4Vwie","./_lib/formatLong/index.js":"310xS","./_lib/formatRelative/index.js":"4GZFL","./_lib/localize/index.js":"32Enk","./_lib/match/index.js":"iN08a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Vwie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace('{{count}}', String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace('{{count}}', String(count));
    else result = tokenValue.present.replace('{{count}}', String(count));
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"310xS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do, MMMM, y',
    medium: 'd, MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GZFL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32Enk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iN08a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kbVuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var locale = {
    code: 'kk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"8SDGK","./_lib/formatLong/index.js":"e4XdT","./_lib/formatRelative/index.js":"dGQH5","./_lib/localize/index.js":"gDsWu","./_lib/match/index.js":"1HJfn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8SDGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: 'weeks',
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: 'weeks',
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'function') return tokenValue(options);
    if (tokenValue.type === 'weeks') return count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return declension(tokenValue.future, count);
            else return declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return declension(tokenValue.past, count);
            else return declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return declension(tokenValue.regular, count);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e4XdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGQH5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDsWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = suffixes[number] || suffixes[mod10] || b && suffixes[b] || '';
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1HJfn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ief84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var locale = {
    code: 'km',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"32NG8","./_lib/formatLong/index.js":"bq6GN","./_lib/formatRelative/index.js":"76KBe","./_lib/localize/index.js":"czT0c","./_lib/match/index.js":"g5FXH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32NG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === 'number') result = result.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bq6GN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a',
    long: 'h:mm:ss a',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"76KBe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czT0c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g5FXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Knme":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var locale = {
    code: 'kn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ePgnL","./_lib/formatLong/index.js":"i5TBj","./_lib/formatRelative/index.js":"iM2Zu","./_lib/localize/index.js":"1uKP3","./_lib/match/index.js":"29Mpy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePgnL":[function(require,module,exports,__globalThis) {
// note: no implementation for weeks
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = getResultByTense(tokenValue.one, options);
    else result = getResultByTense(tokenValue.other, options);
    return result.replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5TBj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM d, y',
    // CLDR 1816
    long: 'MMMM d, y',
    // CLDR 1817
    medium: 'MMM d, y',
    // CLDR 1818
    short: 'd/M/yy' // CLDR 1819
};
var timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR 1820
    long: 'hh:mm:ss a z',
    // CLDR 1821
    medium: 'hh:mm:ss a',
    // CLDR 1822
    short: 'hh:mm a' // CLDR 1823
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR 1824
    long: '{{date}} {{time}}',
    // CLDR 1825
    medium: '{{date}} {{time}}',
    // CLDR 1826
    short: '{{date}} {{time}}' // CLDR 1827
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iM2Zu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uKP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"29Mpy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f4lPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var locale = {
    code: 'ko',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"g0ZBk","./_lib/formatLong/index.js":"jXXkK","./_lib/formatRelative/index.js":"iUrUH","./_lib/localize/index.js":"bpbmF","./_lib/match/index.js":"lyIE8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0ZBk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXXkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iUrUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bpbmF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyIE8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8f9Yz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var locale = {
    code: 'lb',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"1Kfru","./_lib/formatLong/index.js":"6gcGS","./_lib/formatRelative/index.js":"5bwtX","./_lib/localize/index.js":"flNMH","./_lib/match/index.js":"38WqL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Kfru":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
        },
        withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
        }
    },
    halfAMinute: {
        standalone: 'eng hallef Minutt',
        withPreposition: 'enger hallwer Minutt'
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
        },
        withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
        },
        withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
        }
    },
    xDays: {
        standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
        },
        withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: 'ee Mount',
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: 'engem Mount',
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
        },
        withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
        },
        withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
        }
    }
};
var EXCEPTION_CONSONANTS = [
    'd',
    'h',
    'n',
    't',
    'z'
];
var VOWELS = [
    'a,',
    'e',
    'i',
    'o',
    'u'
];
var DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(' ')[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'a' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
        else return 'viru' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gcGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    // Méindeg, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan 2018
    short: 'dd.MM.yy' // 07.01.18
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bwtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += 'n';
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"flNMH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'viru Christus',
        'no Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4e",
        'Abr',
        'Mee',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4erz",
        "Abr\xebll",
        'Mee',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        "M\xe9",
        "D\xeb",
        "M\xeb",
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonndeg',
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        'Donneschdeg',
        'Freideg',
        'Samschdeg'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: 'nom.',
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38WqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9UDJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var locale = {
    code: 'lt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"DEB3D","./_lib/formatLong/index.js":"bWaNu","./_lib/formatRelative/index.js":"41leS","./_lib/localize/index.js":"lNozF","./_lib/match/index.js":"7OaHx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"DEB3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: 'apie',
    over: 'daugiau nei',
    almost: 'beveik',
    lessthan: "ma\u017Eiau nei"
};
var translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
};
var translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
};
var translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) return result + translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    else {
        if (isFuture) return result + forms(key)[1];
        else return result + (special(number) ? forms(key)[1] : forms(key)[2]);
    }
};
function special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function forms(key) {
    return translations[key].split('_');
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: translateSeconds,
        other: translate
    },
    xSeconds: {
        one: translateSeconds,
        other: translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: translateSingular,
        other: translate
    },
    xMinutes: {
        one: translateSingular,
        other: translate
    },
    aboutXHours: {
        one: translateSingular,
        other: translate
    },
    xHours: {
        one: translateSingular,
        other: translate
    },
    xDays: {
        one: translateSingular,
        other: translate
    },
    aboutXWeeks: {
        one: translateSingular,
        other: translate
    },
    xWeeks: {
        one: translateSingular,
        other: translate
    },
    aboutXMonths: {
        one: translateSingular,
        other: translate
    },
    xMonths: {
        one: translateSingular,
        other: translate
    },
    aboutXYears: {
        one: translateSingular,
        other: translate
    },
    xYears: {
        one: translateSingular,
        other: translate
    },
    overXYears: {
        one: translateSingular,
        other: translate
    },
    almostXYears: {
        one: translateSingular,
        other: translate
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_one', isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_other', isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = translations[_key2] + ' ' + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'po ' + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bWaNu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: 'y-MM-dd',
    short: 'y-MM-dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"41leS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: 'eeee p',
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lNozF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr. Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pr. Kr.',
        'po Kr.'
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        'po Kristaus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I ketv.',
        'II ketv.',
        'III ketv.',
        'IV ketv.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I k.',
        'II k.',
        'III k.',
        'IV k.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var monthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausis',
        'vasaris',
        'kovas',
        'balandis',
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        'liepa',
        "rugpj\u016Btis",
        "rugs\u0117jis",
        'spalis',
        'lapkritis',
        'gruodis'
    ]
};
var formattingMonthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausio',
        'vasario',
        'kovo',
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        'liepos',
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        'spalio',
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var dayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        'sekmadienis',
        'pirmadienis',
        'antradienis',
        "tre\u010Diadienis",
        'ketvirtadienis',
        'penktadienis',
        "\u0161e\u0161tadienis"
    ]
};
var formattingDayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '-oji';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7OaHx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkd7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var locale = {
    code: 'lv',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3EFss","./_lib/formatLong/index.js":"kBB1x","./_lib/formatRelative/index.js":"gHewj","./_lib/localize/index.js":"fSInJ","./_lib/match/index.js":"dV25J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EFss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace('{{time}}', schema.one[2]);
            else return schema.one[0].replace('{{time}}', schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', String(count));
            else return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', String(count));
        }
    };
}
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            'sekundi',
            'sekundi'
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    xSeconds: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'sekunde',
            'sekundes'
        ],
        other: [
            '{{count}} {{time}}',
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            '{{count}} {{time}}',
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'stunda',
            'stundas'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xHours: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'stunda',
            'stundas'
        ],
        other: [
            '{{count}} {{time}}',
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xDays: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'diena',
            'dienas'
        ],
        other: [
            '{{count}} {{time}}',
            'diena',
            'dienas',
            'dienas',
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            '{{count}} {{time}}',
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            '{{count}} {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    xYears: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'gads',
            'gada'
        ],
        other: [
            '{{count}} {{time}}',
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    overXYears: buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            'gadu',
            'gadu'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    almostXYears: buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    })
};
var formatDistance = function formatDistance(token, count, options) {
    var result = formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return 'pirms ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kBB1x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: 'dd.MM.y.',
    short: 'dd.MM.y.'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gHewj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSInJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        'pirmais ceturksnis',
        'otrais ceturksnis',
        "tre\u0161ais ceturksnis",
        'ceturtais ceturksnis'
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        'marts',
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        'marts',
        "apr\u012Blis",
        'maijs',
        "j\u016Bnijs",
        "j\u016Blijs",
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris'
    ]
};
var formattingMonthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        "mart\u0101",
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var dayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdiena",
        'pirmdiena',
        'otrdiena',
        "tre\u0161diena",
        'ceturtdiena',
        'piektdiena',
        'sestdiena'
    ]
};
var formattingDayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: 'diena',
        evening: 'vakars',
        night: 'nakts'
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: 'vakars',
        night: 'nakts'
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusnakts',
        noon: 'pusdienlaiks',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: 'vakars',
        night: 'nakts'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dV25J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'wide',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Cvw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var locale = {
    code: 'mk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dLl6D","./_lib/formatLong/index.js":"byLCp","./_lib/formatRelative/index.js":"cNaT9","./_lib/localize/index.js":"28RGv","./_lib/match/index.js":"dLsSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLl6D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byLCp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cNaT9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function _lastWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function thisWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function _nextWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"28RGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLsSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13QbE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var locale = {
    code: 'mn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"Fs4xQ","./_lib/formatLong/index.js":"cm3BB","./_lib/formatRelative/index.js":"K0YsV","./_lib/localize/index.js":"3C52m","./_lib/match/index.js":"2C2T3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Fs4xQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(' ');
        var lastword = words.pop();
        result = words.join(' ');
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cm3BB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: 'y.MM.dd'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"K0YsV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3C52m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var quarterValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV'
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var formattingMonthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2C2T3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /\d+/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gca2E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var locale = {
    code: 'ms',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ed58Q","./_lib/formatLong/index.js":"dJgop","./_lib/formatRelative/index.js":"1pko9","./_lib/localize/index.js":"5Bi5I","./_lib/match/index.js":"lzkyS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ed58Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 saat',
        other: 'kurang dari {{count}} saat'
    },
    xSeconds: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    halfAMinute: 'setengah minit',
    lessThanXMinutes: {
        one: 'kurang dari 1 minit',
        other: 'kurang dari {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam masa ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dJgop":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1pko9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Bi5I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Most data for localization are taken from this page
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/ms.html
var eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masihi',
        'Masihi'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'S1',
        'S2',
        'S3',
        'S4'
    ],
    wide: [
        'Suku pertama',
        'Suku kedua',
        'Suku ketiga',
        'Suku keempat'
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mac',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Ogo',
        'Sep',
        'Okt',
        'Nov',
        'Dis'
    ],
    wide: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember'
    ]
};
var dayValues = {
    narrow: [
        'A',
        'I',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    wide: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tgh malam',
        noon: 'tgh hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + Number(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lzkyS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern = /petama|\d+/i;
var matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44qfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var locale = {
    code: 'mt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"RXZAd","./_lib/formatLong/index.js":"4pxTo","./_lib/formatRelative/index.js":"jye5W","./_lib/localize/index.js":"7SjDn","./_lib/match/index.js":"2MHg1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"RXZAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'inqas minn sekonda',
        other: 'inqas minn {{count}} sekondi'
    },
    xSeconds: {
        one: 'sekonda',
        other: '{{count}} sekondi'
    },
    halfAMinute: 'nofs minuta',
    lessThanXMinutes: {
        one: 'inqas minn minuta',
        other: 'inqas minn {{count}} minuti'
    },
    xMinutes: {
        one: 'minuta',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: 'madwar xahar',
        other: 'madwar {{count}} xhur'
    },
    xMonths: {
        one: 'xahar',
        other: '{{count}} xhur'
    },
    aboutXYears: {
        one: 'madwar sena',
        two: 'madwar sentejn',
        other: 'madwar {{count}} snin'
    },
    xYears: {
        one: 'sena',
        two: 'sentejn',
        other: '{{count}} snin'
    },
    overXYears: {
        one: 'aktar minn sena',
        two: 'aktar minn sentejn',
        other: 'aktar minn {{count}} snin'
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + ' ilu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4pxTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jye5W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SjDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'Q',
        'W'
    ],
    abbreviated: [
        'QK',
        'WK'
    ],
    wide: [
        'qabel Kristu',
        'wara Kristu'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kwart',
        '2. kwart',
        '3. kwart',
        '4. kwart'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        "\u0120",
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Fra',
        'Mar',
        'Apr',
        'Mej',
        "\u0120un",
        'Lul',
        'Aww',
        'Set',
        'Ott',
        'Nov',
        "Di\u010B"
    ],
    wide: [
        'Jannar',
        'Frar',
        'Marzu',
        'April',
        'Mejju',
        "\u0120unju",
        'Lulju',
        'Awwissu',
        'Settembru',
        'Ottubru',
        'Novembru',
        "Di\u010Bembru"
    ]
};
var dayValues = {
    narrow: [
        "\u0126",
        'T',
        'T',
        'E',
        "\u0126",
        "\u0120",
        'S'
    ],
    short: [
        "\u0126a",
        'Tn',
        'Tl',
        'Er',
        "\u0126a",
        "\u0120i",
        'Si'
    ],
    abbreviated: [
        "\u0126ad",
        'Tne',
        'Tli',
        'Erb',
        "\u0126am",
        "\u0120im",
        'Sib'
    ],
    wide: [
        "Il-\u0126add",
        'It-Tnejn',
        'It-Tlieta',
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        'Is-Sibt'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2MHg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aJ75U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var locale = {
    code: 'nb',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5tnXr","./_lib/formatLong/index.js":"9tGny","./_lib/formatRelative/index.js":"URaCv","./_lib/localize/index.js":"gaXfU","./_lib/match/index.js":"317Ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tnXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tGny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"URaCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gaXfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"317Ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HBIPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var locale = {
    code: 'nl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fhcrH","./_lib/formatLong/index.js":"cO4Hc","./_lib/formatRelative/index.js":"cnGUn","./_lib/localize/index.js":"kkYia","./_lib/match/index.js":"ccGjm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhcrH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cO4Hc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cnGUn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkYia":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ccGjm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljPLv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var locale = {
    code: 'nl-BE',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jAIEw","./_lib/formatLong/index.js":"a2v36","./_lib/formatRelative/index.js":"aCt4o","./_lib/localize/index.js":"haD49","./_lib/match/index.js":"3jaJp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jAIEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a2v36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCt4o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"haD49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jaJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4H3VI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var locale = {
    code: 'nn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dbFFu","./_lib/formatLong/index.js":"d8Slz","./_lib/formatRelative/index.js":"crlnq","./_lib/localize/index.js":"h7ZQf","./_lib/match/index.js":"jCFFf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dbFFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn eitt sekund',
        other: 'mindre enn {{count}} sekund'
    },
    xSeconds: {
        one: 'eitt sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'eit halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn eitt minutt',
        other: 'mindre enn {{count}} minutt'
    },
    xMinutes: {
        one: 'eitt minutt',
        other: '{{count}} minutt'
    },
    aboutXHours: {
        one: 'omtrent ein time',
        other: 'omtrent {{count}} timar'
    },
    xHours: {
        one: 'ein time',
        other: '{{count}} timar'
    },
    xDays: {
        one: 'ein dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'omtrent ei veke',
        other: 'omtrent {{count}} veker'
    },
    xWeeks: {
        one: 'ei veke',
        other: '{{count}} veker'
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var wordMapping = [
    'null',
    'ein',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sidan';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d8Slz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crlnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h7ZQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        'su',
        "m\xe5",
        'ty',
        'on',
        'to',
        'fr',
        'lau'
    ],
    abbreviated: [
        'sun',
        "m\xe5n",
        'tys',
        'ons',
        'tor',
        'fre',
        'laur'
    ],
    wide: [
        'sundag',
        "m\xe5ndag",
        'tysdag',
        'onsdag',
        'torsdag',
        'fredag',
        'laurdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCFFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bhYtb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var locale = {
    code: 'oc',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"vj3mx","./_lib/formatLong/index.js":"aMNsP","./_lib/formatRelative/index.js":"2LjJv","./_lib/localize/index.js":"8IiUD","./_lib/match/index.js":"f7Jdl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vj3mx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: 'mens de {{count}} segondas'
    },
    xSeconds: {
        one: '1 segonda',
        other: '{{count}} segondas'
    },
    halfAMinute: '30 segondas',
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: 'mens de {{count}} minutas'
    },
    xMinutes: {
        one: '1 minuta',
        other: '{{count}} minutas'
    },
    aboutXHours: {
        one: 'environ 1 ora',
        other: 'environ {{count}} oras'
    },
    xHours: {
        one: '1 ora',
        other: '{{count}} oras'
    },
    xDays: {
        one: '1 jorn',
        other: '{{count}} jorns'
    },
    aboutXWeeks: {
        one: 'environ 1 setmana',
        other: 'environ {{count}} setmanas'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanas'
    },
    aboutXMonths: {
        one: 'environ 1 mes',
        other: 'environ {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: 'mai de {{count}} ans'
    },
    almostXYears: {
        one: 'gaireben un an',
        other: 'gaireben {{count}} ans'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return 'fa ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMNsP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LjJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8IiUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    abbreviated: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        "1\xe8r trim.",
        '2nd trim.',
        '3en trim.',
        '4en trim.'
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MA',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DC'
    ],
    abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'mai',
        'junh',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'dec.'
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        'abril',
        'mai',
        'junh',
        'julhet',
        'agost',
        'setembre',
        "oct\xf2bre",
        'novembre',
        'decembre'
    ]
};
var dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'dimenge',
        'diluns',
        'dimars',
        "dim\xe8cres",
        "dij\xf2us",
        'divendres',
        'dissabte'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = 'nd';
            break;
        default:
            ordinal = 'en';
    }
    // feminine for year, week, hour, minute, second
    if (unit === 'year' || unit === 'week' || unit === 'hour' || unit === 'minute' || unit === 'second') ordinal += 'a';
    return number + ordinal;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7Jdl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7hSVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var locale = {
    code: 'pl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hUcoR","./_lib/formatLong/index.js":"hOw09","./_lib/formatRelative/index.js":"9vZl4","./_lib/localize/index.js":"lTzCJ","./_lib/match/index.js":"dvJum","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hUcoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function declension(scheme, count, time) {
    var group = declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var formatDistance = function formatDistance(token, count, options) {
    var scheme = formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + declension(scheme, count, 'future');
    else return declension(scheme, count, 'past') + ' temu';
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hOw09":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9vZl4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, _indexJsDefault.default)(date, baseDate, options)) adjectives = adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var formatRelativeLocale = {
    lastWeek: dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: dayAndTimeWithAdjective,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTzCJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dvJum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YsAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var locale = {
    code: 'pt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dFzs2","./_lib/formatLong/index.js":"fOfNz","./_lib/formatRelative/index.js":"iZFLh","./_lib/localize/index.js":"5NkCh","./_lib/match/index.js":"dO1Fr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFzs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fOfNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iZFLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5NkCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dO1Fr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cErTo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var locale = {
    code: 'pt-BR',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4gW7c","./_lib/formatLong/index.js":"7efy4","./_lib/formatRelative/index.js":"cVfsX","./_lib/localize/index.js":"dn48C","./_lib/match/index.js":"byl7t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gW7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7efy4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVfsX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dn48C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byl7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"loZ7k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var locale = {
    code: 'ro',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fGGr6","./_lib/formatLong/index.js":"93o5F","./_lib/formatRelative/index.js":"2QMps","./_lib/localize/index.js":"auw7y","./_lib/match/index.js":"7hapv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fGGr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93o5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2QMps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"auw7y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7hapv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"an5Rd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'ru',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"gys48","./_lib/formatLong/index.js":"lKJSK","./_lib/formatRelative/index.js":"iyWFf","./_lib/localize/index.js":"g5tB7","./_lib/match/index.js":"llGGc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gys48":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return declension(scheme.regular, count);
    };
}
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lKJSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyWFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g5tB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"llGGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ayYqD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var locale = {
    code: 'sk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dFoB2","./_lib/formatLong/index.js":"jtiHB","./_lib/formatRelative/index.js":"9pvcY","./_lib/localize/index.js":"lfDXA","./_lib/match/index.js":"bo592","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFoB2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function declension(scheme, count, time) {
    var group = declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var preposition = extractPreposition(token) || '';
    var key = lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return prefixPreposition(preposition) + 'o ' + suffixPreposition(preposition) + declension(scheme, count, 'future');
    else return prefixPreposition(preposition) + 'pred ' + suffixPreposition(preposition) + declension(scheme, count, 'past');
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtiHB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9pvcY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lfDXA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bo592":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEaez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var locale = {
    code: 'sl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5ZD1d","./_lib/formatLong/index.js":"beCb6","./_lib/formatRelative/index.js":"8GTPk","./_lib/localize/index.js":"anNxz","./_lib/match/index.js":"eeV7e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5ZD1d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isPluralType(val) {
    return val.one !== undefined;
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: 'manj kot {{count}} sekunda',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        },
        past: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundama',
            few: 'manj kot {{count}} sekundami',
            other: 'manj kot {{count}} sekundami'
        },
        future: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        }
    },
    xSeconds: {
        present: {
            one: '{{count}} sekunda',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        },
        past: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundama',
            few: '{{count}} sekundami',
            other: '{{count}} sekundami'
        },
        future: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        }
    },
    halfAMinute: 'pol minute',
    lessThanXMinutes: {
        present: {
            one: 'manj kot {{count}} minuta',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        },
        past: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minutama',
            few: 'manj kot {{count}} minutami',
            other: 'manj kot {{count}} minutami'
        },
        future: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        }
    },
    xMinutes: {
        present: {
            one: '{{count}} minuta',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        },
        past: {
            one: '{{count}} minuto',
            two: '{{count}} minutama',
            few: '{{count}} minutami',
            other: '{{count}} minutami'
        },
        future: {
            one: '{{count}} minuto',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: '{{count}} ura',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        },
        past: {
            one: '{{count}} uro',
            two: '{{count}} urama',
            few: '{{count}} urami',
            other: '{{count}} urami'
        },
        future: {
            one: '{{count}} uro',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        }
    },
    xDays: {
        present: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        },
        past: {
            one: '{{count}} dnem',
            two: '{{count}} dnevoma',
            few: '{{count}} dnevi',
            other: '{{count}} dnevi'
        },
        future: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: '{{count}} teden',
        two: '{{count}} tedna',
        few: '{{count}} tedne',
        other: '{{count}} tednov'
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} meseci',
            other: '{{count}} mesecev'
        },
        past: {
            one: '{{count}} mesecem',
            two: '{{count}} mesecema',
            few: '{{count}} meseci',
            other: '{{count}} meseci'
        },
        future: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} mesece',
            other: '{{count}} mesecev'
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        },
        past: {
            one: '{{count}} letom',
            two: '{{count}} letoma',
            few: '{{count}} leti',
            other: '{{count}} leti'
        },
        future: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        },
        past: {
            one: 'skoraj {{count}} letom',
            two: 'skoraj {{count}} letoma',
            few: 'skoraj {{count}} leti',
            other: 'skoraj {{count}} leti'
        },
        future: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        }
    }
};
function getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
        case 4:
            return 'few';
        default:
            return 'other';
    }
}
var formatDistance = function formatDistance(token, count, options) {
    var result = '';
    var tense = 'present';
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = 'future';
            result = "\u010Dez ";
        } else {
            tense = 'past';
            result = 'pred ';
        }
    }
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result += tokenValue;
    else {
        var form = getFormFromCount(count);
        if (isPluralType(tokenValue)) result += tokenValue[form].replace('{{count}}', String(count));
        else result += tokenValue[tense][form].replace('{{count}}', String(count));
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beCb6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd. MMMM y',
    long: 'dd. MMMM y',
    medium: 'd. MMM y',
    short: 'd. MM. yy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8GTPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"anNxz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'avg.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marec',
        'april',
        'maj',
        'junij',
        'julij',
        'avgust',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'n',
        'p',
        't',
        's',
        "\u010D",
        'p',
        's'
    ],
    short: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    abbreviated: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    wide: [
        'nedelja',
        'ponedeljek',
        'torek',
        'sreda',
        "\u010Detrtek",
        'petek',
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'j',
        afternoon: 'p',
        evening: 'v',
        night: 'n'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'poln.',
        noon: 'pold.',
        morning: 'jut.',
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "polno\u010D",
        noon: 'poldne',
        morning: 'jutro',
        afternoon: 'popoldne',
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'zj',
        afternoon: 'p',
        evening: 'zv',
        night: 'po'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'opoln.',
        noon: 'opold.',
        morning: 'zjut.',
        afternoon: 'pop.',
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "opolno\u010Di",
        noon: 'opoldne',
        morning: 'zjutraj',
        afternoon: 'popoldan',
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eeV7e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3XCK6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var locale = {
    code: 'sq',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"cAZO1","./_lib/formatLong/index.js":"f0UCY","./_lib/formatRelative/index.js":"hQkJP","./_lib/localize/index.js":"4yHeP","./_lib/match/index.js":"jtrmP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cAZO1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: '{{count}} sekonda'
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: 'rreth 1 muaj',
        other: 'rreth {{count}} muaj'
    },
    xMonths: {
        one: '1 muaj',
        other: '{{count}} muaj'
    },
    aboutXYears: {
        one: 'rreth 1 vit',
        other: 'rreth {{count}} vite'
    },
    xYears: {
        one: '1 vit',
        other: '{{count}} vite'
    },
    overXYears: {
        one: 'mbi 1 vit',
        other: 'mbi {{count}} vite'
    },
    almostXYears: {
        one: 'pothuajse 1 vit',
        other: 'pothuajse {{count}} vite'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f0UCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hQkJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4yHeP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'P',
        'M'
    ],
    abbreviated: [
        'PK',
        'MK'
    ],
    wide: [
        'Para Krishtit',
        'Mbas Krishtit'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '4-mujori I',
        '4-mujori II',
        '4-mujori III',
        '4-mujori IV'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'S',
        'M',
        'P',
        'M',
        'Q',
        'K',
        'G',
        'S',
        'T',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Shk',
        'Mar',
        'Pri',
        'Maj',
        'Qer',
        'Kor',
        'Gus',
        'Sht',
        'Tet',
        "N\xebn",
        'Dhj'
    ],
    wide: [
        'Janar',
        'Shkurt',
        'Mars',
        'Prill',
        'Maj',
        'Qershor',
        'Korrik',
        'Gusht',
        'Shtator',
        'Tetor',
        "N\xebntor",
        'Dhjetor'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'H',
        'M',
        'M',
        'E',
        'P',
        'S'
    ],
    short: [
        'Di',
        "H\xeb",
        'Ma',
        "M\xeb",
        'En',
        'Pr',
        'Sh'
    ],
    abbreviated: [
        'Die',
        "H\xebn",
        'Mar',
        "M\xebr",
        'Enj',
        'Pre',
        'Sht'
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        'Enjte',
        'Premte',
        "Shtun\xeb"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "m\xebngjes",
        afternoon: 'dite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'hour') return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + 't';
    return number + "-t\xeb";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtrmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c4a5E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var locale = {
    code: 'sr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dGC8E","./_lib/formatLong/index.js":"lzxOZ","./_lib/formatRelative/index.js":"lQCtP","./_lib/localize/index.js":"i6tTO","./_lib/match/index.js":"ag5kV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGC8E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lzxOZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lQCtP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6tTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ag5kV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4qSpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var locale = {
    code: 'sr-Latn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"byZA8","./_lib/formatLong/index.js":"fP4dO","./_lib/formatRelative/index.js":"5xpjE","./_lib/localize/index.js":"2HutN","./_lib/match/index.js":"aOq2K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byZA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
        },
        dual: 'oko {{count}} nedelje',
        other: 'oko {{count}} nedelje'
    },
    xWeeks: {
        one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
        },
        dual: '{{count}} nedelje',
        other: '{{count}} nedelje'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
        },
        dual: 'oko {{count}} meseca',
        other: 'oko {{count}} meseci'
    },
    xMonths: {
        one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
        },
        dual: '{{count}} meseca',
        other: '{{count}} meseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'pre ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fP4dO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5xpjE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2HutN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Pre Hrista',
        'Posle Hrista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedelja',
        'ponedeljak',
        'utorak',
        'sreda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOq2K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8S82i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var locale = {
    code: 'sv',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4rBGt","./_lib/formatLong/index.js":"9HbmU","./_lib/formatRelative/index.js":"kZoIX","./_lib/localize/index.js":"dL8J3","./_lib/match/index.js":"dPvqq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4rBGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HbmU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZoIX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dL8J3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPvqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l6qRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var locale = {
    code: 'ta',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hAwVK","./_lib/formatLong/index.js":"aaIrr","./_lib/formatRelative/index.js":"70qKo","./_lib/localize/index.js":"dWsVi","./_lib/match/index.js":"2c9Oc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAwVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isPluralType(val) {
    return val.one !== undefined;
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? 'in' : 'ago' : 'default';
    var tokenValue = formatDistanceLocale[token];
    if (!isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aaIrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// CLDR #1846 - #1849
var dateFormats = {
    full: 'EEEE, d MMMM, y',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'd/M/yy'
};
// CLDR #1850 - #1853
var timeFormats = {
    full: 'a h:mm:ss zzzz',
    long: 'a h:mm:ss z',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70qKo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dWsVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2c9Oc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvwZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var locale = {
    code: 'te',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"enIuw","./_lib/formatLong/index.js":"j1mKE","./_lib/formatRelative/index.js":"f37Nj","./_lib/localize/index.js":"4DeQF","./_lib/match/index.js":"aRIEI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enIuw":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j1mKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// CLDR #1807 - #1811
var dateFormats = {
    full: 'd, MMMM y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd-MM-yy'
};
// CLDR #1807 - #1811
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
// CLDR #1815 - #1818
var dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f37Nj":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4DeQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRIEI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81s8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var locale = {
    code: 'th',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3pAeA","./_lib/formatLong/index.js":"jawL3","./_lib/formatRelative/index.js":"loAw0","./_lib/localize/index.js":"ePmxs","./_lib/match/index.js":"drGtC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pAeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === 'halfAMinute') return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jawL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'medium'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"loAw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePmxs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        "\u0E04\u0E28"
    ],
    abbreviated: [
        'BC',
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"drGtC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^\d+/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3zlpo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var locale = {
    code: 'tr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"cFEnt","./_lib/formatLong/index.js":"hLwA7","./_lib/formatRelative/index.js":"h4UuC","./_lib/localize/index.js":"4SHUj","./_lib/match/index.js":"5wFxm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cFEnt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLwA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4UuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SHUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5wFxm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"crzEv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var locale = {
    code: 'ug',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5DXCS","./_lib/formatLong/index.js":"dfZKH","./_lib/formatRelative/index.js":"cw1yj","./_lib/localize/index.js":"h3gpF","./_lib/match/index.js":"jTOVE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5DXCS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dfZKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cw1yj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h3gpF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1',
        '2',
        '3',
        '4'
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jTOVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oawC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var locale = {
    code: 'uk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"aXZMq","./_lib/formatLong/index.js":"awXqT","./_lib/formatRelative/index.js":"aCoJC","./_lib/localize/index.js":"3nFiB","./_lib/match/index.js":"8xZNz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXZMq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u0437\u0430 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAtMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"awXqT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCoJC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"btU8f","../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nFiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === 'date') {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === 'minute' || unit === 'second' || unit === 'hour') suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xZNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2yIqt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var locale = {
    code: 'uz',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7Cx0u","./_lib/formatLong/index.js":"luPuP","./_lib/formatRelative/index.js":"ilQlU","./_lib/localize/index.js":"8nbTU","./_lib/match/index.js":"cjIph","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Cx0u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'sekunddan kam',
        other: '{{count}} sekunddan kam'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'yarim minut',
    lessThanXMinutes: {
        one: 'bir minutdan kam',
        other: '{{count}} minutdan kam'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: 'tahminan 1 soat',
        other: 'tahminan {{count}} soat'
    },
    xHours: {
        one: '1 soat',
        other: '{{count}} soat'
    },
    xDays: {
        one: '1 kun',
        other: '{{count}} kun'
    },
    aboutXWeeks: {
        one: 'tahminan 1 hafta',
        other: 'tahminan {{count}} hafta'
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: 'tahminan 1 oy',
        other: 'tahminan {{count}} oy'
    },
    xMonths: {
        one: '1 oy',
        other: '{{count}} oy'
    },
    aboutXYears: {
        one: 'tahminan 1 yil',
        other: 'tahminan {{count}} yil'
    },
    xYears: {
        one: '1 yil',
        other: '{{count}} yil'
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: 'deyarli 1 yil',
        other: 'deyarli {{count}} yil'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' dan keyin';
        else return result + ' oldin';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"luPuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss zzzz',
    long: 'h:mm:ss z',
    medium: 'h:mm:ss',
    short: 'h:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ilQlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nbTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'M.A',
        'M.'
    ],
    abbreviated: [
        'M.A',
        'M.'
    ],
    wide: [
        'Miloddan Avvalgi',
        'Milodiy'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'CH.1',
        'CH.2',
        'CH.3',
        'CH.4'
    ],
    wide: [
        '1-chi chorak',
        '2-chi chorak',
        '3-chi chorak',
        '4-chi chorak'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        'Iyun',
        'Iyul',
        'Avg',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentabr',
        'Oktabr',
        'Noyabr',
        'Dekabr'
    ]
};
var dayValues = {
    narrow: [
        'Y',
        'D',
        'S',
        'CH',
        'P',
        'J',
        'SH'
    ],
    short: [
        'Ya',
        'Du',
        'Se',
        'Cho',
        'Pa',
        'Ju',
        'Sha'
    ],
    abbreviated: [
        'Yak',
        'Dush',
        'Sesh',
        'Chor',
        'Pay',
        'Jum',
        'Shan'
    ],
    wide: [
        'Yakshanba',
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cjIph":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5OQW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var locale = {
    code: 'uz-Cyrl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"k9kQZ","./_lib/formatLong/index.js":"h9bvt","./_lib/formatRelative/index.js":"iAqDL","./_lib/localize/index.js":"8hFSh","./_lib/match/index.js":"35Ay1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k9kQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h9bvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iAqDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8hFSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'any'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"35Ay1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2GiK8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var locale = {
    code: 'vi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"guYlS","./_lib/formatLong/index.js":"3XLYh","./_lib/formatRelative/index.js":"8tTWc","./_lib/localize/index.js":"04kSe","./_lib/match/index.js":"34goi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"guYlS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3XLYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: '{{date}} {{time}}',
    // ngày 25 tháng 08 năm 2017 23:25
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8tTWc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04kSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var eraValues = {
    narrow: [
        'TCN',
        'SCN'
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        'sau CN'
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'Thg 1',
        'Thg 2',
        'Thg 3',
        'Thg 4',
        'Thg 5',
        'Thg 6',
        'Thg 7',
        'Thg 8',
        'Thg 9',
        'Thg 10',
        'Thg 11',
        'Thg 12'
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var formattingMonthValues = {
    narrow: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'thg 1',
        'thg 2',
        'thg 3',
        'thg 4',
        'thg 5',
        'thg 6',
        'thg 7',
        'thg 8',
        'thg 9',
        'thg 10',
        'thg 11',
        'thg 12'
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var dayValues = {
    narrow: [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ],
    short: [
        'CN',
        'Th 2',
        'Th 3',
        'Th 4',
        'Th 5',
        'Th 6',
        'Th 7'
    ],
    abbreviated: [
        'CN',
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'quarter') // many news outlets use "quý I"...
    switch(number){
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
    }
    else if (unit === 'day') // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === 'week') {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === 'dayOfYear') {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34goi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5iego":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var locale = {
    code: 'zh-CN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"falKS","./_lib/formatLong/index.js":"5FYcD","./_lib/formatRelative/index.js":"50hYR","./_lib/localize/index.js":"3cu3e","./_lib/match/index.js":"fph5p","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"falKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5FYcD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50hYR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var formatRelativeLocale = {
    lastWeek: checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"eMkKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cu3e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fph5p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gI19e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var locale = {
    code: 'zh-HK',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5VIel","./_lib/formatLong/index.js":"jYWrr","./_lib/formatRelative/index.js":"9CXVw","./_lib/localize/index.js":"7RpD0","./_lib/match/index.js":"fg6gs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5VIel":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYWrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9CXVw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7RpD0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fg6gs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8NIxK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var locale = {
    code: 'zh-TW',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"llg2u","./_lib/formatLong/index.js":"4d4yw","./_lib/formatRelative/index.js":"hemIl","./_lib/localize/index.js":"lq0d1","./_lib/match/index.js":"knt6a","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"llg2u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4d4yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"begpu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hemIl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lq0d1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"apnSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knt6a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"8m1gR","../../../_lib/buildMatchPatternFn/index.js":"imsfL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"63bhO":[function() {},{}],"dyW9k":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _class, _temp2;
exports.confirmAlert = confirmAlert;
var _react = require("519f0ac8a347dac6");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("ce77b7fc3324c7e2");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactDom = require("abf9c13416b09086");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ReactConfirmAlert = (_temp2 = _class = function(_Component) {
    _inherits(ReactConfirmAlert, _Component);
    function ReactConfirmAlert() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, ReactConfirmAlert);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactConfirmAlert.__proto__ || Object.getPrototypeOf(ReactConfirmAlert)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleClickButton = function(button) {
            if (button.onClick) button.onClick();
            _this.close();
        }, _this.handleClickOverlay = function(e) {
            var _this$props = _this.props, closeOnClickOutside = _this$props.closeOnClickOutside, onClickOutside = _this$props.onClickOutside;
            var isClickOutside = e.target === _this.overlay;
            if (closeOnClickOutside && isClickOutside) {
                onClickOutside();
                _this.close();
            }
        }, _this.close = function() {
            var afterClose = _this.props.afterClose;
            removeBodyClass();
            removeElementReconfirm();
            removeSVGBlurReconfirm(afterClose);
        }, _this.keyboardClose = function(event) {
            var _this$props2 = _this.props, closeOnEscape = _this$props2.closeOnEscape, onKeypressEscape = _this$props2.onKeypressEscape, keyCodeForClose = _this$props2.keyCodeForClose;
            var keyCode = event.keyCode;
            var isKeyCodeEscape = keyCode === 27;
            if (keyCodeForClose.includes(keyCode)) _this.close();
            if (closeOnEscape && isKeyCodeEscape) {
                onKeypressEscape(event);
                _this.close();
            }
        }, _this.componentDidMount = function() {
            document.addEventListener('keydown', _this.keyboardClose, false);
        }, _this.componentWillUnmount = function() {
            document.removeEventListener('keydown', _this.keyboardClose, false);
            _this.props.willUnmount();
        }, _this.renderCustomUI = function() {
            var _this$props3 = _this.props, title = _this$props3.title, message = _this$props3.message, buttons = _this$props3.buttons, customUI = _this$props3.customUI;
            var dataCustomUI = {
                title: title,
                message: message,
                buttons: buttons,
                onClose: _this.close
            };
            return customUI(dataCustomUI);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(ReactConfirmAlert, [
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, title = _props.title, message = _props.message, buttons = _props.buttons, childrenElement = _props.childrenElement, customUI = _props.customUI, overlayClassName = _props.overlayClassName;
                return _react2.default.createElement('div', {
                    className: 'react-confirm-alert-overlay ' + overlayClassName,
                    ref: function ref(dom) {
                        return _this2.overlay = dom;
                    },
                    onClick: this.handleClickOverlay
                }, _react2.default.createElement('div', {
                    className: 'react-confirm-alert'
                }, customUI ? this.renderCustomUI() : _react2.default.createElement('div', {
                    className: 'react-confirm-alert-body'
                }, title && _react2.default.createElement('h1', null, title), message, childrenElement(), _react2.default.createElement('div', {
                    className: 'react-confirm-alert-button-group'
                }, buttons.map(function(button, i) {
                    return _react2.default.createElement('button', {
                        key: i,
                        onClick: function onClick() {
                            return _this2.handleClickButton(button);
                        },
                        className: button.className
                    }, button.label);
                })))));
            }
        }
    ]);
    return ReactConfirmAlert;
}(_react.Component), _class.propTypes = {
    title: _propTypes2.default.string,
    message: _propTypes2.default.string,
    buttons: _propTypes2.default.array.isRequired,
    childrenElement: _propTypes2.default.func,
    customUI: _propTypes2.default.func,
    closeOnClickOutside: _propTypes2.default.bool,
    closeOnEscape: _propTypes2.default.bool,
    keyCodeForClose: _propTypes2.default.arrayOf(_propTypes2.default.number),
    willUnmount: _propTypes2.default.func,
    afterClose: _propTypes2.default.func,
    onClickOutside: _propTypes2.default.func,
    onKeypressEscape: _propTypes2.default.func,
    overlayClassName: _propTypes2.default.string
}, _class.defaultProps = {
    buttons: [
        {
            label: 'Cancel',
            onClick: function onClick() {
                return null;
            },
            className: null
        },
        {
            label: 'Confirm',
            onClick: function onClick() {
                return null;
            },
            className: null
        }
    ],
    childrenElement: function childrenElement() {
        return null;
    },
    closeOnClickOutside: true,
    closeOnEscape: true,
    keyCodeForClose: [],
    willUnmount: function willUnmount() {
        return null;
    },
    afterClose: function afterClose() {
        return null;
    },
    onClickOutside: function onClickOutside() {
        return null;
    },
    onKeypressEscape: function onKeypressEscape() {
        return null;
    }
}, _temp2);
exports.default = ReactConfirmAlert;
function createSVGBlurReconfirm() {
    // If has svg ignore to create the svg
    var svg = document.getElementById('react-confirm-alert-firm-svg');
    if (svg) return;
    var svgNS = 'http://www.w3.org/2000/svg';
    var feGaussianBlur = document.createElementNS(svgNS, 'feGaussianBlur');
    feGaussianBlur.setAttribute('stdDeviation', '0.3');
    var filter = document.createElementNS(svgNS, 'filter');
    filter.setAttribute('id', 'gaussian-blur');
    filter.appendChild(feGaussianBlur);
    var svgElem = document.createElementNS(svgNS, 'svg');
    svgElem.setAttribute('id', 'react-confirm-alert-firm-svg');
    svgElem.setAttribute('class', 'react-confirm-alert-svg');
    svgElem.appendChild(filter);
    document.body.appendChild(svgElem);
}
function removeSVGBlurReconfirm(afterClose) {
    var svg = document.getElementById('react-confirm-alert-firm-svg');
    if (svg) svg.parentNode.removeChild(svg);
    document.body.children[0].classList.remove('react-confirm-alert-blur');
    afterClose();
}
function createElementReconfirm(properties) {
    var divTarget = document.getElementById('react-confirm-alert');
    if (divTarget) // Rerender - the mounted ReactConfirmAlert
    (0, _reactDom.render)(_react2.default.createElement(ReactConfirmAlert, properties), divTarget);
    else {
        // Mount the ReactConfirmAlert component
        document.body.children[0].classList.add('react-confirm-alert-blur');
        divTarget = document.createElement('div');
        divTarget.id = 'react-confirm-alert';
        document.body.appendChild(divTarget);
        (0, _reactDom.render)(_react2.default.createElement(ReactConfirmAlert, properties), divTarget);
    }
}
function removeElementReconfirm() {
    var target = document.getElementById('react-confirm-alert');
    if (target) {
        (0, _reactDom.unmountComponentAtNode)(target);
        target.parentNode.removeChild(target);
    }
}
function addBodyClass() {
    document.body.classList.add('react-confirm-alert-body-element');
}
function removeBodyClass() {
    document.body.classList.remove('react-confirm-alert-body-element');
}
function confirmAlert(properties) {
    addBodyClass();
    createSVGBlurReconfirm();
    createElementReconfirm(properties);
}

},{"519f0ac8a347dac6":"9njXz","ce77b7fc3324c7e2":"bnNSm","abf9c13416b09086":"2ApDx"}],"j36cq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateManager", ()=>(0, _useStateManager7E1E8489EsmJs.u));
parcelHelpers.export(exports, "createFilter", ()=>(0, _selectAab027F3EsmJs.c));
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _selectAab027F3EsmJs.d));
parcelHelpers.export(exports, "mergeStyles", ()=>(0, _selectAab027F3EsmJs.m));
parcelHelpers.export(exports, "components", ()=>(0, _index641Ee5B8EsmJs.c));
parcelHelpers.export(exports, "NonceProvider", ()=>NonceProvider);
parcelHelpers.export(exports, "default", ()=>StateManagedSelect$1);
var _useStateManager7E1E8489EsmJs = require("./useStateManager-7e1e8489.esm.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _selectAab027F3EsmJs = require("./Select-aab027f3.esm.js");
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _index641Ee5B8EsmJs = require("./index-641ee5b8.esm.js");
var _objectSpread2 = require("@babel/runtime/helpers/objectSpread2");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");
var _createClass = require("@babel/runtime/helpers/createClass");
var _inherits = require("@babel/runtime/helpers/inherits");
var _createSuper = require("@babel/runtime/helpers/createSuper");
var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _memoizeOne = require("memoize-one");
var _typeof = require("@babel/runtime/helpers/typeof");
var _taggedTemplateLiteral = require("@babel/runtime/helpers/taggedTemplateLiteral");
var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var StateManagedSelect = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, _useStateManager7E1E8489EsmJs.u)(props);
    return /*#__PURE__*/ _react.createElement((0, _selectAab027F3EsmJs.S), (0, _extendsDefault.default)({
        ref: ref
    }, baseSelectProps));
});
var StateManagedSelect$1 = StateManagedSelect;
var NonceProvider = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, _react.useMemo)(function() {
        return (0, _cacheDefault.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ _react.createElement((0, _react1.CacheProvider), {
        value: emotionCache
    }, children);
};

},{"./useStateManager-7e1e8489.esm.js":"DxpkG","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","./Select-aab027f3.esm.js":"6lk0u","@emotion/react":"lIeII","@emotion/cache":"r7hGp","./index-641ee5b8.esm.js":"yt2FF","@babel/runtime/helpers/objectSpread2":"TY7Mr","@babel/runtime/helpers/slicedToArray":"cSV7V","@babel/runtime/helpers/objectWithoutProperties":"5xa1i","@babel/runtime/helpers/classCallCheck":"6C9u8","@babel/runtime/helpers/createClass":"g9J5L","@babel/runtime/helpers/inherits":"43peb","@babel/runtime/helpers/createSuper":"ayUOk","@babel/runtime/helpers/toConsumableArray":"c2UGM","memoize-one":"jucOx","@babel/runtime/helpers/typeof":"979to","@babel/runtime/helpers/taggedTemplateLiteral":"cpSDa","@babel/runtime/helpers/defineProperty":"hjdoh","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"DxpkG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "u", ()=>useStateManager);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _react = require("react");
var _excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function useStateManager(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    var _useState = (0, _react.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, _react.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, _react.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, _react.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, _react.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, _react.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/slicedToArray":"idCNq","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"idCNq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_slicedToArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(r, e) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayLimitJsDefault.default)(r, e) || (0, _unsupportedIterableToArrayJsDefault.default)(r, e) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"81tIH","./iterableToArrayLimit.js":"8js8z","./unsupportedIterableToArray.js":"K5PcV","./nonIterableRest.js":"7uBRd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"81tIH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8js8z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArrayLimit);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7uBRd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aFSss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutProperties);
var _objectWithoutPropertiesLooseJs = require("./objectWithoutPropertiesLoose.js");
var _objectWithoutPropertiesLooseJsDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLooseJs);
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = (0, _objectWithoutPropertiesLooseJsDefault.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

},{"./objectWithoutPropertiesLoose.js":"jGdYV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6lk0u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>Select);
parcelHelpers.export(exports, "a", ()=>defaultProps);
parcelHelpers.export(exports, "b", ()=>getOptionLabel$1);
parcelHelpers.export(exports, "c", ()=>createFilter);
parcelHelpers.export(exports, "d", ()=>defaultTheme);
parcelHelpers.export(exports, "g", ()=>getOptionValue$1);
parcelHelpers.export(exports, "m", ()=>mergeStyles);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _index641Ee5B8EsmJs = require("./index-641ee5b8.esm.js");
var _react1 = require("@emotion/react");
var _memoizeOne = require("memoize-one");
var _memoizeOneDefault = parcelHelpers.interopDefault(_memoizeOne);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var _ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var A11yText = function A11yText(props) {
    return (0, _react1.jsx)("span", (0, _extendsDefault.default)({
        css: _ref
    }, props));
};
var A11yText$1 = A11yText;
var defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, _react.useMemo)(function() {
        return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, _react.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, _objectSpread2Default.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, _react.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, _react.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, _react.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, _react1.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, _react1.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, _react1.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, _react1.jsx)((0, _react.Fragment), null, (0, _react1.jsx)(A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, _react1.jsx)(A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var LiveRegion$1 = LiveRegion;
var diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var anyDiacritic = new RegExp('[' + diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};
for(var i = 0; i < diacritics.length; i++){
    var diacritic = diacritics[i];
    for(var j = 0; j < diacritic.letters.length; j++)diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
var stripDiacritics = function stripDiacritics(str) {
    return str.replace(anyDiacritic, function(match) {
        return diacriticToBase[match];
    });
};
var memoizedStripDiacriticsForInput = (0, _memoizeOneDefault.default)(stripDiacritics);
var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var createFilter = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, _objectSpread2Default.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? trimString(rawInput) : rawInput;
        var candidate = trim ? trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = memoizedStripDiacriticsForInput(input);
            candidate = stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var _excluded = [
    "innerRef"
];
function DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, _index641Ee5B8EsmJs.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, _react1.jsx)("input", (0, _extendsDefault.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, _react1.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, _react.useRef)(false);
    var isTop = (0, _react.useRef)(false);
    var touchStart = (0, _react.useRef)(0);
    var scrollTarget = (0, _react.useRef)(null);
    var handleEventDelta = (0, _react.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, _react.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, _react.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, _react.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, _index641Ee5B8EsmJs.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, _react.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function preventTouchMove(e) {
    if (e.cancelable) e.preventDefault();
}
function allowTouchMove(e) {
    e.stopPropagation();
}
function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
    capture: false,
    passive: false
};
function useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, _react.useRef)({});
    var scrollTarget = (0, _react.useRef)(null);
    var addScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys(LOCK_STYLES).forEach(function(key) {
                var val = LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', preventTouchMove, listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
        // increment active scroll locks
        activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, _react.useCallback)(function(touchScrollTarget) {
        if (!canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        activeScrollLocks = Math.max(activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && activeScrollLocks < 1) STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && isTouchDevice()) {
            target.removeEventListener('touchmove', preventTouchMove, listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, _react.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var _ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, _react1.jsx)((0, _react.Fragment), null, lockEnabled && (0, _react1.jsx)("div", {
        onClick: blurSelectInput,
        css: _ref2$1
    }), children(targetRef));
}
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var _ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, _react1.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: _ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var RequiredInput$1 = RequiredInput;
/// <reference types="user-agent-data-types" />
function testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function isIPhone() {
    return testPlatform(/^iPhone/i);
}
function isMac() {
    return testPlatform(/^Mac/i);
}
function isIPad() {
    return testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    isMac() && navigator.maxTouchPoints > 1;
}
function isIOS() {
    return isIPhone() || isIPad();
}
function isAppleDevice() {
    return isMac() || isIOS();
}
var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var getOptionLabel$1 = function getOptionLabel(option) {
    return option.label;
};
var getOptionValue$1 = function getOptionValue(option) {
    return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var defaultStyles = {
    clearIndicator: (0, _index641Ee5B8EsmJs.a),
    container: (0, _index641Ee5B8EsmJs.b),
    control: (0, _index641Ee5B8EsmJs.d),
    dropdownIndicator: (0, _index641Ee5B8EsmJs.e),
    group: (0, _index641Ee5B8EsmJs.g),
    groupHeading: (0, _index641Ee5B8EsmJs.f),
    indicatorsContainer: (0, _index641Ee5B8EsmJs.i),
    indicatorSeparator: (0, _index641Ee5B8EsmJs.h),
    input: (0, _index641Ee5B8EsmJs.j),
    loadingIndicator: (0, _index641Ee5B8EsmJs.l),
    loadingMessage: (0, _index641Ee5B8EsmJs.k),
    menu: (0, _index641Ee5B8EsmJs.m),
    menuList: (0, _index641Ee5B8EsmJs.n),
    menuPortal: (0, _index641Ee5B8EsmJs.o),
    multiValue: (0, _index641Ee5B8EsmJs.p),
    multiValueLabel: (0, _index641Ee5B8EsmJs.q),
    multiValueRemove: (0, _index641Ee5B8EsmJs.t),
    noOptionsMessage: (0, _index641Ee5B8EsmJs.u),
    option: (0, _index641Ee5B8EsmJs.v),
    placeholder: (0, _index641Ee5B8EsmJs.w),
    singleValue: (0, _index641Ee5B8EsmJs.x),
    valueContainer: (0, _index641Ee5B8EsmJs.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function mergeStyles(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, _objectSpread2Default.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var baseUnit = 4;
// The minimum height of the control
var controlHeight = 38;
// The amount of space between the control and menu */
var menuGutter = baseUnit * 2;
var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
};
var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors,
    spacing: spacing
};
var defaultProps = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, _index641Ee5B8EsmJs.z)(),
    captureMenuScroll: !(0, _index641Ee5B8EsmJs.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel$1,
    getOptionValue: getOptionValue$1,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, _index641Ee5B8EsmJs.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = _isOptionDisabled(props, option, selectValue);
    var isSelected = _isOptionSelected(props, option, selectValue);
    var label = getOptionLabel(props, option);
    var value = getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, _index641Ee5B8EsmJs.K));
}
function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, _toConsumableArrayDefault.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function buildFocusableOptions(props, selectValue) {
    return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}
function isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function _isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function _isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = getOptionValue(props, option);
    return selectValue.some(function(i) {
        return getOptionValue(props, i) === candidate;
    });
}
function _filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var instanceId = 1;
var Select = /*#__PURE__*/ function(_Component) {
    (0, _inheritsDefault.default)(Select, _Component);
    var _super = (0, _createSuperDefault.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, _classCallCheckDefault.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, _index641Ee5B8EsmJs.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, _index641Ee5B8EsmJs.B)([].concat((0, _toConsumableArrayDefault.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, _index641Ee5B8EsmJs.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, _index641Ee5B8EsmJs.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, _index641Ee5B8EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, _index641Ee5B8EsmJs.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, _index641Ee5B8EsmJs.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return buildFocusableOptionsWithIds(buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, _index641Ee5B8EsmJs.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, _index641Ee5B8EsmJs.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, _objectSpread2Default.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, _index641Ee5B8EsmJs.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
        _this.state.selectValue = (0, _index641Ee5B8EsmJs.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, _createClassDefault.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, _index641Ee5B8EsmJs.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, _index641Ee5B8EsmJs.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return defaultTheme;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme(defaultTheme);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultTheme), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return _isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return _isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return _filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ _react.createElement(DummyInput, (0, _extendsDefault.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, _index641Ee5B8EsmJs.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ _react.createElement(Input, (0, _extendsDefault.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ _react.createElement(Placeholder, (0, _extendsDefault.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ _react.createElement(MultiValue, (0, _extendsDefault.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ _react.createElement(SingleValue, (0, _extendsDefault.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(ClearIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(LoadingIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ _react.createElement(IndicatorSeparator, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ _react.createElement(DropdownIndicator, (0, _extendsDefault.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ _react.createElement(Option, (0, _extendsDefault.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ _react.createElement(Group, (0, _extendsDefault.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ _react.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ _react.createElement((0, _index641Ee5B8EsmJs.M), (0, _extendsDefault.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ _react.createElement(Menu, (0, _extendsDefault.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ _react.createElement(ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ _react.createElement(MenuList, (0, _extendsDefault.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ _react.createElement(MenuPortal, (0, _extendsDefault.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ _react.createElement(RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ _react.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ _react.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ _react.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ _react.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ _react.createElement(LiveRegion$1, (0, _extendsDefault.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ _react.createElement(SelectContainer, (0, _extendsDefault.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ _react.createElement(Control, (0, _extendsDefault.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ _react.createElement(ValueContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ _react.createElement(IndicatorsContainer, (0, _extendsDefault.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, _index641Ee5B8EsmJs.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? buildFocusableOptionsWithIds(buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, _index641Ee5B8EsmJs.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, _react.Component));
Select.defaultProps = defaultProps;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/classCallCheck":"chhAr","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/inherits":"6oM96","@babel/runtime/helpers/esm/createSuper":"4Qcqa","@babel/runtime/helpers/esm/toConsumableArray":"iT0h5","react":"9njXz","./index-641ee5b8.esm.js":"yt2FF","@emotion/react":"lIeII","memoize-one":"jucOx","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iT0h5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toConsumableArray);
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(r) {
    return (0, _arrayWithoutHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"1M61l","./iterableToArray.js":"isHxT","./unsupportedIterableToArray.js":"K5PcV","./nonIterableSpread.js":"8TA3X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1M61l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithoutHoles);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return (0, _arrayLikeToArrayJsDefault.default)(r);
}

},{"./arrayLikeToArray.js":"enjjy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"isHxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TA3X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableSpread);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"yt2FF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>isMobileDevice);
parcelHelpers.export(exports, "B", ()=>multiValueAsValue);
parcelHelpers.export(exports, "C", ()=>singleValueAsValue);
parcelHelpers.export(exports, "D", ()=>valueTernary);
parcelHelpers.export(exports, "E", ()=>classNames);
parcelHelpers.export(exports, "F", ()=>defaultComponents);
parcelHelpers.export(exports, "G", ()=>isDocumentElement);
parcelHelpers.export(exports, "H", ()=>cleanValue);
parcelHelpers.export(exports, "I", ()=>scrollIntoView);
parcelHelpers.export(exports, "J", ()=>noop);
parcelHelpers.export(exports, "K", ()=>notNullish);
parcelHelpers.export(exports, "L", ()=>handleInputChange);
parcelHelpers.export(exports, "M", ()=>MenuPlacer);
parcelHelpers.export(exports, "a", ()=>clearIndicatorCSS);
parcelHelpers.export(exports, "b", ()=>containerCSS);
parcelHelpers.export(exports, "c", ()=>components);
parcelHelpers.export(exports, "d", ()=>css$1);
parcelHelpers.export(exports, "e", ()=>dropdownIndicatorCSS);
parcelHelpers.export(exports, "f", ()=>groupHeadingCSS);
parcelHelpers.export(exports, "g", ()=>groupCSS);
parcelHelpers.export(exports, "h", ()=>indicatorSeparatorCSS);
parcelHelpers.export(exports, "i", ()=>indicatorsContainerCSS);
parcelHelpers.export(exports, "j", ()=>inputCSS);
parcelHelpers.export(exports, "k", ()=>loadingMessageCSS);
parcelHelpers.export(exports, "l", ()=>loadingIndicatorCSS);
parcelHelpers.export(exports, "m", ()=>menuCSS);
parcelHelpers.export(exports, "n", ()=>menuListCSS);
parcelHelpers.export(exports, "o", ()=>menuPortalCSS);
parcelHelpers.export(exports, "p", ()=>multiValueCSS);
parcelHelpers.export(exports, "q", ()=>multiValueLabelCSS);
parcelHelpers.export(exports, "r", ()=>removeProps);
parcelHelpers.export(exports, "s", ()=>supportsPassiveEvents);
parcelHelpers.export(exports, "t", ()=>multiValueRemoveCSS);
parcelHelpers.export(exports, "u", ()=>noOptionsMessageCSS);
parcelHelpers.export(exports, "v", ()=>optionCSS);
parcelHelpers.export(exports, "w", ()=>placeholderCSS);
parcelHelpers.export(exports, "x", ()=>css);
parcelHelpers.export(exports, "y", ()=>valueContainerCSS);
parcelHelpers.export(exports, "z", ()=>isTouchCapable);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectWithoutProperties = require("@babel/runtime/helpers/esm/objectWithoutProperties");
var _objectWithoutPropertiesDefault = parcelHelpers.interopDefault(_objectWithoutProperties);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _taggedTemplateLiteral = require("@babel/runtime/helpers/esm/taggedTemplateLiteral");
var _taggedTemplateLiteralDefault = parcelHelpers.interopDefault(_taggedTemplateLiteral);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react1 = require("react");
var _reactDom = require("react-dom");
var _dom = require("@floating-ui/dom");
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function classNames(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat(applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var cleanValue = function cleanValue(value) {
    if (isArray(value)) return value.filter(Boolean);
    if ((0, _typeofDefault.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(props, _excluded$4);
    return (0, _objectSpread2Default.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function normalizedHeight(el) {
    if (isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function getScrollTop(el) {
    if (isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = easeOutCubic(currentTime, start, change, duration);
        scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var passiveOptionAccessed = false;
var options = {
    get passive () {
        return passiveOptionAccessed = true;
    }
};
// check for SSR
var w = typeof window !== 'undefined' ? window : {};
if (w.addEventListener && w.removeEventListener) {
    w.addEventListener('p', noop, options);
    w.removeEventListener('p', noop, false);
}
var supportsPassiveEvents = passiveOptionAccessed;
function notNullish(item) {
    return item != null;
}
function isArray(arg) {
    return Array.isArray(arg);
}
function valueTernary(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function singleValueAsValue(singleValue) {
    return singleValue;
}
function multiValueAsValue(multiValue) {
    return multiValue;
}
var removeProps = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, _slicedToArrayDefault.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, _slicedToArrayDefault.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var _excluded$3 = [
    "children",
    "innerProps"
], _excluded2$1 = [
    "children",
    "innerProps"
];
function getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : normalizedHeight(scrollParent);
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var menuCSS = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, _objectSpread2Default.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, _definePropertyDefault.default)(_objectSpread2, alignToControl(placement), '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "position", 'absolute'), (0, _definePropertyDefault.default)(_objectSpread2, "width", '100%'), (0, _definePropertyDefault.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var PortalPlacementContext = /*#__PURE__*/ (0, _react1.createContext)(null);
// NOTE: internal only
var MenuPlacer = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, _react1.useContext)(PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, _react1.useRef)(null);
    var _useState = (0, _react1.useState)(maxMenuHeight), _useState2 = (0, _slicedToArrayDefault.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, _react1.useState)(null), _useState4 = (0, _slicedToArrayDefault.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
            placement: placement || coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var Menu$1 = Menu;
// ==============================
// Menu List
// ==============================
var menuListCSS = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, _objectSpread2Default.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref6, _excluded$3);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var menuPortalCSS = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, _react1.useRef)(null);
    var cleanupRef = (0, _react1.useRef)(null);
    var _useState5 = (0, _react1.useState)(coercePlacement(menuPlacement)), _useState6 = (0, _slicedToArrayDefault.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, _react1.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, _react1.useState)(null), _useState8 = (0, _slicedToArrayDefault.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, _react1.useCallback)(function() {
        if (!controlElement) return;
        var rect = getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, _react1.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, _dom.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, _react1.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: setMenuPortalElement
    }, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, _react.jsx)(PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, _reactDom.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var valueContainerCSS = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var _templateObject;
var _excluded$2 = [
    "size"
], _excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var _ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, _objectWithoutPropertiesDefault.default)(_ref, _excluded$2);
    return (0, _react.jsx)("svg", (0, _extendsDefault.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: _ref2
    }, props));
};
var CrossIcon = function CrossIcon(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var DownChevron = function DownChevron(props) {
    return (0, _react.jsx)(Svg, (0, _extendsDefault.default)({
        size: 20
    }, props), (0, _react.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, _react.jsx)(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, _react.jsx)(CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, _react.jsx)("span", (0, _extendsDefault.default)({}, innerProps, getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var loadingDotAnimations = (0, _react.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralDefault.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, _objectSpread2Default.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, _react.jsx)("span", {
        css: /*#__PURE__*/ (0, _react.css)({
            animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, _objectWithoutPropertiesDefault.default)(_ref7, _excluded2);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, _react.jsx)(LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, _react.jsx)(LoadingDot, {
        delay: 160,
        offset: true
    }), (0, _react.jsx)(LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var css$1 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        ref: innerRef
    }, getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var Control$1 = Control;
var _excluded$1 = [
    "data"
];
var groupCSS = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, _react.jsx)(Heading, (0, _extendsDefault.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, _react.jsx)("div", null, children));
};
var groupHeadingCSS = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, _objectSpread2Default.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded$1);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var Group$1 = Group;
var _excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var inputCSS = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, _objectSpread2Default.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, spacingStyle)
};
var inputStyle = function inputStyle(isHidden) {
    return (0, _objectSpread2Default.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, spacingStyle);
};
var Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, _objectWithoutPropertiesDefault.default)(_cleanCommonProps, _excluded);
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, _react.jsx)("input", (0, _extendsDefault.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var Input$1 = Input;
var multiValueCSS = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, _objectSpread2Default.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, _objectSpread2Default.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, _react.jsx)("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({
        role: "button"
    }, innerProps), children || (0, _react.jsx)(CrossIcon, {
        size: 14
    }));
}
var MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, _react.jsx)(Container, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, _react.jsx)(Label, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, _react.jsx)(Remove, {
        data: data,
        innerProps: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var MultiValue$1 = MultiValue;
var optionCSS = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var Option$1 = Option;
var placeholderCSS = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var Placeholder$1 = Placeholder;
var css = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, _objectSpread2Default.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, _react.jsx)("div", (0, _extendsDefault.default)({}, getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var SingleValue$1 = SingleValue;
var components = {
    ClearIndicator: ClearIndicator,
    Control: Control$1,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group$1,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input$1,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu$1,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue$1,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option$1,
    Placeholder: Placeholder$1,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue$1,
    ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
    return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, components), props.components);
};

},{"@babel/runtime/helpers/esm/objectSpread2":"59BsR","@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/react":"lIeII","@babel/runtime/helpers/esm/slicedToArray":"idCNq","@babel/runtime/helpers/esm/objectWithoutProperties":"aFSss","@babel/runtime/helpers/esm/typeof":"la19k","@babel/runtime/helpers/esm/taggedTemplateLiteral":"fonV0","@babel/runtime/helpers/esm/defineProperty":"5zOJa","react":"9njXz","react-dom":"2ApDx","@floating-ui/dom":"4vfaI","use-isomorphic-layout-effect":"1Jrzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lIeII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CacheProvider", ()=>(0, _emotionElementD59E098FEsmJs.C));
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _emotionElementD59E098FEsmJs.T));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _emotionElementD59E098FEsmJs.b));
parcelHelpers.export(exports, "__unsafe_useEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs._));
parcelHelpers.export(exports, "useTheme", ()=>(0, _emotionElementD59E098FEsmJs.u));
parcelHelpers.export(exports, "withEmotionCache", ()=>(0, _emotionElementD59E098FEsmJs.w));
parcelHelpers.export(exports, "withTheme", ()=>(0, _emotionElementD59E098FEsmJs.d));
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "createElement", ()=>jsx);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _emotionElementD59E098FEsmJs = require("./emotion-element-d59e098f.esm.js");
var _react = require("react");
var _utils = require("@emotion/utils");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _serialize = require("@emotion/serialize");
var _cache = require("@emotion/cache");
var _extends = require("@babel/runtime/helpers/extends");
var _weakMemoize = require("@emotion/weak-memoize");
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var jsx = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, _emotionElementD59E098FEsmJs.h).call(props, 'css')) return _react.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, _emotionElementD59E098FEsmJs.E);
    createElementArgArray[1] = (0, _emotionElementD59E098FEsmJs.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})(jsx || (jsx = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var Global = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, _serialize.serializeStyles)([
        styles
    ], undefined, _react.useContext((0, _emotionElementD59E098FEsmJs.T)));
    if (!(0, _emotionElementD59E098FEsmJs.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ _react.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = _react.useRef();
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, _utils.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, _serialize.serializeStyles)(args);
}
function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, _utils.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, _utils.insertStyles)(cache, serializedArr[i], false);
            if (!(0, _emotionElementD59E098FEsmJs.i) && res !== undefined) rules += res;
        }
        if (!(0, _emotionElementD59E098FEsmJs.i)) return rules;
    });
    if (!(0, _emotionElementD59E098FEsmJs.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var ClassNames = /* #__PURE__ */ (0, _emotionElementD59E098FEsmJs.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, _serialize.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, _utils.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, _emotionElementD59E098FEsmJs.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css, classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: _react.useContext((0, _emotionElementD59E098FEsmJs.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

},{"./emotion-element-d59e098f.esm.js":"8wFC4","react":"9njXz","@emotion/utils":"du4W1","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@emotion/serialize":"6P7Gu","@emotion/cache":"r7hGp","@babel/runtime/helpers/extends":"ktcBy","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"4kFGQ","hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wFC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CacheProvider);
parcelHelpers.export(exports, "E", ()=>Emotion$1);
parcelHelpers.export(exports, "T", ()=>ThemeContext);
parcelHelpers.export(exports, "_", ()=>__unsafe_useEmotionCache);
parcelHelpers.export(exports, "a", ()=>isDevelopment);
parcelHelpers.export(exports, "b", ()=>ThemeProvider);
parcelHelpers.export(exports, "c", ()=>createEmotionProps);
parcelHelpers.export(exports, "d", ()=>withTheme);
parcelHelpers.export(exports, "h", ()=>hasOwn);
parcelHelpers.export(exports, "i", ()=>isBrowser);
parcelHelpers.export(exports, "u", ()=>useTheme);
parcelHelpers.export(exports, "w", ()=>withEmotionCache);
var _react = require("react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _emotionReactIsolatedHnrsEsmJs = require("../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js");
var _emotionReactIsolatedHnrsEsmJsDefault = parcelHelpers.interopDefault(_emotionReactIsolatedHnrsEsmJs);
var _utils = require("@emotion/utils");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var isDevelopment = false;
var isBrowser = typeof document !== 'undefined';
var EmotionCacheContext = /* #__PURE__ */ _react.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, _cacheDefault.default)({
    key: 'css'
}) : null);
var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
    return (0, _react.useContext)(EmotionCacheContext);
};
var withEmotionCache = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!isBrowser) withEmotionCache = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, _cacheDefault.default)({
                key: 'css'
            });
            return /*#__PURE__*/ _react.createElement(EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var ThemeContext = /* #__PURE__ */ _react.createContext({});
var useTheme = function useTheme() {
    return _react.useContext(ThemeContext);
};
var getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, theme);
};
var createCacheWithTheme = /* #__PURE__ */ (0, _weakMemoizeDefault.default)(function(outerTheme) {
    return (0, _weakMemoizeDefault.default)(function(theme) {
        return getTheme(outerTheme, theme);
    });
});
var ThemeProvider = function ThemeProvider(props) {
    var theme = _react.useContext(ThemeContext);
    if (props.theme !== theme) theme = createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ _react.forwardRef(function render(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, _emotionReactIsolatedHnrsEsmJsDefault.default)(WithTheme, Component);
}
var hasOwn = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if (hasOwn.call(props, _key)) newProps[_key] = props[_key];
    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var Emotion = /* #__PURE__ */ withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, _serialize.serializeStyles)(registeredStyles, undefined, _react.useContext(ThemeContext));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !isDevelopment) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ _react.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

},{"react":"9njXz","@emotion/cache":"r7hGp","@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/weak-memoize":"8azSs","../_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js":"4kFGQ","@emotion/utils":"du4W1","@emotion/serialize":"6P7Gu","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"r7hGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createCache);
var _sheet = require("@emotion/sheet");
var _stylis = require("stylis");
var _weakMemoize = require("@emotion/weak-memoize");
var _weakMemoizeDefault = parcelHelpers.interopDefault(_weakMemoize);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isBrowser = typeof document !== 'undefined';
var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, _stylis.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, _stylis.token)(character)) break;
        (0, _stylis.next)();
    }
    return (0, _stylis.slice)(begin, (0, _stylis.position));
};
var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, _stylis.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, _stylis.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += identifierWithPointTracking((0, _stylis.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, _stylis.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, _stylis.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, _stylis.from)(character);
    }
    while (character = (0, _stylis.next)());
    return parsed;
};
var getRules = function getRules(value, points) {
    return (0, _stylis.dealloc)(toRules((0, _stylis.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var fixedElements = /* #__PURE__ */ new WeakMap();
var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function prefix(value, length) {
    switch((0, _stylis.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, _stylis.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, _stylis.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MOZ) + value + (0, _stylis.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
        // order
        case 6165:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.replace)(value, /(\w+).+(:[^]+)/, (0, _stylis.WEBKIT) + 'box-$1$2' + (0, _stylis.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-item-' + (0, _stylis.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + 'flex-line-pack' + (0, _stylis.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, _stylis.WEBKIT) + 'box-' + (0, _stylis.replace)(value, '-grow', '') + (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, _stylis.WEBKIT) + (0, _stylis.replace)(value, /([^-])(transform)/g, '$1' + (0, _stylis.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, _stylis.replace)((0, _stylis.replace)((0, _stylis.replace)(value, /(zoom-|grab)/, (0, _stylis.WEBKIT) + '$1'), /(image-set)/, (0, _stylis.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, _stylis.replace)(value, /(image-set\([^]*)/, (0, _stylis.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, _stylis.replace)((0, _stylis.replace)(value, /(.+:)(flex-)?(.*)/, (0, _stylis.WEBKIT) + 'box-pack:$3' + (0, _stylis.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, _stylis.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, _stylis.replace)(value, /(.+)-inline(.+)/, (0, _stylis.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, _stylis.strlen)(value) - 1 - length > 6) switch((0, _stylis.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, _stylis.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, _stylis.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, _stylis.WEBKIT) + '$2-$3' + '$1' + (0, _stylis.MOZ) + ((0, _stylis.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, _stylis.indexof)(value, 'stretch') ? prefix((0, _stylis.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, _stylis.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, _stylis.charat)(value, (0, _stylis.strlen)(value) - 3 - (~(0, _stylis.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, _stylis.replace)(value, ':', ':' + (0, _stylis.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, _stylis.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, _stylis.WEBKIT) + ((0, _stylis.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, _stylis.WEBKIT) + '$2$3' + '$1' + (0, _stylis.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, _stylis.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + (0, _stylis.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, _stylis.WEBKIT) + value + (0, _stylis.MS) + value + value;
    }
    return value;
}
var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, _stylis.DECLARATION:
                element["return"] = prefix(element.value, element.length);
                break;
            case 0, _stylis.KEYFRAMES:
                return (0, _stylis.serialize)([
                    (0, _stylis.copy)(element, {
                        value: (0, _stylis.replace)(element.value, '@', '@' + (0, _stylis.WEBKIT))
                    })
                ], callback);
            case 0, _stylis.RULESET:
                if (element.length) return (0, _stylis.combine)(element.props, function(value) {
                    switch((0, _stylis.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(read-\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, _stylis.serialize)([
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, ':' + (0, _stylis.MOZ) + '$1')
                                    ]
                                }),
                                (0, _stylis.copy)(element, {
                                    props: [
                                        (0, _stylis.replace)(value, /:(plac\w+)/, (0, _stylis.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var getServerStylisCache = isBrowser ? undefined : (0, _weakMemoizeDefault.default)(function() {
    return (0, _memoizeDefault.default)(function() {
        return {};
    });
});
var defaultStylisPlugins = [
    prefixer
];
var createCache = function createCache(options) {
    var key = options.key;
    if (isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if (isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        compat,
        removeLabel
    ];
    if (!getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, _stylis.stringify),
            (0, _stylis.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, _stylis.stringify)
        ];
        var _serializer = (0, _stylis.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis1 = function _stylis1(styles) {
            return (0, _stylis.serialize)((0, _stylis.compile)(styles), _serializer);
        };
        var serverStylisCache = getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, _sheet.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

},{"@emotion/sheet":"4RXfS","stylis":"8LsfH","@emotion/weak-memoize":"8azSs","@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RXfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
var isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var StyleSheet = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8LsfH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>n);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>v);
parcelHelpers.export(exports, "FONT_FACE", ()=>b);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>h);
parcelHelpers.export(exports, "LAYER", ()=>$);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>p);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>c);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>g);
parcelHelpers.export(exports, "alloc", ()=>V);
parcelHelpers.export(exports, "append", ()=>q);
parcelHelpers.export(exports, "assign", ()=>m);
parcelHelpers.export(exports, "caret", ()=>R);
parcelHelpers.export(exports, "char", ()=>L);
parcelHelpers.export(exports, "character", ()=>H);
parcelHelpers.export(exports, "characters", ()=>I);
parcelHelpers.export(exports, "charat", ()=>O);
parcelHelpers.export(exports, "column", ()=>E);
parcelHelpers.export(exports, "combine", ()=>B);
parcelHelpers.export(exports, "comment", ()=>ue);
parcelHelpers.export(exports, "commenter", ()=>ae);
parcelHelpers.export(exports, "compile", ()=>ce);
parcelHelpers.export(exports, "copy", ()=>K);
parcelHelpers.export(exports, "dealloc", ()=>W);
parcelHelpers.export(exports, "declaration", ()=>ie);
parcelHelpers.export(exports, "delimit", ()=>X);
parcelHelpers.export(exports, "delimiter", ()=>re);
parcelHelpers.export(exports, "escaping", ()=>ee);
parcelHelpers.export(exports, "from", ()=>k);
parcelHelpers.export(exports, "hash", ()=>x);
parcelHelpers.export(exports, "identifier", ()=>ne);
parcelHelpers.export(exports, "indexof", ()=>C);
parcelHelpers.export(exports, "length", ()=>F);
parcelHelpers.export(exports, "line", ()=>D);
parcelHelpers.export(exports, "match", ()=>j);
parcelHelpers.export(exports, "middleware", ()=>ve);
parcelHelpers.export(exports, "namespace", ()=>be);
parcelHelpers.export(exports, "next", ()=>P);
parcelHelpers.export(exports, "node", ()=>J);
parcelHelpers.export(exports, "parse", ()=>se);
parcelHelpers.export(exports, "peek", ()=>Q);
parcelHelpers.export(exports, "position", ()=>G);
parcelHelpers.export(exports, "prefix", ()=>fe);
parcelHelpers.export(exports, "prefixer", ()=>he);
parcelHelpers.export(exports, "prev", ()=>N);
parcelHelpers.export(exports, "replace", ()=>z);
parcelHelpers.export(exports, "ruleset", ()=>te);
parcelHelpers.export(exports, "rulesheet", ()=>pe);
parcelHelpers.export(exports, "serialize", ()=>oe);
parcelHelpers.export(exports, "sizeof", ()=>S);
parcelHelpers.export(exports, "slice", ()=>T);
parcelHelpers.export(exports, "stringify", ()=>le);
parcelHelpers.export(exports, "strlen", ()=>M);
parcelHelpers.export(exports, "substr", ()=>A);
parcelHelpers.export(exports, "token", ()=>U);
parcelHelpers.export(exports, "tokenize", ()=>Y);
parcelHelpers.export(exports, "tokenizer", ()=>_);
parcelHelpers.export(exports, "trim", ()=>y);
parcelHelpers.export(exports, "whitespace", ()=>Z);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var n = "comm";
var c = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var p = "@namespace";
var h = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var $ = "@layer";
var g = Math.abs;
var k = String.fromCharCode;
var m = Object.assign;
function x(e, r) {
    return O(e, 0) ^ 45 ? (((r << 2 ^ O(e, 0)) << 2 ^ O(e, 1)) << 2 ^ O(e, 2)) << 2 ^ O(e, 3) : 0;
}
function y(e) {
    return e.trim();
}
function j(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function z(e, r, a) {
    return e.replace(r, a);
}
function C(e, r) {
    return e.indexOf(r);
}
function O(e, r) {
    return e.charCodeAt(r) | 0;
}
function A(e, r, a) {
    return e.slice(r, a);
}
function M(e) {
    return e.length;
}
function S(e) {
    return e.length;
}
function q(e, r) {
    return r.push(e), e;
}
function B(e, r) {
    return e.map(r).join("");
}
var D = 1;
var E = 1;
var F = 0;
var G = 0;
var H = 0;
var I = "";
function J(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: D,
        column: E,
        length: t,
        return: ""
    };
}
function K(e, r) {
    return m(J("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function L() {
    return H;
}
function N() {
    H = G > 0 ? O(I, --G) : 0;
    if (E--, H === 10) E = 1, D--;
    return H;
}
function P() {
    H = G < F ? O(I, G++) : 0;
    if (E++, H === 10) E = 1, D++;
    return H;
}
function Q() {
    return O(I, G);
}
function R() {
    return G;
}
function T(e, r) {
    return A(I, e, r);
}
function U(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function V(e) {
    return D = E = 1, F = M(I = e), G = 0, [];
}
function W(e) {
    return I = "", e;
}
function X(e) {
    return y(T(G - 1, re(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Y(e) {
    return W(_(V(e)));
}
function Z(e) {
    while(H = Q())if (H < 33) P();
    else break;
    return U(e) > 2 || U(H) > 3 ? "" : " ";
}
function _(e) {
    while(P())switch(U(H)){
        case 0:
            q(ne(G - 1), e);
            break;
        case 2:
            q(X(H), e);
            break;
        default:
            q(k(H), e);
    }
    return e;
}
function ee(e, r) {
    while(--r && P())if (H < 48 || H > 102 || H > 57 && H < 65 || H > 70 && H < 97) break;
    return T(e, R() + (r < 6 && Q() == 32 && P() == 32));
}
function re(e) {
    while(P())switch(H){
        case e:
            return G;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) re(H);
            break;
        case 40:
            if (e === 41) re(e);
            break;
        case 92:
            P();
            break;
    }
    return G;
}
function ae(e, r) {
    while(P())if (e + H === 57) break;
    else if (e + H === 84 && Q() === 47) break;
    return "/*" + T(r, G - 1) + "*" + k(e === 47 ? e : P());
}
function ne(e) {
    while(!U(Q()))P();
    return T(e, G);
}
function ce(e) {
    return W(se("", null, null, null, [
        ""
    ], e = V(e), 0, [
        0
    ], e));
}
function se(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = P()){
        case 40:
            if (h != 108 && O(j, l - 1) == 58) {
                if (C(j += z(X($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += X($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += Z(h);
            break;
        case 92:
            j += ee(R() - 1, 7);
            continue;
        case 47:
            switch(Q()){
                case 42:
                case 47:
                    q(ue(ae(P(), R()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = M(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = z(j, /\f/g, "");
                    if (p > 0 && M(j) - l) q(p > 32 ? ie(j + ";", n, a, l - 1) : ie(z(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    q(y = te(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) se(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && O(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                se(e, y, y, n && q(te(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                se(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + M(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && N() == 125) continue;
            }
            switch(j += k($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = (M(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if (Q() === 45) j += X(P());
                    v = Q(), o = l = M(g = j += ne(R())), $++;
                    break;
                case 45:
                    if (h === 45 && M(j) == 2) b = 0;
            }
    }
    return s;
}
function te(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = S(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = A(e, v + 1, v = g(w = u[b])), m = e; $ < h; ++$)if (m = y(w > 0 ? p[$] + " " + k : z(k, /&\f/g, p[$]))) f[d++] = m;
    return J(e, r, a, s === 0 ? c : i, f, o, l);
}
function ue(e, r, a) {
    return J(e, r, a, n, k(L()), A(e, 2, -2), 0);
}
function ie(e, r, a, n) {
    return J(e, r, a, s, A(e, 0, n), A(e, n + 1, -1), n);
}
function fe(n, c, s) {
    switch(x(n, c)){
        case 5103:
            return a + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return a + n + n;
        case 4789:
            return r + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + n + r + n + e + n + n;
        case 5936:
            switch(O(n, c + 11)){
                case 114:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return a + n + e + z(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + n + e + n + n;
        case 6165:
            return a + n + e + "flex-" + n + n;
        case 5187:
            return a + n + z(n, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + n;
        case 5443:
            return a + n + e + "flex-item-" + z(n, /flex-|-self/g, "") + (!j(n, /flex-|baseline/) ? e + "grid-row-" + z(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return a + n + e + "flex-line-pack" + z(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return a + n + e + z(n, "shrink", "negative") + n;
        case 5292:
            return a + n + e + z(n, "basis", "preferred-size") + n;
        case 6060:
            return a + "box-" + z(n, "-grow", "") + a + n + e + z(n, "grow", "positive") + n;
        case 4554:
            return a + z(n, /([^-])(transform)/g, "$1" + a + "$2") + n;
        case 6187:
            return z(z(z(n, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return z(n, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return z(z(n, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + n + n;
        case 4200:
            if (!j(n, /flex-|baseline/)) return e + "grid-column-align" + A(n, c) + n;
            break;
        case 2592:
        case 3360:
            return e + z(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, j(e.props, /grid-\w+-end/);
            })) return ~C(n + (s = s[c].value), "span") ? n : e + z(n, "-start", "") + n + e + "grid-row-span:" + (~C(s, "span") ? j(s, /\d+/) : +j(s, /\d+/) - +j(n, /\d+/)) + ";";
            return e + z(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return j(e.props, /grid-\w+-start/);
            }) ? n : e + z(z(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return z(n, /(.+)-inline(.+)/, a + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (M(n) - 1 - c > 6) switch(O(n, c + 1)){
                case 109:
                    if (O(n, c + 4) !== 45) break;
                case 102:
                    return z(n, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (O(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~C(n, "stretch") ? fe(z(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return z(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return e + a + ":" + c + i + (s ? e + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if (O(n, c + 6) === 121) return z(n, ":", ":" + a) + n;
            break;
        case 6444:
            switch(O(n, O(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return z(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (O(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + n;
                case 100:
                    return z(n, ":", ":" + e) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return z(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function oe(e, r) {
    var a = "";
    var n = S(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function le(e, r, a, t) {
    switch(e.type){
        case $:
            if (e.children.length) break;
        case i:
        case s:
            return e.return = e.return || e.value;
        case n:
            return "";
        case h:
            return e.return = e.value + "{" + oe(e.children, t) + "}";
        case c:
            e.value = e.props.join(",");
    }
    return M(a = oe(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function ve(e) {
    var r = S(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function pe(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function he(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case s:
                n.return = fe(n.value, n.length, u);
                return;
            case h:
                return oe([
                    K(n, {
                        value: z(n.value, "@", "@" + a)
                    })
                ], i);
            case c:
                if (n.length) return B(n.props, function(c) {
                    switch(j(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(read-\w+)/, ":" + r + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return oe([
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + a + "input-$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, ":" + r + "$1")
                                    ]
                                }),
                                K(n, {
                                    props: [
                                        z(c, /:(plac\w+)/, e + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function be(e) {
    switch(e.type){
        case c:
            e.props = e.props.map(function(r) {
                return B(Y(r), function(r, a, n) {
                    switch(O(r, 0)){
                        case 12:
                            return A(r, 1, M(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + A(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return S(n) > 1 ? "" : r;
                                case a = S(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8azSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>weakMemoize);
var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fCpYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kFGQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hoistNonReactStatics);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, _hoistNonReactStaticsDefault.default)(targetComponent, sourceComponent);
};

},{"hoist-non-react-statics":"59Kh2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"du4W1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRegisteredStyles", ()=>getRegisteredStyles);
parcelHelpers.export(exports, "insertStyles", ()=>insertStyles);
parcelHelpers.export(exports, "registerStyles", ()=>registerStyles);
var isBrowser = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6P7Gu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeStyles", ()=>serializeStyles);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var isDevelopment = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var processStyleName = /* #__PURE__ */ (0, _memoizeDefault.default)(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace(animationRegex, function(match, p1, p2) {
                cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                };
                return p1;
            });
    }
    if ((0, _unitlessDefault.default)[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = cursor;
                var result = interpolation(mergedProps);
                cursor = previousCursor;
                return handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if (isProcessableValue(asString)) string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if (isProcessableValue(value[_i])) string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var cursor;
function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, _hashDefault.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: cursor
    };
}

},{"@emotion/hash":"h2KJ7","@emotion/unitless":"bJPP1","@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h2KJ7":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>murmur2);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bJPP1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unitlessKeys);
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kt8pI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var isBrowser = typeof document !== 'undefined';
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser ? syncFallback : useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fonV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_taggedTemplateLiteral);
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vfaI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>(0, _dom.getOverflowAncestors));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "autoUpdate", ()=>autoUpdate);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "platform", ()=>platform);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _core = require("@floating-ui/core");
var _utils = require("@floating-ui/utils");
var _dom = require("@floating-ui/utils/dom");
function getCssDimensions(element) {
    const css = (0, _dom.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, _dom.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, _utils.round)(width) !== offsetWidth || (0, _utils.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width,
        height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !(0, _dom.isElement)(element) ? element.contextElement : element;
}
function getScale(element) {
    const domElement = unwrapElement(element);
    if (!(0, _dom.isHTMLElement)(domElement)) return (0, _utils.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width, height, $ } = getCssDimensions(domElement);
    let x = ($ ? (0, _utils.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, _utils.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x,
        y
    };
}
const noOffsets = /*#__PURE__*/ (0, _utils.createCoords)(0);
function getVisualOffsets(element) {
    const win = (0, _dom.getWindow)(element);
    if (!(0, _dom.isWebKit)() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, _dom.getWindow)(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = unwrapElement(element);
    let scale = (0, _utils.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, _dom.isElement)(offsetParent)) scale = getScale(offsetParent);
        } else scale = getScale(element);
    }
    const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : (0, _utils.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, _dom.getWindow)(domElement);
        const offsetWin = offsetParent && (0, _dom.isElement)(offsetParent) ? (0, _dom.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, _dom.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, _dom.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, _dom.getWindow)(currentIFrame);
            currentIFrame = (0, _dom.getFrameElement)(currentWin);
        }
    }
    return (0, _core.rectToClientRect)({
        width,
        height,
        x,
        y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
    const leftScroll = (0, _dom.getNodeScroll)(element).scrollLeft;
    if (!rect) return getBoundingClientRect((0, _dom.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x,
        y
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements, rect, offsetParent, strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, _dom.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, _utils.createCoords)(1);
    const offsets = (0, _utils.createCoords)(0);
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if ((0, _dom.isHTMLElement)(offsetParent)) {
            const offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : (0, _utils.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
    const html = (0, _dom.getDocumentElement)(element);
    const scroll = (0, _dom.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, _utils.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, _utils.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, _dom.getComputedStyle)(body).direction === 'rtl') x += (0, _utils.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width,
        height,
        x,
        y
    };
}
function getViewportRect(element, strategy) {
    const win = (0, _dom.getWindow)(element);
    const html = (0, _dom.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, _dom.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width,
        height,
        x,
        y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
    const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, _dom.isHTMLElement)(element) ? getScale(element) : (0, _utils.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width,
        height,
        x,
        y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = getDocumentRect((0, _dom.getDocumentElement)(element));
    else if ((0, _dom.isElement)(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, _core.rectToClientRect)(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, _dom.getParentNode)(element);
    if (parentNode === stopNode || !(0, _dom.isElement)(parentNode) || (0, _dom.isLastTraversableNode)(parentNode)) return false;
    return (0, _dom.getComputedStyle)(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, _dom.getOverflowAncestors)(element, [], false).filter((el)=>(0, _dom.isElement)(el) && (0, _dom.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, _dom.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, _dom.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, _dom.isElement)(currentNode) && !(0, _dom.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, _dom.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, _dom.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, _dom.isOverflowElement)(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, _dom.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
    let { element, boundary, rootBoundary, strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, _dom.isTopLayer)(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, _utils.max)(rect.top, accRect.top);
        accRect.right = (0, _utils.min)(rect.right, accRect.right);
        accRect.bottom = (0, _utils.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _utils.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function getDimensions(element) {
    const { width, height } = getCssDimensions(element);
    return {
        width,
        height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, _dom.isHTMLElement)(offsetParent);
    const documentElement = (0, _dom.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, _utils.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _dom.getNodeName)(offsetParent) !== 'body' || (0, _dom.isOverflowElement)(documentElement)) scroll = (0, _dom.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = getWindowScrollBarX(documentElement);
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : (0, _utils.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x,
        y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return (0, _dom.getComputedStyle)(element).position === 'static';
}
function getTrueOffsetParent(element, polyfill) {
    if (!(0, _dom.isHTMLElement)(element) || (0, _dom.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, _dom.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
    const win = (0, _dom.getWindow)(element);
    if ((0, _dom.isTopLayer)(element)) return win;
    if (!(0, _dom.isHTMLElement)(element)) {
        let svgOffsetParent = (0, _dom.getParentNode)(element);
        while(svgOffsetParent && !(0, _dom.isLastTraversableNode)(svgOffsetParent)){
            if ((0, _dom.isElement)(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, _dom.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, _dom.isTableElement)(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, _dom.isLastTraversableNode)(offsetParent) && isStaticPositioned(offsetParent) && !(0, _dom.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, _dom.getContainingBlock)(element) || win;
}
const getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function isRTL(element) {
    return (0, _dom.getComputedStyle)(element).direction === 'rtl';
}
const platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: (0, _dom.getDocumentElement),
    getClippingRect,
    getOffsetParent,
    getElementRects,
    getClientRects,
    getDimensions,
    getScale,
    isElement: (0, _dom.isElement),
    isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, _dom.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left, top, width, height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, _utils.floor)(top);
        const insetRight = (0, _utils.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, _utils.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, _utils.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin,
            threshold: (0, _utils.max)(0, (0, _utils.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll = true, ancestorResize = true, elementResize = typeof ResizeObserver === 'function', layoutShift = typeof IntersectionObserver === 'function', animationFrame = false } = options;
    const referenceEl = unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, _dom.getOverflowAncestors)(referenceEl) : [],
        ...(0, _dom.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const detectOverflow = (0, _core.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = (0, _core.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = (0, _core.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = (0, _core.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = (0, _core.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = (0, _core.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = (0, _core.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (0, _core.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = (0, _core.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = (0, _core.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const computePosition = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, _core.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

},{"@floating-ui/core":"jiGLa","@floating-ui/utils":"4C4fb","@floating-ui/utils/dom":"ctIgS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiGLa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectToClientRect", ()=>(0, _utils.rectToClientRect));
parcelHelpers.export(exports, "arrow", ()=>arrow);
parcelHelpers.export(exports, "autoPlacement", ()=>autoPlacement);
parcelHelpers.export(exports, "computePosition", ()=>computePosition);
parcelHelpers.export(exports, "detectOverflow", ()=>detectOverflow);
parcelHelpers.export(exports, "flip", ()=>flip);
parcelHelpers.export(exports, "hide", ()=>hide);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "limitShift", ()=>limitShift);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shift", ()=>shift);
parcelHelpers.export(exports, "size", ()=>size);
var _utils = require("@floating-ui/utils");
function computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference, floating } = _ref;
    const sideAxis = (0, _utils.getSideAxis)(placement);
    const alignmentAxis = (0, _utils.getAlignmentAxis)(placement);
    const alignLength = (0, _utils.getAxisLength)(alignmentAxis);
    const side = (0, _utils.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, _utils.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const computePosition = async (reference, floating, config)=>{
    const { placement = 'bottom', strategy = 'absolute', middleware = [], platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference,
        floating,
        strategy
    });
    let { x, y } = computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name, fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data, reset } = await fn({
            x,
            y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy,
            middlewareData,
            rects,
            platform,
            elements: {
                reference,
                floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference,
                    floating,
                    strategy
                }) : reset.rects;
                ({ x, y } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x,
        y,
        placement: statefulPlacement,
        strategy,
        middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function detectOverflow(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x, y, platform, rects, elements, strategy } = state;
    const { boundary = 'clippingAncestors', rootBoundary = 'viewport', elementContext = 'floating', altBoundary = false, padding = 0 } = (0, _utils.evaluate)(options, state);
    const paddingObject = (0, _utils.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, _utils.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary,
        rootBoundary,
        strategy
    }));
    const rect = elementContext === 'floating' ? {
        x,
        y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, _utils.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements,
        rect,
        offsetParent,
        strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const arrow = (options)=>({
        name: 'arrow',
        options,
        async fn (state) {
            const { x, y, placement, rects, platform, elements, middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element, padding = 0 } = (0, _utils.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            const coords = {
                x,
                y
            };
            const axis = (0, _utils.getAlignmentAxis)(placement);
            const length = (0, _utils.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, _utils.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, _utils.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, _utils.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, _utils.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, _utils.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, _utils.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, _utils.getAlignment)(placement) === alignment || (autoAlignment ? (0, _utils.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const autoPlacement = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects, middlewareData, placement, platform, elements } = state;
            const { crossAxis = false, alignment, allowedPlacements = (0, _utils.placements), autoAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, _utils.placements) ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, _utils.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, _utils.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, _utils.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, _utils.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const flip = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement, middlewareData, rects, initialPlacement, platform, elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy = 'bestFit', fallbackAxisSideDirection = 'none', flipAlignment = true, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, _utils.getSide)(placement);
            const initialSideAxis = (0, _utils.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, _utils.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, _utils.getOppositePlacement)(initialPlacement)
            ] : (0, _utils.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, _utils.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, _utils.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement,
                    overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, _utils.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return (0, _utils.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const hide = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options,
        async fn (state) {
            const { rects } = state;
            const { strategy = 'referenceHidden', ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function getBoundingRect(rects) {
    const minX = (0, _utils.min)(...rects.map((rect)=>rect.left));
    const minY = (0, _utils.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, _utils.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, _utils.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, _utils.rectToClientRect)(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const inline = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options,
        async fn (state) {
            const { placement, elements, rects, platform, strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding = 2, x, y } = (0, _utils.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = getRectsByLine(nativeClientRects);
            const fallback = (0, _utils.rectToClientRect)(getBoundingRect(nativeClientRects));
            const paddingObject = (0, _utils.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, _utils.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, _utils.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top,
                            bottom,
                            left,
                            right,
                            width,
                            height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, _utils.getSide)(placement) === 'left';
                    const maxRight = (0, _utils.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, _utils.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top,
                        bottom,
                        left,
                        right,
                        width,
                        height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect
                },
                floating: elements.floating,
                strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function convertValueToCoords(state, options) {
    const { placement, platform, elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, _utils.getSide)(placement);
    const alignment = (0, _utils.getAlignment)(placement);
    const isVertical = (0, _utils.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, _utils.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis, crossAxis, alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const offset = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x, y, placement, middlewareData } = state;
            const diffCoords = await convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const shift = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options,
        async fn (state) {
            const { x, y, placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter = {
                fn: (_ref)=>{
                    let { x, y } = _ref;
                    return {
                        x,
                        y
                    };
                }
            }, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, _utils.getSideAxis)((0, _utils.getSide)(placement));
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, _utils.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, _utils.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const limitShift = function(options) {
    if (options === void 0) options = {};
    return {
        options,
        fn (state) {
            const { x, y, placement, rects, middlewareData } = state;
            const { offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, _utils.evaluate)(options, state);
            const coords = {
                x,
                y
            };
            const crossAxis = (0, _utils.getSideAxis)(placement);
            const mainAxis = (0, _utils.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, _utils.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, _utils.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const size = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement, rects, platform, elements } = state;
            const { apply = ()=>{}, ...detectOverflowOptions } = (0, _utils.evaluate)(options, state);
            const overflow = await detectOverflow(state, detectOverflowOptions);
            const side = (0, _utils.getSide)(placement);
            const alignment = (0, _utils.getAlignment)(placement);
            const isYAxis = (0, _utils.getSideAxis)(placement) === 'y';
            const { width, height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, _utils.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, _utils.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, _utils.max)(overflow.left, 0);
                const xMax = (0, _utils.max)(overflow.right, 0);
                const yMin = (0, _utils.max)(overflow.top, 0);
                const yMax = (0, _utils.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, _utils.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, _utils.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth,
                availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

},{"@floating-ui/utils":"4C4fb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4C4fb":[function(require,module,exports,__globalThis) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alignments", ()=>alignments);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "createCoords", ()=>createCoords);
parcelHelpers.export(exports, "evaluate", ()=>evaluate);
parcelHelpers.export(exports, "expandPaddingObject", ()=>expandPaddingObject);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "getAlignment", ()=>getAlignment);
parcelHelpers.export(exports, "getAlignmentAxis", ()=>getAlignmentAxis);
parcelHelpers.export(exports, "getAlignmentSides", ()=>getAlignmentSides);
parcelHelpers.export(exports, "getAxisLength", ()=>getAxisLength);
parcelHelpers.export(exports, "getExpandedPlacements", ()=>getExpandedPlacements);
parcelHelpers.export(exports, "getOppositeAlignmentPlacement", ()=>getOppositeAlignmentPlacement);
parcelHelpers.export(exports, "getOppositeAxis", ()=>getOppositeAxis);
parcelHelpers.export(exports, "getOppositeAxisPlacements", ()=>getOppositeAxisPlacements);
parcelHelpers.export(exports, "getOppositePlacement", ()=>getOppositePlacement);
parcelHelpers.export(exports, "getPaddingObject", ()=>getPaddingObject);
parcelHelpers.export(exports, "getSide", ()=>getSide);
parcelHelpers.export(exports, "getSideAxis", ()=>getSideAxis);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "rectToClientRect", ()=>rectToClientRect);
parcelHelpers.export(exports, "round", ()=>round);
parcelHelpers.export(exports, "sides", ()=>sides);
const sides = [
    'top',
    'right',
    'bottom',
    'left'
];
const alignments = [
    'start',
    'end'
];
const placements = /*#__PURE__*/ sides.reduce((acc, side)=>acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v)=>({
        x: v,
        y: v
    });
const oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function clamp(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
    return placement.split('-')[0];
}
function getAlignment(placement) {
    return placement.split('-')[1];
}
function getOppositeAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
    return [
        'top',
        'bottom'
    ].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = getAlignment(placement);
    const alignmentAxis = getAlignmentAxis(placement);
    const length = getAxisLength(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    const oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.replace(/start|end/g, (alignment)=>oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    const alignment = getAlignment(placement);
    let list = getSideList(getSide(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function getPaddingObject(padding) {
    return typeof padding !== 'number' ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    const { x, y, width, height } = rect;
    return {
        width,
        height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x,
        y
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ctIgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
parcelHelpers.export(exports, "getContainingBlock", ()=>getContainingBlock);
parcelHelpers.export(exports, "getDocumentElement", ()=>getDocumentElement);
parcelHelpers.export(exports, "getFrameElement", ()=>getFrameElement);
parcelHelpers.export(exports, "getNearestOverflowAncestor", ()=>getNearestOverflowAncestor);
parcelHelpers.export(exports, "getNodeName", ()=>getNodeName);
parcelHelpers.export(exports, "getNodeScroll", ()=>getNodeScroll);
parcelHelpers.export(exports, "getOverflowAncestors", ()=>getOverflowAncestors);
parcelHelpers.export(exports, "getParentNode", ()=>getParentNode);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "isContainingBlock", ()=>isContainingBlock);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isLastTraversableNode", ()=>isLastTraversableNode);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isOverflowElement", ()=>isOverflowElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
parcelHelpers.export(exports, "isTableElement", ()=>isTableElement);
parcelHelpers.export(exports, "isTopLayer", ()=>isTopLayer);
parcelHelpers.export(exports, "isWebKit", ()=>isWebKit);
function hasWindow() {
    return typeof window !== 'undefined';
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
    if (!hasWindow()) return false;
    return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
    const { overflow, overflowX, overflowY, display } = getComputedStyle(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].includes(getNodeName(element));
}
function isTopLayer(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function isContainingBlock(elementOrCss) {
    const webkit = isWebKit();
    const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective'
    ].some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'translate',
        'scale',
        'rotate',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function getContainingBlock(element) {
    let currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes(getNodeName(node));
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    const parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = getNearestOverflowAncestor(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = getWindow(scrollableAncestor);
    if (isBody) {
        const frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    }
    return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Jrzu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>index);
var _react = require("react");
var index = (0, _react.useLayoutEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jucOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoizeOne);
var safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function isEqual(first, second) {
    if (first === second) return true;
    if (safeIsNaN(first) && safeIsNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TY7Mr":[function(require,module,exports,__globalThis) {
var defineProperty = require("818faec3224b1d63");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"818faec3224b1d63":"hjdoh"}],"cSV7V":[function(require,module,exports,__globalThis) {
var arrayWithHoles = require("a3af206dbd14b1b5");
var iterableToArrayLimit = require("c109e0e3b1a7ef05");
var unsupportedIterableToArray = require("6782568c4383bd49");
var nonIterableRest = require("1e06d43f4bd6e532");
function _slicedToArray(r, e) {
    return arrayWithHoles(r) || iterableToArrayLimit(r, e) || unsupportedIterableToArray(r, e) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a3af206dbd14b1b5":"1GvOn","c109e0e3b1a7ef05":"5o08D","6782568c4383bd49":"4zHVJ","1e06d43f4bd6e532":"aSebZ"}],"1GvOn":[function(require,module,exports,__globalThis) {
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5o08D":[function(require,module,exports,__globalThis) {
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4zHVJ":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("f8ccc0353f5f3746");
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
    }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f8ccc0353f5f3746":"1AicQ"}],"1AicQ":[function(require,module,exports,__globalThis) {
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"aSebZ":[function(require,module,exports,__globalThis) {
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5xa1i":[function(require,module,exports,__globalThis) {
var objectWithoutPropertiesLoose = require("424c8dc91f0a14f9");
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"424c8dc91f0a14f9":"imPRm"}],"6C9u8":[function(require,module,exports,__globalThis) {
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"g9J5L":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"6uI3m"}],"43peb":[function(require,module,exports,__globalThis) {
var setPrototypeOf = require("f41396146170672b");
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"f41396146170672b":"iyNOR"}],"ayUOk":[function(require,module,exports,__globalThis) {
var getPrototypeOf = require("b241ea01e2bf5861");
var isNativeReflectConstruct = require("35b08a444265bcf9");
var possibleConstructorReturn = require("d50bbe07b7bb3622");
function _createSuper(t) {
    var r = isNativeReflectConstruct();
    return function() {
        var e, o = getPrototypeOf(t);
        if (r) {
            var s = getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return possibleConstructorReturn(this, e);
    };
}
module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b241ea01e2bf5861":"CaUfL","35b08a444265bcf9":"4whD7","d50bbe07b7bb3622":"2pp8P"}],"CaUfL":[function(require,module,exports,__globalThis) {
function _getPrototypeOf(t) {
    return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4whD7":[function(require,module,exports,__globalThis) {
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = _isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2pp8P":[function(require,module,exports,__globalThis) {
var _typeof = require("52fa942c15a57b36")["default"];
var assertThisInitialized = require("ca3744a9acc8b6f9");
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"52fa942c15a57b36":"979to","ca3744a9acc8b6f9":"f0luE"}],"c2UGM":[function(require,module,exports,__globalThis) {
var arrayWithoutHoles = require("80b438c8f11ca70e");
var iterableToArray = require("4f1268a27b81f1fd");
var unsupportedIterableToArray = require("bfa7725fe5f724b");
var nonIterableSpread = require("24ae2b6222a85da6");
function _toConsumableArray(r) {
    return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"80b438c8f11ca70e":"aOlvk","4f1268a27b81f1fd":"1KRMO","bfa7725fe5f724b":"4zHVJ","24ae2b6222a85da6":"jdiaX"}],"aOlvk":[function(require,module,exports,__globalThis) {
var arrayLikeToArray = require("d3a23041cb0f1512");
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d3a23041cb0f1512":"1AicQ"}],"1KRMO":[function(require,module,exports,__globalThis) {
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jdiaX":[function(require,module,exports,__globalThis) {
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"cpSDa":[function(require,module,exports,__globalThis) {
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = _taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"6hdws":[function(require,module,exports,__globalThis) {
'use strict';
const { inspect } = require("28b8482d97d69585");
class NonError extends Error {
    constructor(message){
        super(inspect(message));
        this.name = 'NonError';
        Error.captureStackTrace(this, NonError);
    }
}
const commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const serializeError = (value)=>{
    if (typeof value === 'object' && value !== null) return destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const deserializeError = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        destroyCircular(value, [], newError);
        return newError;
    }
    return new NonError(value);
};
module.exports = {
    serializeError,
    deserializeError
};

},{"28b8482d97d69585":"6Hf8s"}],"6Hf8s":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("bc23a3ea4a141c0b");
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
    if (!isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push(inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if (isNull(x) || !isObject(x)) str += ' ' + x;
    else str += ' ' + inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
    if (typeof process !== 'undefined' && process.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof process === 'undefined') return function() {
        return exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (process.throwDeprecation) throw new Error(msg);
            else if (process.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var debugs = {};
var debugEnvRegex = /^$/;
var debugEnv;
exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!debugs[set]) {
        if (debugEnvRegex.test(set)) {
            var pid = process.pid;
            debugs[set] = function() {
                var msg = exports.format.apply(exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else debugs[set] = function() {};
    }
    return debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    exports._extend(ctx, opts);
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];
    if (style) return '\u001b[' + inspect.colors[style][0] + 'm' + str + '\u001b[' + inspect.colors[style][1] + 'm';
    else return str;
}
function stylizeNoColor(str, styleType) {
    return str;
}
function arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!isString(ret)) ret = formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if (isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if (isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if (isError(value)) return formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if (isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if (isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if (isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if (isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if (isError(value)) base = ' ' + formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if (isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return reduceToSingleString(output, base, braces);
}
function formatPrimitive(ctx, value) {
    if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if (isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if (isNumber(value)) return ctx.stylize('' + value, 'number');
    if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if (isNull(value)) return ctx.stylize('null', 'null');
}
function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if (hasOwnProperty(value, String(i))) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if (isNull(recurseTimes)) str = formatValue(ctx, desc.value, null);
            else str = formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if (isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = require("6a1c15bae847a134");
function isArray(ar) {
    return Array.isArray(ar);
}
exports.isArray = isArray;
function isBoolean(arg) {
    return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;
function isNull(arg) {
    return arg === null;
}
exports.isNull = isNull;
function isNullOrUndefined(arg) {
    return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNumber(arg) {
    return typeof arg === 'number';
}
exports.isNumber = isNumber;
function isString(arg) {
    return typeof arg === 'string';
}
exports.isString = isString;
function isSymbol(arg) {
    return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;
function isUndefined(arg) {
    return arg === void 0;
}
exports.isUndefined = isUndefined;
function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;
function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;
function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;
function isError(e) {
    return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;
function isFunction(arg) {
    return typeof arg === 'function';
}
exports.isFunction = isFunction;
function isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;
exports.isBuffer = require("a42137cd7fc8700d");
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function timestamp() {
    var d = new Date();
    var time = [
        pad(d.getHours()),
        pad(d.getMinutes()),
        pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
    console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};
/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ exports.inherits = require("a792e8e3e2aa1973");
exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
        var fn = original[kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, getOwnPropertyDescriptors(original));
};
exports.promisify.custom = kCustomPromisifiedSymbol;
function callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            process.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            process.nextTick(callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, getOwnPropertyDescriptors(original));
    return callbackified;
}
exports.callbackify = callbackify;

},{"bc23a3ea4a141c0b":"5jT8D","6a1c15bae847a134":"amv1q","a42137cd7fc8700d":"iSwSk","a792e8e3e2aa1973":"3qcfW"}],"5jT8D":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"amv1q":[function(require,module,exports,__globalThis) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
var isArgumentsObject = require("6b5f9ae3e436d527");
var isGeneratorFunction = require("285c2b8081bf4b68");
var whichTypedArray = require("e95b88ccd80e1671");
var isTypedArray = require("7db151546a22c2a8");
function uncurryThis(f) {
    return f.call.bind(f);
}
var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';
var ObjectToString = uncurryThis(Object.prototype.toString);
var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);
if (BigIntSupported) var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
if (SymbolSupported) var symbolValue = uncurryThis(Symbol.prototype.valueOf);
function checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
exports.isPromise = isPromise;
function isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return isTypedArray(value) || isDataView(value);
}
exports.isArrayBufferView = isArrayBufferView;
function isUint8Array(value) {
    return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;
function isUint8ClampedArray(value) {
    return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;
function isUint16Array(value) {
    return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;
function isUint32Array(value) {
    return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;
function isInt8Array(value) {
    return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;
function isInt16Array(value) {
    return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;
function isInt32Array(value) {
    return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;
function isFloat32Array(value) {
    return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;
function isFloat64Array(value) {
    return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;
function isBigInt64Array(value) {
    return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;
function isBigUint64Array(value) {
    return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;
function isMapToString(value) {
    return ObjectToString(value) === '[object Map]';
}
isMapToString.working = typeof Map !== 'undefined' && isMapToString(new Map());
function isMap(value) {
    if (typeof Map === 'undefined') return false;
    return isMapToString.working ? isMapToString(value) : value instanceof Map;
}
exports.isMap = isMap;
function isSetToString(value) {
    return ObjectToString(value) === '[object Set]';
}
isSetToString.working = typeof Set !== 'undefined' && isSetToString(new Set());
function isSet(value) {
    if (typeof Set === 'undefined') return false;
    return isSetToString.working ? isSetToString(value) : value instanceof Set;
}
exports.isSet = isSet;
function isWeakMapToString(value) {
    return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = typeof WeakMap !== 'undefined' && isWeakMapToString(new WeakMap());
function isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return isWeakMapToString.working ? isWeakMapToString(value) : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;
function isWeakSetToString(value) {
    return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = typeof WeakSet !== 'undefined' && isWeakSetToString(new WeakSet());
function isWeakSet(value) {
    return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;
function isArrayBufferToString(value) {
    return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && isArrayBufferToString(new ArrayBuffer());
function isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return isArrayBufferToString.working ? isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;
function isDataViewToString(value) {
    return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return isDataViewToString.working ? isDataViewToString(value) : value instanceof DataView;
}
exports.isDataView = isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
    return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
    if (typeof SharedArrayBufferCopy === 'undefined') return false;
    if (typeof isSharedArrayBufferToString.working === 'undefined') isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
    return isSharedArrayBufferToString.working ? isSharedArrayBufferToString(value) : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;
function isAsyncFunction(value) {
    return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;
function isMapIterator(value) {
    return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;
function isSetIterator(value) {
    return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;
function isGeneratorObject(value) {
    return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;
function isWebAssemblyCompiledModule(value) {
    return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
function isNumberObject(value) {
    return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;
function isStringObject(value) {
    return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;
function isBooleanObject(value) {
    return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;
function isBigIntObject(value) {
    return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;
function isSymbolObject(value) {
    return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;
function isBoxedPrimitive(value) {
    return isNumberObject(value) || isStringObject(value) || isBooleanObject(value) || isBigIntObject(value) || isSymbolObject(value);
}
exports.isBoxedPrimitive = isBoxedPrimitive;
function isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && (isArrayBuffer(value) || isSharedArrayBuffer(value));
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

},{"6b5f9ae3e436d527":"ikBfj","285c2b8081bf4b68":"7ikTm","e95b88ccd80e1671":"rQv5T","7db151546a22c2a8":"1VM4Q"}],"7ikTm":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("7f8723b0ba578595");
var safeRegexTest = require("32324cc769caa0cc");
var isFnRegex = safeRegexTest(/^\s*(?:function)?\*/);
var hasToStringTag = require("b42ab74c25dbb155")();
var getProto = require("4729fa737ebfd9c1");
var toStr = callBound('Object.prototype.toString');
var fnToStr = callBound('Function.prototype.toString');
var getGeneratorFunc = function() {
    if (!hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
/** @type {undefined | false | null | GeneratorFunctionConstructor} */ var GeneratorFunction;
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if (isFnRegex(fnToStr(fn))) return true;
    if (!hasToStringTag) {
        var str = toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!getProto) return false;
    if (typeof GeneratorFunction === 'undefined') {
        var generatorFunc = getGeneratorFunc();
        GeneratorFunction = generatorFunc ? /** @type {GeneratorFunctionConstructor} */ getProto(generatorFunc) : false;
    }
    return getProto(fn) === GeneratorFunction;
};

},{"7f8723b0ba578595":"dhWMF","32324cc769caa0cc":"joaPu","b42ab74c25dbb155":"daNF4","4729fa737ebfd9c1":"8CcHr"}],"joaPu":[function(require,module,exports,__globalThis) {
'use strict';
var callBound = require("39b5e226f465bdc3");
var isRegex = require("a52af5ff2805a373");
var $exec = callBound('RegExp.prototype.exec');
var $TypeError = require("e0ef9e92c1444ab0");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!isRegex(regex)) throw new $TypeError('`regex` must be a RegExp');
    return function test(s) {
        return $exec(regex, s) !== null;
    };
};

},{"39b5e226f465bdc3":"dhWMF","a52af5ff2805a373":"YNqlw","e0ef9e92c1444ab0":"4FiSx"}],"rQv5T":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var forEach = require("2941d48f36957e3c");
var availableTypedArrays = require("beaf5502a5823cce");
var callBind = require("e5d203a1b4c809f9");
var callBound = require("c1f328b1ef67e936");
var gOPD = require("ce6b45c571ba4e3e");
/** @type {(O: object) => string} */ var $toString = callBound('Object.prototype.toString');
var hasToStringTag = require("9e7ef6c88184c56")();
var g = typeof globalThis === 'undefined' ? global : globalThis;
var typedArrays = availableTypedArrays();
var $slice = callBound('String.prototype.slice');
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var cache = {
    __proto__: null
};
if (hasToStringTag && gOPD && getPrototypeOf) forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = gOPD(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = gOPD(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        cache['$' + typedArray] = callBind(descriptor.get);
    }
});
else forEach(typedArrays, function(typedArray) {
    var arr = new g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    cache['$' + typedArray] = callBind(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ('$' + getter(value) === typedArray) found = $slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    forEach(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!hasToStringTag) {
        /** @type {string} */ var tag = $slice($toString(value), 8, -1);
        if ($indexOf(typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return trySlices(value);
    }
    if (!gOPD) return null;
     // unknown engine
    return tryTypedArrays(value);
};

},{"2941d48f36957e3c":"eq62e","beaf5502a5823cce":"jzp1M","e5d203a1b4c809f9":"hMR6y","c1f328b1ef67e936":"dhWMF","ce6b45c571ba4e3e":"iyLmA","9e7ef6c88184c56":"daNF4"}],"eq62e":[function(require,module,exports,__globalThis) {
'use strict';
var isCallable = require("e50ebc24bbb25feb");
var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if (hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if (hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if (toStr.call(list) === '[object Array]') forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') forEachString(list, iterator, receiver);
    else forEachObject(list, iterator, receiver);
};
module.exports = forEach;

},{"e50ebc24bbb25feb":"3iOA5"}],"3iOA5":[function(require,module,exports,__globalThis) {
'use strict';
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw isCallableMarker;
        }
    });
    isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    reflectApply(function() {
        throw 42;
    }, null, badArrayLike);
} catch (_) {
    if (_ !== isCallableMarker) reflectApply = null;
}
else reflectApply = null;
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = fnToStr.call(value);
        return constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if (isES6ClassFn(value)) return false;
        fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var all = document.all;
    if (toStr.call(all) === toStr.call(document.all)) isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = toStr.call(value);
            return (str === ddaClass || str === ddaClass2 || str === ddaClass3 // opera 12.16
             || str === objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = reflectApply ? function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        reflectApply(value, null, badArrayLike);
    } catch (e) {
        if (e !== isCallableMarker) return false;
    }
    return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable(value) {
    if (isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if (hasToStringTag) return tryFunctionObject(value);
    if (isES6ClassFn(value)) return false;
    var strClass = toStr.call(value);
    if (strClass !== fnClass && strClass !== genClass && !/^\[object HTML/.test(strClass)) return false;
    return tryFunctionObject(value);
};

},{}],"jzp1M":[function(require,module,exports,__globalThis) {
var global = arguments[3];
'use strict';
var possibleNames = require("3021d1584ad62785");
var g = typeof globalThis === 'undefined' ? global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < possibleNames.length; i++)if (typeof g[possibleNames[i]] === 'function') // @ts-expect-error
    out[out.length] = possibleNames[i];
    return out;
};

},{"3021d1584ad62785":"dBrCY"}],"dBrCY":[function(require,module,exports,__globalThis) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

},{}],"1VM4Q":[function(require,module,exports,__globalThis) {
'use strict';
var whichTypedArray = require("ccf73e5f240c2b8");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!whichTypedArray(value);
};

},{"ccf73e5f240c2b8":"rQv5T"}],"iSwSk":[function(require,module,exports,__globalThis) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

},{}],"3qcfW":[function(require,module,exports,__globalThis) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

},{}],"8rmpk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveUpload", ()=>saveUpload);
parcelHelpers.export(exports, "saveTemplate", ()=>saveTemplate);
parcelHelpers.export(exports, "saveRDTemplate", ()=>saveRDTemplate);
parcelHelpers.export(exports, "scheduleAssessment", ()=>scheduleAssessment);
parcelHelpers.export(exports, "scheduleComment", ()=>scheduleComment);
parcelHelpers.export(exports, "scheduleEvent", ()=>scheduleEvent);
parcelHelpers.export(exports, "scheduleUpload", ()=>scheduleUpload);
parcelHelpers.export(exports, "editSchedule", ()=>editSchedule);
parcelHelpers.export(exports, "editAssessmentSchedule", ()=>editAssessmentSchedule);
parcelHelpers.export(exports, "rescheduleEvent", ()=>rescheduleEvent);
parcelHelpers.export(exports, "deleteEvent", ()=>deleteEvent);
parcelHelpers.export(exports, "deletePlanTemplate", ()=>deletePlanTemplate);
parcelHelpers.export(exports, "renamePlanTemplate", ()=>renamePlanTemplate);
parcelHelpers.export(exports, "sendAssessment", ()=>sendAssessment);
parcelHelpers.export(exports, "deleteAssessment", ()=>deleteAssessment);
parcelHelpers.export(exports, "cloneAssessment", ()=>cloneAssessment);
parcelHelpers.export(exports, "savePlan", ()=>savePlan);
parcelHelpers.export(exports, "reschedulePlan", ()=>reschedulePlan);
parcelHelpers.export(exports, "deletePlan", ()=>deletePlan);
parcelHelpers.export(exports, "deleteCycle", ()=>deleteCycle);
parcelHelpers.export(exports, "createCycle", ()=>createCycle);
parcelHelpers.export(exports, "editCycle", ()=>editCycle);
parcelHelpers.export(exports, "duplicatePlan", ()=>duplicatePlan);
parcelHelpers.export(exports, "switchToClassic", ()=>switchToClassic);
parcelHelpers.export(exports, "uiInformed", ()=>uiInformed);
parcelHelpers.export(exports, "logout", ()=>logout);
parcelHelpers.export(exports, "deleteUploadedLesson", ()=>deleteUploadedLesson);
var _url = require("../helpers/url");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _command = require("../helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
async function saveUpload({ name: name1, subject, grade, file }) {
    const upload = (0, _commandDefault.default)('teacher', 'save_upload');
    const [{ id }] = await upload({
        Name: name1,
        Subject: subject,
        Grade: grade
    });
    return (0, _commandDefault.default)('teacher', 'hash')({
        id,
        file
    });
}
function saveTemplate(name1, plan) {
    const save = (0, _commandDefault.default)('teacher', 'saveTemplate', {
        method: 'POST'
    });
    const items = plan.items.map(({ name: name1, content }, order)=>({
            name: name1,
            order,
            content
        }));
    return save({
        name: name1,
        items
    });
}
function saveRDTemplate(name1, plan) {
    const save = (0, _commandDefault.default)('teacher', 'saveTemplate', {
        method: 'POST'
    });
    const items = plan.items.map(({ name: name1, element }, order)=>({
            name: name1,
            order,
            element
        }));
    return save({
        name: `rd-${name1}`,
        items
    });
}
function scheduleAssessment({ id, title, language, course, message, action, students, start, finish, maxTime }) {
    const schedule = (0, _commandDefault.default)('teacher', 'schedule_event', {
        method: 'POST'
    });
    return schedule({
        Type: 'a.assignment',
        Title: id,
        Clique: students[0].teacher,
        Content: {
            title: title || message,
            course,
            language,
            message,
            subject: course.substring(0, 2),
            linked: true
        },
        MaxTime: maxTime,
        Start: (0, _momentDefault.default)(start).toISOString(),
        Finish: (0, _momentDefault.default)(finish).toISOString(),
        Students: students.map(({ id })=>id)
    });
}
function scheduleComment({ language, subject, message, action, students, date }) {
    const schedule = (0, _commandDefault.default)('teacher', 'schedule_event', {
        method: 'POST'
    });
    const isoDate = (0, _momentDefault.default)(date).toISOString();
    return schedule({
        Type: 'comment',
        Title: 'comment',
        Clique: students[0].teacher,
        Content: {
            language: language,
            message: message,
            subject: subject,
            linked: false
        },
        Start: isoDate,
        Finish: isoDate,
        Students: students.map(({ id })=>id)
    });
}
function scheduleEvent({ lesson, language, message, action, students, date }) {
    const schedule = (0, _commandDefault.default)('teacher', 'schedule_event', {
        method: 'POST'
    });
    const isoDate = (0, _momentDefault.default)(date).toISOString();
    return schedule({
        Type: 'schedule',
        Title: lesson.id,
        Clique: students[0].teacher,
        Content: {
            language: language,
            message: message,
            subject: lesson.id.substring(0, 2),
            linked: action == 'schedule'
        },
        Start: isoDate,
        Finish: isoDate,
        Students: students.map(({ id })=>id)
    });
}
function scheduleUpload({ upload, profile, url, language, message, action, students, date }) {
    const schedule = (0, _commandDefault.default)('teacher', 'schedule_event', {
        method: 'POST'
    });
    const isoDate = (0, _momentDefault.default)(date).toISOString();
    return schedule({
        Type: 'uploaded',
        Title: upload.id,
        Clique: students[0].teacher,
        Content: {
            title: upload.name,
            language,
            url: (0, _url.subdomainLink)('download', profile.domain, profile.Passport.userName, 'lesson', name),
            message,
            subject: upload.subject,
            linked: action == 'schedule'
        },
        Start: isoDate,
        Finish: isoDate,
        Students: students.map(({ id })=>id)
    });
}
function editSchedule({ content, event, group, language, message, action, students, date }) {
    const schedule = (0, _commandDefault.default)('teacher', 'schedule_event', {
        method: 'POST'
    });
    const isoDate = (0, _momentDefault.default)(date).toISOString();
    return schedule({
        Type: 'schedule',
        Event: event,
        Clique: students[0].teacher,
        Content: {
            ...content,
            language: language,
            message: message,
            subject: group.course.substring(0, 2),
            linked: action == 'schedule'
        },
        Start: isoDate,
        Finish: isoDate,
        Students: students.map(({ id })=>id)
    });
}
function editAssessmentSchedule({ title, content, event, group, language, message, action, students, start, finish, maxTime }) {
    const schedule = (0, _commandDefault.default)('teacher', 'schedule_event', {
        method: 'POST'
    });
    const isoDate = (date)=>(0, _momentDefault.default)(date).toISOString();
    const args = {
        Type: 'a.assignment',
        Title: title,
        Event: event,
        Clique: students[0].teacher,
        Content: {
            ...content,
            language: language,
            message: message,
            max_time: maxTime,
            subject: group.course.substring(0, 2),
            linked: action == 'schedule'
        },
        MaxTime: maxTime,
        Start: isoDate(start),
        Finish: isoDate(finish),
        Students: students.map(({ id })=>id)
    };
    return schedule(args);
}
function rescheduleEvent(id, start, finish) {
    const schedule = (0, _commandDefault.default)('teacher', 'reschedule_event', {
        method: 'GET'
    });
    return schedule({
        Event: id,
        Start: (0, _momentDefault.default)(start).toISOString(),
        Finish: (0, _momentDefault.default)(finish).toISOString()
    });
}
function deleteEvent(id) {
    return (0, _commandDefault.default)('teacher', 'delete_schedule', {
        method: 'GET'
    })({
        Event: id
    });
}
function deletePlanTemplate(id) {
    return (0, _commandDefault.default)('teacher', 'deletePlanTemplate', {
        method: 'GET'
    })({
        id
    });
}
function renamePlanTemplate(id, name1) {
    return (0, _commandDefault.default)('teacher', 'renamePlanTemplate', {
        method: 'GET'
    })({
        id,
        name: name1
    });
}
function sendAssessment(teacher, assessment) {
    return (0, _commandDefault.default)('teachers', `${teacher}/assessment_templates/${assessment.id}`, {
        method: 'PUT',
        server: (0, _url.subdomainResource)('assessment')
    })(assessment);
}
function deleteAssessment(teacher, assessment) {
    return (0, _commandDefault.default)('teachers', `${teacher}/assessment_templates/${assessment}`, {
        method: 'DELETE',
        server: (0, _url.subdomainResource)('assessment')
    })();
}
function cloneAssessment({ teacher, id }, name1) {
    return (0, _commandDefault.default)('teachers', `${teacher}/assessment_templates/${id}/deep_copy`, {
        method: 'POST',
        server: (0, _url.subdomainResource)('assessment'),
        sendAsArgs: true
    })({
        name: name1
    });
}
function savePlan(plan, template) {
    const save = (0, _commandDefault.default)('teacher', 'savePlan', {
        method: 'POST'
    });
    const items = plan.items.map(({ name: name1, content }, order)=>({
            name: name1,
            order,
            content
        }));
    return save({
        ...plan,
        items,
        template
    });
}
function reschedulePlan(plan, start, finish) {
    const schedule = (0, _commandDefault.default)('teacher', 'reschedulePlan', {
        method: 'GET'
    });
    return schedule({
        plan,
        start: (0, _momentDefault.default)(start).toISOString(),
        finish: (0, _momentDefault.default)(finish).toISOString()
    });
}
function deletePlan(id) {
    return (0, _commandDefault.default)('teacher', 'deletePlan', {
        method: 'GET'
    })({
        id
    });
}
function deleteCycle(id) {
    return (0, _commandDefault.default)('planning', 'deleteCycle', {
        method: 'GET'
    })({
        id
    });
}
function createCycle(start, finish, content) {
    return (0, _commandDefault.default)('planning', 'createCycle', {
        method: 'POST'
    })({
        start,
        finish,
        content
    });
}
function editCycle(id, start, finish, content) {
    return (0, _commandDefault.default)('planning', 'editCycle', {
        method: 'POST'
    })({
        id,
        start,
        finish,
        content
    });
}
function duplicatePlan(options) {
    const { start, end } = options;
    return (0, _commandDefault.default)('teacher', 'duplicatePlan', {
        method: 'POST'
    })({
        ...options,
        start: (0, _momentDefault.default)(start).toISOString(),
        end: (0, _momentDefault.default)(end).toISOString()
    });
}
function switchToClassic(error) {
    const update = (0, _commandDefault.default)('teacher', 'updateProperties', {
        method: error ? 'POST' : 'GET'
    });
    return update({
        newEduSystemAsked: true,
        style: 'classic',
        error
    });
}
function uiInformed(error) {
    const update = (0, _commandDefault.default)('teacher', 'updateProperties', 'GET');
    return update({
        uiInformed: true
    });
}
function logout() {
    return (0, _commandDefault.default)('security', 'logout')();
}
function deleteUploadedLesson(id, lesson) {
    const moxie = (0, _commandDefault.default)(null, 'api.php', {
        method: 'GET',
        server: (0, _url.subdomainResource)('moxie')
    })({
        json: JSON.stringify({
            id: 'qwertyGoogleThunder',
            method: 'Delete',
            jsonrpc: '2.0',
            params: {
                paths: [
                    `/lesson/${lesson}`
                ]
            }
        })
    });
    const download = (0, _commandDefault.default)('teacher', 'delete_upload', 'GET')({
        Upload: id
    });
    return Promise.all([
        moxie,
        download
    ]);
}

},{"../helpers/url":"65SQD","moment":"1e4qG","../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65SQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiDomain", ()=>apiDomain);
parcelHelpers.export(exports, "apiHost", ()=>apiHost);
parcelHelpers.export(exports, "apiProtocol", ()=>apiProtocol);
parcelHelpers.export(exports, "environment", ()=>environment);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "contentHost", ()=>contentHost);
parcelHelpers.export(exports, "staticAssetsDomain", ()=>staticAssetsDomain);
parcelHelpers.export(exports, "converseDisabled", ()=>converseDisabled);
parcelHelpers.export(exports, "inViewer", ()=>inViewer);
parcelHelpers.export(exports, "inWindowStore", ()=>inWindowStore);
parcelHelpers.export(exports, "parentDomain", ()=>parentDomain);
parcelHelpers.export(exports, "subdomainResource", ()=>subdomainResource);
parcelHelpers.export(exports, "subdomainLink", ()=>subdomainLink);
parcelHelpers.export(exports, "pdfPreviewLink", ()=>pdfPreviewLink);
parcelHelpers.export(exports, "staticAssetLink", ()=>staticAssetLink);
parcelHelpers.export(exports, "contentLink", ()=>contentLink);
parcelHelpers.export(exports, "viewerGuard", ()=>viewerGuard);
parcelHelpers.export(exports, "parseOrderColumn", ()=>parseOrderColumn);
const apiDomain = "edufile.net";
const apiHost = "api";
const apiProtocol = location.protocol.substring(0, location.protocol.length - 1); //process.env.EDUSYSTEM_API_PROTOCOL
const environment = "production";
const version = "2026.10.28.16.30";
const contentHost = "content";
const staticAssetsDomain = "static.edufile.net";
const converseDisabled = true;
const inViewer = navigator.userAgent.indexOf("EduSystemViewer") !== -1 || location.host.startsWith('localhost');
const inWindowStore = navigator.userAgent.indexOf("EduSystemViewer-WindowsStore") !== -1;
function parentDomain(content, options = {}) {
    const domains = location.hostname.split('.');
    return domains.length > 2 ? domains.slice(1).join('.') : location.hostname;
}
function subdomainResource(subdomain, ...resource) {
    const domain = `${subdomain}.${parentDomain()}`;
    return resource.length == 0 ? domain : `${domain}/${resource.join('/')}`;
}
function subdomainLink(subdomain, ...path) {
    return `//${subdomainResource(subdomain, ...path)}`;
}
function pdfPreviewLink(subdomain, ...resource) {
    const parent = parentDomain(false, {
        devOverride: 'edufile.net'
    });
    const domain = `${subdomain}.${parent}`;
    const pdfUrl = resource.length == 0 ? domain : `${domain}/${resource.join('/')}`;
    return `//download.${parent}/pdfjs/web/viewer.html?file=//${pdfUrl}`;
}
function staticAssetLink(...path) {
    return `//static.${parentDomain(true)}/${path.join('/')}`;
}
function contentLink(passport, ...resource) {
    return `${apiProtocol}://${contentHost}.${parentDomain()}/${passport}/${resource.join('/')}`;
}
function viewerGuard({ target, href }) {
    return inViewer ? {
        target: '_self',
        href: `${href}__blank`
    } : {
        target,
        href
    };
}
function parseOrderColumn(orderBy, defaultColumn) {
    const order = orderBy ? orderBy.startsWith('-') ? 'desc' : 'asc' : 'asc';
    const orderColumn = (order == 'asc' ? orderBy : orderBy.substring(1)) || defaultColumn;
    return {
        order,
        orderColumn
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1e4qG":[function(require,module,exports,__globalThis) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

},{}],"f3cbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPublicPost", ()=>createPublicPost);
parcelHelpers.export(exports, "requestPDF", ()=>requestPDF);
parcelHelpers.export(exports, "createPost", ()=>createPost);
parcelHelpers.export(exports, "createPublic", ()=>createPublic);
parcelHelpers.export(exports, "mapParameters", ()=>mapParameters);
parcelHelpers.export(exports, "createDelayed", ()=>createDelayed);
parcelHelpers.export(exports, "default", ()=>create);
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _url = require("./url");
const browser = (0, _bowserDefault.default).getParser(window.navigator.userAgent).getBrowser();
function createPublicPost(name, options) {
    return createPost('public', name, options);
}
function requestPDF(filename, html) {
    const req = new XMLHttpRequest();
    req.open("POST", '//' + (0, _url.subdomainResource)((0, _url.apiHost), 'pdf'), true);
    req.setRequestHeader('Content-Type', 'application/json');
    req.responseType = 'blob';
    req.onreadystatechange = ()=>{
        const completed = req.readyState === 4 && req.status === 200;
        if (!completed) return;
        switch(browser.name){
            case 'Microsoft Edge':
            case 'Internet Explorer':
                const blob = new Blob([
                    req.response
                ], {
                    type: 'application/pdf'
                });
                window.navigator.msSaveBlob(blob, filename);
                break;
            case 'Chrome':
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(req.response);
                link.download = filename;
                link.click();
                break;
            default:
                var file = new File([
                    req.response
                ], filename, {
                    type: 'application/force-download'
                });
                window.open(URL.createObjectURL(file));
        }
    };
    req.send(JSON.stringify({
        filename,
        html
    }));
}
function createPost(context, name, options = {}) {
    return create(context, name, {
        method: 'POST',
        ...options
    });
}
function createPublic(name, options) {
    return create('public', name, options);
}
function mapParameters(command, map) {
    return (...parameters)=>command(map(...parameters));
}
function createDelayed(context, name, delay = 800, options) {
    let timeout;
    const command = create(context, name, options);
    return (parameters)=>new Promise((resolve)=>{
            const execute = ()=>command(parameters).then(resolve);
            clearTimeout(timeout);
            timeout = setTimeout(execute, delay);
        });
}
function create(context, name, options = {}) {
    const { method = 'GET', sendAsArgs = false, protocol = (0, _url.apiProtocol), server = (0, _url.subdomainResource)((0, _url.apiHost)), mapParameters = (a)=>a, mapResponse = (a)=>a } = options;
    const commandUrl = context ? `${protocol}://${server}/${context}/${name}` : `${protocol}://${server}/${name}`;
    const language = location.hash.substring(2, 4);
    const requestOptions = {
        method: method,
        cache: 'no-store',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Accept-Language': language
        }),
        mode: 'cors',
        redirect: 'follow',
        credentials: 'include'
    };
    return async (args)=>{
        const parameters = mapParameters(args);
        const url = (method == 'GET' || sendAsArgs) && parameters ? `${commandUrl}?${(0, _queryStringDefault.default).stringify(parameters)}` : commandUrl;
        let settings = requestOptions;
        if (method != 'GET' && parameters) settings = {
            ...requestOptions,
            body: JSON.stringify(parameters)
        };
        const response = await fetch(url, settings);
        if (response.ok) {
            if (response.status != 200) return true;
            const contentType = /^(.*?)(;|$)/.exec(response.headers.get('content-type'))[1];
            switch(contentType){
                case 'application/json':
                    return mapResponse(await response.json());
                default:
                    return true;
            }
        } else throw response;
    };
}

},{"bowser":"fJVhI","query-string":"h6dFx","./url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fJVhI":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

},{}],"5VRKp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _pathToRegexp = require("path-to-regexp");
var _bluebird = require("bluebird");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDnd = require("react-dnd");
var _reactDndHtml5Backend = require("react-dnd-html5-backend");
var _reactDndHtml5BackendDefault = parcelHelpers.interopDefault(_reactDndHtml5Backend);
var _reactRouterDom = require("react-router-dom");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _topbar = require("./components/topbar");
var _topbarDefault = parcelHelpers.interopDefault(_topbar);
var _navigation = require("./components/navigation");
var _navigationDefault = parcelHelpers.interopDefault(_navigation);
var _menu = require("./components/menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _page = require("./components/page");
var _pageDefault = parcelHelpers.interopDefault(_page);
var _index = require("./roles/teacher/index");
var _planningPdf = require("./components/planning-pdf");
var _planningPdfDefault = parcelHelpers.interopDefault(_planningPdf);
var _roles = require("./roles");
var _rolesDefault = parcelHelpers.interopDefault(_roles);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _sprintfJs = require("sprintf-js");
var _chat = require("./components/chat");
var _chatDefault = parcelHelpers.interopDefault(_chat);
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _api = require("./helpers/api");
var _themes = require("themes");
var _themesDefault = parcelHelpers.interopDefault(_themes);
var _users = require("helpers/users");
var _keepAliveForm = require("components/KeepAliveForm");
var _keepAliveFormDefault = parcelHelpers.interopDefault(_keepAliveForm);
function searchElement(url) {
    const index = url.indexOf('?');
    return index < 0 ? '' : url.substr(index + 1);
}
function getQueryString(query, newQuery, clear) {
    const string = (0, _queryStringDefault.default).stringify(clear ? newQuery : {
        ...query,
        ...newQuery
    });
    return string == '' ? '' : `?${string}`;
}
function init(context, [name, fetch]) {
    return (0, _bluebird.resolve)(fetch).then((data)=>({
            ...context,
            [name]: data
        }));
}
const initContext = (0, _bluebird.reduce)(Object.entries(_api), init, {});
async function App() {
    const context = await initContext;
    const { languages, profile, settings } = context;
    const matchLanguage = (language)=>languages.find(({ id })=>id == language);
    const { last_language: lastLanguage, role } = profile.Passport;
    const { project, premium, noChat, locked = false, lockedMessage = {
        date: '2024-01-10',
        title: 'Aviso',
        message: 'Locked'
    } } = profile.institution;
    const loadChat = premium;
    const defaultPage = settings.defaults[project][role].page;
    const defaultRedirect = ({ match: { params: { language: id, page } } })=>{
        const language = matchLanguage(id);
        const url = page || defaultPage;
        const link = `/${(language || lastLanguage).id}/${role}/${url}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
            to: link
        });
    };
    const App = ({ match, history })=>{
        const [profile, setProfile] = (0, _react.useState)(context.profile);
        const refreshProfile = ()=>{
            (0, _users.getProfile)().then(([newProfile])=>{
                setProfile({
                    ...profile,
                    ...newProfile
                });
            });
        };
        const query = (0, _queryStringDefault.default).parse(searchElement(location.hash));
        const language = matchLanguage(match.params.languageId);
        (0, _momentDefault.default).locale(language.id);
        const link = (params, path = match.path, options = {})=>{
            const buildPath = (0, _pathToRegexp.compile)(path);
            let linkPath = buildPath(options.override ? params : {
                ...match.params,
                ...params
            });
            let linkQuery = options.preserveQuery ? {
                ...query,
                ...options.query || {}
            } : options.query;
            if (!(0, _lodash.isEqual)(linkQuery, {})) {
                if (linkQuery) linkPath = `${linkPath}?${(0, _queryStringDefault.default).stringify(linkQuery)}`;
                else if (options.preserveQuery) linkPath = `${linkPath}?${(0, _queryStringDefault.default).stringify(linkQuery)}`;
            }
            return linkPath.replace(/\?$/, '');
        };
        const linkQuery = (link, query, clearQuery)=>`${link}${getQueryString(props.query, query, clearQuery)}`;
        const navigate = (params, path = match.path, options)=>{
            const pathname = link(params, path, options);
            if (location.hash.substring(1) != pathname) history.push(pathname);
        };
        const translate = (key, params)=>{
            const translations = context.translations[key] || {};
            const translation = translations[match.params.languageId];
            if (translation) return params ? (0, _sprintfJs.sprintf)(translation, params) : translation;
            else return key;
        };
        const props = {
            ...context,
            profile,
            locked,
            lockedMessage,
            refreshProfile,
            ...match.params,
            translate,
            query,
            link,
            linkQuery,
            navigate,
            match,
            history,
            language,
            defaultRedirect: defaultRedirect({
                match
            })
        };
        const page = (0, _react.useMemo)(()=>{
            return match.params.page || 'dashboard';
        }, [
            match.params
        ]);
        const TeacherPage = (0, _react.useMemo)(()=>{
            return (0, _index.teacherPages)[page] || (0, _index.teacherPages)['dashboard'];
        }, [
            page
        ]);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextDefault.default), {
            ...props,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
                children: ({ languageId, translations, role, page, sizes, setState })=>{
                    /*
          if (converse && converse.saveWindowState) {
            converse.saveWindowState({type: page == 'chat' ? 'focus' : 'blur'})
          }
          */ /*
          if (page == 'chat' && !loadChat) return setTimeout(() => navigate({page: 'premium-required'}, '/:languageId/:role/:page'), 0)
          */ if (page == 'planning-pdf') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        language: languageId,
                        dictionary: translations,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planningPdfDefault.default), {})
                    });
                    else return (0, _rolesDefault.default)[role] && (0, _rolesDefault.default)[role][page] || page == 'chat' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        language: languageId,
                        dictionary: translations,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themes.StyledEngineProvider), {
                            injectFirst: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themes.LegacyThemeProvider), {
                                theme: (0, _themesDefault.default),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themes.ThemeProvider), {
                                    theme: (0, _themesDefault.default),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDnd.DndProvider), {
                                        backend: (0, _reactDndHtml5BackendDefault.default),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topbarDefault.default), {}),
                                            !locked && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationDefault.default), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keepAliveFormDefault.default), {}),
                                            !noChat && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatDefault.default), {
                                                width: sizes.width,
                                                pageName: page,
                                                style: {
                                                    display: page == 'chat' ? 'flex' : 'none',
                                                    'flexGrow': 1,
                                                    width: `${sizes.width}px`
                                                }
                                            }),
                                            page != 'chat' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `page ${page}`,
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(TeacherPage, {})
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                        to: defaultRedirect
                    });
                }
            })
        });
    };
    const uuid = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
    return ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/",
                    render: defaultRedirect
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId",
                    render: defaultRedirect
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role",
                    render: defaultRedirect
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(my-courses)/:course(C...G..)?/:unit(\\d\\d)?",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(my-courses)/:course(C...G..)?/:unit(\\d\\d)?/:action(schedule|posts)/:lesson(C...G..U\\d\\dL\\d\\d)",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(dashboard)",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(catalogue)/:subject(C.)?/:course(C...G..)?/:unit(\\d\\d)?",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(catalogue)/:subject(C.)?/:course(C...G..)?/:unit(\\d\\d)?/:action(schedule|posts)/:lesson(C...G..U\\d\\dL\\d\\d)",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(catalogue)/:subject(C.)?/:searching(lessons)",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(catalogue)/:subject(C.)?/:searching(lessons)?/:action(schedule|posts)/:lesson(C...G..U\\d\\dL\\d\\d)",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(monitoring)/:section(groups)?",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(monitoring)/:groupId(${uuid})?/:section(students)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(monitoring)/:groupId(${uuid})?/:section(student)/:studentId(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(calendars)/:view(month|day|week)?/:action(comment)?",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(calendars)/:view(day)/:action(schedule|posts)/:event(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: "/:languageId/:role/:page(my-lessons)",
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(my-lessons)/:action(schedule|posts)/:upload(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(planning|planning-rd)/:view(month|week|day)?/:action(pdf|duplicate)?/:planId(${uuid})?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(planning|planning-rd)/:view(plan|plan-rd)/:planId(${uuid})?/:section(templates|add-lessons|add-standards|add-link-resource)?/:activeTab(catalogue|my-lessons)?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(planning|planning-rd)/:view(preview|preview-rd)/:planId(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(planning-pdf)/:group(${uuid})?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(resources)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(help)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role(admin)/:page(groups)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(chat)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(premium-required)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(rollbook)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(gradebook)/:groupId(${uuid})?/:studentId(${uuid})?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(homework)/:homeworkId(${uuid})?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(assessment)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(assessment)/:action(schedule)/:assessment(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/quiz`,
                    render: (props)=>{
                        const { languageId, role } = props.match.params;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                            to: `/${languageId}/${role}/quiz/assessments`
                        });
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/imported-test/:attemptId(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:action(schedule)/:assessment(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:tab(assessments|question-bank|assessment-bank|assigned)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:tab(assessments|question-bank|assessment-bank|assigned)/:sectionName(standards-search)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:tab(assessments|question-bank|assessment-bank|assigned)/:assessment(${uuid})/:sectionName(standards)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:tab(assigned)/:assignmentId(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:tab(question-bank)/:sectionName(edit-question|new-question)/:questionId(${uuid})/:operation(add-standards)?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:assessment(${uuid})/:action(edit|preview)/:sectionName(standards)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:assessment(${uuid})/:action(edit|preview|review|take|preview-results|standards-results)/:sectionId(${uuid})?/:questionId(${uuid})?/:operation(add-standards)?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(quiz)/:assessment(${uuid})/:action(edit)/:sectionId(${uuid})?/:questionId(${uuid})?/:sectionName(standards-search)`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(grading)/:section(create-school-year|books|book)?`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(grading)/:section(book)/:bookId(${uuid})`,
                    component: App
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    exact: true,
                    path: `/:languageId/:role/:page(videos)`,
                    component: App
                })
            ]
        });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","path-to-regexp":"3G4we","bluebird":"1NtHA","react":"9njXz","react-dnd":"9NZ1L","react-dnd-html5-backend":"hla4A","react-router-dom":"3uzXR","react-text":"lEpdJ","./components/topbar":"8JC9w","./components/navigation":"XdIgA","./components/menu":"iYRw9","./components/page":"6ShgF","./roles/teacher/index":"kFFrW","./components/planning-pdf":"lruE9","./roles":"hZ9q9","query-string":"h6dFx","sprintf-js":"lQMWj","./components/chat":"6e0eV","./context":"iUP37","./helpers/api":"8hlxJ","themes":"jxjTT","helpers/users":"43gbr","components/KeepAliveForm":"lu9ca","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qc47":[function(require,module,exports,__globalThis) {
var global = arguments[3];
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

},{}],"3G4we":[function(require,module,exports,__globalThis) {
/**
 * Tokenize input string.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parse a string for the raw tokens.
 */ parcelHelpers.export(exports, "parse", ()=>parse);
/**
 * Compile a string to a template function for the path.
 */ parcelHelpers.export(exports, "compile", ()=>compile);
/**
 * Expose a method for transforming tokens into the path function.
 */ parcelHelpers.export(exports, "tokensToFunction", ()=>tokensToFunction);
/**
 * Create path match function from `path-to-regexp` spec.
 */ parcelHelpers.export(exports, "match", ()=>match);
/**
 * Create a path match function from `path-to-regexp` output.
 */ parcelHelpers.export(exports, "regexpToFunction", ()=>regexpToFunction);
/**
 * Expose a function for taking tokens and returning a RegExp.
 */ parcelHelpers.export(exports, "tokensToRegexp", ()=>tokensToRegexp);
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 */ parcelHelpers.export(exports, "pathToRegexp", ()=>pathToRegexp);
function lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at " + i);
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at " + j);
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at " + j);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at " + i);
            if (!pattern) throw new TypeError("Missing pattern at " + i);
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function parse(str, options) {
    if (options === void 0) options = {};
    var tokens = lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a;
    var defaultPattern = "[^" + escapeString(options.delimiter || "/#?") + "]+?";
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected " + nextType + " at " + index + ", expected " + type);
    };
    var consumeText = function() {
        var result = "";
        var value;
        // tslint:disable-next-line
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? defaultPattern : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function compile(str, options) {
    return tokensToFunction(parse(str, options), options);
}
function tokensToFunction(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:" + token.pattern + ")$", reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"" + token.name + "\" to not repeat, but got an array");
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"" + token.name + "\" to not be empty");
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"" + token.name + "\" to match \"" + token.pattern + "\", but got \"" + segment + "\"");
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"" + token.name + "\" to be " + typeOfMessage);
        }
        return path;
    };
}
function match(str, options) {
    var keys = [];
    var re = pathToRegexp(str, keys, options);
    return regexpToFunction(re, keys, options);
}
function regexpToFunction(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            // tslint:disable-next-line
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: "",
        suffix: "",
        modifier: "",
        pattern: ""
    });
    return path;
}
/**
 * Transform an array into a regexp.
 */ function arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return pathToRegexp(path, keys, options).source;
    });
    return new RegExp("(?:" + parts.join("|") + ")", flags(options));
}
/**
 * Create a path regexp from string input.
 */ function stringToRegexp(path, keys, options) {
    return tokensToRegexp(parse(path, options), keys, options);
}
function tokensToRegexp(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d;
    var endsWith = "[" + escapeString(options.endsWith || "") + "]|$";
    var delimiter = "[" + escapeString(options.delimiter || "/#?") + "]";
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += escapeString(encode(token));
        else {
            var prefix = escapeString(encode(token.prefix));
            var suffix = escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:" + prefix + "((?:" + token.pattern + ")(?:" + suffix + prefix + "(?:" + token.pattern + "))*)" + suffix + ")" + mod;
                    } else route += "(?:" + prefix + "(" + token.pattern + ")" + suffix + ")" + token.modifier;
                } else route += "(" + token.pattern + ")" + token.modifier;
            } else route += "(?:" + prefix + suffix + ")" + token.modifier;
        }
    }
    if (end) {
        if (!strict) route += delimiter + "?";
        route += !options.endsWith ? "$" : "(?=" + endsWith + ")";
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiter.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:" + delimiter + "(?=" + endsWith + "))?";
        if (!isEndDelimited) route += "(?=" + delimiter + "|" + endsWith + ")";
    }
    return new RegExp(route, flags(options));
}
function pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return regexpToRegexp(path, keys);
    if (Array.isArray(path)) return arrayToRegexp(path, keys, options);
    return stringToRegexp(path, keys, options);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1NtHA":[function(require,module,exports,__globalThis) {
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */ /**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/ var process = require("fb71ed40a9331d76");
var global = arguments[3];
!function(e) {
    var f;
    module.exports = e();
}(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof _dereq_ == "function" && _dereq_;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = typeof _dereq_ == "function" && _dereq_;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var SomePromiseArray = Promise1._SomePromiseArray;
                    function any(promises) {
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(1);
                        ret.setUnwrap();
                        ret.init();
                        return promise;
                    }
                    Promise1.any = function(promises) {
                        return any(promises);
                    };
                    Promise1.prototype.any = function() {
                        return any(this);
                    };
                };
            },
            {}
        ],
        2: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var firstLineError;
                try {
                    throw new Error();
                } catch (e) {
                    firstLineError = e;
                }
                var schedule = _dereq_1("./schedule");
                var Queue = _dereq_1("./queue");
                function Async() {
                    this._customScheduler = false;
                    this._isTickUsed = false;
                    this._lateQueue = new Queue(16);
                    this._normalQueue = new Queue(16);
                    this._haveDrainedQueues = false;
                    var self1 = this;
                    this.drainQueues = function() {
                        self1._drainQueues();
                    };
                    this._schedule = schedule;
                }
                Async.prototype.setScheduler = function(fn) {
                    var prev = this._schedule;
                    this._schedule = fn;
                    this._customScheduler = true;
                    return prev;
                };
                Async.prototype.hasCustomScheduler = function() {
                    return this._customScheduler;
                };
                Async.prototype.haveItemsQueued = function() {
                    return this._isTickUsed || this._haveDrainedQueues;
                };
                Async.prototype.fatalError = function(e, isNode) {
                    if (isNode) {
                        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
                        process.exit(2);
                    } else this.throwLater(e);
                };
                Async.prototype.throwLater = function(fn, arg) {
                    if (arguments.length === 1) {
                        arg = fn;
                        fn = function() {
                            throw arg;
                        };
                    }
                    if (typeof setTimeout !== "undefined") setTimeout(function() {
                        fn(arg);
                    }, 0);
                    else try {
                        this._schedule(function() {
                            fn(arg);
                        });
                    } catch (e) {
                        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                    }
                };
                function AsyncInvokeLater(fn, receiver, arg) {
                    this._lateQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncInvoke(fn, receiver, arg) {
                    this._normalQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncSettlePromises(promise) {
                    this._normalQueue._pushOne(promise);
                    this._queueTick();
                }
                Async.prototype.invokeLater = AsyncInvokeLater;
                Async.prototype.invoke = AsyncInvoke;
                Async.prototype.settlePromises = AsyncSettlePromises;
                function _drainQueue(queue) {
                    while(queue.length() > 0)_drainQueueStep(queue);
                }
                function _drainQueueStep(queue) {
                    var fn = queue.shift();
                    if (typeof fn !== "function") fn._settlePromises();
                    else {
                        var receiver = queue.shift();
                        var arg = queue.shift();
                        fn.call(receiver, arg);
                    }
                }
                Async.prototype._drainQueues = function() {
                    _drainQueue(this._normalQueue);
                    this._reset();
                    this._haveDrainedQueues = true;
                    _drainQueue(this._lateQueue);
                };
                Async.prototype._queueTick = function() {
                    if (!this._isTickUsed) {
                        this._isTickUsed = true;
                        this._schedule(this.drainQueues);
                    }
                };
                Async.prototype._reset = function() {
                    this._isTickUsed = false;
                };
                module1.exports = Async;
                module1.exports.firstLineError = firstLineError;
            },
            {
                "./queue": 26,
                "./schedule": 29
            }
        ],
        3: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, debug) {
                    var calledBind = false;
                    var rejectThis = function(_, e) {
                        this._reject(e);
                    };
                    var targetRejected = function(e, context) {
                        context.promiseRejectionQueued = true;
                        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
                    };
                    var bindingResolved = function(thisArg, context) {
                        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
                    };
                    var bindingRejected = function(e, context) {
                        if (!context.promiseRejectionQueued) this._reject(e);
                    };
                    Promise1.prototype.bind = function(thisArg) {
                        if (!calledBind) {
                            calledBind = true;
                            Promise1.prototype._propagateFrom = debug.propagateFromFunction();
                            Promise1.prototype._boundValue = debug.boundValueFunction();
                        }
                        var maybePromise = tryConvertToPromise(thisArg);
                        var ret = new Promise1(INTERNAL);
                        ret._propagateFrom(this, 1);
                        var target = this._target();
                        ret._setBoundTo(maybePromise);
                        if (maybePromise instanceof Promise1) {
                            var context = {
                                promiseRejectionQueued: false,
                                promise: ret,
                                target: target,
                                bindingPromise: maybePromise
                            };
                            target._then(INTERNAL, targetRejected, undefined, ret, context);
                            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
                            ret._setOnCancel(maybePromise);
                        } else ret._resolveCallback(target);
                        return ret;
                    };
                    Promise1.prototype._setBoundTo = function(obj) {
                        if (obj !== undefined) {
                            this._bitField = this._bitField | 2097152;
                            this._boundTo = obj;
                        } else this._bitField = this._bitField & -2097153;
                    };
                    Promise1.prototype._isBound = function() {
                        return (this._bitField & 2097152) === 2097152;
                    };
                    Promise1.bind = function(thisArg, value) {
                        return Promise1.resolve(value).bind(thisArg);
                    };
                };
            },
            {}
        ],
        4: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var old;
                if (typeof Promise !== "undefined") old = Promise;
                function noConflict() {
                    try {
                        if (Promise === bluebird) Promise = old;
                    } catch (e) {}
                    return bluebird;
                }
                var bluebird = _dereq_1("./promise")();
                bluebird.noConflict = noConflict;
                module1.exports = bluebird;
            },
            {
                "./promise": 22
            }
        ],
        5: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var cr = Object.create;
                if (cr) {
                    var callerCache = cr(null);
                    var getterCache = cr(null);
                    callerCache[" size"] = getterCache[" size"] = 0;
                }
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var isIdentifier = util.isIdentifier;
                    var getMethodCaller;
                    var getGetter;
                    var makeMethodCaller, makeGetter, getCompiled;
                    function ensureMethod(obj, methodName) {
                        var fn;
                        if (obj != null) fn = obj[methodName];
                        if (typeof fn !== "function") {
                            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                            throw new Promise1.TypeError(message);
                        }
                        return fn;
                    }
                    function caller(obj) {
                        var methodName = this.pop();
                        var fn = ensureMethod(obj, methodName);
                        return fn.apply(obj, this);
                    }
                    Promise1.prototype.call = function(methodName) {
                        var args = [].slice.call(arguments, 1);
                        var maybeCaller;
                        args.push(methodName);
                        return this._then(caller, undefined, undefined, args, undefined);
                    };
                    function namedGetter(obj) {
                        return obj[this];
                    }
                    function indexedGetter(obj) {
                        var index = +this;
                        if (index < 0) index = Math.max(0, index + obj.length);
                        return obj[index];
                    }
                    Promise1.prototype.get = function(propertyName) {
                        var isIndex = typeof propertyName === "number";
                        var getter;
                        if (!isIndex) {
                            if (canEvaluate) {
                                var maybeGetter = getGetter(propertyName);
                                getter = maybeGetter !== null ? maybeGetter : namedGetter;
                            } else getter = namedGetter;
                        } else getter = indexedGetter;
                        return this._then(getter, undefined, undefined, propertyName, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        6: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    Promise1.prototype["break"] = Promise1.prototype.cancel = function() {
                        if (!debug.cancellation()) return this._warn("cancellation is disabled");
                        var promise = this;
                        var child = promise;
                        while(promise._isCancellable()){
                            if (!promise._cancelBy(child)) {
                                if (child._isFollowing()) child._followee().cancel();
                                else child._cancelBranched();
                                break;
                            }
                            var parent = promise._cancellationParent;
                            if (parent == null || !parent._isCancellable()) {
                                if (promise._isFollowing()) promise._followee().cancel();
                                else promise._cancelBranched();
                                break;
                            } else {
                                if (promise._isFollowing()) promise._followee().cancel();
                                promise._setWillBeCancelled();
                                child = promise;
                                promise = parent;
                            }
                        }
                    };
                    Promise1.prototype._branchHasCancelled = function() {
                        this._branchesRemainingToCancel--;
                    };
                    Promise1.prototype._enoughBranchesHaveCancelled = function() {
                        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
                    };
                    Promise1.prototype._cancelBy = function(canceller) {
                        if (canceller === this) {
                            this._branchesRemainingToCancel = 0;
                            this._invokeOnCancel();
                            return true;
                        } else {
                            this._branchHasCancelled();
                            if (this._enoughBranchesHaveCancelled()) {
                                this._invokeOnCancel();
                                return true;
                            }
                        }
                        return false;
                    };
                    Promise1.prototype._cancelBranched = function() {
                        if (this._enoughBranchesHaveCancelled()) this._cancel();
                    };
                    Promise1.prototype._cancel = function() {
                        if (!this._isCancellable()) return;
                        this._setCancelled();
                        async.invoke(this._cancelPromises, this, undefined);
                    };
                    Promise1.prototype._cancelPromises = function() {
                        if (this._length() > 0) this._settlePromises();
                    };
                    Promise1.prototype._unsetOnCancel = function() {
                        this._onCancelField = undefined;
                    };
                    Promise1.prototype._isCancellable = function() {
                        return this.isPending() && !this._isCancelled();
                    };
                    Promise1.prototype.isCancellable = function() {
                        return this.isPending() && !this.isCancelled();
                    };
                    Promise1.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
                        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                        else if (onCancelCallback !== undefined) {
                            if (typeof onCancelCallback === "function") {
                                if (!internalOnly) {
                                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                                    if (e === errorObj) {
                                        this._attachExtraTrace(e.e);
                                        async.throwLater(e.e);
                                    }
                                }
                            } else onCancelCallback._resultCancelled(this);
                        }
                    };
                    Promise1.prototype._invokeOnCancel = function() {
                        var onCancelCallback = this._onCancel();
                        this._unsetOnCancel();
                        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
                    };
                    Promise1.prototype._invokeInternalOnCancel = function() {
                        if (this._isCancellable()) {
                            this._doInvokeOnCancel(this._onCancel(), true);
                            this._unsetOnCancel();
                        }
                    };
                    Promise1.prototype._resultCancelled = function() {
                        this.cancel();
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        7: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var getKeys = _dereq_1("./es5").keys;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function catchFilter(instances, cb, promise) {
                        return function(e) {
                            var boundTo = promise._boundValue();
                            predicateLoop: for(var i = 0; i < instances.length; ++i){
                                var item = instances[i];
                                if (item === Error || item != null && item.prototype instanceof Error) {
                                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                                } else if (typeof item === "function") {
                                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                                    if (matchesPredicate === errorObj) return matchesPredicate;
                                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                                } else if (util.isObject(e)) {
                                    var keys = getKeys(item);
                                    for(var j = 0; j < keys.length; ++j){
                                        var key = keys[j];
                                        if (item[key] != e[key]) continue predicateLoop;
                                    }
                                    return tryCatch(cb).call(boundTo, e);
                                }
                            }
                            return NEXT_FILTER;
                        };
                    }
                    return catchFilter;
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        8: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var longStackTraces = false;
                    var contextStack = [];
                    Promise1.prototype._promiseCreated = function() {};
                    Promise1.prototype._pushContext = function() {};
                    Promise1.prototype._popContext = function() {
                        return null;
                    };
                    Promise1._peekContext = Promise1.prototype._peekContext = function() {};
                    function Context() {
                        this._trace = new Context.CapturedTrace(peekContext());
                    }
                    Context.prototype._pushContext = function() {
                        if (this._trace !== undefined) {
                            this._trace._promiseCreated = null;
                            contextStack.push(this._trace);
                        }
                    };
                    Context.prototype._popContext = function() {
                        if (this._trace !== undefined) {
                            var trace = contextStack.pop();
                            var ret = trace._promiseCreated;
                            trace._promiseCreated = null;
                            return ret;
                        }
                        return null;
                    };
                    function createContext() {
                        if (longStackTraces) return new Context();
                    }
                    function peekContext() {
                        var lastIndex = contextStack.length - 1;
                        if (lastIndex >= 0) return contextStack[lastIndex];
                        return undefined;
                    }
                    Context.CapturedTrace = null;
                    Context.create = createContext;
                    Context.deactivateLongStackTraces = function() {};
                    Context.activateLongStackTraces = function() {
                        var Promise_pushContext = Promise1.prototype._pushContext;
                        var Promise_popContext = Promise1.prototype._popContext;
                        var Promise_PeekContext = Promise1._peekContext;
                        var Promise_peekContext = Promise1.prototype._peekContext;
                        var Promise_promiseCreated = Promise1.prototype._promiseCreated;
                        Context.deactivateLongStackTraces = function() {
                            Promise1.prototype._pushContext = Promise_pushContext;
                            Promise1.prototype._popContext = Promise_popContext;
                            Promise1._peekContext = Promise_PeekContext;
                            Promise1.prototype._peekContext = Promise_peekContext;
                            Promise1.prototype._promiseCreated = Promise_promiseCreated;
                            longStackTraces = false;
                        };
                        longStackTraces = true;
                        Promise1.prototype._pushContext = Context.prototype._pushContext;
                        Promise1.prototype._popContext = Context.prototype._popContext;
                        Promise1._peekContext = Promise1.prototype._peekContext = peekContext;
                        Promise1.prototype._promiseCreated = function() {
                            var ctx = this._peekContext();
                            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
                        };
                    };
                    return Context;
                };
            },
            {}
        ],
        9: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, Context, enableAsyncHooks, disableAsyncHooks) {
                    var async = Promise1._async;
                    var Warning = _dereq_1("./errors").Warning;
                    var util = _dereq_1("./util");
                    var es5 = _dereq_1("./es5");
                    var canAttachTrace = util.canAttachTrace;
                    var unhandledRejectionHandled;
                    var possiblyUnhandledRejection;
                    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
                    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
                    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
                    var stackFramePattern = null;
                    var formatStack = null;
                    var indentStackFrames = false;
                    var printWarning;
                    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && true);
                    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
                    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
                    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                    var deferUnhandledRejectionCheck;
                    (function() {
                        var promises = [];
                        function unhandledRejectionCheck() {
                            for(var i = 0; i < promises.length; ++i)promises[i]._notifyUnhandledRejection();
                            unhandledRejectionClear();
                        }
                        function unhandledRejectionClear() {
                            promises.length = 0;
                        }
                        deferUnhandledRejectionCheck = function(promise) {
                            promises.push(promise);
                            setTimeout(unhandledRejectionCheck, 1);
                        };
                        es5.defineProperty(Promise1, "_unhandledRejectionCheck", {
                            value: unhandledRejectionCheck
                        });
                        es5.defineProperty(Promise1, "_unhandledRejectionClear", {
                            value: unhandledRejectionClear
                        });
                    })();
                    Promise1.prototype.suppressUnhandledRejections = function() {
                        var target = this._target();
                        target._bitField = target._bitField & -1048577 | 524288;
                    };
                    Promise1.prototype._ensurePossibleRejectionHandled = function() {
                        if ((this._bitField & 524288) !== 0) return;
                        this._setRejectionIsUnhandled();
                        deferUnhandledRejectionCheck(this);
                    };
                    Promise1.prototype._notifyUnhandledRejectionIsHandled = function() {
                        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
                    };
                    Promise1.prototype._setReturnedNonUndefined = function() {
                        this._bitField = this._bitField | 268435456;
                    };
                    Promise1.prototype._returnedNonUndefined = function() {
                        return (this._bitField & 268435456) !== 0;
                    };
                    Promise1.prototype._notifyUnhandledRejection = function() {
                        if (this._isRejectionUnhandled()) {
                            var reason = this._settledValue();
                            this._setUnhandledRejectionIsNotified();
                            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
                        }
                    };
                    Promise1.prototype._setUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField | 262144;
                    };
                    Promise1.prototype._unsetUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField & -262145;
                    };
                    Promise1.prototype._isUnhandledRejectionNotified = function() {
                        return (this._bitField & 262144) > 0;
                    };
                    Promise1.prototype._setRejectionIsUnhandled = function() {
                        this._bitField = this._bitField | 1048576;
                    };
                    Promise1.prototype._unsetRejectionIsUnhandled = function() {
                        this._bitField = this._bitField & -1048577;
                        if (this._isUnhandledRejectionNotified()) {
                            this._unsetUnhandledRejectionIsNotified();
                            this._notifyUnhandledRejectionIsHandled();
                        }
                    };
                    Promise1.prototype._isRejectionUnhandled = function() {
                        return (this._bitField & 1048576) > 0;
                    };
                    Promise1.prototype._warn = function(message, shouldUseOwnTrace, promise) {
                        return warn(message, shouldUseOwnTrace, promise || this);
                    };
                    Promise1.onPossiblyUnhandledRejection = function(fn) {
                        var context = Promise1._getContext();
                        possiblyUnhandledRejection = util.contextBind(context, fn);
                    };
                    Promise1.onUnhandledRejectionHandled = function(fn) {
                        var context = Promise1._getContext();
                        unhandledRejectionHandled = util.contextBind(context, fn);
                    };
                    var disableLongStackTraces = function() {};
                    Promise1.longStackTraces = function() {
                        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        if (!config.longStackTraces && longStackTracesIsSupported()) {
                            var Promise_captureStackTrace = Promise1.prototype._captureStackTrace;
                            var Promise_attachExtraTrace = Promise1.prototype._attachExtraTrace;
                            var Promise_dereferenceTrace = Promise1.prototype._dereferenceTrace;
                            config.longStackTraces = true;
                            disableLongStackTraces = function() {
                                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                                Promise1.prototype._captureStackTrace = Promise_captureStackTrace;
                                Promise1.prototype._attachExtraTrace = Promise_attachExtraTrace;
                                Promise1.prototype._dereferenceTrace = Promise_dereferenceTrace;
                                Context.deactivateLongStackTraces();
                                config.longStackTraces = false;
                            };
                            Promise1.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                            Promise1.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                            Promise1.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                            Context.activateLongStackTraces();
                        }
                    };
                    Promise1.hasLongStackTraces = function() {
                        return config.longStackTraces && longStackTracesIsSupported();
                    };
                    var legacyHandlers = {
                        unhandledrejection: {
                            before: function() {
                                var ret = util.global.onunhandledrejection;
                                util.global.onunhandledrejection = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onunhandledrejection = fn;
                            }
                        },
                        rejectionhandled: {
                            before: function() {
                                var ret = util.global.onrejectionhandled;
                                util.global.onrejectionhandled = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onrejectionhandled = fn;
                            }
                        }
                    };
                    var fireDomEvent = function() {
                        var dispatch = function(legacy, e) {
                            if (legacy) {
                                var fn;
                                try {
                                    fn = legacy.before();
                                    return !util.global.dispatchEvent(e);
                                } finally{
                                    legacy.after(fn);
                                }
                            } else return !util.global.dispatchEvent(e);
                        };
                        try {
                            if (typeof CustomEvent === "function") {
                                var event = new CustomEvent("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var eventData = {
                                        detail: event,
                                        cancelable: true
                                    };
                                    var domEvent = new CustomEvent(name, eventData);
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else if (typeof Event === "function") {
                                var event = new Event("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = new Event(name, {
                                        cancelable: true
                                    });
                                    domEvent.detail = event;
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else {
                                var event = document.createEvent("CustomEvent");
                                event.initCustomEvent("testingtheevent", false, true, {});
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = document.createEvent("CustomEvent");
                                    domEvent.initCustomEvent(name, false, true, event);
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            }
                        } catch (e) {}
                        return function() {
                            return false;
                        };
                    }();
                    var fireGlobalEvent = function() {
                        if (util.isNode) return function() {
                            return process.emit.apply(process, arguments);
                        };
                        else {
                            if (!util.global) return function() {
                                return false;
                            };
                            return function(name) {
                                var methodName = "on" + name.toLowerCase();
                                var method = util.global[methodName];
                                if (!method) return false;
                                method.apply(util.global, [].slice.call(arguments, 1));
                                return true;
                            };
                        }
                    }();
                    function generatePromiseLifecycleEventObject(name, promise) {
                        return {
                            promise: promise
                        };
                    }
                    var eventToObjectGenerator = {
                        promiseCreated: generatePromiseLifecycleEventObject,
                        promiseFulfilled: generatePromiseLifecycleEventObject,
                        promiseRejected: generatePromiseLifecycleEventObject,
                        promiseResolved: generatePromiseLifecycleEventObject,
                        promiseCancelled: generatePromiseLifecycleEventObject,
                        promiseChained: function(name, promise, child) {
                            return {
                                promise: promise,
                                child: child
                            };
                        },
                        warning: function(name, warning) {
                            return {
                                warning: warning
                            };
                        },
                        unhandledRejection: function(name, reason, promise) {
                            return {
                                reason: reason,
                                promise: promise
                            };
                        },
                        rejectionHandled: generatePromiseLifecycleEventObject
                    };
                    var activeFireEvent = function(name) {
                        var globalEventFired = false;
                        try {
                            globalEventFired = fireGlobalEvent.apply(null, arguments);
                        } catch (e) {
                            async.throwLater(e);
                            globalEventFired = true;
                        }
                        var domEventFired = false;
                        try {
                            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
                        } catch (e) {
                            async.throwLater(e);
                            domEventFired = true;
                        }
                        return domEventFired || globalEventFired;
                    };
                    Promise1.config = function(opts) {
                        opts = Object(opts);
                        if ("longStackTraces" in opts) {
                            if (opts.longStackTraces) Promise1.longStackTraces();
                            else if (!opts.longStackTraces && Promise1.hasLongStackTraces()) disableLongStackTraces();
                        }
                        if ("warnings" in opts) {
                            var warningsOption = opts.warnings;
                            config.warnings = !!warningsOption;
                            wForgottenReturn = config.warnings;
                            if (util.isObject(warningsOption)) {
                                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
                            }
                        }
                        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                            Promise1.prototype._clearCancellationData = cancellationClearCancellationData;
                            Promise1.prototype._propagateFrom = cancellationPropagateFrom;
                            Promise1.prototype._onCancel = cancellationOnCancel;
                            Promise1.prototype._setOnCancel = cancellationSetOnCancel;
                            Promise1.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                            Promise1.prototype._execute = cancellationExecute;
                            propagateFromFunction = cancellationPropagateFrom;
                            config.cancellation = true;
                        }
                        if ("monitoring" in opts) {
                            if (opts.monitoring && !config.monitoring) {
                                config.monitoring = true;
                                Promise1.prototype._fireEvent = activeFireEvent;
                            } else if (!opts.monitoring && config.monitoring) {
                                config.monitoring = false;
                                Promise1.prototype._fireEvent = defaultFireEvent;
                            }
                        }
                        if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                            var prev = config.asyncHooks;
                            var cur = !!opts.asyncHooks;
                            if (prev !== cur) {
                                config.asyncHooks = cur;
                                if (cur) enableAsyncHooks();
                                else disableAsyncHooks();
                            }
                        }
                        return Promise1;
                    };
                    function defaultFireEvent() {
                        return false;
                    }
                    Promise1.prototype._fireEvent = defaultFireEvent;
                    Promise1.prototype._execute = function(executor, resolve, reject) {
                        try {
                            executor(resolve, reject);
                        } catch (e) {
                            return e;
                        }
                    };
                    Promise1.prototype._onCancel = function() {};
                    Promise1.prototype._setOnCancel = function(handler) {};
                    Promise1.prototype._attachCancellationCallback = function(onCancel) {};
                    Promise1.prototype._captureStackTrace = function() {};
                    Promise1.prototype._attachExtraTrace = function() {};
                    Promise1.prototype._dereferenceTrace = function() {};
                    Promise1.prototype._clearCancellationData = function() {};
                    Promise1.prototype._propagateFrom = function(parent, flags) {};
                    function cancellationExecute(executor, resolve, reject) {
                        var promise = this;
                        try {
                            executor(resolve, reject, function(onCancel) {
                                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                                promise._attachCancellationCallback(onCancel);
                            });
                        } catch (e) {
                            return e;
                        }
                    }
                    function cancellationAttachCancellationCallback(onCancel) {
                        if (!this._isCancellable()) return this;
                        var previousOnCancel = this._onCancel();
                        if (previousOnCancel !== undefined) {
                            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
                            else this._setOnCancel([
                                previousOnCancel,
                                onCancel
                            ]);
                        } else this._setOnCancel(onCancel);
                    }
                    function cancellationOnCancel() {
                        return this._onCancelField;
                    }
                    function cancellationSetOnCancel(onCancel) {
                        this._onCancelField = onCancel;
                    }
                    function cancellationClearCancellationData() {
                        this._cancellationParent = undefined;
                        this._onCancelField = undefined;
                    }
                    function cancellationPropagateFrom(parent, flags) {
                        if ((flags & 1) !== 0) {
                            this._cancellationParent = parent;
                            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
                            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
                            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
                        }
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    function bindingPropagateFrom(parent, flags) {
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    var propagateFromFunction = bindingPropagateFrom;
                    function boundValueFunction() {
                        var ret = this._boundTo;
                        if (ret !== undefined) {
                            if (ret instanceof Promise1) {
                                if (ret.isFulfilled()) return ret.value();
                                else return undefined;
                            }
                        }
                        return ret;
                    }
                    function longStackTracesCaptureStackTrace() {
                        this._trace = new CapturedTrace(this._peekContext());
                    }
                    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
                        if (canAttachTrace(error)) {
                            var trace = this._trace;
                            if (trace !== undefined) {
                                if (ignoreSelf) trace = trace._parent;
                            }
                            if (trace !== undefined) trace.attachExtraTrace(error);
                            else if (!error.__stackCleaned__) {
                                var parsed = parseStackAndMessage(error);
                                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                                util.notEnumerableProp(error, "__stackCleaned__", true);
                            }
                        }
                    }
                    function longStackTracesDereferenceTrace() {
                        this._trace = undefined;
                    }
                    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
                        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                            if (parent !== undefined && parent._returnedNonUndefined()) return;
                            if ((promise._bitField & 65535) === 0) return;
                            if (name) name = name + " ";
                            var handlerLine = "";
                            var creatorLine = "";
                            if (promiseCreated._trace) {
                                var traceLines = promiseCreated._trace.stack.split("\n");
                                var stack = cleanStack(traceLines);
                                for(var i = stack.length - 1; i >= 0; --i){
                                    var line = stack[i];
                                    if (!nodeFramePattern.test(line)) {
                                        var lineMatches = line.match(parseLinePattern);
                                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                                        break;
                                    }
                                }
                                if (stack.length > 0) {
                                    var firstUserLine = stack[0];
                                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                                        break;
                                    }
                                }
                            }
                            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
                            promise._warn(msg, true, promiseCreated);
                        }
                    }
                    function deprecated(name, replacement) {
                        var message = name + " is deprecated and will be removed in a future version.";
                        if (replacement) message += " Use " + replacement + " instead.";
                        return warn(message);
                    }
                    function warn(message, shouldUseOwnTrace, promise) {
                        if (!config.warnings) return;
                        var warning = new Warning(message);
                        var ctx;
                        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
                        else if (config.longStackTraces && (ctx = Promise1._peekContext())) ctx.attachExtraTrace(warning);
                        else {
                            var parsed = parseStackAndMessage(warning);
                            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
                        }
                        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
                    }
                    function reconstructStack(message, stacks) {
                        for(var i = 0; i < stacks.length - 1; ++i){
                            stacks[i].push("From previous event:");
                            stacks[i] = stacks[i].join("\n");
                        }
                        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
                        return message + "\n" + stacks.join("\n");
                    }
                    function removeDuplicateOrEmptyJumps(stacks) {
                        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                            stacks.splice(i, 1);
                            i--;
                        }
                    }
                    function removeCommonRoots(stacks) {
                        var current = stacks[0];
                        for(var i = 1; i < stacks.length; ++i){
                            var prev = stacks[i];
                            var currentLastIndex = current.length - 1;
                            var currentLastLine = current[currentLastIndex];
                            var commonRootMeetPoint = -1;
                            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                                commonRootMeetPoint = j;
                                break;
                            }
                            for(var j = commonRootMeetPoint; j >= 0; --j){
                                var line = prev[j];
                                if (current[currentLastIndex] === line) {
                                    current.pop();
                                    currentLastIndex--;
                                } else break;
                            }
                            current = prev;
                        }
                    }
                    function cleanStack(stack) {
                        var ret = [];
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                            var isInternalFrame = isTraceLine && shouldIgnore(line);
                            if (isTraceLine && !isInternalFrame) {
                                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                                ret.push(line);
                            }
                        }
                        return ret;
                    }
                    function stackFramesAsArray(error) {
                        var stack = error.stack.replace(/\s+$/g, "").split("\n");
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
                        }
                        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
                        return stack;
                    }
                    function parseStackAndMessage(error) {
                        var stack = error.stack;
                        var message = error.toString();
                        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
                            "    (No stack trace)"
                        ];
                        return {
                            message: message,
                            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
                        };
                    }
                    function formatAndLogError(error, title, isSoft) {
                        if (typeof console !== "undefined") {
                            var message;
                            if (util.isObject(error)) {
                                var stack = error.stack;
                                message = title + formatStack(stack, error);
                            } else message = title + String(error);
                            if (typeof printWarning === "function") printWarning(message, isSoft);
                            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
                        }
                    }
                    function fireRejectionEvent(name, localHandler, reason, promise) {
                        var localEventFired = false;
                        try {
                            if (typeof localHandler === "function") {
                                localEventFired = true;
                                if (name === "rejectionHandled") localHandler(promise);
                                else localHandler(reason, promise);
                            }
                        } catch (e) {
                            async.throwLater(e);
                        }
                        if (name === "unhandledRejection") {
                            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
                        } else activeFireEvent(name, promise);
                    }
                    function formatNonError(obj) {
                        var str;
                        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
                        else {
                            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
                            if (ruselessToString.test(str)) try {
                                var newStr = JSON.stringify(obj);
                                str = newStr;
                            } catch (e) {}
                            if (str.length === 0) str = "(empty array)";
                        }
                        return "(<" + snip(str) + ">, no stack trace)";
                    }
                    function snip(str) {
                        var maxChars = 41;
                        if (str.length < maxChars) return str;
                        return str.substr(0, maxChars - 3) + "...";
                    }
                    function longStackTracesIsSupported() {
                        return typeof captureStackTrace === "function";
                    }
                    var shouldIgnore = function() {
                        return false;
                    };
                    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                    function parseLineInfo(line) {
                        var matches = line.match(parseLineInfoRegex);
                        if (matches) return {
                            fileName: matches[1],
                            line: parseInt(matches[2], 10)
                        };
                    }
                    function setBounds(firstLineError, lastLineError) {
                        if (!longStackTracesIsSupported()) return;
                        var firstStackLines = (firstLineError.stack || "").split("\n");
                        var lastStackLines = (lastLineError.stack || "").split("\n");
                        var firstIndex = -1;
                        var lastIndex = -1;
                        var firstFileName;
                        var lastFileName;
                        for(var i = 0; i < firstStackLines.length; ++i){
                            var result = parseLineInfo(firstStackLines[i]);
                            if (result) {
                                firstFileName = result.fileName;
                                firstIndex = result.line;
                                break;
                            }
                        }
                        for(var i = 0; i < lastStackLines.length; ++i){
                            var result = parseLineInfo(lastStackLines[i]);
                            if (result) {
                                lastFileName = result.fileName;
                                lastIndex = result.line;
                                break;
                            }
                        }
                        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
                        shouldIgnore = function(line) {
                            if (bluebirdFramePattern.test(line)) return true;
                            var info = parseLineInfo(line);
                            if (info) {
                                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
                            }
                            return false;
                        };
                    }
                    function CapturedTrace(parent) {
                        this._parent = parent;
                        this._promisesCreated = 0;
                        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
                        captureStackTrace(this, CapturedTrace);
                        if (length > 32) this.uncycle();
                    }
                    util.inherits(CapturedTrace, Error);
                    Context.CapturedTrace = CapturedTrace;
                    CapturedTrace.prototype.uncycle = function() {
                        var length = this._length;
                        if (length < 2) return;
                        var nodes = [];
                        var stackToIndex = {};
                        for(var i = 0, node = this; node !== undefined; ++i){
                            nodes.push(node);
                            node = node._parent;
                        }
                        length = this._length = i;
                        for(var i = length - 1; i >= 0; --i){
                            var stack = nodes[i].stack;
                            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
                        }
                        for(var i = 0; i < length; ++i){
                            var currentStack = nodes[i].stack;
                            var index = stackToIndex[currentStack];
                            if (index !== undefined && index !== i) {
                                if (index > 0) {
                                    nodes[index - 1]._parent = undefined;
                                    nodes[index - 1]._length = 1;
                                }
                                nodes[i]._parent = undefined;
                                nodes[i]._length = 1;
                                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                                if (index < length - 1) {
                                    cycleEdgeNode._parent = nodes[index + 1];
                                    cycleEdgeNode._parent.uncycle();
                                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                                } else {
                                    cycleEdgeNode._parent = undefined;
                                    cycleEdgeNode._length = 1;
                                }
                                var currentChildLength = cycleEdgeNode._length + 1;
                                for(var j = i - 2; j >= 0; --j){
                                    nodes[j]._length = currentChildLength;
                                    currentChildLength++;
                                }
                                return;
                            }
                        }
                    };
                    CapturedTrace.prototype.attachExtraTrace = function(error) {
                        if (error.__stackCleaned__) return;
                        this.uncycle();
                        var parsed = parseStackAndMessage(error);
                        var message = parsed.message;
                        var stacks = [
                            parsed.stack
                        ];
                        var trace = this;
                        while(trace !== undefined){
                            stacks.push(cleanStack(trace.stack.split("\n")));
                            trace = trace._parent;
                        }
                        removeCommonRoots(stacks);
                        removeDuplicateOrEmptyJumps(stacks);
                        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
                        util.notEnumerableProp(error, "__stackCleaned__", true);
                    };
                    var captureStackTrace = function stackDetection() {
                        var v8stackFramePattern = /^\s*at\s*/;
                        var v8stackFormatter = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if (error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                            Error.stackTraceLimit += 6;
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            var captureStackTrace = Error.captureStackTrace;
                            shouldIgnore = function(line) {
                                return bluebirdFramePattern.test(line);
                            };
                            return function(receiver, ignoreUntil) {
                                Error.stackTraceLimit += 6;
                                captureStackTrace(receiver, ignoreUntil);
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        var err = new Error();
                        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                            stackFramePattern = /@/;
                            formatStack = v8stackFormatter;
                            indentStackFrames = true;
                            return function captureStackTrace(o) {
                                o.stack = new Error().stack;
                            };
                        }
                        var hasStackAfterThrow;
                        try {
                            throw new Error();
                        } catch (e) {
                            hasStackAfterThrow = "stack" in e;
                        }
                        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            return function captureStackTrace(o) {
                                Error.stackTraceLimit += 6;
                                try {
                                    throw new Error();
                                } catch (e) {
                                    o.stack = e.stack;
                                }
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        formatStack = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        return null;
                    }([]);
                    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                        printWarning = function(message) {
                            console.warn(message);
                        };
                        if (util.isNode && process.stderr.isTTY) printWarning = function(message, isSoft) {
                            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
                            console.warn(color + message + "\u001b[0m\n");
                        };
                        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
                            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                        };
                    }
                    var config = {
                        warnings: warnings,
                        longStackTraces: false,
                        cancellation: false,
                        monitoring: false,
                        asyncHooks: false
                    };
                    if (longStackTraces) Promise1.longStackTraces();
                    return {
                        asyncHooks: function() {
                            return config.asyncHooks;
                        },
                        longStackTraces: function() {
                            return config.longStackTraces;
                        },
                        warnings: function() {
                            return config.warnings;
                        },
                        cancellation: function() {
                            return config.cancellation;
                        },
                        monitoring: function() {
                            return config.monitoring;
                        },
                        propagateFromFunction: function() {
                            return propagateFromFunction;
                        },
                        boundValueFunction: function() {
                            return boundValueFunction;
                        },
                        checkForgottenReturns: checkForgottenReturns,
                        setBounds: setBounds,
                        warn: warn,
                        deprecated: deprecated,
                        CapturedTrace: CapturedTrace,
                        fireDomEvent: fireDomEvent,
                        fireGlobalEvent: fireGlobalEvent
                    };
                };
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        10: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function returner() {
                        return this.value;
                    }
                    function thrower() {
                        throw this.reason;
                    }
                    Promise1.prototype["return"] = Promise1.prototype.thenReturn = function(value) {
                        if (value instanceof Promise1) value.suppressUnhandledRejections();
                        return this._then(returner, undefined, undefined, {
                            value: value
                        }, undefined);
                    };
                    Promise1.prototype["throw"] = Promise1.prototype.thenThrow = function(reason) {
                        return this._then(thrower, undefined, undefined, {
                            reason: reason
                        }, undefined);
                    };
                    Promise1.prototype.catchThrow = function(reason) {
                        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
                            reason: reason
                        }, undefined);
                        else {
                            var _reason = arguments[1];
                            var handler = function() {
                                throw _reason;
                            };
                            return this.caught(reason, handler);
                        }
                    };
                    Promise1.prototype.catchReturn = function(value) {
                        if (arguments.length <= 1) {
                            if (value instanceof Promise1) value.suppressUnhandledRejections();
                            return this._then(undefined, returner, undefined, {
                                value: value
                            }, undefined);
                        } else {
                            var _value = arguments[1];
                            if (_value instanceof Promise1) _value.suppressUnhandledRejections();
                            var handler = function() {
                                return _value;
                            };
                            return this.caught(value, handler);
                        }
                    };
                };
            },
            {}
        ],
        11: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseReduce = Promise1.reduce;
                    var PromiseAll = Promise1.all;
                    function promiseAllThis() {
                        return PromiseAll(this);
                    }
                    function PromiseMapSeries(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
                    }
                    Promise1.prototype.each = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
                    };
                    Promise1.prototype.mapSeries = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
                    };
                    Promise1.each = function(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
                    };
                    Promise1.mapSeries = PromiseMapSeries;
                };
            },
            {}
        ],
        12: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var Objectfreeze = es5.freeze;
                var util = _dereq_1("./util");
                var inherits = util.inherits;
                var notEnumerableProp = util.notEnumerableProp;
                function subError(nameProperty, defaultMessage) {
                    function SubError(message) {
                        if (!(this instanceof SubError)) return new SubError(message);
                        notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
                        notEnumerableProp(this, "name", nameProperty);
                        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        else Error.call(this);
                    }
                    inherits(SubError, Error);
                    return SubError;
                }
                var _TypeError, _RangeError;
                var Warning = subError("Warning", "warning");
                var CancellationError = subError("CancellationError", "cancellation error");
                var TimeoutError = subError("TimeoutError", "timeout error");
                var AggregateError = subError("AggregateError", "aggregate error");
                try {
                    _TypeError = TypeError;
                    _RangeError = RangeError;
                } catch (e) {
                    _TypeError = subError("TypeError", "type error");
                    _RangeError = subError("RangeError", "range error");
                }
                var methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
                for(var i = 0; i < methods.length; ++i)if (typeof Array.prototype[methods[i]] === "function") AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
                es5.defineProperty(AggregateError.prototype, "length", {
                    value: 0,
                    configurable: false,
                    writable: true,
                    enumerable: true
                });
                AggregateError.prototype["isOperational"] = true;
                var level = 0;
                AggregateError.prototype.toString = function() {
                    var indent = Array(level * 4 + 1).join(" ");
                    var ret = "\n" + indent + "AggregateError of:" + "\n";
                    level++;
                    indent = Array(level * 4 + 1).join(" ");
                    for(var i = 0; i < this.length; ++i){
                        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
                        var lines = str.split("\n");
                        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
                        str = lines.join("\n");
                        ret += str + "\n";
                    }
                    level--;
                    return ret;
                };
                function OperationalError(message) {
                    if (!(this instanceof OperationalError)) return new OperationalError(message);
                    notEnumerableProp(this, "name", "OperationalError");
                    notEnumerableProp(this, "message", message);
                    this.cause = message;
                    this["isOperational"] = true;
                    if (message instanceof Error) {
                        notEnumerableProp(this, "message", message.message);
                        notEnumerableProp(this, "stack", message.stack);
                    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                }
                inherits(OperationalError, Error);
                var errorTypes = Error["__BluebirdErrorTypes__"];
                if (!errorTypes) {
                    errorTypes = Objectfreeze({
                        CancellationError: CancellationError,
                        TimeoutError: TimeoutError,
                        OperationalError: OperationalError,
                        RejectionError: OperationalError,
                        AggregateError: AggregateError
                    });
                    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
                        value: errorTypes,
                        writable: false,
                        enumerable: false,
                        configurable: false
                    });
                }
                module1.exports = {
                    Error: Error,
                    TypeError: _TypeError,
                    RangeError: _RangeError,
                    CancellationError: errorTypes.CancellationError,
                    OperationalError: errorTypes.OperationalError,
                    TimeoutError: errorTypes.TimeoutError,
                    AggregateError: errorTypes.AggregateError,
                    Warning: Warning
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        13: [
            function(_dereq_1, module1, exports) {
                var isES5 = function() {
                    "use strict";
                    return this === undefined;
                }();
                if (isES5) module1.exports = {
                    freeze: Object.freeze,
                    defineProperty: Object.defineProperty,
                    getDescriptor: Object.getOwnPropertyDescriptor,
                    keys: Object.keys,
                    names: Object.getOwnPropertyNames,
                    getPrototypeOf: Object.getPrototypeOf,
                    isArray: Array.isArray,
                    isES5: isES5,
                    propertyIsWritable: function(obj, prop) {
                        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                        return !!(!descriptor || descriptor.writable || descriptor.set);
                    }
                };
                else {
                    var has = {}.hasOwnProperty;
                    var str = {}.toString;
                    var proto = {}.constructor.prototype;
                    var ObjectKeys = function(o) {
                        var ret = [];
                        for(var key in o)if (has.call(o, key)) ret.push(key);
                        return ret;
                    };
                    var ObjectGetDescriptor = function(o, key) {
                        return {
                            value: o[key]
                        };
                    };
                    var ObjectDefineProperty = function(o, key, desc) {
                        o[key] = desc.value;
                        return o;
                    };
                    var ObjectFreeze = function(obj) {
                        return obj;
                    };
                    var ObjectGetPrototypeOf = function(obj) {
                        try {
                            return Object(obj).constructor.prototype;
                        } catch (e) {
                            return proto;
                        }
                    };
                    var ArrayIsArray = function(obj) {
                        try {
                            return str.call(obj) === "[object Array]";
                        } catch (e) {
                            return false;
                        }
                    };
                    module1.exports = {
                        isArray: ArrayIsArray,
                        keys: ObjectKeys,
                        names: ObjectKeys,
                        defineProperty: ObjectDefineProperty,
                        getDescriptor: ObjectGetDescriptor,
                        freeze: ObjectFreeze,
                        getPrototypeOf: ObjectGetPrototypeOf,
                        isES5: isES5,
                        propertyIsWritable: function() {
                            return true;
                        }
                    };
                }
            },
            {}
        ],
        14: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseMap = Promise1.map;
                    Promise1.prototype.filter = function(fn, options) {
                        return PromiseMap(this, fn, options, INTERNAL);
                    };
                    Promise1.filter = function(promises, fn, options) {
                        return PromiseMap(promises, fn, options, INTERNAL);
                    };
                };
            },
            {}
        ],
        15: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, tryConvertToPromise, NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var CancellationError = Promise1.CancellationError;
                    var errorObj = util.errorObj;
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    function PassThroughHandlerContext(promise, type, handler) {
                        this.promise = promise;
                        this.type = type;
                        this.handler = handler;
                        this.called = false;
                        this.cancelPromise = null;
                    }
                    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
                        return this.type === 0;
                    };
                    function FinallyHandlerCancelReaction(finallyHandler) {
                        this.finallyHandler = finallyHandler;
                    }
                    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
                        checkCancel(this.finallyHandler);
                    };
                    function checkCancel(ctx, reason) {
                        if (ctx.cancelPromise != null) {
                            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
                            else ctx.cancelPromise._cancel();
                            ctx.cancelPromise = null;
                            return true;
                        }
                        return false;
                    }
                    function succeed() {
                        return finallyHandler.call(this, this.promise._target()._settledValue());
                    }
                    function fail(reason) {
                        if (checkCancel(this, reason)) return;
                        errorObj.e = reason;
                        return errorObj;
                    }
                    function finallyHandler(reasonOrValue) {
                        var promise = this.promise;
                        var handler = this.handler;
                        if (!this.called) {
                            this.called = true;
                            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
                            if (ret === NEXT_FILTER) return ret;
                            else if (ret !== undefined) {
                                promise._setReturnedNonUndefined();
                                var maybePromise = tryConvertToPromise(ret, promise);
                                if (maybePromise instanceof Promise1) {
                                    if (this.cancelPromise != null) {
                                        if (maybePromise._isCancelled()) {
                                            var reason = new CancellationError("late cancellation observer");
                                            promise._attachExtraTrace(reason);
                                            errorObj.e = reason;
                                            return errorObj;
                                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                                    }
                                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                                }
                            }
                        }
                        if (promise.isRejected()) {
                            checkCancel(this);
                            errorObj.e = reasonOrValue;
                            return errorObj;
                        } else {
                            checkCancel(this);
                            return reasonOrValue;
                        }
                    }
                    Promise1.prototype._passThrough = function(handler, type, success, fail) {
                        if (typeof handler !== "function") return this.then();
                        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
                    };
                    Promise1.prototype.lastly = Promise1.prototype["finally"] = function(handler) {
                        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
                    };
                    Promise1.prototype.tap = function(handler) {
                        return this._passThrough(handler, 1, finallyHandler);
                    };
                    Promise1.prototype.tapCatch = function(handlerOrPredicate) {
                        var len = arguments.length;
                        if (len === 1) return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
                        else {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return Promise1.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + util.classString(item)));
                            }
                            catchInstances.length = j;
                            var handler = arguments[i];
                            return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
                        }
                    };
                    return PassThroughHandlerContext;
                };
            },
            {
                "./catch_filter": 7,
                "./util": 36
            }
        ],
        16: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
                    var errors = _dereq_1("./errors");
                    var TypeError1 = errors.TypeError;
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var yieldHandlers = [];
                    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
                        for(var i = 0; i < yieldHandlers.length; ++i){
                            traceParent._pushContext();
                            var result = tryCatch(yieldHandlers[i])(value);
                            traceParent._popContext();
                            if (result === errorObj) {
                                traceParent._pushContext();
                                var ret = Promise1.reject(errorObj.e);
                                traceParent._popContext();
                                return ret;
                            }
                            var maybePromise = tryConvertToPromise(result, traceParent);
                            if (maybePromise instanceof Promise1) return maybePromise;
                        }
                        return null;
                    }
                    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
                        if (debug.cancellation()) {
                            var internal = new Promise1(INTERNAL);
                            var _finallyPromise = this._finallyPromise = new Promise1(INTERNAL);
                            this._promise = internal.lastly(function() {
                                return _finallyPromise;
                            });
                            internal._captureStackTrace();
                            internal._setOnCancel(this);
                        } else {
                            var promise = this._promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                        }
                        this._stack = stack;
                        this._generatorFunction = generatorFunction;
                        this._receiver = receiver;
                        this._generator = undefined;
                        this._yieldHandlers = typeof yieldHandler === "function" ? [
                            yieldHandler
                        ].concat(yieldHandlers) : yieldHandlers;
                        this._yieldedPromise = null;
                        this._cancellationPhase = false;
                    }
                    util.inherits(PromiseSpawn, Proxyable);
                    PromiseSpawn.prototype._isResolved = function() {
                        return this._promise === null;
                    };
                    PromiseSpawn.prototype._cleanup = function() {
                        this._promise = this._generator = null;
                        if (debug.cancellation() && this._finallyPromise !== null) {
                            this._finallyPromise._fulfill();
                            this._finallyPromise = null;
                        }
                    };
                    PromiseSpawn.prototype._promiseCancelled = function() {
                        if (this._isResolved()) return;
                        var implementsReturn = typeof this._generator["return"] !== "undefined";
                        var result;
                        if (!implementsReturn) {
                            var reason = new Promise1.CancellationError("generator .return() sentinel");
                            Promise1.coroutine.returnSentinel = reason;
                            this._promise._attachExtraTrace(reason);
                            this._promise._pushContext();
                            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                            this._promise._popContext();
                        } else {
                            this._promise._pushContext();
                            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
                            this._promise._popContext();
                        }
                        this._cancellationPhase = true;
                        this._yieldedPromise = null;
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseFulfilled = function(value) {
                        this._yieldedPromise = null;
                        this._promise._pushContext();
                        var result = tryCatch(this._generator.next).call(this._generator, value);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseRejected = function(reason) {
                        this._yieldedPromise = null;
                        this._promise._attachExtraTrace(reason);
                        this._promise._pushContext();
                        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._resultCancelled = function() {
                        if (this._yieldedPromise instanceof Promise1) {
                            var promise = this._yieldedPromise;
                            this._yieldedPromise = null;
                            promise.cancel();
                        }
                    };
                    PromiseSpawn.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseSpawn.prototype._run = function() {
                        this._generator = this._generatorFunction.call(this._receiver);
                        this._receiver = this._generatorFunction = undefined;
                        this._promiseFulfilled(undefined);
                    };
                    PromiseSpawn.prototype._continue = function(result) {
                        var promise = this._promise;
                        if (result === errorObj) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._rejectCallback(result.e, false);
                        }
                        var value = result.value;
                        if (result.done === true) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._resolveCallback(value);
                        } else {
                            var maybePromise = tryConvertToPromise(value, this._promise);
                            if (!(maybePromise instanceof Promise1)) {
                                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                                if (maybePromise === null) {
                                    this._promiseRejected(new TypeError1("A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) + "From coroutine:\u000a" + this._stack.split("\n").slice(1, -7).join("\n")));
                                    return;
                                }
                            }
                            maybePromise = maybePromise._target();
                            var bitField = maybePromise._bitField;
                            if ((bitField & 50397184) === 0) {
                                this._yieldedPromise = maybePromise;
                                maybePromise._proxy(this, null);
                            } else if ((bitField & 33554432) !== 0) Promise1._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                            else if ((bitField & 16777216) !== 0) Promise1._async.invoke(this._promiseRejected, this, maybePromise._reason());
                            else this._promiseCancelled();
                        }
                    };
                    Promise1.coroutine = function(generatorFunction, options) {
                        if (typeof generatorFunction !== "function") throw new TypeError1("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var yieldHandler = Object(options).yieldHandler;
                        var PromiseSpawn$ = PromiseSpawn;
                        var stack = new Error().stack;
                        return function() {
                            var generator = generatorFunction.apply(this, arguments);
                            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                            var ret = spawn.promise();
                            spawn._generator = generator;
                            spawn._promiseFulfilled(undefined);
                            return ret;
                        };
                    };
                    Promise1.coroutine.addYieldHandler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        yieldHandlers.push(fn);
                    };
                    Promise1.spawn = function(generatorFunction) {
                        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
                        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var spawn = new PromiseSpawn(generatorFunction, this);
                        var ret = spawn.promise();
                        spawn._run(Promise1.spawn);
                        return ret;
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        17: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var reject;
                    var thenCallback, promiseSetter, generateHolderClass, holderClasses, thenCallbacks, promiseSetters, i;
                    Promise1.join = function() {
                        var last = arguments.length - 1;
                        var fn;
                        if (last > 0 && typeof arguments[last] === "function") {
                            fn = arguments[last];
                            var ret, HolderClass, holder, callbacks, i, maybePromise, bitField, context;
                        }
                        var args = [].slice.call(arguments);
                        if (fn) args.pop();
                        var ret = new PromiseArray(args).promise();
                        return fn !== undefined ? ret.spread(fn) : ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        18: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    function MappingPromiseArray(promises, fn, limit, _filter) {
                        this.constructor$(promises);
                        this._promise._captureStackTrace();
                        var context = Promise1._getContext();
                        this._callback = util.contextBind(context, fn);
                        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
                        this._limit = limit;
                        this._inFlight = 0;
                        this._queue = [];
                        async.invoke(this._asyncInit, this, undefined);
                        if (util.isArray(promises)) for(var i = 0; i < promises.length; ++i){
                            var maybePromise = promises[i];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                    }
                    util.inherits(MappingPromiseArray, PromiseArray);
                    MappingPromiseArray.prototype._asyncInit = function() {
                        this._init$(undefined, -2);
                    };
                    MappingPromiseArray.prototype._init = function() {};
                    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var values = this._values;
                        var length = this.length();
                        var preservedValues = this._preservedValues;
                        var limit = this._limit;
                        if (index < 0) {
                            index = index * -1 - 1;
                            values[index] = value;
                            if (limit >= 1) {
                                this._inFlight--;
                                this._drainQueue();
                                if (this._isResolved()) return true;
                            }
                        } else {
                            if (limit >= 1 && this._inFlight >= limit) {
                                values[index] = value;
                                this._queue.push(index);
                                return false;
                            }
                            if (preservedValues !== null) preservedValues[index] = value;
                            var promise = this._promise;
                            var callback = this._callback;
                            var receiver = promise._boundValue();
                            promise._pushContext();
                            var ret = tryCatch(callback).call(receiver, value, index, length);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
                            if (ret === errorObj) {
                                this._reject(ret.e);
                                return true;
                            }
                            var maybePromise = tryConvertToPromise(ret, this._promise);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                var bitField = maybePromise._bitField;
                                if ((bitField & 50397184) === 0) {
                                    if (limit >= 1) this._inFlight++;
                                    values[index] = maybePromise;
                                    maybePromise._proxy(this, (index + 1) * -1);
                                    return false;
                                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                                else if ((bitField & 16777216) !== 0) {
                                    this._reject(maybePromise._reason());
                                    return true;
                                } else {
                                    this._cancel();
                                    return true;
                                }
                            }
                            values[index] = ret;
                        }
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= length) {
                            if (preservedValues !== null) this._filter(values, preservedValues);
                            else this._resolve(values);
                            return true;
                        }
                        return false;
                    };
                    MappingPromiseArray.prototype._drainQueue = function() {
                        var queue = this._queue;
                        var limit = this._limit;
                        var values = this._values;
                        while(queue.length > 0 && this._inFlight < limit){
                            if (this._isResolved()) return;
                            var index = queue.pop();
                            this._promiseFulfilled(values[index], index);
                        }
                    };
                    MappingPromiseArray.prototype._filter = function(booleans, values) {
                        var len = values.length;
                        var ret = new Array(len);
                        var j = 0;
                        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
                        ret.length = j;
                        this._resolve(ret);
                    };
                    MappingPromiseArray.prototype.preservedValues = function() {
                        return this._preservedValues;
                    };
                    function map(promises, fn, options, _filter) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var limit = 0;
                        if (options !== undefined) {
                            if (typeof options === "object" && options !== null) {
                                if (typeof options.concurrency !== "number") return Promise1.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                                limit = options.concurrency;
                            } else return Promise1.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                        }
                        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
                        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
                    }
                    Promise1.prototype.map = function(fn, options) {
                        return map(this, fn, options, null);
                    };
                    Promise1.map = function(promises, fn, options, _filter) {
                        return map(promises, fn, options, _filter);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        19: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    Promise1.method = function(fn) {
                        if (typeof fn !== "function") throw new Promise1.TypeError("expecting a function but got " + util.classString(fn));
                        return function() {
                            var ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._pushContext();
                            var value = tryCatch(fn).apply(this, arguments);
                            var promiseCreated = ret._popContext();
                            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
                            ret._resolveFromSyncValue(value);
                            return ret;
                        };
                    };
                    Promise1.attempt = Promise1["try"] = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._pushContext();
                        var value;
                        if (arguments.length > 1) {
                            debug.deprecated("calling Promise.try with more than 1 argument");
                            var arg = arguments[1];
                            var ctx = arguments[2];
                            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
                        } else value = tryCatch(fn)();
                        var promiseCreated = ret._popContext();
                        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
                        ret._resolveFromSyncValue(value);
                        return ret;
                    };
                    Promise1.prototype._resolveFromSyncValue = function(value) {
                        if (value === util.errorObj) this._rejectCallback(value.e, false);
                        else this._resolveCallback(value, true);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        20: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var maybeWrapAsError = util.maybeWrapAsError;
                var errors = _dereq_1("./errors");
                var OperationalError = errors.OperationalError;
                var es5 = _dereq_1("./es5");
                function isUntypedError(obj) {
                    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
                }
                var rErrorKey = /^(?:name|message|stack|cause)$/;
                function wrapAsOperationalError(obj) {
                    var ret;
                    if (isUntypedError(obj)) {
                        ret = new OperationalError(obj);
                        ret.name = obj.name;
                        ret.message = obj.message;
                        ret.stack = obj.stack;
                        var keys = es5.keys(obj);
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            if (!rErrorKey.test(key)) ret[key] = obj[key];
                        }
                        return ret;
                    }
                    util.markAsOriginatingFromRejection(obj);
                    return obj;
                }
                function nodebackForPromise(promise, multiArgs) {
                    return function(err, value) {
                        if (promise === null) return;
                        if (err) {
                            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
                            promise._attachExtraTrace(wrapped);
                            promise._reject(wrapped);
                        } else if (!multiArgs) promise._fulfill(value);
                        else {
                            var args = [].slice.call(arguments, 1);
                            promise._fulfill(args);
                        }
                        promise = null;
                    };
                }
                module1.exports = nodebackForPromise;
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        21: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var async = Promise1._async;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function spreadAdapter(val, nodeback) {
                        var promise = this;
                        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
                        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
                            null
                        ].concat(val));
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function successAdapter(val, nodeback) {
                        var promise = this;
                        var receiver = promise._boundValue();
                        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function errorAdapter(reason, nodeback) {
                        var promise = this;
                        if (!reason) {
                            var newReason = new Error(reason + "");
                            newReason.cause = reason;
                            reason = newReason;
                        }
                        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    Promise1.prototype.asCallback = Promise1.prototype.nodeify = function(nodeback, options) {
                        if (typeof nodeback == "function") {
                            var adapter = successAdapter;
                            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
                            this._then(adapter, errorAdapter, undefined, this, nodeback);
                        }
                        return this;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        22: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function() {
                    var makeSelfResolutionError = function() {
                        return new TypeError1("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                    };
                    var reflectHandler = function() {
                        return new Promise1.PromiseInspection(this._target());
                    };
                    var apiRejection = function(msg) {
                        return Promise1.reject(new TypeError1(msg));
                    };
                    function Proxyable() {}
                    var UNDEFINED_BINDING = {};
                    var util = _dereq_1("./util");
                    util.setReflectHandler(reflectHandler);
                    var getDomain = function() {
                        var domain = process.domain;
                        if (domain === undefined) return null;
                        return domain;
                    };
                    var getContextDefault = function() {
                        return null;
                    };
                    var getContextDomain = function() {
                        return {
                            domain: getDomain(),
                            async: null
                        };
                    };
                    var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_1("async_hooks").AsyncResource : null;
                    var getContextAsyncHooks = function() {
                        return {
                            domain: getDomain(),
                            async: new AsyncResource("Bluebird::Promise")
                        };
                    };
                    var getContext = util.isNode ? getContextDomain : getContextDefault;
                    util.notEnumerableProp(Promise1, "_getContext", getContext);
                    var enableAsyncHooks = function() {
                        getContext = getContextAsyncHooks;
                        util.notEnumerableProp(Promise1, "_getContext", getContextAsyncHooks);
                    };
                    var disableAsyncHooks = function() {
                        getContext = getContextDomain;
                        util.notEnumerableProp(Promise1, "_getContext", getContextDomain);
                    };
                    var es5 = _dereq_1("./es5");
                    var Async = _dereq_1("./async");
                    var async = new Async();
                    es5.defineProperty(Promise1, "_async", {
                        value: async
                    });
                    var errors = _dereq_1("./errors");
                    var TypeError1 = Promise1.TypeError = errors.TypeError;
                    Promise1.RangeError = errors.RangeError;
                    var CancellationError = Promise1.CancellationError = errors.CancellationError;
                    Promise1.TimeoutError = errors.TimeoutError;
                    Promise1.OperationalError = errors.OperationalError;
                    Promise1.RejectionError = errors.OperationalError;
                    Promise1.AggregateError = errors.AggregateError;
                    var INTERNAL = function() {};
                    var APPLY = {};
                    var NEXT_FILTER = {};
                    var tryConvertToPromise = _dereq_1("./thenables")(Promise1, INTERNAL);
                    var PromiseArray = _dereq_1("./promise_array")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
                    var Context = _dereq_1("./context")(Promise1);
                    /*jshint unused:false*/ var createContext = Context.create;
                    var debug = _dereq_1("./debuggability")(Promise1, Context, enableAsyncHooks, disableAsyncHooks);
                    var CapturedTrace = debug.CapturedTrace;
                    var PassThroughHandlerContext = _dereq_1("./finally")(Promise1, tryConvertToPromise, NEXT_FILTER);
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    function check(self1, executor) {
                        if (self1 == null || self1.constructor !== Promise1) throw new TypeError1("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        if (typeof executor !== "function") throw new TypeError1("expecting a function but got " + util.classString(executor));
                    }
                    function Promise1(executor) {
                        if (executor !== INTERNAL) check(this, executor);
                        this._bitField = 0;
                        this._fulfillmentHandler0 = undefined;
                        this._rejectionHandler0 = undefined;
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._resolveFromExecutor(executor);
                        this._promiseCreated();
                        this._fireEvent("promiseCreated", this);
                    }
                    Promise1.prototype.toString = function() {
                        return "[object Promise]";
                    };
                    Promise1.prototype.caught = Promise1.prototype["catch"] = function(fn) {
                        var len = arguments.length;
                        if (len > 1) {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return apiRejection("Catch statement predicate: expecting an object but got " + util.classString(item));
                            }
                            catchInstances.length = j;
                            fn = arguments[i];
                            if (typeof fn !== "function") throw new TypeError1("The last argument to .catch() must be a function, got " + util.toString(fn));
                            return this.then(undefined, catchFilter(catchInstances, fn, this));
                        }
                        return this.then(undefined, fn);
                    };
                    Promise1.prototype.reflect = function() {
                        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
                    };
                    Promise1.prototype.then = function(didFulfill, didReject) {
                        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
                            if (arguments.length > 1) msg += ", " + util.classString(didReject);
                            this._warn(msg);
                        }
                        return this._then(didFulfill, didReject, undefined, undefined, undefined);
                    };
                    Promise1.prototype.done = function(didFulfill, didReject) {
                        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
                        promise._setIsFinal();
                    };
                    Promise1.prototype.spread = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
                    };
                    Promise1.prototype.toJSON = function() {
                        var ret = {
                            isFulfilled: false,
                            isRejected: false,
                            fulfillmentValue: undefined,
                            rejectionReason: undefined
                        };
                        if (this.isFulfilled()) {
                            ret.fulfillmentValue = this.value();
                            ret.isFulfilled = true;
                        } else if (this.isRejected()) {
                            ret.rejectionReason = this.reason();
                            ret.isRejected = true;
                        }
                        return ret;
                    };
                    Promise1.prototype.all = function() {
                        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
                        return new PromiseArray(this).promise();
                    };
                    Promise1.prototype.error = function(fn) {
                        return this.caught(util.originatesFromRejection, fn);
                    };
                    Promise1.getNewLibraryCopy = module1.exports;
                    Promise1.is = function(val) {
                        return val instanceof Promise1;
                    };
                    Promise1.fromNode = Promise1.fromCallback = function(fn) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
                        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
                        if (result === errorObj) ret._rejectCallback(result.e, true);
                        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.all = function(promises) {
                        return new PromiseArray(promises).promise();
                    };
                    Promise1.cast = function(obj) {
                        var ret = tryConvertToPromise(obj);
                        if (!(ret instanceof Promise1)) {
                            ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._setFulfilled();
                            ret._rejectionHandler0 = obj;
                        }
                        return ret;
                    };
                    Promise1.resolve = Promise1.fulfilled = Promise1.cast;
                    Promise1.reject = Promise1.rejected = function(reason) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._rejectCallback(reason, true);
                        return ret;
                    };
                    Promise1.setScheduler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        return async.setScheduler(fn);
                    };
                    Promise1.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
                        var haveInternalData = internalData !== undefined;
                        var promise = haveInternalData ? internalData : new Promise1(INTERNAL);
                        var target = this._target();
                        var bitField = target._bitField;
                        if (!haveInternalData) {
                            promise._propagateFrom(this, 3);
                            promise._captureStackTrace();
                            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                                else receiver = target === this ? undefined : this._boundTo;
                            }
                            this._fireEvent("promiseChained", this, promise);
                        }
                        var context = getContext();
                        if (!((bitField & 50397184) === 0)) {
                            var handler, value, settler = target._settlePromiseCtx;
                            if ((bitField & 33554432) !== 0) {
                                value = target._rejectionHandler0;
                                handler = didFulfill;
                            } else if ((bitField & 16777216) !== 0) {
                                value = target._fulfillmentHandler0;
                                handler = didReject;
                                target._unsetRejectionIsUnhandled();
                            } else {
                                settler = target._settlePromiseLateCancellationObserver;
                                value = new CancellationError("late cancellation observer");
                                target._attachExtraTrace(value);
                                handler = didReject;
                            }
                            async.invoke(settler, target, {
                                handler: util.contextBind(context, handler),
                                promise: promise,
                                receiver: receiver,
                                value: value
                            });
                        } else target._addCallbacks(didFulfill, didReject, promise, receiver, context);
                        return promise;
                    };
                    Promise1.prototype._length = function() {
                        return this._bitField & 65535;
                    };
                    Promise1.prototype._isFateSealed = function() {
                        return (this._bitField & 117506048) !== 0;
                    };
                    Promise1.prototype._isFollowing = function() {
                        return (this._bitField & 67108864) === 67108864;
                    };
                    Promise1.prototype._setLength = function(len) {
                        this._bitField = this._bitField & -65536 | len & 65535;
                    };
                    Promise1.prototype._setFulfilled = function() {
                        this._bitField = this._bitField | 33554432;
                        this._fireEvent("promiseFulfilled", this);
                    };
                    Promise1.prototype._setRejected = function() {
                        this._bitField = this._bitField | 16777216;
                        this._fireEvent("promiseRejected", this);
                    };
                    Promise1.prototype._setFollowing = function() {
                        this._bitField = this._bitField | 67108864;
                        this._fireEvent("promiseResolved", this);
                    };
                    Promise1.prototype._setIsFinal = function() {
                        this._bitField = this._bitField | 4194304;
                    };
                    Promise1.prototype._isFinal = function() {
                        return (this._bitField & 4194304) > 0;
                    };
                    Promise1.prototype._unsetCancelled = function() {
                        this._bitField = this._bitField & -65537;
                    };
                    Promise1.prototype._setCancelled = function() {
                        this._bitField = this._bitField | 65536;
                        this._fireEvent("promiseCancelled", this);
                    };
                    Promise1.prototype._setWillBeCancelled = function() {
                        this._bitField = this._bitField | 8388608;
                    };
                    Promise1.prototype._setAsyncGuaranteed = function() {
                        if (async.hasCustomScheduler()) return;
                        var bitField = this._bitField;
                        this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
                    };
                    Promise1.prototype._setNoAsyncGuarantee = function() {
                        this._bitField = (this._bitField | 536870912) & -134217729;
                    };
                    Promise1.prototype._receiverAt = function(index) {
                        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
                        if (ret === UNDEFINED_BINDING) return undefined;
                        else if (ret === undefined && this._isBound()) return this._boundValue();
                        return ret;
                    };
                    Promise1.prototype._promiseAt = function(index) {
                        return this[index * 4 - 4 + 2];
                    };
                    Promise1.prototype._fulfillmentHandlerAt = function(index) {
                        return this[index * 4 - 4 + 0];
                    };
                    Promise1.prototype._rejectionHandlerAt = function(index) {
                        return this[index * 4 - 4 + 1];
                    };
                    Promise1.prototype._boundValue = function() {};
                    Promise1.prototype._migrateCallback0 = function(follower) {
                        var bitField = follower._bitField;
                        var fulfill = follower._fulfillmentHandler0;
                        var reject = follower._rejectionHandler0;
                        var promise = follower._promise0;
                        var receiver = follower._receiverAt(0);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._migrateCallbackAt = function(follower, index) {
                        var fulfill = follower._fulfillmentHandlerAt(index);
                        var reject = follower._rejectionHandlerAt(index);
                        var promise = follower._promiseAt(index);
                        var receiver = follower._receiverAt(index);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._addCallbacks = function(fulfill, reject, promise, receiver, context) {
                        var index = this._length();
                        if (index >= 65531) {
                            index = 0;
                            this._setLength(0);
                        }
                        if (index === 0) {
                            this._promise0 = promise;
                            this._receiver0 = receiver;
                            if (typeof fulfill === "function") this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this._rejectionHandler0 = util.contextBind(context, reject);
                        } else {
                            var base = index * 4 - 4;
                            this[base + 2] = promise;
                            this[base + 3] = receiver;
                            if (typeof fulfill === "function") this[base + 0] = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this[base + 1] = util.contextBind(context, reject);
                        }
                        this._setLength(index + 1);
                        return index;
                    };
                    Promise1.prototype._proxy = function(proxyable, arg) {
                        this._addCallbacks(undefined, undefined, arg, proxyable, null);
                    };
                    Promise1.prototype._resolveCallback = function(value, shouldBind) {
                        if ((this._bitField & 117506048) !== 0) return;
                        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
                        var maybePromise = tryConvertToPromise(value, this);
                        if (!(maybePromise instanceof Promise1)) return this._fulfill(value);
                        if (shouldBind) this._propagateFrom(maybePromise, 2);
                        var promise = maybePromise._target();
                        if (promise === this) {
                            this._reject(makeSelfResolutionError());
                            return;
                        }
                        var bitField = promise._bitField;
                        if ((bitField & 50397184) === 0) {
                            var len = this._length();
                            if (len > 0) promise._migrateCallback0(this);
                            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
                            this._setFollowing();
                            this._setLength(0);
                            this._setFollowee(maybePromise);
                        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
                        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
                        else {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            this._reject(reason);
                        }
                    };
                    Promise1.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
                        var trace = util.ensureErrorObject(reason);
                        var hasStack = trace === reason;
                        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                            var message = "a promise was rejected with a non-error: " + util.classString(reason);
                            this._warn(message, true);
                        }
                        this._attachExtraTrace(trace, synchronous ? hasStack : false);
                        this._reject(reason);
                    };
                    Promise1.prototype._resolveFromExecutor = function(executor) {
                        if (executor === INTERNAL) return;
                        var promise = this;
                        this._captureStackTrace();
                        this._pushContext();
                        var synchronous = true;
                        var r = this._execute(executor, function(value) {
                            promise._resolveCallback(value);
                        }, function(reason) {
                            promise._rejectCallback(reason, synchronous);
                        });
                        synchronous = false;
                        this._popContext();
                        if (r !== undefined) promise._rejectCallback(r, true);
                    };
                    Promise1.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
                        var bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        promise._pushContext();
                        var x;
                        if (receiver === APPLY) {
                            if (!value || typeof value.length !== "number") {
                                x = errorObj;
                                x.e = new TypeError1("cannot .spread() a non-array: " + util.classString(value));
                            } else x = tryCatch(handler).apply(this._boundValue(), value);
                        } else x = tryCatch(handler).call(receiver, value);
                        var promiseCreated = promise._popContext();
                        bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        if (x === NEXT_FILTER) promise._reject(value);
                        else if (x === errorObj) promise._rejectCallback(x.e, false);
                        else {
                            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
                            promise._resolveCallback(x);
                        }
                    };
                    Promise1.prototype._target = function() {
                        var ret = this;
                        while(ret._isFollowing())ret = ret._followee();
                        return ret;
                    };
                    Promise1.prototype._followee = function() {
                        return this._rejectionHandler0;
                    };
                    Promise1.prototype._setFollowee = function(promise) {
                        this._rejectionHandler0 = promise;
                    };
                    Promise1.prototype._settlePromise = function(promise, handler, receiver, value) {
                        var isPromise = promise instanceof Promise1;
                        var bitField = this._bitField;
                        var asyncGuaranteed = (bitField & 134217728) !== 0;
                        if ((bitField & 65536) !== 0) {
                            if (isPromise) promise._invokeInternalOnCancel();
                            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                                receiver.cancelPromise = promise;
                                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
                            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
                            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
                            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
                            else receiver.cancel();
                        } else if (typeof handler === "function") {
                            if (!isPromise) handler.call(receiver, value, promise);
                            else {
                                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                this._settlePromiseFromHandler(handler, receiver, value, promise);
                            }
                        } else if (receiver instanceof Proxyable) {
                            if (!receiver._isResolved()) {
                                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                                else receiver._promiseRejected(value, promise);
                            }
                        } else if (isPromise) {
                            if (asyncGuaranteed) promise._setAsyncGuaranteed();
                            if ((bitField & 33554432) !== 0) promise._fulfill(value);
                            else promise._reject(value);
                        }
                    };
                    Promise1.prototype._settlePromiseLateCancellationObserver = function(ctx) {
                        var handler = ctx.handler;
                        var promise = ctx.promise;
                        var receiver = ctx.receiver;
                        var value = ctx.value;
                        if (typeof handler === "function") {
                            if (!(promise instanceof Promise1)) handler.call(receiver, value, promise);
                            else this._settlePromiseFromHandler(handler, receiver, value, promise);
                        } else if (promise instanceof Promise1) promise._reject(value);
                    };
                    Promise1.prototype._settlePromiseCtx = function(ctx) {
                        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
                    };
                    Promise1.prototype._settlePromise0 = function(handler, value, bitField) {
                        var promise = this._promise0;
                        var receiver = this._receiverAt(0);
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._settlePromise(promise, handler, receiver, value);
                    };
                    Promise1.prototype._clearCallbackDataAtIndex = function(index) {
                        var base = index * 4 - 4;
                        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
                    };
                    Promise1.prototype._fulfill = function(value) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        if (value === this) {
                            var err = makeSelfResolutionError();
                            this._attachExtraTrace(err);
                            return this._reject(err);
                        }
                        this._setFulfilled();
                        this._rejectionHandler0 = value;
                        if ((bitField & 65535) > 0) {
                            if ((bitField & 134217728) !== 0) this._settlePromises();
                            else async.settlePromises(this);
                            this._dereferenceTrace();
                        }
                    };
                    Promise1.prototype._reject = function(reason) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        this._setRejected();
                        this._fulfillmentHandler0 = reason;
                        if (this._isFinal()) return async.fatalError(reason, util.isNode);
                        if ((bitField & 65535) > 0) async.settlePromises(this);
                        else this._ensurePossibleRejectionHandled();
                    };
                    Promise1.prototype._fulfillPromises = function(len, value) {
                        for(var i = 1; i < len; i++){
                            var handler = this._fulfillmentHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, value);
                        }
                    };
                    Promise1.prototype._rejectPromises = function(len, reason) {
                        for(var i = 1; i < len; i++){
                            var handler = this._rejectionHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, reason);
                        }
                    };
                    Promise1.prototype._settlePromises = function() {
                        var bitField = this._bitField;
                        var len = bitField & 65535;
                        if (len > 0) {
                            if ((bitField & 16842752) !== 0) {
                                var reason = this._fulfillmentHandler0;
                                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                                this._rejectPromises(len, reason);
                            } else {
                                var value = this._rejectionHandler0;
                                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                                this._fulfillPromises(len, value);
                            }
                            this._setLength(0);
                        }
                        this._clearCancellationData();
                    };
                    Promise1.prototype._settledValue = function() {
                        var bitField = this._bitField;
                        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
                        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
                    };
                    if (typeof Symbol !== "undefined" && Symbol.toStringTag) es5.defineProperty(Promise1.prototype, Symbol.toStringTag, {
                        get: function() {
                            return "Object";
                        }
                    });
                    function deferResolve(v) {
                        this.promise._resolveCallback(v);
                    }
                    function deferReject(v) {
                        this.promise._rejectCallback(v, false);
                    }
                    Promise1.defer = Promise1.pending = function() {
                        debug.deprecated("Promise.defer", "new Promise");
                        var promise = new Promise1(INTERNAL);
                        return {
                            promise: promise,
                            resolve: deferResolve,
                            reject: deferReject
                        };
                    };
                    util.notEnumerableProp(Promise1, "_makeSelfResolutionError", makeSelfResolutionError);
                    _dereq_1("./method")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug);
                    _dereq_1("./bind")(Promise1, INTERNAL, tryConvertToPromise, debug);
                    _dereq_1("./cancel")(Promise1, PromiseArray, apiRejection, debug);
                    _dereq_1("./direct_resolve")(Promise1);
                    _dereq_1("./synchronous_inspection")(Promise1);
                    _dereq_1("./join")(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async);
                    Promise1.Promise = Promise1;
                    Promise1.version = "3.7.2";
                    _dereq_1('./call_get.js')(Promise1);
                    _dereq_1('./generators.js')(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
                    _dereq_1('./map.js')(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1('./nodeify.js')(Promise1);
                    _dereq_1('./promisify.js')(Promise1, INTERNAL);
                    _dereq_1('./props.js')(Promise1, PromiseArray, tryConvertToPromise, apiRejection);
                    _dereq_1('./race.js')(Promise1, INTERNAL, tryConvertToPromise, apiRejection);
                    _dereq_1('./reduce.js')(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1('./settle.js')(Promise1, PromiseArray, debug);
                    _dereq_1('./some.js')(Promise1, PromiseArray, apiRejection);
                    _dereq_1('./timers.js')(Promise1, INTERNAL, debug);
                    _dereq_1('./using.js')(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
                    _dereq_1('./any.js')(Promise1);
                    _dereq_1('./each.js')(Promise1, INTERNAL);
                    _dereq_1('./filter.js')(Promise1, INTERNAL);
                    util.toFastProperties(Promise1);
                    util.toFastProperties(Promise1.prototype);
                    function fillTypes(value) {
                        var p = new Promise1(INTERNAL);
                        p._fulfillmentHandler0 = value;
                        p._rejectionHandler0 = value;
                        p._promise0 = value;
                        p._receiver0 = value;
                    }
                    // Complete slack tracking, opt out of field-type tracking and           
                    // stabilize map                                                         
                    fillTypes({
                        a: 1
                    });
                    fillTypes({
                        b: 2
                    });
                    fillTypes({
                        c: 3
                    });
                    fillTypes(1);
                    fillTypes(function() {});
                    fillTypes(undefined);
                    fillTypes(false);
                    fillTypes(new Promise1(INTERNAL));
                    debug.setBounds(Async.firstLineError, util.lastLineError);
                    return Promise1;
                };
            },
            {
                "./any.js": 1,
                "./async": 2,
                "./bind": 3,
                "./call_get.js": 5,
                "./cancel": 6,
                "./catch_filter": 7,
                "./context": 8,
                "./debuggability": 9,
                "./direct_resolve": 10,
                "./each.js": 11,
                "./errors": 12,
                "./es5": 13,
                "./filter.js": 14,
                "./finally": 15,
                "./generators.js": 16,
                "./join": 17,
                "./map.js": 18,
                "./method": 19,
                "./nodeback": 20,
                "./nodeify.js": 21,
                "./promise_array": 23,
                "./promisify.js": 24,
                "./props.js": 25,
                "./race.js": 27,
                "./reduce.js": 28,
                "./settle.js": 30,
                "./some.js": 31,
                "./synchronous_inspection": 32,
                "./thenables": 33,
                "./timers.js": 34,
                "./using.js": 35,
                "./util": 36,
                "async_hooks": undefined
            }
        ],
        23: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
                    var util = _dereq_1("./util");
                    var isArray = util.isArray;
                    function toResolutionValue(val) {
                        switch(val){
                            case -2:
                                return [];
                            case -3:
                                return {};
                            case -6:
                                return new Map();
                        }
                    }
                    function PromiseArray(values) {
                        var promise = this._promise = new Promise1(INTERNAL);
                        if (values instanceof Promise1) {
                            promise._propagateFrom(values, 3);
                            values.suppressUnhandledRejections();
                        }
                        promise._setOnCancel(this);
                        this._values = values;
                        this._length = 0;
                        this._totalResolved = 0;
                        this._init(undefined, -2);
                    }
                    util.inherits(PromiseArray, Proxyable);
                    PromiseArray.prototype.length = function() {
                        return this._length;
                    };
                    PromiseArray.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
                        var values = tryConvertToPromise(this._values, this._promise);
                        if (values instanceof Promise1) {
                            values = values._target();
                            var bitField = values._bitField;
                            this._values = values;
                            if ((bitField & 50397184) === 0) {
                                this._promise._setAsyncGuaranteed();
                                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                            } else if ((bitField & 33554432) !== 0) values = values._value();
                            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
                            else return this._cancel();
                        }
                        values = util.asArray(values);
                        if (values === null) {
                            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
                            this._promise._rejectCallback(err, false);
                            return;
                        }
                        if (values.length === 0) {
                            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
                            else this._resolve(toResolutionValue(resolveValueIfEmpty));
                            return;
                        }
                        this._iterate(values);
                    };
                    PromiseArray.prototype._iterate = function(values) {
                        var len = this.getActualLength(values.length);
                        this._length = len;
                        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
                        var result = this._promise;
                        var isResolved = false;
                        var bitField = null;
                        for(var i = 0; i < len; ++i){
                            var maybePromise = tryConvertToPromise(values[i], result);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                bitField = maybePromise._bitField;
                            } else bitField = null;
                            if (isResolved) {
                                if (bitField !== null) maybePromise.suppressUnhandledRejections();
                            } else if (bitField !== null) {
                                if ((bitField & 50397184) === 0) {
                                    maybePromise._proxy(this, i);
                                    this._values[i] = maybePromise;
                                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                                else isResolved = this._promiseCancelled(i);
                            } else isResolved = this._promiseFulfilled(maybePromise, i);
                        }
                        if (!isResolved) result._setAsyncGuaranteed();
                    };
                    PromiseArray.prototype._isResolved = function() {
                        return this._values === null;
                    };
                    PromiseArray.prototype._resolve = function(value) {
                        this._values = null;
                        this._promise._fulfill(value);
                    };
                    PromiseArray.prototype._cancel = function() {
                        if (this._isResolved() || !this._promise._isCancellable()) return;
                        this._values = null;
                        this._promise._cancel();
                    };
                    PromiseArray.prototype._reject = function(reason) {
                        this._values = null;
                        this._promise._rejectCallback(reason, false);
                    };
                    PromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    PromiseArray.prototype._promiseCancelled = function() {
                        this._cancel();
                        return true;
                    };
                    PromiseArray.prototype._promiseRejected = function(reason) {
                        this._totalResolved++;
                        this._reject(reason);
                        return true;
                    };
                    PromiseArray.prototype._resultCancelled = function() {
                        if (this._isResolved()) return;
                        var values = this._values;
                        this._cancel();
                        if (values instanceof Promise1) values.cancel();
                        else {
                            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise1) values[i].cancel();
                        }
                    };
                    PromiseArray.prototype.shouldCopyValues = function() {
                        return true;
                    };
                    PromiseArray.prototype.getActualLength = function(len) {
                        return len;
                    };
                    return PromiseArray;
                };
            },
            {
                "./util": 36
            }
        ],
        24: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var THIS = {};
                    var util = _dereq_1("./util");
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var withAppended = util.withAppended;
                    var maybeWrapAsError = util.maybeWrapAsError;
                    var canEvaluate = util.canEvaluate;
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var defaultSuffix = "Async";
                    var defaultPromisified = {
                        __isPromisified__: true
                    };
                    var noCopyProps = [
                        "arity",
                        "length",
                        "name",
                        "arguments",
                        "caller",
                        "callee",
                        "prototype",
                        "__isPromisified__"
                    ];
                    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
                    var defaultFilter = function(name) {
                        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
                    };
                    function propsFilter(key) {
                        return !noCopyPropsPattern.test(key);
                    }
                    function isPromisified(fn) {
                        try {
                            return fn.__isPromisified__ === true;
                        } catch (e) {
                            return false;
                        }
                    }
                    function hasPromisified(obj, key, suffix) {
                        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
                        return val ? isPromisified(val) : false;
                    }
                    function checkValid(ret, suffix, suffixRegexp) {
                        for(var i = 0; i < ret.length; i += 2){
                            var key = ret[i];
                            if (suffixRegexp.test(key)) {
                                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                                for(var j = 0; j < ret.length; j += 2){
                                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError1("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a".replace("%s", suffix));
                                }
                            }
                        }
                    }
                    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
                        var keys = util.inheritedDataKeys(obj);
                        var ret = [];
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            var value = obj[key];
                            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
                            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
                        }
                        checkValid(ret, suffix, suffixRegexp);
                        return ret;
                    }
                    var escapeIdentRegex = function(str) {
                        return str.replace(/([$])/, "\\$");
                    };
                    var makeNodePromisifiedEval;
                    var switchCaseArgumentOrder, argumentSequence, parameterDeclaration, parameterCount;
                    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
                        var defaultThis = function() {
                            return this;
                        }();
                        var method = callback;
                        if (typeof method === "string") callback = fn;
                        function promisified() {
                            var _receiver = receiver;
                            if (receiver === THIS) _receiver = this;
                            var promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                            var fn = nodebackForPromise(promise, multiArgs);
                            try {
                                cb.apply(_receiver, withAppended(arguments, fn));
                            } catch (e) {
                                promise._rejectCallback(maybeWrapAsError(e), true, true);
                            }
                            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                            return promise;
                        }
                        util.notEnumerableProp(promisified, "__isPromisified__", true);
                        return promisified;
                    }
                    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
                    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
                        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
                        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
                        for(var i = 0, len = methods.length; i < len; i += 2){
                            var key = methods[i];
                            var fn = methods[i + 1];
                            var promisifiedKey = key + suffix;
                            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                            else {
                                var promisified = promisifier(fn, function() {
                                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                });
                                util.notEnumerableProp(promisified, "__isPromisified__", true);
                                obj[promisifiedKey] = promisified;
                            }
                        }
                        util.toFastProperties(obj);
                        return obj;
                    }
                    function promisify(callback, receiver, multiArgs) {
                        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
                    }
                    Promise1.promisify = function(fn, options) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        if (isPromisified(fn)) return fn;
                        options = Object(options);
                        var receiver = options.context === undefined ? THIS : options.context;
                        var multiArgs = !!options.multiArgs;
                        var ret = promisify(fn, receiver, multiArgs);
                        util.copyDescriptors(fn, ret, propsFilter);
                        return ret;
                    };
                    Promise1.promisifyAll = function(target, options) {
                        if (typeof target !== "function" && typeof target !== "object") throw new TypeError1("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        options = Object(options);
                        var multiArgs = !!options.multiArgs;
                        var suffix = options.suffix;
                        if (typeof suffix !== "string") suffix = defaultSuffix;
                        var filter = options.filter;
                        if (typeof filter !== "function") filter = defaultFilter;
                        var promisifier = options.promisifier;
                        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
                        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var keys = util.inheritedDataKeys(target);
                        for(var i = 0; i < keys.length; ++i){
                            var value = target[keys[i]];
                            if (keys[i] !== "constructor" && util.isClass(value)) {
                                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                                promisifyAll(value, suffix, filter, promisifier, multiArgs);
                            }
                        }
                        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
                    };
                };
            },
            {
                "./errors": 12,
                "./nodeback": 20,
                "./util": 36
            }
        ],
        25: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var isObject = util.isObject;
                    var es5 = _dereq_1("./es5");
                    var Es6Map;
                    if (typeof Map === "function") Es6Map = Map;
                    var mapToEntries = function() {
                        var index = 0;
                        var size = 0;
                        function extractEntry(value, key) {
                            this[index] = value;
                            this[index + size] = key;
                            index++;
                        }
                        return function mapToEntries(map) {
                            size = map.size;
                            index = 0;
                            var ret = new Array(map.size * 2);
                            map.forEach(extractEntry, ret);
                            return ret;
                        };
                    }();
                    var entriesToMap = function(entries) {
                        var ret = new Es6Map();
                        var length = entries.length / 2 | 0;
                        for(var i = 0; i < length; ++i){
                            var key = entries[length + i];
                            var value = entries[i];
                            ret.set(key, value);
                        }
                        return ret;
                    };
                    function PropertiesPromiseArray(obj) {
                        var isMap = false;
                        var entries;
                        if (Es6Map !== undefined && obj instanceof Es6Map) {
                            entries = mapToEntries(obj);
                            isMap = true;
                        } else {
                            var keys = es5.keys(obj);
                            var len = keys.length;
                            entries = new Array(len * 2);
                            for(var i = 0; i < len; ++i){
                                var key = keys[i];
                                entries[i] = obj[key];
                                entries[i + len] = key;
                            }
                        }
                        this.constructor$(entries);
                        this._isMap = isMap;
                        this._init$(undefined, isMap ? -6 : -3);
                    }
                    util.inherits(PropertiesPromiseArray, PromiseArray);
                    PropertiesPromiseArray.prototype._init = function() {};
                    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            var val;
                            if (this._isMap) val = entriesToMap(this._values);
                            else {
                                val = {};
                                var keyOffset = this.length();
                                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
                            }
                            this._resolve(val);
                            return true;
                        }
                        return false;
                    };
                    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    PropertiesPromiseArray.prototype.getActualLength = function(len) {
                        return len >> 1;
                    };
                    function props(promises) {
                        var ret;
                        var castValue = tryConvertToPromise(promises);
                        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        else if (castValue instanceof Promise1) ret = castValue._then(Promise1.props, undefined, undefined, undefined, undefined);
                        else ret = new PropertiesPromiseArray(castValue).promise();
                        if (castValue instanceof Promise1) ret._propagateFrom(castValue, 2);
                        return ret;
                    }
                    Promise1.prototype.props = function() {
                        return props(this);
                    };
                    Promise1.props = function(promises) {
                        return props(promises);
                    };
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        26: [
            function(_dereq_1, module1, exports) {
                "use strict";
                function arrayMove(src, srcIndex, dst, dstIndex, len) {
                    for(var j = 0; j < len; ++j){
                        dst[j + dstIndex] = src[j + srcIndex];
                        src[j + srcIndex] = void 0;
                    }
                }
                function Queue(capacity) {
                    this._capacity = capacity;
                    this._length = 0;
                    this._front = 0;
                }
                Queue.prototype._willBeOverCapacity = function(size) {
                    return this._capacity < size;
                };
                Queue.prototype._pushOne = function(arg) {
                    var length = this.length();
                    this._checkCapacity(length + 1);
                    var i = this._front + length & this._capacity - 1;
                    this[i] = arg;
                    this._length = length + 1;
                };
                Queue.prototype.push = function(fn, receiver, arg) {
                    var length = this.length() + 3;
                    if (this._willBeOverCapacity(length)) {
                        this._pushOne(fn);
                        this._pushOne(receiver);
                        this._pushOne(arg);
                        return;
                    }
                    var j = this._front + length - 3;
                    this._checkCapacity(length);
                    var wrapMask = this._capacity - 1;
                    this[j + 0 & wrapMask] = fn;
                    this[j + 1 & wrapMask] = receiver;
                    this[j + 2 & wrapMask] = arg;
                    this._length = length;
                };
                Queue.prototype.shift = function() {
                    var front = this._front, ret = this[front];
                    this[front] = undefined;
                    this._front = front + 1 & this._capacity - 1;
                    this._length--;
                    return ret;
                };
                Queue.prototype.length = function() {
                    return this._length;
                };
                Queue.prototype._checkCapacity = function(size) {
                    if (this._capacity < size) this._resizeTo(this._capacity << 1);
                };
                Queue.prototype._resizeTo = function(capacity) {
                    var oldCapacity = this._capacity;
                    this._capacity = capacity;
                    var front = this._front;
                    var length = this._length;
                    var moveItemsCount = front + length & oldCapacity - 1;
                    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
                };
                module1.exports = Queue;
            },
            {}
        ],
        27: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var raceLater = function(promise) {
                        return promise.then(function(array) {
                            return race(array, promise);
                        });
                    };
                    function race(promises, parent) {
                        var maybePromise = tryConvertToPromise(promises);
                        if (maybePromise instanceof Promise1) return raceLater(maybePromise);
                        else {
                            promises = util.asArray(promises);
                            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
                        }
                        var ret = new Promise1(INTERNAL);
                        if (parent !== undefined) ret._propagateFrom(parent, 3);
                        var fulfill = ret._fulfill;
                        var reject = ret._reject;
                        for(var i = 0, len = promises.length; i < len; ++i){
                            var val = promises[i];
                            if (val === undefined && !(i in promises)) continue;
                            Promise1.cast(val)._then(fulfill, reject, undefined, ret, null);
                        }
                        return ret;
                    }
                    Promise1.race = function(promises) {
                        return race(promises, undefined);
                    };
                    Promise1.prototype.race = function() {
                        return race(this, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        28: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    function ReductionPromiseArray(promises, fn, initialValue, _each) {
                        this.constructor$(promises);
                        var context = Promise1._getContext();
                        this._fn = util.contextBind(context, fn);
                        if (initialValue !== undefined) {
                            initialValue = Promise1.resolve(initialValue);
                            initialValue._attachCancellationCallback(this);
                        }
                        this._initialValue = initialValue;
                        this._currentCancellable = null;
                        if (_each === INTERNAL) this._eachValues = Array(this._length);
                        else if (_each === 0) this._eachValues = null;
                        else this._eachValues = undefined;
                        this._promise._captureStackTrace();
                        this._init$(undefined, -5);
                    }
                    util.inherits(ReductionPromiseArray, PromiseArray);
                    ReductionPromiseArray.prototype._gotAccum = function(accum) {
                        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
                    };
                    ReductionPromiseArray.prototype._eachComplete = function(value) {
                        if (this._eachValues !== null) this._eachValues.push(value);
                        return this._eachValues;
                    };
                    ReductionPromiseArray.prototype._init = function() {};
                    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
                        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
                    };
                    ReductionPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    ReductionPromiseArray.prototype._resolve = function(value) {
                        this._promise._resolveCallback(value);
                        this._values = null;
                    };
                    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
                        if (sender === this._initialValue) return this._cancel();
                        if (this._isResolved()) return;
                        this._resultCancelled$();
                        if (this._currentCancellable instanceof Promise1) this._currentCancellable.cancel();
                        if (this._initialValue instanceof Promise1) this._initialValue.cancel();
                    };
                    ReductionPromiseArray.prototype._iterate = function(values) {
                        this._values = values;
                        var value;
                        var i;
                        var length = values.length;
                        if (this._initialValue !== undefined) {
                            value = this._initialValue;
                            i = 0;
                        } else {
                            value = Promise1.resolve(values[0]);
                            i = 1;
                        }
                        this._currentCancellable = value;
                        for(var j = i; j < length; ++j){
                            var maybePromise = values[j];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                        if (!value.isRejected()) for(; i < length; ++i){
                            var ctx = {
                                accum: null,
                                value: values[i],
                                index: i,
                                length: length,
                                array: this
                            };
                            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
                            if ((i & 127) === 0) value._setNoAsyncGuarantee();
                        }
                        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
                        value._then(completed, completed, undefined, value, this);
                    };
                    Promise1.prototype.reduce = function(fn, initialValue) {
                        return reduce(this, fn, initialValue, null);
                    };
                    Promise1.reduce = function(promises, fn, initialValue, _each) {
                        return reduce(promises, fn, initialValue, _each);
                    };
                    function completed(valueOrReason, array) {
                        if (this.isFulfilled()) array._resolve(valueOrReason);
                        else array._reject(valueOrReason);
                    }
                    function reduce(promises, fn, initialValue, _each) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
                        return array.promise();
                    }
                    function gotAccum(accum) {
                        this.accum = accum;
                        this.array._gotAccum(accum);
                        var value = tryConvertToPromise(this.value, this.array._promise);
                        if (value instanceof Promise1) {
                            this.array._currentCancellable = value;
                            return value._then(gotValue, undefined, undefined, this, undefined);
                        } else return gotValue.call(this, value);
                    }
                    function gotValue(value) {
                        var array = this.array;
                        var promise = array._promise;
                        var fn = tryCatch(array._fn);
                        promise._pushContext();
                        var ret;
                        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
                        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
                        if (ret instanceof Promise1) array._currentCancellable = ret;
                        var promiseCreated = promise._popContext();
                        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
                        return ret;
                    }
                };
            },
            {
                "./util": 36
            }
        ],
        29: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var schedule;
                var noAsyncScheduler = function() {
                    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                };
                var NativePromise = util.getNativePromise();
                if (util.isNode && typeof MutationObserver === "undefined") {
                    var GlobalSetImmediate = global.setImmediate;
                    var ProcessNextTick = process.nextTick;
                    schedule = util.isRecentNode ? function(fn) {
                        GlobalSetImmediate.call(global, fn);
                    } : function(fn) {
                        ProcessNextTick.call(process, fn);
                    };
                } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
                    var nativePromise = NativePromise.resolve();
                    schedule = function(fn) {
                        nativePromise.then(fn);
                    };
                } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) schedule = function() {
                    var div = document.createElement("div");
                    var opts = {
                        attributes: true
                    };
                    var toggleScheduled = false;
                    var div2 = document.createElement("div");
                    var o2 = new MutationObserver(function() {
                        div.classList.toggle("foo");
                        toggleScheduled = false;
                    });
                    o2.observe(div2, opts);
                    var scheduleToggle = function() {
                        if (toggleScheduled) return;
                        toggleScheduled = true;
                        div2.classList.toggle("foo");
                    };
                    return function schedule(fn) {
                        var o = new MutationObserver(function() {
                            o.disconnect();
                            fn();
                        });
                        o.observe(div, opts);
                        scheduleToggle();
                    };
                }();
                else if (typeof setImmediate !== "undefined") schedule = function(fn) {
                    setImmediate(fn);
                };
                else if (typeof setTimeout !== "undefined") schedule = function(fn) {
                    setTimeout(fn, 0);
                };
                else schedule = noAsyncScheduler;
                module1.exports = schedule;
            },
            {
                "./util": 36
            }
        ],
        30: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, debug) {
                    var PromiseInspection = Promise1.PromiseInspection;
                    var util = _dereq_1("./util");
                    function SettledPromiseArray(values) {
                        this.constructor$(values);
                    }
                    util.inherits(SettledPromiseArray, PromiseArray);
                    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
                        this._values[index] = inspection;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 33554432;
                        ret._settledValueField = value;
                        return this._promiseResolved(index, ret);
                    };
                    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 16777216;
                        ret._settledValueField = reason;
                        return this._promiseResolved(index, ret);
                    };
                    Promise1.settle = function(promises) {
                        debug.deprecated(".settle()", ".reflect()");
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.allSettled = function(promises) {
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.prototype.settle = function() {
                        return Promise1.settle(this);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        31: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection) {
                    var util = _dereq_1("./util");
                    var RangeError1 = _dereq_1("./errors").RangeError;
                    var AggregateError = _dereq_1("./errors").AggregateError;
                    var isArray = util.isArray;
                    var CANCELLATION = {};
                    function SomePromiseArray(values) {
                        this.constructor$(values);
                        this._howMany = 0;
                        this._unwrap = false;
                        this._initialized = false;
                    }
                    util.inherits(SomePromiseArray, PromiseArray);
                    SomePromiseArray.prototype._init = function() {
                        if (!this._initialized) return;
                        if (this._howMany === 0) {
                            this._resolve([]);
                            return;
                        }
                        this._init$(undefined, -5);
                        var isArrayResolved = isArray(this._values);
                        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
                    };
                    SomePromiseArray.prototype.init = function() {
                        this._initialized = true;
                        this._init();
                    };
                    SomePromiseArray.prototype.setUnwrap = function() {
                        this._unwrap = true;
                    };
                    SomePromiseArray.prototype.howMany = function() {
                        return this._howMany;
                    };
                    SomePromiseArray.prototype.setHowMany = function(count) {
                        this._howMany = count;
                    };
                    SomePromiseArray.prototype._promiseFulfilled = function(value) {
                        this._addFulfilled(value);
                        if (this._fulfilled() === this.howMany()) {
                            this._values.length = this.howMany();
                            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
                            else this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._promiseRejected = function(reason) {
                        this._addRejected(reason);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._promiseCancelled = function() {
                        if (this._values instanceof Promise1 || this._values == null) return this._cancel();
                        this._addRejected(CANCELLATION);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._checkOutcome = function() {
                        if (this.howMany() > this._canPossiblyFulfill()) {
                            var e = new AggregateError();
                            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
                            if (e.length > 0) this._reject(e);
                            else this._cancel();
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._fulfilled = function() {
                        return this._totalResolved;
                    };
                    SomePromiseArray.prototype._rejected = function() {
                        return this._values.length - this.length();
                    };
                    SomePromiseArray.prototype._addRejected = function(reason) {
                        this._values.push(reason);
                    };
                    SomePromiseArray.prototype._addFulfilled = function(value) {
                        this._values[this._totalResolved++] = value;
                    };
                    SomePromiseArray.prototype._canPossiblyFulfill = function() {
                        return this.length() - this._rejected();
                    };
                    SomePromiseArray.prototype._getRangeError = function(count) {
                        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
                        return new RangeError1(message);
                    };
                    SomePromiseArray.prototype._resolveEmptyArray = function() {
                        this._reject(this._getRangeError(0));
                    };
                    function some(promises, howMany) {
                        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(howMany);
                        ret.init();
                        return promise;
                    }
                    Promise1.some = function(promises, howMany) {
                        return some(promises, howMany);
                    };
                    Promise1.prototype.some = function(howMany) {
                        return some(this, howMany);
                    };
                    Promise1._SomePromiseArray = SomePromiseArray;
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        32: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function PromiseInspection(promise) {
                        if (promise !== undefined) {
                            promise = promise._target();
                            this._bitField = promise._bitField;
                            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
                        } else {
                            this._bitField = 0;
                            this._settledValueField = undefined;
                        }
                    }
                    PromiseInspection.prototype._settledValue = function() {
                        return this._settledValueField;
                    };
                    var value = PromiseInspection.prototype.value = function() {
                        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        return this._settledValue();
                    };
                    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
                        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        return this._settledValue();
                    };
                    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
                        return (this._bitField & 33554432) !== 0;
                    };
                    var isRejected = PromiseInspection.prototype.isRejected = function() {
                        return (this._bitField & 16777216) !== 0;
                    };
                    var isPending = PromiseInspection.prototype.isPending = function() {
                        return (this._bitField & 50397184) === 0;
                    };
                    var isResolved = PromiseInspection.prototype.isResolved = function() {
                        return (this._bitField & 50331648) !== 0;
                    };
                    PromiseInspection.prototype.isCancelled = function() {
                        return (this._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.__isCancelled = function() {
                        return (this._bitField & 65536) === 65536;
                    };
                    Promise1.prototype._isCancelled = function() {
                        return this._target().__isCancelled();
                    };
                    Promise1.prototype.isCancelled = function() {
                        return (this._target()._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.isPending = function() {
                        return isPending.call(this._target());
                    };
                    Promise1.prototype.isRejected = function() {
                        return isRejected.call(this._target());
                    };
                    Promise1.prototype.isFulfilled = function() {
                        return isFulfilled.call(this._target());
                    };
                    Promise1.prototype.isResolved = function() {
                        return isResolved.call(this._target());
                    };
                    Promise1.prototype.value = function() {
                        return value.call(this._target());
                    };
                    Promise1.prototype.reason = function() {
                        var target = this._target();
                        target._unsetRejectionIsUnhandled();
                        return reason.call(target);
                    };
                    Promise1.prototype._value = function() {
                        return this._settledValue();
                    };
                    Promise1.prototype._reason = function() {
                        this._unsetRejectionIsUnhandled();
                        return this._settledValue();
                    };
                    Promise1.PromiseInspection = PromiseInspection;
                };
            },
            {}
        ],
        33: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var isObject = util.isObject;
                    function tryConvertToPromise(obj, context) {
                        if (isObject(obj)) {
                            if (obj instanceof Promise1) return obj;
                            var then = getThen(obj);
                            if (then === errorObj) {
                                if (context) context._pushContext();
                                var ret = Promise1.reject(then.e);
                                if (context) context._popContext();
                                return ret;
                            } else if (typeof then === "function") {
                                if (isAnyBluebirdPromise(obj)) {
                                    var ret = new Promise1(INTERNAL);
                                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                                    return ret;
                                }
                                return doThenable(obj, then, context);
                            }
                        }
                        return obj;
                    }
                    function doGetThen(obj) {
                        return obj.then;
                    }
                    function getThen(obj) {
                        try {
                            return doGetThen(obj);
                        } catch (e) {
                            errorObj.e = e;
                            return errorObj;
                        }
                    }
                    var hasProp = {}.hasOwnProperty;
                    function isAnyBluebirdPromise(obj) {
                        try {
                            return hasProp.call(obj, "_promise0");
                        } catch (e) {
                            return false;
                        }
                    }
                    function doThenable(x, then, context) {
                        var promise = new Promise1(INTERNAL);
                        var ret = promise;
                        if (context) context._pushContext();
                        promise._captureStackTrace();
                        if (context) context._popContext();
                        var synchronous = true;
                        var result = util.tryCatch(then).call(x, resolve, reject);
                        synchronous = false;
                        if (promise && result === errorObj) {
                            promise._rejectCallback(result.e, true, true);
                            promise = null;
                        }
                        function resolve(value) {
                            if (!promise) return;
                            promise._resolveCallback(value);
                            promise = null;
                        }
                        function reject(reason) {
                            if (!promise) return;
                            promise._rejectCallback(reason, synchronous, true);
                            promise = null;
                        }
                        return ret;
                    }
                    return tryConvertToPromise;
                };
            },
            {
                "./util": 36
            }
        ],
        34: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TimeoutError = Promise1.TimeoutError;
                    function HandleWrapper(handle) {
                        this.handle = handle;
                    }
                    HandleWrapper.prototype._resultCancelled = function() {
                        clearTimeout(this.handle);
                    };
                    var afterValue = function(value) {
                        return delay(+this).thenReturn(value);
                    };
                    var delay = Promise1.delay = function(ms, value) {
                        var ret;
                        var handle;
                        if (value !== undefined) {
                            ret = Promise1.resolve(value)._then(afterValue, null, null, ms, undefined);
                            if (debug.cancellation() && value instanceof Promise1) ret._setOnCancel(value);
                        } else {
                            ret = new Promise1(INTERNAL);
                            handle = setTimeout(function() {
                                ret._fulfill();
                            }, +ms);
                            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
                            ret._captureStackTrace();
                        }
                        ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.prototype.delay = function(ms) {
                        return delay(ms, this);
                    };
                    var afterTimeout = function(promise, message, parent) {
                        var err;
                        if (typeof message !== "string") {
                            if (message instanceof Error) err = message;
                            else err = new TimeoutError("operation timed out");
                        } else err = new TimeoutError(message);
                        util.markAsOriginatingFromRejection(err);
                        promise._attachExtraTrace(err);
                        promise._reject(err);
                        if (parent != null) parent.cancel();
                    };
                    function successClear(value) {
                        clearTimeout(this.handle);
                        return value;
                    }
                    function failureClear(reason) {
                        clearTimeout(this.handle);
                        throw reason;
                    }
                    Promise1.prototype.timeout = function(ms, message) {
                        ms = +ms;
                        var ret, parent;
                        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
                            if (ret.isPending()) afterTimeout(ret, message, parent);
                        }, ms));
                        if (debug.cancellation()) {
                            parent = this.then();
                            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
                            ret._setOnCancel(handleWrapper);
                        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
                        return ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        35: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var inherits = _dereq_1("./util").inherits;
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var NULL = {};
                    function thrower(e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                    function castPreservingDisposable(thenable) {
                        var maybePromise = tryConvertToPromise(thenable);
                        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
                        return maybePromise;
                    }
                    function dispose(resources, inspection) {
                        var i = 0;
                        var len = resources.length;
                        var ret = new Promise1(INTERNAL);
                        function iterator() {
                            if (i >= len) return ret._fulfill();
                            var maybePromise = castPreservingDisposable(resources[i++]);
                            if (maybePromise instanceof Promise1 && maybePromise._isDisposable()) {
                                try {
                                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                                } catch (e) {
                                    return thrower(e);
                                }
                                if (maybePromise instanceof Promise1) return maybePromise._then(iterator, thrower, null, null, null);
                            }
                            iterator();
                        }
                        iterator();
                        return ret;
                    }
                    function Disposer(data, promise, context) {
                        this._data = data;
                        this._promise = promise;
                        this._context = context;
                    }
                    Disposer.prototype.data = function() {
                        return this._data;
                    };
                    Disposer.prototype.promise = function() {
                        return this._promise;
                    };
                    Disposer.prototype.resource = function() {
                        if (this.promise().isFulfilled()) return this.promise().value();
                        return NULL;
                    };
                    Disposer.prototype.tryDispose = function(inspection) {
                        var resource = this.resource();
                        var context = this._context;
                        if (context !== undefined) context._pushContext();
                        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
                        if (context !== undefined) context._popContext();
                        this._promise._unsetDisposable();
                        this._data = null;
                        return ret;
                    };
                    Disposer.isDisposer = function(d) {
                        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
                    };
                    function FunctionDisposer(fn, promise, context) {
                        this.constructor$(fn, promise, context);
                    }
                    inherits(FunctionDisposer, Disposer);
                    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
                        var fn = this.data();
                        return fn.call(resource, resource, inspection);
                    };
                    function maybeUnwrapDisposer(value) {
                        if (Disposer.isDisposer(value)) {
                            this.resources[this.index]._setDisposable(value);
                            return value.promise();
                        }
                        return value;
                    }
                    function ResourceList(length) {
                        this.length = length;
                        this.promise = null;
                        this[length - 1] = null;
                    }
                    ResourceList.prototype._resultCancelled = function() {
                        var len = this.length;
                        for(var i = 0; i < len; ++i){
                            var item = this[i];
                            if (item instanceof Promise1) item.cancel();
                        }
                    };
                    Promise1.using = function() {
                        var len = arguments.length;
                        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
                        var fn = arguments[len - 1];
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var input;
                        var spreadArgs = true;
                        if (len === 2 && Array.isArray(arguments[0])) {
                            input = arguments[0];
                            len = input.length;
                            spreadArgs = false;
                        } else {
                            input = arguments;
                            len--;
                        }
                        var resources = new ResourceList(len);
                        for(var i = 0; i < len; ++i){
                            var resource = input[i];
                            if (Disposer.isDisposer(resource)) {
                                var disposer = resource;
                                resource = resource.promise();
                                resource._setDisposable(disposer);
                            } else {
                                var maybePromise = tryConvertToPromise(resource);
                                if (maybePromise instanceof Promise1) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                                    resources: resources,
                                    index: i
                                }, undefined);
                            }
                            resources[i] = resource;
                        }
                        var reflectedResources = new Array(resources.length);
                        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise1.resolve(resources[i]).reflect();
                        var resultPromise = Promise1.all(reflectedResources).then(function(inspections) {
                            for(var i = 0; i < inspections.length; ++i){
                                var inspection = inspections[i];
                                if (inspection.isRejected()) {
                                    errorObj.e = inspection.error();
                                    return errorObj;
                                } else if (!inspection.isFulfilled()) {
                                    resultPromise.cancel();
                                    return;
                                }
                                inspections[i] = inspection.value();
                            }
                            promise._pushContext();
                            fn = tryCatch(fn);
                            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                            return ret;
                        });
                        var promise = resultPromise.lastly(function() {
                            var inspection = new Promise1.PromiseInspection(resultPromise);
                            return dispose(resources, inspection);
                        });
                        resources.promise = promise;
                        promise._setOnCancel(resources);
                        return promise;
                    };
                    Promise1.prototype._setDisposable = function(disposer) {
                        this._bitField = this._bitField | 131072;
                        this._disposer = disposer;
                    };
                    Promise1.prototype._isDisposable = function() {
                        return (this._bitField & 131072) > 0;
                    };
                    Promise1.prototype._getDisposer = function() {
                        return this._disposer;
                    };
                    Promise1.prototype._unsetDisposable = function() {
                        this._bitField = this._bitField & -131073;
                        this._disposer = undefined;
                    };
                    Promise1.prototype.disposer = function(fn) {
                        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
                        throw new TypeError1();
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        36: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var canEvaluate = typeof navigator == "undefined";
                var errorObj = {
                    e: {}
                };
                var tryCatchTarget;
                var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : this !== undefined ? this : null;
                function tryCatcher() {
                    try {
                        var target = tryCatchTarget;
                        tryCatchTarget = null;
                        return target.apply(this, arguments);
                    } catch (e) {
                        errorObj.e = e;
                        return errorObj;
                    }
                }
                function tryCatch(fn) {
                    tryCatchTarget = fn;
                    return tryCatcher;
                }
                var inherits = function(Child, Parent) {
                    var hasProp = {}.hasOwnProperty;
                    function T() {
                        this.constructor = Child;
                        this.constructor$ = Parent;
                        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
                    }
                    T.prototype = Parent.prototype;
                    Child.prototype = new T();
                    return Child.prototype;
                };
                function isPrimitive(val) {
                    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
                }
                function isObject(value) {
                    return typeof value === "function" || typeof value === "object" && value !== null;
                }
                function maybeWrapAsError(maybeError) {
                    if (!isPrimitive(maybeError)) return maybeError;
                    return new Error(safeToString(maybeError));
                }
                function withAppended(target, appendee) {
                    var len = target.length;
                    var ret = new Array(len + 1);
                    var i;
                    for(i = 0; i < len; ++i)ret[i] = target[i];
                    ret[i] = appendee;
                    return ret;
                }
                function getDataPropertyOrDefault(obj, key, defaultValue) {
                    if (es5.isES5) {
                        var desc = Object.getOwnPropertyDescriptor(obj, key);
                        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
                    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
                }
                function notEnumerableProp(obj, name, value) {
                    if (isPrimitive(obj)) return obj;
                    var descriptor = {
                        value: value,
                        configurable: true,
                        enumerable: false,
                        writable: true
                    };
                    es5.defineProperty(obj, name, descriptor);
                    return obj;
                }
                function thrower(r) {
                    throw r;
                }
                var inheritedDataKeys = function() {
                    var excludedPrototypes = [
                        Array.prototype,
                        Object.prototype,
                        Function.prototype
                    ];
                    var isExcludedProto = function(val) {
                        for(var i = 0; i < excludedPrototypes.length; ++i){
                            if (excludedPrototypes[i] === val) return true;
                        }
                        return false;
                    };
                    if (es5.isES5) {
                        var getKeys = Object.getOwnPropertyNames;
                        return function(obj) {
                            var ret = [];
                            var visitedKeys = Object.create(null);
                            while(obj != null && !isExcludedProto(obj)){
                                var keys;
                                try {
                                    keys = getKeys(obj);
                                } catch (e) {
                                    return ret;
                                }
                                for(var i = 0; i < keys.length; ++i){
                                    var key = keys[i];
                                    if (visitedKeys[key]) continue;
                                    visitedKeys[key] = true;
                                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                                }
                                obj = es5.getPrototypeOf(obj);
                            }
                            return ret;
                        };
                    } else {
                        var hasProp = {}.hasOwnProperty;
                        return function(obj) {
                            if (isExcludedProto(obj)) return [];
                            var ret = [];
                            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
                            else {
                                for(var i = 0; i < excludedPrototypes.length; ++i){
                                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                                }
                                ret.push(key);
                            }
                            return ret;
                        };
                    }
                }();
                var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
                function isClass(fn) {
                    try {
                        if (typeof fn === "function") {
                            var keys = es5.names(fn.prototype);
                            var hasMethods = es5.isES5 && keys.length > 1;
                            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
                            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
                        }
                        return false;
                    } catch (e) {
                        return false;
                    }
                }
                function toFastProperties(obj) {
                    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
                    FakeConstructor.prototype = obj;
                    var receiver = new FakeConstructor();
                    function ic() {
                        return typeof receiver.foo;
                    }
                    ic();
                    ic();
                    return obj;
                }
                var rident = /^[a-z$_][a-z$_0-9]*$/i;
                function isIdentifier(str) {
                    return rident.test(str);
                }
                function filledRange(count, prefix, suffix) {
                    var ret = new Array(count);
                    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
                    return ret;
                }
                function safeToString(obj) {
                    try {
                        return obj + "";
                    } catch (e) {
                        return "[no string representation]";
                    }
                }
                function isError(obj) {
                    return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
                }
                function markAsOriginatingFromRejection(e) {
                    try {
                        notEnumerableProp(e, "isOperational", true);
                    } catch (ignore) {}
                }
                function originatesFromRejection(e) {
                    if (e == null) return false;
                    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
                }
                function canAttachTrace(obj) {
                    return isError(obj) && es5.propertyIsWritable(obj, "stack");
                }
                var ensureErrorObject = function() {
                    if (!("stack" in new Error())) return function(value) {
                        if (canAttachTrace(value)) return value;
                        try {
                            throw new Error(safeToString(value));
                        } catch (err) {
                            return err;
                        }
                    };
                    else return function(value) {
                        if (canAttachTrace(value)) return value;
                        return new Error(safeToString(value));
                    };
                }();
                function classString(obj) {
                    return ({}).toString.call(obj);
                }
                function copyDescriptors(from, to, filter) {
                    var keys = es5.names(from);
                    for(var i = 0; i < keys.length; ++i){
                        var key = keys[i];
                        if (filter(key)) try {
                            es5.defineProperty(to, key, es5.getDescriptor(from, key));
                        } catch (ignore) {}
                    }
                }
                var asArray = function(v) {
                    if (es5.isArray(v)) return v;
                    return null;
                };
                if (typeof Symbol !== "undefined" && Symbol.iterator) {
                    var ArrayFrom = typeof Array.from === "function" ? function(v) {
                        return Array.from(v);
                    } : function(v) {
                        var ret = [];
                        var it = v[Symbol.iterator]();
                        var itResult;
                        while(!(itResult = it.next()).done)ret.push(itResult.value);
                        return ret;
                    };
                    asArray = function(v) {
                        if (es5.isArray(v)) return v;
                        else if (v != null && typeof v[Symbol.iterator] === "function") return ArrayFrom(v);
                        return null;
                    };
                }
                var isNode = typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]";
                var hasEnvVariables = typeof process !== "undefined" && typeof process.env !== "undefined";
                function env(key) {
                    return hasEnvVariables ? process.env[key] : undefined;
                }
                function getNativePromise() {
                    if (typeof Promise === "function") try {
                        var promise = new Promise(function() {});
                        if (classString(promise) === "[object Promise]") return Promise;
                    } catch (e) {}
                }
                var reflectHandler;
                function contextBind(ctx, cb) {
                    if (ctx === null || typeof cb !== "function" || cb === reflectHandler) return cb;
                    if (ctx.domain !== null) cb = ctx.domain.bind(cb);
                    var async = ctx.async;
                    if (async !== null) {
                        var old = cb;
                        cb = function() {
                            var args = new Array(2).concat([].slice.call(arguments));
                            args[0] = old;
                            args[1] = this;
                            return async.runInAsyncScope.apply(async, args);
                        };
                    }
                    return cb;
                }
                var ret = {
                    setReflectHandler: function(fn) {
                        reflectHandler = fn;
                    },
                    isClass: isClass,
                    isIdentifier: isIdentifier,
                    inheritedDataKeys: inheritedDataKeys,
                    getDataPropertyOrDefault: getDataPropertyOrDefault,
                    thrower: thrower,
                    isArray: es5.isArray,
                    asArray: asArray,
                    notEnumerableProp: notEnumerableProp,
                    isPrimitive: isPrimitive,
                    isObject: isObject,
                    isError: isError,
                    canEvaluate: canEvaluate,
                    errorObj: errorObj,
                    tryCatch: tryCatch,
                    inherits: inherits,
                    withAppended: withAppended,
                    maybeWrapAsError: maybeWrapAsError,
                    toFastProperties: toFastProperties,
                    filledRange: filledRange,
                    toString: safeToString,
                    canAttachTrace: canAttachTrace,
                    ensureErrorObject: ensureErrorObject,
                    originatesFromRejection: originatesFromRejection,
                    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
                    classString: classString,
                    copyDescriptors: copyDescriptors,
                    isNode: isNode,
                    hasEnvVariables: hasEnvVariables,
                    env: env,
                    global: globalObject,
                    getNativePromise: getNativePromise,
                    contextBind: contextBind
                };
                ret.isRecentNode = ret.isNode && function() {
                    var version;
                    if (process.versions && process.versions.node) version = process.versions.node.split(".").map(Number);
                    else if (process.version) version = process.version.split(".").map(Number);
                    return version[0] === 0 && version[1] > 10 || version[0] > 0;
                }();
                ret.nodeSupportsAsyncResource = ret.isNode && function() {
                    var supportsAsync = false;
                    try {
                        var res = _dereq_1("async_hooks").AsyncResource;
                        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
                    } catch (e) {
                        supportsAsync = false;
                    }
                    return supportsAsync;
                }();
                if (ret.isNode) ret.toFastProperties(process);
                try {
                    throw new Error();
                } catch (e) {
                    ret.lastLineError = e;
                }
                module1.exports = ret;
            },
            {
                "./es5": 13,
                "async_hooks": undefined
            }
        ]
    }, {}, [
        4
    ])(4);
});
if (typeof window !== 'undefined' && window !== null) window.P = window.Promise;
else if (typeof self !== 'undefined' && self !== null) self.P = self.Promise;

},{"fb71ed40a9331d76":"5jT8D"}],"9NZ1L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _common = require("./common");
parcelHelpers.exportAll(_common, exports);
var _hooks = require("./hooks");
parcelHelpers.exportAll(_hooks, exports);
var _decorators = require("./decorators");
parcelHelpers.exportAll(_decorators, exports);

},{"./common":"7UAAl","./hooks":"9oSuP","./decorators":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7UAAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dndContext = require("./DndContext");
parcelHelpers.exportAll(_dndContext, exports);
var _dndProvider = require("./DndProvider");
parcelHelpers.exportAll(_dndProvider, exports);
var _dragPreviewImage = require("./DragPreviewImage");
parcelHelpers.exportAll(_dragPreviewImage, exports);

},{"./DndContext":false,"./DndProvider":"4zY7F","./DragPreviewImage":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJy8i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DndContext", ()=>DndContext);
/**
 * Creates the context object we're providing
 * @param backend
 * @param context
 */ parcelHelpers.export(exports, "createDndContext", ()=>createDndContext);
var _react = require("react");
var _dndCore = require("dnd-core");
var DndContext = _react.createContext({
    dragDropManager: undefined
});
function createDndContext(backend, context, options, debugMode) {
    return {
        dragDropManager: (0, _dndCore.createDragDropManager)(backend, context, options, debugMode)
    };
}

},{"react":"9njXz","dnd-core":"1tFfS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1tFfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interfaces = require("./interfaces");
parcelHelpers.exportAll(_interfaces, exports);
var _factories = require("./factories");
parcelHelpers.exportAll(_factories, exports);

},{"./interfaces":false,"./factories":"cvc0x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aB8bN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HandlerRole", ()=>HandlerRole);
var HandlerRole;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvc0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDragDropManager", ()=>createDragDropManager);
var _dragDropManagerImpl = require("./DragDropManagerImpl");
var _dragDropManagerImplDefault = parcelHelpers.interopDefault(_dragDropManagerImpl);
function createDragDropManager(backendFactory, globalContext, backendOptions, debugMode) {
    var manager = new (0, _dragDropManagerImplDefault.default)(debugMode);
    var backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}

},{"./DragDropManagerImpl":"hS3Vj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hS3Vj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragDropManagerImpl);
var _redux = require("redux");
var _reducers = require("./reducers");
var _reducersDefault = parcelHelpers.interopDefault(_reducers);
var _dragDrop = require("./actions/dragDrop");
var _dragDropDefault = parcelHelpers.interopDefault(_dragDrop);
var _dragDropMonitorImpl = require("./DragDropMonitorImpl");
var _dragDropMonitorImplDefault = parcelHelpers.interopDefault(_dragDropMonitorImpl);
var _handlerRegistryImpl = require("./HandlerRegistryImpl");
var _handlerRegistryImplDefault = parcelHelpers.interopDefault(_handlerRegistryImpl);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    var reduxDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, _redux.createStore)((0, _reducersDefault.default), debugMode && reduxDevTools && reduxDevTools({
        name: 'dnd-core',
        instanceId: 'dnd-core'
    }));
}
var DragDropManagerImpl = /*#__PURE__*/ function() {
    function DragDropManagerImpl() {
        var _this = this;
        var debugMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        _classCallCheck(this, DragDropManagerImpl);
        this.isSetUp = false;
        this.handleRefCountChange = function() {
            var shouldSetUp = _this.store.getState().refCount > 0;
            if (_this.backend) {
                if (shouldSetUp && !_this.isSetUp) {
                    _this.backend.setup();
                    _this.isSetUp = true;
                } else if (!shouldSetUp && _this.isSetUp) {
                    _this.backend.teardown();
                    _this.isSetUp = false;
                }
            }
        };
        var store = makeStoreInstance(debugMode);
        this.store = store;
        this.monitor = new (0, _dragDropMonitorImplDefault.default)(store, new (0, _handlerRegistryImplDefault.default)(store));
        store.subscribe(this.handleRefCountChange);
    }
    _createClass(DragDropManagerImpl, [
        {
            key: "receiveBackend",
            value: function receiveBackend(backend) {
                this.backend = backend;
            }
        },
        {
            key: "getMonitor",
            value: function getMonitor() {
                return this.monitor;
            }
        },
        {
            key: "getBackend",
            value: function getBackend() {
                return this.backend;
            }
        },
        {
            key: "getRegistry",
            value: function getRegistry() {
                return this.monitor.registry;
            }
        },
        {
            key: "getActions",
            value: function getActions() {
                /* eslint-disable-next-line @typescript-eslint/no-this-alias */ var manager = this;
                var dispatch = this.store.dispatch;
                function bindActionCreator(actionCreator) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        var action = actionCreator.apply(manager, args);
                        if (typeof action !== 'undefined') dispatch(action);
                    };
                }
                var actions = (0, _dragDropDefault.default)(this);
                return Object.keys(actions).reduce(function(boundActions, key) {
                    var action = actions[key];
                    boundActions[key] = bindActionCreator(action);
                    return boundActions;
                }, {});
            }
        },
        {
            key: "dispatch",
            value: function dispatch(action) {
                this.store.dispatch(action);
            }
        }
    ]);
    return DragDropManagerImpl;
}();

},{"redux":"ikKU1","./reducers":"2E3vr","./actions/dragDrop":"5knZo","./DragDropMonitorImpl":"2eBDu","./HandlerRegistryImpl":"h9juU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2E3vr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reduce);
var _dragOffset = require("./dragOffset");
var _dragOffsetDefault = parcelHelpers.interopDefault(_dragOffset);
var _dragOperation = require("./dragOperation");
var _dragOperationDefault = parcelHelpers.interopDefault(_dragOperation);
var _refCount = require("./refCount");
var _refCountDefault = parcelHelpers.interopDefault(_refCount);
var _dirtyHandlerIds = require("./dirtyHandlerIds");
var _dirtyHandlerIdsDefault = parcelHelpers.interopDefault(_dirtyHandlerIds);
var _stateId = require("./stateId");
var _stateIdDefault = parcelHelpers.interopDefault(_stateId);
var _jsUtils = require("../utils/js_utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function reduce() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    return {
        dirtyHandlerIds: (0, _dirtyHandlerIdsDefault.default)(state.dirtyHandlerIds, {
            type: action.type,
            payload: _objectSpread({}, action.payload, {
                prevTargetIds: (0, _jsUtils.get)(state, 'dragOperation.targetIds', [])
            })
        }),
        dragOffset: (0, _dragOffsetDefault.default)(state.dragOffset, action),
        refCount: (0, _refCountDefault.default)(state.refCount, action),
        dragOperation: (0, _dragOperationDefault.default)(state.dragOperation, action),
        stateId: (0, _stateIdDefault.default)(state.stateId)
    };
}

},{"./dragOffset":"dkkE6","./dragOperation":"9JIiZ","./refCount":"bNSyS","./dirtyHandlerIds":"awExh","./stateId":"4IpHE","../utils/js_utils":"lDzmU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dkkE6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dragOffset);
var _dragDrop = require("../actions/dragDrop");
var _equality = require("../utils/equality");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function dragOffset() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, _dragDrop.INIT_COORDS:
        case 0, _dragDrop.BEGIN_DRAG:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, _dragDrop.HOVER:
            if ((0, _equality.areCoordsEqual)(state.clientOffset, payload.clientOffset)) return state;
            return _objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, _dragDrop.END_DRAG:
        case 0, _dragDrop.DROP:
            return initialState;
        default:
            return state;
    }
}

},{"../actions/dragDrop":"5knZo","../utils/equality":"kuV68","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5knZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createDragDropActions);
var _beginDrag = require("./beginDrag");
var _beginDragDefault = parcelHelpers.interopDefault(_beginDrag);
var _publishDragSource = require("./publishDragSource");
var _publishDragSourceDefault = parcelHelpers.interopDefault(_publishDragSource);
var _hover = require("./hover");
var _hoverDefault = parcelHelpers.interopDefault(_hover);
var _drop = require("./drop");
var _dropDefault = parcelHelpers.interopDefault(_drop);
var _endDrag = require("./endDrag");
var _endDragDefault = parcelHelpers.interopDefault(_endDrag);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);
function createDragDropActions(manager) {
    return {
        beginDrag: (0, _beginDragDefault.default)(manager),
        publishDragSource: (0, _publishDragSourceDefault.default)(manager),
        hover: (0, _hoverDefault.default)(manager),
        drop: (0, _dropDefault.default)(manager),
        endDrag: (0, _endDragDefault.default)(manager)
    };
}

},{"./beginDrag":"7J9wz","./publishDragSource":"iUrad","./hover":"cKFhX","./drop":"9yZaW","./endDrag":"dyZGW","./types":"1YEbD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7J9wz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createBeginDrag);
var _invariant = require("@react-dnd/invariant");
var _setClientOffset = require("./local/setClientOffset");
var _jsUtils = require("../../utils/js_utils");
var _types = require("./types");
var ResetCoordinatesAction = {
    type: (0, _types.INIT_COORDS),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function createBeginDrag(manager) {
    return function beginDrag() {
        var sourceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            publishSource: true
        };
        var _options$publishSourc = options.publishSource, publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc, clientOffset = options.clientOffset, getSourceClientOffset = options.getSourceClientOffset;
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry(); // Initialize the coordinates using the client offset
        manager.dispatch((0, _setClientOffset.setClientOffset)(clientOffset));
        verifyInvariants(sourceIds, monitor, registry); // Get the draggable source
        var sourceId = getDraggableSource(sourceIds, monitor);
        if (sourceId === null) {
            manager.dispatch(ResetCoordinatesAction);
            return;
        } // Get the source client offset
        var sourceClientOffset = null;
        if (clientOffset) {
            verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        } // Initialize the full coordinates
        manager.dispatch((0, _setClientOffset.setClientOffset)(clientOffset, sourceClientOffset));
        var source = registry.getSource(sourceId);
        var item = source.beginDrag(monitor, sourceId);
        verifyItemIsObject(item);
        registry.pinSource(sourceId);
        var itemType = registry.getSourceType(sourceId);
        return {
            type: (0, _types.BEGIN_DRAG),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function verifyInvariants(sourceIds, monitor, registry) {
    (0, _invariant.invariant)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
    sourceIds.forEach(function(sourceId) {
        (0, _invariant.invariant)(registry.getSource(sourceId), 'Expected sourceIds to be registered.');
    });
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, _invariant.invariant)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
}
function verifyItemIsObject(item) {
    (0, _invariant.invariant)((0, _jsUtils.isObject)(item), 'Item must be an object.');
}
function getDraggableSource(sourceIds, monitor) {
    var sourceId = null;
    for(var i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}

},{"@react-dnd/invariant":"7P4yo","./local/setClientOffset":"i8rVs","../../utils/js_utils":"lDzmU","./types":"1YEbD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7P4yo":[function(require,module,exports,__globalThis) {
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
function invariant(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8rVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setClientOffset", ()=>setClientOffset);
var _types = require("../types");
function setClientOffset(clientOffset, sourceClientOffset) {
    return {
        type: (0, _types.INIT_COORDS),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}

},{"../types":"1YEbD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1YEbD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "INIT_COORDS", ()=>INIT_COORDS);
parcelHelpers.export(exports, "BEGIN_DRAG", ()=>BEGIN_DRAG);
parcelHelpers.export(exports, "PUBLISH_DRAG_SOURCE", ()=>PUBLISH_DRAG_SOURCE);
parcelHelpers.export(exports, "HOVER", ()=>HOVER);
parcelHelpers.export(exports, "DROP", ()=>DROP);
parcelHelpers.export(exports, "END_DRAG", ()=>END_DRAG);
var INIT_COORDS = 'dnd-core/INIT_COORDS';
var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = 'dnd-core/HOVER';
var DROP = 'dnd-core/DROP';
var END_DRAG = 'dnd-core/END_DRAG';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDzmU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ parcelHelpers.export(exports, "get", ()=>get);
/**
 * drop-in replacement for _.without
 */ parcelHelpers.export(exports, "without", ()=>without);
/**
 * drop-in replacement for _.isString
 * @param input
 */ parcelHelpers.export(exports, "isString", ()=>isString);
/**
 * drop-in replacement for _.isString
 * @param input
 */ parcelHelpers.export(exports, "isObject", ()=>isObject);
/**
 * repalcement for _.xor
 * @param itemsA
 * @param itemsB
 */ parcelHelpers.export(exports, "xor", ()=>xor);
/**
 * replacement for _.intersection
 * @param itemsA
 * @param itemsB
 */ parcelHelpers.export(exports, "intersection", ()=>intersection);
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function get(obj, path, defaultValue) {
    return path.split('.').reduce(function(a, c) {
        return a && a[c] ? a[c] : defaultValue || null;
    }, obj);
}
function without(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function isString(input) {
    return typeof input === 'string';
}
function isObject(input) {
    return _typeof(input) === 'object';
}
function xor(itemsA, itemsB) {
    var map = new Map();
    var insertItem = function insertItem(item) {
        return map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    map.forEach(function(count, key) {
        if (count === 1) result.push(key);
    });
    return result;
}
function intersection(itemsA, itemsB) {
    return itemsA.filter(function(t) {
        return itemsB.indexOf(t) > -1;
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iUrad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createPublishDragSource);
var _types = require("./types");
function createPublishDragSource(manager) {
    return function publishDragSource() {
        var monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, _types.PUBLISH_DRAG_SOURCE)
        };
    };
}

},{"./types":"1YEbD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cKFhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createHover);
var _invariant = require("@react-dnd/invariant");
var _matchesType = require("../../utils/matchesType");
var _matchesTypeDefault = parcelHelpers.interopDefault(_matchesType);
var _types = require("./types");
function createHover(manager) {
    return function hover(targetIdsArg) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, clientOffset = _ref.clientOffset;
        verifyTargetIdsIsArray(targetIdsArg);
        var targetIds = targetIdsArg.slice(0);
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        checkInvariants(targetIds, monitor, registry);
        var draggedItemType = monitor.getItemType();
        removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, _types.HOVER),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function verifyTargetIdsIsArray(targetIdsArg) {
    (0, _invariant.invariant)(Array.isArray(targetIdsArg), 'Expected targetIds to be an array.');
}
function checkInvariants(targetIds, monitor, registry) {
    (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call hover while not dragging.');
    (0, _invariant.invariant)(!monitor.didDrop(), 'Cannot call hover after drop.');
    for(var i = 0; i < targetIds.length; i++){
        var targetId = targetIds[i];
        (0, _invariant.invariant)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
        var target = registry.getTarget(targetId);
        (0, _invariant.invariant)(target, 'Expected targetIds to be registered.');
    }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(var i = targetIds.length - 1; i >= 0; i--){
        var targetId = targetIds[i];
        var targetType = registry.getTargetType(targetId);
        if (!(0, _matchesTypeDefault.default)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        var target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}

},{"@react-dnd/invariant":"7P4yo","../../utils/matchesType":"3HsFg","./types":"1YEbD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3HsFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>matchesType);
function matchesType(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some(function(t) {
        return t === draggedItemType;
    }) : targetType === draggedItemType;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9yZaW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createDrop);
var _invariant = require("@react-dnd/invariant");
var _types = require("./types");
var _jsUtils = require("../../utils/js_utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function createDrop(manager) {
    return function drop() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        verifyInvariants(monitor);
        var targetIds = getDroppableTargets(monitor); // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach(function(targetId, index) {
            var dropResult = determineDropResult(targetId, index, registry, monitor);
            var action = {
                type: (0, _types.DROP),
                payload: {
                    dropResult: _objectSpread({}, options, {}, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function verifyInvariants(monitor) {
    (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call drop while not dragging.');
    (0, _invariant.invariant)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
}
function determineDropResult(targetId, index, registry, monitor) {
    var target = registry.getTarget(targetId);
    var dropResult = target ? target.drop(monitor, targetId) : undefined;
    verifyDropResultType(dropResult);
    if (typeof dropResult === 'undefined') dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function verifyDropResultType(dropResult) {
    (0, _invariant.invariant)(typeof dropResult === 'undefined' || (0, _jsUtils.isObject)(dropResult), 'Drop result must either be an object or undefined.');
}
function getDroppableTargets(monitor) {
    var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}

},{"@react-dnd/invariant":"7P4yo","./types":"1YEbD","../../utils/js_utils":"lDzmU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dyZGW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createEndDrag);
var _invariant = require("@react-dnd/invariant");
var _types = require("./types");
function createEndDrag(manager) {
    return function endDrag() {
        var monitor = manager.getMonitor();
        var registry = manager.getRegistry();
        verifyIsDragging(monitor);
        var sourceId = monitor.getSourceId();
        var source = registry.getSource(sourceId, true);
        source.endDrag(monitor, sourceId);
        registry.unpinSource();
        return {
            type: (0, _types.END_DRAG)
        };
    };
}
function verifyIsDragging(monitor) {
    (0, _invariant.invariant)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');
}

},{"@react-dnd/invariant":"7P4yo","./types":"1YEbD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kuV68":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "strictEquality", ()=>strictEquality);
/**
 * Determine if two cartesian coordinate offsets are equal
 * @param offsetA
 * @param offsetB
 */ parcelHelpers.export(exports, "areCoordsEqual", ()=>areCoordsEqual);
/**
 * Determines if two arrays of items are equal
 * @param a The first array of items
 * @param b The second array of items
 */ parcelHelpers.export(exports, "areArraysEqual", ()=>areArraysEqual);
var strictEquality = function strictEquality(a, b) {
    return a === b;
};
function areCoordsEqual(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function areArraysEqual(a, b) {
    var isEqual = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : strictEquality;
    if (a.length !== b.length) return false;
    for(var i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JIiZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dragOperation);
var _dragDrop = require("../actions/dragDrop");
var _registry = require("../actions/registry");
var _jsUtils = require("../utils/js_utils");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function dragOperation() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var payload = action.payload;
    switch(action.type){
        case 0, _dragDrop.BEGIN_DRAG:
            return _objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, _dragDrop.PUBLISH_DRAG_SOURCE:
            return _objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, _dragDrop.HOVER:
            return _objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, _registry.REMOVE_TARGET:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return _objectSpread({}, state, {
                targetIds: (0, _jsUtils.without)(state.targetIds, payload.targetId)
            });
        case 0, _dragDrop.DROP:
            return _objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, _dragDrop.END_DRAG:
            return _objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}

},{"../actions/dragDrop":"5knZo","../actions/registry":"jdrcN","../utils/js_utils":"lDzmU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jdrcN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADD_SOURCE", ()=>ADD_SOURCE);
parcelHelpers.export(exports, "ADD_TARGET", ()=>ADD_TARGET);
parcelHelpers.export(exports, "REMOVE_SOURCE", ()=>REMOVE_SOURCE);
parcelHelpers.export(exports, "REMOVE_TARGET", ()=>REMOVE_TARGET);
parcelHelpers.export(exports, "addSource", ()=>addSource);
parcelHelpers.export(exports, "addTarget", ()=>addTarget);
parcelHelpers.export(exports, "removeSource", ()=>removeSource);
parcelHelpers.export(exports, "removeTarget", ()=>removeTarget);
var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
function addSource(sourceId) {
    return {
        type: ADD_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function addTarget(targetId) {
    return {
        type: ADD_TARGET,
        payload: {
            targetId: targetId
        }
    };
}
function removeSource(sourceId) {
    return {
        type: REMOVE_SOURCE,
        payload: {
            sourceId: sourceId
        }
    };
}
function removeTarget(targetId) {
    return {
        type: REMOVE_TARGET,
        payload: {
            targetId: targetId
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNSyS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>refCount);
var _registry = require("../actions/registry");
function refCount() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, _registry.ADD_SOURCE:
        case 0, _registry.ADD_TARGET:
            return state + 1;
        case 0, _registry.REMOVE_SOURCE:
        case 0, _registry.REMOVE_TARGET:
            return state - 1;
        default:
            return state;
    }
}

},{"../actions/registry":"jdrcN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"awExh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dirtyHandlerIds);
var _dragDrop = require("../actions/dragDrop");
var _registry = require("../actions/registry");
var _equality = require("../utils/equality");
var _dirtiness = require("../utils/dirtiness");
var _jsUtils = require("../utils/js_utils");
function dirtyHandlerIds() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _dirtiness.NONE);
    var action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, _dragDrop.HOVER:
            break;
        case 0, _registry.ADD_SOURCE:
        case 0, _registry.ADD_TARGET:
        case 0, _registry.REMOVE_TARGET:
        case 0, _registry.REMOVE_SOURCE:
            return 0, _dirtiness.NONE;
        case 0, _dragDrop.BEGIN_DRAG:
        case 0, _dragDrop.PUBLISH_DRAG_SOURCE:
        case 0, _dragDrop.END_DRAG:
        case 0, _dragDrop.DROP:
        default:
            return 0, _dirtiness.ALL;
    }
    var _action$payload = action.payload, _action$payload$targe = _action$payload.targetIds, targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe, _action$payload$prevT = _action$payload.prevTargetIds, prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
    var result = (0, _jsUtils.xor)(targetIds, prevTargetIds);
    var didChange = result.length > 0 || !(0, _equality.areArraysEqual)(targetIds, prevTargetIds);
    if (!didChange) return 0, _dirtiness.NONE;
     // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    var innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}

},{"../actions/dragDrop":"5knZo","../actions/registry":"jdrcN","../utils/equality":"kuV68","../utils/dirtiness":"lvwnW","../utils/js_utils":"lDzmU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvwnW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NONE", ()=>NONE);
parcelHelpers.export(exports, "ALL", ()=>ALL);
/**
 * Determines if the given handler IDs are dirty or not.
 *
 * @param dirtyIds The set of dirty handler ids
 * @param handlerIds The set of handler ids to check
 */ parcelHelpers.export(exports, "areDirty", ()=>areDirty);
var _jsUtils = require("./js_utils");
var NONE = [];
var ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
function areDirty(dirtyIds, handlerIds) {
    if (dirtyIds === NONE) return false;
    if (dirtyIds === ALL || typeof handlerIds === 'undefined') return true;
    var commonIds = (0, _jsUtils.intersection)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}

},{"./js_utils":"lDzmU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4IpHE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>stateId);
function stateId() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return state + 1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2eBDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragDropMonitorImpl);
var _invariant = require("@react-dnd/invariant");
var _matchesType = require("./utils/matchesType");
var _matchesTypeDefault = parcelHelpers.interopDefault(_matchesType);
var _coords = require("./utils/coords");
var _dirtiness = require("./utils/dirtiness");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var DragDropMonitorImpl = /*#__PURE__*/ function() {
    function DragDropMonitorImpl(store, registry) {
        _classCallCheck(this, DragDropMonitorImpl);
        this.store = store;
        this.registry = registry;
    }
    _createClass(DragDropMonitorImpl, [
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    handlerIds: undefined
                };
                var handlerIds = options.handlerIds;
                (0, _invariant.invariant)(typeof listener === 'function', 'listener must be a function.');
                (0, _invariant.invariant)(typeof handlerIds === 'undefined' || Array.isArray(handlerIds), 'handlerIds, when specified, must be an array of strings.');
                var prevStateId = this.store.getState().stateId;
                var handleChange = function handleChange() {
                    var state = _this.store.getState();
                    var currentStateId = state.stateId;
                    try {
                        var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtiness.areDirty)(state.dirtyHandlerIds, handlerIds);
                        if (!canSkipListener) listener();
                    } finally{
                        prevStateId = currentStateId;
                    }
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "subscribeToOffsetChange",
            value: function subscribeToOffsetChange(listener) {
                var _this2 = this;
                (0, _invariant.invariant)(typeof listener === 'function', 'listener must be a function.');
                var previousState = this.store.getState().dragOffset;
                var handleChange = function handleChange() {
                    var nextState = _this2.store.getState().dragOffset;
                    if (nextState === previousState) return;
                    previousState = nextState;
                    listener();
                };
                return this.store.subscribe(handleChange);
            }
        },
        {
            key: "canDragSource",
            value: function canDragSource(sourceId) {
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId);
                (0, _invariant.invariant)(source, 'Expected to find a valid source.');
                if (this.isDragging()) return false;
                return source.canDrag(this, sourceId);
            }
        },
        {
            key: "canDropOnTarget",
            value: function canDropOnTarget(targetId) {
                // undefined on initial render
                if (!targetId) return false;
                var target = this.registry.getTarget(targetId);
                (0, _invariant.invariant)(target, 'Expected to find a valid target.');
                if (!this.isDragging() || this.didDrop()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                return (0, _matchesTypeDefault.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
            }
        },
        {
            key: "isDragging",
            value: function isDragging() {
                return Boolean(this.getItemType());
            }
        },
        {
            key: "isDraggingSource",
            value: function isDraggingSource(sourceId) {
                // undefined on initial render
                if (!sourceId) return false;
                var source = this.registry.getSource(sourceId, true);
                (0, _invariant.invariant)(source, 'Expected to find a valid source.');
                if (!this.isDragging() || !this.isSourcePublic()) return false;
                var sourceType = this.registry.getSourceType(sourceId);
                var draggedItemType = this.getItemType();
                if (sourceType !== draggedItemType) return false;
                return source.isDragging(this, sourceId);
            }
        },
        {
            key: "isOverTarget",
            value: function isOverTarget(targetId) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    shallow: false
                };
                // undefined on initial render
                if (!targetId) return false;
                var shallow = options.shallow;
                if (!this.isDragging()) return false;
                var targetType = this.registry.getTargetType(targetId);
                var draggedItemType = this.getItemType();
                if (draggedItemType && !(0, _matchesTypeDefault.default)(targetType, draggedItemType)) return false;
                var targetIds = this.getTargetIds();
                if (!targetIds.length) return false;
                var index = targetIds.indexOf(targetId);
                if (shallow) return index === targetIds.length - 1;
                else return index > -1;
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.store.getState().dragOperation.itemType;
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.store.getState().dragOperation.item;
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId() {
                return this.store.getState().dragOperation.sourceId;
            }
        },
        {
            key: "getTargetIds",
            value: function getTargetIds() {
                return this.store.getState().dragOperation.targetIds;
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.store.getState().dragOperation.dropResult;
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.store.getState().dragOperation.didDrop;
            }
        },
        {
            key: "isSourcePublic",
            value: function isSourcePublic() {
                return this.store.getState().dragOperation.isSourcePublic;
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.store.getState().dragOffset.initialClientOffset;
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.store.getState().dragOffset.initialSourceClientOffset;
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.store.getState().dragOffset.clientOffset;
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return (0, _coords.getSourceClientOffset)(this.store.getState().dragOffset);
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return (0, _coords.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
            }
        }
    ]);
    return DragDropMonitorImpl;
}();

},{"@react-dnd/invariant":"7P4yo","./utils/matchesType":"3HsFg","./utils/coords":"435nc","./utils/dirtiness":"lvwnW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"435nc":[function(require,module,exports,__globalThis) {
/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>add);
/**
 * Coordinate subtraction
 * @param a The first coordinate
 * @param b The second coordinate
 */ parcelHelpers.export(exports, "subtract", ()=>subtract);
/**
 * Returns the cartesian distance of the drag source component's position, based on its position
 * at the time when the current drag operation has started, and the movement difference.
 *
 * Returns null if no item is being dragged.
 *
 * @param state The offset state to compute from
 */ parcelHelpers.export(exports, "getSourceClientOffset", ()=>getSourceClientOffset);
/**
 * Determines the x,y offset between the client offset and the initial client offset
 *
 * @param state The offset state to compute from
 */ parcelHelpers.export(exports, "getDifferenceFromInitialOffset", ()=>getDifferenceFromInitialOffset);
function add(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function subtract(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getSourceClientOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function getDifferenceFromInitialOffset(state) {
    var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
    if (!clientOffset || !initialClientOffset) return null;
    return subtract(clientOffset, initialClientOffset);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h9juU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HandlerRegistryImpl);
var _invariant = require("@react-dnd/invariant");
var _registry = require("./actions/registry");
var _getNextUniqueId = require("./utils/getNextUniqueId");
var _getNextUniqueIdDefault = parcelHelpers.interopDefault(_getNextUniqueId);
var _interfaces = require("./interfaces");
var _contracts = require("./contracts");
var _asap = require("@react-dnd/asap");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function getNextHandlerId(role) {
    var id = (0, _getNextUniqueIdDefault.default)().toString();
    switch(role){
        case (0, _interfaces.HandlerRole).SOURCE:
            return "S".concat(id);
        case (0, _interfaces.HandlerRole).TARGET:
            return "T".concat(id);
        default:
            throw new Error("Unknown Handler Role: ".concat(role));
    }
}
function parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case 'S':
            return (0, _interfaces.HandlerRole).SOURCE;
        case 'T':
            return (0, _interfaces.HandlerRole).TARGET;
        default:
            (0, _invariant.invariant)(false, "Cannot parse handler ID: ".concat(handlerId));
    }
}
function mapContainsValue(map, searchValue) {
    var entries = map.entries();
    var isDone = false;
    do {
        var _entries$next = entries.next(), done = _entries$next.done, _entries$next$value = _slicedToArray(_entries$next.value, 2), value = _entries$next$value[1];
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
var HandlerRegistryImpl = /*#__PURE__*/ function() {
    function HandlerRegistryImpl(store) {
        _classCallCheck(this, HandlerRegistryImpl);
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
    _createClass(HandlerRegistryImpl, [
        {
            key: "addSource",
            value: function addSource(type, source) {
                (0, _contracts.validateType)(type);
                (0, _contracts.validateSourceContract)(source);
                var sourceId = this.addHandler((0, _interfaces.HandlerRole).SOURCE, type, source);
                this.store.dispatch((0, _registry.addSource)(sourceId));
                return sourceId;
            }
        },
        {
            key: "addTarget",
            value: function addTarget(type, target) {
                (0, _contracts.validateType)(type, true);
                (0, _contracts.validateTargetContract)(target);
                var targetId = this.addHandler((0, _interfaces.HandlerRole).TARGET, type, target);
                this.store.dispatch((0, _registry.addTarget)(targetId));
                return targetId;
            }
        },
        {
            key: "containsHandler",
            value: function containsHandler(handler) {
                return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
            }
        },
        {
            key: "getSource",
            value: function getSource(sourceId) {
                var includePinned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                (0, _invariant.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                var isPinned = includePinned && sourceId === this.pinnedSourceId;
                var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
                return source;
            }
        },
        {
            key: "getTarget",
            value: function getTarget(targetId) {
                (0, _invariant.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.dropTargets.get(targetId);
            }
        },
        {
            key: "getSourceType",
            value: function getSourceType(sourceId) {
                (0, _invariant.invariant)(this.isSourceId(sourceId), 'Expected a valid source ID.');
                return this.types.get(sourceId);
            }
        },
        {
            key: "getTargetType",
            value: function getTargetType(targetId) {
                (0, _invariant.invariant)(this.isTargetId(targetId), 'Expected a valid target ID.');
                return this.types.get(targetId);
            }
        },
        {
            key: "isSourceId",
            value: function isSourceId(handlerId) {
                var role = parseRoleFromHandlerId(handlerId);
                return role === (0, _interfaces.HandlerRole).SOURCE;
            }
        },
        {
            key: "isTargetId",
            value: function isTargetId(handlerId) {
                var role = parseRoleFromHandlerId(handlerId);
                return role === (0, _interfaces.HandlerRole).TARGET;
            }
        },
        {
            key: "removeSource",
            value: function removeSource(sourceId) {
                var _this = this;
                (0, _invariant.invariant)(this.getSource(sourceId), 'Expected an existing source.');
                this.store.dispatch((0, _registry.removeSource)(sourceId));
                (0, _asap.asap)(function() {
                    _this.dragSources.delete(sourceId);
                    _this.types.delete(sourceId);
                });
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(targetId) {
                (0, _invariant.invariant)(this.getTarget(targetId), 'Expected an existing target.');
                this.store.dispatch((0, _registry.removeTarget)(targetId));
                this.dropTargets.delete(targetId);
                this.types.delete(targetId);
            }
        },
        {
            key: "pinSource",
            value: function pinSource(sourceId) {
                var source = this.getSource(sourceId);
                (0, _invariant.invariant)(source, 'Expected an existing source.');
                this.pinnedSourceId = sourceId;
                this.pinnedSource = source;
            }
        },
        {
            key: "unpinSource",
            value: function unpinSource() {
                (0, _invariant.invariant)(this.pinnedSource, 'No source is pinned at the time.');
                this.pinnedSourceId = null;
                this.pinnedSource = null;
            }
        },
        {
            key: "addHandler",
            value: function addHandler(role, type, handler) {
                var id = getNextHandlerId(role);
                this.types.set(id, type);
                if (role === (0, _interfaces.HandlerRole).SOURCE) this.dragSources.set(id, handler);
                else if (role === (0, _interfaces.HandlerRole).TARGET) this.dropTargets.set(id, handler);
                return id;
            }
        }
    ]);
    return HandlerRegistryImpl;
}();

},{"@react-dnd/invariant":"7P4yo","./actions/registry":"jdrcN","./utils/getNextUniqueId":"jwmo5","./interfaces":"aB8bN","./contracts":"96Q89","@react-dnd/asap":"lTYyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwmo5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNextUniqueId);
var nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96Q89":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateSourceContract", ()=>validateSourceContract);
parcelHelpers.export(exports, "validateTargetContract", ()=>validateTargetContract);
parcelHelpers.export(exports, "validateType", ()=>validateType);
var _invariant = require("@react-dnd/invariant");
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function validateSourceContract(source) {
    (0, _invariant.invariant)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
    (0, _invariant.invariant)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
    (0, _invariant.invariant)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}
function validateTargetContract(target) {
    (0, _invariant.invariant)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
    (0, _invariant.invariant)(typeof target.hover === 'function', 'Expected hover to be a function.');
    (0, _invariant.invariant)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}
function validateType(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach(function(t) {
            return validateType(t, false);
        });
        return;
    }
    (0, _invariant.invariant)(typeof type === 'string' || _typeof(type) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

},{"@react-dnd/invariant":"7P4yo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTYyK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
var _asapJs = _interopRequireWildcard(require("9a2ce28a2db09746"));
Object.keys(_asapJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _asapJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _asapJs[key];
        }
    });
});
var _typesJs = _interopRequireWildcard(require("48de27289c7ae02d"));
Object.keys(_typesJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _typesJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typesJs[key];
        }
    });
});
var _asapQueueJs = _interopRequireWildcard(require("789c3899ba47cdcb"));
Object.keys(_asapQueueJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _asapQueueJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _asapQueueJs[key];
        }
    });
});
var _taskFactoryJs = _interopRequireWildcard(require("e9d5fbd699c1cbaa"));
Object.keys(_taskFactoryJs).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _taskFactoryJs[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _taskFactoryJs[key];
        }
    });
});
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}

},{"9a2ce28a2db09746":"6ujh2","48de27289c7ae02d":"gdLWl","789c3899ba47cdcb":"iJO6w","e9d5fbd699c1cbaa":"bFltf"}],"6ujh2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.asap = asap;
var _asapQueueJs = require("4d24b0d50bf1a869");
var _taskFactoryJs = require("c7be1a2172726b19");
const asapQueue = new _asapQueueJs.AsapQueue();
const taskFactory = new _taskFactoryJs.TaskFactory(asapQueue.registerPendingError);
function asap(task) {
    asapQueue.enqueueTask(taskFactory.create(task));
}

},{"4d24b0d50bf1a869":"iJO6w","c7be1a2172726b19":"bFltf"}],"iJO6w":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _makeRequestCallJs = require("8e769a394d80aa8c");
class AsapQueue {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = _makeRequestCallJs.makeRequestCall(this.flush);
        this.requestErrorThrow = _makeRequestCallJs.makeRequestCallFromTimer(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html
// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.
// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }
// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.
// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }
// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.
// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.
// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// // its existence.
// rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
exports.AsapQueue = AsapQueue;

},{"8e769a394d80aa8c":"65vKk"}],"65vKk":[function(require,module,exports,__globalThis) {
var global = arguments[3];
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeRequestCallFromTimer = makeRequestCallFromTimer;
exports.makeRequestCallFromMutationObserver = makeRequestCallFromMutationObserver;
exports.makeRequestCall = void 0;
// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const scope = typeof global !== 'undefined' ? global : self;
const BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function makeRequestCallFromMutationObserver(callback) {
    let toggle = 1;
    const observer = new BrowserMutationObserver(callback);
    const node = document.createTextNode('');
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const makeRequestCall = typeof BrowserMutationObserver === 'function' ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
makeRequestCallFromMutationObserver : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
makeRequestCallFromTimer;
exports.makeRequestCall = makeRequestCall;

},{}],"bFltf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _rawTaskJs = require("8d5520d5db7dc4cd");
class TaskFactory {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new _rawTaskJs.RawTask(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}
exports.TaskFactory = TaskFactory;

},{"8d5520d5db7dc4cd":"977Pf"}],"977Pf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
class RawTask {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}
exports.RawTask = RawTask;

},{}],"gdLWl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"4zY7F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DndProvider", ()=>DndProvider);
var _react = require("react");
var _dndContext = require("./DndContext");
var global = arguments[3];
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var refCount = 0;
var DndProvider = (0, _react.memo)(function(_ref) {
    var children = _ref.children, props = _objectWithoutProperties(_ref, [
        "children"
    ]);
    var _getDndContextValue = getDndContextValue(props), _getDndContextValue2 = _slicedToArray(_getDndContextValue, 2), manager = _getDndContextValue2[0], isGlobalInstance = _getDndContextValue2[1]; // memoized from props
    /**
   * If the global context was used to store the DND context
   * then where theres no more references to it we should
   * clean it up to avoid memory leaks
   */ _react.useEffect(function() {
        if (isGlobalInstance) refCount++;
        return function() {
            if (isGlobalInstance) {
                refCount--;
                if (refCount === 0) {
                    var context = getGlobalContext();
                    context[instanceSymbol] = null;
                }
            }
        };
    }, []);
    return _react.createElement((0, _dndContext.DndContext).Provider, {
        value: manager
    }, children);
});
DndProvider.displayName = 'DndProvider';
function getDndContextValue(props) {
    if ('manager' in props) {
        var _manager = {
            dragDropManager: props.manager
        };
        return [
            _manager,
            false
        ];
    }
    var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    var isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
var instanceSymbol = Symbol.for('__REACT_DND_CONTEXT_INSTANCE__');
function createSingletonDndContext(backend) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlobalContext();
    var options = arguments.length > 2 ? arguments[2] : undefined;
    var debugMode = arguments.length > 3 ? arguments[3] : undefined;
    var ctx = context;
    if (!ctx[instanceSymbol]) ctx[instanceSymbol] = (0, _dndContext.createDndContext)(backend, context, options, debugMode);
    return ctx[instanceSymbol];
}
function getGlobalContext() {
    return typeof global !== 'undefined' ? global : window;
}

},{"react":"9njXz","./DndContext":"iJy8i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9oSuP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useDrag = require("./useDrag");
parcelHelpers.exportAll(_useDrag, exports);
var _useDrop = require("./useDrop");
parcelHelpers.exportAll(_useDrop, exports);
var _useDragLayer = require("./useDragLayer");
parcelHelpers.exportAll(_useDragLayer, exports);

},{"./useDrag":"eh8KJ","./useDrop":"8BKL0","./useDragLayer":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eh8KJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * useDragSource hook
 * @param sourceSpec The drag source specification *
 */ parcelHelpers.export(exports, "useDrag", ()=>useDrag);
var _react = require("react");
var _invariant = require("@react-dnd/invariant");
var _useMonitorOutput = require("./internal/useMonitorOutput");
var _useIsomorphicLayoutEffect = require("./internal/useIsomorphicLayoutEffect");
var _drag = require("./internal/drag");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useDrag(spec) {
    var specRef = (0, _react.useRef)(spec);
    specRef.current = spec; // TODO: wire options into createSourceConnector
    (0, _invariant.invariant)(spec.item != null, 'item must be defined');
    (0, _invariant.invariant)(spec.item.type != null, 'item type must be defined');
    var _useDragSourceMonitor = (0, _drag.useDragSourceMonitor)(), _useDragSourceMonitor2 = _slicedToArray(_useDragSourceMonitor, 2), monitor = _useDragSourceMonitor2[0], connector = _useDragSourceMonitor2[1];
    (0, _drag.useDragHandler)(specRef, monitor, connector);
    var result = (0, _useMonitorOutput.useMonitorOutput)(monitor, specRef.current.collect || function() {
        return {};
    }, function() {
        return connector.reconnect();
    });
    var connectDragSource = (0, _react.useMemo)(function() {
        return connector.hooks.dragSource();
    }, [
        connector
    ]);
    var connectDragPreview = (0, _react.useMemo)(function() {
        return connector.hooks.dragPreview();
    }, [
        connector
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        connector.dragSourceOptions = specRef.current.options || null;
        connector.reconnect();
    }, [
        connector
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        connector.dragPreviewOptions = specRef.current.previewOptions || null;
        connector.reconnect();
    }, [
        connector
    ]);
    return [
        result,
        connectDragSource,
        connectDragPreview
    ];
}

},{"react":"9njXz","@react-dnd/invariant":"7P4yo","./internal/useMonitorOutput":"iaYWC","./internal/useIsomorphicLayoutEffect":"dSOud","./internal/drag":"lqNOA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iaYWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMonitorOutput", ()=>useMonitorOutput);
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
var _useCollector = require("./useCollector");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useMonitorOutput(monitor, collect, onCollect) {
    var _useCollector1 = (0, _useCollector.useCollector)(monitor, collect, onCollect), _useCollector2 = _slicedToArray(_useCollector1, 2), collected = _useCollector2[0], updateCollected = _useCollector2[1];
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function subscribeToMonitorStateChange() {
        var handlerId = monitor.getHandlerId();
        if (handlerId == null) return undefined;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}

},{"./useIsomorphicLayoutEffect":"dSOud","./useCollector":"lCtyA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dSOud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react"); // suppress the useLayoutEffect warning on server side.
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCtyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * @param monitor The monitor to collect state from
 * @param collect The collecting function
 * @param onUpdate A method to invoke when updates occur
 */ parcelHelpers.export(exports, "useCollector", ()=>useCollector);
var _shallowequal = require("@react-dnd/shallowequal");
var _react = require("react");
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useCollector(monitor, collect, onUpdate) {
    var _useState = (0, _react.useState)(function() {
        return collect(monitor);
    }), _useState2 = _slicedToArray(_useState, 2), collected = _useState2[0], setCollected = _useState2[1];
    var updateCollected = (0, _react.useCallback)(function() {
        var nextValue = collect(monitor);
        if (!(0, _shallowequal.shallowEqual)(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]); // update the collected properties after the first render
    // and the components are attached to dnd-core
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(updateCollected, []);
    return [
        collected,
        updateCollected
    ];
}

},{"@react-dnd/shallowequal":"6BP24","react":"9njXz","./useIsomorphicLayoutEffect":"dSOud","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BP24":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
function shallowEqual(objA, objB, compare, compareContext) {
    var compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== 'object' || !objA || typeof objB !== 'object' || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB); // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lqNOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDragSourceMonitor", ()=>useDragSourceMonitor);
parcelHelpers.export(exports, "useDragHandler", ()=>useDragHandler);
var _react = require("react");
var _invariant = require("@react-dnd/invariant");
var _registration = require("../../common/registration");
var _useDragDropManager = require("./useDragDropManager");
var _dragSourceMonitorImpl = require("../../common/DragSourceMonitorImpl");
var _sourceConnector = require("../../common/SourceConnector");
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function useDragSourceMonitor() {
    var manager = (0, _useDragDropManager.useDragDropManager)();
    var monitor = (0, _react.useMemo)(function() {
        return new (0, _dragSourceMonitorImpl.DragSourceMonitorImpl)(manager);
    }, [
        manager
    ]);
    var connector = (0, _react.useMemo)(function() {
        return new (0, _sourceConnector.SourceConnector)(manager.getBackend());
    }, [
        manager
    ]);
    return [
        monitor,
        connector
    ];
}
function useDragHandler(spec, monitor, connector) {
    var manager = (0, _useDragDropManager.useDragDropManager)();
    var handler = (0, _react.useMemo)(function() {
        return {
            beginDrag: function beginDrag() {
                var _spec$current = spec.current, begin = _spec$current.begin, item = _spec$current.item;
                if (begin) {
                    var beginResult = begin(monitor);
                    (0, _invariant.invariant)(beginResult == null || _typeof(beginResult) === 'object', 'dragSpec.begin() must either return an object, undefined, or null');
                    return beginResult || item || {};
                }
                return item || {};
            },
            canDrag: function canDrag() {
                if (typeof spec.current.canDrag === 'boolean') return spec.current.canDrag;
                else if (typeof spec.current.canDrag === 'function') return spec.current.canDrag(monitor);
                else return true;
            },
            isDragging: function isDragging(globalMonitor, target) {
                var isDragging = spec.current.isDragging;
                return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
            },
            endDrag: function endDrag() {
                var end = spec.current.end;
                if (end) end(monitor.getItem(), monitor);
                connector.reconnect();
            }
        };
    }, []);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function registerHandler() {
        var _registerSource = (0, _registration.registerSource)(spec.current.item.type, handler, manager), _registerSource2 = _slicedToArray(_registerSource, 2), handlerId = _registerSource2[0], unregister = _registerSource2[1];
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, []);
}

},{"react":"9njXz","@react-dnd/invariant":"7P4yo","../../common/registration":"JHndx","./useDragDropManager":"dNXln","../../common/DragSourceMonitorImpl":"aVUCi","../../common/SourceConnector":"1mO52","./useIsomorphicLayoutEffect":"dSOud","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"JHndx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerTarget", ()=>registerTarget);
parcelHelpers.export(exports, "registerSource", ()=>registerSource);
function registerTarget(type, target, manager) {
    var registry = manager.getRegistry();
    var targetId = registry.addTarget(type, target);
    return [
        targetId,
        function() {
            return registry.removeTarget(targetId);
        }
    ];
}
function registerSource(type, source, manager) {
    var registry = manager.getRegistry();
    var sourceId = registry.addSource(type, source);
    return [
        sourceId,
        function() {
            return registry.removeSource(sourceId);
        }
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dNXln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook to retrieve the DragDropManager from Context
 */ parcelHelpers.export(exports, "useDragDropManager", ()=>useDragDropManager);
var _react = require("react");
var _invariant = require("@react-dnd/invariant");
var _dndContext = require("../../common/DndContext");
function useDragDropManager() {
    var _useContext = (0, _react.useContext)((0, _dndContext.DndContext)), dragDropManager = _useContext.dragDropManager;
    (0, _invariant.invariant)(dragDropManager != null, 'Expected drag drop context');
    return dragDropManager;
}

},{"react":"9njXz","@react-dnd/invariant":"7P4yo","../../common/DndContext":"iJy8i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aVUCi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragSourceMonitorImpl", ()=>DragSourceMonitorImpl);
var _invariant = require("@react-dnd/invariant");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isCallingCanDrag = false;
var isCallingIsDragging = false;
var DragSourceMonitorImpl = /*#__PURE__*/ function() {
    function DragSourceMonitorImpl(manager) {
        _classCallCheck(this, DragSourceMonitorImpl);
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
    _createClass(DragSourceMonitorImpl, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(sourceId) {
                this.sourceId = sourceId;
            }
        },
        {
            key: "getHandlerId",
            value: function getHandlerId() {
                return this.sourceId;
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                (0, _invariant.invariant)(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
                try {
                    isCallingCanDrag = true;
                    return this.internalMonitor.canDragSource(this.sourceId);
                } finally{
                    isCallingCanDrag = false;
                }
            }
        },
        {
            key: "isDragging",
            value: function isDragging() {
                if (!this.sourceId) return false;
                (0, _invariant.invariant)(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
                try {
                    isCallingIsDragging = true;
                    return this.internalMonitor.isDraggingSource(this.sourceId);
                } finally{
                    isCallingIsDragging = false;
                }
            }
        },
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener, options) {
                return this.internalMonitor.subscribeToStateChange(listener, options);
            }
        },
        {
            key: "isDraggingSource",
            value: function isDraggingSource(sourceId) {
                return this.internalMonitor.isDraggingSource(sourceId);
            }
        },
        {
            key: "isOverTarget",
            value: function isOverTarget(targetId, options) {
                return this.internalMonitor.isOverTarget(targetId, options);
            }
        },
        {
            key: "getTargetIds",
            value: function getTargetIds() {
                return this.internalMonitor.getTargetIds();
            }
        },
        {
            key: "isSourcePublic",
            value: function isSourcePublic() {
                return this.internalMonitor.isSourcePublic();
            }
        },
        {
            key: "getSourceId",
            value: function getSourceId() {
                return this.internalMonitor.getSourceId();
            }
        },
        {
            key: "subscribeToOffsetChange",
            value: function subscribeToOffsetChange(listener) {
                return this.internalMonitor.subscribeToOffsetChange(listener);
            }
        },
        {
            key: "canDragSource",
            value: function canDragSource(sourceId) {
                return this.internalMonitor.canDragSource(sourceId);
            }
        },
        {
            key: "canDropOnTarget",
            value: function canDropOnTarget(targetId) {
                return this.internalMonitor.canDropOnTarget(targetId);
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return DragSourceMonitorImpl;
}();

},{"@react-dnd/invariant":"7P4yo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mO52":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SourceConnector", ()=>SourceConnector);
var _wrapConnectorHooks = require("./wrapConnectorHooks");
var _wrapConnectorHooksDefault = parcelHelpers.interopDefault(_wrapConnectorHooks);
var _isRef = require("../utils/isRef");
var _shallowequal = require("@react-dnd/shallowequal");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var SourceConnector = /*#__PURE__*/ function() {
    function SourceConnector(backend) {
        var _this = this;
        _classCallCheck(this, SourceConnector);
        this.hooks = (0, _wrapConnectorHooksDefault.default)({
            dragSource: function dragSource(node, options) {
                _this.clearDragSource();
                _this.dragSourceOptions = options || null;
                if ((0, _isRef.isRef)(node)) _this.dragSourceRef = node;
                else _this.dragSourceNode = node;
                _this.reconnectDragSource();
            },
            dragPreview: function dragPreview(node, options) {
                _this.clearDragPreview();
                _this.dragPreviewOptions = options || null;
                if ((0, _isRef.isRef)(node)) _this.dragPreviewRef = node;
                else _this.dragPreviewNode = node;
                _this.reconnectDragPreview();
            }
        });
        this.handlerId = null; // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null; // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
    _createClass(SourceConnector, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(newHandlerId) {
                if (this.handlerId === newHandlerId) return;
                this.handlerId = newHandlerId;
                this.reconnect();
            }
        },
        {
            key: "reconnect",
            value: function reconnect() {
                this.reconnectDragSource();
                this.reconnectDragPreview();
            }
        },
        {
            key: "reconnectDragSource",
            value: function reconnectDragSource() {
                var dragSource = this.dragSource; // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
                if (didChange) this.disconnectDragSource();
                if (!this.handlerId) return;
                if (!dragSource) {
                    this.lastConnectedDragSource = dragSource;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDragSource = dragSource;
                    this.lastConnectedDragSourceOptions = this.dragSourceOptions;
                    this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
                }
            }
        },
        {
            key: "reconnectDragPreview",
            value: function reconnectDragPreview() {
                var dragPreview = this.dragPreview; // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
                if (!this.handlerId) this.disconnectDragPreview();
                else if (this.dragPreview && didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDragPreview = dragPreview;
                    this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
                    this.disconnectDragPreview();
                    this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
                }
            }
        },
        {
            key: "didHandlerIdChange",
            value: function didHandlerIdChange() {
                return this.lastConnectedHandlerId !== this.handlerId;
            }
        },
        {
            key: "didConnectedDragSourceChange",
            value: function didConnectedDragSourceChange() {
                return this.lastConnectedDragSource !== this.dragSource;
            }
        },
        {
            key: "didConnectedDragPreviewChange",
            value: function didConnectedDragPreviewChange() {
                return this.lastConnectedDragPreview !== this.dragPreview;
            }
        },
        {
            key: "didDragSourceOptionsChange",
            value: function didDragSourceOptionsChange() {
                return !(0, _shallowequal.shallowEqual)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
            }
        },
        {
            key: "didDragPreviewOptionsChange",
            value: function didDragPreviewOptionsChange() {
                return !(0, _shallowequal.shallowEqual)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
            }
        },
        {
            key: "disconnectDragSource",
            value: function disconnectDragSource() {
                if (this.dragSourceUnsubscribe) {
                    this.dragSourceUnsubscribe();
                    this.dragSourceUnsubscribe = undefined;
                }
            }
        },
        {
            key: "disconnectDragPreview",
            value: function disconnectDragPreview() {
                if (this.dragPreviewUnsubscribe) {
                    this.dragPreviewUnsubscribe();
                    this.dragPreviewUnsubscribe = undefined;
                    this.dragPreviewNode = null;
                    this.dragPreviewRef = null;
                }
            }
        },
        {
            key: "clearDragSource",
            value: function clearDragSource() {
                this.dragSourceNode = null;
                this.dragSourceRef = null;
            }
        },
        {
            key: "clearDragPreview",
            value: function clearDragPreview() {
                this.dragPreviewNode = null;
                this.dragPreviewRef = null;
            }
        },
        {
            key: "connectTarget",
            get: function get() {
                return this.dragSource;
            }
        },
        {
            key: "dragSourceOptions",
            get: function get() {
                return this.dragSourceOptionsInternal;
            },
            set: function set(options) {
                this.dragSourceOptionsInternal = options;
            }
        },
        {
            key: "dragPreviewOptions",
            get: function get() {
                return this.dragPreviewOptionsInternal;
            },
            set: function set(options) {
                this.dragPreviewOptionsInternal = options;
            }
        },
        {
            key: "dragSource",
            get: function get() {
                return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
            }
        },
        {
            key: "dragPreview",
            get: function get() {
                return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
            }
        }
    ]);
    return SourceConnector;
}();

},{"./wrapConnectorHooks":"dNAGU","../utils/isRef":"ffUgD","@react-dnd/shallowequal":"6BP24","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dNAGU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>wrapConnectorHooks);
var _react = require("react");
var _cloneWithRef = require("../utils/cloneWithRef");
function throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === 'string') return;
    var displayName = element.type.displayName || element.type.name || 'the component';
    throw new Error('Only native element nodes can now be passed to React DnD connectors.' + "You can either wrap ".concat(displayName, " into a <div>, or turn it into a ") + 'drag source or a drop target itself.');
}
function wrapHookToRecognizeElement(hook) {
    return function() {
        var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        // When passed a node, call the hook straight away.
        if (!(0, _react.isValidElement)(elementOrNode)) {
            var node = elementOrNode;
            hook(node, options); // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        } // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        var element = elementOrNode;
        throwIfCompositeComponentElement(element); // When no options are passed, use the hook directly
        var ref = options ? function(node) {
            return hook(node, options);
        } : hook;
        return (0, _cloneWithRef.cloneWithRef)(element, ref);
    };
}
function wrapConnectorHooks(hooks) {
    var wrappedHooks = {};
    Object.keys(hooks).forEach(function(key) {
        var hook = hooks[key]; // ref objects should be passed straight through without wrapping
        if (key.endsWith('Ref')) wrappedHooks[key] = hooks[key];
        else {
            var wrappedHook = wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = function() {
                return wrappedHook;
            };
        }
    });
    return wrappedHooks;
}

},{"react":"9njXz","../utils/cloneWithRef":"8Fi2U","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Fi2U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cloneWithRef", ()=>cloneWithRef);
var _react = require("react");
var _invariant = require("@react-dnd/invariant");
function setRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else ref.current = node;
}
function cloneWithRef(element, newRef) {
    var previousRef = element.ref;
    (0, _invariant.invariant)(typeof previousRef !== 'string', "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, _react.cloneElement)(element, {
        ref: newRef
    });
    else return (0, _react.cloneElement)(element, {
        ref: function ref(node) {
            setRef(previousRef, node);
            setRef(newRef, node);
        }
    });
}

},{"react":"9njXz","@react-dnd/invariant":"7P4yo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffUgD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRef", ()=>isRef);
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function isRef(obj) {
    return obj !== null && _typeof(obj) === 'object' && obj.hasOwnProperty('current');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8BKL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * useDropTarget Hook
 * @param spec The drop target specification
 */ parcelHelpers.export(exports, "useDrop", ()=>useDrop);
var _react = require("react");
var _invariant = require("@react-dnd/invariant");
var _useMonitorOutput = require("./internal/useMonitorOutput");
var _useIsomorphicLayoutEffect = require("./internal/useIsomorphicLayoutEffect");
var _drop = require("./internal/drop");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useDrop(spec) {
    var specRef = (0, _react.useRef)(spec);
    specRef.current = spec;
    (0, _invariant.invariant)(spec.accept != null, 'accept must be defined');
    var _useDropTargetMonitor = (0, _drop.useDropTargetMonitor)(), _useDropTargetMonitor2 = _slicedToArray(_useDropTargetMonitor, 2), monitor = _useDropTargetMonitor2[0], connector = _useDropTargetMonitor2[1];
    (0, _drop.useDropHandler)(specRef, monitor, connector);
    var result = (0, _useMonitorOutput.useMonitorOutput)(monitor, specRef.current.collect || function() {
        return {};
    }, function() {
        return connector.reconnect();
    });
    var connectDropTarget = (0, _react.useMemo)(function() {
        return connector.hooks.dropTarget();
    }, [
        connector
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        connector.dropTargetOptions = spec.options || null;
        connector.reconnect();
    }, [
        spec.options
    ]);
    return [
        result,
        connectDropTarget
    ];
}

},{"react":"9njXz","@react-dnd/invariant":"7P4yo","./internal/useMonitorOutput":"iaYWC","./internal/useIsomorphicLayoutEffect":"dSOud","./internal/drop":"9jWHV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9jWHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDropTargetMonitor", ()=>useDropTargetMonitor);
parcelHelpers.export(exports, "useDropHandler", ()=>useDropHandler);
var _react = require("react");
var _registration = require("../../common/registration");
var _useDragDropManager = require("./useDragDropManager");
var _targetConnector = require("../../common/TargetConnector");
var _dropTargetMonitorImpl = require("../../common/DropTargetMonitorImpl");
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useDropTargetMonitor() {
    var manager = (0, _useDragDropManager.useDragDropManager)();
    var monitor = (0, _react.useMemo)(function() {
        return new (0, _dropTargetMonitorImpl.DropTargetMonitorImpl)(manager);
    }, [
        manager
    ]);
    var connector = (0, _react.useMemo)(function() {
        return new (0, _targetConnector.TargetConnector)(manager.getBackend());
    }, [
        manager
    ]);
    return [
        monitor,
        connector
    ];
}
function useDropHandler(spec, monitor, connector) {
    var manager = (0, _useDragDropManager.useDragDropManager)();
    var handler = (0, _react.useMemo)(function() {
        return {
            canDrop: function canDrop() {
                var canDrop = spec.current.canDrop;
                return canDrop ? canDrop(monitor.getItem(), monitor) : true;
            },
            hover: function hover() {
                var hover = spec.current.hover;
                if (hover) hover(monitor.getItem(), monitor);
            },
            drop: function drop() {
                var drop = spec.current.drop;
                if (drop) return drop(monitor.getItem(), monitor);
            }
        };
    }, [
        monitor
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function registerHandler() {
        var _registerTarget = (0, _registration.registerTarget)(spec.current.accept, handler, manager), _registerTarget2 = _slicedToArray(_registerTarget, 2), handlerId = _registerTarget2[0], unregister = _registerTarget2[1];
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        monitor,
        connector
    ]);
}

},{"react":"9njXz","../../common/registration":"JHndx","./useDragDropManager":"dNXln","../../common/TargetConnector":"3q2eN","../../common/DropTargetMonitorImpl":"PCQfG","./useIsomorphicLayoutEffect":"dSOud","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3q2eN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TargetConnector", ()=>TargetConnector);
var _shallowequal = require("@react-dnd/shallowequal");
var _wrapConnectorHooks = require("./wrapConnectorHooks");
var _wrapConnectorHooksDefault = parcelHelpers.interopDefault(_wrapConnectorHooks);
var _isRef = require("../utils/isRef");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var TargetConnector = /*#__PURE__*/ function() {
    function TargetConnector(backend) {
        var _this = this;
        _classCallCheck(this, TargetConnector);
        this.hooks = (0, _wrapConnectorHooksDefault.default)({
            dropTarget: function dropTarget(node, options) {
                _this.clearDropTarget();
                _this.dropTargetOptions = options;
                if ((0, _isRef.isRef)(node)) _this.dropTargetRef = node;
                else _this.dropTargetNode = node;
                _this.reconnect();
            }
        });
        this.handlerId = null; // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
    _createClass(TargetConnector, [
        {
            key: "reconnect",
            value: function reconnect() {
                // if nothing has changed then don't resubscribe
                var didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
                if (didChange) this.disconnectDropTarget();
                var dropTarget = this.dropTarget;
                if (!this.handlerId) return;
                if (!dropTarget) {
                    this.lastConnectedDropTarget = dropTarget;
                    return;
                }
                if (didChange) {
                    this.lastConnectedHandlerId = this.handlerId;
                    this.lastConnectedDropTarget = dropTarget;
                    this.lastConnectedDropTargetOptions = this.dropTargetOptions;
                    this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
                }
            }
        },
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(newHandlerId) {
                if (newHandlerId === this.handlerId) return;
                this.handlerId = newHandlerId;
                this.reconnect();
            }
        },
        {
            key: "didHandlerIdChange",
            value: function didHandlerIdChange() {
                return this.lastConnectedHandlerId !== this.handlerId;
            }
        },
        {
            key: "didDropTargetChange",
            value: function didDropTargetChange() {
                return this.lastConnectedDropTarget !== this.dropTarget;
            }
        },
        {
            key: "didOptionsChange",
            value: function didOptionsChange() {
                return !(0, _shallowequal.shallowEqual)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
            }
        },
        {
            key: "disconnectDropTarget",
            value: function disconnectDropTarget() {
                if (this.unsubscribeDropTarget) {
                    this.unsubscribeDropTarget();
                    this.unsubscribeDropTarget = undefined;
                }
            }
        },
        {
            key: "clearDropTarget",
            value: function clearDropTarget() {
                this.dropTargetRef = null;
                this.dropTargetNode = null;
            }
        },
        {
            key: "connectTarget",
            get: function get() {
                return this.dropTarget;
            }
        },
        {
            key: "dropTargetOptions",
            get: function get() {
                return this.dropTargetOptionsInternal;
            },
            set: function set(options) {
                this.dropTargetOptionsInternal = options;
            }
        },
        {
            key: "dropTarget",
            get: function get() {
                return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
            }
        }
    ]);
    return TargetConnector;
}();

},{"@react-dnd/shallowequal":"6BP24","./wrapConnectorHooks":"dNAGU","../utils/isRef":"ffUgD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"PCQfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropTargetMonitorImpl", ()=>DropTargetMonitorImpl);
var _invariant = require("@react-dnd/invariant");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isCallingCanDrop = false;
var DropTargetMonitorImpl = /*#__PURE__*/ function() {
    function DropTargetMonitorImpl(manager) {
        _classCallCheck(this, DropTargetMonitorImpl);
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
    _createClass(DropTargetMonitorImpl, [
        {
            key: "receiveHandlerId",
            value: function receiveHandlerId(targetId) {
                this.targetId = targetId;
            }
        },
        {
            key: "getHandlerId",
            value: function getHandlerId() {
                return this.targetId;
            }
        },
        {
            key: "subscribeToStateChange",
            value: function subscribeToStateChange(listener, options) {
                return this.internalMonitor.subscribeToStateChange(listener, options);
            }
        },
        {
            key: "canDrop",
            value: function canDrop() {
                // Cut out early if the target id has not been set. This should prevent errors
                // where the user has an older version of dnd-core like in
                // https://github.com/react-dnd/react-dnd/issues/1310
                if (!this.targetId) return false;
                (0, _invariant.invariant)(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
                try {
                    isCallingCanDrop = true;
                    return this.internalMonitor.canDropOnTarget(this.targetId);
                } finally{
                    isCallingCanDrop = false;
                }
            }
        },
        {
            key: "isOver",
            value: function isOver(options) {
                if (!this.targetId) return false;
                return this.internalMonitor.isOverTarget(this.targetId, options);
            }
        },
        {
            key: "getItemType",
            value: function getItemType() {
                return this.internalMonitor.getItemType();
            }
        },
        {
            key: "getItem",
            value: function getItem() {
                return this.internalMonitor.getItem();
            }
        },
        {
            key: "getDropResult",
            value: function getDropResult() {
                return this.internalMonitor.getDropResult();
            }
        },
        {
            key: "didDrop",
            value: function didDrop() {
                return this.internalMonitor.didDrop();
            }
        },
        {
            key: "getInitialClientOffset",
            value: function getInitialClientOffset() {
                return this.internalMonitor.getInitialClientOffset();
            }
        },
        {
            key: "getInitialSourceClientOffset",
            value: function getInitialSourceClientOffset() {
                return this.internalMonitor.getInitialSourceClientOffset();
            }
        },
        {
            key: "getSourceClientOffset",
            value: function getSourceClientOffset() {
                return this.internalMonitor.getSourceClientOffset();
            }
        },
        {
            key: "getClientOffset",
            value: function getClientOffset() {
                return this.internalMonitor.getClientOffset();
            }
        },
        {
            key: "getDifferenceFromInitialOffset",
            value: function getDifferenceFromInitialOffset() {
                return this.internalMonitor.getDifferenceFromInitialOffset();
            }
        }
    ]);
    return DropTargetMonitorImpl;
}();

},{"@react-dnd/invariant":"7P4yo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hla4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEmptyImage", ()=>(0, _getEmptyImage.getEmptyImage));
parcelHelpers.export(exports, "NativeTypes", ()=>_nativeTypes);
var _html5Backend = require("./HTML5Backend");
var _html5BackendDefault = parcelHelpers.interopDefault(_html5Backend);
var _nativeTypes = require("./NativeTypes");
var _getEmptyImage = require("./getEmptyImage");
var createBackend = function createBackend(manager, context) {
    return new (0, _html5BackendDefault.default)(manager, context);
};
exports.default = createBackend;

},{"./HTML5Backend":"2LhWh","./NativeTypes":false,"./getEmptyImage":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2LhWh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HTML5Backend);
var _enterLeaveCounter = require("./EnterLeaveCounter");
var _enterLeaveCounterDefault = parcelHelpers.interopDefault(_enterLeaveCounter);
var _browserDetector = require("./BrowserDetector");
var _offsetUtils = require("./OffsetUtils");
var _nativeDragSources = require("./NativeDragSources");
var _nativeTypes = require("./NativeTypes");
var _optionsReader = require("./OptionsReader");
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var HTML5Backend = /*#__PURE__*/ function() {
    function HTML5Backend(manager, globalContext) {
        var _this = this;
        _classCallCheck(this, HTML5Backend);
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.getSourceClientOffset = function(sourceId) {
            return (0, _offsetUtils.getNodeClientOffset)(_this.sourceNodes.get(sourceId));
        };
        this.endDragNativeItem = function() {
            if (!_this.isDraggingNativeItem()) return;
            _this.actions.endDrag();
            _this.registry.removeSource(_this.currentNativeHandle);
            _this.currentNativeHandle = null;
            _this.currentNativeSource = null;
        };
        this.isNodeInDocument = function(node) {
            // Check the node either in the main document or in the current context
            return _this.document && _this.document.body && document.body.contains(node);
        };
        this.endDragIfSourceWasRemovedFromDOM = function() {
            var node = _this.currentDragSourceNode;
            if (_this.isNodeInDocument(node)) return;
            if (_this.clearCurrentDragSourceNode()) _this.actions.endDrag();
        };
        this.handleTopDragStartCapture = function() {
            _this.clearCurrentDragSourceNode();
            _this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = function(e) {
            if (e.defaultPrevented) return;
            var dragStartSourceIds = _this.dragStartSourceIds;
            _this.dragStartSourceIds = null;
            var clientOffset = (0, _offsetUtils.getEventClientOffset)(e); // Avoid crashing if we missed a drop event or our previous drag died
            if (_this.monitor.isDragging()) _this.actions.endDrag();
             // Don't publish the source just yet (see why below)
            _this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: _this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, _nativeDragSources.matchNativeItemType)(dataTransfer);
            if (_this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === 'function') {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    var sourceId = _this.monitor.getSourceId();
                    var sourceNode = _this.sourceNodes.get(sourceId);
                    var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(), anchorX = _this$getCurrentSourc.anchorX, anchorY = _this$getCurrentSourc.anchorY, offsetX = _this$getCurrentSourc.offsetX, offsetY = _this$getCurrentSourc.offsetY;
                        var anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        var offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        var dragPreviewOffset = (0, _offsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer.setData('application/json', {});
                } catch (err) {} // IE doesn't support MIME types in setData
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                _this.setCurrentDragSourceNode(e.target); // Now we are ready to publish the drag source.. or are we not?
                var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(), captureDraggingState = _this$getCurrentSourc2.captureDraggingState;
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(function() {
                    return _this.actions.publishDragSource();
                }, 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                _this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            _this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute('draggable'))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = function() {
            if (_this.clearCurrentDragSourceNode()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            _this.actions.endDrag();
        };
        this.handleTopDragEnterCapture = function(e) {
            _this.dragEnterTargetIds = [];
            var isFirstEnter = _this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || _this.monitor.isDragging()) return;
            var dataTransfer = e.dataTransfer;
            var nativeType = (0, _nativeDragSources.matchNativeItemType)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            _this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = function(e) {
            var dragEnterTargetIds = _this.dragEnterTargetIds;
            _this.dragEnterTargetIds = [];
            if (!_this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            _this.altKeyPressed = e.altKey;
            if (!(0, _browserDetector.isFirefox)()) // Don't emit hover in `dragenter` on Firefox due to an edge case.
            // If the target changes position as the result of `dragenter`, Firefox
            // will still happily dispatch `dragover` despite target being no longer
            // there. The easy solution is to only fire `hover` in `dragover` on FF.
            _this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, _offsetUtils.getEventClientOffset)(e)
            });
            var canDrop = dragEnterTargetIds.some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = function() {
            _this.dragOverTargetIds = [];
        };
        this.handleTopDragOver = function(e) {
            var dragOverTargetIds = _this.dragOverTargetIds;
            _this.dragOverTargetIds = [];
            if (!_this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
                return;
            }
            _this.altKeyPressed = e.altKey;
            _this.actions.hover(dragOverTargetIds || [], {
                clientOffset: (0, _offsetUtils.getEventClientOffset)(e)
            });
            var canDrop = (dragOverTargetIds || []).some(function(targetId) {
                return _this.monitor.canDropOnTarget(targetId);
            });
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
            } else if (_this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'none';
            }
        };
        this.handleTopDragLeaveCapture = function(e) {
            if (_this.isDraggingNativeItem()) e.preventDefault();
            var isLastLeave = _this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (_this.isDraggingNativeItem()) _this.endDragNativeItem();
        };
        this.handleTopDropCapture = function(e) {
            _this.dropTargetIds = [];
            e.preventDefault();
            if (_this.isDraggingNativeItem()) _this.currentNativeSource.loadDataTransfer(e.dataTransfer);
            _this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = function(e) {
            var dropTargetIds = _this.dropTargetIds;
            _this.dropTargetIds = [];
            _this.actions.hover(dropTargetIds, {
                clientOffset: (0, _offsetUtils.getEventClientOffset)(e)
            });
            _this.actions.drop({
                dropEffect: _this.getCurrentDropEffect()
            });
            if (_this.isDraggingNativeItem()) _this.endDragNativeItem();
            else _this.endDragIfSourceWasRemovedFromDOM();
        };
        this.handleSelectStart = function(e) {
            var target = e.target; // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== 'function') return;
             // Inputs and textareas should be selectable
            if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return;
             // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, _optionsReader.OptionsReader)(globalContext);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, _enterLeaveCounterDefault.default)(this.isNodeInDocument);
    } // public for test
    _createClass(HTML5Backend, [
        {
            key: "setup",
            value: function setup() {
                if (this.window === undefined) return;
                if (this.window.__isReactDndBackendSetUp) throw new Error('Cannot have two HTML5 backends at the same time.');
                this.window.__isReactDndBackendSetUp = true;
                this.addEventListeners(this.window);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                if (this.window === undefined) return;
                this.window.__isReactDndBackendSetUp = false;
                this.removeEventListeners(this.window);
                this.clearCurrentDragSourceNode();
                if (this.asyncEndDragFrameId) this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
            }
        },
        {
            key: "connectDragPreview",
            value: function connectDragPreview(sourceId, node, options) {
                var _this2 = this;
                this.sourcePreviewNodeOptions.set(sourceId, options);
                this.sourcePreviewNodes.set(sourceId, node);
                return function() {
                    _this2.sourcePreviewNodes.delete(sourceId);
                    _this2.sourcePreviewNodeOptions.delete(sourceId);
                };
            }
        },
        {
            key: "connectDragSource",
            value: function connectDragSource(sourceId, node, options) {
                var _this3 = this;
                this.sourceNodes.set(sourceId, node);
                this.sourceNodeOptions.set(sourceId, options);
                var handleDragStart = function handleDragStart(e) {
                    return _this3.handleDragStart(e, sourceId);
                };
                var handleSelectStart = function handleSelectStart(e) {
                    return _this3.handleSelectStart(e);
                };
                node.setAttribute('draggable', 'true');
                node.addEventListener('dragstart', handleDragStart);
                node.addEventListener('selectstart', handleSelectStart);
                return function() {
                    _this3.sourceNodes.delete(sourceId);
                    _this3.sourceNodeOptions.delete(sourceId);
                    node.removeEventListener('dragstart', handleDragStart);
                    node.removeEventListener('selectstart', handleSelectStart);
                    node.setAttribute('draggable', 'false');
                };
            }
        },
        {
            key: "connectDropTarget",
            value: function connectDropTarget(targetId, node) {
                var _this4 = this;
                var handleDragEnter = function handleDragEnter(e) {
                    return _this4.handleDragEnter(e, targetId);
                };
                var handleDragOver = function handleDragOver(e) {
                    return _this4.handleDragOver(e, targetId);
                };
                var handleDrop = function handleDrop(e) {
                    return _this4.handleDrop(e, targetId);
                };
                node.addEventListener('dragenter', handleDragEnter);
                node.addEventListener('dragover', handleDragOver);
                node.addEventListener('drop', handleDrop);
                return function() {
                    node.removeEventListener('dragenter', handleDragEnter);
                    node.removeEventListener('dragover', handleDragOver);
                    node.removeEventListener('drop', handleDrop);
                };
            }
        },
        {
            key: "addEventListeners",
            value: function addEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.addEventListener) return;
                target.addEventListener('dragstart', this.handleTopDragStart);
                target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.addEventListener('dragend', this.handleTopDragEndCapture, true);
                target.addEventListener('dragenter', this.handleTopDragEnter);
                target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.addEventListener('dragover', this.handleTopDragOver);
                target.addEventListener('dragover', this.handleTopDragOverCapture, true);
                target.addEventListener('drop', this.handleTopDrop);
                target.addEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: "removeEventListeners",
            value: function removeEventListeners(target) {
                // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
                if (!target.removeEventListener) return;
                target.removeEventListener('dragstart', this.handleTopDragStart);
                target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
                target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
                target.removeEventListener('dragenter', this.handleTopDragEnter);
                target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
                target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
                target.removeEventListener('dragover', this.handleTopDragOver);
                target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
                target.removeEventListener('drop', this.handleTopDrop);
                target.removeEventListener('drop', this.handleTopDropCapture, true);
            }
        },
        {
            key: "getCurrentSourceNodeOptions",
            value: function getCurrentSourceNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
                return _objectSpread({
                    dropEffect: this.altKeyPressed ? 'copy' : 'move'
                }, sourceNodeOptions || {});
            }
        },
        {
            key: "getCurrentDropEffect",
            value: function getCurrentDropEffect() {
                if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
                return 'copy';
                return this.getCurrentSourceNodeOptions().dropEffect;
            }
        },
        {
            key: "getCurrentSourcePreviewNodeOptions",
            value: function getCurrentSourcePreviewNodeOptions() {
                var sourceId = this.monitor.getSourceId();
                var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
                return _objectSpread({
                    anchorX: 0.5,
                    anchorY: 0.5,
                    captureDraggingState: false
                }, sourcePreviewNodeOptions || {});
            }
        },
        {
            key: "isDraggingNativeItem",
            value: function isDraggingNativeItem() {
                var itemType = this.monitor.getItemType();
                return Object.keys(_nativeTypes).some(function(key) {
                    return _nativeTypes[key] === itemType;
                });
            }
        },
        {
            key: "beginDragNativeItem",
            value: function beginDragNativeItem(type, dataTransfer) {
                this.clearCurrentDragSourceNode();
                this.currentNativeSource = (0, _nativeDragSources.createNativeDragSource)(type, dataTransfer);
                this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
                this.actions.beginDrag([
                    this.currentNativeHandle
                ]);
            }
        },
        {
            key: "setCurrentDragSourceNode",
            value: function setCurrentDragSourceNode(node) {
                var _this5 = this;
                this.clearCurrentDragSourceNode();
                this.currentDragSourceNode = node; // A timeout of > 0 is necessary to resolve Firefox issue referenced
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                var MOUSE_MOVE_TIMEOUT = 1000; // Receiving a mouse event in the middle of a dragging operation
                // means it has ended and the drag source node disappeared from DOM,
                // so the browser didn't dispatch the dragend event.
                //
                // We need to wait before we start listening for mousemove events.
                // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
                // immediately in some browsers.
                //
                // See:
                //   * https://github.com/react-dnd/react-dnd/pull/928
                //   * https://github.com/react-dnd/react-dnd/issues/869
                //
                this.mouseMoveTimeoutTimer = setTimeout(function() {
                    return _this5.window && _this5.window.addEventListener('mousemove', _this5.endDragIfSourceWasRemovedFromDOM, true);
                }, MOUSE_MOVE_TIMEOUT);
            }
        },
        {
            key: "clearCurrentDragSourceNode",
            value: function clearCurrentDragSourceNode() {
                if (this.currentDragSourceNode) {
                    this.currentDragSourceNode = null;
                    if (this.window) {
                        this.window.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                        this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
                    }
                    this.mouseMoveTimeoutTimer = null;
                    return true;
                }
                return false;
            }
        },
        {
            key: "handleDragStart",
            value: function handleDragStart(e, sourceId) {
                if (e.defaultPrevented) return;
                if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
                this.dragStartSourceIds.unshift(sourceId);
            }
        },
        {
            key: "handleDragEnter",
            value: function handleDragEnter(e, targetId) {
                this.dragEnterTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDragOver",
            value: function handleDragOver(e, targetId) {
                if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
                this.dragOverTargetIds.unshift(targetId);
            }
        },
        {
            key: "handleDrop",
            value: function handleDrop(e, targetId) {
                this.dropTargetIds.unshift(targetId);
            }
        },
        {
            key: "window",
            get: function get() {
                return this.options.window;
            }
        },
        {
            key: "document",
            get: function get() {
                return this.options.document;
            }
        }
    ]);
    return HTML5Backend;
}();

},{"./EnterLeaveCounter":"fIbq1","./BrowserDetector":"cepUn","./OffsetUtils":"fSBMu","./NativeDragSources":"cWwir","./NativeTypes":"8jMdW","./OptionsReader":"3lR82","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fIbq1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EnterLeaveCounter);
var _jsUtils = require("./utils/js_utils");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var EnterLeaveCounter = /*#__PURE__*/ function() {
    function EnterLeaveCounter(isNodeInDocument) {
        _classCallCheck(this, EnterLeaveCounter);
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
    _createClass(EnterLeaveCounter, [
        {
            key: "enter",
            value: function enter(enteringNode) {
                var _this = this;
                var previousLength = this.entered.length;
                var isNodeEntered = function isNodeEntered(node) {
                    return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
                };
                this.entered = (0, _jsUtils.union)(this.entered.filter(isNodeEntered), [
                    enteringNode
                ]);
                return previousLength === 0 && this.entered.length > 0;
            }
        },
        {
            key: "leave",
            value: function leave(leavingNode) {
                var previousLength = this.entered.length;
                this.entered = (0, _jsUtils.without)(this.entered.filter(this.isNodeInDocument), leavingNode);
                return previousLength > 0 && this.entered.length === 0;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.entered = [];
            }
        }
    ]);
    return EnterLeaveCounter;
}();

},{"./utils/js_utils":"a0YCR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a0YCR":[function(require,module,exports,__globalThis) {
// cheap lodash replacements
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoize", ()=>memoize);
/**
 * drop-in replacement for _.without
 */ parcelHelpers.export(exports, "without", ()=>without);
parcelHelpers.export(exports, "union", ()=>union);
function memoize(fn) {
    var result = null;
    var memoized = function memoized() {
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function without(items, item) {
    return items.filter(function(i) {
        return i !== item;
    });
}
function union(itemsA, itemsB) {
    var set = new Set();
    var insertItem = function insertItem(item) {
        return set.add(item);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    var result = [];
    set.forEach(function(key) {
        return result.push(key);
    });
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cepUn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFirefox", ()=>isFirefox);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
var _jsUtils = require("./utils/js_utils");
var isFirefox = (0, _jsUtils.memoize)(function() {
    return /firefox/i.test(navigator.userAgent);
});
var isSafari = (0, _jsUtils.memoize)(function() {
    return Boolean(window.safari);
});

},{"./utils/js_utils":"a0YCR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSBMu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNodeClientOffset", ()=>getNodeClientOffset);
parcelHelpers.export(exports, "getEventClientOffset", ()=>getEventClientOffset);
parcelHelpers.export(exports, "getDragPreviewOffset", ()=>getDragPreviewOffset);
var _browserDetector = require("./BrowserDetector");
var _monotonicInterpolant = require("./MonotonicInterpolant");
var _monotonicInterpolantDefault = parcelHelpers.interopDefault(_monotonicInterpolant);
var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
    var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
    return {
        x: left,
        y: top
    };
}
function getEventClientOffset(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function isImageNode(node) {
    return node.nodeName === 'IMG' && ((0, _browserDetector.isFirefox)() || !document.documentElement.contains(node));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight; // Work around @2x coordinate discrepancies in browsers
    if ((0, _browserDetector.isSafari)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    var isImage = isImageNode(dragPreview);
    var dragPreviewNode = isImage ? sourceNode : dragPreview;
    var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
    var offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
    var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
    var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth, dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
    var calculateYOffset = function calculateYOffset() {
        var interpolantY = new (0, _monotonicInterpolantDefault.default)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.y,
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        var y = interpolantY.interpolate(anchorY); // Work around Safari 8 positioning bug
        if ((0, _browserDetector.isSafari)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    var calculateXOffset = function calculateXOffset() {
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        var interpolantX = new (0, _monotonicInterpolantDefault.default)([
            0,
            0.5,
            1
        ], [
            offsetFromDragPreview.x,
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    }; // Force offsets if specified in the options.
    var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
    var isManualOffsetX = offsetX === 0 || offsetX;
    var isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}

},{"./BrowserDetector":"cepUn","./MonotonicInterpolant":"j8Do6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8Do6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MonotonicInterpolant);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var MonotonicInterpolant = /*#__PURE__*/ function() {
    function MonotonicInterpolant(xs, ys) {
        _classCallCheck(this, MonotonicInterpolant);
        var length = xs.length; // Rearrange xs and ys so that xs is sorted
        var indexes = [];
        for(var i = 0; i < length; i++)indexes.push(i);
        indexes.sort(function(a, b) {
            return xs[a] < xs[b] ? -1 : 1;
        }); // Get consecutive differences and slopes
        var dys = [];
        var dxs = [];
        var ms = [];
        var dx;
        var dy;
        for(var _i = 0; _i < length - 1; _i++){
            dx = xs[_i + 1] - xs[_i];
            dy = ys[_i + 1] - ys[_i];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        } // Get degree-1 coefficients
        var c1s = [
            ms[0]
        ];
        for(var _i2 = 0; _i2 < dxs.length - 1; _i2++){
            var m2 = ms[_i2];
            var mNext = ms[_i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[_i2];
                var dxNext = dxs[_i2 + 1];
                var common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]); // Get degree-2 and degree-3 coefficients
        var c2s = [];
        var c3s = [];
        var m;
        for(var _i3 = 0; _i3 < c1s.length - 1; _i3++){
            m = ms[_i3];
            var c1 = c1s[_i3];
            var invDx = 1 / dxs[_i3];
            var _common = c1 + c1s[_i3 + 1] - m - m;
            c2s.push((m - c1 - _common) * invDx);
            c3s.push(_common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
    _createClass(MonotonicInterpolant, [
        {
            key: "interpolate",
            value: function interpolate(x) {
                var xs = this.xs, ys = this.ys, c1s = this.c1s, c2s = this.c2s, c3s = this.c3s; // The rightmost point in the dataset should give an exact result
                var i = xs.length - 1;
                if (x === xs[i]) return ys[i];
                 // Search for the interval x is in, returning the corresponding y if x is one of the original xs
                var low = 0;
                var high = c3s.length - 1;
                var mid;
                while(low <= high){
                    mid = Math.floor(0.5 * (low + high));
                    var xHere = xs[mid];
                    if (xHere < x) low = mid + 1;
                    else if (xHere > x) high = mid - 1;
                    else return ys[mid];
                }
                i = Math.max(0, high); // Interpolate
                var diff = x - xs[i];
                var diffSq = diff * diff;
                return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
            }
        }
    ]);
    return MonotonicInterpolant;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWwir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNativeDragSource", ()=>createNativeDragSource);
parcelHelpers.export(exports, "matchNativeItemType", ()=>matchNativeItemType);
var _nativeTypesConfig = require("./nativeTypesConfig");
var _nativeDragSource = require("./NativeDragSource");
function createNativeDragSource(type, dataTransfer) {
    var result = new (0, _nativeDragSource.NativeDragSource)((0, _nativeTypesConfig.nativeTypesConfig)[type]);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function matchNativeItemType(dataTransfer) {
    if (!dataTransfer) return null;
    var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, _nativeTypesConfig.nativeTypesConfig)).filter(function(nativeItemType) {
        var matchesTypes = (0, _nativeTypesConfig.nativeTypesConfig)[nativeItemType].matchesTypes;
        return matchesTypes.some(function(t) {
            return dataTransferTypes.indexOf(t) > -1;
        });
    })[0] || null;
}

},{"./nativeTypesConfig":"7YxIn","./NativeDragSource":"aeDTF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7YxIn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nativeTypesConfig", ()=>nativeTypesConfig);
var _nativeTypes = require("../NativeTypes");
var _getDataFromDataTransfer = require("./getDataFromDataTransfer");
var _nativeTypesConfig;
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, _nativeTypes.FILE, {
    exposeProperties: {
        files: function files(dataTransfer) {
            return Array.prototype.slice.call(dataTransfer.files);
        },
        items: function items(dataTransfer) {
            return dataTransfer.items;
        }
    },
    matchesTypes: [
        'Files'
    ]
}), _defineProperty(_nativeTypesConfig, _nativeTypes.URL, {
    exposeProperties: {
        urls: function urls(dataTransfer, matchesTypes) {
            return (0, _getDataFromDataTransfer.getDataFromDataTransfer)(dataTransfer, matchesTypes, '').split('\n');
        }
    },
    matchesTypes: [
        'Url',
        'text/uri-list'
    ]
}), _defineProperty(_nativeTypesConfig, _nativeTypes.TEXT, {
    exposeProperties: {
        text: function text(dataTransfer, matchesTypes) {
            return (0, _getDataFromDataTransfer.getDataFromDataTransfer)(dataTransfer, matchesTypes, '');
        }
    },
    matchesTypes: [
        'Text',
        'text/plain'
    ]
}), _nativeTypesConfig);

},{"../NativeTypes":"8jMdW","./getDataFromDataTransfer":"1gWOr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8jMdW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FILE", ()=>FILE);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "TEXT", ()=>TEXT);
var FILE = '__NATIVE_FILE__';
var URL = '__NATIVE_URL__';
var TEXT = '__NATIVE_TEXT__';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1gWOr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDataFromDataTransfer", ()=>getDataFromDataTransfer);
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
    var result = typesToTry.reduce(function(resultSoFar, typeToTry) {
        return resultSoFar || dataTransfer.getData(typeToTry);
    }, '');
    return result != null ? result : defaultValue;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aeDTF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeDragSource", ()=>NativeDragSource);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var NativeDragSource = /*#__PURE__*/ function() {
    function NativeDragSource(config) {
        _classCallCheck(this, NativeDragSource);
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
    _createClass(NativeDragSource, [
        {
            key: "initializeExposedProperties",
            value: function initializeExposedProperties() {
                var _this = this;
                Object.keys(this.config.exposeProperties).forEach(function(property) {
                    Object.defineProperty(_this.item, property, {
                        configurable: true,
                        enumerable: true,
                        get: function get() {
                            // eslint-disable-next-line no-console
                            console.warn("Browser doesn't allow reading \"".concat(property, "\" until the drop event."));
                            return null;
                        }
                    });
                });
            }
        },
        {
            key: "loadDataTransfer",
            value: function loadDataTransfer(dataTransfer) {
                var _this2 = this;
                if (dataTransfer) {
                    var newProperties = {};
                    Object.keys(this.config.exposeProperties).forEach(function(property) {
                        newProperties[property] = {
                            value: _this2.config.exposeProperties[property](dataTransfer, _this2.config.matchesTypes),
                            configurable: true,
                            enumerable: true
                        };
                    });
                    Object.defineProperties(this.item, newProperties);
                }
            }
        },
        {
            key: "canDrag",
            value: function canDrag() {
                return true;
            }
        },
        {
            key: "beginDrag",
            value: function beginDrag() {
                return this.item;
            }
        },
        {
            key: "isDragging",
            value: function isDragging(monitor, handle) {
                return handle === monitor.getSourceId();
            }
        },
        {
            key: "endDrag",
            value: function endDrag() {}
        }
    ]);
    return NativeDragSource;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3lR82":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptionsReader", ()=>OptionsReader);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var OptionsReader = /*#__PURE__*/ function() {
    function OptionsReader(globalContext) {
        _classCallCheck(this, OptionsReader);
        this.globalContext = globalContext;
    }
    _createClass(OptionsReader, [
        {
            key: "window",
            get: function get() {
                if (this.globalContext) return this.globalContext;
                else if (typeof window !== 'undefined') return window;
                return undefined;
            }
        },
        {
            key: "document",
            get: function get() {
                if (this.window) return this.window.document;
                return undefined;
            }
        }
    ]);
    return OptionsReader;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEpdJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var r = (...e)=>{
    const t = Object.assign({}, ...e);
    let r;
    return Object.keys(t).reduce((e, n)=>{
        const o = Object.keys(t[n]);
        if (r || (r = o), JSON.stringify(r.sort()) !== JSON.stringify(o.sort())) throw new Error(`Wrong amount of languages, expected '${r}' but got '${o}'`);
        return {
            ...e,
            [n]: r.reduce((e, r)=>{
                const o = t[n][r];
                if (o && o.normalized) return {
                    ...e,
                    [r]: o
                };
                if ("function" == typeof o) {
                    const t = (e = {})=>o(e);
                    return t.normalized = !0, {
                        ...e,
                        [r]: t
                    };
                }
                if ("string" == typeof o) {
                    const t = ()=>o;
                    return t.normalized = !0, {
                        ...e,
                        [r]: t
                    };
                }
                throw new Error(`Value cannot be of type "${typeof o}"`);
            }, {})
        };
    }, {});
}, n = ({ id: e, dictionary: t, language: r, ...n })=>{
    if (!e) {
        const t = Object.entries(n).filter(([e, t])=>"boolean" == typeof t).map(([e])=>e);
        if (!t.length) throw new Error("Please make sure to pass an id");
        if (t.length > 1) throw new Error(`Please only pass a single id/boolean, detected '${t}'`);
        e = t[0];
    }
    const o = Object.keys(t);
    if (!o.includes(e)) throw new Error(`Couldn't find '${e}' in the dictionary. Available ids: ${o}`);
    if (void 0 === t[e][r]) throw new Error(`The language '${r}' is not available (attempted with id '${e}')`);
    return t[e][r](n);
};
const { Provider: o, Consumer: i } = (0, _react.createContext)({});
let a = ({ children: e })=>e;
try {
    a = require("230bbdf80632ea87").Text;
} catch (e) {}
exports.default = ({ language: t, dictionary: l = {}, children: c, render: s, component: u, ...d })=>(0, _reactDefault.default).createElement(i, null, (i)=>c ? (t = t || i.language, l = {
            ...i.dictionary,
            ...r(l)
        }, (0, _reactDefault.default).createElement(o, {
            value: {
                language: t,
                dictionary: l
            }
        }, c)) : u ? !0 === d[i.language] ? u : null : s ? s(n({
            ...i,
            ...d
        })) : (0, _reactDefault.default).createElement(a, null, n({
            ...i,
            ...d
        })));

},{"react":"9njXz","230bbdf80632ea87":"react-native","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8JC9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Topbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _post = require("context/post");
var _url = require("helpers/url");
var _selectLanguage = require("../select-language");
var _selectLanguageDefault = parcelHelpers.interopDefault(_selectLanguage);
var _switchView = require("../switch-view");
var _switchViewDefault = parcelHelpers.interopDefault(_switchView);
var _notification = require("./Notification");
var _notificationDefault = parcelHelpers.interopDefault(_notification);
var _context = require("teacher/context");
var _topbarStyl = require("./topbar.styl");
function handleLogout(language, project) {
    return async ()=>{
        await (0, _post.logout)();
        const url = (0, _url.subdomainResource)(project == 'de' ? 'de' : 'www', language, 'login.html');
        location.replace(`//${url}`);
    };
}
function Topbar() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { locked, profile, menuShowing, languageId, role, link, settings, translate, updateState } = context;
    const { individual = {}, institution } = profile;
    const addresses = individual.addresses || {};
    const informed = addresses.uiInformed;
    const { properties, loaded } = context.preferences;
    function hide({ target }) {
        if (!target) return;
        if (target.id == 'menu') return;
        if (target.closest('.menu-button')) return;
        if (target.closest('#more-menu')) return;
        if (target.closest('.submenu')) return;
        document.removeEventListener("click", hide);
        updateState({
            menuShowing: {
                $set: false
            },
            expandedMenuShowing: {
                $set: false
            }
        });
    }
    function toggle() {
        updateState({
            menuShowing: {
                $apply: (showing)=>!showing
            }
        });
    }
    (0, _react.useEffect)(()=>{
        if (menuShowing) document.addEventListener('click', hide);
        else document.removeEventListener('click', hide);
    }, [
        menuShowing
    ]);
    const notificationOpened = loaded ? !properties.notifications[settings.showTopbarNotification] : false;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
        className: "topbar",
        children: [
            !locked && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "menu-button",
                onClick: toggle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FAIcon), {
                        icon: "bars"
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "title-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    className: "title",
                    children: translate(`${profile.institution.project}_project_title`)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectLanguageDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "logout",
                onClick: handleLogout(languageId, institution.project),
                children: translate('logout')
            }),
            false,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                ...(0, _url.viewerGuard)({
                    href: 'https://edusystem.com/uso-y-manejo-maestros/',
                    target: "_blank"
                }),
                className: 'help',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FAIcon), {
                        icon: "questionCircle"
                    })
                })
            }),
            settings.showTopbarNotification && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notificationDefault.default), {
                notificationPrefix: settings.showTopbarNotification,
                open: notificationOpened,
                context: context
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","context/post":"8rmpk","helpers/url":"65SQD","../select-language":"dTlzn","../switch-view":"8Lz4b","./Notification":"2bsKa","teacher/context":"5LKDx","./topbar.styl":"1i2uF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6yEDE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Typography", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "Chip", ()=>(0, _chipDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "Paper", ()=>(0, _paperDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipDefault.default));
parcelHelpers.export(exports, "Popover", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "Fade", ()=>(0, _fadeDefault.default));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialogDefault.default));
parcelHelpers.export(exports, "DialogActions", ()=>(0, _dialogActionsDefault.default));
parcelHelpers.export(exports, "DialogContent", ()=>(0, _dialogContentDefault.default));
parcelHelpers.export(exports, "DialogTitle", ()=>(0, _dialogTitleDefault.default));
parcelHelpers.export(exports, "InputLabel", ()=>(0, _inputLabelDefault.default));
parcelHelpers.export(exports, "TextField", ()=>(0, _textFieldDefault.default));
parcelHelpers.export(exports, "TextareaAutosize", ()=>(0, _textareaAutosizeDefault.default));
parcelHelpers.export(exports, "InputUnstyled", ()=>(0, _inputBaseDefault.default));
parcelHelpers.export(exports, "InputAdornment", ()=>(0, _inputAdornmentDefault.default));
parcelHelpers.export(exports, "makeStyles", ()=>(0, _makeStylesDefault.default));
parcelHelpers.export(exports, "withStyles", ()=>(0, _withStylesDefault.default));
parcelHelpers.export(exports, "IconButton", ()=>(0, _iconButtonDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "ListItem", ()=>(0, _listItemDefault.default));
parcelHelpers.export(exports, "ListItemIcon", ()=>(0, _listItemIconDefault.default));
parcelHelpers.export(exports, "ListItemText", ()=>(0, _listItemTextDefault.default));
parcelHelpers.export(exports, "FormHelperText", ()=>(0, _formHelperTextDefault.default));
parcelHelpers.export(exports, "FormControl", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "OutlineInput", ()=>(0, _outlinedInputDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "LegacyThemeProvider", ()=>(0, _themeProviderDefault1.default));
parcelHelpers.export(exports, "useMediaQuery", ()=>(0, _useMediaQueryDefault.default));
parcelHelpers.export(exports, "FormControlLabel", ()=>(0, _formControlLabelDefault.default));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "TableBody", ()=>(0, _tableBodyDefault.default));
parcelHelpers.export(exports, "TableCell", ()=>(0, _tableCellDefault.default));
parcelHelpers.export(exports, "TableContainer", ()=>(0, _tableContainerDefault.default));
parcelHelpers.export(exports, "TableHead", ()=>(0, _tableHeadDefault.default));
parcelHelpers.export(exports, "TableRow", ()=>(0, _tableRowDefault.default));
parcelHelpers.export(exports, "TableSortLabel", ()=>(0, _tableSortLabelDefault.default));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "Tab", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "CircularProgress", ()=>(0, _circularProgressDefault.default));
parcelHelpers.export(exports, "ToggleButton", ()=>(0, _toggleButtonDefault.default));
parcelHelpers.export(exports, "ToggleButtonGroup", ()=>(0, _toggleButtonGroupDefault.default));
// Icons
parcelHelpers.export(exports, "FileDownloadIcon", ()=>(0, _fileDownloadDefault.default));
parcelHelpers.export(exports, "ErrorIcon", ()=>(0, _errorDefault.default));
parcelHelpers.export(exports, "ArrowDropDownIcon", ()=>(0, _arrowDropDownDefault.default));
parcelHelpers.export(exports, "AddIcon", ()=>(0, _addDefault.default));
parcelHelpers.export(exports, "CheckCircleIcon", ()=>(0, _checkCircleDefault.default));
parcelHelpers.export(exports, "CloseIcon", ()=>(0, _closeDefault.default));
parcelHelpers.export(exports, "AssignmentIndIcon", ()=>(0, _assignmentIndDefault.default));
parcelHelpers.export(exports, "AssignmentIcon", ()=>(0, _assignmentDefault.default));
parcelHelpers.export(exports, "AssignmentTurnedInIcon", ()=>(0, _assignmentTurnedInDefault.default));
parcelHelpers.export(exports, "KeyboardArrowDownIcon", ()=>(0, _keyboardArrowDownDefault.default));
parcelHelpers.export(exports, "ArrowForwardIosSharpIcon", ()=>(0, _arrowForwardIosSharpDefault.default));
parcelHelpers.export(exports, "CancelIcon", ()=>(0, _cancelDefault.default));
parcelHelpers.export(exports, "MoreVertIcon", ()=>(0, _moreVertDefault.default));
parcelHelpers.export(exports, "WarningIcon", ()=>(0, _warningDefault.default));
parcelHelpers.export(exports, "ArrowBackIosIcon", ()=>(0, _arrowBackIosDefault.default));
// Seems to fit better here
parcelHelpers.export(exports, "clsx", ()=>(0, _clsxDefault.default));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "LocalizationProvider", ()=>(0, _localizationProvider.LocalizationProvider));
parcelHelpers.export(exports, "MobileTimePicker", ()=>(0, _mobileTimePicker.MobileTimePicker));
parcelHelpers.export(exports, "AdapterDayjs", ()=>(0, _adapterDayjs.AdapterDayjs));
parcelHelpers.export(exports, "DatePicker", ()=>(0, _datePicker.DatePicker));
parcelHelpers.export(exports, "AccordionSummary", ()=>(0, _accordionSummaryDefault.default));
parcelHelpers.export(exports, "accordionSummaryClasses", ()=>(0, _accordionSummary.accordionSummaryClasses));
parcelHelpers.export(exports, "Accordion", ()=>(0, _accordionDefault.default));
parcelHelpers.export(exports, "AccordionDetails", ()=>(0, _accordionDetailsDefault.default));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngineProviderDefault.default));
parcelHelpers.export(exports, "FAIcon", ()=>FAIcon);
parcelHelpers.export(exports, "styled", ()=>(0, _styles.styled));
parcelHelpers.export(exports, "captureProps", ()=>captureProps);
parcelHelpers.export(exports, "styleAndCapture", ()=>styleAndCapture);
var _react = require("./react");
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _popover = require("@mui/material/Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _inputBase = require("@mui/material/InputBase/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _makeStyles = require("@mui/styles/makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
var _withStyles = require("@mui/styles/withStyles");
var _withStylesDefault = parcelHelpers.interopDefault(_withStyles);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _themeProvider = require("@mui/material/styles/ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _themeProvider1 = require("@mui/styles/ThemeProvider");
var _themeProviderDefault1 = parcelHelpers.interopDefault(_themeProvider1);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _toggleButton = require("@mui/material/ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
var _toggleButtonGroup = require("@mui/material/ToggleButtonGroup");
var _toggleButtonGroupDefault = parcelHelpers.interopDefault(_toggleButtonGroup);
var _fileDownload = require("@mui/icons-material/FileDownload");
var _fileDownloadDefault = parcelHelpers.interopDefault(_fileDownload);
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _arrowDropDown = require("@mui/icons-material/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _assignmentInd = require("@mui/icons-material/AssignmentInd");
var _assignmentIndDefault = parcelHelpers.interopDefault(_assignmentInd);
var _assignment = require("@mui/icons-material/Assignment");
var _assignmentDefault = parcelHelpers.interopDefault(_assignment);
var _assignmentTurnedIn = require("@mui/icons-material/AssignmentTurnedIn");
var _assignmentTurnedInDefault = parcelHelpers.interopDefault(_assignmentTurnedIn);
var _keyboardArrowDown = require("@mui/icons-material/KeyboardArrowDown");
var _keyboardArrowDownDefault = parcelHelpers.interopDefault(_keyboardArrowDown);
var _arrowForwardIosSharp = require("@mui/icons-material/ArrowForwardIosSharp");
var _arrowForwardIosSharpDefault = parcelHelpers.interopDefault(_arrowForwardIosSharp);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _warning = require("@mui/icons-material/Warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _arrowBackIos = require("@mui/icons-material/ArrowBackIos");
var _arrowBackIosDefault = parcelHelpers.interopDefault(_arrowBackIos);
// Font Awesome Icons
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styles = require("@mui/material/styles");
var _createTheme = require("@mui/material/styles/createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _useTheme = require("@mui/material/styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _localizationProvider = require("@mui/x-date-pickers/LocalizationProvider");
var _mobileTimePicker = require("@mui/x-date-pickers/MobileTimePicker");
var _adapterDayjs = require("@mui/x-date-pickers/AdapterDayjs");
var _datePicker = require("@mui/x-date-pickers/DatePicker");
var _accordionSummary = require("@mui/material/AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _accordion = require("@mui/material/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionDetails = require("@mui/material/AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _styledEngineProvider = require("@mui/material/StyledEngineProvider");
var _styledEngineProviderDefault = parcelHelpers.interopDefault(_styledEngineProvider);
const supportedIcons = {
    users: (0, _freeSolidSvgIcons.faUsers),
    arrow: (0, _freeSolidSvgIcons.faArrowAltCircleDown),
    trash: (0, _freeSolidSvgIcons.faTrashAlt),
    bars: (0, _freeSolidSvgIcons.faBars),
    questionCircle: (0, _freeSolidSvgIcons.faQuestionCircle)
};
const FAIcon = (props)=>{
    const icon = (0, _react.useMemo)(()=>supportedIcons[props.icon], [
        props.icon
    ]);
    return (0, _react.createElement)((0, _reactFontawesome.FontAwesomeIcon), {
        ...props,
        icon
    });
};
const captureProps = (...captured)=>(p)=>captured.indexOf(p) < 0;
const styleAndCapture = (Base, ...captured)=>(0, _styles.styled)(Base, {
        shouldForwardProp: captureProps(...captured)
    });

},{"./react":"k16GP","@mui/material/Typography":"2wCD5","@mui/material/Chip":"eSSCi","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","@mui/material/Button":"c6Y0y","@mui/material/Select":"aY7hn","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/material/Tooltip":"7bRLE","@mui/material/Popover":"keu0V","@mui/material/Fade":"8DwqP","@mui/material/Dialog":"255tO","@mui/material/DialogActions":"5WZHz","@mui/material/DialogContent":"gD0J9","@mui/material/DialogTitle":"5sOv1","@mui/material/InputLabel":"iTW3B","@mui/material/TextField":"amnzu","@mui/material/TextareaAutosize":"9RmQq","@mui/material/InputBase/InputBase":"aTW7W","@mui/material/InputAdornment":"jiJDh","@mui/styles/makeStyles":"hRYSM","@mui/styles/withStyles":"d8vct","@mui/material/IconButton":"bXjnZ","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/material/FormHelperText":"dlh9L","@mui/material/FormControl":"kkska","@mui/material/OutlinedInput":"8eUp2","@mui/material/styles/ThemeProvider":"1Q7kB","@mui/styles/ThemeProvider":"7Czu0","@mui/material/useMediaQuery":"bnRpi","@mui/material/FormControlLabel":"kemIW","@mui/material/Checkbox":"4sdMA","@mui/material/Table":"if4Vw","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/TableSortLabel":"3xCAT","@mui/material/Tabs":"g7Izf","@mui/material/Tab":"bmkB3","@mui/material/CircularProgress":"bK4ky","@mui/material/ToggleButton":"65CNe","@mui/material/ToggleButtonGroup":"hVYCj","@mui/icons-material/FileDownload":"9m7kY","@mui/icons-material/Error":"4XfdO","@mui/icons-material/ArrowDropDown":"6qreH","@mui/icons-material/Add":"jrNj7","@mui/icons-material/CheckCircle":"crtKq","@mui/icons-material/Close":"acjz6","@mui/icons-material/AssignmentInd":"hh96o","@mui/icons-material/Assignment":"jpADq","@mui/icons-material/AssignmentTurnedIn":"fYcXS","@mui/icons-material/KeyboardArrowDown":"2TA6B","@mui/icons-material/ArrowForwardIosSharp":"7NhqT","@mui/icons-material/Cancel":"lMa52","@mui/icons-material/MoreVert":"22WtH","@mui/icons-material/Warning":"eRDc8","@mui/icons-material/ArrowBackIos":"hgoLH","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","clsx":"5PNR8","@mui/material/styles":"c9RfU","@mui/material/styles/createTheme":"itHnG","@mui/material/styles/useTheme":"d8hfc","@mui/x-date-pickers/LocalizationProvider":"liXbF","@mui/x-date-pickers/MobileTimePicker":"1cvBy","@mui/x-date-pickers/AdapterDayjs":"533c4","@mui/x-date-pickers/DatePicker":"b2Tgt","@mui/material/AccordionSummary":"ggBKJ","@mui/material/Accordion":"lkcQj","@mui/material/AccordionDetails":"96rKf","@mui/material/StyledEngineProvider":"7lWUt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wCD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "typographyClasses", ()=>(0, _typographyClassesDefault.default));
var _typography = require("./Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _typographyClasses = require("./typographyClasses");
var _typographyClassesDefault = parcelHelpers.interopDefault(_typographyClasses);
parcelHelpers.exportAll(_typographyClasses, exports);
'use client';

},{"./Typography":"7vbx5","./typographyClasses":"7JIT0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vbx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypographyRoot", ()=>TypographyRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _typographyClasses = require("./typographyClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const useUtilityClasses = (ownerState)=>{
    const { align, gutterBottom, noWrap, paragraph, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, _capitalizeDefault.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _typographyClasses.getTypographyUtilityClass), classes);
};
const TypographyRoot = (0, _styledDefault.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, _capitalizeDefault.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const transformDeprecatedColors = (color)=>{
    return colorTransformations[color] || color;
};
const Typography = /*#__PURE__*/ _react.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = transformDeprecatedColors(themeProps.color);
    const props = (0, _styleFunctionSx.extendSxProp)((0, _extendsDefault.default)({}, themeProps, {
        color
    }));
    const { align = 'inherit', className, component, gutterBottom = false, noWrap = false, paragraph = false, variant = 'body1', variantMapping = defaultVariantMapping } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        align,
        color,
        className,
        component,
        gutterBottom,
        noWrap,
        paragraph,
        variant,
        variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TypographyRoot, (0, _extendsDefault.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other));
});
exports.default = Typography;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/system/styleFunctionSx":"8WdLC","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../utils/capitalize":"hBZko","./typographyClasses":"7JIT0","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bK0Bf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WdLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styleFunctionSxDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSx.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "extendSxProp", ()=>(0, _extendSxPropDefault.default));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _defaultSxConfigDefault.default));
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _extendSxProp = require("./extendSxProp");
var _extendSxPropDefault = parcelHelpers.interopDefault(_extendSxProp);
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);

},{"./styleFunctionSx":"euRW0","./extendSxProp":"hiZgb","./defaultSxConfig":"h1zF1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"euRW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>unstable_createStyleFunctionSx);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _merge = require("../merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _style = require("../style");
var _breakpoints = require("../breakpoints");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
function objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty = prop, themeKey, transform, style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, _style.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, _style.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, _style.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx, theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, _defaultSxConfigDefault.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, _breakpoints.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, _breakpoints.handleBreakpoints)({
                                theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if (objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme
                            });
                            else css = (0, _mergeDefault.default)(css, breakpointsValues);
                        }
                    } else css = (0, _mergeDefault.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
    'sx'
];
exports.default = styleFunctionSx;

},{"@mui/utils/capitalize":"fRCPT","../merge":"fym7I","../style":"Z23Pf","../breakpoints":"9gmyo","./defaultSxConfig":"h1zF1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fRCPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _capitalizeDefault.default));
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);

},{"./capitalize":"kOfzx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOfzx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>capitalize);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, _formatMuiErrorMessageDefault.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

},{"@mui/utils/formatMuiErrorMessage":"awvJV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"awvJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formatMuiErrorMessageDefault.default));
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);

},{"./formatMuiErrorMessage":"6KFfh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6KFfh":[function(require,module,exports,__globalThis) {
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatMuiErrorMessage);
function formatMuiErrorMessage(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fym7I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
function merge(acc, item) {
    if (!item) return acc;
    return (0, _deepmergeDefault.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
exports.default = merge;

},{"@mui/utils/deepmerge":"aRydR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRydR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _deepmergeDefault.default));
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
parcelHelpers.exportAll(_deepmerge, exports);

},{"./deepmerge":"95Gem","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"95Gem":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "default", ()=>deepmerge);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
function isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
    if (/*#__PURE__*/ _react.isValidElement(source) || !isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = deepClone(source[key]);
    });
    return output;
}
function deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, _extendsDefault.default)({}, target) : target;
    if (isPlainObject(target) && isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ _react.isValidElement(source[key])) output[key] = source[key];
        else if (isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Z23Pf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "getStyleValue", ()=>getStyleValue);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
function getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function style(options) {
    const { prop, cssProperty = options.prop, themeKey, transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalizeDefault.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
exports.default = style;

},{"@mui/utils/capitalize":"fRCPT","./responsivePropType":"9Bauz","./breakpoints":"9gmyo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Bauz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const responsivePropType = {};
exports.default = responsivePropType;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gmyo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "values", ()=>values);
parcelHelpers.export(exports, "handleBreakpoints", ()=>handleBreakpoints);
parcelHelpers.export(exports, "createEmptyBreakpointObject", ()=>createEmptyBreakpointObject);
parcelHelpers.export(exports, "removeUnusedBreakpoints", ()=>removeUnusedBreakpoints);
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>mergeBreakpointsInOrder);
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
parcelHelpers.export(exports, "computeBreakpointsBase", ()=>computeBreakpointsBase);
parcelHelpers.export(exports, "resolveBreakpointValues", ()=>resolveBreakpointValues);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
const values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, _extendsDefault.default)({
                    theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, _mergeDefault.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, _deepmergeDefault.default)(prev, next), {});
    return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
exports.default = breakpoints;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","prop-types":"bnNSm","@mui/utils/deepmerge":"aRydR","./merge":"fym7I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h1zF1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _spacing = require("../spacing");
var _borders = require("../borders");
var _cssGrid = require("../cssGrid");
var _palette = require("../palette");
var _sizing = require("../sizing");
const defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, _borders.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, _borders.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, _palette.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, _palette.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, _palette.paletteTransform)
    },
    // spacing
    p: {
        style: (0, _spacing.padding)
    },
    pt: {
        style: (0, _spacing.padding)
    },
    pr: {
        style: (0, _spacing.padding)
    },
    pb: {
        style: (0, _spacing.padding)
    },
    pl: {
        style: (0, _spacing.padding)
    },
    px: {
        style: (0, _spacing.padding)
    },
    py: {
        style: (0, _spacing.padding)
    },
    padding: {
        style: (0, _spacing.padding)
    },
    paddingTop: {
        style: (0, _spacing.padding)
    },
    paddingRight: {
        style: (0, _spacing.padding)
    },
    paddingBottom: {
        style: (0, _spacing.padding)
    },
    paddingLeft: {
        style: (0, _spacing.padding)
    },
    paddingX: {
        style: (0, _spacing.padding)
    },
    paddingY: {
        style: (0, _spacing.padding)
    },
    paddingInline: {
        style: (0, _spacing.padding)
    },
    paddingInlineStart: {
        style: (0, _spacing.padding)
    },
    paddingInlineEnd: {
        style: (0, _spacing.padding)
    },
    paddingBlock: {
        style: (0, _spacing.padding)
    },
    paddingBlockStart: {
        style: (0, _spacing.padding)
    },
    paddingBlockEnd: {
        style: (0, _spacing.padding)
    },
    m: {
        style: (0, _spacing.margin)
    },
    mt: {
        style: (0, _spacing.margin)
    },
    mr: {
        style: (0, _spacing.margin)
    },
    mb: {
        style: (0, _spacing.margin)
    },
    ml: {
        style: (0, _spacing.margin)
    },
    mx: {
        style: (0, _spacing.margin)
    },
    my: {
        style: (0, _spacing.margin)
    },
    margin: {
        style: (0, _spacing.margin)
    },
    marginTop: {
        style: (0, _spacing.margin)
    },
    marginRight: {
        style: (0, _spacing.margin)
    },
    marginBottom: {
        style: (0, _spacing.margin)
    },
    marginLeft: {
        style: (0, _spacing.margin)
    },
    marginX: {
        style: (0, _spacing.margin)
    },
    marginY: {
        style: (0, _spacing.margin)
    },
    marginInline: {
        style: (0, _spacing.margin)
    },
    marginInlineStart: {
        style: (0, _spacing.margin)
    },
    marginInlineEnd: {
        style: (0, _spacing.margin)
    },
    marginBlock: {
        style: (0, _spacing.margin)
    },
    marginBlockStart: {
        style: (0, _spacing.margin)
    },
    marginBlockEnd: {
        style: (0, _spacing.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, _cssGrid.gap)
    },
    rowGap: {
        style: (0, _cssGrid.rowGap)
    },
    columnGap: {
        style: (0, _cssGrid.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, _sizing.sizingTransform)
    },
    maxWidth: {
        style: (0, _sizing.maxWidth)
    },
    minWidth: {
        transform: (0, _sizing.sizingTransform)
    },
    height: {
        transform: (0, _sizing.sizingTransform)
    },
    maxHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    minHeight: {
        transform: (0, _sizing.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
exports.default = defaultSxConfig;

},{"../spacing":"9oZxj","../borders":"l3mou","../cssGrid":"Rwarv","../palette":"aKlKA","../sizing":"fc3GT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9oZxj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "marginKeys", ()=>marginKeys);
parcelHelpers.export(exports, "paddingKeys", ()=>paddingKeys);
parcelHelpers.export(exports, "createUnaryUnit", ()=>createUnaryUnit);
parcelHelpers.export(exports, "createUnarySpacing", ()=>createUnarySpacing);
parcelHelpers.export(exports, "getValue", ()=>getValue);
parcelHelpers.export(exports, "getStyleFromPropValue", ()=>getStyleFromPropValue);
parcelHelpers.export(exports, "margin", ()=>margin);
parcelHelpers.export(exports, "padding", ()=>padding);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _breakpoints = require("./breakpoints");
var _style = require("./style");
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _memoize = require("./memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
const properties = {
    m: 'margin',
    p: 'padding'
};
const directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoizeDefault.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if (aliases[prop]) prop = aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = properties[a];
    const direction = directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const spacingKeys = [
    ...marginKeys,
    ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, _style.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function createUnarySpacing(theme) {
    return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = getValue(transformer, propValue);
            return acc;
        }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style(props, keys) {
    const transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>resolveCssProperty(props, keys, prop, transformer)).reduce((0, _mergeDefault.default), {});
}
function margin(props) {
    return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
    return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function spacing(props) {
    return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
exports.default = spacing;

},{"./responsivePropType":"9Bauz","./breakpoints":"9gmyo","./style":"Z23Pf","./merge":"fym7I","./memoize":"1cRXY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cRXY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l3mou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "borderTransform", ()=>borderTransform);
parcelHelpers.export(exports, "border", ()=>border);
parcelHelpers.export(exports, "borderTop", ()=>borderTop);
parcelHelpers.export(exports, "borderRight", ()=>borderRight);
parcelHelpers.export(exports, "borderBottom", ()=>borderBottom);
parcelHelpers.export(exports, "borderLeft", ()=>borderLeft);
parcelHelpers.export(exports, "borderColor", ()=>borderColor);
parcelHelpers.export(exports, "borderTopColor", ()=>borderTopColor);
parcelHelpers.export(exports, "borderRightColor", ()=>borderRightColor);
parcelHelpers.export(exports, "borderBottomColor", ()=>borderBottomColor);
parcelHelpers.export(exports, "borderLeftColor", ()=>borderLeftColor);
parcelHelpers.export(exports, "outline", ()=>outline);
parcelHelpers.export(exports, "outlineColor", ()=>outlineColor);
parcelHelpers.export(exports, "borderRadius", ()=>borderRadius);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
function borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
    return (0, _styleDefault.default)({
        prop,
        themeKey: 'borders',
        transform
    });
}
const border = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');
const borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = [
    'borderRadius'
];
const borders = (0, _composeDefault.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
exports.default = borders;

},{"./responsivePropType":"9Bauz","./style":"Z23Pf","./compose":"6XzLJ","./spacing":"9oZxj","./breakpoints":"9gmyo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XzLJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
function compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, _mergeDefault.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
exports.default = compose;

},{"./merge":"fym7I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Rwarv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gap", ()=>gap);
parcelHelpers.export(exports, "columnGap", ()=>columnGap);
parcelHelpers.export(exports, "rowGap", ()=>rowGap);
parcelHelpers.export(exports, "gridColumn", ()=>gridColumn);
parcelHelpers.export(exports, "gridRow", ()=>gridRow);
parcelHelpers.export(exports, "gridAutoFlow", ()=>gridAutoFlow);
parcelHelpers.export(exports, "gridAutoColumns", ()=>gridAutoColumns);
parcelHelpers.export(exports, "gridAutoRows", ()=>gridAutoRows);
parcelHelpers.export(exports, "gridTemplateColumns", ()=>gridTemplateColumns);
parcelHelpers.export(exports, "gridTemplateRows", ()=>gridTemplateRows);
parcelHelpers.export(exports, "gridTemplateAreas", ()=>gridTemplateAreas);
parcelHelpers.export(exports, "gridArea", ()=>gridArea);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _spacing = require("./spacing");
var _breakpoints = require("./breakpoints");
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
const gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
gap.propTypes = {};
gap.filterProps = [
    'gap'
];
const columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
columnGap.propTypes = {};
columnGap.filterProps = [
    'columnGap'
];
const rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
rowGap.propTypes = {};
rowGap.filterProps = [
    'rowGap'
];
const gridColumn = (0, _styleDefault.default)({
    prop: 'gridColumn'
});
const gridRow = (0, _styleDefault.default)({
    prop: 'gridRow'
});
const gridAutoFlow = (0, _styleDefault.default)({
    prop: 'gridAutoFlow'
});
const gridAutoColumns = (0, _styleDefault.default)({
    prop: 'gridAutoColumns'
});
const gridAutoRows = (0, _styleDefault.default)({
    prop: 'gridAutoRows'
});
const gridTemplateColumns = (0, _styleDefault.default)({
    prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0, _styleDefault.default)({
    prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0, _styleDefault.default)({
    prop: 'gridTemplateAreas'
});
const gridArea = (0, _styleDefault.default)({
    prop: 'gridArea'
});
const grid = (0, _composeDefault.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
exports.default = grid;

},{"./style":"Z23Pf","./compose":"6XzLJ","./spacing":"9oZxj","./breakpoints":"9gmyo","./responsivePropType":"9Bauz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKlKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paletteTransform", ()=>paletteTransform);
parcelHelpers.export(exports, "color", ()=>color);
parcelHelpers.export(exports, "bgcolor", ()=>bgcolor);
parcelHelpers.export(exports, "backgroundColor", ()=>backgroundColor);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
function paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const color = (0, _styleDefault.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: paletteTransform
});
const bgcolor = (0, _styleDefault.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const backgroundColor = (0, _styleDefault.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const palette = (0, _composeDefault.default)(color, bgcolor, backgroundColor);
exports.default = palette;

},{"./style":"Z23Pf","./compose":"6XzLJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fc3GT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sizingTransform", ()=>sizingTransform);
parcelHelpers.export(exports, "width", ()=>width);
parcelHelpers.export(exports, "maxWidth", ()=>maxWidth);
parcelHelpers.export(exports, "minWidth", ()=>minWidth);
parcelHelpers.export(exports, "height", ()=>height);
parcelHelpers.export(exports, "maxHeight", ()=>maxHeight);
parcelHelpers.export(exports, "minHeight", ()=>minHeight);
parcelHelpers.export(exports, "sizeWidth", ()=>sizeWidth);
parcelHelpers.export(exports, "sizeHeight", ()=>sizeHeight);
parcelHelpers.export(exports, "boxSizing", ()=>boxSizing);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _breakpoints = require("./breakpoints");
function sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0, _styleDefault.default)({
    prop: 'width',
    transform: sizingTransform
});
const maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, _breakpoints.values)[propValue];
            if (!breakpoint) return {
                maxWidth: sizingTransform(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
maxWidth.filterProps = [
    'maxWidth'
];
const minWidth = (0, _styleDefault.default)({
    prop: 'minWidth',
    transform: sizingTransform
});
const height = (0, _styleDefault.default)({
    prop: 'height',
    transform: sizingTransform
});
const maxHeight = (0, _styleDefault.default)({
    prop: 'maxHeight',
    transform: sizingTransform
});
const minHeight = (0, _styleDefault.default)({
    prop: 'minHeight',
    transform: sizingTransform
});
const sizeWidth = (0, _styleDefault.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: sizingTransform
});
const sizeHeight = (0, _styleDefault.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: sizingTransform
});
const boxSizing = (0, _styleDefault.default)({
    prop: 'boxSizing'
});
const sizing = (0, _composeDefault.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
exports.default = sizing;

},{"./style":"Z23Pf","./compose":"6XzLJ","./breakpoints":"9gmyo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hiZgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extendSxProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _defaultSxConfig = require("./defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
const _excluded = [
    "sx"
];
const splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, _defaultSxConfigDefault.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function extendSxProp(props) {
    const { sx: inSx } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { systemProps, otherProps } = splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, _deepmerge.isPlainObject)(result)) return systemProps;
        return (0, _extendsDefault.default)({}, systemProps, result);
    };
    else finalSx = (0, _extendsDefault.default)({}, systemProps, inSx);
    return (0, _extendsDefault.default)({}, otherProps, {
        sx: finalSx
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/deepmerge":"aRydR","./defaultSxConfig":"h1zF1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43D21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _composeClassesDefault.default));
var _composeClasses = require("./composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);

},{"./composeClasses":"30zYV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"30zYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeClasses);
function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bTnxF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slotShouldForwardProp", ()=>(0, _slotShouldForwardPropDefault.default));
parcelHelpers.export(exports, "rootShouldForwardProp", ()=>(0, _rootShouldForwardPropDefault.default));
var _createStyled = require("@mui/system/createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _rootShouldForwardProp = require("./rootShouldForwardProp");
var _rootShouldForwardPropDefault = parcelHelpers.interopDefault(_rootShouldForwardProp);
var _slotShouldForwardProp = require("./slotShouldForwardProp");
var _slotShouldForwardPropDefault = parcelHelpers.interopDefault(_slotShouldForwardProp);
'use client';
const styled = (0, _createStyledDefault.default)({
    themeId: (0, _identifierDefault.default),
    defaultTheme: (0, _defaultThemeDefault.default),
    rootShouldForwardProp: (0, _rootShouldForwardPropDefault.default)
});
exports.default = styled;

},{"@mui/system/createStyled":"de5eV","./defaultTheme":"gDdTD","./identifier":"asvw3","./rootShouldForwardProp":"dIcrQ","./slotShouldForwardProp":"arfz9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"de5eV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("319bf29b1ac021db");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStyled;
exports.shouldForwardProp = shouldForwardProp;
exports.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault(require("5f787551b23dbda"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("de4eed3c4e85da99"));
var _styledEngine = _interopRequireWildcard(require("3aec34a436d2a882"));
var _deepmerge = require("3a46c9f49624428c");
var _capitalize = _interopRequireDefault(require("ac13265501085469"));
var _getDisplayName = _interopRequireDefault(require("1d716735a4cd420b"));
var _createTheme = _interopRequireDefault(require("ac214b19a20b198f"));
var _styleFunctionSx = _interopRequireDefault(require("ca2ff8dfa6778918"));
const _excluded = [
    "ownerState"
], _excluded2 = [
    "variants"
], _excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = exports.systemDefaultTheme = (0, _createTheme.default)();
const lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({ defaultTheme, theme, themeId }) {
    return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function processStyleArg(callableStyle, _ref) {
    let { ownerState } = _ref, props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, _extends2.default)({
        ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>processStyleArg(resolvedStyle, (0, _extends2.default)({
            ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants = [] } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLoose2.default)(resolvedStylesArg, _excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, _extends2.default)({
                ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, _extends2.default)({
                    ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
            theme: resolveTheme((0, _extends2.default)({}, props, {
                defaultTheme,
                themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngine.default)(tag, (0, _extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) return (props)=>processStyleArg(stylesArg, (0, _extends2.default)({}, props, {
                    theme: resolveTheme({
                        theme: props.theme,
                        defaultTheme,
                        themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = resolveTheme((0, _extends2.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extends2.default)({}, props, {
                        theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = resolveTheme((0, _extends2.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return processStyleArg({
                    variants: themeVariants
                }, (0, _extends2.default)({}, props, {
                    theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

},{"319bf29b1ac021db":"kZ6eK","5f787551b23dbda":"ktcBy","de4eed3c4e85da99":"imPRm","3aec34a436d2a882":"4hxt2","3a46c9f49624428c":"aRydR","ac13265501085469":"fRCPT","1d716735a4cd420b":"duLzC","ac214b19a20b198f":"2h77y","ca2ff8dfa6778918":"8WdLC"}],"kZ6eK":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"4hxt2":[function(require,module,exports,__globalThis) {
/**
 * @mui/styled-engine v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _react.ThemeContext));
parcelHelpers.export(exports, "keyframes", ()=>(0, _react.keyframes));
parcelHelpers.export(exports, "css", ()=>(0, _react.css));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngineProviderDefault.default));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "default", ()=>styled);
parcelHelpers.export(exports, "internal_processStyles", ()=>internal_processStyles);
/* eslint-disable no-underscore-dangle */ var _styled = require("@emotion/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _react = require("@emotion/react");
var _styledEngineProvider = require("./StyledEngineProvider");
var _styledEngineProviderDefault = parcelHelpers.interopDefault(_styledEngineProvider);
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
'use client';
function styled(tag, options) {
    const stylesFactory = (0, _styledDefault.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const internal_processStyles = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

},{"@emotion/styled":"3YoOh","@emotion/react":"lIeII","./StyledEngineProvider":"e5aRY","./GlobalStyles":"bWBFO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3YoOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newStyled);
var _emotionStyledBaseEsmJs = require("../base/dist/emotion-styled-base.esm.js");
var _emotionStyledBaseEsmJsDefault = parcelHelpers.interopDefault(_emotionStyledBaseEsmJs);
var _extends = require("@babel/runtime/helpers/extends");
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var newStyled = (0, _emotionStyledBaseEsmJsDefault.default).bind(null);
tags.forEach(function(tagName) {
    newStyled[tagName] = newStyled(tagName);
});

},{"../base/dist/emotion-styled-base.esm.js":"8MyFy","@babel/runtime/helpers/extends":"ktcBy","@emotion/react":"lIeII","@emotion/serialize":"6P7Gu","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@emotion/utils":"du4W1","react":"9njXz","@emotion/is-prop-valid":"hCPdT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MyFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("@emotion/react");
var _serialize = require("@emotion/serialize");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _utils = require("@emotion/utils");
var _react1 = require("react");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var isBrowser = typeof document !== 'undefined';
var isDevelopment = false;
var testOmitPropsOnStringTag = (0, _isPropValidDefault.default);
var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, _utils.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, _utils.insertStyles)(cache, serialized, isStringTag);
    });
    if (!isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ _react1.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var createStyled = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, _react.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react1.useContext((0, _react.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, _utils.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, _serialize.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ _react1.createElement(_react1.Fragment, null, /*#__PURE__*/ _react1.createElement(Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ _react1.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, _extendsDefault.default)({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@emotion/react":"lIeII","@emotion/serialize":"6P7Gu","@emotion/use-insertion-effect-with-fallbacks":"kt8pI","@emotion/utils":"du4W1","react":"9njXz","@emotion/is-prop-valid":"hCPdT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hCPdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"fCpYs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e5aRY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styledEngineProviderDefault.default));
var _styledEngineProvider = require("./StyledEngineProvider");
var _styledEngineProviderDefault = parcelHelpers.interopDefault(_styledEngineProvider);
'use client';

},{"./StyledEngineProvider":"hWoIw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hWoIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StyledEngineProvider);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _cache = require("@emotion/cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.
var _jsxRuntime = require("react/jsx-runtime");
'use client';
let cache;
if (typeof document === 'object') cache = (0, _cacheDefault.default)({
    key: 'css',
    prepend: true
});
function StyledEngineProvider(props) {
    const { injectFirst, children } = props;
    return injectFirst && cache ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.CacheProvider), {
        value: cache,
        children: children
    }) : children;
}

},{"react":"9njXz","prop-types":"bnNSm","@emotion/react":"lIeII","@emotion/cache":"r7hGp","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bWBFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
'use client';

},{"./GlobalStyles":"45xi6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45xi6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GlobalStyles);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react1 = require("@emotion/react");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
    const { styles, defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.Global), {
        styles: globalStyles
    });
}

},{"react":"9njXz","prop-types":"bnNSm","@emotion/react":"lIeII","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"duLzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getDisplayNameDefault.default));
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
parcelHelpers.exportAll(_getDisplayName, exports);

},{"./getDisplayName":"ixMWW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixMWW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFunctionName", ()=>getFunctionName);
parcelHelpers.export(exports, "default", ()=>getDisplayName);
var _reactIs = require("react-is");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
    const match = `${fn}`.match(fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
    const functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, _reactIs.ForwardRef:
            return getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, _reactIs.Memo:
            return getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

},{"react-is":"7MwU6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7MwU6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a620b46ed6d86cc0");

},{"a620b46ed6d86cc0":"4Bb1C"}],"4Bb1C":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"2h77y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "private_createBreakpoints", ()=>(0, _createBreakpointsDefault.default));
parcelHelpers.export(exports, "unstable_applyStyles", ()=>(0, _applyStylesDefault.default));
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);

},{"./createTheme":"1nbqq","./createBreakpoints":"fZK9u","./applyStyles":"6ryCn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1nbqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _createBreakpoints = require("./createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _shape = require("./shape");
var _shapeDefault = parcelHelpers.interopDefault(_shape);
var _createSpacing = require("./createSpacing");
var _createSpacingDefault = parcelHelpers.interopDefault(_createSpacing);
var _styleFunctionSx = require("../styleFunctionSx/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _defaultSxConfig = require("../styleFunctionSx/defaultSxConfig");
var _defaultSxConfigDefault = parcelHelpers.interopDefault(_defaultSxConfig);
var _applyStyles = require("./applyStyles");
var _applyStylesDefault = parcelHelpers.interopDefault(_applyStyles);
const _excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    const breakpoints = (0, _createBreakpointsDefault.default)(breakpointsInput);
    const spacing = (0, _createSpacingDefault.default)(spacingInput);
    let muiTheme = (0, _deepmergeDefault.default)({
        breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, _extendsDefault.default)({
            mode: 'light'
        }, paletteInput),
        spacing,
        shape: (0, _extendsDefault.default)({}, (0, _shapeDefault.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, _applyStylesDefault.default);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _defaultSxConfigDefault.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/deepmerge":"aRydR","./createBreakpoints":"fZK9u","./shape":"cIw7q","./createSpacing":"bfvQ9","../styleFunctionSx/styleFunctionSx":"euRW0","../styleFunctionSx/defaultSxConfig":"h1zF1","./applyStyles":"6ryCn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fZK9u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "breakpointKeys", ()=>breakpointKeys);
parcelHelpers.export(exports, "default", ()=>createBreakpoints);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "values",
    "unit",
    "step"
];
const breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, _extendsDefault.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function createBreakpoints(breakpoints) {
    const { // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit = 'px', step = 5 } = breakpoints, other = (0, _objectWithoutPropertiesLooseDefault.default)(breakpoints, _excluded);
    const sortedValues = sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, _extendsDefault.default)({
        keys,
        values: sortedValues,
        up,
        down,
        between,
        only,
        not,
        unit
    }, other);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIw7q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shape = {
    borderRadius: 4
};
exports.default = shape;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bfvQ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSpacing);
var _spacing = require("../spacing");
function createSpacing(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, _spacing.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

},{"../spacing":"9oZxj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ryCn":[function(require,module,exports,__globalThis) {
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>applyStyles);
function applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gDdTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
'use client';
const defaultTheme = (0, _createThemeDefault.default)();
exports.default = defaultTheme;

},{"./createTheme":"itHnG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"itHnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMuiTheme", ()=>createMuiTheme);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _createTheme = require("@mui/system/createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _createMixins = require("./createMixins");
var _createMixinsDefault = parcelHelpers.interopDefault(_createMixins);
var _createPalette = require("./createPalette");
var _createPaletteDefault = parcelHelpers.interopDefault(_createPalette);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _shadows = require("./shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _createTransitions = require("./createTransitions");
var _createTransitionsDefault = parcelHelpers.interopDefault(_createTransitions);
var _zIndex = require("./zIndex");
var _zIndexDefault = parcelHelpers.interopDefault(_zIndex);
const _excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    if (options.vars) throw new Error((0, _formatMuiErrorMessageDefault.default)(18));
    const palette = (0, _createPaletteDefault.default)(paletteInput);
    const systemTheme = (0, _createThemeDefault.default)(options);
    let muiTheme = (0, _deepmergeDefault.default)(systemTheme, {
        mixins: (0, _createMixinsDefault.default)(systemTheme.breakpoints, mixinsInput),
        palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, _shadowsDefault.default).slice(),
        typography: (0, _createTypographyDefault.default)(palette, typographyInput),
        transitions: (0, _createTransitionsDefault.default)(transitionsInput),
        zIndex: (0, _extendsDefault.default)({}, (0, _zIndexDefault.default))
    });
    muiTheme = (0, _deepmergeDefault.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _styleFunctionSx.unstable_defaultSxConfig), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let warnedOnce = false;
function createMuiTheme(...args) {
    return createTheme(...args);
}
exports.default = createTheme;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/formatMuiErrorMessage":"awvJV","@mui/utils/deepmerge":"aRydR","@mui/system/styleFunctionSx":"8WdLC","@mui/system/createTheme":"2h77y","@mui/utils/generateUtilityClass":"ktE5h","./createMixins":"dprtV","./createPalette":"aVFYX","./createTypography":"byLfw","./shadows":"5byGs","./createTransitions":"4xJuz","./zIndex":"eqp2B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktE5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _generateUtilityClassDefault.default));
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);

},{"./generateUtilityClass":"3rcOA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rcOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalStateClasses", ()=>globalStateClasses);
parcelHelpers.export(exports, "default", ()=>generateUtilityClass);
parcelHelpers.export(exports, "isGlobalState", ()=>isGlobalState);
var _classNameGenerator = require("../ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
const globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, _classNameGeneratorDefault.default).generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
    return globalStateClasses[slot] !== undefined;
}

},{"../ClassNameGenerator":"eZky1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eZky1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _classNameGeneratorDefault.default));
var _classNameGenerator = require("./ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);

},{"./ClassNameGenerator":"anDMV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"anDMV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator = createClassNameGenerator();
exports.default = ClassNameGenerator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dprtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createMixins);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function createMixins(breakpoints, mixins) {
    return (0, _extendsDefault.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aVFYX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "light", ()=>light);
parcelHelpers.export(exports, "dark", ()=>dark);
parcelHelpers.export(exports, "default", ()=>createPalette);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _colorManipulator = require("@mui/system/colorManipulator");
var _common = require("../colors/common");
var _commonDefault = parcelHelpers.interopDefault(_common);
var _grey = require("../colors/grey");
var _greyDefault = parcelHelpers.interopDefault(_grey);
var _purple = require("../colors/purple");
var _purpleDefault = parcelHelpers.interopDefault(_purple);
var _red = require("../colors/red");
var _redDefault = parcelHelpers.interopDefault(_red);
var _orange = require("../colors/orange");
var _orangeDefault = parcelHelpers.interopDefault(_orange);
var _blue = require("../colors/blue");
var _blueDefault = parcelHelpers.interopDefault(_blue);
var _lightBlue = require("../colors/lightBlue");
var _lightBlueDefault = parcelHelpers.interopDefault(_lightBlue);
var _green = require("../colors/green");
var _greenDefault = parcelHelpers.interopDefault(_green);
const _excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const light = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, _commonDefault.default).white,
        default: (0, _commonDefault.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const dark = {
    text: {
        primary: (0, _commonDefault.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, _commonDefault.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffsetDark);
    }
}
function getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _blueDefault.default)[200],
        light: (0, _blueDefault.default)[50],
        dark: (0, _blueDefault.default)[400]
    };
    return {
        main: (0, _blueDefault.default)[700],
        light: (0, _blueDefault.default)[400],
        dark: (0, _blueDefault.default)[800]
    };
}
function getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _purpleDefault.default)[200],
        light: (0, _purpleDefault.default)[50],
        dark: (0, _purpleDefault.default)[400]
    };
    return {
        main: (0, _purpleDefault.default)[500],
        light: (0, _purpleDefault.default)[300],
        dark: (0, _purpleDefault.default)[700]
    };
}
function getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _redDefault.default)[500],
        light: (0, _redDefault.default)[300],
        dark: (0, _redDefault.default)[700]
    };
    return {
        main: (0, _redDefault.default)[700],
        light: (0, _redDefault.default)[400],
        dark: (0, _redDefault.default)[800]
    };
}
function getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _lightBlueDefault.default)[400],
        light: (0, _lightBlueDefault.default)[300],
        dark: (0, _lightBlueDefault.default)[700]
    };
    return {
        main: (0, _lightBlueDefault.default)[700],
        light: (0, _lightBlueDefault.default)[500],
        dark: (0, _lightBlueDefault.default)[900]
    };
}
function getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _greenDefault.default)[400],
        light: (0, _greenDefault.default)[300],
        dark: (0, _greenDefault.default)[700]
    };
    return {
        main: (0, _greenDefault.default)[800],
        light: (0, _greenDefault.default)[500],
        dark: (0, _greenDefault.default)[900]
    };
}
function getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, _orangeDefault.default)[400],
        light: (0, _orangeDefault.default)[300],
        dark: (0, _orangeDefault.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, _orangeDefault.default)[500],
        dark: (0, _orangeDefault.default)[900]
    };
}
function createPalette(palette) {
    const { mode = 'light', contrastThreshold = 3, tonalOffset = 0.2 } = palette, other = (0, _objectWithoutPropertiesLooseDefault.default)(palette, _excluded);
    const primary = palette.primary || getDefaultPrimary(mode);
    const secondary = palette.secondary || getDefaultSecondary(mode);
    const error = palette.error || getDefaultError(mode);
    const info = palette.info || getDefaultInfo(mode);
    const success = palette.success || getDefaultSuccess(mode);
    const warning = palette.warning || getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color, name, mainShade = 500, lightShade = 300, darkShade = 700 })=>{
        color = (0, _extendsDefault.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, _formatMuiErrorMessageDefault.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, _formatMuiErrorMessageDefault.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        addLightOrDark(color, 'light', lightShade, tonalOffset);
        addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark,
        light
    };
    const paletteOutput = (0, _deepmergeDefault.default)((0, _extendsDefault.default)({
        // A collection of common colors.
        common: (0, _extendsDefault.default)({}, (0, _commonDefault.default)),
        // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        (0, _greyDefault.default),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        // Generate a rich color object.
        augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/formatMuiErrorMessage":"awvJV","@mui/utils/deepmerge":"aRydR","@mui/system/colorManipulator":"dHYgR","../colors/common":"kNQfe","../colors/grey":"kAOPX","../colors/purple":"diL7Q","../colors/red":"hdlMU","../colors/orange":"kBlig","../colors/blue":"4VxbD","../colors/lightBlue":"bZYpg","../colors/green":"jwjip","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dHYgR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("da5dc2216aa1925e");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alpha = alpha;
exports.blend = blend;
exports.colorChannel = void 0;
exports.darken = darken;
exports.decomposeColor = decomposeColor;
exports.emphasize = emphasize;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.hexToRgb = hexToRgb;
exports.hslToRgb = hslToRgb;
exports.lighten = lighten;
exports.private_safeAlpha = private_safeAlpha;
exports.private_safeColorChannel = void 0;
exports.private_safeDarken = private_safeDarken;
exports.private_safeEmphasize = private_safeEmphasize;
exports.private_safeLighten = private_safeLighten;
exports.recomposeColor = recomposeColor;
exports.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault(require("3fd8f5d6f51e9ed6"));
var _clamp = _interopRequireDefault(require("c9fb216631dfcecb"));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return decomposeColor(hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, _formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, _formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
exports.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ exports.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

},{"da5dc2216aa1925e":"kZ6eK","3fd8f5d6f51e9ed6":"awvJV","c9fb216631dfcecb":"4daFJ"}],"4daFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _clampDefault.default));
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);

},{"./clamp":"l4ptt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4ptt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
exports.default = clamp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kNQfe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const common = {
    black: '#000',
    white: '#fff'
};
exports.default = common;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAOPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
exports.default = grey;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"diL7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
exports.default = purple;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hdlMU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
exports.default = red;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kBlig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
exports.default = orange;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4VxbD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
exports.default = blue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bZYpg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
exports.default = lightBlue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwjip":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
exports.default = green;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byLfw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createTypography);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
const _excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
    textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily = defaultFontFamily, // The default font size of the Material Specification.
    fontSize = 14, // px
    fontWeightLight = 300, fontWeightRegular = 400, fontWeightMedium = 500, fontWeightBold = 700, // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, _extendsDefault.default)({
            fontFamily,
            fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === defaultFontFamily ? {
            letterSpacing: `${round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, _deepmergeDefault.default)((0, _extendsDefault.default)({
        htmlFontSize,
        pxToRem,
        fontFamily,
        fontSize,
        fontWeightLight,
        fontWeightRegular,
        fontWeightMedium,
        fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/deepmerge":"aRydR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5byGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = [
    'none',
    createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
exports.default = shadows;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4xJuz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easing", ()=>easing);
parcelHelpers.export(exports, "duration", ()=>duration);
parcelHelpers.export(exports, "default", ()=>createTransitions);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const _excluded = [
    "duration",
    "easing",
    "delay"
];
const easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
    const mergedEasing = (0, _extendsDefault.default)({}, easing, inputTransitions.easing);
    const mergedDuration = (0, _extendsDefault.default)({}, duration, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay = 0 } = options, other = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
    };
    return (0, _extendsDefault.default)({
        getAutoHeightDuration,
        create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqp2B":[function(require,module,exports,__globalThis) {
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
exports.default = zIndex;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asvw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '$$material';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dIcrQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slotShouldForwardProp = require("./slotShouldForwardProp");
var _slotShouldForwardPropDefault = parcelHelpers.interopDefault(_slotShouldForwardProp);
const rootShouldForwardProp = (prop)=>(0, _slotShouldForwardPropDefault.default)(prop) && prop !== 'classes';
exports.default = rootShouldForwardProp;

},{"./slotShouldForwardProp":"arfz9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"arfz9":[function(require,module,exports,__globalThis) {
// copied from @mui/system/createStyled
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
exports.default = slotShouldForwardProp;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ff3VX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultPropsProviderDefault.default));
parcelHelpers.export(exports, "useDefaultProps", ()=>(0, _defaultPropsProvider.useDefaultProps));
var _defaultPropsProvider = require("./DefaultPropsProvider");
var _defaultPropsProviderDefault = parcelHelpers.interopDefault(_defaultPropsProvider);

},{"./DefaultPropsProvider":"1g0Hr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1g0Hr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDefaultProps", ()=>useDefaultProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _defaultPropsProvider = require("@mui/system/DefaultPropsProvider");
var _defaultPropsProviderDefault = parcelHelpers.interopDefault(_defaultPropsProvider);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _defaultPropsProviderDefault.default), (0, _extendsDefault.default)({}, props));
}
exports.default = DefaultPropsProvider;
function useDefaultProps(params) {
    return (0, _defaultPropsProvider.useDefaultProps)(params);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/system/DefaultPropsProvider":"j6h6T","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j6h6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _defaultPropsProviderDefault.default));
parcelHelpers.export(exports, "useDefaultProps", ()=>(0, _defaultPropsProvider.useDefaultProps));
var _defaultPropsProvider = require("./DefaultPropsProvider");
var _defaultPropsProviderDefault = parcelHelpers.interopDefault(_defaultPropsProvider);

},{"./DefaultPropsProvider":"iHmAB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iHmAB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDefaultProps", ()=>useDefaultProps);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const PropsContext = /*#__PURE__*/ _react.createContext(undefined);
function DefaultPropsProvider({ value, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropsContext.Provider, {
        value: value,
        children: children
    });
}
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, _resolvePropsDefault.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, _resolvePropsDefault.default)(config, props);
    return props;
}
function useDefaultProps({ props, name }) {
    const ctx = _react.useContext(PropsContext);
    return getThemeProps({
        props,
        name,
        theme: {
            components: ctx
        }
    });
}
exports.default = DefaultPropsProvider;

},{"react":"9njXz","prop-types":"bnNSm","@mui/utils/resolveProps":"gemxd","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gemxd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _resolvePropsDefault.default));
var _resolveProps = require("./resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);

},{"./resolveProps":"8Aerb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Aerb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>resolveProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function resolveProps(defaultProps, props) {
    const output = (0, _extendsDefault.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, _extendsDefault.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, _extendsDefault.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hBZko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
exports.default = (0, _capitalizeDefault.default);

},{"@mui/utils/capitalize":"fRCPT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7JIT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTypographyUtilityClass", ()=>getTypographyUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTypographyUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTypography', slot);
}
const typographyClasses = (0, _generateUtilityClassesDefault.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
exports.default = typographyClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kn9BC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _generateUtilityClassesDefault.default));
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);

},{"./generateUtilityClasses":"kox3N","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kox3N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generateUtilityClasses);
var _generateUtilityClass = require("../generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClassDefault.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

},{"../generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eSSCi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _chipDefault.default));
parcelHelpers.export(exports, "chipClasses", ()=>(0, _chipClassesDefault.default));
var _chip = require("./Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _chipClasses = require("./chipClasses");
var _chipClassesDefault = parcelHelpers.interopDefault(_chipClasses);
parcelHelpers.exportAll(_chipClasses, exports);
'use client';

},{"./Chip":"lDpp0","./chipClasses":"hzEJn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDpp0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _cancel = require("../internal/svg-icons/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _unsupportedProp = require("../utils/unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _chipClasses = require("./chipClasses");
var _chipClassesDefault = parcelHelpers.interopDefault(_chipClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, size, color, iconColor, onDelete, clickable, variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, _capitalizeDefault.default)(size)}`,
            `color${(0, _capitalizeDefault.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, _capitalizeDefault.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, _capitalizeDefault.default)(color)}`,
            `${variant}${(0, _capitalizeDefault.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, _capitalizeDefault.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, _capitalizeDefault.default)(size)}`,
            `avatarColor${(0, _capitalizeDefault.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, _capitalizeDefault.default)(size)}`,
            `iconColor${(0, _capitalizeDefault.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, _capitalizeDefault.default)(size)}`,
            `deleteIconColor${(0, _capitalizeDefault.default)(color)}`,
            `deleteIcon${(0, _capitalizeDefault.default)(variant)}Color${(0, _capitalizeDefault.default)(color)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _chipClasses.getChipUtilityClass), classes);
};
const ChipRoot = (0, _styledDefault.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { color, iconColor, clickable, onDelete, size, variant } = ownerState;
        return [
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles[`avatar${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).avatar}`]: styles[`avatarColor${(0, _capitalizeDefault.default)(color)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles[`icon${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).icon}`]: styles[`iconColor${(0, _capitalizeDefault.default)(iconColor)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIcon${(0, _capitalizeDefault.default)(size)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIconColor${(0, _capitalizeDefault.default)(color)}`]
            },
            {
                [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: styles[`deleteIcon${(0, _capitalizeDefault.default)(variant)}Color${(0, _capitalizeDefault.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, _capitalizeDefault.default)(size)}`],
            styles[`color${(0, _capitalizeDefault.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, _capitalizeDefault.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, _capitalizeDefault.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, _capitalizeDefault.default)(color)}`]
        ];
    }
})(({ theme, ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, _extendsDefault.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, _chipClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, _chipClassesDefault.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, _chipClassesDefault.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, _chipClassesDefault.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, _chipClassesDefault.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, _chipClassesDefault.default).icon}`]: (0, _extendsDefault.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, _extendsDefault.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: (0, _extendsDefault.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, _chipClassesDefault.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, _chipClassesDefault.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, _chipClassesDefault.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, _chipClassesDefault.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, _chipClassesDefault.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, _chipClassesDefault.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, _chipClassesDefault.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, _chipClassesDefault.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, _chipClassesDefault.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const ChipLabel = (0, _styledDefault.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, _capitalizeDefault.default)(size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const Chip = /*#__PURE__*/ _react.forwardRef(function Chip(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className, clickable: clickableProp, color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled = false, icon: iconProp, label, onClick, onDelete, onKeyDown, onKeyUp, size = 'medium', variant = 'filled', tabIndex, skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const chipRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, _buttonBaseDefault.default) : ComponentProp || 'div';
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        disabled,
        size,
        color,
        iconColor: /*#__PURE__*/ _react.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const moreProps = component === (0, _buttonBaseDefault.default) ? (0, _extendsDefault.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ _react.isValidElement(deleteIconProp) ? /*#__PURE__*/ _react.cloneElement(deleteIconProp, {
        className: (0, _clsxDefault.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
        className: (0, _clsxDefault.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ _react.isValidElement(avatarProp)) avatar = /*#__PURE__*/ _react.cloneElement(avatarProp, {
        className: (0, _clsxDefault.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ _react.isValidElement(iconProp)) icon = /*#__PURE__*/ _react.cloneElement(iconProp, {
        className: (0, _clsxDefault.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ChipRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ChipLabel, {
                className: (0, _clsxDefault.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
exports.default = Chip;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../internal/svg-icons/Cancel":"kdAWN","../utils/useForkRef":"cq8Sn","../utils/unsupportedProp":"lTxN8","../utils/capitalize":"hBZko","../ButtonBase":"ajcyv","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./chipClasses":"hzEJn","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kdAWN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1uMV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createSvgIcon);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _svgIcon = require("../SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
/**
 * Private module reserved for @mui packages.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
function createSvgIcon(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _svgIconDefault.default), (0, _extendsDefault.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, _svgIconDefault.default).muiName;
    return /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(Component));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../SvgIcon":"lkqfz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lkqfz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _svgIconDefault.default));
parcelHelpers.export(exports, "svgIconClasses", ()=>(0, _svgIconClassesDefault.default));
var _svgIcon = require("./SvgIcon");
var _svgIconDefault = parcelHelpers.interopDefault(_svgIcon);
var _svgIconClasses = require("./svgIconClasses");
var _svgIconClassesDefault = parcelHelpers.interopDefault(_svgIconClasses);
parcelHelpers.exportAll(_svgIconClasses, exports);
'use client';

},{"./SvgIcon":"gCFP8","./svgIconClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gCFP8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _svgIconClasses = require("./svgIconClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const useUtilityClasses = (ownerState)=>{
    const { color, fontSize, classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, _capitalizeDefault.default)(color)}`,
            `fontSize${(0, _capitalizeDefault.default)(fontSize)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _svgIconClasses.getSvgIconUtilityClass), classes);
};
const SvgIconRoot = (0, _styledDefault.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[`fontSize${(0, _capitalizeDefault.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const SvgIcon = /*#__PURE__*/ _react.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children, className, color = 'inherit', component = 'svg', fontSize = 'medium', htmlColor, inheritViewBox = false, titleAccess, viewBox = '0 0 24 24' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const hasSvgAsChild = /*#__PURE__*/ _react.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox,
        viewBox,
        hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SvgIconRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
SvgIcon.muiName = 'SvgIcon';
exports.default = SvgIcon;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../utils/capitalize":"hBZko","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./svgIconClasses":"5rRWg","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5rRWg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSvgIconUtilityClass", ()=>getSvgIconUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSvgIconUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiSvgIcon', slot);
}
const svgIconClasses = (0, _generateUtilityClassesDefault.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
exports.default = svgIconClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cq8Sn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
'use client';
exports.default = (0, _useForkRefDefault.default);

},{"@mui/utils/useForkRef":"gq6SY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gq6SY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useForkRefDefault.default));
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);

},{"./useForkRef":"8gMwv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gMwv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForkRef);
var _react = require("react");
var _setRef = require("../setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
'use client';
function useForkRef(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return _react.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, _setRefDefault.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

},{"react":"9njXz","../setRef":"fgdh8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgdh8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _setRefDefault.default));
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);

},{"./setRef":"8gAev","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gAev":[function(require,module,exports,__globalThis) {
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>setRef);
function setRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTxN8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unsupportedProp = require("@mui/utils/unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
exports.default = (0, _unsupportedPropDefault.default);

},{"@mui/utils/unsupportedProp":"jIwiP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jIwiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _unsupportedPropDefault.default));
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);

},{"./unsupportedProp":"c2GBb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c2GBb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>unsupportedProp);
function unsupportedProp(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ajcyv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonBaseDefault.default));
parcelHelpers.export(exports, "buttonBaseClasses", ()=>(0, _buttonBaseClassesDefault.default));
parcelHelpers.export(exports, "touchRippleClasses", ()=>(0, _touchRippleClassesDefault.default));
var _buttonBase = require("./ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _buttonBaseClasses = require("./buttonBaseClasses");
var _buttonBaseClassesDefault = parcelHelpers.interopDefault(_buttonBaseClasses);
parcelHelpers.exportAll(_buttonBaseClasses, exports);
var _touchRippleClasses = require("./touchRippleClasses");
var _touchRippleClassesDefault = parcelHelpers.interopDefault(_touchRippleClasses);
parcelHelpers.exportAll(_touchRippleClasses, exports);
'use client';

},{"./ButtonBase":"2xcyI","./buttonBaseClasses":"flxF9","./touchRippleClasses":"H6sp0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2xcyI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonBaseRoot", ()=>ButtonBaseRoot);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useIsFocusVisible = require("../utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _touchRipple = require("./TouchRipple");
var _touchRippleDefault = parcelHelpers.interopDefault(_touchRipple);
var _buttonBaseClasses = require("./buttonBaseClasses");
var _buttonBaseClassesDefault = parcelHelpers.interopDefault(_buttonBaseClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { disabled, focusVisible, focusVisibleClassName, classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _buttonBaseClasses.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const ButtonBaseRoot = (0, _styledDefault.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, _buttonBaseClassesDefault.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const ButtonBase = /*#__PURE__*/ _react.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action, centerRipple = false, children, className, component = 'button', disabled = false, disableRipple = false, disableTouchRipple = false, focusRipple = false, LinkComponent = 'a', onBlur, onClick, onContextMenu, onDragLeave, onFocus, onFocusVisible, onKeyDown, onKeyUp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, tabIndex = 0, TouchRippleProps, touchRippleRef, type } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const buttonRef = _react.useRef(null);
    const rippleRef = _react.useRef(null);
    const handleRippleRef = (0, _useForkRefDefault.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, _useIsFocusVisibleDefault.default)();
    const [focusVisible, setFocusVisible] = _react.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    _react.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = _react.useState(false);
    _react.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    _react.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, _useEventCallbackDefault.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, _useEventCallbackDefault.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = _react.useRef(false);
    const handleKeyDown = (0, _useEventCallbackDefault.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, _useEventCallbackDefault.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, _useForkRefDefault.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        centerRipple,
        component,
        disabled,
        disableRipple,
        disableTouchRipple,
        focusRipple,
        tabIndex,
        focusVisible
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonBaseRoot, (0, _extendsDefault.default)({
        as: ComponentProp,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, _jsxRuntime.jsx)((0, _touchRippleDefault.default), (0, _extendsDefault.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
exports.default = ButtonBase;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/refType":"7a8uL","@mui/utils/elementTypeAcceptingRef":"gpPr5","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../utils/useForkRef":"cq8Sn","../utils/useEventCallback":"jTtn3","../utils/useIsFocusVisible":"fK0On","./TouchRipple":"9I8Ri","./buttonBaseClasses":"flxF9","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7a8uL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _refTypeDefault.default));
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);

},{"./refType":"euMyY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"euMyY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
const refType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).func,
    (0, _propTypesDefault.default).object
]);
exports.default = refType;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gpPr5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _elementTypeAcceptingRefDefault.default));
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);

},{"./elementTypeAcceptingRef":"1srdH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1srdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
exports.default = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).elementType, elementTypeAcceptingRef);

},{"prop-types":"bnNSm","../chainPropTypes":"83tGg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"83tGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _chainPropTypesDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);

},{"./chainPropTypes":"eIKfT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eIKfT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>chainPropTypes);
function chainPropTypes(propType1, propType2) {
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jTtn3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEventCallback = require("@mui/utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
'use client';
exports.default = (0, _useEventCallbackDefault.default);

},{"@mui/utils/useEventCallback":"ee70R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ee70R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useEventCallbackDefault.default));
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);

},{"./useEventCallback":"lgGiE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lgGiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEnhancedEffect = require("../useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function useEventCallback(fn) {
    const ref = _react.useRef(fn);
    (0, _useEnhancedEffectDefault.default)(()=>{
        ref.current = fn;
    });
    return _react.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
exports.default = useEventCallback;

},{"react":"9njXz","../useEnhancedEffect":"9v0Mw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9v0Mw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useEnhancedEffectDefault.default));
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);

},{"./useEnhancedEffect":"jF7Da","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jF7Da":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const useEnhancedEffect = typeof window !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
exports.default = useEnhancedEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fK0On":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useIsFocusVisible = require("@mui/utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
'use client';
exports.default = (0, _useIsFocusVisibleDefault.default);

},{"@mui/utils/useIsFocusVisible":"e1xVB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e1xVB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useIsFocusVisibleDefault.default));
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
parcelHelpers.exportAll(_useIsFocusVisible, exports);

},{"./useIsFocusVisible":"cLu8m","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cLu8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "teardown", ()=>teardown);
parcelHelpers.export(exports, "default", ()=>useIsFocusVisible);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var _react = require("react");
var _useTimeout = require("../useTimeout/useTimeout");
'use client';
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
const hadFocusVisibleRecentlyTimeout = new (0, _useTimeout.Timeout)();
const inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function focusTriggersKeyboardModality(node) {
    const { type, tagName } = node;
    if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function handlePointerDown() {
    hadKeyboardEvent = false;
}
function handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if (hadFocusVisibleRecently) hadKeyboardEvent = true;
    }
}
function prepare(doc) {
    doc.addEventListener('keydown', handleKeyDown, true);
    doc.addEventListener('mousedown', handlePointerDown, true);
    doc.addEventListener('pointerdown', handlePointerDown, true);
    doc.addEventListener('touchstart', handlePointerDown, true);
    doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}
function teardown(doc) {
    doc.removeEventListener('keydown', handleKeyDown, true);
    doc.removeEventListener('mousedown', handlePointerDown, true);
    doc.removeEventListener('pointerdown', handlePointerDown, true);
    doc.removeEventListener('touchstart', handlePointerDown, true);
    doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}
function isFocusVisible(event) {
    const { target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function useIsFocusVisible() {
    const ref = _react.useCallback((node)=>{
        if (node != null) prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = _react.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            hadFocusVisibleRecently = true;
            hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if (isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref
    };
}

},{"react":"9njXz","../useTimeout/useTimeout":"8suxl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8suxl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timeout", ()=>Timeout);
parcelHelpers.export(exports, "default", ()=>useTimeout);
var _useLazyRef = require("../useLazyRef/useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useOnMount = require("../useOnMount/useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
'use client';
class Timeout {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new Timeout();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function useTimeout() {
    const timeout = (0, _useLazyRefDefault.default)(Timeout.create).current;
    (0, _useOnMountDefault.default)(timeout.disposeEffect);
    return timeout;
}

},{"../useLazyRef/useLazyRef":"MNx2m","../useOnMount/useOnMount":"kAtuj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"MNx2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLazyRef);
var _react = require("react");
'use client';
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
    const ref = _react.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAtuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOnMount);
var _react = require("react");
'use client';
const EMPTY = [];
function useOnMount(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ _react.useEffect(fn, EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9I8Ri":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DELAY_RIPPLE", ()=>DELAY_RIPPLE);
parcelHelpers.export(exports, "TouchRippleRoot", ()=>TouchRippleRoot);
parcelHelpers.export(exports, "TouchRippleRipple", ()=>TouchRippleRipple);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _ripple = require("./Ripple");
var _rippleDefault = parcelHelpers.interopDefault(_ripple);
var _touchRippleClasses = require("./touchRippleClasses");
var _touchRippleClassesDefault = parcelHelpers.interopDefault(_touchRippleClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "center",
    "classes",
    "className"
];
let _ = (t)=>t, _t, _t2, _t3, _t4;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = (0, _system.keyframes)(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = (0, _system.keyframes)(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = (0, _styledDefault.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const TouchRippleRipple = (0, _styledDefault.default)((0, _rippleDefault.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, _touchRippleClassesDefault.default).rippleVisible, enterKeyframe, DURATION, ({ theme })=>theme.transitions.easing.easeInOut, (0, _touchRippleClassesDefault.default).ripplePulsate, ({ theme })=>theme.transitions.duration.shorter, (0, _touchRippleClassesDefault.default).child, (0, _touchRippleClassesDefault.default).childLeaving, exitKeyframe, DURATION, ({ theme })=>theme.transitions.easing.easeInOut, (0, _touchRippleClassesDefault.default).childPulsate, pulsateKeyframe, ({ theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const TouchRipple = /*#__PURE__*/ _react.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes = {}, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [ripples, setRipples] = _react.useState([]);
    const nextKey = _react.useRef(0);
    const rippleCallback = _react.useRef(null);
    _react.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = _react.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, _useTimeoutDefault.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = _react.useRef(null);
    const container = _react.useRef(null);
    const startCommit = _react.useCallback((params)=>{
        const { pulsate, rippleX, rippleY, rippleSize, cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRipple, {
                    classes: {
                        ripple: (0, _clsxDefault.default)(classes.ripple, (0, _touchRippleClassesDefault.default).ripple),
                        rippleVisible: (0, _clsxDefault.default)(classes.rippleVisible, (0, _touchRippleClassesDefault.default).rippleVisible),
                        ripplePulsate: (0, _clsxDefault.default)(classes.ripplePulsate, (0, _touchRippleClassesDefault.default).ripplePulsate),
                        child: (0, _clsxDefault.default)(classes.child, (0, _touchRippleClassesDefault.default).child),
                        childLeaving: (0, _clsxDefault.default)(classes.childLeaving, (0, _touchRippleClassesDefault.default).childLeaving),
                        childPulsate: (0, _clsxDefault.default)(classes.childPulsate, (0, _touchRippleClassesDefault.default).childPulsate)
                    },
                    timeout: DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = _react.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate = false, center = centerProp || options.pulsate, fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX, clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate,
                        rippleX,
                        rippleY,
                        rippleSize,
                        cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start(DELAY_RIPPLE, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = _react.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = _react.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    _react.useImperativeHandle(ref, ()=>({
            pulsate,
            start,
            stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TouchRippleRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)((0, _touchRippleClassesDefault.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTransitionGroup.TransitionGroup), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
exports.default = TouchRipple;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","react-transition-group":"hnCQJ","clsx":"bK0Bf","@mui/system":"5Hnj5","@mui/utils/useTimeout":"6WuNb","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./Ripple":"fUW0U","./touchRippleClasses":"H6sp0","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnCQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", ()=>(0, _csstransitionDefault.default));
parcelHelpers.export(exports, "ReplaceTransition", ()=>(0, _replaceTransitionDefault.default));
parcelHelpers.export(exports, "SwitchTransition", ()=>(0, _switchTransitionDefault.default));
parcelHelpers.export(exports, "TransitionGroup", ()=>(0, _transitionGroupDefault.default));
parcelHelpers.export(exports, "Transition", ()=>(0, _transitionDefault.default));
parcelHelpers.export(exports, "config", ()=>(0, _configDefault.default));
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"iyv3L","./ReplaceTransition":"1v1ld","./SwitchTransition":"iEWMb","./TransitionGroup":"4WN9V","./Transition":"6LVcl","./config":"7vGu2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyv3L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = {};
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","dom-helpers/addClass":"16v5y","dom-helpers/removeClass":"cUvLe","react":"9njXz","./Transition":"6LVcl","./utils/PropTypes":"8gMVu","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16v5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>addClass);
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"3I5QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I5QN":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hasClass);
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUvLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>removeClass);
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LVcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", ()=>UNMOUNTED);
parcelHelpers.export(exports, "EXITED", ()=>EXITED);
parcelHelpers.export(exports, "ENTERING", ()=>ENTERING);
parcelHelpers.export(exports, "ENTERED", ()=>ENTERED);
parcelHelpers.export(exports, "EXITING", ()=>EXITING);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./config":"7vGu2","./utils/PropTypes":"8gMVu","./TransitionGroupContext":"162y0","./utils/reflow":"8V7Al","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vGu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gMVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", ()=>timeoutsShape);
parcelHelpers.export(exports, "classNamesShape", ()=>classNamesShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = null;
var classNamesShape = null;

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"162y0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V7Al":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", ()=>forceReflow);
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1v1ld":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle('onEnter', 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle('onEntering', 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle('onEntered', 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle('onExit', 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle('onExiting', 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle('onExited', 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = (0, _reactDefault.default).Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) {
            var maybeNode = child.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this);
            this.props[handler](maybeNode);
        }
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = (0, _reactDefault.default).Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupDefault.default), props, inProp ? (0, _reactDefault.default).cloneElement(first, {
            key: 'first',
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : (0, _reactDefault.default).cloneElement(second, {
            key: 'second',
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}((0, _reactDefault.default).Component);
ReplaceTransition.propTypes = {};
exports.default = ReplaceTransition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","react-dom":"2ApDx","./TransitionGroup":"4WN9V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4WN9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _childMapping = require("./utils/ChildMapping");
var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, _assertThisInitializedDefault.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, _childMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _childMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, _childMapping.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, _extendsDefault.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, _reactDefault.default).Component);
TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps;
exports.default = TransitionGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","prop-types":"bnNSm","react":"9njXz","./TransitionGroupContext":"162y0","./utils/ChildMapping":"kq3eN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kq3eN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ parcelHelpers.export(exports, "getChildMapping", ()=>getChildMapping);
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ parcelHelpers.export(exports, "mergeChildMappings", ()=>mergeChildMappings);
parcelHelpers.export(exports, "getInitialChildMapping", ()=>getInitialChildMapping);
parcelHelpers.export(exports, "getNextChildMapping", ()=>getNextChildMapping);
var _react = require("react");
function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, _react.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function(child) {
        return (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: getProp(child, 'appear', props),
            enter: getProp(child, 'enter', props),
            exit: getProp(child, 'exit', props)
        });
    });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, _react.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, _react.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, _react.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: getProp(child, 'exit', nextProps),
            enter: getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iEWMb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modes", ()=>modes);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _transition = require("./Transition");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _leaveRenders, _enterRenders;
function areChildrenDifferent(oldChildren, newChildren) {
    if (oldChildren === newChildren) return false;
    if ((0, _reactDefault.default).isValidElement(oldChildren) && (0, _reactDefault.default).isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) return false;
    return true;
}
var modes = {
    out: 'out-in',
    in: 'in-out'
};
var callHook = function callHook(element, name, cb) {
    return function() {
        var _element$props;
        element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
        cb();
    };
};
var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function(_ref) {
    var current = _ref.current, changeState = _ref.changeState;
    return (0, _reactDefault.default).cloneElement(current, {
        in: false,
        onExited: callHook(current, 'onExited', function() {
            changeState((0, _transition.ENTERING), null);
        })
    });
}, _leaveRenders[modes.in] = function(_ref2) {
    var current = _ref2.current, changeState = _ref2.changeState, children = _ref2.children;
    return [
        current,
        (0, _reactDefault.default).cloneElement(children, {
            in: true,
            onEntered: callHook(children, 'onEntered', function() {
                changeState((0, _transition.ENTERING));
            })
        })
    ];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function(_ref3) {
    var children = _ref3.children, changeState = _ref3.changeState;
    return (0, _reactDefault.default).cloneElement(children, {
        in: true,
        onEntered: callHook(children, 'onEntered', function() {
            changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                in: true
            }));
        })
    });
}, _enterRenders[modes.in] = function(_ref4) {
    var current = _ref4.current, children = _ref4.children, changeState = _ref4.changeState;
    return [
        (0, _reactDefault.default).cloneElement(current, {
            in: false,
            onExited: callHook(current, 'onExited', function() {
                changeState((0, _transition.ENTERED), (0, _reactDefault.default).cloneElement(children, {
                    in: true
                }));
            })
        }),
        (0, _reactDefault.default).cloneElement(children, {
            in: true
        })
    ];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */ var SwitchTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(SwitchTransition, _React$Component);
    function SwitchTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            status: (0, _transition.ENTERED),
            current: null
        };
        _this.appeared = false;
        _this.changeState = function(status, current) {
            if (current === void 0) current = _this.state.current;
            _this.setState({
                status: status,
                current: current
            });
        };
        return _this;
    }
    var _proto = SwitchTransition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
    };
    SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.children == null) return {
            current: null
        };
        if (state.status === (0, _transition.ENTERING) && props.mode === modes.in) return {
            status: (0, _transition.ENTERING)
        };
        if (state.current && areChildrenDifferent(state.current, props.children)) return {
            status: (0, _transition.EXITING)
        };
        return {
            current: (0, _reactDefault.default).cloneElement(props.children, {
                in: true
            })
        };
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, mode = _this$props.mode, _this$state = this.state, status = _this$state.status, current = _this$state.current;
        var data = {
            children: children,
            current: current,
            changeState: this.changeState,
            status: status
        };
        var component;
        switch(status){
            case 0, _transition.ENTERING:
                component = enterRenders[mode](data);
                break;
            case 0, _transition.EXITING:
                component = leaveRenders[mode](data);
                break;
            case 0, _transition.ENTERED:
                component = current;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: {
                isMounting: !this.appeared
            }
        }, component);
    };
    return SwitchTransition;
}((0, _reactDefault.default).Component);
SwitchTransition.propTypes = {};
SwitchTransition.defaultProps = {
    mode: modes.out
};
exports.default = SwitchTransition;

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","./Transition":"6LVcl","./TransitionGroupContext":"162y0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Hnj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>(0, _styledEngine.css));
parcelHelpers.export(exports, "keyframes", ()=>(0, _styledEngine.keyframes));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _styledEngine.StyledEngineProvider));
parcelHelpers.export(exports, "GlobalStyles", ()=>(0, _globalStylesDefault.default));
parcelHelpers.export(exports, "borders", ()=>(0, _bordersDefault.default));
parcelHelpers.export(exports, "breakpoints", ()=>(0, _breakpointsDefault.default));
parcelHelpers.export(exports, "handleBreakpoints", ()=>(0, _breakpoints.handleBreakpoints));
parcelHelpers.export(exports, "mergeBreakpointsInOrder", ()=>(0, _breakpoints.mergeBreakpointsInOrder));
parcelHelpers.export(exports, "unstable_resolveBreakpointValues", ()=>(0, _breakpoints.resolveBreakpointValues));
parcelHelpers.export(exports, "compose", ()=>(0, _composeDefault.default));
parcelHelpers.export(exports, "display", ()=>(0, _displayDefault.default));
parcelHelpers.export(exports, "flexbox", ()=>(0, _flexboxDefault.default));
parcelHelpers.export(exports, "grid", ()=>(0, _cssGridDefault.default));
parcelHelpers.export(exports, "palette", ()=>(0, _paletteDefault.default));
parcelHelpers.export(exports, "positions", ()=>(0, _positionsDefault.default));
parcelHelpers.export(exports, "shadows", ()=>(0, _shadowsDefault.default));
parcelHelpers.export(exports, "sizing", ()=>(0, _sizingDefault.default));
parcelHelpers.export(exports, "spacing", ()=>(0, _spacingDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _styleDefault.default));
parcelHelpers.export(exports, "getPath", ()=>(0, _style.getPath));
parcelHelpers.export(exports, "getStyleValue", ()=>(0, _style.getStyleValue));
parcelHelpers.export(exports, "typography", ()=>(0, _typographyDefault.default));
parcelHelpers.export(exports, "unstable_styleFunctionSx", ()=>(0, _styleFunctionSxDefault.default));
parcelHelpers.export(exports, "unstable_createStyleFunctionSx", ()=>(0, _styleFunctionSx.unstable_createStyleFunctionSx));
parcelHelpers.export(exports, "unstable_extendSxProp", ()=>(0, _styleFunctionSx.extendSxProp));
parcelHelpers.export(exports, "unstable_defaultSxConfig", ()=>(0, _styleFunctionSx.unstable_defaultSxConfig));
parcelHelpers.export(exports, "unstable_getThemeValue", ()=>(0, _getThemeValueDefault.default));
parcelHelpers.export(exports, "Box", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "createBox", ()=>(0, _createBoxDefault.default));
parcelHelpers.export(exports, "createStyled", ()=>(0, _createStyledDefault.default));
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "createBreakpoints", ()=>(0, _createBreakpointsDefault.default));
parcelHelpers.export(exports, "createSpacing", ()=>(0, _createSpacingDefault.default));
parcelHelpers.export(exports, "shape", ()=>(0, _shapeDefault.default));
parcelHelpers.export(exports, "useThemeProps", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _useThemeProps.getThemeProps));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useThemeWithoutDefault", ()=>(0, _useThemeWithoutDefaultDefault.default));
parcelHelpers.export(exports, "useMediaQuery", ()=>(0, _useMediaQueryDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsProvider", ()=>(0, _createCssVarsProviderDefault.default));
parcelHelpers.export(exports, "unstable_createGetCssVar", ()=>(0, _createGetCssVarDefault.default));
parcelHelpers.export(exports, "unstable_cssVarsParser", ()=>(0, _cssVarsParserDefault.default));
parcelHelpers.export(exports, "unstable_prepareCssVars", ()=>(0, _prepareCssVarsDefault.default));
parcelHelpers.export(exports, "unstable_createCssVarsTheme", ()=>(0, _createCssVarsThemeDefault.default));
parcelHelpers.export(exports, "responsivePropType", ()=>(0, _responsivePropTypeDefault.default));
parcelHelpers.export(exports, "RtlProvider", ()=>(0, _rtlProviderDefault.default));
/** ----------------- */ /** Layout components */ parcelHelpers.export(exports, "createContainer", ()=>(0, _createContainerDefault.default));
parcelHelpers.export(exports, "Container", ()=>(0, _containerDefault.default));
parcelHelpers.export(exports, "Unstable_Grid", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "Stack", ()=>(0, _stackDefault.default));
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "experimental_sx", ()=>experimental_sx);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _styledEngine = require("@mui/styled-engine");
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _borders = require("./borders");
var _bordersDefault = parcelHelpers.interopDefault(_borders);
parcelHelpers.exportAll(_borders, exports);
var _breakpoints = require("./breakpoints");
var _breakpointsDefault = parcelHelpers.interopDefault(_breakpoints);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _display = require("./display");
var _displayDefault = parcelHelpers.interopDefault(_display);
var _flexbox = require("./flexbox");
var _flexboxDefault = parcelHelpers.interopDefault(_flexbox);
parcelHelpers.exportAll(_flexbox, exports);
var _cssGrid = require("./cssGrid");
var _cssGridDefault = parcelHelpers.interopDefault(_cssGrid);
parcelHelpers.exportAll(_cssGrid, exports);
var _palette = require("./palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
parcelHelpers.exportAll(_palette, exports);
var _positions = require("./positions");
var _positionsDefault = parcelHelpers.interopDefault(_positions);
parcelHelpers.exportAll(_positions, exports);
var _shadows = require("./shadows");
var _shadowsDefault = parcelHelpers.interopDefault(_shadows);
var _sizing = require("./sizing");
var _sizingDefault = parcelHelpers.interopDefault(_sizing);
parcelHelpers.exportAll(_sizing, exports);
var _spacing = require("./spacing");
var _spacingDefault = parcelHelpers.interopDefault(_spacing);
parcelHelpers.exportAll(_spacing, exports);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _typography = require("./typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
parcelHelpers.exportAll(_typography, exports);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _getThemeValue = require("./getThemeValue");
var _getThemeValueDefault = parcelHelpers.interopDefault(_getThemeValue);
var _box = require("./Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _createBox = require("./createBox");
var _createBoxDefault = parcelHelpers.interopDefault(_createBox);
var _createStyled = require("./createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
parcelHelpers.exportAll(_createStyled, exports);
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createBreakpoints = require("./createTheme/createBreakpoints");
var _createBreakpointsDefault = parcelHelpers.interopDefault(_createBreakpoints);
var _createSpacing = require("./createTheme/createSpacing");
var _createSpacingDefault = parcelHelpers.interopDefault(_createSpacing);
var _shape = require("./createTheme/shape");
var _shapeDefault = parcelHelpers.interopDefault(_shape);
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeWithoutDefault = require("./useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _colorManipulator = require("./colorManipulator");
parcelHelpers.exportAll(_colorManipulator, exports);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _createCssVarsProvider = require("./cssVars/createCssVarsProvider");
var _createCssVarsProviderDefault = parcelHelpers.interopDefault(_createCssVarsProvider);
var _createGetCssVar = require("./cssVars/createGetCssVar");
var _createGetCssVarDefault = parcelHelpers.interopDefault(_createGetCssVar);
var _cssVarsParser = require("./cssVars/cssVarsParser");
var _cssVarsParserDefault = parcelHelpers.interopDefault(_cssVarsParser);
var _prepareCssVars = require("./cssVars/prepareCssVars");
var _prepareCssVarsDefault = parcelHelpers.interopDefault(_prepareCssVars);
var _createCssVarsTheme = require("./cssVars/createCssVarsTheme");
var _createCssVarsThemeDefault = parcelHelpers.interopDefault(_createCssVarsTheme);
var _responsivePropType = require("./responsivePropType");
var _responsivePropTypeDefault = parcelHelpers.interopDefault(_responsivePropType);
var _rtlProvider = require("./RtlProvider");
var _rtlProviderDefault = parcelHelpers.interopDefault(_rtlProvider);
parcelHelpers.exportAll(_rtlProvider, exports);
var _version = require("./version");
parcelHelpers.exportAll(_version, exports);
var _createContainer = require("./Container/createContainer");
var _createContainerDefault = parcelHelpers.interopDefault(_createContainer);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
parcelHelpers.exportAll(_container, exports);
var _grid = require("./Unstable_Grid/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _unstableGrid = require("./Unstable_Grid");
parcelHelpers.exportAll(_unstableGrid, exports);
var _stack = require("./Stack/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _stack1 = require("./Stack");
parcelHelpers.exportAll(_stack1, exports);
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(20));
}

},{"@mui/utils/formatMuiErrorMessage":"awvJV","@mui/styled-engine":"4hxt2","./GlobalStyles":"9G64p","./borders":false,"./breakpoints":"9gmyo","./compose":false,"./display":false,"./flexbox":false,"./cssGrid":false,"./palette":false,"./positions":false,"./shadows":false,"./sizing":false,"./spacing":false,"./style":false,"./typography":false,"./styleFunctionSx":false,"./getThemeValue":false,"./Box":false,"./createBox":"jRKlJ","./createStyled":false,"./styled":false,"./createTheme":false,"./createTheme/createBreakpoints":"fZK9u","./createTheme/createSpacing":"bfvQ9","./createTheme/shape":false,"./useThemeProps":false,"./useTheme":"ajiEB","./useThemeWithoutDefault":false,"./useMediaQuery":false,"./colorManipulator":"aNCBi","./ThemeProvider":"ljFOn","./cssVars/createCssVarsProvider":"fiCyc","./cssVars/createGetCssVar":"30Mi2","./cssVars/cssVarsParser":false,"./cssVars/prepareCssVars":"9iNQU","./cssVars/createCssVarsTheme":false,"./responsivePropType":false,"./RtlProvider":false,"./version":false,"./Container/createContainer":false,"./Container":false,"./Unstable_Grid/Grid":false,"./Unstable_Grid":false,"./Stack/Stack":false,"./Stack":"2JA2t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9G64p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
parcelHelpers.exportAll(_globalStyles, exports);
'use client';

},{"./GlobalStyles":"3G8MP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3G8MP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styledEngine = require("@mui/styled-engine");
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function GlobalStyles({ styles, themeId, defaultTheme = {} }) {
    const upperTheme = (0, _useThemeDefault.default)(defaultTheme);
    const globalStyles = typeof styles === 'function' ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
        styles: globalStyles
    });
}
exports.default = GlobalStyles;

},{"react":"9njXz","prop-types":"bnNSm","@mui/styled-engine":"4hxt2","../useTheme":"ajiEB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ajiEB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _useThemeWithoutDefault = require("./useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
'use client';
const systemDefaultTheme = (0, _createThemeDefault.default)();
function useTheme(defaultTheme = systemDefaultTheme) {
    return (0, _useThemeWithoutDefaultDefault.default)(defaultTheme);
}
exports.default = useTheme;

},{"./createTheme":"2h77y","./useThemeWithoutDefault":"fTRG8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fTRG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _styledEngine = require("@mui/styled-engine");
'use client';
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = _react.useContext((0, _styledEngine.ThemeContext));
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
exports.default = useTheme;

},{"react":"9njXz","@mui/styled-engine":"4hxt2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jRKlJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createBox);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component"
];
function createBox(options = {}) {
    const { themeId, defaultTheme, defaultClassName = 'MuiBox-root', generateClassName } = options;
    const BoxRoot = (0, _styledEngineDefault.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, _styleFunctionSxDefault.default));
    const Box = /*#__PURE__*/ _react.forwardRef(function Box(inProps, ref) {
        const theme = (0, _useThemeDefault.default)(defaultTheme);
        const _extendSxProp = (0, _styleFunctionSx.extendSxProp)(inProps), { className, component = 'div' } = _extendSxProp, other = (0, _objectWithoutPropertiesLooseDefault.default)(_extendSxProp, _excluded);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoxRoot, (0, _extendsDefault.default)({
            as: component,
            ref: ref,
            className: (0, _clsxDefault.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"bK0Bf","@mui/styled-engine":"4hxt2","./styleFunctionSx":"8WdLC","./useTheme":"ajiEB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5CuSf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Update /system/styled/#api in case if this changes
parcelHelpers.export(exports, "shouldForwardProp", ()=>shouldForwardProp);
parcelHelpers.export(exports, "systemDefaultTheme", ()=>systemDefaultTheme);
parcelHelpers.export(exports, "default", ()=>createStyled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable no-underscore-dangle */ var _styledEngine = require("@mui/styled-engine");
var _styledEngineDefault = parcelHelpers.interopDefault(_styledEngine);
var _deepmerge = require("@mui/utils/deepmerge");
var _capitalize = require("@mui/utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _getDisplayName = require("@mui/utils/getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _styleFunctionSx = require("./styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
const _excluded = [
    "ownerState"
], _excluded2 = [
    "variants"
], _excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = (0, _createThemeDefault.default)();
const lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function resolveTheme({ defaultTheme, theme, themeId }) {
    return isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function processStyleArg(callableStyle, _ref) {
    let { ownerState } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, _extendsDefault.default)({
        ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>processStyleArg(resolvedStyle, (0, _extendsDefault.default)({
            ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants = [] } = resolvedStylesArg, otherStyles = (0, _objectWithoutPropertiesLooseDefault.default)(resolvedStylesArg, _excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, _extendsDefault.default)({
                ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === 'function' ? variant.style((0, _extendsDefault.default)({
                    ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, _styleFunctionSxDefault.default)((0, _extendsDefault.default)({}, props, {
            theme: resolveTheme((0, _extendsDefault.default)({}, props, {
                defaultTheme,
                themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, _objectWithoutPropertiesLooseDefault.default)(inputOptions, _excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngineDefault.default)(tag, (0, _extendsDefault.default)({
            shouldForwardProp: shouldForwardPropOption,
            label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, _deepmerge.isPlainObject)(stylesArg)) return (props)=>processStyleArg(stylesArg, (0, _extendsDefault.default)({}, props, {
                    theme: resolveTheme({
                        theme: props.theme,
                        defaultTheme,
                        themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = resolveTheme((0, _extendsDefault.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = processStyleArg(slotStyle, (0, _extendsDefault.default)({}, props, {
                        theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = resolveTheme((0, _extendsDefault.default)({}, props, {
                    defaultTheme,
                    themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return processStyleArg({
                    variants: themeVariants
                }, (0, _extendsDefault.default)({}, props, {
                    theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/styled-engine":"4hxt2","@mui/utils/deepmerge":"aRydR","@mui/utils/capitalize":"fRCPT","@mui/utils/getDisplayName":"duLzC","./createTheme":"2h77y","./styleFunctionSx":"8WdLC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gaki6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createStyled = require("./createStyled");
var _createStyledDefault = parcelHelpers.interopDefault(_createStyled);
const styled = (0, _createStyledDefault.default)();
exports.default = styled;

},{"./createStyled":"5CuSf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3fKK0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _getThemePropsDefault.default));
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
'use client';

},{"./useThemeProps":"3v1Af","./getThemeProps":"UBXzB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3v1Af":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useThemeProps);
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
'use client';
function useThemeProps({ props, name, defaultTheme, themeId }) {
    let theme = (0, _useThemeDefault.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, _getThemePropsDefault.default)({
        theme,
        name,
        props
    });
    return mergedProps;
}

},{"./getThemeProps":"UBXzB","../useTheme":"ajiEB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"UBXzB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getThemeProps);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, _resolvePropsDefault.default)(theme.components[name].defaultProps, props);
}

},{"@mui/utils/resolveProps":"gemxd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k92j1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useMediaQueryDefault.default));
var _useMediaQuery = require("./useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
parcelHelpers.exportAll(_useMediaQuery, exports);

},{"./useMediaQuery":"hmr1h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmr1h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMediaQuery);
var _react = require("react");
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useThemeProps = require("../useThemeProps");
var _useThemeWithoutDefault = require("../useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = _react.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseSyncExternalStore = _react["useSyncExternalStore"];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = _react.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = _react.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = _react.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function useMediaQuery(queryInput, options = {}) {
    const theme = (0, _useThemeWithoutDefaultDefault.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches = false, matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia = null, noSsr = false } = (0, _useThemeProps.getThemeProps)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme
    });
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}

},{"react":"9njXz","@mui/utils/useEnhancedEffect":"9v0Mw","../useThemeProps":"3fKK0","../useThemeWithoutDefault":"fTRG8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aNCBi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ parcelHelpers.export(exports, "hexToRgb", ()=>hexToRgb);
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ parcelHelpers.export(exports, "decomposeColor", ()=>decomposeColor);
parcelHelpers.export(exports, "colorChannel", ()=>colorChannel);
parcelHelpers.export(exports, "private_safeColorChannel", ()=>private_safeColorChannel);
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ parcelHelpers.export(exports, "recomposeColor", ()=>recomposeColor);
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ parcelHelpers.export(exports, "rgbToHex", ()=>rgbToHex);
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ parcelHelpers.export(exports, "hslToRgb", ()=>hslToRgb);
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ parcelHelpers.export(exports, "getLuminance", ()=>getLuminance);
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ parcelHelpers.export(exports, "getContrastRatio", ()=>getContrastRatio);
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "private_safeAlpha", ()=>private_safeAlpha);
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "darken", ()=>darken);
parcelHelpers.export(exports, "private_safeDarken", ()=>private_safeDarken);
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "lighten", ()=>lighten);
parcelHelpers.export(exports, "private_safeLighten", ()=>private_safeLighten);
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ parcelHelpers.export(exports, "emphasize", ()=>emphasize);
parcelHelpers.export(exports, "private_safeEmphasize", ()=>private_safeEmphasize);
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ parcelHelpers.export(exports, "blend", ()=>blend);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
/* eslint-disable @typescript-eslint/naming-convention */ var _clamp = require("@mui/utils/clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clampDefault.default)(value, min, max);
}
function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return decomposeColor(hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, _formatMuiErrorMessageDefault.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, _formatMuiErrorMessageDefault.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

},{"@mui/utils/formatMuiErrorMessage":"awvJV","@mui/utils/clamp":"4daFJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ljFOn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
'use client';

},{"./ThemeProvider":"6GKJO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GKJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _privateTheming = require("@mui/private-theming");
var _exactProp = require("@mui/utils/exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _styledEngine = require("@mui/styled-engine");
var _useThemeWithoutDefault = require("../useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _rtlProvider = require("../RtlProvider");
var _rtlProviderDefault = parcelHelpers.interopDefault(_rtlProvider);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _defaultPropsProviderDefault = parcelHelpers.interopDefault(_defaultPropsProvider);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return _react.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, _extendsDefault.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, _extendsDefault.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, _extendsDefault.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function ThemeProvider(props) {
    const { children, theme: localTheme, themeId } = props;
    const upperTheme = (0, _useThemeWithoutDefaultDefault.default)(EMPTY_THEME);
    const upperPrivateTheme = (0, _privateTheming.useTheme)() || EMPTY_THEME;
    const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateTheming.ThemeProvider), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.ThemeContext).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rtlProviderDefault.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _defaultPropsProviderDefault.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: children
                })
            })
        })
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/private-theming":"faJCj","@mui/utils/exactProp":"7IZ8M","@mui/styled-engine":"4hxt2","../useThemeWithoutDefault":"fTRG8","../RtlProvider":"aMQRu","../DefaultPropsProvider":"j6h6T","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"faJCj":[function(require,module,exports,__globalThis) {
/**
 * @mui/private-theming v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
parcelHelpers.exportAll(_themeProvider, exports);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);

},{"./ThemeProvider":"llabg","./useTheme":"3GQzX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"llabg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "unstable_nested", ()=>(0, _nestedDefault.default));
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _nested = require("./nested");
var _nestedDefault = parcelHelpers.interopDefault(_nested);

},{"./ThemeProvider":"hsaao","./nested":"l2OYd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hsaao":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _themeContext = require("../useTheme/ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _nested = require("./nested");
var _nestedDefault = parcelHelpers.interopDefault(_nested);
// To support composition of theme.
var _jsxRuntime = require("react/jsx-runtime");
function mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, _extendsDefault.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function ThemeProvider(props) {
    const { children, theme: localTheme } = props;
    const outerTheme = (0, _useThemeDefault.default)();
    const theme = _react.useMemo(()=>{
        const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, _nestedDefault.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeContextDefault.default).Provider, {
        value: theme,
        children: children
    });
}
exports.default = ThemeProvider;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils":"lfcNH","../useTheme/ThemeContext":"hSPSQ","../useTheme":"3GQzX","./nested":"l2OYd","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lfcNH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chainPropTypes", ()=>(0, _chainPropTypesDefault.default));
parcelHelpers.export(exports, "deepmerge", ()=>(0, _deepmergeDefault.default));
parcelHelpers.export(exports, "isPlainObject", ()=>(0, _deepmerge.isPlainObject));
parcelHelpers.export(exports, "elementAcceptingRef", ()=>(0, _elementAcceptingRefDefault.default));
parcelHelpers.export(exports, "elementTypeAcceptingRef", ()=>(0, _elementTypeAcceptingRefDefault.default));
parcelHelpers.export(exports, "exactProp", ()=>(0, _exactPropDefault.default));
parcelHelpers.export(exports, "formatMuiErrorMessage", ()=>(0, _formatMuiErrorMessageDefault.default));
parcelHelpers.export(exports, "getDisplayName", ()=>(0, _getDisplayNameDefault.default));
parcelHelpers.export(exports, "HTMLElementType", ()=>(0, _htmlelementTypeDefault.default));
parcelHelpers.export(exports, "ponyfillGlobal", ()=>(0, _ponyfillGlobalDefault.default));
parcelHelpers.export(exports, "refType", ()=>(0, _refTypeDefault.default));
parcelHelpers.export(exports, "unstable_capitalize", ()=>(0, _capitalizeDefault.default));
parcelHelpers.export(exports, "unstable_createChainedFunction", ()=>(0, _createChainedFunctionDefault.default));
parcelHelpers.export(exports, "unstable_debounce", ()=>(0, _debounceDefault.default));
parcelHelpers.export(exports, "unstable_deprecatedPropType", ()=>(0, _deprecatedPropTypeDefault.default));
parcelHelpers.export(exports, "unstable_isMuiElement", ()=>(0, _isMuiElementDefault.default));
parcelHelpers.export(exports, "unstable_ownerDocument", ()=>(0, _ownerDocumentDefault.default));
parcelHelpers.export(exports, "unstable_ownerWindow", ()=>(0, _ownerWindowDefault.default));
parcelHelpers.export(exports, "unstable_requirePropFactory", ()=>(0, _requirePropFactoryDefault.default));
parcelHelpers.export(exports, "unstable_setRef", ()=>(0, _setRefDefault.default));
parcelHelpers.export(exports, "unstable_useEnhancedEffect", ()=>(0, _useEnhancedEffectDefault.default));
parcelHelpers.export(exports, "unstable_useId", ()=>(0, _useIdDefault.default));
parcelHelpers.export(exports, "unstable_unsupportedProp", ()=>(0, _unsupportedPropDefault.default));
parcelHelpers.export(exports, "unstable_useControlled", ()=>(0, _useControlledDefault.default));
parcelHelpers.export(exports, "unstable_useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "unstable_useForkRef", ()=>(0, _useForkRefDefault.default));
parcelHelpers.export(exports, "unstable_useLazyRef", ()=>(0, _useLazyRefDefault.default));
parcelHelpers.export(exports, "unstable_useTimeout", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "unstable_Timeout", ()=>(0, _useTimeout.Timeout));
parcelHelpers.export(exports, "unstable_useOnMount", ()=>(0, _useOnMountDefault.default));
parcelHelpers.export(exports, "unstable_useIsFocusVisible", ()=>(0, _useIsFocusVisibleDefault.default));
parcelHelpers.export(exports, "unstable_getScrollbarSize", ()=>(0, _getScrollbarSizeDefault.default));
parcelHelpers.export(exports, "unstable_detectScrollType", ()=>(0, _scrollLeft.detectScrollType));
parcelHelpers.export(exports, "unstable_getNormalizedScrollLeft", ()=>(0, _scrollLeft.getNormalizedScrollLeft));
parcelHelpers.export(exports, "usePreviousProps", ()=>(0, _usePreviousPropsDefault.default));
parcelHelpers.export(exports, "getValidReactChildren", ()=>(0, _getValidReactChildrenDefault.default));
parcelHelpers.export(exports, "visuallyHidden", ()=>(0, _visuallyHiddenDefault.default));
parcelHelpers.export(exports, "integerPropType", ()=>(0, _integerPropTypeDefault.default));
parcelHelpers.export(exports, "internal_resolveProps", ()=>(0, _resolvePropsDefault.default));
parcelHelpers.export(exports, "unstable_composeClasses", ()=>(0, _composeClassesDefault.default));
parcelHelpers.export(exports, "unstable_generateUtilityClass", ()=>(0, _generateUtilityClassDefault.default));
parcelHelpers.export(exports, "unstable_isGlobalState", ()=>(0, _generateUtilityClass.isGlobalState));
parcelHelpers.export(exports, "unstable_generateUtilityClasses", ()=>(0, _generateUtilityClassesDefault.default));
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _classNameGeneratorDefault.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampDefault.default));
parcelHelpers.export(exports, "unstable_useSlotProps", ()=>(0, _useSlotPropsDefault.default));
parcelHelpers.export(exports, "unstable_resolveComponentProps", ()=>(0, _resolveComponentPropsDefault.default));
parcelHelpers.export(exports, "unstable_extractEventHandlers", ()=>(0, _extractEventHandlersDefault.default));
parcelHelpers.export(exports, "unstable_getReactElementRef", ()=>(0, _getReactElementRefDefault.default));
var _chainPropTypes = require("./chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _deepmerge = require("./deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _elementAcceptingRef = require("./elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _elementTypeAcceptingRef = require("./elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _formatMuiErrorMessage = require("./formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _getDisplayName = require("./getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _htmlelementType = require("./HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _ponyfillGlobal = require("./ponyfillGlobal");
var _ponyfillGlobalDefault = parcelHelpers.interopDefault(_ponyfillGlobal);
var _refType = require("./refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useLazyRef = require("./useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useOnMount = require("./useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _getScrollbarSize = require("./getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
var _scrollLeft = require("./scrollLeft");
var _usePreviousProps = require("./usePreviousProps");
var _usePreviousPropsDefault = parcelHelpers.interopDefault(_usePreviousProps);
var _getValidReactChildren = require("./getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);
var _visuallyHidden = require("./visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _resolveProps = require("./resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _composeClasses = require("./composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _generateUtilityClass = require("./generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
parcelHelpers.exportAll(_generateUtilityClass, exports);
var _generateUtilityClasses = require("./generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _classNameGenerator = require("./ClassNameGenerator");
var _classNameGeneratorDefault = parcelHelpers.interopDefault(_classNameGenerator);
var _clamp = require("./clamp");
var _clampDefault = parcelHelpers.interopDefault(_clamp);
var _useSlotProps = require("./useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _resolveComponentProps = require("./resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _extractEventHandlers = require("./extractEventHandlers");
var _extractEventHandlersDefault = parcelHelpers.interopDefault(_extractEventHandlers);
var _getReactElementRef = require("./getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./chainPropTypes":"83tGg","./deepmerge":"aRydR","./elementAcceptingRef":"5WlCj","./elementTypeAcceptingRef":"gpPr5","./exactProp":"7IZ8M","./formatMuiErrorMessage":"awvJV","./getDisplayName":"duLzC","./HTMLElementType":"jZED3","./ponyfillGlobal":"k7rki","./refType":"7a8uL","./capitalize":"fRCPT","./createChainedFunction":"1ZqU8","./debounce":"1rcGS","./deprecatedPropType":"fopsQ","./isMuiElement":"43Tbr","./ownerDocument":"7AorK","./ownerWindow":"af1fJ","./requirePropFactory":"hLsmf","./setRef":"fgdh8","./useEnhancedEffect":"9v0Mw","./useId":"eMerL","./unsupportedProp":"jIwiP","./useControlled":"fOjEQ","./useEventCallback":"ee70R","./useForkRef":"gq6SY","./useLazyRef":"8OyrV","./useTimeout":"6WuNb","./useOnMount":"659KA","./useIsFocusVisible":"e1xVB","./getScrollbarSize":"dPz4l","./scrollLeft":"f923Q","./usePreviousProps":"gKE6Y","./getValidReactChildren":"BQN46","./visuallyHidden":"1ZWGa","./integerPropType":"bc5x8","./resolveProps":"gemxd","./composeClasses":"43D21","./generateUtilityClass":"ktE5h","./generateUtilityClasses":"kn9BC","./ClassNameGenerator":"eZky1","./clamp":"4daFJ","./useSlotProps":"kv8TD","./resolveComponentProps":"dzXZN","./extractEventHandlers":"lbNYN","./getReactElementRef":"guLSb","./types":"kmSYW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5WlCj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _elementAcceptingRefDefault.default));
var _elementAcceptingRef = require("./elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);

},{"./elementAcceptingRef":"62E2J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"62E2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _chainPropTypes = require("../chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
function isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
const elementAcceptingRef = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element, acceptingRef);
elementAcceptingRef.isRequired = (0, _chainPropTypesDefault.default)((0, _propTypesDefault.default).element.isRequired, acceptingRef);
exports.default = elementAcceptingRef;

},{"prop-types":"bnNSm","../chainPropTypes":"83tGg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7IZ8M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _exactPropDefault.default));
var _exactProp = require("./exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);

},{"./exactProp":"gPVzD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPVzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>exactProp);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZED3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _htmlelementTypeDefault.default));
var _htmlelementType = require("./HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);

},{"./HTMLElementType":"6g17Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6g17Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HTMLElementType);
function HTMLElementType(props, propName, componentName, location, propFullName) {
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k7rki":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ponyfillGlobalDefault.default));
var _ponyfillGlobal = require("./ponyfillGlobal");
var _ponyfillGlobalDefault = parcelHelpers.interopDefault(_ponyfillGlobal);

},{"./ponyfillGlobal":"5Lo7G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Lo7G":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ZqU8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createChainedFunctionDefault.default));
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);

},{"./createChainedFunction":"8iDdC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8iDdC":[function(require,module,exports,__globalThis) {
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createChainedFunction);
function createChainedFunction(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1rcGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _debounceDefault.default));
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
parcelHelpers.exportAll(_debounce, exports);

},{"./debounce":"8pTPD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8pTPD":[function(require,module,exports,__globalThis) {
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fopsQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _deprecatedPropTypeDefault.default));
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);

},{"./deprecatedPropType":"bojWO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bojWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>deprecatedPropType);
function deprecatedPropType(validator, reason) {
    var props, propName, componentName, location, propFullName;
    return ()=>null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43Tbr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _isMuiElementDefault.default));
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);

},{"./isMuiElement":"arF9k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"arF9k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isMuiElement);
var _react = require("react");
function isMuiElement(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ _react.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7AorK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ownerDocumentDefault.default));
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);

},{"./ownerDocument":"8n3X3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8n3X3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerDocument);
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"af1fJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _ownerWindowDefault.default));
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);

},{"./ownerWindow":"2pP3Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pP3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ownerWindow);
var _ownerDocument = require("../ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
function ownerWindow(node) {
    const doc = (0, _ownerDocumentDefault.default)(node);
    return doc.defaultView || window;
}

},{"../ownerDocument":"7AorK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hLsmf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _requirePropFactoryDefault.default));
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);

},{"./requirePropFactory":"FWMyE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"FWMyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>requirePropFactory);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function requirePropFactory(componentNameInError, Component) {
    return ()=>null;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMerL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useIdDefault.default));
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);

},{"./useId":"kchGK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kchGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useId);
var _react = require("react");
'use client';
let globalId = 0;
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = _react.useState(idOverride);
    const id = idOverride || defaultId;
    _react.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = _react['useId'.toString()];
function useId(idOverride) {
    if (maybeReactUseId !== undefined) {
        const reactId = maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return useGlobalId(idOverride);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fOjEQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useControlledDefault.default));
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);

},{"./useControlled":"inT8k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"inT8k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useControlled);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ var _react = require("react");
'use client';
function useControlled({ controlled, default: defaultProp, name, state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = _react.useRef(controlled !== undefined);
    const [valueState, setValue] = _react.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = _react.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8OyrV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useLazyRefDefault.default));
var _useLazyRef = require("./useLazyRef");
var _useLazyRefDefault = parcelHelpers.interopDefault(_useLazyRef);

},{"./useLazyRef":"MNx2m","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6WuNb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "Timeout", ()=>(0, _useTimeout.Timeout));
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);

},{"./useTimeout":"8suxl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"659KA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useOnMountDefault.default));
var _useOnMount = require("./useOnMount");
var _useOnMountDefault = parcelHelpers.interopDefault(_useOnMount);

},{"./useOnMount":"kAtuj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPz4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getScrollbarSizeDefault.default));
var _getScrollbarSize = require("./getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);

},{"./getScrollbarSize":"fYE3J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fYE3J":[function(require,module,exports,__globalThis) {
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollbarSize);
function getScrollbarSize(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f923Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _scrollLeft = require("./scrollLeft");
parcelHelpers.exportAll(_scrollLeft, exports);

},{"./scrollLeft":"2dwgO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2dwgO":[function(require,module,exports,__globalThis) {
// Source from https://github.com/alitaheri/normalize-scroll-left
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */ parcelHelpers.export(exports, "detectScrollType", ()=>detectScrollType);
// Based on https://stackoverflow.com/a/24394376
parcelHelpers.export(exports, "getNormalizedScrollLeft", ()=>getNormalizedScrollLeft);
let cachedType;
function detectScrollType() {
    if (cachedType) return cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return cachedType;
}
function getNormalizedScrollLeft(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = detectScrollType();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKE6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _usePreviousPropsDefault.default));
var _usePreviousProps = require("./usePreviousProps");
var _usePreviousPropsDefault = parcelHelpers.interopDefault(_usePreviousProps);

},{"./usePreviousProps":"dxx9E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dxx9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
const usePreviousProps = (value)=>{
    const ref = _react.useRef({});
    _react.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
exports.default = usePreviousProps;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"BQN46":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getValidReactChildrenDefault.default));
var _getValidReactChildren = require("./getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);

},{"./getValidReactChildren":"g2aVX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g2aVX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getValidReactChildren);
var _react = require("react");
function getValidReactChildren(children) {
    return _react.Children.toArray(children).filter((child)=>/*#__PURE__*/ _react.isValidElement(child));
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ZWGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _visuallyHiddenDefault.default));
var _visuallyHidden = require("./visuallyHidden");
var _visuallyHiddenDefault = parcelHelpers.interopDefault(_visuallyHidden);

},{"./visuallyHidden":"6ZUFS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ZUFS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
exports.default = visuallyHidden;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bc5x8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _integerPropTypeDefault.default));
var _integerPropType = require("./integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
parcelHelpers.exportAll(_integerPropType, exports);

},{"./integerPropType":"c7POp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7POp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTypeByValue", ()=>getTypeByValue);
function getTypeByValue(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
// IE 11 support
function ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !isInteger(propValue)) {
        const propType = getTypeByValue(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return requiredInteger(props, propName, ...other);
}
function validatorNoop() {
    return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
exports.default = validatorNoop;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kv8TD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useSlotPropsDefault.default));
var _useSlotProps = require("./useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);

},{"./useSlotProps":"hgH2y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgH2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _useForkRef = require("../useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _appendOwnerState = require("../appendOwnerState");
var _appendOwnerStateDefault = parcelHelpers.interopDefault(_appendOwnerState);
var _mergeSlotProps = require("../mergeSlotProps");
var _mergeSlotPropsDefault = parcelHelpers.interopDefault(_mergeSlotProps);
var _resolveComponentProps = require("../resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
'use client';
const _excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false } = parameters, rest = (0, _objectWithoutPropertiesLooseDefault.default)(parameters, _excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, _resolveComponentPropsDefault.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = (0, _mergeSlotPropsDefault.default)((0, _extendsDefault.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, _useForkRefDefault.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, _appendOwnerStateDefault.default)(elementType, (0, _extendsDefault.default)({}, mergedProps, {
        ref
    }), ownerState);
    return props;
}
exports.default = useSlotProps;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","../useForkRef":"gq6SY","../appendOwnerState":"3olcZ","../mergeSlotProps":"I71PR","../resolveComponentProps":"dzXZN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3olcZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _appendOwnerStateDefault.default));
var _appendOwnerState = require("./appendOwnerState");
var _appendOwnerStateDefault = parcelHelpers.interopDefault(_appendOwnerState);

},{"./appendOwnerState":"e7KaN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e7KaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _isHostComponent = require("../isHostComponent");
var _isHostComponentDefault = parcelHelpers.interopDefault(_isHostComponent);
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, _isHostComponentDefault.default)(elementType)) return otherProps;
    return (0, _extendsDefault.default)({}, otherProps, {
        ownerState: (0, _extendsDefault.default)({}, otherProps.ownerState, ownerState)
    });
}
exports.default = appendOwnerState;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","../isHostComponent":"2X2lI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2X2lI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _isHostComponentDefault.default));
var _isHostComponent = require("./isHostComponent");
var _isHostComponentDefault = parcelHelpers.interopDefault(_isHostComponent);

},{"./isHostComponent":"fHQXi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHQXi":[function(require,module,exports,__globalThis) {
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isHostComponent(element) {
    return typeof element === 'string';
}
exports.default = isHostComponent;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"I71PR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mergeSlotPropsDefault.default));
var _mergeSlotProps = require("./mergeSlotProps");
var _mergeSlotPropsDefault = parcelHelpers.interopDefault(_mergeSlotProps);

},{"./mergeSlotProps":"5G4kY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5G4kY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _extractEventHandlers = require("../extractEventHandlers");
var _extractEventHandlersDefault = parcelHelpers.interopDefault(_extractEventHandlers);
var _omitEventHandlers = require("../omitEventHandlers");
var _omitEventHandlersDefault = parcelHelpers.interopDefault(_omitEventHandlers);
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function mergeSlotProps(parameters) {
    const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, _clsxDefault.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, _extendsDefault.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, _extendsDefault.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, _extractEventHandlersDefault.default)((0, _extendsDefault.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, _omitEventHandlersDefault.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, _omitEventHandlersDefault.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, _clsxDefault.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, _extendsDefault.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, _extendsDefault.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props,
        internalRef: internalSlotProps.ref
    };
}
exports.default = mergeSlotProps;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","clsx":"cjnjz","../extractEventHandlers":"lbNYN","../omitEventHandlers":"fgIdO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cjnjz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lbNYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _extractEventHandlersDefault.default));
var _extractEventHandlers = require("./extractEventHandlers");
var _extractEventHandlersDefault = parcelHelpers.interopDefault(_extractEventHandlers);

},{"./extractEventHandlers":"cPzer","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cPzer":[function(require,module,exports,__globalThis) {
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
exports.default = extractEventHandlers;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fgIdO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _omitEventHandlersDefault.default));
var _omitEventHandlers = require("./omitEventHandlers");
var _omitEventHandlersDefault = parcelHelpers.interopDefault(_omitEventHandlers);

},{"./omitEventHandlers":"l8kIx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l8kIx":[function(require,module,exports,__globalThis) {
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
exports.default = omitEventHandlers;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dzXZN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _resolveComponentPropsDefault.default));
var _resolveComponentProps = require("./resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);

},{"./resolveComponentProps":"8Meyr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Meyr":[function(require,module,exports,__globalThis) {
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
exports.default = resolveComponentProps;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"guLSb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getReactElementRefDefault.default));
var _getReactElementRef = require("./getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);

},{"./getReactElementRef":"j7ALZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j7ALZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getReactElementRef);
var _react = require("react");
function getReactElementRef(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt(_react.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kmSYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hSPSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const ThemeContext = /*#__PURE__*/ _react.createContext(null);
exports.default = ThemeContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3GQzX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useThemeDefault.default));
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);

},{"./useTheme":"lod3w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lod3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _themeContext = require("./ThemeContext");
var _themeContextDefault = parcelHelpers.interopDefault(_themeContext);
function useTheme() {
    const theme = _react.useContext((0, _themeContextDefault.default));
    return theme;
}

},{"react":"9njXz","./ThemeContext":"hSPSQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2OYd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
exports.default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aMQRu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRtl", ()=>useRtl);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "value"
];
const RtlContext = /*#__PURE__*/ _react.createContext();
function RtlProvider(_ref) {
    let { value } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RtlContext.Provider, (0, _extendsDefault.default)({
        value: value != null ? value : true
    }, props));
}
const useRtl = ()=>{
    const value = _react.useContext(RtlContext);
    return value != null ? value : false;
};
exports.default = RtlProvider;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiCyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DISABLE_CSS_TRANSITION", ()=>DISABLE_CSS_TRANSITION);
parcelHelpers.export(exports, "default", ()=>createCssVarsProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _styledEngine = require("@mui/styled-engine");
var _privateTheming = require("@mui/private-theming");
var _themeProvider = require("../ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _initColorSchemeScript = require("../InitColorSchemeScript/InitColorSchemeScript");
var _initColorSchemeScriptDefault = parcelHelpers.interopDefault(_initColorSchemeScript);
var _useCurrentColorScheme = require("./useCurrentColorScheme");
var _useCurrentColorSchemeDefault = parcelHelpers.interopDefault(_useCurrentColorScheme);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "colorSchemes",
    "components",
    "generateCssVars",
    "cssVarPrefix"
];
const DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function createCssVarsProvider(options) {
    const { themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, attribute: defaultAttribute = (0, _initColorSchemeScript.DEFAULT_ATTRIBUTE), modeStorageKey: defaultModeStorageKey = (0, _initColorSchemeScript.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, _initColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY), defaultMode: designSystemMode = 'light', defaultColorScheme: designSystemColorScheme, disableTransitionOnChange: designSystemTransitionOnChange = false, resolveTheme, excludeVariablesFromRoot } = options;
    if (!defaultTheme.colorSchemes || typeof designSystemColorScheme === 'string' && !defaultTheme.colorSchemes[designSystemColorScheme] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.light] || typeof designSystemColorScheme === 'object' && !defaultTheme.colorSchemes[designSystemColorScheme == null ? void 0 : designSystemColorScheme.dark]) console.error(`MUI: \`${designSystemColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
    const ColorSchemeContext = /*#__PURE__*/ _react.createContext(undefined);
    const useColorScheme = ()=>{
        const value = _react.useContext(ColorSchemeContext);
        if (!value) throw new Error((0, _formatMuiErrorMessageDefault.default)(19));
        return value;
    };
    function CssVarsProvider(props) {
        const { children, theme: themeProp = defaultTheme, modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey = defaultColorSchemeStorageKey, attribute = defaultAttribute, defaultMode = designSystemMode, defaultColorScheme = designSystemColorScheme, disableTransitionOnChange = designSystemTransitionOnChange, storageWindow = typeof window === 'undefined' ? undefined : window, documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, colorSchemeSelector = ':root', disableNestedContext = false, disableStyleSheetGeneration = false } = props;
        const hasMounted = _react.useRef(false);
        const upperTheme = (0, _privateTheming.useTheme)();
        const ctx = _react.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const scopedTheme = themeProp[themeId];
        const _ref = scopedTheme || themeProp, { colorSchemes = {}, components = {}, generateCssVars = ()=>({
                vars: {},
                css: {}
            }), cssVarPrefix } = _ref, restThemeProp = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
        const allColorSchemes = Object.keys(colorSchemes);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode, systemMode, lightColorScheme, darkColorScheme, colorScheme: stateColorScheme, setColorScheme } = (0, _useCurrentColorSchemeDefault.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey,
            colorSchemeStorageKey,
            defaultMode,
            storageWindow
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        const calculatedMode = (()=>{
            if (mode) return mode;
            // This scope occurs on the server
            if (defaultMode === 'system') return designSystemMode;
            return defaultMode;
        })();
        const calculatedColorScheme = (()=>{
            if (!colorScheme) {
                // This scope occurs on the server
                if (calculatedMode === 'dark') return defaultDarkColorScheme;
                // use light color scheme, if default mode is 'light' | 'system'
                return defaultLightColorScheme;
            }
            return colorScheme;
        })();
        // 2. Create CSS variables and store them in objects (to be generated in stylesheets in the final step)
        const { css: rootCss, vars: rootVars } = generateCssVars();
        // 3. Start composing the theme object
        const theme = (0, _extendsDefault.default)({}, restThemeProp, {
            components,
            colorSchemes,
            cssVarPrefix,
            vars: rootVars,
            getColorSchemeSelector: (targetColorScheme)=>`[${attribute}="${targetColorScheme}"] &`
        });
        // 4. Create color CSS variables and store them in objects (to be generated in stylesheets in the final step)
        //    The default color scheme stylesheet is constructed to have the least CSS specificity.
        //    The other color schemes uses selector, default as data attribute, to increase the CSS specificity so that they can override the default color scheme stylesheet.
        const defaultColorSchemeStyleSheet = {};
        const otherColorSchemesStyleSheet = {};
        Object.entries(colorSchemes).forEach(([key, scheme])=>{
            const { css, vars } = generateCssVars(key);
            theme.vars = (0, _deepmergeDefault.default)(theme.vars, vars);
            if (key === calculatedColorScheme) {
                // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = (0, _extendsDefault.default)({}, theme[schemeKey], scheme[schemeKey]);
                    else theme[schemeKey] = scheme[schemeKey];
                });
                if (theme.palette) theme.palette.colorScheme = key;
            }
            const resolvedDefaultColorScheme = (()=>{
                if (typeof defaultColorScheme === 'string') return defaultColorScheme;
                if (defaultMode === 'dark') return defaultColorScheme.dark;
                return defaultColorScheme.light;
            })();
            if (key === resolvedDefaultColorScheme) {
                if (excludeVariablesFromRoot) {
                    const excludedVariables = {};
                    excludeVariablesFromRoot(cssVarPrefix).forEach((cssVar)=>{
                        excludedVariables[cssVar] = css[cssVar];
                        delete css[cssVar];
                    });
                    defaultColorSchemeStyleSheet[`[${attribute}="${key}"]`] = excludedVariables;
                }
                defaultColorSchemeStyleSheet[`${colorSchemeSelector}, [${attribute}="${key}"]`] = css;
            } else otherColorSchemesStyleSheet[`${colorSchemeSelector === ':root' ? '' : colorSchemeSelector}[${attribute}="${key}"]`] = css;
        });
        theme.vars = (0, _deepmergeDefault.default)(theme.vars, rootVars);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        _react.useEffect(()=>{
            if (colorScheme && colorSchemeNode) // attaches attribute to <html> because the css variables are attached to :root (html)
            colorSchemeNode.setAttribute(attribute, colorScheme);
        }, [
            colorScheme,
            attribute,
            colorSchemeNode
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        _react.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode(DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        _react.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = _react.useMemo(()=>({
                allColorSchemes,
                colorScheme,
                darkColorScheme,
                lightColorScheme,
                mode,
                setColorScheme,
                setMode,
                systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || nested && (upperTheme == null ? void 0 : upperTheme.cssVarPrefix) === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
            children: [
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
                            styles: {
                                [colorSchemeSelector]: rootCss
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
                            styles: defaultColorSchemeStyleSheet
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledEngine.GlobalStyles), {
                            styles: otherColorSchemesStyleSheet
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeProviderDefault.default), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: resolveTheme ? resolveTheme(theme) : theme,
                    children: children
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.light;
    const defaultDarkColorScheme = typeof designSystemColorScheme === 'string' ? designSystemColorScheme : designSystemColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, _initColorSchemeScriptDefault.default)((0, _extendsDefault.default)({
            attribute: defaultAttribute,
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultMode: designSystemMode,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey
        }, params));
    return {
        CssVarsProvider,
        useColorScheme,
        getInitColorSchemeScript
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/formatMuiErrorMessage":"awvJV","react":"9njXz","prop-types":"bnNSm","@mui/utils/deepmerge":"aRydR","@mui/styled-engine":"4hxt2","@mui/private-theming":"faJCj","../ThemeProvider":"ljFOn","../InitColorSchemeScript/InitColorSchemeScript":"jxL8I","./useCurrentColorScheme":"eNvsl","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jxL8I":[function(require,module,exports,__globalThis) {
/**
 * Split this component for RSC import
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_MODE_STORAGE_KEY", ()=>DEFAULT_MODE_STORAGE_KEY);
parcelHelpers.export(exports, "DEFAULT_COLOR_SCHEME_STORAGE_KEY", ()=>DEFAULT_COLOR_SCHEME_STORAGE_KEY);
parcelHelpers.export(exports, "DEFAULT_ATTRIBUTE", ()=>DEFAULT_ATTRIBUTE);
parcelHelpers.export(exports, "default", ()=>InitColorSchemeScript);
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const DEFAULT_MODE_STORAGE_KEY = 'mode';
const DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const DEFAULT_ATTRIBUTE = 'data-color-scheme';
function InitColorSchemeScript(options) {
    const { defaultMode = 'light', defaultLightColorScheme = 'light', defaultDarkColorScheme = 'dark', modeStorageKey = DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute = DEFAULT_ATTRIBUTE, colorSchemeNode = 'document.documentElement', nonce } = options || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  var mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  var colorScheme = '';
  if (mode === 'system') {
    // handle system mode
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
    } else {
      colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
    }
  }
  if (mode === 'light') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  }
  if (mode === 'dark') {
    colorScheme = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  }
  if (colorScheme) {
    ${colorSchemeNode}.setAttribute('${attribute}', colorScheme);
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

},{"react":"9njXz","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNvsl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSystemMode", ()=>getSystemMode);
parcelHelpers.export(exports, "getColorScheme", ()=>getColorScheme);
parcelHelpers.export(exports, "default", ()=>useCurrentColorScheme);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _initColorSchemeScript = require("../InitColorSchemeScript/InitColorSchemeScript");
'use client';
function getSystemMode(mode) {
    if (typeof window !== 'undefined' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function getColorScheme(state) {
    return processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function initializeValue(key, defaultValue) {
    if (typeof window === 'undefined') return undefined;
    let value;
    try {
        value = localStorage.getItem(key) || undefined;
        if (!value) // the first time that user enters the site.
        localStorage.setItem(key, defaultValue);
    } catch (e) {
    // Unsupported
    }
    return value || defaultValue;
}
function useCurrentColorScheme(options) {
    const { defaultMode = 'light', defaultLightColorScheme, defaultDarkColorScheme, supportedColorSchemes = [], modeStorageKey = (0, _initColorSchemeScript.DEFAULT_MODE_STORAGE_KEY), colorSchemeStorageKey = (0, _initColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY), storageWindow = typeof window === 'undefined' ? undefined : window } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const [state, setState] = _react.useState(()=>{
        const initialMode = initializeValue(modeStorageKey, defaultMode);
        const lightColorScheme = initializeValue(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
        const darkColorScheme = initializeValue(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
        return {
            mode: initialMode,
            systemMode: getSystemMode(initialMode),
            lightColorScheme,
            darkColorScheme
        };
    });
    const colorScheme = getColorScheme(state);
    const setMode = _react.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode != null ? mode : defaultMode;
            try {
                localStorage.setItem(modeStorageKey, newMode);
            } catch (e) {
            // Unsupported
            }
            return (0, _extendsDefault.default)({}, currentState, {
                mode: newMode,
                systemMode: getSystemMode(newMode)
            });
        });
    }, [
        modeStorageKey,
        defaultMode
    ]);
    const setColorScheme = _react.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            try {
                localStorage.setItem(`${colorSchemeStorageKey}-light`, defaultLightColorScheme);
                localStorage.setItem(`${colorSchemeStorageKey}-dark`, defaultDarkColorScheme);
            } catch (e) {
            // Unsupported
            }
            return (0, _extendsDefault.default)({}, currentState, {
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            });
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = (0, _extendsDefault.default)({}, currentState);
                processState(currentState, (mode)=>{
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-${mode}`, value);
                    } catch (e) {
                    // Unsupported
                    }
                    if (mode === 'light') newState.lightColorScheme = value;
                    if (mode === 'dark') newState.darkColorScheme = value;
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = (0, _extendsDefault.default)({}, currentState);
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-light`, newLightColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    try {
                        localStorage.setItem(`${colorSchemeStorageKey}-dark`, newDarkColorScheme);
                    } catch (error) {
                    // Unsupported
                    }
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        colorSchemeStorageKey,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = _react.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event != null && event.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return (0, _extendsDefault.default)({}, currentState, {
                systemMode
            });
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = _react.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    _react.useEffect(()=>{
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, []);
    // Handle when localStorage has changed
    _react.useEffect(()=>{
        if (storageWindow) {
            const handleStorage = (event)=>{
                const value = event.newValue;
                if (typeof event.key === 'string' && event.key.startsWith(colorSchemeStorageKey) && (!value || joinedColorSchemes.match(value))) {
                    // If the key is deleted, value will be null then reset color scheme to the default one.
                    if (event.key.endsWith('light')) setColorScheme({
                        light: value
                    });
                    if (event.key.endsWith('dark')) setColorScheme({
                        dark: value
                    });
                }
                if (event.key === modeStorageKey && (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value))) setMode(value || defaultMode);
            };
            // For syncing color-scheme changes between iframes
            storageWindow.addEventListener('storage', handleStorage);
            return ()=>{
                storageWindow.removeEventListener('storage', handleStorage);
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        modeStorageKey,
        colorSchemeStorageKey,
        joinedColorSchemes,
        defaultMode,
        storageWindow
    ]);
    return (0, _extendsDefault.default)({}, state, {
        colorScheme,
        setMode,
        setColorScheme
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","../InitColorSchemeScript/InitColorSchemeScript":"jxL8I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"30Mi2":[function(require,module,exports,__globalThis) {
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createGetCssVar);
function createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kLBNa":[function(require,module,exports,__globalThis) {
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assignNestedKeys", ()=>assignNestedKeys);
parcelHelpers.export(exports, "walkObjectDeep", ()=>walkObjectDeep);
parcelHelpers.export(exports, "default", ()=>cssVarsParser);
const assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().indexOf('opacity') >= 0) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function cssVarsParser(theme, options) {
    const { prefix, shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                Object.assign(css, {
                    [cssVar]: getCssValue(keys, value)
                });
                assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${value})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css,
        vars,
        varsWithDefaults
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9iNQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _toPropertyKey = require("@babel/runtime/helpers/esm/toPropertyKey");
var _toPropertyKeyDefault = parcelHelpers.interopDefault(_toPropertyKey);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _cssVarsParser = require("./cssVarsParser");
var _cssVarsParserDefault = parcelHelpers.interopDefault(_cssVarsParser);
const _excluded = [
    "colorSchemes",
    "components",
    "defaultColorScheme"
];
function prepareCssVars(theme, parserConfig) {
    // @ts-ignore - ignore components do not exist
    const { colorSchemes = {}, defaultColorScheme = 'light' } = theme, otherTheme = (0, _objectWithoutPropertiesLooseDefault.default)(theme, _excluded);
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, _cssVarsParserDefault.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: light } = colorSchemes, otherColorSchemes = (0, _objectWithoutPropertiesLooseDefault.default)(colorSchemes, [
        defaultColorScheme
    ].map((0, _toPropertyKeyDefault.default)));
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars, css, varsWithDefaults } = (0, _cssVarsParserDefault.default)(scheme, parserConfig);
        themeVars = (0, _deepmergeDefault.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css,
            vars
        };
    });
    if (light) {
        // default color scheme vars should be merged last to set as default
        const { css, vars, varsWithDefaults } = (0, _cssVarsParserDefault.default)(light, parserConfig);
        themeVars = (0, _deepmergeDefault.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css,
            vars
        };
    }
    const generateCssVars = (colorScheme)=>{
        var _parserConfig$getSele2;
        if (!colorScheme) {
            var _parserConfig$getSele;
            const css = (0, _extendsDefault.default)({}, rootCss);
            return {
                css,
                vars: rootVars,
                selector: (parserConfig == null || (_parserConfig$getSele = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele.call(parserConfig, colorScheme, css)) || ':root'
            };
        }
        const css = (0, _extendsDefault.default)({}, colorSchemesMap[colorScheme].css);
        return {
            css,
            vars: colorSchemesMap[colorScheme].vars,
            selector: (parserConfig == null || (_parserConfig$getSele2 = parserConfig.getSelector) == null ? void 0 : _parserConfig$getSele2.call(parserConfig, colorScheme, css)) || ':root'
        };
    };
    return {
        vars: themeVars,
        generateCssVars
    };
}
exports.default = prepareCssVars;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/toPropertyKey":"61Sn9","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/deepmerge":"aRydR","./cssVarsParser":"kLBNa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2JA2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "createStack", ()=>(0, _createStackDefault.default));
parcelHelpers.export(exports, "stackClasses", ()=>(0, _stackClassesDefault.default));
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _createStack = require("./createStack");
var _createStackDefault = parcelHelpers.interopDefault(_createStack);
var _stackProps = require("./StackProps");
parcelHelpers.exportAll(_stackProps, exports);
var _stackClasses = require("./stackClasses");
var _stackClassesDefault = parcelHelpers.interopDefault(_stackClasses);
parcelHelpers.exportAll(_stackClasses, exports);
'use client';

},{"./Stack":false,"./createStack":"ah8v5","./StackProps":false,"./stackClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ah8v5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "style", ()=>style);
parcelHelpers.export(exports, "default", ()=>createStack);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useThemeProps = require("../useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styleFunctionSx = require("../styleFunctionSx");
var _createTheme = require("../createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _breakpoints = require("../breakpoints");
var _spacing = require("../spacing");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const defaultTheme = (0, _createThemeDefault.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _styledDefault.default)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function useThemePropsDefault(props) {
    return (0, _useThemePropsDefault.default)({
        props,
        name: 'MuiStack',
        defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function joinChildren(children, separator) {
    const childrenArray = _react.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ _react.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const style = ({ ownerState, theme })=>{
    let styles = (0, _extendsDefault.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, _breakpoints.handleBreakpoints)({
        theme
    }, (0, _breakpoints.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, _spacing.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, _breakpoints.resolveBreakpointValues)({
            values: ownerState.direction,
            base
        });
        const spacingValues = (0, _breakpoints.resolveBreakpointValues)({
            values: ownerState.spacing,
            base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, _spacing.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, _spacing.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, _deepmergeDefault.default)(styles, (0, _breakpoints.handleBreakpoints)({
            theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, _breakpoints.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function createStack(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, _composeClassesDefault.default)(slots, (slot)=>(0, _generateUtilityClassDefault.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent(style);
    const Stack = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, _styleFunctionSx.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const { component = 'div', direction = 'column', spacing = 0, divider, children, className, useFlexGap = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
        const ownerState = {
            direction,
            spacing,
            useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StackRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            children: divider ? joinChildren(children, divider) : children
        }));
    });
    return Stack;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/deepmerge":"aRydR","@mui/utils/generateUtilityClass":"ktE5h","@mui/utils/composeClasses":"43D21","../styled":"gaki6","../useThemeProps":"3fKK0","../styleFunctionSx":"8WdLC","../createTheme":"2h77y","../breakpoints":"9gmyo","../spacing":"9oZxj","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fUW0U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
function Ripple(props) {
    const { className, classes, pulsate = false, rippleX, rippleY, rippleSize, in: inProp, onExited, timeout } = props;
    const [leaving, setLeaving] = _react.useState(false);
    const rippleClassName = (0, _clsxDefault.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, _clsxDefault.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    _react.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: childClassName
        })
    });
}
exports.default = Ripple;

},{"react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"H6sp0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTouchRippleUtilityClass", ()=>getTouchRippleUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTouchRippleUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTouchRipple', slot);
}
const touchRippleClasses = (0, _generateUtilityClassesDefault.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
exports.default = touchRippleClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"flxF9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getButtonBaseUtilityClass", ()=>getButtonBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getButtonBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiButtonBase', slot);
}
const buttonBaseClasses = (0, _generateUtilityClassesDefault.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
exports.default = buttonBaseClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hzEJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChipUtilityClass", ()=>getChipUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getChipUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiChip', slot);
}
const chipClasses = (0, _generateUtilityClassesDefault.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
exports.default = chipClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"73kto":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _boxDefault.default));
parcelHelpers.export(exports, "boxClasses", ()=>(0, _boxClassesDefault.default));
var _box = require("./Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _boxClasses = require("./boxClasses");
var _boxClassesDefault = parcelHelpers.interopDefault(_boxClasses);
parcelHelpers.exportAll(_boxClasses, exports);
'use client';

},{"./Box":"4gzkw","./boxClasses":"g1SKC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gzkw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _system = require("@mui/system");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _className = require("../className");
var _styles = require("../styles");
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _boxClasses = require("./boxClasses");
var _boxClassesDefault = parcelHelpers.interopDefault(_boxClasses);
'use client';
const defaultTheme = (0, _styles.createTheme)();
const Box = (0, _system.createBox)({
    themeId: (0, _identifierDefault.default),
    defaultTheme,
    defaultClassName: (0, _boxClassesDefault.default).root,
    generateClassName: (0, _className.unstable_ClassNameGenerator).generate
});
exports.default = Box;

},{"@mui/system":"5Hnj5","prop-types":"bnNSm","../className":"8MBSc","../styles":"c9RfU","../styles/identifier":"asvw3","./boxClasses":"g1SKC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8MBSc":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line import/prefer-default-export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>(0, _utils.unstable_ClassNameGenerator));
var _utils = require("@mui/utils");

},{"@mui/utils":"lfcNH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9RfU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "THEME_ID", ()=>(0, _identifierDefault.default));
parcelHelpers.export(exports, "adaptV4Theme", ()=>(0, _adaptV4ThemeDefault.default));
parcelHelpers.export(exports, "hexToRgb", ()=>(0, _system.hexToRgb));
parcelHelpers.export(exports, "rgbToHex", ()=>(0, _system.rgbToHex));
parcelHelpers.export(exports, "hslToRgb", ()=>(0, _system.hslToRgb));
parcelHelpers.export(exports, "decomposeColor", ()=>(0, _system.decomposeColor));
parcelHelpers.export(exports, "recomposeColor", ()=>(0, _system.recomposeColor));
parcelHelpers.export(exports, "getContrastRatio", ()=>(0, _system.getContrastRatio));
parcelHelpers.export(exports, "getLuminance", ()=>(0, _system.getLuminance));
parcelHelpers.export(exports, "emphasize", ()=>(0, _system.emphasize));
parcelHelpers.export(exports, "alpha", ()=>(0, _system.alpha));
parcelHelpers.export(exports, "darken", ()=>(0, _system.darken));
parcelHelpers.export(exports, "lighten", ()=>(0, _system.lighten));
parcelHelpers.export(exports, "css", ()=>(0, _system.css));
parcelHelpers.export(exports, "keyframes", ()=>(0, _system.keyframes));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "createMuiTheme", ()=>(0, _createTheme.createMuiTheme));
parcelHelpers.export(exports, "unstable_createMuiStrictModeTheme", ()=>(0, _createMuiStrictModeThemeDefault.default));
parcelHelpers.export(exports, "createStyles", ()=>(0, _createStylesDefault.default));
parcelHelpers.export(exports, "unstable_getUnit", ()=>(0, _cssUtils.getUnit));
parcelHelpers.export(exports, "unstable_toUnitless", ()=>(0, _cssUtils.toUnitless));
parcelHelpers.export(exports, "responsiveFontSizes", ()=>(0, _responsiveFontSizesDefault.default));
parcelHelpers.export(exports, "duration", ()=>(0, _createTransitions.duration));
parcelHelpers.export(exports, "easing", ()=>(0, _createTransitions.easing));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useThemeProps", ()=>(0, _useThemePropsDefault.default));
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "experimentalStyled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _system.StyledEngineProvider));
// The legacy utilities from @mui/styles
// These are just empty functions that throws when invoked
parcelHelpers.export(exports, "makeStyles", ()=>(0, _makeStylesDefault.default));
parcelHelpers.export(exports, "withStyles", ()=>(0, _withStylesDefault.default));
parcelHelpers.export(exports, "withTheme", ()=>(0, _withThemeDefault.default));
parcelHelpers.export(exports, "experimental_extendTheme", ()=>(0, _experimentalExtendThemeDefault.default));
parcelHelpers.export(exports, "getOverlayAlpha", ()=>(0, _getOverlayAlphaDefault.default));
parcelHelpers.export(exports, "shouldSkipGeneratingVar", ()=>(0, _shouldSkipGeneratingVarDefault.default));
// Private methods for creating parts of the theme
parcelHelpers.export(exports, "private_createTypography", ()=>(0, _createTypographyDefault.default));
parcelHelpers.export(exports, "private_createMixins", ()=>(0, _createMixinsDefault.default));
parcelHelpers.export(exports, "private_excludeVariablesFromRoot", ()=>(0, _excludeVariablesFromRootDefault.default));
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
parcelHelpers.export(exports, "experimental_sx", ()=>experimental_sx);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _adaptV4Theme = require("./adaptV4Theme");
var _adaptV4ThemeDefault = parcelHelpers.interopDefault(_adaptV4Theme);
var _system = require("@mui/system");
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _createMuiStrictModeTheme = require("./createMuiStrictModeTheme");
var _createMuiStrictModeThemeDefault = parcelHelpers.interopDefault(_createMuiStrictModeTheme);
var _createStyles = require("./createStyles");
var _createStylesDefault = parcelHelpers.interopDefault(_createStyles);
var _cssUtils = require("./cssUtils");
var _responsiveFontSizes = require("./responsiveFontSizes");
var _responsiveFontSizesDefault = parcelHelpers.interopDefault(_responsiveFontSizes);
var _createTransitions = require("./createTransitions");
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useThemeProps = require("./useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
var _makeStyles = require("./makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
var _withStyles = require("./withStyles");
var _withStylesDefault = parcelHelpers.interopDefault(_withStyles);
var _withTheme = require("./withTheme");
var _withThemeDefault = parcelHelpers.interopDefault(_withTheme);
var _cssVarsProvider = require("./CssVarsProvider");
parcelHelpers.exportAll(_cssVarsProvider, exports);
var _experimentalExtendTheme = require("./experimental_extendTheme");
var _experimentalExtendThemeDefault = parcelHelpers.interopDefault(_experimentalExtendTheme);
var _getOverlayAlpha = require("./getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
var _shouldSkipGeneratingVar = require("./shouldSkipGeneratingVar");
var _shouldSkipGeneratingVarDefault = parcelHelpers.interopDefault(_shouldSkipGeneratingVar);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _createMixins = require("./createMixins");
var _createMixinsDefault = parcelHelpers.interopDefault(_createMixins);
var _excludeVariablesFromRoot = require("./excludeVariablesFromRoot");
var _excludeVariablesFromRootDefault = parcelHelpers.interopDefault(_excludeVariablesFromRoot);
'use client';
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(20));
}

},{"@mui/utils/formatMuiErrorMessage":"awvJV","./identifier":"asvw3","./adaptV4Theme":"dLuKA","@mui/system":"5Hnj5","./createTheme":"itHnG","./createMuiStrictModeTheme":"61Xm8","./createStyles":"2udPr","./cssUtils":"a70O5","./responsiveFontSizes":"6Byx5","./createTransitions":"4xJuz","./useTheme":"d8hfc","./useThemeProps":"9ffJF","./styled":"bTnxF","./ThemeProvider":"1Q7kB","./makeStyles":"irmH0","./withStyles":"bWZlL","./withTheme":"lTNkx","./CssVarsProvider":"bwlxr","./experimental_extendTheme":"lPQpc","./getOverlayAlpha":"5bDnG","./shouldSkipGeneratingVar":"i7Nw9","./createTypography":"byLfw","./createMixins":"dprtV","./excludeVariablesFromRoot":"2gXZR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dLuKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>adaptV4Theme);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _system = require("@mui/system");
const _excluded = [
    "defaultProps",
    "mixins",
    "overrides",
    "palette",
    "props",
    "styleOverrides"
], _excluded2 = [
    "type",
    "mode"
];
function adaptV4Theme(inputTheme) {
    const { defaultProps = {}, mixins = {}, overrides = {}, palette = {}, props = {}, styleOverrides = {} } = inputTheme, other = (0, _objectWithoutPropertiesLooseDefault.default)(inputTheme, _excluded);
    const theme = (0, _extendsDefault.default)({}, other, {
        components: {}
    });
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, _system.createSpacing)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, _system.createBreakpoints)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = (0, _extendsDefault.default)({
        gutters: (styles = {})=>{
            return (0, _extendsDefault.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, {
                [breakpoints.up('sm')]: (0, _extendsDefault.default)({
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3)
                }, styles[breakpoints.up('sm')])
            });
        }
    }, mixins);
    const { type: typeInput, mode: modeInput } = palette, paletteRest = (0, _objectWithoutPropertiesLooseDefault.default)(palette, _excluded2);
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = (0, _extendsDefault.default)({
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode
    }, paletteRest);
    return theme;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/system":"5Hnj5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61Xm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createMuiStrictModeTheme);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
function createMuiStrictModeTheme(options, ...args) {
    return (0, _createThemeDefault.default)((0, _deepmergeDefault.default)({
        unstable_strictMode: true
    }, options), ...args);
}

},{"@mui/utils/deepmerge":"aRydR","./createTheme":"itHnG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2udPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createStyles);
let warnedOnce = false;
function createStyles(styles) {
    if (!warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        warnedOnce = true;
    }
    return styles;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a70O5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isUnitless", ()=>isUnitless);
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
parcelHelpers.export(exports, "getUnit", ()=>getUnit);
// Emulate the sass function "unitless"
parcelHelpers.export(exports, "toUnitless", ()=>toUnitless);
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
parcelHelpers.export(exports, "convertLength", ()=>convertLength);
parcelHelpers.export(exports, "alignProperty", ()=>alignProperty);
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
parcelHelpers.export(exports, "fontGrid", ()=>fontGrid);
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ parcelHelpers.export(exports, "responsiveProperty", ()=>responsiveProperty);
function isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function toUnitless(length) {
    return parseFloat(length);
}
function convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = toUnitless(length) * toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = toUnitless(length) * toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function alignProperty({ size, grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function fontGrid({ lineHeight, pixels, htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function responsiveProperty({ cssProperty, min, max, unit = 'rem', breakpoints = [
    600,
    900,
    1200
], transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Byx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>responsiveFontSizes);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _cssUtils = require("./cssUtils");
function responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign = false, factor = 2, variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = (0, _extendsDefault.default)({}, themeInput);
    theme.typography = (0, _extendsDefault.default)({}, theme.typography);
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight } = style;
        if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, _formatMuiErrorMessageDefault.default)(6));
        if (!(0, _cssUtils.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, _cssUtils.alignProperty)({
                size: value,
                grid: (0, _cssUtils.fontGrid)({
                    pixels: 4,
                    lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        typography[variant] = (0, _extendsDefault.default)({}, style, (0, _cssUtils.responsiveProperty)({
            cssProperty: 'fontSize',
            min: minFontSize,
            max: maxFontSize,
            unit: 'rem',
            breakpoints: breakpointValues,
            transform
        }));
    });
    return theme;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/formatMuiErrorMessage":"awvJV","./cssUtils":"a70O5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d8hfc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _system = require("@mui/system");
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
'use client';
function useTheme() {
    const theme = (0, _system.useTheme)((0, _defaultThemeDefault.default));
    return theme[0, _identifierDefault.default] || theme;
}

},{"react":"9njXz","@mui/system":"5Hnj5","./defaultTheme":"gDdTD","./identifier":"asvw3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ffJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useThemeProps);
var _useThemeProps = require("@mui/system/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _defaultTheme = require("./defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
'use client';
function useThemeProps({ props, name }) {
    return (0, _useThemePropsDefault.default)({
        props,
        name,
        defaultTheme: (0, _defaultThemeDefault.default),
        themeId: (0, _identifierDefault.default)
    });
}

},{"@mui/system/useThemeProps":"3fKK0","./defaultTheme":"gDdTD","./identifier":"asvw3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Q7kB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ThemeProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "theme"
];
function ThemeProvider(_ref) {
    let { theme: themeInput } = _ref, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    const scopedTheme = themeInput[0, _identifierDefault.default];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.ThemeProvider), (0, _extendsDefault.default)({}, props, {
        themeId: scopedTheme ? (0, _identifierDefault.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/system":"5Hnj5","./identifier":"asvw3","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irmH0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>makeStyles);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function makeStyles() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(14));
}

},{"@mui/utils/formatMuiErrorMessage":"awvJV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bWZlL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>withStyles);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function withStyles() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(15));
}

},{"@mui/utils/formatMuiErrorMessage":"awvJV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTNkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>withTheme);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
function withTheme() {
    throw new Error((0, _formatMuiErrorMessageDefault.default)(16));
}

},{"@mui/utils/formatMuiErrorMessage":"awvJV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bwlxr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInitColorSchemeScript", ()=>getInitColorSchemeScript);
parcelHelpers.export(exports, "useColorScheme", ()=>useColorScheme);
parcelHelpers.export(exports, "Experimental_CssVarsProvider", ()=>CssVarsProvider);
// do not remove the following import (https://github.com/microsoft/TypeScript/issues/29808#issuecomment-1320713018)
/* eslint-disable @typescript-eslint/no-unused-vars */ // @ts-ignore
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _system = require("@mui/system");
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _experimentalExtendTheme = require("./experimental_extendTheme");
var _experimentalExtendThemeDefault = parcelHelpers.interopDefault(_experimentalExtendTheme);
var _createTypography = require("./createTypography");
var _createTypographyDefault = parcelHelpers.interopDefault(_createTypography);
var _excludeVariablesFromRoot = require("./excludeVariablesFromRoot");
var _excludeVariablesFromRootDefault = parcelHelpers.interopDefault(_excludeVariablesFromRoot);
var _identifier = require("./identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _initColorSchemeScript = require("../InitColorSchemeScript/InitColorSchemeScript");
'use client';
const defaultTheme = (0, _experimentalExtendThemeDefault.default)();
const { CssVarsProvider, useColorScheme, getInitColorSchemeScript: getInitColorSchemeScriptSystem } = (0, _system.unstable_createCssVarsProvider)({
    themeId: (0, _identifierDefault.default),
    theme: defaultTheme,
    attribute: (0, _initColorSchemeScript.defaultConfig).attribute,
    colorSchemeStorageKey: (0, _initColorSchemeScript.defaultConfig).colorSchemeStorageKey,
    modeStorageKey: (0, _initColorSchemeScript.defaultConfig).modeStorageKey,
    defaultColorScheme: {
        light: (0, _initColorSchemeScript.defaultConfig).defaultLightColorScheme,
        dark: (0, _initColorSchemeScript.defaultConfig).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = (0, _extendsDefault.default)({}, theme, {
            typography: (0, _createTypographyDefault.default)(theme.palette, theme.typography)
        });
        newTheme.unstable_sx = function sx(props) {
            return (0, _styleFunctionSxDefault.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    },
    excludeVariablesFromRoot: (0, _excludeVariablesFromRootDefault.default)
});
const getInitColorSchemeScript = getInitColorSchemeScriptSystem;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/system":"5Hnj5","@mui/system/styleFunctionSx":"8WdLC","./experimental_extendTheme":"lPQpc","./createTypography":"byLfw","./excludeVariablesFromRoot":"2gXZR","./identifier":"asvw3","../InitColorSchemeScript/InitColorSchemeScript":"2AVL2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lPQpc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGetCssVar", ()=>createGetCssVar);
parcelHelpers.export(exports, "default", ()=>extendTheme);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _system = require("@mui/system");
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _styleFunctionSxDefault = parcelHelpers.interopDefault(_styleFunctionSx);
var _colorManipulator = require("@mui/system/colorManipulator");
var _shouldSkipGeneratingVar = require("./shouldSkipGeneratingVar");
var _shouldSkipGeneratingVarDefault = parcelHelpers.interopDefault(_shouldSkipGeneratingVar);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _getOverlayAlpha = require("./getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
const _excluded = [
    "colorSchemes",
    "cssVarPrefix",
    "shouldSkipGeneratingVar"
], _excluded2 = [
    "palette"
];
const defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return undefined;
    const overlay = (0, _getOverlayAlphaDefault.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function toRgb(color) {
    if (!color || !color.startsWith('hsl')) return color;
    return (0, _colorManipulator.hslToRgb)(color);
}
function setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, _colorManipulator.private_safeColorChannel)(toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
const silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const createGetCssVar = (cssVarPrefix = 'mui')=>(0, _system.unstable_createGetCssVar)(cssVarPrefix);
function extendTheme(options = {}, ...args) {
    var _colorSchemesInput$li, _colorSchemesInput$da, _colorSchemesInput$li2, _colorSchemesInput$li3, _colorSchemesInput$da2, _colorSchemesInput$da3;
    const { colorSchemes: colorSchemesInput = {}, cssVarPrefix = 'mui', shouldSkipGeneratingVar = (0, _shouldSkipGeneratingVarDefault.default) } = options, input = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    const getCssVar = createGetCssVar(cssVarPrefix);
    const _createThemeWithoutVa = (0, _createThemeDefault.default)((0, _extendsDefault.default)({}, input, colorSchemesInput.light && {
        palette: (_colorSchemesInput$li = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li.palette
    })), { palette: lightPalette } = _createThemeWithoutVa, muiTheme = (0, _objectWithoutPropertiesLooseDefault.default)(_createThemeWithoutVa, _excluded2);
    const { palette: darkPalette } = (0, _createThemeDefault.default)({
        palette: (0, _extendsDefault.default)({
            mode: 'dark'
        }, (_colorSchemesInput$da = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da.palette)
    });
    let theme = (0, _extendsDefault.default)({}, muiTheme, {
        cssVarPrefix,
        getCssVar,
        colorSchemes: (0, _extendsDefault.default)({}, colorSchemesInput, {
            light: (0, _extendsDefault.default)({}, colorSchemesInput.light, {
                palette: lightPalette,
                opacity: (0, _extendsDefault.default)({
                    inputPlaceholder: 0.42,
                    inputUnderline: 0.42,
                    switchTrackDisabled: 0.12,
                    switchTrack: 0.38
                }, (_colorSchemesInput$li2 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li2.opacity),
                overlays: ((_colorSchemesInput$li3 = colorSchemesInput.light) == null ? void 0 : _colorSchemesInput$li3.overlays) || []
            }),
            dark: (0, _extendsDefault.default)({}, colorSchemesInput.dark, {
                palette: darkPalette,
                opacity: (0, _extendsDefault.default)({
                    inputPlaceholder: 0.5,
                    inputUnderline: 0.7,
                    switchTrackDisabled: 0.2,
                    switchTrack: 0.3
                }, (_colorSchemesInput$da2 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da2.opacity),
                overlays: ((_colorSchemesInput$da3 = colorSchemesInput.dark) == null ? void 0 : _colorSchemesInput$da3.overlays) || defaultDarkOverlays
            })
        })
    });
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (key === 'light') {
            setColor(palette.common, 'background', '#fff');
            setColor(palette.common, 'onBackground', '#000');
        } else {
            setColor(palette.common, 'background', '#000');
            setColor(palette.common, 'onBackground', '#fff');
        }
        // assign component variables
        assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (key === 'light') {
            setColor(palette.Alert, 'errorColor', (0, _colorManipulator.private_safeDarken)(palette.error.light, 0.6));
            setColor(palette.Alert, 'infoColor', (0, _colorManipulator.private_safeDarken)(palette.info.light, 0.6));
            setColor(palette.Alert, 'successColor', (0, _colorManipulator.private_safeDarken)(palette.success.light, 0.6));
            setColor(palette.Alert, 'warningColor', (0, _colorManipulator.private_safeDarken)(palette.warning.light, 0.6));
            setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            setColor(palette.Alert, 'errorFilledColor', silent(()=>lightPalette.getContrastText(palette.error.main)));
            setColor(palette.Alert, 'infoFilledColor', silent(()=>lightPalette.getContrastText(palette.info.main)));
            setColor(palette.Alert, 'successFilledColor', silent(()=>lightPalette.getContrastText(palette.success.main)));
            setColor(palette.Alert, 'warningFilledColor', silent(()=>lightPalette.getContrastText(palette.warning.main)));
            setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator.private_safeLighten)(palette.error.light, 0.9));
            setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator.private_safeLighten)(palette.info.light, 0.9));
            setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator.private_safeLighten)(palette.success.light, 0.9));
            setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator.private_safeLighten)(palette.warning.light, 0.9));
            setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.Slider, 'errorTrack', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.Slider, 'infoTrack', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.Slider, 'successTrack', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.Slider, 'warningTrack', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            const snackbarContentBackground = (0, _colorManipulator.private_safeEmphasize)(palette.background.default, 0.8);
            setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            setColor(palette.SnackbarContent, 'color', silent(()=>lightPalette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator.private_safeEmphasize)(palette.background.paper, 0.15));
            setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.primary.main, 0.62));
            setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.secondary.main, 0.62));
            setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.error.main, 0.62));
            setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.info.main, 0.62));
            setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.success.main, 0.62));
            setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator.private_safeLighten)(palette.warning.main, 0.62));
            setColor(palette.TableCell, 'border', (0, _colorManipulator.private_safeLighten)((0, _colorManipulator.private_safeAlpha)(palette.divider, 1), 0.88));
            setColor(palette.Tooltip, 'bg', (0, _colorManipulator.private_safeAlpha)(palette.grey[700], 0.92));
        } else {
            setColor(palette.Alert, 'errorColor', (0, _colorManipulator.private_safeLighten)(palette.error.light, 0.6));
            setColor(palette.Alert, 'infoColor', (0, _colorManipulator.private_safeLighten)(palette.info.light, 0.6));
            setColor(palette.Alert, 'successColor', (0, _colorManipulator.private_safeLighten)(palette.success.light, 0.6));
            setColor(palette.Alert, 'warningColor', (0, _colorManipulator.private_safeLighten)(palette.warning.light, 0.6));
            setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            setColor(palette.Alert, 'errorFilledColor', silent(()=>darkPalette.getContrastText(palette.error.dark)));
            setColor(palette.Alert, 'infoFilledColor', silent(()=>darkPalette.getContrastText(palette.info.dark)));
            setColor(palette.Alert, 'successFilledColor', silent(()=>darkPalette.getContrastText(palette.success.dark)));
            setColor(palette.Alert, 'warningFilledColor', silent(()=>darkPalette.getContrastText(palette.warning.dark)));
            setColor(palette.Alert, 'errorStandardBg', (0, _colorManipulator.private_safeDarken)(palette.error.light, 0.9));
            setColor(palette.Alert, 'infoStandardBg', (0, _colorManipulator.private_safeDarken)(palette.info.light, 0.9));
            setColor(palette.Alert, 'successStandardBg', (0, _colorManipulator.private_safeDarken)(palette.success.light, 0.9));
            setColor(palette.Alert, 'warningStandardBg', (0, _colorManipulator.private_safeDarken)(palette.warning.light, 0.9));
            setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            setColor(palette.LinearProgress, 'primaryBg', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.5));
            setColor(palette.LinearProgress, 'secondaryBg', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.5));
            setColor(palette.LinearProgress, 'errorBg', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.5));
            setColor(palette.LinearProgress, 'infoBg', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.5));
            setColor(palette.LinearProgress, 'successBg', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.5));
            setColor(palette.LinearProgress, 'warningBg', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.5));
            setColor(palette.Skeleton, 'bg', `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            setColor(palette.Slider, 'primaryTrack', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.5));
            setColor(palette.Slider, 'secondaryTrack', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.5));
            setColor(palette.Slider, 'errorTrack', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.5));
            setColor(palette.Slider, 'infoTrack', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.5));
            setColor(palette.Slider, 'successTrack', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.5));
            setColor(palette.Slider, 'warningTrack', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.5));
            const snackbarContentBackground = (0, _colorManipulator.private_safeEmphasize)(palette.background.default, 0.98);
            setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            setColor(palette.SnackbarContent, 'color', silent(()=>darkPalette.getContrastText(snackbarContentBackground)));
            setColor(palette.SpeedDialAction, 'fabHoverBg', (0, _colorManipulator.private_safeEmphasize)(palette.background.paper, 0.15));
            setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            setColor(palette.Switch, 'primaryDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.primary.main, 0.55));
            setColor(palette.Switch, 'secondaryDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.secondary.main, 0.55));
            setColor(palette.Switch, 'errorDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.error.main, 0.55));
            setColor(palette.Switch, 'infoDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.info.main, 0.55));
            setColor(palette.Switch, 'successDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.success.main, 0.55));
            setColor(palette.Switch, 'warningDisabledColor', (0, _colorManipulator.private_safeDarken)(palette.warning.main, 0.55));
            setColor(palette.TableCell, 'border', (0, _colorManipulator.private_safeDarken)((0, _colorManipulator.private_safeAlpha)(palette.divider, 1), 0.68));
            setColor(palette.Tooltip, 'bg', (0, _colorManipulator.private_safeAlpha)(palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        setColorChannel(palette.background, 'paper');
        setColorChannel(palette.common, 'background');
        setColorChannel(palette.common, 'onBackground');
        setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) setColor(palette[color], 'mainChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.main)));
                if (colors.light) setColor(palette[color], 'lightChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.light)));
                if (colors.dark) setColor(palette[color], 'darkChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.dark)));
                if (colors.contrastText) setColor(palette[color], 'contrastTextChannel', (0, _colorManipulator.private_safeColorChannel)(toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    setColorChannel(palette[color], 'primary');
                    setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) setColorChannel(palette[color], 'active');
                    if (colors.selected) setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, _deepmergeDefault.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        shouldSkipGeneratingVar
    };
    const { vars: themeVars, generateCssVars } = (0, _system.unstable_prepareCssVars)(theme, parserConfig);
    theme.vars = themeVars;
    theme.generateCssVars = generateCssVars;
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = (0, _extendsDefault.default)({}, (0, _styleFunctionSx.unstable_defaultSxConfig), input == null ? void 0 : input.unstable_sxConfig);
    theme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSxDefault.default)({
            sx: props,
            theme: this
        });
    };
    return theme;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/deepmerge":"aRydR","@mui/system":"5Hnj5","@mui/system/styleFunctionSx":"8WdLC","@mui/system/colorManipulator":"dHYgR","./shouldSkipGeneratingVar":"i7Nw9","./createTheme":"itHnG","./getOverlayAlpha":"5bDnG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i7Nw9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shouldSkipGeneratingVar);
function shouldSkipGeneratingVar(keys) {
    var _keys$;
    return !!keys[0].match(/(cssVarPrefix|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!((_keys$ = keys[1]) != null && _keys$.match(/(mode|contrastThreshold|tonalOffset)/));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bDnG":[function(require,module,exports,__globalThis) {
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
exports.default = getOverlayAlpha;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2gXZR":[function(require,module,exports,__globalThis) {
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultMode="dark"`
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(24)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index + 1}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
exports.default = excludeVariablesFromRoot;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2AVL2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _initColorSchemeScript = require("@mui/system/InitColorSchemeScript");
var _initColorSchemeScriptDefault = parcelHelpers.interopDefault(_initColorSchemeScript);
var _jsxRuntime = require("react/jsx-runtime");
const defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
exports.default = function InitColorSchemeScript(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _initColorSchemeScriptDefault.default), (0, _extendsDefault.default)({}, defaultConfig, props));
};

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/system/InitColorSchemeScript":"9pXCI","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9pXCI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _initColorSchemeScriptDefault.default));
var _initColorSchemeScript = require("./InitColorSchemeScript");
var _initColorSchemeScriptDefault = parcelHelpers.interopDefault(_initColorSchemeScript);

},{"./InitColorSchemeScript":"jxL8I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g1SKC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
const boxClasses = (0, _generateUtilityClassesDefault.default)('MuiBox', [
    'root'
]);
exports.default = boxClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"arHf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paperDefault.default));
parcelHelpers.export(exports, "paperClasses", ()=>(0, _paperClassesDefault.default));
var _paper = require("./Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _paperClasses = require("./paperClasses");
var _paperClassesDefault = parcelHelpers.interopDefault(_paperClasses);
parcelHelpers.exportAll(_paperClasses, exports);
'use client';

},{"./Paper":"cTBJg","./paperClasses":"3JLuT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTBJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _getOverlayAlpha = require("../styles/getOverlayAlpha");
var _getOverlayAlphaDefault = parcelHelpers.interopDefault(_getOverlayAlpha);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _paperClasses = require("./paperClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { square, elevation, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _paperClasses.getPaperUtilityClass), classes);
};
const PaperRoot = (0, _styledDefault.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$vars$overlays;
    return (0, _extendsDefault.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, _extendsDefault.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlphaDefault.default)(ownerState.elevation))}, ${(0, _colorManipulator.alpha)('#fff', (0, _getOverlayAlphaDefault.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const Paper = /*#__PURE__*/ _react.forwardRef(function Paper(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className, component = 'div', elevation = 1, square = false, variant = 'elevation' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        elevation,
        square,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other));
});
exports.default = Paper;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/integerPropType":"bc5x8","@mui/utils/chainPropTypes":"83tGg","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../styles/styled":"bTnxF","../styles/getOverlayAlpha":"5bDnG","../DefaultPropsProvider":"ff3VX","../styles/useTheme":"d8hfc","./paperClasses":"3JLuT","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3JLuT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaperUtilityClass", ()=>getPaperUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPaper', slot);
}
const paperClasses = (0, _generateUtilityClassesDefault.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
exports.default = paperClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6Y0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _buttonDefault.default));
parcelHelpers.export(exports, "buttonClasses", ()=>(0, _buttonClassesDefault.default));
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonClasses = require("./buttonClasses");
var _buttonClassesDefault = parcelHelpers.interopDefault(_buttonClasses);
parcelHelpers.exportAll(_buttonClasses, exports);
'use client';

},{"./Button":"f9Ua7","./buttonClasses":"jMRzq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f9Ua7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _buttonClasses = require("./buttonClasses");
var _buttonClassesDefault = parcelHelpers.interopDefault(_buttonClasses);
var _buttonGroupContext = require("../ButtonGroup/ButtonGroupContext");
var _buttonGroupContextDefault = parcelHelpers.interopDefault(_buttonGroupContext);
var _buttonGroupButtonContext = require("../ButtonGroup/ButtonGroupButtonContext");
var _buttonGroupButtonContextDefault = parcelHelpers.interopDefault(_buttonGroupButtonContext);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { color, disableElevation, fullWidth, size, variant, classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, _capitalizeDefault.default)(color)}`,
            `size${(0, _capitalizeDefault.default)(size)}`,
            `${variant}Size${(0, _capitalizeDefault.default)(size)}`,
            `color${(0, _capitalizeDefault.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, _capitalizeDefault.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _buttonClasses.getButtonUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const commonIconStyles = (ownerState)=>(0, _extendsDefault.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const ButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, _extendsDefault.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, _extendsDefault.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, _extendsDefault.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, _buttonClassesDefault.default).focusVisible}`]: (0, _extendsDefault.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, _buttonClassesDefault.default).disabled}`]: (0, _extendsDefault.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, _buttonClassesDefault.default).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, _buttonClassesDefault.default).disabled}`]: {
            boxShadow: 'none'
        }
    });
const ButtonStartIcon = (0, _styledDefault.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, commonIconStyles(ownerState)));
const ButtonEndIcon = (0, _styledDefault.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, commonIconStyles(ownerState)));
const Button = /*#__PURE__*/ _react.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = _react.useContext((0, _buttonGroupContextDefault.default));
    const buttonGroupButtonContextPositionClassName = _react.useContext((0, _buttonGroupButtonContextDefault.default));
    const resolvedProps = (0, _resolvePropsDefault.default)(contextProps, inProps);
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children, color = 'primary', component = 'button', className, disabled = false, disableElevation = false, disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName, fullWidth = false, size = 'medium', startIcon: startIconProp, type, variant = 'text' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disabled,
        disableElevation,
        disableFocusRipple,
        fullWidth,
        size,
        type,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ButtonRoot, (0, _extendsDefault.default)({
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
exports.default = Button;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/resolveProps":"gemxd","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../ButtonBase":"ajcyv","../utils/capitalize":"hBZko","./buttonClasses":"jMRzq","../ButtonGroup/ButtonGroupContext":"cbh6e","../ButtonGroup/ButtonGroupButtonContext":"iTQbB","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jMRzq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getButtonUtilityClass", ()=>getButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiButton', slot);
}
const buttonClasses = (0, _generateUtilityClassesDefault.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
exports.default = buttonClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbh6e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ButtonGroupContext = /*#__PURE__*/ _react.createContext({});
exports.default = ButtonGroupContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iTQbB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ButtonGroupButtonContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = ButtonGroupButtonContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aY7hn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "selectClasses", ()=>(0, _selectClassesDefault.default));
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectClasses = require("./selectClasses");
var _selectClassesDefault = parcelHelpers.interopDefault(_selectClasses);
parcelHelpers.exportAll(_selectClasses, exports);
'use client';

},{"./Select":"hFsCY","./selectClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hFsCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _getReactElementRef = require("@mui/utils/getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);
var _selectInput = require("./SelectInput");
var _selectInputDefault = parcelHelpers.interopDefault(_selectInput);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _arrowDropDown = require("../internal/svg-icons/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _nativeSelectInput = require("../NativeSelect/NativeSelectInput");
var _nativeSelectInputDefault = parcelHelpers.interopDefault(_nativeSelectInput);
var _filledInput = require("../FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _outlinedInput = require("../OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], _excluded2 = [
    "root"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    return classes;
};
const styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) && prop !== 'variant',
    slot: 'Root'
};
const StyledInput = (0, _styledDefault.default)((0, _inputDefault.default), styledRootConfig)('');
const StyledOutlinedInput = (0, _styledDefault.default)((0, _outlinedInputDefault.default), styledRootConfig)('');
const StyledFilledInput = (0, _styledDefault.default)((0, _filledInputDefault.default), styledRootConfig)('');
const Select = /*#__PURE__*/ _react.forwardRef(function Select(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth = false, children, classes: classesProp = {}, className, defaultOpen = false, displayEmpty = false, IconComponent = (0, _arrowDropDownDefault.default), id, input, inputProps, label, labelId, MenuProps, multiple = false, native = false, onClose, onOpen, open, renderValue, SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const inputComponent = native ? (0, _nativeSelectInputDefault.default) : (0, _selectInputDefault.default);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        variant,
        classes: classesProp
    });
    const classes = useUtilityClasses(ownerState);
    const restOfClasses = (0, _objectWithoutPropertiesLooseDefault.default)(classes, _excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, _useForkRefDefault.default)(ref, (0, _getReactElementRefDefault.default)(InputComponent));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/ _react.cloneElement(InputComponent, (0, _extendsDefault.default)({
            // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, _extendsDefault.default)({
                children,
                error: fcs.error,
                IconComponent,
                variant,
                type: undefined,
                // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id
            } : {
                autoWidth,
                defaultOpen,
                displayEmpty,
                labelId,
                MenuProps,
                onClose,
                onOpen,
                open,
                renderValue,
                SelectDisplayProps: (0, _extendsDefault.default)({
                    id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, _deepmergeDefault.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, _clsxDefault.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant
        }, other))
    });
});
Select.muiName = 'Select';
exports.default = Select;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/deepmerge":"aRydR","@mui/utils/getReactElementRef":"guLSb","./SelectInput":"1Uroj","../FormControl/formControlState":"lhkcI","../FormControl/useFormControl":"H1I5Z","../internal/svg-icons/ArrowDropDown":"1gNb2","../Input":"4s0JB","../NativeSelect/NativeSelectInput":"lLoCh","../FilledInput":"bo4qf","../OutlinedInput":"8eUp2","../DefaultPropsProvider":"ff3VX","../utils/useForkRef":"cq8Sn","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Uroj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _menu = require("../Menu/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _nativeSelectInput = require("../NativeSelect/NativeSelectInput");
var _utils = require("../InputBase/utils");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _selectClasses = require("./selectClasses");
var _selectClassesDefault = parcelHelpers.interopDefault(_selectClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
var _span;
const _excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const SelectSelect = (0, _styledDefault.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, _selectClassesDefault.default).select}`]: styles.select
            },
            {
                [`&.${(0, _selectClassesDefault.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, _selectClassesDefault.default).error}`]: styles.error
            },
            {
                [`&.${(0, _selectClassesDefault.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, _nativeSelectInput.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, _selectClassesDefault.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const SelectIcon = (0, _styledDefault.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, _nativeSelectInput.nativeSelectIconStyles));
const SelectNativeInput = (0, _styledDefault.default)('input', {
    shouldForwardProp: (prop)=>(0, _styled.slotShouldForwardProp)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, _capitalizeDefault.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _selectClasses.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const SelectInput = /*#__PURE__*/ _react.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus, autoWidth, children, className, defaultOpen, defaultValue, disabled, displayEmpty, error = false, IconComponent, inputRef: inputRefProp, labelId, MenuProps = {}, multiple, name, onBlur, onChange, onClose, onFocus, onOpen, open: openProp, readOnly, renderValue, SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant = 'standard' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [value, setValueState] = (0, _useControlledDefault.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, _useControlledDefault.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = _react.useRef(null);
    const displayRef = _react.useRef(null);
    const [displayNode, setDisplayNode] = _react.useState(null);
    const { current: isOpenControlled } = _react.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = _react.useState();
    const handleRef = (0, _useForkRefDefault.default)(ref, inputRefProp);
    const handleDisplayRef = _react.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    _react.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    _react.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    _react.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    _react.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, _ownerDocumentDefault.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = _react.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value,
                    name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, _utils.isFilled)({
        value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, _formatMuiErrorMessageDefault.default)(2));
            selected = value.some((v)=>areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ _react.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        variant,
        value,
        open,
        error
    });
    const classes = useUtilityClasses(ownerState);
    const paperProps = (0, _extendsDefault.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, _useIdDefault.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectSelect, (0, _extendsDefault.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, _clsxDefault.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: isEmpty(display) ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectNativeInput, (0, _extendsDefault.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), (0, _extendsDefault.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, _extendsDefault.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, _extendsDefault.default)({}, MenuProps.slotProps, {
                    paper: (0, _extendsDefault.default)({}, paperProps, {
                        style: (0, _extendsDefault.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
exports.default = SelectInput;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/formatMuiErrorMessage":"awvJV","react":"9njXz","react-is":"8oKlE","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/useId":"eMerL","@mui/utils/refType":"7a8uL","../utils/ownerDocument":"7Yspg","../utils/capitalize":"hBZko","../Menu/Menu":"4D7gU","../NativeSelect/NativeSelectInput":"lLoCh","../InputBase/utils":"ukWip","../styles/styled":"bTnxF","../utils/useForkRef":"cq8Sn","../utils/useControlled":"1VreF","./selectClasses":"fqIdL","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oKlE":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("ae7bfd90e5772027");

},{"ae7bfd90e5772027":"73dbz"}],"73dbz":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"7Yspg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ownerDocument = require("@mui/utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
exports.default = (0, _ownerDocumentDefault.default);

},{"@mui/utils/ownerDocument":"7AorK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4D7gU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuPaper", ()=>MenuPaper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _rtlProvider = require("@mui/system/RtlProvider");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _menuList = require("../MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
var _popover = require("../Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _menuClasses = require("./menuClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "onEntering"
], _excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _menuClasses.getMenuUtilityClass), classes);
};
const MenuRoot = (0, _styledDefault.default)((0, _popoverDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const MenuPaper = (0, _styledDefault.default)((0, _popover.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = (0, _styledDefault.default)((0, _menuListDefault.default), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Menu = /*#__PURE__*/ _react.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus = true, children, className, disableAutoFocusItem = false, MenuListProps = {}, onClose, open, PaperProps = {}, PopoverClasses, transitionDuration = 'auto', TransitionProps: { onEntering } = {}, variant = 'selectedMenu', slots = {}, slotProps = {} } = props, TransitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.TransitionProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const isRtl = (0, _rtlProvider.useRtl)();
    const ownerState = (0, _extendsDefault.default)({}, props, {
        autoFocus,
        disableAutoFocusItem,
        MenuListProps,
        onEntering,
        PaperProps,
        transitionDuration,
        TransitionProps,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = _react.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    _react.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : MenuPaper;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuRoot, (0, _extendsDefault.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, _extendsDefault.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuMenuList, (0, _extendsDefault.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, _clsxDefault.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
exports.default = Menu;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","react-is":"8oKlE","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/HTMLElementType":"jZED3","@mui/system/RtlProvider":"aMQRu","@mui/utils/useSlotProps":"kv8TD","../MenuList":"eogrV","../Popover":"keu0V","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./menuClasses":"3yXu4","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eogrV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuListDefault.default));
var _menuList = require("./MenuList");
var _menuListDefault = parcelHelpers.interopDefault(_menuList);
'use client';

},{"./MenuList":"1myh4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1myh4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _list = require("../List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _getScrollbarSize = require("../utils/getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const MenuList = /*#__PURE__*/ _react.forwardRef(function MenuList(props, ref) {
    const { // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus = false, autoFocusItem = false, children, className, disabledItemsFocusable = false, disableListWrap = false, onKeyDown, variant = 'selectedMenu' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const listRef = _react.useRef(null);
    const textCriteriaRef = _react.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    _react.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, _getScrollbarSizeDefault.default)((0, _ownerDocumentDefault.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, _ownerDocumentDefault.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, _useForkRefDefault.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    _react.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = _react.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ _react.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), (0, _extendsDefault.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
exports.default = MenuList;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","react-is":"8oKlE","prop-types":"bnNSm","../utils/ownerDocument":"7Yspg","../List":"4j4o2","../utils/getScrollbarSize":"jyGpq","../utils/useForkRef":"cq8Sn","../utils/useEnhancedEffect":"hXusa","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4j4o2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "listClasses", ()=>(0, _listClassesDefault.default));
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listClasses = require("./listClasses");
var _listClassesDefault = parcelHelpers.interopDefault(_listClasses);
parcelHelpers.exportAll(_listClasses, exports);
'use client';

},{"./List":"2Kstk","./listClasses":"9MNNM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Kstk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _listContext = require("./ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listClasses = require("./listClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePadding, dense, subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listClasses.getListUtilityClass), classes);
};
const ListRoot = (0, _styledDefault.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const List = /*#__PURE__*/ _react.forwardRef(function List(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children, className, component = 'ul', dense = false, disablePadding = false, subheader } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useMemo(()=>({
            dense
        }), [
        dense
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        dense,
        disablePadding
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListRoot, (0, _extendsDefault.default)({
            as: component,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
exports.default = List;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./ListContext":"lt3pu","./listClasses":"9MNNM","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lt3pu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
/**
 * @ignore - internal component.
 */ const ListContext = /*#__PURE__*/ _react.createContext({});
exports.default = ListContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9MNNM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListUtilityClass", ()=>getListUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiList', slot);
}
const listClasses = (0, _generateUtilityClassesDefault.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
exports.default = listClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyGpq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getScrollbarSize = require("@mui/utils/getScrollbarSize");
var _getScrollbarSizeDefault = parcelHelpers.interopDefault(_getScrollbarSize);
exports.default = (0, _getScrollbarSizeDefault.default);

},{"@mui/utils/getScrollbarSize":"dPz4l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXusa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEnhancedEffect = require("@mui/utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
'use client';
exports.default = (0, _useEnhancedEffectDefault.default);

},{"@mui/utils/useEnhancedEffect":"9v0Mw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"keu0V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _popoverDefault.default));
parcelHelpers.export(exports, "popoverClasses", ()=>(0, _popoverClassesDefault.default));
var _popover = require("./Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
parcelHelpers.exportAll(_popover, exports);
var _popoverClasses = require("./popoverClasses");
var _popoverClassesDefault = parcelHelpers.interopDefault(_popoverClasses);
parcelHelpers.exportAll(_popoverClasses, exports);
'use client';

},{"./Popover":"1alPY","./popoverClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1alPY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOffsetTop", ()=>getOffsetTop);
parcelHelpers.export(exports, "getOffsetLeft", ()=>getOffsetLeft);
parcelHelpers.export(exports, "PopoverRoot", ()=>PopoverRoot);
parcelHelpers.export(exports, "PopoverPaper", ()=>PopoverPaper);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _isHostComponent = require("@mui/utils/isHostComponent");
var _isHostComponentDefault = parcelHelpers.interopDefault(_isHostComponent);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("../utils/ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _grow = require("../Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _popoverClasses = require("./popoverClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "onEntering"
], _excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], _excluded3 = [
    "slotProps"
];
function getOffsetTop(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function getOffsetLeft(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _popoverClasses.getPopoverUtilityClass), classes);
};
const PopoverRoot = (0, _styledDefault.default)((0, _modalDefault.default), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const PopoverPaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const Popover = /*#__PURE__*/ _react.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action, anchorEl, anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition, anchorReference = 'anchorEl', children, className, container: containerProp, elevation = 8, marginThreshold = 16, open, PaperProps: PaperPropsProp = {}, slots, slotProps, transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent = (0, _growDefault.default), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering } = {}, disableScrollLock = false } = props, TransitionProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.TransitionProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = _react.useRef();
    const handlePaperRef = (0, _useForkRefDefault.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        anchorOrigin,
        anchorReference,
        elevation,
        marginThreshold,
        externalPaperSlotProps,
        transformOrigin,
        TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps
    });
    const classes = useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = _react.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, _ownerDocumentDefault.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = _react.useCallback((elemRect)=>{
        return {
            vertical: getOffsetTop(elemRect, transformOrigin.vertical),
            horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = _react.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, _ownerWindowDefault.default)(resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = _react.useState(open);
    const setPositioningStyles = _react.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    _react.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    _react.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    _react.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    _react.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, _debounceDefault.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, _ownerWindowDefault.default)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, _ownerDocumentDefault.default)(resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : PopoverRoot;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : PopoverPaper;
    const paperProps = (0, _useSlotPropsDefault.default)({
        elementType: PaperSlot,
        externalSlotProps: (0, _extendsDefault.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, _extendsDefault.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation,
            ref: handlePaperRef
        },
        ownerState,
        className: (0, _clsxDefault.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, _useSlotPropsDefault.default)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container,
            open
        },
        ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, _objectWithoutPropertiesLooseDefault.default)(_useSlotProps, _excluded3);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RootSlot, (0, _extendsDefault.default)({}, rootProps, !(0, _isHostComponentDefault.default)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperSlot, (0, _extendsDefault.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
exports.default = Popover;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/HTMLElementType":"jZED3","@mui/utils/refType":"7a8uL","@mui/utils/elementTypeAcceptingRef":"gpPr5","@mui/utils/integerPropType":"bc5x8","@mui/utils/chainPropTypes":"83tGg","@mui/utils/useSlotProps":"kv8TD","@mui/utils/isHostComponent":"2X2lI","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../utils/debounce":"cvBWT","../utils/ownerDocument":"7Yspg","../utils/ownerWindow":"4Wjh2","../utils/useForkRef":"cq8Sn","../Grow":"4LWtg","../Modal":"akOht","../Paper":"arHf6","./popoverClasses":"1QYLF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvBWT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _debounce = require("@mui/utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
exports.default = (0, _debounceDefault.default);

},{"@mui/utils/debounce":"1rcGS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Wjh2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ownerWindow = require("@mui/utils/ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
exports.default = (0, _ownerWindowDefault.default);

},{"@mui/utils/ownerWindow":"af1fJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LWtg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _growDefault.default));
var _grow = require("./Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
'use client';

},{"./Grow":"bcxqT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bcxqT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _getReactElementRef = require("@mui/utils/getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);
var _reactTransitionGroup = require("react-transition-group");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils = require("../transitions/utils");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const styles = {
    entering: {
        opacity: 1,
        transform: getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Grow = /*#__PURE__*/ _react.forwardRef(function Grow(props, ref) {
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = 'auto', // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const timer = (0, _useTimeoutDefault.default)();
    const autoTimeout = _react.useRef();
    const theme = (0, _useThemeDefault.default)();
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(nodeRef, (0, _getReactElementRefDefault.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration,
                delay
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration,
                delay
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                style: (0, _extendsDefault.default)({
                    opacity: 0,
                    transform: getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
Grow.muiSupportAuto = true;
exports.default = Grow;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/utils/useTimeout":"6WuNb","@mui/utils/elementAcceptingRef":"5WlCj","@mui/utils/getReactElementRef":"guLSb","react-transition-group":"hnCQJ","../styles/useTheme":"d8hfc","../transitions/utils":"3QK1j","../utils/useForkRef":"cq8Sn","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QK1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reflow", ()=>reflow);
parcelHelpers.export(exports, "getTransitionProps", ()=>getTransitionProps);
const reflow = (node)=>node.scrollTop;
function getTransitionProps(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout, easing, style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"akOht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalManager", ()=>(0, _modalManager.ModalManager));
parcelHelpers.export(exports, "default", ()=>(0, _modalDefault.default));
parcelHelpers.export(exports, "modalClasses", ()=>(0, _modalClassesDefault.default));
var _modalManager = require("./ModalManager");
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _modalClasses = require("./modalClasses");
var _modalClassesDefault = parcelHelpers.interopDefault(_modalClasses);
parcelHelpers.exportAll(_modalClasses, exports);
'use client';

},{"./ModalManager":false,"./Modal":"16Ewb","./modalClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gr6Q3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ariaHidden", ()=>ariaHidden);
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */ parcelHelpers.export(exports, "ModalManager", ()=>ModalManager);
var _utils = require("@mui/utils");
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
    const doc = (0, _utils.unstable_ownerDocument)(container);
    if (doc.body === container) return (0, _utils.unstable_ownerWindow)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function getPaddingRight(element) {
    return parseInt((0, _utils.unstable_ownerWindow)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) ariaHidden(element, show);
    });
}
function findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if (isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, _utils.unstable_getScrollbarSize)((0, _utils.unstable_ownerDocument)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, _utils.unstable_ownerDocument)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, _utils.unstable_ownerDocument)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, _utils.unstable_ownerWindow)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value, el, property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class ModalManager {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) ariaHidden(modal.modalRef, false);
        const hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container,
            restore: null,
            hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            ariaHidden(modal.modalRef, ariaHiddenState);
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) ariaHidden(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

},{"@mui/utils":"lfcNH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16Ewb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _unstableTrapFocus = require("../Unstable_TrapFocus");
var _unstableTrapFocusDefault = parcelHelpers.interopDefault(_unstableTrapFocus);
var _portal = require("../Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _backdrop = require("../Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _useModal = require("./useModal");
var _useModalDefault = parcelHelpers.interopDefault(_useModal);
var _modalClasses = require("./modalClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const useUtilityClasses = (ownerState)=>{
    const { open, exited, classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _modalClasses.getModalUtilityClass), classes);
};
const ModalRoot = (0, _styledDefault.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const ModalBackdrop = (0, _styledDefault.default)((0, _backdropDefault.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const Modal = /*#__PURE__*/ _react.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent = ModalBackdrop, BackdropProps, className, closeAfterTransition = false, children, container, component, components = {}, componentsProps = {}, disableAutoFocus = false, disableEnforceFocus = false, disableEscapeKeyDown = false, disablePortal = false, disableRestoreFocus = false, disableScrollLock = false, hideBackdrop = false, keepMounted = false, onBackdropClick, open, slotProps, slots } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const propsWithDefaults = (0, _extendsDefault.default)({}, props, {
        closeAfterTransition,
        disableAutoFocus,
        disableEnforceFocus,
        disableEscapeKeyDown,
        disablePortal,
        disableRestoreFocus,
        disableScrollLock,
        hideBackdrop,
        keepMounted
    });
    const { getRootProps, getBackdropProps, getTransitionProps, portalRef, isTopModal, exited, hasTransition } = (0, _useModalDefault.default)((0, _extendsDefault.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, _extendsDefault.default)({}, propsWithDefaults, {
        exited
    });
    const classes = useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter, onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, _useSlotPropsDefault.default)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref,
            as: component
        },
        ownerState,
        className: (0, _clsxDefault.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, _useSlotPropsDefault.default)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, _extendsDefault.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, _clsxDefault.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, (0, _extendsDefault.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropSlot, (0, _extendsDefault.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unstableTrapFocusDefault.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ _react.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
exports.default = Modal;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/HTMLElementType":"jZED3","@mui/utils/elementAcceptingRef":"5WlCj","@mui/utils/composeClasses":"43D21","@mui/utils/useSlotProps":"kv8TD","../Unstable_TrapFocus":"6WLXP","../Portal":"gdTpC","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../Backdrop":"j7994","./useModal":"ehXGi","./modalClasses":"bbWSZ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6WLXP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _focusTrapDefault.default));
var _focusTrap = require("./FocusTrap");
var _focusTrapDefault = parcelHelpers.interopDefault(_focusTrap);

},{"./FocusTrap":"e2A5w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2A5w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) return false;
    return true;
}
function defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = getTabIndex(node);
        if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function FocusTrap(props) {
    const { children, disableAutoFocus = false, disableEnforceFocus = false, disableRestoreFocus = false, getTabbable = defaultGetTabbable, isEnabled = defaultIsEnabled, open } = props;
    const ignoreNextEnforceFocus = _react.useRef(false);
    const sentinelStart = _react.useRef(null);
    const sentinelEnd = _react.useRef(null);
    const nodeToRestore = _react.useRef(null);
    const reactFocusEventTarget = _react.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = _react.useRef(false);
    const rootRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)((0, _utils.unstable_getReactElementRef)(children), rootRef);
    const lastKeydown = _react.useRef(null);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _utils.unstable_ownerDocument)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    _react.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, _utils.unstable_ownerDocument)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ _react.cloneElement(children, {
                ref: handleRef,
                onFocus
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
exports.default = FocusTrap;

},{"react":"9njXz","prop-types":"bnNSm","@mui/utils":"lfcNH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdTpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _portalDefault.default));
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);

},{"./Portal":"3t9n5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3t9n5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDom = require("react-dom");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const Portal = /*#__PURE__*/ _react.forwardRef(function Portal(props, forwardedRef) {
    const { children, container, disablePortal = false } = props;
    const [mountNode, setMountNode] = _react.useState(null);
    const handleRef = (0, _utils.unstable_useForkRef)(/*#__PURE__*/ _react.isValidElement(children) ? (0, _utils.unstable_getReactElementRef)(children) : null, forwardedRef);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!disablePortal) setMountNode(getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (mountNode && !disablePortal) {
            (0, _utils.unstable_setRef)(forwardedRef, mountNode);
            return ()=>{
                (0, _utils.unstable_setRef)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ _react.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ _react.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: mountNode ? /*#__PURE__*/ _reactDom.createPortal(children, mountNode) : mountNode
    });
});
exports.default = Portal;

},{"react":"9njXz","react-dom":"2ApDx","prop-types":"bnNSm","@mui/utils":"lfcNH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j7994":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _backdropDefault.default));
parcelHelpers.export(exports, "backdropClasses", ()=>(0, _backdropClassesDefault.default));
var _backdrop = require("./Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _backdropClasses = require("./backdropClasses");
var _backdropClassesDefault = parcelHelpers.interopDefault(_backdropClasses);
parcelHelpers.exportAll(_backdropClasses, exports);
'use client';

},{"./Backdrop":"cd60q","./backdropClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cd60q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _fade = require("../Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _backdropClasses = require("./backdropClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _backdropClasses.getBackdropUtilityClass), classes);
};
const BackdropRoot = (0, _styledDefault.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const Backdrop = /*#__PURE__*/ _react.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children, className, component = 'div', components = {}, componentsProps = {}, invisible = false, open, slotProps = {}, slots = {}, TransitionComponent = (0, _fadeDefault.default), transitionDuration } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        invisible
    });
    const classes = useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BackdropRoot, (0, _extendsDefault.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, _clsxDefault.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, _extendsDefault.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
exports.default = Backdrop;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../Fade":"8DwqP","./backdropClasses":"slXk3","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8DwqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _fadeDefault.default));
var _fade = require("./Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
'use client';

},{"./Fade":"3s8eU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3s8eU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _getReactElementRef = require("@mui/utils/getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils = require("../transitions/utils");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Fade = /*#__PURE__*/ _react.forwardRef(function Fade(props, ref) {
    const theme = (0, _useThemeDefault.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener, appear = true, children, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, style, timeout = defaultTimeout, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const enableStrictModeCompat = true;
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _useForkRefDefault.default)(nodeRef, (0, _getReactElementRefDefault.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, _utils.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                style: (0, _extendsDefault.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
exports.default = Fade;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","react-transition-group":"hnCQJ","@mui/utils/elementAcceptingRef":"5WlCj","@mui/utils/getReactElementRef":"guLSb","../styles/useTheme":"d8hfc","../transitions/utils":"3QK1j","../utils/useForkRef":"cq8Sn","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"slXk3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBackdropUtilityClass", ()=>getBackdropUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getBackdropUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiBackdrop', slot);
}
const backdropClasses = (0, _generateUtilityClassesDefault.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
exports.default = backdropClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehXGi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _utils = require("@mui/utils");
var _extractEventHandlers = require("@mui/utils/extractEventHandlers");
var _extractEventHandlersDefault = parcelHelpers.interopDefault(_extractEventHandlers);
var _modalManager = require("./ModalManager");
'use client';
function getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const defaultManager = new (0, _modalManager.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function useModal(parameters) {
    const { container, disableEscapeKeyDown = false, disableScrollLock = false, // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = defaultManager, closeAfterTransition = false, onTransitionEnter, onTransitionExited, children, onClose, open, rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = _react.useRef({});
    const mountNodeRef = _react.useRef(null);
    const modalRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(modalRef, rootRef);
    const [exited, setExited] = _react.useState(!open);
    const hasTransition = getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, _utils.unstable_ownerDocument)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, _utils.unstable_useEventCallback)(()=>{
        const resolvedContainer = getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = _react.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, _utils.unstable_useEventCallback)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, _modalManager.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = _react.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    _react.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    _react.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, _extractEventHandlersDefault.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, _extendsDefault.default)({}, propsEventHandlers, otherHandlers);
        return (0, _extendsDefault.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, _extendsDefault.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, _utils.unstable_createChainedFunction)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, _utils.unstable_createChainedFunction)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps,
        getBackdropProps,
        getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal,
        exited,
        hasTransition
    };
}
exports.default = useModal;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils":"lfcNH","@mui/utils/extractEventHandlers":"lbNYN","./ModalManager":"gr6Q3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bbWSZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getModalUtilityClass", ()=>getModalUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getModalUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiModal', slot);
}
const modalClasses = (0, _generateUtilityClassesDefault.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
exports.default = modalClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1QYLF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopoverUtilityClass", ()=>getPopoverUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPopoverUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPopover', slot);
}
const popoverClasses = (0, _generateUtilityClassesDefault.default)('MuiPopover', [
    'root',
    'paper'
]);
exports.default = popoverClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3yXu4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMenuUtilityClass", ()=>getMenuUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMenuUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiMenu', slot);
}
const menuClasses = (0, _generateUtilityClassesDefault.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
exports.default = menuClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLoCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nativeSelectSelectStyles", ()=>nativeSelectSelectStyles);
parcelHelpers.export(exports, "nativeSelectIconStyles", ()=>nativeSelectIconStyles);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _nativeSelectClasses = require("./nativeSelectClasses");
var _nativeSelectClassesDefault = parcelHelpers.interopDefault(_nativeSelectClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, disabled, multiple, open, error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, _capitalizeDefault.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _nativeSelectClasses.getNativeSelectUtilityClasses), classes);
};
const nativeSelectSelectStyles = ({ ownerState, theme })=>(0, _extendsDefault.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, _extendsDefault.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, _nativeSelectClassesDefault.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const NativeSelectSelect = (0, _styledDefault.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, _styled.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, _nativeSelectClassesDefault.default).multiple}`]: styles.multiple
            }
        ];
    }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({ ownerState, theme })=>(0, _extendsDefault.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, _nativeSelectClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const NativeSelectIcon = (0, _styledDefault.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})(nativeSelectIconStyles);
/**
 * @ignore - internal component.
 */ const NativeSelectInput = /*#__PURE__*/ _react.forwardRef(function NativeSelectInput(props, ref) {
    const { className, disabled, error, IconComponent, inputRef, variant = 'standard' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        variant,
        error
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectSelect, (0, _extendsDefault.default)({
                ownerState: ownerState,
                className: (0, _clsxDefault.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
exports.default = NativeSelectInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","../utils/capitalize":"hBZko","./nativeSelectClasses":"N1g2C","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"N1g2C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNativeSelectUtilityClasses", ()=>getNativeSelectUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getNativeSelectUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiNativeSelect', slot);
}
const nativeSelectClasses = (0, _generateUtilityClassesDefault.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
exports.default = nativeSelectClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ukWip":[function(require,module,exports,__globalThis) {
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasValue", ()=>hasValue);
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
parcelHelpers.export(exports, "isFilled", ()=>isFilled);
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
parcelHelpers.export(exports, "isAdornedStart", ()=>isAdornedStart);
function hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function isFilled(obj, SSR = false) {
    return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
}
function isAdornedStart(obj) {
    return obj.startAdornment;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1VreF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
'use client';
exports.default = (0, _useControlledDefault.default);

},{"@mui/utils/useControlled":"fOjEQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fqIdL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSelectUtilityClasses", ()=>getSelectUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSelectUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiSelect', slot);
}
const selectClasses = (0, _generateUtilityClassesDefault.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
exports.default = selectClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lhkcI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formControlState);
function formControlState({ props, states, muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"H1I5Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFormControl);
var _react = require("react");
var _formControlContext = require("./FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
'use client';
function useFormControl() {
    return _react.useContext((0, _formControlContextDefault.default));
}

},{"react":"9njXz","./FormControlContext":"lcpxD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcpxD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const FormControlContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = FormControlContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1gNb2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4s0JB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputDefault.default));
parcelHelpers.export(exports, "inputClasses", ()=>(0, _inputClassesDefault.default));
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _inputClasses = require("./inputClasses");
var _inputClassesDefault = parcelHelpers.interopDefault(_inputClasses);
parcelHelpers.exportAll(_inputClasses, exports);
'use client';

},{"./Input":"cAJhD","./inputClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cAJhD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _inputBase = require("../InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _inputClasses = require("./inputClasses");
var _inputClassesDefault = parcelHelpers.interopDefault(_inputClasses);
var _inputBase1 = require("../InputBase/InputBase");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _inputClasses.getInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const InputRoot = (0, _styledDefault.default)((0, _inputBase1.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _inputBase1.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme, ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, _extendsDefault.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, _inputClassesDefault.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, _inputClassesDefault.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, _inputClassesDefault.default).disabled}, .${(0, _inputClassesDefault.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, _inputClassesDefault.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const InputInput = (0, _styledDefault.default)((0, _inputBase1.InputBaseComponent), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, _inputBase1.inputOverridesResolver)
})({});
const Input = /*#__PURE__*/ _react.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline, components = {}, componentsProps: componentsPropsProp, fullWidth = false, inputComponent = 'input', multiline = false, slotProps, slots = {}, type = 'text' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    const ownerState = {
        disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _deepmergeDefault.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : InputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
Input.muiName = 'Input';
exports.default = Input;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils/composeClasses":"43D21","@mui/utils/deepmerge":"aRydR","@mui/utils/refType":"7a8uL","../InputBase":"c1XNn","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./inputClasses":"hyHMe","../InputBase/InputBase":"aTW7W","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1XNn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputBaseDefault.default));
parcelHelpers.export(exports, "inputBaseClasses", ()=>(0, _inputBaseClassesDefault.default));
var _inputBase = require("./InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _inputBaseClasses = require("./inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
parcelHelpers.exportAll(_inputBaseClasses, exports);
'use client';

},{"./InputBase":"aTW7W","./inputBaseClasses":"d0rpO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aTW7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootOverridesResolver", ()=>rootOverridesResolver);
parcelHelpers.export(exports, "inputOverridesResolver", ()=>inputOverridesResolver);
parcelHelpers.export(exports, "InputBaseRoot", ()=>InputBaseRoot);
parcelHelpers.export(exports, "InputBaseComponent", ()=>InputBaseComponent);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _formatMuiErrorMessage = require("@mui/utils/formatMuiErrorMessage");
var _formatMuiErrorMessageDefault = parcelHelpers.interopDefault(_formatMuiErrorMessage);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _isHostComponent = require("@mui/utils/isHostComponent");
var _isHostComponentDefault = parcelHelpers.interopDefault(_isHostComponent);
var _textareaAutosize = require("../TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _formControlContext = require("../FormControl/FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _globalStyles = require("../GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);
var _utils = require("./utils");
var _inputBaseClasses = require("./inputBaseClasses");
var _inputBaseClassesDefault = parcelHelpers.interopDefault(_inputBaseClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const rootOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const inputOverridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, error, endAdornment, focused, formControl, fullWidth, hiddenLabel, multiline, readOnly, size, startAdornment, type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalizeDefault.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, _capitalizeDefault.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _inputBaseClasses.getInputBaseUtilityClass), classes);
};
const InputBaseRoot = (0, _styledDefault.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: rootOverridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const InputBaseComponent = (0, _styledDefault.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: inputOverridesResolver
})(({ theme, ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, _extendsDefault.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, _extendsDefault.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, _inputBaseClassesDefault.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, _inputBaseClassesDefault.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const inputGlobalStyles = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _globalStylesDefault.default), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const InputBase = /*#__PURE__*/ _react.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete, autoFocus, className, components = {}, componentsProps = {}, defaultValue, disabled, disableInjectingGlobalStyles, endAdornment, fullWidth = false, id, inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows, minRows, multiline = false, name, onBlur, onChange, onClick, onFocus, onKeyDown, onKeyUp, placeholder, readOnly, renderSuffix, rows, slotProps = {}, slots = {}, startAdornment, type = 'text', value: valueProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = _react.useRef(value != null);
    const inputRef = _react.useRef();
    const handleInputRefWarning = _react.useCallback((instance)=>{}, []);
    const handleInputRef = (0, _useForkRefDefault.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = _react.useState(false);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    _react.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = _react.useCallback((obj)=>{
        if ((0, _utils.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (isControlled) checkDirty({
            value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, _formatMuiErrorMessageDefault.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    _react.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, _extendsDefault.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, _extendsDefault.default)({
            type: undefined,
            maxRows,
            minRows
        }, inputProps);
        InputComponent = (0, _textareaAutosizeDefault.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    _react.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        startAdornment,
        type
    });
    const classes = useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || InputBaseRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || InputBaseComponent;
    inputProps = (0, _extendsDefault.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            !disableInjectingGlobalStyles && inputGlobalStyles,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, (0, _extendsDefault.default)({}, rootProps, !(0, _isHostComponentDefault.default)(Root) && {
                ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, _clsxDefault.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Input, (0, _extendsDefault.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, _isHostComponentDefault.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, _extendsDefault.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, _clsxDefault.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, _extendsDefault.default)({}, fcs, {
                        startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
exports.default = InputBase;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/formatMuiErrorMessage":"awvJV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/elementTypeAcceptingRef":"gpPr5","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","@mui/utils/isHostComponent":"2X2lI","../TextareaAutosize":"9RmQq","../FormControl/formControlState":"lhkcI","../FormControl/FormControlContext":"lcpxD","../FormControl/useFormControl":"H1I5Z","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../utils/capitalize":"hBZko","../utils/useForkRef":"cq8Sn","../utils/useEnhancedEffect":"hXusa","../GlobalStyles":"Tt5ys","./utils":"ukWip","./inputBaseClasses":"d0rpO","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9RmQq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _textareaAutosizeDefault.default));
var _textareaAutosize = require("./TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);

},{"./TextareaAutosize":"kpeK4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kpeK4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const TextareaAutosize = /*#__PURE__*/ _react.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange, maxRows, minRows = 1, style, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { current: isControlled } = _react.useRef(value != null);
    const inputRef = _react.useRef(null);
    const handleRef = (0, _utils.unstable_useForkRef)(forwardedRef, inputRef);
    const heightRef = _react.useRef(null);
    const shadowRef = _react.useRef(null);
    const calculateTextareaStyles = _react.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, _utils.unstable_ownerWindow)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = getStyleValue(computedStyle.paddingBottom) + getStyleValue(computedStyle.paddingTop);
        const border = getStyleValue(computedStyle.borderBottomWidth) + getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle,
            overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = _react.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if (isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        const input = inputRef.current;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            input.style.height = `${outerHeightStyle}px`;
        }
        input.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, _utils.unstable_debounce)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, _utils.unstable_ownerWindow)(input);
        containerWindow.addEventListener('resize', debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener('resize', debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", (0, _extendsDefault.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, _extendsDefault.default)({}, styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
exports.default = TextareaAutosize;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/utils":"lfcNH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Tt5ys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _globalStylesDefault.default));
var _globalStyles = require("./GlobalStyles");
var _globalStylesDefault = parcelHelpers.interopDefault(_globalStyles);

},{"./GlobalStyles":"5IUCa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5IUCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _defaultTheme = require("../styles/defaultTheme");
var _defaultThemeDefault = parcelHelpers.interopDefault(_defaultTheme);
var _identifier = require("../styles/identifier");
var _identifierDefault = parcelHelpers.interopDefault(_identifier);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function GlobalStyles(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.GlobalStyles), (0, _extendsDefault.default)({}, props, {
        defaultTheme: (0, _defaultThemeDefault.default),
        themeId: (0, _identifierDefault.default)
    }));
}
exports.default = GlobalStyles;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/system":"5Hnj5","../styles/defaultTheme":"gDdTD","../styles/identifier":"asvw3","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d0rpO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputBaseUtilityClass", ()=>getInputBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiInputBase', slot);
}
const inputBaseClasses = (0, _generateUtilityClassesDefault.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
exports.default = inputBaseClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hyHMe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputUtilityClass", ()=>getInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiInput', slot);
}
const inputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
exports.default = inputClasses;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","../InputBase":"c1XNn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bo4qf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _filledInputDefault.default));
parcelHelpers.export(exports, "filledInputClasses", ()=>(0, _filledInputClassesDefault.default));
var _filledInput = require("./FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _filledInputClasses = require("./filledInputClasses");
var _filledInputClassesDefault = parcelHelpers.interopDefault(_filledInputClasses);
parcelHelpers.exportAll(_filledInputClasses, exports);
'use client';

},{"./FilledInput":"krW6P","./filledInputClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"krW6P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _deepmerge = require("@mui/utils/deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _inputBase = require("../InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _filledInputClasses = require("./filledInputClasses");
var _filledInputClassesDefault = parcelHelpers.interopDefault(_filledInputClasses);
var _inputBase1 = require("../InputBase/InputBase");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _filledInputClasses.getFilledInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const FilledInputRoot = (0, _styledDefault.default)((0, _inputBase1.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            ...(0, _inputBase1.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme, ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, _extendsDefault.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, _filledInputClassesDefault.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, _filledInputClassesDefault.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, _filledInputClassesDefault.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, _filledInputClassesDefault.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, _filledInputClassesDefault.default).disabled}, .${(0, _filledInputClassesDefault.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, _filledInputClassesDefault.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const FilledInputInput = (0, _styledDefault.default)((0, _inputBase1.InputBaseComponent), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, _inputBase1.inputOverridesResolver)
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const FilledInput = /*#__PURE__*/ _react.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components = {}, componentsProps: componentsPropsProp, fullWidth = false, // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline = false, slotProps, slots = {}, type = 'text' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        fullWidth,
        inputComponent,
        multiline,
        type
    });
    const classes = useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState
        },
        input: {
            ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, _deepmergeDefault.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : FilledInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
FilledInput.muiName = 'Input';
exports.default = FilledInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","@mui/utils/deepmerge":"aRydR","@mui/utils/refType":"7a8uL","prop-types":"bnNSm","@mui/utils/composeClasses":"43D21","../InputBase":"c1XNn","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./filledInputClasses":"9EyvX","../InputBase/InputBase":"aTW7W","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9EyvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFilledInputUtilityClass", ()=>getFilledInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getFilledInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiFilledInput', slot);
}
const filledInputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
exports.default = filledInputClasses;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","../InputBase":"c1XNn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8eUp2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _outlinedInputDefault.default));
parcelHelpers.export(exports, "outlinedInputClasses", ()=>(0, _outlinedInputClassesDefault.default));
var _outlinedInput = require("./OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _outlinedInputClasses = require("./outlinedInputClasses");
var _outlinedInputClassesDefault = parcelHelpers.interopDefault(_outlinedInputClasses);
parcelHelpers.exportAll(_outlinedInputClasses, exports);
'use client';

},{"./OutlinedInput":"c8yfD","./outlinedInputClasses":"72KPB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8yfD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _notchedOutline = require("./NotchedOutline");
var _notchedOutlineDefault = parcelHelpers.interopDefault(_notchedOutline);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _outlinedInputClasses = require("./outlinedInputClasses");
var _outlinedInputClassesDefault = parcelHelpers.interopDefault(_outlinedInputClasses);
var _inputBase = require("../InputBase/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _outlinedInputClasses.getOutlinedInputUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const OutlinedInputRoot = (0, _styledDefault.default)((0, _inputBase.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, _inputBase.rootOverridesResolver)
})(({ theme, ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, _extendsDefault.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, _outlinedInputClassesDefault.default).focused} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, _outlinedInputClassesDefault.default).error} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, _outlinedInputClassesDefault.default).disabled} .${(0, _outlinedInputClassesDefault.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, _extendsDefault.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const NotchedOutlineRoot = (0, _styledDefault.default)((0, _notchedOutlineDefault.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const OutlinedInputInput = (0, _styledDefault.default)((0, _inputBase.InputBaseComponent), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, _inputBase.inputOverridesResolver)
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const OutlinedInput = /*#__PURE__*/ _react.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components = {}, fullWidth = false, inputComponent = 'input', label, multiline = false, notched, slots = {}, type = 'text' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(props);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline,
        size: fcs.size,
        type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : OutlinedInputInput;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), (0, _extendsDefault.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, _extendsDefault.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
OutlinedInput.muiName = 'Input';
exports.default = OutlinedInput;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","./NotchedOutline":"eCmf6","../FormControl/useFormControl":"H1I5Z","../FormControl/formControlState":"lhkcI","../styles/styled":"bTnxF","./outlinedInputClasses":"72KPB","../InputBase/InputBase":"aTW7W","../DefaultPropsProvider":"ff3VX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eCmf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NotchedOutline);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
var _span;
const _excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const NotchedOutlineRoot = (0, _styledDefault.default)('fieldset', {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const NotchedOutlineLegend = (0, _styledDefault.default)('legend', {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, _extendsDefault.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function NotchedOutline(props) {
    const { className, label, notched } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, _extendsDefault.default)({}, props, {
        notched,
        withLabel
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineRoot, (0, _extendsDefault.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            }) : _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"72KPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOutlinedInputUtilityClass", ()=>getOutlinedInputUtilityClass);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
var _inputBase = require("../InputBase");
function getOutlinedInputUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiOutlinedInput', slot);
}
const outlinedInputClasses = (0, _extendsDefault.default)({}, (0, _inputBase.inputBaseClasses), (0, _generateUtilityClassesDefault.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
exports.default = outlinedInputClasses;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","../InputBase":"c1XNn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fW0kE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuDefault.default));
parcelHelpers.export(exports, "menuClasses", ()=>(0, _menuClassesDefault.default));
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuClasses = require("./menuClasses");
var _menuClassesDefault = parcelHelpers.interopDefault(_menuClasses);
parcelHelpers.exportAll(_menuClasses, exports);
'use client';

},{"./Menu":"4D7gU","./menuClasses":"3yXu4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a18vm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "menuItemClasses", ()=>(0, _menuItemClassesDefault.default));
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _menuItemClasses = require("./menuItemClasses");
parcelHelpers.exportAll(_menuItemClasses, exports);
var _menuItemClassesDefault = parcelHelpers.interopDefault(_menuItemClasses);
'use client';

},{"./MenuItem":"keBEM","./menuItemClasses":"hUxvt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"keBEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overridesResolver", ()=>overridesResolver);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _divider = require("../Divider");
var _listItemIcon = require("../ListItemIcon");
var _listItemText = require("../ListItemText");
var _menuItemClasses = require("./menuItemClasses");
var _menuItemClassesDefault = parcelHelpers.interopDefault(_menuItemClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { disabled, dense, divider, disableGutters, selected, classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _menuItemClasses.getMenuItemUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const MenuItemRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, _menuItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, _menuItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _menuItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, _divider.dividerClasses).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, _divider.dividerClasses).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, _listItemText.listItemTextClasses).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, _listItemText.listItemTextClasses).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, _listItemIcon.listItemIconClasses).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, _extendsDefault.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, _listItemIcon.listItemIconClasses).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const MenuItem = /*#__PURE__*/ _react.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus = false, component = 'li', dense = false, divider = false, disableGutters = false, focusVisibleClassName, role = 'menuitem', tabIndex: tabIndexProp, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const childContext = _react.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = _react.useRef(null);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        dense: childContext.dense,
        divider,
        disableGutters
    });
    const classes = useUtilityClasses(props);
    const handleRef = (0, _useForkRefDefault.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuItemRoot, (0, _extendsDefault.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
exports.default = MenuItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../List/ListContext":"lt3pu","../ButtonBase":"ajcyv","../utils/useEnhancedEffect":"hXusa","../utils/useForkRef":"cq8Sn","../Divider":"5Ykub","../ListItemIcon":"fp9B2","../ListItemText":"8IBhx","./menuItemClasses":"hUxvt","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Ykub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dividerDefault.default));
parcelHelpers.export(exports, "dividerClasses", ()=>(0, _dividerClassesDefault.default));
var _divider = require("./Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _dividerClasses = require("./dividerClasses");
var _dividerClassesDefault = parcelHelpers.interopDefault(_dividerClasses);
parcelHelpers.exportAll(_dividerClasses, exports);
'use client';

},{"./Divider":"1fvTD","./dividerClasses":"kFVvv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fvTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _dividerClasses = require("./dividerClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { absolute, children, classes, flexItem, light, orientation, textAlign, variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dividerClasses.getDividerUtilityClass), classes);
};
const DividerRoot = (0, _styledDefault.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, _colorManipulator.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const DividerWrapper = (0, _styledDefault.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const Divider = /*#__PURE__*/ _react.forwardRef(function Divider(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute = false, children, className, component = children ? 'div' : 'hr', flexItem = false, light = false, orientation = 'horizontal', role = component !== 'hr' ? 'separator' : undefined, textAlign = 'center', variant = 'fullWidth' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        absolute,
        component,
        flexItem,
        light,
        orientation,
        role,
        textAlign,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerRoot, (0, _extendsDefault.default)({
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ Divider.muiSkipListHighlight = true;
exports.default = Divider;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./dividerClasses":"kFVvv","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kFVvv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDividerUtilityClass", ()=>getDividerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDividerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDivider', slot);
}
const dividerClasses = (0, _generateUtilityClassesDefault.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
exports.default = dividerClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fp9B2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemIconDefault.default));
parcelHelpers.export(exports, "listItemIconClasses", ()=>(0, _listItemIconClassesDefault.default));
var _listItemIcon = require("./ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemIconClasses = require("./listItemIconClasses");
var _listItemIconClassesDefault = parcelHelpers.interopDefault(_listItemIconClasses);
parcelHelpers.exportAll(_listItemIconClasses, exports);
'use client';

},{"./ListItemIcon":"3rp2p","./listItemIconClasses":"6cdKu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3rp2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _listItemIconClasses = require("./listItemIconClasses");
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { alignItems, classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemIconClasses.getListItemIconUtilityClass), classes);
};
const ListItemIconRoot = (0, _styledDefault.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const ListItemIcon = /*#__PURE__*/ _react.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemIconRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = ListItemIcon;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./listItemIconClasses":"6cdKu","../List/ListContext":"lt3pu","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6cdKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemIconUtilityClass", ()=>getListItemIconUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemIconUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiListItemIcon', slot);
}
const listItemIconClasses = (0, _generateUtilityClassesDefault.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
exports.default = listItemIconClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8IBhx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemTextDefault.default));
parcelHelpers.export(exports, "listItemTextClasses", ()=>(0, _listItemTextClassesDefault.default));
var _listItemText = require("./ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _listItemTextClasses = require("./listItemTextClasses");
var _listItemTextClassesDefault = parcelHelpers.interopDefault(_listItemTextClasses);
parcelHelpers.exportAll(_listItemTextClasses, exports);
'use client';

},{"./ListItemText":"eWU8B","./listItemTextClasses":"8YFwN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eWU8B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _listItemTextClasses = require("./listItemTextClasses");
var _listItemTextClassesDefault = parcelHelpers.interopDefault(_listItemTextClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, inset, primary, secondary, dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemTextClasses.getListItemTextUtilityClass), classes);
};
const ListItemTextRoot = (0, _styledDefault.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _listItemTextClassesDefault.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, _listItemTextClassesDefault.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const ListItemText = /*#__PURE__*/ _react.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children, className, disableTypography = false, inset = false, primary: primaryProp, primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { dense } = _react.useContext((0, _listContextDefault.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableTypography,
        inset,
        primary: !!primary,
        secondary: !!secondary,
        dense
    });
    const classes = useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, _typographyDefault.default) && !disableTypography) primary = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, _typographyDefault.default) && !disableTypography) secondary = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemTextRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
exports.default = ListItemText;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../Typography":"2wCD5","../List/ListContext":"lt3pu","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./listItemTextClasses":"8YFwN","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YFwN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemTextUtilityClass", ()=>getListItemTextUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemTextUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiListItemText', slot);
}
const listItemTextClasses = (0, _generateUtilityClassesDefault.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
exports.default = listItemTextClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hUxvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMenuItemUtilityClass", ()=>getMenuItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMenuItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiMenuItem', slot);
}
const menuItemClasses = (0, _generateUtilityClassesDefault.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
exports.default = menuItemClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7bRLE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tooltipDefault.default));
parcelHelpers.export(exports, "tooltipClasses", ()=>(0, _tooltipClassesDefault.default));
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tooltipClasses = require("./tooltipClasses");
var _tooltipClassesDefault = parcelHelpers.interopDefault(_tooltipClasses);
parcelHelpers.exportAll(_tooltipClasses, exports);
'use client';

},{"./Tooltip":"bYcnH","./tooltipClasses":"edVnQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bYcnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testReset", ()=>testReset);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _elementAcceptingRef = require("@mui/utils/elementAcceptingRef");
var _elementAcceptingRefDefault = parcelHelpers.interopDefault(_elementAcceptingRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _rtlProvider = require("@mui/system/RtlProvider");
var _appendOwnerState = require("@mui/utils/appendOwnerState");
var _appendOwnerStateDefault = parcelHelpers.interopDefault(_appendOwnerState);
var _getReactElementRef = require("@mui/utils/getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);
var _styles = require("../styles");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _grow = require("../Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _popper = require("../Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useId = require("../utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _useIsFocusVisible = require("../utils/useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _tooltipClasses = require("./tooltipClasses");
var _tooltipClassesDefault = parcelHelpers.interopDefault(_tooltipClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const useUtilityClasses = (ownerState)=>{
    const { classes, disableInteractive, arrow, touch, placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, _capitalizeDefault.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tooltipClasses.getTooltipUtilityClass), classes);
};
const TooltipPopper = (0, _styles.styled)((0, _popperDefault.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme, ownerState, open })=>(0, _extendsDefault.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, _tooltipClassesDefault.default).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, _tooltipClassesDefault.default).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, _tooltipClassesDefault.default).arrow}`]: (0, _extendsDefault.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, _tooltipClassesDefault.default).arrow}`]: (0, _extendsDefault.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const TooltipTooltip = (0, _styles.styled)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, _capitalizeDefault.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="left"] &`]: (0, _extendsDefault.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, _extendsDefault.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, _extendsDefault.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="right"] &`]: (0, _extendsDefault.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, _extendsDefault.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, _extendsDefault.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="top"] &`]: (0, _extendsDefault.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, _tooltipClassesDefault.default).popper}[data-popper-placement*="bottom"] &`]: (0, _extendsDefault.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const TooltipArrow = (0, _styles.styled)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, _colorManipulator.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let hystersisOpen = false;
const hystersisTimer = new (0, _useTimeout.Timeout)();
let cursorPosition = {
    x: 0,
    y: 0
};
function testReset() {
    hystersisOpen = false;
    hystersisTimer.clear();
}
function composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const Tooltip = /*#__PURE__*/ _react.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow = false, children: childrenProp, components = {}, componentsProps = {}, describeChild = false, disableFocusListener = false, disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener = false, enterDelay = 100, enterNextDelay = 0, enterTouchDelay = 700, followCursor = false, id: idProp, leaveDelay = 0, leaveTouchDelay = 1500, onClose, onOpen, open: openProp, placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps = {}, slotProps = {}, slots = {}, title, TransitionComponent: TransitionComponentProp = (0, _growDefault.default), TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ _react.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, _styles.useTheme)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const [childNode, setChildNode] = _react.useState();
    const [arrowRef, setArrowRef] = _react.useState(null);
    const ignoreNonTouchEvents = _react.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, _useTimeoutDefault.default)();
    const enterTimer = (0, _useTimeoutDefault.default)();
    const leaveTimer = (0, _useTimeoutDefault.default)();
    const touchTimer = (0, _useTimeoutDefault.default)();
    const [openState, setOpenState] = (0, _useControlledDefault.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, _useIdDefault.default)(idProp);
    const prevUserSelect = _react.useRef();
    const stopTouchInteraction = (0, _useEventCallbackDefault.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    _react.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        hystersisTimer.clear();
        hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, _useEventCallbackDefault.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        hystersisTimer.start(800 + leaveDelay, ()=>{
            hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || hystersisOpen && enterNextDelay) enterTimer.start(hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, _useIsFocusVisibleDefault.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = _react.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    _react.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, _useForkRefDefault.default)((0, _getReactElementRefDefault.default)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = _react.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, _extendsDefault.default)({}, nameOrDescProps, other, children.props, {
        className: (0, _clsxDefault.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = _react.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, _extendsDefault.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        isRtl,
        arrow,
        disableInteractive,
        placement,
        PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, _growDefault.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : TooltipArrow;
    const popperProps = (0, _appendOwnerStateDefault.default)(PopperComponent, (0, _extendsDefault.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, _clsxDefault.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, _appendOwnerStateDefault.default)(TransitionComponent, (0, _extendsDefault.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, _appendOwnerStateDefault.default)(TooltipComponent, (0, _extendsDefault.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, _clsxDefault.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, _appendOwnerStateDefault.default)(ArrowComponent, (0, _extendsDefault.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, _clsxDefault.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [
            /*#__PURE__*/ _react.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperComponent, (0, _extendsDefault.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, _popperDefault.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: cursorPosition.y,
                            left: cursorPosition.x,
                            right: cursorPosition.x,
                            bottom: cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TooltipComponent, (0, _extendsDefault.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ArrowComponent, (0, _extendsDefault.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
exports.default = Tooltip;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/useTimeout":"6WuNb","@mui/utils/elementAcceptingRef":"5WlCj","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","@mui/system/RtlProvider":"aMQRu","@mui/utils/appendOwnerState":"3olcZ","@mui/utils/getReactElementRef":"guLSb","../styles":"c9RfU","../DefaultPropsProvider":"ff3VX","../utils/capitalize":"hBZko","../Grow":"4LWtg","../Popper":"lX4bO","../utils/useEventCallback":"jTtn3","../utils/useForkRef":"cq8Sn","../utils/useId":"iMSy2","../utils/useIsFocusVisible":"fK0On","../utils/useControlled":"1VreF","./tooltipClasses":"edVnQ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lX4bO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _popperDefault.default));
var _popper = require("./Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _popperClasses = require("./popperClasses");
parcelHelpers.exportAll(_popperClasses, exports);
'use client';

},{"./Popper":"69dVP","./popperClasses":"4R31f","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"69dVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _useThemeWithoutDefault = require("@mui/system/useThemeWithoutDefault");
var _useThemeWithoutDefaultDefault = parcelHelpers.interopDefault(_useThemeWithoutDefault);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _htmlelementType = require("@mui/utils/HTMLElementType");
var _htmlelementTypeDefault = parcelHelpers.interopDefault(_htmlelementType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _basePopper = require("./BasePopper");
var _basePopperDefault = parcelHelpers.interopDefault(_basePopper);
var _styles = require("../styles");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const PopperRoot = (0, _styles.styled)((0, _basePopperDefault.default), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const Popper = /*#__PURE__*/ _react.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, _useThemeWithoutDefaultDefault.default)();
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl, component, components, componentsProps, container, disablePortal, keepMounted, modifiers, open, placement, popperOptions, popperRef, transition, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, _extendsDefault.default)({
        anchorEl,
        container,
        disablePortal,
        keepMounted,
        modifiers,
        open,
        placement,
        popperOptions,
        popperRef,
        transition
    }, other);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperRoot, (0, _extendsDefault.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
exports.default = Popper;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/system/useThemeWithoutDefault":"jklNp","@mui/utils/refType":"7a8uL","@mui/utils/HTMLElementType":"jZED3","prop-types":"bnNSm","react":"9njXz","./BasePopper":"2cLAp","../styles":"c9RfU","../DefaultPropsProvider":"ff3VX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jklNp":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("695d4c8cb3907f16"));
var _styledEngine = require("8d10ac940e387faa");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = React.useContext(_styledEngine.ThemeContext);
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var _default = exports.default = useTheme;

},{"695d4c8cb3907f16":"9njXz","8d10ac940e387faa":"4hxt2"}],"2cLAp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _utils = require("@mui/utils");
var _core = require("@popperjs/core");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _portal = require("../Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _popperClasses = require("./popperClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], _excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function isVirtualElement(element) {
    return !isHTMLElement(element);
}
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _popperClasses.getPopperUtilityClass), classes);
};
const defaultPopperOptions = {};
const PopperTooltip = /*#__PURE__*/ _react.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl, children, direction, disablePortal, modifiers, open, placement: initialPlacement, popperOptions, popperRef: popperRefProp, slotProps = {}, slots = {}, TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const tooltipRef = _react.useRef(null);
    const ownRef = (0, _utils.unstable_useForkRef)(tooltipRef, forwardedRef);
    const popperRef = _react.useRef(null);
    const handlePopperRef = (0, _utils.unstable_useForkRef)(popperRef, popperRefProp);
    const handlePopperRefRef = _react.useRef(handlePopperRef);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    _react.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = _react.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = _react.useState(resolveAnchorEl(anchorEl));
    _react.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    _react.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement(resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, _core.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, _extendsDefault.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, _useSlotPropsDefault.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const Popper = /*#__PURE__*/ _react.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl, children, container: containerProp, direction = 'ltr', disablePortal = false, keepMounted = false, modifiers, open, placement = 'bottom', popperOptions = defaultPopperOptions, popperRef, style, transition = false, slotProps = {}, slots = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const [exited, setExited] = _react.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && isHTMLElement(resolvedAnchorEl) ? (0, _utils.unstable_ownerDocument)(resolvedAnchorEl).body : (0, _utils.unstable_ownerDocument)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _portalDefault.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PopperTooltip, (0, _extendsDefault.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, _extendsDefault.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
exports.default = Popper;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","@mui/utils":"lfcNH","@popperjs/core":"4kymL","prop-types":"bnNSm","@mui/utils/composeClasses":"43D21","@mui/utils/useSlotProps":"kv8TD","../Portal":"gdTpC","./popperClasses":"4R31f","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kymL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
parcelHelpers.export(exports, "createPopperBase", ()=>(0, _createPopperJs.createPopper));
parcelHelpers.export(exports, "createPopper", ()=>(0, _popperJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper));
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":false,"./createPopper.js":false,"./popper.js":"23oSG","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVkdf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", ()=>top);
parcelHelpers.export(exports, "bottom", ()=>bottom);
parcelHelpers.export(exports, "right", ()=>right);
parcelHelpers.export(exports, "left", ()=>left);
parcelHelpers.export(exports, "auto", ()=>auto);
parcelHelpers.export(exports, "basePlacements", ()=>basePlacements);
parcelHelpers.export(exports, "start", ()=>start);
parcelHelpers.export(exports, "end", ()=>end);
parcelHelpers.export(exports, "clippingParents", ()=>clippingParents);
parcelHelpers.export(exports, "viewport", ()=>viewport);
parcelHelpers.export(exports, "popper", ()=>popper);
parcelHelpers.export(exports, "reference", ()=>reference);
parcelHelpers.export(exports, "variationPlacements", ()=>variationPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "beforeRead", ()=>beforeRead);
parcelHelpers.export(exports, "read", ()=>read);
parcelHelpers.export(exports, "afterRead", ()=>afterRead);
parcelHelpers.export(exports, "beforeMain", ()=>beforeMain);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "afterMain", ()=>afterMain);
parcelHelpers.export(exports, "beforeWrite", ()=>beforeWrite);
parcelHelpers.export(exports, "write", ()=>write);
parcelHelpers.export(exports, "afterWrite", ()=>afterWrite);
parcelHelpers.export(exports, "modifierPhases", ()=>modifierPhases);
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4uCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", ()=>popperGenerator);
parcelHelpers.export(exports, "createPopper", ()=>createPopper);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _detectOverflowJsDefault.default));
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(reference, (0, _getOffsetParentJsDefault.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"4mQXp","./dom-utils/getLayoutRect.js":"bweSm","./dom-utils/listScrollParents.js":"1qClO","./dom-utils/getOffsetParent.js":"bLvkb","./utils/orderModifiers.js":"4RWkj","./utils/debounce.js":"gcfKw","./utils/mergeByName.js":"kcmZR","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4mQXp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getCompositeRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","./getNodeScroll.js":"8P5ka","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","./getWindowScrollBarX.js":"kaNJ3","./getDocumentElement.js":"gcVmr","./isScrollParent.js":"eD7m7","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XyXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBoundingClientRect);
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"1bDAn","../utils/math.js":"8B7aS","./getWindow.js":"3ynkX","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bDAn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", ()=>isElement);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isShadowRoot", ()=>isShadowRoot);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ynkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindow);
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B7aS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "round", ()=>round);
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAhTK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isLayoutViewport);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fpMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getUAString);
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P5ka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeScroll);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"btekq","./getWindow.js":"3ynkX","./instanceOf.js":"1bDAn","./getHTMLElementScroll.js":"hYXUH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btekq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScroll);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYXUH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getHTMLElementScroll);
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyQUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getNodeName);
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kaNJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getWindowScrollBarX);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"4XyXs","./getDocumentElement.js":"gcVmr","./getWindowScroll.js":"btekq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcVmr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentElement);
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eD7m7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isScrollParent);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"5uZSa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uZSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getComputedStyle);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bweSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getLayoutRect);
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"4XyXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1qClO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>listScrollParents);
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"1igW6","./getParentNode.js":"k0cfu","./getWindow.js":"3ynkX","./isScrollParent.js":"eD7m7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1igW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollParent);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"k0cfu","./isScrollParent.js":"eD7m7","./getNodeName.js":"jyQUh","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k0cfu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getParentNode);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"jyQUh","./getDocumentElement.js":"gcVmr","./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLvkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOffsetParent);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"3ynkX","./getNodeName.js":"jyQUh","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./isTableElement.js":"btBRX","./getParentNode.js":"k0cfu","../utils/userAgent.js":"6fpMW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btBRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isTableElement);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"jyQUh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RWkj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>orderModifiers);
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcfKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>debounce);
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kcmZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeByName);
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6v2ts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectOverflow);
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"YPNSr","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getBoundingClientRect.js":"4XyXs","./computeOffsets.js":"gnv44","./rectToClientRect.js":"5PWlE","../enums.js":"gVkdf","../dom-utils/instanceOf.js":"1bDAn","./mergePaddingObject.js":"43lYJ","./expandToHashMap.js":"16QKI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YPNSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getClippingRect);
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"gVkdf","./getViewportRect.js":"2wQ5y","./getDocumentRect.js":"3LAyO","./listScrollParents.js":"1qClO","./getOffsetParent.js":"bLvkb","./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./instanceOf.js":"1bDAn","./getBoundingClientRect.js":"4XyXs","./getParentNode.js":"k0cfu","./contains.js":"eGlaM","./getNodeName.js":"jyQUh","../utils/rectToClientRect.js":"5PWlE","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2wQ5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getViewportRect);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"3ynkX","./getDocumentElement.js":"gcVmr","./getWindowScrollBarX.js":"kaNJ3","./isLayoutViewport.js":"hAhTK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LAyO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getDocumentRect);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"gcVmr","./getComputedStyle.js":"5uZSa","./getWindowScrollBarX.js":"kaNJ3","./getWindowScroll.js":"btekq","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGlaM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PWlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rectToClientRect);
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnv44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeOffsets);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"5S4fc","./getVariation.js":"4BYPr","./getMainAxisFromPlacement.js":"avEhJ","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5S4fc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getBasePlacement);
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4BYPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getVariation);
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avEhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getMainAxisFromPlacement);
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43lYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergePaddingObject);
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"gtdyp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtdyp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getFreshSideObject);
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"16QKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>expandToHashMap);
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"23oSG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", ()=>(0, _popperLiteJs.createPopper)) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", ()=>createPopper) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", ()=>(0, _createPopperJs.popperGenerator));
parcelHelpers.export(exports, "defaultModifiers", ()=>defaultModifiers);
parcelHelpers.export(exports, "detectOverflow", ()=>(0, _createPopperJs.detectOverflow));
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"b4uCU","./modifiers/eventListeners.js":"5tT8s","./modifiers/popperOffsets.js":"hVDuj","./modifiers/computeStyles.js":"jvHvj","./modifiers/applyStyles.js":"ewuA1","./modifiers/offset.js":"2lcLd","./modifiers/flip.js":"8WVPr","./modifiers/preventOverflow.js":"jUko2","./modifiers/arrow.js":"5Trmz","./modifiers/hide.js":"6kFua","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tT8s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"3ynkX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVDuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"gnv44","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jvHvj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", ()=>mapToStyles);
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"gVkdf","../dom-utils/getOffsetParent.js":"bLvkb","../dom-utils/getWindow.js":"3ynkX","../dom-utils/getDocumentElement.js":"gcVmr","../dom-utils/getComputedStyle.js":"5uZSa","../utils/getBasePlacement.js":"5S4fc","../utils/getVariation.js":"4BYPr","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewuA1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"jyQUh","../dom-utils/instanceOf.js":"1bDAn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lcLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", ()=>distanceAndSkiddingToXY);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"5S4fc","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WVPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"htgah","../utils/getBasePlacement.js":"5S4fc","../utils/getOppositeVariationPlacement.js":"3n1hw","../utils/detectOverflow.js":"6v2ts","../utils/computeAutoPlacement.js":"clJeY","../enums.js":"gVkdf","../utils/getVariation.js":"4BYPr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htgah":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositePlacement);
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n1hw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getOppositeVariationPlacement);
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"clJeY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>computeAutoPlacement);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"4BYPr","../enums.js":"gVkdf","./detectOverflow.js":"6v2ts","./getBasePlacement.js":"5S4fc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUko2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"gVkdf","../utils/getBasePlacement.js":"5S4fc","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/getAltAxis.js":"l4M4a","../utils/within.js":"cdkh1","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/getOffsetParent.js":"bLvkb","../utils/detectOverflow.js":"6v2ts","../utils/getVariation.js":"4BYPr","../utils/getFreshSideObject.js":"gtdyp","../utils/math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l4M4a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getAltAxis);
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cdkh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", ()=>within);
parcelHelpers.export(exports, "withinMaxClamp", ()=>withinMaxClamp);
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"8B7aS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Trmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"5S4fc","../dom-utils/getLayoutRect.js":"bweSm","../dom-utils/contains.js":"eGlaM","../dom-utils/getOffsetParent.js":"bLvkb","../utils/getMainAxisFromPlacement.js":"avEhJ","../utils/within.js":"cdkh1","../utils/mergePaddingObject.js":"43lYJ","../utils/expandToHashMap.js":"16QKI","../enums.js":"gVkdf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kFua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"gVkdf","../utils/detectOverflow.js":"6v2ts","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4R31f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPopperUtilityClass", ()=>getPopperUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPopperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPopper', slot);
}
const popperClasses = (0, _generateUtilityClassesDefault.default)('MuiPopper', [
    'root'
]);
exports.default = popperClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iMSy2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
'use client';
exports.default = (0, _useIdDefault.default);

},{"@mui/utils/useId":"eMerL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"edVnQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipUtilityClass", ()=>getTooltipUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTooltipUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTooltip', slot);
}
const tooltipClasses = (0, _generateUtilityClassesDefault.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
exports.default = tooltipClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"255tO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogDefault.default));
parcelHelpers.export(exports, "dialogClasses", ()=>(0, _dialogClassesDefault.default));
var _dialog = require("./Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogClasses = require("./dialogClasses");
var _dialogClassesDefault = parcelHelpers.interopDefault(_dialogClasses);
parcelHelpers.exportAll(_dialogClasses, exports);
'use client';

},{"./Dialog":"apEQC","./dialogClasses":"7FBQB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apEQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _modal = require("../Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _fade = require("../Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _dialogClasses = require("./dialogClasses");
var _dialogClassesDefault = parcelHelpers.interopDefault(_dialogClasses);
var _dialogContext = require("./DialogContext");
var _dialogContextDefault = parcelHelpers.interopDefault(_dialogContext);
var _backdrop = require("../Backdrop");
var _backdropDefault = parcelHelpers.interopDefault(_backdrop);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const DialogBackdrop = (0, _styledDefault.default)((0, _backdropDefault.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const useUtilityClasses = (ownerState)=>{
    const { classes, scroll, maxWidth, fullWidth, fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, _capitalizeDefault.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, _capitalizeDefault.default)(scroll)}`,
            `paperWidth${(0, _capitalizeDefault.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dialogClasses.getDialogUtilityClass), classes);
};
const DialogRoot = (0, _styledDefault.default)((0, _modalDefault.default), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const DialogContainer = (0, _styledDefault.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, _capitalizeDefault.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const DialogPaper = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, _capitalizeDefault.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, _capitalizeDefault.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, _dialogClassesDefault.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, _dialogClassesDefault.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, _dialogClassesDefault.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const Dialog = /*#__PURE__*/ _react.forwardRef(function Dialog(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, _useThemeDefault.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent, BackdropProps, children, className, disableEscapeKeyDown = false, fullScreen = false, fullWidth = false, maxWidth = 'sm', onBackdropClick, onClick, onClose, open, PaperComponent = (0, _paperDefault.default), PaperProps = {}, scroll = 'paper', TransitionComponent = (0, _fadeDefault.default), transitionDuration = defaultTransitionDuration, TransitionProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableEscapeKeyDown,
        fullScreen,
        fullWidth,
        maxWidth,
        scroll
    });
    const classes = useUtilityClasses(ownerState);
    const backdropClick = _react.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, _useIdDefault.default)(ariaLabelledbyProp);
    const dialogContextValue = _react.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, _extendsDefault.default)({
                transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContainer, {
                className: (0, _clsxDefault.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogPaper, (0, _extendsDefault.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, _clsxDefault.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContextDefault.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
exports.default = Dialog;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/useId":"eMerL","../utils/capitalize":"hBZko","../Modal":"akOht","../Fade":"8DwqP","../Paper":"arHf6","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./dialogClasses":"7FBQB","./DialogContext":"8O3Tg","../Backdrop":"j7994","../styles/useTheme":"d8hfc","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7FBQB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogUtilityClass", ()=>getDialogUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDialog', slot);
}
const dialogClasses = (0, _generateUtilityClassesDefault.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
exports.default = dialogClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8O3Tg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const DialogContext = /*#__PURE__*/ _react.createContext({});
exports.default = DialogContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5WZHz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogActionsDefault.default));
parcelHelpers.export(exports, "dialogActionsClasses", ()=>(0, _dialogActionsClassesDefault.default));
var _dialogActions = require("./DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogActionsClasses = require("./dialogActionsClasses");
var _dialogActionsClassesDefault = parcelHelpers.interopDefault(_dialogActionsClasses);
parcelHelpers.exportAll(_dialogActionsClasses, exports);
'use client';

},{"./DialogActions":"eMT6z","./dialogActionsClasses":"gGxDJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMT6z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _dialogActionsClasses = require("./dialogActionsClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "disableSpacing"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dialogActionsClasses.getDialogActionsUtilityClass), classes);
};
const DialogActionsRoot = (0, _styledDefault.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const DialogActions = /*#__PURE__*/ _react.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className, disableSpacing = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableSpacing
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogActionsRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = DialogActions;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./dialogActionsClasses":"gGxDJ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gGxDJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogActionsUtilityClass", ()=>getDialogActionsUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogActionsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDialogActions', slot);
}
const dialogActionsClasses = (0, _generateUtilityClassesDefault.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
exports.default = dialogActionsClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gD0J9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogContentDefault.default));
parcelHelpers.export(exports, "dialogContentClasses", ()=>(0, _dialogContentClassesDefault.default));
var _dialogContent = require("./DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogContentClasses = require("./dialogContentClasses");
var _dialogContentClassesDefault = parcelHelpers.interopDefault(_dialogContentClasses);
parcelHelpers.exportAll(_dialogContentClasses, exports);
'use client';

},{"./DialogContent":"4yW2t","./dialogContentClasses":"c7aZj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4yW2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _dialogContentClasses = require("./dialogContentClasses");
var _dialogTitleClasses = require("../DialogTitle/dialogTitleClasses");
var _dialogTitleClassesDefault = parcelHelpers.interopDefault(_dialogTitleClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "dividers"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dialogContentClasses.getDialogContentUtilityClass), classes);
};
const DialogContentRoot = (0, _styledDefault.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, _dialogTitleClassesDefault.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const DialogContent = /*#__PURE__*/ _react.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className, dividers = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        dividers
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContentRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = DialogContent;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./dialogContentClasses":"c7aZj","../DialogTitle/dialogTitleClasses":"8b2cc","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7aZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogContentUtilityClass", ()=>getDialogContentUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogContentUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDialogContent', slot);
}
const dialogContentClasses = (0, _generateUtilityClassesDefault.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
exports.default = dialogContentClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8b2cc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogTitleUtilityClass", ()=>getDialogTitleUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogTitleUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0, _generateUtilityClassesDefault.default)('MuiDialogTitle', [
    'root'
]);
exports.default = dialogTitleClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5sOv1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogTitleDefault.default));
parcelHelpers.export(exports, "dialogTitleClasses", ()=>(0, _dialogTitleClassesDefault.default));
var _dialogTitle = require("./DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _dialogTitleClasses = require("./dialogTitleClasses");
var _dialogTitleClassesDefault = parcelHelpers.interopDefault(_dialogTitleClasses);
parcelHelpers.exportAll(_dialogTitleClasses, exports);
'use client';

},{"./DialogTitle":"9BmDZ","./dialogTitleClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9BmDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _dialogTitleClasses = require("./dialogTitleClasses");
var _dialogContext = require("../Dialog/DialogContext");
var _dialogContextDefault = parcelHelpers.interopDefault(_dialogContext);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "id"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _dialogTitleClasses.getDialogTitleUtilityClass), classes);
};
const DialogTitleRoot = (0, _styledDefault.default)((0, _typographyDefault.default), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const DialogTitle = /*#__PURE__*/ _react.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className, id: idProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    const { titleId = idProp } = _react.useContext((0, _dialogContextDefault.default));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogTitleRoot, (0, _extendsDefault.default)({
        component: "h2",
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
exports.default = DialogTitle;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../Typography":"2wCD5","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./dialogTitleClasses":"8b2cc","../Dialog/DialogContext":"8O3Tg","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iTW3B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputLabelDefault.default));
parcelHelpers.export(exports, "inputLabelClasses", ()=>(0, _inputLabelClassesDefault.default));
var _inputLabel = require("./InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _inputLabelClasses = require("./inputLabelClasses");
var _inputLabelClassesDefault = parcelHelpers.interopDefault(_inputLabelClasses);
parcelHelpers.exportAll(_inputLabelClasses, exports);
'use client';

},{"./InputLabel":"e3dDT","./inputLabelClasses":"1o1Mc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e3dDT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formLabel = require("../FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _inputLabelClasses = require("./inputLabelClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, formControl, size, shrink, disableAnimation, variant, required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, _capitalizeDefault.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _inputLabelClasses.getInputLabelUtilityClasses), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const InputLabelRoot = (0, _styledDefault.default)((0, _formLabelDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _formLabel.formLabelClasses).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, _extendsDefault.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, _extendsDefault.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, _extendsDefault.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const InputLabel = /*#__PURE__*/ _react.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation = false, shrink: shrinkProp, className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableAnimation,
        formControl: muiFormControl,
        shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputLabelRoot, (0, _extendsDefault.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
exports.default = InputLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","@mui/utils/composeClasses":"43D21","clsx":"bK0Bf","../FormControl/formControlState":"lhkcI","../FormControl/useFormControl":"H1I5Z","../FormLabel":"haS5J","../DefaultPropsProvider":"ff3VX","../utils/capitalize":"hBZko","../styles/styled":"bTnxF","./inputLabelClasses":"1o1Mc","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"haS5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formLabelDefault.default));
parcelHelpers.export(exports, "formLabelClasses", ()=>(0, _formLabelClassesDefault.default));
var _formLabel = require("./FormLabel");
var _formLabelDefault = parcelHelpers.interopDefault(_formLabel);
parcelHelpers.exportAll(_formLabel, exports);
var _formLabelClasses = require("./formLabelClasses");
var _formLabelClassesDefault = parcelHelpers.interopDefault(_formLabelClasses);
parcelHelpers.exportAll(_formLabelClasses, exports);
'use client';

},{"./FormLabel":"dI3Wb","./formLabelClasses":"5s17K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dI3Wb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormLabelRoot", ()=>FormLabelRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _formLabelClasses = require("./formLabelClasses");
var _formLabelClassesDefault = parcelHelpers.interopDefault(_formLabelClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, color, focused, disabled, error, filled, required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalizeDefault.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formLabelClasses.getFormLabelUtilityClasses), classes);
};
const FormLabelRoot = (0, _styledDefault.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState }, styles)=>{
        return (0, _extendsDefault.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, _formLabelClassesDefault.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, _formLabelClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, _formLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const AsteriskComponent = (0, _styledDefault.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme })=>({
        [`&.${(0, _formLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const FormLabel = /*#__PURE__*/ _react.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children, className, component = 'label' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color: fcs.color || 'primary',
        component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormLabelRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
exports.default = FormLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../FormControl/formControlState":"lhkcI","../FormControl/useFormControl":"H1I5Z","../utils/capitalize":"hBZko","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./formLabelClasses":"5s17K","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5s17K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormLabelUtilityClasses", ()=>getFormLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiFormLabel', slot);
}
const formLabelClasses = (0, _generateUtilityClassesDefault.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
exports.default = formLabelClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1o1Mc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputLabelUtilityClasses", ()=>getInputLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiInputLabel', slot);
}
const inputLabelClasses = (0, _generateUtilityClassesDefault.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
exports.default = inputLabelClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"amnzu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _textFieldDefault.default));
parcelHelpers.export(exports, "textFieldClasses", ()=>(0, _textFieldClassesDefault.default));
var _textField = require("./TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _textFieldClasses = require("./textFieldClasses");
var _textFieldClassesDefault = parcelHelpers.interopDefault(_textFieldClasses);
parcelHelpers.exportAll(_textFieldClasses, exports);
'use client';

},{"./TextField":"iJGzx","./textFieldClasses":"cVE4u","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJGzx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _useId = require("@mui/utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _filledInput = require("../FilledInput");
var _filledInputDefault = parcelHelpers.interopDefault(_filledInput);
var _outlinedInput = require("../OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _inputLabel = require("../InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("../FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("../FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _select = require("../Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _textFieldClasses = require("./textFieldClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const variantComponent = {
    standard: (0, _inputDefault.default),
    filled: (0, _filledInputDefault.default),
    outlined: (0, _outlinedInputDefault.default)
};
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _textFieldClasses.getTextFieldUtilityClass), classes);
};
const TextFieldRoot = (0, _styledDefault.default)((0, _formControlDefault.default), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const TextField = /*#__PURE__*/ _react.forwardRef(function TextField(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete, autoFocus = false, children, className, color = 'primary', defaultValue, disabled = false, error = false, FormHelperTextProps, fullWidth = false, helperText, id: idOverride, InputLabelProps, inputProps, InputProps, inputRef, label, maxRows, minRows, multiline = false, name, onBlur, onChange, onFocus, placeholder, required = false, rows, select = false, SelectProps, type, value, variant = 'outlined' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        autoFocus,
        color,
        disabled,
        error,
        fullWidth,
        multiline,
        required,
        select,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, _useIdDefault.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputComponent, (0, _extendsDefault.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TextFieldRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), (0, _extendsDefault.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), (0, _extendsDefault.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), (0, _extendsDefault.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
exports.default = TextField;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/useId":"eMerL","@mui/utils/refType":"7a8uL","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../Input":"4s0JB","../FilledInput":"bo4qf","../OutlinedInput":"8eUp2","../InputLabel":"iTW3B","../FormControl":"kkska","../FormHelperText":"dlh9L","../Select":"aY7hn","./textFieldClasses":"cVE4u","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkska":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formControlDefault.default));
parcelHelpers.export(exports, "useFormControl", ()=>(0, _useFormControlDefault.default));
parcelHelpers.export(exports, "formControlClasses", ()=>(0, _formControlClassesDefault.default));
var _formControl = require("./FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _useFormControl = require("./useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formControlClasses = require("./formControlClasses");
var _formControlClassesDefault = parcelHelpers.interopDefault(_formControlClasses);
parcelHelpers.exportAll(_formControlClasses, exports);
'use client';

},{"./FormControl":"3jmNx","./useFormControl":"H1I5Z","./formControlClasses":"1V6jF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jmNx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _utils = require("../InputBase/utils");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _isMuiElement = require("../utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _formControlContext = require("./FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _formControlClasses = require("./formControlClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, margin, fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, _capitalizeDefault.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formControlClasses.getFormControlUtilityClasses), classes);
};
const FormControlRoot = (0, _styledDefault.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState }, styles)=>{
        return (0, _extendsDefault.default)({}, styles.root, styles[`margin${(0, _capitalizeDefault.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const FormControl = /*#__PURE__*/ _react.forwardRef(function FormControl(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children, className, color = 'primary', component = 'div', disabled = false, error = false, focused: visuallyFocused, fullWidth = false, hiddenLabel = false, margin = 'none', required = false, size = 'medium', variant = 'outlined' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disabled,
        error,
        fullWidth,
        hiddenLabel,
        margin,
        required,
        size,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = _react.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) _react.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElementDefault.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, _isMuiElementDefault.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, _utils.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = _react.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) _react.Children.forEach(children, (child)=>{
            if (!(0, _isMuiElementDefault.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, _utils.isFilled)(child.props, true) || (0, _utils.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = _react.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = _react.useMemo(()=>{
        return {
            adornedStart,
            setAdornedStart,
            color,
            disabled,
            error,
            filled,
            focused,
            fullWidth,
            hiddenLabel,
            size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect,
            required,
            variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormControlRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
exports.default = FormControl;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","../InputBase/utils":"ukWip","../utils/capitalize":"hBZko","../utils/isMuiElement":"bgSQq","./FormControlContext":"lcpxD","./formControlClasses":"1V6jF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgSQq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isMuiElement = require("@mui/utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
exports.default = (0, _isMuiElementDefault.default);

},{"@mui/utils/isMuiElement":"43Tbr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1V6jF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormControlUtilityClasses", ()=>getFormControlUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormControlUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiFormControl', slot);
}
const formControlClasses = (0, _generateUtilityClassesDefault.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
exports.default = formControlClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dlh9L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formHelperTextDefault.default));
parcelHelpers.export(exports, "formHelperTextClasses", ()=>(0, _formHelperTextClassesDefault.default));
var _formHelperText = require("./FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _formHelperTextClasses = require("./formHelperTextClasses");
var _formHelperTextClassesDefault = parcelHelpers.interopDefault(_formHelperTextClasses);
parcelHelpers.exportAll(_formHelperTextClasses, exports);
'use client';

},{"./FormHelperText":"kz0AS","./formHelperTextClasses":"7464F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kz0AS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _formHelperTextClasses = require("./formHelperTextClasses");
var _formHelperTextClassesDefault = parcelHelpers.interopDefault(_formHelperTextClasses);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
var _span;
const _excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, contained, size, disabled, error, filled, focused, required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, _capitalizeDefault.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formHelperTextClasses.getFormHelperTextUtilityClasses), classes);
};
const FormHelperTextRoot = (0, _styledDefault.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, _formHelperTextClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, _formHelperTextClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const FormHelperText = /*#__PURE__*/ _react.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children, className, component = 'p' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormHelperTextRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
exports.default = FormHelperText;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../FormControl/formControlState":"lhkcI","../FormControl/useFormControl":"H1I5Z","../styles/styled":"bTnxF","../utils/capitalize":"hBZko","./formHelperTextClasses":"7464F","../DefaultPropsProvider":"ff3VX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7464F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormHelperTextUtilityClasses", ()=>getFormHelperTextUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormHelperTextUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiFormHelperText', slot);
}
const formHelperTextClasses = (0, _generateUtilityClassesDefault.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
exports.default = formHelperTextClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVE4u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTextFieldUtilityClass", ()=>getTextFieldUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTextFieldUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTextField', slot);
}
const textFieldClasses = (0, _generateUtilityClassesDefault.default)('MuiTextField', [
    'root'
]);
exports.default = textFieldClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiJDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _inputAdornmentDefault.default));
parcelHelpers.export(exports, "inputAdornmentClasses", ()=>(0, _inputAdornmentClassesDefault.default));
var _inputAdornment = require("./InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _inputAdornmentClasses = require("./inputAdornmentClasses");
var _inputAdornmentClassesDefault = parcelHelpers.interopDefault(_inputAdornmentClasses);
parcelHelpers.exportAll(_inputAdornmentClasses, exports);
'use client';

},{"./InputAdornment":"hJGIl","./inputAdornmentClasses":"hwNA5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hJGIl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _formControlContext = require("../FormControl/FormControlContext");
var _formControlContextDefault = parcelHelpers.interopDefault(_formControlContext);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _inputAdornmentClasses = require("./inputAdornmentClasses");
var _inputAdornmentClassesDefault = parcelHelpers.interopDefault(_inputAdornmentClasses);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
var _span;
const _excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, disablePointerEvents, hiddenLabel, position, size, variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, _capitalizeDefault.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _inputAdornmentClasses.getInputAdornmentUtilityClass), classes);
};
const InputAdornmentRoot = (0, _styledDefault.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, _inputAdornmentClassesDefault.default).positionStart}&:not(.${(0, _inputAdornmentClassesDefault.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const InputAdornment = /*#__PURE__*/ _react.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children, className, component = 'div', disablePointerEvents = false, disableTypography = false, position, variant: variantProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents,
        position,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlContextDefault.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputAdornmentRoot, (0, _extendsDefault.default)({
            as: component,
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ _span || (_span = /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
exports.default = InputAdornment;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../utils/capitalize":"hBZko","../Typography":"2wCD5","../FormControl/FormControlContext":"lcpxD","../FormControl/useFormControl":"H1I5Z","../styles/styled":"bTnxF","./inputAdornmentClasses":"hwNA5","../DefaultPropsProvider":"ff3VX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwNA5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInputAdornmentUtilityClass", ()=>getInputAdornmentUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getInputAdornmentUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiInputAdornment', slot);
}
const inputAdornmentClasses = (0, _generateUtilityClassesDefault.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
exports.default = inputAdornmentClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRYSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _makeStylesDefault.default));
var _makeStyles = require("./makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);

},{"./makeStyles":"i84dZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i84dZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>makeStyles);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _jss = require("jss");
var _mergeClasses = require("../mergeClasses");
var _mergeClassesDefault = parcelHelpers.interopDefault(_mergeClasses);
var _multiKeyStore = require("./multiKeyStore");
var _multiKeyStoreDefault = parcelHelpers.interopDefault(_multiKeyStore);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _stylesProvider = require("../StylesProvider");
var _indexCounter = require("./indexCounter");
var _getStylesCreator = require("../getStylesCreator");
var _getStylesCreatorDefault = parcelHelpers.interopDefault(_getStylesCreator);
var _noopTheme = require("../getStylesCreator/noopTheme");
var _noopThemeDefault = parcelHelpers.interopDefault(_noopTheme);
const _excluded = [
    "name",
    "classNamePrefix",
    "Component",
    "defaultTheme"
];
function getClasses({ state, stylesOptions }, classes, Component) {
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
    // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    let generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, _mergeClassesDefault.default)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component
    });
    return state.cacheClasses.value;
}
function attach({ state, theme, stylesOptions, stylesCreator, name }, props) {
    if (stylesOptions.disableGeneration) return;
    let sheetManager = (0, _multiKeyStoreDefault.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, _multiKeyStoreDefault.default).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    const options = (0, _extendsDefault.default)({}, stylesCreator.options, stylesOptions, {
        theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        let staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, _multiKeyStoreDefault.default).get(stylesOptions.sheetsCache, stylesCreator, theme);
        const styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extendsDefault.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, _multiKeyStoreDefault.default).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        const dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extendsDefault.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, _mergeClassesDefault.default)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function update({ state }, props) {
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function detach({ state, theme, stylesOptions, stylesCreator }) {
    if (stylesOptions.disableGeneration) return;
    const sheetManager = (0, _multiKeyStoreDefault.default).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    const sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, _multiKeyStoreDefault.default).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function useSynchronousEffect(func, values) {
    const key = _react.useRef([]);
    let output;
    // Store "generation" key. Just returns a new object every time
    const currentKey = _react.useMemo(()=>({}), values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    _react.useEffect(()=>()=>{
            if (output) output();
        }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function makeStyles(stylesOrCreator, options = {}) {
    const { // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name, // Help with debuggability.
    classNamePrefix: classNamePrefixOption, Component, defaultTheme = (0, _noopThemeDefault.default) } = options, stylesOptions2 = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
    const stylesCreator = (0, _getStylesCreatorDefault.default)(stylesOrCreator);
    const classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, _indexCounter.increment)(),
        name,
        meta: classNamePrefix,
        classNamePrefix
    };
    const useStyles = (props = {})=>{
        const theme = (0, _useThemeDefault.default)() || defaultTheme;
        const stylesOptions = (0, _extendsDefault.default)({}, _react.useContext((0, _stylesProvider.StylesContext)), stylesOptions2);
        const instance = _react.useRef();
        const shouldUpdate = _react.useRef();
        useSynchronousEffect(()=>{
            const current = {
                name,
                state: {},
                stylesCreator,
                stylesOptions,
                theme
            };
            attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return ()=>{
                detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        _react.useEffect(()=>{
            if (shouldUpdate.current) update(instance.current, props);
            shouldUpdate.current = true;
        });
        const classes = getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","jss":"goZkg","../mergeClasses":"10sQg","./multiKeyStore":"PuCel","../useTheme":"bgjlH","../StylesProvider":"9RKq6","./indexCounter":"9Syd6","../getStylesCreator":"2BsIb","../getStylesCreator/noopTheme":"9zkxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"goZkg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuleList", ()=>RuleList);
parcelHelpers.export(exports, "SheetsManager", ()=>SheetsManager);
parcelHelpers.export(exports, "SheetsRegistry", ()=>SheetsRegistry);
parcelHelpers.export(exports, "create", ()=>createJss);
parcelHelpers.export(exports, "createGenerateId", ()=>createGenerateId);
parcelHelpers.export(exports, "createRule", ()=>createRule);
parcelHelpers.export(exports, "getDynamicStyles", ()=>getDynamicStyles);
parcelHelpers.export(exports, "hasCSSTOMSupport", ()=>hasCSSTOMSupport);
parcelHelpers.export(exports, "sheets", ()=>sheets);
parcelHelpers.export(exports, "toCssValue", ()=>toCssValue);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _isInBrowser = require("is-in-browser");
var _isInBrowserDefault = parcelHelpers.interopDefault(_isInBrowser);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, _inheritsLooseDefault.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, _extendsDefault.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, _createClassDefault.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, _extendsDefault.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, _extendsDefault.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, _extendsDefault.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, _inheritsLooseDefault.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, _extendsDefault.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, _extendsDefault.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, _extendsDefault.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, _extendsDefault.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, _createClassDefault.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, _isInBrowserDefault.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, _extendsDefault.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, _extendsDefault.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, _extendsDefault.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, _tinyWarningDefault.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, _tinyWarningDefault.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, _createClassDefault.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
exports.default = index;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","is-in-browser":"kMtWA","tiny-warning":"5e17w","@babel/runtime/helpers/esm/createClass":"3gRhs","@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kMtWA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
exports.default = isBrowser;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10sQg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mergeClassesDefault.default));
var _mergeClasses = require("./mergeClasses");
var _mergeClassesDefault = parcelHelpers.interopDefault(_mergeClasses);

},{"./mergeClasses":"8FAOB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8FAOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeClasses);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("@mui/utils");
function mergeClasses(options = {}) {
    const { baseClasses, newClasses, Component } = options;
    if (!newClasses) return baseClasses;
    const nextClasses = (0, _extendsDefault.default)({}, baseClasses);
    Object.keys(newClasses).forEach((key)=>{
        if (newClasses[key]) nextClasses[key] = `${baseClasses[key]} ${newClasses[key]}`;
    });
    return nextClasses;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils":"lfcNH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"PuCel":[function(require,module,exports,__globalThis) {
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const multiKeyStore = {
    set: (cache, key1, key2, value)=>{
        let subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: (cache, key1, key2)=>{
        const subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
exports.default = multiKeyStore;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgjlH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _useTheme = require("@mui/private-theming/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
function useTheme() {
    var _privateTheme$$$mater;
    const privateTheme = (0, _useThemeDefault.default)();
    return (_privateTheme$$$mater = privateTheme == null ? void 0 : privateTheme.$$material) != null ? _privateTheme$$$mater : privateTheme;
}

},{"@mui/private-theming/useTheme":"3GQzX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9RKq6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _stylesProviderDefault.default));
var _stylesProvider = require("./StylesProvider");
var _stylesProviderDefault = parcelHelpers.interopDefault(_stylesProvider);
parcelHelpers.exportAll(_stylesProvider, exports);

},{"./StylesProvider":"a8KuI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8KuI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Exported for test purposes
parcelHelpers.export(exports, "sheetsManager", ()=>defaultSheetsManager);
parcelHelpers.export(exports, "StylesContext", ()=>StylesContext);
parcelHelpers.export(exports, "default", ()=>StylesProvider);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _jss = require("jss");
var _createGenerateClassName = require("../createGenerateClassName");
var _createGenerateClassNameDefault = parcelHelpers.interopDefault(_createGenerateClassName);
var _jssPreset = require("../jssPreset");
var _jssPresetDefault = parcelHelpers.interopDefault(_jssPreset);
// Default JSS instance.
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "children",
    "injectFirst",
    "disableGeneration"
];
const defaultJSS = (0, _jss.create)((0, _jssPresetDefault.default)());
// Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
const defaultGenerateClassName = (0, _createGenerateClassNameDefault.default)();
const defaultSheetsManager = new Map();
const defaultOptions = {
    disableGeneration: false,
    generateClassName: defaultGenerateClassName,
    jss: defaultJSS,
    sheetsCache: null,
    sheetsManager: defaultSheetsManager,
    sheetsRegistry: null
};
const StylesContext = /*#__PURE__*/ _react.createContext(defaultOptions);
let injectFirstNode;
function StylesProvider(props) {
    const { children, injectFirst = false, disableGeneration = false } = props, localOptions = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const outerOptions = _react.useContext(StylesContext);
    const { generateClassName, jss, serverGenerateClassName, sheetsCache, sheetsManager, sheetsRegistry } = (0, _extendsDefault.default)({}, outerOptions, localOptions);
    const value = _react.useMemo(()=>{
        const context = {
            disableGeneration,
            generateClassName,
            jss,
            serverGenerateClassName,
            sheetsCache,
            sheetsManager,
            sheetsRegistry
        };
        if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
            if (!injectFirstNode) {
                const head = document.head;
                injectFirstNode = document.createComment('mui-inject-first');
                head.insertBefore(injectFirstNode, head.firstChild);
            }
            context.jss = (0, _jss.create)({
                plugins: (0, _jssPresetDefault.default)().plugins,
                insertionPoint: injectFirstNode
            });
        }
        return context;
    }, [
        injectFirst,
        disableGeneration,
        generateClassName,
        jss,
        serverGenerateClassName,
        sheetsCache,
        sheetsManager,
        sheetsRegistry
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StylesContext.Provider, {
        value: value,
        children: children
    });
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/utils":"lfcNH","jss":"goZkg","../createGenerateClassName":"lDuwv","../jssPreset":"ia5L9","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDuwv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _createGenerateClassNameDefault.default));
var _createGenerateClassName = require("./createGenerateClassName");
var _createGenerateClassNameDefault = parcelHelpers.interopDefault(_createGenerateClassName);

},{"./createGenerateClassName":"TdGwh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"TdGwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createGenerateClassName);
var _themeProvider = require("@mui/private-theming/ThemeProvider");
/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously defined styles as well as
 * being untouched by simple user overrides.
 */ const stateClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
];
function createGenerateClassName(options = {}) {
    const { disableGlobal = false, productionPrefix = 'jss', seed = '' } = options;
    const seedPrefix = seed === '' ? '' : `${seed}-`;
    let ruleCounter = 0;
    const getNextCounterId = ()=>{
        ruleCounter += 1;
        return ruleCounter;
    };
    return (rule, styleSheet)=>{
        const name = styleSheet.options.name;
        // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if (stateClasses.indexOf(rule.key) !== -1) return `Mui-${rule.key}`;
            const prefix = `${seedPrefix}${name}-${rule.key}`;
            if (!styleSheet.options.theme[0, _themeProvider.unstable_nested] || seed !== '') return prefix;
            return `${prefix}-${getNextCounterId()}`;
        }
        return `${seedPrefix}${productionPrefix}${getNextCounterId()}`;
    };
}

},{"@mui/private-theming/ThemeProvider":"llabg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ia5L9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _jssPresetDefault.default));
var _jssPreset = require("./jssPreset");
var _jssPresetDefault = parcelHelpers.interopDefault(_jssPreset);

},{"./jssPreset":"5He8c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5He8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>jssPreset);
var _jssPluginRuleValueFunction = require("jss-plugin-rule-value-function");
var _jssPluginRuleValueFunctionDefault = parcelHelpers.interopDefault(_jssPluginRuleValueFunction);
var _jssPluginGlobal = require("jss-plugin-global");
var _jssPluginGlobalDefault = parcelHelpers.interopDefault(_jssPluginGlobal);
var _jssPluginNested = require("jss-plugin-nested");
var _jssPluginNestedDefault = parcelHelpers.interopDefault(_jssPluginNested);
var _jssPluginCamelCase = require("jss-plugin-camel-case");
var _jssPluginCamelCaseDefault = parcelHelpers.interopDefault(_jssPluginCamelCase);
var _jssPluginDefaultUnit = require("jss-plugin-default-unit");
var _jssPluginDefaultUnitDefault = parcelHelpers.interopDefault(_jssPluginDefaultUnit);
var _jssPluginVendorPrefixer = require("jss-plugin-vendor-prefixer");
var _jssPluginVendorPrefixerDefault = parcelHelpers.interopDefault(_jssPluginVendorPrefixer);
var _jssPluginPropsSort = require("jss-plugin-props-sort");
var _jssPluginPropsSortDefault = parcelHelpers.interopDefault(_jssPluginPropsSort);
function jssPreset() {
    return {
        plugins: [
            (0, _jssPluginRuleValueFunctionDefault.default)(),
            (0, _jssPluginGlobalDefault.default)(),
            (0, _jssPluginNestedDefault.default)(),
            (0, _jssPluginCamelCaseDefault.default)(),
            (0, _jssPluginDefaultUnitDefault.default)(),
            // Disable the vendor prefixer server-side, it does nothing.
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixerDefault.default)(),
            (0, _jssPluginPropsSortDefault.default)()
        ]
    };
}

},{"jss-plugin-rule-value-function":"7NaMZ","jss-plugin-global":"gQwqk","jss-plugin-nested":"jAn1r","jss-plugin-camel-case":"5HEWg","jss-plugin-default-unit":"h4hxB","jss-plugin-vendor-prefixer":"2y9c5","jss-plugin-props-sort":"410Oy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7NaMZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var _jss = require("jss");
var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
var functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, _jss.createRule)(name, {}, options);
            rule[fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if (fnValuesNs in rule || fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
exports.default = functionPlugin;

},{"tiny-warning":"5e17w","jss":"goZkg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQwqk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _jss = require("jss");
var at = '@global';
var atPrefix = '@global ';
var GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, _jss.RuleList)((0, _extendsDefault.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr(atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, _extendsDefault.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var separatorRegExp = /\s*,\s*/g;
function addScope(selector, scope) {
    var parts = selector.split(separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, _extendsDefault.default)({}, options, {
        selector: addScope(name, rule.selector)
    }));
    delete style[at];
}
function handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
        var selector = addScope(prop.substr(at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, _extendsDefault.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === at) return new GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) return new GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        handleNestedGlobalContainerRule(rule, sheet);
        handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
exports.default = jssGlobal;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","jss":"goZkg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jAn1r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split(separatorRegExp);
        var nestedSelectors = nestedProp.split(separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, _extendsDefault.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, _extendsDefault.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace(refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, _extendsDefault.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, _extendsDefault.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
exports.default = jssNested;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","tiny-warning":"5e17w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5HEWg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hyphenateStyleName = require("hyphenate-style-name");
var _hyphenateStyleNameDefault = parcelHelpers.interopDefault(_hyphenateStyleName);
/**
 * Convert camel cased property names to dash separated.
 */ function convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, _hyphenateStyleNameDefault.default)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);
        else converted.fallbacks = convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = convertCase(style[index]);
            return style;
        }
        return convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, _hyphenateStyleNameDefault.default)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
exports.default = camelCase;

},{"hyphenate-style-name":"54EmU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"54EmU":[function(require,module,exports,__globalThis) {
/* eslint-disable no-var, prefer-template */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};
function toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function hyphenateStyleName(name) {
    if (cache.hasOwnProperty(name)) return cache[name];
    var hName = name.replace(uppercasePattern, toHyphenLower);
    return cache[name] = msPattern.test(hName) ? '-' + hName : hName;
}
exports.default = hyphenateStyleName;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4hxB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jss = require("jss");
var px = (0, _jss.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var ms = (0, _jss.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var percent = (0, _jss.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var defaultUnits = {
    // Animation properties
    'animation-delay': ms,
    'animation-duration': ms,
    // Background properties
    'background-position': px,
    'background-position-x': px,
    'background-position-y': px,
    'background-size': px,
    // Border Properties
    border: px,
    'border-bottom': px,
    'border-bottom-left-radius': px,
    'border-bottom-right-radius': px,
    'border-bottom-width': px,
    'border-left': px,
    'border-left-width': px,
    'border-radius': px,
    'border-right': px,
    'border-right-width': px,
    'border-top': px,
    'border-top-left-radius': px,
    'border-top-right-radius': px,
    'border-top-width': px,
    'border-width': px,
    'border-block': px,
    'border-block-end': px,
    'border-block-end-width': px,
    'border-block-start': px,
    'border-block-start-width': px,
    'border-block-width': px,
    'border-inline': px,
    'border-inline-end': px,
    'border-inline-end-width': px,
    'border-inline-start': px,
    'border-inline-start-width': px,
    'border-inline-width': px,
    'border-start-start-radius': px,
    'border-start-end-radius': px,
    'border-end-start-radius': px,
    'border-end-end-radius': px,
    // Margin properties
    margin: px,
    'margin-bottom': px,
    'margin-left': px,
    'margin-right': px,
    'margin-top': px,
    'margin-block': px,
    'margin-block-end': px,
    'margin-block-start': px,
    'margin-inline': px,
    'margin-inline-end': px,
    'margin-inline-start': px,
    // Padding properties
    padding: px,
    'padding-bottom': px,
    'padding-left': px,
    'padding-right': px,
    'padding-top': px,
    'padding-block': px,
    'padding-block-end': px,
    'padding-block-start': px,
    'padding-inline': px,
    'padding-inline-end': px,
    'padding-inline-start': px,
    // Mask properties
    'mask-position-x': px,
    'mask-position-y': px,
    'mask-size': px,
    // Width and height properties
    height: px,
    width: px,
    'min-height': px,
    'max-height': px,
    'min-width': px,
    'max-width': px,
    // Position properties
    bottom: px,
    left: px,
    top: px,
    right: px,
    inset: px,
    'inset-block': px,
    'inset-block-end': px,
    'inset-block-start': px,
    'inset-inline': px,
    'inset-inline-end': px,
    'inset-inline-start': px,
    // Shadow properties
    'box-shadow': px,
    'text-shadow': px,
    // Column properties
    'column-gap': px,
    'column-rule': px,
    'column-rule-width': px,
    'column-width': px,
    // Font and text properties
    'font-size': px,
    'font-size-delta': px,
    'letter-spacing': px,
    'text-decoration-thickness': px,
    'text-indent': px,
    'text-stroke': px,
    'text-stroke-width': px,
    'word-spacing': px,
    // Motion properties
    motion: px,
    'motion-offset': px,
    // Outline properties
    outline: px,
    'outline-offset': px,
    'outline-width': px,
    // Perspective properties
    perspective: px,
    'perspective-origin-x': percent,
    'perspective-origin-y': percent,
    // Transform properties
    'transform-origin': percent,
    'transform-origin-x': percent,
    'transform-origin-y': percent,
    'transform-origin-z': percent,
    // Transition properties
    'transition-delay': ms,
    'transition-duration': ms,
    // Alignment properties
    'vertical-align': px,
    'flex-basis': px,
    // Some random properties
    'shape-margin': px,
    size: px,
    gap: px,
    // Grid properties
    grid: px,
    'grid-gap': px,
    'row-gap': px,
    'grid-row-gap': px,
    'grid-column-gap': px,
    'grid-template-rows': px,
    'grid-template-columns': px,
    'grid-auto-rows': px,
    'grid-auto-columns': px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': px,
    'box-shadow-y': px,
    'box-shadow-blur': px,
    'box-shadow-spread': px,
    'font-line-height': px,
    'text-shadow-x': px,
    'text-shadow-y': px,
    'text-shadow-blur': px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */ function iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
exports.default = defaultUnit;

},{"jss":"goZkg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2y9c5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssVendor = require("css-vendor");
var _jss = require("jss");
/**
 * Add vendor prefix to a property name when needed.
 */ function jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, _cssVendor.supportedKeyframes)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, _cssVendor.supportedProperty)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, _cssVendor.supportedValue)(supportedProp, (0, _jss.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, _cssVendor.supportedValue)(prop, (0, _jss.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
exports.default = jssVendorPrefixer;

},{"css-vendor":"diAj5","jss":"goZkg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"diAj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefix", ()=>prefix);
parcelHelpers.export(exports, "supportedKeyframes", ()=>supportedKeyframes);
parcelHelpers.export(exports, "supportedProperty", ()=>supportedProperty);
parcelHelpers.export(exports, "supportedValue", ()=>supportedValue);
var _isInBrowser = require("is-in-browser");
var _isInBrowserDefault = parcelHelpers.interopDefault(_isInBrowser);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = (0, _isInBrowserDefault.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, _isInBrowserDefault.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var _document$createEleme = document.createElement('p'), style = _document$createEleme.style;
    var testProp = 'Transform';
    for(var key in jsCssMap)if (key + testProp in style) {
        js = key;
        css = jsCssMap[key];
        break;
    }
     // Correctly detect the Edge browser.
    if (js === 'Webkit' && 'msHyphens' in style) {
        js = 'ms';
        css = jsCssMap.ms;
        browser = 'edge';
    } // Correctly detect the Safari browser.
    if (js === 'Webkit' && '-apple-trailing-word' in style) vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var prefix = {
    js: js,
    css: css,
    vendor: vendor,
    browser: browser,
    isTouch: isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function supportedKeyframes(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if (prefix.js === 'ms') return key;
    return "@" + prefix.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if (prefix.js === 'ms') return "-webkit-" + prop;
        return prefix.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
        return prop;
    }
};
var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function camelize(str) {
    return str.replace(regExp, toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function pascalize(str) {
    return camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if (prefix.js === 'Webkit') {
            var longhand = 'mask-image';
            if (camelize(longhand) in style) return prop;
            if (prefix.js + pascalize(longhand) in style) return prefix.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if (prefix.vendor === 'apple' && !prefix.isTouch) return prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return prefix.css + prop;
    }
};
// https://caniuse.com/#search=transition
var transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return prefix.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') return prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') return prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if (prefix.js === 'Webkit') {
            var jsProp = "WebkitColumn" + pascalize(prop);
            return jsProp in style ? prefix.css + "column-" + prop : false;
        }
        if (prefix.js === 'Moz') {
            var _jsProp = "page" + pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if (prefix.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return camelize(prop) in style ? prop : false;
    }
};
var prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
        if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if (prefix.js === 'ms') return "" + prefix.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if (prefix.js === 'ms') return prefix.css + "scroll-chaining";
        return prop;
    }
};
var propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = propMap[prop];
        if (!newProp) return false;
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
    }
};
var propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);
var prefixCss = function prefixCss(p) {
    return prefix.css + p;
}; // Support old flex spec from 2009.
var flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if (propKeys.indexOf(prop) > -1) {
            var newProp = propMap$1[prop];
            if (!Array.isArray(newProp)) return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!(prefix.js + pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map(prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var plugins = [
    appearence,
    colorAdjust,
    mask,
    textOrientation,
    transform,
    transition,
    writingMode,
    userSelect,
    breakPropsOld,
    inlineLogicalOld,
    unprefixed,
    prefixed,
    scrollSnap,
    overscrollBehavior,
    flex2012,
    flex2009
];
var propertyDetectors = plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var noPrefill = plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, _toConsumableArrayDefault.default)(p.noPrefill));
    return a;
}, []);
var el;
var cache = {};
if (0, _isInBrowserDefault.default) {
    el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var computed = window.getComputedStyle(document.documentElement, '');
    for(var key$1 in computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    noPrefill.forEach(function(x) {
        return delete cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function supportedProperty(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if (cache[prop] != null) return cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < propertyDetectors.length; i++){
        cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
        if (cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return cache[prop];
}
var cache$1 = {};
var transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, _isInBrowserDefault.default) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function supportedValue(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if (cache$1[cacheKey] != null) return cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if (transitionProperties[property]) prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
    else if (el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        el$1.style[property] = prefixedValue; // Return false if value not supported.
        if (el$1.style[property] === '') {
            cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    el$1.style[property] = ''; // Write current value to cache.
    cache$1[cacheKey] = prefixedValue;
    return cache$1[cacheKey];
}

},{"is-in-browser":"kMtWA","@babel/runtime/helpers/esm/toConsumableArray":"iT0h5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"410Oy":[function(require,module,exports,__globalThis) {
/**
 * Sort props by length.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
exports.default = jssPropsSort;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Syd6":[function(require,module,exports,__globalThis) {
/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "increment", ()=>increment);
let indexCounter = -1000000000;
function increment() {
    indexCounter += 1;
    return indexCounter;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2BsIb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getStylesCreatorDefault.default));
var _getStylesCreator = require("./getStylesCreator");
var _getStylesCreatorDefault = parcelHelpers.interopDefault(_getStylesCreator);

},{"./getStylesCreator":"kiFd8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kiFd8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getStylesCreator);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _utils = require("@mui/utils");
var _propsToClassKey = require("../propsToClassKey");
var _propsToClassKeyDefault = parcelHelpers.interopDefault(_propsToClassKey);
var _noopTheme = require("./noopTheme");
var _noopThemeDefault = parcelHelpers.interopDefault(_noopTheme);
function getStylesCreator(stylesOrCreator) {
    const themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: (theme, name)=>{
            let styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.components || !theme.components[name] || !theme.components[name].styleOverrides && !theme.components[name].variants) return styles;
            const overrides = theme.components[name].styleOverrides || {};
            const variants = theme.components[name].variants || [];
            const stylesWithOverrides = (0, _extendsDefault.default)({}, styles);
            Object.keys(overrides).forEach((key)=>{
                stylesWithOverrides[key] = (0, _utils.deepmerge)(stylesWithOverrides[key] || {}, overrides[key]);
            });
            variants.forEach((definition)=>{
                const classKey = (0, _propsToClassKeyDefault.default)(definition.props);
                stylesWithOverrides[classKey] = (0, _utils.deepmerge)(stylesWithOverrides[classKey] || {}, definition.style);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils":"lfcNH","../propsToClassKey":"71eCp","./noopTheme":"9zkxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71eCp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _propsToClassKeyDefault.default));
var _propsToClassKey = require("./propsToClassKey");
var _propsToClassKeyDefault = parcelHelpers.interopDefault(_propsToClassKey);

},{"./propsToClassKey":"heS86","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"heS86":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>propsToClassKey);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _utils = require("@mui/utils");
const _excluded = [
    "variant"
];
function isEmpty(string) {
    return string.length === 0;
}
function propsToClassKey(props) {
    const { variant } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    let classKey = variant || '';
    Object.keys(other).sort().forEach((key)=>{
        if (key === 'color') classKey += isEmpty(classKey) ? props[key] : (0, _utils.unstable_capitalize)(props[key]);
        else classKey += `${isEmpty(classKey) ? key : (0, _utils.unstable_capitalize)(key)}${(0, _utils.unstable_capitalize)(props[key].toString())}`;
    });
    return classKey;
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils":"lfcNH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9zkxf":[function(require,module,exports,__globalThis) {
// We use the same empty object to ref count the styles that don't need a theme object.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const noopTheme = {};
exports.default = noopTheme;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d8vct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _withStylesDefault.default));
var _withStyles = require("./withStyles");
var _withStylesDefault = parcelHelpers.interopDefault(_withStyles);

},{"./withStyles":"f0GLS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f0GLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _utils = require("@mui/utils");
var _makeStyles = require("../makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
var _getThemeProps = require("../getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
var _useTheme = require("../useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
// Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "defaultTheme",
    "withTheme",
    "name"
], _excluded2 = [
    "classes"
];
const withStyles = (stylesOrCreator, options = {})=>(Component)=>{
        const { defaultTheme, withTheme = false, name } = options, stylesOptions = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
        let classNamePrefix = name;
        const useStyles = (0, _makeStylesDefault.default)(stylesOrCreator, (0, _extendsDefault.default)({
            defaultTheme,
            Component,
            name: name || Component.displayName,
            classNamePrefix
        }, stylesOptions));
        const WithStyles = /*#__PURE__*/ _react.forwardRef(function WithStyles(props, ref) {
            const other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
            // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            const classes = useStyles((0, _extendsDefault.default)({}, Component.defaultProps, props));
            let theme;
            let more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, _useThemeDefault.default)() || defaultTheme;
                if (name) more = (0, _getThemePropsDefault.default)({
                    theme,
                    name,
                    props: other
                });
                // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _extendsDefault.default)({
                ref: ref,
                classes: classes
            }, more));
        });
        (0, _hoistNonReactStaticsDefault.default)(WithStyles, Component);
        return WithStyles;
    };
exports.default = withStyles;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","hoist-non-react-statics":"59Kh2","@mui/utils":"lfcNH","../makeStyles":"hRYSM","../getThemeProps":"4VYEe","../useTheme":"bgjlH","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4VYEe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _getThemePropsDefault.default));
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);

},{"./getThemeProps":"6z7Xo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6z7Xo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getThemeProps);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    const output = (0, _extendsDefault.default)({}, props);
    // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    const defaultProps = theme.components[name].defaultProps;
    let propName;
    for(propName in defaultProps)if (output[propName] === undefined) output[propName] = defaultProps[propName];
    return output;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bXjnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _iconButtonDefault.default));
parcelHelpers.export(exports, "iconButtonClasses", ()=>(0, _iconButtonClassesDefault.default));
var _iconButton = require("./IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _iconButtonClasses = require("./iconButtonClasses");
var _iconButtonClassesDefault = parcelHelpers.interopDefault(_iconButtonClasses);
parcelHelpers.exportAll(_iconButtonClasses, exports);
'use client';

},{"./IconButton":"gWbyX","./iconButtonClasses":"bLPmg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWbyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _iconButtonClasses = require("./iconButtonClasses");
var _iconButtonClassesDefault = parcelHelpers.interopDefault(_iconButtonClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, color, edge, size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, _capitalizeDefault.default)(color)}`,
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _iconButtonClasses.getIconButtonUtilityClass), classes);
};
const IconButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, _capitalizeDefault.default)(ownerState.edge)}`],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme, ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, _extendsDefault.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, _extendsDefault.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, _extendsDefault.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, _iconButtonClassesDefault.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const IconButton = /*#__PURE__*/ _react.forwardRef(function IconButton(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge = false, children, className, color = 'default', disabled = false, disableFocusRipple = false, size = 'medium' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        edge,
        color,
        disabled,
        disableFocusRipple,
        size
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconButtonRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
exports.default = IconButton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/chainPropTypes":"83tGg","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../ButtonBase":"ajcyv","../utils/capitalize":"hBZko","./iconButtonClasses":"bLPmg","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bLPmg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIconButtonUtilityClass", ()=>getIconButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getIconButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiIconButton', slot);
}
const iconButtonClasses = (0, _generateUtilityClassesDefault.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
exports.default = iconButtonClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2EejF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemDefault.default));
parcelHelpers.export(exports, "listItemClasses", ()=>(0, _listItemClassesDefault.default));
var _listItem = require("./ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemClasses = require("./listItemClasses");
var _listItemClassesDefault = parcelHelpers.interopDefault(_listItemClasses);
parcelHelpers.exportAll(_listItemClasses, exports);
'use client';

},{"./ListItem":"4Mboj","./listItemClasses":"btYc1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Mboj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "overridesResolver", ()=>overridesResolver);
parcelHelpers.export(exports, "ListItemRoot", ()=>ListItemRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _colorManipulator = require("@mui/system/colorManipulator");
var _isHostComponent = require("@mui/utils/isHostComponent");
var _isHostComponentDefault = parcelHelpers.interopDefault(_isHostComponent);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _isMuiElement = require("../utils/isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listItemClasses = require("./listItemClasses");
var _listItemClassesDefault = parcelHelpers.interopDefault(_listItemClasses);
var _listItemButton = require("../ListItemButton");
var _listItemSecondaryAction = require("../ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className"
], _excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { alignItems, button, classes, dense, disabled, disableGutters, disablePadding, divider, hasSecondaryAction, selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemClasses.getListItemUtilityClass), classes);
};
const ListItemRoot = (0, _styledDefault.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, _extendsDefault.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, _listItemButton.listItemButtonClasses).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, _listItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _listItemClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, _listItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, _listItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, _listItemClassesDefault.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const ListItemContainer = (0, _styledDefault.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const ListItem = /*#__PURE__*/ _react.forwardRef(function ListItem(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems = 'center', autoFocus = false, button = false, children: childrenProp, className, component: componentProp, components = {}, componentsProps = {}, ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense = false, disabled = false, disableGutters = false, disablePadding = false, divider = false, focusVisibleClassName, secondaryAction, selected = false, slotProps = {}, slots = {} } = props, ContainerProps = (0, _objectWithoutPropertiesLooseDefault.default)(props.ContainerProps, _excluded), other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const context = _react.useContext((0, _listContextDefault.default));
    const childContext = _react.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems,
            disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = _react.useRef(null);
    (0, _useEnhancedEffectDefault.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = _react.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, _isMuiElementDefault.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        alignItems,
        autoFocus,
        button,
        dense: childContext.dense,
        disabled,
        disableGutters,
        disablePadding,
        divider,
        hasSecondaryAction,
        selected
    });
    const classes = useUtilityClasses(ownerState);
    const handleRef = (0, _useForkRefDefault.default)(listItemRef, ref);
    const Root = slots.root || components.Root || ListItemRoot;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, rootProps.className, className),
        disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, _clsxDefault.default)((0, _listItemClassesDefault.default).focusVisible, focusVisibleClassName);
        Component = (0, _buttonBaseDefault.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ListItemContainer, (0, _extendsDefault.default)({
                as: ContainerComponent,
                className: (0, _clsxDefault.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extendsDefault.default)({}, rootProps, !(0, _isHostComponentDefault.default)(Root) && {
                        as: Component,
                        ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listContextDefault.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, (0, _extendsDefault.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, _isHostComponentDefault.default)(Root) && {
            ownerState: (0, _extendsDefault.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemSecondaryActionDefault.default), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
exports.default = ListItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/elementTypeAcceptingRef":"gpPr5","@mui/utils/chainPropTypes":"83tGg","@mui/system/colorManipulator":"dHYgR","@mui/utils/isHostComponent":"2X2lI","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../ButtonBase":"ajcyv","../utils/isMuiElement":"bgSQq","../utils/useEnhancedEffect":"hXusa","../utils/useForkRef":"cq8Sn","../List/ListContext":"lt3pu","./listItemClasses":"btYc1","../ListItemButton":"3RKQ6","../ListItemSecondaryAction":"fztfw","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"btYc1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemUtilityClass", ()=>getListItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiListItem', slot);
}
const listItemClasses = (0, _generateUtilityClassesDefault.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
exports.default = listItemClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RKQ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemButtonDefault.default));
parcelHelpers.export(exports, "listItemButtonClasses", ()=>(0, _listItemButtonClassesDefault.default));
var _listItemButton = require("./ListItemButton");
var _listItemButtonDefault = parcelHelpers.interopDefault(_listItemButton);
var _listItemButtonClasses = require("./listItemButtonClasses");
var _listItemButtonClassesDefault = parcelHelpers.interopDefault(_listItemButtonClasses);
parcelHelpers.exportAll(_listItemButtonClasses, exports);
'use client';

},{"./ListItemButton":false,"./listItemButtonClasses":"3VzXh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3VzXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemButtonUtilityClass", ()=>getListItemButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiListItemButton', slot);
}
const listItemButtonClasses = (0, _generateUtilityClassesDefault.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
exports.default = listItemButtonClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fztfw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _listItemSecondaryActionDefault.default));
parcelHelpers.export(exports, "listItemSecondaryActionClasses", ()=>(0, _listItemSecondaryActionClassesDefault.default));
var _listItemSecondaryAction = require("./ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
var _listItemSecondaryActionClasses = require("./listItemSecondaryActionClasses");
var _listItemSecondaryActionClassesDefault = parcelHelpers.interopDefault(_listItemSecondaryActionClasses);
parcelHelpers.exportAll(_listItemSecondaryActionClasses, exports);
'use client';

},{"./ListItemSecondaryAction":"hnDQ8","./listItemSecondaryActionClasses":"3z898","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnDQ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _listContext = require("../List/ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _listItemSecondaryActionClasses = require("./listItemSecondaryActionClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { disableGutters, classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _listItemSecondaryActionClasses.getListItemSecondaryActionClassesUtilityClass), classes);
};
const ListItemSecondaryActionRoot = (0, _styledDefault.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const ListItemSecondaryAction = /*#__PURE__*/ _react.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const context = _react.useContext((0, _listContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItemSecondaryActionRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
exports.default = ListItemSecondaryAction;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../List/ListContext":"lt3pu","./listItemSecondaryActionClasses":"3z898","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3z898":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getListItemSecondaryActionClassesUtilityClass", ()=>getListItemSecondaryActionClassesUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getListItemSecondaryActionClassesUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiListItemSecondaryAction', slot);
}
const listItemSecondaryActionClasses = (0, _generateUtilityClassesDefault.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
exports.default = listItemSecondaryActionClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Czu0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _themeProviderDefault.default));
var _themeProvider = require("@mui/private-theming/ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);

},{"@mui/private-theming/ThemeProvider":"llabg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnRpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _useMediaQueryDefault.default));
var _useMediaQuery = require("@mui/system/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);

},{"@mui/system/useMediaQuery":"k92j1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kemIW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formControlLabelDefault.default));
parcelHelpers.export(exports, "formControlLabelClasses", ()=>(0, _formControlLabelClassesDefault.default));
var _formControlLabel = require("./FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formControlLabelClasses = require("./formControlLabelClasses");
var _formControlLabelClassesDefault = parcelHelpers.interopDefault(_formControlLabelClasses);
parcelHelpers.exportAll(_formControlLabelClasses, exports);
'use client';

},{"./FormControlLabel":"rP829","./formControlLabelClasses":"aisBr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"rP829":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormControlLabelRoot", ()=>FormControlLabelRoot);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _formControl = require("../FormControl");
var _stack = require("../Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _formControlLabelClasses = require("./formControlLabelClasses");
var _formControlLabelClassesDefault = parcelHelpers.interopDefault(_formControlLabelClasses);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, disabled, labelPlacement, error, required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, _capitalizeDefault.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formControlLabelClasses.getFormControlLabelUtilityClasses), classes);
};
const FormControlLabelRoot = (0, _styledDefault.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _formControlLabelClassesDefault.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, _capitalizeDefault.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, _formControlLabelClassesDefault.default).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, _formControlLabelClassesDefault.default).label}`]: {
            [`&.${(0, _formControlLabelClassesDefault.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const AsteriskComponent = (0, _styledDefault.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme })=>({
        [`&.${(0, _formControlLabelClassesDefault.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const FormControlLabel = /*#__PURE__*/ _react.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className, componentsProps = {}, control, disabled: disabledProp, disableTypography, label: labelProp, labelPlacement = 'end', required: requiredProp, slotProps = {} } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _formControl.useFormControl)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled,
        required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        labelPlacement,
        required,
        error: fcs.error
    });
    const classes = useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, _typographyDefault.default) && !disableTypography) label = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, _clsxDefault.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(FormControlLabelRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ _react.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
exports.default = FormControlLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","../FormControl":"kkska","../Stack":"jY4TS","../Typography":"2wCD5","../utils/capitalize":"hBZko","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./formControlLabelClasses":"aisBr","../FormControl/formControlState":"lhkcI","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jY4TS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _stackDefault.default));
parcelHelpers.export(exports, "stackClasses", ()=>(0, _stackClassesDefault.default));
var _stack = require("./Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _stackClasses = require("./stackClasses");
var _stackClassesDefault = parcelHelpers.interopDefault(_stackClasses);
'use client';

},{"./Stack":"c8pMq","./stackClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8pMq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
'use client';
const Stack = (0, _system.createStack)({
    createStyledComponent: (0, _styledDefault.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, _defaultPropsProvider.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
exports.default = Stack;

},{"prop-types":"bnNSm","@mui/system":"5Hnj5","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aisBr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormControlLabelUtilityClasses", ()=>getFormControlLabelUtilityClasses);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormControlLabelUtilityClasses(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiFormControlLabel', slot);
}
const formControlLabelClasses = (0, _generateUtilityClassesDefault.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
exports.default = formControlLabelClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sdMA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _checkboxDefault.default));
parcelHelpers.export(exports, "checkboxClasses", ()=>(0, _checkboxClassesDefault.default));
var _checkbox = require("./Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _checkboxClasses = require("./checkboxClasses");
var _checkboxClassesDefault = parcelHelpers.interopDefault(_checkboxClasses);
parcelHelpers.exportAll(_checkboxClasses, exports);
'use client';

},{"./Checkbox":"gXR8Z","./checkboxClasses":"jjqCZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXR8Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _switchBase = require("../internal/SwitchBase");
var _switchBaseDefault = parcelHelpers.interopDefault(_switchBase);
var _checkBoxOutlineBlank = require("../internal/svg-icons/CheckBoxOutlineBlank");
var _checkBoxOutlineBlankDefault = parcelHelpers.interopDefault(_checkBoxOutlineBlank);
var _checkBox = require("../internal/svg-icons/CheckBox");
var _checkBoxDefault = parcelHelpers.interopDefault(_checkBox);
var _indeterminateCheckBox = require("../internal/svg-icons/IndeterminateCheckBox");
var _indeterminateCheckBoxDefault = parcelHelpers.interopDefault(_indeterminateCheckBox);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _checkboxClasses = require("./checkboxClasses");
var _checkboxClassesDefault = parcelHelpers.interopDefault(_checkboxClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, indeterminate, color, size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, _capitalizeDefault.default)(color)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _checkboxClasses.getCheckboxUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const CheckboxRoot = (0, _styledDefault.default)((0, _switchBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, _checkboxClassesDefault.default).checked}, &.${(0, _checkboxClassesDefault.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, _checkboxClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const defaultCheckedIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBoxDefault.default), {});
const defaultIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBoxOutlineBlankDefault.default), {});
const defaultIndeterminateIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indeterminateCheckBoxDefault.default), {});
const Checkbox = /*#__PURE__*/ _react.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon = defaultCheckedIcon, color = 'primary', icon: iconProp = defaultIcon, indeterminate = false, indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon, inputProps, size = 'medium', className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        indeterminate,
        size
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckboxRoot, (0, _extendsDefault.default)({
        type: "checkbox",
        inputProps: (0, _extendsDefault.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ _react.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ _react.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
exports.default = Checkbox;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../internal/SwitchBase":"8FNiy","../internal/svg-icons/CheckBoxOutlineBlank":"z2Uvb","../internal/svg-icons/CheckBox":"lUcjZ","../internal/svg-icons/IndeterminateCheckBox":"cOXTe","../utils/capitalize":"hBZko","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./checkboxClasses":"jjqCZ","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8FNiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _switchBaseClasses = require("./switchBaseClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, checked, disabled, edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, _capitalizeDefault.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _switchBaseClasses.getSwitchBaseUtilityClass), classes);
};
const SwitchBaseRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default))(({ ownerState })=>(0, _extendsDefault.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const SwitchBaseInput = (0, _styledDefault.default)('input', {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const SwitchBase = /*#__PURE__*/ _react.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus, checked: checkedProp, checkedIcon, className, defaultChecked, disabled: disabledProp, disableFocusRipple = false, edge = false, icon, id, inputProps, inputRef, name, onBlur, onChange, onFocus, readOnly, required = false, tabIndex, type, value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [checked, setCheckedState] = (0, _useControlledDefault.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, _useFormControlDefault.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, _extendsDefault.default)({}, props, {
        checked,
        disabled,
        disableFocusRipple,
        edge
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(SwitchBaseRoot, (0, _extendsDefault.default)({
        component: "span",
        className: (0, _clsxDefault.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchBaseInput, (0, _extendsDefault.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
exports.default = SwitchBase;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","../utils/capitalize":"hBZko","../styles/styled":"bTnxF","../utils/useControlled":"1VreF","../FormControl/useFormControl":"H1I5Z","../ButtonBase":"ajcyv","./switchBaseClasses":"iWb69","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWb69":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSwitchBaseUtilityClass", ()=>getSwitchBaseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSwitchBaseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('PrivateSwitchBase', slot);
}
const switchBaseClasses = (0, _generateUtilityClassesDefault.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
exports.default = switchBaseClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"z2Uvb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUcjZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cOXTe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jjqCZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCheckboxUtilityClass", ()=>getCheckboxUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCheckboxUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiCheckbox', slot);
}
const checkboxClasses = (0, _generateUtilityClassesDefault.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
exports.default = checkboxClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"if4Vw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableDefault.default));
parcelHelpers.export(exports, "tableClasses", ()=>(0, _tableClassesDefault.default));
var _table = require("./Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableClasses = require("./tableClasses");
var _tableClassesDefault = parcelHelpers.interopDefault(_tableClasses);
parcelHelpers.exportAll(_tableClasses, exports);
'use client';

},{"./Table":"lkNtz","./tableClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lkNtz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _tableContext = require("./TableContext");
var _tableContextDefault = parcelHelpers.interopDefault(_tableContext);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableClasses = require("./tableClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableClasses.getTableUtilityClass), classes);
};
const TableRoot = (0, _styledDefault.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, _extendsDefault.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const defaultComponent = 'table';
const Table = /*#__PURE__*/ _react.forwardRef(function Table(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className, component = defaultComponent, padding = 'normal', size = 'medium', stickyHeader = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        padding,
        size,
        stickyHeader
    });
    const classes = useUtilityClasses(ownerState);
    const table = _react.useMemo(()=>({
            padding,
            size,
            stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContextDefault.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableRoot, (0, _extendsDefault.default)({
            as: component,
            role: component === defaultComponent ? null : 'table',
            ref: ref,
            className: (0, _clsxDefault.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
exports.default = Table;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","./TableContext":"auxdF","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./tableClasses":"hZlbo","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"auxdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
/**
 * @ignore - internal component.
 */ const TableContext = /*#__PURE__*/ _react.createContext();
exports.default = TableContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZlbo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableUtilityClass", ()=>getTableUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTable', slot);
}
const tableClasses = (0, _generateUtilityClassesDefault.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
exports.default = tableClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPEEy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableBodyDefault.default));
parcelHelpers.export(exports, "tableBodyClasses", ()=>(0, _tableBodyClassesDefault.default));
var _tableBody = require("./TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableBodyClasses = require("./tableBodyClasses");
var _tableBodyClassesDefault = parcelHelpers.interopDefault(_tableBodyClasses);
parcelHelpers.exportAll(_tableBodyClasses, exports);
'use client';

},{"./TableBody":"kDDsj","./tableBodyClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kDDsj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableBodyClasses = require("./tableBodyClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableBodyClasses.getTableBodyUtilityClass), classes);
};
const TableBodyRoot = (0, _styledDefault.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const tablelvl2 = {
    variant: 'body'
};
const defaultComponent = 'tbody';
const TableBody = /*#__PURE__*/ _react.forwardRef(function TableBody(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className, component = defaultComponent } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tablelvl2ContextDefault.default).Provider, {
        value: tablelvl2,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableBodyRoot, (0, _extendsDefault.default)({
            className: (0, _clsxDefault.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
exports.default = TableBody;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../Table/Tablelvl2Context":"4kOJV","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./tableBodyClasses":"fHMff","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kOJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const Tablelvl2Context = /*#__PURE__*/ _react.createContext();
exports.default = Tablelvl2Context;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHMff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableBodyUtilityClass", ()=>getTableBodyUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableBodyUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTableBody', slot);
}
const tableBodyClasses = (0, _generateUtilityClassesDefault.default)('MuiTableBody', [
    'root'
]);
exports.default = tableBodyClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Htaw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableCellDefault.default));
parcelHelpers.export(exports, "tableCellClasses", ()=>(0, _tableCellClassesDefault.default));
var _tableCell = require("./TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableCellClasses = require("./tableCellClasses");
var _tableCellClassesDefault = parcelHelpers.interopDefault(_tableCellClasses);
parcelHelpers.exportAll(_tableCellClasses, exports);
'use client';

},{"./TableCell":"i0OC9","./tableCellClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0OC9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _tableContext = require("../Table/TableContext");
var _tableContextDefault = parcelHelpers.interopDefault(_tableContext);
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableCellClasses = require("./tableCellClasses");
var _tableCellClassesDefault = parcelHelpers.interopDefault(_tableCellClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, align, padding, size, stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, _capitalizeDefault.default)(align)}`,
            padding !== 'normal' && `padding${(0, _capitalizeDefault.default)(padding)}`,
            `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableCellClasses.getTableCellUtilityClass), classes);
};
const TableCellRoot = (0, _styledDefault.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, _capitalizeDefault.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, _capitalizeDefault.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.alpha)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, _tableCellClassesDefault.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const TableCell = /*#__PURE__*/ _react.forwardRef(function TableCell(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align = 'inherit', className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection, variant: variantProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const table = _react.useContext((0, _tableContextDefault.default));
    const tablelvl2 = _react.useContext((0, _tablelvl2ContextDefault.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        align,
        component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCellRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
exports.default = TableCell;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../utils/capitalize":"hBZko","../Table/TableContext":"auxdF","../Table/Tablelvl2Context":"4kOJV","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./tableCellClasses":"9JcTw","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9JcTw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableCellUtilityClass", ()=>getTableCellUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableCellUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTableCell', slot);
}
const tableCellClasses = (0, _generateUtilityClassesDefault.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
exports.default = tableCellClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Kmn7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableContainerDefault.default));
parcelHelpers.export(exports, "tableContainerClasses", ()=>(0, _tableContainerClassesDefault.default));
var _tableContainer = require("./TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableContainerClasses = require("./tableContainerClasses");
var _tableContainerClassesDefault = parcelHelpers.interopDefault(_tableContainerClasses);
parcelHelpers.exportAll(_tableContainerClasses, exports);
'use client';

},{"./TableContainer":"9xqyt","./tableContainerClasses":"dt2D7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9xqyt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableContainerClasses = require("./tableContainerClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableContainerClasses.getTableContainerUtilityClass), classes);
};
const TableContainerRoot = (0, _styledDefault.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const TableContainer = /*#__PURE__*/ _react.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className, component = 'div' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableContainerRoot, (0, _extendsDefault.default)({
        ref: ref,
        as: component,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
exports.default = TableContainer;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./tableContainerClasses":"dt2D7","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dt2D7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableContainerUtilityClass", ()=>getTableContainerUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableContainerUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTableContainer', slot);
}
const tableContainerClasses = (0, _generateUtilityClassesDefault.default)('MuiTableContainer', [
    'root'
]);
exports.default = tableContainerClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"inilD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableHeadDefault.default));
parcelHelpers.export(exports, "tableHeadClasses", ()=>(0, _tableHeadClassesDefault.default));
var _tableHead = require("./TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableHeadClasses = require("./tableHeadClasses");
var _tableHeadClassesDefault = parcelHelpers.interopDefault(_tableHeadClasses);
parcelHelpers.exportAll(_tableHeadClasses, exports);
'use client';

},{"./TableHead":"e95Ue","./tableHeadClasses":"eFcxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e95Ue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableHeadClasses = require("./tableHeadClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableHeadClasses.getTableHeadUtilityClass), classes);
};
const TableHeadRoot = (0, _styledDefault.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const tablelvl2 = {
    variant: 'head'
};
const defaultComponent = 'thead';
const TableHead = /*#__PURE__*/ _react.forwardRef(function TableHead(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className, component = defaultComponent } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tablelvl2ContextDefault.default).Provider, {
        value: tablelvl2,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableHeadRoot, (0, _extendsDefault.default)({
            as: component,
            className: (0, _clsxDefault.default)(classes.root, className),
            ref: ref,
            role: component === defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
exports.default = TableHead;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../Table/Tablelvl2Context":"4kOJV","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./tableHeadClasses":"eFcxf","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFcxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableHeadUtilityClass", ()=>getTableHeadUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableHeadUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTableHead', slot);
}
const tableHeadClasses = (0, _generateUtilityClassesDefault.default)('MuiTableHead', [
    'root'
]);
exports.default = tableHeadClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4f4VX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableRowDefault.default));
parcelHelpers.export(exports, "tableRowClasses", ()=>(0, _tableRowClassesDefault.default));
var _tableRow = require("./TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableRowClasses = require("./tableRowClasses");
var _tableRowClassesDefault = parcelHelpers.interopDefault(_tableRowClasses);
parcelHelpers.exportAll(_tableRowClasses, exports);
'use client';

},{"./TableRow":"6PUbI","./tableRowClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6PUbI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _tablelvl2Context = require("../Table/Tablelvl2Context");
var _tablelvl2ContextDefault = parcelHelpers.interopDefault(_tablelvl2Context);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tableRowClasses = require("./tableRowClasses");
var _tableRowClassesDefault = parcelHelpers.interopDefault(_tableRowClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, selected, hover, head, footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableRowClasses.getTableRowUtilityClass), classes);
};
const TableRowRoot = (0, _styledDefault.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, _tableRowClassesDefault.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, _tableRowClassesDefault.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const TableRow = /*#__PURE__*/ _react.forwardRef(function TableRow(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className, component = defaultComponent, hover = false, selected = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const tablelvl2 = _react.useContext((0, _tablelvl2ContextDefault.default));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        hover,
        selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableRowRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        role: component === defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
exports.default = TableRow;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../Table/Tablelvl2Context":"4kOJV","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./tableRowClasses":"jii26","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jii26":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableRowUtilityClass", ()=>getTableRowUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableRowUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTableRow', slot);
}
const tableRowClasses = (0, _generateUtilityClassesDefault.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
exports.default = tableRowClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xCAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tableSortLabelDefault.default));
parcelHelpers.export(exports, "tableSortLabelClasses", ()=>(0, _tableSortLabelClassesDefault.default));
var _tableSortLabel = require("./TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
var _tableSortLabelClasses = require("./tableSortLabelClasses");
var _tableSortLabelClassesDefault = parcelHelpers.interopDefault(_tableSortLabelClasses);
parcelHelpers.exportAll(_tableSortLabelClasses, exports);
'use client';

},{"./TableSortLabel":"4h4sa","./tableSortLabelClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4h4sa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _arrowDownward = require("../internal/svg-icons/ArrowDownward");
var _arrowDownwardDefault = parcelHelpers.interopDefault(_arrowDownward);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _tableSortLabelClasses = require("./tableSortLabelClasses");
var _tableSortLabelClassesDefault = parcelHelpers.interopDefault(_tableSortLabelClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, direction, active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active'
        ],
        icon: [
            'icon',
            `iconDirection${(0, _capitalizeDefault.default)(direction)}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tableSortLabelClasses.getTableSortLabelUtilityClass), classes);
};
const TableSortLabelRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, _tableSortLabelClassesDefault.default).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, _tableSortLabelClassesDefault.default).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, _tableSortLabelClassesDefault.default).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const TableSortLabelIcon = (0, _styledDefault.default)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, _capitalizeDefault.default)(ownerState.direction)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none'
    }, ownerState.direction === 'desc' && {
        transform: 'rotate(0deg)'
    }, ownerState.direction === 'asc' && {
        transform: 'rotate(180deg)'
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const TableSortLabel = /*#__PURE__*/ _react.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active = false, children, className, direction = 'asc', hideSortIcon = false, IconComponent = (0, _arrowDownwardDefault.default) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        active,
        direction,
        hideSortIcon,
        IconComponent
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TableSortLabelRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableSortLabelIcon, {
                as: IconComponent,
                className: (0, _clsxDefault.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
exports.default = TableSortLabel;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","@mui/utils/composeClasses":"43D21","clsx":"bK0Bf","prop-types":"bnNSm","react":"9njXz","../ButtonBase":"ajcyv","../internal/svg-icons/ArrowDownward":"jqmaz","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../utils/capitalize":"hBZko","./tableSortLabelClasses":"i5rnE","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jqmaz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5rnE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTableSortLabelUtilityClass", ()=>getTableSortLabelUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTableSortLabelUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTableSortLabel', slot);
}
const tableSortLabelClasses = (0, _generateUtilityClassesDefault.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc'
]);
exports.default = tableSortLabelClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g7Izf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tabsDefault.default));
parcelHelpers.export(exports, "tabsClasses", ()=>(0, _tabsClassesDefault.default));
var _tabs = require("./Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tabsClasses = require("./tabsClasses");
var _tabsClassesDefault = parcelHelpers.interopDefault(_tabsClasses);
parcelHelpers.exportAll(_tabsClasses, exports);
'use client';

},{"./Tabs":"91Lez","./tabsClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"91Lez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _rtlProvider = require("@mui/system/RtlProvider");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _scrollLeft = require("../utils/scrollLeft");
var _animate = require("../internal/animate");
var _animateDefault = parcelHelpers.interopDefault(_animate);
var _scrollbarSize = require("./ScrollbarSize");
var _scrollbarSizeDefault = parcelHelpers.interopDefault(_scrollbarSize);
var _tabScrollButton = require("../TabScrollButton");
var _tabScrollButtonDefault = parcelHelpers.interopDefault(_tabScrollButton);
var _useEventCallback = require("../utils/useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _tabsClasses = require("./tabsClasses");
var _tabsClassesDefault = parcelHelpers.interopDefault(_tabsClasses);
var _ownerDocument = require("../utils/ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("../utils/ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const useUtilityClasses = (ownerState)=>{
    const { vertical, fixed, hideScrollbar, scrollableX, scrollableY, centered, scrollButtonsHideMobile, classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tabsClasses.getTabsUtilityClass), classes);
};
const TabsRoot = (0, _styledDefault.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _tabsClassesDefault.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, _tabsClassesDefault.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, _tabsClassesDefault.default).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const TabsScroller = (0, _styledDefault.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const FlexContainer = (0, _styledDefault.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const TabsIndicator = (0, _styledDefault.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const TabsScrollbarSize = (0, _styledDefault.default)((0, _scrollbarSizeDefault.default))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const defaultIndicatorStyle = {};
let warnedOnceTabPresent = false;
const Tabs = /*#__PURE__*/ _react.forwardRef(function Tabs(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, _useThemeDefault.default)();
    const isRtl = (0, _rtlProvider.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action, centered = false, children: childrenProp, className, component = 'div', allowScrollButtonsMobile = false, indicatorColor = 'primary', onChange, orientation = 'horizontal', ScrollButtonComponent = (0, _tabScrollButtonDefault.default), scrollButtons = 'auto', selectionFollowsFocus, slots = {}, slotProps = {}, TabIndicatorProps = {}, TabScrollButtonProps = {}, textColor = 'primary', value, variant = 'standard', visibleScrollbar = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        allowScrollButtonsMobile,
        indicatorColor,
        orientation,
        vertical,
        scrollButtons,
        textColor,
        variant,
        visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, _useSlotPropsDefault.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState
    });
    const endScrollButtonIconProps = (0, _useSlotPropsDefault.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState
    });
    const [mounted, setMounted] = _react.useState(false);
    const [indicatorStyle, setIndicatorStyle] = _react.useState(defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = _react.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = _react.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = _react.useState(false);
    const [scrollerStyle, setScrollerStyle] = _react.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = _react.useRef(null);
    const tabListRef = _react.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, _scrollLeft.getNormalizedScrollLeft)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta,
            tabMeta
        };
    };
    const updateIndicatorState = (0, _useEventCallbackDefault.default)(()=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation = true } = {})=>{
        if (animation) (0, _animateDefault.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, _scrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = _react.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, _clsxDefault.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonComponent, (0, _extendsDefault.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, _clsxDefault.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScrollButtonComponent, (0, _extendsDefault.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, _clsxDefault.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, _useEventCallbackDefault.default)((animation)=>{
        const { tabsMeta, tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation
            });
        }
    });
    const updateScrollButtonState = (0, _useEventCallbackDefault.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    _react.useEffect(()=>{
        const handleResize = (0, _debounceDefault.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, _ownerWindowDefault.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ _react.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    _react.useEffect(()=>{
        setMounted(true);
    }, []);
    _react.useEffect(()=>{
        updateIndicatorState();
    });
    _react.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView(defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    _react.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabsIndicator, (0, _extendsDefault.default)({}, TabIndicatorProps, {
        className: (0, _clsxDefault.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, _extendsDefault.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = _react.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ _react.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ _react.cloneElement(child, (0, _extendsDefault.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected,
            selectionFollowsFocus,
            onChange,
            textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, _ownerDocumentDefault.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                moveFocus(list, currentFocus, nextItem);
                break;
            case 'Home':
                event.preventDefault();
                moveFocus(list, null, nextItem);
                break;
            case 'End':
                event.preventDefault();
                moveFocus(list, null, previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabsRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
exports.default = Tabs;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","react-is":"8oKlE","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","@mui/system/RtlProvider":"aMQRu","@mui/utils/useSlotProps":"kv8TD","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../styles/useTheme":"d8hfc","../utils/debounce":"cvBWT","../utils/scrollLeft":"8IjVZ","../internal/animate":"7Sg0D","./ScrollbarSize":"iW43j","../TabScrollButton":"kialp","../utils/useEventCallback":"jTtn3","./tabsClasses":"W2KpW","../utils/ownerDocument":"7Yspg","../utils/ownerWindow":"4Wjh2","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8IjVZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detectScrollType", ()=>(0, _utils.unstable_detectScrollType));
parcelHelpers.export(exports, "getNormalizedScrollLeft", ()=>(0, _utils.unstable_getNormalizedScrollLeft));
var _utils = require("@mui/utils");

},{"@mui/utils":"lfcNH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Sg0D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>animate);
function easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to, options = {}, cb = ()=>{}) {
    const { ease = easeInOutSin, duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iW43j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScrollbarSize);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _debounce = require("../utils/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "onChange"
];
const styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function ScrollbarSize(props) {
    const { onChange } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const scrollbarHeight = _react.useRef();
    const nodeRef = _react.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, _utils.unstable_useEnhancedEffect)(()=>{
        const handleResize = (0, _debounceDefault.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, _utils.ownerWindow)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    _react.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", (0, _extendsDefault.default)({
        style: styles
    }, other, {
        ref: nodeRef
    }));
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","../utils/debounce":"cvBWT","../utils":"60iOt","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"60iOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "capitalize", ()=>(0, _capitalizeDefault.default));
parcelHelpers.export(exports, "createChainedFunction", ()=>(0, _createChainedFunctionDefault.default));
parcelHelpers.export(exports, "createSvgIcon", ()=>(0, _createSvgIconDefault.default));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounceDefault.default));
parcelHelpers.export(exports, "deprecatedPropType", ()=>(0, _deprecatedPropTypeDefault.default));
parcelHelpers.export(exports, "isMuiElement", ()=>(0, _isMuiElementDefault.default));
parcelHelpers.export(exports, "ownerDocument", ()=>(0, _ownerDocumentDefault.default));
parcelHelpers.export(exports, "ownerWindow", ()=>(0, _ownerWindowDefault.default));
parcelHelpers.export(exports, "requirePropFactory", ()=>(0, _requirePropFactoryDefault.default));
parcelHelpers.export(exports, "setRef", ()=>(0, _setRefDefault.default));
parcelHelpers.export(exports, "unstable_useEnhancedEffect", ()=>(0, _useEnhancedEffectDefault.default));
parcelHelpers.export(exports, "unstable_useId", ()=>(0, _useIdDefault.default));
parcelHelpers.export(exports, "unsupportedProp", ()=>(0, _unsupportedPropDefault.default));
parcelHelpers.export(exports, "useControlled", ()=>(0, _useControlledDefault.default));
parcelHelpers.export(exports, "useEventCallback", ()=>(0, _useEventCallbackDefault.default));
parcelHelpers.export(exports, "useForkRef", ()=>(0, _useForkRefDefault.default));
parcelHelpers.export(exports, "useIsFocusVisible", ()=>(0, _useIsFocusVisibleDefault.default));
parcelHelpers.export(exports, "unstable_ClassNameGenerator", ()=>unstable_ClassNameGenerator);
var _utils = require("@mui/utils");
var _capitalize = require("./capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("./createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _createSvgIcon = require("./createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
var _debounce = require("./debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
var _deprecatedPropType = require("./deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
var _isMuiElement = require("./isMuiElement");
var _isMuiElementDefault = parcelHelpers.interopDefault(_isMuiElement);
var _ownerDocument = require("./ownerDocument");
var _ownerDocumentDefault = parcelHelpers.interopDefault(_ownerDocument);
var _ownerWindow = require("./ownerWindow");
var _ownerWindowDefault = parcelHelpers.interopDefault(_ownerWindow);
var _requirePropFactory = require("./requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _setRef = require("./setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
var _useEnhancedEffect = require("./useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useId = require("./useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _unsupportedProp = require("./unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _useControlled = require("./useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useEventCallback = require("./useEventCallback");
var _useEventCallbackDefault = parcelHelpers.interopDefault(_useEventCallback);
var _useForkRef = require("./useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useIsFocusVisible = require("./useIsFocusVisible");
var _useIsFocusVisibleDefault = parcelHelpers.interopDefault(_useIsFocusVisible);
'use client';
const unstable_ClassNameGenerator = {
    configure: (generator)=>{
        (0, _utils.unstable_ClassNameGenerator).configure(generator);
    }
};

},{"@mui/utils":"lfcNH","./capitalize":"hBZko","./createChainedFunction":"8CRq6","./createSvgIcon":"k1uMV","./debounce":"cvBWT","./deprecatedPropType":"3n9Eo","./isMuiElement":"bgSQq","./ownerDocument":"7Yspg","./ownerWindow":"4Wjh2","./requirePropFactory":"g4unq","./setRef":"hWYln","./useEnhancedEffect":"hXusa","./useId":"iMSy2","./unsupportedProp":"lTxN8","./useControlled":"1VreF","./useEventCallback":"jTtn3","./useForkRef":"cq8Sn","./useIsFocusVisible":"fK0On","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8CRq6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createChainedFunction = require("@mui/utils/createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
exports.default = (0, _createChainedFunctionDefault.default);

},{"@mui/utils/createChainedFunction":"1ZqU8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3n9Eo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _deprecatedPropType = require("@mui/utils/deprecatedPropType");
var _deprecatedPropTypeDefault = parcelHelpers.interopDefault(_deprecatedPropType);
exports.default = (0, _deprecatedPropTypeDefault.default);

},{"@mui/utils/deprecatedPropType":"fopsQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4unq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _requirePropFactory = require("@mui/utils/requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
exports.default = (0, _requirePropFactoryDefault.default);

},{"@mui/utils/requirePropFactory":"hLsmf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hWYln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setRef = require("@mui/utils/setRef");
var _setRefDefault = parcelHelpers.interopDefault(_setRef);
exports.default = (0, _setRefDefault.default);

},{"@mui/utils/setRef":"fgdh8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kialp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tabScrollButtonDefault.default));
parcelHelpers.export(exports, "tabScrollButtonClasses", ()=>(0, _tabScrollButtonClassesDefault.default));
var _tabScrollButton = require("./TabScrollButton");
var _tabScrollButtonDefault = parcelHelpers.interopDefault(_tabScrollButton);
var _tabScrollButtonClasses = require("./tabScrollButtonClasses");
var _tabScrollButtonClassesDefault = parcelHelpers.interopDefault(_tabScrollButtonClasses);
parcelHelpers.exportAll(_tabScrollButtonClasses, exports);
'use client';

},{"./TabScrollButton":"2fZuG","./tabScrollButtonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2fZuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable jsx-a11y/aria-role */ var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _rtlProvider = require("@mui/system/RtlProvider");
var _useSlotProps = require("@mui/utils/useSlotProps");
var _useSlotPropsDefault = parcelHelpers.interopDefault(_useSlotProps);
var _keyboardArrowLeft = require("../internal/svg-icons/KeyboardArrowLeft");
var _keyboardArrowLeftDefault = parcelHelpers.interopDefault(_keyboardArrowLeft);
var _keyboardArrowRight = require("../internal/svg-icons/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _tabScrollButtonClasses = require("./tabScrollButtonClasses");
var _tabScrollButtonClassesDefault = parcelHelpers.interopDefault(_tabScrollButtonClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, orientation, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tabScrollButtonClasses.getTabScrollButtonUtilityClass), classes);
};
const TabScrollButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, _tabScrollButtonClassesDefault.default).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const TabScrollButton = /*#__PURE__*/ _react.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className, slots = {}, slotProps = {}, direction } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const isRtl = (0, _rtlProvider.useRtl)();
    const ownerState = (0, _extendsDefault.default)({
        isRtl
    }, props);
    const classes = useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, _keyboardArrowLeftDefault.default);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, _keyboardArrowRightDefault.default);
    const startButtonIconProps = (0, _useSlotPropsDefault.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    const endButtonIconProps = (0, _useSlotPropsDefault.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TabScrollButtonRoot, (0, _extendsDefault.default)({
        component: "div",
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StartButtonIcon, (0, _extendsDefault.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(EndButtonIcon, (0, _extendsDefault.default)({}, endButtonIconProps))
    }));
});
exports.default = TabScrollButton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/RtlProvider":"aMQRu","@mui/utils/useSlotProps":"kv8TD","../internal/svg-icons/KeyboardArrowLeft":"g1fhR","../internal/svg-icons/KeyboardArrowRight":"5QNCT","../ButtonBase":"ajcyv","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./tabScrollButtonClasses":"g9GGO","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g1fhR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5QNCT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g9GGO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabScrollButtonUtilityClass", ()=>getTabScrollButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTabScrollButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTabScrollButton', slot);
}
const tabScrollButtonClasses = (0, _generateUtilityClassesDefault.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
exports.default = tabScrollButtonClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"W2KpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabsUtilityClass", ()=>getTabsUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTabsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTabs', slot);
}
const tabsClasses = (0, _generateUtilityClassesDefault.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
exports.default = tabsClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bmkB3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _tabDefault.default));
parcelHelpers.export(exports, "tabClasses", ()=>(0, _tabClassesDefault.default));
var _tab = require("./Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _tabClasses = require("./tabClasses");
var _tabClassesDefault = parcelHelpers.interopDefault(_tabClasses);
parcelHelpers.exportAll(_tabClasses, exports);
'use client';

},{"./Tab":"5g0Pq","./tabClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5g0Pq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _unsupportedProp = require("../utils/unsupportedProp");
var _unsupportedPropDefault = parcelHelpers.interopDefault(_unsupportedProp);
var _tabClasses = require("./tabClasses");
var _tabClassesDefault = parcelHelpers.interopDefault(_tabClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, textColor, fullWidth, wrapped, icon, label, selected, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, _capitalizeDefault.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _tabClasses.getTabUtilityClass), classes);
};
const TabRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, _capitalizeDefault.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, _tabClassesDefault.default).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, _tabClassesDefault.default).iconWrapper}`]: (0, _extendsDefault.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, _tabClassesDefault.default).selected}`]: {
            opacity: 1
        },
        [`&.${(0, _tabClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, _tabClassesDefault.default).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, _tabClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, _tabClassesDefault.default).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, _tabClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const Tab = /*#__PURE__*/ _react.forwardRef(function Tab(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className, disabled = false, disableFocusRipple = false, // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition = 'top', // eslint-disable-next-line react/prop-types
    indicator, label, onChange, onClick, onFocus, // eslint-disable-next-line react/prop-types
    selected, // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value, wrapped = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        disableFocusRipple,
        selected,
        icon: !!iconProp,
        iconPosition,
        label: !!label,
        fullWidth,
        textColor,
        wrapped
    });
    const classes = useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ _react.isValidElement(iconProp) ? /*#__PURE__*/ _react.cloneElement(iconProp, {
        className: (0, _clsxDefault.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabRoot, (0, _extendsDefault.default)({
        focusRipple: !disableFocusRipple,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
exports.default = Tab;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../ButtonBase":"ajcyv","../utils/capitalize":"hBZko","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","../utils/unsupportedProp":"lTxN8","./tabClasses":"1Tlfp","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Tlfp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTabUtilityClass", ()=>getTabUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getTabUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiTab', slot);
}
const tabClasses = (0, _generateUtilityClassesDefault.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
exports.default = tabClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bK4ky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _circularProgressDefault.default));
parcelHelpers.export(exports, "circularProgressClasses", ()=>(0, _circularProgressClassesDefault.default));
var _circularProgress = require("./CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _circularProgressClasses = require("./circularProgressClasses");
var _circularProgressClassesDefault = parcelHelpers.interopDefault(_circularProgressClasses);
parcelHelpers.exportAll(_circularProgressClasses, exports);
'use client';

},{"./CircularProgress":"fseyv","./circularProgressClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fseyv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _system = require("@mui/system");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _circularProgressClasses = require("./circularProgressClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let _ = (t)=>t, _t, _t2, _t3, _t4;
const SIZE = 44;
const circularRotateKeyframe = (0, _system.keyframes)(_t || (_t = _`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color, disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, _capitalizeDefault.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, _capitalizeDefault.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _circularProgressClasses.getCircularProgressUtilityClass), classes);
};
const CircularProgressRoot = (0, _styledDefault.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState })=>ownerState.variant === 'indeterminate' && (0, _system.css)(_t3 || (_t3 = _`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = (0, _styledDefault.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const CircularProgressCircle = (0, _styledDefault.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, _capitalizeDefault.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, _system.css)(_t4 || (_t4 = _`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const CircularProgress = /*#__PURE__*/ _react.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className, color = 'primary', disableShrink = false, size = 40, style, thickness = 3.6, value = 0, variant = 'indeterminate' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        disableShrink,
        size,
        thickness,
        value,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        style: (0, _extendsDefault.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: SIZE,
                cy: SIZE,
                r: (SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
exports.default = CircularProgress;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/chainPropTypes":"83tGg","@mui/utils/composeClasses":"43D21","@mui/system":"5Hnj5","../utils/capitalize":"hBZko","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./circularProgressClasses":"6HS9Q","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HS9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCircularProgressUtilityClass", ()=>getCircularProgressUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCircularProgressUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiCircularProgress', slot);
}
const circularProgressClasses = (0, _generateUtilityClassesDefault.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
exports.default = circularProgressClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65CNe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _toggleButtonDefault.default));
parcelHelpers.export(exports, "toggleButtonClasses", ()=>(0, _toggleButtonClassesDefault.default));
var _toggleButton = require("./ToggleButton");
var _toggleButtonDefault = parcelHelpers.interopDefault(_toggleButton);
var _toggleButtonClasses = require("./toggleButtonClasses");
var _toggleButtonClassesDefault = parcelHelpers.interopDefault(_toggleButtonClasses);
parcelHelpers.exportAll(_toggleButtonClasses, exports);
'use client';

},{"./ToggleButton":"aifzH","./toggleButtonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aifzH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @inheritedComponent ButtonBase
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _resolveProps = require("@mui/utils/resolveProps");
var _resolvePropsDefault = parcelHelpers.interopDefault(_resolveProps);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styles = require("../styles");
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _toggleButtonClasses = require("./toggleButtonClasses");
var _toggleButtonClassesDefault = parcelHelpers.interopDefault(_toggleButtonClasses);
var _toggleButtonGroupContext = require("../ToggleButtonGroup/ToggleButtonGroupContext");
var _toggleButtonGroupContextDefault = parcelHelpers.interopDefault(_toggleButtonGroupContext);
var _toggleButtonGroupButtonContext = require("../ToggleButtonGroup/ToggleButtonGroupButtonContext");
var _toggleButtonGroupButtonContextDefault = parcelHelpers.interopDefault(_toggleButtonGroupButtonContext);
var _isValueSelected = require("../ToggleButtonGroup/isValueSelected");
var _isValueSelectedDefault = parcelHelpers.interopDefault(_isValueSelected);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "value"
], _excluded2 = [
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "onChange",
    "onClick",
    "selected",
    "size",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, fullWidth, selected, disabled, size, color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, _capitalizeDefault.default)(size)}`,
            color
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _toggleButtonClasses.getToggleButtonUtilityClass), classes);
};
const ToggleButtonRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`]
        ];
    }
})(({ theme, ownerState })=>{
    let selectedColor = ownerState.color === 'standard' ? theme.palette.text.primary : theme.palette[ownerState.color].main;
    let selectedColorChannel;
    if (theme.vars) {
        selectedColor = ownerState.color === 'standard' ? theme.vars.palette.text.primary : theme.vars.palette[ownerState.color].main;
        selectedColorChannel = ownerState.color === 'standard' ? theme.vars.palette.text.primaryChannel : theme.vars.palette[ownerState.color].mainChannel;
    }
    return (0, _extendsDefault.default)({}, theme.typography.button, {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`&.${(0, _toggleButtonClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, _toggleButtonClassesDefault.default).selected}`]: {
            color: selectedColor,
            backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _styles.alpha)(selectedColor, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _styles.alpha)(selectedColor, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.vars ? `rgba(${selectedColorChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, _styles.alpha)(selectedColor, theme.palette.action.selectedOpacity)
                }
            }
        }
    }, ownerState.size === 'small' && {
        padding: 7,
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && {
        padding: 15,
        fontSize: theme.typography.pxToRem(15)
    });
});
const ToggleButton = /*#__PURE__*/ _react.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const _React$useContext = _react.useContext((0, _toggleButtonGroupContextDefault.default)), { value: contextValue } = _React$useContext, contextProps = (0, _objectWithoutPropertiesLooseDefault.default)(_React$useContext, _excluded);
    const toggleButtonGroupButtonContextPositionClassName = _react.useContext((0, _toggleButtonGroupButtonContextDefault.default));
    const resolvedProps = (0, _resolvePropsDefault.default)((0, _extendsDefault.default)({}, contextProps, {
        selected: (0, _isValueSelectedDefault.default)(inProps.value, contextValue)
    }), inProps);
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children, className, color = 'standard', disabled = false, disableFocusRipple = false, fullWidth = false, onChange, onClick, selected, size = 'medium', value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        disabled,
        disableFocusRipple,
        fullWidth,
        size
    });
    const classes = useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToggleButtonRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected
    }, other, {
        children: children
    }));
});
exports.default = ToggleButton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/resolveProps":"gemxd","@mui/utils/composeClasses":"43D21","../styles":"c9RfU","../ButtonBase":"ajcyv","../utils/capitalize":"hBZko","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./toggleButtonClasses":"1Sduf","../ToggleButtonGroup/ToggleButtonGroupContext":"e9atr","../ToggleButtonGroup/ToggleButtonGroupButtonContext":"8TGet","../ToggleButtonGroup/isValueSelected":"6AWHX","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Sduf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getToggleButtonUtilityClass", ()=>getToggleButtonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getToggleButtonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiToggleButton', slot);
}
const toggleButtonClasses = (0, _generateUtilityClassesDefault.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
exports.default = toggleButtonClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9atr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ToggleButtonGroupContext = /*#__PURE__*/ _react.createContext({});
exports.default = ToggleButtonGroupContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TGet":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const ToggleButtonGroupButtonContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = ToggleButtonGroupButtonContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6AWHX":[function(require,module,exports,__globalThis) {
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isValueSelected);
function isValueSelected(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.indexOf(value) >= 0;
    return value === candidate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hVYCj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _toggleButtonGroupDefault.default));
parcelHelpers.export(exports, "toggleButtonGroupClasses", ()=>(0, _toggleButtonGroupClassesDefault.default));
var _toggleButtonGroup = require("./ToggleButtonGroup");
var _toggleButtonGroupDefault = parcelHelpers.interopDefault(_toggleButtonGroup);
var _toggleButtonGroupClasses = require("./toggleButtonGroupClasses");
var _toggleButtonGroupClassesDefault = parcelHelpers.interopDefault(_toggleButtonGroupClasses);
parcelHelpers.exportAll(_toggleButtonGroupClasses, exports);
'use client';

},{"./ToggleButtonGroup":"8HhGZ","./toggleButtonGroupClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8HhGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _getValidReactChildren = require("@mui/utils/getValidReactChildren");
var _getValidReactChildrenDefault = parcelHelpers.interopDefault(_getValidReactChildren);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _toggleButtonGroupClasses = require("./toggleButtonGroupClasses");
var _toggleButtonGroupClassesDefault = parcelHelpers.interopDefault(_toggleButtonGroupClasses);
var _toggleButtonGroupContext = require("./ToggleButtonGroupContext");
var _toggleButtonGroupContextDefault = parcelHelpers.interopDefault(_toggleButtonGroupContext);
var _toggleButtonGroupButtonContext = require("./ToggleButtonGroupButtonContext");
var _toggleButtonGroupButtonContextDefault = parcelHelpers.interopDefault(_toggleButtonGroupButtonContext);
var _toggleButtonClasses = require("../ToggleButton/toggleButtonClasses");
var _toggleButtonClassesDefault = parcelHelpers.interopDefault(_toggleButtonClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "color",
    "disabled",
    "exclusive",
    "fullWidth",
    "onChange",
    "orientation",
    "size",
    "value"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, orientation, fullWidth, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth'
        ],
        grouped: [
            'grouped',
            `grouped${(0, _capitalizeDefault.default)(orientation)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _toggleButtonGroupClasses.getToggleButtonGroupUtilityClass), classes);
};
const ToggleButtonGroupRoot = (0, _styledDefault.default)('div', {
    name: 'MuiToggleButtonGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _toggleButtonGroupClassesDefault.default).grouped}`]: styles.grouped
            },
            {
                [`& .${(0, _toggleButtonGroupClassesDefault.default).grouped}`]: styles[`grouped${(0, _capitalizeDefault.default)(ownerState.orientation)}`]
            },
            {
                [`& .${(0, _toggleButtonGroupClassesDefault.default).firstButton}`]: styles.firstButton
            },
            {
                [`& .${(0, _toggleButtonGroupClassesDefault.default).lastButton}`]: styles.lastButton
            },
            {
                [`& .${(0, _toggleButtonGroupClassesDefault.default).middleButton}`]: styles.middleButton
            },
            styles.root,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.fullWidth && {
        width: '100%'
    }, {
        [`& .${(0, _toggleButtonGroupClassesDefault.default).grouped}`]: (0, _extendsDefault.default)({}, ownerState.orientation === 'horizontal' ? {
            [`&.${(0, _toggleButtonGroupClassesDefault.default).selected} + .${(0, _toggleButtonGroupClassesDefault.default).grouped}.${(0, _toggleButtonGroupClassesDefault.default).selected}`]: {
                borderLeft: 0,
                marginLeft: 0
            }
        } : {
            [`&.${(0, _toggleButtonGroupClassesDefault.default).selected} + .${(0, _toggleButtonGroupClassesDefault.default).grouped}.${(0, _toggleButtonGroupClassesDefault.default).selected}`]: {
                borderTop: 0,
                marginTop: 0
            }
        })
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, _toggleButtonGroupClassesDefault.default).firstButton},& .${(0, _toggleButtonGroupClassesDefault.default).middleButton}`]: {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, _toggleButtonGroupClassesDefault.default).lastButton},& .${(0, _toggleButtonGroupClassesDefault.default).middleButton}`]: {
            marginLeft: -1,
            borderLeft: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }
    } : {
        [`& .${(0, _toggleButtonGroupClassesDefault.default).firstButton},& .${(0, _toggleButtonGroupClassesDefault.default).middleButton}`]: {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        [`& .${(0, _toggleButtonGroupClassesDefault.default).lastButton},& .${(0, _toggleButtonGroupClassesDefault.default).middleButton}`]: {
            marginTop: -1,
            borderTop: '1px solid transparent',
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0
        }
    }, ownerState.orientation === 'horizontal' ? {
        [`& .${(0, _toggleButtonGroupClassesDefault.default).lastButton}.${(0, _toggleButtonClassesDefault.default).disabled},& .${(0, _toggleButtonGroupClassesDefault.default).middleButton}.${(0, _toggleButtonClassesDefault.default).disabled}`]: {
            borderLeft: '1px solid transparent'
        }
    } : {
        [`& .${(0, _toggleButtonGroupClassesDefault.default).lastButton}.${(0, _toggleButtonClassesDefault.default).disabled},& .${(0, _toggleButtonGroupClassesDefault.default).middleButton}.${(0, _toggleButtonClassesDefault.default).disabled}`]: {
            borderTop: '1px solid transparent'
        }
    }));
const ToggleButtonGroup = /*#__PURE__*/ _react.forwardRef(function ToggleButtonGroup(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiToggleButtonGroup'
    });
    const { children, className, color = 'standard', disabled = false, exclusive = false, fullWidth = false, onChange, orientation = 'horizontal', size = 'medium', value } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        disabled,
        fullWidth,
        orientation,
        size
    });
    const classes = useUtilityClasses(ownerState);
    const handleChange = _react.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        const index = value && value.indexOf(buttonValue);
        let newValue;
        if (value && index >= 0) {
            newValue = value.slice();
            newValue.splice(index, 1);
        } else newValue = value ? value.concat(buttonValue) : [
            buttonValue
        ];
        onChange(event, newValue);
    }, [
        onChange,
        value
    ]);
    const handleExclusiveChange = _react.useCallback((event, buttonValue)=>{
        if (!onChange) return;
        onChange(event, value === buttonValue ? null : buttonValue);
    }, [
        onChange,
        value
    ]);
    const context = _react.useMemo(()=>({
            className: classes.grouped,
            onChange: exclusive ? handleExclusiveChange : handleChange,
            value,
            size,
            fullWidth,
            color,
            disabled
        }), [
        classes.grouped,
        exclusive,
        handleExclusiveChange,
        handleChange,
        value,
        size,
        fullWidth,
        color,
        disabled
    ]);
    const validChildren = (0, _getValidReactChildrenDefault.default)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ToggleButtonGroupRoot, (0, _extendsDefault.default)({
        role: "group",
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonGroupContextDefault.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleButtonGroupButtonContextDefault.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
exports.default = ToggleButtonGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","react-is":"8oKlE","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/getValidReactChildren":"BQN46","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../utils/capitalize":"hBZko","./toggleButtonGroupClasses":"1GHbi","./ToggleButtonGroupContext":"e9atr","./ToggleButtonGroupButtonContext":"8TGet","../ToggleButton/toggleButtonClasses":"1Sduf","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1GHbi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getToggleButtonGroupUtilityClass", ()=>getToggleButtonGroupUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getToggleButtonGroupUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiToggleButtonGroup', slot);
}
const toggleButtonGroupClasses = (0, _generateUtilityClassesDefault.default)('MuiToggleButtonGroup', [
    'root',
    'selected',
    'horizontal',
    'vertical',
    'disabled',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'fullWidth',
    'firstButton',
    'lastButton',
    'middleButton'
]);
exports.default = toggleButtonGroupClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9m7kY":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("ef259826876677bc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("26677d5703e006f6"));
var _jsxRuntime = require("1538f8544eaff15d");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
}), 'FileDownload');

},{"ef259826876677bc":"kZ6eK","26677d5703e006f6":"2vOnF","1538f8544eaff15d":"1dlk8"}],"2vOnF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _utils.createSvgIcon;
    }
});
var _utils = require("21f2d1dcc9f0020d");

},{"21f2d1dcc9f0020d":"60iOt"}],"4XfdO":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("7b6bec045d2c0e45");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("a0755c411e3b87b1"));
var _jsxRuntime = require("21c44aa95307b304");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');

},{"7b6bec045d2c0e45":"kZ6eK","a0755c411e3b87b1":"2vOnF","21c44aa95307b304":"1dlk8"}],"6qreH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("e08d1c8f77ec2eac");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4de2629ead76be7"));
var _jsxRuntime = require("370c36fae6895c2f");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');

},{"e08d1c8f77ec2eac":"kZ6eK","4de2629ead76be7":"2vOnF","370c36fae6895c2f":"1dlk8"}],"jrNj7":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("18a23610d276482a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("ed61619ca1b8a2c"));
var _jsxRuntime = require("423147912c296b5f");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');

},{"18a23610d276482a":"kZ6eK","ed61619ca1b8a2c":"2vOnF","423147912c296b5f":"1dlk8"}],"crtKq":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("f67ab80c4d13eef3");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("36ee8ae8473e27d8"));
var _jsxRuntime = require("52c745c00027fcc6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');

},{"f67ab80c4d13eef3":"kZ6eK","36ee8ae8473e27d8":"2vOnF","52c745c00027fcc6":"1dlk8"}],"acjz6":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("239535702eb5ed24");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6c62a682237a7579"));
var _jsxRuntime = require("61f3f716cbb9f2ed");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

},{"239535702eb5ed24":"kZ6eK","6c62a682237a7579":"2vOnF","61f3f716cbb9f2ed":"1dlk8"}],"hh96o":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("cab4a11d1bb87c40");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("5262ba91c676d9f0"));
var _jsxRuntime = require("8477ff7b58e9268a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3m6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1z"
}), 'AssignmentInd');

},{"cab4a11d1bb87c40":"kZ6eK","5262ba91c676d9f0":"2vOnF","8477ff7b58e9268a":"1dlk8"}],"jpADq":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("19e1035a7642ae3d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4aad62b7ba607cd6"));
var _jsxRuntime = require("c21cd309f527cb18");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m2 14H7v-2h7zm3-4H7v-2h10zm0-4H7V7h10z"
}), 'Assignment');

},{"19e1035a7642ae3d":"kZ6eK","4aad62b7ba607cd6":"2vOnF","c21cd309f527cb18":"1dlk8"}],"fYcXS":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("c8c7adc358446b1d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("c5fe82dfe318be1e"));
var _jsxRuntime = require("2b178db48105aac9");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m-2 14-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z"
}), 'AssignmentTurnedIn');

},{"c8c7adc358446b1d":"kZ6eK","c5fe82dfe318be1e":"2vOnF","2b178db48105aac9":"1dlk8"}],"2TA6B":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("7ec71bc9dc97a207");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b6cb72f80fd9dc2d"));
var _jsxRuntime = require("5e0be801818a8cb1");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');

},{"7ec71bc9dc97a207":"kZ6eK","b6cb72f80fd9dc2d":"2vOnF","5e0be801818a8cb1":"1dlk8"}],"7NhqT":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("87d0dac1a08f9aa8");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("c0b94e62516b8a71"));
var _jsxRuntime = require("53565cc345e4a29e");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIosSharp');

},{"87d0dac1a08f9aa8":"kZ6eK","c0b94e62516b8a71":"2vOnF","53565cc345e4a29e":"1dlk8"}],"lMa52":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("2a06ddcf2f2cee42");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("12bc78a3cf4c0fb6"));
var _jsxRuntime = require("e4bc108cadf11e17");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');

},{"2a06ddcf2f2cee42":"kZ6eK","12bc78a3cf4c0fb6":"2vOnF","e4bc108cadf11e17":"1dlk8"}],"22WtH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("232ab8a207fe2464");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("8f6184f10c32f401"));
var _jsxRuntime = require("6b76b0748d35cf91");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');

},{"232ab8a207fe2464":"kZ6eK","8f6184f10c32f401":"2vOnF","6b76b0748d35cf91":"1dlk8"}],"eRDc8":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("8ee63de35adad671");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("844049b74d6acb38"));
var _jsxRuntime = require("59ceb3871d77d8c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'Warning');

},{"8ee63de35adad671":"kZ6eK","844049b74d6acb38":"2vOnF","59ceb3871d77d8c":"1dlk8"}],"hgoLH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("962f4c63089af010");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("96536f39a1eb602c"));
var _jsxRuntime = require("b94307d67cbd52fc");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');

},{"962f4c63089af010":"kZ6eK","96536f39a1eb602c":"2vOnF","b94307d67cbd52fc":"1dlk8"}],"joPR3":[function(require,module,exports,__globalThis) {
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fas", ()=>_iconsCache);
parcelHelpers.export(exports, "prefix", ()=>prefix);
parcelHelpers.export(exports, "faAd", ()=>faAd);
parcelHelpers.export(exports, "faAddressBook", ()=>faAddressBook);
parcelHelpers.export(exports, "faAddressCard", ()=>faAddressCard);
parcelHelpers.export(exports, "faAdjust", ()=>faAdjust);
parcelHelpers.export(exports, "faAirFreshener", ()=>faAirFreshener);
parcelHelpers.export(exports, "faAlignCenter", ()=>faAlignCenter);
parcelHelpers.export(exports, "faAlignJustify", ()=>faAlignJustify);
parcelHelpers.export(exports, "faAlignLeft", ()=>faAlignLeft);
parcelHelpers.export(exports, "faAlignRight", ()=>faAlignRight);
parcelHelpers.export(exports, "faAllergies", ()=>faAllergies);
parcelHelpers.export(exports, "faAmbulance", ()=>faAmbulance);
parcelHelpers.export(exports, "faAmericanSignLanguageInterpreting", ()=>faAmericanSignLanguageInterpreting);
parcelHelpers.export(exports, "faAnchor", ()=>faAnchor);
parcelHelpers.export(exports, "faAngleDoubleDown", ()=>faAngleDoubleDown);
parcelHelpers.export(exports, "faAngleDoubleLeft", ()=>faAngleDoubleLeft);
parcelHelpers.export(exports, "faAngleDoubleRight", ()=>faAngleDoubleRight);
parcelHelpers.export(exports, "faAngleDoubleUp", ()=>faAngleDoubleUp);
parcelHelpers.export(exports, "faAngleDown", ()=>faAngleDown);
parcelHelpers.export(exports, "faAngleLeft", ()=>faAngleLeft);
parcelHelpers.export(exports, "faAngleRight", ()=>faAngleRight);
parcelHelpers.export(exports, "faAngleUp", ()=>faAngleUp);
parcelHelpers.export(exports, "faAngry", ()=>faAngry);
parcelHelpers.export(exports, "faAnkh", ()=>faAnkh);
parcelHelpers.export(exports, "faAppleAlt", ()=>faAppleAlt);
parcelHelpers.export(exports, "faArchive", ()=>faArchive);
parcelHelpers.export(exports, "faArchway", ()=>faArchway);
parcelHelpers.export(exports, "faArrowAltCircleDown", ()=>faArrowAltCircleDown);
parcelHelpers.export(exports, "faArrowAltCircleLeft", ()=>faArrowAltCircleLeft);
parcelHelpers.export(exports, "faArrowAltCircleRight", ()=>faArrowAltCircleRight);
parcelHelpers.export(exports, "faArrowAltCircleUp", ()=>faArrowAltCircleUp);
parcelHelpers.export(exports, "faArrowCircleDown", ()=>faArrowCircleDown);
parcelHelpers.export(exports, "faArrowCircleLeft", ()=>faArrowCircleLeft);
parcelHelpers.export(exports, "faArrowCircleRight", ()=>faArrowCircleRight);
parcelHelpers.export(exports, "faArrowCircleUp", ()=>faArrowCircleUp);
parcelHelpers.export(exports, "faArrowDown", ()=>faArrowDown);
parcelHelpers.export(exports, "faArrowLeft", ()=>faArrowLeft);
parcelHelpers.export(exports, "faArrowRight", ()=>faArrowRight);
parcelHelpers.export(exports, "faArrowUp", ()=>faArrowUp);
parcelHelpers.export(exports, "faArrowsAlt", ()=>faArrowsAlt);
parcelHelpers.export(exports, "faArrowsAltH", ()=>faArrowsAltH);
parcelHelpers.export(exports, "faArrowsAltV", ()=>faArrowsAltV);
parcelHelpers.export(exports, "faAssistiveListeningSystems", ()=>faAssistiveListeningSystems);
parcelHelpers.export(exports, "faAsterisk", ()=>faAsterisk);
parcelHelpers.export(exports, "faAt", ()=>faAt);
parcelHelpers.export(exports, "faAtlas", ()=>faAtlas);
parcelHelpers.export(exports, "faAtom", ()=>faAtom);
parcelHelpers.export(exports, "faAudioDescription", ()=>faAudioDescription);
parcelHelpers.export(exports, "faAward", ()=>faAward);
parcelHelpers.export(exports, "faBaby", ()=>faBaby);
parcelHelpers.export(exports, "faBabyCarriage", ()=>faBabyCarriage);
parcelHelpers.export(exports, "faBackspace", ()=>faBackspace);
parcelHelpers.export(exports, "faBackward", ()=>faBackward);
parcelHelpers.export(exports, "faBacon", ()=>faBacon);
parcelHelpers.export(exports, "faBacteria", ()=>faBacteria);
parcelHelpers.export(exports, "faBacterium", ()=>faBacterium);
parcelHelpers.export(exports, "faBahai", ()=>faBahai);
parcelHelpers.export(exports, "faBalanceScale", ()=>faBalanceScale);
parcelHelpers.export(exports, "faBalanceScaleLeft", ()=>faBalanceScaleLeft);
parcelHelpers.export(exports, "faBalanceScaleRight", ()=>faBalanceScaleRight);
parcelHelpers.export(exports, "faBan", ()=>faBan);
parcelHelpers.export(exports, "faBandAid", ()=>faBandAid);
parcelHelpers.export(exports, "faBarcode", ()=>faBarcode);
parcelHelpers.export(exports, "faBars", ()=>faBars);
parcelHelpers.export(exports, "faBaseballBall", ()=>faBaseballBall);
parcelHelpers.export(exports, "faBasketballBall", ()=>faBasketballBall);
parcelHelpers.export(exports, "faBath", ()=>faBath);
parcelHelpers.export(exports, "faBatteryEmpty", ()=>faBatteryEmpty);
parcelHelpers.export(exports, "faBatteryFull", ()=>faBatteryFull);
parcelHelpers.export(exports, "faBatteryHalf", ()=>faBatteryHalf);
parcelHelpers.export(exports, "faBatteryQuarter", ()=>faBatteryQuarter);
parcelHelpers.export(exports, "faBatteryThreeQuarters", ()=>faBatteryThreeQuarters);
parcelHelpers.export(exports, "faBed", ()=>faBed);
parcelHelpers.export(exports, "faBeer", ()=>faBeer);
parcelHelpers.export(exports, "faBell", ()=>faBell);
parcelHelpers.export(exports, "faBellSlash", ()=>faBellSlash);
parcelHelpers.export(exports, "faBezierCurve", ()=>faBezierCurve);
parcelHelpers.export(exports, "faBible", ()=>faBible);
parcelHelpers.export(exports, "faBicycle", ()=>faBicycle);
parcelHelpers.export(exports, "faBiking", ()=>faBiking);
parcelHelpers.export(exports, "faBinoculars", ()=>faBinoculars);
parcelHelpers.export(exports, "faBiohazard", ()=>faBiohazard);
parcelHelpers.export(exports, "faBirthdayCake", ()=>faBirthdayCake);
parcelHelpers.export(exports, "faBlender", ()=>faBlender);
parcelHelpers.export(exports, "faBlenderPhone", ()=>faBlenderPhone);
parcelHelpers.export(exports, "faBlind", ()=>faBlind);
parcelHelpers.export(exports, "faBlog", ()=>faBlog);
parcelHelpers.export(exports, "faBold", ()=>faBold);
parcelHelpers.export(exports, "faBolt", ()=>faBolt);
parcelHelpers.export(exports, "faBomb", ()=>faBomb);
parcelHelpers.export(exports, "faBone", ()=>faBone);
parcelHelpers.export(exports, "faBong", ()=>faBong);
parcelHelpers.export(exports, "faBook", ()=>faBook);
parcelHelpers.export(exports, "faBookDead", ()=>faBookDead);
parcelHelpers.export(exports, "faBookMedical", ()=>faBookMedical);
parcelHelpers.export(exports, "faBookOpen", ()=>faBookOpen);
parcelHelpers.export(exports, "faBookReader", ()=>faBookReader);
parcelHelpers.export(exports, "faBookmark", ()=>faBookmark);
parcelHelpers.export(exports, "faBorderAll", ()=>faBorderAll);
parcelHelpers.export(exports, "faBorderNone", ()=>faBorderNone);
parcelHelpers.export(exports, "faBorderStyle", ()=>faBorderStyle);
parcelHelpers.export(exports, "faBowlingBall", ()=>faBowlingBall);
parcelHelpers.export(exports, "faBox", ()=>faBox);
parcelHelpers.export(exports, "faBoxOpen", ()=>faBoxOpen);
parcelHelpers.export(exports, "faBoxTissue", ()=>faBoxTissue);
parcelHelpers.export(exports, "faBoxes", ()=>faBoxes);
parcelHelpers.export(exports, "faBraille", ()=>faBraille);
parcelHelpers.export(exports, "faBrain", ()=>faBrain);
parcelHelpers.export(exports, "faBreadSlice", ()=>faBreadSlice);
parcelHelpers.export(exports, "faBriefcase", ()=>faBriefcase);
parcelHelpers.export(exports, "faBriefcaseMedical", ()=>faBriefcaseMedical);
parcelHelpers.export(exports, "faBroadcastTower", ()=>faBroadcastTower);
parcelHelpers.export(exports, "faBroom", ()=>faBroom);
parcelHelpers.export(exports, "faBrush", ()=>faBrush);
parcelHelpers.export(exports, "faBug", ()=>faBug);
parcelHelpers.export(exports, "faBuilding", ()=>faBuilding);
parcelHelpers.export(exports, "faBullhorn", ()=>faBullhorn);
parcelHelpers.export(exports, "faBullseye", ()=>faBullseye);
parcelHelpers.export(exports, "faBurn", ()=>faBurn);
parcelHelpers.export(exports, "faBus", ()=>faBus);
parcelHelpers.export(exports, "faBusAlt", ()=>faBusAlt);
parcelHelpers.export(exports, "faBusinessTime", ()=>faBusinessTime);
parcelHelpers.export(exports, "faCalculator", ()=>faCalculator);
parcelHelpers.export(exports, "faCalendar", ()=>faCalendar);
parcelHelpers.export(exports, "faCalendarAlt", ()=>faCalendarAlt);
parcelHelpers.export(exports, "faCalendarCheck", ()=>faCalendarCheck);
parcelHelpers.export(exports, "faCalendarDay", ()=>faCalendarDay);
parcelHelpers.export(exports, "faCalendarMinus", ()=>faCalendarMinus);
parcelHelpers.export(exports, "faCalendarPlus", ()=>faCalendarPlus);
parcelHelpers.export(exports, "faCalendarTimes", ()=>faCalendarTimes);
parcelHelpers.export(exports, "faCalendarWeek", ()=>faCalendarWeek);
parcelHelpers.export(exports, "faCamera", ()=>faCamera);
parcelHelpers.export(exports, "faCameraRetro", ()=>faCameraRetro);
parcelHelpers.export(exports, "faCampground", ()=>faCampground);
parcelHelpers.export(exports, "faCandyCane", ()=>faCandyCane);
parcelHelpers.export(exports, "faCannabis", ()=>faCannabis);
parcelHelpers.export(exports, "faCapsules", ()=>faCapsules);
parcelHelpers.export(exports, "faCar", ()=>faCar);
parcelHelpers.export(exports, "faCarAlt", ()=>faCarAlt);
parcelHelpers.export(exports, "faCarBattery", ()=>faCarBattery);
parcelHelpers.export(exports, "faCarCrash", ()=>faCarCrash);
parcelHelpers.export(exports, "faCarSide", ()=>faCarSide);
parcelHelpers.export(exports, "faCaravan", ()=>faCaravan);
parcelHelpers.export(exports, "faCaretDown", ()=>faCaretDown);
parcelHelpers.export(exports, "faCaretLeft", ()=>faCaretLeft);
parcelHelpers.export(exports, "faCaretRight", ()=>faCaretRight);
parcelHelpers.export(exports, "faCaretSquareDown", ()=>faCaretSquareDown);
parcelHelpers.export(exports, "faCaretSquareLeft", ()=>faCaretSquareLeft);
parcelHelpers.export(exports, "faCaretSquareRight", ()=>faCaretSquareRight);
parcelHelpers.export(exports, "faCaretSquareUp", ()=>faCaretSquareUp);
parcelHelpers.export(exports, "faCaretUp", ()=>faCaretUp);
parcelHelpers.export(exports, "faCarrot", ()=>faCarrot);
parcelHelpers.export(exports, "faCartArrowDown", ()=>faCartArrowDown);
parcelHelpers.export(exports, "faCartPlus", ()=>faCartPlus);
parcelHelpers.export(exports, "faCashRegister", ()=>faCashRegister);
parcelHelpers.export(exports, "faCat", ()=>faCat);
parcelHelpers.export(exports, "faCertificate", ()=>faCertificate);
parcelHelpers.export(exports, "faChair", ()=>faChair);
parcelHelpers.export(exports, "faChalkboard", ()=>faChalkboard);
parcelHelpers.export(exports, "faChalkboardTeacher", ()=>faChalkboardTeacher);
parcelHelpers.export(exports, "faChargingStation", ()=>faChargingStation);
parcelHelpers.export(exports, "faChartArea", ()=>faChartArea);
parcelHelpers.export(exports, "faChartBar", ()=>faChartBar);
parcelHelpers.export(exports, "faChartLine", ()=>faChartLine);
parcelHelpers.export(exports, "faChartPie", ()=>faChartPie);
parcelHelpers.export(exports, "faCheck", ()=>faCheck);
parcelHelpers.export(exports, "faCheckCircle", ()=>faCheckCircle);
parcelHelpers.export(exports, "faCheckDouble", ()=>faCheckDouble);
parcelHelpers.export(exports, "faCheckSquare", ()=>faCheckSquare);
parcelHelpers.export(exports, "faCheese", ()=>faCheese);
parcelHelpers.export(exports, "faChess", ()=>faChess);
parcelHelpers.export(exports, "faChessBishop", ()=>faChessBishop);
parcelHelpers.export(exports, "faChessBoard", ()=>faChessBoard);
parcelHelpers.export(exports, "faChessKing", ()=>faChessKing);
parcelHelpers.export(exports, "faChessKnight", ()=>faChessKnight);
parcelHelpers.export(exports, "faChessPawn", ()=>faChessPawn);
parcelHelpers.export(exports, "faChessQueen", ()=>faChessQueen);
parcelHelpers.export(exports, "faChessRook", ()=>faChessRook);
parcelHelpers.export(exports, "faChevronCircleDown", ()=>faChevronCircleDown);
parcelHelpers.export(exports, "faChevronCircleLeft", ()=>faChevronCircleLeft);
parcelHelpers.export(exports, "faChevronCircleRight", ()=>faChevronCircleRight);
parcelHelpers.export(exports, "faChevronCircleUp", ()=>faChevronCircleUp);
parcelHelpers.export(exports, "faChevronDown", ()=>faChevronDown);
parcelHelpers.export(exports, "faChevronLeft", ()=>faChevronLeft);
parcelHelpers.export(exports, "faChevronRight", ()=>faChevronRight);
parcelHelpers.export(exports, "faChevronUp", ()=>faChevronUp);
parcelHelpers.export(exports, "faChild", ()=>faChild);
parcelHelpers.export(exports, "faChurch", ()=>faChurch);
parcelHelpers.export(exports, "faCircle", ()=>faCircle);
parcelHelpers.export(exports, "faCircleNotch", ()=>faCircleNotch);
parcelHelpers.export(exports, "faCity", ()=>faCity);
parcelHelpers.export(exports, "faClinicMedical", ()=>faClinicMedical);
parcelHelpers.export(exports, "faClipboard", ()=>faClipboard);
parcelHelpers.export(exports, "faClipboardCheck", ()=>faClipboardCheck);
parcelHelpers.export(exports, "faClipboardList", ()=>faClipboardList);
parcelHelpers.export(exports, "faClock", ()=>faClock);
parcelHelpers.export(exports, "faClone", ()=>faClone);
parcelHelpers.export(exports, "faClosedCaptioning", ()=>faClosedCaptioning);
parcelHelpers.export(exports, "faCloud", ()=>faCloud);
parcelHelpers.export(exports, "faCloudDownloadAlt", ()=>faCloudDownloadAlt);
parcelHelpers.export(exports, "faCloudMeatball", ()=>faCloudMeatball);
parcelHelpers.export(exports, "faCloudMoon", ()=>faCloudMoon);
parcelHelpers.export(exports, "faCloudMoonRain", ()=>faCloudMoonRain);
parcelHelpers.export(exports, "faCloudRain", ()=>faCloudRain);
parcelHelpers.export(exports, "faCloudShowersHeavy", ()=>faCloudShowersHeavy);
parcelHelpers.export(exports, "faCloudSun", ()=>faCloudSun);
parcelHelpers.export(exports, "faCloudSunRain", ()=>faCloudSunRain);
parcelHelpers.export(exports, "faCloudUploadAlt", ()=>faCloudUploadAlt);
parcelHelpers.export(exports, "faCocktail", ()=>faCocktail);
parcelHelpers.export(exports, "faCode", ()=>faCode);
parcelHelpers.export(exports, "faCodeBranch", ()=>faCodeBranch);
parcelHelpers.export(exports, "faCoffee", ()=>faCoffee);
parcelHelpers.export(exports, "faCog", ()=>faCog);
parcelHelpers.export(exports, "faCogs", ()=>faCogs);
parcelHelpers.export(exports, "faCoins", ()=>faCoins);
parcelHelpers.export(exports, "faColumns", ()=>faColumns);
parcelHelpers.export(exports, "faComment", ()=>faComment);
parcelHelpers.export(exports, "faCommentAlt", ()=>faCommentAlt);
parcelHelpers.export(exports, "faCommentDollar", ()=>faCommentDollar);
parcelHelpers.export(exports, "faCommentDots", ()=>faCommentDots);
parcelHelpers.export(exports, "faCommentMedical", ()=>faCommentMedical);
parcelHelpers.export(exports, "faCommentSlash", ()=>faCommentSlash);
parcelHelpers.export(exports, "faComments", ()=>faComments);
parcelHelpers.export(exports, "faCommentsDollar", ()=>faCommentsDollar);
parcelHelpers.export(exports, "faCompactDisc", ()=>faCompactDisc);
parcelHelpers.export(exports, "faCompass", ()=>faCompass);
parcelHelpers.export(exports, "faCompress", ()=>faCompress);
parcelHelpers.export(exports, "faCompressAlt", ()=>faCompressAlt);
parcelHelpers.export(exports, "faCompressArrowsAlt", ()=>faCompressArrowsAlt);
parcelHelpers.export(exports, "faConciergeBell", ()=>faConciergeBell);
parcelHelpers.export(exports, "faCookie", ()=>faCookie);
parcelHelpers.export(exports, "faCookieBite", ()=>faCookieBite);
parcelHelpers.export(exports, "faCopy", ()=>faCopy);
parcelHelpers.export(exports, "faCopyright", ()=>faCopyright);
parcelHelpers.export(exports, "faCouch", ()=>faCouch);
parcelHelpers.export(exports, "faCreditCard", ()=>faCreditCard);
parcelHelpers.export(exports, "faCrop", ()=>faCrop);
parcelHelpers.export(exports, "faCropAlt", ()=>faCropAlt);
parcelHelpers.export(exports, "faCross", ()=>faCross);
parcelHelpers.export(exports, "faCrosshairs", ()=>faCrosshairs);
parcelHelpers.export(exports, "faCrow", ()=>faCrow);
parcelHelpers.export(exports, "faCrown", ()=>faCrown);
parcelHelpers.export(exports, "faCrutch", ()=>faCrutch);
parcelHelpers.export(exports, "faCube", ()=>faCube);
parcelHelpers.export(exports, "faCubes", ()=>faCubes);
parcelHelpers.export(exports, "faCut", ()=>faCut);
parcelHelpers.export(exports, "faDatabase", ()=>faDatabase);
parcelHelpers.export(exports, "faDeaf", ()=>faDeaf);
parcelHelpers.export(exports, "faDemocrat", ()=>faDemocrat);
parcelHelpers.export(exports, "faDesktop", ()=>faDesktop);
parcelHelpers.export(exports, "faDharmachakra", ()=>faDharmachakra);
parcelHelpers.export(exports, "faDiagnoses", ()=>faDiagnoses);
parcelHelpers.export(exports, "faDice", ()=>faDice);
parcelHelpers.export(exports, "faDiceD20", ()=>faDiceD20);
parcelHelpers.export(exports, "faDiceD6", ()=>faDiceD6);
parcelHelpers.export(exports, "faDiceFive", ()=>faDiceFive);
parcelHelpers.export(exports, "faDiceFour", ()=>faDiceFour);
parcelHelpers.export(exports, "faDiceOne", ()=>faDiceOne);
parcelHelpers.export(exports, "faDiceSix", ()=>faDiceSix);
parcelHelpers.export(exports, "faDiceThree", ()=>faDiceThree);
parcelHelpers.export(exports, "faDiceTwo", ()=>faDiceTwo);
parcelHelpers.export(exports, "faDigitalTachograph", ()=>faDigitalTachograph);
parcelHelpers.export(exports, "faDirections", ()=>faDirections);
parcelHelpers.export(exports, "faDisease", ()=>faDisease);
parcelHelpers.export(exports, "faDivide", ()=>faDivide);
parcelHelpers.export(exports, "faDizzy", ()=>faDizzy);
parcelHelpers.export(exports, "faDna", ()=>faDna);
parcelHelpers.export(exports, "faDog", ()=>faDog);
parcelHelpers.export(exports, "faDollarSign", ()=>faDollarSign);
parcelHelpers.export(exports, "faDolly", ()=>faDolly);
parcelHelpers.export(exports, "faDollyFlatbed", ()=>faDollyFlatbed);
parcelHelpers.export(exports, "faDonate", ()=>faDonate);
parcelHelpers.export(exports, "faDoorClosed", ()=>faDoorClosed);
parcelHelpers.export(exports, "faDoorOpen", ()=>faDoorOpen);
parcelHelpers.export(exports, "faDotCircle", ()=>faDotCircle);
parcelHelpers.export(exports, "faDove", ()=>faDove);
parcelHelpers.export(exports, "faDownload", ()=>faDownload);
parcelHelpers.export(exports, "faDraftingCompass", ()=>faDraftingCompass);
parcelHelpers.export(exports, "faDragon", ()=>faDragon);
parcelHelpers.export(exports, "faDrawPolygon", ()=>faDrawPolygon);
parcelHelpers.export(exports, "faDrum", ()=>faDrum);
parcelHelpers.export(exports, "faDrumSteelpan", ()=>faDrumSteelpan);
parcelHelpers.export(exports, "faDrumstickBite", ()=>faDrumstickBite);
parcelHelpers.export(exports, "faDumbbell", ()=>faDumbbell);
parcelHelpers.export(exports, "faDumpster", ()=>faDumpster);
parcelHelpers.export(exports, "faDumpsterFire", ()=>faDumpsterFire);
parcelHelpers.export(exports, "faDungeon", ()=>faDungeon);
parcelHelpers.export(exports, "faEdit", ()=>faEdit);
parcelHelpers.export(exports, "faEgg", ()=>faEgg);
parcelHelpers.export(exports, "faEject", ()=>faEject);
parcelHelpers.export(exports, "faEllipsisH", ()=>faEllipsisH);
parcelHelpers.export(exports, "faEllipsisV", ()=>faEllipsisV);
parcelHelpers.export(exports, "faEnvelope", ()=>faEnvelope);
parcelHelpers.export(exports, "faEnvelopeOpen", ()=>faEnvelopeOpen);
parcelHelpers.export(exports, "faEnvelopeOpenText", ()=>faEnvelopeOpenText);
parcelHelpers.export(exports, "faEnvelopeSquare", ()=>faEnvelopeSquare);
parcelHelpers.export(exports, "faEquals", ()=>faEquals);
parcelHelpers.export(exports, "faEraser", ()=>faEraser);
parcelHelpers.export(exports, "faEthernet", ()=>faEthernet);
parcelHelpers.export(exports, "faEuroSign", ()=>faEuroSign);
parcelHelpers.export(exports, "faExchangeAlt", ()=>faExchangeAlt);
parcelHelpers.export(exports, "faExclamation", ()=>faExclamation);
parcelHelpers.export(exports, "faExclamationCircle", ()=>faExclamationCircle);
parcelHelpers.export(exports, "faExclamationTriangle", ()=>faExclamationTriangle);
parcelHelpers.export(exports, "faExpand", ()=>faExpand);
parcelHelpers.export(exports, "faExpandAlt", ()=>faExpandAlt);
parcelHelpers.export(exports, "faExpandArrowsAlt", ()=>faExpandArrowsAlt);
parcelHelpers.export(exports, "faExternalLinkAlt", ()=>faExternalLinkAlt);
parcelHelpers.export(exports, "faExternalLinkSquareAlt", ()=>faExternalLinkSquareAlt);
parcelHelpers.export(exports, "faEye", ()=>faEye);
parcelHelpers.export(exports, "faEyeDropper", ()=>faEyeDropper);
parcelHelpers.export(exports, "faEyeSlash", ()=>faEyeSlash);
parcelHelpers.export(exports, "faFan", ()=>faFan);
parcelHelpers.export(exports, "faFastBackward", ()=>faFastBackward);
parcelHelpers.export(exports, "faFastForward", ()=>faFastForward);
parcelHelpers.export(exports, "faFaucet", ()=>faFaucet);
parcelHelpers.export(exports, "faFax", ()=>faFax);
parcelHelpers.export(exports, "faFeather", ()=>faFeather);
parcelHelpers.export(exports, "faFeatherAlt", ()=>faFeatherAlt);
parcelHelpers.export(exports, "faFemale", ()=>faFemale);
parcelHelpers.export(exports, "faFighterJet", ()=>faFighterJet);
parcelHelpers.export(exports, "faFile", ()=>faFile);
parcelHelpers.export(exports, "faFileAlt", ()=>faFileAlt);
parcelHelpers.export(exports, "faFileArchive", ()=>faFileArchive);
parcelHelpers.export(exports, "faFileAudio", ()=>faFileAudio);
parcelHelpers.export(exports, "faFileCode", ()=>faFileCode);
parcelHelpers.export(exports, "faFileContract", ()=>faFileContract);
parcelHelpers.export(exports, "faFileCsv", ()=>faFileCsv);
parcelHelpers.export(exports, "faFileDownload", ()=>faFileDownload);
parcelHelpers.export(exports, "faFileExcel", ()=>faFileExcel);
parcelHelpers.export(exports, "faFileExport", ()=>faFileExport);
parcelHelpers.export(exports, "faFileImage", ()=>faFileImage);
parcelHelpers.export(exports, "faFileImport", ()=>faFileImport);
parcelHelpers.export(exports, "faFileInvoice", ()=>faFileInvoice);
parcelHelpers.export(exports, "faFileInvoiceDollar", ()=>faFileInvoiceDollar);
parcelHelpers.export(exports, "faFileMedical", ()=>faFileMedical);
parcelHelpers.export(exports, "faFileMedicalAlt", ()=>faFileMedicalAlt);
parcelHelpers.export(exports, "faFilePdf", ()=>faFilePdf);
parcelHelpers.export(exports, "faFilePowerpoint", ()=>faFilePowerpoint);
parcelHelpers.export(exports, "faFilePrescription", ()=>faFilePrescription);
parcelHelpers.export(exports, "faFileSignature", ()=>faFileSignature);
parcelHelpers.export(exports, "faFileUpload", ()=>faFileUpload);
parcelHelpers.export(exports, "faFileVideo", ()=>faFileVideo);
parcelHelpers.export(exports, "faFileWord", ()=>faFileWord);
parcelHelpers.export(exports, "faFill", ()=>faFill);
parcelHelpers.export(exports, "faFillDrip", ()=>faFillDrip);
parcelHelpers.export(exports, "faFilm", ()=>faFilm);
parcelHelpers.export(exports, "faFilter", ()=>faFilter);
parcelHelpers.export(exports, "faFingerprint", ()=>faFingerprint);
parcelHelpers.export(exports, "faFire", ()=>faFire);
parcelHelpers.export(exports, "faFireAlt", ()=>faFireAlt);
parcelHelpers.export(exports, "faFireExtinguisher", ()=>faFireExtinguisher);
parcelHelpers.export(exports, "faFirstAid", ()=>faFirstAid);
parcelHelpers.export(exports, "faFish", ()=>faFish);
parcelHelpers.export(exports, "faFistRaised", ()=>faFistRaised);
parcelHelpers.export(exports, "faFlag", ()=>faFlag);
parcelHelpers.export(exports, "faFlagCheckered", ()=>faFlagCheckered);
parcelHelpers.export(exports, "faFlagUsa", ()=>faFlagUsa);
parcelHelpers.export(exports, "faFlask", ()=>faFlask);
parcelHelpers.export(exports, "faFlushed", ()=>faFlushed);
parcelHelpers.export(exports, "faFolder", ()=>faFolder);
parcelHelpers.export(exports, "faFolderMinus", ()=>faFolderMinus);
parcelHelpers.export(exports, "faFolderOpen", ()=>faFolderOpen);
parcelHelpers.export(exports, "faFolderPlus", ()=>faFolderPlus);
parcelHelpers.export(exports, "faFont", ()=>faFont);
parcelHelpers.export(exports, "faFontAwesomeLogoFull", ()=>faFontAwesomeLogoFull);
parcelHelpers.export(exports, "faFootballBall", ()=>faFootballBall);
parcelHelpers.export(exports, "faForward", ()=>faForward);
parcelHelpers.export(exports, "faFrog", ()=>faFrog);
parcelHelpers.export(exports, "faFrown", ()=>faFrown);
parcelHelpers.export(exports, "faFrownOpen", ()=>faFrownOpen);
parcelHelpers.export(exports, "faFunnelDollar", ()=>faFunnelDollar);
parcelHelpers.export(exports, "faFutbol", ()=>faFutbol);
parcelHelpers.export(exports, "faGamepad", ()=>faGamepad);
parcelHelpers.export(exports, "faGasPump", ()=>faGasPump);
parcelHelpers.export(exports, "faGavel", ()=>faGavel);
parcelHelpers.export(exports, "faGem", ()=>faGem);
parcelHelpers.export(exports, "faGenderless", ()=>faGenderless);
parcelHelpers.export(exports, "faGhost", ()=>faGhost);
parcelHelpers.export(exports, "faGift", ()=>faGift);
parcelHelpers.export(exports, "faGifts", ()=>faGifts);
parcelHelpers.export(exports, "faGlassCheers", ()=>faGlassCheers);
parcelHelpers.export(exports, "faGlassMartini", ()=>faGlassMartini);
parcelHelpers.export(exports, "faGlassMartiniAlt", ()=>faGlassMartiniAlt);
parcelHelpers.export(exports, "faGlassWhiskey", ()=>faGlassWhiskey);
parcelHelpers.export(exports, "faGlasses", ()=>faGlasses);
parcelHelpers.export(exports, "faGlobe", ()=>faGlobe);
parcelHelpers.export(exports, "faGlobeAfrica", ()=>faGlobeAfrica);
parcelHelpers.export(exports, "faGlobeAmericas", ()=>faGlobeAmericas);
parcelHelpers.export(exports, "faGlobeAsia", ()=>faGlobeAsia);
parcelHelpers.export(exports, "faGlobeEurope", ()=>faGlobeEurope);
parcelHelpers.export(exports, "faGolfBall", ()=>faGolfBall);
parcelHelpers.export(exports, "faGopuram", ()=>faGopuram);
parcelHelpers.export(exports, "faGraduationCap", ()=>faGraduationCap);
parcelHelpers.export(exports, "faGreaterThan", ()=>faGreaterThan);
parcelHelpers.export(exports, "faGreaterThanEqual", ()=>faGreaterThanEqual);
parcelHelpers.export(exports, "faGrimace", ()=>faGrimace);
parcelHelpers.export(exports, "faGrin", ()=>faGrin);
parcelHelpers.export(exports, "faGrinAlt", ()=>faGrinAlt);
parcelHelpers.export(exports, "faGrinBeam", ()=>faGrinBeam);
parcelHelpers.export(exports, "faGrinBeamSweat", ()=>faGrinBeamSweat);
parcelHelpers.export(exports, "faGrinHearts", ()=>faGrinHearts);
parcelHelpers.export(exports, "faGrinSquint", ()=>faGrinSquint);
parcelHelpers.export(exports, "faGrinSquintTears", ()=>faGrinSquintTears);
parcelHelpers.export(exports, "faGrinStars", ()=>faGrinStars);
parcelHelpers.export(exports, "faGrinTears", ()=>faGrinTears);
parcelHelpers.export(exports, "faGrinTongue", ()=>faGrinTongue);
parcelHelpers.export(exports, "faGrinTongueSquint", ()=>faGrinTongueSquint);
parcelHelpers.export(exports, "faGrinTongueWink", ()=>faGrinTongueWink);
parcelHelpers.export(exports, "faGrinWink", ()=>faGrinWink);
parcelHelpers.export(exports, "faGripHorizontal", ()=>faGripHorizontal);
parcelHelpers.export(exports, "faGripLines", ()=>faGripLines);
parcelHelpers.export(exports, "faGripLinesVertical", ()=>faGripLinesVertical);
parcelHelpers.export(exports, "faGripVertical", ()=>faGripVertical);
parcelHelpers.export(exports, "faGuitar", ()=>faGuitar);
parcelHelpers.export(exports, "faHSquare", ()=>faHSquare);
parcelHelpers.export(exports, "faHamburger", ()=>faHamburger);
parcelHelpers.export(exports, "faHammer", ()=>faHammer);
parcelHelpers.export(exports, "faHamsa", ()=>faHamsa);
parcelHelpers.export(exports, "faHandHolding", ()=>faHandHolding);
parcelHelpers.export(exports, "faHandHoldingHeart", ()=>faHandHoldingHeart);
parcelHelpers.export(exports, "faHandHoldingMedical", ()=>faHandHoldingMedical);
parcelHelpers.export(exports, "faHandHoldingUsd", ()=>faHandHoldingUsd);
parcelHelpers.export(exports, "faHandHoldingWater", ()=>faHandHoldingWater);
parcelHelpers.export(exports, "faHandLizard", ()=>faHandLizard);
parcelHelpers.export(exports, "faHandMiddleFinger", ()=>faHandMiddleFinger);
parcelHelpers.export(exports, "faHandPaper", ()=>faHandPaper);
parcelHelpers.export(exports, "faHandPeace", ()=>faHandPeace);
parcelHelpers.export(exports, "faHandPointDown", ()=>faHandPointDown);
parcelHelpers.export(exports, "faHandPointLeft", ()=>faHandPointLeft);
parcelHelpers.export(exports, "faHandPointRight", ()=>faHandPointRight);
parcelHelpers.export(exports, "faHandPointUp", ()=>faHandPointUp);
parcelHelpers.export(exports, "faHandPointer", ()=>faHandPointer);
parcelHelpers.export(exports, "faHandRock", ()=>faHandRock);
parcelHelpers.export(exports, "faHandScissors", ()=>faHandScissors);
parcelHelpers.export(exports, "faHandSparkles", ()=>faHandSparkles);
parcelHelpers.export(exports, "faHandSpock", ()=>faHandSpock);
parcelHelpers.export(exports, "faHands", ()=>faHands);
parcelHelpers.export(exports, "faHandsHelping", ()=>faHandsHelping);
parcelHelpers.export(exports, "faHandsWash", ()=>faHandsWash);
parcelHelpers.export(exports, "faHandshake", ()=>faHandshake);
parcelHelpers.export(exports, "faHandshakeAltSlash", ()=>faHandshakeAltSlash);
parcelHelpers.export(exports, "faHandshakeSlash", ()=>faHandshakeSlash);
parcelHelpers.export(exports, "faHanukiah", ()=>faHanukiah);
parcelHelpers.export(exports, "faHardHat", ()=>faHardHat);
parcelHelpers.export(exports, "faHashtag", ()=>faHashtag);
parcelHelpers.export(exports, "faHatCowboy", ()=>faHatCowboy);
parcelHelpers.export(exports, "faHatCowboySide", ()=>faHatCowboySide);
parcelHelpers.export(exports, "faHatWizard", ()=>faHatWizard);
parcelHelpers.export(exports, "faHdd", ()=>faHdd);
parcelHelpers.export(exports, "faHeadSideCough", ()=>faHeadSideCough);
parcelHelpers.export(exports, "faHeadSideCoughSlash", ()=>faHeadSideCoughSlash);
parcelHelpers.export(exports, "faHeadSideMask", ()=>faHeadSideMask);
parcelHelpers.export(exports, "faHeadSideVirus", ()=>faHeadSideVirus);
parcelHelpers.export(exports, "faHeading", ()=>faHeading);
parcelHelpers.export(exports, "faHeadphones", ()=>faHeadphones);
parcelHelpers.export(exports, "faHeadphonesAlt", ()=>faHeadphonesAlt);
parcelHelpers.export(exports, "faHeadset", ()=>faHeadset);
parcelHelpers.export(exports, "faHeart", ()=>faHeart);
parcelHelpers.export(exports, "faHeartBroken", ()=>faHeartBroken);
parcelHelpers.export(exports, "faHeartbeat", ()=>faHeartbeat);
parcelHelpers.export(exports, "faHelicopter", ()=>faHelicopter);
parcelHelpers.export(exports, "faHighlighter", ()=>faHighlighter);
parcelHelpers.export(exports, "faHiking", ()=>faHiking);
parcelHelpers.export(exports, "faHippo", ()=>faHippo);
parcelHelpers.export(exports, "faHistory", ()=>faHistory);
parcelHelpers.export(exports, "faHockeyPuck", ()=>faHockeyPuck);
parcelHelpers.export(exports, "faHollyBerry", ()=>faHollyBerry);
parcelHelpers.export(exports, "faHome", ()=>faHome);
parcelHelpers.export(exports, "faHorse", ()=>faHorse);
parcelHelpers.export(exports, "faHorseHead", ()=>faHorseHead);
parcelHelpers.export(exports, "faHospital", ()=>faHospital);
parcelHelpers.export(exports, "faHospitalAlt", ()=>faHospitalAlt);
parcelHelpers.export(exports, "faHospitalSymbol", ()=>faHospitalSymbol);
parcelHelpers.export(exports, "faHospitalUser", ()=>faHospitalUser);
parcelHelpers.export(exports, "faHotTub", ()=>faHotTub);
parcelHelpers.export(exports, "faHotdog", ()=>faHotdog);
parcelHelpers.export(exports, "faHotel", ()=>faHotel);
parcelHelpers.export(exports, "faHourglass", ()=>faHourglass);
parcelHelpers.export(exports, "faHourglassEnd", ()=>faHourglassEnd);
parcelHelpers.export(exports, "faHourglassHalf", ()=>faHourglassHalf);
parcelHelpers.export(exports, "faHourglassStart", ()=>faHourglassStart);
parcelHelpers.export(exports, "faHouseDamage", ()=>faHouseDamage);
parcelHelpers.export(exports, "faHouseUser", ()=>faHouseUser);
parcelHelpers.export(exports, "faHryvnia", ()=>faHryvnia);
parcelHelpers.export(exports, "faICursor", ()=>faICursor);
parcelHelpers.export(exports, "faIceCream", ()=>faIceCream);
parcelHelpers.export(exports, "faIcicles", ()=>faIcicles);
parcelHelpers.export(exports, "faIcons", ()=>faIcons);
parcelHelpers.export(exports, "faIdBadge", ()=>faIdBadge);
parcelHelpers.export(exports, "faIdCard", ()=>faIdCard);
parcelHelpers.export(exports, "faIdCardAlt", ()=>faIdCardAlt);
parcelHelpers.export(exports, "faIgloo", ()=>faIgloo);
parcelHelpers.export(exports, "faImage", ()=>faImage);
parcelHelpers.export(exports, "faImages", ()=>faImages);
parcelHelpers.export(exports, "faInbox", ()=>faInbox);
parcelHelpers.export(exports, "faIndent", ()=>faIndent);
parcelHelpers.export(exports, "faIndustry", ()=>faIndustry);
parcelHelpers.export(exports, "faInfinity", ()=>faInfinity);
parcelHelpers.export(exports, "faInfo", ()=>faInfo);
parcelHelpers.export(exports, "faInfoCircle", ()=>faInfoCircle);
parcelHelpers.export(exports, "faItalic", ()=>faItalic);
parcelHelpers.export(exports, "faJedi", ()=>faJedi);
parcelHelpers.export(exports, "faJoint", ()=>faJoint);
parcelHelpers.export(exports, "faJournalWhills", ()=>faJournalWhills);
parcelHelpers.export(exports, "faKaaba", ()=>faKaaba);
parcelHelpers.export(exports, "faKey", ()=>faKey);
parcelHelpers.export(exports, "faKeyboard", ()=>faKeyboard);
parcelHelpers.export(exports, "faKhanda", ()=>faKhanda);
parcelHelpers.export(exports, "faKiss", ()=>faKiss);
parcelHelpers.export(exports, "faKissBeam", ()=>faKissBeam);
parcelHelpers.export(exports, "faKissWinkHeart", ()=>faKissWinkHeart);
parcelHelpers.export(exports, "faKiwiBird", ()=>faKiwiBird);
parcelHelpers.export(exports, "faLandmark", ()=>faLandmark);
parcelHelpers.export(exports, "faLanguage", ()=>faLanguage);
parcelHelpers.export(exports, "faLaptop", ()=>faLaptop);
parcelHelpers.export(exports, "faLaptopCode", ()=>faLaptopCode);
parcelHelpers.export(exports, "faLaptopHouse", ()=>faLaptopHouse);
parcelHelpers.export(exports, "faLaptopMedical", ()=>faLaptopMedical);
parcelHelpers.export(exports, "faLaugh", ()=>faLaugh);
parcelHelpers.export(exports, "faLaughBeam", ()=>faLaughBeam);
parcelHelpers.export(exports, "faLaughSquint", ()=>faLaughSquint);
parcelHelpers.export(exports, "faLaughWink", ()=>faLaughWink);
parcelHelpers.export(exports, "faLayerGroup", ()=>faLayerGroup);
parcelHelpers.export(exports, "faLeaf", ()=>faLeaf);
parcelHelpers.export(exports, "faLemon", ()=>faLemon);
parcelHelpers.export(exports, "faLessThan", ()=>faLessThan);
parcelHelpers.export(exports, "faLessThanEqual", ()=>faLessThanEqual);
parcelHelpers.export(exports, "faLevelDownAlt", ()=>faLevelDownAlt);
parcelHelpers.export(exports, "faLevelUpAlt", ()=>faLevelUpAlt);
parcelHelpers.export(exports, "faLifeRing", ()=>faLifeRing);
parcelHelpers.export(exports, "faLightbulb", ()=>faLightbulb);
parcelHelpers.export(exports, "faLink", ()=>faLink);
parcelHelpers.export(exports, "faLiraSign", ()=>faLiraSign);
parcelHelpers.export(exports, "faList", ()=>faList);
parcelHelpers.export(exports, "faListAlt", ()=>faListAlt);
parcelHelpers.export(exports, "faListOl", ()=>faListOl);
parcelHelpers.export(exports, "faListUl", ()=>faListUl);
parcelHelpers.export(exports, "faLocationArrow", ()=>faLocationArrow);
parcelHelpers.export(exports, "faLock", ()=>faLock);
parcelHelpers.export(exports, "faLockOpen", ()=>faLockOpen);
parcelHelpers.export(exports, "faLongArrowAltDown", ()=>faLongArrowAltDown);
parcelHelpers.export(exports, "faLongArrowAltLeft", ()=>faLongArrowAltLeft);
parcelHelpers.export(exports, "faLongArrowAltRight", ()=>faLongArrowAltRight);
parcelHelpers.export(exports, "faLongArrowAltUp", ()=>faLongArrowAltUp);
parcelHelpers.export(exports, "faLowVision", ()=>faLowVision);
parcelHelpers.export(exports, "faLuggageCart", ()=>faLuggageCart);
parcelHelpers.export(exports, "faLungs", ()=>faLungs);
parcelHelpers.export(exports, "faLungsVirus", ()=>faLungsVirus);
parcelHelpers.export(exports, "faMagic", ()=>faMagic);
parcelHelpers.export(exports, "faMagnet", ()=>faMagnet);
parcelHelpers.export(exports, "faMailBulk", ()=>faMailBulk);
parcelHelpers.export(exports, "faMale", ()=>faMale);
parcelHelpers.export(exports, "faMap", ()=>faMap);
parcelHelpers.export(exports, "faMapMarked", ()=>faMapMarked);
parcelHelpers.export(exports, "faMapMarkedAlt", ()=>faMapMarkedAlt);
parcelHelpers.export(exports, "faMapMarker", ()=>faMapMarker);
parcelHelpers.export(exports, "faMapMarkerAlt", ()=>faMapMarkerAlt);
parcelHelpers.export(exports, "faMapPin", ()=>faMapPin);
parcelHelpers.export(exports, "faMapSigns", ()=>faMapSigns);
parcelHelpers.export(exports, "faMarker", ()=>faMarker);
parcelHelpers.export(exports, "faMars", ()=>faMars);
parcelHelpers.export(exports, "faMarsDouble", ()=>faMarsDouble);
parcelHelpers.export(exports, "faMarsStroke", ()=>faMarsStroke);
parcelHelpers.export(exports, "faMarsStrokeH", ()=>faMarsStrokeH);
parcelHelpers.export(exports, "faMarsStrokeV", ()=>faMarsStrokeV);
parcelHelpers.export(exports, "faMask", ()=>faMask);
parcelHelpers.export(exports, "faMedal", ()=>faMedal);
parcelHelpers.export(exports, "faMedkit", ()=>faMedkit);
parcelHelpers.export(exports, "faMeh", ()=>faMeh);
parcelHelpers.export(exports, "faMehBlank", ()=>faMehBlank);
parcelHelpers.export(exports, "faMehRollingEyes", ()=>faMehRollingEyes);
parcelHelpers.export(exports, "faMemory", ()=>faMemory);
parcelHelpers.export(exports, "faMenorah", ()=>faMenorah);
parcelHelpers.export(exports, "faMercury", ()=>faMercury);
parcelHelpers.export(exports, "faMeteor", ()=>faMeteor);
parcelHelpers.export(exports, "faMicrochip", ()=>faMicrochip);
parcelHelpers.export(exports, "faMicrophone", ()=>faMicrophone);
parcelHelpers.export(exports, "faMicrophoneAlt", ()=>faMicrophoneAlt);
parcelHelpers.export(exports, "faMicrophoneAltSlash", ()=>faMicrophoneAltSlash);
parcelHelpers.export(exports, "faMicrophoneSlash", ()=>faMicrophoneSlash);
parcelHelpers.export(exports, "faMicroscope", ()=>faMicroscope);
parcelHelpers.export(exports, "faMinus", ()=>faMinus);
parcelHelpers.export(exports, "faMinusCircle", ()=>faMinusCircle);
parcelHelpers.export(exports, "faMinusSquare", ()=>faMinusSquare);
parcelHelpers.export(exports, "faMitten", ()=>faMitten);
parcelHelpers.export(exports, "faMobile", ()=>faMobile);
parcelHelpers.export(exports, "faMobileAlt", ()=>faMobileAlt);
parcelHelpers.export(exports, "faMoneyBill", ()=>faMoneyBill);
parcelHelpers.export(exports, "faMoneyBillAlt", ()=>faMoneyBillAlt);
parcelHelpers.export(exports, "faMoneyBillWave", ()=>faMoneyBillWave);
parcelHelpers.export(exports, "faMoneyBillWaveAlt", ()=>faMoneyBillWaveAlt);
parcelHelpers.export(exports, "faMoneyCheck", ()=>faMoneyCheck);
parcelHelpers.export(exports, "faMoneyCheckAlt", ()=>faMoneyCheckAlt);
parcelHelpers.export(exports, "faMonument", ()=>faMonument);
parcelHelpers.export(exports, "faMoon", ()=>faMoon);
parcelHelpers.export(exports, "faMortarPestle", ()=>faMortarPestle);
parcelHelpers.export(exports, "faMosque", ()=>faMosque);
parcelHelpers.export(exports, "faMotorcycle", ()=>faMotorcycle);
parcelHelpers.export(exports, "faMountain", ()=>faMountain);
parcelHelpers.export(exports, "faMouse", ()=>faMouse);
parcelHelpers.export(exports, "faMousePointer", ()=>faMousePointer);
parcelHelpers.export(exports, "faMugHot", ()=>faMugHot);
parcelHelpers.export(exports, "faMusic", ()=>faMusic);
parcelHelpers.export(exports, "faNetworkWired", ()=>faNetworkWired);
parcelHelpers.export(exports, "faNeuter", ()=>faNeuter);
parcelHelpers.export(exports, "faNewspaper", ()=>faNewspaper);
parcelHelpers.export(exports, "faNotEqual", ()=>faNotEqual);
parcelHelpers.export(exports, "faNotesMedical", ()=>faNotesMedical);
parcelHelpers.export(exports, "faObjectGroup", ()=>faObjectGroup);
parcelHelpers.export(exports, "faObjectUngroup", ()=>faObjectUngroup);
parcelHelpers.export(exports, "faOilCan", ()=>faOilCan);
parcelHelpers.export(exports, "faOm", ()=>faOm);
parcelHelpers.export(exports, "faOtter", ()=>faOtter);
parcelHelpers.export(exports, "faOutdent", ()=>faOutdent);
parcelHelpers.export(exports, "faPager", ()=>faPager);
parcelHelpers.export(exports, "faPaintBrush", ()=>faPaintBrush);
parcelHelpers.export(exports, "faPaintRoller", ()=>faPaintRoller);
parcelHelpers.export(exports, "faPalette", ()=>faPalette);
parcelHelpers.export(exports, "faPallet", ()=>faPallet);
parcelHelpers.export(exports, "faPaperPlane", ()=>faPaperPlane);
parcelHelpers.export(exports, "faPaperclip", ()=>faPaperclip);
parcelHelpers.export(exports, "faParachuteBox", ()=>faParachuteBox);
parcelHelpers.export(exports, "faParagraph", ()=>faParagraph);
parcelHelpers.export(exports, "faParking", ()=>faParking);
parcelHelpers.export(exports, "faPassport", ()=>faPassport);
parcelHelpers.export(exports, "faPastafarianism", ()=>faPastafarianism);
parcelHelpers.export(exports, "faPaste", ()=>faPaste);
parcelHelpers.export(exports, "faPause", ()=>faPause);
parcelHelpers.export(exports, "faPauseCircle", ()=>faPauseCircle);
parcelHelpers.export(exports, "faPaw", ()=>faPaw);
parcelHelpers.export(exports, "faPeace", ()=>faPeace);
parcelHelpers.export(exports, "faPen", ()=>faPen);
parcelHelpers.export(exports, "faPenAlt", ()=>faPenAlt);
parcelHelpers.export(exports, "faPenFancy", ()=>faPenFancy);
parcelHelpers.export(exports, "faPenNib", ()=>faPenNib);
parcelHelpers.export(exports, "faPenSquare", ()=>faPenSquare);
parcelHelpers.export(exports, "faPencilAlt", ()=>faPencilAlt);
parcelHelpers.export(exports, "faPencilRuler", ()=>faPencilRuler);
parcelHelpers.export(exports, "faPeopleArrows", ()=>faPeopleArrows);
parcelHelpers.export(exports, "faPeopleCarry", ()=>faPeopleCarry);
parcelHelpers.export(exports, "faPepperHot", ()=>faPepperHot);
parcelHelpers.export(exports, "faPercent", ()=>faPercent);
parcelHelpers.export(exports, "faPercentage", ()=>faPercentage);
parcelHelpers.export(exports, "faPersonBooth", ()=>faPersonBooth);
parcelHelpers.export(exports, "faPhone", ()=>faPhone);
parcelHelpers.export(exports, "faPhoneAlt", ()=>faPhoneAlt);
parcelHelpers.export(exports, "faPhoneSlash", ()=>faPhoneSlash);
parcelHelpers.export(exports, "faPhoneSquare", ()=>faPhoneSquare);
parcelHelpers.export(exports, "faPhoneSquareAlt", ()=>faPhoneSquareAlt);
parcelHelpers.export(exports, "faPhoneVolume", ()=>faPhoneVolume);
parcelHelpers.export(exports, "faPhotoVideo", ()=>faPhotoVideo);
parcelHelpers.export(exports, "faPiggyBank", ()=>faPiggyBank);
parcelHelpers.export(exports, "faPills", ()=>faPills);
parcelHelpers.export(exports, "faPizzaSlice", ()=>faPizzaSlice);
parcelHelpers.export(exports, "faPlaceOfWorship", ()=>faPlaceOfWorship);
parcelHelpers.export(exports, "faPlane", ()=>faPlane);
parcelHelpers.export(exports, "faPlaneArrival", ()=>faPlaneArrival);
parcelHelpers.export(exports, "faPlaneDeparture", ()=>faPlaneDeparture);
parcelHelpers.export(exports, "faPlaneSlash", ()=>faPlaneSlash);
parcelHelpers.export(exports, "faPlay", ()=>faPlay);
parcelHelpers.export(exports, "faPlayCircle", ()=>faPlayCircle);
parcelHelpers.export(exports, "faPlug", ()=>faPlug);
parcelHelpers.export(exports, "faPlus", ()=>faPlus);
parcelHelpers.export(exports, "faPlusCircle", ()=>faPlusCircle);
parcelHelpers.export(exports, "faPlusSquare", ()=>faPlusSquare);
parcelHelpers.export(exports, "faPodcast", ()=>faPodcast);
parcelHelpers.export(exports, "faPoll", ()=>faPoll);
parcelHelpers.export(exports, "faPollH", ()=>faPollH);
parcelHelpers.export(exports, "faPoo", ()=>faPoo);
parcelHelpers.export(exports, "faPooStorm", ()=>faPooStorm);
parcelHelpers.export(exports, "faPoop", ()=>faPoop);
parcelHelpers.export(exports, "faPortrait", ()=>faPortrait);
parcelHelpers.export(exports, "faPoundSign", ()=>faPoundSign);
parcelHelpers.export(exports, "faPowerOff", ()=>faPowerOff);
parcelHelpers.export(exports, "faPray", ()=>faPray);
parcelHelpers.export(exports, "faPrayingHands", ()=>faPrayingHands);
parcelHelpers.export(exports, "faPrescription", ()=>faPrescription);
parcelHelpers.export(exports, "faPrescriptionBottle", ()=>faPrescriptionBottle);
parcelHelpers.export(exports, "faPrescriptionBottleAlt", ()=>faPrescriptionBottleAlt);
parcelHelpers.export(exports, "faPrint", ()=>faPrint);
parcelHelpers.export(exports, "faProcedures", ()=>faProcedures);
parcelHelpers.export(exports, "faProjectDiagram", ()=>faProjectDiagram);
parcelHelpers.export(exports, "faPumpMedical", ()=>faPumpMedical);
parcelHelpers.export(exports, "faPumpSoap", ()=>faPumpSoap);
parcelHelpers.export(exports, "faPuzzlePiece", ()=>faPuzzlePiece);
parcelHelpers.export(exports, "faQrcode", ()=>faQrcode);
parcelHelpers.export(exports, "faQuestion", ()=>faQuestion);
parcelHelpers.export(exports, "faQuestionCircle", ()=>faQuestionCircle);
parcelHelpers.export(exports, "faQuidditch", ()=>faQuidditch);
parcelHelpers.export(exports, "faQuoteLeft", ()=>faQuoteLeft);
parcelHelpers.export(exports, "faQuoteRight", ()=>faQuoteRight);
parcelHelpers.export(exports, "faQuran", ()=>faQuran);
parcelHelpers.export(exports, "faRadiation", ()=>faRadiation);
parcelHelpers.export(exports, "faRadiationAlt", ()=>faRadiationAlt);
parcelHelpers.export(exports, "faRainbow", ()=>faRainbow);
parcelHelpers.export(exports, "faRandom", ()=>faRandom);
parcelHelpers.export(exports, "faReceipt", ()=>faReceipt);
parcelHelpers.export(exports, "faRecordVinyl", ()=>faRecordVinyl);
parcelHelpers.export(exports, "faRecycle", ()=>faRecycle);
parcelHelpers.export(exports, "faRedo", ()=>faRedo);
parcelHelpers.export(exports, "faRedoAlt", ()=>faRedoAlt);
parcelHelpers.export(exports, "faRegistered", ()=>faRegistered);
parcelHelpers.export(exports, "faRemoveFormat", ()=>faRemoveFormat);
parcelHelpers.export(exports, "faReply", ()=>faReply);
parcelHelpers.export(exports, "faReplyAll", ()=>faReplyAll);
parcelHelpers.export(exports, "faRepublican", ()=>faRepublican);
parcelHelpers.export(exports, "faRestroom", ()=>faRestroom);
parcelHelpers.export(exports, "faRetweet", ()=>faRetweet);
parcelHelpers.export(exports, "faRibbon", ()=>faRibbon);
parcelHelpers.export(exports, "faRing", ()=>faRing);
parcelHelpers.export(exports, "faRoad", ()=>faRoad);
parcelHelpers.export(exports, "faRobot", ()=>faRobot);
parcelHelpers.export(exports, "faRocket", ()=>faRocket);
parcelHelpers.export(exports, "faRoute", ()=>faRoute);
parcelHelpers.export(exports, "faRss", ()=>faRss);
parcelHelpers.export(exports, "faRssSquare", ()=>faRssSquare);
parcelHelpers.export(exports, "faRubleSign", ()=>faRubleSign);
parcelHelpers.export(exports, "faRuler", ()=>faRuler);
parcelHelpers.export(exports, "faRulerCombined", ()=>faRulerCombined);
parcelHelpers.export(exports, "faRulerHorizontal", ()=>faRulerHorizontal);
parcelHelpers.export(exports, "faRulerVertical", ()=>faRulerVertical);
parcelHelpers.export(exports, "faRunning", ()=>faRunning);
parcelHelpers.export(exports, "faRupeeSign", ()=>faRupeeSign);
parcelHelpers.export(exports, "faSadCry", ()=>faSadCry);
parcelHelpers.export(exports, "faSadTear", ()=>faSadTear);
parcelHelpers.export(exports, "faSatellite", ()=>faSatellite);
parcelHelpers.export(exports, "faSatelliteDish", ()=>faSatelliteDish);
parcelHelpers.export(exports, "faSave", ()=>faSave);
parcelHelpers.export(exports, "faSchool", ()=>faSchool);
parcelHelpers.export(exports, "faScrewdriver", ()=>faScrewdriver);
parcelHelpers.export(exports, "faScroll", ()=>faScroll);
parcelHelpers.export(exports, "faSdCard", ()=>faSdCard);
parcelHelpers.export(exports, "faSearch", ()=>faSearch);
parcelHelpers.export(exports, "faSearchDollar", ()=>faSearchDollar);
parcelHelpers.export(exports, "faSearchLocation", ()=>faSearchLocation);
parcelHelpers.export(exports, "faSearchMinus", ()=>faSearchMinus);
parcelHelpers.export(exports, "faSearchPlus", ()=>faSearchPlus);
parcelHelpers.export(exports, "faSeedling", ()=>faSeedling);
parcelHelpers.export(exports, "faServer", ()=>faServer);
parcelHelpers.export(exports, "faShapes", ()=>faShapes);
parcelHelpers.export(exports, "faShare", ()=>faShare);
parcelHelpers.export(exports, "faShareAlt", ()=>faShareAlt);
parcelHelpers.export(exports, "faShareAltSquare", ()=>faShareAltSquare);
parcelHelpers.export(exports, "faShareSquare", ()=>faShareSquare);
parcelHelpers.export(exports, "faShekelSign", ()=>faShekelSign);
parcelHelpers.export(exports, "faShieldAlt", ()=>faShieldAlt);
parcelHelpers.export(exports, "faShieldVirus", ()=>faShieldVirus);
parcelHelpers.export(exports, "faShip", ()=>faShip);
parcelHelpers.export(exports, "faShippingFast", ()=>faShippingFast);
parcelHelpers.export(exports, "faShoePrints", ()=>faShoePrints);
parcelHelpers.export(exports, "faShoppingBag", ()=>faShoppingBag);
parcelHelpers.export(exports, "faShoppingBasket", ()=>faShoppingBasket);
parcelHelpers.export(exports, "faShoppingCart", ()=>faShoppingCart);
parcelHelpers.export(exports, "faShower", ()=>faShower);
parcelHelpers.export(exports, "faShuttleVan", ()=>faShuttleVan);
parcelHelpers.export(exports, "faSign", ()=>faSign);
parcelHelpers.export(exports, "faSignInAlt", ()=>faSignInAlt);
parcelHelpers.export(exports, "faSignLanguage", ()=>faSignLanguage);
parcelHelpers.export(exports, "faSignOutAlt", ()=>faSignOutAlt);
parcelHelpers.export(exports, "faSignal", ()=>faSignal);
parcelHelpers.export(exports, "faSignature", ()=>faSignature);
parcelHelpers.export(exports, "faSimCard", ()=>faSimCard);
parcelHelpers.export(exports, "faSink", ()=>faSink);
parcelHelpers.export(exports, "faSitemap", ()=>faSitemap);
parcelHelpers.export(exports, "faSkating", ()=>faSkating);
parcelHelpers.export(exports, "faSkiing", ()=>faSkiing);
parcelHelpers.export(exports, "faSkiingNordic", ()=>faSkiingNordic);
parcelHelpers.export(exports, "faSkull", ()=>faSkull);
parcelHelpers.export(exports, "faSkullCrossbones", ()=>faSkullCrossbones);
parcelHelpers.export(exports, "faSlash", ()=>faSlash);
parcelHelpers.export(exports, "faSleigh", ()=>faSleigh);
parcelHelpers.export(exports, "faSlidersH", ()=>faSlidersH);
parcelHelpers.export(exports, "faSmile", ()=>faSmile);
parcelHelpers.export(exports, "faSmileBeam", ()=>faSmileBeam);
parcelHelpers.export(exports, "faSmileWink", ()=>faSmileWink);
parcelHelpers.export(exports, "faSmog", ()=>faSmog);
parcelHelpers.export(exports, "faSmoking", ()=>faSmoking);
parcelHelpers.export(exports, "faSmokingBan", ()=>faSmokingBan);
parcelHelpers.export(exports, "faSms", ()=>faSms);
parcelHelpers.export(exports, "faSnowboarding", ()=>faSnowboarding);
parcelHelpers.export(exports, "faSnowflake", ()=>faSnowflake);
parcelHelpers.export(exports, "faSnowman", ()=>faSnowman);
parcelHelpers.export(exports, "faSnowplow", ()=>faSnowplow);
parcelHelpers.export(exports, "faSoap", ()=>faSoap);
parcelHelpers.export(exports, "faSocks", ()=>faSocks);
parcelHelpers.export(exports, "faSolarPanel", ()=>faSolarPanel);
parcelHelpers.export(exports, "faSort", ()=>faSort);
parcelHelpers.export(exports, "faSortAlphaDown", ()=>faSortAlphaDown);
parcelHelpers.export(exports, "faSortAlphaDownAlt", ()=>faSortAlphaDownAlt);
parcelHelpers.export(exports, "faSortAlphaUp", ()=>faSortAlphaUp);
parcelHelpers.export(exports, "faSortAlphaUpAlt", ()=>faSortAlphaUpAlt);
parcelHelpers.export(exports, "faSortAmountDown", ()=>faSortAmountDown);
parcelHelpers.export(exports, "faSortAmountDownAlt", ()=>faSortAmountDownAlt);
parcelHelpers.export(exports, "faSortAmountUp", ()=>faSortAmountUp);
parcelHelpers.export(exports, "faSortAmountUpAlt", ()=>faSortAmountUpAlt);
parcelHelpers.export(exports, "faSortDown", ()=>faSortDown);
parcelHelpers.export(exports, "faSortNumericDown", ()=>faSortNumericDown);
parcelHelpers.export(exports, "faSortNumericDownAlt", ()=>faSortNumericDownAlt);
parcelHelpers.export(exports, "faSortNumericUp", ()=>faSortNumericUp);
parcelHelpers.export(exports, "faSortNumericUpAlt", ()=>faSortNumericUpAlt);
parcelHelpers.export(exports, "faSortUp", ()=>faSortUp);
parcelHelpers.export(exports, "faSpa", ()=>faSpa);
parcelHelpers.export(exports, "faSpaceShuttle", ()=>faSpaceShuttle);
parcelHelpers.export(exports, "faSpellCheck", ()=>faSpellCheck);
parcelHelpers.export(exports, "faSpider", ()=>faSpider);
parcelHelpers.export(exports, "faSpinner", ()=>faSpinner);
parcelHelpers.export(exports, "faSplotch", ()=>faSplotch);
parcelHelpers.export(exports, "faSprayCan", ()=>faSprayCan);
parcelHelpers.export(exports, "faSquare", ()=>faSquare);
parcelHelpers.export(exports, "faSquareFull", ()=>faSquareFull);
parcelHelpers.export(exports, "faSquareRootAlt", ()=>faSquareRootAlt);
parcelHelpers.export(exports, "faStamp", ()=>faStamp);
parcelHelpers.export(exports, "faStar", ()=>faStar);
parcelHelpers.export(exports, "faStarAndCrescent", ()=>faStarAndCrescent);
parcelHelpers.export(exports, "faStarHalf", ()=>faStarHalf);
parcelHelpers.export(exports, "faStarHalfAlt", ()=>faStarHalfAlt);
parcelHelpers.export(exports, "faStarOfDavid", ()=>faStarOfDavid);
parcelHelpers.export(exports, "faStarOfLife", ()=>faStarOfLife);
parcelHelpers.export(exports, "faStepBackward", ()=>faStepBackward);
parcelHelpers.export(exports, "faStepForward", ()=>faStepForward);
parcelHelpers.export(exports, "faStethoscope", ()=>faStethoscope);
parcelHelpers.export(exports, "faStickyNote", ()=>faStickyNote);
parcelHelpers.export(exports, "faStop", ()=>faStop);
parcelHelpers.export(exports, "faStopCircle", ()=>faStopCircle);
parcelHelpers.export(exports, "faStopwatch", ()=>faStopwatch);
parcelHelpers.export(exports, "faStopwatch20", ()=>faStopwatch20);
parcelHelpers.export(exports, "faStore", ()=>faStore);
parcelHelpers.export(exports, "faStoreAlt", ()=>faStoreAlt);
parcelHelpers.export(exports, "faStoreAltSlash", ()=>faStoreAltSlash);
parcelHelpers.export(exports, "faStoreSlash", ()=>faStoreSlash);
parcelHelpers.export(exports, "faStream", ()=>faStream);
parcelHelpers.export(exports, "faStreetView", ()=>faStreetView);
parcelHelpers.export(exports, "faStrikethrough", ()=>faStrikethrough);
parcelHelpers.export(exports, "faStroopwafel", ()=>faStroopwafel);
parcelHelpers.export(exports, "faSubscript", ()=>faSubscript);
parcelHelpers.export(exports, "faSubway", ()=>faSubway);
parcelHelpers.export(exports, "faSuitcase", ()=>faSuitcase);
parcelHelpers.export(exports, "faSuitcaseRolling", ()=>faSuitcaseRolling);
parcelHelpers.export(exports, "faSun", ()=>faSun);
parcelHelpers.export(exports, "faSuperscript", ()=>faSuperscript);
parcelHelpers.export(exports, "faSurprise", ()=>faSurprise);
parcelHelpers.export(exports, "faSwatchbook", ()=>faSwatchbook);
parcelHelpers.export(exports, "faSwimmer", ()=>faSwimmer);
parcelHelpers.export(exports, "faSwimmingPool", ()=>faSwimmingPool);
parcelHelpers.export(exports, "faSynagogue", ()=>faSynagogue);
parcelHelpers.export(exports, "faSync", ()=>faSync);
parcelHelpers.export(exports, "faSyncAlt", ()=>faSyncAlt);
parcelHelpers.export(exports, "faSyringe", ()=>faSyringe);
parcelHelpers.export(exports, "faTable", ()=>faTable);
parcelHelpers.export(exports, "faTableTennis", ()=>faTableTennis);
parcelHelpers.export(exports, "faTablet", ()=>faTablet);
parcelHelpers.export(exports, "faTabletAlt", ()=>faTabletAlt);
parcelHelpers.export(exports, "faTablets", ()=>faTablets);
parcelHelpers.export(exports, "faTachometerAlt", ()=>faTachometerAlt);
parcelHelpers.export(exports, "faTag", ()=>faTag);
parcelHelpers.export(exports, "faTags", ()=>faTags);
parcelHelpers.export(exports, "faTape", ()=>faTape);
parcelHelpers.export(exports, "faTasks", ()=>faTasks);
parcelHelpers.export(exports, "faTaxi", ()=>faTaxi);
parcelHelpers.export(exports, "faTeeth", ()=>faTeeth);
parcelHelpers.export(exports, "faTeethOpen", ()=>faTeethOpen);
parcelHelpers.export(exports, "faTemperatureHigh", ()=>faTemperatureHigh);
parcelHelpers.export(exports, "faTemperatureLow", ()=>faTemperatureLow);
parcelHelpers.export(exports, "faTenge", ()=>faTenge);
parcelHelpers.export(exports, "faTerminal", ()=>faTerminal);
parcelHelpers.export(exports, "faTextHeight", ()=>faTextHeight);
parcelHelpers.export(exports, "faTextWidth", ()=>faTextWidth);
parcelHelpers.export(exports, "faTh", ()=>faTh);
parcelHelpers.export(exports, "faThLarge", ()=>faThLarge);
parcelHelpers.export(exports, "faThList", ()=>faThList);
parcelHelpers.export(exports, "faTheaterMasks", ()=>faTheaterMasks);
parcelHelpers.export(exports, "faThermometer", ()=>faThermometer);
parcelHelpers.export(exports, "faThermometerEmpty", ()=>faThermometerEmpty);
parcelHelpers.export(exports, "faThermometerFull", ()=>faThermometerFull);
parcelHelpers.export(exports, "faThermometerHalf", ()=>faThermometerHalf);
parcelHelpers.export(exports, "faThermometerQuarter", ()=>faThermometerQuarter);
parcelHelpers.export(exports, "faThermometerThreeQuarters", ()=>faThermometerThreeQuarters);
parcelHelpers.export(exports, "faThumbsDown", ()=>faThumbsDown);
parcelHelpers.export(exports, "faThumbsUp", ()=>faThumbsUp);
parcelHelpers.export(exports, "faThumbtack", ()=>faThumbtack);
parcelHelpers.export(exports, "faTicketAlt", ()=>faTicketAlt);
parcelHelpers.export(exports, "faTimes", ()=>faTimes);
parcelHelpers.export(exports, "faTimesCircle", ()=>faTimesCircle);
parcelHelpers.export(exports, "faTint", ()=>faTint);
parcelHelpers.export(exports, "faTintSlash", ()=>faTintSlash);
parcelHelpers.export(exports, "faTired", ()=>faTired);
parcelHelpers.export(exports, "faToggleOff", ()=>faToggleOff);
parcelHelpers.export(exports, "faToggleOn", ()=>faToggleOn);
parcelHelpers.export(exports, "faToilet", ()=>faToilet);
parcelHelpers.export(exports, "faToiletPaper", ()=>faToiletPaper);
parcelHelpers.export(exports, "faToiletPaperSlash", ()=>faToiletPaperSlash);
parcelHelpers.export(exports, "faToolbox", ()=>faToolbox);
parcelHelpers.export(exports, "faTools", ()=>faTools);
parcelHelpers.export(exports, "faTooth", ()=>faTooth);
parcelHelpers.export(exports, "faTorah", ()=>faTorah);
parcelHelpers.export(exports, "faToriiGate", ()=>faToriiGate);
parcelHelpers.export(exports, "faTractor", ()=>faTractor);
parcelHelpers.export(exports, "faTrademark", ()=>faTrademark);
parcelHelpers.export(exports, "faTrafficLight", ()=>faTrafficLight);
parcelHelpers.export(exports, "faTrailer", ()=>faTrailer);
parcelHelpers.export(exports, "faTrain", ()=>faTrain);
parcelHelpers.export(exports, "faTram", ()=>faTram);
parcelHelpers.export(exports, "faTransgender", ()=>faTransgender);
parcelHelpers.export(exports, "faTransgenderAlt", ()=>faTransgenderAlt);
parcelHelpers.export(exports, "faTrash", ()=>faTrash);
parcelHelpers.export(exports, "faTrashAlt", ()=>faTrashAlt);
parcelHelpers.export(exports, "faTrashRestore", ()=>faTrashRestore);
parcelHelpers.export(exports, "faTrashRestoreAlt", ()=>faTrashRestoreAlt);
parcelHelpers.export(exports, "faTree", ()=>faTree);
parcelHelpers.export(exports, "faTrophy", ()=>faTrophy);
parcelHelpers.export(exports, "faTruck", ()=>faTruck);
parcelHelpers.export(exports, "faTruckLoading", ()=>faTruckLoading);
parcelHelpers.export(exports, "faTruckMonster", ()=>faTruckMonster);
parcelHelpers.export(exports, "faTruckMoving", ()=>faTruckMoving);
parcelHelpers.export(exports, "faTruckPickup", ()=>faTruckPickup);
parcelHelpers.export(exports, "faTshirt", ()=>faTshirt);
parcelHelpers.export(exports, "faTty", ()=>faTty);
parcelHelpers.export(exports, "faTv", ()=>faTv);
parcelHelpers.export(exports, "faUmbrella", ()=>faUmbrella);
parcelHelpers.export(exports, "faUmbrellaBeach", ()=>faUmbrellaBeach);
parcelHelpers.export(exports, "faUnderline", ()=>faUnderline);
parcelHelpers.export(exports, "faUndo", ()=>faUndo);
parcelHelpers.export(exports, "faUndoAlt", ()=>faUndoAlt);
parcelHelpers.export(exports, "faUniversalAccess", ()=>faUniversalAccess);
parcelHelpers.export(exports, "faUniversity", ()=>faUniversity);
parcelHelpers.export(exports, "faUnlink", ()=>faUnlink);
parcelHelpers.export(exports, "faUnlock", ()=>faUnlock);
parcelHelpers.export(exports, "faUnlockAlt", ()=>faUnlockAlt);
parcelHelpers.export(exports, "faUpload", ()=>faUpload);
parcelHelpers.export(exports, "faUser", ()=>faUser);
parcelHelpers.export(exports, "faUserAlt", ()=>faUserAlt);
parcelHelpers.export(exports, "faUserAltSlash", ()=>faUserAltSlash);
parcelHelpers.export(exports, "faUserAstronaut", ()=>faUserAstronaut);
parcelHelpers.export(exports, "faUserCheck", ()=>faUserCheck);
parcelHelpers.export(exports, "faUserCircle", ()=>faUserCircle);
parcelHelpers.export(exports, "faUserClock", ()=>faUserClock);
parcelHelpers.export(exports, "faUserCog", ()=>faUserCog);
parcelHelpers.export(exports, "faUserEdit", ()=>faUserEdit);
parcelHelpers.export(exports, "faUserFriends", ()=>faUserFriends);
parcelHelpers.export(exports, "faUserGraduate", ()=>faUserGraduate);
parcelHelpers.export(exports, "faUserInjured", ()=>faUserInjured);
parcelHelpers.export(exports, "faUserLock", ()=>faUserLock);
parcelHelpers.export(exports, "faUserMd", ()=>faUserMd);
parcelHelpers.export(exports, "faUserMinus", ()=>faUserMinus);
parcelHelpers.export(exports, "faUserNinja", ()=>faUserNinja);
parcelHelpers.export(exports, "faUserNurse", ()=>faUserNurse);
parcelHelpers.export(exports, "faUserPlus", ()=>faUserPlus);
parcelHelpers.export(exports, "faUserSecret", ()=>faUserSecret);
parcelHelpers.export(exports, "faUserShield", ()=>faUserShield);
parcelHelpers.export(exports, "faUserSlash", ()=>faUserSlash);
parcelHelpers.export(exports, "faUserTag", ()=>faUserTag);
parcelHelpers.export(exports, "faUserTie", ()=>faUserTie);
parcelHelpers.export(exports, "faUserTimes", ()=>faUserTimes);
parcelHelpers.export(exports, "faUsers", ()=>faUsers);
parcelHelpers.export(exports, "faUsersCog", ()=>faUsersCog);
parcelHelpers.export(exports, "faUsersSlash", ()=>faUsersSlash);
parcelHelpers.export(exports, "faUtensilSpoon", ()=>faUtensilSpoon);
parcelHelpers.export(exports, "faUtensils", ()=>faUtensils);
parcelHelpers.export(exports, "faVectorSquare", ()=>faVectorSquare);
parcelHelpers.export(exports, "faVenus", ()=>faVenus);
parcelHelpers.export(exports, "faVenusDouble", ()=>faVenusDouble);
parcelHelpers.export(exports, "faVenusMars", ()=>faVenusMars);
parcelHelpers.export(exports, "faVest", ()=>faVest);
parcelHelpers.export(exports, "faVestPatches", ()=>faVestPatches);
parcelHelpers.export(exports, "faVial", ()=>faVial);
parcelHelpers.export(exports, "faVials", ()=>faVials);
parcelHelpers.export(exports, "faVideo", ()=>faVideo);
parcelHelpers.export(exports, "faVideoSlash", ()=>faVideoSlash);
parcelHelpers.export(exports, "faVihara", ()=>faVihara);
parcelHelpers.export(exports, "faVirus", ()=>faVirus);
parcelHelpers.export(exports, "faVirusSlash", ()=>faVirusSlash);
parcelHelpers.export(exports, "faViruses", ()=>faViruses);
parcelHelpers.export(exports, "faVoicemail", ()=>faVoicemail);
parcelHelpers.export(exports, "faVolleyballBall", ()=>faVolleyballBall);
parcelHelpers.export(exports, "faVolumeDown", ()=>faVolumeDown);
parcelHelpers.export(exports, "faVolumeMute", ()=>faVolumeMute);
parcelHelpers.export(exports, "faVolumeOff", ()=>faVolumeOff);
parcelHelpers.export(exports, "faVolumeUp", ()=>faVolumeUp);
parcelHelpers.export(exports, "faVoteYea", ()=>faVoteYea);
parcelHelpers.export(exports, "faVrCardboard", ()=>faVrCardboard);
parcelHelpers.export(exports, "faWalking", ()=>faWalking);
parcelHelpers.export(exports, "faWallet", ()=>faWallet);
parcelHelpers.export(exports, "faWarehouse", ()=>faWarehouse);
parcelHelpers.export(exports, "faWater", ()=>faWater);
parcelHelpers.export(exports, "faWaveSquare", ()=>faWaveSquare);
parcelHelpers.export(exports, "faWeight", ()=>faWeight);
parcelHelpers.export(exports, "faWeightHanging", ()=>faWeightHanging);
parcelHelpers.export(exports, "faWheelchair", ()=>faWheelchair);
parcelHelpers.export(exports, "faWifi", ()=>faWifi);
parcelHelpers.export(exports, "faWind", ()=>faWind);
parcelHelpers.export(exports, "faWindowClose", ()=>faWindowClose);
parcelHelpers.export(exports, "faWindowMaximize", ()=>faWindowMaximize);
parcelHelpers.export(exports, "faWindowMinimize", ()=>faWindowMinimize);
parcelHelpers.export(exports, "faWindowRestore", ()=>faWindowRestore);
parcelHelpers.export(exports, "faWineBottle", ()=>faWineBottle);
parcelHelpers.export(exports, "faWineGlass", ()=>faWineGlass);
parcelHelpers.export(exports, "faWineGlassAlt", ()=>faWineGlassAlt);
parcelHelpers.export(exports, "faWonSign", ()=>faWonSign);
parcelHelpers.export(exports, "faWrench", ()=>faWrench);
parcelHelpers.export(exports, "faXRay", ()=>faXRay);
parcelHelpers.export(exports, "faYenSign", ()=>faYenSign);
parcelHelpers.export(exports, "faYinYang", ()=>faYinYang);
var prefix = "fas";
var faAd = {
    prefix: 'fas',
    iconName: 'ad',
    icon: [
        512,
        512,
        [],
        "f641",
        "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
    ]
};
var faAddressBook = {
    prefix: 'fas',
    iconName: 'address-book',
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var faAddressCard = {
    prefix: 'fas',
    iconName: 'address-card',
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var faAdjust = {
    prefix: 'fas',
    iconName: 'adjust',
    icon: [
        512,
        512,
        [],
        "f042",
        "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
    ]
};
var faAirFreshener = {
    prefix: 'fas',
    iconName: 'air-freshener',
    icon: [
        512,
        512,
        [],
        "f5d0",
        "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
    ]
};
var faAlignCenter = {
    prefix: 'fas',
    iconName: 'align-center',
    icon: [
        448,
        512,
        [],
        "f037",
        "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
    ]
};
var faAlignJustify = {
    prefix: 'fas',
    iconName: 'align-justify',
    icon: [
        448,
        512,
        [],
        "f039",
        "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faAlignLeft = {
    prefix: 'fas',
    iconName: 'align-left',
    icon: [
        448,
        512,
        [],
        "f036",
        "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faAlignRight = {
    prefix: 'fas',
    iconName: 'align-right',
    icon: [
        448,
        512,
        [],
        "f038",
        "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
    ]
};
var faAllergies = {
    prefix: 'fas',
    iconName: 'allergies',
    icon: [
        448,
        512,
        [],
        "f461",
        "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faAmbulance = {
    prefix: 'fas',
    iconName: 'ambulance',
    icon: [
        640,
        512,
        [],
        "f0f9",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var faAmericanSignLanguageInterpreting = {
    prefix: 'fas',
    iconName: 'american-sign-language-interpreting',
    icon: [
        640,
        512,
        [],
        "f2a3",
        "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
    ]
};
var faAnchor = {
    prefix: 'fas',
    iconName: 'anchor',
    icon: [
        576,
        512,
        [],
        "f13d",
        "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
    ]
};
var faAngleDoubleDown = {
    prefix: 'fas',
    iconName: 'angle-double-down',
    icon: [
        320,
        512,
        [],
        "f103",
        "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
    ]
};
var faAngleDoubleLeft = {
    prefix: 'fas',
    iconName: 'angle-double-left',
    icon: [
        448,
        512,
        [],
        "f100",
        "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
    ]
};
var faAngleDoubleRight = {
    prefix: 'fas',
    iconName: 'angle-double-right',
    icon: [
        448,
        512,
        [],
        "f101",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
    ]
};
var faAngleDoubleUp = {
    prefix: 'fas',
    iconName: 'angle-double-up',
    icon: [
        320,
        512,
        [],
        "f102",
        "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
    ]
};
var faAngleDown = {
    prefix: 'fas',
    iconName: 'angle-down',
    icon: [
        320,
        512,
        [],
        "f107",
        "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
    ]
};
var faAngleLeft = {
    prefix: 'fas',
    iconName: 'angle-left',
    icon: [
        256,
        512,
        [],
        "f104",
        "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
    ]
};
var faAngleRight = {
    prefix: 'fas',
    iconName: 'angle-right',
    icon: [
        256,
        512,
        [],
        "f105",
        "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
    ]
};
var faAngleUp = {
    prefix: 'fas',
    iconName: 'angle-up',
    icon: [
        320,
        512,
        [],
        "f106",
        "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
    ]
};
var faAngry = {
    prefix: 'fas',
    iconName: 'angry',
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
    ]
};
var faAnkh = {
    prefix: 'fas',
    iconName: 'ankh',
    icon: [
        320,
        512,
        [],
        "f644",
        "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
    ]
};
var faAppleAlt = {
    prefix: 'fas',
    iconName: 'apple-alt',
    icon: [
        448,
        512,
        [],
        "f5d1",
        "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
    ]
};
var faArchive = {
    prefix: 'fas',
    iconName: 'archive',
    icon: [
        512,
        512,
        [],
        "f187",
        "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
    ]
};
var faArchway = {
    prefix: 'fas',
    iconName: 'archway',
    icon: [
        576,
        512,
        [],
        "f557",
        "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var faArrowAltCircleDown = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-down',
    icon: [
        512,
        512,
        [],
        "f358",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
    ]
};
var faArrowAltCircleLeft = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-left',
    icon: [
        512,
        512,
        [],
        "f359",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
    ]
};
var faArrowAltCircleRight = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-right',
    icon: [
        512,
        512,
        [],
        "f35a",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
    ]
};
var faArrowAltCircleUp = {
    prefix: 'fas',
    iconName: 'arrow-alt-circle-up',
    icon: [
        512,
        512,
        [],
        "f35b",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
    ]
};
var faArrowCircleDown = {
    prefix: 'fas',
    iconName: 'arrow-circle-down',
    icon: [
        512,
        512,
        [],
        "f0ab",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
    ]
};
var faArrowCircleLeft = {
    prefix: 'fas',
    iconName: 'arrow-circle-left',
    icon: [
        512,
        512,
        [],
        "f0a8",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
    ]
};
var faArrowCircleRight = {
    prefix: 'fas',
    iconName: 'arrow-circle-right',
    icon: [
        512,
        512,
        [],
        "f0a9",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
    ]
};
var faArrowCircleUp = {
    prefix: 'fas',
    iconName: 'arrow-circle-up',
    icon: [
        512,
        512,
        [],
        "f0aa",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
    ]
};
var faArrowDown = {
    prefix: 'fas',
    iconName: 'arrow-down',
    icon: [
        448,
        512,
        [],
        "f063",
        "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
    ]
};
var faArrowLeft = {
    prefix: 'fas',
    iconName: 'arrow-left',
    icon: [
        448,
        512,
        [],
        "f060",
        "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
    ]
};
var faArrowRight = {
    prefix: 'fas',
    iconName: 'arrow-right',
    icon: [
        448,
        512,
        [],
        "f061",
        "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
    ]
};
var faArrowUp = {
    prefix: 'fas',
    iconName: 'arrow-up',
    icon: [
        448,
        512,
        [],
        "f062",
        "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
    ]
};
var faArrowsAlt = {
    prefix: 'fas',
    iconName: 'arrows-alt',
    icon: [
        512,
        512,
        [],
        "f0b2",
        "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
    ]
};
var faArrowsAltH = {
    prefix: 'fas',
    iconName: 'arrows-alt-h',
    icon: [
        512,
        512,
        [],
        "f337",
        "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
    ]
};
var faArrowsAltV = {
    prefix: 'fas',
    iconName: 'arrows-alt-v',
    icon: [
        256,
        512,
        [],
        "f338",
        "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
    ]
};
var faAssistiveListeningSystems = {
    prefix: 'fas',
    iconName: 'assistive-listening-systems',
    icon: [
        512,
        512,
        [],
        "f2a2",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
    ]
};
var faAsterisk = {
    prefix: 'fas',
    iconName: 'asterisk',
    icon: [
        512,
        512,
        [],
        "f069",
        "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
    ]
};
var faAt = {
    prefix: 'fas',
    iconName: 'at',
    icon: [
        512,
        512,
        [],
        "f1fa",
        "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
    ]
};
var faAtlas = {
    prefix: 'fas',
    iconName: 'atlas',
    icon: [
        448,
        512,
        [],
        "f558",
        "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
    ]
};
var faAtom = {
    prefix: 'fas',
    iconName: 'atom',
    icon: [
        448,
        512,
        [],
        "f5d2",
        "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
    ]
};
var faAudioDescription = {
    prefix: 'fas',
    iconName: 'audio-description',
    icon: [
        512,
        512,
        [],
        "f29e",
        "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
    ]
};
var faAward = {
    prefix: 'fas',
    iconName: 'award',
    icon: [
        384,
        512,
        [],
        "f559",
        "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
    ]
};
var faBaby = {
    prefix: 'fas',
    iconName: 'baby',
    icon: [
        384,
        512,
        [],
        "f77c",
        "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
    ]
};
var faBabyCarriage = {
    prefix: 'fas',
    iconName: 'baby-carriage',
    icon: [
        512,
        512,
        [],
        "f77d",
        "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
    ]
};
var faBackspace = {
    prefix: 'fas',
    iconName: 'backspace',
    icon: [
        640,
        512,
        [],
        "f55a",
        "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
    ]
};
var faBackward = {
    prefix: 'fas',
    iconName: 'backward',
    icon: [
        512,
        512,
        [],
        "f04a",
        "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
    ]
};
var faBacon = {
    prefix: 'fas',
    iconName: 'bacon',
    icon: [
        576,
        512,
        [],
        "f7e5",
        "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
    ]
};
var faBacteria = {
    prefix: 'fas',
    iconName: 'bacteria',
    icon: [
        640,
        512,
        [],
        "e059",
        "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
    ]
};
var faBacterium = {
    prefix: 'fas',
    iconName: 'bacterium',
    icon: [
        512,
        512,
        [],
        "e05a",
        "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
    ]
};
var faBahai = {
    prefix: 'fas',
    iconName: 'bahai',
    icon: [
        512,
        512,
        [],
        "f666",
        "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
    ]
};
var faBalanceScale = {
    prefix: 'fas',
    iconName: 'balance-scale',
    icon: [
        640,
        512,
        [],
        "f24e",
        "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faBalanceScaleLeft = {
    prefix: 'fas',
    iconName: 'balance-scale-left',
    icon: [
        640,
        512,
        [],
        "f515",
        "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
    ]
};
var faBalanceScaleRight = {
    prefix: 'fas',
    iconName: 'balance-scale-right',
    icon: [
        640,
        512,
        [],
        "f516",
        "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
    ]
};
var faBan = {
    prefix: 'fas',
    iconName: 'ban',
    icon: [
        512,
        512,
        [],
        "f05e",
        "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
    ]
};
var faBandAid = {
    prefix: 'fas',
    iconName: 'band-aid',
    icon: [
        640,
        512,
        [],
        "f462",
        "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
    ]
};
var faBarcode = {
    prefix: 'fas',
    iconName: 'barcode',
    icon: [
        512,
        512,
        [],
        "f02a",
        "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
    ]
};
var faBars = {
    prefix: 'fas',
    iconName: 'bars',
    icon: [
        448,
        512,
        [],
        "f0c9",
        "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
    ]
};
var faBaseballBall = {
    prefix: 'fas',
    iconName: 'baseball-ball',
    icon: [
        496,
        512,
        [],
        "f433",
        "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
    ]
};
var faBasketballBall = {
    prefix: 'fas',
    iconName: 'basketball-ball',
    icon: [
        496,
        512,
        [],
        "f434",
        "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
    ]
};
var faBath = {
    prefix: 'fas',
    iconName: 'bath',
    icon: [
        512,
        512,
        [],
        "f2cd",
        "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
    ]
};
var faBatteryEmpty = {
    prefix: 'fas',
    iconName: 'battery-empty',
    icon: [
        640,
        512,
        [],
        "f244",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
    ]
};
var faBatteryFull = {
    prefix: 'fas',
    iconName: 'battery-full',
    icon: [
        640,
        512,
        [],
        "f240",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
    ]
};
var faBatteryHalf = {
    prefix: 'fas',
    iconName: 'battery-half',
    icon: [
        640,
        512,
        [],
        "f242",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
    ]
};
var faBatteryQuarter = {
    prefix: 'fas',
    iconName: 'battery-quarter',
    icon: [
        640,
        512,
        [],
        "f243",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
    ]
};
var faBatteryThreeQuarters = {
    prefix: 'fas',
    iconName: 'battery-three-quarters',
    icon: [
        640,
        512,
        [],
        "f241",
        "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
    ]
};
var faBed = {
    prefix: 'fas',
    iconName: 'bed',
    icon: [
        640,
        512,
        [],
        "f236",
        "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
    ]
};
var faBeer = {
    prefix: 'fas',
    iconName: 'beer',
    icon: [
        448,
        512,
        [],
        "f0fc",
        "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
    ]
};
var faBell = {
    prefix: 'fas',
    iconName: 'bell',
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
    ]
};
var faBellSlash = {
    prefix: 'fas',
    iconName: 'bell-slash',
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var faBezierCurve = {
    prefix: 'fas',
    iconName: 'bezier-curve',
    icon: [
        640,
        512,
        [],
        "f55b",
        "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var faBible = {
    prefix: 'fas',
    iconName: 'bible',
    icon: [
        448,
        512,
        [],
        "f647",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var faBicycle = {
    prefix: 'fas',
    iconName: 'bicycle',
    icon: [
        640,
        512,
        [],
        "f206",
        "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
    ]
};
var faBiking = {
    prefix: 'fas',
    iconName: 'biking',
    icon: [
        640,
        512,
        [],
        "f84a",
        "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
    ]
};
var faBinoculars = {
    prefix: 'fas',
    iconName: 'binoculars',
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
    ]
};
var faBiohazard = {
    prefix: 'fas',
    iconName: 'biohazard',
    icon: [
        576,
        512,
        [],
        "f780",
        "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var faBirthdayCake = {
    prefix: 'fas',
    iconName: 'birthday-cake',
    icon: [
        448,
        512,
        [],
        "f1fd",
        "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
    ]
};
var faBlender = {
    prefix: 'fas',
    iconName: 'blender',
    icon: [
        512,
        512,
        [],
        "f517",
        "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
    ]
};
var faBlenderPhone = {
    prefix: 'fas',
    iconName: 'blender-phone',
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faBlind = {
    prefix: 'fas',
    iconName: 'blind',
    icon: [
        384,
        512,
        [],
        "f29d",
        "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
    ]
};
var faBlog = {
    prefix: 'fas',
    iconName: 'blog',
    icon: [
        512,
        512,
        [],
        "f781",
        "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
    ]
};
var faBold = {
    prefix: 'fas',
    iconName: 'bold',
    icon: [
        384,
        512,
        [],
        "f032",
        "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
    ]
};
var faBolt = {
    prefix: 'fas',
    iconName: 'bolt',
    icon: [
        320,
        512,
        [],
        "f0e7",
        "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
    ]
};
var faBomb = {
    prefix: 'fas',
    iconName: 'bomb',
    icon: [
        512,
        512,
        [],
        "f1e2",
        "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
    ]
};
var faBone = {
    prefix: 'fas',
    iconName: 'bone',
    icon: [
        640,
        512,
        [],
        "f5d7",
        "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
    ]
};
var faBong = {
    prefix: 'fas',
    iconName: 'bong',
    icon: [
        448,
        512,
        [],
        "f55c",
        "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
    ]
};
var faBook = {
    prefix: 'fas',
    iconName: 'book',
    icon: [
        448,
        512,
        [],
        "f02d",
        "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
    ]
};
var faBookDead = {
    prefix: 'fas',
    iconName: 'book-dead',
    icon: [
        448,
        512,
        [],
        "f6b7",
        "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
    ]
};
var faBookMedical = {
    prefix: 'fas',
    iconName: 'book-medical',
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
    ]
};
var faBookOpen = {
    prefix: 'fas',
    iconName: 'book-open',
    icon: [
        576,
        512,
        [],
        "f518",
        "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
    ]
};
var faBookReader = {
    prefix: 'fas',
    iconName: 'book-reader',
    icon: [
        512,
        512,
        [],
        "f5da",
        "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
    ]
};
var faBookmark = {
    prefix: 'fas',
    iconName: 'bookmark',
    icon: [
        384,
        512,
        [],
        "f02e",
        "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
    ]
};
var faBorderAll = {
    prefix: 'fas',
    iconName: 'border-all',
    icon: [
        448,
        512,
        [],
        "f84c",
        "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
    ]
};
var faBorderNone = {
    prefix: 'fas',
    iconName: 'border-none',
    icon: [
        448,
        512,
        [],
        "f850",
        "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faBorderStyle = {
    prefix: 'fas',
    iconName: 'border-style',
    icon: [
        448,
        512,
        [],
        "f853",
        "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faBowlingBall = {
    prefix: 'fas',
    iconName: 'bowling-ball',
    icon: [
        496,
        512,
        [],
        "f436",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faBox = {
    prefix: 'fas',
    iconName: 'box',
    icon: [
        512,
        512,
        [],
        "f466",
        "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
    ]
};
var faBoxOpen = {
    prefix: 'fas',
    iconName: 'box-open',
    icon: [
        640,
        512,
        [],
        "f49e",
        "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
    ]
};
var faBoxTissue = {
    prefix: 'fas',
    iconName: 'box-tissue',
    icon: [
        512,
        512,
        [],
        "e05b",
        "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
    ]
};
var faBoxes = {
    prefix: 'fas',
    iconName: 'boxes',
    icon: [
        576,
        512,
        [],
        "f468",
        "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
    ]
};
var faBraille = {
    prefix: 'fas',
    iconName: 'braille',
    icon: [
        640,
        512,
        [],
        "f2a1",
        "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var faBrain = {
    prefix: 'fas',
    iconName: 'brain',
    icon: [
        576,
        512,
        [],
        "f5dc",
        "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
    ]
};
var faBreadSlice = {
    prefix: 'fas',
    iconName: 'bread-slice',
    icon: [
        576,
        512,
        [],
        "f7ec",
        "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
    ]
};
var faBriefcase = {
    prefix: 'fas',
    iconName: 'briefcase',
    icon: [
        512,
        512,
        [],
        "f0b1",
        "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
    ]
};
var faBriefcaseMedical = {
    prefix: 'fas',
    iconName: 'briefcase-medical',
    icon: [
        512,
        512,
        [],
        "f469",
        "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
    ]
};
var faBroadcastTower = {
    prefix: 'fas',
    iconName: 'broadcast-tower',
    icon: [
        640,
        512,
        [],
        "f519",
        "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
    ]
};
var faBroom = {
    prefix: 'fas',
    iconName: 'broom',
    icon: [
        640,
        512,
        [],
        "f51a",
        "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
    ]
};
var faBrush = {
    prefix: 'fas',
    iconName: 'brush',
    icon: [
        384,
        512,
        [],
        "f55d",
        "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
    ]
};
var faBug = {
    prefix: 'fas',
    iconName: 'bug',
    icon: [
        512,
        512,
        [],
        "f188",
        "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
    ]
};
var faBuilding = {
    prefix: 'fas',
    iconName: 'building',
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
    ]
};
var faBullhorn = {
    prefix: 'fas',
    iconName: 'bullhorn',
    icon: [
        576,
        512,
        [],
        "f0a1",
        "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
    ]
};
var faBullseye = {
    prefix: 'fas',
    iconName: 'bullseye',
    icon: [
        496,
        512,
        [],
        "f140",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
    ]
};
var faBurn = {
    prefix: 'fas',
    iconName: 'burn',
    icon: [
        384,
        512,
        [],
        "f46a",
        "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
    ]
};
var faBus = {
    prefix: 'fas',
    iconName: 'bus',
    icon: [
        512,
        512,
        [],
        "f207",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faBusAlt = {
    prefix: 'fas',
    iconName: 'bus-alt',
    icon: [
        512,
        512,
        [],
        "f55e",
        "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faBusinessTime = {
    prefix: 'fas',
    iconName: 'business-time',
    icon: [
        640,
        512,
        [],
        "f64a",
        "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
    ]
};
var faCalculator = {
    prefix: 'fas',
    iconName: 'calculator',
    icon: [
        448,
        512,
        [],
        "f1ec",
        "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
    ]
};
var faCalendar = {
    prefix: 'fas',
    iconName: 'calendar',
    icon: [
        448,
        512,
        [],
        "f133",
        "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
    ]
};
var faCalendarAlt = {
    prefix: 'fas',
    iconName: 'calendar-alt',
    icon: [
        448,
        512,
        [],
        "f073",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var faCalendarCheck = {
    prefix: 'fas',
    iconName: 'calendar-check',
    icon: [
        448,
        512,
        [],
        "f274",
        "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
    ]
};
var faCalendarDay = {
    prefix: 'fas',
    iconName: 'calendar-day',
    icon: [
        448,
        512,
        [],
        "f783",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var faCalendarMinus = {
    prefix: 'fas',
    iconName: 'calendar-minus',
    icon: [
        448,
        512,
        [],
        "f272",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
    ]
};
var faCalendarPlus = {
    prefix: 'fas',
    iconName: 'calendar-plus',
    icon: [
        448,
        512,
        [],
        "f271",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
    ]
};
var faCalendarTimes = {
    prefix: 'fas',
    iconName: 'calendar-times',
    icon: [
        448,
        512,
        [],
        "f273",
        "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
    ]
};
var faCalendarWeek = {
    prefix: 'fas',
    iconName: 'calendar-week',
    icon: [
        448,
        512,
        [],
        "f784",
        "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
    ]
};
var faCamera = {
    prefix: 'fas',
    iconName: 'camera',
    icon: [
        512,
        512,
        [],
        "f030",
        "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
    ]
};
var faCameraRetro = {
    prefix: 'fas',
    iconName: 'camera-retro',
    icon: [
        512,
        512,
        [],
        "f083",
        "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
    ]
};
var faCampground = {
    prefix: 'fas',
    iconName: 'campground',
    icon: [
        640,
        512,
        [],
        "f6bb",
        "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
    ]
};
var faCandyCane = {
    prefix: 'fas',
    iconName: 'candy-cane',
    icon: [
        512,
        512,
        [],
        "f786",
        "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
    ]
};
var faCannabis = {
    prefix: 'fas',
    iconName: 'cannabis',
    icon: [
        512,
        512,
        [],
        "f55f",
        "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
    ]
};
var faCapsules = {
    prefix: 'fas',
    iconName: 'capsules',
    icon: [
        576,
        512,
        [],
        "f46b",
        "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
    ]
};
var faCar = {
    prefix: 'fas',
    iconName: 'car',
    icon: [
        512,
        512,
        [],
        "f1b9",
        "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var faCarAlt = {
    prefix: 'fas',
    iconName: 'car-alt',
    icon: [
        480,
        512,
        [],
        "f5de",
        "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
    ]
};
var faCarBattery = {
    prefix: 'fas',
    iconName: 'car-battery',
    icon: [
        512,
        512,
        [],
        "f5df",
        "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
    ]
};
var faCarCrash = {
    prefix: 'fas',
    iconName: 'car-crash',
    icon: [
        640,
        512,
        [],
        "f5e1",
        "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
    ]
};
var faCarSide = {
    prefix: 'fas',
    iconName: 'car-side',
    icon: [
        640,
        512,
        [],
        "f5e4",
        "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var faCaravan = {
    prefix: 'fas',
    iconName: 'caravan',
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
    ]
};
var faCaretDown = {
    prefix: 'fas',
    iconName: 'caret-down',
    icon: [
        320,
        512,
        [],
        "f0d7",
        "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
    ]
};
var faCaretLeft = {
    prefix: 'fas',
    iconName: 'caret-left',
    icon: [
        192,
        512,
        [],
        "f0d9",
        "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
    ]
};
var faCaretRight = {
    prefix: 'fas',
    iconName: 'caret-right',
    icon: [
        192,
        512,
        [],
        "f0da",
        "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
    ]
};
var faCaretSquareDown = {
    prefix: 'fas',
    iconName: 'caret-square-down',
    icon: [
        448,
        512,
        [],
        "f150",
        "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
    ]
};
var faCaretSquareLeft = {
    prefix: 'fas',
    iconName: 'caret-square-left',
    icon: [
        448,
        512,
        [],
        "f191",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
    ]
};
var faCaretSquareRight = {
    prefix: 'fas',
    iconName: 'caret-square-right',
    icon: [
        448,
        512,
        [],
        "f152",
        "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
    ]
};
var faCaretSquareUp = {
    prefix: 'fas',
    iconName: 'caret-square-up',
    icon: [
        448,
        512,
        [],
        "f151",
        "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
    ]
};
var faCaretUp = {
    prefix: 'fas',
    iconName: 'caret-up',
    icon: [
        320,
        512,
        [],
        "f0d8",
        "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
    ]
};
var faCarrot = {
    prefix: 'fas',
    iconName: 'carrot',
    icon: [
        512,
        512,
        [],
        "f787",
        "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
    ]
};
var faCartArrowDown = {
    prefix: 'fas',
    iconName: 'cart-arrow-down',
    icon: [
        576,
        512,
        [],
        "f218",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
    ]
};
var faCartPlus = {
    prefix: 'fas',
    iconName: 'cart-plus',
    icon: [
        576,
        512,
        [],
        "f217",
        "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
    ]
};
var faCashRegister = {
    prefix: 'fas',
    iconName: 'cash-register',
    icon: [
        512,
        512,
        [],
        "f788",
        "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
    ]
};
var faCat = {
    prefix: 'fas',
    iconName: 'cat',
    icon: [
        512,
        512,
        [],
        "f6be",
        "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var faCertificate = {
    prefix: 'fas',
    iconName: 'certificate',
    icon: [
        512,
        512,
        [],
        "f0a3",
        "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
    ]
};
var faChair = {
    prefix: 'fas',
    iconName: 'chair',
    icon: [
        448,
        512,
        [],
        "f6c0",
        "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
    ]
};
var faChalkboard = {
    prefix: 'fas',
    iconName: 'chalkboard',
    icon: [
        640,
        512,
        [],
        "f51b",
        "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faChalkboardTeacher = {
    prefix: 'fas',
    iconName: 'chalkboard-teacher',
    icon: [
        640,
        512,
        [],
        "f51c",
        "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
    ]
};
var faChargingStation = {
    prefix: 'fas',
    iconName: 'charging-station',
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
    ]
};
var faChartArea = {
    prefix: 'fas',
    iconName: 'chart-area',
    icon: [
        512,
        512,
        [],
        "f1fe",
        "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
    ]
};
var faChartBar = {
    prefix: 'fas',
    iconName: 'chart-bar',
    icon: [
        512,
        512,
        [],
        "f080",
        "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faChartLine = {
    prefix: 'fas',
    iconName: 'chart-line',
    icon: [
        512,
        512,
        [],
        "f201",
        "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
    ]
};
var faChartPie = {
    prefix: 'fas',
    iconName: 'chart-pie',
    icon: [
        544,
        512,
        [],
        "f200",
        "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
    ]
};
var faCheck = {
    prefix: 'fas',
    iconName: 'check',
    icon: [
        512,
        512,
        [],
        "f00c",
        "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
    ]
};
var faCheckCircle = {
    prefix: 'fas',
    iconName: 'check-circle',
    icon: [
        512,
        512,
        [],
        "f058",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
    ]
};
var faCheckDouble = {
    prefix: 'fas',
    iconName: 'check-double',
    icon: [
        512,
        512,
        [],
        "f560",
        "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
    ]
};
var faCheckSquare = {
    prefix: 'fas',
    iconName: 'check-square',
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
    ]
};
var faCheese = {
    prefix: 'fas',
    iconName: 'cheese',
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
    ]
};
var faChess = {
    prefix: 'fas',
    iconName: 'chess',
    icon: [
        512,
        512,
        [],
        "f439",
        "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
    ]
};
var faChessBishop = {
    prefix: 'fas',
    iconName: 'chess-bishop',
    icon: [
        320,
        512,
        [],
        "f43a",
        "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChessBoard = {
    prefix: 'fas',
    iconName: 'chess-board',
    icon: [
        512,
        512,
        [],
        "f43c",
        "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
    ]
};
var faChessKing = {
    prefix: 'fas',
    iconName: 'chess-king',
    icon: [
        448,
        512,
        [],
        "f43f",
        "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
    ]
};
var faChessKnight = {
    prefix: 'fas',
    iconName: 'chess-knight',
    icon: [
        384,
        512,
        [],
        "f441",
        "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChessPawn = {
    prefix: 'fas',
    iconName: 'chess-pawn',
    icon: [
        320,
        512,
        [],
        "f443",
        "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChessQueen = {
    prefix: 'fas',
    iconName: 'chess-queen',
    icon: [
        512,
        512,
        [],
        "f445",
        "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
    ]
};
var faChessRook = {
    prefix: 'fas',
    iconName: 'chess-rook',
    icon: [
        384,
        512,
        [],
        "f447",
        "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faChevronCircleDown = {
    prefix: 'fas',
    iconName: 'chevron-circle-down',
    icon: [
        512,
        512,
        [],
        "f13a",
        "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
    ]
};
var faChevronCircleLeft = {
    prefix: 'fas',
    iconName: 'chevron-circle-left',
    icon: [
        512,
        512,
        [],
        "f137",
        "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
    ]
};
var faChevronCircleRight = {
    prefix: 'fas',
    iconName: 'chevron-circle-right',
    icon: [
        512,
        512,
        [],
        "f138",
        "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
    ]
};
var faChevronCircleUp = {
    prefix: 'fas',
    iconName: 'chevron-circle-up',
    icon: [
        512,
        512,
        [],
        "f139",
        "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
    ]
};
var faChevronDown = {
    prefix: 'fas',
    iconName: 'chevron-down',
    icon: [
        448,
        512,
        [],
        "f078",
        "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
    ]
};
var faChevronLeft = {
    prefix: 'fas',
    iconName: 'chevron-left',
    icon: [
        320,
        512,
        [],
        "f053",
        "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
    ]
};
var faChevronRight = {
    prefix: 'fas',
    iconName: 'chevron-right',
    icon: [
        320,
        512,
        [],
        "f054",
        "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
    ]
};
var faChevronUp = {
    prefix: 'fas',
    iconName: 'chevron-up',
    icon: [
        448,
        512,
        [],
        "f077",
        "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
    ]
};
var faChild = {
    prefix: 'fas',
    iconName: 'child',
    icon: [
        384,
        512,
        [],
        "f1ae",
        "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
    ]
};
var faChurch = {
    prefix: 'fas',
    iconName: 'church',
    icon: [
        640,
        512,
        [],
        "f51d",
        "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
    ]
};
var faCircle = {
    prefix: 'fas',
    iconName: 'circle',
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
    ]
};
var faCircleNotch = {
    prefix: 'fas',
    iconName: 'circle-notch',
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
    ]
};
var faCity = {
    prefix: 'fas',
    iconName: 'city',
    icon: [
        640,
        512,
        [],
        "f64f",
        "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
    ]
};
var faClinicMedical = {
    prefix: 'fas',
    iconName: 'clinic-medical',
    icon: [
        576,
        512,
        [],
        "f7f2",
        "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
    ]
};
var faClipboard = {
    prefix: 'fas',
    iconName: 'clipboard',
    icon: [
        384,
        512,
        [],
        "f328",
        "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
    ]
};
var faClipboardCheck = {
    prefix: 'fas',
    iconName: 'clipboard-check',
    icon: [
        384,
        512,
        [],
        "f46c",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
    ]
};
var faClipboardList = {
    prefix: 'fas',
    iconName: 'clipboard-list',
    icon: [
        384,
        512,
        [],
        "f46d",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
    ]
};
var faClock = {
    prefix: 'fas',
    iconName: 'clock',
    icon: [
        512,
        512,
        [],
        "f017",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
    ]
};
var faClone = {
    prefix: 'fas',
    iconName: 'clone',
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    ]
};
var faClosedCaptioning = {
    prefix: 'fas',
    iconName: 'closed-captioning',
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
    ]
};
var faCloud = {
    prefix: 'fas',
    iconName: 'cloud',
    icon: [
        640,
        512,
        [],
        "f0c2",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
    ]
};
var faCloudDownloadAlt = {
    prefix: 'fas',
    iconName: 'cloud-download-alt',
    icon: [
        640,
        512,
        [],
        "f381",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
    ]
};
var faCloudMeatball = {
    prefix: 'fas',
    iconName: 'cloud-meatball',
    icon: [
        512,
        512,
        [],
        "f73b",
        "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
    ]
};
var faCloudMoon = {
    prefix: 'fas',
    iconName: 'cloud-moon',
    icon: [
        576,
        512,
        [],
        "f6c3",
        "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
    ]
};
var faCloudMoonRain = {
    prefix: 'fas',
    iconName: 'cloud-moon-rain',
    icon: [
        576,
        512,
        [],
        "f73c",
        "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var faCloudRain = {
    prefix: 'fas',
    iconName: 'cloud-rain',
    icon: [
        512,
        512,
        [],
        "f73d",
        "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
    ]
};
var faCloudShowersHeavy = {
    prefix: 'fas',
    iconName: 'cloud-showers-heavy',
    icon: [
        512,
        512,
        [],
        "f740",
        "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
    ]
};
var faCloudSun = {
    prefix: 'fas',
    iconName: 'cloud-sun',
    icon: [
        640,
        512,
        [],
        "f6c4",
        "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
    ]
};
var faCloudSunRain = {
    prefix: 'fas',
    iconName: 'cloud-sun-rain',
    icon: [
        576,
        512,
        [],
        "f743",
        "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
    ]
};
var faCloudUploadAlt = {
    prefix: 'fas',
    iconName: 'cloud-upload-alt',
    icon: [
        640,
        512,
        [],
        "f382",
        "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
    ]
};
var faCocktail = {
    prefix: 'fas',
    iconName: 'cocktail',
    icon: [
        576,
        512,
        [],
        "f561",
        "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
    ]
};
var faCode = {
    prefix: 'fas',
    iconName: 'code',
    icon: [
        640,
        512,
        [],
        "f121",
        "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
    ]
};
var faCodeBranch = {
    prefix: 'fas',
    iconName: 'code-branch',
    icon: [
        384,
        512,
        [],
        "f126",
        "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
    ]
};
var faCoffee = {
    prefix: 'fas',
    iconName: 'coffee',
    icon: [
        640,
        512,
        [],
        "f0f4",
        "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
    ]
};
var faCog = {
    prefix: 'fas',
    iconName: 'cog',
    icon: [
        512,
        512,
        [],
        "f013",
        "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faCogs = {
    prefix: 'fas',
    iconName: 'cogs',
    icon: [
        640,
        512,
        [],
        "f085",
        "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
    ]
};
var faCoins = {
    prefix: 'fas',
    iconName: 'coins',
    icon: [
        512,
        512,
        [],
        "f51e",
        "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
    ]
};
var faColumns = {
    prefix: 'fas',
    iconName: 'columns',
    icon: [
        512,
        512,
        [],
        "f0db",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
    ]
};
var faComment = {
    prefix: 'fas',
    iconName: 'comment',
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
    ]
};
var faCommentAlt = {
    prefix: 'fas',
    iconName: 'comment-alt',
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
    ]
};
var faCommentDollar = {
    prefix: 'fas',
    iconName: 'comment-dollar',
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
    ]
};
var faCommentDots = {
    prefix: 'fas',
    iconName: 'comment-dots',
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faCommentMedical = {
    prefix: 'fas',
    iconName: 'comment-medical',
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
    ]
};
var faCommentSlash = {
    prefix: 'fas',
    iconName: 'comment-slash',
    icon: [
        640,
        512,
        [],
        "f4b3",
        "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var faComments = {
    prefix: 'fas',
    iconName: 'comments',
    icon: [
        576,
        512,
        [],
        "f086",
        "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
    ]
};
var faCommentsDollar = {
    prefix: 'fas',
    iconName: 'comments-dollar',
    icon: [
        576,
        512,
        [],
        "f653",
        "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
    ]
};
var faCompactDisc = {
    prefix: 'fas',
    iconName: 'compact-disc',
    icon: [
        496,
        512,
        [],
        "f51f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var faCompass = {
    prefix: 'fas',
    iconName: 'compass',
    icon: [
        496,
        512,
        [],
        "f14e",
        "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
    ]
};
var faCompress = {
    prefix: 'fas',
    iconName: 'compress',
    icon: [
        448,
        512,
        [],
        "f066",
        "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var faCompressAlt = {
    prefix: 'fas',
    iconName: 'compress-alt',
    icon: [
        448,
        512,
        [],
        "f422",
        "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
    ]
};
var faCompressArrowsAlt = {
    prefix: 'fas',
    iconName: 'compress-arrows-alt',
    icon: [
        512,
        512,
        [],
        "f78c",
        "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
    ]
};
var faConciergeBell = {
    prefix: 'fas',
    iconName: 'concierge-bell',
    icon: [
        512,
        512,
        [],
        "f562",
        "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faCookie = {
    prefix: 'fas',
    iconName: 'cookie',
    icon: [
        512,
        512,
        [],
        "f563",
        "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faCookieBite = {
    prefix: 'fas',
    iconName: 'cookie-bite',
    icon: [
        512,
        512,
        [],
        "f564",
        "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faCopy = {
    prefix: 'fas',
    iconName: 'copy',
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
    ]
};
var faCopyright = {
    prefix: 'fas',
    iconName: 'copyright',
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
    ]
};
var faCouch = {
    prefix: 'fas',
    iconName: 'couch',
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
    ]
};
var faCreditCard = {
    prefix: 'fas',
    iconName: 'credit-card',
    icon: [
        576,
        512,
        [],
        "f09d",
        "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
    ]
};
var faCrop = {
    prefix: 'fas',
    iconName: 'crop',
    icon: [
        512,
        512,
        [],
        "f125",
        "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var faCropAlt = {
    prefix: 'fas',
    iconName: 'crop-alt',
    icon: [
        512,
        512,
        [],
        "f565",
        "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
    ]
};
var faCross = {
    prefix: 'fas',
    iconName: 'cross',
    icon: [
        384,
        512,
        [],
        "f654",
        "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var faCrosshairs = {
    prefix: 'fas',
    iconName: 'crosshairs',
    icon: [
        512,
        512,
        [],
        "f05b",
        "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ]
};
var faCrow = {
    prefix: 'fas',
    iconName: 'crow',
    icon: [
        640,
        512,
        [],
        "f520",
        "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faCrown = {
    prefix: 'fas',
    iconName: 'crown',
    icon: [
        640,
        512,
        [],
        "f521",
        "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
    ]
};
var faCrutch = {
    prefix: 'fas',
    iconName: 'crutch',
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
    ]
};
var faCube = {
    prefix: 'fas',
    iconName: 'cube',
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
    ]
};
var faCubes = {
    prefix: 'fas',
    iconName: 'cubes',
    icon: [
        512,
        512,
        [],
        "f1b3",
        "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
    ]
};
var faCut = {
    prefix: 'fas',
    iconName: 'cut',
    icon: [
        448,
        512,
        [],
        "f0c4",
        "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var faDatabase = {
    prefix: 'fas',
    iconName: 'database',
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
    ]
};
var faDeaf = {
    prefix: 'fas',
    iconName: 'deaf',
    icon: [
        512,
        512,
        [],
        "f2a4",
        "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
    ]
};
var faDemocrat = {
    prefix: 'fas',
    iconName: 'democrat',
    icon: [
        640,
        512,
        [],
        "f747",
        "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
    ]
};
var faDesktop = {
    prefix: 'fas',
    iconName: 'desktop',
    icon: [
        576,
        512,
        [],
        "f108",
        "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
    ]
};
var faDharmachakra = {
    prefix: 'fas',
    iconName: 'dharmachakra',
    icon: [
        512,
        512,
        [],
        "f655",
        "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
    ]
};
var faDiagnoses = {
    prefix: 'fas',
    iconName: 'diagnoses',
    icon: [
        640,
        512,
        [],
        "f470",
        "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faDice = {
    prefix: 'fas',
    iconName: 'dice',
    icon: [
        640,
        512,
        [],
        "f522",
        "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faDiceD20 = {
    prefix: 'fas',
    iconName: 'dice-d20',
    icon: [
        480,
        512,
        [],
        "f6cf",
        "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
    ]
};
var faDiceD6 = {
    prefix: 'fas',
    iconName: 'dice-d6',
    icon: [
        448,
        512,
        [],
        "f6d1",
        "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
    ]
};
var faDiceFive = {
    prefix: 'fas',
    iconName: 'dice-five',
    icon: [
        448,
        512,
        [],
        "f523",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceFour = {
    prefix: 'fas',
    iconName: 'dice-four',
    icon: [
        448,
        512,
        [],
        "f524",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceOne = {
    prefix: 'fas',
    iconName: 'dice-one',
    icon: [
        448,
        512,
        [],
        "f525",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceSix = {
    prefix: 'fas',
    iconName: 'dice-six',
    icon: [
        448,
        512,
        [],
        "f526",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceThree = {
    prefix: 'fas',
    iconName: 'dice-three',
    icon: [
        448,
        512,
        [],
        "f527",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDiceTwo = {
    prefix: 'fas',
    iconName: 'dice-two',
    icon: [
        448,
        512,
        [],
        "f528",
        "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faDigitalTachograph = {
    prefix: 'fas',
    iconName: 'digital-tachograph',
    icon: [
        640,
        512,
        [],
        "f566",
        "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
    ]
};
var faDirections = {
    prefix: 'fas',
    iconName: 'directions',
    icon: [
        512,
        512,
        [],
        "f5eb",
        "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
    ]
};
var faDisease = {
    prefix: 'fas',
    iconName: 'disease',
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
    ]
};
var faDivide = {
    prefix: 'fas',
    iconName: 'divide',
    icon: [
        448,
        512,
        [],
        "f529",
        "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faDizzy = {
    prefix: 'fas',
    iconName: 'dizzy',
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
    ]
};
var faDna = {
    prefix: 'fas',
    iconName: 'dna',
    icon: [
        448,
        512,
        [],
        "f471",
        "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
    ]
};
var faDog = {
    prefix: 'fas',
    iconName: 'dog',
    icon: [
        576,
        512,
        [],
        "f6d3",
        "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
    ]
};
var faDollarSign = {
    prefix: 'fas',
    iconName: 'dollar-sign',
    icon: [
        288,
        512,
        [],
        "f155",
        "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
    ]
};
var faDolly = {
    prefix: 'fas',
    iconName: 'dolly',
    icon: [
        576,
        512,
        [],
        "f472",
        "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var faDollyFlatbed = {
    prefix: 'fas',
    iconName: 'dolly-flatbed',
    icon: [
        640,
        512,
        [],
        "f474",
        "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faDonate = {
    prefix: 'fas',
    iconName: 'donate',
    icon: [
        512,
        512,
        [],
        "f4b9",
        "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
    ]
};
var faDoorClosed = {
    prefix: 'fas',
    iconName: 'door-closed',
    icon: [
        640,
        512,
        [],
        "f52a",
        "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
    ]
};
var faDoorOpen = {
    prefix: 'fas',
    iconName: 'door-open',
    icon: [
        640,
        512,
        [],
        "f52b",
        "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
    ]
};
var faDotCircle = {
    prefix: 'fas',
    iconName: 'dot-circle',
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
    ]
};
var faDove = {
    prefix: 'fas',
    iconName: 'dove',
    icon: [
        512,
        512,
        [],
        "f4ba",
        "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faDownload = {
    prefix: 'fas',
    iconName: 'download',
    icon: [
        512,
        512,
        [],
        "f019",
        "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var faDraftingCompass = {
    prefix: 'fas',
    iconName: 'drafting-compass',
    icon: [
        512,
        512,
        [],
        "f568",
        "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
    ]
};
var faDragon = {
    prefix: 'fas',
    iconName: 'dragon',
    icon: [
        640,
        512,
        [],
        "f6d5",
        "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
    ]
};
var faDrawPolygon = {
    prefix: 'fas',
    iconName: 'draw-polygon',
    icon: [
        448,
        512,
        [],
        "f5ee",
        "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
    ]
};
var faDrum = {
    prefix: 'fas',
    iconName: 'drum',
    icon: [
        512,
        512,
        [],
        "f569",
        "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
    ]
};
var faDrumSteelpan = {
    prefix: 'fas',
    iconName: 'drum-steelpan',
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
    ]
};
var faDrumstickBite = {
    prefix: 'fas',
    iconName: 'drumstick-bite',
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
    ]
};
var faDumbbell = {
    prefix: 'fas',
    iconName: 'dumbbell',
    icon: [
        640,
        512,
        [],
        "f44b",
        "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
    ]
};
var faDumpster = {
    prefix: 'fas',
    iconName: 'dumpster',
    icon: [
        576,
        512,
        [],
        "f793",
        "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faDumpsterFire = {
    prefix: 'fas',
    iconName: 'dumpster-fire',
    icon: [
        640,
        512,
        [],
        "f794",
        "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
    ]
};
var faDungeon = {
    prefix: 'fas',
    iconName: 'dungeon',
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
    ]
};
var faEdit = {
    prefix: 'fas',
    iconName: 'edit',
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
    ]
};
var faEgg = {
    prefix: 'fas',
    iconName: 'egg',
    icon: [
        384,
        512,
        [],
        "f7fb",
        "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
    ]
};
var faEject = {
    prefix: 'fas',
    iconName: 'eject',
    icon: [
        448,
        512,
        [],
        "f052",
        "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
    ]
};
var faEllipsisH = {
    prefix: 'fas',
    iconName: 'ellipsis-h',
    icon: [
        512,
        512,
        [],
        "f141",
        "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
    ]
};
var faEllipsisV = {
    prefix: 'fas',
    iconName: 'ellipsis-v',
    icon: [
        192,
        512,
        [],
        "f142",
        "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
    ]
};
var faEnvelope = {
    prefix: 'fas',
    iconName: 'envelope',
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
    ]
};
var faEnvelopeOpen = {
    prefix: 'fas',
    iconName: 'envelope-open',
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
    ]
};
var faEnvelopeOpenText = {
    prefix: 'fas',
    iconName: 'envelope-open-text',
    icon: [
        512,
        512,
        [],
        "f658",
        "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
    ]
};
var faEnvelopeSquare = {
    prefix: 'fas',
    iconName: 'envelope-square',
    icon: [
        448,
        512,
        [],
        "f199",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
    ]
};
var faEquals = {
    prefix: 'fas',
    iconName: 'equals',
    icon: [
        448,
        512,
        [],
        "f52c",
        "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faEraser = {
    prefix: 'fas',
    iconName: 'eraser',
    icon: [
        512,
        512,
        [],
        "f12d",
        "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
    ]
};
var faEthernet = {
    prefix: 'fas',
    iconName: 'ethernet',
    icon: [
        512,
        512,
        [],
        "f796",
        "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
    ]
};
var faEuroSign = {
    prefix: 'fas',
    iconName: 'euro-sign',
    icon: [
        320,
        512,
        [],
        "f153",
        "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
    ]
};
var faExchangeAlt = {
    prefix: 'fas',
    iconName: 'exchange-alt',
    icon: [
        512,
        512,
        [],
        "f362",
        "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
    ]
};
var faExclamation = {
    prefix: 'fas',
    iconName: 'exclamation',
    icon: [
        192,
        512,
        [],
        "f12a",
        "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
    ]
};
var faExclamationCircle = {
    prefix: 'fas',
    iconName: 'exclamation-circle',
    icon: [
        512,
        512,
        [],
        "f06a",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var faExclamationTriangle = {
    prefix: 'fas',
    iconName: 'exclamation-triangle',
    icon: [
        576,
        512,
        [],
        "f071",
        "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
    ]
};
var faExpand = {
    prefix: 'fas',
    iconName: 'expand',
    icon: [
        448,
        512,
        [],
        "f065",
        "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
    ]
};
var faExpandAlt = {
    prefix: 'fas',
    iconName: 'expand-alt',
    icon: [
        448,
        512,
        [],
        "f424",
        "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
    ]
};
var faExpandArrowsAlt = {
    prefix: 'fas',
    iconName: 'expand-arrows-alt',
    icon: [
        448,
        512,
        [],
        "f31e",
        "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
    ]
};
var faExternalLinkAlt = {
    prefix: 'fas',
    iconName: 'external-link-alt',
    icon: [
        512,
        512,
        [],
        "f35d",
        "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
    ]
};
var faExternalLinkSquareAlt = {
    prefix: 'fas',
    iconName: 'external-link-square-alt',
    icon: [
        448,
        512,
        [],
        "f360",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
    ]
};
var faEye = {
    prefix: 'fas',
    iconName: 'eye',
    icon: [
        576,
        512,
        [],
        "f06e",
        "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
    ]
};
var faEyeDropper = {
    prefix: 'fas',
    iconName: 'eye-dropper',
    icon: [
        512,
        512,
        [],
        "f1fb",
        "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
    ]
};
var faEyeSlash = {
    prefix: 'fas',
    iconName: 'eye-slash',
    icon: [
        640,
        512,
        [],
        "f070",
        "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
    ]
};
var faFan = {
    prefix: 'fas',
    iconName: 'fan',
    icon: [
        512,
        512,
        [],
        "f863",
        "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var faFastBackward = {
    prefix: 'fas',
    iconName: 'fast-backward',
    icon: [
        512,
        512,
        [],
        "f049",
        "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
    ]
};
var faFastForward = {
    prefix: 'fas',
    iconName: 'fast-forward',
    icon: [
        512,
        512,
        [],
        "f050",
        "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
    ]
};
var faFaucet = {
    prefix: 'fas',
    iconName: 'faucet',
    icon: [
        512,
        512,
        [],
        "e005",
        "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
    ]
};
var faFax = {
    prefix: 'fas',
    iconName: 'fax',
    icon: [
        512,
        512,
        [],
        "f1ac",
        "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
    ]
};
var faFeather = {
    prefix: 'fas',
    iconName: 'feather',
    icon: [
        512,
        512,
        [],
        "f52d",
        "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
    ]
};
var faFeatherAlt = {
    prefix: 'fas',
    iconName: 'feather-alt',
    icon: [
        512,
        512,
        [],
        "f56b",
        "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
    ]
};
var faFemale = {
    prefix: 'fas',
    iconName: 'female',
    icon: [
        256,
        512,
        [],
        "f182",
        "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
    ]
};
var faFighterJet = {
    prefix: 'fas',
    iconName: 'fighter-jet',
    icon: [
        640,
        512,
        [],
        "f0fb",
        "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
    ]
};
var faFile = {
    prefix: 'fas',
    iconName: 'file',
    icon: [
        384,
        512,
        [],
        "f15b",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileAlt = {
    prefix: 'fas',
    iconName: 'file-alt',
    icon: [
        384,
        512,
        [],
        "f15c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileArchive = {
    prefix: 'fas',
    iconName: 'file-archive',
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
    ]
};
var faFileAudio = {
    prefix: 'fas',
    iconName: 'file-audio',
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileCode = {
    prefix: 'fas',
    iconName: 'file-code',
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
    ]
};
var faFileContract = {
    prefix: 'fas',
    iconName: 'file-contract',
    icon: [
        384,
        512,
        [],
        "f56c",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileCsv = {
    prefix: 'fas',
    iconName: 'file-csv',
    icon: [
        384,
        512,
        [],
        "f6dd",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileDownload = {
    prefix: 'fas',
    iconName: 'file-download',
    icon: [
        384,
        512,
        [],
        "f56d",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileExcel = {
    prefix: 'fas',
    iconName: 'file-excel',
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileExport = {
    prefix: 'fas',
    iconName: 'file-export',
    icon: [
        576,
        512,
        [],
        "f56e",
        "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
    ]
};
var faFileImage = {
    prefix: 'fas',
    iconName: 'file-image',
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
    ]
};
var faFileImport = {
    prefix: 'fas',
    iconName: 'file-import',
    icon: [
        512,
        512,
        [],
        "f56f",
        "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
    ]
};
var faFileInvoice = {
    prefix: 'fas',
    iconName: 'file-invoice',
    icon: [
        384,
        512,
        [],
        "f570",
        "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
    ]
};
var faFileInvoiceDollar = {
    prefix: 'fas',
    iconName: 'file-invoice-dollar',
    icon: [
        384,
        512,
        [],
        "f571",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
    ]
};
var faFileMedical = {
    prefix: 'fas',
    iconName: 'file-medical',
    icon: [
        384,
        512,
        [],
        "f477",
        "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
    ]
};
var faFileMedicalAlt = {
    prefix: 'fas',
    iconName: 'file-medical-alt',
    icon: [
        448,
        512,
        [],
        "f478",
        "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFilePdf = {
    prefix: 'fas',
    iconName: 'file-pdf',
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
    ]
};
var faFilePowerpoint = {
    prefix: 'fas',
    iconName: 'file-powerpoint',
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
    ]
};
var faFilePrescription = {
    prefix: 'fas',
    iconName: 'file-prescription',
    icon: [
        384,
        512,
        [],
        "f572",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFileSignature = {
    prefix: 'fas',
    iconName: 'file-signature',
    icon: [
        576,
        512,
        [],
        "f573",
        "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
    ]
};
var faFileUpload = {
    prefix: 'fas',
    iconName: 'file-upload',
    icon: [
        384,
        512,
        [],
        "f574",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
    ]
};
var faFileVideo = {
    prefix: 'fas',
    iconName: 'file-video',
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
    ]
};
var faFileWord = {
    prefix: 'fas',
    iconName: 'file-word',
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
    ]
};
var faFill = {
    prefix: 'fas',
    iconName: 'fill',
    icon: [
        512,
        512,
        [],
        "f575",
        "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
    ]
};
var faFillDrip = {
    prefix: 'fas',
    iconName: 'fill-drip',
    icon: [
        576,
        512,
        [],
        "f576",
        "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
    ]
};
var faFilm = {
    prefix: 'fas',
    iconName: 'film',
    icon: [
        512,
        512,
        [],
        "f008",
        "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var faFilter = {
    prefix: 'fas',
    iconName: 'filter',
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
    ]
};
var faFingerprint = {
    prefix: 'fas',
    iconName: 'fingerprint',
    icon: [
        512,
        512,
        [],
        "f577",
        "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
    ]
};
var faFire = {
    prefix: 'fas',
    iconName: 'fire',
    icon: [
        384,
        512,
        [],
        "f06d",
        "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
    ]
};
var faFireAlt = {
    prefix: 'fas',
    iconName: 'fire-alt',
    icon: [
        448,
        512,
        [],
        "f7e4",
        "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
    ]
};
var faFireExtinguisher = {
    prefix: 'fas',
    iconName: 'fire-extinguisher',
    icon: [
        448,
        512,
        [],
        "f134",
        "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
    ]
};
var faFirstAid = {
    prefix: 'fas',
    iconName: 'first-aid',
    icon: [
        576,
        512,
        [],
        "f479",
        "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var faFish = {
    prefix: 'fas',
    iconName: 'fish',
    icon: [
        576,
        512,
        [],
        "f578",
        "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var faFistRaised = {
    prefix: 'fas',
    iconName: 'fist-raised',
    icon: [
        384,
        512,
        [],
        "f6de",
        "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
    ]
};
var faFlag = {
    prefix: 'fas',
    iconName: 'flag',
    icon: [
        512,
        512,
        [],
        "f024",
        "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
    ]
};
var faFlagCheckered = {
    prefix: 'fas',
    iconName: 'flag-checkered',
    icon: [
        512,
        512,
        [],
        "f11e",
        "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
    ]
};
var faFlagUsa = {
    prefix: 'fas',
    iconName: 'flag-usa',
    icon: [
        512,
        512,
        [],
        "f74d",
        "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
    ]
};
var faFlask = {
    prefix: 'fas',
    iconName: 'flask',
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
    ]
};
var faFlushed = {
    prefix: 'fas',
    iconName: 'flushed',
    icon: [
        496,
        512,
        [],
        "f579",
        "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
    ]
};
var faFolder = {
    prefix: 'fas',
    iconName: 'folder',
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
    ]
};
var faFolderMinus = {
    prefix: 'fas',
    iconName: 'folder-minus',
    icon: [
        512,
        512,
        [],
        "f65d",
        "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
    ]
};
var faFolderOpen = {
    prefix: 'fas',
    iconName: 'folder-open',
    icon: [
        576,
        512,
        [],
        "f07c",
        "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
    ]
};
var faFolderPlus = {
    prefix: 'fas',
    iconName: 'folder-plus',
    icon: [
        512,
        512,
        [],
        "f65e",
        "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
    ]
};
var faFont = {
    prefix: 'fas',
    iconName: 'font',
    icon: [
        448,
        512,
        [],
        "f031",
        "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
    ]
};
var faFontAwesomeLogoFull = {
    prefix: 'fas',
    iconName: 'font-awesome-logo-full',
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var faFootballBall = {
    prefix: 'fas',
    iconName: 'football-ball',
    icon: [
        496,
        512,
        [],
        "f44e",
        "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
    ]
};
var faForward = {
    prefix: 'fas',
    iconName: 'forward',
    icon: [
        512,
        512,
        [],
        "f04e",
        "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
    ]
};
var faFrog = {
    prefix: 'fas',
    iconName: 'frog',
    icon: [
        576,
        512,
        [],
        "f52e",
        "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
    ]
};
var faFrown = {
    prefix: 'fas',
    iconName: 'frown',
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
    ]
};
var faFrownOpen = {
    prefix: 'fas',
    iconName: 'frown-open',
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faFunnelDollar = {
    prefix: 'fas',
    iconName: 'funnel-dollar',
    icon: [
        640,
        512,
        [],
        "f662",
        "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
    ]
};
var faFutbol = {
    prefix: 'fas',
    iconName: 'futbol',
    icon: [
        512,
        512,
        [],
        "f1e3",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
    ]
};
var faGamepad = {
    prefix: 'fas',
    iconName: 'gamepad',
    icon: [
        640,
        512,
        [],
        "f11b",
        "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
    ]
};
var faGasPump = {
    prefix: 'fas',
    iconName: 'gas-pump',
    icon: [
        512,
        512,
        [],
        "f52f",
        "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
    ]
};
var faGavel = {
    prefix: 'fas',
    iconName: 'gavel',
    icon: [
        512,
        512,
        [],
        "f0e3",
        "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
    ]
};
var faGem = {
    prefix: 'fas',
    iconName: 'gem',
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
    ]
};
var faGenderless = {
    prefix: 'fas',
    iconName: 'genderless',
    icon: [
        288,
        512,
        [],
        "f22d",
        "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
    ]
};
var faGhost = {
    prefix: 'fas',
    iconName: 'ghost',
    icon: [
        384,
        512,
        [],
        "f6e2",
        "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faGift = {
    prefix: 'fas',
    iconName: 'gift',
    icon: [
        512,
        512,
        [],
        "f06b",
        "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
    ]
};
var faGifts = {
    prefix: 'fas',
    iconName: 'gifts',
    icon: [
        640,
        512,
        [],
        "f79c",
        "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
    ]
};
var faGlassCheers = {
    prefix: 'fas',
    iconName: 'glass-cheers',
    icon: [
        640,
        512,
        [],
        "f79f",
        "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
    ]
};
var faGlassMartini = {
    prefix: 'fas',
    iconName: 'glass-martini',
    icon: [
        512,
        512,
        [],
        "f000",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
    ]
};
var faGlassMartiniAlt = {
    prefix: 'fas',
    iconName: 'glass-martini-alt',
    icon: [
        512,
        512,
        [],
        "f57b",
        "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
    ]
};
var faGlassWhiskey = {
    prefix: 'fas',
    iconName: 'glass-whiskey',
    icon: [
        512,
        512,
        [],
        "f7a0",
        "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
    ]
};
var faGlasses = {
    prefix: 'fas',
    iconName: 'glasses',
    icon: [
        576,
        512,
        [],
        "f530",
        "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
    ]
};
var faGlobe = {
    prefix: 'fas',
    iconName: 'globe',
    icon: [
        496,
        512,
        [],
        "f0ac",
        "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
    ]
};
var faGlobeAfrica = {
    prefix: 'fas',
    iconName: 'globe-africa',
    icon: [
        496,
        512,
        [],
        "f57c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
    ]
};
var faGlobeAmericas = {
    prefix: 'fas',
    iconName: 'globe-americas',
    icon: [
        496,
        512,
        [],
        "f57d",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
    ]
};
var faGlobeAsia = {
    prefix: 'fas',
    iconName: 'globe-asia',
    icon: [
        496,
        512,
        [],
        "f57e",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
    ]
};
var faGlobeEurope = {
    prefix: 'fas',
    iconName: 'globe-europe',
    icon: [
        496,
        512,
        [],
        "f7a2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
    ]
};
var faGolfBall = {
    prefix: 'fas',
    iconName: 'golf-ball',
    icon: [
        416,
        512,
        [],
        "f450",
        "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
    ]
};
var faGopuram = {
    prefix: 'fas',
    iconName: 'gopuram',
    icon: [
        512,
        512,
        [],
        "f664",
        "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
    ]
};
var faGraduationCap = {
    prefix: 'fas',
    iconName: 'graduation-cap',
    icon: [
        640,
        512,
        [],
        "f19d",
        "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
    ]
};
var faGreaterThan = {
    prefix: 'fas',
    iconName: 'greater-than',
    icon: [
        384,
        512,
        [],
        "f531",
        "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
    ]
};
var faGreaterThanEqual = {
    prefix: 'fas',
    iconName: 'greater-than-equal',
    icon: [
        448,
        512,
        [],
        "f532",
        "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var faGrimace = {
    prefix: 'fas',
    iconName: 'grimace',
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
    ]
};
var faGrin = {
    prefix: 'fas',
    iconName: 'grin',
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinAlt = {
    prefix: 'fas',
    iconName: 'grin-alt',
    icon: [
        496,
        512,
        [],
        "f581",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinBeam = {
    prefix: 'fas',
    iconName: 'grin-beam',
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinBeamSweat = {
    prefix: 'fas',
    iconName: 'grin-beam-sweat',
    icon: [
        504,
        512,
        [],
        "f583",
        "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinHearts = {
    prefix: 'fas',
    iconName: 'grin-hearts',
    icon: [
        496,
        512,
        [],
        "f584",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
    ]
};
var faGrinSquint = {
    prefix: 'fas',
    iconName: 'grin-squint',
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinSquintTears = {
    prefix: 'fas',
    iconName: 'grin-squint-tears',
    icon: [
        512,
        512,
        [],
        "f586",
        "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
    ]
};
var faGrinStars = {
    prefix: 'fas',
    iconName: 'grin-stars',
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
    ]
};
var faGrinTears = {
    prefix: 'fas',
    iconName: 'grin-tears',
    icon: [
        640,
        512,
        [],
        "f588",
        "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
    ]
};
var faGrinTongue = {
    prefix: 'fas',
    iconName: 'grin-tongue',
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var faGrinTongueSquint = {
    prefix: 'fas',
    iconName: 'grin-tongue-squint',
    icon: [
        496,
        512,
        [],
        "f58a",
        "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
    ]
};
var faGrinTongueWink = {
    prefix: 'fas',
    iconName: 'grin-tongue-wink',
    icon: [
        496,
        512,
        [],
        "f58b",
        "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
    ]
};
var faGrinWink = {
    prefix: 'fas',
    iconName: 'grin-wink',
    icon: [
        496,
        512,
        [],
        "f58c",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
    ]
};
var faGripHorizontal = {
    prefix: 'fas',
    iconName: 'grip-horizontal',
    icon: [
        448,
        512,
        [],
        "f58d",
        "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var faGripLines = {
    prefix: 'fas',
    iconName: 'grip-lines',
    icon: [
        512,
        512,
        [],
        "f7a4",
        "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
    ]
};
var faGripLinesVertical = {
    prefix: 'fas',
    iconName: 'grip-lines-vertical',
    icon: [
        256,
        512,
        [],
        "f7a5",
        "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
    ]
};
var faGripVertical = {
    prefix: 'fas',
    iconName: 'grip-vertical',
    icon: [
        320,
        512,
        [],
        "f58e",
        "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
    ]
};
var faGuitar = {
    prefix: 'fas',
    iconName: 'guitar',
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
    ]
};
var faHSquare = {
    prefix: 'fas',
    iconName: 'h-square',
    icon: [
        448,
        512,
        [],
        "f0fd",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
    ]
};
var faHamburger = {
    prefix: 'fas',
    iconName: 'hamburger',
    icon: [
        512,
        512,
        [],
        "f805",
        "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
    ]
};
var faHammer = {
    prefix: 'fas',
    iconName: 'hammer',
    icon: [
        576,
        512,
        [],
        "f6e3",
        "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
    ]
};
var faHamsa = {
    prefix: 'fas',
    iconName: 'hamsa',
    icon: [
        512,
        512,
        [],
        "f665",
        "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var faHandHolding = {
    prefix: 'fas',
    iconName: 'hand-holding',
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var faHandHoldingHeart = {
    prefix: 'fas',
    iconName: 'hand-holding-heart',
    icon: [
        576,
        512,
        [],
        "f4be",
        "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var faHandHoldingMedical = {
    prefix: 'fas',
    iconName: 'hand-holding-medical',
    icon: [
        576,
        512,
        [],
        "e05c",
        "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
    ]
};
var faHandHoldingUsd = {
    prefix: 'fas',
    iconName: 'hand-holding-usd',
    icon: [
        576,
        512,
        [],
        "f4c0",
        "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
    ]
};
var faHandHoldingWater = {
    prefix: 'fas',
    iconName: 'hand-holding-water',
    icon: [
        576,
        512,
        [],
        "f4c1",
        "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
    ]
};
var faHandLizard = {
    prefix: 'fas',
    iconName: 'hand-lizard',
    icon: [
        576,
        512,
        [],
        "f258",
        "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
    ]
};
var faHandMiddleFinger = {
    prefix: 'fas',
    iconName: 'hand-middle-finger',
    icon: [
        512,
        512,
        [],
        "f806",
        "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
    ]
};
var faHandPaper = {
    prefix: 'fas',
    iconName: 'hand-paper',
    icon: [
        448,
        512,
        [],
        "f256",
        "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
    ]
};
var faHandPeace = {
    prefix: 'fas',
    iconName: 'hand-peace',
    icon: [
        448,
        512,
        [],
        "f25b",
        "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
    ]
};
var faHandPointDown = {
    prefix: 'fas',
    iconName: 'hand-point-down',
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var faHandPointLeft = {
    prefix: 'fas',
    iconName: 'hand-point-left',
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
    ]
};
var faHandPointRight = {
    prefix: 'fas',
    iconName: 'hand-point-right',
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
    ]
};
var faHandPointUp = {
    prefix: 'fas',
    iconName: 'hand-point-up',
    icon: [
        384,
        512,
        [],
        "f0a6",
        "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
    ]
};
var faHandPointer = {
    prefix: 'fas',
    iconName: 'hand-pointer',
    icon: [
        448,
        512,
        [],
        "f25a",
        "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
    ]
};
var faHandRock = {
    prefix: 'fas',
    iconName: 'hand-rock',
    icon: [
        512,
        512,
        [],
        "f255",
        "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
    ]
};
var faHandScissors = {
    prefix: 'fas',
    iconName: 'hand-scissors',
    icon: [
        512,
        512,
        [],
        "f257",
        "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
    ]
};
var faHandSparkles = {
    prefix: 'fas',
    iconName: 'hand-sparkles',
    icon: [
        640,
        512,
        [],
        "e05d",
        "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
    ]
};
var faHandSpock = {
    prefix: 'fas',
    iconName: 'hand-spock',
    icon: [
        512,
        512,
        [],
        "f259",
        "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
    ]
};
var faHands = {
    prefix: 'fas',
    iconName: 'hands',
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
    ]
};
var faHandsHelping = {
    prefix: 'fas',
    iconName: 'hands-helping',
    icon: [
        640,
        512,
        [],
        "f4c4",
        "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
    ]
};
var faHandsWash = {
    prefix: 'fas',
    iconName: 'hands-wash',
    icon: [
        576,
        512,
        [],
        "e05e",
        "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
    ]
};
var faHandshake = {
    prefix: 'fas',
    iconName: 'handshake',
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
    ]
};
var faHandshakeAltSlash = {
    prefix: 'fas',
    iconName: 'handshake-alt-slash',
    icon: [
        640,
        512,
        [],
        "e05f",
        "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
    ]
};
var faHandshakeSlash = {
    prefix: 'fas',
    iconName: 'handshake-slash',
    icon: [
        640,
        512,
        [],
        "e060",
        "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
    ]
};
var faHanukiah = {
    prefix: 'fas',
    iconName: 'hanukiah',
    icon: [
        640,
        512,
        [],
        "f6e6",
        "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
    ]
};
var faHardHat = {
    prefix: 'fas',
    iconName: 'hard-hat',
    icon: [
        512,
        512,
        [],
        "f807",
        "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faHashtag = {
    prefix: 'fas',
    iconName: 'hashtag',
    icon: [
        448,
        512,
        [],
        "f292",
        "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
    ]
};
var faHatCowboy = {
    prefix: 'fas',
    iconName: 'hat-cowboy',
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
    ]
};
var faHatCowboySide = {
    prefix: 'fas',
    iconName: 'hat-cowboy-side',
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
    ]
};
var faHatWizard = {
    prefix: 'fas',
    iconName: 'hat-wizard',
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
    ]
};
var faHdd = {
    prefix: 'fas',
    iconName: 'hdd',
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
    ]
};
var faHeadSideCough = {
    prefix: 'fas',
    iconName: 'head-side-cough',
    icon: [
        640,
        512,
        [],
        "e061",
        "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
    ]
};
var faHeadSideCoughSlash = {
    prefix: 'fas',
    iconName: 'head-side-cough-slash',
    icon: [
        640,
        512,
        [],
        "e062",
        "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
    ]
};
var faHeadSideMask = {
    prefix: 'fas',
    iconName: 'head-side-mask',
    icon: [
        512,
        512,
        [],
        "e063",
        "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
    ]
};
var faHeadSideVirus = {
    prefix: 'fas',
    iconName: 'head-side-virus',
    icon: [
        512,
        512,
        [],
        "e064",
        "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
    ]
};
var faHeading = {
    prefix: 'fas',
    iconName: 'heading',
    icon: [
        512,
        512,
        [],
        "f1dc",
        "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
    ]
};
var faHeadphones = {
    prefix: 'fas',
    iconName: 'headphones',
    icon: [
        512,
        512,
        [],
        "f025",
        "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
    ]
};
var faHeadphonesAlt = {
    prefix: 'fas',
    iconName: 'headphones-alt',
    icon: [
        512,
        512,
        [],
        "f58f",
        "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
    ]
};
var faHeadset = {
    prefix: 'fas',
    iconName: 'headset',
    icon: [
        512,
        512,
        [],
        "f590",
        "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
    ]
};
var faHeart = {
    prefix: 'fas',
    iconName: 'heart',
    icon: [
        512,
        512,
        [],
        "f004",
        "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
    ]
};
var faHeartBroken = {
    prefix: 'fas',
    iconName: 'heart-broken',
    icon: [
        512,
        512,
        [],
        "f7a9",
        "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var faHeartbeat = {
    prefix: 'fas',
    iconName: 'heartbeat',
    icon: [
        512,
        512,
        [],
        "f21e",
        "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
    ]
};
var faHelicopter = {
    prefix: 'fas',
    iconName: 'helicopter',
    icon: [
        640,
        512,
        [],
        "f533",
        "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
    ]
};
var faHighlighter = {
    prefix: 'fas',
    iconName: 'highlighter',
    icon: [
        544,
        512,
        [],
        "f591",
        "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
    ]
};
var faHiking = {
    prefix: 'fas',
    iconName: 'hiking',
    icon: [
        384,
        512,
        [],
        "f6ec",
        "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
    ]
};
var faHippo = {
    prefix: 'fas',
    iconName: 'hippo',
    icon: [
        640,
        512,
        [],
        "f6ed",
        "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var faHistory = {
    prefix: 'fas',
    iconName: 'history',
    icon: [
        512,
        512,
        [],
        "f1da",
        "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
    ]
};
var faHockeyPuck = {
    prefix: 'fas',
    iconName: 'hockey-puck',
    icon: [
        512,
        512,
        [],
        "f453",
        "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
    ]
};
var faHollyBerry = {
    prefix: 'fas',
    iconName: 'holly-berry',
    icon: [
        448,
        512,
        [],
        "f7aa",
        "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
    ]
};
var faHome = {
    prefix: 'fas',
    iconName: 'home',
    icon: [
        576,
        512,
        [],
        "f015",
        "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
    ]
};
var faHorse = {
    prefix: 'fas',
    iconName: 'horse',
    icon: [
        576,
        512,
        [],
        "f6f0",
        "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
    ]
};
var faHorseHead = {
    prefix: 'fas',
    iconName: 'horse-head',
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
    ]
};
var faHospital = {
    prefix: 'fas',
    iconName: 'hospital',
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
    ]
};
var faHospitalAlt = {
    prefix: 'fas',
    iconName: 'hospital-alt',
    icon: [
        576,
        512,
        [],
        "f47d",
        "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
    ]
};
var faHospitalSymbol = {
    prefix: 'fas',
    iconName: 'hospital-symbol',
    icon: [
        512,
        512,
        [],
        "f47e",
        "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
    ]
};
var faHospitalUser = {
    prefix: 'fas',
    iconName: 'hospital-user',
    icon: [
        640,
        512,
        [],
        "f80d",
        "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
    ]
};
var faHotTub = {
    prefix: 'fas',
    iconName: 'hot-tub',
    icon: [
        512,
        512,
        [],
        "f593",
        "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
    ]
};
var faHotdog = {
    prefix: 'fas',
    iconName: 'hotdog',
    icon: [
        512,
        512,
        [],
        "f80f",
        "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
    ]
};
var faHotel = {
    prefix: 'fas',
    iconName: 'hotel',
    icon: [
        576,
        512,
        [],
        "f594",
        "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var faHourglass = {
    prefix: 'fas',
    iconName: 'hourglass',
    icon: [
        384,
        512,
        [],
        "f254",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
    ]
};
var faHourglassEnd = {
    prefix: 'fas',
    iconName: 'hourglass-end',
    icon: [
        384,
        512,
        [],
        "f253",
        "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
    ]
};
var faHourglassHalf = {
    prefix: 'fas',
    iconName: 'hourglass-half',
    icon: [
        384,
        512,
        [],
        "f252",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
    ]
};
var faHourglassStart = {
    prefix: 'fas',
    iconName: 'hourglass-start',
    icon: [
        384,
        512,
        [],
        "f251",
        "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
    ]
};
var faHouseDamage = {
    prefix: 'fas',
    iconName: 'house-damage',
    icon: [
        576,
        512,
        [],
        "f6f1",
        "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
    ]
};
var faHouseUser = {
    prefix: 'fas',
    iconName: 'house-user',
    icon: [
        576,
        512,
        [],
        "e065",
        "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
    ]
};
var faHryvnia = {
    prefix: 'fas',
    iconName: 'hryvnia',
    icon: [
        384,
        512,
        [],
        "f6f2",
        "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
    ]
};
var faICursor = {
    prefix: 'fas',
    iconName: 'i-cursor',
    icon: [
        256,
        512,
        [],
        "f246",
        "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
    ]
};
var faIceCream = {
    prefix: 'fas',
    iconName: 'ice-cream',
    icon: [
        448,
        512,
        [],
        "f810",
        "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
    ]
};
var faIcicles = {
    prefix: 'fas',
    iconName: 'icicles',
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
    ]
};
var faIcons = {
    prefix: 'fas',
    iconName: 'icons',
    icon: [
        512,
        512,
        [],
        "f86d",
        "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
    ]
};
var faIdBadge = {
    prefix: 'fas',
    iconName: 'id-badge',
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var faIdCard = {
    prefix: 'fas',
    iconName: 'id-card',
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
    ]
};
var faIdCardAlt = {
    prefix: 'fas',
    iconName: 'id-card-alt',
    icon: [
        576,
        512,
        [],
        "f47f",
        "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
    ]
};
var faIgloo = {
    prefix: 'fas',
    iconName: 'igloo',
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
    ]
};
var faImage = {
    prefix: 'fas',
    iconName: 'image',
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
    ]
};
var faImages = {
    prefix: 'fas',
    iconName: 'images',
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
    ]
};
var faInbox = {
    prefix: 'fas',
    iconName: 'inbox',
    icon: [
        576,
        512,
        [],
        "f01c",
        "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
    ]
};
var faIndent = {
    prefix: 'fas',
    iconName: 'indent',
    icon: [
        448,
        512,
        [],
        "f03c",
        "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faIndustry = {
    prefix: 'fas',
    iconName: 'industry',
    icon: [
        512,
        512,
        [],
        "f275",
        "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
    ]
};
var faInfinity = {
    prefix: 'fas',
    iconName: 'infinity',
    icon: [
        640,
        512,
        [],
        "f534",
        "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
    ]
};
var faInfo = {
    prefix: 'fas',
    iconName: 'info',
    icon: [
        192,
        512,
        [],
        "f129",
        "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
    ]
};
var faInfoCircle = {
    prefix: 'fas',
    iconName: 'info-circle',
    icon: [
        512,
        512,
        [],
        "f05a",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
    ]
};
var faItalic = {
    prefix: 'fas',
    iconName: 'italic',
    icon: [
        320,
        512,
        [],
        "f033",
        "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
    ]
};
var faJedi = {
    prefix: 'fas',
    iconName: 'jedi',
    icon: [
        576,
        512,
        [],
        "f669",
        "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
    ]
};
var faJoint = {
    prefix: 'fas',
    iconName: 'joint',
    icon: [
        640,
        512,
        [],
        "f595",
        "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
    ]
};
var faJournalWhills = {
    prefix: 'fas',
    iconName: 'journal-whills',
    icon: [
        448,
        512,
        [],
        "f66a",
        "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
    ]
};
var faKaaba = {
    prefix: 'fas',
    iconName: 'kaaba',
    icon: [
        576,
        512,
        [],
        "f66b",
        "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
    ]
};
var faKey = {
    prefix: 'fas',
    iconName: 'key',
    icon: [
        512,
        512,
        [],
        "f084",
        "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
    ]
};
var faKeyboard = {
    prefix: 'fas',
    iconName: 'keyboard',
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var faKhanda = {
    prefix: 'fas',
    iconName: 'khanda',
    icon: [
        512,
        512,
        [],
        "f66d",
        "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
    ]
};
var faKiss = {
    prefix: 'fas',
    iconName: 'kiss',
    icon: [
        496,
        512,
        [],
        "f596",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faKissBeam = {
    prefix: 'fas',
    iconName: 'kiss-beam',
    icon: [
        496,
        512,
        [],
        "f597",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
    ]
};
var faKissWinkHeart = {
    prefix: 'fas',
    iconName: 'kiss-wink-heart',
    icon: [
        504,
        512,
        [],
        "f598",
        "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
    ]
};
var faKiwiBird = {
    prefix: 'fas',
    iconName: 'kiwi-bird',
    icon: [
        576,
        512,
        [],
        "f535",
        "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
    ]
};
var faLandmark = {
    prefix: 'fas',
    iconName: 'landmark',
    icon: [
        512,
        512,
        [],
        "f66f",
        "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faLanguage = {
    prefix: 'fas',
    iconName: 'language',
    icon: [
        640,
        512,
        [],
        "f1ab",
        "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
    ]
};
var faLaptop = {
    prefix: 'fas',
    iconName: 'laptop',
    icon: [
        640,
        512,
        [],
        "f109",
        "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var faLaptopCode = {
    prefix: 'fas',
    iconName: 'laptop-code',
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
    ]
};
var faLaptopHouse = {
    prefix: 'fas',
    iconName: 'laptop-house',
    icon: [
        640,
        512,
        [],
        "e066",
        "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
    ]
};
var faLaptopMedical = {
    prefix: 'fas',
    iconName: 'laptop-medical',
    icon: [
        640,
        512,
        [],
        "f812",
        "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
    ]
};
var faLaugh = {
    prefix: 'fas',
    iconName: 'laugh',
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
    ]
};
var faLaughBeam = {
    prefix: 'fas',
    iconName: 'laugh-beam',
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var faLaughSquint = {
    prefix: 'fas',
    iconName: 'laugh-squint',
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var faLaughWink = {
    prefix: 'fas',
    iconName: 'laugh-wink',
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
    ]
};
var faLayerGroup = {
    prefix: 'fas',
    iconName: 'layer-group',
    icon: [
        512,
        512,
        [],
        "f5fd",
        "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
    ]
};
var faLeaf = {
    prefix: 'fas',
    iconName: 'leaf',
    icon: [
        576,
        512,
        [],
        "f06c",
        "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
    ]
};
var faLemon = {
    prefix: 'fas',
    iconName: 'lemon',
    icon: [
        512,
        512,
        [],
        "f094",
        "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
    ]
};
var faLessThan = {
    prefix: 'fas',
    iconName: 'less-than',
    icon: [
        384,
        512,
        [],
        "f536",
        "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
    ]
};
var faLessThanEqual = {
    prefix: 'fas',
    iconName: 'less-than-equal',
    icon: [
        448,
        512,
        [],
        "f537",
        "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
    ]
};
var faLevelDownAlt = {
    prefix: 'fas',
    iconName: 'level-down-alt',
    icon: [
        320,
        512,
        [],
        "f3be",
        "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
    ]
};
var faLevelUpAlt = {
    prefix: 'fas',
    iconName: 'level-up-alt',
    icon: [
        320,
        512,
        [],
        "f3bf",
        "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
    ]
};
var faLifeRing = {
    prefix: 'fas',
    iconName: 'life-ring',
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
    ]
};
var faLightbulb = {
    prefix: 'fas',
    iconName: 'lightbulb',
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var faLink = {
    prefix: 'fas',
    iconName: 'link',
    icon: [
        512,
        512,
        [],
        "f0c1",
        "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
    ]
};
var faLiraSign = {
    prefix: 'fas',
    iconName: 'lira-sign',
    icon: [
        384,
        512,
        [],
        "f195",
        "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
    ]
};
var faList = {
    prefix: 'fas',
    iconName: 'list',
    icon: [
        512,
        512,
        [],
        "f03a",
        "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faListAlt = {
    prefix: 'fas',
    iconName: 'list-alt',
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
    ]
};
var faListOl = {
    prefix: 'fas',
    iconName: 'list-ol',
    icon: [
        512,
        512,
        [],
        "f0cb",
        "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
    ]
};
var faListUl = {
    prefix: 'fas',
    iconName: 'list-ul',
    icon: [
        512,
        512,
        [],
        "f0ca",
        "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faLocationArrow = {
    prefix: 'fas',
    iconName: 'location-arrow',
    icon: [
        512,
        512,
        [],
        "f124",
        "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
    ]
};
var faLock = {
    prefix: 'fas',
    iconName: 'lock',
    icon: [
        448,
        512,
        [],
        "f023",
        "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
    ]
};
var faLockOpen = {
    prefix: 'fas',
    iconName: 'lock-open',
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
    ]
};
var faLongArrowAltDown = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-down',
    icon: [
        256,
        512,
        [],
        "f309",
        "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
    ]
};
var faLongArrowAltLeft = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-left',
    icon: [
        448,
        512,
        [],
        "f30a",
        "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
    ]
};
var faLongArrowAltRight = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-right',
    icon: [
        448,
        512,
        [],
        "f30b",
        "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
    ]
};
var faLongArrowAltUp = {
    prefix: 'fas',
    iconName: 'long-arrow-alt-up',
    icon: [
        256,
        512,
        [],
        "f30c",
        "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
    ]
};
var faLowVision = {
    prefix: 'fas',
    iconName: 'low-vision',
    icon: [
        576,
        512,
        [],
        "f2a8",
        "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
    ]
};
var faLuggageCart = {
    prefix: 'fas',
    iconName: 'luggage-cart',
    icon: [
        640,
        512,
        [],
        "f59d",
        "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
    ]
};
var faLungs = {
    prefix: 'fas',
    iconName: 'lungs',
    icon: [
        640,
        512,
        [],
        "f604",
        "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
    ]
};
var faLungsVirus = {
    prefix: 'fas',
    iconName: 'lungs-virus',
    icon: [
        640,
        512,
        [],
        "e067",
        "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
    ]
};
var faMagic = {
    prefix: 'fas',
    iconName: 'magic',
    icon: [
        512,
        512,
        [],
        "f0d0",
        "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
    ]
};
var faMagnet = {
    prefix: 'fas',
    iconName: 'magnet',
    icon: [
        512,
        512,
        [],
        "f076",
        "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
    ]
};
var faMailBulk = {
    prefix: 'fas',
    iconName: 'mail-bulk',
    icon: [
        576,
        512,
        [],
        "f674",
        "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
    ]
};
var faMale = {
    prefix: 'fas',
    iconName: 'male',
    icon: [
        192,
        512,
        [],
        "f183",
        "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
    ]
};
var faMap = {
    prefix: 'fas',
    iconName: 'map',
    icon: [
        576,
        512,
        [],
        "f279",
        "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var faMapMarked = {
    prefix: 'fas',
    iconName: 'map-marked',
    icon: [
        576,
        512,
        [],
        "f59f",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var faMapMarkedAlt = {
    prefix: 'fas',
    iconName: 'map-marked-alt',
    icon: [
        576,
        512,
        [],
        "f5a0",
        "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
    ]
};
var faMapMarker = {
    prefix: 'fas',
    iconName: 'map-marker',
    icon: [
        384,
        512,
        [],
        "f041",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
    ]
};
var faMapMarkerAlt = {
    prefix: 'fas',
    iconName: 'map-marker-alt',
    icon: [
        384,
        512,
        [],
        "f3c5",
        "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
    ]
};
var faMapPin = {
    prefix: 'fas',
    iconName: 'map-pin',
    icon: [
        288,
        512,
        [],
        "f276",
        "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
    ]
};
var faMapSigns = {
    prefix: 'fas',
    iconName: 'map-signs',
    icon: [
        512,
        512,
        [],
        "f277",
        "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
    ]
};
var faMarker = {
    prefix: 'fas',
    iconName: 'marker',
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
    ]
};
var faMars = {
    prefix: 'fas',
    iconName: 'mars',
    icon: [
        384,
        512,
        [],
        "f222",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faMarsDouble = {
    prefix: 'fas',
    iconName: 'mars-double',
    icon: [
        512,
        512,
        [],
        "f227",
        "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
    ]
};
var faMarsStroke = {
    prefix: 'fas',
    iconName: 'mars-stroke',
    icon: [
        384,
        512,
        [],
        "f229",
        "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faMarsStrokeH = {
    prefix: 'fas',
    iconName: 'mars-stroke-h',
    icon: [
        480,
        512,
        [],
        "f22b",
        "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var faMarsStrokeV = {
    prefix: 'fas',
    iconName: 'mars-stroke-v',
    icon: [
        288,
        512,
        [],
        "f22a",
        "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
    ]
};
var faMask = {
    prefix: 'fas',
    iconName: 'mask',
    icon: [
        640,
        512,
        [],
        "f6fa",
        "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
    ]
};
var faMedal = {
    prefix: 'fas',
    iconName: 'medal',
    icon: [
        512,
        512,
        [],
        "f5a2",
        "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
    ]
};
var faMedkit = {
    prefix: 'fas',
    iconName: 'medkit',
    icon: [
        512,
        512,
        [],
        "f0fa",
        "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
    ]
};
var faMeh = {
    prefix: 'fas',
    iconName: 'meh',
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faMehBlank = {
    prefix: 'fas',
    iconName: 'meh-blank',
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faMehRollingEyes = {
    prefix: 'fas',
    iconName: 'meh-rolling-eyes',
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
    ]
};
var faMemory = {
    prefix: 'fas',
    iconName: 'memory',
    icon: [
        640,
        512,
        [],
        "f538",
        "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
    ]
};
var faMenorah = {
    prefix: 'fas',
    iconName: 'menorah',
    icon: [
        640,
        512,
        [],
        "f676",
        "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
    ]
};
var faMercury = {
    prefix: 'fas',
    iconName: 'mercury',
    icon: [
        288,
        512,
        [],
        "f223",
        "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var faMeteor = {
    prefix: 'fas',
    iconName: 'meteor',
    icon: [
        512,
        512,
        [],
        "f753",
        "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
    ]
};
var faMicrochip = {
    prefix: 'fas',
    iconName: 'microchip',
    icon: [
        512,
        512,
        [],
        "f2db",
        "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
    ]
};
var faMicrophone = {
    prefix: 'fas',
    iconName: 'microphone',
    icon: [
        352,
        512,
        [],
        "f130",
        "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
    ]
};
var faMicrophoneAlt = {
    prefix: 'fas',
    iconName: 'microphone-alt',
    icon: [
        352,
        512,
        [],
        "f3c9",
        "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
    ]
};
var faMicrophoneAltSlash = {
    prefix: 'fas',
    iconName: 'microphone-alt-slash',
    icon: [
        640,
        512,
        [],
        "f539",
        "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var faMicrophoneSlash = {
    prefix: 'fas',
    iconName: 'microphone-slash',
    icon: [
        640,
        512,
        [],
        "f131",
        "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
    ]
};
var faMicroscope = {
    prefix: 'fas',
    iconName: 'microscope',
    icon: [
        512,
        512,
        [],
        "f610",
        "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
    ]
};
var faMinus = {
    prefix: 'fas',
    iconName: 'minus',
    icon: [
        448,
        512,
        [],
        "f068",
        "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faMinusCircle = {
    prefix: 'fas',
    iconName: 'minus-circle',
    icon: [
        512,
        512,
        [],
        "f056",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
    ]
};
var faMinusSquare = {
    prefix: 'fas',
    iconName: 'minus-square',
    icon: [
        448,
        512,
        [],
        "f146",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
    ]
};
var faMitten = {
    prefix: 'fas',
    iconName: 'mitten',
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
    ]
};
var faMobile = {
    prefix: 'fas',
    iconName: 'mobile',
    icon: [
        320,
        512,
        [],
        "f10b",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faMobileAlt = {
    prefix: 'fas',
    iconName: 'mobile-alt',
    icon: [
        320,
        512,
        [],
        "f3cd",
        "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
    ]
};
var faMoneyBill = {
    prefix: 'fas',
    iconName: 'money-bill',
    icon: [
        640,
        512,
        [],
        "f0d6",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var faMoneyBillAlt = {
    prefix: 'fas',
    iconName: 'money-bill-alt',
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
    ]
};
var faMoneyBillWave = {
    prefix: 'fas',
    iconName: 'money-bill-wave',
    icon: [
        640,
        512,
        [],
        "f53a",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
    ]
};
var faMoneyBillWaveAlt = {
    prefix: 'fas',
    iconName: 'money-bill-wave-alt',
    icon: [
        640,
        512,
        [],
        "f53b",
        "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
    ]
};
var faMoneyCheck = {
    prefix: 'fas',
    iconName: 'money-check',
    icon: [
        640,
        512,
        [],
        "f53c",
        "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
    ]
};
var faMoneyCheckAlt = {
    prefix: 'fas',
    iconName: 'money-check-alt',
    icon: [
        640,
        512,
        [],
        "f53d",
        "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
    ]
};
var faMonument = {
    prefix: 'fas',
    iconName: 'monument',
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
    ]
};
var faMoon = {
    prefix: 'fas',
    iconName: 'moon',
    icon: [
        512,
        512,
        [],
        "f186",
        "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
    ]
};
var faMortarPestle = {
    prefix: 'fas',
    iconName: 'mortar-pestle',
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
    ]
};
var faMosque = {
    prefix: 'fas',
    iconName: 'mosque',
    icon: [
        640,
        512,
        [],
        "f678",
        "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
    ]
};
var faMotorcycle = {
    prefix: 'fas',
    iconName: 'motorcycle',
    icon: [
        640,
        512,
        [],
        "f21c",
        "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
    ]
};
var faMountain = {
    prefix: 'fas',
    iconName: 'mountain',
    icon: [
        640,
        512,
        [],
        "f6fc",
        "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
    ]
};
var faMouse = {
    prefix: 'fas',
    iconName: 'mouse',
    icon: [
        384,
        512,
        [],
        "f8cc",
        "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
    ]
};
var faMousePointer = {
    prefix: 'fas',
    iconName: 'mouse-pointer',
    icon: [
        320,
        512,
        [],
        "f245",
        "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
    ]
};
var faMugHot = {
    prefix: 'fas',
    iconName: 'mug-hot',
    icon: [
        512,
        512,
        [],
        "f7b6",
        "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var faMusic = {
    prefix: 'fas',
    iconName: 'music',
    icon: [
        512,
        512,
        [],
        "f001",
        "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
    ]
};
var faNetworkWired = {
    prefix: 'fas',
    iconName: 'network-wired',
    icon: [
        640,
        512,
        [],
        "f6ff",
        "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
    ]
};
var faNeuter = {
    prefix: 'fas',
    iconName: 'neuter',
    icon: [
        288,
        512,
        [],
        "f22c",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faNewspaper = {
    prefix: 'fas',
    iconName: 'newspaper',
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
    ]
};
var faNotEqual = {
    prefix: 'fas',
    iconName: 'not-equal',
    icon: [
        448,
        512,
        [],
        "f53e",
        "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
    ]
};
var faNotesMedical = {
    prefix: 'fas',
    iconName: 'notes-medical',
    icon: [
        384,
        512,
        [],
        "f481",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
    ]
};
var faObjectGroup = {
    prefix: 'fas',
    iconName: 'object-group',
    icon: [
        512,
        512,
        [],
        "f247",
        "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
    ]
};
var faObjectUngroup = {
    prefix: 'fas',
    iconName: 'object-ungroup',
    icon: [
        576,
        512,
        [],
        "f248",
        "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
    ]
};
var faOilCan = {
    prefix: 'fas',
    iconName: 'oil-can',
    icon: [
        640,
        512,
        [],
        "f613",
        "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
    ]
};
var faOm = {
    prefix: 'fas',
    iconName: 'om',
    icon: [
        512,
        512,
        [],
        "f679",
        "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
    ]
};
var faOtter = {
    prefix: 'fas',
    iconName: 'otter',
    icon: [
        640,
        512,
        [],
        "f700",
        "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
    ]
};
var faOutdent = {
    prefix: 'fas',
    iconName: 'outdent',
    icon: [
        448,
        512,
        [],
        "f03b",
        "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faPager = {
    prefix: 'fas',
    iconName: 'pager',
    icon: [
        512,
        512,
        [],
        "f815",
        "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
    ]
};
var faPaintBrush = {
    prefix: 'fas',
    iconName: 'paint-brush',
    icon: [
        512,
        512,
        [],
        "f1fc",
        "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
    ]
};
var faPaintRoller = {
    prefix: 'fas',
    iconName: 'paint-roller',
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
    ]
};
var faPalette = {
    prefix: 'fas',
    iconName: 'palette',
    icon: [
        512,
        512,
        [],
        "f53f",
        "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faPallet = {
    prefix: 'fas',
    iconName: 'pallet',
    icon: [
        640,
        512,
        [],
        "f482",
        "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
    ]
};
var faPaperPlane = {
    prefix: 'fas',
    iconName: 'paper-plane',
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
    ]
};
var faPaperclip = {
    prefix: 'fas',
    iconName: 'paperclip',
    icon: [
        448,
        512,
        [],
        "f0c6",
        "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
    ]
};
var faParachuteBox = {
    prefix: 'fas',
    iconName: 'parachute-box',
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
    ]
};
var faParagraph = {
    prefix: 'fas',
    iconName: 'paragraph',
    icon: [
        448,
        512,
        [],
        "f1dd",
        "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
    ]
};
var faParking = {
    prefix: 'fas',
    iconName: 'parking',
    icon: [
        448,
        512,
        [],
        "f540",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
    ]
};
var faPassport = {
    prefix: 'fas',
    iconName: 'passport',
    icon: [
        448,
        512,
        [],
        "f5ab",
        "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
    ]
};
var faPastafarianism = {
    prefix: 'fas',
    iconName: 'pastafarianism',
    icon: [
        640,
        512,
        [],
        "f67b",
        "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
    ]
};
var faPaste = {
    prefix: 'fas',
    iconName: 'paste',
    icon: [
        448,
        512,
        [],
        "f0ea",
        "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
    ]
};
var faPause = {
    prefix: 'fas',
    iconName: 'pause',
    icon: [
        448,
        512,
        [],
        "f04c",
        "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
    ]
};
var faPauseCircle = {
    prefix: 'fas',
    iconName: 'pause-circle',
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
    ]
};
var faPaw = {
    prefix: 'fas',
    iconName: 'paw',
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
    ]
};
var faPeace = {
    prefix: 'fas',
    iconName: 'peace',
    icon: [
        496,
        512,
        [],
        "f67c",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
    ]
};
var faPen = {
    prefix: 'fas',
    iconName: 'pen',
    icon: [
        512,
        512,
        [],
        "f304",
        "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
    ]
};
var faPenAlt = {
    prefix: 'fas',
    iconName: 'pen-alt',
    icon: [
        512,
        512,
        [],
        "f305",
        "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
    ]
};
var faPenFancy = {
    prefix: 'fas',
    iconName: 'pen-fancy',
    icon: [
        512,
        512,
        [],
        "f5ac",
        "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
    ]
};
var faPenNib = {
    prefix: 'fas',
    iconName: 'pen-nib',
    icon: [
        512,
        512,
        [],
        "f5ad",
        "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
    ]
};
var faPenSquare = {
    prefix: 'fas',
    iconName: 'pen-square',
    icon: [
        448,
        512,
        [],
        "f14b",
        "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
    ]
};
var faPencilAlt = {
    prefix: 'fas',
    iconName: 'pencil-alt',
    icon: [
        512,
        512,
        [],
        "f303",
        "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
    ]
};
var faPencilRuler = {
    prefix: 'fas',
    iconName: 'pencil-ruler',
    icon: [
        512,
        512,
        [],
        "f5ae",
        "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
    ]
};
var faPeopleArrows = {
    prefix: 'fas',
    iconName: 'people-arrows',
    icon: [
        576,
        512,
        [],
        "e068",
        "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
    ]
};
var faPeopleCarry = {
    prefix: 'fas',
    iconName: 'people-carry',
    icon: [
        640,
        512,
        [],
        "f4ce",
        "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
    ]
};
var faPepperHot = {
    prefix: 'fas',
    iconName: 'pepper-hot',
    icon: [
        512,
        512,
        [],
        "f816",
        "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
    ]
};
var faPercent = {
    prefix: 'fas',
    iconName: 'percent',
    icon: [
        448,
        512,
        [],
        "f295",
        "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
    ]
};
var faPercentage = {
    prefix: 'fas',
    iconName: 'percentage',
    icon: [
        384,
        512,
        [],
        "f541",
        "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
    ]
};
var faPersonBooth = {
    prefix: 'fas',
    iconName: 'person-booth',
    icon: [
        576,
        512,
        [],
        "f756",
        "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
    ]
};
var faPhone = {
    prefix: 'fas',
    iconName: 'phone',
    icon: [
        512,
        512,
        [],
        "f095",
        "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
    ]
};
var faPhoneAlt = {
    prefix: 'fas',
    iconName: 'phone-alt',
    icon: [
        512,
        512,
        [],
        "f879",
        "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
    ]
};
var faPhoneSlash = {
    prefix: 'fas',
    iconName: 'phone-slash',
    icon: [
        640,
        512,
        [],
        "f3dd",
        "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
    ]
};
var faPhoneSquare = {
    prefix: 'fas',
    iconName: 'phone-square',
    icon: [
        448,
        512,
        [],
        "f098",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
    ]
};
var faPhoneSquareAlt = {
    prefix: 'fas',
    iconName: 'phone-square-alt',
    icon: [
        448,
        512,
        [],
        "f87b",
        "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
    ]
};
var faPhoneVolume = {
    prefix: 'fas',
    iconName: 'phone-volume',
    icon: [
        384,
        512,
        [],
        "f2a0",
        "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
    ]
};
var faPhotoVideo = {
    prefix: 'fas',
    iconName: 'photo-video',
    icon: [
        640,
        512,
        [],
        "f87c",
        "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
    ]
};
var faPiggyBank = {
    prefix: 'fas',
    iconName: 'piggy-bank',
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
    ]
};
var faPills = {
    prefix: 'fas',
    iconName: 'pills',
    icon: [
        576,
        512,
        [],
        "f484",
        "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
    ]
};
var faPizzaSlice = {
    prefix: 'fas',
    iconName: 'pizza-slice',
    icon: [
        512,
        512,
        [],
        "f818",
        "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
    ]
};
var faPlaceOfWorship = {
    prefix: 'fas',
    iconName: 'place-of-worship',
    icon: [
        640,
        512,
        [],
        "f67f",
        "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
    ]
};
var faPlane = {
    prefix: 'fas',
    iconName: 'plane',
    icon: [
        576,
        512,
        [],
        "f072",
        "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
    ]
};
var faPlaneArrival = {
    prefix: 'fas',
    iconName: 'plane-arrival',
    icon: [
        640,
        512,
        [],
        "f5af",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
    ]
};
var faPlaneDeparture = {
    prefix: 'fas',
    iconName: 'plane-departure',
    icon: [
        640,
        512,
        [],
        "f5b0",
        "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
    ]
};
var faPlaneSlash = {
    prefix: 'fas',
    iconName: 'plane-slash',
    icon: [
        640,
        512,
        [],
        "e069",
        "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
    ]
};
var faPlay = {
    prefix: 'fas',
    iconName: 'play',
    icon: [
        448,
        512,
        [],
        "f04b",
        "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
    ]
};
var faPlayCircle = {
    prefix: 'fas',
    iconName: 'play-circle',
    icon: [
        512,
        512,
        [],
        "f144",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
    ]
};
var faPlug = {
    prefix: 'fas',
    iconName: 'plug',
    icon: [
        384,
        512,
        [],
        "f1e6",
        "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
    ]
};
var faPlus = {
    prefix: 'fas',
    iconName: 'plus',
    icon: [
        448,
        512,
        [],
        "f067",
        "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    ]
};
var faPlusCircle = {
    prefix: 'fas',
    iconName: 'plus-circle',
    icon: [
        512,
        512,
        [],
        "f055",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var faPlusSquare = {
    prefix: 'fas',
    iconName: 'plus-square',
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
    ]
};
var faPodcast = {
    prefix: 'fas',
    iconName: 'podcast',
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
    ]
};
var faPoll = {
    prefix: 'fas',
    iconName: 'poll',
    icon: [
        448,
        512,
        [],
        "f681",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
    ]
};
var faPollH = {
    prefix: 'fas',
    iconName: 'poll-h',
    icon: [
        448,
        512,
        [],
        "f682",
        "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
    ]
};
var faPoo = {
    prefix: 'fas',
    iconName: 'poo',
    icon: [
        512,
        512,
        [],
        "f2fe",
        "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faPooStorm = {
    prefix: 'fas',
    iconName: 'poo-storm',
    icon: [
        448,
        512,
        [],
        "f75a",
        "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
    ]
};
var faPoop = {
    prefix: 'fas',
    iconName: 'poop',
    icon: [
        512,
        512,
        [],
        "f619",
        "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
    ]
};
var faPortrait = {
    prefix: 'fas',
    iconName: 'portrait',
    icon: [
        384,
        512,
        [],
        "f3e0",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
    ]
};
var faPoundSign = {
    prefix: 'fas',
    iconName: 'pound-sign',
    icon: [
        320,
        512,
        [],
        "f154",
        "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
    ]
};
var faPowerOff = {
    prefix: 'fas',
    iconName: 'power-off',
    icon: [
        512,
        512,
        [],
        "f011",
        "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
    ]
};
var faPray = {
    prefix: 'fas',
    iconName: 'pray',
    icon: [
        384,
        512,
        [],
        "f683",
        "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
    ]
};
var faPrayingHands = {
    prefix: 'fas',
    iconName: 'praying-hands',
    icon: [
        640,
        512,
        [],
        "f684",
        "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
    ]
};
var faPrescription = {
    prefix: 'fas',
    iconName: 'prescription',
    icon: [
        384,
        512,
        [],
        "f5b1",
        "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
    ]
};
var faPrescriptionBottle = {
    prefix: 'fas',
    iconName: 'prescription-bottle',
    icon: [
        384,
        512,
        [],
        "f485",
        "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
    ]
};
var faPrescriptionBottleAlt = {
    prefix: 'fas',
    iconName: 'prescription-bottle-alt',
    icon: [
        384,
        512,
        [],
        "f486",
        "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
    ]
};
var faPrint = {
    prefix: 'fas',
    iconName: 'print',
    icon: [
        512,
        512,
        [],
        "f02f",
        "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faProcedures = {
    prefix: 'fas',
    iconName: 'procedures',
    icon: [
        640,
        512,
        [],
        "f487",
        "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var faProjectDiagram = {
    prefix: 'fas',
    iconName: 'project-diagram',
    icon: [
        640,
        512,
        [],
        "f542",
        "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
    ]
};
var faPumpMedical = {
    prefix: 'fas',
    iconName: 'pump-medical',
    icon: [
        384,
        512,
        [],
        "e06a",
        "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
    ]
};
var faPumpSoap = {
    prefix: 'fas',
    iconName: 'pump-soap',
    icon: [
        384,
        512,
        [],
        "e06b",
        "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
    ]
};
var faPuzzlePiece = {
    prefix: 'fas',
    iconName: 'puzzle-piece',
    icon: [
        576,
        512,
        [],
        "f12e",
        "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
    ]
};
var faQrcode = {
    prefix: 'fas',
    iconName: 'qrcode',
    icon: [
        448,
        512,
        [],
        "f029",
        "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
    ]
};
var faQuestion = {
    prefix: 'fas',
    iconName: 'question',
    icon: [
        384,
        512,
        [],
        "f128",
        "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
    ]
};
var faQuestionCircle = {
    prefix: 'fas',
    iconName: 'question-circle',
    icon: [
        512,
        512,
        [],
        "f059",
        "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
    ]
};
var faQuidditch = {
    prefix: 'fas',
    iconName: 'quidditch',
    icon: [
        640,
        512,
        [],
        "f458",
        "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
    ]
};
var faQuoteLeft = {
    prefix: 'fas',
    iconName: 'quote-left',
    icon: [
        512,
        512,
        [],
        "f10d",
        "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var faQuoteRight = {
    prefix: 'fas',
    iconName: 'quote-right',
    icon: [
        512,
        512,
        [],
        "f10e",
        "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
    ]
};
var faQuran = {
    prefix: 'fas',
    iconName: 'quran',
    icon: [
        448,
        512,
        [],
        "f687",
        "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
    ]
};
var faRadiation = {
    prefix: 'fas',
    iconName: 'radiation',
    icon: [
        496,
        512,
        [],
        "f7b9",
        "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
    ]
};
var faRadiationAlt = {
    prefix: 'fas',
    iconName: 'radiation-alt',
    icon: [
        496,
        512,
        [],
        "f7ba",
        "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var faRainbow = {
    prefix: 'fas',
    iconName: 'rainbow',
    icon: [
        576,
        512,
        [],
        "f75b",
        "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
    ]
};
var faRandom = {
    prefix: 'fas',
    iconName: 'random',
    icon: [
        512,
        512,
        [],
        "f074",
        "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
    ]
};
var faReceipt = {
    prefix: 'fas',
    iconName: 'receipt',
    icon: [
        384,
        512,
        [],
        "f543",
        "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
    ]
};
var faRecordVinyl = {
    prefix: 'fas',
    iconName: 'record-vinyl',
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
    ]
};
var faRecycle = {
    prefix: 'fas',
    iconName: 'recycle',
    icon: [
        512,
        512,
        [],
        "f1b8",
        "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
    ]
};
var faRedo = {
    prefix: 'fas',
    iconName: 'redo',
    icon: [
        512,
        512,
        [],
        "f01e",
        "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
    ]
};
var faRedoAlt = {
    prefix: 'fas',
    iconName: 'redo-alt',
    icon: [
        512,
        512,
        [],
        "f2f9",
        "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
    ]
};
var faRegistered = {
    prefix: 'fas',
    iconName: 'registered',
    icon: [
        512,
        512,
        [],
        "f25d",
        "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
    ]
};
var faRemoveFormat = {
    prefix: 'fas',
    iconName: 'remove-format',
    icon: [
        640,
        512,
        [],
        "f87d",
        "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
    ]
};
var faReply = {
    prefix: 'fas',
    iconName: 'reply',
    icon: [
        512,
        512,
        [],
        "f3e5",
        "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
    ]
};
var faReplyAll = {
    prefix: 'fas',
    iconName: 'reply-all',
    icon: [
        576,
        512,
        [],
        "f122",
        "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
    ]
};
var faRepublican = {
    prefix: 'fas',
    iconName: 'republican',
    icon: [
        640,
        512,
        [],
        "f75e",
        "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
    ]
};
var faRestroom = {
    prefix: 'fas',
    iconName: 'restroom',
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
    ]
};
var faRetweet = {
    prefix: 'fas',
    iconName: 'retweet',
    icon: [
        640,
        512,
        [],
        "f079",
        "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
    ]
};
var faRibbon = {
    prefix: 'fas',
    iconName: 'ribbon',
    icon: [
        448,
        512,
        [],
        "f4d6",
        "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
    ]
};
var faRing = {
    prefix: 'fas',
    iconName: 'ring',
    icon: [
        512,
        512,
        [],
        "f70b",
        "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
    ]
};
var faRoad = {
    prefix: 'fas',
    iconName: 'road',
    icon: [
        576,
        512,
        [],
        "f018",
        "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
    ]
};
var faRobot = {
    prefix: 'fas',
    iconName: 'robot',
    icon: [
        640,
        512,
        [],
        "f544",
        "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
    ]
};
var faRocket = {
    prefix: 'fas',
    iconName: 'rocket',
    icon: [
        512,
        512,
        [],
        "f135",
        "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
    ]
};
var faRoute = {
    prefix: 'fas',
    iconName: 'route',
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faRss = {
    prefix: 'fas',
    iconName: 'rss',
    icon: [
        448,
        512,
        [],
        "f09e",
        "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
    ]
};
var faRssSquare = {
    prefix: 'fas',
    iconName: 'rss-square',
    icon: [
        448,
        512,
        [],
        "f143",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
    ]
};
var faRubleSign = {
    prefix: 'fas',
    iconName: 'ruble-sign',
    icon: [
        384,
        512,
        [],
        "f158",
        "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
    ]
};
var faRuler = {
    prefix: 'fas',
    iconName: 'ruler',
    icon: [
        640,
        512,
        [],
        "f545",
        "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
    ]
};
var faRulerCombined = {
    prefix: 'fas',
    iconName: 'ruler-combined',
    icon: [
        512,
        512,
        [],
        "f546",
        "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var faRulerHorizontal = {
    prefix: 'fas',
    iconName: 'ruler-horizontal',
    icon: [
        576,
        512,
        [],
        "f547",
        "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
    ]
};
var faRulerVertical = {
    prefix: 'fas',
    iconName: 'ruler-vertical',
    icon: [
        256,
        512,
        [],
        "f548",
        "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
    ]
};
var faRunning = {
    prefix: 'fas',
    iconName: 'running',
    icon: [
        416,
        512,
        [],
        "f70c",
        "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
    ]
};
var faRupeeSign = {
    prefix: 'fas',
    iconName: 'rupee-sign',
    icon: [
        320,
        512,
        [],
        "f156",
        "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
    ]
};
var faSadCry = {
    prefix: 'fas',
    iconName: 'sad-cry',
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
    ]
};
var faSadTear = {
    prefix: 'fas',
    iconName: 'sad-tear',
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
    ]
};
var faSatellite = {
    prefix: 'fas',
    iconName: 'satellite',
    icon: [
        512,
        512,
        [],
        "f7bf",
        "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
    ]
};
var faSatelliteDish = {
    prefix: 'fas',
    iconName: 'satellite-dish',
    icon: [
        512,
        512,
        [],
        "f7c0",
        "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
    ]
};
var faSave = {
    prefix: 'fas',
    iconName: 'save',
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
    ]
};
var faSchool = {
    prefix: 'fas',
    iconName: 'school',
    icon: [
        640,
        512,
        [],
        "f549",
        "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
    ]
};
var faScrewdriver = {
    prefix: 'fas',
    iconName: 'screwdriver',
    icon: [
        512,
        512,
        [],
        "f54a",
        "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
    ]
};
var faScroll = {
    prefix: 'fas',
    iconName: 'scroll',
    icon: [
        640,
        512,
        [],
        "f70e",
        "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
    ]
};
var faSdCard = {
    prefix: 'fas',
    iconName: 'sd-card',
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
    ]
};
var faSearch = {
    prefix: 'fas',
    iconName: 'search',
    icon: [
        512,
        512,
        [],
        "f002",
        "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
    ]
};
var faSearchDollar = {
    prefix: 'fas',
    iconName: 'search-dollar',
    icon: [
        512,
        512,
        [],
        "f688",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
    ]
};
var faSearchLocation = {
    prefix: 'fas',
    iconName: 'search-location',
    icon: [
        512,
        512,
        [],
        "f689",
        "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faSearchMinus = {
    prefix: 'fas',
    iconName: 'search-minus',
    icon: [
        512,
        512,
        [],
        "f010",
        "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var faSearchPlus = {
    prefix: 'fas',
    iconName: 'search-plus',
    icon: [
        512,
        512,
        [],
        "f00e",
        "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
    ]
};
var faSeedling = {
    prefix: 'fas',
    iconName: 'seedling',
    icon: [
        512,
        512,
        [],
        "f4d8",
        "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
    ]
};
var faServer = {
    prefix: 'fas',
    iconName: 'server',
    icon: [
        512,
        512,
        [],
        "f233",
        "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
    ]
};
var faShapes = {
    prefix: 'fas',
    iconName: 'shapes',
    icon: [
        512,
        512,
        [],
        "f61f",
        "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
    ]
};
var faShare = {
    prefix: 'fas',
    iconName: 'share',
    icon: [
        512,
        512,
        [],
        "f064",
        "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
    ]
};
var faShareAlt = {
    prefix: 'fas',
    iconName: 'share-alt',
    icon: [
        448,
        512,
        [],
        "f1e0",
        "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
    ]
};
var faShareAltSquare = {
    prefix: 'fas',
    iconName: 'share-alt-square',
    icon: [
        448,
        512,
        [],
        "f1e1",
        "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
    ]
};
var faShareSquare = {
    prefix: 'fas',
    iconName: 'share-square',
    icon: [
        576,
        512,
        [],
        "f14d",
        "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
    ]
};
var faShekelSign = {
    prefix: 'fas',
    iconName: 'shekel-sign',
    icon: [
        448,
        512,
        [],
        "f20b",
        "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
    ]
};
var faShieldAlt = {
    prefix: 'fas',
    iconName: 'shield-alt',
    icon: [
        512,
        512,
        [],
        "f3ed",
        "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
    ]
};
var faShieldVirus = {
    prefix: 'fas',
    iconName: 'shield-virus',
    icon: [
        512,
        512,
        [],
        "e06c",
        "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
    ]
};
var faShip = {
    prefix: 'fas',
    iconName: 'ship',
    icon: [
        640,
        512,
        [],
        "f21a",
        "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
    ]
};
var faShippingFast = {
    prefix: 'fas',
    iconName: 'shipping-fast',
    icon: [
        640,
        512,
        [],
        "f48b",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var faShoePrints = {
    prefix: 'fas',
    iconName: 'shoe-prints',
    icon: [
        640,
        512,
        [],
        "f54b",
        "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
    ]
};
var faShoppingBag = {
    prefix: 'fas',
    iconName: 'shopping-bag',
    icon: [
        448,
        512,
        [],
        "f290",
        "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
    ]
};
var faShoppingBasket = {
    prefix: 'fas',
    iconName: 'shopping-basket',
    icon: [
        576,
        512,
        [],
        "f291",
        "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
    ]
};
var faShoppingCart = {
    prefix: 'fas',
    iconName: 'shopping-cart',
    icon: [
        576,
        512,
        [],
        "f07a",
        "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
    ]
};
var faShower = {
    prefix: 'fas',
    iconName: 'shower',
    icon: [
        512,
        512,
        [],
        "f2cc",
        "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
    ]
};
var faShuttleVan = {
    prefix: 'fas',
    iconName: 'shuttle-van',
    icon: [
        640,
        512,
        [],
        "f5b6",
        "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
    ]
};
var faSign = {
    prefix: 'fas',
    iconName: 'sign',
    icon: [
        512,
        512,
        [],
        "f4d9",
        "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
    ]
};
var faSignInAlt = {
    prefix: 'fas',
    iconName: 'sign-in-alt',
    icon: [
        512,
        512,
        [],
        "f2f6",
        "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
    ]
};
var faSignLanguage = {
    prefix: 'fas',
    iconName: 'sign-language',
    icon: [
        448,
        512,
        [],
        "f2a7",
        "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
    ]
};
var faSignOutAlt = {
    prefix: 'fas',
    iconName: 'sign-out-alt',
    icon: [
        512,
        512,
        [],
        "f2f5",
        "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
    ]
};
var faSignal = {
    prefix: 'fas',
    iconName: 'signal',
    icon: [
        640,
        512,
        [],
        "f012",
        "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
    ]
};
var faSignature = {
    prefix: 'fas',
    iconName: 'signature',
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
    ]
};
var faSimCard = {
    prefix: 'fas',
    iconName: 'sim-card',
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
    ]
};
var faSink = {
    prefix: 'fas',
    iconName: 'sink',
    icon: [
        512,
        512,
        [],
        "e06d",
        "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
    ]
};
var faSitemap = {
    prefix: 'fas',
    iconName: 'sitemap',
    icon: [
        640,
        512,
        [],
        "f0e8",
        "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
    ]
};
var faSkating = {
    prefix: 'fas',
    iconName: 'skating',
    icon: [
        448,
        512,
        [],
        "f7c5",
        "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var faSkiing = {
    prefix: 'fas',
    iconName: 'skiing',
    icon: [
        512,
        512,
        [],
        "f7c9",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
    ]
};
var faSkiingNordic = {
    prefix: 'fas',
    iconName: 'skiing-nordic',
    icon: [
        576,
        512,
        [],
        "f7ca",
        "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
    ]
};
var faSkull = {
    prefix: 'fas',
    iconName: 'skull',
    icon: [
        512,
        512,
        [],
        "f54c",
        "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
    ]
};
var faSkullCrossbones = {
    prefix: 'fas',
    iconName: 'skull-crossbones',
    icon: [
        448,
        512,
        [],
        "f714",
        "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
    ]
};
var faSlash = {
    prefix: 'fas',
    iconName: 'slash',
    icon: [
        640,
        512,
        [],
        "f715",
        "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
    ]
};
var faSleigh = {
    prefix: 'fas',
    iconName: 'sleigh',
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
    ]
};
var faSlidersH = {
    prefix: 'fas',
    iconName: 'sliders-h',
    icon: [
        512,
        512,
        [],
        "f1de",
        "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
    ]
};
var faSmile = {
    prefix: 'fas',
    iconName: 'smile',
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
    ]
};
var faSmileBeam = {
    prefix: 'fas',
    iconName: 'smile-beam',
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
    ]
};
var faSmileWink = {
    prefix: 'fas',
    iconName: 'smile-wink',
    icon: [
        496,
        512,
        [],
        "f4da",
        "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
    ]
};
var faSmog = {
    prefix: 'fas',
    iconName: 'smog',
    icon: [
        640,
        512,
        [],
        "f75f",
        "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
    ]
};
var faSmoking = {
    prefix: 'fas',
    iconName: 'smoking',
    icon: [
        640,
        512,
        [],
        "f48d",
        "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
    ]
};
var faSmokingBan = {
    prefix: 'fas',
    iconName: 'smoking-ban',
    icon: [
        512,
        512,
        [],
        "f54d",
        "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
    ]
};
var faSms = {
    prefix: 'fas',
    iconName: 'sms',
    icon: [
        512,
        512,
        [],
        "f7cd",
        "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
    ]
};
var faSnowboarding = {
    prefix: 'fas',
    iconName: 'snowboarding',
    icon: [
        512,
        512,
        [],
        "f7ce",
        "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
    ]
};
var faSnowflake = {
    prefix: 'fas',
    iconName: 'snowflake',
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
    ]
};
var faSnowman = {
    prefix: 'fas',
    iconName: 'snowman',
    icon: [
        512,
        512,
        [],
        "f7d0",
        "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faSnowplow = {
    prefix: 'fas',
    iconName: 'snowplow',
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var faSoap = {
    prefix: 'fas',
    iconName: 'soap',
    icon: [
        512,
        512,
        [],
        "e06e",
        "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
    ]
};
var faSocks = {
    prefix: 'fas',
    iconName: 'socks',
    icon: [
        512,
        512,
        [],
        "f696",
        "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
    ]
};
var faSolarPanel = {
    prefix: 'fas',
    iconName: 'solar-panel',
    icon: [
        640,
        512,
        [],
        "f5ba",
        "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
    ]
};
var faSort = {
    prefix: 'fas',
    iconName: 'sort',
    icon: [
        320,
        512,
        [],
        "f0dc",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
    ]
};
var faSortAlphaDown = {
    prefix: 'fas',
    iconName: 'sort-alpha-down',
    icon: [
        448,
        512,
        [],
        "f15d",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var faSortAlphaDownAlt = {
    prefix: 'fas',
    iconName: 'sort-alpha-down-alt',
    icon: [
        448,
        512,
        [],
        "f881",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var faSortAlphaUp = {
    prefix: 'fas',
    iconName: 'sort-alpha-up',
    icon: [
        448,
        512,
        [],
        "f15e",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
    ]
};
var faSortAlphaUpAlt = {
    prefix: 'fas',
    iconName: 'sort-alpha-up-alt',
    icon: [
        448,
        512,
        [],
        "f882",
        "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
    ]
};
var faSortAmountDown = {
    prefix: 'fas',
    iconName: 'sort-amount-down',
    icon: [
        512,
        512,
        [],
        "f160",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faSortAmountDownAlt = {
    prefix: 'fas',
    iconName: 'sort-amount-down-alt',
    icon: [
        512,
        512,
        [],
        "f884",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var faSortAmountUp = {
    prefix: 'fas',
    iconName: 'sort-amount-up',
    icon: [
        512,
        512,
        [],
        "f161",
        "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faSortAmountUpAlt = {
    prefix: 'fas',
    iconName: 'sort-amount-up-alt',
    icon: [
        512,
        512,
        [],
        "f885",
        "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
    ]
};
var faSortDown = {
    prefix: 'fas',
    iconName: 'sort-down',
    icon: [
        320,
        512,
        [],
        "f0dd",
        "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
    ]
};
var faSortNumericDown = {
    prefix: 'fas',
    iconName: 'sort-numeric-down',
    icon: [
        448,
        512,
        [],
        "f162",
        "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
    ]
};
var faSortNumericDownAlt = {
    prefix: 'fas',
    iconName: 'sort-numeric-down-alt',
    icon: [
        448,
        512,
        [],
        "f886",
        "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var faSortNumericUp = {
    prefix: 'fas',
    iconName: 'sort-numeric-up',
    icon: [
        448,
        512,
        [],
        "f163",
        "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
    ]
};
var faSortNumericUpAlt = {
    prefix: 'fas',
    iconName: 'sort-numeric-up-alt',
    icon: [
        448,
        512,
        [],
        "f887",
        "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
    ]
};
var faSortUp = {
    prefix: 'fas',
    iconName: 'sort-up',
    icon: [
        320,
        512,
        [],
        "f0de",
        "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
    ]
};
var faSpa = {
    prefix: 'fas',
    iconName: 'spa',
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
    ]
};
var faSpaceShuttle = {
    prefix: 'fas',
    iconName: 'space-shuttle',
    icon: [
        640,
        512,
        [],
        "f197",
        "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
    ]
};
var faSpellCheck = {
    prefix: 'fas',
    iconName: 'spell-check',
    icon: [
        576,
        512,
        [],
        "f891",
        "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
    ]
};
var faSpider = {
    prefix: 'fas',
    iconName: 'spider',
    icon: [
        576,
        512,
        [],
        "f717",
        "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
    ]
};
var faSpinner = {
    prefix: 'fas',
    iconName: 'spinner',
    icon: [
        512,
        512,
        [],
        "f110",
        "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
    ]
};
var faSplotch = {
    prefix: 'fas',
    iconName: 'splotch',
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
    ]
};
var faSprayCan = {
    prefix: 'fas',
    iconName: 'spray-can',
    icon: [
        512,
        512,
        [],
        "f5bd",
        "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var faSquare = {
    prefix: 'fas',
    iconName: 'square',
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var faSquareFull = {
    prefix: 'fas',
    iconName: 'square-full',
    icon: [
        512,
        512,
        [],
        "f45c",
        "M512 512H0V0h512v512z"
    ]
};
var faSquareRootAlt = {
    prefix: 'fas',
    iconName: 'square-root-alt',
    icon: [
        576,
        512,
        [],
        "f698",
        "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
    ]
};
var faStamp = {
    prefix: 'fas',
    iconName: 'stamp',
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
    ]
};
var faStar = {
    prefix: 'fas',
    iconName: 'star',
    icon: [
        576,
        512,
        [],
        "f005",
        "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
    ]
};
var faStarAndCrescent = {
    prefix: 'fas',
    iconName: 'star-and-crescent',
    icon: [
        512,
        512,
        [],
        "f699",
        "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
    ]
};
var faStarHalf = {
    prefix: 'fas',
    iconName: 'star-half',
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
    ]
};
var faStarHalfAlt = {
    prefix: 'fas',
    iconName: 'star-half-alt',
    icon: [
        536,
        512,
        [],
        "f5c0",
        "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
    ]
};
var faStarOfDavid = {
    prefix: 'fas',
    iconName: 'star-of-david',
    icon: [
        464,
        512,
        [],
        "f69a",
        "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
    ]
};
var faStarOfLife = {
    prefix: 'fas',
    iconName: 'star-of-life',
    icon: [
        480,
        512,
        [],
        "f621",
        "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
    ]
};
var faStepBackward = {
    prefix: 'fas',
    iconName: 'step-backward',
    icon: [
        448,
        512,
        [],
        "f048",
        "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
    ]
};
var faStepForward = {
    prefix: 'fas',
    iconName: 'step-forward',
    icon: [
        448,
        512,
        [],
        "f051",
        "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
    ]
};
var faStethoscope = {
    prefix: 'fas',
    iconName: 'stethoscope',
    icon: [
        512,
        512,
        [],
        "f0f1",
        "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var faStickyNote = {
    prefix: 'fas',
    iconName: 'sticky-note',
    icon: [
        448,
        512,
        [],
        "f249",
        "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
    ]
};
var faStop = {
    prefix: 'fas',
    iconName: 'stop',
    icon: [
        448,
        512,
        [],
        "f04d",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
    ]
};
var faStopCircle = {
    prefix: 'fas',
    iconName: 'stop-circle',
    icon: [
        512,
        512,
        [],
        "f28d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
    ]
};
var faStopwatch = {
    prefix: 'fas',
    iconName: 'stopwatch',
    icon: [
        448,
        512,
        [],
        "f2f2",
        "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
    ]
};
var faStopwatch20 = {
    prefix: 'fas',
    iconName: 'stopwatch-20',
    icon: [
        448,
        512,
        [],
        "e06f",
        "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
    ]
};
var faStore = {
    prefix: 'fas',
    iconName: 'store',
    icon: [
        616,
        512,
        [],
        "f54e",
        "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
    ]
};
var faStoreAlt = {
    prefix: 'fas',
    iconName: 'store-alt',
    icon: [
        640,
        512,
        [],
        "f54f",
        "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
    ]
};
var faStoreAltSlash = {
    prefix: 'fas',
    iconName: 'store-alt-slash',
    icon: [
        640,
        512,
        [],
        "e070",
        "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
    ]
};
var faStoreSlash = {
    prefix: 'fas',
    iconName: 'store-slash',
    icon: [
        640,
        512,
        [],
        "e071",
        "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
    ]
};
var faStream = {
    prefix: 'fas',
    iconName: 'stream',
    icon: [
        512,
        512,
        [],
        "f550",
        "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
    ]
};
var faStreetView = {
    prefix: 'fas',
    iconName: 'street-view',
    icon: [
        512,
        512,
        [],
        "f21d",
        "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
    ]
};
var faStrikethrough = {
    prefix: 'fas',
    iconName: 'strikethrough',
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
    ]
};
var faStroopwafel = {
    prefix: 'fas',
    iconName: 'stroopwafel',
    icon: [
        512,
        512,
        [],
        "f551",
        "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
    ]
};
var faSubscript = {
    prefix: 'fas',
    iconName: 'subscript',
    icon: [
        512,
        512,
        [],
        "f12c",
        "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var faSubway = {
    prefix: 'fas',
    iconName: 'subway',
    icon: [
        448,
        512,
        [],
        "f239",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var faSuitcase = {
    prefix: 'fas',
    iconName: 'suitcase',
    icon: [
        512,
        512,
        [],
        "f0f2",
        "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
    ]
};
var faSuitcaseRolling = {
    prefix: 'fas',
    iconName: 'suitcase-rolling',
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
    ]
};
var faSun = {
    prefix: 'fas',
    iconName: 'sun',
    icon: [
        512,
        512,
        [],
        "f185",
        "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
    ]
};
var faSuperscript = {
    prefix: 'fas',
    iconName: 'superscript',
    icon: [
        512,
        512,
        [],
        "f12b",
        "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
    ]
};
var faSurprise = {
    prefix: 'fas',
    iconName: 'surprise',
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faSwatchbook = {
    prefix: 'fas',
    iconName: 'swatchbook',
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
    ]
};
var faSwimmer = {
    prefix: 'fas',
    iconName: 'swimmer',
    icon: [
        640,
        512,
        [],
        "f5c4",
        "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
    ]
};
var faSwimmingPool = {
    prefix: 'fas',
    iconName: 'swimming-pool',
    icon: [
        640,
        512,
        [],
        "f5c5",
        "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
    ]
};
var faSynagogue = {
    prefix: 'fas',
    iconName: 'synagogue',
    icon: [
        640,
        512,
        [],
        "f69b",
        "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
    ]
};
var faSync = {
    prefix: 'fas',
    iconName: 'sync',
    icon: [
        512,
        512,
        [],
        "f021",
        "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
    ]
};
var faSyncAlt = {
    prefix: 'fas',
    iconName: 'sync-alt',
    icon: [
        512,
        512,
        [],
        "f2f1",
        "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
    ]
};
var faSyringe = {
    prefix: 'fas',
    iconName: 'syringe',
    icon: [
        512,
        512,
        [],
        "f48e",
        "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
    ]
};
var faTable = {
    prefix: 'fas',
    iconName: 'table',
    icon: [
        512,
        512,
        [],
        "f0ce",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
    ]
};
var faTableTennis = {
    prefix: 'fas',
    iconName: 'table-tennis',
    icon: [
        512,
        512,
        [],
        "f45d",
        "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
    ]
};
var faTablet = {
    prefix: 'fas',
    iconName: 'tablet',
    icon: [
        448,
        512,
        [],
        "f10a",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var faTabletAlt = {
    prefix: 'fas',
    iconName: 'tablet-alt',
    icon: [
        448,
        512,
        [],
        "f3fa",
        "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
    ]
};
var faTablets = {
    prefix: 'fas',
    iconName: 'tablets',
    icon: [
        640,
        512,
        [],
        "f490",
        "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
    ]
};
var faTachometerAlt = {
    prefix: 'fas',
    iconName: 'tachometer-alt',
    icon: [
        576,
        512,
        [],
        "f3fd",
        "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faTag = {
    prefix: 'fas',
    iconName: 'tag',
    icon: [
        512,
        512,
        [],
        "f02b",
        "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
    ]
};
var faTags = {
    prefix: 'fas',
    iconName: 'tags',
    icon: [
        640,
        512,
        [],
        "f02c",
        "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
    ]
};
var faTape = {
    prefix: 'fas',
    iconName: 'tape',
    icon: [
        640,
        512,
        [],
        "f4db",
        "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ]
};
var faTasks = {
    prefix: 'fas',
    iconName: 'tasks',
    icon: [
        512,
        512,
        [],
        "f0ae",
        "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faTaxi = {
    prefix: 'fas',
    iconName: 'taxi',
    icon: [
        512,
        512,
        [],
        "f1ba",
        "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faTeeth = {
    prefix: 'fas',
    iconName: 'teeth',
    icon: [
        640,
        512,
        [],
        "f62e",
        "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
    ]
};
var faTeethOpen = {
    prefix: 'fas',
    iconName: 'teeth-open',
    icon: [
        640,
        512,
        [],
        "f62f",
        "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
    ]
};
var faTemperatureHigh = {
    prefix: 'fas',
    iconName: 'temperature-high',
    icon: [
        512,
        512,
        [],
        "f769",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var faTemperatureLow = {
    prefix: 'fas',
    iconName: 'temperature-low',
    icon: [
        512,
        512,
        [],
        "f76b",
        "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
    ]
};
var faTenge = {
    prefix: 'fas',
    iconName: 'tenge',
    icon: [
        384,
        512,
        [],
        "f7d7",
        "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
    ]
};
var faTerminal = {
    prefix: 'fas',
    iconName: 'terminal',
    icon: [
        640,
        512,
        [],
        "f120",
        "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
    ]
};
var faTextHeight = {
    prefix: 'fas',
    iconName: 'text-height',
    icon: [
        576,
        512,
        [],
        "f034",
        "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
    ]
};
var faTextWidth = {
    prefix: 'fas',
    iconName: 'text-width',
    icon: [
        448,
        512,
        [],
        "f035",
        "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
    ]
};
var faTh = {
    prefix: 'fas',
    iconName: 'th',
    icon: [
        512,
        512,
        [],
        "f00a",
        "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
    ]
};
var faThLarge = {
    prefix: 'fas',
    iconName: 'th-large',
    icon: [
        512,
        512,
        [],
        "f009",
        "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
    ]
};
var faThList = {
    prefix: 'fas',
    iconName: 'th-list',
    icon: [
        512,
        512,
        [],
        "f00b",
        "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
    ]
};
var faTheaterMasks = {
    prefix: 'fas',
    iconName: 'theater-masks',
    icon: [
        640,
        512,
        [],
        "f630",
        "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
    ]
};
var faThermometer = {
    prefix: 'fas',
    iconName: 'thermometer',
    icon: [
        512,
        512,
        [],
        "f491",
        "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
    ]
};
var faThermometerEmpty = {
    prefix: 'fas',
    iconName: 'thermometer-empty',
    icon: [
        256,
        512,
        [],
        "f2cb",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThermometerFull = {
    prefix: 'fas',
    iconName: 'thermometer-full',
    icon: [
        256,
        512,
        [],
        "f2c7",
        "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
    ]
};
var faThermometerHalf = {
    prefix: 'fas',
    iconName: 'thermometer-half',
    icon: [
        256,
        512,
        [],
        "f2c9",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThermometerQuarter = {
    prefix: 'fas',
    iconName: 'thermometer-quarter',
    icon: [
        256,
        512,
        [],
        "f2ca",
        "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThermometerThreeQuarters = {
    prefix: 'fas',
    iconName: 'thermometer-three-quarters',
    icon: [
        256,
        512,
        [],
        "f2c8",
        "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
    ]
};
var faThumbsDown = {
    prefix: 'fas',
    iconName: 'thumbs-down',
    icon: [
        512,
        512,
        [],
        "f165",
        "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
    ]
};
var faThumbsUp = {
    prefix: 'fas',
    iconName: 'thumbs-up',
    icon: [
        512,
        512,
        [],
        "f164",
        "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
    ]
};
var faThumbtack = {
    prefix: 'fas',
    iconName: 'thumbtack',
    icon: [
        384,
        512,
        [],
        "f08d",
        "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
    ]
};
var faTicketAlt = {
    prefix: 'fas',
    iconName: 'ticket-alt',
    icon: [
        576,
        512,
        [],
        "f3ff",
        "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
    ]
};
var faTimes = {
    prefix: 'fas',
    iconName: 'times',
    icon: [
        352,
        512,
        [],
        "f00d",
        "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
    ]
};
var faTimesCircle = {
    prefix: 'fas',
    iconName: 'times-circle',
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
    ]
};
var faTint = {
    prefix: 'fas',
    iconName: 'tint',
    icon: [
        352,
        512,
        [],
        "f043",
        "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
    ]
};
var faTintSlash = {
    prefix: 'fas',
    iconName: 'tint-slash',
    icon: [
        640,
        512,
        [],
        "f5c7",
        "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
    ]
};
var faTired = {
    prefix: 'fas',
    iconName: 'tired',
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
    ]
};
var faToggleOff = {
    prefix: 'fas',
    iconName: 'toggle-off',
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
    ]
};
var faToggleOn = {
    prefix: 'fas',
    iconName: 'toggle-on',
    icon: [
        576,
        512,
        [],
        "f205",
        "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
    ]
};
var faToilet = {
    prefix: 'fas',
    iconName: 'toilet',
    icon: [
        384,
        512,
        [],
        "f7d8",
        "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
    ]
};
var faToiletPaper = {
    prefix: 'fas',
    iconName: 'toilet-paper',
    icon: [
        576,
        512,
        [],
        "f71e",
        "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
    ]
};
var faToiletPaperSlash = {
    prefix: 'fas',
    iconName: 'toilet-paper-slash',
    icon: [
        640,
        512,
        [],
        "e072",
        "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
    ]
};
var faToolbox = {
    prefix: 'fas',
    iconName: 'toolbox',
    icon: [
        512,
        512,
        [],
        "f552",
        "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
    ]
};
var faTools = {
    prefix: 'fas',
    iconName: 'tools',
    icon: [
        512,
        512,
        [],
        "f7d9",
        "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
    ]
};
var faTooth = {
    prefix: 'fas',
    iconName: 'tooth',
    icon: [
        448,
        512,
        [],
        "f5c9",
        "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
    ]
};
var faTorah = {
    prefix: 'fas',
    iconName: 'torah',
    icon: [
        640,
        512,
        [],
        "f6a0",
        "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
    ]
};
var faToriiGate = {
    prefix: 'fas',
    iconName: 'torii-gate',
    icon: [
        512,
        512,
        [],
        "f6a1",
        "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
    ]
};
var faTractor = {
    prefix: 'fas',
    iconName: 'tractor',
    icon: [
        640,
        512,
        [],
        "f722",
        "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
    ]
};
var faTrademark = {
    prefix: 'fas',
    iconName: 'trademark',
    icon: [
        640,
        512,
        [],
        "f25c",
        "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
    ]
};
var faTrafficLight = {
    prefix: 'fas',
    iconName: 'traffic-light',
    icon: [
        384,
        512,
        [],
        "f637",
        "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var faTrailer = {
    prefix: 'fas',
    iconName: 'trailer',
    icon: [
        640,
        512,
        [],
        "e041",
        "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
    ]
};
var faTrain = {
    prefix: 'fas',
    iconName: 'train',
    icon: [
        448,
        512,
        [],
        "f238",
        "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
    ]
};
var faTram = {
    prefix: 'fas',
    iconName: 'tram',
    icon: [
        512,
        512,
        [],
        "f7da",
        "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var faTransgender = {
    prefix: 'fas',
    iconName: 'transgender',
    icon: [
        384,
        512,
        [],
        "f224",
        "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faTransgenderAlt = {
    prefix: 'fas',
    iconName: 'transgender-alt',
    icon: [
        480,
        512,
        [],
        "f225",
        "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faTrash = {
    prefix: 'fas',
    iconName: 'trash',
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
    ]
};
var faTrashAlt = {
    prefix: 'fas',
    iconName: 'trash-alt',
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faTrashRestore = {
    prefix: 'fas',
    iconName: 'trash-restore',
    icon: [
        448,
        512,
        [],
        "f829",
        "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faTrashRestoreAlt = {
    prefix: 'fas',
    iconName: 'trash-restore-alt',
    icon: [
        448,
        512,
        [],
        "f82a",
        "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
    ]
};
var faTree = {
    prefix: 'fas',
    iconName: 'tree',
    icon: [
        384,
        512,
        [],
        "f1bb",
        "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
    ]
};
var faTrophy = {
    prefix: 'fas',
    iconName: 'trophy',
    icon: [
        576,
        512,
        [],
        "f091",
        "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
    ]
};
var faTruck = {
    prefix: 'fas',
    iconName: 'truck',
    icon: [
        640,
        512,
        [],
        "f0d1",
        "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
    ]
};
var faTruckLoading = {
    prefix: 'fas',
    iconName: 'truck-loading',
    icon: [
        640,
        512,
        [],
        "f4de",
        "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
    ]
};
var faTruckMonster = {
    prefix: 'fas',
    iconName: 'truck-monster',
    icon: [
        640,
        512,
        [],
        "f63b",
        "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
    ]
};
var faTruckMoving = {
    prefix: 'fas',
    iconName: 'truck-moving',
    icon: [
        640,
        512,
        [],
        "f4df",
        "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
    ]
};
var faTruckPickup = {
    prefix: 'fas',
    iconName: 'truck-pickup',
    icon: [
        640,
        512,
        [],
        "f63c",
        "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
    ]
};
var faTshirt = {
    prefix: 'fas',
    iconName: 'tshirt',
    icon: [
        640,
        512,
        [],
        "f553",
        "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
    ]
};
var faTty = {
    prefix: 'fas',
    iconName: 'tty',
    icon: [
        512,
        512,
        [],
        "f1e4",
        "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
    ]
};
var faTv = {
    prefix: 'fas',
    iconName: 'tv',
    icon: [
        640,
        512,
        [],
        "f26c",
        "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
    ]
};
var faUmbrella = {
    prefix: 'fas',
    iconName: 'umbrella',
    icon: [
        576,
        512,
        [],
        "f0e9",
        "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
    ]
};
var faUmbrellaBeach = {
    prefix: 'fas',
    iconName: 'umbrella-beach',
    icon: [
        640,
        512,
        [],
        "f5ca",
        "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
    ]
};
var faUnderline = {
    prefix: 'fas',
    iconName: 'underline',
    icon: [
        448,
        512,
        [],
        "f0cd",
        "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
    ]
};
var faUndo = {
    prefix: 'fas',
    iconName: 'undo',
    icon: [
        512,
        512,
        [],
        "f0e2",
        "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
    ]
};
var faUndoAlt = {
    prefix: 'fas',
    iconName: 'undo-alt',
    icon: [
        512,
        512,
        [],
        "f2ea",
        "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
    ]
};
var faUniversalAccess = {
    prefix: 'fas',
    iconName: 'universal-access',
    icon: [
        512,
        512,
        [],
        "f29a",
        "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
    ]
};
var faUniversity = {
    prefix: 'fas',
    iconName: 'university',
    icon: [
        512,
        512,
        [],
        "f19c",
        "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
    ]
};
var faUnlink = {
    prefix: 'fas',
    iconName: 'unlink',
    icon: [
        512,
        512,
        [],
        "f127",
        "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
    ]
};
var faUnlock = {
    prefix: 'fas',
    iconName: 'unlock',
    icon: [
        448,
        512,
        [],
        "f09c",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    ]
};
var faUnlockAlt = {
    prefix: 'fas',
    iconName: 'unlock-alt',
    icon: [
        448,
        512,
        [],
        "f13e",
        "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
    ]
};
var faUpload = {
    prefix: 'fas',
    iconName: 'upload',
    icon: [
        512,
        512,
        [],
        "f093",
        "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
    ]
};
var faUser = {
    prefix: 'fas',
    iconName: 'user',
    icon: [
        448,
        512,
        [],
        "f007",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUserAlt = {
    prefix: 'fas',
    iconName: 'user-alt',
    icon: [
        512,
        512,
        [],
        "f406",
        "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
    ]
};
var faUserAltSlash = {
    prefix: 'fas',
    iconName: 'user-alt-slash',
    icon: [
        640,
        512,
        [],
        "f4fa",
        "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
    ]
};
var faUserAstronaut = {
    prefix: 'fas',
    iconName: 'user-astronaut',
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
    ]
};
var faUserCheck = {
    prefix: 'fas',
    iconName: 'user-check',
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
    ]
};
var faUserCircle = {
    prefix: 'fas',
    iconName: 'user-circle',
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
    ]
};
var faUserClock = {
    prefix: 'fas',
    iconName: 'user-clock',
    icon: [
        640,
        512,
        [],
        "f4fd",
        "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
    ]
};
var faUserCog = {
    prefix: 'fas',
    iconName: 'user-cog',
    icon: [
        640,
        512,
        [],
        "f4fe",
        "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
    ]
};
var faUserEdit = {
    prefix: 'fas',
    iconName: 'user-edit',
    icon: [
        640,
        512,
        [],
        "f4ff",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
    ]
};
var faUserFriends = {
    prefix: 'fas',
    iconName: 'user-friends',
    icon: [
        640,
        512,
        [],
        "f500",
        "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
    ]
};
var faUserGraduate = {
    prefix: 'fas',
    iconName: 'user-graduate',
    icon: [
        448,
        512,
        [],
        "f501",
        "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
    ]
};
var faUserInjured = {
    prefix: 'fas',
    iconName: 'user-injured',
    icon: [
        448,
        512,
        [],
        "f728",
        "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
    ]
};
var faUserLock = {
    prefix: 'fas',
    iconName: 'user-lock',
    icon: [
        640,
        512,
        [],
        "f502",
        "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
    ]
};
var faUserMd = {
    prefix: 'fas',
    iconName: 'user-md',
    icon: [
        448,
        512,
        [],
        "f0f0",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
    ]
};
var faUserMinus = {
    prefix: 'fas',
    iconName: 'user-minus',
    icon: [
        640,
        512,
        [],
        "f503",
        "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUserNinja = {
    prefix: 'fas',
    iconName: 'user-ninja',
    icon: [
        448,
        512,
        [],
        "f504",
        "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
    ]
};
var faUserNurse = {
    prefix: 'fas',
    iconName: 'user-nurse',
    icon: [
        448,
        512,
        [],
        "f82f",
        "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
    ]
};
var faUserPlus = {
    prefix: 'fas',
    iconName: 'user-plus',
    icon: [
        640,
        512,
        [],
        "f234",
        "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUserSecret = {
    prefix: 'fas',
    iconName: 'user-secret',
    icon: [
        448,
        512,
        [],
        "f21b",
        "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
    ]
};
var faUserShield = {
    prefix: 'fas',
    iconName: 'user-shield',
    icon: [
        640,
        512,
        [],
        "f505",
        "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
    ]
};
var faUserSlash = {
    prefix: 'fas',
    iconName: 'user-slash',
    icon: [
        640,
        512,
        [],
        "f506",
        "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
    ]
};
var faUserTag = {
    prefix: 'fas',
    iconName: 'user-tag',
    icon: [
        640,
        512,
        [],
        "f507",
        "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
    ]
};
var faUserTie = {
    prefix: 'fas',
    iconName: 'user-tie',
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
    ]
};
var faUserTimes = {
    prefix: 'fas',
    iconName: 'user-times',
    icon: [
        640,
        512,
        [],
        "f235",
        "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
    ]
};
var faUsers = {
    prefix: 'fas',
    iconName: 'users',
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var faUsersCog = {
    prefix: 'fas',
    iconName: 'users-cog',
    icon: [
        640,
        512,
        [],
        "f509",
        "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
    ]
};
var faUsersSlash = {
    prefix: 'fas',
    iconName: 'users-slash',
    icon: [
        640,
        512,
        [],
        "e073",
        "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
    ]
};
var faUtensilSpoon = {
    prefix: 'fas',
    iconName: 'utensil-spoon',
    icon: [
        512,
        512,
        [],
        "f2e5",
        "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
    ]
};
var faUtensils = {
    prefix: 'fas',
    iconName: 'utensils',
    icon: [
        416,
        512,
        [],
        "f2e7",
        "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
    ]
};
var faVectorSquare = {
    prefix: 'fas',
    iconName: 'vector-square',
    icon: [
        512,
        512,
        [],
        "f5cb",
        "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
    ]
};
var faVenus = {
    prefix: 'fas',
    iconName: 'venus',
    icon: [
        288,
        512,
        [],
        "f221",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
    ]
};
var faVenusDouble = {
    prefix: 'fas',
    iconName: 'venus-double',
    icon: [
        512,
        512,
        [],
        "f226",
        "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
    ]
};
var faVenusMars = {
    prefix: 'fas',
    iconName: 'venus-mars',
    icon: [
        576,
        512,
        [],
        "f228",
        "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
    ]
};
var faVest = {
    prefix: 'fas',
    iconName: 'vest',
    icon: [
        448,
        512,
        [],
        "e085",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
    ]
};
var faVestPatches = {
    prefix: 'fas',
    iconName: 'vest-patches',
    icon: [
        448,
        512,
        [],
        "e086",
        "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
    ]
};
var faVial = {
    prefix: 'fas',
    iconName: 'vial',
    icon: [
        480,
        512,
        [],
        "f492",
        "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
    ]
};
var faVials = {
    prefix: 'fas',
    iconName: 'vials',
    icon: [
        640,
        512,
        [],
        "f493",
        "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
    ]
};
var faVideo = {
    prefix: 'fas',
    iconName: 'video',
    icon: [
        576,
        512,
        [],
        "f03d",
        "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
    ]
};
var faVideoSlash = {
    prefix: 'fas',
    iconName: 'video-slash',
    icon: [
        640,
        512,
        [],
        "f4e2",
        "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
    ]
};
var faVihara = {
    prefix: 'fas',
    iconName: 'vihara',
    icon: [
        640,
        512,
        [],
        "f6a7",
        "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
    ]
};
var faVirus = {
    prefix: 'fas',
    iconName: 'virus',
    icon: [
        512,
        512,
        [],
        "e074",
        "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
    ]
};
var faVirusSlash = {
    prefix: 'fas',
    iconName: 'virus-slash',
    icon: [
        640,
        512,
        [],
        "e075",
        "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
    ]
};
var faViruses = {
    prefix: 'fas',
    iconName: 'viruses',
    icon: [
        640,
        512,
        [],
        "e076",
        "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
    ]
};
var faVoicemail = {
    prefix: 'fas',
    iconName: 'voicemail',
    icon: [
        640,
        512,
        [],
        "f897",
        "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
    ]
};
var faVolleyballBall = {
    prefix: 'fas',
    iconName: 'volleyball-ball',
    icon: [
        512,
        512,
        [],
        "f45f",
        "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
    ]
};
var faVolumeDown = {
    prefix: 'fas',
    iconName: 'volume-down',
    icon: [
        384,
        512,
        [],
        "f027",
        "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
    ]
};
var faVolumeMute = {
    prefix: 'fas',
    iconName: 'volume-mute',
    icon: [
        512,
        512,
        [],
        "f6a9",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
    ]
};
var faVolumeOff = {
    prefix: 'fas',
    iconName: 'volume-off',
    icon: [
        256,
        512,
        [],
        "f026",
        "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
    ]
};
var faVolumeUp = {
    prefix: 'fas',
    iconName: 'volume-up',
    icon: [
        576,
        512,
        [],
        "f028",
        "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
    ]
};
var faVoteYea = {
    prefix: 'fas',
    iconName: 'vote-yea',
    icon: [
        640,
        512,
        [],
        "f772",
        "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
    ]
};
var faVrCardboard = {
    prefix: 'fas',
    iconName: 'vr-cardboard',
    icon: [
        640,
        512,
        [],
        "f729",
        "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
    ]
};
var faWalking = {
    prefix: 'fas',
    iconName: 'walking',
    icon: [
        320,
        512,
        [],
        "f554",
        "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
    ]
};
var faWallet = {
    prefix: 'fas',
    iconName: 'wallet',
    icon: [
        512,
        512,
        [],
        "f555",
        "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
    ]
};
var faWarehouse = {
    prefix: 'fas',
    iconName: 'warehouse',
    icon: [
        640,
        512,
        [],
        "f494",
        "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
    ]
};
var faWater = {
    prefix: 'fas',
    iconName: 'water',
    icon: [
        576,
        512,
        [],
        "f773",
        "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
    ]
};
var faWaveSquare = {
    prefix: 'fas',
    iconName: 'wave-square',
    icon: [
        640,
        512,
        [],
        "f83e",
        "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
    ]
};
var faWeight = {
    prefix: 'fas',
    iconName: 'weight',
    icon: [
        512,
        512,
        [],
        "f496",
        "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
    ]
};
var faWeightHanging = {
    prefix: 'fas',
    iconName: 'weight-hanging',
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
    ]
};
var faWheelchair = {
    prefix: 'fas',
    iconName: 'wheelchair',
    icon: [
        512,
        512,
        [],
        "f193",
        "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
    ]
};
var faWifi = {
    prefix: 'fas',
    iconName: 'wifi',
    icon: [
        640,
        512,
        [],
        "f1eb",
        "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
    ]
};
var faWind = {
    prefix: 'fas',
    iconName: 'wind',
    icon: [
        512,
        512,
        [],
        "f72e",
        "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
    ]
};
var faWindowClose = {
    prefix: 'fas',
    iconName: 'window-close',
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
    ]
};
var faWindowMaximize = {
    prefix: 'fas',
    iconName: 'window-maximize',
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
    ]
};
var faWindowMinimize = {
    prefix: 'fas',
    iconName: 'window-minimize',
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
    ]
};
var faWindowRestore = {
    prefix: 'fas',
    iconName: 'window-restore',
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
    ]
};
var faWineBottle = {
    prefix: 'fas',
    iconName: 'wine-bottle',
    icon: [
        512,
        512,
        [],
        "f72f",
        "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
    ]
};
var faWineGlass = {
    prefix: 'fas',
    iconName: 'wine-glass',
    icon: [
        288,
        512,
        [],
        "f4e3",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
    ]
};
var faWineGlassAlt = {
    prefix: 'fas',
    iconName: 'wine-glass-alt',
    icon: [
        288,
        512,
        [],
        "f5ce",
        "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
    ]
};
var faWonSign = {
    prefix: 'fas',
    iconName: 'won-sign',
    icon: [
        576,
        512,
        [],
        "f159",
        "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
    ]
};
var faWrench = {
    prefix: 'fas',
    iconName: 'wrench',
    icon: [
        512,
        512,
        [],
        "f0ad",
        "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
    ]
};
var faXRay = {
    prefix: 'fas',
    iconName: 'x-ray',
    icon: [
        640,
        512,
        [],
        "f497",
        "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
    ]
};
var faYenSign = {
    prefix: 'fas',
    iconName: 'yen-sign',
    icon: [
        384,
        512,
        [],
        "f157",
        "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
    ]
};
var faYinYang = {
    prefix: 'fas',
    iconName: 'yin-yang',
    icon: [
        496,
        512,
        [],
        "f6ad",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
    ]
};
var _iconsCache = {
    faAd: faAd,
    faAddressBook: faAddressBook,
    faAddressCard: faAddressCard,
    faAdjust: faAdjust,
    faAirFreshener: faAirFreshener,
    faAlignCenter: faAlignCenter,
    faAlignJustify: faAlignJustify,
    faAlignLeft: faAlignLeft,
    faAlignRight: faAlignRight,
    faAllergies: faAllergies,
    faAmbulance: faAmbulance,
    faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
    faAnchor: faAnchor,
    faAngleDoubleDown: faAngleDoubleDown,
    faAngleDoubleLeft: faAngleDoubleLeft,
    faAngleDoubleRight: faAngleDoubleRight,
    faAngleDoubleUp: faAngleDoubleUp,
    faAngleDown: faAngleDown,
    faAngleLeft: faAngleLeft,
    faAngleRight: faAngleRight,
    faAngleUp: faAngleUp,
    faAngry: faAngry,
    faAnkh: faAnkh,
    faAppleAlt: faAppleAlt,
    faArchive: faArchive,
    faArchway: faArchway,
    faArrowAltCircleDown: faArrowAltCircleDown,
    faArrowAltCircleLeft: faArrowAltCircleLeft,
    faArrowAltCircleRight: faArrowAltCircleRight,
    faArrowAltCircleUp: faArrowAltCircleUp,
    faArrowCircleDown: faArrowCircleDown,
    faArrowCircleLeft: faArrowCircleLeft,
    faArrowCircleRight: faArrowCircleRight,
    faArrowCircleUp: faArrowCircleUp,
    faArrowDown: faArrowDown,
    faArrowLeft: faArrowLeft,
    faArrowRight: faArrowRight,
    faArrowUp: faArrowUp,
    faArrowsAlt: faArrowsAlt,
    faArrowsAltH: faArrowsAltH,
    faArrowsAltV: faArrowsAltV,
    faAssistiveListeningSystems: faAssistiveListeningSystems,
    faAsterisk: faAsterisk,
    faAt: faAt,
    faAtlas: faAtlas,
    faAtom: faAtom,
    faAudioDescription: faAudioDescription,
    faAward: faAward,
    faBaby: faBaby,
    faBabyCarriage: faBabyCarriage,
    faBackspace: faBackspace,
    faBackward: faBackward,
    faBacon: faBacon,
    faBacteria: faBacteria,
    faBacterium: faBacterium,
    faBahai: faBahai,
    faBalanceScale: faBalanceScale,
    faBalanceScaleLeft: faBalanceScaleLeft,
    faBalanceScaleRight: faBalanceScaleRight,
    faBan: faBan,
    faBandAid: faBandAid,
    faBarcode: faBarcode,
    faBars: faBars,
    faBaseballBall: faBaseballBall,
    faBasketballBall: faBasketballBall,
    faBath: faBath,
    faBatteryEmpty: faBatteryEmpty,
    faBatteryFull: faBatteryFull,
    faBatteryHalf: faBatteryHalf,
    faBatteryQuarter: faBatteryQuarter,
    faBatteryThreeQuarters: faBatteryThreeQuarters,
    faBed: faBed,
    faBeer: faBeer,
    faBell: faBell,
    faBellSlash: faBellSlash,
    faBezierCurve: faBezierCurve,
    faBible: faBible,
    faBicycle: faBicycle,
    faBiking: faBiking,
    faBinoculars: faBinoculars,
    faBiohazard: faBiohazard,
    faBirthdayCake: faBirthdayCake,
    faBlender: faBlender,
    faBlenderPhone: faBlenderPhone,
    faBlind: faBlind,
    faBlog: faBlog,
    faBold: faBold,
    faBolt: faBolt,
    faBomb: faBomb,
    faBone: faBone,
    faBong: faBong,
    faBook: faBook,
    faBookDead: faBookDead,
    faBookMedical: faBookMedical,
    faBookOpen: faBookOpen,
    faBookReader: faBookReader,
    faBookmark: faBookmark,
    faBorderAll: faBorderAll,
    faBorderNone: faBorderNone,
    faBorderStyle: faBorderStyle,
    faBowlingBall: faBowlingBall,
    faBox: faBox,
    faBoxOpen: faBoxOpen,
    faBoxTissue: faBoxTissue,
    faBoxes: faBoxes,
    faBraille: faBraille,
    faBrain: faBrain,
    faBreadSlice: faBreadSlice,
    faBriefcase: faBriefcase,
    faBriefcaseMedical: faBriefcaseMedical,
    faBroadcastTower: faBroadcastTower,
    faBroom: faBroom,
    faBrush: faBrush,
    faBug: faBug,
    faBuilding: faBuilding,
    faBullhorn: faBullhorn,
    faBullseye: faBullseye,
    faBurn: faBurn,
    faBus: faBus,
    faBusAlt: faBusAlt,
    faBusinessTime: faBusinessTime,
    faCalculator: faCalculator,
    faCalendar: faCalendar,
    faCalendarAlt: faCalendarAlt,
    faCalendarCheck: faCalendarCheck,
    faCalendarDay: faCalendarDay,
    faCalendarMinus: faCalendarMinus,
    faCalendarPlus: faCalendarPlus,
    faCalendarTimes: faCalendarTimes,
    faCalendarWeek: faCalendarWeek,
    faCamera: faCamera,
    faCameraRetro: faCameraRetro,
    faCampground: faCampground,
    faCandyCane: faCandyCane,
    faCannabis: faCannabis,
    faCapsules: faCapsules,
    faCar: faCar,
    faCarAlt: faCarAlt,
    faCarBattery: faCarBattery,
    faCarCrash: faCarCrash,
    faCarSide: faCarSide,
    faCaravan: faCaravan,
    faCaretDown: faCaretDown,
    faCaretLeft: faCaretLeft,
    faCaretRight: faCaretRight,
    faCaretSquareDown: faCaretSquareDown,
    faCaretSquareLeft: faCaretSquareLeft,
    faCaretSquareRight: faCaretSquareRight,
    faCaretSquareUp: faCaretSquareUp,
    faCaretUp: faCaretUp,
    faCarrot: faCarrot,
    faCartArrowDown: faCartArrowDown,
    faCartPlus: faCartPlus,
    faCashRegister: faCashRegister,
    faCat: faCat,
    faCertificate: faCertificate,
    faChair: faChair,
    faChalkboard: faChalkboard,
    faChalkboardTeacher: faChalkboardTeacher,
    faChargingStation: faChargingStation,
    faChartArea: faChartArea,
    faChartBar: faChartBar,
    faChartLine: faChartLine,
    faChartPie: faChartPie,
    faCheck: faCheck,
    faCheckCircle: faCheckCircle,
    faCheckDouble: faCheckDouble,
    faCheckSquare: faCheckSquare,
    faCheese: faCheese,
    faChess: faChess,
    faChessBishop: faChessBishop,
    faChessBoard: faChessBoard,
    faChessKing: faChessKing,
    faChessKnight: faChessKnight,
    faChessPawn: faChessPawn,
    faChessQueen: faChessQueen,
    faChessRook: faChessRook,
    faChevronCircleDown: faChevronCircleDown,
    faChevronCircleLeft: faChevronCircleLeft,
    faChevronCircleRight: faChevronCircleRight,
    faChevronCircleUp: faChevronCircleUp,
    faChevronDown: faChevronDown,
    faChevronLeft: faChevronLeft,
    faChevronRight: faChevronRight,
    faChevronUp: faChevronUp,
    faChild: faChild,
    faChurch: faChurch,
    faCircle: faCircle,
    faCircleNotch: faCircleNotch,
    faCity: faCity,
    faClinicMedical: faClinicMedical,
    faClipboard: faClipboard,
    faClipboardCheck: faClipboardCheck,
    faClipboardList: faClipboardList,
    faClock: faClock,
    faClone: faClone,
    faClosedCaptioning: faClosedCaptioning,
    faCloud: faCloud,
    faCloudDownloadAlt: faCloudDownloadAlt,
    faCloudMeatball: faCloudMeatball,
    faCloudMoon: faCloudMoon,
    faCloudMoonRain: faCloudMoonRain,
    faCloudRain: faCloudRain,
    faCloudShowersHeavy: faCloudShowersHeavy,
    faCloudSun: faCloudSun,
    faCloudSunRain: faCloudSunRain,
    faCloudUploadAlt: faCloudUploadAlt,
    faCocktail: faCocktail,
    faCode: faCode,
    faCodeBranch: faCodeBranch,
    faCoffee: faCoffee,
    faCog: faCog,
    faCogs: faCogs,
    faCoins: faCoins,
    faColumns: faColumns,
    faComment: faComment,
    faCommentAlt: faCommentAlt,
    faCommentDollar: faCommentDollar,
    faCommentDots: faCommentDots,
    faCommentMedical: faCommentMedical,
    faCommentSlash: faCommentSlash,
    faComments: faComments,
    faCommentsDollar: faCommentsDollar,
    faCompactDisc: faCompactDisc,
    faCompass: faCompass,
    faCompress: faCompress,
    faCompressAlt: faCompressAlt,
    faCompressArrowsAlt: faCompressArrowsAlt,
    faConciergeBell: faConciergeBell,
    faCookie: faCookie,
    faCookieBite: faCookieBite,
    faCopy: faCopy,
    faCopyright: faCopyright,
    faCouch: faCouch,
    faCreditCard: faCreditCard,
    faCrop: faCrop,
    faCropAlt: faCropAlt,
    faCross: faCross,
    faCrosshairs: faCrosshairs,
    faCrow: faCrow,
    faCrown: faCrown,
    faCrutch: faCrutch,
    faCube: faCube,
    faCubes: faCubes,
    faCut: faCut,
    faDatabase: faDatabase,
    faDeaf: faDeaf,
    faDemocrat: faDemocrat,
    faDesktop: faDesktop,
    faDharmachakra: faDharmachakra,
    faDiagnoses: faDiagnoses,
    faDice: faDice,
    faDiceD20: faDiceD20,
    faDiceD6: faDiceD6,
    faDiceFive: faDiceFive,
    faDiceFour: faDiceFour,
    faDiceOne: faDiceOne,
    faDiceSix: faDiceSix,
    faDiceThree: faDiceThree,
    faDiceTwo: faDiceTwo,
    faDigitalTachograph: faDigitalTachograph,
    faDirections: faDirections,
    faDisease: faDisease,
    faDivide: faDivide,
    faDizzy: faDizzy,
    faDna: faDna,
    faDog: faDog,
    faDollarSign: faDollarSign,
    faDolly: faDolly,
    faDollyFlatbed: faDollyFlatbed,
    faDonate: faDonate,
    faDoorClosed: faDoorClosed,
    faDoorOpen: faDoorOpen,
    faDotCircle: faDotCircle,
    faDove: faDove,
    faDownload: faDownload,
    faDraftingCompass: faDraftingCompass,
    faDragon: faDragon,
    faDrawPolygon: faDrawPolygon,
    faDrum: faDrum,
    faDrumSteelpan: faDrumSteelpan,
    faDrumstickBite: faDrumstickBite,
    faDumbbell: faDumbbell,
    faDumpster: faDumpster,
    faDumpsterFire: faDumpsterFire,
    faDungeon: faDungeon,
    faEdit: faEdit,
    faEgg: faEgg,
    faEject: faEject,
    faEllipsisH: faEllipsisH,
    faEllipsisV: faEllipsisV,
    faEnvelope: faEnvelope,
    faEnvelopeOpen: faEnvelopeOpen,
    faEnvelopeOpenText: faEnvelopeOpenText,
    faEnvelopeSquare: faEnvelopeSquare,
    faEquals: faEquals,
    faEraser: faEraser,
    faEthernet: faEthernet,
    faEuroSign: faEuroSign,
    faExchangeAlt: faExchangeAlt,
    faExclamation: faExclamation,
    faExclamationCircle: faExclamationCircle,
    faExclamationTriangle: faExclamationTriangle,
    faExpand: faExpand,
    faExpandAlt: faExpandAlt,
    faExpandArrowsAlt: faExpandArrowsAlt,
    faExternalLinkAlt: faExternalLinkAlt,
    faExternalLinkSquareAlt: faExternalLinkSquareAlt,
    faEye: faEye,
    faEyeDropper: faEyeDropper,
    faEyeSlash: faEyeSlash,
    faFan: faFan,
    faFastBackward: faFastBackward,
    faFastForward: faFastForward,
    faFaucet: faFaucet,
    faFax: faFax,
    faFeather: faFeather,
    faFeatherAlt: faFeatherAlt,
    faFemale: faFemale,
    faFighterJet: faFighterJet,
    faFile: faFile,
    faFileAlt: faFileAlt,
    faFileArchive: faFileArchive,
    faFileAudio: faFileAudio,
    faFileCode: faFileCode,
    faFileContract: faFileContract,
    faFileCsv: faFileCsv,
    faFileDownload: faFileDownload,
    faFileExcel: faFileExcel,
    faFileExport: faFileExport,
    faFileImage: faFileImage,
    faFileImport: faFileImport,
    faFileInvoice: faFileInvoice,
    faFileInvoiceDollar: faFileInvoiceDollar,
    faFileMedical: faFileMedical,
    faFileMedicalAlt: faFileMedicalAlt,
    faFilePdf: faFilePdf,
    faFilePowerpoint: faFilePowerpoint,
    faFilePrescription: faFilePrescription,
    faFileSignature: faFileSignature,
    faFileUpload: faFileUpload,
    faFileVideo: faFileVideo,
    faFileWord: faFileWord,
    faFill: faFill,
    faFillDrip: faFillDrip,
    faFilm: faFilm,
    faFilter: faFilter,
    faFingerprint: faFingerprint,
    faFire: faFire,
    faFireAlt: faFireAlt,
    faFireExtinguisher: faFireExtinguisher,
    faFirstAid: faFirstAid,
    faFish: faFish,
    faFistRaised: faFistRaised,
    faFlag: faFlag,
    faFlagCheckered: faFlagCheckered,
    faFlagUsa: faFlagUsa,
    faFlask: faFlask,
    faFlushed: faFlushed,
    faFolder: faFolder,
    faFolderMinus: faFolderMinus,
    faFolderOpen: faFolderOpen,
    faFolderPlus: faFolderPlus,
    faFont: faFont,
    faFontAwesomeLogoFull: faFontAwesomeLogoFull,
    faFootballBall: faFootballBall,
    faForward: faForward,
    faFrog: faFrog,
    faFrown: faFrown,
    faFrownOpen: faFrownOpen,
    faFunnelDollar: faFunnelDollar,
    faFutbol: faFutbol,
    faGamepad: faGamepad,
    faGasPump: faGasPump,
    faGavel: faGavel,
    faGem: faGem,
    faGenderless: faGenderless,
    faGhost: faGhost,
    faGift: faGift,
    faGifts: faGifts,
    faGlassCheers: faGlassCheers,
    faGlassMartini: faGlassMartini,
    faGlassMartiniAlt: faGlassMartiniAlt,
    faGlassWhiskey: faGlassWhiskey,
    faGlasses: faGlasses,
    faGlobe: faGlobe,
    faGlobeAfrica: faGlobeAfrica,
    faGlobeAmericas: faGlobeAmericas,
    faGlobeAsia: faGlobeAsia,
    faGlobeEurope: faGlobeEurope,
    faGolfBall: faGolfBall,
    faGopuram: faGopuram,
    faGraduationCap: faGraduationCap,
    faGreaterThan: faGreaterThan,
    faGreaterThanEqual: faGreaterThanEqual,
    faGrimace: faGrimace,
    faGrin: faGrin,
    faGrinAlt: faGrinAlt,
    faGrinBeam: faGrinBeam,
    faGrinBeamSweat: faGrinBeamSweat,
    faGrinHearts: faGrinHearts,
    faGrinSquint: faGrinSquint,
    faGrinSquintTears: faGrinSquintTears,
    faGrinStars: faGrinStars,
    faGrinTears: faGrinTears,
    faGrinTongue: faGrinTongue,
    faGrinTongueSquint: faGrinTongueSquint,
    faGrinTongueWink: faGrinTongueWink,
    faGrinWink: faGrinWink,
    faGripHorizontal: faGripHorizontal,
    faGripLines: faGripLines,
    faGripLinesVertical: faGripLinesVertical,
    faGripVertical: faGripVertical,
    faGuitar: faGuitar,
    faHSquare: faHSquare,
    faHamburger: faHamburger,
    faHammer: faHammer,
    faHamsa: faHamsa,
    faHandHolding: faHandHolding,
    faHandHoldingHeart: faHandHoldingHeart,
    faHandHoldingMedical: faHandHoldingMedical,
    faHandHoldingUsd: faHandHoldingUsd,
    faHandHoldingWater: faHandHoldingWater,
    faHandLizard: faHandLizard,
    faHandMiddleFinger: faHandMiddleFinger,
    faHandPaper: faHandPaper,
    faHandPeace: faHandPeace,
    faHandPointDown: faHandPointDown,
    faHandPointLeft: faHandPointLeft,
    faHandPointRight: faHandPointRight,
    faHandPointUp: faHandPointUp,
    faHandPointer: faHandPointer,
    faHandRock: faHandRock,
    faHandScissors: faHandScissors,
    faHandSparkles: faHandSparkles,
    faHandSpock: faHandSpock,
    faHands: faHands,
    faHandsHelping: faHandsHelping,
    faHandsWash: faHandsWash,
    faHandshake: faHandshake,
    faHandshakeAltSlash: faHandshakeAltSlash,
    faHandshakeSlash: faHandshakeSlash,
    faHanukiah: faHanukiah,
    faHardHat: faHardHat,
    faHashtag: faHashtag,
    faHatCowboy: faHatCowboy,
    faHatCowboySide: faHatCowboySide,
    faHatWizard: faHatWizard,
    faHdd: faHdd,
    faHeadSideCough: faHeadSideCough,
    faHeadSideCoughSlash: faHeadSideCoughSlash,
    faHeadSideMask: faHeadSideMask,
    faHeadSideVirus: faHeadSideVirus,
    faHeading: faHeading,
    faHeadphones: faHeadphones,
    faHeadphonesAlt: faHeadphonesAlt,
    faHeadset: faHeadset,
    faHeart: faHeart,
    faHeartBroken: faHeartBroken,
    faHeartbeat: faHeartbeat,
    faHelicopter: faHelicopter,
    faHighlighter: faHighlighter,
    faHiking: faHiking,
    faHippo: faHippo,
    faHistory: faHistory,
    faHockeyPuck: faHockeyPuck,
    faHollyBerry: faHollyBerry,
    faHome: faHome,
    faHorse: faHorse,
    faHorseHead: faHorseHead,
    faHospital: faHospital,
    faHospitalAlt: faHospitalAlt,
    faHospitalSymbol: faHospitalSymbol,
    faHospitalUser: faHospitalUser,
    faHotTub: faHotTub,
    faHotdog: faHotdog,
    faHotel: faHotel,
    faHourglass: faHourglass,
    faHourglassEnd: faHourglassEnd,
    faHourglassHalf: faHourglassHalf,
    faHourglassStart: faHourglassStart,
    faHouseDamage: faHouseDamage,
    faHouseUser: faHouseUser,
    faHryvnia: faHryvnia,
    faICursor: faICursor,
    faIceCream: faIceCream,
    faIcicles: faIcicles,
    faIcons: faIcons,
    faIdBadge: faIdBadge,
    faIdCard: faIdCard,
    faIdCardAlt: faIdCardAlt,
    faIgloo: faIgloo,
    faImage: faImage,
    faImages: faImages,
    faInbox: faInbox,
    faIndent: faIndent,
    faIndustry: faIndustry,
    faInfinity: faInfinity,
    faInfo: faInfo,
    faInfoCircle: faInfoCircle,
    faItalic: faItalic,
    faJedi: faJedi,
    faJoint: faJoint,
    faJournalWhills: faJournalWhills,
    faKaaba: faKaaba,
    faKey: faKey,
    faKeyboard: faKeyboard,
    faKhanda: faKhanda,
    faKiss: faKiss,
    faKissBeam: faKissBeam,
    faKissWinkHeart: faKissWinkHeart,
    faKiwiBird: faKiwiBird,
    faLandmark: faLandmark,
    faLanguage: faLanguage,
    faLaptop: faLaptop,
    faLaptopCode: faLaptopCode,
    faLaptopHouse: faLaptopHouse,
    faLaptopMedical: faLaptopMedical,
    faLaugh: faLaugh,
    faLaughBeam: faLaughBeam,
    faLaughSquint: faLaughSquint,
    faLaughWink: faLaughWink,
    faLayerGroup: faLayerGroup,
    faLeaf: faLeaf,
    faLemon: faLemon,
    faLessThan: faLessThan,
    faLessThanEqual: faLessThanEqual,
    faLevelDownAlt: faLevelDownAlt,
    faLevelUpAlt: faLevelUpAlt,
    faLifeRing: faLifeRing,
    faLightbulb: faLightbulb,
    faLink: faLink,
    faLiraSign: faLiraSign,
    faList: faList,
    faListAlt: faListAlt,
    faListOl: faListOl,
    faListUl: faListUl,
    faLocationArrow: faLocationArrow,
    faLock: faLock,
    faLockOpen: faLockOpen,
    faLongArrowAltDown: faLongArrowAltDown,
    faLongArrowAltLeft: faLongArrowAltLeft,
    faLongArrowAltRight: faLongArrowAltRight,
    faLongArrowAltUp: faLongArrowAltUp,
    faLowVision: faLowVision,
    faLuggageCart: faLuggageCart,
    faLungs: faLungs,
    faLungsVirus: faLungsVirus,
    faMagic: faMagic,
    faMagnet: faMagnet,
    faMailBulk: faMailBulk,
    faMale: faMale,
    faMap: faMap,
    faMapMarked: faMapMarked,
    faMapMarkedAlt: faMapMarkedAlt,
    faMapMarker: faMapMarker,
    faMapMarkerAlt: faMapMarkerAlt,
    faMapPin: faMapPin,
    faMapSigns: faMapSigns,
    faMarker: faMarker,
    faMars: faMars,
    faMarsDouble: faMarsDouble,
    faMarsStroke: faMarsStroke,
    faMarsStrokeH: faMarsStrokeH,
    faMarsStrokeV: faMarsStrokeV,
    faMask: faMask,
    faMedal: faMedal,
    faMedkit: faMedkit,
    faMeh: faMeh,
    faMehBlank: faMehBlank,
    faMehRollingEyes: faMehRollingEyes,
    faMemory: faMemory,
    faMenorah: faMenorah,
    faMercury: faMercury,
    faMeteor: faMeteor,
    faMicrochip: faMicrochip,
    faMicrophone: faMicrophone,
    faMicrophoneAlt: faMicrophoneAlt,
    faMicrophoneAltSlash: faMicrophoneAltSlash,
    faMicrophoneSlash: faMicrophoneSlash,
    faMicroscope: faMicroscope,
    faMinus: faMinus,
    faMinusCircle: faMinusCircle,
    faMinusSquare: faMinusSquare,
    faMitten: faMitten,
    faMobile: faMobile,
    faMobileAlt: faMobileAlt,
    faMoneyBill: faMoneyBill,
    faMoneyBillAlt: faMoneyBillAlt,
    faMoneyBillWave: faMoneyBillWave,
    faMoneyBillWaveAlt: faMoneyBillWaveAlt,
    faMoneyCheck: faMoneyCheck,
    faMoneyCheckAlt: faMoneyCheckAlt,
    faMonument: faMonument,
    faMoon: faMoon,
    faMortarPestle: faMortarPestle,
    faMosque: faMosque,
    faMotorcycle: faMotorcycle,
    faMountain: faMountain,
    faMouse: faMouse,
    faMousePointer: faMousePointer,
    faMugHot: faMugHot,
    faMusic: faMusic,
    faNetworkWired: faNetworkWired,
    faNeuter: faNeuter,
    faNewspaper: faNewspaper,
    faNotEqual: faNotEqual,
    faNotesMedical: faNotesMedical,
    faObjectGroup: faObjectGroup,
    faObjectUngroup: faObjectUngroup,
    faOilCan: faOilCan,
    faOm: faOm,
    faOtter: faOtter,
    faOutdent: faOutdent,
    faPager: faPager,
    faPaintBrush: faPaintBrush,
    faPaintRoller: faPaintRoller,
    faPalette: faPalette,
    faPallet: faPallet,
    faPaperPlane: faPaperPlane,
    faPaperclip: faPaperclip,
    faParachuteBox: faParachuteBox,
    faParagraph: faParagraph,
    faParking: faParking,
    faPassport: faPassport,
    faPastafarianism: faPastafarianism,
    faPaste: faPaste,
    faPause: faPause,
    faPauseCircle: faPauseCircle,
    faPaw: faPaw,
    faPeace: faPeace,
    faPen: faPen,
    faPenAlt: faPenAlt,
    faPenFancy: faPenFancy,
    faPenNib: faPenNib,
    faPenSquare: faPenSquare,
    faPencilAlt: faPencilAlt,
    faPencilRuler: faPencilRuler,
    faPeopleArrows: faPeopleArrows,
    faPeopleCarry: faPeopleCarry,
    faPepperHot: faPepperHot,
    faPercent: faPercent,
    faPercentage: faPercentage,
    faPersonBooth: faPersonBooth,
    faPhone: faPhone,
    faPhoneAlt: faPhoneAlt,
    faPhoneSlash: faPhoneSlash,
    faPhoneSquare: faPhoneSquare,
    faPhoneSquareAlt: faPhoneSquareAlt,
    faPhoneVolume: faPhoneVolume,
    faPhotoVideo: faPhotoVideo,
    faPiggyBank: faPiggyBank,
    faPills: faPills,
    faPizzaSlice: faPizzaSlice,
    faPlaceOfWorship: faPlaceOfWorship,
    faPlane: faPlane,
    faPlaneArrival: faPlaneArrival,
    faPlaneDeparture: faPlaneDeparture,
    faPlaneSlash: faPlaneSlash,
    faPlay: faPlay,
    faPlayCircle: faPlayCircle,
    faPlug: faPlug,
    faPlus: faPlus,
    faPlusCircle: faPlusCircle,
    faPlusSquare: faPlusSquare,
    faPodcast: faPodcast,
    faPoll: faPoll,
    faPollH: faPollH,
    faPoo: faPoo,
    faPooStorm: faPooStorm,
    faPoop: faPoop,
    faPortrait: faPortrait,
    faPoundSign: faPoundSign,
    faPowerOff: faPowerOff,
    faPray: faPray,
    faPrayingHands: faPrayingHands,
    faPrescription: faPrescription,
    faPrescriptionBottle: faPrescriptionBottle,
    faPrescriptionBottleAlt: faPrescriptionBottleAlt,
    faPrint: faPrint,
    faProcedures: faProcedures,
    faProjectDiagram: faProjectDiagram,
    faPumpMedical: faPumpMedical,
    faPumpSoap: faPumpSoap,
    faPuzzlePiece: faPuzzlePiece,
    faQrcode: faQrcode,
    faQuestion: faQuestion,
    faQuestionCircle: faQuestionCircle,
    faQuidditch: faQuidditch,
    faQuoteLeft: faQuoteLeft,
    faQuoteRight: faQuoteRight,
    faQuran: faQuran,
    faRadiation: faRadiation,
    faRadiationAlt: faRadiationAlt,
    faRainbow: faRainbow,
    faRandom: faRandom,
    faReceipt: faReceipt,
    faRecordVinyl: faRecordVinyl,
    faRecycle: faRecycle,
    faRedo: faRedo,
    faRedoAlt: faRedoAlt,
    faRegistered: faRegistered,
    faRemoveFormat: faRemoveFormat,
    faReply: faReply,
    faReplyAll: faReplyAll,
    faRepublican: faRepublican,
    faRestroom: faRestroom,
    faRetweet: faRetweet,
    faRibbon: faRibbon,
    faRing: faRing,
    faRoad: faRoad,
    faRobot: faRobot,
    faRocket: faRocket,
    faRoute: faRoute,
    faRss: faRss,
    faRssSquare: faRssSquare,
    faRubleSign: faRubleSign,
    faRuler: faRuler,
    faRulerCombined: faRulerCombined,
    faRulerHorizontal: faRulerHorizontal,
    faRulerVertical: faRulerVertical,
    faRunning: faRunning,
    faRupeeSign: faRupeeSign,
    faSadCry: faSadCry,
    faSadTear: faSadTear,
    faSatellite: faSatellite,
    faSatelliteDish: faSatelliteDish,
    faSave: faSave,
    faSchool: faSchool,
    faScrewdriver: faScrewdriver,
    faScroll: faScroll,
    faSdCard: faSdCard,
    faSearch: faSearch,
    faSearchDollar: faSearchDollar,
    faSearchLocation: faSearchLocation,
    faSearchMinus: faSearchMinus,
    faSearchPlus: faSearchPlus,
    faSeedling: faSeedling,
    faServer: faServer,
    faShapes: faShapes,
    faShare: faShare,
    faShareAlt: faShareAlt,
    faShareAltSquare: faShareAltSquare,
    faShareSquare: faShareSquare,
    faShekelSign: faShekelSign,
    faShieldAlt: faShieldAlt,
    faShieldVirus: faShieldVirus,
    faShip: faShip,
    faShippingFast: faShippingFast,
    faShoePrints: faShoePrints,
    faShoppingBag: faShoppingBag,
    faShoppingBasket: faShoppingBasket,
    faShoppingCart: faShoppingCart,
    faShower: faShower,
    faShuttleVan: faShuttleVan,
    faSign: faSign,
    faSignInAlt: faSignInAlt,
    faSignLanguage: faSignLanguage,
    faSignOutAlt: faSignOutAlt,
    faSignal: faSignal,
    faSignature: faSignature,
    faSimCard: faSimCard,
    faSink: faSink,
    faSitemap: faSitemap,
    faSkating: faSkating,
    faSkiing: faSkiing,
    faSkiingNordic: faSkiingNordic,
    faSkull: faSkull,
    faSkullCrossbones: faSkullCrossbones,
    faSlash: faSlash,
    faSleigh: faSleigh,
    faSlidersH: faSlidersH,
    faSmile: faSmile,
    faSmileBeam: faSmileBeam,
    faSmileWink: faSmileWink,
    faSmog: faSmog,
    faSmoking: faSmoking,
    faSmokingBan: faSmokingBan,
    faSms: faSms,
    faSnowboarding: faSnowboarding,
    faSnowflake: faSnowflake,
    faSnowman: faSnowman,
    faSnowplow: faSnowplow,
    faSoap: faSoap,
    faSocks: faSocks,
    faSolarPanel: faSolarPanel,
    faSort: faSort,
    faSortAlphaDown: faSortAlphaDown,
    faSortAlphaDownAlt: faSortAlphaDownAlt,
    faSortAlphaUp: faSortAlphaUp,
    faSortAlphaUpAlt: faSortAlphaUpAlt,
    faSortAmountDown: faSortAmountDown,
    faSortAmountDownAlt: faSortAmountDownAlt,
    faSortAmountUp: faSortAmountUp,
    faSortAmountUpAlt: faSortAmountUpAlt,
    faSortDown: faSortDown,
    faSortNumericDown: faSortNumericDown,
    faSortNumericDownAlt: faSortNumericDownAlt,
    faSortNumericUp: faSortNumericUp,
    faSortNumericUpAlt: faSortNumericUpAlt,
    faSortUp: faSortUp,
    faSpa: faSpa,
    faSpaceShuttle: faSpaceShuttle,
    faSpellCheck: faSpellCheck,
    faSpider: faSpider,
    faSpinner: faSpinner,
    faSplotch: faSplotch,
    faSprayCan: faSprayCan,
    faSquare: faSquare,
    faSquareFull: faSquareFull,
    faSquareRootAlt: faSquareRootAlt,
    faStamp: faStamp,
    faStar: faStar,
    faStarAndCrescent: faStarAndCrescent,
    faStarHalf: faStarHalf,
    faStarHalfAlt: faStarHalfAlt,
    faStarOfDavid: faStarOfDavid,
    faStarOfLife: faStarOfLife,
    faStepBackward: faStepBackward,
    faStepForward: faStepForward,
    faStethoscope: faStethoscope,
    faStickyNote: faStickyNote,
    faStop: faStop,
    faStopCircle: faStopCircle,
    faStopwatch: faStopwatch,
    faStopwatch20: faStopwatch20,
    faStore: faStore,
    faStoreAlt: faStoreAlt,
    faStoreAltSlash: faStoreAltSlash,
    faStoreSlash: faStoreSlash,
    faStream: faStream,
    faStreetView: faStreetView,
    faStrikethrough: faStrikethrough,
    faStroopwafel: faStroopwafel,
    faSubscript: faSubscript,
    faSubway: faSubway,
    faSuitcase: faSuitcase,
    faSuitcaseRolling: faSuitcaseRolling,
    faSun: faSun,
    faSuperscript: faSuperscript,
    faSurprise: faSurprise,
    faSwatchbook: faSwatchbook,
    faSwimmer: faSwimmer,
    faSwimmingPool: faSwimmingPool,
    faSynagogue: faSynagogue,
    faSync: faSync,
    faSyncAlt: faSyncAlt,
    faSyringe: faSyringe,
    faTable: faTable,
    faTableTennis: faTableTennis,
    faTablet: faTablet,
    faTabletAlt: faTabletAlt,
    faTablets: faTablets,
    faTachometerAlt: faTachometerAlt,
    faTag: faTag,
    faTags: faTags,
    faTape: faTape,
    faTasks: faTasks,
    faTaxi: faTaxi,
    faTeeth: faTeeth,
    faTeethOpen: faTeethOpen,
    faTemperatureHigh: faTemperatureHigh,
    faTemperatureLow: faTemperatureLow,
    faTenge: faTenge,
    faTerminal: faTerminal,
    faTextHeight: faTextHeight,
    faTextWidth: faTextWidth,
    faTh: faTh,
    faThLarge: faThLarge,
    faThList: faThList,
    faTheaterMasks: faTheaterMasks,
    faThermometer: faThermometer,
    faThermometerEmpty: faThermometerEmpty,
    faThermometerFull: faThermometerFull,
    faThermometerHalf: faThermometerHalf,
    faThermometerQuarter: faThermometerQuarter,
    faThermometerThreeQuarters: faThermometerThreeQuarters,
    faThumbsDown: faThumbsDown,
    faThumbsUp: faThumbsUp,
    faThumbtack: faThumbtack,
    faTicketAlt: faTicketAlt,
    faTimes: faTimes,
    faTimesCircle: faTimesCircle,
    faTint: faTint,
    faTintSlash: faTintSlash,
    faTired: faTired,
    faToggleOff: faToggleOff,
    faToggleOn: faToggleOn,
    faToilet: faToilet,
    faToiletPaper: faToiletPaper,
    faToiletPaperSlash: faToiletPaperSlash,
    faToolbox: faToolbox,
    faTools: faTools,
    faTooth: faTooth,
    faTorah: faTorah,
    faToriiGate: faToriiGate,
    faTractor: faTractor,
    faTrademark: faTrademark,
    faTrafficLight: faTrafficLight,
    faTrailer: faTrailer,
    faTrain: faTrain,
    faTram: faTram,
    faTransgender: faTransgender,
    faTransgenderAlt: faTransgenderAlt,
    faTrash: faTrash,
    faTrashAlt: faTrashAlt,
    faTrashRestore: faTrashRestore,
    faTrashRestoreAlt: faTrashRestoreAlt,
    faTree: faTree,
    faTrophy: faTrophy,
    faTruck: faTruck,
    faTruckLoading: faTruckLoading,
    faTruckMonster: faTruckMonster,
    faTruckMoving: faTruckMoving,
    faTruckPickup: faTruckPickup,
    faTshirt: faTshirt,
    faTty: faTty,
    faTv: faTv,
    faUmbrella: faUmbrella,
    faUmbrellaBeach: faUmbrellaBeach,
    faUnderline: faUnderline,
    faUndo: faUndo,
    faUndoAlt: faUndoAlt,
    faUniversalAccess: faUniversalAccess,
    faUniversity: faUniversity,
    faUnlink: faUnlink,
    faUnlock: faUnlock,
    faUnlockAlt: faUnlockAlt,
    faUpload: faUpload,
    faUser: faUser,
    faUserAlt: faUserAlt,
    faUserAltSlash: faUserAltSlash,
    faUserAstronaut: faUserAstronaut,
    faUserCheck: faUserCheck,
    faUserCircle: faUserCircle,
    faUserClock: faUserClock,
    faUserCog: faUserCog,
    faUserEdit: faUserEdit,
    faUserFriends: faUserFriends,
    faUserGraduate: faUserGraduate,
    faUserInjured: faUserInjured,
    faUserLock: faUserLock,
    faUserMd: faUserMd,
    faUserMinus: faUserMinus,
    faUserNinja: faUserNinja,
    faUserNurse: faUserNurse,
    faUserPlus: faUserPlus,
    faUserSecret: faUserSecret,
    faUserShield: faUserShield,
    faUserSlash: faUserSlash,
    faUserTag: faUserTag,
    faUserTie: faUserTie,
    faUserTimes: faUserTimes,
    faUsers: faUsers,
    faUsersCog: faUsersCog,
    faUsersSlash: faUsersSlash,
    faUtensilSpoon: faUtensilSpoon,
    faUtensils: faUtensils,
    faVectorSquare: faVectorSquare,
    faVenus: faVenus,
    faVenusDouble: faVenusDouble,
    faVenusMars: faVenusMars,
    faVest: faVest,
    faVestPatches: faVestPatches,
    faVial: faVial,
    faVials: faVials,
    faVideo: faVideo,
    faVideoSlash: faVideoSlash,
    faVihara: faVihara,
    faVirus: faVirus,
    faVirusSlash: faVirusSlash,
    faViruses: faViruses,
    faVoicemail: faVoicemail,
    faVolleyballBall: faVolleyballBall,
    faVolumeDown: faVolumeDown,
    faVolumeMute: faVolumeMute,
    faVolumeOff: faVolumeOff,
    faVolumeUp: faVolumeUp,
    faVoteYea: faVoteYea,
    faVrCardboard: faVrCardboard,
    faWalking: faWalking,
    faWallet: faWallet,
    faWarehouse: faWarehouse,
    faWater: faWater,
    faWaveSquare: faWaveSquare,
    faWeight: faWeight,
    faWeightHanging: faWeightHanging,
    faWheelchair: faWheelchair,
    faWifi: faWifi,
    faWind: faWind,
    faWindowClose: faWindowClose,
    faWindowMaximize: faWindowMaximize,
    faWindowMinimize: faWindowMinimize,
    faWindowRestore: faWindowRestore,
    faWineBottle: faWineBottle,
    faWineGlass: faWineGlass,
    faWineGlassAlt: faWineGlassAlt,
    faWonSign: faWonSign,
    faWrench: faWrench,
    faXRay: faXRay,
    faYenSign: faYenSign,
    faYinYang: faYinYang
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32SD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FontAwesomeIcon", ()=>FontAwesomeIcon);
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        'fa-beat': beat,
        'fa-fade': fade,
        'fa-beat-fade': beatFade,
        'fa-bounce': bounce,
        'fa-shake': shake,
        'fa-flash': flash,
        'fa-spin': spin,
        'fa-spin-reverse': spinReverse,
        'fa-spin-pulse': spinPulse,
        'fa-pulse': pulse,
        'fa-fw': fixedWidth,
        'fa-inverse': inverse,
        'fa-border': border,
        'fa-li': listItem,
        'fa-flip': flip === true,
        'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
        'fa-flip-vertical': flip === 'vertical' || flip === 'both'
    }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function _isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function camelize(string) {
    if (_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : '';
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var _excluded$1 = [
    "style"
];
function capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
    return style.split(';').map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(':');
        var prop = camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === 'string') return element;
    var children = (element.children || []).map(function(child) {
        return convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case 'class':
                acc.attrs['className'] = val;
                delete element.attributes['class'];
                break;
            case 'style':
                acc.attrs['style'] = styleToObject(val);
                break;
            default:
                if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = _objectWithoutProperties(extraProps, _excluded$1);
    mixins.attrs['style'] = _objectSpread2(_objectSpread2({}, mixins.attrs['style']), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)
    ].concat(_toConsumableArray(children)));
}
var PRODUCTION = false;
try {
    PRODUCTION = true;
} catch (e) {}
function log() {
    if (!PRODUCTION && console && typeof console.error === 'function') {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, _fontawesomeSvgCore.parse).icon) return (0, _fontawesomeSvgCore.parse).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === 'string') return {
        prefix: 'fas',
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}
var _excluded = [
    "forwardedRef"
];
function FontAwesomeIcon(_ref) {
    var forwardedRef = _ref.forwardedRef, props = _objectWithoutProperties(_ref, _excluded);
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = normalizeIconArgs(iconArgs);
    var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
    var transform = objectWithKey('transform', typeof props.transform === 'string' ? (0, _fontawesomeSvgCore.parse).transform(props.transform) : props.transform);
    var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
    var renderedIcon = (0, _fontawesomeSvgCore.icon)(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        log('Could not find icon', iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: forwardedRef
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
    beat: (0, _propTypesDefault.default).bool,
    border: (0, _propTypesDefault.default).bool,
    beatFade: (0, _propTypesDefault.default).bool,
    bounce: (0, _propTypesDefault.default).bool,
    className: (0, _propTypesDefault.default).string,
    fade: (0, _propTypesDefault.default).bool,
    flash: (0, _propTypesDefault.default).bool,
    mask: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).string
    ]),
    maskId: (0, _propTypesDefault.default).string,
    fixedWidth: (0, _propTypesDefault.default).bool,
    inverse: (0, _propTypesDefault.default).bool,
    flip: (0, _propTypesDefault.default).oneOf([
        true,
        false,
        'horizontal',
        'vertical',
        'both'
    ]),
    icon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).object,
        (0, _propTypesDefault.default).array,
        (0, _propTypesDefault.default).string
    ]),
    listItem: (0, _propTypesDefault.default).bool,
    pull: (0, _propTypesDefault.default).oneOf([
        'right',
        'left'
    ]),
    pulse: (0, _propTypesDefault.default).bool,
    rotation: (0, _propTypesDefault.default).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, _propTypesDefault.default).bool,
    size: (0, _propTypesDefault.default).oneOf([
        '2xs',
        'xs',
        'sm',
        'lg',
        'xl',
        '2xl',
        '1x',
        '2x',
        '3x',
        '4x',
        '5x',
        '6x',
        '7x',
        '8x',
        '9x',
        '10x'
    ]),
    spin: (0, _propTypesDefault.default).bool,
    spinPulse: (0, _propTypesDefault.default).bool,
    spinReverse: (0, _propTypesDefault.default).bool,
    symbol: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).string
    ]),
    title: (0, _propTypesDefault.default).string,
    titleId: (0, _propTypesDefault.default).string,
    transform: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).object
    ]),
    swapOpacity: (0, _propTypesDefault.default).bool
};
FontAwesomeIcon.defaultProps = {
    border: false,
    className: '',
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: '',
    titleId: null,
    transform: null,
    swapOpacity: false
};
var convertCurry = convert.bind(null, (0, _reactDefault.default).createElement);

},{"@fortawesome/fontawesome-svg-core":"inKXd","prop-types":"bnNSm","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"inKXd":[function(require,module,exports,__globalThis) {
/*!
 * Font Awesome Free 6.0.0 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noAuto", ()=>noAuto$1);
parcelHelpers.export(exports, "config", ()=>config$1);
parcelHelpers.export(exports, "library", ()=>library$1);
parcelHelpers.export(exports, "dom", ()=>dom$1);
parcelHelpers.export(exports, "parse", ()=>parse$1);
parcelHelpers.export(exports, "findIconDefinition", ()=>findIconDefinition$1);
parcelHelpers.export(exports, "toHtml", ()=>toHtml$1);
parcelHelpers.export(exports, "icon", ()=>icon);
parcelHelpers.export(exports, "layer", ()=>layer);
parcelHelpers.export(exports, "text", ()=>text);
parcelHelpers.export(exports, "counter", ()=>counter);
parcelHelpers.export(exports, "api", ()=>api);
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _wrapRegExp() {
    _wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, _wrapRegExp.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var noop = function noop() {};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
    mark: noop,
    measure: noop
};
try {
    if (typeof window !== 'undefined') _WINDOW = window;
    if (typeof document !== 'undefined') _DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}
var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
var IS_BROWSER = !!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var MUTATION_APPROACH_ASYNC = 'async';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var PREFIX_TO_STYLE = {
    'fas': 'solid',
    'fa-solid': 'solid',
    'far': 'regular',
    'fa-regular': 'regular',
    'fal': 'light',
    'fa-light': 'light',
    'fat': 'thin',
    'fa-thin': 'thin',
    'fad': 'duotone',
    'fa-duotone': 'duotone',
    'fab': 'brands',
    'fa-brands': 'brands',
    'fak': 'kit',
    'fa-kit': 'kit',
    'fa': 'solid'
};
var STYLE_TO_PREFIX = {
    'solid': 'fas',
    'regular': 'far',
    'light': 'fal',
    'thin': 'fat',
    'duotone': 'fad',
    'brands': 'fab',
    'kit': 'fak'
};
var PREFIX_TO_LONG_STYLE = {
    'fab': 'fa-brands',
    'fad': 'fa-duotone',
    'fak': 'fa-kit',
    'fal': 'fa-light',
    'far': 'fa-regular',
    'fas': 'fa-solid',
    'fat': 'fa-thin'
};
var LONG_STYLE_TO_PREFIX = {
    'fa-brands': 'fab',
    'fa-duotone': 'fad',
    'fa-kit': 'fak',
    'fa-light': 'fal',
    'fa-regular': 'far',
    'fa-solid': 'fas',
    'fa-thin': 'fat'
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/; // eslint-disable-line no-useless-escape
var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
var FONT_WEIGHT_TO_PREFIX = {
    '900': 'fas',
    '400': 'far',
    'normal': 'far',
    '300': 'fal',
    '100': 'fat'
};
var oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var oneToTwenty = oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var DUOTONE_CLASSES = {
    GROUP: 'duotone-group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
var RESERVED_CLASSES = [].concat(_toConsumableArray(Object.keys(STYLE_TO_PREFIX)), [
    '2xs',
    'xs',
    'sm',
    'lg',
    'xl',
    '2xl',
    'beat',
    'border',
    'fade',
    'beat-fade',
    'bounce',
    'flip-both',
    'flip-horizontal',
    'flip-vertical',
    'flip',
    'fw',
    'inverse',
    'layers-counter',
    'layers-text',
    'layers',
    'li',
    'pull-left',
    'pull-right',
    'pulse',
    'rotate-180',
    'rotate-270',
    'rotate-90',
    'rotate-by',
    'shake',
    'spin-pulse',
    'spin-reverse',
    'spin',
    'stack-1x',
    'stack-2x',
    'stack',
    'ul',
    DUOTONE_CLASSES.GROUP,
    DUOTONE_CLASSES.SWAP_OPACITY,
    DUOTONE_CLASSES.PRIMARY,
    DUOTONE_CLASSES.SECONDARY
]).concat(oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat(oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
    var element = DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    // For example <script data-search-pseudo-elements src="..."></script>
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
    var attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    attrs.forEach(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = coerce(getAttrConfig(attr));
        if (val !== undefined && val !== null) initial[key] = val;
    });
}
var _default = {
    familyPrefix: DEFAULT_FAMILY_PREFIX,
    styleDefault: 'solid',
    replacementClass: DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
var _config = _objectSpread2(_objectSpread2({}, _default), initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function(key) {
    Object.defineProperty(config, key, {
        enumerable: true,
        set: function set(val) {
            _config[key] = val;
            _onChangeCb.forEach(function(cb) {
                return cb(config);
            });
        },
        get: function get() {
            return _config[key];
        }
    });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb) {
    _onChangeCb.push(cb);
    return function() {
        _onChangeCb.splice(_onChangeCb.indexOf(cb), 1);
    };
}
var d = UNITS_IN_GRID;
var meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function insertCss(css) {
    if (!css || !IS_DOM) return;
    var style = DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += idPool[Math.random() * 62 | 0];
    return id;
}
function toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function classArray(node) {
    if (node.classList) return toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function transformIsMeaningful(transform) {
    return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && IS_IE) val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
    else val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
    val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";
function css() {
    var dfp = DEFAULT_FAMILY_PREFIX;
    var drc = DEFAULT_REPLACEMENT_CLASS;
    var fp = config.familyPrefix;
    var rc = config.replacementClass;
    var s = baseStyles;
    if (fp !== dfp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var _cssInserted = false;
function ensureCss() {
    if (config.autoAddCss && !_cssInserted) {
        insertCss(css());
        _cssInserted = true;
    }
}
var InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: css,
                insertCss: ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                ensureCss();
            }
        };
    }
};
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener() {
    DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    loaded = 1;
    functions.map(function(fn) {
        return fn();
    });
};
var loaded = false;
if (IS_DOM) {
    loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
    if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}
function domready(fn) {
    if (!IS_DOM) return;
    loaded ? setTimeout(fn, 0) : functions.push(fn);
}
function toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
}
function iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function toHex(unicode) {
    var decoded = ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = normalizeIcons(icons);
    if (typeof namespace.hooks.addPack === 'function' && !skipHooks) namespace.hooks.addPack(prefix, normalizeIcons(icons));
    else namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') defineIcons('fa', icons);
}
var duotonePathRe = [
    /*#__PURE__*/ _wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ _wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ _wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var styles = namespace.styles, shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);
function isReserved(name) {
    return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(familyPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) return iconName;
    else return null;
}
var build = function build() {
    var lookup = function lookup(reducer) {
        return reduce(styles, function(o, style, prefix) {
            o[prefix] = reduce(style, reducer, {});
            return o;
        }, {});
    };
    _byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    _byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    _byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in styles || config.autoFetchSvg;
    var shimLookups = reduce(shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    _byOldName = shimLookups.names;
    _byOldUnicode = shimLookups.unicodes;
    _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function(c) {
    _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
    return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
    return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
    return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
    return _byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function byOldUnicode(unicode) {
    var oldUnicode = _byOldUnicode[unicode];
    var newUnicode = byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function getDefaultUsablePrefix() {
    return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function getCanonicalPrefix(styleOrPrefix) {
    var style = PREFIX_TO_STYLE[styleOrPrefix];
    var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
    var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
function getCanonicalIcon(values) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var givenPrefix = null;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = getIconName(config.familyPrefix, cls);
        if (styles[cls]) {
            cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if (PREFIXES.indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = getCanonicalPrefix(cls);
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== config.replacementClass) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === 'fa' ? byOldName(acc.iconName) : {};
            var aliasIconName = byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === 'far' && !styles['far'] && styles['fas'] && !config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = 'fas';
        }
        return acc;
    }, emptyCanonicalIcon());
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var Library = /*#__PURE__*/ function() {
    function Library() {
        _classCallCheck(this, Library);
        this.definitions = {};
    }
    _createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = _objectSpread2(_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    defineIcons(key, additions[key]);
                    var longPrefix = PREFIX_TO_LONG_STYLE[key];
                    if (longPrefix) defineIcons(longPrefix, additions[key]);
                    build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    _plugins = nextPlugins;
    _hooks = {};
    Object.keys(providers).forEach(function(k) {
        if (defaultProviderKeys.indexOf(k) === -1) delete providers[k];
    });
    _plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if (_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!_hooks[hook]) _hooks[hook] = [];
                _hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides(providers);
    });
    return obj;
}
function chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = _hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return providers[hook] ? providers[hook].apply(null, args) : undefined;
}
function findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = byAlias(prefix, iconName) || iconName;
    return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto() {
    config.autoReplaceSvg = false;
    config.observeMutations = false;
    callHooks('noAuto');
};
var dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (IS_DOM) {
            callHooks('beforeI2svg', params);
            callProvided('pseudoElements2svg', params);
            return callProvided('i2svg', params);
        } else return Promise.reject('Operation requires a DOM of some kind.');
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if (config.autoReplaceSvg === false) config.autoReplaceSvg = true;
        config.observeMutations = true;
        domready(function() {
            autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            callHooks('watch', params);
        });
    }
};
var parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if (_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
                iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var api = {
    noAuto: noAuto,
    config: config,
    dom: dom,
    parse: parse,
    library: library,
    findIconDefinition: findIconDefinition,
    toHtml: toHtml
};
var autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!IS_DOM) return;
            var container = DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if (transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = joinStyles(_objectSpread2(_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: _objectSpread2(_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === 'fak';
    var attrClass = [
        config.replacementClass,
        iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: _objectSpread2(_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = _objectSpread2(_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: _objectSpread2(_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return asSymbol(args);
    else return asIcon(args);
}
function makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[DATA_FA_I2SVG] = '';
    var styles = _objectSpread2({}, extra.styles);
    if (transformIsMeaningful(transform)) {
        styles['transform'] = transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = _objectSpread2(_objectSpread2(_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    var styleString = joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
var styles$1 = namespace.styles;
function asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = _slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function maybeNotifyMissing(iconName, prefix) {
    if (!PRODUCTION && !config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && config.styleDefault !== null) prefix = getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: callProvided('missingIconAbstract') || {}
        };
        if (givenPrefix === 'fa') {
            var shim = byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && styles$1[prefix] && styles$1[prefix][iconName]) {
            var icon = styles$1[prefix][iconName];
            return resolve(asFoundIcon(icon));
        }
        maybeNotifyMissing(iconName, prefix);
        resolve(_objectSpread2(_objectSpread2({}, missingIconResolutionMixin), {}, {
            icon: config.showMissingIcons && iconName ? callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var noop$1 = function noop() {};
var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
    mark: noop$1,
    measure: noop$1
};
var preamble = "FA \"6.0.0\"";
var begin = function begin(name) {
    p.mark("".concat(preamble, " ").concat(name, " begins"));
    return function() {
        return end(name);
    };
};
var end = function end(name) {
    p.mark("".concat(preamble, " ").concat(name, " ends"));
    p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
    begin: begin,
    end: end
};
var noop$2 = function noop() {};
function isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
    return prefix && icon;
}
function hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
    if (config.autoReplaceSvg === true) return mutators.replace;
    var mutator = mutators[config.autoReplaceSvg];
    return mutator || mutators.replace;
}
function createElementNS(tag) {
    return DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function createElement(tag) {
    return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? createElementNS : createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild(convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore(convertSVG(abstract), node);
            });
            if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
                var comment = DOCUMENT.createComment(nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~classArray(node).indexOf(config.replacementClass)) return mutators.replace(mutation);
        var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return toHtml(a);
        }).join('\n');
        node.setAttribute(DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function performOperationSync(op) {
    op();
}
function perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = performOperationSync;
        if (config.mutateApproach === MUTATION_APPROACH_ASYNC) frame = WINDOW.requestAnimationFrame || performOperationSync;
        frame(function() {
            var mutator = getMutator();
            var mark = perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var disabled = false;
function disableObservation() {
    disabled = true;
}
function enableObservation() {
    disabled = false;
}
var mo = null;
function observe(options) {
    if (!MUTATION_OBSERVER) return;
    if (!config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
    mo = new MUTATION_OBSERVER(function(objects) {
        if (disabled) return;
        var defaultPrefix = getDefaultUsablePrefix();
        toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
                if (config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute(DATA_ICON, iconName);
                } else if (hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!IS_DOM) return;
    mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function disconnect() {
    if (!mo) return;
    mo.disconnect();
}
function styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = getCanonicalIcon(classArray(node));
    if (!val.prefix) val.prefix = getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
    return val;
}
function attributesParser(node) {
    var extraAttributes = toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute('title');
    var titleId = node.getAttribute('data-fa-title-id');
    if (config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = attributesParser(node);
    var pluginMeta = chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? styleParser(node) : [];
    return _objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var styles$2 = namespace.styles;
function generateMutation(node) {
    var nodeMeta = config.autoReplaceSvg === 'nest' ? parseMeta(node, {
        styleParser: false
    }) : parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) return callProvided('generateLayersText', node, nodeMeta);
    else return callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!IS_DOM) return Promise.resolve();
    var htmlClassList = DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2);
    var prefixesDomQuery = [
        ".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!PRODUCTION) {
                if (e.name === 'MissingIcon') console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    generateMutation(node).then(function(mutation) {
        if (mutation) perform([
            mutation
        ], callback);
    });
}
function resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
        return next(iconDefinition, _objectSpread2(_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return domVariants(_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if (config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return makeInlineSvgAbstract({
            icons: {
                main: asFoundIcon(icon),
                mask: mask ? asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: resolveIcons(render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = onTree;
                accumulator.nodeCallback = onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    findIcon(iconName, prefix),
                    mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if (transformIsMeaningful(transform)) nextChild = callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return domVariants({
                    type: 'layer'
                }, function() {
                    callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat(config.familyPrefix, "-layers")
                                ].concat(_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat(config.familyPrefix, "-layers-counter")
                            ].concat(_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return makeLayersTextAbstract({
                        content: content,
                        transform: _objectSpread2(_objectSpread2({}, meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat(config.familyPrefix, "-layers-text")
                            ].concat(_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if (IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if (config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function hexValueFromContent(content) {
    var cleaned = content.replace(CLEAN_CONTENT_PATTERN, '');
    var codePoint = codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function replaceForPosition(node, position) {
    var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = ~[
                'Solid',
                'Regular',
                'Light',
                'Thin',
                'Duotone',
                'Brands',
                'Kit'
            ].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
            var _hexValueFromContent = hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith('FontAwesome');
            var iconName = byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = blankMeta();
                var extra = meta.extra;
                extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
                findIcon(iconName, prefix).then(function(main) {
                    var abstract = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = DOCUMENT.createElement('svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a) {
                        return toHtml(a);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function replace(node) {
    return Promise.all([
        replaceForPosition(node, '::before'),
        replaceForPosition(node, '::after')
    ]);
}
function processable(node) {
    return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function searchPseudoElements(root) {
    if (!IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = toArray(root.querySelectorAll('*')).filter(processable).map(replace);
        var end = perf.begin('searchPseudoElements');
        disableObservation();
        Promise.all(operations).then(function() {
            end();
            enableObservation();
            resolve();
        }).catch(function() {
            end();
            enableObservation();
            reject();
        });
    });
}
var PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node;
            if (config.searchPseudoElements) searchPseudoElements(node);
        };
    }
};
var _unwatched = false;
var MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    disableObservation();
                    _unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                observe(chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if (_unwatched) enableObservation();
                else observe(chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: _objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: _objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: _objectSpread2(_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map(fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: _objectSpread2({}, trans.inner),
                children: [
                    fillBlack(_objectSpread2({
                        tag: mainPath.tag,
                        attributes: _objectSpread2(_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: _objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: _objectSpread2(_objectSpread2({}, ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: _objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if (WINDOW.matchMedia) reduceMotion = WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            }; // Ring
            gChildren.push({
                tag: 'path',
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: _objectSpread2(_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: _objectSpread2(_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: _objectSpread2(_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var plugins = [
    InjectCSS,
    ReplaceElements,
    Layers,
    LayersCounter,
    LayersText,
    PseudoElements,
    MutationObserver$1,
    PowerTransforms,
    Masks,
    MissingIconIndicator,
    SvgSymbols
];
registerPlugins(plugins, {
    mixoutsTo: api
});
var noAuto$1 = api.noAuto;
var config$1 = api.config;
var library$1 = api.library;
var dom$1 = api.dom;
var parse$1 = api.parse;
var findIconDefinition$1 = api.findIconDefinition;
var toHtml$1 = api.toHtml;
var icon = api.icon;
var layer = api.layer;
var text = api.text;
var counter = api.counter;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PNR8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"liXbF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "LocalizationProvider", {
    enumerable: true,
    get: function() {
        return _LocalizationProvider.LocalizationProvider;
    }
});
Object.defineProperty(exports, "MuiPickersAdapterContext", {
    enumerable: true,
    get: function() {
        return _LocalizationProvider.MuiPickersAdapterContext;
    }
});
var _LocalizationProvider = require("a33594e55e660668");

},{"a33594e55e660668":"4xBEv"}],"4xBEv":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b2fc38b5b6e5dd19").default;
var _interopRequireWildcard = require("32c96016b31655a3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickerAdapterContext = exports.MuiPickersAdapterContext = exports.LocalizationProvider = void 0;
var _extends2 = _interopRequireDefault(require("d0f0d6ccd42e3523"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("560fe7f3ea4bcb44"));
var React = _interopRequireWildcard(require("2e10ab214181f8cb"));
var _propTypes = _interopRequireDefault(require("e2364a637c5873a"));
var _styles = require("291a70b82befda8f");
var _jsxRuntime = require("317efa627d4893f7");
const _excluded = [
    "localeText"
];
const PickerAdapterContext = exports.PickerAdapterContext = /*#__PURE__*/ React.createContext(null);
const MuiPickersAdapterContext = exports.MuiPickersAdapterContext = PickerAdapterContext;
/**
 * Demos:
 *
 * - [Date format and localization](https://mui.com/x/react-date-pickers/adapters-locale/)
 * - [Calendar systems](https://mui.com/x/react-date-pickers/calendar-systems/)
 * - [Translated components](https://mui.com/x/react-date-pickers/localization/)
 * - [UTC and timezones](https://mui.com/x/react-date-pickers/timezone/)
 *
 * API:
 *
 * - [LocalizationProvider API](https://mui.com/x/api/date-pickers/localization-provider/)
 */ const LocalizationProvider = exports.LocalizationProvider = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, _objectWithoutPropertiesLoose2.default)(inProps, _excluded);
    const { adapter: parentAdapter, localeText: parentLocaleText } = React.useContext(PickerAdapterContext) ?? {
        utils: undefined,
        adapter: undefined,
        localeText: undefined
    };
    const props = (0, _styles.useThemeProps)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children, dateAdapter: DateAdapter, dateFormats, dateLibInstance, adapterLocale, localeText: themeLocaleText } = props;
    const localeText = React.useMemo(()=>(0, _extends2.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const adapter = React.useMemo(()=>{
        if (!DateAdapter) {
            if (parentAdapter) return parentAdapter;
            return null;
        }
        const dateAdapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!dateAdapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation'
        ].join(`\n`));
        return dateAdapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentAdapter
    ]);
    const defaultDates = React.useMemo(()=>{
        if (!adapter) return null;
        return {
            minDate: adapter.date('1900-01-01T00:00:00.000'),
            maxDate: adapter.date('2099-12-31T00:00:00.000')
        };
    }, [
        adapter
    ]);
    const contextValue = React.useMemo(()=>{
        return {
            utils: adapter,
            adapter,
            defaultDates,
            localeText
        };
    }, [
        defaultDates,
        adapter,
        localeText
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerAdapterContext.Provider, {
        value: contextValue,
        children: children
    });
};

},{"b2fc38b5b6e5dd19":"9snJq","32c96016b31655a3":"5RcSx","d0f0d6ccd42e3523":"h7ttl","560fe7f3ea4bcb44":"jeIdK","2e10ab214181f8cb":"9njXz","e2364a637c5873a":"bnNSm","291a70b82befda8f":"c9RfU","317efa627d4893f7":"1dlk8"}],"9snJq":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5RcSx":[function(require,module,exports,__globalThis) {
var _typeof = require("726f0df07df46e")["default"];
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"726f0df07df46e":"j2Jok"}],"j2Jok":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"h7ttl":[function(require,module,exports,__globalThis) {
function _extends() {
    return module.exports = _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jeIdK":[function(require,module,exports,__globalThis) {
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"1cvBy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MobileTimePicker", {
    enumerable: true,
    get: function() {
        return _MobileTimePicker.MobileTimePicker;
    }
});
var _MobileTimePicker = require("979b7a7c5fe1f394");

},{"979b7a7c5fe1f394":"3h5KV"}],"3h5KV":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("b74ac3f0d4f925b4").default;
var _interopRequireDefault = require("a37a0e1e8d514705").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileTimePicker = void 0;
var _extends2 = _interopRequireDefault(require("b1954e7a99f0f28e"));
var React = _interopRequireWildcard(require("3d8659129e963d58"));
var _propTypes = _interopRequireDefault(require("aa356740f2af7feb"));
var _resolveComponentProps = _interopRequireDefault(require("ca5a2886843d9b87"));
var _refType = _interopRequireDefault(require("be1dfd3e6eb3fa1a"));
var _valueManagers = require("5ef0d9244012cd49");
var _TimeField = require("1dba5aecad97a607");
var _shared = require("d644f44d757f645c");
var _usePickerAdapter = require("71650d059f128799");
var _validation = require("7f92967ade523923");
var _useMobilePicker = require("47eee5ace0a6e51a");
var _timeViewRenderers = require("ad9bd2331e5522c6");
var _timeUtils = require("bd3eae7775d96b89");
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileTimePicker API](https://mui.com/x/api/date-pickers/mobile-time-picker/)
 */ const MobileTimePicker = exports.MobileTimePicker = /*#__PURE__*/ React.forwardRef(function MobileTimePicker(inProps, ref) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, _shared.useTimePickerDefaultizedProps)(inProps, 'MuiMobileTimePicker');
    const viewRenderers = (0, _extends2.default)({
        hours: _timeViewRenderers.renderTimeViewClock,
        minutes: _timeViewRenderers.renderTimeViewClock,
        seconds: _timeViewRenderers.renderTimeViewClock
    }, defaultizedProps.viewRenderers);
    const ampmInClock = defaultizedProps.ampmInClock ?? false;
    // Props with the default values specific to the mobile variant
    const props = (0, _extends2.default)({}, defaultizedProps, {
        ampmInClock,
        viewRenderers,
        format: (0, _timeUtils.resolveTimeFormat)(adapter, defaultizedProps),
        slots: (0, _extends2.default)({
            field: _TimeField.TimeField
        }, defaultizedProps.slots),
        slotProps: (0, _extends2.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, _extends2.default)({}, (0, _resolveComponentProps.default)(defaultizedProps.slotProps?.field, ownerState), (0, _validation.extractValidationProps)(defaultizedProps)),
            toolbar: (0, _extends2.default)({
                hidden: false,
                ampmInClock
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker } = (0, _useMobilePicker.useMobilePicker)({
        ref,
        props,
        valueManager: _valueManagers.singleItemValueManager,
        valueType: 'time',
        validator: _validation.validateTime,
        steps: null
    });
    return renderPicker();
});
MobileTimePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default adapter.is12HourCycleInCurrentLocale()
   */ ampm: _propTypes.default.bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: _propTypes.default.bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: _propTypes.default.bool,
    className: _propTypes.default.string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: _propTypes.default.bool,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: _propTypes.default.object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: _propTypes.default.bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: _propTypes.default.bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: _propTypes.default.bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: _propTypes.default.bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: _propTypes.default.any,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: _propTypes.default.string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: _propTypes.default.oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: _refType.default,
    /**
   * The label content.
   */ label: _propTypes.default.node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: _propTypes.default.object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: _propTypes.default.object,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: _propTypes.default.object,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: _propTypes.default.number,
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: _propTypes.default.string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: _propTypes.default.func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: _propTypes.default.func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: _propTypes.default.func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: _propTypes.default.func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: _propTypes.default.func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: _propTypes.default.func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: _propTypes.default.func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: _propTypes.default.bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: _propTypes.default.oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: _propTypes.default.oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: _propTypes.default.bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: _propTypes.default.bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: _propTypes.default.object,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: _propTypes.default.oneOfType([
        _propTypes.default.oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        _propTypes.default.number
    ]),
    /**
   * Disable specific time.
   * @param {PickerValidDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: _propTypes.default.func,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: _propTypes.default.object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: _propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: _propTypes.default.string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: _propTypes.default.object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: _propTypes.default.oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: _propTypes.default.shape({
        hours: _propTypes.default.func,
        minutes: _propTypes.default.func,
        seconds: _propTypes.default.func
    }),
    /**
   * Available views.
   */ views: _propTypes.default.arrayOf(_propTypes.default.oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
};

},{"b74ac3f0d4f925b4":"5RcSx","a37a0e1e8d514705":"9snJq","b1954e7a99f0f28e":"h7ttl","3d8659129e963d58":"9njXz","aa356740f2af7feb":"bnNSm","ca5a2886843d9b87":"iXpA3","be1dfd3e6eb3fa1a":"fAbhl","5ef0d9244012cd49":"03AqV","1dba5aecad97a607":"2aDNx","d644f44d757f645c":"57t9f","71650d059f128799":"hE9K5","7f92967ade523923":"2toSg","47eee5ace0a6e51a":"d0HtL","ad9bd2331e5522c6":"kAMAW","bd3eae7775d96b89":"gSWbl"}],"iXpA3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4d11259c2a99026b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _resolveComponentProps.default;
    }
});
var _resolveComponentProps = _interopRequireDefault(require("dce45738432f432b"));

},{"4d11259c2a99026b":"9snJq","dce45738432f432b":"1RyIV"}],"1RyIV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var _default = exports.default = resolveComponentProps;

},{}],"fAbhl":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e7aec33bec2df068").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _refType.default;
    }
});
var _refType = _interopRequireDefault(require("a6ca75995e5ea302"));

},{"e7aec33bec2df068":"9snJq","a6ca75995e5ea302":"hLlqY"}],"hLlqY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1cecfcade70af020").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("4c615ea3ab8383ff"));
const refType = _propTypes.default.oneOfType([
    _propTypes.default.func,
    _propTypes.default.object
]);
var _default = exports.default = refType;

},{"1cecfcade70af020":"9snJq","4c615ea3ab8383ff":"bnNSm"}],"03AqV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f11c1106c4f033d8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.singleItemValueManager = exports.singleItemFieldValueManager = void 0;
var _extends2 = _interopRequireDefault(require("6e669e95604e52b8"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("50b0614b1abb78ec"));
var _dateUtils = require("57580caa8317dd0d");
var _getDefaultReferenceDate = require("7c8d9ae53b7ce4b5");
var _useField = require("189836139c5bdb96");
const _excluded = [
    "value",
    "referenceDate"
];
const singleItemValueManager = exports.singleItemValueManager = {
    emptyValue: null,
    getTodayValue: _dateUtils.getTodayDate,
    getInitialReferenceValue: (_ref)=>{
        let { value, referenceDate } = _ref, params = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
        if (params.adapter.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, _getDefaultReferenceDate.getDefaultReferenceDate)(params);
    },
    cleanValue: _dateUtils.replaceInvalidDateByNull,
    areValuesEqual: _dateUtils.areDatesEqual,
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (adapter, value)=>adapter.isValid(value) ? adapter.getTimezone(value) : null,
    setTimezone: (adapter, timezone, value)=>value == null ? null : adapter.setTimezone(value, timezone)
};
const singleItemFieldValueManager = exports.singleItemFieldValueManager = {
    updateReferenceValue: (adapter, value, prevReferenceValue)=>adapter.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (date, getSectionsFromDate)=>getSectionsFromDate(date),
    getV7HiddenInputValueFromSections: _useField.createDateStrForV7HiddenInputFromSections,
    getV6InputValueFromSections: _useField.createDateStrForV6InputFromSections,
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue),
    getDateFromSection: (value)=>value,
    getDateSectionsFromValue: (sections)=>sections,
    updateDateInValue: (value, activeSection, activeDate)=>activeDate,
    clearDateSections: (sections)=>sections.map((section)=>(0, _extends2.default)({}, section, {
                value: ''
            }))
};

},{"f11c1106c4f033d8":"9snJq","6e669e95604e52b8":"h7ttl","50b0614b1abb78ec":"jeIdK","57580caa8317dd0d":"jwfEA","7c8d9ae53b7ce4b5":"kOJTa","189836139c5bdb96":"4JxIG"}],"jwfEA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveDateFormat = exports.replaceInvalidDateByNull = exports.mergeDateAndTime = exports.isDatePickerView = exports.getWeekdays = exports.getTodayDate = exports.getMonthsInYear = exports.formatMeridiem = exports.findClosestEnabledDate = exports.areDatesEqual = exports.applyDefaultDate = exports.DATE_VIEWS = void 0;
var _views = require("c122b85a7e71494f");
const mergeDateAndTime = (adapter, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = adapter.setHours(mergedDate, adapter.getHours(timeParam));
    mergedDate = adapter.setMinutes(mergedDate, adapter.getMinutes(timeParam));
    mergedDate = adapter.setSeconds(mergedDate, adapter.getSeconds(timeParam));
    mergedDate = adapter.setMilliseconds(mergedDate, adapter.getMilliseconds(timeParam));
    return mergedDate;
};
exports.mergeDateAndTime = mergeDateAndTime;
const findClosestEnabledDate = ({ date, disableFuture, disablePast, maxDate, minDate, isDateDisabled, adapter, timezone })=>{
    const today = mergeDateAndTime(adapter, adapter.date(undefined, timezone), date);
    if (disablePast && adapter.isBefore(minDate, today)) minDate = today;
    if (disableFuture && adapter.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (adapter.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (adapter.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && adapter.isAfter(forward, maxDate)) forward = null;
        if (backward && adapter.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = adapter.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = adapter.addDays(backward, -1);
        }
    }
    return null;
};
exports.findClosestEnabledDate = findClosestEnabledDate;
const replaceInvalidDateByNull = (adapter, value)=>!adapter.isValid(value) ? null : value;
exports.replaceInvalidDateByNull = replaceInvalidDateByNull;
const applyDefaultDate = (adapter, value, defaultValue)=>{
    if (value == null || !adapter.isValid(value)) return defaultValue;
    return value;
};
exports.applyDefaultDate = applyDefaultDate;
const areDatesEqual = (adapter, a, b)=>{
    if (!adapter.isValid(a) && a != null && !adapter.isValid(b) && b != null) return true;
    return adapter.isEqual(a, b);
};
exports.areDatesEqual = areDatesEqual;
const getMonthsInYear = (adapter, year)=>{
    const firstMonth = adapter.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(adapter.addMonths(prevMonth, 1));
    }
    return months;
};
exports.getMonthsInYear = getMonthsInYear;
const getTodayDate = (adapter, timezone, valueType)=>valueType === 'date' ? adapter.startOfDay(adapter.date(undefined, timezone)) : adapter.date(undefined, timezone);
exports.getTodayDate = getTodayDate;
const formatMeridiem = (adapter, meridiem)=>{
    const date = adapter.setHours(adapter.date(), meridiem === 'am' ? 2 : 14);
    return adapter.format(date, 'meridiem');
};
exports.formatMeridiem = formatMeridiem;
const DATE_VIEWS = exports.DATE_VIEWS = [
    'year',
    'month',
    'day'
];
const isDatePickerView = (view)=>DATE_VIEWS.includes(view);
exports.isDatePickerView = isDatePickerView;
const resolveDateFormat = (adapter, { format, views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, _views.areViewsEqual)(views, [
        'year'
    ])) return formats.year;
    if ((0, _views.areViewsEqual)(views, [
        'month'
    ])) return formats.month;
    if ((0, _views.areViewsEqual)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, _views.areViewsEqual)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, _views.areViewsEqual)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(adapter.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
exports.resolveDateFormat = resolveDateFormat;
const getWeekdays = (adapter, date)=>{
    const start = adapter.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>adapter.addDays(start, diff));
};
exports.getWeekdays = getWeekdays;

},{"c122b85a7e71494f":"geKoG"}],"geKoG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areViewsEqual = exports.applyDefaultViewProps = void 0;
const areViewsEqual = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
exports.areViewsEqual = areViewsEqual;
const applyDefaultViewProps = ({ openTo, defaultOpenTo, views, defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};
exports.applyDefaultViewProps = applyDefaultViewProps;

},{}],"kOJTa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSectionTypeGranularity = exports.getDefaultReferenceDate = exports.SECTION_TYPE_GRANULARITY = void 0;
var _timeUtils = require("644d369502a11863");
var _dateUtils = require("fae29e7a45d079a1");
const SECTION_TYPE_GRANULARITY = exports.SECTION_TYPE_GRANULARITY = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const getSectionTypeGranularity = (sections)=>Math.max(...sections.map((section)=>SECTION_TYPE_GRANULARITY[section.type] ?? 1));
exports.getSectionTypeGranularity = getSectionTypeGranularity;
const roundDate = (adapter, granularity, date)=>{
    if (granularity === SECTION_TYPE_GRANULARITY.year) return adapter.startOfYear(date);
    if (granularity === SECTION_TYPE_GRANULARITY.month) return adapter.startOfMonth(date);
    if (granularity === SECTION_TYPE_GRANULARITY.day) return adapter.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < SECTION_TYPE_GRANULARITY.minutes) roundedDate = adapter.setMinutes(roundedDate, 0);
    if (granularity < SECTION_TYPE_GRANULARITY.seconds) roundedDate = adapter.setSeconds(roundedDate, 0);
    if (granularity < SECTION_TYPE_GRANULARITY.milliseconds) roundedDate = adapter.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const getDefaultReferenceDate = ({ props, adapter, granularity, timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : roundDate(adapter, granularity, (0, _dateUtils.getTodayDate)(adapter, timezone));
    if (props.minDate != null && adapter.isAfterDay(props.minDate, referenceDate)) referenceDate = roundDate(adapter, granularity, props.minDate);
    if (props.maxDate != null && adapter.isBeforeDay(props.maxDate, referenceDate)) referenceDate = roundDate(adapter, granularity, props.maxDate);
    const isAfter = (0, _timeUtils.createIsAfterIgnoreDatePart)(props.disableIgnoringDatePartForTimeValidation ?? false, adapter);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, _dateUtils.mergeDateAndTime)(adapter, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, _dateUtils.mergeDateAndTime)(adapter, referenceDate, props.maxTime));
    return referenceDate;
};
exports.getDefaultReferenceDate = getDefaultReferenceDate;

},{"644d369502a11863":"gSWbl","fae29e7a45d079a1":"jwfEA"}],"gSWbl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resolveTimeFormat = exports.isTimeView = exports.isInternalTimeView = exports.getSecondsInDay = exports.getMeridiem = exports.createIsAfterIgnoreDatePart = exports.convertValueToMeridiem = exports.convertToMeridiem = exports.TIME_VIEWS = exports.EXPORTED_TIME_VIEWS = void 0;
var _views = require("214bbc7d109214e8");
const EXPORTED_TIME_VIEWS = exports.EXPORTED_TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds'
];
const TIME_VIEWS = exports.TIME_VIEWS = [
    'hours',
    'minutes',
    'seconds',
    'meridiem'
];
const isTimeView = (view)=>EXPORTED_TIME_VIEWS.includes(view);
exports.isTimeView = isTimeView;
const isInternalTimeView = (view)=>TIME_VIEWS.includes(view);
exports.isInternalTimeView = isInternalTimeView;
const getMeridiem = (date, adapter)=>{
    if (!date) return null;
    return adapter.getHours(date) >= 12 ? 'pm' : 'am';
};
exports.getMeridiem = getMeridiem;
const convertValueToMeridiem = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
exports.convertValueToMeridiem = convertValueToMeridiem;
const convertToMeridiem = (time, meridiem, ampm, adapter)=>{
    const newHoursAmount = convertValueToMeridiem(adapter.getHours(time), meridiem, ampm);
    return adapter.setHours(time, newHoursAmount);
};
exports.convertToMeridiem = convertToMeridiem;
const getSecondsInDay = (date, adapter)=>{
    return adapter.getHours(date) * 3600 + adapter.getMinutes(date) * 60 + adapter.getSeconds(date);
};
exports.getSecondsInDay = getSecondsInDay;
const createIsAfterIgnoreDatePart = (disableIgnoringDatePartForTimeValidation, adapter)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return adapter.isAfter(dateLeft, dateRight);
        return getSecondsInDay(dateLeft, adapter) > getSecondsInDay(dateRight, adapter);
    };
exports.createIsAfterIgnoreDatePart = createIsAfterIgnoreDatePart;
const resolveTimeFormat = (adapter, { format, views, ampm })=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, _views.areViewsEqual)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, _views.areViewsEqual)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, _views.areViewsEqual)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, _views.areViewsEqual)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, _views.areViewsEqual)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};
exports.resolveTimeFormat = resolveTimeFormat;

},{"214bbc7d109214e8":"geKoG"}],"4JxIG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateSections = exports.removeLocalizedDigits = exports.parseSelectedSections = exports.mergeDateIntoReferenceDate = exports.isStringNumber = exports.isAndroid = exports.getSectionsBoundaries = exports.getSectionVisibleValue = exports.getSectionOrder = exports.getLocalizedDigits = exports.getLetterEditingOptions = exports.getDaysInWeekStr = exports.getDateSectionConfigFromFormatToken = exports.getDateFromDateSections = exports.doesSectionFormatHaveLeadingZeros = exports.createDateStrForV7HiddenInputFromSections = exports.createDateStrForV6InputFromSections = exports.cleanLeadingZeros = exports.cleanDigitSectionValue = exports.changeSectionValueFormat = exports.applyLocalizedDigits = exports.FORMAT_SECONDS_NO_LEADING_ZEROS = void 0;
var _dateUtils = require("c3bd0fcb00d543e9");
const getDateSectionConfigFromFormatToken = (adapter, formatToken)=>{
    const config = adapter.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
exports.getDateSectionConfigFromFormatToken = getDateSectionConfigFromFormatToken;
const getDaysInWeekStr = (adapter, format)=>{
    const elements = [];
    const now = adapter.date(undefined, 'default');
    const startDate = adapter.startOfWeek(now);
    const endDate = adapter.endOfWeek(now);
    let current = startDate;
    while(adapter.isBefore(current, endDate)){
        elements.push(current);
        current = adapter.addDays(current, 1);
    }
    return elements.map((weekDay)=>adapter.formatByString(weekDay, format));
};
exports.getDaysInWeekStr = getDaysInWeekStr;
const getLetterEditingOptions = (adapter, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, _dateUtils.getMonthsInYear)(adapter, adapter.date(undefined, timezone)).map((month)=>adapter.formatByString(month, format));
        case 'weekDay':
            return getDaysInWeekStr(adapter, format);
        case 'meridiem':
            {
                const now = adapter.date(undefined, timezone);
                return [
                    adapter.startOfDay(now),
                    adapter.endOfDay(now)
                ].map((date)=>adapter.formatByString(date, format));
            }
        default:
            return [];
    }
};
// This format should be the same on all the adapters
// If some adapter does not respect this convention, then we will need to hardcode the format on each adapter.
exports.getLetterEditingOptions = getLetterEditingOptions;
const FORMAT_SECONDS_NO_LEADING_ZEROS = exports.FORMAT_SECONDS_NO_LEADING_ZEROS = 's';
const NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const getLocalizedDigits = (adapter)=>{
    const today = adapter.date(undefined);
    const formattedZero = adapter.formatByString(adapter.setSeconds(today, 0), FORMAT_SECONDS_NO_LEADING_ZEROS);
    if (formattedZero === '0') return NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>adapter.formatByString(adapter.setSeconds(today, index), FORMAT_SECONDS_NO_LEADING_ZEROS));
};
exports.getLocalizedDigits = getLocalizedDigits;
const removeLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
exports.removeLocalizedDigits = removeLocalizedDigits;
const applyLocalizedDigits = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
exports.applyLocalizedDigits = applyLocalizedDigits;
const isStringNumber = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = removeLocalizedDigits(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
/**
 * Make sure the value of a digit section have the right amount of leading zeros.
 * E.g.: `03` => `3`
 * Warning: Should only be called with non-localized digits. Call `removeLocalizedDigits` with your value if needed.
 */ exports.isStringNumber = isStringNumber;
const cleanLeadingZeros = (valueStr, size)=>{
    // Remove the leading zeros and then add back as many as needed.
    return Number(valueStr).toString().padStart(size, '0');
};
exports.cleanLeadingZeros = cleanLeadingZeros;
const cleanDigitSectionValue = (adapter, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = adapter.setDate(sectionBoundaries.longestMonth, value);
        return adapter.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = cleanLeadingZeros(valueStr, section.maxLength);
    return applyLocalizedDigits(valueStr, localizedDigits);
};
exports.cleanDigitSectionValue = cleanDigitSectionValue;
const getSectionVisibleValue = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(removeLocalizedDigits(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
exports.getSectionVisibleValue = getSectionVisibleValue;
const changeSectionValueFormat = (adapter, valueStr, currentFormat, newFormat)=>{
    return adapter.formatByString(adapter.parse(valueStr, currentFormat), newFormat);
};
exports.changeSectionValueFormat = changeSectionValueFormat;
const isFourDigitYearFormat = (adapter, format)=>adapter.formatByString(adapter.date(undefined, 'system'), format).length === 4;
const doesSectionFormatHaveLeadingZeros = (adapter, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = adapter.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (adapter.lib === 'dayjs' && format === 'YY') return true;
            return adapter.formatByString(adapter.setYear(now, 1), format).startsWith('0');
        case 'month':
            return adapter.formatByString(adapter.startOfYear(now), format).length > 1;
        case 'day':
            return adapter.formatByString(adapter.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return adapter.formatByString(adapter.startOfWeek(now), format).length > 1;
        case 'hours':
            return adapter.formatByString(adapter.setHours(now, 1), format).length > 1;
        case 'minutes':
            return adapter.formatByString(adapter.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return adapter.formatByString(adapter.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
/**
 * Some date libraries like `dayjs` don't support parsing from date with escaped characters.
 * To make sure that the parsing works, we are building a format and a date without any separator.
 */ exports.doesSectionFormatHaveLeadingZeros = doesSectionFormatHaveLeadingZeros;
const getDateFromDateSections = (adapter, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push(getSectionVisibleValue(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return adapter.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
exports.getDateFromDateSections = getDateFromDateSections;
const createDateStrForV7HiddenInputFromSections = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
exports.createDateStrForV7HiddenInputFromSections = createDateStrForV7HiddenInputFromSections;
const createDateStrForV6InputFromSections = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = getSectionVisibleValue(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
exports.createDateStrForV6InputFromSections = createDateStrForV6InputFromSections;
const getSectionsBoundaries = (adapter, localizedDigits, timezone)=>{
    const today = adapter.date(undefined, timezone);
    const endOfYear = adapter.endOfYear(today);
    const endOfDay = adapter.endOfDay(today);
    const { maxDaysInMonth, longestMonth } = (0, _dateUtils.getMonthsInYear)(adapter, today).reduce((acc, month)=>{
        const daysInMonth = adapter.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format })=>({
                minimum: 0,
                maximum: isFourDigitYearFormat(adapter, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: adapter.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate })=>({
                minimum: 1,
                maximum: adapter.isValid(currentDate) ? adapter.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format, contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = getDaysInWeekStr(adapter, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format })=>{
            const lastHourInDay = adapter.getHours(endOfDay);
            const hasMeridiem = removeLocalizedDigits(adapter.formatByString(adapter.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(removeLocalizedDigits(adapter.formatByString(adapter.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: adapter.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: adapter.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
exports.getSectionsBoundaries = getSectionsBoundaries;
let warnedOnceInvalidSection = false;
const validateSections = (sections, valueType)=>{};
exports.validateSections = validateSections;
const transferDateSectionValue = (adapter, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return adapter.setYear(dateToTransferTo, adapter.getYear(dateToTransferFrom));
        case 'month':
            return adapter.setMonth(dateToTransferTo, adapter.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                let dayInWeekStrOfActiveDate = adapter.formatByString(dateToTransferFrom, section.format);
                if (section.hasLeadingZerosInInput) dayInWeekStrOfActiveDate = cleanLeadingZeros(dayInWeekStrOfActiveDate, section.maxLength);
                const formattedDaysInWeek = getDaysInWeekStr(adapter, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return adapter.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return adapter.setDate(dateToTransferTo, adapter.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = adapter.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = adapter.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return adapter.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return adapter.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return adapter.setHours(dateToTransferTo, adapter.getHours(dateToTransferFrom));
        case 'minutes':
            return adapter.setMinutes(dateToTransferTo, adapter.getMinutes(dateToTransferFrom));
        case 'seconds':
            return adapter.setSeconds(dateToTransferTo, adapter.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const mergeDateIntoReferenceDate = (adapter, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>reliableSectionModificationOrder[a.type] - reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return transferDateSectionValue(adapter, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
exports.mergeDateIntoReferenceDate = mergeDateIntoReferenceDate;
const isAndroid = ()=>navigator.userAgent.toLowerCase().includes('android');
// TODO v9: Remove
exports.isAndroid = isAndroid;
const getSectionOrder = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex,
                rightIndex
            };
        });
        return {
            neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex,
            rightIndex
        };
    });
    return {
        neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
exports.getSectionOrder = getSectionOrder;
const parseSelectedSections = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};
exports.parseSelectedSections = parseSelectedSections;

},{"c3bd0fcb00d543e9":"jwfEA"}],"2aDNx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TimeField", {
    enumerable: true,
    get: function() {
        return _TimeField.TimeField;
    }
});
Object.defineProperty(exports, "unstable_useTimeField", {
    enumerable: true,
    get: function() {
        return _useTimeField.useTimeField;
    }
});
var _TimeField = require("2c28927cf5a4a882");
var _useTimeField = require("308e8ab8efbcb558");

},{"2c28927cf5a4a882":"kT66m","308e8ab8efbcb558":"33JZi"}],"kT66m":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c2dab68818d51907").default;
var _interopRequireWildcard = require("9536c41beda65754").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeField = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("97930dcda125e3e0"));
var React = _interopRequireWildcard(require("fe895ecc81ee629"));
var _propTypes = _interopRequireDefault(require("bddbb6c4ec680701"));
var _styles = require("afd23d26cb87b1fc");
var _refType = _interopRequireDefault(require("478c2af47e08cd5f"));
var _useTimeField = require("b3ff67792ec30c0c");
var _PickerFieldUI = require("d5d7c79ce50d8399");
var _icons = require("51dbcec5bd31ab5a");
var _jsxRuntime = require("ead36feb042a63d7");
const _excluded = [
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
];
/**
 * Demos:
 *
 * - [TimeField](http://mui.com/x/react-date-pickers/time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [TimeField API](https://mui.com/x/api/date-pickers/time-field/)
 */ const TimeField = exports.TimeField = /*#__PURE__*/ React.forwardRef(function TimeField(inProps, inRef) {
    const themeProps = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiTimeField'
    });
    const { slots, slotProps } = themeProps, other = (0, _objectWithoutPropertiesLoose2.default)(themeProps, _excluded);
    const textFieldProps = (0, _PickerFieldUI.useFieldTextFieldProps)({
        slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, _useTimeField.useTimeField)(textFieldProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickerFieldUI.PickerFieldUIContextProvider, {
        slots: slots,
        slotProps: slotProps,
        inputRef: other.inputRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickerFieldUI.PickerFieldUI, {
            fieldResponse: fieldResponse,
            defaultOpenPickerIcon: _icons.ClockIcon
        })
    });
});

},{"c2dab68818d51907":"9snJq","9536c41beda65754":"5RcSx","97930dcda125e3e0":"jeIdK","fe895ecc81ee629":"9njXz","bddbb6c4ec680701":"bnNSm","afd23d26cb87b1fc":"c9RfU","478c2af47e08cd5f":"fAbhl","b3ff67792ec30c0c":"33JZi","d5d7c79ce50d8399":"lO9ia","51dbcec5bd31ab5a":"ezFd3","ead36feb042a63d7":"1dlk8"}],"33JZi":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTimeField = void 0;
var _useField = require("90c5dcf4ecdf6225");
var _managers = require("3760c3daa58ecbb8");
const useTimeField = (props)=>{
    const manager = (0, _managers.useTimeManager)(props);
    return (0, _useField.useField)({
        manager,
        props
    });
};
exports.useTimeField = useTimeField;

},{"90c5dcf4ecdf6225":"igDrb","3760c3daa58ecbb8":"bvF8R"}],"igDrb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "createDateStrForV6InputFromSections", {
    enumerable: true,
    get: function() {
        return _useField2.createDateStrForV6InputFromSections;
    }
});
Object.defineProperty(exports, "createDateStrForV7HiddenInputFromSections", {
    enumerable: true,
    get: function() {
        return _useField2.createDateStrForV7HiddenInputFromSections;
    }
});
Object.defineProperty(exports, "useField", {
    enumerable: true,
    get: function() {
        return _useField.useField;
    }
});
Object.defineProperty(exports, "useFieldInternalPropsWithDefaults", {
    enumerable: true,
    get: function() {
        return _useFieldInternalPropsWithDefaults.useFieldInternalPropsWithDefaults;
    }
});
var _useField = require("eb10032c0c7f7615");
var _useField2 = require("333c4c740ef86a58");
var _useFieldInternalPropsWithDefaults = require("104b9e80a14be05c");

},{"eb10032c0c7f7615":"9pnAF","333c4c740ef86a58":"4JxIG","104b9e80a14be05c":"6iq2U"}],"9pnAF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useField = void 0;
var _useFieldV7TextField = require("bcf869339b522847");
var _useFieldV6TextField = require("ba03a1049ca6843c");
var _useNullableFieldPrivateContext = require("4cae3758a4193120");
const useField = (parameters)=>{
    const fieldPrivateContext = (0, _useNullableFieldPrivateContext.useNullableFieldPrivateContext)();
    const enableAccessibleFieldDOMStructure = parameters.props.enableAccessibleFieldDOMStructure ?? fieldPrivateContext?.enableAccessibleFieldDOMStructure ?? true;
    const useFieldTextField = enableAccessibleFieldDOMStructure ? _useFieldV7TextField.useFieldV7TextField : _useFieldV6TextField.useFieldV6TextField;
    return useFieldTextField(parameters);
};
exports.useField = useField;

},{"bcf869339b522847":"4hawo","ba03a1049ca6843c":"ctAY3","4cae3758a4193120":"5PhrV"}],"4hawo":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("e0028cfa7d3f0dd0").default;
var _interopRequireDefault = require("910d29797dbe7962").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldV7TextField = void 0;
var _extends2 = _interopRequireDefault(require("628b6675a65fe1ad"));
var React = _interopRequireWildcard(require("e133618bca46dff2"));
var _useForkRef = _interopRequireDefault(require("1965d4095501aa60"));
var _useEventCallback = _interopRequireDefault(require("336c950e369d7836"));
var _useEnhancedEffect = _interopRequireDefault(require("43d45640a95f2690"));
var _useField = require("510d864aafee68e9");
var _utils = require("c490fbeb1f5a9b70");
var _hooks = require("cb2f4c60cd7ffc74");
var _useFieldCharacterEditing = require("b790afe10e951043");
var _useFieldState = require("69776d781d8f1971");
var _useFieldInternalPropsWithDefaults = require("dbea06066b38f4a9");
var _syncSelectionToDOM = require("1dbd2cfd53bb9b01");
var _useFieldRootProps = require("a8a036802d017017");
var _useFieldHiddenInputProps = require("49fc99fe752e0dd4");
var _useFieldSectionContainerProps = require("c610cf2a7e0261e");
var _useFieldSectionContentProps = require("75fb910b642d5552");
const useFieldV7TextField = (parameters)=>{
    const { props, manager, skipContextFieldRefAssignment, manager: { valueType, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps, forwardedProps } = (0, _hooks.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, _useFieldInternalPropsWithDefaults.useFieldInternalPropsWithDefaults)({
        manager,
        internalProps,
        skipContextFieldRefAssignment
    });
    const { sectionListRef: sectionListRefProp, onBlur, onClick, onFocus, onInput, onPaste, onKeyDown, onClear, clearable } = forwardedProps;
    const { disabled = false, readOnly = false, autoFocus = false, focused: focusedProp, unstableFieldRef } = internalPropsWithDefaults;
    const sectionListRef = React.useRef(null);
    const handleSectionListRef = (0, _useForkRef.default)(sectionListRefProp, sectionListRef);
    const domGetters = React.useMemo(()=>({
            isReady: ()=>sectionListRef.current != null,
            getRoot: ()=>sectionListRef.current.getRoot(),
            getSectionContainer: (sectionIndex)=>sectionListRef.current.getSectionContainer(sectionIndex),
            getSectionContent: (sectionIndex)=>sectionListRef.current.getSectionContent(sectionIndex),
            getSectionIndexFromDOMElement: (element)=>sectionListRef.current.getSectionIndexFromDOMElement(element)
        }), [
        sectionListRef
    ]);
    const stateResponse = (0, _useFieldState.useFieldState)({
        manager,
        internalPropsWithDefaults,
        forwardedProps
    });
    const { // States and derived states
    areAllSectionsEmpty, error, parsedSelectedSections, sectionOrder, state, value, // Methods to update the states
    clearValue, setSelectedSections } = stateResponse;
    const applyCharacterEditing = (0, _useFieldCharacterEditing.useFieldCharacterEditing)({
        stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const [focused, setFocused] = React.useState(false);
    function focusField(newSelectedSections = 0) {
        if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
        getActiveSectionIndex(sectionListRef) != null) return;
        const newParsedSelectedSections = (0, _useField.parseSelectedSections)(newSelectedSections, state.sections);
        setFocused(true);
        sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    }
    const rootProps = (0, _useFieldRootProps.useFieldRootProps)({
        manager,
        internalPropsWithDefaults,
        stateResponse,
        applyCharacterEditing,
        focused,
        setFocused,
        domGetters
    });
    const hiddenInputProps = (0, _useFieldHiddenInputProps.useFieldHiddenInputProps)({
        manager,
        stateResponse
    });
    const createSectionContainerProps = (0, _useFieldSectionContainerProps.useFieldSectionContainerProps)({
        stateResponse,
        internalPropsWithDefaults
    });
    const createSectionContentProps = (0, _useFieldSectionContentProps.useFieldSectionContentProps)({
        manager,
        stateResponse,
        applyCharacterEditing,
        internalPropsWithDefaults,
        domGetters,
        focused
    });
    const handleRootKeyDown = (0, _useEventCallback.default)((event)=>{
        onKeyDown?.(event);
        rootProps.onKeyDown(event);
    });
    const handleRootBlur = (0, _useEventCallback.default)((event)=>{
        onBlur?.(event);
        rootProps.onBlur(event);
    });
    const handleRootFocus = (0, _useEventCallback.default)((event)=>{
        onFocus?.(event);
        rootProps.onFocus(event);
    });
    const handleRootClick = (0, _useEventCallback.default)((event)=>{
        // The click event on the clear or open button would propagate to the input, trigger this handler and result in an inadvertent section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a propagated call, which should be skipped.
        if (event.isDefaultPrevented()) return;
        onClick?.(event);
        rootProps.onClick(event);
    });
    const handleRootPaste = (0, _useEventCallback.default)((event)=>{
        onPaste?.(event);
        rootProps.onPaste(event);
    });
    const handleRootInput = (0, _useEventCallback.default)((event)=>{
        onInput?.(event);
        rootProps.onInput(event);
    });
    const handleClear = (0, _useEventCallback.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!isFieldFocused(sectionListRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const elements = React.useMemo(()=>{
        return state.sections.map((section, sectionIndex)=>{
            const content = createSectionContentProps(section, sectionIndex);
            return {
                container: createSectionContainerProps(sectionIndex),
                content: createSectionContentProps(section, sectionIndex),
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator,
                    'data-range-position': section.isEndFormatSeparator ? content['data-range-position'] : undefined
                }
            };
        });
    }, [
        state.sections,
        createSectionContainerProps,
        createSectionContentProps
    ]);
    React.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:',
            '',
            '<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && !disabled && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, _useEnhancedEffect.default)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    (0, _useEnhancedEffect.default)(()=>{
        (0, _syncSelectionToDOM.syncSelectionToDOM)({
            focused,
            domGetters,
            stateResponse
        });
    });
    React.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>getActiveSectionIndex(sectionListRef),
            setSelectedSections: (newSelectedSections)=>{
                if (disabled || !sectionListRef.current) return;
                const newParsedSelectedSections = (0, _useField.parseSelectedSections)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            focusField,
            isFieldFocused: ()=>isFieldFocused(sectionListRef)
        }));
    return (0, _extends2.default)({}, forwardedProps, rootProps, {
        onBlur: handleRootBlur,
        onClick: handleRootClick,
        onFocus: handleRootFocus,
        onInput: handleRootInput,
        onPaste: handleRootPaste,
        onKeyDown: handleRootKeyDown,
        onClear: handleClear
    }, hiddenInputProps, {
        error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        focused: focusedProp ?? focused,
        sectionListRef: handleSectionListRef,
        // Additional
        enableAccessibleFieldDOMStructure: true,
        elements,
        areAllSectionsEmpty,
        disabled,
        readOnly,
        autoFocus,
        openPickerAriaLabel
    });
};
exports.useFieldV7TextField = useFieldV7TextField;
function getActiveSectionIndex(sectionListRef) {
    const activeElement = (0, _utils.getActiveElement)(sectionListRef.current?.getRoot());
    if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
    return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
}
function isFieldFocused(sectionListRef) {
    const activeElement = (0, _utils.getActiveElement)(sectionListRef.current?.getRoot());
    return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
}

},{"e0028cfa7d3f0dd0":"5RcSx","910d29797dbe7962":"9snJq","628b6675a65fe1ad":"h7ttl","e133618bca46dff2":"9njXz","1965d4095501aa60":"93645","336c950e369d7836":"lkrdI","43d45640a95f2690":"foonr","510d864aafee68e9":"4JxIG","c490fbeb1f5a9b70":"aj7pj","cb2f4c60cd7ffc74":"6MTP2","b790afe10e951043":"828md","69776d781d8f1971":"jaQXA","dbea06066b38f4a9":"6iq2U","1dbd2cfd53bb9b01":"aCTUM","a8a036802d017017":"blNFr","49fc99fe752e0dd4":"hf3um","c610cf2a7e0261e":"NwONa","75fb910b642d5552":"1W5Ae"}],"93645":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("87ce1ee3216c63bd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useForkRef.default;
    }
});
var _useForkRef = _interopRequireDefault(require("79dcb0e326aadf93"));

},{"87ce1ee3216c63bd":"9snJq","79dcb0e326aadf93":"iWcLM"}],"iWcLM":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("3b1cb7ff27618332").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useForkRef;
var React = _interopRequireWildcard(require("27e77f6b1e18ba7f"));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function useForkRef(...refs) {
    const cleanupRef = React.useRef(undefined);
    const refEffect = React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

},{"3b1cb7ff27618332":"5RcSx","27e77f6b1e18ba7f":"9njXz"}],"lkrdI":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("807dd85780d45471").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useEventCallback.default;
    }
});
var _useEventCallback = _interopRequireDefault(require("70ce5df20f252e12"));

},{"807dd85780d45471":"9snJq","70ce5df20f252e12":"dfZdC"}],"dfZdC":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("161b5556e577dcf8").default;
var _interopRequireWildcard = require("b7d8777d976b289b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("a513a2a8a7e8bda"));
var _useEnhancedEffect = _interopRequireDefault(require("cedf9c2b45883cdb"));
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function useEventCallback(fn) {
    const ref = React.useRef(fn);
    (0, _useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var _default = exports.default = useEventCallback;

},{"161b5556e577dcf8":"9snJq","b7d8777d976b289b":"5RcSx","a513a2a8a7e8bda":"9njXz","cedf9c2b45883cdb":"foonr"}],"foonr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7291ec2d82bafd69").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useEnhancedEffect.default;
    }
});
var _useEnhancedEffect = _interopRequireDefault(require("a179b339351d329"));

},{"7291ec2d82bafd69":"9snJq","a179b339351d329":"7bsXb"}],"7bsXb":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("1bc773b7c4250075").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("78dddf6ef3ade582"));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var _default = exports.default = useEnhancedEffect;

},{"1bc773b7c4250075":"5RcSx","78dddf6ef3ade582":"9njXz"}],"aj7pj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8dc4ec42e6cd64da").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_DESKTOP_MODE_MEDIA_QUERY = void 0;
exports.arrayIncludes = arrayIncludes;
exports.getFocusedListItemIndex = exports.getActiveElement = exports.executeInTheNextEventLoopTick = void 0;
exports.mergeSx = mergeSx;
exports.onSpaceOrEnter = void 0;
var _ownerDocument = _interopRequireDefault(require("d042186cbc67f169"));
/* Use it instead of .includes method for IE support */ function arrayIncludes(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const onSpaceOrEnter = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
exports.onSpaceOrEnter = onSpaceOrEnter;
const executeInTheNextEventLoopTick = (fn)=>{
    setTimeout(fn, 0);
};
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
exports.executeInTheNextEventLoopTick = executeInTheNextEventLoopTick;
const getActiveElementInternal = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return getActiveElementInternal(activeEl.shadowRoot);
    return activeEl;
};
/**
 * Gets the currently active element within a given node's document.
 * This function traverses shadow DOM if necessary.
 * @param node - The node from which to get the active element.
 * @returns The currently active element, or null if none is found.
 */ const getActiveElement = (node)=>{
    return getActiveElementInternal((0, _ownerDocument.default)(node));
};
/**
 * Gets the index of the focused list item in a given ul list element.
 *
 * @param {HTMLUListElement} listElement - The list element to search within.
 * @returns {number} The index of the focused list item, or -1 if none is focused.
 */ exports.getActiveElement = getActiveElement;
const getFocusedListItemIndex = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf(getActiveElement(listElement));
};
exports.getFocusedListItemIndex = getFocusedListItemIndex;
const DEFAULT_DESKTOP_MODE_MEDIA_QUERY = exports.DEFAULT_DESKTOP_MODE_MEDIA_QUERY = '@media (pointer: fine)';
function mergeSx(...sxProps) {
    return sxProps.reduce((acc, sxProp)=>{
        if (Array.isArray(sxProp)) acc.push(...sxProp);
        else if (sxProp != null) acc.push(sxProp);
        return acc;
    }, []);
}

},{"8dc4ec42e6cd64da":"9snJq","d042186cbc67f169":"c6JQt"}],"c6JQt":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c9b22c8bc756930f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ownerDocument.default;
    }
});
var _ownerDocument = _interopRequireDefault(require("a411753a15f04199"));

},{"c9b22c8bc756930f":"9snJq","a411753a15f04199":"cZmTI"}],"cZmTI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
    return node && node.ownerDocument || document;
}

},{}],"6MTP2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsValidValue", {
    enumerable: true,
    get: function() {
        return _useIsValidValue.useIsValidValue;
    }
});
Object.defineProperty(exports, "useParsedFormat", {
    enumerable: true,
    get: function() {
        return _useParsedFormat.useParsedFormat;
    }
});
Object.defineProperty(exports, "usePickerActionsContext", {
    enumerable: true,
    get: function() {
        return _usePickerActionsContext.usePickerActionsContext;
    }
});
Object.defineProperty(exports, "usePickerAdapter", {
    enumerable: true,
    get: function() {
        return _usePickerAdapter.usePickerAdapter;
    }
});
Object.defineProperty(exports, "usePickerContext", {
    enumerable: true,
    get: function() {
        return _usePickerContext.usePickerContext;
    }
});
Object.defineProperty(exports, "usePickerTranslations", {
    enumerable: true,
    get: function() {
        return _usePickerTranslations.usePickerTranslations;
    }
});
Object.defineProperty(exports, "useSplitFieldProps", {
    enumerable: true,
    get: function() {
        return _useSplitFieldProps.useSplitFieldProps;
    }
});
var _usePickerTranslations = require("6d49ea2e602961a3");
var _useSplitFieldProps = require("6306939acbf7733b");
var _useParsedFormat = require("dd9d63591999206e");
var _usePickerContext = require("9082295fb5703e8f");
var _usePickerActionsContext = require("9527cc3e53335797");
var _useIsValidValue = require("b112b9b8f53f017a");
var _usePickerAdapter = require("853ac1b060851561");

},{"6d49ea2e602961a3":"5FUwu","6306939acbf7733b":"aOpAn","dd9d63591999206e":"ba41l","9082295fb5703e8f":"5ATdR","9527cc3e53335797":"8Likw","b112b9b8f53f017a":"4ogn8","853ac1b060851561":"hE9K5"}],"5FUwu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickerTranslations = void 0;
var _usePickerAdapter = require("61c000b41e3e1b50");
const usePickerTranslations = ()=>(0, _usePickerAdapter.useLocalizationContext)().localeText;
exports.usePickerTranslations = usePickerTranslations;

},{"61c000b41e3e1b50":"hE9K5"}],"hE9K5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("284c7fe4d4559393").default;
var _interopRequireDefault = require("23458f05830ed37b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickerAdapter = exports.useLocalizationContext = void 0;
var _extends2 = _interopRequireDefault(require("53d87b467b67cdc5"));
var React = _interopRequireWildcard(require("f921ab652b2663a"));
var _enUS = require("9b1c33f7994650ec");
var _LocalizationProvider = require("9882df3b455d544b");
const useLocalizationContext = ()=>{
    const localization = React.useContext(_LocalizationProvider.PickerAdapterContext);
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.adapter === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = React.useMemo(()=>(0, _extends2.default)({}, _enUS.DEFAULT_LOCALE, localization.localeText), [
        localization.localeText
    ]);
    return React.useMemo(()=>(0, _extends2.default)({}, localization, {
            localeText
        }), [
        localization,
        localeText
    ]);
};
exports.useLocalizationContext = useLocalizationContext;
const usePickerAdapter = ()=>useLocalizationContext().adapter;
exports.usePickerAdapter = usePickerAdapter;

},{"284c7fe4d4559393":"5RcSx","23458f05830ed37b":"9snJq","53d87b467b67cdc5":"h7ttl","f921ab652b2663a":"9njXz","9b1c33f7994650ec":"2XmoD","9882df3b455d544b":"4xBEv"}],"2XmoD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.enUS = exports.DEFAULT_LOCALE = void 0;
var _getPickersLocalization = require("cf255ccbefaea078");
// This object is not Partial<PickersLocaleText> because it is the default values
const enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    nextStepButtonLabel: 'Next',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    timeRangePickerToolbarTitle: 'Select time range',
    // Clock labels
    clockLabelText: (view, formattedTime)=>`Select ${view}. ${!formattedTime ? 'No time selected' : `Selected time is ${formattedTime}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open Picker labels
    openDatePickerDialogue: (formattedDate)=>formattedDate ? `Choose date, selected date is ${formattedDate}` : 'Choose date',
    openTimePickerDialogue: (formattedTime)=>formattedTime ? `Choose time, selected time is ${formattedTime}` : 'Choose time',
    openRangePickerDialogue: (formattedRange)=>formattedRange ? `Choose range, selected range is ${formattedRange}` : 'Choose range',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const DEFAULT_LOCALE = exports.DEFAULT_LOCALE = enUSPickers;
const enUS = exports.enUS = (0, _getPickersLocalization.getPickersLocalization)(enUSPickers);

},{"cf255ccbefaea078":"4FeHs"}],"4FeHs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("20d2f78d8d21c2a2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersLocalization = void 0;
var _extends2 = _interopRequireDefault(require("d391c1a4cb05c5b7"));
const getPickersLocalization = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, _extends2.default)({}, pickersTranslations)
                }
            }
        }
    };
};
exports.getPickersLocalization = getPickersLocalization;

},{"20d2f78d8d21c2a2":"9snJq","d391c1a4cb05c5b7":"h7ttl"}],"aOpAn":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("ba447d53cdba8089").default;
var _interopRequireDefault = require("43eb08aa9a0a5cff").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useSplitFieldProps = void 0;
var _extends2 = _interopRequireDefault(require("5ba46ed1bcfedb4f"));
var React = _interopRequireWildcard(require("f432de4b4057e485"));
var _extractValidationProps = require("817e1934c23809bc");
const SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'unstableStartFieldRef',
    'unstableEndFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator',
    'autoFocus',
    'focused'
];
/**
 * Split the props received by the field component into:
 * - `internalProps` which are used by the various hooks called by the field component.
 * - `forwardedProps` which are passed to the underlying component.
 * Note that some forwarded props might be used by the hooks as well.
 * For instance, hooks like `useDateField` need props like `onKeyDown` to merge the default event handler and the one provided by the application.
 * @template TProps, TValueType
 * @param {TProps} props The props received by the field component.
 * @param {TValueType} valueType The type of the field value ('date', 'time', or 'date-time').
 */ const useSplitFieldProps = (props, valueType)=>{
    return React.useMemo(()=>{
        const forwardedProps = (0, _extends2.default)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') _extractValidationProps.DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
        else if (valueType === 'time') _extractValidationProps.TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
        else if (valueType === 'date-time') {
            _extractValidationProps.DATE_VALIDATION_PROP_NAMES.forEach(extractProp);
            _extractValidationProps.TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
            _extractValidationProps.DATE_TIME_VALIDATION_PROP_NAMES.forEach(extractProp);
        }
        return {
            forwardedProps,
            internalProps
        };
    }, [
        props,
        valueType
    ]);
};
/**
 * Extract the internal props from the props received by the field component.
 * This makes sure that the internal props not defined in the props are not present in the result.
 */ exports.useSplitFieldProps = useSplitFieldProps;

},{"ba447d53cdba8089":"5RcSx","43eb08aa9a0a5cff":"9snJq","5ba46ed1bcfedb4f":"h7ttl","f432de4b4057e485":"9njXz","817e1934c23809bc":"aFqW2"}],"aFqW2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.extractValidationProps = exports.TIME_VALIDATION_PROP_NAMES = exports.DATE_VALIDATION_PROP_NAMES = exports.DATE_TIME_VALIDATION_PROP_NAMES = void 0;
const DATE_VALIDATION_PROP_NAMES = exports.DATE_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const TIME_VALIDATION_PROP_NAMES = exports.TIME_VALIDATION_PROP_NAMES = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const DATE_TIME_VALIDATION_PROP_NAMES = exports.DATE_TIME_VALIDATION_PROP_NAMES = [
    'minDateTime',
    'maxDateTime'
];
const VALIDATION_PROP_NAMES = [
    ...DATE_VALIDATION_PROP_NAMES,
    ...TIME_VALIDATION_PROP_NAMES,
    ...DATE_TIME_VALIDATION_PROP_NAMES
];
/**
 * Extract the validation props for the props received by a component.
 * Limit the risk of forgetting some of them and reduce the bundle size.
 */ const extractValidationProps = (props)=>VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});
exports.extractValidationProps = extractValidationProps;

},{}],"ba41l":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("526412316798e4e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useParsedFormat = void 0;
var React = _interopRequireWildcard(require("fa19667205501d7"));
var _RtlProvider = require("4b34b9f424dd1f29");
var _usePickerAdapter = require("211b224e0ba4888b");
var _buildSectionsFromFormat = require("47e024a81db8c06b");
var _useField = require("cbed74a7cc5d0cbe");
var _usePickerTranslations = require("dda901b8880bf66a");
var _useNullablePickerContext = require("2da8abc67d6a839c");
/**
 * Returns the parsed format to be rendered in the field when there is no value or in other parts of the Picker.
 * This format is localized (for example `AAAA` for the year with the French locale) and cannot be parsed by your date library.
 * @param {object} The parameters needed to build the placeholder.
 * @param {string} params.format Format to parse.
 * @returns
 */ const useParsedFormat = (parameters = {})=>{
    const pickerContext = (0, _useNullablePickerContext.useNullablePickerContext)();
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const translations = (0, _usePickerTranslations.usePickerTranslations)();
    const localizedDigits = React.useMemo(()=>(0, _useField.getLocalizedDigits)(adapter), [
        adapter
    ]);
    const { format = pickerContext?.fieldFormat ?? adapter.formats.fullDate } = parameters;
    return React.useMemo(()=>{
        const sections = (0, _buildSectionsFromFormat.buildSectionsFromFormat)({
            adapter,
            format,
            formatDensity: 'dense',
            isRtl,
            shouldRespectLeadingZeros: true,
            localeText: translations,
            localizedDigits,
            date: null,
            // TODO v9: Make sure we still don't reverse in `buildSectionsFromFormat` when using `useParsedFormat`.
            enableAccessibleFieldDOMStructure: false
        });
        return sections.map((section)=>`${section.startSeparator}${section.placeholder}${section.endSeparator}`).join('');
    }, [
        adapter,
        isRtl,
        translations,
        localizedDigits,
        format
    ]);
};
exports.useParsedFormat = useParsedFormat;

},{"526412316798e4e6":"5RcSx","fa19667205501d7":"9njXz","4b34b9f424dd1f29":"ck9Pb","211b224e0ba4888b":"hE9K5","47e024a81db8c06b":"5HmuB","cbed74a7cc5d0cbe":"4JxIG","dda901b8880bf66a":"5FUwu","2da8abc67d6a839c":"eId1l"}],"ck9Pb":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("75271e7f0a9be8b8").default;
var _interopRequireWildcard = require("8be47b4a0ee19137").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useRtl = exports.default = void 0;
var React = _interopRequireWildcard(require("9c011c2e93eae9d7"));
var _propTypes = _interopRequireDefault(require("1cdad4212e0b63a6"));
var _jsxRuntime = require("35bc5316f55d23ce");
const RtlContext = /*#__PURE__*/ React.createContext();
function RtlProvider({ value, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const useRtl = ()=>{
    const value = React.useContext(RtlContext);
    return value ?? false;
};
exports.useRtl = useRtl;
var _default = exports.default = RtlProvider;

},{"75271e7f0a9be8b8":"74mZ8","8be47b4a0ee19137":"jIxH8","9c011c2e93eae9d7":"9njXz","1cdad4212e0b63a6":"bnNSm","35bc5316f55d23ce":"1dlk8"}],"74mZ8":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"jIxH8":[function(require,module,exports,__globalThis) {
var _typeof = require("d4c00abd355a2cc0")["default"];
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d4c00abd355a2cc0":"haGML"}],"haGML":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"5HmuB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6199ab690040551e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildSectionsFromFormat = void 0;
var _extends2 = _interopRequireDefault(require("d5dd6e8e294dd64a"));
var _useField = require("5588e651b7f55b9");
const expandFormat = ({ adapter, format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = adapter.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = adapter.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.');
    }
    return nextFormat;
};
const getEscapedPartsFromFormat = ({ adapter, expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = adapter.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const getSectionPlaceholder = (adapter, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: adapter.formatByString(adapter.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const createSection = ({ adapter, date, shouldRespectLeadingZeros, localeText, localizedDigits, now, token, startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, _useField.getDateSectionConfigFromFormatToken)(adapter, token);
    const hasLeadingZerosInFormat = (0, _useField.doesSectionFormatHaveLeadingZeros)(adapter, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = adapter.isValid(date);
    let sectionValue = isValidDate ? adapter.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? adapter.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxLength' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, _useField.applyLocalizedDigits)((0, _useField.cleanLeadingZeros)((0, _useField.removeLocalizedDigits)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, _extends2.default)({}, sectionConfig, {
        format: token,
        maxLength,
        value: sectionValue,
        placeholder: getSectionPlaceholder(adapter, localeText, sectionConfig, token),
        hasLeadingZerosInFormat,
        hasLeadingZerosInInput,
        startSeparator,
        endSeparator: '',
        modified: false
    });
};
const buildSections = (parameters)=>{
    const { adapter, expandedFormat, escapedParts } = parameters;
    const now = adapter.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(adapter.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push(createSection((0, _extends2.default)({}, parameters, {
                    now,
                    token: firstWord,
                    startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else {
                    sections[sections.length - 1].endSeparator += char;
                    sections[sections.length - 1].isEndFormatSeparator = true;
                }
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const postProcessSections = ({ isRtl, formatDensity, sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const buildSectionsFromFormat = (parameters)=>{
    let expandedFormat = expandFormat(parameters);
    if (parameters.isRtl && parameters.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = getEscapedPartsFromFormat((0, _extends2.default)({}, parameters, {
        expandedFormat
    }));
    const sections = buildSections((0, _extends2.default)({}, parameters, {
        expandedFormat,
        escapedParts
    }));
    return postProcessSections((0, _extends2.default)({}, parameters, {
        sections
    }));
};
exports.buildSectionsFromFormat = buildSectionsFromFormat;

},{"6199ab690040551e":"9snJq","d5dd6e8e294dd64a":"h7ttl","5588e651b7f55b9":"4JxIG"}],"eId1l":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("d15ccfa750f603cd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useNullablePickerContext = void 0;
var React = _interopRequireWildcard(require("2e8feaf61701df22"));
var _usePickerContext = require("cbd0a7b4faebf7e5");
/**
 * Returns the context passed by the Picker wrapping the current component.
 * If the context is not found, returns `null`.
 */ const useNullablePickerContext = ()=>React.useContext(_usePickerContext.PickerContext);
exports.useNullablePickerContext = useNullablePickerContext;

},{"d15ccfa750f603cd":"5RcSx","2e8feaf61701df22":"9njXz","cbd0a7b4faebf7e5":"5ATdR"}],"5ATdR":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("22f96ec424557980").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickerContext = exports.PickerContext = void 0;
var React = _interopRequireWildcard(require("2654102b4fe4d578"));
const PickerContext = exports.PickerContext = /*#__PURE__*/ React.createContext(null);
const usePickerContext = ()=>{
    const value = React.useContext(PickerContext);
    if (value == null) throw new Error('MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component');
    return value;
};
exports.usePickerContext = usePickerContext;

},{"22f96ec424557980":"5RcSx","2654102b4fe4d578":"9njXz"}],"8Likw":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("c323cbf3ac3f6c67").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickerActionsContext = void 0;
var React = _interopRequireWildcard(require("4a848ff47a4ef749"));
var _PickerProvider = require("cf275c8f4aa56561");
/**
 * Returns a subset of the context passed by the Picker wrapping the current component.
 * It only contains the actions and never causes a re-render of the component using it.
 */ const usePickerActionsContext = ()=>{
    const value = React.useContext(_PickerProvider.PickerActionsContext);
    if (value == null) throw new Error([
        'MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component'
    ].join('\n'));
    return value;
};
exports.usePickerActionsContext = usePickerActionsContext;

},{"c323cbf3ac3f6c67":"5RcSx","4a848ff47a4ef749":"9njXz","cf275c8f4aa56561":"i6in8"}],"i6in8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("6562ae21f5249b15").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickerPrivateContext = exports.PickerActionsContext = void 0;
exports.PickerProvider = PickerProvider;
var React = _interopRequireWildcard(require("d8c23f0eef81d720"));
var _LocalizationProvider = require("5df231d6092f326d");
var _useIsValidValue = require("dd8a69a87609a80a");
var _useNullableFieldPrivateContext = require("b038a1527bc60753");
var _usePickerContext = require("828a574da9852a10");
var _jsxRuntime = require("2231e692bfeed6e5");
const PickerActionsContext = exports.PickerActionsContext = /*#__PURE__*/ React.createContext(null);
const PickerPrivateContext = exports.PickerPrivateContext = /*#__PURE__*/ React.createContext({
    ownerState: {
        isPickerDisabled: false,
        isPickerReadOnly: false,
        isPickerValueEmpty: false,
        isPickerOpen: false,
        pickerVariant: 'desktop',
        pickerOrientation: 'portrait'
    },
    rootRefObject: {
        current: null
    },
    labelId: undefined,
    dismissViews: ()=>{},
    hasUIView: true,
    getCurrentViewMode: ()=>'UI',
    triggerElement: null,
    viewContainerRole: null,
    defaultActionBarActions: [],
    onPopperExited: undefined
});
function PickerProvider(props) {
    const { contextValue, actionsContextValue, privateContextValue, fieldPrivateContextValue, isValidContextValue, localeText, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_usePickerContext.PickerContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerActionsContext.Provider, {
            value: actionsContextValue,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerPrivateContext.Provider, {
                value: privateContextValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_useNullableFieldPrivateContext.PickerFieldPrivateContext.Provider, {
                    value: fieldPrivateContextValue,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_useIsValidValue.IsValidValueContext.Provider, {
                        value: isValidContextValue,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_LocalizationProvider.LocalizationProvider, {
                            localeText: localeText,
                            children: children
                        })
                    })
                })
            })
        })
    });
}

},{"6562ae21f5249b15":"5RcSx","d8c23f0eef81d720":"9njXz","5df231d6092f326d":"liXbF","dd8a69a87609a80a":"4ogn8","b038a1527bc60753":"5PhrV","828a574da9852a10":"5ATdR","2231e692bfeed6e5":"1dlk8"}],"4ogn8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("29e0745faf9c4278").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IsValidValueContext = void 0;
exports.useIsValidValue = useIsValidValue;
var React = _interopRequireWildcard(require("2430f05ff32c10f5"));
const IsValidValueContext = exports.IsValidValueContext = /*#__PURE__*/ React.createContext(()=>true);
function useIsValidValue() {
    return React.useContext(IsValidValueContext);
}

},{"29e0745faf9c4278":"5RcSx","2430f05ff32c10f5":"9njXz"}],"5PhrV":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("1e66c6cf376c6e41").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickerFieldPrivateContext = void 0;
exports.useNullableFieldPrivateContext = useNullableFieldPrivateContext;
var React = _interopRequireWildcard(require("adc053a89fed5835"));
const PickerFieldPrivateContext = exports.PickerFieldPrivateContext = /*#__PURE__*/ React.createContext(null);
function useNullableFieldPrivateContext() {
    return React.useContext(PickerFieldPrivateContext);
}

},{"1e66c6cf376c6e41":"5RcSx","adc053a89fed5835":"9njXz"}],"828md":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("17deddd7ac85d0fc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldCharacterEditing = void 0;
var _extends2 = _interopRequireDefault(require("70bfac734b385a80"));
var _useEventCallback = _interopRequireDefault(require("bff283d31dcab0b8"));
var _useField = require("9534ef054f3e10b2");
var _usePickerAdapter = require("79ba199d89728269");
const isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
/**
 * Update the active section value when the user pressed a key that is not a navigation key (arrow key for example).
 * This hook has two main editing behaviors
 *
 * 1. The numeric editing when the user presses a digit
 * 2. The letter editing when the user presses another key
 */ const useFieldCharacterEditing = ({ stateResponse: { // States and derived states
localizedDigits, sectionsValueBoundaries, state, timezone, // Methods to update the states
setCharacterQuery, setTempAndroidValueStr, updateSectionValue } })=>{
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const applyQuery = ({ keyPressed, sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = state.sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!isQueryResponseWithoutValue(queryResponse)) {
                setCharacterQuery({
                    sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if (isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            setCharacterQuery(null);
            return null;
        }
        setCharacterQuery({
            sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if (isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, _useField.getLetterEditingOptions)(adapter, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, _useField.getDateSectionConfigFromFormatToken)(adapter, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if (isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, _extends2.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, _useField.changeSectionValueFormat)(adapter, fallbackValue, adapter.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = ({ queryValue, skipIfBelowMinimum, section })=>{
            const cleanQueryValue = (0, _useField.removeLocalizedDigits)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, _useField.cleanDigitSectionValue)(adapter, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue({
                queryValue,
                skipIfBelowMinimum: false,
                section: activeSection
            });
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, _useField.doesSectionFormatHaveLeadingZeros)(adapter, 'digit', 'month', 'MM');
                const response = getNewSectionValue({
                    queryValue,
                    skipIfBelowMinimum: true,
                    section: {
                        type: activeSection.type,
                        format: 'MM',
                        hasLeadingZerosInFormat,
                        hasLeadingZerosInInput: true,
                        contentType: 'digit',
                        maxLength: 2
                    }
                });
                if (isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, _useField.changeSectionValueFormat)(adapter, response.sectionValue, 'MM', activeSection.format);
                return (0, _extends2.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue({
                    queryValue,
                    skipIfBelowMinimum: true,
                    section: activeSection
                });
                if (isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, _useField.getDaysInWeekStr)(adapter, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, _extends2.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, _useField.isStringNumber)(queryValue, localizedDigits));
    };
    return (0, _useEventCallback.default)((params)=>{
        const section = state.sections[params.sectionIndex];
        const isNumericEditing = (0, _useField.isStringNumber)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, _extends2.default)({}, params, {
            keyPressed: (0, _useField.applyLocalizedDigits)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            section,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
};
/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ exports.useFieldCharacterEditing = useFieldCharacterEditing;

},{"17deddd7ac85d0fc":"9snJq","70bfac734b385a80":"h7ttl","bff283d31dcab0b8":"lkrdI","9534ef054f3e10b2":"4JxIG","79ba199d89728269":"hE9K5"}],"jaQXA":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("ec4212697a7ca08b").default;
var _interopRequireDefault = require("c239a3a4ced3ab98").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldState = void 0;
var _extends2 = _interopRequireDefault(require("7b957c452a3f396"));
var React = _interopRequireWildcard(require("b4b0ee5a48ff2dd0"));
var _useControlled = _interopRequireDefault(require("1802d1cb491d5366"));
var _useTimeout = _interopRequireDefault(require("e65eec16477bfa15"));
var _useEventCallback = _interopRequireDefault(require("e5ef2ae4a3013de5"));
var _RtlProvider = require("7338f395b4f626c7");
var _hooks = require("1710437d21a14972");
var _useField = require("87536a4226055602");
var _buildSectionsFromFormat = require("4078cbaf79d0d79c");
var _validation = require("39a30f295ab6e80e");
var _useControlledValue = require("7a2f873767145f61");
var _getDefaultReferenceDate = require("c40158dfb2a91197");
const QUERY_LIFE_DURATION_MS = 5000;
const useFieldState = (parameters)=>{
    const adapter = (0, _hooks.usePickerAdapter)();
    const translations = (0, _hooks.usePickerTranslations)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const { manager: { validator, valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults, internalPropsWithDefaults: { value: valueProp, defaultValue, referenceDate: referenceDateProp, onChange, format, formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange, shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure = true }, forwardedProps: { error: errorProp } } = parameters;
    const { value, handleValueChange, timezone } = (0, _useControlledValue.useControlledValue)({
        name: 'a field component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager
    });
    const valueRef = React.useRef(value);
    React.useEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    const { hasValidationError } = (0, _validation.useValidation)({
        props: internalPropsWithDefaults,
        validator,
        timezone,
        value,
        onError: internalPropsWithDefaults.onError
    });
    const error = React.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (errorProp !== undefined) return errorProp;
        return hasValidationError;
    }, [
        hasValidationError,
        errorProp
    ]);
    const localizedDigits = React.useMemo(()=>(0, _useField.getLocalizedDigits)(adapter), [
        adapter
    ]);
    const sectionsValueBoundaries = React.useMemo(()=>(0, _useField.getSectionsBoundaries)(adapter, localizedDigits, timezone), [
        adapter,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = React.useCallback((valueToAnalyze)=>fieldValueManager.getSectionsFromValue(valueToAnalyze, (date)=>(0, _buildSectionsFromFormat.buildSectionsFromFormat)({
                adapter,
                localeText: translations,
                localizedDigits,
                format,
                date,
                formatDensity,
                shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure,
                isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        adapter,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = React.useState(()=>{
        const sections = getSectionsFromValue(value);
        (0, _useField.validateSections)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections,
            lastExternalValue: value,
            lastSectionsDependencies: {
                format,
                isRtl,
                locale: adapter.locale
            },
            tempValueStrAndroid: null,
            characterQuery: null
        };
        const granularity = (0, _getDefaultReferenceDate.getSectionTypeGranularity)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value,
            adapter,
            props: internalPropsWithDefaults,
            granularity,
            timezone
        });
        return (0, _extends2.default)({}, stateWithoutReferenceDate, {
            referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, _useControlled.default)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = React.useMemo(()=>(0, _useField.parseSelectedSections)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const sectionOrder = React.useMemo(()=>(0, _useField.getSectionOrder)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const areAllSectionsEmpty = React.useMemo(()=>state.sections.every((section)=>section.value === ''), [
        state.sections
    ]);
    const publishValue = (newValue)=>{
        const context = {
            validationError: validator({
                adapter,
                value: newValue,
                timezone,
                props: internalPropsWithDefaults
            })
        };
        handleValueChange(newValue, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, _extends2.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const sectionToUpdateOnNextInvalidDateRef = React.useRef(null);
    const updateSectionValueOnNextInvalidDateTimeout = (0, _useTimeout.default)();
    const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue)=>{
        if (activeSectionIndex == null) return;
        sectionToUpdateOnNextInvalidDateRef.current = {
            sectionIndex: activeSectionIndex,
            value: newSectionValue
        };
        updateSectionValueOnNextInvalidDateTimeout.start(0, ()=>{
            sectionToUpdateOnNextInvalidDateRef.current = null;
        });
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(adapter, value, valueManager.emptyValue)) setState((prevState)=>(0, _extends2.default)({}, prevState, {
                sections: prevState.sections.map((section)=>(0, _extends2.default)({}, section, {
                        value: ''
                    })),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, _extends2.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(valueManager.emptyValue);
        }
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        if (activeSection.value === '') return;
        setSectionUpdateToApplyOnNextInvalidDate('');
        if (fieldValueManager.getDateFromSection(value, activeSection) === null) setState((prevState)=>(0, _extends2.default)({}, prevState, {
                sections: setSectionValue(activeSectionIndex, ''),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, _extends2.default)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
        }
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = adapter.parse(dateStr, format);
            if (!adapter.isValid(date)) return null;
            const sections = (0, _buildSectionsFromFormat.buildSectionsFromFormat)({
                adapter,
                localeText: translations,
                localizedDigits,
                format,
                date,
                formatDensity,
                shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure,
                isRtl
            });
            return (0, _useField.mergeDateIntoReferenceDate)(adapter, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        publishValue(newValue);
    };
    const cleanActiveDateSectionsIfValueNullTimeout = (0, _useTimeout.default)();
    const updateSectionValue = ({ section, newSectionValue, shouldGoToNextSection })=>{
        updateSectionValueOnNextInvalidDateTimeout.clear();
        cleanActiveDateSectionsIfValueNullTimeout.clear();
        const activeDate = fieldValueManager.getDateFromSection(value, section);
        /**
     * Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * Try to build a valid date from the new section value
     */ const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
        const newActiveDate = (0, _useField.getDateFromDateSections)(adapter, newActiveDateSections, localizedDigits);
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (adapter.isValid(newActiveDate)) {
            const mergedDate = (0, _useField.mergeDateIntoReferenceDate)(adapter, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
            if (activeDate == null) cleanActiveDateSectionsIfValueNullTimeout.start(0, ()=>{
                if (valueRef.current === value) setState((prevState)=>(0, _extends2.default)({}, prevState, {
                        sections: fieldValueManager.clearDateSections(state.sections, section),
                        tempValueStrAndroid: null
                    }));
            });
            return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
        }
        /**
     * If all the sections are filled but the date is invalid and the previous date is valid or null,
     * Then we publish an invalid date.
     */ if (newActiveDateSections.every((sectionBis)=>sectionBis.value !== '') && (activeDate == null || adapter.isValid(activeDate))) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is not null,
     * Then we publish the date as `null`.
     */ if (activeDate != null) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, null));
        }
        /**
     * If the previous date is already null,
     * Then we don't publish the date and we update the sections.
     */ return setState((prevState)=>(0, _extends2.default)({}, prevState, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prevState)=>(0, _extends2.default)({}, prevState, {
                tempValueStrAndroid
            }));
    const setCharacterQuery = (0, _useEventCallback.default)((newCharacterQuery)=>{
        setState((prevState)=>(0, _extends2.default)({}, prevState, {
                characterQuery: newCharacterQuery
            }));
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) {
        const isActiveDateInvalid = sectionToUpdateOnNextInvalidDateRef.current != null && !adapter.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]));
        let sections;
        if (isActiveDateInvalid) sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
        else sections = getSectionsFromValue(value);
        setState((prevState)=>(0, _extends2.default)({}, prevState, {
                lastExternalValue: value,
                sections,
                sectionsDependencies: {
                    format,
                    isRtl,
                    locale: adapter.locale
                },
                referenceValue: isActiveDateInvalid ? prevState.referenceValue : fieldValueManager.updateReferenceValue(adapter, value, prevState.referenceValue),
                tempValueStrAndroid: null
            }));
    }
    if (isRtl !== state.lastSectionsDependencies.isRtl || format !== state.lastSectionsDependencies.format || adapter.locale !== state.lastSectionsDependencies.locale) {
        const sections = getSectionsFromValue(value);
        (0, _useField.validateSections)(sections, valueType);
        setState((prevState)=>(0, _extends2.default)({}, prevState, {
                lastSectionsDependencies: {
                    format,
                    isRtl,
                    locale: adapter.locale
                },
                sections,
                tempValueStrAndroid: null,
                characterQuery: null
            }));
    }
    if (state.characterQuery != null && !error && activeSectionIndex == null) setCharacterQuery(null);
    if (state.characterQuery != null && state.sections[state.characterQuery.sectionIndex]?.type !== state.characterQuery.sectionType) setCharacterQuery(null);
    React.useEffect(()=>{
        if (sectionToUpdateOnNextInvalidDateRef.current != null) sectionToUpdateOnNextInvalidDateRef.current = null;
    });
    const cleanCharacterQueryTimeout = (0, _useTimeout.default)();
    React.useEffect(()=>{
        if (state.characterQuery != null) cleanCharacterQueryTimeout.start(QUERY_LIFE_DURATION_MS, ()=>setCharacterQuery(null));
        return ()=>{};
    }, [
        state.characterQuery,
        setCharacterQuery,
        cleanCharacterQueryTimeout
    ]);
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    React.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) clearActiveSection();
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        // States and derived states
        activeSectionIndex,
        areAllSectionsEmpty,
        error,
        localizedDigits,
        parsedSelectedSections,
        sectionOrder,
        sectionsValueBoundaries,
        state,
        timezone,
        value,
        // Methods to update the states
        clearValue,
        clearActiveSection,
        setCharacterQuery,
        setSelectedSections,
        setTempAndroidValueStr,
        updateSectionValue,
        updateValueFromValueStr,
        // Utilities methods
        getSectionsFromValue
    };
};
exports.useFieldState = useFieldState;

},{"ec4212697a7ca08b":"5RcSx","c239a3a4ced3ab98":"9snJq","7b957c452a3f396":"h7ttl","b4b0ee5a48ff2dd0":"9njXz","1802d1cb491d5366":"aysZ8","e65eec16477bfa15":"8iyFq","e5ef2ae4a3013de5":"lkrdI","7338f395b4f626c7":"ck9Pb","1710437d21a14972":"6MTP2","87536a4226055602":"4JxIG","4078cbaf79d0d79c":"5HmuB","39a30f295ab6e80e":"2toSg","7a2f873767145f61":"gd9Iu","c40158dfb2a91197":"kOJTa"}],"aysZ8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("aad6dc0ecd239832").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useControlled.default;
    }
});
var _useControlled = _interopRequireWildcard(require("e7dba5da572d265a"));
Object.keys(_useControlled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useControlled[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useControlled[key];
        }
    });
});

},{"aad6dc0ecd239832":"5RcSx","e7dba5da572d265a":"4Uc64"}],"4Uc64":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
// TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- process.env never changes, dependency arrays are intentionally ignored
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ var _interopRequireWildcard = require("54f6d3c5d1389ae6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useControlled;
var React = _interopRequireWildcard(require("3be94f34b92d3c8a"));
function useControlled(props) {
    const { controlled, default: defaultProp, name, state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = React.useRef(controlled !== undefined);
    const [valueState, setValue] = React.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = React.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

},{"54f6d3c5d1389ae6":"5RcSx","3be94f34b92d3c8a":"9njXz"}],"8iyFq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ef290950929fa1d8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Timeout", {
    enumerable: true,
    get: function() {
        return _useTimeout.Timeout;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useTimeout.default;
    }
});
var _useTimeout = _interopRequireWildcard(require("eca648da40aeab33"));

},{"ef290950929fa1d8":"5RcSx","eca648da40aeab33":"9iQo8"}],"9iQo8":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("64f80ae6ecbf17f6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Timeout = void 0;
exports.default = useTimeout;
var _useLazyRef = _interopRequireDefault(require("a1f441dc5feb8ba1"));
var _useOnMount = _interopRequireDefault(require("7ce534a5869a6174"));
class Timeout {
    static create() {
        return new Timeout();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
exports.Timeout = Timeout;
function useTimeout() {
    const timeout = (0, _useLazyRef.default)(Timeout.create).current;
    (0, _useOnMount.default)(timeout.disposeEffect);
    return timeout;
}

},{"64f80ae6ecbf17f6":"9snJq","a1f441dc5feb8ba1":"1i7Hp","7ce534a5869a6174":"dZAM4"}],"1i7Hp":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("2034925142edef28").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useLazyRef;
var React = _interopRequireWildcard(require("b75847cb594970fd"));
const UNINITIALIZED = {};
/**
 * A React.useRef() that is initialized lazily with a function. Note that it accepts an optional
 * initialization argument, so the initialization function doesn't need to be an inline closure.
 *
 * @usage
 *   const ref = useLazyRef(sortColumns, columns)
 */ function useLazyRef(init, initArg) {
    const ref = React.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

},{"2034925142edef28":"5RcSx","b75847cb594970fd":"9njXz"}],"dZAM4":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("13da6806184f6838").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useOnMount;
var React = _interopRequireWildcard(require("cb4ed490c6ebbde9"));
const EMPTY = [];
/**
 * A React.useEffect equivalent that runs once, when the component is mounted.
 */ function useOnMount(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ React.useEffect(fn, EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

},{"13da6806184f6838":"5RcSx","cb4ed490c6ebbde9":"9njXz"}],"2toSg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "extractValidationProps", {
    enumerable: true,
    get: function() {
        return _extractValidationProps.extractValidationProps;
    }
});
Object.defineProperty(exports, "useValidation", {
    enumerable: true,
    get: function() {
        return _useValidation.useValidation;
    }
});
Object.defineProperty(exports, "validateDate", {
    enumerable: true,
    get: function() {
        return _validateDate.validateDate;
    }
});
Object.defineProperty(exports, "validateDateTime", {
    enumerable: true,
    get: function() {
        return _validateDateTime.validateDateTime;
    }
});
Object.defineProperty(exports, "validateTime", {
    enumerable: true,
    get: function() {
        return _validateTime.validateTime;
    }
});
var _validateDate = require("135a638de3c29048");
var _validateTime = require("b14708694b6c681f");
var _validateDateTime = require("e87595ac86d93cab");
var _extractValidationProps = require("4557773b24b7786e");
var _useValidation = require("69346bd2d8d4f53f");

},{"135a638de3c29048":"4V0kU","b14708694b6c681f":"gYGQM","e87595ac86d93cab":"gf5eQ","4557773b24b7786e":"aFqW2","69346bd2d8d4f53f":"iYoI0"}],"4V0kU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateDate = void 0;
var _valueManagers = require("5981fe37b432d542");
/**
 * Validation props used by the Date Picker, Date Field and Date Calendar components.
 */ /**
 * Validation props as received by the validateDate method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateDate method.
 */ const validateDate = ({ props, value, timezone, adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate, shouldDisableMonth, shouldDisableYear, disablePast, disableFuture, minDate, maxDate } = props;
    const now = adapter.date(undefined, timezone);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
exports.validateDate = validateDate;
validateDate.valueManager = _valueManagers.singleItemValueManager;

},{"5981fe37b432d542":"03AqV"}],"gYGQM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateTime = void 0;
var _timeUtils = require("5437dc9b6fe3907e");
var _valueManagers = require("8fbc24d92ffbcd82");
/**
 * Validation props used by the Time Picker, Time Field and Clock components.
 */ /**
 * Validation props as received by the validateTime method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateTime method.
 */ const validateTime = ({ adapter, value, timezone, props })=>{
    if (value === null) return null;
    const { minTime, maxTime, minutesStep, shouldDisableTime, disableIgnoringDatePartForTimeValidation = false, disablePast, disableFuture } = props;
    const now = adapter.date(undefined, timezone);
    const isAfter = (0, _timeUtils.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, value)):
            return 'minTime';
        case Boolean(maxTime && isAfter(value, maxTime)):
            return 'maxTime';
        case Boolean(disableFuture && adapter.isAfter(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBefore(value, now)):
            return 'disablePast';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(value, 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(minutesStep && adapter.getMinutes(value) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};
exports.validateTime = validateTime;
validateTime.valueManager = _valueManagers.singleItemValueManager;

},{"5437dc9b6fe3907e":"gSWbl","8fbc24d92ffbcd82":"03AqV"}],"gf5eQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateDateTime = void 0;
var _validateDate = require("2c170f10c288d781");
var _validateTime = require("8ee2094d12ff8846");
var _valueManagers = require("942d3bbb405da92");
/**
 * Validation props used by the Date Time Picker and Date Time Field components.
 */ /**
 * Validation props as received by the validateDateTime method.
 */ /**
 * Name of the props that should be defaulted before being passed to the validateDateTime method.
 */ const validateDateTime = ({ adapter, value, timezone, props })=>{
    const dateValidationResult = (0, _validateDate.validateDate)({
        adapter,
        value,
        timezone,
        props
    });
    if (dateValidationResult !== null) return dateValidationResult;
    return (0, _validateTime.validateTime)({
        adapter,
        value,
        timezone,
        props
    });
};
exports.validateDateTime = validateDateTime;
validateDateTime.valueManager = _valueManagers.singleItemValueManager;

},{"2c170f10c288d781":"4V0kU","8ee2094d12ff8846":"gYGQM","942d3bbb405da92":"03AqV"}],"iYoI0":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5ec02fd16304ca65").default;
var _interopRequireWildcard = require("3e38809444cb56a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useValidation = useValidation;
var React = _interopRequireWildcard(require("11b6b3d2774aa855"));
var _useEventCallback = _interopRequireDefault(require("5c7de66aeaa18739"));
var _hooks = require("447eb71fc038cfe2");
/**
 * Utility hook to check if a given value is valid based on the provided validation props.
 * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
 * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
 * @param {UseValidationOptions<TValue, TError, TValidationProps>} options The options to configure the hook.
 * @param {TValue} options.value The value to validate.
 * @param {PickersTimezone} options.timezone The timezone to use for the validation.
 * @param {Validator<TValue, TError, TValidationProps>} options.validator The validator function to use.
 * @param {TValidationProps} options.props The validation props, they differ depending on the component.
 * @param {(error: TError, value: TValue) => void} options.onError Callback fired when the error associated with the current value changes.
 */ function useValidation(options) {
    const { props, validator, value, timezone, onError } = options;
    const adapter = (0, _hooks.usePickerAdapter)();
    const previousValidationErrorRef = React.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter,
        value,
        timezone,
        props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    React.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, _useEventCallback.default)((newValue)=>{
        return validator({
            adapter,
            value: newValue,
            timezone,
            props
        });
    });
    return {
        validationError,
        hasValidationError,
        getValidationErrorForNewValue
    };
}

},{"5ec02fd16304ca65":"9snJq","3e38809444cb56a":"5RcSx","11b6b3d2774aa855":"9njXz","5c7de66aeaa18739":"lkrdI","447eb71fc038cfe2":"6MTP2"}],"gd9Iu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("324f8d2ed6a2ca04").default;
var _interopRequireWildcard = require("628d902004fefb6c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useControlledValue = void 0;
var React = _interopRequireWildcard(require("816c7ac73251a5f0"));
var _useEventCallback = _interopRequireDefault(require("a0c433ff7c962743"));
var _useControlled = _interopRequireDefault(require("23043186d6160da5"));
var _usePickerAdapter = require("9ff74226c2aea150");
/**
 * Hooks controlling the value while making sure that:
 * - The value returned by `onChange` always have the timezone of `props.value` or `props.defaultValue` if defined
 * - The value rendered is always the one from `props.timezone` if defined
 */ const useControlledValue = ({ name, timezone: timezoneProp, value: valueProp, defaultValue, referenceDate, onChange: onChangeProp, valueManager })=>{
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const [valueWithInputTimezone, setValue] = (0, _useControlled.default)({
        name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const inputTimezone = React.useMemo(()=>valueManager.getTimezone(adapter, valueWithInputTimezone), [
        adapter,
        valueManager,
        valueWithInputTimezone
    ]);
    const setInputTimezone = (0, _useEventCallback.default)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(adapter, inputTimezone, newValue);
    });
    const timezoneToRender = React.useMemo(()=>{
        if (timezoneProp) return timezoneProp;
        if (inputTimezone) return inputTimezone;
        if (referenceDate) return adapter.getTimezone(Array.isArray(referenceDate) ? referenceDate[0] : referenceDate);
        return 'default';
    }, [
        timezoneProp,
        inputTimezone,
        referenceDate,
        adapter
    ]);
    const valueWithTimezoneToRender = React.useMemo(()=>valueManager.setTimezone(adapter, timezoneToRender, valueWithInputTimezone), [
        valueManager,
        adapter,
        timezoneToRender,
        valueWithInputTimezone
    ]);
    const handleValueChange = (0, _useEventCallback.default)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        setValue(newValueWithInputTimezone);
        onChangeProp?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange,
        timezone: timezoneToRender
    };
};
exports.useControlledValue = useControlledValue;

},{"324f8d2ed6a2ca04":"9snJq","628d902004fefb6c":"5RcSx","816c7ac73251a5f0":"9njXz","a0c433ff7c962743":"lkrdI","23043186d6160da5":"aysZ8","9ff74226c2aea150":"hE9K5"}],"6iq2U":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("33240460065f081a").default;
var _interopRequireDefault = require("b69f09021e4358b1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldInternalPropsWithDefaults = useFieldInternalPropsWithDefaults;
var _extends2 = _interopRequireDefault(require("3ec227ddecafae0d"));
var React = _interopRequireWildcard(require("197f54198d88c2df"));
var _useForkRef = _interopRequireDefault(require("c69e7a90c08d022c"));
var _useNullablePickerContext = require("5db7a1b778a892f7");
var _useNullableFieldPrivateContext = require("d520f33e06299c3c");
/**
 * Applies the default values to the field internal props.
 * This is a temporary hook that will be removed during a follow up when `useField` will receive the internal props without the defaults.
 * It is only here to allow the migration to be done in smaller steps.
 */ function useFieldInternalPropsWithDefaults(parameters) {
    const { manager: { internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps }, internalProps, skipContextFieldRefAssignment } = parameters;
    const pickerContext = (0, _useNullablePickerContext.useNullablePickerContext)();
    const fieldPrivateContext = (0, _useNullableFieldPrivateContext.useNullableFieldPrivateContext)();
    const handleFieldRef = (0, _useForkRef.default)(internalProps.unstableFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext?.fieldRef);
    const setValue = pickerContext?.setValue;
    const handleChangeFromPicker = React.useCallback((newValue, ctx)=>{
        return setValue?.(newValue, {
            validationError: ctx.validationError,
            shouldClose: false
        });
    }, [
        setValue
    ]);
    const internalPropsWithDefaultsFromContext = React.useMemo(()=>{
        // If one of the context is null,
        // Then the field is used as a standalone component and the other context will be null as well.
        if (fieldPrivateContext != null && pickerContext != null) return (0, _extends2.default)({
            value: pickerContext.value,
            onChange: handleChangeFromPicker,
            timezone: pickerContext.timezone,
            disabled: pickerContext.disabled,
            readOnly: pickerContext.readOnly,
            autoFocus: pickerContext.autoFocus && !pickerContext.open,
            focused: pickerContext.open ? true : undefined,
            format: pickerContext.fieldFormat,
            formatDensity: fieldPrivateContext.formatDensity,
            enableAccessibleFieldDOMStructure: fieldPrivateContext.enableAccessibleFieldDOMStructure,
            selectedSections: fieldPrivateContext.selectedSections,
            onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
            unstableFieldRef: handleFieldRef
        }, internalProps);
        return internalProps;
    }, [
        pickerContext,
        fieldPrivateContext,
        internalProps,
        handleChangeFromPicker,
        handleFieldRef
    ]);
    return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}

},{"33240460065f081a":"5RcSx","b69f09021e4358b1":"9snJq","3ec227ddecafae0d":"h7ttl","197f54198d88c2df":"9njXz","c69e7a90c08d022c":"93645","5db7a1b778a892f7":"eId1l","d520f33e06299c3c":"5PhrV"}],"aCTUM":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("407952a158d660e4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.syncSelectionToDOM = syncSelectionToDOM;
var _ownerDocument = _interopRequireDefault(require("c4b8edecb6a746a5"));
var _utils = require("b8093bdaa986a36");
function syncSelectionToDOM(parameters) {
    const { focused, domGetters, stateResponse: { // States and derived states
    parsedSelectedSections, state } } = parameters;
    if (!domGetters.isReady()) return;
    const selection = (0, _ownerDocument.default)(domGetters.getRoot()).getSelection();
    if (!selection) return;
    if (parsedSelectedSections == null) {
        // If the selection contains an element inside the field, we reset it.
        if (selection.rangeCount > 0 && // Firefox can return a Restricted object here
        selection.getRangeAt(0).startContainer instanceof Node && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
        if (focused) domGetters.getRoot().blur();
        return;
    }
    // On multi input range pickers we want to update selection range only for the active input
    if (!domGetters.getRoot().contains((0, _utils.getActiveElement)(domGetters.getRoot()))) return;
    const range = new window.Range();
    let target;
    if (parsedSelectedSections === 'all') target = domGetters.getRoot();
    else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === 'empty') target = domGetters.getSectionContainer(parsedSelectedSections);
        else target = domGetters.getSectionContent(parsedSelectedSections);
    }
    range.selectNodeContents(target);
    target.focus();
    selection.removeAllRanges();
    selection.addRange(range);
}

},{"407952a158d660e4":"9snJq","c4b8edecb6a746a5":"c6JQt","b8093bdaa986a36":"aj7pj"}],"blNFr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cb395bc87d971aa7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldRootProps = useFieldRootProps;
var _useEventCallback = _interopRequireDefault(require("d72345792e8682f5"));
var _useTimeout = _interopRequireDefault(require("cbb6349b0124b45b"));
var _useFieldRootHandleKeyDown = require("d6c0e5b5ef59e87");
var _utils = require("69b84e4cb453f6a6");
var _syncSelectionToDOM = require("f8f2b5706201c780");
/**
 * Generate the props to pass to the root element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the root element of the field.
 */ function useFieldRootProps(parameters) {
    const { manager, focused, setFocused, domGetters, stateResponse, applyCharacterEditing, internalPropsWithDefaults, stateResponse: { // States and derived states
    parsedSelectedSections, sectionOrder, state, // Methods to update the states
    clearValue, setCharacterQuery, setSelectedSections, updateValueFromValueStr }, internalPropsWithDefaults: { disabled = false, readOnly = false } } = parameters;
    // TODO: Inline onContainerKeyDown once the old DOM structure is removed
    const handleKeyDown = (0, _useFieldRootHandleKeyDown.useFieldRootHandleKeyDown)({
        manager,
        internalPropsWithDefaults,
        stateResponse
    });
    const containerClickTimeout = (0, _useTimeout.default)();
    const handleClick = (0, _useEventCallback.default)((event)=>{
        if (disabled || !domGetters.isReady()) return;
        setFocused(true);
        if (parsedSelectedSections === 'all') containerClickTimeout.start(0, ()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = domGetters.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleInput = (0, _useEventCallback.default)((event)=>{
        if (!domGetters.isReady() || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        domGetters.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        (0, _syncSelectionToDOM.syncSelectionToDOM)({
            focused,
            domGetters,
            stateResponse
        });
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handlePaste = (0, _useEventCallback.default)((event)=>{
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleFocus = (0, _useEventCallback.default)(()=>{
        if (focused || disabled || !domGetters.isReady()) return;
        const activeElement = (0, _utils.getActiveElement)(domGetters.getRoot());
        setFocused(true);
        const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleBlur = (0, _useEventCallback.default)(()=>{
        setTimeout(()=>{
            if (!domGetters.isReady()) return;
            const activeElement = (0, _utils.getActiveElement)(domGetters.getRoot());
            const shouldBlur = !domGetters.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    return {
        // Event handlers
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        onPaste: handlePaste,
        onInput: handleInput,
        // Other
        contentEditable: parsedSelectedSections === 'all',
        tabIndex: parsedSelectedSections === 0 ? -1 : 0 // TODO: Try to set to undefined when there is a section selected.
    };
}

},{"cb395bc87d971aa7":"9snJq","d72345792e8682f5":"lkrdI","cbb6349b0124b45b":"8iyFq","d6c0e5b5ef59e87":"lMMcA","69b84e4cb453f6a6":"aj7pj","f8f2b5706201c780":"aCTUM"}],"lMMcA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a6d3f700d3cd01c1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldRootHandleKeyDown = useFieldRootHandleKeyDown;
var _useEventCallback = _interopRequireDefault(require("e5a6dc33b0bafbec"));
var _useField = require("195dbc82cf4ce9f1");
var _usePickerAdapter = require("731407eaac213600");
/**
 * Returns the `onKeyDown` handler to pass to the root element of the field.
 */ function useFieldRootHandleKeyDown(parameters) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const { manager: { internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: { minutesStep, disabled, readOnly }, stateResponse: { // States and derived states
    state, value, activeSectionIndex, parsedSelectedSections, sectionsValueBoundaries, localizedDigits, timezone, sectionOrder, // Methods to update the states
    clearValue, clearActiveSection, setSelectedSections, updateSectionValue } } = parameters;
    return (0, _useEventCallback.default)((event)=>{
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const newSectionValue = adjustSectionValue(adapter, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
                        minutesStep
                    });
                    updateSectionValue({
                        section: activeSection,
                        newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
}
function getDeltaFromKeyCode(keyCode) {
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
}
function adjustSectionValue(adapter, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
    const delta = getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>(0, _useField.cleanDigitSectionValue)(adapter, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return adapter.formatByString(adapter.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt((0, _useField.removeLocalizedDigits)(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = (0, _useField.getLetterEditingOptions)(adapter, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
}

},{"a6d3f700d3cd01c1":"9snJq","e5a6dc33b0bafbec":"lkrdI","195dbc82cf4ce9f1":"4JxIG","731407eaac213600":"hE9K5"}],"hf3um":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1565e87bf7c60453").default;
var _interopRequireWildcard = require("f4fa8ae98d268ab7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldHiddenInputProps = useFieldHiddenInputProps;
var React = _interopRequireWildcard(require("62d1d6414aaceb8e"));
var _useEventCallback = _interopRequireDefault(require("b1f70afb20d5c537"));
/**
 * Generate the props to pass to the hidden input element of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldHiddenInputPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldHiddenInputPropsReturnValue} The props to forward to the hidden input element of the field.
 */ function useFieldHiddenInputProps(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { // States and derived states
    areAllSectionsEmpty, state, // Methods to update the states
    updateValueFromValueStr } } = parameters;
    const handleChange = (0, _useEventCallback.default)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = React.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    return {
        value: valueStr,
        onChange: handleChange
    };
}

},{"1565e87bf7c60453":"9snJq","f4fa8ae98d268ab7":"5RcSx","62d1d6414aaceb8e":"9njXz","b1f70afb20d5c537":"lkrdI"}],"NwONa":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ab8f604f475c8955").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldSectionContainerProps = useFieldSectionContainerProps;
var React = _interopRequireWildcard(require("532722525f7a58d9"));
/**
 * Generate the props to pass to the container element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the container element of each section of the field.
 */ function useFieldSectionContainerProps(parameters) {
    const { stateResponse: { // Methods to update the states
    setSelectedSections }, internalPropsWithDefaults: { disabled = false } } = parameters;
    const createHandleClick = React.useCallback((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (disabled || event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return React.useCallback((sectionIndex)=>({
            'data-sectionindex': sectionIndex,
            onClick: createHandleClick(sectionIndex)
        }), [
        createHandleClick
    ]);
}

},{"ab8f604f475c8955":"5RcSx","532722525f7a58d9":"9njXz"}],"1W5Ae":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4dc2559cc39d6be8").default;
var _interopRequireWildcard = require("e79a5c8f6ea2e4c2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldSectionContentProps = useFieldSectionContentProps;
var React = _interopRequireWildcard(require("78bdde95bc52ef21"));
var _useEventCallback = _interopRequireDefault(require("b4d8225a1bd1d34f"));
var _hooks = require("3296cc9fd31802e2");
var _syncSelectionToDOM = require("d1ff6e1a7ed845b6");
/**
 * Generate the props to pass to the content element of each section of the field.
 * It is not used by the non-accessible DOM structure (with an <input /> element for editing).
 * It should be used in the MUI accessible DOM structure and the Base UI implementation.
 * @param {UseFieldRootPropsParameters} parameters The parameters of the hook.
 * @returns {UseFieldRootPropsReturnValue} The props to forward to the content element of each section of the field.
 */ function useFieldSectionContentProps(parameters) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const translations = (0, _hooks.usePickerTranslations)();
    const { focused, domGetters, stateResponse, applyCharacterEditing, manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { // States and derived states
    parsedSelectedSections, sectionsValueBoundaries, state, value, // Methods to update the states
    clearActiveSection, setCharacterQuery, setSelectedSections, updateSectionValue, updateValueFromValueStr }, internalPropsWithDefaults: { disabled = false, readOnly = false } } = parameters;
    const isContainerEditable = parsedSelectedSections === 'all';
    const isEditable = !isContainerEditable && !disabled && !readOnly;
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, _useEventCallback.default)((sectionIndex)=>{
        if (!domGetters.isReady()) return;
        const section = state.sections[sectionIndex];
        domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        (0, _syncSelectionToDOM.syncSelectionToDOM)({
            focused,
            domGetters,
            stateResponse
        });
    });
    const handleInput = (0, _useEventCallback.default)((event)=>{
        if (!domGetters.isReady()) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            revertDOMSectionChange(sectionIndex);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed,
            sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    const handleMouseUp = (0, _useEventCallback.default)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handlePaste = (0, _useEventCallback.default)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            setCharacterQuery(null);
            updateSectionValue({
                section: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            setCharacterQuery(null);
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleDragOver = (0, _useEventCallback.default)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const createFocusHandler = React.useCallback((sectionIndex)=>()=>{
            if (disabled) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return React.useCallback((section, sectionIndex)=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: fieldValueManager.getDateFromSection(value, section),
            contentType: section.contentType,
            format: section.format
        });
        return {
            // Event handlers
            onInput: handleInput,
            onPaste: handlePaste,
            onMouseUp: handleMouseUp,
            onDragOver: handleDragOver,
            onFocus: createFocusHandler(sectionIndex),
            // Aria attributes
            'aria-readonly': readOnly,
            'aria-valuenow': getSectionValueNow(section, adapter),
            'aria-valuemin': sectionBoundaries.minimum,
            'aria-valuemax': sectionBoundaries.maximum,
            'aria-valuetext': section.value ? getSectionValueText(section, adapter) : translations.empty,
            'aria-label': translations[section.type],
            'aria-disabled': disabled,
            // Other
            tabIndex: isContainerEditable || sectionIndex > 0 ? -1 : 0,
            contentEditable: !isContainerEditable && !disabled && !readOnly,
            role: 'spinbutton',
            'data-range-position': section.dateName || undefined,
            spellCheck: isEditable ? false : undefined,
            autoCapitalize: isEditable ? 'off' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            children: section.value || section.placeholder,
            inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
        };
    }, [
        sectionsValueBoundaries,
        isContainerEditable,
        disabled,
        readOnly,
        isEditable,
        translations,
        adapter,
        handleInput,
        handlePaste,
        handleMouseUp,
        handleDragOver,
        createFocusHandler,
        fieldValueManager,
        value
    ]);
}
function getSectionValueText(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') {
                    const dateWithMonth = adapter.setMonth(adapter.date(), Number(section.value) - 1);
                    return adapter.isValid(dateWithMonth) ? adapter.format(dateWithMonth, 'month') : '';
                }
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate && adapter.isValid(parsedDate) ? adapter.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            if (section.contentType === 'digit') {
                const dateWithDay = adapter.setDate(adapter.startOfYear(adapter.date()), Number(section.value));
                return adapter.isValid(dateWithDay) ? adapter.format(dateWithDay, 'dayOfMonthFull') : '';
            }
            return section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
}
function getSectionValueNow(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = adapter.parse(`01:00 ${section.value}`, `${adapter.formats.hours12h}:${adapter.formats.minutes} ${section.format}`);
                if (parsedDate) return adapter.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate ? adapter.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
}

},{"4dc2559cc39d6be8":"9snJq","e79a5c8f6ea2e4c2":"5RcSx","78bdde95bc52ef21":"9njXz","b4d8225a1bd1d34f":"lkrdI","3296cc9fd31802e2":"6MTP2","d1ff6e1a7ed845b6":"aCTUM"}],"ctAY3":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("c3e08b2a3025a03c").default;
var _interopRequireDefault = require("24f423dbb08f4e99").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldV6TextField = exports.addPositionPropertiesToSections = void 0;
var _extends2 = _interopRequireDefault(require("1eccdd5e6f4f1d71"));
var React = _interopRequireWildcard(require("f1a7a0b39c0aa532"));
var _RtlProvider = require("1de8a6d8034ce43d");
var _useEnhancedEffect = _interopRequireDefault(require("c6dbf7670113c7b1"));
var _useEventCallback = _interopRequireDefault(require("37e548f7d9ecb41f"));
var _useTimeout = _interopRequireDefault(require("f28fddb1c9c194f2"));
var _useForkRef = _interopRequireDefault(require("72377e91fca72cf8"));
var _hooks = require("e2bc4b75fbd7e76c");
var _utils = require("1ef900d10778411e");
var _useField = require("1975c31a1c278fff");
var _useFieldCharacterEditing = require("cec93821ff2335a3");
var _useFieldRootHandleKeyDown = require("917cf82c4aa0ed72");
var _useFieldState = require("988c6485b4fec38e");
var _useFieldInternalPropsWithDefaults = require("9075216422b740f1");
const cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const addPositionPropertiesToSections = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, _useField.getSectionVisibleValue)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, _extends2.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput,
            endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
exports.addPositionPropertiesToSections = addPositionPropertiesToSections;
const useFieldV6TextField = (parameters)=>{
    const isRtl = (0, _RtlProvider.useRtl)();
    const focusTimeout = (0, _useTimeout.default)();
    const selectionSyncTimeout = (0, _useTimeout.default)();
    const { props, manager, skipContextFieldRefAssignment, manager: { valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps, forwardedProps } = (0, _hooks.useSplitFieldProps)(props, valueType);
    const internalPropsWithDefaults = (0, _useFieldInternalPropsWithDefaults.useFieldInternalPropsWithDefaults)({
        manager,
        internalProps,
        skipContextFieldRefAssignment
    });
    const { onFocus, onClick, onPaste, onBlur, onKeyDown, onClear, clearable, inputRef: inputRefProp, placeholder: inPlaceholder } = forwardedProps;
    const { readOnly = false, disabled = false, autoFocus = false, focused, unstableFieldRef } = internalPropsWithDefaults;
    const inputRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(inputRefProp, inputRef);
    const stateResponse = (0, _useFieldState.useFieldState)({
        manager,
        internalPropsWithDefaults,
        forwardedProps
    });
    const { // States and derived states
    activeSectionIndex, areAllSectionsEmpty, error, localizedDigits, parsedSelectedSections, sectionOrder, state, value, // Methods to update the states
    clearValue, clearActiveSection, setCharacterQuery, setSelectedSections, setTempAndroidValueStr, updateSectionValue, updateValueFromValueStr, // Utilities methods
    getSectionsFromValue } = stateResponse;
    const applyCharacterEditing = (0, _useFieldCharacterEditing.useFieldCharacterEditing)({
        stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const sections = React.useMemo(()=>addPositionPropertiesToSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    function syncSelectionFromDOM() {
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    }
    function focusField(newSelectedSection = 0) {
        if ((0, _utils.getActiveElement)(inputRef.current) === inputRef.current) return;
        inputRef.current?.focus();
        setSelectedSections(newSelectedSection);
    }
    const handleInputFocus = (0, _useEventCallback.default)((event)=>{
        onFocus?.(event);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        focusTimeout.start(0, ()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, _useEventCallback.default)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, _useEventCallback.default)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                setCharacterQuery(null);
                updateSectionValue({
                    section: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, _useEventCallback.default)((event)=>{
        onBlur?.(event);
        setSelectedSections(null);
    });
    const handleInputChange = (0, _useEventCallback.default)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, _useField.isAndroid)()) setTempAndroidValueStr(valueStr);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const handleClear = (0, _useEventCallback.default)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!isFieldFocused(inputRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerKeyDown = (0, _useFieldRootHandleKeyDown.useFieldRootHandleKeyDown)({
        manager,
        internalPropsWithDefaults,
        stateResponse
    });
    const wrappedHandleContainerKeyDown = (0, _useEventCallback.default)((event)=>{
        onKeyDown?.(event);
        handleContainerKeyDown(event);
    });
    const placeholder = React.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = React.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    React.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, _utils.getActiveElement)(inputRef.current)) setSelectedSections('all');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, _useEnhancedEffect.default)(()=>{
        function syncSelectionToDOM() {
            if (!inputRef.current) return;
            if (parsedSelectedSections == null) {
                if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                // setting selection range to 0 causes issues in Safari.
                // https://bugs.webkit.org/show_bug.cgi?id=224425
                inputRef.current.scrollLeft = 0;
                return;
            }
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current !== (0, _utils.getActiveElement)(inputRef.current)) return;
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            if (parsedSelectedSections === 'all') inputRef.current.select();
            else {
                const selectedSection = sections[parsedSelectedSections];
                const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                    if (inputRef.current === (0, _utils.getActiveElement)(inputRef.current)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                }
                selectionSyncTimeout.start(0, ()=>{
                    // handle case when the selection is not updated correctly
                    // could happen on Android
                    if (inputRef.current && inputRef.current === (0, _utils.getActiveElement)(inputRef.current) && // The section might loose all selection, where `selectionStart === selectionEnd`
                    // https://github.com/mui/mui-x/pull/13652
                    inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) syncSelectionToDOM();
                });
            }
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
        syncSelectionToDOM();
    });
    const inputMode = React.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, _utils.getActiveElement)(inputRef.current);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    React.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            focusField,
            isFieldFocused: ()=>isFieldFocused(inputRef)
        }));
    return (0, _extends2.default)({}, forwardedProps, {
        error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        onBlur: handleContainerBlur,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onPaste: handleInputPaste,
        onKeyDown: wrappedHandleContainerKeyDown,
        onClear: handleClear,
        inputRef: handleRef,
        // Additional
        enableAccessibleFieldDOMStructure: false,
        placeholder,
        inputMode,
        autoComplete: 'off',
        value: shouldShowPlaceholder ? '' : valueStr,
        onChange: handleInputChange,
        focused,
        disabled,
        readOnly,
        autoFocus,
        openPickerAriaLabel
    });
};
exports.useFieldV6TextField = useFieldV6TextField;
function isFieldFocused(inputRef) {
    return inputRef.current === (0, _utils.getActiveElement)(inputRef.current);
}

},{"c3e08b2a3025a03c":"5RcSx","24f423dbb08f4e99":"9snJq","1eccdd5e6f4f1d71":"h7ttl","f1a7a0b39c0aa532":"9njXz","1de8a6d8034ce43d":"ck9Pb","c6dbf7670113c7b1":"foonr","37e548f7d9ecb41f":"lkrdI","f28fddb1c9c194f2":"8iyFq","72377e91fca72cf8":"93645","e2bc4b75fbd7e76c":"6MTP2","1ef900d10778411e":"aj7pj","1975c31a1c278fff":"4JxIG","cec93821ff2335a3":"828md","917cf82c4aa0ed72":"lMMcA","988c6485b4fec38e":"jaQXA","9075216422b740f1":"6iq2U"}],"bvF8R":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDateManager", {
    enumerable: true,
    get: function() {
        return _useDateManager.useDateManager;
    }
});
Object.defineProperty(exports, "useDateTimeManager", {
    enumerable: true,
    get: function() {
        return _useDateTimeManager.useDateTimeManager;
    }
});
Object.defineProperty(exports, "useTimeManager", {
    enumerable: true,
    get: function() {
        return _useTimeManager.useTimeManager;
    }
});
var _useDateManager = require("8b9260ebfbd0c695");
var _useTimeManager = require("c9fe516e34d28da9");
var _useDateTimeManager = require("d4ba21fe255a0f6e");

},{"8b9260ebfbd0c695":"5P0Cn","c9fe516e34d28da9":"6iAu1","d4ba21fe255a0f6e":"1aFeD"}],"5P0Cn":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("81da135e16a074e2").default;
var _interopRequireDefault = require("a584703d658b134e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useApplyDefaultValuesToDateValidationProps = useApplyDefaultValuesToDateValidationProps;
exports.useDateManager = useDateManager;
var _extends2 = _interopRequireDefault(require("bfe73b5559be35b2"));
var React = _interopRequireWildcard(require("25b23113d780c79d"));
var _dateUtils = require("f53c2a70441cd6");
var _valueManagers = require("73bf4c1350287543");
var _validation = require("f3bddf5639a9647f");
var _useUtils = require("33261e0eb471470a");
var _hooks = require("1acbae0c5fd54ae5");
function useDateManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure = true } = parameters;
    return React.useMemo(()=>({
            valueType: 'date',
            validator: _validation.validateDate,
            internal_valueManager: _valueManagers.singleItemValueManager,
            internal_fieldValueManager: _valueManagers.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToDateFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const translations = (0, _hooks.usePickerTranslations)();
    return React.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const validationProps = useApplyDefaultValuesToDateValidationProps(internalProps);
    return React.useMemo(()=>(0, _extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? adapter.formats.keyboardDate
        }), [
        internalProps,
        validationProps,
        adapter
    ]);
}
function useApplyDefaultValuesToDateValidationProps(props) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const defaultDates = (0, _useUtils.useDefaultDates)();
    return React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            minDate: (0, _dateUtils.applyDefaultDate)(adapter, props.minDate, defaultDates.minDate),
            maxDate: (0, _dateUtils.applyDefaultDate)(adapter, props.maxDate, defaultDates.maxDate)
        }), [
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}

},{"81da135e16a074e2":"5RcSx","a584703d658b134e":"9snJq","bfe73b5559be35b2":"h7ttl","25b23113d780c79d":"9njXz","f53c2a70441cd6":"jwfEA","73bf4c1350287543":"03AqV","f3bddf5639a9647f":"2toSg","33261e0eb471470a":"j0icU","1acbae0c5fd54ae5":"6MTP2"}],"j0icU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("2ec40f734e422c8c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useNow = exports.useDefaultDates = void 0;
var React = _interopRequireWildcard(require("191e4ca74a9e9597"));
var _usePickerAdapter = require("4f377bee16878a17");
const useDefaultDates = ()=>(0, _usePickerAdapter.useLocalizationContext)().defaultDates;
exports.useDefaultDates = useDefaultDates;
const useNow = (timezone)=>{
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const now = React.useRef(undefined);
    if (now.current === undefined) now.current = adapter.date(undefined, timezone);
    return now.current;
};
exports.useNow = useNow;

},{"2ec40f734e422c8c":"5RcSx","191e4ca74a9e9597":"9njXz","4f377bee16878a17":"hE9K5"}],"6iAu1":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("f8f0d89228d01e7f").default;
var _interopRequireDefault = require("6d2c9b867d88ea5b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useApplyDefaultValuesToTimeValidationProps = useApplyDefaultValuesToTimeValidationProps;
exports.useTimeManager = useTimeManager;
var _extends2 = _interopRequireDefault(require("63e96f161507df65"));
var React = _interopRequireWildcard(require("99c99a8e9dec1bdd"));
var _valueManagers = require("9c479f6ee3bb35da");
var _validation = require("15887054ffd10b5f");
var _hooks = require("13ff1cd01403bbf5");
function useTimeManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure = true, ampm } = parameters;
    return React.useMemo(()=>({
            valueType: 'time',
            validator: _validation.validateTime,
            internal_valueManager: _valueManagers.singleItemValueManager,
            internal_fieldValueManager: _valueManagers.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: createUseOpenPickerButtonAriaLabel(ampm)
        }), [
        ampm,
        enableAccessibleFieldDOMStructure
    ]);
}
function createUseOpenPickerButtonAriaLabel(ampm) {
    return function useOpenPickerButtonAriaLabel(value) {
        const adapter = (0, _hooks.usePickerAdapter)();
        const translations = (0, _hooks.usePickerTranslations)();
        return React.useMemo(()=>{
            const formatKey = ampm ?? adapter.is12HourCycleInCurrentLocale() ? 'fullTime12h' : 'fullTime24h';
            const formattedValue = adapter.isValid(value) ? adapter.format(value, formatKey) : null;
            return translations.openTimePickerDialogue(formattedValue);
        }, [
            value,
            translations,
            adapter
        ]);
    };
}
function useApplyDefaultValuesToTimeFieldInternalProps(internalProps) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const validationProps = useApplyDefaultValuesToTimeValidationProps(internalProps);
    const ampm = React.useMemo(()=>internalProps.ampm ?? adapter.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        adapter
    ]);
    return React.useMemo(()=>(0, _extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? adapter.formats.fullTime12h : adapter.formats.fullTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        adapter
    ]);
}
function useApplyDefaultValuesToTimeValidationProps(props) {
    return React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false
        }), [
        props.disablePast,
        props.disableFuture
    ]);
}

},{"f8f0d89228d01e7f":"5RcSx","6d2c9b867d88ea5b":"9snJq","63e96f161507df65":"h7ttl","99c99a8e9dec1bdd":"9njXz","9c479f6ee3bb35da":"03AqV","15887054ffd10b5f":"2toSg","13ff1cd01403bbf5":"6MTP2"}],"1aFeD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("ef92b2e72118a922").default;
var _interopRequireDefault = require("b66ae450deb2d8bf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useApplyDefaultValuesToDateTimeValidationProps = useApplyDefaultValuesToDateTimeValidationProps;
exports.useDateTimeManager = useDateTimeManager;
var _extends2 = _interopRequireDefault(require("3eff973c7fd52eaa"));
var React = _interopRequireWildcard(require("aa5f5beb543f54c2"));
var _dateUtils = require("4aeaa1c77fd922c0");
var _valueManagers = require("3bac1e2a78a28bc9");
var _validation = require("96a4e25bd696b7d6");
var _useUtils = require("167409423319d652");
var _hooks = require("85f24910a8d3cf5c");
function useDateTimeManager(parameters = {}) {
    const { enableAccessibleFieldDOMStructure = true } = parameters;
    return React.useMemo(()=>({
            valueType: 'date-time',
            validator: _validation.validateDateTime,
            internal_valueManager: _valueManagers.singleItemValueManager,
            internal_fieldValueManager: _valueManagers.singleItemFieldValueManager,
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToDateTimeFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const translations = (0, _hooks.usePickerTranslations)();
    return React.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function useApplyDefaultValuesToDateTimeFieldInternalProps(internalProps) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const validationProps = useApplyDefaultValuesToDateTimeValidationProps(internalProps);
    const ampm = React.useMemo(()=>internalProps.ampm ?? adapter.is12HourCycleInCurrentLocale(), [
        internalProps.ampm,
        adapter
    ]);
    return React.useMemo(()=>(0, _extends2.default)({}, internalProps, validationProps, {
            format: internalProps.format ?? (ampm ? adapter.formats.keyboardDateTime12h : adapter.formats.keyboardDateTime24h)
        }), [
        internalProps,
        validationProps,
        ampm,
        adapter
    ]);
}
function useApplyDefaultValuesToDateTimeValidationProps(props) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const defaultDates = (0, _useUtils.useDefaultDates)();
    return React.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            // TODO: Explore if we can remove it from the public API
            disableIgnoringDatePartForTimeValidation: !!props.minDateTime || !!props.maxDateTime || !!props.disableFuture || !!props.disablePast,
            minDate: (0, _dateUtils.applyDefaultDate)(adapter, props.minDateTime ?? props.minDate, defaultDates.minDate),
            maxDate: (0, _dateUtils.applyDefaultDate)(adapter, props.maxDateTime ?? props.maxDate, defaultDates.maxDate),
            minTime: props.minDateTime ?? props.minTime,
            maxTime: props.maxDateTime ?? props.maxTime
        }), [
        props.minDateTime,
        props.maxDateTime,
        props.minTime,
        props.maxTime,
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}

},{"ef92b2e72118a922":"5RcSx","b66ae450deb2d8bf":"9snJq","3eff973c7fd52eaa":"h7ttl","aa5f5beb543f54c2":"9njXz","4aeaa1c77fd922c0":"jwfEA","3bac1e2a78a28bc9":"03AqV","96a4e25bd696b7d6":"2toSg","167409423319d652":"j0icU","85f24910a8d3cf5c":"6MTP2"}],"lO9ia":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e2445c533c01fe52").default;
var _interopRequireWildcard = require("5cc588e72054ee6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickerFieldUI = PickerFieldUI;
exports.PickerFieldUIContext = void 0;
exports.PickerFieldUIContextProvider = PickerFieldUIContextProvider;
exports.cleanFieldResponse = void 0;
exports.mergeSlotProps = mergeSlotProps;
exports.useFieldTextFieldProps = useFieldTextFieldProps;
var _extends2 = _interopRequireDefault(require("fa40706ab84ae8a7"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("87aa5b0d8404c5ea"));
var React = _interopRequireWildcard(require("6ae5312ece71e5ca"));
var _useEventCallback = _interopRequireDefault(require("4eaf05929214b92"));
var _useForkRef = _interopRequireDefault(require("d5231e653e89368b"));
var _resolveComponentProps = _interopRequireDefault(require("a3415eadad9d3747"));
var _TextField = _interopRequireDefault(require("cbfbddfc216342d1"));
var _IconButton = _interopRequireDefault(require("48a0b4ee778bbfda"));
var _InputAdornment = _interopRequireDefault(require("c5c2e7561c8d56c7"));
var _version = require("39a50d677be29267");
var _useSlotProps5 = _interopRequireDefault(require("e1dbfc8944aa5458"));
var _useFieldOwnerState = require("a7b2ecc3d0f74277");
var _hooks = require("4626ce8d7e2f0f39");
var _icons = require("1bd2984147f17770");
var _useNullablePickerContext = require("3db54b3b5e67affa");
var _PickersTextField = require("69d2eb3f25954bcd");
var _jsxRuntime = require("4345d7fcef917e5a");
const _excluded = [
    "enableAccessibleFieldDOMStructure"
], _excluded2 = [
    "InputProps",
    "readOnly",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], _excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], _excluded4 = [
    "ownerState"
], _excluded5 = [
    "ownerState"
], _excluded6 = [
    "ownerState"
], _excluded7 = [
    "ownerState"
], _excluded8 = [
    "InputProps",
    "inputProps"
];
const noop = ()=>{};
const cleanFieldResponse = (_ref)=>{
    let { enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps, readOnly, onClear, clearable, clearButtonPosition, openPickerButtonPosition, openPickerAriaLabel } = fieldResponse, other = (0, _objectWithoutPropertiesLoose2.default)(fieldResponse, _excluded2);
        const mergedInputProps = _version.major >= 6 && other?.slotProps?.input ? mergeSlotProps(other?.slotProps?.input, InputProps) : noop;
        return {
            clearable,
            onClear,
            clearButtonPosition,
            openPickerButtonPosition,
            openPickerAriaLabel,
            textFieldProps: (0, _extends2.default)({}, other, _version.major >= 6 && other?.slotProps?.input ? {
                slotProps: (0, _extends2.default)({}, other?.slotProps, {
                    input: (ownerState)=>(0, _extends2.default)({}, (0, _resolveComponentProps.default)(mergedInputProps, ownerState), {
                            readOnly
                        })
                })
            } : {
                InputProps: (0, _extends2.default)({}, InputProps ?? {}, {
                    readOnly
                })
            })
        };
    }
    const { onPaste, onKeyDown, inputMode, readOnly, InputProps, inputProps, inputRef, onClear, clearable, clearButtonPosition, openPickerButtonPosition, openPickerAriaLabel } = fieldResponse, other = (0, _objectWithoutPropertiesLoose2.default)(fieldResponse, _excluded3);
    const mergedInputProps = _version.major >= 6 && other?.slotProps?.input ? mergeSlotProps(other?.slotProps?.input, InputProps) : noop;
    const mergedHtmlInputProps = _version.major >= 6 && other?.slotProps?.htmlInput ? mergeSlotProps(other?.slotProps?.htmlInput, inputProps) : noop;
    return {
        clearable,
        onClear,
        clearButtonPosition,
        openPickerButtonPosition,
        openPickerAriaLabel,
        textFieldProps: (0, _extends2.default)({}, other, _version.major >= 6 && (other?.slotProps?.input || other?.slotProps?.htmlInput) ? {
            slotProps: (0, _extends2.default)({}, other?.slotProps, {
                input: (ownerState)=>(0, _extends2.default)({}, (0, _resolveComponentProps.default)(mergedInputProps, ownerState), {
                        readOnly
                    }),
                htmlInput: (ownerState)=>(0, _extends2.default)({}, (0, _resolveComponentProps.default)(mergedHtmlInputProps, ownerState), {
                        inputMode,
                        onPaste,
                        onKeyDown,
                        ref: inputRef
                    })
            })
        } : {
            InputProps: (0, _extends2.default)({}, InputProps ?? {}, {
                readOnly
            }),
            inputProps: (0, _extends2.default)({}, inputProps ?? {}, {
                inputMode,
                onPaste,
                onKeyDown,
                ref: inputRef
            })
        })
    };
};
exports.cleanFieldResponse = cleanFieldResponse;
const PickerFieldUIContext = exports.PickerFieldUIContext = /*#__PURE__*/ React.createContext({
    slots: {},
    slotProps: {},
    inputRef: undefined
});
function PickerFieldUI(props) {
    const { fieldResponse, defaultOpenPickerIcon } = props;
    const translations = (0, _hooks.usePickerTranslations)();
    const pickerContext = (0, _useNullablePickerContext.useNullablePickerContext)();
    const pickerFieldUIContext = React.useContext(PickerFieldUIContext);
    const { textFieldProps, onClear, clearable, openPickerAriaLabel, clearButtonPosition: clearButtonPositionProp = 'end', openPickerButtonPosition: openPickerButtonPositionProp = 'end' } = cleanFieldResponse(fieldResponse);
    const ownerState = (0, _useFieldOwnerState.useFieldOwnerState)(textFieldProps);
    const handleClickOpeningButton = (0, _useEventCallback.default)((event)=>{
        event.preventDefault();
        pickerContext?.setOpen((prev)=>!prev);
    });
    const triggerStatus = pickerContext ? pickerContext.triggerStatus : 'hidden';
    const clearButtonPosition = clearable ? clearButtonPositionProp : null;
    const openPickerButtonPosition = triggerStatus !== 'hidden' ? openPickerButtonPositionProp : null;
    const TextField = pickerFieldUIContext.slots.textField ?? (fieldResponse.enableAccessibleFieldDOMStructure === false ? _TextField.default : _PickersTextField.PickersTextField);
    const InputAdornment = pickerFieldUIContext.slots.inputAdornment ?? _InputAdornment.default;
    const _useSlotProps = (0, _useSlotProps5.default)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'start'
        },
        ownerState: (0, _extends2.default)({}, ownerState, {
            position: 'start'
        })
    }), startInputAdornmentProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps, _excluded4);
    const _useSlotProps2 = (0, _useSlotProps5.default)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: (0, _extends2.default)({}, ownerState, {
            position: 'end'
        })
    }), endInputAdornmentProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps2, _excluded5);
    const OpenPickerButton = pickerFieldUIContext.slots.openPickerButton ?? _IconButton.default;
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps3 = (0, _useSlotProps5.default)({
        elementType: OpenPickerButton,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
        additionalProps: {
            disabled: triggerStatus === 'disabled',
            onClick: handleClickOpeningButton,
            'aria-label': openPickerAriaLabel,
            edge: // open button is always rendered at the edge
            textFieldProps.variant !== 'standard' ? openPickerButtonPosition : false
        },
        ownerState
    }), openPickerButtonProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps3, _excluded6);
    const OpenPickerIcon = pickerFieldUIContext.slots.openPickerIcon ?? defaultOpenPickerIcon;
    const openPickerIconProps = (0, _useSlotProps5.default)({
        elementType: OpenPickerIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
        ownerState
    });
    const ClearButton = pickerFieldUIContext.slots.clearButton ?? _IconButton.default;
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps4 = (0, _useSlotProps5.default)({
        elementType: ClearButton,
        externalSlotProps: pickerFieldUIContext.slotProps.clearButton,
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel,
            tabIndex: -1,
            onClick: onClear,
            disabled: fieldResponse.disabled || fieldResponse.readOnly,
            edge: // clear button can only be at the edge if it's position differs from the open button
            textFieldProps.variant !== 'standard' && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
        },
        ownerState
    }), clearButtonProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps4, _excluded7);
    const ClearIcon = pickerFieldUIContext.slots.clearIcon ?? _icons.ClearIcon;
    const clearIconProps = (0, _useSlotProps5.default)({
        elementType: ClearIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.clearIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState
    });
    textFieldProps.ref = (0, _useForkRef.default)(textFieldProps.ref, pickerContext?.rootRef);
    const additionalTextFieldInputProps = {};
    const textFieldInputProps = (0, _resolveComponentProps.default)((_version.major >= 6 && textFieldProps?.slotProps?.input) ?? textFieldProps.InputProps, ownerState);
    if (pickerContext) additionalTextFieldInputProps.ref = pickerContext.triggerRef;
    if (!textFieldInputProps?.startAdornment && (clearButtonPosition === 'start' || openPickerButtonPosition === 'start')) additionalTextFieldInputProps.startAdornment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InputAdornment, (0, _extends2.default)({}, startInputAdornmentProps, {
        children: [
            openPickerButtonPosition === 'start' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerButton, (0, _extends2.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerIcon, (0, _extends2.default)({}, openPickerIconProps))
            })),
            clearButtonPosition === 'start' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearButton, (0, _extends2.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearIcon, (0, _extends2.default)({}, clearIconProps))
            }))
        ]
    }));
    if (!textFieldInputProps?.endAdornment && (clearButtonPosition === 'end' || openPickerButtonPosition === 'end')) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InputAdornment, (0, _extends2.default)({}, endInputAdornmentProps, {
        children: [
            clearButtonPosition === 'end' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearButton, (0, _extends2.default)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearIcon, (0, _extends2.default)({}, clearIconProps))
            })),
            openPickerButtonPosition === 'end' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerButton, (0, _extends2.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OpenPickerIcon, (0, _extends2.default)({}, openPickerIconProps))
            }))
        ]
    }));
    // handle the case of showing custom `inputAdornment` for Field components
    if (!additionalTextFieldInputProps?.endAdornment && !additionalTextFieldInputProps?.startAdornment && pickerFieldUIContext.slots.inputAdornment) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, _jsxRuntime.jsx)(InputAdornment, (0, _extends2.default)({}, endInputAdornmentProps));
    if (clearButtonPosition != null) textFieldProps.sx = [
        {
            '& .clearButton': {
                opacity: 1
            },
            '@media (pointer: fine)': {
                '& .clearButton': {
                    opacity: 0
                },
                '&:hover, &:focus-within': {
                    '.clearButton': {
                        opacity: 1
                    }
                }
            }
        },
        ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [
            textFieldProps.sx
        ]
    ];
    const resolvedTextFieldInputProps = _version.major >= 6 && textFieldProps?.slotProps?.input ? (0, _resolveComponentProps.default)(mergeSlotProps(textFieldInputProps, additionalTextFieldInputProps), ownerState) : (0, _extends2.default)({}, textFieldInputProps, additionalTextFieldInputProps);
    // We need to resolve the `inputProps` since we are messing with those props in this component.
    textFieldProps.inputProps = _version.major >= 6 && textFieldProps?.slotProps?.htmlInput ? (0, _resolveComponentProps.default)(textFieldProps.slotProps.htmlInput, ownerState) : textFieldProps.inputProps;
    // Remove the `input` slotProps to avoid them overriding the manually resolved `InputProps`.
    // Relevant on `materialMajor >= 6` since `slotProps` would take precedence.
    delete textFieldProps?.slotProps?.input;
    if (fieldResponse.enableAccessibleFieldDOMStructure) // Remove the `slotProps` on `PickersTextField` as they are not supported.
    delete textFieldProps?.slotProps;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextField, (0, _extends2.default)({}, textFieldProps, {
        InputProps: resolvedTextFieldInputProps
    }));
}
function mergeSlotProps(slotPropsA, slotPropsB) {
    if (!slotPropsA) return slotPropsB;
    if (!slotPropsB) return slotPropsA;
    return (ownerState)=>{
        return (0, _extends2.default)({}, (0, _resolveComponentProps.default)(slotPropsB, ownerState), (0, _resolveComponentProps.default)(slotPropsA, ownerState));
    };
}
/**
 * The `textField` slot props cannot be handled inside `PickerFieldUI` because it would be a breaking change to not pass the enriched props to `useField`.
 * Once the non-accessible DOM structure will be removed, we will be able to remove the `textField` slot and clean this logic.
 */ function useFieldTextFieldProps(parameters) {
    const { ref, externalForwardedProps, slotProps } = parameters;
    const pickerFieldUIContext = React.useContext(PickerFieldUIContext);
    const pickerContext = (0, _useNullablePickerContext.useNullablePickerContext)();
    const ownerState = (0, _useFieldOwnerState.useFieldOwnerState)(externalForwardedProps);
    const { InputProps, inputProps } = externalForwardedProps, otherExternalForwardedProps = (0, _objectWithoutPropertiesLoose2.default)(externalForwardedProps, _excluded8);
    const textFieldProps = (0, _useSlotProps5.default)({
        elementType: _PickersTextField.PickersTextField,
        externalSlotProps: mergeSlotProps(pickerFieldUIContext.slotProps.textField, slotProps?.textField),
        externalForwardedProps: otherExternalForwardedProps,
        additionalProps: {
            ref,
            sx: pickerContext?.rootSx,
            label: pickerContext?.label,
            name: pickerContext?.name,
            className: pickerContext?.rootClassName,
            inputRef: pickerFieldUIContext.inputRef
        },
        ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, _extends2.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, _extends2.default)({}, InputProps, textFieldProps.InputProps);
    return textFieldProps;
}
function PickerFieldUIContextProvider(props) {
    const { slots = {}, slotProps = {}, inputRef, children } = props;
    const contextValue = React.useMemo(()=>({
            inputRef,
            slots: {
                openPickerButton: slots.openPickerButton,
                openPickerIcon: slots.openPickerIcon,
                textField: slots.textField,
                inputAdornment: slots.inputAdornment,
                clearIcon: slots.clearIcon,
                clearButton: slots.clearButton
            },
            slotProps: {
                openPickerButton: slotProps.openPickerButton,
                openPickerIcon: slotProps.openPickerIcon,
                textField: slotProps.textField,
                inputAdornment: slotProps.inputAdornment,
                clearIcon: slotProps.clearIcon,
                clearButton: slotProps.clearButton
            }
        }), [
        inputRef,
        slots.openPickerButton,
        slots.openPickerIcon,
        slots.textField,
        slots.inputAdornment,
        slots.clearIcon,
        slots.clearButton,
        slotProps.openPickerButton,
        slotProps.openPickerIcon,
        slotProps.textField,
        slotProps.inputAdornment,
        slotProps.clearIcon,
        slotProps.clearButton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerFieldUIContext.Provider, {
        value: contextValue,
        children: children
    });
}

},{"e2445c533c01fe52":"9snJq","5cc588e72054ee6":"5RcSx","fa40706ab84ae8a7":"h7ttl","87aa5b0d8404c5ea":"jeIdK","6ae5312ece71e5ca":"9njXz","4eaf05929214b92":"lkrdI","d5231e653e89368b":"93645","a3415eadad9d3747":"iXpA3","cbfbddfc216342d1":"amnzu","48a0b4ee778bbfda":"bXjnZ","c5c2e7561c8d56c7":"jiJDh","39a50d677be29267":"l0AUN","e1dbfc8944aa5458":"izoZZ","a7b2ecc3d0f74277":"7GYkG","4626ce8d7e2f0f39":"6MTP2","1bd2984147f17770":"ezFd3","3db54b3b5e67affa":"eId1l","69d2eb3f25954bcd":"d4baB","4345d7fcef917e5a":"1dlk8"}],"l0AUN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "major", ()=>major);
parcelHelpers.export(exports, "minor", ()=>minor);
parcelHelpers.export(exports, "patch", ()=>patch);
parcelHelpers.export(exports, "preReleaseLabel", ()=>preReleaseLabel);
parcelHelpers.export(exports, "preReleaseNumber", ()=>preReleaseNumber);
const version = "5.16.14";
const major = Number("5");
const minor = Number("16");
const patch = Number("14");
const preReleaseLabel = null;
const preReleaseNumber = Number(undefined) || null;
exports.default = version;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"izoZZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("41dd97ed8541f28c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useSlotProps.default;
    }
});
var _useSlotProps = _interopRequireDefault(require("225956d014e1efc4"));

},{"41dd97ed8541f28c":"9snJq","225956d014e1efc4":"linpQ"}],"linpQ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2fcfd21444f60419").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _useForkRef = _interopRequireDefault(require("bd1afd73a6b177cf"));
var _appendOwnerState = _interopRequireDefault(require("b499a4588075e217"));
var _mergeSlotProps = _interopRequireDefault(require("e18e803659d845ea"));
var _resolveComponentProps = _interopRequireDefault(require("cb532b005d3a8d77"));
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function useSlotProps(parameters) {
    const { elementType, externalSlotProps, ownerState, skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, _resolveComponentProps.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef } = (0, _mergeSlotProps.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, _useForkRef.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, _appendOwnerState.default)(elementType, {
        ...mergedProps,
        ref
    }, ownerState);
    return props;
}
var _default = exports.default = useSlotProps;

},{"2fcfd21444f60419":"9snJq","bd1afd73a6b177cf":"93645","b499a4588075e217":"jr4pr","e18e803659d845ea":"412DV","cb532b005d3a8d77":"iXpA3"}],"jr4pr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("692a81a44a88e935").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _appendOwnerState.default;
    }
});
var _appendOwnerState = _interopRequireDefault(require("1d26e63ffb74956"));

},{"692a81a44a88e935":"9snJq","1d26e63ffb74956":"fD7Uj"}],"fD7Uj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a37cd030d1ec4749").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isHostComponent = _interopRequireDefault(require("1ec746364e62c3e4"));
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, _isHostComponent.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var _default = exports.default = appendOwnerState;

},{"a37cd030d1ec4749":"9snJq","1ec746364e62c3e4":"2HE1v"}],"2HE1v":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("db37b4af83c81622").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _isHostComponent.default;
    }
});
var _isHostComponent = _interopRequireDefault(require("4561c0aa65fb4d31"));

},{"db37b4af83c81622":"9snJq","4561c0aa65fb4d31":"bITSU"}],"bITSU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function isHostComponent(element) {
    return typeof element === 'string';
}
var _default = exports.default = isHostComponent;

},{}],"412DV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d2544550fad44d7b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _mergeSlotProps.default;
    }
});
var _mergeSlotProps = _interopRequireDefault(require("dfd443f5bacfe55c"));

},{"d2544550fad44d7b":"9snJq","dfd443f5bacfe55c":"hO4vJ"}],"hO4vJ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("38565e956e1f7501").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _clsx = _interopRequireDefault(require("365d25aee7ac9c5b"));
var _extractEventHandlers = _interopRequireDefault(require("56876e66523f2d71"));
var _omitEventHandlers = _interopRequireDefault(require("f2bb2fa77c3b03a0"));
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function mergeSlotProps(parameters) {
    const { getSlotProps, additionalProps, externalSlotProps, externalForwardedProps, className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, _clsx.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, _extractEventHandlers.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, _omitEventHandlers.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, _omitEventHandlers.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, _clsx.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props,
        internalRef: internalSlotProps.ref
    };
}
var _default = exports.default = mergeSlotProps;

},{"38565e956e1f7501":"9snJq","365d25aee7ac9c5b":"by5ni","56876e66523f2d71":"7oZ9h","f2bb2fa77c3b03a0":"8LW9h"}],"by5ni":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7oZ9h":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("32cc81d15ba6b548").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _extractEventHandlers.default;
    }
});
var _extractEventHandlers = _interopRequireDefault(require("4ed5e47ad2131019"));

},{"32cc81d15ba6b548":"9snJq","4ed5e47ad2131019":"crsqZ"}],"crsqZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var _default = exports.default = extractEventHandlers;

},{}],"8LW9h":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c4029a8cee969ba1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _omitEventHandlers.default;
    }
});
var _omitEventHandlers = _interopRequireDefault(require("3b45dcc5f5992ca0"));

},{"c4029a8cee969ba1":"9snJq","3b45dcc5f5992ca0":"6SEUx"}],"6SEUx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var _default = exports.default = omitEventHandlers;

},{}],"7GYkG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("1a8346509d526960").default;
var _interopRequireDefault = require("daefe4d518f128ae").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFieldOwnerState = useFieldOwnerState;
var _extends2 = _interopRequireDefault(require("688c5a16e9cabe27"));
var React = _interopRequireWildcard(require("1f92ba677462e3d"));
var _RtlProvider = require("ea88f70055e0bb41");
var _usePickerPrivateContext = require("827592e1a4eaa0fc");
function useFieldOwnerState(parameters) {
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const isRtl = (0, _RtlProvider.useRtl)();
    return React.useMemo(()=>(0, _extends2.default)({}, pickerOwnerState, {
            isFieldDisabled: parameters.disabled ?? false,
            isFieldReadOnly: parameters.readOnly ?? false,
            isFieldRequired: parameters.required ?? false,
            fieldDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        parameters.disabled,
        parameters.readOnly,
        parameters.required,
        isRtl
    ]);
}

},{"1a8346509d526960":"5RcSx","daefe4d518f128ae":"9snJq","688c5a16e9cabe27":"h7ttl","1f92ba677462e3d":"9njXz","ea88f70055e0bb41":"ck9Pb","827592e1a4eaa0fc":"8xvkv"}],"8xvkv":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("1654d7222946dc16").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickerPrivateContext = void 0;
var React = _interopRequireWildcard(require("85709cef4f9c0c98"));
var _PickerProvider = require("94376592871f0afd");
/**
 * Returns the private context passed by the Picker wrapping the current component.
 */ const usePickerPrivateContext = ()=>React.useContext(_PickerProvider.PickerPrivateContext);
exports.usePickerPrivateContext = usePickerPrivateContext;

},{"1654d7222946dc16":"5RcSx","85709cef4f9c0c98":"9njXz","94376592871f0afd":"i6in8"}],"ezFd3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("55e3c335a7d26af1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeIcon = exports.DateRangeIcon = exports.ClockIcon = exports.ClearIcon = exports.CalendarIcon = exports.ArrowRightIcon = exports.ArrowLeftIcon = exports.ArrowDropDownIcon = void 0;
var _utils = require("96ea272d8510093b");
var React = _interopRequireWildcard(require("81e484ae5d6bf645"));
var _jsxRuntime = require("46a6eefe017643cf");
/**
 * @ignore - internal component.
 */ const ArrowDropDownIcon = exports.ArrowDropDownIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
/**
 * @ignore - internal component.
 */ const ArrowLeftIcon = exports.ArrowLeftIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
/**
 * @ignore - internal component.
 */ const ArrowRightIcon = exports.ArrowRightIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
/**
 * @ignore - internal component.
 */ const CalendarIcon = exports.CalendarIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
/**
 * @ignore - internal component.
 */ const ClockIcon = exports.ClockIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
/**
 * @ignore - internal component.
 */ const DateRangeIcon = exports.DateRangeIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
/**
 * @ignore - internal component.
 */ const TimeIcon = exports.TimeIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
/**
 * @ignore - internal component.
 */ const ClearIcon = exports.ClearIcon = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

},{"55e3c335a7d26af1":"5RcSx","96ea272d8510093b":"60iOt","81e484ae5d6bf645":"9njXz","46a6eefe017643cf":"1dlk8"}],"d4baB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    PickersTextField: true,
    pickersTextFieldClasses: true,
    getPickersTextFieldUtilityClass: true
};
Object.defineProperty(exports, "PickersTextField", {
    enumerable: true,
    get: function() {
        return _PickersTextField.PickersTextField;
    }
});
Object.defineProperty(exports, "getPickersTextFieldUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersTextFieldClasses.getPickersTextFieldUtilityClass;
    }
});
Object.defineProperty(exports, "pickersTextFieldClasses", {
    enumerable: true,
    get: function() {
        return _pickersTextFieldClasses.pickersTextFieldClasses;
    }
});
var _PickersTextField = require("ba576b2370d2e7c4");
var _pickersTextFieldClasses = require("dc206985c7754d2b");
var _PickersInput = require("a7afe1ef31a2f383");
Object.keys(_PickersInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _PickersInput[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PickersInput[key];
        }
    });
});
var _PickersFilledInput = require("727fb5d7ed0f1238");
Object.keys(_PickersFilledInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _PickersFilledInput[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PickersFilledInput[key];
        }
    });
});
var _PickersOutlinedInput = require("de61b11c7bbfd1ad");
Object.keys(_PickersOutlinedInput).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _PickersOutlinedInput[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PickersOutlinedInput[key];
        }
    });
});
var _PickersInputBase = require("ca6e4c4b4bb0ba68");
Object.keys(_PickersInputBase).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _PickersInputBase[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _PickersInputBase[key];
        }
    });
});

},{"ba576b2370d2e7c4":"jxL2F","dc206985c7754d2b":"6vIL3","a7afe1ef31a2f383":"e7eXj","727fb5d7ed0f1238":"P4edb","de61b11c7bbfd1ad":"9sQD6","ca6e4c4b4bb0ba68":"bNm4V"}],"jxL2F":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("339e2fcfd5907ff6").default;
var _interopRequireWildcard = require("c9c2ef35d92ccfd4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersTextField = void 0;
var _extends2 = _interopRequireDefault(require("bfd06c488436bf6e"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("a174cc88969b892c"));
var React = _interopRequireWildcard(require("fe02d320e3a6091a"));
var _propTypes = _interopRequireDefault(require("47f2bfe559e3e0d8"));
var _clsx = _interopRequireDefault(require("c06dcfc3383aaa8d"));
var _styles = require("6b9136bbcb64189");
var _refType = _interopRequireDefault(require("3df1a38e9788ab72"));
var _useForkRef = _interopRequireDefault(require("e72a7f7b3ac967be"));
var _composeClasses = _interopRequireDefault(require("a975e781bac5c029"));
var _useId = _interopRequireDefault(require("3d6f9977834a916a"));
var _InputLabel = _interopRequireDefault(require("16d071bcec69895e"));
var _FormHelperText = _interopRequireDefault(require("5886c3863667fbac"));
var _FormControl = _interopRequireDefault(require("d6e54192425c4a8e"));
var _pickersTextFieldClasses = require("e29f7ac3fb7df68");
var _PickersOutlinedInput = require("3690d745481e61c2");
var _PickersFilledInput = require("fa6a8989bf9e4f68");
var _PickersInput = require("7ed9cadc55382f20");
var _useFieldOwnerState = require("fca35705708bdd48");
var _usePickerTextFieldOwnerState = require("d24842b4dfbffcd4");
var _jsxRuntime = require("822640a2e52e25c6");
const _excluded = [
    "onFocus",
    "onBlur",
    "className",
    "classes",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "hiddenLabel",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps",
    "data-active-range-position"
];
const VARIANT_COMPONENT = {
    standard: _PickersInput.PickersInput,
    filled: _PickersFilledInput.PickersFilledInput,
    outlined: _PickersOutlinedInput.PickersOutlinedInput
};
const PickersTextFieldRoot = (0, _styles.styled)(_FormControl.default, {
    name: 'MuiPickersTextField',
    slot: 'Root'
})({
    maxWidth: '100%'
});
const useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused, isFieldDisabled, isFieldRequired } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldRequired && 'required'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersTextFieldClasses.getPickersTextFieldUtilityClass, classes);
};
const PickersTextField = exports.PickersTextField = /*#__PURE__*/ React.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { // Props used by FormControl
    onFocus, onBlur, className, classes: classesProp, color = 'primary', disabled = false, error = false, variant = 'outlined', required = false, hiddenLabel = false, // Props used by PickersInput
    InputProps, inputProps, inputRef, sectionListRef, elements, areAllSectionsEmpty, onClick, onKeyDown, onKeyUp, onPaste, onInput, endAdornment, startAdornment, tabIndex, contentEditable, focused, value, onChange, fullWidth, id: idProp, name, // Props used by FormHelperText
    helperText, FormHelperTextProps, // Props used by InputLabel
    label, InputLabelProps, // @ts-ignore
    'data-active-range-position': dataActiveRangePosition } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const rootRef = React.useRef(null);
    const handleRootRef = (0, _useForkRef.default)(ref, rootRef);
    const id = (0, _useId.default)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const fieldOwnerState = (0, _useFieldOwnerState.useFieldOwnerState)({
        disabled: props.disabled,
        required: props.required,
        readOnly: InputProps?.readOnly
    });
    const ownerState = React.useMemo(()=>(0, _extends2.default)({}, fieldOwnerState, {
            isFieldValueEmpty: areAllSectionsEmpty,
            isFieldFocused: focused ?? false,
            hasFieldError: error ?? false,
            inputSize: props.size ?? 'medium',
            inputColor: color ?? 'primary',
            isInputInFullWidth: fullWidth ?? false,
            hasStartAdornment: Boolean(startAdornment ?? InputProps?.startAdornment),
            hasEndAdornment: Boolean(endAdornment ?? InputProps?.endAdornment),
            inputHasLabel: !!label,
            isLabelShrunk: Boolean(InputLabelProps?.shrink)
        }), [
        fieldOwnerState,
        areAllSectionsEmpty,
        focused,
        error,
        props.size,
        color,
        fullWidth,
        startAdornment,
        endAdornment,
        InputProps?.startAdornment,
        InputProps?.endAdornment,
        label,
        InputLabelProps?.shrink
    ]);
    const classes = useUtilityClasses(classesProp, ownerState);
    const PickersInputComponent = VARIANT_COMPONENT[variant];
    const inputAdditionalProps = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') inputAdditionalProps.notched = InputLabelProps.shrink;
        inputAdditionalProps.label = label;
    } else if (variant === 'filled') inputAdditionalProps.hiddenLabel = hiddenLabel;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_usePickerTextFieldOwnerState.PickerTextFieldOwnerStateContext.Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersTextFieldRoot, (0, _extends2.default)({
            className: (0, _clsx.default)(classes.root, className),
            ref: handleRootRef,
            focused: focused,
            disabled: disabled,
            variant: variant,
            error: error,
            color: color,
            fullWidth: fullWidth,
            required: required,
            ownerState: ownerState
        }, other, {
            children: [
                label != null && label !== '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_InputLabel.default, (0, _extends2.default)({
                    htmlFor: id,
                    id: inputLabelId
                }, InputLabelProps, {
                    children: label
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersInputComponent, (0, _extends2.default)({
                    elements: elements,
                    areAllSectionsEmpty: areAllSectionsEmpty,
                    onClick: onClick,
                    onKeyDown: onKeyDown,
                    onKeyUp: onKeyUp,
                    onInput: onInput,
                    onPaste: onPaste,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment,
                    tabIndex: tabIndex,
                    contentEditable: contentEditable,
                    value: value,
                    onChange: onChange,
                    id: id,
                    fullWidth: fullWidth,
                    inputProps: inputProps,
                    inputRef: inputRef,
                    sectionListRef: sectionListRef,
                    label: label,
                    name: name,
                    role: "group",
                    "aria-labelledby": inputLabelId,
                    "aria-describedby": helperTextId,
                    "aria-live": helperTextId ? 'polite' : undefined,
                    "data-active-range-position": dataActiveRangePosition
                }, inputAdditionalProps, InputProps)),
                helperText && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormHelperText.default, (0, _extends2.default)({
                    id: helperTextId
                }, FormHelperTextProps, {
                    children: helperText
                }))
            ]
        }))
    });
});

},{"339e2fcfd5907ff6":"9snJq","c9c2ef35d92ccfd4":"5RcSx","bfd06c488436bf6e":"h7ttl","a174cc88969b892c":"jeIdK","fe02d320e3a6091a":"9njXz","47f2bfe559e3e0d8":"bnNSm","c06dcfc3383aaa8d":"by5ni","6b9136bbcb64189":"c9RfU","3df1a38e9788ab72":"fAbhl","e72a7f7b3ac967be":"93645","a975e781bac5c029":"eKeIT","3d6f9977834a916a":"icfbA","16d071bcec69895e":"iTW3B","5886c3863667fbac":"dlh9L","d6e54192425c4a8e":"kkska","e29f7ac3fb7df68":"6vIL3","3690d745481e61c2":"9sQD6","fa6a8989bf9e4f68":"P4edb","7ed9cadc55382f20":"e7eXj","fca35705708bdd48":"7GYkG","d24842b4dfbffcd4":"67IIT","822640a2e52e25c6":"1dlk8"}],"eKeIT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("dd37961d513c1184").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _composeClasses.default;
    }
});
var _composeClasses = _interopRequireDefault(require("44d40562c5f193e2"));

},{"dd37961d513c1184":"9snJq","44d40562c5f193e2":"ftq2A"}],"ftq2A":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

},{}],"icfbA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("46377f081a3f574c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useId.default;
    }
});
var _useId = _interopRequireDefault(require("a571e6f00fc99070"));

},{"46377f081a3f574c":"9snJq","a571e6f00fc99070":"6I3bn"}],"6I3bn":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("d517234b81020c72").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useId;
var React = _interopRequireWildcard(require("ac6fee5931122951"));
let globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = React.useState(idOverride);
    const id = idOverride || defaultId;
    React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const safeReact = {
    ...React
};
const maybeReactUseId = safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if (maybeReactUseId !== undefined) {
        const reactId = maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return useGlobalId(idOverride);
}

},{"d517234b81020c72":"5RcSx","ac6fee5931122951":"9njXz"}],"6vIL3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c9db80362c33130").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersTextFieldUtilityClass = getPickersTextFieldUtilityClass;
exports.pickersTextFieldClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("d4a4d7e440ba75f1"));
var _generateUtilityClasses = _interopRequireDefault(require("eaf9f6ad340d9f7d"));
function getPickersTextFieldUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersTextField', slot);
}
const pickersTextFieldClasses = exports.pickersTextFieldClasses = (0, _generateUtilityClasses.default)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);

},{"c9db80362c33130":"9snJq","d4a4d7e440ba75f1":"dtNEc","eaf9f6ad340d9f7d":"2Z0QC"}],"dtNEc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("66b2329b27ef05c2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _generateUtilityClass.default;
    }
});
var _generateUtilityClass = _interopRequireWildcard(require("c6f859d8bbebeb06"));
Object.keys(_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _generateUtilityClass[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _generateUtilityClass[key];
        }
    });
});

},{"66b2329b27ef05c2":"5RcSx","c6f859d8bbebeb06":"5TUnB"}],"5TUnB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6a72f236f62c202d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = generateUtilityClass;
exports.globalStateClasses = void 0;
exports.isGlobalState = isGlobalState;
var _ClassNameGenerator = _interopRequireDefault(require("83e008bbe0ed9362"));
const globalStateClasses = exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
    return globalStateClasses[slot] !== undefined;
}

},{"6a72f236f62c202d":"9snJq","83e008bbe0ed9362":"8aAlF"}],"8aAlF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3b0ff7c7e2ec55f7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ClassNameGenerator.default;
    }
});
var _ClassNameGenerator = _interopRequireDefault(require("98c6d2e982f77156"));

},{"3b0ff7c7e2ec55f7":"9snJq","98c6d2e982f77156":"c5muK"}],"c5muK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator = createClassNameGenerator();
var _default = exports.default = ClassNameGenerator;

},{}],"2Z0QC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("80d83e746db350ce").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _generateUtilityClasses.default;
    }
});
var _generateUtilityClasses = _interopRequireDefault(require("8511652ae27dd4cc"));

},{"80d83e746db350ce":"9snJq","8511652ae27dd4cc":"jBjzv"}],"jBjzv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fa2035eca48d521").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = generateUtilityClasses;
var _generateUtilityClass = _interopRequireDefault(require("a1c6de1a8293bbd"));
function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

},{"fa2035eca48d521":"9snJq","a1c6de1a8293bbd":"dtNEc"}],"9sQD6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersOutlinedInput", {
    enumerable: true,
    get: function() {
        return _PickersOutlinedInput.PickersOutlinedInput;
    }
});
Object.defineProperty(exports, "getPickersOutlinedInputUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersOutlinedInputClasses.getPickersOutlinedInputUtilityClass;
    }
});
Object.defineProperty(exports, "pickersOutlinedInputClasses", {
    enumerable: true,
    get: function() {
        return _pickersOutlinedInputClasses.pickersOutlinedInputClasses;
    }
});
var _PickersOutlinedInput = require("25f451a09f048fb2");
var _pickersOutlinedInputClasses = require("402759d7af4e5768");

},{"25f451a09f048fb2":"1ThkR","402759d7af4e5768":"k7Hj1"}],"1ThkR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9ce907ae239f92ef").default;
var _interopRequireWildcard = require("4a633380de403bc5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersOutlinedInput = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("2942799aa852c384"));
var _extends2 = _interopRequireDefault(require("5ca0376a11595ded"));
var React = _interopRequireWildcard(require("a36f2be684f116e8"));
var _propTypes = _interopRequireDefault(require("941342afef0efb0c"));
var _FormControl = require("e9963d307fe8f593");
var _styles = require("9562431afce8880");
var _refType = _interopRequireDefault(require("35cb6f80d38e5763"));
var _composeClasses = _interopRequireDefault(require("6f341a024f69582"));
var _pickersOutlinedInputClasses = require("6d0c366324e7a8fb");
var _Outline = _interopRequireDefault(require("db5a85cd9c3ad032"));
var _PickersInputBase = require("727375af7cc6ab24");
var _PickersInputBase2 = require("400199c9dede1295");
var _jsxRuntime = require("10adbde1b8199a76");
const _excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "classes",
    "notched"
];
const PickersOutlinedInputRoot = (0, _styles.styled)(_PickersInputBase2.PickersInputBaseRoot, {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root'
})(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.focused} .${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.disabled}`]: {
            [`& .${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.error} .${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    inputColor: color
                },
                style: {
                    [`&.${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.focused}:not(.${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.error}) .${_pickersOutlinedInputClasses.pickersOutlinedInputClasses.notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const PickersOutlinedInputSectionsContainer = (0, _styles.styled)(_PickersInputBase2.PickersInputBaseSectionsContainer, {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer'
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _pickersOutlinedInputClasses.getPickersOutlinedInputUtilityClass, classes);
    return (0, _extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const PickersOutlinedInput = exports.PickersOutlinedInput = /*#__PURE__*/ React.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label, classes: classesProp, notched } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const muiFormControl = (0, _FormControl.useFormControl)();
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersInputBase.PickersInputBase, (0, _extends2.default)({
        slots: {
            root: PickersOutlinedInputRoot,
            input: PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_Outline.default, {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
PickersOutlinedInput.muiName = 'Input';

},{"9ce907ae239f92ef":"9snJq","4a633380de403bc5":"5RcSx","2942799aa852c384":"jeIdK","5ca0376a11595ded":"h7ttl","a36f2be684f116e8":"9njXz","941342afef0efb0c":"bnNSm","e9963d307fe8f593":"kkska","9562431afce8880":"c9RfU","35cb6f80d38e5763":"fAbhl","6f341a024f69582":"eKeIT","6d0c366324e7a8fb":"k7Hj1","db5a85cd9c3ad032":"iFLth","727375af7cc6ab24":"bNm4V","400199c9dede1295":"iAc4t","10adbde1b8199a76":"1dlk8"}],"k7Hj1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("50fe64af26ea05d7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersOutlinedInputUtilityClass = getPickersOutlinedInputUtilityClass;
exports.pickersOutlinedInputClasses = void 0;
var _extends2 = _interopRequireDefault(require("4a43232532c0e6d3"));
var _generateUtilityClasses = _interopRequireDefault(require("3eda986cf50d6202"));
var _generateUtilityClass = _interopRequireDefault(require("8d2afe4c0d2e1170"));
var _PickersInputBase = require("680f6063f4895a5e");
function getPickersOutlinedInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersOutlinedInput', slot);
}
const pickersOutlinedInputClasses = exports.pickersOutlinedInputClasses = (0, _extends2.default)({}, _PickersInputBase.pickersInputBaseClasses, (0, _generateUtilityClasses.default)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));

},{"50fe64af26ea05d7":"9snJq","4a43232532c0e6d3":"h7ttl","3eda986cf50d6202":"2Z0QC","8d2afe4c0d2e1170":"dtNEc","680f6063f4895a5e":"bNm4V"}],"bNm4V":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersInputBase", {
    enumerable: true,
    get: function() {
        return _PickersInputBase.PickersInputBase;
    }
});
Object.defineProperty(exports, "getPickersInputBaseUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersInputBaseClasses.getPickersInputBaseUtilityClass;
    }
});
Object.defineProperty(exports, "pickersInputBaseClasses", {
    enumerable: true,
    get: function() {
        return _pickersInputBaseClasses.pickersInputBaseClasses;
    }
});
var _PickersInputBase = require("8bb16927e6c444fa");
var _pickersInputBaseClasses = require("1ffe3b7c57375eab");

},{"8bb16927e6c444fa":"iAc4t","1ffe3b7c57375eab":"3M2Pc"}],"iAc4t":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b09902f93bb77f48").default;
var _interopRequireWildcard = require("5626dda478a658e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersInputBaseSectionsContainer = exports.PickersInputBaseRoot = exports.PickersInputBase = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("9853c470da3b4d11"));
var _extends2 = _interopRequireDefault(require("37a061f885c4a04a"));
var React = _interopRequireWildcard(require("fbd2dd0dd867feba"));
var _propTypes = _interopRequireDefault(require("ed7301167ed37efc"));
var _FormControl = require("a44fa592dbf962ca");
var _styles = require("e0b54dcc19ed396");
var _useForkRef = _interopRequireDefault(require("900ea0dc0c8380c2"));
var _refType = _interopRequireDefault(require("1b4bb6f6aecfd032"));
var _composeClasses = _interopRequireDefault(require("54dd8978ad9969a7"));
var _capitalize = _interopRequireDefault(require("68329e3a9f77af4b"));
var _useSlotProps = _interopRequireDefault(require("4e005dcc960b9f41"));
var _visuallyHidden = _interopRequireDefault(require("4323cae5a47c10d0"));
var _pickersInputBaseClasses = require("e9521b8b4dfe3f5b");
var _PickersSectionList = require("19935495535a0c3b");
var _usePickerTextFieldOwnerState = require("e5fb472cb989335c");
var _jsxRuntime = require("a346b19817a69731");
const _excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "onFocus",
    "onBlur",
    "classes",
    "ownerState"
];
const round = (value)=>Math.round(value * 1e5) / 1e5;
const PickersInputBaseRoot = exports.PickersInputBaseRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root'
})(({ theme })=>(0, _extends2.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    isInputInFullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const PickersInputBaseSectionsContainer = exports.PickersInputBaseSectionsContainer = (0, _styles.styled)(_PickersSectionList.Unstable_PickersSectionListRoot, {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer'
})(({ theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    fieldDirection: 'rtl'
                },
                style: {
                    justifyContent: 'end'
                }
            },
            {
                props: {
                    inputSize: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: false
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: true,
                    isLabelShrunk: true
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const PickersInputBaseSection = (0, _styles.styled)(_PickersSectionList.Unstable_PickersSectionListSection, {
    name: 'MuiPickersInputBase',
    slot: 'Section'
})(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const PickersInputBaseSectionContent = (0, _styles.styled)(_PickersSectionList.Unstable_PickersSectionListSectionContent, {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content // FIXME: Inconsistent naming with slot
})(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const PickersInputBaseSectionSeparator = (0, _styles.styled)(_PickersSectionList.Unstable_PickersSectionListSectionSeparator, {
    name: 'MuiPickersInputBase',
    slot: 'Separator'
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const PickersInputBaseInput = (0, _styles.styled)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput // FIXME: Inconsistent naming with slot
})((0, _extends2.default)({}, _visuallyHidden.default));
const PickersInputBaseActiveBar = (0, _styles.styled)('div', {
    name: 'MuiPickersInputBase',
    slot: 'ActiveBar'
})(({ theme, ownerState })=>({
        display: 'none',
        position: 'absolute',
        height: 2,
        bottom: 2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        transition: theme.transitions.create([
            'width',
            'left'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.primary.main,
        '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
            display: 'block'
        },
        '[data-active-range-position="start"] &': {
            left: ownerState.sectionOffsets[0]
        },
        '[data-active-range-position="end"] &': {
            left: ownerState.sectionOffsets[1]
        }
    }));
const useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused, isFieldDisabled, isFieldReadOnly, hasFieldError, inputSize, isInputInFullWidth, inputColor, hasStartAdornment, hasEndAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldReadOnly && 'readOnly',
            hasFieldError && 'error',
            isInputInFullWidth && 'fullWidth',
            `color${(0, _capitalize.default)(inputColor)}`,
            inputSize === 'small' && 'inputSizeSmall',
            hasStartAdornment && 'adornedStart',
            hasEndAdornment && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ],
        activeBar: [
            'activeBar'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersInputBaseClasses.getPickersInputBaseUtilityClass, classes);
};
function resolveSectionElementWidth(sectionElement, rootRef, index, dateRangePosition) {
    if (sectionElement.content.id) {
        const activeSectionElements = rootRef.current?.querySelectorAll(`[data-sectionindex="${index}"] [data-range-position="${dateRangePosition}"]`);
        if (activeSectionElements) return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element)=>{
            return currentActiveBarWidth + element.offsetWidth;
        }, 0);
    }
    return 0;
}
function resolveSectionWidthAndOffsets(elements, rootRef) {
    let activeBarWidth = 0;
    const activeRangePosition = rootRef.current?.getAttribute('data-active-range-position');
    if (activeRangePosition === 'end') for(let i = elements.length - 1; i >= elements.length / 2; i -= 1)activeBarWidth += resolveSectionElementWidth(elements[i], rootRef, i, 'end');
    else for(let i = 0; i < elements.length / 2; i += 1)activeBarWidth += resolveSectionElementWidth(elements[i], rootRef, i, 'start');
    return {
        activeBarWidth,
        sectionOffsets: [
            rootRef.current?.querySelector(`[data-sectionindex="0"]`)?.offsetLeft || 0,
            rootRef.current?.querySelector(`[data-sectionindex="${elements.length / 2}"]`)?.offsetLeft || 0
        ]
    };
}
/**
 * @ignore - internal component.
 */ const PickersInputBase = exports.PickersInputBase = /*#__PURE__*/ React.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements, areAllSectionsEmpty, value, onChange, id, endAdornment, startAdornment, renderSuffix, slots, slotProps, contentEditable, tabIndex, onInput, onPaste, onKeyDown, name, readOnly, inputProps, inputRef, sectionListRef, onFocus, onBlur, classes: classesProp, ownerState: ownerStateProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerStateContext = (0, _usePickerTextFieldOwnerState.usePickerTextFieldOwnerState)();
    const rootRef = React.useRef(null);
    const activeBarRef = React.useRef(null);
    const sectionOffsetsRef = React.useRef([]);
    const handleRootRef = (0, _useForkRef.default)(ref, rootRef);
    const handleInputRef = (0, _useForkRef.default)(inputProps?.ref, inputRef);
    const muiFormControl = (0, _FormControl.useFormControl)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const ownerState = ownerStateProp ?? ownerStateContext;
    const handleInputFocus = (event)=>{
        muiFormControl.onFocus?.(event);
        onFocus?.(event);
    };
    const handleHiddenInputFocus = (event)=>{
        handleInputFocus(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (event.key === 'Enter' && !event.defaultMuiPrevented) {
            // Do nothing if it's a multi input field
            if (rootRef.current?.dataset.multiInput) return;
            const closestForm = rootRef.current?.closest('form');
            const submitTrigger = closestForm?.querySelector('[type="submit"]');
            if (!closestForm || !submitTrigger) // do nothing if there is no form or no submit button (trigger)
            return;
            event.preventDefault();
            // native input trigger submit with the `submitter` field set
            closestForm.requestSubmit(submitTrigger);
        }
    };
    const handleInputBlur = (event)=>{
        muiFormControl.onBlur?.(event);
        onBlur?.(event);
    };
    React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    React.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const classes = useUtilityClasses(classesProp, ownerState);
    const InputRoot = slots?.root || PickersInputBaseRoot;
    const inputRootProps = (0, _useSlotProps.default)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState
    });
    const InputSectionsContainer = slots?.input || PickersInputBaseSectionsContainer;
    const isSingleInputRange = elements.some((element)=>element.content['data-range-position'] !== undefined);
    React.useEffect(()=>{
        if (!isSingleInputRange || !ownerState.isPickerOpen) return;
        const { activeBarWidth, sectionOffsets } = resolveSectionWidthAndOffsets(elements, rootRef);
        sectionOffsetsRef.current = [
            sectionOffsets[0],
            sectionOffsets[1]
        ];
        if (activeBarRef.current) activeBarRef.current.style.width = `${activeBarWidth}px`;
    }, [
        elements,
        isSingleInputRange,
        ownerState.isPickerOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(InputRoot, (0, _extends2.default)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersSectionList.Unstable_PickersSectionList, {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: handleKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: PickersInputBaseSection,
                    sectionContent: PickersInputBaseSectionContent,
                    sectionSeparator: PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: (0, _extends2.default)({}, slotProps?.input, {
                        ownerState
                    }),
                    sectionContent: {
                        className: _pickersInputBaseClasses.pickersInputBaseClasses.sectionContent
                    },
                    sectionSeparator: ({ separatorPosition })=>({
                            className: separatorPosition === 'before' ? _pickersInputBaseClasses.pickersInputBaseClasses.sectionBefore : _pickersInputBaseClasses.pickersInputBaseClasses.sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, _extends2.default)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersInputBaseInput, (0, _extends2.default)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled,
                onFocus: handleHiddenInputFocus
            }, inputProps, {
                ref: handleInputRef
            })),
            isSingleInputRange && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersInputBaseActiveBar, {
                className: classes.activeBar,
                ref: activeBarRef,
                ownerState: {
                    sectionOffsets: sectionOffsetsRef.current
                }
            })
        ]
    }));
});

},{"b09902f93bb77f48":"9snJq","5626dda478a658e6":"5RcSx","9853c470da3b4d11":"jeIdK","37a061f885c4a04a":"h7ttl","fbd2dd0dd867feba":"9njXz","ed7301167ed37efc":"bnNSm","a44fa592dbf962ca":"kkska","e0b54dcc19ed396":"c9RfU","900ea0dc0c8380c2":"93645","1b4bb6f6aecfd032":"fAbhl","54dd8978ad9969a7":"eKeIT","68329e3a9f77af4b":"5lY2m","4e005dcc960b9f41":"izoZZ","4323cae5a47c10d0":"4SrPY","e9521b8b4dfe3f5b":"3M2Pc","19935495535a0c3b":"ekQOn","e5fb472cb989335c":"67IIT","a346b19817a69731":"1dlk8"}],"5lY2m":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c53731fccfb64ee7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _capitalize.default;
    }
});
var _capitalize = _interopRequireDefault(require("fd335a9bbd965010"));

},{"c53731fccfb64ee7":"9snJq","fd335a9bbd965010":"8WQoQ"}],"8WQoQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7798481228f2d686").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = capitalize;
var _formatMuiErrorMessage = _interopRequireDefault(require("afb3d8532a61330f"));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, _formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

},{"7798481228f2d686":"9snJq","afb3d8532a61330f":"fifV4"}],"fifV4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("43ed225f3767045c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _formatMuiErrorMessage.default;
    }
});
var _formatMuiErrorMessage = _interopRequireDefault(require("1ff0de98d1e29196"));

},{"43ed225f3767045c":"9snJq","1ff0de98d1e29196":"5RZ6e"}],"5RZ6e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

},{}],"4SrPY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("38afed1f93a863d9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _visuallyHidden.default;
    }
});
var _visuallyHidden = _interopRequireDefault(require("a33661139b540d76"));

},{"38afed1f93a863d9":"9snJq","a33661139b540d76":"lnQSR"}],"lnQSR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var _default = exports.default = visuallyHidden;

},{}],"3M2Pc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("aabc082591908187").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersInputBaseUtilityClass = getPickersInputBaseUtilityClass;
exports.pickersInputBaseClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("872025d7fe43829f"));
var _generateUtilityClasses = _interopRequireDefault(require("3c72da128ee1fba3"));
function getPickersInputBaseUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersInputBase', slot);
}
const pickersInputBaseClasses = exports.pickersInputBaseClasses = (0, _generateUtilityClasses.default)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input',
    'inputSizeSmall',
    'activeBar'
]);

},{"aabc082591908187":"9snJq","872025d7fe43829f":"dtNEc","3c72da128ee1fba3":"2Z0QC"}],"ekQOn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Unstable_PickersSectionList", {
    enumerable: true,
    get: function() {
        return _PickersSectionList.PickersSectionList;
    }
});
Object.defineProperty(exports, "Unstable_PickersSectionListRoot", {
    enumerable: true,
    get: function() {
        return _PickersSectionList.PickersSectionListRoot;
    }
});
Object.defineProperty(exports, "Unstable_PickersSectionListSection", {
    enumerable: true,
    get: function() {
        return _PickersSectionList.PickersSectionListSection;
    }
});
Object.defineProperty(exports, "Unstable_PickersSectionListSectionContent", {
    enumerable: true,
    get: function() {
        return _PickersSectionList.PickersSectionListSectionContent;
    }
});
Object.defineProperty(exports, "Unstable_PickersSectionListSectionSeparator", {
    enumerable: true,
    get: function() {
        return _PickersSectionList.PickersSectionListSectionSeparator;
    }
});
Object.defineProperty(exports, "getPickersSectionListUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersSectionListClasses.getPickersSectionListUtilityClass;
    }
});
Object.defineProperty(exports, "pickersSectionListClasses", {
    enumerable: true,
    get: function() {
        return _pickersSectionListClasses.pickersSectionListClasses;
    }
});
var _PickersSectionList = require("1f19c28aed824275");
var _pickersSectionListClasses = require("782818bd4269f0ae");

},{"1f19c28aed824275":"gMOTs","782818bd4269f0ae":"iYfCx"}],"gMOTs":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("14dd132936133d83").default;
var _interopRequireWildcard = require("c960fb641d44ac1d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersSectionListSectionSeparator = exports.PickersSectionListSectionContent = exports.PickersSectionListSection = exports.PickersSectionListRoot = exports.PickersSectionList = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("239580eac5284646"));
var _extends2 = _interopRequireDefault(require("793cd1df717fabf6"));
var React = _interopRequireWildcard(require("ea0be811e05d6ca7"));
var _propTypes = _interopRequireDefault(require("e7d2d3665b0c760d"));
var _useSlotProps = _interopRequireDefault(require("ad77fa308fb1874"));
var _composeClasses = _interopRequireDefault(require("73da852d232a241d"));
var _useForkRef = _interopRequireDefault(require("5adb4209b28ed16a"));
var _styles = require("1177690e19cf041f");
var _pickersSectionListClasses = require("4300bc54629d59cf");
var _usePickerPrivateContext = require("bb8d2aa3371260c7");
var _jsxRuntime = require("eacb430b2e5ad97");
const _excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef",
    "classes"
];
const PickersSectionListRoot = exports.PickersSectionListRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root'
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const PickersSectionListSection = exports.PickersSectionListSection = (0, _styles.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section'
})({});
const PickersSectionListSectionSeparator = exports.PickersSectionListSectionSeparator = (0, _styles.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator'
})({
    whiteSpace: 'pre'
});
const PickersSectionListSectionContent = exports.PickersSectionListSectionContent = (0, _styles.styled)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent'
})({
    outline: 'none'
});
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersSectionListClasses.getPickersSectionListUtilityClass, classes);
};
function PickersSection(props) {
    const { slots, slotProps, element, classes } = props;
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const Section = slots?.section ?? PickersSectionListSection;
    const sectionProps = (0, _useSlotProps.default)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState
    });
    const SectionContent = slots?.sectionContent ?? PickersSectionListSectionContent;
    const sectionContentProps = (0, _useSlotProps.default)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState
    });
    const SectionSeparator = slots?.sectionSeparator ?? PickersSectionListSectionSeparator;
    const sectionSeparatorBeforeProps = (0, _useSlotProps.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: (0, _extends2.default)({}, ownerState, {
            separatorPosition: 'before'
        })
    });
    const sectionSeparatorAfterProps = (0, _useSlotProps.default)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: (0, _extends2.default)({}, ownerState, {
            separatorPosition: 'after'
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Section, (0, _extends2.default)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionSeparator, (0, _extends2.default)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionContent, (0, _extends2.default)({}, sectionContentProps)),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SectionSeparator, (0, _extends2.default)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const PickersSectionList = exports.PickersSectionList = /*#__PURE__*/ React.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots, slotProps, elements, sectionListRef, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const rootRef = React.useRef(null);
    const handleRootRef = (0, _useForkRef.default)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    React.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${_pickersSectionListClasses.pickersSectionListClasses.section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${_pickersSectionListClasses.pickersSectionListClasses.section}[data-sectionindex="${index}"] .${_pickersSectionListClasses.pickersSectionListClasses.sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains(_pickersSectionListClasses.pickersSectionListClasses.section)) sectionContainer = element;
                else if (element.classList.contains(_pickersSectionListClasses.pickersSectionListClasses.sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? PickersSectionListRoot;
    const rootProps = (0, _useSlotProps.default)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, (0, _extends2.default)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content, before, after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, _jsxRuntime.jsx)(React.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});

},{"14dd132936133d83":"9snJq","c960fb641d44ac1d":"5RcSx","239580eac5284646":"jeIdK","793cd1df717fabf6":"h7ttl","ea0be811e05d6ca7":"9njXz","e7d2d3665b0c760d":"bnNSm","ad77fa308fb1874":"izoZZ","73da852d232a241d":"eKeIT","5adb4209b28ed16a":"93645","1177690e19cf041f":"c9RfU","4300bc54629d59cf":"iYfCx","bb8d2aa3371260c7":"8xvkv","eacb430b2e5ad97":"1dlk8"}],"iYfCx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1127ddf2d1e52559").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersSectionListUtilityClass = getPickersSectionListUtilityClass;
exports.pickersSectionListClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("389e3fac612ae980"));
var _generateUtilityClasses = _interopRequireDefault(require("1d3ec28d7f929d87"));
function getPickersSectionListUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersSectionList', slot);
}
const pickersSectionListClasses = exports.pickersSectionListClasses = (0, _generateUtilityClasses.default)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);

},{"1127ddf2d1e52559":"9snJq","389e3fac612ae980":"dtNEc","1d3ec28d7f929d87":"2Z0QC"}],"67IIT":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("90d1af2d616bf8f8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickerTextFieldOwnerState = exports.PickerTextFieldOwnerStateContext = void 0;
var React = _interopRequireWildcard(require("1fff24626ae872e8"));
const PickerTextFieldOwnerStateContext = exports.PickerTextFieldOwnerStateContext = /*#__PURE__*/ React.createContext(null);
const usePickerTextFieldOwnerState = ()=>{
    const value = React.useContext(PickerTextFieldOwnerStateContext);
    if (value == null) throw new Error([
        'MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component'
    ].join('\n'));
    return value;
};
exports.usePickerTextFieldOwnerState = usePickerTextFieldOwnerState;

},{"90d1af2d616bf8f8":"5RcSx","1fff24626ae872e8":"9njXz"}],"iFLth":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("86bbd39432424d42").default;
var _interopRequireWildcard = require("898332d8f45da5a4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Outline;
var _extends2 = _interopRequireDefault(require("f9275fe1cdd87ebf"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("9e03a9f052bea8c6"));
var React = _interopRequireWildcard(require("5c39c4ca5c93e8ad"));
var _styles = require("955ecc6d069fcba2");
var _createStyled = require("3f40d76c7e92d3e3");
var _usePickerTextFieldOwnerState = require("f2f09860e85a3bba");
var _jsxRuntime = require("ae69327424d84501");
const _excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const OutlineRoot = (0, _styles.styled)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline'
})(({ theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const OutlineLabel = (0, _styles.styled)('span')(({ theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const OutlineLegend = (0, _styles.styled)('legend', {
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'notched'
})(({ theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    inputHasLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    inputHasLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    inputHasLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function Outline(props) {
    const { className, label, notched } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _usePickerTextFieldOwnerState.usePickerTextFieldOwnerState)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineRoot, (0, _extends2.default)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineLegend, {
            ownerState: ownerState,
            notched: notched,
            children: label ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, _jsxRuntime.jsx)(OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}

},{"86bbd39432424d42":"9snJq","898332d8f45da5a4":"5RcSx","f9275fe1cdd87ebf":"h7ttl","9e03a9f052bea8c6":"jeIdK","5c39c4ca5c93e8ad":"9njXz","955ecc6d069fcba2":"c9RfU","3f40d76c7e92d3e3":"6ySdS","f2f09860e85a3bba":"67IIT","ae69327424d84501":"1dlk8"}],"6ySdS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d3fcf02e78575e2e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _createStyled.default;
    }
});
var _createStyled = _interopRequireWildcard(require("5f89072a663e921"));
Object.keys(_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _createStyled[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _createStyled[key];
        }
    });
});

},{"d3fcf02e78575e2e":"jIxH8","5f89072a663e921":"ac1i8"}],"ac1i8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6133cdf82f560f08").default;
var _interopRequireWildcard = require("b44a5c6928314bca").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStyled;
exports.shouldForwardProp = shouldForwardProp;
exports.systemDefaultTheme = void 0;
var _styledEngine = _interopRequireWildcard(require("766c6067aca00c60"));
var _deepmerge = require("769865f2cfbbcf39");
var _capitalize = _interopRequireDefault(require("172c5cc1504f511f"));
var _getDisplayName = _interopRequireDefault(require("8c6347b34f380bc1"));
var _createTheme = _interopRequireDefault(require("332771a3a6457326"));
var _styleFunctionSx = _interopRequireDefault(require("6d6fee53ff3c0e51"));
var _preprocessStyles = _interopRequireDefault(require("ac41deb8895ce74c"));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const systemDefaultTheme = exports.systemDefaultTheme = (0, _createTheme.default)();
// Update /system/styled/#api in case if this changes
function shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function attachTheme(props, themeId, defaultTheme) {
    props.theme = isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? shallowLayer((0, _styledEngine.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? shallowLayer((0, _styledEngine.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? shallowLayer((0, _styledEngine.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(layerName ? shallowLayer((0, _styledEngine.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? shallowLayer((0, _styledEngine.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function createStyled(input = {}) {
    const { themeId, defaultTheme = systemDefaultTheme, rootShouldForwardProp = shouldForwardProp, slotShouldForwardProp = shouldForwardProp } = input;
    function styleAttachTheme(props) {
        attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, _styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== _styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = defaultOverridesResolver(lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if (isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, _styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, _deepmerge.isPlainObject)(style)) {
                const serialized = (0, _preprocessStyles.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? shallowLayer(serialized.style, layerName) : serialized.style;
                    return processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push(_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, _capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, _getDisplayName.default)(tag)})`;
}
function generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

},{"6133cdf82f560f08":"74mZ8","b44a5c6928314bca":"jIxH8","766c6067aca00c60":"2KtHf","769865f2cfbbcf39":"jqcMl","172c5cc1504f511f":"iyeHV","8c6347b34f380bc1":"6FUHX","332771a3a6457326":"lBucb","6d6fee53ff3c0e51":"e1roB","ac41deb8895ce74c":"b8rSc"}],"2KtHf":[function(require,module,exports,__globalThis) {
/**
 * @mui/styled-engine v7.3.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
'use client';
/* eslint-disable no-underscore-dangle */ var _interopRequireDefault = require("968f4653f4bfc7ec").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return _GlobalStyles.default;
    }
});
Object.defineProperty(exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return _StyledEngineProvider.default;
    }
});
Object.defineProperty(exports, "ThemeContext", {
    enumerable: true,
    get: function() {
        return _react.ThemeContext;
    }
});
Object.defineProperty(exports, "css", {
    enumerable: true,
    get: function() {
        return _react.css;
    }
});
exports.default = styled;
exports.internal_mutateStyles = internal_mutateStyles;
exports.internal_serializeStyles = internal_serializeStyles;
Object.defineProperty(exports, "keyframes", {
    enumerable: true,
    get: function() {
        return _react.keyframes;
    }
});
var _styled = _interopRequireDefault(require("5d622cdd897f1877"));
var _serialize = require("bed873a4eceeddb7");
var _react = require("9c8f5283e6ea4419");
var _StyledEngineProvider = _interopRequireDefault(require("b8b85de6bd90f7af"));
var _GlobalStyles = _interopRequireDefault(require("a57df2937858346b"));
function styled(tag, options) {
    const stylesFactory = (0, _styled.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_serializeStyles(styles) {
    wrapper[0] = styles;
    return (0, _serialize.serializeStyles)(wrapper);
}

},{"968f4653f4bfc7ec":"aZwI8","5d622cdd897f1877":"3YoOh","bed873a4eceeddb7":"6P7Gu","9c8f5283e6ea4419":"lIeII","b8b85de6bd90f7af":"3CMza","a57df2937858346b":"kaggy"}],"aZwI8":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"3CMza":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1dfff88975bb605b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _StyledEngineProvider.default;
    }
});
var _StyledEngineProvider = _interopRequireDefault(require("7a0ee0926ff81a67"));

},{"1dfff88975bb605b":"aZwI8","7a0ee0926ff81a67":"krvO0"}],"krvO0":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b99c24f035e46b97").default;
var _interopRequireWildcard = require("a2822dcf17786a2d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TEST_INTERNALS_DO_NOT_USE = void 0;
exports.default = StyledEngineProvider;
var React = _interopRequireWildcard(require("b1df1ad8dc9d9aea"));
var _propTypes = _interopRequireDefault(require("dde2ebc2484f468b"));
var _react2 = require("a68671e3ea645ab5");
var _cache = _interopRequireDefault(require("292a3e781694d299"));
var _sheet = require("cbac3dcb08437dbe");
var _jsxRuntime = require("335bc345b5e1390b");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
const cacheMap = new Map();
// Need to add a private variable to test the generated CSS from Emotion, this is the simplest way to do it.
// We can't test the CSS from `style` tag easily because the `speedy: true` (produce empty text content) is enabled by Emotion.
// Even if we disable it, JSDOM needs extra configuration to be able to parse `@layer` CSS.
const TEST_INTERNALS_DO_NOT_USE = exports.TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, _cache.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!insertionPoint) {
        insertionPoint = document.createElement('meta');
        insertionPoint.setAttribute('name', 'emotion-insertion-point');
        insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend(insertionPoint);
    }
}
function getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends _sheet.StyleSheet {
            insert(rule, options) {
                if (TEST_INTERNALS_DO_NOT_USE.insert) return TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function StyledEngineProvider(props) {
    const { injectFirst, enableCssLayer, children } = props;
    const cache = React.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && cacheMap.has(cacheKey)) return cacheMap.get(cacheKey);
        const fresh = getCache(injectFirst, enableCssLayer);
        cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react2.CacheProvider, {
        value: cache,
        children: children
    }) : children;
}

},{"b99c24f035e46b97":"aZwI8","a2822dcf17786a2d":"e0Iks","b1df1ad8dc9d9aea":"9njXz","dde2ebc2484f468b":"bnNSm","a68671e3ea645ab5":"lIeII","292a3e781694d299":"r7hGp","cbac3dcb08437dbe":"4RXfS","335bc345b5e1390b":"1dlk8"}],"e0Iks":[function(require,module,exports,__globalThis) {
var _typeof = require("d93c43d514a663a2")["default"];
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"d93c43d514a663a2":"lwYWT"}],"lwYWT":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"kaggy":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2189f0ada3c9605f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _GlobalStyles.default;
    }
});
var _GlobalStyles = _interopRequireDefault(require("d20e3c41dd876783"));

},{"2189f0ada3c9605f":"aZwI8","d20e3c41dd876783":"eivHx"}],"eivHx":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("3ac2ac4d1500aa3b").default;
var _interopRequireWildcard = require("53230feaa9393b4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = GlobalStyles;
var React = _interopRequireWildcard(require("698249945a795dbe"));
var _propTypes = _interopRequireDefault(require("543d070c94b70ccb"));
var _react2 = require("8ea4931d68988b29");
var _jsxRuntime = require("4b6077f189162dcc");
function isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
    const { styles, defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react2.Global, {
        styles: globalStyles
    });
}

},{"3ac2ac4d1500aa3b":"aZwI8","53230feaa9393b4":"e0Iks","698249945a795dbe":"9njXz","543d070c94b70ccb":"bnNSm","8ea4931d68988b29":"lIeII","4b6077f189162dcc":"1dlk8"}],"jqcMl":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("cf7b3ac8de1d6056").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _deepmerge.default;
    }
});
var _deepmerge = _interopRequireWildcard(require("f51f43a1f51c77af"));
Object.keys(_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _deepmerge[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _deepmerge[key];
        }
    });
});

},{"cf7b3ac8de1d6056":"jIxH8","f51f43a1f51c77af":"2xB0C"}],"2xB0C":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("91c1227d33505699").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deepmerge;
exports.isPlainObject = isPlainObject;
var React = _interopRequireWildcard(require("f78ef04149c10be8"));
var _reactIs = require("2a4829e77000de47");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
    if (/*#__PURE__*/ React.isValidElement(source) || (0, _reactIs.isValidElementType)(source) || !isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if (isPlainObject(target) && isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ React.isValidElement(source[key]) || (0, _reactIs.isValidElementType)(source[key])) output[key] = source[key];
        else if (isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

},{"91c1227d33505699":"jIxH8","f78ef04149c10be8":"9njXz","2a4829e77000de47":"4bD4G"}],"4bD4G":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c73442077b674450");

},{"c73442077b674450":"c8ct4"}],"c8ct4":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                    case REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"iyeHV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("86309f3aa8077c46").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _capitalize.default;
    }
});
var _capitalize = _interopRequireDefault(require("97897216cd91d1b7"));

},{"86309f3aa8077c46":"74mZ8","97897216cd91d1b7":"gXQFU"}],"gXQFU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("856abc0f8a107641").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = capitalize;
var _formatMuiErrorMessage = _interopRequireDefault(require("6983662c5c6c2029"));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, _formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

},{"856abc0f8a107641":"74mZ8","6983662c5c6c2029":"26TdG"}],"26TdG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("64d7465808235537").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _formatMuiErrorMessage.default;
    }
});
var _formatMuiErrorMessage = _interopRequireDefault(require("f3d5be6559b03b26"));

},{"64d7465808235537":"74mZ8","f3d5be6559b03b26":"9lfST"}],"9lfST":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

},{}],"6FUHX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("dabffbf602724a8f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _getDisplayName.default;
    }
});
var _getDisplayName = _interopRequireDefault(require("ce30083ca8e0d91f"));

},{"dabffbf602724a8f":"74mZ8","ce30083ca8e0d91f":"gozXa"}],"gozXa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDisplayName;
var _reactIs = require("c5dff98e3c4298f0");
function getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function getWrappedName(outerType, innerType, wrapperName) {
    const functionName = getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case _reactIs.ForwardRef:
            return getWrappedName(Component, Component.render, 'ForwardRef');
        case _reactIs.Memo:
            return getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

},{"c5dff98e3c4298f0":"4bD4G"}],"lBucb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("dd1c30bf430b5bba").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _createTheme.default;
    }
});
Object.defineProperty(exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return _createBreakpoints.default;
    }
});
Object.defineProperty(exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return _applyStyles.default;
    }
});
var _createTheme = _interopRequireDefault(require("bdc18df69795eaba"));
var _createBreakpoints = _interopRequireDefault(require("48b86d2ba11b61d7"));
var _applyStyles = _interopRequireDefault(require("a63ca49c1a3790b7"));

},{"dd1c30bf430b5bba":"74mZ8","bdc18df69795eaba":"crbT4","48b86d2ba11b61d7":"cQVkp","a63ca49c1a3790b7":"jKIbG"}],"crbT4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a7a69b6314ef6820").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("f08de1e574d96be4"));
var _createBreakpoints = _interopRequireDefault(require("fef76d655aaa132e"));
var _cssContainerQueries = _interopRequireDefault(require("83f3137514b70a38"));
var _shape = _interopRequireDefault(require("e487320954df9b05"));
var _createSpacing = _interopRequireDefault(require("4a83e44bc56a5742"));
var _styleFunctionSx = _interopRequireDefault(require("5ae03db25d336f5a"));
var _defaultSxConfig = _interopRequireDefault(require("e9031ccc4da151b1"));
var _applyStyles = _interopRequireDefault(require("555272fc77b24fc5"));
function createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
    const spacing = (0, _createSpacing.default)(spacingInput);
    let muiTheme = (0, _deepmerge.default)({
        breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing,
        shape: {
            ..._shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, _cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = _applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, _deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ..._defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, _styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var _default = exports.default = createTheme;

},{"a7a69b6314ef6820":"74mZ8","f08de1e574d96be4":"jqcMl","fef76d655aaa132e":"cQVkp","83f3137514b70a38":"9nycZ","e487320954df9b05":"kAWBz","4a83e44bc56a5742":"3KIEP","5ae03db25d336f5a":"2FlmW","e9031ccc4da151b1":"fAPQU","555272fc77b24fc5":"jKIbG"}],"cQVkp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.breakpointKeys = void 0;
exports.default = createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
    const { // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit = 'px', step = 5, ...other } = breakpoints;
    const sortedValues = sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys,
        values: sortedValues,
        up,
        down,
        between,
        only,
        not,
        unit,
        ...other
    };
}

},{}],"9nycZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b4cec13b20945773").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.default;
    }
});
Object.defineProperty(exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.sortContainerQueries;
    }
});
var _cssContainerQueries = _interopRequireWildcard(require("59ff7536d9109ba6"));

},{"b4cec13b20945773":"jIxH8","59ff7536d9109ba6":"jRZqy"}],"jRZqy":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("63c97ab4ead71b1d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cssContainerQueries;
exports.getContainerQuery = getContainerQuery;
exports.isCqShorthand = isCqShorthand;
exports.sortContainerQueries = sortContainerQueries;
var _formatMuiErrorMessage = _interopRequireDefault(require("ed2a2f8b3caa624b"));
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function sortContainerQueries(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries
    };
}

},{"63c97ab4ead71b1d":"74mZ8","ed2a2f8b3caa624b":"26TdG"}],"kAWBz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const shape = {
    borderRadius: 4
};
var _default = exports.default = shape;

},{}],"3KIEP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createSpacing;
var _spacing = require("2efeaeaa34925f80");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, _spacing.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

},{"2efeaeaa34925f80":"3PKpA"}],"3PKpA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("606a2ed0ce831dd9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _spacing.default;
    }
});
var _spacing = _interopRequireWildcard(require("e86ea1f53daffa96"));
Object.keys(_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _spacing[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _spacing[key];
        }
    });
});

},{"606a2ed0ce831dd9":"jIxH8","e86ea1f53daffa96":"253jp"}],"253jp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("71d176b307068e0e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createUnarySpacing = createUnarySpacing;
exports.createUnaryUnit = createUnaryUnit;
exports.default = void 0;
exports.getStyleFromPropValue = getStyleFromPropValue;
exports.getValue = getValue;
exports.margin = margin;
exports.marginKeys = void 0;
exports.padding = padding;
exports.paddingKeys = void 0;
var _responsivePropType = _interopRequireDefault(require("e629f08b8f852dff"));
var _breakpoints = require("c3fa080d2d3f53d3");
var _style = require("2dd9a87d7c34c534");
var _merge = _interopRequireDefault(require("26bf834107052fd6"));
var _memoize = _interopRequireDefault(require("e1785f73db1c256a"));
const properties = {
    m: 'margin',
    p: 'padding'
};
const directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = (0, _memoize.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if (aliases[prop]) prop = aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = properties[a];
    const direction = directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const marginKeys = exports.marginKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const paddingKeys = exports.paddingKeys = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const spacingKeys = [
    ...marginKeys,
    ...paddingKeys
];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, _style.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function createUnarySpacing(theme) {
    return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function getStyleFromPropValue(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = getValue(transformer, propValue);
            return acc;
        }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = getCssProperties(prop);
    const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    const propValue = props[prop];
    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function style(props, keys) {
    const transformer = createUnarySpacing(props.theme);
    return Object.keys(props).map((prop)=>resolveCssProperty(props, keys, prop, transformer)).reduce(_merge.default, {});
}
function margin(props) {
    return style(props, marginKeys);
}
margin.propTypes = {};
margin.filterProps = marginKeys;
function padding(props) {
    return style(props, paddingKeys);
}
padding.propTypes = {};
padding.filterProps = paddingKeys;
function spacing(props) {
    return style(props, spacingKeys);
}
spacing.propTypes = {};
spacing.filterProps = spacingKeys;
var _default = exports.default = spacing;

},{"71d176b307068e0e":"74mZ8","e629f08b8f852dff":"bqofx","c3fa080d2d3f53d3":"1dc0z","2dd9a87d7c34c534":"fiOnV","26bf834107052fd6":"4iLSQ","e1785f73db1c256a":"1Bq1a"}],"bqofx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ec6c7c0e1b7f6948").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _responsivePropType.default;
    }
});
var _responsivePropType = _interopRequireDefault(require("650457f449899290"));

},{"ec6c7c0e1b7f6948":"74mZ8","650457f449899290":"fHaFb"}],"fHaFb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("297608686d02322a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("b35663a2342e647f"));
const responsivePropType = {};
var _default = exports.default = responsivePropType;

},{"297608686d02322a":"74mZ8","b35663a2342e647f":"bnNSm"}],"1dc0z":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("298040812d0beba9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _breakpoints.default;
    }
});
var _breakpoints = _interopRequireWildcard(require("a155ccd2323803e9"));
Object.keys(_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _breakpoints[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _breakpoints[key];
        }
    });
});

},{"298040812d0beba9":"jIxH8","a155ccd2323803e9":"9z4df"}],"9z4df":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a6136cdc22d0813d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.computeBreakpointsBase = computeBreakpointsBase;
exports.createEmptyBreakpointObject = createEmptyBreakpointObject;
exports.default = void 0;
exports.handleBreakpoints = handleBreakpoints;
exports.mergeBreakpointsInOrder = mergeBreakpointsInOrder;
exports.removeUnusedBreakpoints = removeUnusedBreakpoints;
exports.resolveBreakpointValues = resolveBreakpointValues;
exports.values = void 0;
var _propTypes = _interopRequireDefault(require("8e5b28389e20e17b"));
var _deepmerge = _interopRequireDefault(require("1d9f2e62540cf7b6"));
var _merge = _interopRequireDefault(require("5d17e0af0929002b"));
var _cssContainerQueries = require("6bd2fe12ec9a2caa");
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${values[key]}px)`
};
const defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, _cssContainerQueries.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, _cssContainerQueries.getContainerQuery)(theme.containerQueries ? theme : defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || values).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, _merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
    const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, _deepmerge.default)(prev, next), {});
    return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}
// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function resolveBreakpointValues({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var _default = exports.default = breakpoints;

},{"a6136cdc22d0813d":"74mZ8","8e5b28389e20e17b":"bnNSm","1d9f2e62540cf7b6":"jqcMl","5d17e0af0929002b":"4iLSQ","6bd2fe12ec9a2caa":"9nycZ"}],"4iLSQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fc6ab35294d6090c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _merge.default;
    }
});
var _merge = _interopRequireDefault(require("5675c06187a9f579"));

},{"fc6ab35294d6090c":"74mZ8","5675c06187a9f579":"drdlm"}],"drdlm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cd412d495236e54a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("450a67cad5d36e5a"));
function merge(acc, item) {
    if (!item) return acc;
    return (0, _deepmerge.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var _default = exports.default = merge;

},{"cd412d495236e54a":"74mZ8","450a67cad5d36e5a":"jqcMl"}],"fiOnV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c8a7c8d9b8f4e240").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _style.default;
    }
});
var _style = _interopRequireWildcard(require("744c9014913efcd8"));
Object.keys(_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _style[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _style[key];
        }
    });
});

},{"c8a7c8d9b8f4e240":"jIxH8","744c9014913efcd8":"gkQEi"}],"gkQEi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("15c10178470582d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getPath = getPath;
exports.getStyleValue = getStyleValue;
var _capitalize = _interopRequireDefault(require("913a49dd101c73af"));
var _responsivePropType = _interopRequireDefault(require("5a0088855d5ded69"));
var _breakpoints = require("19752313f867dee4");
function getPath(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = getPath(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function style(options) {
    const { prop, cssProperty = options.prop, themeKey, transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = getPath(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = getStyleValue(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var _default = exports.default = style;

},{"15c10178470582d":"74mZ8","913a49dd101c73af":"iyeHV","5a0088855d5ded69":"bqofx","19752313f867dee4":"1dc0z"}],"1Bq1a":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f213d6040afacb77").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _memoize.default;
    }
});
var _memoize = _interopRequireDefault(require("180b2e3d46554f10"));

},{"f213d6040afacb77":"74mZ8","180b2e3d46554f10":"iye7y"}],"iye7y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = memoize;
function memoize(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{}],"2FlmW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c0143919dad125fe").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.unstable_createStyleFunctionSx = unstable_createStyleFunctionSx;
var _capitalize = _interopRequireDefault(require("96896e59929bb199"));
var _merge = _interopRequireDefault(require("474adad98f2fe185"));
var _style = require("657abc912cdf60e4");
var _breakpoints = require("49e436695c9eeb7b");
var _cssContainerQueries = require("788160d5aa5dca63");
var _defaultSxConfig = _interopRequireDefault(require("ecd15981307fab21"));
function objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty = prop, themeKey, transform, style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, _style.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, _style.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, _style.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, _capitalize.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx, theme = {}, nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? _defaultSxConfig.default;
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, _breakpoints.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, _merge.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, _breakpoints.handleBreakpoints)({
                                theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if (objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme,
                                nested: true
                            });
                            else css = (0, _merge.default)(css, breakpointsValues);
                        }
                    } else css = (0, _merge.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, _cssContainerQueries.sortContainerQueries)(theme, (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, _cssContainerQueries.sortContainerQueries)(theme, (0, _breakpoints.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = [
    'sx'
];
var _default = exports.default = styleFunctionSx;

},{"c0143919dad125fe":"74mZ8","96896e59929bb199":"iyeHV","474adad98f2fe185":"4iLSQ","657abc912cdf60e4":"fiOnV","49e436695c9eeb7b":"1dc0z","788160d5aa5dca63":"9nycZ","ecd15981307fab21":"fAPQU"}],"fAPQU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _spacing = require("c57d76f643a2b254");
var _borders = require("6c964eb5aa743c86");
var _cssGrid = require("10ca837dc3e62cc8");
var _palette = require("d96c52549a7b804d");
var _sizing = require("90d21174e5fb17be");
const defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: _borders.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: _borders.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: _palette.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: _palette.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: _palette.paletteTransform
    },
    // spacing
    p: {
        style: _spacing.padding
    },
    pt: {
        style: _spacing.padding
    },
    pr: {
        style: _spacing.padding
    },
    pb: {
        style: _spacing.padding
    },
    pl: {
        style: _spacing.padding
    },
    px: {
        style: _spacing.padding
    },
    py: {
        style: _spacing.padding
    },
    padding: {
        style: _spacing.padding
    },
    paddingTop: {
        style: _spacing.padding
    },
    paddingRight: {
        style: _spacing.padding
    },
    paddingBottom: {
        style: _spacing.padding
    },
    paddingLeft: {
        style: _spacing.padding
    },
    paddingX: {
        style: _spacing.padding
    },
    paddingY: {
        style: _spacing.padding
    },
    paddingInline: {
        style: _spacing.padding
    },
    paddingInlineStart: {
        style: _spacing.padding
    },
    paddingInlineEnd: {
        style: _spacing.padding
    },
    paddingBlock: {
        style: _spacing.padding
    },
    paddingBlockStart: {
        style: _spacing.padding
    },
    paddingBlockEnd: {
        style: _spacing.padding
    },
    m: {
        style: _spacing.margin
    },
    mt: {
        style: _spacing.margin
    },
    mr: {
        style: _spacing.margin
    },
    mb: {
        style: _spacing.margin
    },
    ml: {
        style: _spacing.margin
    },
    mx: {
        style: _spacing.margin
    },
    my: {
        style: _spacing.margin
    },
    margin: {
        style: _spacing.margin
    },
    marginTop: {
        style: _spacing.margin
    },
    marginRight: {
        style: _spacing.margin
    },
    marginBottom: {
        style: _spacing.margin
    },
    marginLeft: {
        style: _spacing.margin
    },
    marginX: {
        style: _spacing.margin
    },
    marginY: {
        style: _spacing.margin
    },
    marginInline: {
        style: _spacing.margin
    },
    marginInlineStart: {
        style: _spacing.margin
    },
    marginInlineEnd: {
        style: _spacing.margin
    },
    marginBlock: {
        style: _spacing.margin
    },
    marginBlockStart: {
        style: _spacing.margin
    },
    marginBlockEnd: {
        style: _spacing.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: _cssGrid.gap
    },
    rowGap: {
        style: _cssGrid.rowGap
    },
    columnGap: {
        style: _cssGrid.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: _sizing.sizingTransform
    },
    maxWidth: {
        style: _sizing.maxWidth
    },
    minWidth: {
        transform: _sizing.sizingTransform
    },
    height: {
        transform: _sizing.sizingTransform
    },
    maxHeight: {
        transform: _sizing.sizingTransform
    },
    minHeight: {
        transform: _sizing.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var _default = exports.default = defaultSxConfig;

},{"c57d76f643a2b254":"3PKpA","6c964eb5aa743c86":"afjq7","10ca837dc3e62cc8":"3nf7W","d96c52549a7b804d":"cHnmn","90d21174e5fb17be":"7bMrz"}],"afjq7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("dcce089d5908f568").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _borders.default;
    }
});
var _borders = _interopRequireWildcard(require("5fdcb604265ccfdc"));
Object.keys(_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _borders[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _borders[key];
        }
    });
});

},{"dcce089d5908f568":"jIxH8","5fdcb604265ccfdc":"h03y2"}],"h03y2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e2dc5666a8871a7e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.borderTopColor = exports.borderTop = exports.borderRightColor = exports.borderRight = exports.borderRadius = exports.borderLeftColor = exports.borderLeft = exports.borderColor = exports.borderBottomColor = exports.borderBottom = exports.border = void 0;
exports.borderTransform = borderTransform;
exports.outlineColor = exports.outline = exports.default = void 0;
var _responsivePropType = _interopRequireDefault(require("2c25771648e887a7"));
var _style = _interopRequireDefault(require("c2fb266b8e96749a"));
var _compose = _interopRequireDefault(require("dc05a15740d248e0"));
var _spacing = require("63b2b7100e242903");
var _breakpoints = require("2b87fd0661fd640");
function borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
    return (0, _style.default)({
        prop,
        themeKey: 'borders',
        transform
    });
}
const border = exports.border = createBorderStyle('border', borderTransform);
const borderTop = exports.borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = exports.borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = exports.borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = exports.borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = exports.borderColor = createBorderStyle('borderColor');
const borderTopColor = exports.borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = exports.borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = exports.borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = exports.borderLeftColor = createBorderStyle('borderLeftColor');
const outline = exports.outline = createBorderStyle('outline', borderTransform);
const outlineColor = exports.outlineColor = createBorderStyle('outlineColor');
// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
exports.borderRadius = borderRadius;
borderRadius.propTypes = {};
borderRadius.filterProps = [
    'borderRadius'
];
const borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
var _default = exports.default = borders;

},{"e2dc5666a8871a7e":"74mZ8","2c25771648e887a7":"bqofx","c2fb266b8e96749a":"fiOnV","dc05a15740d248e0":"cHtKH","63b2b7100e242903":"3PKpA","2b87fd0661fd640":"1dc0z"}],"cHtKH":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3d74380f49397bed").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _compose.default;
    }
});
var _compose = _interopRequireDefault(require("d391cd3bb4012335"));

},{"3d74380f49397bed":"74mZ8","d391cd3bb4012335":"9Kxq2"}],"9Kxq2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("14e4e4a88d602ae4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _merge = _interopRequireDefault(require("ff50934fa3d5e60e"));
function compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, _merge.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var _default = exports.default = compose;

},{"14e4e4a88d602ae4":"74mZ8","ff50934fa3d5e60e":"4iLSQ"}],"3nf7W":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5b680ec5197bb2fc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _cssGrid.default;
    }
});
var _cssGrid = _interopRequireWildcard(require("e0b08a3944a6d551"));
Object.keys(_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _cssGrid[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _cssGrid[key];
        }
    });
});

},{"5b680ec5197bb2fc":"jIxH8","e0b08a3944a6d551":"iq1ML"}],"iq1ML":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("300f35d57ddbfa95").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rowGap = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridTemplateAreas = exports.gridRow = exports.gridColumn = exports.gridAutoRows = exports.gridAutoFlow = exports.gridAutoColumns = exports.gridArea = exports.gap = exports.default = exports.columnGap = void 0;
var _style = _interopRequireDefault(require("927191ba8c0c341e"));
var _compose = _interopRequireDefault(require("d75713cdbc0b5233"));
var _spacing = require("55ed5a86f79ad101");
var _breakpoints = require("22f6d220a1401b69");
var _responsivePropType = _interopRequireDefault(require("d3962afb6cf389ca"));
// false positive
// eslint-disable-next-line react/function-component-definition
const gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
exports.gap = gap;
gap.propTypes = {};
gap.filterProps = [
    'gap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
exports.columnGap = columnGap;
columnGap.propTypes = {};
columnGap.filterProps = [
    'columnGap'
];
// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, _spacing.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, _spacing.getValue)(transformer, propValue)
            });
        return (0, _breakpoints.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
exports.rowGap = rowGap;
rowGap.propTypes = {};
rowGap.filterProps = [
    'rowGap'
];
const gridColumn = exports.gridColumn = (0, _style.default)({
    prop: 'gridColumn'
});
const gridRow = exports.gridRow = (0, _style.default)({
    prop: 'gridRow'
});
const gridAutoFlow = exports.gridAutoFlow = (0, _style.default)({
    prop: 'gridAutoFlow'
});
const gridAutoColumns = exports.gridAutoColumns = (0, _style.default)({
    prop: 'gridAutoColumns'
});
const gridAutoRows = exports.gridAutoRows = (0, _style.default)({
    prop: 'gridAutoRows'
});
const gridTemplateColumns = exports.gridTemplateColumns = (0, _style.default)({
    prop: 'gridTemplateColumns'
});
const gridTemplateRows = exports.gridTemplateRows = (0, _style.default)({
    prop: 'gridTemplateRows'
});
const gridTemplateAreas = exports.gridTemplateAreas = (0, _style.default)({
    prop: 'gridTemplateAreas'
});
const gridArea = exports.gridArea = (0, _style.default)({
    prop: 'gridArea'
});
const grid = (0, _compose.default)(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var _default = exports.default = grid;

},{"300f35d57ddbfa95":"74mZ8","927191ba8c0c341e":"fiOnV","d75713cdbc0b5233":"cHtKH","55ed5a86f79ad101":"3PKpA","22f6d220a1401b69":"1dc0z","d3962afb6cf389ca":"bqofx"}],"cHnmn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e353c406c441666e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _palette.default;
    }
});
var _palette = _interopRequireWildcard(require("7f0ad3806bebb455"));
Object.keys(_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _palette[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _palette[key];
        }
    });
});

},{"e353c406c441666e":"jIxH8","7f0ad3806bebb455":"eLwhj"}],"eLwhj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("34066a344d8daecf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.color = exports.bgcolor = exports.backgroundColor = void 0;
exports.paletteTransform = paletteTransform;
var _style = _interopRequireDefault(require("c7773e82f050f56b"));
var _compose = _interopRequireDefault(require("779f4fad9951137b"));
function paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const color = exports.color = (0, _style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: paletteTransform
});
const bgcolor = exports.bgcolor = (0, _style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const backgroundColor = exports.backgroundColor = (0, _style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: paletteTransform
});
const palette = (0, _compose.default)(color, bgcolor, backgroundColor);
var _default = exports.default = palette;

},{"34066a344d8daecf":"74mZ8","c7773e82f050f56b":"fiOnV","779f4fad9951137b":"cHtKH"}],"7bMrz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("781c1f35f5805a82").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _sizing.default;
    }
});
var _sizing = _interopRequireWildcard(require("ae93bb06e3e389f4"));
Object.keys(_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _sizing[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _sizing[key];
        }
    });
});

},{"781c1f35f5805a82":"jIxH8","ae93bb06e3e389f4":"dfScd"}],"dfScd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("149b7315c3e764d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sizeWidth = exports.sizeHeight = exports.minWidth = exports.minHeight = exports.maxWidth = exports.maxHeight = exports.height = exports.default = exports.boxSizing = void 0;
exports.sizingTransform = sizingTransform;
exports.width = void 0;
var _style = _interopRequireDefault(require("dc9f1f09def53b2b"));
var _compose = _interopRequireDefault(require("817e5b138a0e941c"));
var _breakpoints = require("d41bba6b0766ba5d");
function sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = exports.width = (0, _style.default)({
    prop: 'width',
    transform: sizingTransform
});
const maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || _breakpoints.values[propValue];
            if (!breakpoint) return {
                maxWidth: sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, _breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
exports.maxWidth = maxWidth;
maxWidth.filterProps = [
    'maxWidth'
];
const minWidth = exports.minWidth = (0, _style.default)({
    prop: 'minWidth',
    transform: sizingTransform
});
const height = exports.height = (0, _style.default)({
    prop: 'height',
    transform: sizingTransform
});
const maxHeight = exports.maxHeight = (0, _style.default)({
    prop: 'maxHeight',
    transform: sizingTransform
});
const minHeight = exports.minHeight = (0, _style.default)({
    prop: 'minHeight',
    transform: sizingTransform
});
const sizeWidth = exports.sizeWidth = (0, _style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: sizingTransform
});
const sizeHeight = exports.sizeHeight = (0, _style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: sizingTransform
});
const boxSizing = exports.boxSizing = (0, _style.default)({
    prop: 'boxSizing'
});
const sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
var _default = exports.default = sizing;

},{"149b7315c3e764d":"74mZ8","dc9f1f09def53b2b":"fiOnV","817e5b138a0e941c":"cHtKH","d41bba6b0766ba5d":"1dc0z"}],"jKIbG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

},{}],"e1roB":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ebf92742dab40c54").default;
var _interopRequireWildcard = require("7bd85c2d391b9be3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.default;
    }
});
Object.defineProperty(exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return _extendSxProp.default;
    }
});
Object.defineProperty(exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return _defaultSxConfig.default;
    }
});
var _styleFunctionSx = _interopRequireWildcard(require("a36ab58f22476148"));
var _extendSxProp = _interopRequireDefault(require("2413bd638e69fe83"));
var _defaultSxConfig = _interopRequireDefault(require("465244391337dec0"));

},{"ebf92742dab40c54":"74mZ8","7bd85c2d391b9be3":"jIxH8","a36ab58f22476148":"2FlmW","2413bd638e69fe83":"BWIBK","465244391337dec0":"fAPQU"}],"BWIBK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("87b2fb8bb141f448").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = extendSxProp;
var _deepmerge = require("5c6e7a57f2743787");
var _defaultSxConfig = _interopRequireDefault(require("b647cc6fd4459669"));
const splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? _defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps, otherProps } = splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, _deepmerge.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

},{"87b2fb8bb141f448":"74mZ8","5c6e7a57f2743787":"jqcMl","b647cc6fd4459669":"fAPQU"}],"b8rSc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = preprocessStyles;
var _styledEngine = require("83fa6b8ae50c7fe5");
function preprocessStyles(input) {
    const { variants, ...style } = input;
    const result = {
        variants,
        style: (0, _styledEngine.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, _styledEngine.internal_serializeStyles)(variant.style);
    });
    return result;
}

},{"83fa6b8ae50c7fe5":"2KtHf"}],"P4edb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersFilledInput", {
    enumerable: true,
    get: function() {
        return _PickersFilledInput.PickersFilledInput;
    }
});
Object.defineProperty(exports, "getPickersFilledInputUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersFilledInputClasses.getPickersFilledInputUtilityClass;
    }
});
Object.defineProperty(exports, "pickersFilledInputClasses", {
    enumerable: true,
    get: function() {
        return _pickersFilledInputClasses.pickersFilledInputClasses;
    }
});
var _PickersFilledInput = require("76eb375b277f7640");
var _pickersFilledInputClasses = require("2c7d45ec794e210c");

},{"76eb375b277f7640":"5u6CQ","2c7d45ec794e210c":"eMS7Z"}],"5u6CQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f01b7a5e80ce39e2").default;
var _interopRequireWildcard = require("dc77577741fbf1ae").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersFilledInput = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("d9f0b0493dab2b6b"));
var _extends2 = _interopRequireDefault(require("e34bc51594b38e28"));
var React = _interopRequireWildcard(require("457421dcf4fb9674"));
var _propTypes = _interopRequireDefault(require("918d31ae9f0943bb"));
var _styles = require("7f84bd1b5e739070");
var _system = require("b7651ccc60b47f96");
var _refType = _interopRequireDefault(require("711bee2e89dfd7a1"));
var _composeClasses = _interopRequireDefault(require("28c302eb94f9c780"));
var _pickersFilledInputClasses = require("79007597b9dc493e");
var _PickersInputBase = require("61a0a7b71b4a6761");
var _PickersInputBase2 = require("1e71bb7bdd97629b");
var _usePickerTextFieldOwnerState = require("25ee40cfd64a95d2");
var _jsxRuntime = require("39f30db50d1e515c");
const _excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "hiddenLabel",
    "classes"
];
const PickersFilledInputRoot = (0, _styles.styled)(_PickersInputBase2.PickersInputBaseRoot, {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _system.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${_pickersFilledInputClasses.pickersFilledInputClasses.focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${_pickersFilledInputClasses.pickersFilledInputClasses.disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${_pickersFilledInputClasses.pickersFilledInputClasses.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${_pickersFilledInputClasses.pickersFilledInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${_pickersFilledInputClasses.pickersFilledInputClasses.disabled}, .${_pickersFilledInputClasses.pickersFilledInputClasses.error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${_pickersFilledInputClasses.pickersFilledInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: {
                    hasStartAdornment: true
                },
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: {
                    hasEndAdornment: true
                },
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const PickersFilledSectionsContainer = (0, _styles.styled)(_PickersInputBase2.PickersInputBaseSectionsContainer, {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    shouldForwardProp: (prop)=>(0, _system.shouldForwardProp)(prop) && prop !== 'hiddenLabel'
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: {
                hasStartAdornment: true
            },
            style: {
                paddingLeft: 0
            }
        },
        {
            props: {
                hasEndAdornment: true
            },
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                inputSize: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _pickersFilledInputClasses.getPickersFilledInputUtilityClass, classes);
    return (0, _extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const PickersFilledInput = exports.PickersFilledInput = /*#__PURE__*/ React.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label, disableUnderline = false, hiddenLabel = false, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const pickerTextFieldOwnerState = (0, _usePickerTextFieldOwnerState.usePickerTextFieldOwnerState)();
    const ownerState = (0, _extends2.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersInputBase.PickersInputBase, (0, _extends2.default)({
        slots: {
            root: PickersFilledInputRoot,
            input: PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline
            },
            input: {
                hiddenLabel
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref,
        ownerState: ownerState
    }));
});
PickersFilledInput.muiName = 'Input';

},{"f01b7a5e80ce39e2":"9snJq","dc77577741fbf1ae":"5RcSx","d9f0b0493dab2b6b":"jeIdK","e34bc51594b38e28":"h7ttl","457421dcf4fb9674":"9njXz","918d31ae9f0943bb":"bnNSm","7f84bd1b5e739070":"c9RfU","b7651ccc60b47f96":"khGaZ","711bee2e89dfd7a1":"fAbhl","28c302eb94f9c780":"eKeIT","79007597b9dc493e":"eMS7Z","61a0a7b71b4a6761":"bNm4V","1e71bb7bdd97629b":"iAc4t","25ee40cfd64a95d2":"67IIT","39f30db50d1e515c":"1dlk8"}],"khGaZ":[function(require,module,exports,__globalThis) {
/**
 * @mui/system v7.3.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var _interopRequireWildcard = require("102b86f952687e60").default;
var _interopRequireDefault = require("6c4d0aaa3a165bdc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    experimental_sx: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    GlobalStyles: true,
    borders: true,
    breakpoints: true,
    handleBreakpoints: true,
    mergeBreakpointsInOrder: true,
    unstable_resolveBreakpointValues: true,
    cssContainerQueries: true,
    compose: true,
    display: true,
    flexbox: true,
    grid: true,
    palette: true,
    positions: true,
    shadows: true,
    sizing: true,
    spacing: true,
    style: true,
    getPath: true,
    getStyleValue: true,
    typography: true,
    unstable_styleFunctionSx: true,
    unstable_createStyleFunctionSx: true,
    unstable_extendSxProp: true,
    unstable_defaultSxConfig: true,
    unstable_getThemeValue: true,
    Box: true,
    createBox: true,
    createStyled: true,
    styled: true,
    createTheme: true,
    createBreakpoints: true,
    createSpacing: true,
    shape: true,
    useThemeProps: true,
    getThemeProps: true,
    useTheme: true,
    useThemeWithoutDefault: true,
    useMediaQuery: true,
    ThemeProvider: true,
    unstable_memoTheme: true,
    unstable_createCssVarsProvider: true,
    unstable_createGetCssVar: true,
    unstable_cssVarsParser: true,
    unstable_prepareCssVars: true,
    unstable_createCssVarsTheme: true,
    responsivePropType: true,
    RtlProvider: true,
    createContainer: true,
    Container: true,
    Grid: true,
    Stack: true
};
Object.defineProperty(exports, "Box", {
    enumerable: true,
    get: function() {
        return _Box.default;
    }
});
Object.defineProperty(exports, "Container", {
    enumerable: true,
    get: function() {
        return _Container.default;
    }
});
Object.defineProperty(exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return _GlobalStyles.default;
    }
});
Object.defineProperty(exports, "Grid", {
    enumerable: true,
    get: function() {
        return _Grid.default;
    }
});
Object.defineProperty(exports, "RtlProvider", {
    enumerable: true,
    get: function() {
        return _RtlProvider.default;
    }
});
Object.defineProperty(exports, "Stack", {
    enumerable: true,
    get: function() {
        return _Stack.default;
    }
});
Object.defineProperty(exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return _styledEngine.StyledEngineProvider;
    }
});
Object.defineProperty(exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return _ThemeProvider.default;
    }
});
Object.defineProperty(exports, "borders", {
    enumerable: true,
    get: function() {
        return _borders.default;
    }
});
Object.defineProperty(exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return _breakpoints.default;
    }
});
Object.defineProperty(exports, "compose", {
    enumerable: true,
    get: function() {
        return _compose.default;
    }
});
Object.defineProperty(exports, "createBox", {
    enumerable: true,
    get: function() {
        return _createBox.default;
    }
});
Object.defineProperty(exports, "createBreakpoints", {
    enumerable: true,
    get: function() {
        return _createBreakpoints.default;
    }
});
Object.defineProperty(exports, "createContainer", {
    enumerable: true,
    get: function() {
        return _createContainer.default;
    }
});
Object.defineProperty(exports, "createSpacing", {
    enumerable: true,
    get: function() {
        return _createSpacing.default;
    }
});
Object.defineProperty(exports, "createStyled", {
    enumerable: true,
    get: function() {
        return _createStyled.default;
    }
});
Object.defineProperty(exports, "createTheme", {
    enumerable: true,
    get: function() {
        return _createTheme.default;
    }
});
Object.defineProperty(exports, "css", {
    enumerable: true,
    get: function() {
        return _styledEngine.css;
    }
});
Object.defineProperty(exports, "cssContainerQueries", {
    enumerable: true,
    get: function() {
        return _cssContainerQueries.default;
    }
});
Object.defineProperty(exports, "display", {
    enumerable: true,
    get: function() {
        return _display.default;
    }
});
exports.experimental_sx = experimental_sx;
Object.defineProperty(exports, "flexbox", {
    enumerable: true,
    get: function() {
        return _flexbox.default;
    }
});
Object.defineProperty(exports, "getPath", {
    enumerable: true,
    get: function() {
        return _style.getPath;
    }
});
Object.defineProperty(exports, "getStyleValue", {
    enumerable: true,
    get: function() {
        return _style.getStyleValue;
    }
});
Object.defineProperty(exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return _useThemeProps.getThemeProps;
    }
});
Object.defineProperty(exports, "grid", {
    enumerable: true,
    get: function() {
        return _cssGrid.default;
    }
});
Object.defineProperty(exports, "handleBreakpoints", {
    enumerable: true,
    get: function() {
        return _breakpoints.handleBreakpoints;
    }
});
Object.defineProperty(exports, "keyframes", {
    enumerable: true,
    get: function() {
        return _styledEngine.keyframes;
    }
});
Object.defineProperty(exports, "mergeBreakpointsInOrder", {
    enumerable: true,
    get: function() {
        return _breakpoints.mergeBreakpointsInOrder;
    }
});
Object.defineProperty(exports, "palette", {
    enumerable: true,
    get: function() {
        return _palette.default;
    }
});
Object.defineProperty(exports, "positions", {
    enumerable: true,
    get: function() {
        return _positions.default;
    }
});
Object.defineProperty(exports, "responsivePropType", {
    enumerable: true,
    get: function() {
        return _responsivePropType.default;
    }
});
Object.defineProperty(exports, "shadows", {
    enumerable: true,
    get: function() {
        return _shadows.default;
    }
});
Object.defineProperty(exports, "shape", {
    enumerable: true,
    get: function() {
        return _shape.default;
    }
});
Object.defineProperty(exports, "sizing", {
    enumerable: true,
    get: function() {
        return _sizing.default;
    }
});
Object.defineProperty(exports, "spacing", {
    enumerable: true,
    get: function() {
        return _spacing.default;
    }
});
Object.defineProperty(exports, "style", {
    enumerable: true,
    get: function() {
        return _style.default;
    }
});
Object.defineProperty(exports, "styled", {
    enumerable: true,
    get: function() {
        return _styled.default;
    }
});
Object.defineProperty(exports, "typography", {
    enumerable: true,
    get: function() {
        return _typography.default;
    }
});
Object.defineProperty(exports, "unstable_createCssVarsProvider", {
    enumerable: true,
    get: function() {
        return _createCssVarsProvider.default;
    }
});
Object.defineProperty(exports, "unstable_createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return _createCssVarsTheme.default;
    }
});
Object.defineProperty(exports, "unstable_createGetCssVar", {
    enumerable: true,
    get: function() {
        return _createGetCssVar.default;
    }
});
Object.defineProperty(exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(exports, "unstable_cssVarsParser", {
    enumerable: true,
    get: function() {
        return _cssVarsParser.default;
    }
});
Object.defineProperty(exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.unstable_defaultSxConfig;
    }
});
Object.defineProperty(exports, "unstable_extendSxProp", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.extendSxProp;
    }
});
Object.defineProperty(exports, "unstable_getThemeValue", {
    enumerable: true,
    get: function() {
        return _getThemeValue.default;
    }
});
Object.defineProperty(exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return _memoTheme.default;
    }
});
Object.defineProperty(exports, "unstable_prepareCssVars", {
    enumerable: true,
    get: function() {
        return _prepareCssVars.default;
    }
});
Object.defineProperty(exports, "unstable_resolveBreakpointValues", {
    enumerable: true,
    get: function() {
        return _breakpoints.resolveBreakpointValues;
    }
});
Object.defineProperty(exports, "unstable_styleFunctionSx", {
    enumerable: true,
    get: function() {
        return _styleFunctionSx.default;
    }
});
Object.defineProperty(exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return _useMediaQuery.default;
    }
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
Object.defineProperty(exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return _useThemeProps.default;
    }
});
Object.defineProperty(exports, "useThemeWithoutDefault", {
    enumerable: true,
    get: function() {
        return _useThemeWithoutDefault.default;
    }
});
var _formatMuiErrorMessage = _interopRequireDefault(require("627da9371c97ee1a"));
var _styledEngine = require("d99ba328629ba91f");
var _GlobalStyles = _interopRequireDefault(require("fb7688224c7f8b08"));
var _borders = _interopRequireWildcard(require("602988851e3fc13e"));
Object.keys(_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _borders[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _borders[key];
        }
    });
});
var _breakpoints = _interopRequireWildcard(require("e85655a8dcc2bcb8"));
var _cssContainerQueries = _interopRequireDefault(require("a30273ccd5f8b056"));
var _compose = _interopRequireDefault(require("8f2fc6d38b99e604"));
var _display = _interopRequireDefault(require("fe7ccaf24d573d22"));
var _flexbox = _interopRequireWildcard(require("5953f25531803738"));
Object.keys(_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _flexbox[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _flexbox[key];
        }
    });
});
var _cssGrid = _interopRequireWildcard(require("10221ef911a299ca"));
Object.keys(_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _cssGrid[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _cssGrid[key];
        }
    });
});
var _palette = _interopRequireWildcard(require("9f92ac7d8495b68a"));
Object.keys(_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _palette[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _palette[key];
        }
    });
});
var _positions = _interopRequireWildcard(require("a89cc387d208e86f"));
Object.keys(_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _positions[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _positions[key];
        }
    });
});
var _shadows = _interopRequireDefault(require("ad9444637cd2dbc9"));
var _sizing = _interopRequireWildcard(require("caa40d8fd2199506"));
Object.keys(_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _sizing[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _sizing[key];
        }
    });
});
var _spacing = _interopRequireWildcard(require("1f2fb3e768ddef5c"));
Object.keys(_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _spacing[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _spacing[key];
        }
    });
});
var _style = _interopRequireWildcard(require("258cb6b50775d39b"));
var _typography = _interopRequireWildcard(require("7b7d2c559787d871"));
Object.keys(_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _typography[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typography[key];
        }
    });
});
var _styleFunctionSx = _interopRequireWildcard(require("b0995038b865a0eb"));
var _getThemeValue = _interopRequireDefault(require("12999ce84eb46cf6"));
var _Box = _interopRequireWildcard(require("832159ae808124b8"));
Object.keys(_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Box[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Box[key];
        }
    });
});
var _createBox = _interopRequireDefault(require("a8a7b279a0827453"));
var _createStyled = _interopRequireWildcard(require("e58471d2b929f563"));
Object.keys(_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _createStyled[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _createStyled[key];
        }
    });
});
var _styled = _interopRequireDefault(require("9fd5d3d921e201bc"));
var _createTheme = _interopRequireDefault(require("75ec2fd591cecc45"));
var _createBreakpoints = _interopRequireDefault(require("aa956b577fb00c2c"));
var _createSpacing = _interopRequireDefault(require("f1d9da2323943d5e"));
var _shape = _interopRequireDefault(require("baf264a9b42cf616"));
var _useThemeProps = _interopRequireWildcard(require("ea77d88c688cbdbd"));
var _useTheme = _interopRequireDefault(require("62fde6accf00d754"));
var _useThemeWithoutDefault = _interopRequireDefault(require("f811add6c13855b1"));
var _useMediaQuery = _interopRequireDefault(require("758284cd31e49aed"));
var _colorManipulator = require("f8a3a57b17a73e4c");
Object.keys(_colorManipulator).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _colorManipulator[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _colorManipulator[key];
        }
    });
});
var _ThemeProvider = _interopRequireDefault(require("1bf38f2ae6c91a63"));
var _memoTheme = _interopRequireDefault(require("c770b375bcc3dd6d"));
var _createCssVarsProvider = _interopRequireDefault(require("1e0990bcf2648d33"));
var _createGetCssVar = _interopRequireDefault(require("23d0e96e037a2c15"));
var _cssVarsParser = _interopRequireDefault(require("7d21258ec1512933"));
var _prepareCssVars = _interopRequireDefault(require("8490ced172fc8732"));
var _createCssVarsTheme = _interopRequireDefault(require("5afadbcbda190342"));
var _responsivePropType = _interopRequireDefault(require("7c177df5c1dc3896"));
var _RtlProvider = _interopRequireWildcard(require("d399c56ac31bf83c"));
Object.keys(_RtlProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _RtlProvider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _RtlProvider[key];
        }
    });
});
var _version = require("6e1605728938e302");
Object.keys(_version).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _version[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _version[key];
        }
    });
});
var _createContainer = _interopRequireDefault(require("5046dec22e1a11cf"));
var _Container = _interopRequireWildcard(require("c0fc1fbe89a0b291"));
Object.keys(_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Container[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Container[key];
        }
    });
});
var _Grid = _interopRequireDefault(require("be911fed5fcec4a6"));
var _Grid2 = require("653fa54460c88831");
Object.keys(_Grid2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Grid2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Grid2[key];
        }
    });
});
var _Stack = _interopRequireDefault(require("cbeff4169d7e7a03"));
var _Stack2 = require("eea863793685af91");
Object.keys(_Stack2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _Stack2[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _Stack2[key];
        }
    });
});
// TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function experimental_sx() {
    throw new Error((0, _formatMuiErrorMessage.default)(19));
} /** ----------------- */  /** Layout components */ 

},{"102b86f952687e60":"jIxH8","6c4d0aaa3a165bdc":"74mZ8","627da9371c97ee1a":"26TdG","d99ba328629ba91f":"2KtHf","fb7688224c7f8b08":"4PTlz","602988851e3fc13e":"afjq7","e85655a8dcc2bcb8":"1dc0z","a30273ccd5f8b056":"9nycZ","8f2fc6d38b99e604":"cHtKH","fe7ccaf24d573d22":"4tJqw","5953f25531803738":"5k4ER","10221ef911a299ca":"3nf7W","9f92ac7d8495b68a":"cHnmn","a89cc387d208e86f":"hlaxe","ad9444637cd2dbc9":"3QRkx","caa40d8fd2199506":"7bMrz","1f2fb3e768ddef5c":"3PKpA","258cb6b50775d39b":"fiOnV","7b7d2c559787d871":"7rx94","b0995038b865a0eb":"e1roB","12999ce84eb46cf6":"8Gu7V","832159ae808124b8":"5Ky5l","a8a7b279a0827453":"aCzrA","e58471d2b929f563":"6ySdS","9fd5d3d921e201bc":"6Au1X","75ec2fd591cecc45":"lBucb","aa956b577fb00c2c":"cQVkp","f1d9da2323943d5e":"3KIEP","baf264a9b42cf616":"kAWBz","ea77d88c688cbdbd":"tiL16","62fde6accf00d754":"jem9R","f811add6c13855b1":"f7Z9J","758284cd31e49aed":"epnHo","f8a3a57b17a73e4c":"hTYBL","1bf38f2ae6c91a63":"7jEDU","c770b375bcc3dd6d":"8QYp7","1e0990bcf2648d33":"c7nFK","23d0e96e037a2c15":"1uRGE","7d21258ec1512933":"jM4Ep","8490ced172fc8732":"dQWqG","5afadbcbda190342":"fGQiW","7c177df5c1dc3896":"bqofx","d399c56ac31bf83c":"ck9Pb","6e1605728938e302":"1exbg","5046dec22e1a11cf":"ibiMS","c0fc1fbe89a0b291":"5uJES","be911fed5fcec4a6":"5IPqD","653fa54460c88831":"QCdeK","cbeff4169d7e7a03":"1gAzA","eea863793685af91":"3PEFz"}],"4PTlz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("da5508d1e8eef709").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _GlobalStyles.default;
    }
});
var _GlobalStyles = _interopRequireWildcard(require("95973170f4d0ddfe"));
Object.keys(_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _GlobalStyles[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _GlobalStyles[key];
        }
    });
});

},{"da5508d1e8eef709":"jIxH8","95973170f4d0ddfe":"hyky9"}],"hyky9":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("77afae777a659b72").default;
var _interopRequireWildcard = require("ae76aa91b0dfd56").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("cbe59a51ccc01abb"));
var _propTypes = _interopRequireDefault(require("32df667a671853e5"));
var _styledEngine = require("b85e749d33a9a4a9");
var _useTheme = _interopRequireDefault(require("bedf33f24d8783d4"));
var _jsxRuntime = require("3f70e754a8d658d0");
function wrapGlobalLayer(styles) {
    const serialized = (0, _styledEngine.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function GlobalStyles({ styles, themeId, defaultTheme = {} }) {
    const upperTheme = (0, _useTheme.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return wrapGlobalLayer(styleArg(resolvedTheme));
            return wrapGlobalLayer(styleArg);
        });
        else globalStyles = wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styledEngine.GlobalStyles, {
        styles: globalStyles
    });
}
var _default = exports.default = GlobalStyles;

},{"77afae777a659b72":"74mZ8","ae76aa91b0dfd56":"jIxH8","cbe59a51ccc01abb":"9njXz","32df667a671853e5":"bnNSm","b85e749d33a9a4a9":"2KtHf","bedf33f24d8783d4":"jem9R","3f70e754a8d658d0":"1dlk8"}],"jem9R":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a2c0d6dcb9e05d5e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
var _useTheme = _interopRequireWildcard(require("1e8d72b9c5b75a36"));
Object.keys(_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useTheme[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useTheme[key];
        }
    });
});

},{"a2c0d6dcb9e05d5e":"jIxH8","1e8d72b9c5b75a36":"1MgoD"}],"1MgoD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("56d9c0ef8420c115").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.systemDefaultTheme = exports.default = void 0;
var _createTheme = _interopRequireDefault(require("828191d9ac14be9d"));
var _useThemeWithoutDefault = _interopRequireDefault(require("844ae56d568ac095"));
const systemDefaultTheme = exports.systemDefaultTheme = (0, _createTheme.default)();
function useTheme(defaultTheme = systemDefaultTheme) {
    return (0, _useThemeWithoutDefault.default)(defaultTheme);
}
var _default = exports.default = useTheme;

},{"56d9c0ef8420c115":"74mZ8","828191d9ac14be9d":"lBucb","844ae56d568ac095":"f7Z9J"}],"f7Z9J":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("22da61490d6d52e6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useThemeWithoutDefault.default;
    }
});
var _useThemeWithoutDefault = _interopRequireDefault(require("f31bbf1bc32a60ae"));

},{"22da61490d6d52e6":"74mZ8","f31bbf1bc32a60ae":"52wOa"}],"52wOa":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("cb4397c685c1a400").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("d565964b4cacfe6d"));
var _styledEngine = require("c6c07bae4e5cb0af");
function isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
    const contextTheme = React.useContext(_styledEngine.ThemeContext);
    return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var _default = exports.default = useTheme;

},{"cb4397c685c1a400":"jIxH8","d565964b4cacfe6d":"9njXz","c6c07bae4e5cb0af":"2KtHf"}],"4tJqw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f10dc070fe2fe2e2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _display.default;
    }
});
var _display = _interopRequireWildcard(require("97ef9d2ef964bb83"));
Object.keys(_display).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _display[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _display[key];
        }
    });
});

},{"f10dc070fe2fe2e2":"jIxH8","97ef9d2ef964bb83":"1DFMD"}],"1DFMD":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9bf76c9eaa64eed7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.whiteSpace = exports.visibility = exports.textOverflow = exports.overflow = exports.displayRaw = exports.displayPrint = exports.default = void 0;
var _style = _interopRequireDefault(require("5c99c98879eb407e"));
var _compose = _interopRequireDefault(require("c176e512d6fa140b"));
const displayPrint = exports.displayPrint = (0, _style.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const displayRaw = exports.displayRaw = (0, _style.default)({
    prop: 'display'
});
const overflow = exports.overflow = (0, _style.default)({
    prop: 'overflow'
});
const textOverflow = exports.textOverflow = (0, _style.default)({
    prop: 'textOverflow'
});
const visibility = exports.visibility = (0, _style.default)({
    prop: 'visibility'
});
const whiteSpace = exports.whiteSpace = (0, _style.default)({
    prop: 'whiteSpace'
});
var _default = exports.default = (0, _compose.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

},{"9bf76c9eaa64eed7":"74mZ8","5c99c98879eb407e":"fiOnV","c176e512d6fa140b":"cHtKH"}],"5k4ER":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5b8206396feeee59").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _flexbox.default;
    }
});
var _flexbox = _interopRequireWildcard(require("d112c2e5d7c0a0a5"));
Object.keys(_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _flexbox[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _flexbox[key];
        }
    });
});

},{"5b8206396feeee59":"jIxH8","d112c2e5d7c0a0a5":"avMzM"}],"avMzM":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b96c04eddaf6ee0f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.order = exports.justifySelf = exports.justifyItems = exports.justifyContent = exports.flexWrap = exports.flexShrink = exports.flexGrow = exports.flexDirection = exports.flexBasis = exports.flex = exports.default = exports.alignSelf = exports.alignItems = exports.alignContent = void 0;
var _style = _interopRequireDefault(require("4e6644ac4e3cb45e"));
var _compose = _interopRequireDefault(require("f939ecc4af124c51"));
const flexBasis = exports.flexBasis = (0, _style.default)({
    prop: 'flexBasis'
});
const flexDirection = exports.flexDirection = (0, _style.default)({
    prop: 'flexDirection'
});
const flexWrap = exports.flexWrap = (0, _style.default)({
    prop: 'flexWrap'
});
const justifyContent = exports.justifyContent = (0, _style.default)({
    prop: 'justifyContent'
});
const alignItems = exports.alignItems = (0, _style.default)({
    prop: 'alignItems'
});
const alignContent = exports.alignContent = (0, _style.default)({
    prop: 'alignContent'
});
const order = exports.order = (0, _style.default)({
    prop: 'order'
});
const flex = exports.flex = (0, _style.default)({
    prop: 'flex'
});
const flexGrow = exports.flexGrow = (0, _style.default)({
    prop: 'flexGrow'
});
const flexShrink = exports.flexShrink = (0, _style.default)({
    prop: 'flexShrink'
});
const alignSelf = exports.alignSelf = (0, _style.default)({
    prop: 'alignSelf'
});
const justifyItems = exports.justifyItems = (0, _style.default)({
    prop: 'justifyItems'
});
const justifySelf = exports.justifySelf = (0, _style.default)({
    prop: 'justifySelf'
});
const flexbox = (0, _compose.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
var _default = exports.default = flexbox;

},{"b96c04eddaf6ee0f":"74mZ8","4e6644ac4e3cb45e":"fiOnV","f939ecc4af124c51":"cHtKH"}],"hlaxe":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a704a7fca7c085c3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _positions.default;
    }
});
var _positions = _interopRequireWildcard(require("51559ab78759eb8c"));
Object.keys(_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _positions[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _positions[key];
        }
    });
});

},{"a704a7fca7c085c3":"jIxH8","51559ab78759eb8c":"3ILjS"}],"3ILjS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e7c465225129af39").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.zIndex = exports.top = exports.right = exports.position = exports.left = exports.default = exports.bottom = void 0;
var _style = _interopRequireDefault(require("2ef3cc23b0ccd68d"));
var _compose = _interopRequireDefault(require("dafb5ed74ca3ed89"));
const position = exports.position = (0, _style.default)({
    prop: 'position'
});
const zIndex = exports.zIndex = (0, _style.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const top = exports.top = (0, _style.default)({
    prop: 'top'
});
const right = exports.right = (0, _style.default)({
    prop: 'right'
});
const bottom = exports.bottom = (0, _style.default)({
    prop: 'bottom'
});
const left = exports.left = (0, _style.default)({
    prop: 'left'
});
var _default = exports.default = (0, _compose.default)(position, zIndex, top, right, bottom, left);

},{"e7c465225129af39":"74mZ8","2ef3cc23b0ccd68d":"fiOnV","dafb5ed74ca3ed89":"cHtKH"}],"3QRkx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3dafc20762df93f6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _shadows.default;
    }
});
var _shadows = _interopRequireDefault(require("78a914fa8c83b33a"));

},{"3dafc20762df93f6":"74mZ8","78a914fa8c83b33a":"a3Hsd"}],"a3Hsd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("af5dd608df9d6658").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _style = _interopRequireDefault(require("f3ab29f36dd08c77"));
const boxShadow = (0, _style.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var _default = exports.default = boxShadow;

},{"af5dd608df9d6658":"74mZ8","f3ab29f36dd08c77":"fiOnV"}],"7rx94":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("df65ad4d4a7437b2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _typography.default;
    }
});
var _typography = _interopRequireWildcard(require("cb3dd1a30b83ec9b"));
Object.keys(_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _typography[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _typography[key];
        }
    });
});

},{"df65ad4d4a7437b2":"jIxH8","cb3dd1a30b83ec9b":"dcb2j"}],"dcb2j":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6917d32863e0f960").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.typographyVariant = exports.textTransform = exports.textAlign = exports.lineHeight = exports.letterSpacing = exports.fontWeight = exports.fontStyle = exports.fontSize = exports.fontFamily = exports.default = void 0;
var _style = _interopRequireDefault(require("b8dd08e9b11a751e"));
var _compose = _interopRequireDefault(require("2711606304b3a3d8"));
const fontFamily = exports.fontFamily = (0, _style.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const fontSize = exports.fontSize = (0, _style.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const fontStyle = exports.fontStyle = (0, _style.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const fontWeight = exports.fontWeight = (0, _style.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const letterSpacing = exports.letterSpacing = (0, _style.default)({
    prop: 'letterSpacing'
});
const textTransform = exports.textTransform = (0, _style.default)({
    prop: 'textTransform'
});
const lineHeight = exports.lineHeight = (0, _style.default)({
    prop: 'lineHeight'
});
const textAlign = exports.textAlign = (0, _style.default)({
    prop: 'textAlign'
});
const typographyVariant = exports.typographyVariant = (0, _style.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const typography = (0, _compose.default)(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign, textTransform);
var _default = exports.default = typography;

},{"6917d32863e0f960":"74mZ8","b8dd08e9b11a751e":"fiOnV","2711606304b3a3d8":"cHtKH"}],"8Gu7V":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ec67f90368e75b30").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _getThemeValue.default;
    }
});
var _getThemeValue = _interopRequireWildcard(require("b9bf6aee17e4fc98"));
Object.keys(_getThemeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _getThemeValue[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _getThemeValue[key];
        }
    });
});

},{"ec67f90368e75b30":"jIxH8","b9bf6aee17e4fc98":"3wViS"}],"3wViS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1eba0fa554b4f25").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.styleFunctionMapping = exports.propToStyleFunction = exports.default = void 0;
var _borders = _interopRequireDefault(require("5c790bec951afcb8"));
var _display = _interopRequireDefault(require("8cac4be3a10f0c28"));
var _flexbox = _interopRequireDefault(require("92b300ecd3ff8236"));
var _cssGrid = _interopRequireDefault(require("35baed04f1581d51"));
var _positions = _interopRequireDefault(require("8788bbacbfbbcd53"));
var _palette = _interopRequireDefault(require("a1831c8299ddb824"));
var _shadows = _interopRequireDefault(require("9af35e9ff58b0c5f"));
var _sizing = _interopRequireDefault(require("450c2221d3b3b3e2"));
var _spacing = _interopRequireDefault(require("3d10b4dc86a083dc"));
var _typography = _interopRequireDefault(require("a069d11573c7c52b"));
const filterPropsMapping = {
    borders: _borders.default.filterProps,
    display: _display.default.filterProps,
    flexbox: _flexbox.default.filterProps,
    grid: _cssGrid.default.filterProps,
    positions: _positions.default.filterProps,
    palette: _palette.default.filterProps,
    shadows: _shadows.default.filterProps,
    sizing: _sizing.default.filterProps,
    spacing: _spacing.default.filterProps,
    typography: _typography.default.filterProps
};
const styleFunctionMapping = exports.styleFunctionMapping = {
    borders: _borders.default,
    display: _display.default,
    flexbox: _flexbox.default,
    grid: _cssGrid.default,
    positions: _positions.default,
    palette: _palette.default,
    shadows: _shadows.default,
    sizing: _sizing.default,
    spacing: _spacing.default,
    typography: _typography.default
};
const propToStyleFunction = exports.propToStyleFunction = Object.keys(filterPropsMapping).reduce((acc, styleFnName)=>{
    filterPropsMapping[styleFnName].forEach((propName)=>{
        acc[propName] = styleFunctionMapping[styleFnName];
    });
    return acc;
}, {});
function getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme
    };
    const styleFunction = propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var _default = exports.default = getThemeValue;

},{"1eba0fa554b4f25":"74mZ8","5c790bec951afcb8":"afjq7","8cac4be3a10f0c28":"4tJqw","92b300ecd3ff8236":"5k4ER","35baed04f1581d51":"3nf7W","8788bbacbfbbcd53":"hlaxe","a1831c8299ddb824":"cHnmn","9af35e9ff58b0c5f":"3QRkx","450c2221d3b3b3e2":"7bMrz","3d10b4dc86a083dc":"3PKpA","a069d11573c7c52b":"7rx94"}],"5Ky5l":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("811bf4dc557b94fd").default;
var _interopRequireDefault = require("f2adc02bc8e4b2e9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    boxClasses: true
};
Object.defineProperty(exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return _boxClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Box.default;
    }
});
var _Box = _interopRequireDefault(require("72f024adef1c2a22"));
var _boxClasses = _interopRequireWildcard(require("2720525ac8497555"));
Object.keys(_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _boxClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _boxClasses[key];
        }
    });
});

},{"811bf4dc557b94fd":"jIxH8","f2adc02bc8e4b2e9":"74mZ8","72f024adef1c2a22":"dqrCS","2720525ac8497555":"7BeQj"}],"dqrCS":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("bbefdf81b8206eb9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("76afeeecc51454f0"));
var _ClassNameGenerator = _interopRequireDefault(require("52db4392110916d1"));
var _createBox = _interopRequireDefault(require("19842583e59c4e3a"));
var _boxClasses = _interopRequireDefault(require("3622d3080fae973e"));
const Box = (0, _createBox.default)({
    defaultClassName: _boxClasses.default.root,
    generateClassName: _ClassNameGenerator.default.generate
});
var _default = exports.default = Box;

},{"bbefdf81b8206eb9":"74mZ8","76afeeecc51454f0":"bnNSm","52db4392110916d1":"fluTy","19842583e59c4e3a":"aCzrA","3622d3080fae973e":"7BeQj"}],"fluTy":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a26d9a04e727413e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ClassNameGenerator.default;
    }
});
var _ClassNameGenerator = _interopRequireDefault(require("b055ae4f7d1a1159"));

},{"a26d9a04e727413e":"74mZ8","b055ae4f7d1a1159":"9gvVC"}],"9gvVC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const defaultGenerator = (componentName)=>componentName;
const createClassNameGenerator = ()=>{
    let generate = defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = defaultGenerator;
        }
    };
};
const ClassNameGenerator = createClassNameGenerator();
var _default = exports.default = ClassNameGenerator;

},{}],"aCzrA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f245201bc811b11c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _createBox.default;
    }
});
var _createBox = _interopRequireDefault(require("8991bd08fae45be8"));

},{"f245201bc811b11c":"74mZ8","8991bd08fae45be8":"2I9gF"}],"2I9gF":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8be8ef46bbd08e7").default;
var _interopRequireWildcard = require("7a6a40ddaa1133").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createBox;
var React = _interopRequireWildcard(require("226211a044bee0e9"));
var _clsx = _interopRequireDefault(require("56a8fec17bdabae1"));
var _styledEngine = _interopRequireDefault(require("61cf4bf510092309"));
var _styleFunctionSx = _interopRequireWildcard(require("d3a191df453274bc"));
var _useTheme = _interopRequireDefault(require("3e68e06e9f2caa13"));
var _jsxRuntime = require("be783b9282183220");
function createBox(options = {}) {
    const { themeId, defaultTheme, defaultClassName = 'MuiBox-root', generateClassName } = options;
    const BoxRoot = (0, _styledEngine.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })(_styleFunctionSx.default);
    const Box = /*#__PURE__*/ React.forwardRef(function Box(inProps, ref) {
        const theme = (0, _useTheme.default)(defaultTheme);
        const { className, component = 'div', ...other } = (0, _styleFunctionSx.extendSxProp)(inProps);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, _clsx.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

},{"8be8ef46bbd08e7":"74mZ8","7a6a40ddaa1133":"jIxH8","226211a044bee0e9":"9njXz","56a8fec17bdabae1":"5pYiP","61cf4bf510092309":"2KtHf","d3a191df453274bc":"e1roB","3e68e06e9f2caa13":"jem9R","be783b9282183220":"1dlk8"}],"5pYiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7BeQj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f55c083b6d5c2be6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _generateUtilityClasses = _interopRequireDefault(require("7a4feef9a89787ec"));
const boxClasses = (0, _generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var _default = exports.default = boxClasses;

},{"f55c083b6d5c2be6":"74mZ8","7a4feef9a89787ec":"5bmvW"}],"5bmvW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cfedf4b0f54b149b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _generateUtilityClasses.default;
    }
});
var _generateUtilityClasses = _interopRequireDefault(require("a52474bef7ac4356"));

},{"cfedf4b0f54b149b":"74mZ8","a52474bef7ac4356":"1I3SO"}],"1I3SO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e4f7037320f8b839").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = generateUtilityClasses;
var _generateUtilityClass = _interopRequireDefault(require("4b77ce0f0d0ab8ba"));
function generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, _generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

},{"e4f7037320f8b839":"74mZ8","4b77ce0f0d0ab8ba":"hwfl5"}],"hwfl5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("6cd4a225def41c15").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _generateUtilityClass.default;
    }
});
var _generateUtilityClass = _interopRequireWildcard(require("20d9486b0c0b8741"));
Object.keys(_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _generateUtilityClass[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _generateUtilityClass[key];
        }
    });
});

},{"6cd4a225def41c15":"jIxH8","20d9486b0c0b8741":"4QFRz"}],"4QFRz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a2693a490abfc138").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = generateUtilityClass;
exports.globalStateClasses = void 0;
exports.isGlobalState = isGlobalState;
var _ClassNameGenerator = _interopRequireDefault(require("9274b75e5e89b0a7"));
const globalStateClasses = exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function isGlobalState(slot) {
    return globalStateClasses[slot] !== undefined;
}

},{"a2693a490abfc138":"74mZ8","9274b75e5e89b0a7":"fluTy"}],"6Au1X":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5b81c707cf9e80a1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _styled.default;
    }
});
var _styled = _interopRequireDefault(require("a6441e56f2b9b5c0"));

},{"5b81c707cf9e80a1":"74mZ8","a6441e56f2b9b5c0":"8dPdU"}],"8dPdU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("88451216d1e72252").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createStyled = _interopRequireDefault(require("648c341cfc6b682"));
const styled = (0, _createStyled.default)();
var _default = exports.default = styled;

},{"88451216d1e72252":"74mZ8","648c341cfc6b682":"6ySdS"}],"tiL16":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1c909ce09236dc56").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useThemeProps.default;
    }
});
Object.defineProperty(exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return _getThemeProps.default;
    }
});
var _useThemeProps = _interopRequireDefault(require("9ae2857601959f0a"));
var _getThemeProps = _interopRequireDefault(require("a3e4fe27a5e6a7f4"));

},{"1c909ce09236dc56":"74mZ8","9ae2857601959f0a":"gXXn1","a3e4fe27a5e6a7f4":"gRUxU"}],"gXXn1":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("267804c15a5e3f7a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useThemeProps;
var _getThemeProps = _interopRequireDefault(require("dc2d62e4900991ca"));
var _useTheme = _interopRequireDefault(require("ebc6b593badac40c"));
function useThemeProps({ props, name, defaultTheme, themeId }) {
    let theme = (0, _useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, _getThemeProps.default)({
        theme,
        name,
        props
    });
}

},{"267804c15a5e3f7a":"74mZ8","dc2d62e4900991ca":"gRUxU","ebc6b593badac40c":"jem9R"}],"gRUxU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("76bf39b56103a8b1").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getThemeProps;
var _resolveProps = _interopRequireDefault(require("a769613b6a670c93"));
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, _resolveProps.default)(theme.components[name].defaultProps, props);
}

},{"76bf39b56103a8b1":"74mZ8","a769613b6a670c93":"hsSA1"}],"hsSA1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("55857f100c703281").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _resolveProps.default;
    }
});
var _resolveProps = _interopRequireDefault(require("e2fcd39866baaf7c"));

},{"55857f100c703281":"74mZ8","e2fcd39866baaf7c":"jAcVU"}],"jAcVU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("87615cd3816197b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = resolveProps;
var _clsx = _interopRequireDefault(require("47ef1d9fa9a04e25"));
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */ function resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, _clsx.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

},{"87615cd3816197b":"74mZ8","47ef1d9fa9a04e25":"5pYiP"}],"epnHo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("78998556127ac12a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useMediaQuery.default;
    }
});
var _useMediaQuery = _interopRequireWildcard(require("99a218613f3a2f91"));
Object.keys(_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _useMediaQuery[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _useMediaQuery[key];
        }
    });
});

},{"78998556127ac12a":"jIxH8","99a218613f3a2f91":"bfOI5"}],"bfOI5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b4c32fb802515b3b").default;
var _interopRequireWildcard = require("8e3005a8a53e6cc8").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.unstable_createUseMediaQuery = unstable_createUseMediaQuery;
var React = _interopRequireWildcard(require("5a8463084267210b"));
var _useEnhancedEffect = _interopRequireDefault(require("6a2bcf140a4dd33a"));
var _useThemeProps = require("c2bc66fdb0c07b7");
var _useThemeWithoutDefault = _interopRequireDefault(require("281c0e6b8a4c918b"));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, _useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const safeReact = {
    ...React
};
const maybeReactUseSyncExternalStore = safeReact.useSyncExternalStore;
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createUseMediaQuery(params = {}) {
    const { themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, _useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches = false, matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia = null, noSsr = false } = (0, _useThemeProps.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const useMediaQuery = unstable_createUseMediaQuery();
var _default = exports.default = useMediaQuery;

},{"b4c32fb802515b3b":"74mZ8","8e3005a8a53e6cc8":"jIxH8","5a8463084267210b":"9njXz","6a2bcf140a4dd33a":"Yvscf","c2bc66fdb0c07b7":"tiL16","281c0e6b8a4c918b":"f7Z9J"}],"Yvscf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f0b278cfb2726c9a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useEnhancedEffect.default;
    }
});
var _useEnhancedEffect = _interopRequireDefault(require("76a36a6bfc51cefe"));

},{"f0b278cfb2726c9a":"74mZ8","76a36a6bfc51cefe":"fp8Zo"}],"fp8Zo":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("a119db8a000e687").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("ae200aa69dcdd30a"));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var _default = exports.default = useEnhancedEffect;

},{"a119db8a000e687":"jIxH8","ae200aa69dcdd30a":"9njXz"}],"hTYBL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _colorManipulator = require("310dda5cb8c2fab9");
Object.keys(_colorManipulator).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _colorManipulator[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _colorManipulator[key];
        }
    });
});

},{"310dda5cb8c2fab9":"ioMKX"}],"ioMKX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a54f4eea3def311f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.alpha = alpha;
exports.blend = blend;
exports.colorChannel = void 0;
exports.darken = darken;
exports.decomposeColor = decomposeColor;
exports.emphasize = emphasize;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.hexToRgb = hexToRgb;
exports.hslToRgb = hslToRgb;
exports.lighten = lighten;
exports.private_safeAlpha = private_safeAlpha;
exports.private_safeColorChannel = void 0;
exports.private_safeDarken = private_safeDarken;
exports.private_safeEmphasize = private_safeEmphasize;
exports.private_safeLighten = private_safeLighten;
exports.recomposeColor = recomposeColor;
exports.rgbToHex = rgbToHex;
var _formatMuiErrorMessage = _interopRequireDefault(require("47a311b376171898"));
var _clamp = _interopRequireDefault(require("dd0db14c48cc1331"));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function clampWrapper(value, min = 0, max = 1) {
    return (0, _clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return decomposeColor(hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, _formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, _formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type,
        values,
        colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const colorChannel = (color)=>{
    const decomposedColor = decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
exports.colorChannel = colorChannel;
const private_safeColorChannel = (color, warning)=>{
    try {
        return colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ exports.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values } = decomposeColor(color);
    return `#${values.map((n, i)=>intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function hslToRgb(color) {
    color = decomposeColor(color);
    const { values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return recomposeColor({
        type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function getLuminance(color) {
    color = decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function getContrastRatio(foreground, background) {
    const lumA = getLuminance(foreground);
    const lumB = getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function alpha(color, value) {
    color = decomposeColor(color);
    value = clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
    try {
        return alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
    try {
        return darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
    try {
        return lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function emphasize(color, coefficient = 0.15) {
    return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
    try {
        return emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = decomposeColor(background);
    const overlayColor = decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

},{"a54f4eea3def311f":"74mZ8","47a311b376171898":"26TdG","dd0db14c48cc1331":"1SZ3r"}],"1SZ3r":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3227bf55bb4b6609").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _clamp.default;
    }
});
var _clamp = _interopRequireDefault(require("fc031e3a75303da"));

},{"3227bf55bb4b6609":"74mZ8","fc031e3a75303da":"fYeTM"}],"fYeTM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var _default = exports.default = clamp;

},{}],"7jEDU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9642812f9fa3db8d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ThemeProvider.default;
    }
});
var _ThemeProvider = _interopRequireDefault(require("7da009a5ef328225"));

},{"9642812f9fa3db8d":"74mZ8","7da009a5ef328225":"7jyfu"}],"7jyfu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2f0cdb539014f0d4").default;
var _interopRequireWildcard = require("945ee145cb6db818").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("f66bdf805eb6a174"));
var _propTypes = _interopRequireDefault(require("a7dc9850114c1c07"));
var _privateTheming = require("d2b933a117fa27b3");
var _exactProp = _interopRequireDefault(require("daa2a36d2d0ccf09"));
var _styledEngine = require("617d81d7a7442614");
var _useThemeWithoutDefault = _interopRequireDefault(require("44c8f2f530ac38e9"));
var _RtlProvider = _interopRequireDefault(require("31aada5253a2fae2"));
var _DefaultPropsProvider = _interopRequireDefault(require("c65b0fe1e1532163"));
var _useLayerOrder = _interopRequireDefault(require("a6caedfa1fde25be"));
var _jsxRuntime = require("d40852f22693d112");
const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function ThemeProvider(props) {
    const { children, theme: localTheme, themeId } = props;
    const upperTheme = (0, _useThemeWithoutDefault.default)(EMPTY_THEME);
    const upperPrivateTheme = (0, _privateTheming.useTheme)() || EMPTY_THEME;
    const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, _useLayerOrder.default)(engineTheme);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_privateTheming.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styledEngine.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var _default = exports.default = ThemeProvider;

},{"2f0cdb539014f0d4":"74mZ8","945ee145cb6db818":"jIxH8","f66bdf805eb6a174":"9njXz","a7dc9850114c1c07":"bnNSm","d2b933a117fa27b3":"iTVx9","daa2a36d2d0ccf09":"bofLM","617d81d7a7442614":"2KtHf","44c8f2f530ac38e9":"f7Z9J","31aada5253a2fae2":"ck9Pb","c65b0fe1e1532163":"aF5dK","a6caedfa1fde25be":"e7wh2","d40852f22693d112":"1dlk8"}],"iTVx9":[function(require,module,exports,__globalThis) {
/**
 * @mui/private-theming v7.3.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var _interopRequireDefault = require("2d846935ff3cfc52").default;
var _interopRequireWildcard = require("4bf90d097e035de5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    ThemeProvider: true,
    useTheme: true
};
Object.defineProperty(exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return _ThemeProvider.default;
    }
});
Object.defineProperty(exports, "useTheme", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
var _ThemeProvider = _interopRequireWildcard(require("a95067bce497518e"));
Object.keys(_ThemeProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _ThemeProvider[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _ThemeProvider[key];
        }
    });
});
var _useTheme = _interopRequireDefault(require("3c9dfc74ed6865f0"));

},{"2d846935ff3cfc52":"74mZ8","4bf90d097e035de5":"jIxH8","a95067bce497518e":"3Zk8X","3c9dfc74ed6865f0":"c1FEd"}],"3Zk8X":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1e5bc4f1d5580c73").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _ThemeProvider.default;
    }
});
Object.defineProperty(exports, "unstable_nested", {
    enumerable: true,
    get: function() {
        return _nested.default;
    }
});
var _ThemeProvider = _interopRequireDefault(require("57644e87ed84bebe"));
var _nested = _interopRequireDefault(require("2c38eafce7678d9"));

},{"1e5bc4f1d5580c73":"74mZ8","57644e87ed84bebe":"dMOxz","2c38eafce7678d9":"7WQsx"}],"dMOxz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("148ead47c4168070").default;
var _interopRequireWildcard = require("86e5dab25aa86994").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("68771544e4ff4be3"));
var _propTypes = _interopRequireDefault(require("58472f58d78d5ed7"));
var _exactProp = _interopRequireDefault(require("61310242ff280634"));
var _ThemeContext = _interopRequireDefault(require("5747b454fbf13616"));
var _useTheme = _interopRequireDefault(require("fec186adf3c34e8d"));
var _nested = _interopRequireDefault(require("4d394efa376b0727"));
var _jsxRuntime = require("5d4aa082f257adc4");
// To support composition of theme.
function mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function ThemeProvider(props) {
    const { children, theme: localTheme } = props;
    const outerTheme = (0, _useTheme.default)();
    const theme = React.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[_nested.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThemeContext.default.Provider, {
        value: theme,
        children: children
    });
}
var _default = exports.default = ThemeProvider;

},{"148ead47c4168070":"74mZ8","86e5dab25aa86994":"jIxH8","68771544e4ff4be3":"9njXz","58472f58d78d5ed7":"bnNSm","61310242ff280634":"bofLM","5747b454fbf13616":"2qhJE","fec186adf3c34e8d":"c1FEd","4d394efa376b0727":"7WQsx","5d4aa082f257adc4":"1dlk8"}],"bofLM":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ff315e216e2a9d2f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _exactProp.default;
    }
});
var _exactProp = _interopRequireDefault(require("4216339b74051ad6"));

},{"ff315e216e2a9d2f":"74mZ8","4216339b74051ad6":"2SYIX"}],"2SYIX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const specialProperty = 'exact-prop: \u200b';
function exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

},{}],"2qhJE":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("f2dd187f4e0d0518").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("459eefb390dded07"));
const ThemeContext = /*#__PURE__*/ React.createContext(null);
var _default = exports.default = ThemeContext;

},{"f2dd187f4e0d0518":"jIxH8","459eefb390dded07":"9njXz"}],"c1FEd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f3a2a66264db1b80").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useTheme.default;
    }
});
var _useTheme = _interopRequireDefault(require("c3a99b8088bb20c5"));

},{"f3a2a66264db1b80":"74mZ8","c3a99b8088bb20c5":"31Oi3"}],"31Oi3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3fc5ed0e8d427cf3").default;
var _interopRequireWildcard = require("6dfa735a32a3696b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useTheme;
var React = _interopRequireWildcard(require("3b2e1e44c5f49bd1"));
var _ThemeContext = _interopRequireDefault(require("f02ccb4a675cc01b"));
function useTheme() {
    const theme = React.useContext(_ThemeContext.default);
    return theme;
}

},{"3fc5ed0e8d427cf3":"74mZ8","6dfa735a32a3696b":"jIxH8","3b2e1e44c5f49bd1":"9njXz","f02ccb4a675cc01b":"2qhJE"}],"7WQsx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
var _default = exports.default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

},{}],"aF5dK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3212c96339aec0a5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.default;
    }
});
Object.defineProperty(exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return _DefaultPropsProvider.useDefaultProps;
    }
});
var _DefaultPropsProvider = _interopRequireWildcard(require("2efb2ac9cb89e9ff"));

},{"3212c96339aec0a5":"jIxH8","2efb2ac9cb89e9ff":"ebJGu"}],"ebJGu":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("4ce0159cb79f502a").default;
var _interopRequireWildcard = require("337ded59bbe1d92b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.useDefaultProps = useDefaultProps;
var React = _interopRequireWildcard(require("deb15c239d6dfd29"));
var _propTypes = _interopRequireDefault(require("44902174b186aff9"));
var _resolveProps = _interopRequireDefault(require("79e1b19e0eadc3aa"));
var _jsxRuntime = require("899997d347218abd");
const PropsContext = /*#__PURE__*/ React.createContext(undefined);
function DefaultPropsProvider({ value, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropsContext.Provider, {
        value: value,
        children: children
    });
}
function getThemeProps(params) {
    const { theme, name, props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, _resolveProps.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, _resolveProps.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function useDefaultProps({ props, name }) {
    const ctx = React.useContext(PropsContext);
    return getThemeProps({
        props,
        name,
        theme: {
            components: ctx
        }
    });
}
var _default = exports.default = DefaultPropsProvider;

},{"4ce0159cb79f502a":"74mZ8","337ded59bbe1d92b":"jIxH8","deb15c239d6dfd29":"9njXz","44902174b186aff9":"bnNSm","79e1b19e0eadc3aa":"hsSA1","899997d347218abd":"1dlk8"}],"e7wh2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("38035027b4b9776a").default;
var _interopRequireWildcard = require("2a476d3e88da07c0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useLayerOrder;
var React = _interopRequireWildcard(require("48e3967d70244f7f"));
var _useEnhancedEffect = _interopRequireDefault(require("99bc5f1aab1670f2"));
var _useId = _interopRequireDefault(require("6fc29e8610287ff6"));
var _GlobalStyles = _interopRequireDefault(require("d5c470a0e9678c1a"));
var _useThemeWithoutDefault = _interopRequireDefault(require("cbb0245d4ba0675d"));
var _jsxRuntime = require("94a64fc2a2fd281d");
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ function useLayerOrder(theme) {
    const upperTheme = (0, _useThemeWithoutDefault.default)();
    const id = (0, _useId.default)() || '';
    const { modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, _useEnhancedEffect.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_GlobalStyles.default, {
        styles: layerOrder
    });
}

},{"38035027b4b9776a":"74mZ8","2a476d3e88da07c0":"jIxH8","48e3967d70244f7f":"9njXz","99bc5f1aab1670f2":"Yvscf","6fc29e8610287ff6":"7ym0z","d5c470a0e9678c1a":"4PTlz","cbb0245d4ba0675d":"f7Z9J","94a64fc2a2fd281d":"1dlk8"}],"7ym0z":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6899cf510331dc86").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _useId.default;
    }
});
var _useId = _interopRequireDefault(require("b9eac1c73177fb04"));

},{"6899cf510331dc86":"74mZ8","b9eac1c73177fb04":"7aTzT"}],"7aTzT":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("410bc3129a331a76").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useId;
var React = _interopRequireWildcard(require("840a702321ebf283"));
let globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = React.useState(idOverride);
    const id = idOverride || defaultId;
    React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            globalId += 1;
            setDefaultId(`mui-${globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const safeReact = {
    ...React
};
const maybeReactUseId = safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if (maybeReactUseId !== undefined) {
        const reactId = maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return useGlobalId(idOverride);
}

},{"410bc3129a331a76":"jIxH8","840a702321ebf283":"9njXz"}],"8QYp7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("757883f998026354").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = unstable_memoTheme;
var _preprocessStyles = _interopRequireDefault(require("14cb9084a6f3b505"));
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const arg = {
    theme: undefined
};
/**
 * Memoize style function on theme.
 * Intended to be used in styled() calls that only need access to the theme.
 */ function unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            arg.theme = props.theme;
            value = (0, _preprocessStyles.default)(styleFn(arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

},{"757883f998026354":"74mZ8","14cb9084a6f3b505":"b8rSc"}],"c7nFK":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("7bb1b00c3ce16e70").default;
var _interopRequireWildcard = require("841305f8151d5761").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DISABLE_CSS_TRANSITION = void 0;
exports.default = createCssVarsProvider;
var React = _interopRequireWildcard(require("cf72253cf59a0c4a"));
var _propTypes = _interopRequireDefault(require("85ef376bdcc70ce"));
var _styledEngine = require("27fd9fa473c78e80");
var _privateTheming = require("45eb920496ba4f96");
var _useEnhancedEffect = _interopRequireDefault(require("4af90c5f9c5514e"));
var _ThemeProvider = _interopRequireDefault(require("90a7650b1c1f5bfe"));
var _InitColorSchemeScript = _interopRequireWildcard(require("c9120b7bafb1949e"));
var _useCurrentColorScheme = _interopRequireDefault(require("bdfdcd452b0a518"));
var _jsxRuntime = require("2547781ca18894b7");
const DISABLE_CSS_TRANSITION = exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function createCssVarsProvider(options) {
    const { themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = _InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = _InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme, resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ React.createContext(undefined);
    const useColorScheme = ()=>React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children, theme: themeProp, modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange = designSystemTransitionOnChange, storageManager, storageWindow = typeof window === 'undefined' ? undefined : window, documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext = false, disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender = false, noSsr } = props;
        const hasMounted = React.useRef(false);
        const upperTheme = (0, _privateTheming.useTheme)();
        const ctx = React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes = defaultColorSchemes, components = defaultComponents, cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode, systemMode, lightColorScheme, darkColorScheme, colorScheme: stateColorScheme, setColorScheme } = (0, _useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey,
            colorSchemeStorageKey,
            defaultMode,
            storageManager,
            storageWindow,
            noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components,
                colorSchemes,
                cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, _useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode(DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = React.useMemo(()=>({
                allColorSchemes,
                colorScheme,
                darkColorScheme,
                lightColorScheme,
                mode,
                setColorScheme,
                setMode: setMode,
                systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styledEngine.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, _InitColorSchemeScript.default)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme,
            defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider,
        useColorScheme,
        getInitColorSchemeScript
    };
}

},{"7bb1b00c3ce16e70":"74mZ8","841305f8151d5761":"jIxH8","cf72253cf59a0c4a":"9njXz","85ef376bdcc70ce":"bnNSm","27fd9fa473c78e80":"2KtHf","45eb920496ba4f96":"iTVx9","4af90c5f9c5514e":"Yvscf","90a7650b1c1f5bfe":"7jEDU","c9120b7bafb1949e":"8DcsU","bdfdcd452b0a518":"9ueGc","2547781ca18894b7":"1dlk8"}],"8DcsU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("ef652579247cd5d5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_MODE_STORAGE_KEY = exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = exports.DEFAULT_ATTRIBUTE = void 0;
exports.default = InitColorSchemeScript;
var React = _interopRequireWildcard(require("b07e9c9c3771fb3a"));
var _jsxRuntime = require("e1ecb68d89a38c71");
/**
 * Split this component for RSC import
 */ const DEFAULT_MODE_STORAGE_KEY = exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const DEFAULT_COLOR_SCHEME_STORAGE_KEY = exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const DEFAULT_ATTRIBUTE = exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
function InitColorSchemeScript(options) {
    const { defaultMode = 'system', defaultLightColorScheme = 'light', defaultDarkColorScheme = 'dark', modeStorageKey = DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = DEFAULT_ATTRIBUTE, colorSchemeNode = 'document.documentElement', nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}

},{"ef652579247cd5d5":"jIxH8","b07e9c9c3771fb3a":"9njXz","e1ecb68d89a38c71":"1dlk8"}],"9ueGc":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c1c40b040dbdc7d5").default;
var _interopRequireWildcard = require("6fc06eaa0ead1cc3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = useCurrentColorScheme;
exports.getColorScheme = getColorScheme;
exports.getSystemMode = getSystemMode;
var React = _interopRequireWildcard(require("a1e57bd1e615fdc1"));
var _InitColorSchemeScript = require("54b6e4d95dd85459");
var _localStorageManager = _interopRequireDefault(require("2cdbf5ace57ee651"));
function noop() {}
function getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function getColorScheme(state) {
    return processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function useCurrentColorScheme(options) {
    const { defaultMode = 'light', defaultLightColorScheme, defaultDarkColorScheme, supportedColorSchemes = [], modeStorageKey = _InitColorSchemeScript.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey = _InitColorSchemeScript.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow = typeof window === 'undefined' ? undefined : window, storageManager = _localStorageManager.default, noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: getSystemMode(initialMode),
            lightColorScheme,
            darkColorScheme
        };
    });
    const [isClient, setIsClient] = React.useState(noSsr || !isMultiSchemes);
    React.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = getColorScheme(state);
    const setMode = React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode,
        setColorScheme
    };
}

},{"c1c40b040dbdc7d5":"74mZ8","6fc06eaa0ead1cc3":"jIxH8","a1e57bd1e615fdc1":"9njXz","54b6e4d95dd85459":"8DcsU","2cdbf5ace57ee651":"zEDtK"}],"zEDtK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
function noop() {}
const localStorageManager = ({ key, storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var _default = exports.default = localStorageManager;

},{}],"1uRGE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createGetCssVar;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

},{}],"jM4Ep":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assignNestedKeys = void 0;
exports.default = cssVarsParser;
exports.walkObjectDeep = void 0;
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ exports.assignNestedKeys = assignNestedKeys;
const walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
exports.walkObjectDeep = walkObjectDeep;
const getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function cssVarsParser(theme, options) {
    const { prefix, shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css,
        vars,
        varsWithDefaults
    };
}

},{}],"dQWqG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e5e8499e17180f19").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _deepmerge = _interopRequireDefault(require("f9d07c742884f482"));
var _cssVarsParser = _interopRequireDefault(require("1bab20d6b631648d"));
function prepareCssVars(theme, parserConfig = {}) {
    const { getSelector = defaultGetSelector, disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes = {}, components, defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, _cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars, css, varsWithDefaults } = (0, _cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, _deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css,
            vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css, vars, varsWithDefaults } = (0, _cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, _deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css,
            vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, _deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars,
        generateStyleSheets
    };
}
var _default = exports.default = prepareCssVars;

},{"e5e8499e17180f19":"74mZ8","f9d07c742884f482":"jqcMl","1bab20d6b631648d":"jM4Ep"}],"fGQiW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("191401da11436a57").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _prepareCssVars = _interopRequireDefault(require("1d6d5d48f41948fe"));
var _getColorSchemeSelector = require("57053e77e0adcb4d");
var _InitColorSchemeScript = require("bd22249bfb50e2b0");
function createCssVarsTheme({ colorSchemeSelector = `[${_InitColorSchemeScript.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, _prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, _getColorSchemeSelector.createGetColorSchemeSelector)(colorSchemeSelector);
    return output;
}
var _default = exports.default = createCssVarsTheme;

},{"191401da11436a57":"74mZ8","1d6d5d48f41948fe":"dQWqG","57053e77e0adcb4d":"lCjr9","bd22249bfb50e2b0":"8DcsU"}],"lCjr9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createGetColorSchemeSelector = createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

},{}],"1exbg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.version = exports.prerelease = exports.patch = exports.minor = exports.major = exports.default = void 0;
const version = exports.version = "7.3.3";
const major = exports.major = Number("7");
const minor = exports.minor = Number("3");
const patch = exports.patch = Number("3");
const prerelease = exports.prerelease = undefined;
var _default = exports.default = version;

},{}],"ibiMS":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e2f1f50078146fd9").default;
var _interopRequireWildcard = require("b17caa0ee9cede90").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createContainer;
var React = _interopRequireWildcard(require("d773fa7879a2b44"));
var _propTypes = _interopRequireDefault(require("13fccb63947d2df6"));
var _clsx = _interopRequireDefault(require("ce0a5c59522ee521"));
var _generateUtilityClass = _interopRequireDefault(require("35af074f1c6369ab"));
var _composeClasses = _interopRequireDefault(require("6b9161e520485a3e"));
var _capitalize = _interopRequireDefault(require("11739ccada9f6591"));
var _useThemeProps = _interopRequireDefault(require("cce82e388eb28bb8"));
var _styled = _interopRequireDefault(require("ffb34ce3bc5924df"));
var _createTheme = _interopRequireDefault(require("20c00e9b01efef30"));
var _jsxRuntime = require("db58536c2183b174");
const defaultTheme = (0, _createTheme.default)();
const defaultCreateStyledComponent = (0, _styled.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, _capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const useThemePropsDefault = (inProps)=>(0, _useThemeProps.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme
    });
const useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, _generateUtilityClass.default)(componentName, slot);
    };
    const { classes, fixed, disableGutters, maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, _capitalize.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, _composeClasses.default)(slots, getContainerUtilityClass, classes);
};
function createContainer(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme, ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme, ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme, ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ React.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className, component = 'div', disableGutters = false, fixed = false, maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component,
            disableGutters,
            fixed,
            maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, _jsxRuntime.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

},{"e2f1f50078146fd9":"74mZ8","b17caa0ee9cede90":"jIxH8","d773fa7879a2b44":"9njXz","13fccb63947d2df6":"bnNSm","ce0a5c59522ee521":"5pYiP","35af074f1c6369ab":"hwfl5","6b9161e520485a3e":"6FWiW","11739ccada9f6591":"iyeHV","cce82e388eb28bb8":"tiL16","ffb34ce3bc5924df":"6Au1X","20c00e9b01efef30":"lBucb","db58536c2183b174":"1dlk8"}],"6FWiW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7f7a4fba9997664e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _composeClasses.default;
    }
});
var _composeClasses = _interopRequireDefault(require("29adbad24359023e"));

},{"7f7a4fba9997664e":"74mZ8","29adbad24359023e":"ajw1p"}],"ajw1p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

},{}],"5uJES":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("4757c19b714bac75").default;
var _interopRequireDefault = require("42ccc41b23e6c6d7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    containerClasses: true
};
Object.defineProperty(exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return _containerClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Container.default;
    }
});
var _Container = _interopRequireDefault(require("66412d5a2d4a3459"));
var _containerClasses = _interopRequireWildcard(require("2884c447133e3cc8"));
Object.keys(_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _containerClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _containerClasses[key];
        }
    });
});

},{"4757c19b714bac75":"jIxH8","42ccc41b23e6c6d7":"74mZ8","66412d5a2d4a3459":"aW5Ov","2884c447133e3cc8":"4PB1a"}],"aW5Ov":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8c77873a176b75a6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("822b01d358271b62"));
var _createContainer = _interopRequireDefault(require("3c85e7887feb4e06"));
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const Container = (0, _createContainer.default)();
var _default = exports.default = Container;

},{"8c77873a176b75a6":"74mZ8","822b01d358271b62":"bnNSm","3c85e7887feb4e06":"ibiMS"}],"4PB1a":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9aaadb3f031ee45e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getContainerUtilityClass = getContainerUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("928d43fe2f68974f"));
var _generateUtilityClass = _interopRequireDefault(require("84f3e268ab0575c5"));
function getContainerUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiContainer', slot);
}
const containerClasses = (0, _generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var _default = exports.default = containerClasses;

},{"9aaadb3f031ee45e":"74mZ8","928d43fe2f68974f":"5bmvW","84f3e268ab0575c5":"hwfl5"}],"5IPqD":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("287ce615845131d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("ebb64b749fbaa72d"));
var _createGrid = _interopRequireDefault(require("9224c13684dcebb2"));
/**
 *
 * Demos:
 *
 * - [Grid (Joy UI)](https://mui.com/joy-ui/react-grid/)
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const Grid = (0, _createGrid.default)();
var _default = exports.default = Grid;

},{"287ce615845131d":"74mZ8","ebb64b749fbaa72d":"bnNSm","9224c13684dcebb2":"h59v5"}],"h59v5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5e8b8f8a87a74dab").default;
var _interopRequireWildcard = require("d6b880b32747cf81").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createGrid;
var React = _interopRequireWildcard(require("911dcb021b794dfa"));
var _propTypes = _interopRequireDefault(require("76a2d414e957c42e"));
var _clsx = _interopRequireDefault(require("d79d9d96f05b86b6"));
var _isMuiElement = _interopRequireDefault(require("2beabd27f8564e15"));
var _generateUtilityClass = _interopRequireDefault(require("187b65d9f76a314e"));
var _composeClasses = _interopRequireDefault(require("3558609d8048437"));
var _styled = _interopRequireDefault(require("a9dabebc4684becb"));
var _useThemeProps = _interopRequireDefault(require("a7d7a905551fc2c5"));
var _useTheme = _interopRequireDefault(require("c46f3c12df3a08cb"));
var _styleFunctionSx = require("9e79e0340596ec5d");
var _createTheme = _interopRequireDefault(require("39cacc3e60ead2ea"));
var _gridGenerator = require("c51cce52cd527a14");
var _deleteLegacyGridProps = _interopRequireDefault(require("e70ffbd3cc9d022b"));
var _jsxRuntime = require("6c45d05e26051074");
const defaultTheme = (0, _createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function useThemePropsDefault(props) {
    return (0, _useThemeProps.default)({
        props,
        name: 'MuiGrid',
        defaultTheme
    });
}
function createGrid(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, useTheme = _useTheme.default, componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container, direction, spacing, wrap, size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, _gridGenerator.generateDirectionClasses)(direction),
                ...(0, _gridGenerator.generateSizeClassNames)(size),
                ...container ? (0, _gridGenerator.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, _composeClasses.default)(slots, (slot)=>(0, _generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent(_gridGenerator.generateGridColumnsStyles, _gridGenerator.generateGridColumnSpacingStyles, _gridGenerator.generateGridRowSpacingStyles, _gridGenerator.generateGridSizeStyles, _gridGenerator.generateGridDirectionStyles, _gridGenerator.generateGridStyles, _gridGenerator.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, _styleFunctionSx.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, _deleteLegacyGridProps.default)(props, theme.breakpoints);
        const { className, children, columns: columnsProp = 12, container = false, component = 'div', direction = 'row', wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level,
            columns,
            container,
            direction,
            wrap,
            spacing,
            rowSpacing,
            columnSpacing,
            size,
            offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            children: React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ React.isValidElement(child) && (0, _isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

},{"5e8b8f8a87a74dab":"74mZ8","d6b880b32747cf81":"jIxH8","911dcb021b794dfa":"9njXz","76a2d414e957c42e":"bnNSm","d79d9d96f05b86b6":"5pYiP","2beabd27f8564e15":"9A3qE","187b65d9f76a314e":"hwfl5","3558609d8048437":"6FWiW","a9dabebc4684becb":"6Au1X","a7d7a905551fc2c5":"tiL16","c46f3c12df3a08cb":"jem9R","9e79e0340596ec5d":"e1roB","39cacc3e60ead2ea":"lBucb","c51cce52cd527a14":"jPfr0","e70ffbd3cc9d022b":"de0bd","6c45d05e26051074":"1dlk8"}],"9A3qE":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e13e3267fc36b322").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _isMuiElement.default;
    }
});
var _isMuiElement = _interopRequireDefault(require("b86f9b88c16b396a"));

},{"e13e3267fc36b322":"74mZ8","b86f9b88c16b396a":"ieL2q"}],"ieL2q":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("908ff69120a8c599").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isMuiElement;
var React = _interopRequireWildcard(require("d7f638cd491e42f8"));
function isMuiElement(element, muiNames) {
    return /*#__PURE__*/ React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

},{"908ff69120a8c599":"jIxH8","d7f638cd491e42f8":"9njXz"}],"jPfr0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateSpacingClassNames = exports.generateSizeClassNames = exports.generateGridStyles = exports.generateGridSizeStyles = exports.generateGridRowSpacingStyles = exports.generateGridOffsetStyles = exports.generateGridDirectionStyles = exports.generateGridColumnsStyles = exports.generateGridColumnSpacingStyles = exports.generateDirectionClasses = void 0;
var _traverseBreakpoints = require("802c07388e1623e1");
function getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const selfColumnsVar = '--Grid-columns';
const parentColumnsVar = '--Grid-parent-columns';
const generateGridSizeStyles = ({ theme, ownerState })=>{
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${parentColumnsVar}) - (var(${parentColumnsVar}) - ${value}) * (var(${getParentSpacingVar('column')}) / var(${parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
exports.generateGridSizeStyles = generateGridSizeStyles;
const generateGridOffsetStyles = ({ theme, ownerState })=>{
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${parentColumnsVar}) + var(${getParentSpacingVar('column')}) * ${value} / var(${parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
exports.generateGridOffsetStyles = generateGridOffsetStyles;
const generateGridColumnsStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [selfColumnsVar]: 12
    };
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [selfColumnsVar]: columns,
            '> *': {
                [parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
exports.generateGridColumnsStyles = generateGridColumnsStyles;
const generateGridRowSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [getSelfSpacingVar('row')]: spacing,
            '> *': {
                [getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
exports.generateGridRowSpacingStyles = generateGridRowSpacingStyles;
const generateGridColumnSpacingStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [getSelfSpacingVar('column')]: spacing,
            '> *': {
                [getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
exports.generateGridColumnSpacingStyles = generateGridColumnSpacingStyles;
const generateGridDirectionStyles = ({ theme, ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, _traverseBreakpoints.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
exports.generateGridDirectionStyles = generateGridDirectionStyles;
const generateGridStyles = ({ ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${getSelfSpacingVar('row')}) var(${getSelfSpacingVar('column')})`
        }
    };
};
exports.generateGridStyles = generateGridStyles;
const generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
exports.generateSizeClassNames = generateSizeClassNames;
const generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
exports.generateSpacingClassNames = generateSpacingClassNames;
const generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
exports.generateDirectionClasses = generateDirectionClasses;

},{"802c07388e1623e1":"hNkTG"}],"hNkTG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.traverseBreakpoints = exports.filterBreakpointKeys = void 0;
const filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
exports.filterBreakpointKeys = filterBreakpointKeys;
const traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
exports.traverseBreakpoints = traverseBreakpoints;

},{}],"de0bd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deleteLegacyGridProps;
const getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const warnedAboutProps = [];
/**
 * Deletes the legacy Grid component props from the `props` object and warns once about them if found.
 *
 * @param {object} props The props object to remove the legacy Grid props from.
 * @param {Breakpoints} breakpoints The breakpoints object.
 */ function deleteLegacyGridProps(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}

},{}],"QCdeK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("6777b5166885b68").default;
var _interopRequireDefault = require("dc5de09531151b42").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty(exports, "createGrid", {
    enumerable: true,
    get: function() {
        return _createGrid.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Grid.default;
    }
});
Object.defineProperty(exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return _gridClasses.default;
    }
});
Object.defineProperty(exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return _gridGenerator.generateDirectionClasses;
    }
});
Object.defineProperty(exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return _gridGenerator.generateSizeClassNames;
    }
});
Object.defineProperty(exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return _gridGenerator.generateSpacingClassNames;
    }
});
Object.defineProperty(exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return _traverseBreakpoints.traverseBreakpoints;
    }
});
var _Grid = _interopRequireDefault(require("320cf288c543da5f"));
var _createGrid = _interopRequireDefault(require("413733bc76f4a166"));
var _GridProps = require("d3e7d1d8c00e22c6");
Object.keys(_GridProps).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _GridProps[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _GridProps[key];
        }
    });
});
var _gridClasses = _interopRequireWildcard(require("6b23f0b9dcef2b9e"));
Object.keys(_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _gridClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _gridClasses[key];
        }
    });
});
var _traverseBreakpoints = require("d27dd608fe81fc78");
var _gridGenerator = require("ac2be87bc31bb59a");

},{"6777b5166885b68":"jIxH8","dc5de09531151b42":"74mZ8","320cf288c543da5f":"5IPqD","413733bc76f4a166":"h59v5","d3e7d1d8c00e22c6":"4O8ds","6b23f0b9dcef2b9e":"iyfkS","d27dd608fe81fc78":"hNkTG","ac2be87bc31bb59a":"jPfr0"}],"4O8ds":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"iyfkS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cae58f89633c7240").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getGridUtilityClass = getGridUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("d8ed53e71bb866cb"));
var _generateUtilityClass = _interopRequireDefault(require("567d2557a1d7e880"));
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiGrid', slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const gridClasses = (0, _generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var _default = exports.default = gridClasses;

},{"cae58f89633c7240":"74mZ8","d8ed53e71bb866cb":"5bmvW","567d2557a1d7e880":"hwfl5"}],"1gAzA":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("14c520bfa7473ecf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("cb806e4327846fed"));
var _createStack = _interopRequireDefault(require("97d453a79dcbf311"));
/**
 *
 * Demos:
 *
 * - [Stack (Joy UI)](https://mui.com/joy-ui/react-stack/)
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const Stack = (0, _createStack.default)();
var _default = exports.default = Stack;

},{"14c520bfa7473ecf":"74mZ8","cb806e4327846fed":"bnNSm","97d453a79dcbf311":"iMG75"}],"iMG75":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("cadecf949b58aa5e").default;
var _interopRequireWildcard = require("7749fac3e7b2784d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStack;
exports.style = void 0;
var React = _interopRequireWildcard(require("fc8507c1caf13ed9"));
var _propTypes = _interopRequireDefault(require("84b92442c555ed5e"));
var _clsx = _interopRequireDefault(require("260b184dc638bfd4"));
var _deepmerge = _interopRequireDefault(require("ea811145e8eb98be"));
var _generateUtilityClass = _interopRequireDefault(require("e8a68cc0d997c6b7"));
var _composeClasses = _interopRequireDefault(require("3bfd71548eed97b1"));
var _styled = _interopRequireDefault(require("2b622a1f2f8d6cf6"));
var _useThemeProps = _interopRequireDefault(require("7bf3d002a7cc081e"));
var _styleFunctionSx = require("fb6153feb2a36eae");
var _createTheme = _interopRequireDefault(require("b750b17be5a71c5e"));
var _breakpoints = require("6d376df692cbde13");
var _spacing = require("5b915e08a9374d0e");
var _jsxRuntime = require("cc191597d1f974f5");
const defaultTheme = (0, _createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const defaultCreateStyledComponent = (0, _styled.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function useThemePropsDefault(props) {
    return (0, _useThemeProps.default)({
        props,
        name: 'MuiStack',
        defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function joinChildren(children, separator) {
    const childrenArray = React.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ React.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const style = ({ ownerState, theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, _breakpoints.handleBreakpoints)({
            theme
        }, (0, _breakpoints.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, _spacing.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, _breakpoints.resolveBreakpointValues)({
            values: ownerState.direction,
            base
        });
        const spacingValues = (0, _breakpoints.resolveBreakpointValues)({
            values: ownerState.spacing,
            base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, _spacing.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, _spacing.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, _deepmerge.default)(styles, (0, _breakpoints.handleBreakpoints)({
            theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, _breakpoints.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
exports.style = style;
function createStack(options = {}) {
    const { // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = defaultCreateStyledComponent, useThemeProps = useThemePropsDefault, componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, _composeClasses.default)(slots, (slot)=>(0, _generateUtilityClass.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent(style);
    const Stack = /*#__PURE__*/ React.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, _styleFunctionSx.extendSxProp)(themeProps); // `color` type conflicts with html color attribute.
        const { component = 'div', direction = 'column', spacing = 0, divider, children, className, useFlexGap = false, ...other } = props;
        const ownerState = {
            direction,
            spacing,
            useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, _clsx.default)(classes.root, className),
            ...other,
            children: divider ? joinChildren(children, divider) : children
        });
    });
    return Stack;
}

},{"cadecf949b58aa5e":"74mZ8","7749fac3e7b2784d":"jIxH8","fc8507c1caf13ed9":"9njXz","84b92442c555ed5e":"bnNSm","260b184dc638bfd4":"5pYiP","ea811145e8eb98be":"jqcMl","e8a68cc0d997c6b7":"hwfl5","3bfd71548eed97b1":"6FWiW","2b622a1f2f8d6cf6":"6Au1X","7bf3d002a7cc081e":"tiL16","fb6153feb2a36eae":"e1roB","b750b17be5a71c5e":"lBucb","6d376df692cbde13":"1dc0z","5b915e08a9374d0e":"3PKpA","cc191597d1f974f5":"1dlk8"}],"3PEFz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("2886f46279327a").default;
var _interopRequireDefault = require("cafb7ef1e37a5d0c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    createStack: true,
    stackClasses: true
};
Object.defineProperty(exports, "createStack", {
    enumerable: true,
    get: function() {
        return _createStack.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _Stack.default;
    }
});
Object.defineProperty(exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return _stackClasses.default;
    }
});
var _Stack = _interopRequireDefault(require("5190cd5d29cf7f27"));
var _createStack = _interopRequireDefault(require("1814d9259608881f"));
var _StackProps = require("bcc1647f0b20cedd");
Object.keys(_StackProps).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _StackProps[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _StackProps[key];
        }
    });
});
var _stackClasses = _interopRequireWildcard(require("f312e53d1d03a84"));
Object.keys(_stackClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _stackClasses[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _stackClasses[key];
        }
    });
});

},{"2886f46279327a":"jIxH8","cafb7ef1e37a5d0c":"74mZ8","5190cd5d29cf7f27":"1gAzA","1814d9259608881f":"iMG75","bcc1647f0b20cedd":"7JHGE","f312e53d1d03a84":"g53N6"}],"7JHGE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"g53N6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("41045a10ef504c55").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.getStackUtilityClass = getStackUtilityClass;
var _generateUtilityClasses = _interopRequireDefault(require("edd3e2da9a404960"));
var _generateUtilityClass = _interopRequireDefault(require("c71c2286e1aa7626"));
function getStackUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiStack', slot);
}
const stackClasses = (0, _generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var _default = exports.default = stackClasses;

},{"41045a10ef504c55":"74mZ8","edd3e2da9a404960":"5bmvW","c71c2286e1aa7626":"hwfl5"}],"eMS7Z":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5dda23d4672fe748").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersFilledInputUtilityClass = getPickersFilledInputUtilityClass;
exports.pickersFilledInputClasses = void 0;
var _extends2 = _interopRequireDefault(require("2d5b548808340f31"));
var _generateUtilityClasses = _interopRequireDefault(require("eb8a11af9555508a"));
var _generateUtilityClass = _interopRequireDefault(require("89b16bfe948991f2"));
var _PickersInputBase = require("d6e87418ccc2f546");
function getPickersFilledInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersFilledInput', slot);
}
const pickersFilledInputClasses = exports.pickersFilledInputClasses = (0, _extends2.default)({}, _PickersInputBase.pickersInputBaseClasses, (0, _generateUtilityClasses.default)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));

},{"5dda23d4672fe748":"9snJq","2d5b548808340f31":"h7ttl","eb8a11af9555508a":"2Z0QC","89b16bfe948991f2":"dtNEc","d6e87418ccc2f546":"bNm4V"}],"e7eXj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersInput", {
    enumerable: true,
    get: function() {
        return _PickersInput.PickersInput;
    }
});
Object.defineProperty(exports, "getPickersInputUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersInputClasses.getPickersInputUtilityClass;
    }
});
Object.defineProperty(exports, "pickersInputClasses", {
    enumerable: true,
    get: function() {
        return _pickersInputClasses.pickersInputClasses;
    }
});
var _PickersInput = require("b07cb004da3f1bdc");
var _pickersInputClasses = require("9f7dfc24c2caa32b");

},{"b07cb004da3f1bdc":"5eyIg","9f7dfc24c2caa32b":"ebA7x"}],"5eyIg":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b7c3d3337dc492ad").default;
var _interopRequireWildcard = require("98f0b6b5ef3e6139").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersInput = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("b36811b32ddfb44b"));
var _extends2 = _interopRequireDefault(require("96aa97eb7bdd80c4"));
var React = _interopRequireWildcard(require("ef2ae15a07537ef2"));
var _propTypes = _interopRequireDefault(require("29357577392a8307"));
var _styles = require("ffdb92dfa5a8fae8");
var _createStyled = require("bcdde3b882c01aaf");
var _refType = _interopRequireDefault(require("4b90c7338dd0a4e8"));
var _composeClasses = _interopRequireDefault(require("cd4b0c05fb4eb2b2"));
var _pickersInputClasses = require("30800f1cf7076bf0");
var _PickersInputBase = require("f0707781dafb0cae");
var _PickersInputBase2 = require("e92a74f5a363fed6");
var _usePickerTextFieldOwnerState = require("e5527d1ba6472f3e");
var _jsxRuntime = require("60352ef1fb25261d");
const _excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState",
    "classes"
];
const PickersInputRoot = (0, _styles.styled)(_PickersInputBase2.PickersInputBaseRoot, {
    name: 'MuiPickersInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'disableUnderline'
})(({ theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        inputHasUnderline: true
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    inputHasUnderline: true
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${_pickersInputClasses.pickersInputClasses.focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${_pickersInputClasses.pickersInputClasses.error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${_pickersInputClasses.pickersInputClasses.disabled}, .${_pickersInputClasses.pickersInputClasses.error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${_pickersInputClasses.pickersInputClasses.disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, _composeClasses.default)(slots, _pickersInputClasses.getPickersInputUtilityClass, classes);
    return (0, _extends2.default)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const PickersInput = exports.PickersInput = /*#__PURE__*/ React.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label, disableUnderline = false, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const pickerTextFieldOwnerState = (0, _usePickerTextFieldOwnerState.usePickerTextFieldOwnerState)();
    const ownerState = (0, _extends2.default)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersInputBase.PickersInputBase, (0, _extends2.default)({
        slots: {
            root: PickersInputRoot
        },
        slotProps: {
            root: {
                disableUnderline
            }
        }
    }, other, {
        ownerState: ownerState,
        label: label,
        classes: classes,
        ref: ref
    }));
});
PickersInput.muiName = 'Input';

},{"b7c3d3337dc492ad":"9snJq","98f0b6b5ef3e6139":"5RcSx","b36811b32ddfb44b":"jeIdK","96aa97eb7bdd80c4":"h7ttl","ef2ae15a07537ef2":"9njXz","29357577392a8307":"bnNSm","ffdb92dfa5a8fae8":"c9RfU","bcdde3b882c01aaf":"6ySdS","4b90c7338dd0a4e8":"fAbhl","cd4b0c05fb4eb2b2":"eKeIT","30800f1cf7076bf0":"ebA7x","f0707781dafb0cae":"bNm4V","e92a74f5a363fed6":"iAc4t","e5527d1ba6472f3e":"67IIT","60352ef1fb25261d":"1dlk8"}],"ebA7x":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d8b9210235d1a41c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersInputUtilityClass = getPickersInputUtilityClass;
exports.pickersInputClasses = void 0;
var _extends2 = _interopRequireDefault(require("4d0a89cab2f56707"));
var _generateUtilityClasses = _interopRequireDefault(require("9b25c2f574b79fab"));
var _generateUtilityClass = _interopRequireDefault(require("71cd22a9f7f0f592"));
var _PickersInputBase = require("cb098fc484dab334");
function getPickersInputUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersFilledInput', slot);
}
const pickersInputClasses = exports.pickersInputClasses = (0, _extends2.default)({}, _PickersInputBase.pickersInputBaseClasses, (0, _generateUtilityClasses.default)('MuiPickersInput', [
    'root',
    'underline',
    'input'
]));

},{"d8b9210235d1a41c":"9snJq","4d0a89cab2f56707":"h7ttl","9b25c2f574b79fab":"2Z0QC","71cd22a9f7f0f592":"dtNEc","cb098fc484dab334":"bNm4V"}],"57t9f":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("87d9290d35f5989b").default;
var _interopRequireDefault = require("68f4926f990e9277").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTimePickerDefaultizedProps = useTimePickerDefaultizedProps;
var _extends2 = _interopRequireDefault(require("e3b8bfc61f8b727e"));
var React = _interopRequireWildcard(require("c77f415f7e72d634"));
var _styles = require("50255023f3ab3446");
var _TimePickerToolbar = require("47b833c4f8a10500");
var _views = require("ba5cdad2b07eb761");
var _useTimeManager = require("eee9e912c2d1e69e");
var _usePickerAdapter = require("499eecc6a3f4fe24");
function useTimePickerDefaultizedProps(props, name) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useTimeManager.useApplyDefaultValuesToTimeValidationProps)(themeProps);
    const ampm = themeProps.ampm ?? adapter.is12HourCycleInCurrentLocale();
    const localeText = React.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, _extends2.default)({}, themeProps.localeText, {
            timePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, _extends2.default)({}, themeProps, validationProps, {
        ampm,
        localeText
    }, (0, _views.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'hours',
            'minutes'
        ],
        defaultOpenTo: 'hours'
    }), {
        slots: (0, _extends2.default)({
            toolbar: _TimePickerToolbar.TimePickerToolbar
        }, themeProps.slots),
        slotProps: (0, _extends2.default)({}, themeProps.slotProps, {
            toolbar: (0, _extends2.default)({
                ampm,
                ampmInClock: themeProps.ampmInClock
            }, themeProps.slotProps?.toolbar)
        })
    });
}

},{"87d9290d35f5989b":"5RcSx","68f4926f990e9277":"9snJq","e3b8bfc61f8b727e":"h7ttl","c77f415f7e72d634":"9njXz","50255023f3ab3446":"c9RfU","47b833c4f8a10500":"dqgzI","ba5cdad2b07eb761":"geKoG","eee9e912c2d1e69e":"6iAu1","499eecc6a3f4fe24":"hE9K5"}],"dqgzI":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d5fe0a7e76f4c231").default;
var _interopRequireWildcard = require("6977aaa147beda38").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimePickerToolbar = TimePickerToolbar;
var _extends2 = _interopRequireDefault(require("c9a003570f51ec72"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("7d10a7b592840d8e"));
var React = _interopRequireWildcard(require("af112aa151296002"));
var _clsx = _interopRequireDefault(require("651c4584085123b1"));
var _propTypes = _interopRequireDefault(require("174eaabedab16b80"));
var _styles = require("c0163f04dbf453c1");
var _composeClasses = _interopRequireDefault(require("b13e6da5c976385e"));
var _PickersToolbarText = require("a0e86188b574b301");
var _PickersToolbarButton = require("d122b4d4ee906bd1");
var _PickersToolbar = require("608db4344c1829b3");
var _utils = require("929f9c847c3307bf");
var _hooks = require("cc6e8c8de8065b8b");
var _dateHelpersHooks = require("6f39186d5595e5d3");
var _timePickerToolbarClasses = require("62f38c6e570ee456");
var _dateUtils = require("fb0f0f6acc07bcb");
var _useToolbarOwnerState = require("a6272be6187bc3b7");
var _jsxRuntime = require("dd117ea09540679c");
const _excluded = [
    "ampm",
    "ampmInClock",
    "className",
    "classes"
];
const useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation, toolbarDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        separator: [
            'separator'
        ],
        hourMinuteLabel: [
            'hourMinuteLabel',
            pickerOrientation === 'landscape' && 'hourMinuteLabelLandscape',
            toolbarDirection === 'rtl' && 'hourMinuteLabelReverse'
        ],
        ampmSelection: [
            'ampmSelection',
            pickerOrientation === 'landscape' && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, _composeClasses.default)(slots, _timePickerToolbarClasses.getTimePickerToolbarUtilityClass, classes);
};
const TimePickerToolbarRoot = (0, _styles.styled)(_PickersToolbar.PickersToolbar, {
    name: 'MuiTimePickerToolbar',
    slot: 'Root'
})({});
const TimePickerToolbarSeparator = (0, _styles.styled)(_PickersToolbarText.PickersToolbarText, {
    name: 'MuiTimePickerToolbar',
    slot: 'Separator'
})({
    outline: 0,
    margin: '0 4px 0 2px',
    cursor: 'default'
});
const TimePickerToolbarHourMinuteLabel = (0, _styles.styled)('div', {
    name: 'MuiTimePickerToolbar',
    slot: 'HourMinuteLabel',
    overridesResolver: (props, styles)=>[
            {
                [`&.${_timePickerToolbarClasses.timePickerToolbarClasses.hourMinuteLabelLandscape}`]: styles.hourMinuteLabelLandscape,
                [`&.${_timePickerToolbarClasses.timePickerToolbarClasses.hourMinuteLabelReverse}`]: styles.hourMinuteLabelReverse
            },
            styles.hourMinuteLabel
        ]
})({
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    variants: [
        {
            props: {
                toolbarDirection: 'rtl'
            },
            style: {
                flexDirection: 'row-reverse'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                marginTop: 'auto'
            }
        }
    ]
});
const TimePickerToolbarAmPmSelection = (0, _styles.styled)('div', {
    name: 'MuiTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${_timePickerToolbarClasses.timePickerToolbarClasses.ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${_timePickerToolbarClasses.timePickerToolbarClasses.ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})({
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    marginLeft: 12,
    [`& .${_timePickerToolbarClasses.timePickerToolbarClasses.ampmLabel}`]: {
        fontSize: 17
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: '4px 0 auto',
                flexDirection: 'row',
                justifyContent: 'space-around',
                flexBasis: '100%'
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [TimePickerToolbar API](https://mui.com/x/api/date-pickers/time-picker-toolbar/)
 */ function TimePickerToolbar(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiTimePickerToolbar'
    });
    const { ampm, ampmInClock, className, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const adapter = (0, _hooks.usePickerAdapter)();
    const translations = (0, _hooks.usePickerTranslations)();
    const ownerState = (0, _useToolbarOwnerState.useToolbarOwnerState)();
    const classes = useUtilityClasses(classesProp, ownerState);
    const { value, setValue, disabled, readOnly, view, setView, views } = (0, _hooks.usePickerContext)();
    const showAmPmControl = Boolean(ampm && !ampmInClock && views.includes('hours'));
    const { meridiemMode, handleMeridiemChange } = (0, _dateHelpersHooks.useMeridiemMode)(value, ampm, (newValue)=>setValue(newValue, {
            changeImportance: 'set'
        }));
    const formatSection = (format)=>{
        if (!adapter.isValid(value)) return '--';
        return adapter.format(value, format);
    };
    const separator = /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimePickerToolbarSeparator, {
        tabIndex: -1,
        value: ":",
        variant: "h3",
        selected: false,
        className: classes.separator
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TimePickerToolbarRoot, (0, _extends2.default)({
        landscapeDirection: "row",
        toolbarTitle: translations.timePickerToolbarTitle,
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className)
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TimePickerToolbarHourMinuteLabel, {
                className: classes.hourMinuteLabel,
                ownerState: ownerState,
                children: [
                    (0, _utils.arrayIncludes)(views, 'hours') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersToolbarButton.PickersToolbarButton, {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>setView('hours'),
                        selected: view === 'hours',
                        value: formatSection(ampm ? 'hours12h' : 'hours24h')
                    }),
                    (0, _utils.arrayIncludes)(views, [
                        'hours',
                        'minutes'
                    ]) && separator,
                    (0, _utils.arrayIncludes)(views, 'minutes') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersToolbarButton.PickersToolbarButton, {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>setView('minutes'),
                        selected: view === 'minutes',
                        value: formatSection('minutes')
                    }),
                    (0, _utils.arrayIncludes)(views, [
                        'minutes',
                        'seconds'
                    ]) && separator,
                    (0, _utils.arrayIncludes)(views, 'seconds') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersToolbarButton.PickersToolbarButton, {
                        variant: "h3",
                        onClick: ()=>setView('seconds'),
                        selected: view === 'seconds',
                        value: formatSection('seconds')
                    })
                ]
            }),
            showAmPmControl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TimePickerToolbarAmPmSelection, {
                className: classes.ampmSelection,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersToolbarButton.PickersToolbarButton, {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === 'am',
                        typographyClassName: classes.ampmLabel,
                        value: (0, _dateUtils.formatMeridiem)(adapter, 'am'),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersToolbarButton.PickersToolbarButton, {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === 'pm',
                        typographyClassName: classes.ampmLabel,
                        value: (0, _dateUtils.formatMeridiem)(adapter, 'pm'),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        disabled: disabled
                    })
                ]
            })
        ]
    }));
}

},{"d5fe0a7e76f4c231":"9snJq","6977aaa147beda38":"5RcSx","c9a003570f51ec72":"h7ttl","7d10a7b592840d8e":"jeIdK","af112aa151296002":"9njXz","651c4584085123b1":"by5ni","174eaabedab16b80":"bnNSm","c0163f04dbf453c1":"c9RfU","b13e6da5c976385e":"eKeIT","a0e86188b574b301":"84BJ7","d122b4d4ee906bd1":"9h4Oj","608db4344c1829b3":"hrCW8","929f9c847c3307bf":"aj7pj","cc6e8c8de8065b8b":"6MTP2","6f39186d5595e5d3":"b2RZ3","62f38c6e570ee456":"hPKV3","fb0f0f6acc07bcb":"jwfEA","a6272be6187bc3b7":"9Of8r","dd117ea09540679c":"1dlk8"}],"84BJ7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("458d279b5d07baa1").default;
var _interopRequireWildcard = require("c33fe77bdabca05f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersToolbarText = void 0;
var _extends2 = _interopRequireDefault(require("6270f47fef0029d1"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("386ebb19882dd00b"));
var React = _interopRequireWildcard(require("3465e8e46716e08c"));
var _clsx = _interopRequireDefault(require("ec093da280ce1dab"));
var _Typography = _interopRequireDefault(require("bb2ad966a0caa67f"));
var _styles = require("406e32005058925d");
var _composeClasses = _interopRequireDefault(require("9f0598a75cab32d2"));
var _pickersToolbarTextClasses = require("1bf68c768e09f642");
var _jsxRuntime = require("fb11fa8690d88545");
const _excluded = [
    "className",
    "classes",
    "selected",
    "value"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersToolbarTextClasses.getPickersToolbarTextUtilityClass, classes);
};
const PickersToolbarTextRoot = (0, _styles.styled)(_Typography.default, {
    name: 'MuiPickersToolbarText',
    slot: 'Root'
})(({ theme })=>({
        transition: theme.transitions.create('color'),
        color: (theme.vars || theme).palette.text.secondary,
        [`&[data-selected]`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const PickersToolbarText = exports.PickersToolbarText = /*#__PURE__*/ React.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarText'
    });
    const { className, classes: classesProp, selected, value } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersToolbarTextRoot, (0, _extends2.default)({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        component: "span",
        ownerState: props
    }, selected && {
        'data-selected': true
    }, other, {
        children: value
    }));
});

},{"458d279b5d07baa1":"9snJq","c33fe77bdabca05f":"5RcSx","6270f47fef0029d1":"h7ttl","386ebb19882dd00b":"jeIdK","3465e8e46716e08c":"9njXz","ec093da280ce1dab":"by5ni","bb2ad966a0caa67f":"2wCD5","406e32005058925d":"c9RfU","9f0598a75cab32d2":"eKeIT","1bf68c768e09f642":"5amI8","fb11fa8690d88545":"1dlk8"}],"5amI8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a78db447fb40492d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersToolbarTextUtilityClass = getPickersToolbarTextUtilityClass;
exports.pickersToolbarTextClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("2304e37770d4cd39"));
var _generateUtilityClasses = _interopRequireDefault(require("cb5f958fac0f7064"));
function getPickersToolbarTextUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersToolbarText', slot);
}
const pickersToolbarTextClasses = exports.pickersToolbarTextClasses = (0, _generateUtilityClasses.default)('MuiPickersToolbarText', [
    'root'
]);

},{"a78db447fb40492d":"9snJq","2304e37770d4cd39":"dtNEc","cb5f958fac0f7064":"2Z0QC"}],"9h4Oj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("72e116c6d4a21a81").default;
var _interopRequireWildcard = require("f1d20beed75d8d31").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersToolbarButton = void 0;
var _extends2 = _interopRequireDefault(require("dcffc9d9ed42a75f"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("b36e85999756c948"));
var React = _interopRequireWildcard(require("cb0668005e8a0116"));
var _clsx = _interopRequireDefault(require("1bb74e4e83b90191"));
var _Button = _interopRequireDefault(require("213d1597e0ee0037"));
var _styles = require("d8b96bf868430482");
var _composeClasses = _interopRequireDefault(require("45656adbbb6f26b8"));
var _PickersToolbarText = require("c6b53e10353d305");
var _pickersToolbarClasses = require("7b5864e8864a0f08");
var _jsxRuntime = require("7133d2497d294504");
const _excluded = [
    "align",
    "className",
    "classes",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersToolbarClasses.getPickersToolbarUtilityClass, classes);
};
const PickersToolbarButtonRoot = (0, _styles.styled)(_Button.default, {
    name: 'MuiPickersToolbarButton',
    slot: 'Root'
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const PickersToolbarButton = exports.PickersToolbarButton = /*#__PURE__*/ React.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align, className, classes: classesProp, selected, typographyClassName, value, variant, width } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersToolbarButtonRoot, (0, _extends2.default)({
        variant: "text",
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: props
    }, width ? {
        sx: {
            width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersToolbarText.PickersToolbarText, {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});

},{"72e116c6d4a21a81":"9snJq","f1d20beed75d8d31":"5RcSx","dcffc9d9ed42a75f":"h7ttl","b36e85999756c948":"jeIdK","cb0668005e8a0116":"9njXz","1bb74e4e83b90191":"by5ni","213d1597e0ee0037":"c6Y0y","d8b96bf868430482":"c9RfU","45656adbbb6f26b8":"eKeIT","c6b53e10353d305":"84BJ7","7b5864e8864a0f08":"iaLy9","7133d2497d294504":"1dlk8"}],"iaLy9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1a50523f3b5566ba").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersToolbarUtilityClass = getPickersToolbarUtilityClass;
exports.pickersToolbarClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("609fc2c6b7ab36dd"));
var _generateUtilityClasses = _interopRequireDefault(require("e5b361a0edfef393"));
function getPickersToolbarUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersToolbar', slot);
}
const pickersToolbarClasses = exports.pickersToolbarClasses = (0, _generateUtilityClasses.default)('MuiPickersToolbar', [
    'root',
    'title',
    'content'
]);

},{"1a50523f3b5566ba":"9snJq","609fc2c6b7ab36dd":"dtNEc","e5b361a0edfef393":"2Z0QC"}],"hrCW8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6899d6b1f6534423").default;
var _interopRequireWildcard = require("60d5a16c6d16c957").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersToolbar = void 0;
var _extends2 = _interopRequireDefault(require("92f4830c6292afcc"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("a822e9cce781cdb6"));
var React = _interopRequireWildcard(require("239dbdb3c5fba92c"));
var _clsx = _interopRequireDefault(require("aca76484652ef254"));
var _Typography = _interopRequireDefault(require("62dae39b31851180"));
var _styles = require("17bd3707f01af2a0");
var _composeClasses = _interopRequireDefault(require("3b01eb6b45eff229"));
var _createStyled = require("639ca25836e29ddc");
var _pickersToolbarClasses = require("e80b06b9318cd884");
var _useToolbarOwnerState = require("39c9ddc6b5c705a4");
var _jsxRuntime = require("42e1ae04a58b006b");
const _excluded = [
    "children",
    "className",
    "classes",
    "toolbarTitle",
    "hidden",
    "titleId",
    "classes",
    "landscapeDirection"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ],
        content: [
            'content'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersToolbarClasses.getPickersToolbarUtilityClass, classes);
};
const PickersToolbarRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root'
})(({ theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    pickerOrientation: 'landscape'
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const PickersToolbarContent = (0, _styles.styled)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'landscapeDirection'
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const PickersToolbar = exports.PickersToolbar = /*#__PURE__*/ React.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children, className, classes: classesProp, toolbarTitle, hidden, titleId, landscapeDirection } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _useToolbarOwnerState.useToolbarOwnerState)();
    const classes = useUtilityClasses(classesProp);
    if (hidden) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersToolbarRoot, (0, _extends2.default)({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Typography.default, {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                className: classes.title,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                landscapeDirection: landscapeDirection,
                children: children
            })
        ]
    }));
});

},{"6899d6b1f6534423":"9snJq","60d5a16c6d16c957":"5RcSx","92f4830c6292afcc":"h7ttl","a822e9cce781cdb6":"jeIdK","239dbdb3c5fba92c":"9njXz","aca76484652ef254":"by5ni","62dae39b31851180":"2wCD5","17bd3707f01af2a0":"c9RfU","3b01eb6b45eff229":"eKeIT","639ca25836e29ddc":"6ySdS","e80b06b9318cd884":"iaLy9","39c9ddc6b5c705a4":"9Of8r","42e1ae04a58b006b":"1dlk8"}],"9Of8r":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("9a5a277e20937ce2").default;
var _interopRequireDefault = require("28f166e672fb85fd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useToolbarOwnerState = useToolbarOwnerState;
var _extends2 = _interopRequireDefault(require("b8c674bf3d02f909"));
var React = _interopRequireWildcard(require("4968c908206d3b6e"));
var _RtlProvider = require("f13f3db11bd41e06");
var _usePickerPrivateContext = require("7de8cc0392469d1e");
function useToolbarOwnerState() {
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const isRtl = (0, _RtlProvider.useRtl)();
    return React.useMemo(()=>(0, _extends2.default)({}, pickerOwnerState, {
            toolbarDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
}

},{"9a5a277e20937ce2":"5RcSx","28f166e672fb85fd":"9snJq","b8c674bf3d02f909":"h7ttl","4968c908206d3b6e":"9njXz","f13f3db11bd41e06":"ck9Pb","7de8cc0392469d1e":"8xvkv"}],"b2RZ3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("d35cf876b70e81a0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useMeridiemMode = useMeridiemMode;
exports.useNextMonthDisabled = useNextMonthDisabled;
exports.usePreviousMonthDisabled = usePreviousMonthDisabled;
var React = _interopRequireWildcard(require("90b9feed9afc8e01"));
var _timeUtils = require("a3f01546f4fce628");
var _usePickerAdapter = require("c09ac35e59273019");
function useNextMonthDisabled(month, { disableFuture, maxDate, timezone }) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    return React.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        return !adapter.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        adapter,
        timezone
    ]);
}
function usePreviousMonthDisabled(month, { disablePast, minDate, timezone }) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    return React.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        return !adapter.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        adapter,
        timezone
    ]);
}
function useMeridiemMode(date, ampm, onChange, selectionState) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const cleanDate = React.useMemo(()=>!adapter.isValid(date) ? null : date, [
        adapter,
        date
    ]);
    const meridiemMode = (0, _timeUtils.getMeridiem)(cleanDate, adapter);
    const handleMeridiemChange = React.useCallback((mode)=>{
        const timeWithMeridiem = cleanDate == null ? null : (0, _timeUtils.convertToMeridiem)(cleanDate, mode, Boolean(ampm), adapter);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        cleanDate,
        onChange,
        selectionState,
        adapter
    ]);
    return {
        meridiemMode,
        handleMeridiemChange
    };
}

},{"d35cf876b70e81a0":"5RcSx","90b9feed9afc8e01":"9njXz","a3f01546f4fce628":"gSWbl","c09ac35e59273019":"hE9K5"}],"hPKV3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5a6133b2d66f80d6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTimePickerToolbarUtilityClass = getTimePickerToolbarUtilityClass;
exports.timePickerToolbarClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("274613fd338e0f50"));
var _generateUtilityClasses = _interopRequireDefault(require("ac0e105b0a92bde2"));
function getTimePickerToolbarUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTimePickerToolbar', slot);
}
const timePickerToolbarClasses = exports.timePickerToolbarClasses = (0, _generateUtilityClasses.default)('MuiTimePickerToolbar', [
    'root',
    'separator',
    'hourMinuteLabel',
    'hourMinuteLabelLandscape',
    'hourMinuteLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);

},{"5a6133b2d66f80d6":"9snJq","274613fd338e0f50":"dtNEc","ac0e105b0a92bde2":"2Z0QC"}],"d0HtL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useMobilePicker", {
    enumerable: true,
    get: function() {
        return _useMobilePicker.useMobilePicker;
    }
});
var _useMobilePicker = require("f4faf5f828a5c1f7");

},{"f4faf5f828a5c1f7":"hPnzY"}],"hPnzY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5ee9b86f006688a3").default;
var _interopRequireWildcard = require("4e58a4e458e05579").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useMobilePicker = void 0;
var _extends2 = _interopRequireDefault(require("d017cd45cad894a"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("d8a899f94852d99"));
var React = _interopRequireWildcard(require("60813bf353185976"));
var _useSlotProps2 = _interopRequireDefault(require("aef7644099771a61"));
var _PickersModalDialog = require("d289302738d8c108");
var _usePicker = require("1ad00794ee8e158b");
var _PickersLayout = require("b95a2c041cec6dcf");
var _PickerProvider = require("f913ae2498226486");
var _createNonRangePickerStepNavigation = require("f97653682877a420");
var _jsxRuntime = require("d30305cb5336b8fb");
const _excluded = [
    "props",
    "steps"
], _excluded2 = [
    "ownerState"
];
/**
 * Hook managing all the single-date mobile pickers:
 * - MobileDatePicker
 * - MobileDateTimePicker
 * - MobileTimePicker
 */ const useMobilePicker = (_ref)=>{
    let { props, steps } = _ref, pickerParams = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    const { slots, slotProps: innerSlotProps, label, inputRef, localeText } = props;
    const getStepNavigation = (0, _createNonRangePickerStepNavigation.createNonRangePickerStepNavigation)({
        steps
    });
    const { providerProps, renderCurrentView, ownerState } = (0, _usePicker.usePicker)((0, _extends2.default)({}, pickerParams, {
        props,
        localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'mobile',
        getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, _useSlotProps2.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, _extends2.default)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState
    }), fieldProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps, _excluded2);
    const Layout = slots.layout ?? _PickersLayout.PickersLayout;
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, _extends2.default)({}, innerSlotProps, {
        toolbar: (0, _extends2.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, _extends2.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_PickerProvider.PickerProvider, (0, _extends2.default)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Field, (0, _extends2.default)({}, fieldProps, {
                    slots: slots,
                    slotProps: slotProps,
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersModalDialog.PickersModalDialog, {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layout, (0, _extends2.default)({}, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker
    };
};
exports.useMobilePicker = useMobilePicker;

},{"5ee9b86f006688a3":"9snJq","4e58a4e458e05579":"5RcSx","d017cd45cad894a":"h7ttl","d8a899f94852d99":"jeIdK","60813bf353185976":"9njXz","aef7644099771a61":"izoZZ","d289302738d8c108":"9UJc9","1ad00794ee8e158b":"kfLaB","b95a2c041cec6dcf":"dE92R","f913ae2498226486":"i6in8","f97653682877a420":"euBpu","d30305cb5336b8fb":"1dlk8"}],"9UJc9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5148e93192f4dc7b").default;
var _interopRequireDefault = require("f4e3b0b15269487e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersModalDialog = PickersModalDialog;
var _extends2 = _interopRequireDefault(require("717cfd61275160f7"));
var React = _interopRequireWildcard(require("638e13dfd0f112cb"));
var _DialogContent = _interopRequireDefault(require("474aa186d8d04306"));
var _Fade = _interopRequireDefault(require("f6f2e91d78853450"));
var _Dialog = _interopRequireWildcard(require("6ddb9d7c1e405b4c"));
var _styles = require("dd5c05930aab7eb9");
var _dimensions = require("6c226cfd8a7fcb31");
var _hooks = require("be0aaf90eb4f909c");
var _usePickerPrivateContext = require("5086c4e111a2f92b");
var _jsxRuntime = require("c62c7e74bd3cfaa5");
const PickersModalDialogRoot = (0, _styles.styled)(_Dialog.default)({
    [`& .${_Dialog.dialogClasses.container}`]: {
        outline: 0
    },
    [`& .${_Dialog.dialogClasses.paper}`]: {
        outline: 0,
        minWidth: _dimensions.DIALOG_WIDTH
    }
});
const PickersModalDialogContent = (0, _styles.styled)(_DialogContent.default)({
    '&:first-of-type': {
        padding: 0
    }
});
function PickersModalDialog(props) {
    const { children, slots, slotProps } = props;
    const { open } = (0, _hooks.usePickerContext)();
    const { dismissViews, onPopperExited } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const Dialog = slots?.dialog ?? PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? _Fade.default;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Dialog, (0, _extends2.default)({
        open: open,
        onClose: ()=>{
            dismissViews();
            onPopperExited?.();
        }
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersModalDialogContent, {
            children: children
        })
    }));
}

},{"5148e93192f4dc7b":"5RcSx","f4e3b0b15269487e":"9snJq","717cfd61275160f7":"h7ttl","638e13dfd0f112cb":"9njXz","474aa186d8d04306":"gD0J9","f6f2e91d78853450":"8DwqP","6ddb9d7c1e405b4c":"255tO","dd5c05930aab7eb9":"c9RfU","6c226cfd8a7fcb31":"l0mMZ","be0aaf90eb4f909c":"6MTP2","5086c4e111a2f92b":"8xvkv","c62c7e74bd3cfaa5":"1dlk8"}],"l0mMZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VIEW_HEIGHT = exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = exports.MAX_CALENDAR_HEIGHT = exports.DIGITAL_CLOCK_VIEW_HEIGHT = exports.DIALOG_WIDTH = exports.DAY_SIZE = exports.DAY_MARGIN = void 0;
const DAY_SIZE = exports.DAY_SIZE = 36;
const DAY_MARGIN = exports.DAY_MARGIN = 2;
const DIALOG_WIDTH = exports.DIALOG_WIDTH = 320;
const MAX_CALENDAR_HEIGHT = exports.MAX_CALENDAR_HEIGHT = 280;
const VIEW_HEIGHT = exports.VIEW_HEIGHT = 336;
const DIGITAL_CLOCK_VIEW_HEIGHT = exports.DIGITAL_CLOCK_VIEW_HEIGHT = 232;
const MULTI_SECTION_CLOCK_SECTION_WIDTH = exports.MULTI_SECTION_CLOCK_SECTION_WIDTH = 48;

},{}],"kfLaB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "usePicker", {
    enumerable: true,
    get: function() {
        return _usePicker.usePicker;
    }
});
var _usePicker = require("64a15fb1a77a0890");

},{"64a15fb1a77a0890":"hlSXP"}],"hlSXP":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("54a5447b0dd302d0").default;
var _interopRequireWildcard = require("936f6cfc5fbc330").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePicker = void 0;
var _extends2 = _interopRequireDefault(require("815af27527d0fbda"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("8aa62e3c6728fae4"));
var React = _interopRequireWildcard(require("473074be8274a136"));
var _useEnhancedEffect = _interopRequireDefault(require("8ebdfd0e5ef24581"));
var _useEventCallback = _interopRequireDefault(require("8eee2614d15cb654"));
var _useForkRef = _interopRequireDefault(require("86cbdd8480c611a1"));
var _useId = _interopRequireDefault(require("a700f58fb12f6955"));
var _usePickerAdapter = require("aedbb09c91b8b067");
var _useReduceAnimations = require("916c35edf988bc85");
var _timeUtils = require("e36df9c637aa58da");
var _useViews = require("26de5f58e9de9661");
var _useOrientation = require("5987182bda79e371");
var _useValueAndOpenStates = require("83ea6955c14f009a");
var _jsxRuntime = require("a19e8c74d7645723");
const _excluded = [
    "className",
    "sx"
];
const usePicker = ({ ref, props, valueManager, valueType, variant, validator, onPopperExited, autoFocusView, rendererInterceptor: RendererInterceptor, localeText, viewContainerRole, getStepNavigation })=>{
    const { // View props
    views, view: viewProp, openTo, onViewChange, viewRenderers, reduceAnimations: reduceAnimationsProp, orientation: orientationProp, disableOpenPicker, closeOnSelect, // Form props
    disabled, readOnly, // Field props
    formatDensity, enableAccessibleFieldDOMStructure, selectedSections, onSelectedSectionsChange, format, label, // Other props
    autoFocus, name } = props;
    const { className, sx } = props, propsToForwardToView = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    /**
   * TODO: Improve how we generate the aria-label and aria-labelledby attributes.
   */ const labelId = (0, _useId.default)();
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const reduceAnimations = (0, _useReduceAnimations.useReduceAnimations)(reduceAnimationsProp);
    const orientation = (0, _useOrientation.useOrientation)(views, orientationProp);
    const { current: initialView } = React.useRef(openTo ?? null);
    /**
   * Refs
   */ const [triggerElement, triggerRef] = React.useState(null);
    const popupRef = React.useRef(null);
    const fieldRef = React.useRef(null);
    const rootRefObject = React.useRef(null);
    const rootRef = (0, _useForkRef.default)(ref, rootRefObject);
    const { timezone, state, setOpen, setValue, setValueFromView, value, viewValue } = (0, _useValueAndOpenStates.useValueAndOpenStates)({
        props,
        valueManager,
        validator
    });
    const { view, setView, defaultView, focusedView, setFocusedView, setValueAndGoToNextView, goToNextStep, hasNextStep, hasSeveralSteps } = (0, _useViews.useViews)({
        view: viewProp,
        views,
        openTo,
        onChange: setValueFromView,
        onViewChange,
        autoFocus: autoFocusView,
        getStepNavigation
    });
    const clearValue = (0, _useEventCallback.default)(()=>setValue(valueManager.emptyValue));
    const setValueToToday = (0, _useEventCallback.default)(()=>setValue(valueManager.getTodayValue(adapter, timezone, valueType)));
    const acceptValueChanges = (0, _useEventCallback.default)(()=>setValue(value));
    const cancelValueChanges = (0, _useEventCallback.default)(()=>setValue(state.lastCommittedValue, {
            skipPublicationIfPristine: true
        }));
    const dismissViews = (0, _useEventCallback.default)(()=>{
        setValue(value, {
            skipPublicationIfPristine: true
        });
    });
    const { hasUIView, viewModeLookup, timeViewsCount } = React.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            const viewMode = viewRenderers[viewForReduce] == null ? 'field' : 'UI';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') {
                acc.hasUIView = true;
                if ((0, _timeUtils.isTimeView)(viewForReduce)) acc.timeViewsCount += 1;
            }
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {},
            timeViewsCount: 0
        }), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const getCurrentViewMode = (0, _useEventCallback.default)(()=>currentViewMode);
    const [popperView, setPopperView] = React.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, _useEnhancedEffect.default)(()=>{
        // Handle case of Date Time Picker without time renderers
        if (currentViewMode === 'field' && state.open) {
            setOpen(false);
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, _useEnhancedEffect.default)(()=>{
        if (!state.open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        state.open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ownerState = React.useMemo(()=>({
            isPickerValueEmpty: valueManager.areValuesEqual(adapter, value, valueManager.emptyValue),
            isPickerOpen: state.open,
            isPickerDisabled: props.disabled ?? false,
            isPickerReadOnly: props.readOnly ?? false,
            pickerOrientation: orientation,
            pickerVariant: variant
        }), [
        adapter,
        valueManager,
        value,
        state.open,
        orientation,
        variant,
        props.disabled,
        props.readOnly
    ]);
    const triggerStatus = React.useMemo(()=>{
        if (disableOpenPicker || !hasUIView) return 'hidden';
        if (disabled || readOnly) return 'disabled';
        return 'enabled';
    }, [
        disableOpenPicker,
        hasUIView,
        disabled,
        readOnly
    ]);
    const wrappedGoToNextStep = (0, _useEventCallback.default)(goToNextStep);
    const defaultActionBarActions = React.useMemo(()=>{
        if (closeOnSelect && !hasSeveralSteps) return [];
        return [
            'cancel',
            'nextOrAccept'
        ];
    }, [
        closeOnSelect,
        hasSeveralSteps
    ]);
    const actionsContextValue = React.useMemo(()=>({
            setValue,
            setOpen,
            clearValue,
            setValueToToday,
            acceptValueChanges,
            cancelValueChanges,
            setView,
            goToNextStep: wrappedGoToNextStep
        }), [
        setValue,
        setOpen,
        clearValue,
        setValueToToday,
        acceptValueChanges,
        cancelValueChanges,
        setView,
        wrappedGoToNextStep
    ]);
    const contextValue = React.useMemo(()=>(0, _extends2.default)({}, actionsContextValue, {
            value,
            timezone,
            open: state.open,
            views,
            view: popperView,
            initialView,
            disabled: disabled ?? false,
            readOnly: readOnly ?? false,
            autoFocus: autoFocus ?? false,
            variant,
            orientation,
            popupRef,
            reduceAnimations,
            triggerRef,
            triggerStatus,
            hasNextStep,
            fieldFormat: format ?? '',
            name,
            label,
            rootSx: sx,
            rootRef,
            rootClassName: className
        }), [
        actionsContextValue,
        value,
        rootRef,
        variant,
        orientation,
        reduceAnimations,
        disabled,
        readOnly,
        format,
        className,
        name,
        label,
        sx,
        triggerStatus,
        hasNextStep,
        timezone,
        state.open,
        popperView,
        views,
        initialView,
        autoFocus
    ]);
    const privateContextValue = React.useMemo(()=>({
            dismissViews,
            ownerState,
            hasUIView,
            getCurrentViewMode,
            rootRefObject,
            labelId,
            triggerElement,
            viewContainerRole,
            defaultActionBarActions,
            onPopperExited
        }), [
        dismissViews,
        ownerState,
        hasUIView,
        getCurrentViewMode,
        labelId,
        triggerElement,
        viewContainerRole,
        defaultActionBarActions,
        onPopperExited
    ]);
    const fieldPrivateContextValue = React.useMemo(()=>({
            formatDensity,
            enableAccessibleFieldDOMStructure,
            selectedSections,
            onSelectedSectionsChange,
            fieldRef
        }), [
        formatDensity,
        enableAccessibleFieldDOMStructure,
        selectedSections,
        onSelectedSectionsChange,
        fieldRef
    ]);
    const isValidContextValue = (testedValue)=>{
        const error = validator({
            adapter,
            value: testedValue,
            timezone,
            props
        });
        return !valueManager.hasError(error);
    };
    const renderCurrentView = ()=>{
        if (popperView == null) return null;
        const renderer = viewRenderers[popperView];
        if (renderer == null) return null;
        const rendererProps = (0, _extends2.default)({}, propsToForwardToView, {
            views,
            timezone,
            value: viewValue,
            onChange: setValueAndGoToNextView,
            view: popperView,
            onViewChange: setView,
            showViewSwitcher: timeViewsCount > 1,
            timeViewsCount
        }, viewContainerRole === 'tooltip' ? {
            focusedView: null,
            onFocusedViewChange: ()=>{}
        } : {
            focusedView,
            onFocusedViewChange: setFocusedView
        });
        if (RendererInterceptor) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RendererInterceptor, {
            viewRenderers: viewRenderers,
            popperView: popperView,
            rendererProps: rendererProps
        });
        return renderer(rendererProps);
    };
    return {
        providerProps: {
            localeText,
            contextValue,
            privateContextValue,
            actionsContextValue,
            fieldPrivateContextValue,
            isValidContextValue
        },
        renderCurrentView,
        ownerState
    };
};
exports.usePicker = usePicker;

},{"54a5447b0dd302d0":"9snJq","936f6cfc5fbc330":"5RcSx","815af27527d0fbda":"h7ttl","8aa62e3c6728fae4":"jeIdK","473074be8274a136":"9njXz","8ebdfd0e5ef24581":"foonr","8eee2614d15cb654":"lkrdI","86cbdd8480c611a1":"93645","a700f58fb12f6955":"icfbA","aedbb09c91b8b067":"hE9K5","916c35edf988bc85":"jxsYR","e36df9c637aa58da":"gSWbl","26de5f58e9de9661":"6z8XQ","5987182bda79e371":"cRdOX","83ea6955c14f009a":"errQZ","a19e8c74d7645723":"1dlk8"}],"jxsYR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2ff6f04189218495").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slowAnimationDevices = void 0;
exports.useReduceAnimations = useReduceAnimations;
var _useMediaQuery = _interopRequireDefault(require("4c95f00d8a7f6521"));
const PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null;
const iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null;
const slowAnimationDevices = exports.slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || false;
function useReduceAnimations(customReduceAnimations) {
    const prefersReduced = (0, _useMediaQuery.default)(PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    if (customReduceAnimations != null) return customReduceAnimations;
    return prefersReduced || slowAnimationDevices;
}

},{"2ff6f04189218495":"9snJq","4c95f00d8a7f6521":"bnRpi"}],"6z8XQ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("c06bc58447d0c13d").default;
var _interopRequireDefault = require("df64206cd9d4f3e5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useViews = useViews;
var _extends2 = _interopRequireDefault(require("6849b9b550ede6af"));
var React = _interopRequireWildcard(require("90ab1d1d591d000a"));
var _useEventCallback = _interopRequireDefault(require("138172a890961778"));
var _useControlled = _interopRequireDefault(require("c4228f7423c365b2"));
var _createStepNavigation = require("7379766915b8a521");
let warnedOnceNotValidView = false;
function useViews({ onChange, onViewChange, openTo, view: inView, views, autoFocus, focusedView: inFocusedView, onFocusedViewChange, getStepNavigation }) {
    const previousOpenTo = React.useRef(openTo);
    const previousViews = React.useRef(views);
    const defaultView = React.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, _useControlled.default)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = React.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, _useControlled.default)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    const stepNavigation = getStepNavigation ? getStepNavigation({
        setView,
        view,
        defaultView: defaultView.current,
        views
    }) : _createStepNavigation.DEFAULT_STEP_NAVIGATION;
    React.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, _useEventCallback.default)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, _useEventCallback.default)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, _useEventCallback.default)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, _useEventCallback.default)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // The selected view can be different from the active view,
        // This can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        let currentView = null;
        if (selectedView != null && selectedView !== view) currentView = selectedView;
        else if (isSelectionFinishedOnCurrentView) currentView = view;
        if (currentView == null) return;
        const viewToNavigateTo = views[views.indexOf(currentView) + 1];
        if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) return;
        handleChangeView(viewToNavigateTo);
    });
    return (0, _extends2.default)({}, stepNavigation, {
        view,
        setView: handleChangeView,
        focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView,
        previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView,
        setValueAndGoToNextView
    });
}

},{"c06bc58447d0c13d":"5RcSx","df64206cd9d4f3e5":"9snJq","6849b9b550ede6af":"h7ttl","90ab1d1d591d000a":"9njXz","138172a890961778":"lkrdI","c4228f7423c365b2":"aysZ8","7379766915b8a521":"jTht6"}],"jTht6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3378135f85b5766f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_STEP_NAVIGATION = void 0;
exports.createStepNavigation = createStepNavigation;
var _extends2 = _interopRequireDefault(require("50038286e979056f"));
const DEFAULT_STEP_NAVIGATION = exports.DEFAULT_STEP_NAVIGATION = {
    hasNextStep: false,
    hasSeveralSteps: false,
    goToNextStep: ()=>{},
    areViewsInSameStep: ()=>true
};
/**
 * Create an object that determines whether there is a next step and allows to go to the next step.
 * @param {CreateStepNavigationParameters<TStep>} parameters The parameters of the createStepNavigation function
 * @returns {CreateStepNavigationReturnValue} The return value of the createStepNavigation function
 */ function createStepNavigation(parameters) {
    const { steps, isViewMatchingStep, onStepChange } = parameters;
    return (parametersBis)=>{
        if (steps == null) return DEFAULT_STEP_NAVIGATION;
        const currentStepIndex = steps.findIndex((step)=>isViewMatchingStep(parametersBis.view, step));
        const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
        return {
            hasNextStep: nextStep != null,
            hasSeveralSteps: steps.length > 1,
            goToNextStep: ()=>{
                if (nextStep == null) return;
                onStepChange((0, _extends2.default)({}, parametersBis, {
                    step: nextStep
                }));
            },
            areViewsInSameStep: (viewA, viewB)=>{
                const stepA = steps.find((step)=>isViewMatchingStep(viewA, step));
                const stepB = steps.find((step)=>isViewMatchingStep(viewB, step));
                return stepA === stepB;
            }
        };
    };
}

},{"3378135f85b5766f":"9snJq","50038286e979056f":"h7ttl"}],"cRdOX":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e6ae317395b912ec").default;
var _interopRequireWildcard = require("24eaba509b8b046b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useOrientation = useOrientation;
var React = _interopRequireWildcard(require("e40309e01ccdd305"));
var _useEnhancedEffect = _interopRequireDefault(require("9516199c584f511"));
var _utils = require("690d1f12f41b545c");
function getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function useOrientation(views, customOrientation) {
    const [orientation, setOrientation] = React.useState(getOrientation);
    (0, _useEnhancedEffect.default)(()=>{
        const eventHandler = ()=>{
            setOrientation(getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, _utils.arrayIncludes)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return 'portrait';
    return customOrientation ?? orientation;
}

},{"e6ae317395b912ec":"9snJq","24eaba509b8b046b":"5RcSx","e40309e01ccdd305":"9njXz","9516199c584f511":"foonr","690d1f12f41b545c":"aj7pj"}],"errQZ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("7ba78a9e29c2355c").default;
var _interopRequireDefault = require("cb221ed7053d05d3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useValueAndOpenStates = useValueAndOpenStates;
var _extends2 = _interopRequireDefault(require("d512b73c58f6bea6"));
var React = _interopRequireWildcard(require("2ea0fe204d887e51"));
var _warning = require("11760fd214034cea");
var _useEventCallback = _interopRequireDefault(require("4fbfc4410c956d92"));
var _useControlledValue = require("9a9bd078b3fb81bc");
var _usePickerAdapter = require("a30cda15e2a773cc");
var _validation = require("6a7275c6ad22bf55");
function useValueAndOpenStates(parameters) {
    const { props, valueManager, validator } = parameters;
    const { value: valueProp, defaultValue: defaultValueProp, onChange, referenceDate, timezone: timezoneProp, onAccept, closeOnSelect, open: openProp, onOpen, onClose } = props;
    const { current: defaultValue } = React.useRef(defaultValueProp);
    const { current: isValueControlled } = React.useRef(valueProp !== undefined);
    const { current: isOpenControlled } = React.useRef(openProp !== undefined);
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const { timezone, value, handleValueChange } = (0, _useControlledValue.useControlledValue)({
        name: 'a picker component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate,
        onChange,
        valueManager
    });
    const [state, setState] = React.useState(()=>({
            open: false,
            lastExternalValue: value,
            clockShallowValue: undefined,
            lastCommittedValue: value,
            hasBeenModifiedSinceMount: false
        }));
    const { getValidationErrorForNewValue } = (0, _validation.useValidation)({
        props,
        validator,
        timezone,
        value,
        onError: props.onError
    });
    const setOpen = (0, _useEventCallback.default)((action)=>{
        const newOpen = typeof action === 'function' ? action(state.open) : action;
        if (!isOpenControlled) setState((prevState)=>(0, _extends2.default)({}, prevState, {
                open: newOpen
            }));
        if (newOpen && onOpen) onOpen();
        if (!newOpen) onClose?.();
    });
    const setValue = (0, _useEventCallback.default)((newValue, options)=>{
        const { changeImportance = 'accept', skipPublicationIfPristine = false, validationError, shortcut, shouldClose = changeImportance === 'accept' } = options ?? {};
        let shouldFireOnChange;
        let shouldFireOnAccept;
        if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
            // If the value is not controlled and the value has never been modified before,
            // Then clicking on any value (including the one equal to `defaultValue`) should call `onChange` and `onAccept`
            shouldFireOnChange = true;
            shouldFireOnAccept = changeImportance === 'accept';
        } else {
            shouldFireOnChange = !valueManager.areValuesEqual(adapter, newValue, value);
            shouldFireOnAccept = changeImportance === 'accept' && !valueManager.areValuesEqual(adapter, newValue, state.lastCommittedValue);
        }
        setState((prevState)=>(0, _extends2.default)({}, prevState, {
                // We reset the shallow value whenever we fire onChange.
                clockShallowValue: shouldFireOnChange ? undefined : prevState.clockShallowValue,
                lastCommittedValue: shouldFireOnAccept ? newValue : prevState.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                cachedContext = {
                    validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError
                };
                if (shortcut) cachedContext.shortcut = shortcut;
            }
            return cachedContext;
        };
        if (shouldFireOnChange) handleValueChange(newValue, getContext());
        if (shouldFireOnAccept && onAccept) onAccept(newValue, getContext());
        if (shouldClose) setOpen(false);
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) setState((prevState)=>(0, _extends2.default)({}, prevState, {
            lastExternalValue: value,
            clockShallowValue: undefined,
            hasBeenModifiedSinceMount: true
        }));
    const setValueFromView = (0, _useEventCallback.default)((newValue, selectionState = 'partial')=>{
        // TODO: Expose a new method (private?) like `setView` that only updates the clock shallow value.
        if (selectionState === 'shallow') {
            setState((prev)=>(0, _extends2.default)({}, prev, {
                    clockShallowValue: newValue,
                    hasBeenModifiedSinceMount: true
                }));
            return;
        }
        setValue(newValue, {
            changeImportance: selectionState === 'finish' && closeOnSelect ? 'accept' : 'set'
        });
    });
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    React.useEffect(()=>{
        if (isOpenControlled) {
            if (openProp === undefined) throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setState((prevState)=>(0, _extends2.default)({}, prevState, {
                    open: openProp
                }));
        }
    }, [
        isOpenControlled,
        openProp
    ]);
    const viewValue = React.useMemo(()=>valueManager.cleanValue(adapter, state.clockShallowValue === undefined ? value : state.clockShallowValue), [
        adapter,
        valueManager,
        state.clockShallowValue,
        value
    ]);
    return {
        timezone,
        state,
        setValue,
        setValueFromView,
        setOpen,
        value,
        viewValue
    };
}

},{"7ba78a9e29c2355c":"5RcSx","cb221ed7053d05d3":"9snJq","d512b73c58f6bea6":"h7ttl","2ea0fe204d887e51":"9njXz","11760fd214034cea":"gernP","4fbfc4410c956d92":"lkrdI","9a9bd078b3fb81bc":"gd9Iu","a30cda15e2a773cc":"hE9K5","6a7275c6ad22bf55":"2toSg"}],"gernP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "clearWarningsCache", {
    enumerable: true,
    get: function() {
        return _warning.clearWarningsCache;
    }
});
Object.defineProperty(exports, "warnOnce", {
    enumerable: true,
    get: function() {
        return _warning.warnOnce;
    }
});
var _warning = require("f7f8947a801f6f55");

},{"f7f8947a801f6f55":"3vfXv"}],"3vfXv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clearWarningsCache = clearWarningsCache;
exports.warnOnce = warnOnce;
const warnedOnceCache = new Set();
/**
 * Logs a message to the console on development mode. The warning will only be logged once.
 *
 * The message is the log's cache key. Two identical messages will only be logged once.
 *
 * This function is a no-op in production.
 *
 * @param message the message to log
 * @param gravity the gravity of the warning. Defaults to `'warning'`.
 * @returns
 */ function warnOnce(message, gravity = 'warning') {
    return;
}
function clearWarningsCache() {
    warnedOnceCache.clear();
}

},{}],"dE92R":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e39d018073a82ef").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersLayout", {
    enumerable: true,
    get: function() {
        return _PickersLayout.PickersLayout;
    }
});
Object.defineProperty(exports, "PickersLayoutContentWrapper", {
    enumerable: true,
    get: function() {
        return _PickersLayout.PickersLayoutContentWrapper;
    }
});
Object.defineProperty(exports, "PickersLayoutRoot", {
    enumerable: true,
    get: function() {
        return _PickersLayout.PickersLayoutRoot;
    }
});
Object.defineProperty(exports, "pickersLayoutClasses", {
    enumerable: true,
    get: function() {
        return _pickersLayoutClasses.pickersLayoutClasses;
    }
});
Object.defineProperty(exports, "usePickerLayout", {
    enumerable: true,
    get: function() {
        return _usePickerLayout.default;
    }
});
var _PickersLayout = require("26b2dae8d7a4965");
var _usePickerLayout = _interopRequireDefault(require("4a72732594647425"));
var _pickersLayoutClasses = require("88f47d77863f9a63");

},{"e39d018073a82ef":"9snJq","26b2dae8d7a4965":"79zpm","4a72732594647425":"9mPGQ","88f47d77863f9a63":"dWjrV"}],"79zpm":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a0e1ce8b1558774a").default;
var _interopRequireWildcard = require("ecc4b6852b85df6b").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersLayoutRoot = exports.PickersLayoutContentWrapper = exports.PickersLayout = void 0;
var React = _interopRequireWildcard(require("4004bab8e694369b"));
var _propTypes = _interopRequireDefault(require("66ae601af85b9a5c"));
var _clsx = _interopRequireDefault(require("210701afde05a16"));
var _styles = require("8789d20639a36e3b");
var _composeClasses = _interopRequireDefault(require("ad258100d1acc360"));
var _pickersLayoutClasses = require("daaa712cc184ac14");
var _usePickerLayout = _interopRequireDefault(require("56dd8b822b75b10"));
var _usePickerContext = require("92372ba8a9503045");
var _jsxRuntime = require("99ac2dfb3438c317");
const useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersLayoutClasses.getPickersLayoutUtilityClass, classes);
};
const PickersLayoutRoot = exports.PickersLayoutRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root'
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${_pickersLayoutClasses.pickersLayoutClasses.actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: false
            },
            style: {
                [`& .${_pickersLayoutClasses.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '1 / 3'
                }
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: true
            },
            style: {
                [`& .${_pickersLayoutClasses.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1,
                    maxWidth: 'max-content'
                },
                [`& .${_pickersLayoutClasses.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: 2
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait'
            },
            style: {
                [`& .${_pickersLayoutClasses.pickersLayoutClasses.toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${_pickersLayoutClasses.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                hasShortcuts: true,
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${_pickersLayoutClasses.pickersLayoutClasses.shortcuts}`]: {
                    gridColumn: 4
                }
            }
        }
    ]
});
const PickersLayoutContentWrapper = exports.PickersLayoutContentWrapper = (0, _styles.styled)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper'
})({
    gridColumn: '2 / 4',
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const PickersLayout = exports.PickersLayout = /*#__PURE__*/ React.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar, content, tabs, actionBar, shortcuts, ownerState } = (0, _usePickerLayout.default)(props);
    const { orientation, variant } = (0, _usePickerContext.usePickerContext)();
    const { sx, className, classes: classesProp } = props;
    const classes = useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersLayoutRoot, {
        ref: ref,
        sx: sx,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersLayoutContentWrapper, {
                className: classes.contentWrapper,
                ownerState: ownerState,
                children: variant === 'desktop' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});

},{"a0e1ce8b1558774a":"9snJq","ecc4b6852b85df6b":"5RcSx","4004bab8e694369b":"9njXz","66ae601af85b9a5c":"bnNSm","210701afde05a16":"by5ni","8789d20639a36e3b":"c9RfU","ad258100d1acc360":"eKeIT","daaa712cc184ac14":"dWjrV","56dd8b822b75b10":"9mPGQ","92372ba8a9503045":"5ATdR","99ac2dfb3438c317":"1dlk8"}],"dWjrV":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("69af34515d192b58").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersLayoutUtilityClass = getPickersLayoutUtilityClass;
exports.pickersLayoutClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("2b42ad674f2f4e88"));
var _generateUtilityClasses = _interopRequireDefault(require("363ac2f2bcafcd3"));
function getPickersLayoutUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersLayout', slot);
}
const pickersLayoutClasses = exports.pickersLayoutClasses = (0, _generateUtilityClasses.default)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);

},{"69af34515d192b58":"9snJq","2b42ad674f2f4e88":"dtNEc","363ac2f2bcafcd3":"2Z0QC"}],"9mPGQ":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("8dd611524f8cdd5").default;
var _interopRequireWildcard = require("b82e125a386b5a77").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("d490d311e65656c3"));
var _extends2 = _interopRequireDefault(require("f13c7923c3ce8a6"));
var React = _interopRequireWildcard(require("d7ae37198a35f9cf"));
var _useSlotProps2 = _interopRequireDefault(require("e12707b9258903ae"));
var _composeClasses = _interopRequireDefault(require("979b3ea76a5614ba"));
var _RtlProvider = require("d49469f5bf8d9ef5");
var _PickersActionBar = require("ad02c560f6db01ba");
var _pickersLayoutClasses = require("eaf0c8a13bfee38");
var _PickersShortcuts = require("6d53f98c3ccadfcf");
var _usePickerPrivateContext = require("a0ff2b9469b1b38b");
var _hooks = require("5b4e91a605c23560");
var _jsxRuntime = require("4a1b2f9a557be088");
const _excluded = [
    "ownerState"
];
function toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersLayoutClasses.getPickersLayoutUtilityClass, classes);
};
const usePickerLayout = (props)=>{
    const { ownerState: pickerOwnerState, defaultActionBarActions } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const { view } = (0, _hooks.usePickerContext)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const { children, slots, slotProps, classes: classesProp } = props;
    const ownerState = React.useMemo(()=>(0, _extends2.default)({}, pickerOwnerState, {
            layoutDirection: isRtl ? 'rtl' : 'ltr',
            hasShortcuts: false
        }), [
        pickerOwnerState,
        isRtl
    ]);
    const classes = useUtilityClasses(classesProp, ownerState);
    // Action bar
    const ActionBar = slots?.actionBar ?? _PickersActionBar.PickersActionBar;
    const _useSlotProps = (0, _useSlotProps2.default)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            actions: defaultActionBarActions
        },
        className: classes.actionBar,
        ownerState
    }), actionBarProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps, _excluded);
    const actionBar = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionBar, (0, _extends2.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, _useSlotProps2.default)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        className: classes.toolbar,
        ownerState
    });
    const toolbar = toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Toolbar, (0, _extends2.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tabs, (0, _extends2.default)({
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? _PickersShortcuts.PickersShortcuts;
    const shortcutsProps = (0, _useSlotProps2.default)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        className: classes.shortcuts,
        ownerState
    });
    const hasShortcuts = Array.isArray(shortcutsProps?.items) && shortcutsProps.items.length > 0;
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Shortcuts, (0, _extends2.default)({}, shortcutsProps)) : null;
    return {
        toolbar,
        content,
        tabs,
        actionBar,
        shortcuts,
        ownerState: (0, _extends2.default)({}, ownerState, {
            hasShortcuts
        })
    };
};
var _default = exports.default = usePickerLayout;

},{"8dd611524f8cdd5":"9snJq","b82e125a386b5a77":"5RcSx","d490d311e65656c3":"jeIdK","f13c7923c3ce8a6":"h7ttl","d7ae37198a35f9cf":"9njXz","e12707b9258903ae":"izoZZ","979b3ea76a5614ba":"eKeIT","d49469f5bf8d9ef5":"ck9Pb","ad02c560f6db01ba":"eYR9r","eaf0c8a13bfee38":"dWjrV","6d53f98c3ccadfcf":"01JJt","a0ff2b9469b1b38b":"8xvkv","5b4e91a605c23560":"6MTP2","4a1b2f9a557be088":"1dlk8"}],"eYR9r":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersActionBar", {
    enumerable: true,
    get: function() {
        return _PickersActionBar.PickersActionBar;
    }
});
var _PickersActionBar = require("5a7483fcc9197eb2");

},{"5a7483fcc9197eb2":"6XTto"}],"6XTto":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("a8687a0c4e5d8e8f").default;
var _interopRequireWildcard = require("ac55a43e0c8e2438").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersActionBar = void 0;
var _extends2 = _interopRequireDefault(require("96ec50705cccb257"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("aba5f5f6ff14bfd7"));
var React = _interopRequireWildcard(require("1344cfff7a568e81"));
var _propTypes = _interopRequireDefault(require("fbecc92bff244bc1"));
var _styles = require("878b2575ba422c9b");
var _Button = _interopRequireDefault(require("63ab7c56d11b9da5"));
var _DialogActions = _interopRequireDefault(require("4a85c3842c18ea22"));
var _usePickerTranslations = require("28f40bb192d53beb");
var _hooks = require("ab1a4183bfb7d834");
var _jsxRuntime = require("ed38d85f6e30f09");
const _excluded = [
    "actions"
];
const PickersActionBarRoot = (0, _styles.styled)(_DialogActions.default, {
    name: 'MuiPickersLayout',
    slot: 'ActionBar'
})({});
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function PickersActionBarComponent(props) {
    const { actions } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const translations = (0, _usePickerTranslations.usePickerTranslations)();
    const { clearValue, setValueToToday, acceptValueChanges, cancelValueChanges, goToNextStep, hasNextStep } = (0, _hooks.usePickerContext)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Button.default, {
                    onClick: clearValue,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Button.default, {
                    onClick: cancelValueChanges,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Button.default, {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Button.default, {
                    onClick: setValueToToday,
                    children: translations.todayButtonLabel
                }, actionType);
            case 'next':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Button.default, {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
            case 'nextOrAccept':
                if (hasNextStep) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Button.default, {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Button.default, {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersActionBarRoot, (0, _extends2.default)({}, other, {
        children: buttons
    }));
}
const PickersActionBar = exports.PickersActionBar = /*#__PURE__*/ React.memo(PickersActionBarComponent);

},{"a8687a0c4e5d8e8f":"9snJq","ac55a43e0c8e2438":"5RcSx","96ec50705cccb257":"h7ttl","aba5f5f6ff14bfd7":"jeIdK","1344cfff7a568e81":"9njXz","fbecc92bff244bc1":"bnNSm","878b2575ba422c9b":"c9RfU","63ab7c56d11b9da5":"c6Y0y","4a85c3842c18ea22":"5WZHz","28f40bb192d53beb":"5FUwu","ab1a4183bfb7d834":"6MTP2","ed38d85f6e30f09":"1dlk8"}],"01JJt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersShortcuts", {
    enumerable: true,
    get: function() {
        return _PickersShortcuts.PickersShortcuts;
    }
});
var _PickersShortcuts = require("1328df6861112daa");

},{"1328df6861112daa":"g31lv"}],"g31lv":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("aa1011a1b98d7499").default;
var _interopRequireWildcard = require("79ffa8d359c8599a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersShortcuts = PickersShortcuts;
var _extends2 = _interopRequireDefault(require("fef360af69599cf7"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("205004e9643ed9eb"));
var React = _interopRequireWildcard(require("f4b881be41e943f3"));
var _styles = require("216d2a6b99ad14b4");
var _propTypes = _interopRequireDefault(require("ee616505980f0c91"));
var _List = _interopRequireDefault(require("5f0b097c9ae06c26"));
var _ListItem = _interopRequireDefault(require("728982b094821825"));
var _Chip = _interopRequireDefault(require("fd9850680f5dfbea"));
var _dimensions = require("4d4a42024cd17b6");
var _hooks = require("a74195ec880e3d9f");
var _jsxRuntime = require("31a224a2ee93faab");
const _excluded = [
    "items",
    "changeImportance"
], _excluded2 = [
    "getValue"
];
const PickersShortcutsRoot = (0, _styles.styled)(_List.default, {
    name: 'MuiPickersLayout',
    slot: 'Shortcuts'
})({});
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function PickersShortcuts(props) {
    const { items, changeImportance = 'accept' } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { setValue } = (0, _hooks.usePickerActionsContext)();
    const isValidValue = (0, _hooks.useIsValidValue)();
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue } = _ref, item = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded2);
        const newValue = getValue({
            isValid: isValidValue
        });
        return (0, _extends2.default)({}, item, {
            label: item.label,
            onClick: ()=>{
                setValue(newValue, {
                    changeImportance,
                    shortcut: item
                });
            },
            disabled: !isValidValue(newValue)
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersShortcutsRoot, (0, _extends2.default)({
        dense: true,
        sx: [
            {
                maxHeight: _dimensions.VIEW_HEIGHT,
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ListItem.default, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Chip.default, (0, _extends2.default)({}, item))
            }, item.id ?? item.label);
        })
    }));
}

},{"aa1011a1b98d7499":"9snJq","79ffa8d359c8599a":"5RcSx","fef360af69599cf7":"h7ttl","205004e9643ed9eb":"jeIdK","f4b881be41e943f3":"9njXz","216d2a6b99ad14b4":"c9RfU","ee616505980f0c91":"bnNSm","5f0b097c9ae06c26":"4j4o2","728982b094821825":"2EejF","fd9850680f5dfbea":"eSSCi","4d4a42024cd17b6":"l0mMZ","a74195ec880e3d9f":"6MTP2","31a224a2ee93faab":"1dlk8"}],"euBpu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createNonRangePickerStepNavigation = createNonRangePickerStepNavigation;
var _createStepNavigation = require("bf3db6b82ec678a3");
function createNonRangePickerStepNavigation(parameters) {
    const { steps } = parameters;
    return (0, _createStepNavigation.createStepNavigation)({
        steps,
        isViewMatchingStep: (view, step)=>{
            return step.views == null || step.views.includes(view);
        },
        onStepChange: ({ step, defaultView, setView, view, views })=>{
            const targetView = step.views == null ? defaultView : step.views.find((viewBis)=>views.includes(viewBis));
            if (targetView !== view) setView(targetView);
        }
    });
}

},{"bf3db6b82ec678a3":"jTht6"}],"kAMAW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDigitalClockTimeView", {
    enumerable: true,
    get: function() {
        return _timeViewRenderers.renderDigitalClockTimeView;
    }
});
Object.defineProperty(exports, "renderMultiSectionDigitalClockTimeView", {
    enumerable: true,
    get: function() {
        return _timeViewRenderers.renderMultiSectionDigitalClockTimeView;
    }
});
Object.defineProperty(exports, "renderTimeViewClock", {
    enumerable: true,
    get: function() {
        return _timeViewRenderers.renderTimeViewClock;
    }
});
var _timeViewRenderers = require("e948f9f689e364bc");

},{"e948f9f689e364bc":"hnTaR"}],"hnTaR":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("eac6edd94f5fb442").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderTimeViewClock = exports.renderMultiSectionDigitalClockTimeView = exports.renderDigitalClockTimeView = void 0;
var React = _interopRequireWildcard(require("6d3a6b7190206f91"));
var _TimeClock = require("89bdad94214cde98");
var _DigitalClock = require("af70db70b91f8e9a");
var _MultiSectionDigitalClock = require("e2b85e932595208d");
var _timeUtils = require("96b2a8381a1ed911");
var _jsxRuntime = require("664130458fb0b0a6");
const renderTimeViewClock = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, ampmInClock, slots, slotProps, readOnly, disabled, sx, autoFocus, showViewSwitcher, disableIgnoringDatePartForTimeValidation, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_TimeClock.TimeClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, _timeUtils.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter(_timeUtils.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
exports.renderTimeViewClock = renderTimeViewClock;
const renderDigitalClockTimeView = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, slots, slotProps, readOnly, disabled, sx, autoFocus, disableIgnoringDatePartForTimeValidation, timeSteps, skipDisabled, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_DigitalClock.DigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, _timeUtils.isTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter(_timeUtils.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps?.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
exports.renderDigitalClockTimeView = renderDigitalClockTimeView;
const renderMultiSectionDigitalClockTimeView = ({ view, onViewChange, focusedView, onFocusedViewChange, views, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minTime, maxTime, shouldDisableTime, minutesStep, ampm, slots, slotProps, readOnly, disabled, sx, autoFocus, disableIgnoringDatePartForTimeValidation, timeSteps, skipDisabled, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_MultiSectionDigitalClock.MultiSectionDigitalClock, {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, _timeUtils.isInternalTimeView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter(_timeUtils.isTimeView),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        minutesStep: minutesStep,
        ampm: ampm,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
exports.renderMultiSectionDigitalClockTimeView = renderMultiSectionDigitalClockTimeView;

},{"eac6edd94f5fb442":"5RcSx","6d3a6b7190206f91":"9njXz","89bdad94214cde98":"lRdAc","af70db70b91f8e9a":"8VVts","e2b85e932595208d":"2hWoB","96b2a8381a1ed911":"gSWbl","664130458fb0b0a6":"1dlk8"}],"lRdAc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TimeClock", {
    enumerable: true,
    get: function() {
        return _TimeClock.TimeClock;
    }
});
Object.defineProperty(exports, "clockClasses", {
    enumerable: true,
    get: function() {
        return _clockClasses.clockClasses;
    }
});
Object.defineProperty(exports, "clockNumberClasses", {
    enumerable: true,
    get: function() {
        return _clockNumberClasses.clockNumberClasses;
    }
});
Object.defineProperty(exports, "clockPointerClasses", {
    enumerable: true,
    get: function() {
        return _clockPointerClasses.clockPointerClasses;
    }
});
Object.defineProperty(exports, "getTimeClockUtilityClass", {
    enumerable: true,
    get: function() {
        return _timeClockClasses.getTimeClockUtilityClass;
    }
});
Object.defineProperty(exports, "timeClockClasses", {
    enumerable: true,
    get: function() {
        return _timeClockClasses.timeClockClasses;
    }
});
var _TimeClock = require("d0871f81db08d8d4");
var _clockClasses = require("a82febc28d49d8");
var _clockNumberClasses = require("5bf5efbfd510b674");
var _timeClockClasses = require("8afa39d9fb9e69d4");
var _clockPointerClasses = require("4377706281624660");

},{"d0871f81db08d8d4":"2Rn7m","a82febc28d49d8":"3PjKA","5bf5efbfd510b674":"7cOO3","8afa39d9fb9e69d4":"bzYo0","4377706281624660":"8CZid"}],"2Rn7m":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("63b8489528bc32aa").default;
var _interopRequireWildcard = require("67bf4793c0a89d92").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeClock = void 0;
var _extends2 = _interopRequireDefault(require("b9aa51f81f1cb56"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("d61ce10ced210df4"));
var React = _interopRequireWildcard(require("8f72e0aea2742cf4"));
var _clsx = _interopRequireDefault(require("db6ebfefe7ce7341"));
var _propTypes = _interopRequireDefault(require("e28232b51c991efc"));
var _styles = require("36dd27b15a2b0bca");
var _composeClasses = _interopRequireDefault(require("af71acf145f81e3f"));
var _useId = _interopRequireDefault(require("78b8de1afad26b40"));
var _hooks = require("e1c525ac2e4f730d");
var _useUtils = require("5f2fb2b08933bbba");
var _PickersArrowSwitcher = require("528e79531f60af25");
var _timeUtils = require("328893e9c81d1e90");
var _useViews = require("ac7d15377c7b92bc");
var _dateHelpersHooks = require("2297d84994407fff");
var _PickerViewRoot = require("94b8a1b148ee5ba2");
var _timeClockClasses = require("c72cfc9e76d01f6c");
var _Clock = require("48f32bb0e396d7fc");
var _ClockNumbers = require("f5c65ed54486f432");
var _useControlledValue = require("75924f5c6d3c7270");
var _valueManagers = require("6342dc077109fa75");
var _useClockReferenceDate = require("79db0586797124f0");
var _usePickerPrivateContext = require("8a6822f202532ceb");
var _jsxRuntime = require("41f0ae8143ad3512");
const _excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, _composeClasses.default)(slots, _timeClockClasses.getTimeClockUtilityClass, classes);
};
const TimeClockRoot = (0, _styles.styled)(_PickerViewRoot.PickerViewRoot, {
    name: 'MuiTimeClock',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
});
const TimeClockArrowSwitcher = (0, _styles.styled)(_PickersArrowSwitcher.PickersArrowSwitcher, {
    name: 'MuiTimeClock',
    slot: 'ArrowSwitcher'
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const TIME_CLOCK_DEFAULT_VIEWS = [
    'hours',
    'minutes'
];
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [TimeClock](https://mui.com/x/react-date-pickers/time-clock/)
 *
 * API:
 *
 * - [TimeClock API](https://mui.com/x/api/date-pickers/time-clock/)
 */ const TimeClock = exports.TimeClock = /*#__PURE__*/ React.forwardRef(function TimeClock(inProps, ref) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiTimeClock'
    });
    const { ampm = adapter.is12HourCycleInCurrentLocale(), ampmInClock = false, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, showViewSwitcher, onChange, view: inView, views = TIME_CLOCK_DEFAULT_VIEWS, openTo, onViewChange, focusedView, onFocusedViewChange, className, classes: classesProp, disabled, readOnly, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValue.useControlledValue)({
        name: 'TimeClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: _valueManagers.singleItemValueManager
    });
    const valueOrReferenceDate = (0, _useClockReferenceDate.useClockReferenceDate)({
        value,
        referenceDate: referenceDateProp,
        adapter,
        props,
        timezone
    });
    const translations = (0, _hooks.usePickerTranslations)();
    const now = (0, _useUtils.useNow)(timezone);
    const selectedId = (0, _useId.default)();
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const { view, setView, previousView, nextView, setValueAndGoToNextView } = (0, _useViews.useViews)({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView,
        onFocusedViewChange
    });
    const { meridiemMode, handleMeridiemChange } = (0, _dateHelpersHooks.useMeridiemMode)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = React.useCallback((rawValue, viewType)=>{
        const isAfter = (0, _timeUtils.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start, end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, _timeUtils.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const viewProps = React.useMemo(()=>{
        switch(view){
            case 'hours':
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, _timeUtils.convertValueToMeridiem)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish, 'hours');
                    };
                    const viewValue = adapter.getHours(valueOrReferenceDate);
                    let viewRange;
                    if (ampm) {
                        if (viewValue > 12) viewRange = [
                            12,
                            23
                        ];
                        else viewRange = [
                            0,
                            11
                        ];
                    } else viewRange = [
                        0,
                        23
                    ];
                    return {
                        onChange: handleHoursChange,
                        viewValue,
                        children: (0, _ClockNumbers.getHourNumbers)({
                            value,
                            adapter,
                            ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: translations.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, 'hours'),
                            selectedId
                        }),
                        viewRange
                    };
                }
            case 'minutes':
                {
                    const minutesValue = adapter.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minuteValue), isFinish, 'minutes');
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, _ClockNumbers.getMinutesNumbers)({
                            adapter,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: translations.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, 'minutes'),
                            selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            case 'seconds':
                {
                    const secondsValue = adapter.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, secondValue), isFinish, 'seconds');
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, _ClockNumbers.getMinutesNumbers)({
                            adapter,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: translations.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, 'seconds'),
                            selectedId
                        }),
                        viewRange: [
                            0,
                            59
                        ]
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        view,
        adapter,
        value,
        ampm,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TimeClockRoot, (0, _extends2.default)({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Clock.Clock, (0, _extends2.default)({
                autoFocus: autoFocus ?? !!focusedView,
                ampmInClock: ampmInClock && views.includes('hours'),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: translations.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: translations.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});

},{"63b8489528bc32aa":"9snJq","67bf4793c0a89d92":"5RcSx","b9aa51f81f1cb56":"h7ttl","d61ce10ced210df4":"jeIdK","8f72e0aea2742cf4":"9njXz","db6ebfefe7ce7341":"by5ni","e28232b51c991efc":"bnNSm","36dd27b15a2b0bca":"c9RfU","af71acf145f81e3f":"eKeIT","78b8de1afad26b40":"icfbA","e1c525ac2e4f730d":"6MTP2","5f2fb2b08933bbba":"j0icU","528e79531f60af25":"1dVlM","328893e9c81d1e90":"gSWbl","ac7d15377c7b92bc":"6z8XQ","2297d84994407fff":"b2RZ3","94b8a1b148ee5ba2":"cfp4O","c72cfc9e76d01f6c":"bzYo0","48f32bb0e396d7fc":"eZdan","f5c65ed54486f432":"iQ90D","75924f5c6d3c7270":"gd9Iu","6342dc077109fa75":"03AqV","79db0586797124f0":"joJz2","8a6822f202532ceb":"8xvkv","41f0ae8143ad3512":"1dlk8"}],"1dVlM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersArrowSwitcher", {
    enumerable: true,
    get: function() {
        return _PickersArrowSwitcher.PickersArrowSwitcher;
    }
});
Object.defineProperty(exports, "getPickersArrowSwitcherUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersArrowSwitcherClasses.getPickersArrowSwitcherUtilityClass;
    }
});
Object.defineProperty(exports, "pickersArrowSwitcherClasses", {
    enumerable: true,
    get: function() {
        return _pickersArrowSwitcherClasses.pickersArrowSwitcherClasses;
    }
});
var _PickersArrowSwitcher = require("3598ebb974afce14");
var _pickersArrowSwitcherClasses = require("1c98a02e621b4e61");

},{"3598ebb974afce14":"gOIGS","1c98a02e621b4e61":"9VkHu"}],"gOIGS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("fc1439fc73c28e76").default;
var _interopRequireWildcard = require("c5d2068ca7c8ca63").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersArrowSwitcher = void 0;
var _extends2 = _interopRequireDefault(require("efd508882a947262"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("84c8e601e7ebbbc1"));
var React = _interopRequireWildcard(require("5438ab427b2025e4"));
var _clsx = _interopRequireDefault(require("dbfea0ed41981c1f"));
var _Typography = _interopRequireDefault(require("e8f9c8fc37db1d1b"));
var _RtlProvider = require("f2d3a4302a85cc51");
var _styles = require("d84e3af7f7a18820");
var _composeClasses = _interopRequireDefault(require("33154e17f710d8af"));
var _useSlotProps3 = _interopRequireDefault(require("a9e53278127fd093"));
var _IconButton = _interopRequireDefault(require("bed49d7d186fb2"));
var _icons = require("84a9c54e5dea2d31");
var _pickersArrowSwitcherClasses = require("ba4bc11cf1506b1");
var _usePickerPrivateContext = require("4754f174231fa80c");
var _jsxRuntime = require("3a70e112a7303879");
const _excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId",
    "classes"
], _excluded2 = [
    "ownerState"
], _excluded3 = [
    "ownerState"
];
const PickersArrowSwitcherRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root'
})({
    display: 'flex'
});
const PickersArrowSwitcherSpacer = (0, _styles.styled)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer'
})(({ theme })=>({
        width: theme.spacing(3)
    }));
const PickersArrowSwitcherButton = (0, _styles.styled)(_IconButton.default, {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button'
})({
    variants: [
        {
            props: {
                isButtonHidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersArrowSwitcherClasses.getPickersArrowSwitcherUtilityClass, classes);
};
const PickersArrowSwitcher = exports.PickersArrowSwitcher = /*#__PURE__*/ React.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, _RtlProvider.useRtl)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children, className, slots, slotProps, isNextDisabled, isNextHidden, onGoToNext, nextLabel, isPreviousDisabled, isPreviousHidden, onGoToPrevious, previousLabel, labelId, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const classes = useUtilityClasses(classesProp);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, _useSlotProps3.default)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, _extends2.default)({}, ownerState, {
            isButtonHidden: previousProps.isHidden ?? false
        }),
        className: (0, _clsx.default)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, _useSlotProps3.default)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, _extends2.default)({}, ownerState, {
            isButtonHidden: nextProps.isHidden ?? false
        }),
        className: (0, _clsx.default)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? _icons.ArrowLeftIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, _useSlotProps3.default)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps, _excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? _icons.ArrowRightIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, _useSlotProps3.default)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps2, _excluded3);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersArrowSwitcherRoot, (0, _extends2.default)({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviousIconButton, (0, _extends2.default)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightArrowIcon, (0, _extends2.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftArrowIcon, (0, _extends2.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Typography.default, {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NextIconButton, (0, _extends2.default)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftArrowIcon, (0, _extends2.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightArrowIcon, (0, _extends2.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});

},{"fc1439fc73c28e76":"9snJq","c5d2068ca7c8ca63":"5RcSx","efd508882a947262":"h7ttl","84c8e601e7ebbbc1":"jeIdK","5438ab427b2025e4":"9njXz","dbfea0ed41981c1f":"by5ni","e8f9c8fc37db1d1b":"2wCD5","f2d3a4302a85cc51":"ck9Pb","d84e3af7f7a18820":"c9RfU","33154e17f710d8af":"eKeIT","a9e53278127fd093":"izoZZ","bed49d7d186fb2":"bXjnZ","84a9c54e5dea2d31":"ezFd3","ba4bc11cf1506b1":"9VkHu","4754f174231fa80c":"8xvkv","3a70e112a7303879":"1dlk8"}],"9VkHu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("40e7b869d4104ae2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersArrowSwitcherUtilityClass = getPickersArrowSwitcherUtilityClass;
exports.pickersArrowSwitcherClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("46d7e614699bbbc4"));
var _generateUtilityClasses = _interopRequireDefault(require("dcd4617620a59625"));
function getPickersArrowSwitcherUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersArrowSwitcher', slot);
}
const pickersArrowSwitcherClasses = exports.pickersArrowSwitcherClasses = (0, _generateUtilityClasses.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);

},{"40e7b869d4104ae2":"9snJq","46d7e614699bbbc4":"dtNEc","dcd4617620a59625":"2Z0QC"}],"cfp4O":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickerViewRoot", {
    enumerable: true,
    get: function() {
        return _PickerViewRoot.PickerViewRoot;
    }
});
var _PickerViewRoot = require("dd54082790ed17c4");

},{"dd54082790ed17c4":"6IoRU"}],"6IoRU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickerViewRoot = void 0;
var _styles = require("af95e9e33b09413d");
var _dimensions = require("e28f2998a03e2c29");
const PickerViewRoot = exports.PickerViewRoot = (0, _styles.styled)('div')({
    overflow: 'hidden',
    width: _dimensions.DIALOG_WIDTH,
    maxHeight: _dimensions.VIEW_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});

},{"af95e9e33b09413d":"c9RfU","e28f2998a03e2c29":"l0mMZ"}],"bzYo0":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("dac32c476dc48538").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTimeClockUtilityClass = getTimeClockUtilityClass;
exports.timeClockClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("d4a7260884fdea7c"));
var _generateUtilityClasses = _interopRequireDefault(require("7b4b676cbf5ccc9c"));
function getTimeClockUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiTimeClock', slot);
}
const timeClockClasses = exports.timeClockClasses = (0, _generateUtilityClasses.default)('MuiTimeClock', [
    'root',
    'arrowSwitcher'
]);

},{"dac32c476dc48538":"9snJq","d4a7260884fdea7c":"dtNEc","7b4b676cbf5ccc9c":"2Z0QC"}],"eZdan":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("be8d968186308476").default;
var _interopRequireDefault = require("a7b1eaa0580cfa13").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Clock = Clock;
var _extends2 = _interopRequireDefault(require("dcb55eb494d6b7ec"));
var React = _interopRequireWildcard(require("121f5babc1a85ab"));
var _clsx = _interopRequireDefault(require("9caa738f8673751d"));
var _IconButton = _interopRequireDefault(require("74f0a2d8e6e93ef"));
var _Typography = _interopRequireDefault(require("1445586bee7f0d36"));
var _styles = require("6a4ad384a9c49aa5");
var _useEnhancedEffect = _interopRequireDefault(require("2ac328b6057276f5"));
var _composeClasses = _interopRequireDefault(require("e5b8b60d894693f2"));
var _ClockPointer = require("5ca5854516157f58");
var _hooks = require("ff48b4aabfb17c99");
var _shared = require("c413ab051e09dbc9");
var _clockClasses = require("5fb0b63d9225355f");
var _dateUtils = require("3a90cb11b44b06c1");
var _usePickerPrivateContext = require("d9ccde0a172c652f");
var _jsxRuntime = require("eee8db151abaf9fe");
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton',
            ownerState.clockMeridiemMode === 'am' && 'selected'
        ],
        pmButton: [
            'pmButton',
            ownerState.clockMeridiemMode === 'pm' && 'selected'
        ],
        meridiemText: [
            'meridiemText'
        ]
    };
    return (0, _composeClasses.default)(slots, _clockClasses.getClockUtilityClass, classes);
};
const ClockRoot = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Root'
})(({ theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const ClockClock = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Clock'
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const ClockWrapper = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Wrapper'
})({
    '&:focus': {
        outline: 'none'
    }
});
const ClockSquareMask = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'SquareMask'
})({
    width: '100%',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'auto',
    outline: 0,
    // Disable scroll capabilities.
    touchAction: 'none',
    userSelect: 'none',
    variants: [
        {
            props: {
                isClockDisabled: false
            },
            style: {
                '@media (pointer: fine)': {
                    cursor: 'pointer',
                    borderRadius: '50%'
                },
                '&:active': {
                    cursor: 'move'
                }
            }
        }
    ]
});
const ClockPin = (0, _styles.styled)('div', {
    name: 'MuiClock',
    slot: 'Pin'
})(({ theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const meridiemButtonCommonStyles = (theme, clockMeridiemMode)=>({
        zIndex: 1,
        bottom: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: _shared.CLOCK_HOUR_WIDTH,
        variants: [
            {
                props: {
                    clockMeridiemMode
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main,
                    color: (theme.vars || theme).palette.primary.contrastText,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette.primary.light
                    }
                }
            }
        ]
    });
const ClockAmButton = (0, _styles.styled)(_IconButton.default, {
    name: 'MuiClock',
    slot: 'AmButton'
})(({ theme })=>(0, _extends2.default)({}, meridiemButtonCommonStyles(theme, 'am'), {
        // keeping it here to make TS happy
        position: 'absolute',
        left: 8
    }));
const ClockPmButton = (0, _styles.styled)(_IconButton.default, {
    name: 'MuiClock',
    slot: 'PmButton'
})(({ theme })=>(0, _extends2.default)({}, meridiemButtonCommonStyles(theme, 'pm'), {
        // keeping it here to make TS happy
        position: 'absolute',
        right: 8
    }));
const ClockMeridiemText = (0, _styles.styled)(_Typography.default, {
    name: 'MuiClock',
    slot: 'MeridiemText'
})({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
/**
 * @ignore - internal component.
 */ function Clock(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm, ampmInClock, autoFocus, children, value, handleMeridiemChange, isTimeDisabled, meridiemMode, minutesStep = 1, onChange, selectedId, type, viewValue, viewRange: [minViewValue, maxViewValue], disabled = false, readOnly, className, classes: classesProp } = props;
    const adapter = (0, _hooks.usePickerAdapter)();
    const translations = (0, _hooks.usePickerTranslations)();
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        isClockDisabled: disabled,
        clockMeridiemMode: meridiemMode
    });
    const isMoving = React.useRef(false);
    const classes = useUtilityClasses(classesProp, ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === 'hours' && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX, offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, _shared.getMinutes)(offsetX, offsetY, minutesStep) : (0, _shared.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchSelection = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
        event.preventDefault();
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const isPointerBetweenTwoClockValues = type === 'hours' ? false : viewValue % 5 !== 0;
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = React.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const clampValue = (newValue)=>Math.max(minViewValue, Math.min(maxViewValue, newValue));
    const circleValue = (newValue)=>(newValue + (maxViewValue + 1)) % (maxViewValue + 1);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // reset both hours and minutes
                handleValueChange(minViewValue, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(maxViewValue, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(circleValue(viewValue + keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(circleValue(viewValue - keyboardControlStep), 'partial');
                event.preventDefault();
                break;
            case 'PageUp':
                handleValueChange(clampValue(viewValue + 5), 'partial');
                event.preventDefault();
                break;
            case 'PageDown':
                handleValueChange(clampValue(viewValue - 5), 'partial');
                event.preventDefault();
                break;
            case 'Enter':
            case ' ':
                handleValueChange(viewValue, 'finish');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ClockRoot, {
        className: (0, _clsx.default)(classes.root, className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockSquareMask, {
                        onTouchMove: handleTouchSelection,
                        onTouchStart: handleTouchSelection,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: ownerState,
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ClockPointer.ClockPointer, {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                isBetweenTwoClockValues: isPointerBetweenTwoClockValues
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": translations.clockLabelText(type, value == null ? null : adapter.format(value, ampm ? 'fullTime12h' : 'fullTime24h')),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, _dateUtils.formatMeridiem)(adapter, 'am'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, _dateUtils.formatMeridiem)(adapter, 'am')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, _dateUtils.formatMeridiem)(adapter, 'pm'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, _dateUtils.formatMeridiem)(adapter, 'pm')
                        })
                    })
                ]
            })
        ]
    });
}

},{"be8d968186308476":"5RcSx","a7b1eaa0580cfa13":"9snJq","dcb55eb494d6b7ec":"h7ttl","121f5babc1a85ab":"9njXz","9caa738f8673751d":"by5ni","74f0a2d8e6e93ef":"bXjnZ","1445586bee7f0d36":"2wCD5","6a4ad384a9c49aa5":"c9RfU","2ac328b6057276f5":"foonr","e5b8b60d894693f2":"eKeIT","5ca5854516157f58":"lGPW5","ff48b4aabfb17c99":"6MTP2","c413ab051e09dbc9":"eEtaH","5fb0b63d9225355f":"3PjKA","3a90cb11b44b06c1":"jwfEA","d9ccde0a172c652f":"8xvkv","eee8db151abaf9fe":"1dlk8"}],"lGPW5":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("ffe6c0d498573264").default;
var _interopRequireWildcard = require("8392854dc71c112c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClockPointer = ClockPointer;
var _extends2 = _interopRequireDefault(require("b26a2960e1b86534"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("d04ae00f4eb2bc25"));
var React = _interopRequireWildcard(require("7f4fd4fd5d4bdf86"));
var _clsx = _interopRequireDefault(require("fc554b2ace1750d6"));
var _styles = require("274492b9cc4b03f2");
var _composeClasses = _interopRequireDefault(require("e2bcf8aeeb2d56e0"));
var _shared = require("4d219403d959ea38");
var _clockPointerClasses = require("d056ecb53b77cbd6");
var _usePickerPrivateContext = require("bbb17b280b1e3c3f");
var _jsxRuntime = require("b39046b37cd92b64");
const _excluded = [
    "className",
    "classes",
    "isBetweenTwoClockValues",
    "isInner",
    "type",
    "viewValue"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, _composeClasses.default)(slots, _clockPointerClasses.getClockPointerUtilityClass, classes);
};
const ClockPointerRoot = (0, _styles.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Root'
})(({ theme })=>({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px',
        variants: [
            {
                props: {
                    isClockPointerAnimated: true
                },
                style: {
                    transition: theme.transitions.create([
                        'transform',
                        'height'
                    ])
                }
            }
        ]
    }));
const ClockPointerThumb = (0, _styles.styled)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb'
})(({ theme })=>({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${_shared.CLOCK_HOUR_WIDTH / 2}px)`,
        border: `${(_shared.CLOCK_HOUR_WIDTH - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: 'content-box',
        variants: [
            {
                props: {
                    isClockPointerBetweenTwoValues: false
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function ClockPointer(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className, classes: classesProp, isBetweenTwoClockValues, isInner, type, viewValue } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const previousType = React.useRef(type);
    React.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        isClockPointerAnimated: previousType.current !== type,
        isClockPointerBetweenTwoValues: isBetweenTwoClockValues
    });
    const classes = useUtilityClasses(classesProp);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === 'hours' && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * _shared.CLOCK_WIDTH),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPointerRoot, (0, _extends2.default)({
        style: getAngleStyle(),
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

},{"ffe6c0d498573264":"9snJq","8392854dc71c112c":"5RcSx","b26a2960e1b86534":"h7ttl","d04ae00f4eb2bc25":"jeIdK","7f4fd4fd5d4bdf86":"9njXz","fc554b2ace1750d6":"by5ni","274492b9cc4b03f2":"c9RfU","e2bcf8aeeb2d56e0":"eKeIT","4d219403d959ea38":"eEtaH","d056ecb53b77cbd6":"8CZid","bbb17b280b1e3c3f":"8xvkv","b39046b37cd92b64":"1dlk8"}],"eEtaH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMinutes = exports.getHours = exports.CLOCK_WIDTH = exports.CLOCK_HOUR_WIDTH = void 0;
const CLOCK_WIDTH = exports.CLOCK_WIDTH = 220;
const CLOCK_HOUR_WIDTH = exports.CLOCK_HOUR_WIDTH = 36;
const clockCenter = {
    x: CLOCK_WIDTH / 2,
    y: CLOCK_WIDTH / 2
};
const baseClockPoint = {
    x: clockCenter.x,
    y: 0
};
const cx = baseClockPoint.x - clockCenter.x;
const cy = baseClockPoint.y - clockCenter.y;
const rad2deg = (rad)=>rad * (180 / Math.PI);
const getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - clockCenter.x;
    const y = offsetY - clockCenter.y;
    const atan = Math.atan2(cx, cy) - Math.atan2(x, y);
    let deg = rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value,
        distance
    };
};
const getMinutes = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value } = getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
exports.getMinutes = getMinutes;
const getHours = (offsetX, offsetY, ampm)=>{
    const { value, distance } = getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};
exports.getHours = getHours;

},{}],"8CZid":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("62d0aa1bedbabc3").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clockPointerClasses = void 0;
exports.getClockPointerUtilityClass = getClockPointerUtilityClass;
var _generateUtilityClass = _interopRequireDefault(require("3a400696919e24ea"));
var _generateUtilityClasses = _interopRequireDefault(require("80caab2aa47c881d"));
function getClockPointerUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiClockPointer', slot);
}
const clockPointerClasses = exports.clockPointerClasses = (0, _generateUtilityClasses.default)('MuiClockPointer', [
    'root',
    'thumb'
]);

},{"62d0aa1bedbabc3":"9snJq","3a400696919e24ea":"dtNEc","80caab2aa47c881d":"2Z0QC"}],"3PjKA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("58c7bb917e81eb6f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clockClasses = void 0;
exports.getClockUtilityClass = getClockUtilityClass;
var _generateUtilityClass = _interopRequireDefault(require("41f9c0e36b09ef9d"));
var _generateUtilityClasses = _interopRequireDefault(require("252f3ef9cecb4cb4"));
function getClockUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiClock', slot);
}
const clockClasses = exports.clockClasses = (0, _generateUtilityClasses.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton',
    'meridiemText',
    'selected'
]);

},{"58c7bb917e81eb6f":"9snJq","41f9c0e36b09ef9d":"dtNEc","252f3ef9cecb4cb4":"2Z0QC"}],"iQ90D":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("72b65f86d8b2dff9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMinutesNumbers = exports.getHourNumbers = void 0;
var React = _interopRequireWildcard(require("e4d6779ae75ef4b1"));
var _ClockNumber = require("d340913d33ab8e91");
var _jsxRuntime = require("e23e5b5cb4a93fef");
/**
 * @ignore - internal component.
 */ const getHourNumbers = ({ ampm, value, getClockNumberText, isDisabled, selectedId, adapter })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = adapter.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(_ClockNumber.ClockNumber, {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
exports.getHourNumbers = getHourNumbers;
const getMinutesNumbers = ({ adapter, value, isDisabled, getClockNumberText, selectedId })=>{
    const f = adapter.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ClockNumber.ClockNumber, {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};
exports.getMinutesNumbers = getMinutesNumbers;

},{"72b65f86d8b2dff9":"5RcSx","e4d6779ae75ef4b1":"9njXz","d340913d33ab8e91":"1nzsq","e23e5b5cb4a93fef":"1dlk8"}],"1nzsq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ddb20543fcecc56b").default;
var _interopRequireWildcard = require("3dec4bd0c00d0ebf").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClockNumber = ClockNumber;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("720b7c8587d34375"));
var _extends2 = _interopRequireDefault(require("8d66c98bf206c3ad"));
var React = _interopRequireWildcard(require("1b878eb67863c5cc"));
var _clsx = _interopRequireDefault(require("617370dd7868d2f4"));
var _styles = require("c2546713a50f3a16");
var _composeClasses = _interopRequireDefault(require("1f37277cd303d373"));
var _shared = require("e8a5d92887d1f0b4");
var _clockNumberClasses = require("667e00c7df29888e");
var _usePickerPrivateContext = require("de6bce52e8c5c337");
var _jsxRuntime = require("f1ac5181a2319ad0");
const _excluded = [
    "className",
    "classes",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        root: [
            'root',
            ownerState.isClockNumberSelected && 'selected',
            ownerState.isClockNumberDisabled && 'disabled'
        ]
    };
    return (0, _composeClasses.default)(slots, _clockNumberClasses.getClockNumberUtilityClass, classes);
};
const ClockNumberRoot = (0, _styles.styled)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${_clockNumberClasses.clockNumberClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${_clockNumberClasses.clockNumberClasses.selected}`]: styles.selected
            }
        ]
})(({ theme })=>({
        height: _shared.CLOCK_HOUR_WIDTH,
        width: _shared.CLOCK_HOUR_WIDTH,
        position: 'absolute',
        left: `calc((100% - ${_shared.CLOCK_HOUR_WIDTH}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${_clockNumberClasses.clockNumberClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${_clockNumberClasses.clockNumberClasses.disabled}`]: {
            pointerEvents: 'none',
            color: (theme.vars || theme).palette.text.disabled
        },
        variants: [
            {
                props: {
                    isClockNumberInInnerRing: true
                },
                style: (0, _extends2.default)({}, theme.typography.body2, {
                    color: (theme.vars || theme).palette.text.secondary
                })
            }
        ]
    }));
/**
 * @ignore - internal component.
 */ function ClockNumber(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className, classes: classesProp, disabled, index, inner, label, selected } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        isClockNumberInInnerRing: inner,
        isClockNumberSelected: selected,
        isClockNumberDisabled: disabled
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = (_shared.CLOCK_WIDTH - _shared.CLOCK_HOUR_WIDTH - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockNumberRoot, (0, _extends2.default)({
        className: (0, _clsx.default)(classes.root, className),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + (_shared.CLOCK_WIDTH - _shared.CLOCK_HOUR_WIDTH) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

},{"ddb20543fcecc56b":"9snJq","3dec4bd0c00d0ebf":"5RcSx","720b7c8587d34375":"jeIdK","8d66c98bf206c3ad":"h7ttl","1b878eb67863c5cc":"9njXz","617370dd7868d2f4":"by5ni","c2546713a50f3a16":"c9RfU","1f37277cd303d373":"eKeIT","e8a5d92887d1f0b4":"eEtaH","667e00c7df29888e":"7cOO3","de6bce52e8c5c337":"8xvkv","f1ac5181a2319ad0":"1dlk8"}],"7cOO3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9f2126a51061850f").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clockNumberClasses = void 0;
exports.getClockNumberUtilityClass = getClockNumberUtilityClass;
var _generateUtilityClass = _interopRequireDefault(require("1b26545ed6f9b8fd"));
var _generateUtilityClasses = _interopRequireDefault(require("16e0b51afcace1a3"));
function getClockNumberUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiClockNumber', slot);
}
const clockNumberClasses = exports.clockNumberClasses = (0, _generateUtilityClasses.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);

},{"9f2126a51061850f":"9snJq","1b26545ed6f9b8fd":"dtNEc","16e0b51afcace1a3":"2Z0QC"}],"joJz2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("46a03090e925336e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useClockReferenceDate = void 0;
var React = _interopRequireWildcard(require("7e1b71d633185f66"));
var _valueManagers = require("1f96c31e90da8300");
var _dateUtils = require("fb5f51cde69d681a");
var _getDefaultReferenceDate = require("a23cd0401b78e8b3");
const useClockReferenceDate = ({ value, referenceDate: referenceDateProp, adapter, props, timezone })=>{
    const referenceDate = React.useMemo(()=>_valueManagers.singleItemValueManager.getInitialReferenceValue({
            value,
            adapter,
            props,
            referenceDate: referenceDateProp,
            granularity: _getDefaultReferenceDate.SECTION_TYPE_GRANULARITY.day,
            timezone,
            getTodayDate: ()=>(0, _dateUtils.getTodayDate)(adapter, timezone, 'date')
        }), // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    [
        referenceDateProp,
        timezone
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value ?? referenceDate;
};
exports.useClockReferenceDate = useClockReferenceDate;

},{"46a03090e925336e":"5RcSx","7e1b71d633185f66":"9njXz","1f96c31e90da8300":"03AqV","fb5f51cde69d681a":"jwfEA","a23cd0401b78e8b3":"kOJTa"}],"8VVts":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DigitalClock", {
    enumerable: true,
    get: function() {
        return _DigitalClock.DigitalClock;
    }
});
Object.defineProperty(exports, "DigitalClockItem", {
    enumerable: true,
    get: function() {
        return _DigitalClock.DigitalClockItem;
    }
});
Object.defineProperty(exports, "digitalClockClasses", {
    enumerable: true,
    get: function() {
        return _digitalClockClasses.digitalClockClasses;
    }
});
Object.defineProperty(exports, "getDigitalClockUtilityClass", {
    enumerable: true,
    get: function() {
        return _digitalClockClasses.getDigitalClockUtilityClass;
    }
});
var _DigitalClock = require("5e58e77384302481");
var _digitalClockClasses = require("50b0427bbe83e136");

},{"5e58e77384302481":"fT3PL","50b0427bbe83e136":"qpHS4"}],"fT3PL":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("415b73324aba50d9").default;
var _interopRequireWildcard = require("1780d7dd88074d80").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DigitalClockItem = exports.DigitalClock = void 0;
var _extends2 = _interopRequireDefault(require("6a6539c9a5e5c916"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("94fe0d15fcbc9d43"));
var React = _interopRequireWildcard(require("cf1c80333638ac29"));
var _clsx = _interopRequireDefault(require("8a3b59e1d3bfcd19"));
var _propTypes = _interopRequireDefault(require("a2b663d8f8b77991"));
var _useSlotProps = _interopRequireDefault(require("33e2d798a143a209"));
var _styles = require("4989310b0ab36421");
var _useEventCallback = _interopRequireDefault(require("f3a6414944bf840e"));
var _composeClasses = _interopRequireDefault(require("94b418373bc4e0ea"));
var _MenuItem = _interopRequireDefault(require("de5553632f1279cc"));
var _MenuList = _interopRequireDefault(require("91bc47246db826da"));
var _useForkRef = _interopRequireDefault(require("8de762d4e4af946"));
var _useEnhancedEffect = _interopRequireDefault(require("b708f09059b2e1c0"));
var _hooks = require("4bea4b78f247589d");
var _useUtils = require("626aeba17db0298f");
var _timeUtils = require("6c372c8ba7d0f54a");
var _PickerViewRoot = require("c973861fc1618859");
var _digitalClockClasses = require("2078449608a091e2");
var _useViews = require("fd1db2f6c28e6614");
var _dimensions = require("d2761b96f6c78600");
var _useControlledValue = require("18f84d778ba5c8e3");
var _valueManagers = require("413d591e56a66582");
var _useClockReferenceDate = require("406ab40d2f2c58c1");
var _utils = require("a2090a73845f089b");
var _usePickerPrivateContext = require("4fd4f764b20cab9");
var _jsxRuntime = require("915d8914a5255876");
const _excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        list: [
            'list'
        ],
        item: [
            'item'
        ]
    };
    return (0, _composeClasses.default)(slots, _digitalClockClasses.getDigitalClockUtilityClass, classes);
};
const DigitalClockRoot = (0, _styles.styled)(_PickerViewRoot.PickerViewRoot, {
    name: 'MuiDigitalClock',
    slot: 'Root'
})({
    overflowY: 'auto',
    width: '100%',
    scrollbarWidth: 'thin',
    '@media (prefers-reduced-motion: no-preference)': {
        scrollBehavior: 'auto'
    },
    maxHeight: _dimensions.DIGITAL_CLOCK_VIEW_HEIGHT,
    variants: [
        {
            props: {
                hasDigitalClockAlreadyBeenRendered: true
            },
            style: {
                '@media (prefers-reduced-motion: no-preference)': {
                    scrollBehavior: 'smooth'
                }
            }
        }
    ]
});
const DigitalClockList = (0, _styles.styled)(_MenuList.default, {
    name: 'MuiDigitalClock',
    slot: 'List'
})({
    padding: 0
});
const DigitalClockItem = exports.DigitalClockItem = (0, _styles.styled)(_MenuItem.default, {
    name: 'MuiDigitalClock',
    slot: 'Item',
    shouldForwardProp: (prop)=>prop !== 'itemValue' && prop !== 'formattedValue'
})(({ theme })=>({
        padding: '8px 16px',
        margin: '2px 4px',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [DigitalClock](https://mui.com/x/react-date-pickers/digital-clock/)
 *
 * API:
 *
 * - [DigitalClock API](https://mui.com/x/api/date-pickers/digital-clock/)
 */ const DigitalClock = exports.DigitalClock = /*#__PURE__*/ React.forwardRef(function DigitalClock(inProps, ref) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const containerRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(ref, containerRef);
    const listRef = React.useRef(null);
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDigitalClock'
    });
    const { ampm = adapter.is12HourCycleInCurrentLocale(), timeStep = 30, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, onChange, view: inView, openTo, onViewChange, focusedView, onFocusedViewChange, className, classes: classesProp, disabled, readOnly, views = [
        'hours'
    ], skipDisabled = false, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { value, handleValueChange: handleRawValueChange, timezone } = (0, _useControlledValue.useControlledValue)({
        name: 'DigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: _valueManagers.singleItemValueManager
    });
    const translations = (0, _hooks.usePickerTranslations)();
    const now = (0, _useUtils.useNow)(timezone);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = useUtilityClasses(classesProp);
    const ClockItem = slots?.digitalClockItem ?? DigitalClockItem;
    const clockItemProps = (0, _useSlotProps.default)({
        elementType: ClockItem,
        externalSlotProps: slotProps?.digitalClockItem,
        ownerState,
        className: classes.item
    });
    const valueOrReferenceDate = (0, _useClockReferenceDate.useClockReferenceDate)({
        value,
        referenceDate: referenceDateProp,
        adapter,
        props,
        timezone
    });
    const handleValueChange = (0, _useEventCallback.default)((newValue)=>handleRawValueChange(newValue, 'finish', 'hours'));
    const { setValueAndGoToNextView } = (0, _useViews.useViews)({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView,
        onFocusedViewChange
    });
    const handleItemSelect = (0, _useEventCallback.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish');
    });
    (0, _useEnhancedEffect.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
        if (!activeItem) return;
        const offsetTop = activeItem.offsetTop;
        if (autoFocus || !!focusedView) activeItem.focus();
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = React.useCallback((valueToCheck)=>{
        const isAfter = (0, _timeUtils.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (adapter.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, 'hours');
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        adapter,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableTime
    ]);
    const timeOptions = React.useMemo(()=>{
        const result = [];
        const startOfDay = adapter.startOfDay(valueOrReferenceDate);
        let nextTimeStepOption = startOfDay;
        while(adapter.isSameDay(valueOrReferenceDate, nextTimeStepOption)){
            result.push(nextTimeStepOption);
            nextTimeStepOption = adapter.addMinutes(nextTimeStepOption, timeStep);
        }
        return result;
    }, [
        valueOrReferenceDate,
        timeStep,
        adapter
    ]);
    const focusedOptionIndex = timeOptions.findIndex((option)=>adapter.isEqual(option, valueOrReferenceDate));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, _utils.getFocusedListItemIndex)(listRef.current) - 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, _utils.getFocusedListItemIndex)(listRef.current) + 5;
                    const children = listRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DigitalClockRoot, (0, _extends2.default)({
        ref: handleRef,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DigitalClockList, {
            ref: listRef,
            role: "listbox",
            "aria-label": translations.timePickerToolbarTitle,
            className: classes.list,
            onKeyDown: handleKeyDown,
            children: timeOptions.map((option, index)=>{
                const optionDisabled = isTimeDisabled(option);
                if (skipDisabled && optionDisabled) return null;
                const isSelected = adapter.isEqual(option, value);
                const formattedValue = adapter.format(option, ampm ? 'fullTime12h' : 'fullTime24h');
                const isFocused = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0;
                const tabIndex = isFocused ? 0 : -1;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClockItem, (0, _extends2.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || optionDisabled,
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected,
                    tabIndex: tabIndex,
                    itemValue: option,
                    formattedValue: formattedValue
                }, clockItemProps, {
                    children: formattedValue
                }), `${option.valueOf()}-${formattedValue}`);
            })
        })
    }));
});

},{"415b73324aba50d9":"9snJq","1780d7dd88074d80":"5RcSx","6a6539c9a5e5c916":"h7ttl","94fe0d15fcbc9d43":"jeIdK","cf1c80333638ac29":"9njXz","8a3b59e1d3bfcd19":"by5ni","a2b663d8f8b77991":"bnNSm","33e2d798a143a209":"izoZZ","4989310b0ab36421":"c9RfU","f3a6414944bf840e":"lkrdI","94b418373bc4e0ea":"eKeIT","de5553632f1279cc":"a18vm","91bc47246db826da":"eogrV","8de762d4e4af946":"93645","b708f09059b2e1c0":"foonr","4bea4b78f247589d":"6MTP2","626aeba17db0298f":"j0icU","6c372c8ba7d0f54a":"gSWbl","c973861fc1618859":"cfp4O","2078449608a091e2":"qpHS4","fd1db2f6c28e6614":"6z8XQ","d2761b96f6c78600":"l0mMZ","18f84d778ba5c8e3":"gd9Iu","413d591e56a66582":"03AqV","406ab40d2f2c58c1":"joJz2","a2090a73845f089b":"aj7pj","4fd4f764b20cab9":"8xvkv","915d8914a5255876":"1dlk8"}],"qpHS4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5f4b0461cbecf891").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.digitalClockClasses = void 0;
exports.getDigitalClockUtilityClass = getDigitalClockUtilityClass;
var _generateUtilityClass = _interopRequireDefault(require("63e1897d11a4eee4"));
var _generateUtilityClasses = _interopRequireDefault(require("6485cd6f2cfa42b9"));
function getDigitalClockUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDigitalClock', slot);
}
const digitalClockClasses = exports.digitalClockClasses = (0, _generateUtilityClasses.default)('MuiDigitalClock', [
    'root',
    'list',
    'item'
]);

},{"5f4b0461cbecf891":"9snJq","63e1897d11a4eee4":"dtNEc","6485cd6f2cfa42b9":"2Z0QC"}],"2hWoB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MultiSectionDigitalClock", {
    enumerable: true,
    get: function() {
        return _MultiSectionDigitalClock.MultiSectionDigitalClock;
    }
});
Object.defineProperty(exports, "getMultiSectionDigitalClockUtilityClass", {
    enumerable: true,
    get: function() {
        return _multiSectionDigitalClockClasses.getMultiSectionDigitalClockUtilityClass;
    }
});
Object.defineProperty(exports, "multiSectionDigitalClockClasses", {
    enumerable: true,
    get: function() {
        return _multiSectionDigitalClockClasses.multiSectionDigitalClockClasses;
    }
});
Object.defineProperty(exports, "multiSectionDigitalClockSectionClasses", {
    enumerable: true,
    get: function() {
        return _multiSectionDigitalClockSectionClasses.multiSectionDigitalClockSectionClasses;
    }
});
var _MultiSectionDigitalClock = require("2517820353642234");
var _multiSectionDigitalClockSectionClasses = require("bcac9c66c0f11436");
var _multiSectionDigitalClockClasses = require("50a57776099dec6b");

},{"2517820353642234":"ehuct","bcac9c66c0f11436":"gbxgW","50a57776099dec6b":"dIbRw"}],"ehuct":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("23702674fee24856").default;
var _interopRequireWildcard = require("1c142249f7d6465c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultiSectionDigitalClock = void 0;
var _extends2 = _interopRequireDefault(require("db1f5957ee753524"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("b1c0e97811904d69"));
var React = _interopRequireWildcard(require("35cdeb629b8c8289"));
var _clsx = _interopRequireDefault(require("5b81b1c7a3be093d"));
var _propTypes = _interopRequireDefault(require("34f8a433e06b1322"));
var _RtlProvider = require("2f25613520819f2");
var _styles = require("e0bb6d9f0bcc835");
var _useEventCallback = _interopRequireDefault(require("abdc69dd2a26802c"));
var _composeClasses = _interopRequireDefault(require("57ca6369a025bb55"));
var _hooks = require("6a43ddde41bd4d27");
var _useUtils = require("8a0c119267aad4e4");
var _timeUtils = require("b223946affae81a");
var _useViews = require("b85aa44077d292f6");
var _dateHelpersHooks = require("b5a7524c73549a60");
var _PickerViewRoot = require("2c84b81ca0157071");
var _multiSectionDigitalClockClasses = require("9f838b33d33cb5aa");
var _MultiSectionDigitalClockSection = require("c13bcaf5196f2b56");
var _MultiSectionDigitalClock2 = require("bc22677ac839c5b0");
var _useControlledValue = require("1d90f7a878ecbea2");
var _valueManagers = require("3101bb9431c0a599");
var _useClockReferenceDate = require("75354a59a96769a2");
var _dateUtils = require("61494055b60a520a");
var _usePickerPrivateContext = require("747359bce9ae219");
var _jsxRuntime = require("b5f18cea740402c9");
const _excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _multiSectionDigitalClockClasses.getMultiSectionDigitalClockUtilityClass, classes);
};
const MultiSectionDigitalClockRoot = (0, _styles.styled)(_PickerViewRoot.PickerViewRoot, {
    name: 'MuiMultiSectionDigitalClock',
    slot: 'Root'
})(({ theme })=>({
        flexDirection: 'row',
        width: '100%',
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [DigitalClock](https://mui.com/x/react-date-pickers/digital-clock/)
 *
 * API:
 *
 * - [MultiSectionDigitalClock API](https://mui.com/x/api/date-pickers/multi-section-digital-clock/)
 */ const MultiSectionDigitalClock = exports.MultiSectionDigitalClock = /*#__PURE__*/ React.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const adapter = (0, _hooks.usePickerAdapter)();
    const isRtl = (0, _RtlProvider.useRtl)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClock'
    });
    const { ampm = adapter.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus, slots, slotProps, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation = false, maxTime, minTime, disableFuture, disablePast, minutesStep = 1, shouldDisableTime, onChange, view: inView, views: inViews = [
        'hours',
        'minutes'
    ], openTo, onViewChange, focusedView: inFocusedView, onFocusedViewChange, className, classes: classesProp, disabled, readOnly, skipDisabled = false, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { value, handleValueChange: handleRawValueChange, timezone } = (0, _useControlledValue.useControlledValue)({
        name: 'MultiSectionDigitalClock',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: _valueManagers.singleItemValueManager
    });
    const translations = (0, _hooks.usePickerTranslations)();
    const now = (0, _useUtils.useNow)(timezone);
    const timeSteps = React.useMemo(()=>(0, _extends2.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, _useClockReferenceDate.useClockReferenceDate)({
        value,
        referenceDate: referenceDateProp,
        adapter,
        props,
        timezone
    });
    const handleValueChange = (0, _useEventCallback.default)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = React.useMemo(()=>{
        if (!ampm || !inViews.includes('hours')) return inViews;
        return inViews.includes('meridiem') ? inViews : [
            ...inViews,
            'meridiem'
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view, setValueAndGoToNextView, focusedView } = (0, _useViews.useViews)({
        view: inView,
        views,
        openTo,
        onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, _useEventCallback.default)((newValue)=>{
        setValueAndGoToNextView(newValue, 'finish', 'meridiem');
    });
    const { meridiemMode, handleMeridiemChange } = (0, _dateHelpersHooks.useMeridiemMode)(valueOrReferenceDate, ampm, handleMeridiemValueChange, 'finish');
    const isTimeDisabled = React.useCallback((rawValue, viewType)=>{
        const isAfter = (0, _timeUtils.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter);
        const shouldCheckPastEnd = viewType === 'hours' || viewType === 'minutes' && views.includes('seconds');
        const containsValidTime = ({ start, end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableTime) switch(viewType){
                case 'hours':
                    return !shouldDisableTime(adapter.setHours(valueOrReferenceDate, timeValue), 'hours');
                case 'minutes':
                    return !shouldDisableTime(adapter.setMinutes(valueOrReferenceDate, timeValue), 'minutes');
                case 'seconds':
                    return !shouldDisableTime(adapter.setSeconds(valueOrReferenceDate, timeValue), 'seconds');
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const valueWithMeridiem = (0, _timeUtils.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = adapter.setHours(valueOrReferenceDate, valueWithMeridiem);
                    if (adapter.getHours(dateWithNewHours) !== valueWithMeridiem) return true;
                    const start = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 0), 0);
                    const end = adapter.setSeconds(adapter.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = adapter.setMinutes(valueOrReferenceDate, rawValue);
                    const start = adapter.setSeconds(dateWithNewMinutes, 0);
                    const end = adapter.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = adapter.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start,
                        end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        adapter,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = React.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case 'hours':
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, _timeUtils.convertValueToMeridiem)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(adapter.setHours(valueOrReferenceDate, valueWithMeridiem), 'finish', 'hours');
                    },
                    items: (0, _MultiSectionDigitalClock2.getHourSectionOptions)({
                        now,
                        value,
                        ampm,
                        adapter,
                        isDisabled: (hours)=>isTimeDisabled(hours, 'hours'),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: translations.hoursClockNumberText,
                        valueOrReferenceDate
                    })
                };
            case 'minutes':
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(adapter.setMinutes(valueOrReferenceDate, minutes), 'finish', 'minutes');
                    },
                    items: (0, _MultiSectionDigitalClock2.getTimeSectionOptions)({
                        value: adapter.getMinutes(valueOrReferenceDate),
                        adapter,
                        isDisabled: (minutes)=>isTimeDisabled(minutes, 'minutes'),
                        resolveLabel: (minutes)=>adapter.format(adapter.setMinutes(now, minutes), 'minutes'),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: translations.minutesClockNumberText
                    })
                };
            case 'seconds':
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(adapter.setSeconds(valueOrReferenceDate, seconds), 'finish', 'seconds');
                    },
                    items: (0, _MultiSectionDigitalClock2.getTimeSectionOptions)({
                        value: adapter.getSeconds(valueOrReferenceDate),
                        adapter,
                        isDisabled: (seconds)=>isTimeDisabled(seconds, 'seconds'),
                        resolveLabel: (seconds)=>adapter.format(adapter.setSeconds(now, seconds), 'seconds'),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: translations.secondsClockNumberText
                    })
                };
            case 'meridiem':
                {
                    const amLabel = (0, _dateUtils.formatMeridiem)(adapter, 'am');
                    const pmLabel = (0, _dateUtils.formatMeridiem)(adapter, 'pm');
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: 'am',
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === 'am',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'am',
                                ariaLabel: amLabel
                            },
                            {
                                value: 'pm',
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === 'pm',
                                isFocused: ()=>!!valueOrReferenceDate && meridiemMode === 'pm',
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        adapter,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        translations.hoursClockNumberText,
        translations.minutesClockNumberText,
        translations.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewsToRender = React.useMemo(()=>{
        if (!isRtl) return views;
        const digitViews = views.filter((v)=>v !== 'meridiem');
        digitViews.reverse();
        if (views.includes('meridiem')) digitViews.push('meridiem');
        return digitViews;
    }, [
        isRtl,
        views
    ]);
    const viewTimeOptions = React.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, _extends2.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const classes = useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MultiSectionDigitalClockRoot, (0, _extends2.default)({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: viewsToRender.map((timeView)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_MultiSectionDigitalClockSection.MultiSectionDigitalClockSection, {
                items: viewTimeOptions[timeView].items,
                onChange: viewTimeOptions[timeView].onChange,
                active: view === timeView,
                autoFocus: autoFocus || focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots,
                slotProps: slotProps,
                skipDisabled: skipDisabled,
                "aria-label": translations.selectViewText(timeView)
            }, timeView))
    }));
});

},{"23702674fee24856":"9snJq","1c142249f7d6465c":"5RcSx","db1f5957ee753524":"h7ttl","b1c0e97811904d69":"jeIdK","35cdeb629b8c8289":"9njXz","5b81b1c7a3be093d":"by5ni","34f8a433e06b1322":"bnNSm","2f25613520819f2":"ck9Pb","e0bb6d9f0bcc835":"c9RfU","abdc69dd2a26802c":"lkrdI","57ca6369a025bb55":"eKeIT","6a43ddde41bd4d27":"6MTP2","8a0c119267aad4e4":"j0icU","b223946affae81a":"gSWbl","b85aa44077d292f6":"6z8XQ","b5a7524c73549a60":"b2RZ3","2c84b81ca0157071":"cfp4O","9f838b33d33cb5aa":"dIbRw","c13bcaf5196f2b56":"590g2","bc22677ac839c5b0":"lBysu","1d90f7a878ecbea2":"gd9Iu","3101bb9431c0a599":"03AqV","75354a59a96769a2":"joJz2","61494055b60a520a":"jwfEA","747359bce9ae219":"8xvkv","b5f18cea740402c9":"1dlk8"}],"dIbRw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8de201118c90faf6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMultiSectionDigitalClockUtilityClass = getMultiSectionDigitalClockUtilityClass;
exports.multiSectionDigitalClockClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("617490907d08020a"));
var _generateUtilityClasses = _interopRequireDefault(require("410804b89be9e5e1"));
function getMultiSectionDigitalClockUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiMultiSectionDigitalClock', slot);
}
const multiSectionDigitalClockClasses = exports.multiSectionDigitalClockClasses = (0, _generateUtilityClasses.default)('MuiMultiSectionDigitalClock', [
    'root'
]);

},{"8de201118c90faf6":"9snJq","617490907d08020a":"dtNEc","410804b89be9e5e1":"2Z0QC"}],"590g2":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("cd21de3d950ca478").default;
var _interopRequireWildcard = require("c97dfabd28063f5c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MultiSectionDigitalClockSection = void 0;
var _extends2 = _interopRequireDefault(require("825d82689c017d50"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("609013a435d512c7"));
var React = _interopRequireWildcard(require("178760991220c821"));
var _clsx = _interopRequireDefault(require("e09f975b1a075ea2"));
var _styles = require("b19b0ac3e8a6923");
var _composeClasses = _interopRequireDefault(require("66956c7d2bc67551"));
var _MenuList = _interopRequireDefault(require("586726368bd0d659"));
var _MenuItem = _interopRequireDefault(require("26a8fdf6b3c8cda2"));
var _useForkRef = _interopRequireDefault(require("3f1ed91b5353ea9b"));
var _useEnhancedEffect = _interopRequireDefault(require("ad856c7f4e95dfae"));
var _multiSectionDigitalClockSectionClasses = require("4ce8a755a53d5943");
var _dimensions = require("973e18f103645e30");
var _utils = require("63072c3e6413ef39");
var _usePickerPrivateContext = require("c4ae0a0d917effc3");
var _jsxRuntime = require("9da581686200afb9");
const _excluded = [
    "autoFocus",
    "onChange",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        item: [
            'item'
        ]
    };
    return (0, _composeClasses.default)(slots, _multiSectionDigitalClockSectionClasses.getMultiSectionDigitalClockSectionUtilityClass, classes);
};
const MultiSectionDigitalClockSectionRoot = (0, _styles.styled)(_MenuList.default, {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Root'
})(({ theme })=>({
        maxHeight: _dimensions.DIGITAL_CLOCK_VIEW_HEIGHT,
        width: 56,
        padding: 0,
        overflow: 'hidden',
        scrollbarWidth: 'thin',
        '@media (prefers-reduced-motion: no-preference)': {
            scrollBehavior: 'auto'
        },
        '@media (pointer: fine)': {
            '&:hover': {
                overflowY: 'auto'
            }
        },
        '@media (pointer: none), (pointer: coarse)': {
            overflowY: 'auto'
        },
        '&:not(:first-of-type)': {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        variants: [
            {
                props: {
                    hasDigitalClockAlreadyBeenRendered: true
                },
                style: {
                    '@media (prefers-reduced-motion: no-preference)': {
                        scrollBehavior: 'smooth'
                    }
                }
            }
        ]
    }));
const MultiSectionDigitalClockSectionItem = (0, _styles.styled)(_MenuItem.default, {
    name: 'MuiMultiSectionDigitalClockSection',
    slot: 'Item'
})(({ theme })=>({
        padding: 8,
        margin: '2px 4px',
        width: _dimensions.MULTI_SECTION_CLOCK_SECTION_WIDTH,
        justifyContent: 'center',
        '&:first-of-type': {
            marginTop: 4
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        '&.Mui-selected': {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            '&:focus-visible, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        '&.Mui-focusVisible': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
/**
 * @ignore - internal component.
 */ const MultiSectionDigitalClockSection = exports.MultiSectionDigitalClockSection = /*#__PURE__*/ React.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    const containerRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(ref, containerRef);
    const previousActive = React.useRef(null);
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiMultiSectionDigitalClockSection'
    });
    const { autoFocus, onChange, className, classes: classesProp, disabled, readOnly, items, active, slots, slotProps, skipDisabled } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        hasDigitalClockAlreadyBeenRendered: !!containerRef.current
    });
    const classes = useUtilityClasses(classesProp);
    const DigitalClockSectionItem = slots?.digitalClockSectionItem ?? MultiSectionDigitalClockSectionItem;
    (0, _useEnhancedEffect.default)(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        const itemHeight = activeItem.offsetHeight;
        const containerHeight = containerRef.current.clientHeight;
        const scrollableHeight = containerRef.current.scrollHeight;
        // Calculate the ideal centered position
        const centeredPosition = offsetTop - containerHeight / 2 + itemHeight / 2;
        // Calculate the maximum scroll position that would show content at the bottom
        const maxScrollTop = scrollableHeight - containerHeight;
        // If centering would create empty space at the bottom, align the last items to the bottom instead
        const scrollPosition = Math.min(centeredPosition, maxScrollTop);
        // Ensure we don't scroll past the top
        containerRef.current.scrollTop = Math.max(0, scrollPosition);
    });
    const focusedOptionIndex = items.findIndex((item)=>item.isFocused(item.value));
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'PageUp':
                {
                    const newIndex = (0, _utils.getFocusedListItemIndex)(containerRef.current) - 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.max(0, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            case 'PageDown':
                {
                    const newIndex = (0, _utils.getFocusedListItemIndex)(containerRef.current) + 5;
                    const children = containerRef.current.children;
                    const newFocusedIndex = Math.min(children.length - 1, newIndex);
                    const childToFocus = children[newFocusedIndex];
                    if (childToFocus) childToFocus.focus();
                    event.preventDefault();
                    break;
                }
            default:
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MultiSectionDigitalClockSectionRoot, (0, _extends2.default)({
        ref: handleRef,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox",
        onKeyDown: handleKeyDown
    }, other, {
        children: items.map((option, index)=>{
            const isItemDisabled = option.isDisabled?.(option.value);
            const isDisabled = disabled || isItemDisabled;
            if (skipDisabled && isDisabled) return null;
            const isSelected = option.isSelected(option.value);
            const tabIndex = focusedOptionIndex === index || focusedOptionIndex === -1 && index === 0 ? 0 : -1;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DigitalClockSectionItem, (0, _extends2.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: isDisabled,
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly || isDisabled || undefined,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                tabIndex: tabIndex,
                className: classes.item
            }, slotProps?.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});

},{"cd21de3d950ca478":"9snJq","c97dfabd28063f5c":"5RcSx","825d82689c017d50":"h7ttl","609013a435d512c7":"jeIdK","178760991220c821":"9njXz","e09f975b1a075ea2":"by5ni","b19b0ac3e8a6923":"c9RfU","66956c7d2bc67551":"eKeIT","586726368bd0d659":"eogrV","26a8fdf6b3c8cda2":"a18vm","3f1ed91b5353ea9b":"93645","ad856c7f4e95dfae":"foonr","4ce8a755a53d5943":"gbxgW","973e18f103645e30":"l0mMZ","63072c3e6413ef39":"aj7pj","c4ae0a0d917effc3":"8xvkv","9da581686200afb9":"1dlk8"}],"gbxgW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("b730855e47c13888").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMultiSectionDigitalClockSectionUtilityClass = getMultiSectionDigitalClockSectionUtilityClass;
exports.multiSectionDigitalClockSectionClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("d5c50a5cdd7ca7c3"));
var _generateUtilityClasses = _interopRequireDefault(require("6ddc83d984b71c08"));
function getMultiSectionDigitalClockSectionUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiMultiSectionDigitalClockSection', slot);
}
const multiSectionDigitalClockSectionClasses = exports.multiSectionDigitalClockSectionClasses = (0, _generateUtilityClasses.default)('MuiMultiSectionDigitalClockSection', [
    'root',
    'item'
]);

},{"b730855e47c13888":"9snJq","d5c50a5cdd7ca7c3":"dtNEc","6ddc83d984b71c08":"2Z0QC"}],"lBysu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTimeSectionOptions = exports.getHourSectionOptions = void 0;
const getHourSectionOptions = ({ now, value, adapter, ampm, isDisabled, resolveAriaLabel, timeStep, valueOrReferenceDate })=>{
    const currentHours = value ? adapter.getHours(value) : null;
    const result = [];
    const isSelected = (hour, overriddenCurrentHours)=>{
        const resolvedCurrentHours = overriddenCurrentHours ?? currentHours;
        if (resolvedCurrentHours === null) return false;
        if (ampm) {
            if (hour === 12) return resolvedCurrentHours === 12 || resolvedCurrentHours === 0;
            return resolvedCurrentHours === hour || resolvedCurrentHours - 12 === hour;
        }
        return resolvedCurrentHours === hour;
    };
    const isFocused = (hour)=>{
        return isSelected(hour, adapter.getHours(valueOrReferenceDate));
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = adapter.format(adapter.setHours(now, hour), ampm ? 'hours12h' : 'hours24h');
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = adapter.formatNumber(label);
        result.push({
            value: hour,
            label,
            isSelected,
            isDisabled,
            isFocused,
            ariaLabel
        });
    }
    return result;
};
exports.getHourSectionOptions = getHourSectionOptions;
const getTimeSectionOptions = ({ value, adapter, isDisabled, timeStep, resolveLabel, resolveAriaLabel, hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    const isFocused = (timeValue)=>{
        return value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: adapter.formatNumber(resolveLabel(timeValue)),
                isDisabled,
                isSelected,
                isFocused,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};
exports.getTimeSectionOptions = getTimeSectionOptions;

},{}],"533c4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AdapterDayjs", {
    enumerable: true,
    get: function() {
        return _AdapterDayjs.AdapterDayjs;
    }
});
var _AdapterDayjs = require("7440f797bffef0da");

},{"7440f797bffef0da":"lyzS8"}],"lyzS8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e3995c9270ec99b9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdapterDayjs = void 0;
var _extends2 = _interopRequireDefault(require("1b72d9e3d745337e"));
var _dayjs = _interopRequireDefault(require("14eef06f5f387e6"));
var _weekOfYear = _interopRequireDefault(require("1e0c702a9dfdb044"));
var _customParseFormat = _interopRequireDefault(require("cf5d2e92c71fc7f6"));
var _localizedFormat = _interopRequireDefault(require("ba2f273e1fc966ea"));
var _isBetween = _interopRequireDefault(require("8a4f12ff8824bd1"));
var _advancedFormat = _interopRequireDefault(require("e0d46f8b341ee2e3"));
var _warning = require("992724918a8bc1f6");
/* v8 ignore start */ // dayjs has no exports field defined
// See https://github.com/iamkun/dayjs/issues/2562
/* eslint-disable import/extensions */ /* v8 ignore stop */ /* eslint-enable import/extensions */ _dayjs.default.extend(_localizedFormat.default);
_dayjs.default.extend(_weekOfYear.default);
_dayjs.default.extend(_isBetween.default);
_dayjs.default.extend(_advancedFormat.default);
const formatTokenMap = {
    // Year
    YY: 'year',
    YYYY: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    D: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    DD: 'day',
    Do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    d: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 2
    },
    dd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    dddd: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    A: 'meridiem',
    a: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const defaultFormats = {
    year: 'YYYY',
    month: 'MMMM',
    monthShort: 'MMM',
    dayOfMonth: 'D',
    dayOfMonthFull: 'Do',
    weekday: 'dddd',
    weekdayShort: 'dd',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'A',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'll',
    keyboardDate: 'L',
    shortDate: 'MMM D',
    normalDate: 'D MMMM',
    normalDateWithWeekday: 'ddd, MMM D',
    fullTime12h: 'hh:mm A',
    fullTime24h: 'HH:mm',
    keyboardDateTime12h: 'L hh:mm A',
    keyboardDateTime24h: 'L HH:mm'
};
const MISSING_UTC_PLUGIN = [
    'Missing UTC plugin',
    'To be able to use UTC or timezones, you have to enable the `utc` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc'
].join('\n');
const MISSING_TIMEZONE_PLUGIN = [
    'Missing timezone plugin',
    'To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin',
    'Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone'
].join('\n');
/**
 * Based on `@date-io/dayjs`
 *
 * MIT License
 *
 * Copyright (c) 2017 Dmitriy Kovalenko
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ class AdapterDayjs {
    isMUIAdapter = true;
    isTimezoneCompatible = true;
    lib = 'dayjs';
    escapedCharacters = {
        start: '[',
        end: ']'
    };
    formatTokenMap = formatTokenMap;
    constructor({ locale, formats } = {}){
        this.locale = locale;
        this.formats = (0, _extends2.default)({}, defaultFormats, formats);
        // Moved plugins to the constructor to allow for users to use options on the library
        // for reference: https://github.com/mui/mui-x/pull/11151
        _dayjs.default.extend(_customParseFormat.default);
    }
    setLocaleToValue = (value)=>{
        const expectedLocale = this.getCurrentLocaleCode();
        if (expectedLocale === value.locale()) return value;
        return value.locale(expectedLocale);
    };
    hasUTCPlugin = ()=>typeof _dayjs.default.utc !== 'undefined';
    hasTimezonePlugin = ()=>typeof _dayjs.default.tz !== 'undefined';
    isSame = (value, comparing, comparisonTemplate)=>{
        const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
        return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
    };
    /**
   * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
   */ cleanTimezone = (timezone)=>{
        switch(timezone){
            case 'default':
                return undefined;
            case 'system':
                return _dayjs.default.tz.guess();
            default:
                return timezone;
        }
    };
    createSystemDate = (value)=>{
        let date;
        if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
            const timezone = _dayjs.default.tz.guess();
            if (timezone === 'UTC') date = (0, _dayjs.default)(value);
            else // We can't change the system timezone in the tests
            date = _dayjs.default.tz(value, timezone);
        } else date = (0, _dayjs.default)(value);
        return this.setLocaleToValue(date);
    };
    createUTCDate = (value)=>{
        /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) throw new Error(MISSING_UTC_PLUGIN);
        return this.setLocaleToValue(_dayjs.default.utc(value));
    };
    createTZDate = (value, timezone)=>{
        /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) throw new Error(MISSING_UTC_PLUGIN);
        /* v8 ignore next 3 */ if (!this.hasTimezonePlugin()) throw new Error(MISSING_TIMEZONE_PLUGIN);
        const keepLocalTime = value !== undefined && !value.endsWith('Z');
        return this.setLocaleToValue((0, _dayjs.default)(value).tz(this.cleanTimezone(timezone), keepLocalTime));
    };
    getLocaleFormats = ()=>{
        const locales = _dayjs.default.Ls;
        const locale = this.locale || 'en';
        let localeObject = locales[locale];
        if (localeObject === undefined) /* v8 ignore stop */ localeObject = locales.en;
        return localeObject.formats;
    };
    /**
   * If the new day does not have the same offset as the old one (when switching to summer day time for example),
   * Then dayjs will not automatically adjust the offset (moment does).
   * We have to parse again the value to make sure the `fixOffset` method is applied.
   * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
   */ adjustOffset = (value)=>{
        if (!this.hasTimezonePlugin()) return value;
        const timezone = this.getTimezone(value);
        if (timezone !== 'UTC') {
            const fixedValue = value.tz(this.cleanTimezone(timezone), true);
            // TODO: Simplify the case when we raise the `dayjs` peer dep to 1.11.12 (https://github.com/iamkun/dayjs/releases/tag/v1.11.12)
            /* v8 ignore next 3 */ // @ts-ignore
            if (fixedValue.$offset === (value.$offset ?? 0)) return value;
            // Change only what is needed to avoid creating a new object with unwanted data
            // Especially important when used in an environment where utc or timezone dates are used only in some places
            // Reference: https://github.com/mui/mui-x/issues/13290
            // @ts-ignore
            value.$offset = fixedValue.$offset;
        }
        return value;
    };
    date = (value, timezone = 'default')=>{
        if (value === null) return null;
        if (timezone === 'UTC') return this.createUTCDate(value);
        if (timezone === 'system' || timezone === 'default' && !this.hasTimezonePlugin()) return this.createSystemDate(value);
        return this.createTZDate(value, timezone);
    };
    getInvalidDate = ()=>(0, _dayjs.default)(new Date('Invalid date'));
    getTimezone = (value)=>{
        if (this.hasTimezonePlugin()) {
            // @ts-ignore
            const zone = value.$x?.$timezone;
            if (zone) return zone;
        }
        if (this.hasUTCPlugin() && value.isUTC()) return 'UTC';
        return 'system';
    };
    setTimezone = (value, timezone)=>{
        if (this.getTimezone(value) === timezone) return value;
        if (timezone === 'UTC') {
            /* v8 ignore next 3 */ if (!this.hasUTCPlugin()) throw new Error(MISSING_UTC_PLUGIN);
            return value.utc();
        }
        // We know that we have the UTC plugin.
        // Otherwise, the value timezone would always equal "system".
        // And it would be caught by the first "if" of this method.
        if (timezone === 'system') return value.local();
        if (!this.hasTimezonePlugin()) {
            if (timezone === 'default') return value;
            /* v8 ignore next */ throw new Error(MISSING_TIMEZONE_PLUGIN);
        }
        return this.setLocaleToValue(_dayjs.default.tz(value, this.cleanTimezone(timezone)));
    };
    toJsDate = (value)=>{
        return value.toDate();
    };
    parse = (value, format)=>{
        if (value === '') return null;
        return (0, _dayjs.default)(value, format, this.locale, true);
    };
    getCurrentLocaleCode = ()=>{
        return this.locale || 'en';
    };
    is12HourCycleInCurrentLocale = ()=>{
        /* v8 ignore next */ return /A|a/.test(this.getLocaleFormats().LT || '');
    };
    expandFormat = (format)=>{
        const localeFormats = this.getLocaleFormats();
        // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
        const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
        return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
            const B = b && b.toUpperCase();
            return a || localeFormats[b] || t(localeFormats[B]);
        });
    };
    isValid = (value)=>{
        if (value == null) return false;
        return value.isValid();
    };
    format = (value, formatKey)=>{
        return this.formatByString(value, this.formats[formatKey]);
    };
    formatByString = (value, formatString)=>{
        return this.setLocaleToValue(value).format(formatString);
    };
    formatNumber = (numberToFormat)=>{
        return numberToFormat;
    };
    isEqual = (value, comparing)=>{
        if (value === null && comparing === null) return true;
        if (value === null || comparing === null) return false;
        return value.toDate().getTime() === comparing.toDate().getTime();
    };
    isSameYear = (value, comparing)=>{
        return this.isSame(value, comparing, 'YYYY');
    };
    isSameMonth = (value, comparing)=>{
        return this.isSame(value, comparing, 'YYYY-MM');
    };
    isSameDay = (value, comparing)=>{
        return this.isSame(value, comparing, 'YYYY-MM-DD');
    };
    isSameHour = (value, comparing)=>{
        return value.isSame(comparing, 'hour');
    };
    isAfter = (value, comparing)=>{
        return value > comparing;
    };
    isAfterYear = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'year');
        return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
    };
    isAfterDay = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isAfter(comparing, 'day');
        return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
    };
    isBefore = (value, comparing)=>{
        return value < comparing;
    };
    isBeforeYear = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'year');
        return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
    };
    isBeforeDay = (value, comparing)=>{
        if (!this.hasUTCPlugin()) return value.isBefore(comparing, 'day');
        return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
    };
    isWithinRange = (value, [start, end])=>{
        return value >= start && value <= end;
    };
    startOfYear = (value)=>{
        return this.adjustOffset(value.startOf('year'));
    };
    startOfMonth = (value)=>{
        return this.adjustOffset(value.startOf('month'));
    };
    startOfWeek = (value)=>{
        return this.adjustOffset(this.setLocaleToValue(value).startOf('week'));
    };
    startOfDay = (value)=>{
        return this.adjustOffset(value.startOf('day'));
    };
    endOfYear = (value)=>{
        return this.adjustOffset(value.endOf('year'));
    };
    endOfMonth = (value)=>{
        return this.adjustOffset(value.endOf('month'));
    };
    endOfWeek = (value)=>{
        return this.adjustOffset(this.setLocaleToValue(value).endOf('week'));
    };
    endOfDay = (value)=>{
        return this.adjustOffset(value.endOf('day'));
    };
    addYears = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'year'));
    };
    addMonths = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'month'));
    };
    addWeeks = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'week'));
    };
    addDays = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'day'));
    };
    addHours = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'hour'));
    };
    addMinutes = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'minute'));
    };
    addSeconds = (value, amount)=>{
        return this.adjustOffset(value.add(amount, 'second'));
    };
    getYear = (value)=>{
        return value.year();
    };
    getMonth = (value)=>{
        return value.month();
    };
    getDate = (value)=>{
        return value.date();
    };
    getHours = (value)=>{
        return value.hour();
    };
    getMinutes = (value)=>{
        return value.minute();
    };
    getSeconds = (value)=>{
        return value.second();
    };
    getMilliseconds = (value)=>{
        return value.millisecond();
    };
    setYear = (value, year)=>{
        return this.adjustOffset(value.set('year', year));
    };
    setMonth = (value, month)=>{
        return this.adjustOffset(value.set('month', month));
    };
    setDate = (value, date)=>{
        return this.adjustOffset(value.set('date', date));
    };
    setHours = (value, hours)=>{
        return this.adjustOffset(value.set('hour', hours));
    };
    setMinutes = (value, minutes)=>{
        return this.adjustOffset(value.set('minute', minutes));
    };
    setSeconds = (value, seconds)=>{
        return this.adjustOffset(value.set('second', seconds));
    };
    setMilliseconds = (value, milliseconds)=>{
        return this.adjustOffset(value.set('millisecond', milliseconds));
    };
    getDaysInMonth = (value)=>{
        return value.daysInMonth();
    };
    getWeekArray = (value)=>{
        const start = this.startOfWeek(this.startOfMonth(value));
        const end = this.endOfWeek(this.endOfMonth(value));
        let count = 0;
        let current = start;
        const nestedWeeks = [];
        while(current < end){
            const weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = this.addDays(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    getWeekNumber = (value)=>{
        return value.week();
    };
    getDayOfWeek(value) {
        return value.day() + 1;
    }
    getYearRange = ([start, end])=>{
        const startDate = this.startOfYear(start);
        const endDate = this.endOfYear(end);
        const years = [];
        let current = startDate;
        while(this.isBefore(current, endDate)){
            years.push(current);
            current = this.addYears(current, 1);
        }
        return years;
    };
}
exports.AdapterDayjs = AdapterDayjs;

},{"e3995c9270ec99b9":"9snJq","1b72d9e3d745337e":"h7ttl","14eef06f5f387e6":"9FMDe","1e0c702a9dfdb044":"eFwyn","cf5d2e92c71fc7f6":"a6E4P","ba2f273e1fc966ea":"5XqAK","8a4f12ff8824bd1":"hXQJe","e0d46f8b341ee2e3":"JmNE4","992724918a8bc1f6":"gernP"}],"9FMDe":[function(require,module,exports,__globalThis) {
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

},{}],"eFwyn":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});

},{}],"a6E4P":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

},{}],"5XqAK":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

},{}],"hXQJe":[function(require,module,exports,__globalThis) {
!function(e, i) {
    module.exports = i();
}(this, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});

},{}],"JmNE4":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

},{}],"b2Tgt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DatePicker", {
    enumerable: true,
    get: function() {
        return _DatePicker.DatePicker;
    }
});
Object.defineProperty(exports, "DatePickerToolbar", {
    enumerable: true,
    get: function() {
        return _DatePickerToolbar.DatePickerToolbar;
    }
});
Object.defineProperty(exports, "datePickerToolbarClasses", {
    enumerable: true,
    get: function() {
        return _datePickerToolbarClasses.datePickerToolbarClasses;
    }
});
var _DatePicker = require("8c23c40f50aa3618");
var _DatePickerToolbar = require("c0f8d21d01e17422");
var _datePickerToolbarClasses = require("c97a8fdce38c7bf");

},{"8c23c40f50aa3618":"c7DEl","c0f8d21d01e17422":"cI3Xl","c97a8fdce38c7bf":"hGg8N"}],"c7DEl":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("6555d12bbc14e27a").default;
var _interopRequireWildcard = require("fc1ed990df7412b6").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DatePicker = void 0;
var _extends2 = _interopRequireDefault(require("4d5abc7f35b15a9e"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("769caef07f4347d"));
var React = _interopRequireWildcard(require("303fb538b53c80f6"));
var _propTypes = _interopRequireDefault(require("6f8dd0593eac623f"));
var _useMediaQuery = _interopRequireDefault(require("5ea8ce48667979b8"));
var _styles = require("1d7021f6062ed424");
var _refType = _interopRequireDefault(require("283863a645702253"));
var _DesktopDatePicker = require("14beb30c4abe08cd");
var _MobileDatePicker = require("bea5fe6dddef8a89");
var _utils = require("950d34be18751236");
var _jsxRuntime = require("d2c4fa598f005be5");
const _excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const DatePicker = exports.DatePicker = /*#__PURE__*/ React.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery = _utils.DEFAULT_DESKTOP_MODE_MEDIA_QUERY } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, _useMediaQuery.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DesktopDatePicker.DesktopDatePicker, (0, _extends2.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_MobileDatePicker.MobileDatePicker, (0, _extends2.default)({
        ref: ref
    }, other));
});

},{"6555d12bbc14e27a":"9snJq","fc1ed990df7412b6":"5RcSx","4d5abc7f35b15a9e":"h7ttl","769caef07f4347d":"jeIdK","303fb538b53c80f6":"9njXz","6f8dd0593eac623f":"bnNSm","5ea8ce48667979b8":"bnRpi","1d7021f6062ed424":"c9RfU","283863a645702253":"fAbhl","14beb30c4abe08cd":"htVg1","bea5fe6dddef8a89":"2Ji01","950d34be18751236":"aj7pj","d2c4fa598f005be5":"1dlk8"}],"htVg1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DesktopDatePicker", {
    enumerable: true,
    get: function() {
        return _DesktopDatePicker.DesktopDatePicker;
    }
});
var _DesktopDatePicker = require("e4d5fb4ccfa404de");

},{"e4d5fb4ccfa404de":"emwiH"}],"emwiH":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("17e7d0e212b931b7").default;
var _interopRequireDefault = require("93de488cdc9ff4b0").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DesktopDatePicker = void 0;
var _extends2 = _interopRequireDefault(require("32d87e40fcb15182"));
var React = _interopRequireWildcard(require("fb3c09719a67fa57"));
var _propTypes = _interopRequireDefault(require("505c447e8dcede34"));
var _resolveComponentProps = _interopRequireDefault(require("ee7dbd363db5e09"));
var _refType = _interopRequireDefault(require("820ca8c7c554d38d"));
var _valueManagers = require("121b16f47d48bb7d");
var _shared = require("a1c6311e7c949595");
var _usePickerAdapter = require("daf4260eef5ec774");
var _validation = require("c25be623c54c3845");
var _useDesktopPicker = require("c631b6044133976c");
var _DateField = require("e2177a5d9c3cb165");
var _dateViewRenderers = require("d7e296b6838e8c51");
var _dateUtils = require("a39ca6b70fa94daf");
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const DesktopDatePicker = exports.DesktopDatePicker = /*#__PURE__*/ React.forwardRef(function DesktopDatePicker(inProps, ref) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, _shared.useDatePickerDefaultizedProps)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, _extends2.default)({
        day: _dateViewRenderers.renderDateViewCalendar,
        month: _dateViewRenderers.renderDateViewCalendar,
        year: _dateViewRenderers.renderDateViewCalendar
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, _extends2.default)({}, defaultizedProps, {
        closeOnSelect: defaultizedProps.closeOnSelect ?? true,
        viewRenderers,
        format: (0, _dateUtils.resolveDateFormat)(adapter, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: (0, _extends2.default)({
            field: _DateField.DateField
        }, defaultizedProps.slots),
        slotProps: (0, _extends2.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, _extends2.default)({}, (0, _resolveComponentProps.default)(defaultizedProps.slotProps?.field, ownerState), (0, _validation.extractValidationProps)(defaultizedProps)),
            toolbar: (0, _extends2.default)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker } = (0, _useDesktopPicker.useDesktopPicker)({
        ref,
        props,
        valueManager: _valueManagers.singleItemValueManager,
        valueType: 'date',
        validator: _validation.validateDate,
        steps: null
    });
    return renderPicker();
});
DesktopDatePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: _propTypes.default.bool,
    className: _propTypes.default.string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default true
   */ closeOnSelect: _propTypes.default.bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: _propTypes.default.func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: _propTypes.default.object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: _propTypes.default.bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: _propTypes.default.bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: _propTypes.default.bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: _propTypes.default.bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: _propTypes.default.bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: _propTypes.default.any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: _propTypes.default.number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: _propTypes.default.string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: _propTypes.default.oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: _refType.default,
    /**
   * The label content.
   */ label: _propTypes.default.node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: _propTypes.default.bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: _propTypes.default.object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: _propTypes.default.object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: _propTypes.default.object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: _propTypes.default.oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: _propTypes.default.string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: _propTypes.default.func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: _propTypes.default.func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: _propTypes.default.func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: _propTypes.default.func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: _propTypes.default.func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: _propTypes.default.func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: _propTypes.default.func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: _propTypes.default.func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: _propTypes.default.func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: _propTypes.default.bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: _propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: _propTypes.default.oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: _propTypes.default.bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: _propTypes.default.bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: _propTypes.default.object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: _propTypes.default.func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: _propTypes.default.oneOfType([
        _propTypes.default.oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        _propTypes.default.number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: _propTypes.default.func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: _propTypes.default.func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: _propTypes.default.func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: _propTypes.default.bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: _propTypes.default.object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: _propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: _propTypes.default.string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: _propTypes.default.object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: _propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: _propTypes.default.shape({
        day: _propTypes.default.func,
        month: _propTypes.default.func,
        year: _propTypes.default.func
    }),
    /**
   * Available views.
   */ views: _propTypes.default.arrayOf(_propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: _propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: _propTypes.default.oneOf([
        3,
        4
    ])
};

},{"17e7d0e212b931b7":"5RcSx","93de488cdc9ff4b0":"9snJq","32d87e40fcb15182":"h7ttl","fb3c09719a67fa57":"9njXz","505c447e8dcede34":"bnNSm","ee7dbd363db5e09":"iXpA3","820ca8c7c554d38d":"fAbhl","121b16f47d48bb7d":"03AqV","a1c6311e7c949595":"8PD0g","daf4260eef5ec774":"hE9K5","c25be623c54c3845":"2toSg","c631b6044133976c":"iX4LD","e2177a5d9c3cb165":"7R29R","d7e296b6838e8c51":"iJnFI","a39ca6b70fa94daf":"jwfEA"}],"8PD0g":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("c978ab817368ab3c").default;
var _interopRequireDefault = require("69452c77c950bf20").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDatePickerDefaultizedProps = useDatePickerDefaultizedProps;
var _extends2 = _interopRequireDefault(require("dc7447e6825e081"));
var React = _interopRequireWildcard(require("1760ff69b91b5acb"));
var _styles = require("bbbb1f832d28ed1a");
var _views = require("a7593a122cfb7781");
var _DatePickerToolbar = require("b09235dcdfd0bef1");
var _useDateManager = require("5e95b00e7c31d4a5");
function useDatePickerDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useDateManager.useApplyDefaultValuesToDateValidationProps)(themeProps);
    const localeText = React.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, _extends2.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, _extends2.default)({}, themeProps, validationProps, {
        localeText
    }, (0, _views.applyDefaultViewProps)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        slots: (0, _extends2.default)({
            toolbar: _DatePickerToolbar.DatePickerToolbar
        }, themeProps.slots)
    });
}

},{"c978ab817368ab3c":"5RcSx","69452c77c950bf20":"9snJq","dc7447e6825e081":"h7ttl","1760ff69b91b5acb":"9njXz","bbbb1f832d28ed1a":"c9RfU","a7593a122cfb7781":"geKoG","b09235dcdfd0bef1":"cI3Xl","5e95b00e7c31d4a5":"5P0Cn"}],"cI3Xl":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("2ab95105ae11cc1a").default;
var _interopRequireWildcard = require("6cbab7158664d642").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DatePickerToolbar = void 0;
var _extends2 = _interopRequireDefault(require("fd460a389039391e"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("68f76aa8662d9ab2"));
var React = _interopRequireWildcard(require("5cb13cd043261898"));
var _clsx = _interopRequireDefault(require("bab71b06625e1b74"));
var _propTypes = _interopRequireDefault(require("d673f84895fb9be9"));
var _Typography = _interopRequireDefault(require("e429dae14ec5853c"));
var _styles = require("bc2239805cd866ad");
var _composeClasses = _interopRequireDefault(require("ba41c8d2d067947b"));
var _PickersToolbar = require("99b17a52b9e96223");
var _hooks = require("4daf64c394a1a913");
var _datePickerToolbarClasses = require("8de324bce2deccff");
var _dateUtils = require("b95594fd8f808115");
var _useToolbarOwnerState = require("1175acf055212774");
var _jsxRuntime = require("832ed2b4f43ceb8d");
const _excluded = [
    "toolbarFormat",
    "toolbarPlaceholder",
    "className",
    "classes"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, _composeClasses.default)(slots, _datePickerToolbarClasses.getDatePickerToolbarUtilityClass, classes);
};
const DatePickerToolbarRoot = (0, _styles.styled)(_PickersToolbar.PickersToolbar, {
    name: 'MuiDatePickerToolbar',
    slot: 'Root'
})({});
const DatePickerToolbarTitle = (0, _styles.styled)(_Typography.default, {
    name: 'MuiDatePickerToolbar',
    slot: 'Title'
})({
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [DatePickerToolbar API](https://mui.com/x/api/date-pickers/date-picker-toolbar/)
 */ const DatePickerToolbar = exports.DatePickerToolbar = /*#__PURE__*/ React.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { toolbarFormat, toolbarPlaceholder = "\u2013\u2013", className, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const adapter = (0, _hooks.usePickerAdapter)();
    const { value, views, orientation } = (0, _hooks.usePickerContext)();
    const translations = (0, _hooks.usePickerTranslations)();
    const ownerState = (0, _useToolbarOwnerState.useToolbarOwnerState)();
    const classes = useUtilityClasses(classesProp);
    const dateText = React.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        const formatFromViews = (0, _dateUtils.resolveDateFormat)(adapter, {
            format: toolbarFormat,
            views
        }, true);
        return adapter.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter,
        views
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerToolbarRoot, (0, _extends2.default)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        className: (0, _clsx.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DatePickerToolbarTitle, {
            variant: "h4",
            align: orientation === 'landscape' ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});

},{"2ab95105ae11cc1a":"9snJq","6cbab7158664d642":"5RcSx","fd460a389039391e":"h7ttl","68f76aa8662d9ab2":"jeIdK","5cb13cd043261898":"9njXz","bab71b06625e1b74":"by5ni","d673f84895fb9be9":"bnNSm","e429dae14ec5853c":"2wCD5","bc2239805cd866ad":"c9RfU","ba41c8d2d067947b":"eKeIT","99b17a52b9e96223":"hrCW8","4daf64c394a1a913":"6MTP2","8de324bce2deccff":"hGg8N","b95594fd8f808115":"jwfEA","1175acf055212774":"9Of8r","832ed2b4f43ceb8d":"1dlk8"}],"hGg8N":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2d0bc97fd36e77ee").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.datePickerToolbarClasses = void 0;
exports.getDatePickerToolbarUtilityClass = getDatePickerToolbarUtilityClass;
var _generateUtilityClass = _interopRequireDefault(require("a886f5740ac2d44c"));
var _generateUtilityClasses = _interopRequireDefault(require("66f26eab06a9d53e"));
function getDatePickerToolbarUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiDatePickerToolbar', slot);
}
const datePickerToolbarClasses = exports.datePickerToolbarClasses = (0, _generateUtilityClasses.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);

},{"2d0bc97fd36e77ee":"9snJq","a886f5740ac2d44c":"dtNEc","66f26eab06a9d53e":"2Z0QC"}],"iX4LD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDesktopPicker", {
    enumerable: true,
    get: function() {
        return _useDesktopPicker.useDesktopPicker;
    }
});
var _useDesktopPicker = require("84e77a497e3d35f");

},{"84e77a497e3d35f":"1gL2W"}],"1gL2W":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("338f64d1be0aff71").default;
var _interopRequireWildcard = require("4d28a885c027d2c2").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDesktopPicker = void 0;
var _extends2 = _interopRequireDefault(require("f905cfc7881986a"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("b15df91f499c8464"));
var React = _interopRequireWildcard(require("90ff98092f76b908"));
var _useSlotProps2 = _interopRequireDefault(require("509b829400311eae"));
var _PickerPopper = require("7bf62a0ced8a4d24");
var _usePicker = require("732161f0871a799");
var _PickersLayout = require("809451d677b93347");
var _PickerProvider = require("a01d06914e94ffb2");
var _createNonRangePickerStepNavigation = require("185c8a2a1f0f19fc");
var _jsxRuntime = require("5501bd61ed49e19a");
const _excluded = [
    "props",
    "steps"
], _excluded2 = [
    "ownerState"
];
/**
 * Hook managing all the single-date desktop pickers:
 * - DesktopDatePicker
 * - DesktopDateTimePicker
 * - DesktopTimePicker
 */ const useDesktopPicker = (_ref)=>{
    let { props, steps } = _ref, pickerParams = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    const { slots, slotProps: innerSlotProps, label, inputRef, localeText } = props;
    const getStepNavigation = (0, _createNonRangePickerStepNavigation.createNonRangePickerStepNavigation)({
        steps
    });
    const { providerProps, renderCurrentView, ownerState } = (0, _usePicker.usePicker)((0, _extends2.default)({}, pickerParams, {
        props,
        localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'desktop',
        getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, _useSlotProps2.default)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, _extends2.default)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState
    }), fieldProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps, _excluded2);
    const Layout = slots.layout ?? _PickersLayout.PickersLayout;
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, _extends2.default)({}, innerSlotProps, {
        toolbar: (0, _extends2.default)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, _extends2.default)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_PickerProvider.PickerProvider, (0, _extends2.default)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Field, (0, _extends2.default)({}, fieldProps, {
                    slots: slots,
                    slotProps: slotProps,
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickerPopper.PickerPopper, {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Layout, (0, _extends2.default)({}, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker
    };
};
exports.useDesktopPicker = useDesktopPicker;

},{"338f64d1be0aff71":"9snJq","4d28a885c027d2c2":"5RcSx","f905cfc7881986a":"h7ttl","b15df91f499c8464":"jeIdK","90ff98092f76b908":"9njXz","509b829400311eae":"izoZZ","7bf62a0ced8a4d24":"id0qU","732161f0871a799":"kfLaB","809451d677b93347":"dE92R","a01d06914e94ffb2":"i6in8","185c8a2a1f0f19fc":"euBpu","5501bd61ed49e19a":"1dlk8"}],"id0qU":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("b2cdd0ed8f784740").default;
var _interopRequireWildcard = require("8463dd9f6f61ace4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickerPopper = PickerPopper;
var _extends2 = _interopRequireDefault(require("feb61eece88bdd31"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("2b7fd6bf0523901"));
var React = _interopRequireWildcard(require("88fe26a1a5fc4400"));
var _useSlotProps = _interopRequireDefault(require("99b2208640b61a0f"));
var _Grow = _interopRequireDefault(require("e5c7271250b88c99"));
var _Fade = _interopRequireDefault(require("2a06bb543f742296"));
var _Paper = _interopRequireDefault(require("2f39e4f863173e0c"));
var _Popper = _interopRequireDefault(require("8bbb5fca34f13172"));
var _Unstable_TrapFocus = _interopRequireDefault(require("6de11a8bcbfc2b3f"));
var _useForkRef = _interopRequireDefault(require("60a950c8ddc8b33f"));
var _useEventCallback = _interopRequireDefault(require("11edfe547938fbee"));
var _ownerDocument = _interopRequireDefault(require("2a0b42692437d8ca"));
var _composeClasses = _interopRequireDefault(require("d6d98407880bd8ea"));
var _styles = require("47d303f3ca85cfa7");
var _pickerPopperClasses = require("d42a8a98b6864623");
var _utils = require("5ac535ddb1500e17");
var _usePickerPrivateContext = require("3ecbef364ecf6f21");
var _hooks = require("55d13d1347568a89");
var _jsxRuntime = require("319f6e319cdd0489");
const _excluded = [
    "PaperComponent",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickerPopperClasses.getPickerPopperUtilityClass, classes);
};
const PickerPopperRoot = (0, _styles.styled)(_Popper.default, {
    name: 'MuiPickerPopper',
    slot: 'Root'
})(({ theme })=>({
        zIndex: theme.zIndex.modal
    }));
const PickerPopperPaper = (0, _styles.styled)(_Paper.default, {
    name: 'MuiPickerPopper',
    slot: 'Paper'
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ popperPlacement })=>new Set([
                    'top',
                    'top-start',
                    'top-end'
                ]).has(popperPlacement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function useClickAwayListener(active, onClickAway) {
    const movedRef = React.useRef(false);
    const syntheticEventRef = React.useRef(false);
    const nodeRef = React.useRef(null);
    const activatedRef = React.useRef(false);
    React.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, _useEventCallback.default)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, _ownerDocument.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = (event)=>{
        // Ignore events handled by our internal components
        if (!event.defaultMuiPrevented) syntheticEventRef.current = true;
    };
    React.useEffect(()=>{
        if (active) {
            const doc = (0, _ownerDocument.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    React.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, _ownerDocument.default)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const PickerPopperPaperWrapper = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { PaperComponent, ownerState, children, paperSlotProps, paperClasses, onPaperClick, onPaperTouchStart } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const paperProps = (0, _useSlotProps.default)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref
        },
        className: paperClasses,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaperComponent, (0, _extends2.default)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function PickerPopper(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickerPopper'
    });
    const { children, placement = 'bottom-start', slots, slotProps, classes: classesProp } = props;
    const { open, popupRef, reduceAnimations } = (0, _hooks.usePickerContext)();
    const { ownerState: pickerOwnerState, rootRefObject } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const { dismissViews, getCurrentViewMode, onPopperExited, triggerElement, viewContainerRole } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    React.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') dismissViews();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        dismissViews,
        open
    ]);
    const lastFocusedElementRef = React.useRef(null);
    React.useEffect(()=>{
        if (viewContainerRole === 'tooltip' || getCurrentViewMode() === 'field') return;
        if (open) lastFocusedElementRef.current = (0, _utils.getActiveElement)(rootRefObject.current);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        viewContainerRole,
        getCurrentViewMode,
        rootRefObject
    ]);
    const classes = useUtilityClasses(classesProp);
    const handleClickAway = (0, _useEventCallback.default)(()=>{
        if (viewContainerRole === 'tooltip') (0, _utils.executeInTheNextEventLoopTick)(()=>{
            if (rootRefObject.current?.contains((0, _utils.getActiveElement)(rootRefObject.current)) || popupRef.current?.contains((0, _utils.getActiveElement)(popupRef.current))) return;
            dismissViews();
        });
        else dismissViews();
    });
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = useClickAwayListener(open, handleClickAway);
    const paperRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(paperRef, popupRef);
    const handlePaperRef = (0, _useForkRef.default)(handleRef, clickAwayRef);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            dismissViews();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? _Fade.default : _Grow.default;
    const FocusTrap = slots?.desktopTrapFocus ?? _Unstable_TrapFocus.default;
    const Paper = slots?.desktopPaper ?? PickerPopperPaper;
    const Popper = slots?.popper ?? PickerPopperRoot;
    const popperProps = (0, _useSlotProps.default)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: viewContainerRole == null ? undefined : viewContainerRole,
            open,
            placement,
            anchorEl: triggerElement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: pickerOwnerState
    });
    const ownerState = React.useMemo(()=>(0, _extends2.default)({}, pickerOwnerState, {
            popperPlacement: popperProps.placement
        }), [
        pickerOwnerState,
        popperProps.placement
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Popper, (0, _extends2.default)({}, popperProps, {
        children: ({ TransitionProps })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(FocusTrap, (0, _extends2.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: viewContainerRole === 'tooltip',
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Transition, (0, _extends2.default)({}, TransitionProps, slotProps?.desktopTransition, {
                    onExited: (event)=>{
                        onPopperExited?.();
                        slotProps?.desktopTransition?.onExited?.(event);
                        TransitionProps?.onExited?.();
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickerPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}

},{"b2cdd0ed8f784740":"9snJq","8463dd9f6f61ace4":"5RcSx","feb61eece88bdd31":"h7ttl","2b7fd6bf0523901":"jeIdK","88fe26a1a5fc4400":"9njXz","99b2208640b61a0f":"izoZZ","e5c7271250b88c99":"4LWtg","2a06bb543f742296":"8DwqP","2f39e4f863173e0c":"arHf6","8bbb5fca34f13172":"lX4bO","6de11a8bcbfc2b3f":"6WLXP","60a950c8ddc8b33f":"93645","11edfe547938fbee":"lkrdI","2a0b42692437d8ca":"c6JQt","d6d98407880bd8ea":"eKeIT","47d303f3ca85cfa7":"c9RfU","d42a8a98b6864623":"bQIXX","5ac535ddb1500e17":"aj7pj","3ecbef364ecf6f21":"8xvkv","55d13d1347568a89":"6MTP2","319f6e319cdd0489":"1dlk8"}],"bQIXX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("df713d9adca8150c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickerPopperUtilityClass = getPickerPopperUtilityClass;
exports.pickerPopperClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("db96a0ed3db85fc8"));
var _generateUtilityClasses = _interopRequireDefault(require("c143cef5a9e48a8f"));
function getPickerPopperUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickerPopper', slot);
}
const pickerPopperClasses = exports.pickerPopperClasses = (0, _generateUtilityClasses.default)('MuiPickerPopper', [
    'root',
    'paper'
]);

},{"df713d9adca8150c":"9snJq","db96a0ed3db85fc8":"dtNEc","c143cef5a9e48a8f":"2Z0QC"}],"7R29R":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateField", {
    enumerable: true,
    get: function() {
        return _DateField.DateField;
    }
});
Object.defineProperty(exports, "unstable_useDateField", {
    enumerable: true,
    get: function() {
        return _useDateField.useDateField;
    }
});
var _DateField = require("e73995224ddcb87");
var _useDateField = require("7578012961b12050");

},{"e73995224ddcb87":"2caKR","7578012961b12050":"fwmva"}],"2caKR":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("e08b748c56df236").default;
var _interopRequireWildcard = require("f24c556930881780").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateField = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("13eefbca13630c15"));
var React = _interopRequireWildcard(require("1faeb732863ab1cb"));
var _propTypes = _interopRequireDefault(require("cd6cf5882755553f"));
var _styles = require("a5bde6180a9da3d2");
var _refType = _interopRequireDefault(require("9caccead91b58f79"));
var _useDateField = require("9d5b2651b7e59f8f");
var _PickerFieldUI = require("db60f06ff09fec8c");
var _icons = require("3e70301f5f872a43");
var _jsxRuntime = require("3e6ffb49de2a8430");
const _excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const DateField = exports.DateField = /*#__PURE__*/ React.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots, slotProps } = themeProps, other = (0, _objectWithoutPropertiesLoose2.default)(themeProps, _excluded);
    const textFieldProps = (0, _PickerFieldUI.useFieldTextFieldProps)({
        slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, _useDateField.useDateField)(textFieldProps);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickerFieldUI.PickerFieldUIContextProvider, {
        slots: slots,
        slotProps: slotProps,
        inputRef: other.inputRef,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickerFieldUI.PickerFieldUI, {
            fieldResponse: fieldResponse,
            defaultOpenPickerIcon: _icons.CalendarIcon
        })
    });
});

},{"e08b748c56df236":"9snJq","f24c556930881780":"5RcSx","13eefbca13630c15":"jeIdK","1faeb732863ab1cb":"9njXz","cd6cf5882755553f":"bnNSm","a5bde6180a9da3d2":"c9RfU","9caccead91b58f79":"fAbhl","9d5b2651b7e59f8f":"fwmva","db60f06ff09fec8c":"lO9ia","3e70301f5f872a43":"ezFd3","3e6ffb49de2a8430":"1dlk8"}],"fwmva":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useDateField = void 0;
var _useField = require("d68a84cfe8639ee0");
var _managers = require("e25c67d2597a25f5");
const useDateField = (props)=>{
    const manager = (0, _managers.useDateManager)(props);
    return (0, _useField.useField)({
        manager,
        props
    });
};
exports.useDateField = useDateField;

},{"d68a84cfe8639ee0":"igDrb","e25c67d2597a25f5":"bvF8R"}],"iJnFI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDateViewCalendar", {
    enumerable: true,
    get: function() {
        return _dateViewRenderers.renderDateViewCalendar;
    }
});
var _dateViewRenderers = require("53573ba9959d6ea5");

},{"53573ba9959d6ea5":"6bXMX"}],"6bXMX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("932ebc3aaaba9eae").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderDateViewCalendar = void 0;
var React = _interopRequireWildcard(require("d68f1a75688ba71b"));
var _DateCalendar = require("91c84d3535a6c3d0");
var _dateUtils = require("46c8befed69db8db");
var _jsxRuntime = require("8713b1359fdc44b9");
const renderDateViewCalendar = ({ view, onViewChange, views, focusedView, onFocusedViewChange, value, defaultValue, referenceDate, onChange, className, classes, disableFuture, disablePast, minDate, maxDate, shouldDisableDate, shouldDisableMonth, shouldDisableYear, reduceAnimations, onMonthChange, monthsPerRow, onYearChange, yearsOrder, yearsPerRow, slots, slotProps, loading, renderLoading, disableHighlightToday, readOnly, disabled, showDaysOutsideCurrentMonth, dayOfWeekFormatter, sx, autoFocus, fixedWeekNumber, displayWeekNumber, timezone })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_DateCalendar.DateCalendar, {
        view: view,
        onViewChange: onViewChange,
        views: views.filter(_dateUtils.isDatePickerView),
        focusedView: focusedView && (0, _dateUtils.isDatePickerView)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });
exports.renderDateViewCalendar = renderDateViewCalendar;

},{"932ebc3aaaba9eae":"5RcSx","d68f1a75688ba71b":"9njXz","91c84d3535a6c3d0":"eYFJF","46c8befed69db8db":"jwfEA","8713b1359fdc44b9":"1dlk8"}],"eYFJF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DateCalendar", {
    enumerable: true,
    get: function() {
        return _DateCalendar.DateCalendar;
    }
});
Object.defineProperty(exports, "dateCalendarClasses", {
    enumerable: true,
    get: function() {
        return _dateCalendarClasses.dateCalendarClasses;
    }
});
Object.defineProperty(exports, "dayCalendarClasses", {
    enumerable: true,
    get: function() {
        return _dayCalendarClasses.dayCalendarClasses;
    }
});
Object.defineProperty(exports, "getDateCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return _dateCalendarClasses.getDateCalendarUtilityClass;
    }
});
Object.defineProperty(exports, "pickersFadeTransitionGroupClasses", {
    enumerable: true,
    get: function() {
        return _pickersFadeTransitionGroupClasses.pickersFadeTransitionGroupClasses;
    }
});
Object.defineProperty(exports, "pickersSlideTransitionClasses", {
    enumerable: true,
    get: function() {
        return _pickersSlideTransitionClasses.pickersSlideTransitionClasses;
    }
});
var _DateCalendar = require("af24fe4ad69bd514");
var _dateCalendarClasses = require("c7dff44d5fbc79ec");
var _dayCalendarClasses = require("1fb735028d32e027");
var _pickersFadeTransitionGroupClasses = require("9d6680b8c138fd91");
var _pickersSlideTransitionClasses = require("2c46e2663913da1f");

},{"af24fe4ad69bd514":"9cbBB","c7dff44d5fbc79ec":"a6wiF","1fb735028d32e027":"aY44y","9d6680b8c138fd91":"a1UGP","2c46e2663913da1f":"dgMqC"}],"9cbBB":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("d53f51ab0a2f2fcc").default;
var _interopRequireWildcard = require("dbb5de2b017c4ddc").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateCalendar = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("60aed60c0034218e"));
var _extends2 = _interopRequireDefault(require("dfe4c4a6b5daec67"));
var React = _interopRequireWildcard(require("2f15a9d8977751b6"));
var _propTypes = _interopRequireDefault(require("e5c8892ca5dfde32"));
var _clsx = _interopRequireDefault(require("a6ef2827825742d"));
var _useSlotProps = _interopRequireDefault(require("e04728370728749a"));
var _styles = require("41d6bf10d75c0af3");
var _composeClasses = _interopRequireDefault(require("d69f577d1efa2a99"));
var _useId = _interopRequireDefault(require("74dbd433146cf0a"));
var _useEventCallback = _interopRequireDefault(require("ecd6db23c09c909e"));
var _useCalendarState = require("d7a5bd3ced79eb9c");
var _PickersFadeTransitionGroup = require("2b39832f8418b119");
var _DayCalendar = require("55d829dedac1407c");
var _MonthCalendar = require("a7e584614c7d1bd9");
var _YearCalendar = require("6d134f6add55a1ac");
var _useViews = require("5f7e5ac4119d4e9b");
var _PickersCalendarHeader = require("cc36036043da277e");
var _dateUtils = require("cf3e9686b3755ca8");
var _PickerViewRoot = require("382ce903c48c22c6");
var _useReduceAnimations = require("55106651cd7123fe");
var _dateCalendarClasses = require("949328d38bfb2428");
var _useControlledValue = require("1336ab9a3861cea8");
var _valueManagers = require("63fdd45821668752");
var _dimensions = require("55841ef4ec114cd0");
var _usePickerPrivateContext = require("2292059209b85415");
var _useDateManager = require("7a91b74c8269c0b2");
var _usePickerAdapter = require("acc5b699679d6042");
var _jsxRuntime = require("5f953f8353f3f4cb");
const _excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, _composeClasses.default)(slots, _dateCalendarClasses.getDateCalendarUtilityClass, classes);
};
function useDateCalendarDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const reduceAnimations = (0, _useReduceAnimations.useReduceAnimations)(themeProps.reduceAnimations);
    const validationProps = (0, _useDateManager.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, _extends2.default)({}, themeProps, validationProps, {
        loading: themeProps.loading ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "..."
            }))
    });
}
const DateCalendarRoot = (0, _styles.styled)(_PickerViewRoot.PickerViewRoot, {
    name: 'MuiDateCalendar',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    height: _dimensions.VIEW_HEIGHT
});
const DateCalendarViewTransitionContainer = (0, _styles.styled)(_PickersFadeTransitionGroup.PickersFadeTransitionGroup, {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer'
})({});
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DateCalendar API](https://mui.com/x/api/date-pickers/date-calendar/)
 */ const DateCalendar = exports.DateCalendar = /*#__PURE__*/ React.forwardRef(function DateCalendar(inProps, ref) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const id = (0, _useId.default)();
    const props = useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus, onViewChange, value: valueProp, defaultValue, referenceDate: referenceDateProp, disableFuture, disablePast, onChange, onMonthChange, reduceAnimations, shouldDisableDate, shouldDisableMonth, shouldDisableYear, view: inView, views, openTo, className, classes: classesProp, disabled, readOnly, minDate, maxDate, disableHighlightToday, focusedView: focusedViewProp, onFocusedViewChange, showDaysOutsideCurrentMonth, fixedWeekNumber, dayOfWeekFormatter, slots, slotProps, loading, renderLoading, displayWeekNumber, yearsOrder, yearsPerRow, monthsPerRow, timezone: timezoneProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValue.useControlledValue)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: _valueManagers.singleItemValueManager
    });
    const { view, setView, focusedView, setFocusedView, goToNextView, setValueAndGoToNextView } = (0, _useViews.useViews)({
        view: inView,
        views,
        openTo,
        onChange: handleValueChange,
        onViewChange,
        autoFocus,
        focusedView: focusedViewProp,
        onFocusedViewChange
    });
    const { referenceDate, calendarState, setVisibleDate, isDateDisabled, onMonthSwitchingAnimationEnd } = (0, _useCalendarState.useCalendarState)({
        value,
        referenceDate: referenceDateProp,
        reduceAnimations,
        onMonthChange,
        minDate,
        maxDate,
        shouldDisableDate,
        disablePast,
        disableFuture,
        timezone,
        getCurrentMonthFromVisibleDate: (visibleDate, prevMonth)=>{
            if (adapter.isSameMonth(visibleDate, prevMonth)) return prevMonth;
            return adapter.startOfMonth(visibleDate);
        }
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? _PickersCalendarHeader.PickersCalendarHeader;
    const calendarHeaderProps = (0, _useSlotProps.default)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views,
            view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (month)=>setVisibleDate({
                    target: month,
                    reason: 'header-navigation'
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled,
            disablePast,
            disableFuture,
            reduceAnimations,
            timezone,
            labelId: gridLabelId
        },
        ownerState
    });
    const handleDateMonthChange = (0, _useEventCallback.default)((newDate)=>{
        const startOfMonth = adapter.startOfMonth(newDate);
        const endOfMonth = adapter.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, _dateUtils.findClosestEnabledDate)({
            adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled,
            timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfMonth,
                reason: 'cell-interaction'
            });
        }
    });
    const handleDateYearChange = (0, _useEventCallback.default)((newDate)=>{
        const startOfYear = adapter.startOfYear(newDate);
        const endOfYear = adapter.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, _dateUtils.findClosestEnabledDate)({
            adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: adapter.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast,
            disableFuture,
            isDateDisabled,
            timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfYear,
                reason: 'cell-interaction'
            });
        }
    });
    const handleSelectedDayChange = (0, _useEventCallback.default)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, _dateUtils.mergeDateAndTime)(adapter, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    React.useEffect(()=>{
        if (adapter.isValid(value)) setVisibleDate({
            target: value,
            reason: 'controlled-value-change'
        });
    }, [
        value
    ]); // eslint-disable-line
    const classes = useUtilityClasses(classesProp);
    const baseDateValidationProps = {
        disablePast,
        disableFuture,
        maxDate,
        minDate
    };
    const commonViewProps = {
        disableHighlightToday,
        readOnly,
        disabled,
        timezone,
        gridLabelId,
        slots,
        slotProps
    };
    const prevOpenViewRef = React.useRef(view);
    React.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = React.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DateCalendarRoot, (0, _extends2.default)({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(CalendarHeader, (0, _extends2.default)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_YearCalendar.YearCalendar, (0, _extends2.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_MonthCalendar.MonthCalendar, (0, _extends2.default)({}, baseDateValidationProps, commonViewProps, {
                            currentMonth: calendarState.currentMonth,
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DayCalendar.DayCalendar, (0, _extends2.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            hasFocus: hasFocus,
                            onFocusedDayChange: (focusedDate)=>setVisibleDate({
                                    target: focusedDate,
                                    reason: 'cell-interaction'
                                }),
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});

},{"d53f51ab0a2f2fcc":"9snJq","dbb5de2b017c4ddc":"5RcSx","60aed60c0034218e":"jeIdK","dfe4c4a6b5daec67":"h7ttl","2f15a9d8977751b6":"9njXz","e5c8892ca5dfde32":"bnNSm","a6ef2827825742d":"by5ni","e04728370728749a":"izoZZ","41d6bf10d75c0af3":"c9RfU","d69f577d1efa2a99":"eKeIT","74dbd433146cf0a":"icfbA","ecd6db23c09c909e":"lkrdI","d7a5bd3ced79eb9c":"fvOQ9","2b39832f8418b119":"fECtb","55d829dedac1407c":"z49F1","a7e584614c7d1bd9":"lY4UB","6d134f6add55a1ac":"1wnII","5f7e5ac4119d4e9b":"6z8XQ","cc36036043da277e":"f9XRr","cf3e9686b3755ca8":"jwfEA","382ce903c48c22c6":"cfp4O","55106651cd7123fe":"jxsYR","949328d38bfb2428":"a6wiF","1336ab9a3861cea8":"gd9Iu","63fdd45821668752":"03AqV","55841ef4ec114cd0":"l0mMZ","2292059209b85415":"8xvkv","7a91b74c8269c0b2":"5P0Cn","acc5b699679d6042":"hE9K5","5f953f8353f3f4cb":"1dlk8"}],"fvOQ9":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("8eba28a1a6f92ef9").default;
var _interopRequireDefault = require("6349bab8dcd94022").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCalendarState = void 0;
var _extends2 = _interopRequireDefault(require("6049bffc74d8e9d1"));
var React = _interopRequireWildcard(require("dbdcd6942745d4ab"));
var _useEventCallback = _interopRequireDefault(require("b14be58c8c09d897"));
var _useIsDateDisabled = require("8ad2d29bd1b9d605");
var _valueManagers = require("42c3f4459c480cd5");
var _getDefaultReferenceDate = require("9d3322b5f86d2718");
var _dateUtils = require("795a3a6920c1b46f");
var _usePickerAdapter = require("4fea148c24818ae6");
const createCalendarStateReducer = (reduceAnimations, adapter)=>(state, action)=>{
        switch(action.type){
            case 'setVisibleDate':
                return (0, _extends2.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.month,
                    isMonthSwitchingAnimating: !adapter.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
                    focusedDay: action.focusedDay
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (adapter.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = adapter.setTimezone(state.currentMonth, newTimezone);
                    if (adapter.getMonth(newCurrentMonth) !== adapter.getMonth(state.currentMonth)) newCurrentMonth = adapter.setMonth(newCurrentMonth, adapter.getMonth(state.currentMonth));
                    return (0, _extends2.default)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, _extends2.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            default:
                throw new Error('missing support');
        }
    };
const useCalendarState = (params)=>{
    const { value, referenceDate: referenceDateProp, disableFuture, disablePast, maxDate, minDate, onMonthChange, onYearChange, reduceAnimations, shouldDisableDate, timezone, getCurrentMonthFromVisibleDate } = params;
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const reducerFn = React.useRef(createCalendarStateReducer(Boolean(reduceAnimations), adapter)).current;
    const referenceDate = React.useMemo(()=>{
        return _valueManagers.singleItemValueManager.getInitialReferenceValue({
            value,
            adapter,
            timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: _getDefaultReferenceDate.SECTION_TYPE_GRANULARITY.day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = React.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: adapter.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const isDateDisabled = (0, _useIsDateDisabled.useIsDateDisabled)({
        shouldDisableDate,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    React.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: adapter.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        adapter
    ]);
    const setVisibleDate = (0, _useEventCallback.default)(({ target, reason })=>{
        if (reason === 'cell-interaction' && calendarState.focusedDay != null && adapter.isSameDay(target, calendarState.focusedDay)) return;
        const skipAnimation = reason === 'cell-interaction';
        let month;
        let focusedDay;
        if (reason === 'cell-interaction') {
            month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
            focusedDay = target;
        } else {
            month = adapter.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : adapter.startOfMonth(target);
            focusedDay = target;
            // If the date is disabled, we try to find a non-disabled date inside the same month.
            if (isDateDisabled(focusedDay)) {
                const startOfMonth = adapter.startOfMonth(target);
                const endOfMonth = adapter.endOfMonth(target);
                focusedDay = (0, _dateUtils.findClosestEnabledDate)({
                    adapter,
                    date: focusedDay,
                    minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
                    maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
                    disablePast,
                    disableFuture,
                    isDateDisabled,
                    timezone
                });
            }
        }
        const hasChangedMonth = !adapter.isSameMonth(calendarState.currentMonth, month);
        const hasChangedYear = !adapter.isSameYear(calendarState.currentMonth, month);
        if (hasChangedMonth) onMonthChange?.(month);
        if (hasChangedYear) onYearChange?.(adapter.startOfYear(month));
        dispatch({
            type: 'setVisibleDate',
            month,
            direction: adapter.isAfterDay(month, calendarState.currentMonth) ? 'left' : 'right',
            focusedDay: calendarState.focusedDay != null && focusedDay != null && adapter.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
            skipAnimation
        });
    });
    const onMonthSwitchingAnimationEnd = React.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    return {
        referenceDate,
        calendarState,
        setVisibleDate,
        isDateDisabled,
        onMonthSwitchingAnimationEnd
    };
};
exports.useCalendarState = useCalendarState;

},{"8eba28a1a6f92ef9":"5RcSx","6349bab8dcd94022":"9snJq","6049bffc74d8e9d1":"h7ttl","dbdcd6942745d4ab":"9njXz","b14be58c8c09d897":"lkrdI","8ad2d29bd1b9d605":"9YFDy","42c3f4459c480cd5":"03AqV","9d3322b5f86d2718":"kOJTa","795a3a6920c1b46f":"jwfEA","4fea148c24818ae6":"hE9K5"}],"9YFDy":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("d43866f6a85256ea").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useIsDateDisabled = void 0;
var React = _interopRequireWildcard(require("8806d1576168f0e0"));
var _validation = require("b1137974297b01da");
var _usePickerAdapter = require("6a3a7f4bf2130a32");
const useIsDateDisabled = ({ shouldDisableDate, shouldDisableMonth, shouldDisableYear, minDate, maxDate, disableFuture, disablePast, timezone })=>{
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    return React.useCallback((day)=>(0, _validation.validateDate)({
            adapter,
            value: day,
            timezone,
            props: {
                shouldDisableDate,
                shouldDisableMonth,
                shouldDisableYear,
                minDate,
                maxDate,
                disableFuture,
                disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};
exports.useIsDateDisabled = useIsDateDisabled;

},{"d43866f6a85256ea":"5RcSx","8806d1576168f0e0":"9njXz","b1137974297b01da":"2toSg","6a3a7f4bf2130a32":"hE9K5"}],"fECtb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cdcbf17f23ba786f").default;
var _interopRequireWildcard = require("76596a12c1692a83").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersFadeTransitionGroup = PickersFadeTransitionGroup;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("c960943a183d7a99"));
var React = _interopRequireWildcard(require("1ba0866ad885da23"));
var _clsx = _interopRequireDefault(require("491c05cebf48ded0"));
var _reactTransitionGroup = require("699cfb215a5abaca");
var _Fade = _interopRequireDefault(require("1b9c1f19aff73791"));
var _styles = require("9f819b589cbf871e");
var _composeClasses = _interopRequireDefault(require("48ce985db20cddcf"));
var _pickersFadeTransitionGroupClasses = require("b5187bcf4fe0f08b");
var _jsxRuntime = require("9a3f2bb8312a3a52");
const _excluded = [
    "children"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersFadeTransitionGroupClasses.getPickersFadeTransitionGroupUtilityClass, classes);
};
const PickersFadeTransitionGroupRoot = (0, _styles.styled)(_reactTransitionGroup.TransitionGroup, {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root'
})({
    display: 'block',
    position: 'relative'
});
/**
 * @ignore - do not document.
 */ function PickersFadeTransitionGroup(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { className, reduceAnimations, transKey, classes: classesProp } = props;
    const { children } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const classes = useUtilityClasses(classesProp);
    const theme = (0, _styles.useTheme)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersFadeTransitionGroupRoot, {
        className: (0, _clsx.default)(classes.root, className),
        ownerState: other,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Fade.default, {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

},{"cdcbf17f23ba786f":"9snJq","76596a12c1692a83":"5RcSx","c960943a183d7a99":"jeIdK","1ba0866ad885da23":"9njXz","491c05cebf48ded0":"by5ni","699cfb215a5abaca":"hnCQJ","1b9c1f19aff73791":"8DwqP","9f819b589cbf871e":"c9RfU","48ce985db20cddcf":"eKeIT","b5187bcf4fe0f08b":"a1UGP","9a3f2bb8312a3a52":"1dlk8"}],"a1UGP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("edc039df771d3bfd").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pickersFadeTransitionGroupClasses = exports.getPickersFadeTransitionGroupUtilityClass = void 0;
var _generateUtilityClass = _interopRequireDefault(require("20cd417b0ca35a40"));
var _generateUtilityClasses = _interopRequireDefault(require("f8c2b5092636b542"));
const getPickersFadeTransitionGroupUtilityClass = (slot)=>(0, _generateUtilityClass.default)('MuiPickersFadeTransitionGroup', slot);
exports.getPickersFadeTransitionGroupUtilityClass = getPickersFadeTransitionGroupUtilityClass;
const pickersFadeTransitionGroupClasses = exports.pickersFadeTransitionGroupClasses = (0, _generateUtilityClasses.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);

},{"edc039df771d3bfd":"9snJq","20cd417b0ca35a40":"dtNEc","f8c2b5092636b542":"2Z0QC"}],"z49F1":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("c5a5306665c8fd7d").default;
var _interopRequireWildcard = require("19f38288f1b30c87").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DayCalendar = DayCalendar;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("d054b19c73748f08"));
var _extends2 = _interopRequireDefault(require("b340fcd6e193e265"));
var React = _interopRequireWildcard(require("affec9e26639ea0d"));
var _useEventCallback = _interopRequireDefault(require("56ff32128c72fd1b"));
var _Typography = _interopRequireDefault(require("418aee0761f40c8d"));
var _useSlotProps2 = _interopRequireDefault(require("abb649064a489e47"));
var _RtlProvider = require("ba9ff47d54cc732a");
var _styles = require("95da0085e8c876d7");
var _composeClasses = _interopRequireDefault(require("ce4d7664f83e903f"));
var _clsx = _interopRequireDefault(require("e2b1028d2a056d8e"));
var _PickersDay = require("a7dc3992d2dea471");
var _hooks = require("66082a89306b7a06");
var _useUtils = require("d5202c7f063b514c");
var _dimensions = require("1d904a01aa0c139e");
var _PickersSlideTransition = require("26a5c7fa7b7a02ab");
var _useIsDateDisabled = require("a94e93b9ae9da29b");
var _dateUtils = require("6b709ca1d3da2b1");
var _dayCalendarClasses = require("5535dfdefa51b700");
var _usePickerDayOwnerState = require("3d8ffd2cc5a3a6e2");
var _jsxRuntime = require("808278e3608eb102");
const _excluded = [
    "parentProps",
    "day",
    "focusedDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], _excluded2 = [
    "ownerState"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, _composeClasses.default)(slots, _dayCalendarClasses.getDayCalendarUtilityClass, classes);
};
const weeksContainerHeight = (_dimensions.DAY_SIZE + _dimensions.DAY_MARGIN * 2) * 6;
const PickersCalendarDayRoot = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root'
})({});
const PickersCalendarDayHeader = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const PickersCalendarWeekDayLabel = (0, _styles.styled)(_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel'
})(({ theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const PickersCalendarWeekNumberLabel = (0, _styles.styled)(_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel'
})(({ theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.disabled
    }));
const PickersCalendarWeekNumber = (0, _styles.styled)(_Typography.default, {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber'
})(({ theme })=>(0, _extends2.default)({}, theme.typography.caption, {
        width: _dimensions.DAY_SIZE,
        height: _dimensions.DAY_SIZE,
        padding: 0,
        margin: `0 ${_dimensions.DAY_MARGIN}px`,
        color: (theme.vars || theme).palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const PickersCalendarLoadingContainer = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: weeksContainerHeight
});
const PickersCalendarSlideTransition = (0, _styles.styled)(_PickersSlideTransition.PickersSlideTransition, {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition'
})({
    minHeight: weeksContainerHeight
});
const PickersCalendarWeekContainer = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer'
})({
    overflow: 'hidden'
});
const PickersCalendarWeek = (0, _styles.styled)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer'
})({
    margin: `${_dimensions.DAY_MARGIN}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function WrappedDay(_ref) {
    let { parentProps, day, focusedDay, selectedDays, isDateDisabled, currentMonthNumber, isViewFocused } = _ref, other = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
    const { disabled, disableHighlightToday, isMonthSwitchingAnimating, showDaysOutsideCurrentMonth, slots, slotProps, timezone } = parentProps;
    const adapter = (0, _hooks.usePickerAdapter)();
    const now = (0, _useUtils.useNow)(timezone);
    const isFocusableDay = focusedDay != null && adapter.isSameDay(day, focusedDay);
    const isFocusedDay = isViewFocused && isFocusableDay;
    const isSelected = selectedDays.some((selectedDay)=>adapter.isSameDay(selectedDay, day));
    const isToday = adapter.isSameDay(day, now);
    const isDisabled = React.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const isOutsideCurrentMonth = React.useMemo(()=>adapter.getMonth(day) !== currentMonthNumber, [
        adapter,
        day,
        currentMonthNumber
    ]);
    const ownerState = (0, _usePickerDayOwnerState.usePickerDayOwnerState)({
        day,
        selected: isSelected,
        disabled: isDisabled,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        disableMargin: undefined,
        // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    });
    const Day = slots?.day ?? _PickersDay.PickersDay;
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, _useSlotProps2.default)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, _extends2.default)({
            disableHighlightToday,
            showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': adapter.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, _extends2.default)({}, ownerState, {
            day,
            isDayDisabled: isDisabled,
            isDaySelected: isSelected
        })
    }), dayProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps, _excluded2);
    const isFirstVisibleCell = React.useMemo(()=>{
        const startOfMonth = adapter.startOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, startOfMonth);
        return adapter.isSameDay(day, adapter.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    const isLastVisibleCell = React.useMemo(()=>{
        const endOfMonth = adapter.endOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, endOfMonth);
        return adapter.isSameDay(day, adapter.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Day, (0, _extends2.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: !isOutsideCurrentMonth && isFocusedDay,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
/**
 * @ignore - do not document.
 */ function DayCalendar(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const adapter = (0, _hooks.usePickerAdapter)();
    const { onFocusedDayChange, className, classes: classesProp, currentMonth, selectedDays, focusedDay, loading, onSelectedDaysChange, onMonthSwitchingAnimationEnd, readOnly, reduceAnimations, renderLoading = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: "..."
        }), slideDirection, TransitionProps, disablePast, disableFuture, minDate, maxDate, shouldDisableDate, shouldDisableMonth, shouldDisableYear, dayOfWeekFormatter = (date)=>adapter.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus, onFocusedViewChange, gridLabelId, displayWeekNumber, fixedWeekNumber, timezone } = props;
    const now = (0, _useUtils.useNow)(timezone);
    const classes = useUtilityClasses(classesProp);
    const isRtl = (0, _RtlProvider.useRtl)();
    const isDateDisabled = (0, _useIsDateDisabled.useIsDateDisabled)({
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disablePast,
        disableFuture,
        timezone
    });
    const translations = (0, _hooks.usePickerTranslations)();
    const handleDaySelect = (0, _useEventCallback.default)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            onFocusedViewChange?.(true);
        }
    };
    const handleKeyDown = (0, _useEventCallback.default)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(adapter.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(adapter.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, _dateUtils.findClosestEnabledDate)({
                        adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : adapter.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? adapter.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled,
                        timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, _dateUtils.findClosestEnabledDate)({
                        adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? adapter.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : adapter.endOfMonth(nextAvailableMonth),
                        isDateDisabled,
                        timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(adapter.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(adapter.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(adapter.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(adapter.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, _useEventCallback.default)((event, day)=>focusDay(day));
    const handleBlur = (0, _useEventCallback.default)((event, day)=>{
        if (focusedDay != null && adapter.isSameDay(focusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = adapter.getMonth(currentMonth);
    const currentYearNumber = adapter.getYear(currentMonth);
    const validSelectedDays = React.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>adapter.startOfDay(day)), [
        adapter,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = React.useMemo(()=>/*#__PURE__*/ React.createRef(), [
        transitionKey
    ]);
    const weeksToDisplay = React.useMemo(()=>{
        const toDisplay = adapter.getWeekArray(currentMonth);
        let nextMonth = adapter.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = adapter.getWeekArray(nextMonth);
            const hasCommonWeek = adapter.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = adapter.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        adapter
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, _dateUtils.getWeekdays)(adapter, now).map((weekday, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": adapter.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarSlideTransition, (0, _extends2.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, _clsx.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(adapter.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(adapter.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        isViewFocused: hasFocus,
                                        focusedDay: focusedDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

},{"c5a5306665c8fd7d":"9snJq","19f38288f1b30c87":"5RcSx","d054b19c73748f08":"jeIdK","b340fcd6e193e265":"h7ttl","affec9e26639ea0d":"9njXz","56ff32128c72fd1b":"lkrdI","418aee0761f40c8d":"2wCD5","abb649064a489e47":"izoZZ","ba9ff47d54cc732a":"ck9Pb","95da0085e8c876d7":"c9RfU","ce4d7664f83e903f":"eKeIT","e2b1028d2a056d8e":"by5ni","a7dc3992d2dea471":"7fdux","66082a89306b7a06":"6MTP2","d5202c7f063b514c":"j0icU","1d904a01aa0c139e":"l0mMZ","26a5c7fa7b7a02ab":"cPbsI","a94e93b9ae9da29b":"9YFDy","6b709ca1d3da2b1":"jwfEA","5535dfdefa51b700":"aY44y","3d8ffd2cc5a3a6e2":"e77tZ","808278e3608eb102":"1dlk8"}],"7fdux":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersDay", {
    enumerable: true,
    get: function() {
        return _PickersDay.PickersDay;
    }
});
Object.defineProperty(exports, "getPickersDayUtilityClass", {
    enumerable: true,
    get: function() {
        return _pickersDayClasses.getPickersDayUtilityClass;
    }
});
Object.defineProperty(exports, "pickersDayClasses", {
    enumerable: true,
    get: function() {
        return _pickersDayClasses.pickersDayClasses;
    }
});
var _PickersDay = require("95bfaee72e21fb4c");
var _pickersDayClasses = require("f40c741aaa0cf521");

},{"95bfaee72e21fb4c":"5I9ON","f40c741aaa0cf521":"8wfTM"}],"5I9ON":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("21e7e41e5a0d2ec0").default;
var _interopRequireWildcard = require("2c204b98b0a7a6ff").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersDay = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("c46c01c0e5e9400a"));
var _extends2 = _interopRequireDefault(require("e5563a1f0455cf77"));
var React = _interopRequireWildcard(require("3ac4ddfa5247e020"));
var _propTypes = _interopRequireDefault(require("e2bb4eb12155daf"));
var _clsx = _interopRequireDefault(require("34e3ca248100ac3b"));
var _ButtonBase = _interopRequireDefault(require("8f02520c69575db6"));
var _useEnhancedEffect = _interopRequireDefault(require("d753d15b5b4da9e5"));
var _composeClasses = _interopRequireDefault(require("a3583bb3b5e39c3b"));
var _useForkRef = _interopRequireDefault(require("e0652a1f2bea4d6e"));
var _styles = require("327d8d1c3db4f934");
var _usePickerAdapter = require("4ac623dd414ef623");
var _dimensions = require("583d061933d1a1ca");
var _pickersDayClasses = require("cd999aba50e48182");
var _usePickerDayOwnerState = require("1b55e08c9f629074");
var _jsxRuntime = require("86b97315df0d173d");
const _excluded = [
    "autoFocus",
    "className",
    "classes",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "children",
    "isFirstVisibleCell",
    "isLastVisibleCell",
    "day",
    "selected",
    "disabled",
    "today",
    "outsideCurrentMonth",
    "disableMargin",
    "disableHighlightToday",
    "showDaysOutsideCurrentMonth"
];
const useUtilityClasses = (classes, ownerState)=>{
    const { isDaySelected, isDayDisabled, isDayCurrent, isDayOutsideMonth, disableMargin, disableHighlightToday, showDaysOutsideCurrentMonth } = ownerState;
    const isHiddenDaySpacingFiller = isDayOutsideMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            isDaySelected && !isHiddenDaySpacingFiller && 'selected',
            isDayDisabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && isDayCurrent && 'today',
            isDayOutsideMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersDayClasses.getPickersDayUtilityClass, classes);
};
const styleArg = ({ theme })=>(0, _extends2.default)({}, theme.typography.caption, {
        width: _dimensions.DAY_SIZE,
        height: _dimensions.DAY_SIZE,
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${_pickersDayClasses.pickersDayClasses.selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${_pickersDayClasses.pickersDayClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${_pickersDayClasses.pickersDayClasses.disabled}:not(.${_pickersDayClasses.pickersDayClasses.selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${_pickersDayClasses.pickersDayClasses.disabled}&.${_pickersDayClasses.pickersDayClasses.selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${_dimensions.DAY_MARGIN}px`
                }
            },
            {
                props: {
                    isDayOutsideMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    isDayCurrent: true
                },
                style: {
                    [`&:not(.${_pickersDayClasses.pickersDayClasses.selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles.today,
        !ownerState.isDayOutsideMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.isDayOutsideMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const PickersDayRoot = (0, _styles.styled)(_ButtonBase.default, {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver
})(styleArg);
const PickersDayFiller = (0, _styles.styled)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver
})(({ theme })=>(0, _extends2.default)({}, styleArg({
        theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const noop = ()=>{};
const PickersDayRaw = /*#__PURE__*/ React.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus = false, className, classes: classesProp, isAnimating, onClick, onDaySelect, onFocus = noop, onBlur = noop, onKeyDown = noop, onMouseDown = noop, onMouseEnter = noop, children, day, selected, disabled, today, outsideCurrentMonth, disableMargin, disableHighlightToday, showDaysOutsideCurrentMonth } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _usePickerDayOwnerState.usePickerDayOwnerState)({
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const ref = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        event.defaultMuiPrevented = true;
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersDayFiller, {
        className: (0, _clsx.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersDayRoot, (0, _extends2.default)({
        className: (0, _clsx.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: children ?? adapter.format(day, 'dayOfMonth')
    }));
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * API:
 *
 * - [PickersDay API](https://mui.com/x/api/date-pickers/pickers-day/)
 */ const PickersDay = exports.PickersDay = /*#__PURE__*/ React.memo(PickersDayRaw);

},{"21e7e41e5a0d2ec0":"9snJq","2c204b98b0a7a6ff":"5RcSx","c46c01c0e5e9400a":"jeIdK","e5563a1f0455cf77":"h7ttl","3ac4ddfa5247e020":"9njXz","e2bb4eb12155daf":"bnNSm","34e3ca248100ac3b":"by5ni","8f02520c69575db6":"ajcyv","d753d15b5b4da9e5":"foonr","a3583bb3b5e39c3b":"eKeIT","e0652a1f2bea4d6e":"93645","327d8d1c3db4f934":"c9RfU","4ac623dd414ef623":"hE9K5","583d061933d1a1ca":"l0mMZ","cd999aba50e48182":"8wfTM","1b55e08c9f629074":"e77tZ","86b97315df0d173d":"1dlk8"}],"8wfTM":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("af615a85e5fb5405").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPickersDayUtilityClass = getPickersDayUtilityClass;
exports.pickersDayClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("c74d362584a5e7a7"));
var _generateUtilityClasses = _interopRequireDefault(require("8a2deff97f27a4e3"));
function getPickersDayUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiPickersDay', slot);
}
const pickersDayClasses = exports.pickersDayClasses = (0, _generateUtilityClasses.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);

},{"af615a85e5fb5405":"9snJq","c74d362584a5e7a7":"dtNEc","8a2deff97f27a4e3":"2Z0QC"}],"e77tZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("fd7e70dcc1ed8b5e").default;
var _interopRequireDefault = require("a578492c62bc89c9").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePickerDayOwnerState = usePickerDayOwnerState;
var _extends2 = _interopRequireDefault(require("e2ae587b3a5328a0"));
var React = _interopRequireWildcard(require("eb755f995ce5c929"));
var _usePickerPrivateContext = require("8bc91607ddda933b");
var _usePickerAdapter = require("ce8964d1ff8a633e");
function usePickerDayOwnerState(parameters) {
    const { disabled, selected, today, outsideCurrentMonth, day, disableMargin, disableHighlightToday, showDaysOutsideCurrentMonth } = parameters;
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    return React.useMemo(()=>(0, _extends2.default)({}, pickerOwnerState, {
            day,
            isDaySelected: selected ?? false,
            isDayDisabled: disabled ?? false,
            isDayCurrent: today ?? false,
            isDayOutsideMonth: outsideCurrentMonth ?? false,
            isDayStartOfWeek: adapter.isSameDay(day, adapter.startOfWeek(day)),
            isDayEndOfWeek: adapter.isSameDay(day, adapter.endOfWeek(day)),
            disableMargin: disableMargin ?? false,
            disableHighlightToday: disableHighlightToday ?? false,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth ?? false
        }), [
        adapter,
        pickerOwnerState,
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    ]);
}

},{"fd7e70dcc1ed8b5e":"5RcSx","a578492c62bc89c9":"9snJq","e2ae587b3a5328a0":"h7ttl","eb755f995ce5c929":"9njXz","8bc91607ddda933b":"8xvkv","ce8964d1ff8a633e":"hE9K5"}],"cPbsI":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bf47c21a2dba6bce").default;
var _interopRequireWildcard = require("9aa25e18e8fe8f63").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersSlideTransition = PickersSlideTransition;
var _extends2 = _interopRequireDefault(require("f8016a0777bfe390"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("5b52be14662bb853"));
var React = _interopRequireWildcard(require("368a52bdf16595d"));
var _clsx = _interopRequireDefault(require("b8aca326e33e8564"));
var _styles = require("1bd7f9947023cdd8");
var _composeClasses = _interopRequireDefault(require("388f5d74108a1ae0"));
var _reactTransitionGroup = require("f5ff0a920eb68ac1");
var _pickersSlideTransitionClasses = require("49b82bca7c4d8a");
var _usePickerPrivateContext = require("2d4d89bc000297ee");
var _jsxRuntime = require("e4b5894b17d294ee");
const _excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const useUtilityClasses = (classes, ownerState)=>{
    const { slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersSlideTransitionClasses.getPickersSlideTransitionUtilityClass, classes);
};
const PickersSlideTransitionRoot = (0, _styles.styled)(_reactTransitionGroup.TransitionGroup, {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${_pickersSlideTransitionClasses.pickersSlideTransitionClasses.slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${_pickersSlideTransitionClasses.pickersSlideTransitionClasses.slideExit}`]: styles.slideExit
            },
            {
                [`.${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${_pickersSlideTransitionClasses.pickersSlideTransitionClasses.slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${_pickersSlideTransitionClasses.pickersSlideTransitionClasses.slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${_pickersSlideTransitionClasses.pickersSlideTransitionClasses['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
/**
 * @ignore - do not document.
 */ function PickersSlideTransition(inProps) {
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children, className, reduceAnimations, slideDirection, transKey, classes: classesProp } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        slideDirection
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    const theme = (0, _styles.useTheme)();
    if (reduceAnimations) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsx.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersSlideTransitionRoot, {
        className: (0, _clsx.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ React.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactTransitionGroup.CSSTransition, (0, _extends2.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}

},{"bf47c21a2dba6bce":"9snJq","9aa25e18e8fe8f63":"5RcSx","f8016a0777bfe390":"h7ttl","5b52be14662bb853":"jeIdK","368a52bdf16595d":"9njXz","b8aca326e33e8564":"by5ni","1bd7f9947023cdd8":"c9RfU","388f5d74108a1ae0":"eKeIT","f5ff0a920eb68ac1":"hnCQJ","49b82bca7c4d8a":"dgMqC","2d4d89bc000297ee":"8xvkv","e4b5894b17d294ee":"1dlk8"}],"dgMqC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("52d64ff96213e937").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pickersSlideTransitionClasses = exports.getPickersSlideTransitionUtilityClass = void 0;
var _generateUtilityClass = _interopRequireDefault(require("fcca3f195e739519"));
var _generateUtilityClasses = _interopRequireDefault(require("6f9dd621df6d23af"));
const getPickersSlideTransitionUtilityClass = (slot)=>(0, _generateUtilityClass.default)('MuiPickersSlideTransition', slot);
exports.getPickersSlideTransitionUtilityClass = getPickersSlideTransitionUtilityClass;
const pickersSlideTransitionClasses = exports.pickersSlideTransitionClasses = (0, _generateUtilityClasses.default)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);

},{"52d64ff96213e937":"9snJq","fcca3f195e739519":"dtNEc","6f9dd621df6d23af":"2Z0QC"}],"aY44y":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("21feb6c54cbb4b30").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDayCalendarUtilityClass = exports.dayCalendarClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("70c251c9bfc17bd2"));
var _generateUtilityClasses = _interopRequireDefault(require("25992e6328e220aa"));
const getDayCalendarUtilityClass = (slot)=>(0, _generateUtilityClass.default)('MuiDayCalendar', slot);
exports.getDayCalendarUtilityClass = getDayCalendarUtilityClass;
const dayCalendarClasses = exports.dayCalendarClasses = (0, _generateUtilityClasses.default)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);

},{"21feb6c54cbb4b30":"9snJq","70c251c9bfc17bd2":"dtNEc","25992e6328e220aa":"2Z0QC"}],"lY4UB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MonthCalendar", {
    enumerable: true,
    get: function() {
        return _MonthCalendar.MonthCalendar;
    }
});
Object.defineProperty(exports, "getMonthCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return _monthCalendarClasses.getMonthCalendarUtilityClass;
    }
});
Object.defineProperty(exports, "monthCalendarClasses", {
    enumerable: true,
    get: function() {
        return _monthCalendarClasses.monthCalendarClasses;
    }
});
var _MonthCalendar = require("a355ab973e8ba741");
var _monthCalendarClasses = require("ee2037521a228166");

},{"a355ab973e8ba741":"1DUJ7","ee2037521a228166":"85Jog"}],"1DUJ7":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("134d2f967203e671").default;
var _interopRequireWildcard = require("ce37839842fec689").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MonthCalendar = void 0;
exports.useMonthCalendarDefaultizedProps = useMonthCalendarDefaultizedProps;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("9410855dc50c627a"));
var _extends2 = _interopRequireDefault(require("c7ae2f192eda3355"));
var React = _interopRequireWildcard(require("e29f305212aa1871"));
var _propTypes = _interopRequireDefault(require("d09474d440dce29e"));
var _clsx = _interopRequireDefault(require("3f59da92ce6336f1"));
var _RtlProvider = require("4ec3efe52f6282f2");
var _createStyled = require("314bf45278a68fc1");
var _styles = require("74ea96d50b29c150");
var _useControlled = _interopRequireDefault(require("b66fe597e70b228e"));
var _composeClasses = _interopRequireDefault(require("2bef009059c105e6"));
var _useEventCallback = _interopRequireDefault(require("930cc456b88b8097"));
var _MonthCalendarButton = require("49683b4e62fc3f6b");
var _useUtils = require("10f8e50557a78bff");
var _monthCalendarClasses = require("9c6c57342eb2d857");
var _dateUtils = require("d5fd7d91183ba5e8");
var _valueManagers = require("dc732fc84a61f479");
var _getDefaultReferenceDate = require("2c94563a5a0cad0c");
var _useControlledValue = require("4ddfcff805fbb80f");
var _dimensions = require("e7d99294b5d4f4fd");
var _usePickerPrivateContext = require("b32b0f8a80e33ed3");
var _useDateManager = require("8df6396a48483dee");
var _usePickerAdapter = require("ef84d9b6ffa84758");
var _jsxRuntime = require("bbaaca23baa7452");
const _excluded = [
    "autoFocus",
    "className",
    "currentMonth",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _monthCalendarClasses.getMonthCalendarUtilityClass, classes);
};
function useMonthCalendarDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useDateManager.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, _extends2.default)({}, themeProps, validationProps, {
        monthsPerRow: themeProps.monthsPerRow ?? 3
    });
}
const isSameMonth = (monthA, monthB, yearA, yearB, adapter)=>Boolean(monthA === monthB && yearB && adapter.isSameYear(yearA, yearB));
const MonthCalendarRoot = (0, _styles.styled)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'monthsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 16,
    padding: '8px 0',
    width: _dimensions.DIALOG_WIDTH,
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    variants: [
        {
            props: {
                monthsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                columnGap: 0
            }
        }
    ]
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [MonthCalendar API](https://mui.com/x/api/date-pickers/month-calendar/)
 */ const MonthCalendar = exports.MonthCalendar = /*#__PURE__*/ React.forwardRef(function MonthCalendar(inProps, ref) {
    const props = useMonthCalendarDefaultizedProps(inProps, 'MuiMonthCalendar');
    const { autoFocus, className, currentMonth, classes: classesProp, value: valueProp, defaultValue, referenceDate: referenceDateProp, disabled, disableFuture, disablePast, maxDate, minDate, onChange, shouldDisableMonth, readOnly, onMonthFocus, hasFocus, onFocusedViewChange, monthsPerRow, timezone: timezoneProp, gridLabelId, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValue.useControlledValue)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: _valueManagers.singleItemValueManager
    });
    const now = (0, _useUtils.useNow)(timezone);
    const isRtl = (0, _RtlProvider.useRtl)();
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const referenceDate = React.useMemo(()=>_valueManagers.singleItemValueManager.getInitialReferenceValue({
            value,
            adapter,
            props,
            timezone,
            referenceDate: referenceDateProp,
            granularity: _getDefaultReferenceDate.SECTION_TYPE_GRANULARITY.month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = useUtilityClasses(classesProp);
    const todayMonth = React.useMemo(()=>adapter.getMonth(now), [
        adapter,
        now
    ]);
    const selectedMonth = React.useMemo(()=>{
        if (value != null) return adapter.getMonth(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedMonth, setFocusedMonth] = React.useState(()=>selectedMonth || adapter.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, _useControlled.default)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, _useEventCallback.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = React.useCallback((dateToValidate)=>{
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = adapter.startOfMonth(dateToValidate);
        if (adapter.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (adapter.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        adapter
    ]);
    const handleMonthSelection = (0, _useEventCallback.default)((event, month)=>{
        if (readOnly) return;
        const currentValue = value && currentMonth && !adapter.isSameYear(value, currentMonth) ? adapter.setYear(value, adapter.getYear(currentMonth)) : value;
        const newDate = adapter.setMonth(currentValue ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, _useEventCallback.default)((month)=>{
        if (!isMonthDisabled(adapter.setMonth(value ?? currentMonth ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    React.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, _useEventCallback.default)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, _useEventCallback.default)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, _useEventCallback.default)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MonthCalendarRoot, (0, _extends2.default)({
        ref: ref,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        monthsPerRow: monthsPerRow
    }, other, {
        children: (0, _dateUtils.getMonthsInYear)(adapter, currentMonth ?? value ?? referenceDate).map((month)=>{
            const monthNumber = adapter.getMonth(month);
            const monthText = adapter.format(month, 'monthShort');
            const monthLabel = adapter.format(month, 'month');
            const isSelected = isSameMonth(monthNumber, selectedMonth, month, value, adapter);
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_MonthCalendarButton.MonthCalendarButton, {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": isSameMonth(monthNumber, todayMonth, month, now, adapter) ? 'date' : undefined,
                "aria-label": monthLabel,
                slots: slots,
                slotProps: slotProps,
                classes: classesProp,
                children: monthText
            }, monthText);
        })
    }));
});

},{"134d2f967203e671":"9snJq","ce37839842fec689":"5RcSx","9410855dc50c627a":"jeIdK","c7ae2f192eda3355":"h7ttl","e29f305212aa1871":"9njXz","d09474d440dce29e":"bnNSm","3f59da92ce6336f1":"by5ni","4ec3efe52f6282f2":"ck9Pb","314bf45278a68fc1":"6ySdS","74ea96d50b29c150":"c9RfU","b66fe597e70b228e":"aysZ8","2bef009059c105e6":"eKeIT","930cc456b88b8097":"lkrdI","49683b4e62fc3f6b":"hqT3W","10f8e50557a78bff":"j0icU","9c6c57342eb2d857":"85Jog","d5fd7d91183ba5e8":"jwfEA","dc732fc84a61f479":"03AqV","2c94563a5a0cad0c":"kOJTa","4ddfcff805fbb80f":"gd9Iu","e7d99294b5d4f4fd":"l0mMZ","b32b0f8a80e33ed3":"8xvkv","8df6396a48483dee":"5P0Cn","ef84d9b6ffa84758":"hE9K5","bbaaca23baa7452":"1dlk8"}],"hqT3W":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5b18bfd005067921").default;
var _interopRequireWildcard = require("1a3a932f18c1395d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MonthCalendarButton = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("e5187e07156a9e4b"));
var _extends2 = _interopRequireDefault(require("20b424e9e1374a85"));
var React = _interopRequireWildcard(require("a52f9b056f686ede"));
var _styles = require("c525a756e36634b7");
var _useSlotProps = _interopRequireDefault(require("3ad7cbd90b1ac82f"));
var _composeClasses = _interopRequireDefault(require("811108449dba7c2e"));
var _useEnhancedEffect = _interopRequireDefault(require("dd44be91f4d26121"));
var _usePickerPrivateContext = require("8eea28e270d65c20");
var _monthCalendarClasses = require("5b99429957bad436");
var _jsxRuntime = require("2260ee32091520ca");
const _excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isMonthDisabled && 'disabled',
            ownerState.isMonthSelected && 'selected'
        ]
    };
    return (0, _composeClasses.default)(slots, _monthCalendarClasses.getMonthCalendarUtilityClass, classes);
};
const DefaultMonthButton = (0, _styles.styled)('button', {
    name: 'MuiMonthCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${_monthCalendarClasses.monthCalendarClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${_monthCalendarClasses.monthCalendarClasses.selected}`]: styles.selected
            }
        ]
})(({ theme })=>(0, _extends2.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${_monthCalendarClasses.monthCalendarClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${_monthCalendarClasses.monthCalendarClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
/**
 * @ignore - do not document.
 */ const MonthCalendarButton = exports.MonthCalendarButton = /*#__PURE__*/ React.memo(function MonthCalendarButton(props) {
    const { autoFocus, classes: classesProp, disabled, selected, value, onClick, onKeyDown, onFocus, onBlur, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ref = React.useRef(null);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        isMonthDisabled: disabled,
        isMonthSelected: selected
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? DefaultMonthButton;
    const monthButtonProps = (0, _useSlotProps.default)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled,
            ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MonthButton, (0, _extends2.default)({}, monthButtonProps));
});

},{"5b18bfd005067921":"9snJq","1a3a932f18c1395d":"5RcSx","e5187e07156a9e4b":"jeIdK","20b424e9e1374a85":"h7ttl","a52f9b056f686ede":"9njXz","c525a756e36634b7":"c9RfU","3ad7cbd90b1ac82f":"izoZZ","811108449dba7c2e":"eKeIT","dd44be91f4d26121":"foonr","8eea28e270d65c20":"8xvkv","5b99429957bad436":"85Jog","2260ee32091520ca":"1dlk8"}],"85Jog":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("71842203f497bb59").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMonthCalendarUtilityClass = getMonthCalendarUtilityClass;
exports.monthCalendarClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("56f93b5e6c9454f1"));
var _generateUtilityClasses = _interopRequireDefault(require("567daf284e2e48ba"));
function getMonthCalendarUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiMonthCalendar', slot);
}
const monthCalendarClasses = exports.monthCalendarClasses = (0, _generateUtilityClasses.default)('MuiMonthCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

},{"71842203f497bb59":"9snJq","56f93b5e6c9454f1":"dtNEc","567daf284e2e48ba":"2Z0QC"}],"1wnII":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "YearCalendar", {
    enumerable: true,
    get: function() {
        return _YearCalendar.YearCalendar;
    }
});
Object.defineProperty(exports, "getYearCalendarUtilityClass", {
    enumerable: true,
    get: function() {
        return _yearCalendarClasses.getYearCalendarUtilityClass;
    }
});
Object.defineProperty(exports, "yearCalendarClasses", {
    enumerable: true,
    get: function() {
        return _yearCalendarClasses.yearCalendarClasses;
    }
});
var _YearCalendar = require("53532f4ac534ccbe");
var _yearCalendarClasses = require("6ba755587ec0b6fc");

},{"53532f4ac534ccbe":"gl13p","6ba755587ec0b6fc":"bCBzu"}],"gl13p":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("3438471754df8abe").default;
var _interopRequireWildcard = require("f6c3fd6215e5129e").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.YearCalendar = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("293d30ab90b5f664"));
var _extends2 = _interopRequireDefault(require("c2e1384e52a0b55a"));
var React = _interopRequireWildcard(require("dbf11e8a36aaf43e"));
var _propTypes = _interopRequireDefault(require("3b65ce6672146dac"));
var _clsx = _interopRequireDefault(require("f6c5745fc5e28aae"));
var _RtlProvider = require("b9a2a32e7886b47");
var _createStyled = require("b8f92eeb3bccc944");
var _styles = require("ac8233917b7282ad");
var _useForkRef = _interopRequireDefault(require("a0d600d38fb64277"));
var _composeClasses = _interopRequireDefault(require("98202555d5660c0f"));
var _useControlled = _interopRequireDefault(require("a2f77062fd2efc3e"));
var _useEventCallback = _interopRequireDefault(require("9776e12321df7f3a"));
var _YearCalendarButton = require("834cd30b69ac2b35");
var _useUtils = require("17b5e1f68f9e7d89");
var _yearCalendarClasses = require("228ca938a997d909");
var _valueManagers = require("d5570cc297e76890");
var _getDefaultReferenceDate = require("40818fcfc0b475bd");
var _useControlledValue = require("2371f0d0f2b73ee6");
var _dimensions = require("4f3d5788a0117273");
var _usePickerPrivateContext = require("f53f797ee856f3c4");
var _useDateManager = require("9090a1abaf2e0080");
var _usePickerAdapter = require("ac767e0f4f6c5f65");
var _jsxRuntime = require("ccfeb8422e4707a8");
const _excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClasses.default)(slots, _yearCalendarClasses.getYearCalendarUtilityClass, classes);
};
function useYearCalendarDefaultizedProps(props, name) {
    const themeProps = (0, _styles.useThemeProps)({
        props,
        name
    });
    const validationProps = (0, _useDateManager.useApplyDefaultValuesToDateValidationProps)(themeProps);
    return (0, _extends2.default)({}, themeProps, validationProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        yearsOrder: themeProps.yearsOrder ?? 'asc'
    });
}
const YearCalendarRoot = (0, _styles.styled)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _createStyled.shouldForwardProp)(prop) && prop !== 'yearsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 12,
    padding: '6px 0',
    overflowY: 'auto',
    height: '100%',
    width: _dimensions.DIALOG_WIDTH,
    maxHeight: _dimensions.MAX_CALENDAR_HEIGHT,
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative',
    variants: [
        {
            props: {
                yearsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                columnGap: 0,
                padding: '0 2px'
            }
        }
    ]
});
const YearCalendarButtonFiller = (0, _styles.styled)('div', {
    name: 'MuiYearCalendar',
    slot: 'ButtonFiller'
})({
    height: 36,
    width: 72
});
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 *
 * API:
 *
 * - [YearCalendar API](https://mui.com/x/api/date-pickers/year-calendar/)
 */ const YearCalendar = exports.YearCalendar = /*#__PURE__*/ React.forwardRef(function YearCalendar(inProps, ref) {
    const props = useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus, className, classes: classesProp, value: valueProp, defaultValue, referenceDate: referenceDateProp, disabled, disableFuture, disablePast, maxDate, minDate, onChange, readOnly, shouldDisableYear, onYearFocus, hasFocus, onFocusedViewChange, yearsOrder, yearsPerRow, timezone: timezoneProp, gridLabelId, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { value, handleValueChange, timezone } = (0, _useControlledValue.useControlledValue)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue,
        referenceDate: referenceDateProp,
        onChange,
        valueManager: _valueManagers.singleItemValueManager
    });
    const now = (0, _useUtils.useNow)(timezone);
    const isRtl = (0, _RtlProvider.useRtl)();
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const referenceDate = React.useMemo(()=>_valueManagers.singleItemValueManager.getInitialReferenceValue({
            value,
            adapter,
            props,
            timezone,
            referenceDate: referenceDateProp,
            granularity: _getDefaultReferenceDate.SECTION_TYPE_GRANULARITY.year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = useUtilityClasses(classesProp);
    const todayYear = React.useMemo(()=>adapter.getYear(now), [
        adapter,
        now
    ]);
    const selectedYear = React.useMemo(()=>{
        if (value != null) return adapter.getYear(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedYear, setFocusedYear] = React.useState(()=>selectedYear || adapter.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, _useControlled.default)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, _useEventCallback.default)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = React.useCallback((dateToValidate)=>{
        if (disablePast && adapter.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && adapter.isAfterYear(dateToValidate, now)) return true;
        if (minDate && adapter.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && adapter.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = adapter.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        adapter
    ]);
    const handleYearSelection = (0, _useEventCallback.default)((event, year)=>{
        if (readOnly) return;
        const newDate = adapter.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, _useEventCallback.default)((year)=>{
        if (!isYearDisabled(adapter.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    React.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, _useEventCallback.default)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, _useEventCallback.default)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, _useEventCallback.default)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = React.useRef(null);
    const handleRef = (0, _useForkRef.default)(ref, scrollerRef);
    React.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = adapter.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
    if (fillerAmount === yearsPerRow) fillerAmount = 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(YearCalendarRoot, (0, _extends2.default)({
        ref: handleRef,
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        yearsPerRow: yearsPerRow
    }, other, {
        children: [
            yearRange.map((year)=>{
                const yearNumber = adapter.getYear(year);
                const isSelected = yearNumber === selectedYear;
                const isDisabled = disabled || isYearDisabled(year);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_YearCalendarButton.YearCalendarButton, {
                    selected: isSelected,
                    value: yearNumber,
                    onClick: handleYearSelection,
                    onKeyDown: handleKeyDown,
                    autoFocus: internalHasFocus && yearNumber === focusedYear,
                    disabled: isDisabled,
                    tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                    onFocus: handleYearFocus,
                    onBlur: handleYearBlur,
                    "aria-current": todayYear === yearNumber ? 'date' : undefined,
                    slots: slots,
                    slotProps: slotProps,
                    classes: classesProp,
                    children: adapter.format(year, 'year')
                }, adapter.format(year, 'year'));
            }),
            Array.from({
                length: fillerAmount
            }, (_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(YearCalendarButtonFiller, {}, index))
        ]
    }));
});

},{"3438471754df8abe":"9snJq","f6c3fd6215e5129e":"5RcSx","293d30ab90b5f664":"jeIdK","c2e1384e52a0b55a":"h7ttl","dbf11e8a36aaf43e":"9njXz","3b65ce6672146dac":"bnNSm","f6c5745fc5e28aae":"by5ni","b9a2a32e7886b47":"ck9Pb","b8f92eeb3bccc944":"6ySdS","ac8233917b7282ad":"c9RfU","a0d600d38fb64277":"93645","98202555d5660c0f":"eKeIT","a2f77062fd2efc3e":"aysZ8","9776e12321df7f3a":"lkrdI","834cd30b69ac2b35":"7Aarv","17b5e1f68f9e7d89":"j0icU","228ca938a997d909":"bCBzu","d5570cc297e76890":"03AqV","40818fcfc0b475bd":"kOJTa","2371f0d0f2b73ee6":"gd9Iu","4f3d5788a0117273":"l0mMZ","f53f797ee856f3c4":"8xvkv","9090a1abaf2e0080":"5P0Cn","ac767e0f4f6c5f65":"hE9K5","ccfeb8422e4707a8":"1dlk8"}],"7Aarv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("66aa73d240e41dde").default;
var _interopRequireWildcard = require("1db7f23e7c7a2696").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.YearCalendarButton = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("a1516342cdea0595"));
var _extends2 = _interopRequireDefault(require("5de97f937460da7e"));
var React = _interopRequireWildcard(require("a4c6e87595076a6c"));
var _styles = require("7052e8cf13ce0779");
var _useSlotProps = _interopRequireDefault(require("4d5b4c6c10c95627"));
var _composeClasses = _interopRequireDefault(require("3704b26db03a1c51"));
var _useEnhancedEffect = _interopRequireDefault(require("6adbe6b740538dea"));
var _usePickerPrivateContext = require("84ffaa3a841b4958");
var _yearCalendarClasses = require("21498be8b8377ea4");
var _jsxRuntime = require("3e2cfee1b2535080");
const _excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isYearDisabled && 'disabled',
            ownerState.isYearSelected && 'selected'
        ]
    };
    return (0, _composeClasses.default)(slots, _yearCalendarClasses.getYearCalendarUtilityClass, classes);
};
const DefaultYearButton = (0, _styles.styled)('button', {
    name: 'MuiYearCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${_yearCalendarClasses.yearCalendarClasses.disabled}`]: styles.disabled
            },
            {
                [`&.${_yearCalendarClasses.yearCalendarClasses.selected}`]: styles.selected
            }
        ]
})(({ theme })=>(0, _extends2.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _styles.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${_yearCalendarClasses.yearCalendarClasses.disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${_yearCalendarClasses.yearCalendarClasses.selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
/**
 * @ignore - internal component.
 */ const YearCalendarButton = exports.YearCalendarButton = /*#__PURE__*/ React.memo(function YearCalendarButton(props) {
    const { autoFocus, classes: classesProp, disabled, selected, value, onClick, onKeyDown, onFocus, onBlur, slots, slotProps } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ref = React.useRef(null);
    const { ownerState: pickerOwnerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const ownerState = (0, _extends2.default)({}, pickerOwnerState, {
        isYearDisabled: disabled,
        isYearSelected: selected
    });
    const classes = useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, _useEnhancedEffect.default)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? DefaultYearButton;
    const yearButtonProps = (0, _useSlotProps.default)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled,
            ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(YearButton, (0, _extends2.default)({}, yearButtonProps));
});

},{"66aa73d240e41dde":"9snJq","1db7f23e7c7a2696":"5RcSx","a1516342cdea0595":"jeIdK","5de97f937460da7e":"h7ttl","a4c6e87595076a6c":"9njXz","7052e8cf13ce0779":"c9RfU","4d5b4c6c10c95627":"izoZZ","3704b26db03a1c51":"eKeIT","6adbe6b740538dea":"foonr","84ffaa3a841b4958":"8xvkv","21498be8b8377ea4":"bCBzu","3e2cfee1b2535080":"1dlk8"}],"bCBzu":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4db6ad8aebaa5a19").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getYearCalendarUtilityClass = getYearCalendarUtilityClass;
exports.yearCalendarClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("99f61a9d9083465d"));
var _generateUtilityClasses = _interopRequireDefault(require("7ca01339fd791d9f"));
function getYearCalendarUtilityClass(slot) {
    return (0, _generateUtilityClass.default)('MuiYearCalendar', slot);
}
const yearCalendarClasses = exports.yearCalendarClasses = (0, _generateUtilityClasses.default)('MuiYearCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);

},{"4db6ad8aebaa5a19":"9snJq","99f61a9d9083465d":"dtNEc","7ca01339fd791d9f":"2Z0QC"}],"f9XRr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PickersCalendarHeader", {
    enumerable: true,
    get: function() {
        return _PickersCalendarHeader.PickersCalendarHeader;
    }
});
Object.defineProperty(exports, "pickersCalendarHeaderClasses", {
    enumerable: true,
    get: function() {
        return _pickersCalendarHeaderClasses.pickersCalendarHeaderClasses;
    }
});
var _pickersCalendarHeaderClasses = require("b5385d4fdf876b1");
var _PickersCalendarHeader = require("40f0d01a7fdc6d27");

},{"b5385d4fdf876b1":"iCFol","40f0d01a7fdc6d27":"alCA1"}],"iCFol":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("adb5983651f84610").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pickersCalendarHeaderClasses = exports.getPickersCalendarHeaderUtilityClass = void 0;
var _generateUtilityClass = _interopRequireDefault(require("60acdb3bdfa7a56b"));
var _generateUtilityClasses = _interopRequireDefault(require("bcf67a3e791286a3"));
const getPickersCalendarHeaderUtilityClass = (slot)=>(0, _generateUtilityClass.default)('MuiPickersCalendarHeader', slot);
exports.getPickersCalendarHeaderUtilityClass = getPickersCalendarHeaderUtilityClass;
const pickersCalendarHeaderClasses = exports.pickersCalendarHeaderClasses = (0, _generateUtilityClasses.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);

},{"adb5983651f84610":"9snJq","60acdb3bdfa7a56b":"dtNEc","bcf67a3e791286a3":"2Z0QC"}],"alCA1":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireDefault = require("5c53ce0893074a60").default;
var _interopRequireWildcard = require("9fd7970570e7c52d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PickersCalendarHeader = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("d5d18920df7f1419"));
var _extends2 = _interopRequireDefault(require("c35ef2a3073d499b"));
var React = _interopRequireWildcard(require("b2479b1719f8dc53"));
var _propTypes = _interopRequireDefault(require("338633822ae0d9b9"));
var _clsx = _interopRequireDefault(require("dd9073f6215393e6"));
var _Fade = _interopRequireDefault(require("769d517ffc13ae35"));
var _styles = require("857440660f3b3770");
var _useSlotProps2 = _interopRequireDefault(require("31679da6a06130f2"));
var _composeClasses = _interopRequireDefault(require("a759a901a7b722ef"));
var _IconButton = _interopRequireDefault(require("e7d5d6220f9a9613"));
var _hooks = require("f484ff21efe12d9b");
var _PickersFadeTransitionGroup = require("4e1277febcd8a938");
var _icons = require("cc808cea27186b4c");
var _PickersArrowSwitcher = require("5fceb50863f32dce");
var _dateHelpersHooks = require("bc791152f4b476d3");
var _pickersCalendarHeaderClasses = require("da49727e5c09bd5c");
var _usePickerPrivateContext = require("1286e9a3b4bd89b8");
var _jsxRuntime = require("34511ecc9834091c");
const _excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "classes",
    "timezone",
    "format"
], _excluded2 = [
    "ownerState"
];
const useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, _composeClasses.default)(slots, _pickersCalendarHeaderClasses.getPickersCalendarHeaderUtilityClass, classes);
};
const PickersCalendarHeaderRoot = (0, _styles.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root'
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const PickersCalendarHeaderLabelContainer = (0, _styles.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer'
})(({ theme })=>(0, _extends2.default)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const PickersCalendarHeaderLabel = (0, _styles.styled)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label'
})({
    marginRight: 6
});
const PickersCalendarHeaderSwitchViewButton = (0, _styles.styled)(_IconButton.default, {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton'
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${_pickersCalendarHeaderClasses.pickersCalendarHeaderClasses.switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const PickersCalendarHeaderSwitchViewIcon = (0, _styles.styled)(_icons.ArrowDropDownIcon, {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon'
})(({ theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const PickersCalendarHeader = exports.PickersCalendarHeader = /*#__PURE__*/ React.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, _hooks.usePickerTranslations)();
    const adapter = (0, _hooks.usePickerAdapter)();
    const props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots, slotProps, currentMonth: month, disabled, disableFuture, disablePast, maxDate, minDate, onMonthChange, onViewChange, view, reduceAnimations, views, labelId, className, classes: classesProp, timezone, format = `${adapter.formats.month} ${adapter.formats.year}` } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const { ownerState } = (0, _usePickerPrivateContext.usePickerPrivateContext)();
    const classes = useUtilityClasses(classesProp);
    const SwitchViewButton = slots?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, _useSlotProps2.default)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: (0, _extends2.default)({}, ownerState, {
            view
        }),
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, _useSlotProps2.default)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, _objectWithoutPropertiesLoose2.default)(_useSlotProps, _excluded2);
    const selectNextMonth = ()=>onMonthChange(adapter.addMonths(month, 1));
    const selectPreviousMonth = ()=>onMonthChange(adapter.addMonths(month, -1));
    const isNextMonthDisabled = (0, _dateHelpersHooks.useNextMonthDisabled)(month, {
        disableFuture,
        maxDate,
        timezone
    });
    const isPreviousMonthDisabled = (0, _dateHelpersHooks.usePreviousMonthDisabled)(month, {
        disablePast,
        minDate,
        timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = adapter.formatByString(month, format);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarHeaderRoot, (0, _extends2.default)({}, other, {
        ownerState: ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersFadeTransitionGroup.PickersFadeTransitionGroup, {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchViewButton, (0, _extends2.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchViewIcon, (0, _extends2.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Fade.default, {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PickersArrowSwitcher.PickersArrowSwitcher, {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});

},{"5c53ce0893074a60":"9snJq","9fd7970570e7c52d":"5RcSx","d5d18920df7f1419":"jeIdK","c35ef2a3073d499b":"h7ttl","b2479b1719f8dc53":"9njXz","338633822ae0d9b9":"bnNSm","dd9073f6215393e6":"by5ni","769d517ffc13ae35":"8DwqP","857440660f3b3770":"c9RfU","31679da6a06130f2":"izoZZ","a759a901a7b722ef":"eKeIT","e7d5d6220f9a9613":"bXjnZ","f484ff21efe12d9b":"6MTP2","4e1277febcd8a938":"fECtb","cc808cea27186b4c":"ezFd3","5fceb50863f32dce":"1dVlM","bc791152f4b476d3":"b2RZ3","da49727e5c09bd5c":"iCFol","1286e9a3b4bd89b8":"8xvkv","34511ecc9834091c":"1dlk8"}],"a6wiF":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bb2a3945a8ecafb4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDateCalendarUtilityClass = exports.dateCalendarClasses = void 0;
var _generateUtilityClass = _interopRequireDefault(require("d68e582469362f81"));
var _generateUtilityClasses = _interopRequireDefault(require("921897dd9f326b6d"));
const getDateCalendarUtilityClass = (slot)=>(0, _generateUtilityClass.default)('MuiDateCalendar', slot);
exports.getDateCalendarUtilityClass = getDateCalendarUtilityClass;
const dateCalendarClasses = exports.dateCalendarClasses = (0, _generateUtilityClasses.default)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);

},{"bb2a3945a8ecafb4":"9snJq","d68e582469362f81":"dtNEc","921897dd9f326b6d":"2Z0QC"}],"2Ji01":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MobileDatePicker", {
    enumerable: true,
    get: function() {
        return _MobileDatePicker.MobileDatePicker;
    }
});
var _MobileDatePicker = require("14e42bc3aa19c8cc");

},{"14e42bc3aa19c8cc":"jdWPz"}],"jdWPz":[function(require,module,exports,__globalThis) {
"use strict";
'use client';
var _interopRequireWildcard = require("c7741478bd51514a").default;
var _interopRequireDefault = require("751a95a8dc5aba58").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MobileDatePicker = void 0;
var _extends2 = _interopRequireDefault(require("674bc9f9e3baac9a"));
var React = _interopRequireWildcard(require("2582a7c3684cf61"));
var _propTypes = _interopRequireDefault(require("38aa49851e5b4109"));
var _resolveComponentProps = _interopRequireDefault(require("58abb6b148fd707c"));
var _refType = _interopRequireDefault(require("1ff8ebff6d6144d1"));
var _useMobilePicker = require("4ce0586fc5f81f82");
var _shared = require("9a8a1773a6900876");
var _usePickerAdapter = require("2ee749e96dfc2f24");
var _validation = require("d428635dea67f788");
var _DateField = require("75f22a157de1170b");
var _valueManagers = require("b80ea8e2f0cca90");
var _dateViewRenderers = require("6e364831a15bbbd3");
var _dateUtils = require("ab7dec8279d4abf0");
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const MobileDatePicker = exports.MobileDatePicker = /*#__PURE__*/ React.forwardRef(function MobileDatePicker(inProps, ref) {
    const adapter = (0, _usePickerAdapter.usePickerAdapter)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, _shared.useDatePickerDefaultizedProps)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, _extends2.default)({
        day: _dateViewRenderers.renderDateViewCalendar,
        month: _dateViewRenderers.renderDateViewCalendar,
        year: _dateViewRenderers.renderDateViewCalendar
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, _extends2.default)({}, defaultizedProps, {
        viewRenderers,
        format: (0, _dateUtils.resolveDateFormat)(adapter, defaultizedProps, false),
        slots: (0, _extends2.default)({
            field: _DateField.DateField
        }, defaultizedProps.slots),
        slotProps: (0, _extends2.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, _extends2.default)({}, (0, _resolveComponentProps.default)(defaultizedProps.slotProps?.field, ownerState), (0, _validation.extractValidationProps)(defaultizedProps)),
            toolbar: (0, _extends2.default)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker } = (0, _useMobilePicker.useMobilePicker)({
        ref,
        props,
        valueManager: _valueManagers.singleItemValueManager,
        valueType: 'date',
        validator: _validation.validateDate,
        steps: null
    });
    return renderPicker();
});
MobileDatePicker.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: _propTypes.default.bool,
    className: _propTypes.default.string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: _propTypes.default.bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: _propTypes.default.func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: _propTypes.default.object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: _propTypes.default.bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: _propTypes.default.bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: _propTypes.default.bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: _propTypes.default.bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: _propTypes.default.bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: _propTypes.default.any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: _propTypes.default.number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: _propTypes.default.string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: _propTypes.default.oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: _refType.default,
    /**
   * The label content.
   */ label: _propTypes.default.node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: _propTypes.default.bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: _propTypes.default.object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: _propTypes.default.object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: _propTypes.default.object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: _propTypes.default.oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: _propTypes.default.string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: _propTypes.default.func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: _propTypes.default.func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: _propTypes.default.func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: _propTypes.default.func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: _propTypes.default.func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: _propTypes.default.func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: _propTypes.default.func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: _propTypes.default.func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: _propTypes.default.func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: _propTypes.default.bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: _propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: _propTypes.default.oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: _propTypes.default.bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: _propTypes.default.bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: _propTypes.default.object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: _propTypes.default.func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: _propTypes.default.oneOfType([
        _propTypes.default.oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        _propTypes.default.number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: _propTypes.default.func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: _propTypes.default.func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: _propTypes.default.func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: _propTypes.default.bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: _propTypes.default.object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: _propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: _propTypes.default.string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: _propTypes.default.object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: _propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: _propTypes.default.shape({
        day: _propTypes.default.func,
        month: _propTypes.default.func,
        year: _propTypes.default.func
    }),
    /**
   * Available views.
   */ views: _propTypes.default.arrayOf(_propTypes.default.oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: _propTypes.default.oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: _propTypes.default.oneOf([
        3,
        4
    ])
};

},{"c7741478bd51514a":"5RcSx","751a95a8dc5aba58":"9snJq","674bc9f9e3baac9a":"h7ttl","2582a7c3684cf61":"9njXz","38aa49851e5b4109":"bnNSm","58abb6b148fd707c":"iXpA3","1ff8ebff6d6144d1":"fAbhl","4ce0586fc5f81f82":"d0HtL","9a8a1773a6900876":"8PD0g","2ee749e96dfc2f24":"hE9K5","d428635dea67f788":"2toSg","75f22a157de1170b":"7R29R","b80ea8e2f0cca90":"03AqV","6e364831a15bbbd3":"iJnFI","ab7dec8279d4abf0":"jwfEA"}],"ggBKJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _accordionSummaryDefault.default));
parcelHelpers.export(exports, "accordionSummaryClasses", ()=>(0, _accordionSummaryClassesDefault.default));
var _accordionSummary = require("./AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _accordionSummaryClasses = require("./accordionSummaryClasses");
var _accordionSummaryClassesDefault = parcelHelpers.interopDefault(_accordionSummaryClasses);
parcelHelpers.exportAll(_accordionSummaryClasses, exports);

},{"./AccordionSummary":"er37Q","./accordionSummaryClasses":"4jRuh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"er37Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _zeroStyled = require("../zero-styled");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _accordionContext = require("../Accordion/AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _accordionSummaryClasses = require("./accordionSummaryClasses");
var _accordionSummaryClassesDefault = parcelHelpers.interopDefault(_accordionSummaryClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, expanded, disabled, disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _accordionSummaryClasses.getAccordionSummaryUtilityClass), classes);
};
const AccordionSummaryRoot = (0, _zeroStyled.styled)((0, _buttonBaseDefault.default), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, _accordionSummaryClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _accordionSummaryClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, _accordionSummaryClassesDefault.default).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, _accordionSummaryClassesDefault.default).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const AccordionSummaryContent = (0, _zeroStyled.styled)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, _accordionSummaryClassesDefault.default).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const AccordionSummaryExpandIconWrapper = (0, _zeroStyled.styled)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, _accordionSummaryClassesDefault.default).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const AccordionSummary = /*#__PURE__*/ _react.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children, className, expandIcon, focusVisibleClassName, onClick } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { disabled = false, disableGutters, expanded, toggle } = _react.useContext((0, _accordionContextDefault.default));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, _extendsDefault.default)({}, props, {
        expanded,
        disabled,
        disableGutters
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AccordionSummaryRoot, (0, _extendsDefault.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, _clsxDefault.default)(classes.root, className),
        focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
exports.default = AccordionSummary;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../zero-styled":"89fxU","../DefaultPropsProvider":"ff3VX","../ButtonBase":"ajcyv","../Accordion/AccordionContext":"gALVp","./accordionSummaryClasses":"4jRuh","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"89fxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelHelpers.export(exports, "createUseThemeProps", ()=>createUseThemeProps);
var _useThemeProps = require("../styles/useThemeProps");
var _useThemePropsDefault = parcelHelpers.interopDefault(_useThemeProps);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
function createUseThemeProps(name) {
    return 0, _useThemePropsDefault.default;
}

},{"../styles/useThemeProps":"9ffJF","../styles/styled":"bTnxF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gALVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const AccordionContext = /*#__PURE__*/ _react.createContext({});
exports.default = AccordionContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jRuh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccordionSummaryUtilityClass", ()=>getAccordionSummaryUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAccordionSummaryUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiAccordionSummary', slot);
}
const accordionSummaryClasses = (0, _generateUtilityClassesDefault.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
exports.default = accordionSummaryClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lkcQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _accordionDefault.default));
parcelHelpers.export(exports, "accordionClasses", ()=>(0, _accordionClassesDefault.default));
var _accordion = require("./Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionClasses = require("./accordionClasses");
var _accordionClassesDefault = parcelHelpers.interopDefault(_accordionClasses);
parcelHelpers.exportAll(_accordionClasses, exports);

},{"./Accordion":"hDqD9","./accordionClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hDqD9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _reactIs = require("react-is");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _zeroStyled = require("../zero-styled");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _collapse = require("../Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _accordionContext = require("./AccordionContext");
var _accordionContextDefault = parcelHelpers.interopDefault(_accordionContext);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _useSlot = require("../utils/useSlot");
var _useSlotDefault = parcelHelpers.interopDefault(_useSlot);
var _accordionClasses = require("./accordionClasses");
var _accordionClassesDefault = parcelHelpers.interopDefault(_accordionClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, square, expanded, disabled, disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _accordionClasses.getAccordionUtilityClass), classes);
};
const AccordionRoot = (0, _zeroStyled.styled)((0, _paperDefault.default), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            {
                [`& .${(0, _accordionClassesDefault.default).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, _accordionClassesDefault.default).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, _accordionClassesDefault.default).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, _accordionClassesDefault.default).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const Accordion = /*#__PURE__*/ _react.forwardRef(function Accordion(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className, defaultExpanded = false, disabled = false, disableGutters = false, expanded: expandedProp, onChange, square = false, slots = {}, slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [expanded, setExpandedState] = (0, _useControlledDefault.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = _react.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = _react.Children.toArray(childrenProp);
    const contextValue = _react.useMemo(()=>({
            expanded,
            disabled,
            disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        square,
        disabled,
        disableGutters,
        expanded
    });
    const classes = useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, _extendsDefault.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, _extendsDefault.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, _useSlotDefault.default)('transition', {
        elementType: (0, _collapseDefault.default),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AccordionRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionContextDefault.default).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionSlot, (0, _extendsDefault.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
exports.default = Accordion;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","react-is":"8oKlE","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/chainPropTypes":"83tGg","@mui/utils/composeClasses":"43D21","../zero-styled":"89fxU","../DefaultPropsProvider":"ff3VX","../Collapse":"eS35Z","../Paper":"arHf6","./AccordionContext":"gALVp","../utils/useControlled":"1VreF","../utils/useSlot":"29rI6","./accordionClasses":"aWVvO","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eS35Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _collapseDefault.default));
parcelHelpers.export(exports, "collapseClasses", ()=>(0, _collapseClassesDefault.default));
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _collapseClasses = require("./collapseClasses");
var _collapseClassesDefault = parcelHelpers.interopDefault(_collapseClasses);
parcelHelpers.exportAll(_collapseClasses, exports);
'use client';

},{"./Collapse":"irRoA","./collapseClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irRoA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactTransitionGroup = require("react-transition-group");
var _useTimeout = require("@mui/utils/useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _elementTypeAcceptingRef = require("@mui/utils/elementTypeAcceptingRef");
var _elementTypeAcceptingRefDefault = parcelHelpers.interopDefault(_elementTypeAcceptingRef);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _createTransitions = require("../styles/createTransitions");
var _utils = require("../transitions/utils");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _utils1 = require("../utils");
var _collapseClasses = require("./collapseClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const useUtilityClasses = (ownerState)=>{
    const { orientation, classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _collapseClasses.getCollapseUtilityClass), classes);
};
const CollapseRoot = (0, _styledDefault.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, _extendsDefault.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const CollapseWrapper = (0, _styledDefault.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState })=>(0, _extendsDefault.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const CollapseWrapperInner = (0, _styledDefault.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState })=>(0, _extendsDefault.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const Collapse = /*#__PURE__*/ _react.forwardRef(function Collapse(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener, children, className, collapsedSize: collapsedSizeProp = '0px', component, easing, in: inProp, onEnter, onEntered, onEntering, onExit, onExited, onExiting, orientation = 'vertical', style, timeout = (0, _createTransitions.duration).standard, // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, _reactTransitionGroup.Transition) } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = useUtilityClasses(ownerState);
    const theme = (0, _useThemeDefault.default)();
    const timer = (0, _useTimeoutDefault.default)();
    const wrapperRef = _react.useRef(null);
    const autoTransitionDuration = _react.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = _react.useRef(null);
    const handleRef = (0, _utils1.useForkRef)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, _utils.getTransitionProps)({
            style,
            timeout,
            easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TransitionComponent, (0, _extendsDefault.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseRoot, (0, _extendsDefault.default)({
                as: component,
                className: (0, _clsxDefault.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, _extendsDefault.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, _extendsDefault.default)({}, ownerState, {
                    state
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapper, {
                    ownerState: (0, _extendsDefault.default)({}, ownerState, {
                        state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CollapseWrapperInner, {
                        ownerState: (0, _extendsDefault.default)({}, ownerState, {
                            state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
Collapse.muiSupportAuto = true;
exports.default = Collapse;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","clsx":"bK0Bf","prop-types":"bnNSm","react-transition-group":"hnCQJ","@mui/utils/useTimeout":"6WuNb","@mui/utils/elementTypeAcceptingRef":"gpPr5","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../styles/createTransitions":"4xJuz","../transitions/utils":"3QK1j","../styles/useTheme":"d8hfc","../utils":"60iOt","./collapseClasses":"bnGTy","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnGTy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCollapseUtilityClass", ()=>getCollapseUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCollapseUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiCollapse', slot);
}
const collapseClasses = (0, _generateUtilityClassesDefault.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
exports.default = collapseClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"29rI6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSlot);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _useForkRef = require("@mui/utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _appendOwnerState = require("@mui/utils/appendOwnerState");
var _appendOwnerStateDefault = parcelHelpers.interopDefault(_appendOwnerState);
var _resolveComponentProps = require("@mui/utils/resolveComponentProps");
var _resolveComponentPropsDefault = parcelHelpers.interopDefault(_resolveComponentProps);
var _mergeSlotProps = require("@mui/utils/mergeSlotProps");
var _mergeSlotPropsDefault = parcelHelpers.interopDefault(_mergeSlotProps);
'use client';
const _excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], _excluded2 = [
    "component",
    "slots",
    "slotProps"
], _excluded3 = [
    "component"
];
function useSlot(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className, elementType: initialElementType, ownerState, externalForwardedProps, getSlotOwnerState, internalForwardedProps } = parameters, useSlotPropsParams = (0, _objectWithoutPropertiesLooseDefault.default)(parameters, _excluded);
    const { component: rootComponent, slots = {
        [name]: undefined
    }, slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, _objectWithoutPropertiesLooseDefault.default)(externalForwardedProps, _excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, _resolveComponentPropsDefault.default)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, _mergeSlotPropsDefault.default)((0, _extendsDefault.default)({
        className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef } = _mergeSlotProps, mergedProps = (0, _objectWithoutPropertiesLooseDefault.default)(_mergeSlotProps.props, _excluded3);
    const ref = (0, _useForkRefDefault.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, _extendsDefault.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, _appendOwnerStateDefault.default)(elementType, (0, _extendsDefault.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/useForkRef":"gq6SY","@mui/utils/appendOwnerState":"3olcZ","@mui/utils/resolveComponentProps":"dzXZN","@mui/utils/mergeSlotProps":"I71PR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aWVvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccordionUtilityClass", ()=>getAccordionUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAccordionUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiAccordion', slot);
}
const accordionClasses = (0, _generateUtilityClassesDefault.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
exports.default = accordionClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96rKf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _accordionDetailsDefault.default));
parcelHelpers.export(exports, "accordionDetailsClasses", ()=>(0, _accordionDetailsClassesDefault.default));
var _accordionDetails = require("./AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _accordionDetailsClasses = require("./accordionDetailsClasses");
var _accordionDetailsClassesDefault = parcelHelpers.interopDefault(_accordionDetailsClasses);
parcelHelpers.exportAll(_accordionDetailsClasses, exports);

},{"./AccordionDetails":"4edFA","./accordionDetailsClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4edFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _zeroStyled = require("../zero-styled");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _accordionDetailsClasses = require("./accordionDetailsClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _accordionDetailsClasses.getAccordionDetailsUtilityClass), classes);
};
const AccordionDetailsRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const AccordionDetails = /*#__PURE__*/ _react.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = props;
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AccordionDetailsRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
exports.default = AccordionDetails;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../zero-styled":"89fxU","../DefaultPropsProvider":"ff3VX","./accordionDetailsClasses":"jzgMs","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jzgMs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccordionDetailsUtilityClass", ()=>getAccordionDetailsUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAccordionDetailsUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiAccordionDetails', slot);
}
const accordionDetailsClasses = (0, _generateUtilityClassesDefault.default)('MuiAccordionDetails', [
    'root'
]);
exports.default = accordionDetailsClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7lWUt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _system.StyledEngineProvider));
var _system = require("@mui/system");

},{"@mui/system":"5Hnj5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dTlzn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectLanguage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _context = require("../../context");
function SelectLanguage(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "select-language",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "dropdown",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        className: "select-language",
                        classNamePrefix: "select-language",
                        formatOptionLabel: ({ name })=>name,
                        isSearchable: false,
                        getOptionValue: ({ id })=>id,
                        value: context.language,
                        onChange: ({ id: languageId })=>context.navigate({
                                languageId
                            }, context.match.path, {
                                preserveQuery: true
                            }),
                        options: context.languages
                    })
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-select":"j36cq","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iUP37":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "default", ()=>AppProvider);
parcelHelpers.export(exports, "Consumer", ()=>Consumer);
parcelHelpers.export(exports, "Context", ()=>Context);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _api = require("helpers/api");
var _utils = require("helpers/utils");
var _hooks = require("helpers/hooks");
var _hooksDefault = parcelHelpers.interopDefault(_hooks);
var _fetch = require("context/fetch");
var _hooks1 = require("context/hooks");
var _hooksDefault1 = parcelHelpers.interopDefault(_hooks1);
var _quizContext = require("context/quiz-context");
var _quizContextDefault = parcelHelpers.interopDefault(_quizContext);
var _rollbookContext = require("context/rollbook-context");
var _rollbookContextDefault = parcelHelpers.interopDefault(_rollbookContext);
var _preferencesContext = require("context/preferences-context");
var _preferencesContextDefault = parcelHelpers.interopDefault(_preferencesContext);
var _context = require("teacher/components/add-standards/context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _hooks2 = require("teacher/components/add-standards/hooks");
var _hooksDefault2 = parcelHelpers.interopDefault(_hooks2);
var _context1 = require("teacher/homework/context");
var _contextDefault1 = parcelHelpers.interopDefault(_context1);
var _hooks3 = require("teacher/homework/hooks");
var _hooksDefault3 = parcelHelpers.interopDefault(_hooks3);
var _url = require("helpers/url");
var _edgePermissionBanner = require("components/EdgePermissionBanner");
var _edgePermissionBannerDefault = parcelHelpers.interopDefault(_edgePermissionBanner);
var _edge = require("helpers/edge");
window.downloadedContentCB = undefined;
window.downloadedContent = {};
window.setDownloadedContent = (raw)=>{
    const content = raw.reduce((acc, { id, hash })=>({
            ...acc,
            [id]: hash
        }), {});
    window.downloadedContent = content;
    if (window.downloadedContentCB) window.downloadedContentCB(content);
};
const initialState = {
    displayingScheduleMeeting: false,
    openfireSettings: false,
    openfireSettingsLoaded: false,
    downloadedContent: {},
    unreadMessages: 0,
    assessments: [],
    assessmentUpdates: 0,
    assessmentView: [],
    assessmentViewUpdates: 0,
    assessmentCount: 0,
    sizes: {
        width: window.innerWidth,
        height: window.innerHeight
    },
    sending: {
        scheduleAssessment: false
    },
    news: [],
    units: [],
    lessons: [],
    myLessons: [],
    activity: [],
    groups: [],
    groupsLoaded: false,
    groupsDigests: {},
    students: {},
    eventUpdates: 0,
    uploadUpdates: 0,
    scheduledDays: [],
    events: [],
    eventsByDay: {},
    groupsLanguage: false,
    catalogueSubjects: [],
    catalogueCourses: [],
    catalogueSearchResults: [],
    downloadLog: [],
    studentsDownloadLog: [],
    lessonLogTitles: {},
    downloadLogFilters: [],
    loading: {},
    selectedLesson: {},
    goingBack: false,
    menuShowing: false,
    expandedMenuShowing: false,
    myCourses: [],
    mySubjects: [],
    myGrades: [],
    newPlan: {},
    planUpdated: false,
    suggestedGroup: undefined,
    suggestedDate: (0, _momentDefault.default)().toISOString(),
    planningWeek: (0, _momentDefault.default)().startOf('week').format('YYYY-MM-DD'),
    planningNavigatedFrom: "week",
    planningNavigatedFromQuery: {},
    newPlanFrom: "week",
    newPlanFromQuery: {},
    planTemplates: [],
    templateItems: [],
    templateUpdates: 0,
    plans: [],
    plansUpdated: false,
    planUpdates: 0,
    plansByDay: {},
    setState: (p)=>{},
    deSubjects: [],
    deGrades: [],
    deStandards: [],
    deExpectations: [],
    pdfPlans: [],
    pdfPlansLoaded: false,
    teacherStandards: {},
    teacherExpectations: {},
    teacherStandardsLoaded: false,
    teacherExpectationsLoaded: false,
    cycles: [],
    cycleUpdates: 0,
    searchBackPath: '',
    ...(0, _quizContextDefault.default),
    ...(0, _preferencesContextDefault.default),
    ...(0, _rollbookContextDefault.default),
    standardsContext: (0, _contextDefault.default),
    homeworkContext: (0, _contextDefault1.default),
    dashboard: {
        loading: false,
        activeVideo: null,
        videos: []
    },
    edgeServers: {
        init: false,
        available: false,
        ips: [],
        needsPermission: false
    },
    showEdgeBanner: false
};
const Context = /*#__PURE__*/ (0, _react.createContext)();
const { Provider, Consumer } = Context;
function mapSizes([e]) {
    const { innerHeight: height, innerWidth: width } = e.target;
    return {
        sizes: {
            height,
            width
        }
    };
}
function buildContext(props, state) {
    return {
        ...(0, _lodash.omit)(props, [
            'children'
        ]),
        ...state
    };
}
const edusystem = window.edusystem = window.edusystem = {};
const edusystemChat = edusystem.chat = edusystem.chat = {};
class AppProvider extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            ...initialState,
            setState,
            updateState: updateState.bind(this),
            at: (...paths)=>(0, _lodash.at)(this.state, paths),
            isDownloaded: ({ id, hash })=>(0, _url.inViewer) && this.state.downloadedContent[id] == hash
        };
        function updateState(...commands) {
            return new Promise((resolve, reject)=>{
                try {
                    const state = commands.reduce((state, command)=>(0, _immutabilityHelperDefault.default)(state, command), this.state);
                    setState(state, ()=>resolve(state));
                } catch (e) {
                    reject(e);
                }
            });
        }
        this.setSizes = (0, _utils.delay)(200, setState, mapSizes).bind(this);
        this.setUnreadMessages = (unreadMessages)=>setState({
                unreadMessages
            });
        this.allowEdgeAccess = async ()=>{
            (0, _edge.grantEdgePermission)();
            this.state.updateState({
                showEdgeBanner: {
                    $set: false
                }
            });
            try {
                const loadedProfile = await (0, _api.profile);
                const edgeServers = await (0, _edge.pingEdgeServers)(loadedProfile);
                if (this._mounted) this.state.updateState({
                    edgeServers: {
                        $set: edgeServers
                    }
                });
            } catch (e) {
                console.error('[edge] allowEdgeAccess failed:', e);
            }
        };
        this.skipEdgeAccess = ()=>{
            (0, _edge.skipEdgePermission)();
            this.state.updateState({
                showEdgeBanner: {
                    $set: false
                },
                edgeServers: {
                    $set: {
                        init: true,
                        available: false,
                        ips: [],
                        needsPermission: false
                    }
                }
            });
        };
    }
    componentDidMount() {
        this._mounted = true;
        window.addEventListener('resize', this.setSizes);
        if (window.downloadedContent) this.state.updateState({
            downloadedContent: {
                $set: window.downloadedContent
            }
        });
        window.downloadedContentCB = (content)=>this.state.updateState({
                downloadedContent: {
                    $set: content
                }
            });
        edusystemChat.onUnreadMessagesChange = this.setUnreadMessages;
        const context = buildContext(this.props, this.state);
        Object.values(_fetch).forEach((fetch)=>fetch(context));
        Object.values(_hooks2).forEach((fetch)=>typeof fetch == 'function' && fetch(context));
        Object.values(_hooks3).forEach((fetch)=>typeof fetch == 'function' && fetch(context));
        (0, _hooksDefault1.default)();
        (0, _hooksDefault2.default).forEach(({ paths, fetches })=>(0, _hooks.register)(paths, fetches));
        (0, _hooksDefault3.default).forEach(({ paths, fetches })=>(0, _hooks.register)(paths, fetches));
        (0, _api.getEdgeServers)().then((edgeServers)=>{
            this.state.updateState({
                edgeServers: {
                    $set: edgeServers
                },
                showEdgeBanner: {
                    $set: edgeServers.needsPermission
                }
            });
        });
    }
    componentDidUpdate(props, state) {
        (0, _hooksDefault.default)(buildContext(this.props, this.state), buildContext(props, state));
    }
    componentWillUnmount() {
        this._mounted = false;
        edusystemChat.onUnreadMessagesChange = null;
        window.removeEventListener('resize', this.setSizes);
    }
    render() {
        const context = buildContext(this.props, this.state);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Provider, {
            value: context,
            children: [
                this.state.showEdgeBanner && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edgePermissionBannerDefault.default), {
                    onAllow: this.allowEdgeAccess,
                    onSkip: this.skipEdgeAccess
                }),
                this.props.children
            ]
        });
    }
}
(0, _immutabilityHelper.extend)('$auto', function(value, object) {
    return object ? (0, _immutabilityHelperDefault.default)(object, value) : (0, _immutabilityHelperDefault.default)({}, value);
});
(0, _immutabilityHelper.extend)('$autoArray', function(value, object) {
    return object ? (0, _immutabilityHelperDefault.default)(object, value) : (0, _immutabilityHelperDefault.default)([], value);
});

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","moment":"1e4qG","lodash":"1qc47","react":"9njXz","helpers/api":"8hlxJ","helpers/utils":"gGc98","helpers/hooks":"kU1GJ","context/fetch":"8um2e","context/hooks":"jv1X7","context/quiz-context":"dh8G9","context/rollbook-context":"ckCl1","context/preferences-context":"5lWhG","teacher/components/add-standards/context":"fumfd","teacher/components/add-standards/hooks":"ksW05","teacher/homework/context":"c6DDC","teacher/homework/hooks":"d6LdU","helpers/url":"65SQD","components/EdgePermissionBanner":"40ZlA","helpers/edge":"koxTY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hwjCt":[function(require,module,exports,__globalThis) {
var process = require("3b0661aaf46967c8");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */ return typeof obj === 'object' && !('toString' in obj) ? Object.prototype.toString.call(obj).slice(8, -1) : obj;
}
var isProduction = typeof process === 'object' && true;
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */ if (isProduction) throw new Error('Invariant failed');
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ function(target, source) {
    getAllKeys(source).forEach(function(key) {
        if (hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : function(obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === 'Map' ? new Map(object) : type(object) === 'Set' ? new Set(object) : object && typeof object === 'object' ? assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}
var Context = /** @class */ function() {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function(x, y) {
            return x === y;
        };
        this.update.newContext = function() {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function() {
            return this.update.isEquals;
        },
        set: function(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function(directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function(object, $spec) {
        var _this = this;
        var spec = typeof $spec === 'function' ? {
            $apply: $spec
        } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) invariant(!Array.isArray(spec), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        });
        invariant(typeof spec === 'object' && spec !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(_this.commands).join(', ') + ".");
        });
        var nextObject = object;
        getAllKeys(spec).forEach(function(key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = type(object) === 'Map' ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === 'Map' ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === 'undefined' && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = copy(object);
                    if (type(nextObject) === 'Map') nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$push');
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, '$unshift');
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        invariantSpecArray(targets, '$toggle');
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, '$unset');
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$add');
        invariantSpecArray(values, '$add');
        if (type(nextObject) === 'Map') values.forEach(function(_a) {
            var key = _a[0], value = _a[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
            nextObject.set(key, value);
        });
        else values.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, '$remove');
        invariantSpecArray(value, '$remove');
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function() {
        return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + ".";
    });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function() {
        return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " + "Did you forget to wrap your parameter in an array?";
    });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function() {
        return "Expected $splice target to be an array; got " + stringifiable(value);
    });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " + "Did you forget to wrap your parameters in an array?";
    });
}
function invariantApply(fn) {
    invariant(typeof fn === 'function', function() {
        return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + ".";
    });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
    });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === 'object', function() {
        return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue);
    });
    invariant(target && typeof target === 'object', function() {
        return "update(): $merge expects a target of type 'object'; got " + stringifiable(target);
    });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === 'Map' || typeOfTarget === 'Set', function() {
        return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget);
    });
}

},{"3b0661aaf46967c8":"5jT8D"}],"8hlxJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "profile", ()=>profile);
parcelHelpers.export(exports, "getEdgeServers", ()=>getEdgeServers);
parcelHelpers.export(exports, "institutionCourses", ()=>institutionCourses);
parcelHelpers.export(exports, "languages", ()=>languages);
parcelHelpers.export(exports, "subjects", ()=>subjects);
parcelHelpers.export(exports, "periodTypes", ()=>periodTypes);
parcelHelpers.export(exports, "periodTypesMap", ()=>periodTypesMap);
parcelHelpers.export(exports, "gradingCategories", ()=>gradingCategories);
parcelHelpers.export(exports, "gradingCategoryMap", ()=>gradingCategoryMap);
parcelHelpers.export(exports, "summaryTypes", ()=>summaryTypes);
parcelHelpers.export(exports, "grades", ()=>grades);
parcelHelpers.export(exports, "gradePrecedence", ()=>gradePrecedence);
parcelHelpers.export(exports, "translations", ()=>translations);
parcelHelpers.export(exports, "settings", ()=>settings);
parcelHelpers.export(exports, "templateTypes", ()=>templateTypes);
parcelHelpers.export(exports, "quizTypes", ()=>quizTypes);
parcelHelpers.export(exports, "quizTypesMap", ()=>quizTypesMap);
parcelHelpers.export(exports, "quizQuestionTypes", ()=>quizQuestionTypes);
parcelHelpers.export(exports, "quizStandardScale", ()=>quizStandardScale);
parcelHelpers.export(exports, "courses", ()=>courses);
parcelHelpers.export(exports, "homeworkStatus", ()=>homeworkStatus);
parcelHelpers.export(exports, "homeworkStatusMap", ()=>homeworkStatusMap);
var _lodash = require("lodash");
var _command = require("./command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _edge = require("./edge");
const profile = (0, _command.createPublic)('myinfo')().then(([profile])=>profile);
const getEdgeServers = ()=>profile.then((0, _edge.checkEdgeServers));
const institutionCourses = (0, _commandDefault.default)('institution', 'courses')();
const languages = (0, _commandDefault.default)('support', 'languages')();
const subjects = (0, _command.createPublic)('subjects')();
const periodTypes = (0, _commandDefault.default)('grading', 'getPeriodTypes')();
const periodTypesMap = periodTypes.then(associate('id', 'name'));
const gradingCategories = (0, _commandDefault.default)('grading', 'getCategory')();
const gradingCategoryMap = gradingCategories.then(associate('id', 'name'));
const summaryTypes = (0, _commandDefault.default)('grading', 'getSummaryTypes')();
const grades = (0, _commandDefault.default)('catalog', 'grades')();
const gradePrecedence = grades.then(associate('id', 'precedence'));
const translations = (0, _command.createPublic)('translations')({
    prefix: 'new-edufile'
}).then(associate('name', 'language', 'value'));
const settings = (0, _commandDefault.default)('web', 'settings')({
    Prefix: 'new-edufile'
}).then(associate('name', 'value'));
const templateTypes = (0, _commandDefault.default)('assessment', 'template_types')().catch(()=>[]);
const quizTypes = (0, _commandDefault.default)('quiz', 'getTypes')();
const quizTypesMap = quizTypes.then(associate('id', 'name'));
const quizQuestionTypes = (0, _commandDefault.default)('quiz', 'getQuestionTypes')();
const quizStandardScale = (0, _commandDefault.default)('quiz', 'getStandardScale')();
function associate(head, ...keys) {
    return (data)=>keys.length > 0 ? (0, _lodash.mapValues)((0, _lodash.groupBy)(data, (item)=>item[head]), associate(...keys)) : data[0][head];
}
const courses = (0, _commandDefault.default)('catalog', 'courses')().then((data)=>{
    const [availableLanguages, ...coursesData] = data;
    const courses = Object.entries(coursesData.reduce((acc, course)=>{
        if (acc[course.name]) acc[course.name].push(course);
        else acc[course.name] = [
            course
        ];
        return acc;
    }, {})).reduce((acc, [name, courses])=>acc.concat(courses.length > 1 ? courses.map((c)=>({
                ...c,
                notUniqueName: true
            })) : courses), []);
    return courses;
});
const getHomeworkStatus = (0, _commandDefault.default)('homework', 'getHomeworkStatus')();
const homeworkStatus = getHomeworkStatus.then(associate('id', 'name'));
const homeworkStatusMap = getHomeworkStatus.then(associate('name', 'id'));

},{"lodash":"1qc47","./command":"f3cbG","./edge":"koxTY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"koxTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasEdgeServers", ()=>hasEdgeServers);
parcelHelpers.export(exports, "pingEdgeServers", ()=>pingEdgeServers);
parcelHelpers.export(exports, "grantEdgePermission", ()=>grantEdgePermission);
parcelHelpers.export(exports, "skipEdgePermission", ()=>skipEdgePermission);
parcelHelpers.export(exports, "checkEdgeServers", ()=>checkEdgeServers);
const TIMEOUT = 500;
const STORAGE_KEY = 'edgePermission';
function heartbeat(hostname) {
    return new Promise((resolve)=>{
        const controller = new AbortController();
        const timer = setTimeout(()=>{
            controller.abort();
            resolve(false);
        }, TIMEOUT);
        fetch(`https://${hostname}/edge/health`, {
            signal: controller.signal,
            mode: 'cors'
        }).then((res)=>{
            clearTimeout(timer);
            resolve(res.ok);
        }).catch(()=>{
            clearTimeout(timer);
            resolve(false);
        });
    });
}
function hasEdgeServers(profile) {
    const servers = profile && profile.edgeServers || [];
    return servers.some((s)=>(s.hostnames || []).length > 0);
}
async function pingEdgeServers(profile) {
    const servers = profile && profile.edgeServers || [];
    const allHostnames = servers.reduce((acc, s)=>acc.concat(s.hostnames || []), []);
    if (allHostnames.length === 0) return {
        init: true,
        available: false,
        ips: [],
        needsPermission: false
    };
    const results = await Promise.all(allHostnames.map(async (hostname)=>({
            hostname,
            alive: await heartbeat(hostname)
        })));
    const hostnames = results.filter((r)=>r.alive).map((r)=>r.hostname);
    console.log('[edge] responsive hostnames:', hostnames);
    return {
        init: true,
        available: hostnames.length > 0,
        ips: hostnames,
        needsPermission: false
    };
}
function grantEdgePermission() {
    localStorage.setItem(STORAGE_KEY, 'granted');
}
function skipEdgePermission() {
    localStorage.setItem(STORAGE_KEY, 'skipped');
}
async function checkEdgeServers(profile) {
    if (!hasEdgeServers(profile)) return {
        init: true,
        available: false,
        ips: [],
        needsPermission: false
    };
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'granted') // user already granted — run heartbeats silently
    return await pingEdgeServers(profile);
    if (stored === 'skipped') // user already skipped — don't ask again
    return {
        init: true,
        available: false,
        ips: [],
        needsPermission: false
    };
    // first time — show banner
    return {
        init: false,
        available: false,
        ips: [],
        needsPermission: true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gGc98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmptyOrWhiteSpace", ()=>isEmptyOrWhiteSpace);
parcelHelpers.export(exports, "toDownloadableFileName", ()=>toDownloadableFileName);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "testRegex", ()=>testRegex);
parcelHelpers.export(exports, "dayRange", ()=>dayRange);
parcelHelpers.export(exports, "isFieldEmpty", ()=>isFieldEmpty);
parcelHelpers.export(exports, "pickAttributes", ()=>pickAttributes);
parcelHelpers.export(exports, "viewInCycle", ()=>viewInCycle);
parcelHelpers.export(exports, "isInCycle", ()=>isInCycle);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isUUID", ()=>isUUID);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "truncateText", ()=>truncateText);
parcelHelpers.export(exports, "bind", ()=>bind);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "formatNumber", ()=>formatNumber);
parcelHelpers.export(exports, "enhancedWithRowData", ()=>enhancedWithRowData);
parcelHelpers.export(exports, "enhancedWithPageProperties", ()=>enhancedWithPageProperties);
parcelHelpers.export(exports, "enhancedWithSortColumns", ()=>enhancedWithSortColumns);
parcelHelpers.export(exports, "htmlToText", ()=>htmlToText);
parcelHelpers.export(exports, "shuffleArray", ()=>shuffleArray);
parcelHelpers.export(exports, "toDisplayPoints", ()=>toDisplayPoints);
parcelHelpers.export(exports, "buildContext", ()=>buildContext);
parcelHelpers.export(exports, "createRatio", ()=>createRatio);
parcelHelpers.export(exports, "SvgKeepRatio", ()=>SvgKeepRatio);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _griddleReact = require("griddle-react");
var _lodash = require("lodash");
const isEmptyOrWhiteSpace = testRegex(/^\s*$/);
function toDownloadableFileName(name = '') {
    return name.trim().toLocaleLowerCase().replaceAll(/\s+/g, ' ').replaceAll(/\s/g, '-');
}
function encode(text) {
    const encoder = new TextEncoder();
    return encoder.encode(text);
}
function testRegex(regex) {
    return regex.test.bind(regex);
}
function dayRange(start, end) {
    const days = Math.abs((0, _momentDefault.default).duration((0, _momentDefault.default)(end).startOf('day').diff((0, _momentDefault.default)(start).startOf('day'))).as('days')) + 1;
    return (0, _lodash.range)(days).map((offset)=>(0, _momentDefault.default)(start).startOf('day').add(offset, 'd').toDate());
}
function isFieldEmpty(field) {
    switch(field.type){
        case "panel":
            return (0, _lodash.every)(field.children, (field)=>isFieldEmpty(field));
        case "dropdown":
            return (0, _lodash.every)(field.value, (value)=>value == "");
        default:
            return field.value == "";
    }
}
function pickAttributes(props, prefix) {
    const pattern = new RegExp(`^${prefix}`);
    return (0, _lodash.chain)(props).pickBy((_, key)=>pattern.test(key)).mapKeys((_, key)=>{
        const newKey = key.replace(pattern, '');
        return newKey[0].toLowerCase() + newKey.substring(1);
    }).value();
}
function viewInCycle(date, cycle, view) {
    const viewTests = {
        month: ()=>(0, _momentDefault.default)(cycle.start).startOf('month').startOf('week').isSameOrBefore((0, _momentDefault.default)(date)) && (0, _momentDefault.default)(cycle.end).endOf('month').endOf('week').isSameOrAfter((0, _momentDefault.default)(date)),
        week: ()=>(0, _momentDefault.default)(cycle.start).startOf('week').isSameOrBefore((0, _momentDefault.default)(date)) && (0, _momentDefault.default)(cycle.end).endOf('week').isSameOrAfter((0, _momentDefault.default)(date)),
        day: ()=>(0, _momentDefault.default)(cycle.start).isSameOrBefore((0, _momentDefault.default)(date)) && (0, _momentDefault.default)(cycle.end).isSameOrAfter((0, _momentDefault.default)(date))
    };
    return (viewTests[view] || viewTests.month)();
}
function isInCycle(date, cycle) {
    return (0, _momentDefault.default)(cycle.start).isSameOrBefore((0, _momentDefault.default)(date)) && (0, _momentDefault.default)(cycle.end).isSameOrAfter((0, _momentDefault.default)(date));
}
function get(property, def) {
    return (obj)=>obj[property] || def;
}
function isEmpty(str) {
    return !str || 0 === str.length;
}
function isUUID(value) {
    return /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/.test(value);
}
function uuid(a) {
    return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : "10000000-1000-4000-8000-100000000000".replace(/[018]/g, uuid);
}
function truncateText(max, overflow = '...') {
    return (text)=>text.length > max ? text.substring(0, max - overflow.length) + overflow : text;
}
function bind(context, ...methods) {
    methods.forEach((method)=>context[method] = context[method].bind(context));
}
function delay(delay1, comp, mapArgs = (a)=>a) {
    let id = 0;
    return (...args)=>{
        clearTimeout(id);
        const mappedArgs = mapArgs(args);
        id = (0, _lodash.isArray)(mappedArgs) ? setTimeout(comp, delay1, ...mappedArgs) : setTimeout(comp, delay1, mappedArgs);
    };
}
const formatNumber = function(formatter) {
    return formatter.format.bind(formatter);
}(new Intl.NumberFormat('en-US', {
    maximumSignificantDigits: 3
}));
const enhancedWithRowData = (0, _griddleReact.connect)((state, props)=>{
    return {
        rowData: rowDataSelector(state, props)
    };
});
function rowDataSelector(state, { griddleKey }) {
    return state.get('data').find((rowMap)=>rowMap.get('griddleKey') === griddleKey).toJSON();
}
const enhancedWithPageProperties = (0, _griddleReact.connect)((state, props)=>{
    return {
        pageProperties: pagePropertiesSelector(state)
    };
});
function pagePropertiesSelector(state) {
    return state.get('pageProperties').toJSON();
}
const enhancedWithSortColumns = (0, _griddleReact.connect)((state, props)=>({
        sortColumns: sortColumnsSelector(state, props)
    }));
function sortColumnsSelector(state, { sortProperty }) {
    return sortProperty;
}
const parser = new DOMParser();
function htmlToText(html) {
    const doc = parser.parseFromString(html, "text/html");
    const treeWalker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
    const nodeList = [];
    let currentNode = treeWalker.nextNode();
    while(currentNode){
        if (currentNode.textContent != 'undefined') nodeList.push(currentNode.textContent);
        currentNode = treeWalker.nextNode();
    }
    return nodeList.join(' ');
}
function shuffleArray(array = []) {
    return array.reduce((array, element, index, src)=>{
        const i = src.length - 1 - index;
        const j = Math.floor(Math.random() * (i + 1));
        if (i == j) return array;
        else {
            const a = array[i];
            const b = array[j];
            return (0, _immutabilityHelperDefault.default)(array, {
                $splice: [
                    [
                        i,
                        1
                    ],
                    [
                        i,
                        0,
                        b
                    ],
                    [
                        j,
                        1
                    ],
                    [
                        j,
                        0,
                        a
                    ]
                ]
            });
        }
    }, array);
}
function toDisplayPoints(points = 0, precision = 3) {
    return Number.isSafeInteger(points) ? points : points.toPrecision(precision);
}
function buildContext(props, state) {
    return {
        ...omit(props, [
            'children'
        ]),
        ...state
    };
}
class Ratio {
    constructor({ width, height, unit }){
        this.unit = unit;
        this.width = width;
        this.height = height;
        this.widthRatio = width / height;
        this.heightRatio = height / width;
    }
    size(width, height) {
        return {
            width: `${width}${this.unit}`,
            height: `${height}${this.unit}`,
            "viewBox": `0 0 ${this.width} ${this.height}`
        };
    }
    keep(width, height) {
        return height ? this.size(Math.round(this.widthRatio * height), height) : width ? this.size(width, Math.round(this.heightRatio * width)) : this.size(this.width, this.height);
    }
}
function createRatio(width, height, unit = 'px') {
    return new Ratio({
        width,
        height,
        unit
    });
}
function SvgKeepRatio({ viewBox, width, height, children }) {
    const ratio = createRatio(viewBox.width, viewBox.height);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        ...ratio.keep(width, height),
        children: children
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","immutability-helper":"hwjCt","moment":"1e4qG","griddle-react":"6zdUV","lodash":"1qc47","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6zdUV":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.connect = exports.RowDefinition = exports.ColumnDefinition = exports.plugins = exports.utils = exports.settingsComponentObjects = exports.selectors = exports.constants = exports.components = exports.actions = undefined;
var _index = require("a87eaaa0e1416b5e");
var _index2 = _interopRequireDefault(_index);
var _actions = require("67d11c864b5ccbcf");
var actions = _interopRequireWildcard(_actions);
var _components = require("683f71e4b0bf6cf5");
var _components2 = _interopRequireDefault(_components);
var _constants = require("1c3b4946292f6d3");
var constants = _interopRequireWildcard(_constants);
var _dataSelectors = require("a1114077ced60f3a");
var selectors = _interopRequireWildcard(_dataSelectors);
var _settingsComponentObjects = require("18909ae2d30725f6");
var _settingsComponentObjects2 = _interopRequireDefault(_settingsComponentObjects);
var _utils = require("d1003910f5446da2");
var _utils2 = _interopRequireDefault(_utils);
var _core = require("77ff6f4ac09f99aa");
var _core2 = _interopRequireDefault(_core);
var _legacyStyle = require("702dd0cdcf98c7d8");
var _legacyStyle2 = _interopRequireDefault(_legacyStyle);
var _local = require("da342683708a65b");
var _local2 = _interopRequireDefault(_local);
var _position = require("61eaf33a85b52523");
var _position2 = _interopRequireDefault(_position);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var plugins = {
    CorePlugin: _core2.default,
    LegacyStylePlugin: _legacyStyle2.default,
    LocalPlugin: _local2.default,
    PositionPlugin: _position2.default
};
var ColumnDefinition = _components2.default.ColumnDefinition;
var RowDefinition = _components2.default.RowDefinition;
var connect = _utils2.default.connect;
exports.default = _index2.default;
exports.actions = actions;
exports.components = _components2.default;
exports.constants = constants;
exports.selectors = selectors;
exports.settingsComponentObjects = _settingsComponentObjects2.default;
exports.utils = _utils2.default;
exports.plugins = plugins;
exports.ColumnDefinition = ColumnDefinition;
exports.RowDefinition = RowDefinition;
exports.connect = connect;

},{"a87eaaa0e1416b5e":"cqu2r","67d11c864b5ccbcf":"fHAx9","683f71e4b0bf6cf5":"blbFk","1c3b4946292f6d3":"lGlFg","a1114077ced60f3a":"4c1CS","18909ae2d30725f6":"8rUt9","d1003910f5446da2":"hr64y","77ff6f4ac09f99aa":"fL9a4","702dd0cdcf98c7d8":"j2kxF","da342683708a65b":"blG6y","61eaf33a85b52523":"cdfg5"}],"cqu2r":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _pickBy2 = require("467317b38f901b2f");
var _pickBy3 = _interopRequireDefault(_pickBy2);
var _forIn2 = require("1fb1f8753cacba2a");
var _forIn3 = _interopRequireDefault(_forIn2);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _redux = require("ab2f94830713ee8c");
var _reactRedux = require("13ee3329f266b28f");
var _react = require("f85e4786cc43bd5a");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("14d3c7381169fdb6");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _core = require("8a2a8b2b8445ab2d");
var _core2 = _interopRequireDefault(_core);
var _initializer = require("5805f1f760b7dee4");
var _initializer2 = _interopRequireDefault(_initializer);
var _listenerUtils = require("d95950dc4609b8d");
var _actions = require("a48e158a16c5828");
var actions = _interopRequireWildcard(_actions);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Griddle = function(_Component) {
    _inherits(Griddle, _Component);
    function Griddle(props) {
        _classCallCheck(this, Griddle);
        var _this = _possibleConstructorReturn(this, (Griddle.__proto__ || Object.getPrototypeOf(Griddle)).call(this, props));
        _this.getStoreKey = function() {
            return _this.props.storeKey || Griddle.storeKey || 'store';
        };
        var _props$core = props.core, core = _props$core === undefined ? _core2.default : _props$core, _props$storeKey = props.storeKey, storeKey = _props$storeKey === undefined ? Griddle.storeKey || 'store' : _props$storeKey;
        var _init$call = _initializer2.default.call(_this, core), initialState = _init$call.initialState, reducer = _init$call.reducer, reduxMiddleware = _init$call.reduxMiddleware;
        var composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
        _this.store = (0, _redux.createStore)(reducer, initialState, composeEnhancers(_redux.applyMiddleware.apply(undefined, _toConsumableArray(reduxMiddleware))));
        _this.provider = (0, _reactRedux.createProvider)(storeKey);
        _this.storeListener = new _listenerUtils.StoreListener(_this.store);
        (0, _forIn3.default)(_this.listeners, function(listener, name) {
            _this.storeListener.addListener(listener, name, {
                events: _this.events,
                selectors: _this.selectors
            });
        });
        return _this;
    }
    _createClass(Griddle, [
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                var _this2 = this;
                var newState = (0, _pickBy3.default)(nextProps, function(value, key) {
                    return _this2.props[key] !== value;
                });
                // Only update the state if something has changed.
                if (Object.keys(newState).length > 0) this.store.dispatch(actions.updateState(newState));
            }
        },
        {
            key: 'shouldComponentUpdate',
            value: function shouldComponentUpdate() {
                // As relevant property updates are captured in `componentWillReceiveProps`.
                // return false to prevent the the entire root node from being deleted.
                return false;
            }
        },
        {
            key: 'getChildContext',
            value: function getChildContext() {
                return {
                    components: this.components,
                    settingsComponentObjects: this.settingsComponentObjects,
                    events: this.events,
                    selectors: this.selectors,
                    storeKey: this.getStoreKey(),
                    storeListener: this.storeListener
                };
            }
        },
        {
            key: 'render',
            value: function render() {
                if (!this.components.Layout) return null;
                return _react2.default.createElement(this.provider, {
                    store: this.store
                }, _react2.default.createElement(this.components.Layout, null));
            }
        }
    ]);
    return Griddle;
}(_react.Component);
Griddle.childContextTypes = {
    components: _propTypes2.default.object.isRequired,
    settingsComponentObjects: _propTypes2.default.object,
    events: _propTypes2.default.object,
    selectors: _propTypes2.default.object,
    storeKey: _propTypes2.default.string,
    storeListener: _propTypes2.default.object
};
Griddle.storeKey = 'store';
exports.default = Griddle;

},{"467317b38f901b2f":"jfoze","1fb1f8753cacba2a":"i3UkJ","ab2f94830713ee8c":"cocGw","13ee3329f266b28f":"j3wUA","f85e4786cc43bd5a":"9njXz","14d3c7381169fdb6":"bnNSm","8a2a8b2b8445ab2d":"fL9a4","5805f1f760b7dee4":"h43sr","d95950dc4609b8d":"3TqZk","a48e158a16c5828":"fHAx9"}],"jfoze":[function(require,module,exports,__globalThis) {
var arrayMap = require("6fd113b3f5002de4"), baseIteratee = require("1e32e0d8feab18e"), basePickBy = require("85ba60b03da46517"), getAllKeysIn = require("86922ee5dcf85621");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function pickBy(object, predicate) {
    if (object == null) return {};
    var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = baseIteratee(predicate);
    return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = pickBy;

},{"6fd113b3f5002de4":"chzeu","1e32e0d8feab18e":"6jZAq","85ba60b03da46517":"369pd","86922ee5dcf85621":"iZ6gY"}],"chzeu":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"6jZAq":[function(require,module,exports,__globalThis) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"1Dnfv","4f010869f7b63154":"flZVA","28f06147d1eb9502":"2HXBf","3c56f88c4debf449":"1DVeR","aee920e0ef5bf111":"bSOBT"}],"1Dnfv":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"5GI5z","89e9034a8071e297":"eEnTQ","782598b150762386":"18Sgh"}],"5GI5z":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"cltFt","9003c0cc8ac007b6":"hrIE8"}],"cltFt":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"iugcK","ceda2a63c77c915":"5KcsT","91ee1b348d9d7172":"hJzOg","3fe28318f65b9332":"ck5Lg","724ca4def8b84e06":"Ez0QG","e9ceacb40d9582bd":"iepWB"}],"iugcK":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"5b3H7","b700cb849df2c166":"bZ5tW","d76dd90eead6cced":"11sMk","3d210628ba60ec8":"TkrmM","76026bf2d4cfff93":"cCYah"}],"5b3H7":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"bZ5tW":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"5AZA1"}],"5AZA1":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"evtiM"}],"evtiM":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"11sMk":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"5AZA1"}],"TkrmM":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"5AZA1"}],"cCYah":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"5AZA1"}],"5KcsT":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"iugcK"}],"hJzOg":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"ck5Lg":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"Ez0QG":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"iepWB":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"iugcK","1494efbafafa9552":"bEqpc","6049e8027fe9407f":"lV1BE"}],"bEqpc":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"bz0ok","29224713b8d411e6":"gVq56"}],"bz0ok":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"i4SFU","16db51a0e009bd8c":"fQ3rQ"}],"i4SFU":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"3A7xI","cabbc2adfaeb27d9":"eUAv3","cbb5703fe1562e7f":"6hgJK","388b819f47a43aa5":"2HVCC"}],"3A7xI":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"5ltt8","3cba3c966459d528":"6hgJK"}],"5ltt8":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"crlKT","9b2aaf31b7bdd837":"66zQh","46d5beb3375f8a28":"7zYCt"}],"crlKT":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"gVq56"}],"gVq56":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"egvmL"}],"egvmL":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"66zQh":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"crlKT"}],"7zYCt":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"6hgJK":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"eUAv3":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"h0VAr"}],"h0VAr":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"gVq56"}],"2HVCC":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"fQ3rQ":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"lV1BE":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"6JGdu","d2967b0e32ccfa56":"jD16i","ca21409ea89624c0":"9OB5v","f88fd07f8dd1f67d":"hsHKK","dbf3eae765642a3b":"5bQCB"}],"6JGdu":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"1q5yZ","a07dcf3fd3097a0c":"iugcK","92c01c953ef00ded":"bEqpc"}],"1q5yZ":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"77BkF","bc25d439ccd1fb47":"jt1rM","f096b37295a92ab0":"finz6","d88173cbc6a133c8":"5E27p","afb9b3bae0461cbf":"giimS"}],"77BkF":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"lElJo"}],"lElJo":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"bz0ok"}],"jt1rM":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"finz6":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"lElJo"}],"5E27p":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"lElJo"}],"giimS":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"lElJo"}],"jD16i":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"hINJU"}],"hINJU":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"5JCrb"}],"5JCrb":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"9OB5v":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"hINJU"}],"hsHKK":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"hINJU"}],"5bQCB":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"hINJU"}],"hrIE8":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"9gcZQ","809bbb0c20650dbc":"4gOki"}],"9gcZQ":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"cltFt","96bc8a1825db53a5":"cXMUl","8bdece495e87fb69":"7eeNO","bb94920432a68eca":"kyaB8","45495edff98e5837":"1chae","18256411ae9e2858":"1DVeR","e5ba7abf54247fc5":"26W2O","50d786bb5c7366af":"hq5rz"}],"cXMUl":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"irm8l","1ee20de911db0cb0":"bjRBC","defff3d81be91b23":"c2cDw"}],"irm8l":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"lV1BE","9a831e81e9a1f98c":"blGac","1a2b6c8a7399c39f":"h2eS8"}],"blGac":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"h2eS8":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"bjRBC":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"c2cDw":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"7eeNO":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"crlKT","dbf6aa5033a0f48":"eHExv","539966708f906e61":"evtiM","8142d4017f0a425f":"cXMUl","48cddf732eff33ba":"7z4fi","9dc78b26c5daba20":"lxNlE"}],"eHExv":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"gVq56"}],"7z4fi":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"lxNlE":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"kyaB8":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"lOHy9"}],"lOHy9":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"hu5MU","aa79b69a13f924db":"igqw1","e3ad83e53433bc8a":"9qKxr"}],"hu5MU":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"8JuEE","148b85918856c33a":"1DVeR"}],"8JuEE":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"1DVeR":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"igqw1":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"egrke","6b1c62cea92cdb9":"gRVIR"}],"egrke":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"gRVIR":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"9qKxr":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"aB7KR","e8453365fdacc8da":"f4fT3","7760b47b02971dfa":"kzICo"}],"aB7KR":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"iMrJS","9cdb51ffa56f149b":"bpegN","38cd49f1e493b3d7":"1DVeR","b379831fe1873fed":"26W2O","f362a34cd8321bb7":"bxLaX","c019db5297494469":"hq5rz"}],"iMrJS":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"bpegN":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"5IKlp","bead821d6af018b5":"4gOki"}],"5IKlp":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"5ltt8","b6cdbe52dcf709f8":"4gOki"}],"4gOki":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"26W2O":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"gVq56","a1e87b138cf75d1d":"gotX4"}],"gotX4":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"bxLaX":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"hq5rz":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"jRqan","903f50eb1c16d257":"jVyhK","fa49853a82034c30":"bPzLC"}],"jRqan":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"5ltt8","f661b3a120d7a4cb":"aFNSq","cdd86c83797c0618":"4gOki"}],"aFNSq":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"jVyhK":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"bPzLC":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"egvmL"}],"f4fT3":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"6l00J","3ec652610d8dd5d3":"39iyK"}],"6l00J":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"39iyK":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"3OxAn"}],"3OxAn":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"kzICo":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"3A7xI","f3db08d4d1110aaf":"aFNSq"}],"1chae":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"7C8Fy","28e3344aae951f13":"bEqpc","b286298be5b1d9a4":"97fST","3ae50c158f89813":"juoJE","9f458755f627d456":"9vICk","8e9160b373d7fe66":"5ltt8","b210627dd951641f":"2HVCC"}],"7C8Fy":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"bz0ok","f83c375075418382":"gVq56"}],"97fST":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"bz0ok","a5c6637bac681a0":"gVq56"}],"juoJE":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"bz0ok","ca486d41cdf819d4":"gVq56"}],"9vICk":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"bz0ok","7a9a6581834a8452":"gVq56"}],"eEnTQ":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"6mRk0","94ffded3a85af2f6":"9qKxr"}],"6mRk0":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"6hgJK"}],"18Sgh":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"flZVA":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"hrIE8","d5ca180f7d6f956a":"dBTJh","3462bb3f546fa1f7":"105Hu","f5fef07966a1c4ee":"c7lh2","2a1cd212d48516":"6mRk0","885e72ee7fc6d296":"18Sgh","cd65eaf4a3af29f6":"b5swP"}],"dBTJh":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"5Vkba"}],"5Vkba":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"1tEcE","c3296f04fad32769":"b5swP"}],"1tEcE":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"1DVeR","e823e604d75f975b":"c7lh2","f5fff1c342107fbd":"6K5tB","b04e8cc634273c23":"iEDGT"}],"c7lh2":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"1DVeR","4cdff6c9e9ff5d38":"fMaHV"}],"fMaHV":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"5ltt8","74644060ad1a1d3c":"4gOki"}],"6K5tB":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"9EwFx"}],"9EwFx":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"kx0Xn"}],"kx0Xn":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"lV1BE"}],"iEDGT":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"E4Kq0"}],"E4Kq0":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"crlKT","8439a3a1551d0706":"chzeu","4b12c9f502d3288a":"1DVeR","a0ebd327d618908a":"fMaHV"}],"b5swP":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"fMaHV"}],"105Hu":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"fdP9g","b0aefd36de99e579":"7O6Cp"}],"fdP9g":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"7O6Cp":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"1tEcE","47ffafdab3ba0d6f":"bpegN","93ebd263ff0131c1":"1DVeR","252ef74480e01958":"bxLaX","23c2f64e75e90a2":"aFNSq","af5ade297cb685ee":"b5swP"}],"2HXBf":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"bSOBT":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"fzLOJ","abf31da39349df22":"f5Egk","a387ef4a4373de2c":"c7lh2","9315973458389ae7":"b5swP"}],"fzLOJ":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"f5Egk":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"5Vkba"}],"369pd":[function(require,module,exports,__globalThis) {
var baseGet = require("d8aa974fba65e61e"), baseSet = require("b07dbab95dca4167"), castPath = require("64b51364f27b9088");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = baseGet(object, path);
        if (predicate(value, path)) baseSet(result, castPath(path, object), value);
    }
    return result;
}
module.exports = basePickBy;

},{"d8aa974fba65e61e":"5Vkba","b07dbab95dca4167":"7efHu","64b51364f27b9088":"1tEcE"}],"7efHu":[function(require,module,exports,__globalThis) {
var assignValue = require("a01f3b7ce097c710"), castPath = require("56e0b8a492d56399"), isIndex = require("d1eb8acc5a65dc38"), isObject = require("dfb182b16ef275c0"), toKey = require("6a51dc787ca5b6e3");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function baseSet(object, path, value, customizer) {
    if (!isObject(object)) return object;
    path = castPath(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = toKey(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = baseSet;

},{"a01f3b7ce097c710":"aKTSf","56e0b8a492d56399":"1tEcE","d1eb8acc5a65dc38":"bxLaX","dfb182b16ef275c0":"6hgJK","6a51dc787ca5b6e3":"b5swP"}],"aKTSf":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("be513dd57a36b3f4"), eq = require("b62ef95b3cf1cde1");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignValue;

},{"be513dd57a36b3f4":"ba13n","b62ef95b3cf1cde1":"evtiM"}],"ba13n":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"fUDy8"}],"fUDy8":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"bz0ok"}],"iZ6gY":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("f6d6a583609f5bf6"), getSymbolsIn = require("feede5d0a2d06427"), keysIn = require("287f70f798405911");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeysIn(object) {
    return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
module.exports = getAllKeysIn;

},{"f6d6a583609f5bf6":"hu5MU","feede5d0a2d06427":"IRyaH","287f70f798405911":"6emcB"}],"IRyaH":[function(require,module,exports,__globalThis) {
var arrayPush = require("2f7c7daf8773557"), getPrototype = require("6ccae2aa7cfa3c66"), getSymbols = require("bdb501682ee9305d"), stubArray = require("7641fe4ae6d2cc96");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
    var result = [];
    while(object){
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
    }
    return result;
};
module.exports = getSymbolsIn;

},{"2f7c7daf8773557":"8JuEE","6ccae2aa7cfa3c66":"9DBU4","bdb501682ee9305d":"igqw1","7641fe4ae6d2cc96":"gRVIR"}],"9DBU4":[function(require,module,exports,__globalThis) {
var overArg = require("11c2fcc01fbb2119");
/** Built-in value references. */ var getPrototype = overArg(Object.getPrototypeOf, Object);
module.exports = getPrototype;

},{"11c2fcc01fbb2119":"3OxAn"}],"6emcB":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("635aebb56f3a408f"), baseKeysIn = require("194eb1a802636842"), isArrayLike = require("ac15afdc3ddd76cd");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
module.exports = keysIn;

},{"635aebb56f3a408f":"aB7KR","194eb1a802636842":"5O0AO","ac15afdc3ddd76cd":"kzICo"}],"5O0AO":[function(require,module,exports,__globalThis) {
var isObject = require("bd1636f5883f1002"), isPrototype = require("f7d53cd92b2b977b"), nativeKeysIn = require("c039208a16eb68bd");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = baseKeysIn;

},{"bd1636f5883f1002":"6hgJK","f7d53cd92b2b977b":"6l00J","c039208a16eb68bd":"8srRf"}],"8srRf":[function(require,module,exports,__globalThis) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = nativeKeysIn;

},{}],"i3UkJ":[function(require,module,exports,__globalThis) {
var baseFor = require("6f49ac2e144b4ed"), castFunction = require("5f8f129fc5ff26a6"), keysIn = require("678578ce407317bb");
/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */ function forIn(object, iteratee) {
    return object == null ? object : baseFor(object, castFunction(iteratee), keysIn);
}
module.exports = forIn;

},{"6f49ac2e144b4ed":"9oLrx","5f8f129fc5ff26a6":"jVEVZ","678578ce407317bb":"6emcB"}],"9oLrx":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"d4N9s"}],"d4N9s":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"jVEVZ":[function(require,module,exports,__globalThis) {
var identity = require("c0eaa1c5ad52cc2f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function castFunction(value) {
    return typeof value == 'function' ? value : identity;
}
module.exports = castFunction;

},{"c0eaa1c5ad52cc2f":"2HXBf"}],"cocGw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", ()=>(0, _createStoreDefault.default));
parcelHelpers.export(exports, "combineReducers", ()=>(0, _combineReducersDefault.default));
parcelHelpers.export(exports, "bindActionCreators", ()=>(0, _bindActionCreatorsDefault.default));
parcelHelpers.export(exports, "applyMiddleware", ()=>(0, _applyMiddlewareDefault.default));
parcelHelpers.export(exports, "compose", ()=>(0, _composeDefault.default));
var _createStore = require("./createStore");
var _createStoreDefault = parcelHelpers.interopDefault(_createStore);
var _combineReducers = require("./combineReducers");
var _combineReducersDefault = parcelHelpers.interopDefault(_combineReducers);
var _bindActionCreators = require("./bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _applyMiddleware = require("./applyMiddleware");
var _applyMiddlewareDefault = parcelHelpers.interopDefault(_applyMiddleware);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _warning = require("./utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function isCrushed() {}

},{"./createStore":"dIEao","./combineReducers":"cq9AL","./bindActionCreators":"6wOIH","./applyMiddleware":"jWotm","./compose":"8UNGo","./utils/warning":"kPy3V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dIEao":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionTypes", ()=>ActionTypes);
parcelHelpers.export(exports, "default", ()=>createStore);
var _isPlainObject = require("lodash-es/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _symbolObservable = require("symbol-observable");
var _symbolObservableDefault = parcelHelpers.interopDefault(_symbolObservable);
var ActionTypes = {
    INIT: '@@redux/INIT'
};
function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, _isPlainObjectDefault.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: ActionTypes.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, _symbolObservableDefault.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, _symbolObservableDefault.default] = observable, _ref2;
}

},{"lodash-es/isPlainObject":"fiE8B","symbol-observable":"lpBaO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiE8B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _baseGetTagJs = require("./_baseGetTag.js");
var _baseGetTagJsDefault = parcelHelpers.interopDefault(_baseGetTagJs);
var _getPrototypeJs = require("./_getPrototype.js");
var _getPrototypeJsDefault = parcelHelpers.interopDefault(_getPrototypeJs);
var _isObjectLikeJs = require("./isObjectLike.js");
var _isObjectLikeJsDefault = parcelHelpers.interopDefault(_isObjectLikeJs);
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!(0, _isObjectLikeJsDefault.default)(value) || (0, _baseGetTagJsDefault.default)(value) != objectTag) return false;
    var proto = (0, _getPrototypeJsDefault.default)(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
exports.default = isPlainObject;

},{"./_baseGetTag.js":"9Chff","./_getPrototype.js":"gSX6x","./isObjectLike.js":"6kL9F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Chff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _getRawTagJs = require("./_getRawTag.js");
var _getRawTagJsDefault = parcelHelpers.interopDefault(_getRawTagJs);
var _objectToStringJs = require("./_objectToString.js");
var _objectToStringJsDefault = parcelHelpers.interopDefault(_objectToStringJs);
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? (0, _getRawTagJsDefault.default)(value) : (0, _objectToStringJsDefault.default)(value);
}
exports.default = baseGetTag;

},{"./_Symbol.js":"c53Uj","./_getRawTag.js":"gkm0n","./_objectToString.js":"2GCBc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c53Uj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rootJs = require("./_root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
/** Built-in value references. */ var Symbol = (0, _rootJsDefault.default).Symbol;
exports.default = Symbol;

},{"./_root.js":"10cmd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"10cmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _freeGlobalJs = require("./_freeGlobal.js");
var _freeGlobalJsDefault = parcelHelpers.interopDefault(_freeGlobalJs);
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = (0, _freeGlobalJsDefault.default) || freeSelf || Function('return this')();
exports.default = root;

},{"./_freeGlobal.js":"cvlFB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvlFB":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
exports.default = freeGlobal;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gkm0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbolJs = require("./_Symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = (0, _symbolJsDefault.default) ? (0, _symbolJsDefault.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
exports.default = getRawTag;

},{"./_Symbol.js":"c53Uj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2GCBc":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
exports.default = objectToString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gSX6x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overArgJs = require("./_overArg.js");
var _overArgJsDefault = parcelHelpers.interopDefault(_overArgJs);
/** Built-in value references. */ var getPrototype = (0, _overArgJsDefault.default)(Object.getPrototypeOf, Object);
exports.default = getPrototype;

},{"./_overArg.js":"gLjM1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gLjM1":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
exports.default = overArg;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kL9F":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
exports.default = isObjectLike;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpBaO":[function(require,module,exports,__globalThis) {
/* global window */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ponyfillJs = require("./ponyfill.js");
var _ponyfillJsDefault = parcelHelpers.interopDefault(_ponyfillJs);
var global = arguments[3];
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof global !== 'undefined') root = global;
else root = module;
var result = (0, _ponyfillJsDefault.default)(root);
exports.default = result;

},{"./ponyfill.js":"9LSa7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9LSa7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>symbolObservablePonyfill);
function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cq9AL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineReducers);
var _createStore = require("./createStore");
var _isPlainObject = require("lodash-es/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, _createStore.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, _isPlainObjectDefault.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, _createStore.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, _createStore.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

},{"./createStore":"dIEao","lodash-es/isPlainObject":"fiE8B","./utils/warning":"kPy3V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kPy3V":[function(require,module,exports,__globalThis) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6wOIH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bindActionCreators);
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jWotm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>applyMiddleware);
var _compose = require("./compose");
var _composeDefault = parcelHelpers.interopDefault(_compose);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function applyMiddleware() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, _composeDefault.default).apply(undefined, chain)(store.dispatch);
            return _extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

},{"./compose":"8UNGo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UNGo":[function(require,module,exports,__globalThis) {
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compose);
function compose() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j3wUA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _providerDefault.default));
parcelHelpers.export(exports, "createProvider", ()=>(0, _provider.createProvider));
parcelHelpers.export(exports, "connectAdvanced", ()=>(0, _connectAdvancedDefault.default));
parcelHelpers.export(exports, "connect", ()=>(0, _connectDefault.default));
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connectAdvanced = require("./components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _connect = require("./connect/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);

},{"./components/Provider":"c8Lxf","./components/connectAdvanced":"l9EoY","./connect/connect":"44nHG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8Lxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createProvider", ()=>createProvider);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _propTypes1 = require("../utils/PropTypes");
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var prefixUnsafeLifecycleMethods = typeof (0, _reactDefault.default).forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
    if (didWarnAboutReceivingStore) return;
    didWarnAboutReceivingStore = true;
    (0, _warningDefault.default)("<Provider> does not support changing `store` on the fly. It is most likely that you see this error because you updated to Redux 2.x and React Redux 2.x which no longer hot reload reducers automatically. See https://github.com/reduxjs/react-redux/releases/tag/v2.0.0 for the migration instructions.");
}
function createProvider(storeKey) {
    var _Provider$childContex;
    if (storeKey === void 0) storeKey = 'store';
    var subscriptionKey = storeKey + "Subscription";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, _inheritsLooseDefault.default)(Provider, _Component);
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
        };
        function Provider(props, context) {
            var _this;
            _this = _Component.call(this, props, context) || this;
            _this[storeKey] = props.store;
            return _this;
        }
        _proto.render = function render() {
            return (0, _react.Children).only(this.props.children);
        };
        return Provider;
    }((0, _react.Component));
    var eventName;
    Provider.propTypes = {
        store: (0, _propTypes1.storeShape).isRequired,
        children: (0, _propTypesDefault.default).element.isRequired
    };
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = (0, _propTypes1.storeShape).isRequired, _Provider$childContex[subscriptionKey] = (0, _propTypes1.subscriptionShape), _Provider$childContex);
    return Provider;
}
exports.default = createProvider();

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","react":"9njXz","prop-types":"bnNSm","../utils/PropTypes":"4KDaJ","../utils/warning":"b5sI8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4KDaJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscriptionShape", ()=>subscriptionShape);
parcelHelpers.export(exports, "storeShape", ()=>storeShape);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var subscriptionShape = (0, _propTypesDefault.default).shape({
    trySubscribe: (0, _propTypesDefault.default).func.isRequired,
    tryUnsubscribe: (0, _propTypesDefault.default).func.isRequired,
    notifyNestedSubs: (0, _propTypesDefault.default).func.isRequired,
    isSubscribed: (0, _propTypesDefault.default).func.isRequired
});
var storeShape = (0, _propTypesDefault.default).shape({
    subscribe: (0, _propTypesDefault.default).func.isRequired,
    dispatch: (0, _propTypesDefault.default).func.isRequired,
    getState: (0, _propTypesDefault.default).func.isRequired
});

},{"prop-types":"bnNSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b5sI8":[function(require,module,exports,__globalThis) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>warning);
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l9EoY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>connectAdvanced);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactIs = require("react-is");
var _subscription = require("../utils/Subscription");
var _subscriptionDefault = parcelHelpers.interopDefault(_subscription);
var _propTypes = require("../utils/PropTypes");
var prefixUnsafeLifecycleMethods = typeof (0, _reactDefault.default).forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
    // wrap the selector in an object that tracks its results between runs.
    var selector = {
        run: function runComponentSelector(props) {
            try {
                var nextProps = sourceSelector(store.getState(), props);
                if (nextProps !== selector.props || selector.error) {
                    selector.shouldComponentUpdate = true;
                    selector.props = nextProps;
                    selector.error = null;
                }
            } catch (error) {
                selector.shouldComponentUpdate = true;
                selector.error = error;
            }
        }
    };
    return selector;
}
function connectAdvanced(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    var _contextTypes, _childContextTypes;
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, connectOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef"
    ]);
    var subscriptionKey = storeKey + 'Subscription';
    var version = hotReloadingVersion++;
    var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = (0, _propTypes.storeShape), _contextTypes[subscriptionKey] = (0, _propTypes.subscriptionShape), _contextTypes);
    var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = (0, _propTypes.subscriptionShape), _childContextTypes);
    return function wrapWithConnect(WrappedComponent) {
        (0, _invariantDefault.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, _extendsDefault.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            withRef: withRef,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
        });
        var Connect = /*#__PURE__*/ function(_Component) {
            (0, _inheritsLooseDefault.default)(Connect, _Component);
            function Connect(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.version = version;
                _this.state = {};
                _this.renderCount = 0;
                _this.store = props[storeKey] || context[storeKey];
                _this.propsMode = Boolean(props[storeKey]);
                _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitializedDefault.default)((0, _assertThisInitializedDefault.default)(_this)));
                (0, _invariantDefault.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
                _this.initSelector();
                _this.initSubscription();
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.getChildContext = function getChildContext() {
                var _ref3;
                // If this component received store from props, its subscription should be transparent
                // to any descendants receiving store+subscription from context; it passes along
                // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
                // Connect to control ordering of notifications to flow top-down.
                var subscription = this.propsMode ? null : this.subscription;
                return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
            };
            _proto.componentDidMount = function componentDidMount() {
                if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
                // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
                // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
                // To handle the case where a child component may have triggered a state change by
                // dispatching an action in its componentWillMount, we have to re-run the select and maybe
                // re-render.
                this.subscription.trySubscribe();
                this.selector.run(this.props);
                if (this.selector.shouldComponentUpdate) this.forceUpdate();
            }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
            _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
                this.selector.run(nextProps);
            };
            _proto.shouldComponentUpdate = function shouldComponentUpdate() {
                return this.selector.shouldComponentUpdate;
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                if (this.subscription) this.subscription.tryUnsubscribe();
                this.subscription = null;
                this.notifyNestedSubs = noop;
                this.store = null;
                this.selector.run = noop;
                this.selector.shouldComponentUpdate = false;
            };
            _proto.getWrappedInstance = function getWrappedInstance() {
                (0, _invariantDefault.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
                return this.wrappedInstance;
            };
            _proto.setWrappedInstance = function setWrappedInstance(ref) {
                this.wrappedInstance = ref;
            };
            _proto.initSelector = function initSelector() {
                var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
                this.selector = makeSelectorStateful(sourceSelector, this.store);
                this.selector.run(this.props);
            };
            _proto.initSubscription = function initSubscription() {
                if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
                this.subscription = new (0, _subscriptionDefault.default)(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `this.subscription` will then be null. An
                // extra null check every change can be avoided by copying the method onto `this` and then
                // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
                // listeners logic is changed to not call listeners that have been unsubscribed in the
                // middle of the notification loop.
                this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
            };
            _proto.onStateChange = function onStateChange() {
                this.selector.run(this.props);
                if (!this.selector.shouldComponentUpdate) this.notifyNestedSubs();
                else {
                    this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
                    this.setState(dummyState);
                }
            };
            _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
                // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
                // needs to notify nested subs. Once called, it unimplements itself until further state
                // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
                // a boolean check every time avoids an extra method call most of the time, resulting
                // in some perf boost.
                this.componentDidUpdate = undefined;
                this.notifyNestedSubs();
            };
            _proto.isSubscribed = function isSubscribed() {
                return Boolean(this.subscription) && this.subscription.isSubscribed();
            };
            _proto.addExtraProps = function addExtraProps(props) {
                if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
                // this is especially important for 'ref' since that's a reference back to the component
                // instance. a singleton memoized selector would then be holding a reference to the
                // instance, preventing the instance from being garbage collected, and that would be bad
                var withExtras = (0, _extendsDefault.default)({}, props);
                if (withRef) withExtras.ref = this.setWrappedInstance;
                if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
                if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
                return withExtras;
            };
            _proto.render = function render() {
                var selector = this.selector;
                selector.shouldComponentUpdate = false;
                if (selector.error) throw selector.error;
                else return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
            };
            return Connect;
        }((0, _react.Component));
        if (prefixUnsafeLifecycleMethods) {
            // Use UNSAFE_ event name where supported
            Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
            delete Connect.prototype.componentWillReceiveProps;
        }
        /* eslint-enable react/no-deprecated */ Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        Connect.childContextTypes = childContextTypes;
        Connect.contextTypes = contextTypes;
        Connect.propTypes = contextTypes;
        var eventName;
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
}

},{"@babel/runtime/helpers/esm/inheritsLoose":"6cnxy","@babel/runtime/helpers/esm/assertThisInitialized":"jJtsr","@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","hoist-non-react-statics":"59Kh2","invariant":"eNRZI","react":"9njXz","react-is":"3b6hO","../utils/Subscription":"3QtlF","../utils/PropTypes":"4KDaJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNRZI":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"3QtlF":[function(require,module,exports,__globalThis) {
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Subscription);
var CLEARED = null;
var nullListeners = {
    notify: function notify() {}
};
function createListenerCollection() {
    // the current/next pattern is copied from redux's createStore code.
    // TODO: refactor+expose that code to be reusable here?
    var current = [];
    var next = [];
    return {
        clear: function clear() {
            next = CLEARED;
            current = CLEARED;
        },
        notify: function notify() {
            var listeners = current = next;
            for(var i = 0; i < listeners.length; i++)listeners[i]();
        },
        get: function get() {
            return next;
        },
        subscribe: function subscribe(listener) {
            var isSubscribed = true;
            if (next === current) next = current.slice();
            next.push(listener);
            return function unsubscribe() {
                if (!isSubscribed || current === CLEARED) return;
                isSubscribed = false;
                if (next === current) next = current.slice();
                next.splice(next.indexOf(listener), 1);
            };
        }
    };
}
var Subscription = /*#__PURE__*/ function() {
    function Subscription(store, parentSub, onStateChange) {
        this.store = store;
        this.parentSub = parentSub;
        this.onStateChange = onStateChange;
        this.unsubscribe = null;
        this.listeners = nullListeners;
    }
    var _proto = Subscription.prototype;
    _proto.addNestedSub = function addNestedSub(listener) {
        this.trySubscribe();
        return this.listeners.subscribe(listener);
    };
    _proto.notifyNestedSubs = function notifyNestedSubs() {
        this.listeners.notify();
    };
    _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.unsubscribe);
    };
    _proto.trySubscribe = function trySubscribe() {
        if (!this.unsubscribe) {
            this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
            this.listeners = createListenerCollection();
        }
    };
    _proto.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
            this.listeners.clear();
            this.listeners = nullListeners;
        }
    };
    return Subscription;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44nHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// different options opens up some testing and extensibility scenarios
parcelHelpers.export(exports, "createConnect", ()=>createConnect);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _connectAdvanced = require("../components/connectAdvanced");
var _connectAdvancedDefault = parcelHelpers.interopDefault(_connectAdvanced);
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _mapDispatchToProps = require("./mapDispatchToProps");
var _mapDispatchToPropsDefault = parcelHelpers.interopDefault(_mapDispatchToProps);
var _mapStateToProps = require("./mapStateToProps");
var _mapStateToPropsDefault = parcelHelpers.interopDefault(_mapStateToProps);
var _mergeProps = require("./mergeProps");
var _mergePropsDefault = parcelHelpers.interopDefault(_mergeProps);
var _selectorFactory = require("./selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function createConnect(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, _connectAdvancedDefault.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, _mapStateToPropsDefault.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, _mapDispatchToPropsDefault.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, _mergePropsDefault.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, _selectorFactoryDefault.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, _shallowEqualDefault.default) : _ref3$areMergedPropsE, extraOptions = (0, _objectWithoutPropertiesLooseDefault.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, _extendsDefault.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
exports.default = createConnect();

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","../components/connectAdvanced":"l9EoY","../utils/shallowEqual":"6Dstd","./mapDispatchToProps":"gEg9m","./mapStateToProps":"7vOU7","./mergeProps":"05bXi","./selectorFactory":"1uoLK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Dstd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>shallowEqual);
var hasOwn = Object.prototype.hasOwnProperty;
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gEg9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsFunction", ()=>whenMapDispatchToPropsIsFunction);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsMissing", ()=>whenMapDispatchToPropsIsMissing);
parcelHelpers.export(exports, "whenMapDispatchToPropsIsObject", ()=>whenMapDispatchToPropsIsObject);
var _redux = require("redux");
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
    }) : undefined;
}
exports.default = [
    whenMapDispatchToPropsIsFunction,
    whenMapDispatchToPropsIsMissing,
    whenMapDispatchToPropsIsObject
];

},{"redux":"cocGw","./wrapMapToProps":"3UdeN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3UdeN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", ()=>wrapMapToPropsConstant) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
parcelHelpers.export(exports, "getDependsOnOwnProps", ()=>getDependsOnOwnProps) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
parcelHelpers.export(exports, "wrapMapToPropsFunc", ()=>wrapMapToPropsFunc);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"8XkBI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8XkBI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifyPlainObject);
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

},{"./isPlainObject":"g3lvy","./warning":"b5sI8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g3lvy":[function(require,module,exports,__globalThis) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPlainObject);
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vOU7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "whenMapStateToPropsIsFunction", ()=>whenMapStateToPropsIsFunction);
parcelHelpers.export(exports, "whenMapStateToPropsIsMissing", ()=>whenMapStateToPropsIsMissing);
var _wrapMapToProps = require("./wrapMapToProps");
function whenMapStateToPropsIsFunction(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
exports.default = [
    whenMapStateToPropsIsFunction,
    whenMapStateToPropsIsMissing
];

},{"./wrapMapToProps":"3UdeN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"05bXi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", ()=>defaultMergeProps);
parcelHelpers.export(exports, "wrapMergePropsFunc", ()=>wrapMergePropsFunc);
parcelHelpers.export(exports, "whenMergePropsIsFunction", ()=>whenMergePropsIsFunction);
parcelHelpers.export(exports, "whenMergePropsIsOmitted", ()=>whenMergePropsIsOmitted);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function whenMergePropsIsFunction(mergeProps) {
    return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : undefined;
}
exports.default = [
    whenMergePropsIsFunction,
    whenMergePropsIsOmitted
];

},{"@babel/runtime/helpers/esm/extends":"aAOJb","../utils/verifyPlainObject":"8XkBI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uoLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "impureFinalPropsSelectorFactory", ()=>impureFinalPropsSelectorFactory);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", ()=>pureFinalPropsSelectorFactory) // TODO: Add more comments
;
parcelHelpers.export(exports, "default", ()=>finalPropsSelectorFactory);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","./verifySubselectors":"jiS79","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiS79":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>verifySubselectors);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!selector.hasOwnProperty('dependsOnOwnProps')) (0, _warningDefault.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    verify(mapStateToProps, 'mapStateToProps', displayName);
    verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    verify(mergeProps, 'mergeProps', displayName);
}

},{"../utils/warning":"b5sI8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fL9a4":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _components = require("9f68d194c24c5414");
var _components2 = _interopRequireDefault(_components);
var _dataReducer = require("1f27b0245be7c099");
var reducer = _interopRequireWildcard(_dataReducer);
var _dataSelectors = require("255954b6bba041d8");
var selectors = _interopRequireWildcard(_dataSelectors);
var _actions = require("30a772832aad18c9");
var actions = _interopRequireWildcard(_actions);
var _settingsComponentObjects = require("dc8b46f5be8f57fd");
var _settingsComponentObjects2 = _interopRequireDefault(_settingsComponentObjects);
var _initialState = require("65c1d2ad99129b20");
var _initialState2 = _interopRequireDefault(_initialState);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var CorePlugin = _extends({
    components: _components2.default,
    settingsComponentObjects: _settingsComponentObjects2.default,
    reducer: reducer,
    selectors: selectors,
    actions: actions
}, _initialState2.default);
exports.default = CorePlugin;

},{"9f68d194c24c5414":"blbFk","1f27b0245be7c099":"eV7y2","255954b6bba041d8":"4c1CS","30a772832aad18c9":"fHAx9","dc8b46f5be8f57fd":"8rUt9","65c1d2ad99129b20":"bs75O"}],"blbFk":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _Cell = require("3b91b9e7374b6e5a");
var _Cell2 = _interopRequireDefault(_Cell);
var _CellContainer = require("2291542f9fe1df23");
var _CellContainer2 = _interopRequireDefault(_CellContainer);
var _ColumnDefinition = require("6040165d19d511d3");
var _ColumnDefinition2 = _interopRequireDefault(_ColumnDefinition);
var _Row = require("a54b9217b8e22fcd");
var _Row2 = _interopRequireDefault(_Row);
var _RowContainer = require("66ef235a60b71d7");
var _RowContainer2 = _interopRequireDefault(_RowContainer);
var _RowDefinition = require("60753bff1b88fdb6");
var _RowDefinition2 = _interopRequireDefault(_RowDefinition);
var _Table = require("5c07131f3432c431");
var _Table2 = _interopRequireDefault(_Table);
var _TableBody = require("b7434c578d7bc693");
var _TableBody2 = _interopRequireDefault(_TableBody);
var _TableBodyContainer = require("d2231bf95e20883d");
var _TableBodyContainer2 = _interopRequireDefault(_TableBodyContainer);
var _TableHeading = require("c8a5fc634a9015b3");
var _TableHeading2 = _interopRequireDefault(_TableHeading);
var _TableHeadingContainer = require("66c830539f75e16d");
var _TableHeadingContainer2 = _interopRequireDefault(_TableHeadingContainer);
var _TableHeadingCell = require("4ad9e30ea745f22c");
var _TableHeadingCell2 = _interopRequireDefault(_TableHeadingCell);
var _TableHeadingCellContainer = require("75c1a7d6616095e1");
var _TableHeadingCellContainer2 = _interopRequireDefault(_TableHeadingCellContainer);
var _TableHeadingCellEnhancer = require("a56c87c5ee534b89");
var _TableHeadingCellEnhancer2 = _interopRequireDefault(_TableHeadingCellEnhancer);
var _TableContainer = require("50a1b4d40239b396");
var _TableContainer2 = _interopRequireDefault(_TableContainer);
var _Layout = require("b735fee1a78f66de");
var _Layout2 = _interopRequireDefault(_Layout);
var _LayoutContainer = require("2cce33d6ec22cd27");
var _LayoutContainer2 = _interopRequireDefault(_LayoutContainer);
var _Pagination = require("b35d3108e20d7591");
var _Pagination2 = _interopRequireDefault(_Pagination);
var _PaginationContainer = require("778d47ddcaf235e5");
var _PaginationContainer2 = _interopRequireDefault(_PaginationContainer);
var _Filter = require("a7bf5d2e5cd22c7d");
var _Filter2 = _interopRequireDefault(_Filter);
var _FilterEnhancer = require("61b83fdeda8eb346");
var _FilterEnhancer2 = _interopRequireDefault(_FilterEnhancer);
var _FilterContainer = require("2c3af9e240fa943a");
var _FilterContainer2 = _interopRequireDefault(_FilterContainer);
var _SettingsToggle = require("659fc0df9ed26d44");
var _SettingsToggle2 = _interopRequireDefault(_SettingsToggle);
var _SettingsToggleContainer = require("6bc76aa6db61534");
var _SettingsToggleContainer2 = _interopRequireDefault(_SettingsToggleContainer);
var _SettingsWrapper = require("b3a7a9456d29b095");
var _SettingsWrapper2 = _interopRequireDefault(_SettingsWrapper);
var _SettingsWrapperContainer = require("b76afed47116b113");
var _SettingsWrapperContainer2 = _interopRequireDefault(_SettingsWrapperContainer);
var _Settings = require("55904215c0147d82");
var _Settings2 = _interopRequireDefault(_Settings);
var _SettingsContainer = require("60eabfb47d3ec71e");
var _SettingsContainer2 = _interopRequireDefault(_SettingsContainer);
var _settingsComponentObjects = require("9841b1db951cc0d");
var _NextButton = require("84b20c4ea90dbc08");
var _NextButton2 = _interopRequireDefault(_NextButton);
var _NextButtonEnhancer = require("3ee9aa85710f393d");
var _NextButtonEnhancer2 = _interopRequireDefault(_NextButtonEnhancer);
var _NextButtonContainer = require("c6c9e04bf852cbfb");
var _NextButtonContainer2 = _interopRequireDefault(_NextButtonContainer);
var _Loading = require("2d7c620a699f587d");
var _Loading2 = _interopRequireDefault(_Loading);
var _LoadingContainer = require("9778711cdd7dff16");
var _LoadingContainer2 = _interopRequireDefault(_LoadingContainer);
var _NoResults = require("894e2027ff0a4fe2");
var _NoResults2 = _interopRequireDefault(_NoResults);
var _NoResultsContainer = require("57ff588a8589d1c0");
var _NoResultsContainer2 = _interopRequireDefault(_NoResultsContainer);
var _PreviousButton = require("b413403c818b811f");
var _PreviousButton2 = _interopRequireDefault(_PreviousButton);
var _PreviousButtonEnhancer = require("25c4e63aea5f3d4a");
var _PreviousButtonEnhancer2 = _interopRequireDefault(_PreviousButtonEnhancer);
var _PreviousButtonContainer = require("f50e4b97d9ba67e8");
var _PreviousButtonContainer2 = _interopRequireDefault(_PreviousButtonContainer);
var _PageDropdown = require("868d6d265c77538b");
var _PageDropdown2 = _interopRequireDefault(_PageDropdown);
var _PageDropdownContainer = require("8c4049ef02a23b58");
var _PageDropdownContainer2 = _interopRequireDefault(_PageDropdownContainer);
var _PageDropdownEnhancer = require("d080c9723aeb1431");
var _PageDropdownEnhancer2 = _interopRequireDefault(_PageDropdownEnhancer);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var components = {
    Cell: _Cell2.default,
    CellContainer: _CellContainer2.default,
    ColumnDefinition: _ColumnDefinition2.default,
    Row: _Row2.default,
    RowContainer: _RowContainer2.default,
    RowDefinition: _RowDefinition2.default,
    Table: _Table2.default,
    TableBody: _TableBody2.default,
    TableBodyContainer: _TableBodyContainer2.default,
    TableHeading: _TableHeading2.default,
    TableHeadingContainer: _TableHeadingContainer2.default,
    TableHeadingCell: _TableHeadingCell2.default,
    TableHeadingCellContainer: _TableHeadingCellContainer2.default,
    TableHeadingCellEnhancer: _TableHeadingCellEnhancer2.default,
    TableContainer: _TableContainer2.default,
    Layout: _Layout2.default,
    LayoutContainer: _LayoutContainer2.default,
    NextButton: _NextButton2.default,
    NextButtonEnhancer: _NextButtonEnhancer2.default,
    NextButtonContainer: _NextButtonContainer2.default,
    Loading: _Loading2.default,
    LoadingContainer: _LoadingContainer2.default,
    NoResults: _NoResults2.default,
    NoResultsContainer: _NoResultsContainer2.default,
    PageDropdown: _PageDropdown2.default,
    PageDropdownContainer: _PageDropdownContainer2.default,
    PageDropdownEnhancer: _PageDropdownEnhancer2.default,
    Pagination: _Pagination2.default,
    PaginationContainer: _PaginationContainer2.default,
    PreviousButton: _PreviousButton2.default,
    PreviousButtonEnhancer: _PreviousButtonEnhancer2.default,
    PreviousButtonContainer: _PreviousButtonContainer2.default,
    Filter: _Filter2.default,
    FilterEnhancer: _FilterEnhancer2.default,
    FilterContainer: _FilterContainer2.default,
    SettingsToggle: _SettingsToggle2.default,
    SettingsToggleContainer: _SettingsToggleContainer2.default,
    SettingsWrapper: _SettingsWrapper2.default,
    SettingsWrapperContainer: _SettingsWrapperContainer2.default,
    Settings: _Settings2.default,
    SettingsContainer: _SettingsContainer2.default,
    SettingsComponents: _settingsComponentObjects.components,
    Style: function Style() {
        return null;
    }
};
exports.default = components;

},{"3b91b9e7374b6e5a":"bvuZQ","2291542f9fe1df23":"6V7Jg","6040165d19d511d3":"6rGqh","a54b9217b8e22fcd":"jLslG","66ef235a60b71d7":"eLiQT","60753bff1b88fdb6":"2Jt5f","5c07131f3432c431":"6PobJ","b7434c578d7bc693":"2IfRF","d2231bf95e20883d":"dbE9Z","c8a5fc634a9015b3":"dmQ7i","66c830539f75e16d":"23htc","4ad9e30ea745f22c":"7pgwi","75c1a7d6616095e1":"8I13p","a56c87c5ee534b89":"lUg0I","50a1b4d40239b396":"d4kAU","b735fee1a78f66de":"6wCmL","2cce33d6ec22cd27":"2fWii","b35d3108e20d7591":"7OIF3","778d47ddcaf235e5":"dpNI2","a7bf5d2e5cd22c7d":"fYJSv","61b83fdeda8eb346":"55Sko","2c3af9e240fa943a":"012K5","659fc0df9ed26d44":"q7zoe","6bc76aa6db61534":"dC7vN","b3a7a9456d29b095":"iwc0k","b76afed47116b113":"2lKZY","55904215c0147d82":"1NRPU","60eabfb47d3ec71e":"dPakf","9841b1db951cc0d":"8rUt9","84b20c4ea90dbc08":"4VJll","3ee9aa85710f393d":"2CdGj","c6c9e04bf852cbfb":"7Lh5a","2d7c620a699f587d":"gRJpd","9778711cdd7dff16":"8mfbS","894e2027ff0a4fe2":"2CRTd","57ff588a8589d1c0":"etLpT","b413403c818b811f":"5ItI1","25c4e63aea5f3d4a":"feFw9","f50e4b97d9ba67e8":"fDGeh","868d6d265c77538b":"9oiKv","8c4049ef02a23b58":"kOwyS","d080c9723aeb1431":"2Yeeq"}],"bvuZQ":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("8015ac83a5125182");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Cell = function Cell(_ref) {
    var value = _ref.value, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, style = _ref.style, className = _ref.className;
    return _react2.default.createElement('td', {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: style,
        className: className
    }, value);
};
exports.default = Cell;

},{"8015ac83a5125182":"9njXz"}],"6V7Jg":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("cf0a2f8c5a45794e");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("fa5ace8510e034e8");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("f41d1359c621989c");
var _getContext = require("5cd8945f9968a3a8");
var _getContext2 = _interopRequireDefault(_getContext);
var _mapProps = require("e9f282227a391f1c");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _compose = require("9d24b6e91109b062");
var _compose2 = _interopRequireDefault(_compose);
var _dataSelectors = require("d157280c12813514");
var _valueUtils = require("8d20ed398852fb09");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function hasWidthOrStyles(cellProperties) {
    return cellProperties.hasOwnProperty('width') || cellProperties.hasOwnProperty('styles');
}
function getCellStyles(cellProperties, originalStyles) {
    if (!hasWidthOrStyles(cellProperties)) return originalStyles;
    var styles = originalStyles;
    // we want to take griddle style object styles, cell specific styles
    if (cellProperties.hasOwnProperty('style')) styles = Object.assign({}, styles, originalStyles, cellProperties.style);
    if (cellProperties.hasOwnProperty('width')) styles = Object.assign({}, styles, {
        width: cellProperties.width
    });
    return styles;
}
var mapStateToProps = function mapStateToProps() {
    var cellPropertiesSelector = (0, _dataSelectors.cellPropertiesSelectorFactory)();
    return function(state, props) {
        return {
            value: (0, _dataSelectors.cellValueSelector)(state, props),
            customComponent: (0, _dataSelectors.customComponentSelector)(state, props),
            cellProperties: cellPropertiesSelector(state, props),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Cell'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Cell')
        };
    };
};
var ComposedCellContainer = function ComposedCellContainer(OriginalComponent) {
    return (0, _compose2.default)((0, _griddleConnect.connect)(mapStateToProps), (0, _mapProps2.default)(function(props) {
        return _extends({}, props.cellProperties.extraData, props, {
            className: (0, _valueUtils.valueOrResult)(props.cellProperties.cssClassName, props) || props.className,
            style: getCellStyles(props.cellProperties, props.style),
            value: props.customComponent ? _react2.default.createElement(props.customComponent, _extends({}, props.cellProperties.extraData, props)) : props.value
        });
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = ComposedCellContainer;

},{"cf0a2f8c5a45794e":"9njXz","fa5ace8510e034e8":"bnNSm","f41d1359c621989c":"cIMyH","5cd8945f9968a3a8":"eIqBR","e9f282227a391f1c":"dy8dd","9d24b6e91109b062":"j6Pty","d157280c12813514":"4c1CS","8d20ed398852fb09":"kAOrs"}],"cIMyH":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.connect = exports.mergeConnectParametersWithOptions = undefined;
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var _react = require("62a10911ecff88c9");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("4222439d0faa1e7b");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRedux = require("c32a261788f0c41d");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/// This method appends options onto existing connect parameters
var mergeConnectParametersWithOptions = exports.mergeConnectParametersWithOptions = function mergeConnectParametersWithOptions(originalConnect, newOptions) {
    var _originalConnect = _slicedToArray(originalConnect, 4), mapStateFromProps = _originalConnect[0], mapDispatchFromProps = _originalConnect[1], mergeProps = _originalConnect[2], options = _originalConnect[3];
    return [
        mapStateFromProps,
        mapDispatchFromProps,
        mergeProps,
        _extends({}, options, newOptions)
    ];
};
var griddleConnect = function griddleConnect() {
    for(var _len = arguments.length, connectOptions = Array(_len), _key = 0; _key < _len; _key++)connectOptions[_key] = arguments[_key];
    return function(OriginalComponent) {
        var _class, _temp;
        return _temp = _class = function(_React$Component) {
            _inherits(_class, _React$Component);
            function _class(props, context) {
                _classCallCheck(this, _class);
                var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));
                var newOptions = mergeConnectParametersWithOptions(connectOptions, {
                    storeKey: context.storeKey
                });
                _this.ConnectedComponent = _reactRedux.connect.apply(undefined, _toConsumableArray(newOptions))(OriginalComponent);
                return _this;
            }
            _createClass(_class, [
                {
                    key: 'render',
                    value: function render() {
                        return _react2.default.createElement(this.ConnectedComponent, this.props);
                    }
                }
            ]);
            return _class;
        }(_react2.default.Component), _class.contextTypes = {
            storeKey: _propTypes2.default.string
        }, _temp;
    };
};
exports.connect = griddleConnect;

},{"62a10911ecff88c9":"9njXz","4222439d0faa1e7b":"bnNSm","c32a261788f0c41d":"j3wUA"}],"eIqBR":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createHelper = require("8b9573d1f3f5f045");
var _createHelper2 = _interopRequireDefault(_createHelper);
var _createEagerFactory = require("b95a55296fa9222d");
var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getContext = function getContext(contextTypes) {
    return function(BaseComponent) {
        var factory = (0, _createEagerFactory2.default)(BaseComponent);
        var GetContext = function GetContext(ownerProps, context) {
            return factory(_extends({}, ownerProps, context));
        };
        GetContext.contextTypes = contextTypes;
        return GetContext;
    };
};
exports.default = (0, _createHelper2.default)(getContext, 'getContext');

},{"8b9573d1f3f5f045":"HesZM","b95a55296fa9222d":"lnk7P"}],"HesZM":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var createHelper = function createHelper(func, helperName) {
    var setDisplayName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var noArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var _ret;
    return func;
};
exports.default = createHelper;

},{}],"lnk7P":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _createEagerElementUtil = require("36353d75939d13e0");
var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
var _isReferentiallyTransparentFunctionComponent = require("d4db237124f7384d");
var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var createFactory = function createFactory(type) {
    var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
    return function(p, c) {
        return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
    };
};
exports.default = createFactory;

},{"36353d75939d13e0":"aDtpH","d4db237124f7384d":"8bLS0"}],"aDtpH":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("1e8cd05e5ee1cda2");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
    if (!hasKey && isReferentiallyTransparent) {
        if (children) return type(_extends({}, props, {
            children: children
        }));
        return type(props);
    }
    var Component = type;
    if (children) return _react2.default.createElement(Component, props, children);
    return _react2.default.createElement(Component, props);
};
exports.default = createEagerElementUtil;

},{"1e8cd05e5ee1cda2":"9njXz"}],"8bLS0":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _isClassComponent = require("7e665f913ff034c0");
var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
    return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && true);
};
exports.default = isReferentiallyTransparentFunctionComponent;

},{"7e665f913ff034c0":"fU5u7"}],"fU5u7":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var isClassComponent = function isClassComponent(Component) {
    return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
};
exports.default = isClassComponent;

},{}],"dy8dd":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _createHelper = require("46b015ebeb95cb2f");
var _createHelper2 = _interopRequireDefault(_createHelper);
var _createEagerFactory = require("7bcbf0279457360c");
var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var mapProps = function mapProps(propsMapper) {
    return function(BaseComponent) {
        var factory = (0, _createEagerFactory2.default)(BaseComponent);
        return function(props) {
            return factory(propsMapper(props));
        };
    };
};
exports.default = (0, _createHelper2.default)(mapProps, 'mapProps');

},{"46b015ebeb95cb2f":"HesZM","7bcbf0279457360c":"lnk7P"}],"j6Pty":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = compose;
function compose() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

},{}],"4c1CS":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cellPropertiesSelector = exports.cellPropertiesSelectorFactory = exports.rowPropertiesSelector = exports.rowDataSelector = exports.cellValueSelector = exports.visibleRowCountSelector = exports.visibleRowIdsSelector = exports.columnTitlesSelector = exports.columnIdsSelector = exports.textSelector = exports.isSettingsVisibleSelector = exports.isSettingsEnabledSelector = exports.customHeadingComponentSelector = exports.customComponentSelector = exports.classNamesForComponentSelector = exports.stylesForComponentSelector = exports.iconsForComponentSelector = exports.iconByNameSelector = exports.sortPropertyByIdSelector = exports.hiddenColumnPropertiesSelector = exports.hiddenColumnsSelector = exports.visibleColumnPropertiesSelector = exports.visibleColumnsSelector = exports.metaDataColumnsSelector = exports.sortedColumnPropertiesSelector = exports.allColumnsSelector = exports.sortColumnsSelector = exports.filterSelector = exports.hasNextSelector = exports.maxPageSelector = exports.hasPreviousSelector = exports.renderPropertiesSelector = exports.recordCountSelector = exports.currentPageSelector = exports.pageSizeSelector = exports.dataLoadingSelector = exports.dataSelector = undefined;
var _union2 = require("4cce84deb36defb6");
var _union3 = _interopRequireDefault(_union2);
var _isFinite2 = require("a3ddc3a6019839b8");
var _isFinite3 = _interopRequireDefault(_isFinite2);
var _isEqual2 = require("e5c3e6929bfb6449");
var _isEqual3 = _interopRequireDefault(_isEqual2);
var _immutable = require("8b88ac44bb9b727");
var _immutable2 = _interopRequireDefault(_immutable);
var _reselect = require("7c718a6cdfa05c10");
var _maxSafeInteger = require("3c9a3bfd03088426");
var _maxSafeInteger2 = _interopRequireDefault(_maxSafeInteger);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var createDeepEqualSelector = (0, _reselect.createSelectorCreator)(_reselect.defaultMemoize, _isEqual3.default);
//import { createSelector } from 'reselect';
/** Gets the full dataset currently tracked by Griddle */ var dataSelector = exports.dataSelector = function dataSelector(state) {
    return state.get('data');
};
var dataLoadingSelector = exports.dataLoadingSelector = (0, _reselect.createSelector)(dataSelector, function(data) {
    return !data;
});
/** Gets the page size */ var pageSizeSelector = exports.pageSizeSelector = function pageSizeSelector(state) {
    return state.getIn([
        'pageProperties',
        'pageSize'
    ]);
};
/** Gets the current page */ var currentPageSelector = exports.currentPageSelector = function currentPageSelector(state) {
    return state.getIn([
        'pageProperties',
        'currentPage'
    ]);
};
/** Gets the record count */ var recordCountSelector = exports.recordCountSelector = function recordCountSelector(state) {
    return state.getIn([
        'pageProperties',
        'recordCount'
    ]);
};
/** Gets the render properties */ var renderPropertiesSelector = exports.renderPropertiesSelector = function renderPropertiesSelector(state) {
    return state.get('renderProperties');
};
/** Determines if there are previous pages */ var hasPreviousSelector = exports.hasPreviousSelector = (0, _reselect.createSelector)(currentPageSelector, function(currentPage) {
    return currentPage > 1;
});
/** Gets the max page size
 */ var maxPageSelector = exports.maxPageSelector = (0, _reselect.createSelector)(pageSizeSelector, recordCountSelector, function(pageSize, recordCount) {
    var calc = recordCount / pageSize;
    var result = calc > Math.floor(calc) ? Math.floor(calc) + 1 : Math.floor(calc);
    return (0, _isFinite3.default)(result) ? result : 1;
});
/** Determines if there are more pages available. Assumes pageProperties.maxPage is set by the container */ var hasNextSelector = exports.hasNextSelector = (0, _reselect.createSelector)(currentPageSelector, maxPageSelector, function(currentPage, maxPage) {
    return currentPage < maxPage;
});
/** Gets current filter */ var filterSelector = exports.filterSelector = function filterSelector(state) {
    return state.get('filter') || '';
};
/** Gets the current sortColumns */ var sortColumnsSelector = exports.sortColumnsSelector = function sortColumnsSelector(state) {
    return state.get('sortColumns') || [];
};
/** Gets all the columns */ var allColumnsSelector = exports.allColumnsSelector = (0, _reselect.createSelector)(dataSelector, renderPropertiesSelector, function(data, renderProperties) {
    var dataColumns = !data || data.size === 0 ? [] : data.get(0).keySeq().toJSON();
    var columnPropertyColumns = renderProperties && renderProperties.size > 0 ? // TODO: Make this not so ugly
    Object.keys(renderProperties.get('columnProperties').toJSON()) : [];
    return (0, _union3.default)(dataColumns, columnPropertyColumns);
});
/** Gets the column properties objects sorted by order
 */ var sortedColumnPropertiesSelector = exports.sortedColumnPropertiesSelector = (0, _reselect.createSelector)(renderPropertiesSelector, function(renderProperties) {
    return renderProperties && renderProperties.get('columnProperties') && renderProperties.get('columnProperties').size !== 0 ? renderProperties.get('columnProperties').sortBy(function(col) {
        return col && col.get('order') || _maxSafeInteger2.default;
    }) : null;
});
/** Gets metadata column ids
 */ var metaDataColumnsSelector = exports.metaDataColumnsSelector = (0, _reselect.createSelector)(sortedColumnPropertiesSelector, function(sortedColumnProperties) {
    return sortedColumnProperties ? sortedColumnProperties.filter(function(c) {
        return c.get('isMetadata');
    }).keySeq().toJSON() : [];
});
/** Gets the visible columns either obtaining the sorted column properties or all columns
 */ var visibleColumnsSelector = exports.visibleColumnsSelector = (0, _reselect.createSelector)(sortedColumnPropertiesSelector, allColumnsSelector, function(sortedColumnProperties, allColumns) {
    return sortedColumnProperties ? sortedColumnProperties.filter(function(c) {
        var isVisible = c.get('visible') || c.get('visible') === undefined;
        var isMetadata = c.get('isMetadata');
        return isVisible && !isMetadata;
    }).keySeq().toJSON() : allColumns;
});
/** TODO: add tests and docs
 */ var visibleColumnPropertiesSelector = exports.visibleColumnPropertiesSelector = (0, _reselect.createSelector)(visibleColumnsSelector, renderPropertiesSelector, function() {
    var visibleColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var renderProperties = arguments[1];
    return visibleColumns.map(function(c) {
        var columnProperty = renderProperties.getIn([
            'columnProperties',
            c
        ]);
        return columnProperty && columnProperty.toJSON() || {
            id: c
        };
    });
});
/** Gets the possible columns that are currently hidden */ var hiddenColumnsSelector = exports.hiddenColumnsSelector = (0, _reselect.createSelector)(visibleColumnsSelector, allColumnsSelector, metaDataColumnsSelector, function(visibleColumns, allColumns, metaDataColumns) {
    var removeColumns = [].concat(_toConsumableArray(visibleColumns), _toConsumableArray(metaDataColumns));
    return allColumns.filter(function(c) {
        return removeColumns.indexOf(c) === -1;
    });
});
/** TODO: add tests and docs
 */ var hiddenColumnPropertiesSelector = exports.hiddenColumnPropertiesSelector = (0, _reselect.createSelector)(hiddenColumnsSelector, renderPropertiesSelector, function() {
    var hiddenColumns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var renderProperties = arguments[1];
    return hiddenColumns.map(function(c) {
        var columnProperty = renderProperties.getIn([
            'columnProperties',
            c
        ]);
        return columnProperty && columnProperty.toJSON() || {
            id: c
        };
    });
});
/** Gets the sort property for a given column */ var sortPropertyByIdSelector = exports.sortPropertyByIdSelector = function sortPropertyByIdSelector(state, _ref) {
    var columnId = _ref.columnId;
    var sortProperties = state.get('sortProperties');
    var individualProperty = sortProperties && sortProperties.size > 0 && sortProperties.find(function(r) {
        return r.get('id') === columnId;
    });
    return individualProperty && individualProperty.toJSON() || null;
};
/** Gets the icons property from styles */ var iconByNameSelector = exports.iconByNameSelector = function iconByNameSelector(state, _ref2) {
    var name = _ref2.name;
    return state.getIn([
        'styleConfig',
        'icons',
        name
    ]);
};
/** Gets the icons for a component */ var iconsForComponentSelector = exports.iconsForComponentSelector = function iconsForComponentSelector(state, componentName) {
    var icons = state.getIn([
        'styleConfig',
        'icons',
        componentName
    ]);
    return icons && icons.toJS ? icons.toJS() : icons;
};
/** Gets a style for a component */ var stylesForComponentSelector = exports.stylesForComponentSelector = function stylesForComponentSelector(state, componentName) {
    var style = state.getIn([
        'styleConfig',
        'styles',
        componentName
    ]);
    return style && style.toJS ? style.toJS() : style;
};
/** Gets a classname for a component */ var classNamesForComponentSelector = exports.classNamesForComponentSelector = function classNamesForComponentSelector(state, componentName) {
    var classNames = state.getIn([
        'styleConfig',
        'classNames',
        componentName
    ]);
    return classNames && classNames.toJS ? classNames.toJS() : classNames;
};
/** Gets a custom component for a given column
* TODO: Needs tests
*/ var customComponentSelector = exports.customComponentSelector = function customComponentSelector(state, _ref3) {
    var columnId = _ref3.columnId;
    return state.getIn([
        'renderProperties',
        'columnProperties',
        columnId,
        'customComponent'
    ]);
};
/** Gets a custom heading component for a given column
* TODO: Needs tests
*/ var customHeadingComponentSelector = exports.customHeadingComponentSelector = function customHeadingComponentSelector(state, _ref4) {
    var columnId = _ref4.columnId;
    return state.getIn([
        'renderProperties',
        'columnProperties',
        columnId,
        'customHeadingComponent'
    ]);
};
var isSettingsEnabledSelector = exports.isSettingsEnabledSelector = function isSettingsEnabledSelector(state) {
    var enableSettings = state.get('enableSettings');
    return enableSettings === undefined ? true : enableSettings;
};
var isSettingsVisibleSelector = exports.isSettingsVisibleSelector = function isSettingsVisibleSelector(state) {
    return state.get('showSettings');
};
var textSelector = exports.textSelector = function textSelector(state, _ref5) {
    var key = _ref5.key;
    return state.getIn([
        'textProperties',
        key
    ]);
};
/** Gets the column ids for the visible columns
*/ var columnIdsSelector = exports.columnIdsSelector = (0, _reselect.createSelector)(renderPropertiesSelector, visibleColumnsSelector, function(renderProperties, visibleColumns) {
    var offset = 1000;
    // TODO: Make this better -- This is pretty inefficient
    return visibleColumns.map(function(k, index) {
        return {
            id: renderProperties.getIn([
                'columnProperties',
                k,
                'id'
            ]) || k,
            order: renderProperties.getIn([
                'columnProperties',
                k,
                'order'
            ]) || offset + index
        };
    }).sort(function(first, second) {
        return first.order - second.order;
    }).map(function(item) {
        return item.id;
    });
});
/** Gets the column titles for the visible columns
 */ var columnTitlesSelector = exports.columnTitlesSelector = (0, _reselect.createSelector)(columnIdsSelector, renderPropertiesSelector, function(columnIds, renderProperties) {
    return columnIds.map(function(k) {
        return renderProperties.getIn([
            'columnProperties',
            k,
            'title'
        ]) || k;
    });
});
/** Gets the griddleIds for the visible rows */ var visibleRowIdsSelector = exports.visibleRowIdsSelector = (0, _reselect.createSelector)(dataSelector, function(currentPageData) {
    return currentPageData ? currentPageData.map(function(c) {
        return c.get('griddleKey');
    }) : new _immutable2.default.List();
});
/** Gets the count of visible rows */ var visibleRowCountSelector = exports.visibleRowCountSelector = (0, _reselect.createSelector)(visibleRowIdsSelector, function(visibleRowIds) {
    return visibleRowIds.size;
});
// TODO: Needs tests and jsdoc
var cellValueSelector = exports.cellValueSelector = function cellValueSelector(state, props) {
    var griddleKey = props.griddleKey, columnId = props.columnId;
    var cellProperties = cellPropertiesSelector(state, props);
    //TODO: Make Griddle key a string in data utils
    var lookup = state.getIn([
        'lookup',
        griddleKey.toString()
    ]);
    var value = state.get('data').get(lookup).getIn(columnId.split('.'));
    var type = !!cellProperties ? cellProperties.type : 'string';
    switch(type){
        case 'date':
            return value.toLocaleDateString();
        case 'string':
        default:
            return value;
    }
};
// TODO: Needs jsdoc
var rowDataSelector = exports.rowDataSelector = function rowDataSelector(state, _ref6) {
    var griddleKey = _ref6.griddleKey;
    var rowIndex = state.getIn([
        'lookup',
        griddleKey.toString()
    ]);
    return state.get('data').get(rowIndex).toJSON();
};
/** Gets the row render properties
 */ var rowPropertiesSelector = exports.rowPropertiesSelector = function rowPropertiesSelector(state) {
    var row = state.getIn([
        'renderProperties',
        'rowProperties'
    ]);
    return row && row.toJSON() || {};
};
/** Gets the column render properties for the specified columnId
 */ var cellPropertiesSelectorFactory = exports.cellPropertiesSelectorFactory = function cellPropertiesSelectorFactory() {
    var immutableCellPropertiesSelector = function immutableCellPropertiesSelector(state, _ref7) {
        var columnId = _ref7.columnId;
        var item = state.getIn([
            'renderProperties',
            'columnProperties',
            columnId
        ]);
        return item && item.toJSON() || {};
    };
    return createDeepEqualSelector(immutableCellPropertiesSelector, function(item) {
        return item;
    });
};
var cellPropertiesSelector = exports.cellPropertiesSelector = cellPropertiesSelectorFactory();

},{"4cce84deb36defb6":"3aDzJ","a3ddc3a6019839b8":"kWFgN","e5c3e6929bfb6449":"3mRdp","8b88ac44bb9b727":"AnTq9","7c718a6cdfa05c10":"eYQTI","3c9a3bfd03088426":"2FF4q"}],"3aDzJ":[function(require,module,exports,__globalThis) {
var baseFlatten = require("4c6a8d1d22b46f1e"), baseRest = require("3c5b68a5bd4cb3c4"), baseUniq = require("d4a39eace292bbe3"), isArrayLikeObject = require("b9956cfd928a69da");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var union = baseRest(function(arrays) {
    return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});
module.exports = union;

},{"4c6a8d1d22b46f1e":"iu9J0","3c5b68a5bd4cb3c4":"5w1TW","d4a39eace292bbe3":"lImIy","b9956cfd928a69da":"gamaN"}],"iu9J0":[function(require,module,exports,__globalThis) {
var arrayPush = require("d752582e5b174691"), isFlattenable = require("ec5f080ebf5764e8");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = isFlattenable);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
            else arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = baseFlatten;

},{"d752582e5b174691":"8JuEE","ec5f080ebf5764e8":"6OjlR"}],"6OjlR":[function(require,module,exports,__globalThis) {
var Symbol = require("dde07f6ab8ba5eb5"), isArguments = require("ee6f325d7f5309b1"), isArray = require("ff8d93236e335297");
/** Built-in value references. */ var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
module.exports = isFlattenable;

},{"dde07f6ab8ba5eb5":"crlKT","ee6f325d7f5309b1":"bpegN","ff8d93236e335297":"1DVeR"}],"5w1TW":[function(require,module,exports,__globalThis) {
var identity = require("3b2979bd51a0f85f"), overRest = require("ff7d23ff2a2ea6f8"), setToString = require("a11d545e809d14f7");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + '');
}
module.exports = baseRest;

},{"3b2979bd51a0f85f":"2HXBf","ff7d23ff2a2ea6f8":"rlFXD","a11d545e809d14f7":"cmKNW"}],"rlFXD":[function(require,module,exports,__globalThis) {
var apply = require("6f683b05f63ed25a");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
module.exports = overRest;

},{"6f683b05f63ed25a":"bZSxb"}],"bZSxb":[function(require,module,exports,__globalThis) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = apply;

},{}],"cmKNW":[function(require,module,exports,__globalThis) {
var baseSetToString = require("eebd487fbab521b6"), shortOut = require("9114f59293388d49");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
module.exports = setToString;

},{"eebd487fbab521b6":"i2oRN","9114f59293388d49":"9rYPt"}],"i2oRN":[function(require,module,exports,__globalThis) {
var constant = require("706929c7b4749485"), defineProperty = require("eff1240bc0447727"), identity = require("b00d1e57326793e1");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
    });
};
module.exports = baseSetToString;

},{"706929c7b4749485":"bvu2c","eff1240bc0447727":"fUDy8","b00d1e57326793e1":"2HXBf"}],"bvu2c":[function(require,module,exports,__globalThis) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
module.exports = constant;

},{}],"9rYPt":[function(require,module,exports,__globalThis) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = shortOut;

},{}],"lImIy":[function(require,module,exports,__globalThis) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"irm8l","a1d85be956e037a9":"3t5Fw","8cd18f86a4a2c118":"4yfFQ","3acf9f4a3a78c511":"c2cDw","19b77385b4f7775a":"gStkf","4568580f7416eb83":"lxNlE"}],"3t5Fw":[function(require,module,exports,__globalThis) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"1LJGE"}],"1LJGE":[function(require,module,exports,__globalThis) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"9mWam","c991ed2b82d165b":"dG3he","c0bb8190b05a00a5":"4WTof"}],"9mWam":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"dG3he":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"4WTof":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"4yfFQ":[function(require,module,exports,__globalThis) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"gStkf":[function(require,module,exports,__globalThis) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"juoJE","a02c367b3608ccee":"enX86","cd8d0af6a14b2f7d":"lxNlE"}],"enX86":[function(require,module,exports,__globalThis) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"gamaN":[function(require,module,exports,__globalThis) {
var isArrayLike = require("9ce7efb3ed8cb283"), isObjectLike = require("639a4883b097af28");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
module.exports = isArrayLikeObject;

},{"9ce7efb3ed8cb283":"kzICo","639a4883b097af28":"4gOki"}],"kWFgN":[function(require,module,exports,__globalThis) {
var root = require("2ada4c14bc352a04");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsFinite = root.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function isFinite(value) {
    return typeof value == 'number' && nativeIsFinite(value);
}
module.exports = isFinite;

},{"2ada4c14bc352a04":"gVq56"}],"3mRdp":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("7b71d3bc42bb6f3e");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
    return baseIsEqual(value, other);
}
module.exports = isEqual;

},{"7b71d3bc42bb6f3e":"hrIE8"}],"AnTq9":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var SLICE$0 = Array.prototype.slice;
    function createClass(ctor, superClass) {
        if (superClass) ctor.prototype = Object.create(superClass.prototype);
        ctor.prototype.constructor = ctor;
    }
    function Iterable(value) {
        return isIterable(value) ? value : Seq(value);
    }
    createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    createClass(SetIterable, Iterable);
    function SetIterable(value) {
        return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    function isIterable(maybeIterable) {
        return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
    }
    function isKeyed(maybeKeyed) {
        return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
    }
    function isIndexed(maybeIndexed) {
        return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
    }
    function isAssociative(maybeAssociative) {
        return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
    }
    function isOrdered(maybeOrdered) {
        return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
    }
    Iterable.isIterable = isIterable;
    Iterable.isKeyed = isKeyed;
    Iterable.isIndexed = isIndexed;
    Iterable.isAssociative = isAssociative;
    Iterable.isOrdered = isOrdered;
    Iterable.Keyed = KeyedIterable;
    Iterable.Indexed = IndexedIterable;
    Iterable.Set = SetIterable;
    var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
    // Used for setting prototype methods that IE8 chokes on.
    var DELETE = 'delete';
    // Constants describing the size of trie nodes.
    var SHIFT = 5; // Resulted in best performance after ______?
    var SIZE = 1 << SHIFT;
    var MASK = SIZE - 1;
    // A consistent shared value representing "not set" which equals nothing other
    // than itself, and nothing that could be provided externally.
    var NOT_SET = {};
    // Boolean references, Rough equivalent of `bool &`.
    var CHANGE_LENGTH = {
        value: false
    };
    var DID_ALTER = {
        value: false
    };
    function MakeRef(ref) {
        ref.value = false;
        return ref;
    }
    function SetRef(ref) {
        ref && (ref.value = true);
    }
    // A function which returns a value representing an "owner" for transient writes
    // to tries. The return value will only ever equal itself, and will not equal
    // the return of any subsequent call of this function.
    function OwnerID() {}
    // http://jsperf.com/copy-array-inline
    function arrCopy(arr, offset) {
        offset = offset || 0;
        var len = Math.max(0, arr.length - offset);
        var newArr = new Array(len);
        for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
        return newArr;
    }
    function ensureSize(iter) {
        if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
        return iter.size;
    }
    function wrapIndex(iter, index) {
        // This implements "is array index" which the ECMAString spec defines as:
        //
        //     A String property name P is an array index if and only if
        //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
        //     to 2^32−1.
        //
        // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
        if (typeof index !== 'number') {
            var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
            if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
            index = uint32Index;
        }
        return index < 0 ? ensureSize(iter) + index : index;
    }
    function returnTrue() {
        return true;
    }
    function wholeSlice(begin, end, size) {
        return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
    }
    function resolveBegin(begin, size) {
        return resolveIndex(begin, size, 0);
    }
    function resolveEnd(end, size) {
        return resolveIndex(end, size, size);
    }
    function resolveIndex(index, size, defaultIndex) {
        return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
    }
    /* global Symbol */ var ITERATE_KEYS = 0;
    var ITERATE_VALUES = 1;
    var ITERATE_ENTRIES = 2;
    var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
    function Iterator(next) {
        this.next = next;
    }
    Iterator.prototype.toString = function() {
        return '[Iterator]';
    };
    Iterator.KEYS = ITERATE_KEYS;
    Iterator.VALUES = ITERATE_VALUES;
    Iterator.ENTRIES = ITERATE_ENTRIES;
    Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
        return this.toString();
    };
    Iterator.prototype[ITERATOR_SYMBOL] = function() {
        return this;
    };
    function iteratorValue(type, k, v, iteratorResult) {
        var value = type === 0 ? k : type === 1 ? v : [
            k,
            v
        ];
        iteratorResult ? iteratorResult.value = value : iteratorResult = {
            value: value,
            done: false
        };
        return iteratorResult;
    }
    function iteratorDone() {
        return {
            value: undefined,
            done: true
        };
    }
    function hasIterator(maybeIterable) {
        return !!getIteratorFn(maybeIterable);
    }
    function isIterator(maybeIterator) {
        return maybeIterator && typeof maybeIterator.next === 'function';
    }
    function getIterator(iterable) {
        var iteratorFn = getIteratorFn(iterable);
        return iteratorFn && iteratorFn.call(iterable);
    }
    function getIteratorFn(iterable) {
        var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    function isArrayLike(value) {
        return value && typeof value.length === 'number';
    }
    createClass(Seq, Iterable);
    function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
    }
    Seq.of = function() {
        return Seq(arguments);
    };
    Seq.prototype.toSeq = function() {
        return this;
    };
    Seq.prototype.toString = function() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, true);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, true);
    };
    createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
    }
    KeyedSeq.prototype.toKeyedSeq = function() {
        return this;
    };
    createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }
    IndexedSeq.of = function() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function() {
        return this;
    };
    IndexedSeq.prototype.toString = function() {
        return this.__toString('Seq [', ']');
    };
    IndexedSeq.prototype.__iterate = function(fn, reverse) {
        return seqIterate(this, fn, reverse, false);
    };
    IndexedSeq.prototype.__iterator = function(type, reverse) {
        return seqIterator(this, type, reverse, false);
    };
    createClass(SetSeq, Seq);
    function SetSeq(value) {
        return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
    }
    SetSeq.of = function() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function() {
        return this;
    };
    Seq.isSeq = isSeq;
    Seq.Keyed = KeyedSeq;
    Seq.Set = SetSeq;
    Seq.Indexed = IndexedSeq;
    var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
    Seq.prototype[IS_SEQ_SENTINEL] = true;
    createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    ArraySeq.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function(fn, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) return ii + 1;
        }
        return ii;
    };
    ArraySeq.prototype.__iterator = function(type, reverse) {
        var array = this._array;
        var maxIndex = array.length - 1;
        var ii = 0;
        return new Iterator(function() {
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
        });
    };
    createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    ObjectSeq.prototype.get = function(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function(key) {
        return this._object.hasOwnProperty(key);
    };
    ObjectSeq.prototype.__iterate = function(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        for(var ii = 0; ii <= maxIndex; ii++){
            var key = keys[reverse ? maxIndex - ii : ii];
            if (fn(object[key], key, this) === false) return ii + 1;
        }
        return ii;
    };
    ObjectSeq.prototype.__iterator = function(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var maxIndex = keys.length - 1;
        var ii = 0;
        return new Iterator(function() {
            var key = keys[reverse ? maxIndex - ii : ii];
            return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
        });
    };
    ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
        this._iterable = iterable;
        this.size = iterable.length || iterable.size;
    }
    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterable = this._iterable;
        var iterator = getIterator(iterable);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
    }
    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while(iterations < cache.length){
            if (fn(cache[iterations], iterations++, this) === false) return iterations;
        }
        var step;
        while(!(step = iterator.next()).done){
            var val = step.value;
            cache[iterations] = val;
            if (fn(val, iterations++, this) === false) break;
        }
        return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function() {
            if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) return step;
                cache[iterations] = step.value;
            }
            return iteratorValue(type, iterations, cache[iterations++]);
        });
    };
    // # pragma Helper functions
    function isSeq(maybeSeq) {
        return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
    }
    var EMPTY_SEQ;
    function emptySequence() {
        return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
    }
    function keyedSeqFromValue(value) {
        var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;
        if (!seq) throw new TypeError("Expected Array or iterable object of [k, v] entries, or keyed object: " + value);
        return seq;
    }
    function indexedSeqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value);
        if (!seq) throw new TypeError('Expected Array or iterable object of values: ' + value);
        return seq;
    }
    function seqFromValue(value) {
        var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);
        if (!seq) throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
        return seq;
    }
    function maybeIndexedSeqFromValue(value) {
        return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
    }
    function seqIterate(seq, fn, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            for(var ii = 0; ii <= maxIndex; ii++){
                var entry = cache[reverse ? maxIndex - ii : ii];
                if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) return ii + 1;
            }
            return ii;
        }
        return seq.__iterateUncached(fn, reverse);
    }
    function seqIterator(seq, type, reverse, useKeys) {
        var cache = seq._cache;
        if (cache) {
            var maxIndex = cache.length - 1;
            var ii = 0;
            return new Iterator(function() {
                var entry = cache[reverse ? maxIndex - ii : ii];
                return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
            });
        }
        return seq.__iteratorUncached(type, reverse);
    }
    function fromJS(json, converter) {
        return converter ? fromJSWith(converter, json, '', {
            '': json
        }) : fromJSDefault(json);
    }
    function fromJSWith(converter, json, key, parentJSON) {
        if (Array.isArray(json)) return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        if (isPlainObj(json)) return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k) {
            return fromJSWith(converter, v, k, json);
        }));
        return json;
    }
    function fromJSDefault(json) {
        if (Array.isArray(json)) return IndexedSeq(json).map(fromJSDefault).toList();
        if (isPlainObj(json)) return KeyedSeq(json).map(fromJSDefault).toMap();
        return json;
    }
    function isPlainObj(value) {
        return value && (value.constructor === Object || value.constructor === undefined);
    }
    /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */ function is(valueA, valueB) {
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
        if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
            valueA = valueA.valueOf();
            valueB = valueB.valueOf();
            if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
            if (!valueA || !valueB) return false;
        }
        if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) return true;
        return false;
    }
    function deepEqual(a, b) {
        if (a === b) return true;
        if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
        if (a.size === 0 && b.size === 0) return true;
        var notAssociative = !isAssociative(a);
        if (isOrdered(a)) {
            var entries = a.entries();
            return b.every(function(v, k) {
                var entry = entries.next().value;
                return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
            }) && entries.next().done;
        }
        var flipped = false;
        if (a.size === undefined) {
            if (b.size === undefined) {
                if (typeof a.cacheResult === 'function') a.cacheResult();
            } else {
                flipped = true;
                var _ = a;
                a = b;
                b = _;
            }
        }
        var allEqual = true;
        var bSize = b.__iterate(function(v, k) {
            if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
                allEqual = false;
                return false;
            }
        });
        return allEqual && a.size === bSize;
    }
    createClass(Repeat, IndexedSeq);
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    Repeat.prototype.toString = function() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function() {
        return this;
    };
    Repeat.prototype.indexOf = function(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function(fn, reverse) {
        for(var ii = 0; ii < this.size; ii++){
            if (fn(this._value, ii, this) === false) return ii + 1;
        }
        return ii;
    };
    Repeat.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        var ii = 0;
        return new Iterator(function() {
            return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
        });
    };
    Repeat.prototype.equals = function(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };
    var EMPTY_REPEAT;
    function invariant(condition, error) {
        if (!condition) throw new Error(error);
    }
    createClass(Range, IndexedSeq);
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    Range.prototype.toString = function() {
        if (this.size === 0) return 'Range []';
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };
    Range.prototype.get = function(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function(fn, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        for(var ii = 0; ii <= maxIndex; ii++){
            if (fn(value, ii, this) === false) return ii + 1;
            value += reverse ? -step : step;
        }
        return ii;
    };
    Range.prototype.__iterator = function(type, reverse) {
        var maxIndex = this.size - 1;
        var step = this._step;
        var value = reverse ? this._start + maxIndex * step : this._start;
        var ii = 0;
        return new Iterator(function() {
            var v = value;
            value += reverse ? -step : step;
            return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
        });
    };
    Range.prototype.equals = function(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    var EMPTY_RANGE;
    createClass(Collection, Iterable);
    function Collection() {
        throw TypeError('Abstract');
    }
    createClass(KeyedCollection, Collection);
    function KeyedCollection() {}
    createClass(IndexedCollection, Collection);
    function IndexedCollection() {}
    createClass(SetCollection, Collection);
    function SetCollection() {}
    Collection.Keyed = KeyedCollection;
    Collection.Indexed = IndexedCollection;
    Collection.Set = SetCollection;
    var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
        a = a | 0; // int
        b = b | 0; // int
        var c = a & 0xffff;
        var d = b & 0xffff;
        // Shift by 0 fixes the sign on the high part.
        return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
    };
    // v8 has an optimization for storing 31-bit signed numbers.
    // Values which have either 00 or 11 as the high order bits qualify.
    // This function drops the highest order bit in a signed number, maintaining
    // the sign bit.
    function smi(i32) {
        return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
    }
    function hash(o) {
        if (o === false || o === null || o === undefined) return 0;
        if (typeof o.valueOf === 'function') {
            o = o.valueOf();
            if (o === false || o === null || o === undefined) return 0;
        }
        if (o === true) return 1;
        var type = typeof o;
        if (type === 'number') {
            if (o !== o || o === Infinity) return 0;
            var h = o | 0;
            if (h !== o) h ^= o * 0xFFFFFFFF;
            while(o > 0xFFFFFFFF){
                o /= 0xFFFFFFFF;
                h ^= o;
            }
            return smi(h);
        }
        if (type === 'string') return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
        if (typeof o.hashCode === 'function') return o.hashCode();
        if (type === 'object') return hashJSObj(o);
        if (typeof o.toString === 'function') return hashString(o.toString());
        throw new Error('Value type ' + type + ' cannot be hashed.');
    }
    function cachedHashString(string) {
        var hash = stringHashCache[string];
        if (hash === undefined) {
            hash = hashString(string);
            if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
                STRING_HASH_CACHE_SIZE = 0;
                stringHashCache = {};
            }
            STRING_HASH_CACHE_SIZE++;
            stringHashCache[string] = hash;
        }
        return hash;
    }
    // http://jsperf.com/hashing-strings
    function hashString(string) {
        // This is the hash from JVM
        // The hash code for a string is computed as
        // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
        // where s[i] is the ith character of the string and n is the length of
        // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
        // (exclusive) by dropping high bits.
        var hash = 0;
        for(var ii = 0; ii < string.length; ii++)hash = 31 * hash + string.charCodeAt(ii) | 0;
        return smi(hash);
    }
    function hashJSObj(obj) {
        var hash;
        if (usingWeakMap) {
            hash = weakMap.get(obj);
            if (hash !== undefined) return hash;
        }
        hash = obj[UID_HASH_KEY];
        if (hash !== undefined) return hash;
        if (!canDefineProperty) {
            hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
            if (hash !== undefined) return hash;
            hash = getIENodeHash(obj);
            if (hash !== undefined) return hash;
        }
        hash = ++objHashUID;
        if (objHashUID & 0x40000000) objHashUID = 0;
        if (usingWeakMap) weakMap.set(obj, hash);
        else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
        else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
            'enumerable': false,
            'configurable': false,
            'writable': false,
            'value': hash
        });
        else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
            // Since we can't define a non-enumerable property on the object
            // we'll hijack one of the less-used non-enumerable properties to
            // save our hash on it. Since this is a function it will not show up in
            // `JSON.stringify` which is what we want.
            obj.propertyIsEnumerable = function() {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
            };
            obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
        } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
        // and we couldn't use a non-enumerable property to exploit the
        // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
        // itself.
        obj[UID_HASH_KEY] = hash;
        else throw new Error('Unable to set a non-enumerable property on object.');
        return hash;
    }
    // Get references to ES5 object methods.
    var isExtensible = Object.isExtensible;
    // True if Object.defineProperty works as expected. IE8 fails this test.
    var canDefineProperty = function() {
        try {
            Object.defineProperty({}, '@', {});
            return true;
        } catch (e) {
            return false;
        }
    }();
    // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
    // and avoid memory leaks from the IE cloneNode bug.
    function getIENodeHash(node) {
        if (node && node.nodeType > 0) switch(node.nodeType){
            case 1:
                return node.uniqueID;
            case 9:
                return node.documentElement && node.documentElement.uniqueID;
        }
    }
    // If possible, use a WeakMap.
    var usingWeakMap = typeof WeakMap === 'function';
    var weakMap;
    if (usingWeakMap) weakMap = new WeakMap();
    var objHashUID = 0;
    var UID_HASH_KEY = '__immutablehash__';
    if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
    var STRING_HASH_CACHE_MIN_STRLEN = 16;
    var STRING_HASH_CACHE_MAX_SIZE = 255;
    var STRING_HASH_CACHE_SIZE = 0;
    var stringHashCache = {};
    function assertNotInfinite(size) {
        invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
    }
    createClass(Map, KeyedCollection);
    // @pragma Construction
    function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    Map.of = function() {
        var keyValues = SLICE$0.call(arguments, 0);
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error('Missing value for key: ' + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.setIn = function(keyPath, v) {
        return this.updateIn(keyPath, NOT_SET, function() {
            return v;
        });
    };
    Map.prototype.remove = function(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteIn = function(keyPath) {
        return this.updateIn(keyPath, function() {
            return NOT_SET;
        });
    };
    Map.prototype.update = function(k, notSetValue, updater) {
        return arguments.length === 1 ? k(this) : this.updateIn([
            k
        ], notSetValue, updater);
    };
    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
        if (!updater) {
            updater = notSetValue;
            notSetValue = undefined;
        }
        var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
        return updatedValue === NOT_SET ? undefined : updatedValue;
    };
    Map.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.merge = function() {
        return mergeIntoMapWith(this, undefined, arguments);
    };
    Map.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, merger, iters);
    };
    Map.prototype.mergeIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.mergeDeep = function() {
        return mergeIntoMapWith(this, deepMerger, arguments);
    };
    Map.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };
    Map.prototype.mergeDeepIn = function(keyPath) {
        var iters = SLICE$0.call(arguments, 1);
        return this.updateIn(keyPath, emptyMap(), function(m) {
            return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
        });
    };
    Map.prototype.sort = function(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    // @pragma Mutability
    Map.prototype.withMutations = function(fn) {
        var mutable = this.asMutable();
        fn(mutable);
        return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };
    Map.prototype.asMutable = function() {
        return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };
    Map.prototype.asImmutable = function() {
        return this.__ensureOwner();
    };
    Map.prototype.wasAltered = function() {
        return this.__altered;
    };
    Map.prototype.__iterator = function(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$0);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    function isMap(maybeMap) {
        return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
    }
    Map.isMap = isMap;
    var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
    var MapPrototype = Map.prototype;
    MapPrototype[IS_MAP_SENTINEL] = true;
    MapPrototype[DELETE] = MapPrototype.remove;
    MapPrototype.removeIn = MapPrototype.deleteIn;
    // #pragma Trie Nodes
    function ArrayMapNode(ownerID, entries) {
        this.ownerID = ownerID;
        this.entries = entries;
    }
    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && entries.length === 1) return; // undefined
        if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new ArrayMapNode(ownerID, newEntries);
    };
    function BitmapIndexedNode(ownerID, bitmap, nodes) {
        this.ownerID = ownerID;
        this.bitmap = bitmap;
        this.nodes = nodes;
    }
    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
        var bitmap = this.bitmap;
        return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
    };
    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var bit = 1 << keyHashFrag;
        var bitmap = this.bitmap;
        var exists = (bitmap & bit) !== 0;
        if (!exists && value === NOT_SET) return this;
        var idx = popCount(bitmap & bit - 1);
        var nodes = this.nodes;
        var node = exists ? nodes[idx] : undefined;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
        if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
        if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
        var isEditable = ownerID && ownerID === this.ownerID;
        var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
        var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.bitmap = newBitmap;
            this.nodes = newNodes;
            return this;
        }
        return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };
    function HashArrayMapNode(ownerID, count, nodes) {
        this.ownerID = ownerID;
        this.count = count;
        this.nodes = nodes;
    }
    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var node = this.nodes[idx];
        return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };
    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var removed = value === NOT_SET;
        var nodes = this.nodes;
        var node = nodes[idx];
        if (removed && !node) return this;
        var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
        if (newNode === node) return this;
        var newCount = this.count;
        if (!node) newCount++;
        else if (!newNode) {
            newCount--;
            if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
        }
        var isEditable = ownerID && ownerID === this.ownerID;
        var newNodes = setIn(nodes, idx, newNode, isEditable);
        if (isEditable) {
            this.count = newCount;
            this.nodes = newNodes;
            return this;
        }
        return new HashArrayMapNode(ownerID, newCount, newNodes);
    };
    function HashCollisionNode(ownerID, keyHash, entries) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entries = entries;
    }
    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        var entries = this.entries;
        for(var ii = 0, len = entries.length; ii < len; ii++){
            if (is(key, entries[ii][0])) return entries[ii][1];
        }
        return notSetValue;
    };
    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (keyHash === undefined) keyHash = hash(key);
        var removed = value === NOT_SET;
        if (keyHash !== this.keyHash) {
            if (removed) return this;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return mergeIntoNode(this, ownerID, shift, keyHash, [
                key,
                value
            ]);
        }
        var entries = this.entries;
        var idx = 0;
        for(var len = entries.length; idx < len; idx++){
            if (is(key, entries[idx][0])) break;
        }
        var exists = idx < len;
        if (exists ? entries[idx][1] === value : removed) return this;
        SetRef(didAlter);
        (removed || !exists) && SetRef(didChangeSize);
        if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
        var isEditable = ownerID && ownerID === this.ownerID;
        var newEntries = isEditable ? entries : arrCopy(entries);
        if (exists) {
            if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
            else newEntries[idx] = [
                key,
                value
            ];
        } else newEntries.push([
            key,
            value
        ]);
        if (isEditable) {
            this.entries = newEntries;
            return this;
        }
        return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };
    function ValueNode(ownerID, keyHash, entry) {
        this.ownerID = ownerID;
        this.keyHash = keyHash;
        this.entry = entry;
    }
    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
        return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };
    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        var removed = value === NOT_SET;
        var keyMatch = is(key, this.entry[0]);
        if (keyMatch ? value === this.entry[1] : removed) return this;
        SetRef(didAlter);
        if (removed) {
            SetRef(didChangeSize);
            return; // undefined
        }
        if (keyMatch) {
            if (ownerID && ownerID === this.ownerID) {
                this.entry[1] = value;
                return this;
            }
            return new ValueNode(ownerID, this.keyHash, [
                key,
                value
            ]);
        }
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, hash(key), [
            key,
            value
        ]);
    };
    // #pragma Iterators
    ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
        var entries = this.entries;
        for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
            if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
        }
    };
    BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
        var nodes = this.nodes;
        for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
            var node = nodes[reverse ? maxIndex - ii : ii];
            if (node && node.iterate(fn, reverse) === false) return false;
        }
    };
    ValueNode.prototype.iterate = function(fn, reverse) {
        return fn(this.entry);
    };
    createClass(MapIterator, Iterator);
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    MapIterator.prototype.next = function() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    function mapIteratorValue(type, entry) {
        return iteratorValue(type, entry[0], entry[1]);
    }
    function mapIteratorFrame(node, prev) {
        return {
            node: node,
            index: 0,
            __prev: prev
        };
    }
    function makeMap(size, root, ownerID, hash) {
        var map = Object.create(MapPrototype);
        map.size = size;
        map._root = root;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_MAP;
    function emptyMap() {
        return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
    }
    function updateMap(map, k, v) {
        var newRoot;
        var newSize;
        if (!map._root) {
            if (v === NOT_SET) return map;
            newSize = 1;
            newRoot = new ArrayMapNode(map.__ownerID, [
                [
                    k,
                    v
                ]
            ]);
        } else {
            var didChangeSize = MakeRef(CHANGE_LENGTH);
            var didAlter = MakeRef(DID_ALTER);
            newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
            if (!didAlter.value) return map;
            newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
        }
        if (map.__ownerID) {
            map.size = newSize;
            map._root = newRoot;
            map.__hash = undefined;
            map.__altered = true;
            return map;
        }
        return newRoot ? makeMap(newSize, newRoot) : emptyMap();
    }
    function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
        if (!node) {
            if (value === NOT_SET) return node;
            SetRef(didAlter);
            SetRef(didChangeSize);
            return new ValueNode(ownerID, keyHash, [
                key,
                value
            ]);
        }
        return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
    }
    function isLeafNode(node) {
        return node.constructor === ValueNode || node.constructor === HashCollisionNode;
    }
    function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
        if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
            node.entry,
            entry
        ]);
        var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
        var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
        var newNode;
        var nodes = idx1 === idx2 ? [
            mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
        ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
            node,
            newNode
        ] : [
            newNode,
            node
        ]);
        return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
    }
    function createNodes(ownerID, entries, key, value) {
        if (!ownerID) ownerID = new OwnerID();
        var node = new ValueNode(ownerID, hash(key), [
            key,
            value
        ]);
        for(var ii = 0; ii < entries.length; ii++){
            var entry = entries[ii];
            node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
        }
        return node;
    }
    function packNodes(ownerID, nodes, count, excluding) {
        var bitmap = 0;
        var packedII = 0;
        var packedNodes = new Array(count);
        for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
            var node = nodes[ii];
            if (node !== undefined && ii !== excluding) {
                bitmap |= bit;
                packedNodes[packedII++] = node;
            }
        }
        return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
    }
    function expandNodes(ownerID, nodes, bitmap, including, node) {
        var count = 0;
        var expandedNodes = new Array(SIZE);
        for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
        expandedNodes[including] = node;
        return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
    }
    function mergeIntoMapWith(map, merger, iterables) {
        var iters = [];
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = KeyedIterable(value);
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        return mergeIntoCollectionWith(map, merger, iters);
    }
    function deepMerger(existing, value, key) {
        return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
    }
    function deepMergerWith(merger) {
        return function(existing, value, key) {
            if (existing && existing.mergeDeepWith && isIterable(value)) return existing.mergeDeepWith(merger, value);
            var nextValue = merger(existing, value, key);
            return is(existing, nextValue) ? existing : nextValue;
        };
    }
    function mergeIntoCollectionWith(collection, merger, iters) {
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return collection;
        if (collection.size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
        return collection.withMutations(function(collection) {
            var mergeIntoMap = merger ? function(value, key) {
                collection.update(key, NOT_SET, function(existing) {
                    return existing === NOT_SET ? value : merger(existing, value, key);
                });
            } : function(value, key) {
                collection.set(key, value);
            };
            for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoMap);
        });
    }
    function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
        var isNotSet = existing === NOT_SET;
        var step = keyPathIter.next();
        if (step.done) {
            var existingValue = isNotSet ? notSetValue : existing;
            var newValue = updater(existingValue);
            return newValue === existingValue ? existing : newValue;
        }
        invariant(isNotSet || existing && existing.set, 'invalid keyPath');
        var key = step.value;
        var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
        var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
        return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
    }
    function popCount(x) {
        x = x - (x >> 1 & 0x55555555);
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x = x + (x >> 8);
        x = x + (x >> 16);
        return x & 0x7f;
    }
    function setIn(array, idx, val, canEdit) {
        var newArray = canEdit ? array : arrCopy(array);
        newArray[idx] = val;
        return newArray;
    }
    function spliceIn(array, idx, val, canEdit) {
        var newLen = array.length + 1;
        if (canEdit && idx + 1 === newLen) {
            array[idx] = val;
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
            newArray[ii] = val;
            after = -1;
        } else newArray[ii] = array[ii + after];
        return newArray;
    }
    function spliceOut(array, idx, canEdit) {
        var newLen = array.length - 1;
        if (canEdit && idx === newLen) {
            array.pop();
            return array;
        }
        var newArray = new Array(newLen);
        var after = 0;
        for(var ii = 0; ii < newLen; ii++){
            if (ii === idx) after = 1;
            newArray[ii] = array[ii + after];
        }
        return newArray;
    }
    var MAX_ARRAY_MAP_SIZE = SIZE / 4;
    var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
    var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
    createClass(List, IndexedCollection);
    // @pragma Construction
    function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) return empty;
        if (isList(value)) return value;
        var iter = IndexedIterable(value);
        var size = iter.size;
        if (size === 0) return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    List.of = function() {
        return this(arguments);
    };
    List.prototype.toString = function() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.merge = function() {
        return mergeIntoListWith(this, undefined, arguments);
    };
    List.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, merger, iters);
    };
    List.prototype.mergeDeep = function() {
        return mergeIntoListWith(this, deepMerger, arguments);
    };
    List.prototype.mergeDeepWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };
    List.prototype.setSize = function(size) {
        return setListBounds(this, 0, size);
    };
    // @pragma Iteration
    List.prototype.slice = function(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function(type, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
        });
    };
    List.prototype.__iterate = function(fn, reverse) {
        var index = 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    function isList(maybeList) {
        return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
    }
    List.isList = isList;
    var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
    var ListPrototype = List.prototype;
    ListPrototype[IS_LIST_SENTINEL] = true;
    ListPrototype[DELETE] = ListPrototype.remove;
    ListPrototype.setIn = MapPrototype.setIn;
    ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
    ListPrototype.update = MapPrototype.update;
    ListPrototype.updateIn = MapPrototype.updateIn;
    ListPrototype.mergeIn = MapPrototype.mergeIn;
    ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    ListPrototype.withMutations = MapPrototype.withMutations;
    ListPrototype.asMutable = MapPrototype.asMutable;
    ListPrototype.asImmutable = MapPrototype.asImmutable;
    ListPrototype.wasAltered = MapPrototype.wasAltered;
    function VNode(array, ownerID) {
        this.array = array;
        this.ownerID = ownerID;
    }
    // TODO: seems like these methods are very similar
    VNode.prototype.removeBefore = function(ownerID, level, index) {
        if (index === level ? 1 << level : this.array.length === 0) return this;
        var originIndex = index >>> level & MASK;
        if (originIndex >= this.array.length) return new VNode([], ownerID);
        var removingFirst = originIndex === 0;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[originIndex];
            newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
            if (newChild === oldChild && removingFirst) return this;
        }
        if (removingFirst && !newChild) return this;
        var editable = editableVNode(this, ownerID);
        if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
        if (newChild) editable.array[originIndex] = newChild;
        return editable;
    };
    VNode.prototype.removeAfter = function(ownerID, level, index) {
        if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
        var sizeIndex = index - 1 >>> level & MASK;
        if (sizeIndex >= this.array.length) return this;
        var newChild;
        if (level > 0) {
            var oldChild = this.array[sizeIndex];
            newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
            if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
        }
        var editable = editableVNode(this, ownerID);
        editable.array.splice(sizeIndex + 1);
        if (newChild) editable.array[sizeIndex] = newChild;
        return editable;
    };
    var DONE = {};
    function iterateList(list, reverse) {
        var left = list._origin;
        var right = list._capacity;
        var tailPos = getTailOffset(right);
        var tail = list._tail;
        return iterateNodeOrLeaf(list._root, list._level, 0);
        function iterateNodeOrLeaf(node, level, offset) {
            return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
        }
        function iterateLeaf(node, offset) {
            var array = offset === tailPos ? tail && tail.array : node && node.array;
            var from = offset > left ? 0 : left - offset;
            var to = right - offset;
            if (to > SIZE) to = SIZE;
            return function() {
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                return array && array[idx];
            };
        }
        function iterateNode(node, level, offset) {
            var values;
            var array = node && node.array;
            var from = offset > left ? 0 : left - offset >> level;
            var to = (right - offset >> level) + 1;
            if (to > SIZE) to = SIZE;
            return function() {
                do {
                    if (values) {
                        var value = values();
                        if (value !== DONE) return value;
                        values = null;
                    }
                    if (from === to) return DONE;
                    var idx = reverse ? --to : from++;
                    values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
                }while (true);
            };
        }
    }
    function makeList(origin, capacity, level, root, tail, ownerID, hash) {
        var list = Object.create(ListPrototype);
        list.size = capacity - origin;
        list._origin = origin;
        list._capacity = capacity;
        list._level = level;
        list._root = root;
        list._tail = tail;
        list.__ownerID = ownerID;
        list.__hash = hash;
        list.__altered = false;
        return list;
    }
    var EMPTY_LIST;
    function emptyList() {
        return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
    }
    function updateList(list, index, value) {
        index = wrapIndex(list, index);
        if (index !== index) return list;
        if (index >= list.size || index < 0) return list.withMutations(function(list) {
            index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
        });
        index += list._origin;
        var newTail = list._tail;
        var newRoot = list._root;
        var didAlter = MakeRef(DID_ALTER);
        if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
        else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
        if (!didAlter.value) return list;
        if (list.__ownerID) {
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
    }
    function updateVNode(node, ownerID, level, index, value, didAlter) {
        var idx = index >>> level & MASK;
        var nodeHas = node && idx < node.array.length;
        if (!nodeHas && value === undefined) return node;
        var newNode;
        if (level > 0) {
            var lowerNode = node && node.array[idx];
            var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
            if (newLowerNode === lowerNode) return node;
            newNode = editableVNode(node, ownerID);
            newNode.array[idx] = newLowerNode;
            return newNode;
        }
        if (nodeHas && node.array[idx] === value) return node;
        SetRef(didAlter);
        newNode = editableVNode(node, ownerID);
        if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
        else newNode.array[idx] = value;
        return newNode;
    }
    function editableVNode(node, ownerID) {
        if (ownerID && node && ownerID === node.ownerID) return node;
        return new VNode(node ? node.array.slice() : [], ownerID);
    }
    function listNodeFor(list, rawIndex) {
        if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
        if (rawIndex < 1 << list._level + SHIFT) {
            var node = list._root;
            var level = list._level;
            while(node && level > 0){
                node = node.array[rawIndex >>> level & MASK];
                level -= SHIFT;
            }
            return node;
        }
    }
    function setListBounds(list, begin, end) {
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) end = end | 0;
        var owner = list.__ownerID || new OwnerID();
        var oldOrigin = list._origin;
        var oldCapacity = list._capacity;
        var newOrigin = oldOrigin + begin;
        var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
        if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
        // If it's going to end after it starts, it's empty.
        if (newOrigin >= newCapacity) return list.clear();
        var newLevel = list._level;
        var newRoot = list._root;
        // New origin might need creating a higher root.
        var offsetShift = 0;
        while(newOrigin + offsetShift < 0){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                undefined,
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
            offsetShift += 1 << newLevel;
        }
        if (offsetShift) {
            newOrigin += offsetShift;
            oldOrigin += offsetShift;
            newCapacity += offsetShift;
            oldCapacity += offsetShift;
        }
        var oldTailOffset = getTailOffset(oldCapacity);
        var newTailOffset = getTailOffset(newCapacity);
        // New size might need creating a higher root.
        while(newTailOffset >= 1 << newLevel + SHIFT){
            newRoot = new VNode(newRoot && newRoot.array.length ? [
                newRoot
            ] : [], owner);
            newLevel += SHIFT;
        }
        // Locate or create the new tail.
        var oldTail = list._tail;
        var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
        // Merge Tail into tree.
        if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
            newRoot = editableVNode(newRoot, owner);
            var node = newRoot;
            for(var level = newLevel; level > SHIFT; level -= SHIFT){
                var idx = oldTailOffset >>> level & MASK;
                node = node.array[idx] = editableVNode(node.array[idx], owner);
            }
            node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
        }
        // If the size has been reduced, there's a chance the tail needs to be trimmed.
        if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
        // If the new origin is within the tail, then we do not need a root.
        if (newOrigin >= newTailOffset) {
            newOrigin -= newTailOffset;
            newCapacity -= newTailOffset;
            newLevel = SHIFT;
            newRoot = null;
            newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
        // Otherwise, if the root has been trimmed, garbage collect.
        } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
            offsetShift = 0;
            // Identify the new top root node of the subtree of the old root.
            while(newRoot){
                var beginIndex = newOrigin >>> newLevel & MASK;
                if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
                if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
                newLevel -= SHIFT;
                newRoot = newRoot.array[beginIndex];
            }
            // Trim the new sides of the new root.
            if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
            if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
            if (offsetShift) {
                newOrigin -= offsetShift;
                newCapacity -= offsetShift;
            }
        }
        if (list.__ownerID) {
            list.size = newCapacity - newOrigin;
            list._origin = newOrigin;
            list._capacity = newCapacity;
            list._level = newLevel;
            list._root = newRoot;
            list._tail = newTail;
            list.__hash = undefined;
            list.__altered = true;
            return list;
        }
        return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
    }
    function mergeIntoListWith(list, merger, iterables) {
        var iters = [];
        var maxSize = 0;
        for(var ii = 0; ii < iterables.length; ii++){
            var value = iterables[ii];
            var iter = IndexedIterable(value);
            if (iter.size > maxSize) maxSize = iter.size;
            if (!isIterable(value)) iter = iter.map(function(v) {
                return fromJS(v);
            });
            iters.push(iter);
        }
        if (maxSize > list.size) list = list.setSize(maxSize);
        return mergeIntoCollectionWith(list, merger, iters);
    }
    function getTailOffset(size) {
        return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
    }
    createClass(OrderedMap, Map);
    // @pragma Construction
    function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    OrderedMap.of = function() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.wasAltered = function() {
        return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$0);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    function isOrderedMap(maybeOrderedMap) {
        return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
    }
    OrderedMap.isOrderedMap = isOrderedMap;
    OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
    OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
    function makeOrderedMap(map, list, ownerID, hash) {
        var omap = Object.create(OrderedMap.prototype);
        omap.size = map ? map.size : 0;
        omap._map = map;
        omap._list = list;
        omap.__ownerID = ownerID;
        omap.__hash = hash;
        return omap;
    }
    var EMPTY_ORDERED_MAP;
    function emptyOrderedMap() {
        return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
    }
    function updateOrderedMap(omap, k, v) {
        var map = omap._map;
        var list = omap._list;
        var i = map.get(k);
        var has = i !== undefined;
        var newMap;
        var newList;
        if (v === NOT_SET) {
            if (!has) return omap;
            if (list.size >= SIZE && list.size >= map.size * 2) {
                newList = list.filter(function(entry, idx) {
                    return entry !== undefined && i !== idx;
                });
                newMap = newList.toKeyedSeq().map(function(entry) {
                    return entry[0];
                }).flip().toMap();
                if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
            } else {
                newMap = map.remove(k);
                newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
            }
        } else if (has) {
            if (v === list.get(i)[1]) return omap;
            newMap = map;
            newList = list.set(i, [
                k,
                v
            ]);
        } else {
            newMap = map.set(k, list.size);
            newList = list.set(list.size, [
                k,
                v
            ]);
        }
        if (omap.__ownerID) {
            omap.size = newMap.size;
            omap._map = newMap;
            omap._list = newList;
            omap.__hash = undefined;
            return omap;
        }
        return makeOrderedMap(newMap, newList);
    }
    createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    ToKeyedSequence.prototype.get = function(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function() {
        var this$0 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$0._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function(mapper, context) {
        var this$0 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$0._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var ii;
        return this._iter.__iterate(this._useKeys ? function(v, k) {
            return fn(v, k, this$0);
        } : (ii = reverse ? resolveSize(this) : 0, function(v) {
            return fn(v, reverse ? --ii : ii++, this$0);
        }), reverse);
    };
    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
        if (this._useKeys) return this._iter.__iterator(type, reverse);
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var ii = reverse ? resolveSize(this) : 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
        });
    };
    ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
    createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToIndexedSequence.prototype.includes = function(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        var iterations = 0;
        return this._iter.__iterate(function(v) {
            return fn(v, iterations++, this$0);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value, step);
        });
    };
    createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    ToSetSequence.prototype.has = function(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$0);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    FromEntriesSequence.prototype.entrySeq = function() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedIterable = isIterable(entry);
                return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedIterable = isIterable(entry);
                    return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
    function flipFactory(iterable) {
        var flipSequence = makeSequence(iterable);
        flipSequence._iter = iterable;
        flipSequence.size = iterable.size;
        flipSequence.flip = function() {
            return iterable;
        };
        flipSequence.reverse = function() {
            var reversedSequence = iterable.reverse.apply(this); // super.reverse()
            reversedSequence.flip = function() {
                return iterable.reverse();
            };
            return reversedSequence;
        };
        flipSequence.has = function(key) {
            return iterable.includes(key);
        };
        flipSequence.includes = function(key) {
            return iterable.has(key);
        };
        flipSequence.cacheResult = cacheResultThrough;
        flipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(k, v, this$0) !== false;
            }, reverse);
        };
        flipSequence.__iteratorUncached = function(type, reverse) {
            if (type === ITERATE_ENTRIES) {
                var iterator = iterable.__iterator(type, reverse);
                return new Iterator(function() {
                    var step = iterator.next();
                    if (!step.done) {
                        var k = step.value[0];
                        step.value[0] = step.value[1];
                        step.value[1] = k;
                    }
                    return step;
                });
            }
            return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
        };
        return flipSequence;
    }
    function mapFactory(iterable, mapper, context) {
        var mappedSequence = makeSequence(iterable);
        mappedSequence.size = iterable.size;
        mappedSequence.has = function(key) {
            return iterable.has(key);
        };
        mappedSequence.get = function(key, notSetValue) {
            var v = iterable.get(key, NOT_SET);
            return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
        };
        mappedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k, c) {
                return fn(mapper.call(context, v, k, c), k, this$0) !== false;
            }, reverse);
        };
        mappedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
            });
        };
        return mappedSequence;
    }
    function reverseFactory(iterable, useKeys) {
        var reversedSequence = makeSequence(iterable);
        reversedSequence._iter = iterable;
        reversedSequence.size = iterable.size;
        reversedSequence.reverse = function() {
            return iterable;
        };
        if (iterable.flip) reversedSequence.flip = function() {
            var flipSequence = flipFactory(iterable);
            flipSequence.reverse = function() {
                return iterable.flip();
            };
            return flipSequence;
        };
        reversedSequence.get = function(key, notSetValue) {
            return iterable.get(useKeys ? key : -1 - key, notSetValue);
        };
        reversedSequence.has = function(key) {
            return iterable.has(useKeys ? key : -1 - key);
        };
        reversedSequence.includes = function(value) {
            return iterable.includes(value);
        };
        reversedSequence.cacheResult = cacheResultThrough;
        reversedSequence.__iterate = function(fn, reverse) {
            var this$0 = this;
            return iterable.__iterate(function(v, k) {
                return fn(v, k, this$0);
            }, !reverse);
        };
        reversedSequence.__iterator = function(type, reverse) {
            return iterable.__iterator(type, !reverse);
        };
        return reversedSequence;
    }
    function filterFactory(iterable, predicate, context, useKeys) {
        var filterSequence = makeSequence(iterable);
        if (useKeys) {
            filterSequence.has = function(key) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
            };
            filterSequence.get = function(key, notSetValue) {
                var v = iterable.get(key, NOT_SET);
                return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
            };
        }
        filterSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            }, reverse);
            return iterations;
        };
        filterSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterations = 0;
            return new Iterator(function() {
                while(true){
                    var step = iterator.next();
                    if (step.done) return step;
                    var entry = step.value;
                    var key = entry[0];
                    var value = entry[1];
                    if (predicate.call(context, value, key, iterable)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
                }
            });
        };
        return filterSequence;
    }
    function countByFactory(iterable, grouper, context) {
        var groups = Map().asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), 0, function(a) {
                return a + 1;
            });
        });
        return groups.asImmutable();
    }
    function groupByFactory(iterable, grouper, context) {
        var isKeyedIter = isKeyed(iterable);
        var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
        iterable.__iterate(function(v, k) {
            groups.update(grouper.call(context, v, k, iterable), function(a) {
                return a = a || [], a.push(isKeyedIter ? [
                    k,
                    v
                ] : v), a;
            });
        });
        var coerce = iterableClass(iterable);
        return groups.map(function(arr) {
            return reify(iterable, coerce(arr));
        });
    }
    function sliceFactory(iterable, begin, end, useKeys) {
        var originalSize = iterable.size;
        // Sanitize begin & end using this shorthand for ToInt32(argument)
        // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
        if (begin !== undefined) begin = begin | 0;
        if (end !== undefined) {
            if (end === Infinity) end = originalSize;
            else end = end | 0;
        }
        if (wholeSlice(begin, end, originalSize)) return iterable;
        var resolvedBegin = resolveBegin(begin, originalSize);
        var resolvedEnd = resolveEnd(end, originalSize);
        // begin or end will be NaN if they were provided as negative numbers and
        // this iterable's size is unknown. In that case, cache first so there is
        // a known size and these do not resolve to NaN.
        if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
        // Note: resolvedEnd is undefined when the original sequence's length is
        // unknown and this slice did not supply an end and should contain all
        // elements after resolvedBegin.
        // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
        var resolvedSize = resolvedEnd - resolvedBegin;
        var sliceSize;
        if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
        var sliceSeq = makeSequence(iterable);
        // If iterable.size is undefined, the size of the realized sliceSeq is
        // unknown at this point unless the number of items to slice is 0
        sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
        if (!useKeys && isSeq(iterable) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
        };
        sliceSeq.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (sliceSize === 0) return 0;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var skipped = 0;
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
                }
            });
            return iterations;
        };
        sliceSeq.__iteratorUncached = function(type, reverse) {
            if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
            // Don't bother instantiating parent iterator if taking 0.
            var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
            var skipped = 0;
            var iterations = 0;
            return new Iterator(function() {
                while(skipped++ < resolvedBegin)iterator.next();
                if (++iterations > sliceSize) return iteratorDone();
                var step = iterator.next();
                if (useKeys || type === ITERATE_VALUES) return step;
                else if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
                else return iteratorValue(type, iterations - 1, step.value[1], step);
            });
        };
        return sliceSeq;
    }
    function takeWhileFactory(iterable, predicate, context) {
        var takeSequence = makeSequence(iterable);
        takeSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
            });
            return iterations;
        };
        takeSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var iterating = true;
            return new Iterator(function() {
                if (!iterating) return iteratorDone();
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var k = entry[0];
                var v = entry[1];
                if (!predicate.call(context, v, k, this$0)) {
                    iterating = false;
                    return iteratorDone();
                }
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return takeSequence;
    }
    function skipWhileFactory(iterable, predicate, context, useKeys) {
        var skipSequence = makeSequence(iterable);
        skipSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterate(fn, reverse);
            var isSkipping = true;
            var iterations = 0;
            iterable.__iterate(function(v, k, c) {
                if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                    iterations++;
                    return fn(v, useKeys ? k : iterations - 1, this$0);
                }
            });
            return iterations;
        };
        skipSequence.__iteratorUncached = function(type, reverse) {
            var this$0 = this;
            if (reverse) return this.cacheResult().__iterator(type, reverse);
            var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
            var skipping = true;
            var iterations = 0;
            return new Iterator(function() {
                var step, k, v;
                do {
                    step = iterator.next();
                    if (step.done) {
                        if (useKeys || type === ITERATE_VALUES) return step;
                        else if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                        else return iteratorValue(type, iterations++, step.value[1], step);
                    }
                    var entry = step.value;
                    k = entry[0];
                    v = entry[1];
                    skipping && (skipping = predicate.call(context, v, k, this$0));
                }while (skipping);
                return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
            });
        };
        return skipSequence;
    }
    function concatFactory(iterable, values) {
        var isKeyedIterable = isKeyed(iterable);
        var iters = [
            iterable
        ].concat(values).map(function(v) {
            if (!isIterable(v)) v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
                v
            ]);
            else if (isKeyedIterable) v = KeyedIterable(v);
            return v;
        }).filter(function(v) {
            return v.size !== 0;
        });
        if (iters.length === 0) return iterable;
        if (iters.length === 1) {
            var singleton = iters[0];
            if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) return singleton;
        }
        var concatSeq = new ArraySeq(iters);
        if (isKeyedIterable) concatSeq = concatSeq.toKeyedSeq();
        else if (!isIndexed(iterable)) concatSeq = concatSeq.toSetSeq();
        concatSeq = concatSeq.flatten(true);
        concatSeq.size = iters.reduce(function(sum, seq) {
            if (sum !== undefined) {
                var size = seq.size;
                if (size !== undefined) return sum + size;
            }
        }, 0);
        return concatSeq;
    }
    function flattenFactory(iterable, depth, useKeys) {
        var flatSequence = makeSequence(iterable);
        flatSequence.__iterateUncached = function(fn, reverse) {
            var iterations = 0;
            var stopped = false;
            function flatDeep(iter, currentDepth) {
                var this$0 = this;
                iter.__iterate(function(v, k) {
                    if ((!depth || currentDepth < depth) && isIterable(v)) flatDeep(v, currentDepth + 1);
                    else if (fn(v, useKeys ? k : iterations++, this$0) === false) stopped = true;
                    return !stopped;
                }, reverse);
            }
            flatDeep(iterable, 0);
            return iterations;
        };
        flatSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(type, reverse);
            var stack = [];
            var iterations = 0;
            return new Iterator(function() {
                while(iterator){
                    var step = iterator.next();
                    if (step.done !== false) {
                        iterator = stack.pop();
                        continue;
                    }
                    var v = step.value;
                    if (type === ITERATE_ENTRIES) v = v[1];
                    if ((!depth || stack.length < depth) && isIterable(v)) {
                        stack.push(iterator);
                        iterator = v.__iterator(type, reverse);
                    } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
                }
                return iteratorDone();
            });
        };
        return flatSequence;
    }
    function flatMapFactory(iterable, mapper, context) {
        var coerce = iterableClass(iterable);
        return iterable.toSeq().map(function(v, k) {
            return coerce(mapper.call(context, v, k, iterable));
        }).flatten(true);
    }
    function interposeFactory(iterable, separator) {
        var interposedSequence = makeSequence(iterable);
        interposedSequence.size = iterable.size && iterable.size * 2 - 1;
        interposedSequence.__iterateUncached = function(fn, reverse) {
            var this$0 = this;
            var iterations = 0;
            iterable.__iterate(function(v, k) {
                return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
            }, reverse);
            return iterations;
        };
        interposedSequence.__iteratorUncached = function(type, reverse) {
            var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
            var iterations = 0;
            var step;
            return new Iterator(function() {
                if (!step || iterations % 2) {
                    step = iterator.next();
                    if (step.done) return step;
                }
                return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
            });
        };
        return interposedSequence;
    }
    function sortFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        var isKeyedIterable = isKeyed(iterable);
        var index = 0;
        var entries = iterable.toSeq().map(function(v, k) {
            return [
                k,
                v,
                index++,
                mapper ? mapper(v, k, iterable) : v
            ];
        }).toArray();
        entries.sort(function(a, b) {
            return comparator(a[3], b[3]) || a[2] - b[2];
        }).forEach(isKeyedIterable ? function(v, i) {
            entries[i].length = 2;
        } : function(v, i) {
            entries[i] = v[1];
        });
        return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
    }
    function maxFactory(iterable, comparator, mapper) {
        if (!comparator) comparator = defaultComparator;
        if (mapper) {
            var entry = iterable.toSeq().map(function(v, k) {
                return [
                    v,
                    mapper(v, k, iterable)
                ];
            }).reduce(function(a, b) {
                return maxCompare(comparator, a[1], b[1]) ? b : a;
            });
            return entry && entry[0];
        } else return iterable.reduce(function(a, b) {
            return maxCompare(comparator, a, b) ? b : a;
        });
    }
    function maxCompare(comparator, a, b) {
        var comp = comparator(b, a);
        // b is considered the new max if the comparator declares them equal, but
        // they are not equal and b is in fact a nullish value.
        return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
    }
    function zipWithFactory(keyIter, zipper, iters) {
        var zipSequence = makeSequence(keyIter);
        zipSequence.size = new ArraySeq(iters).map(function(i) {
            return i.size;
        }).min();
        // Note: this a generic base implementation of __iterate in terms of
        // __iterator which may be more generically useful in the future.
        zipSequence.__iterate = function(fn, reverse) {
            /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */ // indexed:
            var iterator = this.__iterator(ITERATE_VALUES, reverse);
            var step;
            var iterations = 0;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
            return iterations;
        };
        zipSequence.__iteratorUncached = function(type, reverse) {
            var iterators = iters.map(function(i) {
                return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
            });
            var iterations = 0;
            var isDone = false;
            return new Iterator(function() {
                var steps;
                if (!isDone) {
                    steps = iterators.map(function(i) {
                        return i.next();
                    });
                    isDone = steps.some(function(s) {
                        return s.done;
                    });
                }
                if (isDone) return iteratorDone();
                return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                    return s.value;
                })));
            });
        };
        return zipSequence;
    }
    // #pragma Helper Functions
    function reify(iter, seq) {
        return isSeq(iter) ? seq : iter.constructor(seq);
    }
    function validateEntry(entry) {
        if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
    function resolveSize(iter) {
        assertNotInfinite(iter.size);
        return ensureSize(iter);
    }
    function iterableClass(iterable) {
        return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
    }
    function makeSequence(iterable) {
        return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
    }
    function cacheResultThrough() {
        if (this._iter.cacheResult) {
            this._iter.cacheResult();
            this.size = this._iter.size;
            return this;
        } else return Seq.prototype.cacheResult.call(this);
    }
    function defaultComparator(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    function forceIterator(keyPath) {
        var iter = getIterator(keyPath);
        if (!iter) {
            // Array might not be iterable in this environment, so we need a fallback
            // to our wrapped type.
            if (!isArrayLike(keyPath)) throw new TypeError('Expected iterable or array-like: ' + keyPath);
            iter = getIterator(Iterable(keyPath));
        }
        return iter;
    }
    createClass(Record, KeyedCollection);
    function Record(defaultValues, name) {
        var hasInitialized;
        var RecordType = function Record(values) {
            if (values instanceof RecordType) return values;
            if (!(this instanceof RecordType)) return new RecordType(values);
            if (!hasInitialized) {
                hasInitialized = true;
                var keys = Object.keys(defaultValues);
                setProps(RecordTypePrototype, keys);
                RecordTypePrototype.size = keys.length;
                RecordTypePrototype._name = name;
                RecordTypePrototype._keys = keys;
                RecordTypePrototype._defaultValues = defaultValues;
            }
            this._map = Map(values);
        };
        var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
        RecordTypePrototype.constructor = RecordType;
        return RecordType;
    }
    Record.prototype.toString = function() {
        return this.__toString(recordName(this) + ' {', '}');
    };
    // @pragma Access
    Record.prototype.has = function(k) {
        return this._defaultValues.hasOwnProperty(k);
    };
    Record.prototype.get = function(k, notSetValue) {
        if (!this.has(k)) return notSetValue;
        var defaultVal = this._defaultValues[k];
        return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };
    // @pragma Modification
    Record.prototype.clear = function() {
        if (this.__ownerID) {
            this._map && this._map.clear();
            return this;
        }
        var RecordType = this.constructor;
        return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };
    Record.prototype.set = function(k, v) {
        if (!this.has(k)) throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
        if (this._map && !this._map.has(k)) {
            var defaultVal = this._defaultValues[k];
            if (v === defaultVal) return this;
        }
        var newMap = this._map && this._map.set(k, v);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.remove = function(k) {
        if (!this.has(k)) return this;
        var newMap = this._map && this._map.remove(k);
        if (this.__ownerID || newMap === this._map) return this;
        return makeRecord(this, newMap);
    };
    Record.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Record.prototype.__iterator = function(type, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterator(type, reverse);
    };
    Record.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return KeyedIterable(this._defaultValues).map(function(_, k) {
            return this$0.get(k);
        }).__iterate(fn, reverse);
    };
    Record.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map && this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return makeRecord(this, newMap, ownerID);
    };
    var RecordPrototype = Record.prototype;
    RecordPrototype[DELETE] = RecordPrototype.remove;
    RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
    RecordPrototype.merge = MapPrototype.merge;
    RecordPrototype.mergeWith = MapPrototype.mergeWith;
    RecordPrototype.mergeIn = MapPrototype.mergeIn;
    RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
    RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
    RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
    RecordPrototype.setIn = MapPrototype.setIn;
    RecordPrototype.update = MapPrototype.update;
    RecordPrototype.updateIn = MapPrototype.updateIn;
    RecordPrototype.withMutations = MapPrototype.withMutations;
    RecordPrototype.asMutable = MapPrototype.asMutable;
    RecordPrototype.asImmutable = MapPrototype.asImmutable;
    function makeRecord(likeRecord, map, ownerID) {
        var record = Object.create(Object.getPrototypeOf(likeRecord));
        record._map = map;
        record.__ownerID = ownerID;
        return record;
    }
    function recordName(record) {
        return record._name || record.constructor.name || 'Record';
    }
    function setProps(prototype, names) {
        try {
            names.forEach(setProp.bind(undefined, prototype));
        } catch (error) {
        // Object.defineProperty failed. Probably IE8.
        }
    }
    function setProp(prototype, name) {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    }
    createClass(Set, SetCollection);
    // @pragma Construction
    function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    Set.of = function() {
        return this(arguments);
    };
    Set.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    Set.prototype.toString = function() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function(value) {
        return updateSet(this, this._map.set(value, true));
    };
    Set.prototype.remove = function(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.union = function() {
        var iters = SLICE$0.call(arguments, 0);
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)SetIterable(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (!iters.every(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function() {
        var iters = SLICE$0.call(arguments, 0);
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetIterable(iter);
        });
        var originalSet = this;
        return this.withMutations(function(set) {
            originalSet.forEach(function(value) {
                if (iters.some(function(iter) {
                    return iter.includes(value);
                })) set.remove(value);
            });
        });
    };
    Set.prototype.merge = function() {
        return this.union.apply(this, arguments);
    };
    Set.prototype.mergeWith = function(merger) {
        var iters = SLICE$0.call(arguments, 1);
        return this.union.apply(this, iters);
    };
    Set.prototype.sort = function(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function(fn, reverse) {
        var this$0 = this;
        return this._map.__iterate(function(_, k) {
            return fn(k, k, this$0);
        }, reverse);
    };
    Set.prototype.__iterator = function(type, reverse) {
        return this._map.map(function(_, k) {
            return k;
        }).__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    function isSet(maybeSet) {
        return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
    }
    Set.isSet = isSet;
    var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
    var SetPrototype = Set.prototype;
    SetPrototype[IS_SET_SENTINEL] = true;
    SetPrototype[DELETE] = SetPrototype.remove;
    SetPrototype.mergeDeep = SetPrototype.merge;
    SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
    SetPrototype.withMutations = MapPrototype.withMutations;
    SetPrototype.asMutable = MapPrototype.asMutable;
    SetPrototype.asImmutable = MapPrototype.asImmutable;
    SetPrototype.__empty = emptySet;
    SetPrototype.__make = makeSet;
    function updateSet(set, newMap) {
        if (set.__ownerID) {
            set.size = newMap.size;
            set._map = newMap;
            return set;
        }
        return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
    }
    function makeSet(map, ownerID) {
        var set = Object.create(SetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_SET;
    function emptySet() {
        return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
    }
    createClass(OrderedSet, Set);
    // @pragma Construction
    function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetIterable(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    OrderedSet.of = function() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function(value) {
        return this(KeyedIterable(value).keySeq());
    };
    OrderedSet.prototype.toString = function() {
        return this.__toString('OrderedSet {', '}');
    };
    function isOrderedSet(maybeOrderedSet) {
        return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
    }
    OrderedSet.isOrderedSet = isOrderedSet;
    var OrderedSetPrototype = OrderedSet.prototype;
    OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
    OrderedSetPrototype.__empty = emptyOrderedSet;
    OrderedSetPrototype.__make = makeOrderedSet;
    function makeOrderedSet(map, ownerID) {
        var set = Object.create(OrderedSetPrototype);
        set.size = map ? map.size : 0;
        set._map = map;
        set.__ownerID = ownerID;
        return set;
    }
    var EMPTY_ORDERED_SET;
    function emptyOrderedSet() {
        return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
    }
    createClass(Stack, IndexedCollection);
    // @pragma Construction
    function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
    }
    Stack.of = function() {
        return this(arguments);
    };
    Stack.prototype.toString = function() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function() {
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function(iter) {
        iter = IndexedIterable(iter);
        if (iter.size === 0) return this;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.reverse().forEach(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        });
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function() {
        return this.slice(1);
    };
    Stack.prototype.unshift = function() {
        return this.push.apply(this, arguments);
    };
    Stack.prototype.unshiftAll = function(iter) {
        return this.pushAll(iter);
    };
    Stack.prototype.shift = function() {
        return this.pop.apply(this, arguments);
    };
    Stack.prototype.clear = function() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function(fn, reverse) {
        if (reverse) return this.reverse().__iterate(fn);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function(type, reverse) {
        if (reverse) return this.reverse().__iterator(type);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    function isStack(maybeStack) {
        return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
    }
    Stack.isStack = isStack;
    var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
    var StackPrototype = Stack.prototype;
    StackPrototype[IS_STACK_SENTINEL] = true;
    StackPrototype.withMutations = MapPrototype.withMutations;
    StackPrototype.asMutable = MapPrototype.asMutable;
    StackPrototype.asImmutable = MapPrototype.asImmutable;
    StackPrototype.wasAltered = MapPrototype.wasAltered;
    function makeStack(size, head, ownerID, hash) {
        var map = Object.create(StackPrototype);
        map.size = size;
        map._head = head;
        map.__ownerID = ownerID;
        map.__hash = hash;
        map.__altered = false;
        return map;
    }
    var EMPTY_STACK;
    function emptyStack() {
        return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
    }
    /**
   * Contributes additional methods to a constructor
   */ function mixin(ctor, methods) {
        var keyCopier = function(key) {
            ctor.prototype[key] = methods[key];
        };
        Object.keys(methods).forEach(keyCopier);
        Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
        return ctor;
    }
    Iterable.Iterator = Iterator;
    mixin(Iterable, {
        // ### Conversion to other types
        toArray: function() {
            assertNotInfinite(this.size);
            var array = new Array(this.size || 0);
            this.valueSeq().__iterate(function(v, i) {
                array[i] = v;
            });
            return array;
        },
        toIndexedSeq: function() {
            return new ToIndexedSequence(this);
        },
        toJS: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJS === 'function' ? value.toJS() : value;
            }).__toJS();
        },
        toJSON: function() {
            return this.toSeq().map(function(value) {
                return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
            }).__toJS();
        },
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, true);
        },
        toMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return Map(this.toKeyedSeq());
        },
        toObject: function() {
            assertNotInfinite(this.size);
            var object = {};
            this.__iterate(function(v, k) {
                object[k] = v;
            });
            return object;
        },
        toOrderedMap: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedMap(this.toKeyedSeq());
        },
        toOrderedSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
        },
        toSet: function() {
            // Use Late Binding here to solve the circular dependency.
            return Set(isKeyed(this) ? this.valueSeq() : this);
        },
        toSetSeq: function() {
            return new ToSetSequence(this);
        },
        toSeq: function() {
            return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
        },
        toStack: function() {
            // Use Late Binding here to solve the circular dependency.
            return Stack(isKeyed(this) ? this.valueSeq() : this);
        },
        toList: function() {
            // Use Late Binding here to solve the circular dependency.
            return List(isKeyed(this) ? this.valueSeq() : this);
        },
        // ### Common JavaScript methods and properties
        toString: function() {
            return '[Iterable]';
        },
        __toString: function(head, tail) {
            if (this.size === 0) return head + tail;
            return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        concat: function() {
            var values = SLICE$0.call(arguments, 0);
            return reify(this, concatFactory(this, values));
        },
        includes: function(searchValue) {
            return this.some(function(value) {
                return is(value, searchValue);
            });
        },
        entries: function() {
            return this.__iterator(ITERATE_ENTRIES);
        },
        every: function(predicate, context) {
            assertNotInfinite(this.size);
            var returnValue = true;
            this.__iterate(function(v, k, c) {
                if (!predicate.call(context, v, k, c)) {
                    returnValue = false;
                    return false;
                }
            });
            return returnValue;
        },
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, true));
        },
        find: function(predicate, context, notSetValue) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[1] : notSetValue;
        },
        forEach: function(sideEffect, context) {
            assertNotInfinite(this.size);
            return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
        },
        join: function(separator) {
            assertNotInfinite(this.size);
            separator = separator !== undefined ? '' + separator : ',';
            var joined = '';
            var isFirst = true;
            this.__iterate(function(v) {
                isFirst ? isFirst = false : joined += separator;
                joined += v !== null && v !== undefined ? v.toString() : '';
            });
            return joined;
        },
        keys: function() {
            return this.__iterator(ITERATE_KEYS);
        },
        map: function(mapper, context) {
            return reify(this, mapFactory(this, mapper, context));
        },
        reduce: function(reducer, initialReduction, context) {
            assertNotInfinite(this.size);
            var reduction;
            var useFirst;
            if (arguments.length < 2) useFirst = true;
            else reduction = initialReduction;
            this.__iterate(function(v, k, c) {
                if (useFirst) {
                    useFirst = false;
                    reduction = v;
                } else reduction = reducer.call(context, reduction, v, k, c);
            });
            return reduction;
        },
        reduceRight: function(reducer, initialReduction, context) {
            var reversed = this.toKeyedSeq().reverse();
            return reversed.reduce.apply(reversed, arguments);
        },
        reverse: function() {
            return reify(this, reverseFactory(this, true));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, true));
        },
        some: function(predicate, context) {
            return !this.every(not(predicate), context);
        },
        sort: function(comparator) {
            return reify(this, sortFactory(this, comparator));
        },
        values: function() {
            return this.__iterator(ITERATE_VALUES);
        },
        // ### More sequential methods
        butLast: function() {
            return this.slice(0, -1);
        },
        isEmpty: function() {
            return this.size !== undefined ? this.size === 0 : !this.some(function() {
                return true;
            });
        },
        count: function(predicate, context) {
            return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
        },
        countBy: function(grouper, context) {
            return countByFactory(this, grouper, context);
        },
        equals: function(other) {
            return deepEqual(this, other);
        },
        entrySeq: function() {
            var iterable = this;
            if (iterable._cache) // We cache as an entries array, so we can just return the cache!
            return new ArraySeq(iterable._cache);
            var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
            entriesSequence.fromEntrySeq = function() {
                return iterable.toSeq();
            };
            return entriesSequence;
        },
        filterNot: function(predicate, context) {
            return this.filter(not(predicate), context);
        },
        findEntry: function(predicate, context, notSetValue) {
            var found = notSetValue;
            this.__iterate(function(v, k, c) {
                if (predicate.call(context, v, k, c)) {
                    found = [
                        k,
                        v
                    ];
                    return false;
                }
            });
            return found;
        },
        findKey: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry && entry[0];
        },
        findLast: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
        },
        findLastEntry: function(predicate, context, notSetValue) {
            return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
        },
        findLastKey: function(predicate, context) {
            return this.toKeyedSeq().reverse().findKey(predicate, context);
        },
        first: function() {
            return this.find(returnTrue);
        },
        flatMap: function(mapper, context) {
            return reify(this, flatMapFactory(this, mapper, context));
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, true));
        },
        fromEntrySeq: function() {
            return new FromEntriesSequence(this);
        },
        get: function(searchKey, notSetValue) {
            return this.find(function(_, key) {
                return is(key, searchKey);
            }, undefined, notSetValue);
        },
        getIn: function(searchKeyPath, notSetValue) {
            var nested = this;
            // Note: in an ES6 environment, we would prefer:
            // for (var key of searchKeyPath) {
            var iter = forceIterator(searchKeyPath);
            var step;
            while(!(step = iter.next()).done){
                var key = step.value;
                nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
                if (nested === NOT_SET) return notSetValue;
            }
            return nested;
        },
        groupBy: function(grouper, context) {
            return groupByFactory(this, grouper, context);
        },
        has: function(searchKey) {
            return this.get(searchKey, NOT_SET) !== NOT_SET;
        },
        hasIn: function(searchKeyPath) {
            return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
        },
        isSubset: function(iter) {
            iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
            return this.every(function(value) {
                return iter.includes(value);
            });
        },
        isSuperset: function(iter) {
            iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
            return iter.isSubset(this);
        },
        keyOf: function(searchValue) {
            return this.findKey(function(value) {
                return is(value, searchValue);
            });
        },
        keySeq: function() {
            return this.toSeq().map(keyMapper).toIndexedSeq();
        },
        last: function() {
            return this.toSeq().reverse().first();
        },
        lastKeyOf: function(searchValue) {
            return this.toKeyedSeq().reverse().keyOf(searchValue);
        },
        max: function(comparator) {
            return maxFactory(this, comparator);
        },
        maxBy: function(mapper, comparator) {
            return maxFactory(this, comparator, mapper);
        },
        min: function(comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
        },
        minBy: function(mapper, comparator) {
            return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
        },
        rest: function() {
            return this.slice(1);
        },
        skip: function(amount) {
            return this.slice(Math.max(0, amount));
        },
        skipLast: function(amount) {
            return reify(this, this.toSeq().reverse().skip(amount).reverse());
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, true));
        },
        skipUntil: function(predicate, context) {
            return this.skipWhile(not(predicate), context);
        },
        sortBy: function(mapper, comparator) {
            return reify(this, sortFactory(this, comparator, mapper));
        },
        take: function(amount) {
            return this.slice(0, Math.max(0, amount));
        },
        takeLast: function(amount) {
            return reify(this, this.toSeq().reverse().take(amount).reverse());
        },
        takeWhile: function(predicate, context) {
            return reify(this, takeWhileFactory(this, predicate, context));
        },
        takeUntil: function(predicate, context) {
            return this.takeWhile(not(predicate), context);
        },
        valueSeq: function() {
            return this.toIndexedSeq();
        },
        // ### Hashable Object
        hashCode: function() {
            return this.__hash || (this.__hash = hashIterable(this));
        }
    });
    // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
    // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
    // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
    // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
    var IterablePrototype = Iterable.prototype;
    IterablePrototype[IS_ITERABLE_SENTINEL] = true;
    IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
    IterablePrototype.__toJS = IterablePrototype.toArray;
    IterablePrototype.__toStringMapper = quoteString;
    IterablePrototype.inspect = IterablePrototype.toSource = function() {
        return this.toString();
    };
    IterablePrototype.chain = IterablePrototype.flatMap;
    IterablePrototype.contains = IterablePrototype.includes;
    mixin(KeyedIterable, {
        // ### More sequential methods
        flip: function() {
            return reify(this, flipFactory(this));
        },
        mapEntries: function(mapper, context) {
            var this$0 = this;
            var iterations = 0;
            return reify(this, this.toSeq().map(function(v, k) {
                return mapper.call(context, [
                    k,
                    v
                ], iterations++, this$0);
            }).fromEntrySeq());
        },
        mapKeys: function(mapper, context) {
            var this$0 = this;
            return reify(this, this.toSeq().flip().map(function(k, v) {
                return mapper.call(context, k, v, this$0);
            }).flip());
        }
    });
    var KeyedIterablePrototype = KeyedIterable.prototype;
    KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
    KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
    KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
    KeyedIterablePrototype.__toStringMapper = function(v, k) {
        return JSON.stringify(k) + ': ' + quoteString(v);
    };
    mixin(IndexedIterable, {
        // ### Conversion to other types
        toKeyedSeq: function() {
            return new ToKeyedSequence(this, false);
        },
        // ### ES6 Collection methods (ES6 Array and Map)
        filter: function(predicate, context) {
            return reify(this, filterFactory(this, predicate, context, false));
        },
        findIndex: function(predicate, context) {
            var entry = this.findEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        indexOf: function(searchValue) {
            var key = this.keyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        lastIndexOf: function(searchValue) {
            var key = this.lastKeyOf(searchValue);
            return key === undefined ? -1 : key;
        },
        reverse: function() {
            return reify(this, reverseFactory(this, false));
        },
        slice: function(begin, end) {
            return reify(this, sliceFactory(this, begin, end, false));
        },
        splice: function(index, removeNum /*, ...values*/ ) {
            var numArgs = arguments.length;
            removeNum = Math.max(removeNum | 0, 0);
            if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
            // If index is negative, it should resolve relative to the size of the
            // collection. However size may be expensive to compute if not cached, so
            // only call count() if the number is in fact negative.
            index = resolveBegin(index, index < 0 ? this.count() : this.size);
            var spliced = this.slice(0, index);
            return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
        },
        // ### More collection methods
        findLastIndex: function(predicate, context) {
            var entry = this.findLastEntry(predicate, context);
            return entry ? entry[0] : -1;
        },
        first: function() {
            return this.get(0);
        },
        flatten: function(depth) {
            return reify(this, flattenFactory(this, depth, false));
        },
        get: function(index, notSetValue) {
            index = wrapIndex(this, index);
            return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
                return key === index;
            }, undefined, notSetValue);
        },
        has: function(index) {
            index = wrapIndex(this, index);
            return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
        },
        interpose: function(separator) {
            return reify(this, interposeFactory(this, separator));
        },
        interleave: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
            var interleaved = zipped.flatten(true);
            if (zipped.size) interleaved.size = zipped.size * iterables.length;
            return reify(this, interleaved);
        },
        keySeq: function() {
            return Range(0, this.size);
        },
        last: function() {
            return this.get(-1);
        },
        skipWhile: function(predicate, context) {
            return reify(this, skipWhileFactory(this, predicate, context, false));
        },
        zip: function() {
            var iterables = [
                this
            ].concat(arrCopy(arguments));
            return reify(this, zipWithFactory(this, defaultZipper, iterables));
        },
        zipWith: function(zipper /*, ...iterables */ ) {
            var iterables = arrCopy(arguments);
            iterables[0] = this;
            return reify(this, zipWithFactory(this, zipper, iterables));
        }
    });
    IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
    IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
    mixin(SetIterable, {
        // ### ES6 Collection methods (ES6 Array and Map)
        get: function(value, notSetValue) {
            return this.has(value) ? value : notSetValue;
        },
        includes: function(value) {
            return this.has(value);
        },
        // ### More sequential methods
        keySeq: function() {
            return this.valueSeq();
        }
    });
    SetIterable.prototype.has = IterablePrototype.includes;
    SetIterable.prototype.contains = SetIterable.prototype.includes;
    // Mixin subclasses
    mixin(KeyedSeq, KeyedIterable.prototype);
    mixin(IndexedSeq, IndexedIterable.prototype);
    mixin(SetSeq, SetIterable.prototype);
    mixin(KeyedCollection, KeyedIterable.prototype);
    mixin(IndexedCollection, IndexedIterable.prototype);
    mixin(SetCollection, SetIterable.prototype);
    // #pragma Helper functions
    function keyMapper(v, k) {
        return k;
    }
    function entryMapper(v, k) {
        return [
            k,
            v
        ];
    }
    function not(predicate) {
        return function() {
            return !predicate.apply(this, arguments);
        };
    }
    function neg(predicate) {
        return function() {
            return -predicate.apply(this, arguments);
        };
    }
    function quoteString(value) {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    }
    function defaultZipper() {
        return arrCopy(arguments);
    }
    function defaultNegComparator(a, b) {
        return a < b ? 1 : a > b ? -1 : 0;
    }
    function hashIterable(iterable) {
        if (iterable.size === Infinity) return 0;
        var ordered = isOrdered(iterable);
        var keyed = isKeyed(iterable);
        var h = ordered ? 1 : 0;
        var size = iterable.__iterate(keyed ? ordered ? function(v, k) {
            h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
        } : function(v, k) {
            h = h + hashMerge(hash(v), hash(k)) | 0;
        } : ordered ? function(v) {
            h = 31 * h + hash(v) | 0;
        } : function(v) {
            h = h + hash(v) | 0;
        });
        return murmurHashOfSize(size, h);
    }
    function murmurHashOfSize(size, h) {
        h = imul(h, 0xCC9E2D51);
        h = imul(h << 15 | h >>> -15, 0x1B873593);
        h = imul(h << 13 | h >>> -13, 5);
        h = (h + 0xE6546B64 | 0) ^ size;
        h = imul(h ^ h >>> 16, 0x85EBCA6B);
        h = imul(h ^ h >>> 13, 0xC2B2AE35);
        h = smi(h ^ h >>> 16);
        return h;
    }
    function hashMerge(a, b) {
        return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
    }
    var Immutable = {
        Iterable: Iterable,
        Seq: Seq,
        Collection: Collection,
        Map: Map,
        OrderedMap: OrderedMap,
        List: List,
        Stack: Stack,
        Set: Set,
        OrderedSet: OrderedSet,
        Record: Record,
        Range: Range,
        Repeat: Repeat,
        is: is,
        fromJS: fromJS
    };
    return Immutable;
});

},{}],"eYQTI":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function defaultEqualityCheck(a, b) {
    return a === b;
}
function defaultMemoize(func) {
    var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (lastArgs === null || lastArgs.length !== args.length || !args.every(function(value, index) {
            return equalityCheck(value, lastArgs[index]);
        })) lastResult = func.apply(undefined, args);
        lastArgs = args;
        return lastResult;
    };
}
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)memoizeOptions[_key2 - 1] = arguments[_key2];
    return function() {
        for(var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)funcs[_key3] = arguments[_key3];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                return resultFunc.apply(undefined, arguments);
            }
        ].concat(memoizeOptions));
        var selector = function selector(state, props) {
            for(var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++)args[_key4 - 2] = arguments[_key4];
            var params = dependencies.map(function(dependency) {
                return dependency.apply(undefined, [
                    state,
                    props
                ].concat(args));
            });
            return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
        };
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
function createStructuredSelector(selectors) {
    var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++)values[_key5] = arguments[_key5];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

},{}],"2FF4q":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = 9007199254740991;

},{}],"kAOrs":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.valueOrResult = valueOrResult;
function valueOrResult(arg) {
    if (typeof arg === 'function') {
        for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return arg.apply(null, args);
    }
    return arg;
}

},{}],"6rGqh":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("699ce758a864c7f4");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("3843e7b2e38c3a55");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ColumnDefinition = function(_Component) {
    _inherits(ColumnDefinition, _Component);
    function ColumnDefinition() {
        _classCallCheck(this, ColumnDefinition);
        return _possibleConstructorReturn(this, (ColumnDefinition.__proto__ || Object.getPrototypeOf(ColumnDefinition)).apply(this, arguments));
    }
    _createClass(ColumnDefinition, [
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return ColumnDefinition;
}(_react.Component);
ColumnDefinition.propTypes = {
    //The name of the column that this definition applies to.
    id: _propTypes2.default.string.isRequired,
    //The order that this column appears in. If not specified will just use the order that they are defined
    order: _propTypes2.default.number,
    //Determines whether or not the user can disable this column from the settings.
    locked: _propTypes2.default.bool,
    //The css class name, or a function to generate a class name from props, to apply to the header for the column.
    headerCssClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.func
    ]),
    //The css class name, or a function to generate a class name from props, to apply to this column.
    cssClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.func
    ]),
    //The display name for the column. This is used when the name in the column heading and settings should be different from the data passed in to the Griddle component.
    title: _propTypes2.default.string,
    //The component that should be rendered instead of the standard column data. This component will still be rendered inside of a TD element.
    customComponent: _propTypes2.default.func,
    //The component that should be used instead of the normal title
    customHeadingComponent: _propTypes2.default.func,
    //Can this column be filtered
    filterable: _propTypes2.default.bool,
    //Can this column be sorted
    sortable: _propTypes2.default.bool,
    //What sort type this column uses - magic string :shame:
    sortType: _propTypes2.default.string,
    //Any extra data that should be passed to each instance of this column
    extraData: _propTypes2.default.object,
    //The width of this column -- this is string so things like % can be specified
    width: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.number
    ]),
    //The number of cells this column should extend. Default is 1.
    colSpan: _propTypes2.default.number,
    // Is this column visible
    visible: _propTypes2.default.bool,
    // Is this column metadta
    isMetadata: _propTypes2.default.bool
};
exports.default = ColumnDefinition;

},{"699ce758a864c7f4":"9njXz","3843e7b2e38c3a55":"bnNSm"}],"jLslG":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("dbbc423dfb0170fc");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Row = function Row(_ref) {
    var Cell = _ref.Cell, griddleKey = _ref.griddleKey, columnIds = _ref.columnIds, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, style = _ref.style, className = _ref.className;
    return _react2.default.createElement('tr', {
        key: griddleKey,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: style,
        className: className
    }, columnIds && columnIds.map(function(c) {
        return _react2.default.createElement(Cell, {
            key: c + '-' + griddleKey,
            griddleKey: griddleKey,
            columnId: c,
            style: style,
            className: className
        });
    }));
};
exports.default = Row;

},{"dbbc423dfb0170fc":"9njXz"}],"eLiQT":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("cecb4522eb1effa7");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("cc88d1a43014b324");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("636e3d7d5c6797");
var _compose = require("79a00d678e69889e");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("a0a0b8f3afe4016b");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("cfaecbea4b6c3a5");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("2754ff8f43d8c64b");
var _valueUtils = require("dd239cac1d4c9580");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var ComposedRowContainer = function ComposedRowContainer(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            columnIds: (0, _dataSelectors.columnIdsSelector)(state),
            rowProperties: (0, _dataSelectors.rowPropertiesSelector)(state),
            rowData: (0, _dataSelectors.rowDataSelector)(state, props),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Row'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Row')
        };
    }), (0, _mapProps2.default)(function(props) {
        var components = props.components, rowProperties = props.rowProperties, className = props.className, otherProps = _objectWithoutProperties(props, [
            'components',
            'rowProperties',
            'className'
        ]);
        return _extends({
            Cell: components.Cell,
            className: (0, _valueUtils.valueOrResult)(rowProperties.cssClassName, props) || props.className
        }, otherProps);
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = ComposedRowContainer;

},{"cecb4522eb1effa7":"9njXz","cc88d1a43014b324":"bnNSm","636e3d7d5c6797":"cIMyH","79a00d678e69889e":"j6Pty","a0a0b8f3afe4016b":"dy8dd","cfaecbea4b6c3a5":"eIqBR","2754ff8f43d8c64b":"4c1CS","dd239cac1d4c9580":"kAOrs"}],"2Jt5f":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("b96348cc78861ed5");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("df565e84724a376a");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var RowDefinition = function(_Component) {
    _inherits(RowDefinition, _Component);
    function RowDefinition() {
        _classCallCheck(this, RowDefinition);
        return _possibleConstructorReturn(this, (RowDefinition.__proto__ || Object.getPrototypeOf(RowDefinition)).apply(this, arguments));
    }
    _createClass(RowDefinition, [
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return RowDefinition;
}(_react.Component);
RowDefinition.propTypes = {
    //Children can be either a single column definition or an array
    //of column definition objects
    //TODO: get this prop type working again
    /*children: PropTypes.oneOfType([
    PropTypes.instanceOf(ColumnDefinition),
    PropTypes.arrayOf(PropTypes.instanceOf(ColumnDefinition))
  ]),*/ //The column value that should be used as the key for the row
    //if this is not set it will make one up (not efficient)
    rowKey: _propTypes2.default.string,
    //The column that will be known used to track child data
    //By default this will be "children"
    childColumnName: _propTypes2.default.string,
    //The css class name, or a function to generate a class name from props, to apply to this row.
    cssClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.func
    ])
};
exports.default = RowDefinition;

},{"b96348cc78861ed5":"9njXz","df565e84724a376a":"bnNSm"}],"6PobJ":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Table = undefined;
var _react = require("9339c595a718cf72");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Table = exports.Table = function Table(_ref) {
    var TableHeading = _ref.TableHeading, TableBody = _ref.TableBody, Loading = _ref.Loading, NoResults = _ref.NoResults, style = _ref.style, className = _ref.className, dataLoading = _ref.dataLoading, visibleRows = _ref.visibleRows;
    return dataLoading ? Loading && _react2.default.createElement(Loading, null) : visibleRows > 0 ? _react2.default.createElement('table', {
        style: style,
        className: className
    }, TableHeading && _react2.default.createElement(TableHeading, null), TableBody && _react2.default.createElement(TableBody, null)) : NoResults && _react2.default.createElement(NoResults, null);
};
exports.default = Table;

},{"9339c595a718cf72":"9njXz"}],"2IfRF":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("4d1c596cc9ac0468");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var TableBody = function TableBody(_ref) {
    var rowIds = _ref.rowIds, Row = _ref.Row, style = _ref.style, className = _ref.className;
    return _react2.default.createElement('tbody', {
        style: style,
        className: className
    }, rowIds && rowIds.map(function(k, i) {
        return _react2.default.createElement(Row, {
            key: k,
            griddleKey: k,
            index: i
        });
    }));
};
exports.default = TableBody;

},{"4d1c596cc9ac0468":"9njXz"}],"dbE9Z":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("1dc951c8080ad8a4");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("8a367f142d9aa6c");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("d6cad2bdbbee0dad");
var _compose = require("6e538e014b3662ea");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("b606110884b676af");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("2556cce7f9aff3b9");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("bb7086f8400b8d26");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var ComposedTableBodyContainer = function ComposedTableBodyContainer(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object,
        selectors: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            visibleRowIds: (0, _dataSelectors.visibleRowIdsSelector)(state),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'TableBody'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'TableBody')
        };
    }), (0, _mapProps2.default)(function(props) {
        var components = props.components, otherProps = _objectWithoutProperties(props, [
            'components'
        ]);
        return _extends({
            Row: props.components.Row
        }, otherProps);
    }))(function(_ref) {
        var Row = _ref.Row, visibleRowIds = _ref.visibleRowIds, style = _ref.style, className = _ref.className;
        return _react2.default.createElement(OriginalComponent, {
            rowIds: visibleRowIds,
            Row: Row,
            style: style,
            className: className
        });
    });
};
exports.default = ComposedTableBodyContainer;

},{"1dc951c8080ad8a4":"9njXz","8a367f142d9aa6c":"bnNSm","d6cad2bdbbee0dad":"cIMyH","6e538e014b3662ea":"j6Pty","b606110884b676af":"dy8dd","2556cce7f9aff3b9":"eIqBR","bb7086f8400b8d26":"4c1CS"}],"dmQ7i":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("c91aa8073211991f");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var TableHeading = function TableHeading(_ref) {
    var columnTitles = _ref.columnTitles, columnIds = _ref.columnIds, TableHeadingCell = _ref.TableHeadingCell, style = _ref.style, className = _ref.className;
    var headingCells = columnIds && columnTitles && columnTitles.map(function(t, i) {
        return _react2.default.createElement(TableHeadingCell, {
            key: columnIds[i],
            title: t,
            columnId: columnIds[i]
        });
    });
    return _react2.default.createElement('thead', {
        style: style,
        className: className
    }, _react2.default.createElement('tr', null, headingCells));
};
exports.default = TableHeading;

},{"c91aa8073211991f":"9njXz"}],"23htc":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("dfb4075178068327");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("8c0679d1ac96077c");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("5217c392571c6da7");
var _compose = require("e4a8ce75b1380ca");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("3bc899aa414beacb");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("9d3aa4be6e1287d3");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("bb89468a30aaa14e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var ComposedContainerComponent = function ComposedContainerComponent(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object,
        selectors: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            columnTitles: (0, _dataSelectors.columnTitlesSelector)(state),
            columnIds: (0, _dataSelectors.columnIdsSelector)(state),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'TableHeading'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'TableHeading')
        };
    }), (0, _mapProps2.default)(function(props) {
        var components = props.components, otherProps = _objectWithoutProperties(props, [
            'components'
        ]);
        return _extends({
            TableHeadingCell: components.TableHeadingCell
        }, otherProps);
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = ComposedContainerComponent;

},{"dfb4075178068327":"9njXz","8c0679d1ac96077c":"bnNSm","5217c392571c6da7":"cIMyH","e4a8ce75b1380ca":"j6Pty","3bc899aa414beacb":"dy8dd","9d3aa4be6e1287d3":"eIqBR","bb89468a30aaa14e":"4c1CS"}],"7pgwi":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("caa5d4fac13bfec4");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var TableHeadingCell = function TableHeadingCell(_ref) {
    var title = _ref.title, columnId = _ref.columnId, onClick = _ref.onClick, onMouseEnter = _ref.onMouseEnter, onMouseLeave = _ref.onMouseLeave, icon = _ref.icon, style = _ref.style, className = _ref.className;
    return _react2.default.createElement('th', {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        style: style,
        className: className
    }, title);
};
exports.default = TableHeadingCell;

},{"caa5d4fac13bfec4":"9njXz"}],"8I13p":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("f01f716d07a6c06e");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("371459c0acc60942");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("4cc4689b7e4e9aa0");
var _compose = require("ed48cb5c9906342b");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("1405cfeeb6bd65e8");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("3ec6944eabd3ec9");
var _getContext2 = _interopRequireDefault(_getContext);
var _withHandlers = require("4dfa59bb0544c164");
var _withHandlers2 = _interopRequireDefault(_withHandlers);
var _dataSelectors = require("e81417a1a3c66c27");
var _actions = require("4efe6bd14de7e237");
var _compositionUtils = require("414114931380e5fa");
var _sortUtils = require("db9b465861a1cf83");
var _valueUtils = require("c3ebf89a846e5fd2");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var DefaultTableHeadingCellContent = function DefaultTableHeadingCellContent(_ref) {
    var title = _ref.title, icon = _ref.icon, iconClassName = _ref.iconClassName;
    return _react2.default.createElement('span', null, title, icon && _react2.default.createElement('span', {
        className: iconClassName
    }, icon));
};
var EnhancedHeadingCell = function EnhancedHeadingCell(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        events: _propTypes2.default.object,
        selectors: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return _extends({
            sortProperty: (0, _dataSelectors.sortPropertyByIdSelector)(state, props),
            customHeadingComponent: (0, _dataSelectors.customHeadingComponentSelector)(state, props),
            cellProperties: (0, _dataSelectors.cellPropertiesSelector)(state, props),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'TableHeadingCell'),
            sortAscendingClassName: (0, _dataSelectors.classNamesForComponentSelector)(state, 'TableHeadingCellAscending'),
            sortDescendingClassName: (0, _dataSelectors.classNamesForComponentSelector)(state, 'TableHeadingCellDescending'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'TableHeadingCell')
        }, (0, _dataSelectors.iconsForComponentSelector)(state, 'TableHeadingCell'));
    }, function(dispatch, _ref2) {
        var onSort = _ref2.events.onSort;
        return {
            setSortColumn: (0, _compositionUtils.combineHandlers)([
                onSort,
                (0, _compose2.default)(dispatch, _actions.setSortColumn)
            ])
        };
    }), (0, _withHandlers2.default)(function(props) {
        return {
            onClick: props.cellProperties.sortable === false ? function() {
                return function() {};
            } : props.events.setSortProperties || _sortUtils.setSortProperties
        };
    }), //TODO: use with props on change or something more performant here
    (0, _mapProps2.default)(function(props) {
        var iconProps = (0, _sortUtils.getSortIconProps)(props);
        var title = props.customHeadingComponent ? _react2.default.createElement(props.customHeadingComponent, _extends({}, props.cellProperties.extraData, props, iconProps)) : _react2.default.createElement(DefaultTableHeadingCellContent, _extends({
            title: props.title
        }, iconProps));
        var className = (0, _valueUtils.valueOrResult)(props.cellProperties.headerCssClassName, props) || props.className;
        var style = _extends({}, props.cellProperties.sortable === false || {
            cursor: 'pointer'
        }, props.style);
        return _extends({}, props.cellProperties.extraData, props, iconProps, {
            title: title,
            style: style,
            className: className
        });
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = EnhancedHeadingCell;

},{"f01f716d07a6c06e":"9njXz","371459c0acc60942":"bnNSm","4cc4689b7e4e9aa0":"cIMyH","ed48cb5c9906342b":"j6Pty","1405cfeeb6bd65e8":"dy8dd","3ec6944eabd3ec9":"eIqBR","4dfa59bb0544c164":"5V2aT","e81417a1a3c66c27":"4c1CS","4efe6bd14de7e237":"fHAx9","414114931380e5fa":"4hJLU","db9b465861a1cf83":"aBsX5","c3ebf89a846e5fd2":"kAOrs"}],"5V2aT":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("705153cf722b08e1");
var _createEagerFactory = require("12f3b52d6452e9aa");
var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
var _createHelper = require("61edcceba0453479");
var _createHelper2 = _interopRequireDefault(_createHelper);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var mapValues = function mapValues(obj, func) {
    var result = {};
    /* eslint-disable no-restricted-syntax */ for(var key in obj)if (obj.hasOwnProperty(key)) result[key] = func(obj[key], key);
    /* eslint-enable no-restricted-syntax */ return result;
};
var withHandlers = function withHandlers(handlers) {
    return function(BaseComponent) {
        var _class, _temp2, _initialiseProps;
        var factory = (0, _createEagerFactory2.default)(BaseComponent);
        return _temp2 = _class = function(_Component) {
            _inherits(_class, _Component);
            function _class() {
                var _temp, _this, _ret;
                _classCallCheck(this, _class);
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [
                    this
                ].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
            }
            _class.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
                this.cachedHandlers = {};
            };
            _class.prototype.render = function render() {
                return factory(_extends({}, this.props, this.handlers));
            };
            return _class;
        }(_react.Component), _initialiseProps = function _initialiseProps() {
            var _this2 = this;
            this.cachedHandlers = {};
            this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function(createHandler, handlerName) {
                return function() {
                    var cachedHandler = _this2.cachedHandlers[handlerName];
                    if (cachedHandler) return cachedHandler.apply(undefined, arguments);
                    var handler = createHandler(_this2.props);
                    _this2.cachedHandlers[handlerName] = handler;
                    return handler.apply(undefined, arguments);
                };
            });
        }, _temp2;
    };
};
exports.default = (0, _createHelper2.default)(withHandlers, 'withHandlers');

},{"705153cf722b08e1":"9njXz","12f3b52d6452e9aa":"lnk7P","61edcceba0453479":"HesZM"}],"fHAx9":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNext = getNext;
exports.getPrevious = getPrevious;
exports.setPage = setPage;
exports.setFilter = setFilter;
exports.setSortColumn = setSortColumn;
exports.toggleSettings = toggleSettings;
exports.toggleColumn = toggleColumn;
exports.setPageSize = setPageSize;
exports.updateState = updateState;
var _constants = require("37b9e892824bd63e");
function getNext() {
    return {
        type: _constants.GRIDDLE_NEXT_PAGE
    };
}
function getPrevious() {
    return {
        type: _constants.GRIDDLE_PREVIOUS_PAGE
    };
}
function setPage(pageNumber) {
    return {
        type: _constants.GRIDDLE_SET_PAGE,
        pageNumber: pageNumber
    };
}
function setFilter(filter) {
    return {
        type: _constants.GRIDDLE_SET_FILTER,
        filter: filter
    };
}
function setSortColumn(sortProperties) {
    return {
        type: _constants.GRIDDLE_SET_SORT,
        sortProperties: sortProperties
    };
}
function toggleSettings() {
    return {
        type: _constants.GRIDDLE_TOGGLE_SETTINGS
    };
}
function toggleColumn(columnId) {
    return {
        type: _constants.GRIDDLE_TOGGLE_COLUMN,
        columnId: columnId
    };
}
function setPageSize(pageSize) {
    return {
        type: _constants.GRIDDLE_SET_PAGE_SIZE,
        pageSize: pageSize
    };
}
function updateState(newState) {
    return {
        type: _constants.GRIDDLE_UPDATE_STATE,
        newState: newState
    };
}

},{"37b9e892824bd63e":"lGlFg"}],"lGlFg":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var GRIDDLE_SET_FILTER = exports.GRIDDLE_SET_FILTER = 'GRIDDLE_SET_FILTER';
var GRIDDLE_SET_FILTER_BY_COLUMN = exports.GRIDDLE_SET_FILTER_BY_COLUMN = 'GRIDDLE_SET_FILTER_BY_COLUMN';
var GRIDDLE_SET_PAGE = exports.GRIDDLE_SET_PAGE = 'GRIDDLE_SET_PAGE';
var GRIDDLE_FILTER_REMOVED = exports.GRIDDLE_FILTER_REMOVED = 'GRIDDLE_FILTER_REMOVED';
var GRIDDLE_SET_SORT = exports.GRIDDLE_SET_SORT = 'GRIDDLE_SET_SORT';
var GRIDDLE_LOAD_DATA = exports.GRIDDLE_LOAD_DATA = 'GRIDDLE_LOAD_DATA';
var GRIDDLE_LOADED_DATA = exports.GRIDDLE_LOADED_DATA = 'GRIDDLE_LOADED_DATA';
var GRIDDLE_NEXT_PAGE = exports.GRIDDLE_NEXT_PAGE = 'GRIDDLE_NEXT_PAGE';
var GRIDDLE_PREVIOUS_PAGE = exports.GRIDDLE_PREVIOUS_PAGE = 'GRIDDLE_PREVIOUS_PAGE';
var GRIDDLE_GET_PAGE = exports.GRIDDLE_GET_PAGE = 'GRIDDLE_GET_PAGE';
var GRIDDLE_PAGE_LOADED = exports.GRIDDLE_PAGE_LOADED = 'GRIDDLE_PAGE_LOADED';
var GRIDDLE_SET_PAGE_SIZE = exports.GRIDDLE_SET_PAGE_SIZE = 'GRIDDLE_SET_PAGE_SIZE';
var GRIDDLE_INITIALIZE = exports.GRIDDLE_INITIALIZE = 'GRIDDLE_INITIALIZE';
var GRIDDLE_INITIALIZED = exports.GRIDDLE_INITIALIZED = 'GRIDDLE_INITIALIZED';
var GRIDDLE_REMOVED = exports.GRIDDLE_REMOVED = 'GRIDDLE_REMOVED';
var GRIDDLE_TOGGLE_COLUMN = exports.GRIDDLE_TOGGLE_COLUMN = 'GRIDDLE_TOGGLE_COLUMN';
var GRIDDLE_ROW_TOGGLED = exports.GRIDDLE_ROW_TOGGLED = 'GRIDDLE_ROW_TOGGLED';
var GRIDDLE_ROW_SELECTION_TOGGLED = exports.GRIDDLE_ROW_SELECTION_TOGGLED = 'GRIDDLE_ROW_SELECTION_TOGGLED';
var GRIDDLE_TOGGLE_SETTINGS = exports.GRIDDLE_TOGGLE_SETTINGS = 'GRIDDLE_TOGGLE_SETTINGS';
var GRIDDLE_UPDATE_STATE = exports.GRIDDLE_UPDATE_STATE = 'GRIDDLE_UPDATE_STATE';

},{}],"4hJLU":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _flowRight2 = require("da8a244ecf20d7b2");
var _flowRight3 = _interopRequireDefault(_flowRight2);
var _flow2 = require("9ac8ea99d1495265");
var _flow3 = _interopRequireDefault(_flow2);
var _pickBy2 = require("ebb83baf8ef94119");
var _pickBy3 = _interopRequireDefault(_pickBy2);
var _flattenDeep2 = require("f54afe8df35bae9");
var _flattenDeep3 = _interopRequireDefault(_flattenDeep2);
var _uniq2 = require("281def9011cf0bf8");
var _uniq3 = _interopRequireDefault(_uniq2);
var _pick2 = require("f15d9faca769bcb7");
var _pick3 = _interopRequireDefault(_pick2);
var _extend2 = require("85d62ff89d5fa9e9");
var _extend3 = _interopRequireDefault(_extend2);
exports.extendArray = extendArray;
exports.combineHandlers = combineHandlers;
exports.getPropertiesByEnding = getPropertiesByEnding;
exports.getObjectWherePropertyEndsWith = getObjectWherePropertyEndsWith;
exports.composeReducer = composeReducer;
exports.composeReducers = composeReducers;
exports.getKeysForObjects = getKeysForObjects;
exports.isKeyGriddleHook = isKeyGriddleHook;
exports.removeHooksFromObject = removeHooksFromObject;
exports.removeKeyNamePartFromObject = removeKeyNamePartFromObject;
exports.getBeforeHooksFromObject = getBeforeHooksFromObject;
exports.getBeforeReduceHooksFromObject = getBeforeReduceHooksFromObject;
exports.getAfterHooksFromObject = getAfterHooksFromObject;
exports.getAfterReduceHooksFromObject = getAfterReduceHooksFromObject;
exports.composeReducerObjects = composeReducerObjects;
exports.callReducerWithBeforeAfterPipe = callReducerWithBeforeAfterPipe;
exports.buildGriddleReducer = buildGriddleReducer;
exports.getReducersByWordEnding = getReducersByWordEnding;
exports.wrapMethodsByWordEnding = wrapMethodsByWordEnding;
exports.combineAndEnhanceComponents = combineAndEnhanceComponents;
exports.combineAndEnhanceContainers = combineAndEnhanceContainers;
exports.combineAndWrapWithContainerComponents = combineAndWrapWithContainerComponents;
exports.buildGriddleComponents = buildGriddleComponents;
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/** Extends an array rather than known list of objects */ //TODO: Look at using object.assign
function extendArray(objects) {
    //return an empty object if we don't have anything to combine
    if (!objects) return {};
    //add empty object to the beginning for Object.extend
    objects.unshift({});
    //Buid the combined object
    var combinedObject = _extend3.default.apply(this, objects);
    //TODO: why are we doing this? is it necessary
    objects.shift();
    //return the combined object
    return combinedObject;
}
function combineHandlers(functionArray) {
    return function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        functionArray.forEach(function(func) {
            return !!func && func.apply(undefined, args);
        });
    };
}
//from MDN
if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Finds properties on an object that end in specified word
 * @param {string} ending - The string that properties should be found ending with
 * @param {Object} object - The object to find keys on
 */ function getPropertiesByEnding(ending, object) {
    return Object.keys(object).filter(function(name) {
        return name.endsWith(ending);
    });
}
/** Creates a new object containing only properties that end with specified ending
 * @param {string} ending - The string that properties should be found ending with
 * @param {Object} object - The object to find keys on
 */ function getObjectWherePropertyEndsWith(ending, object) {
    var keys = getPropertiesByEnding(ending, object);
    return (0, _pick3.default)(object, keys);
}
/** Creates a new reducer by taking the output of the first reducer as state to the second
 * @param {Object} currentReducer - reducerMethod (state, action) to that we want to run as the state parameter for second reducer
 * @param {Object} previousReducer - reducerMethod (state, action) to run second
 */ function composeReducer(nextReducer, previousReducer) {
    // compose the reducers when both parameters are functions
    if (typeof nextReducer === 'function' && typeof previousReducer === 'function') return function(state, action) {
        return previousReducer(nextReducer(state, action), action);
    };
    // return the nextReducer
    return nextReducer;
}
/** Creates a composed reducer method from an array of reducer methods
 * @param {Object <array>} reducers - An array of reducer methods to compose
 */ function composeReducers(reducers) {
    // flip the array (since we want to apply from left-to-right and compose each reducer
    return reducers.reverse().reduce(function(previous, next) {
        return composeReducer(next, previous);
    }, {});
}
/** Obtains all the unique keys between an array of objects
 * @param {Object <array>} objects - An array of objects
 */ function getKeysForObjects(objects) {
    return (0, _uniq3.default)((0, _flattenDeep3.default)(objects.map(function(o) {
        return Object.keys(o);
    })));
}
/** Determines if a given key is a Griddle hook reducer
 * @param {string} key - the key to check if it refers to a Griddle hook
 */ function isKeyGriddleHook(key) {
    return key === 'BEFORE_REDUCE' || key === 'AFTER_REDUCE' || key.endsWith('AFTER') || key.endsWith('BEFORE');
}
/** Removes Griddle hooks from a reducer object
 * @param {Object} reducerObject - The reducer object to remove hooks from
 */ function removeHooksFromObject(reducerObject) {
    return (0, _pickBy3.default)(reducerObject, function(value, key) {
        if (isKeyGriddleHook(key)) return false;
        return true;
    });
}
/** Removes a given string from any key on the object that contains that string
 * @param {Object} reducer object - the reducer object to update keys on
 * @param {string} keyString - the string to remove from all keys
*/ function removeKeyNamePartFromObject(reducerObject, keyString) {
    return Object.keys(reducerObject).reduce(function(previous, current) {
        previous[current.replace(keyString, '')] = reducerObject[current];
        return previous;
    }, {});
}
/** Gets an object that consists of only the _BEFORE hooks. _BEFORE will be removed from the key.
 * @param {Object} reducerObject - the reducer to get the _BEFORE hooks from
 */ function getBeforeHooksFromObject(reducerObject) {
    return removeKeyNamePartFromObject((0, _pickBy3.default)(reducerObject, function(value, key) {
        return key.endsWith('BEFORE');
    }), '_BEFORE');
}
/** Gets an object that consists of only the BEFORE_REDUCE hooks.
 * @param {Object} reducerObject - the reducer to get the BEFORE_REDUCE hooks from
 */ function getBeforeReduceHooksFromObject(reducerObject) {
    return (0, _pickBy3.default)(reducerObject, function(value, key) {
        return key === 'BEFORE_REDUCE';
    });
}
/** Gets an object that conists of only the _AFTER hooks. _AFTER will be removed from the key
 * @param {Object} reducerObject - the reducer to get the _AFTER hooks from
 */ function getAfterHooksFromObject(reducerObject) {
    return removeKeyNamePartFromObject((0, _pickBy3.default)(reducerObject, function(value, key) {
        return key.endsWith('AFTER');
    }), '_AFTER');
}
/** Gets an object that conists of only the AFTER_REDUCE hooks.
 * @param {Object} reducerObject - the reducer to get the AFTER_REDUCE hooks from
 */ function getAfterReduceHooksFromObject(reducerObject) {
    return (0, _pickBy3.default)(reducerObject, function(value, key) {
        return key === 'AFTER_REDUCE';
    });
}
/** Combines the given reducer objects left to right
 * @param {Object <array>} reducerObjects - An array containing objects consisting of reducer methods as properties
 */ function composeReducerObjects(reducerObjects) {
    if (reducerObjects.length < 1) return null;
    return reducerObjects.reverse().reduce(function(previous, next) {
        // if we don't have any reducers in previous object continue with next
        if (previous === null) return next;
        //mutate the previous object by composing the reducer methods
        for(var key in next)previous[key] = composeReducer(next[key], previous[key]);
        return previous;
    }, null);
}
/** Builds a new reducer that composes hooks and extends standard reducers between reducerObjects
 * @param {Object <array>} reducers - An array of reducerObjects
 * Note: this used to be exported, but the same properties are available from buildGriddleReducer.
 * TODO: This method should be broken down a bit -- it's doing too much currently
 */ function buildGriddleReducerObject(reducerObjects) {
    var reducerMethodsWithoutHooks = [];
    var beforeHooks = [];
    var afterHooks = [];
    var beforeReduceAll = [];
    var afterReduceAll = [];
    if (reducerObjects.length > 0) // remove the hooks and extend the object
    for(var key in reducerObjects){
        var reducer = reducerObjects[key];
        reducerMethodsWithoutHooks.push(removeHooksFromObject(reducer));
        beforeHooks.push(getBeforeHooksFromObject(reducer));
        afterHooks.push(getAfterHooksFromObject(reducer));
        beforeReduceAll.push(getBeforeReduceHooksFromObject(reducer));
        afterReduceAll.push(getAfterReduceHooksFromObject(reducer));
    }
    var composedBeforeHooks = composeReducerObjects(beforeHooks);
    var composedAfterHooks = composeReducerObjects(afterHooks);
    var composedBeforeReduceAll = composeReducerObjects(beforeReduceAll);
    var composedAfterReduceAll = composeReducerObjects(afterReduceAll);
    // combine the reducers without hooks
    var combinedReducer = extendArray(reducerMethodsWithoutHooks);
    var composed = composeReducerObjects([
        composedBeforeReduceAll,
        composedBeforeHooks,
        combinedReducer,
        composedAfterHooks,
        composedAfterReduceAll
    ]);
    return composed;
}
/** Builds a composed method containing the before / after reduce calls
 * @param {Object} reduceObject - The reducer that contains the composed reducer methods
 * @param {Object} state - The store state
 * @param {object} action - The action payload information
*/ function callReducerWithBeforeAfterPipe(reducerObject, state, action) {
    var noop = function noop(passThroughState) {
        return passThroughState;
    };
    var before = reducerObject.hasOwnProperty('BEFORE_REDUCE') ? reducerObject.BEFORE_REDUCE : noop;
    var after = reducerObject.hasOwnProperty('AFTER_REDUCE') ? reducerObject.AFTER_REDUCE : noop;
    var call = action.type && reducerObject[action.type] && reducerObject[action.type] || reducerObject.GRIDDLE_INITIALIZED || noop;
    var partialCall = function(partialAction) {
        return function(partialState) {
            return call(partialState, partialAction);
        };
    }(action);
    var method = (0, _flow3.default)([
        before,
        partialCall,
        after
    ]);
    return method(state);
}
/** Builds a griddleReducer function from a series of reducerObjects
 * @param {Object <array>} reducers - An array of reducerObjects
*/ function buildGriddleReducer(reducerObjects) {
    var reducerObject = buildGriddleReducerObject(reducerObjects);
    var reducer = function reducer(state, action) {
        return callReducerWithBeforeAfterPipe(reducerObject, state, action);
    };
    Object.assign(reducer, reducerObject);
    return reducer;
}
/** Gets all reducers by a specific wordEnding
 * @param {array <Object>} reducers - An array of reducer objects
 * @param {string} ending - the wordEnding for the reducer name
 */ function getReducersByWordEnding(reducers, ending) {
    return reducers.reduce(function(previous, current) {
        var keys = Object.keys(current).filter(function(name) {
            return name.endsWith(ending);
        });
        var reducer = pick(current, keys);
        //TODO: clean this up it's a bit hacky
        for(var key in current){
            if (!key.endsWith(ending)) continue;
            var keyWithoutEnding = key.replace('_' + ending, "");
            //make a new method that pipes output of previous into state of current
            //this is to allow chaining these
            var hasPrevious = previous.hasOwnProperty(keyWithoutEnding) && typeof previous[keyWithoutEnding] === 'function';
            var previousReducer = hasPrevious ? previous[keyWithoutEnding] : undefined;
            var currentReducer = reducer[key];
            reducer[keyWithoutEnding] = wrapReducer(currentReducer, previousReducer);
        }
        //override anything in previous (since this now calls previous to make sure we have helpers from both);
        return extend(previous, reducer);
    }, {});
}
/** Wraps all methods in another method by name and word ending
  * @param {array<Object>} componentObjectArray - An array of component objects
  * @param {string} ending - the word ending to determine what is a enhancer method
  * @param {string} keyReplaceString - the word ending to apply when replacing the 'ending' parameter. Defaults to ''
*/ function wrapMethodsByWordEnding(componentArray, wordEnding) {
    var keyReplaceString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return componentArray.reduce(function(previous, current) {
        var newObject = {};
        for(var key in current){
            var keyWithoutEnhancer = key.replace(wordEnding, keyReplaceString);
            if (key.endsWith(wordEnding) && (previous.hasOwnProperty(keyWithoutEnhancer) || current.hasOwnProperty(keyWithoutEnhancer))) // Determine if we are working with an HoC that wraps another HoC
            newObject[keyWithoutEnhancer] = keyWithoutEnhancer.endsWith('Container') || keyWithoutEnhancer.endsWith('Enhancer') ? // If we are enhancing a container or enhancer flow this stuff since it's likely an HoC
            (0, _flowRight3.default)(current[key], current[keyWithoutEnhancer] || previous[keyWithoutEnhancer]) : // Wrap the current component in the Enhancer or container
            current[key](current[keyWithoutEnhancer] || previous[keyWithoutEnhancer]);
        }
        return (0, _pickBy3.default)(Object.assign(previous, current, newObject), function(v, k) {
            return !k.endsWith(wordEnding);
        });
    }, {});
}
/** Gets a new components object with component per component name
 * @param {array<Object>} componentObjectArray - An array of component objects
*/ function combineAndEnhanceComponents(componentArray) {
    return wrapMethodsByWordEnding(componentArray, 'Enhancer');
}
function combineAndEnhanceContainers(componentArray) {
    return wrapMethodsByWordEnding(componentArray, 'ContainerEnhancer', 'Container');
}
/** Gets a new component object with containers wrapping standard components
  (this is the same as enhance but just applying different naming conventions)
 * @param {array<Object>} componentObjectArray - An array of component objects
*/ function combineAndWrapWithContainerComponents(componentArray) {
    return wrapMethodsByWordEnding(componentArray, 'Container');
}
/** Wraps components in their containers and enhancers
 * @param {array<Object>} componentObjectArray - An array of component objects
*/ function buildGriddleComponents(componentArray) {
    //enhance the containers
    var withEnhancedContainers = combineAndEnhanceContainers(componentArray);
    //enhance the components
    var withEnhancedComponents = combineAndEnhanceComponents([
        withEnhancedContainers
    ]);
    //wrap the components with the container
    var withWrappedComponents = combineAndWrapWithContainerComponents([
        withEnhancedComponents
    ]);
    return withWrappedComponents;
}

},{"da8a244ecf20d7b2":"breBa","9ac8ea99d1495265":"38l8s","ebb83baf8ef94119":"jfoze","f54afe8df35bae9":"iatNl","281def9011cf0bf8":"6MoB8","f15d9faca769bcb7":"5kPds","85d62ff89d5fa9e9":"3zSHU"}],"breBa":[function(require,module,exports,__globalThis) {
var createFlow = require("805ca4c7ac73b2b0");
/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */ var flowRight = createFlow(true);
module.exports = flowRight;

},{"805ca4c7ac73b2b0":"4c63t"}],"4c63t":[function(require,module,exports,__globalThis) {
var LodashWrapper = require("896a1c8bec2b249e"), flatRest = require("4a2194ae9cc8745e"), getData = require("ce4d495b9cb7f28"), getFuncName = require("2b121606aab8b2b9"), isArray = require("c65a4bf20589b1c2"), isLaziable = require("3377c8e35cb57f18");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var WRAP_CURRY_FLAG = 8, WRAP_PARTIAL_FLAG = 32, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256;
/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */ function createFlow(fromRight) {
    return flatRest(function(funcs) {
        var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
        if (fromRight) funcs.reverse();
        while(index--){
            var func = funcs[index];
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
        }
        index = wrapper ? index : length;
        while(++index < length){
            func = funcs[index];
            var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
        }
        return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
            var index = 0, result = length ? funcs[index].apply(this, args) : value;
            while(++index < length)result = funcs[index].call(this, result);
            return result;
        };
    });
}
module.exports = createFlow;

},{"896a1c8bec2b249e":"7XVPJ","4a2194ae9cc8745e":"j0z0i","ce4d495b9cb7f28":"9ducP","2b121606aab8b2b9":"fQChO","c65a4bf20589b1c2":"1DVeR","3377c8e35cb57f18":"42nVD"}],"7XVPJ":[function(require,module,exports,__globalThis) {
var baseCreate = require("1f2f5be1a3c6d678"), baseLodash = require("2c2205c836afd08b");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;
module.exports = LodashWrapper;

},{"1f2f5be1a3c6d678":"5YCvM","2c2205c836afd08b":"lmQjQ"}],"5YCvM":[function(require,module,exports,__globalThis) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"6hgJK"}],"lmQjQ":[function(require,module,exports,__globalThis) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function baseLodash() {
// No operation performed.
}
module.exports = baseLodash;

},{}],"j0z0i":[function(require,module,exports,__globalThis) {
var flatten = require("199f7cbd69032298"), overRest = require("aa5c38699e42775a"), setToString = require("6a66c8b3fbd122d5");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function flatRest(func) {
    return setToString(overRest(func, undefined, flatten), func + '');
}
module.exports = flatRest;

},{"199f7cbd69032298":"cPyWt","aa5c38699e42775a":"rlFXD","6a66c8b3fbd122d5":"cmKNW"}],"cPyWt":[function(require,module,exports,__globalThis) {
var baseFlatten = require("a35d6abfacb4b52b");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, 1) : [];
}
module.exports = flatten;

},{"a35d6abfacb4b52b":"iu9J0"}],"9ducP":[function(require,module,exports,__globalThis) {
var metaMap = require("64c6b8282a70671c"), noop = require("19698e8556ad5081");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var getData = !metaMap ? noop : function(func) {
    return metaMap.get(func);
};
module.exports = getData;

},{"64c6b8282a70671c":"1fOev","19698e8556ad5081":"enX86"}],"1fOev":[function(require,module,exports,__globalThis) {
var WeakMap = require("e4c0cdd8d94afe67");
/** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
module.exports = metaMap;

},{"e4c0cdd8d94afe67":"9vICk"}],"fQChO":[function(require,module,exports,__globalThis) {
var realNames = require("14ca6afa60113322");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function getFuncName(func) {
    var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = getFuncName;

},{"14ca6afa60113322":"ecbA8"}],"ecbA8":[function(require,module,exports,__globalThis) {
/** Used to lookup unminified function names. */ var realNames = {};
module.exports = realNames;

},{}],"42nVD":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("56693ece680765d7"), getData = require("60c1c90169f6a5fe"), getFuncName = require("c8348f842539c358"), lodash = require("81fdf3ae1e47ec3e");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function isLaziable(func) {
    var funcName = getFuncName(func), other = lodash[funcName];
    if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
    if (func === other) return true;
    var data = getData(other);
    return !!data && func === data[0];
}
module.exports = isLaziable;

},{"56693ece680765d7":"amUJv","60c1c90169f6a5fe":"9ducP","c8348f842539c358":"fQChO","81fdf3ae1e47ec3e":"3MrYj"}],"amUJv":[function(require,module,exports,__globalThis) {
var baseCreate = require("e4056cbc3b9903bd"), baseLodash = require("3dfa16f8f7f9ba49");
/** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;
module.exports = LazyWrapper;

},{"e4056cbc3b9903bd":"5YCvM","3dfa16f8f7f9ba49":"lmQjQ"}],"3MrYj":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("e957c6a134f81ad3"), LodashWrapper = require("dc12267c6e1ac251"), baseLodash = require("2e62ee2285f7942e"), isArray = require("7d71cf75ddd5142"), isObjectLike = require("31691bc364b8b2af"), wrapperClone = require("d2329b4b44e63943");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function lodash(value) {
    if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) return value;
        if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
    }
    return new LodashWrapper(value);
}
// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;
module.exports = lodash;

},{"e957c6a134f81ad3":"amUJv","dc12267c6e1ac251":"7XVPJ","2e62ee2285f7942e":"lmQjQ","7d71cf75ddd5142":"1DVeR","31691bc364b8b2af":"4gOki","d2329b4b44e63943":"iLXws"}],"iLXws":[function(require,module,exports,__globalThis) {
var LazyWrapper = require("c911f6aa155b3acf"), LodashWrapper = require("8e63eae4d3286327"), copyArray = require("633c60334a2eb5ec");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function wrapperClone(wrapper) {
    if (wrapper instanceof LazyWrapper) return wrapper.clone();
    var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = copyArray(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = wrapperClone;

},{"c911f6aa155b3acf":"amUJv","8e63eae4d3286327":"7XVPJ","633c60334a2eb5ec":"lWbYv"}],"lWbYv":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"38l8s":[function(require,module,exports,__globalThis) {
var createFlow = require("6513737ed544c399");
/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */ var flow = createFlow();
module.exports = flow;

},{"6513737ed544c399":"4c63t"}],"iatNl":[function(require,module,exports,__globalThis) {
var baseFlatten = require("57782bd3a8a372a0");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? baseFlatten(array, INFINITY) : [];
}
module.exports = flattenDeep;

},{"57782bd3a8a372a0":"iu9J0"}],"6MoB8":[function(require,module,exports,__globalThis) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"lImIy"}],"5kPds":[function(require,module,exports,__globalThis) {
var basePick = require("e13834df88faab8"), flatRest = require("7f4b4cdb31764f87");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var pick = flatRest(function(object, paths) {
    return object == null ? {} : basePick(object, paths);
});
module.exports = pick;

},{"e13834df88faab8":"kT10w","7f4b4cdb31764f87":"j0z0i"}],"kT10w":[function(require,module,exports,__globalThis) {
var basePickBy = require("4620eb0b3c4f1463"), hasIn = require("c697490fd5f67a25");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function basePick(object, paths) {
    return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
    });
}
module.exports = basePick;

},{"4620eb0b3c4f1463":"369pd","c697490fd5f67a25":"105Hu"}],"3zSHU":[function(require,module,exports,__globalThis) {
module.exports = require("f6bda18e7aeacc51");

},{"f6bda18e7aeacc51":"7oa3Y"}],"7oa3Y":[function(require,module,exports,__globalThis) {
var copyObject = require("ed46b3ccb10c5e8b"), createAssigner = require("a607a474f65d26aa"), keysIn = require("8a711cf78d63982f");
/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */ var assignIn = createAssigner(function(object, source) {
    copyObject(source, keysIn(source), object);
});
module.exports = assignIn;

},{"ed46b3ccb10c5e8b":"vDc33","a607a474f65d26aa":"e0xvq","8a711cf78d63982f":"6emcB"}],"vDc33":[function(require,module,exports,__globalThis) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"aKTSf","9cddf6ac1a092765":"ba13n"}],"e0xvq":[function(require,module,exports,__globalThis) {
var baseRest = require("b91f3c8e236f389b"), isIterateeCall = require("4f5832110eba92d3");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = createAssigner;

},{"b91f3c8e236f389b":"5w1TW","4f5832110eba92d3":"gTLnH"}],"gTLnH":[function(require,module,exports,__globalThis) {
var eq = require("a8ec2a011d2eca69"), isArrayLike = require("616bc732534dffe0"), isIndex = require("e781332a36d1bd7"), isObject = require("c8548bf6929b8a5d");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
    return false;
}
module.exports = isIterateeCall;

},{"a8ec2a011d2eca69":"evtiM","616bc732534dffe0":"kzICo","e781332a36d1bd7":"bxLaX","c8548bf6929b8a5d":"6hgJK"}],"aBsX5":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports.defaultSort = defaultSort;
exports.setSortProperties = setSortProperties;
exports.getSortIconProps = getSortIconProps;
/* Sorts the given data by the specified column
 * @parameter {array<object>} data - The data to sort
 * @parameter {string} column - the name of the column to sort
 * @parameter {boolean optional} sortAscending - whether or not to sort this column in ascending order
 *
 * TODO: Needs tests!
 */ function defaultSort(data, column) {
    var sortAscending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return data.sort(function(original, newRecord) {
        var columnKey = column.split('.');
        var originalValue = original.hasIn(columnKey) && original.getIn(columnKey) || '';
        var newRecordValue = newRecord.hasIn(columnKey) && newRecord.getIn(columnKey) || '';
        //TODO: This is about the most cheezy sorting check ever.
        //Make it better
        if (originalValue === newRecordValue) return 0;
        else if (originalValue > newRecordValue) return sortAscending ? 1 : -1;
        else return sortAscending ? -1 : 1;
    });
}
function setSortProperties(_ref) {
    var setSortColumn = _ref.setSortColumn, sortProperty = _ref.sortProperty, columnId = _ref.columnId;
    return function() {
        if (sortProperty === null) {
            setSortColumn({
                id: columnId,
                sortAscending: true
            });
            return;
        }
        var newSortProperty = _extends({}, sortProperty, {
            sortAscending: !sortProperty.sortAscending
        });
        setSortColumn(newSortProperty);
    };
}
function getSortIconProps(props) {
    var sortProperty = props.sortProperty, sortAscendingIcon = props.sortAscendingIcon, sortDescendingIcon = props.sortDescendingIcon;
    var sortAscendingClassName = props.sortAscendingClassName, sortDescendingClassName = props.sortDescendingClassName;
    if (sortProperty) return sortProperty.sortAscending ? {
        icon: sortAscendingIcon,
        iconClassName: sortAscendingClassName
    } : {
        icon: sortDescendingIcon,
        iconClassName: sortDescendingClassName
    };
    // return null so we don't render anything if no sortProperty
    return null;
}

},{}],"lUg0I":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// Obsolete
var EnhancedHeadingCell = function EnhancedHeadingCell(OriginalComponent) {
    return OriginalComponent;
};
exports.default = EnhancedHeadingCell;

},{}],"d4kAU":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("6e972c765d42eb97");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("daa656ea73272ba");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("e1dccbdbc1b54316");
var _compose = require("816e1fb3e277a2ff");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("8835de1852aff421");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("f1abc2e652c649");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("fbca847a1d4b31df");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ComposedContainerComponent = function ComposedContainerComponent(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), //TODO: Should we use withHandlers here instead? I realize that's not 100% the intent of that method
    (0, _mapProps2.default)(function(props) {
        return {
            TableHeading: props.components.TableHeading,
            TableBody: props.components.TableBody,
            Loading: props.components.Loading,
            NoResults: props.components.NoResults
        };
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            dataLoading: (0, _dataSelectors.dataLoadingSelector)(state),
            visibleRows: (0, _dataSelectors.visibleRowCountSelector)(state),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Table'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Table')
        };
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = ComposedContainerComponent;

},{"6e972c765d42eb97":"9njXz","daa656ea73272ba":"bnNSm","e1dccbdbc1b54316":"cIMyH","816e1fb3e277a2ff":"j6Pty","8835de1852aff421":"dy8dd","f1abc2e652c649":"eIqBR","fbca847a1d4b31df":"4c1CS"}],"6wCmL":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("a0003ddc7d98d270");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var component = function component(_ref) {
    var Table = _ref.Table, Pagination = _ref.Pagination, Filter = _ref.Filter, SettingsWrapper = _ref.SettingsWrapper, Style = _ref.Style, className = _ref.className, style = _ref.style;
    return _react2.default.createElement('div', {
        className: className,
        style: style
    }, Style && _react2.default.createElement(Style, null), _react2.default.createElement(Filter, null), _react2.default.createElement(SettingsWrapper, null), _react2.default.createElement(Table, null), _react2.default.createElement(Pagination, null));
};
exports.default = component;

},{"a0003ddc7d98d270":"9njXz"}],"2fWii":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("b89a7e577f231a0");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("2edfa3accb21a94e");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("86dccb41d1c05a11");
var _getContext = require("e2037b0f35351225");
var _getContext2 = _interopRequireDefault(_getContext);
var _mapProps = require("f1bca7d8474f3f6b");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _compose = require("271efa668d2c1774");
var _compose2 = _interopRequireDefault(_compose);
var _dataSelectors = require("1e9a06bf77385b1d");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EnhancedLayout = function EnhancedLayout(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Layout'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Layout')
        };
    }), (0, _mapProps2.default)(function(props) {
        return {
            Table: props.components.Table,
            Pagination: props.components.Pagination,
            Filter: props.components.Filter,
            SettingsWrapper: props.components.SettingsWrapper,
            Style: props.components.Style,
            className: props.className,
            style: props.style
        };
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = EnhancedLayout;

},{"b89a7e577f231a0":"9njXz","2edfa3accb21a94e":"bnNSm","86dccb41d1c05a11":"cIMyH","e2037b0f35351225":"eIqBR","f1bca7d8474f3f6b":"dy8dd","271efa668d2c1774":"j6Pty","1e9a06bf77385b1d":"4c1CS"}],"7OIF3":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("4bcde62746135d16");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Pagination = function Pagination(_ref) {
    var Next = _ref.Next, Previous = _ref.Previous, PageDropdown = _ref.PageDropdown, style = _ref.style, className = _ref.className;
    return _react2.default.createElement('div', {
        style: style,
        className: className
    }, Previous && _react2.default.createElement(Previous, null), PageDropdown && _react2.default.createElement(PageDropdown, null), Next && _react2.default.createElement(Next, null));
};
exports.default = Pagination;

},{"4bcde62746135d16":"9njXz"}],"dpNI2":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("141c9bac7c39458d");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("d53391b73acf3d0a");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("ccccc457b579f10e");
var _compose = require("5355aa40a4334e5a");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("fc4488933926be99");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("414705b0c64d3e48");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("e391d6788e84c338");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var EnhancedPaginationContainer = function EnhancedPaginationContainer(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Pagination'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Pagination')
        };
    }), (0, _mapProps2.default)(function(props) {
        var components = props.components, otherProps = _objectWithoutProperties(props, [
            'components'
        ]);
        return _extends({
            Next: components.NextButton,
            Previous: components.PreviousButton,
            PageDropdown: components.PageDropdown
        }, otherProps);
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = EnhancedPaginationContainer;

},{"141c9bac7c39458d":"9njXz","d53391b73acf3d0a":"bnNSm","ccccc457b579f10e":"cIMyH","5355aa40a4334e5a":"j6Pty","fc4488933926be99":"dy8dd","414705b0c64d3e48":"eIqBR","e391d6788e84c338":"4c1CS"}],"fYJSv":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("6b237ce35aa6f8f3");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("ae066cd4fd92dc7e");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Filter = function(_Component) {
    _inherits(Filter, _Component);
    function Filter() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, Filter);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Filter.__proto__ || Object.getPrototypeOf(Filter)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.setFilter = function(e) {
            _this.props.setFilter(e.target.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Filter, [
        {
            key: 'render',
            value: function render() {
                return _react2.default.createElement('input', {
                    type: 'text',
                    name: 'filter',
                    placeholder: this.props.placeholder,
                    onChange: this.setFilter,
                    style: this.props.style,
                    className: this.props.className
                });
            }
        }
    ]);
    return Filter;
}(_react.Component);
Filter.propTypes = {
    setFilter: _propTypes2.default.func,
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    placeholder: _propTypes2.default.string
};
exports.default = Filter;

},{"6b237ce35aa6f8f3":"9njXz","ae066cd4fd92dc7e":"bnNSm"}],"55Sko":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("7e2b9012a2a62075");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("228da980f97b27bf");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _compose = require("c0d9e8777d2bb93a");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("b6896bed69705f31");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("ed09a94ab2d91be6");
var _getContext2 = _interopRequireDefault(_getContext);
var _compositionUtils = require("7986dcefd0fe49f6");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var EnhancedFilter = function EnhancedFilter(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        events: _propTypes2.default.object
    }), (0, _mapProps2.default)(function(_ref) {
        var onFilter = _ref.events.onFilter, props = _objectWithoutProperties(_ref, [
            'events'
        ]);
        return _extends({}, props, {
            setFilter: (0, _compositionUtils.combineHandlers)([
                onFilter,
                props.setFilter
            ])
        });
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = EnhancedFilter;

},{"7e2b9012a2a62075":"9njXz","228da980f97b27bf":"bnNSm","c0d9e8777d2bb93a":"j6Pty","b6896bed69705f31":"dy8dd","ed09a94ab2d91be6":"eIqBR","7986dcefd0fe49f6":"4hJLU"}],"012K5":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("b36af23643520b3");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("e5ca50be2e6a4c89");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("f47f727b4de2c323");
var _dataSelectors = require("fd86d5035cfd2c5a");
var _actions = require("2f2371eac9d47db7");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EnhancedFilter = function EnhancedFilter(OriginalComponent) {
    return (0, _griddleConnect.connect)(function(state, props) {
        return {
            placeholder: (0, _dataSelectors.textSelector)(state, {
                key: 'filterPlaceholder'
            }),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Filter'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Filter')
        };
    }, {
        setFilter: _actions.setFilter
    })(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = EnhancedFilter;

},{"b36af23643520b3":"9njXz","e5ca50be2e6a4c89":"bnNSm","f47f727b4de2c323":"cIMyH","fd86d5035cfd2c5a":"4c1CS","2f2371eac9d47db7":"fHAx9"}],"q7zoe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("14ce2a9f23f9c44a");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var SettingsToggle = function SettingsToggle(_ref) {
    var onClick = _ref.onClick, text = _ref.text, style = _ref.style, className = _ref.className;
    return _react2.default.createElement("button", {
        onClick: onClick,
        type: "button",
        style: style,
        className: className
    }, text);
};
exports.default = SettingsToggle;

},{"14ce2a9f23f9c44a":"9njXz"}],"dC7vN":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("dd1178dbdc613822");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("9ae4161b19c7baab");
var _compose = require("fb330335779b8933");
var _compose2 = _interopRequireDefault(_compose);
var _dataSelectors = require("bfa4b6bb2d9141c9");
var _actions = require("a2bc5fbe2c5a2782");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var enhancedSettingsToggle = function enhancedSettingsToggle(OriginalComponent) {
    return (0, _compose2.default)((0, _griddleConnect.connect)(function(state, props) {
        return {
            text: (0, _dataSelectors.textSelector)(state, {
                key: 'settingsToggle'
            }),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'SettingsToggle'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'SettingsToggle')
        };
    }, {
        toggleSettings: _actions.toggleSettings
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, _extends({}, props, {
            onClick: props.toggleSettings
        }));
    });
};
exports.default = enhancedSettingsToggle;

},{"dd1178dbdc613822":"9njXz","9ae4161b19c7baab":"cIMyH","fb330335779b8933":"j6Pty","bfa4b6bb2d9141c9":"4c1CS","a2bc5fbe2c5a2782":"fHAx9"}],"iwc0k":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("823f1ad346eb9429");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This is a component that wraps all of the other settings components ( SettingsToggle, Settings, etc).
// All of the settings views will be hiddne if isEnabled = false
var SettingsWrapper = function SettingsWrapper(_ref) {
    var SettingsToggle = _ref.SettingsToggle, Settings = _ref.Settings, isEnabled = _ref.isEnabled, isVisible = _ref.isVisible, style = _ref.style, className = _ref.className;
    return isEnabled ? _react2.default.createElement('div', {
        style: style,
        className: className
    }, SettingsToggle && _react2.default.createElement(SettingsToggle, null), isVisible && _react2.default.createElement(Settings, null)) : null;
};
exports.default = SettingsWrapper;

},{"823f1ad346eb9429":"9njXz"}],"2lKZY":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("99b216e7beebccd8");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("fd084219b9b28168");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("183c921435cbf11");
var _compose = require("58f30b0def3cbd84");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("6ee05d6aec415a3c");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("b8adb8d8504b3dbe");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("e99d39a95abb08c3");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EnhancedSettingsWrapper = function EnhancedSettingsWrapper(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), (0, _mapProps2.default)(function(props) {
        return {
            Settings: props.components.Settings,
            SettingsToggle: props.components.SettingsToggle
        };
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            isEnabled: (0, _dataSelectors.isSettingsEnabledSelector)(state),
            isVisible: (0, _dataSelectors.isSettingsVisibleSelector)(state),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'SettingsWrapper'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'SettingsWrapper')
        };
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = EnhancedSettingsWrapper;

},{"99b216e7beebccd8":"9njXz","fd084219b9b28168":"bnNSm","183c921435cbf11":"cIMyH","58f30b0def3cbd84":"j6Pty","6ee05d6aec415a3c":"dy8dd","b8adb8d8504b3dbe":"eIqBR","e99d39a95abb08c3":"4c1CS"}],"1NRPU":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("a764d9855d6bc221");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This is responsible for rendering the individual settings sections
var Settings = function Settings(_ref) {
    var settingsComponents = _ref.settingsComponents, style = _ref.style, className = _ref.className;
    return _react2.default.createElement('div', {
        style: style,
        className: className
    }, settingsComponents && settingsComponents.map(function(SettingsComponent, i) {
        return SettingsComponent && _react2.default.createElement('div', {
            key: SettingsComponent.key || i
        }, _react2.default.createElement(SettingsComponent, null));
    }));
};
exports.default = Settings;

},{"a764d9855d6bc221":"9njXz"}],"dPakf":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("276144d1f71fc04b");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("d0cc4a28c91063c3");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("a5ea36b75ce02f78");
var _compose = require("56d25d1bbf867d08");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("e63ff81b71d7aa5a");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("20ae673ed69f5738");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("c67b8640ae1c2211");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function getSettingsComponentsArrayFromObject(settingsObject, settingsComponents) {
    //TODO: determine if we need to make this faster
    return settingsObject ? Object.keys(settingsObject).sort(function(a, b) {
        var oa = settingsObject[a], ob = settingsObject[b];
        return (oa && oa.order || 0) - (ob && ob.order || 0);
    }).map(function(key) {
        return settingsObject[key] && (settingsObject[key].component || settingsComponents && settingsComponents[key]);
    }) : null;
}
var EnhancedSettings = function EnhancedSettings(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object,
        settingsComponentObjects: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Settings'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Settings')
        };
    }), (0, _mapProps2.default)(function(props) {
        var components = props.components, settingsComponentObjects = props.settingsComponentObjects, otherProps = _objectWithoutProperties(props, [
            'components',
            'settingsComponentObjects'
        ]);
        return _extends({
            settingsComponents: getSettingsComponentsArrayFromObject(settingsComponentObjects, components.SettingsComponents)
        }, otherProps);
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = EnhancedSettings;

},{"276144d1f71fc04b":"9njXz","d0cc4a28c91063c3":"bnNSm","a5ea36b75ce02f78":"cIMyH","56d25d1bbf867d08":"j6Pty","e63ff81b71d7aa5a":"dy8dd","20ae673ed69f5738":"eIqBR","c67b8640ae1c2211":"4c1CS"}],"8rUt9":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.components = undefined;
var _PageSizeSettings = require("40152ad4c5ea3105");
var _PageSizeSettings2 = _interopRequireDefault(_PageSizeSettings);
var _ColumnChooser = require("e8dbc3769bf5feea");
var _ColumnChooser2 = _interopRequireDefault(_ColumnChooser);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var components = exports.components = {
    pageSizeSettings: _PageSizeSettings2.default,
    columnChooser: _ColumnChooser2.default
};
exports.default = {
    pageSizeSettings: {
        order: 1
    },
    columnChooser: {
        order: 2
    }
};

},{"40152ad4c5ea3105":"1LXhr","e8dbc3769bf5feea":"1t3bL"}],"1LXhr":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("80cf135416013aaf");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("21ec3d267541d473");
var _compose = require("790354f410257bd0");
var _compose2 = _interopRequireDefault(_compose);
var _withState = require("cac043bc4a636627");
var _withState2 = _interopRequireDefault(_withState);
var _withHandlers = require("81c94d2d073df3de");
var _withHandlers2 = _interopRequireDefault(_withHandlers);
var _dataSelectors = require("8e1a89df06994941");
var _actions = require("668a83ebb3f7dfe5");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ComposedPageSizeSettings = (0, _compose2.default)((0, _griddleConnect.connect)(function(state) {
    return {
        pageSize: (0, _dataSelectors.pageSizeSelector)(state)
    };
}, {
    setPageSize: _actions.setPageSize
}), (0, _withState2.default)('value', 'updateValue', ''), (0, _withHandlers2.default)({
    onChange: function onChange(props) {
        return function(e) {
            props.updateValue(e.target.value);
        };
    },
    onSave: function onSave(props) {
        return function(e) {
            props.setPageSize(props.value);
        };
    }
}))(function(_ref) {
    var pageSize = _ref.pageSize, onChange = _ref.onChange, onSave = _ref.onSave;
    return _react2.default.createElement('div', null, _react2.default.createElement('input', {
        type: 'text',
        onChange: onChange,
        defaultValue: pageSize
    }), _react2.default.createElement('button', {
        type: 'button',
        onClick: onSave
    }, 'Save'));
});
exports.default = ComposedPageSizeSettings;

},{"80cf135416013aaf":"9njXz","21ec3d267541d473":"cIMyH","790354f410257bd0":"j6Pty","cac043bc4a636627":"h6WRE","81c94d2d073df3de":"5V2aT","8e1a89df06994941":"4c1CS","668a83ebb3f7dfe5":"fHAx9"}],"h6WRE":[function(require,module,exports,__globalThis) {
'use strict';
exports.__esModule = true;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("455acfa5bd7d25ed");
var _createHelper = require("e8909efb06f3d087");
var _createHelper2 = _interopRequireDefault(_createHelper);
var _createEagerFactory = require("fb6e4989662b5c95");
var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var withState = function withState(stateName, stateUpdaterName, initialState) {
    return function(BaseComponent) {
        var factory = (0, _createEagerFactory2.default)(BaseComponent);
        return function(_Component) {
            _inherits(_class2, _Component);
            function _class2() {
                var _temp, _this, _ret;
                _classCallCheck(this, _class2);
                for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [
                    this
                ].concat(args))), _this), _this.state = {
                    stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
                }, _this.updateStateValue = function(updateFn, callback) {
                    return _this.setState(function(_ref) {
                        var stateValue = _ref.stateValue;
                        return {
                            stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
                        };
                    }, callback);
                }, _temp), _possibleConstructorReturn(_this, _ret);
            }
            _class2.prototype.render = function render() {
                var _extends2;
                return factory(_extends({}, this.props, (_extends2 = {}, _extends2[stateName] = this.state.stateValue, _extends2[stateUpdaterName] = this.updateStateValue, _extends2)));
            };
            return _class2;
        }(_react.Component);
    };
};
exports.default = (0, _createHelper2.default)(withState, 'withState');

},{"455acfa5bd7d25ed":"9njXz","e8909efb06f3d087":"HesZM","fb6e4989662b5c95":"lnk7P"}],"1t3bL":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("f64b3e7b871e9595");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("8699c010c4c70f54");
var _compose = require("375ef1048e6a0dff");
var _compose2 = _interopRequireDefault(_compose);
var _withHandlers = require("a0d4d80da948aec1");
var _withHandlers2 = _interopRequireDefault(_withHandlers);
var _dataSelectors = require("51e02327fd844ef8");
var _actions = require("549a0691ccbb31be");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var style = {
    label: {
        clear: 'both'
    }
};
var ComposedColumnSettings = (0, _compose2.default)((0, _griddleConnect.connect)(function(state) {
    return {
        visibleColumns: (0, _dataSelectors.visibleColumnPropertiesSelector)(state),
        hiddenColumns: (0, _dataSelectors.hiddenColumnPropertiesSelector)(state)
    };
}, {
    toggleColumn: _actions.toggleColumn
}), (0, _withHandlers2.default)({
    onToggle: function onToggle(_ref) {
        var toggleColumn = _ref.toggleColumn;
        return function(event) {
            toggleColumn(event.target.name);
        };
    }
}))(function(_ref2) {
    var visibleColumns = _ref2.visibleColumns, hiddenColumns = _ref2.hiddenColumns, onToggle = _ref2.onToggle;
    return _react2.default.createElement('div', null, _react2.default.createElement('div', null, _react2.default.createElement('h4', null, 'Visible Columns'), Object.keys(visibleColumns).map(function(v) {
        return _react2.default.createElement('label', {
            htmlFor: visibleColumns[v].id,
            key: visibleColumns[v].id,
            style: style.label
        }, _react2.default.createElement('input', {
            type: 'checkbox',
            name: visibleColumns[v].id,
            checked: true,
            onChange: onToggle
        }), visibleColumns[v].title || visibleColumns[v].id);
    })), _react2.default.createElement('div', null, _react2.default.createElement('h4', null, 'Hidden Columns'), Object.keys(hiddenColumns).map(function(v) {
        return _react2.default.createElement('label', {
            key: hiddenColumns[v].id,
            htmlFor: hiddenColumns[v].id,
            style: style.label
        }, _react2.default.createElement('input', {
            type: 'checkbox',
            name: hiddenColumns[v].id,
            onChange: onToggle,
            defaultChecked: false
        }), hiddenColumns[v].title || hiddenColumns[v].id);
    })));
});
exports.default = ComposedColumnSettings;

},{"f64b3e7b871e9595":"9njXz","8699c010c4c70f54":"cIMyH","375ef1048e6a0dff":"j6Pty","a0d4d80da948aec1":"5V2aT","51e02327fd844ef8":"4c1CS","549a0691ccbb31be":"fHAx9"}],"4VJll":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("a35527382f31c7cf");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var NextButton = function NextButton(_ref) {
    var hasNext = _ref.hasNext, onClick = _ref.onClick, style = _ref.style, className = _ref.className, text = _ref.text;
    return hasNext ? _react2.default.createElement("button", {
        type: "button",
        onClick: onClick,
        style: style,
        className: className
    }, text) : null;
};
exports.default = NextButton;

},{"a35527382f31c7cf":"9njXz"}],"2CdGj":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("294b512f1fd3de36");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("d5062c357e8806a2");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _compose = require("e2933b25d7381172");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("15d0feaa25d52733");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("1f921f2a44da6391");
var _getContext2 = _interopRequireDefault(_getContext);
var _compositionUtils = require("3e29c84f2fd52e07");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var enhance = function enhance(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        events: _propTypes2.default.object
    }), (0, _mapProps2.default)(function(_ref) {
        var onNext = _ref.events.onNext, props = _objectWithoutProperties(_ref, [
            'events'
        ]);
        return _extends({}, props, {
            onClick: (0, _compositionUtils.combineHandlers)([
                onNext,
                props.onClick
            ])
        });
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = enhance;

},{"294b512f1fd3de36":"9njXz","d5062c357e8806a2":"bnNSm","e2933b25d7381172":"j6Pty","15d0feaa25d52733":"dy8dd","1f921f2a44da6391":"eIqBR","3e29c84f2fd52e07":"4hJLU"}],"7Lh5a":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("8e70982ba1317a4c");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("943d4bbc9e483b11");
var _dataSelectors = require("945c99e8bedde0e2");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var enhance = function enhance(OriginalComponent) {
    return (0, _griddleConnect.connect)(function(state, props) {
        return {
            text: (0, _dataSelectors.textSelector)(state, {
                key: 'next'
            }),
            hasNext: (0, _dataSelectors.hasNextSelector)(state, props),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'NextButton'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'NextButton')
        };
    })(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = enhance;

},{"8e70982ba1317a4c":"9njXz","943d4bbc9e483b11":"cIMyH","945c99e8bedde0e2":"4c1CS"}],"gRJpd":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("2037df008c891d59");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Loading = function Loading(_ref) {
    var className = _ref.className, style = _ref.style;
    return _react2.default.createElement('div', {
        style: style,
        className: className
    }, 'Loading\u2026');
};
exports.default = Loading;

},{"2037df008c891d59":"9njXz"}],"8mfbS":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _propTypes = require("e108761b9b86de55");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("1d5adf7dd3a1c8d2");
var _compose = require("97e58d358e973981");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("f407197b1b262afa");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("df6b23ecf3394e1");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("a11ac4b566fb106e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var LoadingContainer = (0, _compose2.default)((0, _getContext2.default)({
    components: _propTypes2.default.object
}), (0, _griddleConnect.connect)(function(state) {
    return {
        className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'Loading'),
        style: (0, _dataSelectors.stylesForComponentSelector)(state, 'Loading')
    };
}), (0, _mapProps2.default)(function(props) {
    var components = props.components, otherProps = _objectWithoutProperties(props, [
        'components'
    ]);
    return _extends({
        Loading: components.Loading
    }, otherProps);
}));
exports.default = LoadingContainer;

},{"e108761b9b86de55":"bnNSm","1d5adf7dd3a1c8d2":"cIMyH","97e58d358e973981":"j6Pty","f407197b1b262afa":"dy8dd","df6b23ecf3394e1":"eIqBR","a11ac4b566fb106e":"4c1CS"}],"2CRTd":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("ac79bba9c5c8eecc");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var NoResults = function NoResults(_ref) {
    var className = _ref.className, style = _ref.style;
    return _react2.default.createElement('div', {
        style: style,
        className: className
    }, 'No results found.');
};
exports.default = NoResults;

},{"ac79bba9c5c8eecc":"9njXz"}],"etLpT":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("31363f35454f0a96");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("e1a1f41357606c78");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("be66bd3e68fc6343");
var _compose = require("700590042cda2c00");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("b1b791b2231e2e06");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("8516f7dbe5b66b7");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("ec550dd2b3f3f578");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var NoResultsContainer = function NoResultsContainer(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state) {
        return {
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'NoResults'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'NoResults')
        };
    }), (0, _mapProps2.default)(function(props) {
        var components = props.components, otherProps = _objectWithoutProperties(props, [
            'components'
        ]);
        return _extends({
            NoResults: components.NoResults
        }, otherProps);
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = NoResultsContainer;

},{"31363f35454f0a96":"9njXz","e1a1f41357606c78":"bnNSm","be66bd3e68fc6343":"cIMyH","700590042cda2c00":"j6Pty","b1b791b2231e2e06":"dy8dd","8516f7dbe5b66b7":"eIqBR","ec550dd2b3f3f578":"4c1CS"}],"5ItI1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("d62f9317212ed9d2");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var PreviousButton = function PreviousButton(_ref) {
    var hasPrevious = _ref.hasPrevious, onClick = _ref.onClick, style = _ref.style, className = _ref.className, text = _ref.text;
    return hasPrevious ? _react2.default.createElement("button", {
        type: "button",
        onClick: onClick,
        style: style,
        className: className
    }, text) : null;
};
exports.default = PreviousButton;

},{"d62f9317212ed9d2":"9njXz"}],"feFw9":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("fb4b13a9a5462a2a");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("7565bca4e54f3d72");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _compose = require("bb12a2e0f616a18f");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("99c9a89232038a3a");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("27c1bcc69ac6a50c");
var _getContext2 = _interopRequireDefault(_getContext);
var _compositionUtils = require("bed40f13d717ba7");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var enhance = function enhance(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        events: _propTypes2.default.object
    }), (0, _mapProps2.default)(function(_ref) {
        var onPrevious = _ref.events.onPrevious, props = _objectWithoutProperties(_ref, [
            'events'
        ]);
        return _extends({}, props, {
            onClick: (0, _compositionUtils.combineHandlers)([
                onPrevious,
                props.onClick
            ])
        });
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = enhance;

},{"fb4b13a9a5462a2a":"9njXz","7565bca4e54f3d72":"bnNSm","bb12a2e0f616a18f":"j6Pty","99c9a89232038a3a":"dy8dd","27c1bcc69ac6a50c":"eIqBR","bed40f13d717ba7":"4hJLU"}],"fDGeh":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("bdf895fab4a9f82");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("e989a2d898f34581");
var _dataSelectors = require("96a0755253da8725");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var enhance = function enhance(OriginalComponent) {
    return (0, _griddleConnect.connect)(function(state, props) {
        return {
            text: (0, _dataSelectors.textSelector)(state, {
                key: 'previous'
            }),
            hasPrevious: (0, _dataSelectors.hasPreviousSelector)(state, props),
            className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'PreviousButton'),
            style: (0, _dataSelectors.stylesForComponentSelector)(state, 'PreviousButton')
        };
    })(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = enhance;

},{"bdf895fab4a9f82":"9njXz","e989a2d898f34581":"cIMyH","96a0755253da8725":"4c1CS"}],"9oiKv":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _isFinite2 = require("d1b616337cccfdeb");
var _isFinite3 = _interopRequireDefault(_isFinite2);
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("14ac3a13face1b47");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("21e66e4486af9c04");
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/** Gets a range from a single value.
 * TODO: Could probably make this take a predicate to avoid running through the loop twice */ var getRange = function getRange(number) {
    if (!(0, _isFinite3.default)(number)) return [
        0
    ];
    return Array(number).fill().map(function(_, i) {
        return i + 1;
    });
};
var PageDropdown = function(_Component) {
    _inherits(PageDropdown, _Component);
    function PageDropdown() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, PageDropdown);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageDropdown.__proto__ || Object.getPrototypeOf(PageDropdown)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.setPage = function(e) {
            _this.props.setPage(parseInt(e.target.value));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(PageDropdown, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, currentPage = _props.currentPage, maxPages = _props.maxPages;
                return _react2.default.createElement('select', {
                    onChange: this.setPage,
                    value: currentPage,
                    style: this.props.style,
                    className: this.props.className
                }, getRange(maxPages).map(function(num) {
                    return _react2.default.createElement('option', {
                        key: num,
                        value: num
                    }, num);
                }));
            }
        }
    ]);
    return PageDropdown;
}(_react.Component);
PageDropdown.propTypes = {
    maxPages: _propTypes2.default.number,
    currentPage: _propTypes2.default.number,
    setPage: _propTypes2.default.func,
    style: _propTypes2.default.object,
    className: _propTypes2.default.string
};
exports.default = PageDropdown;

},{"d1b616337cccfdeb":"kWFgN","14ac3a13face1b47":"9njXz","21e66e4486af9c04":"bnNSm"}],"kOwyS":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("6aaab53c2946064f");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("3c3a29ef39ac508b");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("6c24e8c4f1a531f5");
var _compose = require("39eaae144ea0eb57");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("8e85eeb647f56de8");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("20c67e0675584aad");
var _getContext2 = _interopRequireDefault(_getContext);
var _dataSelectors = require("f90e0782daeacdc0");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var enhance = (0, _griddleConnect.connect)(function(state, props) {
    return {
        maxPages: (0, _dataSelectors.maxPageSelector)(state, props),
        currentPage: (0, _dataSelectors.currentPageSelector)(state, props),
        className: (0, _dataSelectors.classNamesForComponentSelector)(state, 'PageDropdown'),
        style: (0, _dataSelectors.stylesForComponentSelector)(state, 'PageDropdown')
    };
});
exports.default = enhance;

},{"6aaab53c2946064f":"9njXz","3c3a29ef39ac508b":"bnNSm","6c24e8c4f1a531f5":"cIMyH","39eaae144ea0eb57":"j6Pty","8e85eeb647f56de8":"dy8dd","20c67e0675584aad":"eIqBR","f90e0782daeacdc0":"4c1CS"}],"2Yeeq":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("f28909150cd41126");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("27f2471ea6e6046d");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _compose = require("37399d13c026121c");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("c66492ffa12da975");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("64845fdc201ec258");
var _getContext2 = _interopRequireDefault(_getContext);
var _compositionUtils = require("91316147030ca752");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var enhance = function enhance(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        events: _propTypes2.default.object
    }), (0, _mapProps2.default)(function(_ref) {
        var onGetPage = _ref.events.onGetPage, props = _objectWithoutProperties(_ref, [
            'events'
        ]);
        return _extends({}, props, {
            setPage: (0, _compositionUtils.combineHandlers)([
                onGetPage,
                props.setPage
            ])
        });
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = enhance;

},{"f28909150cd41126":"9njXz","27f2471ea6e6046d":"bnNSm","37399d13c026121c":"j6Pty","c66492ffa12da975":"dy8dd","64845fdc201ec258":"eIqBR","91316147030ca752":"4hJLU"}],"eV7y2":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GRIDDLE_INITIALIZED = GRIDDLE_INITIALIZED;
exports.GRIDDLE_LOADED_DATA = GRIDDLE_LOADED_DATA;
exports.GRIDDLE_SET_PAGE_SIZE = GRIDDLE_SET_PAGE_SIZE;
exports.GRIDDLE_SET_PAGE = GRIDDLE_SET_PAGE;
exports.GRIDDLE_SET_FILTER = GRIDDLE_SET_FILTER;
exports.GRIDDLE_SET_SORT = GRIDDLE_SET_SORT;
exports.GRIDDLE_TOGGLE_SETTINGS = GRIDDLE_TOGGLE_SETTINGS;
exports.GRIDDLE_TOGGLE_COLUMN = GRIDDLE_TOGGLE_COLUMN;
exports.GRIDDLE_UPDATE_STATE = GRIDDLE_UPDATE_STATE;
var _immutable = require("5fb79a10d22eaa47");
var _immutable2 = _interopRequireDefault(_immutable);
var _dataUtils = require("826cb87eb79b73b0");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/*
 * State
 * ------------------
 *  data {Immutable.List} - the data that the grid is displaying
 *  loading {boolean} - is the data currently loading
 *  renderProperties {Immutable.Map} - the properties that determine how the grid should be displayed
 *  pageProperties {Immutable.Map} - the metadata for paging information
 *  .-- currentPage {int} - The current, visible page
 *  .-- pageSize {int} - The number of records to display
 *  sortProperties {Immutable.List} - the metadata surrounding sort
 *  .-- id {string} - the column id
 *  .-- sortAscending {boolean} - the direction of the sort. Index matches that of sortColumns
 **/ function isColumnVisible(state, columnId) {
    var hasRenderProperty = state.getIn([
        'renderProperties',
        'columnProperties',
        columnId
    ]);
    var currentlyVisibleProperty = state.getIn([
        'renderProperties',
        'columnProperties',
        columnId,
        'visible'
    ]);
    // if there is a render property and visible is not set, visible is true
    if (hasRenderProperty && currentlyVisibleProperty === undefined) return true;
    // if there is no render property currently and visible is not set
    if (!hasRenderProperty && currentlyVisibleProperty === undefined) return false;
    return currentlyVisibleProperty;
}
/** Sets the default render properties
 * @param {Immutable} state- Immutable previous state object
 * @param {Object} action - The action object to work with
 *
 * TODO: Consider renaming this to be more in line with what it's actually doing (setting render properties)
*/ function GRIDDLE_INITIALIZED(initialState) {
    var tempState = Object.assign({}, initialState);
    tempState = (0, _dataUtils.addColumnPropertiesWhenNoneExist)(tempState);
    //TODO: could probably make this more efficient by removing data
    // making the rest of the properties initial state and
    // setting the mapped data on the new initial state immutable object
    if (initialState.data && initialState.data.length > 0) {
        var transformedData = (0, _dataUtils.transformData)(initialState.data, initialState.renderProperties);
        tempState.data = transformedData.data;
        tempState.lookup = transformedData.lookup;
    }
    return _immutable2.default.fromJS(tempState);
}
/** Sets the griddle data
 * @param {Immutable} state- Immutable previous state object
 * @param {Object} action - The action object to work with
*/ function GRIDDLE_LOADED_DATA(state, action) {
    var transformedData = (0, _dataUtils.transformData)(action.data, state.get('renderProperties').toJSON());
    return state.set('data', transformedData.data).set('lookup', transformedData.lookup).set('loading', false);
}
/** Sets the current page size
 * @param {Immutable} state- Immutable previous state object
 * @param {Object} action - The action object to work with
*/ function GRIDDLE_SET_PAGE_SIZE(state, action) {
    return state.setIn([
        'pageProperties',
        'currentPage'
    ], 1).setIn([
        'pageProperties',
        'pageSize'
    ], action.pageSize);
}
/** Sets the current page
 * @param {Immutable} state- Immutable previous state object
 * @param {Object} action - The action object to work with
*/ function GRIDDLE_SET_PAGE(state, action) {
    return state.setIn([
        'pageProperties',
        'currentPage'
    ], action.pageNumber);
}
/** Sets the filter
 * @param {Immutable} state- Immutable previous state object
 * @param {Object} action - The action object to work with
*/ function GRIDDLE_SET_FILTER(state, action) {
    return state.set('filter', action.filter);
}
/** Sets sort properties
 * @param {Immutable} state- Immutable previous state object
 * @param {Object} action - The action object to work with
*/ function GRIDDLE_SET_SORT(state, action) {
    // turn this into an array if it's not already
    var sortProperties = action.sortProperties.hasOwnProperty('length') ? action.sortProperties : [
        action.sortProperties
    ];
    return state.set('sortProperties', new _immutable2.default.fromJS(sortProperties));
}
/** Sets the settings visibility to true / false depending on the current property
 */ function GRIDDLE_TOGGLE_SETTINGS(state, action) {
    // if undefined treat as if it's false
    var showSettings = state.get('showSettings') || false;
    return state.set('showSettings', !showSettings);
}
function GRIDDLE_TOGGLE_COLUMN(state, action) {
    // flips the visible state if the column property exists
    var currentlyVisible = isColumnVisible(state, action.columnId);
    return state.getIn([
        'renderProperties',
        'columnProperties',
        action.columnId
    ]) ? state.setIn([
        'renderProperties',
        'columnProperties',
        action.columnId,
        'visible'
    ], !currentlyVisible) : // if the columnProperty doesn't exist, create a new one and set the property to true
    state.setIn([
        'renderProperties',
        'columnProperties',
        action.columnId
    ], new _immutable2.default.Map({
        id: action.columnId,
        visible: true
    }));
}
var defaultRenderProperties = _immutable2.default.fromJS({});
function GRIDDLE_UPDATE_STATE(state, action) {
    var _action$newState = action.newState, data = _action$newState.data, newState = _objectWithoutProperties(_action$newState, [
        'data'
    ]);
    var mergedState = state.mergeDeep(_immutable2.default.fromJS(newState));
    if (!data) return mergedState;
    var renderProperties = state.get('renderProperties', defaultRenderProperties).toJSON();
    var transformedData = (0, _dataUtils.transformData)(data, renderProperties);
    return mergedState.set('data', transformedData.data).set('lookup', transformedData.lookup);
}

},{"5fb79a10d22eaa47":"AnTq9","826cb87eb79b73b0":"c7t27"}],"c7t27":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
exports.getIncrementer = getIncrementer;
exports.transformData = transformData;
exports.getVisibleDataForColumns = getVisibleDataForColumns;
exports.hasColumnProperties = hasColumnProperties;
exports.hasData = hasData;
exports.addColumnPropertiesWhenNoneExist = addColumnPropertiesWhenNoneExist;
var _immutable = require("bf304c8e18618b9f");
var _immutable2 = _interopRequireDefault(_immutable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
//From Immutable docs - https://github.com/facebook/immutable-js/wiki/Predicates
function keyInArray(keys) {
    var keySet = _immutable2.default.Set(keys);
    return function(v, k) {
        return keySet.has(k);
    };
}
function getIncrementer(startIndex) {
    var key = startIndex;
    return function() {
        return key++;
    };
}
function isImmutableConvertibleValue(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' || value === null || value instanceof Date;
}
// From https://github.com/facebook/immutable-js/wiki/Converting-from-JS-objects#custom-conversion
function fromJSGreedy(js) {
    return isImmutableConvertibleValue(js) ? js : Array.isArray(js) ? _immutable2.default.Seq(js).map(fromJSGreedy).toList() : _immutable2.default.Seq(js).map(fromJSGreedy).toMap();
}
function transformData(data, renderProperties) {
    if (!data) return {};
    var hasCustomRowId = renderProperties.rowProperties && renderProperties.rowProperties.rowKey;
    // Validate that the first item in our data has the custom Griddle key
    if (hasCustomRowId && data.length > 0 && !data[0].hasOwnProperty(renderProperties.rowProperties.rowKey)) throw new Error('Griddle: Property \'' + renderProperties.rowProperties.rowKey + '\' doesn\'t exist in row data. Please specify a rowKey that exists in <RowDefinition>');
    var list = [];
    var lookup = {};
    data.forEach(function(rowData, index) {
        var map = fromJSGreedy(rowData);
        // if this has a row key use that -- otherwise use Griddle key
        var key = hasCustomRowId ? rowData[renderProperties.rowProperties.rowKey] : index;
        // if our map object already has griddleKey use that -- otherwise add key as griddleKey
        var keyedData = map.has('griddleKey') ? map : map.set('griddleKey', key);
        list.push(keyedData);
        lookup[key] = index;
    });
    return {
        data: new _immutable2.default.List(list),
        lookup: new _immutable2.default.Map(lookup)
    };
}
/** Gets the visible data based on columns
 *  @param (List<Map>) data - data collection
 *  @param (array<string>) columns - list of columns to display
 *
 *  TODO: Needs tests
 */ function getVisibleDataForColumns(data, columns) {
    if (data.size < 1) return data;
    var dataColumns = data.get(0).keySeq().toArray();
    var metadataColumns = dataColumns.filter(function(item) {
        return columns.indexOf(item) < 0;
    });
    //if columns are specified but aren't in the data
    //make it up (as null). We will append this column
    //to the resultant data
    var magicColumns = columns.filter(function(item) {
        return dataColumns.indexOf(item) < 0;
    }).reduce(function(original, item) {
        original[item] = null;
        return original;
    }, {});
    //combine the metadata and the "magic" columns
    var extra = data.map(function(d, i) {
        return new _immutable2.default.Map(Object.assign(magicColumns));
    });
    var result = data.map(function(d) {
        return d.filter(keyInArray(columns));
    });
    return result.mergeDeep(extra).map(function(item) {
        return item.sortBy(function(val, key) {
            return columns.indexOf(key) > -1 ? columns.indexOf(key) : MAX_SAFE_INTEGER;
        });
    });
}
/* TODO: Add documentation and tests for this whole section!*/ /** Does this initial state object have column properties?
 * @param (object) stateObject - a non-immutable state object for initialization
 *
 * TODO: Needs tests
 */ function hasColumnProperties(stateObject) {
    return stateObject.hasOwnProperty('renderProperties') && stateObject.renderProperties.hasOwnProperty('columnProperties') && Object.keys(stateObject.renderProperties.columnProperties).length > 0;
}
/** Does this initial state object have data?
 * @param (object) stateObject - a non-immutable state object for initialization
 */ function hasData(stateObject) {
    return !!stateObject.data && stateObject.data.length > 0;
}
/** Gets a new state object (not immutable) that has columnProperties if none exist
 * @param (object) stateObject - a non-immutable state object for initialization
 *
 * TODO: Needs tests
 */ function addColumnPropertiesWhenNoneExist(stateObject) {
    if (!hasData(stateObject) || hasColumnProperties(stateObject)) return stateObject;
    return _extends({}, stateObject, {
        renderProperties: {
            columnProperties: Object.keys(stateObject.data[0]).reduce(function(previous, current) {
                previous[current] = {
                    id: current,
                    visible: true
                };
                return previous;
            }, {})
        }
    });
}

},{"bf304c8e18618b9f":"AnTq9"}],"bs75O":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var styleConfig = {
    icons: {
        TableHeadingCell: {
            sortDescendingIcon: "\u25BC",
            sortAscendingIcon: "\u25B2"
        }
    },
    classNames: {
        Cell: 'griddle-cell',
        Filter: 'griddle-filter',
        Loading: 'griddle-loadingResults',
        NextButton: 'griddle-next-button',
        NoResults: 'griddle-noResults',
        PageDropdown: 'griddle-page-select',
        Pagination: 'griddle-pagination',
        PreviousButton: 'griddle-previous-button',
        Row: 'griddle-row',
        RowDefinition: 'griddle-row-definition',
        Settings: 'griddle-settings',
        SettingsToggle: 'griddle-settings-toggle',
        Table: 'griddle-table',
        TableBody: 'griddle-table-body',
        TableHeading: 'griddle-table-heading',
        TableHeadingCell: 'griddle-table-heading-cell',
        TableHeadingCellAscending: 'griddle-heading-ascending',
        TableHeadingCellDescending: 'griddle-heading-descending'
    },
    styles: {}
};
exports.default = {
    styleConfig: styleConfig,
    pageProperties: {
        currentPage: 1,
        pageSize: 10
    },
    enableSettings: true,
    textProperties: {
        filterPlaceholder: 'Filter',
        next: 'Next',
        previous: 'Previous',
        settingsToggle: 'Settings'
    }
};

},{}],"h43sr":[function(require,module,exports,__globalThis) {
'use strict';
var _flatten2 = require("6ba833b907543f76");
var _flatten3 = _interopRequireDefault(_flatten2);
var _compact2 = require("718b0eaba03fba2");
var _compact3 = _interopRequireDefault(_compact2);
var _pickBy2 = require("c53fbaafb583b07a");
var _pickBy3 = _interopRequireDefault(_pickBy2);
var _merge2 = require("4b0dde4722a3a0c5");
var _merge3 = _interopRequireDefault(_merge2);
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _compositionUtils = require("7080b598949b989c");
var _columnUtils = require("4491923d712025d9");
var _rowUtils = require("e5acfefcd1fad804");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
module.exports = function initializer(defaults) {
    if (!this) throw new Error('this missing!');
    var _ref = defaults || {}, defaultReducer = _ref.reducer, components = _ref.components, settingsComponentObjects = _ref.settingsComponentObjects, selectors = _ref.selectors, defaultStyleConfig = _ref.styleConfig, defaultInitialState = _objectWithoutProperties(_ref, [
        'reducer',
        'components',
        'settingsComponentObjects',
        'selectors',
        'styleConfig'
    ]);
    var _props = this.props, _props$plugins = _props.plugins, plugins = _props$plugins === undefined ? [] : _props$plugins, _props$data = _props.data, data = _props$data === undefined ? [] : _props$data, rowPropertiesComponent = _props.children, _props$events = _props.events, userEvents = _props$events === undefined ? {} : _props$events, _props$styleConfig = _props.styleConfig, userStyleConfig = _props$styleConfig === undefined ? {} : _props$styleConfig, userComponents = _props.components, _props$renderProperti = _props.renderProperties, userRenderProperties = _props$renderProperti === undefined ? {} : _props$renderProperti, userSettingsComponentObjects = _props.settingsComponentObjects, _props$reduxMiddlewar = _props.reduxMiddleware, reduxMiddleware = _props$reduxMiddlewar === undefined ? [] : _props$reduxMiddlewar, _props$listeners = _props.listeners, listeners = _props$listeners === undefined ? {} : _props$listeners, userInitialState = _objectWithoutProperties(_props, [
        'plugins',
        'data',
        'children',
        'events',
        'styleConfig',
        'components',
        'renderProperties',
        'settingsComponentObjects',
        'reduxMiddleware',
        'listeners'
    ]);
    var rowProperties = (0, _rowUtils.getRowProperties)(rowPropertiesComponent);
    var columnProperties = (0, _columnUtils.getColumnProperties)(rowPropertiesComponent);
    // Combine / compose the reducers to make a single, unified reducer
    var reducer = (0, _compositionUtils.buildGriddleReducer)([
        defaultReducer
    ].concat(_toConsumableArray(plugins.map(function(p) {
        return p.reducer;
    }))));
    // Combine / Compose the components to make a single component for each component type
    this.components = (0, _compositionUtils.buildGriddleComponents)([
        components
    ].concat(_toConsumableArray(plugins.map(function(p) {
        return p.components;
    })), [
        userComponents
    ]));
    this.settingsComponentObjects = Object.assign.apply(Object, [
        _extends({}, settingsComponentObjects)
    ].concat(_toConsumableArray(plugins.map(function(p) {
        return p.settingsComponentObjects;
    })), [
        userSettingsComponentObjects
    ]));
    this.events = Object.assign.apply(Object, [
        {},
        userEvents
    ].concat(_toConsumableArray(plugins.map(function(p) {
        return p.events;
    }))));
    this.selectors = plugins.reduce(function(combined, plugin) {
        return _extends({}, combined, plugin.selectors);
    }, _extends({}, selectors));
    var styleConfig = _merge3.default.apply(undefined, [
        _extends({}, defaultStyleConfig)
    ].concat(_toConsumableArray(plugins.map(function(p) {
        return p.styleConfig;
    })), [
        userStyleConfig
    ]));
    // TODO: This should also look at the default and plugin initial state objects
    var renderProperties = Object.assign.apply(Object, [
        {
            rowProperties: rowProperties,
            columnProperties: columnProperties
        }
    ].concat(_toConsumableArray(plugins.map(function(p) {
        return p.renderProperties;
    })), [
        userRenderProperties
    ]));
    // TODO: Make this its own method
    var initialState = _merge3.default.apply(undefined, [
        defaultInitialState
    ].concat(_toConsumableArray(plugins.map(function(p) {
        return p.initialState;
    })), [
        userInitialState,
        {
            data: data,
            renderProperties: renderProperties,
            styleConfig: styleConfig
        }
    ]));
    var sanitizedListeners = (0, _pickBy3.default)(listeners, function(value) {
        return typeof value === 'function';
    });
    this.listeners = plugins.reduce(function(combined, plugin) {
        return _extends({}, combined, (0, _pickBy3.default)(plugin.listeners, function(value) {
            return typeof value === 'function';
        }));
    }, sanitizedListeners);
    return {
        initialState: initialState,
        reducer: reducer,
        reduxMiddleware: (0, _compact3.default)([].concat(_toConsumableArray((0, _flatten3.default)(plugins.map(function(p) {
            return p.reduxMiddleware;
        }))), _toConsumableArray(reduxMiddleware)))
    };
};

},{"6ba833b907543f76":"cPyWt","718b0eaba03fba2":"cM5tL","c53fbaafb583b07a":"jfoze","4b0dde4722a3a0c5":"iHC1F","7080b598949b989c":"4hJLU","4491923d712025d9":"eJnKd","e5acfefcd1fad804":"1efoL"}],"cM5tL":[function(require,module,exports,__globalThis) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = compact;

},{}],"iHC1F":[function(require,module,exports,__globalThis) {
var baseMerge = require("7b601c4be119b25d"), createAssigner = require("e87a09d93c0fc32d");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
module.exports = merge;

},{"7b601c4be119b25d":"1n4LL","e87a09d93c0fc32d":"e0xvq"}],"1n4LL":[function(require,module,exports,__globalThis) {
var Stack = require("49ff021be75c93ea"), assignMergeValue = require("76e9fd6386317324"), baseFor = require("e7dca58bcfe9c669"), baseMergeDeep = require("4ea46d88599071ec"), isObject = require("c52c932be04280cc"), keysIn = require("27adf66142f57b4b"), safeGet = require("564385b2292facea");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
module.exports = baseMerge;

},{"49ff021be75c93ea":"cltFt","76e9fd6386317324":"e0LII","e7dca58bcfe9c669":"9oLrx","4ea46d88599071ec":"8JjIw","c52c932be04280cc":"6hgJK","27adf66142f57b4b":"6emcB","564385b2292facea":"34puL"}],"e0LII":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("30a6c72f04f5134"), eq = require("7d9c95e1ffdd4f16");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
module.exports = assignMergeValue;

},{"30a6c72f04f5134":"ba13n","7d9c95e1ffdd4f16":"evtiM"}],"8JjIw":[function(require,module,exports,__globalThis) {
var assignMergeValue = require("4af3e5b0ee4c14f6"), cloneBuffer = require("ec8e1b90277c5e12"), cloneTypedArray = require("4b1a2b5090faf247"), copyArray = require("d7675bdf0a02bffc"), initCloneObject = require("1067a6f3f6bd5986"), isArguments = require("2238139506f6727b"), isArray = require("290c774b41e416bb"), isArrayLikeObject = require("f481819c40e5b527"), isBuffer = require("6532fda6a198015f"), isFunction = require("7f306c94b573f977"), isObject = require("32c89e763261c579"), isPlainObject = require("ff359d315efefc4f"), isTypedArray = require("61ce92c01fd411fe"), safeGet = require("abfa8f7e72201edb"), toPlainObject = require("c54d414b219fa287");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
module.exports = baseMergeDeep;

},{"4af3e5b0ee4c14f6":"e0LII","ec8e1b90277c5e12":"aNaSh","4b1a2b5090faf247":"WFexx","d7675bdf0a02bffc":"lWbYv","1067a6f3f6bd5986":"fGkGx","2238139506f6727b":"bpegN","290c774b41e416bb":"1DVeR","f481819c40e5b527":"gamaN","6532fda6a198015f":"26W2O","7f306c94b573f977":"3A7xI","32c89e763261c579":"6hgJK","ff359d315efefc4f":"lCxAG","61ce92c01fd411fe":"hq5rz","abfa8f7e72201edb":"34puL","c54d414b219fa287":"i8tDZ"}],"aNaSh":[function(require,module,exports,__globalThis) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"gVq56"}],"WFexx":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"ZLaCu"}],"ZLaCu":[function(require,module,exports,__globalThis) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"eHExv"}],"fGkGx":[function(require,module,exports,__globalThis) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"5YCvM","8c92276927b7c3e0":"9DBU4","e939f15d7a0f64a5":"6l00J"}],"lCxAG":[function(require,module,exports,__globalThis) {
var baseGetTag = require("c03dd41ed9922dd2"), getPrototype = require("2ca5b85a120835de"), isObjectLike = require("963b65e043435612");
/** `Object#toString` result references. */ var objectTag = '[object Object]';
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
module.exports = isPlainObject;

},{"c03dd41ed9922dd2":"5ltt8","2ca5b85a120835de":"9DBU4","963b65e043435612":"4gOki"}],"34puL":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = safeGet;

},{}],"i8tDZ":[function(require,module,exports,__globalThis) {
var copyObject = require("6377e94c7c46b197"), keysIn = require("437a3e3814017158");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
module.exports = toPlainObject;

},{"6377e94c7c46b197":"vDc33","437a3e3814017158":"6emcB"}],"eJnKd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
exports.getColumnProperties = getColumnProperties;
var offset = 1000;
/** Gets a column properties object from an array of columnNames
 * @param {Array<string>} columns - array of column names
 */ function getColumnPropertiesFromColumnArray(columnProperties, columns) {
    return columns.reduce(function(previous, current, i) {
        previous[current] = {
            id: current,
            order: offset + i
        };
        return previous;
    }, columnProperties);
}
/** Gets the column properties object from a react component (rowProperties) that contains child component(s) for columnProperties.
 *    If no properties are found, it will work return a column properties object based on the all columns array
 * @param {Object} rowProperties - An React component that contains the rowProperties and child columnProperties components
 * @param {Array<string> optional} allColumns - An optional array of colummn names. This will be used to generate the columnProperties when they are not defined in rowProperties
 */ function getColumnProperties(rowProperties) {
    var allColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var children = rowProperties && rowProperties.props && rowProperties.props.children;
    var columnProperties = {};
    // Working against an array of columnProperties
    if (Array.isArray(children)) // build one object that contains all of the column properties keyed by id
    children.reduce(function(previous, current, i) {
        if (current) previous[current.props.id] = _extends({
            order: offset + i
        }, current.props);
        return previous;
    }, columnProperties);
    else if (children && children.props) columnProperties[children.props.id] = _extends({
        order: offset
    }, children.props);
    if (Object.keys(columnProperties).length === 0 && allColumns) getColumnPropertiesFromColumnArray(columnProperties, allColumns);
    return columnProperties;
}

},{}],"1efoL":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRowProperties = getRowProperties;
/** Gets a row properties object from a rowProperties component
 * @param {Object} rowPropertiesComponent - A react component that contains rowProperties as props
*/ function getRowProperties(rowPropertiesComponent) {
    if (!rowPropertiesComponent) return null;
    var rowProps = Object.assign({}, rowPropertiesComponent.props);
    delete rowProps.children;
    if (!rowProps.hasOwnProperty('childColumnName')) rowProps.childColumnName = 'children';
    return rowProps;
}

},{}],"3TqZk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var StoreListener = exports.StoreListener = function StoreListener(store) {
    var _this = this;
    _classCallCheck(this, StoreListener);
    this.removeListener = function(name) {
        if (_this.unsubscribers.hasOwnProperty(name)) {
            _this.unsubscribers[name]();
            delete _this.unsubscribers[name];
            return true;
        } else return false;
    };
    this.addListener = function(listener, name, otherArgs) {
        // attempt to unsubscribe an existing listener if the new 
        // listener name matches
        // if no name is provided, do nothing
        name && _this.removeListener(name);
        var unsubscribe = function() {
            var oldState = void 0;
            return _this.store.subscribe(function() {
                var newState = _this.store.getState();
                listener(oldState, newState, _extends({}, otherArgs));
                oldState = newState;
            });
        }();
        // if name was provided, add the unsubscribe
        // otherwise this is an "anonymous" listener
        name && (_this.unsubscribers[name] = unsubscribe);
        return unsubscribe;
    };
    this.hasListener = function(name) {
        return _this.unsubscribers.hasOwnProperty(name);
    };
    this.store = store;
    this.unsubscribers = {};
};

},{}],"hr64y":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _columnUtils = require("b9d891336faa68c0");
var columnUtils = _interopRequireWildcard(_columnUtils);
var _compositionUtils = require("d5483c5c7400231e");
var compositionUtils = _interopRequireWildcard(_compositionUtils);
var _dataUtils = require("7ebf5688d2f8ad24");
var dataUtils = _interopRequireWildcard(_dataUtils);
var _rowUtils = require("2a5e2a658a106cc3");
var rowUtils = _interopRequireWildcard(_rowUtils);
var _sortUtils = require("d0e6e5a7ac350562");
var sortUtils = _interopRequireWildcard(_sortUtils);
var _griddleConnect = require("11caf586947e80d2");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
exports.default = {
    columnUtils: columnUtils,
    compositionUtils: compositionUtils,
    dataUtils: dataUtils,
    rowUtils: rowUtils,
    sortUtils: sortUtils,
    connect: _griddleConnect.connect
};

},{"b9d891336faa68c0":"eJnKd","d5483c5c7400231e":"4hJLU","7ebf5688d2f8ad24":"c7t27","2a5e2a658a106cc3":"1efoL","d0e6e5a7ac350562":"aBsX5","11caf586947e80d2":"cIMyH"}],"j2kxF":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("d982971d4ccb9e67");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = {
    styleConfig: {
        classNames: {
            Layout: 'griddle griddle-container'
        }
    },
    components: {
        Style: function Style() {
            return _react2.default.createElement('style', {
                type: 'text/css'
            }, '\n          .griddle-container{\n            border:1px solid #DDD;\n          }\n\n          .griddle .top-section{\n            clear:both;\n            display:table;\n            width:100%;\n          }\n\n          .griddle .griddle-filter{\n            float:left;\n            width:50%;\n            text-align:left;\n            color:#222;\n            min-height:1px;\n          }\n\n          .griddle .griddle-settings-toggle{\n            float:left;\n            width:50%;\n            text-align:right;\n          }\n\n          .griddle .griddle-settings{\n            background-color:#FFF;\n            border:1px solid #DDD;\n            color:#222;\n            padding:10px;\n            margin-bottom:10px;\n          }\n\n          .griddle .griddle-settings .griddle-columns{\n            clear:both;\n            display:table;\n            width:100%;\n            border-bottom:1px solid #EDEDED;\n            margin-bottom:10px;\n          }\n\n          .griddle .griddle-settings .griddle-column-selection{\n            float:left;\n            width:20%;\n          }\n          .griddle table{\n            width:100%;table-layout:fixed;\n          }\n\n          .griddle th{\n            background-color:#EDEDEF;\n            border:0px;\n            border-bottom:1px solid #DDD;\n            color:#222;\n            padding:5px;\n          }\n\n          .griddle td{\n            padding:5px;\n            background-color:#FFF;\n            border-top-color:#DDD;\n            color:#222;\n          }\n\n          .griddle .footer-container{\n            padding:0px;\n            background-color:#EDEDED;\n            border:0px;\n            color:#222;\n          }\n\n          .griddle .griddle-previous, .griddle .griddle-page, .griddle .griddle-next{\n            float:left;\n            width:33%;\n            min-height:1px;\n            margin-top:5px;\n          }\n\n          .griddle .griddle-page{\n            text-align:center;\n          }\n\n          .griddle .griddle-next{\n            text-align:right;\n          }\n\n        ');
        }
    }
};

},{"d982971d4ccb9e67":"9njXz"}],"blG6y":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _components = require("23fdbe004e7233f4");
var _components2 = _interopRequireDefault(_components);
var _reducers = require("d6f2c99fd112ef6");
var reducer = _interopRequireWildcard(_reducers);
var _localSelectors = require("fdabd62e9d4c861f");
var selectors = _interopRequireWildcard(_localSelectors);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = {
    components: _components2.default,
    reducer: reducer,
    selectors: selectors
};

},{"23fdbe004e7233f4":"QFs0Z","d6f2c99fd112ef6":"3ueMf","fdabd62e9d4c861f":"euBvc"}],"QFs0Z":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _TableBodyContainer = require("5341cafdc7f83ecd");
var _TableBodyContainer2 = _interopRequireDefault(_TableBodyContainer);
var _RowContainer = require("b5ef8b28d21e6f6d");
var _RowContainer2 = _interopRequireDefault(_RowContainer);
var _NextButtonContainer = require("c7c7da60baf73157");
var _NextButtonContainer2 = _interopRequireDefault(_NextButtonContainer);
var _PreviousButtonContainer = require("e3ceb8961fa84678");
var _PreviousButtonContainer2 = _interopRequireDefault(_PreviousButtonContainer);
var _PageDropdownContainer = require("dd04a77bffadd000");
var _PageDropdownContainer2 = _interopRequireDefault(_PageDropdownContainer);
var _TableContainer = require("15ee7614ac389d14");
var _TableContainer2 = _interopRequireDefault(_TableContainer);
var _TableHeadingCellContainer = require("19b1a2aa95963990");
var _TableHeadingCellContainer2 = _interopRequireDefault(_TableHeadingCellContainer);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = {
    TableBodyContainer: _TableBodyContainer2.default,
    RowContainer: _RowContainer2.default,
    NextButtonContainer: _NextButtonContainer2.default,
    PreviousButtonContainer: _PreviousButtonContainer2.default,
    PageDropdownContainer: _PageDropdownContainer2.default,
    TableContainer: _TableContainer2.default,
    TableHeadingCellContainer: _TableHeadingCellContainer2.default // TODO: Obsolete; remove
};

},{"5341cafdc7f83ecd":"1STD2","b5ef8b28d21e6f6d":"9EZEV","c7c7da60baf73157":"4xj4V","e3ceb8961fa84678":"bFn8D","dd04a77bffadd000":"1uWW5","15ee7614ac389d14":"cJ11w","19b1a2aa95963990":"5GP6z"}],"1STD2":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("f13008b6137ccfee");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("4b48782047872cf");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("c86e770e531d320d");
var _compose = require("51a292c1776455ff");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("46278cc4d1c12e94");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("c81e53d3076fc6cd");
var _getContext2 = _interopRequireDefault(_getContext);
var _localSelectors = require("50c8d259ac50059b");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ComposedTableBodyContainer = function ComposedTableBodyContainer(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object,
        selectors: _propTypes2.default.object
    }), (0, _mapProps2.default)(function(props) {
        return _extends({
            Row: props.components.Row,
            visibleRowIdsSelector: props.selectors.visibleRowIdsSelector
        }, props);
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            visibleRowIds: props.visibleRowIdsSelector(state),
            className: (0, _localSelectors.classNamesForComponentSelector)(state, 'TableBody'),
            style: (0, _localSelectors.stylesForComponentSelector)(state, 'TableBody')
        };
    }))(function(_ref) {
        var Row = _ref.Row, visibleRowIds = _ref.visibleRowIds, style = _ref.style, className = _ref.className;
        return _react2.default.createElement(OriginalComponent, {
            rowIds: visibleRowIds,
            Row: Row,
            style: style,
            className: className
        });
    });
};
exports.default = ComposedTableBodyContainer;

},{"f13008b6137ccfee":"9njXz","4b48782047872cf":"bnNSm","c86e770e531d320d":"cIMyH","51a292c1776455ff":"j6Pty","46278cc4d1c12e94":"dy8dd","c81e53d3076fc6cd":"eIqBR","50c8d259ac50059b":"euBvc"}],"euBvc":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.textSelector = exports.cellPropertiesSelector = exports.rowPropertiesSelector = exports.classNamesForComponentSelector = exports.stylesForComponentSelector = exports.iconsByNameSelector = exports.iconsForComponentSelector = exports.rowDataSelector = exports.cellValueSelector = exports.columnTitlesSelector = exports.columnIdsSelector = exports.hiddenColumnsSelector = exports.visibleRowCountSelector = exports.visibleRowIdsSelector = exports.visibleDataSelector = exports.currentPageDataSelector = exports.sortedDataSelector = exports.hasPreviousSelector = exports.hasNextSelector = exports.visibleColumnsSelector = exports.sortedColumnPropertiesSelector = exports.allColumnsSelector = exports.maxPageSelector = exports.filteredDataSelector = exports.metaDataColumnsSelector = exports.renderPropertiesSelector = exports.sortMethodSelector = exports.sortPropertiesSelector = exports.filterSelector = exports.pageSizeSelector = exports.currentPageSelector = exports.dataLoadingSelector = exports.dataSelector = undefined;
var _isFinite2 = require("8022ed6a7770005d");
var _isFinite3 = _interopRequireDefault(_isFinite2);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _immutable = require("48b8d5f489f09395");
var _immutable2 = _interopRequireDefault(_immutable);
var _reselect = require("ad4fdd692b2b15b6");
var _sortUtils = require("feebfcf3f2b8845d");
var _dataUtils = require("d3fdfcf13c44217d");
var _dataSelectors = require("f1d7d2a64648d9d3");
var dataSelectors = _interopRequireWildcard(_dataSelectors);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
/** Gets the entire data set
 * @param {Immutable} state - state object
 */ var dataSelector = exports.dataSelector = function dataSelector(state) {
    return state.get('data');
};
var dataLoadingSelector = exports.dataLoadingSelector = dataSelectors.dataLoadingSelector;
/** Gets the current page from pageProperties
 * @param {Immutable} state - state object
 */ var currentPageSelector = exports.currentPageSelector = function currentPageSelector(state) {
    return state.getIn([
        'pageProperties',
        'currentPage'
    ]);
};
/** Gets the currently set page size
 * @param {Immutable} state - state object
 */ var pageSizeSelector = exports.pageSizeSelector = function pageSizeSelector(state) {
    return state.getIn([
        'pageProperties',
        'pageSize'
    ]);
};
/** Gets the currently set filter
 */ var filterSelector = exports.filterSelector = function filterSelector(state) {
    return state.get('filter') || '';
};
var sortPropertiesSelector = exports.sortPropertiesSelector = function sortPropertiesSelector(state) {
    return state.get('sortProperties');
};
var sortMethodSelector = exports.sortMethodSelector = function sortMethodSelector(state) {
    return state.get('sortMethod');
};
var renderPropertiesSelector = exports.renderPropertiesSelector = function renderPropertiesSelector(state) {
    return state.get('renderProperties');
};
var metaDataColumnsSelector = exports.metaDataColumnsSelector = dataSelectors.metaDataColumnsSelector;
var columnPropertiesSelector = function columnPropertiesSelector(state) {
    return state.getIn([
        'renderProperties',
        'columnProperties'
    ]);
};
var substringSearch = function substringSearch(value, filter) {
    if (!filter) return true;
    var filterToLower = filter.toLowerCase();
    return value && value.toString().toLowerCase().indexOf(filterToLower) > -1;
};
var filterable = function filterable(columnProperties, key) {
    if (key === 'griddleKey') return false;
    if (columnProperties) {
        if (columnProperties.get(key) === undefined || columnProperties.getIn([
            key,
            'filterable'
        ]) === false) return false;
    }
    return true;
};
var textFilterRowSearch = function textFilterRowSearch(columnProperties, filter) {
    return function(row) {
        return row.keySeq().some(function(key) {
            if (!filterable(columnProperties, key)) return false;
            return substringSearch(row.get(key), filter);
        });
    };
};
var objectFilterRowSearch = function objectFilterRowSearch(columnProperties, filter) {
    return function(row, i, data) {
        return row.keySeq().every(function(key) {
            if (!filterable(columnProperties, key)) return true;
            var keyFilter = filter.get(key);
            switch(typeof keyFilter === 'undefined' ? 'undefined' : _typeof(keyFilter)){
                case 'string':
                    return substringSearch(row.get(key), keyFilter);
                case 'function':
                    return keyFilter(row.get(key), i, data);
                default:
                    return true;
            }
        });
    };
};
/** Gets the data filtered by the current filter
 */ var filteredDataSelector = exports.filteredDataSelector = (0, _reselect.createSelector)(dataSelector, filterSelector, columnPropertiesSelector, function(data, filter, columnProperties) {
    if (!filter || !data) return data;
    switch(typeof filter === 'undefined' ? 'undefined' : _typeof(filter)){
        case 'string':
            return data.filter(textFilterRowSearch(columnProperties, filter));
        case 'object':
            return data.filter(objectFilterRowSearch(columnProperties, filter));
        case 'function':
            return data.filter(filter);
        default:
            return data;
    }
});
/** Gets the max page size
 */ var maxPageSelector = exports.maxPageSelector = (0, _reselect.createSelector)(pageSizeSelector, filteredDataSelector, function(pageSize, data) {
    var total = data ? data.size : 0;
    var calc = total / pageSize;
    var result = calc > Math.floor(calc) ? Math.floor(calc) + 1 : Math.floor(calc);
    return (0, _isFinite3.default)(result) ? result : 1;
});
var allColumnsSelector = exports.allColumnsSelector = (0, _reselect.createSelector)(dataSelector, function(data) {
    return !data || data.size === 0 ? [] : data.get(0).keySeq().toJSON();
});
/** Gets the column properties objects sorted by order
 */ var sortedColumnPropertiesSelector = exports.sortedColumnPropertiesSelector = dataSelectors.sortedColumnPropertiesSelector;
/** Gets the visible columns either obtaining the sorted column properties or all columns
 */ var visibleColumnsSelector = exports.visibleColumnsSelector = dataSelectors.visibleColumnsSelector;
/** Returns whether or not this result set has more pages
 */ var hasNextSelector = exports.hasNextSelector = (0, _reselect.createSelector)(currentPageSelector, maxPageSelector, function(currentPage, maxPage) {
    return currentPage < maxPage;
});
/** Returns whether or not there is a previous page to the current data
 */ var hasPreviousSelector = exports.hasPreviousSelector = function hasPreviousSelector(state) {
    return state.getIn([
        'pageProperties',
        'currentPage'
    ]) > 1;
};
/** Gets the data sorted by the sort function specified in render properties
 *  if no sort method is supplied, it will use the default sort defined in griddle
 */ var sortedDataSelector = exports.sortedDataSelector = (0, _reselect.createSelector)(filteredDataSelector, sortPropertiesSelector, renderPropertiesSelector, sortMethodSelector, function(filteredData, sortProperties, renderProperties) {
    var sortMethod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _sortUtils.defaultSort;
    if (!sortProperties) return filteredData;
    return sortProperties.reverse().reduce(function(data, sortColumnOptions) {
        var columnProperties = renderProperties && renderProperties.get('columnProperties').get(sortColumnOptions.get('id'));
        var sortFunction = columnProperties && columnProperties.get('sortMethod') || sortMethod;
        return sortFunction(data, sortColumnOptions.get('id'), sortColumnOptions.get('sortAscending'));
    }, filteredData);
});
/** Gets the current page of data
 */ var currentPageDataSelector = exports.currentPageDataSelector = (0, _reselect.createSelector)(sortedDataSelector, pageSizeSelector, currentPageSelector, function(sortedData, pageSize, currentPage) {
    if (!sortedData) return [];
    return sortedData.skip(pageSize * (currentPage - 1)).take(pageSize);
});
/** Get the visible data (and only the columns that are visible)
 */ var visibleDataSelector = exports.visibleDataSelector = (0, _reselect.createSelector)(currentPageDataSelector, visibleColumnsSelector, function(currentPageData, visibleColumns) {
    return (0, _dataUtils.getVisibleDataForColumns)(currentPageData, visibleColumns);
});
/** Gets the griddleIds for the visible rows */ var visibleRowIdsSelector = exports.visibleRowIdsSelector = (0, _reselect.createSelector)(currentPageDataSelector, function(currentPageData) {
    return currentPageData ? currentPageData.map(function(c) {
        return c.get('griddleKey');
    }) : new _immutable2.default.List();
});
/** Gets the count of visible rows */ var visibleRowCountSelector = exports.visibleRowCountSelector = (0, _reselect.createSelector)(visibleRowIdsSelector, function(visibleRowIds) {
    return visibleRowIds.size;
});
/** Gets the columns that are not currently visible
 */ var hiddenColumnsSelector = exports.hiddenColumnsSelector = (0, _reselect.createSelector)(visibleColumnsSelector, allColumnsSelector, metaDataColumnsSelector, function(visibleColumns, allColumns, metaDataColumns) {
    var removeColumns = [].concat(_toConsumableArray(visibleColumns), _toConsumableArray(metaDataColumns));
    return allColumns.filter(function(c) {
        return removeColumns.indexOf(c) === -1;
    });
});
/** Gets the column ids for the visible columns
*/ var columnIdsSelector = exports.columnIdsSelector = (0, _reselect.createSelector)(visibleDataSelector, renderPropertiesSelector, function(visibleData, renderProperties) {
    if (visibleData.size > 0) return Object.keys(visibleData.get(0).toJSON()).map(function(k) {
        return renderProperties.getIn([
            'columnProperties',
            k,
            'id'
        ]) || k;
    });
});
/** Gets the column titles for the visible columns
 */ var columnTitlesSelector = exports.columnTitlesSelector = dataSelectors.columnTitlesSelector;
var cellValueSelector = exports.cellValueSelector = dataSelectors.cellValueSelector;
var rowDataSelector = exports.rowDataSelector = dataSelectors.rowDataSelector;
var iconsForComponentSelector = exports.iconsForComponentSelector = dataSelectors.iconsForComponentSelector;
var iconsByNameSelector = exports.iconsByNameSelector = dataSelectors.iconsForComponentSelector;
var stylesForComponentSelector = exports.stylesForComponentSelector = dataSelectors.stylesForComponentSelector;
var classNamesForComponentSelector = exports.classNamesForComponentSelector = dataSelectors.classNamesForComponentSelector;
var rowPropertiesSelector = exports.rowPropertiesSelector = dataSelectors.rowPropertiesSelector;
var cellPropertiesSelector = exports.cellPropertiesSelector = dataSelectors.cellPropertiesSelector;
var textSelector = exports.textSelector = dataSelectors.textSelector;

},{"8022ed6a7770005d":"kWFgN","48b8d5f489f09395":"AnTq9","ad4fdd692b2b15b6":"eYQTI","feebfcf3f2b8845d":"aBsX5","d3fdfcf13c44217d":"c7t27","f1d7d2a64648d9d3":"4c1CS"}],"9EZEV":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("73e8d305e8a95559");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("a533262adb79f993");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("faccbb1b9436bfe3");
var _compose = require("4f511ad9b7033324");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("4b1c59ace9bbf3e");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("89afbf67380e605d");
var _getContext2 = _interopRequireDefault(_getContext);
var _localSelectors = require("8641538e99092531");
var _valueUtils = require("f0f6333f3d1d345a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var ComposedRowContainer = function ComposedRowContainer(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            columnIds: (0, _localSelectors.columnIdsSelector)(state),
            rowProperties: (0, _localSelectors.rowPropertiesSelector)(state),
            rowData: (0, _localSelectors.rowDataSelector)(state, props),
            className: (0, _localSelectors.classNamesForComponentSelector)(state, 'Row'),
            style: (0, _localSelectors.stylesForComponentSelector)(state, 'Row')
        };
    }), (0, _mapProps2.default)(function(props) {
        var components = props.components, rowProperties = props.rowProperties, className = props.className, otherProps = _objectWithoutProperties(props, [
            'components',
            'rowProperties',
            'className'
        ]);
        return _extends({
            Cell: components.Cell,
            className: (0, _valueUtils.valueOrResult)(rowProperties.cssClassName, props) || props.className
        }, otherProps);
    }))(function(_ref) {
        var Cell = _ref.Cell, columnIds = _ref.columnIds, griddleKey = _ref.griddleKey, style = _ref.style, className = _ref.className;
        return _react2.default.createElement(OriginalComponent, {
            griddleKey: griddleKey,
            columnIds: columnIds,
            Cell: Cell,
            className: className,
            style: style
        });
    });
};
exports.default = ComposedRowContainer;

},{"73e8d305e8a95559":"9njXz","a533262adb79f993":"bnNSm","faccbb1b9436bfe3":"cIMyH","4f511ad9b7033324":"j6Pty","4b1c59ace9bbf3e":"dy8dd","89afbf67380e605d":"eIqBR","8641538e99092531":"euBvc","f0f6333f3d1d345a":"kAOrs"}],"4xj4V":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("b64b2cfc29d6fe70");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("ecdbf8dc043ae179");
var _localSelectors = require("484f29aa85a6188");
var _actions = require("49a20824a1f36fbb");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var enhance = function enhance(OriginalComponent) {
    return (0, _griddleConnect.connect)(function(state) {
        return {
            text: (0, _localSelectors.textSelector)(state, {
                key: 'next'
            }),
            hasNext: (0, _localSelectors.hasNextSelector)(state),
            className: (0, _localSelectors.classNamesForComponentSelector)(state, 'NextButton'),
            style: (0, _localSelectors.stylesForComponentSelector)(state, 'NextButton')
        };
    }, {
        getNext: _actions.getNext
    })(function(props) {
        return _react2.default.createElement(OriginalComponent, _extends({}, props, {
            onClick: props.getNext
        }));
    });
};
exports.default = enhance;

},{"b64b2cfc29d6fe70":"9njXz","ecdbf8dc043ae179":"cIMyH","484f29aa85a6188":"euBvc","49a20824a1f36fbb":"fHAx9"}],"bFn8D":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _react = require("281ba6fbb969eb61");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("6ebf6092917fa90e");
var _localSelectors = require("92daf6d8f99841e0");
var _actions = require("3bf53857c1438287");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var enhance = function enhance(OriginalComponent) {
    return (0, _griddleConnect.connect)(function(state) {
        return {
            text: (0, _localSelectors.textSelector)(state, {
                key: 'previous'
            }),
            hasPrevious: (0, _localSelectors.hasPreviousSelector)(state),
            className: (0, _localSelectors.classNamesForComponentSelector)(state, 'PreviousButton'),
            style: (0, _localSelectors.stylesForComponentSelector)(state, 'PreviousButton')
        };
    }, {
        getPrevious: _actions.getPrevious
    })(function(props) {
        return _react2.default.createElement(OriginalComponent, _extends({}, props, {
            onClick: props.getPrevious
        }));
    });
};
exports.default = enhance;

},{"281ba6fbb969eb61":"9njXz","6ebf6092917fa90e":"cIMyH","92daf6d8f99841e0":"euBvc","3bf53857c1438287":"fHAx9"}],"1uWW5":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("ae93b262592fef6a");
var _react2 = _interopRequireDefault(_react);
var _griddleConnect = require("8c1cbe4013a9aaa7");
var _reselect = require("8aaad766d6b224d9");
var _localSelectors = require("f6767992a2e66428");
var _actions = require("c8b7efbad5f92b83");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var enhance = function enhance(OriginalComponent) {
    return (0, _griddleConnect.connect)(function(state) {
        return {
            maxPages: (0, _localSelectors.maxPageSelector)(state),
            currentPage: (0, _localSelectors.currentPageSelector)(state),
            className: (0, _localSelectors.classNamesForComponentSelector)(state, 'PageDropdown'),
            style: (0, _localSelectors.stylesForComponentSelector)(state, 'PageDropdown')
        };
    }, {
        setPage: _actions.setPage
    })(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = enhance;

},{"ae93b262592fef6a":"9njXz","8c1cbe4013a9aaa7":"cIMyH","8aaad766d6b224d9":"eYQTI","f6767992a2e66428":"euBvc","c8b7efbad5f92b83":"fHAx9"}],"cJ11w":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("6fa08dbadb1831c9");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("6d4a7d0b5278b59b");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("9bc9c7b2d3b9701");
var _compose = require("38ced0b3f5321501");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("2bae15935c951e9e");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("9e8e1506e717773c");
var _getContext2 = _interopRequireDefault(_getContext);
var _localSelectors = require("8ad40dcfd8cd9a49");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ComposedContainerComponent = function ComposedContainerComponent(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        components: _propTypes2.default.object
    }), (0, _mapProps2.default)(function(props) {
        return {
            TableHeading: props.components.TableHeading,
            TableBody: props.components.TableBody,
            Loading: props.components.Loading,
            NoResults: props.components.NoResults
        };
    }), (0, _griddleConnect.connect)(function(state, props) {
        return {
            dataLoading: (0, _localSelectors.dataLoadingSelector)(state),
            visibleRows: (0, _localSelectors.visibleRowCountSelector)(state),
            className: (0, _localSelectors.classNamesForComponentSelector)(state, 'Table'),
            style: (0, _localSelectors.stylesForComponentSelector)(state, 'Table')
        };
    }))(function(props) {
        return _react2.default.createElement(OriginalComponent, props);
    });
};
exports.default = ComposedContainerComponent;

},{"6fa08dbadb1831c9":"9njXz","6d4a7d0b5278b59b":"bnNSm","9bc9c7b2d3b9701":"cIMyH","38ced0b3f5321501":"j6Pty","2bae15935c951e9e":"dy8dd","9e8e1506e717773c":"eIqBR","8ad40dcfd8cd9a49":"euBvc"}],"5GP6z":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _TableHeadingCellContainer = require("8d3b22eb5d2c9d24");
var _TableHeadingCellContainer2 = _interopRequireDefault(_TableHeadingCellContainer);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Obsolete
var EnhancedHeadingCell = _TableHeadingCellContainer2.default;
exports.default = EnhancedHeadingCell;

},{"8d3b22eb5d2c9d24":"8I13p"}],"3ueMf":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GRIDDLE_INITIALIZED = GRIDDLE_INITIALIZED;
exports.GRIDDLE_LOADED_DATA = GRIDDLE_LOADED_DATA;
exports.GRIDDLE_SET_PAGE_SIZE = GRIDDLE_SET_PAGE_SIZE;
exports.GRIDDLE_SET_PAGE = GRIDDLE_SET_PAGE;
exports.GRIDDLE_NEXT_PAGE = GRIDDLE_NEXT_PAGE;
exports.GRIDDLE_PREVIOUS_PAGE = GRIDDLE_PREVIOUS_PAGE;
exports.GRIDDLE_SET_FILTER = GRIDDLE_SET_FILTER;
exports.GRIDDLE_SET_SORT = GRIDDLE_SET_SORT;
var _immutable = require("b62b94a4ff20ea9");
var _immutable2 = _interopRequireDefault(_immutable);
var _localSelectors = require("66745fcaf7141f0b");
var _dataReducer = require("8776f65bf3242104");
var dataReducers = _interopRequireWildcard(_dataReducer);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function GRIDDLE_INITIALIZED(state) {
    return dataReducers.GRIDDLE_INITIALIZED(state);
}
/** Sets the Griddle data
 * @param {Immutable} state - Immutable state object
 * @param {Object} action - the action object to work with
 *
 * This simply wraps dataReducer
 */ function GRIDDLE_LOADED_DATA(state, action) {
    return dataReducers.GRIDDLE_LOADED_DATA(state, action);
}
/** Sets the page size
 * @param {Immutable} state - Immutable state object
 * @param {Object} action - the action object to work with
 *
 * This simply wraps dataReducer
 */ function GRIDDLE_SET_PAGE_SIZE(state, action) {
    return dataReducers.GRIDDLE_SET_PAGE_SIZE(state, action);
}
/** Sets the current page
 * @param {Immutable} state - Immutable state object
 * @param {Object} action - the action object to work with
 *
 * This simply wraps dataReducer
 */ function GRIDDLE_SET_PAGE(state, action) {
    return dataReducers.GRIDDLE_SET_PAGE(state, action);
}
function GRIDDLE_NEXT_PAGE(state, action) {
    var maxPage = (0, _localSelectors.maxPageSelector)(state);
    var currentPage = (0, _localSelectors.currentPageSelector)(state);
    if (currentPage < maxPage) return state.setIn([
        'pageProperties',
        'currentPage'
    ], currentPage + 1);
    return state;
}
function GRIDDLE_PREVIOUS_PAGE(state, action) {
    var currentPage = (0, _localSelectors.currentPageSelector)(state);
    if (currentPage > 0) return state.setIn([
        'pageProperties',
        'currentPage'
    ], currentPage - 1);
    return state;
}
/** Sets the current filter
 * @param {Immutable} state - Immutable state object
 * @param {Object} action - the action object to work with
 *
 */ function GRIDDLE_SET_FILTER(state, action) {
    return state.set('filter', action.filter && _immutable2.default.fromJS(action.filter)).setIn([
        'pageProperties',
        'currentPage'
    ], 1);
}
/** Sets the sort options
 * @param {Immutable} state - Immutable state object
 * @param {Object} action - the action object to work with
 *
 * This simply wraps dataReducer
 */ function GRIDDLE_SET_SORT(state, action) {
    return dataReducers.GRIDDLE_SET_SORT(state, action);
}

},{"b62b94a4ff20ea9":"AnTq9","66745fcaf7141f0b":"euBvc","8776f65bf3242104":"eV7y2"}],"cdfg5":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _components = require("33f624c10b8e8340");
var _components2 = _interopRequireDefault(_components);
var _reducers = require("e928acc4851fea19");
var reducer = _interopRequireWildcard(_reducers);
var _initialState = require("687c138496288cdd");
var _initialState2 = _interopRequireDefault(_initialState);
var _selectors = require("ed6a632ac40ca20");
var selectors = _interopRequireWildcard(_selectors);
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var PositionPlugin = function PositionPlugin(config) {
    return {
        initialState: _extends({}, _initialState2.default, {
            positionSettings: Object.assign({}, _initialState2.default.positionSettings, config)
        }),
        components: _components2.default,
        reducer: reducer,
        selectors: selectors
    };
};
exports.default = PositionPlugin;

},{"33f624c10b8e8340":"7bLNk","e928acc4851fea19":"bZyJ6","687c138496288cdd":"ezWzA","ed6a632ac40ca20":"cLJc8"}],"7bLNk":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _Pagination = require("8ae668328499d99d");
var _Pagination2 = _interopRequireDefault(_Pagination);
var _SpacerRow = require("fd30c77ac8ac6cf7");
var _SpacerRow2 = _interopRequireDefault(_SpacerRow);
var _TableBody = require("fff93047d1521b24");
var _TableBody2 = _interopRequireDefault(_TableBody);
var _TableEnhancer = require("2b1205e6caf75f16");
var _TableEnhancer2 = _interopRequireDefault(_TableEnhancer);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = {
    Pagination: _Pagination2.default,
    SpacerRow: _SpacerRow2.default,
    TableBody: _TableBody2.default,
    TableEnhancer: _TableEnhancer2.default
};

},{"8ae668328499d99d":"c1ivu","fd30c77ac8ac6cf7":"2OVYl","fff93047d1521b24":"egQOy","2b1205e6caf75f16":"creCu"}],"c1ivu":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("8feded565567dba1");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// We're not going to be displaying a pagination bar for infinite scrolling.
var PaginationComponent = function PaginationComponent(props) {
    return _react2.default.createElement('span', null);
};
exports.default = PaginationComponent;

},{"8feded565567dba1":"9njXz"}],"2OVYl":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _class, _temp;
var _react = require("b6a5168ef32e4e85");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("b073a518fb559780");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("6a2043071d2cb034");
var _compose = require("11d631451e0de535");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("b67b2b0bd19d4216");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("a41b7bd72b57b46d");
var _getContext2 = _interopRequireDefault(_getContext);
var _withHandlers = require("483f690324080c55");
var _withHandlers2 = _interopRequireDefault(_withHandlers);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var spacerRow = (0, _compose2.default)((0, _getContext2.default)({
    selectors: _propTypes2.default.object
}), (0, _griddleConnect.connect)(function(state, props) {
    var _props$selectors = props.selectors, topSpacerSelector = _props$selectors.topSpacerSelector, bottomSpacerSelector = _props$selectors.bottomSpacerSelector;
    var placement = props.placement;
    return {
        spacerHeight: placement === 'top' ? topSpacerSelector(state, props) : bottomSpacerSelector(state, props)
    };
}), (0, _mapProps2.default)(function(props) {
    return {
        placement: props.placement,
        spacerHeight: props.spacerHeight
    };
}))((_temp = _class = function(_Component) {
    _inherits(_class, _Component);
    function _class() {
        _classCallCheck(this, _class);
        return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }
    _createClass(_class, [
        {
            key: 'render',
            // shouldComponentUpdate(nextProps) {
            //   const { currentPosition: oldPosition, placement: oldPlacement } = this.props;
            //   const { currentPosition, placement } = nextProps;
            //
            //   return oldPosition !== currentPosition || oldPlacement !== placement;
            // }
            value: function render() {
                var _props = this.props, placement = _props.placement, spacerHeight = _props.spacerHeight;
                var spacerRowStyle = {
                    height: spacerHeight + 'px'
                };
                return _react2.default.createElement('tr', {
                    key: placement + '-' + spacerHeight,
                    style: spacerRowStyle
                });
            }
        }
    ]);
    return _class;
}(_react.Component), _class.propTypes = {
    placement: _propTypes2.default.string,
    spacerHeight: _propTypes2.default.number
}, _class.defaultProps = {
    placement: 'top'
}, _temp));
exports.default = spacerRow;

},{"b6a5168ef32e4e85":"9njXz","b073a518fb559780":"bnNSm","6a2043071d2cb034":"cIMyH","11d631451e0de535":"j6Pty","b67b2b0bd19d4216":"dy8dd","a41b7bd72b57b46d":"eIqBR","483f690324080c55":"5V2aT"}],"egQOy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _react = require("81b7b3317832d490");
var _react2 = _interopRequireDefault(_react);
var _SpacerRow = require("932f7e0ee0479e8b");
var _SpacerRow2 = _interopRequireDefault(_SpacerRow);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var TableBody = function TableBody(_ref) {
    var rowIds = _ref.rowIds, Row = _ref.Row;
    return _react2.default.createElement('tbody', null, _react2.default.createElement(_SpacerRow2.default, {
        placement: 'top'
    }), rowIds && rowIds.map(function(r) {
        return _react2.default.createElement(Row, {
            key: r,
            griddleKey: r
        });
    }), _react2.default.createElement(_SpacerRow2.default, {
        placement: 'bottom'
    }));
};
exports.default = TableBody;

},{"81b7b3317832d490":"9njXz","932f7e0ee0479e8b":"2OVYl"}],"creCu":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("f02a53fd14841cab");
var _react2 = _interopRequireDefault(_react);
var _propTypes = require("ea340b11718c0ab7");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _griddleConnect = require("45248e5d691ebd20");
var _compose = require("890aa632d10753ae");
var _compose2 = _interopRequireDefault(_compose);
var _mapProps = require("cf6ff041256f849c");
var _mapProps2 = _interopRequireDefault(_mapProps);
var _getContext = require("f3f8c64cc88e4fc1");
var _getContext2 = _interopRequireDefault(_getContext);
var _actions = require("59606547e3ba887c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var Table = function Table(OriginalComponent) {
    return (0, _compose2.default)((0, _getContext2.default)({
        selectors: _propTypes2.default.object
    }), (0, _griddleConnect.connect)(function(state, props) {
        var _props$selectors = props.selectors, tableHeightSelector = _props$selectors.tableHeightSelector, tableWidthSelector = _props$selectors.tableWidthSelector, rowHeightSelector = _props$selectors.rowHeightSelector;
        return {
            TableHeight: tableHeightSelector(state),
            TableWidth: tableWidthSelector(state),
            RowHeight: rowHeightSelector(state)
        };
    }, {
        setScrollPosition: _actions.setScrollPosition
    }), (0, _mapProps2.default)(function(props) {
        var selectors = props.selectors, restProps = _objectWithoutProperties(props, [
            'selectors'
        ]);
        return restProps;
    }))(function(_Component) {
        _inherits(_class2, _Component);
        function _class2(props, context) {
            _classCallCheck(this, _class2);
            var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, props, context));
            _this._scroll = function() {
                var _this$props = _this.props, setScrollPosition = _this$props.setScrollPosition, RowHeight = _this$props.RowHeight;
                var scrollTop = _this.state.scrollTop;
                if (_this._scrollable && Math.abs(_this._scrollable.scrollTop - scrollTop) >= RowHeight) {
                    setScrollPosition(_this._scrollable.scrollLeft, _this._scrollable.scrollWidth, _this._scrollable.clientWidth, _this._scrollable.scrollTop, _this._scrollable.scrollHeight, _this._scrollable.clientHeight);
                    _this.setState({
                        scrollTop: _this._scrollable.scrollTop
                    });
                }
            };
            _this.state = {
                scrollTop: 0
            };
            return _this;
        }
        _createClass(_class2, [
            {
                key: 'render',
                value: function render() {
                    var _this2 = this;
                    var _props = this.props, TableHeight = _props.TableHeight, TableWidth = _props.TableWidth;
                    var scrollStyle = {
                        'overflow': TableHeight && TableWidth ? 'scroll' : null,
                        'overflowY': TableHeight && !TableWidth ? 'scroll' : null,
                        'overflowX': !TableHeight && TableWidth ? 'scroll' : null,
                        'height': TableHeight ? TableHeight : null,
                        'width': TableWidth ? TableWidth : null,
                        'display': 'inline-block'
                    };
                    return _react2.default.createElement('div', {
                        ref: function ref(_ref) {
                            return _this2._scrollable = _ref;
                        },
                        style: scrollStyle,
                        onScroll: this._scroll
                    }, _react2.default.createElement(OriginalComponent, this.props));
                }
            }
        ]);
        return _class2;
    }(_react.Component));
};
exports.default = Table;

},{"f02a53fd14841cab":"9njXz","ea340b11718c0ab7":"bnNSm","45248e5d691ebd20":"cIMyH","890aa632d10753ae":"j6Pty","cf6ff041256f849c":"dy8dd","f3f8c64cc88e4fc1":"eIqBR","59606547e3ba887c":"gTzPY"}],"gTzPY":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setScrollPosition = setScrollPosition;
var _constants = require("9a66d438a83b9814");
function setScrollPosition(xScrollPosition, xScrollMax, xVisible, yScrollPosition, yScrollMax, yVisible) {
    return {
        type: _constants.XY_POSITION_CHANGED,
        xScrollPosition: xScrollPosition,
        xScrollMax: xScrollMax,
        xVisible: xVisible,
        yScrollPosition: yScrollPosition,
        yScrollMax: yScrollMax,
        yVisible: yVisible
    };
}

},{"9a66d438a83b9814":"bOnPs"}],"bOnPs":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var XY_POSITION_CHANGED = exports.XY_POSITION_CHANGED = 'XY_POSITION_CHANGED';

},{}],"bZyJ6":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.XY_POSITION_CHANGED = XY_POSITION_CHANGED;
exports.GRIDDLE_SET_FILTER_AFTER = GRIDDLE_SET_FILTER_AFTER;
var _utils = require("c923f72afff43c6");
function XY_POSITION_CHANGED(state, action) {
    var height = state.getIn([
        'currentPosition',
        'height'
    ]) || 0;
    var width = state.getIn([
        'currentPosition',
        'width'
    ]) || 0;
    return state.setIn([
        'currentPosition',
        'xScrollChangePosition'
    ], action.xScrollPosition || 0).setIn([
        'currentPosition',
        'yScrollChangePosition'
    ], action.yScrollPosition || 0).setIn([
        'currentPosition',
        'height'
    ], action.height || height).setIn([
        'currentPosition',
        'width'
    ], action.width || width);
}
function GRIDDLE_SET_FILTER_AFTER(state, action, helpers) {
    return state.setIn([
        'currentPosition',
        'xScrollChangePosition'
    ], 0).setIn([
        'currentPosition',
        'yScrollChangePosition'
    ], 0);
}

},{"c923f72afff43c6":"e1geL"}],"e1geL":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldUpdateDrawnRows = shouldUpdateDrawnRows;
exports.setCurrentPosition = setCurrentPosition;
exports.updatePositionProperties = updatePositionProperties;
exports.updateRenderedData = updateRenderedData;
var _immutable = require("b32de98fa451ea9e");
var _immutable2 = _interopRequireDefault(_immutable);
var _initialState = require("67a55b9d42f127df");
var _initialState2 = _interopRequireDefault(_initialState);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function shouldUpdateDrawnRows(action, state) {
    var height = state.getIn([
        'currentPosition',
        'height'
    ]);
    var width = state.getIn([
        'currentPosition',
        'width'
    ]);
    // If the containers have changed size, update drawn rows.
    if (height != action.yVisible || width != action.xVisible) return true;
    var yScrollChangePosition = state.getIn([
        'currentPosition',
        'yScrollChangePosition'
    ]);
    var rowHeight = state.getIn([
        'positionConfig',
        'rowHeight'
    ]);
    // Get the current visible record count.
    var visibleRecordCount = getVisibleRecordCount(state);
    // Get the count of rendered rows.
    var startDisplayIndex = state.getIn([
        'currentPosition',
        'renderedStartDisplayIndex'
    ]);
    var endDisplayIndex = state.getIn([
        'currentPosition',
        'renderedEndDisplayIndex'
    ]);
    var renderedRecordCount = endDisplayIndex - startDisplayIndex;
    // Calculate the height of a third of the difference.
    var rowDifferenceHeight = rowHeight * (renderedRecordCount - visibleRecordCount) / 3;
    return Math.abs(action.yScrollPosition - yScrollChangePosition) >= rowDifferenceHeight;
}
function setCurrentPosition(state, yScrollPosition, xScrollPosition) {
    return state.setIn([
        'currentPosition',
        'yScrollChangePosition'
    ], yScrollPosition).setIn([
        'currentPosition',
        'xScrollChangePosition'
    ], xScrollPosition);
}
function updatePositionProperties(action, state, force) {
    if (!action.force && !shouldUpdateDrawnRows(action, state) && !_immutable2.default.is(state.get('currentPosition'), (0, _initialState2.default)().get('currentPosition'))) return state; // Indicate that this shouldn't result in an emit.
    var sizeUpdatedState = state.setIn([
        'currentPosition',
        'height'
    ], action.yVisible ? action.yVisible * 1.2 : state.getIn([
        'currentPosition',
        'height'
    ])).setIn([
        'currentPosition',
        'width'
    ], action.xVisible || state.getIn([
        'currentPosition',
        'width'
    ]));
    var visibleRecordCount = getVisibleRecordCount(sizeUpdatedState);
    var visibleDataLength = helpers.getDataSetSize(sizeUpdatedState);
    var rowHeight = sizeUpdatedState.getIn([
        'positionConfig',
        'rowHeight'
    ]);
    var verticalScrollPosition = action.yScrollPosition || 0;
    var horizontalScrollPosition = action.xScrollPosition || 0;
    // Inspired by : http://jsfiddle.net/vjeux/KbWJ2/9/
    var renderedStartDisplayIndex = Math.max(0, Math.floor(Math.floor(verticalScrollPosition / rowHeight) - visibleRecordCount * 0.25));
    var renderedEndDisplayIndex = Math.min(Math.floor(renderedStartDisplayIndex + visibleRecordCount * 2), visibleDataLength - 1) + 1;
    return setCurrentPosition(sizeUpdatedState, verticalScrollPosition, horizontalScrollPosition).setIn([
        'currentPosition',
        'renderedStartDisplayIndex'
    ], renderedStartDisplayIndex).setIn([
        'currentPosition',
        'renderedEndDisplayIndex'
    ], renderedEndDisplayIndex).setIn([
        'currentPosition',
        'visibleDataLength'
    ], visibleDataLength);
}
function updateRenderedData(state) {
    var startDisplayIndex = state.getIn([
        'currentPosition',
        'renderedStartDisplayIndex'
    ]);
    var columns = helpers.getDataColumns(state, data);
    var data = helpers.getDataSet(state);
    return state.set('renderedData', helpers.getVisibleDataColumns(data.skip(startDisplayIndex).take(state.getIn([
        'currentPosition',
        'renderedEndDisplayIndex'
    ]) - startDisplayIndex), columns));
}

},{"b32de98fa451ea9e":"AnTq9","67a55b9d42f127df":"ezWzA"}],"ezWzA":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var initialState = {
    renderedData: [],
    currentPosition: {
        height: 500,
        width: 500,
        xScrollChangePosition: 0,
        yScrollChangePosition: 0,
        renderedStartDisplayIndex: 0,
        renderedEndDisplayIndex: 16,
        visibleDataLength: 16
    },
    positionSettings: {
        // The height of the table
        tableHeight: '70%',
        // The width of the table
        tableWidth: null,
        // The minimum row height
        rowHeight: 30,
        // The minimum column width
        defaultColumnWidth: null,
        // Whether or not the header should be fixed
        fixedHeader: true,
        // Disable pointer events while scrolling to improve performance
        disablePointerEvents: false
    }
};
exports.default = initialState;

},{}],"cLJc8":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.visibleRowIdsSelector = exports.visibleDataSelector = exports.currentPageDataSelector = exports.bottomSpacerSelector = exports.topSpacerSelector = exports.endIndexSelector = exports.startIndexSelector = exports.verticalScrollChangeSelector = exports.hoizontalScrollChangeSelector = exports.visibleDataLengthSelector = exports.visibleRecordCountSelector = exports.tableWidthSelector = exports.tableHeightSelector = exports.currentHeightSelector = exports.rowHeightSelector = exports.positionSettingsSelector = undefined;
var _reselect = require("a49e7af2ac9c2043");
var _localSelectors = require("93c1d1ff96ddbeb");
var positionSettingsSelector = exports.positionSettingsSelector = function positionSettingsSelector(state) {
    return state.get('positionSettings');
};
var rowHeightSelector = exports.rowHeightSelector = function rowHeightSelector(state) {
    return state.getIn([
        'positionSettings',
        'rowHeight'
    ]);
};
var currentHeightSelector = exports.currentHeightSelector = function currentHeightSelector(state) {
    return state.getIn([
        'currentPosition',
        'height'
    ]);
};
var tableHeightSelector = exports.tableHeightSelector = function tableHeightSelector(state) {
    return state.getIn([
        'positionSettings',
        'tableHeight'
    ]);
};
var tableWidthSelector = exports.tableWidthSelector = function tableWidthSelector(state) {
    return state.getIn([
        'positionSettings',
        'tableWidth'
    ]);
};
// From what i can tell from the original virtual scrolling plugin...
// 1. We want to get the visible record count
// 2. Get the size of the dataset we're working with (whether thats local or remote)
// 3. Figure out the renderedStart and End display index
// 4. Show only the records that'd fall in the render indexes
/** Gets the number of viisble rows based on the height of the container and the rowHeight
 */ var visibleRecordCountSelector = exports.visibleRecordCountSelector = (0, _reselect.createSelector)(rowHeightSelector, currentHeightSelector, function(rowHeight, currentHeight) {
    return Math.ceil(currentHeight / rowHeight);
});
var visibleDataLengthSelector = exports.visibleDataLengthSelector = (0, _reselect.createSelector)(_localSelectors.sortedDataSelector, function(sortedData) {
    return sortedData.size;
});
var hoizontalScrollChangeSelector = exports.hoizontalScrollChangeSelector = function hoizontalScrollChangeSelector(state) {
    return state.getIn([
        'currentPosition',
        'xScrollChangePosition'
    ]) || 0;
};
var verticalScrollChangeSelector = exports.verticalScrollChangeSelector = function verticalScrollChangeSelector(state) {
    return state.getIn([
        'currentPosition',
        'yScrollChangePosition'
    ]) || 0;
};
var startIndexSelector = exports.startIndexSelector = (0, _reselect.createSelector)(verticalScrollChangeSelector, rowHeightSelector, visibleRecordCountSelector, function(verticalScrollPosition, rowHeight, visibleRecordCount) {
    // Inspired by : http://jsfiddle.net/vjeux/KbWJ2/9/
    return Math.max(0, Math.floor(Math.floor(verticalScrollPosition / rowHeight) - visibleRecordCount * 0.25));
});
var endIndexSelector = exports.endIndexSelector = (0, _reselect.createSelector)(startIndexSelector, visibleRecordCountSelector, visibleDataLengthSelector, function(startDisplayIndex, visibleRecordCount, visibleDataLength) {
    // Inspired by : http://jsfiddle.net/vjeux/KbWJ2/9/
    return Math.min(Math.floor(startDisplayIndex + visibleRecordCount * 2), visibleDataLength - 1) + 1;
});
var topSpacerSelector = exports.topSpacerSelector = (0, _reselect.createSelector)(rowHeightSelector, startIndexSelector, function(rowHeight, startIndex) {
    return rowHeight * startIndex;
});
var bottomSpacerSelector = exports.bottomSpacerSelector = (0, _reselect.createSelector)(rowHeightSelector, visibleDataLengthSelector, endIndexSelector, function(rowHeight, visibleDataLength, endIndex) {
    return rowHeight * (visibleDataLength - endIndex);
});
/** Gets the current page of data
 * Won't be memoized :cry:
 */ var currentPageDataSelector = exports.currentPageDataSelector = function currentPageDataSelector() {
    return (0, _reselect.createSelector)(_localSelectors.sortedDataSelector, startIndexSelector, endIndexSelector, function(sortedData, startDisplayIndex, endDisplayIndex) {
        return sortedData.skip(startDisplayIndex).take(endDisplayIndex - startDisplayIndex);
    }).apply(undefined, arguments);
};
/** Get the visible data (and only the columns that are visible)
 */ var visibleDataSelector = exports.visibleDataSelector = (0, _reselect.createSelector)(currentPageDataSelector, _localSelectors.visibleColumnsSelector, function(currentPageData, visibleColumns) {
    return getVisibleDataForColumns(currentPageData, visibleColumns);
});
/** Gets the griddleIds for the visible rows */ var visibleRowIdsSelector = exports.visibleRowIdsSelector = (0, _reselect.createSelector)(currentPageDataSelector, function(currentPageData) {
    return currentPageData.map(function(c) {
        return c.get('griddleKey');
    });
});

},{"a49e7af2ac9c2043":"eYQTI","93c1d1ff96ddbeb":"euBvc"}],"kU1GJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "register", ()=>register);
parcelHelpers.export(exports, "default", ()=>trigger);
var _lodash = require("lodash");
var _deepDiff = require("deep-diff");
var _deepDiffDefault = parcelHelpers.interopDefault(_deepDiff);
const log = console.log.bind(console);
const hooks = [];
function register(path, trigger) {
    const paths = (0, _lodash.isArray)(path) ? path : [
        path
    ];
    const triggers = (0, _lodash.isArray)(trigger) ? trigger : [
        trigger
    ];
    paths.forEach((p)=>triggers.forEach((t)=>hooks.push(createHook(p, t))));
}
function createHook(path, callback) {
    const trigger = (...diff)=>(...args)=>callback.apply(path, args.concat(diff));
    const hook = {
        path,
        trigger,
        hook: callback
    };
    return hook;
}
function trigger(current, previous) {
    const difference = (0, _deepDiffDefault.default)(current, previous, filterHooks);
    if (difference) {
        const hooks = (0, _lodash.chain)(difference).map(createTrigger).flatten().uniqBy('hook').map((hook)=>({
                ...hook,
                trigger: hook.trigger(hook.diff)
            })).value();
        hooks.forEach((hook)=>hook.trigger(current, hook.path, hook.diff));
    }
}
function filterHooks(path, key) {
    const id = path.concat([
        key
    ]).join('/');
    return !hooks.some(matchHookId(id));
}
function createTrigger(diff) {
    return (0, _lodash.chain)(hooks).filter(matchHookId(diff.path.join('/'))).uniqBy('hook').map((trigger)=>({
            ...trigger,
            diff
        })).value();
}
function matchHookId(id) {
    return ({ path })=>{
        if (path.length > id.length) return path.startsWith(id);
        else return id.startsWith(path);
    };
}

},{"lodash":"1qc47","deep-diff":"3ceMf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ceMf":[function(require,module,exports,__globalThis) {
(function(root, factory) {
    var deepDiff = factory(root);
    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) // AMD
    define('DeepDiff', function() {
        return deepDiff;
    });
    else {
        var _deepdiff;
        // Node.js or ReactNative
        module.exports = deepDiff;
    }
})(this, function(root) {
    var validKinds = [
        'N',
        'E',
        'A',
        'D'
    ];
    // nodejs compatible on server side and in the browser.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
    function Diff(kind, path) {
        Object.defineProperty(this, 'kind', {
            value: kind,
            enumerable: true
        });
        if (path && path.length) Object.defineProperty(this, 'path', {
            value: path,
            enumerable: true
        });
    }
    function DiffEdit(path, origin, value) {
        DiffEdit.super_.call(this, 'E', path);
        Object.defineProperty(this, 'lhs', {
            value: origin,
            enumerable: true
        });
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffEdit, Diff);
    function DiffNew(path, value) {
        DiffNew.super_.call(this, 'N', path);
        Object.defineProperty(this, 'rhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffNew, Diff);
    function DiffDeleted(path, value) {
        DiffDeleted.super_.call(this, 'D', path);
        Object.defineProperty(this, 'lhs', {
            value: value,
            enumerable: true
        });
    }
    inherits(DiffDeleted, Diff);
    function DiffArray(path, index, item) {
        DiffArray.super_.call(this, 'A', path);
        Object.defineProperty(this, 'index', {
            value: index,
            enumerable: true
        });
        Object.defineProperty(this, 'item', {
            value: item,
            enumerable: true
        });
    }
    inherits(DiffArray, Diff);
    function arrayRemove(arr, from, to) {
        var rest = arr.slice((to || from) + 1 || arr.length);
        arr.length = from < 0 ? arr.length + from : from;
        arr.push.apply(arr, rest);
        return arr;
    }
    function realTypeOf(subject) {
        var type = typeof subject;
        if (type !== 'object') return type;
        if (subject === Math) return 'math';
        else if (subject === null) return 'null';
        else if (Array.isArray(subject)) return 'array';
        else if (Object.prototype.toString.call(subject) === '[object Date]') return 'date';
        else if (typeof subject.toString === 'function' && /^\/.*\//.test(subject.toString())) return 'regexp';
        return 'object';
    }
    // http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    function hashThisString(string) {
        var hash = 0;
        if (string.length === 0) return hash;
        for(var i = 0; i < string.length; i++){
            var char = string.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }
    // Gets a hash of the given object in an array order-independent fashion
    // also object key order independent (easier since they can be alphabetized)
    function getOrderIndependentHash(object) {
        var accum = 0;
        var type = realTypeOf(object);
        if (type === 'array') {
            object.forEach(function(item) {
                // Addition is commutative so this is order indep
                accum += getOrderIndependentHash(item);
            });
            var arrayString = '[type: array, hash: ' + accum + ']';
            return accum + hashThisString(arrayString);
        }
        if (type === 'object') {
            for(var key in object)if (object.hasOwnProperty(key)) {
                var keyValueString = '[ type: object, key: ' + key + ', value hash: ' + getOrderIndependentHash(object[key]) + ']';
                accum += hashThisString(keyValueString);
            }
            return accum;
        }
        // Non object, non array...should be good?
        var stringToHash = '[ type: ' + type + ' ; value: ' + object + ']';
        return accum + hashThisString(stringToHash);
    }
    function deepDiff(lhs, rhs, changes, prefilter, path, key, stack, orderIndependent) {
        changes = changes || [];
        path = path || [];
        stack = stack || [];
        var currentPath = path.slice(0);
        if (typeof key !== 'undefined' && key !== null) {
            if (prefilter) {
                if (typeof prefilter === 'function' && prefilter(currentPath, key)) return;
                else if (typeof prefilter === 'object') {
                    if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) return;
                    if (prefilter.normalize) {
                        var alt = prefilter.normalize(currentPath, key, lhs, rhs);
                        if (alt) {
                            lhs = alt[0];
                            rhs = alt[1];
                        }
                    }
                }
            }
            currentPath.push(key);
        }
        // Use string comparison for regexes
        if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
            lhs = lhs.toString();
            rhs = rhs.toString();
        }
        var ltype = typeof lhs;
        var rtype = typeof rhs;
        var i, j, k, other;
        var ldefined = ltype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].lhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].lhs, key);
        var rdefined = rtype !== 'undefined' || stack && stack.length > 0 && stack[stack.length - 1].rhs && Object.getOwnPropertyDescriptor(stack[stack.length - 1].rhs, key);
        if (!ldefined && rdefined) changes.push(new DiffNew(currentPath, rhs));
        else if (!rdefined && ldefined) changes.push(new DiffDeleted(currentPath, lhs));
        else if (realTypeOf(lhs) !== realTypeOf(rhs)) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (realTypeOf(lhs) === 'date' && lhs - rhs !== 0) changes.push(new DiffEdit(currentPath, lhs, rhs));
        else if (ltype === 'object' && lhs !== null && rhs !== null) {
            for(i = stack.length - 1; i > -1; --i)if (stack[i].lhs === lhs) {
                other = true;
                break;
            }
            if (!other) {
                stack.push({
                    lhs: lhs,
                    rhs: rhs
                });
                if (Array.isArray(lhs)) {
                    // If order doesn't matter, we need to sort our arrays
                    if (orderIndependent) {
                        lhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                        rhs.sort(function(a, b) {
                            return getOrderIndependentHash(a) - getOrderIndependentHash(b);
                        });
                    }
                    i = rhs.length - 1;
                    j = lhs.length - 1;
                    while(i > j)changes.push(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i--])));
                    while(j > i)changes.push(new DiffArray(currentPath, j, new DiffDeleted(undefined, lhs[j--])));
                    for(; i >= 0; --i)deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack, orderIndependent);
                } else {
                    var akeys = Object.keys(lhs);
                    var pkeys = Object.keys(rhs);
                    for(i = 0; i < akeys.length; ++i){
                        k = akeys[i];
                        other = pkeys.indexOf(k);
                        if (other >= 0) {
                            deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                            pkeys[other] = null;
                        } else deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                    for(i = 0; i < pkeys.length; ++i){
                        k = pkeys[i];
                        if (k) deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack, orderIndependent);
                    }
                }
                stack.length = stack.length - 1;
            } else if (lhs !== rhs) // lhs is contains a cycle at this element and it differs from rhs
            changes.push(new DiffEdit(currentPath, lhs, rhs));
        } else if (lhs !== rhs) {
            if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) changes.push(new DiffEdit(currentPath, lhs, rhs));
        }
    }
    function observableDiff(lhs, rhs, observer, prefilter, orderIndependent) {
        var changes = [];
        deepDiff(lhs, rhs, changes, prefilter, null, null, null, orderIndependent);
        if (observer) for(var i = 0; i < changes.length; ++i)observer(changes[i]);
        return changes;
    }
    function orderIndependentDeepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
        return deepDiff(lhs, rhs, changes, prefilter, path, key, stack, true);
    }
    function accumulateDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function accumulateOrderIndependentDiff(lhs, rhs, prefilter, accum) {
        var observer = accum ? function(difference) {
            if (difference) accum.push(difference);
        } : undefined;
        var changes = observableDiff(lhs, rhs, observer, prefilter, true);
        return accum ? accum : changes.length ? changes : undefined;
    }
    function applyArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    applyArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        } else switch(change.kind){
            case 'A':
                applyArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr = arrayRemove(arr, index);
                break;
            case 'E':
            case 'N':
                arr[index] = change.rhs;
                break;
        }
        return arr;
    }
    function applyChange(target, source, change) {
        if (typeof change === 'undefined' && source && ~validKinds.indexOf(source.kind)) change = source;
        if (target && change && change.kind) {
            var it = target, i = -1, last = change.path ? change.path.length - 1 : 0;
            while(++i < last){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = typeof change.path[i + 1] !== 'undefined' && typeof change.path[i + 1] === 'number' ? [] : {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    if (change.path && typeof it[change.path[i]] === 'undefined') it[change.path[i]] = [];
                    applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
                    break;
                case 'D':
                    delete it[change.path[i]];
                    break;
                case 'E':
                case 'N':
                    it[change.path[i]] = change.rhs;
                    break;
            }
        }
    }
    function revertArrayChange(arr, index, change) {
        if (change.path && change.path.length) {
            // the structure of the object at the index has changed...
            var it = arr[index], i, u = change.path.length - 1;
            for(i = 0; i < u; i++)it = it[change.path[i]];
            switch(change.kind){
                case 'A':
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    delete it[change.path[i]];
                    break;
            }
        } else // the array item is different...
        switch(change.kind){
            case 'A':
                revertArrayChange(arr[index], change.index, change.item);
                break;
            case 'D':
                arr[index] = change.lhs;
                break;
            case 'E':
                arr[index] = change.lhs;
                break;
            case 'N':
                arr = arrayRemove(arr, index);
                break;
        }
        return arr;
    }
    function revertChange(target, source, change) {
        if (target && source && change && change.kind) {
            var it = target, i, u;
            u = change.path.length - 1;
            for(i = 0; i < u; i++){
                if (typeof it[change.path[i]] === 'undefined') it[change.path[i]] = {};
                it = it[change.path[i]];
            }
            switch(change.kind){
                case 'A':
                    // Array was modified...
                    // it will be an array...
                    revertArrayChange(it[change.path[i]], change.index, change.item);
                    break;
                case 'D':
                    // Item was deleted...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'E':
                    // Item was edited...
                    it[change.path[i]] = change.lhs;
                    break;
                case 'N':
                    // Item is new...
                    delete it[change.path[i]];
                    break;
            }
        }
    }
    function applyDiff(target, source, filter) {
        if (target && source) {
            var onChange = function(change) {
                if (!filter || filter(target, source, change)) applyChange(target, source, change);
            };
            observableDiff(target, source, onChange);
        }
    }
    Object.defineProperties(accumulateDiff, {
        diff: {
            value: accumulateDiff,
            enumerable: true
        },
        orderIndependentDiff: {
            value: accumulateOrderIndependentDiff,
            enumerable: true
        },
        observableDiff: {
            value: observableDiff,
            enumerable: true
        },
        orderIndependentObservableDiff: {
            value: orderIndependentDeepDiff,
            enumerable: true
        },
        orderIndepHash: {
            value: getOrderIndependentHash,
            enumerable: true
        },
        applyDiff: {
            value: applyDiff,
            enumerable: true
        },
        applyChange: {
            value: applyChange,
            enumerable: true
        },
        revertChange: {
            value: revertChange,
            enumerable: true
        },
        isConflict: {
            value: function() {
                return typeof $conflict !== 'undefined';
            },
            enumerable: true
        }
    });
    // hackish...
    accumulateDiff.DeepDiff = accumulateDiff;
    // ...but works with:
    // import DeepDiff from 'deep-diff'
    // import { DeepDiff } from 'deep-diff'
    // const DeepDiff = require('deep-diff');
    // const { DeepDiff } = require('deep-diff');
    if (root) root.DeepDiff = accumulateDiff;
    return accumulateDiff;
});

},{}],"8um2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CatalogueSearch", ()=>CatalogueSearch);
parcelHelpers.export(exports, "CatalogueSubjects", ()=>CatalogueSubjects);
parcelHelpers.export(exports, "CatalogueCourses", ()=>CatalogueCourses);
parcelHelpers.export(exports, "Units", ()=>Units);
parcelHelpers.export(exports, "Lessons", ()=>Lessons);
parcelHelpers.export(exports, "MyCourses", ()=>MyCourses);
parcelHelpers.export(exports, "NewsItems", ()=>NewsItems);
parcelHelpers.export(exports, "ScheduledDays", ()=>ScheduledDays);
parcelHelpers.export(exports, "RecentActivity", ()=>RecentActivity);
parcelHelpers.export(exports, "Groups", ()=>Groups);
parcelHelpers.export(exports, "StudentsDownloadLog", ()=>StudentsDownloadLog);
parcelHelpers.export(exports, "DownloadLog", ()=>DownloadLog);
parcelHelpers.export(exports, "DownloadLogFilters", ()=>DownloadLogFilters);
parcelHelpers.export(exports, "Events", ()=>Events);
parcelHelpers.export(exports, "MyLessons", ()=>MyLessons);
parcelHelpers.export(exports, "GroupsDigests", ()=>GroupsDigests);
parcelHelpers.export(exports, "Assessments", ()=>Assessments);
parcelHelpers.export(exports, "AssessmentView", ()=>AssessmentView);
parcelHelpers.export(exports, "NewPlan", ()=>NewPlan);
parcelHelpers.export(exports, "PlanTemplates", ()=>PlanTemplates);
parcelHelpers.export(exports, "PlanRDTemplates", ()=>PlanRDTemplates);
parcelHelpers.export(exports, "TemplateRDItems", ()=>TemplateRDItems);
parcelHelpers.export(exports, "TemplateItems", ()=>TemplateItems);
parcelHelpers.export(exports, "Plans", ()=>Plans);
parcelHelpers.export(exports, "DESubjects", ()=>DESubjects);
parcelHelpers.export(exports, "DEGrades", ()=>DEGrades);
parcelHelpers.export(exports, "DEStandards", ()=>DEStandards);
parcelHelpers.export(exports, "DEExpectations", ()=>DEExpectations);
parcelHelpers.export(exports, "PdfPlans", ()=>PdfPlans);
parcelHelpers.export(exports, "TeacherStandards", ()=>TeacherStandards);
parcelHelpers.export(exports, "TeacherExpectations", ()=>TeacherExpectations);
parcelHelpers.export(exports, "PlanningWeek", ()=>PlanningWeek);
/*
export function OpenfireSettings (context) {
  if (!openfireDisabled && !context.openfireSettingsLoaded) {
    delayedSetState(0, fetch('openfire', 'settings', {
      mapParameters: () => ({}),
      mapResponse: settings => ({openfireSettings: handleSettings(settings), openfireSettingsLoaded: true})
    }))(context)
  }
}
*/ parcelHelpers.export(exports, "dashboardVideos", ()=>dashboardVideos);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _planning = require("helpers/planning");
var _planningPdfCjs = require("components/standards-selector/domain/planning-pdf.cjs");
var _url = require("helpers/url");
var _openfire = require("./openfire");
var _youtube = require("external/youtube");
var _quizFetch = require("./quiz-fetch");
parcelHelpers.exportAll(_quizFetch, exports);
var _preferencesFetch = require("./preferences-fetch");
parcelHelpers.exportAll(_preferencesFetch, exports);
var _rollbookFetch = require("./rollbook-fetch");
parcelHelpers.exportAll(_rollbookFetch, exports);
function whenInPage(pages, fetch) {
    return (context, ...args)=>{
        return pages.indexOf(context.page) >= 0 && fetch(context, ...args);
    };
}
function delayedSetState(defaultDelay, fetch) {
    let timeoutId = 0;
    return async (context, options = {})=>{
        const { delay = defaultDelay } = options;
        const data = await fetch(context);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(context.setState, delay, {
            ...data
        });
    };
}
function CatalogueSearch(context) {
    let searching = context.page == 'catalogue' && context.searching == 'lessons';
    searching = searching || inPlanning(context) && context.section == 'add-lessons' && context.activeTab == 'catalogue';
    if (searching) {
        const loading = (catalogueSearch)=>({
                ...context.loading,
                catalogueSearch
            });
        context.setState({
            loading: loading(true)
        });
        delayedSetState(0, (0, _commandDefault.default)('catalog', 'search', {
            mapParameters: ({ query })=>query,
            mapResponse: (catalogueSearchResults)=>({
                    catalogueSearchResults,
                    loading: loading(false)
                })
        }))(context);
    }
}
function CatalogueSubjects(context) {
    if (context.page == 'catalogue' && !context.subject) delayedSetState(0, (0, _commandDefault.default)('catalog', 'subjects', {
        mapParameters: ({ languageId, query })=>({
                language: query.languageId || languageId
            }),
        mapResponse: (catalogueSubjects)=>({
                catalogueSubjects
            })
    }))(context);
}
function CatalogueCourses(context) {
    if (context.page == 'catalogue' && context.subject) delayedSetState(0, (0, _commandDefault.default)('catalog', 'courses', {
        mapParameters: ({ languageId, query, subject })=>({
                subject,
                language: query.languageId || languageId
            }),
        mapResponse: (catalogueCourses)=>({
                catalogueCourses
            })
    }))(context);
}
function Units(context) {
    const course = [
        'assessment-bank',
        'question-bank'
    ].indexOf(context.tab) > -1 ? context.query.course : context.course;
    if (course) {
        context.setState({
            units: []
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'units', {
            mapParameters: ({ languageId, query })=>({
                    course,
                    language: query.languageId || languageId
                }),
            mapResponse: (units)=>({
                    units
                })
        }))(context);
    }
}
function Lessons(context) {
    const unit = [
        'assessment-bank',
        'question-bank'
    ].indexOf(context.tab) > -1 ? context.query.unit : context.course && context.unit ? `${context.course}U${context.unit}` : false;
    if (unit) {
        context.setState({
            lessons: []
        });
        delayedSetState(10, (0, _commandDefault.default)('teacher', 'unitLessons', {
            mapParameters: ({ languageId, query })=>({
                    unit,
                    language: query.languageId || languageId
                }),
            mapResponse: (lessons)=>({
                    lessons
                })
        }))(context);
    }
}
function MyCourses(context) {
    if (context.page == 'my-courses' || context.page == 'assessment' || context.page == 'quiz' || context.page == 'catalogue') {
        context.setState({
            myCourses: []
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'myCourses', {
            mapParameters: ({ languageId: language })=>({
                    language
                }),
            mapResponse: (myCourses)=>({
                    myCourses
                })
        }))(context);
    }
}
const NewsItems = whenInPage([
    'dashboard'
], delayedSetState(700, (0, _command.createPublic)('news', {
    mapParameters: ({ language: { id: language } })=>({
            language
        }),
    mapResponse: (news)=>({
            news
        })
})));
const ScheduledDays = whenInPage([
    'dashboard'
], delayedSetState(0, (0, _commandDefault.default)('teacher', 'ScheduledDays', {
    mapParameters: ()=>undefined,
    mapResponse: (scheduledDays)=>({
            scheduledDays
        })
})));
const RecentActivity = whenInPage([
    'dashboard'
], delayedSetState(850, (0, _commandDefault.default)('teacher', 'recentActivity', {
    mapParameters: ()=>{
        0, _url.inViewer;
    },
    mapResponse: (activity)=>({
            activity
        })
})));
function aggregateStudents(students, group) {
    group.students.forEach((student)=>{
        if (!student) return;
        const { studentId: id } = student;
        const record = students[id] || (students[id] = {
            ...student,
            groups: {}
        });
        record.groups[group.id] = group;
    });
    return students;
}
function Groups(context) {
    const { groups, groupsLanguage, languageId } = context;
    if (groups.length == 0 || groupsLanguage != languageId) delayedSetState(0, (0, _commandDefault.default)(context.role, 'myGroups', {
        mapParameters: ({ languageId: language })=>({
                language
            }),
        mapResponse: (groups)=>{
            const students = groups.reduce(aggregateStudents, {});
            const myGrades = (0, _lodash.chain)(groups).map(({ course, grade, precedence })=>({
                    id: course.substring(4, 7),
                    name: grade,
                    precedence
                })).uniqBy('id').sortBy('precedence').value();
            const mySubjects = Object.values(groups.reduce((acc, group)=>{
                const id = group.course.substring(0, 2);
                const grade = group.course.substring(4, 7);
                acc[id] = acc[id] || {
                    id,
                    name: group.subject,
                    grades: {}
                };
                acc[id].grades[grade] = true;
                return acc;
            }, {}));
            return {
                students,
                groups,
                groupsLoaded: true,
                groupsLanguage: languageId,
                mySubjects,
                myGrades
            };
        }
    }))(context);
}
function StudentsDownloadLog(context) {
    const { page, section } = context;
    if (page == 'monitoring' && section == 'students') {
        const loading = (studentsDownloadLog)=>({
                ...context.loading,
                studentsDownloadLog
            });
        context.setState({
            loading: loading(true)
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'studentsDownloadLog', {
            mapParameters: ({ query, groupId })=>{
                return {
                    ...query,
                    group: groupId
                };
            },
            mapResponse: (studentsDownloadLog)=>({
                    studentsDownloadLog,
                    loading: loading(false)
                })
        }))(context);
    }
}
function DownloadLog(context) {
    const { page, section } = context;
    if (page == 'monitoring' && section == 'student') {
        const loading = (downloadLog)=>({
                ...context.loading,
                downloadLog
            });
        context.setState({
            loading: loading(true)
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'downloadLog', {
            mapParameters: ({ query, studentId, groupId: group })=>{
                return {
                    ...query,
                    studentId,
                    group
                };
            },
            mapResponse: (downloadLog)=>({
                    downloadLog,
                    loading: loading(false)
                })
        }))(context);
    }
}
function matchUnit(course) {
    return ({ id })=>id.startsWith(course);
}
function matchLesson(unit) {
    return ({ id })=>id.startsWith(unit);
}
function DownloadLogFilters(context) {
    if (context.page == 'monitoring') delayedSetState(0, (0, _commandDefault.default)('teacher', 'downloadLogFilters', {
        mapParameters: ()=>({}),
        mapResponse: (data)=>{
            const [groupData, unitData, lessonData] = data;
            if (groupData) {
                const units = unitData.map((unit)=>({
                        ...unit,
                        lessons: lessonData.filter(matchLesson(unit.id))
                    }));
                const downloadLogFilters = groupData.map((group)=>({
                        ...group,
                        units: units.filter(matchUnit(group.course))
                    }));
                const lessonLogTitles = lessonData.reduce((acc, lesson)=>({
                        ...acc,
                        [lesson.id]: lesson
                    }), {});
                return {
                    downloadLogFilters,
                    lessonLogTitles
                };
            }
        }
    }))(context);
}
function Events(context) {
    if (context.page == 'calendars') delayedSetState(0, (0, _commandDefault.default)('teacher', 'events', {
        mapParameters: ({ query, languageId: language })=>{
            const start = query.start && (0, _momentDefault.default)(query.start).startOf('day').toISOString();
            const end = query.end && (0, _momentDefault.default)(query.end).endOf('day').toISOString();
            return {
                language,
                ...query,
                start,
                end
            };
        },
        mapResponse: (events)=>{
            const eventsByDay = events.reduce((days, event)=>{
                const start = (0, _momentDefault.default)(event.start);
                const end = (0, _momentDefault.default)(event.end);
                const dayDiff = Math.floor((0, _momentDefault.default).duration(end.diff(start)).as('days'));
                (0, _lodash.range)(dayDiff + 1).forEach((i)=>{
                    const day = (0, _momentDefault.default)(start).add(i, 'days').format('YYYY-MM-DD');
                    days[day] = days[day] || [];
                    days[day].push(event);
                });
                return days;
            }, {});
            return {
                eventsByDay,
                events
            };
        }
    }))(context);
}
function MyLessons(context) {
    const addingLessonsToPlan = context.page == 'planning' && context.view == 'plan' && context.activeTab == 'my-lessons';
    if (context.page == 'my-lessons' || addingLessonsToPlan) {
        const loading = (myLessons)=>({
                ...context.loading,
                myLessons
            });
        context.setState({
            loading: loading(true)
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'myLessons', {
            mapParameters: ({ query, languageId: language })=>({
                    ...query,
                    language
                }),
            mapResponse: (myLessons)=>({
                    myLessons,
                    loading: loading(false)
                })
        }))(context);
    }
}
function GroupsDigests(context) {
    if (context.page == 'rollbook') {
        const loading = (groupsDigests)=>({
                ...context.loading,
                groupsDigests
            });
        context.setState({
            loading: loading(true)
        });
        const fetchGroupsDigests = (0, _commandDefault.default)('teachers', `${context.profile.Passport.id}/groups`, {
            server: (0, _url.subdomainResource)('assessment'),
            mapParameters: ()=>({
                    use_digest: true
                }),
            mapResponse: ({ links })=>{
                const groupsDigests = links.reduce((acc, { href, digest })=>{
                    const group = href.substring(54, 90);
                    acc[group] = digest;
                    return acc;
                }, {});
                return {
                    groupsDigests,
                    loading: loading(false)
                };
            }
        });
        delayedSetState(0, fetchGroupsDigests)(context);
    }
}
function Assessments(context) {
    if (context.page == 'assessment') {
        const { page = 1, pageSize = 8 } = context.query;
        const loading = (assessments)=>({
                ...context.loading,
                assessments
            });
        context.setState({
            loading: loading(true)
        });
        const fetchAssessments = (0, _commandDefault.default)('teachers', `${context.profile.Passport.id}/assessment_templates`, {
            server: (0, _url.subdomainResource)('assessment'),
            mapParameters: ({ query })=>({
                    use_digest: true,
                    filter: query.pattern
                }),
            mapResponse: ({ links })=>{
                const templates = links.filter((link)=>link.rel == 'assessment_templates');
                const chunks = (0, _lodash.chunk)(templates, pageSize);
                const index = Math.min(page, chunks.length) - 1;
                const assessments = chunks[index].map(({ href, digest })=>({
                        id: href.substring(68, 104),
                        digest
                    }));
                return {
                    assessments,
                    assessmentCount: templates.length,
                    loading: loading(false)
                };
            }
        });
        delayedSetState(0, fetchAssessments)(context);
    }
}
async function AssessmentView(context) {
    if (context.page == 'assessment' && context.assessments.length > 0) {
        const loading = (assessmentView)=>({
                ...context.loading,
                assessmentView
            });
        context.setState({
            loading: loading(true)
        });
        const fetchAssessment = ({ id })=>(0, _commandDefault.default)('teachers', `${context.profile.Passport.id}/assessment_templates/${id}`, {
                server: (0, _url.subdomainResource)('assessment')
            })().then((assessment)=>(0, _lodash.omit)(assessment, [
                    'links'
                ]));
        const assessmentView = await Promise.all(context.assessments.map(fetchAssessment));
        context.setState({
            assessmentView,
            loading: loading(false)
        });
    }
}
function setLoading(value) {
    return {
        loading: {
            $auto: {
                isLoading: {
                    $set: value
                }
            }
        }
    };
}
function inPlanning({ page }) {
    return [
        'planning',
        'planning-rd'
    ].indexOf(page) >= 0;
}
async function NewPlan(context) {
    const { planId, view } = context;
    if (inPlanning(context) && [
        'plan',
        'plan-rd',
        'preview',
        'preview-rd'
    ].indexOf(view) >= 0) {
        const isNew = !planId;
        await context.updateState({
            planUpdated: {
                $set: false
            },
            newPlan: {
                $set: {}
            },
            ...setLoading(true)
        });
        const fetchNewPlan = (0, _commandDefault.default)('teacher', 'plan', {
            mapParameters: ({ query, suggestedDate, suggestedGroup })=>isNew ? {
                    ...query,
                    suggestedGroup,
                    suggestedDate
                } : {
                    ...query,
                    id: planId
                },
            mapResponse: ([data])=>{
                if (data === undefined) return {
                    newPlan: false,
                    ...setLoading(false)
                };
                const items = data.items[0] === null || view == 'plan-rd' ? [] : (0, _lodash.orderBy)(data.items.map((item)=>{
                    if (item.source == 'item') return item;
                    const { content } = item;
                    const sections = content?.sections?.map((0, _planning.createPlanSection));
                    return {
                        ...item,
                        content: {
                            ...content,
                            sections
                        },
                        ...setLoading(false)
                    };
                }), [
                    'order'
                ]);
                const newPlan = {
                    ...data,
                    items
                };
                return {
                    newPlan,
                    loadPlan: false,
                    planUpdated: true,
                    ...setLoading(false)
                };
            }
        });
        delayedSetState(30, fetchNewPlan)(context);
    }
}
async function PlanTemplates(context) {
    if (inPlanning(context) && context.view == 'plan') {
        const fetchTemplates = (0, _commandDefault.default)('teacher', 'planTemplates', {
            mapParameters: ({ query })=>query,
            mapResponse: (planTemplates)=>{
                const templs = planTemplates.filter((template)=>!template.label.startsWith('rd-'));
                return {
                    planTemplates: templs,
                    loadPlan: false
                };
            }
        });
        delayedSetState(0, fetchTemplates)(context);
    }
}
async function PlanRDTemplates(context) {
    if (inPlanning(context) && context.view == 'plan-rd') {
        const fetchTemplates = (0, _commandDefault.default)('teacher', 'planTemplates', {
            mapParameters: ({ query })=>query,
            mapResponse: (planTemplates)=>{
                const rdTemplates = planTemplates.filter((template)=>template.label.startsWith('rd-'));
                return {
                    planTemplates: rdTemplates,
                    loadPlan: false
                };
            }
        });
        delayedSetState(0, fetchTemplates)(context);
    }
}
async function TemplateRDItems(context) {
    if (inPlanning(context) && context.view == 'plan-rd') {
        const fetchTemplateItems = (0, _commandDefault.default)('planning', 'templateItems', {
            mapParameters: ()=>({}),
            mapResponse: (templateItems)=>({
                    templateItems,
                    loadPlan: false
                })
        });
        delayedSetState(0, fetchTemplateItems)(context);
    }
}
async function TemplateItems(context) {
    if (inPlanning(context) && context.view == 'plan') {
        const fetchTemplateItems = (0, _commandDefault.default)('planning', 'templateItems', {
            mapParameters: ()=>({}),
            mapResponse: (templateItems)=>({
                    templateItems,
                    loadPlan: false
                })
        });
        delayedSetState(0, fetchTemplateItems)(context);
    }
}
function Plans(context) {
    const inCalendar = [
        'plan'
    ].indexOf(context.view) < 0;
    if (inPlanning(context) && inCalendar && context.query.start) {
        context.updateState({
            plansUpdated: {
                $set: false
            },
            ...setLoading(true)
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'planSchedule', {
            mapParameters: ({ query, languageId: language })=>({
                    language,
                    ...query
                }),
            mapResponse: (source)=>{
                const plans = source.filter((plan)=>!plan.content.source ? true : plan.content.source === context.page);
                const plansByDay = plans.reduce((days, plan)=>{
                    const start = (0, _momentDefault.default)(plan.start);
                    const finish = (0, _momentDefault.default)(plan.finish);
                    (0, _lodash.range)((0, _momentDefault.default).duration(finish.diff(start)).as('days') + 1).forEach((i)=>{
                        const day = (0, _momentDefault.default)(start).add(i, 'days').format('YYYY-MM-DD');
                        days[day] = days[day] || [];
                        days[day].push(plan);
                    });
                    return days;
                }, {});
                return {
                    plansByDay,
                    plans,
                    plansUpdated: true
                };
            }
        }))(context);
    }
}
function fetchDE(entity) {
    return (context)=>{
        const { page, view, section } = context;
        const addingStandards = page == 'planning' && view == 'plan' && section == 'add-standards';
        if (addingStandards) delayedSetState(0, (0, _commandDefault.default)('de', entity, {
            mapParameters: ({ languageId: language, query })=>({
                    language,
                    ...query
                }),
            mapResponse: (data)=>({
                    [`de${entity}`]: data
                })
        }))(context);
    };
}
const DESubjects = fetchDE('Subjects');
const DEGrades = fetchDE('Grades');
const DEStandards = fetchDE('Standards');
const DEExpectations = fetchDE('Expectations');
function PdfPlans(context) {
    if (context.page == 'planning-pdf') {
        context.setState({
            pdfPlans: [],
            pdfPlansLoaded: false
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'plans', {
            mapParameters: ({ languageId: language, query })=>({
                    ...query,
                    language
                }),
            mapResponse: (pdfPlans)=>({
                    pdfPlans,
                    pdfPlansLoaded: true
                })
        }))(context);
    }
}
function TeacherStandards(context) {
    if (context.page == 'planning-pdf' || context.page == 'planning' && context.view == 'preview') {
        context.setState({
            teacherStandards: {},
            teacherStandardsLoaded: false
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'standards', {
            mapParameters: ({ planId })=>({
                    planId
                }),
            mapResponse: (standards)=>{
                const teacherStandards = (0, _planningPdfCjs.indexEditionParents)(standards);
                return {
                    teacherStandards,
                    teacherStandardsLoaded: true
                };
            }
        }))(context);
    }
}
function TeacherExpectations(context) {
    if (context.page == 'planning-pdf' || context.page == 'planning' && context.view == 'preview') {
        context.setState({
            teacherExpectations: {},
            teacherExpectationsLoaded: false
        });
        delayedSetState(0, (0, _commandDefault.default)('teacher', 'expectations', {
            mapParameters: ({ planId })=>({
                    planId
                }),
            mapResponse: (expectations)=>{
                const teacherExpectations = (0, _planningPdfCjs.indexEditionParents)(expectations);
                return {
                    teacherExpectations,
                    teacherExpectationsLoaded: true
                };
            }
        }))(context);
    }
}
function PlanningWeek(context) {
    if (context.view == 'week' && context.query.start) context.setState({
        planningWeek: context.query.start
    });
}
const openfireDisabled = true;
async function dashboardVideos(context) {
    const { page, settings = {} } = context;
    const { dashboardVideos } = settings;
    if (![
        'dashboard',
        'videos'
    ].includes(page)) return;
    if (!dashboardVideos) return;
    const loadVideos = (loading, videos)=>({
            dashboard: {
                loadingVideos: {
                    $set: loading
                },
                videos: {
                    $set: videos
                }
            }
        });
    await context.updateState(loadVideos(true, []));
    const videos = await (0, _youtube.getVideos)(dashboardVideos);
    context.updateState(loadVideos(false, videos));
}

},{"moment":"1e4qG","lodash":"1qc47","helpers/command":"f3cbG","helpers/planning":"5kcmd","components/standards-selector/domain/planning-pdf.cjs":"j2Aoc","helpers/url":"65SQD","./openfire":"cvWmF","external/youtube":"lRUoX","./quiz-fetch":"8vI8v","./preferences-fetch":"2JtWa","./rollbook-fetch":"fdlgl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kcmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPlanSection", ()=>createPlanSection);
var _lodash = require("lodash");
function createPlanSection(section) {
    const { type } = section;
    switch(type){
        case "dropdown":
            return {
                ...section,
                value: (0, _lodash.range)(section.count || 1).map((_)=>"")
            };
        case "panel":
            return {
                ...section,
                children: section.children.map(createPlanSection)
            };
        default:
            return {
                ...section,
                value: ""
            };
    }
}

},{"lodash":"1qc47","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j2Aoc":[function(require,module,exports,__globalThis) {
const { groupByEdition, resolveEdition, DEFAULT_EDITION } = require("cae73cbc640740ef");
function parentKey(edition, id) {
    return JSON.stringify([
        edition,
        id
    ]);
}
function indexEditionParents(items = []) {
    const result = {};
    for (const item of items){
        if (!item || !item.id) continue;
        result[parentKey(resolveEdition(item.standard_set), item.id)] = item;
    }
    return result;
}
function editionParent(index, edition, id) {
    if (!id) return undefined;
    const qualified = index[parentKey(edition, id)];
    if (qualified) return qualified;
    // Unqualified legacy maps belong to 2014, never silently to 2022.
    return edition === DEFAULT_EDITION ? index[id] : undefined;
}
function groupPlanningPdfStandards(items = [], teacherExpectations = {}, teacherStandards = {}) {
    return groupByEdition(items).map((edition)=>{
        const standards = [];
        const byStandard = new Map();
        for (const item of edition.items){
            const parent = item.expectation ? editionParent(teacherExpectations, edition.id, item.expectation) : item;
            const expectation = parent || (item.expectation ? {
                id: item.expectation,
                standard: item.standard,
                name: item.expectation_name,
                description: item.expectation_description
            } : item);
            const expectationId = expectation.id || item.expectation || item.id;
            const standardId = expectation.standard || item.standard || `unresolved:${expectationId}`;
            let standard = byStandard.get(standardId);
            if (!standard) {
                const resolved = editionParent(teacherStandards, edition.id, standardId) || {};
                standard = {
                    ...resolved,
                    id: standardId,
                    name: resolved.name || item.standard_name,
                    standard_set: edition.id,
                    expectations: []
                };
                byStandard.set(standardId, standard);
                standards.push(standard);
            }
            let entry = standard.expectations.find((value)=>value.id === expectationId);
            if (!entry) {
                entry = {
                    ...expectation,
                    id: expectationId,
                    standard_set: edition.id,
                    indicators: []
                };
                standard.expectations.push(entry);
            }
            if (item.expectation) entry.indicators.push({
                ...item,
                standard_set: edition.id
            });
        }
        return {
            ...edition,
            standards
        };
    });
}
module.exports = {
    parentKey,
    indexEditionParents,
    groupPlanningPdfStandards
};

},{"cae73cbc640740ef":"Ul5PW"}],"Ul5PW":[function(require,module,exports,__globalThis) {
// Pure edition/filter rules; CommonJS permits tests without a browser or Babel.
const EDITIONS = Object.freeze([
    Object.freeze({
        year: 2014,
        id: "20140000-0000-4000-8000-000000000001"
    }),
    Object.freeze({
        year: 2022,
        id: "20220000-0000-4000-8000-000000000001"
    })
]);
const DEFAULT_EDITION = EDITIONS[0].id;
function resolveEdition(id) {
    return EDITIONS.some((edition)=>edition.id === id) ? id : DEFAULT_EDITION;
}
function changeFilter(query, name, value) {
    const next = {
        ...query,
        [name]: value || undefined
    };
    if (name === "standard_set") for (const key of [
        "standard",
        "pattern"
    ])delete next[key];
    else if (name === "subject" || name === "grade" || name === "standard") {
        delete next.pattern;
        if (name !== "standard") delete next.standard;
    }
    return next;
}
function deParameters(entity, query = {}, language) {
    const allowed = entity === "expectations" ? [
        "standard",
        "pattern"
    ] : entity === "subjects" ? [
        "standard_set"
    ] : entity === "grades" ? [
        "subject",
        "standard_set"
    ] : [
        "subject",
        "grade",
        "standard_set"
    ];
    const result = {
        language
    };
    for (const key of allowed)if (query[key] !== undefined) result[key] = query[key];
    return result;
}
function resolveItemEdition(item = {}) {
    return resolveEdition(item.standard_set);
}
function groupByEdition(items = []) {
    return EDITIONS.map((edition)=>({
            ...edition,
            items: items.filter((item)=>resolveItemEdition(item) === edition.id)
        })).filter((group)=>group.items.length > 0);
}
module.exports = {
    EDITIONS,
    DEFAULT_EDITION,
    resolveEdition,
    resolveItemEdition,
    groupByEdition,
    changeFilter,
    deParameters
};

},{}],"cvWmF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleSettings", ()=>handleSettings);
var _url = require("../helpers/url");
const server = (0, _url.subdomainResource)((0, _url.apiHost));
let loglevel = 'info';
function handleSettings(data) {
    const [settings] = data;
    const { serviceName, domainName, boshPort, boshSSLPort, id, groups, nick } = settings;
    const port = (0, _url.apiProtocol) == 'http' ? boshPort : boshSSLPort;
    const jid = `${id}@${domainName}`;
    const bosh_service_url = `//${domainName}:${port}/http-bind`;
    const auto_join_rooms = groups.map((group)=>({
            jid: `${group.roomName}@${serviceName}.${domainName}`,
            nick,
            naturalName: group.naturalName
        }));
    const prebind_url = `//${server}/security/prebind`;
    return {
        hidden_occupants: true,
        allow_logout: false,
        allow_refresh_profile: true,
        allow_contact_removal: false,
        allow_non_roster_messaging: true,
        roster_groups: false,
        allow_bookmarks: false,
        allow_contact_requests: false,
        allow_muc_invitations: false,
        sounds_path: (0, _url.subdomainResource)('static', 'sounds', ''),
        message_archiving: true,
        show_client_info: false,
        show_profile_modal: false,
        muc_show_room_features: false,
        fullname: nick,
        prebind_url,
        prebind_with_credentials: true,
        bosh_service_url,
        auto_join_rooms_nickname: nick,
        auto_join_rooms,
        auto_subscribe: true,
        jid,
        loglevel,
        authentication: 'prebind',
        trusted: false,
        auto_login: true,
        auto_reconnect: true
    };
}

},{"../helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRUoX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVideos", ()=>getVideos);
var _dateFns = require("external/date-fns");
var _command = require("helpers/command");
const key = "AIzaSyAfyMzlZ7UwX2gSRJZiReJuw-1wyX4qHm8";
const channelId = "UCeJ7zyWET7ro11m-qiNiAJg";
const baseURL = "https://www.googleapis.com/youtube/v3";
function createURL(endpoint, params = {}) {
    const url = new URL(`${baseURL}/${endpoint}`);
    const allParams = {
        ...params,
        key,
        channelId
    };
    const filteredParams = Object.entries(allParams).filter(([_, v])=>typeof v == 'string' && !/^\s*$/.test(v));
    for (const [k, v] of filteredParams)url.searchParams.set(k, v);
    return url.toString();
}
async function ytCall(endpoint, params = {}, filterFunction = ()=>true) {
    let results = [];
    let pageToken = "";
    do {
        const url = createURL(endpoint, {
            ...params,
            pageToken,
            maxResults: '50'
        });
        const res = await fetch(url);
        if (!res.ok) {
            const text = await res.text();
            console.log(`YT Error: ${text}`);
            return [];
        }
        const data = await res.json();
        results = results.concat(data.items);
        pageToken = data.nextPageToken || false;
    }while (pageToken);
    return results.filter(filterFunction);
}
async function getVideos(dashboardVideos) {
    const { whiteList, videos: settingVideos } = dashboardVideos;
    const hasCurrentVideos = settingVideos.valid && (0, _dateFns.isAfter)(settingVideos.lastUpdated, (0, _dateFns.yesterday)());
    if (hasCurrentVideos) return settingVideos.items;
    const filterWhitelistPlaylists = (playlist)=>{
        if (whiteList.includes(playlist.snippet.title)) return true;
        return false;
    };
    const playlists = (await ytCall('playlists', {
        part: 'contentDetails,snippet'
    }, filterWhitelistPlaylists) || []).map(({ id })=>id);
    const mapVideosPromises = playlists.map(async (playlist)=>{
        const videoParams = {
            part: 'snippet',
            playlistId: playlist
        };
        const videos = await ytCall('playlistItems', videoParams) || [];
        return videos;
    });
    const videos = await Promise.all(mapVideosPromises);
    const items = videos.flat();
    (0, _command.createPost)('web', 'dashboardVideos')({
        items
    });
    return items;
}

},{"external/date-fns":"kwxNe","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vI8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuizTopics", ()=>QuizTopics);
parcelHelpers.export(exports, "QuizDirectories", ()=>QuizDirectories);
parcelHelpers.export(exports, "QuizAssessments", ()=>QuizAssessments);
parcelHelpers.export(exports, "QuizBankAssessments", ()=>QuizBankAssessments);
parcelHelpers.export(exports, "QuizAssignments", ()=>QuizAssignments);
parcelHelpers.export(exports, "QuizAssessment", ()=>QuizAssessment);
parcelHelpers.export(exports, "QuizAssessmentToReview", ()=>QuizAssessmentToReview);
parcelHelpers.export(exports, "QuizAssessmentForPDF", ()=>QuizAssessmentForPDF);
parcelHelpers.export(exports, "QuizAssessmentToTake", ()=>QuizAssessmentToTake);
parcelHelpers.export(exports, "QuizBlankAssessmentForPDF", ()=>QuizBlankAssessmentForPDF);
parcelHelpers.export(exports, "QuizAssignmentAssessments", ()=>QuizAssignmentAssessments);
parcelHelpers.export(exports, "QuizAssessmentResults", ()=>QuizAssessmentResults);
parcelHelpers.export(exports, "QuizQuestionBank", ()=>QuizQuestionBank);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _command = require("../helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _utils = require("../helpers/utils");
var _quiz = require("../helpers/quiz");
function whenInPage(pages, fetch) {
    return (context, ...args)=>{
        return pages.indexOf(context.page) >= 0 && fetch(context, ...args);
    };
}
function delayedSetState(defaultDelay, fetch) {
    let timeoutId = 0;
    return async (context, options = {})=>{
        const { delay = defaultDelay } = options;
        const data = await fetch(context);
        clearTimeout(timeoutId);
        timeoutId = setTimeout(context.setState, delay, {
            ...data
        });
    };
}
async function QuizTopics(context) {
    if (context.page != 'quiz' || context.tab != 'assessments') return;
    context.updateState({
        quizTopics: {
            $set: []
        }
    });
    const topics = await (0, _commandDefault.default)('quiz', 'getTopics')();
    context.updateState({
        quizTopics: {
            $set: topics
        }
    });
}
function QuizDirectories(context) {
    if (context.page == 'quiz' && context.tab == 'assessments' || context.page == 'catalogue') delayedSetState(0, (0, _commandDefault.default)('quiz', 'getDirectories', {
        mapParameters: ()=>({}),
        mapResponse: (data)=>({
                quizDirectories: data.reduce((acc, directory)=>{
                    acc[directory.id] = {
                        ...directory,
                        opened: false
                    };
                    return acc;
                }, {})
            })
    }))(context);
}
function QuizAssessments(context) {
    if (context.page == 'quiz' && context.tab == 'assessments') {
        if (context.sectionName == 'standards-search') return;
        const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
            'assessments': {
                $set: true
            }
        });
        context.setState({
            quizSearch
        });
        delayedSetState(0, (0, _command.createPost)('quiz', 'searchAssessments', {
            mapParameters: ({ query, quizStandardFilters })=>({
                    ...query,
                    ...(0, _quiz.standardFilters)(quizStandardFilters)
                }),
            mapResponse: (results)=>{
                const [quizPaging, assessments] = results;
                const quizAssessments = assessments ? assessments : [];
                const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
                    'assessments': {
                        $set: false
                    }
                });
                return {
                    quizPaging,
                    quizAssessments,
                    quizSearch
                };
            }
        }))(context);
    }
}
function QuizBankAssessments(context) {
    if (context.page == 'quiz' && context.tab == 'assessment-bank') {
        if (context.sectionName == 'standards-search') return;
        const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
            'assessment-bank': {
                $set: true
            }
        });
        context.setState({
            quizSearch
        });
        delayedSetState(0, (0, _command.createPost)('quiz', 'searchAssessmentBank', {
            mapParameters: ({ query, quizStandardFilters })=>({
                    ...query,
                    ...(0, _quiz.standardFilters)(quizStandardFilters)
                }),
            mapResponse: (results)=>{
                const [quizPaging, assessments] = results;
                const quizBankAssessments = assessments ? assessments : [];
                const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
                    'assessment-bank': {
                        $set: false
                    }
                });
                return {
                    quizPaging,
                    quizBankAssessments,
                    quizSearch
                };
            }
        }))(context);
    }
}
function QuizAssignments(context) {
    if (context.page == 'quiz' && context.tab == 'assigned') {
        if (context.sectionName == 'standards-search') return;
        const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
            'assigned': {
                $set: true
            }
        });
        context.setState({
            quizSearch
        });
        delayedSetState(0, (0, _command.createPost)('quiz', 'searchAssignments', {
            mapParameters: ({ query, quizStandardFilters })=>({
                    ...query,
                    ...(0, _quiz.standardFilters)(quizStandardFilters)
                }),
            mapResponse: (results)=>{
                const [quizPaging, assignments] = results;
                const quizAssignments = assignments ? assignments : [];
                const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
                    'assigned': {
                        $set: false
                    }
                });
                return {
                    quizPaging,
                    quizAssignments,
                    quizSearch
                };
            }
        }))(context);
    }
}
function QuizAssessment(context) {
    if (context.page == 'quiz' && context.assessment && [
        'edit',
        'preview'
    ].indexOf(context.action) >= 0) {
        const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
            'assessment': {
                $set: true
            }
        });
        const init = (0, _quiz.initQuestion)(context);
        context.setState({
            quizSearch
        });
        delayedSetState(0, (0, _commandDefault.default)('quiz', 'getAssessment', {
            mapParameters: ({ assessment })=>({
                    id: assessment
                }),
            mapResponse: (results)=>{
                const [assessment, sections, questions = []] = results;
                const quizAssessment = (0, _immutabilityHelperDefault.default)(assessment, {
                    course: {
                        $set: assessment.course || ''
                    }
                });
                const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
                    'assessment': {
                        $set: false
                    }
                });
                const quizQuestions = questions.reduce((acc, question)=>{
                    acc[question.section] = acc[question.section] || [];
                    acc[question.section].push(question.initialized ? question : init(question));
                    return acc;
                }, {});
                const quizSections = sections.map((section)=>({
                        ...section,
                        opened: true
                    }));
                return {
                    quizAssessment,
                    quizSections,
                    quizQuestions,
                    quizSearch
                };
            }
        }))(context);
    }
}
async function QuizAssessmentToReview(context) {
    if (context.page != 'quiz' || !context.assessment || [
        'review',
        'standards-results'
    ].indexOf(context.action) < 0) return;
    context.updateState({
        quizAssessmentToReview: {},
        quizSearch: {
            'assessment-to-review': {
                $set: true
            }
        }
    });
    const [assessment] = await (0, _commandDefault.default)('quiz', 'getAssessmentToReview')({
        id: context.assessment
    });
    context.updateState({
        quizAssessmentToReview: {
            $set: assessment
        },
        quizSearch: {
            'assessment-to-review': {
                $set: false
            }
        }
    });
}
async function QuizAssessmentForPDF(context) {
    if (context.page != 'quiz' || !context.quizAssessmentForPdfId) return;
    context.updateState({
        quizAssessmentForPdf: {},
        quizSearch: {
            'assessment-for-pdf': {
                $set: true
            }
        }
    });
    const [assessment] = await (0, _commandDefault.default)('quiz', 'getAssessmentToReview')({
        id: context.quizAssessmentForPdfId
    });
    context.updateState({
        quizAssessmentForPdf: {
            $set: assessment
        },
        quizSearch: {
            'assessment-for-pdf': {
                $set: false
            }
        }
    });
}
async function QuizAssessmentToTake(context) {
    if (context.page != 'quiz' || !context.assessment || context.action != 'take') return;
    context.updateState({
        quizAssessmentToTake: {},
        quizSearch: {
            'assessment-to-take': {
                $set: true
            }
        }
    });
    const assessment = await searchAssessmentToTake(context.assessment, context);
    context.updateState({
        quizAssessmentToTake: {
            $set: assessment
        },
        quizSearch: {
            'assessment-to-take': {
                $set: false
            }
        }
    });
}
async function QuizBlankAssessmentForPDF(context) {
    if (context.page != 'quiz' || !context.quizBlankAssessmentForPdfId) return;
    context.updateState({
        quizBlankAssessmentForPdf: {},
        quizSearch: {
            'blank-assessment-for-pdf': {
                $set: true
            }
        }
    });
    const assessment = await searchAssessmentToTake(context.quizBlankAssessmentForPdfId, context);
    context.updateState({
        quizBlankAssessmentForPdf: {
            $set: assessment
        },
        quizSearch: {
            'blank-assessment-for-pdf': {
                $set: false
            }
        }
    });
}
async function searchAssessmentToTake(id, context) {
    const [data] = await (0, _commandDefault.default)('quiz', 'getTestAssessment')({
        id
    });
    if (!data || !data.content) return {};
    const assessment = Object.values(data.content.sections).reduce((assessment, section)=>section.questions.reduce((assessment, question)=>(0, _immutabilityHelperDefault.default)(assessment, {
                answers: {
                    [question.id]: {
                        $apply: initAnswer(context.quizQuestionTypes, question)
                    }
                }
            }), assessment), data);
    return assessment;
}
function initAnswer(types, question) {
    const type = types.find((t)=>t.id == question.type) || {};
    const { defaultStudentAnswer = {} } = type.properties || {};
    function getDefault() {
        if (type.name == 'fill-in-the-blanks') {
            const { phrases = [] } = question.answer;
            return {
                phrases: phrases.map((p)=>p.blanked ? {
                        blanked: true,
                        phrase: ''
                    } : p)
            };
        } else if (type.name == 'matching') {
            const { choices = [] } = question.answer;
            const terms = (0, _utils.shuffleArray)(choices.map(([term], index)=>({
                    term,
                    index
                })));
            const definitions = (0, _utils.shuffleArray)(choices.map(([_, definition], index)=>({
                    definition,
                    index
                })));
            const selected = terms.map(()=>-1);
            return {
                terms,
                definitions,
                selected
            };
        } else if (type.name == 'multiple-choice' && question.properties.shuffle) {
            const { choices = [] } = question.answer;
            return {
                selected: null,
                selectedOptions: [],
                choices: (0, _utils.shuffleArray)(choices)
            };
        }
        return defaultStudentAnswer;
    }
    return (answer)=>!answer ? {
            pending: false,
            completed: false,
            ...getDefault()
        } : answer;
}
async function QuizAssignmentAssessments(context) {
    if (context.page != 'quiz' || context.tab != 'assigned') return;
    if (!context.assignmentId) return context.updateState({
        quizStudentAssessments: []
    });
    context.updateState({
        quizStudentAssessmentAssignmentId: {
            $set: undefined
        },
        quizStudentAssessments: {
            $set: []
        },
        quizSearch: {
            'student-assessments': {
                $set: true
            }
        }
    });
    const assessments = await (0, _commandDefault.default)('quiz', 'getAssignmentAssessments')({
        id: context.assignmentId
    });
    context.updateState({
        quizStudentAssessmentAssignmentId: {
            $set: context.assignmentId
        },
        quizStudentAssessments: {
            $set: assessments
        },
        quizSearch: {
            'student-assessments': {
                $set: false
            }
        }
    });
}
async function QuizAssessmentResults(context) {
    if (context.page != 'quiz' || !context.assessment || context.action != 'preview-results') return;
    context.updateState({
        quizAssessmentResults: {},
        quizSearch: {
            'assessment-results': {
                $set: true
            }
        }
    });
    const [assessment] = await (0, _commandDefault.default)('quiz', 'getTestAssessment')({
        id: context.assessment
    });
    context.updateState({
        quizAssessmentResults: {
            $set: assessment
        },
        quizSearch: {
            'assessment-results': {
                $set: false
            }
        }
    });
}
function QuizQuestionBank(context) {
    const searchingQuestionBank = context.page == 'quiz' && context.tab == 'question-bank' || context.quizDialogs['search-and-select-question'];
    if (searchingQuestionBank) {
        if (context.sectionName == 'standards-search') return;
        const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
            'question-bank': {
                $set: true
            }
        });
        context.setState({
            quizSearch
        });
        delayedSetState(0, (0, _command.createPost)('quiz', 'searchQuestionBank', {
            mapParameters: ({ query, quizStandardFilters })=>({
                    ...query,
                    ...(0, _quiz.standardFilters)(quizStandardFilters)
                }),
            mapResponse: (results)=>{
                const [quizPaging, questions] = results;
                const quizQuestionBank = questions ? questions.map((0, _quiz.initQuestion)(context)) : [];
                const quizSearch = (0, _immutabilityHelperDefault.default)(context.quizSearch, {
                    'question-bank': {
                        $set: false
                    }
                });
                return {
                    quizPaging,
                    quizQuestionBank,
                    quizSearch
                };
            }
        }))(context);
    }
}

},{"immutability-helper":"hwjCt","../helpers/command":"f3cbG","../helpers/utils":"gGc98","../helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2gdOk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectCourseLabel", ()=>selectCourseLabel);
parcelHelpers.export(exports, "initQuestion", ()=>initQuestion);
parcelHelpers.export(exports, "validationHandlers", ()=>validationHandlers);
parcelHelpers.export(exports, "isValidQuestion", ()=>isValidQuestion);
parcelHelpers.export(exports, "validateAssessment", ()=>validateAssessment);
parcelHelpers.export(exports, "getAssessmentStatus", ()=>getAssessmentStatus);
parcelHelpers.export(exports, "getAssessmentPoints", ()=>getAssessmentPoints);
parcelHelpers.export(exports, "createValidateStatus", ()=>createValidateStatus);
parcelHelpers.export(exports, "getQuizQuestionStandards", ()=>getQuizQuestionStandards);
parcelHelpers.export(exports, "standardFilters", ()=>standardFilters);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _utils = require("./utils");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
const questionTypeHandlers = {
    'multiple-choice': initMultipleChoice,
    'matching': initMatching
};
function selectCourseLabel({ course, courseName }) {
    return `${course.substring(0, 4)}_${courseName}`;
}
function initQuestion(context) {
    return (question)=>{
        const { quizQuestionTypes: types } = context;
        const { name: typeName } = types.find((t)=>t.id == question.type);
        const handler = questionTypeHandlers[typeName];
        return {
            modifications: 0,
            ...handler ? handler(question) : question
        };
    };
}
function initMultipleChoice(question) {
    return question.answer.choices ? (0, _immutabilityHelperDefault.default)(question, {
        properties: {
            $apply: (properties)=>({
                    singleOption: true,
                    ...properties
                })
        },
        answer: {
            initialized: {
                $set: true
            },
            choices: {
                $apply: (choices)=>choices.map((choice, id)=>({
                            ...choice,
                            id: (0, _utils.uuid)()
                        }))
            }
        }
    }) : question;
}
function initMatching(question) {
    return question.answer.choices ? (0, _immutabilityHelperDefault.default)(question, {
        answer: {
            initialized: {
                $set: true
            },
            choices: {
                $apply: (choices)=>choices.map((choice)=>[
                            ...choice,
                            (0, _utils.uuid)()
                        ])
            }
        }
    }) : question;
}
const valueValidation = [
    ({ properties })=>!properties.cleared,
    'missing-value'
];
const hasTextOrImage = (text, html)=>{
    return !(0, _utils.isEmpty)(text) || /<img src=/.test(html);
};
const premiseValidation = [
    (question)=>{
        const { premise, textpremise } = question;
        return hasTextOrImage(textpremise, premise.html);
    },
    'missing-premise'
];
const validationHandlers = {
    'true-or-false': [
        valueValidation,
        premiseValidation,
        [
            ({ answer })=>answer.value != undefined,
            'true-or-false-missing-answer'
        ]
    ],
    'open-question': [
        valueValidation,
        premiseValidation
    ],
    'fill-in-the-blanks': [
        valueValidation,
        premiseValidation,
        [
            ({ answer })=>answer.phrases && answer.phrases.findIndex((p)=>p.blanked) >= 0,
            'fill-in-the-blanks-missing-blanks'
        ]
    ],
    'multiple-choice': [
        valueValidation,
        premiseValidation,
        [
            ({ answer })=>answer.choices.findIndex((c)=>c.correct) >= 0,
            'multiple-choice-missing-correct-answer'
        ],
        [
            ({ answer })=>answer.choices.every((c)=>hasTextOrImage((0, _utils.htmlToText)(c.html), c.html)),
            ({ answer }, context)=>{
                return answer.choices.map((choice, index)=>!hasTextOrImage((0, _utils.htmlToText)(choice.html), choice.html) && context.translate('multiple-choice-missing-html', {
                        choice: String.fromCharCode(index + 97)
                    })).filter((c)=>c);
            }
        ]
    ],
    'matching': [
        valueValidation,
        [
            ({ answer })=>{
                return answer.choices.every(([term, definition])=>{
                    return hasTextOrImage((0, _utils.htmlToText)(term), term) && hasTextOrImage((0, _utils.htmlToText)(definition), definition);
                });
            },
            ({ answer }, context)=>{
                return answer.choices.map(([term, definition], index)=>{
                    const missingTerm = !hasTextOrImage((0, _utils.htmlToText)(term), term);
                    const missingDefinition = !hasTextOrImage((0, _utils.htmlToText)(definition), definition);
                    if (!missingDefinition && !missingTerm) return false;
                    const choice = String.fromCharCode(index + 97);
                    if (missingDefinition && missingTerm) return context.translate('matching-missing-term-and-definition', {
                        choice
                    });
                    if (missingDefinition) return context.translate('matching-missing-definition', {
                        choice
                    });
                    if (missingTerm) return context.translate('matching-missing-term', {
                        choice
                    });
                }).filter((c)=>c);
            }
        ]
    ]
};
const assessmentValidations = [
    [
        ({ quizQuestions })=>{
            return Object.values(quizQuestions).length > 0;
        },
        'assessment-missing-questions'
    ]
];
function isValidQuestion(question, type) {
    const validations = validationHandlers[type] || [];
    return validations.every(([validate])=>validate(question));
}
function validateAssessment(sections, context) {
    const getTypeName = (id)=>{
        const type = context.quizQuestionTypes.find((t)=>t.id == id);
        return type && type.name;
    };
    const sectionIndex = (id)=>context.quizSections.findIndex((s)=>s.id == id);
    const assessmentErrors = assessmentValidations.filter(([validate])=>!validate(context)).map(([_, message])=>message);
    const questionErrors = (0, _lodash.orderBy)(Object.entries(sections).reduce((sections, [section, questions])=>{
        const targets = questions.filter((q)=>!isValidQuestion(q, getTypeName(q.type)));
        if (targets.length > 0) sections.push({
            id: section,
            index: sectionIndex(section),
            questions: targets.reduce((questions, question, index)=>{
                const typeName = getTypeName(question.type);
                const validations = validationHandlers[typeName] || [];
                questions.push({
                    ...question,
                    index,
                    typeName,
                    errors: validations.map(([validate, message])=>validate(question) ? false : message).filter((e)=>e)
                });
                return questions;
            }, [])
        });
        return sections;
    }, []), [
        'index'
    ]);
    return {
        assessmentErrors,
        questionErrors
    };
}
const assessmentStatus = [
    {
        status: 'started',
        test: ({ duration, finished, durationSinceStart })=>!finished && durationSinceStart > 0 && duration > durationSinceStart
    },
    {
        status: 'expired',
        test: ({ finished, duration, durationSinceStart })=>!finished && durationSinceStart >= duration
    },
    {
        status: 'finished',
        test: ({ started, finished })=>started != null && finished != null
    },
    {
        status: 'missed',
        test: ({ finish, started, finished })=>(0, _momentDefault.default)().isAfter(finish) && !started && !finished
    },
    {
        status: 'available',
        test: ({ started, start, finish })=>!started && (0, _momentDefault.default)().isBetween(start, finish)
    },
    {
        status: 'unavailable',
        test: ({ started, start, finish })=>!started && (0, _momentDefault.default)().isBefore(start)
    }
];
function getAssessmentStatus(assessment) {
    const { status } = assessmentStatus.find((a)=>a.test(assessment)) || {
        status: 'missed'
    };
    return status;
}
function getAssessmentPoints(studentAssessment) {
    const { results, properties = {} } = studentAssessment || {};
    const { bonus = 0, published = false } = properties;
    const points = Object.values(results || {}).reduce((acc, result)=>{
        return {
            points: acc.points + result.points,
            total: acc.total + result.total,
            pending: acc.pending + (result.pending ? 1 : 0)
        };
    }, {
        points: bonus || 0,
        total: 0,
        pending: 0
    });
    return {
        published,
        ...points
    };
}
function createValidateStatus(context) {
    return async ({ id })=>{
        const [paging, results] = await (0, _commandDefault.default)('quiz', 'searchAssignments')({
            id
        });
        if (paging.recordCount < 1) return false;
        const [assignment] = results;
        const { startedCount, assessmentProperties: { validated } } = assignment;
        if (startedCount > 0) {
            const index = context.quizAssignments.findIndex((a)=>a.id == assignment.id);
            if (index >= 0) await context.updateState({
                quizAssignments: {
                    [index]: {
                        $set: assignment
                    }
                }
            });
            return false;
        }
        return true;
    };
}
function getQuizQuestionStandards({ quizQuestions, quizSections }) {
    return (0, _lodash.chain)(Object.values(quizQuestions)).flatten().orderBy([
        'section',
        'index'
    ]).map((question)=>{
        const { id, properties, index } = question;
        const section = quizSections.find((s)=>s.id == question.section) || {};
        return {
            id,
            standards: properties.standards || [],
            index,
            sectionIndex: section.index
        };
    }).value();
}
function standardFilters(filters) {
    return Object.entries(filters).filter(([k, v])=>v.length > 0).reduce((filters, [k, v])=>({
            ...filters,
            [k]: v
        }), {});
}

},{"moment":"1e4qG","lodash":"1qc47","immutability-helper":"hwjCt","./utils":"gGc98","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2JtWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadPreferences", ()=>LoadPreferences);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _command = require("../helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
async function LoadPreferences({ preferences, updateState }) {
    if (!preferences.pendingRefresh) return;
    updateState({
        preferences: {
            loaded: {
                $set: false
            }
        }
    });
    const [properties] = await (0, _commandDefault.default)('public', 'preferences')();
    updateState({
        preferences: {
            properties: {
                $set: initializeProperties(properties)
            },
            loaded: {
                $set: true
            },
            pendingRefresh: {
                $set: false
            }
        }
    });
}
function initializeProperties(initial) {
    let properties = initial;
    if (!properties.notifications) properties = (0, _immutabilityHelperDefault.default)(properties, {
        notifications: {
            $set: {}
        }
    });
    return properties;
}

},{"immutability-helper":"hwjCt","../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fdlgl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRollbook", ()=>getRollbook);
parcelHelpers.export(exports, "getGrades", ()=>getGrades);
parcelHelpers.export(exports, "getStudentAssignmentProperties", ()=>getStudentAssignmentProperties);
parcelHelpers.export(exports, "getPeriods", ()=>getPeriods);
parcelHelpers.export(exports, "getGradeColumns", ()=>getGradeColumns);
var _lodash = require("lodash");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _context = require("helpers/context");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
async function getRollbook(context, options) {
    const { page, groupId, updateState } = context;
    if (page != 'gradebook' || groupId == undefined) return;
    const clearUpdate = {
        ...(0, _context.updateLoadableList)('rollbookContextGrades'),
        ...(0, _context.updateLoadableList)('rollbookContextPeriods'),
        ...(0, _context.updateLoadableList)('rollbookContextGradeColumns'),
        rollbookContextStudentAssignmentProperties: {
            $set: {}
        }
    };
    updateState(clearUpdate);
    const { grades, columns, properties, periods } = await fetchRollbook('*', context);
    const stateUpdate = {
        ...(0, _context.updateLoadableList)('rollbookContextGrades', grades),
        ...(0, _context.updateLoadableList)('rollbookContextPeriods', periods),
        ...(0, _context.updateLoadableList)('rollbookContextGradeColumns', columns),
        rollbookContextStudentAssignmentProperties: {
            $set: properties
        }
    };
    updateState(stateUpdate);
}
async function getGrades(context, refresh) {
    if (!refresh) return;
    const { page, groupId, updateState } = context;
    if (page != 'gradebook' || groupId == undefined) return;
    updateState((0, _context.updateLoadableList)('rollbookContextGrades'));
    const { grades } = await fetchRollbook('grades', context);
    updateState((0, _context.updateLoadableList)('rollbookContextGrades', grades));
}
async function getStudentAssignmentProperties(context, refresh) {
    if (!refresh) return;
    const { page, groupId, updateState } = context;
    if (page != 'gradebook' || groupId == undefined) return;
    updateState({
        rollbookContextStudentAssignmentProperties: {
            $set: {}
        }
    });
    const { properties } = await fetchRollbook('properties', context);
    updateState({
        rollbookContextStudentAssignmentProperties: {
            $set: properties
        }
    });
}
async function getPeriods(context, refresh) {
    if (!refresh) return;
    const { page, groupId, updateState } = context;
    if (page != 'gradebook' || groupId == undefined) return;
    updateState((0, _context.updateLoadableList)('rollbookContextPeriods'));
    const { periods } = await fetchRollbook('periods', context);
    updateState((0, _context.updateLoadableList)('rollbookContextPeriods', periods));
}
async function getGradeColumns(context, refresh) {
    if (!refresh) return;
    const { page, groupId, updateState } = context;
    if (page != 'gradebook' || groupId == undefined) return;
    updateState((0, _context.updateLoadableList)('rollbookContextGradeColumns'));
    const { columns } = await fetchRollbook('columns', context);
    updateState((0, _context.updateLoadableList)('rollbookContextGradeColumns', columns));
}
async function fetchRollbook(target, context) {
    const { translate, groupId, gradingCategoryMap, quizTypesMap, homeworkStatus } = context;
    const fetches = [];
    if (target == '*' || target == 'grades') fetches.push((0, _commandDefault.default)('grading', 'getGrades')({
        groupId
    }));
    if (target == '*' || target == 'properties') fetches.push((0, _commandDefault.default)('grading', 'getStudentAssignmentProperties')({
        groupId
    }));
    if (target == '*' || target == 'columns') fetches.push((0, _commandDefault.default)('grading', 'getGradeColumns')({
        groupId
    }));
    if (target == '*' || target == 'periods') fetches.push((0, _commandDefault.default)('grading', 'getPeriods')());
    let fetchedData = {};
    const data = await Promise.all(fetches);
    if (target == '*') {
        const [grades, properties, columns, periods] = data;
        fetchedData = {
            grades,
            properties,
            columns,
            periods
        };
    } else fetchedData[target] = data[0];
    let results = {};
    if (target == '*' || target == 'grades') {
        const processedGrades = fetchedData.grades.map((grade)=>{
            if (grade.type != 'homework') return grade;
            const [reviewed = {}] = (0, _lodash.orderBy)((grade.log || []).filter((e)=>homeworkStatus[e.status] == 'completed'), (e)=>(0, _momentDefault.default)(e.created).valueOf(), [
                'desc'
            ]);
            const [turned = {}] = (0, _lodash.orderBy)((grade.log || []).filter((e)=>homeworkStatus[e.status] == 'pending'), (e)=>(0, _momentDefault.default)(e.created).valueOf(), [
                'desc'
            ]);
            return {
                ...grade,
                finished: turned.created,
                points: reviewed.score || 0,
                notGraded: reviewed.score == undefined
            };
        });
        results.grades = processedGrades;
    }
    if (target == '*' || target == 'properties') {
        const properties = fetchedData.properties.reduce((acc, { id, assignment, student, properties })=>{
            const students = acc[student] || (acc[student] = {});
            students[assignment] = {
                id,
                properties
            };
            return acc;
        }, {});
        results.properties = properties;
    }
    if (target == '*' || target == 'columns') {
        const typeCounts = {};
        const columnLabel = (t)=>typeCounts[t] ? `${t}${++typeCounts[t]}` : `${t}${typeCounts[t] = 1}`;
        const sortedByDate = (0, _lodash.orderBy)(fetchedData.columns, [
            (p)=>(0, _momentDefault.default)(p.start).valueOf()
        ]);
        const columns = sortedByDate.map((column)=>{
            const type = column.type == 'homework' ? 'homework' : column.external ? gradingCategoryMap[column.type] : quizTypesMap[column.type];
            return {
                ...column,
                type,
                label: columnLabel(translate(`${type}-label`)[0])
            };
        });
        results.columns = columns;
    }
    if (target == '*' || target == 'periods') results.periods = fetchedData.periods;
    return results;
}

},{"lodash":"1qc47","helpers/command":"f3cbG","helpers/context":"1olSX","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1olSX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createContext);
parcelHelpers.export(exports, "createLoadableList", ()=>createLoadableList);
parcelHelpers.export(exports, "createLoadableObject", ()=>createLoadableObject);
parcelHelpers.export(exports, "updateLoadableList", ()=>updateLoadableList);
parcelHelpers.export(exports, "updateLoadableObject", ()=>updateLoadableObject);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _utils = require("./utils");
(0, _immutabilityHelper.extend)('$auto', function(value, object) {
    return object ? (0, _immutabilityHelperDefault.default)(object, value) : (0, _immutabilityHelperDefault.default)({}, value);
});
(0, _immutabilityHelper.extend)('$autoArray', function(value, object) {
    return object ? (0, _immutabilityHelperDefault.default)(object, value) : (0, _immutabilityHelperDefault.default)([], value);
});
function createContext(initialState, { onInit, onUpdate }) {
    const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext();
    const { Provider, Consumer } = Context;
    class ContextProvider extends (0, _reactDefault.default).Component {
        constructor(props){
            super(props);
            const setState = this.setState.bind(this);
            this.state = {
                ...initialState,
                setState,
                updateState: updateState.bind(this),
                at: (...paths)=>(0, _lodash.at)(this.state, paths)
            };
            function updateState(first, ...params) {
                const commands = Array.isArray(first) ? first.concat(params) : [
                    first
                ].concat(params);
                return new Promise((resolve, reject)=>{
                    try {
                        const state = commands.reduce((state, command)=>(0, _immutabilityHelperDefault.default)(state, command), this.state);
                        setState(state, ()=>resolve(state));
                    } catch (e) {
                        reject(e);
                    }
                });
            }
        }
        componentDidMount() {
            if (onInit) {
                const context = ()=>(0, _utils.buildContext)(this.props, this.state);
                onInit(context(), context);
            }
        }
        componentDidUpdate(props, state) {
            if (onUpdate) onUpdate((0, _utils.buildContext)(this.props, this.state), (0, _utils.buildContext)(props, state));
        }
        render() {
            const context = (0, _utils.buildContext)(this.props, this.state);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
                value: context,
                children: this.props.children
            });
        }
    }
    return {
        Consumer,
        ContextProvider,
        Context
    };
}
function createLoadableList(override) {
    return {
        loaded: false,
        items: [],
        refreshes: 0,
        ...override || {}
    };
}
function createLoadableObject(override) {
    return {
        loaded: false,
        items: {},
        refreshes: 0,
        ...override || {}
    };
}
function updateLoadableList(path, items) {
    const initial = {
        loaded: {
            $set: items != undefined
        },
        items: {
            $set: items || []
        }
    };
    return path.split('.').reverse().reduce((command, name)=>({
            [name]: command
        }), initial);
}
function updateLoadableObject(path, items) {
    const initial = {
        loaded: {
            $set: items != undefined
        },
        items: {
            $set: items || {}
        }
    };
    return path.split('.').reverse().reduce((command, name)=>({
            [name]: command
        }), initial);
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","immutability-helper":"hwjCt","./utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jv1X7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>registerContextHooks);
var _hooks = require("../helpers/hooks");
var _fetch = require("./fetch");
function registerContextHooks() {
    (0, _hooks.register)([
        'language/id',
        'page/'
    ], _fetch.NewsItems);
    (0, _hooks.register)('page/', _fetch.RecentActivity);
    (0, _hooks.register)('page/', _fetch.ScheduledDays);
    (0, _hooks.register)('page/', _fetch.GroupsDigests);
    (0, _hooks.register)([
        'page/',
        'query/',
        'assessmentUpdates'
    ], [
        _fetch.Assessments
    ]);
    (0, _hooks.register)([
        'assessments/',
        'assessmentViewUpdates'
    ], [
        _fetch.AssessmentView
    ]);
    (0, _hooks.register)([
        'language/id',
        'page/'
    ], _fetch.Groups);
    (0, _hooks.register)([
        'language/id',
        'page/'
    ], _fetch.MyCourses);
    (0, _hooks.register)([
        'language/id',
        'course/',
        'query/course'
    ], _fetch.Units);
    (0, _hooks.register)([
        'language/id',
        'unit/',
        'query/unit'
    ], _fetch.Lessons);
    (0, _hooks.register)([
        'query/languageId',
        'page/',
        'subject/'
    ], [
        _fetch.CatalogueSubjects,
        _fetch.CatalogueCourses
    ]);
    (0, _hooks.register)([
        'page/',
        'query/',
        'section/',
        'activeTab/'
    ], [
        _fetch.CatalogueSearch
    ]);
    (0, _hooks.register)([
        'query/',
        'page/',
        'groupId',
        'section'
    ], [
        _fetch.StudentsDownloadLog,
        _fetch.DownloadLog
    ]);
    (0, _hooks.register)('page/', _fetch.DownloadLogFilters);
    (0, _hooks.register)('studentId', _fetch.DownloadLog);
    (0, _hooks.register)([
        'language/id',
        'page/',
        'query/',
        'eventUpdates/'
    ], _fetch.Events);
    (0, _hooks.register)([
        'query/languageId',
        'page/',
        'query/',
        'uploadUpdates/',
        'activeTab/'
    ], [
        _fetch.MyLessons
    ]);
    (0, _hooks.register)([
        'query/start'
    ], _fetch.PlanningWeek);
    (0, _hooks.register)([
        'view/'
    ], [
        _fetch.TeacherStandards,
        _fetch.TeacherExpectations
    ]);
    (0, _hooks.register)([
        'page/',
        'view/',
        'query/',
        'planUpdates'
    ], _fetch.Plans);
    (0, _hooks.register)([
        'page/',
        'view/',
        'query/template'
    ], [
        _fetch.NewPlan,
        _fetch.TemplateItems,
        _fetch.PlanTemplates,
        _fetch.PlanRDTemplates
    ]);
    (0, _hooks.register)([
        'templateUpdates'
    ], [
        _fetch.PlanTemplates,
        _fetch.PlanRDTemplates
    ]);
    (0, _hooks.register)([
        'section/',
        'languageId/'
    ], [
        _fetch.DESubjects,
        _fetch.DEGrades,
        _fetch.DEStandards,
        _fetch.DEExpectations
    ]);
    (0, _hooks.register)([
        'query/grade',
        'query/subject'
    ], [
        _fetch.DEStandards,
        _fetch.DEExpectations
    ]);
    (0, _hooks.register)([
        'query/standard',
        'query/pattern'
    ], [
        _fetch.DEExpectations
    ]);
    (0, _hooks.register)('openfireSettingsLoaded/', _fetch.OpenfireSettings);
    (0, _hooks.register)([
        'tab/',
        'page/'
    ], [
        _fetch.QuizDirectories
    ]);
    (0, _hooks.register)([
        'tab/',
        'page/',
        'query/',
        'quizAssessmentCalls/',
        'sectionName/',
        'quizStandardFiltersCalls/'
    ], [
        _fetch.QuizAssessments
    ]);
    (0, _hooks.register)([
        'tab/',
        'page/',
        'query/',
        'quizBankAssessmentCalls/',
        'sectionName/',
        'quizStandardFiltersCalls/'
    ], [
        _fetch.QuizBankAssessments
    ]);
    (0, _hooks.register)([
        'tab/',
        'page/',
        'query/',
        'quizAssignmentCalls/',
        'sectionName/',
        'quizStandardFiltersCalls/'
    ], [
        _fetch.QuizAssignments
    ]);
    (0, _hooks.register)([
        'tab/',
        'page/',
        'query/',
        'quizSearchQuestionBankCalls/',
        'quizDialogs/search-and-select-question/',
        'sectionName/',
        'quizStandardFiltersCalls/'
    ], [
        _fetch.QuizQuestionBank
    ]);
    (0, _hooks.register)([
        'assignmentId/'
    ], [
        _fetch.QuizAssignmentAssessments
    ]);
    (0, _hooks.register)([
        'assessment/',
        'action/'
    ], [
        _fetch.QuizAssessment,
        _fetch.QuizAssessmentToReview,
        _fetch.QuizAssessmentToTake,
        _fetch.QuizAssessmentResults
    ]);
    (0, _hooks.register)([
        'quizBlankAssessmentForPdfId/'
    ], [
        _fetch.QuizBlankAssessmentForPDF
    ]);
    (0, _hooks.register)([
        'quizAssessmentForPdfId/'
    ], [
        _fetch.QuizAssessmentForPDF
    ]);
    (0, _hooks.register)([
        'page/',
        'preferences/pendingRefresh'
    ], [
        _fetch.LoadPreferences
    ]);
    (0, _hooks.register)([
        'page/',
        'groupId/',
        'query/',
        'rollbookRefresh/'
    ], [
        _fetch.getRollbook
    ]);
    (0, _hooks.register)([
        'rollbookContextPeriods/refreshes'
    ], [
        _fetch.getPeriods
    ]);
    (0, _hooks.register)([
        'rollbookContextGrades/refreshes'
    ], [
        _fetch.getStudentAssignmentProperties
    ]);
    (0, _hooks.register)([
        'rollbookContextGrades/refreshes'
    ], [
        _fetch.getGrades
    ]);
    (0, _hooks.register)([
        'rollbookContextGradeColumns/refreshes'
    ], [
        _fetch.getGradeColumns
    ]);
    (0, _hooks.register)([
        'page/',
        'settings/dashboardVideos/'
    ], _fetch.dashboardVideos);
}

},{"../helpers/hooks":"kU1GJ","./fetch":"8um2e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dh8G9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quizContext);
const quizContext = {
    quizPaging: {
        recordCount: 0,
        currentPage: 1,
        pageSize: 15
    },
    quizStandardFiltersCalls: 0,
    quizStandardFilters: {
        standards: [],
        expectations: [],
        indicators: []
    },
    quizTopics: [],
    quizGenerator: {
        questionCount: 0,
        selectedTopics: {}
    },
    quizReviewFrom: undefined,
    quizReviewFromQuery: {},
    quizEditFrom: undefined,
    quizEditFromQuery: {},
    quizPreviewFrom: undefined,
    quizPreviewFromQuery: {},
    quizAssessmentToReview: {},
    quizAssessmentToTake: {},
    quizAssessmentForPdfId: undefined,
    quizAssessmentForPdf: {},
    quizBlankAssessmentForPdfId: undefined,
    quizBlankAssessmentForPdf: {},
    quizAssessmentResults: {},
    quizAssessmentToAssign: false,
    quizAssignmentToModify: false,
    quizAssignmentToReassign: false,
    quizAssessments: [],
    quizAssignments: [],
    quizNewBankQuestion: {},
    quizQuestionBankCart: [],
    quizQuestionBankCartEl: null,
    quizStudentAssessments: [],
    quizStudentAssessmentAssignmentId: undefined,
    quizBankAssessments: [],
    quizQuestionBank: [],
    quizBankQuestionIndex: undefined,
    quizAssessmentToDuplicate: {},
    quizAssessmentCalls: 0,
    quizBankAssessmentCalls: 0,
    quizSearchQuestionBankCalls: 0,
    quizQuestionTemplate: {},
    quizAssignmentCalls: 0,
    quizSelectedDirectory: undefined,
    quizDirectories: {},
    quizBankQuestionToDuplicate: {},
    quizSearch: {
        'assessments': false,
        'assessment-bank': false,
        'question-bank': false,
        'assigned': false,
        'student-assessments': false,
        'assessment': false,
        'assessment-to-review': false,
        'assessment-to-take': false,
        'blank-assessment-for-pdf': false,
        'assessment-for-pdf': false,
        'assessment-results': false
    },
    quizAssessment: {},
    quizSections: [],
    quizQuestions: {},
    quizQuestionStandards: [],
    quizSearchAndSelectSection: undefined,
    quizDialogs: {
        'create-assessment': false,
        'create-directory': false,
        'duplicate-assessment': false,
        'duplicate-bank-question': false,
        'search-and-select-question': false,
        'save-to-bank': false,
        'edit-bank-question': false,
        'edit-assignment': false,
        'edit-student-assignment': false
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckCl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rollbook);
var _context = require("helpers/context");
const rollbook = {
    rollbookRefresh: 0,
    rollbookContextGrades: (0, _context.createLoadableList)(),
    rollbookContextGradesToExport: [],
    rollbookContextGradeColumns: (0, _context.createLoadableList)(),
    rollbookContextStudentAssignmentProperties: {},
    rollbookContextPeriods: (0, _context.createLoadableList)(),
    rollbookContextGradingDialogs: {
        'add-external-grade': false,
        'export-rollbook': false
    },
    rollbookContextStudentGradesNavigation: {
        origin: undefined,
        query: {}
    },
    rollbookContextDeleteGrade: {
        open: false,
        grade: undefined
    }
};

},{"helpers/context":"1olSX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5lWhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>preferences);
const preferences = {
    preferences: {
        pendingRefresh: true,
        properties: {},
        loaded: false
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fumfd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>standards);
var _context = require("helpers/context");
const standards = {
    expectations: (0, _context.createLoadableList)(),
    standards: (0, _context.createLoadableList)(),
    subjects: (0, _context.createLoadableList)(),
    grades: (0, _context.createLoadableList)(),
    assessment: {},
    assessmentIndicators: {},
    assessmentStandards: (0, _context.createLoadableList)(),
    selectStandards: {
        selected: {},
        questionStandards: {}
    },
    standardsSearch: {
        selected: {},
        questionStandards: {}
    }
};

},{"helpers/context":"1olSX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ksW05":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subjects", ()=>subjects);
parcelHelpers.export(exports, "grades", ()=>grades);
parcelHelpers.export(exports, "standards", ()=>standards);
parcelHelpers.export(exports, "expectations", ()=>expectations);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "getAssessmentStandards", ()=>getAssessmentStandards);
var _assessmentAggregationCjs = require("components/standards-selector/domain/assessment-aggregation.cjs");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _utils = require("helpers/utils");
var _context = require("helpers/context");
const subjects = fetchDE('subjects');
const grades = fetchDE('grades');
const standards = fetchDE('standards');
const expectations = fetchDE('expectations');
const hooks = [
    {
        paths: [
            'page/',
            'operation/',
            'query/',
            'sectionName/'
        ],
        fetches: [
            subjects,
            grades,
            standards,
            expectations
        ]
    },
    {
        paths: [
            'page/',
            'assessment/',
            'action/',
            'sectionName/',
            'assignmentId/'
        ],
        fetches: [
            getAssessmentStandards
        ]
    }
];
function fetchDE(entity) {
    return async ({ operation, sectionName, query, updateState, languageId: language })=>{
        if (operation != 'add-standards' && sectionName != 'standards-search') return;
        const entityPath = `standardsContext.${entity}`;
        updateState((0, _context.updateLoadableList)(entityPath));
        const items = await (0, _commandDefault.default)('de', entity)({
            language,
            ...query
        });
        updateState((0, _context.updateLoadableList)(entityPath, items));
    };
}
async function getAssessmentStandards({ updateState, assessment, page, assignmentId, tab }) {
    const id = assignmentId || assessment;
    if (!(0, _utils.isUUID)(id)) return;
    updateState((0, _context.updateLoadableList)('standardsContext.assessmentStandards'), {
        standardsContext: {
            assessment: {
                $set: {}
            },
            assessmentIndicators: {}
        }
    });
    const [standards, expectations, indicators, assessmentProperties] = await (0, _commandDefault.default)('quiz', 'getAssessmentStandards')({
        id
    });
    const { standards: parsedStandards, assessmentIndicators } = (0, _assessmentAggregationCjs.aggregateAssessmentStandards)(standards, expectations, indicators);
    updateState((0, _context.updateLoadableList)('standardsContext.assessmentStandards', parsedStandards), {
        standardsContext: {
            assessment: {
                $set: assessmentProperties
            },
            assessmentIndicators: {
                $set: assessmentIndicators
            }
        }
    });
}

},{"components/standards-selector/domain/assessment-aggregation.cjs":"9h7fD","helpers/command":"f3cbG","helpers/utils":"gGc98","helpers/context":"1olSX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9h7fD":[function(require,module,exports,__globalThis) {
const { resolveItemEdition } = require("cc7f3747128b5a38");
const key = (id, edition)=>JSON.stringify([
        edition,
        id
    ]);
// Preserve the server's hierarchy and question references without merging editions.
function aggregateAssessmentStandards(standards = [], expectations = [], indicators = []) {
    const standardEdition = new Map();
    for (const standard of standards){
        const id = standard.id;
        const editions = standardEdition.get(id) || new Set();
        editions.add(resolveItemEdition(standard));
        standardEdition.set(id, editions);
    }
    const expectationEditions = new Map();
    for (const expectation of expectations){
        const edition = expectation.standard_set ? resolveItemEdition(expectation) : standardEdition.get(expectation.standard)?.size === 1 ? [
            ...standardEdition.get(expectation.standard)
        ][0] : resolveItemEdition(expectation);
        const editions = expectationEditions.get(expectation.id) || new Set();
        editions.add(edition);
        expectationEditions.set(expectation.id, editions);
    }
    const parsedIndicators = new Map();
    const assessmentIndicators = {};
    for (const indicator of indicators){
        const edition = indicator.standard_set ? resolveItemEdition(indicator) : expectationEditions.get(indicator.expectation)?.size === 1 ? [
            ...expectationEditions.get(indicator.expectation)
        ][0] : resolveItemEdition(indicator);
        const enriched = {
            ...indicator,
            standard_set: edition
        };
        const lookup = key(indicator.expectation, edition);
        if (!parsedIndicators.has(lookup)) parsedIndicators.set(lookup, []);
        parsedIndicators.get(lookup).push(enriched);
        for (const reference of indicator.references || []){
            if (!assessmentIndicators[reference.id]) assessmentIndicators[reference.id] = [];
            assessmentIndicators[reference.id].push(enriched);
        }
    }
    const parsedExpectations = new Map();
    for (const expectation of expectations){
        const edition = expectation.standard_set ? resolveItemEdition(expectation) : standardEdition.get(expectation.standard)?.size === 1 ? [
            ...standardEdition.get(expectation.standard)
        ][0] : resolveItemEdition(expectation);
        const lookup = key(expectation.standard, edition);
        if (!parsedExpectations.has(lookup)) parsedExpectations.set(lookup, []);
        parsedExpectations.get(lookup).push({
            ...expectation,
            standard_set: edition,
            indicators: parsedIndicators.get(key(expectation.id, edition)) || []
        });
    }
    return {
        standards: standards.map((standard)=>{
            const edition = resolveItemEdition(standard);
            return {
                ...standard,
                standard_set: edition,
                expectations: parsedExpectations.get(key(standard.id, edition)) || []
            };
        }),
        assessmentIndicators
    };
}
module.exports = {
    aggregateAssessmentStandards
};

},{"cc7f3747128b5a38":"Ul5PW"}],"c6DDC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>homework);
var _context = require("helpers/context");
const homework = {
    homeworks: (0, _context.createLoadableList)(),
    studentHomeworkStatus: (0, _context.createLoadableList)(),
    review: {
        from: undefined,
        query: undefined
    },
    createHomework: {
        open: false,
        editing: false,
        editState: undefined
    },
    deleteHomework: {
        open: false,
        homework: undefined
    }
};

},{"helpers/context":"1olSX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6LdU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hooks);
parcelHelpers.export(exports, "getHomeworks", ()=>getHomeworks);
parcelHelpers.export(exports, "getStudentHomeworkStatus", ()=>getStudentHomeworkStatus);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _context = require("helpers/context");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const hooks = [
    {
        paths: [
            'page/',
            'query/',
            'homeworkContext/homeworks/refreshes'
        ],
        fetches: [
            getHomeworks
        ]
    },
    {
        paths: [
            'page/',
            'homeworkId/',
            'homeworkContext/studentHomeworkStatus/refreshes'
        ],
        fetches: [
            getStudentHomeworkStatus
        ]
    }
];
async function getHomeworks({ page, query, updateState }) {
    if (page != 'homework') return;
    updateState((0, _context.updateLoadableList)('homeworkContext.homeworks'));
    const items = await (0, _commandDefault.default)('homework', 'getHomeworks')({
        ...query
    });
    items.reverse();
    const addTurnIns = (h)=>({
            ...h,
            turnIns: h.students.filter((s)=>s.properties.files && s.properties.files.length > 0).length
        });
    updateState((0, _context.updateLoadableList)('homeworkContext.homeworks', items.map(addTurnIns)));
}
async function getStudentHomeworkStatus({ page, homeworkId, updateState }) {
    if (page != 'homework' || !homeworkId) return;
    updateState((0, _context.updateLoadableList)('homeworkContext.studentHomeworkStatus'));
    const status = await (0, _commandDefault.default)('homework', 'getStudentHomeworkStatus')({
        id: homeworkId
    });
    const sortedFeedbackStatuses = status.map((s)=>{
        const sorted = (0, _immutabilityHelperDefault.default)(s, {
            status: {
                $apply: (a)=>(0, _lodash.sortBy)(a, (a)=>(0, _momentDefault.default)(a.created).valueOf())
            }
        });
        return sorted;
    });
    updateState((0, _context.updateLoadableList)('homeworkContext.studentHomeworkStatus', sortedFeedbackStatuses));
}

},{"immutability-helper":"hwjCt","lodash":"1qc47","helpers/command":"f3cbG","helpers/context":"1olSX","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"40ZlA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EdgePermissionBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const messages = {
    es: {
        title: 'Acceso a red local',
        body: "Esta escuela tiene un servidor local que puede mejorar la velocidad de carga del contenido. \xbfDesea permitir el acceso?",
        allow: 'Permitir',
        skip: 'Omitir'
    },
    en: {
        title: 'Local Network Access',
        body: 'This school has a local server that can improve content loading speed. Would you like to allow access?',
        allow: 'Allow',
        skip: 'Skip'
    }
};
function getLang() {
    const match = location.hash.match(/\/(es|en)\//);
    return match && match[1] || 'es';
}
function EdgePermissionBanner({ onAllow, onSkip }) {
    const t = messages[getLang()] || messages.es;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            position: 'fixed',
            top: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#1a73e8',
            color: '#fff',
            borderRadius: '8px',
            padding: '16px 20px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            zIndex: 9999,
            maxWidth: '420px',
            width: 'calc(100% - 48px)',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            fontFamily: 'sans-serif',
            fontSize: '14px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                style: {
                    fontSize: '15px'
                },
                children: t.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: t.body
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '10px',
                    justifyContent: 'flex-end'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: onSkip,
                        style: {
                            background: 'transparent',
                            border: '1px solid rgba(255,255,255,0.6)',
                            color: '#fff',
                            borderRadius: '4px',
                            padding: '6px 14px',
                            cursor: 'pointer',
                            fontSize: '13px'
                        },
                        children: t.skip
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        onClick: onAllow,
                        style: {
                            background: '#fff',
                            border: 'none',
                            color: '#1a73e8',
                            borderRadius: '4px',
                            padding: '6px 14px',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            fontSize: '13px'
                        },
                        children: t.allow
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Lz4b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SwitchView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _post = require("../../context/post");
var _url = require("../../helpers/url");
var _context = require("../../context");
var _gearPng = require("../../resources/gear.png");
var _gearPngDefault = parcelHelpers.interopDefault(_gearPng);
var _indexStyl = require("./index.styl");
function SwitchView({ informed }) {
    const [closed, close] = (0, _reactDefault.default).useState(informed);
    async function handleClick() {
        await (0, _post.uiInformed)();
        close(true);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: ({ languageId, role })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        onClick: classicView(languageId, role),
                        className: "settings",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            width: 30,
                            height: 30,
                            src: (0, _gearPngDefault.default)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        onClick: handleClick,
                        className: `switch-view-info ${closed ? "closed" : "opened"}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "arrow"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "content",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "switch-view-info"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
}
function classicView(language, role) {
    return async ()=>{
        await (0, _post.switchToClassic)();
        const url = (0, _url.subdomainResource)('www', language, role);
        location.replace(`//${url}`);
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","../../context/post":"8rmpk","../../helpers/url":"65SQD","../../context":"iUP37","../../resources/gear.png":"ivHhD","./index.styl":"04eHE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivHhD":[function(require,module,exports,__globalThis) {
module.exports = require("d0bbc1a5d4151afd").getBundleURL('eAbh3') + "gear.0967cf89.png";

},{"d0bbc1a5d4151afd":"a2ypy"}],"04eHE":[function() {},{}],"2bsKa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Notification);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _command = require("helpers/command");
const useStyles = (0, _material.makeStyles)(notificationStyles);
const useTitleStyles = (0, _material.makeStyles)(titleStyles);
function Notification({ open, context, notificationPrefix }) {
    const { preferences, translate, updateState } = context;
    const classes = useStyles();
    const titleClasses = useTitleStyles();
    const theme = (0, _material.useTheme)();
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const [stopNotification, setStopNotification] = (0, _react.React).useState(false);
    async function onConfirm() {
        const { preferences: { properties } } = await updateState({
            preferences: {
                properties: {
                    notifications: {
                        [notificationPrefix]: {
                            $set: true
                        }
                    }
                }
            }
        });
        if (stopNotification) (0, _command.createPost)('public', 'preferences')({
            properties
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        fullScreen: fullScreen,
        open: open,
        onClose: (e)=>close(e),
        "aria-labelledby": `${notificationPrefix}-notification-dialog-title`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogTitle), {
                id: "tobar-notification-dialog-title",
                classes: titleClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: classes.icon,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.WarningIcon), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        children: translate(`${notificationPrefix}-notification-dialog-title`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: classes.notification,
                    dangerouslySetInnerHTML: {
                        __html: translate(`${notificationPrefix}-notification-html`)
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                className: classes.actions,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                        size: "small",
                        className: classes.stopNotification,
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                            size: "small",
                            color: "primary",
                            checked: stopNotification,
                            onChange: (e)=>setStopNotification(e.target.checked)
                        }),
                        label: translate('stop-showing')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.filler
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                        variant: "contained",
                        color: "primary",
                        className: (0, _material.clsx)(classes.button, "confirm"),
                        onClick: onConfirm,
                        children: translate('continue')
                    })
                ]
            })
        ]
    });
}
function titleStyles(theme) {
    return {
        root: {
            display: 'flex',
            justifyContent: 'center',
            fontSize: '16pt',
            fontWeight: 'bold',
            borderBottom: 'solid 1px #f3f3f3',
            background: '#fdfdfd'
        }
    };
}
function notificationStyles(theme) {
    return {
        icon: {
            color: 'red',
            fontSize: '15pt',
            marginTop: -1,
            marginRight: 10
        },
        notification: {
            padding: '0 15px',
            "& ol": {
                padding: '8px 40px'
            },
            "& li": {
                marginTop: 10,
                "&:first-child": {
                    marginTop: 0
                }
            }
        },
        actions: {
            padding: 12,
            display: 'flex',
            borderTop: 'solid 1px #f3f3f3',
            background: '#fdfdfd'
        },
        filler: {
            flexGrow: 1
        },
        button: {
            textTransform: 'none'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5LKDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TeacherContext", ()=>(0, _context.Context));
var _context = require("context");

},{"context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1i2uF":[function() {},{}],"XdIgA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _navigationStyl = require("./navigation.styl");
function Navigation() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { page, profile, translate } = context;
            const personName = profile.individual ? profile.individual.first_name : '';
            document.title = translate(`${page}_title`);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                className: "navigation",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "current-page",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: context.link({}, '/:languageId/:role/:page', {
                                preserverQuery: false
                            }),
                            children: translate(`${page}_title`)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        className: "welcome-message",
                        children: `${translate('welcome')},   ${personName}`
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","react-text":"lEpdJ","../../context":"iUP37","./navigation.styl":"f42V2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f42V2":[function() {},{}],"iYRw9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Menu);
var _jsxRuntime = require("react/jsx-runtime");
var _d3 = require("d3");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _renderprops = require("react-spring/renderprops");
var _url = require("helpers/url");
var _icon = require("components/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _versionLabel = require("components/VersionLabel");
var _versionLabelDefault = parcelHelpers.interopDefault(_versionLabel);
var _context = require("teacher/context");
var _menuItem = require("./menu-item");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _subMenuItem = require("./SubMenuItem");
var _subMenuItemDefault = parcelHelpers.interopDefault(_subMenuItem);
const Version = (0, _versionLabelDefault.default)();
const StyledMenu = (0, _material.styleAndCapture)((0, _material.Box), 'size', 'top')(menuStyles);
const typeHandlers = {
    'submenu': (0, _subMenuItemDefault.default)
};
function getHandler(type) {
    return typeHandlers[type] || (0, _menuItemDefault.default);
}
function inLocation({ location }, menuItem) {
    const locations = (menuItem.location || "").split(',');
    return locations.indexOf(location || 'pr') >= 0;
}
const menuItems = (chained, direction, page, context)=>chained.map((item)=>({
            ...item,
            direction,
            selected: item.page == page || item.items && item.items.findIndex((i)=>i.page == page) >= 0
        })).map((item)=>{
        const Handler = getHandler(inLocation(context.profile.institution, item) && item.type);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
            ...item
        }, item.order);
    }).value();
const itemHeight = 90;
const itemWidth = 90;
const headerHeight = 50;
const navigationHeight = 50;
const availableHeight = ({ height })=>{
    return height - headerHeight - navigationHeight;
};
const visibleItemCount = (sizes, items)=>{
    const available = availableHeight(sizes);
    const count = Math.floor(available / itemHeight - 1);
    return items - count < 2 ? items : count;
};
function Menu() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const language = context.language;
    const role = context.profile.role;
    const { limited, project, premium } = context.profile.institution;
    const noChat = (0, _url.converseDisabled) || context.profile.institution.noChat;
    const isDreyfous = context.profile.domain === 'dreyfous' || context.profile.domain === 'dreyfous-dg';
    const items = context.settings.menu[project][role].map((item)=>{
        return item;
    }).filter((i)=>!i.inViewer || (0, _url.inViewer)).filter((i)=>i.page == 'chat' ? !noChat : true).filter((i)=>!i.premium || i.premium && premium).filter((i)=>i.location ? inLocation(context.profile.institution, i) : true);
    const sortedItems = (0, _lodash.chain)(items).sortBy(({ order })=>order).map((item)=>({
            ...item,
            language,
            role
        }));
    const verticalItemCount = visibleItemCount(context.sizes, items.length);
    const verticalItems = menuItems(sortedItems.take(verticalItemCount), 'vertical', context.page, context);
    const verticalAnimation = (0, _react.useMemo)(()=>({
            config: {
                delay: context.menuShowing ? 0 : 250,
                duration: 400,
                easing: _d3.easeQuad
            },
            to: {
                left: context.menuShowing ? 0 : -(itemWidth + 5)
            }
        }), [
        context.menuShowing
    ]);
    const horizontalItemCount = items.length - verticalItemCount;
    const horizontalItems = menuItems(sortedItems.takeRight(horizontalItemCount), 'horizontal', context.page, context);
    const horizontalMenuTop = verticalItemCount * itemHeight + 100;
    const horizontalMenuWidth = itemWidth * horizontalItemCount;
    const horizontalAnimation = {
        to: {
            marginLeft: context.expandedMenuShowing ? itemWidth : -horizontalMenuWidth,
            top: horizontalMenuTop
        },
        from: {
            marginLeft: -9999
        }
    };
    const onMoreMenuClick = ()=>{
        context.setState({
            expandedMenuShowing: !context.expandedMenuShowing
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMenu, {
        className: "menu-container",
        sizes: context.sizes,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderprops.Spring), {
                ...verticalAnimation,
                children: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        id: "menu",
                        className: "menu vertical",
                        style: props,
                        children: [
                            verticalItems,
                            horizontalItems.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                id: "more-menu",
                                className: "menu-item",
                                onClick: onMoreMenuClick,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                    name: "more-menu"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Version, {
                                number: (0, _url.version)
                            })
                        ]
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderprops.Spring), {
                ...horizontalAnimation,
                children: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "menu horizontal",
                        style: props,
                        children: horizontalItems
                    })
            })
        ]
    });
}
function menuStyles(props) {
    const { sizes, top = 100 } = props;
    const backgroundColor = '#0a4986';
    const selectedBackground = '#0f4071';
    const fontSize = '9pt';
    const itemSize = 90;
    const height = sizes.height - top;
    return {
        "& .menu": {
            display: 'flex',
            position: 'absolute',
            backgroundColor,
            "&.vertical": {
                zIndex: 3000,
                top,
                height: isNaN(height) ? 'calc(var(--screen-height, 100vh) - 100px)' : height,
                flexDirection: 'column'
            },
            "&.horizontal": {
                zIndex: 2900,
                backgroundColor,
                flexDirection: 'row'
            },
            "& .menu-item": {
                color: '#fff',
                cursor: 'pointer',
                backgroundColor,
                fontSize,
                textDecoration: 'none',
                width: itemSize,
                height: itemSize,
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                "&:hover": {
                    backgroundColor: '#2a4158'
                },
                "& label": {
                    cursor: 'pointer',
                    marginTop: 8
                },
                "&:active": {
                    height: 88,
                    borderBottom: '1px inset #246fb9',
                    borderTop: '1px inset #246fb9',
                    opacity: 0.5
                },
                "&.selected": {
                    backgroundColor: selectedBackground,
                    "&:hover": {
                        backgroundColor: selectedBackground
                    },
                    "&.vertical": {
                        borderLeft: 'solid 4px #d6710f',
                        width: 86
                    },
                    "&.selected.horizontal": {
                        borderBottom: 'solid 4px #d6710f',
                        height: 86
                    },
                    "& label": {
                        marginLeft: -4
                    },
                    "& svg": {
                        marginLeft: -4
                    }
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","d3":"aLplL","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","react-spring/renderprops":"gWF4m","helpers/url":"65SQD","components/icon":"82gpi","components/VersionLabel":"2II2m","teacher/context":"5LKDx","./menu-item":"1rNJY","./SubMenuItem":"gYR0H","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aLplL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>(0, _packageJs.version));
var _packageJs = require("./dist/package.js");
var _d3Array = require("d3-array");
parcelHelpers.exportAll(_d3Array, exports);
var _d3Axis = require("d3-axis");
parcelHelpers.exportAll(_d3Axis, exports);
var _d3Brush = require("d3-brush");
parcelHelpers.exportAll(_d3Brush, exports);
var _d3Chord = require("d3-chord");
parcelHelpers.exportAll(_d3Chord, exports);
var _d3Collection = require("d3-collection");
parcelHelpers.exportAll(_d3Collection, exports);
var _d3Color = require("d3-color");
parcelHelpers.exportAll(_d3Color, exports);
var _d3Contour = require("d3-contour");
parcelHelpers.exportAll(_d3Contour, exports);
var _d3Dispatch = require("d3-dispatch");
parcelHelpers.exportAll(_d3Dispatch, exports);
var _d3Drag = require("d3-drag");
parcelHelpers.exportAll(_d3Drag, exports);
var _d3Dsv = require("d3-dsv");
parcelHelpers.exportAll(_d3Dsv, exports);
var _d3Ease = require("d3-ease");
parcelHelpers.exportAll(_d3Ease, exports);
var _d3Fetch = require("d3-fetch");
parcelHelpers.exportAll(_d3Fetch, exports);
var _d3Force = require("d3-force");
parcelHelpers.exportAll(_d3Force, exports);
var _d3Format = require("d3-format");
parcelHelpers.exportAll(_d3Format, exports);
var _d3Geo = require("d3-geo");
parcelHelpers.exportAll(_d3Geo, exports);
var _d3Hierarchy = require("d3-hierarchy");
parcelHelpers.exportAll(_d3Hierarchy, exports);
var _d3Interpolate = require("d3-interpolate");
parcelHelpers.exportAll(_d3Interpolate, exports);
var _d3Path = require("d3-path");
parcelHelpers.exportAll(_d3Path, exports);
var _d3Polygon = require("d3-polygon");
parcelHelpers.exportAll(_d3Polygon, exports);
var _d3Quadtree = require("d3-quadtree");
parcelHelpers.exportAll(_d3Quadtree, exports);
var _d3Random = require("d3-random");
parcelHelpers.exportAll(_d3Random, exports);
var _d3Scale = require("d3-scale");
parcelHelpers.exportAll(_d3Scale, exports);
var _d3ScaleChromatic = require("d3-scale-chromatic");
parcelHelpers.exportAll(_d3ScaleChromatic, exports);
var _d3Selection = require("d3-selection");
parcelHelpers.exportAll(_d3Selection, exports);
var _d3Shape = require("d3-shape");
parcelHelpers.exportAll(_d3Shape, exports);
var _d3Time = require("d3-time");
parcelHelpers.exportAll(_d3Time, exports);
var _d3TimeFormat = require("d3-time-format");
parcelHelpers.exportAll(_d3TimeFormat, exports);
var _d3Timer = require("d3-timer");
parcelHelpers.exportAll(_d3Timer, exports);
var _d3Transition = require("d3-transition");
parcelHelpers.exportAll(_d3Transition, exports);
var _d3Voronoi = require("d3-voronoi");
parcelHelpers.exportAll(_d3Voronoi, exports);
var _d3Zoom = require("d3-zoom");
parcelHelpers.exportAll(_d3Zoom, exports);

},{"./dist/package.js":"8lz8F","d3-array":"aoYKF","d3-axis":"41neH","d3-brush":"eFd4k","d3-chord":"4B9KG","d3-collection":"c1YdX","d3-color":"jv6Pr","d3-contour":"klb8D","d3-dispatch":"2VwUr","d3-drag":"HHNYu","d3-dsv":"59Jxi","d3-ease":"djx4i","d3-fetch":"cZ2qo","d3-force":"67Mne","d3-format":"97aCb","d3-geo":"iQZKv","d3-hierarchy":"cFwdY","d3-interpolate":"5gJW0","d3-path":"a7nC8","d3-polygon":"e5TI9","d3-quadtree":"5yYuF","d3-random":"4hcGu","d3-scale":"8BE7D","d3-scale-chromatic":"1ruLi","d3-selection":"9PvvP","d3-shape":"c0b97","d3-time":"bCmrc","d3-time-format":"6Z3KL","d3-timer":"lpgSt","d3-transition":"aj1c5","d3-voronoi":"l2DKc","d3-zoom":"9wSnq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lz8F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "name", ()=>name);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "description", ()=>description);
parcelHelpers.export(exports, "keywords", ()=>keywords);
parcelHelpers.export(exports, "homepage", ()=>homepage);
parcelHelpers.export(exports, "license", ()=>license);
parcelHelpers.export(exports, "author", ()=>author);
parcelHelpers.export(exports, "main", ()=>main);
parcelHelpers.export(exports, "unpkg", ()=>unpkg);
parcelHelpers.export(exports, "jsdelivr", ()=>jsdelivr);
parcelHelpers.export(exports, "module", ()=>module);
parcelHelpers.export(exports, "repository", ()=>repository);
parcelHelpers.export(exports, "files", ()=>files);
parcelHelpers.export(exports, "scripts", ()=>scripts);
parcelHelpers.export(exports, "devDependencies", ()=>devDependencies);
parcelHelpers.export(exports, "dependencies", ()=>dependencies);
var name = "d3";
var version = "5.16.0";
var description = "Data-Driven Documents";
var keywords = [
    "dom",
    "visualization",
    "svg",
    "animation",
    "canvas"
];
var homepage = "https://d3js.org";
var license = "BSD-3-Clause";
var author = {
    "name": "Mike Bostock",
    "url": "https://bost.ocks.org/mike"
};
var main = "dist/d3.node.js";
var unpkg = "dist/d3.min.js";
var jsdelivr = "dist/d3.min.js";
var module = "index.js";
var repository = {
    "type": "git",
    "url": "https://github.com/d3/d3.git"
};
var files = [
    "dist/**/*.js",
    "index.js"
];
var scripts = {
    "pretest": "rimraf dist && mkdir dist && json2module package.json > dist/package.js && rollup -c",
    "test": "tape 'test/**/*-test.js'",
    "prepublishOnly": "yarn test",
    "postpublish": "git push && git push --tags && cd ../d3.github.com && git pull && cp ../d3/dist/d3.js d3.v5.js && cp ../d3/dist/d3.min.js d3.v5.min.js && git add d3.v5.js d3.v5.min.js && git commit -m \"d3 ${npm_package_version}\" && git push && cd - && cd ../d3-bower && git pull && cp ../d3/LICENSE ../d3/README.md ../d3/dist/d3.js ../d3/dist/d3.min.js . && git add -- LICENSE README.md d3.js d3.min.js && git commit -m \"${npm_package_version}\" && git tag -am \"${npm_package_version}\" v${npm_package_version} && git push && git push --tags && cd - && zip -j dist/d3.zip -- LICENSE README.md API.md CHANGES.md dist/d3.js dist/d3.min.js"
};
var devDependencies = {
    "json2module": "0.0",
    "rimraf": "2",
    "rollup": "1",
    "rollup-plugin-ascii": "0.0",
    "rollup-plugin-node-resolve": "3",
    "rollup-plugin-terser": "5",
    "tape": "4"
};
var dependencies = {
    "d3-array": "1",
    "d3-axis": "1",
    "d3-brush": "1",
    "d3-chord": "1",
    "d3-collection": "1",
    "d3-color": "1",
    "d3-contour": "1",
    "d3-dispatch": "1",
    "d3-drag": "1",
    "d3-dsv": "1",
    "d3-ease": "1",
    "d3-fetch": "1",
    "d3-force": "1",
    "d3-format": "1",
    "d3-geo": "1",
    "d3-hierarchy": "1",
    "d3-interpolate": "1",
    "d3-path": "1",
    "d3-polygon": "1",
    "d3-quadtree": "1",
    "d3-random": "1",
    "d3-scale": "2",
    "d3-scale-chromatic": "1",
    "d3-selection": "1",
    "d3-shape": "1",
    "d3-time": "1",
    "d3-time-format": "2",
    "d3-timer": "1",
    "d3-transition": "1",
    "d3-voronoi": "1",
    "d3-zoom": "1"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoYKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisect", ()=>(0, _bisectDefault.default));
parcelHelpers.export(exports, "bisectRight", ()=>(0, _bisect.bisectRight));
parcelHelpers.export(exports, "bisectLeft", ()=>(0, _bisect.bisectLeft));
parcelHelpers.export(exports, "ascending", ()=>(0, _ascendingDefault.default));
parcelHelpers.export(exports, "bisector", ()=>(0, _bisectorDefault.default));
parcelHelpers.export(exports, "cross", ()=>(0, _crossDefault.default));
parcelHelpers.export(exports, "descending", ()=>(0, _descendingDefault.default));
parcelHelpers.export(exports, "deviation", ()=>(0, _deviationDefault.default));
parcelHelpers.export(exports, "extent", ()=>(0, _extentDefault.default));
parcelHelpers.export(exports, "histogram", ()=>(0, _histogramDefault.default));
parcelHelpers.export(exports, "thresholdFreedmanDiaconis", ()=>(0, _freedmanDiaconisDefault.default));
parcelHelpers.export(exports, "thresholdScott", ()=>(0, _scottDefault.default));
parcelHelpers.export(exports, "thresholdSturges", ()=>(0, _sturgesDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianDefault.default));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minDefault.default));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairsDefault.default));
parcelHelpers.export(exports, "permute", ()=>(0, _permuteDefault.default));
parcelHelpers.export(exports, "quantile", ()=>(0, _quantileDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanDefault.default));
parcelHelpers.export(exports, "shuffle", ()=>(0, _shuffleDefault.default));
parcelHelpers.export(exports, "sum", ()=>(0, _sumDefault.default));
parcelHelpers.export(exports, "ticks", ()=>(0, _ticksDefault.default));
parcelHelpers.export(exports, "tickIncrement", ()=>(0, _ticks.tickIncrement));
parcelHelpers.export(exports, "tickStep", ()=>(0, _ticks.tickStep));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeDefault.default));
parcelHelpers.export(exports, "variance", ()=>(0, _varianceDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipDefault.default));
var _bisect = require("./bisect");
var _bisectDefault = parcelHelpers.interopDefault(_bisect);
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _bisector = require("./bisector");
var _bisectorDefault = parcelHelpers.interopDefault(_bisector);
var _cross = require("./cross");
var _crossDefault = parcelHelpers.interopDefault(_cross);
var _descending = require("./descending");
var _descendingDefault = parcelHelpers.interopDefault(_descending);
var _deviation = require("./deviation");
var _deviationDefault = parcelHelpers.interopDefault(_deviation);
var _extent = require("./extent");
var _extentDefault = parcelHelpers.interopDefault(_extent);
var _histogram = require("./histogram");
var _histogramDefault = parcelHelpers.interopDefault(_histogram);
var _freedmanDiaconis = require("./threshold/freedmanDiaconis");
var _freedmanDiaconisDefault = parcelHelpers.interopDefault(_freedmanDiaconis);
var _scott = require("./threshold/scott");
var _scottDefault = parcelHelpers.interopDefault(_scott);
var _sturges = require("./threshold/sturges");
var _sturgesDefault = parcelHelpers.interopDefault(_sturges);
var _max = require("./max");
var _maxDefault = parcelHelpers.interopDefault(_max);
var _mean = require("./mean");
var _meanDefault = parcelHelpers.interopDefault(_mean);
var _median = require("./median");
var _medianDefault = parcelHelpers.interopDefault(_median);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _min = require("./min");
var _minDefault = parcelHelpers.interopDefault(_min);
var _pairs = require("./pairs");
var _pairsDefault = parcelHelpers.interopDefault(_pairs);
var _permute = require("./permute");
var _permuteDefault = parcelHelpers.interopDefault(_permute);
var _quantile = require("./quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _scan = require("./scan");
var _scanDefault = parcelHelpers.interopDefault(_scan);
var _shuffle = require("./shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _sum = require("./sum");
var _sumDefault = parcelHelpers.interopDefault(_sum);
var _ticks = require("./ticks");
var _ticksDefault = parcelHelpers.interopDefault(_ticks);
var _transpose = require("./transpose");
var _transposeDefault = parcelHelpers.interopDefault(_transpose);
var _variance = require("./variance");
var _varianceDefault = parcelHelpers.interopDefault(_variance);
var _zip = require("./zip");
var _zipDefault = parcelHelpers.interopDefault(_zip);

},{"./bisect":"e2SWo","./ascending":"1y6jc","./bisector":"8AGhY","./cross":"fiX4X","./descending":"hogJT","./deviation":"dG1f7","./extent":"hurrf","./histogram":"iy6q0","./threshold/freedmanDiaconis":"6Od34","./threshold/scott":"c0ke1","./threshold/sturges":"70wjL","./max":"lyQpF","./mean":"64dcr","./median":"vw2AB","./merge":"1SDhC","./min":"1bloD","./pairs":"hJu6c","./permute":"5UdXT","./quantile":"jofqf","./range":"4AFrP","./scan":"8RClz","./shuffle":"8oVcf","./sum":"gdn1u","./ticks":"8lqi0","./transpose":"5jrVL","./variance":"chdhs","./zip":"byBEE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2SWo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bisectRight", ()=>bisectRight);
parcelHelpers.export(exports, "bisectLeft", ()=>bisectLeft);
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _bisector = require("./bisector");
var _bisectorDefault = parcelHelpers.interopDefault(_bisector);
var ascendingBisect = (0, _bisectorDefault.default)((0, _ascendingDefault.default));
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
exports.default = bisectRight;

},{"./ascending":"1y6jc","./bisector":"8AGhY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1y6jc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8AGhY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (compare.length === 1) compare = ascendingComparator(compare);
        return {
            left: function(a, x, lo, hi) {
                if (lo == null) lo = 0;
                if (hi == null) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (compare(a[mid], x) < 0) lo = mid + 1;
                    else hi = mid;
                }
                return lo;
            },
            right: function(a, x, lo, hi) {
                if (lo == null) lo = 0;
                if (hi == null) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (compare(a[mid], x) > 0) hi = mid;
                    else lo = mid + 1;
                }
                return lo;
            }
        };
    });
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
function ascendingComparator(f) {
    return function(d, x) {
        return (0, _ascendingDefault.default)(f(d), x);
    };
}

},{"./ascending":"1y6jc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiX4X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values0, values1, reduce) {
        var n0 = values0.length, n1 = values1.length, values = new Array(n0 * n1), i0, i1, i, value0;
        if (reduce == null) reduce = (0, _pairs.pair);
        for(i0 = i = 0; i0 < n0; ++i0)for(value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i)values[i] = reduce(value0, values1[i1]);
        return values;
    });
var _pairs = require("./pairs");

},{"./pairs":"hJu6c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hJu6c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, f) {
        if (f == null) f = pair;
        var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
        while(i < n)pairs[i] = f(p, p = array[++i]);
        return pairs;
    });
parcelHelpers.export(exports, "pair", ()=>pair);
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hogJT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dG1f7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, f) {
        var v = (0, _varianceDefault.default)(array, f);
        return v ? Math.sqrt(v) : v;
    });
var _variance = require("./variance");
var _varianceDefault = parcelHelpers.interopDefault(_variance);

},{"./variance":"chdhs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chdhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, m = 0, i = -1, mean = 0, value, delta, sum = 0;
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) {
                delta = value - mean;
                mean += delta / ++m;
                sum += delta * (value - mean);
            }
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) {
                delta = value - mean;
                mean += delta / ++m;
                sum += delta * (value - mean);
            }
        }
        if (m > 1) return sum / (m - 1);
    });
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"cQ9YG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQ9YG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x === null ? NaN : +x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hurrf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, min, max;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                min = max = value;
                while(++i < n)if ((value = values[i]) != null) {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                min = max = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null) {
                    if (min > value) min = value;
                    if (max < value) max = value;
                }
            }
        }
        return [
            min,
            max
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iy6q0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityDefault.default), domain = (0, _extentDefault.default), threshold = (0, _sturgesDefault.default);
        function histogram(data) {
            var i, n = data.length, x, values = new Array(n);
            for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                tz = (0, _ticks.tickStep)(x0, x1, tz);
                tz = (0, _rangeDefault.default)(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
            }
            // Remove any thresholds outside the domain.
            var m = tz.length;
            while(tz[0] <= x0)tz.shift(), --m;
            while(tz[m - 1] > x1)tz.pop(), --m;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for(i = 0; i <= m; ++i){
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            for(i = 0; i < n; ++i){
                x = values[i];
                if (x0 <= x && x <= x1) bins[(0, _bisectDefault.default)(tz, x, 0, m)].push(data[i]);
            }
            return bins;
        }
        histogram.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantDefault.default)(_), histogram) : value;
        };
        histogram.domain = function(_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constantDefault.default)([
                _[0],
                _[1]
            ]), histogram) : domain;
        };
        histogram.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantDefault.default)((0, _array.slice).call(_)) : (0, _constantDefault.default)(_), histogram) : threshold;
        };
        return histogram;
    });
var _array = require("./array");
var _bisect = require("./bisect");
var _bisectDefault = parcelHelpers.interopDefault(_bisect);
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _extent = require("./extent");
var _extentDefault = parcelHelpers.interopDefault(_extent);
var _identity = require("./identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _ticks = require("./ticks");
var _sturges = require("./threshold/sturges");
var _sturgesDefault = parcelHelpers.interopDefault(_sturges);

},{"./array":"aKBe4","./bisect":"e2SWo","./constant":"ed8jk","./extent":"hurrf","./identity":"UdjmT","./range":"4AFrP","./ticks":"8lqi0","./threshold/sturges":"70wjL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKBe4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "map", ()=>map);
var array = Array.prototype;
var slice = array.slice;
var map = array.map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ed8jk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"UdjmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4AFrP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while(++i < n)range[i] = start + i * step;
        return range;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lqi0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0) return [
            start
        ];
        if (reverse = stop < start) n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
        if (step > 0) {
            start = Math.ceil(start / step);
            stop = Math.floor(stop / step);
            ticks = new Array(n = Math.ceil(stop - start + 1));
            while(++i < n)ticks[i] = (start + i) * step;
        } else {
            start = Math.floor(start * step);
            stop = Math.ceil(stop * step);
            ticks = new Array(n = Math.ceil(start - stop + 1));
            while(++i < n)ticks[i] = (start - i) / step;
        }
        if (reverse) ticks.reverse();
        return ticks;
    });
parcelHelpers.export(exports, "tickIncrement", ()=>tickIncrement);
parcelHelpers.export(exports, "tickStep", ()=>tickStep);
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"70wjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Od34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        values = (0, _array.map).call(values, (0, _numberDefault.default)).sort((0, _ascendingDefault.default));
        return Math.ceil((max - min) / (2 * ((0, _quantileDefault.default)(values, 0.75) - (0, _quantileDefault.default)(values, 0.25)) * Math.pow(values.length, -1 / 3)));
    });
var _array = require("../array");
var _ascending = require("../ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _number = require("../number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _quantile = require("../quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);

},{"../array":"aKBe4","../ascending":"1y6jc","../number":"cQ9YG","../quantile":"jofqf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jofqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, p, valueof) {
        if (valueof == null) valueof = (0, _numberDefault.default);
        if (!(n = values.length)) return;
        if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
        if (p >= 1) return +valueof(values[n - 1], n - 1, values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
        return value0 + (value1 - value0) * (i - i0);
    });
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"cQ9YG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0ke1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, min, max) {
        return Math.ceil((max - min) / (3.5 * (0, _deviationDefault.default)(values) * Math.pow(values.length, -1 / 3)));
    });
var _deviation = require("../deviation");
var _deviationDefault = parcelHelpers.interopDefault(_deviation);

},{"../deviation":"dG1f7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyQpF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, max;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                max = value;
                while(++i < n)if ((value = values[i]) != null && value > max) max = value;
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                max = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null && value > max) max = value;
            }
        }
        return max;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"64dcr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, m = n, i = -1, value, sum = 0;
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) sum += value;
            else --m;
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) sum += value;
            else --m;
        }
        if (m) return sum / m;
    });
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);

},{"./number":"cQ9YG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"vw2AB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, numbers = [];
        if (valueof == null) {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(values[i]))) numbers.push(value);
        } else {
            while(++i < n)if (!isNaN(value = (0, _numberDefault.default)(valueof(values[i], i, values)))) numbers.push(value);
        }
        return (0, _quantileDefault.default)(numbers.sort((0, _ascendingDefault.default)), 0.5);
    });
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _quantile = require("./quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);

},{"./ascending":"1y6jc","./number":"cQ9YG","./quantile":"jofqf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1SDhC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(arrays) {
        var n = arrays.length, m, i = -1, j = 0, merged, array;
        while(++i < n)j += arrays[i].length;
        merged = new Array(j);
        while(--n >= 0){
            array = arrays[n];
            m = array.length;
            while(--m >= 0)merged[--j] = array[m];
        }
        return merged;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1bloD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, min;
        if (valueof == null) {
            while(++i < n)if ((value = values[i]) != null && value >= value) {
                min = value;
                while(++i < n)if ((value = values[i]) != null && min > value) min = value;
            }
        } else {
            while(++i < n)if ((value = valueof(values[i], i, values)) != null && value >= value) {
                min = value;
                while(++i < n)if ((value = valueof(values[i], i, values)) != null && min > value) min = value;
            }
        }
        return min;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5UdXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, indexes) {
        var i = indexes.length, permutes = new Array(i);
        while(i--)permutes[i] = array[indexes[i]];
        return permutes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8RClz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, compare) {
        if (!(n = values.length)) return;
        var n, i = 0, j = 0, xi, xj = values[j];
        if (compare == null) compare = (0, _ascendingDefault.default);
        while(++i < n)if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
        if (compare(xj, xj) === 0) return j;
    });
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);

},{"./ascending":"1y6jc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oVcf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(array, i0, i1) {
        var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0), t, i;
        while(m){
            i = Math.random() * m-- | 0;
            t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdn1u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values, valueof) {
        var n = values.length, i = -1, value, sum = 0;
        if (valueof == null) {
            while(++i < n)if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
        } else {
            while(++i < n)if (value = +valueof(values[i], i, values)) sum += value;
        }
        return sum;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jrVL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(matrix) {
        if (!(n = matrix.length)) return [];
        for(var i = -1, m = (0, _minDefault.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
        return transpose;
    });
var _min = require("./min");
var _minDefault = parcelHelpers.interopDefault(_min);
function length(d) {
    return d.length;
}

},{"./min":"1bloD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byBEE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _transposeDefault.default)(arguments);
    });
var _transpose = require("./transpose");
var _transposeDefault = parcelHelpers.interopDefault(_transpose);

},{"./transpose":"5jrVL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"41neH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>(0, _axis.axisTop));
parcelHelpers.export(exports, "axisRight", ()=>(0, _axis.axisRight));
parcelHelpers.export(exports, "axisBottom", ()=>(0, _axis.axisBottom));
parcelHelpers.export(exports, "axisLeft", ()=>(0, _axis.axisLeft));
var _axis = require("./axis");

},{"./axis":"gl0Cu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gl0Cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "axisTop", ()=>axisTop);
parcelHelpers.export(exports, "axisRight", ()=>axisRight);
parcelHelpers.export(exports, "axisBottom", ()=>axisBottom);
parcelHelpers.export(exports, "axisLeft", ()=>axisLeft);
var _array = require("./array");
var _identity = require("./identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var top = 1, right = 2, bottom = 3, left = 4, epsilon = 1e-6;
function translateX(x) {
    return "translate(" + (x + 0.5) + ",0)";
}
function translateY(y) {
    return "translate(0," + (y + 0.5) + ")";
}
function number(scale) {
    return function(d) {
        return +scale(d);
    };
}
function center(scale) {
    var offset = Math.max(0, scale.bandwidth() - 1) / 2; // Adjust for 0.5px offset.
    if (scale.round()) offset = Math.round(offset);
    return function(d) {
        return +scale(d) + offset;
    };
}
function entering() {
    return !this.__axis;
}
function axis(orient, scale) {
    var tickArguments = [], tickValues = null, tickFormat = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, k = orient === top || orient === left ? -1 : 1, x = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
    function axis(context) {
        var values = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format = tickFormat == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : (0, _identityDefault.default) : tickFormat, spacing = Math.max(tickSizeInner, 0) + tickPadding, range = scale.range(), range0 = +range[0] + 0.5, range1 = +range[range.length - 1] + 0.5, position = (scale.bandwidth ? center : number)(scale.copy()), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([
            null
        ]), tick = selection.selectAll(".tick").data(values, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line = tick.select("line"), text = tick.select("text");
        path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
        tick = tick.merge(tickEnter);
        line = line.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x + "2", k * tickSizeInner));
        text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x, k * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
        if (context !== selection) {
            path = path.transition(context);
            tick = tick.transition(context);
            line = line.transition(context);
            text = text.transition(context);
            tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function(d) {
                return isFinite(d = position(d)) ? transform(d) : this.getAttribute("transform");
            });
            tickEnter.attr("opacity", epsilon).attr("transform", function(d) {
                var p = this.parentNode.__axis;
                return transform(p && isFinite(p = p(d)) ? p : position(d));
            });
        }
        tickExit.remove();
        path.attr("d", orient === left || orient == right ? tickSizeOuter ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter : "M0.5," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter : "M" + range0 + ",0.5H" + range1);
        tick.attr("opacity", 1).attr("transform", function(d) {
            return transform(position(d));
        });
        line.attr(x + "2", k * tickSizeInner);
        text.attr(x, k * spacing).text(format);
        selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
        selection.each(function() {
            this.__axis = position;
        });
    }
    axis.scale = function(_) {
        return arguments.length ? (scale = _, axis) : scale;
    };
    axis.ticks = function() {
        return tickArguments = (0, _array.slice).call(arguments), axis;
    };
    axis.tickArguments = function(_) {
        return arguments.length ? (tickArguments = _ == null ? [] : (0, _array.slice).call(_), axis) : tickArguments.slice();
    };
    axis.tickValues = function(_) {
        return arguments.length ? (tickValues = _ == null ? null : (0, _array.slice).call(_), axis) : tickValues && tickValues.slice();
    };
    axis.tickFormat = function(_) {
        return arguments.length ? (tickFormat = _, axis) : tickFormat;
    };
    axis.tickSize = function(_) {
        return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
    };
    axis.tickSizeInner = function(_) {
        return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
    };
    axis.tickSizeOuter = function(_) {
        return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
    };
    axis.tickPadding = function(_) {
        return arguments.length ? (tickPadding = +_, axis) : tickPadding;
    };
    return axis;
}
function axisTop(scale) {
    return axis(top, scale);
}
function axisRight(scale) {
    return axis(right, scale);
}
function axisBottom(scale) {
    return axis(bottom, scale);
}
function axisLeft(scale) {
    return axis(left, scale);
}

},{"./array":"fncYV","./identity":"aUrCV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fncYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUrCV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eFd4k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brush", ()=>(0, _brushJsDefault.default));
parcelHelpers.export(exports, "brushX", ()=>(0, _brushJs.brushX));
parcelHelpers.export(exports, "brushY", ()=>(0, _brushJs.brushY));
parcelHelpers.export(exports, "brushSelection", ()=>(0, _brushJs.brushSelection));
var _brushJs = require("./brush.js");
var _brushJsDefault = parcelHelpers.interopDefault(_brushJs);

},{"./brush.js":"8FHep","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8FHep":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brushSelection", ()=>brushSelection);
parcelHelpers.export(exports, "brushX", ()=>brushX);
parcelHelpers.export(exports, "brushY", ()=>brushY);
parcelHelpers.export(exports, "default", ()=>function() {
        return brush(XY);
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var MODE_DRAG = {
    name: "drag"
}, MODE_SPACE = {
    name: "space"
}, MODE_HANDLE = {
    name: "handle"
}, MODE_CENTER = {
    name: "center"
};
function number1(e) {
    return [
        +e[0],
        +e[1]
    ];
}
function number2(e) {
    return [
        number1(e[0]),
        number1(e[1])
    ];
}
function toucher(identifier) {
    return function(target) {
        return (0, _d3Selection.touch)(target, (0, _d3Selection.event).touches, identifier);
    };
}
var X = {
    name: "x",
    handles: [
        "w",
        "e"
    ].map(type),
    input: function(x, e) {
        return x == null ? null : [
            [
                +x[0],
                e[0][1]
            ],
            [
                +x[1],
                e[1][1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][0],
            xy[1][0]
        ];
    }
};
var Y = {
    name: "y",
    handles: [
        "n",
        "s"
    ].map(type),
    input: function(y, e) {
        return y == null ? null : [
            [
                e[0][0],
                +y[0]
            ],
            [
                e[1][0],
                +y[1]
            ]
        ];
    },
    output: function(xy) {
        return xy && [
            xy[0][1],
            xy[1][1]
        ];
    }
};
var XY = {
    name: "xy",
    handles: [
        "n",
        "w",
        "e",
        "s",
        "nw",
        "ne",
        "sw",
        "se"
    ].map(type),
    input: function(xy) {
        return xy == null ? null : number2(xy);
    },
    output: function(xy) {
        return xy;
    }
};
var cursors = {
    overlay: "crosshair",
    selection: "move",
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
};
var flipX = {
    e: "w",
    w: "e",
    nw: "ne",
    ne: "nw",
    se: "sw",
    sw: "se"
};
var flipY = {
    n: "s",
    s: "n",
    nw: "sw",
    ne: "se",
    se: "ne",
    sw: "nw"
};
var signsX = {
    overlay: 1,
    selection: 1,
    n: null,
    e: 1,
    s: null,
    w: -1,
    nw: -1,
    ne: 1,
    se: 1,
    sw: -1
};
var signsY = {
    overlay: 1,
    selection: 1,
    n: -1,
    e: null,
    s: 1,
    w: null,
    nw: -1,
    ne: -1,
    se: 1,
    sw: 1
};
function type(t) {
    return {
        type: t
    };
}
// Ignore right-click, since that should open the context menu.
function defaultFilter() {
    return !(0, _d3Selection.event).ctrlKey && !(0, _d3Selection.event).button;
}
function defaultExtent() {
    var svg = this.ownerSVGElement || this;
    if (svg.hasAttribute("viewBox")) {
        svg = svg.viewBox.baseVal;
        return [
            [
                svg.x,
                svg.y
            ],
            [
                svg.x + svg.width,
                svg.y + svg.height
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            svg.width.baseVal.value,
            svg.height.baseVal.value
        ]
    ];
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
    while(!node.__brush)if (!(node = node.parentNode)) return;
    return node.__brush;
}
function empty(extent) {
    return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}
function brushSelection(node) {
    var state = node.__brush;
    return state ? state.dim.output(state.selection) : null;
}
function brushX() {
    return brush(X);
}
function brushY() {
    return brush(Y);
}
function brush(dim) {
    var extent = defaultExtent, filter = defaultFilter, touchable = defaultTouchable, keys = true, listeners = (0, _d3Dispatch.dispatch)("start", "brush", "end"), handleSize = 6, touchending;
    function brush(group) {
        var overlay = group.property("__brush", initialize).selectAll(".overlay").data([
            type("overlay")
        ]);
        overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function() {
            var extent = local(this).extent;
            (0, _d3Selection.select)(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
        });
        group.selectAll(".selection").data([
            type("selection")
        ]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
        var handle = group.selectAll(".handle").data(dim.handles, function(d) {
            return d.type;
        });
        handle.exit().remove();
        handle.enter().append("rect").attr("class", function(d) {
            return "handle handle--" + d.type;
        }).attr("cursor", function(d) {
            return cursors[d.type];
        });
        group.each(redraw).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", started).filter(touchable).on("touchstart.brush", started).on("touchmove.brush", touchmoved).on("touchend.brush touchcancel.brush", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
    }
    brush.move = function(group, selection) {
        if (group.selection) group.on("start.brush", function() {
            emitter(this, arguments).beforestart().start();
        }).on("interrupt.brush end.brush", function() {
            emitter(this, arguments).end();
        }).tween("brush", function() {
            var that = this, state = that.__brush, emit = emitter(that, arguments), selection0 = state.selection, selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent), i = (0, _d3Interpolate.interpolate)(selection0, selection1);
            function tween(t) {
                state.selection = t === 1 && selection1 === null ? null : i(t);
                redraw.call(that);
                emit.brush();
            }
            return selection0 !== null && selection1 !== null ? tween : tween(1);
        });
        else group.each(function() {
            var that = this, args = arguments, state = that.__brush, selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent), emit = emitter(that, args).beforestart();
            (0, _d3Transition.interrupt)(that);
            state.selection = selection1 === null ? null : selection1;
            redraw.call(that);
            emit.start().brush().end();
        });
    };
    brush.clear = function(group) {
        brush.move(group, null);
    };
    function redraw() {
        var group = (0, _d3Selection.select)(this), selection = local(this).selection;
        if (selection) {
            group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);
            group.selectAll(".handle").style("display", null).attr("x", function(d) {
                return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
            }).attr("y", function(d) {
                return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
            }).attr("width", function(d) {
                return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
            }).attr("height", function(d) {
                return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
            });
        } else group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
    function emitter(that, args, clean) {
        var emit = that.__brush.emitter;
        return emit && (!clean || !emit.clean) ? emit : new Emitter(that, args, clean);
    }
    function Emitter(that, args, clean) {
        this.that = that;
        this.args = args;
        this.state = that.__brush;
        this.active = 0;
        this.clean = clean;
    }
    Emitter.prototype = {
        beforestart: function() {
            if (++this.active === 1) this.state.emitter = this, this.starting = true;
            return this;
        },
        start: function() {
            if (this.starting) this.starting = false, this.emit("start");
            else this.emit("brush");
            return this;
        },
        brush: function() {
            this.emit("brush");
            return this;
        },
        end: function() {
            if (--this.active === 0) delete this.state.emitter, this.emit("end");
            return this;
        },
        emit: function(type) {
            (0, _d3Selection.customEvent)(new (0, _eventJsDefault.default)(brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [
                type,
                this.that,
                this.args
            ]);
        }
    };
    function started() {
        if (touchending && !(0, _d3Selection.event).touches) return;
        if (!filter.apply(this, arguments)) return;
        var that = this, type = (0, _d3Selection.event).target.__data__.type, mode = (keys && (0, _d3Selection.event).metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : keys && (0, _d3Selection.event).altKey ? MODE_CENTER : MODE_HANDLE, signX = dim === Y ? null : signsX[type], signY = dim === X ? null : signsY[type], state = local(that), extent = state.extent, selection = state.selection, W = extent[0][0], w0, w1, N = extent[0][1], n0, n1, E = extent[1][0], e0, e1, S = extent[1][1], s0, s1, dx = 0, dy = 0, moving, shifting = signX && signY && keys && (0, _d3Selection.event).shiftKey, lockX, lockY, pointer = (0, _d3Selection.event).touches ? toucher((0, _d3Selection.event).changedTouches[0].identifier) : (0, _d3Selection.mouse), point0 = pointer(that), point = point0, emit = emitter(that, arguments, true).beforestart();
        if (type === "overlay") {
            if (selection) moving = true;
            state.selection = selection = [
                [
                    w0 = dim === Y ? W : point0[0],
                    n0 = dim === X ? N : point0[1]
                ],
                [
                    e0 = dim === Y ? E : w0,
                    s0 = dim === X ? S : n0
                ]
            ];
        } else {
            w0 = selection[0][0];
            n0 = selection[0][1];
            e0 = selection[1][0];
            s0 = selection[1][1];
        }
        w1 = w0;
        n1 = n0;
        e1 = e0;
        s1 = s0;
        var group = (0, _d3Selection.select)(that).attr("pointer-events", "none");
        var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);
        if ((0, _d3Selection.event).touches) {
            emit.moved = moved;
            emit.ended = ended;
        } else {
            var view = (0, _d3Selection.select)((0, _d3Selection.event).view).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);
            if (keys) view.on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true);
            (0, _d3Drag.dragDisable)((0, _d3Selection.event).view);
        }
        (0, _noeventJs.nopropagation)();
        (0, _d3Transition.interrupt)(that);
        redraw.call(that);
        emit.start();
        function moved() {
            var point1 = pointer(that);
            if (shifting && !lockX && !lockY) {
                if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;
                else lockX = true;
            }
            point = point1;
            moving = true;
            (0, _noeventJsDefault.default)();
            move();
        }
        function move() {
            var t;
            dx = point[0] - point0[0];
            dy = point[1] - point0[1];
            switch(mode){
                case MODE_SPACE:
                case MODE_DRAG:
                    if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
                    if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
                    break;
                case MODE_HANDLE:
                    if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;
                    else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
                    if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;
                    else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
                    break;
                case MODE_CENTER:
                    if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
                    if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
                    break;
            }
            if (e1 < w1) {
                signX *= -1;
                t = w0, w0 = e0, e0 = t;
                t = w1, w1 = e1, e1 = t;
                if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
            }
            if (s1 < n1) {
                signY *= -1;
                t = n0, n0 = s0, s0 = t;
                t = n1, n1 = s1, s1 = t;
                if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
            }
            if (state.selection) selection = state.selection; // May be set by brush.move!
            if (lockX) w1 = selection[0][0], e1 = selection[1][0];
            if (lockY) n1 = selection[0][1], s1 = selection[1][1];
            if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
                state.selection = [
                    [
                        w1,
                        n1
                    ],
                    [
                        e1,
                        s1
                    ]
                ];
                redraw.call(that);
                emit.brush();
            }
        }
        function ended() {
            (0, _noeventJs.nopropagation)();
            if ((0, _d3Selection.event).touches) {
                if ((0, _d3Selection.event).touches.length) return;
                if (touchending) clearTimeout(touchending);
                touchending = setTimeout(function() {
                    touchending = null;
                }, 500); // Ghost clicks are delayed!
            } else {
                (0, _d3Drag.dragEnable)((0, _d3Selection.event).view, moving);
                view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
            }
            group.attr("pointer-events", "all");
            overlay.attr("cursor", cursors.overlay);
            if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
            if (empty(selection)) state.selection = null, redraw.call(that);
            emit.end();
        }
        function keydowned() {
            switch((0, _d3Selection.event).keyCode){
                case 16:
                    shifting = signX && signY;
                    break;
                case 18:
                    if (mode === MODE_HANDLE) {
                        if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                        if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                        mode = MODE_CENTER;
                        move();
                    }
                    break;
                case 32:
                    if (mode === MODE_HANDLE || mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1 - dx;
                        else if (signX > 0) w0 = w1 - dx;
                        if (signY < 0) s0 = s1 - dy;
                        else if (signY > 0) n0 = n1 - dy;
                        mode = MODE_SPACE;
                        overlay.attr("cursor", cursors.selection);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)();
        }
        function keyupped() {
            switch((0, _d3Selection.event).keyCode){
                case 16:
                    if (shifting) {
                        lockX = lockY = shifting = false;
                        move();
                    }
                    break;
                case 18:
                    if (mode === MODE_CENTER) {
                        if (signX < 0) e0 = e1;
                        else if (signX > 0) w0 = w1;
                        if (signY < 0) s0 = s1;
                        else if (signY > 0) n0 = n1;
                        mode = MODE_HANDLE;
                        move();
                    }
                    break;
                case 32:
                    if (mode === MODE_SPACE) {
                        if ((0, _d3Selection.event).altKey) {
                            if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                            if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                            mode = MODE_CENTER;
                        } else {
                            if (signX < 0) e0 = e1;
                            else if (signX > 0) w0 = w1;
                            if (signY < 0) s0 = s1;
                            else if (signY > 0) n0 = n1;
                            mode = MODE_HANDLE;
                        }
                        overlay.attr("cursor", cursors[type]);
                        move();
                    }
                    break;
                default:
                    return;
            }
            (0, _noeventJsDefault.default)();
        }
    }
    function touchmoved() {
        emitter(this, arguments).moved();
    }
    function touchended() {
        emitter(this, arguments).ended();
    }
    function initialize() {
        var state = this.__brush || {
            selection: null
        };
        state.extent = number2(extent.apply(this, arguments));
        state.dim = dim;
        return state;
    }
    brush.extent = function(_) {
        return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(number2(_)), brush) : extent;
    };
    brush.filter = function(_) {
        return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : filter;
    };
    brush.touchable = function(_) {
        return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), brush) : touchable;
    };
    brush.handleSize = function(_) {
        return arguments.length ? (handleSize = +_, brush) : handleSize;
    };
    brush.keyModifiers = function(_) {
        return arguments.length ? (keys = !!_, brush) : keys;
    };
    brush.on = function() {
        var value = listeners.on.apply(listeners, arguments);
        return value === listeners ? brush : value;
    };
    return brush;
}

},{"d3-dispatch":"2VwUr","d3-drag":"HHNYu","d3-interpolate":"5gJW0","d3-selection":"9PvvP","d3-transition":"aj1c5","./constant.js":"4jWqH","./event.js":"9LU8z","./noevent.js":"4ofxs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2VwUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dispatch", ()=>(0, _dispatchJsDefault.default));
var _dispatchJs = require("./dispatch.js");
var _dispatchJsDefault = parcelHelpers.interopDefault(_dispatchJs);

},{"./dispatch.js":"cWgMh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWgMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var noop = {
    value: function() {}
};
function dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new Dispatch(_);
}
function Dispatch(_) {
    this._ = _;
}
function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
exports.default = dispatch;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"HHNYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>(0, _dragJsDefault.default));
parcelHelpers.export(exports, "dragDisable", ()=>(0, _nodragJsDefault.default));
parcelHelpers.export(exports, "dragEnable", ()=>(0, _nodragJs.yesdrag));
var _dragJs = require("./drag.js");
var _dragJsDefault = parcelHelpers.interopDefault(_dragJs);
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);

},{"./drag.js":"6a3PW","./nodrag.js":"kOGkY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6a3PW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, container = defaultContainer, subject = defaultSubject, touchable = defaultTouchable, gestures = {}, listeners = (0, _d3Dispatch.dispatch)("start", "drag", "end"), active = 0, mousedownx, mousedowny, mousemoving, touchending, clickDistance2 = 0;
        function drag(selection) {
            selection.on("mousedown.drag", mousedowned).filter(touchable).on("touchstart.drag", touchstarted).on("touchmove.drag", touchmoved).on("touchend.drag touchcancel.drag", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        function mousedowned() {
            if (touchending || !filter.apply(this, arguments)) return;
            var gesture = beforestart("mouse", container.apply(this, arguments), (0, _d3Selection.mouse), this, arguments);
            if (!gesture) return;
            (0, _d3Selection.select)((0, _d3Selection.event).view).on("mousemove.drag", mousemoved, true).on("mouseup.drag", mouseupped, true);
            (0, _nodragJsDefault.default)((0, _d3Selection.event).view);
            (0, _noeventJs.nopropagation)();
            mousemoving = false;
            mousedownx = (0, _d3Selection.event).clientX;
            mousedowny = (0, _d3Selection.event).clientY;
            gesture("start");
        }
        function mousemoved() {
            (0, _noeventJsDefault.default)();
            if (!mousemoving) {
                var dx = (0, _d3Selection.event).clientX - mousedownx, dy = (0, _d3Selection.event).clientY - mousedowny;
                mousemoving = dx * dx + dy * dy > clickDistance2;
            }
            gestures.mouse("drag");
        }
        function mouseupped() {
            (0, _d3Selection.select)((0, _d3Selection.event).view).on("mousemove.drag mouseup.drag", null);
            (0, _nodragJs.yesdrag)((0, _d3Selection.event).view, mousemoving);
            (0, _noeventJsDefault.default)();
            gestures.mouse("end");
        }
        function touchstarted() {
            if (!filter.apply(this, arguments)) return;
            var touches = (0, _d3Selection.event).changedTouches, c = container.apply(this, arguments), n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = beforestart(touches[i].identifier, c, (0, _d3Selection.touch), this, arguments)) {
                (0, _noeventJs.nopropagation)();
                gesture("start");
            }
        }
        function touchmoved() {
            var touches = (0, _d3Selection.event).changedTouches, n = touches.length, i, gesture;
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJsDefault.default)();
                gesture("drag");
            }
        }
        function touchended() {
            var touches = (0, _d3Selection.event).changedTouches, n = touches.length, i, gesture;
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, 500); // Ghost clicks are delayed!
            for(i = 0; i < n; ++i)if (gesture = gestures[touches[i].identifier]) {
                (0, _noeventJs.nopropagation)();
                gesture("end");
            }
        }
        function beforestart(id, container, point, that, args) {
            var p = point(container, id), s, dx, dy, sublisteners = listeners.copy();
            if (!(0, _d3Selection.customEvent)(new (0, _eventJsDefault.default)(drag, "beforestart", s, id, active, p[0], p[1], 0, 0, sublisteners), function() {
                if (((0, _d3Selection.event).subject = s = subject.apply(that, args)) == null) return false;
                dx = s.x - p[0] || 0;
                dy = s.y - p[1] || 0;
                return true;
            })) return;
            return function gesture(type) {
                var p0 = p, n;
                switch(type){
                    case "start":
                        gestures[id] = gesture, n = active++;
                        break;
                    case "end":
                        delete gestures[id], --active; // nobreak
                    case "drag":
                        p = point(container, id), n = active;
                        break;
                }
                (0, _d3Selection.customEvent)(new (0, _eventJsDefault.default)(drag, type, s, id, n, p[0] + dx, p[1] + dy, p[0] - p0[0], p[1] - p0[1], sublisteners), sublisteners.apply, sublisteners, [
                    type,
                    that,
                    args
                ]);
            };
        }
        drag.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : filter;
        };
        drag.container = function(_) {
            return arguments.length ? (container = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : container;
        };
        drag.subject = function(_) {
            return arguments.length ? (subject = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), drag) : subject;
        };
        drag.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), drag) : touchable;
        };
        drag.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? drag : value;
        };
        drag.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, drag) : Math.sqrt(clickDistance2);
        };
        return drag;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Selection = require("d3-selection");
var _nodragJs = require("./nodrag.js");
var _nodragJsDefault = parcelHelpers.interopDefault(_nodragJs);
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter() {
    return !(0, _d3Selection.event).ctrlKey && !(0, _d3Selection.event).button;
}
function defaultContainer() {
    return this.parentNode;
}
function defaultSubject(d) {
    return d == null ? {
        x: (0, _d3Selection.event).x,
        y: (0, _d3Selection.event).y
    } : d;
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}

},{"d3-dispatch":"2VwUr","d3-selection":"9PvvP","./nodrag.js":"kOGkY","./noevent.js":"8rhnL","./constant.js":"gczea","./event.js":"6OX4n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PvvP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>(0, _createDefault.default));
parcelHelpers.export(exports, "creator", ()=>(0, _creatorDefault.default));
parcelHelpers.export(exports, "local", ()=>(0, _localDefault.default));
parcelHelpers.export(exports, "matcher", ()=>(0, _matcherDefault.default));
parcelHelpers.export(exports, "mouse", ()=>(0, _mouseDefault.default));
parcelHelpers.export(exports, "namespace", ()=>(0, _namespaceDefault.default));
parcelHelpers.export(exports, "namespaces", ()=>(0, _namespacesDefault.default));
parcelHelpers.export(exports, "clientPoint", ()=>(0, _pointDefault.default));
parcelHelpers.export(exports, "select", ()=>(0, _selectDefault.default));
parcelHelpers.export(exports, "selectAll", ()=>(0, _selectAllDefault.default));
parcelHelpers.export(exports, "selection", ()=>(0, _indexDefault.default));
parcelHelpers.export(exports, "selector", ()=>(0, _selectorDefault.default));
parcelHelpers.export(exports, "selectorAll", ()=>(0, _selectorAllDefault.default));
parcelHelpers.export(exports, "style", ()=>(0, _style.styleValue));
parcelHelpers.export(exports, "touch", ()=>(0, _touchDefault.default));
parcelHelpers.export(exports, "touches", ()=>(0, _touchesDefault.default));
parcelHelpers.export(exports, "window", ()=>(0, _windowDefault.default));
parcelHelpers.export(exports, "event", ()=>(0, _on.event));
parcelHelpers.export(exports, "customEvent", ()=>(0, _on.customEvent));
var _create = require("./create");
var _createDefault = parcelHelpers.interopDefault(_create);
var _creator = require("./creator");
var _creatorDefault = parcelHelpers.interopDefault(_creator);
var _local = require("./local");
var _localDefault = parcelHelpers.interopDefault(_local);
var _matcher = require("./matcher");
var _matcherDefault = parcelHelpers.interopDefault(_matcher);
var _mouse = require("./mouse");
var _mouseDefault = parcelHelpers.interopDefault(_mouse);
var _namespace = require("./namespace");
var _namespaceDefault = parcelHelpers.interopDefault(_namespace);
var _namespaces = require("./namespaces");
var _namespacesDefault = parcelHelpers.interopDefault(_namespaces);
var _point = require("./point");
var _pointDefault = parcelHelpers.interopDefault(_point);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectAll = require("./selectAll");
var _selectAllDefault = parcelHelpers.interopDefault(_selectAll);
var _index = require("./selection/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _selector = require("./selector");
var _selectorDefault = parcelHelpers.interopDefault(_selector);
var _selectorAll = require("./selectorAll");
var _selectorAllDefault = parcelHelpers.interopDefault(_selectorAll);
var _style = require("./selection/style");
var _touch = require("./touch");
var _touchDefault = parcelHelpers.interopDefault(_touch);
var _touches = require("./touches");
var _touchesDefault = parcelHelpers.interopDefault(_touches);
var _window = require("./window");
var _windowDefault = parcelHelpers.interopDefault(_window);
var _on = require("./selection/on");

},{"./create":"aThp7","./creator":"9J1Uc","./local":"8V0zV","./matcher":"3cbxf","./mouse":"kyHsT","./namespace":"890X9","./namespaces":"1Q4PJ","./point":"6OKtK","./select":"2Rc7o","./selectAll":"1EslL","./selection/index":"a5jDB","./selector":"hZ4f6","./selectorAll":"9WsMK","./selection/style":"4vnVK","./touch":"04py6","./touches":"fNpld","./window":"aXAiN","./selection/on":"Lh6iE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aThp7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return (0, _selectDefault.default)((0, _creatorDefault.default)(name).call(document.documentElement));
    });
var _creator = require("./creator");
var _creatorDefault = parcelHelpers.interopDefault(_creator);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);

},{"./creator":"9J1Uc","./select":"2Rc7o","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9J1Uc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var fullname = (0, _namespaceDefault.default)(name);
        return (fullname.local ? creatorFixed : creatorInherit)(fullname);
    });
var _namespace = require("./namespace");
var _namespaceDefault = parcelHelpers.interopDefault(_namespace);
var _namespaces = require("./namespaces");
function creatorInherit(name) {
    return function() {
        var document = this.ownerDocument, uri = this.namespaceURI;
        return uri === (0, _namespaces.xhtml) && document.documentElement.namespaceURI === (0, _namespaces.xhtml) ? document.createElement(name) : document.createElementNS(uri, name);
    };
}
function creatorFixed(fullname) {
    return function() {
        return this.ownerDocument.createElementNS(fullname.space, fullname.local);
    };
}

},{"./namespace":"890X9","./namespaces":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"890X9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var prefix = name += "", i = prefix.indexOf(":");
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return (0, _namespacesDefault.default).hasOwnProperty(prefix) ? {
            space: (0, _namespacesDefault.default)[prefix],
            local: name
        } : name;
    });
var _namespaces = require("./namespaces");
var _namespacesDefault = parcelHelpers.interopDefault(_namespaces);

},{"./namespaces":"1Q4PJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Q4PJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xhtml", ()=>xhtml);
var xhtml = "http://www.w3.org/1999/xhtml";
exports.default = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: xhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Rc7o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _index.Selection)([
            [
                document.querySelector(selector)
            ]
        ], [
            document.documentElement
        ]) : new (0, _index.Selection)([
            [
                selector
            ]
        ], (0, _index.root));
    });
var _index = require("./selection/index");

},{"./selection/index":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a5jDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "root", ()=>root);
parcelHelpers.export(exports, "Selection", ()=>Selection);
var _select = require("./select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectAll = require("./selectAll");
var _selectAllDefault = parcelHelpers.interopDefault(_selectAll);
var _filter = require("./filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _data = require("./data");
var _dataDefault = parcelHelpers.interopDefault(_data);
var _enter = require("./enter");
var _enterDefault = parcelHelpers.interopDefault(_enter);
var _exit = require("./exit");
var _exitDefault = parcelHelpers.interopDefault(_exit);
var _join = require("./join");
var _joinDefault = parcelHelpers.interopDefault(_join);
var _merge = require("./merge");
var _mergeDefault = parcelHelpers.interopDefault(_merge);
var _order = require("./order");
var _orderDefault = parcelHelpers.interopDefault(_order);
var _sort = require("./sort");
var _sortDefault = parcelHelpers.interopDefault(_sort);
var _call = require("./call");
var _callDefault = parcelHelpers.interopDefault(_call);
var _nodes = require("./nodes");
var _nodesDefault = parcelHelpers.interopDefault(_nodes);
var _node = require("./node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _size = require("./size");
var _sizeDefault = parcelHelpers.interopDefault(_size);
var _empty = require("./empty");
var _emptyDefault = parcelHelpers.interopDefault(_empty);
var _each = require("./each");
var _eachDefault = parcelHelpers.interopDefault(_each);
var _attr = require("./attr");
var _attrDefault = parcelHelpers.interopDefault(_attr);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _property = require("./property");
var _propertyDefault = parcelHelpers.interopDefault(_property);
var _classed = require("./classed");
var _classedDefault = parcelHelpers.interopDefault(_classed);
var _text = require("./text");
var _textDefault = parcelHelpers.interopDefault(_text);
var _html = require("./html");
var _htmlDefault = parcelHelpers.interopDefault(_html);
var _raise = require("./raise");
var _raiseDefault = parcelHelpers.interopDefault(_raise);
var _lower = require("./lower");
var _lowerDefault = parcelHelpers.interopDefault(_lower);
var _append = require("./append");
var _appendDefault = parcelHelpers.interopDefault(_append);
var _insert = require("./insert");
var _insertDefault = parcelHelpers.interopDefault(_insert);
var _remove = require("./remove");
var _removeDefault = parcelHelpers.interopDefault(_remove);
var _clone = require("./clone");
var _cloneDefault = parcelHelpers.interopDefault(_clone);
var _datum = require("./datum");
var _datumDefault = parcelHelpers.interopDefault(_datum);
var _on = require("./on");
var _onDefault = parcelHelpers.interopDefault(_on);
var _dispatch = require("./dispatch");
var _dispatchDefault = parcelHelpers.interopDefault(_dispatch);
var root = [
    null
];
function Selection(groups, parents) {
    this._groups = groups;
    this._parents = parents;
}
function selection() {
    return new Selection([
        [
            document.documentElement
        ]
    ], root);
}
Selection.prototype = selection.prototype = {
    constructor: Selection,
    select: (0, _selectDefault.default),
    selectAll: (0, _selectAllDefault.default),
    filter: (0, _filterDefault.default),
    data: (0, _dataDefault.default),
    enter: (0, _enterDefault.default),
    exit: (0, _exitDefault.default),
    join: (0, _joinDefault.default),
    merge: (0, _mergeDefault.default),
    order: (0, _orderDefault.default),
    sort: (0, _sortDefault.default),
    call: (0, _callDefault.default),
    nodes: (0, _nodesDefault.default),
    node: (0, _nodeDefault.default),
    size: (0, _sizeDefault.default),
    empty: (0, _emptyDefault.default),
    each: (0, _eachDefault.default),
    attr: (0, _attrDefault.default),
    style: (0, _styleDefault.default),
    property: (0, _propertyDefault.default),
    classed: (0, _classedDefault.default),
    text: (0, _textDefault.default),
    html: (0, _htmlDefault.default),
    raise: (0, _raiseDefault.default),
    lower: (0, _lowerDefault.default),
    append: (0, _appendDefault.default),
    insert: (0, _insertDefault.default),
    remove: (0, _removeDefault.default),
    clone: (0, _cloneDefault.default),
    datum: (0, _datumDefault.default),
    on: (0, _onDefault.default),
    dispatch: (0, _dispatchDefault.default)
};
exports.default = selection;

},{"./select":"4cEkx","./selectAll":"kCglL","./filter":"eNhDs","./data":"9DDr4","./enter":"gP2QE","./exit":"jH42X","./join":"1AmkZ","./merge":"4XmUG","./order":"hgq2c","./sort":"jZWGX","./call":"lf3EW","./nodes":"j05Td","./node":"8ksut","./size":"cMqWP","./empty":"jngRU","./each":"3Fax0","./attr":"4sWgc","./style":"4vnVK","./property":"gUsSc","./classed":"7umaZ","./text":"8vz6Q","./html":"fkrCd","./raise":"i9fD3","./lower":"cy1Ek","./append":"dA1zq","./insert":"kmSFy","./remove":"bjetH","./clone":"3ll3H","./datum":"i9Aev","./on":"Lh6iE","./dispatch":"4tSUD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cEkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
            }
        }
        return new (0, _index.Selection)(subgroups, this._parents);
    });
var _index = require("./index");
var _selector = require("../selector");
var _selectorDefault = parcelHelpers.interopDefault(_selector);

},{"./index":"a5jDB","../selector":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZ4f6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? none : function() {
            return this.querySelector(selector);
        };
    });
function none() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kCglL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        if (typeof select !== "function") select = (0, _selectorAllDefault.default)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                subgroups.push(select.call(node, node.__data__, i, group));
                parents.push(node);
            }
        }
        return new (0, _index.Selection)(subgroups, parents);
    });
var _index = require("./index");
var _selectorAll = require("../selectorAll");
var _selectorAllDefault = parcelHelpers.interopDefault(_selectorAll);

},{"./index":"a5jDB","../selectorAll":"9WsMK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9WsMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return selector == null ? empty : function() {
            return this.querySelectorAll(selector);
        };
    });
function empty() {
    return [];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNhDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _matcherDefault.default)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _index.Selection)(subgroups, this._parents);
    });
var _index = require("./index");
var _matcher = require("../matcher");
var _matcherDefault = parcelHelpers.interopDefault(_matcher);

},{"./index":"a5jDB","../matcher":"3cbxf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3cbxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return function() {
            return this.matches(selector);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9DDr4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value, key) {
        if (!value) {
            data = new Array(this.size()), j = -1;
            this.each(function(d) {
                data[++j] = d;
            });
            return data;
        }
        var bind = key ? bindKey : bindIndex, parents = this._parents, groups = this._groups;
        if (typeof value !== "function") value = (0, _constantDefault.default)(value);
        for(var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j){
            var parent = parents[j], group = groups[j], groupLength = group.length, data = value.call(parent, parent && parent.__data__, j, parents), dataLength = data.length, enterGroup = enter[j] = new Array(dataLength), updateGroup = update[j] = new Array(dataLength), exitGroup = exit[j] = new Array(groupLength);
            bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
            // Now connect the enter nodes to their following update node, such that
            // appendChild can insert the materialized enter node before this node,
            // rather than at the end of the parent node.
            for(var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0)if (previous = enterGroup[i0]) {
                if (i0 >= i1) i1 = i0 + 1;
                while(!(next = updateGroup[i1]) && ++i1 < dataLength);
                previous._next = next || null;
            }
        }
        update = new (0, _index.Selection)(update, parents);
        update._enter = enter;
        update._exit = exit;
        return update;
    });
var _index = require("./index");
var _enter = require("./enter");
var _constant = require("../constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var keyPrefix = "$"; // Protect against keys like “__proto__”.
function bindIndex(parent, group, enter, update, exit, data) {
    var i = 0, node, groupLength = group.length, dataLength = data.length;
    // Put any non-null nodes that fit into update.
    // Put any null nodes into enter.
    // Put any remaining data into enter.
    for(; i < dataLength; ++i)if (node = group[i]) {
        node.__data__ = data[i];
        update[i] = node;
    } else enter[i] = new (0, _enter.EnterNode)(parent, data[i]);
    // Put any non-null nodes that don’t fit into exit.
    for(; i < groupLength; ++i)if (node = group[i]) exit[i] = node;
}
function bindKey(parent, group, enter, update, exit, data, key) {
    var i, node, nodeByKeyValue = {}, groupLength = group.length, dataLength = data.length, keyValues = new Array(groupLength), keyValue;
    // Compute the key for each node.
    // If multiple nodes have the same key, the duplicates are added to exit.
    for(i = 0; i < groupLength; ++i)if (node = group[i]) {
        keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
        if (keyValue in nodeByKeyValue) exit[i] = node;
        else nodeByKeyValue[keyValue] = node;
    }
    // Compute the key for each datum.
    // If there a node associated with this key, join and add it to update.
    // If there is not (or the key is a duplicate), add it to enter.
    for(i = 0; i < dataLength; ++i){
        keyValue = keyPrefix + key.call(parent, data[i], i, data);
        if (node = nodeByKeyValue[keyValue]) {
            update[i] = node;
            node.__data__ = data[i];
            nodeByKeyValue[keyValue] = null;
        } else enter[i] = new (0, _enter.EnterNode)(parent, data[i]);
    }
    // Add any remaining nodes that were not bound to data to exit.
    for(i = 0; i < groupLength; ++i)if ((node = group[i]) && nodeByKeyValue[keyValues[i]] === node) exit[i] = node;
}

},{"./index":"a5jDB","./enter":"gP2QE","../constant":"c7sKD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gP2QE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _index.Selection)(this._enter || this._groups.map((0, _sparseDefault.default)), this._parents);
    });
parcelHelpers.export(exports, "EnterNode", ()=>EnterNode);
var _sparse = require("./sparse");
var _sparseDefault = parcelHelpers.interopDefault(_sparse);
var _index = require("./index");
function EnterNode(parent, datum) {
    this.ownerDocument = parent.ownerDocument;
    this.namespaceURI = parent.namespaceURI;
    this._next = null;
    this._parent = parent;
    this.__data__ = datum;
}
EnterNode.prototype = {
    constructor: EnterNode,
    appendChild: function(child) {
        return this._parent.insertBefore(child, this._next);
    },
    insertBefore: function(child, next) {
        return this._parent.insertBefore(child, next);
    },
    querySelector: function(selector) {
        return this._parent.querySelector(selector);
    },
    querySelectorAll: function(selector) {
        return this._parent.querySelectorAll(selector);
    }
};

},{"./sparse":"4Dzlv","./index":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Dzlv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(update) {
        return new Array(update.length);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7sKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jH42X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new (0, _index.Selection)(this._exit || this._groups.map((0, _sparseDefault.default)), this._parents);
    });
var _sparse = require("./sparse");
var _sparseDefault = parcelHelpers.interopDefault(_sparse);
var _index = require("./index");

},{"./sparse":"4Dzlv","./index":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AmkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(onenter, onupdate, onexit) {
        var enter = this.enter(), update = this, exit = this.exit();
        enter = typeof onenter === "function" ? onenter(enter) : enter.append(onenter + "");
        if (onupdate != null) update = onupdate(update);
        if (onexit == null) exit.remove();
        else onexit(exit);
        return enter && update ? enter.merge(update).order() : update;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XmUG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selection) {
        for(var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _index.Selection)(merges, this._parents);
    });
var _index = require("./index");

},{"./index":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgq2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = -1, m = groups.length; ++j < m;){
            for(var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jZWGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        if (!compare) compare = ascending;
        function compareNode(a, b) {
            return a && b ? compare(a.__data__, b.__data__) : !a - !b;
        }
        for(var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group[i]) sortgroup[i] = node;
            sortgroup.sort(compareNode);
        }
        return new (0, _index.Selection)(sortgroups, this._parents).order();
    });
var _index = require("./index");
function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{"./index":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lf3EW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var callback = arguments[0];
        arguments[0] = this;
        callback.apply(null, arguments);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j05Td":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes = new Array(this.size()), i = -1;
        this.each(function() {
            nodes[++i] = this;
        });
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ksut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j)for(var group = groups[j], i = 0, n = group.length; i < n; ++i){
            var node = group[i];
            if (node) return node;
        }
        return null;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cMqWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.each(function() {
            ++size;
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jngRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return !this.node();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Fax0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        for(var groups = this._groups, j = 0, m = groups.length; j < m; ++j){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; ++i)if (node = group[i]) callback.call(node, node.__data__, i, group);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4sWgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _namespaceDefault.default)(name);
        if (arguments.length < 2) {
            var node = this.node();
            return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
        }
        return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
    });
var _namespace = require("../namespace");
var _namespaceDefault = parcelHelpers.interopDefault(_namespace);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, value) {
    return function() {
        this.setAttribute(name, value);
    };
}
function attrConstantNS(fullname, value) {
    return function() {
        this.setAttributeNS(fullname.space, fullname.local, value);
    };
}
function attrFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttribute(name);
        else this.setAttribute(name, v);
    };
}
function attrFunctionNS(fullname, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
        else this.setAttributeNS(fullname.space, fullname.local, v);
    };
}

},{"../namespace":"890X9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4vnVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
    });
parcelHelpers.export(exports, "styleValue", ()=>styleValue);
var _window = require("../window");
var _windowDefault = parcelHelpers.interopDefault(_window);
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, value, priority) {
    return function() {
        this.style.setProperty(name, value, priority);
    };
}
function styleFunction(name, value, priority) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) this.style.removeProperty(name);
        else this.style.setProperty(name, v, priority);
    };
}
function styleValue(node, name) {
    return node.style.getPropertyValue(name) || (0, _windowDefault.default)(node).getComputedStyle(node, null).getPropertyValue(name);
}

},{"../window":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aXAiN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        return node.ownerDocument && node.ownerDocument.defaultView // node is a Node
         || node.document && node // node is a Window
         || node.defaultView; // node is a Document
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUsSc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
    });
function propertyRemove(name) {
    return function() {
        delete this[name];
    };
}
function propertyConstant(name, value) {
    return function() {
        this[name] = value;
    };
}
function propertyFunction(name, value) {
    return function() {
        var v = value.apply(this, arguments);
        if (v == null) delete this[name];
        else this[name] = v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7umaZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var names = classArray(name + "");
        if (arguments.length < 2) {
            var list = classList(this.node()), i = -1, n = names.length;
            while(++i < n)if (!list.contains(names[i])) return false;
            return true;
        }
        return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
    });
function classArray(string) {
    return string.trim().split(/^|\s+/);
}
function classList(node) {
    return node.classList || new ClassList(node);
}
function ClassList(node) {
    this._node = node;
    this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
    add: function(name) {
        var i = this._names.indexOf(name);
        if (i < 0) {
            this._names.push(name);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    remove: function(name) {
        var i = this._names.indexOf(name);
        if (i >= 0) {
            this._names.splice(i, 1);
            this._node.setAttribute("class", this._names.join(" "));
        }
    },
    contains: function(name) {
        return this._names.indexOf(name) >= 0;
    }
};
function classedAdd(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.add(names[i]);
}
function classedRemove(node, names) {
    var list = classList(node), i = -1, n = names.length;
    while(++i < n)list.remove(names[i]);
}
function classedTrue(names) {
    return function() {
        classedAdd(this, names);
    };
}
function classedFalse(names) {
    return function() {
        classedRemove(this, names);
    };
}
function classedFunction(names, value) {
    return function() {
        (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vz6Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
    });
function textRemove() {
    this.textContent = "";
}
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fkrCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
    });
function htmlRemove() {
    this.innerHTML = "";
}
function htmlConstant(value) {
    return function() {
        this.innerHTML = value;
    };
}
function htmlFunction(value) {
    return function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9fD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(raise);
    });
function raise() {
    if (this.nextSibling) this.parentNode.appendChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cy1Ek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(lower);
    });
function lower() {
    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dA1zq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var create = typeof name === "function" ? name : (0, _creatorDefault.default)(name);
        return this.select(function() {
            return this.appendChild(create.apply(this, arguments));
        });
    });
var _creator = require("../creator");
var _creatorDefault = parcelHelpers.interopDefault(_creator);

},{"../creator":"9J1Uc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kmSFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, before) {
        var create = typeof name === "function" ? name : (0, _creatorDefault.default)(name), select = before == null ? constantNull : typeof before === "function" ? before : (0, _selectorDefault.default)(before);
        return this.select(function() {
            return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
        });
    });
var _creator = require("../creator");
var _creatorDefault = parcelHelpers.interopDefault(_creator);
var _selector = require("../selector");
var _selectorDefault = parcelHelpers.interopDefault(_selector);
function constantNull() {
    return null;
}

},{"../creator":"9J1Uc","../selector":"hZ4f6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjetH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.each(remove);
    });
function remove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ll3H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(deep) {
        return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
    });
function selection_cloneShallow() {
    var clone = this.cloneNode(false), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}
function selection_cloneDeep() {
    var clone = this.cloneNode(true), parent = this.parentNode;
    return parent ? parent.insertBefore(clone, this.nextSibling) : clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9Aev":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return arguments.length ? this.property("__data__", value) : this.node().__data__;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Lh6iE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "event", ()=>event);
parcelHelpers.export(exports, "default", ()=>function(typename, value, capture) {
        var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
        if (arguments.length < 2) {
            var on = this.node().__on;
            if (on) for(var j = 0, m = on.length, o; j < m; ++j)for(i = 0, o = on[j]; i < n; ++i){
                if ((t = typenames[i]).type === o.type && t.name === o.name) return o.value;
            }
            return;
        }
        on = value ? onAdd : onRemove;
        if (capture == null) capture = false;
        for(i = 0; i < n; ++i)this.each(on(typenames[i], value, capture));
        return this;
    });
parcelHelpers.export(exports, "customEvent", ()=>customEvent);
var filterEvents = {};
var event = null;
if (typeof document !== "undefined") {
    var element = document.documentElement;
    if (!("onmouseenter" in element)) filterEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
}
function filterContextListener(listener, index, group) {
    listener = contextListener(listener, index, group);
    return function(event) {
        var related = event.relatedTarget;
        if (!related || related !== this && !(related.compareDocumentPosition(this) & 8)) listener.call(this, event);
    };
}
function contextListener(listener, index, group) {
    return function(event1) {
        var event0 = event; // Events can be reentrant (e.g., focus).
        event = event1;
        try {
            listener.call(this, this.__data__, index, group);
        } finally{
            event = event0;
        }
    };
}
function parseTypenames(typenames) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        return {
            type: t,
            name: name
        };
    });
}
function onRemove(typename) {
    return function() {
        var on = this.__on;
        if (!on) return;
        for(var j = 0, i = -1, m = on.length, o; j < m; ++j)if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) this.removeEventListener(o.type, o.listener, o.capture);
        else on[++i] = o;
        if (++i) on.length = i;
        else delete this.__on;
    };
}
function onAdd(typename, value, capture) {
    var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
    return function(d, i, group) {
        var on = this.__on, o, listener = wrap(value, i, group);
        if (on) {
            for(var j = 0, m = on.length; j < m; ++j)if ((o = on[j]).type === typename.type && o.name === typename.name) {
                this.removeEventListener(o.type, o.listener, o.capture);
                this.addEventListener(o.type, o.listener = listener, o.capture = capture);
                o.value = value;
                return;
            }
        }
        this.addEventListener(typename.type, listener, capture);
        o = {
            type: typename.type,
            name: typename.name,
            value: value,
            listener: listener,
            capture: capture
        };
        if (!on) this.__on = [
            o
        ];
        else on.push(o);
    };
}
function customEvent(event1, listener, that, args) {
    var event0 = event;
    event1.sourceEvent = event;
    event = event1;
    try {
        return listener.apply(that, args);
    } finally{
        event = event0;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tSUD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(type, params) {
        return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type, params));
    });
var _window = require("../window");
var _windowDefault = parcelHelpers.interopDefault(_window);
function dispatchEvent(node, type, params) {
    var window = (0, _windowDefault.default)(node), event = window.CustomEvent;
    if (typeof event === "function") event = new event(type, params);
    else {
        event = window.document.createEvent("Event");
        if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
        else event.initEvent(type, false, false);
    }
    node.dispatchEvent(event);
}
function dispatchConstant(type, params) {
    return function() {
        return dispatchEvent(this, type, params);
    };
}
function dispatchFunction(type, params) {
    return function() {
        return dispatchEvent(this, type, params.apply(this, arguments));
    };
}

},{"../window":"aXAiN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8V0zV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>local);
var nextId = 0;
function local() {
    return new Local;
}
function Local() {
    this._ = "@" + (++nextId).toString(36);
}
Local.prototype = local.prototype = {
    constructor: Local,
    get: function(node) {
        var id = this._;
        while(!(id in node))if (!(node = node.parentNode)) return;
        return node[id];
    },
    set: function(node, value) {
        return node[this._] = value;
    },
    remove: function(node) {
        return this._ in node && delete node[this._];
    },
    toString: function() {
        return this._;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kyHsT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        var event = (0, _sourceEventDefault.default)();
        if (event.changedTouches) event = event.changedTouches[0];
        return (0, _pointDefault.default)(node, event);
    });
var _sourceEvent = require("./sourceEvent");
var _sourceEventDefault = parcelHelpers.interopDefault(_sourceEvent);
var _point = require("./point");
var _pointDefault = parcelHelpers.interopDefault(_point);

},{"./sourceEvent":"fQtlW","./point":"6OKtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fQtlW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var current = (0, _on.event), source;
        while(source = current.sourceEvent)current = source;
        return current;
    });
var _on = require("./selection/on");

},{"./selection/on":"Lh6iE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6OKtK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, event) {
        var svg = node.ownerSVGElement || node;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            point.x = event.clientX, point.y = event.clientY;
            point = point.matrixTransform(node.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        var rect = node.getBoundingClientRect();
        return [
            event.clientX - rect.left - node.clientLeft,
            event.clientY - rect.top - node.clientTop
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1EslL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(selector) {
        return typeof selector === "string" ? new (0, _index.Selection)([
            document.querySelectorAll(selector)
        ], [
            document.documentElement
        ]) : new (0, _index.Selection)([
            selector == null ? [] : selector
        ], (0, _index.root));
    });
var _index = require("./selection/index");

},{"./selection/index":"a5jDB","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04py6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, touches, identifier) {
        if (arguments.length < 3) identifier = touches, touches = (0, _sourceEventDefault.default)().changedTouches;
        for(var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i){
            if ((touch = touches[i]).identifier === identifier) return (0, _pointDefault.default)(node, touch);
        }
        return null;
    });
var _sourceEvent = require("./sourceEvent");
var _sourceEventDefault = parcelHelpers.interopDefault(_sourceEvent);
var _point = require("./point");
var _pointDefault = parcelHelpers.interopDefault(_point);

},{"./sourceEvent":"fQtlW","./point":"6OKtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNpld":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, touches) {
        if (touches == null) touches = (0, _sourceEventDefault.default)().touches;
        for(var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i)points[i] = (0, _pointDefault.default)(node, touches[i]);
        return points;
    });
var _sourceEvent = require("./sourceEvent");
var _sourceEventDefault = parcelHelpers.interopDefault(_sourceEvent);
var _point = require("./point");
var _pointDefault = parcelHelpers.interopDefault(_point);

},{"./sourceEvent":"fQtlW","./point":"6OKtK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOGkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(view) {
        var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", (0, _noeventJsDefault.default), true);
        if ("onselectstart" in root) selection.on("selectstart.drag", (0, _noeventJsDefault.default), true);
        else {
            root.__noselect = root.style.MozUserSelect;
            root.style.MozUserSelect = "none";
        }
    });
parcelHelpers.export(exports, "yesdrag", ()=>yesdrag);
var _d3Selection = require("d3-selection");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
function yesdrag(view, noclick) {
    var root = view.document.documentElement, selection = (0, _d3Selection.select)(view).on("dragstart.drag", null);
    if (noclick) {
        selection.on("click.drag", (0, _noeventJsDefault.default), true);
        setTimeout(function() {
            selection.on("click.drag", null);
        }, 0);
    }
    if ("onselectstart" in root) selection.on("selectstart.drag", null);
    else {
        root.style.MozUserSelect = root.__noselect;
        delete root.__noselect;
    }
}

},{"d3-selection":"9PvvP","./noevent.js":"8rhnL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rhnL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function() {
        (0, _d3Selection.event).preventDefault();
        (0, _d3Selection.event).stopImmediatePropagation();
    });
var _d3Selection = require("d3-selection");
function nopropagation() {
    (0, _d3Selection.event).stopImmediatePropagation();
}

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gczea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6OX4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DragEvent);
function DragEvent(target, type, subject, id, active, x, y, dx, dy, dispatch) {
    this.target = target;
    this.type = type;
    this.subject = subject;
    this.identifier = id;
    this.active = active;
    this.x = x;
    this.y = y;
    this.dx = dx;
    this.dy = dy;
    this._ = dispatch;
}
DragEvent.prototype.on = function() {
    var value = this._.on.apply(this._, arguments);
    return value === this._ ? this : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5gJW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>(0, _valueJsDefault.default));
parcelHelpers.export(exports, "interpolateArray", ()=>(0, _arrayJsDefault.default));
parcelHelpers.export(exports, "interpolateBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "interpolateBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "interpolateDate", ()=>(0, _dateJsDefault.default));
parcelHelpers.export(exports, "interpolateDiscrete", ()=>(0, _discreteJsDefault.default));
parcelHelpers.export(exports, "interpolateHue", ()=>(0, _hueJsDefault.default));
parcelHelpers.export(exports, "interpolateNumber", ()=>(0, _numberJsDefault.default));
parcelHelpers.export(exports, "interpolateNumberArray", ()=>(0, _numberArrayJsDefault.default));
parcelHelpers.export(exports, "interpolateObject", ()=>(0, _objectJsDefault.default));
parcelHelpers.export(exports, "interpolateRound", ()=>(0, _roundJsDefault.default));
parcelHelpers.export(exports, "interpolateString", ()=>(0, _stringJsDefault.default));
parcelHelpers.export(exports, "interpolateTransformCss", ()=>(0, _indexJs.interpolateTransformCss));
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>(0, _indexJs.interpolateTransformSvg));
parcelHelpers.export(exports, "interpolateZoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "interpolateRgb", ()=>(0, _rgbJsDefault.default));
parcelHelpers.export(exports, "interpolateRgbBasis", ()=>(0, _rgbJs.rgbBasis));
parcelHelpers.export(exports, "interpolateRgbBasisClosed", ()=>(0, _rgbJs.rgbBasisClosed));
parcelHelpers.export(exports, "interpolateHsl", ()=>(0, _hslJsDefault.default));
parcelHelpers.export(exports, "interpolateHslLong", ()=>(0, _hslJs.hslLong));
parcelHelpers.export(exports, "interpolateLab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "interpolateHcl", ()=>(0, _hclJsDefault.default));
parcelHelpers.export(exports, "interpolateHclLong", ()=>(0, _hclJs.hclLong));
parcelHelpers.export(exports, "interpolateCubehelix", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixLong", ()=>(0, _cubehelixJs.cubehelixLong));
parcelHelpers.export(exports, "piecewise", ()=>(0, _piecewiseJsDefault.default));
parcelHelpers.export(exports, "quantize", ()=>(0, _quantizeJsDefault.default));
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _arrayJs = require("./array.js");
var _arrayJsDefault = parcelHelpers.interopDefault(_arrayJs);
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _discreteJs = require("./discrete.js");
var _discreteJsDefault = parcelHelpers.interopDefault(_discreteJs);
var _hueJs = require("./hue.js");
var _hueJsDefault = parcelHelpers.interopDefault(_hueJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _indexJs = require("./transform/index.js");
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _hslJs = require("./hsl.js");
var _hslJsDefault = parcelHelpers.interopDefault(_hslJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _hclJs = require("./hcl.js");
var _hclJsDefault = parcelHelpers.interopDefault(_hclJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _piecewiseJs = require("./piecewise.js");
var _piecewiseJsDefault = parcelHelpers.interopDefault(_piecewiseJs);
var _quantizeJs = require("./quantize.js");
var _quantizeJsDefault = parcelHelpers.interopDefault(_quantizeJs);

},{"./value.js":"78upz","./array.js":"eb1ox","./basis.js":"6hdhZ","./basisClosed.js":"pPwhQ","./date.js":"eBq0A","./discrete.js":"cDTKZ","./hue.js":"6bCtD","./number.js":"j5icT","./numberArray.js":"2R8WR","./object.js":"dfxE0","./round.js":"2oPnZ","./string.js":"fqpjr","./transform/index.js":"5Kwa1","./zoom.js":"dYZqs","./rgb.js":"f5JLR","./hsl.js":"gpCEl","./lab.js":"59sZQ","./hcl.js":"8D5sR","./cubehelix.js":"fTpuZ","./piecewise.js":"8nOq6","./quantize.js":"hHRVh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78upz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var t = typeof b, c;
        return b == null || t === "boolean" ? (0, _constantJsDefault.default)(b) : (t === "number" ? (0, _numberJsDefault.default) : t === "string" ? (c = (0, _d3Color.color)(b)) ? (b = c, _rgbJsDefault.default) : (0, _stringJsDefault.default) : b instanceof (0, _d3Color.color) ? (0, _rgbJsDefault.default) : b instanceof Date ? (0, _dateJsDefault.default) : (0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : Array.isArray(b) ? (0, _arrayJs.genericArray) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, _objectJsDefault.default) : (0, _numberJsDefault.default))(a, b);
    });
var _d3Color = require("d3-color");
var _rgbJs = require("./rgb.js");
var _rgbJsDefault = parcelHelpers.interopDefault(_rgbJs);
var _arrayJs = require("./array.js");
var _dateJs = require("./date.js");
var _dateJsDefault = parcelHelpers.interopDefault(_dateJs);
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _objectJs = require("./object.js");
var _objectJsDefault = parcelHelpers.interopDefault(_objectJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);

},{"d3-color":"jv6Pr","./rgb.js":"f5JLR","./array.js":"eb1ox","./date.js":"eBq0A","./number.js":"j5icT","./object.js":"dfxE0","./string.js":"fqpjr","./constant.js":"xDayq","./numberArray.js":"2R8WR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jv6Pr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>(0, _colorJsDefault.default));
parcelHelpers.export(exports, "rgb", ()=>(0, _colorJs.rgb));
parcelHelpers.export(exports, "hsl", ()=>(0, _colorJs.hsl));
parcelHelpers.export(exports, "lab", ()=>(0, _labJsDefault.default));
parcelHelpers.export(exports, "hcl", ()=>(0, _labJs.hcl));
parcelHelpers.export(exports, "lch", ()=>(0, _labJs.lch));
parcelHelpers.export(exports, "gray", ()=>(0, _labJs.gray));
parcelHelpers.export(exports, "cubehelix", ()=>(0, _cubehelixJsDefault.default));
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
var _labJs = require("./lab.js");
var _labJsDefault = parcelHelpers.interopDefault(_labJs);
var _cubehelixJs = require("./cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);

},{"./color.js":"bQ7hd","./lab.js":"80Y9r","./cubehelix.js":"bpc6C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bQ7hd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "darker", ()=>darker);
parcelHelpers.export(exports, "brighter", ()=>brighter);
parcelHelpers.export(exports, "default", ()=>color);
parcelHelpers.export(exports, "rgbConvert", ()=>rgbConvert);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "Rgb", ()=>Rgb);
parcelHelpers.export(exports, "hslConvert", ()=>hslConvert);
parcelHelpers.export(exports, "hsl", ()=>hsl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _defineJsDefault.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Rgb, rgb, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Hsl, hsl, (0, _defineJs.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"./define.js":"fhaY4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fhaY4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(constructor, factory, prototype) {
        constructor.prototype = factory.prototype = prototype;
        prototype.constructor = constructor;
    });
parcelHelpers.export(exports, "extend", ()=>extend);
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"80Y9r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "default", ()=>lab);
parcelHelpers.export(exports, "Lab", ()=>Lab);
parcelHelpers.export(exports, "lch", ()=>lch);
parcelHelpers.export(exports, "hcl", ()=>hcl);
parcelHelpers.export(exports, "Hcl", ()=>Hcl);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Lab, lab, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new (0, _colorJs.Rgb)(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * (0, _mathJs.rad2deg);
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * (0, _mathJs.deg2rad);
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _defineJsDefault.default)(Hcl, hcl, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
        return hcl2lab(this).rgb();
    }
}));

},{"./define.js":"fhaY4","./color.js":"bQ7hd","./math.js":"aokDz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aokDz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deg2rad", ()=>deg2rad);
parcelHelpers.export(exports, "rad2deg", ()=>rad2deg);
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bpc6C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>cubehelix);
parcelHelpers.export(exports, "Cubehelix", ()=>Cubehelix);
var _defineJs = require("./define.js");
var _defineJsDefault = parcelHelpers.interopDefault(_defineJs);
var _colorJs = require("./color.js");
var _mathJs = require("./math.js");
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, _colorJs.Rgb))) o = (0, _colorJs.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, _mathJs.rad2deg) - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _defineJsDefault.default)(Cubehelix, cubehelix, (0, _defineJs.extend)((0, _colorJs.Color), {
    brighter: function(k) {
        k = k == null ? (0, _colorJs.brighter) : Math.pow((0, _colorJs.brighter), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, _colorJs.darker) : Math.pow((0, _colorJs.darker), k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, _mathJs.deg2rad), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, _colorJs.Rgb)(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"./define.js":"fhaY4","./color.js":"bQ7hd","./math.js":"aokDz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f5JLR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbBasis", ()=>rgbBasis);
parcelHelpers.export(exports, "rgbBasisClosed", ()=>rgbBasisClosed);
var _d3Color = require("d3-color");
var _basisJs = require("./basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _basisClosedJs = require("./basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
exports.default = function rgbGamma(y) {
    var color = (0, _colorJs.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _d3Color.rgb)(start)).r, (end = (0, _d3Color.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _d3Color.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = rgbSpline((0, _basisJsDefault.default));
var rgbBasisClosed = rgbSpline((0, _basisClosedJsDefault.default));

},{"d3-color":"jv6Pr","./basis.js":"6hdhZ","./basisClosed.js":"pPwhQ","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hdhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basis", ()=>basis);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length - 1;
        return function(t) {
            var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
            return basis((t - i / n) * n, v0, v1, v2, v3);
        };
    });
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pPwhQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(values) {
        var n = values.length;
        return function(t) {
            var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
            return (0, _basisJs.basis)((t - i / n) * n, v0, v1, v2, v3);
        };
    });
var _basisJs = require("./basis.js");

},{"./basis.js":"6hdhZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoWOo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hue", ()=>hue);
parcelHelpers.export(exports, "gamma", ()=>gamma);
parcelHelpers.export(exports, "default", ()=>nogamma);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constantJsDefault.default)(isNaN(a) ? b : a);
}

},{"./constant.js":"xDayq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xDayq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eb1ox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return ((0, _numberArrayJs.isNumberArray)(b) ? (0, _numberArrayJsDefault.default) : genericArray)(a, b);
    });
parcelHelpers.export(exports, "genericArray", ()=>genericArray);
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);
var _numberArrayJs = require("./numberArray.js");
var _numberArrayJsDefault = parcelHelpers.interopDefault(_numberArrayJs);
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _valueJsDefault.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"./value.js":"78upz","./numberArray.js":"2R8WR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2R8WR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        if (!b) b = [];
        var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
        return function(t) {
            for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
            return c;
        };
    });
parcelHelpers.export(exports, "isNumberArray", ()=>isNumberArray);
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBq0A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var d = new Date;
        return a = +a, b = +b, function(t) {
            return d.setTime(a * (1 - t) + b * t), d;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j5icT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return a * (1 - t) + b * t;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dfxE0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = {}, c = {}, k;
        if (a === null || typeof a !== "object") a = {};
        if (b === null || typeof b !== "object") b = {};
        for(k in b)if (k in a) i[k] = (0, _valueJsDefault.default)(a[k], b[k]);
        else c[k] = b[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    });
var _valueJs = require("./value.js");
var _valueJsDefault = parcelHelpers.interopDefault(_valueJs);

},{"./value.js":"78upz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fqpjr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
        // Coerce inputs to strings.
        a = a + "", b = b + "";
        // Interpolate pairs of numbers in a & b.
        while((am = reA.exec(a)) && (bm = reB.exec(b))){
            if ((bs = bm.index) > bi) {
                bs = b.slice(bi, bs);
                if (s[i]) s[i] += bs; // coalesce with previous string
                else s[++i] = bs;
            }
            if ((am = am[0]) === (bm = bm[0])) {
                if (s[i]) s[i] += bm; // coalesce with previous string
                else s[++i] = bm;
            } else {
                s[++i] = null;
                q.push({
                    i: i,
                    x: (0, _numberJsDefault.default)(am, bm)
                });
            }
            bi = reB.lastIndex;
        }
        // Add remains of b.
        if (bi < b.length) {
            bs = b.slice(bi);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        // Special optimization for only a single match.
        // Otherwise, interpolate each of the numbers and rejoin the string.
        return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
            for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        });
    });
var _numberJs = require("./number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}

},{"./number.js":"j5icT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cDTKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(range) {
        var n = range.length;
        return function(t) {
            return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6bCtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var i = (0, _colorJs.hue)(+a, +b);
        return function(t) {
            var x = i(t);
            return x - 360 * Math.floor(x / 360);
        };
    });
var _colorJs = require("./color.js");

},{"./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2oPnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a = +a, b = +b, function(t) {
            return Math.round(a * (1 - t) + b * t);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Kwa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolateTransformCss", ()=>interpolateTransformCss);
parcelHelpers.export(exports, "interpolateTransformSvg", ()=>interpolateTransformSvg);
var _numberJs = require("../number.js");
var _numberJsDefault = parcelHelpers.interopDefault(_numberJs);
var _parseJs = require("./parse.js");
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _numberJsDefault.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _numberJsDefault.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _numberJsDefault.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _numberJsDefault.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = interpolateTransform((0, _parseJs.parseCss), "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform((0, _parseJs.parseSvg), ", ", ")", ")");

},{"../number.js":"j5icT","./parse.js":"lUixM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUixM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCss", ()=>parseCss);
parcelHelpers.export(exports, "parseSvg", ()=>parseSvg);
var _decomposeJs = require("./decompose.js");
var _decomposeJsDefault = parcelHelpers.interopDefault(_decomposeJs);
var cssNode, cssRoot, cssView, svgNode;
function parseCss(value) {
    if (value === "none") return 0, _decomposeJs.identity;
    if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
    cssNode.style.transform = value;
    value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
    cssRoot.removeChild(cssNode);
    value = value.slice(7, -1).split(",");
    return (0, _decomposeJsDefault.default)(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}
function parseSvg(value) {
    if (value == null) return 0, _decomposeJs.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return 0, _decomposeJs.identity;
    value = value.matrix;
    return (0, _decomposeJsDefault.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"./decompose.js":"fFCw3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFCw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>function(a, b, c, d, e, f) {
        var scaleX, scaleY, skewX;
        if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
        if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
        if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
        if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
        return {
            translateX: e,
            translateY: f,
            rotate: Math.atan2(b, a) * degrees,
            skewX: Math.atan(skewX) * degrees,
            scaleX: scaleX,
            scaleY: scaleY
        };
    });
var degrees = 180 / Math.PI;
var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYZqs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
parcelHelpers.export(exports, "default", ()=>function(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000;
        return i;
    });
var rho = Math.SQRT2, rho2 = 2, rho4 = 4, epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gpCEl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslLong", ()=>hslLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hsl)(start)).h, (end = (0, _d3Color.hsl)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hsl((0, _colorJs.hue));
var hslLong = hsl((0, _colorJsDefault.default));

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59sZQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lab);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function lab(start, end) {
    var l = (0, _colorJsDefault.default)((start = (0, _d3Color.lab)(start)).l, (end = (0, _d3Color.lab)(end)).l), a = (0, _colorJsDefault.default)(start.a, end.a), b = (0, _colorJsDefault.default)(start.b, end.b), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8D5sR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hclLong", ()=>hclLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _d3Color.hcl)(start)).h, (end = (0, _d3Color.hcl)(end)).h), c = (0, _colorJsDefault.default)(start.c, end.c), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
exports.default = hcl((0, _colorJs.hue));
var hclLong = hcl((0, _colorJsDefault.default));

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fTpuZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubehelixLong", ()=>cubehelixLong);
var _d3Color = require("d3-color");
var _colorJs = require("./color.js");
var _colorJsDefault = parcelHelpers.interopDefault(_colorJs);
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _d3Color.cubehelix)(start)).h, (end = (0, _d3Color.cubehelix)(end)).h), s = (0, _colorJsDefault.default)(start.s, end.s), l = (0, _colorJsDefault.default)(start.l, end.l), opacity = (0, _colorJsDefault.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
exports.default = cubehelix((0, _colorJs.hue));
var cubehelixLong = cubehelix((0, _colorJsDefault.default));

},{"d3-color":"jv6Pr","./color.js":"aoWOo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nOq6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>piecewise);
function piecewise(interpolate, values) {
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHRVh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(interpolator, n) {
        var samples = new Array(n);
        for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
        return samples;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aj1c5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transition", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "active", ()=>(0, _activeJsDefault.default));
parcelHelpers.export(exports, "interrupt", ()=>(0, _interruptJsDefault.default));
var _indexJs = require("./selection/index.js");
var _indexJs1 = require("./transition/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _activeJs = require("./active.js");
var _activeJsDefault = parcelHelpers.interopDefault(_activeJs);
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"./selection/index.js":"kZ3M7","./transition/index.js":"5tqW2","./active.js":"1yv3Z","./interrupt.js":"3IFg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZ3M7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _d3Selection = require("d3-selection");
var _interruptJs = require("./interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
(0, _d3Selection.selection).prototype.interrupt = (0, _interruptJsDefault.default);
(0, _d3Selection.selection).prototype.transition = (0, _transitionJsDefault.default);

},{"d3-selection":"9PvvP","./interrupt.js":"coKKt","./transition.js":"a9oBa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coKKt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        return this.each(function() {
            (0, _interruptJsDefault.default)(this, name);
        });
    });
var _interruptJs = require("../interrupt.js");
var _interruptJsDefault = parcelHelpers.interopDefault(_interruptJs);

},{"../interrupt.js":"3IFg8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3IFg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, active, empty = true, i;
        if (!schedules) return;
        name = name == null ? null : name + "";
        for(i in schedules){
            if ((schedule = schedules[i]).name !== name) {
                empty = false;
                continue;
            }
            active = schedule.state > (0, _scheduleJs.STARTING) && schedule.state < (0, _scheduleJs.ENDING);
            schedule.state = (0, _scheduleJs.ENDED);
            schedule.timer.stop();
            schedule.on.call(active ? "interrupt" : "cancel", node, node.__data__, schedule.index, schedule.group);
            delete schedules[i];
        }
        if (empty) delete node.__transition;
    });
var _scheduleJs = require("./transition/schedule.js");

},{"./transition/schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2KS27":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CREATED", ()=>CREATED);
parcelHelpers.export(exports, "SCHEDULED", ()=>SCHEDULED);
parcelHelpers.export(exports, "STARTING", ()=>STARTING);
parcelHelpers.export(exports, "STARTED", ()=>STARTED);
parcelHelpers.export(exports, "RUNNING", ()=>RUNNING);
parcelHelpers.export(exports, "ENDING", ()=>ENDING);
parcelHelpers.export(exports, "ENDED", ()=>ENDED);
parcelHelpers.export(exports, "default", ()=>function(node, name, id, index, group, timing) {
        var schedules = node.__transition;
        if (!schedules) node.__transition = {};
        else if (id in schedules) return;
        create(node, id, {
            name: name,
            index: index,
            group: group,
            on: emptyOn,
            tween: emptyTween,
            time: timing.time,
            delay: timing.delay,
            duration: timing.duration,
            ease: timing.ease,
            timer: null,
            state: CREATED
        });
    });
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "set", ()=>set);
parcelHelpers.export(exports, "get", ()=>get);
var _d3Dispatch = require("d3-dispatch");
var _d3Timer = require("d3-timer");
var emptyOn = (0, _d3Dispatch.dispatch)("start", "end", "cancel", "interrupt");
var emptyTween = [];
var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;
function init(node, id) {
    var schedule = get(node, id);
    if (schedule.state > CREATED) throw new Error("too late; already scheduled");
    return schedule;
}
function set(node, id) {
    var schedule = get(node, id);
    if (schedule.state > STARTED) throw new Error("too late; already running");
    return schedule;
}
function get(node, id) {
    var schedule = node.__transition;
    if (!schedule || !(schedule = schedule[id])) throw new Error("transition not found");
    return schedule;
}
function create(node, id, self) {
    var schedules = node.__transition, tween;
    // Initialize the self timer when the transition is created.
    // Note the actual delay is not known until the first callback!
    schedules[id] = self;
    self.timer = (0, _d3Timer.timer)(schedule, 0, self.time);
    function schedule(elapsed) {
        self.state = SCHEDULED;
        self.timer.restart(start, self.delay, self.time);
        // If the elapsed delay is less than our first sleep, start immediately.
        if (self.delay <= elapsed) start(elapsed - self.delay);
    }
    function start(elapsed) {
        var i, j, n, o;
        // If the state is not SCHEDULED, then we previously errored on start.
        if (self.state !== SCHEDULED) return stop();
        for(i in schedules){
            o = schedules[i];
            if (o.name !== self.name) continue;
            // While this element already has a starting transition during this frame,
            // defer starting an interrupting transition until that transition has a
            // chance to tick (and possibly end); see d3/d3-transition#54!
            if (o.state === STARTED) return (0, _d3Timer.timeout)(start);
            // Interrupt the active transition, if any.
            if (o.state === RUNNING) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("interrupt", node, node.__data__, o.index, o.group);
                delete schedules[i];
            } else if (+i < id) {
                o.state = ENDED;
                o.timer.stop();
                o.on.call("cancel", node, node.__data__, o.index, o.group);
                delete schedules[i];
            }
        }
        // Defer the first tick to end of the current frame; see d3/d3#1576.
        // Note the transition may be canceled after start and before the first tick!
        // Note this must be scheduled before the start event; see d3/d3-transition#16!
        // Assuming this is successful, subsequent callbacks go straight to tick.
        (0, _d3Timer.timeout)(function() {
            if (self.state === STARTED) {
                self.state = RUNNING;
                self.timer.restart(tick, self.delay, self.time);
                tick(elapsed);
            }
        });
        // Dispatch the start event.
        // Note this must be done before the tween are initialized.
        self.state = STARTING;
        self.on.call("start", node, node.__data__, self.index, self.group);
        if (self.state !== STARTING) return; // interrupted
        self.state = STARTED;
        // Initialize the tween, deleting null tween.
        tween = new Array(n = self.tween.length);
        for(i = 0, j = -1; i < n; ++i)if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) tween[++j] = o;
        tween.length = j + 1;
    }
    function tick(elapsed) {
        var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1), i = -1, n = tween.length;
        while(++i < n)tween[i].call(node, t);
        // Dispatch the end event.
        if (self.state === ENDING) {
            self.on.call("end", node, node.__data__, self.index, self.group);
            stop();
        }
    }
    function stop() {
        self.state = ENDED;
        self.timer.stop();
        delete schedules[id];
        for(var i in schedules)return; // eslint-disable-line no-unused-vars
        delete node.__transition;
    }
}

},{"d3-dispatch":"2VwUr","d3-timer":"lpgSt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpgSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>(0, _timerJs.now));
parcelHelpers.export(exports, "timer", ()=>(0, _timerJs.timer));
parcelHelpers.export(exports, "timerFlush", ()=>(0, _timerJs.timerFlush));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeoutJsDefault.default));
parcelHelpers.export(exports, "interval", ()=>(0, _intervalJsDefault.default));
var _timerJs = require("./timer.js");
var _timeoutJs = require("./timeout.js");
var _timeoutJsDefault = parcelHelpers.interopDefault(_timeoutJs);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);

},{"./timer.js":"atLFA","./timeout.js":"h5YmT","./interval.js":"MBzPK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"atLFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "timer", ()=>timer);
parcelHelpers.export(exports, "timerFlush", ()=>timerFlush);
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1000, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
    clockNow = 0;
}
function Timer() {
    this._call = this._time = this._next = null;
}
Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && taskTail !== this) {
            if (taskTail) taskTail._next = this;
            else taskHead = this;
            taskTail = this;
        }
        this._call = callback;
        this._time = time;
        sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            sleep();
        }
    }
};
function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
}
function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while(t){
        if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
        t = t._next;
    }
    --frame;
}
function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
        timerFlush();
    } finally{
        frame = 0;
        nap();
        clockNow = 0;
    }
}
function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}
function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
    taskTail = t0;
    sleep(time);
}
function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
        if (interval) interval = clearInterval(interval);
    } else {
        if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
        frame = 1, setFrame(wake);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h5YmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer);
        delay = delay == null ? 0 : +delay;
        t.restart(function(elapsed) {
            t.stop();
            callback(elapsed + delay);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"atLFA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"MBzPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback, delay, time) {
        var t = new (0, _timerJs.Timer), total = delay;
        if (delay == null) return t.restart(callback, delay, time), t;
        delay = +delay, time = time == null ? (0, _timerJs.now)() : +time;
        t.restart(function tick(elapsed) {
            elapsed += total;
            t.restart(tick, total += delay, time);
            callback(elapsed);
        }, delay, time);
        return t;
    });
var _timerJs = require("./timer.js");

},{"./timer.js":"atLFA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9oBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name) {
        var id, timing;
        if (name instanceof (0, _indexJs.Transition)) id = name._id, name = name._name;
        else id = (0, _indexJs.newId)(), (timing = defaultTiming).time = (0, _d3Timer.now)(), name = name == null ? null : name + "";
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) (0, _scheduleJsDefault.default)(node, name, id, i, group, timing || inherit(node, id));
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id);
    });
var _indexJs = require("../transition/index.js");
var _scheduleJs = require("../transition/schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);
var _d3Ease = require("d3-ease");
var _d3Timer = require("d3-timer");
var defaultTiming = {
    time: null,
    delay: 0,
    duration: 250,
    ease: (0, _d3Ease.easeCubicInOut)
};
function inherit(node, id) {
    var timing;
    while(!(timing = node.__transition) || !(timing = timing[id])){
        if (!(node = node.parentNode)) return defaultTiming.time = (0, _d3Timer.now)(), defaultTiming;
    }
    return timing;
}

},{"../transition/index.js":"5tqW2","../transition/schedule.js":"2KS27","d3-ease":"djx4i","d3-timer":"lpgSt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tqW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "default", ()=>transition);
parcelHelpers.export(exports, "newId", ()=>newId);
var _d3Selection = require("d3-selection");
var _attrJs = require("./attr.js");
var _attrJsDefault = parcelHelpers.interopDefault(_attrJs);
var _attrTweenJs = require("./attrTween.js");
var _attrTweenJsDefault = parcelHelpers.interopDefault(_attrTweenJs);
var _delayJs = require("./delay.js");
var _delayJsDefault = parcelHelpers.interopDefault(_delayJs);
var _durationJs = require("./duration.js");
var _durationJsDefault = parcelHelpers.interopDefault(_durationJs);
var _easeJs = require("./ease.js");
var _easeJsDefault = parcelHelpers.interopDefault(_easeJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _onJs = require("./on.js");
var _onJsDefault = parcelHelpers.interopDefault(_onJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _selectAllJs = require("./selectAll.js");
var _selectAllJsDefault = parcelHelpers.interopDefault(_selectAllJs);
var _selectionJs = require("./selection.js");
var _selectionJsDefault = parcelHelpers.interopDefault(_selectionJs);
var _styleJs = require("./style.js");
var _styleJsDefault = parcelHelpers.interopDefault(_styleJs);
var _styleTweenJs = require("./styleTween.js");
var _styleTweenJsDefault = parcelHelpers.interopDefault(_styleTweenJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _textTweenJs = require("./textTween.js");
var _textTweenJsDefault = parcelHelpers.interopDefault(_textTweenJs);
var _transitionJs = require("./transition.js");
var _transitionJsDefault = parcelHelpers.interopDefault(_transitionJs);
var _tweenJs = require("./tween.js");
var _tweenJsDefault = parcelHelpers.interopDefault(_tweenJs);
var _endJs = require("./end.js");
var _endJsDefault = parcelHelpers.interopDefault(_endJs);
var id = 0;
function Transition(groups, parents, name, id) {
    this._groups = groups;
    this._parents = parents;
    this._name = name;
    this._id = id;
}
function transition(name) {
    return (0, _d3Selection.selection)().transition(name);
}
function newId() {
    return ++id;
}
var selection_prototype = (0, _d3Selection.selection).prototype;
Transition.prototype = transition.prototype = {
    constructor: Transition,
    select: (0, _selectJsDefault.default),
    selectAll: (0, _selectAllJsDefault.default),
    filter: (0, _filterJsDefault.default),
    merge: (0, _mergeJsDefault.default),
    selection: (0, _selectionJsDefault.default),
    transition: (0, _transitionJsDefault.default),
    call: selection_prototype.call,
    nodes: selection_prototype.nodes,
    node: selection_prototype.node,
    size: selection_prototype.size,
    empty: selection_prototype.empty,
    each: selection_prototype.each,
    on: (0, _onJsDefault.default),
    attr: (0, _attrJsDefault.default),
    attrTween: (0, _attrTweenJsDefault.default),
    style: (0, _styleJsDefault.default),
    styleTween: (0, _styleTweenJsDefault.default),
    text: (0, _textJsDefault.default),
    textTween: (0, _textTweenJsDefault.default),
    remove: (0, _removeJsDefault.default),
    tween: (0, _tweenJsDefault.default),
    delay: (0, _delayJsDefault.default),
    duration: (0, _durationJsDefault.default),
    ease: (0, _easeJsDefault.default),
    end: (0, _endJsDefault.default)
};

},{"d3-selection":"9PvvP","./attr.js":"ettza","./attrTween.js":"fKBNf","./delay.js":"3uMbw","./duration.js":"k5T03","./ease.js":"lDozG","./filter.js":"1mjyo","./merge.js":"lnzih","./on.js":"gvIIF","./remove.js":"1KRzH","./select.js":"5uH34","./selectAll.js":"ZI7Ih","./selection.js":"1VhQX","./style.js":"gijRh","./styleTween.js":"bC37S","./text.js":"6eNBo","./textTween.js":"cwqtH","./transition.js":"htXRp","./tween.js":"fPCiA","./end.js":"a4mEw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ettza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var fullname = (0, _d3Selection.namespace)(name), i = fullname === "transform" ? (0, _d3Interpolate.interpolateTransformSvg) : (0, _interpolateJsDefault.default);
        return this.attrTween(name, typeof value === "function" ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, (0, _tweenJs.tweenValue)(this, "attr." + name, value)) : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname) : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function attrRemove(name) {
    return function() {
        this.removeAttribute(name);
    };
}
function attrRemoveNS(fullname) {
    return function() {
        this.removeAttributeNS(fullname.space, fullname.local);
    };
}
function attrConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttribute(name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrConstantNS(fullname, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = this.getAttributeNS(fullname.space, fullname.local);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function attrFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttribute(name);
        string0 = this.getAttribute(name);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function attrFunctionNS(fullname, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0, value1 = value(this), string1;
        if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
        string0 = this.getAttributeNS(fullname.space, fullname.local);
        string1 = value1 + "";
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}

},{"d3-interpolate":"5gJW0","d3-selection":"9PvvP","./tween.js":"fPCiA","./interpolate.js":"jmTgx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fPCiA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var id = this._id;
        name += "";
        if (arguments.length < 2) {
            var tween = (0, _scheduleJs.get)(this.node(), id).tween;
            for(var i = 0, n = tween.length, t; i < n; ++i){
                if ((t = tween[i]).name === name) return t.value;
            }
            return null;
        }
        return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
    });
parcelHelpers.export(exports, "tweenValue", ()=>tweenValue);
var _scheduleJs = require("./schedule.js");
function tweenRemove(id, name) {
    var tween0, tween1;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = tween0 = tween;
            for(var i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1 = tween1.slice();
                tween1.splice(i, 1);
                break;
            }
        }
        schedule.tween = tween1;
    };
}
function tweenFunction(id, name, value) {
    var tween0, tween1;
    if (typeof value !== "function") throw new Error;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), tween = schedule.tween;
        // If this node shared tween with the previous node,
        // just assign the updated shared tween and we’re done!
        // Otherwise, copy-on-write.
        if (tween !== tween0) {
            tween1 = (tween0 = tween).slice();
            for(var t = {
                name: name,
                value: value
            }, i = 0, n = tween1.length; i < n; ++i)if (tween1[i].name === name) {
                tween1[i] = t;
                break;
            }
            if (i === n) tween1.push(t);
        }
        schedule.tween = tween1;
    };
}
function tweenValue(transition, name, value) {
    var id = transition._id;
    transition.each(function() {
        var schedule = (0, _scheduleJs.set)(this, id);
        (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
    });
    return function(node) {
        return (0, _scheduleJs.get)(node, id).value[name];
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmTgx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var c;
        return (typeof b === "number" ? (0, _d3Interpolate.interpolateNumber) : b instanceof (0, _d3Color.color) ? (0, _d3Interpolate.interpolateRgb) : (c = (0, _d3Color.color)(b)) ? (b = c, _d3Interpolate.interpolateRgb) : (0, _d3Interpolate.interpolateString))(a, b);
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");

},{"d3-color":"jv6Pr","d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKBNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value) {
        var key = "attr." + name;
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        var fullname = (0, _d3Selection.namespace)(name);
        return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
    });
var _d3Selection = require("d3-selection");
function attrInterpolate(name, i) {
    return function(t) {
        this.setAttribute(name, i.call(this, t));
    };
}
function attrInterpolateNS(fullname, i) {
    return function(t) {
        this.setAttributeNS(fullname.space, fullname.local, i.call(this, t));
    };
}
function attrTweenNS(fullname, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolateNS(fullname, i);
        return t0;
    }
    tween._value = value;
    return tween;
}
function attrTween(name, value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && attrInterpolate(name, i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3uMbw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? delayFunction : delayConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).delay;
    });
var _scheduleJs = require("./schedule.js");
function delayFunction(id, value) {
    return function() {
        (0, _scheduleJs.init)(this, id).delay = +value.apply(this, arguments);
    };
}
function delayConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.init)(this, id).delay = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k5T03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each((typeof value === "function" ? durationFunction : durationConstant)(id, value)) : (0, _scheduleJs.get)(this.node(), id).duration;
    });
var _scheduleJs = require("./schedule.js");
function durationFunction(id, value) {
    return function() {
        (0, _scheduleJs.set)(this, id).duration = +value.apply(this, arguments);
    };
}
function durationConstant(id, value) {
    return value = +value, function() {
        (0, _scheduleJs.set)(this, id).duration = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDozG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var id = this._id;
        return arguments.length ? this.each(easeConstant(id, value)) : (0, _scheduleJs.get)(this.node(), id).ease;
    });
var _scheduleJs = require("./schedule.js");
function easeConstant(id, value) {
    if (typeof value !== "function") throw new Error;
    return function() {
        (0, _scheduleJs.set)(this, id).ease = value;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mjyo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(match) {
        if (typeof match !== "function") match = (0, _d3Selection.matcher)(match);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i)if ((node = group[i]) && match.call(node, node.__data__, i, group)) subgroup.push(node);
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, this._name, this._id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");

},{"d3-selection":"9PvvP","./index.js":"5tqW2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lnzih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(transition) {
        if (transition._id !== this._id) throw new Error;
        for(var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j){
            for(var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i)if (node = group0[i] || group1[i]) merge[i] = node;
        }
        for(; j < m0; ++j)merges[j] = groups0[j];
        return new (0, _indexJs.Transition)(merges, this._parents, this._name, this._id);
    });
var _indexJs = require("./index.js");

},{"./index.js":"5tqW2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gvIIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, listener) {
        var id = this._id;
        return arguments.length < 2 ? (0, _scheduleJs.get)(this.node(), id).on.on(name) : this.each(onFunction(id, name, listener));
    });
var _scheduleJs = require("./schedule.js");
function start(name) {
    return (name + "").trim().split(/^|\s+/).every(function(t) {
        var i = t.indexOf(".");
        if (i >= 0) t = t.slice(0, i);
        return !t || t === "start";
    });
}
function onFunction(id, name, listener) {
    var on0, on1, sit = start(name) ? (0, _scheduleJs.init) : (0, _scheduleJs.set);
    return function() {
        var schedule = sit(this, id), on = schedule.on;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
        schedule.on = on1;
    };
}

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1KRzH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.on("end.remove", removeFunction(this._id));
    });
function removeFunction(id) {
    return function() {
        var parent = this.parentNode;
        for(var i in this.__transition)if (+i !== id) return;
        if (parent) parent.removeChild(this);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uH34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selector)(select);
        for(var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i)if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                subgroup[i] = subnode;
                (0, _scheduleJsDefault.default)(subgroup[i], name, id, i, subgroup, (0, _scheduleJs.get)(node, id));
            }
        }
        return new (0, _indexJs.Transition)(subgroups, this._parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"9PvvP","./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ZI7Ih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(select) {
        var name = this._name, id = this._id;
        if (typeof select !== "function") select = (0, _d3Selection.selectorAll)(select);
        for(var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                for(var children = select.call(node, node.__data__, i, group), child, inherit = (0, _scheduleJs.get)(node, id), k = 0, l = children.length; k < l; ++k)if (child = children[k]) (0, _scheduleJsDefault.default)(child, name, id, k, children, inherit);
                subgroups.push(children);
                parents.push(node);
            }
        }
        return new (0, _indexJs.Transition)(subgroups, parents, name, id);
    });
var _d3Selection = require("d3-selection");
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"d3-selection":"9PvvP","./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1VhQX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Selection(this._groups, this._parents);
    });
var _d3Selection = require("d3-selection");
var Selection = (0, _d3Selection.selection).prototype.constructor;

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gijRh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var i = (name += "") === "transform" ? (0, _d3Interpolate.interpolateTransformCss) : (0, _interpolateJsDefault.default);
        return value == null ? this.styleTween(name, styleNull(name, i)).on("end.style." + name, styleRemove(name)) : typeof value === "function" ? this.styleTween(name, styleFunction(name, i, (0, _tweenJs.tweenValue)(this, "style." + name, value))).each(styleMaybeRemove(this._id, name)) : this.styleTween(name, styleConstant(name, i, value), priority).on("end.style." + name, null);
    });
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _scheduleJs = require("./schedule.js");
var _tweenJs = require("./tween.js");
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
function styleNull(name, interpolate) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), string1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : interpolate0 = interpolate(string00 = string0, string10 = string1);
    };
}
function styleRemove(name) {
    return function() {
        this.style.removeProperty(name);
    };
}
function styleConstant(name, interpolate, value1) {
    var string00, string1 = value1 + "", interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name);
        return string0 === string1 ? null : string0 === string00 ? interpolate0 : interpolate0 = interpolate(string00 = string0, value1);
    };
}
function styleFunction(name, interpolate, value) {
    var string00, string10, interpolate0;
    return function() {
        var string0 = (0, _d3Selection.style)(this, name), value1 = value(this), string1 = value1 + "";
        if (value1 == null) string1 = value1 = (this.style.removeProperty(name), (0, _d3Selection.style)(this, name));
        return string0 === string1 ? null : string0 === string00 && string1 === string10 ? interpolate0 : (string10 = string1, interpolate0 = interpolate(string00 = string0, value1));
    };
}
function styleMaybeRemove(id, name) {
    var on0, on1, listener0, key = "style." + name, event = "end." + key, remove;
    return function() {
        var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on, listener = schedule.value[key] == null ? remove || (remove = styleRemove(name)) : undefined;
        // If this node shared a dispatch with the previous node,
        // just assign the updated shared dispatch and we’re done!
        // Otherwise, copy-on-write.
        if (on !== on0 || listener0 !== listener) (on1 = (on0 = on).copy()).on(event, listener0 = listener);
        schedule.on = on1;
    };
}

},{"d3-interpolate":"5gJW0","d3-selection":"9PvvP","./schedule.js":"2KS27","./tween.js":"fPCiA","./interpolate.js":"jmTgx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bC37S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(name, value, priority) {
        var key = "style." + (name += "");
        if (arguments.length < 2) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
    });
function styleInterpolate(name, i, priority) {
    return function(t) {
        this.style.setProperty(name, i.call(this, t), priority);
    };
}
function styleTween(name, value, priority) {
    var t, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t = (i0 = i) && styleInterpolate(name, i, priority);
        return t;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6eNBo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.tween("text", typeof value === "function" ? textFunction((0, _tweenJs.tweenValue)(this, "text", value)) : textConstant(value == null ? "" : value + ""));
    });
var _tweenJs = require("./tween.js");
function textConstant(value) {
    return function() {
        this.textContent = value;
    };
}
function textFunction(value) {
    return function() {
        var value1 = value(this);
        this.textContent = value1 == null ? "" : value1;
    };
}

},{"./tween.js":"fPCiA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cwqtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        var key = "text";
        if (arguments.length < 1) return (key = this.tween(key)) && key._value;
        if (value == null) return this.tween(key, null);
        if (typeof value !== "function") throw new Error;
        return this.tween(key, textTween(value));
    });
function textInterpolate(i) {
    return function(t) {
        this.textContent = i.call(this, t);
    };
}
function textTween(value) {
    var t0, i0;
    function tween() {
        var i = value.apply(this, arguments);
        if (i !== i0) t0 = (i0 = i) && textInterpolate(i);
        return t0;
    }
    tween._value = value;
    return tween;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htXRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var name = this._name, id0 = this._id, id1 = (0, _indexJs.newId)();
        for(var groups = this._groups, m = groups.length, j = 0; j < m; ++j){
            for(var group = groups[j], n = group.length, node, i = 0; i < n; ++i)if (node = group[i]) {
                var inherit = (0, _scheduleJs.get)(node, id0);
                (0, _scheduleJsDefault.default)(node, name, id1, i, group, {
                    time: inherit.time + inherit.delay + inherit.duration,
                    delay: 0,
                    duration: inherit.duration,
                    ease: inherit.ease
                });
            }
        }
        return new (0, _indexJs.Transition)(groups, this._parents, name, id1);
    });
var _indexJs = require("./index.js");
var _scheduleJs = require("./schedule.js");
var _scheduleJsDefault = parcelHelpers.interopDefault(_scheduleJs);

},{"./index.js":"5tqW2","./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a4mEw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var on0, on1, that = this, id = that._id, size = that.size();
        return new Promise(function(resolve, reject) {
            var cancel = {
                value: reject
            }, end = {
                value: function() {
                    if (--size === 0) resolve();
                }
            };
            that.each(function() {
                var schedule = (0, _scheduleJs.set)(this, id), on = schedule.on;
                // If this node shared a dispatch with the previous node,
                // just assign the updated shared dispatch and we’re done!
                // Otherwise, copy-on-write.
                if (on !== on0) {
                    on1 = (on0 = on).copy();
                    on1._.cancel.push(cancel);
                    on1._.interrupt.push(cancel);
                    on1._.end.push(end);
                }
                schedule.on = on1;
            });
        });
    });
var _scheduleJs = require("./schedule.js");

},{"./schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"djx4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeLinear", ()=>(0, _linearJs.linear));
parcelHelpers.export(exports, "easeQuad", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeQuadIn", ()=>(0, _quadJs.quadIn));
parcelHelpers.export(exports, "easeQuadOut", ()=>(0, _quadJs.quadOut));
parcelHelpers.export(exports, "easeQuadInOut", ()=>(0, _quadJs.quadInOut));
parcelHelpers.export(exports, "easeCubic", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easeCubicIn", ()=>(0, _cubicJs.cubicIn));
parcelHelpers.export(exports, "easeCubicOut", ()=>(0, _cubicJs.cubicOut));
parcelHelpers.export(exports, "easeCubicInOut", ()=>(0, _cubicJs.cubicInOut));
parcelHelpers.export(exports, "easePoly", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easePolyIn", ()=>(0, _polyJs.polyIn));
parcelHelpers.export(exports, "easePolyOut", ()=>(0, _polyJs.polyOut));
parcelHelpers.export(exports, "easePolyInOut", ()=>(0, _polyJs.polyInOut));
parcelHelpers.export(exports, "easeSin", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeSinIn", ()=>(0, _sinJs.sinIn));
parcelHelpers.export(exports, "easeSinOut", ()=>(0, _sinJs.sinOut));
parcelHelpers.export(exports, "easeSinInOut", ()=>(0, _sinJs.sinInOut));
parcelHelpers.export(exports, "easeExp", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeExpIn", ()=>(0, _expJs.expIn));
parcelHelpers.export(exports, "easeExpOut", ()=>(0, _expJs.expOut));
parcelHelpers.export(exports, "easeExpInOut", ()=>(0, _expJs.expInOut));
parcelHelpers.export(exports, "easeCircle", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeCircleIn", ()=>(0, _circleJs.circleIn));
parcelHelpers.export(exports, "easeCircleOut", ()=>(0, _circleJs.circleOut));
parcelHelpers.export(exports, "easeCircleInOut", ()=>(0, _circleJs.circleInOut));
parcelHelpers.export(exports, "easeBounce", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceIn", ()=>(0, _bounceJs.bounceIn));
parcelHelpers.export(exports, "easeBounceOut", ()=>(0, _bounceJs.bounceOut));
parcelHelpers.export(exports, "easeBounceInOut", ()=>(0, _bounceJs.bounceInOut));
parcelHelpers.export(exports, "easeBack", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeBackIn", ()=>(0, _backJs.backIn));
parcelHelpers.export(exports, "easeBackOut", ()=>(0, _backJs.backOut));
parcelHelpers.export(exports, "easeBackInOut", ()=>(0, _backJs.backInOut));
parcelHelpers.export(exports, "easeElastic", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticIn", ()=>(0, _elasticJs.elasticIn));
parcelHelpers.export(exports, "easeElasticOut", ()=>(0, _elasticJs.elasticOut));
parcelHelpers.export(exports, "easeElasticInOut", ()=>(0, _elasticJs.elasticInOut));
var _linearJs = require("./linear.js");
var _quadJs = require("./quad.js");
var _cubicJs = require("./cubic.js");
var _polyJs = require("./poly.js");
var _sinJs = require("./sin.js");
var _expJs = require("./exp.js");
var _circleJs = require("./circle.js");
var _bounceJs = require("./bounce.js");
var _backJs = require("./back.js");
var _elasticJs = require("./elastic.js");

},{"./linear.js":"50jbt","./quad.js":"iWfjc","./cubic.js":"kXdds","./poly.js":"3T1Tc","./sin.js":"7HLKm","./exp.js":"dATgq","./circle.js":"kGt6T","./bounce.js":"5VFCT","./back.js":"kSI9R","./elastic.js":"9vwgb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"50jbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linear", ()=>linear);
function linear(t) {
    return +t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWfjc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadIn", ()=>quadIn);
parcelHelpers.export(exports, "quadOut", ()=>quadOut);
parcelHelpers.export(exports, "quadInOut", ()=>quadInOut);
function quadIn(t) {
    return t * t;
}
function quadOut(t) {
    return t * (2 - t);
}
function quadInOut(t) {
    return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXdds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicIn", ()=>cubicIn);
parcelHelpers.export(exports, "cubicOut", ()=>cubicOut);
parcelHelpers.export(exports, "cubicInOut", ()=>cubicInOut);
function cubicIn(t) {
    return t * t * t;
}
function cubicOut(t) {
    return --t * t * t + 1;
}
function cubicInOut(t) {
    return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3T1Tc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyIn", ()=>polyIn);
parcelHelpers.export(exports, "polyOut", ()=>polyOut);
parcelHelpers.export(exports, "polyInOut", ()=>polyInOut);
var exponent = 3;
var polyIn = function custom(e) {
    e = +e;
    function polyIn(t) {
        return Math.pow(t, e);
    }
    polyIn.exponent = custom;
    return polyIn;
}(exponent);
var polyOut = function custom(e) {
    e = +e;
    function polyOut(t) {
        return 1 - Math.pow(1 - t, e);
    }
    polyOut.exponent = custom;
    return polyOut;
}(exponent);
var polyInOut = function custom(e) {
    e = +e;
    function polyInOut(t) {
        return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
    }
    polyInOut.exponent = custom;
    return polyInOut;
}(exponent);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7HLKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sinIn", ()=>sinIn);
parcelHelpers.export(exports, "sinOut", ()=>sinOut);
parcelHelpers.export(exports, "sinInOut", ()=>sinInOut);
var pi = Math.PI, halfPi = pi / 2;
function sinIn(t) {
    return +t === 1 ? 1 : 1 - Math.cos(t * halfPi);
}
function sinOut(t) {
    return Math.sin(t * halfPi);
}
function sinInOut(t) {
    return (1 - Math.cos(pi * t)) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dATgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expIn", ()=>expIn);
parcelHelpers.export(exports, "expOut", ()=>expOut);
parcelHelpers.export(exports, "expInOut", ()=>expInOut);
var _mathJs = require("./math.js");
function expIn(t) {
    return (0, _mathJs.tpmt)(1 - +t);
}
function expOut(t) {
    return 1 - (0, _mathJs.tpmt)(t);
}
function expInOut(t) {
    return ((t *= 2) <= 1 ? (0, _mathJs.tpmt)(1 - t) : 2 - (0, _mathJs.tpmt)(t - 1)) / 2;
}

},{"./math.js":"3aorF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3aorF":[function(require,module,exports,__globalThis) {
// tpmt is two power minus ten times t scaled to [0,1]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tpmt", ()=>tpmt);
function tpmt(x) {
    return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGt6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circleIn", ()=>circleIn);
parcelHelpers.export(exports, "circleOut", ()=>circleOut);
parcelHelpers.export(exports, "circleInOut", ()=>circleInOut);
function circleIn(t) {
    return 1 - Math.sqrt(1 - t * t);
}
function circleOut(t) {
    return Math.sqrt(1 - --t * t);
}
function circleInOut(t) {
    return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5VFCT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bounceIn", ()=>bounceIn);
parcelHelpers.export(exports, "bounceOut", ()=>bounceOut);
parcelHelpers.export(exports, "bounceInOut", ()=>bounceInOut);
var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
function bounceIn(t) {
    return 1 - bounceOut(1 - t);
}
function bounceOut(t) {
    return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}
function bounceInOut(t) {
    return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kSI9R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", ()=>backIn);
parcelHelpers.export(exports, "backOut", ()=>backOut);
parcelHelpers.export(exports, "backInOut", ()=>backInOut);
var overshoot = 1.70158;
var backIn = function custom(s) {
    s = +s;
    function backIn(t) {
        return (t = +t) * t * (s * (t - 1) + t);
    }
    backIn.overshoot = custom;
    return backIn;
}(overshoot);
var backOut = function custom(s) {
    s = +s;
    function backOut(t) {
        return --t * t * ((t + 1) * s + t) + 1;
    }
    backOut.overshoot = custom;
    return backOut;
}(overshoot);
var backInOut = function custom(s) {
    s = +s;
    function backInOut(t) {
        return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
    }
    backInOut.overshoot = custom;
    return backInOut;
}(overshoot);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9vwgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elasticIn", ()=>elasticIn);
parcelHelpers.export(exports, "elasticOut", ()=>elasticOut);
parcelHelpers.export(exports, "elasticInOut", ()=>elasticInOut);
var _mathJs = require("./math.js");
var tau = 2 * Math.PI, amplitude = 1, period = 0.3;
var elasticIn = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticIn(t) {
        return a * (0, _mathJs.tpmt)(- --t) * Math.sin((s - t) / p);
    }
    elasticIn.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticIn.period = function(p) {
        return custom(a, p);
    };
    return elasticIn;
}(amplitude, period);
var elasticOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticOut(t) {
        return 1 - a * (0, _mathJs.tpmt)(t = +t) * Math.sin((t + s) / p);
    }
    elasticOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticOut.period = function(p) {
        return custom(a, p);
    };
    return elasticOut;
}(amplitude, period);
var elasticInOut = function custom(a, p) {
    var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
    function elasticInOut(t) {
        return ((t = t * 2 - 1) < 0 ? a * (0, _mathJs.tpmt)(-t) * Math.sin((s - t) / p) : 2 - a * (0, _mathJs.tpmt)(t) * Math.sin((s + t) / p)) / 2;
    }
    elasticInOut.amplitude = function(a) {
        return custom(a, p * tau);
    };
    elasticInOut.period = function(p) {
        return custom(a, p);
    };
    return elasticInOut;
}(amplitude, period);

},{"./math.js":"3aorF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1yv3Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, name) {
        var schedules = node.__transition, schedule, i;
        if (schedules) {
            name = name == null ? null : name + "";
            for(i in schedules){
                if ((schedule = schedules[i]).state > (0, _scheduleJs.SCHEDULED) && schedule.name === name) return new (0, _indexJs.Transition)([
                    [
                        node
                    ]
                ], root, name, +i);
            }
        }
        return null;
    });
var _indexJs = require("./transition/index.js");
var _scheduleJs = require("./transition/schedule.js");
var root = [
    null
];

},{"./transition/index.js":"5tqW2","./transition/schedule.js":"2KS27","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jWqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9LU8z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(target, type, selection) {
        this.target = target;
        this.type = type;
        this.selection = selection;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ofxs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function() {
        (0, _d3Selection.event).preventDefault();
        (0, _d3Selection.event).stopImmediatePropagation();
    });
var _d3Selection = require("d3-selection");
function nopropagation() {
    (0, _d3Selection.event).stopImmediatePropagation();
}

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4B9KG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chord", ()=>(0, _chordDefault.default));
parcelHelpers.export(exports, "ribbon", ()=>(0, _ribbonDefault.default));
var _chord = require("./chord");
var _chordDefault = parcelHelpers.interopDefault(_chord);
var _ribbon = require("./ribbon");
var _ribbonDefault = parcelHelpers.interopDefault(_ribbon);

},{"./chord":"jN3jv","./ribbon":"9EMll","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jN3jv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
        function chord(matrix) {
            var n = matrix.length, groupSums = [], groupIndex = (0, _d3Array.range)(n), subgroupIndex = [], chords = [], groups = chords.groups = new Array(n), subgroups = new Array(n * n), k, x, x0, dx, i, j;
            // Compute the sum.
            k = 0, i = -1;
            while(++i < n){
                x = 0, j = -1;
                while(++j < n)x += matrix[i][j];
                groupSums.push(x);
                subgroupIndex.push((0, _d3Array.range)(n));
                k += x;
            }
            // Sort groups…
            if (sortGroups) groupIndex.sort(function(a, b) {
                return sortGroups(groupSums[a], groupSums[b]);
            });
            // Sort subgroups…
            if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
                d.sort(function(a, b) {
                    return sortSubgroups(matrix[i][a], matrix[i][b]);
                });
            });
            // Convert the sum to scaling factor for [0, 2pi].
            // TODO Allow start and end angle to be specified?
            // TODO Allow padding to be specified as percentage?
            k = (0, _math.max)(0, (0, _math.tau) - padAngle * n) / k;
            dx = k ? padAngle : (0, _math.tau) / n;
            // Compute the start and end angle for each group and subgroup.
            // Note: Opera has a bug reordering object literal properties!
            x = 0, i = -1;
            while(++i < n){
                x0 = x, j = -1;
                while(++j < n){
                    var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                    subgroups[dj * n + di] = {
                        index: di,
                        subindex: dj,
                        startAngle: a0,
                        endAngle: a1,
                        value: v
                    };
                }
                groups[di] = {
                    index: di,
                    startAngle: x0,
                    endAngle: x,
                    value: groupSums[di]
                };
                x += dx;
            }
            // Generate chords for each (non-empty) subgroup-subgroup link.
            i = -1;
            while(++i < n){
                j = i - 1;
                while(++j < n){
                    var source = subgroups[j * n + i], target = subgroups[i * n + j];
                    if (source.value || target.value) chords.push(source.value < target.value ? {
                        source: target,
                        target: source
                    } : {
                        source: source,
                        target: target
                    });
                }
            }
            return sortChords ? chords.sort(sortChords) : chords;
        }
        chord.padAngle = function(_) {
            return arguments.length ? (padAngle = (0, _math.max)(0, _), chord) : padAngle;
        };
        chord.sortGroups = function(_) {
            return arguments.length ? (sortGroups = _, chord) : sortGroups;
        };
        chord.sortSubgroups = function(_) {
            return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
        };
        chord.sortChords = function(_) {
            return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
        };
        return chord;
    });
var _d3Array = require("d3-array");
var _math = require("./math");
function compareValue(compare) {
    return function(a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}

},{"d3-array":"aoYKF","./math":"b6B7b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6B7b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "max", ()=>max);
var cos = Math.cos;
var sin = Math.sin;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = pi * 2;
var max = Math.max;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9EMll":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var source = defaultSource, target = defaultTarget, radius = defaultRadius, startAngle = defaultStartAngle, endAngle = defaultEndAngle, context = null;
        function ribbon() {
            var buffer, argv = (0, _array.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv), sr = +radius.apply(this, (argv[0] = s, argv)), sa0 = startAngle.apply(this, argv) - (0, _math.halfPi), sa1 = endAngle.apply(this, argv) - (0, _math.halfPi), sx0 = sr * (0, _math.cos)(sa0), sy0 = sr * (0, _math.sin)(sa0), tr = +radius.apply(this, (argv[0] = t, argv)), ta0 = startAngle.apply(this, argv) - (0, _math.halfPi), ta1 = endAngle.apply(this, argv) - (0, _math.halfPi);
            if (!context) context = buffer = (0, _d3Path.path)();
            context.moveTo(sx0, sy0);
            context.arc(0, 0, sr, sa0, sa1);
            if (sa0 !== ta0 || sa1 !== ta1) {
                context.quadraticCurveTo(0, 0, tr * (0, _math.cos)(ta0), tr * (0, _math.sin)(ta0));
                context.arc(0, 0, tr, ta0, ta1);
            }
            context.quadraticCurveTo(0, 0, sx0, sy0);
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        ribbon.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), ribbon) : radius;
        };
        ribbon.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), ribbon) : startAngle;
        };
        ribbon.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), ribbon) : endAngle;
        };
        ribbon.source = function(_) {
            return arguments.length ? (source = _, ribbon) : source;
        };
        ribbon.target = function(_) {
            return arguments.length ? (target = _, ribbon) : target;
        };
        ribbon.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, ribbon) : context;
        };
        return ribbon;
    });
var _array = require("./array");
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _math = require("./math");
var _d3Path = require("d3-path");
function defaultSource(d) {
    return d.source;
}
function defaultTarget(d) {
    return d.target;
}
function defaultRadius(d) {
    return d.radius;
}
function defaultStartAngle(d) {
    return d.startAngle;
}
function defaultEndAngle(d) {
    return d.endAngle;
}

},{"./array":"eGSaf","./constant":"1Nhsa","./math":"b6B7b","d3-path":"a7nC8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGSaf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Nhsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a7nC8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "path", ()=>(0, _pathJsDefault.default));
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);

},{"./path.js":"lMfok","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMfok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path;
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
exports.default = path;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1YdX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nest", ()=>(0, _nestDefault.default));
parcelHelpers.export(exports, "set", ()=>(0, _setDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapDefault.default));
parcelHelpers.export(exports, "keys", ()=>(0, _keysDefault.default));
parcelHelpers.export(exports, "values", ()=>(0, _valuesDefault.default));
parcelHelpers.export(exports, "entries", ()=>(0, _entriesDefault.default));
var _nest = require("./nest");
var _nestDefault = parcelHelpers.interopDefault(_nest);
var _set = require("./set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
var _keys = require("./keys");
var _keysDefault = parcelHelpers.interopDefault(_keys);
var _values = require("./values");
var _valuesDefault = parcelHelpers.interopDefault(_values);
var _entries = require("./entries");
var _entriesDefault = parcelHelpers.interopDefault(_entries);

},{"./nest":"dgeF0","./set":"eNOYB","./map":"6QDd3","./keys":"htogy","./values":"39wNR","./entries":"2gsw1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dgeF0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = [], sortKeys = [], sortValues, rollup, nest;
        function apply(array, depth, createResult, setResult) {
            if (depth >= keys.length) {
                if (sortValues != null) array.sort(sortValues);
                return rollup != null ? rollup(array) : array;
            }
            var i = -1, n = array.length, key = keys[depth++], keyValue, value, valuesByKey = (0, _mapDefault.default)(), values, result = createResult();
            while(++i < n)if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) values.push(value);
            else valuesByKey.set(keyValue, [
                value
            ]);
            valuesByKey.each(function(values, key) {
                setResult(result, key, apply(values, depth, createResult, setResult));
            });
            return result;
        }
        function entries(map, depth) {
            if (++depth > keys.length) return map;
            var array, sortKey = sortKeys[depth - 1];
            if (rollup != null && depth >= keys.length) array = map.entries();
            else array = [], map.each(function(v, k) {
                array.push({
                    key: k,
                    values: entries(v, depth)
                });
            });
            return sortKey != null ? array.sort(function(a, b) {
                return sortKey(a.key, b.key);
            }) : array;
        }
        return nest = {
            object: function(array) {
                return apply(array, 0, createObject, setObject);
            },
            map: function(array) {
                return apply(array, 0, createMap, setMap);
            },
            entries: function(array) {
                return entries(apply(array, 0, createMap, setMap), 0);
            },
            key: function(d) {
                keys.push(d);
                return nest;
            },
            sortKeys: function(order) {
                sortKeys[keys.length - 1] = order;
                return nest;
            },
            sortValues: function(order) {
                sortValues = order;
                return nest;
            },
            rollup: function(f) {
                rollup = f;
                return nest;
            }
        };
    });
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
function createObject() {
    return {};
}
function setObject(object, key, value) {
    object[key] = value;
}
function createMap() {
    return (0, _mapDefault.default)();
}
function setMap(map, key, value) {
    map.set(key, value);
}

},{"./map":"6QDd3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6QDd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefix", ()=>prefix);
var prefix = "$";
function Map() {}
Map.prototype = map.prototype = {
    constructor: Map,
    has: function(key) {
        return prefix + key in this;
    },
    get: function(key) {
        return this[prefix + key];
    },
    set: function(key, value) {
        this[prefix + key] = value;
        return this;
    },
    remove: function(key) {
        var property = prefix + key;
        return property in this && delete this[property];
    },
    clear: function() {
        for(var property in this)if (property[0] === prefix) delete this[property];
    },
    keys: function() {
        var keys = [];
        for(var property in this)if (property[0] === prefix) keys.push(property.slice(1));
        return keys;
    },
    values: function() {
        var values = [];
        for(var property in this)if (property[0] === prefix) values.push(this[property]);
        return values;
    },
    entries: function() {
        var entries = [];
        for(var property in this)if (property[0] === prefix) entries.push({
            key: property.slice(1),
            value: this[property]
        });
        return entries;
    },
    size: function() {
        var size = 0;
        for(var property in this)if (property[0] === prefix) ++size;
        return size;
    },
    empty: function() {
        for(var property in this)if (property[0] === prefix) return false;
        return true;
    },
    each: function(f) {
        for(var property in this)if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
};
function map(object, f) {
    var map = new Map;
    // Copy constructor.
    if (object instanceof Map) object.each(function(value, key) {
        map.set(key, value);
    });
    else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (f == null) while(++i < n)map.set(i, object[i]);
        else while(++i < n)map.set(f(o = object[i], i, object), o);
    } else if (object) for(var key in object)map.set(key, object[key]);
    return map;
}
exports.default = map;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eNOYB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _map = require("./map");
var _mapDefault = parcelHelpers.interopDefault(_map);
function Set() {}
var proto = (0, _mapDefault.default).prototype;
Set.prototype = set.prototype = {
    constructor: Set,
    has: proto.has,
    add: function(value) {
        value += "";
        this[(0, _map.prefix) + value] = value;
        return this;
    },
    remove: proto.remove,
    clear: proto.clear,
    values: proto.keys,
    size: proto.size,
    empty: proto.empty,
    each: proto.each
};
function set(object, f) {
    var set = new Set;
    // Copy constructor.
    if (object instanceof Set) object.each(function(value) {
        set.add(value);
    });
    else if (object) {
        var i = -1, n = object.length;
        if (f == null) while(++i < n)set.add(object[i]);
        else while(++i < n)set.add(f(object[i], i, object));
    }
    return set;
}
exports.default = set;

},{"./map":"6QDd3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"htogy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(map) {
        var keys = [];
        for(var key in map)keys.push(key);
        return keys;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39wNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(map) {
        var values = [];
        for(var key in map)values.push(map[key]);
        return values;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2gsw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(map) {
        var entries = [];
        for(var key in map)entries.push({
            key: key,
            value: map[key]
        });
        return entries;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klb8D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contours", ()=>(0, _contoursDefault.default));
parcelHelpers.export(exports, "contourDensity", ()=>(0, _densityDefault.default));
var _contours = require("./contours");
var _contoursDefault = parcelHelpers.interopDefault(_contours);
var _density = require("./density");
var _densityDefault = parcelHelpers.interopDefault(_density);

},{"./contours":"gIi5F","./density":"jKHuJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIi5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, threshold = (0, _d3Array.thresholdSturges), smooth = smoothLinear;
        function contours(values) {
            var tz = threshold(values);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                var domain = (0, _d3Array.extent)(values), start = domain[0], stop = domain[1];
                tz = (0, _d3Array.tickStep)(start, stop, tz);
                tz = (0, _d3Array.range)(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
            } else tz = tz.slice().sort((0, _ascendingDefault.default));
            return tz.map(function(value) {
                return contour(values, value);
            });
        }
        // Accumulate, smooth contour rings, assign holes to exterior rings.
        // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
        function contour(values, value) {
            var polygons = [], holes = [];
            isorings(values, value, function(ring) {
                smooth(ring, values, value);
                if ((0, _areaDefault.default)(ring) > 0) polygons.push([
                    ring
                ]);
                else holes.push(ring);
            });
            holes.forEach(function(hole) {
                for(var i = 0, n = polygons.length, polygon; i < n; ++i)if ((0, _containsDefault.default)((polygon = polygons[i])[0], hole) !== -1) {
                    polygon.push(hole);
                    return;
                }
            });
            return {
                type: "MultiPolygon",
                value: value,
                coordinates: polygons
            };
        }
        // Marching squares with isolines stitched into rings.
        // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
        function isorings(values, value, callback) {
            var fragmentByStart = new Array, fragmentByEnd = new Array, x, y, t0, t1, t2, t3;
            // Special case for the first row (y = -1, t2 = t3 = 0).
            x = y = -1;
            t1 = values[0] >= value;
            cases[t1 << 1].forEach(stitch);
            while(++x < dx - 1){
                t0 = t1, t1 = values[x + 1] >= value;
                cases[t0 | t1 << 1].forEach(stitch);
            }
            cases[t1 << 0].forEach(stitch);
            // General case for the intermediate rows.
            while(++y < dy - 1){
                x = -1;
                t1 = values[y * dx + dx] >= value;
                t2 = values[y * dx] >= value;
                cases[t1 << 1 | t2 << 2].forEach(stitch);
                while(++x < dx - 1){
                    t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
                    t3 = t2, t2 = values[y * dx + x + 1] >= value;
                    cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
                }
                cases[t1 | t2 << 3].forEach(stitch);
            }
            // Special case for the last row (y = dy - 1, t0 = t1 = 0).
            x = -1;
            t2 = values[y * dx] >= value;
            cases[t2 << 2].forEach(stitch);
            while(++x < dx - 1){
                t3 = t2, t2 = values[y * dx + x + 1] >= value;
                cases[t2 << 2 | t3 << 3].forEach(stitch);
            }
            cases[t2 << 3].forEach(stitch);
            function stitch(line) {
                var start = [
                    line[0][0] + x,
                    line[0][1] + y
                ], end = [
                    line[1][0] + x,
                    line[1][1] + y
                ], startIndex = index(start), endIndex = index(end), f, g;
                if (f = fragmentByEnd[startIndex]) {
                    if (g = fragmentByStart[endIndex]) {
                        delete fragmentByEnd[f.end];
                        delete fragmentByStart[g.start];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[f.start] = fragmentByEnd[g.end] = {
                            start: f.start,
                            end: g.end,
                            ring: f.ring.concat(g.ring)
                        };
                    } else {
                        delete fragmentByEnd[f.end];
                        f.ring.push(end);
                        fragmentByEnd[f.end = endIndex] = f;
                    }
                } else if (f = fragmentByStart[endIndex]) {
                    if (g = fragmentByEnd[startIndex]) {
                        delete fragmentByStart[f.start];
                        delete fragmentByEnd[g.end];
                        if (f === g) {
                            f.ring.push(end);
                            callback(f.ring);
                        } else fragmentByStart[g.start] = fragmentByEnd[f.end] = {
                            start: g.start,
                            end: f.end,
                            ring: g.ring.concat(f.ring)
                        };
                    } else {
                        delete fragmentByStart[f.start];
                        f.ring.unshift(start);
                        fragmentByStart[f.start = startIndex] = f;
                    }
                } else fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {
                    start: startIndex,
                    end: endIndex,
                    ring: [
                        start,
                        end
                    ]
                };
            }
        }
        function index(point) {
            return point[0] * 2 + point[1] * (dx + 1) * 4;
        }
        function smoothLinear(ring, values, value) {
            ring.forEach(function(point) {
                var x = point[0], y = point[1], xt = x | 0, yt = y | 0, v0, v1 = values[yt * dx + xt];
                if (x > 0 && x < dx && xt === x) {
                    v0 = values[yt * dx + xt - 1];
                    point[0] = x + (value - v0) / (v1 - v0) - 0.5;
                }
                if (y > 0 && y < dy && yt === y) {
                    v0 = values[(yt - 1) * dx + xt];
                    point[1] = y + (value - v0) / (v1 - v0) - 0.5;
                }
            });
        }
        contours.contour = contour;
        contours.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
            if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, contours;
        };
        contours.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantDefault.default)((0, _array.slice).call(_)) : (0, _constantDefault.default)(_), contours) : threshold;
        };
        contours.smooth = function(_) {
            return arguments.length ? (smooth = _ ? smoothLinear : (0, _noopDefault.default), contours) : smooth === smoothLinear;
        };
        return contours;
    });
var _d3Array = require("d3-array");
var _array = require("./array");
var _ascending = require("./ascending");
var _ascendingDefault = parcelHelpers.interopDefault(_ascending);
var _area = require("./area");
var _areaDefault = parcelHelpers.interopDefault(_area);
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _contains = require("./contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _noop = require("./noop");
var _noopDefault = parcelHelpers.interopDefault(_noop);
var cases = [
    [],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                0.5,
                1.0
            ]
        ],
        [
            [
                1.0,
                0.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                0.5
            ],
            [
                0.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ],
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    [
        [
            [
                1.5,
                1.0
            ],
            [
                1.0,
                0.5
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                1.0,
                1.5
            ],
            [
                1.5,
                1.0
            ]
        ]
    ],
    [
        [
            [
                0.5,
                1.0
            ],
            [
                1.0,
                1.5
            ]
        ]
    ],
    []
];

},{"d3-array":"aoYKF","./array":"1JdE0","./ascending":"45San","./area":"9oTPo","./constant":"h2LxA","./contains":"aZqVT","./noop":"l9h0Z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1JdE0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var array = Array.prototype;
var slice = array.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45San":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return a - b;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9oTPo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring) {
        var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
        while(++i < n)area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
        return area;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h2LxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aZqVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(ring, hole) {
        var i = -1, n = hole.length, c;
        while(++i < n)if (c = ringContains(ring, hole[i])) return c;
        return 0;
    });
function ringContains(ring, point) {
    var x = point[0], y = point[1], contains = -1;
    for(var i = 0, n = ring.length, j = n - 1; i < n; j = i++){
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if (segmentContains(pi, pj, point)) return 0;
        if (yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = -contains;
    }
    return contains;
}
function segmentContains(a, b, c) {
    var i;
    return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
}
function collinear(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
}
function within(p, q, r) {
    return p <= q && q <= r || r <= q && q <= p;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l9h0Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jKHuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x = defaultX, y = defaultY, weight = defaultWeight, dx = 960, dy = 500, r = 20, k = 2, o = r * 3, n = dx + o * 2 >> k, m = dy + o * 2 >> k, threshold = (0, _constantDefault.default)(20);
        function density(data) {
            var values0 = new Float32Array(n * m), values1 = new Float32Array(n * m);
            data.forEach(function(d, i, data) {
                var xi = +x(d, i, data) + o >> k, yi = +y(d, i, data) + o >> k, wi = +weight(d, i, data);
                if (xi >= 0 && xi < n && yi >= 0 && yi < m) values0[xi + yi * n] += wi;
            });
            // TODO Optimize.
            (0, _blur.blurX)({
                width: n,
                height: m,
                data: values0
            }, {
                width: n,
                height: m,
                data: values1
            }, r >> k);
            (0, _blur.blurY)({
                width: n,
                height: m,
                data: values1
            }, {
                width: n,
                height: m,
                data: values0
            }, r >> k);
            (0, _blur.blurX)({
                width: n,
                height: m,
                data: values0
            }, {
                width: n,
                height: m,
                data: values1
            }, r >> k);
            (0, _blur.blurY)({
                width: n,
                height: m,
                data: values1
            }, {
                width: n,
                height: m,
                data: values0
            }, r >> k);
            (0, _blur.blurX)({
                width: n,
                height: m,
                data: values0
            }, {
                width: n,
                height: m,
                data: values1
            }, r >> k);
            (0, _blur.blurY)({
                width: n,
                height: m,
                data: values1
            }, {
                width: n,
                height: m,
                data: values0
            }, r >> k);
            var tz = threshold(values0);
            // Convert number of thresholds into uniform thresholds.
            if (!Array.isArray(tz)) {
                var stop = (0, _d3Array.max)(values0);
                tz = (0, _d3Array.tickStep)(0, stop, tz);
                tz = (0, _d3Array.range)(0, Math.floor(stop / tz) * tz, tz);
                tz.shift();
            }
            return (0, _contoursDefault.default)().thresholds(tz).size([
                n,
                m
            ])(values0).map(transform);
        }
        function transform(geometry) {
            geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
            geometry.coordinates.forEach(transformPolygon);
            return geometry;
        }
        function transformPolygon(coordinates) {
            coordinates.forEach(transformRing);
        }
        function transformRing(coordinates) {
            coordinates.forEach(transformPoint);
        }
        // TODO Optimize.
        function transformPoint(coordinates) {
            coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
            coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
        }
        function resize() {
            o = r * 3;
            n = dx + o * 2 >> k;
            m = dy + o * 2 >> k;
            return density;
        }
        density.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), density) : x;
        };
        density.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), density) : y;
        };
        density.weight = function(_) {
            return arguments.length ? (weight = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), density) : weight;
        };
        density.size = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
            if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
            return dx = _0, dy = _1, resize();
        };
        density.cellSize = function(_) {
            if (!arguments.length) return 1 << k;
            if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
            return k = Math.floor(Math.log(_) / Math.LN2), resize();
        };
        density.thresholds = function(_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constantDefault.default)((0, _array.slice).call(_)) : (0, _constantDefault.default)(_), density) : threshold;
        };
        density.bandwidth = function(_) {
            if (!arguments.length) return Math.sqrt(r * (r + 1));
            if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
            return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
        };
        return density;
    });
var _d3Array = require("d3-array");
var _array = require("./array");
var _blur = require("./blur");
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _contours = require("./contours");
var _contoursDefault = parcelHelpers.interopDefault(_contours);
function defaultX(d) {
    return d[0];
}
function defaultY(d) {
    return d[1];
}
function defaultWeight() {
    return 1;
}

},{"d3-array":"aoYKF","./array":"1JdE0","./blur":"8ln6A","./constant":"h2LxA","./contours":"gIi5F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ln6A":[function(require,module,exports,__globalThis) {
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blurX", ()=>blurX);
// TODO Optimize edge cases.
// TODO Optimize index calculation.
// TODO Optimize arguments.
parcelHelpers.export(exports, "blurY", ()=>blurY);
function blurX(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var j = 0; j < m; ++j)for(var i = 0, sr = 0; i < n + r; ++i){
        if (i < n) sr += source.data[i + j * n];
        if (i >= r) {
            if (i >= w) sr -= source.data[i - w + j * n];
            target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
        }
    }
}
function blurY(source, target, r) {
    var n = source.width, m = source.height, w = (r << 1) + 1;
    for(var i = 0; i < n; ++i)for(var j = 0, sr = 0; j < m + r; ++j){
        if (j < m) sr += source.data[i + j * n];
        if (j >= r) {
            if (j >= w) sr -= source.data[i + (j - w) * n];
            target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59Jxi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsvFormat", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csvParse", ()=>(0, _csvJs.csvParse));
parcelHelpers.export(exports, "csvParseRows", ()=>(0, _csvJs.csvParseRows));
parcelHelpers.export(exports, "csvFormat", ()=>(0, _csvJs.csvFormat));
parcelHelpers.export(exports, "csvFormatBody", ()=>(0, _csvJs.csvFormatBody));
parcelHelpers.export(exports, "csvFormatRows", ()=>(0, _csvJs.csvFormatRows));
parcelHelpers.export(exports, "csvFormatRow", ()=>(0, _csvJs.csvFormatRow));
parcelHelpers.export(exports, "csvFormatValue", ()=>(0, _csvJs.csvFormatValue));
parcelHelpers.export(exports, "tsvParse", ()=>(0, _tsvJs.tsvParse));
parcelHelpers.export(exports, "tsvParseRows", ()=>(0, _tsvJs.tsvParseRows));
parcelHelpers.export(exports, "tsvFormat", ()=>(0, _tsvJs.tsvFormat));
parcelHelpers.export(exports, "tsvFormatBody", ()=>(0, _tsvJs.tsvFormatBody));
parcelHelpers.export(exports, "tsvFormatRows", ()=>(0, _tsvJs.tsvFormatRows));
parcelHelpers.export(exports, "tsvFormatRow", ()=>(0, _tsvJs.tsvFormatRow));
parcelHelpers.export(exports, "tsvFormatValue", ()=>(0, _tsvJs.tsvFormatValue));
parcelHelpers.export(exports, "autoType", ()=>(0, _autoTypeJsDefault.default));
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _csvJs = require("./csv.js");
var _tsvJs = require("./tsv.js");
var _autoTypeJs = require("./autoType.js");
var _autoTypeJsDefault = parcelHelpers.interopDefault(_autoTypeJs);

},{"./dsv.js":"aG13X","./csv.js":"6akDa","./tsv.js":"hJZEe","./autoType.js":"e6fGF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aG13X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(delimiter) {
        var reFormat = new RegExp("[\"" + delimiter + "\n\r]"), DELIMITER = delimiter.charCodeAt(0);
        function parse(text, f) {
            var convert, columns, rows = parseRows(text, function(row, i) {
                if (convert) return convert(row, i - 1);
                columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
            });
            rows.columns = columns || [];
            return rows;
        }
        function parseRows(text, f) {
            var rows = [], N = text.length, I = 0, n = 0, t, eof = N <= 0, eol = false; // current token followed by EOL?
            // Strip the trailing newline.
            if (text.charCodeAt(N - 1) === NEWLINE) --N;
            if (text.charCodeAt(N - 1) === RETURN) --N;
            function token() {
                if (eof) return EOF;
                if (eol) return eol = false, EOL;
                // Unescape quotes.
                var i, j = I, c;
                if (text.charCodeAt(j) === QUOTE) {
                    while(I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
                    if ((i = I) >= N) eof = true;
                    else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    }
                    return text.slice(j + 1, i - 1).replace(/""/g, "\"");
                }
                // Find next delimiter or newline.
                while(I < N){
                    if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
                    else if (c === RETURN) {
                        eol = true;
                        if (text.charCodeAt(I) === NEWLINE) ++I;
                    } else if (c !== DELIMITER) continue;
                    return text.slice(j, i);
                }
                // Return last token before EOF.
                return eof = true, text.slice(j, N);
            }
            while((t = token()) !== EOF){
                var row = [];
                while(t !== EOL && t !== EOF)row.push(t), t = token();
                if (f && (row = f(row, n++)) == null) continue;
                rows.push(row);
            }
            return rows;
        }
        function preformatBody(rows, columns) {
            return rows.map(function(row) {
                return columns.map(function(column) {
                    return formatValue(row[column]);
                }).join(delimiter);
            });
        }
        function format(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return [
                columns.map(formatValue).join(delimiter)
            ].concat(preformatBody(rows, columns)).join("\n");
        }
        function formatBody(rows, columns) {
            if (columns == null) columns = inferColumns(rows);
            return preformatBody(rows, columns).join("\n");
        }
        function formatRows(rows) {
            return rows.map(formatRow).join("\n");
        }
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(value) {
            return value == null ? "" : value instanceof Date ? formatDate(value) : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\"" : value;
        }
        return {
            parse: parse,
            parseRows: parseRows,
            format: format,
            formatBody: formatBody,
            formatRows: formatRows,
            formatRow: formatRow,
            formatValue: formatValue
        };
    });
var EOL = {}, EOF = {}, QUOTE = 34, NEWLINE = 10, RETURN = 13;
function objectConverter(columns) {
    return new Function("d", "return {" + columns.map(function(name, i) {
        return JSON.stringify(name) + ": d[" + i + "] || \"\"";
    }).join(",") + "}");
}
function customConverter(columns, f) {
    var object = objectConverter(columns);
    return function(row, i) {
        return f(object(row), i, columns);
    };
}
// Compute unique columns in order of discovery.
function inferColumns(rows) {
    var columnSet = Object.create(null), columns = [];
    rows.forEach(function(row) {
        for(var column in row)if (!(column in columnSet)) columns.push(columnSet[column] = column);
    });
    return columns;
}
function pad(value, width) {
    var s = value + "", length = s.length;
    return length < width ? new Array(width - length + 1).join(0) + s : s;
}
function formatYear(year) {
    return year < 0 ? "-" + pad(-year, 6) : year > 9999 ? "+" + pad(year, 6) : pad(year, 4);
}
function formatDate(date) {
    var hours = date.getUTCHours(), minutes = date.getUTCMinutes(), seconds = date.getUTCSeconds(), milliseconds = date.getUTCMilliseconds();
    return isNaN(date) ? "Invalid Date" : formatYear(date.getUTCFullYear(), 4) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2) + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z" : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z" : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z" : "");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6akDa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "csvParse", ()=>csvParse);
parcelHelpers.export(exports, "csvParseRows", ()=>csvParseRows);
parcelHelpers.export(exports, "csvFormat", ()=>csvFormat);
parcelHelpers.export(exports, "csvFormatBody", ()=>csvFormatBody);
parcelHelpers.export(exports, "csvFormatRows", ()=>csvFormatRows);
parcelHelpers.export(exports, "csvFormatRow", ()=>csvFormatRow);
parcelHelpers.export(exports, "csvFormatValue", ()=>csvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var csv = (0, _dsvJsDefault.default)(",");
var csvParse = csv.parse;
var csvParseRows = csv.parseRows;
var csvFormat = csv.format;
var csvFormatBody = csv.formatBody;
var csvFormatRows = csv.formatRows;
var csvFormatRow = csv.formatRow;
var csvFormatValue = csv.formatValue;

},{"./dsv.js":"aG13X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hJZEe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tsvParse", ()=>tsvParse);
parcelHelpers.export(exports, "tsvParseRows", ()=>tsvParseRows);
parcelHelpers.export(exports, "tsvFormat", ()=>tsvFormat);
parcelHelpers.export(exports, "tsvFormatBody", ()=>tsvFormatBody);
parcelHelpers.export(exports, "tsvFormatRows", ()=>tsvFormatRows);
parcelHelpers.export(exports, "tsvFormatRow", ()=>tsvFormatRow);
parcelHelpers.export(exports, "tsvFormatValue", ()=>tsvFormatValue);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var tsv = (0, _dsvJsDefault.default)("\t");
var tsvParse = tsv.parse;
var tsvParseRows = tsv.parseRows;
var tsvFormat = tsv.format;
var tsvFormatBody = tsv.formatBody;
var tsvFormatRows = tsv.formatRows;
var tsvFormatRow = tsv.formatRow;
var tsvFormatValue = tsv.formatValue;

},{"./dsv.js":"aG13X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e6fGF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>autoType);
function autoType(object) {
    for(var key in object){
        var value = object[key].trim(), number, m;
        if (!value) value = null;
        else if (value === "true") value = true;
        else if (value === "false") value = false;
        else if (value === "NaN") value = NaN;
        else if (!isNaN(number = +value)) value = number;
        else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
            if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
            value = new Date(value);
        } else continue;
        object[key] = value;
    }
    return object;
}
// https://github.com/d3/d3-dsv/issues/45
var fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZ2qo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "blob", ()=>(0, _blobJsDefault.default));
parcelHelpers.export(exports, "buffer", ()=>(0, _bufferJsDefault.default));
parcelHelpers.export(exports, "dsv", ()=>(0, _dsvJsDefault.default));
parcelHelpers.export(exports, "csv", ()=>(0, _dsvJs.csv));
parcelHelpers.export(exports, "tsv", ()=>(0, _dsvJs.tsv));
parcelHelpers.export(exports, "image", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "json", ()=>(0, _jsonJsDefault.default));
parcelHelpers.export(exports, "text", ()=>(0, _textJsDefault.default));
parcelHelpers.export(exports, "xml", ()=>(0, _xmlJsDefault.default));
parcelHelpers.export(exports, "html", ()=>(0, _xmlJs.html));
parcelHelpers.export(exports, "svg", ()=>(0, _xmlJs.svg));
var _blobJs = require("./blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _dsvJs = require("./dsv.js");
var _dsvJsDefault = parcelHelpers.interopDefault(_dsvJs);
var _imageJs = require("./image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _jsonJs = require("./json.js");
var _jsonJsDefault = parcelHelpers.interopDefault(_jsonJs);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
var _xmlJs = require("./xml.js");
var _xmlJsDefault = parcelHelpers.interopDefault(_xmlJs);

},{"./blob.js":"52NQv","./buffer.js":"g92qc","./dsv.js":"8P16R","./image.js":"9Zx5V","./json.js":"ceAuY","./text.js":"d6voj","./xml.js":"5aqmc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"52NQv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseBlob);
    });
function responseBlob(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.blob();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g92qc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseArrayBuffer);
    });
function responseArrayBuffer(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.arrayBuffer();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P16R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dsv);
parcelHelpers.export(exports, "csv", ()=>csv);
parcelHelpers.export(exports, "tsv", ()=>tsv);
var _d3Dsv = require("d3-dsv");
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function dsvParse(parse) {
    return function(input, init, row) {
        if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
        return (0, _textJsDefault.default)(input, init).then(function(response) {
            return parse(response, row);
        });
    };
}
function dsv(delimiter, input, init, row) {
    if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
    var format = (0, _d3Dsv.dsvFormat)(delimiter);
    return (0, _textJsDefault.default)(input, init).then(function(response) {
        return format.parse(response, row);
    });
}
var csv = dsvParse((0, _d3Dsv.csvParse));
var tsv = dsvParse((0, _d3Dsv.tsvParse));

},{"d3-dsv":"59Jxi","./text.js":"d6voj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6voj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseText);
    });
function responseText(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    return response.text();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Zx5V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return new Promise(function(resolve, reject) {
            var image = new Image;
            for(var key in init)image[key] = init[key];
            image.onerror = reject;
            image.onload = function() {
                resolve(image);
            };
            image.src = input;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ceAuY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(input, init) {
        return fetch(input, init).then(responseJson);
    });
function responseJson(response) {
    if (!response.ok) throw new Error(response.status + " " + response.statusText);
    if (response.status === 204 || response.status === 205) return;
    return response.json();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5aqmc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "html", ()=>html);
parcelHelpers.export(exports, "svg", ()=>svg);
var _textJs = require("./text.js");
var _textJsDefault = parcelHelpers.interopDefault(_textJs);
function parser(type) {
    return function(input, init) {
        return (0, _textJsDefault.default)(input, init).then(function(text) {
            return (new DOMParser).parseFromString(text, type);
        });
    };
}
exports.default = parser("application/xml");
var html = parser("text/html");
var svg = parser("image/svg+xml");

},{"./text.js":"d6voj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67Mne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceCenter", ()=>(0, _centerDefault.default));
parcelHelpers.export(exports, "forceCollide", ()=>(0, _collideDefault.default));
parcelHelpers.export(exports, "forceLink", ()=>(0, _linkDefault.default));
parcelHelpers.export(exports, "forceManyBody", ()=>(0, _manyBodyDefault.default));
parcelHelpers.export(exports, "forceRadial", ()=>(0, _radialDefault.default));
parcelHelpers.export(exports, "forceSimulation", ()=>(0, _simulationDefault.default));
parcelHelpers.export(exports, "forceX", ()=>(0, _xDefault.default));
parcelHelpers.export(exports, "forceY", ()=>(0, _yDefault.default));
var _center = require("./center");
var _centerDefault = parcelHelpers.interopDefault(_center);
var _collide = require("./collide");
var _collideDefault = parcelHelpers.interopDefault(_collide);
var _link = require("./link");
var _linkDefault = parcelHelpers.interopDefault(_link);
var _manyBody = require("./manyBody");
var _manyBodyDefault = parcelHelpers.interopDefault(_manyBody);
var _radial = require("./radial");
var _radialDefault = parcelHelpers.interopDefault(_radial);
var _simulation = require("./simulation");
var _simulationDefault = parcelHelpers.interopDefault(_simulation);
var _x = require("./x");
var _xDefault = parcelHelpers.interopDefault(_x);
var _y = require("./y");
var _yDefault = parcelHelpers.interopDefault(_y);

},{"./center":"d1ShK","./collide":"4XlLY","./link":"5c9TZ","./manyBody":"gAD1B","./radial":"21kIj","./simulation":"3RfPP","./x":"kRsbd","./y":"d6AXc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d1ShK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        var nodes;
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force() {
            var i, n = nodes.length, node, sx = 0, sy = 0;
            for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
            for(sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
        }
        force.initialize = function(_) {
            nodes = _;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XlLY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var nodes, radii, strength = 1, iterations = 1;
        if (typeof radius !== "function") radius = (0, _constantDefault.default)(radius == null ? 1 : +radius);
        function force() {
            var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
            for(var k = 0; k < iterations; ++k){
                tree = (0, _d3Quadtree.quadtree)(nodes, x, y).visitAfter(prepare);
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    ri = radii[node.index], ri2 = ri * ri;
                    xi = node.x + node.vx;
                    yi = node.y + node.vy;
                    tree.visit(apply);
                }
            }
            function apply(quad, x0, y0, x1, y1) {
                var data = quad.data, rj = quad.r, r = ri + rj;
                if (data) {
                    if (data.index > node.index) {
                        var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                        if (l < r * r) {
                            if (x === 0) x = (0, _jiggleDefault.default)(), l += x * x;
                            if (y === 0) y = (0, _jiggleDefault.default)(), l += y * y;
                            l = (r - (l = Math.sqrt(l))) / l * strength;
                            node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                            node.vy += (y *= l) * r;
                            data.vx -= x * (r = 1 - r);
                            data.vy -= y * r;
                        }
                    }
                    return;
                }
                return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
            }
        }
        function prepare(quad) {
            if (quad.data) return quad.r = radii[quad.data.index];
            for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            radii = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = +_, force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : radius;
        };
        return force;
    });
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _jiggle = require("./jiggle");
var _jiggleDefault = parcelHelpers.interopDefault(_jiggle);
var _d3Quadtree = require("d3-quadtree");
function x(d) {
    return d.x + d.vx;
}
function y(d) {
    return d.y + d.vy;
}

},{"./constant":"2kwg2","./jiggle":"axE08","d3-quadtree":"5yYuF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kwg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axE08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (Math.random() - 0.5) * 1e-6;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5yYuF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "quadtree", ()=>(0, _quadtreeJsDefault.default));
var _quadtreeJs = require("./quadtree.js");
var _quadtreeJsDefault = parcelHelpers.interopDefault(_quadtreeJs);

},{"./quadtree.js":"6vDgM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vDgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quadtree);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _coverJs = require("./cover.js");
var _coverJsDefault = parcelHelpers.interopDefault(_coverJs);
var _dataJs = require("./data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _extentJs = require("./extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _rootJs = require("./root.js");
var _rootJsDefault = parcelHelpers.interopDefault(_rootJs);
var _sizeJs = require("./size.js");
var _sizeJsDefault = parcelHelpers.interopDefault(_sizeJs);
var _visitJs = require("./visit.js");
var _visitJsDefault = parcelHelpers.interopDefault(_visitJs);
var _visitAfterJs = require("./visitAfter.js");
var _visitAfterJsDefault = parcelHelpers.interopDefault(_visitAfterJs);
var _xJs = require("./x.js");
var _xJsDefault = parcelHelpers.interopDefault(_xJs);
var _yJs = require("./y.js");
var _yJsDefault = parcelHelpers.interopDefault(_yJs);
function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? (0, _xJs.defaultX) : x, y == null ? (0, _yJs.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var treeProto = quadtree.prototype = Quadtree.prototype;
treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = leaf_copy(child);
        }
    }
    return copy;
};
treeProto.add = (0, _addJsDefault.default);
treeProto.addAll = (0, _addJs.addAll);
treeProto.cover = (0, _coverJsDefault.default);
treeProto.data = (0, _dataJsDefault.default);
treeProto.extent = (0, _extentJsDefault.default);
treeProto.find = (0, _findJsDefault.default);
treeProto.remove = (0, _removeJsDefault.default);
treeProto.removeAll = (0, _removeJs.removeAll);
treeProto.root = (0, _rootJsDefault.default);
treeProto.size = (0, _sizeJsDefault.default);
treeProto.visit = (0, _visitJsDefault.default);
treeProto.visitAfter = (0, _visitAfterJsDefault.default);
treeProto.x = (0, _xJsDefault.default);
treeProto.y = (0, _yJsDefault.default);

},{"./add.js":"7LC4G","./cover.js":"5es8I","./data.js":"8I0lM","./extent.js":"aU9hE","./find.js":"jpx7G","./remove.js":"3QFtD","./root.js":"khDrv","./size.js":"cQzYu","./visit.js":"8xbxh","./visitAfter.js":"ihORj","./x.js":"iDUW5","./y.js":"iLKgW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LC4G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        var x = +this._x.call(null, d), y = +this._y.call(null, d);
        return add(this.cover(x, y), x, y, d);
    });
parcelHelpers.export(exports, "addAll", ()=>addAll);
function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function addAll(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)add(this, xz[i], yz[i], data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5es8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
        var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
        // If the quadtree has no extent, initialize them.
        // Integer extent are necessary so that if we later double the extent,
        // the existing quadrant boundaries don’t change due to floating point error!
        if (isNaN(x0)) {
            x1 = (x0 = Math.floor(x)) + 1;
            y1 = (y0 = Math.floor(y)) + 1;
        } else {
            var z = x1 - x0, node = this._root, parent, i;
            while(x0 > x || x >= x1 || y0 > y || y >= y1){
                i = (y < y0) << 1 | x < x0;
                parent = new Array(4), parent[i] = node, node = parent, z *= 2;
                switch(i){
                    case 0:
                        x1 = x0 + z, y1 = y0 + z;
                        break;
                    case 1:
                        x0 = x1 - z, y1 = y0 + z;
                        break;
                    case 2:
                        x1 = x0 + z, y0 = y1 - z;
                        break;
                    case 3:
                        x0 = x1 - z, y0 = y1 - z;
                        break;
                }
            }
            if (this._root && this._root.length) this._root = node;
        }
        this._x0 = x0;
        this._y0 = y0;
        this._x1 = x1;
        this._y1 = y1;
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8I0lM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var data = [];
        this.visit(function(node) {
            if (!node.length) do data.push(node.data);
            while (node = node.next);
        });
        return data;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aU9hE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
            [
                this._x0,
                this._y0
            ],
            [
                this._x1,
                this._y1
            ]
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jpx7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y, radius) {
        var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, x0, y0, x3, y3));
        if (radius == null) radius = Infinity;
        else {
            x0 = x - radius, y0 = y - radius;
            x3 = x + radius, y3 = y + radius;
            radius *= radius;
        }
        while(q = quads.pop()){
            // Stop searching if this quadrant can’t contain a closer node.
            if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
            // Bisect the current quadrant.
            if (node.length) {
                var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
                quads.push(new (0, _quadJsDefault.default)(node[3], xm, ym, x2, y2), new (0, _quadJsDefault.default)(node[2], x1, ym, xm, y2), new (0, _quadJsDefault.default)(node[1], xm, y1, x2, ym), new (0, _quadJsDefault.default)(node[0], x1, y1, xm, ym));
                // Visit the closest quadrant first.
                if (i = (y >= ym) << 1 | x >= xm) {
                    q = quads[quads.length - 1];
                    quads[quads.length - 1] = quads[quads.length - 1 - i];
                    quads[quads.length - 1 - i] = q;
                }
            } else {
                var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
                if (d2 < radius) {
                    var d = Math.sqrt(radius = d2);
                    x0 = x - d, y0 = y - d;
                    x3 = x + d, y3 = y + d;
                    data = node.data;
                }
            }
        }
        return data;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2MGsj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node, x0, y0, x1, y1) {
        this.node = node;
        this.x0 = x0;
        this.y0 = y0;
        this.x1 = x1;
        this.y1 = y1;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3QFtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
        var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
        // If the tree is empty, initialize the root as a leaf.
        if (!node) return this;
        // Find the leaf node for the point.
        // While descending, also retain the deepest parent with a non-removed sibling.
        if (node.length) while(true){
            if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
            else x1 = xm;
            if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
            else y1 = ym;
            if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
            if (!node.length) break;
            if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
        }
        // Find the point to remove.
        while(node.data !== d)if (!(previous = node, node = node.next)) return this;
        if (next = node.next) delete node.next;
        // If there are multiple coincident points, remove just the point.
        if (previous) return next ? previous.next = next : delete previous.next, this;
        // If this is the root point, remove it.
        if (!parent) return this._root = next, this;
        // Remove this leaf.
        next ? parent[i] = next : delete parent[i];
        // If the parent now contains exactly one leaf, collapse superfluous parents.
        if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
            if (retainer) retainer[j] = node;
            else this._root = node;
        }
        return this;
    });
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
function removeAll(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"khDrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this._root;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cQzYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var size = 0;
        this.visit(function(node) {
            if (!node.length) do ++size;
            while (node = node.next);
        });
        return size;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8xbxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], q, node = this._root, child, x0, y0, x1, y1;
        if (node) quads.push(new (0, _quadJsDefault.default)(node, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
            var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
            if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
            if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
        }
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihORj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var quads = [], next = [], q;
        if (this._root) quads.push(new (0, _quadJsDefault.default)(this._root, this._x0, this._y0, this._x1, this._y1));
        while(q = quads.pop()){
            var node = q.node;
            if (node.length) {
                var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
                if (child = node[0]) quads.push(new (0, _quadJsDefault.default)(child, x0, y0, xm, ym));
                if (child = node[1]) quads.push(new (0, _quadJsDefault.default)(child, xm, y0, x1, ym));
                if (child = node[2]) quads.push(new (0, _quadJsDefault.default)(child, x0, ym, xm, y1));
                if (child = node[3]) quads.push(new (0, _quadJsDefault.default)(child, xm, ym, x1, y1));
            }
            next.push(q);
        }
        while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
        return this;
    });
var _quadJs = require("./quad.js");
var _quadJsDefault = parcelHelpers.interopDefault(_quadJs);

},{"./quad.js":"2MGsj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDUW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultX", ()=>defaultX);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._x = _, this) : this._x;
    });
function defaultX(d) {
    return d[0];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iLKgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultY", ()=>defaultY);
parcelHelpers.export(exports, "default", ()=>function(_) {
        return arguments.length ? (this._y = _, this) : this._y;
    });
function defaultY(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5c9TZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(links) {
        var id = index, strength = defaultStrength, strengths, distance = (0, _constantDefault.default)(30), distances, nodes, count, bias, iterations = 1;
        if (links == null) links = [];
        function defaultStrength(link) {
            return 1 / Math.min(count[link.source.index], count[link.target.index]);
        }
        function force(alpha) {
            for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
                link = links[i], source = link.source, target = link.target;
                x = target.x + target.vx - source.x - source.vx || (0, _jiggleDefault.default)();
                y = target.y + target.vy - source.y - source.vy || (0, _jiggleDefault.default)();
                l = Math.sqrt(x * x + y * y);
                l = (l - distances[i]) / l * alpha * strengths[i];
                x *= l, y *= l;
                target.vx -= x * (b = bias[i]);
                target.vy -= y * b;
                source.vx += x * (b = 1 - b);
                source.vy += y * b;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, m = links.length, nodeById = (0, _d3Collection.map)(nodes, id), link;
            for(i = 0, count = new Array(n); i < m; ++i){
                link = links[i], link.index = i;
                if (typeof link.source !== "object") link.source = find(nodeById, link.source);
                if (typeof link.target !== "object") link.target = find(nodeById, link.target);
                count[link.source.index] = (count[link.source.index] || 0) + 1;
                count[link.target.index] = (count[link.target.index] || 0) + 1;
            }
            for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
            strengths = new Array(m), initializeStrength();
            distances = new Array(m), initializeDistance();
        }
        function initializeStrength() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
        }
        function initializeDistance() {
            if (!nodes) return;
            for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.links = function(_) {
            return arguments.length ? (links = _, initialize(), force) : links;
        };
        force.id = function(_) {
            return arguments.length ? (id = _, force) : id;
        };
        force.iterations = function(_) {
            return arguments.length ? (iterations = +_, force) : iterations;
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initializeStrength(), force) : strength;
        };
        force.distance = function(_) {
            return arguments.length ? (distance = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initializeDistance(), force) : distance;
        };
        return force;
    });
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _jiggle = require("./jiggle");
var _jiggleDefault = parcelHelpers.interopDefault(_jiggle);
var _d3Collection = require("d3-collection");
function index(d) {
    return d.index;
}
function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("missing: " + nodeId);
    return node;
}

},{"./constant":"2kwg2","./jiggle":"axE08","d3-collection":"c1YdX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAD1B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes, node, alpha, strength = (0, _constantDefault.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
        function force(_) {
            var i, n = nodes.length, tree = (0, _d3Quadtree.quadtree)(nodes, (0, _simulation.x), (0, _simulation.y)).visitAfter(accumulate);
            for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length, node;
            strengths = new Array(n);
            for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
        }
        function accumulate(quad) {
            var strength = 0, q, c, weight = 0, x, y, i;
            // For internal nodes, accumulate forces from child quadrants.
            if (quad.length) {
                for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
                quad.x = x / weight;
                quad.y = y / weight;
            } else {
                q = quad;
                q.x = q.data.x;
                q.y = q.data.y;
                do strength += strengths[q.data.index];
                while (q = q.next);
            }
            quad.value = strength;
        }
        function apply(quad, x1, _, x2) {
            if (!quad.value) return true;
            var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
            // Apply the Barnes-Hut approximation if possible.
            // Limit forces for very close nodes; randomize direction if coincident.
            if (w * w / theta2 < l) {
                if (l < distanceMax2) {
                    if (x === 0) x = (0, _jiggleDefault.default)(), l += x * x;
                    if (y === 0) y = (0, _jiggleDefault.default)(), l += y * y;
                    if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                    node.vx += x * quad.value * alpha / l;
                    node.vy += y * quad.value * alpha / l;
                }
                return true;
            } else if (quad.length || l >= distanceMax2) return;
            // Limit forces for very close nodes; randomize direction if coincident.
            if (quad.data !== node || quad.next) {
                if (x === 0) x = (0, _jiggleDefault.default)(), l += x * x;
                if (y === 0) y = (0, _jiggleDefault.default)(), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
            }
            do if (quad.data !== node) {
                w = strengths[quad.data.index] * alpha / l;
                node.vx += x * w;
                node.vy += y * w;
            }
            while (quad = quad.next);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : strength;
        };
        force.distanceMin = function(_) {
            return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
        };
        force.distanceMax = function(_) {
            return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
        };
        force.theta = function(_) {
            return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
        };
        return force;
    });
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _jiggle = require("./jiggle");
var _jiggleDefault = parcelHelpers.interopDefault(_jiggle);
var _d3Quadtree = require("d3-quadtree");
var _simulation = require("./simulation");

},{"./constant":"2kwg2","./jiggle":"axE08","d3-quadtree":"5yYuF","./simulation":"3RfPP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RfPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
parcelHelpers.export(exports, "default", ()=>function(nodes) {
        var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = (0, _d3Collection.map)(), stepper = (0, _d3Timer.timer)(step), event = (0, _d3Dispatch.dispatch)("tick", "end");
        if (nodes == null) nodes = [];
        function step() {
            tick();
            event.call("tick", simulation);
            if (alpha < alphaMin) {
                stepper.stop();
                event.call("end", simulation);
            }
        }
        function tick(iterations) {
            var i, n = nodes.length, node;
            if (iterations === undefined) iterations = 1;
            for(var k = 0; k < iterations; ++k){
                alpha += (alphaTarget - alpha) * alphaDecay;
                forces.each(function(force) {
                    force(alpha);
                });
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    if (node.fx == null) node.x += node.vx *= velocityDecay;
                    else node.x = node.fx, node.vx = 0;
                    if (node.fy == null) node.y += node.vy *= velocityDecay;
                    else node.y = node.fy, node.vy = 0;
                }
            }
            return simulation;
        }
        function initializeNodes() {
            for(var i = 0, n = nodes.length, node; i < n; ++i){
                node = nodes[i], node.index = i;
                if (node.fx != null) node.x = node.fx;
                if (node.fy != null) node.y = node.fy;
                if (isNaN(node.x) || isNaN(node.y)) {
                    var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
                    node.x = radius * Math.cos(angle);
                    node.y = radius * Math.sin(angle);
                }
                if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
            }
        }
        function initializeForce(force) {
            if (force.initialize) force.initialize(nodes);
            return force;
        }
        initializeNodes();
        return simulation = {
            tick: tick,
            restart: function() {
                return stepper.restart(step), simulation;
            },
            stop: function() {
                return stepper.stop(), simulation;
            },
            nodes: function(_) {
                return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
            },
            alpha: function(_) {
                return arguments.length ? (alpha = +_, simulation) : alpha;
            },
            alphaMin: function(_) {
                return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
            },
            alphaDecay: function(_) {
                return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
            },
            alphaTarget: function(_) {
                return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
            },
            velocityDecay: function(_) {
                return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
            },
            force: function(name, _) {
                return arguments.length > 1 ? (_ == null ? forces.remove(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
            },
            find: function(x, y, radius) {
                var i = 0, n = nodes.length, dx, dy, d2, node, closest;
                if (radius == null) radius = Infinity;
                else radius *= radius;
                for(i = 0; i < n; ++i){
                    node = nodes[i];
                    dx = x - node.x;
                    dy = y - node.y;
                    d2 = dx * dx + dy * dy;
                    if (d2 < radius) closest = node, radius = d2;
                }
                return closest;
            },
            on: function(name, _) {
                return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
            }
        };
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Collection = require("d3-collection");
var _d3Timer = require("d3-timer");
function x(d) {
    return d.x;
}
function y(d) {
    return d.y;
}
var initialRadius = 10, initialAngle = Math.PI * (3 - Math.sqrt(5));

},{"d3-dispatch":"2VwUr","d3-collection":"c1YdX","d3-timer":"lpgSt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21kIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius, x, y) {
        var nodes, strength = (0, _constantDefault.default)(0.1), strengths, radiuses;
        if (typeof radius !== "function") radius = (0, _constantDefault.default)(+radius);
        if (x == null) x = 0;
        if (y == null) y = 0;
        function force(alpha) {
            for(var i = 0, n = nodes.length; i < n; ++i){
                var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
                node.vx += dx * k;
                node.vy += dy * k;
            }
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            radiuses = new Array(n);
            for(i = 0; i < n; ++i){
                radiuses[i] = +radius(nodes[i], i, nodes);
                strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
            }
        }
        force.initialize = function(_) {
            nodes = _, initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : strength;
        };
        force.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : radius;
        };
        force.x = function(_) {
            return arguments.length ? (x = +_, force) : x;
        };
        force.y = function(_) {
            return arguments.length ? (y = +_, force) : y;
        };
        return force;
    });
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);

},{"./constant":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kRsbd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        var strength = (0, _constantDefault.default)(0.1), nodes, strengths, xz;
        if (typeof x !== "function") x = (0, _constantDefault.default)(x == null ? 0 : +x);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            xz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : strength;
        };
        force.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : x;
        };
        return force;
    });
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);

},{"./constant":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6AXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(y) {
        var strength = (0, _constantDefault.default)(0.1), nodes, strengths, yz;
        if (typeof y !== "function") y = (0, _constantDefault.default)(y == null ? 0 : +y);
        function force(alpha) {
            for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
        }
        function initialize() {
            if (!nodes) return;
            var i, n = nodes.length;
            strengths = new Array(n);
            yz = new Array(n);
            for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
        }
        force.initialize = function(_) {
            nodes = _;
            initialize();
        };
        force.strength = function(_) {
            return arguments.length ? (strength = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : strength;
        };
        force.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), initialize(), force) : y;
        };
        return force;
    });
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);

},{"./constant":"2kwg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"97aCb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _defaultLocaleJs.format));
parcelHelpers.export(exports, "formatPrefix", ()=>(0, _defaultLocaleJs.formatPrefix));
parcelHelpers.export(exports, "formatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "formatSpecifier", ()=>(0, _formatSpecifierJsDefault.default));
parcelHelpers.export(exports, "FormatSpecifier", ()=>(0, _formatSpecifierJs.FormatSpecifier));
parcelHelpers.export(exports, "precisionFixed", ()=>(0, _precisionFixedJsDefault.default));
parcelHelpers.export(exports, "precisionPrefix", ()=>(0, _precisionPrefixJsDefault.default));
parcelHelpers.export(exports, "precisionRound", ()=>(0, _precisionRoundJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _precisionFixedJs = require("./precisionFixed.js");
var _precisionFixedJsDefault = parcelHelpers.interopDefault(_precisionFixedJs);
var _precisionPrefixJs = require("./precisionPrefix.js");
var _precisionPrefixJsDefault = parcelHelpers.interopDefault(_precisionPrefixJs);
var _precisionRoundJs = require("./precisionRound.js");
var _precisionRoundJsDefault = parcelHelpers.interopDefault(_precisionRoundJs);

},{"./defaultLocale.js":"j70HL","./locale.js":"lYlSA","./formatSpecifier.js":"51Kl1","./precisionFixed.js":"k1LIY","./precisionPrefix.js":"jGAhd","./precisionRound.js":"1aiyN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j70HL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatPrefix", ()=>formatPrefix);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var format;
var formatPrefix;
defaultLocale({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    format = locale.format;
    formatPrefix = locale.formatPrefix;
    return locale;
}

},{"./locale.js":"lYlSA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lYlSA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(locale) {
        var group = locale.grouping === undefined || locale.thousands === undefined ? (0, _identityJsDefault.default) : (0, _formatGroupJsDefault.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, _identityJsDefault.default) : (0, _formatNumeralsJsDefault.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
        function newFormat(specifier) {
            specifier = (0, _formatSpecifierJsDefault.default)(specifier);
            var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
            // The "n" type is an alias for ",g".
            if (type === "n") comma = true, type = "g";
            else if (!(0, _formatTypesJsDefault.default)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
            // If zero fill is specified, padding goes after sign and before digits.
            if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
            // Compute the prefix and suffix.
            // For SI-prefix, the suffix is lazily computed.
            var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
            // What format function should we use?
            // Is this an integer type?
            // Can this type generate exponential notation?
            var formatType = (0, _formatTypesJsDefault.default)[type], maybeSuffix = /[defgprs%]/.test(type);
            // Set the default precision if not specified,
            // or clamp the specified precision to the supported range.
            // For significant precision, it must be in [1, 21].
            // For fixed precision, it must be in [0, 20].
            precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
            function format(value) {
                var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
                if (type === "c") {
                    valueSuffix = formatType(value) + valueSuffix;
                    value = "";
                } else {
                    value = +value;
                    // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                    var valueNegative = value < 0 || 1 / value < 0;
                    // Perform the initial formatting.
                    value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                    // Trim insignificant zeros.
                    if (trim) value = (0, _formatTrimJsDefault.default)(value);
                    // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                    if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                    // Compute the prefix and suffix.
                    valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                    valueSuffix = (type === "s" ? prefixes[8 + (0, _formatPrefixAutoJs.prefixExponent) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                    // Break the formatted value into the integer “value” part that can be
                    // grouped, and fractional or exponential “suffix” part that is not.
                    if (maybeSuffix) {
                        i = -1, n = value.length;
                        while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                            valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                            value = value.slice(0, i);
                            break;
                        }
                    }
                }
                // If the fill character is not "0", grouping is applied before padding.
                if (comma && !zero) value = group(value, Infinity);
                // Compute the padding.
                var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
                // If the fill character is "0", grouping is applied after padding.
                if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
                // Reconstruct the final output based on the desired alignment.
                switch(align){
                    case "<":
                        value = valuePrefix + value + valueSuffix + padding;
                        break;
                    case "=":
                        value = valuePrefix + padding + value + valueSuffix;
                        break;
                    case "^":
                        value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                        break;
                    default:
                        value = padding + valuePrefix + value + valueSuffix;
                        break;
                }
                return numerals(value);
            }
            format.toString = function() {
                return specifier + "";
            };
            return format;
        }
        function formatPrefix(specifier, value) {
            var f = newFormat((specifier = (0, _formatSpecifierJsDefault.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
            return function(value) {
                return f(k * value) + prefix;
            };
        }
        return {
            format: newFormat,
            formatPrefix: formatPrefix
        };
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);
var _formatGroupJs = require("./formatGroup.js");
var _formatGroupJsDefault = parcelHelpers.interopDefault(_formatGroupJs);
var _formatNumeralsJs = require("./formatNumerals.js");
var _formatNumeralsJsDefault = parcelHelpers.interopDefault(_formatNumeralsJs);
var _formatSpecifierJs = require("./formatSpecifier.js");
var _formatSpecifierJsDefault = parcelHelpers.interopDefault(_formatSpecifierJs);
var _formatTrimJs = require("./formatTrim.js");
var _formatTrimJsDefault = parcelHelpers.interopDefault(_formatTrimJs);
var _formatTypesJs = require("./formatTypes.js");
var _formatTypesJsDefault = parcelHelpers.interopDefault(_formatTypesJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];

},{"./exponent.js":"2idUI","./formatGroup.js":"8F8bk","./formatNumerals.js":"evZ3T","./formatSpecifier.js":"51Kl1","./formatTrim.js":"5Jmf8","./formatTypes.js":"9eqgx","./formatPrefixAuto.js":"8YfIw","./identity.js":"21vxF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2idUI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x = (0, _formatDecimalJs.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"6SG29","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6SG29":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
    });
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
parcelHelpers.export(exports, "formatDecimalParts", ()=>formatDecimalParts);
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8F8bk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(grouping, thousands) {
        return function(value, width) {
            var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
            while(i > 0 && g > 0){
                if (length + g + 1 > width) g = Math.max(1, width - length);
                t.push(value.substring(i -= g, i + g));
                if ((length += g + 1) > width) break;
                g = grouping[j = (j + 1) % grouping.length];
            }
            return t.reverse().join(thousands);
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evZ3T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(numerals) {
        return function(value) {
            return value.replace(/[0-9]/g, function(i) {
                return numerals[+i];
            });
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51Kl1":[function(require,module,exports,__globalThis) {
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatSpecifier);
parcelHelpers.export(exports, "FormatSpecifier", ()=>FormatSpecifier);
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Jmf8":[function(require,module,exports,__globalThis) {
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(s) {
        out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
            case ".":
                i0 = i1 = i;
                break;
            case "0":
                if (i0 === 0) i0 = i;
                i1 = i;
                break;
            default:
                if (!+s[i]) break out;
                if (i0 > 0) i0 = 0;
                break;
        }
        return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9eqgx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _formatDecimalJs = require("./formatDecimal.js");
var _formatDecimalJsDefault = parcelHelpers.interopDefault(_formatDecimalJs);
var _formatPrefixAutoJs = require("./formatPrefixAuto.js");
var _formatPrefixAutoJsDefault = parcelHelpers.interopDefault(_formatPrefixAutoJs);
var _formatRoundedJs = require("./formatRounded.js");
var _formatRoundedJsDefault = parcelHelpers.interopDefault(_formatRoundedJs);
exports.default = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, _formatDecimalJsDefault.default),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, _formatRoundedJsDefault.default)(x * 100, p);
    },
    "r": (0, _formatRoundedJsDefault.default),
    "s": (0, _formatPrefixAutoJsDefault.default),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};

},{"./formatDecimal.js":"6SG29","./formatPrefixAuto.js":"8YfIw","./formatRounded.js":"jQKJD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YfIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prefixExponent", ()=>prefixExponent);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1], i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
        return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimalJs.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
    });
var _formatDecimalJs = require("./formatDecimal.js");
var prefixExponent;

},{"./formatDecimal.js":"6SG29","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQKJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, p) {
        var d = (0, _formatDecimalJs.formatDecimalParts)(x, p);
        if (!d) return x + "";
        var coefficient = d[0], exponent = d[1];
        return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
    });
var _formatDecimalJs = require("./formatDecimal.js");

},{"./formatDecimal.js":"6SG29","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21vxF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1LIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step) {
        return Math.max(0, -(0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"2idUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGAhd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, value) {
        return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponentJsDefault.default)(value) / 3))) * 3 - (0, _exponentJsDefault.default)(Math.abs(step)));
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"2idUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1aiyN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(step, max) {
        step = Math.abs(step), max = Math.abs(max) - step;
        return Math.max(0, (0, _exponentJsDefault.default)(max) - (0, _exponentJsDefault.default)(step)) + 1;
    });
var _exponentJs = require("./exponent.js");
var _exponentJsDefault = parcelHelpers.interopDefault(_exponentJs);

},{"./exponent.js":"2idUI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQZKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "geoArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "geoBounds", ()=>(0, _boundsJsDefault.default));
parcelHelpers.export(exports, "geoCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "geoCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "geoClipAntimeridian", ()=>(0, _antimeridianJsDefault.default));
parcelHelpers.export(exports, "geoClipCircle", ()=>(0, _circleJsDefault1.default));
parcelHelpers.export(exports, "geoClipExtent", ()=>(0, _extentJsDefault.default)) // DEPRECATED! Use d3.geoIdentity().clipExtent(…).
;
parcelHelpers.export(exports, "geoClipRectangle", ()=>(0, _rectangleJsDefault.default));
parcelHelpers.export(exports, "geoContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "geoDistance", ()=>(0, _distanceJsDefault.default));
parcelHelpers.export(exports, "geoGraticule", ()=>(0, _graticuleJsDefault.default));
parcelHelpers.export(exports, "geoGraticule10", ()=>(0, _graticuleJs.graticule10));
parcelHelpers.export(exports, "geoInterpolate", ()=>(0, _interpolateJsDefault.default));
parcelHelpers.export(exports, "geoLength", ()=>(0, _lengthJsDefault.default));
parcelHelpers.export(exports, "geoPath", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "geoAlbers", ()=>(0, _albersJsDefault.default));
parcelHelpers.export(exports, "geoAlbersUsa", ()=>(0, _albersUsaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualArea", ()=>(0, _azimuthalEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEqualAreaRaw", ()=>(0, _azimuthalEqualAreaJs.azimuthalEqualAreaRaw));
parcelHelpers.export(exports, "geoAzimuthalEquidistant", ()=>(0, _azimuthalEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoAzimuthalEquidistantRaw", ()=>(0, _azimuthalEquidistantJs.azimuthalEquidistantRaw));
parcelHelpers.export(exports, "geoConicConformal", ()=>(0, _conicConformalJsDefault.default));
parcelHelpers.export(exports, "geoConicConformalRaw", ()=>(0, _conicConformalJs.conicConformalRaw));
parcelHelpers.export(exports, "geoConicEqualArea", ()=>(0, _conicEqualAreaJsDefault.default));
parcelHelpers.export(exports, "geoConicEqualAreaRaw", ()=>(0, _conicEqualAreaJs.conicEqualAreaRaw));
parcelHelpers.export(exports, "geoConicEquidistant", ()=>(0, _conicEquidistantJsDefault.default));
parcelHelpers.export(exports, "geoConicEquidistantRaw", ()=>(0, _conicEquidistantJs.conicEquidistantRaw));
parcelHelpers.export(exports, "geoEqualEarth", ()=>(0, _equalEarthJsDefault.default));
parcelHelpers.export(exports, "geoEqualEarthRaw", ()=>(0, _equalEarthJs.equalEarthRaw));
parcelHelpers.export(exports, "geoEquirectangular", ()=>(0, _equirectangularJsDefault.default));
parcelHelpers.export(exports, "geoEquirectangularRaw", ()=>(0, _equirectangularJs.equirectangularRaw));
parcelHelpers.export(exports, "geoGnomonic", ()=>(0, _gnomonicJsDefault.default));
parcelHelpers.export(exports, "geoGnomonicRaw", ()=>(0, _gnomonicJs.gnomonicRaw));
parcelHelpers.export(exports, "geoIdentity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "geoProjection", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "geoProjectionMutator", ()=>(0, _indexJs1.projectionMutator));
parcelHelpers.export(exports, "geoMercator", ()=>(0, _mercatorJsDefault.default));
parcelHelpers.export(exports, "geoMercatorRaw", ()=>(0, _mercatorJs.mercatorRaw));
parcelHelpers.export(exports, "geoNaturalEarth1", ()=>(0, _naturalEarth1JsDefault.default));
parcelHelpers.export(exports, "geoNaturalEarth1Raw", ()=>(0, _naturalEarth1Js.naturalEarth1Raw));
parcelHelpers.export(exports, "geoOrthographic", ()=>(0, _orthographicJsDefault.default));
parcelHelpers.export(exports, "geoOrthographicRaw", ()=>(0, _orthographicJs.orthographicRaw));
parcelHelpers.export(exports, "geoStereographic", ()=>(0, _stereographicJsDefault.default));
parcelHelpers.export(exports, "geoStereographicRaw", ()=>(0, _stereographicJs.stereographicRaw));
parcelHelpers.export(exports, "geoTransverseMercator", ()=>(0, _transverseMercatorJsDefault.default));
parcelHelpers.export(exports, "geoTransverseMercatorRaw", ()=>(0, _transverseMercatorJs.transverseMercatorRaw));
parcelHelpers.export(exports, "geoRotation", ()=>(0, _rotationJsDefault.default));
parcelHelpers.export(exports, "geoStream", ()=>(0, _streamJsDefault.default));
parcelHelpers.export(exports, "geoTransform", ()=>(0, _transformJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _circleJs = require("./circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _antimeridianJs = require("./clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs1 = require("./clip/circle.js");
var _circleJsDefault1 = parcelHelpers.interopDefault(_circleJs1);
var _extentJs = require("./clip/extent.js");
var _extentJsDefault = parcelHelpers.interopDefault(_extentJs);
var _rectangleJs = require("./clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _graticuleJs = require("./graticule.js");
var _graticuleJsDefault = parcelHelpers.interopDefault(_graticuleJs);
var _interpolateJs = require("./interpolate.js");
var _interpolateJsDefault = parcelHelpers.interopDefault(_interpolateJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _indexJs = require("./path/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _albersJs = require("./projection/albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _albersUsaJs = require("./projection/albersUsa.js");
var _albersUsaJsDefault = parcelHelpers.interopDefault(_albersUsaJs);
var _azimuthalEqualAreaJs = require("./projection/azimuthalEqualArea.js");
var _azimuthalEqualAreaJsDefault = parcelHelpers.interopDefault(_azimuthalEqualAreaJs);
var _azimuthalEquidistantJs = require("./projection/azimuthalEquidistant.js");
var _azimuthalEquidistantJsDefault = parcelHelpers.interopDefault(_azimuthalEquidistantJs);
var _conicConformalJs = require("./projection/conicConformal.js");
var _conicConformalJsDefault = parcelHelpers.interopDefault(_conicConformalJs);
var _conicEqualAreaJs = require("./projection/conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _conicEquidistantJs = require("./projection/conicEquidistant.js");
var _conicEquidistantJsDefault = parcelHelpers.interopDefault(_conicEquidistantJs);
var _equalEarthJs = require("./projection/equalEarth.js");
var _equalEarthJsDefault = parcelHelpers.interopDefault(_equalEarthJs);
var _equirectangularJs = require("./projection/equirectangular.js");
var _equirectangularJsDefault = parcelHelpers.interopDefault(_equirectangularJs);
var _gnomonicJs = require("./projection/gnomonic.js");
var _gnomonicJsDefault = parcelHelpers.interopDefault(_gnomonicJs);
var _identityJs = require("./projection/identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _indexJs1 = require("./projection/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _mercatorJs = require("./projection/mercator.js");
var _mercatorJsDefault = parcelHelpers.interopDefault(_mercatorJs);
var _naturalEarth1Js = require("./projection/naturalEarth1.js");
var _naturalEarth1JsDefault = parcelHelpers.interopDefault(_naturalEarth1Js);
var _orthographicJs = require("./projection/orthographic.js");
var _orthographicJsDefault = parcelHelpers.interopDefault(_orthographicJs);
var _stereographicJs = require("./projection/stereographic.js");
var _stereographicJsDefault = parcelHelpers.interopDefault(_stereographicJs);
var _transverseMercatorJs = require("./projection/transverseMercator.js");
var _transverseMercatorJsDefault = parcelHelpers.interopDefault(_transverseMercatorJs);
var _rotationJs = require("./rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./area.js":"hfp1u","./bounds.js":"3mtJj","./centroid.js":"e2FyM","./circle.js":"i8eJz","./clip/antimeridian.js":"gdVz3","./clip/circle.js":"jHMRk","./clip/extent.js":"6NFVu","./clip/rectangle.js":"cmyz6","./contains.js":"4Ax1X","./distance.js":"2Xo7Z","./graticule.js":"5h4Wk","./interpolate.js":"c6YqV","./length.js":"lcoiE","./path/index.js":"8Av9e","./projection/albers.js":"lTRWa","./projection/albersUsa.js":"enFIP","./projection/azimuthalEqualArea.js":"5uowk","./projection/azimuthalEquidistant.js":"47ye5","./projection/conicConformal.js":"kIoAV","./projection/conicEqualArea.js":"cGDVP","./projection/conicEquidistant.js":"1hkbk","./projection/equalEarth.js":"lMwLK","./projection/equirectangular.js":"cTwHL","./projection/gnomonic.js":"hx9Pk","./projection/identity.js":"fJNsT","./projection/index.js":"h6rSs","./projection/mercator.js":"itxln","./projection/naturalEarth1.js":"6uiN3","./projection/orthographic.js":"9l5H5","./projection/stereographic.js":"iSTLy","./projection/transverseMercator.js":"kRAj0","./rotation.js":"kS2aY","./stream.js":"l5ilc","./transform.js":"hXP19","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfp1u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "areaRingSum", ()=>areaRingSum);
parcelHelpers.export(exports, "areaStream", ()=>areaStream);
parcelHelpers.export(exports, "default", ()=>function(object) {
        areaSum.reset();
        (0, _streamJsDefault.default)(object, areaStream);
        return areaSum * 2;
    });
var _adderJs = require("./adder.js");
var _adderJsDefault = parcelHelpers.interopDefault(_adderJs);
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var areaRingSum = (0, _adderJsDefault.default)();
var areaSum = (0, _adderJsDefault.default)(), lambda00, phi00, lambda0, cosPhi0, sinPhi0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaRingSum.reset();
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        var areaRing = +areaRingSum;
        areaSum.add(areaRing < 0 ? (0, _mathJs.tau) + areaRing : areaRing);
        this.lineStart = this.lineEnd = this.point = (0, _noopJsDefault.default);
    },
    sphere: function() {
        areaSum.add((0, _mathJs.tau));
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaRingEnd() {
    areaPoint(lambda00, phi00);
}
function areaPointFirst(lambda, phi) {
    areaStream.point = areaPoint;
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, cosPhi0 = (0, _mathJs.cos)(phi = phi / 2 + (0, _mathJs.quarterPi)), sinPhi0 = (0, _mathJs.sin)(phi);
}
function areaPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    phi = phi / 2 + (0, _mathJs.quarterPi); // half the angular distance from south pole
    // Spherical excess E for a spherical triangle with vertices: south pole,
    // previous point, current point.  Uses a formula derived from Cagnoli’s
    // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
    var dLambda = lambda - lambda0, sdLambda = dLambda >= 0 ? 1 : -1, adLambda = sdLambda * dLambda, cosPhi = (0, _mathJs.cos)(phi), sinPhi = (0, _mathJs.sin)(phi), k = sinPhi0 * sinPhi, u = cosPhi0 * cosPhi + k * (0, _mathJs.cos)(adLambda), v = k * sdLambda * (0, _mathJs.sin)(adLambda);
    areaRingSum.add((0, _mathJs.atan2)(v, u));
    // Advance the previous points.
    lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
}

},{"./adder.js":"dAZtM","./math.js":"3L2E2","./noop.js":"aImez","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAZtM":[function(require,module,exports,__globalThis) {
// Adds floating point numbers with twice the normal precision.
// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
// 305–363 (1997).
// Code adapted from GeographicLib by Charles F. F. Karney,
// http://geographiclib.sourceforge.net/
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return new Adder;
    });
function Adder() {
    this.reset();
}
Adder.prototype = {
    constructor: Adder,
    reset: function() {
        this.s = this.t = 0; // exact error
    },
    add: function(y) {
        add(temp, y, this.t);
        add(this, temp.s, this.s);
        if (this.s) this.t += temp.t;
        else this.s = temp.t;
    },
    valueOf: function() {
        return this.s;
    }
};
var temp = new Adder;
function add(adder, a, b) {
    var x = adder.s = a + b, bv = x - a, av = x - bv;
    adder.t = a - av + (b - bv);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3L2E2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "quarterPi", ()=>quarterPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "radians", ()=>radians);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan", ()=>atan);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "ceil", ()=>ceil);
parcelHelpers.export(exports, "exp", ()=>exp);
parcelHelpers.export(exports, "floor", ()=>floor);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "pow", ()=>pow);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "tan", ()=>tan);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
parcelHelpers.export(exports, "haversin", ()=>haversin);
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var quarterPi = pi / 4;
var tau = pi * 2;
var degrees = 180 / pi;
var radians = pi / 180;
var abs = Math.abs;
var atan = Math.atan;
var atan2 = Math.atan2;
var cos = Math.cos;
var ceil = Math.ceil;
var exp = Math.exp;
var floor = Math.floor;
var log = Math.log;
var pow = Math.pow;
var sin = Math.sin;
var sign = Math.sign || function(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
};
var sqrt = Math.sqrt;
var tan = Math.tan;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
}
function haversin(x) {
    return (x = sin(x / 2)) * x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aImez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l5ilc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, stream) {
        if (object && streamObjectType.hasOwnProperty(object.type)) streamObjectType[object.type](object, stream);
        else streamGeometry(object, stream);
    });
function streamGeometry(geometry, stream) {
    if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) streamGeometryType[geometry.type](geometry, stream);
}
var streamObjectType = {
    Feature: function(object, stream) {
        streamGeometry(object.geometry, stream);
    },
    FeatureCollection: function(object, stream) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)streamGeometry(features[i].geometry, stream);
    }
};
var streamGeometryType = {
    Sphere: function(object, stream) {
        stream.sphere();
    },
    Point: function(object, stream) {
        object = object.coordinates;
        stream.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)object = coordinates[i], stream.point(object[0], object[1], object[2]);
    },
    LineString: function(object, stream) {
        streamLine(object.coordinates, stream, 0);
    },
    MultiLineString: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamLine(coordinates[i], stream, 0);
    },
    Polygon: function(object, stream) {
        streamPolygon(object.coordinates, stream);
    },
    MultiPolygon: function(object, stream) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)streamPolygon(coordinates[i], stream);
    },
    GeometryCollection: function(object, stream) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)streamGeometry(geometries[i], stream);
    }
};
function streamLine(coordinates, stream, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    stream.lineStart();
    while(++i < n)coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
    stream.lineEnd();
}
function streamPolygon(coordinates, stream) {
    var i = -1, n = coordinates.length;
    stream.polygonStart();
    while(++i < n)streamLine(coordinates[i], stream, 1);
    stream.polygonEnd();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3mtJj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(feature) {
        var i, n, a, b, merged, deltaMax, delta;
        phi1 = lambda1 = -(lambda0 = phi0 = Infinity);
        ranges = [];
        (0, _streamJsDefault.default)(feature, boundsStream);
        // First, sort ranges by their minimum longitudes.
        if (n = ranges.length) {
            ranges.sort(rangeCompare);
            // Then, merge any ranges that overlap.
            for(i = 1, a = ranges[0], merged = [
                a
            ]; i < n; ++i){
                b = ranges[i];
                if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
                    if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
                    if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
                } else merged.push(a = b);
            }
            // Finally, find the largest gap between the merged ranges.
            // The final bounding box will be the inverse of this gap.
            for(deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i){
                b = merged[i];
                if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0 = b[0], lambda1 = a[1];
            }
        }
        ranges = range = null;
        return lambda0 === Infinity || phi0 === Infinity ? [
            [
                NaN,
                NaN
            ],
            [
                NaN,
                NaN
            ]
        ] : [
            [
                lambda0,
                phi0
            ],
            [
                lambda1,
                phi1
            ]
        ];
    });
var _adderJs = require("./adder.js");
var _adderJsDefault = parcelHelpers.interopDefault(_adderJs);
var _areaJs = require("./area.js");
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lambda0, phi0, lambda1, phi1, lambda2, lambda00, phi00, p0, deltaSum = (0, _adderJsDefault.default)(), ranges, range;
var boundsStream = {
    point: boundsPoint,
    lineStart: boundsLineStart,
    lineEnd: boundsLineEnd,
    polygonStart: function() {
        boundsStream.point = boundsRingPoint;
        boundsStream.lineStart = boundsRingStart;
        boundsStream.lineEnd = boundsRingEnd;
        deltaSum.reset();
        (0, _areaJs.areaStream).polygonStart();
    },
    polygonEnd: function() {
        (0, _areaJs.areaStream).polygonEnd();
        boundsStream.point = boundsPoint;
        boundsStream.lineStart = boundsLineStart;
        boundsStream.lineEnd = boundsLineEnd;
        if ((0, _areaJs.areaRingSum) < 0) lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
        else if (deltaSum > (0, _mathJs.epsilon)) phi1 = 90;
        else if (deltaSum < -(0, _mathJs.epsilon)) phi0 = -90;
        range[0] = lambda0, range[1] = lambda1;
    },
    sphere: function() {
        lambda0 = -(lambda1 = 180), phi0 = -(phi1 = 90);
    }
};
function boundsPoint(lambda, phi) {
    ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
}
function linePoint(lambda, phi) {
    var p = (0, _cartesianJs.cartesian)([
        lambda * (0, _mathJs.radians),
        phi * (0, _mathJs.radians)
    ]);
    if (p0) {
        var normal = (0, _cartesianJs.cartesianCross)(p0, p), equatorial = [
            normal[1],
            -normal[0],
            0
        ], inflection = (0, _cartesianJs.cartesianCross)(equatorial, normal);
        (0, _cartesianJs.cartesianNormalizeInPlace)(inflection);
        inflection = (0, _cartesianJs.spherical)(inflection);
        var delta = lambda - lambda2, sign = delta > 0 ? 1 : -1, lambdai = inflection[0] * (0, _mathJs.degrees) * sign, phii, antimeridian = (0, _mathJs.abs)(delta) > 180;
        if (antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = inflection[1] * (0, _mathJs.degrees);
            if (phii > phi1) phi1 = phii;
        } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign * lambda2 < lambdai && lambdai < sign * lambda)) {
            phii = -inflection[1] * (0, _mathJs.degrees);
            if (phii < phi0) phi0 = phii;
        } else {
            if (phi < phi0) phi0 = phi;
            if (phi > phi1) phi1 = phi;
        }
        if (antimeridian) {
            if (lambda < lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        } else if (lambda1 >= lambda0) {
            if (lambda < lambda0) lambda0 = lambda;
            if (lambda > lambda1) lambda1 = lambda;
        } else {
            if (lambda > lambda2) {
                if (angle(lambda0, lambda) > angle(lambda0, lambda1)) lambda1 = lambda;
            } else if (angle(lambda, lambda1) > angle(lambda0, lambda1)) lambda0 = lambda;
        }
    } else ranges.push(range = [
        lambda0 = lambda,
        lambda1 = lambda
    ]);
    if (phi < phi0) phi0 = phi;
    if (phi > phi1) phi1 = phi;
    p0 = p, lambda2 = lambda;
}
function boundsLineStart() {
    boundsStream.point = linePoint;
}
function boundsLineEnd() {
    range[0] = lambda0, range[1] = lambda1;
    boundsStream.point = boundsPoint;
    p0 = null;
}
function boundsRingPoint(lambda, phi) {
    if (p0) {
        var delta = lambda - lambda2;
        deltaSum.add((0, _mathJs.abs)(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
    } else lambda00 = lambda, phi00 = phi;
    (0, _areaJs.areaStream).point(lambda, phi);
    linePoint(lambda, phi);
}
function boundsRingStart() {
    (0, _areaJs.areaStream).lineStart();
}
function boundsRingEnd() {
    boundsRingPoint(lambda00, phi00);
    (0, _areaJs.areaStream).lineEnd();
    if ((0, _mathJs.abs)(deltaSum) > (0, _mathJs.epsilon)) lambda0 = -(lambda1 = 180);
    range[0] = lambda0, range[1] = lambda1;
    p0 = null;
}
// Finds the left-right distance between two longitudes.
// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
// the distance between ±180° to be 360°.
function angle(lambda0, lambda1) {
    return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
}
function rangeCompare(a, b) {
    return a[0] - b[0];
}
function rangeContains(range, x) {
    return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
}

},{"./adder.js":"dAZtM","./area.js":"hfp1u","./cartesian.js":"gJZ0B","./math.js":"3L2E2","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJZ0B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spherical", ()=>spherical);
parcelHelpers.export(exports, "cartesian", ()=>cartesian);
parcelHelpers.export(exports, "cartesianDot", ()=>cartesianDot);
parcelHelpers.export(exports, "cartesianCross", ()=>cartesianCross);
// TODO return a
parcelHelpers.export(exports, "cartesianAddInPlace", ()=>cartesianAddInPlace);
parcelHelpers.export(exports, "cartesianScale", ()=>cartesianScale);
// TODO return d
parcelHelpers.export(exports, "cartesianNormalizeInPlace", ()=>cartesianNormalizeInPlace);
var _mathJs = require("./math.js");
function spherical(cartesian) {
    return [
        (0, _mathJs.atan2)(cartesian[1], cartesian[0]),
        (0, _mathJs.asin)(cartesian[2])
    ];
}
function cartesian(spherical) {
    var lambda = spherical[0], phi = spherical[1], cosPhi = (0, _mathJs.cos)(phi);
    return [
        cosPhi * (0, _mathJs.cos)(lambda),
        cosPhi * (0, _mathJs.sin)(lambda),
        (0, _mathJs.sin)(phi)
    ];
}
function cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function cartesianCross(a, b) {
    return [
        a[1] * b[2] - a[2] * b[1],
        a[2] * b[0] - a[0] * b[2],
        a[0] * b[1] - a[1] * b[0]
    ];
}
function cartesianAddInPlace(a, b) {
    a[0] += b[0], a[1] += b[1], a[2] += b[2];
}
function cartesianScale(vector, k) {
    return [
        vector[0] * k,
        vector[1] * k,
        vector[2] * k
    ];
}
function cartesianNormalizeInPlace(d) {
    var l = (0, _mathJs.sqrt)(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l, d[1] /= l, d[2] /= l;
}

},{"./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e2FyM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        W0 = W1 = X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
        (0, _streamJsDefault.default)(object, centroidStream);
        var x = X2, y = Y2, z = Z2, m = x * x + y * y + z * z;
        // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
        if (m < (0, _mathJs.epsilon2)) {
            x = X1, y = Y1, z = Z1;
            // If the feature has zero length, fall back to arithmetic mean of point vectors.
            if (W1 < (0, _mathJs.epsilon)) x = X0, y = Y0, z = Z0;
            m = x * x + y * y + z * z;
            // If the feature still has an undefined ccentroid, then return.
            if (m < (0, _mathJs.epsilon2)) return [
                NaN,
                NaN
            ];
        }
        return [
            (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
            (0, _mathJs.asin)(z / (0, _mathJs.sqrt)(m)) * (0, _mathJs.degrees)
        ];
    });
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var W0, W1, X0, Y0, Z0, X1, Y1, Z1, X2, Y2, Z2, lambda00, phi00, x0, y0, z0; // previous point
var centroidStream = {
    sphere: (0, _noopJsDefault.default),
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    }
};
// Arithmetic mean of Cartesian vectors.
function centroidPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    centroidPointCartesian(cosPhi * (0, _mathJs.cos)(lambda), cosPhi * (0, _mathJs.sin)(lambda), (0, _mathJs.sin)(phi));
}
function centroidPointCartesian(x, y, z) {
    ++W0;
    X0 += (x - X0) / W0;
    Y0 += (y - Y0) / W0;
    Z0 += (z - Z0) / W0;
}
function centroidLineStart() {
    centroidStream.point = centroidLinePointFirst;
}
function centroidLinePointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidStream.point = centroidLinePoint;
    centroidPointCartesian(x0, y0, z0);
}
function centroidLinePoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), w = (0, _mathJs.atan2)((0, _mathJs.sqrt)((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
// J. Applied Mechanics 42, 239 (1975).
function centroidRingStart() {
    centroidStream.point = centroidRingPointFirst;
}
function centroidRingEnd() {
    centroidRingPoint(lambda00, phi00);
    centroidStream.point = centroidPoint;
}
function centroidRingPointFirst(lambda, phi) {
    lambda00 = lambda, phi00 = phi;
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    centroidStream.point = centroidRingPoint;
    var cosPhi = (0, _mathJs.cos)(phi);
    x0 = cosPhi * (0, _mathJs.cos)(lambda);
    y0 = cosPhi * (0, _mathJs.sin)(lambda);
    z0 = (0, _mathJs.sin)(phi);
    centroidPointCartesian(x0, y0, z0);
}
function centroidRingPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var cosPhi = (0, _mathJs.cos)(phi), x = cosPhi * (0, _mathJs.cos)(lambda), y = cosPhi * (0, _mathJs.sin)(lambda), z = (0, _mathJs.sin)(phi), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = (0, _mathJs.sqrt)(cx * cx + cy * cy + cz * cz), w = (0, _mathJs.asin)(m), v = m && -w / m; // area weight multiplier
    X2 += v * cx;
    Y2 += v * cy;
    Z2 += v * cz;
    W1 += w;
    X1 += w * (x0 + (x0 = x));
    Y1 += w * (y0 + (y0 = y));
    Z1 += w * (z0 + (z0 = z));
    centroidPointCartesian(x0, y0, z0);
}

},{"./math.js":"3L2E2","./noop.js":"aImez","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8eJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Generates a circle centered at [0°, 0°], with a given radius and precision.
parcelHelpers.export(exports, "circleStream", ()=>circleStream);
parcelHelpers.export(exports, "default", ()=>function() {
        var center = (0, _constantJsDefault.default)([
            0,
            0
        ]), radius = (0, _constantJsDefault.default)(90), precision = (0, _constantJsDefault.default)(6), ring, rotate, stream = {
            point: point
        };
        function point(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= (0, _mathJs.degrees), x[1] *= (0, _mathJs.degrees);
        }
        function circle() {
            var c = center.apply(this, arguments), r = radius.apply(this, arguments) * (0, _mathJs.radians), p = precision.apply(this, arguments) * (0, _mathJs.radians);
            ring = [];
            rotate = (0, _rotationJs.rotateRadians)(-c[0] * (0, _mathJs.radians), -c[1] * (0, _mathJs.radians), 0).invert;
            circleStream(stream, r, p, 1);
            c = {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
            ring = rotate = null;
            return c;
        }
        circle.center = function(_) {
            return arguments.length ? (center = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                +_[0],
                +_[1]
            ]), circle) : center;
        };
        circle.radius = function(_) {
            return arguments.length ? (radius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : radius;
        };
        circle.precision = function(_) {
            return arguments.length ? (precision = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), circle) : precision;
        };
        return circle;
    });
var _cartesianJs = require("./cartesian.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
var _rotationJs = require("./rotation.js");
function circleStream(stream, radius, delta, direction, t0, t1) {
    if (!delta) return;
    var cosRadius = (0, _mathJs.cos)(radius), sinRadius = (0, _mathJs.sin)(radius), step = direction * delta;
    if (t0 == null) {
        t0 = radius + direction * (0, _mathJs.tau);
        t1 = radius - step / 2;
    } else {
        t0 = circleRadius(cosRadius, t0);
        t1 = circleRadius(cosRadius, t1);
        if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * (0, _mathJs.tau);
    }
    for(var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step){
        point = (0, _cartesianJs.spherical)([
            cosRadius,
            -sinRadius * (0, _mathJs.cos)(t),
            -sinRadius * (0, _mathJs.sin)(t)
        ]);
        stream.point(point[0], point[1]);
    }
}
// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
function circleRadius(cosRadius, point) {
    point = (0, _cartesianJs.cartesian)(point), point[0] -= cosRadius;
    (0, _cartesianJs.cartesianNormalizeInPlace)(point);
    var radius = (0, _mathJs.acos)(-point[1]);
    return ((-point[2] < 0 ? -radius : radius) + (0, _mathJs.tau) - (0, _mathJs.epsilon)) % (0, _mathJs.tau);
}

},{"./cartesian.js":"gJZ0B","./constant.js":"PdAls","./math.js":"3L2E2","./rotation.js":"kS2aY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"PdAls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kS2aY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rotateRadians", ()=>rotateRadians);
parcelHelpers.export(exports, "default", ()=>function(rotate) {
        rotate = rotateRadians(rotate[0] * (0, _mathJs.radians), rotate[1] * (0, _mathJs.radians), rotate.length > 2 ? rotate[2] * (0, _mathJs.radians) : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * (0, _mathJs.radians), coordinates[1] * (0, _mathJs.radians));
            return coordinates[0] *= (0, _mathJs.degrees), coordinates[1] *= (0, _mathJs.degrees), coordinates;
        };
        return forward;
    });
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mathJs = require("./math.js");
function rotationIdentity(lambda, phi) {
    return [
        (0, _mathJs.abs)(lambda) > (0, _mathJs.pi) ? lambda + Math.round(-lambda / (0, _mathJs.tau)) * (0, _mathJs.tau) : lambda,
        phi
    ];
}
rotationIdentity.invert = rotationIdentity;
function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
    return (deltaLambda %= (0, _mathJs.tau)) ? deltaPhi || deltaGamma ? (0, _composeJsDefault.default)(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma)) : rotationLambda(deltaLambda) : deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma) : rotationIdentity;
}
function forwardRotationLambda(deltaLambda) {
    return function(lambda, phi) {
        return lambda += deltaLambda, [
            lambda > (0, _mathJs.pi) ? lambda - (0, _mathJs.tau) : lambda < -(0, _mathJs.pi) ? lambda + (0, _mathJs.tau) : lambda,
            phi
        ];
    };
}
function rotationLambda(deltaLambda) {
    var rotation = forwardRotationLambda(deltaLambda);
    rotation.invert = forwardRotationLambda(-deltaLambda);
    return rotation;
}
function rotationPhiGamma(deltaPhi, deltaGamma) {
    var cosDeltaPhi = (0, _mathJs.cos)(deltaPhi), sinDeltaPhi = (0, _mathJs.sin)(deltaPhi), cosDeltaGamma = (0, _mathJs.cos)(deltaGamma), sinDeltaGamma = (0, _mathJs.sin)(deltaGamma);
    function rotation(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaPhi + x * sinDeltaPhi;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaGamma + y * sinDeltaGamma)
        ];
    }
    rotation.invert = function(lambda, phi) {
        var cosPhi = (0, _mathJs.cos)(phi), x = (0, _mathJs.cos)(lambda) * cosPhi, y = (0, _mathJs.sin)(lambda) * cosPhi, z = (0, _mathJs.sin)(phi), k = z * cosDeltaGamma - y * sinDeltaGamma;
        return [
            (0, _mathJs.atan2)(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
            (0, _mathJs.asin)(k * cosDeltaPhi - x * sinDeltaPhi)
        ];
    };
    return rotation;
}

},{"./compose.js":"aIo7W","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aIo7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        function compose(x, y) {
            return x = a(x, y), b(x[0], x[1]);
        }
        if (a.invert && b.invert) compose.invert = function(x, y) {
            return x = b.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gdVz3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
exports.default = (0, _indexJsDefault.default)(function() {
    return true;
}, clipAntimeridianLine, clipAntimeridianInterpolate, [
    -(0, _mathJs.pi),
    -(0, _mathJs.halfPi)
]);
// Takes a line and cuts into visible segments. Return values: 0 - there were
// intersections or the line was empty; 1 - no intersections; 2 - there were
// intersections, and the first and last segments should be rejoined.
function clipAntimeridianLine(stream) {
    var lambda0 = NaN, phi0 = NaN, sign0 = NaN, clean; // no intersections
    return {
        lineStart: function() {
            stream.lineStart();
            clean = 1;
        },
        point: function(lambda1, phi1) {
            var sign1 = lambda1 > 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi), delta = (0, _mathJs.abs)(lambda1 - lambda0);
            if ((0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon)) {
                stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? (0, _mathJs.halfPi) : -(0, _mathJs.halfPi));
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                stream.point(lambda1, phi0);
                clean = 0;
            } else if (sign0 !== sign1 && delta >= (0, _mathJs.pi)) {
                if ((0, _mathJs.abs)(lambda0 - sign0) < (0, _mathJs.epsilon)) lambda0 -= sign0 * (0, _mathJs.epsilon); // handle degeneracies
                if ((0, _mathJs.abs)(lambda1 - sign1) < (0, _mathJs.epsilon)) lambda1 -= sign1 * (0, _mathJs.epsilon);
                phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
                stream.point(sign0, phi0);
                stream.lineEnd();
                stream.lineStart();
                stream.point(sign1, phi0);
                clean = 0;
            }
            stream.point(lambda0 = lambda1, phi0 = phi1);
            sign0 = sign1;
        },
        lineEnd: function() {
            stream.lineEnd();
            lambda0 = phi0 = NaN;
        },
        clean: function() {
            return 2 - clean; // if intersections, rejoin first and last segments
        }
    };
}
function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
    var cosPhi0, cosPhi1, sinLambda0Lambda1 = (0, _mathJs.sin)(lambda0 - lambda1);
    return (0, _mathJs.abs)(sinLambda0Lambda1) > (0, _mathJs.epsilon) ? (0, _mathJs.atan)(((0, _mathJs.sin)(phi0) * (cosPhi1 = (0, _mathJs.cos)(phi1)) * (0, _mathJs.sin)(lambda1) - (0, _mathJs.sin)(phi1) * (cosPhi0 = (0, _mathJs.cos)(phi0)) * (0, _mathJs.sin)(lambda0)) / (cosPhi0 * cosPhi1 * sinLambda0Lambda1)) : (phi0 + phi1) / 2;
}
function clipAntimeridianInterpolate(from, to, direction, stream) {
    var phi;
    if (from == null) {
        phi = direction * (0, _mathJs.halfPi);
        stream.point(-(0, _mathJs.pi), phi);
        stream.point(0, phi);
        stream.point((0, _mathJs.pi), phi);
        stream.point((0, _mathJs.pi), 0);
        stream.point((0, _mathJs.pi), -phi);
        stream.point(0, -phi);
        stream.point(-(0, _mathJs.pi), -phi);
        stream.point(-(0, _mathJs.pi), 0);
        stream.point(-(0, _mathJs.pi), phi);
    } else if ((0, _mathJs.abs)(from[0] - to[0]) > (0, _mathJs.epsilon)) {
        var lambda = from[0] < to[0] ? (0, _mathJs.pi) : -(0, _mathJs.pi);
        phi = direction * lambda / 2;
        stream.point(-lambda, phi);
        stream.point(0, phi);
        stream.point(lambda, phi);
    } else stream.point(to[0], to[1]);
}

},{"./index.js":"iTS9b","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iTS9b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(pointVisible, clipLine, interpolate, start) {
        return function(sink) {
            var line = clipLine(sink), ringBuffer = (0, _bufferJsDefault.default)(), ringSink = clipLine(ringBuffer), polygonStarted = false, polygon, segments, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = (0, _d3Array.merge)(segments);
                    var startInside = (0, _polygonContainsJsDefault.default)(polygon, start);
                    if (segments.length) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, sink);
                    } else if (startInside) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        interpolate(null, null, 1, sink);
                        sink.lineEnd();
                    }
                    if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
                    segments = polygon = null;
                },
                sphere: function() {
                    sink.polygonStart();
                    sink.lineStart();
                    interpolate(null, null, 1, sink);
                    sink.lineEnd();
                    sink.polygonEnd();
                }
            };
            function point(lambda, phi) {
                if (pointVisible(lambda, phi)) sink.point(lambda, phi);
            }
            function pointLine(lambda, phi) {
                line.point(lambda, phi);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            function pointRing(lambda, phi) {
                ring.push([
                    lambda,
                    phi
                ]);
                ringSink.point(lambda, phi);
            }
            function ringStart() {
                ringSink.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringSink.lineEnd();
                var clean = ringSink.clean(), ringSegments = ringBuffer.result(), i, n = ringSegments.length, m, segment, point;
                ring.pop();
                polygon.push(ring);
                ring = null;
                if (!n) return;
                // No intersections.
                if (clean & 1) {
                    segment = ringSegments[0];
                    if ((m = segment.length - 1) > 0) {
                        if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
                        sink.lineStart();
                        for(i = 0; i < m; ++i)sink.point((point = segment[i])[0], point[1]);
                        sink.lineEnd();
                    }
                    return;
                }
                // Rejoin connected segments.
                // TODO reuse ringBuffer.rejoin()?
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(validSegment));
            }
            return clip;
        };
    });
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _mathJs = require("../math.js");
var _polygonContainsJs = require("../polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _d3Array = require("d3-array");
function validSegment(segment) {
    return segment.length > 1;
}
// Intersections are sorted along the clip edge. For both antimeridian cutting
// and circle clipping, the same comparison is used.
function compareIntersection(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - a[1]) - ((b = b.x)[0] < 0 ? b[1] - (0, _mathJs.halfPi) - (0, _mathJs.epsilon) : (0, _mathJs.halfPi) - b[1]);
}

},{"./buffer.js":"jYtWq","./rejoin.js":"dTo08","../math.js":"3L2E2","../polygonContains.js":"bRTnR","d3-array":"aoYKF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYtWq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var lines = [], line;
        return {
            point: function(x, y, m) {
                line.push([
                    x,
                    y,
                    m
                ]);
            },
            lineStart: function() {
                lines.push(line = []);
            },
            lineEnd: (0, _noopJsDefault.default),
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            },
            result: function() {
                var result = lines;
                lines = [];
                line = null;
                return result;
            }
        };
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);

},{"../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dTo08":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A generalized polygon clipping algorithm: given a polygon that has been cut
// into its visible line segments, and rejoins the segments by interpolating
// along the clip edge.
parcelHelpers.export(exports, "default", ()=>function(segments, compareIntersection, startInside, interpolate, stream) {
        var subject = [], clip = [], i, n;
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n], x;
            if ((0, _pointEqualJsDefault.default)(p0, p1)) {
                if (!p0[2] && !p1[2]) {
                    stream.lineStart();
                    for(i = 0; i < n; ++i)stream.point((p0 = segment[i])[0], p0[1]);
                    stream.lineEnd();
                    return;
                }
                // handle degenerate cases by moving the point
                p1[0] += 2 * (0, _mathJs.epsilon);
            }
            subject.push(x = new Intersection(p0, segment, null, true));
            clip.push(x.o = new Intersection(p0, null, x, false));
            subject.push(x = new Intersection(p1, segment, null, false));
            clip.push(x.o = new Intersection(p1, null, x, true));
        });
        if (!subject.length) return;
        clip.sort(compareIntersection);
        link(subject);
        link(clip);
        for(i = 0, n = clip.length; i < n; ++i)clip[i].e = startInside = !startInside;
        var start = subject[0], points, point;
        while(true){
            // Find first unvisited intersection.
            var current = start, isSubject = true;
            while(current.v)if ((current = current.n) === start) return;
            points = current.z;
            stream.lineStart();
            do {
                current.v = current.o.v = true;
                if (current.e) {
                    if (isSubject) for(i = 0, n = points.length; i < n; ++i)stream.point((point = points[i])[0], point[1]);
                    else interpolate(current.x, current.n.x, 1, stream);
                    current = current.n;
                } else {
                    if (isSubject) {
                        points = current.p.z;
                        for(i = points.length - 1; i >= 0; --i)stream.point((point = points[i])[0], point[1]);
                    } else interpolate(current.x, current.p.x, -1, stream);
                    current = current.p;
                }
                current = current.o;
                points = current.z;
                isSubject = !isSubject;
            }while (!current.v);
            stream.lineEnd();
        }
    });
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _mathJs = require("../math.js");
function Intersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other; // another intersection
    this.e = entry; // is an entry?
    this.v = false; // visited
    this.n = this.p = null; // next & previous
}
function link(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while(++i < n){
        a.n = b = array[i];
        b.p = a;
        a = b;
    }
    a.n = b = array[0];
    b.p = a;
}

},{"../pointEqual.js":"2g1IQ","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2g1IQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return (0, _mathJs.abs)(a[0] - b[0]) < (0, _mathJs.epsilon) && (0, _mathJs.abs)(a[1] - b[1]) < (0, _mathJs.epsilon);
    });
var _mathJs = require("./math.js");

},{"./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bRTnR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var lambda = longitude(point), phi = point[1], sinPhi = (0, _mathJs.sin)(phi), normal = [
            (0, _mathJs.sin)(lambda),
            -(0, _mathJs.cos)(lambda),
            0
        ], angle = 0, winding = 0;
        sum.reset();
        if (sinPhi === 1) phi = (0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        else if (sinPhi === -1) phi = -(0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        for(var i = 0, n = polygon.length; i < n; ++i){
            if (!(m = (ring = polygon[i]).length)) continue;
            var ring, m, point0 = ring[m - 1], lambda0 = longitude(point0), phi0 = point0[1] / 2 + (0, _mathJs.quarterPi), sinPhi0 = (0, _mathJs.sin)(phi0), cosPhi0 = (0, _mathJs.cos)(phi0);
            for(var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1){
                var point1 = ring[j], lambda1 = longitude(point1), phi1 = point1[1] / 2 + (0, _mathJs.quarterPi), sinPhi1 = (0, _mathJs.sin)(phi1), cosPhi1 = (0, _mathJs.cos)(phi1), delta = lambda1 - lambda0, sign = delta >= 0 ? 1 : -1, absDelta = sign * delta, antimeridian = absDelta > (0, _mathJs.pi), k = sinPhi0 * sinPhi1;
                sum.add((0, _mathJs.atan2)(k * sign * (0, _mathJs.sin)(absDelta), cosPhi0 * cosPhi1 + k * (0, _mathJs.cos)(absDelta)));
                angle += antimeridian ? delta + sign * (0, _mathJs.tau) : delta;
                // Are the longitudes either side of the point’s meridian (lambda),
                // and are the latitudes smaller than the parallel (phi)?
                if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
                    var arc = (0, _cartesianJs.cartesianCross)((0, _cartesianJs.cartesian)(point0), (0, _cartesianJs.cartesian)(point1));
                    (0, _cartesianJs.cartesianNormalizeInPlace)(arc);
                    var intersection = (0, _cartesianJs.cartesianCross)(normal, arc);
                    (0, _cartesianJs.cartesianNormalizeInPlace)(intersection);
                    var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * (0, _mathJs.asin)(intersection[2]);
                    if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) winding += antimeridian ^ delta >= 0 ? 1 : -1;
                }
            }
        }
        // First, determine whether the South pole is inside or outside:
        //
        // It is inside if:
        // * the polygon winds around it in a clockwise direction.
        // * the polygon does not (cumulatively) wind around it, but has a negative
        //   (counter-clockwise) area.
        //
        // Second, count the (signed) number of times a segment crosses a lambda
        // from the point to the South pole.  If it is zero, then the point is the
        // same side as the South pole.
        return (angle < -(0, _mathJs.epsilon) || angle < (0, _mathJs.epsilon) && sum < -(0, _mathJs.epsilon)) ^ winding & 1;
    });
var _adderJs = require("./adder.js");
var _adderJsDefault = parcelHelpers.interopDefault(_adderJs);
var _cartesianJs = require("./cartesian.js");
var _mathJs = require("./math.js");
var sum = (0, _adderJsDefault.default)();
function longitude(point) {
    if ((0, _mathJs.abs)(point[0]) <= (0, _mathJs.pi)) return point[0];
    else return (0, _mathJs.sign)(point[0]) * (((0, _mathJs.abs)(point[0]) + (0, _mathJs.pi)) % (0, _mathJs.tau) - (0, _mathJs.pi));
}

},{"./adder.js":"dAZtM","./cartesian.js":"gJZ0B","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jHMRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(radius) {
        var cr = (0, _mathJs.cos)(radius), delta = 6 * (0, _mathJs.radians), smallRadius = cr > 0, notHemisphere = (0, _mathJs.abs)(cr) > (0, _mathJs.epsilon); // TODO optimise for this common case
        function interpolate(from, to, direction, stream) {
            (0, _circleJs.circleStream)(stream, radius, delta, direction, from, to);
        }
        function visible(lambda, phi) {
            return (0, _mathJs.cos)(lambda) * (0, _mathJs.cos)(phi) > cr;
        }
        // Takes a line and cuts into visible segments. Return values used for polygon
        // clipping: 0 - there were intersections or the line was empty; 1 - no
        // intersections 2 - there were intersections, and the first and last segments
        // should be rejoined.
        function clipLine(stream) {
            var point0, c0, v0, v00, clean; // no intersections
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(lambda, phi) {
                    var point1 = [
                        lambda,
                        phi
                    ], point2, v = visible(lambda, phi), c = smallRadius ? v ? 0 : code(lambda, phi) : v ? code(lambda + (lambda < 0 ? (0, _mathJs.pi) : -(0, _mathJs.pi)), phi) : 0;
                    if (!point0 && (v00 = v0 = v)) stream.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (!point2 || (0, _pointEqualJsDefault.default)(point0, point2) || (0, _pointEqualJsDefault.default)(point1, point2)) point1[2] = 1;
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            // outside going in
                            stream.lineStart();
                            point2 = intersect(point1, point0);
                            stream.point(point2[0], point2[1]);
                        } else {
                            // inside going out
                            point2 = intersect(point0, point1);
                            stream.point(point2[0], point2[1], 2);
                            stream.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        // If the codes for two points are different, or are both zero,
                        // and there this segment intersects with the small circle.
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1]);
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                            } else {
                                stream.point(t[1][0], t[1][1]);
                                stream.lineEnd();
                                stream.lineStart();
                                stream.point(t[0][0], t[0][1], 3);
                            }
                        }
                    }
                    if (v && (!point0 || !(0, _pointEqualJsDefault.default)(point0, point1))) stream.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) stream.lineEnd();
                    point0 = null;
                },
                // Rejoin first and last segments if there were intersections and the first
                // and last points were visible.
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        // Intersects the great circle between a and b with the clip circle.
        function intersect(a, b, two) {
            var pa = (0, _cartesianJs.cartesian)(a), pb = (0, _cartesianJs.cartesian)(b);
            // We have two planes, n1.p = d1 and n2.p = d2.
            // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
            var n1 = [
                1,
                0,
                0
            ], n2 = (0, _cartesianJs.cartesianCross)(pa, pb), n2n2 = (0, _cartesianJs.cartesianDot)(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            // Two polar points.
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = (0, _cartesianJs.cartesianCross)(n1, n2), A = (0, _cartesianJs.cartesianScale)(n1, c1), B = (0, _cartesianJs.cartesianScale)(n2, c2);
            (0, _cartesianJs.cartesianAddInPlace)(A, B);
            // Solve |p(t)|^2 = 1.
            var u = n1xn2, w = (0, _cartesianJs.cartesianDot)(A, u), uu = (0, _cartesianJs.cartesianDot)(u, u), t2 = w * w - uu * ((0, _cartesianJs.cartesianDot)(A, A) - 1);
            if (t2 < 0) return;
            var t = (0, _mathJs.sqrt)(t2), q = (0, _cartesianJs.cartesianScale)(u, (-w - t) / uu);
            (0, _cartesianJs.cartesianAddInPlace)(q, A);
            q = (0, _cartesianJs.spherical)(q);
            if (!two) return q;
            // Two intersection points.
            var lambda0 = a[0], lambda1 = b[0], phi0 = a[1], phi1 = b[1], z;
            if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
            var delta = lambda1 - lambda0, polar = (0, _mathJs.abs)(delta - (0, _mathJs.pi)) < (0, _mathJs.epsilon), meridian = polar || delta < (0, _mathJs.epsilon);
            if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
            // Check that the first point is between a and b.
            if (meridian ? polar ? phi0 + phi1 > 0 ^ q[1] < ((0, _mathJs.abs)(q[0] - lambda0) < (0, _mathJs.epsilon) ? phi0 : phi1) : phi0 <= q[1] && q[1] <= phi1 : delta > (0, _mathJs.pi) ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
                var q1 = (0, _cartesianJs.cartesianScale)(u, (-w + t) / uu);
                (0, _cartesianJs.cartesianAddInPlace)(q1, A);
                return [
                    q,
                    (0, _cartesianJs.spherical)(q1)
                ];
            }
        }
        // Generates a 4-bit vector representing the location of a point relative to
        // the small circle's bounding box.
        function code(lambda, phi) {
            var r = smallRadius ? radius : (0, _mathJs.pi) - radius, code = 0;
            if (lambda < -r) code |= 1; // left
            else if (lambda > r) code |= 2; // right
            if (phi < -r) code |= 4; // below
            else if (phi > r) code |= 8; // above
            return code;
        }
        return (0, _indexJsDefault.default)(visible, clipLine, interpolate, smallRadius ? [
            0,
            -radius
        ] : [
            -(0, _mathJs.pi),
            radius - (0, _mathJs.pi)
        ]);
    });
var _cartesianJs = require("../cartesian.js");
var _circleJs = require("../circle.js");
var _mathJs = require("../math.js");
var _pointEqualJs = require("../pointEqual.js");
var _pointEqualJsDefault = parcelHelpers.interopDefault(_pointEqualJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);

},{"../cartesian.js":"gJZ0B","../circle.js":"i8eJz","../math.js":"3L2E2","../pointEqual.js":"2g1IQ","./index.js":"iTS9b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6NFVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x0 = 0, y0 = 0, x1 = 960, y1 = 500, cache, cacheStream, clip;
        return clip = {
            stream: function(stream) {
                return cache && cacheStream === stream ? cache : cache = (0, _rectangleJsDefault.default)(x0, y0, x1, y1)(cacheStream = stream);
            },
            extent: function(_) {
                return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ];
            }
        };
    });
var _rectangleJs = require("./rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);

},{"./rectangle.js":"cmyz6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cmyz6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>clipRectangle);
var _mathJs = require("../math.js");
var _bufferJs = require("./buffer.js");
var _bufferJsDefault = parcelHelpers.interopDefault(_bufferJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _rejoinJs = require("./rejoin.js");
var _rejoinJsDefault = parcelHelpers.interopDefault(_rejoinJs);
var _d3Array = require("d3-array");
var clipMax = 1e9, clipMin = -clipMax;
function clipRectangle(x0, y0, x1, y1) {
    function visible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
    }
    function interpolate(from, to, direction, stream) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoint(from, to) < 0 ^ direction > 0) do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
        while ((a = (a + direction + 4) % 4) !== a1);
        else stream.point(to[0], to[1]);
    }
    function corner(p, direction) {
        return (0, _mathJs.abs)(p[0] - x0) < (0, _mathJs.epsilon) ? direction > 0 ? 0 : 3 : (0, _mathJs.abs)(p[0] - x1) < (0, _mathJs.epsilon) ? direction > 0 ? 2 : 1 : (0, _mathJs.abs)(p[1] - y0) < (0, _mathJs.epsilon) ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
    }
    function compareIntersection(a, b) {
        return comparePoint(a.x, b.x);
    }
    function comparePoint(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
    return function(stream) {
        var activeStream = stream, bufferStream = (0, _bufferJsDefault.default)(), segments, polygon, ring, x__, y__, v__, x_, y_, v_, first, clean;
        var clipStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: polygonStart,
            polygonEnd: polygonEnd
        };
        function point(x, y) {
            if (visible(x, y)) activeStream.point(x, y);
        }
        function polygonInside() {
            var winding = 0;
            for(var i = 0, n = polygon.length; i < n; ++i)for(var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j){
                a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
                if (a1 <= y1) {
                    if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding;
                } else if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding;
            }
            return winding;
        }
        // Buffer geometry within a polygon and then clip it en masse.
        function polygonStart() {
            activeStream = bufferStream, segments = [], polygon = [], clean = true;
        }
        function polygonEnd() {
            var startInside = polygonInside(), cleanInside = clean && startInside, visible = (segments = (0, _d3Array.merge)(segments)).length;
            if (cleanInside || visible) {
                stream.polygonStart();
                if (cleanInside) {
                    stream.lineStart();
                    interpolate(null, null, 1, stream);
                    stream.lineEnd();
                }
                if (visible) (0, _rejoinJsDefault.default)(segments, compareIntersection, startInside, interpolate, stream);
                stream.polygonEnd();
            }
            activeStream = stream, segments = polygon = ring = null;
        }
        function lineStart() {
            clipStream.point = linePoint;
            if (polygon) polygon.push(ring = []);
            first = true;
            v_ = false;
            x_ = y_ = NaN;
        }
        // TODO rather than special-case polygons, simply handle them separately.
        // Ideally, coincident intersection points should be jittered to avoid
        // clipping issues.
        function lineEnd() {
            if (segments) {
                linePoint(x__, y__);
                if (v__ && v_) bufferStream.rejoin();
                segments.push(bufferStream.result());
            }
            clipStream.point = point;
            if (v_) activeStream.lineEnd();
        }
        function linePoint(x, y) {
            var v = visible(x, y);
            if (polygon) ring.push([
                x,
                y
            ]);
            if (first) {
                x__ = x, y__ = y, v__ = v;
                first = false;
                if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                }
            } else if (v && v_) activeStream.point(x, y);
            else {
                var a = [
                    x_ = Math.max(clipMin, Math.min(clipMax, x_)),
                    y_ = Math.max(clipMin, Math.min(clipMax, y_))
                ], b = [
                    x = Math.max(clipMin, Math.min(clipMax, x)),
                    y = Math.max(clipMin, Math.min(clipMax, y))
                ];
                if ((0, _lineJsDefault.default)(a, b, x0, y0, x1, y1)) {
                    if (!v_) {
                        activeStream.lineStart();
                        activeStream.point(a[0], a[1]);
                    }
                    activeStream.point(b[0], b[1]);
                    if (!v) activeStream.lineEnd();
                    clean = false;
                } else if (v) {
                    activeStream.lineStart();
                    activeStream.point(x, y);
                    clean = false;
                }
            }
            x_ = x, y_ = y, v_ = v;
        }
        return clipStream;
    };
}

},{"../math.js":"3L2E2","./buffer.js":"jYtWq","./line.js":"bEYjL","./rejoin.js":"dTo08","d3-array":"aoYKF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bEYjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, x0, y0, x1, y1) {
        var ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dx > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dx > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        } else if (dy > 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
            if (r > t1) return;
            if (r > t0) t0 = r;
        } else if (dy > 0) {
            if (r < t0) return;
            if (r < t1) t1 = r;
        }
        if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
        if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
        return true;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Ax1X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object, point) {
        return (object && containsObjectType.hasOwnProperty(object.type) ? containsObjectType[object.type] : containsGeometry)(object, point);
    });
var _polygonContainsJs = require("./polygonContains.js");
var _polygonContainsJsDefault = parcelHelpers.interopDefault(_polygonContainsJs);
var _distanceJs = require("./distance.js");
var _distanceJsDefault = parcelHelpers.interopDefault(_distanceJs);
var _mathJs = require("./math.js");
var containsObjectType = {
    Feature: function(object, point) {
        return containsGeometry(object.geometry, point);
    },
    FeatureCollection: function(object, point) {
        var features = object.features, i = -1, n = features.length;
        while(++i < n)if (containsGeometry(features[i].geometry, point)) return true;
        return false;
    }
};
var containsGeometryType = {
    Sphere: function() {
        return true;
    },
    Point: function(object, point) {
        return containsPoint(object.coordinates, point);
    },
    MultiPoint: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPoint(coordinates[i], point)) return true;
        return false;
    },
    LineString: function(object, point) {
        return containsLine(object.coordinates, point);
    },
    MultiLineString: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsLine(coordinates[i], point)) return true;
        return false;
    },
    Polygon: function(object, point) {
        return containsPolygon(object.coordinates, point);
    },
    MultiPolygon: function(object, point) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while(++i < n)if (containsPolygon(coordinates[i], point)) return true;
        return false;
    },
    GeometryCollection: function(object, point) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while(++i < n)if (containsGeometry(geometries[i], point)) return true;
        return false;
    }
};
function containsGeometry(geometry, point) {
    return geometry && containsGeometryType.hasOwnProperty(geometry.type) ? containsGeometryType[geometry.type](geometry, point) : false;
}
function containsPoint(coordinates, point) {
    return (0, _distanceJsDefault.default)(coordinates, point) === 0;
}
function containsLine(coordinates, point) {
    var ao, bo, ab;
    for(var i = 0, n = coordinates.length; i < n; i++){
        bo = (0, _distanceJsDefault.default)(coordinates[i], point);
        if (bo === 0) return true;
        if (i > 0) {
            ab = (0, _distanceJsDefault.default)(coordinates[i], coordinates[i - 1]);
            if (ab > 0 && ao <= ab && bo <= ab && (ao + bo - ab) * (1 - Math.pow((ao - bo) / ab, 2)) < (0, _mathJs.epsilon2) * ab) return true;
        }
        ao = bo;
    }
    return false;
}
function containsPolygon(coordinates, point) {
    return !!(0, _polygonContainsJsDefault.default)(coordinates.map(ringRadians), pointRadians(point));
}
function ringRadians(ring) {
    return ring = ring.map(pointRadians), ring.pop(), ring;
}
function pointRadians(point) {
    return [
        point[0] * (0, _mathJs.radians),
        point[1] * (0, _mathJs.radians)
    ];
}

},{"./polygonContains.js":"bRTnR","./distance.js":"2Xo7Z","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Xo7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        coordinates[0] = a;
        coordinates[1] = b;
        return (0, _lengthJsDefault.default)(object);
    });
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var coordinates = [
    null,
    null
], object = {
    type: "LineString",
    coordinates: coordinates
};

},{"./length.js":"lcoiE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcoiE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(object) {
        lengthSum.reset();
        (0, _streamJsDefault.default)(object, lengthStream);
        return +lengthSum;
    });
var _adderJs = require("./adder.js");
var _adderJsDefault = parcelHelpers.interopDefault(_adderJs);
var _mathJs = require("./math.js");
var _noopJs = require("./noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _streamJs = require("./stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var lengthSum = (0, _adderJsDefault.default)(), lambda0, sinPhi0, cosPhi0;
var lengthStream = {
    sphere: (0, _noopJsDefault.default),
    point: (0, _noopJsDefault.default),
    lineStart: lengthLineStart,
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default)
};
function lengthLineStart() {
    lengthStream.point = lengthPointFirst;
    lengthStream.lineEnd = lengthLineEnd;
}
function lengthLineEnd() {
    lengthStream.point = lengthStream.lineEnd = (0, _noopJsDefault.default);
}
function lengthPointFirst(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    lambda0 = lambda, sinPhi0 = (0, _mathJs.sin)(phi), cosPhi0 = (0, _mathJs.cos)(phi);
    lengthStream.point = lengthPoint;
}
function lengthPoint(lambda, phi) {
    lambda *= (0, _mathJs.radians), phi *= (0, _mathJs.radians);
    var sinPhi = (0, _mathJs.sin)(phi), cosPhi = (0, _mathJs.cos)(phi), delta = (0, _mathJs.abs)(lambda - lambda0), cosDelta = (0, _mathJs.cos)(delta), sinDelta = (0, _mathJs.sin)(delta), x = cosPhi * sinDelta, y = cosPhi0 * sinPhi - sinPhi0 * cosPhi * cosDelta, z = sinPhi0 * sinPhi + cosPhi0 * cosPhi * cosDelta;
    lengthSum.add((0, _mathJs.atan2)((0, _mathJs.sqrt)(x * x + y * y), z));
    lambda0 = lambda, sinPhi0 = sinPhi, cosPhi0 = cosPhi;
}

},{"./adder.js":"dAZtM","./math.js":"3L2E2","./noop.js":"aImez","./stream.js":"l5ilc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5h4Wk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>graticule);
parcelHelpers.export(exports, "graticule10", ()=>graticule10);
var _d3Array = require("d3-array");
var _mathJs = require("./math.js");
function graticuleX(y0, y1, dy) {
    var y = (0, _d3Array.range)(y0, y1 - (0, _mathJs.epsilon), dy).concat(y1);
    return function(x) {
        return y.map(function(y) {
            return [
                x,
                y
            ];
        });
    };
}
function graticuleY(x0, x1, dx) {
    var x = (0, _d3Array.range)(x0, x1 - (0, _mathJs.epsilon), dx).concat(x1);
    return function(y) {
        return x.map(function(x) {
            return [
                x,
                y
            ];
        });
    };
}
function graticule() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
        return {
            type: "MultiLineString",
            coordinates: lines()
        };
    }
    function lines() {
        return (0, _d3Array.range)((0, _mathJs.ceil)(X0 / DX) * DX, X1, DX).map(X).concat((0, _d3Array.range)((0, _mathJs.ceil)(Y0 / DY) * DY, Y1, DY).map(Y)).concat((0, _d3Array.range)((0, _mathJs.ceil)(x0 / dx) * dx, x1, dx).filter(function(x) {
            return (0, _mathJs.abs)(x % DX) > (0, _mathJs.epsilon);
        }).map(x)).concat((0, _d3Array.range)((0, _mathJs.ceil)(y0 / dy) * dy, y1, dy).filter(function(y) {
            return (0, _mathJs.abs)(y % DY) > (0, _mathJs.epsilon);
        }).map(y));
    }
    graticule.lines = function() {
        return lines().map(function(coordinates) {
            return {
                type: "LineString",
                coordinates: coordinates
            };
        });
    };
    graticule.outline = function() {
        return {
            type: "Polygon",
            coordinates: [
                X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
            ]
        };
    };
    graticule.extent = function(_) {
        if (!arguments.length) return graticule.extentMinor();
        return graticule.extentMajor(_).extentMinor(_);
    };
    graticule.extentMajor = function(_) {
        if (!arguments.length) return [
            [
                X0,
                Y0
            ],
            [
                X1,
                Y1
            ]
        ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
    };
    graticule.extentMinor = function(_) {
        if (!arguments.length) return [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
    };
    graticule.step = function(_) {
        if (!arguments.length) return graticule.stepMinor();
        return graticule.stepMajor(_).stepMinor(_);
    };
    graticule.stepMajor = function(_) {
        if (!arguments.length) return [
            DX,
            DY
        ];
        DX = +_[0], DY = +_[1];
        return graticule;
    };
    graticule.stepMinor = function(_) {
        if (!arguments.length) return [
            dx,
            dy
        ];
        dx = +_[0], dy = +_[1];
        return graticule;
    };
    graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = graticuleX(y0, y1, 90);
        y = graticuleY(x0, x1, precision);
        X = graticuleX(Y0, Y1, 90);
        Y = graticuleY(X0, X1, precision);
        return graticule;
    };
    return graticule.extentMajor([
        [
            -180,
            -90 + (0, _mathJs.epsilon)
        ],
        [
            180,
            90 - (0, _mathJs.epsilon)
        ]
    ]).extentMinor([
        [
            -180,
            -80 - (0, _mathJs.epsilon)
        ],
        [
            180,
            80 + (0, _mathJs.epsilon)
        ]
    ]);
}
function graticule10() {
    return graticule()();
}

},{"d3-array":"aoYKF","./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6YqV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        var x0 = a[0] * (0, _mathJs.radians), y0 = a[1] * (0, _mathJs.radians), x1 = b[0] * (0, _mathJs.radians), y1 = b[1] * (0, _mathJs.radians), cy0 = (0, _mathJs.cos)(y0), sy0 = (0, _mathJs.sin)(y0), cy1 = (0, _mathJs.cos)(y1), sy1 = (0, _mathJs.sin)(y1), kx0 = cy0 * (0, _mathJs.cos)(x0), ky0 = cy0 * (0, _mathJs.sin)(x0), kx1 = cy1 * (0, _mathJs.cos)(x1), ky1 = cy1 * (0, _mathJs.sin)(x1), d = 2 * (0, _mathJs.asin)((0, _mathJs.sqrt)((0, _mathJs.haversin)(y1 - y0) + cy0 * cy1 * (0, _mathJs.haversin)(x1 - x0))), k = (0, _mathJs.sin)(d);
        var interpolate = d ? function(t) {
            var B = (0, _mathJs.sin)(t *= d) / k, A = (0, _mathJs.sin)(d - t) / k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                (0, _mathJs.atan2)(y, x) * (0, _mathJs.degrees),
                (0, _mathJs.atan2)(z, (0, _mathJs.sqrt)(x * x + y * y)) * (0, _mathJs.degrees)
            ];
        } : function() {
            return [
                x0 * (0, _mathJs.degrees),
                y0 * (0, _mathJs.degrees)
            ];
        };
        interpolate.distance = d;
        return interpolate;
    });
var _mathJs = require("./math.js");

},{"./math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Av9e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(projection, context) {
        var pointRadius = 4.5, projectionStream, contextStream;
        function path(object) {
            if (object) {
                if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
                (0, _streamJsDefault.default)(object, projectionStream(contextStream));
            }
            return contextStream.result();
        }
        path.area = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _areaJsDefault.default)));
            return (0, _areaJsDefault.default).result();
        };
        path.measure = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _measureJsDefault.default)));
            return (0, _measureJsDefault.default).result();
        };
        path.bounds = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _boundsJsDefault.default)));
            return (0, _boundsJsDefault.default).result();
        };
        path.centroid = function(object) {
            (0, _streamJsDefault.default)(object, projectionStream((0, _centroidJsDefault.default)));
            return (0, _centroidJsDefault.default).result();
        };
        path.projection = function(_) {
            return arguments.length ? (projectionStream = _ == null ? (projection = null, _identityJsDefault.default) : (projection = _).stream, path) : projection;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = _ == null ? (context = null, new (0, _stringJsDefault.default)) : new (0, _contextJsDefault.default)(context = _);
            if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
            return path;
        };
        return path.projection(projection).context(context);
    });
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _boundsJs = require("./bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _contextJs = require("./context.js");
var _contextJsDefault = parcelHelpers.interopDefault(_contextJs);
var _measureJs = require("./measure.js");
var _measureJsDefault = parcelHelpers.interopDefault(_measureJs);
var _stringJs = require("./string.js");
var _stringJsDefault = parcelHelpers.interopDefault(_stringJs);

},{"../identity.js":"5LHbX","../stream.js":"l5ilc","./area.js":"eQFfj","./bounds.js":"beMh6","./centroid.js":"d3AmC","./context.js":"fKqEr","./measure.js":"agEQd","./string.js":"jgqRu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5LHbX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eQFfj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adderJs = require("../adder.js");
var _adderJsDefault = parcelHelpers.interopDefault(_adderJs);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var areaSum = (0, _adderJsDefault.default)(), areaRingSum = (0, _adderJsDefault.default)(), x00, y00, x0, y0;
var areaStream = {
    point: (0, _noopJsDefault.default),
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: function() {
        areaStream.lineStart = areaRingStart;
        areaStream.lineEnd = areaRingEnd;
    },
    polygonEnd: function() {
        areaStream.lineStart = areaStream.lineEnd = areaStream.point = (0, _noopJsDefault.default);
        areaSum.add((0, _mathJs.abs)(areaRingSum));
        areaRingSum.reset();
    },
    result: function() {
        var area = areaSum / 2;
        areaSum.reset();
        return area;
    }
};
function areaRingStart() {
    areaStream.point = areaPointFirst;
}
function areaPointFirst(x, y) {
    areaStream.point = areaPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function areaPoint(x, y) {
    areaRingSum.add(y0 * x - x0 * y);
    x0 = x, y0 = y;
}
function areaRingEnd() {
    areaPoint(x00, y00);
}
exports.default = areaStream;

},{"../adder.js":"dAZtM","../math.js":"3L2E2","../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beMh6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var x0 = Infinity, y0 = x0, x1 = -x0, y1 = x1;
var boundsStream = {
    point: boundsPoint,
    lineStart: (0, _noopJsDefault.default),
    lineEnd: (0, _noopJsDefault.default),
    polygonStart: (0, _noopJsDefault.default),
    polygonEnd: (0, _noopJsDefault.default),
    result: function() {
        var bounds = [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
        x1 = y1 = -(y0 = x0 = Infinity);
        return bounds;
    }
};
function boundsPoint(x, y) {
    if (x < x0) x0 = x;
    if (x > x1) x1 = x;
    if (y < y0) y0 = y;
    if (y > y1) y1 = y;
}
exports.default = boundsStream;

},{"../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3AmC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
// TODO Enforce positive area for exterior, negative area for interior?
var X0 = 0, Y0 = 0, Z0 = 0, X1 = 0, Y1 = 0, Z1 = 0, X2 = 0, Y2 = 0, Z2 = 0, x00, y00, x0, y0;
var centroidStream = {
    point: centroidPoint,
    lineStart: centroidLineStart,
    lineEnd: centroidLineEnd,
    polygonStart: function() {
        centroidStream.lineStart = centroidRingStart;
        centroidStream.lineEnd = centroidRingEnd;
    },
    polygonEnd: function() {
        centroidStream.point = centroidPoint;
        centroidStream.lineStart = centroidLineStart;
        centroidStream.lineEnd = centroidLineEnd;
    },
    result: function() {
        var centroid = Z2 ? [
            X2 / Z2,
            Y2 / Z2
        ] : Z1 ? [
            X1 / Z1,
            Y1 / Z1
        ] : Z0 ? [
            X0 / Z0,
            Y0 / Z0
        ] : [
            NaN,
            NaN
        ];
        X0 = Y0 = Z0 = X1 = Y1 = Z1 = X2 = Y2 = Z2 = 0;
        return centroid;
    }
};
function centroidPoint(x, y) {
    X0 += x;
    Y0 += y;
    ++Z0;
}
function centroidLineStart() {
    centroidStream.point = centroidPointFirstLine;
}
function centroidPointFirstLine(x, y) {
    centroidStream.point = centroidPointLine;
    centroidPoint(x0 = x, y0 = y);
}
function centroidPointLine(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    centroidPoint(x0 = x, y0 = y);
}
function centroidLineEnd() {
    centroidStream.point = centroidPoint;
}
function centroidRingStart() {
    centroidStream.point = centroidPointFirstRing;
}
function centroidRingEnd() {
    centroidPointRing(x00, y00);
}
function centroidPointFirstRing(x, y) {
    centroidStream.point = centroidPointRing;
    centroidPoint(x00 = x0 = x, y00 = y0 = y);
}
function centroidPointRing(x, y) {
    var dx = x - x0, dy = y - y0, z = (0, _mathJs.sqrt)(dx * dx + dy * dy);
    X1 += z * (x0 + x) / 2;
    Y1 += z * (y0 + y) / 2;
    Z1 += z;
    z = y0 * x - x0 * y;
    X2 += z * (x0 + x);
    Y2 += z * (y0 + y);
    Z2 += z * 3;
    centroidPoint(x0 = x, y0 = y);
}
exports.default = centroidStream;

},{"../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKqEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathContext);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function PathContext(context) {
    this._context = context;
}
PathContext.prototype = {
    _radius: 4.5,
    pointRadius: function(_) {
        return this._radius = _, this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._context.closePath();
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._context.moveTo(x, y);
                this._point = 1;
                break;
            case 1:
                this._context.lineTo(x, y);
                break;
            default:
                this._context.moveTo(x + this._radius, y);
                this._context.arc(x, y, this._radius, 0, (0, _mathJs.tau));
                break;
        }
    },
    result: (0, _noopJsDefault.default)
};

},{"../math.js":"3L2E2","../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agEQd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _adderJs = require("../adder.js");
var _adderJsDefault = parcelHelpers.interopDefault(_adderJs);
var _mathJs = require("../math.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var lengthSum = (0, _adderJsDefault.default)(), lengthRing, x00, y00, x0, y0;
var lengthStream = {
    point: (0, _noopJsDefault.default),
    lineStart: function() {
        lengthStream.point = lengthPointFirst;
    },
    lineEnd: function() {
        if (lengthRing) lengthPoint(x00, y00);
        lengthStream.point = (0, _noopJsDefault.default);
    },
    polygonStart: function() {
        lengthRing = true;
    },
    polygonEnd: function() {
        lengthRing = null;
    },
    result: function() {
        var length = +lengthSum;
        lengthSum.reset();
        return length;
    }
};
function lengthPointFirst(x, y) {
    lengthStream.point = lengthPoint;
    x00 = x0 = x, y00 = y0 = y;
}
function lengthPoint(x, y) {
    x0 -= x, y0 -= y;
    lengthSum.add((0, _mathJs.sqrt)(x0 * x0 + y0 * y0));
    x0 = x, y0 = y;
}
exports.default = lengthStream;

},{"../adder.js":"dAZtM","../math.js":"3L2E2","../noop.js":"aImez","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jgqRu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PathString);
function PathString() {
    this._string = [];
}
PathString.prototype = {
    _radius: 4.5,
    _circle: circle(4.5),
    pointRadius: function(_) {
        if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
        return this;
    },
    polygonStart: function() {
        this._line = 0;
    },
    polygonEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line === 0) this._string.push("Z");
        this._point = NaN;
    },
    point: function(x, y) {
        switch(this._point){
            case 0:
                this._string.push("M", x, ",", y);
                this._point = 1;
                break;
            case 1:
                this._string.push("L", x, ",", y);
                break;
            default:
                if (this._circle == null) this._circle = circle(this._radius);
                this._string.push("M", x, ",", y, this._circle);
                break;
        }
    },
    result: function() {
        if (this._string.length) {
            var result = this._string.join("");
            this._string = [];
            return result;
        } else return null;
    }
};
function circle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lTRWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicEqualAreaJsDefault.default)().parallels([
            29.5,
            45.5
        ]).scale(1070).translate([
            480,
            250
        ]).rotate([
            96,
            0
        ]).center([
            -0.6,
            38.7
        ]);
    });
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);

},{"./conicEqualArea.js":"cGDVP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGDVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEqualAreaRaw", ()=>conicEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEqualAreaRaw).scale(155.424).center([
            0,
            33.6442
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _cylindricalEqualAreaJs = require("./cylindricalEqualArea.js");
function conicEqualAreaRaw(y0, y1) {
    var sy0 = (0, _mathJs.sin)(y0), n = (sy0 + (0, _mathJs.sin)(y1)) / 2;
    // Are the parallels symmetrical around the Equator?
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return (0, _cylindricalEqualAreaJs.cylindricalEqualAreaRaw)(y0);
    var c = 1 + sy0 * (2 * n - sy0), r0 = (0, _mathJs.sqrt)(c) / n;
    function project(x, y) {
        var r = (0, _mathJs.sqrt)(c - 2 * n * (0, _mathJs.sin)(y)) / n;
        return [
            r * (0, _mathJs.sin)(x *= n),
            r0 - r * (0, _mathJs.cos)(x)
        ];
    }
    project.invert = function(x, y) {
        var r0y = r0 - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(r0y)) * (0, _mathJs.sign)(r0y);
        if (r0y * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(r0y);
        return [
            l / n,
            (0, _mathJs.asin)((c - (x * x + r0y * r0y) * n * n) / (2 * n))
        ];
    };
    return project;
}

},{"../math.js":"3L2E2","./conic.js":"4evSq","./cylindricalEqualArea.js":"8B2Uy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4evSq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicProjection", ()=>conicProjection);
var _mathJs = require("../math.js");
var _indexJs = require("./index.js");
function conicProjection(projectAt) {
    var phi0 = 0, phi1 = (0, _mathJs.pi) / 3, m = (0, _indexJs.projectionMutator)(projectAt), p = m(phi0, phi1);
    p.parallels = function(_) {
        return arguments.length ? m(phi0 = _[0] * (0, _mathJs.radians), phi1 = _[1] * (0, _mathJs.radians)) : [
            phi0 * (0, _mathJs.degrees),
            phi1 * (0, _mathJs.degrees)
        ];
    };
    return p;
}

},{"../math.js":"3L2E2","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6rSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>projection);
parcelHelpers.export(exports, "projectionMutator", ()=>projectionMutator);
var _antimeridianJs = require("../clip/antimeridian.js");
var _antimeridianJsDefault = parcelHelpers.interopDefault(_antimeridianJs);
var _circleJs = require("../clip/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _composeJs = require("../compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _resampleJs = require("./resample.js");
var _resampleJsDefault = parcelHelpers.interopDefault(_resampleJs);
var transformRadians = (0, _transformJs.transformer)({
    point: function(x, y) {
        this.stream.point(x * (0, _mathJs.radians), y * (0, _mathJs.radians));
    }
});
function transformRotate(rotate) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            var r = rotate(x, y);
            return this.stream.point(r[0], r[1]);
        }
    });
}
function scaleTranslate(k, dx, dy, sx, sy) {
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            dx + k * x,
            dy - k * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            (x - dx) / k * sx,
            (dy - y) / k * sy
        ];
    };
    return transform;
}
function scaleTranslateRotate(k, dx, dy, sx, sy, alpha) {
    var cosAlpha = (0, _mathJs.cos)(alpha), sinAlpha = (0, _mathJs.sin)(alpha), a = cosAlpha * k, b = sinAlpha * k, ai = cosAlpha / k, bi = sinAlpha / k, ci = (sinAlpha * dy - cosAlpha * dx) / k, fi = (sinAlpha * dx + cosAlpha * dy) / k;
    function transform(x, y) {
        x *= sx;
        y *= sy;
        return [
            a * x - b * y + dx,
            dy - b * x - a * y
        ];
    }
    transform.invert = function(x, y) {
        return [
            sx * (ai * x - bi * y + ci),
            sy * (fi - bi * x - ai * y)
        ];
    };
    return transform;
}
function projection(project) {
    return projectionMutator(function() {
        return project;
    })();
}
function projectionMutator(projectAt) {
    var project, k = 150, x = 480, y = 250, lambda = 0, phi = 0, deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, alpha = 0, sx = 1, sy = 1, theta = null, preclip = (0, _antimeridianJsDefault.default), x0 = null, y0, x1, y1, postclip = (0, _identityJsDefault.default), delta2 = 0.5, projectResample, projectTransform, projectRotateTransform, cache, cacheStream;
    function projection(point) {
        return projectRotateTransform(point[0] * (0, _mathJs.radians), point[1] * (0, _mathJs.radians));
    }
    function invert(point) {
        point = projectRotateTransform.invert(point[0], point[1]);
        return point && [
            point[0] * (0, _mathJs.degrees),
            point[1] * (0, _mathJs.degrees)
        ];
    }
    projection.stream = function(stream) {
        return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
    };
    projection.preclip = function(_) {
        return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
    };
    projection.postclip = function(_) {
        return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
    };
    projection.clipAngle = function(_) {
        return arguments.length ? (preclip = +_ ? (0, _circleJsDefault.default)(theta = _ * (0, _mathJs.radians)) : (theta = null, _antimeridianJsDefault.default), reset()) : theta * (0, _mathJs.degrees);
    };
    projection.clipExtent = function(_) {
        return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    projection.scale = function(_) {
        return arguments.length ? (k = +_, recenter()) : k;
    };
    projection.translate = function(_) {
        return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [
            x,
            y
        ];
    };
    projection.center = function(_) {
        return arguments.length ? (lambda = _[0] % 360 * (0, _mathJs.radians), phi = _[1] % 360 * (0, _mathJs.radians), recenter()) : [
            lambda * (0, _mathJs.degrees),
            phi * (0, _mathJs.degrees)
        ];
    };
    projection.rotate = function(_) {
        return arguments.length ? (deltaLambda = _[0] % 360 * (0, _mathJs.radians), deltaPhi = _[1] % 360 * (0, _mathJs.radians), deltaGamma = _.length > 2 ? _[2] % 360 * (0, _mathJs.radians) : 0, recenter()) : [
            deltaLambda * (0, _mathJs.degrees),
            deltaPhi * (0, _mathJs.degrees),
            deltaGamma * (0, _mathJs.degrees)
        ];
    };
    projection.angle = function(_) {
        return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), recenter()) : alpha * (0, _mathJs.degrees);
    };
    projection.reflectX = function(_) {
        return arguments.length ? (sx = _ ? -1 : 1, recenter()) : sx < 0;
    };
    projection.reflectY = function(_) {
        return arguments.length ? (sy = _ ? -1 : 1, recenter()) : sy < 0;
    };
    projection.precision = function(_) {
        return arguments.length ? (projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2 = _ * _), reset()) : (0, _mathJs.sqrt)(delta2);
    };
    projection.fitExtent = function(extent, object) {
        return (0, _fitJs.fitExtent)(projection, extent, object);
    };
    projection.fitSize = function(size, object) {
        return (0, _fitJs.fitSize)(projection, size, object);
    };
    projection.fitWidth = function(width, object) {
        return (0, _fitJs.fitWidth)(projection, width, object);
    };
    projection.fitHeight = function(height, object) {
        return (0, _fitJs.fitHeight)(projection, height, object);
    };
    function recenter() {
        var center = scaleTranslateRotate(k, 0, 0, sx, sy, alpha).apply(null, project(lambda, phi)), transform = (alpha ? scaleTranslateRotate : scaleTranslate)(k, x - center[0], y - center[1], sx, sy, alpha);
        rotate = (0, _rotationJs.rotateRadians)(deltaLambda, deltaPhi, deltaGamma);
        projectTransform = (0, _composeJsDefault.default)(project, transform);
        projectRotateTransform = (0, _composeJsDefault.default)(rotate, projectTransform);
        projectResample = (0, _resampleJsDefault.default)(projectTransform, delta2);
        return reset();
    }
    function reset() {
        cache = cacheStream = null;
        return projection;
    }
    return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return recenter();
    };
}

},{"../clip/antimeridian.js":"gdVz3","../clip/circle.js":"jHMRk","../clip/rectangle.js":"cmyz6","../compose.js":"aIo7W","../identity.js":"5LHbX","../math.js":"3L2E2","../rotation.js":"kS2aY","../transform.js":"hXP19","./fit.js":"7Eu5K","./resample.js":"blIXs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXP19":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(methods) {
        return {
            stream: transformer(methods)
        };
    });
parcelHelpers.export(exports, "transformer", ()=>transformer);
function transformer(methods) {
    return function(stream) {
        var s = new TransformStream;
        for(var key in methods)s[key] = methods[key];
        s.stream = stream;
        return s;
    };
}
function TransformStream() {}
TransformStream.prototype = {
    constructor: TransformStream,
    point: function(x, y) {
        this.stream.point(x, y);
    },
    sphere: function() {
        this.stream.sphere();
    },
    lineStart: function() {
        this.stream.lineStart();
    },
    lineEnd: function() {
        this.stream.lineEnd();
    },
    polygonStart: function() {
        this.stream.polygonStart();
    },
    polygonEnd: function() {
        this.stream.polygonEnd();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Eu5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fitExtent", ()=>fitExtent);
parcelHelpers.export(exports, "fitSize", ()=>fitSize);
parcelHelpers.export(exports, "fitWidth", ()=>fitWidth);
parcelHelpers.export(exports, "fitHeight", ()=>fitHeight);
var _streamJs = require("../stream.js");
var _streamJsDefault = parcelHelpers.interopDefault(_streamJs);
var _boundsJs = require("../path/bounds.js");
var _boundsJsDefault = parcelHelpers.interopDefault(_boundsJs);
function fit(projection, fitBounds, object) {
    var clip = projection.clipExtent && projection.clipExtent();
    projection.scale(150).translate([
        0,
        0
    ]);
    if (clip != null) projection.clipExtent(null);
    (0, _streamJsDefault.default)(object, projection.stream((0, _boundsJsDefault.default)));
    fitBounds((0, _boundsJsDefault.default).result());
    if (clip != null) projection.clipExtent(clip);
    return projection;
}
function fitExtent(projection, extent, object) {
    return fit(projection, function(b) {
        var w = extent[1][0] - extent[0][0], h = extent[1][1] - extent[0][1], k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])), x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2, y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitSize(projection, size, object) {
    return fitExtent(projection, [
        [
            0,
            0
        ],
        size
    ], object);
}
function fitWidth(projection, width, object) {
    return fit(projection, function(b) {
        var w = +width, k = w / (b[1][0] - b[0][0]), x = (w - k * (b[1][0] + b[0][0])) / 2, y = -k * b[0][1];
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}
function fitHeight(projection, height, object) {
    return fit(projection, function(b) {
        var h = +height, k = h / (b[1][1] - b[0][1]), x = -k * b[0][0], y = (h - k * (b[1][1] + b[0][1])) / 2;
        projection.scale(150 * k).translate([
            x,
            y
        ]);
    }, object);
}

},{"../stream.js":"l5ilc","../path/bounds.js":"beMh6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blIXs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(project, delta2) {
        return +delta2 ? resample(project, delta2) : resampleNone(project);
    });
var _cartesianJs = require("../cartesian.js");
var _mathJs = require("../math.js");
var _transformJs = require("../transform.js");
var maxDepth = 16, cosMinDistance = (0, _mathJs.cos)(30 * (0, _mathJs.radians)); // cos(minimum angular distance)
function resampleNone(project) {
    return (0, _transformJs.transformer)({
        point: function(x, y) {
            x = project(x, y);
            this.stream.point(x[0], x[1]);
        }
    });
}
function resample(project, delta2) {
    function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * delta2 && depth--) {
            var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = (0, _mathJs.sqrt)(a * a + b * b + c * c), phi2 = (0, _mathJs.asin)(c /= m), lambda2 = (0, _mathJs.abs)((0, _mathJs.abs)(c) - 1) < (0, _mathJs.epsilon) || (0, _mathJs.abs)(lambda0 - lambda1) < (0, _mathJs.epsilon) ? (lambda0 + lambda1) / 2 : (0, _mathJs.atan2)(b, a), p = project(lambda2, phi2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
            if (dz * dz / d2 > delta2 // perpendicular projected distance
             || (0, _mathJs.abs)((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
             || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
                resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
                stream.point(x2, y2);
                resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
            }
        }
    }
    return function(stream) {
        var lambda00, x00, y00, a00, b00, c00, lambda0, x0, y0, a0, b0, c0; // previous point
        var resampleStream = {
            point: point,
            lineStart: lineStart,
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.polygonStart();
                resampleStream.lineStart = ringStart;
            },
            polygonEnd: function() {
                stream.polygonEnd();
                resampleStream.lineStart = lineStart;
            }
        };
        function point(x, y) {
            x = project(x, y);
            stream.point(x[0], x[1]);
        }
        function lineStart() {
            x0 = NaN;
            resampleStream.point = linePoint;
            stream.lineStart();
        }
        function linePoint(lambda, phi) {
            var c = (0, _cartesianJs.cartesian)([
                lambda,
                phi
            ]), p = project(lambda, phi);
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
            stream.point(x0, y0);
        }
        function lineEnd() {
            resampleStream.point = point;
            stream.lineEnd();
        }
        function ringStart() {
            lineStart();
            resampleStream.point = ringPoint;
            resampleStream.lineEnd = ringEnd;
        }
        function ringPoint(lambda, phi) {
            linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
            resampleStream.point = linePoint;
        }
        function ringEnd() {
            resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
            resampleStream.lineEnd = lineEnd;
            lineEnd();
        }
        return resampleStream;
    };
}

},{"../cartesian.js":"gJZ0B","../math.js":"3L2E2","../transform.js":"hXP19","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B2Uy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cylindricalEqualAreaRaw", ()=>cylindricalEqualAreaRaw);
var _mathJs = require("../math.js");
function cylindricalEqualAreaRaw(phi0) {
    var cosPhi0 = (0, _mathJs.cos)(phi0);
    function forward(lambda, phi) {
        return [
            lambda * cosPhi0,
            (0, _mathJs.sin)(phi) / cosPhi0
        ];
    }
    forward.invert = function(x, y) {
        return [
            x / cosPhi0,
            (0, _mathJs.asin)(y * cosPhi0)
        ];
    };
    return forward;
}

},{"../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"enFIP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// A composite projection for the United States, configured by default for
// 960×500. The projection also works quite well at 960×600 if you change the
// scale to 1285 and adjust the translate accordingly. The set of standard
// parallels for each region comes from USGS, which is published here:
// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
parcelHelpers.export(exports, "default", ()=>function() {
        var cache, cacheStream, lower48 = (0, _albersJsDefault.default)(), lower48Point, alaska = (0, _conicEqualAreaJsDefault.default)().rotate([
            154,
            0
        ]).center([
            -2,
            58.5
        ]).parallels([
            55,
            65
        ]), alaskaPoint, hawaii = (0, _conicEqualAreaJsDefault.default)().rotate([
            157,
            0
        ]).center([
            -3,
            19.9
        ]).parallels([
            8,
            18
        ]), hawaiiPoint, point, pointStream = {
            point: function(x, y) {
                point = [
                    x,
                    y
                ];
            }
        };
        function albersUsa(coordinates) {
            var x = coordinates[0], y = coordinates[1];
            return point = null, (lower48Point.point(x, y), point) || (alaskaPoint.point(x, y), point) || (hawaiiPoint.point(x, y), point);
        }
        albersUsa.invert = function(coordinates) {
            var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
            return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii : lower48).invert(coordinates);
        };
        albersUsa.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = multiplex([
                lower48.stream(cacheStream = stream),
                alaska.stream(stream),
                hawaii.stream(stream)
            ]);
        };
        albersUsa.precision = function(_) {
            if (!arguments.length) return lower48.precision();
            lower48.precision(_), alaska.precision(_), hawaii.precision(_);
            return reset();
        };
        albersUsa.scale = function(_) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(_) {
            if (!arguments.length) return lower48.translate();
            var k = lower48.scale(), x = +_[0], y = +_[1];
            lower48Point = lower48.translate(_).clipExtent([
                [
                    x - 0.455 * k,
                    y - 0.238 * k
                ],
                [
                    x + 0.455 * k,
                    y + 0.238 * k
                ]
            ]).stream(pointStream);
            alaskaPoint = alaska.translate([
                x - 0.307 * k,
                y + 0.201 * k
            ]).clipExtent([
                [
                    x - 0.425 * k + (0, _mathJs.epsilon),
                    y + 0.120 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.214 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            hawaiiPoint = hawaii.translate([
                x - 0.205 * k,
                y + 0.212 * k
            ]).clipExtent([
                [
                    x - 0.214 * k + (0, _mathJs.epsilon),
                    y + 0.166 * k + (0, _mathJs.epsilon)
                ],
                [
                    x - 0.115 * k - (0, _mathJs.epsilon),
                    y + 0.234 * k - (0, _mathJs.epsilon)
                ]
            ]).stream(pointStream);
            return reset();
        };
        albersUsa.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(albersUsa, extent, object);
        };
        albersUsa.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(albersUsa, size, object);
        };
        albersUsa.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(albersUsa, width, object);
        };
        albersUsa.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(albersUsa, height, object);
        };
        function reset() {
            cache = cacheStream = null;
            return albersUsa;
        }
        return albersUsa.scale(1070);
    });
var _mathJs = require("../math.js");
var _albersJs = require("./albers.js");
var _albersJsDefault = parcelHelpers.interopDefault(_albersJs);
var _conicEqualAreaJs = require("./conicEqualArea.js");
var _conicEqualAreaJsDefault = parcelHelpers.interopDefault(_conicEqualAreaJs);
var _fitJs = require("./fit.js");
// The projections must have mutually exclusive clip regions on the sphere,
// as this will avoid emitting interleaving lines and polygons.
function multiplex(streams) {
    var n = streams.length;
    return {
        point: function(x, y) {
            var i = -1;
            while(++i < n)streams[i].point(x, y);
        },
        sphere: function() {
            var i = -1;
            while(++i < n)streams[i].sphere();
        },
        lineStart: function() {
            var i = -1;
            while(++i < n)streams[i].lineStart();
        },
        lineEnd: function() {
            var i = -1;
            while(++i < n)streams[i].lineEnd();
        },
        polygonStart: function() {
            var i = -1;
            while(++i < n)streams[i].polygonStart();
        },
        polygonEnd: function() {
            var i = -1;
            while(++i < n)streams[i].polygonEnd();
        }
    };
}

},{"../math.js":"3L2E2","./albers.js":"lTRWa","./conicEqualArea.js":"cGDVP","./fit.js":"7Eu5K","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uowk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEqualAreaRaw", ()=>azimuthalEqualAreaRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEqualAreaRaw).scale(124.75).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEqualAreaRaw = (0, _azimuthalJs.azimuthalRaw)(function(cxcy) {
    return (0, _mathJs.sqrt)(2 / (1 + cxcy));
});
azimuthalEqualAreaRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.asin)(z / 2);
});

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4zgCZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalRaw", ()=>azimuthalRaw);
parcelHelpers.export(exports, "azimuthalInvert", ()=>azimuthalInvert);
var _mathJs = require("../math.js");
function azimuthalRaw(scale) {
    return function(x, y) {
        var cx = (0, _mathJs.cos)(x), cy = (0, _mathJs.cos)(y), k = scale(cx * cy);
        return [
            k * cy * (0, _mathJs.sin)(x),
            k * (0, _mathJs.sin)(y)
        ];
    };
}
function azimuthalInvert(angle) {
    return function(x, y) {
        var z = (0, _mathJs.sqrt)(x * x + y * y), c = angle(z), sc = (0, _mathJs.sin)(c), cc = (0, _mathJs.cos)(c);
        return [
            (0, _mathJs.atan2)(x * sc, z * cc),
            (0, _mathJs.asin)(z && y * sc / z)
        ];
    };
}

},{"../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"47ye5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "azimuthalEquidistantRaw", ()=>azimuthalEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(azimuthalEquidistantRaw).scale(79.4188).clipAngle(179.999);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var azimuthalEquidistantRaw = (0, _azimuthalJs.azimuthalRaw)(function(c) {
    return (c = (0, _mathJs.acos)(c)) && c / (0, _mathJs.sin)(c);
});
azimuthalEquidistantRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return z;
});

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIoAV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicConformalRaw", ()=>conicConformalRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicConformalRaw).scale(109.5).parallels([
            30,
            30
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _mercatorJs = require("./mercator.js");
function tany(y) {
    return (0, _mathJs.tan)(((0, _mathJs.halfPi) + y) / 2);
}
function conicConformalRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (0, _mathJs.log)(cy0 / (0, _mathJs.cos)(y1)) / (0, _mathJs.log)(tany(y1) / tany(y0)), f = cy0 * (0, _mathJs.pow)(tany(y0), n) / n;
    if (!n) return 0, _mercatorJs.mercatorRaw;
    function project(x, y) {
        if (f > 0) {
            if (y < -(0, _mathJs.halfPi) + (0, _mathJs.epsilon)) y = -(0, _mathJs.halfPi) + (0, _mathJs.epsilon);
        } else if (y > (0, _mathJs.halfPi) - (0, _mathJs.epsilon)) y = (0, _mathJs.halfPi) - (0, _mathJs.epsilon);
        var r = f / (0, _mathJs.pow)(tany(y), n);
        return [
            r * (0, _mathJs.sin)(n * x),
            f - r * (0, _mathJs.cos)(n * x)
        ];
    }
    project.invert = function(x, y) {
        var fy = f - y, r = (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + fy * fy), l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(fy)) * (0, _mathJs.sign)(fy);
        if (fy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(fy);
        return [
            l / n,
            2 * (0, _mathJs.atan)((0, _mathJs.pow)(f / r, 1 / n)) - (0, _mathJs.halfPi)
        ];
    };
    return project;
}

},{"../math.js":"3L2E2","./conic.js":"4evSq","./mercator.js":"itxln","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"itxln":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercatorRaw", ()=>mercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return mercatorProjection(mercatorRaw).scale(961 / (0, _mathJs.tau));
    });
parcelHelpers.export(exports, "mercatorProjection", ()=>mercatorProjection);
var _mathJs = require("../math.js");
var _rotationJs = require("../rotation.js");
var _rotationJsDefault = parcelHelpers.interopDefault(_rotationJs);
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function mercatorRaw(lambda, phi) {
    return [
        lambda,
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2))
    ];
}
mercatorRaw.invert = function(x, y) {
    return [
        x,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(y)) - (0, _mathJs.halfPi)
    ];
};
function mercatorProjection(project) {
    var m = (0, _indexJsDefault.default)(project), center = m.center, scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, x0 = null, y0, x1, y1; // clip extent
    m.scale = function(_) {
        return arguments.length ? (scale(_), reclip()) : scale();
    };
    m.translate = function(_) {
        return arguments.length ? (translate(_), reclip()) : translate();
    };
    m.center = function(_) {
        return arguments.length ? (center(_), reclip()) : center();
    };
    m.clipExtent = function(_) {
        return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [
            [
                x0,
                y0
            ],
            [
                x1,
                y1
            ]
        ];
    };
    function reclip() {
        var k = (0, _mathJs.pi) * scale(), t = m((0, _rotationJsDefault.default)(m.rotate()).invert([
            0,
            0
        ]));
        return clipExtent(x0 == null ? [
            [
                t[0] - k,
                t[1] - k
            ],
            [
                t[0] + k,
                t[1] + k
            ]
        ] : project === mercatorRaw ? [
            [
                Math.max(t[0] - k, x0),
                y0
            ],
            [
                Math.min(t[0] + k, x1),
                y1
            ]
        ] : [
            [
                x0,
                Math.max(t[1] - k, y0)
            ],
            [
                x1,
                Math.min(t[1] + k, y1)
            ]
        ]);
    }
    return reclip();
}

},{"../math.js":"3L2E2","../rotation.js":"kS2aY","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1hkbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "conicEquidistantRaw", ()=>conicEquidistantRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _conicJs.conicProjection)(conicEquidistantRaw).scale(131.154).center([
            0,
            13.9389
        ]);
    });
var _mathJs = require("../math.js");
var _conicJs = require("./conic.js");
var _equirectangularJs = require("./equirectangular.js");
function conicEquidistantRaw(y0, y1) {
    var cy0 = (0, _mathJs.cos)(y0), n = y0 === y1 ? (0, _mathJs.sin)(y0) : (cy0 - (0, _mathJs.cos)(y1)) / (y1 - y0), g = cy0 / n + y0;
    if ((0, _mathJs.abs)(n) < (0, _mathJs.epsilon)) return 0, _equirectangularJs.equirectangularRaw;
    function project(x, y) {
        var gy = g - y, nx = n * x;
        return [
            gy * (0, _mathJs.sin)(nx),
            g - gy * (0, _mathJs.cos)(nx)
        ];
    }
    project.invert = function(x, y) {
        var gy = g - y, l = (0, _mathJs.atan2)(x, (0, _mathJs.abs)(gy)) * (0, _mathJs.sign)(gy);
        if (gy * n < 0) l -= (0, _mathJs.pi) * (0, _mathJs.sign)(x) * (0, _mathJs.sign)(gy);
        return [
            l / n,
            g - (0, _mathJs.sign)(n) * (0, _mathJs.sqrt)(x * x + gy * gy)
        ];
    };
    return project;
}

},{"../math.js":"3L2E2","./conic.js":"4evSq","./equirectangular.js":"cTwHL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cTwHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equirectangularRaw", ()=>equirectangularRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equirectangularRaw).scale(152.63);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function equirectangularRaw(lambda, phi) {
    return [
        lambda,
        phi
    ];
}
equirectangularRaw.invert = equirectangularRaw;

},{"./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMwLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equalEarthRaw", ()=>equalEarthRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(equalEarthRaw).scale(177.158);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
var A1 = 1.340264, A2 = -0.081106, A3 = 0.000893, A4 = 0.003796, M = (0, _mathJs.sqrt)(3) / 2, iterations = 12;
function equalEarthRaw(lambda, phi) {
    var l = (0, _mathJs.asin)(M * (0, _mathJs.sin)(phi)), l2 = l * l, l6 = l2 * l2 * l2;
    return [
        lambda * (0, _mathJs.cos)(l) / (M * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2))),
        l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2))
    ];
}
equalEarthRaw.invert = function(x, y) {
    var l = y, l2 = l * l, l6 = l2 * l2 * l2;
    for(var i = 0, delta, fy, fpy; i < iterations; ++i){
        fy = l * (A1 + A2 * l2 + l6 * (A3 + A4 * l2)) - y;
        fpy = A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2);
        l -= delta = fy / fpy, l2 = l * l, l6 = l2 * l2 * l2;
        if ((0, _mathJs.abs)(delta) < (0, _mathJs.epsilon2)) break;
    }
    return [
        M * x * (A1 + 3 * A2 * l2 + l6 * (7 * A3 + 9 * A4 * l2)) / (0, _mathJs.cos)(l),
        (0, _mathJs.asin)((0, _mathJs.sin)(l) / M)
    ];
};

},{"./index.js":"h6rSs","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hx9Pk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gnomonicRaw", ()=>gnomonicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(gnomonicRaw).scale(144.049).clipAngle(60);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function gnomonicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
gnomonicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.atan));

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fJNsT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, alpha = 0, ca, sa, x0 = null, y0, x1, y1, kx = 1, ky = 1, transform = (0, _transformJs.transformer)({
            point: function(x, y) {
                var p = projection([
                    x,
                    y
                ]);
                this.stream.point(p[0], p[1]);
            }
        }), postclip = (0, _identityJsDefault.default), cache, cacheStream;
        function reset() {
            kx = k * sx;
            ky = k * sy;
            cache = cacheStream = null;
            return projection;
        }
        function projection(p) {
            var x = p[0] * kx, y = p[1] * ky;
            if (alpha) {
                var t = y * ca - x * sa;
                x = x * ca + y * sa;
                y = t;
            }
            return [
                x + tx,
                y + ty
            ];
        }
        projection.invert = function(p) {
            var x = p[0] - tx, y = p[1] - ty;
            if (alpha) {
                var t = y * ca + x * sa;
                x = x * ca - y * sa;
                y = t;
            }
            return [
                x / kx,
                y / ky
            ];
        };
        projection.stream = function(stream) {
            return cache && cacheStream === stream ? cache : cache = transform(postclip(cacheStream = stream));
        };
        projection.postclip = function(_) {
            return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
        };
        projection.clipExtent = function(_) {
            return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, _identityJsDefault.default) : (0, _rectangleJsDefault.default)(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
        projection.scale = function(_) {
            return arguments.length ? (k = +_, reset()) : k;
        };
        projection.translate = function(_) {
            return arguments.length ? (tx = +_[0], ty = +_[1], reset()) : [
                tx,
                ty
            ];
        };
        projection.angle = function(_) {
            return arguments.length ? (alpha = _ % 360 * (0, _mathJs.radians), sa = (0, _mathJs.sin)(alpha), ca = (0, _mathJs.cos)(alpha), reset()) : alpha * (0, _mathJs.degrees);
        };
        projection.reflectX = function(_) {
            return arguments.length ? (sx = _ ? -1 : 1, reset()) : sx < 0;
        };
        projection.reflectY = function(_) {
            return arguments.length ? (sy = _ ? -1 : 1, reset()) : sy < 0;
        };
        projection.fitExtent = function(extent, object) {
            return (0, _fitJs.fitExtent)(projection, extent, object);
        };
        projection.fitSize = function(size, object) {
            return (0, _fitJs.fitSize)(projection, size, object);
        };
        projection.fitWidth = function(width, object) {
            return (0, _fitJs.fitWidth)(projection, width, object);
        };
        projection.fitHeight = function(height, object) {
            return (0, _fitJs.fitHeight)(projection, height, object);
        };
        return projection;
    });
var _rectangleJs = require("../clip/rectangle.js");
var _rectangleJsDefault = parcelHelpers.interopDefault(_rectangleJs);
var _identityJs = require("../identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _transformJs = require("../transform.js");
var _fitJs = require("./fit.js");
var _mathJs = require("../math.js");

},{"../clip/rectangle.js":"cmyz6","../identity.js":"5LHbX","../transform.js":"hXP19","./fit.js":"7Eu5K","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6uiN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "naturalEarth1Raw", ()=>naturalEarth1Raw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(naturalEarth1Raw).scale(175.295);
    });
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _mathJs = require("../math.js");
function naturalEarth1Raw(lambda, phi) {
    var phi2 = phi * phi, phi4 = phi2 * phi2;
    return [
        lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
        phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
    ];
}
naturalEarth1Raw.invert = function(x, y) {
    var phi = y, i = 25, delta;
    do {
        var phi2 = phi * phi, phi4 = phi2 * phi2;
        phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) / (1.007226 + phi2 * (0.045255 + phi4 * (-0.311325 + 0.259866 * phi2 - 0.005916 * 11 * phi4)));
    }while ((0, _mathJs.abs)(delta) > (0, _mathJs.epsilon) && --i > 0);
    return [
        x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
        phi
    ];
};

},{"./index.js":"h6rSs","../math.js":"3L2E2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9l5H5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orthographicRaw", ()=>orthographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(orthographicRaw).scale(249.5).clipAngle(90 + (0, _mathJs.epsilon));
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function orthographicRaw(x, y) {
    return [
        (0, _mathJs.cos)(y) * (0, _mathJs.sin)(x),
        (0, _mathJs.sin)(y)
    ];
}
orthographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)((0, _mathJs.asin));

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iSTLy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stereographicRaw", ()=>stereographicRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _indexJsDefault.default)(stereographicRaw).scale(250).clipAngle(142);
    });
var _mathJs = require("../math.js");
var _azimuthalJs = require("./azimuthal.js");
var _indexJs = require("./index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function stereographicRaw(x, y) {
    var cy = (0, _mathJs.cos)(y), k = 1 + (0, _mathJs.cos)(x) * cy;
    return [
        cy * (0, _mathJs.sin)(x) / k,
        (0, _mathJs.sin)(y) / k
    ];
}
stereographicRaw.invert = (0, _azimuthalJs.azimuthalInvert)(function(z) {
    return 2 * (0, _mathJs.atan)(z);
});

},{"../math.js":"3L2E2","./azimuthal.js":"4zgCZ","./index.js":"h6rSs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kRAj0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transverseMercatorRaw", ()=>transverseMercatorRaw);
parcelHelpers.export(exports, "default", ()=>function() {
        var m = (0, _mercatorJs.mercatorProjection)(transverseMercatorRaw), center = m.center, rotate = m.rotate;
        m.center = function(_) {
            return arguments.length ? center([
                -_[1],
                _[0]
            ]) : (_ = center(), [
                _[1],
                -_[0]
            ]);
        };
        m.rotate = function(_) {
            return arguments.length ? rotate([
                _[0],
                _[1],
                _.length > 2 ? _[2] + 90 : 90
            ]) : (_ = rotate(), [
                _[0],
                _[1],
                _[2] - 90
            ]);
        };
        return rotate([
            0,
            0,
            90
        ]).scale(159.155);
    });
var _mathJs = require("../math.js");
var _mercatorJs = require("./mercator.js");
function transverseMercatorRaw(lambda, phi) {
    return [
        (0, _mathJs.log)((0, _mathJs.tan)(((0, _mathJs.halfPi) + phi) / 2)),
        -lambda
    ];
}
transverseMercatorRaw.invert = function(x, y) {
    return [
        -y,
        2 * (0, _mathJs.atan)((0, _mathJs.exp)(x)) - (0, _mathJs.halfPi)
    ];
};

},{"../math.js":"3L2E2","./mercator.js":"itxln","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cFwdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cluster", ()=>(0, _clusterJsDefault.default));
parcelHelpers.export(exports, "hierarchy", ()=>(0, _indexJsDefault.default));
parcelHelpers.export(exports, "pack", ()=>(0, _indexJsDefault1.default));
parcelHelpers.export(exports, "packSiblings", ()=>(0, _siblingsJsDefault.default));
parcelHelpers.export(exports, "packEnclose", ()=>(0, _encloseJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "stratify", ()=>(0, _stratifyJsDefault.default));
parcelHelpers.export(exports, "tree", ()=>(0, _treeJsDefault.default));
parcelHelpers.export(exports, "treemap", ()=>(0, _indexJsDefault2.default));
parcelHelpers.export(exports, "treemapBinary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "treemapDice", ()=>(0, _diceJsDefault.default));
parcelHelpers.export(exports, "treemapSlice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "treemapSliceDice", ()=>(0, _sliceDiceJsDefault.default));
parcelHelpers.export(exports, "treemapSquarify", ()=>(0, _squarifyJsDefault.default));
parcelHelpers.export(exports, "treemapResquarify", ()=>(0, _resquarifyJsDefault.default));
var _clusterJs = require("./cluster.js");
var _clusterJsDefault = parcelHelpers.interopDefault(_clusterJs);
var _indexJs = require("./hierarchy/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./pack/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _siblingsJs = require("./pack/siblings.js");
var _siblingsJsDefault = parcelHelpers.interopDefault(_siblingsJs);
var _encloseJs = require("./pack/enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _stratifyJs = require("./stratify.js");
var _stratifyJsDefault = parcelHelpers.interopDefault(_stratifyJs);
var _treeJs = require("./tree.js");
var _treeJsDefault = parcelHelpers.interopDefault(_treeJs);
var _indexJs2 = require("./treemap/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _binaryJs = require("./treemap/binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./treemap/slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sliceDiceJs = require("./treemap/sliceDice.js");
var _sliceDiceJsDefault = parcelHelpers.interopDefault(_sliceDiceJs);
var _squarifyJs = require("./treemap/squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _resquarifyJs = require("./treemap/resquarify.js");
var _resquarifyJsDefault = parcelHelpers.interopDefault(_resquarifyJs);

},{"./cluster.js":"6HKtw","./hierarchy/index.js":"1kLlO","./pack/index.js":"5J3V4","./pack/siblings.js":"gORqP","./pack/enclose.js":"4MtLA","./partition.js":"4iNvs","./stratify.js":"32r3u","./tree.js":"e7DRS","./treemap/index.js":"e5q11","./treemap/binary.js":"93Bqf","./treemap/dice.js":"9U0kv","./treemap/slice.js":"iPXtV","./treemap/sliceDice.js":"3nypX","./treemap/squarify.js":"8lg5l","./treemap/resquarify.js":"dz45X","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6HKtw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = false;
        function cluster(root) {
            var previousNode, x = 0;
            // First walk, computing the initial x & y values.
            root.eachAfter(function(node) {
                var children = node.children;
                if (children) {
                    node.x = meanX(children);
                    node.y = maxY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = leafLeft(root), right = leafRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            // Second walk, normalizing x & y to the desired size.
            return root.eachAfter(nodeSize ? function(node) {
                node.x = (node.x - root.x) * dx;
                node.y = (root.y - node.y) * dy;
            } : function(node) {
                node.x = (node.x - x0) / (x1 - x0) * dx;
                node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
            });
        }
        cluster.separation = function(x) {
            return arguments.length ? (separation = x, cluster) : separation;
        };
        cluster.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        cluster.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return cluster;
    });
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
}
function meanXReduce(x, c) {
    return x + c.x;
}
function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
}
function maxYReduce(y, c) {
    return Math.max(y, c.y);
}
function leafLeft(node) {
    var children;
    while(children = node.children)node = children[0];
    return node;
}
function leafRight(node) {
    var children;
    while(children = node.children)node = children[children.length - 1];
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1kLlO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hierarchy);
parcelHelpers.export(exports, "computeHeight", ()=>computeHeight);
parcelHelpers.export(exports, "Node", ()=>Node);
var _countJs = require("./count.js");
var _countJsDefault = parcelHelpers.interopDefault(_countJs);
var _eachJs = require("./each.js");
var _eachJsDefault = parcelHelpers.interopDefault(_eachJs);
var _eachBeforeJs = require("./eachBefore.js");
var _eachBeforeJsDefault = parcelHelpers.interopDefault(_eachBeforeJs);
var _eachAfterJs = require("./eachAfter.js");
var _eachAfterJsDefault = parcelHelpers.interopDefault(_eachAfterJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _ancestorsJs = require("./ancestors.js");
var _ancestorsJsDefault = parcelHelpers.interopDefault(_ancestorsJs);
var _descendantsJs = require("./descendants.js");
var _descendantsJsDefault = parcelHelpers.interopDefault(_descendantsJs);
var _leavesJs = require("./leaves.js");
var _leavesJsDefault = parcelHelpers.interopDefault(_leavesJs);
var _linksJs = require("./links.js");
var _linksJsDefault = parcelHelpers.interopDefault(_linksJs);
function hierarchy(data, children) {
    var root = new Node(data), valued = +data.value && (root.value = data.value), node, nodes = [
        root
    ], child, childs, i, n;
    if (children == null) children = defaultChildren;
    while(node = nodes.pop()){
        if (valued) node.value = +node.data.value;
        if ((childs = children(node.data)) && (n = childs.length)) {
            node.children = new Array(n);
            for(i = n - 1; i >= 0; --i){
                nodes.push(child = node.children[i] = new Node(childs[i]));
                child.parent = node;
                child.depth = node.depth + 1;
            }
        }
    }
    return root.eachBefore(computeHeight);
}
function node_copy() {
    return hierarchy(this).eachBefore(copyData);
}
function defaultChildren(d) {
    return d.children;
}
function copyData(node) {
    node.data = node.data.data;
}
function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && node.height < ++height);
}
function Node(data) {
    this.data = data;
    this.depth = this.height = 0;
    this.parent = null;
}
Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: (0, _countJsDefault.default),
    each: (0, _eachJsDefault.default),
    eachAfter: (0, _eachAfterJsDefault.default),
    eachBefore: (0, _eachBeforeJsDefault.default),
    sum: (0, _sumJsDefault.default),
    sort: (0, _sortJsDefault.default),
    path: (0, _pathJsDefault.default),
    ancestors: (0, _ancestorsJsDefault.default),
    descendants: (0, _descendantsJsDefault.default),
    leaves: (0, _leavesJsDefault.default),
    links: (0, _linksJsDefault.default),
    copy: node_copy
};

},{"./count.js":"2sGb7","./each.js":"7WXcZ","./eachBefore.js":"bmq4n","./eachAfter.js":"cZjeZ","./sum.js":"1cuXk","./sort.js":"1cxiV","./path.js":"9wQhJ","./ancestors.js":"bdyH6","./descendants.js":"lcRrI","./leaves.js":"hi2Ek","./links.js":"koCGV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2sGb7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return this.eachAfter(count);
    });
function count(node) {
    var sum = 0, children = node.children, i = children && children.length;
    if (!i) sum = 1;
    else while(--i >= 0)sum += children[i].value;
    node.value = sum;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7WXcZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var node = this, current, next = [
            node
        ], children, i, n;
        do {
            current = next.reverse(), next = [];
            while(node = current.pop()){
                callback(node), children = node.children;
                if (children) for(i = 0, n = children.length; i < n; ++i)next.push(children[i]);
            }
        }while (next.length);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bmq4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var node = this, nodes = [
            node
        ], children, i;
        while(node = nodes.pop()){
            callback(node), children = node.children;
            if (children) for(i = children.length - 1; i >= 0; --i)nodes.push(children[i]);
        }
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cZjeZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(callback) {
        var node = this, nodes = [
            node
        ], next = [], children, i, n;
        while(node = nodes.pop()){
            next.push(node), children = node.children;
            if (children) for(i = 0, n = children.length; i < n; ++i)nodes.push(children[i]);
        }
        while(node = next.pop())callback(node);
        return this;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cuXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(value) {
        return this.eachAfter(function(node) {
            var sum = +value(node.data) || 0, children = node.children, i = children && children.length;
            while(--i >= 0)sum += children[i].value;
            node.value = sum;
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cxiV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(compare) {
        return this.eachBefore(function(node) {
            if (node.children) node.children.sort(compare);
        });
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wQhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(end) {
        var start = this, ancestor = leastCommonAncestor(start, end), nodes = [
            start
        ];
        while(start !== ancestor){
            start = start.parent;
            nodes.push(start);
        }
        var k = nodes.length;
        while(end !== ancestor){
            nodes.splice(k, 0, end);
            end = end.parent;
        }
        return nodes;
    });
function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(), bNodes = b.ancestors(), c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while(a === b){
        c = a;
        a = aNodes.pop();
        b = bNodes.pop();
    }
    return c;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdyH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var node = this, nodes = [
            node
        ];
        while(node = node.parent)nodes.push(node);
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcRrI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var nodes = [];
        this.each(function(node) {
            nodes.push(node);
        });
        return nodes;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hi2Ek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var leaves = [];
        this.eachBefore(function(node) {
            if (!node.children) leaves.push(node);
        });
        return leaves;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"koCGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var root = this, links = [];
        root.each(function(node) {
            if (node !== root) links.push({
                source: node.parent,
                target: node
            });
        });
        return links;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5J3V4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var radius = null, dx = 1, dy = 1, padding = (0, _constantJs.constantZero);
        function pack(root) {
            root.x = dx / 2, root.y = dy / 2;
            if (radius) root.eachBefore(radiusLeaf(radius)).eachAfter(packChildren(padding, 0.5)).eachBefore(translateChild(1));
            else root.eachBefore(radiusLeaf(defaultRadius)).eachAfter(packChildren((0, _constantJs.constantZero), 1)).eachAfter(packChildren(padding, root.r / Math.min(dx, dy))).eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
            return root;
        }
        pack.radius = function(x) {
            return arguments.length ? (radius = (0, _accessorsJs.optional)(x), pack) : radius;
        };
        pack.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [
                dx,
                dy
            ];
        };
        pack.padding = function(x) {
            return arguments.length ? (padding = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), pack) : padding;
        };
        return pack;
    });
var _siblingsJs = require("./siblings.js");
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
function defaultRadius(d) {
    return Math.sqrt(d.value);
}
function radiusLeaf(radius) {
    return function(node) {
        if (!node.children) node.r = Math.max(0, +radius(node) || 0);
    };
}
function packChildren(padding, k) {
    return function(node) {
        if (children = node.children) {
            var children, i, n = children.length, r = padding(node) * k || 0, e;
            if (r) for(i = 0; i < n; ++i)children[i].r += r;
            e = (0, _siblingsJs.packEnclose)(children);
            if (r) for(i = 0; i < n; ++i)children[i].r -= r;
            node.r = e + r;
        }
    };
}
function translateChild(k) {
    return function(node) {
        var parent = node.parent;
        node.r *= k;
        if (parent) {
            node.x = parent.x + k * node.x;
            node.y = parent.y + k * node.y;
        }
    };
}

},{"./siblings.js":"gORqP","../accessors.js":"ly2Ie","../constant.js":"jF1ly","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gORqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "packEnclose", ()=>packEnclose);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        packEnclose(circles);
        return circles;
    });
var _encloseJs = require("./enclose.js");
var _encloseJsDefault = parcelHelpers.interopDefault(_encloseJs);
function place(b, a, c) {
    var dx = b.x - a.x, x, a2, dy = b.y - a.y, y, b2, d2 = dx * dx + dy * dy;
    if (d2) {
        a2 = a.r + c.r, a2 *= a2;
        b2 = b.r + c.r, b2 *= b2;
        if (a2 > b2) {
            x = (d2 + b2 - a2) / (2 * d2);
            y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
            c.x = b.x - x * dx - y * dy;
            c.y = b.y - x * dy + y * dx;
        } else {
            x = (d2 + a2 - b2) / (2 * d2);
            y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
            c.x = a.x + x * dx - y * dy;
            c.y = a.y + x * dy + y * dx;
        }
    } else {
        c.x = a.x + c.r;
        c.y = a.y;
    }
}
function intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function score(node) {
    var a = node._, b = node.next._, ab = a.r + b.r, dx = (a.x * b.r + b.x * a.r) / ab, dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
}
function Node(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
}
function packEnclose(circles) {
    if (!(n = circles.length)) return 0;
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
    // Place the third circle.
    place(b, a, c = circles[2]);
    // Initialize the front-chain using the first three circles a, b and c.
    a = new Node(a), b = new Node(b), c = new Node(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
    // Attempt to place each remaining circle…
    pack: for(i = 3; i < n; ++i){
        place(a._, b._, c = circles[i]), c = new Node(c);
        // Find the closest intersecting circle on the front-chain, if any.
        // “Closeness” is determined by linear distance along the front-chain.
        // “Ahead” or “behind” is likewise determined by linear distance.
        j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
        do if (sj <= sk) {
            if (intersects(j._, c._)) {
                b = j, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sj += j._.r, j = j.next;
        } else {
            if (intersects(k._, c._)) {
                a = k, a.next = b, b.previous = a, --i;
                continue pack;
            }
            sk += k._.r, k = k.previous;
        }
        while (j !== k.next);
        // Success! Insert the new circle c between a and b.
        c.previous = a, c.next = b, a.next = b.previous = b = c;
        // Compute the new closest circle pair to the centroid.
        aa = score(a);
        while((c = c.next) !== b)if ((ca = score(c)) < aa) a = c, aa = ca;
        b = a.next;
    }
    // Compute the enclosing circle of the front chain.
    a = [
        b._
    ], c = b;
    while((c = c.next) !== b)a.push(c._);
    c = (0, _encloseJsDefault.default)(a);
    // Translate the circles to put the enclosing circle around the origin.
    for(i = 0; i < n; ++i)a = circles[i], a.x -= c.x, a.y -= c.y;
    return c.r;
}

},{"./enclose.js":"4MtLA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4MtLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(circles) {
        var i = 0, n = (circles = (0, _arrayJs.shuffle)((0, _arrayJs.slice).call(circles))).length, B = [], p, e;
        while(i < n){
            p = circles[i];
            if (e && enclosesWeak(e, p)) ++i;
            else e = encloseBasis(B = extendBasis(B, p)), i = 0;
        }
        return e;
    });
var _arrayJs = require("../array.js");
function extendBasis(B, p) {
    var i, j;
    if (enclosesWeakAll(p, B)) return [
        p
    ];
    // If we get here then B must have at least one element.
    for(i = 0; i < B.length; ++i){
        if (enclosesNot(p, B[i]) && enclosesWeakAll(encloseBasis2(B[i], p), B)) return [
            B[i],
            p
        ];
    }
    // If we get here then B must have at least two elements.
    for(i = 0; i < B.length - 1; ++i)for(j = i + 1; j < B.length; ++j){
        if (enclosesNot(encloseBasis2(B[i], B[j]), p) && enclosesNot(encloseBasis2(B[i], p), B[j]) && enclosesNot(encloseBasis2(B[j], p), B[i]) && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) return [
            B[i],
            B[j],
            p
        ];
    }
    // If we get here then something is very wrong.
    throw new Error;
}
function enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
}
function enclosesWeak(a, b) {
    var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
}
function enclosesWeakAll(a, B) {
    for(var i = 0; i < B.length; ++i){
        if (!enclosesWeak(a, B[i])) return false;
    }
    return true;
}
function encloseBasis(B) {
    switch(B.length){
        case 1:
            return encloseBasis1(B[0]);
        case 2:
            return encloseBasis2(B[0], B[1]);
        case 3:
            return encloseBasis3(B[0], B[1], B[2]);
    }
}
function encloseBasis1(a) {
    return {
        x: a.x,
        y: a.y,
        r: a.r
    };
}
function encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1, l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
        x: (x1 + x2 + x21 / l * r21) / 2,
        y: (y1 + y2 + y21 / l * r21) / 2,
        r: (l + r1 + r2) / 2
    };
}
function encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r, x2 = b.x, y2 = b.y, r2 = b.r, x3 = c.x, y3 = c.y, r3 = c.r, a2 = x1 - x2, a3 = x1 - x3, b2 = y1 - y2, b3 = y1 - y3, c2 = r2 - r1, c3 = r3 - r1, d1 = x1 * x1 + y1 * y1 - r1 * r1, d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2, d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3, ab = a3 * b2 - a2 * b3, xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1, xb = (b3 * c2 - b2 * c3) / ab, ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1, yb = (a2 * c3 - a3 * c2) / ab, A = xb * xb + yb * yb - 1, B = 2 * (r1 + xa * xb + ya * yb), C = xa * xa + ya * ya - r1 * r1, r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
        x: x1 + xa + xb * r,
        y: y1 + ya + yb * r,
        r: r
    };
}

},{"../array.js":"7o1RV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7o1RV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
var slice = Array.prototype.slice;
function shuffle(array) {
    var m = array.length, t, i;
    while(m){
        i = Math.random() * m-- | 0;
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ly2Ie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optional", ()=>optional);
parcelHelpers.export(exports, "required", ()=>required);
function optional(f) {
    return f == null ? null : required(f);
}
function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jF1ly":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "constantZero", ()=>constantZero);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });
function constantZero() {
    return 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4iNvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var dx = 1, dy = 1, padding = 0, round = false;
        function partition(root) {
            var n = root.height + 1;
            root.x0 = root.y0 = padding;
            root.x1 = dx;
            root.y1 = dy / n;
            root.eachBefore(positionNode(dy, n));
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(dy, n) {
            return function(node) {
                if (node.children) (0, _diceJsDefault.default)(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
                var x0 = node.x0, y0 = node.y0, x1 = node.x1 - padding, y1 = node.y1 - padding;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                node.x0 = x0;
                node.y0 = y0;
                node.x1 = x1;
                node.y1 = y1;
            };
        }
        partition.round = function(x) {
            return arguments.length ? (round = !!x, partition) : round;
        };
        partition.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [
                dx,
                dy
            ];
        };
        partition.padding = function(x) {
            return arguments.length ? (padding = +x, partition) : padding;
        };
        return partition;
    });
var _roundJs = require("./treemap/round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _diceJs = require("./treemap/dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);

},{"./treemap/round.js":"4p2rf","./treemap/dice.js":"9U0kv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4p2rf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(node) {
        node.x0 = Math.round(node.x0);
        node.y0 = Math.round(node.y0);
        node.x1 = Math.round(node.x1);
        node.y1 = Math.round(node.y1);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9U0kv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (x1 - x0) / parent.value;
        while(++i < n){
            node = nodes[i], node.y0 = y0, node.y1 = y1;
            node.x0 = x0, node.x1 = x0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32r3u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var id = defaultId, parentId = defaultParentId;
        function stratify(data) {
            var d, i, n = data.length, root, parent, node, nodes = new Array(n), nodeId, nodeKey, nodeByKey = {};
            for(i = 0; i < n; ++i){
                d = data[i], node = nodes[i] = new (0, _indexJs.Node)(d);
                if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
                    nodeKey = keyPrefix + (node.id = nodeId);
                    nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
                }
            }
            for(i = 0; i < n; ++i){
                node = nodes[i], nodeId = parentId(data[i], i, data);
                if (nodeId == null || !(nodeId += "")) {
                    if (root) throw new Error("multiple roots");
                    root = node;
                } else {
                    parent = nodeByKey[keyPrefix + nodeId];
                    if (!parent) throw new Error("missing: " + nodeId);
                    if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
                    if (parent.children) parent.children.push(node);
                    else parent.children = [
                        node
                    ];
                    node.parent = parent;
                }
            }
            if (!root) throw new Error("no root");
            root.parent = preroot;
            root.eachBefore(function(node) {
                node.depth = node.parent.depth + 1;
                --n;
            }).eachBefore((0, _indexJs.computeHeight));
            root.parent = null;
            if (n > 0) throw new Error("cycle");
            return root;
        }
        stratify.id = function(x) {
            return arguments.length ? (id = (0, _accessorsJs.required)(x), stratify) : id;
        };
        stratify.parentId = function(x) {
            return arguments.length ? (parentId = (0, _accessorsJs.required)(x), stratify) : parentId;
        };
        return stratify;
    });
var _accessorsJs = require("./accessors.js");
var _indexJs = require("./hierarchy/index.js");
var keyPrefix = "$", preroot = {
    depth: -1
}, ambiguous = {};
function defaultId(d) {
    return d.id;
}
function defaultParentId(d) {
    return d.parentId;
}

},{"./accessors.js":"ly2Ie","./hierarchy/index.js":"1kLlO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e7DRS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
parcelHelpers.export(exports, "default", ()=>function() {
        var separation = defaultSeparation, dx = 1, dy = 1, nodeSize = null;
        function tree(root) {
            var t = treeRoot(root);
            // Compute the layout using Buchheim et al.’s algorithm.
            t.eachAfter(firstWalk), t.parent.m = -t.z;
            t.eachBefore(secondWalk);
            // If a fixed node size is specified, scale x and y.
            if (nodeSize) root.eachBefore(sizeNode);
            else {
                var left = root, right = root, bottom = root;
                root.eachBefore(function(node) {
                    if (node.x < left.x) left = node;
                    if (node.x > right.x) right = node;
                    if (node.depth > bottom.depth) bottom = node;
                });
                var s = left === right ? 1 : separation(left, right) / 2, tx = s - left.x, kx = dx / (right.x + s + tx), ky = dy / (bottom.depth || 1);
                root.eachBefore(function(node) {
                    node.x = (node.x + tx) * kx;
                    node.y = node.depth * ky;
                });
            }
            return root;
        }
        // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
        // applied recursively to the children of v, as well as the function
        // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
        // node v is placed to the midpoint of its outermost children.
        function firstWalk(v) {
            var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
            if (children) {
                executeShifts(v);
                var midpoint = (children[0].z + children[children.length - 1].z) / 2;
                if (w) {
                    v.z = w.z + separation(v._, w._);
                    v.m = v.z - midpoint;
                } else v.z = midpoint;
            } else if (w) v.z = w.z + separation(v._, w._);
            v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
        }
        // Computes all real x-coordinates by summing up the modifiers recursively.
        function secondWalk(v) {
            v._.x = v.z + v.parent.m;
            v.m += v.parent.m;
        }
        // The core of the algorithm. Here, a new subtree is combined with the
        // previous subtrees. Threads are used to traverse the inside and outside
        // contours of the left and right subtree up to the highest common level. The
        // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
        // superscript o means outside and i means inside, the subscript - means left
        // subtree and + means right subtree. For summing up the modifiers along the
        // contour, we use respective variables si+, si-, so-, and so+. Whenever two
        // nodes of the inside contours conflict, we compute the left one of the
        // greatest uncommon ancestors using the function ANCESTOR and call MOVE
        // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
        // Finally, we add a new thread (if necessary).
        function apportion(v, w, ancestor) {
            if (w) {
                var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
                while(vim = nextRight(vim), vip = nextLeft(vip), vim && vip){
                    vom = nextLeft(vom);
                    vop = nextRight(vop);
                    vop.a = v;
                    shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
                    if (shift > 0) {
                        moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
                        sip += shift;
                        sop += shift;
                    }
                    sim += vim.m;
                    sip += vip.m;
                    som += vom.m;
                    sop += vop.m;
                }
                if (vim && !nextRight(vop)) {
                    vop.t = vim;
                    vop.m += sim - sop;
                }
                if (vip && !nextLeft(vom)) {
                    vom.t = vip;
                    vom.m += sip - som;
                    ancestor = v;
                }
            }
            return ancestor;
        }
        function sizeNode(node) {
            node.x *= dx;
            node.y = node.depth * dy;
        }
        tree.separation = function(x) {
            return arguments.length ? (separation = x, tree) : separation;
        };
        tree.size = function(x) {
            return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : nodeSize ? null : [
                dx,
                dy
            ];
        };
        tree.nodeSize = function(x) {
            return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : nodeSize ? [
                dx,
                dy
            ] : null;
        };
        return tree;
    });
var _indexJs = require("./hierarchy/index.js");
function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
}
// function radialSeparation(a, b) {
//   return (a.parent === b.parent ? 1 : 2) / a.depth;
// }
// This function is used to traverse the left contour of a subtree (or
// subforest). It returns the successor of v on this contour. This successor is
// either given by the leftmost child of v or by the thread of v. The function
// returns null if and only if v is on the highest level of its subtree.
function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
}
// This function works analogously to nextLeft.
function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
}
// Shifts the current subtree rooted at w+. This is done by increasing
// prelim(w+) and mod(w+) by shift.
function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
}
// All other shifts, applied to the smaller subtrees between w- and w+, are
// performed by this function. To prepare the shifts, we have to adjust
// change(w+), shift(w+), and change(w-).
function executeShifts(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while(--i >= 0){
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
    }
}
// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
// returns the specified (default) ancestor.
function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
}
function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
}
TreeNode.prototype = Object.create((0, _indexJs.Node).prototype);
function treeRoot(root) {
    var tree = new TreeNode(root, 0), node, nodes = [
        tree
    ], child, children, i, n;
    while(node = nodes.pop())if (children = node._.children) {
        node.children = new Array(n = children.length);
        for(i = n - 1; i >= 0; --i){
            nodes.push(child = node.children[i] = new TreeNode(children[i], i));
            child.parent = node;
        }
    }
    (tree.parent = new TreeNode(null, 0)).children = [
        tree
    ];
    return tree;
}

},{"./hierarchy/index.js":"1kLlO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e5q11":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var tile = (0, _squarifyJsDefault.default), round = false, dx = 1, dy = 1, paddingStack = [
            0
        ], paddingInner = (0, _constantJs.constantZero), paddingTop = (0, _constantJs.constantZero), paddingRight = (0, _constantJs.constantZero), paddingBottom = (0, _constantJs.constantZero), paddingLeft = (0, _constantJs.constantZero);
        function treemap(root) {
            root.x0 = root.y0 = 0;
            root.x1 = dx;
            root.y1 = dy;
            root.eachBefore(positionNode);
            paddingStack = [
                0
            ];
            if (round) root.eachBefore((0, _roundJsDefault.default));
            return root;
        }
        function positionNode(node) {
            var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
            if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
            if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
            node.x0 = x0;
            node.y0 = y0;
            node.x1 = x1;
            node.y1 = y1;
            if (node.children) {
                p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
                x0 += paddingLeft(node) - p;
                y0 += paddingTop(node) - p;
                x1 -= paddingRight(node) - p;
                y1 -= paddingBottom(node) - p;
                if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
                if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
                tile(node, x0, y0, x1, y1);
            }
        }
        treemap.round = function(x) {
            return arguments.length ? (round = !!x, treemap) : round;
        };
        treemap.size = function(x) {
            return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [
                dx,
                dy
            ];
        };
        treemap.tile = function(x) {
            return arguments.length ? (tile = (0, _accessorsJs.required)(x), treemap) : tile;
        };
        treemap.padding = function(x) {
            return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
        };
        treemap.paddingInner = function(x) {
            return arguments.length ? (paddingInner = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingInner;
        };
        treemap.paddingOuter = function(x) {
            return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
        };
        treemap.paddingTop = function(x) {
            return arguments.length ? (paddingTop = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingTop;
        };
        treemap.paddingRight = function(x) {
            return arguments.length ? (paddingRight = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingRight;
        };
        treemap.paddingBottom = function(x) {
            return arguments.length ? (paddingBottom = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingBottom;
        };
        treemap.paddingLeft = function(x) {
            return arguments.length ? (paddingLeft = typeof x === "function" ? x : (0, _constantJsDefault.default)(+x), treemap) : paddingLeft;
        };
        return treemap;
    });
var _roundJs = require("./round.js");
var _roundJsDefault = parcelHelpers.interopDefault(_roundJs);
var _squarifyJs = require("./squarify.js");
var _squarifyJsDefault = parcelHelpers.interopDefault(_squarifyJs);
var _accessorsJs = require("../accessors.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);

},{"./round.js":"4p2rf","./squarify.js":"8lg5l","../accessors.js":"ly2Ie","../constant.js":"jF1ly","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lg5l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "phi", ()=>phi);
parcelHelpers.export(exports, "squarifyRatio", ()=>squarifyRatio);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
    while(i0 < n){
        dx = x1 - x0, dy = y1 - y0;
        // Find the next non-empty node.
        do sumValue = nodes[i1++].value;
        while (!sumValue && i1 < n);
        minValue = maxValue = sumValue;
        alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
        beta = sumValue * sumValue * alpha;
        minRatio = Math.max(maxValue / beta, beta / minValue);
        // Keep adding nodes while the aspect ratio maintains or improves.
        for(; i1 < n; ++i1){
            sumValue += nodeValue = nodes[i1].value;
            if (nodeValue < minValue) minValue = nodeValue;
            if (nodeValue > maxValue) maxValue = nodeValue;
            beta = sumValue * sumValue * alpha;
            newRatio = Math.max(maxValue / beta, beta / minValue);
            if (newRatio > minRatio) {
                sumValue -= nodeValue;
                break;
            }
            minRatio = newRatio;
        }
        // Position and record the row orientation.
        rows.push(row = {
            value: sumValue,
            dice: dx < dy,
            children: nodes.slice(i0, i1)
        });
        if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
        else (0, _sliceJsDefault.default)(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
        value -= sumValue, i0 = i1;
    }
    return rows;
}
exports.default = function custom(ratio) {
    function squarify(parent, x0, y0, x1, y1) {
        squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
    squarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return squarify;
}(phi);

},{"./dice.js":"9U0kv","./slice.js":"iPXtV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPXtV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, node, i = -1, n = nodes.length, k = parent.value && (y1 - y0) / parent.value;
        while(++i < n){
            node = nodes[i], node.x0 = x0, node.x1 = x1;
            node.y0 = y0, node.y1 = y0 += node.value * k;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"93Bqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        var nodes = parent.children, i, n = nodes.length, sum, sums = new Array(n + 1);
        for(sums[0] = sum = i = 0; i < n; ++i)sums[i + 1] = sum += nodes[i].value;
        partition(0, n, parent.value, x0, y0, x1, y1);
        function partition(i, j, value, x0, y0, x1, y1) {
            if (i >= j - 1) {
                var node = nodes[i];
                node.x0 = x0, node.y0 = y0;
                node.x1 = x1, node.y1 = y1;
                return;
            }
            var valueOffset = sums[i], valueTarget = value / 2 + valueOffset, k = i + 1, hi = j - 1;
            while(k < hi){
                var mid = k + hi >>> 1;
                if (sums[mid] < valueTarget) k = mid + 1;
                else hi = mid;
            }
            if (valueTarget - sums[k - 1] < sums[k] - valueTarget && i + 1 < k) --k;
            var valueLeft = sums[k] - valueOffset, valueRight = value - valueLeft;
            if (x1 - x0 > y1 - y0) {
                var xk = (x0 * valueRight + x1 * valueLeft) / value;
                partition(i, k, valueLeft, x0, y0, xk, y1);
                partition(k, j, valueRight, xk, y0, x1, y1);
            } else {
                var yk = (y0 * valueRight + y1 * valueLeft) / value;
                partition(i, k, valueLeft, x0, y0, x1, yk);
                partition(k, j, valueRight, x0, yk, x1, y1);
            }
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nypX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(parent, x0, y0, x1, y1) {
        (parent.depth & 1 ? (0, _sliceJsDefault.default) : (0, _diceJsDefault.default))(parent, x0, y0, x1, y1);
    });
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);

},{"./dice.js":"9U0kv","./slice.js":"iPXtV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dz45X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _diceJs = require("./dice.js");
var _diceJsDefault = parcelHelpers.interopDefault(_diceJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _squarifyJs = require("./squarify.js");
exports.default = function custom(ratio) {
    function resquarify(parent, x0, y0, x1, y1) {
        if ((rows = parent._squarify) && rows.ratio === ratio) {
            var rows, row, nodes, i, j = -1, n, m = rows.length, value = parent.value;
            while(++j < m){
                row = rows[j], nodes = row.children;
                for(i = row.value = 0, n = nodes.length; i < n; ++i)row.value += nodes[i].value;
                if (row.dice) (0, _diceJsDefault.default)(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
                else (0, _sliceJsDefault.default)(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
                value -= row.value;
            }
        } else {
            parent._squarify = rows = (0, _squarifyJs.squarifyRatio)(ratio, parent, x0, y0, x1, y1);
            rows.ratio = ratio;
        }
    }
    resquarify.ratio = function(x) {
        return custom((x = +x) > 1 ? x : 1);
    };
    return resquarify;
}((0, _squarifyJs.phi));

},{"./dice.js":"9U0kv","./slice.js":"iPXtV","./squarify.js":"8lg5l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e5TI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polygonArea", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "polygonCentroid", ()=>(0, _centroidJsDefault.default));
parcelHelpers.export(exports, "polygonHull", ()=>(0, _hullJsDefault.default));
parcelHelpers.export(exports, "polygonContains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "polygonLength", ()=>(0, _lengthJsDefault.default));
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _centroidJs = require("./centroid.js");
var _centroidJsDefault = parcelHelpers.interopDefault(_centroidJs);
var _hullJs = require("./hull.js");
var _hullJsDefault = parcelHelpers.interopDefault(_hullJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);

},{"./area.js":"c5eKj","./centroid.js":"4ri0v","./hull.js":"gAq6K","./contains.js":"fwWVy","./length.js":"dDLFj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5eKj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, a, b = polygon[n - 1], area = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            area += a[1] * b[0] - a[0] * b[1];
        }
        return area / 2;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ri0v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, x = 0, y = 0, a, b = polygon[n - 1], c, k = 0;
        while(++i < n){
            a = b;
            b = polygon[i];
            k += c = a[0] * b[1] - b[0] * a[1];
            x += (a[0] + b[0]) * c;
            y += (a[1] + b[1]) * c;
        }
        return k *= 3, [
            x / k,
            y / k
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAq6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(points) {
        if ((n = points.length) < 3) return null;
        var i, n, sortedPoints = new Array(n), flippedPoints = new Array(n);
        for(i = 0; i < n; ++i)sortedPoints[i] = [
            +points[i][0],
            +points[i][1],
            i
        ];
        sortedPoints.sort(lexicographicOrder);
        for(i = 0; i < n; ++i)flippedPoints[i] = [
            sortedPoints[i][0],
            -sortedPoints[i][1]
        ];
        var upperIndexes = computeUpperHullIndexes(sortedPoints), lowerIndexes = computeUpperHullIndexes(flippedPoints);
        // Construct the hull polygon, removing possible duplicate endpoints.
        var skipLeft = lowerIndexes[0] === upperIndexes[0], skipRight = lowerIndexes[lowerIndexes.length - 1] === upperIndexes[upperIndexes.length - 1], hull = [];
        // Add upper hull in right-to-l order.
        // Then add lower hull in left-to-right order.
        for(i = upperIndexes.length - 1; i >= 0; --i)hull.push(points[sortedPoints[upperIndexes[i]][2]]);
        for(i = +skipLeft; i < lowerIndexes.length - skipRight; ++i)hull.push(points[sortedPoints[lowerIndexes[i]][2]]);
        return hull;
    });
var _crossJs = require("./cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
function lexicographicOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
}
// Computes the upper convex hull per the monotone chain algorithm.
// Assumes points.length >= 3, is sorted by x, unique in y.
// Returns an array of indices into points in left-to-right order.
function computeUpperHullIndexes(points) {
    var n = points.length, indexes = [
        0,
        1
    ], size = 2;
    for(var i = 2; i < n; ++i){
        while(size > 1 && (0, _crossJsDefault.default)(points[indexes[size - 2]], points[indexes[size - 1]], points[i]) <= 0)--size;
        indexes[size++] = i;
    }
    return indexes.slice(0, size); // remove popped points
}

},{"./cross.js":"el7lZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"el7lZ":[function(require,module,exports,__globalThis) {
// Returns the 2D cross product of AB and AC vectors, i.e., the z-component of
// the 3D cross product in a quadrant I Cartesian coordinate system (+x is
// right, +y is up). Returns a positive value if ABC is counter-clockwise,
// negative if clockwise, and zero if the points are collinear.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b, c) {
        return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fwWVy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon, point) {
        var n = polygon.length, p = polygon[n - 1], x = point[0], y = point[1], x0 = p[0], y0 = p[1], x1, y1, inside = false;
        for(var i = 0; i < n; ++i){
            p = polygon[i], x1 = p[0], y1 = p[1];
            if (y1 > y !== y0 > y && x < (x0 - x1) * (y - y1) / (y0 - y1) + x1) inside = !inside;
            x0 = x1, y0 = y1;
        }
        return inside;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dDLFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(polygon) {
        var i = -1, n = polygon.length, b = polygon[n - 1], xa, ya, xb = b[0], yb = b[1], perimeter = 0;
        while(++i < n){
            xa = xb;
            ya = yb;
            b = polygon[i];
            xb = b[0];
            yb = b[1];
            xa -= xb;
            ya -= yb;
            perimeter += Math.sqrt(xa * xa + ya * ya);
        }
        return perimeter;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4hcGu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "randomUniform", ()=>(0, _uniformDefault.default));
parcelHelpers.export(exports, "randomNormal", ()=>(0, _normalDefault.default));
parcelHelpers.export(exports, "randomLogNormal", ()=>(0, _logNormalDefault.default));
parcelHelpers.export(exports, "randomBates", ()=>(0, _batesDefault.default));
parcelHelpers.export(exports, "randomIrwinHall", ()=>(0, _irwinHallDefault.default));
parcelHelpers.export(exports, "randomExponential", ()=>(0, _exponentialDefault.default));
var _uniform = require("./uniform");
var _uniformDefault = parcelHelpers.interopDefault(_uniform);
var _normal = require("./normal");
var _normalDefault = parcelHelpers.interopDefault(_normal);
var _logNormal = require("./logNormal");
var _logNormalDefault = parcelHelpers.interopDefault(_logNormal);
var _bates = require("./bates");
var _batesDefault = parcelHelpers.interopDefault(_bates);
var _irwinHall = require("./irwinHall");
var _irwinHallDefault = parcelHelpers.interopDefault(_irwinHall);
var _exponential = require("./exponential");
var _exponentialDefault = parcelHelpers.interopDefault(_exponential);

},{"./uniform":"dQgvT","./normal":"hiccp","./logNormal":"68TAU","./bates":"27u5F","./irwinHall":"hZ1mH","./exponential":"aL3g0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dQgvT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSource = require("./defaultSource");
var _defaultSourceDefault = parcelHelpers.interopDefault(_defaultSource);
exports.default = function sourceRandomUniform(source) {
    function randomUniform(min, max) {
        min = min == null ? 0 : +min;
        max = max == null ? 1 : +max;
        if (arguments.length === 1) max = min, min = 0;
        else max -= min;
        return function() {
            return source() * max + min;
        };
    }
    randomUniform.source = sourceRandomUniform;
    return randomUniform;
}((0, _defaultSourceDefault.default));

},{"./defaultSource":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"rc0WM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return Math.random();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hiccp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSource = require("./defaultSource");
var _defaultSourceDefault = parcelHelpers.interopDefault(_defaultSource);
exports.default = function sourceRandomNormal(source) {
    function randomNormal(mu, sigma) {
        var x, r;
        mu = mu == null ? 0 : +mu;
        sigma = sigma == null ? 1 : +sigma;
        return function() {
            var y;
            // If available, use the second previously-generated uniform random.
            if (x != null) y = x, x = null;
            else do {
                x = source() * 2 - 1;
                y = source() * 2 - 1;
                r = x * x + y * y;
            }while (!r || r > 1);
            return mu + sigma * y * Math.sqrt(-2 * Math.log(r) / r);
        };
    }
    randomNormal.source = sourceRandomNormal;
    return randomNormal;
}((0, _defaultSourceDefault.default));

},{"./defaultSource":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68TAU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSource = require("./defaultSource");
var _defaultSourceDefault = parcelHelpers.interopDefault(_defaultSource);
var _normal = require("./normal");
var _normalDefault = parcelHelpers.interopDefault(_normal);
exports.default = function sourceRandomLogNormal(source) {
    function randomLogNormal() {
        var randomNormal = (0, _normalDefault.default).source(source).apply(this, arguments);
        return function() {
            return Math.exp(randomNormal());
        };
    }
    randomLogNormal.source = sourceRandomLogNormal;
    return randomLogNormal;
}((0, _defaultSourceDefault.default));

},{"./defaultSource":"rc0WM","./normal":"hiccp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"27u5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSource = require("./defaultSource");
var _defaultSourceDefault = parcelHelpers.interopDefault(_defaultSource);
var _irwinHall = require("./irwinHall");
var _irwinHallDefault = parcelHelpers.interopDefault(_irwinHall);
exports.default = function sourceRandomBates(source) {
    function randomBates(n) {
        var randomIrwinHall = (0, _irwinHallDefault.default).source(source)(n);
        return function() {
            return randomIrwinHall() / n;
        };
    }
    randomBates.source = sourceRandomBates;
    return randomBates;
}((0, _defaultSourceDefault.default));

},{"./defaultSource":"rc0WM","./irwinHall":"hZ1mH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZ1mH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSource = require("./defaultSource");
var _defaultSourceDefault = parcelHelpers.interopDefault(_defaultSource);
exports.default = function sourceRandomIrwinHall(source) {
    function randomIrwinHall(n) {
        return function() {
            for(var sum = 0, i = 0; i < n; ++i)sum += source();
            return sum;
        };
    }
    randomIrwinHall.source = sourceRandomIrwinHall;
    return randomIrwinHall;
}((0, _defaultSourceDefault.default));

},{"./defaultSource":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aL3g0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultSource = require("./defaultSource");
var _defaultSourceDefault = parcelHelpers.interopDefault(_defaultSource);
exports.default = function sourceRandomExponential(source) {
    function randomExponential(lambda) {
        return function() {
            return -Math.log(1 - source()) / lambda;
        };
    }
    randomExponential.source = sourceRandomExponential;
    return randomExponential;
}((0, _defaultSourceDefault.default));

},{"./defaultSource":"rc0WM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8BE7D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scaleBand", ()=>(0, _bandDefault.default));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _band.point));
parcelHelpers.export(exports, "scaleIdentity", ()=>(0, _identityDefault.default));
parcelHelpers.export(exports, "scaleLinear", ()=>(0, _linearDefault.default));
parcelHelpers.export(exports, "scaleLog", ()=>(0, _logDefault.default));
parcelHelpers.export(exports, "scaleSymlog", ()=>(0, _symlogDefault.default));
parcelHelpers.export(exports, "scaleOrdinal", ()=>(0, _ordinalDefault.default));
parcelHelpers.export(exports, "scaleImplicit", ()=>(0, _ordinal.implicit));
parcelHelpers.export(exports, "scalePow", ()=>(0, _powDefault.default));
parcelHelpers.export(exports, "scaleSqrt", ()=>(0, _pow.sqrt));
parcelHelpers.export(exports, "scaleQuantile", ()=>(0, _quantileDefault.default));
parcelHelpers.export(exports, "scaleQuantize", ()=>(0, _quantizeDefault.default));
parcelHelpers.export(exports, "scaleThreshold", ()=>(0, _thresholdDefault.default));
parcelHelpers.export(exports, "scaleTime", ()=>(0, _timeDefault.default));
parcelHelpers.export(exports, "scaleUtc", ()=>(0, _utcTimeDefault.default));
parcelHelpers.export(exports, "scaleSequential", ()=>(0, _sequentialDefault.default));
parcelHelpers.export(exports, "scaleSequentialLog", ()=>(0, _sequential.sequentialLog));
parcelHelpers.export(exports, "scaleSequentialPow", ()=>(0, _sequential.sequentialPow));
parcelHelpers.export(exports, "scaleSequentialSqrt", ()=>(0, _sequential.sequentialSqrt));
parcelHelpers.export(exports, "scaleSequentialSymlog", ()=>(0, _sequential.sequentialSymlog));
parcelHelpers.export(exports, "scaleSequentialQuantile", ()=>(0, _sequentialQuantileDefault.default));
parcelHelpers.export(exports, "scaleDiverging", ()=>(0, _divergingDefault.default));
parcelHelpers.export(exports, "scaleDivergingLog", ()=>(0, _diverging.divergingLog));
parcelHelpers.export(exports, "scaleDivergingPow", ()=>(0, _diverging.divergingPow));
parcelHelpers.export(exports, "scaleDivergingSqrt", ()=>(0, _diverging.divergingSqrt));
parcelHelpers.export(exports, "scaleDivergingSymlog", ()=>(0, _diverging.divergingSymlog));
parcelHelpers.export(exports, "tickFormat", ()=>(0, _tickFormatDefault.default));
var _band = require("./band");
var _bandDefault = parcelHelpers.interopDefault(_band);
var _identity = require("./identity");
var _identityDefault = parcelHelpers.interopDefault(_identity);
var _linear = require("./linear");
var _linearDefault = parcelHelpers.interopDefault(_linear);
var _log = require("./log");
var _logDefault = parcelHelpers.interopDefault(_log);
var _symlog = require("./symlog");
var _symlogDefault = parcelHelpers.interopDefault(_symlog);
var _ordinal = require("./ordinal");
var _ordinalDefault = parcelHelpers.interopDefault(_ordinal);
var _pow = require("./pow");
var _powDefault = parcelHelpers.interopDefault(_pow);
var _quantile = require("./quantile");
var _quantileDefault = parcelHelpers.interopDefault(_quantile);
var _quantize = require("./quantize");
var _quantizeDefault = parcelHelpers.interopDefault(_quantize);
var _threshold = require("./threshold");
var _thresholdDefault = parcelHelpers.interopDefault(_threshold);
var _time = require("./time");
var _timeDefault = parcelHelpers.interopDefault(_time);
var _utcTime = require("./utcTime");
var _utcTimeDefault = parcelHelpers.interopDefault(_utcTime);
var _sequential = require("./sequential");
var _sequentialDefault = parcelHelpers.interopDefault(_sequential);
var _sequentialQuantile = require("./sequentialQuantile");
var _sequentialQuantileDefault = parcelHelpers.interopDefault(_sequentialQuantile);
var _diverging = require("./diverging");
var _divergingDefault = parcelHelpers.interopDefault(_diverging);
var _tickFormat = require("./tickFormat");
var _tickFormatDefault = parcelHelpers.interopDefault(_tickFormat);

},{"./band":"bNEFi","./identity":"8Lo1M","./linear":"c7lPL","./log":"jzsSJ","./symlog":"k6LKH","./ordinal":"ekwn9","./pow":"8uRFM","./quantile":"fRuUt","./quantize":"49qXX","./threshold":"dqjBZ","./time":"5wvQp","./utcTime":"dAkX6","./sequential":"d5bJE","./sequentialQuantile":"6H4Zg","./diverging":"6LSy6","./tickFormat":"bBGVj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNEFi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>band);
parcelHelpers.export(exports, "point", ()=>point);
var _d3Array = require("d3-array");
var _init = require("./init");
var _ordinal = require("./ordinal");
var _ordinalDefault = parcelHelpers.interopDefault(_ordinal);
function band() {
    var scale = (0, _ordinalDefault.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, range = [
        0,
        1
    ], step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = range[1] < range[0], start = range[reverse - 0], stop = range[1 - reverse];
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _d3Array.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? (range = [
            +_[0],
            +_[1]
        ], rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = [
            +_[0],
            +_[1]
        ], round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), range).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, _init.initRange).apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"d3-array":"aoYKF","./init":"2454B","./ordinal":"ekwn9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2454B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initRange", ()=>initRange);
parcelHelpers.export(exports, "initInterpolator", ()=>initInterpolator);
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.interpolator(domain);
            break;
        default:
            this.interpolator(interpolator).domain(domain);
            break;
    }
    return this;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ekwn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicit", ()=>implicit);
parcelHelpers.export(exports, "default", ()=>ordinal);
var _d3Collection = require("d3-collection");
var _array = require("./array");
var _init = require("./init");
var implicit = {
    name: "implicit"
};
function ordinal() {
    var index = (0, _d3Collection.map)(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        var key = d + "", i = index.get(key);
        if (!i) {
            if (unknown !== implicit) return unknown;
            index.set(key, i = domain.push(d));
        }
        return range[(i - 1) % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = (0, _d3Collection.map)();
        var i = -1, n = _.length, d, key;
        while(++i < n)if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    (0, _init.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-collection":"c1YdX","./array":"6m1My","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6m1My":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "slice", ()=>slice);
var array = Array.prototype;
var map = array.map;
var slice = array.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Lo1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>identity);
var _array = require("./array");
var _linear = require("./linear");
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
function identity(domain) {
    var unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = (0, _array.map).call(_, (0, _numberDefault.default)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? (0, _array.map).call(domain, (0, _numberDefault.default)) : [
        0,
        1
    ];
    return (0, _linear.linearish)(scale);
}

},{"./array":"6m1My","./linear":"c7lPL","./number":"6Bdiz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c7lPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linearish", ()=>linearish);
parcelHelpers.export(exports, "default", ()=>linear);
var _d3Array = require("d3-array");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
var _init = require("./init");
var _tickFormat = require("./tickFormat");
var _tickFormatDefault = parcelHelpers.interopDefault(_tickFormat);
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _d3Array.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormatDefault.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain(), i0 = 0, i1 = d.length - 1, start = d[i0], stop = d[i1], step;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        step = (0, _d3Array.tickIncrement)(start, stop, count);
        if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
            step = (0, _d3Array.tickIncrement)(start, stop, count);
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
            step = (0, _d3Array.tickIncrement)(start, stop, count);
        }
        if (step > 0) {
            d[i0] = Math.floor(start / step) * step;
            d[i1] = Math.ceil(stop / step) * step;
            domain(d);
        } else if (step < 0) {
            d[i0] = Math.ceil(start * step) / step;
            d[i1] = Math.floor(stop * step) / step;
            domain(d);
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuousDefault.default)((0, _continuous.identity), (0, _continuous.identity));
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    (0, _init.initRange).apply(scale, arguments);
    return linearish(scale);
}

},{"d3-array":"aoYKF","./continuous":"6WTm8","./init":"2454B","./tickFormat":"bBGVj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6WTm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "transformer", ()=>transformer);
parcelHelpers.export(exports, "default", ()=>continuous);
var _d3Array = require("d3-array");
var _d3Interpolate = require("d3-interpolate");
var _array = require("./array");
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constantDefault.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(domain) {
    var a = domain[0], b = domain[domain.length - 1], t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _d3Array.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = (0, _d3Interpolate.interpolate), transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, _d3Interpolate.interpolateNumber))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, _array.map).call(_, (0, _numberDefault.default)), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = (0, _array.slice).call(_), interpolate = (0, _d3Interpolate.interpolateRound), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous(transform, untransform) {
    return transformer()(transform, untransform);
}

},{"d3-array":"aoYKF","d3-interpolate":"5gJW0","./array":"6m1My","./constant":"57TP9","./number":"6Bdiz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"57TP9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Bdiz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return +x;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bBGVj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(start, stop, count, specifier) {
        var step = (0, _d3Array.tickStep)(start, stop, count), precision;
        specifier = (0, _d3Format.formatSpecifier)(specifier == null ? ",f" : specifier);
        switch(specifier.type){
            case "s":
                var value = Math.max(Math.abs(start), Math.abs(stop));
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionPrefix)(step, value))) specifier.precision = precision;
                return (0, _d3Format.formatPrefix)(specifier, value);
            case "":
            case "e":
            case "g":
            case "p":
            case "r":
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
                break;
            case "f":
            case "%":
                if (specifier.precision == null && !isNaN(precision = (0, _d3Format.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
                break;
        }
        return (0, _d3Format.format)(specifier);
    });
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");

},{"d3-array":"aoYKF","d3-format":"97aCb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jzsSJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loggish", ()=>loggish);
parcelHelpers.export(exports, "default", ()=>log);
var _d3Array = require("d3-array");
var _d3Format = require("d3-format");
var _nice = require("./nice");
var _niceDefault = parcelHelpers.interopDefault(_nice);
var _continuous = require("./continuous");
var _init = require("./init");
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : function(x) {
        return Math.pow(base, x);
    };
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), function(x) {
        return Math.log(x) / base;
    });
}
function reflect(f) {
    return function(x) {
        return -f(-x);
    };
}
function loggish(transform) {
    var scale = transform(transformLog, transformExp), domain = scale.domain, base = 10, logs, pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = function(count) {
        var d = domain(), u = d[0], v = d[d.length - 1], r;
        if (r = v < u) i = u, u = v, v = i;
        var i = logs(u), j = logs(v), p, k, t, n = count == null ? 10 : +count, z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.round(i) - 1, j = Math.round(j) + 1;
            if (u > 0) for(; i < j; ++i)for(k = 1, p = pows(i); k < base; ++k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i < j; ++i)for(k = base - 1, p = pows(i); k >= 1; --k){
                t = p * k;
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
        } else z = (0, _d3Array.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = function(count, specifier) {
        if (specifier == null) specifier = base === 10 ? ".0e" : ",";
        if (typeof specifier !== "function") specifier = (0, _d3Format.format)(specifier);
        if (count === Infinity) return specifier;
        if (count == null) count = 10;
        var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return function(d) {
            var i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = function() {
        return domain((0, _niceDefault.default)(domain(), {
            floor: function(x) {
                return pows(Math.floor(logs(x)));
            },
            ceil: function(x) {
                return pows(Math.ceil(logs(x)));
            }
        }));
    };
    return scale;
}
function log() {
    var scale = loggish((0, _continuous.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _continuous.copy)(scale, log()).base(scale.base());
    };
    (0, _init.initRange).apply(scale, arguments);
    return scale;
}

},{"d3-array":"aoYKF","d3-format":"97aCb","./nice":"lkpC0","./continuous":"6WTm8","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lkpC0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(domain, interval) {
        domain = domain.slice();
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
        if (x1 < x0) {
            t = i0, i0 = i1, i1 = t;
            t = x0, x0 = x1, x1 = t;
        }
        domain[i0] = interval.floor(x0);
        domain[i1] = interval.ceil(x1);
        return domain;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6LKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symlogish", ()=>symlogish);
parcelHelpers.export(exports, "default", ()=>symlog);
var _linear = require("./linear");
var _continuous = require("./continuous");
var _init = require("./init");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linear.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, symlog()).constant(scale.constant());
    };
    return (0, _init.initRange).apply(scale, arguments);
}

},{"./linear":"c7lPL","./continuous":"6WTm8","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8uRFM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "powish", ()=>powish);
parcelHelpers.export(exports, "default", ()=>pow);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
var _linear = require("./linear");
var _continuous = require("./continuous");
var _init = require("./init");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform((0, _continuous.identity), (0, _continuous.identity)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, _continuous.identity), (0, _continuous.identity)) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linear.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow()).exponent(scale.exponent());
    };
    (0, _init.initRange).apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"./linear":"c7lPL","./continuous":"6WTm8","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fRuUt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantile);
var _d3Array = require("d3-array");
var _array = require("./array");
var _init = require("./init");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _d3Array.quantile)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return isNaN(x = +x) ? unknown : range[(0, _d3Array.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return (0, _init.initRange).apply(scale, arguments);
}

},{"d3-array":"aoYKF","./array":"6m1My","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49qXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>quantize);
var _d3Array = require("d3-array");
var _array = require("./array");
var _linear = require("./linear");
var _init = require("./init");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = (0, _array.slice).call(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, _init.initRange).apply((0, _linear.linearish)(scale), arguments);
}

},{"d3-array":"aoYKF","./array":"6m1My","./linear":"c7lPL","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dqjBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>threshold);
var _d3Array = require("d3-array");
var _array = require("./array");
var _init = require("./init");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x <= x ? range[(0, _d3Array.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = (0, _array.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = (0, _array.slice).call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return (0, _init.initRange).apply(scale, arguments);
}

},{"d3-array":"aoYKF","./array":"6m1My","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5wvQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", ()=>calendar);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _init.initRange).apply(calendar((0, _d3Time.timeYear), (0, _d3Time.timeMonth), (0, _d3Time.timeWeek), (0, _d3Time.timeDay), (0, _d3Time.timeHour), (0, _d3Time.timeMinute), (0, _d3Time.timeSecond), (0, _d3Time.timeMillisecond), (0, _d3TimeFormat.timeFormat)).domain([
            new Date(2000, 0, 1),
            new Date(2000, 0, 2)
        ]), arguments);
    });
var _d3Array = require("d3-array");
var _d3Time = require("d3-time");
var _d3TimeFormat = require("d3-time-format");
var _array = require("./array");
var _continuous = require("./continuous");
var _continuousDefault = parcelHelpers.interopDefault(_continuous);
var _init = require("./init");
var _nice = require("./nice");
var _niceDefault = parcelHelpers.interopDefault(_nice);
var durationSecond = 1000, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365;
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
    var scale = (0, _continuousDefault.default)((0, _continuous.identity), (0, _continuous.identity)), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    var tickIntervals = [
        [
            second,
            1,
            durationSecond
        ],
        [
            second,
            5,
            5 * durationSecond
        ],
        [
            second,
            15,
            15 * durationSecond
        ],
        [
            second,
            30,
            30 * durationSecond
        ],
        [
            minute,
            1,
            durationMinute
        ],
        [
            minute,
            5,
            5 * durationMinute
        ],
        [
            minute,
            15,
            15 * durationMinute
        ],
        [
            minute,
            30,
            30 * durationMinute
        ],
        [
            hour,
            1,
            durationHour
        ],
        [
            hour,
            3,
            3 * durationHour
        ],
        [
            hour,
            6,
            6 * durationHour
        ],
        [
            hour,
            12,
            12 * durationHour
        ],
        [
            day,
            1,
            durationDay
        ],
        [
            day,
            2,
            2 * durationDay
        ],
        [
            week,
            1,
            durationWeek
        ],
        [
            month,
            1,
            durationMonth
        ],
        [
            month,
            3,
            3 * durationMonth
        ],
        [
            year,
            1,
            durationYear
        ]
    ];
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    function tickInterval(interval, start, stop, step) {
        if (interval == null) interval = 10;
        // If a desired tick count is specified, pick a reasonable tick interval
        // based on the extent of the domain and a rough estimate of tick size.
        // Otherwise, assume interval is already a time interval and use it.
        if (typeof interval === "number") {
            var target = Math.abs(stop - start) / interval, i = (0, _d3Array.bisector)(function(i) {
                return i[2];
            }).right(tickIntervals, target);
            if (i === tickIntervals.length) {
                step = (0, _d3Array.tickStep)(start / durationYear, stop / durationYear, interval);
                interval = year;
            } else if (i) {
                i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
                step = i[1];
                interval = i[0];
            } else {
                step = Math.max((0, _d3Array.tickStep)(start, stop, interval), 1);
                interval = millisecond;
            }
        }
        return step == null ? interval : interval.every(step);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain((0, _array.map).call(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval, step) {
        var d = domain(), t0 = d[0], t1 = d[d.length - 1], r = t1 < t0, t;
        if (r) t = t0, t0 = t1, t1 = t;
        t = tickInterval(interval, t0, t1, step);
        t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
        return r ? t.reverse() : t;
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval, step) {
        var d = domain();
        return (interval = tickInterval(interval, d[0], d[d.length - 1], step)) ? domain((0, _niceDefault.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
    };
    return scale;
}

},{"d3-array":"aoYKF","d3-time":"bCmrc","d3-time-format":"6Z3KL","./array":"6m1My","./continuous":"6WTm8","./init":"2454B","./nice":"lkpC0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bCmrc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>(0, _intervalJsDefault.default));
parcelHelpers.export(exports, "timeMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "timeMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "utcMillisecond", ()=>(0, _millisecondJsDefault.default));
parcelHelpers.export(exports, "utcMilliseconds", ()=>(0, _millisecondJs.milliseconds));
parcelHelpers.export(exports, "timeSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "timeSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "utcSecond", ()=>(0, _secondJsDefault.default));
parcelHelpers.export(exports, "utcSeconds", ()=>(0, _secondJs.seconds));
parcelHelpers.export(exports, "timeMinute", ()=>(0, _minuteJsDefault.default));
parcelHelpers.export(exports, "timeMinutes", ()=>(0, _minuteJs.minutes));
parcelHelpers.export(exports, "timeHour", ()=>(0, _hourJsDefault.default));
parcelHelpers.export(exports, "timeHours", ()=>(0, _hourJs.hours));
parcelHelpers.export(exports, "timeDay", ()=>(0, _dayJsDefault.default));
parcelHelpers.export(exports, "timeDays", ()=>(0, _dayJs.days));
parcelHelpers.export(exports, "timeWeek", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeWeeks", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeSunday", ()=>(0, _weekJs.sunday));
parcelHelpers.export(exports, "timeSundays", ()=>(0, _weekJs.sundays));
parcelHelpers.export(exports, "timeMonday", ()=>(0, _weekJs.monday));
parcelHelpers.export(exports, "timeMondays", ()=>(0, _weekJs.mondays));
parcelHelpers.export(exports, "timeTuesday", ()=>(0, _weekJs.tuesday));
parcelHelpers.export(exports, "timeTuesdays", ()=>(0, _weekJs.tuesdays));
parcelHelpers.export(exports, "timeWednesday", ()=>(0, _weekJs.wednesday));
parcelHelpers.export(exports, "timeWednesdays", ()=>(0, _weekJs.wednesdays));
parcelHelpers.export(exports, "timeThursday", ()=>(0, _weekJs.thursday));
parcelHelpers.export(exports, "timeThursdays", ()=>(0, _weekJs.thursdays));
parcelHelpers.export(exports, "timeFriday", ()=>(0, _weekJs.friday));
parcelHelpers.export(exports, "timeFridays", ()=>(0, _weekJs.fridays));
parcelHelpers.export(exports, "timeSaturday", ()=>(0, _weekJs.saturday));
parcelHelpers.export(exports, "timeSaturdays", ()=>(0, _weekJs.saturdays));
parcelHelpers.export(exports, "timeMonth", ()=>(0, _monthJsDefault.default));
parcelHelpers.export(exports, "timeMonths", ()=>(0, _monthJs.months));
parcelHelpers.export(exports, "timeYear", ()=>(0, _yearJsDefault.default));
parcelHelpers.export(exports, "timeYears", ()=>(0, _yearJs.years));
parcelHelpers.export(exports, "utcMinute", ()=>(0, _utcMinuteJsDefault.default));
parcelHelpers.export(exports, "utcMinutes", ()=>(0, _utcMinuteJs.utcMinutes));
parcelHelpers.export(exports, "utcHour", ()=>(0, _utcHourJsDefault.default));
parcelHelpers.export(exports, "utcHours", ()=>(0, _utcHourJs.utcHours));
parcelHelpers.export(exports, "utcDay", ()=>(0, _utcDayJsDefault.default));
parcelHelpers.export(exports, "utcDays", ()=>(0, _utcDayJs.utcDays));
parcelHelpers.export(exports, "utcWeek", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcWeeks", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcSunday", ()=>(0, _utcWeekJs.utcSunday));
parcelHelpers.export(exports, "utcSundays", ()=>(0, _utcWeekJs.utcSundays));
parcelHelpers.export(exports, "utcMonday", ()=>(0, _utcWeekJs.utcMonday));
parcelHelpers.export(exports, "utcMondays", ()=>(0, _utcWeekJs.utcMondays));
parcelHelpers.export(exports, "utcTuesday", ()=>(0, _utcWeekJs.utcTuesday));
parcelHelpers.export(exports, "utcTuesdays", ()=>(0, _utcWeekJs.utcTuesdays));
parcelHelpers.export(exports, "utcWednesday", ()=>(0, _utcWeekJs.utcWednesday));
parcelHelpers.export(exports, "utcWednesdays", ()=>(0, _utcWeekJs.utcWednesdays));
parcelHelpers.export(exports, "utcThursday", ()=>(0, _utcWeekJs.utcThursday));
parcelHelpers.export(exports, "utcThursdays", ()=>(0, _utcWeekJs.utcThursdays));
parcelHelpers.export(exports, "utcFriday", ()=>(0, _utcWeekJs.utcFriday));
parcelHelpers.export(exports, "utcFridays", ()=>(0, _utcWeekJs.utcFridays));
parcelHelpers.export(exports, "utcSaturday", ()=>(0, _utcWeekJs.utcSaturday));
parcelHelpers.export(exports, "utcSaturdays", ()=>(0, _utcWeekJs.utcSaturdays));
parcelHelpers.export(exports, "utcMonth", ()=>(0, _utcMonthJsDefault.default));
parcelHelpers.export(exports, "utcMonths", ()=>(0, _utcMonthJs.utcMonths));
parcelHelpers.export(exports, "utcYear", ()=>(0, _utcYearJsDefault.default));
parcelHelpers.export(exports, "utcYears", ()=>(0, _utcYearJs.utcYears));
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _millisecondJs = require("./millisecond.js");
var _millisecondJsDefault = parcelHelpers.interopDefault(_millisecondJs);
var _secondJs = require("./second.js");
var _secondJsDefault = parcelHelpers.interopDefault(_secondJs);
var _minuteJs = require("./minute.js");
var _minuteJsDefault = parcelHelpers.interopDefault(_minuteJs);
var _hourJs = require("./hour.js");
var _hourJsDefault = parcelHelpers.interopDefault(_hourJs);
var _dayJs = require("./day.js");
var _dayJsDefault = parcelHelpers.interopDefault(_dayJs);
var _weekJs = require("./week.js");
var _monthJs = require("./month.js");
var _monthJsDefault = parcelHelpers.interopDefault(_monthJs);
var _yearJs = require("./year.js");
var _yearJsDefault = parcelHelpers.interopDefault(_yearJs);
var _utcMinuteJs = require("./utcMinute.js");
var _utcMinuteJsDefault = parcelHelpers.interopDefault(_utcMinuteJs);
var _utcHourJs = require("./utcHour.js");
var _utcHourJsDefault = parcelHelpers.interopDefault(_utcHourJs);
var _utcDayJs = require("./utcDay.js");
var _utcDayJsDefault = parcelHelpers.interopDefault(_utcDayJs);
var _utcWeekJs = require("./utcWeek.js");
var _utcMonthJs = require("./utcMonth.js");
var _utcMonthJsDefault = parcelHelpers.interopDefault(_utcMonthJs);
var _utcYearJs = require("./utcYear.js");
var _utcYearJsDefault = parcelHelpers.interopDefault(_utcYearJs);

},{"./interval.js":"9PMsD","./millisecond.js":"4b22w","./second.js":"3vDNh","./minute.js":"1BGJT","./hour.js":"k19pO","./day.js":"6QUnG","./week.js":"5p1DK","./month.js":"hs4om","./year.js":"3np0J","./utcMinute.js":"esPT2","./utcHour.js":"e97nA","./utcDay.js":"jokEx","./utcWeek.js":"blkIw","./utcMonth.js":"jR17X","./utcYear.js":"aUWVW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9PMsD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newInterval);
var t0 = new Date, t1 = new Date;
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4b22w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "milliseconds", ()=>milliseconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var millisecond = (0, _intervalJsDefault.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _intervalJsDefault.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
exports.default = millisecond;
var milliseconds = millisecond.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3vDNh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "seconds", ()=>seconds);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var second = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationSecond));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationSecond);
}, function(date) {
    return date.getUTCSeconds();
});
exports.default = second;
var seconds = second.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lM7m4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "durationSecond", ()=>durationSecond);
parcelHelpers.export(exports, "durationMinute", ()=>durationMinute);
parcelHelpers.export(exports, "durationHour", ()=>durationHour);
parcelHelpers.export(exports, "durationDay", ()=>durationDay);
parcelHelpers.export(exports, "durationWeek", ()=>durationWeek);
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1BGJT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "minutes", ()=>minutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var minute = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getMinutes();
});
exports.default = minute;
var minutes = minute.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k19pO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hours", ()=>hours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var hour = (0, _intervalJsDefault.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, _durationJs.durationSecond) - date.getMinutes() * (0, _durationJs.durationMinute));
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getHours();
});
exports.default = hour;
var hours = hour.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6QUnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "days", ()=>days);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var day = (0, _intervalJsDefault.default)(function(date) {
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setDate(date.getDate() + step);
}, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getDate() - 1;
});
exports.default = day;
var days = day.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5p1DK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sunday", ()=>sunday);
parcelHelpers.export(exports, "monday", ()=>monday);
parcelHelpers.export(exports, "tuesday", ()=>tuesday);
parcelHelpers.export(exports, "wednesday", ()=>wednesday);
parcelHelpers.export(exports, "thursday", ()=>thursday);
parcelHelpers.export(exports, "friday", ()=>friday);
parcelHelpers.export(exports, "saturday", ()=>saturday);
parcelHelpers.export(exports, "sundays", ()=>sundays);
parcelHelpers.export(exports, "mondays", ()=>mondays);
parcelHelpers.export(exports, "tuesdays", ()=>tuesdays);
parcelHelpers.export(exports, "wednesdays", ()=>wednesdays);
parcelHelpers.export(exports, "thursdays", ()=>thursdays);
parcelHelpers.export(exports, "fridays", ()=>fridays);
parcelHelpers.export(exports, "saturdays", ()=>saturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function weekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, _durationJs.durationMinute)) / (0, _durationJs.durationWeek);
    });
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);
var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hs4om":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "months", ()=>months);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var month = (0, _intervalJsDefault.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
exports.default = month;
var months = month.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3np0J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "years", ()=>years);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var year = (0, _intervalJsDefault.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
exports.default = year;
var years = year.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"esPT2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMinutes", ()=>utcMinutes);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcMinute = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationMinute));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationMinute);
}, function(date) {
    return date.getUTCMinutes();
});
exports.default = utcMinute;
var utcMinutes = utcMinute.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e97nA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcHours", ()=>utcHours);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcHour = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, _durationJs.durationHour));
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationHour);
}, function(date) {
    return date.getUTCHours();
});
exports.default = utcHour;
var utcHours = utcHour.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jokEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcDays", ()=>utcDays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
var utcDay = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, _durationJs.durationDay);
}, function(date) {
    return date.getUTCDate() - 1;
});
exports.default = utcDay;
var utcDays = utcDay.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"blkIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcSunday", ()=>utcSunday);
parcelHelpers.export(exports, "utcMonday", ()=>utcMonday);
parcelHelpers.export(exports, "utcTuesday", ()=>utcTuesday);
parcelHelpers.export(exports, "utcWednesday", ()=>utcWednesday);
parcelHelpers.export(exports, "utcThursday", ()=>utcThursday);
parcelHelpers.export(exports, "utcFriday", ()=>utcFriday);
parcelHelpers.export(exports, "utcSaturday", ()=>utcSaturday);
parcelHelpers.export(exports, "utcSundays", ()=>utcSundays);
parcelHelpers.export(exports, "utcMondays", ()=>utcMondays);
parcelHelpers.export(exports, "utcTuesdays", ()=>utcTuesdays);
parcelHelpers.export(exports, "utcWednesdays", ()=>utcWednesdays);
parcelHelpers.export(exports, "utcThursdays", ()=>utcThursdays);
parcelHelpers.export(exports, "utcFridays", ()=>utcFridays);
parcelHelpers.export(exports, "utcSaturdays", ()=>utcSaturdays);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var _durationJs = require("./duration.js");
function utcWeekday(i) {
    return (0, _intervalJsDefault.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, _durationJs.durationWeek);
    });
}
var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);
var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;

},{"./interval.js":"9PMsD","./duration.js":"lM7m4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jR17X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcMonths", ()=>utcMonths);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcMonth = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
exports.default = utcMonth;
var utcMonths = utcMonth.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUWVW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "utcYears", ()=>utcYears);
var _intervalJs = require("./interval.js");
var _intervalJsDefault = parcelHelpers.interopDefault(_intervalJs);
var utcYear = (0, _intervalJsDefault.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _intervalJsDefault.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
exports.default = utcYear;
var utcYears = utcYear.range;

},{"./interval.js":"9PMsD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Z3KL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormatDefaultLocale", ()=>(0, _defaultLocaleJsDefault.default));
parcelHelpers.export(exports, "timeFormat", ()=>(0, _defaultLocaleJs.timeFormat));
parcelHelpers.export(exports, "timeParse", ()=>(0, _defaultLocaleJs.timeParse));
parcelHelpers.export(exports, "utcFormat", ()=>(0, _defaultLocaleJs.utcFormat));
parcelHelpers.export(exports, "utcParse", ()=>(0, _defaultLocaleJs.utcParse));
parcelHelpers.export(exports, "timeFormatLocale", ()=>(0, _localeJsDefault.default));
parcelHelpers.export(exports, "isoFormat", ()=>(0, _isoFormatJsDefault.default));
parcelHelpers.export(exports, "isoParse", ()=>(0, _isoParseJsDefault.default));
var _defaultLocaleJs = require("./defaultLocale.js");
var _defaultLocaleJsDefault = parcelHelpers.interopDefault(_defaultLocaleJs);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var _isoFormatJs = require("./isoFormat.js");
var _isoFormatJsDefault = parcelHelpers.interopDefault(_isoFormatJs);
var _isoParseJs = require("./isoParse.js");
var _isoParseJsDefault = parcelHelpers.interopDefault(_isoParseJs);

},{"./defaultLocale.js":"cIkVK","./locale.js":"eLl5Y","./isoFormat.js":"7vlRp","./isoParse.js":"aKCVQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIkVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeFormat", ()=>timeFormat);
parcelHelpers.export(exports, "timeParse", ()=>timeParse);
parcelHelpers.export(exports, "utcFormat", ()=>utcFormat);
parcelHelpers.export(exports, "utcParse", ()=>utcParse);
parcelHelpers.export(exports, "default", ()=>defaultLocale);
var _localeJs = require("./locale.js");
var _localeJsDefault = parcelHelpers.interopDefault(_localeJs);
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _localeJsDefault.default)(definition);
    timeFormat = locale.format;
    timeParse = locale.parse;
    utcFormat = locale.utcFormat;
    utcParse = locale.utcParse;
    return locale;
}

},{"./locale.js":"eLl5Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eLl5Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatLocale);
var _d3Time = require("d3-time");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.utcMonday).ceil(week) : (0, _d3Time.utcMonday)(week);
                    week = (0, _d3Time.utcDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, _d3Time.timeMonday).ceil(week) : (0, _d3Time.timeMonday)(week);
                    week = (0, _d3Time.timeDay).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while(++i < n)map[names[i].toLowerCase()] = i;
    return map;
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.timeDay).count((0, _d3Time.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad((0, _d3Time.timeSunday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad((0, _d3Time.timeThursday).count((0, _d3Time.timeYear)(d), d) + ((0, _d3Time.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad((0, _d3Time.timeMonday).count((0, _d3Time.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.timeThursday)(d) : (0, _d3Time.timeThursday).ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + (0, _d3Time.utcDay).count((0, _d3Time.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad((0, _d3Time.utcSunday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad((0, _d3Time.utcThursday).count((0, _d3Time.utcYear)(d), d) + ((0, _d3Time.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad((0, _d3Time.utcMonday).count((0, _d3Time.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _d3Time.utcThursday)(d) : (0, _d3Time.utcThursday).ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"d3-time":"bCmrc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7vlRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isoSpecifier", ()=>isoSpecifier);
var _defaultLocaleJs = require("./defaultLocale.js");
var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocaleJs.utcFormat)(isoSpecifier);
exports.default = formatIso;

},{"./defaultLocale.js":"cIkVK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKCVQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _isoFormatJs = require("./isoFormat.js");
var _defaultLocaleJs = require("./defaultLocale.js");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocaleJs.utcParse)((0, _isoFormatJs.isoSpecifier));
exports.default = parseIso;

},{"./isoFormat.js":"7vlRp","./defaultLocale.js":"cIkVK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dAkX6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        return (0, _init.initRange).apply((0, _time.calendar)((0, _d3Time.utcYear), (0, _d3Time.utcMonth), (0, _d3Time.utcWeek), (0, _d3Time.utcDay), (0, _d3Time.utcHour), (0, _d3Time.utcMinute), (0, _d3Time.utcSecond), (0, _d3Time.utcMillisecond), (0, _d3TimeFormat.utcFormat)).domain([
            Date.UTC(2000, 0, 1),
            Date.UTC(2000, 0, 2)
        ]), arguments);
    });
var _time = require("./time");
var _d3TimeFormat = require("d3-time-format");
var _d3Time = require("d3-time");
var _init = require("./init");

},{"./time":"5wvQp","d3-time-format":"6Z3KL","d3-time":"bCmrc","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d5bJE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copy", ()=>copy);
parcelHelpers.export(exports, "default", ()=>sequential);
parcelHelpers.export(exports, "sequentialLog", ()=>sequentialLog);
parcelHelpers.export(exports, "sequentialSymlog", ()=>sequentialSymlog);
parcelHelpers.export(exports, "sequentialPow", ()=>sequentialPow);
parcelHelpers.export(exports, "sequentialSqrt", ()=>sequentialSqrt);
var _continuous = require("./continuous");
var _init = require("./init");
var _linear = require("./linear");
var _log = require("./log");
var _symlog = require("./symlog");
var _pow = require("./pow");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, _continuous.identity), clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linear.linearish)(transformer()((0, _continuous.identity)));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"./continuous":"6WTm8","./init":"2454B","./linear":"c7lPL","./log":"jzsSJ","./symlog":"k6LKH","./pow":"8uRFM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6H4Zg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>sequentialQuantile);
var _d3Array = require("d3-array");
var _continuous = require("./continuous");
var _init = require("./init");
function sequentialQuantile() {
    var domain = [], interpolator = (0, _continuous.identity);
    function scale(x) {
        if (!isNaN(x = +x)) return interpolator(((0, _d3Array.bisect)(domain, x) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for(var i = 0, n = _.length, d; i < n; ++i)if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, _d3Array.ascending));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}

},{"d3-array":"aoYKF","./continuous":"6WTm8","./init":"2454B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6LSy6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>diverging);
parcelHelpers.export(exports, "divergingLog", ()=>divergingLog);
parcelHelpers.export(exports, "divergingSymlog", ()=>divergingSymlog);
parcelHelpers.export(exports, "divergingPow", ()=>divergingPow);
parcelHelpers.export(exports, "divergingSqrt", ()=>divergingSqrt);
var _continuous = require("./continuous");
var _init = require("./init");
var _linear = require("./linear");
var _log = require("./log");
var _sequential = require("./sequential");
var _symlog = require("./symlog");
var _pow = require("./pow");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, t0, t1, t2, k10, k21, interpolator = (0, _continuous.identity), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
        return scale;
    };
}
function diverging() {
    var scale = (0, _linear.linearish)(transformer()((0, _continuous.identity)));
    scale.copy = function() {
        return (0, _sequential.copy)(scale, diverging());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingLog()).base(scale.base());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return (0, _init.initInterpolator).apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"./continuous":"6WTm8","./init":"2454B","./linear":"c7lPL","./log":"jzsSJ","./sequential":"d5bJE","./symlog":"k6LKH","./pow":"8uRFM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ruLi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schemeCategory10", ()=>(0, _category10JsDefault.default));
parcelHelpers.export(exports, "schemeAccent", ()=>(0, _accentJsDefault.default));
parcelHelpers.export(exports, "schemeDark2", ()=>(0, _dark2JsDefault.default));
parcelHelpers.export(exports, "schemePaired", ()=>(0, _pairedJsDefault.default));
parcelHelpers.export(exports, "schemePastel1", ()=>(0, _pastel1JsDefault.default));
parcelHelpers.export(exports, "schemePastel2", ()=>(0, _pastel2JsDefault.default));
parcelHelpers.export(exports, "schemeSet1", ()=>(0, _set1JsDefault.default));
parcelHelpers.export(exports, "schemeSet2", ()=>(0, _set2JsDefault.default));
parcelHelpers.export(exports, "schemeSet3", ()=>(0, _set3JsDefault.default));
parcelHelpers.export(exports, "schemeTableau10", ()=>(0, _tableau10JsDefault.default));
parcelHelpers.export(exports, "interpolateBrBG", ()=>(0, _brBGJsDefault.default));
parcelHelpers.export(exports, "schemeBrBG", ()=>(0, _brBGJs.scheme));
parcelHelpers.export(exports, "interpolatePRGn", ()=>(0, _prgnJsDefault.default));
parcelHelpers.export(exports, "schemePRGn", ()=>(0, _prgnJs.scheme));
parcelHelpers.export(exports, "interpolatePiYG", ()=>(0, _piYGJsDefault.default));
parcelHelpers.export(exports, "schemePiYG", ()=>(0, _piYGJs.scheme));
parcelHelpers.export(exports, "interpolatePuOr", ()=>(0, _puOrJsDefault.default));
parcelHelpers.export(exports, "schemePuOr", ()=>(0, _puOrJs.scheme));
parcelHelpers.export(exports, "interpolateRdBu", ()=>(0, _rdBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdBu", ()=>(0, _rdBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdGy", ()=>(0, _rdGyJsDefault.default));
parcelHelpers.export(exports, "schemeRdGy", ()=>(0, _rdGyJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlBu", ()=>(0, _rdYlBuJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlBu", ()=>(0, _rdYlBuJs.scheme));
parcelHelpers.export(exports, "interpolateRdYlGn", ()=>(0, _rdYlGnJsDefault.default));
parcelHelpers.export(exports, "schemeRdYlGn", ()=>(0, _rdYlGnJs.scheme));
parcelHelpers.export(exports, "interpolateSpectral", ()=>(0, _spectralJsDefault.default));
parcelHelpers.export(exports, "schemeSpectral", ()=>(0, _spectralJs.scheme));
parcelHelpers.export(exports, "interpolateBuGn", ()=>(0, _buGnJsDefault.default));
parcelHelpers.export(exports, "schemeBuGn", ()=>(0, _buGnJs.scheme));
parcelHelpers.export(exports, "interpolateBuPu", ()=>(0, _buPuJsDefault.default));
parcelHelpers.export(exports, "schemeBuPu", ()=>(0, _buPuJs.scheme));
parcelHelpers.export(exports, "interpolateGnBu", ()=>(0, _gnBuJsDefault.default));
parcelHelpers.export(exports, "schemeGnBu", ()=>(0, _gnBuJs.scheme));
parcelHelpers.export(exports, "interpolateOrRd", ()=>(0, _orRdJsDefault.default));
parcelHelpers.export(exports, "schemeOrRd", ()=>(0, _orRdJs.scheme));
parcelHelpers.export(exports, "interpolatePuBuGn", ()=>(0, _puBuGnJsDefault.default));
parcelHelpers.export(exports, "schemePuBuGn", ()=>(0, _puBuGnJs.scheme));
parcelHelpers.export(exports, "interpolatePuBu", ()=>(0, _puBuJsDefault.default));
parcelHelpers.export(exports, "schemePuBu", ()=>(0, _puBuJs.scheme));
parcelHelpers.export(exports, "interpolatePuRd", ()=>(0, _puRdJsDefault.default));
parcelHelpers.export(exports, "schemePuRd", ()=>(0, _puRdJs.scheme));
parcelHelpers.export(exports, "interpolateRdPu", ()=>(0, _rdPuJsDefault.default));
parcelHelpers.export(exports, "schemeRdPu", ()=>(0, _rdPuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGnBu", ()=>(0, _ylGnBuJsDefault.default));
parcelHelpers.export(exports, "schemeYlGnBu", ()=>(0, _ylGnBuJs.scheme));
parcelHelpers.export(exports, "interpolateYlGn", ()=>(0, _ylGnJsDefault.default));
parcelHelpers.export(exports, "schemeYlGn", ()=>(0, _ylGnJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrBr", ()=>(0, _ylOrBrJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrBr", ()=>(0, _ylOrBrJs.scheme));
parcelHelpers.export(exports, "interpolateYlOrRd", ()=>(0, _ylOrRdJsDefault.default));
parcelHelpers.export(exports, "schemeYlOrRd", ()=>(0, _ylOrRdJs.scheme));
parcelHelpers.export(exports, "interpolateBlues", ()=>(0, _bluesJsDefault.default));
parcelHelpers.export(exports, "schemeBlues", ()=>(0, _bluesJs.scheme));
parcelHelpers.export(exports, "interpolateGreens", ()=>(0, _greensJsDefault.default));
parcelHelpers.export(exports, "schemeGreens", ()=>(0, _greensJs.scheme));
parcelHelpers.export(exports, "interpolateGreys", ()=>(0, _greysJsDefault.default));
parcelHelpers.export(exports, "schemeGreys", ()=>(0, _greysJs.scheme));
parcelHelpers.export(exports, "interpolatePurples", ()=>(0, _purplesJsDefault.default));
parcelHelpers.export(exports, "schemePurples", ()=>(0, _purplesJs.scheme));
parcelHelpers.export(exports, "interpolateReds", ()=>(0, _redsJsDefault.default));
parcelHelpers.export(exports, "schemeReds", ()=>(0, _redsJs.scheme));
parcelHelpers.export(exports, "interpolateOranges", ()=>(0, _orangesJsDefault.default));
parcelHelpers.export(exports, "schemeOranges", ()=>(0, _orangesJs.scheme));
parcelHelpers.export(exports, "interpolateCividis", ()=>(0, _cividisJsDefault.default));
parcelHelpers.export(exports, "interpolateCubehelixDefault", ()=>(0, _cubehelixJsDefault.default));
parcelHelpers.export(exports, "interpolateRainbow", ()=>(0, _rainbowJsDefault.default));
parcelHelpers.export(exports, "interpolateWarm", ()=>(0, _rainbowJs.warm));
parcelHelpers.export(exports, "interpolateCool", ()=>(0, _rainbowJs.cool));
parcelHelpers.export(exports, "interpolateSinebow", ()=>(0, _sinebowJsDefault.default));
parcelHelpers.export(exports, "interpolateTurbo", ()=>(0, _turboJsDefault.default));
parcelHelpers.export(exports, "interpolateViridis", ()=>(0, _viridisJsDefault.default));
parcelHelpers.export(exports, "interpolateMagma", ()=>(0, _viridisJs.magma));
parcelHelpers.export(exports, "interpolateInferno", ()=>(0, _viridisJs.inferno));
parcelHelpers.export(exports, "interpolatePlasma", ()=>(0, _viridisJs.plasma));
var _category10Js = require("./categorical/category10.js");
var _category10JsDefault = parcelHelpers.interopDefault(_category10Js);
var _accentJs = require("./categorical/Accent.js");
var _accentJsDefault = parcelHelpers.interopDefault(_accentJs);
var _dark2Js = require("./categorical/Dark2.js");
var _dark2JsDefault = parcelHelpers.interopDefault(_dark2Js);
var _pairedJs = require("./categorical/Paired.js");
var _pairedJsDefault = parcelHelpers.interopDefault(_pairedJs);
var _pastel1Js = require("./categorical/Pastel1.js");
var _pastel1JsDefault = parcelHelpers.interopDefault(_pastel1Js);
var _pastel2Js = require("./categorical/Pastel2.js");
var _pastel2JsDefault = parcelHelpers.interopDefault(_pastel2Js);
var _set1Js = require("./categorical/Set1.js");
var _set1JsDefault = parcelHelpers.interopDefault(_set1Js);
var _set2Js = require("./categorical/Set2.js");
var _set2JsDefault = parcelHelpers.interopDefault(_set2Js);
var _set3Js = require("./categorical/Set3.js");
var _set3JsDefault = parcelHelpers.interopDefault(_set3Js);
var _tableau10Js = require("./categorical/Tableau10.js");
var _tableau10JsDefault = parcelHelpers.interopDefault(_tableau10Js);
var _brBGJs = require("./diverging/BrBG.js");
var _brBGJsDefault = parcelHelpers.interopDefault(_brBGJs);
var _prgnJs = require("./diverging/PRGn.js");
var _prgnJsDefault = parcelHelpers.interopDefault(_prgnJs);
var _piYGJs = require("./diverging/PiYG.js");
var _piYGJsDefault = parcelHelpers.interopDefault(_piYGJs);
var _puOrJs = require("./diverging/PuOr.js");
var _puOrJsDefault = parcelHelpers.interopDefault(_puOrJs);
var _rdBuJs = require("./diverging/RdBu.js");
var _rdBuJsDefault = parcelHelpers.interopDefault(_rdBuJs);
var _rdGyJs = require("./diverging/RdGy.js");
var _rdGyJsDefault = parcelHelpers.interopDefault(_rdGyJs);
var _rdYlBuJs = require("./diverging/RdYlBu.js");
var _rdYlBuJsDefault = parcelHelpers.interopDefault(_rdYlBuJs);
var _rdYlGnJs = require("./diverging/RdYlGn.js");
var _rdYlGnJsDefault = parcelHelpers.interopDefault(_rdYlGnJs);
var _spectralJs = require("./diverging/Spectral.js");
var _spectralJsDefault = parcelHelpers.interopDefault(_spectralJs);
var _buGnJs = require("./sequential-multi/BuGn.js");
var _buGnJsDefault = parcelHelpers.interopDefault(_buGnJs);
var _buPuJs = require("./sequential-multi/BuPu.js");
var _buPuJsDefault = parcelHelpers.interopDefault(_buPuJs);
var _gnBuJs = require("./sequential-multi/GnBu.js");
var _gnBuJsDefault = parcelHelpers.interopDefault(_gnBuJs);
var _orRdJs = require("./sequential-multi/OrRd.js");
var _orRdJsDefault = parcelHelpers.interopDefault(_orRdJs);
var _puBuGnJs = require("./sequential-multi/PuBuGn.js");
var _puBuGnJsDefault = parcelHelpers.interopDefault(_puBuGnJs);
var _puBuJs = require("./sequential-multi/PuBu.js");
var _puBuJsDefault = parcelHelpers.interopDefault(_puBuJs);
var _puRdJs = require("./sequential-multi/PuRd.js");
var _puRdJsDefault = parcelHelpers.interopDefault(_puRdJs);
var _rdPuJs = require("./sequential-multi/RdPu.js");
var _rdPuJsDefault = parcelHelpers.interopDefault(_rdPuJs);
var _ylGnBuJs = require("./sequential-multi/YlGnBu.js");
var _ylGnBuJsDefault = parcelHelpers.interopDefault(_ylGnBuJs);
var _ylGnJs = require("./sequential-multi/YlGn.js");
var _ylGnJsDefault = parcelHelpers.interopDefault(_ylGnJs);
var _ylOrBrJs = require("./sequential-multi/YlOrBr.js");
var _ylOrBrJsDefault = parcelHelpers.interopDefault(_ylOrBrJs);
var _ylOrRdJs = require("./sequential-multi/YlOrRd.js");
var _ylOrRdJsDefault = parcelHelpers.interopDefault(_ylOrRdJs);
var _bluesJs = require("./sequential-single/Blues.js");
var _bluesJsDefault = parcelHelpers.interopDefault(_bluesJs);
var _greensJs = require("./sequential-single/Greens.js");
var _greensJsDefault = parcelHelpers.interopDefault(_greensJs);
var _greysJs = require("./sequential-single/Greys.js");
var _greysJsDefault = parcelHelpers.interopDefault(_greysJs);
var _purplesJs = require("./sequential-single/Purples.js");
var _purplesJsDefault = parcelHelpers.interopDefault(_purplesJs);
var _redsJs = require("./sequential-single/Reds.js");
var _redsJsDefault = parcelHelpers.interopDefault(_redsJs);
var _orangesJs = require("./sequential-single/Oranges.js");
var _orangesJsDefault = parcelHelpers.interopDefault(_orangesJs);
var _cividisJs = require("./sequential-multi/cividis.js");
var _cividisJsDefault = parcelHelpers.interopDefault(_cividisJs);
var _cubehelixJs = require("./sequential-multi/cubehelix.js");
var _cubehelixJsDefault = parcelHelpers.interopDefault(_cubehelixJs);
var _rainbowJs = require("./sequential-multi/rainbow.js");
var _rainbowJsDefault = parcelHelpers.interopDefault(_rainbowJs);
var _sinebowJs = require("./sequential-multi/sinebow.js");
var _sinebowJsDefault = parcelHelpers.interopDefault(_sinebowJs);
var _turboJs = require("./sequential-multi/turbo.js");
var _turboJsDefault = parcelHelpers.interopDefault(_turboJs);
var _viridisJs = require("./sequential-multi/viridis.js");
var _viridisJsDefault = parcelHelpers.interopDefault(_viridisJs);

},{"./categorical/category10.js":"5jSvZ","./categorical/Accent.js":"lMRDh","./categorical/Dark2.js":"geyEl","./categorical/Paired.js":"2dEpS","./categorical/Pastel1.js":"9gkRy","./categorical/Pastel2.js":"gXFa6","./categorical/Set1.js":"evCZl","./categorical/Set2.js":"3wPdi","./categorical/Set3.js":"hubKu","./categorical/Tableau10.js":"e9MzL","./diverging/BrBG.js":"tTdAL","./diverging/PRGn.js":"6Mo0j","./diverging/PiYG.js":"hpB27","./diverging/PuOr.js":"eHirj","./diverging/RdBu.js":"1AEca","./diverging/RdGy.js":"bVkJg","./diverging/RdYlBu.js":"bSyTu","./diverging/RdYlGn.js":"i6WSx","./diverging/Spectral.js":"8HAw0","./sequential-multi/BuGn.js":"3nGZW","./sequential-multi/BuPu.js":"kePiO","./sequential-multi/GnBu.js":"8TDEP","./sequential-multi/OrRd.js":"ixYEJ","./sequential-multi/PuBuGn.js":"6RkW2","./sequential-multi/PuBu.js":"ajWB7","./sequential-multi/PuRd.js":"3Qgit","./sequential-multi/RdPu.js":"kU2Wx","./sequential-multi/YlGnBu.js":"ghGBr","./sequential-multi/YlGn.js":"c6q2h","./sequential-multi/YlOrBr.js":"74hlN","./sequential-multi/YlOrRd.js":"2UKDL","./sequential-single/Blues.js":"7Xh8u","./sequential-single/Greens.js":"b8eLb","./sequential-single/Greys.js":"hIsSh","./sequential-single/Purples.js":"f8zU8","./sequential-single/Reds.js":"1mWp4","./sequential-single/Oranges.js":"5xWYU","./sequential-multi/cividis.js":"4Slzk","./sequential-multi/cubehelix.js":"h6xPU","./sequential-multi/rainbow.js":"4Avio","./sequential-multi/sinebow.js":"iPuSr","./sequential-multi/turbo.js":"3EPRL","./sequential-multi/viridis.js":"4iNb6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jSvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7ZyK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(specifier) {
        var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
        while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
        return colors;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lMRDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"geyEl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2dEpS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gkRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXFa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"evCZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3wPdi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hubKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e9MzL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
exports.default = (0, _colorsJsDefault.default)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"tTdAL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"26zom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(scheme) {
        return (0, _d3Interpolate.interpolateRgbBasis)(scheme[scheme.length - 1]);
    });
var _d3Interpolate = require("d3-interpolate");

},{"d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Mo0j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hpB27":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eHirj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AEca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bVkJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bSyTu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6WSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8HAw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3nGZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kePiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8TDEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixYEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6RkW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ajWB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Qgit":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kU2Wx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ghGBr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c6q2h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"74hlN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2UKDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Xh8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b8eLb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hIsSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f8zU8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1mWp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5xWYU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheme", ()=>scheme);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
var _rampJs = require("../ramp.js");
var _rampJsDefault = parcelHelpers.interopDefault(_rampJs);
var scheme = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, _colorsJsDefault.default));
exports.default = (0, _rampJsDefault.default)(scheme);

},{"../colors.js":"d7ZyK","../ramp.js":"26zom","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Slzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h6xPU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
exports.default = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(300, 0.5, 0.0), (0, _d3Color.cubehelix)(-240, 0.5, 1.0));

},{"d3-color":"jv6Pr","d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Avio":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warm", ()=>warm);
parcelHelpers.export(exports, "cool", ()=>cool);
parcelHelpers.export(exports, "default", ()=>function(t) {
        if (t < 0 || t > 1) t -= Math.floor(t);
        var ts = Math.abs(t - 0.5);
        c.h = 360 * t - 100;
        c.s = 1.5 - 1.5 * ts;
        c.l = 0.8 - 0.9 * ts;
        return c + "";
    });
var _d3Color = require("d3-color");
var _d3Interpolate = require("d3-interpolate");
var warm = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(-100, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var cool = (0, _d3Interpolate.interpolateCubehelixLong)((0, _d3Color.cubehelix)(260, 0.75, 0.35), (0, _d3Color.cubehelix)(80, 1.50, 0.8));
var c = (0, _d3Color.cubehelix)();

},{"d3-color":"jv6Pr","d3-interpolate":"5gJW0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPuSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        var x;
        t = (0.5 - t) * Math.PI;
        c.r = 255 * (x = Math.sin(t)) * x;
        c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
        c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
        return c + "";
    });
var _d3Color = require("d3-color");
var c = (0, _d3Color.rgb)(), pi_1_3 = Math.PI / 3, pi_2_3 = Math.PI * 2 / 3;

},{"d3-color":"jv6Pr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3EPRL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(t) {
        t = Math.max(0, Math.min(1, t));
        return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4iNb6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "magma", ()=>magma);
parcelHelpers.export(exports, "inferno", ()=>inferno);
parcelHelpers.export(exports, "plasma", ()=>plasma);
var _colorsJs = require("../colors.js");
var _colorsJsDefault = parcelHelpers.interopDefault(_colorsJs);
function ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
exports.default = ramp((0, _colorsJsDefault.default)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var magma = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var inferno = ramp((0, _colorsJsDefault.default)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var plasma = ramp((0, _colorsJsDefault.default)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

},{"../colors.js":"d7ZyK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0b97":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arc", ()=>(0, _arcJsDefault.default));
parcelHelpers.export(exports, "area", ()=>(0, _areaJsDefault.default));
parcelHelpers.export(exports, "line", ()=>(0, _lineJsDefault.default));
parcelHelpers.export(exports, "pie", ()=>(0, _pieJsDefault.default));
parcelHelpers.export(exports, "areaRadial", ()=>(0, _areaRadialJsDefault.default)) // Note: radialArea is deprecated!
;
parcelHelpers.export(exports, "radialArea", ()=>(0, _areaRadialJsDefault.default));
parcelHelpers.export(exports, "lineRadial", ()=>(0, _lineRadialJsDefault.default)) // Note: radialLine is deprecated!
;
parcelHelpers.export(exports, "radialLine", ()=>(0, _lineRadialJsDefault.default));
parcelHelpers.export(exports, "pointRadial", ()=>(0, _pointRadialJsDefault.default));
parcelHelpers.export(exports, "linkHorizontal", ()=>(0, _indexJs.linkHorizontal));
parcelHelpers.export(exports, "linkVertical", ()=>(0, _indexJs.linkVertical));
parcelHelpers.export(exports, "linkRadial", ()=>(0, _indexJs.linkRadial));
parcelHelpers.export(exports, "symbol", ()=>(0, _symbolJsDefault.default));
parcelHelpers.export(exports, "symbols", ()=>(0, _symbolJs.symbols));
parcelHelpers.export(exports, "symbolCircle", ()=>(0, _circleJsDefault.default));
parcelHelpers.export(exports, "symbolCross", ()=>(0, _crossJsDefault.default));
parcelHelpers.export(exports, "symbolDiamond", ()=>(0, _diamondJsDefault.default));
parcelHelpers.export(exports, "symbolSquare", ()=>(0, _squareJsDefault.default));
parcelHelpers.export(exports, "symbolStar", ()=>(0, _starJsDefault.default));
parcelHelpers.export(exports, "symbolTriangle", ()=>(0, _triangleJsDefault.default));
parcelHelpers.export(exports, "symbolWye", ()=>(0, _wyeJsDefault.default));
parcelHelpers.export(exports, "curveBasisClosed", ()=>(0, _basisClosedJsDefault.default));
parcelHelpers.export(exports, "curveBasisOpen", ()=>(0, _basisOpenJsDefault.default));
parcelHelpers.export(exports, "curveBasis", ()=>(0, _basisJsDefault.default));
parcelHelpers.export(exports, "curveBundle", ()=>(0, _bundleJsDefault.default));
parcelHelpers.export(exports, "curveCardinalClosed", ()=>(0, _cardinalClosedJsDefault.default));
parcelHelpers.export(exports, "curveCardinalOpen", ()=>(0, _cardinalOpenJsDefault.default));
parcelHelpers.export(exports, "curveCardinal", ()=>(0, _cardinalJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomClosed", ()=>(0, _catmullRomClosedJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRomOpen", ()=>(0, _catmullRomOpenJsDefault.default));
parcelHelpers.export(exports, "curveCatmullRom", ()=>(0, _catmullRomJsDefault.default));
parcelHelpers.export(exports, "curveLinearClosed", ()=>(0, _linearClosedJsDefault.default));
parcelHelpers.export(exports, "curveLinear", ()=>(0, _linearJsDefault.default));
parcelHelpers.export(exports, "curveMonotoneX", ()=>(0, _monotoneJs.monotoneX));
parcelHelpers.export(exports, "curveMonotoneY", ()=>(0, _monotoneJs.monotoneY));
parcelHelpers.export(exports, "curveNatural", ()=>(0, _naturalJsDefault.default));
parcelHelpers.export(exports, "curveStep", ()=>(0, _stepJsDefault.default));
parcelHelpers.export(exports, "curveStepAfter", ()=>(0, _stepJs.stepAfter));
parcelHelpers.export(exports, "curveStepBefore", ()=>(0, _stepJs.stepBefore));
parcelHelpers.export(exports, "stack", ()=>(0, _stackJsDefault.default));
parcelHelpers.export(exports, "stackOffsetExpand", ()=>(0, _expandJsDefault.default));
parcelHelpers.export(exports, "stackOffsetDiverging", ()=>(0, _divergingJsDefault.default));
parcelHelpers.export(exports, "stackOffsetNone", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "stackOffsetSilhouette", ()=>(0, _silhouetteJsDefault.default));
parcelHelpers.export(exports, "stackOffsetWiggle", ()=>(0, _wiggleJsDefault.default));
parcelHelpers.export(exports, "stackOrderAppearance", ()=>(0, _appearanceJsDefault.default));
parcelHelpers.export(exports, "stackOrderAscending", ()=>(0, _ascendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderDescending", ()=>(0, _descendingJsDefault.default));
parcelHelpers.export(exports, "stackOrderInsideOut", ()=>(0, _insideOutJsDefault.default));
parcelHelpers.export(exports, "stackOrderNone", ()=>(0, _noneJsDefault1.default));
parcelHelpers.export(exports, "stackOrderReverse", ()=>(0, _reverseJsDefault.default));
var _arcJs = require("./arc.js");
var _arcJsDefault = parcelHelpers.interopDefault(_arcJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pieJs = require("./pie.js");
var _pieJsDefault = parcelHelpers.interopDefault(_pieJs);
var _areaRadialJs = require("./areaRadial.js");
var _areaRadialJsDefault = parcelHelpers.interopDefault(_areaRadialJs);
var _lineRadialJs = require("./lineRadial.js");
var _lineRadialJsDefault = parcelHelpers.interopDefault(_lineRadialJs);
var _pointRadialJs = require("./pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
var _indexJs = require("./link/index.js");
var _symbolJs = require("./symbol.js");
var _symbolJsDefault = parcelHelpers.interopDefault(_symbolJs);
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _basisClosedJs = require("./curve/basisClosed.js");
var _basisClosedJsDefault = parcelHelpers.interopDefault(_basisClosedJs);
var _basisOpenJs = require("./curve/basisOpen.js");
var _basisOpenJsDefault = parcelHelpers.interopDefault(_basisOpenJs);
var _basisJs = require("./curve/basis.js");
var _basisJsDefault = parcelHelpers.interopDefault(_basisJs);
var _bundleJs = require("./curve/bundle.js");
var _bundleJsDefault = parcelHelpers.interopDefault(_bundleJs);
var _cardinalClosedJs = require("./curve/cardinalClosed.js");
var _cardinalClosedJsDefault = parcelHelpers.interopDefault(_cardinalClosedJs);
var _cardinalOpenJs = require("./curve/cardinalOpen.js");
var _cardinalOpenJsDefault = parcelHelpers.interopDefault(_cardinalOpenJs);
var _cardinalJs = require("./curve/cardinal.js");
var _cardinalJsDefault = parcelHelpers.interopDefault(_cardinalJs);
var _catmullRomClosedJs = require("./curve/catmullRomClosed.js");
var _catmullRomClosedJsDefault = parcelHelpers.interopDefault(_catmullRomClosedJs);
var _catmullRomOpenJs = require("./curve/catmullRomOpen.js");
var _catmullRomOpenJsDefault = parcelHelpers.interopDefault(_catmullRomOpenJs);
var _catmullRomJs = require("./curve/catmullRom.js");
var _catmullRomJsDefault = parcelHelpers.interopDefault(_catmullRomJs);
var _linearClosedJs = require("./curve/linearClosed.js");
var _linearClosedJsDefault = parcelHelpers.interopDefault(_linearClosedJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _monotoneJs = require("./curve/monotone.js");
var _naturalJs = require("./curve/natural.js");
var _naturalJsDefault = parcelHelpers.interopDefault(_naturalJs);
var _stepJs = require("./curve/step.js");
var _stepJsDefault = parcelHelpers.interopDefault(_stepJs);
var _stackJs = require("./stack.js");
var _stackJsDefault = parcelHelpers.interopDefault(_stackJs);
var _expandJs = require("./offset/expand.js");
var _expandJsDefault = parcelHelpers.interopDefault(_expandJs);
var _divergingJs = require("./offset/diverging.js");
var _divergingJsDefault = parcelHelpers.interopDefault(_divergingJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _silhouetteJs = require("./offset/silhouette.js");
var _silhouetteJsDefault = parcelHelpers.interopDefault(_silhouetteJs);
var _wiggleJs = require("./offset/wiggle.js");
var _wiggleJsDefault = parcelHelpers.interopDefault(_wiggleJs);
var _appearanceJs = require("./order/appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./order/ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);
var _descendingJs = require("./order/descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _insideOutJs = require("./order/insideOut.js");
var _insideOutJsDefault = parcelHelpers.interopDefault(_insideOutJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
var _reverseJs = require("./order/reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);

},{"./arc.js":"eW6xE","./area.js":"2B8Op","./line.js":"gnQTs","./pie.js":"3lWHz","./areaRadial.js":"5vmgg","./lineRadial.js":"bXtNa","./pointRadial.js":"a6Uf9","./link/index.js":"cXICL","./symbol.js":"hBVmE","./symbol/circle.js":"eefhB","./symbol/cross.js":"juUuo","./symbol/diamond.js":"k4QPR","./symbol/square.js":"i4RLX","./symbol/star.js":"ci6Xo","./symbol/triangle.js":"bOLuc","./symbol/wye.js":"lgFvs","./curve/basisClosed.js":"aONXZ","./curve/basisOpen.js":"dthU4","./curve/basis.js":"d9HhJ","./curve/bundle.js":"fFlgO","./curve/cardinalClosed.js":"6fW4g","./curve/cardinalOpen.js":"hnBZo","./curve/cardinal.js":"4ulw7","./curve/catmullRomClosed.js":"eYcPU","./curve/catmullRomOpen.js":"bNGKA","./curve/catmullRom.js":"klRKm","./curve/linearClosed.js":"iBRgd","./curve/linear.js":"57yu7","./curve/monotone.js":"bNKMh","./curve/natural.js":"l475B","./curve/step.js":"ecbaV","./stack.js":"bbH4m","./offset/expand.js":"bdZ1X","./offset/diverging.js":"aqEGC","./offset/none.js":"joCmo","./offset/silhouette.js":"jOOqg","./offset/wiggle.js":"cLCZj","./order/appearance.js":"hvQ57","./order/ascending.js":"20KtN","./order/descending.js":"bjr8r","./order/insideOut.js":"7Tk3d","./order/none.js":"cpMJc","./order/reverse.js":"9K4On","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eW6xE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constantJsDefault.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
        function arc() {
            var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, _mathJs.halfPi), a1 = endAngle.apply(this, arguments) - (0, _mathJs.halfPi), da = (0, _mathJs.abs)(a1 - a0), cw = a1 > a0;
            if (!context) context = buffer = (0, _d3Path.path)();
            // Ensure that the outer radius is always larger than the inner radius.
            if (r1 < r0) r = r1, r1 = r0, r0 = r;
            // Is it a point?
            if (!(r1 > (0, _mathJs.epsilon))) context.moveTo(0, 0);
            else if (da > (0, _mathJs.tau) - (0, _mathJs.epsilon)) {
                context.moveTo(r1 * (0, _mathJs.cos)(a0), r1 * (0, _mathJs.sin)(a0));
                context.arc(0, 0, r1, a0, a1, !cw);
                if (r0 > (0, _mathJs.epsilon)) {
                    context.moveTo(r0 * (0, _mathJs.cos)(a1), r0 * (0, _mathJs.sin)(a1));
                    context.arc(0, 0, r0, a1, a0, cw);
                }
            } else {
                var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, _mathJs.epsilon) && (padRadius ? +padRadius.apply(this, arguments) : (0, _mathJs.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _mathJs.min)((0, _mathJs.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
                // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
                if (rp > (0, _mathJs.epsilon)) {
                    var p0 = (0, _mathJs.asin)(rp / r0 * (0, _mathJs.sin)(ap)), p1 = (0, _mathJs.asin)(rp / r1 * (0, _mathJs.sin)(ap));
                    if ((da0 -= p0 * 2) > (0, _mathJs.epsilon)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                    else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                    if ((da1 -= p1 * 2) > (0, _mathJs.epsilon)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                    else da1 = 0, a01 = a11 = (a0 + a1) / 2;
                }
                var x01 = r1 * (0, _mathJs.cos)(a01), y01 = r1 * (0, _mathJs.sin)(a01), x10 = r0 * (0, _mathJs.cos)(a10), y10 = r0 * (0, _mathJs.sin)(a10);
                // Apply rounded corners?
                if (rc > (0, _mathJs.epsilon)) {
                    var x11 = r1 * (0, _mathJs.cos)(a11), y11 = r1 * (0, _mathJs.sin)(a11), x00 = r0 * (0, _mathJs.cos)(a00), y00 = r0 * (0, _mathJs.sin)(a00), oc;
                    // Restrict the corner radius according to the sector angle.
                    if (da < (0, _mathJs.pi) && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _mathJs.sin)((0, _mathJs.acos)((ax * bx + ay * by) / ((0, _mathJs.sqrt)(ax * ax + ay * ay) * (0, _mathJs.sqrt)(bx * bx + by * by))) / 2), lc = (0, _mathJs.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, _mathJs.min)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, _mathJs.min)(rc, (r1 - lc) / (kc + 1));
                    }
                }
                // Is the sector collapsed to a line?
                if (!(da1 > (0, _mathJs.epsilon))) context.moveTo(x01, y01);
                else if (rc1 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                    t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                    context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc1, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r1, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                        context.arc(t1.cx, t1.cy, rc1, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
                // Is there no inner ring, and it’s a circular sector?
                // Or perhaps it’s an annular sector collapsed due to padding?
                if (!(r0 > (0, _mathJs.epsilon)) || !(da0 > (0, _mathJs.epsilon))) context.lineTo(x10, y10);
                else if (rc0 > (0, _mathJs.epsilon)) {
                    t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                    t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                    context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                    // Have the corners merged?
                    if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    else {
                        context.arc(t0.cx, t0.cy, rc0, (0, _mathJs.atan2)(t0.y01, t0.x01), (0, _mathJs.atan2)(t0.y11, t0.x11), !cw);
                        context.arc(0, 0, r0, (0, _mathJs.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _mathJs.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                        context.arc(t1.cx, t1.cy, rc0, (0, _mathJs.atan2)(t1.y11, t1.x11), (0, _mathJs.atan2)(t1.y01, t1.x01), !cw);
                    }
                } else context.arc(0, 0, r0, a10, a00, cw);
            }
            context.closePath();
            if (buffer) return context = null, buffer + "" || null;
        }
        arc.centroid = function() {
            var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, _mathJs.pi) / 2;
            return [
                (0, _mathJs.cos)(a) * r,
                (0, _mathJs.sin)(a) * r
            ];
        };
        arc.innerRadius = function(_) {
            return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : innerRadius;
        };
        arc.outerRadius = function(_) {
            return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : outerRadius;
        };
        arc.cornerRadius = function(_) {
            return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : cornerRadius;
        };
        arc.padRadius = function(_) {
            return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padRadius;
        };
        arc.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : startAngle;
        };
        arc.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : endAngle;
        };
        arc.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), arc) : padAngle;
        };
        arc.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, arc) : context;
        };
        return arc;
    });
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _mathJs = require("./math.js");
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, _mathJs.epsilon)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _mathJs.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _mathJs.sqrt)((0, _mathJs.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}

},{"d3-path":"a7nC8","./constant.js":"kiwm6","./math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kiwm6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function constant() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j0LEm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "abs", ()=>abs);
parcelHelpers.export(exports, "atan2", ()=>atan2);
parcelHelpers.export(exports, "cos", ()=>cos);
parcelHelpers.export(exports, "max", ()=>max);
parcelHelpers.export(exports, "min", ()=>min);
parcelHelpers.export(exports, "sin", ()=>sin);
parcelHelpers.export(exports, "sqrt", ()=>sqrt);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "pi", ()=>pi);
parcelHelpers.export(exports, "halfPi", ()=>halfPi);
parcelHelpers.export(exports, "tau", ()=>tau);
parcelHelpers.export(exports, "acos", ()=>acos);
parcelHelpers.export(exports, "asin", ()=>asin);
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2B8Op":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x0 = (0, _pointJs.x), x1 = null, y0 = (0, _constantJsDefault.default)(0), y1 = (0, _pointJs.y), defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        function area(data) {
            var i, j, k, n = data.length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) {
                        j = i;
                        output.areaStart();
                        output.lineStart();
                    } else {
                        output.lineEnd();
                        output.lineStart();
                        for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                        output.lineEnd();
                        output.areaEnd();
                    }
                }
                if (defined0) {
                    x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                    output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
                }
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        function arealine() {
            return (0, _lineJsDefault.default)().defined(defined).curve(curve).context(context);
        }
        area.x = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), x1 = null, area) : x0;
        };
        area.x0 = function(_) {
            return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x0;
        };
        area.x1 = function(_) {
            return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : x1;
        };
        area.y = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), y1 = null, area) : y0;
        };
        area.y0 = function(_) {
            return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y0;
        };
        area.y1 = function(_) {
            return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), area) : y1;
        };
        area.lineX0 = area.lineY0 = function() {
            return arealine().x(x0).y(y0);
        };
        area.lineY1 = function() {
            return arealine().x(x0).y(y1);
        };
        area.lineX1 = function() {
            return arealine().x(x1).y(y0);
        };
        area.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), area) : defined;
        };
        area.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
        };
        area.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
        };
        return area;
    });
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _pointJs = require("./point.js");

},{"d3-path":"a7nC8","./constant.js":"kiwm6","./curve/linear.js":"57yu7","./line.js":"gnQTs","./point.js":"iW2VA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"57yu7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Linear(context);
    });
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gnQTs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x = (0, _pointJs.x), y = (0, _pointJs.y), defined = (0, _constantJsDefault.default)(true), context = null, curve = (0, _linearJsDefault.default), output = null;
        function line(data) {
            var i, n = data.length, d, defined0 = false, buffer;
            if (context == null) output = curve(buffer = (0, _d3Path.path)());
            for(i = 0; i <= n; ++i){
                if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                    if (defined0 = !defined0) output.lineStart();
                    else output.lineEnd();
                }
                if (defined0) output.point(+x(d, i, data), +y(d, i, data));
            }
            if (buffer) return output = null, buffer + "" || null;
        }
        line.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : x;
        };
        line.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), line) : y;
        };
        line.defined = function(_) {
            return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), line) : defined;
        };
        line.curve = function(_) {
            return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
        };
        line.context = function(_) {
            return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
        };
        return line;
    });
var _d3Path = require("d3-path");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _linearJs = require("./curve/linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var _pointJs = require("./point.js");

},{"d3-path":"a7nC8","./constant.js":"kiwm6","./curve/linear.js":"57yu7","./point.js":"iW2VA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iW2VA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3lWHz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var value = (0, _identityJsDefault.default), sortValues = (0, _descendingJsDefault.default), sort = null, startAngle = (0, _constantJsDefault.default)(0), endAngle = (0, _constantJsDefault.default)((0, _mathJs.tau)), padAngle = (0, _constantJsDefault.default)(0);
        function pie(data) {
            var i, n = data.length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, _mathJs.tau), Math.max(-(0, _mathJs.tau), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
            for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
            // Optionally sort the arcs by previously-computed values or by data.
            if (sortValues != null) index.sort(function(i, j) {
                return sortValues(arcs[i], arcs[j]);
            });
            else if (sort != null) index.sort(function(i, j) {
                return sort(data[i], data[j]);
            });
            // Compute the arcs! They are stored in the original data's order.
            for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
                data: data[j],
                index: i,
                value: v,
                startAngle: a0,
                endAngle: a1,
                padAngle: p
            };
            return arcs;
        }
        pie.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : value;
        };
        pie.sortValues = function(_) {
            return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
        };
        pie.sort = function(_) {
            return arguments.length ? (sort = _, sortValues = null, pie) : sort;
        };
        pie.startAngle = function(_) {
            return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : startAngle;
        };
        pie.endAngle = function(_) {
            return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : endAngle;
        };
        pie.padAngle = function(_) {
            return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), pie) : padAngle;
        };
        return pie;
    });
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _descendingJs = require("./descending.js");
var _descendingJsDefault = parcelHelpers.interopDefault(_descendingJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _mathJs = require("./math.js");

},{"./constant.js":"kiwm6","./descending.js":"6vkEX","./identity.js":"lCwIW","./math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6vkEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCwIW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(d) {
        return d;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5vmgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var a = (0, _areaJsDefault.default)().curve((0, _radialJs.curveRadialLinear)), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
        a.angle = a.x, delete a.x;
        a.startAngle = a.x0, delete a.x0;
        a.endAngle = a.x1, delete a.x1;
        a.radius = a.y, delete a.y;
        a.innerRadius = a.y0, delete a.y0;
        a.outerRadius = a.y1, delete a.y1;
        a.lineStartAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x0());
        }, delete a.lineX0;
        a.lineEndAngle = function() {
            return (0, _lineRadialJs.lineRadial)(x1());
        }, delete a.lineX1;
        a.lineInnerRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y0());
        }, delete a.lineY0;
        a.lineOuterRadius = function() {
            return (0, _lineRadialJs.lineRadial)(y1());
        }, delete a.lineY1;
        a.curve = function(_) {
            return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
        };
        return a;
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _areaJs = require("./area.js");
var _areaJsDefault = parcelHelpers.interopDefault(_areaJs);
var _lineRadialJs = require("./lineRadial.js");

},{"./curve/radial.js":"2cZlP","./area.js":"2B8Op","./lineRadial.js":"bXtNa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2cZlP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "curveRadialLinear", ()=>curveRadialLinear);
parcelHelpers.export(exports, "default", ()=>curveRadial);
var _linearJs = require("./linear.js");
var _linearJsDefault = parcelHelpers.interopDefault(_linearJs);
var curveRadialLinear = curveRadial((0, _linearJsDefault.default));
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"./linear.js":"57yu7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bXtNa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lineRadial", ()=>lineRadial);
parcelHelpers.export(exports, "default", ()=>function() {
        return lineRadial((0, _lineJsDefault.default)().curve((0, _radialJs.curveRadialLinear)));
    });
var _radialJs = require("./curve/radial.js");
var _radialJsDefault = parcelHelpers.interopDefault(_radialJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radialJsDefault.default)(_)) : c()._curve;
    };
    return l;
}

},{"./curve/radial.js":"2cZlP","./line.js":"gnQTs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a6Uf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x, y) {
        return [
            (y = +y) * Math.cos(x -= Math.PI / 2),
            y * Math.sin(x)
        ];
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXICL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linkHorizontal", ()=>linkHorizontal);
parcelHelpers.export(exports, "linkVertical", ()=>linkVertical);
parcelHelpers.export(exports, "linkRadial", ()=>linkRadial);
var _d3Path = require("d3-path");
var _arrayJs = require("../array.js");
var _constantJs = require("../constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _pointJs = require("../point.js");
var _pointRadialJs = require("../pointRadial.js");
var _pointRadialJsDefault = parcelHelpers.interopDefault(_pointRadialJs);
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    var source = linkSource, target = linkTarget, x = (0, _pointJs.x), y = (0, _pointJs.y), context = null;
    function link() {
        var buffer, argv = (0, _arrayJs.slice).call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
        if (!context) context = buffer = (0, _d3Path.path)();
        curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
        if (buffer) return context = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, link) : context;
    };
    return link;
}
function curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}
function curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}
function curveRadial(context, x0, y0, x1, y1) {
    var p0 = (0, _pointRadialJsDefault.default)(x0, y0), p1 = (0, _pointRadialJsDefault.default)(x0, y0 = (y0 + y1) / 2), p2 = (0, _pointRadialJsDefault.default)(x1, y0), p3 = (0, _pointRadialJsDefault.default)(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}
function linkHorizontal() {
    return link(curveHorizontal);
}
function linkVertical() {
    return link(curveVertical);
}
function linkRadial() {
    var l = link(curveRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"d3-path":"a7nC8","../array.js":"hmji0","../constant.js":"kiwm6","../point.js":"iW2VA","../pointRadial.js":"a6Uf9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmji0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slice", ()=>slice);
var slice = Array.prototype.slice;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hBVmE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "symbols", ()=>symbols);
parcelHelpers.export(exports, "default", ()=>function() {
        var type = (0, _constantJsDefault.default)((0, _circleJsDefault.default)), size = (0, _constantJsDefault.default)(64), context = null;
        function symbol() {
            var buffer;
            if (!context) context = buffer = (0, _d3Path.path)();
            type.apply(this, arguments).draw(context, +size.apply(this, arguments));
            if (buffer) return context = null, buffer + "" || null;
        }
        symbol.type = function(_) {
            return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(_), symbol) : type;
        };
        symbol.size = function(_) {
            return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), symbol) : size;
        };
        symbol.context = function(_) {
            return arguments.length ? (context = _ == null ? null : _, symbol) : context;
        };
        return symbol;
    });
var _d3Path = require("d3-path");
var _circleJs = require("./symbol/circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _crossJs = require("./symbol/cross.js");
var _crossJsDefault = parcelHelpers.interopDefault(_crossJs);
var _diamondJs = require("./symbol/diamond.js");
var _diamondJsDefault = parcelHelpers.interopDefault(_diamondJs);
var _starJs = require("./symbol/star.js");
var _starJsDefault = parcelHelpers.interopDefault(_starJs);
var _squareJs = require("./symbol/square.js");
var _squareJsDefault = parcelHelpers.interopDefault(_squareJs);
var _triangleJs = require("./symbol/triangle.js");
var _triangleJsDefault = parcelHelpers.interopDefault(_triangleJs);
var _wyeJs = require("./symbol/wye.js");
var _wyeJsDefault = parcelHelpers.interopDefault(_wyeJs);
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var symbols = [
    (0, _circleJsDefault.default),
    (0, _crossJsDefault.default),
    (0, _diamondJsDefault.default),
    (0, _squareJsDefault.default),
    (0, _starJsDefault.default),
    (0, _triangleJsDefault.default),
    (0, _wyeJsDefault.default)
];

},{"d3-path":"a7nC8","./symbol/circle.js":"eefhB","./symbol/cross.js":"juUuo","./symbol/diamond.js":"k4QPR","./symbol/star.js":"ci6Xo","./symbol/square.js":"i4RLX","./symbol/triangle.js":"bOLuc","./symbol/wye.js":"lgFvs","./constant.js":"kiwm6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eefhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size / (0, _mathJs.pi));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, _mathJs.tau));
    }
};

},{"../math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"juUuo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k4QPR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tan30 = Math.sqrt(1 / 3), tan30_2 = tan30 * 2;
exports.default = {
    draw: function(context, size) {
        var y = Math.sqrt(size / tan30_2), x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ci6Xo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mathJs = require("../math.js");
var ka = 0.89081309152928522810, kr = Math.sin((0, _mathJs.pi) / 10) / Math.sin(7 * (0, _mathJs.pi) / 10), kx = Math.sin((0, _mathJs.tau) / 10) * kr, ky = -Math.cos((0, _mathJs.tau) / 10) * kr;
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size * ka), x = kx * r, y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(var i = 1; i < 5; ++i){
            var a = (0, _mathJs.tau) * i / 5, c = Math.cos(a), s = Math.sin(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"../math.js":"j0LEm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4RLX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    draw: function(context, size) {
        var w = Math.sqrt(size), x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bOLuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var sqrt3 = Math.sqrt(3);
exports.default = {
    draw: function(context, size) {
        var y = -Math.sqrt(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lgFvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var c = -0.5, s = Math.sqrt(3) / 2, k = 1 / Math.sqrt(12), a = (k / 2 + 1) * 3;
exports.default = {
    draw: function(context, size) {
        var r = Math.sqrt(size / a), x0 = r / 2, y0 = r * k, x1 = x0, y1 = r * k + r, x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aONXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _basisJs = require("./basis.js");
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"../noop.js":"7aIZJ","./basis.js":"d9HhJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7aIZJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9HhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Basis", ()=>Basis);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Basis(context);
    });
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1); // proceed
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dthU4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new BasisOpen(context);
    });
var _basisJs = require("./basis.js");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _basisJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};

},{"./basis.js":"d9HhJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fFlgO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _basisJs = require("./basis.js");
function Bundle(context, beta) {
    this._basis = new (0, _basisJs.Basis)(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, _basisJs.Basis)(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"./basis.js":"d9HhJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fW4g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalClosed", ()=>CardinalClosed);
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _cardinalJs = require("./cardinal.js");
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"../noop.js":"7aIZJ","./cardinal.js":"4ulw7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ulw7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
parcelHelpers.export(exports, "Cardinal", ()=>Cardinal);
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnBZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardinalOpen", ()=>CardinalOpen);
var _cardinalJs = require("./cardinal.js");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _cardinalJs.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"./cardinal.js":"4ulw7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eYcPU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalClosedJs = require("./cardinalClosed.js");
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new (0, _cardinalClosedJs.CardinalClosed)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalClosed.js":"6fW4g","../noop.js":"7aIZJ","./catmullRom.js":"klRKm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"klRKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "point", ()=>point);
var _mathJs = require("../math.js");
var _cardinalJs = require("./cardinal.js");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, _mathJs.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, _mathJs.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // proceed
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, _cardinalJs.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"../math.js":"j0LEm","./cardinal.js":"4ulw7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNGKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cardinalOpenJs = require("./cardinalOpen.js");
var _catmullRomJs = require("./catmullRom.js");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // proceed
            default:
                (0, _catmullRomJs.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new (0, _cardinalOpenJs.CardinalOpen)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"./cardinalOpen.js":"hnBZo","./catmullRom.js":"klRKm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iBRgd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new LinearClosed(context);
    });
var _noopJs = require("../noop.js");
var _noopJsDefault = parcelHelpers.interopDefault(_noopJs);
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: (0, _noopJsDefault.default),
    areaEnd: (0, _noopJsDefault.default),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};

},{"../noop.js":"7aIZJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNKMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "monotoneX", ()=>monotoneX);
parcelHelpers.export(exports, "monotoneY", ()=>monotoneY);
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l475B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Natural(context);
    });
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ecbaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(context) {
        return new Step(context, 0.5);
    });
parcelHelpers.export(exports, "stepBefore", ()=>stepBefore);
parcelHelpers.export(exports, "stepAfter", ()=>stepAfter);
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // proceed
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bbH4m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var keys = (0, _constantJsDefault.default)([]), order = (0, _noneJsDefault1.default), offset = (0, _noneJsDefault.default), value = stackValue;
        function stack(data) {
            var kz = keys.apply(this, arguments), i, m = data.length, n = kz.length, sz = new Array(n), oz;
            for(i = 0; i < n; ++i){
                for(var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j){
                    si[j] = sij = [
                        0,
                        +value(data[j], ki, j, data)
                    ];
                    sij.data = data[j];
                }
                si.key = ki;
            }
            for(i = 0, oz = order(sz); i < n; ++i)sz[oz[i]].index = i;
            offset(sz, oz);
            return sz;
        }
        stack.keys = function(_) {
            return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : keys;
        };
        stack.value = function(_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), stack) : value;
        };
        stack.order = function(_) {
            return arguments.length ? (order = _ == null ? (0, _noneJsDefault1.default) : typeof _ === "function" ? _ : (0, _constantJsDefault.default)((0, _arrayJs.slice).call(_)), stack) : order;
        };
        stack.offset = function(_) {
            return arguments.length ? (offset = _ == null ? (0, _noneJsDefault.default) : _, stack) : offset;
        };
        return stack;
    });
var _arrayJs = require("./array.js");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _noneJs = require("./offset/none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _noneJs1 = require("./order/none.js");
var _noneJsDefault1 = parcelHelpers.interopDefault(_noneJs1);
function stackValue(d, key) {
    return d[key];
}

},{"./array.js":"hmji0","./constant.js":"kiwm6","./offset/none.js":"joCmo","./order/none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"joCmo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 1)) return;
        for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
            s0 = s1, s1 = series[order[i]];
            for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cpMJc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, o = new Array(n);
        while(--n >= 0)o[n] = n;
        return o;
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bdZ1X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
            for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
            if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"joCmo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aqEGC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
            if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
            else if (dy < 0) d[1] = yn, d[0] = yn += dy;
            else d[0] = 0, d[1] = dy;
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jOOqg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0)) return;
        for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
            for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
            s0[j][1] += s0[j][0] = -y / 2;
        }
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"joCmo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cLCZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series, order) {
        if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
        for(var y = 0, j = 1, s0, m, n; j < m; ++j){
            for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
                var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
                for(var k = 0; k < i; ++k){
                    var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                    s3 += skj0 - skj1;
                }
                s1 += sij0, s2 += s3 * sij0;
            }
            s0[j - 1][1] += s0[j - 1][0] = y;
            if (s1) y -= s2 / s1;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        (0, _noneJsDefault.default)(series, order);
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"joCmo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hvQ57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var peaks = series.map(peak);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return peaks[a] - peaks[b];
        });
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"./none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"20KtN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var sums = series.map(sum);
        return (0, _noneJsDefault.default)(series).sort(function(a, b) {
            return sums[a] - sums[b];
        });
    });
parcelHelpers.export(exports, "sum", ()=>sum);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"./none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjr8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _ascendingJsDefault.default)(series).reverse();
    });
var _ascendingJs = require("./ascending.js");
var _ascendingJsDefault = parcelHelpers.interopDefault(_ascendingJs);

},{"./ascending.js":"20KtN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Tk3d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        var n = series.length, i, j, sums = series.map((0, _ascendingJs.sum)), order = (0, _appearanceJsDefault.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
        for(i = 0; i < n; ++i){
            j = order[i];
            if (top < bottom) {
                top += sums[j];
                tops.push(j);
            } else {
                bottom += sums[j];
                bottoms.push(j);
            }
        }
        return bottoms.reverse().concat(tops);
    });
var _appearanceJs = require("./appearance.js");
var _appearanceJsDefault = parcelHelpers.interopDefault(_appearanceJs);
var _ascendingJs = require("./ascending.js");

},{"./appearance.js":"hvQ57","./ascending.js":"20KtN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9K4On":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(series) {
        return (0, _noneJsDefault.default)(series).reverse();
    });
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);

},{"./none.js":"cpMJc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l2DKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "voronoi", ()=>(0, _voronoiDefault.default));
var _voronoi = require("./voronoi");
var _voronoiDefault = parcelHelpers.interopDefault(_voronoi);

},{"./voronoi":"7Krun","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Krun":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var x = (0, _point.x), y = (0, _point.y), extent = null;
        function voronoi(data) {
            return new (0, _diagramDefault.default)(data.map(function(d, i) {
                var s = [
                    Math.round(x(d, i, data) / (0, _diagram.epsilon)) * (0, _diagram.epsilon),
                    Math.round(y(d, i, data) / (0, _diagram.epsilon)) * (0, _diagram.epsilon)
                ];
                s.index = i;
                s.data = d;
                return s;
            }), extent);
        }
        voronoi.polygons = function(data) {
            return voronoi(data).polygons();
        };
        voronoi.links = function(data) {
            return voronoi(data).links();
        };
        voronoi.triangles = function(data) {
            return voronoi(data).triangles();
        };
        voronoi.x = function(_) {
            return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), voronoi) : x;
        };
        voronoi.y = function(_) {
            return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constantDefault.default)(+_), voronoi) : y;
        };
        voronoi.extent = function(_) {
            return arguments.length ? (extent = _ == null ? null : [
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ], voronoi) : extent && [
                [
                    extent[0][0],
                    extent[0][1]
                ],
                [
                    extent[1][0],
                    extent[1][1]
                ]
            ];
        };
        voronoi.size = function(_) {
            return arguments.length ? (extent = _ == null ? null : [
                [
                    0,
                    0
                ],
                [
                    +_[0],
                    +_[1]
                ]
            ], voronoi) : extent && [
                extent[1][0] - extent[0][0],
                extent[1][1] - extent[0][1]
            ];
        };
        return voronoi;
    });
var _constant = require("./constant");
var _constantDefault = parcelHelpers.interopDefault(_constant);
var _point = require("./point");
var _diagram = require("./Diagram");
var _diagramDefault = parcelHelpers.interopDefault(_diagram);

},{"./constant":"6kixH","./point":"8VrXk","./Diagram":"d6wZq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kixH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8VrXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "x", ()=>x);
parcelHelpers.export(exports, "y", ()=>y);
function x(d) {
    return d[0];
}
function y(d) {
    return d[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6wZq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "epsilon", ()=>epsilon);
parcelHelpers.export(exports, "epsilon2", ()=>epsilon2);
parcelHelpers.export(exports, "beaches", ()=>beaches);
parcelHelpers.export(exports, "cells", ()=>cells);
parcelHelpers.export(exports, "circles", ()=>circles);
parcelHelpers.export(exports, "edges", ()=>edges);
parcelHelpers.export(exports, "default", ()=>Diagram);
var _beach = require("./Beach");
var _cell = require("./Cell");
var _circle = require("./Circle");
var _edge = require("./Edge");
var _redBlackTree = require("./RedBlackTree");
var _redBlackTreeDefault = parcelHelpers.interopDefault(_redBlackTree);
var epsilon = 1e-6;
var epsilon2 = 1e-12;
var beaches;
var cells;
var circles;
var edges;
function triangleArea(a, b, c) {
    return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
}
function lexicographic(a, b) {
    return b[1] - a[1] || b[0] - a[0];
}
function Diagram(sites, extent) {
    var site = sites.sort(lexicographic).pop(), x, y, circle;
    edges = [];
    cells = new Array(sites.length);
    beaches = new (0, _redBlackTreeDefault.default);
    circles = new (0, _redBlackTreeDefault.default);
    while(true){
        circle = (0, _circle.firstCircle);
        if (site && (!circle || site[1] < circle.y || site[1] === circle.y && site[0] < circle.x)) {
            if (site[0] !== x || site[1] !== y) {
                (0, _beach.addBeach)(site);
                x = site[0], y = site[1];
            }
            site = sites.pop();
        } else if (circle) (0, _beach.removeBeach)(circle.arc);
        else break;
    }
    (0, _cell.sortCellHalfedges)();
    if (extent) {
        var x0 = +extent[0][0], y0 = +extent[0][1], x1 = +extent[1][0], y1 = +extent[1][1];
        (0, _edge.clipEdges)(x0, y0, x1, y1);
        (0, _cell.clipCells)(x0, y0, x1, y1);
    }
    this.edges = edges;
    this.cells = cells;
    beaches = circles = edges = cells = null;
}
Diagram.prototype = {
    constructor: Diagram,
    polygons: function() {
        var edges = this.edges;
        return this.cells.map(function(cell) {
            var polygon = cell.halfedges.map(function(i) {
                return (0, _cell.cellHalfedgeStart)(cell, edges[i]);
            });
            polygon.data = cell.site.data;
            return polygon;
        });
    },
    triangles: function() {
        var triangles = [], edges = this.edges;
        this.cells.forEach(function(cell, i) {
            if (!(m = (halfedges = cell.halfedges).length)) return;
            var site = cell.site, halfedges, j = -1, m, s0, e1 = edges[halfedges[m - 1]], s1 = e1.left === site ? e1.right : e1.left;
            while(++j < m){
                s0 = s1;
                e1 = edges[halfedges[j]];
                s1 = e1.left === site ? e1.right : e1.left;
                if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) triangles.push([
                    site.data,
                    s0.data,
                    s1.data
                ]);
            }
        });
        return triangles;
    },
    links: function() {
        return this.edges.filter(function(edge) {
            return edge.right;
        }).map(function(edge) {
            return {
                source: edge.left.data,
                target: edge.right.data
            };
        });
    },
    find: function(x, y, radius) {
        var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
        // Use the previously-found cell, or start with an arbitrary one.
        while(!(cell = that.cells[i1]))if (++i1 >= n) return null;
        var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
        // Traverse the half-edges to find a closer cell, if any.
        do {
            cell = that.cells[i0 = i1], i1 = null;
            cell.halfedges.forEach(function(e) {
                var edge = that.edges[e], v = edge.left;
                if ((v === cell.site || !v) && !(v = edge.right)) return;
                var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
                if (v2 < d2) d2 = v2, i1 = v.index;
            });
        }while (i1 !== null);
        that._found = i0;
        return radius == null || d2 <= radius * radius ? cell.site : null;
    }
};

},{"./Beach":"1oaeC","./Cell":"8X7Jf","./Circle":"8wYyh","./Edge":"lIrHq","./RedBlackTree":"5aIod","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1oaeC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeBeach", ()=>removeBeach);
parcelHelpers.export(exports, "addBeach", ()=>addBeach);
var _redBlackTree = require("./RedBlackTree");
var _cell = require("./Cell");
var _circle = require("./Circle");
var _edge = require("./Edge");
var _diagram = require("./Diagram");
var beachPool = [];
function Beach() {
    (0, _redBlackTree.RedBlackNode)(this);
    this.edge = this.site = this.circle = null;
}
function createBeach(site) {
    var beach = beachPool.pop() || new Beach;
    beach.site = site;
    return beach;
}
function detachBeach(beach) {
    (0, _circle.detachCircle)(beach);
    (0, _diagram.beaches).remove(beach);
    beachPool.push(beach);
    (0, _redBlackTree.RedBlackNode)(beach);
}
function removeBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = [
        x,
        y
    ], previous = beach.P, next = beach.N, disappearing = [
        beach
    ];
    detachBeach(beach);
    var lArc = previous;
    while(lArc.circle && Math.abs(x - lArc.circle.x) < (0, _diagram.epsilon) && Math.abs(y - lArc.circle.cy) < (0, _diagram.epsilon)){
        previous = lArc.P;
        disappearing.unshift(lArc);
        detachBeach(lArc);
        lArc = previous;
    }
    disappearing.unshift(lArc);
    (0, _circle.detachCircle)(lArc);
    var rArc = next;
    while(rArc.circle && Math.abs(x - rArc.circle.x) < (0, _diagram.epsilon) && Math.abs(y - rArc.circle.cy) < (0, _diagram.epsilon)){
        next = rArc.N;
        disappearing.push(rArc);
        detachBeach(rArc);
        rArc = next;
    }
    disappearing.push(rArc);
    (0, _circle.detachCircle)(rArc);
    var nArcs = disappearing.length, iArc;
    for(iArc = 1; iArc < nArcs; ++iArc){
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        (0, _edge.setEdgeEnd)(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = (0, _edge.createEdge)(lArc.site, rArc.site, null, vertex);
    (0, _circle.attachCircle)(lArc);
    (0, _circle.attachCircle)(rArc);
}
function addBeach(site) {
    var x = site[0], directrix = site[1], lArc, rArc, dxl, dxr, node = (0, _diagram.beaches)._;
    while(node){
        dxl = leftBreakPoint(node, directrix) - x;
        if (dxl > (0, _diagram.epsilon)) node = node.L;
        else {
            dxr = x - rightBreakPoint(node, directrix);
            if (dxr > (0, _diagram.epsilon)) {
                if (!node.R) {
                    lArc = node;
                    break;
                }
                node = node.R;
            } else {
                if (dxl > -(0, _diagram.epsilon)) {
                    lArc = node.P;
                    rArc = node;
                } else if (dxr > -(0, _diagram.epsilon)) {
                    lArc = node;
                    rArc = node.N;
                } else lArc = rArc = node;
                break;
            }
        }
    }
    (0, _cell.createCell)(site);
    var newArc = createBeach(site);
    (0, _diagram.beaches).insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
        (0, _circle.detachCircle)(lArc);
        rArc = createBeach(lArc.site);
        (0, _diagram.beaches).insert(newArc, rArc);
        newArc.edge = rArc.edge = (0, _edge.createEdge)(lArc.site, newArc.site);
        (0, _circle.attachCircle)(lArc);
        (0, _circle.attachCircle)(rArc);
        return;
    }
    if (!rArc) {
        newArc.edge = (0, _edge.createEdge)(lArc.site, newArc.site);
        return;
    }
    // else lArc !== rArc
    (0, _circle.detachCircle)(lArc);
    (0, _circle.detachCircle)(rArc);
    var lSite = lArc.site, ax = lSite[0], ay = lSite[1], bx = site[0] - ax, by = site[1] - ay, rSite = rArc.site, cx = rSite[0] - ax, cy = rSite[1] - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = [
        (cy * hb - by * hc) / d + ax,
        (bx * hc - cx * hb) / d + ay
    ];
    (0, _edge.setEdgeEnd)(rArc.edge, lSite, rSite, vertex);
    newArc.edge = (0, _edge.createEdge)(lSite, site, null, vertex);
    rArc.edge = (0, _edge.createEdge)(site, rSite, null, vertex);
    (0, _circle.attachCircle)(lArc);
    (0, _circle.attachCircle)(rArc);
}
function leftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site[0], rfocy = site[1], pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site[0], lfocy = site[1], plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
}
function rightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return leftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site[1] === directrix ? site[0] : Infinity;
}

},{"./RedBlackTree":"5aIod","./Cell":"8X7Jf","./Circle":"8wYyh","./Edge":"lIrHq","./Diagram":"d6wZq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5aIod":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RedBlackNode", ()=>RedBlackNode);
function RedBlackTree() {
    this._ = null; // root node
}
function RedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null; // next node
}
RedBlackTree.prototype = {
    constructor: RedBlackTree,
    insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
            node.P = after;
            node.N = after.N;
            if (after.N) after.N.P = node;
            after.N = node;
            if (after.R) {
                after = after.R;
                while(after.L)after = after.L;
                after.L = node;
            } else after.R = node;
            parent = after;
        } else if (this._) {
            after = RedBlackFirst(this._);
            node.P = null;
            node.N = after;
            after.P = after.L = node;
            parent = after;
        } else {
            node.P = node.N = null;
            this._ = node;
            parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while(parent && parent.C){
            grandpa = parent.U;
            if (parent === grandpa.L) {
                uncle = grandpa.R;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.R) {
                        RedBlackRotateLeft(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    RedBlackRotateRight(this, grandpa);
                }
            } else {
                uncle = grandpa.L;
                if (uncle && uncle.C) {
                    parent.C = uncle.C = false;
                    grandpa.C = true;
                    after = grandpa;
                } else {
                    if (after === parent.L) {
                        RedBlackRotateRight(this, parent);
                        after = parent;
                        parent = after.U;
                    }
                    parent.C = false;
                    grandpa.C = true;
                    RedBlackRotateLeft(this, grandpa);
                }
            }
            parent = after.U;
        }
        this._.C = false;
    },
    remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right;
        else if (!right) next = left;
        else next = RedBlackFirst(right);
        if (parent) {
            if (parent.L === node) parent.L = next;
            else parent.R = next;
        } else this._ = next;
        if (left && right) {
            red = next.C;
            next.C = node.C;
            next.L = left;
            left.U = next;
            if (next !== right) {
                parent = next.U;
                next.U = node.U;
                node = next.R;
                parent.L = node;
                next.R = right;
                right.U = next;
            } else {
                next.U = parent;
                parent = next;
                node = next.R;
            }
        } else {
            red = node.C;
            node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
            node.C = false;
            return;
        }
        do {
            if (node === this._) break;
            if (node === parent.L) {
                sibling = parent.R;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    RedBlackRotateLeft(this, parent);
                    sibling = parent.R;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.R || !sibling.R.C) {
                        sibling.L.C = false;
                        sibling.C = true;
                        RedBlackRotateRight(this, sibling);
                        sibling = parent.R;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.R.C = false;
                    RedBlackRotateLeft(this, parent);
                    node = this._;
                    break;
                }
            } else {
                sibling = parent.L;
                if (sibling.C) {
                    sibling.C = false;
                    parent.C = true;
                    RedBlackRotateRight(this, parent);
                    sibling = parent.L;
                }
                if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
                    if (!sibling.L || !sibling.L.C) {
                        sibling.R.C = false;
                        sibling.C = true;
                        RedBlackRotateLeft(this, sibling);
                        sibling = parent.L;
                    }
                    sibling.C = parent.C;
                    parent.C = sibling.L.C = false;
                    RedBlackRotateRight(this, parent);
                    node = this._;
                    break;
                }
            }
            sibling.C = true;
            node = parent;
            parent = parent.U;
        }while (!node.C);
        if (node) node.C = false;
    }
};
function RedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
}
function RedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
        if (parent.L === p) parent.L = q;
        else parent.R = q;
    } else tree._ = q;
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
}
function RedBlackFirst(node) {
    while(node.L)node = node.L;
    return node;
}
exports.default = RedBlackTree;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8X7Jf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCell", ()=>createCell);
parcelHelpers.export(exports, "cellHalfedgeStart", ()=>cellHalfedgeStart);
parcelHelpers.export(exports, "cellHalfedgeEnd", ()=>cellHalfedgeEnd);
parcelHelpers.export(exports, "sortCellHalfedges", ()=>sortCellHalfedges);
parcelHelpers.export(exports, "clipCells", ()=>clipCells);
var _edge = require("./Edge");
var _diagram = require("./Diagram");
function createCell(site) {
    return (0, _diagram.cells)[site.index] = {
        site: site,
        halfedges: []
    };
}
function cellHalfedgeAngle(cell, edge) {
    var site = cell.site, va = edge.left, vb = edge.right;
    if (site === vb) vb = va, va = site;
    if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
    if (site === va) va = edge[1], vb = edge[0];
    else va = edge[0], vb = edge[1];
    return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
}
function cellHalfedgeStart(cell, edge) {
    return edge[+(edge.left !== cell.site)];
}
function cellHalfedgeEnd(cell, edge) {
    return edge[+(edge.left === cell.site)];
}
function sortCellHalfedges() {
    for(var i = 0, n = (0, _diagram.cells).length, cell, halfedges, j, m; i < n; ++i)if ((cell = (0, _diagram.cells)[i]) && (m = (halfedges = cell.halfedges).length)) {
        var index = new Array(m), array = new Array(m);
        for(j = 0; j < m; ++j)index[j] = j, array[j] = cellHalfedgeAngle(cell, (0, _diagram.edges)[halfedges[j]]);
        index.sort(function(i, j) {
            return array[j] - array[i];
        });
        for(j = 0; j < m; ++j)array[j] = halfedges[index[j]];
        for(j = 0; j < m; ++j)halfedges[j] = array[j];
    }
}
function clipCells(x0, y0, x1, y1) {
    var nCells = (0, _diagram.cells).length, iCell, cell, site, iHalfedge, halfedges, nHalfedges, start, startX, startY, end, endX, endY, cover = true;
    for(iCell = 0; iCell < nCells; ++iCell)if (cell = (0, _diagram.cells)[iCell]) {
        site = cell.site;
        halfedges = cell.halfedges;
        iHalfedge = halfedges.length;
        // Remove any dangling clipped edges.
        while(iHalfedge--)if (!(0, _diagram.edges)[halfedges[iHalfedge]]) halfedges.splice(iHalfedge, 1);
        // Insert any border edges as necessary.
        iHalfedge = 0, nHalfedges = halfedges.length;
        while(iHalfedge < nHalfedges){
            end = cellHalfedgeEnd(cell, (0, _diagram.edges)[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
            start = cellHalfedgeStart(cell, (0, _diagram.edges)[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
            if (Math.abs(endX - startX) > (0, _diagram.epsilon) || Math.abs(endY - startY) > (0, _diagram.epsilon)) {
                halfedges.splice(iHalfedge, 0, (0, _diagram.edges).push((0, _edge.createBorderEdge)(site, end, Math.abs(endX - x0) < (0, _diagram.epsilon) && y1 - endY > (0, _diagram.epsilon) ? [
                    x0,
                    Math.abs(startX - x0) < (0, _diagram.epsilon) ? startY : y1
                ] : Math.abs(endY - y1) < (0, _diagram.epsilon) && x1 - endX > (0, _diagram.epsilon) ? [
                    Math.abs(startY - y1) < (0, _diagram.epsilon) ? startX : x1,
                    y1
                ] : Math.abs(endX - x1) < (0, _diagram.epsilon) && endY - y0 > (0, _diagram.epsilon) ? [
                    x1,
                    Math.abs(startX - x1) < (0, _diagram.epsilon) ? startY : y0
                ] : Math.abs(endY - y0) < (0, _diagram.epsilon) && endX - x0 > (0, _diagram.epsilon) ? [
                    Math.abs(startY - y0) < (0, _diagram.epsilon) ? startX : x0,
                    y0
                ] : null)) - 1);
                ++nHalfedges;
            }
        }
        if (nHalfedges) cover = false;
    }
    // If there weren’t any edges, have the closest site cover the extent.
    // It doesn’t matter which corner of the extent we measure!
    if (cover) {
        var dx, dy, d2, dc = Infinity;
        for(iCell = 0, cover = null; iCell < nCells; ++iCell)if (cell = (0, _diagram.cells)[iCell]) {
            site = cell.site;
            dx = site[0] - x0;
            dy = site[1] - y0;
            d2 = dx * dx + dy * dy;
            if (d2 < dc) dc = d2, cover = cell;
        }
        if (cover) {
            var v00 = [
                x0,
                y0
            ], v01 = [
                x0,
                y1
            ], v11 = [
                x1,
                y1
            ], v10 = [
                x1,
                y0
            ];
            cover.halfedges.push((0, _diagram.edges).push((0, _edge.createBorderEdge)(site = cover.site, v00, v01)) - 1, (0, _diagram.edges).push((0, _edge.createBorderEdge)(site, v01, v11)) - 1, (0, _diagram.edges).push((0, _edge.createBorderEdge)(site, v11, v10)) - 1, (0, _diagram.edges).push((0, _edge.createBorderEdge)(site, v10, v00)) - 1);
        }
    }
    // Lastly delete any cells with no edges; these were entirely clipped.
    for(iCell = 0; iCell < nCells; ++iCell){
        if (cell = (0, _diagram.cells)[iCell]) {
            if (!cell.halfedges.length) delete (0, _diagram.cells)[iCell];
        }
    }
}

},{"./Edge":"lIrHq","./Diagram":"d6wZq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lIrHq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEdge", ()=>createEdge);
parcelHelpers.export(exports, "createBorderEdge", ()=>createBorderEdge);
parcelHelpers.export(exports, "setEdgeEnd", ()=>setEdgeEnd);
parcelHelpers.export(exports, "clipEdges", ()=>clipEdges);
var _diagram = require("./Diagram");
function createEdge(left, right, v0, v1) {
    var edge = [
        null,
        null
    ], index = (0, _diagram.edges).push(edge) - 1;
    edge.left = left;
    edge.right = right;
    if (v0) setEdgeEnd(edge, left, right, v0);
    if (v1) setEdgeEnd(edge, right, left, v1);
    (0, _diagram.cells)[left.index].halfedges.push(index);
    (0, _diagram.cells)[right.index].halfedges.push(index);
    return edge;
}
function createBorderEdge(left, v0, v1) {
    var edge = [
        v0,
        v1
    ];
    edge.left = left;
    return edge;
}
function setEdgeEnd(edge, left, right, vertex) {
    if (!edge[0] && !edge[1]) {
        edge[0] = vertex;
        edge.left = left;
        edge.right = right;
    } else if (edge.left === right) edge[1] = vertex;
    else edge[0] = vertex;
}
// Liang–Barsky line clipping.
function clipEdge(edge, x0, y0, x1, y1) {
    var a = edge[0], b = edge[1], ax = a[0], ay = a[1], bx = b[0], by = b[1], t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
    r = x0 - ax;
    if (!dx && r > 0) return;
    r /= dx;
    if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = x1 - ax;
    if (!dx && r < 0) return;
    r /= dx;
    if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    r = y0 - ay;
    if (!dy && r > 0) return;
    r /= dy;
    if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    }
    r = y1 - ay;
    if (!dy && r < 0) return;
    r /= dy;
    if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
    } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
    }
    if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
    if (t0 > 0) edge[0] = [
        ax + t0 * dx,
        ay + t0 * dy
    ];
    if (t1 < 1) edge[1] = [
        ax + t1 * dx,
        ay + t1 * dy
    ];
    return true;
}
function connectEdge(edge, x0, y0, x1, y1) {
    var v1 = edge[1];
    if (v1) return true;
    var v0 = edge[0], left = edge.left, right = edge.right, lx = left[0], ly = left[1], rx = right[0], ry = right[1], fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
            if (!v0) v0 = [
                fx,
                y0
            ];
            else if (v0[1] >= y1) return;
            v1 = [
                fx,
                y1
            ];
        } else {
            if (!v0) v0 = [
                fx,
                y1
            ];
            else if (v0[1] < y0) return;
            v1 = [
                fx,
                y0
            ];
        }
    } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
            if (lx > rx) {
                if (!v0) v0 = [
                    (y0 - fb) / fm,
                    y0
                ];
                else if (v0[1] >= y1) return;
                v1 = [
                    (y1 - fb) / fm,
                    y1
                ];
            } else {
                if (!v0) v0 = [
                    (y1 - fb) / fm,
                    y1
                ];
                else if (v0[1] < y0) return;
                v1 = [
                    (y0 - fb) / fm,
                    y0
                ];
            }
        } else if (ly < ry) {
            if (!v0) v0 = [
                x0,
                fm * x0 + fb
            ];
            else if (v0[0] >= x1) return;
            v1 = [
                x1,
                fm * x1 + fb
            ];
        } else {
            if (!v0) v0 = [
                x1,
                fm * x1 + fb
            ];
            else if (v0[0] < x0) return;
            v1 = [
                x0,
                fm * x0 + fb
            ];
        }
    }
    edge[0] = v0;
    edge[1] = v1;
    return true;
}
function clipEdges(x0, y0, x1, y1) {
    var i = (0, _diagram.edges).length, edge;
    while(i--)if (!connectEdge(edge = (0, _diagram.edges)[i], x0, y0, x1, y1) || !clipEdge(edge, x0, y0, x1, y1) || !(Math.abs(edge[0][0] - edge[1][0]) > (0, _diagram.epsilon) || Math.abs(edge[0][1] - edge[1][1]) > (0, _diagram.epsilon))) delete (0, _diagram.edges)[i];
}

},{"./Diagram":"d6wZq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8wYyh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "firstCircle", ()=>firstCircle);
parcelHelpers.export(exports, "attachCircle", ()=>attachCircle);
parcelHelpers.export(exports, "detachCircle", ()=>detachCircle);
var _redBlackTree = require("./RedBlackTree");
var _diagram = require("./Diagram");
var circlePool = [];
var firstCircle;
function Circle() {
    (0, _redBlackTree.RedBlackNode)(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
}
function attachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite[0], by = cSite[1], ax = lSite[0] - bx, ay = lSite[1] - by, cx = rSite[0] - bx, cy = rSite[1] - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -(0, _diagram.epsilon2)) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d;
    var circle = circlePool.pop() || new Circle;
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
    arc.circle = circle;
    var before = null, node = (0, _diagram.circles)._;
    while(node){
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
            if (node.L) node = node.L;
            else {
                before = node.P;
                break;
            }
        } else if (node.R) node = node.R;
        else {
            before = node;
            break;
        }
    }
    (0, _diagram.circles).insert(before, circle);
    if (!before) firstCircle = circle;
}
function detachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
        if (!circle.P) firstCircle = circle.N;
        (0, _diagram.circles).remove(circle);
        circlePool.push(circle);
        (0, _redBlackTree.RedBlackNode)(circle);
        arc.circle = null;
    }
}

},{"./RedBlackTree":"5aIod","./Diagram":"d6wZq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wSnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoom", ()=>(0, _zoomJsDefault.default));
parcelHelpers.export(exports, "zoomTransform", ()=>(0, _transformJsDefault.default));
parcelHelpers.export(exports, "zoomIdentity", ()=>(0, _transformJs.identity));
var _zoomJs = require("./zoom.js");
var _zoomJsDefault = parcelHelpers.interopDefault(_zoomJs);
var _transformJs = require("./transform.js");
var _transformJsDefault = parcelHelpers.interopDefault(_transformJs);

},{"./zoom.js":"lvjYn","./transform.js":"boRyC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvjYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function() {
        var filter = defaultFilter, extent = defaultExtent, constrain = defaultConstrain, wheelDelta = defaultWheelDelta, touchable = defaultTouchable, scaleExtent = [
            0,
            Infinity
        ], translateExtent = [
            [
                -Infinity,
                -Infinity
            ],
            [
                Infinity,
                Infinity
            ]
        ], duration = 250, interpolate = (0, _d3Interpolate.interpolateZoom), listeners = (0, _d3Dispatch.dispatch)("start", "zoom", "end"), touchstarting, touchending, touchDelay = 500, wheelDelay = 150, clickDistance2 = 0;
        function zoom(selection) {
            selection.property("__zoom", defaultTransform).on("wheel.zoom", wheeled).on("mousedown.zoom", mousedowned).on("dblclick.zoom", dblclicked).filter(touchable).on("touchstart.zoom", touchstarted).on("touchmove.zoom", touchmoved).on("touchend.zoom touchcancel.zoom", touchended).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
        }
        zoom.transform = function(collection, transform, point) {
            var selection = collection.selection ? collection.selection() : collection;
            selection.property("__zoom", defaultTransform);
            if (collection !== selection) schedule(collection, transform, point);
            else selection.interrupt().each(function() {
                gesture(this, arguments).start().zoom(null, typeof transform === "function" ? transform.apply(this, arguments) : transform).end();
            });
        };
        zoom.scaleBy = function(selection, k, p) {
            zoom.scaleTo(selection, function() {
                var k0 = this.__zoom.k, k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return k0 * k1;
            }, p);
        };
        zoom.scaleTo = function(selection, k, p) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t0 = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p, p1 = t0.invert(p0), k1 = typeof k === "function" ? k.apply(this, arguments) : k;
                return constrain(translate(scale(t0, k1), p0, p1), e, translateExtent);
            }, p);
        };
        zoom.translateBy = function(selection, x, y) {
            zoom.transform(selection, function() {
                return constrain(this.__zoom.translate(typeof x === "function" ? x.apply(this, arguments) : x, typeof y === "function" ? y.apply(this, arguments) : y), extent.apply(this, arguments), translateExtent);
            });
        };
        zoom.translateTo = function(selection, x, y, p) {
            zoom.transform(selection, function() {
                var e = extent.apply(this, arguments), t = this.__zoom, p0 = p == null ? centroid(e) : typeof p === "function" ? p.apply(this, arguments) : p;
                return constrain((0, _transformJs.identity).translate(p0[0], p0[1]).scale(t.k).translate(typeof x === "function" ? -x.apply(this, arguments) : -x, typeof y === "function" ? -y.apply(this, arguments) : -y), e, translateExtent);
            }, p);
        };
        function scale(transform, k) {
            k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], k));
            return k === transform.k ? transform : new (0, _transformJs.Transform)(k, transform.x, transform.y);
        }
        function translate(transform, p0, p1) {
            var x = p0[0] - p1[0] * transform.k, y = p0[1] - p1[1] * transform.k;
            return x === transform.x && y === transform.y ? transform : new (0, _transformJs.Transform)(transform.k, x, y);
        }
        function centroid(extent) {
            return [
                (+extent[0][0] + +extent[1][0]) / 2,
                (+extent[0][1] + +extent[1][1]) / 2
            ];
        }
        function schedule(transition, transform, point) {
            transition.on("start.zoom", function() {
                gesture(this, arguments).start();
            }).on("interrupt.zoom end.zoom", function() {
                gesture(this, arguments).end();
            }).tween("zoom", function() {
                var that = this, args = arguments, g = gesture(that, args), e = extent.apply(that, args), p = point == null ? centroid(e) : typeof point === "function" ? point.apply(that, args) : point, w = Math.max(e[1][0] - e[0][0], e[1][1] - e[0][1]), a = that.__zoom, b = typeof transform === "function" ? transform.apply(that, args) : transform, i = interpolate(a.invert(p).concat(w / a.k), b.invert(p).concat(w / b.k));
                return function(t) {
                    if (t === 1) t = b; // Avoid rounding error on end.
                    else {
                        var l = i(t), k = w / l[2];
                        t = new (0, _transformJs.Transform)(k, p[0] - l[0] * k, p[1] - l[1] * k);
                    }
                    g.zoom(null, t);
                };
            });
        }
        function gesture(that, args, clean) {
            return !clean && that.__zooming || new Gesture(that, args);
        }
        function Gesture(that, args) {
            this.that = that;
            this.args = args;
            this.active = 0;
            this.extent = extent.apply(that, args);
            this.taps = 0;
        }
        Gesture.prototype = {
            start: function() {
                if (++this.active === 1) {
                    this.that.__zooming = this;
                    this.emit("start");
                }
                return this;
            },
            zoom: function(key, transform) {
                if (this.mouse && key !== "mouse") this.mouse[1] = transform.invert(this.mouse[0]);
                if (this.touch0 && key !== "touch") this.touch0[1] = transform.invert(this.touch0[0]);
                if (this.touch1 && key !== "touch") this.touch1[1] = transform.invert(this.touch1[0]);
                this.that.__zoom = transform;
                this.emit("zoom");
                return this;
            },
            end: function() {
                if (--this.active === 0) {
                    delete this.that.__zooming;
                    this.emit("end");
                }
                return this;
            },
            emit: function(type) {
                (0, _d3Selection.customEvent)(new (0, _eventJsDefault.default)(zoom, type, this.that.__zoom), listeners.apply, listeners, [
                    type,
                    this.that,
                    this.args
                ]);
            }
        };
        function wheeled() {
            if (!filter.apply(this, arguments)) return;
            var g = gesture(this, arguments), t = this.__zoom, k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], t.k * Math.pow(2, wheelDelta.apply(this, arguments)))), p = (0, _d3Selection.mouse)(this);
            // If the mouse is in the same location as before, reuse it.
            // If there were recent wheel events, reset the wheel idle timeout.
            if (g.wheel) {
                if (g.mouse[0][0] !== p[0] || g.mouse[0][1] !== p[1]) g.mouse[1] = t.invert(g.mouse[0] = p);
                clearTimeout(g.wheel);
            } else if (t.k === k) return;
            else {
                g.mouse = [
                    p,
                    t.invert(p)
                ];
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
            (0, _noeventJsDefault.default)();
            g.wheel = setTimeout(wheelidled, wheelDelay);
            g.zoom("mouse", constrain(translate(scale(t, k), g.mouse[0], g.mouse[1]), g.extent, translateExtent));
            function wheelidled() {
                g.wheel = null;
                g.end();
            }
        }
        function mousedowned() {
            if (touchending || !filter.apply(this, arguments)) return;
            var g = gesture(this, arguments, true), v = (0, _d3Selection.select)((0, _d3Selection.event).view).on("mousemove.zoom", mousemoved, true).on("mouseup.zoom", mouseupped, true), p = (0, _d3Selection.mouse)(this), x0 = (0, _d3Selection.event).clientX, y0 = (0, _d3Selection.event).clientY;
            (0, _d3Drag.dragDisable)((0, _d3Selection.event).view);
            (0, _noeventJs.nopropagation)();
            g.mouse = [
                p,
                this.__zoom.invert(p)
            ];
            (0, _d3Transition.interrupt)(this);
            g.start();
            function mousemoved() {
                (0, _noeventJsDefault.default)();
                if (!g.moved) {
                    var dx = (0, _d3Selection.event).clientX - x0, dy = (0, _d3Selection.event).clientY - y0;
                    g.moved = dx * dx + dy * dy > clickDistance2;
                }
                g.zoom("mouse", constrain(translate(g.that.__zoom, g.mouse[0] = (0, _d3Selection.mouse)(g.that), g.mouse[1]), g.extent, translateExtent));
            }
            function mouseupped() {
                v.on("mousemove.zoom mouseup.zoom", null);
                (0, _d3Drag.dragEnable)((0, _d3Selection.event).view, g.moved);
                (0, _noeventJsDefault.default)();
                g.end();
            }
        }
        function dblclicked() {
            if (!filter.apply(this, arguments)) return;
            var t0 = this.__zoom, p0 = (0, _d3Selection.mouse)(this), p1 = t0.invert(p0), k1 = t0.k * ((0, _d3Selection.event).shiftKey ? 0.5 : 2), t1 = constrain(translate(scale(t0, k1), p0, p1), extent.apply(this, arguments), translateExtent);
            (0, _noeventJsDefault.default)();
            if (duration > 0) (0, _d3Selection.select)(this).transition().duration(duration).call(schedule, t1, p0);
            else (0, _d3Selection.select)(this).call(zoom.transform, t1);
        }
        function touchstarted() {
            if (!filter.apply(this, arguments)) return;
            var touches = (0, _d3Selection.event).touches, n = touches.length, g = gesture(this, arguments, (0, _d3Selection.event).changedTouches.length === n), started, i, t, p;
            (0, _noeventJs.nopropagation)();
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.touch)(this, touches, t.identifier);
                p = [
                    p,
                    this.__zoom.invert(p),
                    t.identifier
                ];
                if (!g.touch0) g.touch0 = p, started = true, g.taps = 1 + !!touchstarting;
                else if (!g.touch1 && g.touch0[2] !== p[2]) g.touch1 = p, g.taps = 0;
            }
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            if (started) {
                if (g.taps < 2) touchstarting = setTimeout(function() {
                    touchstarting = null;
                }, touchDelay);
                (0, _d3Transition.interrupt)(this);
                g.start();
            }
        }
        function touchmoved() {
            if (!this.__zooming) return;
            var g = gesture(this, arguments), touches = (0, _d3Selection.event).changedTouches, n = touches.length, i, t, p, l;
            (0, _noeventJsDefault.default)();
            if (touchstarting) touchstarting = clearTimeout(touchstarting);
            g.taps = 0;
            for(i = 0; i < n; ++i){
                t = touches[i], p = (0, _d3Selection.touch)(this, touches, t.identifier);
                if (g.touch0 && g.touch0[2] === t.identifier) g.touch0[0] = p;
                else if (g.touch1 && g.touch1[2] === t.identifier) g.touch1[0] = p;
            }
            t = g.that.__zoom;
            if (g.touch1) {
                var p0 = g.touch0[0], l0 = g.touch0[1], p1 = g.touch1[0], l1 = g.touch1[1], dp = (dp = p1[0] - p0[0]) * dp + (dp = p1[1] - p0[1]) * dp, dl = (dl = l1[0] - l0[0]) * dl + (dl = l1[1] - l0[1]) * dl;
                t = scale(t, Math.sqrt(dp / dl));
                p = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
            } else if (g.touch0) p = g.touch0[0], l = g.touch0[1];
            else return;
            g.zoom("touch", constrain(translate(t, p, l), g.extent, translateExtent));
        }
        function touchended() {
            if (!this.__zooming) return;
            var g = gesture(this, arguments), touches = (0, _d3Selection.event).changedTouches, n = touches.length, i, t;
            (0, _noeventJs.nopropagation)();
            if (touchending) clearTimeout(touchending);
            touchending = setTimeout(function() {
                touchending = null;
            }, touchDelay);
            for(i = 0; i < n; ++i){
                t = touches[i];
                if (g.touch0 && g.touch0[2] === t.identifier) delete g.touch0;
                else if (g.touch1 && g.touch1[2] === t.identifier) delete g.touch1;
            }
            if (g.touch1 && !g.touch0) g.touch0 = g.touch1, delete g.touch1;
            if (g.touch0) g.touch0[1] = this.__zoom.invert(g.touch0[0]);
            else {
                g.end();
                // If this was a dbltap, reroute to the (optional) dblclick.zoom handler.
                if (g.taps === 2) {
                    var p = (0, _d3Selection.select)(this).on("dblclick.zoom");
                    if (p) p.apply(this, arguments);
                }
            }
        }
        zoom.wheelDelta = function(_) {
            return arguments.length ? (wheelDelta = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(+_), zoom) : wheelDelta;
        };
        zoom.filter = function(_) {
            return arguments.length ? (filter = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : filter;
        };
        zoom.touchable = function(_) {
            return arguments.length ? (touchable = typeof _ === "function" ? _ : (0, _constantJsDefault.default)(!!_), zoom) : touchable;
        };
        zoom.extent = function(_) {
            return arguments.length ? (extent = typeof _ === "function" ? _ : (0, _constantJsDefault.default)([
                [
                    +_[0][0],
                    +_[0][1]
                ],
                [
                    +_[1][0],
                    +_[1][1]
                ]
            ]), zoom) : extent;
        };
        zoom.scaleExtent = function(_) {
            return arguments.length ? (scaleExtent[0] = +_[0], scaleExtent[1] = +_[1], zoom) : [
                scaleExtent[0],
                scaleExtent[1]
            ];
        };
        zoom.translateExtent = function(_) {
            return arguments.length ? (translateExtent[0][0] = +_[0][0], translateExtent[1][0] = +_[1][0], translateExtent[0][1] = +_[0][1], translateExtent[1][1] = +_[1][1], zoom) : [
                [
                    translateExtent[0][0],
                    translateExtent[0][1]
                ],
                [
                    translateExtent[1][0],
                    translateExtent[1][1]
                ]
            ];
        };
        zoom.constrain = function(_) {
            return arguments.length ? (constrain = _, zoom) : constrain;
        };
        zoom.duration = function(_) {
            return arguments.length ? (duration = +_, zoom) : duration;
        };
        zoom.interpolate = function(_) {
            return arguments.length ? (interpolate = _, zoom) : interpolate;
        };
        zoom.on = function() {
            var value = listeners.on.apply(listeners, arguments);
            return value === listeners ? zoom : value;
        };
        zoom.clickDistance = function(_) {
            return arguments.length ? (clickDistance2 = (_ = +_) * _, zoom) : Math.sqrt(clickDistance2);
        };
        return zoom;
    });
var _d3Dispatch = require("d3-dispatch");
var _d3Drag = require("d3-drag");
var _d3Interpolate = require("d3-interpolate");
var _d3Selection = require("d3-selection");
var _d3Transition = require("d3-transition");
var _constantJs = require("./constant.js");
var _constantJsDefault = parcelHelpers.interopDefault(_constantJs);
var _eventJs = require("./event.js");
var _eventJsDefault = parcelHelpers.interopDefault(_eventJs);
var _transformJs = require("./transform.js");
var _noeventJs = require("./noevent.js");
var _noeventJsDefault = parcelHelpers.interopDefault(_noeventJs);
// Ignore right-click, since that should open the context menu.
function defaultFilter() {
    return !(0, _d3Selection.event).ctrlKey && !(0, _d3Selection.event).button;
}
function defaultExtent() {
    var e = this;
    if (e instanceof SVGElement) {
        e = e.ownerSVGElement || e;
        if (e.hasAttribute("viewBox")) {
            e = e.viewBox.baseVal;
            return [
                [
                    e.x,
                    e.y
                ],
                [
                    e.x + e.width,
                    e.y + e.height
                ]
            ];
        }
        return [
            [
                0,
                0
            ],
            [
                e.width.baseVal.value,
                e.height.baseVal.value
            ]
        ];
    }
    return [
        [
            0,
            0
        ],
        [
            e.clientWidth,
            e.clientHeight
        ]
    ];
}
function defaultTransform() {
    return this.__zoom || (0, _transformJs.identity);
}
function defaultWheelDelta() {
    return -(0, _d3Selection.event).deltaY * ((0, _d3Selection.event).deltaMode === 1 ? 0.05 : (0, _d3Selection.event).deltaMode ? 1 : 0.002);
}
function defaultTouchable() {
    return navigator.maxTouchPoints || "ontouchstart" in this;
}
function defaultConstrain(transform, extent, translateExtent) {
    var dx0 = transform.invertX(extent[0][0]) - translateExtent[0][0], dx1 = transform.invertX(extent[1][0]) - translateExtent[1][0], dy0 = transform.invertY(extent[0][1]) - translateExtent[0][1], dy1 = transform.invertY(extent[1][1]) - translateExtent[1][1];
    return transform.translate(dx1 > dx0 ? (dx0 + dx1) / 2 : Math.min(0, dx0) || Math.max(0, dx1), dy1 > dy0 ? (dy0 + dy1) / 2 : Math.min(0, dy0) || Math.max(0, dy1));
}

},{"d3-dispatch":"2VwUr","d3-drag":"HHNYu","d3-interpolate":"5gJW0","d3-selection":"9PvvP","d3-transition":"aj1c5","./constant.js":"i5Vxu","./event.js":"aUnay","./transform.js":"boRyC","./noevent.js":"67dpU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i5Vxu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(x) {
        return function() {
            return x;
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUnay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ZoomEvent);
function ZoomEvent(target, type, transform) {
    this.target = target;
    this.type = type;
    this.transform = transform;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"boRyC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transform", ()=>Transform);
parcelHelpers.export(exports, "identity", ()=>identity);
parcelHelpers.export(exports, "default", ()=>transform);
function Transform(k, x, y) {
    this.k = k;
    this.x = x;
    this.y = y;
}
Transform.prototype = {
    constructor: Transform,
    scale: function(k) {
        return k === 1 ? this : new Transform(this.k * k, this.x, this.y);
    },
    translate: function(x, y) {
        return x === 0 & y === 0 ? this : new Transform(this.k, this.x + this.k * x, this.y + this.k * y);
    },
    apply: function(point) {
        return [
            point[0] * this.k + this.x,
            point[1] * this.k + this.y
        ];
    },
    applyX: function(x) {
        return x * this.k + this.x;
    },
    applyY: function(y) {
        return y * this.k + this.y;
    },
    invert: function(location) {
        return [
            (location[0] - this.x) / this.k,
            (location[1] - this.y) / this.k
        ];
    },
    invertX: function(x) {
        return (x - this.x) / this.k;
    },
    invertY: function(y) {
        return (y - this.y) / this.k;
    },
    rescaleX: function(x) {
        return x.copy().domain(x.range().map(this.invertX, this).map(x.invert, x));
    },
    rescaleY: function(y) {
        return y.copy().domain(y.range().map(this.invertY, this).map(y.invert, y));
    },
    toString: function() {
        return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
    }
};
var identity = new Transform(1, 0, 0);
transform.prototype = Transform.prototype;
function transform(node) {
    while(!node.__zoom)if (!(node = node.parentNode)) return identity;
    return node.__zoom;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67dpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nopropagation", ()=>nopropagation);
parcelHelpers.export(exports, "default", ()=>function() {
        (0, _d3Selection.event).preventDefault();
        (0, _d3Selection.event).stopImmediatePropagation();
    });
var _d3Selection = require("d3-selection");
function nopropagation() {
    (0, _d3Selection.event).stopImmediatePropagation();
}

},{"d3-selection":"9PvvP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWF4m":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var _objectWithoutPropertiesLoose = _interopDefault(require("9a9f22394397a59e"));
var _extends = _interopDefault(require("f91ee12b9f700ab4"));
var React = require("6acf65edf5df1d30");
var React__default = _interopDefault(React);
var ReactDOM = _interopDefault(require("74b022ca4bdb31a0"));
let bugfixes = undefined;
let applyAnimatedValues = undefined;
let colorNames = [];
let requestFrame = (cb)=>typeof window !== 'undefined' && window.requestAnimationFrame(cb);
let cancelFrame = (cb)=>typeof window !== 'undefined' && window.cancelAnimationFrame(cb);
let interpolation = undefined;
let now = ()=>Date.now();
let defaultElement = undefined;
let createAnimatedStyle = undefined;
const injectApplyAnimatedValues = (fn, transform)=>applyAnimatedValues = {
        fn,
        transform
    };
const injectColorNames = (names)=>colorNames = names;
const injectBugfixes = (fn)=>bugfixes = fn;
const injectInterpolation = (cls)=>interpolation = cls;
const injectFrame = (raf, caf)=>{
    var _ref = [
        raf,
        caf
    ];
    requestFrame = _ref[0];
    cancelFrame = _ref[1];
    return _ref;
};
const injectNow = (nowFn)=>now = nowFn;
const injectDefaultElement = (el)=>defaultElement = el;
const injectCreateAnimatedStyle = (factory)=>createAnimatedStyle = factory;
var Globals = /*#__PURE__*/ Object.freeze({
    get bugfixes () {
        return bugfixes;
    },
    get applyAnimatedValues () {
        return applyAnimatedValues;
    },
    get colorNames () {
        return colorNames;
    },
    get requestFrame () {
        return requestFrame;
    },
    get cancelFrame () {
        return cancelFrame;
    },
    get interpolation () {
        return interpolation;
    },
    get now () {
        return now;
    },
    get defaultElement () {
        return defaultElement;
    },
    get createAnimatedStyle () {
        return createAnimatedStyle;
    },
    injectApplyAnimatedValues: injectApplyAnimatedValues,
    injectColorNames: injectColorNames,
    injectBugfixes: injectBugfixes,
    injectInterpolation: injectInterpolation,
    injectFrame: injectFrame,
    injectNow: injectNow,
    injectDefaultElement: injectDefaultElement,
    injectCreateAnimatedStyle: injectCreateAnimatedStyle
});
class Animated {
    attach() {}
    detach() {}
    getValue() {}
    getAnimatedValue() {
        return this.getValue();
    }
    addChild(child) {}
    removeChild(child) {}
    getChildren() {
        return [];
    }
}
const getValues = (object)=>Object.keys(object).map((k)=>object[k]);
class AnimatedWithChildren extends Animated {
    constructor(){
        var _this;
        super(...arguments);
        _this = this;
        this.children = [];
        this.getChildren = ()=>this.children;
        this.getPayload = function(index) {
            if (index === void 0) index = undefined;
            return index !== void 0 && _this.payload ? _this.payload[index] : _this.payload || _this;
        };
    }
    addChild(child) {
        if (this.children.length === 0) this.attach();
        this.children.push(child);
    }
    removeChild(child) {
        const index = this.children.indexOf(child);
        this.children.splice(index, 1);
        if (this.children.length === 0) this.detach();
    }
}
class AnimatedArrayWithChildren extends AnimatedWithChildren {
    constructor(){
        super(...arguments);
        this.payload = [];
        this.getAnimatedValue = ()=>this.getValue();
        this.attach = ()=>this.payload.forEach((p)=>p instanceof Animated && p.addChild(this));
        this.detach = ()=>this.payload.forEach((p)=>p instanceof Animated && p.removeChild(this));
    }
}
class AnimatedObjectWithChildren extends AnimatedWithChildren {
    constructor(){
        super(...arguments);
        this.payload = {};
        this.getAnimatedValue = ()=>this.getValue(true);
        this.attach = ()=>getValues(this.payload).forEach((s)=>s instanceof Animated && s.addChild(this));
        this.detach = ()=>getValues(this.payload).forEach((s)=>s instanceof Animated && s.removeChild(this));
    }
    getValue(animated) {
        if (animated === void 0) animated = false;
        const payload = {};
        for(const key in this.payload){
            const value = this.payload[key];
            if (animated && !(value instanceof Animated)) continue;
            payload[key] = value instanceof Animated ? value[animated ? 'getAnimatedValue' : 'getValue']() : value;
        }
        return payload;
    }
}
class AnimatedStyle extends AnimatedObjectWithChildren {
    constructor(style){
        super();
        style = style || {};
        if (style.transform && !(style.transform instanceof Animated)) style = applyAnimatedValues.transform(style);
        this.payload = style;
    }
}
// http://www.w3.org/TR/css3-color/#svg-color
const colors = {
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
};
class Interpolation {
    // Default config = config, args
    // Short config   = range, output, extrapolate
    static create(config, output, extra) {
        if (typeof config === 'function') return config;
        else if (interpolation && config.output && typeof config.output[0] === 'string') return interpolation(config);
        else if (Array.isArray(config)) return Interpolation.create({
            range: config,
            output,
            extrapolate: extra || 'extend'
        });
        let outputRange = config.output;
        let inputRange = config.range || [
            0,
            1
        ];
        let easing = config.easing || ((t)=>t);
        let extrapolateLeft = 'extend';
        let map = config.map;
        if (config.extrapolateLeft !== undefined) extrapolateLeft = config.extrapolateLeft;
        else if (config.extrapolate !== undefined) extrapolateLeft = config.extrapolate;
        let extrapolateRight = 'extend';
        if (config.extrapolateRight !== undefined) extrapolateRight = config.extrapolateRight;
        else if (config.extrapolate !== undefined) extrapolateRight = config.extrapolate;
        return (input)=>{
            let range = findRange(input, inputRange);
            return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight, map);
        };
    }
}
function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input; // Extrapolate
    if (result < inputMin) {
        if (extrapolateLeft === 'identity') return result;
        else if (extrapolateLeft === 'clamp') result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === 'identity') return result;
        else if (extrapolateRight === 'clamp') result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax; // Input Range
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin); // Easing
    result = easing(result); // Output Range
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// const INTEGER = '[-+]?\\d+';
const NUMBER = '[-+]?\\d*\\.?\\d+';
const PERCENTAGE = NUMBER + '%';
function call() {
    return '\\(\\s*(' + Array.prototype.slice.call(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
}
const rgb = new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER));
const rgba = new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl = new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla = new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;
/*
https://github.com/react-community/normalize-css-color

BSD 3-Clause License

Copyright (c) 2016, React Community
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

* Neither the name of the copyright holder nor the names of its
  contributors may be used to endorse or promote products derived from
  this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function normalizeColor(color) {
    let match;
    if (typeof color === 'number') return color >>> 0 === color && color >= 0 && color <= 0xffffffff ? color : null;
     // Ordered based on occurrences on Facebook codebase
    if (match = hex6.exec(color)) return parseInt(match[1] + 'ff', 16) >>> 0;
    if (colors.hasOwnProperty(color)) return colors[color];
    if (match = rgb.exec(color)) return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    0x000000ff) >>> // a
    0;
    if (match = rgba.exec(color)) return (parse255(match[1]) << 24 | // r
    parse255(match[2]) << 16 | // g
    parse255(match[3]) << 8 | // b
    parse1(match[4])) >>> // a
    0;
    if (match = hex3.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    'ff', 16) >>> 0;
     // https://drafts.csswg.org/css-color-4/#hex-notation
    if (match = hex8.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = hex4.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], 16) >>> 0;
    if (match = hsl.exec(color)) return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3]) // l
    ) | 0x000000ff) >>> // a
    0;
    if (match = hsla.exec(color)) return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3]) // l
    ) | parse1(match[4])) >>> // a
    0;
    return null;
}
function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = hue2rgb(p, q, h + 1 / 3);
    const g = hue2rgb(p, q, h);
    const b = hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function parsePercentage(str) {
    // parseFloat conveniently ignores the final %
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
function colorToRgba(input) {
    let int32Color = normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    let r = (int32Color & 0xff000000) >>> 24;
    let g = (int32Color & 0x00ff0000) >>> 16;
    let b = (int32Color & 0x0000ff00) >>> 8;
    let a = (int32Color & 0x000000ff) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
} // Problem: https://github.com/animatedjs/animated/pull/102
// Solution: https://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly/658662
const stringShapeRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g; // Covers rgb, rgba, hsl, hsla
// Taken from https://gist.github.com/olmokramer/82ccce673f86db7cda5e
const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi; // Covers color names (transparent, blue, etc.)
const colorNamesRegex = new RegExp(`(${Object.keys(colors).join('|')})`, 'g');
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36)           // colors
 *   -45deg                            // values with units
 *   0 2px 2px 0px rgba(0, 0, 0, 0.12) // box shadows
 */ function createInterpolation(config) {
    // Replace colors with rgba
    const outputRange = config.output.map((rangeValue)=>rangeValue.replace(colorRegex, colorToRgba)).map((rangeValue)=>rangeValue.replace(colorNamesRegex, colorToRgba)); // ->
    // [
    //   [0, 50],
    //   [100, 150],
    //   [200, 250],
    //   [0, 0.5],
    // ]
    const outputRanges = outputRange[0].match(stringShapeRegex).map(()=>[]);
    outputRange.forEach((value)=>{
        value.match(stringShapeRegex).forEach((number, i)=>outputRanges[i].push(+number));
    });
    const interpolations = outputRange[0].match(stringShapeRegex).map((value, i)=>{
        return Interpolation.create(_extends({}, config, {
            output: outputRanges[i]
        }));
    });
    return (input)=>{
        let i = 0;
        return outputRange[0] // 'rgba(0, 100, 200, 0)'
        // ->
        // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'
        .replace(stringShapeRegex, ()=>interpolations[i++](input)) // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
        // round the opacity (4th column).
        .replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`);
    };
}
class AnimatedInterpolation extends AnimatedArrayWithChildren {
    constructor(parents, _config, _arg){
        super();
        this.getValue = ()=>this.calc(...this.payload.map((value)=>value.getValue()));
        this.updateConfig = (config, arg)=>this.calc = Interpolation.create(config, arg);
        this.interpolate = (config, arg)=>new AnimatedInterpolation(this, config, arg);
        this.payload = parents instanceof AnimatedArrayWithChildren && !parents.updateConfig ? parents.payload : Array.isArray(parents) ? parents : [
            parents
        ];
        this.calc = Interpolation.create(_config, _arg);
    }
}
const interpolate$1 = (parents, config, arg)=>parents && new AnimatedInterpolation(parents, config, arg);
/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an Animated.Value is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */ function findAnimatedStyles(node, styles) {
    if (typeof node.update === 'function') styles.add(node);
    else node.getChildren().forEach((child)=>findAnimatedStyles(child, styles));
}
/**
 * Standard value for driving animations.  One `Animated.Value` can drive
 * multiple properties in a synchronized fashion, but can only be driven by one
 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
 * or calling `setValue`) will stop any previous ones.
 */ class AnimatedValue extends AnimatedWithChildren {
    constructor(_value){
        var _this;
        super();
        _this = this;
        this.setValue = function(value, flush) {
            if (flush === void 0) flush = true;
            _this.value = value;
            if (flush) _this.flush();
        };
        this.getValue = ()=>this.value;
        this.updateStyles = ()=>findAnimatedStyles(this, this.animatedStyles);
        this.updateValue = (value)=>this.flush(this.value = value);
        this.interpolate = (config, arg)=>new AnimatedInterpolation(this, config, arg);
        this.value = _value;
        this.animatedStyles = new Set();
        this.done = false;
        this.startPosition = _value;
        this.lastPosition = _value;
        this.lastVelocity = undefined;
        this.lastTime = undefined;
        this.controller = undefined;
    }
    flush() {
        if (this.animatedStyles.size === 0) this.updateStyles();
        this.animatedStyles.forEach((animatedStyle)=>animatedStyle.update());
    }
    prepare(controller) {
        // Values stay loyal to their original controller, this is also a way to
        // detect trailing values originating from a foreign controller
        if (this.controller === undefined) this.controller = controller;
        if (this.controller === controller) {
            this.startPosition = this.value;
            this.lastPosition = this.value;
            this.lastVelocity = controller.isActive ? this.lastVelocity : undefined;
            this.lastTime = controller.isActive ? this.lastTime : undefined;
            this.done = false;
            this.animatedStyles.clear();
        }
    }
}
class AnimatedArray extends AnimatedArrayWithChildren {
    constructor(array){
        var _this;
        super();
        _this = this;
        this.setValue = function(value, flush) {
            if (flush === void 0) flush = true;
            if (Array.isArray(value)) {
                if (value.length === _this.payload.length) value.forEach((v, i)=>_this.payload[i].setValue(v, flush));
            } else _this.payload.forEach((v, i)=>_this.payload[i].setValue(value, flush));
        };
        this.getValue = ()=>this.payload.map((v)=>v.getValue());
        this.interpolate = (config, arg)=>new AnimatedInterpolation(this, config, arg);
        this.payload = array.map((n)=>new AnimatedValue(n));
    }
}
function withDefault(value, defaultValue) {
    return value === undefined || value === null ? defaultValue : value;
}
function toArray(a) {
    return a !== void 0 ? Array.isArray(a) ? a : [
        a
    ] : [];
}
function shallowEqual(a, b) {
    if (typeof a !== typeof b) return false;
    if (typeof a === 'string' || typeof a === 'number') return a === b;
    let i;
    for(i in a)if (!(i in b)) return false;
    for(i in b)if (a[i] !== b[i]) return false;
    return i === void 0 ? a === b : true;
}
function callProp(obj) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return typeof obj === 'function' ? obj(...args) : obj;
}
function getValues$1(object) {
    return Object.keys(object).map((k)=>object[k]);
}
function getForwardProps(props) {
    const to = props.to, from = props.from, config = props.config, native = props.native, onStart = props.onStart, onRest = props.onRest, onFrame = props.onFrame, children = props.children, reset = props.reset, reverse = props.reverse, force = props.force, immediate = props.immediate, impl = props.impl, inject = props.inject, delay = props.delay, attach = props.attach, destroyed = props.destroyed, interpolateTo = props.interpolateTo, autoStart = props.autoStart, ref = props.ref, forward = _objectWithoutPropertiesLoose(props, [
        "to",
        "from",
        "config",
        "native",
        "onStart",
        "onRest",
        "onFrame",
        "children",
        "reset",
        "reverse",
        "force",
        "immediate",
        "impl",
        "inject",
        "delay",
        "attach",
        "destroyed",
        "interpolateTo",
        "autoStart",
        "ref"
    ]);
    return forward;
}
function interpolateTo(props) {
    const forward = getForwardProps(props);
    const rest = Object.keys(props).reduce((a, k)=>forward[k] !== void 0 ? a : _extends({}, a, {
            [k]: props[k]
        }), {});
    return _extends({
        to: forward
    }, rest);
}
function convertToAnimatedValue(acc, _ref) {
    let name = _ref[0], value = _ref[1];
    return _extends({}, acc, {
        [name]: new (Array.isArray(value) ? AnimatedArray : AnimatedValue)(value)
    });
}
function convertValues(props) {
    const from = props.from, to = props.to, native = props.native;
    const allProps = Object.entries(_extends({}, from, to));
    return native ? allProps.reduce(convertToAnimatedValue, {}) : _extends({}, from, to);
}
function handleRef(ref, forward) {
    if (forward) {
        // If it's a function, assume it's a ref callback
        if (typeof forward === 'function') forward(ref);
        else if (typeof forward === 'object') // If it's an object and has a 'current' property, assume it's a ref object
        forward.current = ref;
    }
    return ref;
}
const check = (value)=>value === 'auto';
const overwrite = (width, height)=>(acc, _ref)=>{
        let name = _ref[0], value = _ref[1];
        return _extends({}, acc, {
            [name]: value === 'auto' ? ~name.indexOf('height') ? height : width : value
        });
    };
function fixAuto(props, callback) {
    const from = props.from, to = props.to, children = props.children; // Dry-route props back if nothing's using 'auto' in there
    // TODO: deal with "null"
    if (!(getValues$1(to).some(check) || getValues$1(from).some(check))) return; // Fetch render v-dom
    let element = children(convertValues(props)); // A spring can return undefined/null, check against that (#153)
    if (!element) return; // Or it could be an array (#346) ...
    if (Array.isArray(element)) element = {
        type: 'div',
        props: {
            children: element
        } // Extract styles
    };
    const elementStyles = element.props.style; // Return v.dom with injected ref
    return React__default.createElement(element.type, _extends({
        key: element.key ? element.key : undefined
    }, element.props, {
        style: _extends({}, elementStyles, {
            position: 'absolute',
            visibility: 'hidden'
        }),
        ref: (_ref2)=>{
            if (_ref2) {
                // Once it's rendered out, fetch bounds (minus padding/margin/borders)
                let node = ReactDOM.findDOMNode(_ref2);
                let width, height;
                let cs = getComputedStyle(node);
                if (cs.boxSizing === 'border-box') {
                    width = node.offsetWidth;
                    height = node.offsetHeight;
                } else {
                    const paddingX = parseFloat(cs.paddingLeft || 0) + parseFloat(cs.paddingRight || 0);
                    const paddingY = parseFloat(cs.paddingTop || 0) + parseFloat(cs.paddingBottom || 0);
                    const borderX = parseFloat(cs.borderLeftWidth || 0) + parseFloat(cs.borderRightWidth || 0);
                    const borderY = parseFloat(cs.borderTopWidth || 0) + parseFloat(cs.borderBottomWidth || 0);
                    width = node.offsetWidth - paddingX - borderX;
                    height = node.offsetHeight - paddingY - borderY;
                }
                const convert = overwrite(width, height);
                callback(_extends({}, props, {
                    from: Object.entries(from).reduce(convert, from),
                    to: Object.entries(to).reduce(convert, to)
                }));
            }
        }
    }));
}
let isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
const prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
const prefixes = [
    'Webkit',
    'Ms',
    'Moz',
    'O'
];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop)=>{
    prefixes.forEach((prefix)=>acc[prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, isUnitlessNumber);
function dangerousStyleValue(name, value, isCustomProperty) {
    if (value == null || typeof value === 'boolean' || value === '') return '';
    if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
    return ('' + value).trim();
}
const attributeCache = {};
injectCreateAnimatedStyle((style)=>new AnimatedStyle(style));
injectDefaultElement('div');
injectInterpolation(createInterpolation);
injectColorNames(colors);
injectBugfixes(fixAuto);
injectApplyAnimatedValues((instance, props)=>{
    if (instance.nodeType && instance.setAttribute !== undefined) {
        const style = props.style, children = props.children, scrollTop = props.scrollTop, scrollLeft = props.scrollLeft, attributes = _objectWithoutPropertiesLoose(props, [
            "style",
            "children",
            "scrollTop",
            "scrollLeft"
        ]);
        if (scrollTop !== void 0) instance.scrollTop = scrollTop;
        if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft; // Set textContent, if children is an animatable value
        if (children !== void 0) instance.textContent = children; // Set styles ...
        for(let styleName in style){
            if (!style.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            var styleValue = dangerousStyleValue(styleName, style[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) instance.style.setProperty(styleName, styleValue);
            else instance.style[styleName] = styleValue;
        } // Set attributes ...
        for(let name in attributes){
            // Attributes are written in dash case
            const dashCase = attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, (n)=>'-' + n.toLowerCase()));
            if (typeof instance.getAttribute(dashCase) !== 'undefined') instance.setAttribute(dashCase, attributes[name]);
        }
    } else return false;
}, (style)=>style);
let active = false;
const controllers = new Set();
const frameLoop = ()=>{
    let time = now();
    for (let controller of controllers){
        let isDone = true;
        let noChange = true;
        for(let configIdx = 0; configIdx < controller.configs.length; configIdx++){
            let config = controller.configs[configIdx];
            let endOfAnimation, lastTime;
            for(let valIdx = 0; valIdx < config.animatedValues.length; valIdx++){
                let animation = config.animatedValues[valIdx]; // If an animation is done, skip, until all of them conclude
                if (animation.done) continue;
                let from = config.fromValues[valIdx];
                let to = config.toValues[valIdx];
                let position = animation.lastPosition;
                let isAnimated = to instanceof Animated;
                let velocity = Array.isArray(config.initialVelocity) ? config.initialVelocity[valIdx] : config.initialVelocity;
                if (isAnimated) to = to.getValue(); // Conclude animation if it's either immediate, or from-values match end-state
                if (config.immediate || !isAnimated && !config.decay && from === to) {
                    animation.updateValue(to);
                    animation.done = true;
                    continue;
                } // Doing delay here instead of setTimeout is one async worry less
                if (config.delay && time - controller.startTime < config.delay) {
                    isDone = false;
                    continue;
                } // Flag change
                noChange = false; // Break animation when string values are involved
                if (typeof from === 'string' || typeof to === 'string') {
                    animation.updateValue(to);
                    animation.done = true;
                    continue;
                }
                if (config.duration !== void 0) {
                    /** Duration easing */ position = from + config.easing((time - controller.startTime - config.delay) / config.duration) * (to - from);
                    endOfAnimation = time >= controller.startTime + config.delay + config.duration;
                } else if (config.decay) {
                    /** Decay easing */ position = from + velocity / (1 - 0.998) * (1 - Math.exp(-(1 - 0.998) * (time - controller.startTime)));
                    endOfAnimation = Math.abs(animation.lastPosition - position) < 0.1;
                    if (endOfAnimation) to = position;
                } else {
                    /** Spring easing */ lastTime = animation.lastTime !== void 0 ? animation.lastTime : time;
                    velocity = animation.lastVelocity !== void 0 ? animation.lastVelocity : config.initialVelocity; // If we lost a lot of frames just jump to the end.
                    if (time > lastTime + 64) lastTime = time; // http://gafferongames.com/game-physics/fix-your-timestep/
                    let numSteps = Math.floor(time - lastTime);
                    for(let i = 0; i < numSteps; ++i){
                        let force = -config.tension * (position - to);
                        let damping = -config.friction * velocity;
                        let acceleration = (force + damping) / config.mass;
                        velocity = velocity + acceleration * 1 / 1000;
                        position = position + velocity * 1 / 1000;
                    } // Conditions for stopping the spring animation
                    let isOvershooting = config.clamp && config.tension !== 0 ? from < to ? position > to : position < to : false;
                    let isVelocity = Math.abs(velocity) <= config.precision;
                    let isDisplacement = config.tension !== 0 ? Math.abs(to - position) <= config.precision : true;
                    endOfAnimation = isOvershooting || isVelocity && isDisplacement;
                    animation.lastVelocity = velocity;
                    animation.lastTime = time;
                } // Trails aren't done until their parents conclude
                if (isAnimated && !config.toValues[valIdx].done) endOfAnimation = false;
                if (endOfAnimation) {
                    // Ensure that we end up with a round value
                    if (animation.value !== to) position = to;
                    animation.done = true;
                } else isDone = false;
                animation.updateValue(position);
                animation.lastPosition = position;
            } // Keep track of updated values only when necessary
            if (controller.props.onFrame || !controller.props.native) controller.animatedProps[config.name] = config.interpolation.getValue();
        } // Update callbacks in the end of the frame
        if (controller.props.onFrame || !controller.props.native) {
            if (!controller.props.native && controller.onUpdate) controller.onUpdate();
            if (controller.props.onFrame) controller.props.onFrame(controller.animatedProps);
        } // Either call onEnd or next frame
        if (isDone) {
            controllers.delete(controller);
            controller.debouncedOnEnd({
                finished: true,
                noChange
            });
        }
    } // Loop over as long as there are controllers ...
    if (controllers.size) requestFrame(frameLoop);
    else active = false;
};
const addController = (controller)=>{
    if (!controllers.has(controller)) {
        controllers.add(controller);
        if (!active) requestFrame(frameLoop);
        active = true;
    }
};
const removeController = (controller)=>{
    if (controllers.has(controller)) controllers.delete(controller);
};
class Controller {
    constructor(props, config){
        if (config === void 0) config = {
            native: true,
            interpolateTo: true,
            autoStart: true
        };
        this.getValues = ()=>this.props.native ? this.interpolations : this.animatedProps;
        this.dependents = new Set();
        this.isActive = false;
        this.hasChanged = false;
        this.props = {};
        this.merged = {};
        this.animations = {};
        this.interpolations = {};
        this.animatedProps = {};
        this.configs = [];
        this.frame = undefined;
        this.startTime = undefined;
        this.lastTime = undefined;
        this.update(_extends({}, props, config));
    }
    update(props) {
        this.props = _extends({}, this.props, props);
        let _ref = this.props.interpolateTo ? interpolateTo(this.props) : this.props, _ref$from = _ref.from, from = _ref$from === void 0 ? {} : _ref$from, _ref$to = _ref.to, to = _ref$to === void 0 ? {} : _ref$to, _ref$config = _ref.config, config = _ref$config === void 0 ? {} : _ref$config, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, reverse = _ref.reverse, attach = _ref.attach, reset = _ref.reset, immediate = _ref.immediate, autoStart = _ref.autoStart, ref = _ref.ref; // Reverse values when requested
        if (reverse) {
            var _ref2 = [
                to,
                from
            ];
            from = _ref2[0];
            to = _ref2[1];
        }
        this.hasChanged = false; // Attachment handling, trailed springs can "attach" themselves to a previous spring
        let target = attach && attach(this); // Reset merged props when necessary
        let extra = reset ? {} : this.merged; // This will collect all props that were ever set
        this.merged = _extends({}, from, extra, to); // Reduces input { name: value } pairs into animated values
        this.animations = Object.entries(this.merged).reduce((acc, _ref3, i)=>{
            let name = _ref3[0], value = _ref3[1];
            // Issue cached entries, except on reset
            let entry = !reset && acc[name] || {}; // Figure out what the value is supposed to be
            const isNumber = typeof value === 'number';
            const isString = typeof value === 'string' && !value.startsWith('#') && !/\d/.test(value) && !colorNames[value];
            const isArray = !isNumber && !isString && Array.isArray(value);
            let fromValue = from[name] !== undefined ? from[name] : value;
            let toValue = isNumber || isArray ? value : isString ? value : 1;
            let toConfig = callProp(config, name);
            if (target) toValue = target.animations[name].parent; // Detect changes, animated values will be checked in the raf-loop
            if (toConfig.decay !== void 0 || !shallowEqual(entry.changes, value)) {
                this.hasChanged = true;
                let parent, interpolation$$1;
                if (isNumber || isString) parent = interpolation$$1 = entry.parent || new AnimatedValue(fromValue);
                else if (isArray) parent = interpolation$$1 = entry.parent || new AnimatedArray(fromValue);
                else {
                    const prev = entry.interpolation && entry.interpolation.calc(entry.parent.value);
                    if (entry.parent) {
                        parent = entry.parent;
                        parent.setValue(0, false);
                    } else parent = new AnimatedValue(0);
                    const range = {
                        output: [
                            prev !== void 0 ? prev : fromValue,
                            value
                        ]
                    };
                    if (entry.interpolation) {
                        interpolation$$1 = entry.interpolation;
                        entry.interpolation.updateConfig(range);
                    } else interpolation$$1 = parent.interpolate(range);
                } // Set immediate values
                if (callProp(immediate, name)) parent.setValue(value, false); // Reset animated values
                const animatedValues = toArray(parent.getPayload());
                animatedValues.forEach((value)=>value.prepare(this));
                return _extends({}, acc, {
                    [name]: _extends({}, entry, {
                        name,
                        parent,
                        interpolation: interpolation$$1,
                        animatedValues,
                        changes: value,
                        fromValues: toArray(parent.getValue()),
                        toValues: toArray(target ? toValue.getPayload() : toValue),
                        immediate: callProp(immediate, name),
                        delay: withDefault(toConfig.delay, delay || 0),
                        initialVelocity: withDefault(toConfig.velocity, 0),
                        clamp: withDefault(toConfig.clamp, false),
                        precision: withDefault(toConfig.precision, 0.01),
                        tension: withDefault(toConfig.tension, 170),
                        friction: withDefault(toConfig.friction, 26),
                        mass: withDefault(toConfig.mass, 1),
                        duration: toConfig.duration,
                        easing: withDefault(toConfig.easing, (t)=>t),
                        decay: toConfig.decay
                    })
                });
            } else return acc;
        }, this.animations);
        if (this.hasChanged) {
            this.configs = getValues$1(this.animations);
            this.animatedProps = {};
            this.interpolations = {};
            for(let key in this.animations){
                this.interpolations[key] = this.animations[key].interpolation;
                this.animatedProps[key] = this.animations[key].interpolation.getValue();
            }
        } // TODO: clean up ref in controller
        for(var _len = arguments.length, start = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)start[_key - 1] = arguments[_key];
        if (!ref && (autoStart || start.length)) this.start(...start);
        const onEnd = start[0], onUpdate = start[1];
        this.onEnd = typeof onEnd === 'function' && onEnd;
        this.onUpdate = onUpdate;
        return this.getValues();
    }
    start(onEnd, onUpdate) {
        this.startTime = now();
        if (this.isActive) this.stop();
        this.isActive = true;
        this.onEnd = typeof onEnd === 'function' && onEnd;
        this.onUpdate = onUpdate;
        if (this.props.onStart) this.props.onStart();
        addController(this);
        return new Promise((res)=>this.resolve = res);
    }
    stop(finished) {
        if (finished === void 0) finished = false;
        // Reset collected changes since the animation has been stopped cold turkey
        if (finished) getValues$1(this.animations).forEach((a)=>a.changes = undefined);
        this.debouncedOnEnd({
            finished
        });
    }
    destroy() {
        removeController(this);
        this.props = {};
        this.merged = {};
        this.animations = {};
        this.interpolations = {};
        this.animatedProps = {};
        this.configs = [];
    }
    debouncedOnEnd(result) {
        removeController(this);
        this.isActive = false;
        const onEnd = this.onEnd;
        this.onEnd = null;
        if (onEnd) onEnd(result);
        if (this.resolve) this.resolve();
        this.resolve = null;
    }
}
class AnimatedProps extends AnimatedObjectWithChildren {
    constructor(props, callback){
        super();
        if (props.style) props = _extends({}, props, {
            style: createAnimatedStyle(props.style)
        });
        this.payload = props;
        this.update = callback;
        this.attach();
    }
}
function createAnimatedComponent(Component) {
    class AnimatedComponent extends React__default.Component {
        constructor(props){
            super();
            this.callback = ()=>{
                if (this.node) {
                    const didUpdate = applyAnimatedValues.fn(this.node, this.propsAnimated.getAnimatedValue(), this);
                    if (didUpdate === false) this.forceUpdate();
                }
            };
            this.attachProps(props);
        }
        componentWillUnmount() {
            this.propsAnimated && this.propsAnimated.detach();
        }
        setNativeProps(props) {
            const didUpdate = applyAnimatedValues.fn(this.node, props, this);
            if (didUpdate === false) this.forceUpdate();
        }
        // able to avoid re-rendering and directly set the attributes that
        // changed. However, setNativeProps can only be implemented on leaf
        // native components. If you want to animate a composite component, you
        // need to re-render it. In this case, we have a fallback that uses
        // forceUpdate.
        attachProps(_ref) {
            let forwardRef = _ref.forwardRef, nextProps = _objectWithoutPropertiesLoose(_ref, [
                "forwardRef"
            ]);
            const oldPropsAnimated = this.propsAnimated;
            this.propsAnimated = new AnimatedProps(nextProps, this.callback); // When you call detach, it removes the element from the parent list
            // of children. If it goes to 0, then the parent also detaches itself
            // and so on.
            // An optimization is to attach the new elements and THEN detach the old
            // ones instead of detaching and THEN attaching.
            // This way the intermediate state isn't to go to 0 and trigger
            // this expensive recursive detaching to then re-attach everything on
            // the very next operation.
            oldPropsAnimated && oldPropsAnimated.detach();
        }
        shouldComponentUpdate(props) {
            const style = props.style, nextProps = _objectWithoutPropertiesLoose(props, [
                "style"
            ]);
            const _this$props = this.props, currentStyle = _this$props.style, currentProps = _objectWithoutPropertiesLoose(_this$props, [
                "style"
            ]);
            if (!shallowEqual(currentProps, nextProps) || !shallowEqual(currentStyle, style)) {
                this.attachProps(props);
                return true;
            }
            return false;
        }
        render() {
            const _this$propsAnimated$g = this.propsAnimated.getValue(), scrollTop = _this$propsAnimated$g.scrollTop, scrollLeft = _this$propsAnimated$g.scrollLeft, animatedProps = _objectWithoutPropertiesLoose(_this$propsAnimated$g, [
                "scrollTop",
                "scrollLeft"
            ]);
            return React__default.createElement(Component, _extends({}, animatedProps, {
                ref: (node)=>this.node = handleRef(node, this.props.forwardRef)
            }));
        }
    }
    return React__default.forwardRef((props, ref)=>React__default.createElement(AnimatedComponent, _extends({}, props, {
            forwardRef: ref
        })));
}
const config = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
class Spring extends React__default.Component {
    constructor(){
        super(...arguments);
        this.state = {
            lastProps: {
                from: {},
                to: {}
            },
            propsChanged: false,
            internal: false
        };
        this.controller = new Controller(null, null);
        this.didUpdate = false;
        this.didInject = false;
        this.finished = true;
        this.start = ()=>{
            this.finished = false;
            let wasMounted = this.mounted;
            this.controller.start((props)=>this.finish(_extends({}, props, {
                    wasMounted
                })), this.update);
        };
        this.stop = ()=>this.controller.stop(true);
        this.update = ()=>this.mounted && this.setState({
                internal: true
            });
        this.finish = (_ref)=>{
            let finished = _ref.finished, noChange = _ref.noChange, wasMounted = _ref.wasMounted;
            this.finished = true;
            if (this.mounted && finished) {
                // Only call onRest if either we *were* mounted, or when there were changes
                if (this.props.onRest && (wasMounted || !noChange)) this.props.onRest(this.controller.merged); // Restore end-state
                if (this.mounted && this.didInject) {
                    this.afterInject = convertValues(this.props);
                    this.setState({
                        internal: true
                    });
                } // If we have an inject or values to apply after the animation we ping here
                if (this.mounted && (this.didInject || this.props.after)) this.setState({
                    internal: true
                });
                this.didInject = false;
            }
        };
    }
    componentDidMount() {
        // componentDidUpdate isn't called on mount, we call it here to start animating
        this.componentDidUpdate();
        this.mounted = true;
    }
    componentWillUnmount() {
        // Stop all ongoing animtions
        this.mounted = false;
        this.stop();
    }
    static getDerivedStateFromProps(props, _ref2) {
        let internal = _ref2.internal, lastProps = _ref2.lastProps;
        // The following is a test against props that could alter the animation
        const from = props.from, to = props.to, reset = props.reset, force = props.force;
        const propsChanged = !shallowEqual(to, lastProps.to) || !shallowEqual(from, lastProps.from) || reset && !internal || force && !internal;
        return {
            propsChanged,
            lastProps: props,
            internal: false
        };
    }
    render() {
        const children = this.props.children;
        const propsChanged = this.state.propsChanged; // Inject phase -----------------------------------------------------------
        // Handle injected frames, for instance targets/web/fix-auto
        // An inject will return an intermediary React node which measures itself out
        // .. and returns a callback when the values sought after are ready, usually "auto".
        if (this.props.inject && propsChanged && !this.injectProps) {
            const frame = this.props.inject(this.props, (injectProps)=>{
                // The inject frame has rendered, now let's update animations...
                this.injectProps = injectProps;
                this.setState({
                    internal: true
                });
            }); // Render out injected frame
            if (frame) return frame;
        } // Update phase -----------------------------------------------------------
        if (this.injectProps || propsChanged) {
            // We can potentially cause setState, but we're inside render, the flag prevents that
            this.didInject = false; // Update animations, this turns from/to props into AnimatedValues
            // An update can occur on injected props, or when own-props have changed.
            if (this.injectProps) {
                this.controller.update(this.injectProps); // didInject is needed, because there will be a 3rd stage, where the original values
                // .. will be restored after the animation is finished. When someone animates towards
                // .. "auto", the end-result should be "auto", not "1999px", which would block nested
                // .. height/width changes.
                this.didInject = true;
            } else if (propsChanged) this.controller.update(this.props); // Flag an update that occured, componentDidUpdate will start the animation later on
            this.didUpdate = true;
            this.afterInject = undefined;
            this.injectProps = undefined;
        } // Render phase -----------------------------------------------------------
        // Render out raw values or AnimatedValues depending on "native"
        let values = _extends({}, this.controller.getValues(), this.afterInject);
        if (this.finished) values = _extends({}, values, this.props.after);
        return Object.keys(values).length ? children(values) : null;
    }
    componentDidUpdate() {
        // The animation has to start *after* render, since at that point the scene
        // .. graph should be established, so we do it here. Unfortunatelly, non-native
        // .. animations as well as "auto"-injects call forceUpdate, so it's causing a loop.
        // .. didUpdate prevents that as it gets set only on prop changes.
        if (this.didUpdate) this.start();
        this.didUpdate = false;
    }
}
Spring.defaultProps = {
    from: {},
    to: {},
    config: config.default,
    native: false,
    immediate: false,
    reset: false,
    force: false,
    inject: bugfixes
};
class Trail extends React__default.PureComponent {
    constructor(){
        super(...arguments);
        this.first = true;
        this.instances = new Set();
        this.hook = (instance, index, length, reverse)=>{
            // Add instance to set
            this.instances.add(instance); // Return undefined on the first index and from then on the previous instance
            if (reverse ? index === length - 1 : index === 0) return undefined;
            else return Array.from(this.instances)[reverse ? index + 1 : index - 1];
        };
    }
    render() {
        const _this$props = this.props, items = _this$props.items, _children = _this$props.children, _this$props$from = _this$props.from, from = _this$props$from === void 0 ? {} : _this$props$from, initial = _this$props.initial, reverse = _this$props.reverse, keys = _this$props.keys, delay = _this$props.delay, onRest = _this$props.onRest, props = _objectWithoutPropertiesLoose(_this$props, [
            "items",
            "children",
            "from",
            "initial",
            "reverse",
            "keys",
            "delay",
            "onRest"
        ]);
        const array = toArray(items);
        return toArray(array).map((item, i)=>React__default.createElement(Spring, _extends({
                onRest: i === 0 ? onRest : null,
                key: typeof keys === 'function' ? keys(item) : toArray(keys)[i],
                from: this.first && initial !== void 0 ? initial || {} : from
            }, props, {
                delay: i === 0 && delay || undefined,
                attach: (instance)=>this.hook(instance, i, array.length, reverse),
                children: (props)=>{
                    const child = _children(item, i);
                    return child ? child(props) : null;
                }
            })));
    }
    componentDidUpdate(prevProps) {
        this.first = false;
        if (prevProps.items !== this.props.items) this.instances.clear();
    }
}
Trail.defaultProps = {
    keys: (item)=>item
};
const DEFAULT = '__default';
class KeyframesImpl extends React__default.PureComponent {
    constructor(){
        var _this;
        super(...arguments);
        _this = this;
        this.guid = 0;
        this.state = {
            props: {},
            resolve: ()=>null,
            last: true,
            index: 0
        };
        this.next = function(props, last, index) {
            if (last === void 0) last = true;
            if (index === void 0) index = 0;
            _this.running = true;
            return new Promise((resolve)=>{
                _this.mounted && _this.setState((state)=>({
                        props,
                        resolve,
                        last,
                        index
                    }), ()=>_this.running = false);
            });
        };
    }
    componentDidMount() {
        this.mounted = true;
        this.componentDidUpdate({});
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    componentDidUpdate(previous) {
        var _this2 = this;
        const _this$props = this.props, states = _this$props.states, f = _this$props.filter, state = _this$props.state;
        if (previous.state !== this.props.state || this.props.reset && !this.running || !shallowEqual(states[state], previous.states[previous.state])) {
            if (states && state && states[state]) {
                const localId = ++this.guid;
                const slots = states[state];
                if (slots) {
                    if (Array.isArray(slots)) {
                        let q = Promise.resolve();
                        for(let i = 0; i < slots.length; i++){
                            let index = i;
                            let slot = slots[index];
                            let last = index === slots.length - 1;
                            q = q.then(()=>localId === this.guid && this.next(f(slot), last, index));
                        }
                    } else if (typeof slots === 'function') {
                        let index = 0;
                        slots(function(props, last) {
                            if (last === void 0) last = false;
                            return localId === _this2.guid && _this2.next(f(props), last, index++);
                        }, ()=>requestFrame(()=>this.instance && this.instance.stop()), this.props);
                    } else this.next(f(states[state]));
                }
            }
        }
    }
    render() {
        const _this$state = this.state, props = _this$state.props, resolve = _this$state.resolve, last = _this$state.last, index = _this$state.index;
        if (!props || Object.keys(props).length === 0) return null;
        let _this$props2 = this.props, state = _this$props2.state, filter = _this$props2.filter, states = _this$props2.states, config = _this$props2.config, Component = _this$props2.primitive, _onRest = _this$props2.onRest, forwardRef = _this$props2.forwardRef, rest = _objectWithoutPropertiesLoose(_this$props2, [
            "state",
            "filter",
            "states",
            "config",
            "primitive",
            "onRest",
            "forwardRef"
        ]); // Arrayed configs need an index to process
        if (Array.isArray(config)) config = config[index];
        return React__default.createElement(Component, _extends({
            ref: (_ref)=>this.instance = handleRef(_ref, forwardRef),
            config: config
        }, rest, props, {
            onRest: (args)=>{
                resolve(args);
                if (_onRest && last) _onRest(args);
            }
        }));
    }
}
KeyframesImpl.defaultProps = {
    state: DEFAULT
};
const Keyframes = React__default.forwardRef((props, ref)=>React__default.createElement(KeyframesImpl, _extends({}, props, {
        forwardRef: ref
    })));
Keyframes.create = (primitive)=>function(states, filter) {
        if (filter === void 0) filter = (states)=>states;
        if (typeof states === 'function' || Array.isArray(states)) states = {
            [DEFAULT]: states
        };
        return (props)=>React__default.createElement(KeyframesImpl, _extends({
                primitive: primitive,
                states: states,
                filter: filter
            }, props));
    };
Keyframes.Spring = (states)=>Keyframes.create(Spring)(states, interpolateTo);
Keyframes.Trail = (states)=>Keyframes.create(Trail)(states, interpolateTo);
let guid = 0;
let get = (props)=>{
    let items = props.items, keys = props.keys, rest = _objectWithoutPropertiesLoose(props, [
        "items",
        "keys"
    ]);
    items = toArray(items !== void 0 ? items : null);
    keys = typeof keys === 'function' ? items.map(keys) : toArray(keys); // Make sure numeric keys are interpreted as Strings (5 !== "5")
    return _extends({
        items,
        keys: keys.map((key)=>String(key))
    }, rest);
};
class Transition extends React__default.PureComponent {
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    constructor(prevProps){
        super(prevProps);
        this.destroyItem = (item, key, state)=>(values)=>{
                const _this$props = this.props, onRest = _this$props.onRest, onDestroyed = _this$props.onDestroyed;
                if (this.mounted) {
                    onDestroyed && onDestroyed(item);
                    this.setState((_ref)=>{
                        let deleted = _ref.deleted;
                        return {
                            deleted: deleted.filter((t)=>t.key !== key)
                        };
                    });
                    onRest && onRest(item, state, values);
                }
            };
        this.state = {
            first: true,
            transitions: [],
            current: {},
            deleted: [],
            prevProps
        };
    }
    static getDerivedStateFromProps(props, _ref2) {
        let first = _ref2.first, prevProps = _ref2.prevProps, state = _objectWithoutPropertiesLoose(_ref2, [
            "first",
            "prevProps"
        ]);
        let _get = get(props), items = _get.items, keys = _get.keys, initial = _get.initial, from = _get.from, enter = _get.enter, leave = _get.leave, update = _get.update, _get$trail = _get.trail, trail = _get$trail === void 0 ? 0 : _get$trail, unique = _get.unique, config = _get.config;
        let _get2 = get(prevProps), _keys = _get2.keys, _items = _get2.items;
        let current = _extends({}, state.current);
        let deleted = [
            ...state.deleted
        ]; // Compare next keys with current keys
        let currentKeys = Object.keys(current);
        let currentSet = new Set(currentKeys);
        let nextSet = new Set(keys);
        let added = keys.filter((item)=>!currentSet.has(item));
        let removed = state.transitions.filter((item)=>!item.destroyed && !nextSet.has(item.originalKey)).map((i)=>i.originalKey);
        let updated = keys.filter((item)=>currentSet.has(item));
        let delay = 0;
        added.forEach((key)=>{
            // In unique mode, remove fading out transitions if their key comes in again
            if (unique && deleted.find((d)=>d.originalKey === key)) deleted = deleted.filter((t)=>t.originalKey !== key);
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const state = 'enter';
            current[key] = {
                state,
                originalKey: key,
                key: unique ? String(key) : guid++,
                item,
                trail: delay = delay + trail,
                config: callProp(config, item, state),
                from: callProp(first ? initial !== void 0 ? initial || {} : from : from, item),
                to: callProp(enter, item)
            };
        });
        removed.forEach((key)=>{
            const keyIndex = _keys.indexOf(key);
            const item = _items[keyIndex];
            const state = 'leave';
            deleted.push(_extends({}, current[key], {
                state,
                destroyed: true,
                left: _keys[Math.max(0, keyIndex - 1)],
                right: _keys[Math.min(_keys.length, keyIndex + 1)],
                trail: delay = delay + trail,
                config: callProp(config, item, state),
                to: callProp(leave, item)
            }));
            delete current[key];
        });
        updated.forEach((key)=>{
            const keyIndex = keys.indexOf(key);
            const item = items[keyIndex];
            const state = 'update';
            current[key] = _extends({}, current[key], {
                item,
                state,
                trail: delay = delay + trail,
                config: callProp(config, item, state),
                to: callProp(update, item)
            });
        }); // This tries to restore order for deleted items by finding their last known siblings
        let out = keys.map((key)=>current[key]);
        deleted.forEach((_ref3)=>{
            let left = _ref3.left, right = _ref3.right, transition = _objectWithoutPropertiesLoose(_ref3, [
                "left",
                "right"
            ]);
            let pos; // Was it the element on the left, if yes, move there ...
            if ((pos = out.findIndex((t)=>t.originalKey === left)) !== -1) pos += 1; // Or how about the element on the right ...
            if (pos === -1) pos = out.findIndex((t)=>t.originalKey === right); // Maybe we'll find it in the list of deleted items
            if (pos === -1) pos = deleted.findIndex((t)=>t.originalKey === left); // Checking right side as well
            if (pos === -1) pos = deleted.findIndex((t)=>t.originalKey === right); // And if nothing else helps, move it to the start ¯\_(ツ)_/¯
            pos = Math.max(0, pos);
            out = [
                ...out.slice(0, pos),
                transition,
                ...out.slice(pos)
            ];
        });
        return {
            first: first && added.length === 0,
            transitions: out,
            current,
            deleted,
            prevProps: props
        };
    }
    render() {
        const _this$props2 = this.props, initial = _this$props2.initial, _this$props2$from = _this$props2.from, _this$props2$enter = _this$props2.enter, _this$props2$leave = _this$props2.leave, _this$props2$update = _this$props2.update, onDestroyed = _this$props2.onDestroyed, keys = _this$props2.keys, items = _this$props2.items, onFrame = _this$props2.onFrame, onRest = _this$props2.onRest, onStart = _this$props2.onStart, trail = _this$props2.trail, config = _this$props2.config, _children = _this$props2.children, unique = _this$props2.unique, reset = _this$props2.reset, extra = _objectWithoutPropertiesLoose(_this$props2, [
            "initial",
            "from",
            "enter",
            "leave",
            "update",
            "onDestroyed",
            "keys",
            "items",
            "onFrame",
            "onRest",
            "onStart",
            "trail",
            "config",
            "children",
            "unique",
            "reset"
        ]);
        return this.state.transitions.map((_ref4, i)=>{
            let state = _ref4.state, key = _ref4.key, item = _ref4.item, from = _ref4.from, to = _ref4.to, trail = _ref4.trail, config = _ref4.config, destroyed = _ref4.destroyed;
            return React__default.createElement(Keyframes, _extends({
                reset: reset && state === 'enter',
                primitive: Spring,
                state: state,
                filter: interpolateTo,
                states: {
                    [state]: to
                },
                key: key,
                onRest: destroyed ? this.destroyItem(item, key, state) : onRest && ((values)=>onRest(item, state, values)),
                onStart: onStart && (()=>onStart(item, state)),
                onFrame: onFrame && ((values)=>onFrame(item, state, values)),
                delay: trail,
                config: config
            }, extra, {
                from: from,
                children: (props)=>{
                    const child = _children(item, state, i);
                    return child ? child(props) : null;
                }
            }));
        });
    }
}
Transition.defaultProps = {
    keys: (item)=>item,
    unique: false,
    reset: false
};
const domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
const extendedAnimated = domElements.reduce((acc, element)=>{
    acc[element] = createAnimatedComponent(element);
    return acc;
}, createAnimatedComponent);
exports.Spring = Spring;
exports.Keyframes = Keyframes;
exports.Transition = Transition;
exports.Trail = Trail;
exports.Controller = Controller;
exports.config = config;
exports.animated = extendedAnimated;
exports.interpolate = interpolate$1;
exports.Globals = Globals;

},{"9a9f22394397a59e":"jGdYV","f91ee12b9f700ab4":"aAOJb","6acf65edf5df1d30":"9njXz","74b022ca4bdb31a0":"2ApDx"}],"82gpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
parcelHelpers.export(exports, "IconLink", ()=>IconLink);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _icons = require("resources/icons");
var _iconsDefault = parcelHelpers.interopDefault(_icons);
var _context = require("teacher/context");
function Icon(props) {
    const MyIcon = (0, _react.useMemo)(()=>{
        const MyIcon = (0, _iconsDefault.default)[props.name];
        return MyIcon || /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
            children: "Missing Icon"
        });
    }, [
        props.name
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MyIcon, {
        ...props
    });
}
function IconLink(props) {
    const { icon } = props;
    const { translate } = (0, _react.useContext)((0, _context.TeacherContext));
    const linkProps = (0, _react.useMemo)(()=>(0, _lodash.omit)(props, [
            'icon',
            'label'
        ]), [
        props
    ]);
    const label = (0, _react.useMemo)(()=>translate(props.label), [
        translate,
        props.label
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
        ...linkProps,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                name: icon
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "label",
                children: label
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/lodash":"5bCAQ","external/react":"k16GP","resources/icons":"7BMUb","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bCAQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orderBy", ()=>(0, _orderByDefault.default));
parcelHelpers.export(exports, "pickBy", ()=>(0, _pickByDefault.default));
parcelHelpers.export(exports, "omit", ()=>(0, _omitDefault.default));
parcelHelpers.export(exports, "cloneDeep", ()=>(0, _cloneDeepDefault.default));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArrayDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeDefault.default));
var _orderBy = require("lodash/orderBy");
var _orderByDefault = parcelHelpers.interopDefault(_orderBy);
var _pickBy = require("lodash/pickBy");
var _pickByDefault = parcelHelpers.interopDefault(_pickBy);
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _cloneDeep = require("lodash/cloneDeep");
var _cloneDeepDefault = parcelHelpers.interopDefault(_cloneDeep);
var _toArray = require("lodash/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
var _range = require("lodash/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);

},{"lodash/orderBy":"kdfP9","lodash/pickBy":"jfoze","lodash/omit":"fhxvC","lodash/cloneDeep":"kA4yF","lodash/toArray":"lJju3","lodash/range":"3NTTt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kdfP9":[function(require,module,exports,__globalThis) {
var baseOrderBy = require("9824fb2bf691dd6b"), isArray = require("68c07660ca0a6ddb");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    return baseOrderBy(collection, iteratees, orders);
}
module.exports = orderBy;

},{"9824fb2bf691dd6b":"f3iLf","68c07660ca0a6ddb":"1DVeR"}],"f3iLf":[function(require,module,exports,__globalThis) {
var arrayMap = require("8b3be8ab05c5c021"), baseGet = require("56eb179604ce4d19"), baseIteratee = require("41950d167c7e12b5"), baseMap = require("b09740a39499ec43"), baseSortBy = require("35a9013ca73ef017"), baseUnary = require("b387a5b76e29e664"), compareMultiple = require("2ab709818f44804c"), identity = require("5cb379329c706719"), isArray = require("8acdbb462385356c");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
        if (isArray(iteratee)) return function(value) {
            return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        identity
    ];
    var index = -1;
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
    });
}
module.exports = baseOrderBy;

},{"8b3be8ab05c5c021":"chzeu","56eb179604ce4d19":"5Vkba","41950d167c7e12b5":"6jZAq","b09740a39499ec43":"8JEHD","35a9013ca73ef017":"1dFrx","b387a5b76e29e664":"jVyhK","2ab709818f44804c":"9XLey","5cb379329c706719":"2HXBf","8acdbb462385356c":"1DVeR"}],"8JEHD":[function(require,module,exports,__globalThis) {
var baseEach = require("488df795cf6fe570"), isArrayLike = require("2924e2db4bb5430d");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function baseMap(collection, iteratee) {
    var index = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
    baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = baseMap;

},{"488df795cf6fe570":"hbtgh","2924e2db4bb5430d":"kzICo"}],"hbtgh":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"i7P4y","f1e3fc84161ef3ec":"bY6r9"}],"i7P4y":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"9oLrx","1fb77c53defe5720":"9qKxr"}],"bY6r9":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"kzICo"}],"1dFrx":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = baseSortBy;

},{}],"9XLey":[function(require,module,exports,__globalThis) {
var compareAscending = require("dd5e23e02b1cd726");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = compareMultiple;

},{"dd5e23e02b1cd726":"e5XoH"}],"e5XoH":[function(require,module,exports,__globalThis) {
var isSymbol = require("a51b63ee8daeecee");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = compareAscending;

},{"a51b63ee8daeecee":"fMaHV"}],"fhxvC":[function(require,module,exports,__globalThis) {
var arrayMap = require("edf8d2f2f36e65cf"), baseClone = require("dd27ddc2340179e5"), baseUnset = require("589767d435c41297"), castPath = require("565c158f6d380e60"), copyObject = require("9b4f3122fc9cc1a6"), customOmitClone = require("1c19467b6c51de37"), flatRest = require("24ab2b6e4b71312a"), getAllKeysIn = require("e20a1a7cbb58999e");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var omit = flatRest(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    copyObject(object, getAllKeysIn(object), result);
    if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
    var length = paths.length;
    while(length--)baseUnset(result, paths[length]);
    return result;
});
module.exports = omit;

},{"edf8d2f2f36e65cf":"chzeu","dd27ddc2340179e5":"dqsfF","589767d435c41297":"dGTca","565c158f6d380e60":"1tEcE","9b4f3122fc9cc1a6":"vDc33","1c19467b6c51de37":"bUGk9","24ab2b6e4b71312a":"j0z0i","e20a1a7cbb58999e":"iZ6gY"}],"dqsfF":[function(require,module,exports,__globalThis) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"cltFt","3a79976eb46af94a":"gM7YB","bc83a05a4f99d69b":"aKTSf","e6b4c3e6c85df6bb":"7HkQg","f340cc553ba5643c":"c7Ii5","e72e99883a50402d":"aNaSh","dc840ead07f1054":"lWbYv","309288e8ee190af0":"4A2Va","687fa30fede0b048":"7bLYw","bb0ba724f98b094d":"lOHy9","12bae1dca0e83064":"iZ6gY","4c3204eaea28d680":"1chae","fd7741200b462cdf":"cSkwN","f93a1d24ac08e076":"jeUN0","630039e80f692f17":"fGkGx","f37949484ab52dae":"1DVeR","ac876cc65d29c86e":"26W2O","1056c031d98783c0":"hm6iH","1800fb3122907fc2":"6hgJK","31f022f648037bd3":"7SeAd","5f3267fbd9848a7d":"9qKxr","7d3f3bdc4f2e7bb8":"6emcB"}],"gM7YB":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"7HkQg":[function(require,module,exports,__globalThis) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"vDc33","fcf23a0242ef0da9":"9qKxr"}],"c7Ii5":[function(require,module,exports,__globalThis) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"vDc33","7697a1565646c93":"6emcB"}],"4A2Va":[function(require,module,exports,__globalThis) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"vDc33","39cbde2205d9399c":"igqw1"}],"7bLYw":[function(require,module,exports,__globalThis) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"vDc33","9b660e6b0c20d303":"IRyaH"}],"cSkwN":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"jeUN0":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"ZLaCu","dbf04edaab2ae376":"kzyXT","763300f2dd9bdaf3":"aRqyO","c30e64d90e4b92d1":"2D8ix","d1edd8349e9ad54d":"WFexx"}],"kzyXT":[function(require,module,exports,__globalThis) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"ZLaCu"}],"aRqyO":[function(require,module,exports,__globalThis) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"2D8ix":[function(require,module,exports,__globalThis) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"crlKT"}],"hm6iH":[function(require,module,exports,__globalThis) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"iXyzE","6a7e6b1a2d9fb1d5":"jVyhK","7d4f449dd306450f":"bPzLC"}],"iXyzE":[function(require,module,exports,__globalThis) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"1chae","88260e33e0003386":"4gOki"}],"7SeAd":[function(require,module,exports,__globalThis) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"2H7vq","3cb35dba719c68b1":"jVyhK","7a3e899a332ff7be":"bPzLC"}],"2H7vq":[function(require,module,exports,__globalThis) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"1chae","b6fc875bc5f351c9":"4gOki"}],"dGTca":[function(require,module,exports,__globalThis) {
var castPath = require("f9ed36b4ad99fc49"), last = require("bbfbe3a50d8efe39"), parent = require("b7b0084465c39aec"), toKey = require("7b9792fcc4179101");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function baseUnset(object, path) {
    path = castPath(path, object);
    object = parent(object, path);
    return object == null || delete object[toKey(last(path))];
}
module.exports = baseUnset;

},{"f9ed36b4ad99fc49":"1tEcE","bbfbe3a50d8efe39":"glvbo","b7b0084465c39aec":"bcyN4","7b9792fcc4179101":"b5swP"}],"glvbo":[function(require,module,exports,__globalThis) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = last;

},{}],"bcyN4":[function(require,module,exports,__globalThis) {
var baseGet = require("cbcb75b7339c1ad"), baseSlice = require("3443758a32fd0de1");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function parent(object, path) {
    return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}
module.exports = parent;

},{"cbcb75b7339c1ad":"5Vkba","3443758a32fd0de1":"7H7oa"}],"7H7oa":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = baseSlice;

},{}],"bUGk9":[function(require,module,exports,__globalThis) {
var isPlainObject = require("e34ef634df1bf68a");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function customOmitClone(value) {
    return isPlainObject(value) ? undefined : value;
}
module.exports = customOmitClone;

},{"e34ef634df1bf68a":"lCxAG"}],"kA4yF":[function(require,module,exports,__globalThis) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"dqsfF"}],"lJju3":[function(require,module,exports,__globalThis) {
var Symbol = require("f5b62d1660729b98"), copyArray = require("61cac3c23006c0f6"), getTag = require("9cff37b2e8bee16e"), isArrayLike = require("80e12bc2380f4597"), isString = require("e9a6d0605a1fbcd5"), iteratorToArray = require("1fbcb7346dc657ca"), mapToArray = require("335b9935560779f7"), setToArray = require("21e9745d007863fc"), stringToArray = require("d814a03db328c8ac"), values = require("15f9807a1ab80e1e");
/** `Object#toString` result references. */ var mapTag = '[object Map]', setTag = '[object Set]';
/** Built-in value references. */ var symIterator = Symbol ? Symbol.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function toArray(value) {
    if (!value) return [];
    if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
    if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
    var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
    return func(value);
}
module.exports = toArray;

},{"f5b62d1660729b98":"crlKT","61cac3c23006c0f6":"lWbYv","9cff37b2e8bee16e":"1chae","80e12bc2380f4597":"kzICo","e9a6d0605a1fbcd5":"5nkFr","1fbcb7346dc657ca":"clWrW","335b9935560779f7":"7z4fi","21e9745d007863fc":"lxNlE","d814a03db328c8ac":"e34IY","15f9807a1ab80e1e":"iEaVs"}],"5nkFr":[function(require,module,exports,__globalThis) {
var baseGetTag = require("b4b8a393acf14901"), isArray = require("46fdd4d2c5d7b4ab"), isObjectLike = require("36ebbb6a9d8b3fe4");
/** `Object#toString` result references. */ var stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
module.exports = isString;

},{"b4b8a393acf14901":"5ltt8","46fdd4d2c5d7b4ab":"1DVeR","36ebbb6a9d8b3fe4":"4gOki"}],"clWrW":[function(require,module,exports,__globalThis) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = iteratorToArray;

},{}],"e34IY":[function(require,module,exports,__globalThis) {
var asciiToArray = require("55ec07d60faf873c"), hasUnicode = require("d3e31b390208b2ca"), unicodeToArray = require("2a468ebcd49732b9");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}
module.exports = stringToArray;

},{"55ec07d60faf873c":"8IriL","d3e31b390208b2ca":"6LhZ8","2a468ebcd49732b9":"8eM3H"}],"8IriL":[function(require,module,exports,__globalThis) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function asciiToArray(string) {
    return string.split('');
}
module.exports = asciiToArray;

},{}],"6LhZ8":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function hasUnicode(string) {
    return reHasUnicode.test(string);
}
module.exports = hasUnicode;

},{}],"8eM3H":[function(require,module,exports,__globalThis) {
/** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var rsAstral = '[' + rsAstralRange + ']', rsCombo = '[' + rsComboRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
    rsNonAstral,
    rsRegional,
    rsSurrPair
].join('|') + ')' + rsOptVar + reOptMod + ')*', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = '(?:' + [
    rsNonAstral + rsCombo + '?',
    rsCombo,
    rsRegional,
    rsSurrPair,
    rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}
module.exports = unicodeToArray;

},{}],"iEaVs":[function(require,module,exports,__globalThis) {
var baseValues = require("f4ee8afbcaba5363"), keys = require("4f6b7e914d03d8e3");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;

},{"f4ee8afbcaba5363":"3dYBP","4f6b7e914d03d8e3":"9qKxr"}],"3dYBP":[function(require,module,exports,__globalThis) {
var arrayMap = require("2696d06e8e2fc398");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    return arrayMap(props, function(key) {
        return object[key];
    });
}
module.exports = baseValues;

},{"2696d06e8e2fc398":"chzeu"}],"3NTTt":[function(require,module,exports,__globalThis) {
var createRange = require("1232c42be39f64d6");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var range = createRange();
module.exports = range;

},{"1232c42be39f64d6":"2HsCF"}],"2HsCF":[function(require,module,exports,__globalThis) {
var baseRange = require("f5c6552fbc38341a"), isIterateeCall = require("ae36f017fbc9946"), toFinite = require("c59818521cb53c6a");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = toFinite(end);
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
    };
}
module.exports = createRange;

},{"f5c6552fbc38341a":"3QPng","ae36f017fbc9946":"gTLnH","c59818521cb53c6a":"b6tZP"}],"3QPng":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function baseRange(start, end, step, fromRight) {
    var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = baseRange;

},{}],"b6tZP":[function(require,module,exports,__globalThis) {
var toNumber = require("90c5878489629896");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber(value);
    if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = toFinite;

},{"90c5878489629896":"3MLIQ"}],"3MLIQ":[function(require,module,exports,__globalThis) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"57o9c","faaa289d287a34a5":"6hgJK","47b3bd23f771891":"fMaHV"}],"57o9c":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"gJ6UK"}],"gJ6UK":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"7BMUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BellIcon", ()=>BellIcon);
parcelHelpers.export(exports, "ShareContentIcon", ()=>ShareContentIcon);
parcelHelpers.export(exports, "AssignedContentIcon", ()=>AssignedContentIcon);
parcelHelpers.export(exports, "PreviewIcon", ()=>PreviewIcon);
parcelHelpers.export(exports, "LessonCountIcon", ()=>LessonCountIcon);
parcelHelpers.export(exports, "MessageIcon", ()=>MessageIcon);
parcelHelpers.export(exports, "DoubleArrowLeftIcon", ()=>DoubleArrowLeftIcon);
parcelHelpers.export(exports, "DoubleArrowRightIcon", ()=>DoubleArrowRightIcon);
parcelHelpers.export(exports, "ArrowRightIcon", ()=>ArrowRightIcon);
parcelHelpers.export(exports, "ArrowLeftIcon", ()=>ArrowLeftIcon);
parcelHelpers.export(exports, "TrashIcon", ()=>TrashIcon);
parcelHelpers.export(exports, "EditIcon", ()=>EditIcon);
parcelHelpers.export(exports, "SquareArrowUpRightIcon", ()=>SquareArrowUpRightIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _utils = require("helpers/utils");
const icons = {
    dashboard: DashboardIcon,
    calendars: CalendarsIcon,
    catalogue: CatalogueIcon,
    monitoring: MonitoringIcon,
    "my-courses": MyCoursesIcon,
    "my-lessons": MyLessonsIcon,
    "more-menu": MoreMenuIcon,
    rollbook: RollbookIcon,
    gradebook: RollbookIcon,
    planning: PlanningIcon,
    "planning-rd": PlanningIcon,
    assessment: AssessmentIcon,
    quiz: AssessmentIcon,
    guide: (0, _material.AssignmentIndIcon),
    overview: (0, _material.AssignmentIcon),
    workbook: (0, _material.AssignmentTurnedInIcon),
    preview: PreviewIcon,
    plan: PlanIcon,
    summary: SummaryIcon,
    download: DownloadIcon,
    downloads: DownloadsIcon,
    schedule: ScheduleIcon,
    posts: PostsIcon,
    key: KeyIcon,
    chat: ChatIcon,
    "lesson-count": LessonCountIcon,
    "lesson-upload": LessonUploadIcon,
    "rollbook-link": PlanIcon,
    "publish-rollbook": PostsIcon,
    homework: HomeworkIcon,
    resources: ResourcesIcon,
    "view-local-content": SquareArrowUpRightIcon,
    "lock": LockIcon
};
exports.default = icons;
function LockIcon(props) {
    const fill = props.fill || '#075fc9';
    const backgroundColor = props.backgroundColor || '#ededed';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utils.SvgKeepRatio), {
        viewBox: {
            width: 66,
            height: 66
        },
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            id: "Page-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                id: "vv",
                transform: "translate(-1, -1)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    id: "Group",
                    transform: "translate(1, 1)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            id: "Oval",
                            stroke: "#D1D1D1",
                            fill: backgroundColor,
                            cx: "33",
                            cy: "33",
                            r: "32.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            id: "lock",
                            transform: "translate(19.7247, 17.1549)",
                            fill: fill,
                            fillRule: "nonzero",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M4.6875,11.25 L4.6875,8.4375 C4.6875,3.77753913 8.46679688,0 13.125,0 C17.7832031,0 21.5625,3.77753913 21.5625,8.4375 L21.5625,11.25 L22.5,11.25 C24.5683587,11.25 26.25,12.9316404 26.25,15 L26.25,26.25 C26.25,28.3183587 24.5683587,30 22.5,30 L3.75,30 C1.67871058,30 0,28.3183587 0,26.25 L0,15 C0,12.9316404 1.67871058,11.25 3.75,11.25 L4.6875,11.25 Z M8.4375,11.25 L17.8125,11.25 L17.8125,8.4375 C17.8125,5.84882855 15.7148445,3.75 13.125,3.75 C10.5351564,3.75 8.4375,5.84882855 8.4375,8.4375 L8.4375,11.25 Z",
                                id: "Shape"
                            })
                        })
                    ]
                })
            })
        })
    });
}
function HomeworkIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "32px",
        height: "40px",
        viewBox: "0 0 32 40",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M18.9585378,0.683789881 L24.9023466,0.683789881 L24.9023466,33.7743122 L7.00831783,33.7743122 L1.8189894e-12,27.3029021 L1.8189894e-12,21.7337114 M0,7.2419597 C0,7.2419597 0,4.98046774 0,0.457483826 L6.76576637,0.457483826",
                    stroke: "#FFFFFF",
                    transform: "translate(12.451173, 17.115898) rotate(-180.000000) translate(-12.451173, -17.115898) "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M24.8487198,0.5 L24.8487198,7.22794625 L17.5326918,0.766788139 L24.8487198,0.5 Z",
                    stroke: "#FFFFFF",
                    transform: "translate(21.190706, 3.863973) rotate(-180.000000) translate(-21.190706, -3.863973) "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "6.64062577",
                    y: "10.6470355",
                    width: "11.6210951",
                    height: "1.70209821"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "6.64062577",
                    y: "12.3491337",
                    width: "1.66015644",
                    height: "1.70209821"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "16.6015644",
                    y: "12.3491337",
                    width: "1.66015644",
                    height: "1.70209821"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "11.6210951",
                    y: "10.6470355",
                    width: "1.66015644",
                    height: "11.9146874"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(18.136580, 25.986568) rotate(-315.000000) translate(-18.136580, -25.986568) translate(15.646346, 11.518733)",
                    stroke: "#FFFFFF",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            strokeLinejoin: "round",
                            x: "0",
                            y: "5.10629462",
                            width: "4.98046933",
                            height: "17.0209821"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M2.49023466,0 C3.86555329,-2.52641933e-16 4.98046933,1.11491604 4.98046933,2.49023466 L4.98046933,5.10629462 L4.98046933,5.10629462 L0,5.10629462 L0,2.49023466 C-1.68427956e-16,1.11491604 1.11491604,2.52641933e-16 2.49023466,0 Z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                            strokeLinejoin: "round",
                            points: "-9.09494702e-13 22.1272767 4.98046933 22.1272767 2.49023466 28.9356695"
                        })
                    ]
                })
            ]
        })
    });
}
function DownloadsIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "33px",
        height: "33px",
        viewBox: "0 0 33 33",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-33.000000, -516.000000)",
                fillRule: "nonzero",
                stroke: "#fff",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    transform: "translate(-1.000000, 98.000000)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        transform: "translate(35.000000, 419.000000)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M29.0625,27.6785714 C29.0625,26.9174107 28.4397321,26.2946429 27.6785714,26.2946429 C26.9174107,26.2946429 26.2946429,26.9174107 26.2946429,27.6785714 C26.2946429,28.4397321 26.9174107,29.0625 27.6785714,29.0625 C28.4397321,29.0625 29.0625,28.4397321 29.0625,27.6785714 Z M23.25,26.2946429 C22.4888393,26.2946429 21.8660714,26.9174107 21.8660714,27.6785714 C21.8660714,28.4397321 22.4888393,29.0625 23.25,29.0625 C24.0111607,29.0625 24.6339286,28.4397321 24.6339286,27.6785714 C24.6339286,26.9174107 24.0111607,26.2946429 23.25,26.2946429 Z M15.1055668,24.1980046 L5.36961583,14.4620536 C5.02363368,14.1091788 5.27278137,13.514049 5.76404899,13.514049 L11.625,13.514049 L11.625,0.553571429 C11.625,0.249080113 11.8740801,0 12.1785714,0 L18.8214286,0 C19.1259199,0 19.375,0.249080113 19.375,0.553571429 L19.375,13.514049 L25.2289908,13.514049 C25.7272186,13.514049 25.9694061,14.1160714 25.623424,14.4620536 L15.887473,24.1980046 C15.6729911,24.4124865 15.3201163,24.4124865 15.1055668,24.1980046 Z M31,22.9732143 L31,30.1696429 C31,30.6263123 30.6263123,31 30.1696429,31 L0.830357143,31 C0.373687744,31 0,30.6263123 0,30.1696429 L0,22.9732143 C0,22.5165449 0.373687744,22.1428571 0.830357143,22.1428571 L9.92279489,22.1428571 L13.5417546,25.7618168 C14.6211918,26.8413217 16.3788082,26.8413217 17.4582454,25.7618168 L21.0772051,22.1428571 L30.1696429,22.1428571 C30.6263123,22.1428571 31,22.5165449 31,22.9732143 Z"
                        })
                    })
                })
            })
        })
    });
}
function BellIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "19px",
        height: "19px",
        viewBox: "0 0 19 19",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            strokeWidth: "1",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: props.backgroundColor || "#C52929",
                    x: "4.52970994e-13",
                    y: "5.68434189e-14",
                    width: "18.139636",
                    height: "18.139636",
                    rx: "9.06981802"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M9.14716785,14.0032337 C8.45731965,14.0032337 7.89776211,13.443657 7.89776211,12.7532366 L10.3965736,12.7532366 C10.3965736,13.443657 9.83701606,14.0032337 9.14716785,14.0032337 Z M13.3539869,11.079218 C13.4711741,11.2050073 13.5231302,11.3557828 13.5221839,11.5032396 C13.5202119,11.823559 13.2686332,12.1282381 12.8952134,12.1282381 L5.39912229,12.1282381 C5.02570246,12.1282381 4.77433358,11.823559 4.77215185,11.5032396 C4.77120554,11.3557828 4.82316159,11.205198 4.94034881,11.079218 C5.31767869,10.6737547 6.02373933,10.0637861 6.02373933,8.06574781 C6.02373933,6.54816949 7.08778937,5.33332482 8.52255081,5.03528324 L8.52255081,4.62825601 C8.52255081,4.28314117 8.80224375,4.0032575 9.14716785,4.0032575 C9.49209196,4.0032575 9.7717849,4.28314117 9.7717849,4.62825601 L9.7717849,5.03528324 C11.2065463,5.33332482 12.2705964,6.54816949 12.2705964,8.06574781 C12.2705964,10.0637861 12.976657,10.6737547 13.3539869,11.079218 Z",
                    fill: props.fill || "#FFFFFF"
                })
            ]
        })
    });
}
function ShareContentIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "23px",
        height: "21px",
        viewBox: "0 0 23 21",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-1081.000000, -299.000000)",
            fill: props.fill || "#3395CE",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1103.20629,306.431597 L1097.58115,311.743474 C1096.98824,312.303432 1095.99996,311.88828 1095.99996,311.061942 L1095.99996,308.250898 C1090.35251,308.288778 1087.97005,309.622469 1089.56344,314.944341 C1089.73857,315.529209 1089.06166,315.982127 1088.58665,315.621295 C1087.06451,314.465063 1085.68749,312.25346 1085.68749,310.021066 C1085.68749,304.398559 1090.28117,303.282801 1095.99996,303.251101 L1095.99996,300.437997 C1095.99996,299.610897 1096.98892,299.197079 1097.58115,299.756465 L1103.20629,305.068456 C1103.59768,305.4381 1103.59798,306.061611 1103.20629,306.431597 Z M1095.99996,314.309691 C1095.99996,314.022788 1096.25505,313.80558 1096.53902,313.846435 C1096.64884,313.862266 1096.82802,313.875122 1096.93899,313.875122 C1097.2048,313.875122 1097.62392,313.803177 1097.87454,313.714524 C1098.17975,313.606568 1098.49996,313.832283 1098.49996,314.156036 L1098.49996,317.624999 C1098.49996,318.660534 1097.6605,319.499994 1096.62496,319.499994 L1082.875,319.499994 C1081.83946,319.499994 1081,318.660534 1081,317.624999 L1081,303.875031 C1081,302.839496 1081.83946,302.000036 1082.875,302.000036 L1087.60284,302.000036 C1088.09311,302.000036 1088.2542,302.657459 1087.81944,302.884052 C1087.08595,303.266322 1086.41079,303.747659 1085.82672,304.355758 C1085.75043,304.435333 1085.5991,304.499954 1085.4889,304.500036 L1083.5,304.500036 L1083.5,317 L1095.99996,317 L1095.99996,314.309691 Z"
            })
        })
    });
}
function AssignedContentIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "15px",
        height: "20px",
        viewBox: "0 0 15 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-1141.000000, -194.000000)",
            fill: props.fill || '#2CA5EC',
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1152.18747,204.103893 L1152.18747,206.478887 L1145.06249,206.478887 L1145.06249,204.103893 L1152.18747,204.103893 Z M1155.4902,198.500391 C1155.65719,198.667382 1155.74997,198.893735 1155.74997,199.127552 L1155.74997,199.353904 L1150.99998,199.353904 L1150.99998,194.603916 L1151.22633,194.603916 C1151.46384,194.603916 1151.6902,194.696689 1151.85719,194.863681 L1155.4902,198.500391 Z M1149.81248,199.650779 C1149.81248,200.140628 1150.21325,200.541401 1150.7031,200.541401 L1155.74997,200.541401 L1155.74997,212.713247 C1155.74997,213.206794 1155.35289,213.60387 1154.85934,213.60387 L1142.39062,213.60387 C1141.89708,213.60387 1141.5,213.206794 1141.5,212.713247 L1141.5,195.494538 C1141.5,195.000992 1141.89708,194.603916 1142.39062,194.603916 L1149.81248,194.603916 L1149.81248,199.650779 Z M1143.87499,197.275784 L1143.87499,197.869533 C1143.87499,198.033553 1144.00785,198.166407 1144.17187,198.166407 L1147.14061,198.166407 C1147.30463,198.166407 1147.43749,198.033553 1147.43749,197.869533 L1147.43749,197.275784 C1147.43749,197.111764 1147.30463,196.97891 1147.14061,196.97891 L1144.17187,196.97891 C1144.00785,196.97891 1143.87499,197.111764 1143.87499,197.275784 Z M1143.87499,199.650779 L1143.87499,200.244527 C1143.87499,200.408547 1144.00785,200.541401 1144.17187,200.541401 L1147.14061,200.541401 C1147.30463,200.541401 1147.43749,200.408547 1147.43749,200.244527 L1147.43749,199.650779 C1147.43749,199.486758 1147.30463,199.353904 1147.14061,199.353904 L1144.17187,199.353904 C1144.00785,199.353904 1143.87499,199.486758 1143.87499,199.650779 Z M1153.37497,210.932002 L1153.37497,210.338253 C1153.37497,210.174233 1153.24212,210.041379 1153.0781,210.041379 L1150.10935,210.041379 C1149.94533,210.041379 1149.81248,210.174233 1149.81248,210.338253 L1149.81248,210.932002 C1149.81248,211.096022 1149.94533,211.228876 1150.10935,211.228876 L1153.0781,211.228876 C1153.24212,211.228876 1153.37497,211.096022 1153.37497,210.932002 Z M1153.37497,203.510144 C1153.37497,203.182104 1153.10926,202.916396 1152.78122,202.916396 L1144.46874,202.916396 C1144.1407,202.916396 1143.87499,203.182104 1143.87499,203.510144 L1143.87499,207.072636 C1143.87499,207.400676 1144.1407,207.666384 1144.46874,207.666384 L1152.78122,207.666384 C1153.10926,207.666384 1153.37497,207.400676 1153.37497,207.072636 L1153.37497,203.510144 Z"
            })
        })
    });
}
function MoreMenuIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "44px",
        height: "8px",
        viewBox: "0 0 44 8",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#FFFFFF",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: "4",
                        cy: "4",
                        r: "4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: "22",
                        cy: "4",
                        r: "4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: "40",
                        cy: "4",
                        r: "4"
                    })
                ]
            })
        })
    });
}
function MyLessonsIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "33px",
        height: "27px",
        viewBox: "0 0 33 27",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M24.5,26.5 L32.5,26.5 L32.5,21.5 C32.5,19.290861 30.709139,17.5 28.5,17.5 C26.290861,17.5 24.5,19.290861 24.5,21.5 L24.5,26.5 Z",
                        stroke: "#FFFFFF"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        stroke: "#FFFFFF",
                        cx: "28.5",
                        cy: "13.5",
                        r: "3.5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        fill: "#FFFFFF",
                        fillRule: "nonzero",
                        points: "28 4 28 7 29 6 28 6 28 7 29 7 29 3 0 3 0 26 22 26 22 25 21 25 21 26 22 25 1 25 1 4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M1,1 L1,3 L28,3 L28,1 L1,1 Z M0,0 L29,0 L29,4 L0,4 L0,0 Z",
                        fill: "#FFFFFF",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        stroke: "#FFFFFF",
                        points: "13 10 13 19 19.4985412 14.5"
                    })
                ]
            })
        })
    });
}
function PlanningIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "35px",
        height: "27px",
        viewBox: "0 0 35 27",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        fill: "#FFFFFF",
                        fillRule: "nonzero",
                        points: "28 26 28 25 29 25 29 27 0 27 0 0 29 0 29 8 28 8 28 1 1 1 1 26"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M30.5659787,11.4012025 C29.9281137,11.1424912 29.2306971,11 28.5,11 C25.4624339,11 23,13.4624339 23,16.5 C23,19.5375661 25.4624339,22 28.5,22 C31.5375661,22 34,19.5375661 34,16.5 C34,15.2682442 33.5950864,14.131061 32.9111048,13.214296",
                        stroke: "#FFFFFF"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        fill: "#FFFFFF",
                        points: "25 17 26 16 28 17 34 11 35 12 28 20"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "3",
                        y: "8",
                        width: "4",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "5",
                        y: "12",
                        width: "7",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "9",
                        y: "16",
                        width: "10",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "18",
                        y: "20",
                        width: "3",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "1",
                        y: "3",
                        width: "27",
                        height: "1"
                    })
                ]
            })
        })
    });
}
function RollbookIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "29px",
        height: "32px",
        viewBox: "0 0 29 32",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "10.5",
                        y: "7.5",
                        width: "12",
                        height: "5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "2.5",
                        y: "0.5",
                        width: "24",
                        height: "31"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "2.5",
                        y: "0.5",
                        width: "4",
                        height: "31"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "28",
                        y: "5",
                        width: "1",
                        height: "5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "28",
                        y: "11",
                        width: "1",
                        height: "5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "28",
                        y: "17",
                        width: "1",
                        height: "5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "0",
                        y: "8",
                        width: "4",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "0",
                        y: "3",
                        width: "4",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "0",
                        y: "13",
                        width: "4",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "0",
                        y: "18",
                        width: "4",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "0",
                        y: "28",
                        width: "4",
                        height: "1"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        fill: "#FFFFFF",
                        x: "0",
                        y: "23",
                        width: "4",
                        height: "1"
                    })
                ]
            })
        })
    });
}
function MyCoursesIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "26px",
        height: "38px",
        viewBox: "0 0 26 38",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#FFFFFF",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        points: "10 16 22 16 22 17 10 17"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        points: "10 23 22 23 22 24 10 24"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        points: "10 30 22 30 22 31 10 31"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M13,7.5 C11.6192881,7.5 10.5,6.38071187 10.5,5 C10.5,3.61928813 11.6192881,2.5 13,2.5 C14.3807119,2.5 15.5,3.61928813 15.5,5 C15.5,6.38071187 14.3807119,7.5 13,7.5 Z M13,6.5 C13.8284271,6.5 14.5,5.82842712 14.5,5 C14.5,4.17157288 13.8284271,3.5 13,3.5 C12.1715729,3.5 11.5,4.17157288 11.5,5 C11.5,5.82842712 12.1715729,6.5 13,6.5 Z",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M3,7 L3,8 L2,8 C1.44771525,8 1,8.44771525 1,9 L1,36 C1,36.5522847 1.44771525,37 2,37 L24,37 C24.5522847,37 25,36.5522847 25,36 L25,9 C25,8.44771525 24.5522847,8 24,8 L23,8 L23,7 L24,7 C25.1045695,7 26,7.8954305 26,9 L26,36 C26,37.1045695 25.1045695,38 24,38 L2,38 C0.8954305,38 0,37.1045695 0,36 L0,9 C0,7.8954305 0.8954305,7 2,7 L3,7 Z",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9,5 L9,6 L7,6 C6.44771525,6 6,6.44771525 6,7 L6,9 C6,9.55228475 6.44771525,10 7,10 L19,10 C19.5522847,10 20,9.55228475 20,9 L20,7 C20,6.44771525 19.5522847,6 19,6 L17,6 L17,5 C17,2.790861 15.209139,1 13,1 C10.790861,1 9,2.790861 9,5 Z M8,5 C8,2.23857625 10.2385763,0 13,0 C15.7614237,0 18,2.23857625 18,5 L19,5 C20.1045695,5 21,5.8954305 21,7 L21,9 C21,10.1045695 20.1045695,11 19,11 L7,11 C5.8954305,11 5,10.1045695 5,9 L5,7 C5,5.8954305 5.8954305,5 7,5 L8,5 Z",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        points: "4 15 7 15 7 18 4 18"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        points: "4 22 7 22 7 25 4 25"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        points: "4 29 7 29 7 32 4 32"
                    })
                ]
            })
        })
    });
}
function MonitoringIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "37px",
        height: "31px",
        viewBox: "0 0 37 31",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M29,18 C31.5773288,18 34.4444444,15.5 36,13 C34.4444444,10.5 31.5773288,8 29,8 C26.4226712,8 23.5555556,10.5 22,13 C23.5555556,15.5 26.4226712,18 29,18 Z",
                        stroke: "#FFFFFF"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        stroke: "#FFFFFF",
                        cx: "29",
                        cy: "13",
                        r: "2"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M29,20 L30,20 L30,26 L21,26 L21,25 L29,25 L29,20 Z M1,25 L1,4 L29,4 L29,5 L30,5 L30,3 L0,3 L0,26 L10,26 L10,25 L1,25 Z M29,4 L29,5 L30,5 L30,3 L0,3 L0,26 L10,26 L10,25 L1,25 L1,4 L29,4 Z",
                        fill: "#FFFFFF",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "0.5",
                        y: "0.5",
                        width: "29",
                        height: "3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.5,30.5 L19.5,30.5 L19.5,25.5 C19.5,23.290861 17.709139,21.5 15.5,21.5 C13.290861,21.5 11.5,23.290861 11.5,25.5 L11.5,30.5 Z",
                        stroke: "#FFFFFF"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        stroke: "#FFFFFF",
                        cx: "15.5",
                        cy: "17.5",
                        r: "3.5"
                    })
                ]
            })
        })
    });
}
function CatalogueIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "30px",
        height: "36px",
        viewBox: "0 0 30 36",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    stroke: "#FFFFFF",
                    x: "4.5",
                    y: "10.5",
                    width: "8",
                    height: "9"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                    fill: "#FFFFFF",
                    fillRule: "nonzero",
                    points: "4.5 1.5 28.5 1.5 28.5 32.5 26.9295804 32.5 26.9295804 33.5 29.5 33.5 29.5 0.5 3.5 0.5 3.5 2.95817736 4.5 2.95817736"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    stroke: "#FFFFFF",
                    x: "0.5",
                    y: "5.5",
                    width: "24",
                    height: "30"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "15",
                    y: "10",
                    width: "6",
                    height: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "15",
                    y: "13",
                    width: "6",
                    height: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "15",
                    y: "16",
                    width: "6",
                    height: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "15",
                    y: "19",
                    width: "6",
                    height: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "4",
                    y: "22",
                    width: "17",
                    height: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "4",
                    y: "25",
                    width: "17",
                    height: "1"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "#FFFFFF",
                    x: "4",
                    y: "28",
                    width: "9",
                    height: "1"
                })
            ]
        })
    });
}
function CalendarsIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "29px",
        height: "33px",
        viewBox: "0 0 29 33",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M7,3 L7,4 L3,4 C1.8954305,4 1,4.8954305 1,6 L1,30 C1,31.1045695 1.8954305,32 3,32 L26,32 C27.1045695,32 28,31.1045695 28,30 L28,6 C28,4.8954305 27.1045695,4 26,4 L22.0116915,4 L22.0116915,3 L26,3 C27.6568542,3 29,4.34314575 29,6 L29,30 C29,31.6568542 27.6568542,33 26,33 L3,33 C1.34314575,33 2.02906125e-16,31.6568542 0,30 L0,6 C-2.02906125e-16,4.34314575 1.34314575,3 3,3 L7,3 Z",
                        fill: "#FFFFFF",
                        fillRule: "nonzero"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "6.5",
                        y: "0.5",
                        width: "3",
                        height: "6",
                        rx: "1.5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "19.5",
                        y: "0.5",
                        width: "3",
                        height: "6",
                        rx: "1.5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        fill: "#FFFFFF",
                        fillRule: "nonzero",
                        points: "0 10 0 9 29 9 29 10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        fill: "#FFFFFF",
                        fillRule: "nonzero",
                        points: "9 4 9 3 23 3 23 4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "4.5",
                        y: "13.5",
                        width: "4",
                        height: "3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "4.5",
                        y: "19.5",
                        width: "4",
                        height: "3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "4.5",
                        y: "25.5",
                        width: "4",
                        height: "3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "12.5",
                        y: "13.5",
                        width: "4",
                        height: "3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "12.5",
                        y: "19.5",
                        width: "4",
                        height: "3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "20.5",
                        y: "13.5",
                        width: "4",
                        height: "3"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        stroke: "#FFFFFF",
                        x: "20.5",
                        y: "19.5",
                        width: "4",
                        height: "3"
                    })
                ]
            })
        })
    });
}
function DashboardIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "30px",
        height: "32px",
        viewBox: "0 0 30 32",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M18.4862581,31.4929952 L18.4862581,26.5496857 C18.4862581,24.3405467 16.6953971,22.5496857 14.4862581,22.5496857 C12.2771191,22.5496857 10.4862581,24.3405467 10.4862581,26.5496857 L10.4862581,31.4929952 L0.528280084,31.4929952 L0.528280084,14.4653871 L14.5175771,1 L28.5101858,14.4653596 L28.5101858,31.4929952 L18.4862581,31.4929952 Z",
                stroke: "#FFFFFF",
                fillRule: "nonzero"
            })
        })
    });
}
function AssessmentIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "28px",
        height: "32px",
        viewBox: "0 0 28 32",
        version: "1.1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                            stroke: "#FFFFFF",
                            strokeLinecap: "square",
                            points: "2 7 3 9 8 4"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                            fill: "#FFFFFF",
                            fillRule: "nonzero",
                            points: "4 1 22 1 22 6 27 6 27 31 4 31 4 29 3 29 3 32 28 32 28 5 23 5 23 0 3 0 3 3 4 3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M5.5,9.11803399 L3.69098301,5.5 L0.5,5.5 L0.5,10.5 L5.5,10.5 L5.5,9.11803399 Z",
                            stroke: "#FFFFFF"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            fill: "#FFFFFF",
                            x: "23",
                            y: "0",
                            width: "1",
                            height: "1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            fill: "#FFFFFF",
                            x: "24",
                            y: "1",
                            width: "1",
                            height: "1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            fill: "#FFFFFF",
                            x: "25",
                            y: "2",
                            width: "1",
                            height: "1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            fill: "#FFFFFF",
                            x: "26",
                            y: "3",
                            width: "1",
                            height: "1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            fill: "#FFFFFF",
                            x: "27",
                            y: "4",
                            width: "1",
                            height: "1"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M19.0701172,24 L17.9978516,20.7568359 L13.3308594,20.7568359 L12.2410156,24 L9.94707034,24 L14.4470703,11.3173828 L16.9958985,11.3173828 L21.5046875,24 L19.0701172,24 Z M15.5984375,13.734375 L13.8582031,18.9638672 L17.4705078,18.9638672 L15.7478516,13.734375 L15.5984375,13.734375 Z",
                            fill: "#FFFFFF",
                            fillRule: "nonzero"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            stroke: "#FFFFFF",
                            x: "0.5",
                            y: "13.5",
                            width: "5",
                            height: "5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            stroke: "#FFFFFF",
                            x: "0.5",
                            y: "21.5",
                            width: "5",
                            height: "5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                            fill: "#FFFFFF",
                            points: "21 10 21 8 22 8 22 10 24 10 24 11 22 11 22 13 21 13 21 11 19 11 19 10"
                        })
                    ]
                })
            })
        })
    });
}
function GuideIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "25px",
        height: "25px",
        viewBox: "0 0 25 25",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-1240.000000, -135.000000)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(1240.000000, 135.500000)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            transform: "translate(0.000000, 6.500000)",
                            fill: "#45C7FF",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M5.04249229,6.74039399 C7.82738389,6.74039399 10.0849846,8.99799469 10.0849846,11.7828863 L10.0849846,17.4977109 L0,17.4977109 L0,11.7828863 C-3.41050858e-16,8.99799469 2.2576007,6.74039399 5.04249229,6.74039399 Z"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                    cx: "5.04249229",
                                    cy: "3.71489862",
                                    r: "3.69782768"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M11.5,5 L19.5,5 L19.5,5.48627286 L19.9855317,5 L20,5 L19.9927604,4.99276036 L19.9992374,4.98627344 L19.9862932,4.98629319 L19.5,4.5 L19.5,4.9870349 L11.5,4.9992368 L11.5,4.5 L11.0000006,4.99999942 L10.9992374,5.00000058 L11.5,5.5 L11.5,5 Z",
                            stroke: "#45C7FF",
                            fill: "#D8D8D8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M15.5,8 L20,8 L19.5,7.5 L19.5,8.5 L20,8 L15.5,8 Z M15.5,8 L11,8 L11.5,8.5 L11.5,7.5 L11,8 L15.5,8 Z",
                            stroke: "#45C7FF",
                            fill: "#D8D8D8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M15.5,11 L20,11 L19.5,10.5 L19.5,11.5 L20,11 L15.5,11 Z M15.5,11 L11,11 L11.5,11.5 L11.5,10.5 L11,11 L15.5,11 Z",
                            stroke: "#45C7FF",
                            fill: "#D8D8D8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M15.4924927,14 L19.9849854,14 L19.4850417,13.5075065 L19.5000564,14.5075065 L20,14 L15.4924927,14 Z M15.4924927,14 L11,14 L11.5,14.5 L11.5,13.5 L11,14 L15.4924927,14 Z",
                            stroke: "#45C7FF",
                            fill: "#D8D8D8"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                            fill: "#45C7FF",
                            fillRule: "nonzero",
                            points: "7.5 1 23.5 1 23.5 18 13 18 13 19 24.5 19 24.5 0 6.5 0 6.5 4.5 7.5 4.5"
                        })
                    ]
                })
            })
        })
    });
}
function OverviewIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "17px",
        height: "21px",
        viewBox: "0 0 17 21",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M4.5,7.5 L12.5,7.5 L12.5,7.98627286 L12.9855317,7.5 L13,7.5 L12.9927604,7.49276036 L12.9992374,7.48627344 L12.9862932,7.48629319 L12.5,7 L12.5,7.4870349 L4.5,7.4992368 L4.5,7 L4.00000058,7.49999942 L3.99923738,7.50000058 L4.5,8 L4.5,7.5 Z",
                    stroke: "#45C7FF",
                    fill: "#D8D8D8"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M8.5,10.5 L13,10.5 L12.5,10 L12.5,11 L13,10.5 L8.5,10.5 Z M8.5,10.5 L4,10.5 L4.5,11 L4.5,10 L4,10.5 L8.5,10.5 Z",
                    stroke: "#45C7FF",
                    fill: "#D8D8D8"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M8.5,13.5 L13,13.5 L12.5,13 L12.5,14 L13,13.5 L8.5,13.5 Z M8.5,13.5 L4,13.5 L4.5,14 L4.5,13 L4,13.5 L8.5,13.5 Z",
                    stroke: "#45C7FF",
                    fill: "#D8D8D8"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M8.49249268,16.5 L12.9849854,16.5 L12.4850417,16.0075065 L12.5000564,17.0075065 L13,16.5 L8.49249268,16.5 Z M8.49249268,16.5 L4,16.5 L4.5,17 L4.5,16 L4,16.5 L8.49249268,16.5 Z",
                    stroke: "#45C7FF",
                    fill: "#D8D8D8"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M0,0 L17,0 L17,21 L5,21 L0,16 L0,0 Z M1,1 L1,15.5857864 L5.41421356,20 L16,20 L16,1 L1,1 Z",
                    fill: "#45C7FF",
                    fillRule: "nonzero",
                    transform: "translate(8.500000, 10.500000) rotate(-180.000000) translate(-8.500000, -10.500000) "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11,0 L17,0 L17,6 L11,0 Z M13.4142136,1 L16,3.58578644 L16,1 L13.4142136,1 Z",
                    fill: "#45C7FF",
                    fillRule: "nonzero",
                    transform: "translate(14.000000, 3.000000) rotate(-180.000000) translate(-14.000000, -3.000000) "
                })
            ]
        })
    });
}
function PreviewIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "29px",
        height: "19px",
        viewBox: "0 0 29 19",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "#009dd8",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-741.000000, -346.000000)",
                fill: "#009DD8",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M755.511331,350.75 C758.173219,350.75 760.333556,352.873065 760.333556,355.488865 C760.333556,358.104992 758.173219,360.228057 755.511331,360.228057 C752.849276,360.228057 750.689106,358.104992 750.689106,355.488865 C750.689106,355.140397 750.764422,354.584126 750.857401,354.247613 C751.208986,354.501922 751.848673,354.708251 752.285239,354.708251 C753.6151,354.708251 754.694352,353.64762 754.694352,352.340702 C754.694352,351.911668 754.4844,351.283018 754.225626,350.937498 C754.570214,350.838918 755.141083,350.754913 755.5,350.75 L755.511331,350.75 Z M755.503499,362.624918 C759.50358,362.624918 762.75,359.434507 762.75,355.503439 L762.75,355.5 C762.75,351.566967 759.501913,348.374918 755.5,348.374918 C751.49792,348.374918 748.249833,351.566967 748.249833,355.5 C748.249833,359.43287 751.49792,362.624918 755.5,362.624918 L755.503499,362.624918 Z M770,355.499672 C770,355.71026 769.921351,356.034 769.824707,356.221826 C767.096001,361.455226 761.689077,365 755.5,365 C749.310756,365 743.905499,361.457683 741.175126,356.222317 C741.078315,356.034492 741,355.710751 741,355.500164 C741,355.289577 741.078315,354.966 741.175126,354.778174 C743.903832,349.544774 749.310756,346 755.5,346 C761.689077,346 767.094501,349.542154 769.824707,354.777683 C769.921351,354.965508 770,355.289085 770,355.499672 L770,355.499672 Z"
                })
            })
        })
    });
}
function PlanIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "19px",
        height: "26px",
        viewBox: "0 0 19 26",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M18.9003231,6.2316 L18.9003231,6.53876667 L12.6196051,6.53876667 L12.6196051,0.0927666667 L12.9140239,0.0927666667 C13.2280923,0.0927666667 13.5273829,0.2186 13.7480752,0.445266667 L18.5568615,5.38043333 C18.7775538,5.6071 18.9003231,5.91426667 18.9003231,6.2316 M10.5588359,14.1581 C11.0297761,14.7071 11.0396821,15.8047667 10.5489299,16.3789333 C10.308588,16.6607667 9.9651265,16.8069333 9.51351111,16.8069333 L8.19357949,16.8069333 L8.19357949,13.7501 L9.56271624,13.7501 C9.99451966,13.7501 10.3233658,13.8861 10.5588359,14.1581 M10.0729556,11.3832667 L6.0985453,11.3832667 C5.77473333,11.3832667 5.50970769,11.6551 5.50970769,11.9876 L5.50970769,22.0492667 C5.50970769,22.3816 5.77473333,22.6536 6.0985453,22.6536 L7.60993846,22.6536 C7.93358803,22.6536 8.19861368,22.3816 8.19861368,22.0492667 L8.19861368,19.1687667 C9.2928188,19.1687667 13.6499897,19.8082667 13.6499897,15.2609333 C13.6499897,13.0349333 12.256494,11.3832667 10.0729556,11.3832667 M12.2271009,8.15026667 L18.9003231,8.15026667 L18.9003231,24.6679333 C18.9003231,25.3377667 18.375306,25.8766 17.7226479,25.8766 L1.23600684,25.8766 C0.583186325,25.8766 0.0583316239,25.3377667 0.0583316239,24.6679333 L0.0583316239,1.30143333 C0.0583316239,0.631433333 0.583186325,0.0927666667 1.23600684,0.0927666667 L11.0494256,0.0927666667 L11.0494256,6.9416 C11.0494256,7.60626667 11.5793145,8.15026667 12.2271009,8.15026667",
                fill: "#009DD8"
            })
        })
    });
}
function ResourcesIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "40px",
        height: "32px",
        viewBox: "0 0 40 32",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            transform: "translate(0.500000, 0.500000)",
            fill: "#FFFFFF",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M38.0265002,28.2960439 C38.0265002,29.2530223 37.2625663,30.0265 36.3229588,30.0265 L7.67704125,30.0265 C6.73768517,30.0265 5.9735,29.2528672 5.9735,28.2960439 L5.98071205,20.2056133 L5.03371242,20.2047691 L5.02650019,28.2956219 C5.02650019,29.7732939 6.21204915,30.9735 7.67704125,30.9735 L36.3229588,30.9735 C37.7882299,30.9735 38.9735,29.7734221 38.9735,28.2960439 L38.9735,3.0265 L21.5,3.0265 L21.5,3.9735 L38.0265002,3.9735 L38.0265002,28.2960439 Z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M6.52265136,3.16614197 L5.56626467,2.28943792 C5.33093034,2.07386045 5.02763285,1.95808605 4.71468445,1.95808605 C4.38253015,1.95808605 4.0618515,2.08830836 3.82286171,2.32790157 L2.32741178,3.82337867 C1.85027304,4.30052627 1.8337253,5.06850592 2.28964923,5.56622187 L3.14968019,6.50458576 C2.86733768,7.01896781 2.64012907,7.5627197 2.47229136,8.12795437 L1.20566603,8.18296345 C0.531495247,8.21248969 0,8.76769247 0,9.44250742 L0,11.5578635 C0,12.2324016 0.531589201,12.7875144 1.20548315,12.8170286 L2.47232734,12.8720472 C2.64020853,13.4372737 2.86744165,13.9811404 3.14968695,14.4954069 L2.2897391,15.4336801 C1.83372184,15.9308832 1.8502693,16.6992262 2.3271842,17.1767645 L3.82334776,18.672585 C4.06232986,18.9115716 4.38290445,19.0419139 4.71468445,19.0419139 C5.02763285,19.0419139 5.33093034,18.9261396 5.56613721,18.7106789 L6.52263616,17.833872 C7.03184786,18.1067341 7.56897939,18.3259469 8.12614361,18.4873216 L8.1831872,19.794426 C8.21206666,20.4685009 8.76726126,21 9.44234157,21 L11.5576584,21 C12.2325715,21 12.7873074,20.46876 12.8168103,19.7944826 L12.8752425,18.4537317 C13.4175542,18.2879868 13.940069,18.0672719 14.4353476,17.7956239 L15.433789,18.7106113 C15.6683144,18.9259962 15.972149,19.0419139 16.2853156,19.0419139 C16.6166172,19.0419139 16.936989,18.911654 17.1762533,18.6729834 L18.6725444,17.1770361 C19.1497307,16.6992262 19.1662782,15.9308832 18.7101429,15.4335513 L17.7788292,14.417367 C18.0409446,13.9274242 18.2535241,13.4116824 18.4127654,12.8772046 L19.7940292,12.8170337 C20.4683053,12.7875297 21,12.2325032 21,11.5578635 L21,9.44250742 C21,8.76759092 20.4683993,8.2124744 19.794126,8.18297055 L18.4127587,8.12279512 C18.2535551,7.58850837 18.0409966,7.07289942 17.7787883,6.58267761 L18.7102684,5.5663118 C19.1662747,5.06850592 19.149727,4.30052627 18.6725882,3.82337867 L17.1766961,2.32745879 C16.9374684,2.08822666 16.6169909,1.95808605 16.2853156,1.95808605 C15.972149,1.95808605 15.6683144,2.07400385 15.4333951,2.28975005 L14.4353459,3.20437776 C13.9399566,2.93267393 13.4174361,2.71201989 12.8752396,2.5464946 L12.8168143,1.20560845 C12.7873074,0.531240003 12.2325715,0 11.5576584,0 L11.5576584,0.5 L11.5576584,0 L9.44234157,0 C8.76726126,0 8.21206666,0.5314991 8.18317,1.20597186 L8.12614105,2.51302741 C7.5687435,2.67440427 7.03162875,2.89347573 6.52265136,3.16614197 Z M11.5576584,0.5 L11.5576584,1 C11.697185,1 11.8116577,1.10962425 11.8177662,1.24923042 L11.8919448,2.95166158 L11.9080869,3.32212929 L12.2672868,3.41422899 C12.9651192,3.5931549 13.6300415,3.87456754 14.2425135,4.24781056 L14.563443,4.44338633 L16.1094131,3.02663502 C16.1583531,2.9816897 16.2202211,2.95808605 16.2853156,2.95808605 C16.3542332,2.95808605 16.4196928,2.98466811 16.4695827,3.03455901 L17.9654749,4.5304789 C18.0640262,4.629032 18.0674431,4.78761165 17.9729637,4.89075143 L16.7965101,6.17441521 L16.5455278,6.44826947 L16.7352631,6.76762629 C17.0975702,7.37745116 17.3695814,8.03656391 17.5415671,8.72726573 L17.6318197,9.08972406 L19.7505082,9.18201884 C19.8900129,9.18812309 20,9.30297558 20,9.44250742 L20,11.5578635 C20,11.6970438 19.8899934,11.8118778 19.7504113,11.8179854 L18.0049916,11.8940197 L17.6318197,11.9102759 L17.5415671,12.2727343 C17.369498,12.9637711 17.0973938,13.6231968 16.7353277,14.232265 L16.5454615,14.5516582 L17.9730461,16.1093385 C18.0674427,16.2122607 18.0640192,16.3712187 17.9652473,16.4701198 L16.4696266,17.9653972 C16.4197501,18.0151495 16.3539233,18.0419139 16.2853156,18.0419139 C16.2202211,18.0419139 16.1583531,18.0183103 16.1098069,17.9737263 L14.8405197,16.8105312 L14.563443,16.5566137 L14.2425135,16.7521894 C13.6302383,17.1253125 12.9652596,17.4068365 12.2670631,17.5861993 L11.9080827,17.6784194 L11.8177624,19.7508559 C11.8116577,19.8903758 11.697185,20 11.5576584,20 L9.44234157,20 C9.3027248,20 9.18821529,19.8903777 9.18225349,19.7512241 L9.10916642,18.0764939 L9.09274531,17.7002184 L8.72655192,17.6121538 C8.0139293,17.4407778 7.33441773,17.1632675 6.70824614,16.790364 L6.38870279,16.6000666 L4.89053323,17.9734142 C4.84150018,18.0183307 4.7797186,18.0419139 4.71468445,18.0419139 C4.64581327,18.0419139 4.58021957,18.0152442 4.53041726,17.965441 L3.03448128,16.4698482 C2.93598076,16.3712187 2.93255735,16.2122607 3.02682841,16.1094754 L4.13486356,14.9005188 L4.3889303,14.6233112 L4.19310856,14.3023007 C3.80945988,13.6733855 3.52271926,12.9883084 3.34391125,12.2679051 L3.25384758,11.9050457 L1.24905477,11.8179783 C1.1099936,11.8118879 1,11.6970269 1,11.5578635 L1,9.44250742 C1,9.30299257 1.10997415,9.18811298 1.24923764,9.18201374 L2.88033015,9.11117602 L3.25389102,9.0949524 L3.34392468,8.73204075 C3.52264768,8.01163624 3.80927461,7.32691821 4.19310856,6.69769929 L4.3889303,6.37668876 L3.02694642,4.89065335 C2.93255692,4.78761165 2.93597385,4.629032 3.03452512,4.5304789 L4.53041726,3.03455901 C4.58027752,2.98457342 4.64550393,2.95808605 4.71468445,2.95808605 C4.7797186,2.95808605 4.84150018,2.98166925 4.8906607,3.02670262 L6.11454614,4.14861846 L6.38870279,4.39993338 L6.70824614,4.20963597 C7.3338849,3.83704978 8.01335544,3.55973114 8.72655192,3.38821709 L9.09274898,3.30015168 L9.1822365,1.24916892 C9.18821529,1.10962229 9.3027248,1 9.44234157,1 L11.5576584,1 L11.5576584,0.5 Z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M26.0986073,13.9153342 C25.7313817,14.0273351 25.3760767,14.1722373 25.0365936,14.3480056 L24.3841649,13.749935 C24.1843765,13.5669192 23.9267139,13.4685645 23.6610133,13.4685645 C23.3790259,13.4685645 23.1065854,13.5791981 22.9036466,13.7826493 L21.7821697,14.9041465 C21.3769922,15.3093315 21.36294,15.9614912 21.7500635,16.3841002 L22.3350215,17.0223371 C22.1525596,17.3662443 22.0019875,17.7267544 21.8854243,18.0999214 L21.0238259,18.1373403 C20.4513116,18.1624144 20,18.6338568 20,19.2068806 L20,20.7933976 C20,21.366223 20.4513914,21.8375891 21.0236431,21.8626517 L21.8854576,21.90008 C22.0020446,22.2732429 22.1526249,22.6338071 22.3350305,22.9776532 L21.7501534,23.6158017 C21.3629369,24.0379903 21.376988,24.6904206 21.7819421,25.095904 L22.9041326,26.2178373 C23.1070112,26.4207196 23.3793147,26.5314355 23.6610133,26.5314355 C23.9267139,26.5314355 24.1843765,26.4330808 24.3840375,26.2501819 L25.0365734,25.6520129 C25.3761896,25.8279058 25.731507,25.9729005 26.0986096,26.0849165 L26.1375093,26.9762694 C26.1620314,27.5486411 26.633513,28 27.2067562,28 L28.7932438,28 C29.3663519,28 29.8374367,27.548868 29.8624883,26.9763261 L29.9024949,26.0583578 C30.2586438,25.944031 30.6032302,25.7985613 30.9325961,25.6239341 L31.6158887,26.2501142 C31.814981,26.4329578 32.0731028,26.5314355 32.3389867,26.5314355 C32.6202996,26.5314355 32.8923966,26.4208036 33.0954685,26.2182357 L34.2177865,25.0961756 C34.623012,24.6904206 34.6370631,24.0379903 34.2497286,23.615673 L33.610685,22.9183933 C33.7787222,22.5934409 33.9185416,22.2541403 34.0282855,21.9039397 L34.975962,21.8626568 C35.548518,21.8376038 36,21.3663098 36,20.7933976 L36,19.2068806 C36,18.6337701 35.5485978,18.1623997 34.9760589,18.1373474 L34.028277,18.0960599 C33.9185523,17.7459719 33.7787392,17.4067408 33.6106493,17.0816456 L34.2498541,16.3841901 C34.63706,15.9614912 34.6230078,15.3093315 34.2178303,14.9041465 L33.0959112,13.7822066 C32.8928232,13.5791148 32.6205879,13.4685645 32.3389867,13.4685645 C32.0731028,13.4685645 31.814981,13.5670422 31.6154949,13.7502471 L30.9325946,14.3760673 C30.6031679,14.2014149 30.2585788,14.0559852 29.9024924,13.9417851 L29.8624922,13.023765 C29.8374367,12.451132 29.3663519,12 28.7932438,12 L28.7932438,12.5 L28.7932438,12 L27.2067562,12 C26.633513,12 26.1620314,12.4513589 26.1374921,13.0241284 L26.0986073,13.9153342 Z M28.7932438,12.5 L28.7932438,13 C28.8309654,13 28.8617871,13.0295162 28.8634441,13.0673869 L28.9190771,14.3441875 L28.9352192,14.7146553 L29.294419,14.806755 C29.805762,14.9378645 30.2930013,15.144077 30.7418366,15.4175991 L31.062766,15.6131749 L32.2915128,14.487132 C32.3050196,14.474728 32.3211748,14.4685645 32.3389867,14.4685645 C32.3578302,14.4685645 32.3750476,14.4755563 32.3887979,14.4893068 L33.510717,15.6112467 C33.537307,15.6378372 33.5382284,15.680597 33.5125494,15.7086298 L32.6302298,16.6713551 L32.3792475,16.9452094 L32.5689828,17.2645662 C32.8345153,17.7115028 33.033849,18.1945101 33.159879,18.7006522 L33.2501316,19.0631106 L34.932441,19.1363957 C34.9702114,19.1380484 35,19.1691548 35,19.2068806 L35,20.7933976 C35,20.8308505 34.9702061,20.8619518 34.9323442,20.8636085 L33.6233036,20.9206332 L33.2501316,20.9368894 L33.159879,21.2993478 C33.0337872,21.8057381 32.8343874,22.2889696 32.5690474,22.7353251 L32.3791812,23.0547183 L33.5126318,24.2914602 C33.5382275,24.3193677 33.5373005,24.3624131 33.5104894,24.3892592 L32.3888417,25.5106494 C32.3751577,25.524299 32.3576057,25.5314355 32.3389867,25.5314355 C32.3211748,25.5314355 32.3050196,25.525272 32.2919067,25.5132293 L31.3398428,24.6407426 L31.062766,24.3868251 L30.7418366,24.5824009 C30.2931366,24.8558405 29.8058365,25.0621428 29.2941954,25.1935806 L28.935215,25.2858007 L28.8634404,26.9326994 C28.8617871,26.9704838 28.8309654,27 28.7932438,27 L27.2067562,27 C27.1689765,27 27.13818,26.9705179 27.1365756,26.9330676 L27.081756,25.6769205 L27.0653348,25.3006449 L26.6991415,25.2125804 C26.1769443,25.0869991 25.6790132,24.8836457 25.2201432,24.6103752 L24.9005998,24.4200777 L23.7084335,25.5129171 C23.6949464,25.525272 23.6787997,25.5314355 23.6610133,25.5314355 C23.6422236,25.5314355 23.6249009,25.5243922 23.6112021,25.5106932 L22.4892392,24.3889877 C22.4626995,24.3624131 22.4617725,24.3193677 22.4872427,24.291597 L23.3182986,23.3848474 L23.5723653,23.1076399 L23.3765436,22.7866293 C23.0954072,22.3257625 22.8852874,21.8237471 22.7542523,21.2958168 L22.6641886,20.9329574 L21.0672147,20.8636014 C21.0297958,20.8619626 21,20.8308483 21,20.7933976 L21,19.2068806 C21,19.1691569 21.0297905,19.1380376 21.0673975,19.1363906 L22.2906712,19.0832643 L22.6642321,19.0670407 L22.7542657,18.704129 C22.8852363,18.176207 23.0952685,17.6744649 23.3765436,17.2133707 L23.5723653,16.8923601 L22.4873607,15.7085317 C22.4617716,15.680597 22.462693,15.6378372 22.489283,15.6112467 L23.6112021,14.4893068 C23.6250114,14.4754632 23.6419997,14.4685645 23.6610133,14.4685645 C23.6787997,14.4685645 23.6949464,14.474728 23.708561,14.4871997 L24.6264432,15.3286073 L24.9005998,15.5799223 L25.2201432,15.3896248 C25.6786057,15.116597 26.1765048,14.9133848 26.6991415,14.7876978 L27.0653385,14.6996324 L27.1365586,13.0673254 C27.13818,13.0294821 27.1689765,13 27.2067562,13 L28.7932438,13 L28.7932438,12.5 Z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                    points: "21.5265 7.4735 38.4735 7.4735 38.4735 6.5265 21.5265 6.5265"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M10.5,7.5 L10.5,8 C11.8807282,8 13,9.11929963 13,10.4998042 C13,11.8806499 11.8807787,13 10.5,13 C9.11922132,13 8,11.8806499 8,10.4998042 C8,9.11929963 9.11927177,8 10.5,8 L10.5,7.5 Z M10.5,7.5 L10.5,7 C8.56698144,7 7,8.56702046 7,10.4998042 C7,12.4329089 8.56691081,14 10.5,14 C12.4330892,14 14,12.4329089 14,10.4998042 C14,8.56702046 12.4330186,7 10.5,7 L10.5,7.5 Z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M28,18.5 L28,19 C28.5522915,19 29,19.4477196 29,19.9999021 C29,20.5522602 28.5523117,21 28,21 C27.4476883,21 27,20.5522602 27,19.9999021 C27,19.4477196 27.4477085,19 28,19 L28,18.5 Z M28,18.5 L28,18 C26.8954181,18 26,18.8954404 26,19.9999021 C26,21.1045192 26.8953778,22 28,22 C29.1046222,22 30,21.1045192 30,19.9999021 C30,18.8954404 29.1045819,18 28,18 L28,18.5 Z"
                })
            ]
        })
    });
}
function SummaryIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "19px",
        height: "26px",
        viewBox: "0 0 19 26",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-843.000000, -385.000000)",
                fill: "#009DD8",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M862,391.500042 L855.666612,391.500042 L855.666612,385 L855.968413,385 C856.285278,385 856.586915,385.127056 856.809622,385.355455 L861.653658,390.332166 C861.876365,390.560564 862,390.870474 862,391.190468 L862,391.500042 Z M857.249959,403.484515 C857.249959,403.149228 856.982711,402.875284 856.656183,402.875284 L848.343653,402.875284 C848.017125,402.875284 847.749877,403.149228 847.749877,403.484515 L847.749877,403.890894 C847.749877,404.226014 848.017125,404.500126 848.343653,404.500126 L856.656183,404.500126 C856.982711,404.500126 857.249959,404.226014 857.249959,403.890894 L857.249959,403.484515 Z M857.249959,400.234494 C857.249959,399.899375 856.982711,399.625263 856.656183,399.625263 L848.343653,399.625263 C848.017125,399.625263 847.749877,399.899375 847.749877,400.234494 L847.749877,400.640873 C847.749877,400.975993 848.017125,401.250105 848.343653,401.250105 L856.656183,401.250105 C856.982711,401.250105 857.249959,400.975993 857.249959,400.640873 L857.249959,400.234494 Z M856.656183,396.375242 L848.343653,396.375242 C848.017125,396.375242 847.749877,396.649354 847.749877,396.984473 L847.749877,397.390852 C847.749877,397.725972 848.017125,398.000084 848.343653,398.000084 L856.656183,398.000084 C856.982711,398.000084 857.249959,397.725972 857.249959,397.390852 L857.249959,396.984473 C857.249959,396.649354 856.982711,396.375242 856.656183,396.375242 L856.656183,396.375242 Z M855.270816,393.125221 L862,393.125221 L862,409.7812 C862,410.456817 861.470744,411 860.812449,411 L844.187551,411 C843.52942,411 843,410.456817 843,409.7812 L843,386.2188 C843,385.543519 843.52942,385 844.187551,385 L854.083265,385 L854.083265,391.906421 C854.083265,392.57666 854.617761,393.125221 855.270816,393.125221 L855.270816,393.125221 Z"
                })
            })
        })
    });
}
function DownloadIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "26px",
        height: "26px",
        viewBox: "0 0 26 26",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-778.000000, -341.000000)",
                fill: "#009DD8",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M799.937558,363.546958 C799.378913,363.546958 798.921947,364.003924 798.921947,364.562568 C798.921947,365.121045 799.378913,365.578179 799.937558,365.578179 C800.496202,365.578179 800.953168,365.121045 800.953168,364.562568 C800.953168,364.003924 800.496202,363.546958 799.937558,363.546958 L799.937558,363.546958 Z M796.687537,363.546958 C796.128892,363.546958 795.671926,364.003924 795.671926,364.562568 C795.671926,365.121045 796.128892,365.578179 796.687537,365.578179 C797.246181,365.578179 797.703147,365.121045 797.703147,364.562568 C797.703147,364.003924 797.246181,363.546958 796.687537,363.546958 L796.687537,363.546958 Z M793.031305,341 C793.706754,341 794.250105,341.543351 794.250105,342.2188 L794.250105,350.749895 L798.703632,350.749895 C799.60748,350.749895 800.059404,351.841807 799.419585,352.481626 L791.695701,360.210552 C791.314868,360.591385 790.690342,360.591385 790.309341,360.210552 L782.575373,352.481626 C781.935554,351.841807 782.387646,350.749895 783.291494,350.749895 L787.750063,350.749895 L787.750063,342.2188 C787.750063,341.543351 788.293414,341 788.968863,341 L793.031305,341 Z M804,365.7812 C804,366.456481 803.456649,367 802.7812,367 L779.2188,367 C778.543351,367 778,366.456481 778,365.7812 L778,360.093747 C778,359.418466 778.543351,358.874947 779.2188,358.874947 L786.668403,358.874947 L789.156758,361.363303 C790.177411,362.383955 791.822757,362.383955 792.84341,361.363303 L795.331765,358.874947 L802.7812,358.874947 C803.456649,358.874947 804,359.418466 804,360.093747 L804,365.7812 Z"
                })
            })
        })
    });
}
function ScheduleIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "23px",
        height: "26px",
        viewBox: "0 0 23 26",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M16.3817248,22.0493167 C16.3817248,22.38165 16.6557102,22.65365 16.9904693,22.65365 L19.0195058,22.65365 C19.354265,22.65365 19.6282504,22.38165 19.6282504,22.0493167 L19.6282504,20.0349833 C19.6282504,19.70265 19.354265,19.43065 19.0195058,19.43065 L16.9904693,19.43065 C16.6557102,19.43065 16.3817248,19.70265 16.3817248,20.0349833 L16.3817248,22.0493167 Z M16.3817248,15.6033167 C16.3817248,15.93565 16.6557102,16.20765 16.9904693,16.20765 L19.0195058,16.20765 C19.354265,16.20765 19.6282504,15.93565 19.6282504,15.6033167 L19.6282504,13.5889833 C19.6282504,13.25665 19.354265,12.98465 19.0195058,12.98465 L16.9904693,12.98465 C16.6557102,12.98465 16.3817248,13.25665 16.3817248,13.5889833 L16.3817248,15.6033167 Z M9.88867372,22.0493167 C9.88867372,22.38165 10.1626591,22.65365 10.4974182,22.65365 L12.5264547,22.65365 C12.8612139,22.65365 13.1351993,22.38165 13.1351993,22.0493167 L13.1351993,20.0349833 C13.1351993,19.70265 12.8612139,19.43065 12.5264547,19.43065 L10.4974182,19.43065 C10.1626591,19.43065 9.88867372,19.70265 9.88867372,20.0349833 L9.88867372,22.0493167 Z M9.88867372,15.6033167 C9.88867372,15.93565 10.1626591,16.20765 10.4974182,16.20765 L12.5264547,16.20765 C12.8612139,16.20765 13.1351993,15.93565 13.1351993,15.6033167 L13.1351993,13.5889833 C13.1351993,13.25665 12.8612139,12.98465 12.5264547,12.98465 L10.4974182,12.98465 C10.1626591,12.98465 9.88867372,13.25665 9.88867372,13.5889833 L9.88867372,15.6033167 Z M3.39562263,22.0493167 C3.39562263,22.38165 3.66960803,22.65365 4.00436715,22.65365 L6.03340365,22.65365 C6.36816277,22.65365 6.64214818,22.38165 6.64214818,22.0493167 L6.64214818,20.0349833 C6.64214818,19.70265 6.36816277,19.43065 6.03340365,19.43065 L4.00436715,19.43065 C3.66960803,19.43065 3.39562263,19.70265 3.39562263,20.0349833 L3.39562263,22.0493167 Z M3.39562263,15.6033167 C3.39562263,15.93565 3.66960803,16.20765 4.00436715,16.20765 L6.03340365,16.20765 C6.36816277,16.20765 6.64214818,15.93565 6.64214818,15.6033167 L6.64214818,13.5889833 C6.64214818,13.25665 6.36816277,12.98465 6.03340365,12.98465 L4.00436715,12.98465 C3.66960803,12.98465 3.39562263,13.25665 3.39562263,13.5889833 L3.39562263,15.6033167 Z M0.149264964,9.76165 L22.8747759,9.76165 L22.8747759,23.4593167 C22.8747759,24.7939833 21.7842066,25.87665 20.4397978,25.87665 L2.58407518,25.87665 C1.23983431,25.87665 0.149264964,24.7939833 0.149264964,23.4593167 L0.149264964,9.76165 Z M22.8747759,5.73298333 L22.8747759,8.15015 L0.149264964,8.15015 L0.149264964,5.73298333 C0.149264964,4.39848333 1.23983431,3.31581667 2.58407518,3.31581667 L5.0188854,3.31581667 L5.0188854,0.898483333 C5.0188854,0.455483333 5.38419927,0.0928166667 5.83060073,0.0928166667 L7.4538635,0.0928166667 C7.90009708,0.0928166667 8.26541095,0.455483333 8.26541095,0.898483333 L8.26541095,3.31581667 L14.758462,3.31581667 L14.758462,0.898483333 C14.758462,0.455483333 15.1237759,0.0928166667 15.5701774,0.0928166667 L17.1932723,0.0928166667 C17.6396737,0.0928166667 18.0049876,0.455483333 18.0049876,0.898483333 L18.0049876,3.31581667 L20.4397978,3.31581667 C21.7842066,3.31581667 22.8747759,4.39848333 22.8747759,5.73298333 L22.8747759,5.73298333 Z",
            fill: "#009DD8"
        })
    });
}
function PostsIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "26px",
        height: "26px",
        viewBox: "0 0 26 26",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(-847.000000, -342.000000)",
                fill: "#009DD8",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M861.625,354.593111 C861.625,354.369599 861.442148,354.186757 861.218792,354.186757 L853.906208,354.186757 C853.682684,354.186757 853.5,354.369599 853.5,354.593111 L853.5,355.405483 C853.5,355.628995 853.682684,355.811669 853.906208,355.811669 L861.218792,355.811669 C861.442148,355.811669 861.625,355.628995 861.625,355.405483 L861.625,354.593111 Z M866.5,349.718375 C866.5,349.494863 866.317148,349.312021 866.093792,349.312021 L853.906208,349.312021 C853.682684,349.312021 853.5,349.494863 853.5,349.718375 L853.5,350.530747 C853.5,350.754258 853.682684,350.936933 853.906208,350.936933 L866.093792,350.936933 C866.317148,350.936933 866.5,350.754258 866.5,350.530747 L866.5,349.718375 Z M873,345.249824 L873,359.874033 C873,361.666495 871.542559,363.123858 869.75,363.123858 L862.437416,363.123858 L856.094891,367.881628 C855.693725,368.176227 855.125,367.886838 855.125,367.389231 L855.125,363.123858 L850.25,363.123858 C848.457441,363.123858 847,361.666495 847,359.874033 L847,345.249824 C847,343.457362 848.457441,342 850.25,342 L869.75,342 C871.542559,342 873,343.457362 873,345.249824 L873,345.249824 Z"
                })
            })
        })
    });
}
function KeyIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "26px",
        height: "26px",
        viewBox: "0 0 26 26",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M19.5012245,8.9559 C20.8448374,8.9559 21.9339858,7.87373333 21.9339858,6.53873333 C21.9339858,5.20356667 20.8448374,4.1214 19.5012245,4.1214 C18.1574439,4.1214 17.0682955,5.20356667 17.0682955,6.53873333 C17.0682955,7.87373333 18.1574439,8.9559 19.5012245,8.9559 M17.0682955,17.8192333 C16.4996503,17.8192333 15.9435858,17.7655667 15.4044632,17.6645667 L14.1874955,19.0250667 C13.9872116,19.2489 13.5799342,19.4307333 13.2783342,19.4307333 L11.3917406,19.4307333 L11.3917406,21.4450667 C11.3917406,22.1124 10.8470826,22.6537333 10.1752761,22.6537333 L8.1479471,22.6537333 L8.1479471,24.6679 C8.1479471,25.3354 7.60328903,25.8765667 6.93148258,25.8765667 L1.25509548,25.8765667 C0.58312129,25.8765667 0.0386309677,25.3354 0.0386309677,24.6679 L0.0386309677,20.7370667 C0.0386309677,20.4165667 0.166618065,20.1090667 0.394914839,19.8824 L8.59548258,11.7342333 C8.30562452,10.8602333 8.1479471,9.9264 8.1479471,8.9559 C8.1479471,4.0609 12.1417148,0.0927333333 17.0682955,0.0927333333 C22.0094697,0.0927333333 25.9888116,4.0464 25.9888116,8.95606667 C25.9888116,13.8510667 21.9948761,17.8192333 17.0682955,17.8192333",
                fill: "#009DD8"
            })
        })
    });
}
function LessonCountIcon(props) {
    const fill = props.fill || "#7A85A0";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utils.SvgKeepRatio), {
        viewBox: {
            width: 22,
            height: 18
        },
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                id: "count-icon",
                fill: props.fill,
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M19,12 C20.6568542,12 22,13.3431458 22,15 L22,18 L16,18 L16,15 C16,13.3431458 17.3431458,12 19,12 Z M21,17 L21,15 C21,13.8954305 20.1045695,13 19,13 C17.8954305,13 17,13.8954305 17,15 L17,17 L21,17 Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M19,12.5 C20.3807119,12.5 21.5,11.3807119 21.5,10 C21.5,8.61928813 20.3807119,7.5 19,7.5 C17.6192881,7.5 16.5,8.61928813 16.5,10 C16.5,11.3807119 17.6192881,12.5 19,12.5 Z M19,11.5 C18.1715729,11.5 17.5,10.8284271 17.5,10 C17.5,9.17157288 18.1715729,8.5 19,8.5 C19.8284271,8.5 20.5,9.17157288 20.5,10 C20.5,10.8284271 19.8284271,11.5 19,11.5 Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                        points: "1.5 16.5 1.5 4.5 19.5 4.5 19.5 5.95832549 20.5 5.95832549 20.5 3.5 0.5 3.5 0.5 17.5 15.0333984 17.5 15.0333984 16.5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M0.5,0.5 L20.5,0.5 L20.5,4.5 L0.5,4.5 L0.5,0.5 Z M1.5,1.5 L1.5,3.5 L19.5,3.5 L19.5,1.5 L1.5,1.5 Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.97460855,6.35229821 L8.97460855,14.6881722 L13.3648046,10.5003434 L8.97460855,6.35229821 Z M9.97460855,8.67290549 L11.9123903,10.5038046 L9.97460855,12.3522638 L9.97460855,8.67290549 Z"
                    })
                ]
            })
        })
    });
}
function LessonUploadIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "23px",
        height: "23px",
        viewBox: "0 0 23 23",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-51.000000, -135.000000)",
            fill: "#45C7FF",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                transform: "translate(0.000000, 98.000000)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    transform: "translate(51.500000, 37.500000)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polygon", {
                            points: "11 5.5 6.5 11.5 9.5 11.5 9.5 16.5 12.5 16.5 12.5 11.5 15.5 11.5"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M11,22 C17.0751322,22 22,17.0751322 22,11 C22,4.92486775 17.0751322,0 11,0 C4.92486775,0 0,4.92486775 0,11 C0,17.0751322 4.92486775,22 11,22 Z M11,21 C5.4771525,21 1,16.5228475 1,11 C1,5.4771525 5.4771525,1 11,1 C16.5228475,1 21,5.4771525 21,11 C21,16.5228475 16.5228475,21 11,21 Z",
                            fillRule: "nonzero"
                        })
                    ]
                })
            })
        })
    });
}
function MessageIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "18px",
        height: "17px",
        viewBox: "0 0 18 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-850.000000, -260.000000)",
            fill: props.fill || "#2CA5EC",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M858.999979,260.602095 C863.971074,260.602095 867.999957,263.875121 867.999957,267.914578 C867.999957,271.954035 863.971074,275.227061 858.999979,275.227061 C857.649968,275.227061 856.373806,274.977465 855.224193,274.545017 C854.359365,275.234099 852.612096,276.352058 850.281249,276.352058 C850.168743,276.352058 850.070312,276.288784 850.024616,276.183315 C849.97892,276.077847 850,275.958302 850.07735,275.87745 C850.094929,275.859872 851.564449,274.281346 852.003901,272.509496 C850.752356,271.254414 850,269.65831 850,267.914578 C850,263.875121 854.028883,260.602095 858.999979,260.602095 Z"
            })
        })
    });
}
function ChatIcon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "38px",
        height: "31px",
        viewBox: "0 0 38 31",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            stroke: "#FFFFFF",
            strokeWidth: "1",
            fill: "none",
            transform: "translate(1.000000, 0.687919)",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M12.4951863,0 C19.0841956,0 24.48091,4.14175228 24.956335,9.39705096 C18.470943,9.76952621 13.3543539,14.1599631 13.3543539,19.5237509 C13.3543539,19.7775007 13.3658051,20.0290722 13.3883104,20.2781429 C13.0936179,20.2960657 12.7956417,20.3046777 12.4951863,20.3046777 C10.6208893,20.3046777 8.84912042,19.9581506 7.25304608,19.3577578 C6.05235584,20.3144491 3.62652304,21.866576 0.390474571,21.866576 C0.234275209,21.866576 0.0976186426,21.7787287 0.034176058,21.6323007 C-0.0292665267,21.4858728 -2.85993451e-13,21.319902 0.10739004,21.2076501 C0.131794701,21.1832455 2.1720148,18.9916879 2.78213132,16.5317267 C1.04453854,14.7892244 -2.85993451e-13,12.5732621 -2.85993451e-13,10.1523388 C-2.85993451e-13,4.54412875 5.59352916,0 12.4951863,0 Z"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M25.8495402,11.5580488 C31.370879,11.5580488 35.845713,15.1933604 35.845713,19.6799392 C35.845713,24.166518 31.370879,27.8018296 25.8495402,27.8018296 C24.350099,27.8018296 22.9326806,27.5246073 21.6558181,27.0442919 C20.6952636,27.8096468 18.7545927,29.0513512 16.1657478,29.0513512 C16.040788,29.0513512 15.9314625,28.9810733 15.8807083,28.8639306 C15.8299541,28.746788 15.8533674,28.6140111 15.9392796,28.5242093 C15.9588034,28.5046855 17.5909833,26.7514353 18.0790777,24.7834616 C16.6890002,23.3894565 15.8533674,21.6166824 15.8533674,19.6799392 C15.8533674,15.1933604 20.3282014,11.5580488 25.8495402,11.5580488 Z",
                    transform: "translate(25.849540, 20.304700) scale(-1, 1) translate(-25.849540, -20.304700) "
                })
            ]
        })
    });
}
function DoubleArrowLeftIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "22px",
        height: "17px",
        viewBox: "0 0 22 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            fill: props.fill || "#4E576E",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M21.7236604,1.09595242 L21.7236604,15.1683371 C21.7236604,16.1427763 20.5455321,16.6307436 19.856546,15.9417041 L12.8203537,8.90551174 C12.3932154,8.47842688 12.3932154,7.78586261 12.8203537,7.35877775 L19.856546,0.322585424 C20.5455321,-0.366507476 21.7236604,0.121513211 21.7236604,1.09595242 Z",
                    transform: "translate(17.111830, 8.132133) rotate(-360.000000) translate(-17.111830, -8.132133) "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M9.22366041,1.09595242 L9.22366041,15.1683371 C9.22366041,16.1427763 8.04553212,16.6307436 7.35654603,15.9417041 L0.320353698,8.90551174 C-0.106784566,8.47842688 -0.106784566,7.78586261 0.320353698,7.35877775 L7.35654603,0.322585424 C8.04553212,-0.366507476 9.22366041,0.121513211 9.22366041,1.09595242 Z",
                    transform: "translate(4.611830, 8.132133) rotate(-360.000000) translate(-4.611830, -8.132133) "
                })
            ]
        })
    });
}
function DoubleArrowRightIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "22px",
        height: "17px",
        viewBox: "0 0 22 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
            fill: props.fill || "#4E576E",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M9.22366041,1.09595242 L9.22366041,15.1683371 C9.22366041,16.1427763 8.04553212,16.6307436 7.35654603,15.9417041 L0.320353698,8.90551174 C-0.106784566,8.47842688 -0.106784566,7.78586261 0.320353698,7.35877775 L7.35654603,0.322585424 C8.04553212,-0.366507476 9.22366041,0.121513211 9.22366041,1.09595242 Z",
                    transform: "translate(4.611830, 8.132133) rotate(-180.000000) translate(-4.611830, -8.132133) "
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M21.7236604,1.09595242 L21.7236604,15.1683371 C21.7236604,16.1427763 20.5455321,16.6307436 19.856546,15.9417041 L12.8203537,8.90551174 C12.3932154,8.47842688 12.3932154,7.78586261 12.8203537,7.35877775 L19.856546,0.322585424 C20.5455321,-0.366507476 21.7236604,0.121513211 21.7236604,1.09595242 Z",
                    transform: "translate(17.111830, 8.132133) rotate(-180.000000) translate(-17.111830, -8.132133) "
                })
            ]
        })
    });
}
function ArrowRightIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "10px",
        height: "17px",
        viewBox: "0 0 10 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-764.000000, -480.000000)",
            fill: props.fill || "#4E576E",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M773.999975,481.512353 L773.999975,495.584738 C773.999975,496.559177 772.821847,497.047144 772.132861,496.358105 L765.096668,489.321912 C764.66953,488.894828 764.66953,488.202263 765.096668,487.775178 L772.132861,480.738986 C772.821847,480.049893 773.999975,480.537914 773.999975,481.512353 Z",
                transform: "translate(769.388145, 488.548534) rotate(-180.000000) translate(-769.388145, -488.548534) "
            })
        })
    });
}
function ArrowLeftIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "10px",
        height: "17px",
        viewBox: "0 0 10 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-762.000000, -544.000000)",
            fill: props.fill || "#4E576E",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M771.999975,545.512353 L771.999975,559.584738 C771.999975,560.559177 770.821847,561.047144 770.132861,560.358105 L763.096668,553.321912 C762.66953,552.894828 762.66953,552.202263 763.096668,551.775178 L770.132861,544.738986 C770.821847,544.049893 771.999975,544.537914 771.999975,545.512353 Z"
            })
        })
    });
}
function TrashIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "17px",
        height: "19px",
        viewBox: "0 0 17 19",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-1308.000000, -511.000000)",
            fill: props.fill || "#C65F5F",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1309.79538,527.703214 L1309.79538,515.890742 L1323.29535,515.890742 L1323.29535,527.703214 C1323.29535,528.634715 1322.53936,529.39071 1321.60786,529.39071 L1311.48288,529.39071 C1310.55138,529.39071 1309.79538,528.634715 1309.79538,527.703214 Z M1319.35786,518.703236 L1319.35786,526.578217 C1319.35786,526.888717 1319.60986,527.140715 1319.92036,527.140715 C1320.23086,527.140715 1320.48286,526.888717 1320.48286,526.578217 L1320.48286,518.703236 C1320.48286,518.392735 1320.23086,518.140737 1319.92036,518.140737 C1319.60986,518.140737 1319.35786,518.392735 1319.35786,518.703236 Z M1315.98287,518.703236 L1315.98287,526.578217 C1315.98287,526.888717 1316.23487,527.140715 1316.54537,527.140715 C1316.85587,527.140715 1317.10787,526.888717 1317.10787,526.578217 L1317.10787,518.703236 C1317.10787,518.392735 1316.85587,518.140737 1316.54537,518.140737 C1316.23487,518.140737 1315.98287,518.392735 1315.98287,518.703236 Z M1312.60788,518.703236 L1312.60788,526.578217 C1312.60788,526.888717 1312.85988,527.140715 1313.17038,527.140715 C1313.48088,527.140715 1313.73287,526.888717 1313.73287,526.578217 L1313.73287,518.703236 C1313.73287,518.392735 1313.48088,518.140737 1313.17038,518.140737 C1312.85988,518.140737 1312.60788,518.392735 1312.60788,518.703236 Z M1323.85785,512.51575 C1324.16835,512.51575 1324.42035,512.767749 1324.42035,513.078249 L1324.42035,514.203246 C1324.42035,514.513747 1324.16835,514.765745 1323.85785,514.765745 L1309.23289,514.765745 C1308.92239,514.765745 1308.67039,514.513747 1308.67039,514.203246 L1308.67039,513.078249 C1308.67039,512.767749 1308.92239,512.51575 1309.23289,512.51575 L1313.45163,512.51575 L1313.78211,511.858323 C1313.90831,511.600214 1314.24391,511.390753 1314.53124,511.390753 L1318.55339,511.390753 C1318.84175,511.390753 1319.18009,511.600214 1319.30863,511.858323 L1319.63911,512.51575 L1323.85785,512.51575 Z"
            })
        })
    });
}
function EditIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "21px",
        height: "19px",
        viewBox: "0 0 21 19",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            transform: "translate(-1271.000000, -511.000000)",
            fill: props.fill || "#648090",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1285.15386,514.315753 L1288.32495,517.486846 C1288.45854,517.620432 1288.45854,517.838408 1288.32495,517.971994 L1280.64687,525.65008 L1277.38435,526.012216 C1276.94843,526.061414 1276.57929,525.692275 1276.62849,525.256359 L1276.99062,521.993839 L1284.66871,514.315753 C1284.8023,514.182166 1285.02027,514.182166 1285.15386,514.315753 Z M1290.84916,513.510663 C1291.38354,514.045044 1291.38354,514.913408 1290.84916,515.45129 L1289.60465,516.695832 C1289.47106,516.829419 1289.25309,516.829419 1289.1195,516.695832 L1285.94841,513.524739 C1285.81482,513.391153 1285.81482,513.173177 1285.94841,513.039591 L1287.19292,511.795049 C1287.73083,511.260668 1288.59916,511.260668 1289.13354,511.795049 L1290.84916,513.510663 Z M1284.49997,523.561825 C1284.49997,523.449318 1284.54566,523.343849 1284.62301,523.262997 L1286.02926,521.856751 C1286.29643,521.593079 1286.74996,521.7794 1286.74996,522.155578 L1286.74996,527.703214 C1286.74996,528.634852 1285.9941,529.39071 1285.06247,529.39071 L1272.6875,529.39071 C1271.75586,529.39071 1271,528.634852 1271,527.703214 L1271,515.328244 C1271,514.396605 1271.75586,513.640748 1272.6875,513.640748 L1282.73512,513.640748 C1283.1113,513.640748 1283.30116,514.094276 1283.03395,514.361449 L1281.6277,515.767696 C1281.54685,515.845046 1281.44138,515.890742 1281.32887,515.890742 L1273.24999,515.890742 L1273.24999,527.140715 L1284.49997,527.140715 L1284.49997,523.561825 Z"
            })
        })
    });
}
function SquareArrowUpRightIcon(props) {
    const fill = props.fill || "#009DD8";
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utils.SvgKeepRatio), {
        viewBox: {
            width: 448,
            height: 512
        },
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: fill,
            d: "M384 32H64C28.65 32 0 60.66 0 96v320c0 35.34 28.65 64 64 64h320c35.35 0 64-28.66 64-64V96C448 60.66 419.3 32 384 32zM344 312c0 17.69-14.31 32-32 32s-32-14.31-32-32V245.3l-121.4 121.4C152.4 372.9 144.2 376 136 376s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L234.8 200H168c-17.69 0-32-14.31-32-32s14.31-32 32-32h144c17.69 0 32 14.31 32 32V312z"
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2II2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createVersionComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _omit = require("lodash/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styled = require("@mui/material/styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
function createVersionComponent(wrapper, styles) {
    const StyledVersion = (0, _styledDefault.default)(wrapper || 'label')(styles || versionDefaultStyles);
    const Version = (props)=>{
        const forwarded = (0, _omitDefault.default)(props, [
            'number'
        ]);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledVersion, {
            ...forwarded,
            children: props.number
        });
    };
    return Version;
}
function versionDefaultStyles() {
    return {
        padding: 4,
        color: '#fff',
        fontFamily: 'mono',
        fontSize: '7.6pt',
        display: 'flex',
        justifyContent: 'center'
    };
}

},{"react/jsx-runtime":"1dlk8","lodash/omit":"fhxvC","react":"9njXz","@mui/material/styles/styled":"bTnxF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1rNJY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MenuItem);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../context");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _chatItem = require("./chat-item");
var _chatItemDefault = parcelHelpers.interopDefault(_chatItem);
function MenuItem(item) {
    const { order, page, section, direction, selected, query } = item;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { languageId, role, link, unreadMessages } = context;
            const href = link({
                languageId,
                role,
                page,
                section
            }, '/:languageId/:role/:page/:section?', {
                query: query ? (0, _lodash.pick)(context, query) : undefined
            });
            const MenuIcon = page == 'chat' ? (0, _chatItemDefault.default) : (0, _iconDefault.default);
            if (item.href) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                className: `menu-item ${direction}${selected ? ' selected' : ''}`,
                href: item.href,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuIcon, {
                        name: page,
                        unreadMessages: unreadMessages
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: `${page}_title`
                        })
                    })
                ]
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                className: `menu-item ${direction}${selected ? ' selected' : ''}`,
                onClick: (e)=>selected && e.preventDefault(),
                to: href,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(MenuIcon, {
                        name: page,
                        unreadMessages: unreadMessages
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: `${page}_title`
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","query-string":"h6dFx","react":"9njXz","react-router-dom":"3uzXR","../../context":"iUP37","react-text":"lEpdJ","../icon":"82gpi","./chat-item":"eVTho","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eVTho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ChatItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _icons = require("../../resources/icons");
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const ChatWithNotification = (0, _material.withStyles)({
    bell: {
        position: 'relative',
        top: -26,
        left: -10
    }
})((props)=>{
    const { classes } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.BellIcon), {
                className: classes.bell
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                name: props.name
            })
        ]
    });
});
function ChatItem({ unreadMessages }) {
    const hasUnreadMessages = unreadMessages > 0;
    const Chat = hasUnreadMessages ? ChatWithNotification : (0, _iconDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Chat, {
        name: "chat"
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","../../resources/icons":"7BMUb","../icon":"82gpi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gYR0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubMenuItem);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("../../context");
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function SubMenuItem({ order, page, direction, selected, query, items }) {
    const menuClasses = useMenuClasses(direction);
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const openSubMenu = (e)=>setAnchorEl(e.currentTarget);
    const closeSubMenu = ()=>setAnchorEl(null);
    const toggleMenu = (e)=>anchorEl === null ? openSubMenu(e) : closeSubMenu();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { languageId, role, translate, link } = context;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "submenu",
                onClick: toggleMenu,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
                        id: `submenu-${order}`,
                        anchorEl: anchorEl,
                        keepMounted: true,
                        open: Boolean(anchorEl),
                        onClose: closeSubMenu,
                        PopoverClasses: menuClasses,
                        children: items.map((item, index)=>{
                            const { page, section } = item;
                            const href = link({
                                languageId,
                                role,
                                page,
                                section
                            }, '/:languageId/:role/:page/:section?', {
                                query: query ? pick(context, query) : undefined
                            });
                            const handleClick = (e)=>{
                                if (context.page == page) e.preventDefault();
                            };
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                    className: "link",
                                    to: href,
                                    onClick: handleClick,
                                    children: translate(item.label)
                                })
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)("menu-item", direction, {
                            selected
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                name: page
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: translate(`${page}_title`)
                            })
                        ]
                    })
                ]
            });
        }
    });
}
const useVerticalMenuClasses = (0, _material.makeStyles)(menuStyles('vertical'));
const useHorizontalMenuClasses = (0, _material.makeStyles)(menuStyles('horizontal'));
function useMenuClasses(direction = 'vertical') {
    const styles = {
        vertical: useVerticalMenuClasses(),
        horizontal: useHorizontalMenuClasses()
    };
    const [classes, setClasses] = (0, _reactDefault.default).useState(styles[direction]);
    (0, _reactDefault.default).useEffect(()=>{
        setClasses(styles[direction]);
    }, [
        direction
    ]);
    return classes;
}
function menuStyles(direction) {
    const props = {
        horizontal: {
            marginTop: -10,
            marginLeft: 20
        },
        vertical: {
            borderTopLeftRadius: 0,
            marginLeft: 74,
            marginTop: -89
        }
    };
    return (theme)=>({
            root: {
                zIndex: '5000 !important'
            },
            paper: {
                "& .link": {
                    textDecoration: 'none',
                    color: '#fff'
                },
                backgroundColor: '#2c75bd',
                borderBottomLeftRadius: 0,
                ...props[direction]
            }
        });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","../../context":"iUP37","../icon":"82gpi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ShgF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Page);
parcelHelpers.export(exports, "animatedPage", ()=>animatedPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderprops = require("react-spring/renderprops");
var _roles = require("../../roles");
var _rolesDefault = parcelHelpers.interopDefault(_roles);
var _context = require("../../context");
var _pageStyl = require("./page.styl");
function animatedPage(Elem, page) {
    return (style)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderprops.animated).div, {
            style: style,
            className: `page ${page}`,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Elem, {})
        });
}
function Page() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: ({ page, role })=>{
            const pages = (0, _rolesDefault.default)[role];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderprops.Transition), {
                native: true,
                reset: true,
                unique: true,
                items: page,
                from: {
                    position: 'absolute',
                    opacity: 0
                },
                enter: {
                    opacity: 1
                },
                leave: {
                    opacity: 0
                },
                children: (index)=>pages[index]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-spring/renderprops":"gWF4m","../../roles":"hZ9q9","../../context":"iUP37","./page.styl":"agZfc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hZ9q9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _teacher = require("./teacher");
var _teacherDefault = parcelHelpers.interopDefault(_teacher);
var _admin = require("./admin");
var _adminDefault = parcelHelpers.interopDefault(_admin);
const roles = {
    teacher: (0, _teacherDefault.default),
    admin: (0, _adminDefault.default)
};
exports.default = roles;

},{"./teacher":"kFFrW","./admin":"asbbv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kFFrW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "teacherPages", ()=>teacherPages);
var _lodash = require("lodash");
var _page = require("../../components/page");
var _dashboard = require("./dashboard");
var _dashboardDefault = parcelHelpers.interopDefault(_dashboard);
var _myCourses = require("./my-courses");
var _myCoursesDefault = parcelHelpers.interopDefault(_myCourses);
var _catalogue = require("./catalogue");
var _catalogueDefault = parcelHelpers.interopDefault(_catalogue);
var _monitoring = require("./monitoring");
var _monitoringDefault = parcelHelpers.interopDefault(_monitoring);
var _calendars = require("./calendars");
var _calendarsDefault = parcelHelpers.interopDefault(_calendars);
var _myLessons = require("./my-lessons");
var _myLessonsDefault = parcelHelpers.interopDefault(_myLessons);
var _rollbook = require("./rollbook");
var _rollbookDefault = parcelHelpers.interopDefault(_rollbook);
var _quiz = require("./quiz");
var _quizDefault = parcelHelpers.interopDefault(_quiz);
var _grading = require("./grading");
var _gradingDefault = parcelHelpers.interopDefault(_grading);
var _assessment = require("./assessment");
var _assessmentDefault = parcelHelpers.interopDefault(_assessment);
var _planning = require("./planning");
var _planningDefault = parcelHelpers.interopDefault(_planning);
var _resources = require("./resources");
var _resourcesDefault = parcelHelpers.interopDefault(_resources);
var _premiumRequired = require("./premium-required");
var _premiumRequiredDefault = parcelHelpers.interopDefault(_premiumRequired);
var _help = require("./help");
var _helpDefault = parcelHelpers.interopDefault(_help);
var _gradebook = require("./gradebook");
var _gradebookDefault = parcelHelpers.interopDefault(_gradebook);
var _homework = require("./homework");
var _homeworkDefault = parcelHelpers.interopDefault(_homework);
var _videoGridContainer = require("components/video-grid-container");
var _videoGridContainerDefault = parcelHelpers.interopDefault(_videoGridContainer);
const teacherPages = {
    "dashboard": (0, _dashboardDefault.default),
    "my-courses": (0, _myCoursesDefault.default),
    "catalogue": (0, _catalogueDefault.default),
    "monitoring": (0, _monitoringDefault.default),
    "calendars": (0, _calendarsDefault.default),
    "my-lessons": (0, _myLessonsDefault.default),
    "rollbook": (0, _rollbookDefault.default),
    "gradebook": (0, _gradebookDefault.default),
    "assessment": (0, _assessmentDefault.default),
    "quiz": (0, _quizDefault.default),
    "grading": (0, _gradingDefault.default),
    "planning": (0, _planningDefault.default),
    "planning-rd": (0, _planningDefault.default),
    "resources": (0, _resourcesDefault.default),
    "premium-required": (0, _premiumRequiredDefault.default),
    "homework": (0, _homeworkDefault.default),
    "help": (0, _helpDefault.default),
    "videos": (0, _videoGridContainerDefault.default)
};
const pages = (0, _lodash.mapValues)(teacherPages, (0, _page.animatedPage));
exports.default = pages;

},{"lodash":"1qc47","../../components/page":"6ShgF","./dashboard":"iEj13","./my-courses":"fIEL3","./catalogue":"1Bs2I","./monitoring":"bdobw","./calendars":"aJMED","./my-lessons":"8dSJc","./rollbook":"gLocj","./quiz":"lS3oG","./grading":"dW4vs","./assessment":"73fA8","./planning":"7Ik21","./resources":"l7ja5","./premium-required":"ui2Ft","./help":"9ewWl","./gradebook":"4ddew","./homework":"jvdQi","components/video-grid-container":"9LvLu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iEj13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Dashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _moment = require("external/moment");
var _reactCalendar = require("react-calendar");
var _reactCalendarDefault = parcelHelpers.interopDefault(_reactCalendar);
var _recentActivity = require("components/recent-activity");
var _recentActivityDefault = parcelHelpers.interopDefault(_recentActivity);
var _dashboardGroups = require("components/dashboard-groups");
var _dashboardGroupsDefault = parcelHelpers.interopDefault(_dashboardGroups);
var _newsItem = require("components/news-item");
var _newsItemDefault = parcelHelpers.interopDefault(_newsItem);
var _videoCarrusel = require("teacher/components/video-carrusel/videoCarrusel");
var _videoCarruselDefault = parcelHelpers.interopDefault(_videoCarrusel);
var _context = require("teacher/context");
var _dashboardStyl = require("./dashboard.styl");
function Dashboard(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { locked, lockedMessage, translate, profile } = context;
    const activeClass = ({ date })=>{
        const isActive = context.scheduledDays.find((schedule)=>(0, _moment.moment)(date).isSame(schedule, 'day'));
        return isActive ? 'scheduled-day' : null;
    };
    const news = locked ? [
        lockedMessage
    ] : context.news;
    const isDreyfous = (0, _react.useMemo)(()=>/^dreyfous.*/.test(profile.domain), [
        profile.domain
    ]);
    const isDgenius = (0, _react.useMemo)(()=>profile.institution.project == 'dgenius', [
        profile.institution.project
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "panel left-side",
                children: [
                    news.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "news",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: translate('news_label')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "news-list",
                                children: news.map((0, _newsItemDefault.default))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "activity",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: translate('activity_label')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recentActivityDefault.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "activity video-carrousel",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoCarruselDefault.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "panel right-side",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactCalendarDefault.default), {
                        locale: context.language.id,
                        formatMonth: (_, date)=>(0, _moment.moment)(date).format('MMMM'),
                        formatMonthYear: (_, date)=>(0, _moment.moment)(date).format('MMMM YYYY'),
                        formatShortWeekday: (_, date)=>(0, _moment.moment)(date).format('dd'),
                        tileClassName: activeClass,
                        onClickDay: (date)=>{
                            if (locked) return;
                            const start = (0, _moment.moment)(date).toISOString();
                            const query = {
                                start,
                                end: start
                            };
                            context.navigate({}, '/:languageId/:role/calendars/day', {
                                query
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "groups",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: translate('dashboard_groups_label')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "groups-table",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardGroupsDefault.default), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/moment":"mpofx","react-calendar":"7w9zi","components/recent-activity":"6IHpB","components/dashboard-groups":"glvzr","components/news-item":"8urSF","teacher/components/video-carrusel/videoCarrusel":"7L64M","teacher/context":"5LKDx","./dashboard.styl":"7DlwA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"mpofx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moment", ()=>(0, _momentDefault.default));
parcelHelpers.export(exports, "defaultRanges", ()=>defaultRanges);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const defaultRanges = {
    month: (date)=>({
            start: (0, _momentDefault.default)(date).startOf('month').startOf('week').format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).endOf('month').endOf('week').format('YYYY-MM-DD')
        }),
    week: (date)=>({
            start: (0, _momentDefault.default)(date).startOf('week').format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).endOf('week').format('YYYY-MM-DD')
        }),
    day: (date)=>({
            start: (0, _momentDefault.default)(date).format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).format('YYYY-MM-DD')
        })
};

},{"moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7w9zi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Calendar", {
    enumerable: true,
    get: function get() {
        return _Calendar["default"];
    }
});
Object.defineProperty(exports, "CenturyView", {
    enumerable: true,
    get: function get() {
        return _CenturyView["default"];
    }
});
Object.defineProperty(exports, "DecadeView", {
    enumerable: true,
    get: function get() {
        return _DecadeView["default"];
    }
});
Object.defineProperty(exports, "YearView", {
    enumerable: true,
    get: function get() {
        return _YearView["default"];
    }
});
Object.defineProperty(exports, "MonthView", {
    enumerable: true,
    get: function get() {
        return _MonthView["default"];
    }
});
exports["default"] = void 0;
var _Calendar = _interopRequireDefault(require("2c33e399e44af619"));
var _CenturyView = _interopRequireDefault(require("4e79d8880046633f"));
var _DecadeView = _interopRequireDefault(require("626eed5b12721160"));
var _YearView = _interopRequireDefault(require("cd3704393c764e7b"));
var _MonthView = _interopRequireDefault(require("162fe6dc5dc58244"));
require("64519b35c98a9850");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
var _default = _Calendar["default"];
exports["default"] = _default;

},{"2c33e399e44af619":"7rwuJ","4e79d8880046633f":"bYzSB","626eed5b12721160":"TkF5r","cd3704393c764e7b":"bc8ia","162fe6dc5dc58244":"f0h0k","64519b35c98a9850":"jjhoW"}],"7rwuJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("9cfee87d24d1bb17"));
var _propTypes = _interopRequireDefault(require("2a68b3f565beaf9"));
var _reactLifecyclesCompat = require("7b80746bdca2747d");
var _mergeClassNames = _interopRequireDefault(require("9ab8f1b33b4208a1"));
var _Navigation = _interopRequireDefault(require("d70e776a0bb8ebe7"));
var _CenturyView = _interopRequireDefault(require("15278f33f010b91d"));
var _DecadeView = _interopRequireDefault(require("21097966794ff8da"));
var _YearView = _interopRequireDefault(require("281c6fd89c502e75"));
var _MonthView = _interopRequireDefault(require("c250ff69f71fca1f"));
var _dates = require("3e367186e644fdce");
var _propTypes2 = require("959556566718fdb0");
var _utils = require("1787463c0191999b");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var baseClassName = 'react-calendar';
var allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), [
    'day'
]);
var datesAreDifferent = function datesAreDifferent(date1, date2) {
    return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
};
/**
 * Returns views array with disallowed values cut off.
 */ var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
    return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
};
/**
 * Determines whether a given view is allowed with currently applied settings.
 */ var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
    var views = getLimitedViews(minDetail, maxDetail);
    return views.indexOf(view) !== -1;
};
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */ var getView = function getView(view, minDetail, maxDetail) {
    if (isViewAllowed(view, minDetail, maxDetail)) return view;
    return getLimitedViews(minDetail, maxDetail).pop();
};
/**
 * Returns value type that can be returned with currently applied settings.
 */ var getValueType = function getValueType(maxDetail) {
    return allValueTypes[allViews.indexOf(maxDetail)];
};
var getValueFrom = function getValueFrom(value) {
    if (!value) return null;
    var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;
    if (!rawValueFrom) return null;
    var valueFromDate = new Date(rawValueFrom);
    if (isNaN(valueFromDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueFromDate;
};
var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
    var valueFrom = getValueFrom(value);
    if (!valueFrom) return null;
    var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);
    return (0, _utils.between)(detailValueFrom, minDate, maxDate);
};
var getValueTo = function getValueTo(value) {
    if (!value) return null;
    var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;
    if (!rawValueTo) return null;
    var valueToDate = new Date(rawValueTo);
    if (isNaN(valueToDate.getTime())) throw new Error("Invalid date: ".concat(value));
    return valueToDate;
};
var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
    var valueTo = getValueTo(value);
    if (!valueTo) return null;
    var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);
    return (0, _utils.between)(detailValueTo, minDate, maxDate);
};
var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
    if (value instanceof Array) return value;
    return [
        getDetailValueFrom(value, minDate, maxDate, maxDetail),
        getDetailValueTo(value, minDate, maxDate, maxDetail)
    ];
};
var getActiveStartDate = function getActiveStartDate(props) {
    var activeStartDate = props.activeStartDate, maxDate = props.maxDate, maxDetail = props.maxDetail, minDate = props.minDate, minDetail = props.minDetail, value = props.value, view = props.view;
    var rangeType = getView(view, minDetail, maxDetail);
    var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
    return (0, _dates.getBegin)(rangeType, valueFrom);
};
var Calendar = /*#__PURE__*/ function(_Component) {
    _inherits(Calendar, _Component);
    function Calendar() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, Calendar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "state", {});
        _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function(activeStartDate) {
            var onActiveDateChange = _this.props.onActiveDateChange;
            _this.setState({
                activeStartDate: activeStartDate
            }, function() {
                var view = _this.state.view;
                (0, _utils.callIfDefined)(onActiveDateChange, {
                    activeStartDate: activeStartDate,
                    view: view
                });
            });
        });
        _defineProperty(_assertThisInitialized(_this), "drillDown", function(activeStartDate) {
            if (!_this.drillDownAvailable) return;
            var _this$props = _this.props, maxDetail = _this$props.maxDetail, minDetail = _this$props.minDetail, onDrillDown = _this$props.onDrillDown;
            var views = getLimitedViews(minDetail, maxDetail);
            _this.setState(function(prevState) {
                var nextView = views[views.indexOf(prevState.view) + 1];
                return {
                    activeStartDate: activeStartDate,
                    view: nextView
                };
            }, function() {
                var view = _this.state.view;
                (0, _utils.callIfDefined)(onDrillDown, {
                    activeStartDate: activeStartDate,
                    view: view
                });
            });
        });
        _defineProperty(_assertThisInitialized(_this), "drillUp", function() {
            if (!_this.drillUpAvailable) return;
            var _this$props2 = _this.props, maxDetail = _this$props2.maxDetail, minDetail = _this$props2.minDetail, onDrillUp = _this$props2.onDrillUp;
            var views = getLimitedViews(minDetail, maxDetail);
            _this.setState(function(prevState) {
                var nextView = views[views.indexOf(prevState.view) - 1];
                var activeStartDate = (0, _dates.getBegin)(nextView, prevState.activeStartDate);
                return {
                    activeStartDate: activeStartDate,
                    view: nextView
                };
            }, function() {
                var _this$state = _this.state, activeStartDate = _this$state.activeStartDate, view = _this$state.view;
                (0, _utils.callIfDefined)(onDrillUp, {
                    activeStartDate: activeStartDate,
                    view: view
                });
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onChange", function(value) {
            var _this$props3 = _this.props, onChange = _this$props3.onChange, selectRange = _this$props3.selectRange;
            var nextValue;
            var callback;
            if (selectRange) {
                var previousValue = _this.state.value; // Range selection turned on
                if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
                ) // First value
                nextValue = (0, _dates.getBegin)(_this.valueType, value);
                else {
                    // Second value
                    nextValue = (0, _dates.getValueRange)(_this.valueType, previousValue, value);
                    callback = function callback() {
                        return (0, _utils.callIfDefined)(onChange, nextValue);
                    };
                }
            } else {
                // Range selection turned off
                nextValue = _this.getProcessedValue(value);
                callback = function callback() {
                    return (0, _utils.callIfDefined)(onChange, nextValue);
                };
            }
            _this.setState({
                value: nextValue
            }, callback);
        });
        _defineProperty(_assertThisInitialized(_this), "onMouseOver", function(value) {
            _this.setState(function(prevState) {
                if (prevState.hover && prevState.hover.getTime() === value.getTime()) return null;
                return {
                    hover: value
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function() {
            _this.setState({
                hover: null
            });
        });
        return _this;
    }
    _createClass(Calendar, [
        {
            key: "getProcessedValue",
            /**
     * Gets current value in a desired format.
     */ value: function getProcessedValue(value) {
                var _this$props4 = this.props, minDate = _this$props4.minDate, maxDate = _this$props4.maxDate, maxDetail = _this$props4.maxDetail, returnValue = _this$props4.returnValue;
                var processFunction = function() {
                    switch(returnValue){
                        case 'start':
                            return getDetailValueFrom;
                        case 'end':
                            return getDetailValueTo;
                        case 'range':
                            return getDetailValueArray;
                        default:
                            throw new Error('Invalid returnValue.');
                    }
                }();
                return processFunction(value, minDate, maxDate, maxDetail);
            }
        },
        {
            key: "renderContent",
            value: function renderContent() {
                var _this$props5 = this.props, calendarType = _this$props5.calendarType, locale = _this$props5.locale, maxDate = _this$props5.maxDate, minDate = _this$props5.minDate, renderChildren = _this$props5.renderChildren, selectRange = _this$props5.selectRange, tileClassName = _this$props5.tileClassName, tileContent = _this$props5.tileContent, tileDisabled = _this$props5.tileDisabled;
                var _this$state2 = this.state, activeStartDate = _this$state2.activeStartDate, hover = _this$state2.hover, value = _this$state2.value, view = _this$state2.view;
                var onMouseOver = this.onMouseOver, valueType = this.valueType;
                var commonProps = {
                    activeStartDate: activeStartDate,
                    hover: hover,
                    locale: locale,
                    maxDate: maxDate,
                    minDate: minDate,
                    onMouseOver: selectRange ? onMouseOver : null,
                    tileClassName: tileClassName,
                    tileContent: tileContent || renderChildren,
                    // For backwards compatibility
                    tileDisabled: tileDisabled,
                    value: value,
                    valueType: valueType
                };
                var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;
                switch(view){
                    case 'century':
                        var onClickDecade = this.props.onClickDecade;
                        return _react["default"].createElement(_CenturyView["default"], _extends({
                            onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
                        }, commonProps));
                    case 'decade':
                        var onClickYear = this.props.onClickYear;
                        return _react["default"].createElement(_DecadeView["default"], _extends({
                            onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
                        }, commonProps));
                    case 'year':
                        var _this$props6 = this.props, formatMonth = _this$props6.formatMonth, onClickMonth = _this$props6.onClickMonth;
                        return _react["default"].createElement(_YearView["default"], _extends({
                            formatMonth: formatMonth,
                            onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
                        }, commonProps));
                    case 'month':
                        var _this$props7 = this.props, formatShortWeekday = _this$props7.formatShortWeekday, onClickDay = _this$props7.onClickDay, onClickWeekNumber = _this$props7.onClickWeekNumber, showFixedNumberOfWeeks = _this$props7.showFixedNumberOfWeeks, showNeighboringMonth = _this$props7.showNeighboringMonth, showWeekNumbers = _this$props7.showWeekNumbers;
                        var onMouseLeave = this.onMouseLeave;
                        return _react["default"].createElement(_MonthView["default"], _extends({
                            calendarType: calendarType,
                            formatShortWeekday: formatShortWeekday,
                            onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
                            onClickWeekNumber: onClickWeekNumber,
                            onMouseLeave: onMouseLeave,
                            showFixedNumberOfWeeks: showFixedNumberOfWeeks,
                            showNeighboringMonth: showNeighboringMonth,
                            showWeekNumbers: showWeekNumbers
                        }, commonProps));
                    default:
                        throw new Error("Invalid view: ".concat(view, "."));
                }
            }
        },
        {
            key: "renderNavigation",
            value: function renderNavigation() {
                var showNavigation = this.props.showNavigation;
                if (!showNavigation) return null;
                var _this$props8 = this.props, formatMonthYear = _this$props8.formatMonthYear, locale = _this$props8.locale, maxDate = _this$props8.maxDate, maxDetail = _this$props8.maxDetail, minDate = _this$props8.minDate, minDetail = _this$props8.minDetail, navigationAriaLabel = _this$props8.navigationAriaLabel, navigationLabel = _this$props8.navigationLabel, next2AriaLabel = _this$props8.next2AriaLabel, next2Label = _this$props8.next2Label, nextAriaLabel = _this$props8.nextAriaLabel, nextLabel = _this$props8.nextLabel, prev2AriaLabel = _this$props8.prev2AriaLabel, prev2Label = _this$props8.prev2Label, prevAriaLabel = _this$props8.prevAriaLabel, prevLabel = _this$props8.prevLabel;
                var _this$state3 = this.state, activeStartDate = _this$state3.activeStartDate, view = _this$state3.view;
                return _react["default"].createElement(_Navigation["default"], {
                    activeStartDate: activeStartDate,
                    drillUp: this.drillUp,
                    formatMonthYear: formatMonthYear,
                    locale: locale,
                    maxDate: maxDate,
                    minDate: minDate,
                    navigationAriaLabel: navigationAriaLabel,
                    navigationLabel: navigationLabel,
                    next2AriaLabel: next2AriaLabel,
                    next2Label: next2Label,
                    nextAriaLabel: nextAriaLabel,
                    nextLabel: nextLabel,
                    prev2AriaLabel: prev2AriaLabel,
                    prev2Label: prev2Label,
                    prevAriaLabel: prevAriaLabel,
                    prevLabel: prevLabel,
                    setActiveStartDate: this.setActiveStartDate,
                    view: view,
                    views: getLimitedViews(minDetail, maxDetail)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props9 = this.props, className = _this$props9.className, selectRange = _this$props9.selectRange;
                var value = this.state.value;
                var onMouseLeave = this.onMouseLeave;
                var valueArray = [].concat(value);
                return _react["default"].createElement("div", {
                    className: (0, _mergeClassNames["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), className)
                }, this.renderNavigation(), _react["default"].createElement("div", {
                    className: "".concat(baseClassName, "__viewContainer"),
                    onBlur: selectRange ? onMouseLeave : null,
                    onMouseLeave: selectRange ? onMouseLeave : null
                }, this.renderContent()));
            }
        },
        {
            key: "drillDownAvailable",
            get: function get() {
                var _this$props10 = this.props, maxDetail = _this$props10.maxDetail, minDetail = _this$props10.minDetail;
                var view = this.state.view;
                var views = getLimitedViews(minDetail, maxDetail);
                return views.indexOf(view) < views.length - 1;
            }
        },
        {
            key: "drillUpAvailable",
            get: function get() {
                var _this$props11 = this.props, maxDetail = _this$props11.maxDetail, minDetail = _this$props11.minDetail;
                var view = this.state.view;
                var views = getLimitedViews(minDetail, maxDetail);
                return views.indexOf(view) > 0;
            }
        },
        {
            key: "valueType",
            get: function get() {
                var maxDetail = this.props.maxDetail;
                return getValueType(maxDetail);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var minDate = nextProps.minDate, maxDate = nextProps.maxDate, minDetail = nextProps.minDetail, maxDetail = nextProps.maxDetail;
                var nextState = {};
                /**
       * If the next activeStartDate is different from the current one, update
       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
       */ var nextActiveStartDate = getActiveStartDate(nextProps);
                if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
                    nextState.activeStartDate = nextActiveStartDate;
                    nextState.activeStartDateProps = nextActiveStartDate;
                }
                /**
       * If the next view is different from the current one, and the previously set view is not
       * valid based on minDetail and maxDetail, get a new one.
       */ var nextView = getView(nextProps.view, minDetail, maxDetail);
                if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
                    nextState.view = nextView;
                    nextState.viewProps = nextView;
                }
                /**
       * If the next value is different from the current one (with an exception of situation in
       * which values provided are limited by minDate and maxDate so that the dates are the same),
       * get a new one.
       */ var values = [
                    nextProps.value,
                    prevState.valueProps
                ];
                if (nextState.view // Allowed view changed
                 || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function(value) {
                    return getValueFrom(value, minDate, maxDate, maxDetail);
                }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function(value) {
                    return getValueTo(value, minDate, maxDate, maxDetail);
                })))) {
                    nextState.value = nextProps.value;
                    nextState.valueProps = nextProps.value;
                }
                if (!nextProps.selectRange && prevState.hover) nextState.hover = null;
                return nextState;
            }
        }
    ]);
    return Calendar;
}(_react.Component);
exports["default"] = Calendar;
Calendar.defaultProps = {
    maxDetail: 'month',
    minDetail: 'century',
    returnValue: 'start',
    showNavigation: true,
    showNeighboringMonth: true,
    view: 'month'
};
Calendar.propTypes = {
    activeStartDate: _propTypes["default"].instanceOf(Date),
    calendarType: _propTypes2.isCalendarType,
    className: _propTypes2.isClassName,
    formatMonth: _propTypes["default"].func,
    formatMonthYear: _propTypes["default"].func,
    formatShortWeekday: _propTypes["default"].func,
    locale: _propTypes["default"].string,
    maxDate: _propTypes2.isMaxDate,
    maxDetail: _propTypes["default"].oneOf(allViews),
    minDate: _propTypes2.isMinDate,
    minDetail: _propTypes["default"].oneOf(allViews),
    navigationAriaLabel: _propTypes["default"].string,
    navigationLabel: _propTypes["default"].func,
    next2AriaLabel: _propTypes["default"].string,
    next2Label: _propTypes["default"].node,
    nextAriaLabel: _propTypes["default"].string,
    nextLabel: _propTypes["default"].node,
    onActiveDateChange: _propTypes["default"].func,
    onChange: _propTypes["default"].func,
    onClickDay: _propTypes["default"].func,
    onClickDecade: _propTypes["default"].func,
    onClickMonth: _propTypes["default"].func,
    onClickWeekNumber: _propTypes["default"].func,
    onClickYear: _propTypes["default"].func,
    onDrillDown: _propTypes["default"].func,
    onDrillUp: _propTypes["default"].func,
    prev2AriaLabel: _propTypes["default"].string,
    prev2Label: _propTypes["default"].node,
    prevAriaLabel: _propTypes["default"].string,
    prevLabel: _propTypes["default"].node,
    renderChildren: _propTypes["default"].func,
    // For backwards compatibility
    returnValue: _propTypes["default"].oneOf([
        'start',
        'end',
        'range'
    ]),
    selectRange: _propTypes["default"].bool,
    showFixedNumberOfWeeks: _propTypes["default"].bool,
    showNavigation: _propTypes["default"].bool,
    showNeighboringMonth: _propTypes["default"].bool,
    showWeekNumbers: _propTypes["default"].bool,
    tileClassName: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        _propTypes2.isClassName
    ]),
    tileContent: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        _propTypes["default"].node
    ]),
    tileDisabled: _propTypes["default"].func,
    value: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes2.isValue
    ]),
    view: _propTypes["default"].oneOf(allViews)
};
(0, _reactLifecyclesCompat.polyfill)(Calendar);

},{"9cfee87d24d1bb17":"9njXz","2a68b3f565beaf9":"bnNSm","7b80746bdca2747d":"9jQEY","9ab8f1b33b4208a1":"6X3Jr","d70e776a0bb8ebe7":"7I856","15278f33f010b91d":"bYzSB","21097966794ff8da":"TkF5r","281c6fd89c502e75":"bc8ia","c250ff69f71fca1f":"f0h0k","3e367186e644fdce":"4jabn","959556566718fdb0":"6BWCy","1787463c0191999b":"eVxgy"}],"9jQEY":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfill", ()=>polyfill);
function componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = componentWillMount;
        prototype.componentWillReceiveProps = componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6X3Jr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeClassNames);
function mergeClassNames() {
    return Array.prototype.slice.call(arguments).reduce(function(classList, arg) {
        return classList.concat(arg);
    }, []).filter(function(arg) {
        return typeof arg === 'string';
    }).join(' ');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7I856":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Navigation;
var _react = _interopRequireDefault(require("b089d3952c6ce9d9"));
var _propTypes = _interopRequireDefault(require("418c129c1d46c4d0"));
var _dates = require("de561bc7fa585d6");
var _dateFormatter = require("6ac2a4e9a7749b6e");
var _propTypes2 = require("4806500c801e44f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var className = 'react-calendar__navigation';
function Navigation(_ref) {
    var date = _ref.activeStartDate, drillUp = _ref.drillUp, formatMonthYear = _ref.formatMonthYear, locale = _ref.locale, maxDate = _ref.maxDate, minDate = _ref.minDate, navigationAriaLabel = _ref.navigationAriaLabel, navigationLabel = _ref.navigationLabel, next2AriaLabel = _ref.next2AriaLabel, next2Label = _ref.next2Label, nextAriaLabel = _ref.nextAriaLabel, nextLabel = _ref.nextLabel, prev2AriaLabel = _ref.prev2AriaLabel, prev2Label = _ref.prev2Label, prevAriaLabel = _ref.prevAriaLabel, prevLabel = _ref.prevLabel, setActiveStartDate = _ref.setActiveStartDate, view = _ref.view, views = _ref.views;
    var drillUpAvailable = views.indexOf(view) > 0;
    var shouldShowPrevNext2Buttons = view !== 'century';
    var previousActiveStartDate = (0, _dates.getBeginPrevious)(view, date);
    var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginPrevious2)(view, date);
    var nextActiveStartDate = (0, _dates.getBeginNext)(view, date);
    var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginNext2)(view, date);
    var prevButtonDisabled = function() {
        if (previousActiveStartDate.getFullYear() < 1000) return true;
        var previousActiveEndDate = (0, _dates.getEndPrevious)(view, date);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function() {
        if (previousActiveStartDate2.getFullYear() < 1000) return true;
        var previousActiveEndDate = (0, _dates.getEndPrevious2)(view, date);
        return minDate && minDate >= previousActiveEndDate;
    }();
    var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
    var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;
    function onClickPrevious() {
        setActiveStartDate(previousActiveStartDate);
    }
    function onClickPrevious2() {
        setActiveStartDate(previousActiveStartDate2);
    }
    function onClickNext() {
        setActiveStartDate(nextActiveStartDate);
    }
    function onClickNext2() {
        setActiveStartDate(nextActiveStartDate2);
    }
    var label = function() {
        switch(view){
            case 'century':
                return (0, _dates.getCenturyLabel)(date);
            case 'decade':
                return (0, _dates.getDecadeLabel)(date);
            case 'year':
                return (0, _dates.getYear)(date);
            case 'month':
                return formatMonthYear(locale, date);
            default:
                throw new Error("Invalid view: ".concat(view, "."));
        }
    }();
    return _react["default"].createElement("div", {
        className: className,
        style: {
            display: 'flex'
        }
    }, prev2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
        "aria-label": prev2AriaLabel,
        className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
        disabled: prev2ButtonDisabled,
        onClick: onClickPrevious2,
        type: "button"
    }, prev2Label), _react["default"].createElement("button", {
        "aria-label": prevAriaLabel,
        className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
        disabled: prevButtonDisabled,
        onClick: onClickPrevious,
        type: "button"
    }, prevLabel), _react["default"].createElement("button", {
        "aria-label": navigationAriaLabel,
        className: "react-calendar__navigation__label",
        disabled: !drillUpAvailable,
        onClick: drillUp,
        style: {
            flexGrow: 1
        },
        type: "button"
    }, navigationLabel ? navigationLabel({
        date: date,
        view: view,
        label: label
    }) : label), _react["default"].createElement("button", {
        "aria-label": nextAriaLabel,
        className: "".concat(className, "__arrow ").concat(className, "__next-button"),
        disabled: nextButtonDisabled,
        onClick: onClickNext,
        type: "button"
    }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
        "aria-label": next2AriaLabel,
        className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
        disabled: next2ButtonDisabled,
        onClick: onClickNext2,
        type: "button"
    }, next2Label));
}
Navigation.defaultProps = {
    formatMonthYear: _dateFormatter.formatMonthYear,
    navigationAriaLabel: '',
    next2AriaLabel: '',
    next2Label: "\xbb",
    nextAriaLabel: '',
    nextLabel: "\u203A",
    prev2AriaLabel: '',
    prev2Label: "\xab",
    prevAriaLabel: '',
    prevLabel: "\u2039"
};
Navigation.propTypes = {
    activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
    drillUp: _propTypes["default"].func.isRequired,
    formatMonthYear: _propTypes["default"].func,
    locale: _propTypes["default"].string,
    maxDate: _propTypes["default"].instanceOf(Date),
    minDate: _propTypes["default"].instanceOf(Date),
    navigationAriaLabel: _propTypes["default"].string,
    navigationLabel: _propTypes["default"].func,
    next2AriaLabel: _propTypes["default"].string,
    next2Label: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].node
    ]),
    nextAriaLabel: _propTypes["default"].string,
    nextLabel: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].node
    ]),
    prev2AriaLabel: _propTypes["default"].string,
    prev2Label: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].node
    ]),
    prevAriaLabel: _propTypes["default"].string,
    prevLabel: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].node
    ]),
    setActiveStartDate: _propTypes["default"].func.isRequired,
    view: _propTypes2.isView.isRequired,
    views: _propTypes2.isViews.isRequired
};

},{"b089d3952c6ce9d9":"9njXz","418c129c1d46c4d0":"bnNSm","de561bc7fa585d6":"4jabn","6ac2a4e9a7749b6e":"gHnfW","4806500c801e44f":"6BWCy"}],"4jabn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getYear = getYear;
exports.getMonth = getMonth;
exports.getMonthIndex = getMonthIndex;
exports.getDay = getDay;
exports.getDayOfWeek = getDayOfWeek;
exports.getBeginOfCenturyYear = getBeginOfCenturyYear;
exports.getBeginOfCentury = getBeginOfCentury;
exports.getEndOfCentury = getEndOfCentury;
exports.getCenturyRange = getCenturyRange;
exports.getBeginOfPreviousCentury = getBeginOfPreviousCentury;
exports.getEndOfPreviousCentury = getEndOfPreviousCentury;
exports.getBeginOfNextCentury = getBeginOfNextCentury;
exports.getBeginOfDecadeYear = getBeginOfDecadeYear;
exports.getBeginOfDecade = getBeginOfDecade;
exports.getEndOfDecade = getEndOfDecade;
exports.getDecadeRange = getDecadeRange;
exports.getBeginOfPreviousDecade = getBeginOfPreviousDecade;
exports.getEndOfPreviousDecade = getEndOfPreviousDecade;
exports.getBeginOfNextDecade = getBeginOfNextDecade;
exports.getBeginOfYear = getBeginOfYear;
exports.getEndOfYear = getEndOfYear;
exports.getYearRange = getYearRange;
exports.getBeginOfPreviousYear = getBeginOfPreviousYear;
exports.getEndOfPreviousYear = getEndOfPreviousYear;
exports.getBeginOfNextYear = getBeginOfNextYear;
exports.getBeginOfMonth = getBeginOfMonth;
exports.getEndOfMonth = getEndOfMonth;
exports.getBeginOfWeek = getBeginOfWeek;
exports.getMonthRange = getMonthRange;
exports.getBeginOfPreviousMonth = getBeginOfPreviousMonth;
exports.getEndOfPreviousMonth = getEndOfPreviousMonth;
exports.getBeginOfNextMonth = getBeginOfNextMonth;
exports.getBeginOfDay = getBeginOfDay;
exports.getEndOfDay = getEndOfDay;
exports.getDayRange = getDayRange;
exports.getWeekNumber = getWeekNumber;
exports.getBegin = getBegin;
exports.getBeginPrevious = getBeginPrevious;
exports.getBeginNext = getBeginNext;
exports.getEnd = getEnd;
exports.getEndPrevious = getEndPrevious;
exports.getRange = getRange;
exports.getValueRange = getValueRange;
exports.getDaysInMonth = getDaysInMonth;
exports.getCenturyLabel = getCenturyLabel;
exports.getDecadeLabel = getDecadeLabel;
exports.isWeekend = isWeekend;
exports.getISOLocalMonth = getISOLocalMonth;
exports.getISOLocalDate = getISOLocalDate;
exports.getEndPrevious2 = exports.getBeginNext2 = exports.getBeginPrevious2 = void 0;
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var _map = _toConsumableArray(Array(7)).map(function(el, index) {
    return index;
}), _map2 = _slicedToArray(_map, 7), // eslint-disable-next-line no-unused-vars
SUNDAY = _map2[0], MONDAY = _map2[1], TUESDAY = _map2[2], WEDNESDAY = _map2[3], THURSDAY = _map2[4], FRIDAY = _map2[5], SATURDAY = _map2[6];
/* Simple getters - getting a property of a given point in time */ function getYear(date) {
    if (date instanceof Date) return date.getFullYear();
    if (typeof date === 'number') return date;
    var year = parseInt(date, 10);
    if (typeof date === 'string' && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getMonth(date) {
    return date.getMonth() + 1;
}
function getMonthIndex(date) {
    return date.getMonth();
}
function getDay(date) {
    return date.getDate();
}
function getDayOfWeek(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
    var weekday = date.getDay();
    switch(calendarType){
        case 'ISO 8601':
            // Shifts days of the week so that Monday is 0, Sunday is 6
            return (weekday + 6) % 7;
        case 'Arabic':
            return (weekday + 1) % 7;
        case 'Hebrew':
        case 'US':
            return weekday;
        default:
            throw new Error('Unsupported calendar type.');
    }
}
/* Complex getters - getting a property somehow related to a given point in time */ function getBeginOfCenturyYear(date) {
    var year = getYear(date) - 1;
    return year + -year % 100 + 1;
}
function getBeginOfCentury(date) {
    var beginOfCenturyYear = getBeginOfCenturyYear(date);
    return new Date(beginOfCenturyYear, 0, 1);
}
function getEndOfCentury(date) {
    var beginOfCenturyYear = getBeginOfCenturyYear(date);
    return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
}
function getCenturyRange(date) {
    return [
        getBeginOfCentury(date),
        getEndOfCentury(date)
    ];
}
function getBeginOfPreviousCentury(date) {
    var previousCenturyYear = getYear(date) - 100;
    return getBeginOfCentury(previousCenturyYear);
}
function getEndOfPreviousCentury(date) {
    var previousCenturyYear = getYear(date) - 100;
    return getEndOfCentury(previousCenturyYear);
}
function getBeginOfNextCentury(date) {
    var nextCenturyYear = getYear(date) + 100;
    return getBeginOfCentury(nextCenturyYear);
}
function getBeginOfDecadeYear(date) {
    var year = getYear(date) - 1;
    return year + -year % 10 + 1;
}
function getBeginOfDecade(date) {
    var beginOfDecadeYear = getBeginOfDecadeYear(date);
    return new Date(beginOfDecadeYear, 0, 1);
}
function getEndOfDecade(date) {
    var beginOfDecadeYear = getBeginOfDecadeYear(date);
    return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
}
function getDecadeRange(date) {
    return [
        getBeginOfDecade(date),
        getEndOfDecade(date)
    ];
}
function getBeginOfPreviousDecade(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
    return getBeginOfDecade(previousDecadeYear);
}
function getEndOfPreviousDecade(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
    return getEndOfDecade(previousDecadeYear);
}
function getBeginOfNextDecade(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
    return getBeginOfDecade(nextDecadeYear);
}
/**
 * Returns the beginning of a given year.
 *
 * @param {Date} date Date.
 */ function getBeginOfYear(date) {
    var year = getYear(date);
    return new Date(year, 0, 1);
}
/**
 * Returns the end of a given year.
 *
 * @param {Date} date Date.
 */ function getEndOfYear(date) {
    var year = getYear(date);
    return new Date(year + 1, 0, 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given year.
 *
 * @param {Date} date Date.
 */ function getYearRange(date) {
    return [
        getBeginOfYear(date),
        getEndOfYear(date)
    ];
}
function getBeginOfPreviousYear(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var previousYear = getYear(date) - offset;
    return getBeginOfYear(previousYear);
}
function getEndOfPreviousYear(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var previousYear = getYear(date) - offset;
    return getEndOfYear(previousYear);
}
function getBeginOfNextYear(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var nextYear = getYear(date) + offset;
    return getBeginOfYear(nextYear);
}
/**
 * Returns the beginning of a given month.
 *
 * @param {Date} date Date.
 */ function getBeginOfMonth(date) {
    var year = getYear(date);
    var monthIndex = getMonthIndex(date);
    return new Date(year, monthIndex, 1);
}
/**
 * Returns the end of a given month.
 *
 * @param {Date} date Date.
 */ function getEndOfMonth(date) {
    var year = getYear(date);
    var monthIndex = getMonthIndex(date);
    return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
}
/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */ function getBeginOfWeek(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
    var year = getYear(date);
    var monthIndex = getMonthIndex(date);
    var day = date.getDate() - getDayOfWeek(date, calendarType);
    return new Date(year, monthIndex, day);
}
/**
 * Returns an array with the beginning and the end of a given month.
 *
 * @param {Date} date Date.
 */ function getMonthRange(date) {
    return [
        getBeginOfMonth(date),
        getEndOfMonth(date)
    ];
}
function getDifferentMonth(date, offset) {
    var year = getYear(date);
    var previousMonthIndex = getMonthIndex(date) + offset;
    return new Date(year, previousMonthIndex, 1);
}
function getBeginOfPreviousMonth(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var previousMonth = getDifferentMonth(date, -offset);
    return getBeginOfMonth(previousMonth);
}
function getEndOfPreviousMonth(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var previousMonth = getDifferentMonth(date, -offset);
    return getEndOfMonth(previousMonth);
}
function getBeginOfNextMonth(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var nextMonth = getDifferentMonth(date, offset);
    return getBeginOfMonth(nextMonth);
}
function getBeginOfDay(date) {
    var year = getYear(date);
    var monthIndex = getMonthIndex(date);
    var day = getDay(date);
    return new Date(year, monthIndex, day);
}
function getEndOfDay(date) {
    var year = getYear(date);
    var monthIndex = getMonthIndex(date);
    var day = getDay(date);
    return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given day.
 *
 * @param {Date} date Date.
 */ function getDayRange(date) {
    return [
        getBeginOfDay(date),
        getEndOfDay(date)
    ];
}
/**
 * Gets week number according to ISO 8601 or US standard.
 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
 * In US calendar week 1 is the one with January 1.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */ function getWeekNumber(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
    var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
    var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
    var year = getYear(date) + 1;
    var dayInWeekOne;
    var beginOfFirstWeek; // Look for the first week one that does not come after a given date
    do {
        dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
        beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
        year -= 1;
    }while (date - beginOfFirstWeek < 0);
    return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
/**
 * Returns the beginning of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */ function getBegin(rangeType, date) {
    switch(rangeType){
        case 'century':
            return getBeginOfCentury(date);
        case 'decade':
            return getBeginOfDecade(date);
        case 'year':
            return getBeginOfYear(date);
        case 'month':
            return getBeginOfMonth(date);
        case 'day':
            return getBeginOfDay(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function getBeginPrevious(rangeType, date) {
    switch(rangeType){
        case 'century':
            return getBeginOfPreviousCentury(date);
        case 'decade':
            return getBeginOfPreviousDecade(date);
        case 'year':
            return getBeginOfPreviousYear(date);
        case 'month':
            return getBeginOfPreviousMonth(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function getBeginNext(rangeType, date) {
    switch(rangeType){
        case 'century':
            return getBeginOfNextCentury(date);
        case 'decade':
            return getBeginOfNextDecade(date);
        case 'year':
            return getBeginOfNextYear(date);
        case 'month':
            return getBeginOfNextMonth(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return getBeginOfPreviousDecade(date, 100);
        case 'year':
            return getBeginOfPreviousYear(date, 10);
        case 'month':
            return getBeginOfPreviousMonth(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
exports.getBeginPrevious2 = getBeginPrevious2;
var getBeginNext2 = function getBeginNext2(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return getBeginOfNextDecade(date, 100);
        case 'year':
            return getBeginOfNextYear(date, 10);
        case 'month':
            return getBeginOfNextMonth(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
/**
 * Returns the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */ exports.getBeginNext2 = getBeginNext2;
function getEnd(rangeType, date) {
    switch(rangeType){
        case 'century':
            return getEndOfCentury(date);
        case 'decade':
            return getEndOfDecade(date);
        case 'year':
            return getEndOfYear(date);
        case 'month':
            return getEndOfMonth(date);
        case 'day':
            return getEndOfDay(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
function getEndPrevious(rangeType, date) {
    switch(rangeType){
        case 'century':
            return getEndOfPreviousCentury(date);
        case 'decade':
            return getEndOfPreviousDecade(date);
        case 'year':
            return getEndOfPreviousYear(date);
        case 'month':
            return getEndOfPreviousMonth(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
    switch(rangeType){
        case 'decade':
            return getEndOfPreviousDecade(date, 100);
        case 'year':
            return getEndOfPreviousYear(date, 10);
        case 'month':
            return getEndOfPreviousMonth(date, 12);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
};
/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */ exports.getEndPrevious2 = getEndPrevious2;
function getRange(rangeType, date) {
    switch(rangeType){
        case 'century':
            return getCenturyRange(date);
        case 'decade':
            return getDecadeRange(date);
        case 'year':
            return getYearRange(date);
        case 'month':
            return getMonthRange(date);
        case 'day':
            return getDayRange(date);
        default:
            throw new Error("Invalid rangeType: ".concat(rangeType));
    }
}
/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */ function getValueRange(rangeType, date1, date2) {
    var rawNextValue = [
        date1,
        date2
    ].sort(function(a, b) {
        return a - b;
    });
    return [
        getBegin(rangeType, rawNextValue[0]),
        getEnd(rangeType, rawNextValue[1])
    ];
}
/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date.
 */ function getDaysInMonth(date) {
    var year = getYear(date);
    var monthIndex = getMonthIndex(date);
    return new Date(year, monthIndex + 1, 0).getDate();
}
function toYearLabel(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), start = _ref2[0], end = _ref2[1];
    return "".concat(getYear(start), " \u2013 ").concat(getYear(end));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */ function getCenturyLabel(date) {
    return toYearLabel(getCenturyRange(date));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */ function getDecadeLabel(date) {
    return toYearLabel(getDecadeRange(date));
}
/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */ function isWeekend(date) {
    var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
    var weekday = date.getDay();
    switch(calendarType){
        case 'Arabic':
        case 'Hebrew':
            return weekday === FRIDAY || weekday === SATURDAY;
        case 'ISO 8601':
        case 'US':
            return weekday === SATURDAY || weekday === SUNDAY;
        default:
            throw new Error('Unsupported calendar type.');
    }
}
/**
 * Returns local month in ISO-like format (YYYY-MM).
 */ function getISOLocalMonth(value) {
    if (!value) return value;
    var date = new Date(value);
    if (isNaN(date.getTime())) throw new Error("Invalid date: ".concat(value));
    var year = getYear(date);
    var month = "0".concat(getMonth(date)).slice(-2);
    return "".concat(year, "-").concat(month);
}
/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 */ function getISOLocalDate(value) {
    if (!value) return value;
    var date = new Date(value);
    if (isNaN(date.getTime())) throw new Error("Invalid date: ".concat(value));
    var year = getYear(date);
    var month = "0".concat(getMonth(date)).slice(-2);
    var day = "0".concat(getDay(date)).slice(-2);
    return "".concat(year, "-").concat(month, "-").concat(day);
}

},{}],"gHnfW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatShortWeekday = exports.formatWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatLongDate = exports.formatDate = void 0;
var _getUserLocale = _interopRequireDefault(require("43f1892667f74d93"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function getFormatter(options) {
    return function(locale, date) {
        return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
    };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */ function toSafeHour(date) {
    var safeDate = new Date(date);
    return new Date(safeDate.setHours(12));
}
function getSafeFormatter(options) {
    return function(locale, date) {
        return getFormatter(options)(locale, toSafeHour(date));
    };
}
var formatDateOptions = {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
};
var formatLongDateOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
};
var formatMonthYearOptions = {
    month: 'long',
    year: 'numeric'
};
var formatMonthOptions = {
    month: 'long'
};
var formatWeekdayOptions = {
    weekday: 'long'
};
var formatShortWeekdayOptions = {
    weekday: 'short'
};
var formatDate = getSafeFormatter(formatDateOptions);
exports.formatDate = formatDate;
var formatLongDate = getSafeFormatter(formatLongDateOptions);
exports.formatLongDate = formatLongDate;
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
exports.formatMonthYear = formatMonthYear;
var formatMonth = getSafeFormatter(formatMonthOptions);
exports.formatMonth = formatMonth;
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
exports.formatWeekday = formatWeekday;
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
exports.formatShortWeekday = formatShortWeekday;

},{"43f1892667f74d93":"l1lv0"}],"l1lv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserLocales", ()=>getUserLocales);
parcelHelpers.export(exports, "getUserLocale", ()=>getUserLocale);
var _lodashMemoize = require("lodash.memoize");
var _lodashMemoizeDefault = parcelHelpers.interopDefault(_lodashMemoize);
function resolver(options) {
    return JSON.stringify(options);
}
function uniqDefined(arr) {
    return arr.filter(function(el, index) {
        return el && arr.indexOf(el) === index;
    });
}
function normalizeLocales(arr) {
    return arr.map(function(el) {
        if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) return el;
        var splitEl = el.split('-');
        return splitEl[0] + "-" + splitEl[1].toUpperCase();
    });
}
function getUserLocalesInternal(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$useFallbackLocal = _ref.useFallbackLocale, useFallbackLocale = _ref$useFallbackLocal === void 0 ? true : _ref$useFallbackLocal, _ref$fallbackLocale = _ref.fallbackLocale, fallbackLocale = _ref$fallbackLocale === void 0 ? 'en-US' : _ref$fallbackLocale;
    var languageList = [];
    if (typeof window !== 'undefined') {
        var _window = window, navigator = _window.navigator;
        languageList = languageList.concat(navigator.languages, navigator.language, navigator.userLanguage, navigator.browserLanguage, navigator.systemLanguage);
    }
    if (useFallbackLocale) languageList.push(fallbackLocale);
    return normalizeLocales(uniqDefined(languageList));
}
var getUserLocales = (0, _lodashMemoizeDefault.default)(getUserLocalesInternal, resolver);
function getUserLocaleInternal(options) {
    return getUserLocales(options)[0] || null;
}
var getUserLocale = (0, _lodashMemoizeDefault.default)(getUserLocaleInternal, resolver);
exports.default = getUserLocale;

},{"lodash.memoize":"8Utdz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Utdz":[function(require,module,exports,__globalThis) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var global = arguments[3];
var FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */ var funcTag = '[object Function]', genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var splice = arrayProto.splice;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map'), nativeCreate = getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
module.exports = memoize;

},{}],"6BWCy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = void 0;
var _propTypes = _interopRequireDefault(require("eac943140d224f0c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var calendarTypes = [
    'ISO 8601',
    'US',
    'Arabic',
    'Hebrew'
];
var allViews = [
    'century',
    'decade',
    'year',
    'month'
];
var isCalendarType = _propTypes["default"].oneOf(calendarTypes);
exports.isCalendarType = isCalendarType;
var isMinDate = function isMinDate(props, propName, componentName) {
    var minDate = props[propName];
    if (minDate) {
        if (!(minDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
        var maxDate = props.maxDate;
        if (maxDate && minDate > maxDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    } // Everything is fine
    return null;
};
exports.isMinDate = isMinDate;
var isMaxDate = function isMaxDate(props, propName, componentName) {
    var maxDate = props[propName];
    if (maxDate) {
        if (!(maxDate instanceof Date)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
        var minDate = props.minDate;
        if (minDate && maxDate < minDate) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    } // Everything is fine
    return null;
};
exports.isMaxDate = isMaxDate;
var isValue = _propTypes["default"].oneOfType([
    _propTypes["default"].instanceOf(Date),
    _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date))
]);
exports.isValue = isValue;
var isViews = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(allViews));
exports.isViews = isViews;
var isClassName = _propTypes["default"].oneOfType([
    _propTypes["default"].string,
    _propTypes["default"].arrayOf(_propTypes["default"].string)
]);
exports.isClassName = isClassName;
var isView = function isView(props, propName, componentName) {
    var view = props[propName];
    var views = props.views;
    var allowedViews = views || allViews;
    if (view !== undefined && allowedViews.indexOf(view) === -1) return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function(a) {
        return "\"".concat(a, "\"");
    }).join(', '), "]."));
     // Everything is fine
    return null;
};
exports.isView = isView;
isView.isRequired = function(props, propName, componentName) {
    var view = props[propName];
    if (!view) return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
    return isView(props, propName, componentName);
};
var tileGroupProps = {
    activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
    hover: _propTypes["default"].instanceOf(Date),
    locale: _propTypes["default"].string,
    maxDate: isMaxDate,
    minDate: isMinDate,
    onClick: _propTypes["default"].func,
    onMouseOver: _propTypes["default"].func,
    tileClassName: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        isClassName
    ]),
    tileContent: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        _propTypes["default"].node
    ]),
    value: isValue,
    valueType: _propTypes["default"].string
};
exports.tileGroupProps = tileGroupProps;
var tileProps = {
    activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
    classes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
    date: _propTypes["default"].instanceOf(Date).isRequired,
    locale: _propTypes["default"].string,
    maxDate: isMaxDate,
    minDate: isMinDate,
    onClick: _propTypes["default"].func,
    onMouseOver: _propTypes["default"].func,
    style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ])),
    tileClassName: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        isClassName
    ]),
    tileContent: _propTypes["default"].oneOfType([
        _propTypes["default"].func,
        _propTypes["default"].node
    ]),
    tileDisabled: _propTypes["default"].func
};
exports.tileProps = tileProps;

},{"eac943140d224f0c":"bnNSm"}],"bYzSB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = CenturyView;
var _react = _interopRequireDefault(require("5d00fa74aee89002"));
var _Decades = _interopRequireDefault(require("2198af4a8bbb6909"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function CenturyView(props) {
    function renderDecades() {
        return _react["default"].createElement(_Decades["default"], props);
    }
    return _react["default"].createElement("div", {
        className: "react-calendar__century-view"
    }, renderDecades());
}

},{"5d00fa74aee89002":"9njXz","2198af4a8bbb6909":"fRNQO"}],"fRNQO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Decades;
var _react = _interopRequireDefault(require("78719526f8f81a83"));
var _TileGroup = _interopRequireDefault(require("2d268440e4b75116"));
var _Decade = _interopRequireDefault(require("4442970879a74147"));
var _dates = require("95db5bb422e18991");
var _propTypes = require("dc94c535436dc8ec");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function Decades(props) {
    var activeStartDate = props.activeStartDate;
    var start = (0, _dates.getBeginOfCenturyYear)(activeStartDate);
    var end = start + 99;
    return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
        className: "react-calendar__century-view__decades",
        dateTransform: _dates.getBeginOfDecade,
        dateType: "decade",
        end: end,
        start: start,
        step: 10,
        tile: _Decade["default"]
    }));
}
Decades.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

},{"78719526f8f81a83":"9njXz","2d268440e4b75116":"e1vu8","4442970879a74147":"kfqfp","95db5bb422e18991":"4jabn","dc94c535436dc8ec":"6BWCy"}],"e1vu8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = TileGroup;
var _react = _interopRequireDefault(require("c6a5a3d5e868d51"));
var _propTypes = _interopRequireDefault(require("15ced20b5b482b4a"));
var _Flex = _interopRequireDefault(require("8bb1e23f50b73ea5"));
var _utils = require("17576b1190a2b520");
var _propTypes2 = require("7e733c4c02ad6bf0");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function TileGroup(_ref) {
    var className = _ref.className, count = _ref.count, dateTransform = _ref.dateTransform, dateType = _ref.dateType, end = _ref.end, hover = _ref.hover, offset = _ref.offset, start = _ref.start, step = _ref.step, Tile = _ref.tile, value = _ref.value, valueType = _ref.valueType, tileProps = _objectWithoutProperties(_ref, [
        "className",
        "count",
        "dateTransform",
        "dateType",
        "end",
        "hover",
        "offset",
        "start",
        "step",
        "tile",
        "value",
        "valueType"
    ]);
    var tiles = [];
    for(var point = start; point <= end; point += step){
        var date = dateTransform(point);
        tiles.push(_react["default"].createElement(Tile, _extends({
            key: date.getTime(),
            classes: (0, _utils.getTileClasses)({
                value: value,
                valueType: valueType,
                date: date,
                dateType: dateType,
                hover: hover
            }),
            date: date,
            point: point
        }, tileProps)));
    }
    return _react["default"].createElement(_Flex["default"], {
        className: className,
        count: count,
        offset: offset,
        wrap: true
    }, tiles);
}
TileGroup.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
    activeStartDate: _propTypes["default"].instanceOf(Date),
    count: _propTypes["default"].number,
    dateTransform: _propTypes["default"].func.isRequired,
    offset: _propTypes["default"].number,
    step: _propTypes["default"].number,
    tile: _propTypes["default"].func.isRequired
});
TileGroup.defaultProps = {
    count: 3,
    step: 1
};

},{"c6a5a3d5e868d51":"9njXz","15ced20b5b482b4a":"bnNSm","8bb1e23f50b73ea5":"1tC8R","17576b1190a2b520":"eVxgy","7e733c4c02ad6bf0":"6BWCy"}],"1tC8R":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Flex;
var _react = _interopRequireDefault(require("4eb8a5a2f4ae5717"));
var _propTypes = _interopRequireDefault(require("4dc574506768bb75"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function toPercent(num) {
    return "".concat(num, "%");
}
function Flex(_ref) {
    var children = _ref.children, className = _ref.className, direction = _ref.direction, count = _ref.count, offset = _ref.offset, style = _ref.style, wrap = _ref.wrap, otherProps = _objectWithoutProperties(_ref, [
        "children",
        "className",
        "direction",
        "count",
        "offset",
        "style",
        "wrap"
    ]);
    return _react["default"].createElement("div", _extends({
        className: className,
        style: _objectSpread({
            display: 'flex',
            flexDirection: direction,
            flexWrap: wrap ? 'wrap' : 'no-wrap'
        }, style)
    }, otherProps), _react["default"].Children.map(children, function(child, index) {
        return _react["default"].cloneElement(child, _objectSpread({}, child.props, {
            style: {
                flexBasis: toPercent(100 / count),
                maxWidth: toPercent(100 / count),
                overflow: 'hidden',
                marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
            }
        }));
    }));
}
Flex.propTypes = {
    children: _propTypes["default"].node,
    className: _propTypes["default"].string,
    count: _propTypes["default"].number.isRequired,
    direction: _propTypes["default"].string,
    offset: _propTypes["default"].number,
    style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].number
    ])),
    wrap: _propTypes["default"].bool
};

},{"4eb8a5a2f4ae5717":"9njXz","4dc574506768bb75":"bnNSm"}],"eVxgy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = void 0;
var _dates = require("10d7defeec2fd657");
/**
 * Returns a function that, when called, calls all the functions
 * passed to it, applying its arguments to them.
 *
 * @param {Function[]} functions
 */ var mergeFunctions = function mergeFunctions() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return functions.filter(Boolean).forEach(function(f) {
            return f.apply(void 0, args);
        });
    };
};
/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */ exports.mergeFunctions = mergeFunctions;
var callIfDefined = function callIfDefined(fn) {
    if (fn && typeof fn === 'function') {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        fn.apply(void 0, args);
    }
};
exports.callIfDefined = callIfDefined;
var isValueWithinRange = function isValueWithinRange(value, range) {
    return range[0] <= value && range[1] >= value;
};
exports.isValueWithinRange = isValueWithinRange;
var isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
    return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
};
exports.isRangeWithinRange = isRangeWithinRange;
var doRangesOverlap = function doRangesOverlap(range1, range2) {
    return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
};
/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */ exports.doRangesOverlap = doRangesOverlap;
var between = function between(value, min, max) {
    if (min && min > value) return min;
    if (max && max < value) return max;
    return value;
};
exports.between = between;
var getTileClasses = function getTileClasses() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, value = _ref.value, valueType = _ref.valueType, date = _ref.date, dateType = _ref.dateType, hover = _ref.hover;
    var className = 'react-calendar__tile';
    var classes = [
        className
    ];
    if (!date) return classes;
    if (!(date instanceof Array) && !dateType) throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
    var now = new Date();
    var dateRange = date instanceof Array ? date : (0, _dates.getRange)(dateType, date);
    if (isValueWithinRange(now, dateRange)) classes.push("".concat(className, "--now"));
    if (!value) return classes;
    if (!(value instanceof Array) && !valueType) throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
    var valueRange = value instanceof Array ? value : (0, _dates.getRange)(valueType, value);
    if (isRangeWithinRange(valueRange, dateRange)) classes.push("".concat(className, "--active"));
    else if (doRangesOverlap(valueRange, dateRange)) classes.push("".concat(className, "--hasActive"));
    else if (hover && (dateRange[1] < valueRange[0] && doRangesOverlap(dateRange, [
        hover,
        valueRange[0]
    ]) || // Date after value
    dateRange[0] > valueRange[1] && doRangesOverlap(dateRange, [
        valueRange[1],
        hover
    ]))) classes.push("".concat(className, "--hover"));
    var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
    var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);
    if (isRangeStart) classes.push("".concat(className, "--rangeStart"));
    if (isRangeEnd) classes.push("".concat(className, "--rangeEnd"));
    if (isRangeStart && isRangeEnd) classes.push("".concat(className, "--rangeBothEnds"));
    return classes;
};
exports.getTileClasses = getTileClasses;

},{"10d7defeec2fd657":"4jabn"}],"kfqfp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Decade;
var _react = _interopRequireDefault(require("e8b0397af3092b6a"));
var _propTypes = _interopRequireDefault(require("51b97567dcee3685"));
var _Tile = _interopRequireDefault(require("c3752545c0d0efe9"));
var _dates = require("d7626847561445dc");
var _propTypes2 = require("c361690868f7908");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var className = 'react-calendar__century-view__decades__decade';
function Decade(_ref) {
    var classes = _ref.classes, point = _ref.point, otherProps = _objectWithoutProperties(_ref, [
        "classes",
        "point"
    ]);
    return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
        classes: [].concat(classes, className),
        maxDateTransform: _dates.getEndOfDecade,
        minDateTransform: _dates.getBeginOfDecade,
        view: "century"
    }), (0, _dates.getDecadeLabel)(point));
}
Decade.propTypes = _objectSpread({}, _propTypes2.tileProps, {
    point: _propTypes["default"].number.isRequired
});

},{"e8b0397af3092b6a":"9njXz","51b97567dcee3685":"bnNSm","c3752545c0d0efe9":"dAHSn","d7626847561445dc":"4jabn","c361690868f7908":"6BWCy"}],"dAHSn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("dde2f800b2e09b26"));
var _propTypes = _interopRequireDefault(require("81a794ae73036e38"));
var _mergeClassNames = _interopRequireDefault(require("718ca6148b2e79c5"));
var _propTypes2 = require("5e8a09491499c29e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var Tile = /*#__PURE__*/ function(_Component) {
    _inherits(Tile, _Component);
    function Tile() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, Tile);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "state", {});
        return _this;
    }
    _createClass(Tile, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, activeStartDate = _this$props.activeStartDate, children = _this$props.children, classes = _this$props.classes, date = _this$props.date, formatAbbr = _this$props.formatAbbr, locale = _this$props.locale, maxDate = _this$props.maxDate, maxDateTransform = _this$props.maxDateTransform, minDate = _this$props.minDate, minDateTransform = _this$props.minDateTransform, onClick = _this$props.onClick, onMouseOver = _this$props.onMouseOver, style = _this$props.style, tileDisabled = _this$props.tileDisabled, view = _this$props.view;
                var _this$state = this.state, tileClassName = _this$state.tileClassName, tileContent = _this$state.tileContent;
                return _react["default"].createElement("button", {
                    className: (0, _mergeClassNames["default"])(classes, tileClassName),
                    disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
                        activeStartDate: activeStartDate,
                        date: date,
                        view: view
                    }),
                    onClick: onClick && function() {
                        return onClick(date);
                    },
                    onFocus: onMouseOver && function() {
                        return onMouseOver(date);
                    },
                    onMouseOver: onMouseOver && function() {
                        return onMouseOver(date);
                    },
                    style: style,
                    type: "button"
                }, formatAbbr ? _react["default"].createElement("abbr", {
                    "aria-label": formatAbbr(locale, date)
                }, children) : children, tileContent);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var date = nextProps.date, tileClassName = nextProps.tileClassName, tileContent = nextProps.tileContent, view = nextProps.view;
                var nextState = {};
                if (tileClassName !== prevState.tileClassNameProps) {
                    nextState.tileClassName = typeof tileClassName === 'function' ? tileClassName({
                        date: date,
                        view: view
                    }) : tileClassName;
                    nextState.tileClassNameProps = tileClassName;
                }
                if (tileContent !== prevState.tileContentProps) {
                    nextState.tileContent = typeof tileContent === 'function' ? tileContent({
                        date: date,
                        view: view
                    }) : tileContent;
                    nextState.tileContentProps = tileContent;
                }
                return nextState;
            }
        }
    ]);
    return Tile;
}(_react.Component);
exports["default"] = Tile;
Tile.propTypes = _objectSpread({}, _propTypes2.tileProps, {
    children: _propTypes["default"].node.isRequired,
    formatAbbr: _propTypes["default"].func,
    maxDateTransform: _propTypes["default"].func.isRequired,
    minDateTransform: _propTypes["default"].func.isRequired
});

},{"dde2f800b2e09b26":"9njXz","81a794ae73036e38":"bnNSm","718ca6148b2e79c5":"6X3Jr","5e8a09491499c29e":"6BWCy"}],"TkF5r":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = DecadeView;
var _react = _interopRequireDefault(require("b8bf3b50c5a5c5ca"));
var _Years = _interopRequireDefault(require("fa4cc3658550151"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function DecadeView(props) {
    function renderYears() {
        return _react["default"].createElement(_Years["default"], props);
    }
    return _react["default"].createElement("div", {
        className: "react-calendar__decade-view"
    }, renderYears());
}

},{"b8bf3b50c5a5c5ca":"9njXz","fa4cc3658550151":"9KYS6"}],"9KYS6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Years;
var _react = _interopRequireDefault(require("d14a02e64d2eade"));
var _TileGroup = _interopRequireDefault(require("7f4ac5670ed58bfc"));
var _Year = _interopRequireDefault(require("c468a3b571390f0b"));
var _dates = require("6743e048170a227");
var _propTypes = require("8a38fed5e0a55338");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function Years(props) {
    var activeStartDate = props.activeStartDate;
    var start = (0, _dates.getBeginOfDecadeYear)(activeStartDate);
    var end = start + 9;
    return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
        className: "react-calendar__decade-view__years",
        dateTransform: function dateTransform(year) {
            return new Date(year, 0, 1);
        },
        dateType: "year",
        end: end,
        start: start,
        tile: _Year["default"]
    }));
}
Years.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

},{"d14a02e64d2eade":"9njXz","7f4ac5670ed58bfc":"e1vu8","c468a3b571390f0b":"hCvvV","6743e048170a227":"4jabn","8a38fed5e0a55338":"6BWCy"}],"hCvvV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Year;
var _react = _interopRequireDefault(require("d2ed3d87e8024d93"));
var _propTypes = _interopRequireDefault(require("bba6b74f7f6ddfa6"));
var _Tile = _interopRequireDefault(require("43865eccb11a4205"));
var _dates = require("571e5669605ecbfc");
var _propTypes2 = require("d421694a65603a79");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var className = 'react-calendar__decade-view__years__year';
function Year(_ref) {
    var classes = _ref.classes, point = _ref.point, otherProps = _objectWithoutProperties(_ref, [
        "classes",
        "point"
    ]);
    return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
        classes: [].concat(classes, className),
        maxDateTransform: _dates.getEndOfYear,
        minDateTransform: _dates.getBeginOfYear,
        view: "decade"
    }), point);
}
Year.propTypes = _objectSpread({}, _propTypes2.tileProps, {
    point: _propTypes["default"].number.isRequired
});

},{"d2ed3d87e8024d93":"9njXz","bba6b74f7f6ddfa6":"bnNSm","43865eccb11a4205":"dAHSn","571e5669605ecbfc":"4jabn","d421694a65603a79":"6BWCy"}],"bc8ia":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = YearView;
var _react = _interopRequireDefault(require("95bb22e1ab8cfd63"));
var _Months = _interopRequireDefault(require("913ae09f49c0a995"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function YearView(props) {
    function renderMonths() {
        return _react["default"].createElement(_Months["default"], props);
    }
    return _react["default"].createElement("div", {
        className: "react-calendar__year-view"
    }, renderMonths());
}

},{"95bb22e1ab8cfd63":"9njXz","913ae09f49c0a995":"9dzzd"}],"9dzzd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Months;
var _react = _interopRequireDefault(require("2c5ec6ec1a3c1ac9"));
var _propTypes = _interopRequireDefault(require("970487d35fb9d220"));
var _TileGroup = _interopRequireDefault(require("1bee802d190062a7"));
var _Month = _interopRequireDefault(require("4dce9e18f61d21a3"));
var _dates = require("d050e4a623ffcda3");
var _propTypes2 = require("9fc8eb2c0c88e37e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function Months(props) {
    var activeStartDate = props.activeStartDate;
    var start = 0;
    var end = 11;
    var year = (0, _dates.getYear)(activeStartDate);
    return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
        className: "react-calendar__year-view__months",
        dateTransform: function dateTransform(monthIndex) {
            return new Date(year, monthIndex, 1);
        },
        dateType: "month",
        end: end,
        start: start,
        tile: _Month["default"]
    }));
}
Months.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
    locale: _propTypes["default"].string
});

},{"2c5ec6ec1a3c1ac9":"9njXz","970487d35fb9d220":"bnNSm","1bee802d190062a7":"e1vu8","4dce9e18f61d21a3":"2aS0D","d050e4a623ffcda3":"4jabn","9fc8eb2c0c88e37e":"6BWCy"}],"2aS0D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Month;
var _react = _interopRequireDefault(require("5da17a57a5648b13"));
var _propTypes = _interopRequireDefault(require("a48b09c73ecfa0bf"));
var _Tile = _interopRequireDefault(require("1647ad449ebe3a62"));
var _dates = require("ac7ba18fd8ea8258");
var _dateFormatter = require("d6aa056545e68892");
var _propTypes2 = require("fbf4557498cff9f9");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var className = 'react-calendar__year-view__months__month';
function Month(_ref) {
    var classes = _ref.classes, date = _ref.date, formatMonth = _ref.formatMonth, locale = _ref.locale, otherProps = _objectWithoutProperties(_ref, [
        "classes",
        "date",
        "formatMonth",
        "locale"
    ]);
    return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
        classes: [].concat(classes, className),
        date: date,
        formatAbbr: _dateFormatter.formatMonthYear,
        locale: locale,
        maxDateTransform: _dates.getEndOfMonth,
        minDateTransform: _dates.getBeginOfMonth,
        view: "year"
    }), formatMonth(locale, date));
}
Month.defaultProps = {
    formatMonth: _dateFormatter.formatMonth
};
Month.propTypes = _objectSpread({}, _propTypes2.tileProps, {
    formatMonth: _propTypes["default"].func
});

},{"5da17a57a5648b13":"9njXz","a48b09c73ecfa0bf":"bnNSm","1647ad449ebe3a62":"dAHSn","ac7ba18fd8ea8258":"4jabn","d6aa056545e68892":"gHnfW","fbf4557498cff9f9":"6BWCy"}],"f0h0k":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = MonthView;
var _react = _interopRequireDefault(require("d320baf91d65dcd9"));
var _propTypes = _interopRequireDefault(require("96580e14eeb6c9a7"));
var _Days = _interopRequireDefault(require("ece8a496d54a6e51"));
var _Weekdays = _interopRequireDefault(require("4c0f160b6300ddb8"));
var _WeekNumbers = _interopRequireDefault(require("fdffb5d652b40c9f"));
var _propTypes2 = require("594451d0ebde66ec");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function MonthView(props) {
    var activeStartDate = props.activeStartDate, locale = props.locale, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var calendarTypeProps = props.calendarType, formatShortWeekday = props.formatShortWeekday, onClickWeekNumber = props.onClickWeekNumber, showWeekNumbers = props.showWeekNumbers, childProps = _objectWithoutProperties(props, [
        "calendarType",
        "formatShortWeekday",
        "onClickWeekNumber",
        "showWeekNumbers"
    ]);
    var calendarType = function() {
        if (calendarTypeProps) return calendarTypeProps;
        switch(locale){
            case 'en-CA':
            case 'en-US':
            case 'es-AR':
            case 'es-BO':
            case 'es-CL':
            case 'es-CO':
            case 'es-CR':
            case 'es-DO':
            case 'es-EC':
            case 'es-GT':
            case 'es-HN':
            case 'es-MX':
            case 'es-NI':
            case 'es-PA':
            case 'es-PE':
            case 'es-PR':
            case 'es-SV':
            case 'es-VE':
            case 'pt-BR':
                return 'US';
            // ar-LB, ar-MA intentionally missing
            case 'ar':
            case 'ar-AE':
            case 'ar-BH':
            case 'ar-DZ':
            case 'ar-EG':
            case 'ar-IQ':
            case 'ar-JO':
            case 'ar-KW':
            case 'ar-LY':
            case 'ar-OM':
            case 'ar-QA':
            case 'ar-SA':
            case 'ar-SD':
            case 'ar-SY':
            case 'ar-YE':
            case 'dv':
            case 'dv-MV':
            case 'ps':
            case 'ps-AR':
                return 'Arabic';
            case 'he':
            case 'he-IL':
                return 'Hebrew';
            default:
                return 'ISO 8601';
        }
    }();
    function renderWeekdays() {
        return _react["default"].createElement(_Weekdays["default"], {
            calendarType: calendarType,
            formatShortWeekday: formatShortWeekday,
            locale: locale,
            onMouseLeave: onMouseLeave
        });
    }
    function renderWeekNumbers() {
        if (!showWeekNumbers) return null;
        return _react["default"].createElement(_WeekNumbers["default"], {
            activeStartDate: activeStartDate,
            calendarType: calendarType,
            onClickWeekNumber: onClickWeekNumber,
            onMouseLeave: onMouseLeave,
            showFixedNumberOfWeeks: showFixedNumberOfWeeks
        });
    }
    function renderDays() {
        return _react["default"].createElement(_Days["default"], _extends({
            calendarType: calendarType
        }, childProps));
    }
    var className = 'react-calendar__month-view';
    return _react["default"].createElement("div", {
        className: [
            className,
            showWeekNumbers ? "".concat(className, "--weekNumbers") : ''
        ].join(' ')
    }, _react["default"].createElement("div", {
        style: {
            display: 'flex',
            alignItems: 'flex-end'
        }
    }, renderWeekNumbers(), _react["default"].createElement("div", {
        style: {
            flexGrow: 1,
            width: '100%'
        }
    }, renderWeekdays(), renderDays())));
}
MonthView.propTypes = {
    activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
    calendarType: _propTypes2.isCalendarType,
    formatShortWeekday: _propTypes["default"].func,
    locale: _propTypes["default"].string,
    maxDate: _propTypes2.isMaxDate,
    minDate: _propTypes2.isMinDate,
    onChange: _propTypes["default"].func,
    onClickWeekNumber: _propTypes["default"].func,
    onMouseLeave: _propTypes["default"].func,
    setActiveRange: _propTypes["default"].func,
    showFixedNumberOfWeeks: _propTypes["default"].bool,
    showNeighboringMonth: _propTypes["default"].bool,
    showWeekNumbers: _propTypes["default"].bool,
    value: _propTypes2.isValue,
    valueType: _propTypes["default"].string
};

},{"d320baf91d65dcd9":"9njXz","96580e14eeb6c9a7":"bnNSm","ece8a496d54a6e51":"gG3gy","4c0f160b6300ddb8":"3bBbn","fdffb5d652b40c9f":"ipZJT","594451d0ebde66ec":"6BWCy"}],"gG3gy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Days;
var _react = _interopRequireDefault(require("640cbfe16348a3fd"));
var _propTypes = _interopRequireDefault(require("fa452beb4fe97630"));
var _TileGroup = _interopRequireDefault(require("84b7510620603ebf"));
var _Day = _interopRequireDefault(require("47bfce3104ff27d6"));
var _dates = require("6826ddcb53b2d804");
var _propTypes2 = require("95295cf84854129c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Days(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType;
    var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks, showNeighboringMonth = props.showNeighboringMonth, otherProps = _objectWithoutProperties(props, [
        "showFixedNumberOfWeeks",
        "showNeighboringMonth"
    ]);
    var year = (0, _dates.getYear)(activeStartDate);
    var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
    var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
    var dayOfWeek = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
    var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
    /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */ var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
    /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */ var end = function() {
        if (showFixedNumberOfWeeks) // Always show 6 weeks
        return start + 42 - 1;
        var daysInMonth = (0, _dates.getDaysInMonth)(activeStartDate);
        if (showNeighboringMonth) {
            var activeEndDate = new Date(year, monthIndex, daysInMonth);
            return daysInMonth + (7 - (0, _dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
        }
        return daysInMonth;
    }();
    return _react["default"].createElement(_TileGroup["default"], _extends({}, otherProps, {
        className: "react-calendar__month-view__days",
        count: 7,
        currentMonthIndex: monthIndex,
        dateTransform: function dateTransform(day) {
            return new Date(year, monthIndex, day);
        },
        dateType: "day",
        end: end,
        offset: offset,
        start: start,
        tile: _Day["default"]
    }));
}
Days.propTypes = _objectSpread({
    calendarType: _propTypes2.isCalendarType.isRequired,
    showFixedNumberOfWeeks: _propTypes["default"].bool,
    showNeighboringMonth: _propTypes["default"].bool
}, _propTypes2.tileGroupProps);

},{"640cbfe16348a3fd":"9njXz","fa452beb4fe97630":"bnNSm","84b7510620603ebf":"e1vu8","47bfce3104ff27d6":"1pLSj","6826ddcb53b2d804":"4jabn","95295cf84854129c":"6BWCy"}],"1pLSj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Day;
var _react = _interopRequireDefault(require("11256a50b03c7506"));
var _propTypes = _interopRequireDefault(require("d1ad5522f99be66c"));
var _Tile = _interopRequireDefault(require("2686a3b313051154"));
var _dates = require("6903b09d258d8239");
var _dateFormatter = require("7df8d86a6180b853");
var _propTypes2 = require("dfdb26d7862cfa7");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(source, true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var className = 'react-calendar__month-view__days__day';
function Day(_ref) {
    var calendarType = _ref.calendarType, classes = _ref.classes, currentMonthIndex = _ref.currentMonthIndex, date = _ref.date, otherProps = _objectWithoutProperties(_ref, [
        "calendarType",
        "classes",
        "currentMonthIndex",
        "date"
    ]);
    return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
        classes: [].concat(classes, className, (0, _dates.isWeekend)(date, calendarType) ? "".concat(className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
        date: date,
        formatAbbr: _dateFormatter.formatLongDate,
        maxDateTransform: _dates.getEndOfDay,
        minDateTransform: _dates.getBeginOfDay,
        view: "month"
    }), (0, _dates.getDay)(date));
}
Day.propTypes = _objectSpread({}, _propTypes2.tileProps, {
    currentMonthIndex: _propTypes["default"].number.isRequired
});

},{"11256a50b03c7506":"9njXz","d1ad5522f99be66c":"bnNSm","2686a3b313051154":"dAHSn","6903b09d258d8239":"4jabn","7df8d86a6180b853":"gHnfW","dfdb26d7862cfa7":"6BWCy"}],"3bBbn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Weekdays;
var _react = _interopRequireDefault(require("e25fc52115613465"));
var _propTypes = _interopRequireDefault(require("4536ef9f7104bdb2"));
var _Flex = _interopRequireDefault(require("e38d076120cc0b45"));
var _dates = require("8932dff4fb8dca58");
var _dateFormatter = require("da25924c1210099");
var _propTypes2 = require("1469c51dbeffade5");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function Weekdays(props) {
    var calendarType = props.calendarType, formatShortWeekday = props.formatShortWeekday, locale = props.locale, onMouseLeave = props.onMouseLeave;
    var anyDate = new Date();
    var beginOfMonth = (0, _dates.getBeginOfMonth)(anyDate);
    var year = (0, _dates.getYear)(beginOfMonth);
    var monthIndex = (0, _dates.getMonthIndex)(beginOfMonth);
    var weekdays = [];
    for(var weekday = 1; weekday <= 7; weekday += 1){
        var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));
        var abbr = (0, _dateFormatter.formatWeekday)(locale, weekdayDate);
        weekdays.push(_react["default"].createElement("div", {
            key: weekday,
            className: "react-calendar__month-view__weekdays__weekday"
        }, _react["default"].createElement("abbr", {
            "aria-label": abbr,
            title: abbr
        }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
    }
    return _react["default"].createElement(_Flex["default"], {
        className: "react-calendar__month-view__weekdays",
        count: 7,
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave
    }, weekdays);
}
Weekdays.defaultProps = {
    formatShortWeekday: _dateFormatter.formatShortWeekday
};
Weekdays.propTypes = {
    calendarType: _propTypes2.isCalendarType.isRequired,
    formatShortWeekday: _propTypes["default"].func,
    locale: _propTypes["default"].string,
    onMouseLeave: _propTypes["default"].func
};

},{"e25fc52115613465":"9njXz","4536ef9f7104bdb2":"bnNSm","e38d076120cc0b45":"1tC8R","8932dff4fb8dca58":"4jabn","da25924c1210099":"gHnfW","1469c51dbeffade5":"6BWCy"}],"ipZJT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = WeekNumbers;
var _react = _interopRequireDefault(require("27eb2c6b0e386a0d"));
var _propTypes = _interopRequireDefault(require("2645a538eba45bc1"));
var _WeekNumber = _interopRequireDefault(require("c8d8b4805ca367d3"));
var _Flex = _interopRequireDefault(require("3f4a316ccf4344b1"));
var _dates = require("52e2192c0c995684");
var _propTypes2 = require("30f3ff9a27fb71f8");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function WeekNumbers(props) {
    var activeStartDate = props.activeStartDate, calendarType = props.calendarType, onClickWeekNumber = props.onClickWeekNumber, onMouseLeave = props.onMouseLeave, showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;
    var numberOfWeeks = function() {
        if (showFixedNumberOfWeeks) return 6;
        var numberOfDays = (0, _dates.getDaysInMonth)(activeStartDate);
        var startWeekday = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
        var days = numberOfDays - (7 - startWeekday);
        return 1 + Math.ceil(days / 7);
    }();
    var dates = function() {
        var year = (0, _dates.getYear)(activeStartDate);
        var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
        var day = (0, _dates.getDay)(activeStartDate);
        var result = [];
        for(var index = 0; index < numberOfWeeks; index += 1)result.push((0, _dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
        return result;
    }();
    var weekNumbers = dates.map(function(date) {
        return (0, _dates.getWeekNumber)(date, calendarType);
    });
    return _react["default"].createElement(_Flex["default"], {
        className: "react-calendar__month-view__weekNumbers",
        count: numberOfWeeks,
        direction: "column",
        onFocus: onMouseLeave,
        onMouseOver: onMouseLeave,
        style: {
            flexBasis: 'calc(100% * (1 / 8)',
            flexShrink: 0
        }
    }, weekNumbers.map(function(weekNumber, weekIndex) {
        return _react["default"].createElement(_WeekNumber["default"], {
            key: weekNumber,
            date: dates[weekIndex],
            onClickWeekNumber: onClickWeekNumber,
            weekNumber: weekNumber
        });
    }));
}
WeekNumbers.propTypes = {
    activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
    calendarType: _propTypes2.isCalendarType.isRequired,
    onClickWeekNumber: _propTypes["default"].func,
    onMouseLeave: _propTypes["default"].func,
    showFixedNumberOfWeeks: _propTypes["default"].bool
};

},{"27eb2c6b0e386a0d":"9njXz","2645a538eba45bc1":"bnNSm","c8d8b4805ca367d3":"8vsju","3f4a316ccf4344b1":"1tC8R","52e2192c0c995684":"4jabn","30f3ff9a27fb71f8":"6BWCy"}],"8vsju":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = WeekNumber;
var _react = _interopRequireDefault(require("5d6c52f6608c6c59"));
var _propTypes = _interopRequireDefault(require("f77ebafd56cf1f63"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function WeekNumber(_ref) {
    var date = _ref.date, onClickWeekNumber = _ref.onClickWeekNumber, weekNumber = _ref.weekNumber;
    return onClickWeekNumber ? _react["default"].createElement("button", {
        className: "react-calendar__tile",
        onClick: function onClick() {
            return onClickWeekNumber(weekNumber, date);
        },
        style: {
            flexGrow: 1
        },
        type: "button"
    }, _react["default"].createElement("span", null, weekNumber)) : _react["default"].createElement("div", {
        className: "react-calendar__tile",
        style: {
            flexGrow: 1
        }
    }, _react["default"].createElement("span", null, weekNumber));
}
WeekNumber.propTypes = {
    date: _propTypes["default"].instanceOf(Date).isRequired,
    onClickWeekNumber: _propTypes["default"].func,
    weekNumber: _propTypes["default"].number.isRequired
};

},{"5d6c52f6608c6c59":"9njXz","f77ebafd56cf1f63":"bnNSm"}],"jjhoW":[function() {},{}],"6IHpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RecentActivity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _context = require("../../context");
const Layout = ({ Table })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "activity-table",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
    });
const ActivityHeader = ({ title })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
        id: `${title}_header_title`
    });
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "no-results",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "dashboard-recent-activity-no-results"
        })
    });
}
function RecentActivity(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { activity, locked } = context;
            const columnDefinitions = [
                'date',
                'group',
                'students',
                'lesson'
            ].map((id)=>{
                const Column = (0, _columnsDefault.default)[id];
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                    id: id,
                    customComponent: Column,
                    customHeadingComponent: ActivityHeader
                }, id);
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                data: activity,
                components: {
                    Layout,
                    NoResults
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.RowDefinition), {
                    children: columnDefinitions
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","griddle-react":"6zdUV","react-text":"lEpdJ","./columns":"b05dk","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b05dk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../context");
var _utils = require("../../helpers/utils");
var _url = require("../../helpers/url");
var _url1 = require("helpers/url");
function LessonColumn({ rowData }) {
    const { type, lesson, lessonName, content } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            switch(type){
                case 'schedule':
                    const title = `${lesson} - ${lessonName}`;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "schedule link",
                        title: title,
                        ...(0, _url1.viewerGuard)({
                            href: context.locked ? '#' : (0, _url.subdomainLink)('www', 'preview', `?lesson=${lesson}`),
                            target: "_blank"
                        }),
                        children: title
                    });
                case 'uploaded':
                    const zipName = `${content.title.replace(/.epl$/, '')}.zip`;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "uploaded link",
                        title: content.title,
                        ...(0, _url1.viewerGuard)({
                            target: "_blank",
                            href: context.locked ? '#' : (0, _url.subdomainLink)('api-support', 'catalog', 'downloadUploaded', `?id=${rowData.title}`)
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                            text: content.title,
                            maxLine: 2,
                            ellipsis: "...",
                            trimRight: true,
                            basedOn: "letters"
                        })
                    });
                default:
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {});
            }
        }
    });
}
function DateColumn(row) {
    const start = (0, _momentDefault.default)(row.value).toISOString();
    const query = {
        start,
        end: start
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: "date link",
                to: context.locked ? '#' : context.link({}, '/:languageId/:role/calendars/day', {
                    query
                }),
                children: (0, _momentDefault.default)(row.value).format(context.translate('moment-date-format'))
            });
        }
    });
}
function GroupColumn({ rowData }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: "group link",
                title: rowData.group,
                to: context.locked ? '#' : context.link({
                    course: rowData.groupCourse
                }, '/:languageId/:role/my-courses/:course'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                    text: rowData.group,
                    maxLine: 2,
                    ellipsis: "...",
                    trimRight: true,
                    basedOn: "letters"
                })
            });
        }
    });
}
const columns = {
    date: DateColumn,
    group: (0, _utils.enhancedWithRowData)(GroupColumn),
    lesson: (0, _utils.enhancedWithRowData)(LessonColumn)
};
exports.default = columns;

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-lines-ellipsis":"ikp0X","react-router-dom":"3uzXR","../../context":"iUP37","../../helpers/utils":"gGc98","../../helpers/url":"65SQD","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ikp0X":[function(require,module,exports,__globalThis) {
"use strict";
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var React = require("d8a401464e4f4ac9");
var _require = require("5a2b4c8242fb0ae9"), canvasStyle = _require.canvasStyle, mirrorProps = _require.mirrorProps;
var _require2 = require("2e9fa51258911c0c"), omit = _require2.omit;
function prevSibling(node, count) {
    while(node && count--)node = node.previousElementSibling;
    return node;
}
var defaultProps = {
    basedOn: undefined,
    className: '',
    component: 'div',
    ellipsis: "\u2026",
    // &hellip;
    maxLine: 1,
    onReflow: function onReflow() {},
    text: '',
    trimRight: true,
    winWidth: undefined // for the HOC
};
var usedProps = Object.keys(defaultProps);
/**
 * props.text {String} the text you want to clamp
 * props.maxLine {Number|String} max lines allowed
 * props.ellipsis {String} the ellipsis indicator
 * props.trimRight {Boolean} should we trimRight the clamped text?
 * props.basedOn {String} letters|words
 * props.className {String}
 */ var LinesEllipsis = /*#__PURE__*/ function(_React$Component) {
    _inherits(LinesEllipsis, _React$Component);
    function LinesEllipsis(props) {
        var _this;
        _classCallCheck(this, LinesEllipsis);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(LinesEllipsis).call(this, props));
        _this.state = {
            text: props.text,
            clamped: false
        };
        _this.units = [];
        _this.maxLine = 0;
        _this.canvas = null;
        return _this;
    }
    _createClass(LinesEllipsis, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.initCanvas();
                this.reflow(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.winWidth !== this.props.winWidth) this.copyStyleToCanvas();
                if (this.props !== prevProps) this.reflow(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.canvas.parentNode.removeChild(this.canvas);
            }
        },
        {
            key: "setState",
            value: function setState(state, callback) {
                if (typeof state.clamped !== 'undefined') this.clamped = state.clamped;
                return _get(_getPrototypeOf(LinesEllipsis.prototype), "setState", this).call(this, state, callback);
            }
        },
        {
            key: "initCanvas",
            value: function initCanvas() {
                if (this.canvas) return;
                var canvas = this.canvas = document.createElement('div');
                canvas.className = "LinesEllipsis-canvas ".concat(this.props.className);
                canvas.setAttribute('aria-hidden', 'true');
                this.copyStyleToCanvas();
                Object.keys(canvasStyle).forEach(function(key) {
                    canvas.style[key] = canvasStyle[key];
                });
                document.body.appendChild(canvas);
            }
        },
        {
            key: "copyStyleToCanvas",
            value: function copyStyleToCanvas() {
                var _this2 = this;
                var targetStyle = window.getComputedStyle(this.target);
                mirrorProps.forEach(function(key) {
                    _this2.canvas.style[key] = targetStyle[key];
                });
            }
        },
        {
            key: "reflow",
            value: function reflow(props) {
                /* eslint-disable no-control-regex */ var basedOn = props.basedOn || (/^[\x00-\x7F]+$/.test(props.text) ? 'words' : 'letters');
                switch(basedOn){
                    case 'words':
                        this.units = props.text.split(/\b|(?=\W)/);
                        break;
                    case 'letters':
                        this.units = Array.from(props.text);
                        break;
                    default:
                        throw new Error("Unsupported options basedOn: ".concat(basedOn));
                }
                this.maxLine = +props.maxLine || 1;
                this.canvas.innerHTML = this.units.map(function(c) {
                    return "<span class='LinesEllipsis-unit'>".concat(c, "</span>");
                }).join('');
                var ellipsisIndex = this.putEllipsis(this.calcIndexes());
                var clamped = ellipsisIndex > -1;
                var newState = {
                    clamped: clamped,
                    text: clamped ? this.units.slice(0, ellipsisIndex).join('') : props.text
                };
                this.setState(newState, props.onReflow.bind(this, newState));
            }
        },
        {
            key: "calcIndexes",
            value: function calcIndexes() {
                var indexes = [
                    0
                ];
                var elt = this.canvas.firstElementChild;
                if (!elt) return indexes;
                var index = 0;
                var line = 1;
                var offsetTop = elt.offsetTop;
                while(elt = elt.nextElementSibling){
                    if (elt.offsetTop > offsetTop) {
                        line++;
                        indexes.push(index);
                        offsetTop = elt.offsetTop;
                    }
                    index++;
                    if (line > this.maxLine) break;
                }
                return indexes;
            }
        },
        {
            key: "putEllipsis",
            value: function putEllipsis(indexes) {
                if (indexes.length <= this.maxLine) return -1;
                var lastIndex = indexes[this.maxLine];
                var units = this.units.slice(0, lastIndex);
                var maxOffsetTop = this.canvas.children[lastIndex].offsetTop;
                this.canvas.innerHTML = units.map(function(c, i) {
                    return "<span class='LinesEllipsis-unit'>".concat(c, "</span>");
                }).join('') + "<wbr><span class='LinesEllipsis-ellipsis'>".concat(this.props.ellipsis, "</span>");
                var ndEllipsis = this.canvas.lastElementChild;
                var ndPrevUnit = prevSibling(ndEllipsis, 2);
                while(ndPrevUnit && (ndEllipsis.offsetTop > maxOffsetTop || // IE & Edge: doesn't support <wbr>
                ndEllipsis.offsetHeight > ndPrevUnit.offsetHeight || ndEllipsis.offsetTop > ndPrevUnit.offsetTop)){
                    this.canvas.removeChild(ndPrevUnit);
                    ndPrevUnit = prevSibling(ndEllipsis, 2);
                    units.pop();
                }
                return units.length;
            } // expose
        },
        {
            key: "isClamped",
            value: function isClamped() {
                return this.clamped; // do not use state.clamped. #27
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$state = this.state, text = _this$state.text, clamped = _this$state.clamped;
                var _this$props = this.props, Component = _this$props.component, ellipsis = _this$props.ellipsis, trimRight = _this$props.trimRight, className = _this$props.className, rest = _objectWithoutProperties(_this$props, [
                    "component",
                    "ellipsis",
                    "trimRight",
                    "className"
                ]);
                return React.createElement(Component, _extends({
                    className: "LinesEllipsis ".concat(clamped ? 'LinesEllipsis--clamped' : '', " ").concat(className),
                    ref: function ref(node) {
                        return _this3.target = node;
                    }
                }, omit(rest, usedProps)), clamped && trimRight ? text.replace(/[\s\uFEFF\xA0]+$/, '') : text, React.createElement("wbr", null), clamped && React.createElement("span", {
                    className: "LinesEllipsis-ellipsis"
                }, ellipsis));
            }
        }
    ]);
    return LinesEllipsis;
}(React.Component);
LinesEllipsis.defaultProps = defaultProps;
module.exports = LinesEllipsis;

},{"d8a401464e4f4ac9":"9njXz","5a2b4c8242fb0ae9":"aZxz0","2e9fa51258911c0c":"dGtJw"}],"aZxz0":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = {
    canvasStyle: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: 0,
        overflow: 'hidden',
        'padding-top': 0,
        'padding-bottom': 0,
        border: 'none'
    },
    mirrorProps: [
        'box-sizing',
        'width',
        'font-size',
        'font-weight',
        'font-family',
        'font-style',
        'letter-spacing',
        'text-indent',
        'white-space',
        'word-break',
        'overflow-wrap',
        'padding-left',
        'padding-right'
    ]
};

},{}],"dGtJw":[function(require,module,exports,__globalThis) {
"use strict";
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function omit(obj, omittedKeys) {
    if (!obj || _typeof(obj) !== 'object') return obj;
    var ret = {};
    Object.keys(obj).forEach(function(key) {
        if (omittedKeys.indexOf(key) > -1) return;
        ret[key] = obj[key];
    });
    return ret;
}
module.exports = {
    omit: omit
};

},{}],"glvzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DashboardGroups);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _utils = require("../../helpers/utils");
var _context = require("../../context");
const Layout = ({ Table })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
    });
const EmptyHeader = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
const groupName = ({ subject, grade, name })=>`${subject} ${grade} ${name}`;
const StudentsColumn = (0, _utils.enhancedWithRowData)((props)=>{
    const { students } = props.rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        title: students.map(({ name })=>name).join("\n"),
        children: students.length
    });
});
function DashboardGroups(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { groups, link, locked } = context;
            const GroupLink = (0, _utils.enhancedWithRowData)(({ rowData })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    className: "group-link",
                    title: rowData.name,
                    to: locked ? '#' : link({
                        course: rowData.course
                    }, '/:languageId/:role/my-courses/:course'),
                    children: rowData.name
                }));
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                data: groups,
                components: {
                    Layout
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                            id: "name",
                            customHeadingComponent: EmptyHeader,
                            customComponent: GroupLink
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                            id: "students",
                            customHeadingComponent: EmptyHeader,
                            customComponent: StudentsColumn
                        })
                    ]
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","griddle-react":"6zdUV","react-text":"lEpdJ","../../helpers/utils":"gGc98","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8urSF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NewsItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function NewsItem({ id, date, title, message, link }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "news-item",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                className: "title",
                ...link,
                children: `${date} - ${title}`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "content",
                children: message
            })
        ]
    }, id);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7L64M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DashboardCarrusel);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
var _react = require("external/react");
var _context = require("teacher/context");
const StyledDashboardCarrusel = (0, _material.styled)('div')(dashboardCarruselStyles);
function DashboardCarrusel() {
    const { dashboard, updateState, translate, navigate } = (0, _react.useContext)((0, _context.TeacherContext));
    const activeVideo = (0, _react.useMemo)(()=>dashboard.activeVideo, [
        dashboard.activeVideo
    ]);
    const videos = (0, _react.useMemo)(()=>dashboard.videos, [
        dashboard.videos
    ]);
    const setActiveVideo = (0, _react.useMemo)(()=>(video)=>updateState({
                dashboard: {
                    activeVideo: {
                        $set: video
                    }
                }
            }), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDashboardCarrusel, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "carrusel-header",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "carrusel-title",
                    children: translate('Videos')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "carrusel-content",
                children: [
                    videos.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                        className: "see-more",
                        onClick: ()=>navigate({}, '/:languageId/:role/videos', {
                                preserveQuery: true
                            }),
                        children: [
                            translate('see_more'),
                            "..."
                        ]
                    }),
                    videos.map((video)=>{
                        const thumbnail = video.snippet.thumbnails.maxres ?? video.snippet.thumbnails.high;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "carousel-item-v",
                            onClick: ()=>setActiveVideo(video),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: thumbnail?.url,
                                    alt: video.snippet.title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: video.snippet.title
                                })
                            ]
                        }, video.id);
                    })
                ]
            }),
            activeVideo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setActiveVideo(null),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "close-button",
                            onClick: ()=>setActiveVideo(null),
                            children: "\u2715"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                            src: `https://www.youtube.com/embed/${activeVideo.snippet.resourceId.videoId}?autoplay=1`,
                            title: activeVideo.snippet.title,
                            allow: "autoplay; encrypted-media",
                            allowFullScreen: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: activeVideo.snippet.title
                        })
                    ]
                })
            })
        ]
    });
}
function dashboardCarruselStyles() {
    return {
        display: 'flex',
        flexGrow: 1,
        minHeight: 310,
        flexDirection: 'column',
        overflowY: 'hidden',
        '& .carrusel-header': {
            display: 'flex',
            marginBottom: '10px',
            '& .carrusel-title': {
                flexGrow: 1,
                marginLeft: 2,
                fontSize: '16pt',
                fontWeight: 500,
                color: '#434a5d',
                '&::after': {
                    content: "':'"
                }
            }
        },
        '& .carrusel-content': {
            width: '100%',
            gap: '30px',
            backgroundColor: 'white',
            borderRadius: '20px',
            height: '205px',
            position: 'relative',
            padding: '40px 30px 30px 30px',
            boxSizing: 'border-box',
            display: 'flex',
            overflow: 'hidden',
            flexWrap: 'wrap'
        },
        '& .see-more': {
            position: 'absolute',
            top: '10px',
            right: '24px',
            cursor: 'pointer'
        },
        '& .carousel-item-v': {
            minWidth: '163px',
            flex: 0,
            cursor: 'pointer',
            transition: 'transform 0.2s'
        },
        '& .carousel-item-v:hover': {
            transform: 'scale(1.05)'
        },
        '& .modal-overlay': {
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 99999999
        },
        '& .carousel-item-v img': {
            width: '100%',
            borderRadius: '8px',
            aspectRatio: '16/11',
            objectFit: 'cover',
            marginBottom: '4px'
        },
        '& .carousel-item-v p': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            margin: 0
        },
        '& .modal-content': {
            position: 'relative',
            width: '90%',
            maxWidth: '800px',
            background: '#000',
            borderRadius: '10px',
            padding: '12px'
        },
        '& .modal-content iframe': {
            width: '100%',
            height: '450px',
            borderRadius: '6px'
        },
        '& .modal-content h3': {
            color: 'white',
            marginTop: '10px',
            fontSize: '16px'
        },
        '& .close-button': {
            position: 'absolute',
            top: '6px',
            right: '8px',
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '22px',
            cursor: 'pointer'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","external/react":"k16GP","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7DlwA":[function() {},{}],"fIEL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MyCourses);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../../context");
var _myCourses = require("../../components/my-courses");
var _myCoursesDefault = parcelHelpers.interopDefault(_myCourses);
var _units = require("../../components/units");
var _unitsDefault = parcelHelpers.interopDefault(_units);
var _myCoursesStyl = require("./my-courses.styl");
const views = {
    courses: (0, _myCoursesDefault.default),
    units: (0, _unitsDefault.default)
};
function MyCourses() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const view = /\/..\/.+\/my-courses$/.test(context.match.url) ? 'courses' : 'units';
            const View = views[view];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(View, {})
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../context":"iUP37","../../components/my-courses":"iKMFI","../../components/units":"aYH1g","./my-courses.styl":"feH8y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iKMFI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MyCourses);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _context = require("teacher/context");
var _course = require("./Course");
var _courseDefault = parcelHelpers.interopDefault(_course);
function MyCourses() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { myCourses, sizes } = context;
    const coursesPerRow = Math.floor((sizes.width - 48) / 350);
    const fillersNeeded = coursesPerRow - myCourses.length % coursesPerRow;
    const courses = (0, _react.useMemo)(()=>(myCourses || []).map((course, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _courseDefault.default), {
                ...course,
                context: context
            }, index)), [
        myCourses
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "courses",
        children: [
            courses,
            (0, _lodash.range)(fillersNeeded).map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "course filler"
                }, key))
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/lodash":"5bCAQ","external/react":"k16GP","teacher/context":"5LKDx","./Course":"ipGF5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ipGF5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
var _react = require("external/react");
var _dateFns = require("external/date-fns");
var _url = require("helpers/url");
var _iconLink = require("./IconLink");
var _iconLinkDefault = parcelHelpers.interopDefault(_iconLink);
var _groupLabel = require("./GroupLabel");
var _groupLabelDefault = parcelHelpers.interopDefault(_groupLabel);
var _countLabel = require("./CountLabel");
var _countLabelDefault = parcelHelpers.interopDefault(_countLabel);
const StyledCourse = (0, _material.styled)('div')(courseStyles);
const Course = (props)=>{
    const { course, courseName, unitCount, lessonCount, groups, context } = props;
    const activeGroups = (0, _react.useMemo)(()=>{
        return groups.filter(({ subscription })=>!subscription || subscription.subscriptionMode === undefined || subscription.subscriptionStatus === 'active');
    }, [
        groups
    ]);
    const expiredGroups = (0, _react.useMemo)(()=>{
        return groups.filter(({ subscription })=>subscription && subscription.subscriptionStatus === 'expired');
    }, [
        groups
    ]);
    const groupLabels = (0, _react.useMemo)(()=>activeGroups.map((group, index, groups)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupLabelDefault.default), {
                groups: groups,
                index: index,
                ...group
            }, index)), [
        activeGroups
    ]);
    const expiredGroupLabels = (0, _react.useMemo)(()=>expiredGroups.map((group, index, groups)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupLabelDefault.default), {
                groups: groups,
                index: index,
                ...group
            }, `expired-${index}`)), [
        expiredGroups
    ]);
    const disabled = (0, _react.useMemo)(()=>activeGroups.length == 0, [
        activeGroups
    ]);
    // Find the most recent expired subscription date
    const lastActiveSubscriptionDate = (0, _react.useMemo)(()=>{
        if (activeGroups.length > 0) return null;
        const expiredSubscriptions = groups.filter(({ subscription })=>subscription && subscription.subscriptionStatus === 'expired' && subscription.subscriptionEnds).map(({ subscription })=>subscription.subscriptionEnds).sort((a, b)=>new Date(b) - new Date(a)); // Sort descending to get most recent first
        return expiredSubscriptions.length > 0 ? expiredSubscriptions[0] : null;
    }, [
        groups,
        activeGroups
    ]);
    const { languageId, link, translate } = context;
    const overviewLabel = /^C8/.test(course) ? 'dgenius_overview_label' : 'overview_label';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCourse, {
        className: (0, _material.clsx)('course', {
            disabled
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Link), {
                className: "course-name",
                to: link({
                    course
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "color-band",
                        style: {
                            backgroundColor: props.subjectColor
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "course-label",
                        children: courseName
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "counts-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "course-counts",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countLabelDefault.default), {
                            className: "unit-count",
                            count: unitCount,
                            label: `unit${unitCount > 1 ? 's' : ''}_label`
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "separator",
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countLabelDefault.default), {
                            className: "lesson-count",
                            count: lessonCount,
                            label: `lesson${lessonCount > 1 ? 's' : ''}_label`
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "groups-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "course-groups",
                    children: activeGroups.length > 0 && expiredGroups.length == 0 ? // Only active groups
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "groups-label",
                                children: [
                                    translate(`group${groupLabels.length > 1 ? 's' : ''}_label`),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-names",
                                children: groupLabels
                            })
                        ]
                    }) : activeGroups.length > 0 && expiredGroups.length > 0 ? // Both active and expired groups
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "groups-label",
                                children: [
                                    translate(`group${groupLabels.length > 1 ? 's' : ''}_label`),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "group-names",
                                children: groupLabels
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "expired-groups-label",
                                children: [
                                    translate(`expired-group${expiredGroupLabels.length > 1 ? 's' : ''}_label`),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "expired-group-names",
                                children: expiredGroupLabels
                            })
                        ]
                    }) : // Only expired groups or no groups
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "last-subscription-info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "last-subscription-label",
                                children: [
                                    translate('last-active-subscription'),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "last-subscription-date",
                                children: lastActiveSubscriptionDate ? (0, _dateFns.formatDate)(lastActiveSubscriptionDate, 'MMM d, yyyy', languageId) : translate('no-subscription-found')
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "spacer",
                children: "\xa0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "links-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "course-links",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `overview-link ${props.hasOverview ? 'active' : 'inactive'}`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconLinkDefault.default), {
                                ...(0, _url.viewerGuard)({
                                    href: (0, _url.pdfPreviewLink)('download', 'overview', languageId, course),
                                    target: "_blank"
                                }),
                                icon: "overview",
                                label: overviewLabel
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _material.clsx)('separator', {
                                inactive: !props.hasGuide
                            }),
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `guide-link ${props.hasGuide ? 'active' : 'inactive'}`,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconLinkDefault.default), {
                                ...(0, _url.viewerGuard)({
                                    href: (0, _url.pdfPreviewLink)('download', 'guide', languageId, course),
                                    target: "_blank"
                                }),
                                icon: "guide",
                                label: "guide_label"
                            })
                        })
                    ]
                })
            })
        ]
    }, course);
};
function courseStyles() {
    return {
        "&.disabled": {
            opacity: 0.8,
            pointerEvents: 'none',
            filter: 'grayscale(0.3)',
            '& .course-name': {
                cursor: 'default'
            },
            '& .course-links': {
                '& .overview-link, & .guide-link': {
                    opacity: 0.3
                }
            },
            '& .expired-groups-label, & .expired-group-names': {
                opacity: 0.6,
                fontStyle: 'italic'
            }
        }
    };
}
exports.default = Course;

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","external/react":"k16GP","external/date-fns":"kwxNe","helpers/url":"65SQD","./IconLink":"dlFPy","./GroupLabel":"aPZTM","./CountLabel":"gaigJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dlFPy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _context = require("teacher/context");
var _icon = require("components/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
const IconLink = (props)=>{
    const { icon, label } = props;
    const { translate } = (0, _react.useContext)((0, _context.TeacherContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
        ...(0, _lodash.omit)(props, [
            'icon',
            'label'
        ]),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                name: icon
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "label",
                children: translate(label)
            })
        ]
    });
};
exports.default = IconLink;

},{"react/jsx-runtime":"1dlk8","external/lodash":"5bCAQ","external/react":"k16GP","teacher/context":"5LKDx","components/icon":"82gpi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aPZTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
const GroupLabel = (props)=>{
    const { id, name, index, groups } = props;
    const isLast = index == groups.length - 1;
    const separator = isLast ? '' : ',';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
        className: `group-label${index == 0 ? ' first' : ''}`,
        children: [
            name,
            separator
        ]
    }, id);
};
exports.default = GroupLabel;

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gaigJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _context = require("teacher/context");
const CountLabel = (props)=>{
    const { count, label } = props;
    const { translate } = (0, _react.useContext)((0, _context.TeacherContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...(0, _lodash.omit)(props, [
            'count',
            'label'
        ]),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "value",
                children: count
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "label",
                children: translate(label)
            })
        ]
    });
};
exports.default = CountLabel;

},{"react/jsx-runtime":"1dlk8","external/lodash":"5bCAQ","external/react":"k16GP","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aYH1g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Units);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _url = require("helpers/url");
var _icon = require("../icon");
var _unit = require("./unit");
var _unitDefault = parcelHelpers.interopDefault(_unit);
var _container = require("./Container");
var _containerDefault = parcelHelpers.interopDefault(_container);
var _scheduleLesson = require("../schedule-lesson");
var _scheduleLessonDefault = parcelHelpers.interopDefault(_scheduleLesson);
var _dreyfousLabsLink = require("./DreyfousLabsLink");
var _dreyfousLabsLinkDefault = parcelHelpers.interopDefault(_dreyfousLabsLink);
var _unitsStyl = require("./units.styl");
var _context = require("teacher/context");
function Units() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { course, unit, languageId, action, profile } = context;
    const isDreyfous = (0, _react.useMemo)(()=>profile.domain == 'dreyfous', [
        profile.domain
    ]);
    const [courseInfo, ...units] = context.units;
    const unitId = `${course}U${unit}`;
    const backPath = context.link({
        course: undefined,
        unit: undefined
    }, context.match.path, {
        preserveQuery: true
    });
    const overviewLabel = /^C8/.test(course) ? 'dgenius_overview_label' : 'overview_label';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "units",
        children: [
            courseInfo && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "course-info",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Link), {
                        className: "back",
                        to: backPath
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: courseInfo.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _material.clsx)('overview-link', {
                            inactive: !courseInfo.hasOverview
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icon.IconLink), {
                            ...(0, _url.viewerGuard)({
                                href: (0, _url.pdfPreviewLink)('download', 'overview', languageId, course),
                                target: "blank"
                            }),
                            icon: "overview",
                            label: overviewLabel
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _material.clsx)('guide-link', {
                            inactive: !courseInfo.hasGuide
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icon.IconLink), {
                            ...(0, _url.viewerGuard)({
                                href: (0, _url.pdfPreviewLink)('download', 'guide', languageId, course),
                                target: "blank"
                            }),
                            icon: "guide",
                            label: "guide_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _material.clsx)('student-workbook-link', {
                            inactive: !courseInfo.hasStudentWorkbook
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icon.IconLink), {
                            ...(0, _url.viewerGuard)({
                                href: (0, _url.pdfPreviewLink)('download', 'guide', 'student_workbook', languageId, course),
                                target: "blank"
                            }),
                            icon: "workbook",
                            label: "student_workbook_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _material.clsx)('workbook-link', {
                            inactive: !courseInfo.hasWorkbook
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icon.IconLink), {
                            ...(0, _url.viewerGuard)({
                                href: (0, _url.pdfPreviewLink)('download', 'workbook', languageId, course),
                                target: "blank"
                            }),
                            icon: "workbook",
                            label: "workbook_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _material.clsx)('coursemap-link', {
                            inactive: !courseInfo.hasCoursemap
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icon.IconLink), {
                            ...(0, _url.viewerGuard)({
                                href: (0, _url.pdfPreviewLink)('download', 'guide', 'coursemap', languageId, course),
                                target: "blank"
                            }),
                            icon: "guide",
                            label: "coursemap_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _material.clsx)('didactical-resource-link', {
                            inactive: !courseInfo.hasDidacticalResource
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icon.IconLink), {
                            ...(0, _url.viewerGuard)({
                                href: (0, _url.pdfPreviewLink)('download', 'guide', 'didactical_resource', languageId, course),
                                target: "blank"
                            }),
                            icon: "summary",
                            label: "didactical_resource_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _material.clsx)('dreyfouslabs-link', {
                            inactive: !/^C6/.test(course)
                        }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dreyfousLabsLinkDefault.default), {})
                    })
                ]
            }),
            [
                'schedule',
                'posts'
            ].indexOf(action) >= 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scheduleLessonDefault.default), {
                selectedGroup: {},
                activeTab: "groups"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerDefault.default), {
                children: units && units.map((unit)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitDefault.default), {
                        active: unit.id == unitId,
                        ...unit
                    }, unit.id))
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/url":"65SQD","../icon":"82gpi","./unit":"58Avh","./Container":"78MMj","../schedule-lesson":"k69TP","./DreyfousLabsLink":"984K9","./units.styl":"kG2MA","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"58Avh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Unit);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _accordion = require("@mui/material/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionSummary = require("@mui/material/AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _accordionDetails = require("@mui/material/AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _linkBehavior = require("components/LinkBehavior");
var _linkBehaviorDefault = parcelHelpers.interopDefault(_linkBehavior);
var _context = require("teacher/context");
var _lessons = require("../lessons");
var _lessonsDefault = parcelHelpers.interopDefault(_lessons);
var _assessmentLink = require("components/AssessmentLink");
var _assessmentLinkDefault = parcelHelpers.interopDefault(_assessmentLink);
function Unit(props) {
    const { name, id, active, assessments } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    if (!id) return;
    const unitId = id.substring(8);
    const expanded = context.unit == unitId;
    const unitLink = context.link({
        unit: expanded ? undefined : unitId
    }, context.match.path, {
        preserveQuery: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionDefault.default), {
        TransitionProps: {
            unmountOnExit: true
        },
        disableGutters: true,
        className: (0, _clsxDefault.default)('unit', {
            expanded
        }),
        expanded: expanded,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionSummaryDefault.default), {
                component: (0, _linkBehaviorDefault.default),
                to: unitLink,
                className: (0, _clsxDefault.default)('unitSummary', {
                    expanded
                }),
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {}),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _clsxDefault.default)("unitName", {
                            expanded
                        }),
                        children: `${context.translate('unit_label')} ${unitId}: ${name}`
                    }),
                    assessments.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentLinkDefault.default), {
                        ...props,
                        context
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionDetailsDefault.default), {
                className: "unitDetails",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonsDefault.default), {})
            })
        ]
    }, unitId);
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-text":"lEpdJ","@mui/material/Accordion":"lkcQj","@mui/material/AccordionSummary":"ggBKJ","@mui/material/AccordionDetails":"96rKf","@mui/icons-material/ExpandMore":"gUaK6","components/LinkBehavior":"jYlxA","teacher/context":"5LKDx","../lessons":"dXYjZ","components/AssessmentLink":"a9G5R","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUaK6":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("31f98b340ff5cc06");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("25cc493e3d5769f7"));
var _jsxRuntime = require("14165500abad842a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

},{"31f98b340ff5cc06":"kZ6eK","25cc493e3d5769f7":"2vOnF","14165500abad842a":"1dlk8"}],"jYlxA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LinkBehavior);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
const LinkBehavior = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        ref: ref,
        to: props.to,
        ...(0, _lodash.omit)(props, [
            'to'
        ])
    }));

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dXYjZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Lessons);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../../context");
var _lesson = require("./lesson");
var _lessonDefault = parcelHelpers.interopDefault(_lesson);
var _lessonsStyl = require("./lessons.styl");
function Lessons() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { lessons } = context;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                className: "lessons",
                children: lessons && lessons.map((lesson)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonDefault.default), {
                        ...lesson
                    }, lesson.id))
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../context":"iUP37","./lesson":"8q0lo","./lessons.styl":"CpEKi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8q0lo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Lesson);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lessonLinks = require("../lesson-links");
var _lessonLinksDefault = parcelHelpers.interopDefault(_lessonLinks);
function Lesson(props) {
    const { name, id, assigned } = props;
    const assignedClass = (className)=>assigned ? `${className} assigned` : className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
        className: "lesson",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: assignedClass("item"),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bullet"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "name",
                    children: `${id}: ${name}`
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonLinksDefault.default), {
                    ...props
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../lesson-links":"a44pk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a44pk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LessonLinks);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _url = require("../../helpers/url");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../context");
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _url1 = require("helpers/url");
var _assessmentLink = require("components/AssessmentLink");
var _assessmentLinkDefault = parcelHelpers.interopDefault(_assessmentLink);
var _lessonLink = require("components/imported-assessment/lesson-link");
var _lessonLinkDefault = parcelHelpers.interopDefault(_lessonLink);
function LessonLink(props) {
    const { key, show, to, title, href } = props;
    const linkProps = (0, _lodash.omit)(props, [
        'key',
        'show'
    ]);
    const LinkElem = to ? (0, _reactRouterDom.Link) : ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            ...linkProps,
            ...(0, _url1.viewerGuard)(linkProps),
            children: children
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _clsxDefault.default)(key, 'link'),
        children: [
            show && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkElem, {
                ...linkProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            }),
            !show && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "disabled link",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            })
        ]
    }, key);
}
function LessonLinks(props) {
    const { id, assigned, hash, hasEpl, hasSummary, hasKey, inContract } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { link, translations, languageId, profile, isDownloaded, edgeServers } = context;
            const { limited } = profile.institution;
            const downloaded = isDownloaded({
                id,
                hash
            });
            const edgeIp = edgeServers?.available && edgeServers.ips.length > 0 ? edgeServers.ips[0] : null;
            const downloadHref = edgeIp ? (0, _url.subdomainLink)('api-support', 'catalog', 'download', `?lesson=${id}&edgeIp=${edgeIp}`) : (0, _url.subdomainLink)('api-support', 'catalog', 'download', `?lesson=${id}`);
            const filter = ({ key })=>{
                if (key != 'summary' && !inContract) return false;
                if ([
                    'download',
                    'view-local-content'
                ].indexOf(key) < 0) return true;
                if (key == 'download') return (0, _url1.inViewer) && !downloaded;
                if (key == 'view-local-content') return (0, _url1.inViewer) && downloaded;
            };
            const tooltipTitle = (name)=>`${translations[`${name}_tooltip_title`][languageId]}: ${id}`;
            const links = [
                {
                    key: 'preview',
                    title: tooltipTitle('preview'),
                    show: hasEpl,
                    href: edgeIp ? `http://${edgeIp}/${id}` : (0, _url.subdomainLink)('preview', '#', languageId, 'lesson', id),
                    target: "_blank"
                },
                {
                    key: 'summary',
                    title: tooltipTitle('summary'),
                    show: hasSummary,
                    href: (0, _url.pdfPreviewLink)('download', 'summary', languageId, id),
                    target: "_blank"
                },
                {
                    key: 'view-local-content',
                    title: tooltipTitle('preview'),
                    show: hasEpl,
                    href: `//downloads/${id}`,
                    target: "_blank"
                },
                {
                    key: 'download',
                    title: tooltipTitle('download'),
                    show: hasEpl,
                    href: downloadHref,
                    target: "_blank"
                },
                {
                    key: 'schedule',
                    title: tooltipTitle('schedule'),
                    show: hasEpl && !limited,
                    to: link({
                        lesson: id
                    }, `${context.match.path}/schedule/:lesson`, {
                        preserveQuery: true
                    })
                },
                {
                    key: 'posts',
                    title: tooltipTitle('posts'),
                    show: hasEpl && assigned > 0 && !limited,
                    to: link({
                        lesson: id
                    }, `${context.match.path}/posts/:lesson`, {
                        preserveQuery: true
                    })
                },
                {
                    key: 'key',
                    title: tooltipTitle('key'),
                    show: hasKey && !limited,
                    href: (0, _url.pdfPreviewLink)('download', 'key', languageId, id),
                    target: "_blank"
                }
            ].filter(filter);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "links",
                children: [
                    links.map(LessonLink),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentLinkDefault.default), {
                        ...props,
                        context
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonLinkDefault.default), {
                        assessments: props.importedAssessments,
                        context: context
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","../../helpers/url":"65SQD","react":"9njXz","react-router-dom":"3uzXR","../../context":"iUP37","../icon":"82gpi","helpers/url":"65SQD","components/AssessmentLink":"a9G5R","components/imported-assessment/lesson-link":"eWPft","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9G5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentLink);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _icons = require("resources/icons");
const Container = (0, _styles.styled)((0, _boxDefault.default))(linkStyles);
function AssessmentLink(props) {
    const { context } = props;
    const assessments = (0, _lodash.orderBy)(props.assessments, [
        'title'
    ]);
    const { translate } = context;
    const disabled = assessments.length < 1 || props.busy;
    const multiAssessment = assessments.length > 1;
    const location = (0, _reactRouterDom.useLocation)();
    const history = (0, _reactRouterDom.useHistory)();
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const open = Boolean(anchorEl);
    const openMenu = (event)=>setAnchorEl(event.currentTarget);
    const closeMenu = (e)=>{
        setAnchorEl(null);
        e.preventDefault();
    };
    function goToAssessment(assessment) {
        if (props.onSelect) return props.onSelect(assessment);
        const assessmentLink = context.link({
            assessment,
            action: 'preview',
            page: 'quiz'
        }, '/:languageId/:role/:page/:assessment/:action');
        context.updateState({
            quizPreviewFrom: {
                $set: location.pathname
            },
            quizPreviewFromQuery: {
                $set: {
                    ...context.query
                }
            }
        });
        history.push(assessmentLink);
    }
    function handleMenuClick({ id }) {
        return (e)=>{
            if (!disabled) goToAssessment(id);
            e.preventDefault();
        };
    }
    function handlePreviewClick(e) {
        if (multiAssessment) {
            if (!disabled) openMenu(e);
        } else if (!disabled) goToAssessment(assessments[0].id);
        e.preventDefault();
    }
    const title = multiAssessment || disabled ? '' : `${translate('preview-tooltip')}${multiAssessment ? '' : `: ${assessments[0].title}`}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        title: title,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Container, {
            className: (0, _clsxDefault.default)("assessment", {
                disabled
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    onClick: handlePreviewClick,
                    className: (0, _clsxDefault.default)("assessmentButton", {
                        disabled
                    }),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {})
                }),
                multiAssessment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
                    anchorEl: anchorEl,
                    open: open,
                    onClose: closeMenu,
                    children: assessments.map((assessment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            onClick: handleMenuClick(assessment),
                            children: assessment.title
                        }, assessment.id))
                })
            ]
        })
    });
}
function linkStyles({ theme }) {
    return {
        "&.assessment": {
            marginRight: 0,
            marginLeft: 26,
            "& .assessmentButton": {
                cursor: 'pointer',
                "&:hover": {
                    "& svg": {
                        transform: 'scale(1.15)'
                    }
                },
                "&.disabled": {
                    cursor: 'default',
                    visibility: 'hidden',
                    opacity: 0.5,
                    "&:hover": {
                        "& svg": {
                            transform: 'none'
                        }
                    }
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","@mui/material/styles":"c9RfU","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/material/Tooltip":"7bRLE","resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eWPft":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ImportedAssessmentLessonLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _assessmentLink = require("components/AssessmentLink");
var _assessmentLinkDefault = parcelHelpers.interopDefault(_assessmentLink);
var _command = require("helpers/command");
const startTest = (0, _command.createPost)('quiz', 'startImportedAssessmentTest');
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function ImportedAssessmentLessonLink({ assessments = [], context }) {
    const history = (0, _reactRouterDom.useHistory)();
    const location = (0, _reactRouterDom.useLocation)();
    const [busy, setBusy] = (0, _reactDefault.default).useState(false);
    const [error, setError] = (0, _reactDefault.default).useState('');
    async function open(source) {
        if (busy) return;
        setBusy(true);
        setError('');
        try {
            const result = await startTest({
                id: source
            });
            const attempt = Array.isArray(result) ? result[0] : result;
            if (typeof attempt !== 'string' || !uuid.test(attempt)) throw new Error('Unable to start imported assessment preview');
            history.push(`/${context.languageId}/${context.role}/quiz/imported-test/${attempt}?sourceId=${encodeURIComponent(source)}&returnTo=${encodeURIComponent(`${location.pathname}${location.search}`)}`);
        } catch (e) {
            setError('Unable to start imported assessment preview. Please try again.');
        } finally{
            setBusy(false);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentLinkDefault.default), {
                assessments: assessments,
                context: context,
                onSelect: open,
                busy: busy
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                role: "alert",
                children: error
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","components/AssessmentLink":"a9G5R","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"CpEKi":[function() {},{}],"78MMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Container);
var _styles = require("@mui/material/styles");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const centerVertically = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const Container = (0, _styles.styled)((0, _boxDefault.default))(({ theme })=>{
    return {
        "&.MuiBox-root": {
            marginTop: 30,
            flexGrow: 1
        },
        "& .groupLinksWrapper": {
            marginLeft: 30,
            flexShrink: 0
        },
        "& .unit": {
            "&.expanded": {
                borderTop: 'solid 2px #dddddd'
            },
            textDecoration: 'none',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff'
        },
        "& .unitSummary": {
            display: 'flex',
            padding: '10px 20px',
            "&.expanded": {
                borderBottom: 'solid 1px #dddddd'
            },
            "& .assessment": {
                marginRight: 27
            },
            "& .unitName": {
                display: 'flex',
                flexGrow: 1,
                flexDirection: 'column',
                justifyContent: 'flex-start',
                color: '#565f77',
                fontSize: '13.5pt',
                flexShrink: 1,
                "&.expanded": {
                    fontWeight: 600
                }
            }
        },
        "& .unitDetails": {
            backgroundColor: '#f6fbfe',
            padding: 20,
            paddingRight: 50
        }
    };
});

},{"@mui/material/styles":"c9RfU","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k69TP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _tabBar = require("./tab-bar");
var _tabBarDefault = parcelHelpers.interopDefault(_tabBar);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("context");
var _utils = require("helpers/utils");
var _groupsStep = require("./groups-step");
var _groupsStepDefault = parcelHelpers.interopDefault(_groupsStep);
var _dateStep = require("./date-step");
var _dateStepDefault = parcelHelpers.interopDefault(_dateStep);
var _post = require("context/post");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _scheduleLessonStyl = require("./schedule-lesson.styl");
function Buttons({ left, right }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !left.enabled,
                className: left.label,
                onClick: left.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${left.label}_label`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !right.enabled,
                className: right.label,
                onClick: right.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${right.label}_label`
                })
            })
        ]
    });
}
class ScheduleLesson extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            date: props.date || new Date(),
            message: props.message || "",
            activeTab: props.activeTab,
            selectedGroup: props.selectedGroup,
            studentList: props.studentList || [],
            selectedStudents: props.selectedStudents || [],
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const { setState, activeTab, isOpen } = this.state;
        const { lessons, lesson: lessonId } = context;
        const lessonsProperty = context.searching == 'lessons' ? 'catalogueSearchResults' : 'lessons';
        const idProperty = lessonsProperty == 'lessons' ? 'id' : 'lesson';
        const lesson = context[lessonsProperty].find((item)=>item[idProperty] == lessonId) || {};
        lesson.id = lesson.id || lesson.lesson;
        lesson.name = lesson.name || lesson.lessonName;
        const markLessonAsAssigned = ()=>{
            const assigned = lessonsProperty == 'lessons' ? lesson.assigned + 1 : true;
            const lessons = context[lessonsProperty].map((lesson)=>lesson[idProperty] != lessonId ? lesson : {
                    ...lesson,
                    assigned
                });
            context.setState({
                [lessonsProperty]: lessons
            }, close);
        };
        const canSave = this.state.selectedStudents.length > 0 && !(0, _utils.isEmptyOrWhiteSpace)(this.state.message);
        const save = ()=>{
            return (0, _post.scheduleEvent)({
                lesson,
                language: context.languageId,
                students: this.state.selectedStudents,
                action: context.action,
                date: this.state.date,
                message: this.state.message,
                group: this.state.selectedGroup
            }).then(markLessonAsAssigned);
        };
        const previous = ()=>setState({
                activeTab: 'groups'
            });
        const next = ()=>setState({
                activeTab: 'date'
            });
        const close = ()=>setState({
                isOpen: false
            });
        const navigateOut = ()=>context.navigate({}, context.match.path.replace(/\/:action.*$/, ''), {
                preserveQuery: true
            });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "schedule-lesson-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-lesson",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: `${context.action}_schedule_lesson_title`
                                    }),
                                    `: ${lessonId} ${lesson.name}`
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "close",
                                onClick: ()=>close(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faTimesCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabBarDefault.default), {
                        activeTab,
                        setState
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tab-content",
                        children: [
                            activeTab == 'groups' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'selectedGroup',
                                            'studentList',
                                            'selectedStudents',
                                            'setState'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'cancel',
                                            onClick: close,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'continue',
                                            onClick: next,
                                            enabled: true
                                        }
                                    })
                                ]
                            }),
                            activeTab == 'date' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'date',
                                            'setState',
                                            'message'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'back',
                                            onClick: previous,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'save',
                                            onClick: save,
                                            enabled: canSave
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = ScheduleLesson;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-modal":"kV9Wz","./tab-bar":"ihePu","react-text":"lEpdJ","context":"iUP37","helpers/utils":"gGc98","./groups-step":"2jIwS","./date-step":"l0ng8","context/post":"8rmpk","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./schedule-lesson.styl":"jvc7h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kV9Wz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _Modal = require("61f3c1f4b26edd90");
var _Modal2 = _interopRequireDefault(_Modal);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _Modal2.default;
module.exports = exports["default"];

},{"61f3c1f4b26edd90":"6X4rP"}],"6X4rP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("9a25229d9e827b16");
var _react2 = _interopRequireDefault(_react);
var _reactDom = require("f910a939b759baac");
var _reactDom2 = _interopRequireDefault(_reactDom);
var _propTypes = require("a79c9e589690789c");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ModalPortal = require("34c4b69c6470c61b");
var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
var _ariaAppHider = require("e68a5208ad96e647");
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _safeHTMLElement = require("573142d9c97c52f");
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _reactLifecyclesCompat = require("ad84566654669dc0");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
var createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var getCreatePortal = function getCreatePortal() {
    return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function getParentElement(parentSelector) {
    return parentSelector();
}
var Modal = function(_Component) {
    _inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        _classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = getCreatePortal();
            var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    _createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!_safeHTMLElement.canUseDOM) return;
                if (!isReact16) this.node = createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = getParentElement(prevProps.parentSelector);
                var nextParent = getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!_safeHTMLElement.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!_safeHTMLElement.canUseDOM || !isReact16) return null;
                if (!this.node && isReact16) this.node = createHTMLElement("div");
                var createPortal = getCreatePortal();
                return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}(_react.Component);
Modal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    portalClassName: _propTypes2.default.string,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    className: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.shape({
            base: _propTypes2.default.string.isRequired,
            afterOpen: _propTypes2.default.string.isRequired,
            beforeClose: _propTypes2.default.string.isRequired
        })
    ]),
    appElement: _propTypes2.default.oneOfType([
        _propTypes2.default.instanceOf(_safeHTMLElement2.default),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
        _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))
    ]),
    onAfterOpen: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    ariaHideApp: _propTypes2.default.bool,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    parentSelector: _propTypes2.default.func,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
    isOpen: false,
    portalClassName: portalClassName,
    bodyOpenClassName: bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return _react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return _react2.default.createElement("div", props, children);
    }
};
Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, _reactLifecyclesCompat.polyfill)(Modal);
exports.default = Modal;

},{"9a25229d9e827b16":"9njXz","f910a939b759baac":"2ApDx","a79c9e589690789c":"bnNSm","34c4b69c6470c61b":"j9nha","e68a5208ad96e647":"l4jz0","573142d9c97c52f":"5eQX9","ad84566654669dc0":"9jQEY"}],"j9nha":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _react = require("d320e8781d21c2c5");
var _propTypes = require("33d52b094ecec2e0");
var _propTypes2 = _interopRequireDefault(_propTypes);
var _focusManager = require("bfbfef75d8e85e0");
var focusManager = _interopRequireWildcard(_focusManager);
var _scopeTab = require("8960111ee2cff0b2");
var _scopeTab2 = _interopRequireDefault(_scopeTab);
var _ariaAppHider = require("75f7ac26c5b4b642");
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _classList = require("232716fc77648a71");
var classList = _interopRequireWildcard(_classList);
var _safeHTMLElement = require("5ca8a1c1e3ad494a");
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _portalOpenInstances = require("ce306d5e4e8279b3");
var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
require("56e2a18c3da1ec8b");
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var ariaHiddenInstances = 0;
var ModalPortal = function(_Component) {
    _inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        _classCallCheck(this, ModalPortal);
        var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && ariaHiddenInstances > 0) {
                ariaHiddenInstances -= 1;
                if (ariaHiddenInstances === 0) ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    focusManager.returnFocus(_this.props.preventScroll);
                    focusManager.teardownScopedFocus();
                } else focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            _portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    focusManager.setupScopedFocus(_this.node);
                    focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (isTabKey(event)) (0, _scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
                base: CLASS_NAMES[which],
                afterOpen: CLASS_NAMES[which] + "--after-open",
                beforeClose: CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    _createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    ariaHiddenInstances += 1;
                    ariaAppHider.hide(appElement);
                }
                _portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: _extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = _extends({
                    id: id,
                    ref: this.setContentRef,
                    style: _extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", _extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}(_react.Component);
ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
ModalPortal.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    defaultStyles: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    style: _propTypes2.default.shape({
        content: _propTypes2.default.object,
        overlay: _propTypes2.default.object
    }),
    className: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.object
    ]),
    overlayClassName: _propTypes2.default.oneOfType([
        _propTypes2.default.string,
        _propTypes2.default.object
    ]),
    parentSelector: _propTypes2.default.func,
    bodyOpenClassName: _propTypes2.default.string,
    htmlOpenClassName: _propTypes2.default.string,
    ariaHideApp: _propTypes2.default.bool,
    appElement: _propTypes2.default.oneOfType([
        _propTypes2.default.instanceOf(_safeHTMLElement2.default),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection),
        _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList),
        _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))
    ]),
    onAfterOpen: _propTypes2.default.func,
    onAfterClose: _propTypes2.default.func,
    onRequestClose: _propTypes2.default.func,
    closeTimeoutMS: _propTypes2.default.number,
    shouldFocusAfterRender: _propTypes2.default.bool,
    shouldCloseOnOverlayClick: _propTypes2.default.bool,
    shouldReturnFocusAfterClose: _propTypes2.default.bool,
    preventScroll: _propTypes2.default.bool,
    role: _propTypes2.default.string,
    contentLabel: _propTypes2.default.string,
    aria: _propTypes2.default.object,
    data: _propTypes2.default.object,
    children: _propTypes2.default.node,
    shouldCloseOnEsc: _propTypes2.default.bool,
    overlayRef: _propTypes2.default.func,
    contentRef: _propTypes2.default.func,
    id: _propTypes2.default.string,
    overlayElement: _propTypes2.default.func,
    contentElement: _propTypes2.default.func,
    testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

},{"d320e8781d21c2c5":"9njXz","33d52b094ecec2e0":"bnNSm","bfbfef75d8e85e0":"fyGuH","8960111ee2cff0b2":"aOVTZ","75f7ac26c5b4b642":"l4jz0","232716fc77648a71":"lEKWQ","5ca8a1c1e3ad494a":"5eQX9","ce306d5e4e8279b3":"gvDI6","56e2a18c3da1ec8b":"90xEm"}],"fyGuH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;
var _tabbable = require("a3112cb65ea2b6f");
var _tabbable2 = _interopRequireDefault(_tabbable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    focusLaterElements = [];
}
/* istanbul ignore next */ function log() {}
/* eslint-enable no-console */ function handleBlur() {
    needToFocus = true;
}
function handleFocus() {
    if (needToFocus) {
        needToFocus = false;
        if (!modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if (modalElement.contains(document.activeElement)) return;
            var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
            el.focus();
        }, 0);
    }
}
function markForFocusLater() {
    focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if (focusLaterElements.length !== 0) {
            toFocus = focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function popWithoutFocus() {
    focusLaterElements.length > 0 && focusLaterElements.pop();
}
function setupScopedFocus(element) {
    modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", handleBlur, false);
        document.addEventListener("focus", handleFocus, true);
    } else {
        window.attachEvent("onBlur", handleBlur);
        document.attachEvent("onFocus", handleFocus);
    }
}
function teardownScopedFocus() {
    modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", handleBlur);
        document.removeEventListener("focus", handleFocus);
    } else {
        window.detachEvent("onBlur", handleBlur);
        document.detachEvent("onFocus", handleFocus);
    }
}

},{"a3112cb65ea2b6f":"eVBom"}],"eVBom":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var DISPLAY_NONE = "none";
var DISPLAY_CONTENTS = "contents";
// match the whole word to prevent fuzzy searching
var tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
function isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== DISPLAY_CONTENTS && isNotOverflowing(element, style) : displayValue === DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if (hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
}
function tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}
function findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter(tabbable);
}
module.exports = exports["default"];

},{}],"aOVTZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scopeTab;
var _tabbable = require("f055893759989bbd");
var _tabbable2 = _interopRequireDefault(_tabbable);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function scopeTab(node, event) {
    var tabbable = (0, _tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
module.exports = exports["default"];

},{"f055893759989bbd":"eVBom"}],"l4jz0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
var _warning = require("6eb0682e790e32c7");
var _warning2 = _interopRequireDefault(_warning);
var _safeHTMLElement = require("776bf46766969f66");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    if (globalElement) {
        if (globalElement.removeAttribute) globalElement.removeAttribute("aria-hidden");
        else if (globalElement.length != null) globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll(globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    globalElement = null;
}
/* istanbul ignore next */ function log() {
    var check;
}
/* eslint-enable no-console */ function assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        assertNodeList(el, useElement);
        useElement = el;
    }
    globalElement = useElement || globalElement;
    return globalElement;
}
function validateElement(appElement) {
    var el = appElement || globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, _warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function documentNotReadyOrSSRTesting() {
    globalElement = null;
}

},{"6eb0682e790e32c7":"4kUCc","776bf46766969f66":"5eQX9"}],"5eQX9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.canUseDOM = exports.SafeNodeList = exports.SafeHTMLCollection = undefined;
var _exenv = require("dfc9e0e910107876");
var _exenv2 = _interopRequireDefault(_exenv);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var EE = _exenv2.default;
var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
var SafeHTMLCollection = exports.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
var SafeNodeList = exports.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
var canUseDOM = exports.canUseDOM = EE.canUseDOM;
exports.default = SafeHTMLElement;

},{"dfc9e0e910107876":"kOoUY"}],"kOoUY":[function(require,module,exports,__globalThis) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

},{}],"lEKWQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
var htmlClassList = {};
var docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in htmlClassList)removeClass(htmlElement, htmlClassList[cls]);
    var body = document.body;
    for(var _cls in docBodyClassList)removeClass(body, docBodyClassList[_cls]);
    htmlClassList = {};
    docBodyClassList = {};
}
/* istanbul ignore next */ function log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var add = exports.add = function add(element, classString) {
    return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var remove = exports.remove = function remove(element, classString) {
    return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

},{}],"gvDI6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.log = log;
exports.resetState = resetState;
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    _classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var portalOpenInstances = new PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function log() {
    console.log("portalOpenInstances ----------");
    console.log(portalOpenInstances.openInstances.length);
    portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function resetState() {
    portalOpenInstances = new PortalOpenInstances();
}
/* eslint-enable no-console */ exports.default = portalOpenInstances;

},{}],"90xEm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetState = resetState;
exports.log = log;
var _portalOpenInstances = require("90d3c301f2b237b9");
var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var before = void 0, after = void 0, instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function resetState() {
    var _arr = [
        before,
        after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    before = after = null;
    instances = [];
}
/* istanbul ignore next */ function log() {
    console.log("bodyTrap ----------");
    console.log(instances.length);
    var _arr2 = [
        before,
        after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function focusContent() {
    if (instances.length === 0) return;
    instances[instances.length - 1].focusContent();
}
function bodyTrap(eventType, openInstances) {
    if (!before && !after) {
        before = document.createElement("div");
        before.setAttribute("data-react-modal-body-trap", "");
        before.style.position = "absolute";
        before.style.opacity = "0";
        before.setAttribute("tabindex", "0");
        before.addEventListener("focus", focusContent);
        after = before.cloneNode();
        after.addEventListener("focus", focusContent);
    }
    instances = openInstances;
    if (instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== before) document.body.insertBefore(before, document.body.firstChild);
        if (document.body.lastChild !== after) document.body.appendChild(after);
    } else {
        // Remove focus trap
        if (before.parentElement) before.parentElement.removeChild(before);
        if (after.parentElement) after.parentElement.removeChild(after);
    }
}
_portalOpenInstances2.default.subscribe(bodyTrap);

},{"90d3c301f2b237b9":"gvDI6"}],"ihePu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _tabBarStyl = require("./tab-bar.styl");
function TabBar({ activeTab, setState }) {
    const setActiveTab = (activeTab)=>setState({
            activeTab
        });
    const buttonClassName = (tab)=>`${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`;
    const onClick = (tab)=>()=>activeTab != tab && setActiveTab(tab);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tab-bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('groups'),
                onClick: onClick('groups'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faUsers)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_group_button_label"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('date'),
                onClick: onClick('date'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_date_button_label"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","./tab-bar.styl":"4kOUx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kOUx":[function() {},{}],"2jIwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GroupsStep);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectGroup = require("./select-group");
var _selectGroupDefault = parcelHelpers.interopDefault(_selectGroup);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _listboxActions = require("../listbox/listbox-actions");
var _listboxActionsDefault = parcelHelpers.interopDefault(_listboxActions);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _groupsStepStyl = require("./groups-step.styl");
function makeStudentClickHandler({ props, target }) {
    return ({ id, selected })=>props.setState({
            [target]: props[target].map((student)=>student.id != id ? {
                    ...student
                } : {
                    ...student,
                    selected: !selected
                })
        });
}
function GroupsStep(props) {
    const groupClick = (group)=>{
        if (group.id != props.selectedGroup.id) props.setState({
            selectedGroup: group,
            selectedStudents: [],
            studentList: group.students.map((student)=>({
                    ...student,
                    selected: false
                }))
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "groups-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "groups-message",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "schedule_lesson_groups_instructions"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "student-selector",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGroupDefault.default), {
                        selectedGroup: props.selectedGroup,
                        onClick: groupClick
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "select-student",
                        labelId: "students_label",
                        items: (0, _lodash.orderBy)(props.studentList, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'studentList'
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxActionsDefault.default), {
                        onAllLeft: ()=>{
                            const studentList = props.studentList.concat(props.selectedStudents);
                            props.setState({
                                selectedStudents: [],
                                studentList
                            });
                        },
                        onLeft: ()=>{
                            const selectedStudents = props.selectedStudents.filter(({ selected })=>!selected);
                            const studentList = props.studentList.concat(props.selectedStudents.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onRight: ()=>{
                            const studentList = props.studentList.filter(({ selected })=>!selected);
                            const selectedStudents = props.selectedStudents.concat(props.studentList.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onAllRight: ()=>{
                            const selectedStudents = props.selectedStudents.concat(props.studentList);
                            props.setState({
                                selectedStudents,
                                studentList: []
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "selected-students",
                        labelId: "selection_label",
                        items: (0, _lodash.orderBy)(props.selectedStudents, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'selectedStudents'
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","./select-group":"9EYKZ","../listbox":"b8FP6","../listbox/listbox-actions":"h72SQ","react-text":"lEpdJ","./groups-step.styl":"lv7rc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9EYKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _context = require("../../context");
function groupRelevance(group, course) {
    if (!course) return 1;
    if (group.course == course) return 1;
    if (group.course[1] == course[1]) return 2;
    return 3;
}
function SelectGroup(props) {
    const { selectedGroup, onClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const groups = context.groups.map((group)=>{
                return {
                    ...group,
                    relevance: groupRelevance(group, context.course),
                    selected: group.id == selectedGroup.id
                };
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                className: "select-group",
                labelId: "group_label",
                items: (0, _lodash.orderBy)(groups, [
                    'relevance',
                    'course'
                ]),
                onClick: onClick
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","../listbox":"b8FP6","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b8FP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ListBox);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
function ListItem(props) {
    const { onClick, selected, itemValue } = props;
    const selectedClass = selected ? 'selected' : 'selectable';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `item ${selectedClass}`,
        onClick: ()=>onClick && onClick((0, _lodash.omit)(props, [
                'key',
                'itemValue',
                'onClick',
                'mapItem'
            ])),
        children: itemValue
    });
}
function ListBox(props) {
    const { labelId, onClick, className = "listbox", items = [], idProperty = 'id', mapItem = ({ name })=>name } = props;
    const listItems = items.map((item)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItem, {
            onClick: onClick,
            itemValue: mapItem(item),
            ...item
        }, item[idProperty]);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: className,
        children: [
            labelId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: labelId
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "items-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "items-container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "items",
                        children: listItems
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h72SQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ListBoxActions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
function ActionButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `button ${props.action}`,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                display: 'flex',
                justifyContent: 'center'
            },
            children: props.children
        })
    });
}
function ListBoxActions(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "list-actions",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionButton, {
                action: "right",
                onClick: props.onRight,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCaretRight)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ActionButton, {
                action: "all-right",
                onClick: props.onAllRight,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCaretRight)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCaretRight)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ActionButton, {
                action: "all-left",
                onClick: props.onAllLeft,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCaretLeft)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCaretLeft)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActionButton, {
                action: "left",
                onClick: props.onLeft,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCaretLeft)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lv7rc":[function() {},{}],"l0ng8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateStep);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../context");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _dateStepStyl = require("./date-step.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function DateStep(props) {
    const setDate = (date)=>props.setState({
            date
        });
    const setMessage = (event)=>props.setState({
            message: event.target.value
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "date-step",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "schedule_lesson_date_instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "date",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                    selected: props.date,
                                    onChange: setDate,
                                    minDate: new Date(),
                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "message",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "message_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            placeholder: context.translations.schedule_lesson_date_message_placeholder[context.languageId],
                                            value: props.message,
                                            onChange: setMessage
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../context":"iUP37","react-datepicker/dist/react-datepicker.css":"chsuV","./date-step.styl":"hG6Qd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"hG6Qd":[function() {},{}],"jvc7h":[function() {},{}],"984K9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _context = require("teacher/context");
var _material = require("external/material");
var _url = require("helpers/url");
const StyledDreyfousLink = (0, _material.styled)('a')(dreyfousLinkStyles);
const DreyfousLabsLink = ()=>{
    const { translate, profile } = (0, _react.useContext)((0, _context.TeacherContext));
    const available = (0, _react.useMemo)(()=>profile.dreyfouslabs && profile.dreyfouslabs.length > 0, [
        profile.dreyfouslabs
    ]);
    if (!available) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDreyfousLink, {
        ...(0, _url.viewerGuard)({
            href: `${(0, _url.subdomainLink)('dreyfouslabs', 'index.html')}?from=edusystem`,
            target: "_blank"
        }),
        children: translate('dreyfouslabs_label')
    });
};
function dreyfousLinkStyles() {
    return {};
}
exports.default = DreyfousLabsLink;

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","teacher/context":"5LKDx","external/material":"6yEDE","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kG2MA":[function() {},{}],"feH8y":[function() {},{}],"1Bs2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Catalogue);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _subjects = require("components/catalogue-subjects/Subjects");
var _subjectsDefault = parcelHelpers.interopDefault(_subjects);
var _catalogueCourses = require("components/catalogue-courses");
var _catalogueCoursesDefault = parcelHelpers.interopDefault(_catalogueCourses);
var _units = require("components/units");
var _unitsDefault = parcelHelpers.interopDefault(_units);
var _catalogueSearchResults = require("components/catalogue-search-results");
var _catalogueSearchResultsDefault = parcelHelpers.interopDefault(_catalogueSearchResults);
var _catalogueStyl = require("./catalogue.styl");
var _context = require("./context");
const views = [
    [
        (0, _subjectsDefault.default),
        ({ subject, searching })=>!subject && !searching
    ],
    [
        (0, _catalogueCoursesDefault.default),
        ({ match: { url } })=>/\/..\/.+\/catalogue\/C.$/.test(url)
    ],
    [
        (0, _catalogueSearchResultsDefault.default),
        ({ searching })=>searching == 'lessons'
    ],
    [
        (0, _unitsDefault.default),
        ({ match: { url } })=>/\/..\/.+\/catalogue\/C.\/C...G../.test(url)
    ]
];
const Catalogue = ()=>{
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const [Section] = (0, _react.useMemo)(()=>views.find(([_, isMatch])=>isMatch(context)) || views[0], [
        context.match,
        context.subject,
        context.searching
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Section, {})
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","components/catalogue-subjects/Subjects":"7fXR7","components/catalogue-courses":"3l87L","components/units":"aYH1g","components/catalogue-search-results":"5qV3n","./catalogue.styl":"b3b6W","./context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7fXR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CatalogueSubjects);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _searchPattern = require("components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _languageFilter = require("components/language-filter");
var _languageFilterDefault = parcelHelpers.interopDefault(_languageFilter);
var _context = require("teacher/context");
var _subjectCard = require("./SubjectCard");
var _subjectCardDefault = parcelHelpers.interopDefault(_subjectCard);
var _catalogueSubjectsStyl = require("./catalogue-subjects.styl");
const StyledCatalogueSubjects = (0, _material.styled)('div')(catalogueSubjectStyles);
const CatalogueSubjects = (props)=>{
    const { className } = props;
    const { catalogueSubjects = [], link, match, query } = (0, _react.useContext)((0, _context.TeacherContext));
    const subjects = (0, _react.useMemo)(()=>{
        return catalogueSubjects.map((s)=>({
                ...s,
                id: s.id,
                lessonCount: s.lessonCount || s.lessons?.length,
                to: link({
                    subject: s.id
                }, match.path, {
                    preserveQuery: true
                })
            }));
    }, [
        catalogueSubjects,
        match.path
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCatalogueSubjects, {
        className: (0, _material.clsx)('catalogue-subjects', className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filters",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "filters-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageFilterDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "filter filler"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                            searchPlaceholder: "",
                            initialPattern: query.pattern
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "subjects-grid",
                    children: subjects.map((s)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subjectCardDefault.default), {
                            ...s
                        }, s.id))
                })
            })
        ]
    });
};
function catalogueSubjectStyles() {
    return {
        maxWidth: 1800,
        justifySelf: 'center',
        display: 'flex',
        flexgrow: 1,
        flexDirection: 'column',
        '& .filters-row': {
            display: 'flex',
            justifyContent: 'space-evenly',
            '& .filter': {
                width: 'calc(100% / 3 - 40px)',
                minWidth: 'calc(100% / 3 - 40px)',
                maxWidth: 'calc(100% / 3 - 40px)',
                padding: '20px 0 15px 0',
                color: '#838895'
            },
            '&.filler': {
                backgroundColor: 'transparent',
                border: 'none'
            }
        },
        '& .content': {
            flex: 1,
            maxWidth: 1800,
            overflow: 'auto',
            padding: 25
        },
        '& .subjects-grid': {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
            gap: 50
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/search-pattern":"lUZFT","components/language-filter":"jao8N","teacher/context":"5LKDx","./SubjectCard":"2EYwP","./catalogue-subjects.styl":"2IRhQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUZFT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchPattern);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../context");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _searchPatternStyl = require("./search-pattern.styl");
function searchPattern(context) {
    const { page, navigate, match, pattern, searching, section, action } = context;
    if (pattern.length > 2 || pattern.length == 0) {
        const subject = context.query.subject || (searching == 'lessons' ? undefined : context.subject);
        const query = {
            pattern: pattern == '' ? undefined : pattern,
            subject,
            page: undefined,
            grade: context.query.grade
        };
        let path = match.path;
        if (searching != 'lessons' && page != 'homework' && page != 'gradebook' && page != 'my-lessons' && page != 'assessment' && section != 'add-lessons' && section != 'add-standards' && action != 'edit') path = `${match.path}/lessons`;
        navigate({}, path, {
            preserveQuery: true,
            query
        });
    }
}
function SearchPattern({ searchPlaceholder, initialPattern }) {
    const [pattern, setPattern] = (0, _react.useState)(initialPattern || '');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const searchContext = (0, _lodash.pick)(context, [
                'page',
                'match',
                'navigate',
                'query',
                'subject',
                'searching',
                'section',
                'action'
            ]);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pattern filter",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "wrapper",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faSearch)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            value: pattern,
                            placeholder: searchPlaceholder,
                            onChange: (e)=>setPattern(e.target.value),
                            onKeyPress: ({ key })=>key == 'Enter' && searchPattern({
                                    ...searchContext,
                                    pattern
                                })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "button",
                            onClick: ()=>searchPattern({
                                    ...searchContext,
                                    pattern
                                }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "go_label"
                            })
                        })
                    ]
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","../../context":"iUP37","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./search-pattern.styl":"jtrQh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jtrQh":[function() {},{}],"jao8N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LanguageFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _languageFilterStyl = require("./language-filter.styl");
function LanguageFilterButton({ id, selected }) {
    const query = {
        languageId: id
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: `language-filter ${selected ? 'selected' : ''}`,
                onClick: (e)=>selected && e.preventDefault(),
                to: context.link({}, context.match.params, {
                    query
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${id}_label`
                })
            });
        }
    }, id);
}
function LanguageFilter(props) {
    const { availableLanguages } = props;
    const filter = availableLanguages ? (0, _lodash.partialRight)((0, _lodash.intersectionWith), availableLanguages, (a, b)=>a.id == b) : (a)=>a;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const selectedLanguage = context.query.languageId || context.languageId;
            const languages = (0, _lodash.chain)(filter(context.languages)).orderBy([
                'id'
            ], [
                'desc'
            ]).map((l)=>({
                    ...l,
                    selected: l.id == selectedLanguage
                })).map(LanguageFilterButton).value();
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "language filter",
                children: languages
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react-router-dom":"3uzXR","react":"9njXz","react-text":"lEpdJ","../../context":"iUP37","./language-filter.styl":"3vR3E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3vR3E":[function() {},{}],"2EYwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("components/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _material = require("external/material");
var _react = require("external/react");
var _url = require("helpers/url");
var _utils = require("helpers/utils");
var _context = require("teacher/context");
const StyledSubjectCard = (0, _material.styleAndCapture)((0, _react.Link), 'subject')(subjectCardStyles);
const subjectImage = (subject)=>(0, _url.staticAssetLink)('subject-logos', `${subject}.png`);
const SubjectCard = (props)=>{
    const { className = 'subject-card', id, to, name, lessonCount } = props;
    const { translate } = (0, _react.useContext)((0, _context.TeacherContext));
    const [imageError, setImageError] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledSubjectCard, {
        className: (0, _material.clsx)('subject-card', className, {
            'image-error': imageError
        }),
        to: to,
        subject: id,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "card-image",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "filler"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "image-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: subjectImage(id),
                            alt: id,
                            onError: (e)=>{
                                setImageError(true);
                            }
                        })
                    }),
                    imageError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "fallback-id",
                        children: name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "card-title",
                        children: name
                    })
                ]
            }),
            lessonCount !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "lesson-count",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            name: "lesson-count",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "label",
                        children: [
                            (0, _utils.formatNumber)(lessonCount),
                            " ",
                            translate('lessons')
                        ]
                    })
                ]
            })
        ]
    });
};
exports.default = SubjectCard;
function subjectCardStyles(args) {
    const subject = getSubjectFromId(args.subject);
    return {
        color: '#fff',
        overflow: 'hidden',
        borderRadius: '16px',
        textDecoration: 'none',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        background: `linear-gradient(to bottom, ${subject.startColor}, ${subject.endColor})`,
        aspectRatio: '1 / 1',
        // Forces perfect squares
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        textAlign: 'center',
        position: 'relative',
        minHeight: 0,
        // Prevents flex items from overflowing
        '& > div': {
            width: '100%',
            padding: 0
        },
        '& > .card-image': {
            paddingTop: 10,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 2,
            '& .filler': {
                flexGrow: 1
            }
        },
        '& .card-title': {
            fontSize: '1.2rem',
            fontWeight: 500,
            paddingBottom: 10
        },
        '& > .lesson-count': {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            padding: 8,
            backgroundColor: `${subject.content}`,
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                '&.label': {
                    paddingTop: 2,
                    marginLeft: 8
                }
            }
        },
        '& img': {
            height: 140
        }
    };
}
const SUBJECT_MAP = {
    'C1': {
        startColor: '#91F3E2',
        endColor: '#1A9EA6',
        content: '#218487'
    },
    'C2': {
        startColor: '#FCC663',
        endColor: '#D06703',
        content: '#C05709'
    },
    'C3': {
        startColor: '#D2A1F1',
        endColor: '#B256B8',
        content: '#944599'
    },
    'C4': {
        startColor: '#6DC5DE',
        endColor: '#3B93BB',
        content: '#337C9C'
    },
    'C5': {
        startColor: '#82F0B3',
        endColor: '#459833',
        content: '#367F31'
    },
    'C6': {
        startColor: '#FDDA35',
        endColor: '#C8A818',
        content: '#A78C0F'
    },
    'C7': {
        startColor: '#F19B9B',
        endColor: '#B12323',
        content: '#9F2E2E'
    },
    'C8': {
        startColor: '#F176CA',
        endColor: '#AB2B81',
        content: '#9A2975'
    },
    'C9': {
        startColor: '#C1C1C1',
        endColor: '#6F6D6A',
        content: '#5F5B58'
    }
};
function getSubjectFromId(id) {
    const upperCaseId = id.toUpperCase();
    if (SUBJECT_MAP[upperCaseId]) return SUBJECT_MAP[upperCaseId];
    return SUBJECT_MAP['C1'];
}

},{"react/jsx-runtime":"1dlk8","components/icon":"82gpi","external/material":"6yEDE","external/react":"k16GP","helpers/url":"65SQD","helpers/utils":"gGc98","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2IRhQ":[function() {},{}],"3l87L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CatalogueCourses);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("teacher/context");
var _searchPattern = require("components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _languageFilter = require("components/language-filter");
var _languageFilterDefault = parcelHelpers.interopDefault(_languageFilter);
var _gradeFilter = require("components/grade-filter");
var _gradeFilterDefault = parcelHelpers.interopDefault(_gradeFilter);
var _course = require("./course");
var _courseDefault = parcelHelpers.interopDefault(_course);
var _catalogueCoursesStyl = require("./catalogue-courses.styl");
function CatalogueCourses() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { sizes } = context;
    const selectedGrade = context.query.grade || context.grade;
    const [subjectInfo, availableLanguages, ...catalogueCourses] = context.catalogueCourses;
    const courses = selectedGrade ? catalogueCourses.filter(({ grade })=>grade == selectedGrade) : (0, _lodash.sortBy)(catalogueCourses, [
        ({ grade })=>context.gradePrecedence[grade],
        'id'
    ]);
    const coursesPerRow = Math.floor((sizes.width - 48) / 235);
    const fillersNeeded = coursesPerRow - courses.length % coursesPerRow;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "catalogue-courses",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filters-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "filters",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "back",
                            onClick: ()=>navigateBack(context)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "subject-name",
                            children: subjectInfo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "label",
                                children: subjectInfo.name
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageFilterDefault.default), {
                            ...availableLanguages
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradeFilterDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "courses",
                        children: [
                            courses.map((course)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _courseDefault.default), {
                                    ...course
                                }, course.id)),
                            (0, _lodash.range)(fillersNeeded).map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "course filler"
                                }, key))
                        ]
                    })
                ]
            })
        ]
    });
}
function navigateBack(context) {
    const query = {
        languageId: context.query.languageId
    };
    context.navigate({
        subject: null
    }, context.match.path, {
        query
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","teacher/context":"5LKDx","components/search-pattern":"lUZFT","components/language-filter":"jao8N","components/grade-filter":"4zsNq","./course":"9PLst","./catalogue-courses.styl":"eOZUK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4zsNq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../context");
var _gradeFilterStyl = require("./grade-filter.styl");
function GradeFilterButton({ id, name, selected }) {
    const query = {
        grade: selected ? undefined : id
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: `grade filter ${selected ? 'selected' : ''}`,
                to: context.link({}, context.match.params, {
                    query,
                    preserveQuery: true
                }),
                children: name
            });
        }
    }, id);
}
function GradeFilter() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const courseGrades = (0, _lodash.chain)(context.catalogueCourses).map(({ grade })=>grade).uniq().value();
            const selectedGrade = context.query.grade || context.grade;
            const grades = (0, _lodash.chain)(context.grades).intersectionWith(courseGrades, (a, b)=>a.id == b).orderBy([
                'precedence'
            ]).map((g)=>({
                    ...g,
                    selected: g.id == selectedGrade
                })).map(GradeFilterButton).value();
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "grade-filters",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "grades_label"
                            }),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "content",
                        children: grades
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","../../context":"iUP37","./grade-filter.styl":"etFmq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"etFmq":[function() {},{}],"9PLst":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Course);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("teacher/context");
var _utils = require("helpers/utils");
var _label = require("components/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _icon = require("components/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _cover = require("components/Cover");
var _coverDefault = parcelHelpers.interopDefault(_cover);
var _courseStyl = require("./course.styl");
function Course(props) {
    const { id, name, lessonCount, inContract } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const label = context.translate(`lesson${lessonCount > 1 ? 's' : ''}_label`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "course",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                className: "course-link",
                to: context.link({
                    course: id
                }, context.match.path, {
                    preserveQuery: true
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "cover",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coverDefault.default), {
                            course: id,
                            courseName: name,
                            width: 201,
                            height: 260
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "footer",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
                                className: "label",
                                value: name,
                                maxLength: 20
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "lesson-count",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            name: "lesson-count"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "value",
                                            children: (0, _utils.formatNumber)(lessonCount)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "label",
                                            children: label
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !inContract && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "lock",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: "lock",
                    width: 40,
                    height: 40
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","teacher/context":"5LKDx","helpers/utils":"gGc98","components/label":"59910","components/icon":"82gpi","components/Cover":"UlVrZ","./course.styl":"tH4zA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59910":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Label);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function Label(props) {
    const { value, maxLength } = props;
    const labelProps = (0, _lodash.omit)(props, [
        'value',
        'maxLength'
    ]);
    const hasTitle = value.length > maxLength;
    const title = hasTitle ? value : undefined;
    const text = hasTitle ? `${value.substring(0, maxLength - 3)}...` : value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
        ...labelProps,
        title,
        children: text
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"UlVrZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cardMedia = require("@mui/material/CardMedia");
var _cardMediaDefault = parcelHelpers.interopDefault(_cardMedia);
var _url = require("helpers/url");
const coverImage = (course = 'default')=>(0, _url.staticAssetLink)('covers', `${course}.jpg`);
function CourseItem({ course, courseName, width, height }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardMediaDefault.default), {
        component: "img",
        image: coverImage(course),
        width: width,
        height: height,
        onError: (e)=>e.target.src = coverImage(),
        alt: courseName
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/CardMedia":"4gLtp","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gLtp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cardMediaDefault.default));
parcelHelpers.export(exports, "cardMediaClasses", ()=>(0, _cardMediaClassesDefault.default));
var _cardMedia = require("./CardMedia");
var _cardMediaDefault = parcelHelpers.interopDefault(_cardMedia);
var _cardMediaClasses = require("./cardMediaClasses");
var _cardMediaClassesDefault = parcelHelpers.interopDefault(_cardMediaClasses);
parcelHelpers.exportAll(_cardMediaClasses, exports);
'use client';

},{"./CardMedia":"b3wac","./cardMediaClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b3wac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _cardMediaClasses = require("./cardMediaClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, isMediaComponent, isImageComponent } = ownerState;
    const slots = {
        root: [
            'root',
            isMediaComponent && 'media',
            isImageComponent && 'img'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _cardMediaClasses.getCardMediaUtilityClass), classes);
};
const CardMediaRoot = (0, _styledDefault.default)('div', {
    name: 'MuiCardMedia',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { isMediaComponent, isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: 'block',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
    }, ownerState.isMediaComponent && {
        width: '100%'
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: 'cover'
    }));
const MEDIA_COMPONENTS = [
    'video',
    'audio',
    'picture',
    'iframe',
    'img'
];
const IMAGE_COMPONENTS = [
    'picture',
    'img'
];
const CardMedia = /*#__PURE__*/ _react.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCardMedia'
    });
    const { children, className, component = 'div', image, src, style } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const isMediaComponent = MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, _extendsDefault.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        isMediaComponent,
        isImageComponent: IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardMediaRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? 'img' : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
exports.default = CardMedia;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/chainPropTypes":"83tGg","@mui/utils/composeClasses":"43D21","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./cardMediaClasses":"2alaV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2alaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCardMediaUtilityClass", ()=>getCardMediaUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCardMediaUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiCardMedia', slot);
}
const cardMediaClasses = (0, _generateUtilityClassesDefault.default)('MuiCardMedia', [
    'root',
    'media',
    'img'
]);
exports.default = cardMediaClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"tH4zA":[function() {},{}],"eOZUK":[function() {},{}],"5qV3n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _scheduleLesson = require("../schedule-lesson");
var _scheduleLessonDefault = parcelHelpers.interopDefault(_scheduleLesson);
var _context = require("../../context");
var _utils = require("../../helpers/utils");
var _contextLoader = require("../context-loader");
var _contextLoaderDefault = parcelHelpers.interopDefault(_contextLoader);
var _searchPattern = require("../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _pagination = require("../pagination");
var _catalogueSearchResultsStyl = require("./catalogue-search-results.styl");
const { columns, headers } = (0, _columnsDefault.default);
const Layout = ({ Table, Pagination, Filter })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "catalogue-search-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
        ]
    });
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "catalog_search_no_results_label"
        })
    });
}
class Lessons extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        (0, _utils.bind)(this, 'goPage', 'goNext', 'goPrevious', 'sort');
    }
    goPage(page) {
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                page
            }
        });
    }
    goNext() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage + 1);
    }
    goPrevious() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage - 1);
    }
    sort({ id, sortAscending }) {
        const orderBy = `${sortAscending ? '' : '-'}${id}`;
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                orderBy
            }
        });
    }
    render() {
        const context = this.context;
        const [pageProperties, ...lessons] = context.catalogueSearchResults;
        const { recordCount } = pageProperties || {};
        const backPath = context.link({}, context.match.path.replace(/\/:searching.*$/, ''), {
            preserveQuery: true,
            query: {
                subject: undefined,
                pattern: undefined,
                pageSize: undefined,
                page: undefined
            }
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextLoaderDefault.default), {
            id: "catalogueSearch",
            className: "catalogue-search",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: "back",
                                to: backPath
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "label-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "label",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "catalog_search_header_label"
                                        }),
                                        recordCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            className: "lessonCount",
                                            children: [
                                                ": ",
                                                recordCount,
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                        id: `lesson${recordCount > 1 ? 's' : ''}_label`
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                                initialPattern: context.query.pattern
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "catalogue-search-results",
                        children: [
                            [
                                'schedule',
                                'posts'
                            ].indexOf(this.context.action) >= 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scheduleLessonDefault.default), {
                                selectedGroup: {},
                                activeTab: "groups"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                                data: lessons,
                                components: {
                                    NoResults,
                                    PageDropdown: (0, _pagination.PageDropdown),
                                    Pagination: (0, _pagination.Pagination),
                                    Layout,
                                    Filter: (0, _filtersDefault.default)
                                },
                                pageProperties: pageProperties,
                                events: {
                                    onNext: this.goNext,
                                    onPrevious: this.goPrevious,
                                    onGetPage: this.goPage,
                                    onSort: this.sort
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                            id: "lesson",
                                            customHeadingComponent: headers.CatalogueSearchHeader,
                                            customComponent: columns.LessonColumn
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                            id: "courseName",
                                            customHeadingComponent: headers.CatalogueSearchHeader,
                                            customComponent: columns.LabelColumn(200)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                            id: "lessonName",
                                            customHeadingComponent: headers.CatalogueSearchHeader,
                                            customComponent: columns.LabelColumn(200)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                            id: "links",
                                            customHeadingComponent: headers.EmptyHeader,
                                            customComponent: columns.LessonLinksColumn
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = Lessons;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","griddle-react":"6zdUV","../schedule-lesson":"k69TP","../../context":"iUP37","../../helpers/utils":"gGc98","../context-loader":"ktxlD","../search-pattern":"lUZFT","./columns":"mRjhS","./filters":"21HgL","../pagination":"82vF6","./catalogue-search-results.styl":"cBKcj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ktxlD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ContextLoader);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../../context");
var _contextLoaderStyl = require("./context-loader.styl");
function ContextLoader(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const loading = context.loading[props.id];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `${props.className} ${loading ? 'loading' : 'loaded'}`,
                children: [
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mask",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "spinner",
                            children: (0, _lodash.range)(12).map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    key
                                }))
                        })
                    }),
                    props.children
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","../../context":"iUP37","./context-loader.styl":"2b9MS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2b9MS":[function() {},{}],"mRjhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _label = require("../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _lessonLinks = require("../lesson-links");
var _lessonLinksDefault = parcelHelpers.interopDefault(_lessonLinks);
var _utils = require("../../helpers/utils");
function CatalogueSearchHeader({ sortColumns, title }) {
    const active = sortColumns && sortColumns.id == title;
    const direction = active ? sortColumns.sortAscending ? 'ascending' : 'descending' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "sorted-column-wrapper",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: direction
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${title}_catalog_search_header`
                })
            })
        ]
    });
}
function EmptyHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
}
function LabelColumn(maxLength) {
    return ({ value, sortColumns })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
            value,
            maxLength
        });
    };
}
function LessonColumn({ rowData }) {
    const { lesson, assigned } = rowData;
    const assignedClass = `lesson-code${assigned ? ' assigned' : ''}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: assignedClass,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bullet"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "code",
                children: lesson
            })
        ]
    });
}
function LessonLinksColumn({ rowData }) {
    const map = {
        lesson: 'id',
        lessonName: 'name'
    };
    const props = (0, _lodash.mapKeys)(rowData, (_, key)=>map[key] || key);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonLinksDefault.default), {
        ...props
    });
}
const map = {
    headers: {
        CatalogueSearchHeader: (0, _utils.enhancedWithSortColumns)(CatalogueSearchHeader),
        EmptyHeader
    },
    columns: {
        LessonColumn: (0, _utils.enhancedWithRowData)(LessonColumn),
        LessonLinksColumn: (0, _utils.enhancedWithRowData)(LessonLinksColumn),
        LabelColumn
    }
};
exports.default = map;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","../label":"59910","../lesson-links":"a44pk","../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21HgL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _context = require("../../context");
var _filtersStyl = require("./filters.styl");
function SelectFilter(props) {
    const className = `select-${props.name}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const id = context.query[props.valueProperty];
            const value = context[props.name].find((prop)=>prop.id == id);
            const placeholder = context.translate(`${props.name}_filters_no_options_message`);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "dropdown",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        className: className,
                        classNamePrefix: "select",
                        formatOptionLabel: ({ name })=>name,
                        isSearchable: false,
                        isClearable: true,
                        escapeClearsValue: true,
                        getOptionValue: ({ id })=>id,
                        placeholder: placeholder,
                        value: value,
                        onChange: (option)=>{
                            const { id } = option || {};
                            const query = {
                                [props.valueProperty]: id,
                                page: undefined
                            };
                            context.navigate({}, context.match.path, {
                                preserveQuery: true,
                                query
                            });
                        },
                        options: context[props.name]
                    })
                })
            });
        }
    });
}
function Filters() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "filters-wrapper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "filters",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                    name: "subjects",
                    valueProperty: "subject"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                    name: "grades",
                    valueProperty: "grade"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                    name: "languages",
                    valueProperty: "languageId"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-select":"j36cq","../../context":"iUP37","./filters.styl":"hmN6j","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hmN6j":[function() {},{}],"82vF6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", ()=>Pagination);
parcelHelpers.export(exports, "PageDropdown", ()=>PageDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _rcPagination = require("rc-pagination");
var _rcPaginationDefault = parcelHelpers.interopDefault(_rcPagination);
var _context = require("../../context");
var _utils = require("../../helpers/utils");
var _indexCss = require("rc-pagination/assets/index.css");
const Pagination = ({ PageDropdown, style, className })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: style,
        className: className,
        children: PageDropdown && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PageDropdown, {})
    });
const PageDropdown = (0, _utils.enhancedWithPageProperties)((props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rcPaginationDefault.default), {
                className: props.className,
                current: props.currentPage,
                pageSize: props.pageProperties.pageSize,
                onChange: props.setPage,
                total: props.pageProperties.recordCount,
                locale: context.settings["pagination-locale"][context.languageId]
            });
        }
    });
});

},{"react/jsx-runtime":"1dlk8","react":"9njXz","rc-pagination":"2H64D","../../context":"iUP37","../../helpers/utils":"gGc98","rc-pagination/assets/index.css":"lhVpQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2H64D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationDefault.default));
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);

},{"./Pagination":"99EL0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"99EL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _extends = require("babel-runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _pager = require("./Pager");
var _pagerDefault = parcelHelpers.interopDefault(_pager);
var _options = require("./Options");
var _optionsDefault = parcelHelpers.interopDefault(_options);
var _keyCode = require("./KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _zhCN = require("./locale/zh_CN");
var _zhCNDefault = parcelHelpers.interopDefault(_zhCN);
var _reactLifecyclesCompat = require("react-lifecycles-compat");
function noop() {}
function isInteger(value) {
    return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function defaultItemRender(page, type, element) {
    return element;
}
function calculatePage(p, state, props) {
    var pageSize = p;
    if (typeof pageSize === 'undefined') pageSize = state.pageSize;
    return Math.floor((props.total - 1) / pageSize) + 1;
}
var Pagination = function(_React$Component) {
    (0, _inheritsDefault.default)(Pagination, _React$Component);
    function Pagination(props) {
        (0, _classCallCheckDefault.default)(this, Pagination);
        var _this = (0, _possibleConstructorReturnDefault.default)(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
        _initialiseProps.call(_this);
        var hasOnChange = props.onChange !== noop;
        var hasCurrent = 'current' in props;
        if (hasCurrent && !hasOnChange) console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
        var current = props.defaultCurrent;
        if ('current' in props) current = props.current;
        var pageSize = props.defaultPageSize;
        if ('pageSize' in props) pageSize = props.pageSize;
        current = Math.min(current, calculatePage(pageSize, undefined, props));
        _this.state = {
            current: current,
            currentInputValue: current,
            pageSize: pageSize
        };
        return _this;
    }
    (0, _createClassDefault.default)(Pagination, [
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
                // When current page change, fix focused style of prev item
                // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
                var prefixCls = this.props.prefixCls;
                if (prevState.current !== this.state.current && this.paginationNode) {
                    var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
                    if (lastCurrentNode && document.activeElement === lastCurrentNode) lastCurrentNode.blur();
                }
            }
        },
        {
            key: 'getValidValue',
            value: function getValidValue(e) {
                var inputValue = e.target.value;
                var allPages = calculatePage(undefined, this.state, this.props);
                var currentInputValue = this.state.currentInputValue;
                var value = void 0;
                if (inputValue === '') value = inputValue;
                else if (isNaN(Number(inputValue))) value = currentInputValue;
                else if (inputValue >= allPages) value = allPages;
                else value = Number(inputValue);
                return value;
            }
        },
        {
            key: 'renderPrev',
            value: function renderPrev(prevPage) {
                var _props = this.props, prevIcon = _props.prevIcon, itemRender = _props.itemRender;
                var prevButton = itemRender(prevPage, 'prev', this.getItemIcon(prevIcon));
                var disabled = !this.hasPrev();
                return (0, _react.isValidElement)(prevButton) ? (0, _react.cloneElement)(prevButton, {
                    disabled: disabled
                }) : prevButton;
            }
        },
        {
            key: 'renderNext',
            value: function renderNext(nextPage) {
                var _props2 = this.props, nextIcon = _props2.nextIcon, itemRender = _props2.itemRender;
                var nextButton = itemRender(nextPage, 'next', this.getItemIcon(nextIcon));
                var disabled = !this.hasNext();
                return (0, _react.isValidElement)(nextButton) ? (0, _react.cloneElement)(nextButton, {
                    disabled: disabled
                }) : nextButton;
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props3 = this.props, prefixCls = _props3.prefixCls, className = _props3.className, disabled = _props3.disabled;
                // When hideOnSinglePage is true and there is only 1 page, hide the pager
                if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) return null;
                var props = this.props;
                var locale = props.locale;
                var allPages = calculatePage(undefined, this.state, this.props);
                var pagerList = [];
                var jumpPrev = null;
                var jumpNext = null;
                var firstPager = null;
                var lastPager = null;
                var gotoButton = null;
                var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
                var pageBufferSize = props.showLessItems ? 1 : 2;
                var _state = this.state, current = _state.current, pageSize = _state.pageSize;
                var prevPage = current - 1 > 0 ? current - 1 : 0;
                var nextPage = current + 1 < allPages ? current + 1 : allPages;
                var dataOrAriaAttributeProps = Object.keys(props).reduce(function(prev, key) {
                    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') prev[key] = props[key];
                    return prev;
                }, {});
                if (props.simple) {
                    if (goButton) {
                        if (typeof goButton === 'boolean') gotoButton = (0, _reactDefault.default).createElement('button', {
                            type: 'button',
                            onClick: this.handleGoTO,
                            onKeyUp: this.handleGoTO
                        }, locale.jump_to_confirm);
                        else gotoButton = (0, _reactDefault.default).createElement('span', {
                            onClick: this.handleGoTO,
                            onKeyUp: this.handleGoTO
                        }, goButton);
                        gotoButton = (0, _reactDefault.default).createElement('li', {
                            title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
                            className: prefixCls + '-simple-pager'
                        }, gotoButton);
                    }
                    return (0, _reactDefault.default).createElement('ul', (0, _extendsDefault.default)({
                        className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
                        style: props.style,
                        ref: this.savePaginationNode
                    }, dataOrAriaAttributeProps), (0, _reactDefault.default).createElement('li', {
                        title: props.showTitle ? locale.prev_page : null,
                        onClick: this.prev,
                        tabIndex: this.hasPrev() ? 0 : null,
                        onKeyPress: this.runIfEnterPrev,
                        className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
                        'aria-disabled': !this.hasPrev()
                    }, this.renderPrev(prevPage)), (0, _reactDefault.default).createElement('li', {
                        title: props.showTitle ? this.state.current + '/' + allPages : null,
                        className: prefixCls + '-simple-pager'
                    }, (0, _reactDefault.default).createElement('input', {
                        type: 'text',
                        value: this.state.currentInputValue,
                        onKeyDown: this.handleKeyDown,
                        onKeyUp: this.handleKeyUp,
                        onChange: this.handleKeyUp,
                        size: '3'
                    }), (0, _reactDefault.default).createElement('span', {
                        className: prefixCls + '-slash'
                    }, '/'), allPages), (0, _reactDefault.default).createElement('li', {
                        title: props.showTitle ? locale.next_page : null,
                        onClick: this.next,
                        tabIndex: this.hasPrev() ? 0 : null,
                        onKeyPress: this.runIfEnterNext,
                        className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
                        'aria-disabled': !this.hasNext()
                    }, this.renderNext(nextPage)), gotoButton);
                }
                if (allPages <= 5 + pageBufferSize * 2) {
                    var pagerProps = {
                        locale: locale,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        showTitle: props.showTitle,
                        itemRender: props.itemRender
                    };
                    if (!allPages) pagerList.push((0, _reactDefault.default).createElement((0, _pagerDefault.default), (0, _extendsDefault.default)({}, pagerProps, {
                        key: 'noPager',
                        page: allPages,
                        className: prefixCls + '-disabled'
                    })));
                    for(var i = 1; i <= allPages; i++){
                        var active = this.state.current === i;
                        pagerList.push((0, _reactDefault.default).createElement((0, _pagerDefault.default), (0, _extendsDefault.default)({}, pagerProps, {
                            key: i,
                            page: i,
                            active: active
                        })));
                    }
                } else {
                    var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
                    var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
                    if (props.showPrevNextJumpers) {
                        var jumpPrevClassString = prefixCls + '-jump-prev';
                        if (props.jumpPrevIcon) jumpPrevClassString += ' ' + prefixCls + '-jump-prev-custom-icon';
                        jumpPrev = (0, _reactDefault.default).createElement('li', {
                            title: props.showTitle ? prevItemTitle : null,
                            key: 'prev',
                            onClick: this.jumpPrev,
                            tabIndex: '0',
                            onKeyPress: this.runIfEnterJumpPrev,
                            className: jumpPrevClassString
                        }, props.itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(props.jumpPrevIcon)));
                        var jumpNextClassString = prefixCls + '-jump-next';
                        if (props.jumpNextIcon) jumpNextClassString += ' ' + prefixCls + '-jump-next-custom-icon';
                        jumpNext = (0, _reactDefault.default).createElement('li', {
                            title: props.showTitle ? nextItemTitle : null,
                            key: 'next',
                            tabIndex: '0',
                            onClick: this.jumpNext,
                            onKeyPress: this.runIfEnterJumpNext,
                            className: jumpNextClassString
                        }, props.itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(props.jumpNextIcon)));
                    }
                    lastPager = (0, _reactDefault.default).createElement((0, _pagerDefault.default), {
                        locale: props.locale,
                        last: true,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        key: allPages,
                        page: allPages,
                        active: false,
                        showTitle: props.showTitle,
                        itemRender: props.itemRender
                    });
                    firstPager = (0, _reactDefault.default).createElement((0, _pagerDefault.default), {
                        locale: props.locale,
                        rootPrefixCls: prefixCls,
                        onClick: this.handleChange,
                        onKeyPress: this.runIfEnter,
                        key: 1,
                        page: 1,
                        active: false,
                        showTitle: props.showTitle,
                        itemRender: props.itemRender
                    });
                    var left = Math.max(1, current - pageBufferSize);
                    var right = Math.min(current + pageBufferSize, allPages);
                    if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
                    if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
                    for(var _i = left; _i <= right; _i++){
                        var _active = current === _i;
                        pagerList.push((0, _reactDefault.default).createElement((0, _pagerDefault.default), {
                            locale: props.locale,
                            rootPrefixCls: prefixCls,
                            onClick: this.handleChange,
                            onKeyPress: this.runIfEnter,
                            key: _i,
                            page: _i,
                            active: _active,
                            showTitle: props.showTitle,
                            itemRender: props.itemRender
                        }));
                    }
                    if (current - 1 >= pageBufferSize * 2 && current !== 3) {
                        pagerList[0] = (0, _reactDefault.default).cloneElement(pagerList[0], {
                            className: prefixCls + '-item-after-jump-prev'
                        });
                        pagerList.unshift(jumpPrev);
                    }
                    if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
                        pagerList[pagerList.length - 1] = (0, _reactDefault.default).cloneElement(pagerList[pagerList.length - 1], {
                            className: prefixCls + '-item-before-jump-next'
                        });
                        pagerList.push(jumpNext);
                    }
                    if (left !== 1) pagerList.unshift(firstPager);
                    if (right !== allPages) pagerList.push(lastPager);
                }
                var totalText = null;
                if (props.showTotal) totalText = (0, _reactDefault.default).createElement('li', {
                    className: prefixCls + '-total-text'
                }, props.showTotal(props.total, [
                    props.total === 0 ? 0 : (current - 1) * pageSize + 1,
                    current * pageSize > props.total ? props.total : current * pageSize
                ]));
                var prevDisabled = !this.hasPrev() || !allPages;
                var nextDisabled = !this.hasNext() || !allPages;
                return (0, _reactDefault.default).createElement('ul', (0, _extendsDefault.default)({
                    className: (0, _classnamesDefault.default)(prefixCls, className, (0, _definePropertyDefault.default)({}, prefixCls + '-disabled', disabled)),
                    style: props.style,
                    unselectable: 'unselectable',
                    ref: this.savePaginationNode
                }, dataOrAriaAttributeProps), totalText, (0, _reactDefault.default).createElement('li', {
                    title: props.showTitle ? locale.prev_page : null,
                    onClick: this.prev,
                    tabIndex: prevDisabled ? null : 0,
                    onKeyPress: this.runIfEnterPrev,
                    className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
                    'aria-disabled': prevDisabled
                }, this.renderPrev(prevPage)), pagerList, (0, _reactDefault.default).createElement('li', {
                    title: props.showTitle ? locale.next_page : null,
                    onClick: this.next,
                    tabIndex: nextDisabled ? null : 0,
                    onKeyPress: this.runIfEnterNext,
                    className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
                    'aria-disabled': nextDisabled
                }, this.renderNext(nextPage)), (0, _reactDefault.default).createElement((0, _optionsDefault.default), {
                    disabled: disabled,
                    locale: props.locale,
                    rootPrefixCls: prefixCls,
                    selectComponentClass: props.selectComponentClass,
                    selectPrefixCls: props.selectPrefixCls,
                    changeSize: this.props.showSizeChanger ? this.changePageSize : null,
                    current: this.state.current,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: this.props.pageSizeOptions,
                    quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
                    goButton: goButton
                }));
            }
        }
    ], [
        {
            key: 'getDerivedStateFromProps',
            value: function getDerivedStateFromProps(props, prevState) {
                var newState = {};
                if ('current' in props) {
                    newState.current = props.current;
                    if (props.current !== prevState.current) newState.currentInputValue = newState.current;
                }
                if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
                    var current = prevState.current;
                    var newCurrent = calculatePage(props.pageSize, prevState, props);
                    current = current > newCurrent ? newCurrent : current;
                    if (!('current' in props)) {
                        newState.current = current;
                        newState.currentInputValue = current;
                    }
                    newState.pageSize = props.pageSize;
                }
                return newState;
            }
        }
    ]);
    return Pagination;
}((0, _reactDefault.default).Component);
Pagination.propTypes = {
    disabled: (0, _propTypesDefault.default).bool,
    prefixCls: (0, _propTypesDefault.default).string,
    className: (0, _propTypesDefault.default).string,
    current: (0, _propTypesDefault.default).number,
    defaultCurrent: (0, _propTypesDefault.default).number,
    total: (0, _propTypesDefault.default).number,
    pageSize: (0, _propTypesDefault.default).number,
    defaultPageSize: (0, _propTypesDefault.default).number,
    onChange: (0, _propTypesDefault.default).func,
    hideOnSinglePage: (0, _propTypesDefault.default).bool,
    showSizeChanger: (0, _propTypesDefault.default).bool,
    showLessItems: (0, _propTypesDefault.default).bool,
    onShowSizeChange: (0, _propTypesDefault.default).func,
    selectComponentClass: (0, _propTypesDefault.default).func,
    showPrevNextJumpers: (0, _propTypesDefault.default).bool,
    showQuickJumper: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).object
    ]),
    showTitle: (0, _propTypesDefault.default).bool,
    pageSizeOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    showTotal: (0, _propTypesDefault.default).func,
    locale: (0, _propTypesDefault.default).object,
    style: (0, _propTypesDefault.default).object,
    itemRender: (0, _propTypesDefault.default).func,
    prevIcon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).node
    ]),
    nextIcon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).node
    ]),
    jumpPrevIcon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).node
    ]),
    jumpNextIcon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).node
    ])
};
Pagination.defaultProps = {
    defaultCurrent: 1,
    total: 0,
    defaultPageSize: 10,
    onChange: noop,
    className: '',
    selectPrefixCls: 'rc-select',
    prefixCls: 'rc-pagination',
    selectComponentClass: null,
    hideOnSinglePage: false,
    showPrevNextJumpers: true,
    showQuickJumper: false,
    showSizeChanger: false,
    showLessItems: false,
    showTitle: true,
    onShowSizeChange: noop,
    locale: (0, _zhCNDefault.default),
    style: {},
    itemRender: defaultItemRender
};
var _initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.getJumpPrevPage = function() {
        return Math.max(1, _this2.state.current - (_this2.props.showLessItems ? 3 : 5));
    };
    this.getJumpNextPage = function() {
        return Math.min(calculatePage(undefined, _this2.state, _this2.props), _this2.state.current + (_this2.props.showLessItems ? 3 : 5));
    };
    this.getItemIcon = function(icon) {
        var prefixCls = _this2.props.prefixCls;
        var iconNode = icon || (0, _reactDefault.default).createElement('a', {
            className: prefixCls + '-item-link'
        });
        if (typeof icon === 'function') iconNode = (0, _reactDefault.default).createElement(icon, (0, _extendsDefault.default)({}, _this2.props));
        return iconNode;
    };
    this.savePaginationNode = function(node) {
        _this2.paginationNode = node;
    };
    this.isValid = function(page) {
        return isInteger(page) && page !== _this2.state.current;
    };
    this.shouldDisplayQuickJumper = function() {
        var _props4 = _this2.props, showQuickJumper = _props4.showQuickJumper, pageSize = _props4.pageSize, total = _props4.total;
        if (total <= pageSize) return false;
        return showQuickJumper;
    };
    this.handleKeyDown = function(e) {
        if (e.keyCode === (0, _keyCodeDefault.default).ARROW_UP || e.keyCode === (0, _keyCodeDefault.default).ARROW_DOWN) e.preventDefault();
    };
    this.handleKeyUp = function(e) {
        var value = _this2.getValidValue(e);
        var currentInputValue = _this2.state.currentInputValue;
        if (value !== currentInputValue) _this2.setState({
            currentInputValue: value
        });
        if (e.keyCode === (0, _keyCodeDefault.default).ENTER) _this2.handleChange(value);
        else if (e.keyCode === (0, _keyCodeDefault.default).ARROW_UP) _this2.handleChange(value - 1);
        else if (e.keyCode === (0, _keyCodeDefault.default).ARROW_DOWN) _this2.handleChange(value + 1);
    };
    this.changePageSize = function(size) {
        var current = _this2.state.current;
        var newCurrent = calculatePage(size, _this2.state, _this2.props);
        current = current > newCurrent ? newCurrent : current;
        // fix the issue:
        // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
        if (newCurrent === 0) current = _this2.state.current;
        if (typeof size === 'number') {
            if (!('pageSize' in _this2.props)) _this2.setState({
                pageSize: size
            });
            if (!('current' in _this2.props)) _this2.setState({
                current: current,
                currentInputValue: current
            });
        }
        _this2.props.onShowSizeChange(current, size);
    };
    this.handleChange = function(p) {
        var disabled = _this2.props.disabled;
        var page = p;
        if (_this2.isValid(page) && !disabled) {
            var currentPage = calculatePage(undefined, _this2.state, _this2.props);
            if (page > currentPage) page = currentPage;
            else if (page < 1) page = 1;
            if (!('current' in _this2.props)) _this2.setState({
                current: page,
                currentInputValue: page
            });
            var pageSize = _this2.state.pageSize;
            _this2.props.onChange(page, pageSize);
            return page;
        }
        return _this2.state.current;
    };
    this.prev = function() {
        if (_this2.hasPrev()) _this2.handleChange(_this2.state.current - 1);
    };
    this.next = function() {
        if (_this2.hasNext()) _this2.handleChange(_this2.state.current + 1);
    };
    this.jumpPrev = function() {
        _this2.handleChange(_this2.getJumpPrevPage());
    };
    this.jumpNext = function() {
        _this2.handleChange(_this2.getJumpNextPage());
    };
    this.hasPrev = function() {
        return _this2.state.current > 1;
    };
    this.hasNext = function() {
        return _this2.state.current < calculatePage(undefined, _this2.state, _this2.props);
    };
    this.runIfEnter = function(event, callback) {
        for(var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restParams[_key - 2] = arguments[_key];
        if (event.key === 'Enter' || event.charCode === 13) callback.apply(undefined, restParams);
    };
    this.runIfEnterPrev = function(e) {
        _this2.runIfEnter(e, _this2.prev);
    };
    this.runIfEnterNext = function(e) {
        _this2.runIfEnter(e, _this2.next);
    };
    this.runIfEnterJumpPrev = function(e) {
        _this2.runIfEnter(e, _this2.jumpPrev);
    };
    this.runIfEnterJumpNext = function(e) {
        _this2.runIfEnter(e, _this2.jumpNext);
    };
    this.handleGoTO = function(e) {
        if (e.keyCode === (0, _keyCodeDefault.default).ENTER || e.type === 'click') _this2.handleChange(_this2.state.currentInputValue);
    };
};
(0, _reactLifecyclesCompat.polyfill)(Pagination);
exports.default = Pagination;

},{"babel-runtime/helpers/defineProperty":"bro4R","babel-runtime/helpers/extends":"fdZRO","babel-runtime/helpers/classCallCheck":"cezzA","babel-runtime/helpers/createClass":"3I5b9","babel-runtime/helpers/possibleConstructorReturn":"HSCB8","babel-runtime/helpers/inherits":"fF87n","react":"9njXz","classnames":"5Een2","prop-types":"bnNSm","./Pager":"eucZx","./Options":"8nJRv","./KeyCode":"d7joq","./locale/zh_CN":"cNTSy","react-lifecycles-compat":"9jQEY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bro4R":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _defineProperty = require("f3f48dfa0faaaee6");
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(obj, key, value) {
    if (key in obj) (0, _defineProperty2.default)(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};

},{"f3f48dfa0faaaee6":"djFSD"}],"djFSD":[function(require,module,exports,__globalThis) {
module.exports = {
    "default": require("beda317bff3b8a5f"),
    __esModule: true
};

},{"beda317bff3b8a5f":"grK8y"}],"grK8y":[function(require,module,exports,__globalThis) {
require("adcfebd705a6a86");
var $Object = require("b035140140e10103").Object;
module.exports = function defineProperty(it, key, desc) {
    return $Object.defineProperty(it, key, desc);
};

},{"adcfebd705a6a86":"dPUHT","b035140140e10103":"kvzR0"}],"dPUHT":[function(require,module,exports,__globalThis) {
var $export = require("ce0460023897cca4");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require("1eb9caff8972eeb2"), 'Object', {
    defineProperty: require("9e6383a35b7c4495").f
});

},{"ce0460023897cca4":"bsKmz","1eb9caff8972eeb2":"bTSAE","9e6383a35b7c4495":"klaXp"}],"bsKmz":[function(require,module,exports,__globalThis) {
var global = require("3a24edf2ccbe69ef");
var core = require("48515d2a5db0d879");
var ctx = require("c0dc45eb1ad7a6b1");
var hide = require("de692b30fb0f4f76");
var has = require("add282875d251bf7");
var PROTOTYPE = 'prototype';
var $export = function(type, name, source) {
    var IS_FORCED = type & $export.F;
    var IS_GLOBAL = type & $export.G;
    var IS_STATIC = type & $export.S;
    var IS_PROTO = type & $export.P;
    var IS_BIND = type & $export.B;
    var IS_WRAP = type & $export.W;
    var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
    var expProto = exports[PROTOTYPE];
    var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && has(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? ctx(out, global) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[PROTOTYPE] = C[PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
        }
    }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"3a24edf2ccbe69ef":"J0G1X","48515d2a5db0d879":"kvzR0","c0dc45eb1ad7a6b1":"7uq48","de692b30fb0f4f76":"eskYQ","add282875d251bf7":"i2e6o"}],"J0G1X":[function(require,module,exports,__globalThis) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],"kvzR0":[function(require,module,exports,__globalThis) {
var core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],"7uq48":[function(require,module,exports,__globalThis) {
// optional / simple context binding
var aFunction = require("dc5e321426fdbef");
module.exports = function(fn, that, length) {
    aFunction(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

},{"dc5e321426fdbef":"1J6ua"}],"1J6ua":[function(require,module,exports,__globalThis) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

},{}],"eskYQ":[function(require,module,exports,__globalThis) {
var dP = require("40d0a480459b42e2");
var createDesc = require("e00336b92f5d2039");
module.exports = require("e0c637a3c57fad34") ? function(object, key, value) {
    return dP.f(object, key, createDesc(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

},{"40d0a480459b42e2":"klaXp","e00336b92f5d2039":"86DPB","e0c637a3c57fad34":"bTSAE"}],"klaXp":[function(require,module,exports,__globalThis) {
var anObject = require("cd09d3e1f2dc900");
var IE8_DOM_DEFINE = require("f4f60e74d851987a");
var toPrimitive = require("399f310a05b11dab");
var dP = Object.defineProperty;
exports.f = require("89e3e681595876bc") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (IE8_DOM_DEFINE) try {
        return dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

},{"cd09d3e1f2dc900":"8MwMX","f4f60e74d851987a":"gD2QD","399f310a05b11dab":"pXwis","89e3e681595876bc":"bTSAE"}],"8MwMX":[function(require,module,exports,__globalThis) {
var isObject = require("10c46a995b8bb344");
module.exports = function(it) {
    if (!isObject(it)) throw TypeError(it + ' is not an object!');
    return it;
};

},{"10c46a995b8bb344":"hVOZ0"}],"hVOZ0":[function(require,module,exports,__globalThis) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],"gD2QD":[function(require,module,exports,__globalThis) {
module.exports = !require("5693b309446f9525") && !require("5637d779cb6de004")(function() {
    return Object.defineProperty(require("56bfe76c1117c531")('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

},{"5693b309446f9525":"bTSAE","5637d779cb6de004":"cXu1J","56bfe76c1117c531":"llxwK"}],"bTSAE":[function(require,module,exports,__globalThis) {
// Thank's IE8 for his funny defineProperty
module.exports = !require("b417713bfe1e7448")(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

},{"b417713bfe1e7448":"cXu1J"}],"cXu1J":[function(require,module,exports,__globalThis) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

},{}],"llxwK":[function(require,module,exports,__globalThis) {
var isObject = require("ae8c7d0fb20dd250");
var document = require("c5337efc26248956").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function(it) {
    return is ? document.createElement(it) : {};
};

},{"ae8c7d0fb20dd250":"hVOZ0","c5337efc26248956":"J0G1X"}],"pXwis":[function(require,module,exports,__globalThis) {
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require("c99b670721698341");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!isObject(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

},{"c99b670721698341":"hVOZ0"}],"86DPB":[function(require,module,exports,__globalThis) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

},{}],"i2e6o":[function(require,module,exports,__globalThis) {
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return hasOwnProperty.call(it, key);
};

},{}],"fdZRO":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _assign = require("e12f447c1087414c");
var _assign2 = _interopRequireDefault(_assign);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = _assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

},{"e12f447c1087414c":"h2j8e"}],"h2j8e":[function(require,module,exports,__globalThis) {
module.exports = {
    "default": require("7b76f2e705bf7177"),
    __esModule: true
};

},{"7b76f2e705bf7177":"6HWCP"}],"6HWCP":[function(require,module,exports,__globalThis) {
require("3b124ae051ef926b");
module.exports = require("94faab459cc07f02").Object.assign;

},{"3b124ae051ef926b":"4RBxm","94faab459cc07f02":"kvzR0"}],"4RBxm":[function(require,module,exports,__globalThis) {
// 19.1.3.1 Object.assign(target, source)
var $export = require("947a83f08687b748");
$export($export.S + $export.F, 'Object', {
    assign: require("59fac76b66d93489")
});

},{"947a83f08687b748":"bsKmz","59fac76b66d93489":"eVt6T"}],"eVt6T":[function(require,module,exports,__globalThis) {
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = require("4d06296fc3d37787");
var getKeys = require("816238d97b1e5549");
var gOPS = require("badc9d80d666f716");
var pIE = require("14c943f7ddb8fd56");
var toObject = require("8de8aad7e29f1cab");
var IObject = require("29af38b14746a365");
var $assign = Object.assign;
// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require("a9534cc2b7caf362")(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = toObject(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = gOPS.f;
    var isEnum = pIE.f;
    while(aLen > index){
        var S = IObject(arguments[index++]);
        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $assign;

},{"4d06296fc3d37787":"bTSAE","816238d97b1e5549":"kN8Bb","badc9d80d666f716":"972yt","14c943f7ddb8fd56":"5Bp1g","8de8aad7e29f1cab":"8alwK","29af38b14746a365":"jur3h","a9534cc2b7caf362":"cXu1J"}],"kN8Bb":[function(require,module,exports,__globalThis) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require("4dd4179b2818165b");
var enumBugKeys = require("fa385519c9273a15");
module.exports = Object.keys || function keys(O) {
    return $keys(O, enumBugKeys);
};

},{"4dd4179b2818165b":"1VCKl","fa385519c9273a15":"bIv2C"}],"1VCKl":[function(require,module,exports,__globalThis) {
var has = require("ad134e3306c16798");
var toIObject = require("e8b40bc4d636a197");
var arrayIndexOf = require("a2933c532a542679")(false);
var IE_PROTO = require("e7e82a14412ea32e")('IE_PROTO');
module.exports = function(object, names) {
    var O = toIObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != IE_PROTO) has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if (has(O, key = names[i++])) ~arrayIndexOf(result, key) || result.push(key);
    return result;
};

},{"ad134e3306c16798":"i2e6o","e8b40bc4d636a197":"jkz41","a2933c532a542679":"cDxto","e7e82a14412ea32e":"zyj5h"}],"jkz41":[function(require,module,exports,__globalThis) {
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require("db48536de9b7f05a");
var defined = require("eb893cb8a4995704");
module.exports = function(it) {
    return IObject(defined(it));
};

},{"db48536de9b7f05a":"jur3h","eb893cb8a4995704":"hKdlF"}],"jur3h":[function(require,module,exports,__globalThis) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require("cca543150a1752e5");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"cca543150a1752e5":"jkpqx"}],"jkpqx":[function(require,module,exports,__globalThis) {
var toString = {}.toString;
module.exports = function(it) {
    return toString.call(it).slice(8, -1);
};

},{}],"hKdlF":[function(require,module,exports,__globalThis) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

},{}],"cDxto":[function(require,module,exports,__globalThis) {
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require("dd8cfc0b3bf8ceaf");
var toLength = require("e3010c5be44f4664");
var toAbsoluteIndex = require("fefdfe1064e8082");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

},{"dd8cfc0b3bf8ceaf":"jkz41","e3010c5be44f4664":"ehUMz","fefdfe1064e8082":"7lH0Q"}],"ehUMz":[function(require,module,exports,__globalThis) {
// 7.1.15 ToLength
var toInteger = require("1ccffe893bc913ca");
var min = Math.min;
module.exports = function(it) {
    return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"1ccffe893bc913ca":"kyfse"}],"kyfse":[function(require,module,exports,__globalThis) {
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],"7lH0Q":[function(require,module,exports,__globalThis) {
var toInteger = require("28ec090e3b06eb5");
var max = Math.max;
var min = Math.min;
module.exports = function(index, length) {
    index = toInteger(index);
    return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"28ec090e3b06eb5":"kyfse"}],"zyj5h":[function(require,module,exports,__globalThis) {
var shared = require("6c3a7795c0b5f03f")('keys');
var uid = require("cd6cd9494b0347e8");
module.exports = function(key) {
    return shared[key] || (shared[key] = uid(key));
};

},{"6c3a7795c0b5f03f":"eGtsx","cd6cd9494b0347e8":"DTsTg"}],"eGtsx":[function(require,module,exports,__globalThis) {
var core = require("244d06b59cac8ba8");
var global = require("e579b4716d485d72");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function(key, value) {
    return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: core.version,
    mode: require("8b94e0d99a5c59ab") ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

},{"244d06b59cac8ba8":"kvzR0","e579b4716d485d72":"J0G1X","8b94e0d99a5c59ab":"8JunI"}],"8JunI":[function(require,module,exports,__globalThis) {
module.exports = true;

},{}],"DTsTg":[function(require,module,exports,__globalThis) {
var id = 0;
var px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],"bIv2C":[function(require,module,exports,__globalThis) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

},{}],"972yt":[function(require,module,exports,__globalThis) {
exports.f = Object.getOwnPropertySymbols;

},{}],"5Bp1g":[function(require,module,exports,__globalThis) {
exports.f = ({}).propertyIsEnumerable;

},{}],"8alwK":[function(require,module,exports,__globalThis) {
// 7.1.13 ToObject(argument)
var defined = require("583cb1fa8f0039a");
module.exports = function(it) {
    return Object(defined(it));
};

},{"583cb1fa8f0039a":"hKdlF"}],"cezzA":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.default = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

},{}],"3I5b9":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _defineProperty = require("4ee51b39fa0a487d");
var _defineProperty2 = _interopRequireDefault(_defineProperty);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, _defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

},{"4ee51b39fa0a487d":"djFSD"}],"HSCB8":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _typeof2 = require("6909991043fbc889");
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

},{"6909991043fbc889":"awbNa"}],"awbNa":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _iterator = require("f41d4f4d4fa5a622");
var _iterator2 = _interopRequireDefault(_iterator);
var _symbol = require("ada2ef59a5a3c468");
var _symbol2 = _interopRequireDefault(_symbol);
var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
};
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function(obj) {
    return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

},{"f41d4f4d4fa5a622":"ll2AB","ada2ef59a5a3c468":"eZmFg"}],"ll2AB":[function(require,module,exports,__globalThis) {
module.exports = {
    "default": require("99c786451cb3b226"),
    __esModule: true
};

},{"99c786451cb3b226":"3sy50"}],"3sy50":[function(require,module,exports,__globalThis) {
require("1a15fec2bf9e462a");
require("44fab12c7f48cb5a");
module.exports = require("63a8ef4870abbb9e").f('iterator');

},{"1a15fec2bf9e462a":"5XI0m","44fab12c7f48cb5a":"hhBQV","63a8ef4870abbb9e":"jBByO"}],"5XI0m":[function(require,module,exports,__globalThis) {
'use strict';
var $at = require("fd0128b9f2bb8a53")(true);
// 21.1.3.27 String.prototype[@@iterator]()
require("c6c2e99102a76519")(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

},{"fd0128b9f2bb8a53":"7lGy5","c6c2e99102a76519":"eepH4"}],"7lGy5":[function(require,module,exports,__globalThis) {
var toInteger = require("316e7012a4906fda");
var defined = require("de149983fd56b03a");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

},{"316e7012a4906fda":"kyfse","de149983fd56b03a":"hKdlF"}],"eepH4":[function(require,module,exports,__globalThis) {
'use strict';
var LIBRARY = require("14048cc03af0d30b");
var $export = require("1dfaa17ce9861202");
var redefine = require("6da7df4fa026309f");
var hide = require("c013dbb8237630f8");
var Iterators = require("b4ebea208e44c71a");
var $iterCreate = require("2277bea253ca6b8e");
var setToStringTag = require("8c8ff0b8e14f62a");
var getPrototypeOf = require("c6b01c75d6d68f1f");
var ITERATOR = require("8a5349bf63ee4fa9")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';
var returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $iterCreate(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) hide(proto, ITERATOR, $default);
    // Plug for library
    Iterators[NAME] = $default;
    Iterators[TAG] = returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) redefine(proto, key, methods[key]);
        } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

},{"14048cc03af0d30b":"8JunI","1dfaa17ce9861202":"bsKmz","6da7df4fa026309f":"3Azmh","c013dbb8237630f8":"eskYQ","b4ebea208e44c71a":"bJDn2","2277bea253ca6b8e":"lnw7z","8c8ff0b8e14f62a":"k6M7K","c6b01c75d6d68f1f":"7bNF7","8a5349bf63ee4fa9":"Or7Y6"}],"3Azmh":[function(require,module,exports,__globalThis) {
module.exports = require("f5a8259258da204a");

},{"f5a8259258da204a":"eskYQ"}],"bJDn2":[function(require,module,exports,__globalThis) {
module.exports = {};

},{}],"lnw7z":[function(require,module,exports,__globalThis) {
'use strict';
var create = require("53993231ce7ded98");
var descriptor = require("74134f7e688c8f07");
var setToStringTag = require("78f29310d782740d");
var IteratorPrototype = {};
// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require("692a1580b5669c87")(IteratorPrototype, require("ccdd78d76684a40c")('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = create(IteratorPrototype, {
        next: descriptor(1, next)
    });
    setToStringTag(Constructor, NAME + ' Iterator');
};

},{"53993231ce7ded98":"lquoL","74134f7e688c8f07":"86DPB","78f29310d782740d":"k6M7K","692a1580b5669c87":"eskYQ","ccdd78d76684a40c":"Or7Y6"}],"lquoL":[function(require,module,exports,__globalThis) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require("f85f30583372f2a6");
var dPs = require("eeff72dd48c99bd0");
var enumBugKeys = require("6a9df5f4f7ddbe1f");
var IE_PROTO = require("6c4d65d43f83439f")('IE_PROTO');
var Empty = function() {};
var PROTOTYPE = 'prototype';
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = require("3947f28bd475b86e")('iframe');
    var i = enumBugKeys.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    require("8600c9eb6a77c3d5").appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    createDict = iframeDocument.F;
    while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
    return createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
    } else result = createDict();
    return Properties === undefined ? result : dPs(result, Properties);
};

},{"f85f30583372f2a6":"8MwMX","eeff72dd48c99bd0":"YvOcX","6a9df5f4f7ddbe1f":"bIv2C","6c4d65d43f83439f":"zyj5h","3947f28bd475b86e":"llxwK","8600c9eb6a77c3d5":"eo6A4"}],"YvOcX":[function(require,module,exports,__globalThis) {
var dP = require("d71511859d12323d");
var anObject = require("c244545dc20d5248");
var getKeys = require("63ba16ee905330e7");
module.exports = require("fad066faffc6a434") ? Object.defineProperties : function defineProperties(O, Properties) {
    anObject(O);
    var keys = getKeys(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)dP.f(O, P = keys[i++], Properties[P]);
    return O;
};

},{"d71511859d12323d":"klaXp","c244545dc20d5248":"8MwMX","63ba16ee905330e7":"kN8Bb","fad066faffc6a434":"bTSAE"}],"eo6A4":[function(require,module,exports,__globalThis) {
var document = require("6556298907cc555f").document;
module.exports = document && document.documentElement;

},{"6556298907cc555f":"J0G1X"}],"k6M7K":[function(require,module,exports,__globalThis) {
var def = require("ff59ef0d89124a06").f;
var has = require("d3eb7425de62ab7e");
var TAG = require("401c4d8724b23988")('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
        configurable: true,
        value: tag
    });
};

},{"ff59ef0d89124a06":"klaXp","d3eb7425de62ab7e":"i2e6o","401c4d8724b23988":"Or7Y6"}],"Or7Y6":[function(require,module,exports,__globalThis) {
var store = require("36be93b5c89fdfca")('wks');
var uid = require("2c0f9143ef9ce349");
var Symbol = require("e6bc0bb3737274f8").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';
var $exports = module.exports = function(name) {
    return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};
$exports.store = store;

},{"36be93b5c89fdfca":"eGtsx","2c0f9143ef9ce349":"DTsTg","e6bc0bb3737274f8":"J0G1X"}],"7bNF7":[function(require,module,exports,__globalThis) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require("1df8e1f12bd109b4");
var toObject = require("44a1dfe0775c58c5");
var IE_PROTO = require("6e5f45d208c4d70e")('IE_PROTO');
var ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = toObject(O);
    if (has(O, IE_PROTO)) return O[IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? ObjectProto : null;
};

},{"1df8e1f12bd109b4":"i2e6o","44a1dfe0775c58c5":"8alwK","6e5f45d208c4d70e":"zyj5h"}],"hhBQV":[function(require,module,exports,__globalThis) {
require("4bc8050c6063f6c2");
var global = require("eb7382c1cffea0b8");
var hide = require("3c8b561aaf46371c");
var Iterators = require("3cef1c71340bc75e");
var TO_STRING_TAG = require("ba9eb7929f0b0334")('toStringTag');
var DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var i = 0; i < DOMIterables.length; i++){
    var NAME = DOMIterables[i];
    var Collection = global[NAME];
    var proto = Collection && Collection.prototype;
    if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = Iterators.Array;
}

},{"4bc8050c6063f6c2":"6p6I8","eb7382c1cffea0b8":"J0G1X","3c8b561aaf46371c":"eskYQ","3cef1c71340bc75e":"bJDn2","ba9eb7929f0b0334":"Or7Y6"}],"6p6I8":[function(require,module,exports,__globalThis) {
'use strict';
var addToUnscopables = require("161c5699821bb2bf");
var step = require("313b7c392a33417b");
var Iterators = require("fd5107ae62cd47f6");
var toIObject = require("89dc584941f5b583");
// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require("71751229eac8cec0")(Array, 'Array', function(iterated, kind) {
    this._t = toIObject(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
    }
    if (kind == 'keys') return step(0, index);
    if (kind == 'values') return step(0, O[index]);
    return step(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"161c5699821bb2bf":"aAVjk","313b7c392a33417b":"dp2V5","fd5107ae62cd47f6":"bJDn2","89dc584941f5b583":"jkz41","71751229eac8cec0":"eepH4"}],"aAVjk":[function(require,module,exports,__globalThis) {
module.exports = function() {};

},{}],"dp2V5":[function(require,module,exports,__globalThis) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

},{}],"jBByO":[function(require,module,exports,__globalThis) {
exports.f = require("178d669ddb350832");

},{"178d669ddb350832":"Or7Y6"}],"eZmFg":[function(require,module,exports,__globalThis) {
module.exports = {
    "default": require("fe3e8125a566ee6"),
    __esModule: true
};

},{"fe3e8125a566ee6":"9OzBg"}],"9OzBg":[function(require,module,exports,__globalThis) {
require("aa79f63334f36070");
require("43919599a8778ebf");
require("ac6fac456b1e77dc");
require("9993a1f6cc01bcfc");
module.exports = require("8f514bfa06266a41").Symbol;

},{"aa79f63334f36070":"4PP5r","43919599a8778ebf":"3Dxp7","ac6fac456b1e77dc":"jFHR5","9993a1f6cc01bcfc":"kDDY6","8f514bfa06266a41":"kvzR0"}],"4PP5r":[function(require,module,exports,__globalThis) {
'use strict';
// ECMAScript 6 symbols shim
var global = require("d72706ef1fb631b3");
var has = require("952851ca2356e7ab");
var DESCRIPTORS = require("9fa09252511809a");
var $export = require("17bb6271fa182b99");
var redefine = require("17b51a83f025954a");
var META = require("235acc36cff13db5").KEY;
var $fails = require("ab471db9274d3430");
var shared = require("7d7cbd603a5eb9db");
var setToStringTag = require("fd508de37228b158");
var uid = require("21b6dde79388a37c");
var wks = require("ebdc9789dabaea15");
var wksExt = require("b09c6e00121ec8d9");
var wksDefine = require("91ba534180e2119e");
var enumKeys = require("443bd588bd5fe188");
var isArray = require("c7fd9424ba3532d3");
var anObject = require("e9b58aedc70e7def");
var isObject = require("837548188dc5f0ea");
var toObject = require("d576f6ef5091b5c9");
var toIObject = require("b30296f99d02c195");
var toPrimitive = require("abad484d65791c7");
var createDesc = require("79ab9ce76c9fdaa2");
var _create = require("ef927d3443436c5c");
var gOPNExt = require("b3bc926594b215eb");
var $GOPD = require("8b7c9e5893dd72d");
var $GOPS = require("c3e335a69fd660fa");
var $DP = require("142fc4d93d9b1f49");
var $keys = require("a169f650ada0045b");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function() {
    return _create(dP({}, 'a', {
        get: function() {
            return dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = gOPD(ObjectProto, key);
    if (protoDesc) delete ObjectProto[key];
    dP(it, key, D);
    if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;
var wrap = function(tag) {
    var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $Symbol;
};
var $defineProperty = function defineProperty(it, key, D) {
    if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
    anObject(it);
    key = toPrimitive(key, true);
    anObject(D);
    if (has(AllSymbols, key)) {
        if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
        } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, {
                enumerable: createDesc(0, false)
            });
        }
        return setSymbolDesc(it, key, D);
    }
    return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
    anObject(it);
    var keys = enumKeys(P = toIObject(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $create = function create(it, P) {
    return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = isEnum.call(this, key = toPrimitive(key, true));
    if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
    return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = toIObject(it);
    key = toPrimitive(key, true);
    if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
    var D = gOPD(it, key);
    if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
    return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = gOPN(toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
    return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === ObjectProto;
    var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
    return result;
};
// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
    $Symbol = function Symbol() {
        if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
        };
        if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return wrap(tag);
    };
    redefine($Symbol[PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $GOPD.f = $getOwnPropertyDescriptor;
    $DP.f = $defineProperty;
    require("e19f1a3d97757e48").f = gOPNExt.f = $getOwnPropertyNames;
    require("764cabcc177e27f1").f = $propertyIsEnumerable;
    $GOPS.f = $getOwnPropertySymbols;
    if (DESCRIPTORS && !require("380d4fcc2db56b0f")) redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
    wksExt.f = function(name) {
        return wrap(wks(name));
    };
}
$export($export.G + $export.W + $export.F * !USE_NATIVE, {
    Symbol: $Symbol
});
for(var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
for(var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;)wksDefine(wellKnownSymbols[k++]);
$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in SymbolRegistry)if (SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        setter = true;
    },
    useSimple: function() {
        setter = false;
    }
});
$export($export.S + $export.F * !USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function() {
    $GOPS.f(1);
});
$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $GOPS.f(toObject(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function() {
    var S = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return _stringify([
        S
    ]) != '[null]' || _stringify({
        a: S
    }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
        if (!isArray(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
        };
        args[1] = replacer;
        return _stringify.apply($JSON, args);
    }
});
// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require("8202c4432d84a39")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"d72706ef1fb631b3":"J0G1X","952851ca2356e7ab":"i2e6o","9fa09252511809a":"bTSAE","17bb6271fa182b99":"bsKmz","17b51a83f025954a":"3Azmh","235acc36cff13db5":"7PDRo","ab471db9274d3430":"cXu1J","7d7cbd603a5eb9db":"eGtsx","fd508de37228b158":"k6M7K","21b6dde79388a37c":"DTsTg","ebdc9789dabaea15":"Or7Y6","b09c6e00121ec8d9":"jBByO","91ba534180e2119e":"6KeT3","443bd588bd5fe188":"8yrUq","c7fd9424ba3532d3":"1jTC7","e9b58aedc70e7def":"8MwMX","837548188dc5f0ea":"hVOZ0","d576f6ef5091b5c9":"8alwK","b30296f99d02c195":"jkz41","abad484d65791c7":"pXwis","79ab9ce76c9fdaa2":"86DPB","ef927d3443436c5c":"lquoL","b3bc926594b215eb":"5wpy7","8b7c9e5893dd72d":"4geQJ","c3e335a69fd660fa":"972yt","142fc4d93d9b1f49":"klaXp","a169f650ada0045b":"kN8Bb","e19f1a3d97757e48":"le2ZW","764cabcc177e27f1":"5Bp1g","380d4fcc2db56b0f":"8JunI","8202c4432d84a39":"eskYQ"}],"7PDRo":[function(require,module,exports,__globalThis) {
var META = require("4094e2173a0b3baa")('meta');
var isObject = require("94c531a5969ddce7");
var has = require("65233ceaafbf2a3e");
var setDesc = require("5d09e4283634b4f9").f;
var id = 0;
var isExtensible = Object.isExtensible || function() {
    return true;
};
var FREEZE = !require("f451fa9aa3e479c9")(function() {
    return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it) {
    setDesc(it, META, {
        value: {
            i: 'O' + ++id,
            w: {} // weak collections IDs
        }
    });
};
var fastKey = function(it, create) {
    // return primitive with prefix
    if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        setMeta(it);
    // return object ID
    }
    return it[META].i;
};
var getWeak = function(it, create) {
    if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMeta(it);
    // return hash weak collections IDs
    }
    return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it) {
    if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
    return it;
};
var meta = module.exports = {
    KEY: META,
    NEED: false,
    fastKey: fastKey,
    getWeak: getWeak,
    onFreeze: onFreeze
};

},{"4094e2173a0b3baa":"DTsTg","94c531a5969ddce7":"hVOZ0","65233ceaafbf2a3e":"i2e6o","5d09e4283634b4f9":"klaXp","f451fa9aa3e479c9":"cXu1J"}],"6KeT3":[function(require,module,exports,__globalThis) {
var global = require("3e7196fe431444a6");
var core = require("fe89e2d758160c87");
var LIBRARY = require("d02c788a971c3f2a");
var wksExt = require("de30b8fab6af28dc");
var defineProperty = require("9449d1c32a7627ef").f;
module.exports = function(name) {
    var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
        value: wksExt.f(name)
    });
};

},{"3e7196fe431444a6":"J0G1X","fe89e2d758160c87":"kvzR0","d02c788a971c3f2a":"8JunI","de30b8fab6af28dc":"jBByO","9449d1c32a7627ef":"klaXp"}],"8yrUq":[function(require,module,exports,__globalThis) {
// all enumerable object keys, includes symbols
var getKeys = require("2a7da628577defe1");
var gOPS = require("2c87ea16ec3e0846");
var pIE = require("22f27c489c6ca321");
module.exports = function(it) {
    var result = getKeys(it);
    var getSymbols = gOPS.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = pIE.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

},{"2a7da628577defe1":"kN8Bb","2c87ea16ec3e0846":"972yt","22f27c489c6ca321":"5Bp1g"}],"1jTC7":[function(require,module,exports,__globalThis) {
// 7.2.2 IsArray(argument)
var cof = require("e7143516ed3d2008");
module.exports = Array.isArray || function isArray(arg) {
    return cof(arg) == 'Array';
};

},{"e7143516ed3d2008":"jkpqx"}],"5wpy7":[function(require,module,exports,__globalThis) {
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require("f72f0c57334ff457");
var gOPN = require("63f529473f971c53").f;
var toString = {}.toString;
var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
    try {
        return gOPN(it);
    } catch (e) {
        return windowNames.slice();
    }
};
module.exports.f = function getOwnPropertyNames(it) {
    return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"f72f0c57334ff457":"jkz41","63f529473f971c53":"le2ZW"}],"le2ZW":[function(require,module,exports,__globalThis) {
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require("4989225242a0df15");
var hiddenKeys = require("12286d6eca04ff98").concat('length', 'prototype');
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $keys(O, hiddenKeys);
};

},{"4989225242a0df15":"1VCKl","12286d6eca04ff98":"bIv2C"}],"4geQJ":[function(require,module,exports,__globalThis) {
var pIE = require("1d5024d1c3af8647");
var createDesc = require("4332f0d7f68fb7e3");
var toIObject = require("d57e7c86b48e5166");
var toPrimitive = require("fd9927b774e43ef6");
var has = require("ecc6666e1030b05d");
var IE8_DOM_DEFINE = require("d8c7d7147316da26");
var gOPD = Object.getOwnPropertyDescriptor;
exports.f = require("5294c0b9bcde61e3") ? gOPD : function getOwnPropertyDescriptor(O, P) {
    O = toIObject(O);
    P = toPrimitive(P, true);
    if (IE8_DOM_DEFINE) try {
        return gOPD(O, P);
    } catch (e) {}
    if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"1d5024d1c3af8647":"5Bp1g","4332f0d7f68fb7e3":"86DPB","d57e7c86b48e5166":"jkz41","fd9927b774e43ef6":"pXwis","ecc6666e1030b05d":"i2e6o","d8c7d7147316da26":"gD2QD","5294c0b9bcde61e3":"bTSAE"}],"3Dxp7":[function(require,module,exports,__globalThis) {

},{}],"jFHR5":[function(require,module,exports,__globalThis) {
require("80348e827991c47b")('asyncIterator');

},{"80348e827991c47b":"6KeT3"}],"kDDY6":[function(require,module,exports,__globalThis) {
require("1941cb30109dd323")('observable');

},{"1941cb30109dd323":"6KeT3"}],"fF87n":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
var _setPrototypeOf = require("87c1bc7f6799a236");
var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
var _create = require("dc63738af576b854");
var _create2 = _interopRequireDefault(_create);
var _typeof2 = require("8745ca6044ab5fb2");
var _typeof3 = _interopRequireDefault(_typeof2);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
    subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

},{"87c1bc7f6799a236":"aGRyU","dc63738af576b854":"3SaiA","8745ca6044ab5fb2":"awbNa"}],"aGRyU":[function(require,module,exports,__globalThis) {
module.exports = {
    "default": require("641ca3718ec7174b"),
    __esModule: true
};

},{"641ca3718ec7174b":"fLmQK"}],"fLmQK":[function(require,module,exports,__globalThis) {
require("cd44b85ba2424e36");
module.exports = require("134099f418b233c9").Object.setPrototypeOf;

},{"cd44b85ba2424e36":"3hLos","134099f418b233c9":"kvzR0"}],"3hLos":[function(require,module,exports,__globalThis) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require("461062b1a80bb505");
$export($export.S, 'Object', {
    setPrototypeOf: require("f7b070f10ab2cf95").set
});

},{"461062b1a80bb505":"bsKmz","f7b070f10ab2cf95":"gP96d"}],"gP96d":[function(require,module,exports,__globalThis) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ var isObject = require("f66e69e7c0dd64af");
var anObject = require("db3ccd30cf506065");
var check = function(O, proto) {
    anObject(O);
    if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = require("54ebc7a28a983840")(Function.call, require("f33c4f724ac37970").f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: check
};

},{"f66e69e7c0dd64af":"hVOZ0","db3ccd30cf506065":"8MwMX","54ebc7a28a983840":"7uq48","f33c4f724ac37970":"4geQJ"}],"3SaiA":[function(require,module,exports,__globalThis) {
module.exports = {
    "default": require("6eee693993964e86"),
    __esModule: true
};

},{"6eee693993964e86":"iZOTB"}],"iZOTB":[function(require,module,exports,__globalThis) {
require("f9f242f44211de72");
var $Object = require("6eb10600ab072eb5").Object;
module.exports = function create(P, D) {
    return $Object.create(P, D);
};

},{"f9f242f44211de72":"8UBKi","6eb10600ab072eb5":"kvzR0"}],"8UBKi":[function(require,module,exports,__globalThis) {
var $export = require("ba68d4349394bfcf");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {
    create: require("61bcbcda72ffc053")
});

},{"ba68d4349394bfcf":"bsKmz","61bcbcda72ffc053":"lquoL"}],"eucZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defineProperty = require("babel-runtime/helpers/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var Pager = function Pager(props) {
    var _classNames;
    var prefixCls = props.rootPrefixCls + '-item';
    var cls = (0, _classnamesDefault.default)(prefixCls, prefixCls + '-' + props.page, (_classNames = {}, (0, _definePropertyDefault.default)(_classNames, prefixCls + '-active', props.active), (0, _definePropertyDefault.default)(_classNames, props.className, !!props.className), (0, _definePropertyDefault.default)(_classNames, prefixCls + '-disabled', !props.page), _classNames));
    var handleClick = function handleClick() {
        props.onClick(props.page);
    };
    var handleKeyPress = function handleKeyPress(e) {
        props.onKeyPress(e, props.onClick, props.page);
    };
    return (0, _reactDefault.default).createElement('li', {
        title: props.showTitle ? props.page : null,
        className: cls,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        tabIndex: '0'
    }, props.itemRender(props.page, 'page', (0, _reactDefault.default).createElement('a', null, props.page)));
};
Pager.propTypes = {
    page: (0, _propTypesDefault.default).number,
    active: (0, _propTypesDefault.default).bool,
    last: (0, _propTypesDefault.default).bool,
    locale: (0, _propTypesDefault.default).object,
    className: (0, _propTypesDefault.default).string,
    showTitle: (0, _propTypesDefault.default).bool,
    rootPrefixCls: (0, _propTypesDefault.default).string,
    onClick: (0, _propTypesDefault.default).func,
    onKeyPress: (0, _propTypesDefault.default).func,
    itemRender: (0, _propTypesDefault.default).func
};
exports.default = Pager;

},{"babel-runtime/helpers/defineProperty":"bro4R","react":"9njXz","prop-types":"bnNSm","classnames":"5Een2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nJRv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("babel-runtime/helpers/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("babel-runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _possibleConstructorReturn = require("babel-runtime/helpers/possibleConstructorReturn");
var _possibleConstructorReturnDefault = parcelHelpers.interopDefault(_possibleConstructorReturn);
var _inherits = require("babel-runtime/helpers/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _keyCode = require("./KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var Options = function(_React$Component) {
    (0, _inheritsDefault.default)(Options, _React$Component);
    function Options() {
        var _ref;
        var _temp, _this, _ret;
        (0, _classCallCheckDefault.default)(this, Options);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, _possibleConstructorReturnDefault.default)(this, (_ref = Options.__proto__ || Object.getPrototypeOf(Options)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            goInputText: ''
        }, _this.buildOptionText = function(value) {
            return value + ' ' + _this.props.locale.items_per_page;
        }, _this.changeSize = function(value) {
            _this.props.changeSize(Number(value));
        }, _this.handleChange = function(e) {
            _this.setState({
                goInputText: e.target.value
            });
        }, _this.handleBlur = function(e) {
            var _this$props = _this.props, goButton = _this$props.goButton, quickGo = _this$props.quickGo, rootPrefixCls = _this$props.rootPrefixCls;
            if (goButton) return;
            if (e.relatedTarget && (e.relatedTarget.className.indexOf(rootPrefixCls + '-prev') >= 0 || e.relatedTarget.className.indexOf(rootPrefixCls + '-next') >= 0)) return;
            quickGo(_this.getValidValue());
        }, _this.go = function(e) {
            var goInputText = _this.state.goInputText;
            if (goInputText === '') return;
            if (e.keyCode === (0, _keyCodeDefault.default).ENTER || e.type === 'click') {
                _this.setState({
                    goInputText: ''
                });
                _this.props.quickGo(_this.getValidValue());
            }
        }, _temp), (0, _possibleConstructorReturnDefault.default)(_this, _ret);
    }
    (0, _createClassDefault.default)(Options, [
        {
            key: 'getValidValue',
            value: function getValidValue() {
                var _state = this.state, goInputText = _state.goInputText, current = _state.current;
                return !goInputText || isNaN(goInputText) ? current : Number(goInputText);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this2 = this;
                var _props = this.props, pageSize = _props.pageSize, pageSizeOptions = _props.pageSizeOptions, locale = _props.locale, rootPrefixCls = _props.rootPrefixCls, changeSize = _props.changeSize, quickGo = _props.quickGo, goButton = _props.goButton, selectComponentClass = _props.selectComponentClass, buildOptionText = _props.buildOptionText, selectPrefixCls = _props.selectPrefixCls, disabled = _props.disabled;
                var goInputText = this.state.goInputText;
                var prefixCls = rootPrefixCls + '-options';
                var Select = selectComponentClass;
                var changeSelect = null;
                var goInput = null;
                var gotoButton = null;
                if (!changeSize && !quickGo) return null;
                if (changeSize && Select) {
                    var options = pageSizeOptions.map(function(opt, i) {
                        return (0, _reactDefault.default).createElement(Select.Option, {
                            key: i,
                            value: opt
                        }, (buildOptionText || _this2.buildOptionText)(opt));
                    });
                    changeSelect = (0, _reactDefault.default).createElement(Select, {
                        disabled: disabled,
                        prefixCls: selectPrefixCls,
                        showSearch: false,
                        className: prefixCls + '-size-changer',
                        optionLabelProp: 'children',
                        dropdownMatchSelectWidth: false,
                        value: (pageSize || pageSizeOptions[0]).toString(),
                        onChange: this.changeSize,
                        getPopupContainer: function getPopupContainer(triggerNode) {
                            return triggerNode.parentNode;
                        }
                    }, options);
                }
                if (quickGo) {
                    if (goButton) gotoButton = typeof goButton === 'boolean' ? (0, _reactDefault.default).createElement('button', {
                        type: 'button',
                        onClick: this.go,
                        onKeyUp: this.go,
                        disabled: disabled
                    }, locale.jump_to_confirm) : (0, _reactDefault.default).createElement('span', {
                        onClick: this.go,
                        onKeyUp: this.go
                    }, goButton);
                    goInput = (0, _reactDefault.default).createElement('div', {
                        className: prefixCls + '-quick-jumper'
                    }, locale.jump_to, (0, _reactDefault.default).createElement('input', {
                        disabled: disabled,
                        type: 'text',
                        value: goInputText,
                        onChange: this.handleChange,
                        onKeyUp: this.go,
                        onBlur: this.handleBlur
                    }), locale.page, gotoButton);
                }
                return (0, _reactDefault.default).createElement('li', {
                    className: '' + prefixCls
                }, changeSelect, goInput);
            }
        }
    ]);
    return Options;
}((0, _reactDefault.default).Component);
Options.propTypes = {
    disabled: (0, _propTypesDefault.default).bool,
    changeSize: (0, _propTypesDefault.default).func,
    quickGo: (0, _propTypesDefault.default).func,
    selectComponentClass: (0, _propTypesDefault.default).func,
    current: (0, _propTypesDefault.default).number,
    pageSizeOptions: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    pageSize: (0, _propTypesDefault.default).number,
    buildOptionText: (0, _propTypesDefault.default).func,
    locale: (0, _propTypesDefault.default).object,
    rootPrefixCls: (0, _propTypesDefault.default).string,
    selectPrefixCls: (0, _propTypesDefault.default).string,
    goButton: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).node
    ])
};
Options.defaultProps = {
    pageSizeOptions: [
        '10',
        '20',
        '30',
        '40'
    ]
};
exports.default = Options;

},{"babel-runtime/helpers/classCallCheck":"cezzA","babel-runtime/helpers/createClass":"3I5b9","babel-runtime/helpers/possibleConstructorReturn":"HSCB8","babel-runtime/helpers/inherits":"fF87n","react":"9njXz","prop-types":"bnNSm","./KeyCode":"d7joq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d7joq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    ZERO: 48,
    NINE: 57,
    NUMPAD_ZERO: 96,
    NUMPAD_NINE: 105,
    BACKSPACE: 8,
    DELETE: 46,
    ENTER: 13,
    ARROW_UP: 38,
    ARROW_DOWN: 40
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cNTSy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    // Options.jsx
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination.jsx
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lhVpQ":[function() {},{}],"cBKcj":[function() {},{}],"b3b6W":[function() {},{}],"bdobw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Monitoring);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("teacher/context");
var _monitoringStyl = require("./monitoring.styl");
var _monitoring = require("components/monitoring");
var _monitoringDefault = parcelHelpers.interopDefault(_monitoring);
function Monitoring() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { section, link } = context;
    const Element = (0, _react.useMemo)(()=>(0, _monitoringDefault.default)[section], [
        section
    ]);
    return Element ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `${section}-container`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {})
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
        to: link({
            section: 'groups'
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","teacher/context":"5LKDx","./monitoring.styl":"3Og4J","components/monitoring":"4j5ON","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Og4J":[function() {},{}],"4j5ON":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>views);
var _groups = require("./components/groups");
var _groupsDefault = parcelHelpers.interopDefault(_groups);
var _students = require("./components/students");
var _studentsDefault = parcelHelpers.interopDefault(_students);
var _student = require("./components/student");
var _studentDefault = parcelHelpers.interopDefault(_student);
const views = {
    groups: (0, _groupsDefault.default),
    students: (0, _studentsDefault.default),
    student: (0, _studentDefault.default)
};

},{"./components/groups":"j8IPw","./components/students":"cfRnt","./components/student":"amokD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8IPw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Groups);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styles = require("@mui/material/styles");
var _lodash = require("lodash");
var _context = require("teacher/context");
var _searchPattern = require("../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _group = require("./Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _studentCount = require("./StudentCount");
var _studentCountDefault = parcelHelpers.interopDefault(_studentCount);
const StyledMonitoringGroups = (0, _styles.styled)('div')(monitoringGroupStyles);
function Groups() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { groups, translate } = context;
    const columnCount = Math.floor(context.sizes.width / 342);
    const missingCount = context.groups.length % columnCount;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMonitoringGroups, {
        className: "monitoring groups",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "filters",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "filler"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentCountDefault.default), {
                        groups: groups,
                        translate: translate
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "groups",
                        children: [
                            groups.map((group, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                                    ...group
                                }, i)),
                            (0, _lodash.range)(columnCount - missingCount).map((i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "filler",
                                    style: {
                                        width: 342
                                    }
                                }, i))
                        ]
                    })
                ]
            })
        ]
    });
}
function monitoringGroupStyles() {
    return {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        padding: '10px 20px',
        "& .filters": {
            display: 'flex',
            padding: '13px 0 20px 0',
            color: '#a9b1b6',
            '.filler': {
                flexGrow: 1
            }
        },
        "& > .content": {
            overflowY: 'hidden',
            color: '#4e576e',
            flexGrow: 1,
            borderRadius: 3,
            backgroundColor: '#fff',
            border: 'solid 1px #dfdfdf',
            display: 'flex',
            flexDirection: 'column',
            "& > .student-count": {
                borderBottom: 'solid 1px #e7edf0',
                padding: '10px 20px',
                display: 'flex',
                "& .icon": {
                    color: '#78a7ff',
                    fontSize: '15pt'
                },
                "& .count": {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    textTransform: 'lowercase',
                    padding: '0 20px 0 8px',
                    borderRight: 'solid 1px #e7edf0'
                }
            },
            "& > .groups": {
                padding: 20,
                display: 'flex',
                overflowY: 'scroll',
                justifyContent: 'space-evenly',
                flexWrap: 'wrap',
                "& .group": {
                    borderRadius: 8,
                    border: 'solid 1px #ced3e0',
                    height: 60,
                    width: 300,
                    padding: '10px 20px',
                    marginBottom: '20px',
                    display: 'flex',
                    "&:hover": {
                        transform: 'scale(1.03)'
                    },
                    "& .group-link": {
                        cursor: 'pointer',
                        flexGrow: 1,
                        display: 'flex',
                        textDecoration: 'none',
                        "& .icon-wrapper": {
                            backgroundColor: '#fff',
                            border: '1px solid #d8e8fb',
                            borderRadius: '50%',
                            height: 56,
                            width: 56,
                            padding: 2,
                            "& .icon": {
                                height: 20,
                                width: 20,
                                borderRadius: '50%',
                                fontSize: '18pt',
                                display: 'flex',
                                backgroundColor: '#e6f2ff',
                                padding: 18,
                                justifyContent: 'center',
                                color: '#c54ebf'
                            }
                        },
                        "& .label": {
                            color: '#4e576e',
                            flexGrow: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            paddingLeft: 25,
                            "& .name": {
                                fontWeight: 'bold',
                                fontSize: '11pt'
                            },
                            "& .count": {
                                paddingTop: 1,
                                textTransform: 'lowercase',
                                fontSize: '9.5pt'
                            }
                        }
                    }
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/styles":"c9RfU","lodash":"1qc47","teacher/context":"5LKDx","../search-pattern":"6JKgm","./Group":"02Pe4","./StudentCount":"irnl6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6JKgm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchPattern);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("teacher/context");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _searchPatternStyl = require("./search-pattern.styl");
const monitoringPath = (path)=>`/:languageId/:role/monitoring/${path}`;
function SearchPattern({ searchPlaceholder, initialPattern }) {
    const [pattern, setPattern] = (0, _react.useState)(initialPattern || '');
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    const searchContext = (0, _lodash.pick)(context, [
        'match',
        'navigate',
        'section',
        'groupId'
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "pattern filter",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "wrapper",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faSearch)
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    value: pattern,
                    placeholder: searchPlaceholder,
                    onChange: (e)=>setPattern(e.target.value),
                    onKeyDown: ({ key })=>key == 'Enter' && searchPattern({
                            ...searchContext,
                            pattern
                        })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "button",
                    onClick: ()=>searchPattern({
                            ...searchContext,
                            pattern
                        }),
                    children: translate("go_label")
                })
            ]
        })
    });
}
function searchPath({ match, section }) {
    return section == 'groups' ? monitoringPath('students') : match.path;
}
function searchPattern(context) {
    const { navigate, pattern } = context;
    const query = {
        pattern: pattern == '' ? undefined : pattern
    };
    const path = searchPath(context);
    navigate({}, path, {
        preserveQuery: true,
        query
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","teacher/context":"5LKDx","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./search-pattern.styl":"dV9Yi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dV9Yi":[function() {},{}],"02Pe4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Group);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _label = require("components/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _context = require("teacher/context");
function Group(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, link } = context;
    const { name, students, id } = props;
    const studentCount = students.length;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "group",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
            className: "group-link",
            to: link({
                groupId: id
            }, '/:languageId/:role/:page/:groupId/students', {
                preserveQuery: true
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "icon-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faUsers)
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "label",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "name",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
                                value: name,
                                maxLength: 25
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "count",
                            children: [
                                studentCount,
                                " ",
                                translate(`student${studentCount == 1 ? '' : 's'}_label`)
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","components/label":"59910","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"irnl6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentCount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
function StudentCount({ groups, translate }) {
    const studentCount = groups.reduce((count, group)=>count + group.students.length, 0);
    console.log(studentCount);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "student-count",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "icon",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faUser)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "count",
                children: [
                    studentCount,
                    " ",
                    translate(`student${studentCount == 1 ? '' : 's'}_label`)
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cfRnt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Students);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../../context");
var _searchPattern = require("../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _table = require("./table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _filter = require("./filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _backButtonStyl = require("../../../back-button/back-button.styl");
var _studentsStyl = require("./students.styl");
function Students() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const backPath = context.link({}, "/:languageId/:role/:page/groups", {
                preserveQuery: false
            });
            const notDownloaded = context.query.notDownloaded == 'true';
            const changeNotDownloaded = (e)=>{
                const query = {
                    notDownloaded: !notDownloaded || undefined,
                    page: undefined
                };
                context.navigate({}, context.match.path, {
                    preserveQuery: true,
                    query
                });
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "monitoring students",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filters",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        className: "back-button",
                                        to: backPath
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "filler"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                                        initialPattern: context.query.pattern || ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filters",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "head",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faFilter)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "filters_label"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "not-downloaded",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "checkbox",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "checkbox",
                                                checked: notDownloaded,
                                                onChange: changeNotDownloaded
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "label",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "not_downloaded_label"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","../../../../context":"iUP37","../search-pattern":"6JKgm","./table":"6Od0a","./filter":"5NQIF","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../back-button/back-button.styl":"6XlSQ","./students.styl":"acRtD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Od0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _context = require("../../../../context");
var _utils = require("../../../../helpers/utils");
var _label = require("../../../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _contextLoader = require("../../../context-loader");
var _contextLoaderDefault = parcelHelpers.interopDefault(_contextLoader);
var _pagination = require("../../../pagination");
var _tableStyl = require("./table.styl");
function Containerless(props) {
    const { TableBody } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableBody, {});
}
const CustomTableBody = ({ rowIds, Row, style, className })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: style,
        className: className,
        children: rowIds && rowIds.map((r)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Row, {
                griddleKey: r
            }, r))
    });
const StudentRow = (0, _utils.enhancedWithRowData)(({ rowData })=>{
    const { name, downloadCount, groups, studentId, fillerIndex } = rowData;
    if (fillerIndex != undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "filler",
        style: {
            width: 342
        }
    });
    else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const groupId = context.groupId;
            const query = {
                page: undefined
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "student",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    className: "student-link",
                    to: context.link({
                        studentId,
                        groupId
                    }, '/:languageId/:role/:page/:groupId?/student/:studentId', {
                        preserveQuery: true,
                        query
                    }),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faUser)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "label",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "name",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
                                        value: name,
                                        maxLength: 25
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "count",
                                    children: [
                                        downloadCount,
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: `download${downloadCount == 1 ? '' : 's'}_label`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "groups",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "label",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "groups_label"
                                                }),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "value",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
                                                value: groups.map((0, _utils.get)('name')).join(', '),
                                                maxLength: 37
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            });
        }
    });
});
function Filter(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const [pageProperties, ...students] = context.studentsDownloadLog;
            const group = context.groups.find(({ id })=>id == context.groupId);
            const { recordCount } = pageProperties || {};
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "info",
                children: [
                    group && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "group-name",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faUsers)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "name-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "name",
                                    children: group.name
                                })
                            })
                        ]
                    }),
                    recordCount !== undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "student-count",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faUser)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "count",
                                children: [
                                    recordCount,
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: `student${recordCount == 1 ? '' : 's'}_label`
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}
const Layout = ({ Table, Pagination, Filter })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "students-download-log-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
        ]
    });
};
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "catalog_search_no_results_label"
        })
    });
}
class Students extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        (0, _utils.bind)(this, 'goPage', 'goNext', 'goPrevious');
    }
    goPage(page) {
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                page
            }
        });
    }
    goNext() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage + 1);
    }
    goPrevious() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage - 1);
    }
    render() {
        const context = this.context;
        const [pageProperties, ...students] = context.studentsDownloadLog;
        const columnCount = Math.floor((context.sizes.width - 220) / 342) % 342;
        const missingCount = students.length % columnCount;
        const fillers = (0, _lodash.range)(columnCount - missingCount).map((fillerIndex)=>({
                fillerIndex
            }));
        const { recordCount } = pageProperties || {};
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextLoaderDefault.default), {
            id: "studentsDownloadLog",
            className: "students-download-log",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                className: "students-download-log-results",
                data: students.concat(fillers),
                components: {
                    NoResults,
                    PageDropdown: (0, _pagination.PageDropdown),
                    Filter,
                    Pagination: (0, _pagination.Pagination),
                    Layout,
                    Row: StudentRow,
                    Table: Containerless,
                    TableBody: CustomTableBody
                },
                pageProperties: pageProperties,
                events: {
                    onNext: this.goNext,
                    onPrevious: this.goPrevious,
                    onGetPage: this.goPage
                }
            })
        });
    }
}
exports.default = Students;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","griddle-react":"6zdUV","../../../../context":"iUP37","../../../../helpers/utils":"gGc98","../../../label":"59910","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../context-loader":"ktxlD","../../../pagination":"82vF6","./table.styl":"c1XqV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c1XqV":[function() {},{}],"5NQIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _context = require("../../../../context");
function SelectFilter(props) {
    const className = `select-${props.name}`;
    const selectProps = (0, _lodash.omit)(props, [
        'name'
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "dropdown",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                ...selectProps,
                className: className,
                classNamePrefix: "select",
                isSearchable: false,
                isClearable: true,
                escapeClearsValue: true,
                getOptionValue: ({ id })=>id,
                value: props.value
            })
        })
    });
}
function onGroup(context) {
    return (option)=>{
        const { id } = option || {};
        const query = {
            page: undefined,
            unit: undefined,
            lesson: undefined
        };
        context.navigate({
            groupId: id
        }, '/:languageId/:role/monitoring/:groupId?/students', {
            preserveQuery: true,
            query
        });
    };
}
function onUnit(context) {
    return (option)=>{
        const { id: unit } = option || {};
        const query = {
            unit,
            page: undefined,
            lesson: undefined
        };
        context.navigate({}, context.match.path, {
            preserveQuery: true,
            query
        });
    };
}
function onLesson(context) {
    return (option)=>{
        const { id: lesson } = option || {};
        const query = {
            lesson,
            page: undefined
        };
        context.navigate({}, context.match.path, {
            preserveQuery: true,
            query
        });
    };
}
function Filters() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const placeholder = (name)=>context.translate(`${name}_filters_placeholder`);
            const { downloadLogFilters: groups = [] } = context;
            const group = groups.find((group)=>group.id == context.groupId);
            const units = group ? (0, _lodash.orderBy)(group.units, [
                'id'
            ]) : [];
            const unit = units.find((unit)=>unit.id == context.query.unit);
            const lessons = unit ? (0, _lodash.orderBy)(unit.lessons, [
                'id'
            ]) : [];
            const lesson = lessons.find((lesson)=>lesson.id == context.query.lesson);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "select-filters",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "group filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "group_label"
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                                name: "group",
                                options: groups,
                                value: group || null,
                                getOptionLabel: (item)=>item.name,
                                onChange: onGroup(context)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "unit filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "unit_label"
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                                name: "unit",
                                options: units,
                                value: unit || null,
                                getOptionLabel: (item)=>`${item.id.substring(8, 10)} - ${item.name}`,
                                onChange: onUnit(context)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lesson filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "lesson_label"
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                                name: "lesson",
                                options: lessons,
                                value: lesson || null,
                                getOptionLabel: (item)=>`${item.id.substring(11, 13)} - ${item.name}`,
                                onChange: onLesson(context)
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","react-select":"j36cq","../../../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XlSQ":[function() {},{}],"acRtD":[function() {},{}],"amokD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Students);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../../context");
var _searchPattern = require("../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _table = require("./table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _filter = require("./filter");
var _filterDefault = parcelHelpers.interopDefault(_filter);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _backButtonStyl = require("components/back-button/back-button.styl");
var _studentStyl = require("./student.styl");
function backPath(context) {
    const path = context.groupId;
}
function Students() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { groupId, studentId } = context;
            const query = {
                page: undefined
            };
            const backPath = context.link({
                groupId
            }, "/:languageId/:role/monitoring/:groupId?/students", {
                preserveQuery: true,
                query
            });
            const notDownloaded = context.query.notDownloaded == 'true';
            const changeNotDownloaded = (e)=>{
                const query = {
                    notDownloaded: !notDownloaded || undefined,
                    page: undefined
                };
                context.navigate({}, context.match.path, {
                    preserveQuery: true,
                    query
                });
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "monitoring student",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filters",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        className: "back-button",
                                        to: backPath
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "filler"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                                        initialPattern: context.query.pattern || ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filters",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "head",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faFilter)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "filters_label"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "not-downloaded",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "checkbox",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "checkbox",
                                                checked: notDownloaded,
                                                onChange: changeNotDownloaded
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "label",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "not_downloaded_label"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","../../../../context":"iUP37","../search-pattern":"6JKgm","./table":"dB1qI","./filter":"7qVcy","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","components/back-button/back-button.styl":"6XlSQ","./student.styl":"97mWo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dB1qI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _context = require("../../../../context");
var _utils = require("helpers/utils");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _contextLoader = require("../../../context-loader");
var _contextLoaderDefault = parcelHelpers.interopDefault(_contextLoader);
var _pagination = require("../../../pagination");
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _tableStyl = require("./table.styl");
const { columns, headers } = (0, _columnsDefault.default);
function Filter(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const group = context.groups.find(({ id })=>id == context.groupId);
            const student = context.students[context.studentId];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "info",
                children: [
                    group && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "group-name",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faUsers)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "name-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "name",
                                    children: group.name
                                })
                            })
                        ]
                    }),
                    student && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "student-name",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faUser)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "name",
                                children: student.name
                            })
                        ]
                    })
                ]
            });
        }
    });
}
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "catalog_search_no_results_label"
        })
    });
}
const Layout = ({ Table, Pagination, Filter })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "download-log-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
        ]
    });
class Student extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        (0, _utils.bind)(this, 'goPage', 'goNext', 'goPrevious', 'sort');
    }
    goPage(page) {
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                page
            }
        });
    }
    goNext() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage + 1);
    }
    goPrevious() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage - 1);
    }
    sort({ id, sortAscending }) {
        const orderBy = `${sortAscending ? '' : '-'}${id}`;
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                orderBy
            }
        });
    }
    render() {
        const context = this.context;
        const [pageProperties, ...log] = context.downloadLog;
        const groups = context.downloadLogFilters.reduce((gs, g)=>{
            gs[g.id] = g;
            return gs;
        }, {});
        const downloadLog = log.map((o)=>({
                ...o,
                group: groups[o.group],
                lesson: context.lessonLogTitles[o.title]
            }));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextLoaderDefault.default), {
            id: "downloadLog",
            className: "download-log",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "download-log-results",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                    data: downloadLog,
                    components: {
                        NoResults,
                        PageDropdown: (0, _pagination.PageDropdown),
                        Pagination: (0, _pagination.Pagination),
                        Layout,
                        Filter
                    },
                    pageProperties: pageProperties,
                    events: {
                        onNext: this.goNext,
                        onPrevious: this.goPrevious,
                        onGetPage: this.goPage,
                        onSort: this.sort
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                id: "groupName",
                                customHeadingComponent: headers.DownloadLogHeader,
                                customComponent: columns.GroupColumn
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                id: "title",
                                customHeadingComponent: headers.DownloadLogHeader,
                                customComponent: columns.LessonColumn
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                id: "start",
                                customHeadingComponent: headers.DownloadLogHeader,
                                customComponent: columns.StartColumn
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                id: "firstDownload",
                                customHeadingComponent: headers.DownloadLogHeader,
                                customComponent: columns.FirstDownloadColumn
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                id: "onlineViews",
                                customHeadingComponent: headers.DownloadLogHeader,
                                customComponent: columns.OnlineViewsColumn
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                id: "downloadCount",
                                customHeadingComponent: headers.DownloadLogHeader,
                                customComponent: columns.DownloadCountColumn
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                id: "links",
                                customHeadingComponent: headers.EmptyHeader,
                                customComponent: columns.DownloadLinksColumn
                            })
                        ]
                    })
                })
            })
        });
    }
}
exports.default = Student;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","griddle-react":"6zdUV","../../../../context":"iUP37","helpers/utils":"gGc98","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../context-loader":"ktxlD","../../../pagination":"82vF6","./columns":"85LwK","./table.styl":"kmvXm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"85LwK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _url = require("helpers/url");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _label = require("components/label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _icon = require("components/icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _utils = require("helpers/utils");
var _context = require("teacher/context");
function DownloadLogHeader({ sortColumns, title }) {
    const { translate } = (0, _react.useContext)((0, _context.TeacherContext));
    const active = sortColumns && sortColumns.id == title;
    const direction = active ? sortColumns.sortAscending ? 'ascending' : 'descending' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "sorted-column-wrapper",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: direction
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: translate(`${title}_download_log_header`)
            })
        ]
    });
}
function EmptyHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
}
function LabelColumn(maxLength) {
    return ({ value })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
            value,
            maxLength
        });
    };
}
function GroupColumn({ rowData }) {
    const { group } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: group && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
            value: group.name,
            maxLength: 30
        })
    });
}
function DownloadLinksColumn({ rowData }) {
    const { stamps, lesson = {} } = rowData;
    const { translate, languageId } = (0, _react.useContext)((0, _context.TeacherContext));
    const title = stamps.map((s)=>(0, _momentDefault.default)(s).format('MM/DD/YYYY, hh:mm a')).join(`
`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "links",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "lesson-link",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    title: title,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        name: "schedule"
                    })
                })
            }),
            !lesson.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "lesson-preview",
                style: {
                    visibility: 'hidden'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    target: "_blank",
                    href: "#",
                    title: translate('preview_tooltip_title'),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        name: "preview"
                    })
                })
            }),
            lesson.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "lesson-preview",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                    ...(0, _url.viewerGuard)({
                        target: "_blank",
                        href: (0, _url.subdomainLink)('preview', '#', languageId, 'lesson', lesson.id)
                    }),
                    title: translate('preview_tooltip_title'),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                        name: "preview"
                    })
                })
            })
        ]
    });
}
function DownloadCountColumn({ rowData }) {
    const { stamps } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "download-count",
        children: stamps.length
    });
}
function OnlineViewsColumn({ rowData }) {
    const { views } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "online-views",
        children: views.length
    });
}
function FirstDownloadColumn({ rowData }) {
    const { stamps: [first] } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "first-download",
        children: first && (0, _momentDefault.default)(first).format('MM/DD/YYYY, hh:mm a')
    });
}
function StartColumn({ rowData }) {
    const { start } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "start",
        children: (0, _momentDefault.default)(start).format('MM/DD/YYYY')
    });
}
function LessonColumn({ rowData }) {
    const { lesson, title } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "lesson",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
            value: lesson ? `${lesson.id} - ${lesson.name}` : title || "",
            maxLength: 200
        })
    });
}
const map = {
    headers: {
        DownloadLogHeader: (0, _utils.enhancedWithSortColumns)(DownloadLogHeader),
        EmptyHeader
    },
    columns: {
        GroupColumn: (0, _utils.enhancedWithRowData)(GroupColumn),
        LessonColumn: (0, _utils.enhancedWithRowData)(LessonColumn),
        StartColumn: (0, _utils.enhancedWithRowData)(StartColumn),
        FirstDownloadColumn: (0, _utils.enhancedWithRowData)(FirstDownloadColumn),
        OnlineViewsColumn: (0, _utils.enhancedWithRowData)(OnlineViewsColumn),
        DownloadCountColumn: (0, _utils.enhancedWithRowData)(DownloadCountColumn),
        DownloadLinksColumn: (0, _utils.enhancedWithRowData)(DownloadLinksColumn),
        LabelColumn
    }
};
exports.default = map;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","helpers/url":"65SQD","moment":"1e4qG","components/label":"59910","components/icon":"82gpi","helpers/utils":"gGc98","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kmvXm":[function() {},{}],"7qVcy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _context = require("../../../../context");
function SelectFilter(props) {
    const className = `select-${props.name}`;
    const selectProps = (0, _lodash.omit)(props, [
        'name'
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "dropdown",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                ...selectProps,
                className: className,
                classNamePrefix: "select",
                isSearchable: false,
                isClearable: true,
                escapeClearsValue: true,
                getOptionValue: ({ id })=>id,
                value: props.value
            })
        })
    });
}
function onGroup(context) {
    return (option)=>{
        const { id } = option || {};
        const query = {
            page: undefined,
            unit: undefined,
            lesson: undefined
        };
        context.navigate({
            groupId: id
        }, '/:languageId/:role/monitoring/:groupId?/student/:studentId', {
            preserveQuery: true,
            query
        });
    };
}
function onUnit(context) {
    return (option)=>{
        const { id: unit } = option || {};
        const query = {
            unit,
            page: undefined,
            lesson: undefined
        };
        context.navigate({}, context.match.path, {
            preserveQuery: true,
            query
        });
    };
}
function onLesson(context) {
    return (option)=>{
        const { id: lesson } = option || {};
        const query = {
            lesson,
            page: undefined
        };
        context.navigate({}, context.match.path, {
            preserveQuery: true,
            query
        });
    };
}
function Filters() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const placeholder = (name)=>context.translate(`${name}_filters_placeholder`);
            const student = context.students[context.studentId] || {
                groups: {}
            };
            const { downloadLogFilters = [] } = context;
            const groups = downloadLogFilters.filter(({ id })=>student.groups[id]);
            const group = groups.find((group)=>group.id == context.groupId);
            const units = group ? (0, _lodash.orderBy)(group.units, [
                'id'
            ]) : [];
            const unit = units.find((unit)=>unit.id == context.query.unit);
            const lessons = unit ? (0, _lodash.orderBy)(unit.lessons, [
                'id'
            ]) : [];
            const lesson = lessons.find((lesson)=>lesson.id == context.query.lesson);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "select-filters",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "group filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "group_label"
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                                name: "group",
                                options: groups,
                                value: group || null,
                                getOptionLabel: (item)=>item.name,
                                onChange: onGroup(context)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "unit filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "unit_label"
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                                name: "unit",
                                options: units,
                                value: unit || null,
                                getOptionLabel: (item)=>`${item.id.substring(8, 10)} - ${item.name}`,
                                onChange: onUnit(context)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lesson filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "lesson_label"
                                    }),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                                name: "lesson",
                                options: lessons,
                                value: lesson || null,
                                getOptionLabel: (item)=>`${item.id.substring(11, 13)} - ${item.name}`,
                                onChange: onLesson(context)
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","react-select":"j36cq","../../../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XlSQ":[function() {},{}],"97mWo":[function() {},{}],"aJMED":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Calendars);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../context");
var _calendars = require("../../../components/calendars");
var _calendarsDefault = parcelHelpers.interopDefault(_calendars);
var _calendarsStyl = require("./calendars.styl");
function Calendars() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { view, query, link } = context;
            const View = (0, _calendarsDefault.default)[view];
            const date = getDate(query);
            return View ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(View, {
                date,
                view,
                query
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                to: link({
                    view: 'month'
                }, undefined, {
                    preserveQuery: true
                })
            });
        }
    });
}
function getTime(date) {
    return (0, _momentDefault.default)(date).toDate().getTime();
}
function getDate({ start, end }) {
    const time = (getTime(start) + getTime(end)) / 2;
    return (0, _lodash.partial)((0, _momentDefault.default), time);
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","moment":"1e4qG","react":"9njXz","react-router-dom":"3uzXR","../../../context":"iUP37","../../../components/calendars":"fiuE9","./calendars.styl":"2lSot","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fiuE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _week = require("./week");
var _weekDefault = parcelHelpers.interopDefault(_week);
var _month = require("./month");
var _monthDefault = parcelHelpers.interopDefault(_month);
var _day = require("./day");
var _dayDefault = parcelHelpers.interopDefault(_day);
const views = {
    week: (0, _weekDefault.default),
    month: (0, _monthDefault.default),
    day: (0, _dayDefault.default)
};
exports.default = views;

},{"./week":"8vlYe","./month":"gznNa","./day":"er8Xd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vlYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WeekView);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactDnd = require("react-dnd");
var _context = require("../../context");
var _post = require("../../context/post");
var _toolbar = require("./toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _label = require("../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _event = require("./event");
var _eventDefault = parcelHelpers.interopDefault(_event);
var _weekStyl = require("./week.styl");
const dayTitleHeight = 28;
const eventHeight = 28;
const horizontalMargin = 40;
const verticalMargin = 300;
const groupWidth = 200;
const groupStyle = {
    with: groupWidth,
    maxWidth: groupWidth,
    minWidth: groupWidth
};
function Day(props) {
    const { date, daySize, group, goToDay } = props;
    const day = (0, _momentDefault.default)(date).format('YYYY-MM-DD');
    const isToday = (0, _momentDefault.default)(date).isSame(new Date(), 'day');
    const className = `day ${isToday ? 'current' : ''}`;
    const displayCount = 3;
    const [collectedProps, drop] = (0, _reactDnd.useDrop)({
        accept: 'event',
        canDrop: ()=>{
            return (0, _momentDefault.default)(date).isSameOrAfter(new Date(), 'day');
        },
        drop: ({ id })=>{
            const event = props.context.events.find((e)=>e.id == id);
            if (event) {
                const duration = (0, _momentDefault.default).duration((0, _momentDefault.default)(date).diff((0, _momentDefault.default)(event.start))).asDays();
                const finish = (0, _momentDefault.default)(event.end).add(duration, 'days');
                (0, _post.rescheduleEvent)(id, date, finish).then(()=>{
                    const eventUpdates = props.context.eventUpdates + 1;
                    props.context.setState({
                        eventUpdates
                    });
                });
            }
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const events = (context.eventsByDay[day] || []).filter((event)=>event.group == group.id);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                ref: drop,
                className: className,
                style: daySize,
                onClick: ()=>goToDay({
                        start: day,
                        end: day,
                        group: group.id
                    }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "events",
                    children: (0, _lodash.take)(events, displayCount).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventDefault.default), {
                            ...props
                        }, i))
                })
            });
        }
    });
}
function Week(props) {
    const { start, daySize, context, group, goToDay } = props;
    const days = (0, _lodash.range)(7).map((d)=>({
            goToDay,
            group,
            context,
            daySize,
            date: (0, _momentDefault.default)(start).add(d, 'days')
        })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Day, {
            ...props
        }, i));
    const subjectId = group.course.substring(0, 2);
    const subject = context.subjects.find((subject)=>subject.id == subjectId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "week",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "group",
                style: groupStyle,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "color-band",
                        style: {
                            backgroundColor: subject.color
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "subject",
                                children: `${group.subject} - ${group.grade}`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "name",
                                children: group.name
                            })
                        ]
                    })
                ]
            }),
            days
        ]
    });
}
function Header(props) {
    const { date, daySize } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "header day",
        style: {
            width: daySize.width
        },
        children: date.format('ddd DD/MM')
    });
}
function WeekView(props) {
    const { date } = props;
    const start = date().startOf('week');
    const end = date().endOf('week');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { sizes, groups, query } = context;
            const goToDay = (0, _lodash.partial)((0, _toolbar.changeView)(context), 'day');
            const dayWidth = Math.round((sizes.width - horizontalMargin - groupWidth - 12) / 7);
            const daySize = {
                width: dayWidth,
                maxWidth: dayWidth,
                minWidth: dayWidth
            };
            const weeks = groups.filter((group)=>!query.group || query.group == group.id).map((group)=>({
                    goToDay,
                    context,
                    group,
                    start,
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Week, {
                    ...props
                }, i));
            const headers = (0, _lodash.range)(7).map((d)=>({
                    date: (0, _momentDefault.default)(start).add(d, 'days'),
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                    ...props
                }, i));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "calendar week view",
                style: {
                    width: sizes.width - horizontalMargin
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "calendar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "headers",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "header groups",
                                        style: groupStyle,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "groups_label"
                                        })
                                    }),
                                    headers
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "weeks",
                                children: weeks
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","react-dnd":"9NZ1L","../../context":"iUP37","../../context/post":"8rmpk","./toolbar":"6gIXL","./filters":"ab6Sn","../label":"59910","./event":"97ZMt","./week.styl":"6CBlO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gIXL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeView", ()=>changeView);
parcelHelpers.export(exports, "default", ()=>Toolbar);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactRouterDom = require("react-router-dom");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _scheduleComment = require("../schedule-comment");
var _scheduleCommentDefault = parcelHelpers.interopDefault(_scheduleComment);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _calendarAltInput = require("../date-picker/calendar-alt-input");
var _calendarAltInputDefault = parcelHelpers.interopDefault(_calendarAltInput);
var _toolbarStyl = require("./toolbar.styl");
function changeDate({ navigate, match }, view) {
    const pad = view == 'day' ? 'day' : 'week';
    return (date)=>{
        const query = {
            start: (0, _momentDefault.default)(date).startOf(view).startOf(pad).format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).endOf(view).endOf(pad).format('YYYY-MM-DD')
        };
        navigate({}, match.path, {
            preserveQuery: true,
            query
        });
    };
}
function changeView({ navigate, match }) {
    return (view, query)=>{
        navigate({
            view
        }, match.path, {
            preserveQuery: true,
            query
        });
    };
}
function title(date, level, { translate, languageId }) {
    switch(level){
        case 'week':
            const start = (0, _momentDefault.default)(date).startOf(level).format('DD');
            const end = (0, _momentDefault.default)(date).endOf(level).format('DD');
            return `${translate('week_label')} ${start} - ${end}`;
        case 'day':
            const formats = {
                es: "dddd, DD [de] MMMM [de] YYYY",
                en: "dddd, MMMM do YYYY"
            };
            return (0, _momentDefault.default)(date).format(formats[languageId]);
        default:
            return (0, _momentDefault.default)(date).format('MMMM YYYY');
    }
}
function Toolbar(props) {
    const { date } = props;
    const weekQuery = {
        start: (0, _momentDefault.default)(date()).startOf('week').format('YYYY-MM-DD'),
        end: (0, _momentDefault.default)(date()).endOf('week').format('YYYY-MM-DD')
    };
    const monthQuery = {
        start: (0, _momentDefault.default)(date()).startOf('month').format('YYYY-MM-DD'),
        end: (0, _momentDefault.default)(date()).endOf('month').format('YYYY-MM-DD')
    };
    const level = `${props.view}s`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { languageId } = context;
            const navigate = changeDate(context, props.view);
            const navigateToView = changeView(context);
            const previous = ()=>navigate(date().subtract(1, level));
            const next = ()=>navigate(date().add(1, level));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "navigation",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "previous",
                                onClick: previous,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faChevronLeft)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                    selected: (0, _momentDefault.default)(date()).toDate(),
                                    dateFormat: "MM/yyyy",
                                    locale: languageId,
                                    popperPlacement: "top-end",
                                    popperModifiers: {
                                        offset: {
                                            enabled: true,
                                            offset: props.view == 'month' ? "158px, 5px" : "180px, 5px"
                                        },
                                        preventOverflow: {
                                            enabled: true,
                                            escapeWithReference: false,
                                            boundariesElement: 'viewport'
                                        }
                                    },
                                    onChange: (date)=>{
                                        navigate((0, _momentDefault.default)(date));
                                    },
                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarAltInputDefault.default), {}),
                                    showMonthYearPicker: props.view == 'month'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next",
                                onClick: next,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faChevronRight)
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: title(date(), props.view, context)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "button today",
                        onClick: ()=>navigate(new Date()),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "today_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `button week ${props.view == 'week' ? 'active' : ''}`,
                        onClick: ()=>props.view != 'week' && navigateToView('week', weekQuery),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "week_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `button month ${props.view == 'month' ? 'active' : ''}`,
                        onClick: ()=>props.view != 'month' && navigateToView('month', monthQuery),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "month_label"
                        })
                    }),
                    context.action == 'comment' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scheduleCommentDefault.default), {
                        selectedGroup: {},
                        activeTab: "groups"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                        className: "add-comment",
                        title: context.translate('add-comment'),
                        to: context.link({
                            action: 'comment',
                            view: props.view
                        }, '/:languageId/:role/:page/:view/:action', {
                            preserveQuery: true
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "circle",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "comment-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faComment)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "plus-icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faPlusCircle)
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","react-router-dom":"3uzXR","react-text":"lEpdJ","../schedule-comment":"ixHsg","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","../date-picker/calendar-alt-input":"4EymL","./toolbar.styl":"aRS7b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixHsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _tabBar = require("./tab-bar");
var _tabBarDefault = parcelHelpers.interopDefault(_tabBar);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("context");
var _utils = require("helpers/utils");
var _groupsStep = require("./groups-step");
var _groupsStepDefault = parcelHelpers.interopDefault(_groupsStep);
var _dateStep = require("./date-step");
var _dateStepDefault = parcelHelpers.interopDefault(_dateStep);
var _post = require("context/post");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _indexStyl = require("./index.styl");
function Buttons({ left, right }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !left.enabled,
                className: left.label,
                onClick: left.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${left.label}_label`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !right.enabled,
                className: right.label,
                onClick: right.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${right.label}_label`
                })
            })
        ]
    });
}
class ScheduleLesson extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            date: props.date || new Date(),
            message: props.message || "",
            activeTab: props.activeTab,
            selectedGroup: props.selectedGroup,
            studentList: props.studentList || [],
            selectedStudents: props.selectedStudents || [],
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const { setState, activeTab, isOpen } = this.state;
        const { lessons, lesson: lessonId } = context;
        const save = ()=>{
            const { course } = this.state.selectedGroup;
            return (0, _post.scheduleComment)({
                subject: course.substring(0, 2),
                language: context.languageId,
                students: this.state.selectedStudents,
                action: context.action,
                date: this.state.date,
                message: this.state.message
            }).then(()=>context.setState({
                    eventUpdates: context.eventUpdates + 1
                }, close));
        };
        const previous = ()=>setState({
                activeTab: 'groups'
            });
        const next = ()=>setState({
                activeTab: 'date'
            });
        const close = ()=>setState({
                isOpen: false
            });
        const navigateOut = ()=>context.navigate({}, context.match.path.replace(/\/:action.*$/, ''), {
                preserveQuery: true
            });
        const canSave = this.state.selectedStudents.length > 0 && !(0, _utils.isEmptyOrWhiteSpace)(this.state.message);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "schedule-comment-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-comment",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "label",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "comment"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "close",
                                onClick: ()=>close(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faTimesCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabBarDefault.default), {
                        activeTab,
                        setState
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tab-content",
                        children: [
                            activeTab == 'groups' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'selectedGroup',
                                            'studentList',
                                            'selectedStudents',
                                            'setState'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'cancel',
                                            onClick: close,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'continue',
                                            onClick: next,
                                            enabled: true
                                        }
                                    })
                                ]
                            }),
                            activeTab == 'date' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'date',
                                            'setState',
                                            'message'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'back',
                                            onClick: previous,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'save',
                                            onClick: save,
                                            enabled: canSave
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = ScheduleLesson;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-modal":"kV9Wz","./tab-bar":"8zZN1","react-text":"lEpdJ","context":"iUP37","helpers/utils":"gGc98","./groups-step":"fS2nE","./date-step":"1Bk8F","context/post":"8rmpk","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./index.styl":"aZAOA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8zZN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _tabBarStyl = require("./tab-bar.styl");
function TabBar({ activeTab, setState }) {
    const setActiveTab = (activeTab)=>setState({
            activeTab
        });
    const buttonClassName = (tab)=>`${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`;
    const onClick = (tab)=>()=>activeTab != tab && setActiveTab(tab);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tab-bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('groups'),
                onClick: onClick('groups'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faUsers)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_group_button_label"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('date'),
                onClick: onClick('date'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_date_button_label"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","./tab-bar.styl":"llOFO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"llOFO":[function() {},{}],"fS2nE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GroupsStep);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectGroup = require("./select-group");
var _selectGroupDefault = parcelHelpers.interopDefault(_selectGroup);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _listboxActions = require("../listbox/listbox-actions");
var _listboxActionsDefault = parcelHelpers.interopDefault(_listboxActions);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _groupsStepStyl = require("./groups-step.styl");
function makeStudentClickHandler({ props, target }) {
    return ({ id, selected })=>props.setState({
            [target]: props[target].map((student)=>student.id != id ? {
                    ...student
                } : {
                    ...student,
                    selected: !selected
                })
        });
}
function GroupsStep(props) {
    const groupClick = (group)=>{
        if (group.id != props.selectedGroup.id) props.setState({
            selectedGroup: group,
            selectedStudents: [],
            studentList: group.students.map((student)=>({
                    ...student,
                    selected: false
                }))
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "groups-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "groups-message",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "schedule_comment_groups_instructions"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "student-selector",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGroupDefault.default), {
                        selectedGroup: props.selectedGroup,
                        onClick: groupClick
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "select-student",
                        labelId: "students_label",
                        items: (0, _lodash.orderBy)(props.studentList, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'studentList'
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxActionsDefault.default), {
                        onAllLeft: ()=>{
                            const studentList = props.studentList.concat(props.selectedStudents);
                            props.setState({
                                selectedStudents: [],
                                studentList
                            });
                        },
                        onLeft: ()=>{
                            const selectedStudents = props.selectedStudents.filter(({ selected })=>!selected);
                            const studentList = props.studentList.concat(props.selectedStudents.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onRight: ()=>{
                            const studentList = props.studentList.filter(({ selected })=>!selected);
                            const selectedStudents = props.selectedStudents.concat(props.studentList.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onAllRight: ()=>{
                            const selectedStudents = props.selectedStudents.concat(props.studentList);
                            props.setState({
                                selectedStudents,
                                studentList: []
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "selected-students",
                        labelId: "selection_label",
                        items: (0, _lodash.orderBy)(props.selectedStudents, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'selectedStudents'
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","./select-group":"lFIvS","../listbox":"b8FP6","../listbox/listbox-actions":"h72SQ","react-text":"lEpdJ","./groups-step.styl":"6jgSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lFIvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _context = require("../../context");
function SelectGroup(props) {
    const { selectedGroup, onClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const groups = context.groups.map((group)=>{
                return {
                    ...group,
                    selected: group.id == selectedGroup.id
                };
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                className: "select-group",
                labelId: "group_label",
                items: (0, _lodash.orderBy)(groups, [
                    'course'
                ]),
                onClick: onClick
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","../listbox":"b8FP6","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jgSk":[function() {},{}],"1Bk8F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateStep);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../context");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _dateStepStyl = require("./date-step.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function DateStep(props) {
    const setDate = (date)=>props.setState({
            date
        });
    const setMessage = (event)=>props.setState({
            message: event.target.value
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "date-step",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "schedule_comment_date_instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "date",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                    selected: props.date,
                                    onChange: setDate,
                                    minDate: new Date(),
                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "message",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "message_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            placeholder: context.translations.schedule_lesson_date_message_placeholder[context.languageId],
                                            value: props.message,
                                            onChange: setMessage
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../context":"iUP37","react-datepicker/dist/react-datepicker.css":"chsuV","./date-step.styl":"ikjoI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"ikjoI":[function() {},{}],"aZAOA":[function() {},{}],"4EymL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
class CalendarAltInput extends (0, _reactDefault.default).Component {
    constructor(props){
        super(props);
        this.state = {
            showing: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.hide = this.hide.bind(this);
    }
    show() {
        this.setState({
            showing: true
        }, ()=>{
            document.addEventListener("click", this.hide);
            this.props.onClick();
        });
    }
    hide() {
        this.setState({
            showing: false
        }, ()=>document.removeEventListener("click", this.hide));
    }
    handleClick() {
        if (this.state.showing) this.hide();
        else this.show();
    }
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            onClick: this.handleClick,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                icon: (0, _freeSolidSvgIcons.faCalendarAlt)
            })
        });
    }
}
exports.default = CalendarAltInput;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aRS7b":[function() {},{}],"ab6Sn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _context = require("../../context");
var _filtersStyl = require("./filters.styl");
function SelectFilter(props) {
    const { name, options, mapQuery = (a)=>a } = props;
    const className = `select-${name}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const id = context.query[name];
            const value = options.find((prop)=>prop.id == id) || null;
            const placeholder = context.translate(`${name}_placeholder`);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "dropdown",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        className: className,
                        classNamePrefix: "select",
                        formatOptionLabel: ({ name })=>name,
                        isSearchable: false,
                        isClearable: true,
                        escapeClearsValue: true,
                        getOptionValue: ({ id })=>id,
                        placeholder: placeholder,
                        value: value,
                        onChange: (option)=>{
                            const { id } = option || {};
                            const query = mapQuery({
                                [name]: id
                            });
                            context.navigate({}, context.match.path, {
                                preserveQuery: true,
                                query
                            });
                        },
                        options: options
                    })
                })
            });
        }
    });
}
function Filters() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { groups, query } = context;
            const { students } = groups.find((group)=>group.id == query.group) || {
                students: []
            };
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filters-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "filters",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                            name: "group",
                            options: groups,
                            mapQuery: (q)=>({
                                    ...q,
                                    student: undefined
                                })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                            name: "student",
                            options: students
                        })
                    ]
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-select":"j36cq","../../context":"iUP37","./filters.styl":"xy7HN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"xy7HN":[function() {},{}],"97ZMt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "homeworkColor", ()=>homeworkColor);
parcelHelpers.export(exports, "assessmentColor", ()=>assessmentColor);
parcelHelpers.export(exports, "default", ()=>Event);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDnd = require("react-dnd");
var _context = require("../../context");
var _eventStyl = require("./event.styl");
const homeworkColor = '#93e2c6';
const assessmentColor = '#c98571';
function Event(props) {
    const title = props.content.title || props.title;
    const isAssessment = [
        'quiz',
        'a.assignment'
    ].indexOf(props.type) >= 0;
    const isHomework = props.type == 'homework';
    const [{ opacity }, dragRef] = (0, _reactDnd.useDrag)({
        item: {
            type: 'event',
            id: props.id
        },
        collect: (monitor)=>({
                opacity: monitor.isDragging() ? 0.5 : 1
            })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const subject = context.subjects.find((subject)=>subject.id == props.content.subject);
            const color = isAssessment ? '#fff' : isHomework ? '#fff' : subject.textColor;
            const backgroundColor = isAssessment ? assessmentColor : isHomework ? homeworkColor : subject.color;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: dragRef,
                className: "event",
                style: {
                    opacity,
                    color,
                    backgroundColor
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        title: title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex spacer"
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dnd":"9NZ1L","../../context":"iUP37","./event.styl":"jsBpa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jsBpa":[function() {},{}],"6CBlO":[function() {},{}],"gznNa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MonthView);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactDnd = require("react-dnd");
var _context = require("../../context");
var _post = require("../../context/post");
var _toolbar = require("./toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _label = require("../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _event = require("./event");
var _eventDefault = parcelHelpers.interopDefault(_event);
var _monthStyl = require("./month.styl");
const minEventHeight = 110;
const minEventWidth = 130;
const dayTitleHeight = 28;
const eventHeight = 28;
const viewMoreHeight = 20;
const horizontalMargin = 40;
const verticalMargin = 300;
function Day(props) {
    const { date, daySize, goToDay } = props;
    const day = (0, _momentDefault.default)(date).format('YYYY-MM-DD');
    const isToday = (0, _momentDefault.default)(date).isSame(new Date(), 'day');
    const className = `day ${isToday ? 'current' : ''}`;
    const displayCount = Math.floor((daySize.height - dayTitleHeight - viewMoreHeight) / eventHeight);
    const [collectedProps, drop] = (0, _reactDnd.useDrop)({
        accept: 'event',
        canDrop: ()=>{
            return (0, _momentDefault.default)(date).isSameOrAfter(new Date(), 'day');
        },
        drop: ({ id })=>{
            const event = props.context.events.find((e)=>e.id == id);
            if (event) {
                const finish = (0, _momentDefault.default)(date).startOf('day').add(event.duration, 'days');
                (0, _post.rescheduleEvent)(id, date, finish).then(()=>{
                    const eventUpdates = props.context.eventUpdates + 1;
                    props.context.setState({
                        eventUpdates
                    });
                });
            }
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const events = context.eventsByDay[day] || [];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: drop,
                className: className,
                style: {
                    minWidth: daySize.width,
                    maxWidth: daySize.width
                },
                onClick: ()=>goToDay({
                        start: day,
                        end: day
                    }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: date.format('D')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "events",
                        children: (0, _lodash.take)(events, displayCount).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventDefault.default), {
                                ...props
                            }, i))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    events.length > displayCount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "view-more",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "view-more"
                            }),
                            " ",
                            events.length - displayCount,
                            "..."
                        ]
                    })
                ]
            });
        }
    });
}
function Week(props) {
    const { start, daySize, context, goToDay } = props;
    const days = (0, _lodash.range)(7).map((d)=>({
            goToDay,
            context,
            daySize,
            date: (0, _momentDefault.default)(start).add(d, 'days')
        })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Day, {
            ...props
        }, i));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "week",
        children: days
    });
}
function Header(props) {
    const { date, daySize } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "header week",
        style: {
            flexGrow: 1
        },
        children: date.format('ddd')
    });
}
function MonthView(props) {
    const { date } = props;
    const start = date().startOf('month').startOf('week');
    const end = date().endOf('month').endOf('week');
    const weekCount = Math.ceil(end.diff(start, 'days') / 7);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { sizes } = context;
            const goToDay = (0, _lodash.partial)((0, _toolbar.changeView)(context), 'day');
            const daySize = {
                width: Math.max(minEventWidth, Math.round((sizes.width - horizontalMargin - 6) / 7)),
                height: Math.max(minEventHeight, Math.round((sizes.height - verticalMargin) / weekCount))
            };
            const weeks = (0, _lodash.range)(weekCount).map((w)=>({
                    goToDay,
                    context,
                    start: (0, _momentDefault.default)(start).add(w, 'weeks'),
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Week, {
                    ...props
                }, i));
            const headers = (0, _lodash.range)(7).map((d)=>({
                    date: (0, _momentDefault.default)(start).add(d, 'days'),
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                    ...props
                }, i));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "calendar month view",
                style: {
                    width: sizes.width - horizontalMargin + 6
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "calendar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "headers",
                                children: headers
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "weeks",
                                children: weeks
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","react-dnd":"9NZ1L","../../context":"iUP37","../../context/post":"8rmpk","./toolbar":"6gIXL","./filters":"ab6Sn","../label":"59910","./event":"97ZMt","./month.styl":"iUzbI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iUzbI":[function() {},{}],"er8Xd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DayView);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _post = require("../../context/post");
var _toolbar = require("./toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _label = require("../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _confirmDialog = require("../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _editSchedule = require("../edit-schedule");
var _editScheduleDefault = parcelHelpers.interopDefault(_editSchedule);
var _updateAssignment = require("../quiz/content/update-assignment");
var _updateAssignmentDefault = parcelHelpers.interopDefault(_updateAssignment);
var _editStudentAssignment = require("../quiz/content/EditStudentAssignment");
var _editStudentAssignmentDefault = parcelHelpers.interopDefault(_editStudentAssignment);
var _command = require("../../helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _event = require("./event");
var _dayStyl = require("./day.styl");
var _deleteHomework = require("teacher/homework/components/delete-homework");
var _deleteHomeworkDefault = parcelHelpers.interopDefault(_deleteHomework);
function eventTitle({ translate }, { type, content, title }) {
    switch(type){
        case 'comment':
            return translate('comment');
        case 'uploaded':
            return content.title;
        case 'a.assignment':
            return content.title;
        case 'schedule':
            return title;
        default:
            return title;
    }
}
function eventContent({ type, content, title }) {
    switch(type){
        case 'comment':
            return content.message;
        case 'uploaded':
            return content.title;
        case 'a.assignment':
            return content.title;
        case 'schedule':
            return title;
        default:
            return title;
    }
}
function Event(props) {
    const { context, group } = props;
    const isAssessment = [
        'quiz',
        'a.assignment'
    ].indexOf(props.type) >= 0;
    const isHomework = props.type == 'homework';
    const subjectId = group ? group.course.substring(0, 2) : undefined;
    const subject = context.subjects.find((subject)=>subject.id == subjectId);
    const isEditing = context.event == props.id;
    const canDelete = isAssessment ? props.content.startedCount < 1 : true;
    const bandColor = isAssessment ? (0, _event.assessmentColor) : isHomework ? (0, _event.homeworkColor) : subject.color;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "schedule-event",
        children: [
            subject && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "color-band",
                        style: {
                            backgroundColor: bandColor
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "subject",
                                children: `${group.subject} - ${group.grade}`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "name",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    title: group.name,
                                    children: group.name
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "content",
                children: eventContent(props)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "actions-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "actions",
                    children: [
                        isEditing && group && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editScheduleDefault.default), {
                            title: eventTitle(context, props),
                            eventTitle: props.title,
                            content: props.content,
                            message: props.content.message,
                            start: props.start,
                            finish: props.end,
                            date: (0, _momentDefault.default)(props.start).toDate(),
                            selectedStudents: group.students.filter((student)=>props.students.indexOf(student.id) >= 0).map((student)=>({
                                    ...student,
                                    selected: true
                                })),
                            studentList: group.students.filter((student)=>props.students.indexOf(student.id) < 0).map((student)=>({
                                    ...student,
                                    selected: false
                                })),
                            selectedGroup: group,
                            activeTab: "groups"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "action edit",
                            onClick: async ()=>{
                                const action = props.content.linked ? 'schedule' : 'posts';
                                if (props.type != 'quiz' && !isHomework) return context.navigate({
                                    action,
                                    event: props.id
                                }, '/:languageId/:role/:page/day/:action/:event', {
                                    preserveQuery: true
                                });
                                if (isAssessment) {
                                    const assignment = await fetchAssignment(props.id);
                                    if (!assignment) return;
                                    const dialog = assignment.startedCount > 0 ? 'edit-student-assignment' : 'edit-assignment';
                                    context.updateState({
                                        quizAssignmentToModify: {
                                            $set: assignment
                                        },
                                        quizDialogs: {
                                            [dialog]: {
                                                $set: true
                                            }
                                        }
                                    });
                                }
                                if (isHomework) {
                                    context.updateState({
                                        homeworkContext: {
                                            review: {
                                                from: {
                                                    $set: context.match.url
                                                },
                                                query: {
                                                    $set: context.query
                                                }
                                            }
                                        }
                                    });
                                    context.navigate({
                                        page: 'homework',
                                        id: props.id
                                    }, '/:languageId/:role/:page/:id');
                                }
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "edit_label"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _clsxDefault.default)('action', 'delete', {
                                disabled: !canDelete
                            }),
                            onClick: async ()=>{
                                if (isHomework) {
                                    const homework = await fetchHomework(props.id);
                                    context.updateState({
                                        homeworkContext: {
                                            deleteHomework: {
                                                open: {
                                                    $set: true
                                                },
                                                homework: {
                                                    $set: homework
                                                }
                                            }
                                        }
                                    });
                                    return;
                                }
                                if (!canDelete) return;
                                (0, _confirmDialogDefault.default)({
                                    className: 'delete-schedule',
                                    translate: context.translate,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "message",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "question",
                                                children: context.translate('confirm_delete_item')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "title",
                                                children: eventContent(props)
                                            })
                                        ]
                                    }),
                                    onConfirm: async ()=>{
                                        if (props.type == 'quiz') {
                                            const assignment = await fetchAssignment(props.id);
                                            if (assignment && assignment.startedCount < 1) await (0, _commandDefault.default)('quiz', 'deleteAssignment')({
                                                id: props.id
                                            });
                                        } else await (0, _post.deleteEvent)(props.id);
                                        const eventUpdates = props.context.eventUpdates + 1;
                                        props.context.setState({
                                            eventUpdates
                                        });
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "delete_label"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function DayView(props) {
    const { date } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { groups, query, action, location } = context;
            const events = context.events.map((event)=>{
                const group = groups.find((group)=>group.id == event.group);
                return {
                    ...event,
                    context,
                    group,
                    date
                };
            }).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Event, {
                    ...props
                }, i));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "calendar day view",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "calendar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteHomeworkDefault.default), {
                                onDelete: ()=>{
                                    context.updateState({
                                        eventUpdates: {
                                            $apply: (i)=>i + 1
                                        }
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editStudentAssignmentDefault.default), {
                                context: context
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateAssignmentDefault.default), {
                                context: context
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "schedule-events",
                                children: events
                            })
                        ]
                    })
                ]
            });
        }
    });
}
async function fetchAssignment(id) {
    const [paging, results] = await (0, _commandDefault.default)('quiz', 'searchAssignments')({
        id
    });
    if (paging.recordCount < 1) return false;
    const [assignment] = results;
    return assignment;
}
async function fetchHomework(id) {
    const [homework] = await (0, _commandDefault.default)('homework', 'getHomeworks')({
        id
    });
    return homework ? homework : false;
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","../../context":"iUP37","../../context/post":"8rmpk","./toolbar":"6gIXL","./filters":"ab6Sn","../label":"59910","../confirm-dialog":"hzSdJ","../edit-schedule":"8CCnO","../quiz/content/update-assignment":"kGxLy","../quiz/content/EditStudentAssignment":"ieGsn","../../helpers/command":"f3cbG","./event":"97ZMt","./day.styl":"j75jd","teacher/homework/components/delete-homework":"5p0uh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hzSdJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>confirmDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
function confirmDialog(props) {
    const { onConfirm, children, translate, className } = props;
    return (0, _react.confirmAlert)({
        customUI: ({ onClose })=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `${className} confirm-dialog`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "message",
                        children: children
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "yes button",
                                onClick: ()=>{
                                    onClose();
                                    onConfirm();
                                },
                                children: translate('yes_label')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "no button",
                                onClick: onClose,
                                children: translate('no_label')
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8CCnO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _tabBar = require("./tab-bar");
var _tabBarDefault = parcelHelpers.interopDefault(_tabBar);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _groupsStep = require("./groups-step");
var _groupsStepDefault = parcelHelpers.interopDefault(_groupsStep);
var _dateStep = require("./date-step");
var _dateStepDefault = parcelHelpers.interopDefault(_dateStep);
var _assessmentDateStep = require("./AssessmentDateStep");
var _assessmentDateStepDefault = parcelHelpers.interopDefault(_assessmentDateStep);
var _post = require("../../context/post");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _scheduleLessonStyl = require("./schedule-lesson.styl");
function Buttons({ left, right }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !left.enabled,
                className: left.label,
                onClick: left.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${left.label}_label`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !right.enabled,
                className: right.label,
                onClick: right.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${right.label}_label`
                })
            })
        ]
    });
}
class EditSchedule extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            date: props.date || new Date(),
            start: props.start || new Date(),
            finish: props.finish || new Date(),
            maxTime: props.content.max_time || 3600,
            message: props.message || "",
            activeTab: props.activeTab,
            selectedGroup: props.selectedGroup,
            studentList: props.studentList || [],
            selectedStudents: props.selectedStudents || [],
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const { setState, activeTab, isOpen } = this.state;
        const { title, content = {} } = this.props;
        const previous = ()=>setState({
                activeTab: 'groups'
            });
        const next = ()=>setState({
                activeTab: 'date'
            });
        const close = ()=>setState({
                isOpen: false
            });
        const navigateOut = ()=>context.navigate({}, context.match.path.replace(/\/:action.*$/, ''), {
                preserveQuery: true
            });
        const isRegularEvent = !content.assessment_assignment;
        const saveSchedule = ()=>{
            return (0, _post.editSchedule)({
                content: this.props.content,
                language: context.languageId,
                event: this.context.event,
                students: this.state.selectedStudents,
                action: context.action,
                date: this.state.date,
                message: this.state.message,
                group: this.state.selectedGroup
            }).then(close);
        };
        const saveScheduleAssessment = ()=>{
            return (0, _post.editAssessmentSchedule)({
                title: this.props.eventTitle,
                content: this.props.content,
                language: context.languageId,
                event: this.context.event,
                students: this.state.selectedStudents,
                action: context.action,
                start: this.state.start,
                finish: this.state.finish,
                maxTime: this.state.maxTime,
                message: this.state.message,
                group: this.state.selectedGroup
            }).then(close);
        };
        const save = isRegularEvent ? saveSchedule : saveScheduleAssessment;
        const DateStep = isRegularEvent ? (0, _dateStepDefault.default) : (0, _assessmentDateStepDefault.default);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "schedule-lesson-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-lesson",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "label",
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "close",
                                onClick: ()=>close(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faTimesCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabBarDefault.default), {
                        activeTab,
                        setState
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tab-content",
                        children: [
                            activeTab == 'groups' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'selectedGroup',
                                            'studentList',
                                            'selectedStudents',
                                            'setState'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'cancel',
                                            onClick: close,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'continue',
                                            onClick: next,
                                            enabled: true
                                        }
                                    })
                                ]
                            }),
                            activeTab == 'date' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateStep, {
                                        ...(0, _lodash.pick)(this.state, [
                                            'start',
                                            'finish',
                                            'maxTime',
                                            'date',
                                            'setState',
                                            'message'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'back',
                                            onClick: previous,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'save',
                                            onClick: save,
                                            enabled: this.state.selectedStudents.length > 0
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = EditSchedule;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-modal":"kV9Wz","./tab-bar":"8mV4r","react-text":"lEpdJ","../../context":"iUP37","./groups-step":"2eqfV","./date-step":"h8lgL","./AssessmentDateStep":"1kkBT","../../context/post":"8rmpk","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./schedule-lesson.styl":"duzW2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8mV4r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _tabBarStyl = require("./tab-bar.styl");
function TabBar({ activeTab, setState }) {
    const setActiveTab = (activeTab)=>setState({
            activeTab
        });
    const buttonClassName = (tab)=>`${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`;
    const onClick = (tab)=>()=>activeTab != tab && setActiveTab(tab);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tab-bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('groups'),
                onClick: onClick('groups'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faUsers)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_group_button_label"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('date'),
                onClick: onClick('date'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_date_button_label"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","./tab-bar.styl":"2Pmoj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Pmoj":[function() {},{}],"2eqfV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GroupsStep);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectGroup = require("./select-group");
var _selectGroupDefault = parcelHelpers.interopDefault(_selectGroup);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _listboxActions = require("../listbox/listbox-actions");
var _listboxActionsDefault = parcelHelpers.interopDefault(_listboxActions);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _groupsStepStyl = require("./groups-step.styl");
function makeStudentClickHandler({ props, target }) {
    return ({ id, selected })=>props.setState({
            [target]: props[target].map((student)=>student.id != id ? student : {
                    ...student,
                    selected: !selected
                })
        });
}
function GroupsStep(props) {
    const groupClick = (group)=>{
        if (group.id != props.selectedGroup.id) props.setState({
            selectedGroup: group,
            selectedStudents: [],
            studentList: group.students.map((student)=>({
                    ...student,
                    selected: false
                }))
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "groups-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "groups-message",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "schedule_lesson_groups_instructions"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "student-selector",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGroupDefault.default), {
                        selectedGroup: props.selectedGroup,
                        onClick: groupClick
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "select-student",
                        labelId: "students_label",
                        items: (0, _lodash.orderBy)(props.studentList, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'studentList'
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxActionsDefault.default), {
                        onAllLeft: ()=>{
                            const studentList = props.studentList.concat(props.selectedStudents);
                            props.setState({
                                selectedStudents: [],
                                studentList
                            });
                        },
                        onLeft: ()=>{
                            const selectedStudents = props.selectedStudents.filter(({ selected })=>!selected);
                            const studentList = props.studentList.concat(props.selectedStudents.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onRight: ()=>{
                            const studentList = props.studentList.filter(({ selected })=>!selected);
                            const selectedStudents = props.selectedStudents.concat(props.studentList.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onAllRight: ()=>{
                            const selectedStudents = props.selectedStudents.concat(props.studentList);
                            props.setState({
                                selectedStudents,
                                studentList: []
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "selected-students",
                        labelId: "selection_label",
                        items: (0, _lodash.orderBy)(props.selectedStudents, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'selectedStudents'
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","./select-group":"5PyjR","../listbox":"b8FP6","../listbox/listbox-actions":"h72SQ","react-text":"lEpdJ","./groups-step.styl":"5EOp9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5PyjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _context = require("../../context");
function SelectGroup(props) {
    const { selectedGroup, onClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                className: "select-group",
                labelId: "group_label",
                items: [
                    {
                        ...selectedGroup,
                        selected: true
                    }
                ],
                onClick: onClick
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","../listbox":"b8FP6","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5EOp9":[function() {},{}],"h8lgL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateStep);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../context");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _dateStepStyl = require("./date-step.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function DateStep(props) {
    const setDate = (date)=>props.setState({
            date
        });
    const setMessage = (event)=>props.setState({
            message: event.target.value
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "date-step",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "schedule_lesson_date_instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "date",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                    selected: props.date,
                                    onChange: setDate,
                                    minDate: new Date(),
                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "message",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "message_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            placeholder: context.translations.schedule_lesson_date_message_placeholder[context.languageId],
                                            value: props.message,
                                            onChange: setMessage
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../context":"iUP37","react-datepicker/dist/react-datepicker.css":"chsuV","./date-step.styl":"cP2iv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"cP2iv":[function() {},{}],"1kkBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateStep);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../../context");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _indexStyl = require("./index.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function DateStep(props) {
    const setMessage = (event)=>props.setState({
            message: event.target.value
        });
    const hours = Math.floor(props.maxTime / 3600);
    const minutes = props.maxTime % 3600 / 60;
    const setHours = (event)=>{
        const value = parseInt(event.target.value);
        const hours = isNaN(value) ? 0 : value;
        const maxTime = minutes * 60 + hours * 3600;
        props.setState({
            maxTime
        });
    };
    const setMinutes = (event)=>{
        const value = parseInt(event.target.value);
        const minutes = isNaN(value) ? 0 : value;
        const maxTime = minutes * 60 + hours * 3600;
        props.setState({
            maxTime
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "date-step",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "schedule_lesson_date_instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "date_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "inputs",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "from",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                                    selected: (0, _momentDefault.default)(props.start).toDate(),
                                                    minDate: new Date(),
                                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                                    showTimeInput: true,
                                                    dateFormat: "MM/dd/yyyy h:mm aa",
                                                    onChange: (start)=>{
                                                        const finish = (0, _momentDefault.default)(props.finish).isAfter(start) ? props.finish : (0, _momentDefault.default)(start).toDate();
                                                        props.setState({
                                                            start,
                                                            finish
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "separator",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        flexDirection: 'column'
                                                    },
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "to",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                                    selected: (0, _momentDefault.default)(props.finish).toDate(),
                                                    minDate: (0, _momentDefault.default)(props.start).toDate(),
                                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                                    showTimeInput: true,
                                                    dateFormat: "MM/dd/yyyy h:mm aa",
                                                    timeIntervals: 60,
                                                    onChange: (finish)=>{
                                                        props.setState({
                                                            finish
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "duration",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "hours",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "hours"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inputs",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    value: hours,
                                                    onChange: setHours
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "separator",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: 'column'
                                            },
                                            children: " "
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "minutes",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "minutes"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inputs",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    value: minutes,
                                                    onChange: setMinutes
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "message",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "message_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            placeholder: context.translate('schedule_lesson_date_message_placeholder'),
                                            value: props.message,
                                            onChange: setMessage
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../../context":"iUP37","react-datepicker/dist/react-datepicker.css":"chsuV","./index.styl":"3Bfpj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"3Bfpj":[function() {},{}],"duzW2":[function() {},{}],"kGxLy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assign);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _infoBar = require("./info-bar");
var _infoBarDefault = parcelHelpers.interopDefault(_infoBar);
var _selectStudents = require("./select-students");
var _selectStudentsDefault = parcelHelpers.interopDefault(_selectStudents);
var _writeComments = require("./write-comments");
var _writeCommentsDefault = parcelHelpers.interopDefault(_writeComments);
var _command = require("helpers/command");
var _responsiveFullscreenDialog = require("../../components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
const useDialogStyles = (0, _material.makeStyles)((theme)=>({
        paper: {
            width: '100%',
            padding: '20px 0',
            height: 'calc(100% - 100px)'
        }
    }));
const useDialogActionsStyles = (0, _material.makeStyles)({
    root: {
        padding: 0
    }
});
const useDialogTitleStyles = (0, _material.makeStyles)({
    root: {
        padding: 0
    }
});
const useDialogContentStyles = (0, _material.makeStyles)({
    root: {
        padding: 0,
        display: 'flex'
    }
});
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexDirection: 'column',
            color: '#4f576e',
            flexGrow: 1
        }
    }));
const Tabs = (0, _material.withStyles)({
    root: {
        flexShrink: 0,
        borderBottom: 'solid 1px #dbe3e6'
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        flexGrow: 1
    },
    flexContainer: {
        flexGrow: 1
    }
})((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
        ...props,
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        }
    }));
const Tab = (0, _material.withStyles)((theme)=>({
        root: {
            padding: '0 5px',
            margin: 0,
            maxWidth: 'initial',
            flexShrink: 1,
            flexGrow: 1,
            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            backgroundColor: '#f8f8f8',
            fontSize: theme.typography.pxToRem(18),
            [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.pxToRem(15)
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(12)
            },
            '&:first-child': {
                borderRight: 'solid 1px #dbe3e6'
            },
            '&:focus': {
                opacity: 1
            }
        },
        wrapper: {
            flexDirection: 'row'
        },
        selected: {
            opacity: 1,
            backgroundColor: 'transparent'
        }
    }))((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
        disableRipple: true,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircleIcon, {
            ...props
        }),
        ...props
    }));
const useCircleStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            borderRadius: 50,
            flexShrink: 0,
            color: '#fff',
            width: '25px',
            height: '25px',
            fontSize: '11pt',
            lineHeight: '1.8',
            marginRight: '20px',
            backgroundColor: '#a6a6a6',
            [theme.breakpoints.down('sm')]: {
                marginRight: '8px'
            }
        },
        selected: {
            backgroundColor: '#e27a1b'
        }
    }));
function CircleIcon(props) {
    const classes = useCircleStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, {
            [classes.selected]: props.selected
        }),
        children: props.value + 1
    });
}
const initialState = {
    group: '',
    start: (0, _momentDefault.default)().startOf('day').toDate(),
    finish: (0, _momentDefault.default)().endOf('day').toDate(),
    maxDuration: (0, _momentDefault.default)().endOf('day').diff((0, _momentDefault.default)(), 'seconds'),
    duration: 3600,
    comments: '',
    students: [],
    selectedStudents: [],
    checkedStudents: {},
    tab: 0
};
function Assign({ context }) {
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, quizAssignmentToModify: assignment, quizDialogs, groups } = context;
    const classes = useStyles();
    const dialogClasses = useDialogStyles();
    const dialogActionsClasses = useDialogActionsStyles();
    const dialogTitleClasses = useDialogTitleStyles();
    const dialogContentClasses = useDialogContentStyles();
    const isOpen = quizDialogs['edit-assignment'] !== false && assignment.id != undefined;
    const [state, setState] = (0, _reactDefault.default).useState(initialState);
    function handleTimeChange({ hours, minutes }) {
        const duration = Math.min(minutes * 60 + hours * 3600, state.maxDuration);
        setState({
            ...state,
            duration
        });
    }
    function handleStartChange(start) {
        const finish = (0, _momentDefault.default)(state.finish).isAfter(start) ? state.finish : (0, _momentDefault.default)(start).endOf('day').toDate();
        const maxDuration = (0, _momentDefault.default)(finish).diff((0, _momentDefault.default)(start), 'seconds');
        const duration = Math.min(state.duration, maxDuration);
        setState({
            ...state,
            start,
            finish,
            duration,
            maxDuration
        });
    }
    function handleFinishChange(finish) {
        const maxDuration = (0, _momentDefault.default)(finish).diff((0, _momentDefault.default)(state.start), 'seconds');
        const duration = Math.min(state.duration, maxDuration);
        setState({
            ...state,
            finish,
            duration,
            maxDuration
        });
    }
    function handleTabChange(e, tab) {
        setState({
            ...state,
            tab
        });
    }
    async function handleCancel() {
        await context.updateState({
            quizDialogs: {
                ['edit-assignment']: {
                    $set: false
                }
            }
        });
        setState(initialState);
    }
    function handleContinue() {
        setState({
            ...state,
            tab: 1
        });
    }
    function handleBack() {
        setState({
            ...state,
            tab: 0
        });
    }
    function handleGroupChange(e) {
        const group = groups.find((g)=>g.id == e.target.value) || {};
        const students = group.students || [];
        const checkedStudents = students.reduce((acc, student)=>{
            acc[student.id] = false;
            return acc;
        }, {});
        setState({
            ...state,
            group: e.target.value,
            students,
            selectedStudents: [],
            checkedStudents
        });
    }
    function handleStudentsChecked(id, value) {
        setState({
            ...state,
            checkedStudents: {
                ...state.checkedStudents,
                [id]: value
            }
        });
    }
    function handleStudentsChange({ left, right }) {
        setState({
            ...state,
            students: left,
            selectedStudents: right
        });
    }
    function handleCommentsChange(e) {
        setState({
            ...state,
            comments: e.target.value
        });
    }
    async function handleSend() {
        try {
            const { id } = assignment;
            const { comments, duration } = state;
            const start = (0, _momentDefault.default)(state.start).toISOString();
            const finish = (0, _momentDefault.default)(state.finish).toISOString();
            const students = state.selectedStudents.map((s)=>s.id);
            const result = await (0, _command.createPost)('quiz', 'updateAssignment')({
                id,
                start,
                finish,
                duration,
                comments,
                students
            });
            context.setState({
                quizAssignmentCalls: context.quizAssignmentCalls + 1
            });
            handleCancel();
        } catch (e) {
            console.log(e);
            handleCancel();
        }
    }
    (0, _reactDefault.default).useEffect(()=>{
        if (assignment.id != undefined) {
            const { group, duration, properties } = assignment;
            const { comments } = properties;
            const start = (0, _momentDefault.default)(assignment.start).toDate();
            const finish = (0, _momentDefault.default)(assignment.finish).toDate();
            const { students: groupStudents = [] } = context.groups.find((g)=>g.id == group) || {};
            const students = groupStudents.filter((s)=>assignment.students.indexOf(s.id) < 0);
            const selectedStudents = groupStudents.filter((s)=>assignment.students.indexOf(s.id) > -1);
            const checkedStudents = groupStudents.reduce((acc, s)=>{
                acc[s.id] = false;
                return acc;
            }, {});
            setState({
                ...state,
                group,
                duration,
                comments,
                start,
                finish,
                students,
                checkedStudents,
                selectedStudents
            });
        }
    }, [
        assignment
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: handleCancel,
        dialogClasses: dialogClasses,
        contentClasses: dialogContentClasses,
        headClasses: dialogTitleClasses,
        actionsClasses: dialogActionsClasses,
        dialogMaxWidth: "lg",
        TitleComponent: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBarDefault.default), {
                context: context
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Tabs, {
                    value: state.tab,
                    onChange: handleTabChange,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tab, {
                            label: translate('select-students-tab')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tab, {
                            label: translate('comments-tab')
                        })
                    ]
                }),
                state.tab == 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectStudentsDefault.default), {
                    selectedGroup: state.group,
                    students: state.students,
                    selectedStudents: state.selectedStudents,
                    checkedStudents: state.checkedStudents,
                    onGroupChange: handleGroupChange,
                    onStudentsChecked: handleStudentsChecked,
                    onStudentsChange: handleStudentsChange,
                    onCancel: handleCancel,
                    onContinue: handleContinue,
                    context: context
                }),
                state.tab == 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _writeCommentsDefault.default), {
                    selectedStudents: state.selectedStudents,
                    newComments: state.comments,
                    start: state.start,
                    finish: state.finish,
                    duration: state.duration,
                    onCommentsChange: handleCommentsChange,
                    onStartChange: handleStartChange,
                    onFinishChange: handleFinishChange,
                    onTimeChange: handleTimeChange,
                    onCancel: handleCancel,
                    onSend: handleSend,
                    context: context
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-router-dom":"3uzXR","clsx":"5PNR8","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Tabs":"g7Izf","@mui/material/Tab":"bmkB3","./info-bar":"rFTTW","./select-students":"4kIMz","./write-comments":"s6sb9","helpers/command":"f3cbG","../../components/responsive-fullscreen-dialog":"5zam1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"rFTTW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _icons = require("../../../../resources/icons");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            borderBottom: 'solid 1px #dbe3e6',
            minHeight: '60px',
            paddingLeft: '15px'
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        label: {
            paddingTop: '4px',
            marginLeft: '20px',
            fontSize: '14pt',
            [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.pxToRem(15)
            }
        }
    }));
function InfoBar({ context }) {
    const { quizAssignmentToModify } = context;
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.middle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                    fill: "#4f576e"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: `${classes.middle} ${classes.label}`,
                children: quizAssignmentToModify.title
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../../resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kIMz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectStudents);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _select = require("../../../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _transferList = require("../../../transfer-list");
var _transferListDefault = parcelHelpers.interopDefault(_transferList);
var _checklist = require("./checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: '0 20px',
            overflow: 'hidden'
        },
        group: {
            padding: '20px 0',
            maxWidth: 'calc(50% - 56px)',
            [theme.breakpoints.down('sm')]: {
                maxWidth: 'initial'
            }
        },
        students: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto'
        },
        buttons: {
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center'
            }
        },
        cancel: {
            width: '120px',
            marginRight: '10px',
            boxShadow: 'none',
            [theme.breakpoints.down('sm')]: {
                marginRight: '20px'
            }
        },
        continue: {
            width: '120px',
            color: '#fff',
            boxShadow: 'none',
            backgroundColor: '#2ca5ec'
        }
    }));
function SelectStudents(props) {
    const { selectedGroup, context } = props;
    const { groups, translate } = context;
    const classes = useStyles();
    const groupOptions = groups.map((group, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
            value: group.id,
            children: group.name
        }, key));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.group,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            translate('group_label'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
                        selectValue: selectedGroup,
                        selectOnChange: props.onGroupChange,
                        controlSize: "small",
                        controlVariant: "outlined",
                        controlFullWidth: true,
                        children: [
                            selectedGroup == '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: ""
                            }),
                            groupOptions
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.students,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                        smDown: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListDefault.default), {
                            label: ({ name })=>name,
                            left: props.students,
                            LeftHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.studentsHeader,
                                    children: [
                                        translate('students'),
                                        ":"
                                    ]
                                }),
                            RightHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.selectedHeader,
                                    children: [
                                        translate('selected'),
                                        ":"
                                    ]
                                }),
                            right: props.selectedStudents,
                            checklist: props.checkedStudents,
                            onChecked: props.onStudentsChecked,
                            onTransfer: props.onStudentsChange
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                        smUp: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: (0, _lodash.chain)(props.students).concat(props.selectedStudents).map((s)=>({
                                    ...s,
                                    label: s.alias || s.email
                                })).orderBy([
                                'label',
                                'id'
                            ]).value(),
                            selectAllTitle: translate('students_label'),
                            onChecked: props.onStudentsChange,
                            checklist: props.selectedStudents.map((s)=>s.id)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onCancel,
                        variant: "contained",
                        className: classes.cancel,
                        children: translate('cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onContinue,
                        disabled: props.selectedStudents.length == 0,
                        variant: "contained",
                        className: classes.continue,
                        children: translate('continue_label')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Hidden":"kijsg","@mui/material/Fade":"8DwqP","@mui/material/Button":"c6Y0y","../../../select":"k4sBU","../../../transfer-list":"kQWaU","./checklist":"9NZFG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kijsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _hiddenDefault.default));
var _hidden = require("./Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
'use client';

},{"./Hidden":"v4T8J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"v4T8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _hiddenJs = require("./HiddenJs");
var _hiddenJsDefault = parcelHelpers.interopDefault(_hiddenJs);
var _hiddenCss = require("./HiddenCss");
var _hiddenCssDefault = parcelHelpers.interopDefault(_hiddenCss);
/**
 * Responsively hides children based on the selected implementation.
 *
 * @deprecated The Hidden component was deprecated in Material UI v5. To learn more, see [the Hidden section](/material-ui/migration/v5-component-changes/#hidden) of the migration docs.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "implementation",
    "lgDown",
    "lgUp",
    "mdDown",
    "mdUp",
    "smDown",
    "smUp",
    "xlDown",
    "xlUp",
    "xsDown",
    "xsUp"
];
function Hidden(props) {
    const { implementation = 'js', lgDown = false, lgUp = false, mdDown = false, mdUp = false, smDown = false, smUp = false, xlDown = false, xlUp = false, xsDown = false, xsUp = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    if (implementation === 'js') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenJsDefault.default), (0, _extendsDefault.default)({
        lgDown: lgDown,
        lgUp: lgUp,
        mdDown: mdDown,
        mdUp: mdUp,
        smDown: smDown,
        smUp: smUp,
        xlDown: xlDown,
        xlUp: xlUp,
        xsDown: xsDown,
        xsUp: xsUp
    }, other));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenCssDefault.default), (0, _extendsDefault.default)({
        lgDown: lgDown,
        lgUp: lgUp,
        mdDown: mdDown,
        mdUp: mdUp,
        smDown: smDown,
        smUp: smUp,
        xlDown: xlDown,
        xlUp: xlUp,
        xsDown: xsDown,
        xsUp: xsUp
    }, other));
}
exports.default = Hidden;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","./HiddenJs":"4zjXZ","./HiddenCss":"d9BW2","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4zjXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _exactProp = require("@mui/utils/exactProp");
var _exactPropDefault = parcelHelpers.interopDefault(_exactProp);
var _withWidth = require("./withWidth");
var _withWidthDefault = parcelHelpers.interopDefault(_withWidth);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
function HiddenJs(props) {
    const { children, only, width } = props;
    const theme = (0, _useThemeDefault.default)();
    let visible = true;
    // `only` check is faster to get out sooner if used.
    if (only) {
        if (Array.isArray(only)) for(let i = 0; i < only.length; i += 1){
            const breakpoint = only[i];
            if (width === breakpoint) {
                visible = false;
                break;
            }
        }
        else if (only && width === only) visible = false;
    }
    // Allow `only` to be combined with other props. If already hidden, no need to check others.
    if (visible) // determine visibility based on the smallest size up
    for(let i = 0; i < theme.breakpoints.keys.length; i += 1){
        const breakpoint = theme.breakpoints.keys[i];
        const breakpointUp = props[`${breakpoint}Up`];
        const breakpointDown = props[`${breakpoint}Down`];
        if (breakpointUp && (0, _withWidth.isWidthUp)(breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(breakpoint, width)) {
            visible = false;
            break;
        }
    }
    if (!visible) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: children
    });
}
exports.default = (0, _withWidthDefault.default)()(HiddenJs);

},{"react":"9njXz","prop-types":"bnNSm","@mui/utils/exactProp":"7IZ8M","./withWidth":"huZ0R","../styles/useTheme":"d8hfc","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"huZ0R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWidthUp", ()=>isWidthUp);
parcelHelpers.export(exports, "isWidthDown", ()=>isWidthDown);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _getDisplayName = require("@mui/utils/getDisplayName");
var _getDisplayNameDefault = parcelHelpers.interopDefault(_getDisplayName);
var _useThemeProps = require("@mui/system/useThemeProps");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _useEnhancedEffect = require("../utils/useEnhancedEffect");
var _useEnhancedEffectDefault = parcelHelpers.interopDefault(_useEnhancedEffect);
var _useMediaQuery = require("../useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "initialWidth",
    "width"
];
const breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const isWidthUp = (breakpoint, width, inclusive = true)=>{
    if (inclusive) return breakpointKeys.indexOf(breakpoint) <= breakpointKeys.indexOf(width);
    return breakpointKeys.indexOf(breakpoint) < breakpointKeys.indexOf(width);
};
const isWidthDown = (breakpoint, width, inclusive = false)=>{
    if (inclusive) return breakpointKeys.indexOf(width) <= breakpointKeys.indexOf(breakpoint);
    return breakpointKeys.indexOf(width) < breakpointKeys.indexOf(breakpoint);
};
const withWidth = (options = {})=>(Component)=>{
        const { withTheme: withThemeOption = false, noSSR = false, initialWidth: initialWidthOption } = options;
        function WithWidth(props) {
            const contextTheme = (0, _useThemeDefault.default)();
            const theme = props.theme || contextTheme;
            const _getThemeProps = (0, _useThemeProps.getThemeProps)({
                theme,
                name: 'MuiWithWidth',
                props
            }), { initialWidth, width } = _getThemeProps, other = (0, _objectWithoutPropertiesLooseDefault.default)(_getThemeProps, _excluded);
            const [mountedState, setMountedState] = _react.useState(false);
            (0, _useEnhancedEffectDefault.default)(()=>{
                setMountedState(true);
            }, []);
            /**
     * innerWidth |xs      sm      md      lg      xl
     *            |-------|-------|-------|-------|------>
     * width      |  xs   |  sm   |  md   |  lg   |  xl
     */ const keys = theme.breakpoints.keys.slice().reverse();
            const widthComputed = keys.reduce((output, key)=>{
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const matches = (0, _useMediaQueryDefault.default)(theme.breakpoints.up(key));
                return !output && matches ? key : output;
            }, null);
            const more = (0, _extendsDefault.default)({
                width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
            }, withThemeOption ? {
                theme
            } : {}, other);
            // When rendering the component on the server,
            // we have no idea about the client browser screen width.
            // In order to prevent blinks and help the reconciliation of the React tree
            // we are not rendering the child component.
            //
            // An alternative is to use the `initialWidth` property.
            if (more.width === undefined) return null;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, (0, _extendsDefault.default)({}, more));
        }
        return WithWidth;
    };
exports.default = withWidth;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","@mui/utils/getDisplayName":"duLzC","@mui/system/useThemeProps":"3fKK0","../styles/useTheme":"d8hfc","../utils/useEnhancedEffect":"hXusa","../useMediaQuery":"bnRpi","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d9BW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _hiddenCssClasses = require("./hiddenCssClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "only"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, breakpoints } = ownerState;
    const slots = {
        root: [
            'root',
            ...breakpoints.map(({ breakpoint, dir })=>{
                return dir === 'only' ? `${dir}${(0, _capitalizeDefault.default)(breakpoint)}` : `${breakpoint}${(0, _capitalizeDefault.default)(dir)}`;
            })
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _hiddenCssClasses.getHiddenCssUtilityClass), classes);
};
const HiddenCssRoot = (0, _styledDefault.default)('div', {
    name: 'PrivateHiddenCss',
    slot: 'Root'
})(({ theme, ownerState })=>{
    const hidden = {
        display: 'none'
    };
    return (0, _extendsDefault.default)({}, ownerState.breakpoints.map(({ breakpoint, dir })=>{
        if (dir === 'only') return {
            [theme.breakpoints.only(breakpoint)]: hidden
        };
        return dir === 'up' ? {
            [theme.breakpoints.up(breakpoint)]: hidden
        } : {
            [theme.breakpoints.down(breakpoint)]: hidden
        };
    }).reduce((r, o)=>{
        Object.keys(o).forEach((k)=>{
            r[k] = o[k];
        });
        return r;
    }, {}));
});
/**
 * @ignore - internal component.
 */ function HiddenCss(props) {
    const { children, className, only } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const theme = (0, _useThemeDefault.default)();
    const breakpoints = [];
    for(let i = 0; i < theme.breakpoints.keys.length; i += 1){
        const breakpoint = theme.breakpoints.keys[i];
        const breakpointUp = other[`${breakpoint}Up`];
        const breakpointDown = other[`${breakpoint}Down`];
        if (breakpointUp) breakpoints.push({
            breakpoint,
            dir: 'up'
        });
        if (breakpointDown) breakpoints.push({
            breakpoint,
            dir: 'down'
        });
    }
    if (only) {
        const onlyBreakpoints = Array.isArray(only) ? only : [
            only
        ];
        onlyBreakpoints.forEach((breakpoint)=>{
            breakpoints.push({
                breakpoint,
                dir: 'only'
            });
        });
    }
    const ownerState = (0, _extendsDefault.default)({}, props, {
        breakpoints
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(HiddenCssRoot, {
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        children: children
    });
}
exports.default = HiddenCss;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","clsx":"bK0Bf","prop-types":"bnNSm","@mui/utils/composeClasses":"43D21","../utils/capitalize":"hBZko","../styles/styled":"bTnxF","../styles/useTheme":"d8hfc","./hiddenCssClasses":"g0t8v","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0t8v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getHiddenCssUtilityClass", ()=>getHiddenCssUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getHiddenCssUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('PrivateHiddenCss', slot);
}
const hiddenCssClasses = (0, _generateUtilityClassesDefault.default)('PrivateHiddenCss', [
    'root',
    'xlDown',
    'xlUp',
    'onlyXl',
    'lgDown',
    'lgUp',
    'onlyLg',
    'mdDown',
    'mdUp',
    'onlyMd',
    'smDown',
    'smUp',
    'onlySm',
    'xsDown',
    'xsUp',
    'onlyXs'
]);
exports.default = hiddenCssClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k4sBU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _utils = require("../helpers/utils");
function SelectInput(props) {
    const [labelWidth, setLabelWidth] = (0, _reactDefault.default).useState(0);
    const labelRef = (0, _reactDefault.default).useRef(null);
    const errorId = `${props.id}-error-text`;
    (0, _reactDefault.default).useEffect(()=>setLabelWidth(labelRef.current.offsetWidth), []);
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const labelAttributes = (0, _utils.pickAttributes)(props, 'label');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        ...controlAttributes,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                ref: labelRef,
                ...labelAttributes,
                children: props.caption
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                native: true,
                "aria-describedby": errorId,
                ...selectAttributes,
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                id: errorId,
                ...(0, _utils.pickAttributes)(props, 'error'),
                children: props.errorMessage
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Select":"aY7hn","@mui/material/InputLabel":"iTW3B","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kQWaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TransferList);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _icons = require("../resources/icons");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1
        },
        left: {
            flexGrow: 1,
            width: 'calc(50% - 100px)'
        },
        right: {
            flexGrow: 1,
            width: 'calc(50% - 100px)'
        },
        checked: {
            backgroundColor: '#2ca5ec',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#2ca5ec'
            }
        },
        operations: {
            margin: '0 25px',
            display: 'flex',
            "& .button": {
                marginTop: 15,
                "&:first-child": {
                    marginTop: 0
                }
            }
        },
        paper: {
            border: 'solid 1px #b0b0b0',
            boxShadow: 'none',
            height: 'calc(100% - 30px)',
            flexGrow: 1
        }
    }));
const Button = (0, _material.withStyles)((theme)=>({
        root: {
            width: '50px',
            height: '50px',
            '&:hover': {
                transform: 'scale(1.02)'
            }
        },
        disabled: {
            opacity: 0.5
        }
    }))((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        item: true,
        className: "button",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "outlined",
            size: "small",
            ...props,
            children: props.children
        })
    }));
function ListElem(props) {
    const { index, label, checked, onClick } = props;
    const labelId = `transfer-list-item-${index}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemDefault.default), {
        role: "listitem",
        button: true,
        onClick: onClick,
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
            id: labelId,
            primary: label
        })
    });
}
function TransferList(props) {
    const classes = useStyles();
    const { left, right, checklist, LeftHeader, RightHeader, id = (elem)=>typeof elem == 'object' ? elem.id : elem, label = (elem)=>typeof elem == 'object' ? elem.label : elem, ListItem = ListElem, onChecked } = props;
    const isChecked = (elem)=>checklist[id(elem)];
    const isNotChecked = (elem)=>!checklist[id(elem)];
    const createItem = (elem, index)=>{
        const key = id(elem);
        const checked = checklist[key];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItem, {
            index: index,
            label: label(elem),
            checked: checked,
            className: (0, _clsxDefault.default)({
                [classes.checked]: checked
            }),
            onClick: ()=>onChecked(key, !checked)
        }, key);
    };
    function handleTransfer(source, sourceKey, sink, sinkKey, all) {
        return ()=>{
            const newSource = all ? [] : source.filter(isNotChecked);
            const newSink = sink.concat(all ? source : source.filter(isChecked));
            props.onTransfer({
                [sourceKey]: newSource,
                [sinkKey]: newSink
            });
        };
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        container: true,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                className: classes.left,
                children: [
                    LeftHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftHeader, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                        className: classes.paper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                            dense: true,
                            component: "div",
                            role: "list",
                            children: left.map(createItem)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                item: true,
                className: classes.operations,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    container: true,
                    direction: "column",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
                            disabled: left.length == 0,
                            onClick: handleTransfer(left, 'left', right, 'right', true),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DoubleArrowRightIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
                            disabled: left.find(isChecked) == undefined,
                            onClick: handleTransfer(left, 'left', right, 'right'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowRightIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
                            disabled: right.find(isChecked) == undefined,
                            onClick: handleTransfer(right, 'right', left, 'left'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowLeftIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Button, {
                            disabled: right.length == 0,
                            onClick: handleTransfer(right, 'right', left, 'left', true),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DoubleArrowLeftIcon), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                className: classes.right,
                children: [
                    RightHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightHeader, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                        className: classes.paper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                            dense: true,
                            component: "div",
                            role: "list",
                            children: right.map(createItem)
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Grid":"ggUwv","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/material/Checkbox":"4sdMA","@mui/material/Button":"c6Y0y","@mui/material/Paper":"arHf6","../resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ggUwv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _gridDefault.default));
parcelHelpers.export(exports, "gridClasses", ()=>(0, _gridClassesDefault.default));
var _grid = require("./Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _gridClasses = require("./gridClasses");
var _gridClassesDefault = parcelHelpers.interopDefault(_gridClasses);
parcelHelpers.exportAll(_gridClasses, exports);
'use client';

},{"./Grid":"6gZT0","./gridClasses":"bgUMl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6gZT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateGrid", ()=>generateGrid);
parcelHelpers.export(exports, "generateDirection", ()=>generateDirection);
parcelHelpers.export(exports, "generateRowGap", ()=>generateRowGap);
parcelHelpers.export(exports, "generateColumnGap", ()=>generateColumnGap);
parcelHelpers.export(exports, "resolveSpacingStyles", ()=>resolveSpacingStyles);
parcelHelpers.export(exports, "resolveSpacingClasses", ()=>resolveSpacingClasses);
// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _system = require("@mui/system");
var _styleFunctionSx = require("@mui/system/styleFunctionSx");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _requirePropFactory = require("../utils/requirePropFactory");
var _requirePropFactoryDefault = parcelHelpers.interopDefault(_requirePropFactory);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _useTheme = require("../styles/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _gridContext = require("./GridContext");
var _gridContextDefault = parcelHelpers.interopDefault(_gridContext);
var _gridClasses = require("./gridClasses");
var _gridClassesDefault = parcelHelpers.interopDefault(_gridClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function generateGrid({ theme, ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, _system.unstable_resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, _extendsDefault.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function generateDirection({ theme, ownerState }) {
    const directionValues = (0, _system.unstable_resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, _system.handleBreakpoints)({
        theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, _gridClassesDefault.default).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function extractZeroValueBreakpointKeys({ breakpoints, values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function generateRowGap({ theme, ownerState }) {
    const { container, rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, _system.unstable_resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, _system.handleBreakpoints)({
            theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${getOffset(themeSpacing)}`,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingTop: getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function generateColumnGap({ theme, ownerState }) {
    const { container, columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, _system.unstable_resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, _system.handleBreakpoints)({
            theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${getOffset(themeSpacing)})`,
                marginLeft: `-${getOffset(themeSpacing)}`,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingLeft: getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, _gridClassesDefault.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function resolveSpacingStyles(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const GridRoot = (0, _styledDefault.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        const { container, direction, item, spacing, wrap, zeroMinWidth, breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = resolveSpacingStyles(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), generateDirection, generateRowGap, generateColumnGap, generateGrid);
function resolveSpacingClasses(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const useUtilityClasses = (ownerState)=>{
    const { classes, container, direction, item, spacing, wrap, zeroMinWidth, breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = resolveSpacingClasses(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _gridClasses.getGridUtilityClass), classes);
};
const Grid = /*#__PURE__*/ _react.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints } = (0, _useThemeDefault.default)();
    const props = (0, _styleFunctionSx.extendSxProp)(themeProps);
    const { className, columns: columnsProp, columnSpacing: columnSpacingProp, component = 'div', container = false, direction = 'row', item = false, rowSpacing: rowSpacingProp, spacing = 0, wrap = 'wrap', zeroMinWidth = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = _react.useContext((0, _gridContextDefault.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, _extendsDefault.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        columns,
        container,
        direction,
        item,
        rowSpacing,
        columnSpacing,
        wrap,
        zeroMinWidth,
        spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridContextDefault.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(GridRoot, (0, _extendsDefault.default)({
            ownerState: ownerState,
            className: (0, _clsxDefault.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
exports.default = Grid;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/system":"5Hnj5","@mui/system/styleFunctionSx":"8WdLC","@mui/utils/composeClasses":"43D21","../utils/requirePropFactory":"g4unq","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../styles/useTheme":"d8hfc","./GridContext":"erhYu","./gridClasses":"bgUMl","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"erhYu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
'use client';
/**
 * @ignore - internal component.
 */ const GridContext = /*#__PURE__*/ _react.createContext();
exports.default = GridContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bgUMl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGridUtilityClass", ()=>getGridUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getGridUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiGrid', slot);
}
const SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const gridClasses = (0, _generateUtilityClassesDefault.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
exports.default = gridClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9NZFG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckList);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
const useStyles = (0, _material.makeStyles)((theme)=>({
        card: {
            flexGrow: 1,
            border: 'solid 1px #b0b0b0',
            boxShadow: 'none',
            overflowY: 'auto',
            height: '100%',
            flexGrow: 1
        }
    }));
function ListElem(props) {
    const { id, label, checked, onClick } = props;
    const labelId = `transfer-list-item-${id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
        role: "listitem",
        button: true,
        onClick: onClick,
        className: props.className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: checked,
                    tabIndex: -1,
                    disableRipple: true,
                    inputProps: {
                        'aria-labelledby': labelId
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                id: labelId,
                primary: label
            })
        ]
    });
}
function CheckList(props) {
    const classes = useStyles();
    const { checklist, selectAllTitle, id = (elem)=>typeof elem == 'object' ? elem.id : elem, label = (elem)=>typeof elem == 'object' ? elem.label : elem, ListItem = ListElem, onChecked } = props;
    const isChecked = (elem)=>checklist.indexOf(id(elem)) >= 0;
    const isNotChecked = (elem)=>checklist.indexOf(id(elem)) < 0;
    const items = props.items.map((item)=>({
            id: id(item),
            checked: isChecked(item),
            item
        }));
    const createItem = ({ id, checked, item })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItem, {
            id: id,
            label: label(item),
            checked: checked,
            className: (0, _clsxDefault.default)({
                [classes.checked]: checked
            }),
            onClick: ()=>{
                const left = items.filter((i)=>i.id != id && !i.checked).map((i)=>i.item);
                const right = items.filter((i)=>i.id != id && i.checked).map((i)=>i.item);
                if (checked) onChecked({
                    left: [
                        ...left,
                        item
                    ],
                    right
                });
                else onChecked({
                    left,
                    right: [
                        ...right,
                        item
                    ]
                });
            }
        }, id);
    };
    const allChecked = (0, _lodash.every)(items, (item)=>item.checked);
    const noneChecked = (0, _lodash.every)(items, (item)=>!item.checked);
    const someChecked = !allChecked && !noneChecked;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        className: classes.card,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                className: classes.cardHeader,
                avatar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    onClick: ()=>{
                        if (noneChecked || someChecked) onChecked({
                            left: [],
                            right: [
                                ...props.items
                            ]
                        });
                        else onChecked({
                            left: [
                                ...props.items
                            ],
                            right: []
                        });
                    },
                    checked: allChecked,
                    indeterminate: someChecked,
                    disabled: items.length === 0,
                    inputProps: {
                        'aria-label': 'all items selected'
                    }
                }),
                title: selectAllTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                dense: true,
                component: "div",
                role: "list",
                children: items.map(createItem)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Grid":"ggUwv","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/material/Checkbox":"4sdMA","@mui/material/Card":"1fzLS","@mui/material/Divider":"5Ykub","@mui/material/CardHeader":"kanB9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fzLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cardDefault.default));
parcelHelpers.export(exports, "cardClasses", ()=>(0, _cardClassesDefault.default));
var _card = require("./Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _cardClasses = require("./cardClasses");
var _cardClassesDefault = parcelHelpers.interopDefault(_cardClasses);
parcelHelpers.exportAll(_cardClasses, exports);
'use client';

},{"./Card":"ipjat","./cardClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ipjat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _chainPropTypes = require("@mui/utils/chainPropTypes");
var _chainPropTypesDefault = parcelHelpers.interopDefault(_chainPropTypes);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _cardClasses = require("./cardClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "raised"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _cardClasses.getCardUtilityClass), classes);
};
const CardRoot = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const Card = /*#__PURE__*/ _react.forwardRef(function Card(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className, raised = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        raised
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
exports.default = Card;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/chainPropTypes":"83tGg","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../Paper":"arHf6","./cardClasses":"gBSUg","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gBSUg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCardUtilityClass", ()=>getCardUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCardUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiCard', slot);
}
const cardClasses = (0, _generateUtilityClassesDefault.default)('MuiCard', [
    'root'
]);
exports.default = cardClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kanB9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _cardHeaderDefault.default));
parcelHelpers.export(exports, "cardHeaderClasses", ()=>(0, _cardHeaderClassesDefault.default));
var _cardHeader = require("./CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
var _cardHeaderClasses = require("./cardHeaderClasses");
var _cardHeaderClassesDefault = parcelHelpers.interopDefault(_cardHeaderClasses);
parcelHelpers.exportAll(_cardHeaderClasses, exports);
'use client';

},{"./CardHeader":"92Ivd","./cardHeaderClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"92Ivd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _cardHeaderClasses = require("./cardHeaderClasses");
var _cardHeaderClassesDefault = parcelHelpers.interopDefault(_cardHeaderClasses);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "action",
    "avatar",
    "className",
    "component",
    "disableTypography",
    "subheader",
    "subheaderTypographyProps",
    "title",
    "titleTypographyProps"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _cardHeaderClasses.getCardHeaderUtilityClass), classes);
};
const CardHeaderRoot = (0, _styledDefault.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>(0, _extendsDefault.default)({
            [`& .${(0, _cardHeaderClassesDefault.default).title}`]: styles.title,
            [`& .${(0, _cardHeaderClassesDefault.default).subheader}`]: styles.subheader
        }, styles.root)
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const CardHeaderAvatar = (0, _styledDefault.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar',
    overridesResolver: (props, styles)=>styles.avatar
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const CardHeaderAction = (0, _styledDefault.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const CardHeaderContent = (0, _styledDefault.default)('div', {
    name: 'MuiCardHeader',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})({
    flex: '1 1 auto'
});
const CardHeader = /*#__PURE__*/ _react.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action, avatar, className, component = 'div', disableTypography = false, subheader: subheaderProp, subheaderTypographyProps, title: titleProp, titleTypographyProps } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        component,
        disableTypography
    });
    const classes = useUtilityClasses(ownerState);
    let title = titleProp;
    if (title != null && title.type !== (0, _typographyDefault.default) && !disableTypography) title = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: avatar ? 'body2' : 'h5',
        className: classes.title,
        component: "span",
        display: "block"
    }, titleTypographyProps, {
        children: title
    }));
    let subheader = subheaderProp;
    if (subheader != null && subheader.type !== (0, _typographyDefault.default) && !disableTypography) subheader = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), (0, _extendsDefault.default)({
        variant: avatar ? 'body2' : 'body1',
        className: classes.subheader,
        color: "text.secondary",
        component: "span",
        display: "block"
    }, subheaderTypographyProps, {
        children: subheader
    }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CardHeaderRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        as: component,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            avatar && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardHeaderAvatar, {
                className: classes.avatar,
                ownerState: ownerState,
                children: avatar
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(CardHeaderContent, {
                className: classes.content,
                ownerState: ownerState,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CardHeaderAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            })
        ]
    }));
});
exports.default = CardHeader;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../Typography":"2wCD5","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./cardHeaderClasses":"95bcj","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"95bcj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCardHeaderUtilityClass", ()=>getCardHeaderUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getCardHeaderUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiCardHeader', slot);
}
const cardHeaderClasses = (0, _generateUtilityClassesDefault.default)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
exports.default = cardHeaderClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"s6sb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WriteComments);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _locale = require("date-fns/locale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: '0 20px',
            overflow: 'hidden'
        },
        label: {
            padding: '20px 0'
        },
        comments: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto',
            '& textarea': {
                flexGrow: 1,
                resize: 'none'
            }
        },
        buttons: {
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center'
            }
        },
        cancel: {
            width: '120px',
            marginRight: '20px',
            boxShadow: 'none',
            [theme.breakpoints.down('sm')]: {
                marginRight: '30px'
            }
        },
        send: {
            width: '120px',
            color: '#fff',
            boxShadow: 'none',
            backgroundColor: '#2ca5ec'
        },
        dateDuration: {
            display: 'flex',
            marginTop: 20,
            marginBottom: 20
        },
        dates: {
            display: 'flex'
        },
        datePicker: {
            marginTop: 10,
            marginRight: 20,
            "& .date-input": {
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                padding: 5
            },
            "& svg": {
                marginRight: 5
            }
        },
        durationInput: {
            marginTop: 10,
            marginRight: 20,
            "& input": {
                padding: '3px 5px',
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                fontSize: '1rem',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: '0.00938em'
            }
        },
        duration: {
            display: 'flex'
        }
    }));
function WriteComments(props) {
    const { newComments, context } = props;
    const hours = Math.floor(props.duration / 3600);
    const minutes = Math.floor(props.duration % 3600 / 60);
    const { translate } = context;
    const classes = useStyles();
    const canSave = props.selectedStudents.length > 0 && props.duration > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.dateDuration,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.dates,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "from",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("start")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                            locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                            selected: (0, _momentDefault.default)(props.start).toDate(),
                                            minDate: new Date(),
                                            maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                            showTimeInput: true,
                                            dateFormat: "MM/dd/yyyy h:mm aa",
                                            onChange: props.onStartChange
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "to",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("end")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                            locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                            selected: (0, _momentDefault.default)(props.finish).toDate(),
                                            minDate: (0, _momentDefault.default)(props.start).toDate(),
                                            maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                            showTimeInput: true,
                                            dateFormat: "MM/dd/yyyy h:mm aa",
                                            timeIntervals: 60,
                                            onChange: props.onFinishChange
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.duration,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "hours",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("hours")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: hours,
                                            onChange: (e)=>{
                                                const value = parseInt(e.target.value);
                                                const hours = isNaN(value) ? 0 : value;
                                                props.onTimeChange({
                                                    hours,
                                                    minutes
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "minutes",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("minutes")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: minutes,
                                            onChange: (e)=>{
                                                const value = parseInt(e.target.value);
                                                const minutes = isNaN(value) ? 0 : value;
                                                props.onTimeChange({
                                                    hours,
                                                    minutes
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.label,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: translate('comment')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.comments,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                    autoFocus: true,
                    value: newComments,
                    onChange: props.onCommentsChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onCancel,
                        variant: "contained",
                        className: classes.cancel,
                        children: translate('cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onSend,
                        disabled: !canSave,
                        variant: "contained",
                        className: classes.send,
                        children: translate('save_label')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","date-fns/locale":"dElgW","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Hidden":"kijsg","@mui/material/Typography":"2wCD5","@mui/material/Button":"c6Y0y","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-datepicker/dist/react-datepicker.css":"chsuV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"5zam1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResponsiveDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _utils = require("helpers/utils");
function ResponsiveDialog(props) {
    const { open, close, confirm, cancel, TitleComponent } = props;
    const theme = (0, _material.useTheme)();
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const dialogProps = (0, _utils.pickAttributes)(props, 'dialog');
    const titleProps = (0, _utils.pickAttributes)(props, 'head');
    const contentProps = (0, _utils.pickAttributes)(props, 'content');
    const actionsProps = (0, _utils.pickAttributes)(props, 'actions');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        fullScreen: fullScreen,
        open: open,
        onClose: (e)=>close(e),
        "aria-labelledby": "responsive-dialog-title",
        ...dialogProps,
        children: [
            props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                id: "responsive-dialog-title",
                ...titleProps,
                children: props.title
            }),
            TitleComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                id: "responsive-dialog-title",
                ...titleProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleComponent, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                ...contentProps,
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                ...actionsProps,
                children: [
                    cancel && cancel,
                    confirm && confirm
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ieGsn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditStudentAssignment);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _material = require("external/material");
var _command = require("helpers/command");
var _selectStudents = require("./SelectStudents");
var _selectStudentsDefault = parcelHelpers.interopDefault(_selectStudents);
var _infoBar = require("./InfoBar");
var _infoBarDefault = parcelHelpers.interopDefault(_infoBar);
var _assignmentInfo = require("./AssignmentInfo");
var _assignmentInfoDefault = parcelHelpers.interopDefault(_assignmentInfo);
const initialState = {
    students: [],
    selectedStudents: [],
    checkedStudents: {}
};
const useStyles = (0, _material.makeStyles)(editStudentAssignmentStyles);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
function EditStudentAssignment({ context }) {
    const theme = (0, _material.useTheme)();
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const { translate, updateState, quizAssignmentToModify: assignment, quizDialogs } = context;
    const classes = useStyles();
    const dialogClasses = useDialogStyles();
    const [state, setState] = (0, _reactDefault.default).useState(initialState);
    const isOpen = quizDialogs['edit-student-assignment'] !== false && assignment.id != undefined;
    function handleStudentsChecked(id, value) {
        setState({
            ...state,
            checkedStudents: {
                ...state.checkedStudents,
                [id]: value
            }
        });
    }
    function handleStudentsChange({ left, right }) {
        setState({
            ...state,
            students: left,
            selectedStudents: right
        });
    }
    async function handleSave() {
        const { id } = assignment;
        const students = state.selectedStudents.map((s)=>s.id);
        await (0, _command.createPost)('quiz', 'updateStudentAssignment')({
            id,
            students
        });
        await context.updateState({
            quizAssignmentCalls: {
                $apply: (c)=>c + 1
            }
        });
        close();
    }
    async function close() {
        await context.updateState({
            quizDialogs: {
                ['edit-student-assignment']: {
                    $set: false
                }
            }
        });
    }
    const expired = (0, _momentDefault.default)().isAfter(assignment.finish);
    (0, _reactDefault.default).useEffect(()=>{
        if (assignment.id != undefined) {
            const { group } = assignment;
            const { students: groupStudents = [] } = context.groups.find((g)=>g.id == group) || {};
            const students = groupStudents.filter((s)=>assignment.students.indexOf(s.id) < 0);
            const selectedStudents = groupStudents.filter((s)=>assignment.students.indexOf(s.id) > -1).map((s)=>({
                    ...s,
                    readOnly: expired || assignment.started.indexOf(s.studentId) >= 0
                }));
            const checkedStudents = groupStudents.reduce((acc, s)=>{
                acc[s.id] = false;
                return acc;
            }, {});
            setState({
                ...state,
                students: (0, _lodash.orderBy)(students, [
                    'name'
                ]),
                checkedStudents,
                selectedStudents: (0, _lodash.orderBy)(selectedStudents, [
                    'readOnly',
                    'name'
                ], [
                    'desc',
                    'asc'
                ])
            });
        }
    }, [
        assignment
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        fullScreen: fullScreen,
        open: isOpen,
        onClose: (e)=>close(e),
        classes: dialogClasses,
        "aria-labelledby": "edit-student-assignment-responsive-dialog-title",
        maxWidth: "lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogTitleDefault.default), {
                id: "edit-student-assignment-responsive-dialog-title",
                className: classes.title,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBarDefault.default), {
                    context: context
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                className: classes.content,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.info,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentInfoDefault.default), {
                            context: context
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.students,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectStudentsDefault.default), {
                            expired: expired,
                            students: state.students,
                            selectedStudents: state.selectedStudents,
                            checkedStudents: state.checkedStudents,
                            onStudentsChecked: handleStudentsChecked,
                            onStudentsChange: handleStudentsChange,
                            context: context
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogActionsDefault.default), {
                className: classes.actions,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "outlined",
                        className: (0, _clsxDefault.default)(classes.button, "cancel"),
                        color: "secondary",
                        onClick: close,
                        children: translate(expired ? 'close' : 'cancel')
                    }),
                    !expired && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        variant: "contained",
                        color: "primary",
                        className: (0, _clsxDefault.default)(classes.button, "save"),
                        onClick: handleSave,
                        children: translate('save')
                    })
                ]
            })
        ]
    });
}
function dialogStyles(theme) {
    return {
        paper: {
            width: '100%',
            padding: 0,
            height: 'calc(100% - 100px)'
        }
    };
}
function editStudentAssignmentStyles(theme) {
    return {
        root: {},
        content: {
            display: 'flex',
            flexDirection: 'column',
            padding: '20px 24px 0 24px'
        },
        students: {
            display: 'flex',
            marginTop: 20,
            flexGrow: 1
        },
        title: {
            padding: 0
        },
        actions: {
            padding: '20px 24px'
        },
        button: {
            textTransform: 'none',
            "&.cancel": {
                color: '#3d4556',
                border: 'solid 1px #3d4556'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/material/Dialog":"255tO","@mui/material/DialogActions":"5WZHz","@mui/material/DialogContent":"gD0J9","@mui/material/DialogTitle":"5sOv1","external/material":"6yEDE","helpers/command":"f3cbG","./SelectStudents":"43tVE","./InfoBar":"6KuxN","./AssignmentInfo":"iAN84","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43tVE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectStudents);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _transferList = require("./TransferList");
var _transferListDefault = parcelHelpers.interopDefault(_transferList);
var _checkList = require("./CheckList");
var _checkListDefault = parcelHelpers.interopDefault(_checkList);
const useStyles = (0, _material.makeStyles)(selectStudentsStyles);
function SelectStudents(props) {
    const { translate } = props.context;
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                smDown: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListDefault.default), {
                    label: ({ name })=>name,
                    left: props.students,
                    LeftHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.label, "studentsHeader"),
                            children: [
                                translate('students'),
                                ":"
                            ]
                        }),
                    RightHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.label, "selectedHeader"),
                            children: [
                                translate('selected'),
                                ":"
                            ]
                        }),
                    disabled: props.expired,
                    right: props.selectedStudents,
                    checklist: props.checkedStudents,
                    onChecked: props.onStudentsChecked,
                    onTransfer: props.onStudentsChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                smUp: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkListDefault.default), {
                    items: (0, _lodash.chain)(props.students).concat(props.selectedStudents).map((s)=>({
                            ...s,
                            label: s.name
                        })).orderBy([
                        'label',
                        'id'
                    ]).value(),
                    selectAllTitle: translate('students_label'),
                    onChecked: props.onStudentsChange,
                    checklist: props.selectedStudents.map((s)=>s.id)
                })
            })
        ]
    });
}
function selectStudentsStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: 0,
            overflowY: 'auto'
        },
        label: {
            marginBottom: 5
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Hidden":"kijsg","./TransferList":"dFvqP","./CheckList":"fdnpC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dFvqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TransferList);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _icons = require("../../../../resources/icons");
var _transferListButton = require("./TransferListButton");
var _transferListButtonDefault = parcelHelpers.interopDefault(_transferListButton);
const useStyles = (0, _material.makeStyles)(transferListStyles);
function ListElem(props) {
    const { index, label, checked, onClick, disabled } = props;
    const labelId = `transfer-list-item-${index}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemDefault.default), {
        role: "listitem",
        button: true,
        onClick: onClick,
        className: props.className,
        disabled: disabled,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
            id: labelId,
            primary: label
        })
    });
}
function TransferList(props) {
    const classes = useStyles();
    const { left, right, checklist, LeftHeader, RightHeader, id = (elem)=>typeof elem == 'object' ? elem.id : elem, label = (elem)=>typeof elem == 'object' ? elem.label : elem, ListItem = ListElem, onChecked } = props;
    const isChecked = (elem)=>checklist[id(elem)];
    const isNotDisabled = (elem)=>elem.readOnly !== true;
    const isDisabled = (elem)=>elem.readOnly === true;
    const isNotChecked = (elem)=>!checklist[id(elem)];
    const createItem = (elem, index)=>{
        const key = id(elem);
        const checked = checklist[key];
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItem, {
            index: index,
            label: label(elem),
            checked: checked,
            disabled: elem.readOnly === true,
            className: (0, _clsxDefault.default)({
                [classes.checked]: checked
            }),
            onClick: ()=>onChecked(key, !checked)
        }, key);
    };
    function handleTransfer(source, sourceKey, sink, sinkKey, all) {
        return ()=>{
            const newSource = all ? source.filter(isDisabled) : source.filter(isNotChecked);
            const newSink = sink.concat(all ? source.filter(isNotDisabled) : source.filter(isChecked));
            props.onTransfer({
                [sourceKey]: newSource,
                [sinkKey]: newSink
            });
        };
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        container: true,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                className: classes.left,
                children: [
                    LeftHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LeftHeader, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                        className: classes.paper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                            dense: true,
                            component: "div",
                            role: "list",
                            children: left.map(createItem)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                item: true,
                className: classes.operations,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                    container: true,
                    direction: "column",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListButtonDefault.default), {
                            disabled: props.disabled || left.length == 0,
                            onClick: handleTransfer(left, 'left', right, 'right', true),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DoubleArrowRightIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListButtonDefault.default), {
                            disabled: props.disabled || left.find(isChecked) == undefined,
                            onClick: handleTransfer(left, 'left', right, 'right'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowRightIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListButtonDefault.default), {
                            disabled: props.disabled || right.find(isChecked) == undefined,
                            onClick: handleTransfer(right, 'right', left, 'left'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowLeftIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListButtonDefault.default), {
                            disabled: props.disabled || right.length == 0,
                            onClick: handleTransfer(right, 'right', left, 'left', true),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DoubleArrowLeftIcon), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                className: classes.right,
                children: [
                    RightHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)(RightHeader, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paperDefault.default), {
                        className: classes.paper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                            dense: true,
                            component: "div",
                            role: "list",
                            children: right.map(createItem)
                        })
                    })
                ]
            })
        ]
    });
}
function transferListStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1
        },
        left: {
            flexGrow: 1,
            width: 'calc(50% - 100px)'
        },
        right: {
            flexGrow: 1,
            width: 'calc(50% - 100px)'
        },
        checked: {
            backgroundColor: '#2ca5ec',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#2ca5ec'
            }
        },
        operations: {
            margin: '0 25px',
            display: 'flex',
            "& .button": {
                marginTop: 15,
                "&:first-child": {
                    marginTop: 0
                }
            }
        },
        paper: {
            border: 'solid 1px #b0b0b0',
            boxShadow: 'none',
            height: 'calc(100% - 30px)',
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Grid":"ggUwv","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/material/Checkbox":"4sdMA","@mui/material/Paper":"arHf6","../../../../resources/icons":"7BMUb","./TransferListButton":"g4fnv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4fnv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TransferListButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const TransferListButton = (0, _material.withStyles)((theme)=>({
        root: {
            width: '50px',
            height: '50px',
            '&:hover': {
                transform: 'scale(1.02)'
            }
        },
        disabled: {
            opacity: 0.5
        }
    }))((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        item: true,
        className: "button",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "outlined",
            size: "small",
            ...props,
            children: props.children
        })
    }));

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Grid":"ggUwv","@mui/material/Button":"c6Y0y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fdnpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckList);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
const useStyles = (0, _material.makeStyles)((theme)=>({
        card: {
            flexGrow: 1,
            border: 'solid 1px #b0b0b0',
            boxShadow: 'none',
            overflowY: 'auto',
            height: '100%',
            flexGrow: 1
        }
    }));
function ListElem(props) {
    const { id, label, checked, onClick, disabled } = props;
    const labelId = `transfer-list-item-${id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
        role: "listitem",
        button: true,
        onClick: onClick,
        className: props.className,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    color: "primary",
                    checked: checked,
                    tabIndex: -1,
                    disableRipple: true,
                    inputProps: {
                        'aria-labelledby': labelId
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                id: labelId,
                primary: label
            })
        ]
    });
}
function CheckList(props) {
    const classes = useStyles();
    const { checklist, selectAllTitle, id = (elem)=>typeof elem == 'object' ? elem.id : elem, label = (elem)=>typeof elem == 'object' ? elem.label : elem, ListItem = ListElem, onChecked } = props;
    const isChecked = (elem)=>checklist.indexOf(id(elem)) >= 0;
    const isNotChecked = (elem)=>checklist.indexOf(id(elem)) < 0;
    const items = props.items.map((item)=>({
            id: id(item),
            checked: isChecked(item),
            item
        }));
    const createItem = ({ id, checked, item })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItem, {
            id: id,
            label: label(item),
            checked: checked,
            disabled: item.readOnly,
            className: (0, _clsxDefault.default)({
                [classes.checked]: checked
            }),
            onClick: ()=>{
                const left = items.filter((i)=>i.id != id && !i.checked).map((i)=>i.item);
                const right = items.filter((i)=>i.id != id && i.checked).map((i)=>i.item);
                if (checked) onChecked({
                    left: [
                        ...left,
                        item
                    ],
                    right
                });
                else onChecked({
                    left,
                    right: [
                        ...right,
                        item
                    ]
                });
            }
        }, id);
    };
    const allChecked = (0, _lodash.every)(items, (item)=>item.checked);
    const noneChecked = (0, _lodash.every)(items, (item)=>!item.checked);
    const someChecked = !allChecked && !noneChecked;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        className: classes.card,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                className: classes.cardHeader,
                avatar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    color: "primary",
                    onClick: ()=>{
                        if (noneChecked || someChecked) onChecked({
                            left: [],
                            right: [
                                ...props.items
                            ]
                        });
                        else onChecked({
                            left: props.items.filter((i)=>!i.readOnly),
                            right: props.items.filter((i)=>i.readOnly)
                        });
                    },
                    checked: allChecked,
                    indeterminate: someChecked,
                    disabled: items.length === 0,
                    inputProps: {
                        'aria-label': 'all items selected'
                    }
                }),
                title: selectAllTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                dense: true,
                component: "div",
                role: "list",
                children: items.map(createItem)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Grid":"ggUwv","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/material/Checkbox":"4sdMA","@mui/material/Card":"1fzLS","@mui/material/Divider":"5Ykub","@mui/material/CardHeader":"kanB9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6KuxN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _icons = require("../../../../resources/icons");
const useStyles = (0, _material.makeStyles)(infoBarStyles);
function InfoBar({ context }) {
    const { quizAssignmentToModify: assignment } = context;
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.middle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                    fill: "#4f576e"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: `${classes.middle} ${classes.label}`,
                children: assignment.title
            })
        ]
    });
}
function infoBarStyles(theme) {
    return {
        root: {
            display: 'flex',
            borderBottom: 'solid 1px #dbe3e6',
            padding: 10,
            minHeight: '40px'
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        label: {
            marginLeft: 10,
            fontSize: '14pt',
            [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.pxToRem(15)
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../../resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iAN84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WriteComments);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(infoStyles);
function WriteComments({ context }) {
    const { quizAssignmentToModify: assignment, translate } = context;
    const hours = Math.floor(assignment.duration / 3600);
    const minutes = assignment.duration % 3600 / 60;
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "group"),
                children: translate('group_label')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.container, "group"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.group,
                    children: assignment.groupName
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.dateDuration,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.dates,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "from",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.label,
                                        children: translate("start")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: "date-input",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                                                }),
                                                (0, _momentDefault.default)(assignment.start).format("MM/DD/yyyy h:mm a")
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "to",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.label,
                                        children: translate("end")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: "date-input",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                                                }),
                                                (0, _momentDefault.default)(assignment.finish).format("MM/DD/yyyy h:mm a")
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.duration,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "hours",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.label,
                                        children: translate("hours")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: hours,
                                            readOnly: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "minutes",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.label,
                                        children: translate("minutes")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: minutes,
                                            readOnly: true
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !(0, _utils.isEmpty)(assignment.comments) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.label, "comments"),
                        children: translate('comment')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.comments,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                            value: assignment.comments,
                            readOnly: true
                        })
                    })
                ]
            })
        ]
    });
}
function infoStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: 0,
            overflow: 'hidden'
        },
        comments: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto',
            "& textarea": {
                flexGrow: 1,
                resize: 'none'
            }
        },
        label: {
            marginBottom: 5,
            "&.comments": {
                marginTop: 20
            }
        },
        dateDuration: {
            display: 'flex',
            marginTop: 20
        },
        dates: {
            display: 'flex'
        },
        container: {
            "&.group": {
                display: 'flex'
            }
        },
        group: {
            border: 'solid 1px #4F576E',
            borderRadius: 2,
            minWidth: 372,
            padding: 5
        },
        datePicker: {
            marginRight: 20,
            "& .date-input": {
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                padding: 5
            },
            "& svg": {
                marginRight: 5
            }
        },
        durationInput: {
            marginRight: 20,
            "& input": {
                padding: '3px 5px',
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                fontSize: '1rem',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: '0.00938em'
            }
        },
        duration: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","moment":"1e4qG","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j75jd":[function() {},{}],"5p0uh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteHomework);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styles = require("@mui/styles");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _dialog = require("./Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _context = require("teacher/context");
const StyledDeleteHomework = (0, _styles.styled)((0, _dialogDefault.default))(deleteHomeworkStyles);
function DeleteHomework(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { updateState, homeworkContext: { deleteHomework: { open, homework } } } = context;
    function onClose() {
        return updateState({
            homeworkContext: {
                deleteHomework: {
                    open: {
                        $set: false
                    },
                    homework: {
                        $set: undefined
                    }
                }
            }
        });
    }
    async function onConfirm() {
        const [deletedId] = await (0, _commandDefault.default)('homework', 'deleteHomework')({
            id: homework.id
        });
        props.onDelete && props.onDelete(deletedId);
        await onClose();
        await context.updateState({
            homeworkContext: {
                homeworks: {
                    refreshes: {
                        $apply: (i)=>i + 1
                    }
                }
            }
        });
    }
    const shouldConfirm = homework ? homework.turnIns > 0 : false;
    const notificationId = shouldConfirm ? 'new-homework-delete' : 'homework-delete';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDeleteHomework, {
        open,
        context,
        onClose,
        onConfirm,
        shouldConfirm,
        notificationId
    });
}
function deleteHomeworkStyles() {
    return {};
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/styles":"5LOiR","helpers/command":"f3cbG","./Dialog":"caAzJ","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5LOiR":[function(require,module,exports,__globalThis) {
/**
 * @mui/styles v5.16.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable import/export */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGenerateClassName", ()=>(0, _createGenerateClassNameDefault.default));
parcelHelpers.export(exports, "createStyles", ()=>(0, _createStylesDefault.default));
parcelHelpers.export(exports, "getThemeProps", ()=>(0, _getThemePropsDefault.default));
parcelHelpers.export(exports, "jssPreset", ()=>(0, _jssPresetDefault.default));
parcelHelpers.export(exports, "makeStyles", ()=>(0, _makeStylesDefault.default));
parcelHelpers.export(exports, "mergeClasses", ()=>(0, _mergeClassesDefault.default));
parcelHelpers.export(exports, "ServerStyleSheets", ()=>(0, _serverStyleSheetsDefault.default));
parcelHelpers.export(exports, "styled", ()=>(0, _styledDefault.default));
parcelHelpers.export(exports, "StylesProvider", ()=>(0, _stylesProviderDefault.default));
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _themeProviderDefault.default));
parcelHelpers.export(exports, "useTheme", ()=>(0, _useThemeDefault.default));
parcelHelpers.export(exports, "useThemeVariants", ()=>(0, _useThemeVariantsDefault.default));
parcelHelpers.export(exports, "propsToClassKey", ()=>(0, _propsToClassKeyDefault.default));
parcelHelpers.export(exports, "withStyles", ()=>(0, _withStylesDefault.default));
parcelHelpers.export(exports, "withTheme", ()=>(0, _withThemeDefault.default));
var _utils = require("@mui/utils");
var _createGenerateClassName = require("./createGenerateClassName");
var _createGenerateClassNameDefault = parcelHelpers.interopDefault(_createGenerateClassName);
parcelHelpers.exportAll(_createGenerateClassName, exports);
var _createStyles = require("./createStyles");
var _createStylesDefault = parcelHelpers.interopDefault(_createStyles);
parcelHelpers.exportAll(_createStyles, exports);
var _getThemeProps = require("./getThemeProps");
var _getThemePropsDefault = parcelHelpers.interopDefault(_getThemeProps);
parcelHelpers.exportAll(_getThemeProps, exports);
var _jssPreset = require("./jssPreset");
var _jssPresetDefault = parcelHelpers.interopDefault(_jssPreset);
parcelHelpers.exportAll(_jssPreset, exports);
var _makeStyles = require("./makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
parcelHelpers.exportAll(_makeStyles, exports);
var _mergeClasses = require("./mergeClasses");
var _mergeClassesDefault = parcelHelpers.interopDefault(_mergeClasses);
parcelHelpers.exportAll(_mergeClasses, exports);
var _serverStyleSheets = require("./ServerStyleSheets");
var _serverStyleSheetsDefault = parcelHelpers.interopDefault(_serverStyleSheets);
parcelHelpers.exportAll(_serverStyleSheets, exports);
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
parcelHelpers.exportAll(_styled, exports);
var _stylesProvider = require("./StylesProvider");
var _stylesProviderDefault = parcelHelpers.interopDefault(_stylesProvider);
parcelHelpers.exportAll(_stylesProvider, exports);
var _themeProvider = require("./ThemeProvider");
var _themeProviderDefault = parcelHelpers.interopDefault(_themeProvider);
parcelHelpers.exportAll(_themeProvider, exports);
var _useTheme = require("./useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
parcelHelpers.exportAll(_useTheme, exports);
var _useThemeVariants = require("./useThemeVariants");
var _useThemeVariantsDefault = parcelHelpers.interopDefault(_useThemeVariants);
parcelHelpers.exportAll(_useThemeVariants, exports);
var _propsToClassKey = require("./propsToClassKey");
var _propsToClassKeyDefault = parcelHelpers.interopDefault(_propsToClassKey);
parcelHelpers.exportAll(_propsToClassKey, exports);
var _withStyles = require("./withStyles");
var _withStylesDefault = parcelHelpers.interopDefault(_withStyles);
parcelHelpers.exportAll(_withStyles, exports);
var _withTheme = require("./withTheme");
var _withThemeDefault = parcelHelpers.interopDefault(_withTheme);
parcelHelpers.exportAll(_withTheme, exports);

},{"@mui/utils":"lfcNH","./createGenerateClassName":false,"./createStyles":false,"./getThemeProps":false,"./jssPreset":false,"./makeStyles":false,"./mergeClasses":false,"./ServerStyleSheets":false,"./styled":"kevUk","./StylesProvider":false,"./ThemeProvider":false,"./useTheme":false,"./useThemeVariants":false,"./propsToClassKey":false,"./withStyles":false,"./withTheme":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kevUk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _styledDefault.default));
var _styled = require("./styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);

},{"./styled":"jMd6A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jMd6A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styled);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _makeStyles = require("../makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = [
    "name"
], _excluded2 = [
    "children",
    "className",
    "clone",
    "component"
];
function omit(input, fields) {
    const output = {};
    Object.keys(input).forEach((prop)=>{
        if (fields.indexOf(prop) === -1) output[prop] = input[prop];
    });
    return output;
}
function styled(Component) {
    const componentCreator = (style, options = {})=>{
        const { name } = options, stylesOptions = (0, _objectWithoutPropertiesLooseDefault.default)(options, _excluded);
        let classNamePrefix = name;
        const stylesOrCreator = typeof style === 'function' ? (theme)=>({
                root: (props)=>style((0, _extendsDefault.default)({
                        theme
                    }, props))
            }) : {
            root: style
        };
        const useStyles = (0, _makeStylesDefault.default)(stylesOrCreator, (0, _extendsDefault.default)({
            Component,
            name: name || Component.displayName,
            classNamePrefix
        }, stylesOptions));
        let filterProps;
        let propTypes = {};
        if (style.filterProps) {
            filterProps = style.filterProps;
            delete style.filterProps;
        }
        /* eslint-disable react/forbid-foreign-prop-types */ if (style.propTypes) {
            propTypes = style.propTypes;
            delete style.propTypes;
        }
        /* eslint-enable react/forbid-foreign-prop-types */ const StyledComponent = /*#__PURE__*/ _react.forwardRef(function StyledComponent(props, ref) {
            const { children, className: classNameProp, clone, component: ComponentProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded2);
            const classes = useStyles(props);
            const className = (0, _clsxDefault.default)(classes.root, classNameProp);
            let spread = other;
            if (filterProps) spread = omit(spread, filterProps);
            if (clone) return /*#__PURE__*/ _react.cloneElement(children, (0, _extendsDefault.default)({
                className: (0, _clsxDefault.default)(children.props.className, className)
            }, spread));
            if (typeof children === 'function') return children((0, _extendsDefault.default)({
                className
            }, spread));
            const FinalComponent = ComponentProp || Component;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FinalComponent, (0, _extendsDefault.default)({
                ref: ref,
                className: className
            }, spread, {
                children: children
            }));
        });
        (0, _hoistNonReactStaticsDefault.default)(StyledComponent, Component);
        return StyledComponent;
    };
    return componentCreator;
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","clsx":"gNu3q","prop-types":"bnNSm","@mui/utils":"lfcNH","hoist-non-react-statics":"59Kh2","../makeStyles":"hRYSM","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gNu3q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"caAzJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NotificationDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)(notificationStyles);
const useTitleStyles = (0, _material.makeStyles)(titleStyles);
function NotificationDialog(props) {
    const { open, onClose, onConfirm, context, notificationId: id, shouldConfirm = false } = props;
    const { translate } = context;
    const classes = useStyles();
    const titleClasses = useTitleStyles();
    const theme = (0, _material.useTheme)();
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const [confirmed, setConfirmed] = (0, _react.React).useState(false);
    (0, _react.useEffect)(()=>{
        if (!open) setConfirmed(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        fullScreen: fullScreen,
        open: open,
        onClose: onClose,
        "aria-labelledby": "notification-dialog-title",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: open,
                timeout: {
                    exit: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogTitle), {
                    id: "notification-dialog-title",
                    classes: titleClasses,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            className: classes.icon,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ErrorIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            children: translate(`${id}-title`)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: open,
                timeout: {
                    exit: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogContent), {
                    className: classes.content,
                    children: [
                        shouldConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                            size: "small",
                            className: (0, _material.clsx)(classes.notification, {
                                shouldConfirm
                            }),
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                                size: "small",
                                color: "primary",
                                checked: confirmed,
                                onChange: (e)=>setConfirmed(e.target.checked)
                            }),
                            label: translate(`${id}-message`)
                        }),
                        !shouldConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _material.clsx)(classes.notification, {
                                shouldConfirm
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                children: translate(`${id}-message`)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: open,
                timeout: {
                    exit: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                    className: classes.actions,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            color: "background",
                            className: (0, _material.clsx)(classes.button, "cancel"),
                            onClick: onClose,
                            children: translate(`${id}-cancel`)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            color: "error",
                            className: (0, _material.clsx)(classes.button, "confirm"),
                            onClick: onConfirm,
                            ...!shouldConfirm || confirmed ? {} : {
                                disabled: true
                            },
                            children: translate(`${id}-confirm`)
                        })
                    ]
                })
            })
        ]
    });
}
function titleStyles(theme) {
    return {
        root: {
            display: 'flex',
            justifyContent: 'center',
            fontSize: '14pt',
            fontWeight: 'bold',
            borderBottom: 'solid 1px #f3f3f3',
            background: '#fdfdfd'
        }
    };
}
function notificationStyles(theme) {
    return {
        content: {
            display: 'flex',
            paddingTop: '20px !important',
            flexGrow: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            minWidth: 280,
            maxWidth: 350
        },
        icon: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: '#f4cc2c',
            fontSize: '15pt',
            marginTop: -1,
            marginRight: 10
        },
        notification: {
            color: '79797b',
            fontSize: '11.5pt',
            textAlign: 'center',
            '& .MuiFormControlLabel-label': {
                lineHeight: '1.1',
                fontSize: '11.5pt'
            },
            '&.shouldConfirm': {
                textAlign: 'justify'
            }
        },
        actions: {
            padding: 12,
            display: 'flex',
            justifyContent: 'center',
            borderTop: 'solid 1px #f3f3f3',
            background: '#fdfdfd'
        },
        filler: {
            flexGrow: 1
        },
        button: {
            textTransform: 'none',
            '&.cancel': {
                marginLeft: 0,
                marginRight: 0
            },
            '&.confirm': {
                marginLeft: 16
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2lSot":[function() {},{}],"8dSJc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MyLessons);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _myLessons = require("../../components/my-lessons");
var _myLessonsDefault = parcelHelpers.interopDefault(_myLessons);
var _myLessonsStyl = require("./my-lessons.styl");
function MyLessons() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _myLessonsDefault.default), {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../components/my-lessons":"4N8ct","./my-lessons.styl":"fLrxx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4N8ct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _context = require("../../context");
var _utils = require("../../helpers/utils");
var _contextLoader = require("../context-loader");
var _contextLoaderDefault = parcelHelpers.interopDefault(_contextLoader);
var _searchPattern = require("../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _scheduleUpload = require("../schedule-upload");
var _scheduleUploadDefault = parcelHelpers.interopDefault(_scheduleUpload);
var _upload = require("./upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _pagination = require("../pagination");
var _myLessonsStyl = require("./my-lessons.styl");
const { columns, headers } = (0, _columnsDefault.default);
const Layout = ({ Table, Pagination, Filter })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "my-lessons-search-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
        ]
    });
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "my-lessons_search_no_results_label"
        })
    });
}
class MyLessons extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        (0, _utils.bind)(this, 'goPage', 'goNext', 'goPrevious', 'sort');
    }
    goPage(page) {
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                page
            }
        });
    }
    goNext() {
        this.goPage(this.context.myLessons[0].currentPage + 1);
    }
    goPrevious() {
        this.goPage(this.context.myLessons[0].currentPage - 1);
    }
    sort({ id, sortAscending }) {
        const orderBy = `${sortAscending ? '' : '-'}${id}`;
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                orderBy
            }
        });
    }
    render() {
        const context = this.context;
        const [pageProperties, ...lessons] = context.myLessons;
        const { recordCount } = pageProperties || {};
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextLoaderDefault.default), {
            id: "myLessons",
            className: "my-lessons",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                                initialPattern: context.query.pattern
                            })
                        ]
                    }),
                    [
                        'schedule',
                        'posts'
                    ].indexOf(this.context.action) >= 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scheduleUploadDefault.default), {
                        selectedGroup: {},
                        activeTab: "groups"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "my-lessons-search-results",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                            data: lessons,
                            components: {
                                NoResults,
                                PageDropdown: (0, _pagination.PageDropdown),
                                Pagination: (0, _pagination.Pagination),
                                Layout,
                                Filter: (0, _filtersDefault.default)
                            },
                            pageProperties: pageProperties,
                            events: {
                                onNext: this.goNext,
                                onPrevious: this.goPrevious,
                                onGetPage: this.goPage,
                                onSort: this.sort
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "name",
                                        customHeadingComponent: headers.MyLessonsHeader,
                                        customComponent: columns.UploadColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "subjectName",
                                        customHeadingComponent: headers.MyLessonsHeader
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "gradeName",
                                        customHeadingComponent: headers.MyLessonsHeader
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "byteLength",
                                        customHeadingComponent: headers.MyLessonsHeader,
                                        customComponent: columns.ByteLengthColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "modified",
                                        customHeadingComponent: headers.MyLessonsHeader,
                                        customComponent: columns.DateColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "links",
                                        customHeadingComponent: headers.EmptyHeader,
                                        customComponent: columns.LessonLinksColumn
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        });
    }
}
exports.default = MyLessons;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","griddle-react":"6zdUV","../../context":"iUP37","../../helpers/utils":"gGc98","../context-loader":"ktxlD","../search-pattern":"lUZFT","../schedule-upload":"bEzHQ","./upload":"5gsTV","./columns":"axlDo","./filters":"2YlwH","../pagination":"82vF6","./my-lessons.styl":"ecX2B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bEzHQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _tabBar = require("./tab-bar");
var _tabBarDefault = parcelHelpers.interopDefault(_tabBar);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _utils = require("../../helpers/utils");
var _groupsStep = require("./groups-step");
var _groupsStepDefault = parcelHelpers.interopDefault(_groupsStep);
var _dateStep = require("./date-step");
var _dateStepDefault = parcelHelpers.interopDefault(_dateStep);
var _post = require("../../context/post");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _indexStyl = require("./index.styl");
function Buttons({ left, right }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !left.enabled,
                className: left.label,
                onClick: left.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${left.label}_label`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !right.enabled,
                className: right.label,
                onClick: right.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${right.label}_label`
                })
            })
        ]
    });
}
class ScheduleUpload extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            date: props.date || new Date(),
            message: props.message || "",
            activeTab: props.activeTab,
            selectedGroup: props.selectedGroup,
            studentList: props.studentList || [],
            selectedStudents: props.selectedStudents || [],
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const { setState, activeTab, isOpen } = this.state;
        const { upload: uploadId, myLessons } = context;
        const upload = myLessons.find(({ id })=>id == uploadId) || {};
        const markLessonAsAssigned = ()=>{
            const myLessons = context.myLessons.map((upload)=>upload.id != uploadId ? upload : {
                    ...upload,
                    assigned: true
                });
            context.setState({
                myLessons
            }, close);
        };
        const save = ()=>{
            return (0, _post.scheduleUpload)({
                upload,
                profile: context.profile,
                language: context.languageId,
                students: this.state.selectedStudents,
                action: context.action,
                date: this.state.date,
                message: this.state.message,
                group: this.state.selectedGroup
            }).then(markLessonAsAssigned);
        };
        const previous = ()=>setState({
                activeTab: 'groups'
            });
        const next = ()=>setState({
                activeTab: 'date'
            });
        const close = ()=>setState({
                isOpen: false
            });
        const navigateOut = ()=>context.navigate({}, context.match.path.replace(/\/:action.*$/, ''), {
                preserveQuery: true
            });
        const canSave = this.state.selectedStudents.length > 0 && !(0, _utils.isEmpty)(this.state.message);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "schedule-upload-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-upload",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: `${context.action}_schedule_lesson_title`
                                    }),
                                    `: ${upload.name}`
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "close",
                                onClick: ()=>close(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faTimesCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabBarDefault.default), {
                        activeTab,
                        setState
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tab-content",
                        children: [
                            activeTab == 'groups' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'selectedGroup',
                                            'studentList',
                                            'selectedStudents',
                                            'setState'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'cancel',
                                            onClick: close,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'continue',
                                            onClick: next,
                                            enabled: true
                                        }
                                    })
                                ]
                            }),
                            activeTab == 'date' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'date',
                                            'setState',
                                            'message'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'back',
                                            onClick: previous,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'save',
                                            onClick: save,
                                            enabled: canSave
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = ScheduleUpload;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-modal":"kV9Wz","./tab-bar":"iJE7O","react-text":"lEpdJ","../../context":"iUP37","../../helpers/utils":"gGc98","./groups-step":"8GScU","./date-step":"28rl1","../../context/post":"8rmpk","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./index.styl":"kZbik","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJE7O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _tabBarStyl = require("./tab-bar.styl");
function TabBar({ activeTab, setState }) {
    const setActiveTab = (activeTab)=>setState({
            activeTab
        });
    const buttonClassName = (tab)=>`${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`;
    const onClick = (tab)=>()=>activeTab != tab && setActiveTab(tab);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tab-bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('groups'),
                onClick: onClick('groups'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faUsers)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_group_button_label"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('date'),
                onClick: onClick('date'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_date_button_label"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","./tab-bar.styl":"cbZXt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbZXt":[function() {},{}],"8GScU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GroupsStep);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectGroup = require("./select-group");
var _selectGroupDefault = parcelHelpers.interopDefault(_selectGroup);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _listboxActions = require("../listbox/listbox-actions");
var _listboxActionsDefault = parcelHelpers.interopDefault(_listboxActions);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _groupsStepStyl = require("./groups-step.styl");
function makeStudentClickHandler({ props, target }) {
    return ({ id, selected })=>props.setState({
            [target]: props[target].map((student)=>student.id != id ? {
                    ...student
                } : {
                    ...student,
                    selected: !selected
                })
        });
}
function GroupsStep(props) {
    const groupClick = (group)=>{
        if (group.id != props.selectedGroup.id) props.setState({
            selectedGroup: group,
            selectedStudents: [],
            studentList: group.students.map((student)=>({
                    ...student,
                    selected: false
                }))
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "groups-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "groups-message",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "schedule_lesson_groups_instructions"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "student-selector",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGroupDefault.default), {
                        selectedGroup: props.selectedGroup,
                        onClick: groupClick
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "select-student",
                        labelId: "students_label",
                        items: (0, _lodash.orderBy)(props.studentList, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'studentList'
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxActionsDefault.default), {
                        onAllLeft: ()=>{
                            const studentList = props.studentList.concat(props.selectedStudents);
                            props.setState({
                                selectedStudents: [],
                                studentList
                            });
                        },
                        onLeft: ()=>{
                            const selectedStudents = props.selectedStudents.filter(({ selected })=>!selected);
                            const studentList = props.studentList.concat(props.selectedStudents.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onRight: ()=>{
                            const studentList = props.studentList.filter(({ selected })=>!selected);
                            const selectedStudents = props.selectedStudents.concat(props.studentList.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onAllRight: ()=>{
                            const selectedStudents = props.selectedStudents.concat(props.studentList);
                            props.setState({
                                selectedStudents,
                                studentList: []
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "selected-students",
                        labelId: "selection_label",
                        items: (0, _lodash.orderBy)(props.selectedStudents, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'selectedStudents'
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","./select-group":"fjvWg","../listbox":"b8FP6","../listbox/listbox-actions":"h72SQ","react-text":"lEpdJ","./groups-step.styl":"V531D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjvWg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _context = require("../../context");
function SelectGroup(props) {
    const { selectedGroup, onClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const groups = context.groups.map((group)=>{
                return {
                    ...group,
                    selected: selectedGroup && group.id == selectedGroup.id
                };
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                className: "select-group",
                labelId: "group_label",
                items: (0, _lodash.orderBy)(groups, [
                    'course'
                ]),
                onClick: onClick
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","../listbox":"b8FP6","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"V531D":[function() {},{}],"28rl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateStep);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../context");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _dateStepStyl = require("./date-step.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function DateStep(props) {
    const setDate = (date)=>props.setState({
            date
        });
    const setMessage = (event)=>props.setState({
            message: event.target.value
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "date-step",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "schedule_lesson_date_instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "date",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                    selected: props.date,
                                    onChange: setDate,
                                    minDate: new Date(),
                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "message",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "message_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            placeholder: context.translations.schedule_lesson_date_message_placeholder[context.languageId],
                                            value: props.message,
                                            onChange: setMessage
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../context":"iUP37","react-datepicker/dist/react-datepicker.css":"chsuV","./date-step.styl":"3DZKZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"3DZKZ":[function() {},{}],"kZbik":[function() {},{}],"5gsTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UploadLesson);
var _jsxRuntime = require("react/jsx-runtime");
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _moxie = require("../../helpers/moxie");
var _moxieDefault = parcelHelpers.interopDefault(_moxie);
var _context = require("../../context");
var _post = require("../../context/post");
var _uploadStyl = require("./upload.styl");
function createSelect({ action, label, options, onChange }) {
    const $container = (0, _jqueryDefault.default)('<div>', {
        class: `select_${action}`
    });
    (0, _jqueryDefault.default)('<label>', {
        text: label
    }).appendTo($container);
    const $select = (0, _jqueryDefault.default)('<select>').appendTo($container);
    (0, _jqueryDefault.default)('<option>', {
        text: '',
        value: '',
        selected: 'selected'
    }).appendTo($select);
    options.forEach((item)=>{
        (0, _jqueryDefault.default)('<option>', {
            text: item.name,
            value: item.id
        }).appendTo($select);
    });
    $select.on('change', (e)=>{
        (0, _jqueryDefault.default)("option[value='']", e.target).remove();
        onChange({
            [action]: (0, _jqueryDefault.default)(e.target).val()
        });
    });
    return $select;
}
function enableUpload(enable) {
    const $button = (0, _jqueryDefault.default)('.moxman-primary > button');
    if (enable) $button.removeAttr('disabled').parent().removeClass('disabled');
    else $button.attr('disabled', 'disabled').parent().addClass('disabled');
}
function createSelectGrade(container, label, options, context) {
    (0, _jqueryDefault.default)('.select_grade', container).remove();
    enableUpload(false);
    const $grades = createSelect({
        action: 'grade',
        label,
        options,
        onChange: ({ grade })=>{
            enableUpload(true);
            context.grade = grade;
        }
    });
    container.append($grades.parent());
}
function createSelectSubject(container, label, options, context) {
    const $subjects = createSelect({
        action: 'subject',
        label,
        options,
        onChange: ({ subject })=>{
            context.subject = subject;
            const grades = Object.values(context.subjects[subject].grades);
            createSelectGrade(container, context.translate('grade_label'), grades, context);
        }
    });
    container.append($subjects.parent());
}
async function showUpload({ locale, subjects, translate, profile, setState, uploadUpdates }) {
    const context = {
        subjects,
        translate
    };
    const $uploadInfo = (0, _jqueryDefault.default)('<div>', {
        "class": 'uploadInfo'
    });
    createSelectSubject($uploadInfo, translate('subject_label'), Object.values(subjects), context);
    createSelectGrade($uploadInfo, translate('grade_label'), [], context);
    await (0, _moxieDefault.default);
    (0, _jqueryDefault.default)('body').on('DOMSubtreeModified', '.moxman-window', ()=>{
        (0, _jqueryDefault.default)('body').off('DOMSubtreeModified', '.moxman-window');
        (0, _jqueryDefault.default)('.moxman-window .moxman-upload-drop-zone').parent().prepend($uploadInfo);
        enableUpload(false);
    });
    /*
  const addI18n = window.moxman.addI18n
  window.moxman.addI18n = (locale, values) => {
    console.log(values)
    return addI18n(locale, $.extend(values, locale))
  }*/ window.moxman.upload({
        path: '/lesson',
        onupload: (e)=>{
            Promise.all(e.files.map((file)=>({
                    name: file.name,
                    subject: context.subject,
                    grade: context.grade,
                    file: `${profile.domain}/${profile.Passport.userName}/lesson/${file.name}`
                })).map((0, _post.saveUpload))).then(()=>{
                setState({
                    uploadUpdates: uploadUpdates + 1
                });
                (0, _jqueryDefault.default)('.moxman-last > button').trigger('click');
            });
        }
    });
}
function UploadLesson(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { languageId, settings, translate, profile, uploadUpdates, setState } = context;
            const locale = settings.moxman[languageId];
            const subjects = context.groups.reduce((acc, group)=>{
                const subjectId = group.course.substring(0, 2);
                const gradeId = group.course.substring(4, 7);
                acc[subjectId] = acc[subjectId] || {
                    id: subjectId,
                    name: group.subject,
                    grades: {}
                };
                acc[subjectId].grades[gradeId] = acc[subjectId].grades[gradeId] || {
                    id: gradeId,
                    name: group.grade
                };
                return acc;
            }, {});
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "upload-lesson",
                onClick: ()=>showUpload({
                        locale,
                        subjects,
                        translate,
                        profile,
                        uploadUpdates,
                        setState
                    }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            name: "lesson-upload"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "label-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "upload_lesson_label"
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","jquery":"2Z9Ua","react":"9njXz","react-text":"lEpdJ","../icon":"82gpi","../../helpers/moxie":"eWIsw","../../context":"iUP37","../../context/post":"8rmpk","./upload.styl":"23TWY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Z9Ua":[function(require,module,exports,__globalThis) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : this, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

},{}],"eWIsw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _url = require("./url");
var _command = require("./command");
var _commandDefault = parcelHelpers.interopDefault(_command);
const { send, open } = XMLHttpRequest.prototype;
XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this.requestURL = url;
    open.apply(this, [
        method,
        url,
        ...args
    ]);
};
window.edusystem = window.edusystem || {};
XMLHttpRequest.prototype.send = function() {
    const setHeader = this.setRequestHeader.bind(this);
    const language = location.hash.substring(2, 4);
    setHeader('Accept-Language', language);
    const { session = {} } = edusystem;
    if (session.customHeaders) Object.entries(session.customHeaders).forEach(([name, value])=>setHeader(name, value));
    const toBosh = /\/chat\./.test(this.requestURL) || /:7070\//.test(this.requestURL);
    if (session.withCredentials !== false && !toBosh) this.withCredentials = true;
    send.apply(this, arguments);
};
const disabled = true;
function addMoxie() {
    if (!disabled) {
        const script = document.createElement("script");
        script.src = '//' + (0, _url.subdomainResource)('moxie', 'js/moxman.api.min.js');
        return new Promise((resolve, reject)=>{
            script.onerror = reject;
            script.onload = resolve;
            document.body.appendChild(script);
        });
    } else return new Promise((resolve)=>resolve(true));
}
const loadMoxie = addMoxie();
exports.default = loadMoxie;

},{"./url":"65SQD","./command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"23TWY":[function() {},{}],"axlDo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _uploadLinks = require("./upload-links");
var _uploadLinksDefault = parcelHelpers.interopDefault(_uploadLinks);
var _prettyBytes = require("pretty-bytes");
var _prettyBytesDefault = parcelHelpers.interopDefault(_prettyBytes);
var _utils = require("../../helpers/utils");
function MyLessonsHeader({ sortColumns, title }) {
    const active = sortColumns && sortColumns.id == title;
    const direction = active ? sortColumns.sortAscending ? 'ascending' : 'descending' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "sorted-column-wrapper",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: direction
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${title}_my_lessons_header`
                })
            })
        ]
    });
}
function EmptyHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
}
function UploadColumn({ rowData }) {
    const { name, assigned } = rowData;
    const assignedClass = `name${assigned ? ' assigned' : ''}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: assignedClass,
        title: name,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bullet"
            }),
            name
        ]
    });
}
function ByteLengthColumn({ value }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "size",
        children: (0, _prettyBytesDefault.default)(value || 0)
    });
}
function DateColumn({ value }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "modified",
        children: (0, _momentDefault.default)(value).format('L, LT')
    });
}
function LessonLinksColumn({ rowData }) {
    const map = {
        lesson: 'id',
        lessonName: 'name'
    };
    const props = (0, _lodash.mapKeys)(rowData, (_, key)=>map[key] || key);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadLinksDefault.default), {
        ...props
    });
}
const map = {
    headers: {
        MyLessonsHeader: (0, _utils.enhancedWithSortColumns)(MyLessonsHeader),
        EmptyHeader
    },
    columns: {
        UploadColumn: (0, _utils.enhancedWithRowData)(UploadColumn),
        LessonLinksColumn: (0, _utils.enhancedWithRowData)(LessonLinksColumn),
        ByteLengthColumn,
        DateColumn
    }
};
exports.default = map;

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","./upload-links":"7KLBM","pretty-bytes":"1L0Q0","../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7KLBM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UploadLinks);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _url = require("../../../helpers/url");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../context");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _post = require("../../../context/post");
var _confirmDialog = require("../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _reactConfirmAlertCss = require("react-confirm-alert/src/react-confirm-alert.css");
var _icon = require("../../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function LessonLink(props) {
    const { key, show, to, title, href } = props;
    const linkProps = (0, _lodash.omit)(props, [
        'key',
        'show'
    ]);
    const LinkElem = to ? (0, _reactRouterDom.Link) : ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            ...linkProps,
            ...(0, _url.viewerGuard)(linkProps),
            children: children
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: key,
        children: [
            show && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkElem, {
                ...linkProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            }),
            !show && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "disabled",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            })
        ]
    }, key);
}
function UploadLinks(props) {
    const { name, id, assigned } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { link, match, translations, languageId, profile } = context;
            const zipName = `${name.replace(/.epl$/, '')}.zip`;
            const { limited } = profile.institution;
            const tooltipTitle = (name)=>`${translations[`${name}_tooltip_title`][languageId]}: ${props.name}`;
            const links = [
                {
                    key: 'download',
                    title: tooltipTitle('download'),
                    show: !limited,
                    ...(0, _url.viewerGuard)({
                        target: "_blank",
                        href: (0, _url.subdomainLink)('api-support', 'catalog', 'downloadUploaded', `?id=${id}`)
                    })
                },
                {
                    key: 'schedule',
                    title: tooltipTitle('schedule'),
                    onClick: (e)=>{
                        if (!context.course) {
                            e.preventDefault();
                            context.setState({
                                course: id.substring(0, 6),
                                selectedLesson: props
                            }, ()=>{
                                context.navigate({
                                    lesson: id
                                }, `${context.match.path}/schedule/:lesson`, {
                                    preserveQuery: true
                                });
                            });
                        }
                    },
                    show: !limited,
                    to: link({
                        lesson: id
                    }, `${context.match.path}/schedule/:lesson`, {
                        preserveQuery: true
                    })
                },
                {
                    key: 'posts',
                    title: tooltipTitle('posts'),
                    show: assigned > 0 && !limited,
                    to: link({
                        lesson: id
                    }, `${context.match.path}/posts/:lesson`, {
                        preserveQuery: true
                    })
                }
            ];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "links",
                children: [
                    links.map(LessonLink),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "link delete",
                        onClick: ()=>(0, _confirmDialogDefault.default)({
                                className: 'delete-upload',
                                translate: context.translate,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "message",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "question",
                                            children: context.translate('confirm_delete_item')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "title",
                                            children: name
                                        })
                                    ]
                                }),
                                onConfirm: async ()=>{
                                    await (0, _post.deleteUploadedLesson)(id, name);
                                    const uploadUpdates = context.uploadUpdates + 1;
                                    context.setState({
                                        uploadUpdates
                                    });
                                }
                            }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTrashAlt)
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","../../../helpers/url":"65SQD","react":"9njXz","react-router-dom":"3uzXR","../../../context":"iUP37","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../context/post":"8rmpk","../../confirm-dialog":"hzSdJ","react-confirm-alert/src/react-confirm-alert.css":"63bhO","../../icon":"82gpi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"63bhO":[function() {},{}],"1L0Q0":[function(require,module,exports,__globalThis) {
'use strict';
const BYTE_UNITS = [
    'B',
    'kB',
    'MB',
    'GB',
    'TB',
    'PB',
    'EB',
    'ZB',
    'YB'
];
const BIBYTE_UNITS = [
    'B',
    'kiB',
    'MiB',
    'GiB',
    'TiB',
    'PiB',
    'EiB',
    'ZiB',
    'YiB'
];
const BIT_UNITS = [
    'b',
    'kbit',
    'Mbit',
    'Gbit',
    'Tbit',
    'Pbit',
    'Ebit',
    'Zbit',
    'Ybit'
];
const BIBIT_UNITS = [
    'b',
    'kibit',
    'Mibit',
    'Gibit',
    'Tibit',
    'Pibit',
    'Eibit',
    'Zibit',
    'Yibit'
];
/*
Formats the given number using `Number#toLocaleString`.
- If locale is a string, the value is expected to be a locale-key (for example: `de`).
- If locale is true, the system default locale is used for translation.
- If no value for locale is specified, the number is returned unmodified.
*/ const toLocaleString = (number, locale, options)=>{
    let result = number;
    if (typeof locale === 'string' || Array.isArray(locale)) result = number.toLocaleString(locale, options);
    else if (locale === true || options !== undefined) result = number.toLocaleString(undefined, options);
    return result;
};
module.exports = (number, options)=>{
    if (!Number.isFinite(number)) throw new TypeError(`Expected a finite number, got ${typeof number}: ${number}`);
    options = Object.assign({
        bits: false,
        binary: false
    }, options);
    const UNITS = options.bits ? options.binary ? BIBIT_UNITS : BIT_UNITS : options.binary ? BIBYTE_UNITS : BYTE_UNITS;
    if (options.signed && number === 0) return ` 0 ${UNITS[0]}`;
    const isNegative = number < 0;
    const prefix = isNegative ? '-' : options.signed ? '+' : '';
    if (isNegative) number = -number;
    let localeOptions;
    if (options.minimumFractionDigits !== undefined) localeOptions = {
        minimumFractionDigits: options.minimumFractionDigits
    };
    if (options.maximumFractionDigits !== undefined) localeOptions = Object.assign({
        maximumFractionDigits: options.maximumFractionDigits
    }, localeOptions);
    if (number < 1) {
        const numberString = toLocaleString(number, options.locale, localeOptions);
        return prefix + numberString + ' ' + UNITS[0];
    }
    const exponent = Math.min(Math.floor(options.binary ? Math.log(number) / Math.log(1024) : Math.log10(number) / 3), UNITS.length - 1);
    // eslint-disable-next-line unicorn/prefer-exponentiation-operator
    number /= Math.pow(options.binary ? 1024 : 1000, exponent);
    if (!localeOptions) number = number.toPrecision(3);
    const numberString = toLocaleString(Number(number), options.locale, localeOptions);
    const unit = UNITS[exponent];
    return prefix + numberString + ' ' + unit;
};

},{}],"2YlwH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _context = require("../../context");
var _filtersStyl = require("./filters.styl");
function SelectFilter(props) {
    const className = `select-${props.name}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const id = context.query[props.valueProperty];
            const value = context[props.name].find((prop)=>prop.id == id);
            const placeholder = context.translate(`${props.name}_filters_no_options_message`);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "dropdown",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        className: className,
                        classNamePrefix: "select",
                        formatOptionLabel: ({ name })=>name,
                        isSearchable: false,
                        isClearable: true,
                        escapeClearsValue: true,
                        getOptionValue: ({ id })=>id,
                        placeholder: placeholder,
                        value: value,
                        onChange: (option)=>{
                            const { id } = option || {};
                            const query = {
                                [props.valueProperty]: id,
                                page: undefined
                            };
                            context.navigate({}, context.match.path, {
                                preserveQuery: true,
                                query
                            });
                        },
                        options: context[props.name]
                    })
                })
            });
        }
    });
}
function Filters(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const [pageProperties] = context.myLessons;
            const { recordCount } = pageProperties || {};
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filters-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "filters",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "label-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            name: "lesson-count"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "count",
                                        children: recordCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "uploaded_lessons_label"
                                                }),
                                                ": ",
                                                recordCount
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                flexGrow: 1
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                            name: "grades",
                            valueProperty: "grade"
                        })
                    ]
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-select":"j36cq","../icon":"82gpi","../../context":"iUP37","./filters.styl":"bT2fx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bT2fx":[function() {},{}],"ecX2B":[function() {},{}],"fLrxx":[function() {},{}],"gLocj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Rollbook);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _rollbook = require("components/rollbook");
var _rollbookDefault = parcelHelpers.interopDefault(_rollbook);
var _rollbookStyl = require("./rollbook.styl");
function Rollbook() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rollbookDefault.default), {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","components/rollbook":"6ZVdY","./rollbook.styl":"d1Iub","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ZVdY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _context = require("../../context");
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _rollbookStyl = require("./rollbook.styl");
const { columns, headers } = (0, _columnsDefault.default);
const Layout = ({ Table, Pagination, Filter })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "rollbook-table",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
    });
class Rollbook extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
    }
    render() {
        const context = this.context;
        const { groups } = context;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "wrapper",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                data: groups,
                components: {
                    Layout
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                            id: "name",
                            customHeadingComponent: headers.RollbookHeader
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                            id: "subject",
                            customHeadingComponent: headers.RollbookHeader,
                            customComponent: columns.SubjectColumn
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                            id: "links",
                            customHeadingComponent: headers.EmptyHeader,
                            customComponent: columns.RollbookLinksColumn
                        })
                    ]
                })
            })
        });
    }
}
exports.default = Rollbook;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","griddle-react":"6zdUV","../../context":"iUP37","./columns":"kY4Jp","./rollbook.styl":"8rtLd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kY4Jp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _links = require("./links");
var _linksDefault = parcelHelpers.interopDefault(_links);
var _utils = require("../../helpers/utils");
function RollbookHeader({ title }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: `${title}_rollbook_header`
        })
    });
}
function EmptyHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
}
function SubjectColumn({ rowData }) {
    const { subject, grade } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "subject",
        children: `${subject} - ${grade}`
    });
}
function RollbookLinksColumn({ rowData }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linksDefault.default), {
        ...rowData
    });
}
const map = {
    headers: {
        RollbookHeader: RollbookHeader,
        EmptyHeader
    },
    columns: {
        SubjectColumn: (0, _utils.enhancedWithRowData)(SubjectColumn),
        RollbookLinksColumn: (0, _utils.enhancedWithRowData)(RollbookLinksColumn)
    }
};
exports.default = map;

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","./links":"4XQdP","../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4XQdP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UploadLinks);
var _jsxRuntime = require("react/jsx-runtime");
var _url = require("../../../helpers/url");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../../../context");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _icon = require("../../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _url1 = require("helpers/url");
function UploadLinks(props) {
    const { name, id } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { groupsDigests, languageId } = context;
            const digest = groupsDigests[id];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "links",
                children: [
                    digest && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "rollbook",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            ...(0, _url1.viewerGuard)({
                                href: (0, _url.subdomainLink)('assessment', languageId, `roll_book#${digest}`),
                                target: "_blank"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faBook)
                            })
                        })
                    }),
                    digest && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "publish",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            ...(0, _url1.viewerGuard)({
                                href: (0, _url.subdomainLink)('assessment', languageId, `publishing_roll_book#${digest}`),
                                target: "_blank"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                name: "rollbook-link"
                            })
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","../../../helpers/url":"65SQD","react":"9njXz","../../../context":"iUP37","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../icon":"82gpi","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8rtLd":[function() {},{}],"d1Iub":[function() {},{}],"lS3oG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuizPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _quiz = require("components/quiz");
var _quizDefault = parcelHelpers.interopDefault(_quiz);
var _editAssessment = require("components/quiz/edit-assessment");
var _editAssessmentDefault = parcelHelpers.interopDefault(_editAssessment);
var _preview = require("components/quiz/preview");
var _previewDefault = parcelHelpers.interopDefault(_preview);
var _review = require("components/quiz/review");
var _reviewDefault = parcelHelpers.interopDefault(_review);
var _standardsResults = require("components/quiz/standards-results");
var _standardsResultsDefault = parcelHelpers.interopDefault(_standardsResults);
var _take = require("components/quiz/take");
var _takeDefault = parcelHelpers.interopDefault(_take);
var _previewResults = require("components/quiz/preview-results");
var _previewResultsDefault = parcelHelpers.interopDefault(_previewResults);
var _context = require("context");
var _quizStyl = require("./quiz.styl");
var _teacherTest = require("components/imported-assessment/teacher-test");
var _teacherTestDefault = parcelHelpers.interopDefault(_teacherTest);
function QuizPage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    context.attemptId && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _teacherTestDefault.default), {
                        context: context
                    }, context.attemptId),
                    context.tab && !context.attemptId && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quizDefault.default), {
                        context: context
                    }),
                    context.assessment && context.action == 'edit' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editAssessmentDefault.default), {
                        context: context
                    }),
                    context.assessment && context.action == 'preview' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewDefault.default), {
                        context: context
                    }),
                    context.assessment && context.action == 'review' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewDefault.default), {
                        context: context
                    }),
                    context.assessment && context.action == 'standards-results' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsResultsDefault.default), {
                        context: context
                    }),
                    context.assessment && context.action == 'take' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _takeDefault.default), {
                        context: context
                    }),
                    context.assessment && context.action == 'preview-results' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewResultsDefault.default), {
                        context: context
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","components/quiz":"8nKQp","components/quiz/edit-assessment":"kQL9D","components/quiz/preview":"isGfC","components/quiz/review":"beT4s","components/quiz/standards-results":"ga1yY","components/quiz/take":"68nQ9","components/quiz/preview-results":"fZ6E7","context":"iUP37","./quiz.styl":"kIwf6","components/imported-assessment/teacher-test":"jgfW1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8nKQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Quiz);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _dialog = require("./components/assessment-standards/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _standardsSearch = require("teacher/components/standards-search");
var _standardsSearchDefault = parcelHelpers.interopDefault(_standardsSearch);
var _context = require("teacher/context");
var _tabs = require("./tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _footer = require("./footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _content = require("./content");
var _contentDefault = parcelHelpers.interopDefault(_content);
const useStyles = (0, _material.makeStyles)(quizStyles);
function Quiz() {
    const classes = useStyles();
    const location = (0, _reactRouterDom.useLocation)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { preferences, link, tab, sectionName, updateState } = context;
    const { properties, loaded } = preferences;
    function handleSearchStandards(filters) {
        return updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: (0, _lodash.mapValues)(filters, (v)=>({
                    $set: v
                }))
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        container: true,
        direction: "column",
        className: classes.root,
        wrap: "nowrap",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
                        context: context
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogDefault.default), {
                        closePath: context.link({}, '/:languageId/:role/:page/:tab', {
                            preserveQuery: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsSearchDefault.default), {
                        open: sectionName == 'standards-search',
                        closePath: context.link({}, '/:languageId/:role/:page/:tab', {
                            preserveQuery: true
                        }),
                        onSearchStandards: handleSearchStandards
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                item: true,
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentDefault.default), {
                    context: context
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                item: true,
                className: classes.footer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                    context: context
                })
            })
        ]
    });
}
function quizStyles(theme) {
    return {
        root: {
            flexGrow: 1
        },
        content: {
            display: 'flex',
            flexGrow: 1,
            overflow: 'auto'
        },
        footer: {
            backgroundColor: '#fff',
            padding: 15,
            border: 'solid 1px #e0e0e0',
            borderBottomLeftRadius: 2,
            borderBottomRightRadius: 2
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Grid":"ggUwv","./components/assessment-standards/dialog":"fzY6Y","teacher/components/standards-search":"iSLCk","teacher/context":"5LKDx","./tabs":"auW3t","./footer":"dyMv4","./content":"gRZUJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fzY6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentStandardsDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _utils = require("helpers/utils");
var _index = require("./index");
var _indexDefault = parcelHelpers.interopDefault(_index);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
const useDialogTitleStyles = (0, _material.makeStyles)(dialogTitleStyles);
const useDialogContentStyles = (0, _material.makeStyles)(dialogContentStyles);
function AssessmentStandardsDialog(props) {
    const dialogClasses = useDialogStyles();
    const dialogTitleClasses = useDialogTitleStyles();
    const dialogContentClasses = useDialogContentStyles();
    const history = (0, _react.useHistory)();
    const theme = (0, _material.useTheme)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const { assessment, link, sectionName, standardsContext, translate, quizTypesMap } = context;
    const { assessmentStandards, assessment: properties } = standardsContext;
    const { closePath } = props;
    const inStandards = sectionName == 'standards';
    const open = inStandards && (0, _utils.isUUID)(assessment);
    const handleClose = ()=>history.push(closePath || link('quiz', 'assessments'));
    const title = properties.title != undefined ? translate('assessment-standards-title-dialog', {
        title: properties.title,
        type: translate(quizTypesMap[properties.type])
    }) : translate('standards');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        fullScreen: fullScreen,
        open: open,
        classes: assessmentStandards.loaded && !fullScreen ? dialogClasses : undefined,
        onClose: handleClose,
        "aria-labelledby": "assessment-standards-dialog-title",
        children: [
            assessmentStandards.loaded && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogTitle), {
                id: "assessment-standards-dialog-title",
                classes: dialogTitleClasses,
                children: [
                    assessmentStandards.loaded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                        variant: "h5",
                        component: "h2",
                        className: "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                        "aria-label": "close",
                        className: "closeButton",
                        onClick: handleClose,
                        size: "large",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CloseIcon), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogContent), {
                classes: dialogContentClasses,
                children: [
                    !assessmentStandards.loaded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: "progress",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CircularProgress), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexDefault.default), {
                        Wrapper: DialogWrapper,
                        withReferences: false
                    })
                ]
            })
        ]
    });
}
function DialogWrapper(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
        className: "contentWrapper",
        children: props.children
    });
}
function dialogTitleStyles(theme) {
    return {
        root: {
            borderBottom: 'solid 1px #e0e0e0',
            padding: '16px 3px 16px 24px',
            display: 'flex',
            "& .title": {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                color: '#3f5250',
                flexGrow: 1
            }
        }
    };
}
function dialogContentStyles() {
    return {
        root: {
            display: 'flex',
            justifyContent: 'center',
            padding: 0,
            "& .contentWrapper": {
                display: 'flex',
                flexGrow: 1
            },
            "& .progress": {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }
        }
    };
}
function dialogStyles(theme) {
    return {
        container: {
            display: 'flex',
            color: '#626d88',
            width: '100%',
            height: '100%',
            justifyContent: 'center'
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            border: 'solid 1px #dce1ec',
            height: 'calc(100% - 40px)',
            minWidth: 600,
            maxWidth: 1024,
            borderRadius: 2,
            width: '80%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","helpers/utils":"gGc98","./index":"dynnL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dynnL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentStandards);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _assessmentSummaryCjs = require("components/standards-selector/domain/assessment-summary.cjs");
var _context = require("teacher/context");
var _subjectAndGradeHeader = require("./components/subject-and-grade-header");
var _subjectAndGradeHeaderDefault = parcelHelpers.interopDefault(_subjectAndGradeHeader);
var _standard = require("./components/standard");
var _standardDefault = parcelHelpers.interopDefault(_standard);
const useStyles = (0, _material.makeStyles)(standardsStyles);
function AssessmentStandards(props) {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { Wrapper = DefaultWrapper, withReferences = true } = props;
    const { standardsContext, translate } = context;
    const { assessmentStandards } = standardsContext;
    const editionGroups = (0, _assessmentSummaryCjs.groupAssessmentSummary)(assessmentStandards.items);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            className: classes.root,
            children: [
                editionGroups.map((edition)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        className: classes.editionGroup,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                className: classes.editionHeading,
                                children: [
                                    translate('standards'),
                                    " \xb7 ",
                                    edition.year
                                ]
                            }),
                            edition.sections.map((section)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                    className: classes.subjectGroup,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subjectAndGradeHeaderDefault.default), {
                                            standard: section.items[0]
                                        }),
                                        section.items.map((standard)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardDefault.default), {
                                                standard: standard,
                                                withReferences: withReferences
                                            }, `${edition.id}:${standard.id}`))
                                    ]
                                }, `${edition.id}:${section.subject}:${section.grade}`))
                        ]
                    }, edition.id)),
                assessmentStandards.items.length < 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    className: classes.noStandards,
                    children: assessmentStandards.loaded && translate('no-standards-specified')
                })
            ]
        })
    });
}
function DefaultWrapper(props) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Paper), {
        className: classes.defaultwrapper,
        children: props.children
    });
}
function standardsStyles() {
    return {
        defaultwrapper: {
            display: 'flex',
            flexGrow: 1,
            overflowY: 'hidden',
            padding: '15px 0 15px 15px'
        },
        root: {
            flexGrow: 1,
            padding: 15,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto'
        },
        editionGroup: {
            marginBottom: 48,
            '&:last-child': {
                marginBottom: 0
            }
        },
        editionHeading: {
            fontSize: '19pt',
            fontWeight: 700,
            color: '#294e73',
            backgroundColor: '#eaf2fa',
            borderLeft: '5px solid #477eaf',
            padding: '14px 18px',
            marginBottom: 28
        },
        subjectGroup: {
            marginBottom: 32,
            '&:last-child': {
                marginBottom: 0
            }
        },
        noStandards: {
            display: 'flex',
            flexGrow: 1,
            padding: 30,
            justifyContent: 'center',
            color: '#3f5250',
            fontSize: '12pt',
            minWidth: '400px',
            minHeigth: '350px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/standards-selector/domain/assessment-summary.cjs":"gKIcf","teacher/context":"5LKDx","./components/subject-and-grade-header":"lDPaL","./components/standard":"drABm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKIcf":[function(require,module,exports,__globalThis) {
const { groupByEdition } = require("e858406d50653b9b");
function groupAssessmentSummary(items = []) {
    return groupByEdition(items).map((edition)=>{
        const sections = [];
        const lookup = new Map();
        for (const item of edition.items){
            const key = JSON.stringify([
                item.subject,
                item.grade
            ]);
            let section = lookup.get(key);
            if (!section) {
                section = {
                    subject: item.subject,
                    grade: item.grade,
                    items: []
                };
                lookup.set(key, section);
                sections.push(section);
            }
            section.items.push(item);
        }
        return {
            ...edition,
            sections
        };
    });
}
module.exports = {
    groupAssessmentSummary
};

},{"e858406d50653b9b":"Ul5PW"}],"lDPaL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubjectAndGradeHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(styles);
function SubjectAndGradeHeader(props) {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { standard } = props;
    const { grades, subjects, translate } = context;
    const grade = grades.find((g)=>g.id == standard.grade);
    const subject = subjects.find((s)=>s.id == standard.subject);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                className: classes.name,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _clsxDefault.default)(classes.centered, classes.subject),
                        children: subject?.name || standard.subject
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _clsxDefault.default)(classes.centered, classes.grade),
                        children: grade?.name || standard.grade
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: (0, _clsxDefault.default)(classes.centered, classes.label),
                children: translate('standards')
            })
        ]
    });
}
function styles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            color: '#3f5250'
        },
        name: {
            display: 'flex',
            fontWeight: 'bold',
            fontSize: '18pt'
        },
        label: {
            fontSize: '16pt',
            marginTop: 10,
            padding: '15px 0',
            borderBottom: 'solid 1px #d8d8d8'
        },
        centered: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'centered'
        },
        grade: {
            marginLeft: 4
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"drABm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Standard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _accordion = require("@mui/material/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionSummary = require("@mui/material/AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _accordionDetails = require("@mui/material/AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("teacher/context");
var _references = require("./references");
var _referencesDefault = parcelHelpers.interopDefault(_references);
var _expectation = require("./expectation");
var _expectationDefault = parcelHelpers.interopDefault(_expectation);
const useStyles = (0, _material.makeStyles)(styles);
const useAccordionStyles = (0, _material.makeStyles)(accordionStyles);
const useAccordionSummaryStyles = (0, _material.makeStyles)(accordionSummaryStyles);
const useAccordionDetailStyles = (0, _material.makeStyles)(accordionDetailStyles);
function Standard(props) {
    const classes = useStyles();
    const accordionClasses = useAccordionStyles();
    const accordionSummaryClasses = useAccordionSummaryStyles();
    const accordionDetailClasses = useAccordionDetailStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    const { standard, withReferences } = props;
    const disciplineLabel = standard.content.discipline ? ` - ${standard.content.discipline}` : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionDefault.default), {
        classes: accordionClasses,
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionSummaryDefault.default), {
                classes: accordionSummaryClasses,
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCaretUp)
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.standardLabel,
                        children: [
                            standard.name,
                            disciplineLabel
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.description,
                        children: standard.content.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionDetailsDefault.default), {
                classes: accordionDetailClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.expectationsLabel,
                        children: translate('expectations-and-indicators')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.expectations,
                        children: standard.expectations.map((expectation)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expectationDefault.default), {
                                expectation: expectation,
                                withReferences: withReferences
                            }, expectation.id))
                    })
                ]
            })
        ]
    });
}
function accordionStyles() {
    return {
        root: {
            boxShadow: 'none'
        }
    };
}
function accordionSummaryStyles() {
    return {
        root: {
            backgroundColor: '#f4faf8',
            color: '#4a5760',
            fontSize: '12pt',
            display: 'flex'
        },
        content: {
            display: 'flex',
            flexDirection: 'column'
        }
    };
}
function accordionDetailStyles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            padding: 0
        }
    };
}
function styles() {
    return {
        header: {
            display: 'flex'
        },
        standardLabel: {
            flexGrow: 1,
            color: '#3f5250',
            fontSize: '13pt',
            fontWeight: 'bold'
        },
        expectationsLabel: {
            color: '#3f5250',
            fontSize: '12pt',
            fontWeight: 'bold',
            padding: 16
        },
        description: {
            padding: '8px 16px',
            color: '#444e57',
            fontSize: '12pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Accordion":"lkcQj","@mui/material/AccordionSummary":"ggBKJ","@mui/material/AccordionDetails":"96rKf","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","teacher/context":"5LKDx","./references":"lr43J","./expectation":"i8rRO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lr43J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>References);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(styles);
function References(props) {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { link, assessment, translate, action } = context;
    const { references, withReferences } = props;
    const sortedReferences = (0, _lodash.uniqBy)((0, _lodash.orderBy)(references, [
        'sectionIndex',
        'index'
    ]), (s)=>`${s.sectionIndex}.${s.index}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.label,
                children: [
                    translate('standard-references-label'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.references,
                children: sortedReferences.map((reference, index)=>{
                    const to = link('quiz', assessment, action, reference.section, reference.id);
                    return withReferences ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                        className: (0, _clsxDefault.default)(classes.reference, classes.link),
                        to: to,
                        children: [
                            reference.sectionIndex + 1,
                            ".",
                            reference.index + 1
                        ]
                    }, index) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.reference,
                        children: [
                            reference.sectionIndex + 1,
                            ".",
                            reference.index + 1
                        ]
                    }, index);
                })
            })
        ]
    });
}
function styles() {
    return {
        root: {
            display: 'flex'
        },
        label: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: '#3f5250',
            fontSize: '10pt',
            fontWeight: 'bold',
            fontStyle: 'oblique',
            marginBottom: 8
        },
        references: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        link: {
            "&:hover": {
                transform: 'scale(1.1)'
            }
        },
        reference: {
            color: '#fff',
            marginBottom: 8,
            marginLeft: 8,
            textDecoration: 'none',
            backgroundColor: '#1d9be5',
            padding: 4,
            borderRadius: 5,
            fontSize: '9pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8rRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Expectation);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _accordion = require("@mui/material/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionSummary = require("@mui/material/AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _accordionDetails = require("@mui/material/AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _references = require("./references");
var _referencesDefault = parcelHelpers.interopDefault(_references);
var _indicator = require("./indicator");
var _indicatorDefault = parcelHelpers.interopDefault(_indicator);
const useStyles = (0, _material.makeStyles)(styles);
const useAccordionStyles = (0, _material.makeStyles)(accordionStyles);
const useAccordionSummaryStyles = (0, _material.makeStyles)(accordionSummaryStyles);
const useAccordionDetailStyles = (0, _material.makeStyles)(accordionDetailStyles);
function Expectation(props) {
    const classes = useStyles();
    const accordionClasses = useAccordionStyles();
    const accordionSummaryClasses = useAccordionSummaryStyles();
    const accordionDetailClasses = useAccordionDetailStyles();
    const { expectation, withReferences } = props;
    const hasIndicators = expectation.indicators.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionDefault.default), {
        classes: accordionClasses,
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionSummaryDefault.default), {
                classes: accordionSummaryClasses,
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCaretUp)
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.centered, classes.description),
                        children: expectation.description
                    }),
                    !hasIndicators && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.centered, classes.references),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _referencesDefault.default), {
                            references: expectation.references,
                            withReferences: withReferences
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionDetailsDefault.default), {
                classes: accordionDetailClasses,
                children: hasIndicators && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                    children: expectation.indicators.map((indicator)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorDefault.default), {
                            indicator: indicator,
                            withReferences: withReferences
                        }, indicator.id);
                    })
                })
            })
        ]
    });
}
function accordionStyles() {
    return {
        root: {
            boxShadow: 'none'
        }
    };
}
function accordionSummaryStyles() {
    return {
        root: {
            backgroundColor: '#f0f8fb',
            color: '#4a5760',
            fontSize: '12pt',
            display: 'flex',
            padding: '0 24px'
        },
        content: {
            display: 'flex',
            flexDirection: 'column'
        }
    };
}
function accordionDetailStyles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            padding: 0
        }
    };
}
function styles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            padding: '8px 10px'
        },
        centered: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        description: {
            flexGrow: 1,
            marginRight: 8,
            marginBottom: 5
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Accordion":"lkcQj","@mui/material/AccordionSummary":"ggBKJ","@mui/material/AccordionDetails":"96rKf","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/Box":"73kto","teacher/context":"5LKDx","./references":"lr43J","./indicator":"hL4Td","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hL4Td":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Indicator);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _references = require("./references");
var _referencesDefault = parcelHelpers.interopDefault(_references);
const useStyles = (0, _material.makeStyles)(styles);
function Indicator(props) {
    const classes = useStyles();
    const { indicator, withReferences } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.heading,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.code,
                    children: indicator.code
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    indicator.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.description,
                        children: indicator.description
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.references,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _referencesDefault.default), {
                            references: indicator.references,
                            withReferences: withReferences
                        })
                    })
                ]
            })
        ]
    });
}
function styles() {
    return {
        root: {
            display: 'flex',
            marginTop: 20,
            padding: '0 28px'
        },
        heading: {
            marginRight: 15
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
        },
        description: {
            marginBottom: 15
        },
        code: {
            minWidth: 80,
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            backgroundColor: '#40f993',
            borderRadius: 3,
            fontSize: '11pt',
            padding: '3px 16px',
            color: '#000'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","teacher/context":"5LKDx","./references":"lr43J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iSLCk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddStandards);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("external/react");
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _context = require("teacher/context");
var _standardsSelector = require("components/standards-selector/components/StandardsSelector");
var _standardsSelectorDefault = parcelHelpers.interopDefault(_standardsSelector);
var _selectionCjs = require("components/standards-selector/domain/selection.cjs");
const useStyles = (0, _material.makeStyles)(createStyles);
const useDialogStyles = (0, _material.makeStyles)(createDialogStyles);
function AddStandards({ open, closePath, onSearchStandards }) {
    const classes = useStyles();
    const dialogClasses = useDialogStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, standardsContext, updateState, link, query, languageId } = (0, _react.useContext)((0, _context.TeacherContext));
    const [filters, setFilters] = (0, _react.useState)(query);
    const [selected, setSelected] = (0, _react.useState)(standardsContext.standardsSearch.selected || {});
    // Reopen with the current route filters and a fresh selection.
    (0, _react.useEffect)(()=>{
        if (open) {
            setFilters(query);
            setSelected(standardsContext.standardsSearch.selected || {});
        }
    }, [
        open
    ]);
    const load = (0, _react.useCallback)((entity, parameters)=>(0, _commandDefault.default)('de', entity)({
            language: languageId,
            ...parameters
        }), [
        languageId
    ]);
    async function closeDialog() {
        await updateState({
            standardsContext: {
                standardsSearch: {
                    selected: {
                        $set: {}
                    },
                    questionStandards: {
                        $set: {}
                    }
                }
            }
        });
        history.push(closePath || link({}, '/:languageId/:role/:page/:tab'));
    }
    async function search() {
        const result = (0, _selectionCjs.buildSearchFilters)(selected, filters.standard);
        if (onSearchStandards) await onSearchStandards(result);
        await closeDialog();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        classes: dialogClasses,
        maxWidth: "md",
        open: open,
        onClose: closeDialog,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                className: classes.root,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsSelectorDefault.default), {
                    language: languageId,
                    load: load,
                    mode: "search",
                    filters: filters,
                    onFiltersChange: setFilters,
                    selected: selected,
                    onSelectionChange: setSelected
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogActions), {
                className: classes.actions,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                    className: classes.titleActions,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            className: (0, _clsxDefault.default)(classes.button, 'cancel'),
                            onClick: closeDialog,
                            children: translate('cancel')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            className: (0, _clsxDefault.default)(classes.button, 'search'),
                            onClick: search,
                            children: translate('search')
                        })
                    ]
                })
            })
        ]
    });
}
function createStyles() {
    return {
        root: {
            overflowY: 'auto',
            flexGrow: 1,
            minHeight: 0
        },
        titleActions: {
            marginLeft: 'auto'
        },
        actions: {
            padding: '8px 24px',
            marginBottom: 10
        },
        button: {
            width: 120,
            fontSize: '13pt',
            textTransform: 'none',
            boxShadow: 'none',
            borderRadius: 4,
            '&:first-child': {
                marginRight: 10
            },
            '&.cancel': {
                border: 'solid 1px #3d4556',
                backgroundColor: '#fff',
                color: '#3d4556',
                '&:hover': {
                    color: '#000',
                    border: 'solid 1px #000',
                    backgroundColor: '#eaf5ff'
                }
            },
            '&.search': {
                color: '#fff',
                border: 'solid 1px #2c75bd',
                backgroundColor: '#2c75bd',
                '&:hover': {
                    backgroundColor: '#71a7c7',
                    borderColor: '#71a7c7',
                    boxShadow: 'none'
                }
            }
        }
    };
}
function createDialogStyles() {
    return {
        container: {
            display: 'flex',
            color: '#626d88',
            width: '100%',
            height: '100%',
            justifyContent: 'center'
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            border: 'solid 1px #dce1ec',
            height: 'calc(100% - 120px)',
            minWidth: 600,
            maxWidth: 1600,
            borderRadius: 2,
            width: '80%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","external/react":"k16GP","react-router-dom":"3uzXR","external/material":"6yEDE","helpers/command":"f3cbG","teacher/context":"5LKDx","components/standards-selector/components/StandardsSelector":"c5fch","components/standards-selector/domain/selection.cjs":"bqeL1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5fch":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _standardsFilters = require("./StandardsFilters");
var _standardsFiltersDefault = parcelHelpers.interopDefault(_standardsFilters);
var _expectationsList = require("./ExpectationsList");
var _expectationsListDefault = parcelHelpers.interopDefault(_expectationsList);
var _selectionCjs = require("../domain/selection.cjs");
var _editionsCjs = require("../domain/editions.cjs");
var _planningSelectionMetadataCjs = require("../domain/planning-selection-metadata.cjs");
var _useStandardsData = require("../hooks/useStandardsData");
var _useStandardsDataDefault = parcelHelpers.interopDefault(_useStandardsData);
const Root = (0, _material.styled)('div')(({ theme })=>({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%',
        minWidth: 0
    }));
function StandardsSelector({ language, filters: controlledFilters, initialFilters = {}, onFiltersChange, load, selected, onSelectionChange, mode = 'quiz' }) {
    const [localFilters, setLocalFilters] = (0, _react.useState)(initialFilters);
    const filters = controlledFilters === undefined ? localFilters : controlledFilters;
    const { datasets, retry } = (0, _useStandardsDataDefault.default)({
        load,
        filters,
        language
    });
    const change = (name, value)=>{
        const next = (0, _editionsCjs.changeFilter)(filters, name, value);
        if (controlledFilters === undefined) setLocalFilters(next);
        if (onFiltersChange) onFiltersChange(next);
    };
    const currentSelection = selected === undefined ? mode === 'planning' ? [] : {} : selected;
    const toggle = (item, kind)=>{
        const candidate = mode === 'planning' ? (0, _planningSelectionMetadataCjs.enrichPlanningSelection)(item, kind, filters, datasets) : item;
        if (onSelectionChange) onSelectionChange((0, _selectionCjs.toggleSelection)(mode, currentSelection, candidate, filters, kind));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsFiltersDefault.default), {
                filters: filters,
                datasets: datasets,
                onChange: change,
                onRetry: retry
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expectationsListDefault.default), {
                expectations: datasets.expectations?.items || [],
                dataset: datasets.expectations,
                selected: currentSelection,
                mode: mode,
                edition: filters.standard_set,
                onToggle: toggle,
                onRetry: ()=>retry('expectations')
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./StandardsFilters":"7nvdG","./ExpectationsList":"3I82C","../domain/selection.cjs":"bqeL1","../domain/editions.cjs":"Ul5PW","../domain/planning-selection-metadata.cjs":"4JWfV","../hooks/useStandardsData":"l8ulP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7nvdG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _editionSelect = require("./EditionSelect");
var _editionSelectDefault = parcelHelpers.interopDefault(_editionSelect);
var _filterSelect = require("./FilterSelect");
var _filterSelectDefault = parcelHelpers.interopDefault(_filterSelect);
var _editionsCjs = require("../domain/editions.cjs");
const Filters = (0, _material.styled)('div')(({ theme })=>({
        display: 'grid',
        gridTemplateColumns: '110px minmax(150px, 210px) 110px minmax(260px, 1fr)',
        columnGap: theme.spacing(2),
        rowGap: theme.spacing(2),
        alignItems: 'start',
        padding: theme.spacing(2, 1),
        borderRadius: theme.shape.borderRadius,
        background: theme.palette.background.paper,
        border: '1px solid ' + theme.palette.divider,
        '& > div': {
            paddingTop: 22
        },
        '& .MuiFormControl-root > .MuiInputBase-root': {
            marginTop: 0
        },
        '& .MuiFormControl-root > label + .MuiInputBase-root': {
            marginTop: 0
        },
        '& .MuiInputLabel-formControl': {
            top: '-22px !important',
            left: 0,
            paddingLeft: 0,
            transform: 'translate(0, 0) scale(1) !important',
            transformOrigin: 'top left',
            position: 'absolute',
            fontSize: 12,
            lineHeight: '18px'
        },
        '& .MuiInputLabel-shrink': {
            transform: 'translate(0, 0) scale(1) !important'
        },
        '@media (max-width: 720px)': {
            gridTemplateColumns: 'minmax(100px, 1fr) minmax(140px, 2fr)'
        },
        '@media (max-width: 400px)': {
            gridTemplateColumns: 'minmax(0, 1fr)'
        }
    }));
function StandardsFilters({ filters, datasets, onChange, onRetry }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Filters, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editionSelectDefault.default), {
                value: (0, _editionsCjs.resolveEdition)(filters.standard_set),
                onChange: (value)=>onChange('standard_set', value)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSelectDefault.default), {
                entity: "subjects",
                field: "subject",
                label: "Materia",
                value: filters.subject,
                dataset: datasets.subjects,
                onChange: onChange,
                onRetry: onRetry
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSelectDefault.default), {
                entity: "grades",
                field: "grade",
                label: "Grado",
                value: filters.grade,
                dataset: datasets.grades,
                onChange: onChange,
                onRetry: onRetry
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSelectDefault.default), {
                entity: "standards",
                field: "standard",
                label: "Est\xe1ndar",
                value: filters.standard,
                dataset: datasets.standards,
                onChange: onChange,
                onRetry: onRetry
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./EditionSelect":"6wmaw","./FilterSelect":"3ccAG","../domain/editions.cjs":"Ul5PW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6wmaw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditionSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _editionsCjs = require("../domain/editions.cjs");
const Root = (0, _material.styled)('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: 0,
    '& .MuiFormControl-root': {
        width: '100%',
        minWidth: 0
    }
});
function EditionSelect({ value, onChange }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
            id: "standard-edition-filter",
            caption: "Edici\xf3n",
            value: (0, _editionsCjs.resolveEdition)(value),
            onChange: (event)=>onChange(event.target.value),
            onClear: ()=>onChange(undefined),
            children: (0, _editionsCjs.EDITIONS).map(({ id, year })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                    value: id,
                    children: year
                }, id))
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/clearable-select":"jWvEj","../domain/editions.cjs":"Ul5PW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jWvEj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ClearableSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _clear = require("@mui/icons-material/Clear");
var _clearDefault = parcelHelpers.interopDefault(_clear);
var _arrowDropDown = require("@mui/icons-material/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _input = require("@mui/material/Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _material = require("external/material");
const MenuProps = {
    PaperProps: {
        style: {
            marginTop: '1.5%'
        }
    }
};
const ClearableSelect = (0, _material.withStyles)((theme)=>({
        root: {
            "& .MuiInputLabel-formControl": {
                color: "#747b95",
                top: 8
            },
            "& .MuiSelect-select": {
                "&:focus": {
                    backgroundColor: "transparent"
                }
            },
            "& .MuiInputBase-root": {
                border: 'solid 1px #bec4d2',
                borderRadius: '3px'
            },
            "& .Muiinput-underline:before": {
                borderBottom: "0 !important"
            },
            "& .MuiInputBase-input": {
                color: "#747b95",
                padding: "9px 42px 7px 5px !important"
            },
            "& .Mui-disabled": {
                opacity: 0.5,
                backgroundColor: '#f5f5f5'
            },
            "& .clear": {
                position: 'absolute',
                right: '24px',
                cursor: 'pointer',
                "& svg": {
                    fontSize: '13pt',
                    color: "#747b95"
                }
            }
        }
    }))((props)=>{
    const labelId = `${props.id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        ...(0, _lodash.omit)(props, [
            'notClearable'
        ]),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                id: labelId,
                className: "label",
                children: props.caption
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                labelId: labelId,
                id: props.id,
                className: "select",
                variant: props.variant,
                onChange: props.onChange,
                value: props.value,
                input: props.notClearable ? undefined : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ClearableInput, {
                    onClear: props.onClear || props.onChange
                }),
                disabled: props.children.length > 0 ? false : true,
                children: props.children
            })
        ]
    });
});
function ClearableInput(props) {
    const clear = props.value == '' ? undefined : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Clear, {
        onClear: props.onClear
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputDefault.default), {
        ...(0, _lodash.omit)(props, [
            'onClear'
        ]),
        className: "input",
        endAdornment: clear
    });
}
function Clear(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
        onClick: props.onClear,
        className: "clear",
        position: "end",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearDefault.default), {})
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","@mui/material/FormControl":"kkska","@mui/material/InputAdornment":"jiJDh","@mui/icons-material/Clear":"dyxCG","@mui/icons-material/ArrowDropDown":"6qreH","@mui/material/Input":"4s0JB","@mui/material/InputLabel":"iTW3B","@mui/material/Select":"aY7hn","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dyxCG":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("d7f419fb12209552");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("4990e0c19cb4d874"));
var _jsxRuntime = require("d8cc033b783f5ac3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');

},{"d7f419fb12209552":"kZ6eK","4990e0c19cb4d874":"2vOnF","d8cc033b783f5ac3":"1dlk8"}],"3ccAG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilterSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
const Field = (0, _material.styled)('div')({
    minWidth: 0,
    width: '100%',
    '& .MuiFormControl-root': {
        width: '100%',
        minWidth: 0
    }
});
const Status = (0, _material.styled)('div')(({ theme })=>({
        fontSize: 12,
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(0.5)
    }));
function FilterSelect({ entity, field, label, value, dataset = {}, onChange, onRetry }) {
    const { items = [], status } = dataset;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Field, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                id: 'selector-' + entity,
                caption: label,
                value: value || '',
                onChange: (event)=>onChange(field, event.target.value),
                onClear: ()=>onChange(field, undefined),
                children: items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                        value: item.id,
                        children: item.name
                    }, item.id))
            }),
            status === 'loading' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Status, {
                role: "status",
                children: "Cargando\u2026"
            }),
            status === 'empty' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Status, {
                children: "Sin resultados"
            }),
            status === 'error' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Status, {
                role: "alert",
                children: [
                    "No se pudo cargar ",
                    label.toLowerCase(),
                    ". ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: ()=>onRetry(entity),
                        children: "Reintentar"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/clearable-select":"jWvEj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3I82C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExpectationsList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _expectationItem = require("./ExpectationItem");
var _expectationItemDefault = parcelHelpers.interopDefault(_expectationItem);
const Results = (0, _material.styled)('div')(({ theme })=>({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
        minHeight: 0,
        overflow: 'visible',
        padding: theme.spacing(0.5, 0.25),
        '& > section': {
            flexShrink: 0
        }
    }));
const Message = (0, _material.styled)('div')(({ theme })=>({
        padding: theme.spacing(3),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        border: '1px solid ' + theme.palette.divider,
        borderRadius: theme.shape.borderRadius
    }));
function ExpectationsList({ expectations = [], selected, mode, edition, onToggle, dataset = {}, onRetry }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Results, {
        children: [
            dataset.status === 'loading' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Message, {
                role: "status",
                children: "Cargando expectativas\u2026"
            }),
            dataset.status === 'empty' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Message, {
                children: "No se encontraron expectativas"
            }),
            dataset.status === 'error' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Message, {
                role: "alert",
                children: [
                    "No se pudieron cargar las expectativas. ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: onRetry,
                        children: "Reintentar"
                    })
                ]
            }),
            dataset.status === 'ready' && expectations.map((expectation)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expectationItemDefault.default), {
                    expectation: expectation,
                    selected: selected,
                    mode: mode,
                    edition: edition,
                    onToggle: onToggle
                }, expectation.id))
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./ExpectationItem":"ewYEc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ewYEc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExpectationItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _indicatorItem = require("./IndicatorItem");
var _indicatorItemDefault = parcelHelpers.interopDefault(_indicatorItem);
var _selectionCjs = require("../domain/selection.cjs");
const Group = (0, _material.styled)('section')(({ theme })=>({
        border: '1px solid ' + theme.palette.divider,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        background: theme.palette.background.paper
    }));
const Heading = (0, _material.styled)('button')(({ theme })=>({
        display: 'flex',
        width: '100%',
        gap: theme.spacing(1.5),
        padding: theme.spacing(2),
        textAlign: 'left',
        alignItems: 'flex-start',
        border: 0,
        background: theme.palette.action.hover,
        color: theme.palette.text.primary,
        font: 'inherit',
        fontWeight: 600,
        lineHeight: 1.5,
        cursor: 'pointer',
        '&:hover:not(:disabled)': {
            background: theme.palette.action.selected
        },
        '&[aria-pressed="true"]': {
            background: theme.palette.action.selected
        },
        '&:disabled': {
            cursor: 'default',
            opacity: 1
        },
        '&:focus-visible': {
            outline: '2px solid ' + theme.palette.primary.main,
            outlineOffset: -2
        }
    }));
const Marker = (0, _material.styled)('span')(({ theme })=>({
        color: theme.palette.primary.main,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        border: '2px solid currentColor',
        borderRadius: '50%',
        fontSize: 14,
        fontWeight: 700
    }));
const ParentMarker = (0, _material.styled)('span')(({ theme })=>({
        color: theme.palette.text.secondary,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        fontSize: 16
    }));
function ExpectationItem({ expectation, selected, mode, edition, onToggle }) {
    const children = expectation.indicators || [];
    const canToggle = mode !== 'quiz' || children.length === 0;
    const assigned = (0, _selectionCjs.isExpectationSelected)(mode, selected, expectation, edition);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Group, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Heading, {
                type: "button",
                disabled: !canToggle,
                "aria-pressed": canToggle ? assigned : undefined,
                onClick: ()=>onToggle(expectation, 'expectation'),
                children: [
                    canToggle ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Marker, {
                        "aria-hidden": "true",
                        children: assigned ? "\u2713" : ''
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(ParentMarker, {
                        "aria-hidden": "true",
                        children: "\u2014"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: expectation.description
                    })
                ]
            }),
            children.map((indicator)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indicatorItemDefault.default), {
                    indicator: indicator,
                    selected: (0, _selectionCjs.isSelected)(selected, indicator.id, edition),
                    onToggle: onToggle
                }, indicator.id))
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./IndicatorItem":"8iH1C","../domain/selection.cjs":"bqeL1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8iH1C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>IndicatorItem);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const Row = (0, _material.styled)('button')(({ theme })=>({
        display: 'flex',
        width: '100%',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2, 1.5, 4),
        textAlign: 'left',
        alignItems: 'flex-start',
        border: 0,
        borderTop: '1px solid ' + theme.palette.divider,
        background: 'transparent',
        color: theme.palette.text.primary,
        font: 'inherit',
        lineHeight: 1.5,
        cursor: 'pointer',
        '&:hover': {
            background: theme.palette.action.hover
        },
        '&[aria-pressed="true"]': {
            background: theme.palette.action.selected
        },
        '&:focus-visible': {
            outline: '2px solid ' + theme.palette.primary.main,
            outlineOffset: -2
        }
    }));
const Marker = (0, _material.styled)('span')(({ theme })=>({
        color: theme.palette.primary.main,
        flexShrink: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 22,
        height: 22,
        border: '2px solid currentColor',
        borderRadius: '50%',
        fontSize: 14,
        fontWeight: 700
    }));
function IndicatorItem({ indicator, selected, onToggle }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Row, {
        type: "button",
        "aria-pressed": Boolean(selected),
        onClick: ()=>onToggle(indicator, 'indicator'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Marker, {
                "aria-hidden": "true",
                children: selected ? "\u2713" : ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                children: [
                    indicator.code && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                        children: [
                            indicator.code,
                            " \u2014 "
                        ]
                    }),
                    indicator.description
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bqeL1":[function(require,module,exports,__globalThis) {
const { resolveEdition } = require("9a205821cf21e5f1");
// Pure selection transitions. Consumers own persistence and context updates.
function selectedItems(selected) {
    return Object.values(selected).filter(Boolean);
}
function toggleQuizItem(selected, item, query) {
    if (item.indicators && item.indicators.length) return selected;
    const next = {
        ...selected
    };
    if (next[item.id]) delete next[item.id];
    else next[item.id] = {
        ...item,
        subject: query.subject,
        grade: query.grade,
        standard: query.standard,
        standard_set: resolveEdition(query.standard_set)
    };
    return next;
}
function toggleSearchExpectation(selected, expectation, query) {
    const next = {
        ...selected
    };
    const items = [
        expectation,
        ...expectation.indicators || []
    ];
    const removing = Boolean(next[expectation.id]);
    for (const item of items)if (removing) delete next[item.id];
    else next[item.id] = {
        ...item,
        subject: query.subject,
        grade: query.grade,
        standard: query.standard,
        standard_set: resolveEdition(query.standard_set)
    };
    return next;
}
function toggleSearchIndicator(selected, indicator, query) {
    const next = {
        ...selected
    };
    if (next[indicator.id]) delete next[indicator.id];
    else next[indicator.id] = {
        ...indicator,
        subject: query.subject,
        grade: query.grade,
        standard: query.standard,
        standard_set: resolveEdition(query.standard_set)
    };
    return next;
}
function toggleSelection(mode, selected, item, query = {}, kind = 'expectation') {
    if (mode === 'quiz') return toggleQuizItem(selected, item, query);
    if (mode === 'search') return kind === 'indicator' ? toggleSearchIndicator(selected, item, query) : toggleSearchExpectation(selected, item, query);
    if (mode === 'planning') return kind === 'indicator' ? togglePlanningIndicator(selected, item, query) : togglePlanningExpectation(selected, item, query);
    throw new Error('Unknown selection mode: ' + mode);
}
function isSelected(selected, id, edition) {
    return Array.isArray(selected) ? selected.some((item)=>item.id === id && (edition === undefined || resolveEdition(item.standard_set) === resolveEdition(edition))) : Boolean(selected[id]);
}
function isExpectationSelected(mode, selected, expectation, edition) {
    if (mode !== 'planning' || !(expectation.indicators || []).length) return isSelected(selected, expectation.id, edition);
    return expectation.indicators.every((item)=>isSelected(selected, item.id, edition));
}
function buildSearchFilters(selected, standard) {
    const items = selectedItems(selected);
    const indicators = items.filter((item)=>Boolean(item.code)).map((item)=>item.id);
    const expectations = indicators.length ? [] : items.filter((item)=>!item.code).map((item)=>item.id);
    return {
        indicators,
        expectations,
        standards: indicators.length || expectations.length || !standard ? [] : [
            standard
        ]
    };
}
function togglePlanningIndicator(selected, indicator, query = {}) {
    const edition = resolveEdition(query.standard_set);
    const matches = (item)=>item.id === indicator.id && resolveEdition(item.standard_set) === edition;
    return selected.some(matches) ? selected.filter((item)=>!matches(item)) : [
        ...selected,
        {
            ...indicator,
            standard_set: edition
        }
    ];
}
function togglePlanningExpectation(selected, expectation, query = {}) {
    const children = expectation.indicators || [];
    const items = children.length ? children : [
        expectation
    ];
    const edition = resolveEdition(query.standard_set);
    const ids = new Set(items.map((item)=>item.id));
    const sameEdition = (item)=>resolveEdition(item.standard_set) === edition;
    const existingIds = new Set(selected.filter(sameEdition).map((item)=>item.id));
    const allSelected = items.every((item)=>existingIds.has(item.id));
    if (allSelected) return selected.filter((item)=>!(sameEdition(item) && ids.has(item.id)));
    return [
        ...selected,
        ...items.filter((item)=>!existingIds.has(item.id)).map((item)=>({
                ...item,
                standard_set: resolveEdition(query.standard_set)
            }))
    ];
}
module.exports = {
    selectedItems,
    toggleQuizItem,
    toggleSearchExpectation,
    toggleSearchIndicator,
    toggleSelection,
    isSelected,
    isExpectationSelected,
    buildSearchFilters,
    togglePlanningIndicator,
    togglePlanningExpectation
};

},{"9a205821cf21e5f1":"Ul5PW"}],"4JWfV":[function(require,module,exports,__globalThis) {
function enrichPlanningSelection(item, kind, filters, datasets) {
    const standards = datasets.standards?.items || [];
    const expectations = datasets.expectations?.items || [];
    const parent = kind === 'indicator' ? expectations.find((expectation)=>expectation.id === item.expectation || (expectation.indicators || []).some((indicator)=>indicator.id === item.id)) : item;
    const standard = standards.find((entry)=>entry.id === (parent?.standard || filters.standard));
    const metadata = {
        standard: parent?.standard || filters.standard,
        standard_name: standard?.name,
        expectation_name: parent?.name,
        expectation_description: parent?.description
    };
    if (kind === 'expectation' && Array.isArray(item.indicators)) return {
        ...item,
        ...metadata,
        indicators: item.indicators.map((indicator)=>({
                ...indicator,
                ...metadata
            }))
    };
    return {
        ...item,
        ...metadata
    };
}
module.exports = {
    enrichPlanningSelection
};

},{}],"l8ulP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStandardsData);
var _react = require("external/react");
var _dataCjs = require("../domain/data.cjs");
function useStandardsData({ load, filters, language }) {
    const [datasets, setDatasets] = (0, _react.useState)({});
    const controller = (0, _react.useMemo)(()=>(0, _dataCjs.createStandardsDataController)(load, (entity, state, snapshot)=>setDatasets(snapshot)), [
        load
    ]);
    (0, _react.useEffect)(()=>()=>controller.dispose(), [
        controller
    ]);
    (0, _react.useEffect)(()=>{
        controller.refresh(filters, language);
    }, [
        controller,
        language,
        filters.standard_set,
        filters.subject,
        filters.grade,
        filters.standard,
        filters.pattern
    ]);
    const retry = (entity)=>controller.retry(entity, filters, language);
    return {
        datasets,
        retry
    };
}

},{"external/react":"k16GP","../domain/data.cjs":"6rcgm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6rcgm":[function(require,module,exports,__globalThis) {
const { createRequestGate } = require("4fa2507b101b5435");
const { deParameters, resolveEdition } = require("c61352a0cf9e1db1");
const ENTITIES = [
    'subjects',
    'grades',
    'standards',
    'expectations'
];
function parameters(entity, filters, language) {
    return deParameters(entity, {
        ...filters,
        standard_set: resolveEdition(filters.standard_set)
    }, language);
}
function key(entity, filters, language) {
    return JSON.stringify(parameters(entity, filters, language));
}
function createStandardsDataController(load, notify = ()=>{}) {
    const gate = createRequestGate();
    const states = {};
    const keys = {};
    let disposed = false;
    const emit = (entity, state)=>{
        states[entity] = state;
        if (!disposed) notify(entity, state, {
            ...states
        });
    };
    function request(entity, filters, language, force = false) {
        if (disposed) return Promise.resolve();
        const nextKey = key(entity, filters, language);
        if (!force && keys[entity] === nextKey) return Promise.resolve(states[entity]);
        keys[entity] = nextKey;
        const current = gate.begin(entity);
        emit(entity, {
            items: [],
            status: 'loading',
            error: null
        });
        return Promise.resolve().then(()=>load(entity, parameters(entity, filters, language))).then((items)=>{
            if (!current() || disposed) return;
            if (!Array.isArray(items)) throw new TypeError('Expected an array');
            emit(entity, {
                items,
                status: items.length ? 'ready' : 'empty',
                error: null
            });
        }).catch((error)=>{
            if (current() && !disposed) emit(entity, {
                items: [],
                status: 'error',
                error
            });
        });
    }
    return {
        refresh (filters, language) {
            return Promise.all(ENTITIES.map((entity)=>request(entity, filters, language)));
        },
        retry (entity, filters, language) {
            return request(entity, filters, language, true);
        },
        snapshot () {
            return {
                ...states
            };
        },
        dispose () {
            disposed = true;
            ENTITIES.forEach((entity)=>gate.invalidate(entity));
        }
    };
}
module.exports = {
    ENTITIES,
    parameters,
    key,
    createStandardsDataController
};

},{"4fa2507b101b5435":"f2pQi","c61352a0cf9e1db1":"Ul5PW"}],"f2pQi":[function(require,module,exports,__globalThis) {
// A request sequence per dataset prevents older responses from replacing newer filters.
function createRequestGate() {
    const versions = new Map();
    return {
        begin (key) {
            const version = (versions.get(key) || 0) + 1;
            versions.set(key, version);
            return ()=>versions.get(key) === version;
        },
        invalidate (key) {
            versions.set(key, (versions.get(key) || 0) + 1);
        }
    };
}
module.exports = {
    createRequestGate
};

},{}],"auW3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuizTabsComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _tabPanel = require("../components/TabPanel");
const QuizTab = (0, _material.styled)((0, _material.Tab))(quizTabStyles);
const QuizTabs = (0, _material.styled)((0, _material.Tabs))(quizTabsStyles);
const StyledQuizTab = (0, _material.styled)('div')(tabsComponentStyles);
const QuizTabsComponent = ({ context })=>{
    const { translate, link, tab, updateState } = context;
    const history = (0, _react.useHistory)();
    const handleChange = async (event, nextTab)=>{
        if (nextTab === tab) return;
        await updateState({
            quizStandardFilters: {
                expectations: {
                    $set: []
                },
                indicators: {
                    $set: []
                },
                standards: {
                    $set: []
                }
            }
        });
        history.push(link({
            tab: nextTab
        }, '/:languageId/:role/:page/:tab'));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledQuizTab, {
        children: tab && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(QuizTabs, {
            value: tab,
            onChange: handleChange,
            "aria-label": "ant example",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizTab, {
                    value: "assessments",
                    label: translate('assessment-tab'),
                    ...(0, _tabPanel.a11yProps)('assessments')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizTab, {
                    value: "question-bank",
                    label: translate('question-bank-tab'),
                    ...(0, _tabPanel.a11yProps)('question-bank')
                }),
                ")",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizTab, {
                    value: "assessment-bank",
                    label: translate('assessment-bank-tab'),
                    ...(0, _tabPanel.a11yProps)('assessment-bank')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizTab, {
                    value: "assigned",
                    label: translate('assigned-assessment-tab'),
                    ...(0, _tabPanel.a11yProps)('assigned')
                })
            ]
        })
    });
};
function tabsComponentStyles() {
    return {
        flexGrow: 1
    };
}
function quizTabStyles({ theme }) {
    return {
        textTransform: 'none',
        minWidth: 72,
        color: '#929cb5',
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(4),
        textTransform: 'uppercase',
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(','),
        '&:hover': {
            color: '#40a9ff',
            opacity: 1
        },
        '&$selected': {
            color: '#4f576e',
            fontWeight: theme.typography.fontWeightMedium
        },
        '&:focus': {
            color: '#4f576e'
        }
    };
}
function quizTabsStyles() {
    return {
        borderBottom: '1px solid #e8e8e8',
        '& .indicator': {
            height: 4,
            backgroundColor: '#f3a608'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","../components/TabPanel":"duoCN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"duoCN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabPanel);
parcelHelpers.export(exports, "a11yProps", ()=>a11yProps);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `simple-tabpanel-${index}`,
        "aria-labelledby": `simple-tab-${index}`,
        ...other,
        children: value === index && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: "tab-content",
            children: children
        })
    });
}
TabPanel.propTypes = {
    children: (0, _propTypesDefault.default).node,
    index: (0, _propTypesDefault.default).any.isRequired,
    value: (0, _propTypesDefault.default).any.isRequired
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","prop-types":"bnNSm","@mui/material/Typography":"2wCD5","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dyMv4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _pagination = require("./pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _icons = require("resources/icons");
const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            color: '#4f576e',
            fontSize: '12pt'
        },
        count: {
            display: 'flex'
        },
        countIcon: {
            ...verticalCentering,
            marginTop: -5,
            marginRight: 5
        },
        questionsLabel: {
            ...verticalCentering
        },
        countLabel: {
            ...verticalCentering
        },
        pagination: {
            flexGrow: 1
        }
    }));
function Footer({ context }) {
    const { tab } = context;
    const classes = useStyles();
    const page = parseInt(context.query.page);
    const { recordCount, pageSize } = context.quizPaging;
    const pageCount = Math.ceil(recordCount / pageSize);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.count,
                children: [
                    tab != 'question-bank' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.countIcon,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                            fill: '#68728b'
                        })
                    }),
                    tab == 'question-bank' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.questionsLabel,
                        children: context.translate('question-bank-pagination-label')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.countLabel,
                        children: [
                            ": ",
                            recordCount
                        ]
                    })
                ]
            }),
            tab != 'assessments' && pageCount > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.pagination,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                    context: context,
                    page: isNaN(page) ? 1 : page,
                    count: pageCount
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","./pagination":"8EaGd","resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8EaGd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuizPaginationComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _pagination = require("@mui/material/Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationItem = require("@mui/material/PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
const QuizPagination = (0, _material.withStyles)((theme)=>({
        ul: {
            justifyContent: 'center'
        }
    }))((0, _paginationDefault.default));
const QuizPaginationItem = (0, _material.withStyles)((theme)=>({
        root: {
            color: '#4f576e',
            fontSize: '12pt',
            fontWeight: '400',
            marginRight: '4px',
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"'
            ].join(','),
            '&:hover': {
                borderRadius: 3
            }
        },
        outlined: {
            backgroundColor: '#fff',
            borderRadius: 3,
            border: 'solid 1px #909ebb'
        },
        page: {},
        selected: {
            borderRadius: 3,
            backgroundColor: '#c9f1fd !important'
        }
    }))((0, _paginationItemDefault.default));
function QuizPaginationComponent({ context, page, count }) {
    const history = (0, _reactRouterDom.useHistory)();
    const handleChange = (event, page)=>{
        history.push(context.link(undefined, undefined, {
            query: {
                page
            },
            preserveQuery: true
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizPagination, {
        count: count,
        page: page,
        onChange: handleChange,
        renderItem: (item)=>{
            const variant = [
                'next',
                'previous'
            ].indexOf(item.type) >= 0 ? 'outlined' : 'text';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizPaginationItem, {
                ...item,
                variant
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Pagination":"bePWZ","@mui/material/PaginationItem":"feAT5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bePWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationDefault.default));
parcelHelpers.export(exports, "paginationClasses", ()=>(0, _paginationClassesDefault.default));
var _pagination = require("./Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationClasses = require("./paginationClasses");
var _paginationClassesDefault = parcelHelpers.interopDefault(_paginationClasses);
parcelHelpers.exportAll(_paginationClasses, exports);
'use client';

},{"./Pagination":"2GAmV","./paginationClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2GAmV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _paginationClasses = require("./paginationClasses");
var _usePagination = require("../usePagination");
var _usePaginationDefault = parcelHelpers.interopDefault(_usePagination);
var _paginationItem = require("../PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "boundaryCount",
    "className",
    "color",
    "count",
    "defaultPage",
    "disabled",
    "getItemAriaLabel",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "renderItem",
    "shape",
    "showFirstButton",
    "showLastButton",
    "siblingCount",
    "size",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant
        ],
        ul: [
            'ul'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _paginationClasses.getPaginationUtilityClass), classes);
};
const PaginationRoot = (0, _styledDefault.default)('nav', {
    name: 'MuiPagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant]
        ];
    }
})({});
const PaginationUl = (0, _styledDefault.default)('ul', {
    name: 'MuiPagination',
    slot: 'Ul',
    overridesResolver: (props, styles)=>styles.ul
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
function defaultGetAriaLabel(type, page, selected) {
    if (type === 'page') return `${selected ? '' : 'Go to '}page ${page}`;
    return `Go to ${type} page`;
}
const Pagination = /*#__PURE__*/ _react.forwardRef(function Pagination(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPagination'
    });
    const { boundaryCount = 1, className, color = 'standard', count = 1, defaultPage = 1, disabled = false, getItemAriaLabel = defaultGetAriaLabel, hideNextButton = false, hidePrevButton = false, renderItem = (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationItemDefault.default), (0, _extendsDefault.default)({}, item)), shape = 'circular', showFirstButton = false, showLastButton = false, siblingCount = 1, size = 'medium', variant = 'text' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const { items } = (0, _usePaginationDefault.default)((0, _extendsDefault.default)({}, props, {
        componentName: 'Pagination'
    }));
    const ownerState = (0, _extendsDefault.default)({}, props, {
        boundaryCount,
        color,
        count,
        defaultPage,
        disabled,
        getItemAriaLabel,
        hideNextButton,
        hidePrevButton,
        renderItem,
        shape,
        showFirstButton,
        showLastButton,
        siblingCount,
        size,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationRoot, (0, _extendsDefault.default)({
        "aria-label": "pagination navigation",
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationUl, {
            className: classes.ul,
            ownerState: ownerState,
            children: items.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                    children: renderItem((0, _extendsDefault.default)({}, item, {
                        color,
                        'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
                        shape,
                        size,
                        variant
                    }))
                }, index))
        })
    }));
});
exports.default = Pagination;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/utils/integerPropType":"bc5x8","../DefaultPropsProvider":"ff3VX","./paginationClasses":"hnrIx","../usePagination":"3oXnX","../PaginationItem":"feAT5","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hnrIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaginationUtilityClass", ()=>getPaginationUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaginationUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPagination', slot);
}
const paginationClasses = (0, _generateUtilityClassesDefault.default)('MuiPagination', [
    'root',
    'ul',
    'outlined',
    'text'
]);
exports.default = paginationClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3oXnX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _usePaginationDefault.default));
var _usePagination = require("./usePagination");
var _usePaginationDefault = parcelHelpers.interopDefault(_usePagination);
'use client';

},{"./usePagination":"5i6SE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5i6SE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePagination);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _useControlled = require("@mui/utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
'use client';
const _excluded = [
    "boundaryCount",
    "componentName",
    "count",
    "defaultPage",
    "disabled",
    "hideNextButton",
    "hidePrevButton",
    "onChange",
    "page",
    "showFirstButton",
    "showLastButton",
    "siblingCount"
];
function usePagination(props = {}) {
    // keep default values in sync with @default tags in Pagination.propTypes
    const { boundaryCount = 1, componentName = 'usePagination', count = 1, defaultPage = 1, disabled = false, hideNextButton = false, hidePrevButton = false, onChange: handleChange, page: pageProp, showFirstButton = false, showLastButton = false, siblingCount = 1 } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const [page, setPageState] = (0, _useControlledDefault.default)({
        controlled: pageProp,
        default: defaultPage,
        name: componentName,
        state: 'page'
    });
    const handleClick = (event, value)=>{
        if (!pageProp) setPageState(value);
        if (handleChange) handleChange(event, value);
    };
    // https://dev.to/namirsab/comment/2050
    const range = (start, end)=>{
        const length = end - start + 1;
        return Array.from({
            length
        }, (_, i)=>start + i);
    };
    const startPages = range(1, Math.min(boundaryCount, count));
    const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
    const siblingsStart = Math.max(Math.min(// Natural start
    page - siblingCount, // Lower boundary when page is high
    count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    const siblingsEnd = Math.min(Math.max(// Natural end
    page + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : count - 1);
    // Basic list of items to render
    // for example itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']
    const itemList = [
        ...showFirstButton ? [
            'first'
        ] : [],
        ...hidePrevButton ? [] : [
            'previous'
        ],
        ...startPages,
        // Start ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsStart > boundaryCount + 2 ? [
            'start-ellipsis'
        ] : boundaryCount + 1 < count - boundaryCount ? [
            boundaryCount + 1
        ] : [],
        // Sibling pages
        ...range(siblingsStart, siblingsEnd),
        // End ellipsis
        // eslint-disable-next-line no-nested-ternary
        ...siblingsEnd < count - boundaryCount - 1 ? [
            'end-ellipsis'
        ] : count - boundaryCount > boundaryCount ? [
            count - boundaryCount
        ] : [],
        ...endPages,
        ...hideNextButton ? [] : [
            'next'
        ],
        ...showLastButton ? [
            'last'
        ] : []
    ];
    // Map the button type to its page number
    const buttonPage = (type)=>{
        switch(type){
            case 'first':
                return 1;
            case 'previous':
                return page - 1;
            case 'next':
                return page + 1;
            case 'last':
                return count;
            default:
                return null;
        }
    };
    // Convert the basic item list to PaginationItem props objects
    const items = itemList.map((item)=>{
        return typeof item === 'number' ? {
            onClick: (event)=>{
                handleClick(event, item);
            },
            type: 'page',
            page: item,
            selected: item === page,
            disabled,
            'aria-current': item === page ? 'true' : undefined
        } : {
            onClick: (event)=>{
                handleClick(event, buttonPage(item));
            },
            type: item,
            page: buttonPage(item),
            selected: false,
            disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
        };
    });
    return (0, _extendsDefault.default)({
        items
    }, other);
}

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@mui/utils/useControlled":"fOjEQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"feAT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _paginationItemDefault.default));
parcelHelpers.export(exports, "paginationItemClasses", ()=>(0, _paginationItemClassesDefault.default));
var _paginationItem = require("./PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
var _paginationItemClasses = require("./paginationItemClasses");
var _paginationItemClassesDefault = parcelHelpers.interopDefault(_paginationItemClasses);
parcelHelpers.exportAll(_paginationItemClasses, exports);
'use client';

},{"./PaginationItem":"aUj6s","./paginationItemClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aUj6s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _rtlProvider = require("@mui/system/RtlProvider");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _paginationItemClasses = require("./paginationItemClasses");
var _paginationItemClassesDefault = parcelHelpers.interopDefault(_paginationItemClasses);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _firstPage = require("../internal/svg-icons/FirstPage");
var _firstPageDefault = parcelHelpers.interopDefault(_firstPage);
var _lastPage = require("../internal/svg-icons/LastPage");
var _lastPageDefault = parcelHelpers.interopDefault(_lastPage);
var _navigateBefore = require("../internal/svg-icons/NavigateBefore");
var _navigateBeforeDefault = parcelHelpers.interopDefault(_navigateBefore);
var _navigateNext = require("../internal/svg-icons/NavigateNext");
var _navigateNextDefault = parcelHelpers.interopDefault(_navigateNext);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "color",
    "component",
    "components",
    "disabled",
    "page",
    "selected",
    "shape",
    "size",
    "slots",
    "type",
    "variant"
];
const overridesResolver = (props, styles)=>{
    const { ownerState } = props;
    return [
        styles.root,
        styles[ownerState.variant],
        styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
        ownerState.variant === 'text' && styles[`text${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.variant === 'outlined' && styles[`outlined${(0, _capitalizeDefault.default)(ownerState.color)}`],
        ownerState.shape === 'rounded' && styles.rounded,
        ownerState.type === 'page' && styles.page,
        (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis,
        (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext,
        (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast
    ];
};
const useUtilityClasses = (ownerState)=>{
    const { classes, color, disabled, selected, size, shape, type, variant } = ownerState;
    const slots = {
        root: [
            'root',
            `size${(0, _capitalizeDefault.default)(size)}`,
            variant,
            shape,
            color !== 'standard' && `color${(0, _capitalizeDefault.default)(color)}`,
            color !== 'standard' && `${variant}${(0, _capitalizeDefault.default)(color)}`,
            disabled && 'disabled',
            selected && 'selected',
            {
                page: 'page',
                first: 'firstLast',
                last: 'firstLast',
                'start-ellipsis': 'ellipsis',
                'end-ellipsis': 'ellipsis',
                previous: 'previousNext',
                next: 'previousNext'
            }[type]
        ],
        icon: [
            'icon'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _paginationItemClasses.getPaginationItemUtilityClass), classes);
};
const PaginationItemEllipsis = (0, _styledDefault.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        height: 'auto',
        [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }));
const PaginationItemPage = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: 'MuiPaginationItem',
    slot: 'Root',
    overridesResolver
})(({ theme, ownerState })=>(0, _extendsDefault.default)({}, theme.typography.body2, {
        borderRadius: 16,
        textAlign: 'center',
        boxSizing: 'border-box',
        minWidth: 32,
        height: 32,
        padding: '0 6px',
        margin: '0 3px',
        color: (theme.vars || theme).palette.text.primary,
        [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        transition: theme.transitions.create([
            'color',
            'background-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: {
            backgroundColor: (theme.vars || theme).palette.action.selected,
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette.action.selected
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            },
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.action.disabled,
                backgroundColor: (theme.vars || theme).palette.action.selected
            }
        }
    }, ownerState.size === 'small' && {
        minWidth: 26,
        height: 26,
        borderRadius: 13,
        margin: '0 1px',
        padding: '0 4px'
    }, ownerState.size === 'large' && {
        minWidth: 40,
        height: 40,
        borderRadius: 20,
        padding: '0 10px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.shape === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }), ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === 'text' && {
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: (0, _extendsDefault.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].contrastText,
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
            '&:hover': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: (theme.vars || theme).palette[ownerState.color].main
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
            }
        }, {
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }, ownerState.variant === 'outlined' && {
        border: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
        [`&.${(0, _paginationItemClassesDefault.default).selected}`]: (0, _extendsDefault.default)({}, ownerState.color !== 'standard' && {
            color: (theme.vars || theme).palette[ownerState.color].main,
            border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, 0.5)}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.activatedOpacity})` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, _paginationItemClassesDefault.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / calc(${theme.vars.palette.action.activatedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, _colorManipulator.alpha)(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
            }
        }, {
            [`&.${(0, _paginationItemClassesDefault.default).disabled}`]: {
                borderColor: (theme.vars || theme).palette.action.disabledBackground,
                color: (theme.vars || theme).palette.action.disabled
            }
        })
    }));
const PaginationItemPageIcon = (0, _styledDefault.default)('div', {
    name: 'MuiPaginationItem',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        fontSize: theme.typography.pxToRem(20),
        margin: '0 -8px'
    }, ownerState.size === 'small' && {
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        fontSize: theme.typography.pxToRem(22)
    }));
const PaginationItem = /*#__PURE__*/ _react.forwardRef(function PaginationItem(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiPaginationItem'
    });
    const { className, color = 'standard', component, components = {}, disabled = false, page, selected = false, shape = 'circular', size = 'medium', slots = {}, type = 'page', variant = 'text' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        disabled,
        selected,
        shape,
        size,
        type,
        variant
    });
    const isRtl = (0, _rtlProvider.useRtl)();
    const classes = useUtilityClasses(ownerState);
    const normalizedIcons = isRtl ? {
        previous: slots.next || components.next || (0, _navigateNextDefault.default),
        next: slots.previous || components.previous || (0, _navigateBeforeDefault.default),
        last: slots.first || components.first || (0, _firstPageDefault.default),
        first: slots.last || components.last || (0, _lastPageDefault.default)
    } : {
        previous: slots.previous || components.previous || (0, _navigateBeforeDefault.default),
        next: slots.next || components.next || (0, _navigateNextDefault.default),
        first: slots.first || components.first || (0, _firstPageDefault.default),
        last: slots.last || components.last || (0, _lastPageDefault.default)
    };
    const Icon = normalizedIcons[type];
    return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemEllipsis, {
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        children: "\u2026"
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PaginationItemPage, (0, _extendsDefault.default)({
        ref: ref,
        ownerState: ownerState,
        component: component,
        disabled: disabled,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other, {
        children: [
            type === 'page' && page,
            Icon ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaginationItemPageIcon, {
                as: Icon,
                ownerState: ownerState,
                className: classes.icon
            }) : null
        ]
    }));
});
exports.default = PaginationItem;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","@mui/system/RtlProvider":"aMQRu","../DefaultPropsProvider":"ff3VX","./paginationItemClasses":"ju0DO","../ButtonBase":"ajcyv","../utils/capitalize":"hBZko","../internal/svg-icons/FirstPage":"aaomN","../internal/svg-icons/LastPage":"28Mtn","../internal/svg-icons/NavigateBefore":"6tf7i","../internal/svg-icons/NavigateNext":"9ITFl","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ju0DO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPaginationItemUtilityClass", ()=>getPaginationItemUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getPaginationItemUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiPaginationItem', slot);
}
const paginationItemClasses = (0, _generateUtilityClassesDefault.default)('MuiPaginationItem', [
    'root',
    'page',
    'sizeSmall',
    'sizeLarge',
    'text',
    'textPrimary',
    'textSecondary',
    'outlined',
    'outlinedPrimary',
    'outlinedSecondary',
    'rounded',
    'ellipsis',
    'firstLast',
    'previousNext',
    'focusVisible',
    'disabled',
    'selected',
    'icon',
    'colorPrimary',
    'colorSecondary'
]);
exports.default = paginationItemClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aaomN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"28Mtn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6tf7i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ITFl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gRZUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Content);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _tabPanel = require("../components/TabPanel");
var _tabPanelDefault = parcelHelpers.interopDefault(_tabPanel);
var _assessments = require("./assessments");
var _assessmentsDefault = parcelHelpers.interopDefault(_assessments);
var _assessmentBank = require("./assessment-bank");
var _assessmentBankDefault = parcelHelpers.interopDefault(_assessmentBank);
var _questionBank = require("./question-bank");
var _questionBankDefault = parcelHelpers.interopDefault(_questionBank);
var _assignments = require("./assignments");
var _assignmentsDefault = parcelHelpers.interopDefault(_assignments);
var _previewBlankPdf = require("../preview-blank-pdf");
var _previewBlankPdfDefault = parcelHelpers.interopDefault(_previewBlankPdf);
const useStyles = (0, _material.makeStyles)(contentStyles);
function Content({ context }) {
    const { tab: value } = context;
    const classes = useStyles();
    const tabProperties = (index)=>({
            value,
            index,
            className: (0, _clsxDefault.default)(classes[index], value == index ? classes.active : undefined)
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classes.root,
        children: value != undefined && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewBlankPdfDefault.default), {
                    context: context
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabPanelDefault.default), {
                    ...tabProperties("assessments"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentsDefault.default), {
                        context: context
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabPanelDefault.default), {
                    ...tabProperties("question-bank"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionBankDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabPanelDefault.default), {
                    ...tabProperties("assessment-bank"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentBankDefault.default), {
                        context: context
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabPanelDefault.default), {
                    ...tabProperties("assigned"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentsDefault.default), {
                        context: context
                    })
                })
            ]
        })
    });
}
function contentStyles() {
    return {
        root: {
            display: 'flex',
            flexGrow: 1
        },
        active: {
            display: 'flex',
            flexGrow: 1,
            "& .tab-content": {
                display: 'flex',
                flexGrow: 1,
                border: "solid 1px #e0e0e0",
                borderBottom: "none"
            }
        },
        "question-bank": {
            "& .tab-content": {
                border: 'none'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","../components/TabPanel":"duoCN","./assessments":"lrrPL","./assessment-bank":"8B2ma","./question-bank":"f5tfK","./assignments":"eKVvD","../preview-blank-pdf":"1PWgo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lrrPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assessments);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _createAssessment = require("./create-assessment");
var _createAssessmentDefault = parcelHelpers.interopDefault(_createAssessment);
var _assessmentFilters = require("./assessment-filters");
var _assessmentFiltersDefault = parcelHelpers.interopDefault(_assessmentFilters);
var _assessmentsHead = require("./assessments-head");
var _assessmentsHeadDefault = parcelHelpers.interopDefault(_assessmentsHead);
var _assessmentsBody = require("./assessments-body");
var _assessmentsBodyDefault = parcelHelpers.interopDefault(_assessmentsBody);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _filterChip = require("../components/filter-chip");
var _filterChipDefault = parcelHelpers.interopDefault(_filterChip);
const useStyles = (0, _material.makeStyles)({
    root: {
        flexGrow: 1,
        width: '100%',
        display: 'flex',
        backgroundColor: '#fff',
        flexDirection: 'column'
    },
    content: {
        display: 'flex',
        flexGrow: 1,
        overflow: 'hidden'
    },
    container: {
        flexGrow: 1,
        overflow: 'auto'
    },
    chips: {
        '&.hasChip': {
            padding: '8px 15px',
            marginTop: 0
        },
        '& .filter-chip': {
            backgroundColor: '#de3434',
            color: '#fff',
            '& .MuiChip-label': {
                padding: '0 20px'
            },
            '& .MuiChip-deleteIcon': {}
        }
    },
    filters: {
        display: 'flex',
        padding: '0 15px 8px 15px',
        "& .create-quiz-wrapper": {
            display: "flex",
            marginTop: -9,
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: 15
        }
    }
});
function Assessments({ context }) {
    const { translate, updateState } = context;
    const classes = useStyles();
    const from = context.link();
    const hasStandardsChip = Object.values(context.quizStandardFilters).some((a)=>a.length > 0);
    const hasChip = !(!context.query.pattern && !context.query.id && !hasStandardsChip);
    function clearStandardFilters() {
        updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: {
                expectations: {
                    $set: []
                },
                indicators: {
                    $set: []
                },
                standards: {
                    $set: []
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.filters,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentFiltersDefault.default), {
                        context: context
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "create-quiz-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createAssessmentDefault.default), {
                            context: context
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.chips, {
                    hasChip
                }),
                children: [
                    context.query.pattern && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "pattern",
                        context: context,
                        from: from
                    }),
                    context.query.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "id",
                        context: context,
                        createLabel: ()=>translate('new-assessment'),
                        from: from
                    }),
                    hasStandardsChip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "standards",
                        context: context,
                        createLabel: ()=>translate('standards-filter-chip'),
                        from: from,
                        onDelete: clearStandardFilters
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                    className: classes.container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                        in: !context.quizSearch.assessments,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                            className: classes.table,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentsHeadDefault.default), {
                                    context: context
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentsBodyDefault.default), {
                                    context: context
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","./create-assessment":"e8dJn","./assessment-filters":"6kXOK","./assessments-head":"2fwur","./assessments-body":"3hz76","@mui/material/Fade":"8DwqP","@mui/material/TableContainer":"2Kmn7","@mui/material/Table":"if4Vw","../components/filter-chip":"i3UT5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e8dJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateAssessmentMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _moveToInbox = require("@mui/icons-material/MoveToInbox");
var _moveToInboxDefault = parcelHelpers.interopDefault(_moveToInbox);
var _drafts = require("@mui/icons-material/Drafts");
var _draftsDefault = parcelHelpers.interopDefault(_drafts);
var _send = require("@mui/icons-material/Send");
var _sendDefault = parcelHelpers.interopDefault(_send);
var _form = require("./form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _directoryForm = require("./directory-form");
var _directoryFormDefault = parcelHelpers.interopDefault(_directoryForm);
const AddButton = (0, _material.withStyles)({
    root: {
        backgroundColor: '#2ca5ec',
        color: '#fff',
        '& svg': {
            marginTop: -3
        },
        '&:hover': {
            backgroundColor: '#0069d9',
            borderColor: '#0062cc',
            boxShadow: 'none'
        }
    }
})((0, _buttonDefault.default));
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        button: {
            flexGrow: 1
        },
        menu: {}
    }));
const StyledMenu = (0, _material.withStyles)({
    paper: {
        border: '1px solid #d3d4d5'
    }
})((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        ...props
    }));
const StyledMenuItem = (0, _material.withStyles)((theme)=>({
        root: {
            '&:focus': {
                backgroundColor: theme.palette.primary.main,
                '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                    color: theme.palette.common.white
                }
            }
        }
    }))((0, _menuItemDefault.default));
function CreateAssessmentMenu({ context, simple }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const handleClick = (event)=>{
        if (simple) handleOpenDialog('create-assessment')();
        else setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    function handleOpenDialog(name) {
        return (e)=>{
            handleClose();
            const quizDialogs = (0, _immutabilityHelperDefault.default)(context.quizDialogs, {
                [name]: {
                    $set: true
                }
            });
            context.setState({
                quizDialogs
            });
        };
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AddButton, {
                "aria-controls": "customized-menu",
                "aria-haspopup": "true",
                variant: "contained",
                color: "primary",
                onClick: handleClick,
                className: classes.button,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {}),
                    context.translate('create')
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                id: "customized-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenDialog('create-assessment'),
                        children: context.translate('create-assessment')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenDialog('create-directory'),
                        children: context.translate('create-directory')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {
                context: context
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directoryFormDefault.default), {
                context: context
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/icons-material/Add":"jrNj7","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/icons-material/MoveToInbox":"6sE4q","@mui/icons-material/Drafts":"bKS9q","@mui/icons-material/Send":"hhRwm","./form":"2aP1U","./directory-form":"joz9O","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6sE4q":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("4343e6af7f53429d");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("41c7312aaab71549"));
var _jsxRuntime = require("de629b664780f673");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19zm-3-5h-2V7h-4v3H8l4 4z"
}), 'MoveToInbox');

},{"4343e6af7f53429d":"kZ6eK","41c7312aaab71549":"2vOnF","de629b664780f673":"1dlk8"}],"bKS9q":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("47785538a5deef02");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("95144a0a339deb87"));
var _jsxRuntime = require("82db659341b569e3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zM12 13 3.74 7.84 12 3l8.26 4.84z"
}), 'Drafts');

},{"47785538a5deef02":"kZ6eK","95144a0a339deb87":"2vOnF","82db659341b569e3":"1dlk8"}],"hhRwm":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("ec6086dd160406df");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("3e8e3a66ce672e4a"));
var _jsxRuntime = require("5c90cd5a21a11bab");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"
}), 'Send');

},{"ec6086dd160406df":"kZ6eK","3e8e3a66ce672e4a":"2vOnF","5c90cd5a21a11bab":"1dlk8"}],"2aP1U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateAssessmentForm);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _material = require("external/material");
var _formHook = require("helpers/form-hook");
var _formHookDefault = parcelHelpers.interopDefault(_formHook);
var _validationsHook = require("helpers/validations-hook");
var _validationsHookDefault = parcelHelpers.interopDefault(_validationsHook);
var _command = require("helpers/command");
var _responsiveFullscreenDialog = require("components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _textInput = require("./TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _selectDirectory = require("../../components/SelectDirectory");
var _selectDirectoryDefault = parcelHelpers.interopDefault(_selectDirectory);
var _validations = require("./validations");
var _validationsDefault = parcelHelpers.interopDefault(_validations);
var _mainTopics = require("./generator/MainTopics");
var _mainTopicsDefault = parcelHelpers.interopDefault(_mainTopics);
const initialState = {
    attempted: false,
    type: '',
    title: '',
    subject: '',
    course: '',
    directory: '',
    unit: '',
    useGenerator: false,
    topics: []
};
const inDevelopment = false;
const useStyles = (0, _material.makeStyles)(createStyles);
function CreateAssessmentForm({ context, useCart }) {
    const history = (0, _reactRouterDom.useHistory)();
    const isTesting = context.profile.domain == 'testing-gen' || inDevelopment;
    const { translate, quizDialogs, myCourses } = context;
    const isOpen = quizDialogs['create-assessment'];
    const classes = useStyles();
    const { state, setState, handleChange, resetState } = (0, _formHookDefault.default)(initialState);
    const { errors, errorCount, validate, resetErrors } = (0, _validationsHookDefault.default)((0, _validationsDefault.default));
    const createStateHandler = (mapState)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            setState({
                ...state,
                ...mapState(value)
            });
        };
    const courses = state.subject ? myCourses.filter(({ course })=>course.substring(0, 2) == state.subject) : myCourses;
    function closeDialog() {
        const quizDialogs = (0, _immutabilityHelperDefault.default)(context.quizDialogs, {
            'create-assessment': {
                $set: false
            }
        });
        context.setState({
            quizDialogs
        });
        resetState();
        resetErrors();
    }
    async function createAssessment() {
        if (validate({
            ...state,
            attempted: true
        })) {
            const cart = useCart ? context.quizQuestionBankCart.map((q)=>q.id) : undefined;
            const topics = state.useGenerator ? state.topics : undefined;
            const assessment = (0, _lodash.pick)(state, [
                'title',
                'type',
                'subject',
                'course',
                'unit',
                'directory'
            ]);
            if (state.directory == '') assessment.directory = undefined;
            try {
                const [created] = await (0, _command.createPost)('quiz', topics ? 'generateAssessmentWithTopics' : 'createAssessment')({
                    ...assessment,
                    cart,
                    topics
                });
                if (created) {
                    context.setState({
                        quizAssessmentCalls: context.quizAssessmentCalls + 1
                    });
                    history.push(context.link({
                        assessment: created.id,
                        sectionId: created.firstSection
                    }, '/:languageId/:role/:page/:assessment/edit/:sectionId'));
                } else setState({
                    ...state,
                    attempted: true
                });
            } catch (e) {}
            closeDialog();
        } else setState({
            ...state,
            attempted: true
        });
    }
    (0, _reactDefault.default).useEffect(()=>{
        validate(state);
    }, [
        state
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (state.directory != context.quizSelectedDirectory) setState({
            ...state,
            directory: context.quizSelectedDirectory
        });
    }, [
        context.quizSelectedDirectory
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (state.useGenerator) setState({
            ...state,
            topics: Object.entries(context.quizGenerator.selectedTopics).map(([topic, { questionCount }])=>({
                    topic,
                    questionCount
                }))
        });
        else setState({
            ...state,
            topics: []
        });
    }, [
        state.useGenerator,
        context.quizGenerator.selectedTopics
    ]);
    const topicError = (0, _react.useMemo)(()=>{
        return errors.topics == '' ? undefined : true;
    }, [
        errors.topics
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: closeDialog,
        actionsClassName: classes.actions,
        confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            className: (0, _clsxDefault.default)(classes.button, "create"),
            onClick: createAssessment,
            children: translate('create')
        }),
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            className: (0, _clsxDefault.default)(classes.button, "cancel"),
            onClick: closeDialog,
            children: translate('cancel')
        }),
        title: translate('create-assessment-dialog-title'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "title"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        controlMargin: "dense",
                        id: "title",
                        inputAutoComplete: "title",
                        labelRequired: true,
                        inputAutoFocus: true,
                        caption: translate('title'),
                        value: state.title,
                        inputOnChange: handleChange('title'),
                        controlError: errors.title.length > 0,
                        errorMessage: errors.title.length > 0 ? translate(errors.title) : undefined
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "type"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        controlMargin: "dense",
                        id: "type",
                        labelRequired: true,
                        caption: translate('type_label'),
                        selectValue: state.type,
                        selectOnChange: handleChange('type', (e)=>parseInt(e.target.value)),
                        controlError: errors.type.length > 0,
                        errorMessage: errors.type.length > 0 ? translate(errors.type) : undefined,
                        mapValue: (o)=>o.id,
                        mapText: (o)=>translate(`${o.name}-label`),
                        options: context.quizTypes
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "subject"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        controlMargin: "dense",
                        selectValue: state.subject,
                        selectOnChange: createStateHandler((subject)=>{
                            return {
                                subject,
                                subject_touched: true,
                                course: '',
                                course_touched: false
                            };
                        }),
                        caption: translate('subject_label'),
                        controlError: errors.subject.length > 0,
                        errorMessage: errors.subject.length > 0 ? translate(errors.subject) : undefined,
                        mapValue: (o)=>o.id,
                        mapText: (o)=>o.name,
                        options: context.mySubjects
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "course"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        controlMargin: "dense",
                        selectValue: state.course,
                        selectOnChange: createStateHandler((course)=>{
                            return {
                                course,
                                course_touched: true,
                                subject: course.substring(0, 2),
                                subject_touched: true
                            };
                        }),
                        caption: translate('course_assessment_header'),
                        controlError: errors.course.length > 0,
                        errorMessage: errors.course.length > 0 ? translate(errors.course) : undefined,
                        mapValue: (o)=>o.course,
                        mapText: (o)=>o.courseName,
                        options: courses
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "unit"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        controlMargin: "dense",
                        id: "unit",
                        inputAutoComplete: "unit",
                        caption: translate('unit'),
                        value: state.unit,
                        inputOnChange: handleChange('unit')
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "directory"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDirectoryDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        id: "directory",
                        caption: translate('directory'),
                        selectValue: state.directory || '',
                        selectOnChange: handleChange('directory'),
                        context: context
                    })
                }),
                isTesting && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "generator-question"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                        error: topicError,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                                shrink: false,
                                disableAnimation: true,
                                htmlFor: "use-generator-checkbox",
                                children: translate("quiz-generate-by-topics-label")
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                disableRipple: true,
                                "aria-describedby": "topic-error-text",
                                id: "use-generator-checkbox",
                                onChange: handleChange('useGenerator', ()=>!state.useGenerator),
                                checked: state.useGenerator
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                                error: topicError,
                                id: "topic-error-text",
                                children: translate(errors.topics)
                            })
                        ]
                    })
                }),
                state.useGenerator && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.field, "generator"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mainTopicsDefault.default), {})
                })
            ]
        })
    });
}
function createStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            display: 'flex',
            flexDirection: 'column'
        },
        field: {
            flexGrow: 1,
            display: 'flex',
            marginBottom: 25,
            minWidth: 500,
            "& > div": {
                display: 'flex',
                flexGrow: 1,
                "& .label": {
                    width: 90,
                    fontSize: '12pt',
                    fontWeight: 'bold',
                    color: '#878ea1',
                    ...verticalCentering
                },
                "& .input": {
                    flexGrow: 1,
                    ...verticalCentering,
                    "& input": {
                        borderRadius: 4,
                        border: 'solid 1px #aab7bf !important'
                    },
                    "& .select": {
                        "& .MuiInput-underline:before": {
                            content: 'none',
                            border: 'none'
                        },
                        "& .MuiSelect-select": {
                            border: 'solid 1px #aab7bf',
                            borderRadius: 4,
                            padding: 10,
                            paddingRight: 24
                        }
                    }
                }
            }
        },
        button: {
            width: 120,
            fontSize: "13pt",
            textTransform: "none",
            boxShadow: 'none',
            borderRadius: 4,
            "&:first-child": {
                marginRight: 10
            },
            "&:last-child": {
                marginLeft: 10
            },
            "&.cancel": {
                border: "solid 1px #3d4556",
                backgroundColor: '#fff',
                color: "#3d4556",
                '&:hover': {
                    color: "#000",
                    border: "solid 1px #000",
                    backgroundColor: '#eaf5ff'
                }
            },
            "&.create": {
                color: "#fff",
                border: 'solid 1px #1d9be5',
                backgroundColor: '#1d9be5',
                color: '#fff',
                '&:hover': {
                    backgroundColor: '#29739f',
                    borderColor: '#29739f',
                    boxShadow: 'none'
                }
            }
        },
        actions: {
            padding: '8px 24px 30px 24px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/material/Checkbox":"4sdMA","@mui/material/InputLabel":"iTW3B","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","external/material":"6yEDE","helpers/form-hook":"8O4Ar","helpers/validations-hook":"r624y","helpers/command":"f3cbG","components/responsive-fullscreen-dialog":"9pRHY","./TextInput":"ugcEQ","./Select":"dO7mi","../../components/SelectDirectory":"aHtgV","./validations":"l7ksr","./generator/MainTopics":"2jxIm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8O4Ar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useForm);
parcelHelpers.export(exports, "useImmutableForm", ()=>useImmutableForm);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _deepDiff = require("deep-diff");
var _deepDiffDefault = parcelHelpers.interopDefault(_deepDiff);
function useForm(initialState) {
    const touchedState = (0, _lodash.mapKeys)((0, _lodash.mapValues)(initialState, ()=>false), (name, key)=>`${key}_touched`);
    const [state, setState] = (0, _reactDefault.default).useState({
        ...initialState,
        ...touchedState
    });
    function handleChange(name, value = (e)=>e.target.value) {
        return (event)=>{
            const newState = {
                ...state,
                [name]: value(event),
                [`${name}_touched`]: true
            };
            setState(newState);
        };
    }
    function resetState() {
        setState({
            ...initialState,
            ...touchedState
        });
    }
    return {
        state,
        setState,
        handleChange,
        resetState
    };
}
function useImmutableForm(initialState) {
    const touchedState = (0, _lodash.mapKeys)((0, _lodash.mapValues)(initialState, ()=>false), (name, key)=>`${key}_touched`);
    const [state, setState] = (0, _reactDefault.default).useState({
        ...initialState,
        ...touchedState
    });
    function handleChange(name, value = (e)=>e.target.value) {
        return (event)=>{
            const newState = {
                ...state,
                [name]: value(event),
                [`${name}_touched`]: true
            };
            setState(newState);
        };
    }
    function resetState(overrideState = {}) {
        setState({
            ...initialState,
            ...touchedState,
            ...overrideState
        });
    }
    function createHandler(mapper) {
        return (event)=>{
            const newState = Object.entries(mapper(event)).reduce((newState, [name, value])=>{
                newState[name] = value;
                newState[`${name}_touched`] = true;
                return newState;
            }, {});
            setState({
                ...state,
                ...newState
            });
        };
    }
    function updateState(...commands) {
        const newState = commands.reduce((state, command)=>(0, _immutabilityHelperDefault.default)(state, command), state);
        setState(newState);
    }
    function hasStateChanged() {
        return (0, _deepDiffDefault.default)(state, initialState).length > 0;
    }
    return {
        state,
        setState,
        handleChange,
        resetState,
        createHandler,
        updateState,
        hasStateChanged
    };
}

},{"lodash":"1qc47","react":"9njXz","immutability-helper":"hwjCt","deep-diff":"3ceMf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"r624y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useValidations);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodash = require("lodash");
function useValidations(validations) {
    const [errors, setErrors] = (0, _reactDefault.default).useState((0, _lodash.mapValues)(validations, ()=>''));
    const errorCount = Object.values(errors).filter((e)=>e.length > 0).length;
    function validate(state) {
        let valid = true;
        const validationResults = (0, _lodash.mapValues)(validations, (checks)=>{
            const error = checks.map((validation)=>validation(state)).find((result)=>result.length > 0);
            valid = valid && error == undefined;
            return error || '';
        });
        setErrors({
            ...validationResults
        });
        return valid;
    }
    function resetErrors() {
        setErrors({
            ...(0, _lodash.mapValues)(validations, ()=>'')
        });
    }
    return {
        errors,
        errorCount,
        validate,
        resetErrors
    };
}

},{"react":"9njXz","lodash":"1qc47","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9pRHY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResponsiveDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _utils = require("helpers/utils");
function ResponsiveDialog(props) {
    const { open, close, confirm, cancel, TitleComponent } = props;
    const theme = (0, _material.useTheme)();
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const dialogProps = (0, _utils.pickAttributes)(props, 'dialog');
    const titleProps = (0, _utils.pickAttributes)(props, 'head');
    const contentProps = (0, _utils.pickAttributes)(props, 'content');
    const actionsProps = (0, _utils.pickAttributes)(props, 'actions');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        fullScreen: fullScreen,
        open: open,
        onClose: (e)=>close(e),
        "aria-labelledby": "responsive-dialog-title",
        ...dialogProps,
        className: props.className,
        children: [
            props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                id: "responsive-dialog-title",
                ...titleProps,
                children: props.title
            }),
            props.subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                sx: {
                    fontSize: '14px',
                    fontWeight: 400,
                    color: '#6B7280'
                },
                id: "responsive-dialog-title",
                ...titleProps,
                children: props.subtitle
            }),
            TitleComponent && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                id: "responsive-dialog-title",
                ...titleProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleComponent, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                ...contentProps,
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                ...actionsProps,
                children: [
                    cancel && cancel,
                    confirm && confirm
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ugcEQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextInput);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(textStyles);
function TextInput(props) {
    const classes = useStyles();
    const errorId = `${props.id}-error-text`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                    ...(0, _utils.pickAttributes)(props, 'control'),
                    className: classes.control,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                            id: props.id,
                            "aria-describedby": errorId,
                            value: props.value,
                            ...(0, _utils.pickAttributes)(props, 'input'),
                            className: classes.input
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                            id: errorId,
                            ...(0, _utils.pickAttributes)(props, 'error'),
                            children: props.errorMessage
                        })
                    ]
                })
            })
        ]
    });
}
function textStyles(theme) {
    return {
        root: {},
        control: {
            margin: 0,
            flexGrow: 1
        },
        input: {
            "& input": {
                padding: 10
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/OutlinedInput":"8eUp2","@mui/material/InputLabel":"iTW3B","@mui/material/Box":"73kto","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dO7mi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(selectStyles);
function Select(props) {
    const classes = useStyles();
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    const errorId = `${props.id}-error-text`;
    const labelId = `${props.id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                    ...controlAttributes,
                    className: classes.control,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                            labelId: labelId,
                            id: props.id,
                            ...selectAttributes,
                            className: (0, _clsxDefault.default)(classes.select, "select"),
                            children: props.options.map((option, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                    value: props.mapValue(option),
                                    children: props.mapText(option)
                                }, key))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                            id: errorId,
                            ...(0, _utils.pickAttributes)(props, 'error'),
                            children: props.errorMessage
                        })
                    ]
                })
            })
        ]
    });
}
function selectStyles(theme) {
    return {
        root: {},
        control: {
            margin: 0,
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Select":"aY7hn","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","@mui/material/MenuItem":"a18vm","@mui/material/Box":"73kto","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aHtgV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(selectStyles);
function Select(props) {
    const classes = useStyles();
    const { context } = props;
    const { translate, quizDirectories } = context;
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    const labelId = `${props.id}-label`;
    const options = [
        {
            id: '',
            name: translate('none')
        }
    ].concat((0, _lodash.orderBy)(Object.values(quizDirectories), [
        'name',
        'id'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
                    ...controlAttributes,
                    className: classes.control,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        labelId: labelId,
                        id: props.id,
                        ...selectAttributes,
                        className: (0, _clsxDefault.default)(classes.select, "select"),
                        children: options.map((option, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: option.id,
                                children: option.name
                            }, key))
                    })
                })
            })
        ]
    });
}
function selectStyles(theme) {
    return {
        root: {
            '& .MuiInput-underline:before': {
                content: 'none',
                border: 'none'
            },
            '& .MuiSelect-select': {
                border: 'solid 1px #aab7bf',
                borderRadius: 4,
                padding: 5,
                paddingRight: 24
            }
        },
        control: {
            margin: 0,
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Select":"aY7hn","@mui/material/FormControl":"kkska","@mui/material/MenuItem":"a18vm","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l7ksr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validations = require("../../../../helpers/validations");
const validations = {
    title: [
        (0, _validations.requiredTextAfterAttempt)('title', 'required-title')
    ],
    type: [
        ({ attempted, type })=>{
            return !attempted || type != '' ? '' : 'required-type';
        }
    ],
    subject: [
        (0, _validations.requiredTextAfterAttempt)('subject', 'required-subject')
    ],
    course: [
        (0, _validations.requiredTextAfterAttempt)('course', 'required-course')
    ],
    topics: [
        ({ attempted, useGenerator, topics })=>{
            return !attempted || !useGenerator || topics.length > 0 ? '' : 'required-topics';
        }
    ]
};
exports.default = validations;

},{"../../../../helpers/validations":"lg1Ji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lg1Ji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requiredTextAfterAttempt", ()=>requiredTextAfterAttempt);
function requiredTextAfterAttempt(name, failedLabel, successLabel = '', attemptProperty = 'attempted') {
    return (state)=>{
        const attempted = state[attemptProperty];
        if (!attempted) return successLabel;
        const value = state[name];
        return value && value.length > 0 ? successLabel : failedLabel;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jxIm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MainTopics);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("teacher/context");
var _material = require("external/material");
const StyledMainTopics = (0, _material.styled)('ul')(maintopicStyles);
function MainTopics() {
    const { updateState: update, quizTopics, quizGenerator: { selectedTopics, questionCount } } = (0, _react.useContext)((0, _context.TeacherContext));
    function updateQuestionCount(count) {
        if (count != questionCount) update({
            quizGenerator: {
                questionCount: {
                    $set: count
                }
            }
        });
    }
    const topics = (0, _react.useMemo)(()=>{
        return quizTopics.map((topic)=>{
            const selectedTopic = selectedTopics[topic.name];
            const selected = !!selectedTopic;
            const questionCount = selected ? selectedTopic.questionCount : undefined;
            return {
                ...topic,
                selected,
                questionCount
            };
        });
    }, [
        quizTopics,
        selectedTopics
    ]);
    const minQuestionCount = (0, _react.useMemo)(()=>topics.reduce((count, { selected })=>count + (selected ? 1 : 0), 0), [
        topics
    ]);
    const maxQuestionCount = (0, _react.useMemo)(()=>topics.reduce((count, { selected, questions })=>count + (selected ? questions : 0), 0), [
        topics
    ]);
    function handleMainTopicChange(id, questionCount, toggle) {
        const selectedTopic = selectedTopics[id];
        const selected = !!selectedTopic;
        if (toggle) {
            if (selected) update({
                quizGenerator: {
                    questionCount: {
                        $apply: (oldCount)=>oldCount - selectedTopic.questionCount + questionCount
                    },
                    selectedTopics: {
                        $unset: [
                            id
                        ]
                    }
                }
            });
            else update({
                quizGenerator: {
                    questionCount: {
                        $apply: (oldCount)=>oldCount + questionCount
                    },
                    selectedTopics: {
                        [id]: {
                            $set: {
                                questionCount
                            }
                        }
                    }
                }
            });
        } else if (selected) update({
            quizGenerator: {
                questionCount: {
                    $apply: (oldCount)=>oldCount - selectedTopic.questionCount + questionCount
                },
                selectedTopics: {
                    [id]: {
                        $set: {
                            questionCount
                        }
                    }
                }
            }
        });
    }
    (0, _react.useEffect)(()=>{
        if (questionCount < minQuestionCount) updateQuestionCount(minQuestionCount);
        else if (questionCount > maxQuestionCount) updateQuestionCount(maxQuestionCount);
    }, [
        questionCount,
        minQuestionCount,
        maxQuestionCount
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMainTopics, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberInput, {
                min: minQuestionCount,
                max: maxQuestionCount,
                value: questionCount,
                onChange: updateQuestionCount
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: maxQuestionCount
            }),
            topics.map((topic)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MainTopic, {
                    topic: topic,
                    onChange: handleMainTopicChange
                }, topic.name))
        ]
    });
}
function NumberInput(props) {
    const { min, max, onChange, value } = props;
    const range = (0, _react.useMemo)(()=>max - min, [
        min,
        max
    ]);
    const readonly = (0, _react.useMemo)(()=>range == 0, [
        range
    ]);
    function handleKeyDown(e) {
        if (/\d/.test(e.key)) return;
        const allowedKeys = [
            "Backspace",
            "Enter",
            "Tab"
        ];
        if (allowedKeys.indexOf(e.key) >= 0) return;
        e.preventDefault();
    }
    function handleChange(e) {
        const value = parseInt(e.target.value);
        if (isNaN(value)) onChange(min);
        else if (value < min) onChange(min);
        else if (value > max) onChange(max);
        else onChange(value);
    }
    function handleFocus(e) {
        e.currentTarget.select();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
        type: "text",
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onChange: handleChange,
        value: value,
        readOnly: readonly ? 'readonly' : undefined
    });
}
function MainTopic({ topic, onChange }) {
    const { name, selected, questions, questionCount } = topic;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                label: name,
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                    onChange: ()=>onChange(name, selected ? 0 : 1, true),
                    checked: selected
                })
            }),
            selected && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(NumberInput, {
                        type: "text",
                        min: 1,
                        max: questions,
                        value: questionCount,
                        onChange: (count)=>onChange(name, count)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: questions
                    })
                ]
            })
        ]
    });
}
function maintopicStyles() {
    return {};
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","teacher/context":"5LKDx","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"joz9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateDirectoryForm);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _material = require("external/material");
var _formHook = require("../../../../helpers/form-hook");
var _formHookDefault = parcelHelpers.interopDefault(_formHook);
var _validationsHook = require("../../../../helpers/validations-hook");
var _validationsHookDefault = parcelHelpers.interopDefault(_validationsHook);
var _command = require("../../../../helpers/command");
var _validations = require("../../../../helpers/validations");
var _responsiveFullscreenDialog = require("../../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _textInput = require("../../../text-input");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _select = require("../../../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const validations = {
    name: [
        (0, _validations.requiredTextAfterAttempt)('name', 'required-name')
    ]
};
const initialState = {
    attempted: false,
    name: ''
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            paddingTop: 20
        }
    }));
function CreateDirectoryForm({ context }) {
    const { translate, quizDialogs } = context;
    const isOpen = quizDialogs['create-directory'];
    const classes = useStyles();
    const { state, setState, handleChange, resetState } = (0, _formHookDefault.default)(initialState);
    const { errors, errorCount, validate, resetErrors } = (0, _validationsHookDefault.default)(validations);
    const createStateHandler = (mapState)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            setState({
                ...state,
                ...mapState(value)
            });
        };
    function closeDialog() {
        const quizDialogs = (0, _immutabilityHelperDefault.default)(context.quizDialogs, {
            'create-directory': {
                $set: false
            }
        });
        context.setState({
            quizDialogs
        });
        resetState();
        resetErrors();
    }
    async function createDirectory() {
        if (validate({
            ...state,
            attempted: true
        })) {
            const directory = (0, _lodash.pick)(state, [
                'name'
            ]);
            try {
                const [created] = await (0, _command.createPost)('quiz', 'createDirectory')(directory);
                if (created) {
                    const quizDirectories = (0, _immutabilityHelperDefault.default)(context.quizDirectories, {
                        [created.id]: {
                            $set: created
                        }
                    });
                    context.setState({
                        quizDirectories,
                        quizAssessmentCalls: context.quizAssessmentCalls + 1
                    });
                } else setState({
                    ...state,
                    attempted: true
                });
            } catch (e) {}
            closeDialog();
        } else setState({
            ...state,
            attempted: true
        });
    }
    (0, _reactDefault.default).useEffect(()=>{
        validate(state);
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: closeDialog,
        confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            color: "primary",
            onClick: createDirectory,
            children: translate('create')
        }),
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            color: "secondary",
            onClick: closeDialog,
            children: translate('cancel')
        }),
        title: translate('create-directory-dialog-title'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: classes.root,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                controlFullWidth: true,
                controlVariant: "outlined",
                id: "name",
                inputAutoComplete: "name",
                labelRequired: true,
                inputAutoFocus: true,
                caption: translate('name'),
                value: state.title,
                inputOnChange: handleChange('name'),
                controlError: errors.name.length > 0,
                errorMessage: errors.name.length > 0 ? translate(errors.name) : undefined
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","lodash":"1qc47","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","external/material":"6yEDE","../../../../helpers/form-hook":"8O4Ar","../../../../helpers/validations-hook":"r624y","../../../../helpers/command":"f3cbG","../../../../helpers/validations":"lg1Ji","../../../responsive-fullscreen-dialog":"9pRHY","../../../text-input":"gF58h","../../../select":"k4sBU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gF58h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _utils = require("../helpers/utils");
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
function TextInput(props) {
    const errorId = `${props.id}-error-text`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        ...(0, _utils.pickAttributes)(props, 'control'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                id: props.id,
                "aria-describedby": errorId,
                value: props.value,
                ...(0, _utils.pickAttributes)(props, 'input'),
                label: props.caption
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                id: errorId,
                ...(0, _utils.pickAttributes)(props, 'error'),
                children: props.errorMessage
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/OutlinedInput":"8eUp2","@mui/material/InputLabel":"iTW3B","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","../helpers/utils":"gGc98","@mui/material/TextField":"amnzu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6kXOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _activeFiltersCjs = require("components/standards-selector/domain/active-filters.cjs");
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _lodash = require("external/lodash");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _searchPattern = require("../components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _quiz = require("helpers/quiz");
const useStyles = (0, _material.makeStyles)(filterStyles);
function AssessmentFilters({ context }) {
    const classes = useStyles();
    const { translate, navigate, myCourses, institutionCourses } = context;
    const createFilterHandler = (name, mapQuery)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            const query = mapQuery ? mapQuery(context.query, value) : {
                ...context.query,
                [name]: value
            };
            navigate(undefined, undefined, {
                query: {
                    ...query,
                    page: 1
                }
            });
        };
    const courses = context.query.subject ? myCourses.filter(({ course })=>course.substring(0, 2) == context.query.subject) : myCourses;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.filters,
                children: [
                    context.quizTypes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "quiz-type-filter",
                        className: (0, _clsxDefault.default)(classes.select, "type"),
                        value: context.query.type || "",
                        onChange: createFilterHandler('type'),
                        caption: translate('quiz-type'),
                        children: context.quizTypes.map((type, key)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: type.id,
                                children: translate(`${type.name}-label`)
                            }, key);
                        })
                    }),
                    context.mySubjects.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "quiz-subject-filter",
                        className: (0, _clsxDefault.default)(classes.select, "subject"),
                        value: context.query.subject || "",
                        onChange: createFilterHandler('subject', (query, subject)=>({
                                ...query,
                                course: undefined,
                                subject
                            })),
                        caption: translate('subject_label'),
                        children: context.mySubjects.map((subject, key)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: subject.id,
                                children: subject.name
                            }, key);
                        })
                    }),
                    courses.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "question-bank-course-filter",
                        className: (0, _clsxDefault.default)(classes.select, "course"),
                        value: context.query.course || "",
                        onChange: createFilterHandler('course', (query, course)=>{
                            return course ? {
                                ...query,
                                course,
                                subject: course.substring(0, 2)
                            } : {
                                ...query,
                                course: undefined
                            };
                        }),
                        caption: translate('course_assessment_header'),
                        children: (0, _lodash.orderBy)(courses, [
                            'course'
                        ]).map((course, key)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: course.course,
                                children: (0, _quiz.selectCourseLabel)(course)
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.pattern,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                            path: context.link(),
                            context: context
                        })
                    })
                ]
            }),
            !(0, _activeFiltersCjs.hasActiveStandardsFilter)(context.quizStandardFilters) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.standardsSearch,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: context.link({
                        sectionName: 'standards-search'
                    }, '/:languageId/:role/:page/:tab/:sectionName', {
                        preserveQuery: true
                    }),
                    className: classes.standardsSearchLink,
                    children: translate('standards-search')
                })
            })
        ]
    });
}
function filterStyles(theme) {
    return {
        root: {
            display: "flex",
            paddingTop: 10,
            flexGrow: 1,
            flexDirection: "column"
        },
        standardsSearch: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 5,
            marginBottom: 10
        },
        standardsSearchLink: {
            color: '#009dd8',
            fontSize: '9.5pt'
        },
        filters: {
            flexGrow: 1,
            display: "flex"
        },
        select: {
            marginLeft: 15,
            '&:first-child': {
                marginLeft: 0
            },
            '&:last-child': {
                marginRight: 15
            },
            '&.type': {
                flexGrow: 1,
                minWidth: 120
            },
            '&.subject': {
                flexGrow: 1,
                minWidth: 120
            },
            '&.course': {
                flexGrow: 1,
                minWidth: 120
            }
        },
        filler: {
            flexGrow: 1
        },
        pattern: {
            display: "flex",
            margin: "4px 15px",
            flexDirection: "column",
            justifyContent: "flex-end"
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/standards-selector/domain/active-filters.cjs":"9Ycmg","react-router-dom":"3uzXR","external/material":"6yEDE","external/lodash":"5bCAQ","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","components/clearable-select":"jWvEj","../components/search-pattern":"gUgIQ","helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Ycmg":[function(require,module,exports,__globalThis) {
function hasActiveStandardsFilter(filters = {}) {
    return [
        'indicators',
        'expectations',
        'standards'
    ].some((key)=>Array.isArray(filters[key]) && filters[key].length > 0);
}
module.exports = {
    hasActiveStandardsFilter
};

},{}],"gUgIQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchPattern);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _queryString = require("query-string");
var _queryStringDefault = parcelHelpers.interopDefault(_queryString);
var _reactRouterDom = require("react-router-dom");
var _search = require("@mui/icons-material/Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexWrap: 'nowrap',
            backgroundColor: '#fff',
            border: 'solid 1px #bec4d2',
            borderRadius: '5px',
            width: '100%'
        },
        input: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            "& > input": {
                flexGrow: 1,
                padding: '8px 0 7px 5px',
                fontSize: "12pt",
                color: "#747b95",
                border: 'none',
                '&:focus': {
                    outline: 'none'
                }
            }
        },
        icon: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '0px 6px',
            "& svg": {
                fontWeight: "bold",
                color: "#747b95"
            }
        },
        label: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '8px 10px',
            borderLeft: '1px solid #bec4d2',
            color: "#747b95",
            cursor: 'pointer',
            "&:hover": {
                backgroundColor: '#2ca5ec',
                color: '#fff'
            }
        }
    }));
function SearchPattern({ className, path, placeholder, context }) {
    const [pattern, setPattern] = (0, _react.useState)(context.query.pattern || '');
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    function searchPattern() {
        const query = {
            ...context.query,
            page: 1,
            pattern: pattern == '' ? undefined : pattern
        };
        if (path != history.location.pathname) context.setState({
            searchBackPath: history.location.pathname
        });
        history.push(context.link(undefined, undefined, {
            query
        }));
    }
    (0, _reactDefault.default).useEffect(()=>{
        setPattern(context.query.pattern || '');
    }, [
        context.query.pattern
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsxDefault.default)(className, classes.root),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
            container: true,
            wrap: "nowrap",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    item: true,
                    className: classes.icon,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchDefault.default), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    item: true,
                    className: classes.input,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        onChange: (e)=>setPattern(e.target.value),
                        value: pattern,
                        placeholder: placeholder,
                        onKeyPress: ({ key })=>key == 'Enter' && searchPattern()
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                    item: true,
                    className: classes.label,
                    onClick: searchPattern,
                    children: context.translate('go_label')
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","query-string":"h6dFx","react-router-dom":"3uzXR","@mui/icons-material/Search":"lRGNy","@mui/material/TextField":"amnzu","@mui/material/Grid":"ggUwv","@mui/material/InputAdornment":"jiJDh","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRGNy":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("fba53bc247860689");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("896a02316301fc50"));
var _jsxRuntime = require("b874acb5710c0313");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');

},{"fba53bc247860689":"kZ6eK","896a02316301fc50":"2vOnF","b874acb5710c0313":"1dlk8"}],"2fwur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentsHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
const headCells = [
    {
        id: 'title',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'subject',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'courseName',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'type',
        align: 'left',
        disablePadding: false
    }
];
const useStyles = (0, _material.makeStyles)((theme)=>({
        headersRow: {
            color: '#50566e',
            '& > th': {
                borderTop: 'solid 1px #becfd7',
                backgroundColor: '#ffffff'
            }
        },
        headerLabel: {
            color: '#4f576e',
            fontWeight: 500
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));
function AssessmentsHead({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { query, translate, navigate } = context;
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderBy = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    const createSortHandler = (property)=>(event)=>{
            navigate(undefined, undefined, {
                query: {
                    ...query,
                    orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`
                }
            });
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
            className: classes.headersRow,
            children: [
                headCells.map(({ id, align, disablePadding })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: align,
                        padding: disablePadding ? 'none' : 'normal',
                        sortDirection: order,
                        style: {
                            top: 92
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableSortLabelDefault.default), {
                            className: classes.headerLabel,
                            active: orderBy === id,
                            direction: order,
                            onClick: createSortHandler(id),
                            children: [
                                translate(`${id}-header`),
                                orderBy === id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: classes.visuallyHidden,
                                    children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                                }) : null
                            ]
                        })
                    }, id)),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.actions,
                    style: {
                        top: 92
                    },
                    align: "right"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/TableSortLabel":"3xCAT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3hz76":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentsBody);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _icons = require("resources/icons");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _assessmentRowSettings = require("./assessment-row-settings");
var _assessmentRowSettingsDefault = parcelHelpers.interopDefault(_assessmentRowSettings);
var _directoryRowSettings = require("./directory-row-settings");
var _directoryRowSettingsDefault = parcelHelpers.interopDefault(_directoryRowSettings);
var _share = require("@mui/icons-material/Share");
var _shareDefault = parcelHelpers.interopDefault(_share);
var _duplicateAssessment = require("./duplicate-assessment");
var _duplicateAssessmentDefault = parcelHelpers.interopDefault(_duplicateAssessment);
var _createAssignment = require("./create-assignment");
var _createAssignmentDefault = parcelHelpers.interopDefault(_createAssignment);
var _editableLabel = require("../../editable-label");
var _editableLabelDefault = parcelHelpers.interopDefault(_editableLabel);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
const useStyles = (0, _material.makeStyles)(bodyStyles);
function AssessmentsBody({ context }) {
    const classes = useStyles();
    const { quizAssessments } = context;
    const directories = quizAssessments.reduce((acc, assessment)=>{
        if (assessment.type) {
            acc[assessment.directory] = acc[assessment.directory] || [];
            acc[assessment.directory].push(assessment);
        }
        return acc;
    }, {});
    const directoryCount = quizAssessments.reduce((count, { type })=>count + (type == undefined ? 1 : 0), 0);
    function handleDuplicate(result) {
        context.setState({
            quizAssessmentCalls: context.quizAssessmentCalls + 1
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableBodyDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _duplicateAssessmentDefault.default), {
                context: context,
                onDuplicate: handleDuplicate
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createAssignmentDefault.default), {
                context: context
            }),
            quizAssessments.map((assessment)=>{
                return assessment.type ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(Assessment, {
                    assessment,
                    classes,
                    context,
                    directoryCount
                }, assessment.id) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(Directory, {
                    assessments: directories[assessment.id] || [],
                    directoryId: assessment.id,
                    classes,
                    context
                }, assessment.id);
            })
        ]
    });
}
function Directory({ directoryId, context, classes, assessments }) {
    const { translate, quizSelectedDirectory } = context;
    const directory = context.quizDirectories[directoryId] || {};
    const sharedCount = assessments.reduce((acc, { shared })=>acc + (shared ? 1 : 0), 0);
    const shared = assessments.length > 0 && sharedCount > 0 && sharedCount == assessments.length;
    const [editingName, setEditingName] = (0, _reactDefault.default).useState(false);
    const opened = assessments.length > 0 && directory.opened;
    const selected = directoryId == quizSelectedDirectory;
    function onEditNameClick() {
        setEditingName(true);
    }
    function closeEditName() {
        setEditingName(false);
    }
    async function handleRename(newName) {
        closeEditName();
        if (directory.title != newName && newName.length > 0) {
            const [updatedId] = await (0, _commandDefault.default)('quiz', 'renameDirectory')({
                id: directory.id,
                newName
            });
            if (updatedId == directory.id) {
                const quizDirectories = (0, _immutabilityHelperDefault.default)(context.quizDirectories, {
                    [updatedId]: {
                        name: {
                            $set: newName
                        }
                    }
                });
                context.setState({
                    quizDirectories
                });
            }
        }
    }
    function toggleDirectory(e) {
        const command = selected ? {
            quizDirectories: {
                [directoryId]: {
                    opened: {
                        $apply: (o)=>!o
                    }
                }
            }
        } : {
            quizSelectedDirectory: {
                $set: directoryId
            }
        };
        context.updateState(command);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
        className: (0, _clsxDefault.default)(classes.directoryRow),
        onClick: toggleDirectory,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
            colSpan: 5,
            className: (0, _clsxDefault.default)(classes.directoryCell, classes.directoryName, {
                selected
            }),
            align: "left",
            scope: "row",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: classes.directoryNameContainer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: (0, _clsxDefault.default)(classes.folderIcon, {
                            foldable: assessments.length > 0
                        }),
                        children: [
                            opened && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faFolderOpen)
                            }),
                            !opened && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faFolder)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.directoryNameText,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableLabelDefault.default), {
                            editing: editingName,
                            label: directory.name,
                            onCancel: closeEditName,
                            onConfirm: handleRename
                        })
                    }),
                    sharedCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: classes.sharedLink,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _clsxDefault.default)(classes.sharedIcon, {
                                    shared: true
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: (0, _clsxDefault.default)(classes.sharedText, {
                                    selected
                                }),
                                children: sharedCount > 0 ? `${sharedCount}/${assessments.length}` : '-'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.directorySettingsLink,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _directoryRowSettingsDefault.default), {
                            context,
                            directory,
                            classes,
                            assessments,
                            shared,
                            onEditNameClick,
                            selected
                        })
                    })
                ]
            })
        })
    });
}
function Assessment({ assessment, context, classes, directoryCount }) {
    const { translate, link, navigate } = context;
    const directory = context.quizDirectories[assessment.directory] || {
        opened: true
    };
    function subjectName(subject) {
        const { name = "" } = context.mySubjects.find(({ id })=>id == subject) || {};
        return name;
    }
    function courseName(id) {
        const { courseName = "" } = context.institutionCourses.find(({ course })=>course == id) || {};
        return courseName;
    }
    function typeName(type) {
        const { name = "" } = context.quizTypes.find(({ id })=>id == type) || {};
        return name;
    }
    function handleOpenDuplicate(quizAssessmentToDuplicate) {
        const quizDialogs = (0, _immutabilityHelperDefault.default)(context.quizDialogs, {
            'duplicate-assessment': {
                $set: true
            }
        });
        context.setState({
            quizDialogs,
            quizAssessmentToDuplicate
        });
    }
    const { validated } = assessment.properties;
    function handleOpenAssign(quizAssessmentToAssign) {
        if (validated) context.setState({
            quizAssessmentToAssign
        });
    }
    function assessmentLink(assessment, action, sectionId) {
        return sectionId ? link({
            assessment,
            action,
            sectionId
        }, '/:languageId/:role/:page/:assessment/:action/:sectionId') : link({
            assessment,
            action
        }, '/:languageId/:role/:page/:assessment/:action');
    }
    function handleEditClick() {
        context.setState({
            quizEditFrom: '/:languageId/:role/:page/assessments',
            quizEditFromQuery: {
                ...context.query
            }
        });
    }
    function handlePreviewClick() {
        context.setState({
            quizPreviewFrom: '/:languageId/:role/:page/assessments',
            quizPreviewFromQuery: {
                ...context.query
            }
        });
    }
    const standardsLink = (assessment)=>link({
            assessment,
            sectionName: 'standards'
        }, '/:languageId/:role/:page/:tab/:assessment/:sectionName', {
            preserveQuery: true
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
        className: (0, _clsxDefault.default)(classes.assessmentRow, {
            hidden: !directory.opened
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.title, {
                    inside: directoryCount > 0 && assessment.directory != undefined
                }),
                align: "left",
                scope: "row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: classes.titleContainer,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.assessmentIcon,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                                fill: validated ? '#3295ce' : '#ff3a3a'
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: (0, _clsxDefault.default)(classes.titleText, {
                                validated
                            }),
                            children: assessment.title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.subject),
                align: "left",
                scope: "row",
                children: subjectName(assessment.subject)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.course),
                align: "left",
                scope: "row",
                children: courseName(assessment.course)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.type),
                align: "left",
                scope: "row",
                children: translate(`${typeName(assessment.type)}-label`)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.actions),
                align: "right",
                scope: "row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: classes.links,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('create-assignment-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: ()=>handleOpenAssign(assessment),
                                className: (0, _clsxDefault.default)(classes.link, classes.scheduleLink, {
                                    validated
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('edit-assessment-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                onClick: handleEditClick,
                                to: assessmentLink(assessment.id, 'edit', assessment.firstSection),
                                className: (0, _clsxDefault.default)(classes.link, classes.editLink),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faEdit)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('standards-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: standardsLink(assessment.id),
                                className: classes.link,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faInfoCircle)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('preview-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                onClick: handlePreviewClick,
                                to: assessmentLink(assessment.id, 'preview', assessment.firstSection),
                                className: (0, _clsxDefault.default)(classes.link, classes.previewLink),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PreviewIcon), {})
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('duplicated-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: ()=>handleOpenDuplicate(assessment),
                                className: (0, _clsxDefault.default)(classes.link, classes.duplicateLink),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faClone)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: classes.sharedLink,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: (0, _clsxDefault.default)(classes.sharedIcon, {
                                        shared: assessment.shared
                                    }),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: classes.sharedText,
                                    children: assessment.shared ? translate('shared') : '-'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: classes.settingsLink,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentRowSettingsDefault.default), {
                                context,
                                assessment,
                                classes
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function bodyStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        assessmentRow: {
            '&:hover': {
                backgroundColor: '#def2ff'
            },
            '&.hidden': {
                display: 'none'
            }
        },
        title: {
            '&.inside': {
                paddingLeft: 25
            }
        },
        titleContainer: {
            display: 'flex'
        },
        assessmentIcon: {
            ...verticalCentering,
            marginTop: -5,
            marginRight: 15
        },
        titleText: {
            ...verticalCentering,
            color: '#ff3a3a',
            "&.validated": {
                color: '#000'
            }
        },
        links: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        },
        link: {
            color: '#009dd8',
            fontSize: '16pt',
            marginRight: 20,
            cursor: 'pointer',
            ...verticalCentering
        },
        scheduleLink: {
            color: '#c4c4c4',
            cursor: 'default',
            marginTop: 1,
            fontSize: '16pt',
            "&.validated": {
                cursor: 'pointer',
                color: '#009dd8'
            }
        },
        sharedLink: {
            display: 'flex',
            marginRight: 20,
            color: '#4d586e'
        },
        sharedIcon: {
            ...verticalCentering,
            color: '#c4c4c4',
            marginRight: 10,
            '&.shared': {
                color: '#ea8511'
            }
        },
        sharedText: {
            ...verticalCentering,
            cursor: 'default',
            textAlign: 'center',
            marginRight: 10,
            width: 50,
            "&.selected": {
                color: "#fff"
            }
        },
        moreSettingsButton: {
            color: '#a2a6b2',
            cursor: 'pointer',
            "&.selected": {
                color: '#fff'
            }
        },
        directoryNameContainer: {
            display: 'flex'
        },
        directoryNameText: {
            marginLeft: 20,
            flexGrow: 1
        },
        directoryCell: {
            color: '#2f75bd',
            backgroundColor: '#eff8ff',
            fontSize: '13pt',
            "&.selected": {
                backgroundColor: '#1e85d5',
                color: '#fff'
            }
        },
        folderIcon: {
            fontSize: '15pt',
            '&.foldable': {
                cursor: 'pointer'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","react-router-dom":"3uzXR","clsx":"5PNR8","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Tooltip":"7bRLE","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","resources/icons":"7BMUb","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./assessment-row-settings":"basjQ","./directory-row-settings":"h7vZs","@mui/icons-material/Share":"hf4BL","./duplicate-assessment":"gRM6Y","./create-assignment":"dTBWV","../../editable-label":"Wgagl","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"basjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentRowSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _textInput = require("components/text-input");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _responsiveFullscreenDialog = require("components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _selectDirectory = require("components/quiz/components/SelectDirectory");
var _selectDirectoryDefault = parcelHelpers.interopDefault(_selectDirectory);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _context = require("teacher/context");
function AssessmentRowSettings({ assessment, classes }) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const history = (0, _reactRouterDom.useHistory)();
    const { translate } = context;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const [deleteOpened, openDeleteAssessment] = (0, _reactDefault.default).useState(false);
    const [moveToDirectoryOpened, openMoveToDirectory] = (0, _reactDefault.default).useState(false);
    const [pdfOpened, openPdf] = (0, _reactDefault.default).useState(false);
    const [directory, setDirectory] = (0, _reactDefault.default).useState(assessment.directory || "");
    const openRowSettingsMenu = (e)=>{
        setAnchorEl(e.currentTarget);
    };
    const closeRowSettingsMenu = (e, reason)=>{
        setDirectory(assessment.directory || "");
        setAnchorEl(null);
    };
    function handleOpenDelete() {
        closeRowSettingsMenu();
        openDeleteAssessment(true);
    }
    async function handleDelete(confirmed) {
        openDeleteAssessment(false);
        if (confirmed) {
            const [deletedId] = await (0, _commandDefault.default)('quiz', 'deleteAssessment')({
                id: assessment.id
            });
            if (deletedId == assessment.id) {
                if (context.query.id) context.navigate({}, undefined, {
                    query: {
                        ...context.query,
                        id: undefined
                    }
                });
                else context.setState({
                    quizAssessmentCalls: context.quizAssessmentCalls + 1
                });
            }
        }
    }
    async function handleShare() {
        closeRowSettingsMenu();
        const shared = !assessment.shared;
        const [sharedId] = await (0, _commandDefault.default)('quiz', 'shareAssessment')({
            id: assessment.id,
            shared
        });
        if (sharedId == assessment.id) {
            const index = context.quizAssessments.findIndex(({ id })=>id == sharedId);
            if (index >= 0) {
                const quizAssessments = (0, _immutabilityHelperDefault.default)(context.quizAssessments, {
                    [index]: {
                        shared: {
                            $set: shared
                        }
                    }
                });
                context.setState({
                    quizAssessments
                });
            }
        }
    }
    function handleOpenMoveToDirectory() {
        closeRowSettingsMenu();
        openMoveToDirectory(true);
    }
    async function handleMoveToDirectory() {
        openMoveToDirectory(false);
        const [movedId] = await (0, _commandDefault.default)('quiz', 'moveAssessment')({
            id: assessment.id,
            directory
        });
        if (movedId == assessment.id) context.setState({
            quizAssessmentCalls: context.quizAssessmentCalls + 1
        });
    }
    function handleCloseMoveToDirectory() {
        openMoveToDirectory(false);
    }
    async function handlePrintBlankAssessmentPdf() {
        closeRowSettingsMenu();
        await (0, _commandDefault.default)('quiz', 'startTestAssessment')({
            id: assessment.id
        });
        context.updateState({
            quizBlankAssessmentForPdfId: {
                $set: assessment.id
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.moreSettings,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.moreSettingsButton,
                onClick: openRowSettingsMenu,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                id: "settings-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: closeRowSettingsMenu,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleShare,
                        children: translate(assessment.shared ? 'unshare' : 'share')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenMoveToDirectory,
                        children: translate('move-to-directory')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handlePrintBlankAssessmentPdf,
                        children: translate('blank-assessment-pdf')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenDelete,
                        children: translate('delete')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: moveToDirectoryOpened,
                close: handleCloseMoveToDirectory,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: handleMoveToDirectory,
                    children: translate('move')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: handleCloseMoveToDirectory,
                    children: translate('cancel')
                }),
                title: translate('move-assessment-message', assessment),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDirectoryDefault.default), {
                    controlFullWidth: true,
                    controlVariant: "outlined",
                    id: "directory",
                    caption: translate('directory'),
                    selectValue: directory || '',
                    selectOnChange: (e)=>setDirectory(e.target.value == "" ? undefined : e.target.value),
                    context: context
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: deleteOpened,
                close: handleDelete,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>handleDelete(true),
                    children: translate('delete')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: ()=>handleDelete(),
                    children: translate('cancel')
                }),
                title: translate('confirm_delete_item'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    children: translate('delete-assessment-message', assessment)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/icons-material/MoreVert":"22WtH","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/material/DialogContentText":"5nWzR","components/text-input":"gF58h","components/responsive-fullscreen-dialog":"9pRHY","components/quiz/components/SelectDirectory":"aHtgV","helpers/command":"f3cbG","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5nWzR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _dialogContentTextDefault.default));
parcelHelpers.export(exports, "dialogContentTextClasses", ()=>(0, _dialogContentTextClassesDefault.default));
var _dialogContentText = require("./DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _dialogContentTextClasses = require("./dialogContentTextClasses");
var _dialogContentTextClassesDefault = parcelHelpers.interopDefault(_dialogContentTextClasses);
parcelHelpers.exportAll(_dialogContentTextClasses, exports);
'use client';

},{"./DialogContentText":"6YEye","./dialogContentTextClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6YEye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _typography = require("../Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _dialogContentTextClasses = require("./dialogContentTextClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _dialogContentTextClasses.getDialogContentTextUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const DialogContentTextRoot = (0, _styledDefault.default)((0, _typographyDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const DialogContentText = /*#__PURE__*/ _react.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { className } = props, ownerState = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DialogContentTextRoot, (0, _extendsDefault.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
exports.default = DialogContentText;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","../Typography":"2wCD5","./dialogContentTextClasses":"bsxm4","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bsxm4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDialogContentTextUtilityClass", ()=>getDialogContentTextUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getDialogContentTextUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiDialogContentText', slot);
}
const dialogContentTextClasses = (0, _generateUtilityClassesDefault.default)('MuiDialogContentText', [
    'root'
]);
exports.default = dialogContentTextClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h7vZs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DirectoryRowSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _textInput = require("../../text-input");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _responsiveFullscreenDialog = require("../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _command = require("../../../helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
function DirectoryRowSettings({ selected, directory, context, classes, assessments, shared, onEditNameClick }) {
    const { translate } = context;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const [deleteOpened, openDeleteDirectory] = (0, _reactDefault.default).useState(false);
    const canShare = assessments.length > 0;
    const openRowSettingsMenu = (e)=>{
        e.stopPropagation();
        setAnchorEl(e.currentTarget);
    };
    const closeRowSettingsMenu = (e)=>{
        e.stopPropagation();
        setAnchorEl(null);
    };
    function handleOpenDelete(e) {
        closeRowSettingsMenu(e);
        openDeleteDirectory(true);
    }
    async function handleDelete(e) {
        e.stopPropagation();
        openDeleteDirectory(false);
        const [{ id: deletedId }] = await (0, _commandDefault.default)('quiz', 'deleteDirectory')({
            id: directory.id
        }) || [
            {}
        ];
        if (deletedId == directory.id) {
            const quizDirectories = (0, _immutabilityHelperDefault.default)(context.quizDirectories, {
                $unset: [
                    deletedId
                ]
            });
            context.setState({
                quizDirectories,
                quizAssessmentCalls: context.quizAssessmentCalls + 1
            });
        }
    }
    async function handleShare(e) {
        closeRowSettingsMenu(e);
        const [sharedId] = await (0, _commandDefault.default)('quiz', 'shareDirectory')({
            id: directory.id,
            shared: !shared
        });
        if (sharedId == directory.id) context.setState({
            quizAssessmentCalls: context.quizAssessmentCalls + 1
        });
    }
    function handleRename(e) {
        closeRowSettingsMenu(e);
        e.stopPropagation();
        if (onEditNameClick) onEditNameClick();
    }
    function handleCloseDelete(e) {
        e.stopPropagation();
        openDeleteDirectory(false);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.moreSettings,
        onClick: (e)=>e.stopPropagation(),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.moreSettingsButton, {
                    selected
                }),
                onClick: openRowSettingsMenu,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                id: "settings-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: closeRowSettingsMenu,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleRename,
                        children: context.translate('rename')
                    }),
                    canShare && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleShare,
                        children: context.translate(shared ? 'unshare' : 'share')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenDelete,
                        children: context.translate('delete')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: deleteOpened,
                close: handleCloseDelete,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: handleDelete,
                    children: translate('delete')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: handleCloseDelete,
                    children: translate('cancel')
                }),
                title: translate('confirm_delete_item'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    children: translate('delete-directory-message', directory)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/icons-material/MoreVert":"22WtH","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/material/DialogContentText":"5nWzR","../../text-input":"gF58h","../../responsive-fullscreen-dialog":"9pRHY","../../../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hf4BL":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("d5d12f43ce8bd4e7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("8dfbc983a1d70ad0"));
var _jsxRuntime = require("2211899d42a589c6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92"
}), 'Share');

},{"d5d12f43ce8bd4e7":"kZ6eK","8dfbc983a1d70ad0":"2vOnF","2211899d42a589c6":"1dlk8"}],"gRM6Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DuplicateAssessmentForm);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _material = require("external/material");
var _formHook = require("../../../helpers/form-hook");
var _formHookDefault = parcelHelpers.interopDefault(_formHook);
var _validationsHook = require("../../../helpers/validations-hook");
var _validationsHookDefault = parcelHelpers.interopDefault(_validationsHook);
var _command = require("../../../helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _responsiveFullscreenDialog = require("../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _textInput = require("../../text-input");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _validations = require("../../../helpers/validations");
const validations = {
    title: [
        (0, _validations.requiredTextAfterAttempt)('title', 'required-title')
    ]
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex'
        },
        duplicateTitleInput: {
            paddingTop: 10
        }
    }));
function DuplicateAssessmentForm({ context, onDuplicate }) {
    const { translate, quizDialogs, quizAssessmentToDuplicate: assessment } = context;
    const isOpen = quizDialogs['duplicate-assessment'];
    const classes = useStyles();
    const { state, setState, handleChange, resetState } = (0, _formHookDefault.default)({
        attempted: false,
        title: assessment.title
    });
    const { errors, errorCount, validate, resetErrors } = (0, _validationsHookDefault.default)(validations);
    const createStateHandler = (mapState)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            setState({
                ...state,
                ...mapState(value)
            });
        };
    function closeDialog() {
        const quizDialogs = (0, _immutabilityHelperDefault.default)(context.quizDialogs, {
            'duplicate-assessment': {
                $set: false
            }
        });
        context.setState({
            quizDialogs
        });
        resetState();
    }
    async function handleDuplicate() {
        if (validate({
            ...state,
            attempted: true
        })) {
            const [duplicatedId] = await (0, _commandDefault.default)('quiz', 'duplicateAssessment')({
                id: assessment.id,
                title: state.title
            });
            closeDialog();
            if (onDuplicate) onDuplicate();
        } else setState({
            ...state,
            attempted: true
        });
    }
    (0, _reactDefault.default).useEffect(()=>{
        validate(state);
    }, [
        state
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        setState({
            ...state,
            title: assessment.title
        });
    }, [
        assessment
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: closeDialog,
        title: translate('duplicate-assessment-message', assessment),
        confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            color: "primary",
            onClick: handleDuplicate,
            children: translate('duplicate')
        }),
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            color: "secondary",
            onClick: closeDialog,
            children: translate('cancel')
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: classes.duplicateTitleInput,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                controlFullWidth: true,
                controlVariant: "outlined",
                id: "title",
                inputAutoComplete: "title",
                caption: translate('title'),
                value: state.title,
                inputOnChange: handleChange('title'),
                controlError: errors.title.length > 0,
                errorMessage: errors.title.length > 0 ? translate(errors.title) : undefined
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","external/material":"6yEDE","../../../helpers/form-hook":"8O4Ar","../../../helpers/validations-hook":"r624y","../../../helpers/command":"f3cbG","../../responsive-fullscreen-dialog":"9pRHY","../../text-input":"gF58h","../../../helpers/validations":"lg1Ji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dTBWV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assign);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _infoBar = require("./info-bar");
var _infoBarDefault = parcelHelpers.interopDefault(_infoBar);
var _selectStudents = require("./select-students");
var _selectStudentsDefault = parcelHelpers.interopDefault(_selectStudents);
var _writeComments = require("./write-comments");
var _writeCommentsDefault = parcelHelpers.interopDefault(_writeComments);
var _command = require("helpers/command");
var _responsiveFullscreenDialog = require("../../components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
const useDialogStyles = (0, _material.makeStyles)((theme)=>({
        paper: {
            width: '100%',
            padding: '20px 0',
            height: 'calc(100% - 100px)'
        }
    }));
const useDialogActionsStyles = (0, _material.makeStyles)({
    root: {
        padding: 0
    }
});
const useDialogTitleStyles = (0, _material.makeStyles)({
    root: {
        padding: 0
    }
});
const useDialogContentStyles = (0, _material.makeStyles)({
    root: {
        padding: 0,
        display: 'flex'
    }
});
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexDirection: 'column',
            color: '#4f576e',
            flexGrow: 1
        }
    }));
const Tabs = (0, _material.withStyles)({
    root: {
        flexShrink: 0,
        borderBottom: 'solid 1px #dbe3e6'
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        flexGrow: 1
    },
    flexContainer: {
        flexGrow: 1
    }
})((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
        ...props,
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        }
    }));
const Tab = (0, _material.withStyles)((theme)=>({
        root: {
            padding: '0 5px',
            margin: 0,
            maxWidth: 'initial',
            flexShrink: 1,
            flexGrow: 1,
            textTransform: 'none',
            fontWeight: 400,
            backgroundColor: '#f8f8f8',
            fontSize: '15px',
            '&:first-child': {
                borderRight: 'solid 1px #dbe3e6'
            },
            '&:focus': {
                opacity: 1
            }
        },
        wrapper: {
            flexDirection: 'row'
        },
        selected: {
            opacity: 1,
            backgroundColor: 'transparent'
        }
    }))((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
        disableRipple: true,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircleIcon, {
            ...props
        }),
        ...props
    }));
const StyledCircle = (0, _material.styled)((0, _boxDefault.default))(({ theme })=>({
        borderRadius: 50,
        flexShrink: 0,
        color: '#fff',
        width: '25px',
        height: '25px',
        fontSize: '11pt',
        marginRight: '20px',
        lineHeight: '1.8',
        backgroundColor: '#a6a6a6',
        [theme.breakpoints.down('sm')]: {
            marginRight: '8px'
        },
        '&.selected': {
            backgroundColor: '#e27a1b'
        }
    }));
function CircleIcon(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCircle, {
        className: (0, _clsxDefault.default)({
            selected: props.selected
        }),
        children: props.value + 1
    });
}
const initialState = ()=>({
        group: '',
        start: (0, _momentDefault.default)().toDate(),
        finish: (0, _momentDefault.default)().endOf('day').toDate(),
        maxDuration: (0, _momentDefault.default)().endOf('day').diff((0, _momentDefault.default)(), 'seconds'),
        duration: 3600,
        comments: '',
        students: [],
        selectedStudents: [],
        checkedStudents: {},
        tab: 0
    });
function Assign({ context }) {
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, quizAssessmentToAssign, groups } = context;
    const classes = useStyles();
    const dialogClasses = useDialogStyles();
    const dialogActionsClasses = useDialogActionsStyles();
    const dialogTitleClasses = useDialogTitleStyles();
    const dialogContentClasses = useDialogContentStyles();
    const isOpen = quizAssessmentToAssign !== false;
    const [state, setState] = (0, _reactDefault.default).useState(initialState());
    function handleTimeChange({ hours, minutes }) {
        const duration = Math.min(minutes * 60 + hours * 3600, state.maxDuration);
        setState({
            ...state,
            duration
        });
    }
    function handleStartChange(start) {
        const finish = (0, _momentDefault.default)(state.finish).isAfter(start) ? state.finish : (0, _momentDefault.default)(start).endOf('day').toDate();
        const maxDuration = (0, _momentDefault.default)(finish).diff((0, _momentDefault.default)(start), 'seconds');
        const duration = Math.min(state.duration, maxDuration);
        setState({
            ...state,
            start,
            finish,
            duration,
            maxDuration
        });
    }
    function handleFinishChange(finish) {
        const maxDuration = (0, _momentDefault.default)(finish).diff((0, _momentDefault.default)(state.start), 'seconds');
        const duration = Math.min(state.duration, maxDuration);
        setState({
            ...state,
            finish,
            duration,
            maxDuration
        });
    }
    function handleTabChange(e, tab) {
        setState({
            ...state,
            tab
        });
    }
    function handleCancel() {
        context.setState({
            quizAssessmentToAssign: false
        });
        setState(initialState());
    }
    function handleContinue() {
        setState({
            ...state,
            tab: 1
        });
    }
    function handleBack() {
        setState({
            ...state,
            tab: 0
        });
    }
    function handleGroupChange(e) {
        const group = groups.find((g)=>g.id == e.target.value) || {};
        const students = group.students || [];
        const checkedStudents = students.reduce((acc, student)=>{
            acc[student.id] = false;
            return acc;
        }, {});
        setState({
            ...state,
            group: e.target.value,
            students,
            selectedStudents: [],
            checkedStudents
        });
    }
    function handleStudentsChecked(id, value) {
        setState({
            ...state,
            checkedStudents: {
                ...state.checkedStudents,
                [id]: value
            }
        });
    }
    function handleStudentsChange({ left, right }) {
        setState({
            ...state,
            students: left,
            selectedStudents: right
        });
    }
    function handleCommentsChange(e) {
        setState({
            ...state,
            comments: e.target.value
        });
    }
    async function handleSend() {
        try {
            const { id } = quizAssessmentToAssign;
            const { comments, duration } = state;
            const start = (0, _momentDefault.default)(state.start).toISOString();
            const finish = (0, _momentDefault.default)(state.finish).toISOString();
            const students = state.selectedStudents.map((s)=>s.id);
            const [result] = await (0, _command.createPost)('quiz', 'createAssignment')({
                id,
                start,
                finish,
                duration,
                comments,
                students
            });
            handleCancel();
            if (result) context.navigate({
                tab: 'assigned'
            }, undefined, {
                query: {
                    id: result.assignment
                }
            });
        } catch (e) {
            handleCancel();
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: handleCancel,
        dialogClasses: dialogClasses,
        contentClasses: dialogContentClasses,
        headClasses: dialogTitleClasses,
        actionsClasses: dialogActionsClasses,
        dialogMaxWidth: "lg",
        TitleComponent: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBarDefault.default), {
                context: context
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Tabs, {
                    value: state.tab,
                    onChange: handleTabChange,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tab, {
                            label: translate('select-students-tab')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tab, {
                            label: translate('comments-tab')
                        })
                    ]
                }),
                state.tab == 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectStudentsDefault.default), {
                    selectedGroup: state.group,
                    students: state.students,
                    selectedStudents: state.selectedStudents,
                    checkedStudents: state.checkedStudents,
                    onGroupChange: handleGroupChange,
                    onStudentsChecked: handleStudentsChecked,
                    onStudentsChange: handleStudentsChange,
                    onCancel: handleCancel,
                    onContinue: handleContinue,
                    context: context
                }),
                state.tab == 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _writeCommentsDefault.default), {
                    selectedStudents: state.selectedStudents,
                    newComments: state.comments,
                    start: state.start,
                    finish: state.finish,
                    duration: state.duration,
                    onCommentsChange: handleCommentsChange,
                    onStartChange: handleStartChange,
                    onFinishChange: handleFinishChange,
                    onTimeChange: handleTimeChange,
                    onCancel: handleCancel,
                    onSend: handleSend,
                    context: context
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-router-dom":"3uzXR","clsx":"5PNR8","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Tabs":"g7Izf","@mui/material/Tab":"bmkB3","./info-bar":"aDoMj","./select-students":"52z3w","./write-comments":"jyqOL","helpers/command":"f3cbG","../../components/responsive-fullscreen-dialog":"5zam1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aDoMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _icons = require("resources/icons");
const StyledInfoBar = (0, _material.styled)((0, _material.Box))(({ theme })=>({
        display: 'flex',
        borderBottom: 'solid 1px #dbe3e6',
        minHeight: '60px',
        paddingLeft: '15px',
        '& .middle': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        '& .label': {
            paddingTop: '4px',
            marginLeft: '20px',
            fontSize: '14pt',
            [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.pxToRem(15)
            }
        }
    }));
function InfoBar({ context }) {
    const { quizAssessmentToAssign } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledInfoBar, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "middle",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                    fill: "#4f576e"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "middle label",
                children: quizAssessmentToAssign.title
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"52z3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectStudents);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _select = require("components/select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _transferList = require("components/transfer-list");
var _transferListDefault = parcelHelpers.interopDefault(_transferList);
var _checklist = require("./checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: '0 20px',
            overflow: 'hidden'
        },
        group: {
            padding: '20px 0',
            maxWidth: 'calc(50% - 56px)'
        },
        students: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto'
        },
        buttons: {
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        cancel: {
            width: '120px',
            marginRight: '10px',
            boxShadow: 'none'
        },
        continue: {
            width: '120px',
            color: '#fff',
            boxShadow: 'none',
            backgroundColor: '#2ca5ec'
        }
    }));
function SelectStudents(props) {
    const { selectedGroup, context } = props;
    const { groups, translate } = context;
    const classes = useStyles();
    const groupOptions = groups.map((group, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
            value: group.id,
            children: group.name
        }, key));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.group,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            translate('group_label'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
                        selectValue: selectedGroup,
                        selectOnChange: props.onGroupChange,
                        controlSize: "small",
                        controlVariant: "outlined",
                        controlFullWidth: true,
                        children: [
                            selectedGroup == '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("option", {
                                value: ""
                            }),
                            groupOptions
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.students,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                        smDown: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListDefault.default), {
                            label: ({ name })=>name,
                            left: props.students,
                            LeftHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.studentsHeader,
                                    children: [
                                        translate('students'),
                                        ":"
                                    ]
                                }),
                            RightHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.selectedHeader,
                                    children: [
                                        translate('selected'),
                                        ":"
                                    ]
                                }),
                            right: props.selectedStudents,
                            checklist: props.checkedStudents,
                            onChecked: props.onStudentsChecked,
                            onTransfer: props.onStudentsChange
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                        smUp: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: (0, _lodash.chain)(props.students).concat(props.selectedStudents).map((s)=>({
                                    ...s,
                                    label: s.alias || s.email
                                })).orderBy([
                                'label',
                                'id'
                            ]).value(),
                            selectAllTitle: translate('students_label'),
                            onChecked: props.onStudentsChange,
                            checklist: props.selectedStudents.map((s)=>s.id)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onCancel,
                        variant: "contained",
                        className: classes.cancel,
                        children: translate('cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onContinue,
                        disabled: props.selectedStudents.length == 0,
                        variant: "contained",
                        className: classes.continue,
                        children: translate('continue_label')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Hidden":"kijsg","@mui/material/Fade":"8DwqP","@mui/material/Button":"c6Y0y","components/select":"k4sBU","components/transfer-list":"kQWaU","./checklist":"dTgNX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dTgNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckList);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
const useStyles = (0, _material.makeStyles)((theme)=>({
        card: {
            flexGrow: 1,
            border: 'solid 1px #b0b0b0',
            boxShadow: 'none',
            overflowY: 'auto',
            height: '100%',
            flexGrow: 1
        }
    }));
function ListElem(props) {
    const { id, label, checked, onClick } = props;
    const labelId = `transfer-list-item-${id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
        role: "listitem",
        button: true,
        onClick: onClick,
        className: props.className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: checked,
                    tabIndex: -1,
                    disableRipple: true,
                    inputProps: {
                        'aria-labelledby': labelId
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                id: labelId,
                primary: label
            })
        ]
    });
}
function CheckList(props) {
    const classes = useStyles();
    const { checklist, selectAllTitle, id = (elem)=>typeof elem == 'object' ? elem.id : elem, label = (elem)=>typeof elem == 'object' ? elem.label : elem, ListItem = ListElem, onChecked } = props;
    const isChecked = (elem)=>checklist.indexOf(id(elem)) >= 0;
    const isNotChecked = (elem)=>checklist.indexOf(id(elem)) < 0;
    const items = props.items.map((item)=>({
            id: id(item),
            checked: isChecked(item),
            item
        }));
    const createItem = ({ id, checked, item })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItem, {
            id: id,
            label: label(item),
            checked: checked,
            className: (0, _clsxDefault.default)({
                [classes.checked]: checked
            }),
            onClick: ()=>{
                const left = items.filter((i)=>i.id != id && !i.checked).map((i)=>i.item);
                const right = items.filter((i)=>i.id != id && i.checked).map((i)=>i.item);
                if (checked) onChecked({
                    left: [
                        ...left,
                        item
                    ],
                    right
                });
                else onChecked({
                    left,
                    right: [
                        ...right,
                        item
                    ]
                });
            }
        }, id);
    };
    const allChecked = (0, _lodash.every)(items, (item)=>item.checked);
    const noneChecked = (0, _lodash.every)(items, (item)=>!item.checked);
    const someChecked = !allChecked && !noneChecked;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        className: classes.card,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                className: classes.cardHeader,
                avatar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    onClick: ()=>{
                        if (noneChecked || someChecked) onChecked({
                            left: [],
                            right: [
                                ...props.items
                            ]
                        });
                        else onChecked({
                            left: [
                                ...props.items
                            ],
                            right: []
                        });
                    },
                    checked: allChecked,
                    indeterminate: someChecked,
                    disabled: items.length === 0,
                    inputProps: {
                        'aria-label': 'all items selected'
                    }
                }),
                title: selectAllTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                dense: true,
                component: "div",
                role: "list",
                children: items.map(createItem)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Grid":"ggUwv","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/material/Checkbox":"4sdMA","@mui/material/Card":"1fzLS","@mui/material/Divider":"5Ykub","@mui/material/CardHeader":"kanB9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyqOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WriteComments);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _locale = require("date-fns/locale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: '0 20px',
            overflow: 'hidden'
        },
        label: {
            padding: '20px 0'
        },
        comments: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto',
            '& textarea': {
                flexGrow: 1,
                resize: 'none'
            }
        },
        buttons: {
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        cancel: {
            width: '120px',
            marginRight: '20px',
            boxShadow: 'none'
        },
        send: {
            width: '120px',
            color: '#fff',
            boxShadow: 'none',
            backgroundColor: '#2ca5ec'
        },
        dateDuration: {
            display: 'flex',
            marginTop: 20,
            marginBottom: 20
        },
        dates: {
            display: 'flex'
        },
        datePicker: {
            marginTop: 10,
            marginRight: 20,
            "& .date-input": {
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                padding: 5
            },
            "& svg": {
                marginRight: 5
            }
        },
        durationInput: {
            marginTop: 10,
            marginRight: 20,
            "& input": {
                padding: '3px 5px',
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                fontSize: '1rem',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: '0.00938em'
            }
        },
        duration: {
            display: 'flex'
        }
    }));
function WriteComments(props) {
    const { newComments, context } = props;
    const hours = Math.floor(props.duration / 3600);
    const minutes = Math.floor(props.duration % 3600 / 60);
    const { translate } = context;
    const classes = useStyles();
    const canSave = props.selectedStudents.length > 0 && props.duration > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.dateDuration,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.dates,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "from",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("start")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                            locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                            selected: (0, _momentDefault.default)(props.start).toDate(),
                                            minDate: new Date(),
                                            maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                            showTimeInput: true,
                                            dateFormat: "MM/dd/yyyy h:mm aa",
                                            onChange: props.onStartChange
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "to",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("end")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                            locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                            selected: (0, _momentDefault.default)(props.finish).toDate(),
                                            minDate: (0, _momentDefault.default)(props.start).toDate(),
                                            maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                            showTimeInput: true,
                                            dateFormat: "MM/dd/yyyy h:mm aa",
                                            timeIntervals: 60,
                                            onChange: props.onFinishChange
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.duration,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "hours",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("hours")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: hours,
                                            onChange: (e)=>{
                                                const value = parseInt(e.target.value);
                                                const hours = isNaN(value) ? 0 : value;
                                                props.onTimeChange({
                                                    hours,
                                                    minutes
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "minutes",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("minutes")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: minutes,
                                            onChange: (e)=>{
                                                const value = parseInt(e.target.value);
                                                const minutes = isNaN(value) ? 0 : value;
                                                props.onTimeChange({
                                                    hours,
                                                    minutes
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.label,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: translate('comment')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.comments,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                    autoFocus: true,
                    value: newComments,
                    onChange: props.onCommentsChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onCancel,
                        variant: "contained",
                        className: classes.cancel,
                        children: translate('cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onSend,
                        disabled: !canSave,
                        variant: "contained",
                        className: classes.send,
                        children: translate('save_label')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","date-fns/locale":"dElgW","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Hidden":"kijsg","@mui/material/Typography":"2wCD5","@mui/material/Button":"c6Y0y","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-datepicker/dist/react-datepicker.css":"chsuV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"Wgagl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditableLabel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _clickAwayListener = require("@mui/material/ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _inputAdornment = require("@mui/material/InputAdornment");
var _inputAdornmentDefault = parcelHelpers.interopDefault(_inputAdornment);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _done = require("@mui/icons-material/Done");
var _doneDefault = parcelHelpers.interopDefault(_done);
var _clear = require("@mui/icons-material/Clear");
var _clearDefault = parcelHelpers.interopDefault(_clear);
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            padding: 0
        },
        input: {
            display: 'flex',
            backgroundColor: '#fff',
            padding: 0,
            '& .MuiInputBase-input': {
                borderRight: 'solid 1px #dbe3e6'
            }
        },
        addornment: {
            display: 'flex',
            padding: '0 7px 0 5px',
            justifyContent: 'center'
        },
        button: {
            cursor: 'pointer',
            '&:hover': {
                transform: 'scale(1.2)'
            }
        }
    }));
function EditableLabel(props) {
    const classes = useStyles();
    const [value, setValue] = (0, _reactDefault.default).useState(props.label);
    const inputRef = (0, _reactDefault.default).useRef();
    (0, _reactDefault.default).useEffect(()=>{
        setValue(props.label);
    }, [
        props.label
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.editing) setTimeout(()=>{
            inputRef.current.focus();
        }, 10);
    }, [
        props.editing
    ]);
    function handleCancel() {
        setValue(props.label);
        props.onCancel && props.onCancel();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: props.className,
        children: [
            props.editing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clickAwayListenerDefault.default), {
                onClickAway: handleCancel,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                    className: classes.root,
                    margin: "dense",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputLabelDefault.default), {
                            children: props.caption
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                            value: value,
                            inputRef: inputRef,
                            className: classes.input,
                            onKeyDown: (e)=>{
                                e.key == 'Enter' && props.onConfirm(value);
                                e.key == 'Escape' && handleCancel();
                            },
                            onChange: (e)=>setValue(e.target.value),
                            endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputAdornmentDefault.default), {
                                className: classes.addornment,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: classes.button,
                                    onClick: ()=>props.onConfirm(value),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _doneDefault.default), {})
                                })
                            })
                        })
                    ]
                })
            }),
            !props.editing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: props.label
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/ClickAwayListener":"g3Gd7","@mui/material/OutlinedInput":"8eUp2","@mui/material/InputLabel":"iTW3B","@mui/material/InputAdornment":"jiJDh","@mui/material/FormControl":"kkska","@mui/material/TextField":"amnzu","@mui/icons-material/Done":"6GFTq","@mui/icons-material/Clear":"dyxCG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g3Gd7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _clickAwayListener.ClickAwayListener));
var _clickAwayListener = require("./ClickAwayListener");

},{"./ClickAwayListener":"5EoN1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5EoN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClickAwayListener", ()=>ClickAwayListener);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _utils = require("@mui/utils");
var _getReactElementRef = require("@mui/utils/getReactElementRef");
var _getReactElementRefDefault = parcelHelpers.interopDefault(_getReactElementRef);
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
var _jsxRuntime = require("react/jsx-runtime");
'use client';
function mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function ClickAwayListener(props) {
    const { children, disableReactTree = false, mouseEvent = 'onClick', onClickAway, touchEvent = 'onTouchEnd' } = props;
    const movedRef = _react.useRef(false);
    const nodeRef = _react.useRef(null);
    const activatedRef = _react.useRef(false);
    const syntheticEventRef = _react.useRef(false);
    _react.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, _utils.unstable_useForkRef)((0, _getReactElementRefDefault.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, _utils.unstable_useEventCallback)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    _react.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = mapEventPropToEvent(touchEvent);
            const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    _react.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
            const doc = (0, _utils.unstable_ownerDocument)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Fragment, {
        children: /*#__PURE__*/ _react.cloneElement(children, childrenProps)
    });
}

},{"react":"9njXz","prop-types":"bnNSm","@mui/utils":"lfcNH","@mui/utils/getReactElementRef":"guLSb","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GFTq":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("2a3d93342fddc109");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("acfcd9239bdd2977"));
var _jsxRuntime = require("8f83e669ea385798");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"
}), 'Done');

},{"2a3d93342fddc109":"kZ6eK","acfcd9239bdd2977":"2vOnF","8f83e669ea385798":"1dlk8"}],"i3UT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilterChip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
function FilterChip(props) {
    const history = (0, _reactRouterDom.useHistory)();
    const { name, createLabel = (a)=>a, context, onDelete, from } = props;
    const label = createLabel(context.query[name]);
    function handleDelete() {
        const query = {
            ...context.query,
            [name]: undefined
        };
        history.push(context.link(undefined, undefined, {
            query
        }));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
        label: label,
        onDelete: onDelete || handleDelete,
        className: "filter-chip"
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Chip":"eSSCi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8B2ma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentBank);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _assessmentBankFilters = require("./assessment-bank-filters");
var _assessmentBankFiltersDefault = parcelHelpers.interopDefault(_assessmentBankFilters);
var _assessmentBankHead = require("./assessment-bank-head");
var _assessmentBankHeadDefault = parcelHelpers.interopDefault(_assessmentBankHead);
var _assessmentBankBody = require("./assessment-bank-body");
var _assessmentBankBodyDefault = parcelHelpers.interopDefault(_assessmentBankBody);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _filterChip = require("../components/filter-chip");
var _filterChipDefault = parcelHelpers.interopDefault(_filterChip);
const useStyles = (0, _material.makeStyles)({
    root: {
        flexGrow: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff'
    },
    content: {
        display: 'flex',
        flexGrow: 1,
        overflow: 'hidden'
    },
    container: {
        flexGrow: 1,
        overflow: 'auto'
    },
    chips: {
        '&.hasChip': {
            padding: '8px 15px',
            marginTop: 0
        },
        '& .filter-chip': {
            backgroundColor: '#de3434',
            color: '#fff',
            '& .MuiChip-label': {
                padding: '0 20px'
            },
            '& .MuiChip-deleteIcon': {}
        }
    },
    filters: {
        display: 'flex',
        padding: '0 15px 8px 15px'
    }
});
function AssessmentBank({ context }) {
    const classes = useStyles();
    const from = context.link();
    const hasStandardsChip = Object.values(context.quizStandardFilters).some((a)=>a.length > 0);
    const hasChip = !(!context.query.pattern && !context.query.id && !hasStandardsChip);
    function clearStandardFilters() {
        context.updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: {
                expectations: {
                    $set: []
                },
                indicators: {
                    $set: []
                },
                standards: {
                    $set: []
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.filters,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentBankFiltersDefault.default), {
                    context: context
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.chips, {
                    hasChip
                }),
                children: [
                    context.query.pattern && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "pattern",
                        context: context,
                        from: from
                    }),
                    hasStandardsChip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "standards",
                        context: context,
                        createLabel: ()=>context.translate('standards-filter-chip'),
                        from: from,
                        onDelete: clearStandardFilters
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                    className: classes.container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                        in: !context.quizSearch.assessments,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                            className: classes.table,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentBankHeadDefault.default), {
                                    context: context
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentBankBodyDefault.default), {
                                    context: context
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","./assessment-bank-filters":"7q8vo","./assessment-bank-head":"casWO","./assessment-bank-body":"lxeLt","@mui/material/Fade":"8DwqP","@mui/material/TableContainer":"2Kmn7","@mui/material/Table":"if4Vw","../components/filter-chip":"i3UT5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7q8vo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentBankFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _activeFiltersCjs = require("components/standards-selector/domain/active-filters.cjs");
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _select = require("../../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _searchPattern = require("../components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _lodash = require("external/lodash");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _quiz = require("helpers/quiz");
const useStyles = (0, _material.makeStyles)(filterStyles);
function AssessmentBankFilters({ context }) {
    const classes = useStyles();
    const { translate, navigate, institutionCourses } = context;
    const createFilterHandler = (name, mapQuery)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            const query = mapQuery ? mapQuery(context.query, value) : {
                ...context.query,
                [name]: value
            };
            navigate(undefined, undefined, {
                query: {
                    ...query,
                    page: 1
                }
            });
        };
    const courses = context.query.subject ? institutionCourses.filter(({ course })=>course.substring(0, 2) == context.query.subject) : institutionCourses;
    const units = context.query.course && context.units ? context.units.slice(1) : [];
    const lessons = context.query.unit && context.lessons ? context.lessons : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.filters,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "top",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _clearableSelectDefault.default), {
                        id: "assessment-bank-repository-filter",
                        className: (0, _clsxDefault.default)(classes.select, "repository"),
                        value: context.query.repository || "",
                        onChange: createFilterHandler('repository'),
                        caption: translate('repository'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: "dreyfous",
                                children: translate('dreyfous')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: "institution",
                                children: translate('institution')
                            })
                        ]
                    }),
                    context.quizTypes.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "assessment-bank-type-filter",
                        className: (0, _clsxDefault.default)(classes.select, "type"),
                        value: context.query.type || "",
                        onChange: createFilterHandler('type'),
                        caption: translate('quiz-type'),
                        children: context.quizTypes.map((type, key)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: type.id,
                                children: translate(`${type.name}-label`)
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.filler
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.pattern,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                            path: context.link(),
                            context: context
                        })
                    })
                ]
            }),
            !(0, _activeFiltersCjs.hasActiveStandardsFilter)(context.quizStandardFilters) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.standardsSearch,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: context.link({
                        sectionName: 'standards-search'
                    }, '/:languageId/:role/:page/:tab/:sectionName', {
                        preserveQuery: true
                    }),
                    className: classes.standardsSearchLink,
                    children: translate('standards-search')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "bottom",
                children: [
                    context.subjects.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "question-bank-subject-filter",
                        className: (0, _clsxDefault.default)(classes.select, "subject"),
                        value: context.query.subject || "",
                        onChange: createFilterHandler('subject', (query, subject)=>({
                                ...query,
                                course: undefined,
                                unit: undefined,
                                lesson: undefined,
                                subject
                            })),
                        caption: translate('subject_label'),
                        children: context.subjects.map((subject, key)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: subject.id,
                                children: subject.name
                            }, key);
                        })
                    }),
                    courses.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "question-bank-course-filter",
                        className: (0, _clsxDefault.default)(classes.select, "course"),
                        value: context.query.course || "",
                        onChange: createFilterHandler('course', (query, course)=>{
                            return course ? {
                                ...query,
                                course,
                                subject: course.substring(0, 2),
                                unit: undefined,
                                lesson: undefined
                            } : {
                                ...query,
                                course: undefined,
                                unit: undefined,
                                lesson: undefined
                            };
                        }),
                        caption: translate('course_assessment_header'),
                        children: (0, _lodash.orderBy)(courses, [
                            'course'
                        ]).map((course, key)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: course.course,
                                children: (0, _quiz.selectCourseLabel)(course)
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "question-bank-unit-filter",
                        className: (0, _clsxDefault.default)(classes.select, "unit"),
                        value: context.query.unit || "",
                        onChange: createFilterHandler('unit', (query, unit)=>{
                            return unit ? {
                                ...query,
                                unit
                            } : {
                                ...query,
                                unit: undefined,
                                lesson: undefined
                            };
                        }),
                        caption: translate('unitName-header'),
                        children: units.map((unit, key)=>{
                            const id = unit.id.substring(7);
                            const name = `${id.padStart(2, '0')} - ${unit.name}`;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: unit.id,
                                children: name
                            }, id);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                        id: "question-bank-lesson-filter",
                        className: (0, _clsxDefault.default)(classes.select, "lesson"),
                        value: context.query.lesson || "",
                        onChange: createFilterHandler('lesson', (query, lesson)=>{
                            return lesson ? {
                                ...query,
                                lesson
                            } : {
                                ...query,
                                lesson: undefined
                            };
                        }),
                        caption: translate('lesson-header'),
                        children: lessons.map((lesson, key)=>{
                            const name = `${(key + 1).toString().padStart(2, '0')} - ${lesson.name}`;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: lesson.id,
                                children: name
                            }, key);
                        })
                    })
                ]
            })
        ]
    });
}
function filterStyles(theme) {
    return {
        filters: {
            padding: '15px 0',
            flexGrow: 1,
            display: "flex",
            flexDirection: 'column',
            flexWrap: 'wrap',
            "& .top": {
                display: "flex"
            },
            "& .bottom": {
                marginTop: 8,
                display: "flex"
            }
        },
        standardsSearch: {
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: 5,
            marginBottom: 10
        },
        standardsSearchLink: {
            color: '#009dd8',
            fontSize: '9.5pt'
        },
        select: {
            marginLeft: 15,
            '&:first-child': {
                marginLeft: 0
            },
            '&.repository': {
                minWidth: 155
            },
            '&.type': {
                minWidth: 155
            },
            '&.subject': {
                minWidth: 155
            },
            '&.course': {
                flexGrow: 1,
                minWidth: 100,
                maxWidth: 300
            },
            '&.unit': {
                flexGrow: 1,
                minWidth: 100,
                maxWidth: 300
            },
            '&.lesson': {
                flexGrow: 1,
                minWidth: 100
            }
        },
        filler: {
            flexGrow: 1
        },
        pattern: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end"
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/standards-selector/domain/active-filters.cjs":"9Ycmg","react-router-dom":"3uzXR","external/material":"6yEDE","../../select":"k4sBU","../components/search-pattern":"gUgIQ","external/lodash":"5bCAQ","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","components/clearable-select":"jWvEj","helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"casWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentBankHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
const headCells = [
    {
        id: 'title',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'courseName',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'type',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'unitName',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'repository',
        align: 'left',
        disablePadding: false
    }
];
const useStyles = (0, _material.makeStyles)((theme)=>({
        headersRow: {
            color: '#50566e',
            '& > th': {
                borderTop: 'solid 1px #becfd7',
                backgroundColor: '#ffffff'
            }
        },
        headerLabel: {
            color: '#4f576e',
            fontWeight: 500
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));
function AssessmentBankHead({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { query, translate, navigate } = context;
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderBy = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    const createSortHandler = (property)=>(event)=>{
            navigate(undefined, undefined, {
                query: {
                    ...query,
                    page: 1,
                    orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`
                }
            });
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
            className: classes.headersRow,
            children: [
                headCells.map(({ id, align, disablePadding })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: align,
                        padding: disablePadding ? 'none' : 'normal',
                        sortDirection: order,
                        style: {
                            top: 92
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableSortLabelDefault.default), {
                            className: classes.headerLabel,
                            active: orderBy === id,
                            direction: order,
                            onClick: createSortHandler(id),
                            children: [
                                translate(`${id}-header`),
                                orderBy === id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: classes.visuallyHidden,
                                    children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                                }) : null
                            ]
                        })
                    }, id)),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.actions,
                    style: {
                        top: 92
                    }
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/TableSortLabel":"3xCAT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lxeLt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentBankBody);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _icons = require("resources/icons");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(assessmentBankBodyStyles);
function AssessmentBankBody() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { quizBankAssessments: assessments } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
        children: assessments.map((assessment)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Assessment, {
                assessment: assessment
            }, assessment.id);
        })
    });
}
function Assessment({ assessment }) {
    const history = (0, _reactRouterDom.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = useStyles();
    const { translate, link } = context;
    function courseName(id) {
        const { courseName = "" } = context.institutionCourses.find(({ course })=>course == id) || {};
        return courseName;
    }
    function typeName(type) {
        const { name = "" } = context.quizTypes.find(({ id })=>id == type) || {};
        return name;
    }
    async function handleSave(assessment) {
        const [id] = await (0, _commandDefault.default)('quiz', 'duplicateAssessment')({
            id: assessment.id,
            title: assessment.title
        });
        context.navigate({
            tab: 'assessments'
        }, undefined, {
            query: {
                id
            }
        });
    }
    function assessmentLink(assessment, action, sectionId) {
        return sectionId ? link({
            assessment,
            action,
            sectionId
        }, '/:languageId/:role/:page/:assessment/:action/:sectionId') : link({
            assessment,
            action
        }, '/:languageId/:role/:page/:assessment/:action');
    }
    function standardsLink(assessment) {
        return link({
            assessment,
            sectionName: 'standards'
        }, '/:languageId/:role/:page/:tab/:assessment/:sectionName', {
            preserveQuery: true
        });
    }
    function handlePreviewClick() {
        context.setState({
            quizPreviewFrom: '/:languageId/:role/:page/assessment-bank',
            quizPreviewFromQuery: {
                ...context.query
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
        className: (0, _clsxDefault.default)(classes.row),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.title),
                align: "left",
                scope: "row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: classes.titleContainer,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.assessmentIcon,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                                fill: '#3295ce'
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.titleText,
                            children: assessment.title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.course),
                align: "left",
                scope: "row",
                children: courseName(assessment.course)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.type),
                align: "left",
                scope: "row",
                children: translate(`${typeName(assessment.type)}-label`)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.unit),
                align: "left",
                scope: "row",
                children: assessment.unit
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.repository),
                align: "left",
                scope: "row",
                children: translate(`${assessment.repository}`)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.cell, classes.actions),
                align: "right",
                scope: "row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: classes.links,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('preview-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                onClick: handlePreviewClick,
                                to: assessmentLink(assessment.id, 'preview', assessment.firstSection),
                                className: (0, _clsxDefault.default)(classes.link, classes.previewLink),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PreviewIcon), {})
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('standards-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: standardsLink(assessment.id),
                                className: (0, _clsxDefault.default)(classes.link, classes.standardsLink),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faInfoCircle)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('save-assessment-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                onClick: ()=>handleSave(assessment),
                                className: (0, _clsxDefault.default)(classes.link, classes.duplicateLink),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faFileExport)
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function assessmentBankBodyStyles() {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        row: {
            '&:hover': {
                backgroundColor: '#def2ff'
            },
            '&.hidden': {
                display: 'none'
            }
        },
        title: {
            '&.inside': {
                paddingLeft: 25
            }
        },
        titleContainer: {
            display: 'flex'
        },
        assessmentIcon: {
            ...verticalCentering,
            marginTop: -5,
            marginRight: 15
        },
        titleText: {
            ...verticalCentering
        },
        links: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        },
        link: {
            color: '#009dd8',
            fontSize: '16pt',
            marginRight: 20,
            cursor: 'pointer',
            ...verticalCentering
        },
        sharedLink: {
            display: 'flex',
            marginRight: 20,
            color: '#4d586e'
        },
        sharedIcon: {
            ...verticalCentering,
            color: '#c4c4c4',
            marginRight: 10,
            '&.shared': {
                color: '#ea8511'
            }
        },
        sharedText: {
            ...verticalCentering,
            cursor: 'default',
            textAlign: 'center',
            marginRight: 10,
            width: 50
        },
        moreSettingsButton: {
            color: '#a2a6b2',
            cursor: 'pointer'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Tooltip":"7bRLE","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","resources/icons":"7BMUb","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","helpers/command":"f3cbG","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f5tfK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionBank);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _filters = require("./components/filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _questions = require("./components/questions");
var _questionsDefault = parcelHelpers.interopDefault(_questions);
const useStyles = (0, _material.makeStyles)(questionBankStyles);
function QuestionBank() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { quizSearch, quizQuestionBank, translate, updateState } = context;
    const searchingDone = !quizSearch['question-bank'];
    const questionsFound = quizQuestionBank.length > 0;
    (0, _reactDefault.default).useEffect(()=>{
        updateState({
            quizQuestionBankCart: {
                $set: []
            },
            quizQuestionBankCartEl: {
                $set: null
            }
        });
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.filters,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.container,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                    in: searchingDone,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.content, {
                            questionsFound
                        }),
                        children: [
                            !questionsFound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.noQuestionsFound,
                                children: translate('no-questions-found')
                            }),
                            questionsFound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionsDefault.default), {})
                        ]
                    })
                })
            })
        ]
    });
}
function questionBankStyles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            width: '100%'
        },
        noQuestionsFound: {
            flexGrow: 1,
            backgroundColor: '#f9f9f9',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
            fontSize: '28pt',
            color: '#8990a0',
            border: 'solid 1px #becfd7'
        },
        container: {
            display: 'flex',
            flexGrow: 1,
            overflow: 'hidden'
        },
        content: {
            padding: '10px 0',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            flexGrow: 1,
            '&.questionsFound': {
                padding: '10px 10px 10px 0',
                '&::-webkit-scrollbar': {
                    width: 6
                },
                '&::-webkit-scrollbar-track': {
                    background: '#fff',
                    padding: 2,
                    border: 'solid 1px #d3d3d3',
                    borderTop: 0,
                    borderBottom: 0
                }
            }
        },
        filters: {
            display: 'flex',
            backgroundColor: '#fff',
            border: 'solid 1px #becfd7'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","teacher/context":"5LKDx","./components/filters":"a2SP5","./components/questions":"k6uW6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a2SP5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionBankFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _repository = require("./repository");
var _repositoryDefault = parcelHelpers.interopDefault(_repository);
var _subject = require("./subject");
var _subjectDefault = parcelHelpers.interopDefault(_subject);
var _course = require("./course");
var _courseDefault = parcelHelpers.interopDefault(_course);
var _unit = require("./unit");
var _unitDefault = parcelHelpers.interopDefault(_unit);
var _lesson = require("./lesson");
var _lessonDefault = parcelHelpers.interopDefault(_lesson);
var _questionType = require("./question-type");
var _questionTypeDefault = parcelHelpers.interopDefault(_questionType);
var _pattern = require("./pattern");
var _patternDefault = parcelHelpers.interopDefault(_pattern);
var _addQuestion = require("./add-question");
var _addQuestionDefault = parcelHelpers.interopDefault(_addQuestion);
var _cart = require("./cart");
var _cartDefault = parcelHelpers.interopDefault(_cart);
var _filterChip = require("components/quiz/components/filter-chip");
var _filterChipDefault = parcelHelpers.interopDefault(_filterChip);
const useStyles = (0, _material.makeStyles)((0, _stylesDefault.default));
function QuestionBankFilters() {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { tab, link, linkQuery, translate, updateState } = context;
    const createFilterHandler = (name, mapQuery)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            const query = mapQuery ? mapQuery(context.query, value) : {
                ...context.query,
                [name]: value
            };
            history.push(linkQuery(link('quiz', tab), {
                ...query,
                page: 1
            }));
        };
    function clearStandardFilters() {
        updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: {
                expectations: {
                    $set: []
                },
                indicators: {
                    $set: []
                },
                standards: {
                    $set: []
                }
            }
        });
    }
    const from = context.link('quiz', 'question-bank');
    const hasStandardsChip = Object.values(context.quizStandardFilters).some((a)=>a.length > 0);
    const hasChips = !(!context.query.pattern && !context.query.id && !hasStandardsChip);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.filters,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.top,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _repositoryDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('repository')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _patternDefault.default), {
                        classes: classes
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.filler
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.bottom,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subjectDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('subject', (query, subject)=>({
                                ...query,
                                course: undefined,
                                unit: undefined,
                                lesson: undefined,
                                subject
                            }))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _courseDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('course', (query, course)=>{
                            return course ? {
                                ...query,
                                course,
                                subject: course.substring(0, 2),
                                unit: undefined,
                                lesson: undefined
                            } : {
                                ...query,
                                course: undefined,
                                unit: undefined,
                                lesson: undefined
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('unit', (query, unit)=>{
                            return unit ? {
                                ...query,
                                unit
                            } : {
                                ...query,
                                unit: undefined,
                                lesson: undefined
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('lesson', (query, lesson)=>{
                            return lesson ? {
                                ...query,
                                lesson
                            } : {
                                ...query,
                                lesson: undefined
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionTypeDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('type')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.filler
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addQuestionDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.chips, {
                    hasChips
                }),
                children: [
                    context.query.pattern && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "pattern",
                        context: context,
                        from: from
                    }),
                    context.query.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "id",
                        context: context,
                        createLabel: ()=>translate('new-bank-question'),
                        from: from
                    }),
                    hasStandardsChip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "standards",
                        context: context,
                        createLabel: ()=>translate('standards-filter-chip'),
                        from: from,
                        onDelete: clearStandardFilters
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","teacher/context":"5LKDx","./styles":"4kNr7","./repository":"9AUCY","./subject":"9H1rE","./course":"2oXF8","./unit":"b2ngk","./lesson":"aesCA","./question-type":"i4AOQ","./pattern":"kJaL0","./add-question":"dk6HT","./cart":"2kfFP","components/quiz/components/filter-chip":"i3UT5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kNr7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filterStyles);
function filterStyles(theme) {
    return {
        filters: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column'
        },
        top: {
            display: 'flex',
            padding: '15px 10px 0 20px'
        },
        filler: {
            flexGrow: 1
        },
        bottom: {
            display: 'flex',
            padding: '0 10px 15px 20px'
        },
        select: {
            marginLeft: 15,
            width: 165,
            '&:first-child': {
                marginLeft: 0
            }
        },
        patternFilter: {
            display: 'flex',
            marginLeft: 15,
            paddingTop: 15
        },
        patternInput: {
            borderRadius: 5,
            border: 'solid 1px #becfd7'
        },
        standardsSearch: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 8
        },
        standardsSearchLink: {
            color: '#009dd8',
            fontSize: '9.5pt'
        },
        chips: {
            display: 'none',
            '&.hasChips': {
                display: 'flex',
                borderTop: 'solid 1px #becfd7',
                display: 'flex',
                padding: '10px 15px'
            },
            '& .filter-chip': {
                backgroundColor: '#de3434',
                color: '#fff',
                '& .MuiChip-label': {
                    padding: '0 20px'
                },
                '& .MuiChip-deleteIcon': {}
            }
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9AUCY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RepositoryFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function RepositoryFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _clearableSelectDefault.default), {
        id: "question-bank-repository-filter",
        className: (0, _clsxDefault.default)(classes.select, "repository"),
        value: context.query.repository || "",
        onChange: onChange,
        caption: translate('repository'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: "dreyfous",
                children: translate('dreyfous')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: "institution",
                children: translate('institution')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: "personal",
                children: translate('personal')
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9H1rE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubjectFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function SubjectFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { myCourses: courses, translate } = context;
    const mySubjects = (0, _lodash.uniq)(courses.map(({ course })=>course.substring(0, 2)));
    const subjects = context.subjects.filter(({ id })=>mySubjects.indexOf(id) >= 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-subject-filter",
        className: (0, _clsxDefault.default)(classes.select, "subject"),
        value: context.query.subject || "",
        caption: translate('subject_label'),
        onChange: onChange,
        children: subjects.map((subject, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: subject.id,
                children: subject.name
            }, key))
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2oXF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _lodash = require("external/lodash");
var _context = require("teacher/context");
var _quiz = require("helpers/quiz");
function CourseFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { myCourses, query, translate } = context;
    const courses = query.subject ? myCourses.filter(({ course })=>course.substring(0, 2) == query.subject) : myCourses;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-course-filter",
        className: (0, _clsxDefault.default)(classes.select, "course"),
        value: query.course || "",
        onChange: onChange,
        caption: translate('course_assessment_header'),
        children: (0, _lodash.orderBy)(courses, [
            'course'
        ]).map((course, key)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: course.course,
                children: (0, _quiz.selectCourseLabel)(course)
            }, key);
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","external/lodash":"5bCAQ","teacher/context":"5LKDx","helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2ngk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UnitFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function UnitFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, translate } = context;
    const units = context.query.course && context.units ? context.units : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-unit-filter",
        className: (0, _clsxDefault.default)(classes.select, "unit"),
        value: query.unit || "",
        onChange: onChange,
        caption: translate('unitName-header'),
        children: units.map((unit, key)=>{
            const name = `${(key + 1).toString().padStart(2, '0')} - ${unit.name}`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: unit.id,
                children: name
            }, key);
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aesCA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LessonFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function LessonFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, translate } = context;
    const lessons = context.query.unit && context.lessons ? context.lessons : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-lesson-filter",
        className: (0, _clsxDefault.default)(classes.select, "lesson"),
        value: query.lesson || "",
        onChange: onChange,
        caption: translate('lesson-header'),
        children: lessons.map((lesson, key)=>{
            const name = `${(key + 1).toString().padStart(2, '0')} - ${lesson.name}`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: lesson.id,
                children: name
            }, key);
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4AOQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionTypeFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function QuestionTypeFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, translate, quizQuestionTypes: questionTypes } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-type-filter",
        className: (0, _clsxDefault.default)(classes.select, "question-type"),
        value: query.type || "",
        onChange: onChange,
        caption: translate('question-type'),
        children: questionTypes.map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: type.id,
                children: translate(type.name)
            }, type.id))
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kJaL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PatternFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _activeFiltersCjs = require("components/standards-selector/domain/active-filters.cjs");
var _reactRouterDom = require("react-router-dom");
var _searchPattern = require("components/quiz/components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
function PatternFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, quizQuestionTypes: questionTypes } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.patternFilter,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.pattern,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                    path: context.link(),
                    context: context
                })
            }),
            !(0, _activeFiltersCjs.hasActiveStandardsFilter)(context.quizStandardFilters) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.standardsSearch,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: context.link({
                        sectionName: 'standards-search'
                    }, '/:languageId/:role/:page/:tab/:sectionName', {
                        preserveQuery: true
                    }),
                    className: classes.standardsSearchLink,
                    children: translate('standards-search')
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/standards-selector/domain/active-filters.cjs":"9Ycmg","react-router-dom":"3uzXR","components/quiz/components/search-pattern":"gUgIQ","@mui/material/Box":"73kto","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dk6HT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _quiz = require("helpers/quiz");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(addQuestionStyles);
function AddQuestion() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, quizQuestionTypes, updateState, link, linkQuery } = context;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    async function addQuestion(questionType) {
        const [data] = await (0, _commandDefault.default)('quiz', 'generateQuestion')({
            type: questionType.id
        });
        if (data) {
            const init = (0, _quiz.initQuestion)(context);
            updateState({
                quizNewBankQuestion: {
                    $set: init({
                        ...data,
                        isNew: true
                    })
                }
            });
            history.push(link({
                questionId: data.id,
                sectionName: 'new-question'
            }, '/:languageId/:role/:page/:tab/:sectionName/:questionId'));
        }
        handleClose();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                className: classes.button,
                startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {}),
                onClick: handleClick,
                children: translate('add-to-question-bank')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
                id: "customized-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: quizQuestionTypes.map((type, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: ()=>addQuestion(type),
                        children: translate(type.name)
                    }, index))
            })
        ]
    });
}
function addQuestionStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginTop: 16
        },
        button: {
            padding: '4px 10px',
            backgroundColor: '#2ca5ec',
            color: '#fff',
            textTransform: 'capitalize',
            '& .MuiButton-startIcon': {
                marginRight: 3
            },
            '&:hover': {
                backgroundColor: '#12608e'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/icons-material/Add":"jrNj7","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","helpers/command":"f3cbG","helpers/quiz":"2gdOk","@mui/material/Box":"73kto","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kfFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Cart);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _form = require("components/quiz/content/create-assessment/form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _cartPopper = require("./cart-popper");
var _cartPopperDefault = parcelHelpers.interopDefault(_cartPopper);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(cartStyles);
function Cart() {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { quizQuestionBankCart: cart, quizQuestionBankCartEl, updateState } = context;
    const count = cart.length;
    const hasQuestions = count > 0;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const handleClick = (event)=>{
        hasQuestions && updateState({
            quizQuestionBankCartEl: {
                $apply: (el)=>el ? null : event.currentTarget
            }
        });
    };
    const isCartOpen = Boolean(quizQuestionBankCartEl);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartPopperDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)(classes.button, {
                        hasQuestions
                    }),
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faShoppingBasket)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.count,
                            children: count
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {
                context: context,
                useCart: true
            })
        ]
    });
}
function cartStyles() {
    return {
        root: {
            marginTop: 16,
            fontSize: '11pt',
            '& svg': {
                marginTop: 2,
                marginRight: 8
            }
        },
        count: {},
        button: {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: '#f4f4f4',
            padding: '4px 10px',
            borderRadius: 8,
            color: '#cbc4c4',
            "&.hasQuestions": {
                color: '#fff',
                cursor: 'pointer',
                backgroundColor: '#76c278'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","components/quiz/content/create-assessment/form":"2aP1U","@mui/material/Box":"73kto","./cart-popper":"gtAfV","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtAfV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CartPopper);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _popper = require("@mui/material/Popper");
var _popperDefault = parcelHelpers.interopDefault(_popper);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _context = require("teacher/context");
var _createExamn = require("./create-examn");
var _createExamnDefault = parcelHelpers.interopDefault(_createExamn);
var _cartQuestion = require("./cart-question");
var _cartQuestionDefault = parcelHelpers.interopDefault(_cartQuestion);
const useStyles = (0, _material.makeStyles)(cartPopperStyles);
const useToolTipStyles = (0, _material.makeStyles)(tooltipStyles);
function CartPopper(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = useStyles();
    const tooltipClasses = useToolTipStyles();
    const { quizQuestionBankCart: cart, translate, quizQuestionBankCartEl, updateState } = context;
    const open = Boolean(quizQuestionBankCartEl);
    const handleTooltipClose = ()=>updateState({
            quizQuestionBankCartEl: {
                $set: null
            }
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
        classes: tooltipClasses,
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.paper,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.header,
                    children: translate('selected-questions')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.questions,
                    children: cart.map((question, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cartQuestionDefault.default), {
                            index,
                            ...question
                        }, index))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.create,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createExamnDefault.default), {})
                })
            ]
        }),
        onClose: handleTooltipClose,
        open: open,
        arrow: true,
        interactive: true,
        disableHoverListener: true,
        disableFocusListener: true,
        disableTouchListener: true,
        children: props.children
    });
}
function tooltipStyles(theme) {
    return {
        popperInteractive: {
            display: 'flex',
            maxHeight: '80%'
        },
        tooltip: {
            fontSize: '11pt',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            border: 'solid 1px rgb(99 96 96 / 90%)',
            padding: 0,
            maxWidth: 400,
            minWidth: 300,
            '& > div': {
                border: 0
            },
            '& .header': {
                padding: 5,
                display: 'flex',
                justifyContent: 'flex-end'
            },
            '& .close': {
                color: 'rgb(99 96 96 / 90%)',
                cursor: 'pointer'
            }
        }
    };
}
function cartPopperStyles(theme) {
    return {
        paper: {
            display: 'flex',
            overflowY: 'hidden',
            flexDirection: 'column',
            maxWidth: 600,
            minWidth: 400,
            minHeight: 300,
            maxHeight: 450,
            background: '#fff',
            border: 'solid 1px #bfcdd8',
            borderRadius: 5,
            marginTop: 5
        },
        header: {
            padding: '12px 8px',
            color: '#71768c',
            borderBottom: 'solid 1px #bfcdd8'
        },
        questions: {
            padding: '9px',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto'
        },
        create: {
            display: 'flex',
            padding: 8,
            borderTop: 'solid 1px #bfcdd8'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Popper":"lX4bO","@mui/material/Box":"73kto","@mui/material/Tooltip":"7bRLE","teacher/context":"5LKDx","./create-examn":"1lOTD","./cart-question":"FAZnS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1lOTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateExamn);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(createExamnStyles);
function CreateExamn() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, quizQuestionTypes, updateState, link, linkQuery, updateStae } = context;
    const handleClick = (event)=>{
        updateState({
            quizQuestionBankCartEl: {
                $set: null
            },
            quizDialogs: {
                'create-assessment': {
                    $set: true
                }
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            className: classes.button,
            startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {}),
            onClick: handleClick,
            children: translate('create')
        })
    });
}
function createExamnStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            justifyContent: 'center'
        },
        button: {
            padding: '4px 10px',
            backgroundColor: '#62c874',
            color: '#fff',
            textTransform: 'capitalize',
            '& .MuiButton-startIcon': {
                marginRight: 3
            },
            '&:hover': {
                backgroundColor: '#29652c'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/icons-material/Add":"jrNj7","helpers/command":"f3cbG","@mui/material/Box":"73kto","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"FAZnS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CartQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _highlightOff = require("@mui/icons-material/HighlightOff");
var _highlightOffDefault = parcelHelpers.interopDefault(_highlightOff);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _context = require("teacher/context");
var _utils = require("helpers/utils");
var _previewQuestionTooltip = require("./preview-question-tooltip");
var _previewQuestionTooltipDefault = parcelHelpers.interopDefault(_previewQuestionTooltip);
const useStyles = (0, _material.makeStyles)(cartPopperStyles);
function CartQuestion(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = useStyles();
    const { translate, quizQuestionBankCart: cart, updateState } = context;
    const { index, textpremise, typeName } = props;
    const premiseLabel = (0, _utils.isEmpty)(textpremise) ? translate(typeName) : textpremise;
    const [open, setOpen] = (0, _reactDefault.default).useState(false);
    const removeQuestion = ()=>{
        const updateCommand = cart.length == 1 ? {
            quizQuestionBankCart: {
                $splice: [
                    [
                        index,
                        1
                    ]
                ]
            },
            quizQuestionBankCartEl: {
                $set: null
            }
        } : {
            quizQuestionBankCart: {
                $splice: [
                    [
                        index,
                        1
                    ]
                ]
            }
        };
        updateState(updateCommand);
    };
    const handleTooltipClose = ()=>{
        setOpen(false);
    };
    const handleTooltipOpen = ()=>{
        setOpen(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.question,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.questionHeader,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.removeQuestion,
                    onClick: removeQuestion,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.removeQuestionButton,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faMinusCircle)
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.questionPremise,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                        text: premiseLabel,
                        maxLine: 2,
                        ellipsis: "...",
                        trimRight: true,
                        basedOn: "letters"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.questionFooter,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewQuestionTooltipDefault.default), {
                        ...props
                    })
                })
            ]
        })
    });
}
function cartPopperStyles(theme) {
    return {
        question: {
            marginTop: 4,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            borderRadius: '3px',
            border: '1px solid #bfcdd8',
            color: '#4f5670',
            padding: 0,
            "&:first-child": {
                marginTop: 3
            },
            "&:last-child": {
                marginBottom: 3
            },
            "&:hover": {
                backgroundColor: '#f4f4f4'
            }
        },
        questionHeader: {
            display: 'inline-flex',
            position: 'relative',
            justifyContent: 'end'
        },
        questionFooter: {
            fontSize: 16,
            margin: 'auto 6px',
            width: '7%'
        },
        questionPremise: {
            padding: 9,
            width: '88%',
            maxHeight: '35px'
        },
        removeQuestion: {
            margin: 'auto 6px',
            width: '4%',
            textAlign: 'center'
        },
        removeQuestionButton: {
            cursor: 'pointer',
            color: '#d33d60'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/icons-material/HighlightOff":"afUuo","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"joPR3","react-lines-ellipsis":"ikp0X","teacher/context":"5LKDx","helpers/utils":"gGc98","./preview-question-tooltip":"bSf6o","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"afUuo":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("dcf8064735de4cc9");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("15ba16bbd3f4e545"));
var _jsxRuntime = require("e6bda49c3e2c6fd");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'HighlightOff');

},{"dcf8064735de4cc9":"kZ6eK","15ba16bbd3f4e545":"2vOnF","e6bda49c3e2c6fd":"1dlk8"}],"bSf6o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewQuestionTooltip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _previewQuestion = require("components/quiz/components/preview-question");
var _previewQuestionDefault = parcelHelpers.interopDefault(_previewQuestion);
var _context = require("teacher/context");
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
const styles = (theme)=>({
        root: {
            zIndex: '2000 !important'
        },
        closeButton: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500]
        }
    });
const useStyles = (0, _material.makeStyles)(styles);
function PreviewQuestionTooltip(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = useStyles();
    const [open, setOpen] = (0, _react.useState)(false);
    const { translate } = context;
    const handleClose = ()=>{
        setOpen(false);
    };
    const handleOpen = ()=>{
        setOpen(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                onClick: handleOpen,
                className: classes.link,
                children: [
                    " ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        className: "icon",
                        icon: (0, _freeSolidSvgIcons.faEye)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
                fullWidth: true,
                maxWidth: 'md',
                open: open,
                onClose: handleClose,
                "aria-labelledby": "form-dialog-title",
                className: classes.root,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                        id: classes.title,
                        children: [
                            translate('preview'),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                "aria-label": "close",
                                className: classes.closeButton,
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewQuestionDefault.default), {
                            headless: true,
                            showPoints: true,
                            showStandards: true,
                            context: context,
                            question: props
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"joPR3","@mui/material/Dialog":"255tO","@mui/material/DialogContent":"gD0J9","@mui/material/DialogTitle":"5sOv1","components/quiz/components/preview-question":"4tE9v","teacher/context":"5LKDx","@mui/material/IconButton":"bXjnZ","@mui/icons-material/Close":"acjz6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4tE9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _material = require("external/material");
var _context = require("teacher/context");
var _index = require("../preview-questions/matching/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _index1 = require("../preview-questions/fill-in-the-blanks/index");
var _indexDefault1 = parcelHelpers.interopDefault(_index1);
var _index2 = require("../preview-questions/multiple-choice/index");
var _indexDefault2 = parcelHelpers.interopDefault(_index2);
var _index3 = require("../preview-questions/open-question/index");
var _indexDefault3 = parcelHelpers.interopDefault(_index3);
var _index4 = require("../preview-questions/true-or-false/index");
var _indexDefault4 = parcelHelpers.interopDefault(_index4);
const questionHandlers = {
    'matching': (0, _indexDefault.default),
    'fill-in-the-blanks': (0, _indexDefault1.default),
    'multiple-choice': (0, _indexDefault2.default),
    'open-question': (0, _indexDefault3.default),
    'true-or-false': (0, _indexDefault4.default)
};
const useStandardStyles = (0, _material.makeStyles)(standardStyles);
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 4,
            backgroundColor: '#fff',
            flexGrow: 1,
            color: '#4e566d',
            fontSize: '12pt',
            "& > .header": {
                padding: '10px 15px',
                borderBottom: 'solid 1px #dfdfdf',
                borderTopLeftRadius: 4,
                borderTopRightRadius: 4,
                backgroundColor: '#1d9be5',
                color: '#fff'
            },
            "& > .content": {
                flexGrow: 1
            },
            "& > .points": {
                padding: "20px 15px",
                display: "flex",
                "& > div": {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center"
                },
                "& .points-label": {
                    marginRight: 4
                },
                "& .points-value": {
                    marginTop: 2
                }
            }
        }
    }));
function PreviewQuestion({ context, question, headless, showPoints }) {
    const classes = useStyles();
    const { translate, quizQuestionTypes } = context;
    const { id, properties = {}, type } = question;
    const loaded = id != undefined;
    const questionType = quizQuestionTypes.find((t)=>t.id == type) || {};
    const Handler = questionHandlers[questionType.name];
    const titleLabel = (properties.title || '') == '' ? translate(questionType.name) : properties.title;
    return(// <Fade in={loaded}>
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "section"),
        children: [
            !headless && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "header",
                children: titleLabel
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "content",
                children: Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                    question: question,
                    context: context
                })
            }),
            showPoints && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "points",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "points-label",
                        children: [
                            translate('points'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "points-value",
                        children: question.value
                    })
                ]
            })
        ]
    }));
}
function Standards({ question }) {
    const classes = useStandardStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    const { standards = [] } = question.properties || {};
    const sortedStandards = (0, _lodash.sortBy)(standards, (s)=>{
        const iteratee = `${s.expectation || s.id}-${s.code || '00'}`;
        return iteratee;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.standardsLabel,
                children: [
                    translate('standards'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.standards,
                children: sortedStandards.map((standard, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Standard, {
                        index: index,
                        ...standard
                    }, index))
            })
        ]
    });
}
function Standard(props) {
    const classes = useStandardStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    const { id, code, description } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classes.standard,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _clsxDefault.default)(classes.item, classes.content),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: classes.code,
                    children: code == undefined ? translate("expectation") : code
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: classes.description,
                    title: description,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                        text: description,
                        maxLine: 3,
                        ellipsis: "...",
                        trimRight: true,
                        basedOn: "letters"
                    })
                })
            ]
        })
    });
}
function standardStyles(theme) {
    return {
        standardsLabel: {
            paddingLeft: 15
        },
        standard: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            borderBottom: 'solid 1px #e2ecf2',
            "&:last-child": {
                borderBottom: 'none'
            }
        },
        item: {
            display: 'flex',
            flexDirection: 'column'
        },
        content: {
            cursor: 'default',
            flexGrow: 1,
            color: '#4e576e',
            overflowX: 'hidden',
            padding: '8px 10px 20px 20px'
        },
        code: {
            textTransform: 'uppercase',
            fontWeight: 'bold'
        },
        description: {
            color: '#838999',
            fontSize: '10.5pt',
            wordWrap: 'break-word'
        },
        actions: {
            justifyContent: 'center',
            paddingRight: 10
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","react-lines-ellipsis":"ikp0X","external/material":"6yEDE","teacher/context":"5LKDx","../preview-questions/matching/index":"aTqNt","../preview-questions/fill-in-the-blanks/index":"beBvQ","../preview-questions/multiple-choice/index":"04xAJ","../preview-questions/open-question/index":"am3AU","../preview-questions/true-or-false/index":"k8teh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aTqNt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MatchingQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function shuffleArray(array = []) {
    return array.reduce((array, element, index, src)=>{
        const i = src.length - 1 - index;
        const j = Math.floor(Math.random() * (i + 1));
        if (i == j) return array;
        else {
            const a = array[i];
            const b = array[j];
            return (0, _immutabilityHelperDefault.default)(array, {
                $splice: [
                    [
                        i,
                        1
                    ],
                    [
                        i,
                        0,
                        b
                    ],
                    [
                        j,
                        1
                    ],
                    [
                        j,
                        0,
                        a
                    ]
                ]
            });
        }
    }, array);
}
function MatchingQuestion({ context, question }) {
    const { answer, premise } = question;
    const [state, setState] = (0, _reactDefault.default).useState({
        terms: [],
        definitions: [],
        selected: []
    });
    const classes = (0, _stylesDefault.default)();
    const premiseText = premise.html || '';
    function handleChange(term, definition) {
        setState((0, _immutabilityHelperDefault.default)(state, {
            selected: {
                [state.selected.indexOf(definition)]: {
                    $set: -1
                },
                [term]: {
                    $set: definition
                }
            }
        }));
    }
    (0, _reactDefault.default).useEffect(()=>{
        if (answer.choices) {
            const definitions = shuffleArray(answer.choices.map(([_, definition], index)=>({
                    definition,
                    index
                })));
            const terms = shuffleArray(answer.choices.map(([term], index)=>({
                    term,
                    index
                })));
            const selected = terms.map(({ term }, index)=>-1);
            if (terms.length > 0) terms.map((term, index)=>{
                selected[index] = definitions.findIndex((def)=>def.index === term.index);
            });
            setState({
                terms,
                definitions,
                selected
            });
        }
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Grid, {
        className: (0, _clsxDefault.default)(classes.root, "question", "matching"),
        container: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Grid, {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                item: true,
                xs: 12,
                children: premiseText != '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "instructions",
                    dangerouslySetInnerHTML: {
                        __html: premiseText
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Grid, {
                item: true,
                xs: 12,
                container: true,
                children: state.terms.map((term, index)=>{
                    const answerIndex = String.fromCharCode(Math.min(index, 20) + 65);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Grid, {
                                className: "term",
                                item: true,
                                xs: 6,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectDefinition, {
                                        index: index,
                                        definitions: state.definitions,
                                        onChange: handleChange,
                                        value: state.selected[index]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value",
                                        dangerouslySetInnerHTML: {
                                            __html: term.term || ''
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Grid, {
                                item: true,
                                xs: 6,
                                className: "definitions",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Grid, {
                                    className: (0, _clsxDefault.default)("definition", {
                                        selected: state.selected.indexOf(state.definitions[index].index) > -1
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            className: "index",
                                            children: answerIndex
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "value",
                                            dangerouslySetInnerHTML: {
                                                __html: state.definitions[index].definition || ''
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
}
function SelectDefinition(props) {
    function handleChange(e) {
        props.onChange(props.index, e.target.value);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
        variant: "standard",
        className: "select-definition",
        value: props.value,
        onChange: handleChange,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                style: {
                    display: 'none'
                },
                value: -1,
                children: " "
            }),
            props.definitions.map((definition, index)=>{
                const answerIndex = String.fromCharCode(Math.min(index, 20) + 65);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                    value: index,
                    children: answerIndex
                }, index);
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/Select":"aY7hn","./styles":"lHEgY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lHEgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            padding: 30,
            "& .definitions": {
                minWidth: 300,
                flexGrow: 1,
                padding: '9px 0'
            },
            "& .terms": {
                minWidth: 300,
                flexGrow: 1,
                paddingRight: '10px'
            },
            "& .term": {
                display: 'flex',
                margin: 'auto 0'
            },
            "& .index": {
                textTransform: 'lowercase',
                fontWeight: 'bold',
                marginRight: 10
            },
            "& .value": {
                ...verticalCentering
            },
            "& .select-definition": {
                marginRight: 10,
                height: 50
            },
            "& .definition": {
                display: "flex",
                margin: '8px 0 8px 16px',
                "&.selected": {
                    opacity: 0.5
                }
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beBvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewFillInTheBlanksQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function PreviewFillInTheBlanksQuestion({ index, context, question }) {
    const classes = (0, _stylesDefault.default)();
    const [phrases, setPhrases] = (0, _reactDefault.default).useState([]);
    (0, _reactDefault.default).useEffect(()=>{
        const { phrases = [] } = question.answer;
        setPhrases(phrases);
    }, [
        question.answer
    ]);
    function handlePhraseChange(index, phrase) {
        setPhrases((0, _immutabilityHelperDefault.default)(phrases, {
            [index]: {
                phrase: {
                    $set: phrase
                }
            }
        }));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "fill-in-the-blanks"),
        children: phrases.map(({ phrase, blanked }, index)=>blanked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: (0, _clsxDefault.default)("phrase", "input"),
                type: "text",
                value: phrase,
                onChange: (e)=>handlePhraseChange(index, e.target.value)
            }, index) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)("phrase", "word"),
                children: phrase
            }, index))
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","./styles":"gZ6L8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gZ6L8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            padding: '35px 20px',
            fontSize: '12pt',
            '& .phrase': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginTop: 5,
                marginRight: 5,
                '&:last-child': {
                    marginLeft: 0
                }
            },
            '& .input': {
                border: 'none',
                borderBottom: 'solid 1px black'
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04xAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewMultipleChoiceQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _radioChoice = require("./radio-choice");
var _radioChoiceDefault = parcelHelpers.interopDefault(_radioChoice);
var _checkboxChoice = require("./checkbox-choice");
var _checkboxChoiceDefault = parcelHelpers.interopDefault(_checkboxChoice);
function PreviewMultipleChoiceQuestion({ context, question }) {
    const { translate, quizQuestions = {} } = context;
    const classes = (0, _stylesDefault.default)();
    const { properties, premise, answer } = question;
    const { choices = [] } = answer;
    console.log(answer);
    const premiseText = question.premise.html || '';
    const Choices = question.properties.singleOption ? (0, _radioChoiceDefault.default) : (0, _checkboxChoiceDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "multiple-choice"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: [
                    premiseText != '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        dangerouslySetInnerHTML: {
                            __html: premiseText
                        }
                    }),
                    premiseText == '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)('warning', 'missing-premise'),
                        children: translate('missing-premise')
                    })
                ]
            }),
            choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
                question: question,
                context: context,
                choices: choices
            }),
            choices.length < 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)('warning', 'missing-choices'),
                children: translate('missing-choices')
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","./styles":"fMxmP","./radio-choice":"37O33","./checkbox-choice":"5LIFm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMxmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            padding: 20,
            flexDirection: 'column',
            '& .choices': {}
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37O33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RadioChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
function RadioChoice({ context, question, choices }) {
    const [value, setValue] = (0, _reactDefault.default).useState('');
    function handleChange(e) {
        setValue(e.target.value);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: value,
        onChange: handleChange,
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 65);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                value: `${index}`,
                className: "choice",
                checked: choice.correct,
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "choice-caption",
                    dangerouslySetInnerHTML: {
                        __html: choice.html || ''
                    }
                })
            }, index);
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bneRF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _radioDefault.default));
parcelHelpers.export(exports, "radioClasses", ()=>(0, _radioClassesDefault.default));
var _radio = require("./Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioClasses = require("./radioClasses");
var _radioClassesDefault = parcelHelpers.interopDefault(_radioClasses);
parcelHelpers.exportAll(_radioClasses, exports);
'use client';

},{"./Radio":"6WvVu","./radioClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6WvVu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _refType = require("@mui/utils/refType");
var _refTypeDefault = parcelHelpers.interopDefault(_refType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _switchBase = require("../internal/SwitchBase");
var _switchBaseDefault = parcelHelpers.interopDefault(_switchBase);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _radioButtonIcon = require("./RadioButtonIcon");
var _radioButtonIconDefault = parcelHelpers.interopDefault(_radioButtonIcon);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _createChainedFunction = require("../utils/createChainedFunction");
var _createChainedFunctionDefault = parcelHelpers.interopDefault(_createChainedFunction);
var _useRadioGroup = require("../RadioGroup/useRadioGroup");
var _useRadioGroupDefault = parcelHelpers.interopDefault(_useRadioGroup);
var _radioClasses = require("./radioClasses");
var _radioClassesDefault = parcelHelpers.interopDefault(_radioClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, color, size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalizeDefault.default)(color)}`,
            size !== 'medium' && `size${(0, _capitalizeDefault.default)(size)}`
        ]
    };
    return (0, _extendsDefault.default)({}, classes, (0, _composeClassesDefault.default)(slots, (0, _radioClasses.getRadioUtilityClass), classes));
};
const RadioRoot = (0, _styledDefault.default)((0, _switchBaseDefault.default), {
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, _colorManipulator.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, _radioClassesDefault.default).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, _radioClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const defaultCheckedIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioButtonIconDefault.default), {
    checked: true
});
const defaultIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioButtonIconDefault.default), {});
const Radio = /*#__PURE__*/ _react.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon = defaultCheckedIcon, color = 'primary', icon = defaultIcon, name: nameProp, onChange: onChangeProp, size = 'medium', className } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        size
    });
    const classes = useUtilityClasses(ownerState);
    const radioGroup = (0, _useRadioGroupDefault.default)();
    let checked = checkedProp;
    const onChange = (0, _createChainedFunctionDefault.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioRoot, (0, _extendsDefault.default)({
        type: "radio",
        icon: /*#__PURE__*/ _react.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ _react.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className)
    }, other));
});
exports.default = Radio;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/refType":"7a8uL","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../internal/SwitchBase":"8FNiy","../DefaultPropsProvider":"ff3VX","./RadioButtonIcon":"lvyoH","../utils/capitalize":"hBZko","../utils/createChainedFunction":"8CRq6","../RadioGroup/useRadioGroup":"b4oTH","./radioClasses":"aulnp","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvyoH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _radioButtonUnchecked = require("../internal/svg-icons/RadioButtonUnchecked");
var _radioButtonUncheckedDefault = parcelHelpers.interopDefault(_radioButtonUnchecked);
var _radioButtonChecked = require("../internal/svg-icons/RadioButtonChecked");
var _radioButtonCheckedDefault = parcelHelpers.interopDefault(_radioButtonChecked);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const RadioButtonIconRoot = (0, _styledDefault.default)('span', {
    shouldForwardProp: (0, _styled.rootShouldForwardProp)
})({
    position: 'relative',
    display: 'flex'
});
const RadioButtonIconBackground = (0, _styledDefault.default)((0, _radioButtonUncheckedDefault.default))({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const RadioButtonIconDot = (0, _styledDefault.default)((0, _radioButtonCheckedDefault.default))(({ theme, ownerState })=>(0, _extendsDefault.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function RadioButtonIcon(props) {
    const { checked = false, classes = {}, fontSize } = props;
    const ownerState = (0, _extendsDefault.default)({}, props, {
        checked
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
exports.default = RadioButtonIcon;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","../internal/svg-icons/RadioButtonUnchecked":"dBUfl","../internal/svg-icons/RadioButtonChecked":"k1DSf","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dBUfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1DSf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4oTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRadioGroup);
var _react = require("react");
var _radioGroupContext = require("./RadioGroupContext");
var _radioGroupContextDefault = parcelHelpers.interopDefault(_radioGroupContext);
'use client';
function useRadioGroup() {
    return _react.useContext((0, _radioGroupContextDefault.default));
}

},{"react":"9njXz","./RadioGroupContext":"cbwi6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cbwi6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/**
 * @ignore - internal component.
 */ const RadioGroupContext = /*#__PURE__*/ _react.createContext(undefined);
exports.default = RadioGroupContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aulnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRadioUtilityClass", ()=>getRadioUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getRadioUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiRadio', slot);
}
const radioClasses = (0, _generateUtilityClassesDefault.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
exports.default = radioClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9W1hX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _radioGroupDefault.default));
parcelHelpers.export(exports, "useRadioGroup", ()=>(0, _useRadioGroupDefault.default));
parcelHelpers.export(exports, "radioGroupClasses", ()=>(0, _radioGroupClassesDefault.default));
var _radioGroup = require("./RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _useRadioGroup = require("./useRadioGroup");
var _useRadioGroupDefault = parcelHelpers.interopDefault(_useRadioGroup);
var _radioGroupClasses = require("./radioGroupClasses");
var _radioGroupClassesDefault = parcelHelpers.interopDefault(_radioGroupClasses);
parcelHelpers.exportAll(_radioGroupClasses, exports);
'use client';

},{"./RadioGroup":"kk7zo","./useRadioGroup":false,"./radioGroupClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kk7zo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _formGroup = require("../FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _radioGroupClasses = require("./radioGroupClasses");
var _useForkRef = require("../utils/useForkRef");
var _useForkRefDefault = parcelHelpers.interopDefault(_useForkRef);
var _useControlled = require("../utils/useControlled");
var _useControlledDefault = parcelHelpers.interopDefault(_useControlled);
var _radioGroupContext = require("./RadioGroupContext");
var _radioGroupContextDefault = parcelHelpers.interopDefault(_radioGroupContext);
var _useId = require("../utils/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const useUtilityClasses = (props)=>{
    const { classes, row, error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _radioGroupClasses.getRadioGroupUtilityClass), classes);
};
const RadioGroup = /*#__PURE__*/ _react.forwardRef(function RadioGroup(props, ref) {
    const { // private
    // eslint-disable-next-line react/prop-types
    actions, children, className, defaultValue, name: nameProp, onChange, value: valueProp } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const rootRef = _react.useRef(null);
    const classes = useUtilityClasses(props);
    const [value, setValueState] = (0, _useControlledDefault.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    _react.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, _useForkRefDefault.default)(ref, rootRef);
    const name = (0, _useIdDefault.default)(nameProp);
    const contextValue = _react.useMemo(()=>({
            name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupContextDefault.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), (0, _extendsDefault.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, _clsxDefault.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
exports.default = RadioGroup;

},{"@babel/runtime/helpers/esm/extends":"aAOJb","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../FormGroup":"1gJha","./radioGroupClasses":"8gukz","../utils/useForkRef":"cq8Sn","../utils/useControlled":"1VreF","./RadioGroupContext":"cbwi6","../utils/useId":"iMSy2","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1gJha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _formGroupDefault.default));
parcelHelpers.export(exports, "formGroupClasses", ()=>(0, _formGroupClassesDefault.default));
var _formGroup = require("./FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _formGroupClasses = require("./formGroupClasses");
var _formGroupClassesDefault = parcelHelpers.interopDefault(_formGroupClasses);
parcelHelpers.exportAll(_formGroupClasses, exports);
'use client';

},{"./FormGroup":"bufYi","./formGroupClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bufYi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _formGroupClasses = require("./formGroupClasses");
var _useFormControl = require("../FormControl/useFormControl");
var _useFormControlDefault = parcelHelpers.interopDefault(_useFormControl);
var _formControlState = require("../FormControl/formControlState");
var _formControlStateDefault = parcelHelpers.interopDefault(_formControlState);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "row"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, row, error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _formGroupClasses.getFormGroupUtilityClass), classes);
};
const FormGroupRoot = (0, _styledDefault.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState })=>(0, _extendsDefault.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const FormGroup = /*#__PURE__*/ _react.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className, row = false } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const muiFormControl = (0, _useFormControlDefault.default)();
    const fcs = (0, _formControlStateDefault.default)({
        props,
        muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, _extendsDefault.default)({}, props, {
        row,
        error: fcs.error
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FormGroupRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
exports.default = FormGroup;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./formGroupClasses":"4LcD6","../FormControl/useFormControl":"H1I5Z","../FormControl/formControlState":"lhkcI","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4LcD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFormGroupUtilityClass", ()=>getFormGroupUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFormGroupUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiFormGroup', slot);
}
const formGroupClasses = (0, _generateUtilityClassesDefault.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
exports.default = formGroupClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8gukz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRadioGroupUtilityClass", ()=>getRadioGroupUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getRadioGroupUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiRadioGroup', slot);
}
const radioGroupClasses = (0, _generateUtilityClassesDefault.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
exports.default = radioGroupClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5LIFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckboxChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
function CheckboxChoice({ context, question, choices }) {
    const [options, setOptions] = (0, _reactDefault.default).useState(choices.map((choice)=>({
            ...choice
        })));
    function handleChange(index, checked) {
        const updatedOptions = (0, _immutabilityHelperDefault.default)(options, {
            [index]: {
                correct: {
                    $set: checked
                }
            }
        });
        setOptions(updatedOptions);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: options.map((option, index)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: option.correct,
                    onChange: (e)=>handleChange(index, e.target.checked)
                }),
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "choice-caption",
                    dangerouslySetInnerHTML: {
                        __html: option.html || ''
                    }
                })
            }, index);
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","react":"9njXz","@mui/material/FormGroup":"1gJha","@mui/material/Checkbox":"4sdMA","@mui/material/FormControlLabel":"kemIW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"am3AU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewOpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _utils = require("helpers/utils");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function PreviewOpenQuestion({ context, question }) {
    const { translate, quizQuestions = {} } = context;
    const classes = (0, _stylesDefault.default)();
    const premiseText = question.premise.html || translate('missing-premise');
    const text = (0, _utils.htmlToText)(question.answer.html);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "true-or-false"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: premiseText && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "instructions",
                    dangerouslySetInnerHTML: {
                        __html: premiseText
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.answer, "answer"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                    className: classes.textarea,
                    maxRows: 5,
                    minRows: 5,
                    readOnly: true,
                    value: text
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","helpers/utils":"gGc98","./styles":"jqPH9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jqPH9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            padding: '0 20px',
            flexDirection: 'column',
            '& .premise': {
                marginTop: 20
            }
        },
        textarea: {
            marginTop: 10,
            resize: 'none',
            width: '100%',
            padding: 8,
            flexGrow: 1,
            borderRadius: '4px',
            border: 'solid 1px #c2c7ca'
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8teh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewTrueOrFalseQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function PreviewTrueOrFalseQuestion({ context, question }) {
    const classes = (0, _stylesDefault.default)();
    const { translate, quizQuestions = {} } = context;
    const { properties, premise, answer } = question;
    const [value, setValue] = (0, _reactDefault.default).useState('');
    const premiseText = question.premise.html || '';
    function handleChange(e) {
        setValue(e.target.value == 'true');
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "multiple-choice"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: [
                    premiseText != '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        dangerouslySetInnerHTML: {
                            __html: premiseText
                        }
                    }),
                    premiseText == '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)('warning', 'missing-premise'),
                        children: translate('missing-premise')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.answer, "answer"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
                    className: "content",
                    value: value,
                    onChange: handleChange,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: true,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                color: "primary",
                                checked: answer.value == true
                            }),
                            label: translate('true')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: false,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                color: "primary",
                                checked: answer.value == false
                            }),
                            label: translate('false')
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","./styles":"2QDir","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2QDir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            padding: 20,
            flexDirection: 'column',
            '& .premise': {
                marginTop: 5
            },
            '& .answer': {
                marginTop: 15
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6uW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Questions);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _editQuestion = require("./edit-question");
var _editQuestionDefault = parcelHelpers.interopDefault(_editQuestion);
var _newQuestion = require("./new-question");
var _newQuestionDefault = parcelHelpers.interopDefault(_newQuestion);
var _question = require("./question");
var _questionDefault = parcelHelpers.interopDefault(_question);
const useStyles = (0, _material.makeStyles)(questionsStyles);
function Questions() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { quizQuestionBank: questions, quizNewBankQuestion: question, sectionName, questionId } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editQuestionDefault.default), {
                open: sectionName == 'edit-question'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newQuestionDefault.default), {
                open: sectionName == 'new-question' && question.id != undefined
            }),
            questions.map((question, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                    ...question
                }, index))
        ]
    });
}
function questionsStyles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            width: '100%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","teacher/context":"5LKDx","./edit-question":"8NKwr","./new-question":"lcA89","./question":"8ESYh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8NKwr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditBankQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _quiz = require("helpers/quiz");
var _questionProperties = require("./question-properties");
var _questionPropertiesDefault = parcelHelpers.interopDefault(_questionProperties);
var _questionTitle = require("components/quiz/components/question-title");
var _questionTitleDefault = parcelHelpers.interopDefault(_questionTitle);
var _questionValue = require("components/quiz/components/question-value");
var _questionValueDefault = parcelHelpers.interopDefault(_questionValue);
var _responsiveFullscreenDialog = require("components/quiz/components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _command = require("helpers/command");
var _matching = require("components/quiz/edit-questions/matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
var _fillInTheBlanks = require("components/quiz/edit-questions/fill-in-the-blanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _multipleChoice = require("components/quiz/edit-questions/multiple-choice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _openQuestion = require("components/quiz/edit-questions/open-question");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _trueOrFalse = require("components/quiz/edit-questions/true-or-false");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _context = require("teacher/context");
var _addStandard = require("../add-standard");
var _addStandardDefault = parcelHelpers.interopDefault(_addStandard);
const questionHandlers = {
    'matching': (0, _matchingDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'true-or-false': (0, _trueOrFalseDefault.default)
};
const useStyles = (0, _material.makeStyles)(editQuestionStyles);
function EditBankQuestion(props) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { at, translate, updateState, questionId, quizQuestionBank, link, linkQuery, query } = context;
    const index = quizQuestionBank.findIndex((q)=>q.id == questionId);
    const questionPath = `quizQuestionBank[${index}]`;
    const [question = {}] = at(questionPath);
    const questionType = context.quizQuestionTypes.find((type)=>type.id == question.type) || {};
    const Handler = questionHandlers[questionType.name];
    function closeDialog() {
        history.push(link({}, '/:languageId/:role/:page/:tab', {
            query
        }));
    }
    async function updateProperties(request, updateCommand) {
        const [updatedId] = request ? await (0, _command.createPost)('quiz', 'updateQuestionProperties')(request) : [
            question.id
        ];
        if (updateCommand && updatedId == question.id) updateState({
            quizQuestionBank: {
                [index]: updateCommand
            }
        });
    }
    const handlePropertyChange = (name, value)=>updateProperties({
            id: question.id,
            [name]: value
        }, {
            [name]: {
                $set: value
            }
        });
    const onStandardsChange = (standards)=>updateProperties({
            id: question.id,
            properties: {
                ...question.properties,
                standards
            }
        }, {
            properties: {
                standards: {
                    $set: standards
                }
            }
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: props.open,
        close: closeDialog,
        dialogClasses: classes,
        dialogMaxWidth: "lg",
        TitleComponent: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "caption",
                        children: translate('bank-question-title')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                        onClick: closeDialog,
                        className: "close-icon",
                        size: "large",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                    })
                ]
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: "content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: "properties-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionPropertiesDefault.default), {
                            index: index,
                            question: question,
                            context: context
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: "value-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionValueDefault.default), {
                                context: context,
                                className: "value",
                                question: question,
                                updateProperties: updateProperties
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: "standards",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStandardDefault.default), {
                        question: question,
                        onStandardsChange: onStandardsChange
                    })
                }),
                Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                    index: index,
                    context: context,
                    onPropertyChange: handlePropertyChange,
                    updateProperties: updateProperties,
                    question: question,
                    questionPath: questionPath
                })
            ]
        })
    });
}
function editQuestionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            "& .header": {
                display: "flex",
                color: '#69738c',
                "& .close-icon": {
                    padding: '0 6px',
                    "& svg": {
                        fontSize: '13pt'
                    }
                },
                "& .caption": {
                    flexGrow: 1,
                    ...verticalCentering
                }
            },
            "& .standards": {
                marginBottom: 10
            },
            '& .properties-container': {
                display: 'flex',
                marginTop: 20,
                marginBottom: 30,
                padding: 9
            },
            '& .value-wrapper': {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 10,
                padding: 9,
                '& > .value': {
                    width: 75,
                    '& > .label': {
                        margin: '-8px'
                    },
                    '& > .valueLabel': {
                        color: '#4e566b'
                    },
                    '& > .valueInput': {
                        display: 'flex',
                        // border: 'solid 1px black',
                        borderRadius: 4,
                        cursor: 'text',
                        marginTop: 10,
                        '& .control': {
                            display: 'flex'
                        },
                        '& .input-wrapper': {
                            flexGrow: 1,
                            ...verticalCentering
                        },
                        '& .input': {
                            border: 'none',
                            width: '100%',
                            flexGrow: 1,
                            '&:focus': {
                                outline: 'none'
                            }
                        },
                        '& .addornment': {
                            cursor: 'pointer',
                            marginTop: -3,
                            ...verticalCentering
                        }
                    }
                }
            }
        },
        paper: {
            width: 'calc(100% - 64px)'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","external/material":"6yEDE","@mui/icons-material/Close":"acjz6","@mui/material/IconButton":"bXjnZ","helpers/quiz":"2gdOk","./question-properties":"deEa8","components/quiz/components/question-title":"2JUeL","components/quiz/components/question-value":"7x3pd","components/quiz/components/responsive-fullscreen-dialog":"5zam1","helpers/command":"f3cbG","components/quiz/edit-questions/matching":"GKV70","components/quiz/edit-questions/fill-in-the-blanks":"gUyAx","components/quiz/edit-questions/multiple-choice":"2bsCX","components/quiz/edit-questions/open-question":"6Ovx6","components/quiz/edit-questions/true-or-false":"kyWOK","teacher/context":"5LKDx","../add-standard":"iTKh1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"deEa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionProperties);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _command = require("helpers/command");
var _utils = require("helpers/utils");
const useStyles = (0, _material.makeStyles)(questionStyles);
function QuestionProperties(props) {
    const { question, index, context } = props;
    const { translate, subjects, myCourses, updateState } = context;
    const classes = useStyles();
    async function updateProperties(properties, updateCommand) {
        const [updatedId] = await (0, _command.createPost)('quiz', 'updateBankQuestionProperties')({
            id: question.id,
            ...properties
        });
        if (updatedId == question.id) updateState({
            quizQuestionBank: updateCommand
        });
    }
    function handleSubjectChange(e) {
        const request = {
            subject: e.target.value,
            course: undefined
        };
        const updateCommand = {
            [index]: {
                subject: {
                    $set: e.target.value
                },
                course: {
                    $set: undefined
                },
                courseName: {
                    $set: undefined
                }
            }
        };
        updateProperties(request, updateCommand);
    }
    function handleCourseChange(e) {
        const { course, courseName } = myCourses.find(({ course })=>course == e.target.value);
        const request = {
            course
        };
        const updateCommand = {
            [index]: {
                course: {
                    $set: course
                },
                courseName: {
                    $set: courseName
                }
            }
        };
        updateProperties(request, updateCommand);
    }
    const courses = question.subject ? myCourses.filter(({ course })=>course.substring(0, 2) == question.subject) : myCourses;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectProperty, {
                controlMargin: "dense",
                controlClassName: (0, _clsxDefault.default)(classes.select, classes.subject),
                selectValue: question.subject == null ? '' : question.subject,
                selectOnChange: handleSubjectChange,
                caption: translate('subject_label'),
                children: subjects.map((subject, key)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: subject.id,
                        children: subject.name
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectProperty, {
                controlMargin: "dense",
                controlClassName: (0, _clsxDefault.default)(classes.select, classes.course),
                selectValue: question.course == null ? '' : question.course,
                selectOnChange: handleCourseChange,
                caption: translate('courseName-header'),
                children: courses.map((course, key)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: course.course,
                        children: course.courseName
                    }, key);
                })
            })
        ]
    });
}
function SelectProperty(props) {
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const labelAttributes = (0, _utils.pickAttributes)(props, 'label');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    const labelId = `${props.id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        ...controlAttributes,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _inputLabelDefault.default), {
                shrink: true,
                id: labelId,
                ...labelAttributes,
                className: "label",
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                labelId: labelId,
                id: props.id,
                ...selectAttributes,
                className: "select",
                children: props.children
            })
        ]
    });
}
function questionStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1
        },
        select: {
            marginLeft: 15,
            minWidth: 200,
            '&:first-child': {
                marginLeft: 0
            },
            '& .MuiInput-underline:before': {
                content: 'none',
                border: 'none'
            },
            '& .MuiSelect-select': {
                // border: 'solid 1px #aab7bf',
                borderRadius: 4,
                padding: '4px 24px 4px 8px',
                marginTop: 5
            },
            '& > .label': {
                fontSize: '15pt',
                color: '#4e566b',
                margin: '-11px'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","@mui/material/Select":"aY7hn","@mui/material/InputLabel":"iTW3B","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","@mui/material/MenuItem":"a18vm","@mui/material/Box":"73kto","helpers/command":"f3cbG","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2JUeL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionTitle);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _editableCaption = require("./editable-caption");
var _editableCaptionDefault = parcelHelpers.interopDefault(_editableCaption);
var _command = require("../../../helpers/command");
function QuestionTitle(props) {
    const { context, className, question } = props;
    const { translate } = context;
    const [editingTitle, setEditingTitle] = (0, _reactDefault.default).useState(false);
    const { properties = {} } = question;
    function onEditTitleClick() {
        setEditingTitle(true);
    }
    function closeEditTitle() {
        setEditingTitle(false);
    }
    async function handleRetitle(title) {
        const id = question.id;
        if (properties.title != title) props.updateProperties && props.updateProperties({
            id,
            properties: {
                title
            }
        }, {
            properties: {
                title: {
                    $set: title
                }
            }
        });
    }
    const title = properties.title || translate('question');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: className,
        onClick: onEditTitleClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableCaptionDefault.default), {
                    editing: editingTitle,
                    value: title,
                    onCancel: closeEditTitle,
                    onConfirm: (title)=>handleRetitle(title) && closeEditTitle(),
                    className: "inputTitle"
                })
            }),
            !editingTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "icon",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faEdit)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./editable-caption":"5oy5y","../../../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5oy5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditableCaption);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clickAwayListener = require("@mui/material/ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _utils = require("../../../helpers/utils");
function EditableCaption(props) {
    const [value, setValue] = (0, _reactDefault.default).useState(props.value);
    const inputRef = (0, _reactDefault.default).useRef();
    (0, _reactDefault.default).useEffect(()=>{
        setValue(props.value);
    }, [
        props.value
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        if (props.editing) setTimeout(()=>{
            inputRef.current.focus();
        }, 10);
    }, [
        props.editing
    ]);
    function handleCancel(e) {
        e.stopPropagation();
        setValue(props.value);
        props.onCancel && props.onCancel();
    }
    function handleConfirm(e) {
        e.stopPropagation();
        props.onConfirm && props.onConfirm(value);
    }
    function handleClickAway(e) {
        props.cancelOnClickAway ? handleCancel(e) : handleConfirm(e);
    }
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const inputAttributes = (0, _utils.pickAttributes)(props, 'input');
    const labelAttributes = (0, _utils.pickAttributes)(props, 'label');
    const addornmentAttributes = (0, _utils.pickAttributes)(props, 'addornment');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: props.className,
        children: [
            props.editing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clickAwayListenerDefault.default), {
                onClickAway: handleClickAway,
                mouseEvent: "onMouseDown",
                touchEvent: "onTouchStart",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "control",
                    onClick: (e)=>e.stopPropagation(),
                    ...controlAttributes,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "input-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                className: "input",
                                type: "text",
                                value: value,
                                pattern: props.pattern,
                                ref: inputRef,
                                onKeyDown: (e)=>{
                                    e.key == 'Enter' && handleConfirm(e);
                                    e.key == 'Escape' && handleCancel(e);
                                },
                                onChange: (e)=>setValue(e.target.value),
                                ...inputAttributes
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "addornment",
                            ...addornmentAttributes,
                            onClick: handleConfirm,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faCheck)
                            })
                        })
                    ]
                })
            }),
            !props.editing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                ...labelAttributes,
                children: props.value
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/ClickAwayListener":"g3Gd7","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7x3pd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionValue);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _utils = require("../../../helpers/utils");
function QuestionValue(props) {
    const { context, className, question } = props;
    const { translate } = context;
    const [value, setValue] = (0, _reactDefault.default).useState(0);
    function handleBlur(e) {
        const cleared = value === '';
        const points = cleared ? 0 : parseInt(value);
        props.updateProperties && props.updateProperties({
            id: question.id,
            value: points,
            properties: {
                cleared
            }
        }, {
            value: {
                $set: points
            },
            properties: {
                cleared: {
                    $set: cleared
                }
            }
        });
    }
    function handleChange(e) {
        const value = e.target.value == '' ? '' : parseInt(e.target.value);
        setValue(value);
    }
    (0, _reactDefault.default).useEffect(()=>{
        const isNewValue = question.value && value != question.value;
        const isCleared = question.properties && question.properties.cleared;
        if (isNewValue || isCleared) {
            const points = question.properties.cleared ? '' : question.value;
            setValue(points);
        }
    }, [
        question.value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "valueLabel",
                children: [
                    translate('value'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                className: "valueInput",
                InputProps: {
                    inputProps: {
                        min: 0,
                        max: 1000
                    }
                },
                value: value,
                type: "number",
                onChange: handleChange,
                onBlur: handleBlur
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/TextField":"amnzu","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"GKV70":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MatchingQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("./matching/styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _choice = require("./matching/choice");
var _choiceDefault = parcelHelpers.interopDefault(_choice);
var _addChoice = require("./matching/add-choice");
var _addChoiceDefault = parcelHelpers.interopDefault(_addChoice);
var _context = require("teacher/context");
var _editableHtml = require("components/quiz/components/editable-html");
var _editableHtmlDefault = parcelHelpers.interopDefault(_editableHtml);
var _utils = require("helpers/utils");
function MatchingQuestion(props) {
    const { index, questionPath, updateProperties } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = (0, _stylesDefault.default)();
    const { at, translate } = context;
    const [question] = at(questionPath);
    const choicesCount = question.answer.choices.length;
    const choiceValue = choicesCount > 0 ? question.value / choicesCount : 0;
    const premiseText = question.premise.html || '';
    function handlePremiseChanged(html, textpremise) {
        const premise = {
            html
        };
        updateProperties({
            id: question.id,
            premise,
            textpremise
        }, {
            premise: {
                $set: premise
            },
            textpremise: {
                $set: textpremise
            }
        });
    }
    function handleChoiceMove(drag, hover) {
        const choice = question.answer.choices[drag];
        updateProperties(false, {
            answer: {
                choices: {
                    $splice: [
                        [
                            drag,
                            1
                        ],
                        [
                            hover,
                            0,
                            choice
                        ]
                    ]
                }
            }
        });
    }
    function handleChoiceDrop() {
        const [question] = at(questionPath);
        const { answer } = question;
        updateProperties({
            id: question.id,
            answer
        });
    }
    function handleAddChoice() {
        const [question] = at(questionPath);
        const command = question.answer.choices ? '$push' : '$set';
        const updateCommand = {
            answer: {
                choices: {
                    [command]: [
                        [
                            '',
                            '',
                            (0, _utils.uuid)()
                        ]
                    ]
                }
            }
        };
        const { answer } = (0, _immutabilityHelperDefault.default)(question, updateCommand);
        updateProperties({
            id: question.id,
            answer
        }, updateCommand);
    }
    function handleChoiceTextChange(id, side, html) {
        const [question] = at(questionPath);
        const index = question.answer.choices.findIndex(([a, b, c])=>c == id);
        const updateText = {
            answer: {
                choices: {
                    [index]: {
                        [side]: {
                            $set: html
                        }
                    }
                }
            }
        };
        const { answer } = (0, _immutabilityHelperDefault.default)(question, updateText);
        updateProperties({
            id: question.id,
            answer
        }, updateText);
    }
    function handleDeleteChoice(id) {
        const [question] = at(questionPath);
        const removeChoice = {
            answer: {
                choices: {
                    $apply: (choices)=>choices.filter(([a, b, c])=>c != id)
                }
            }
        };
        const { answer } = (0, _immutabilityHelperDefault.default)(question, removeChoice);
        updateProperties({
            id: question.id,
            answer
        }, removeChoice);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "matching"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('instructions'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                        context: context,
                        html: premiseText,
                        onChange: handlePremiseChanged
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.answer, "answer"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "choices",
                        children: question.answer.choices && question.answer.choices.map((choice, index, { length })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choiceDefault.default), {
                                onChoiceMove: handleChoiceMove,
                                onChoiceDropped: handleChoiceDrop,
                                onChoiceTextChange: handleChoiceTextChange,
                                onDeleteChoice: handleDeleteChoice,
                                questionCount: length,
                                index,
                                choice,
                                context,
                                question,
                                choiceValue
                            }, choice[2]))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addChoiceDefault.default), {
                        context: context,
                        question: question,
                        index: index,
                        onAddChoice: handleAddChoice
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","./matching/styles":"f8J6C","./matching/choice":"8ECdH","./matching/add-choice":"4GsI4","teacher/context":"5LKDx","components/quiz/components/editable-html":"6jWHH","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f8J6C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            '& .label': {
                color: '#69738c',
                fontWeight: 'bold'
            },
            '& .bottom-properties': {
                display: 'flex',
                justifyContent: 'flex-end',
                '& > .choice-value-container': {
                    display: 'flex',
                    paddingTop: 12,
                    '& > span': {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    },
                    '& > .choice-label': {
                        fontWeight: 'bold'
                    },
                    '& > .choice-value': {
                        marginLeft: 5
                    }
                }
            }
        },
        premise: {
            "& > .label": {
                marginBottom: 20
            }
        },
        answer: {
            marginTop: 25,
            flexGrow: 1,
            color: '#828dab',
            "& .choice": {
                display: 'flex',
                marginTop: 20,
                padding: '20px 15px',
                flexGrow: 1,
                borderRadius: 4,
                background: '#edf6fd',
                flexDirection: 'column',
                "& .header": {
                    marginBottom: 5,
                    display: 'flex',
                    "& .sorter": {
                        fontSize: '14pt',
                        cursor: 'pointer'
                    },
                    '& .index': {
                        marginLeft: 15,
                        color: '#69738c',
                        fontWeight: 'bold'
                    },
                    "& .filler": {
                        flexGrow: 1
                    },
                    "& .delete": {
                        fontSize: '14pt',
                        cursor: 'pointer',
                        color: '#ff3a3a',
                        '&:hover': {
                            transform: 'scale(1.1)'
                        }
                    }
                },
                "& .label": {
                    margin: '20px 5px 8px 0'
                },
                "& .correct": {
                    marginTop: 9
                }
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ECdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Choice);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDnd = require("react-dnd");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _editableHtml = require("components/quiz/components/editable-html");
var _editableHtmlDefault = parcelHelpers.interopDefault(_editableHtml);
var _utils = require("helpers/utils");
function Choice(props) {
    const { index, questionCount, context, question, choice, choiceValue, onChoiceMove, onChoiceTextChange, onChoiceDropped, onDeleteChoice } = props;
    const { id } = question;
    const { translate } = context;
    const [firstText = '', secondText = '', choiceId] = choice || [];
    const type = context.quizQuestionTypes.find((t)=>t.id == question.type);
    const canDelete = questionCount > type.properties.minChoices;
    const ref = (0, _reactDefault.default).useRef(null);
    const config = {
        readonly: false
    };
    const [{ isDragging, dragIndex = index }, drag, preview] = (0, _reactDnd.useDrag)({
        item: {
            type: 'CHOICE',
            index
        },
        collect: (monitor, item)=>{
            const { index } = monitor.getItem() || {};
            return {
                isDragging: monitor.isDragging(),
                dragIndex: index
            };
        }
    });
    const [, drop] = (0, _reactDnd.useDrop)({
        accept: 'CHOICE',
        hover (item, monitor) {
            if (item.index == index) return;
            const { current } = ref;
            if (!current) return;
            const { top, bottom } = current.getBoundingClientRect();
            const middle = (bottom - top) / 2;
            const { y } = monitor.getClientOffset();
            const dY = y - top;
            const goingUp = item.index > index;
            if (goingUp && dY < middle) return;
            if (!goingUp && dY > middle) return;
            onChoiceMove && onChoiceMove(item.index, index);
            item.index = index;
        },
        drop (item, monitor) {
            !monitor.didDrop() && onChoiceDropped && onChoiceDropped();
        }
    });
    const opacity = isDragging ? 0 : 1;
    preview(drop(ref));
    const pairIndex = String.fromCharCode(Math.min(isDragging ? dragIndex : index, 20) + 97);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        id: id,
        ref: ref,
        style: {
            opacity
        },
        className: "choice",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        ref: drag,
                        className: "sorter",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faSort)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "index",
                        children: [
                            pairIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "filler"
                    }),
                    canDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "delete",
                        onClick: (e)=>{
                            e.stopPropagation();
                            onDeleteChoice && onDeleteChoice(choiceId);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTrashAlt)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "first-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('premise'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "editor",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                            context: context,
                            html: firstText || '',
                            onChange: (text)=>{
                                onChoiceTextChange && onChoiceTextChange(choiceId, 0, text);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "second-column",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('answer'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "editor",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                            context: context,
                            html: secondText || '',
                            onChange: (text)=>onChoiceTextChange && onChoiceTextChange(choiceId, 1, text)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "bottom-properties",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: "choice-value-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "choice-label",
                            children: [
                                translate('value'),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "choice-value",
                            children: (0, _utils.toDisplayPoints)(choiceValue, 2)
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dnd":"9NZ1L","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","components/quiz/components/editable-html":"6jWHH","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6jWHH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditableHtml);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _clickAwayListener = require("@mui/material/ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
var _jodit = require("../../jodit");
var _joditDefault = parcelHelpers.interopDefault(_jodit);
var _button = require("./button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            "& .editor": {
                display: 'none',
                "&.ready": {
                    display: 'flex',
                    flexGrow: 1,
                    "& .jodit-container": {
                        flexGrow: 1,
                        "& .jodit-wysiwyg": {
                            "&:focus": {
                                outline: '#3260c9 auto 1px'
                            }
                        }
                    }
                }
            }
        }
    }));
function EditableHtml(props) {
    const classes = useStyles();
    const { context, onChange } = props;
    const config = props.config || {
        uploader: {
            insertImageAsBase64URI: true
        },
        showPlaceholder: true,
        enter: "BR",
        disablePlugins: "wraptextnodes",
        toolbarAdaptive: false,
        showXPathInStatusbar: true,
        language: context.languageId,
        toolbarButtonSize: "small",
        buttons: "bold,strikethrough,underline,italic,|,symbol,superscript,subscript,image,|,ul,ol,|,outdent,indent,|,font,fontsize,brush,paragraph,|,,align,undo,redo,fullsize"
    };
    const [jodit, setJodit] = (0, _reactDefault.default).useState(undefined);
    const [ready, setReady] = (0, _reactDefault.default).useState(false);
    const parser = new DOMParser();
    function handleChange(html) {
        const doc = parser.parseFromString(html, "text/html");
        const treeWalker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
        const nodeList = [];
        let currentNode = treeWalker.nextNode();
        while(currentNode){
            nodeList.push(currentNode.textContent);
            currentNode = treeWalker.nextNode();
        }
        onChange && onChange(html, nodeList.join(' '));
    }
    function handleInit(jodit) {
        setJodit(jodit);
    }
    (0, _reactDefault.default).useLayoutEffect(()=>{
        setReady(true);
    }, []);
    (0, _reactDefault.default).useEffect(()=>{
        if (jodit) jodit.setElementValue(props.html);
    }, [
        props.html
    ]);
    return(// <Fade in={ready} timeout={500}>
    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "html-editor-root"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: (0, _clsxDefault.default)("editor", {
                ready
            }),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _joditDefault.default), {
                value: props.html,
                config: config,
                onInit: handleInit,
                onBlur: handleChange,
                onChange: (newContent)=>{}
            })
        })
    }));
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/ClickAwayListener":"g3Gd7","../../jodit":"eMxWY","./button":"9AoSb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eMxWY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _jodit = require("jodit");
var _joditMinCss = require("jodit/build/jodit.min.css");
const JoditEditor = /*#__PURE__*/ (0, _react.forwardRef)(({ value, config, onChange, onInit, onBlur, tabIndex, name }, ref)=>{
    const textArea = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (ref) {
            if (typeof ref === "function") ref(textArea.current);
            else ref.current = textArea.current;
        }
    }, [
        textArea
    ]);
    (0, _react.useEffect)(()=>{
        const blurHandler = (value)=>{
            onBlur && onBlur(value, textArea.current);
        };
        const changeHandler = (value)=>{
            onChange && onChange(value);
        };
        const element = textArea.current;
        const jodit = new (0, _jodit.Jodit)(element, config);
        onInit && onInit(jodit);
        textArea.current = jodit;
        textArea.current.value = value;
        textArea.current.events.on("blur", ()=>blurHandler(textArea.current.value));
        textArea.current.events.on("change", ()=>changeHandler(textArea.current.value));
        textArea.current.workplace.tabIndex = tabIndex || -1;
        return ()=>{
            jodit.destruct();
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
        ref: textArea,
        name: name
    });
});
exports.default = JoditEditor;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","jodit":"lHjEN","jodit/build/jodit.min.css":"4LYin","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lHjEN":[function(require,module,exports,__globalThis) {
var process = require("cd2d3d4629ff93e8");
!function(e, t) {
    var o, n;
    module.exports = t();
}(self, function() {
    return function() {
        var e, t = {
            90643: function(e) {
                e.exports.default = [
                    "\u0625\u0628\u062F\u0623 \u0641\u064A \u0627\u0644\u0643\u062A\u0627\u0628\u0629...",
                    "\u062D\u0648\u0644 \u062C\u0648\u062F\u064A\u062A",
                    "\u0645\u062D\u0631\u0631 \u062C\u0648\u062F\u064A\u062A",
                    null,
                    "\u062F\u0644\u064A\u0644 \u0645\u0633\u062A\u062E\u062F\u0645 \u062C\u0648\u062F\u064A\u062A",
                    "\u064A\u062D\u062A\u0648\u064A \u0639\u0644\u0649 \u0645\u0633\u0627\u0639\u062F\u0629 \u0645\u0641\u0635\u0644\u0629 \u0644\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645",
                    "\u0644\u0644\u062D\u0635\u0648\u0644 \u0639\u0644\u0649 \u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0648\u0644 \u0627\u0644\u062A\u0631\u062E\u064A\u0635\u060C \u064A\u0631\u062C\u0649 \u0627\u0644\u0630\u0647\u0627\u0628 \u0644\u0645\u0648\u0642\u0639\u0646\u0627:",
                    "\u0634\u0631\u0627\u0621 \u0627\u0644\u0646\u0633\u062E\u0629 \u0627\u0644\u0643\u0627\u0645\u0644\u0629",
                    "\u062D\u0642\u0648\u0642 \u0627\u0644\u0637\u0628\u0639 \u0648\u0627\u0644\u0646\u0634\u0631 \xa9 XDSoft.net - Chupurnov Valeriy. \u0643\u0644 \u0627\u0644\u062D\u0642\u0648\u0642 \u0645\u062D\u0641\u0648\u0638\u0629.",
                    "\u0645\u0650\u0631\u0652\u0633\u0627\u0629",
                    "\u0641\u062A\u062D \u0641\u064A \u0646\u0627\u0641\u0630\u0629 \u062C\u062F\u064A\u062F\u0629",
                    "\u0641\u062A\u062D \u0627\u0644\u0645\u062D\u0631\u0631 \u0641\u064A \u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u0643\u0627\u0645\u0644",
                    "\u0645\u0633\u062D \u0627\u0644\u062A\u0646\u0633\u064A\u0642",
                    "\u0645\u0644\u0621 \u0627\u0644\u0644\u0648\u0646 \u0623\u0648 \u062A\u0639\u064A\u064A\u0646 \u0644\u0648\u0646 \u0627\u0644\u0646\u0635",
                    "\u0625\u0639\u0627\u062F\u0629",
                    "\u062A\u0631\u0627\u062C\u0639",
                    "\u0639\u0631\u064A\u0636",
                    "\u0645\u0627\u0626\u0644",
                    "\u0625\u062F\u0631\u0627\u062C \u0642\u0627\u0626\u0645\u0629 \u063A\u064A\u0631 \u0645\u0631\u062A\u0628\u0629",
                    "\u0625\u062F\u0631\u0627\u062C \u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u062A\u0628\u0629",
                    "\u0645\u062D\u0627\u0630\u0627\u0629 \u0644\u0644\u0648\u0633\u0637",
                    "\u0645\u062D\u0627\u0630\u0627\u0629 \u0645\u062B\u0628\u062A\u0629",
                    "\u0645\u062D\u0627\u0630\u0627\u0629 \u0644\u0644\u064A\u0633\u0627\u0631",
                    "\u0645\u062D\u0627\u0630\u0627\u0629 \u0644\u0644\u064A\u0645\u064A\u0646",
                    "\u0625\u062F\u0631\u0627\u062C \u062E\u0637 \u0623\u0641\u0642\u064A",
                    "\u0625\u062F\u0631\u0627\u062C \u0635\u0648\u0631\u0629",
                    "\u0627\u062F\u062E\u0627\u0644 \u0627\u0644\u0645\u0644\u0641",
                    "\u0625\u062F\u0631\u0627\u062C \u0641\u064A\u062F\u064A\u0648 \u064A\u0648\u062A\u064A\u0648\u0628/\u0641\u064A\u0645\u064A\u0648 ",
                    "\u0625\u062F\u0631\u0627\u062C \u0631\u0627\u0628\u0637",
                    "\u062D\u062C\u0645 \u0627\u0644\u062E\u0637",
                    "\u0646\u0648\u0639 \u0627\u0644\u062E\u0637",
                    "\u0625\u062F\u0631\u0627\u062C \u0643\u062A\u0644\u0629 \u062A\u0646\u0633\u064A\u0642",
                    "\u0639\u0627\u062F\u064A",
                    "\u0639\u0646\u0648\u0627\u0646 1",
                    "\u0639\u0646\u0648\u0627\u0646 2",
                    "\u0639\u0646\u0648\u0627\u0646 3",
                    "\u0639\u0646\u0648\u0627\u0646 4",
                    "\u0625\u0642\u062A\u0628\u0627\u0633",
                    "\u0643\u0648\u062F",
                    "\u0625\u062F\u0631\u0627\u062C",
                    "\u0625\u062F\u0631\u0627\u062C \u062C\u062F\u0648\u0644",
                    "\u062A\u0642\u0644\u064A\u0644 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                    "\u0632\u064A\u0627\u062F\u0629 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                    "\u062A\u062D\u062F\u064A\u062F \u0623\u062D\u0631\u0641 \u062E\u0627\u0635\u0629",
                    "\u0625\u062F\u0631\u0627\u062C \u062D\u0631\u0641 \u062E\u0627\u0635",
                    "\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0631\u0633\u0645",
                    "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0648\u0636\u0639",
                    "\u0647\u0648\u0627\u0645\u0634",
                    "\u0623\u0639\u0644\u0649",
                    "\u064A\u0645\u064A\u0646",
                    "\u0623\u0633\u0641\u0644",
                    "\u064A\u0633\u0627\u0631",
                    "\u0627\u0644\u0623\u0646\u0645\u0627\u0637",
                    "\u0627\u0644\u0637\u0628\u0642\u0627\u062A",
                    "\u0645\u062D\u0627\u0630\u0627\u0629",
                    "\u0627\u0644\u064A\u0645\u064A\u0646",
                    "\u0627\u0644\u0648\u0633\u0637",
                    "\u0627\u0644\u064A\u0633\u0627\u0631",
                    "--\u063A\u064A\u0631 \u0645\u0636\u0628\u0648\u0637--",
                    "Src",
                    "\u0627\u0644\u0639\u0646\u0648\u0627\u0646",
                    "\u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u062F\u064A\u0644",
                    "\u0627\u0644\u0631\u0627\u0628\u0637",
                    "\u0627\u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637 \u0641\u064A \u0646\u0627\u0641\u0630\u0629 \u062C\u062F\u064A\u062F\u0629",
                    "\u0627\u0644\u0635\u0648\u0631\u0629",
                    "\u0645\u0644\u0641",
                    "\u0645\u062A\u0642\u062F\u0645",
                    "\u062E\u0635\u0627\u0626\u0635 \u0627\u0644\u0635\u0648\u0631\u0629",
                    "\u0625\u0644\u063A\u0627\u0621",
                    "\u062D\u0633\u0646\u0627",
                    "\u064A\u0634\u0628\u0647 \u0627\u0644\u0643\u0648\u062F \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 HTML. \u062A\u0628\u0642\u064A \u0643\u0645\u0627 HTML\u061F",
                    "\u0627\u0644\u0635\u0642 \u0643 HTML",
                    "\u0627\u062D\u062A\u0641\u0638",
                    "\u0646\u0638\u064A\u0641\u0629",
                    "\u0625\u062F\u0631\u0627\u062C \u0643\u0646\u0635",
                    "\u0625\u062F\u0631\u0627\u062C \u0627\u0644\u0646\u0635 \u0641\u0642\u0637",
                    "\u0643\u0644\u0645\u0629 \u0644\u0635\u0642 \u0627\u0644\u0643\u0634\u0641 \u0639\u0646",
                    "\u0644\u0644\u0635\u0642 \u0627\u0644\u0645\u062D\u062A\u0648\u0649 \u0642\u0627\u062F\u0645 \u0645\u0646 Microsoft Word/Excel \u0627\u0644\u0648\u062B\u064A\u0642\u0629. \u0647\u0644 \u062A\u0631\u064A\u062F \u0623\u0646 \u062A\u0628\u0642\u064A \u0634\u0643\u0644 \u0623\u0648 \u062A\u0646\u0638\u064A\u0641\u0647 \u061F ",
                    "\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u0645\u0644\u0641\u0627\u062A",
                    "\u062D\u062F\u062B \u062E\u0637\u0623 \u0641\u064A \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0642\u0627\u0626\u0645\u0629 ",
                    "\u062D\u062F\u062B \u062E\u0637\u0623 \u0641\u064A \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0645\u062C\u0644\u062F\u0627\u062A",
                    "\u0647\u0644 \u0623\u0646\u062A \u0648\u0627\u062B\u0642\u061F",
                    "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0645\u062C\u0644\u062F",
                    "\u0625\u0646\u0634\u0627\u0621 \u0645\u062C\u0644\u062F",
                    "\u0623\u0643\u062A\u0628 \u0625\u0633\u0645",
                    "\u0625\u0633\u0642\u0627\u0637 \u0635\u0648\u0631\u0629",
                    "\u0625\u0633\u0642\u0627\u0637 \u0627\u0644\u0645\u0644\u0641",
                    "\u0623\u0648 \u0623\u0646\u0642\u0631",
                    "\u0627\u0644\u0646\u0635 \u0627\u0644\u0628\u062F\u064A\u0644",
                    "\u062A\u0635\u0641\u062D",
                    "\u0631\u0641\u0639",
                    "\u0627\u0644\u062E\u0644\u0641\u064A\u0629",
                    "\u0646\u0635",
                    "\u0623\u0639\u0644\u0649",
                    "\u0627\u0644\u0648\u0633\u0637",
                    "\u0627\u0644\u0623\u0633\u0641\u0644",
                    "\u0625\u062F\u0631\u0627\u062C \u0639\u0645\u0648\u062F \u0642\u0628\u0644",
                    "\u0625\u062F\u0631\u0627\u062C \u0639\u0645\u0648\u062F \u0628\u0639\u062F",
                    "\u0625\u062F\u0631\u0627\u062C \u0635\u0641 \u0623\u0639\u0644\u0649",
                    "\u0625\u062F\u0631\u0627\u062C \u0635\u0641 \u0623\u0633\u0641\u0644",
                    "\u062D\u0630\u0641 \u0627\u0644\u062C\u062F\u0648\u0644",
                    "\u062D\u0630\u0641 \u0627\u0644\u0635\u0641",
                    "\u062D\u0630\u0641 \u0627\u0644\u0639\u0645\u0648\u062F",
                    "\u062E\u0644\u064A\u0629 \u0641\u0627\u0631\u063A\u0629",
                    "\u0645\u0635\u062F\u0631",
                    "\u0628\u0627\u0644\u062E\u0637 \u0627\u0644\u0639\u0631\u064A\u0636",
                    "\u0645\u0627\u0626\u0644",
                    "\u0634\u063A\u0644",
                    "\u0635\u0644\u0629",
                    "\u0625\u0644\u063A\u0627\u0621",
                    "\u0643\u0631\u0631",
                    "\u0637\u0627\u0648\u0644\u0629",
                    "\u0635\u0648\u0631\u0629",
                    "\u0646\u0638\u064A\u0641",
                    "\u0641\u0642\u0631\u0629",
                    "\u062D\u062C\u0645 \u0627\u0644\u062E\u0637",
                    "\u0641\u064A\u062F\u064A\u0648",
                    "\u0627\u0644\u062E\u0637",
                    "\u062D\u0648\u0644 \u0627\u0644\u0645\u062D\u0631\u0631",
                    "\u0637\u0628\u0627\u0639\u0629",
                    "\u0623\u0643\u062F",
                    "\u0634\u0637\u0628",
                    "\u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0627\u0644\u0628\u0627\u062F\u0626\u0629",
                    "\u0646\u062A\u0648\u0621",
                    "\u0645\u0644\u0621 \u0627\u0644\u0634\u0627\u0634\u0629",
                    "\u0627\u0644\u062D\u062C\u0645 \u0627\u0644\u062A\u0642\u0644\u064A\u062F\u064A",
                    "\u0627\u0644\u062E\u0637",
                    "\u0642\u0627\u0626\u0645\u0629",
                    "\u0642\u0627\u0626\u0645\u0629 \u0645\u0631\u0642\u0645\u0629",
                    "\u0642\u0637\u0639",
                    "\u0627\u062E\u062A\u0631 \u0627\u0644\u0643\u0644",
                    "\u0642\u0627\u0646\u0648\u0646",
                    "\u0641\u062A\u062D \u0627\u0644\u0631\u0627\u0628\u0637",
                    "\u062A\u0639\u062F\u064A\u0644 \u0627\u0644\u0631\u0627\u0628\u0637",
                    "\u0633\u0645\u0629 Nofollow",
                    "\u0625\u0632\u0627\u0644\u0629 \u0627\u0644\u0631\u0627\u0628\u0637",
                    "\u0645\u0631\u0627\u062C\u0639\u0629",
                    "\u0644\u062A\u062D\u0631\u064A\u0631",
                    "\u062A\u062D\u062F\u064A\u062B",
                    "URL",
                    "\u062A\u062D\u0631\u064A\u0631",
                    "\u0645\u062D\u0627\u0630\u0627\u0629 \u0623\u0641\u0642\u064A\u0629",
                    "\u0641\u0644\u062A\u0631",
                    "\u0639\u0646 \u0637\u0631\u064A\u0642 \u0627\u0644\u062A\u063A\u064A\u064A\u0631",
                    "\u0628\u0627\u0644\u0627\u0633\u0645",
                    "\u062D\u0633\u0628 \u0627\u0644\u062D\u062C\u0645",
                    "\u0625\u0636\u0627\u0641\u0629 \u0645\u062C\u0644\u062F",
                    "\u0625\u0639\u0627\u062F\u0629",
                    "\u0627\u062D\u062A\u0641\u0638",
                    "\u062D\u0641\u0638 \u0628\u0627\u0633\u0645",
                    "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u062D\u062C\u0645",
                    "\u062D\u062C\u0645 \u0627\u0644\u0642\u0637\u0639",
                    "\u0639\u0631\u0636",
                    "\u0627\u0631\u062A\u0641\u0627\u0639",
                    "\u062D\u0627\u0641\u0638 \u0639\u0644\u0649 \u0627\u0644\u0646\u0633\u0628",
                    "\u0623\u0646",
                    "\u0644\u0627",
                    "\u062D\u0630\u0641",
                    "\u062A\u0645\u064A\u0632",
                    "%d \u062D\u0631\u0641",
                    "%d \u0643\u0644\u0627\u0645",
                    null,
                    "\u062A\u0645\u064A\u0632 %s",
                    "\u0627\u062E\u062A\u0631 \u0627\u0644\u0643\u0644",
                    "\u0645\u062D\u0627\u0630\u0627\u0629 \u0639\u0645\u0648\u062F\u064A\u0629",
                    "\u0627\u0646\u0634\u0642\u060C \u0645\u0632\u0642",
                    "\u0627\u0646\u0642\u0633\u0627\u0645 \u0639\u0645\u0648\u062F\u064A",
                    "\u062A\u0642\u0633\u064A\u0645 \u0623\u0641\u0642\u064A",
                    "\u0627\u0630\u0647\u0628",
                    "\u0623\u0636\u0641 \u0627\u0644\u0639\u0645\u0648\u062F",
                    "\u0627\u0636\u0641 \u0633\u0637\u0631",
                    "\u062D\u0630\u0641",
                    "\u0627\u0644\u062D\u062F\u0648\u062F",
                    "\u0631\u062E\u0635\u0629 %s",
                    "\u0627\u0636\u0631\u0628 \u0645\u0646 \u062E\u0644\u0627\u0644",
                    "\u0623\u0643\u062F",
                    "\u062D\u0631\u0641 \u0641\u0648\u0642\u064A",
                    "\u0645\u062E\u0637\u0648\u0637\u0629",
                    "\u0642\u0637\u0639 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631",
                    "\u0627\u0633\u062A\u0631\u0627\u062D\u0629",
                    "\u0627\u0644\u0628\u062D\u062B \u0639\u0646",
                    "\u0627\u0633\u062A\u0628\u062F\u0644 \u0628",
                    "\u0645\u062D\u0644",
                    "\u0645\u0639\u062C\u0648\u0646",
                    "\u0627\u062E\u062A\u0631 \u0645\u062D\u062A\u0648\u0649 \u0644\u0644\u0635\u0642",
                    "\u064A\u0645\u0643\u0646\u0643 \u0641\u0642\u0637 \u062A\u062D\u0631\u064A\u0631 \u0635\u0648\u0631\u0643 \u0627\u0644\u062E\u0627\u0635\u0629. \u062A\u062D\u0645\u064A\u0644 \u0647\u0630\u0647 \u0627\u0644\u0635\u0648\u0631\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0636\u064A\u0641\u061F",
                    "\u062A\u0645 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0635\u0648\u0631\u0629 \u0628\u0646\u062C\u0627\u062D \u0639\u0644\u0649 \u0627\u0644\u062E\u0627\u062F\u0645!",
                    "\u0644\u0648\u062D\u0629",
                    "\u0644\u0627 \u062A\u0648\u062C\u062F \u0645\u0644\u0641\u0627\u062A \u0641\u064A \u0647\u0630\u0627 \u0627\u0644\u062F\u0644\u064A\u0644.",
                    "\u0625\u0639\u0627\u062F\u0629 \u062A\u0633\u0645\u064A\u0629",
                    "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u062C\u062F\u064A\u062F",
                    "\u0645\u0639\u0627\u064A\u0646\u0629",
                    "\u062A\u062D\u0645\u064A\u0644",
                    "\u0644\u0635\u0642 \u0645\u0646 \u0627\u0644\u062D\u0627\u0641\u0638\u0629",
                    "\u0645\u062A\u0635\u0641\u062D\u0643 \u0644\u0627 \u064A\u062F\u0639\u0645 \u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0625\u0644\u0649 \u0627\u0644\u062D\u0627\u0641\u0638\u0629.",
                    "\u0646\u0633\u062E \u0627\u0644\u062A\u062D\u062F\u064A\u062F",
                    "\u0646\u0633\u062E",
                    "\u062F\u0627\u0626\u0631\u0629 \u0646\u0635\u0641 \u0642\u0637\u0631\u0647\u0627 \u0627\u0644\u062D\u062F\u0648\u062F",
                    "\u0639\u0631\u0636 \u0643\u0644",
                    "\u062A\u0637\u0628\u064A\u0642",
                    "\u064A\u0631\u062C\u0649 \u0645\u0644\u0621 \u0647\u0630\u0627 \u0627\u0644\u0645\u062C\u0627\u0644",
                    "\u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0639\u0646\u0648\u0627\u0646 \u0648\u064A\u0628",
                    "\u0627\u0644\u0627\u0641\u062A\u0631\u0627\u0636\u064A",
                    "\u062F\u0627\u0626\u0631\u0629",
                    "\u0646\u0642\u0637\u0629",
                    "\u0627\u0644\u0645\u0631\u0628\u0639\u0629",
                    "\u0627\u0644\u0628\u062D\u062B",
                    "\u062A\u062C\u062F \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
                    "\u062A\u062C\u062F \u0627\u0644\u062A\u0627\u0644\u064A",
                    "\u0623\u062F\u062E\u0644 \u0627\u0633\u0645 \u0627\u0644\u0641\u0635\u0644",
                    "\u0627\u0636\u063A\u0637 \u0627\u0644\u0628\u062F\u064A\u0644 \u0644\u062A\u063A\u064A\u064A\u0631 \u062D\u062C\u0645 \u0645\u062E\u0635\u0635"
                ];
            },
            52532: function(e) {
                e.exports.default = [
                    "Napi\u0161 n\u011Bco",
                    "O Jodit",
                    "Editor Jodit",
                    "Verze pro nekomer\u010Dn\xed pou\u017Eit\xed",
                    "Jodit U\u017Eivatelsk\xe1 p\u0159\xedru\u010Dka",
                    "obsahuje detailn\xed n\xe1pov\u011Bdu",
                    "Pro informace o licenci, pros\xedm, p\u0159ejd\u011Bte na na\u0161i str\xe1nku:",
                    "Koupit plnou verzi",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. V\u0161echna pr\xe1va vyhrazena.",
                    "Anchor",
                    "Otev\u0159\xedt v nov\xe9 z\xe1lo\u017Ece",
                    "Otev\u0159\xedt v celoobrazovkov\xe9m re\u017Eimu",
                    "Vy\u010Distit form\xe1tov\xe1n\xed",
                    "Barva v\xfdpln\u011B a p\xedsma",
                    "Vp\u0159ed",
                    "Zp\u011Bt",
                    "Tu\u010Dn\xe9",
                    "Kurz\xedva",
                    "Odr\xe1\u017Eky",
                    "\u010C\xedslovan\xfd seznam",
                    "Zarovnat na st\u0159ed",
                    "Zarovnat do bloku",
                    "Zarovnat vlevo",
                    "Zarovnat vpravo",
                    "Vlo\u017Eit horizont\xe1ln\xed linku",
                    "Vlo\u017Eit obr\xe1zek",
                    "Vlo\u017Eit soubor",
                    "Vlo\u017Eit video (YT/Vimeo)",
                    "Vlo\u017Eit odkaz",
                    "Velikost p\xedsma",
                    "Typ p\xedsma",
                    "Form\xe1tovat blok",
                    "Norm\xe1ln\xed text",
                    "Nadpis 1",
                    "Nadpis 2",
                    "Nadpis 3",
                    "Nadpis 4",
                    "Cit\xe1t",
                    "K\xf3d",
                    "Vlo\u017Eit",
                    "Vlo\u017Eit tabulku",
                    "Zmen\u0161it odsazen\xed",
                    "Zv\u011Bt\u0161it odsazen\xed",
                    "Vybrat speci\xe1ln\xed symbol",
                    "Vlo\u017Eit speci\xe1ln\xed symbol",
                    "Pou\u017E\xedt form\xe1t",
                    "Zm\u011Bnit m\xf3d",
                    "Okraje",
                    "horn\xed",
                    "prav\xfd",
                    "spodn\xed",
                    "lev\xfd",
                    "Styly",
                    "T\u0159\xeddy",
                    "Zarovn\xe1n\xed",
                    "Vpravo",
                    "Na st\u0159ed",
                    "Vlevo",
                    "--nenastaveno--",
                    "src",
                    "Titulek",
                    "Alternativn\xed text (alt)",
                    "Link",
                    "Otev\u0159\xedt link v nov\xe9 z\xe1lo\u017Ece",
                    "Obr\xe1zek",
                    "soubor",
                    "Roz\u0161\xed\u0159en\xe9",
                    "Vlastnosti obr\xe1zku",
                    "Zp\u011Bt",
                    "Ok",
                    "V\xe1\u0161 text se podob\xe1 HTML. Vlo\u017Eit ho jako HTML?",
                    "Vlo\u017Eit jako HTML",
                    "Ponechat origin\xe1l",
                    "Vy\u010Distit",
                    "Vlo\u017Eit jako TEXT",
                    "Vlo\u017Eit pouze TEXT",
                    "Detekov\xe1n fragment z Wordu nebo Excelu",
                    "Obsah, kter\xfd vkl\xe1d\xe1te, je pravd\u011Bpodobn\u011B z Microsoft Word / Excel. Chcete ponechat form\xe1t nebo vlo\u017Eit pouze text?",
                    "Prohl\xed\u017Ee\u010D soubor\u016F",
                    "Chyba p\u0159i na\u010D\xedt\xe1n\xed seznamu soubor\u016F",
                    "Chyba p\u0159i na\u010D\xedt\xe1n\xed slo\u017Eek",
                    "Jste si jist\xfd(\xe1)?",
                    "N\xe1zev slo\u017Eky",
                    "Vytvo\u0159it slo\u017Eku",
                    "n\xe1zev",
                    "P\u0159et\xe1hn\u011Bte sem obr\xe1zek",
                    "P\u0159et\xe1hn\u011Bte sem soubor",
                    "nebo klikn\u011Bte",
                    "Alternativn\xed text",
                    "Server",
                    "Nahr\xe1t",
                    "Pozad\xed",
                    "Text",
                    "Nahoru",
                    "Na st\u0159ed",
                    "Dolu",
                    "Vlo\u017Eit sloupec p\u0159ed",
                    "Vlo\u017Eit sloupec za",
                    "Vlo\u017Eit \u0159\xe1dek nad",
                    "Vlo\u017Eit \u0159\xe1dek pod",
                    "Vymazat tabulku",
                    "Vymazat \u0159\xe1dku",
                    "Vymazat sloupec",
                    "Vy\u010Distit bu\u0148ku",
                    "HTML",
                    "tu\u010Dn\u011B",
                    "kurz\xedva",
                    "\u0161t\u011Btec",
                    "odkaz",
                    "zp\u011Bt",
                    "vp\u0159ed",
                    "tabulka",
                    "obr\xe1zek",
                    "guma",
                    "odstavec",
                    "velikost p\xedsma",
                    "video",
                    "p\xedsmo",
                    "\u043E editoru",
                    "tisk",
                    "podtr\u017Eeno",
                    "p\u0159e\u0161krtnuto",
                    "zv\u011Bt\u0161it odsazen\xed",
                    "zmen\u0161it odsazen\xed",
                    "celoobrazovkov\xfd re\u017Eim",
                    "smrsknout",
                    "Linka",
                    "Odr\xe1\u017Eka",
                    "\u010C\xedslovan\xfd seznam",
                    "Vyjmout",
                    "Ozna\u010Dit v\u0161e",
                    "K\xf3d",
                    "Otev\u0159\xedt odkaz",
                    "Upravit odkaz",
                    "Atribut no-follow",
                    "Odstranit odkaz",
                    "Zobrazit",
                    "Chcete-li upravit",
                    "Aktualizovat",
                    "URL",
                    "Editovat",
                    "Horizont\xe1ln\xed zarovn\xe1n\xed",
                    "Filtr",
                    "Dle posledn\xed zm\u011Bny",
                    "Dle n\xe1zvu",
                    "Dle velikosti",
                    "P\u0159idat slo\u017Eku",
                    "Reset",
                    "Ulo\u017Eit",
                    "Ulo\u017Eit jako...",
                    "Zm\u011Bnit rozm\u011Br",
                    "O\u0159ezat",
                    "\u0160\xed\u0159ka",
                    "V\xfd\u0161ka",
                    "Ponechat pom\u011Br",
                    "Ano",
                    "Ne",
                    "Vyjmout",
                    "Ozna\u010Dit",
                    "Znaky: %d",
                    "Slova: %d",
                    "V\u0161e",
                    "Ozna\u010Dit %s",
                    "Ozna\u010Dit v\u0161e",
                    "Vertik\xe1ln\xed zarovn\xe1n\xed",
                    "Rozd\u011Blit",
                    "Rozd\u011Blit vertik\xe1ln\u011B",
                    "Rozd\u011Blit horizont\xe1ln\u011B",
                    "Spojit",
                    "P\u0159idat sloupec",
                    "P\u0159idat \u0159\xe1dek",
                    "Vymazat",
                    "Okraj",
                    "Licence: %s",
                    "P\u0159e\u0161krtnuto",
                    "Podtr\u017Eeno",
                    "Horn\xed index",
                    "Doln\xed index",
                    "Vyjmout ozna\u010Den\xe9",
                    "Zalomen\xed",
                    "Najdi",
                    "Nahradit za",
                    "Vym\u011B\u0148te",
                    "Vlo\u017Eit",
                    "Vyber obsah pro vlo\u017Een\xed",
                    "M\u016F\u017Eete upravovat pouze sv\xe9 obr\xe1zky. Na\u010D\xedst obr\xe1zek?",
                    "Obr\xe1zek byl \xfasp\u011B\u0161n\u011B nahr\xe1n!",
                    "paleta",
                    "V tomto adres\xe1\u0159i nejsou \u017E\xe1dn\xe9 soubory.",
                    "p\u0159ejmenovat",
                    "Zadejte nov\xfd n\xe1zev",
                    "n\xe1hled",
                    "Sta\u017Een\xed",
                    "Vlo\u017Eit ze schr\xe1nky",
                    "V\xe1\u0161 prohl\xed\u017Ee\u010D nepodporuje p\u0159\xedm\xfd p\u0159\xedstup do schr\xe1nky.",
                    "Kop\xedrovat v\xfdb\u011Br",
                    "kop\xedrov\xe1n\xed",
                    "Border radius",
                    "Zobrazit v\u0161echny",
                    "Plat\xed",
                    "Pros\xedm, vypl\u0148te toto pole",
                    "Pros\xedm, zadejte webovou adresu",
                    "V\xfdchoz\xed",
                    "Kruh",
                    "Dot",
                    "Quadrate",
                    "Naj\xedt",
                    "Naj\xedt P\u0159edchoz\xed",
                    "Naj\xedt Dal\u0161\xed",
                    "Vlo\u017Ete n\xe1zev t\u0159\xeddy",
                    "Stiskn\u011Bte Alt pro vlastn\xed zm\u011Bnu velikosti"
                ];
            },
            75178: function(e) {
                e.exports.default = [
                    "Bitte geben Sie einen Text ein",
                    "\xdcber Jodit",
                    "Jodit Editor",
                    null,
                    "Das Jodit Benutzerhandbuch",
                    "beinhaltet ausf\xfchrliche Informationen wie Sie den Editor verwenden k\xf6nnen.",
                    "F\xfcr Informationen zur Lizenz, besuchen Sie bitte unsere Web-Pr\xe4senz:",
                    "Vollversion kaufen",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.",
                    "Anker",
                    "In neuer Registerkarte \xf6ffnen",
                    "Editor in voller Gr\xf6\xdfe \xf6ffnen",
                    "Formatierung l\xf6schen",
                    "F\xfcllfarbe oder Textfarbe \xe4ndern",
                    "Wiederholen",
                    "R\xfcckg\xe4ngig machen",
                    "Fett",
                    "Kursiv",
                    "Unsortierte Liste einf\xfcgen",
                    "Nummerierte Liste einf\xfcgen",
                    "Mittig ausrichten",
                    "Blocksatz",
                    "Links ausrichten",
                    "Rechts ausrichten",
                    "Horizontale Linie einf\xfcgen",
                    "Bild einf\xfcgen",
                    "Datei einf\xfcgen",
                    "Youtube/vimeo Video einf\xfcgen",
                    "Link einf\xfcgen",
                    "Schriftgr\xf6\xdfe",
                    "Schriftfamilie",
                    "Formatblock einf\xfcgen",
                    "Normal",
                    "\xdcberschrift 1",
                    "\xdcberschrift 2",
                    "\xdcberschrift 3",
                    "\xdcberschrift 4",
                    "Zitat",
                    "Code",
                    "Einf\xfcgen",
                    "Tabelle einf\xfcgen",
                    "Einzug verkleinern",
                    "Einzug vergr\xf6\xdfern",
                    "Sonderzeichen ausw\xe4hlen",
                    "Sonderzeichen einf\xfcgen",
                    "Format kopieren",
                    "\xc4nderungsmodus",
                    "R\xe4nder",
                    "Oben",
                    "Rechts",
                    "Unten",
                    "Links",
                    "CSS Stil",
                    "CSS Klassen",
                    "Ausrichtung",
                    "Rechts",
                    "Zentriert",
                    "Links",
                    "Keine",
                    "Pfad",
                    "Titel",
                    "Alternativer Text",
                    "Link",
                    "Link in neuem Tab \xf6ffnen",
                    "Bild",
                    "Datei",
                    "Fortgeschritten",
                    "Bildeigenschaften",
                    "Abbrechen",
                    "OK",
                    "Ihr Text \xe4hnelt HTML-Code. Als HTML beibehalten?",
                    "Als HTML einf\xfcgen?",
                    "Original speichern",
                    "S\xe4ubern",
                    "Als Text einf\xfcgen",
                    "Nur Text einf\xfcgen",
                    "In Word formatierter Text erkannt",
                    "Der Inhalt, den Sie einf\xfcgen, stammt aus einem Microsoft Word / Excel-Dokument. M\xf6chten Sie das Format erhalten oder bereinigen?",
                    "Dateibrowser",
                    "Fehler beim Laden der Liste",
                    "Fehler beim Laden der Ordner",
                    "Sind Sie sicher?",
                    "Geben Sie den Verzeichnisnamen ein",
                    "Verzeichnis erstellen",
                    "Typname",
                    "Bild hier hinziehen",
                    "Datei l\xf6schen",
                    "oder hier klicken",
                    "Alternativtext",
                    "Ausw\xe4hlen",
                    "Hochladen",
                    "Hintergrund",
                    "Text",
                    "Oben",
                    "Mittig",
                    "Unten",
                    "Spalte davor einf\xfcgen",
                    "Spalte danach einf\xfcgen",
                    "Zeile oberhalb einf\xfcgen",
                    "Zeile unterhalb einf\xfcgen",
                    "Tabelle l\xf6schen",
                    "Zeile l\xf6schen",
                    "Spalte l\xf6schen",
                    "Zelle leeren",
                    "HTML",
                    "Fett gedruckt",
                    "Kursiv",
                    "B\xfcrste",
                    "Verkn\xfcpfung",
                    "R\xfcckg\xe4ngig machen",
                    "Wiederholen",
                    "Tabelle",
                    "Bild",
                    "Radiergummi",
                    "Absatz",
                    "Schriftgr\xf6\xdfe",
                    "Video",
                    "Schriftart",
                    "\xdcber",
                    "Drucken",
                    "Unterstreichen",
                    "Durchstreichen",
                    "Einzug",
                    "Herausstellen",
                    "Vollgr\xf6\xdfe",
                    "Schrumpfen",
                    "die Linie",
                    "Liste von",
                    "Nummerierte Liste",
                    "Schneiden",
                    "W\xe4hlen Sie Alle aus",
                    "Code einbetten",
                    "Link \xf6ffnen",
                    "Link bearbeiten",
                    "Nofollow-Attribut",
                    "Link entfernen",
                    "Ansehen",
                    "Bearbeiten",
                    "Aktualisieren",
                    "URL",
                    "Bearbeiten",
                    "Horizontale Ausrichtung",
                    "Filter",
                    "Sortieren nach ge\xe4ndert",
                    "Nach Name sortieren",
                    "Nach Gr\xf6\xdfe sortiert",
                    "Ordner hinzuf\xfcgen",
                    "Wiederherstellen",
                    "Speichern",
                    "Speichern als",
                    "Gr\xf6\xdfe \xe4ndern",
                    "Gr\xf6\xdfe anpassen",
                    "Breite",
                    "H\xf6he",
                    "Seitenverh\xe4ltnis beibehalten",
                    "Ja",
                    "Nein",
                    "Entfernen",
                    "Markieren",
                    "Zeichen: %d",
                    "W\xf6rter: %d",
                    "Alles markieren",
                    "Markieren: %s",
                    "Alles markieren",
                    "Vertikale Ausrichtung",
                    "Unterteilen",
                    "Vertikal unterteilen",
                    "Horizontal unterteilen",
                    "Vereinen",
                    "Spalte hinzuf\xfcgen",
                    "Zeile hinzuf\xfcgen",
                    "L\xf6schen",
                    "Rand",
                    null,
                    "Durchstreichen",
                    "Unterstreichen",
                    "Hochstellen",
                    "Tiefstellen",
                    "Auswahl ausschneiden",
                    "Pause",
                    "Suche nach",
                    "Ersetzen durch",
                    "Ersetzen",
                    "Einf\xfcgen",
                    "W\xe4hlen Sie den Inhalt zum Einf\xfcgen aus",
                    "Sie k\xf6nnen nur Ihre eigenen Bilder bearbeiten. Dieses Bild auf den Host herunterladen?",
                    "Das Bild wurde erfolgreich auf den Server hochgeladen!",
                    "Palette",
                    "In diesem Verzeichnis befinden sich keine Dateien.",
                    "Umbenennen",
                    "Geben Sie einen neuen Namen ein",
                    "Vorschau",
                    "Herunterladen",
                    "Aus Zwischenablage einf\xfcgen",
                    "Ihr Browser unterst\xfctzt keinen direkten Zugriff auf die Zwischenablage.",
                    "Auswahl kopieren",
                    "Kopieren",
                    "Radius f\xfcr abgerundete Ecken",
                    "Alle anzeigen",
                    "Anwenden",
                    "Bitte f\xfcllen Sie dieses Feld aus",
                    "Bitte geben Sie eine Web-Adresse ein",
                    "Standard",
                    "Kreis",
                    "Punkte",
                    "Quadrate",
                    "Suchen",
                    "Suche vorherige",
                    "Weitersuchen",
                    "className (CSS) einf\xfcgen",
                    "Dr\xfccken Sie Alt f\xfcr benutzerdefinierte Gr\xf6\xdfenanpassung"
                ];
            },
            51048: function(e) {
                e.exports.default = {
                    "Type something": "Start writing...",
                    pencil: "Edit",
                    Quadrate: "Square"
                };
            },
            22999: function(e) {
                e.exports.default = [
                    "Escriba algo...",
                    "Acerca de Jodit",
                    "Jodit Editor",
                    null,
                    "Gu\xeda de usuario Jodit",
                    "contiene ayuda detallada para el uso.",
                    "Para informaci\xf3n sobre la licencia, por favor visite nuestro sitio:",
                    "Compre la versi\xf3n completa",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Todos los derechos reservados.",
                    "Anclar",
                    "Abrir en nueva pesta\xf1a",
                    "Abrir editor en pantalla completa",
                    "Limpiar formato",
                    "Color de relleno o de letra",
                    "Rehacer",
                    "Deshacer",
                    "Negrita",
                    "Cursiva",
                    "Insertar lista no ordenada",
                    "Insertar lista ordenada",
                    "Alinear Centrado",
                    "Alinear Justificado",
                    "Alinear Izquierda",
                    "Alinear Derecha",
                    "Insertar l\xednea horizontal",
                    "Insertar imagen",
                    "Insertar archivo",
                    "Insertar video de Youtube/vimeo",
                    "Insertar v\xednculo",
                    "Tama\xf1o de letra",
                    "Familia de letra",
                    "Insertar bloque",
                    "Normal",
                    "Encabezado 1",
                    "Encabezado 2",
                    "Encabezado 3",
                    "Encabezado 4",
                    "Cita",
                    "C\xf3digo",
                    "Insertar",
                    "Insertar tabla",
                    "Disminuir sangr\xeda",
                    "Aumentar sangr\xeda",
                    "Seleccionar caracter especial",
                    "Insertar caracter especial",
                    "Copiar formato",
                    "Cambiar modo",
                    "M\xe1rgenes",
                    "arriba",
                    "derecha",
                    "abajo",
                    "izquierda",
                    "Estilos CSS",
                    "Clases CSS",
                    "Alinear",
                    "Derecha",
                    "Centrado",
                    "Izquierda",
                    "--No Establecido--",
                    "Fuente",
                    "T\xedtulo",
                    "Texto Alternativo",
                    "V\xednculo",
                    "Abrir v\xednculo en nueva pesta\xf1a",
                    "Imagen",
                    "Archivo",
                    "Avanzado",
                    "Propiedades de imagen",
                    "Cancelar",
                    "Aceptar",
                    "El c\xf3digo es similar a HTML. \xbfMantener como HTML?",
                    "Pegar como HTML?",
                    "Mantener",
                    "Limpiar",
                    "Insertar como texto",
                    "Insertar solo texto",
                    "Pegado desde Word detectado",
                    "El contenido pegado proviene de un documento de Microsoft Word/Excel. \xbfDesea mantener el formato o limpiarlo?",
                    "Buscar archivo",
                    "Error al cargar la lista",
                    "Error al cargar las carpetas",
                    "\xbfEst\xe1 seguro?",
                    "Entre nombre de carpeta",
                    "Crear carpeta",
                    "Entre el nombre",
                    "Soltar imagen",
                    "Soltar archivo",
                    "o click",
                    "Texto alternativo",
                    "Buscar",
                    "Subir",
                    "Fondo",
                    "Texto",
                    "Arriba",
                    "Centro",
                    "Abajo",
                    "Insertar columna antes",
                    "Interar columna despu\xe9s",
                    "Insertar fila arriba",
                    "Insertar fila debajo",
                    "Borrar tabla",
                    "Borrar fila",
                    "Borrar columna",
                    "Vaciar celda",
                    "HTML",
                    "negrita",
                    "cursiva",
                    "Brocha",
                    "V\xednculo",
                    "deshacer",
                    "rehacer",
                    "Tabla",
                    "Imagen",
                    "Borrar",
                    "P\xe1rrafo",
                    "Tama\xf1o de letra",
                    "Video",
                    "Letra",
                    "Acerca de",
                    "Imprimir",
                    "subrayar",
                    "tachar",
                    "sangr\xeda",
                    "quitar sangr\xeda",
                    "Tama\xf1o completo",
                    "encoger",
                    "l\xednea horizontal",
                    "lista sin ordenar",
                    "lista ordenada",
                    "Cortar",
                    "Seleccionar todo",
                    "Incluir c\xf3digo",
                    "Abrir v\xednculo",
                    "Editar v\xednculo",
                    "No seguir",
                    "Desvincular",
                    "Ver",
                    "Para editar",
                    "Actualizar",
                    "URL",
                    "Editar",
                    "Alineaci\xf3n horizontal",
                    "Filtrar",
                    "Ordenar por fecha modificaci\xf3n",
                    "Ordenar por nombre",
                    "Ordenar por tama\xf1o",
                    "Agregar carpeta",
                    "Resetear",
                    "Guardar",
                    "Guardar como...",
                    "Redimensionar",
                    "Recortar",
                    "Ancho",
                    "Alto",
                    "Mantener relaci\xf3n de aspecto",
                    "Si",
                    "No",
                    "Quitar",
                    "Seleccionar",
                    "Caracteres: %d",
                    "Palabras: %d",
                    "Todo",
                    "Seleccionar: %s",
                    "Seleccionar todo",
                    "Alineaci\xf3n vertical",
                    "Dividir",
                    "Dividir vertical",
                    "Dividir horizontal",
                    "Mezclar",
                    "Agregar columna",
                    "Agregar fila",
                    "Borrar",
                    "Borde",
                    null,
                    "Tachado",
                    "Subrayado",
                    "super\xedndice",
                    "sub\xedndice",
                    "Cortar selecci\xf3n",
                    "Pausa",
                    "Buscar",
                    "Reemplazar con",
                    "Reemplazar",
                    "Pegar",
                    "Seleccionar contenido para pegar",
                    "Solo puedes editar tus propias im\xe1genes. \xbfDescargar esta imagen en el servidor?",
                    "\xa1La imagen se ha subido correctamente al servidor!",
                    "paleta",
                    "No hay archivos en este directorio.",
                    "renombrar",
                    "Ingresa un nuevo nombre",
                    "avance",
                    "Descargar",
                    "Pegar desde el portapapeles",
                    "Su navegador no soporta el acceso directo en el portapapeles.",
                    "Selecci\xf3n de copia",
                    "copia",
                    "Radio frontera",
                    "Mostrar todos los",
                    "Aplicar",
                    "Por favor, rellene este campo",
                    "Por favor, introduzca una direcci\xf3n web",
                    "Predeterminado",
                    "C\xedrculo",
                    "Punto",
                    "Cuadro",
                    "Encontrar",
                    "Buscar Anterior",
                    "Buscar Siguiente",
                    "Insertar nombre de clase",
                    "Presione Alt para cambiar el tama\xf1o personalizado"
                ];
            },
            34145: function(e) {
                e.exports.default = [
                    "Ecrivez ici",
                    "A propos de Jodit",
                    "Editeur Jodit",
                    null,
                    "Guide de l'utilisateur",
                    "Aide d\xe9taill\xe9e \xe0 l'utilisation",
                    "Consulter la licence sur notre site web:",
                    "Acheter la version compl\xe8te",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Tous droits r\xe9serv\xe9s.",
                    "Ancre",
                    "Ouvrir dans un nouvel onglet",
                    "Ouvrir l'\xe9diteur en pleine page",
                    "Supprimer le formattage",
                    "Modifier la couleur du fond ou du texte",
                    "Refaire",
                    "D\xe9faire",
                    "Gras",
                    "Italique",
                    "Liste non ordonn\xe9e",
                    "Liste ordonn\xe9e",
                    "Centrer",
                    "Justifier",
                    "Aligner \xe0 gauche ",
                    "Aligner \xe0 droite",
                    "Ins\xe9rer une ligne horizontale",
                    "Ins\xe9rer une image",
                    "Ins\xe9rer un fichier",
                    "Ins\xe9rer une vid\xe9o",
                    "Ins\xe9rer un lien",
                    "Taille des caract\xe8res",
                    "Famille des caract\xe8res",
                    "Bloc formatt\xe9",
                    "Normal",
                    "Titre 1",
                    "Titre 2",
                    "Titre 3",
                    "Titre 4",
                    "Citation",
                    "Code",
                    "Ins\xe9rer",
                    "Ins\xe9rer un tableau",
                    "Diminuer le retrait",
                    "Retrait plus",
                    "S\xe9lectionnez un caract\xe8re sp\xe9cial",
                    "Ins\xe9rer un caract\xe8re sp\xe9cial",
                    "Cloner le format",
                    "Mode wysiwyg <-> code html",
                    "Marges",
                    "haut",
                    "droite",
                    "Bas",
                    "gauche",
                    "Styles",
                    "Classes",
                    "Alignement",
                    "Droite",
                    "Centre",
                    "Gauche",
                    "--Non disponible--",
                    "Source",
                    "Titre",
                    "Alternative",
                    "Lien",
                    "Ouvrir le lien dans un nouvel onglet",
                    "Image",
                    "fichier",
                    "Avanc\xe9",
                    "Propri\xe9t\xe9s de l'image",
                    "Annuler",
                    "OK",
                    "Votre texte que vous essayez de coller est similaire au HTML. Collez-le en HTML?",
                    "Coller en HTML?",
                    "Sauvegarder l'original",
                    "Nettoyer",
                    "Coller en tant que texte",
                    "Coller le texte seulement",
                    "C'est peut-\xeatre un fragment de Word ou Excel",
                    "Le contenu que vous ins\xe9rez provient d'un document Microsoft Word / Excel. Voulez-vous enregistrer le format ou l'effacer?",
                    "Explorateur de fichiers",
                    "Erreur de liste de chargement",
                    "Erreur de dossier de chargement",
                    "Etes-vous s\xfbrs ?",
                    "Entrer le nom de dossier",
                    "Cr\xe9er un dossier",
                    "type de fichier",
                    "Coller une image",
                    "D\xe9poser un fichier",
                    "ou cliquer",
                    "Texte de remplacemement",
                    "Chercher",
                    "Charger",
                    "Arri\xe8re-plan",
                    "Texte",
                    "Haut",
                    "Milieu",
                    "Bas",
                    "Ins\xe9rer une colonne avant",
                    "Ins\xe9rer une colonne apr\xe8s",
                    "Ins\xe9rer une ligne au dessus",
                    "Ins\xe9rer une ligne en dessous",
                    "Supprimer le tableau",
                    "Supprimer la ligne",
                    "Supprimer la colonne",
                    "Vider la cellule",
                    "la source",
                    "gras",
                    "italique",
                    "pinceau",
                    "lien",
                    "annuler",
                    "refaire",
                    "tableau",
                    "image",
                    "gomme",
                    "clause",
                    "taille de police",
                    "Video",
                    "police",
                    "\xe0 propos de l'\xe9diteur",
                    "impression",
                    "soulign\xe9",
                    "barr\xe9",
                    "indentation",
                    "retrait",
                    "taille r\xe9elle",
                    "taille conventionnelle",
                    "la ligne",
                    "Liste",
                    "Liste num\xe9rot\xe9e",
                    "Couper",
                    "S\xe9lectionner tout",
                    null,
                    "Ouvrir le lien",
                    "Modifier le lien",
                    "Attribut Nofollow",
                    "Supprimer le lien",
                    "Voir",
                    "Pour \xe9diter",
                    "Mettre \xe0 jour",
                    "URL",
                    null,
                    "Alignement horizontal",
                    "Filtre",
                    "Trier par modification",
                    "Trier par nom",
                    "Trier par taille",
                    "Cr\xe9er le dossier",
                    "Restaurer",
                    "Sauvegarder",
                    "Enregistrer sous",
                    "Changer la taille",
                    "Taille de garniture",
                    "Largeur",
                    "Hauteur",
                    "Garder les proportions",
                    "Oui",
                    "Non",
                    "Supprimer",
                    "Mettre en \xe9vidence",
                    "Symboles: %d",
                    "Mots: %d",
                    null,
                    "Mettre en \xe9vidence: %s",
                    "Tout s\xe9lectionner",
                    "Alignement vertical",
                    "Split",
                    "Split vertical",
                    "Split horizontal",
                    "aller",
                    "Ajouter une colonne",
                    "Ajouter une rang\xe9e",
                    "Effacer",
                    "Bordure",
                    null,
                    "Barrer",
                    "Souligner",
                    "exposant",
                    "indice",
                    "Couper la s\xe9lection",
                    "Pause",
                    "Rechercher",
                    "Remplacer par",
                    "Remplacer",
                    "Coller",
                    "Choisissez le contenu \xe0 coller",
                    "Vous ne pouvez \xe9diter que vos propres images. T\xe9l\xe9chargez cette image sur l'h\xf4te?",
                    "L'image a \xe9t\xe9 t\xe9l\xe9charg\xe9e avec succ\xe8s sur le serveur!",
                    "Palette",
                    "Il n'y a aucun fichier dans ce r\xe9pertoire.",
                    "renommer",
                    "Entrez un nouveau nom",
                    "Aper\xe7u",
                    "T\xe9l\xe9charger",
                    "Coller \xe0 partir du presse-papiers",
                    "Votre navigateur ne prend pas en charge l'acc\xe8s direct au presse-papiers.",
                    "Copier la s\xe9lection",
                    "copie",
                    "Rayon des bordures",
                    "Afficher tous",
                    "Appliquer",
                    "Veuillez remplir ce champ",
                    "Veuillez entrer une adresse web",
                    "Par d\xe9faut",
                    "Cercle",
                    "Point",
                    "Quadratique",
                    "Trouver",
                    "Pr\xe9c\xe9dent",
                    "Suivant",
                    "Ins\xe9rer un nom de classe",
                    "Appuyez sur Alt pour un redimensionnement personnalis\xe9"
                ];
            },
            40272: function(e) {
                e.exports.default = [
                    "\u05D4\u05E7\u05DC\u05D3 \u05DE\u05E9\u05D4\u05D5...",
                    "About Jodit",
                    "Jodit Editor",
                    null,
                    "Jodit User's Guide",
                    "contains detailed help for using.",
                    "For information about the license, please go to our website:",
                    "Buy full version",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                    "\u05DE\u05E7\u05D5\u05DD \u05E2\u05D9\u05D2\u05D5\u05DF",
                    "\u05E4\u05EA\u05D7 \u05D1\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D4 \u05D7\u05D3\u05E9\u05D4",
                    "\u05E4\u05EA\u05D7 \u05D0\u05EA \u05D4\u05E2\u05D5\u05E8\u05DA \u05D1\u05D7\u05DC\u05D5\u05DF \u05D7\u05D3\u05E9",
                    "\u05E0\u05E7\u05D4 \u05E2\u05D9\u05E6\u05D5\u05D1",
                    "\u05E9\u05E0\u05D4 \u05E6\u05D1\u05E2 \u05D8\u05E7\u05E1\u05D8 \u05D0\u05D5 \u05E8\u05E7\u05E2",
                    "\u05D1\u05E6\u05E2 \u05E9\u05D5\u05D1",
                    "\u05D1\u05D8\u05DC",
                    "\u05DE\u05D5\u05D3\u05D2\u05E9",
                    "\u05E0\u05D8\u05D5\u05D9",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E8\u05E9\u05D9\u05DE\u05EA \u05EA\u05D1\u05DC\u05D9\u05D8\u05D9\u05DD",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E8\u05E9\u05D9\u05DE\u05D4 \u05DE\u05DE\u05D5\u05E1\u05E4\u05E8\u05EA",
                    "\u05DE\u05E8\u05DB\u05D6",
                    "\u05D9\u05E9\u05E8 ",
                    "\u05D9\u05E9\u05E8 \u05DC\u05E9\u05DE\u05D0\u05DC",
                    "\u05D9\u05E9\u05E8 \u05DC\u05D9\u05DE\u05D9\u05DF",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
                    "\u05D4\u05DB\u05E0\u05E1 \u05EA\u05DE\u05D5\u05E0\u05D4",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E7\u05D5\u05D1\u05E5",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E1\u05E8\u05D8\u05D5\u05DF \u05D5\u05D9\u05D3\u05D0\u05D5 \u05DEYouTube/Vimeo",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E7\u05D9\u05E9\u05D5\u05E8",
                    "\u05D2\u05D5\u05D3\u05DC \u05D2\u05D5\u05E4\u05DF",
                    "\u05D2\u05D5\u05E4\u05DF",
                    "\u05DE\u05E2\u05D5\u05E6\u05D1 \u05DE\u05E8\u05D0\u05E9",
                    "\u05E8\u05D2\u05D9\u05DC",
                    "\u05DB\u05D5\u05EA\u05E8\u05EA 1",
                    "\u05DB\u05D5\u05EA\u05E8\u05EA 2",
                    "\u05DB\u05D5\u05EA\u05E8\u05EA 3",
                    "\u05DB\u05D5\u05EA\u05E8\u05EA 4",
                    "\u05E6\u05D9\u05D8\u05D5\u05D8",
                    "\u05E7\u05D5\u05D3",
                    "\u05D4\u05DB\u05E0\u05E1",
                    "\u05D4\u05DB\u05E0\u05E1 \u05D8\u05D1\u05DC\u05D4",
                    "\u05D4\u05E7\u05D8\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4",
                    "\u05D4\u05D2\u05D3\u05DC \u05DB\u05E0\u05D9\u05E1\u05D4",
                    "\u05D1\u05D7\u05E8 \u05EA\u05D5 \u05DE\u05D9\u05D5\u05D7\u05D3",
                    "\u05D4\u05DB\u05E0\u05E1 \u05EA\u05D5 \u05DE\u05D9\u05D5\u05D7\u05D3",
                    "\u05D4\u05E2\u05EA\u05E7 \u05E2\u05D9\u05E6\u05D5\u05D1",
                    "\u05D4\u05D7\u05DC\u05E3 \u05DE\u05E6\u05D1",
                    "\u05E8\u05D9\u05D5\u05D5\u05D7",
                    "\u05E2\u05DC\u05D9\u05D5\u05DF",
                    "\u05D9\u05DE\u05D9\u05DF",
                    "\u05EA\u05D7\u05EA\u05D5\u05DF",
                    "\u05E9\u05DE\u05D0\u05DC",
                    "\u05E2\u05D9\u05E6\u05D5\u05D1 CSS",
                    "\u05DE\u05D7\u05DC\u05E7\u05EA CSS",
                    "\u05D9\u05D9\u05E9\u05D5\u05E8",
                    "\u05D9\u05DE\u05D9\u05DF",
                    "\u05DE\u05E8\u05DB\u05D6",
                    "\u05E9\u05DE\u05D0\u05DC",
                    "--\u05DC\u05D0 \u05E0\u05E7\u05D1\u05E2--",
                    "\u05DE\u05E7\u05D5\u05E8",
                    "\u05DB\u05D5\u05EA\u05E8\u05EA",
                    "\u05DB\u05D9\u05EA\u05D5\u05D1 \u05D7\u05DC\u05D5\u05E4\u05D9",
                    "\u05E7\u05D9\u05E9\u05D5\u05E8",
                    "\u05E4\u05EA\u05D7 \u05D1\u05DB\u05E8\u05D8\u05D9\u05E1\u05D9\u05D4 \u05D7\u05D3\u05E9\u05D4",
                    "\u05EA\u05DE\u05D5\u05E0\u05D4",
                    "\u05E7\u05D5\u05D1\u05E5",
                    "\u05DE\u05EA\u05E7\u05D3\u05DD",
                    "\u05DE\u05D0\u05E4\u05D9\u05D9\u05E0\u05D9 \u05EA\u05DE\u05D5\u05E0\u05D4",
                    "\u05D1\u05D9\u05D8\u05D5\u05DC",
                    "\u05D0\u05D9\u05E9\u05D5\u05E8",
                    "\u05D4\u05E7\u05D5\u05D3 \u05D3\u05D5\u05DE\u05D4 \u05DCHTML, \u05D4\u05D0\u05DD \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05DBHTML",
                    "\u05D4\u05D3\u05D1\u05E7 \u05DBHTML",
                    "\u05D4\u05E9\u05D0\u05E8",
                    "\u05E0\u05E7\u05D4",
                    "\u05D4\u05DB\u05E0\u05E1 \u05DB\u05D8\u05E7\u05E1\u05D8",
                    "\u05D4\u05DB\u05E0\u05E1 \u05D8\u05E7\u05E1\u05D8 \u05D1\u05DC\u05D1\u05D3",
                    '\u05D6\u05D5\u05D4\u05EA\u05D4 \u05D4\u05D3\u05D1\u05E7\u05D4 \u05DE"\u05D5\u05D5\u05E8\u05D3"',
                    "\u05D4\u05EA\u05D5\u05DB\u05DF \u05D4\u05DE\u05D5\u05D3\u05D1\u05E7 \u05DE\u05D2\u05D9\u05E2 \u05DE\u05DE\u05E1\u05DE\u05DA \u05D5\u05D5\u05E8\u05D3/\u05D0\u05E7\u05E1\u05DC. \u05D4\u05D0\u05DD \u05D1\u05E8\u05E6\u05D5\u05E0\u05DA \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05D0\u05EA \u05D4\u05E2\u05D9\u05E6\u05D5\u05D1 \u05D0\u05D5 \u05DC\u05E0\u05E7\u05D5\u05EA\u05D5",
                    "\u05E1\u05D9\u05D9\u05E8 \u05D4\u05E7\u05D1\u05E6\u05D9\u05DD",
                    "\u05E9\u05D2\u05D9\u05D0\u05D4  \u05D1\u05D6\u05DE\u05DF \u05D8\u05E2\u05D9\u05E0\u05EA \u05E8\u05E9\u05D9\u05DE\u05D4",
                    "\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05D6\u05DE\u05DF \u05D8\u05E2\u05D9\u05E0\u05EA \u05EA\u05E7\u05D9\u05D5\u05EA",
                    "\u05D4\u05D0\u05DD \u05D0\u05EA\u05D4 \u05D1\u05D8\u05D5\u05D7?",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E9\u05DD \u05EA\u05E7\u05D9\u05D4",
                    "\u05E6\u05D5\u05E8 \u05EA\u05E7\u05D9\u05D4",
                    "\u05E1\u05D5\u05D2 \u05D4\u05E7\u05D5\u05D1\u05E5",
                    "\u05D4\u05E1\u05E8 \u05EA\u05DE\u05D5\u05E0\u05D4",
                    "\u05D4\u05E1\u05E8 \u05E7\u05D5\u05D1\u05E5",
                    "\u05D0\u05D5 \u05DC\u05D7\u05E5",
                    "\u05DB\u05D9\u05EA\u05D5\u05D1 \u05D7\u05DC\u05D5\u05E4\u05D9",
                    "\u05E1\u05D9\u05D9\u05E8",
                    "\u05D4\u05E2\u05DC\u05D4",
                    "\u05E8\u05E7\u05E2",
                    "\u05D8\u05E7\u05E1\u05D8",
                    "\u05E2\u05DC\u05D9\u05D5\u05DF",
                    "\u05DE\u05E8\u05DB\u05D6",
                    "\u05EA\u05D7\u05EA\u05D5\u05DF",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E2\u05DE\u05D5\u05D3\u05D4 \u05DC\u05E4\u05E0\u05D9",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E2\u05DE\u05D5\u05D3\u05D4 \u05D0\u05D7\u05E8\u05D9",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E9\u05D5\u05E8\u05D4 \u05DE\u05E2\u05DC",
                    "\u05D4\u05DB\u05E0\u05E1 \u05E9\u05D5\u05E8\u05D4 \u05DE\u05EA\u05D7\u05EA",
                    "\u05DE\u05D7\u05E7 \u05D8\u05D1\u05DC\u05D4",
                    "\u05DE\u05D7\u05E7 \u05E9\u05D5\u05E8\u05D4",
                    "\u05DE\u05D7\u05E7 \u05E2\u05DE\u05D5\u05D3\u05D4",
                    "\u05E8\u05D5\u05E7\u05DF \u05EA\u05D0",
                    "HTML",
                    "\u05DE\u05D5\u05D3\u05D2\u05E9",
                    "\u05E0\u05D8\u05D5\u05D9",
                    "\u05DE\u05D1\u05E8\u05E9\u05EA",
                    "\u05E7\u05D9\u05E9\u05D5\u05E8",
                    "\u05D1\u05D8\u05DC",
                    "\u05D1\u05E6\u05E2 \u05E9\u05D5\u05D1",
                    "\u05D8\u05D1\u05DC\u05D4",
                    "\u05EA\u05DE\u05D5\u05E0\u05D4",
                    "\u05DE\u05D7\u05E7",
                    "\u05E4\u05E1\u05E7\u05D4",
                    "\u05D2\u05D5\u05D3\u05DC \u05D2\u05D5\u05E4\u05DF",
                    "\u05D5\u05D9\u05D3\u05D0\u05D5",
                    "\u05D2\u05D5\u05E4\u05DF",
                    "\u05E2\u05DC\u05D9\u05E0\u05D5",
                    "\u05D4\u05D3\u05E4\u05E1",
                    "\u05E7\u05D5 \u05EA\u05D7\u05EA\u05D5\u05DF",
                    "\u05E7\u05D5 \u05D7\u05D5\u05E6\u05D4",
                    "\u05D4\u05D2\u05D3\u05DC \u05DB\u05E0\u05D9\u05E1\u05D4",
                    "\u05D4\u05E7\u05D8\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4",
                    "\u05D2\u05D5\u05D3\u05DC \u05DE\u05DC\u05D0",
                    "\u05DB\u05D5\u05D5\u05E5",
                    "\u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
                    "\u05E8\u05E9\u05D9\u05DE\u05EA \u05EA\u05D1\u05DC\u05D9\u05D8\u05D9\u05DD",
                    "\u05E8\u05E9\u05D9\u05DE\u05D4 \u05DE\u05DE\u05D5\u05E1\u05E4\u05E8\u05EA",
                    "\u05D7\u05EA\u05D5\u05DA",
                    "\u05D1\u05D7\u05E8 \u05D4\u05DB\u05DC",
                    "\u05D4\u05D5\u05E1\u05E3 \u05E7\u05D5\u05D3",
                    "\u05E4\u05EA\u05D7 \u05E7\u05D9\u05E9\u05D5\u05E8",
                    "\u05E2\u05E8\u05D5\u05DA \u05E7\u05D9\u05E9\u05D5\u05E8",
                    "\u05DC\u05DC\u05D0 \u05DE\u05E2\u05E7\u05D1",
                    "\u05D1\u05D8\u05DC \u05E7\u05D9\u05E9\u05D5\u05E8",
                    "\u05D4\u05E6\u05D2",
                    "\u05DB\u05D3\u05D9 \u05DC\u05E2\u05E8\u05D5\u05DA",
                    "\u05E2\u05D3\u05DB\u05DF",
                    "\u05DB\u05EA\u05D5\u05D1\u05EA",
                    "\u05E2\u05E8\u05D5\u05DA",
                    "\u05D9\u05D9\u05E9\u05D5\u05E8 \u05D0\u05D5\u05E4\u05E7\u05D9",
                    "\u05E1\u05E0\u05DF",
                    "\u05DE\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E9\u05D9\u05E0\u05D5\u05D9",
                    "\u05DE\u05D9\u05D9\u05DF \u05DC\u05E4\u05D9 \u05E9\u05DD",
                    "\u05DE\u05D9\u05D9\u05DF \u05DC\u05E4\u05D9 \u05D2\u05D5\u05D3\u05DC",
                    "\u05D4\u05D5\u05E1\u05E3 \u05EA\u05E7\u05D9\u05D9\u05D4",
                    "\u05D0\u05E4\u05E1",
                    "\u05E9\u05DE\u05D5\u05E8",
                    "\u05E9\u05DE\u05D5\u05E8 \u05D1\u05E9\u05DD...",
                    "\u05E9\u05E0\u05D4 \u05D2\u05D5\u05D3\u05DC",
                    "\u05D7\u05EA\u05D5\u05DA",
                    "\u05E8\u05D5\u05D7\u05D1",
                    "\u05D2\u05D5\u05D1\u05D4",
                    "\u05E9\u05DE\u05D5\u05E8 \u05D9\u05D7\u05E1",
                    "\u05DB\u05DF",
                    "\u05DC\u05D0",
                    "\u05D4\u05E1\u05E8",
                    "\u05D1\u05D7\u05E8",
                    "\u05EA\u05D5\u05D5\u05D9\u05DD: %d",
                    "\u05DE\u05D9\u05DC\u05D9\u05DD: %d",
                    "\u05D4\u05DB\u05DC",
                    "\u05E0\u05D1\u05D7\u05E8: %s",
                    "\u05D1\u05D7\u05E8 \u05D4\u05DB\u05DC",
                    "\u05D9\u05D9\u05E9\u05D5\u05E8 \u05D0\u05E0\u05DB\u05D9",
                    "\u05E4\u05D9\u05E6\u05D5\u05DC",
                    "\u05E4\u05D9\u05E6\u05D5\u05DC \u05D0\u05E0\u05DB\u05D9",
                    "\u05E4\u05D9\u05E6\u05D5\u05DC \u05D0\u05D5\u05E4\u05E7\u05D9",
                    "\u05DE\u05D6\u05D2",
                    "\u05D4\u05D5\u05E1\u05E3 \u05E2\u05DE\u05D5\u05D3\u05D4",
                    "\u05D4\u05D5\u05E1\u05E3 \u05E9\u05D5\u05E8\u05D4",
                    "\u05DE\u05D7\u05E7",
                    "\u05DE\u05E1\u05D2\u05E8\u05EA",
                    null,
                    "\u05E7\u05D5 \u05D7\u05D5\u05E6\u05D4",
                    "\u05E7\u05D5 \u05EA\u05D7\u05EA\u05D5\u05DF",
                    "superscript",
                    "subscript",
                    "\u05D2\u05D6\u05D5\u05E8 \u05D1\u05D7\u05D9\u05E8\u05D4",
                    "\u05E9\u05D1\u05D9\u05E8\u05EA \u05E9\u05D5\u05E8\u05D4",
                    "\u05D7\u05E4\u05E9",
                    "\u05D4\u05D7\u05DC\u05E3 \u05D1",
                    "\u05DC\u05D4\u05D7\u05DC\u05D9\u05E3",
                    "\u05D4\u05D3\u05D1\u05E7",
                    "\u05D1\u05D7\u05E8 \u05EA\u05D5\u05DB\u05DF \u05DC\u05D4\u05D3\u05D1\u05E7\u05D4",
                    "\u05E8\u05E7 \u05E7\u05D1\u05E6\u05D9\u05DD \u05D4\u05DE\u05E9\u05D5\u05D9\u05D9\u05DB\u05D9\u05DD \u05E9\u05DC\u05DA \u05E0\u05D9\u05EA\u05E0\u05D9\u05DD \u05DC\u05E2\u05E8\u05D9\u05DB\u05D4. \u05D4\u05D0\u05DD \u05DC\u05D4\u05D5\u05E8\u05D9\u05D3 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D1\u05E5?",
                    "\u05D4\u05EA\u05DE\u05D5\u05E0\u05D4 \u05E2\u05DC\u05EA\u05D4 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4!",
                    "\u05DC\u05D5\u05D7",
                    "\u05D0\u05D9\u05DF \u05E7\u05D1\u05E6\u05D9\u05DD \u05D1\u05E1\u05E4\u05E8\u05D9\u05D4 \u05D6\u05D5.",
                    "\u05D4\u05D5\u05E0\u05D2\u05E8\u05D9\u05EA",
                    "\u05D4\u05D6\u05DF \u05E9\u05DD \u05D7\u05D3\u05E9",
                    "\u05EA\u05E6\u05D5\u05D2\u05D4 \u05DE\u05E7\u05D3\u05D9\u05DE\u05D4",
                    "\u05D4\u05D5\u05E8\u05D3",
                    "\u05DC\u05D4\u05D3\u05D1\u05D9\u05E7 \u05DE\u05D4\u05DC\u05D5\u05D7",
                    "\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA \u05DC\u05D0 \u05EA\u05D5\u05DE\u05DA \u05D2\u05D9\u05E9\u05D4 \u05D9\u05E9\u05D9\u05E8\u05D4 \u05DC\u05DC\u05D5\u05D7.",
                    "\u05D4\u05E2\u05EA\u05E7 \u05D1\u05D7\u05D9\u05E8\u05D4",
                    "\u05D4\u05E2\u05EA\u05E7",
                    "\u05E8\u05D3\u05D9\u05D5\u05E1 \u05D4\u05D2\u05D1\u05D5\u05DC",
                    "\u05D4\u05E6\u05D2 \u05D0\u05EA \u05DB\u05DC",
                    "\u05D4\u05D7\u05DC",
                    "\u05E0\u05D0 \u05DC\u05DE\u05DC\u05D0 \u05E9\u05D3\u05D4 \u05D6\u05D4",
                    "\u05D0\u05E0\u05D0 \u05D4\u05D6\u05DF \u05DB\u05EA\u05D5\u05D1\u05EA \u05D0\u05D9\u05E0\u05D8\u05E8\u05E0\u05D8",
                    "\u05D1\u05E8\u05D9\u05E8\u05EA \u05D4\u05DE\u05D7\u05D3\u05DC",
                    "\u05DE\u05E2\u05D2\u05DC",
                    "\u05E0\u05E7\u05D5\u05D3\u05D4",
                    "\u05D4\u05E8\u05D9\u05D1\u05D5\u05E2 \u05D4\u05D6\u05D4",
                    "\u05DC\u05DE\u05E6\u05D5\u05D0",
                    "\u05DE\u05E6\u05D0 \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3\u05DD",
                    "\u05D7\u05E4\u05E9 \u05D0\u05EA \u05D4\u05D1\u05D0",
                    "\u05D4\u05DB\u05E0\u05E1 \u05D0\u05EA \u05E9\u05DD \u05D4\u05DB\u05D9\u05EA\u05D4",
                    "\u05DC\u05D7\u05E5 \u05E2\u05DC \u05D0\u05DC\u05D8 \u05DC\u05E9\u05D9\u05E0\u05D5\u05D9 \u05D2\u05D5\u05D3\u05DC \u05DE\u05D5\u05EA\u05D0\u05DD \u05D0\u05D9\u05E9\u05D9\u05EA"
                ];
            },
            2978: function(e) {
                e.exports.default = [
                    "\xcdrjon be valamit",
                    "Joditr\xf3l",
                    "Jodit Editor",
                    "Ingyenes v\xe1ltozat",
                    "Jodit \xfatmutat\xf3",
                    "tov\xe1bbi seg\xedts\xe9get tartalmaz",
                    "Tov\xe1bbi licence inform\xe1ci\xf3k\xe9rt l\xe1togassa meg a weboldalunkat:",
                    "Teljes verzi\xf3 megv\xe1s\xe1rl\xe1sa",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Minden jog fenntartva.",
                    "Horgony",
                    "Megnyit\xe1s \xfaj lapon",
                    "Megnyit\xe1s teljes m\xe9retben",
                    "Form\xe1z\xe1s t\xf6rl\xe9se",
                    "H\xe1tt\xe9r/sz\xf6veg sz\xedn",
                    "\xdajra",
                    "Visszavon",
                    "F\xe9lk\xf6v\xe9r",
                    "D\u0151lt",
                    "Pontozott lista",
                    "Sz\xe1mozott lista",
                    "K\xf6z\xe9pre z\xe1rt",
                    "Sorkiz\xe1rt",
                    "Balra z\xe1rt",
                    "Jobbra z\xe1rt",
                    "V\xedzszintes vonal besz\xfar\xe1sa",
                    "K\xe9p besz\xfar\xe1s",
                    "F\xe1jl besz\xfar\xe1s",
                    "Youtube vide\xf3 besz\xfar\xe1sa",
                    "Link besz\xfar\xe1s",
                    "Bet\u0171m\xe9ret",
                    "Bet\u0171t\xedpus",
                    "Form\xe1zott blokk besz\xfar\xe1sa",
                    "Norm\xe1l",
                    "Fejl\xe9c 1",
                    "Fejl\xe9c 2",
                    "Fejl\xe9c 3",
                    "Fejl\xe9c 4",
                    "Id\xe9zet",
                    "K\xf3d",
                    "Besz\xfar",
                    "T\xe1bl\xe1zat besz\xfar\xe1sa",
                    "Beh\xfaz\xe1s cs\xf6kkent\xe9se",
                    "Beh\xfaz\xe1s n\xf6vel\xe9se",
                    "Speci\xe1lis karakter kiv\xe1laszt\xe1sa",
                    "Speci\xe1lis karakter besz\xfar\xe1sa",
                    "K\xe9p form\xe1z\xe1sa",
                    "N\xe9zet v\xe1lt\xe1sa",
                    "Szeg\xe9lyek",
                    "fels\u0151",
                    "jobb",
                    "als\xf3",
                    "bal",
                    "CSS st\xedlusok",
                    "CSS oszt\xe1lyok",
                    "Igaz\xedt\xe1s",
                    "Jobbra",
                    "K\xf6z\xe9pre",
                    "Balra",
                    "Nincs",
                    "Forr\xe1s",
                    "C\xedm",
                    "Helyettes\xedt\u0151 sz\xf6veg",
                    "Link",
                    "Link megnyit\xe1sa \xfaj lapon",
                    "K\xe9p",
                    "F\xe1jl",
                    "Halad\xf3",
                    "K\xe9p tulajdons\xe1gai",
                    "M\xe9gsem",
                    "OK",
                    "A beillesztett sz\xf6veg HTML-nek t\u0171nik. Megtartsuk HTML-k\xe9nt?",
                    "Besz\xfar\xe1s HTML-k\xe9nt",
                    "Megtart\xe1s",
                    "Elvet\xe9s",
                    "Besz\xfar\xe1s sz\xf6vegk\xe9nt",
                    "Csak sz\xf6veg beilleszt\xe9se",
                    "Word-b\u0151l m\xe1solt sz\xf6veg",
                    "A beillesztett tartalom Microsoft Word/Excel dokumentumb\xf3l sz\xe1rmazik. Meg szeretn\xe9 tartani a form\xe1tum\xe1t?",
                    "F\xe1jl tall\xf3z\xf3",
                    "Hiba a lista bet\xf6lt\xe9se k\xf6zben",
                    "Hiba a mapp\xe1k bet\xf6lt\xe9se k\xf6zben",
                    "Biztosan ezt szeretn\xe9?",
                    "\xcdrjon be egy mappanevet",
                    "Mappa l\xe9trehoz\xe1sa",
                    "\xedrjon be bevet",
                    "H\xfazza ide a k\xe9pet",
                    "H\xfazza ide a f\xe1jlt",
                    "vagy kattintson",
                    "Helyettes\xedt\u0151 sz\xf6veg",
                    "Tall\xf3z",
                    "Felt\xf6lt",
                    "H\xe1tt\xe9r",
                    "Sz\xf6veg",
                    "Fent",
                    "K\xf6z\xe9pen",
                    "Lent",
                    "Oszlop besz\xfar\xe1s el\xe9",
                    "Oszlop besz\xfar\xe1s ut\xe1na",
                    "Sor besz\xfar\xe1s f\xf6l\xe9",
                    "Sor besz\xfar\xe1s al\xe1",
                    "T\xe1bl\xe1zat t\xf6rl\xe9se",
                    "Sor t\xf6rl\xe9se",
                    "Oszlop t\xf6rl\xe9se",
                    "Cella tartalm\xe1nak t\xf6rl\xe9se",
                    "HTML",
                    "F\xe9lk\xf6v\xe9r",
                    "D\u0151lt",
                    "Ecset",
                    "Link",
                    "Visszavon",
                    "\xdajra",
                    "T\xe1bl\xe1zat",
                    "K\xe9p",
                    "T\xf6rl\xe9s",
                    "Paragr\xe1fus",
                    "Bet\u0171m\xe9ret",
                    "Vide\xf3",
                    "Bet\u0171",
                    "R\xf3lunk",
                    "Nyomtat",
                    "Al\xe1h\xfazott",
                    "\xc1th\xfazott",
                    "Beh\xfaz\xe1s",
                    "Aussenseiter",
                    "Teljes m\xe9ret",
                    "\xd6sszenyom",
                    "Egyenes vonal",
                    "Lista",
                    "Sz\xe1mozott lista",
                    "Kiv\xe1g",
                    "\xd6sszes kijel\xf6l\xe9se",
                    "Be\xe1gyazott k\xf3d",
                    "Link megnyit\xe1sa",
                    "Link szerkeszt\xe9se",
                    "Nincs k\xf6vet\xe9s",
                    "Link lev\xe1laszt\xe1sa",
                    "fel\xfclvizsg\xe1lat",
                    "Szerkeszt\xe9s",
                    "Friss\xedt",
                    "URL",
                    "Szerkeszt",
                    "V\xedzszintes igaz\xedt\xe1s",
                    "Sz\u0171r\u0151",
                    "Rendez\xe9s m\xf3dos\xedt\xe1s szerint",
                    "Rendez\xe9s n\xe9v szerint",
                    "Rendez\xe9s m\xe9ret szerint",
                    "Mappa hozz\xe1ad\xe1s",
                    "Vissza\xe1ll\xedt",
                    "Ment\xe9s",
                    "Ment\xe9s m\xe1sk\xe9nt...",
                    "\xc1tm\xe9retez\xe9s",
                    "Kiv\xe1g",
                    "Sz\xe9less\xe9g",
                    "Magass\xe1g",
                    "K\xe9par\xe1ny megtart\xe1sa",
                    "Igen",
                    "Nem",
                    "Elt\xe1vol\xedt",
                    "Kijel\xf6l",
                    "Karakterek sz\xe1ma: %d",
                    "Szavak sz\xe1ma: %d",
                    "\xd6sszes",
                    "Kijel\xf6l: %s",
                    "\xd6sszes kijel\xf6l\xe9se",
                    "F\xfcgg\u0151leges igaz\xedt\xe1s",
                    "Feloszt\xe1s",
                    "F\xfcgg\u0151leges feloszt\xe1s",
                    "V\xedzszintes feloszt\xe1s",
                    "\xd6sszevon\xe1s",
                    "Oszlop hozz\xe1ad\xe1s",
                    "Sor hozz\xe1ad\xe1s",
                    "T\xf6rl\xe9s",
                    "Szeg\xe9ly",
                    null,
                    "\xc1th\xfazott",
                    "Al\xe1h\xfazott",
                    "Fels\u0151 index",
                    "Als\xf3 index",
                    "Kiv\xe1g\xe1s",
                    "Sz\xfcnet",
                    "Keres\xe9s",
                    "Csere erre",
                    "Cser\xe9lje ki",
                    "Beilleszt\xe9s",
                    "V\xe1lasszon tartalmat a beilleszt\xe9shez",
                    "Csak a saj\xe1t k\xe9peit tudja szerkeszteni. Let\xf6lti ezt a k\xe9pet?",
                    "K\xe9p sikeresen felt\xf6ltve!",
                    "Palette",
                    "Er zijn geen bestanden in deze map.",
                    "\xe1tnevez\xe9s",
                    "Adja meg az \xfaj nevet",
                    "el\u0151n\xe9zet",
                    "Let\xf6lt\xe9s",
                    "Illessze be a v\xe1g\xf3lap",
                    "A b\xf6ng\xe9sz\u0151 nem t\xe1mogatja a k\xf6zvetlen hozz\xe1f\xe9r\xe9st biztos\xedt a v\xe1g\xf3lapra.",
                    "M\xe1sol\xe1s kiv\xe1laszt\xe1sa",
                    "m\xe1sol\xe1s",
                    "Hat\xe1r sug\xe1r",
                    "\xd6sszes",
                    "Alkalmazni",
                    "K\xe9rj\xfck, t\xf6ltse ki ezt a mez\u0151t,",
                    "K\xe9rj\xfck, \xedrja be a webc\xedmet",
                    "Alap\xe9rtelmezett",
                    "K\xf6r",
                    "Pont",
                    "Quadrate",
                    "Tal\xe1lni",
                    "Megtal\xe1lja El\u0151z\u0151",
                    "K\xf6vetkez\u0151 Keres\xe9se",
                    "Helyezze be az oszt\xe1ly nev\xe9t",
                    "Nyomja meg az Alt egy\xe9ni \xe1tm\xe9retez\xe9s"
                ];
            },
            99113: function(e) {
                e.exports.default = [
                    "Ketik sesuatu",
                    "Tentang Jodit",
                    "Editor Jodit",
                    "Versi Bebas Non-komersil",
                    "Panduan Pengguna Jodit",
                    "mencakup detail bantuan penggunaan",
                    "Untuk informasi tentang lisensi, silakan kunjungi website:",
                    "Beli versi lengkap",
                    "Hak Cipta \xa9 XDSoft.net - Chupurnov Valeriy. Hak cipta dilindungi undang-undang.",
                    "Tautan",
                    "Buka di tab baru",
                    "Buka editor dalam ukuran penuh",
                    "Hapus Pemformatan",
                    "Isi warna atau atur warna teks",
                    "Ulangi",
                    "Batalkan",
                    "Tebal",
                    "Miring",
                    "Sisipkan Daftar Tidak Berurut",
                    "Sisipkan Daftar Berurut",
                    "Tengah",
                    "Penuh",
                    "Kiri",
                    "Kanan",
                    "Sisipkan Garis Horizontal",
                    "Sisipkan Gambar",
                    "Sisipkan Berkas",
                    "Sisipkan video youtube/vimeo",
                    "Sisipkan tautan",
                    "Ukuran font",
                    "Keluarga font",
                    "Sisipkan blok format",
                    "Normal",
                    "Heading 1",
                    "Heading 2",
                    "Heading 3",
                    "Heading 4",
                    "Kutip",
                    "Kode",
                    "Sisipkan",
                    "Sisipkan tabel",
                    "Kurangi Indentasi",
                    "Tambah Indentasi",
                    "Pilih Karakter Spesial",
                    "Sisipkan Karakter Spesial",
                    "Formar warna",
                    "Ubah mode",
                    "Batas",
                    "atas",
                    "kanan",
                    "bawah",
                    "kiri",
                    "Gaya",
                    "Class",
                    "Rata",
                    "Kanan",
                    "Tengah",
                    "Kiri",
                    "--Tidak diset--",
                    "Src",
                    "Judul",
                    "Teks alternatif",
                    "Tautan",
                    "Buka tautan di tab baru",
                    "Gambar",
                    "berkas",
                    "Lanjutan",
                    "Properti gambar",
                    "Batal",
                    "Ya",
                    "Kode Anda cenderung ke HTML. Biarkan sebagai HTML?",
                    "Paste sebagai HTML",
                    "Jaga",
                    "Bersih",
                    "Sisipkan sebagai teks",
                    "Sisipkan hanya teks",
                    "Terdeteksi paste dari Word",
                    "Konten dipaste dari dokumen Microsoft Word/Excel. Apakah Anda ingin tetap menjaga format atau membersihkannya?",
                    "Penjelajah Berkas",
                    "Error ketika memuat list",
                    "Error ketika memuat folder",
                    "Apakah Anda yakin?",
                    "Masukkan nama Direktori",
                    "Buat direktori",
                    "ketik nama",
                    "Letakkan gambar",
                    "Letakkan berkas",
                    "atau klik",
                    "Teks alternatif",
                    "Jelajahi",
                    "Unggah",
                    "Latar Belakang",
                    "Teks",
                    "Atas",
                    "Tengah",
                    "Bawah",
                    "Sisipkan kolom sebelumnya",
                    "Sisipkan kolom setelahnya",
                    "Sisipkan baris di atasnya",
                    "Sisipkan baris di bawahnya",
                    "Hapus tabel",
                    "Hapus baris",
                    "Hapus kolom",
                    "Kosongkan cell",
                    "sumber",
                    "tebal",
                    "miring",
                    "sikat",
                    "tautan",
                    "batalkan",
                    "ulangi",
                    "tabel",
                    "gambar",
                    "penghapus",
                    "paragraf",
                    "ukuran font",
                    "video",
                    "font",
                    "tentang",
                    "cetak",
                    "garis bawah",
                    "coret",
                    "menjorok ke dalam",
                    "menjorok ke luar",
                    "ukuran penuh",
                    "menyusut",
                    "hr",
                    "ul",
                    "ol",
                    "potong",
                    "Pilih semua",
                    "Kode embed",
                    "Buka tautan",
                    "Edit tautan",
                    "No follow",
                    "Hapus tautan",
                    "Mata",
                    "pensil",
                    "Perbarui",
                    "URL",
                    "Edit",
                    "Perataan horizontal",
                    "Filter",
                    "Urutkan berdasarkan perubahan",
                    "Urutkan berdasarkan nama",
                    "Urutkan berdasarkan ukuran",
                    "Tambah folder",
                    "Reset",
                    "Simpan",
                    "Simpan sebagai...",
                    "Ubah ukuran",
                    "Crop",
                    "Lebar",
                    "Tinggi",
                    "Jaga aspek rasio",
                    "Ya",
                    "Tidak",
                    "Copot",
                    "Pilih",
                    "Karakter: %d",
                    "Kata: %d",
                    "Semua",
                    "Pilih %s",
                    "Pilih semua",
                    "Rata vertikal",
                    "Bagi",
                    "Bagi secara vertikal",
                    "Bagi secara horizontal",
                    "Gabungkan",
                    "Tambah kolom",
                    "tambah baris",
                    "Hapus",
                    "Bingkai",
                    "Lisensi: %s",
                    "Coret",
                    "Garis Bawah",
                    "Superskrip",
                    "Subskrip",
                    "Potong pilihan",
                    "Berhenti",
                    "Mencari",
                    "Ganti dengan",
                    "Mengganti",
                    "Paste",
                    "Pilih konten untuk dipaste",
                    "Anda hanya dapat mengedit gambar Anda sendiri. Unduh gambar ini di host?",
                    "Gambar telah sukses diunggah ke host!",
                    "palet",
                    "Tidak ada berkas",
                    "ganti nama",
                    "Masukkan nama baru",
                    "pratinjau",
                    "Unduh",
                    "Paste dari clipboard",
                    "Browser anda tidak mendukung akses langsung ke clipboard.",
                    "Copy seleksi",
                    "copy",
                    "Border radius",
                    "Tampilkan semua",
                    "Menerapkan",
                    "Silahkan mengisi kolom ini",
                    "Silahkan masukkan alamat web",
                    "Default",
                    "Lingkaran",
                    "Dot",
                    "Kuadrat",
                    "Menemukan",
                    "Menemukan Sebelumnya",
                    "Menemukan Berikutnya",
                    "Masukkan nama kelas",
                    "Tekan Alt untuk mengubah ukuran kustom"
                ];
            },
            51923: function(e) {
                e.exports.default = [
                    "Scrivi qualcosa...",
                    "A proposito di Jodit",
                    "Jodit Editor",
                    null,
                    "Guida utente di Jodit",
                    "contiene una guida dettagliata per l'uso.",
                    "Per informazioni sulla licenza, si prega di visitare il nostro sito:",
                    "Acquista la versione completa",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.",
                    "Ancora",
                    "Apri in una nuova scheda",
                    "Apri l'editor a schermo intero",
                    "Formato chiaro",
                    "Riempi colore o lettera",
                    "Ripristina",
                    "Annulla",
                    "Grassetto",
                    "Corsivo",
                    "Inserisci lista non ordinata",
                    "Inserisci l'elenco ordinato",
                    "Allinea Centra",
                    "Allineare Giustificato",
                    "Allinea a Sinistra",
                    "Allinea a Destra",
                    "Inserisci la linea orizzontale",
                    "Inserisci immagine",
                    "Inserisci un file",
                    "Inserisci video Youtube/Vimeo",
                    "Inserisci il link",
                    "Dimensione del carattere",
                    "Tipo di font",
                    "Inserisci blocco",
                    "Normale",
                    "Heading 1",
                    "Heading 2",
                    "Heading 3",
                    "Heading 4",
                    "Citazione",
                    "Codice",
                    "Inserisci",
                    "Inserisci tabella",
                    "Riduci il rientro",
                    "Aumenta il rientro",
                    "Seleziona una funzione speciale",
                    "Inserisci un carattere speciale",
                    "Copia formato",
                    "Cambia modo",
                    "Margini",
                    "su",
                    "destra",
                    "gi\xf9",
                    "sinistra",
                    "Stili CSS",
                    "Classi CSS",
                    "Allinea",
                    "Destra",
                    "Centro",
                    "Sinistra",
                    "--Non Impostato--",
                    "Fonte",
                    "Titolo",
                    "Testo Alternativo",
                    "Link",
                    "Apri il link in una nuova scheda",
                    "Immagine",
                    "Archivio",
                    "Avanzato",
                    "Propriet\xe0 dell'immagine",
                    "Annulla",
                    "Accetta",
                    "Il codice \xe8 simile all'HTML. Mantieni come HTML?",
                    "Incolla come HTML?",
                    "Mantieni",
                    "Pulisci",
                    "Inserisci come testo",
                    "Inserisci solo il testo",
                    "Incollato da Word rilevato",
                    "Il contenuto incollato proviene da un documento Microsoft Word / Excel. Vuoi mantenere il formato o pulirlo?",
                    "Cerca il file",
                    "Errore durante il caricamento dell'elenco",
                    "Errore durante il caricamento delle cartelle",
                    "Sei sicuro?",
                    "Inserisci il nome della cartella",
                    "Crea cartella",
                    "Entre el nombre",
                    "Rilascia l'immagine",
                    "Rilascia file",
                    "o click",
                    "Testo alternativo",
                    "Sfoglia",
                    "Carica",
                    "Sfondo",
                    "Testo",
                    "Su",
                    "Centro",
                    "Sotto",
                    "Inserisci prima la colonna",
                    "Inserisci colonna dopo",
                    "Inserisci la riga sopra",
                    "Inserisci la riga sotto",
                    "Elimina tabella",
                    "Elimina riga",
                    "Elimina colonna",
                    "Cella vuota",
                    "HTML",
                    "Grassetto",
                    "Corsivo",
                    "Pennello",
                    "Link",
                    "Annulla",
                    "Ripristina",
                    "Tabella",
                    "Immagine",
                    "Gomma",
                    "Paragrafo",
                    "Dimensione del carattere",
                    "Video",
                    "Font",
                    "Approposito di",
                    "Stampa",
                    "Sottolineato",
                    "Barrato",
                    "trattino",
                    "annulla rientro",
                    "A grandezza normale",
                    "comprimere",
                    "linea orizzontale",
                    "lista non ordinata",
                    "lista ordinata",
                    "Taglia",
                    "Seleziona tutto",
                    "Includi codice",
                    "Apri link",
                    "Modifica link",
                    "Non seguire",
                    "Togli link",
                    "Recensione",
                    "Per modificare",
                    "Aggiornare",
                    " URL",
                    "Modifica",
                    "Allineamento orizzontale",
                    "Filtro",
                    "Ordina per data di modifica",
                    "Ordina per nome",
                    "Ordina per dimensione",
                    "Aggiungi cartella",
                    "Reset",
                    "Salva",
                    "Salva con nome...",
                    "Ridimensiona",
                    "Tagliare",
                    "Larghezza",
                    "Altezza",
                    "Mantenere le proporzioni",
                    "Si",
                    "No",
                    "Rimuovere",
                    "Seleziona",
                    "Caratteri: %d",
                    "Parole: %d",
                    "Tutto",
                    "Seleziona: %s",
                    "Seleziona tutto",
                    "Allineamento verticala",
                    "Dividere",
                    "Dividere verticalmente",
                    "Diviso orizzontale",
                    "Fondi",
                    "Aggiungi colonna",
                    "Aggiungi riga",
                    "Cancella",
                    "Bordo",
                    null,
                    "Barrato",
                    "Sottolineato",
                    "indice",
                    "deponente",
                    "Taglia la selezione",
                    "Pausa",
                    "Cerca",
                    "Sostituisci con",
                    "Sostituire",
                    "Incolla",
                    "Seleziona il contenuto da incollare",
                    "Puoi modificare solo le tue immagini. Scarica questa immagine sul server?",
                    "L'immagine \xe8 stata caricata con successo sul server!",
                    "tavolozza",
                    "Non ci sono file in questa directory.",
                    "ungherese",
                    "Inserisci un nuovo nome",
                    "anteprima",
                    "Scaricare",
                    "Incolla dagli appunti",
                    "Il tuo browser non supporta l'accesso diretto agli appunti.",
                    "Selezione di copia",
                    "copia",
                    "Border radius",
                    "Mostra tutti",
                    "Applicare",
                    "Si prega di compilare questo campo",
                    "Si prega di inserire un indirizzo web",
                    "Di Default",
                    "Cerchio",
                    "Dot",
                    "Quadrate",
                    "Trovare",
                    "Trova Precedente",
                    "Trova Successivo",
                    "Inserisci il nome della classe",
                    "Premere Alt per il ridimensionamento personalizzato"
                ];
            },
            21268: function(e) {
                e.exports.default = [
                    "\u306A\u306B\u304B\u30BF\u30A4\u30D7\u3057\u3066\u304F\u3060\u3055\u3044",
                    "Jodit\u306B\u3064\u3044\u3066",
                    "Jodit Editor",
                    null,
                    "Jodit \u30E6\u30FC\u30B6\u30FC\u30BA\u30FB\u30AC\u30A4\u30C9",
                    "\u8A73\u3057\u3044\u4F7F\u3044\u65B9",
                    "\u30E9\u30A4\u30BB\u30F3\u30B9\u8A73\u7D30\u306B\u3064\u3044\u3066\u306FJodit Web\u30B5\u30A4\u30C8\u3092\u78BA\u8A8D\u304F\u3060\u3055\u3044\uFF1A",
                    "\u30D5\u30EB\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u8CFC\u5165",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                    "Anchor",
                    "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
                    "\u30A8\u30C7\u30A3\u30BF\u30FC\u306E\u30B5\u30A4\u30BA\uFF08\u30D5\u30EB/\u30CE\u30FC\u30DE\u30EB\uFF09",
                    "\u66F8\u5F0F\u3092\u30AF\u30EA\u30A2",
                    "\u30C6\u30AD\u30B9\u30C8\u306E\u8272",
                    "\u3084\u308A\u76F4\u3057",
                    "\u5143\u306B\u623B\u3059",
                    "\u592A\u5B57",
                    "\u659C\u4F53",
                    "\u7B87\u6761\u66F8\u304D",
                    "\u756A\u53F7\u4ED8\u304D\u30EA\u30B9\u30C8",
                    "\u4E2D\u592E\u63C3\u3048",
                    "\u4E21\u7AEF\u63C3\u3048",
                    "\u5DE6\u63C3\u3048",
                    "\u53F3\u63C3\u3048",
                    "\u533A\u5207\u308A\u7DDA\u3092\u633F\u5165",
                    "\u753B\u50CF\u3092\u633F\u5165",
                    "\u30D5\u30A1\u30A4\u30EB\u3092\u633F\u5165",
                    "Youtube/Vimeo \u52D5\u753B",
                    "\u30EA\u30F3\u30AF\u3092\u633F\u5165",
                    "\u30D5\u30A9\u30F3\u30C8\u30B5\u30A4\u30BA",
                    "\u30D5\u30A9\u30F3\u30C8",
                    "\u30C6\u30AD\u30B9\u30C8\u306E\u30B9\u30BF\u30A4\u30EB",
                    "\u6307\u5B9A\u306A\u3057",
                    "\u30BF\u30A4\u30C8\u30EB1",
                    "\u30BF\u30A4\u30C8\u30EB2",
                    "\u30BF\u30A4\u30C8\u30EB3",
                    "\u30BF\u30A4\u30C8\u30EB4",
                    "\u5F15\u7528",
                    "\u30B3\u30FC\u30C9",
                    "\u633F\u5165",
                    "\u8868\u3092\u633F\u5165",
                    "\u30A4\u30F3\u30C7\u30F3\u30C8\u6E1B",
                    "\u30A4\u30F3\u30C7\u30F3\u30C8\u5897",
                    "\u7279\u6B8A\u6587\u5B57\u3092\u9078\u629E",
                    "\u7279\u6B8A\u6587\u5B57\u3092\u633F\u5165",
                    "\u66F8\u5F0F\u3092\u8CBC\u4ED8\u3051",
                    "\u7DE8\u96C6\u30E2\u30FC\u30C9\u5207\u66FF\u3048",
                    "\u30DE\u30FC\u30B8\u30F3",
                    "\u4E0A",
                    "\u53F3",
                    "\u4E0B",
                    "\u5DE6",
                    "\u30B9\u30BF\u30A4\u30EB",
                    "\u30AF\u30E9\u30B9",
                    "\u914D\u7F6E",
                    "\u53F3\u5BC4\u305B",
                    "\u4E2D\u592E\u5BC4\u305B",
                    "\u5DE6\u5BC4\u305B",
                    "\u6307\u5B9A\u306A\u3057",
                    "\u30BD\u30FC\u30B9",
                    "\u30BF\u30A4\u30C8\u30EB",
                    "\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8",
                    "\u30EA\u30F3\u30AF",
                    "\u65B0\u3057\u3044\u30BF\u30D6\u3067\u958B\u304F",
                    "\u753B\u50CF",
                    "\u30D5\u30A1\u30A4\u30EB",
                    "\u9AD8\u5EA6\u306A\u8A2D\u5B9A",
                    "\u753B\u50CF\u306E\u30D7\u30ED\u30D1\u30C6\u30A3\u30FC",
                    "\u30AD\u30E3\u30F3\u30BB\u30EB",
                    "\u78BA\u5B9A",
                    "HTML\u30B3\u30FC\u30C9\u3092\u4FDD\u6301\u3057\u307E\u3059\u304B\uFF1F",
                    "HTML\u3067\u8CBC\u4ED8\u3051",
                    "HTML\u3092\u4FDD\u6301",
                    "Clean",
                    "HTML\u3092\u30C6\u30AD\u30B9\u30C8\u306B\u3059\u308B",
                    "\u30C6\u30AD\u30B9\u30C8\u3060\u3051",
                    "Word Paste Detected",
                    "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?",
                    "File Browser",
                    "Error on load list",
                    "Error on load folders",
                    "Are you sure?",
                    "Enter Directory name",
                    "Create directory",
                    "type name",
                    "\u3053\u3053\u306B\u753B\u50CF\u3092\u30C9\u30ED\u30C3\u30D7",
                    "\u3053\u3053\u306B\u30D5\u30A1\u30A4\u30EB\u3092\u30C9\u30ED\u30C3\u30D7",
                    "or \u30AF\u30EA\u30C3\u30AF",
                    "\u4EE3\u66FF\u30C6\u30AD\u30B9\u30C8",
                    "\u30D6\u30E9\u30A6\u30BA",
                    "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9",
                    "\u80CC\u666F",
                    "\u6587\u5B57",
                    "\u4E0A",
                    "\u4E2D\u592E",
                    "\u4E0B",
                    "\u5DE6\u306B\u5217\u3092\u633F\u5165",
                    "\u53F3\u306B\u5217\u3092\u633F\u5165",
                    "\u4E0A\u306B\u884C\u3092\u633F\u5165",
                    "\u4E0B\u306B\u884C\u3092\u633F\u5165",
                    "\u8868\u3092\u524A\u9664",
                    "\u884C\u3092\u524A\u9664",
                    "\u5217\u3092\u524A\u9664",
                    "\u30BB\u30EB\u3092\u7A7A\u306B\u3059\u308B",
                    "source",
                    "bold",
                    "italic",
                    "brush",
                    "link",
                    "undo",
                    "redo",
                    "table",
                    "image",
                    "eraser",
                    "paragraph",
                    "fontsize",
                    "video",
                    "font",
                    "about",
                    "print",
                    "underline",
                    "strikethrough",
                    "indent",
                    "outdent",
                    "fullsize",
                    "shrink",
                    "\u5206\u5272\u7DDA",
                    "\u7B87\u6761\u66F8\u304D",
                    "\u756A\u53F7\u4ED8\u304D\u30EA\u30B9\u30C8",
                    "\u5207\u308A\u53D6\u308A",
                    "\u3059\u3079\u3066\u9078\u629E",
                    "\u57CB\u3081\u8FBC\u307F\u30B3\u30FC\u30C9",
                    "\u30EA\u30F3\u30AF\u3092\u958B\u304F",
                    "\u30EA\u30F3\u30AF\u3092\u7DE8\u96C6",
                    "No follow",
                    "\u30EA\u30F3\u30AF\u89E3\u9664",
                    "\u30B5\u30A4\u30C8\u3092\u78BA\u8A8D",
                    "\u925B\u7B46",
                    "\u66F4\u65B0",
                    "URL",
                    "\u7DE8\u96C6",
                    "\u6C34\u5E73\u65B9\u5411\u306E\u914D\u7F6E",
                    "Filter",
                    "Sort by changed",
                    "Sort by name",
                    "Sort by size",
                    "Add folder",
                    "\u30EA\u30BB\u30C3\u30C8",
                    "\u4FDD\u5B58",
                    "Save as ...",
                    "\u30EA\u30B5\u30A4\u30BA",
                    "Crop",
                    "\u5E45",
                    "\u9AD8\u3055",
                    "\u7E26\u6A2A\u6BD4\u3092\u4FDD\u6301",
                    "\u306F\u3044",
                    "\u3044\u3044\u3048",
                    "\u79FB\u9664",
                    "\u9078\u629E",
                    "\u6587\u5B57\u6570: %d",
                    "\u5358\u8A9E\u6570: %d",
                    "\u5168\u90E8",
                    "\u9078\u629E: %s",
                    "\u3059\u3079\u3066\u9078\u629E",
                    "\u5782\u76F4\u65B9\u5411\u306E\u914D\u7F6E",
                    "\u5206\u5272",
                    "\u30BB\u30EB\u306E\u5206\u5272\uFF08\u5782\u76F4\u65B9\u5411\uFF09",
                    "\u30BB\u30EB\u306E\u5206\u5272\uFF08\u6C34\u5E73\u65B9\u5411\uFF09",
                    "\u30BB\u30EB\u306E\u7D50\u5408",
                    "\u5217\u3092\u8FFD\u52A0",
                    "\u884C\u3092\u8FFD\u52A0",
                    "\u524A\u9664",
                    "\u5883\u754C\u7DDA",
                    null,
                    "\u53D6\u308A\u6D88\u3057\u7DDA",
                    "\u4E0B\u7DDA",
                    "\u4E0A\u4ED8\u304D\u6587\u5B57",
                    "\u4E0B\u4ED8\u304D\u6587\u5B57",
                    "\u5207\u308A\u53D6\u308A",
                    "Pause",
                    "\u691C\u7D22",
                    "\u7F6E\u63DB",
                    "\u4EA4\u63DB",
                    "\u8CBC\u4ED8\u3051",
                    "\u9078\u629E\u3057\u305F\u5185\u5BB9\u3092\u8CBC\u4ED8\u3051",
                    "You can only edit your own images. Download this image on the host?",
                    "The image has been successfully uploaded to the host!",
                    "\u30D1\u30EC\u30C3\u30C8",
                    "There are no files",
                    "Rename",
                    "Enter new name",
                    "\u30D7\u30EC\u30D3\u30E5\u30FC",
                    "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
                    "\u8CBC\u308A\u4ED8\u3051",
                    "\u304A\u4F7F\u3044\u306E\u30D6\u30E9\u30A6\u30B6\u306F\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u3092\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093",
                    "\u30B3\u30D4\u30FC",
                    "copy",
                    "\u89D2\u306E\u4E38\u307F",
                    "\u5168\u3066\u8868\u793A",
                    "\u9069\u7528",
                    "\u307E\u3060\u3053\u306E\u5206\u91CE",
                    "\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u30A6\u30A7\u30D6\u30A2\u30C9\u30EC\u30B9",
                    "\u30C7\u30D5\u30A9\u30EB\u30C8",
                    "\u767D\u4E38",
                    "\u9ED2\u4E38",
                    "\u56DB\u89D2",
                    "\u898B",
                    "\u63A2\u524D",
                    "\u7531\u6765",
                    "\u30AF\u30E9\u30B9\u540D\u3092\u633F\u5165",
                    "\u30AB\u30B9\u30BF\u30E0\u30B5\u30A4\u30BA\u5909\u66F4\u306E\u305F\u3081\u306EAlt\u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059"
                ];
            },
            11399: function(e) {
                e.exports.default = [
                    "Type something",
                    "About Jodit",
                    "Jodit Editor",
                    "Free Non-commercial Version",
                    "Jodit User's Guide",
                    "contains detailed help for using",
                    "For information about the license, please go to our website:",
                    "Buy full version",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                    "Anchor",
                    "Open in new tab",
                    "Open in fullsize",
                    "Clear Formatting",
                    "Fill color or set the text color",
                    "Redo",
                    "Undo",
                    "Bold",
                    "Italic",
                    "Insert Unordered List",
                    "Insert Ordered List",
                    "Align Center",
                    "Align Justify",
                    "Align Left",
                    "Align Right",
                    "Insert Horizontal Line",
                    "Insert Image",
                    "Insert file",
                    "Insert youtube/vimeo video",
                    "Insert link",
                    "Font size",
                    "Font family",
                    "Insert format block",
                    "Normal",
                    "Heading 1",
                    "Heading 2",
                    "Heading 3",
                    "Heading 4",
                    "Quote",
                    "Code",
                    "Insert",
                    "Insert table",
                    "Decrease Indent",
                    "Increase Indent",
                    "Select Special Character",
                    "Insert Special Character",
                    "Paint format",
                    "Change mode",
                    "Margins",
                    "top",
                    "right",
                    "bottom",
                    "left",
                    "Styles",
                    "Classes",
                    "Align",
                    "Right",
                    "Center",
                    "Left",
                    "--Not Set--",
                    "Src",
                    "Title",
                    "Alternative",
                    "Link",
                    "Open link in new tab",
                    "Image",
                    "file",
                    "Advanced",
                    "Image properties",
                    "Cancel",
                    "Ok",
                    "Your code is similar to HTML. Keep as HTML?",
                    "Paste as HTML",
                    "Keep",
                    "Clean",
                    "Insert as Text",
                    "Insert only Text",
                    "Word Paste Detected",
                    "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?",
                    "File Browser",
                    "Error on load list",
                    "Error on load folders",
                    "Are you sure?",
                    "Enter Directory name",
                    "Create directory",
                    "type name",
                    "Drop image",
                    "Drop file",
                    "or click",
                    "Alternative text",
                    "Browse",
                    "Upload",
                    "Background",
                    "Text",
                    "Top",
                    "Middle",
                    "Bottom",
                    "Insert column before",
                    "Insert column after",
                    "Insert row above",
                    "Insert row below",
                    "Delete table",
                    "Delete row",
                    "Delete column",
                    "Empty cell",
                    "source",
                    "bold",
                    "italic",
                    "brush",
                    "link",
                    "undo",
                    "redo",
                    "table",
                    "image",
                    "eraser",
                    "paragraph",
                    "fontsize",
                    "video",
                    "font",
                    "about",
                    "print",
                    "underline",
                    "strikethrough",
                    "indent",
                    "outdent",
                    "fullsize",
                    "shrink",
                    "hr",
                    "ul",
                    "ol",
                    "cut",
                    "selectall",
                    "Embed code",
                    "Open link",
                    "Edit link",
                    "No follow",
                    "Unlink",
                    "Eye",
                    "pencil",
                    "Update",
                    " URL",
                    "Edit",
                    "Horizontal align",
                    "Filter",
                    "Sort by changed",
                    "Sort by name",
                    "Sort by size",
                    "Add folder",
                    "Reset",
                    "Save",
                    "Save as ...",
                    "Resize",
                    "Crop",
                    "Width",
                    "Height",
                    "Keep Aspect Ratio",
                    "Yes",
                    "No",
                    "Remove",
                    "Select",
                    "Chars: %d",
                    "Words: %d",
                    "All",
                    "Select %s",
                    "Select all",
                    "Vertical align",
                    "Split",
                    "Split vertical",
                    "Split horizontal",
                    "Merge",
                    "Add column",
                    "Add row",
                    "Delete",
                    "Border",
                    "License: %s",
                    "Strike through",
                    "Underline",
                    "superscript",
                    "subscript",
                    "Cut selection",
                    "Break",
                    "Search for",
                    "Replace with",
                    "Replace",
                    "Paste",
                    "Choose Content to Paste",
                    "You can only edit your own images. Download this image on the host?",
                    "The image has been successfully uploaded to the host!",
                    "palette",
                    "There are no files",
                    "Rename",
                    "Enter new name",
                    "preview",
                    "download",
                    "Paste from clipboard",
                    "Your browser doesn't support direct access to the clipboard.",
                    "Copy selection",
                    "copy",
                    "Border radius",
                    "Show all",
                    "Apply",
                    "Please fill out this field",
                    "Please enter a web address",
                    "Default",
                    "Circle",
                    "Dot",
                    "Quadrate",
                    "Find",
                    "Find Previous",
                    "Find Next",
                    "Insert className",
                    "Press Alt for custom resizing"
                ];
            },
            37289: function(e) {
                e.exports.default = [
                    "\uBB34\uC5C7\uC774\uB4E0 \uC785\uB825\uD558\uC138\uC694",
                    "Jodit\uC5D0 \uB300\uD558\uC5EC",
                    "Jodit Editor",
                    null,
                    "Jodit \uC0AC\uC6A9\uC790 \uC548\uB0B4\uC11C",
                    "\uC790\uC138\uD55C \uB3C4\uC6C0\uB9D0\uC774 \uB4E4\uC5B4\uC788\uC5B4\uC694",
                    "\uB77C\uC774\uC13C\uC2A4\uC5D0 \uAD00\uD574\uC11C\uB294 Jodit \uC6F9 \uC0AC\uC774\uD2B8\uB97C \uBC29\uBB38\uD574\uC8FC\uC138\uC694\uFF1A",
                    "\uD480 \uBC84\uC804 \uAD6C\uC785\uD558\uAE30",
                    "\xa9 XDSoft.net - Chupurnov Valeriy. \uC5D0\uAC8C \uC800\uC791\uAD8C\uACFC \uBAA8\uB4E0 \uAD8C\uB9AC\uAC00 \uC788\uC2B5\uB2C8\uB2E4.",
                    "Anchor",
                    "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uAE30",
                    "\uC804\uCCB4 \uD06C\uAE30\uB85C \uBCF4\uAE30",
                    "\uC11C\uC2DD \uC9C0\uC6B0\uAE30",
                    "\uAE00\uC528 \uC0C9\uC0C1",
                    "\uC7AC\uC2E4\uD589",
                    "\uC2E4\uD589 \uCDE8\uC18C",
                    "\uAD75\uAC8C",
                    "\uAE30\uC6B8\uC784",
                    "\uAE00\uBA38\uB9AC \uBAA9\uB85D",
                    "\uBC88\uD638 \uBAA9\uB85D",
                    "\uAC00\uC6B4\uB370 \uC815\uB82C",
                    "\uC591\uCABD \uC815\uB82C",
                    "\uC67C\uCABD \uC815\uB82C",
                    "\uC624\uB978\uCABD \uC815\uB82C",
                    "\uC218\uD3C9 \uAD6C\uBD84\uC120 \uB123\uAE30",
                    "\uC774\uBBF8\uC9C0 \uB123\uAE30",
                    "\uD30C\uC77C \uB123\uAE30",
                    "Youtube/Vimeo \uB3D9\uC601\uC0C1",
                    "\uB9C1\uD06C \uB123\uAE30",
                    "\uAE00\uAF34 \uD06C\uAE30",
                    "\uAE00\uAF34",
                    "\uBE14\uB85D \uC694\uC18C \uB123\uAE30",
                    "\uC77C\uBC18 \uD14D\uC2A4\uD2B8",
                    "\uC81C\uBAA9 1",
                    "\uC81C\uBAA9 2",
                    "\uC81C\uBAA9 3",
                    "\uC81C\uBAA9 4",
                    "\uC778\uC6A9",
                    "\uCF54\uB4DC",
                    "\uBD99\uC5EC \uB123\uAE30",
                    "\uD14C\uC774\uBE14",
                    "\uB4E4\uC5EC\uC4F0\uAE30 \uAC10\uC18C",
                    "\uB4E4\uC5EC\uC4F0\uAE30 \uC99D\uAC00",
                    "\uD2B9\uC218\uBB38\uC790 \uC120\uD0DD",
                    "\uD2B9\uC218\uBB38\uC790 \uC785\uB825",
                    "\uD398\uC778\uD2B8 \uD615\uC2DD",
                    "\uD3B8\uC9D1\uBAA8\uB4DC \uBCC0\uACBD",
                    "\uB9C8\uC9C4",
                    "\uC704",
                    "\uC624\uB978\uCABD",
                    "\uC544\uB798",
                    "\uC67C\uCABD",
                    "\uC2A4\uD0C0\uC77C",
                    "\uD074\uB798\uC2A4",
                    "\uC815\uB82C",
                    "\uC624\uB978\uCABD\uC73C\uB85C",
                    "\uAC00\uC6B4\uB370\uB85C",
                    "\uC67C\uCABD\uC73C\uB85C",
                    "--\uC9C0\uC815 \uC548 \uD568--",
                    "\uACBD\uB85C(src)",
                    "\uC81C\uBAA9",
                    "\uB300\uCCB4 \uD14D\uC2A4\uD2B8(alt)",
                    "\uB9C1\uD06C",
                    "\uC0C8 \uD0ED\uC5D0\uC11C \uC5F4\uAE30",
                    null,
                    "\uD30C\uC77C",
                    "\uACE0\uAE09",
                    "\uC774\uBBF8\uC9C0 \uC18D\uC131",
                    "\uCDE8\uC18C",
                    "\uD655\uC778",
                    "HTML \uCF54\uB4DC\uB85C \uAC10\uC9C0\uD588\uC5B4\uC694. \uCF54\uB4DC\uC778\uCC44\uB85C \uBD99\uC5EC\uB123\uC744\uAE4C\uC694?",
                    "HTML\uB85C \uBD99\uC5EC\uB123\uAE30",
                    "\uC6D0\uBCF8 \uC720\uC9C0",
                    "\uC9C0\uC6B0\uAE30",
                    "\uD14D\uC2A4\uD2B8\uB85C \uB123\uAE30",
                    "\uD14D\uC2A4\uD2B8\uB9CC \uB123\uAE30",
                    "Word \uBD99\uC5EC\uB123\uAE30 \uAC10\uC9C0",
                    "Microsoft Word/Excel \uBB38\uC11C\uB85C \uAC10\uC9C0\uD588\uC5B4\uC694. \uC11C\uC2DD\uC744 \uC720\uC9C0\uD55C\uCC44\uB85C \uBD99\uC5EC\uB123\uC744\uAE4C\uC694?",
                    "\uD30C\uC77C \uD0D0\uC0C9\uAE30",
                    "\uBAA9\uB85D \uBD88\uB7EC\uC624\uAE30 \uC5D0\uB7EC",
                    "\uD3F4\uB354 \uBD88\uB7EC\uC624\uAE30",
                    "\uC815\uB9D0 \uC9C4\uD589\uD560\uAE4C\uC694?",
                    "\uB514\uB809\uD1A0\uB9AC \uC774\uB984 \uC785\uB825",
                    "\uB514\uB809\uD1A0\uB9AC \uC0DD\uC131",
                    "\uC774\uB984 \uC785\uB825",
                    "\uC774\uBBF8\uC9C0 \uB4DC\uB798\uADF8",
                    "\uD30C\uC77C \uB4DC\uB798\uADF8",
                    "\uD639\uC740 \uD074\uB9AD",
                    "\uB300\uCCB4 \uD14D\uC2A4\uD2B8",
                    "\uD0D0\uC0C9",
                    "\uC5C5\uB85C\uB4DC",
                    "\uBC30\uACBD",
                    "\uD14D\uC2A4\uD2B8",
                    "\uC704",
                    "\uC911\uC559",
                    "\uC544\uB798",
                    "\uC774\uC804 \uC5F4\uC5D0 \uC0BD\uC785",
                    "\uB2E4\uC74C \uC5F4\uC5D0 \uC0BD\uC785",
                    "\uC704 \uD589\uC5D0 \uC0BD\uC785",
                    "\uC544\uB798 \uD589\uC5D0 \uC0BD\uC785",
                    "\uD14C\uC774\uBE14 \uC0AD\uC81C",
                    "\uD589 \uC0AD\uC81C",
                    "\uC5F4 \uC0AD\uC81C",
                    "\uBE48 \uC140",
                    "HTML \uC18C\uC2A4",
                    "\uBCFC\uB4DC",
                    "\uC774\uD0E4\uB9AD",
                    "\uBE0C\uB7EC\uC2DC",
                    "\uB9C1\uD06C",
                    "\uC2E4\uD589 \uCDE8\uC18C",
                    "\uC7AC\uC2E4\uD589",
                    "\uD14C\uC774\uBE14",
                    "\uC774\uBBF8\uC9C0",
                    "\uC9C0\uC6B0\uAC1C",
                    "\uBB38\uB2E8",
                    "\uAE00\uAF34 \uD06C\uAE30",
                    "\uBE44\uB514\uC624",
                    "\uAE00\uAF34",
                    "\uD3B8\uC9D1\uAE30 \uC815\uBCF4",
                    "\uD504\uB9B0\uD2B8",
                    "\uBC11\uC904",
                    "\uCDE8\uC18C\uC120",
                    "\uB4E4\uC5EC\uC4F0\uAE30",
                    "\uB0B4\uC5B4\uC4F0\uAE30",
                    "\uC804\uCCB4 \uD654\uBA74",
                    "\uC77C\uBC18 \uD654\uBA74",
                    "\uAD6C\uBD84\uC120",
                    "\uAE00\uBA38\uB9AC \uBAA9\uB85D",
                    "\uBC88\uD638 \uBAA9\uB85D",
                    "\uC798\uB77C\uB0B4\uAE30",
                    "\uBAA8\uB450 \uC120\uD0DD",
                    "Embed \uCF54\uB4DC",
                    "\uB9C1\uD06C \uC5F4\uAE30",
                    "\uB9C1\uD06C \uD3B8\uC9D1",
                    "No follow",
                    "\uB9C1\uD06C \uC81C\uAC70",
                    "\uC0AC\uC774\uD2B8 \uD655\uC778",
                    "\uC5F0\uD544",
                    "\uAC31\uC2E0",
                    "URL",
                    "\uD3B8\uC9D1",
                    "\uC218\uD3C9 \uC815\uB82C",
                    "\uD544\uD130",
                    "\uBCC0\uACBD\uC77C \uC815\uB82C",
                    "\uC774\uB984 \uC815\uB82C",
                    "\uD06C\uAE30 \uC815\uB82C",
                    "\uC0C8 \uD3F4\uB354",
                    "\uCD08\uAE30\uD654",
                    "\uC800\uC7A5",
                    "\uC0C8\uB85C \uC800\uC7A5\uD558\uAE30 ...",
                    "\uB9AC\uC0AC\uC774\uC988",
                    "\uD06C\uB86D",
                    "\uAC00\uB85C \uAE38\uC774",
                    "\uC138\uB85C \uB192\uC774",
                    "\uBE44\uC728 \uC720\uC9C0\uD558\uAE30",
                    "\uB124",
                    "\uC544\uB2C8\uC624",
                    "\uC81C\uAC70",
                    "\uC120\uD0DD",
                    "\uBB38\uC790\uC218: %d",
                    "\uB2E8\uC5B4\uC218: %d",
                    "\uBAA8\uB450",
                    "\uC120\uD0DD: %s",
                    "\uBAA8\uB450 \uC120\uD0DD",
                    "\uC218\uC9C1 \uC815\uB82C",
                    "\uBD84\uD560",
                    "\uC138\uB85C \uC140 \uBD84\uD560",
                    "\uAC00\uB85C \uC140 \uBD84\uD560",
                    "\uC140 \uBCD1\uD569",
                    "\uC5F4 \uCD94\uAC00",
                    "\uD589 \uCD94\uAC00",
                    "\uC0AD\uC81C",
                    "\uC678\uACFD\uC120",
                    "\uB77C\uC774\uC13C\uC2A4: %s",
                    "\uCDE8\uC18C\uC120",
                    "\uBC11\uC904",
                    "\uC717\uCCA8\uC790",
                    "\uC544\uB798\uCCA8\uC790",
                    "\uC120\uD0DD \uC798\uB77C\uB0B4\uAE30",
                    "\uAD6C\uBD84\uC790",
                    "\uAC80\uC0C9",
                    "\uB300\uCCB4\uD558\uAE30",
                    "\uB300\uCCB4",
                    "\uBD99\uC5EC\uB123\uAE30",
                    "\uBD99\uC5EC\uB123\uC744 \uB0B4\uC6A9 \uC120\uD0DD",
                    "\uC678\uBD80 \uC774\uBBF8\uC9C0\uB294 \uD3B8\uC9D1\uD560 \uC218 \uC5C6\uC5B4\uC694. \uC678\uBD80 \uC774\uBBF8\uC9C0\uB97C \uB2E4\uC6B4\uB85C\uB4DC \uD560\uAE4C\uC694?",
                    "\uC774\uBBF8\uC9C0\uB97C \uBB34\uC0AC\uD788 \uC5C5\uB85C\uB4DC \uD588\uC5B4\uC694!",
                    "\uD314\uB808\uD2B8",
                    "\uD30C\uC77C\uC774 \uC5C6\uC5B4\uC694",
                    "\uC774\uB984 \uBCC0\uACBD",
                    "\uC0C8 \uC774\uB984 \uC785\uB825",
                    "\uBBF8\uB9AC\uBCF4\uAE30",
                    "\uB2E4\uC6B4\uB85C\uB4DC",
                    "\uD074\uB9BD\uBCF4\uB4DC \uBD99\uC5EC\uB123\uAE30",
                    "\uC0AC\uC6A9\uC911\uC778 \uBE0C\uB77C\uC6B0\uC800\uAC00 \uD074\uB9BD\uBCF4\uB4DC \uC811\uADFC\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC544\uC694.",
                    "\uC120\uD0DD \uBCF5\uC0AC",
                    "\uBCF5\uC0AC",
                    "\uB465\uADFC \uD14C\uB450\uB9AC",
                    "\uBAA8\uB450 \uBCF4\uAE30",
                    "\uC801\uC6A9",
                    "\uC774 \uD56D\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694!",
                    "\uC6F9 URL\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.",
                    "\uAE30\uBCF8",
                    "\uC6D0",
                    "\uC810",
                    "\uC815\uC0AC\uAC01\uD615",
                    "\uCC3E\uAE30",
                    "\uC774\uC804 \uCC3E\uAE30",
                    "\uB2E4\uC74C \uCC3E\uAE30",
                    "className \uC785\uB825",
                    "\uC0AC\uC6A9\uC790 \uC9C0\uC815 \uD06C\uAE30 \uC870\uC815\uC5D0 \uB300 \uD55C \uACE0\uB3C4 \uB204\uB974\uC2ED\uC2DC\uC624"
                ];
            },
            26501: function(e) {
                e.exports.default = [
                    "\u0411\u0438\u0447\u044D\u044D\u0434 \u04AF\u0437\u044D\u044D\u0440\u044D\u0439",
                    "Jodit-\u044B\u043D \u0442\u0430\u043B\u0430\u0430\u0440 ",
                    "Jodit \u043F\u0440\u043E\u0433\u0440\u0430\u043C",
                    null,
                    "Jodit \u0433\u0430\u0440\u044B\u043D \u0430\u0432\u043B\u0430\u0433\u0430",
                    "\u0445\u044D\u0440\u044D\u0433\u043B\u044D\u044D\u043D\u0438\u0439 \u0442\u0430\u043B\u0430\u0430\u0440 \u0434\u044D\u043B\u0433\u044D\u0440\u044D\u043D\u0433\u04AF\u0439 \u043C\u044D\u0434\u044D\u044D\u043B\u043B\u0438\u0439\u0433 \u0430\u0433\u0443\u0443\u043B\u043D\u0430",
                    "\u041B\u0438\u0446\u0435\u043D\u0437\u0438\u0439\u043D \u043C\u044D\u0434\u044D\u044D\u043B\u043B\u0438\u0439\u0433 \u043C\u0430\u043D\u0430\u0439 \u0432\u044D\u0431 \u0445\u0443\u0443\u0434\u0430\u0441\u043D\u0430\u0430\u0441 \u0430\u0432\u043D\u0430 \u0443\u0443:",
                    "\u0411\u04AF\u0440\u044D\u043D \u0445\u0443\u0432\u0438\u043B\u0431\u0430\u0440 \u0445\u0443\u0434\u0430\u043B\u0434\u0430\u043D \u0430\u0432\u0430\u0445",
                    "\u0417\u043E\u0445\u0438\u043E\u0433\u0447\u0438\u0439\u043D \u044D\u0440\u0445 \u0445\u0430\u043C\u0433\u0430\u0430\u043B\u0430\u0433\u0434\u0441\u0430\u043D \xa9 XDSoft.net - Chupurnov Valeriy. \u0411\u04AF\u0445 \u044D\u0440\u0445\u0438\u0439\u0433 \u044D\u0437\u044D\u043C\u0448\u0438\u043D\u044D.",
                    "\u0425\u043E\u043B\u0431\u043E\u043E \u0431\u0430\u0440\u0438\u0445",
                    "\u0428\u0438\u043D\u044D \u0442\u0430\u0431\u0430\u0430\u0440 \u043D\u044D\u044D\u0445",
                    "\u0411\u04AF\u0442\u044D\u043D \u0434\u044D\u043B\u0433\u044D\u0446\u044D\u044D\u0440 \u043D\u044D\u044D\u0445",
                    "\u0424\u043E\u0440\u043C\u0430\u0442\u044B\u0433 \u0430\u0440\u0438\u043B\u0433\u0430\u0445",
                    "\u04E8\u043D\u0433\u04E9\u04E9\u0440 \u0431\u0443\u0434\u0430\u0445 \u044D\u0441\u0432\u044D\u043B \u0442\u0435\u043A\u0441\u0442\u0438\u0439\u043D \u04E9\u043D\u0433\u04E9 \u0441\u043E\u043D\u0433\u043E\u0445",
                    "\u0414\u0430\u0445\u0438\u0445",
                    "\u0411\u0443\u0446\u0430\u0430\u0445",
                    "\u0422\u043E\u0434",
                    "\u041D\u0430\u043B\u0443\u0443",
                    "\u0422\u044D\u043C\u0434\u044D\u0433\u0442 \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442 \u043D\u044D\u043C\u044D\u0445",
                    "\u0414\u0443\u0433\u0430\u0430\u0440\u0442 \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442 \u043D\u044D\u043C\u044D\u0445",
                    "\u0413\u043E\u043B\u043B\u043E\u0436 \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                    "\u0422\u044D\u0433\u0448\u0438\u0442\u0433\u044D\u043D \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                    "\u0417\u04AF\u04AF\u043D\u0434 \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                    "\u0411\u0430\u0440\u0443\u0443\u043D\u0434 \u0431\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                    "\u0425\u044D\u0432\u0442\u044D\u044D \u0437\u0443\u0440\u0430\u0430\u0441 \u043D\u044D\u043C\u044D\u0445",
                    "\u0417\u0443\u0440\u0430\u0433 \u043D\u044D\u043C\u044D\u0445",
                    "\u0424\u0430\u0439\u043B \u043D\u044D\u043C\u044D\u0445",
                    "Youtube/Vimeo \u0432\u0438\u0434\u0435\u043E \u043D\u044D\u043C\u044D\u0445",
                    "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u043D\u044D\u043C\u044D\u0445",
                    "\u0424\u043E\u043D\u0442\u044B\u043D \u0445\u044D\u043C\u0436\u044D\u044D",
                    "\u0424\u043E\u043D\u0442\u044B\u043D \u0431\u04AF\u043B",
                    "\u0411\u043B\u043E\u043A \u043D\u044D\u043C\u044D\u0445",
                    "\u0425\u044D\u0432\u0438\u0439\u043D",
                    "\u0413\u0430\u0440\u0447\u0438\u0433 1",
                    "\u0413\u0430\u0440\u0447\u0438\u0433 2",
                    "\u0413\u0430\u0440\u0447\u0438\u0433 3",
                    "\u0413\u0430\u0440\u0447\u0438\u0433 4",
                    "\u0418\u0448\u043B\u044D\u043B",
                    "\u041A\u043E\u0434",
                    "\u041E\u0440\u0443\u0443\u043B\u0430\u0445",
                    "\u0425\u04AF\u0441\u043D\u044D\u0433\u0442 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                    "\u0414\u043E\u0433\u043E\u043B\u044B\u043D \u0437\u0430\u0439 \u0445\u0430\u0441\u0430\u0445",
                    "\u0414\u043E\u0433\u043E\u043B\u044B\u043D \u0437\u0430\u0439 \u043D\u044D\u043C\u044D\u0445",
                    "\u0422\u0443\u0441\u0433\u0430\u0439 \u0442\u044D\u043C\u0434\u044D\u0433\u0442 \u0441\u043E\u043D\u0433\u043E\u0445",
                    "\u0422\u0443\u0441\u0433\u0430\u0439 \u0442\u044D\u043C\u0434\u044D\u0433\u0442 \u043D\u044D\u043C\u044D\u0445",
                    "\u0417\u0443\u0440\u0433\u0438\u0439\u043D \u0444\u043E\u0440\u043C\u0430\u0442",
                    "\u0413\u043E\u0440\u0438\u043C \u04E9\u04E9\u0440\u0447\u043B\u04E9\u0445",
                    "\u0426\u0430\u0430\u0441\u043D\u044B \u0437\u0430\u0439",
                    "\u0414\u044D\u044D\u0440\u044D\u044D\u0441",
                    "\u0411\u0430\u0440\u0443\u0443\u043D\u0430\u0430\u0441",
                    "\u0414\u043E\u043E\u0440\u043E\u043E\u0441",
                    "\u0417\u04AF\u04AF\u043D\u044D\u044D\u0441",
                    "CSS \u0441\u0442\u0438\u043B\u044C",
                    "CSS \u0430\u043D\u0433\u0438",
                    "\u0411\u0430\u0439\u0440\u043B\u0443\u0443\u043B\u0430\u0445",
                    "\u0411\u0430\u0440\u0443\u0443\u043D",
                    "\u0422\u04E9\u0432",
                    "\u0417\u04AF\u04AF\u043D",
                    "--\u0422\u043E\u0434\u043E\u0440\u0445\u043E\u0439\u0433\u04AF\u0439--",
                    "\u042D\u0445 \u04AF\u04AF\u0441\u0432\u044D\u0440",
                    "\u0413\u0430\u0440\u0447\u0438\u0433",
                    "\u0410\u043B\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432 \u0442\u0435\u043A\u0441\u0442",
                    "\u0425\u043E\u043B\u0431\u043E\u043E\u0441",
                    "\u0425\u043E\u043B\u0431\u043E\u043E\u0441\u044B\u0433 \u0448\u0438\u043D\u044D \u0445\u0430\u0432\u0442\u0441\u0430\u043D\u0434 \u043D\u044D\u044D\u0445",
                    "\u0417\u0443\u0440\u0430\u0433",
                    "\u0424\u0430\u0439\u043B",
                    "\u0414\u044D\u0432\u0448\u0438\u043B\u0442\u044D\u0442",
                    "\u0417\u0443\u0440\u0433\u0438\u0439\u043D \u04AF\u0437\u04AF\u04AF\u043B\u044D\u043B\u0442",
                    "\u0426\u0443\u0446\u043B\u0430\u0445",
                    "Ok",
                    "\u0422\u0430\u043D\u044B \u043A\u043E\u0434 HTML \u043A\u043E\u0434\u0442\u043E\u0439 \u0430\u0434\u0438\u043B \u0431\u0430\u0439\u043D\u0430. HTML \u0444\u043E\u0440\u043C\u0430\u0442\u0430\u0430\u0440 \u04AF\u0440\u0433\u044D\u043B\u0436\u043B\u04AF\u04AF\u043B\u044D\u0445 \u04AF\u04AF?",
                    "HTML \u0431\u0430\u0439\u0434\u043B\u0430\u0430\u0440 \u0431\u0443\u0443\u043B\u0433\u0430\u0445",
                    "\u0425\u0430\u0434\u0433\u0430\u043B\u0430\u0445",
                    "\u0426\u044D\u0432\u044D\u0440\u043B\u044D\u0445",
                    "\u0422\u0435\u043A\u0441\u0442 \u0431\u0430\u0439\u0434\u043B\u0430\u0430\u0440 \u043D\u044D\u043C\u044D\u0445",
                    "\u0417\u04E9\u0432\u0445\u04E9\u043D \u0442\u0435\u043A\u0441\u0442 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                    "Word \u0431\u0430\u0439\u0434\u043B\u0430\u0430\u0440 \u0431\u0443\u0443\u043B\u0433\u0430\u0441\u0430\u043D \u0431\u0430\u0439\u043D\u0430",
                    "\u0411\u0443\u0443\u043B\u0433\u0430\u0441\u0430\u043D \u0430\u0433\u0443\u0443\u043B\u0433\u0430 Microsoft Word/Excel \u0444\u043E\u0440\u043C\u0430\u0442\u0442\u0430\u0439 \u0431\u0430\u0439\u043D\u0430. \u042D\u043D\u044D \u0444\u043E\u0440\u043C\u0430\u0442\u044B\u0433 \u0445\u044D\u0432\u044D\u044D\u0440 \u0445\u0430\u0434\u0433\u0430\u043B\u0430\u0445 \u0443\u0443 \u044D\u0441\u0432\u044D\u043B \u0430\u0440\u0438\u043B\u0433\u0430\u0445 \u0443\u0443?",
                    "\u0424\u0430\u0439\u043B\u044B\u043D \u0446\u043E\u043D\u0445",
                    "\u0416\u0430\u0433\u0441\u0430\u0430\u043B\u0442 \u0442\u0430\u0442\u0430\u0445 \u04AF\u0435\u0434 \u0430\u043B\u0434\u0430\u0430 \u0433\u0430\u0440\u043B\u0430\u0430",
                    "\u0425\u0430\u0432\u0442\u0430\u0441 \u0442\u0430\u0442\u0430\u0445 \u04AF\u0435\u0434 \u0430\u043B\u0434\u0430\u0430 \u0433\u0430\u0440\u043B\u0430\u0430",
                    "\u0418\u0442\u0433\u044D\u043B\u0442\u044D\u0439 \u0431\u0430\u0439\u043D\u0430 \u0443\u0443?",
                    "\u0425\u0430\u0432\u0442\u0441\u044B\u043D \u043D\u044D\u0440 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                    "\u0425\u0430\u0432\u0442\u0430\u0441 \u04AF\u04AF\u0441\u0433\u044D\u0445",
                    "\u041D\u044D\u0440 \u0431\u0438\u0447\u0438\u0445",
                    "\u0417\u0443\u0440\u0430\u0433 \u0431\u0443\u0443\u043B\u0433\u0430\u0445",
                    "\u0424\u0430\u0439\u043B \u0431\u0443\u0443\u043B\u0433\u0430\u0445",
                    "\u044D\u0441\u0432\u044D\u043B \u0442\u043E\u0432\u0448",
                    "\u0410\u043B\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432 \u0442\u0435\u043A\u0441\u0442",
                    "\u04AE\u0437\u044D\u0445",
                    "\u0411\u0430\u0439\u0440\u0448\u0443\u0443\u043B\u0430\u0445",
                    "\u0410\u0440\u044B\u043D \u0437\u0443\u0440\u0430\u0433",
                    "\u0422\u0435\u043A\u0441\u0442",
                    "\u0414\u044D\u044D\u0440",
                    "\u0414\u0443\u043D\u0434",
                    "\u0414\u043E\u043E\u0440",
                    "\u0423\u0440\u0434 \u043D\u044C \u0431\u0430\u0433\u0430\u043D\u0430 \u043D\u044D\u043C\u044D\u0445",
                    "\u0410\u0440\u0434 \u043D\u044C \u0431\u0430\u0433\u0430\u043D\u0430 \u043D\u044D\u043C\u044D\u0445",
                    "\u0414\u044D\u044D\u0440 \u043D\u044C \u043C\u04E9\u0440 \u043D\u044D\u043C\u044D\u0445",
                    "\u0414\u043E\u043E\u0440 \u043D\u044C \u043C\u04E9\u0440 \u043D\u044D\u043C\u044D\u0445",
                    "\u0425\u04AF\u0441\u043D\u044D\u0433\u0442 \u0443\u0441\u0442\u0433\u0430\u0445",
                    "\u041C\u04E9\u0440 \u0443\u0441\u0442\u0433\u0430\u0445",
                    "\u0411\u0430\u0433\u0430\u043D\u0430 \u0443\u0441\u0442\u0433\u0430\u0445",
                    "\u041D\u04AF\u0434 \u0446\u044D\u0432\u044D\u0440\u043B\u044D\u0445",
                    "\u042D\u0445 \u04AF\u04AF\u0441\u0432\u044D\u0440",
                    "\u0422\u043E\u0434",
                    "\u041D\u0430\u043B\u0443\u0443",
                    "\u0411\u0443\u0434\u0430\u0445",
                    "\u0425\u043E\u043B\u0431\u043E\u043E\u0441",
                    "\u0411\u0443\u0446\u0430\u0430\u0445",
                    "\u0414\u0430\u0445\u0438\u0445",
                    "\u0425\u04AF\u0441\u043D\u044D\u0433\u0442",
                    "\u0417\u0443\u0440\u0430\u0433",
                    "\u0411\u0430\u043B\u043B\u0443\u0443\u0440",
                    "\u041F\u0430\u0440\u0430\u0433\u0440\u0430\u0444",
                    "\u0424\u043E\u043D\u0442\u044B\u043D \u0445\u044D\u043C\u0436\u044D\u044D",
                    "\u0412\u0438\u0434\u0435\u043E",
                    "\u0424\u043E\u043D\u0442",
                    "\u0422\u0443\u0445\u0430\u0439",
                    "\u0425\u044D\u0432\u043B\u044D\u0445",
                    "\u0414\u043E\u043E\u0433\u0443\u0443\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                    "\u0414\u044D\u044D\u0433\u04AF\u04AF\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                    "\u0414\u043E\u0433\u043E\u043B \u043D\u044D\u043C\u044D\u0445",
                    "\u0414\u043E\u0433\u043E\u043B \u0431\u0430\u0433\u0430\u0441\u0433\u0430\u0445",
                    "\u0411\u04AF\u0442\u044D\u043D \u0434\u044D\u043B\u0433\u044D\u0446",
                    "\u0411\u0430\u0433\u0430\u0441\u0433\u0430",
                    "\u0425\u0430\u0430\u043B\u0442",
                    "\u0422\u044D\u043C\u0434\u044D\u0433\u0442 \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442",
                    "\u0414\u0443\u0433\u0430\u0430\u0440\u043B\u0430\u0441\u0430\u043D \u0436\u0430\u0433\u0441\u0430\u0430\u043B\u0442",
                    "\u0422\u0430\u0441\u043B\u0430\u0445",
                    "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0441\u043E\u043D\u0433\u043E",
                    "\u041A\u043E\u0434 \u043E\u0440\u0443\u0443\u043B\u0430\u0445",
                    "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u043D\u044D\u044D\u0445",
                    "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u0437\u0430\u0441\u0430\u0445",
                    "Nofollow \xf6zelli\u011Fi",
                    "\u0425\u043E\u043B\u0431\u043E\u043E\u0441 \u0441\u0430\u043B\u0433\u0430\u0445",
                    "\u041D\u04AF\u0434",
                    "\u0417\u0430\u0441\u0430\u0445",
                    "\u0428\u0438\u043D\u044D\u0447\u043B\u044D\u0445",
                    "URL",
                    "\u0417\u0430\u0441\u0430\u0445",
                    "\u0425\u044D\u0432\u0442\u044D\u044D \u044D\u0433\u043D\u04AF\u04AF\u043B\u044D\u0445",
                    "\u0428\u04AF\u04AF\u0445",
                    "\u0421\u04AF\u04AF\u043B\u0434 \u04E9\u04E9\u0440\u0447\u043B\u04E9\u0433\u0434\u0441\u04E9\u043D\u04E9\u04E9\u0440 \u0436\u0430\u0433\u0441\u0430\u0430\u0445",
                    "\u041D\u044D\u0440\u044D\u044D\u0440 \u0436\u0430\u0433\u0441\u0430\u0430\u0445",
                    "\u0425\u044D\u043C\u0436\u044D\u044D\u0433\u044D\u044D\u0440 \u0436\u0430\u0433\u0441\u0430\u0430\u0445",
                    "\u0425\u0430\u0432\u0442\u0430\u0441 \u043D\u044D\u043C\u044D\u0445",
                    "\u0411\u0443\u0446\u0430\u0430\u0445",
                    "\u0425\u0430\u0434\u0433\u0430\u043B\u0430\u0445",
                    "\u04E8\u04E9\u0440\u04E9\u04E9\u0440 \u0445\u0430\u0434\u0433\u0430\u043B\u0430\u0445",
                    "\u0425\u044D\u043C\u0436\u044D\u044D\u0433 \u04E9\u04E9\u0440\u0447\u0438\u043B",
                    "\u0422\u0430\u0439\u0440\u0430\u0445",
                    "\u04E8\u0440\u0433\u04E9\u043D",
                    "\u04E8\u043D\u0434\u04E9\u0440",
                    "\u0425\u0430\u0440\u044C\u0446\u0430\u0430\u0433 \u0445\u0430\u0434\u0433\u0430\u043B",
                    "\u0422\u0438\u0439\u043C",
                    "\u04AE\u0433\u04AF\u0439",
                    "\u0410\u0440\u0438\u043B\u0433\u0430",
                    "\u0421\u043E\u043D\u0433\u043E",
                    "\u0422\u044D\u043C\u0434\u044D\u0433\u0442: %d",
                    "\u04AE\u0433: %d",
                    "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433",
                    "\u0421\u043E\u043D\u0433\u043E: %s",
                    "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0441\u043E\u043D\u0433\u043E",
                    "\u0411\u043E\u0441\u043E\u043E \u044D\u0433\u043D\u04AF\u04AF\u043B\u044D\u0445",
                    "\u0417\u0430\u0434\u043B\u0430\u0445",
                    "\u0411\u0430\u0433\u0430\u043D\u0430\u0430\u0440 \u0437\u0430\u0434\u043B\u0430\u0445",
                    "\u041C\u04E9\u0440\u04E9\u04E9\u0440 \u0437\u0430\u0434\u043B\u0430\u0445",
                    "\u041D\u044D\u0433\u0442\u0433\u044D\u0445",
                    "\u0411\u0430\u0433\u0430\u043D\u0430 \u043D\u044D\u043C\u044D\u0445",
                    "\u041C\u04E9\u0440 \u043D\u044D\u043C\u044D\u0445",
                    "\u0423\u0441\u0442\u0433\u0430\u0445",
                    "\u0425\u04AF\u0440\u044D\u044D",
                    null,
                    "\u0414\u044D\u044D\u0433\u04AF\u04AF\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                    "\u0414\u043E\u043E\u0433\u0443\u0443\u0440 \u0437\u0443\u0440\u0430\u0430\u0441",
                    "\u0414\u044D\u044D\u0434 \u0438\u043D\u0434\u0435\u043A\u0441",
                    "\u0414\u043E\u043E\u0434 \u0438\u043D\u0434\u0435\u043A\u0441",
                    "\u0421\u043E\u043D\u0433\u043E\u043B\u0442\u044B\u0433 \u0442\u0430\u0441\u043B\u0430\u0445",
                    "\u041C\u04E9\u0440\u0438\u0439\u0433 \u0442\u0430\u0441\u043B\u0430\u0445",
                    "\u0425\u0430\u0439\u0445",
                    "\u04AE\u04AF\u0433\u044D\u044D\u0440 \u0441\u043E\u043B\u0438\u0445",
                    "\u0421\u043E\u043B\u0438\u0445",
                    "\u0411\u0443\u0443\u043B\u0433\u0430\u0445",
                    "\u0411\u0443\u0443\u043B\u0433\u0430\u0445 \u0430\u0433\u0443\u0443\u043B\u0433\u0430\u0430 \u0441\u043E\u043D\u0433\u043E\u043D\u043E \u0443\u0443",
                    "\u0422\u0430 \u0437\u04E9\u0432\u0445\u04E9\u043D \u04E9\u04E9\u0440\u0438\u0439\u043D \u0437\u0443\u0440\u0433\u0443\u0443\u0434\u0430\u0430 \u044F\u043D\u0437\u043B\u0430\u0445 \u0431\u043E\u043B\u043E\u043C\u0436\u0442\u043E\u0439. \u042D\u043D\u044D \u0437\u0443\u0440\u0433\u0438\u0439\u0433 \u04E9\u04E9\u0440 \u043B\u04AF\u04AF\u0433\u044D\u044D \u0442\u0430\u0442\u043C\u0430\u0430\u0440 \u0431\u0430\u0439\u043D\u0430 \u0443\u0443?",
                    "\u0417\u0443\u0440\u0433\u0438\u0439\u0433 \u0445\u043E\u0441\u0442 \u0440\u0443\u0443 \u0430\u043C\u0436\u0438\u043B\u0442\u0442\u0430\u0439 \u0445\u0430\u0434\u0433\u0430\u043B\u0441\u0430\u043D",
                    "\u041F\u0430\u043B\u0435\u0442",
                    "\u042D\u043D\u0434 \u044F\u043C\u0430\u0440 \u043D\u044D\u0433 \u0444\u0430\u0439\u043B \u0430\u043B\u0433\u0430",
                    "\u0428\u0438\u043D\u044D\u044D\u0440 \u043D\u044D\u0440\u043B\u044D\u0445",
                    "\u0428\u0438\u043D\u044D \u043D\u044D\u0440 \u043E\u0440\u0443\u0443\u043B\u043D\u0430 \u0443\u0443",
                    "\u0423\u0440\u044C\u0434\u0447\u0438\u043B\u0430\u043D \u0445\u0430\u0440\u0430\u0445",
                    "\u0422\u0430\u0442\u0430\u0445",
                    "\u0421\u0430\u043C\u0431\u0430\u0440\u0430\u0430\u0441 \u0445\u0443\u0443\u043B\u0430\u0445 ",
                    "\u042D\u043D\u044D \u0432\u044D\u0431 \u0445\u04E9\u0442\u0447\u04E9\u04E9\u0441 \u0441\u0430\u043C\u0431\u0430\u0440\u0442 \u0445\u0430\u043D\u0434\u0430\u0445 \u044D\u0440\u0445 \u0430\u043B\u0433\u0430.",
                    "\u0421\u043E\u043D\u0433\u043E\u043B\u0442\u044B\u0433 \u0445\u0443\u0443\u043B",
                    "\u0425\u0443\u0443\u043B\u0430\u0445",
                    "\u0425\u04AF\u0440\u044D\u044D\u043D\u0438\u0439 \u0440\u0430\u0434\u0438\u0443\u0441",
                    "\u0411\u04AF\u0433\u0434\u0438\u0439\u0433 \u0445\u0430\u0440\u0443\u0443\u043B\u0430\u0445",
                    "\u0425\u044D\u0440\u044D\u0433\u0436\u04AF\u04AF\u043B",
                    "\u042D\u043D\u044D \u0442\u0430\u043B\u0431\u0430\u0440\u044B\u0433 \u0431\u04E9\u0433\u043B\u04E9\u043D\u04E9 \u04AF\u04AF",
                    "\u0412\u044D\u0431 \u0445\u0430\u044F\u0433\u0430\u0430 \u043E\u0440\u0443\u0443\u043B\u043D\u0430 \u0443\u0443",
                    "\u04AE\u043D\u0434\u0441\u044D\u043D",
                    "\u0414\u0443\u0433\u0443\u0439",
                    "\u0426\u044D\u0433",
                    "\u0414\u04E9\u0440\u0432\u04E9\u043B\u0436\u0438\u043D",
                    "\u0425\u0430\u0439\u0445",
                    "\u04E8\u043C\u043D\u04E9\u0445\u0438\u0439\u0433 \u043E\u043B",
                    "\u0414\u0430\u0440\u0430\u0430\u0433\u0438\u0439\u043D\u0445\u0438\u0439\u0433 \u043E\u043B",
                    "\u0411\u04AF\u043B\u0433\u0438\u0439\u043D \u043D\u044D\u0440\u044D\u044D \u043E\u0440\u0443\u0443\u043B\u043D\u0430 \u0443\u0443",
                    "\u0425\u044D\u043C\u0436\u044D\u044D\u0441\u0438\u0439\u0433 \u0448\u0438\u043D\u044D\u044D\u0440 \u04E9\u04E9\u0447\u0440\u043B\u04E9\u0445\u0438\u0439\u043D \u0442\u0443\u043B\u0434 Alt \u0442\u043E\u0432\u0447\u0438\u043D \u0434\u044D\u044D\u0440 \u0434\u0430\u0440\u043D\u0430 \u0443\u0443"
                ];
            },
            17084: function(e) {
                e.exports.default = [
                    "Begin met typen..",
                    "Over Jodit",
                    "Jodit Editor",
                    "Gratis niet-commerci\xeble versie",
                    "Jodit gebruikershandleiding",
                    "bevat gedetailleerde informatie voor gebruik.",
                    "Voor informatie over de licentie, ga naar onze website:",
                    "Volledige versie kopen",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Alle rechten voorbehouden.",
                    "Anker",
                    "Open in nieuwe tab",
                    "Editor in volledig scherm openen",
                    "Opmaak verwijderen",
                    "Vulkleur of tekstkleur aanpassen",
                    "Opnieuw",
                    "Ongedaan maken",
                    "Vet",
                    "Cursief",
                    "Geordende list invoegen",
                    "Ongeordende lijst invoegen",
                    "Centreren",
                    "Uitlijnen op volledige breedte",
                    "Links uitlijnen",
                    "Rechts uitlijnen",
                    "Horizontale lijn invoegen",
                    "Afbeelding invoegen",
                    "Bestand invoegen",
                    "Youtube/Vimeo video invoegen",
                    "Link toevoegen",
                    "Tekstgrootte",
                    "Lettertype",
                    "Format blok invoegen",
                    "Normaal",
                    "Koptekst 1",
                    "Koptekst 2",
                    "Koptekst 3",
                    "Koptekst 4",
                    "Citaat",
                    "Code",
                    "Invoegen",
                    "Tabel invoegen",
                    "Inspringing verkleinen",
                    "Inspringing vergroten",
                    "Symbool selecteren",
                    "Symbool invoegen",
                    "Opmaak kopieren",
                    "Modus veranderen",
                    "Marges",
                    "Boven",
                    "Rechts",
                    "Onder",
                    "Links",
                    "CSS styles",
                    "CSS classes",
                    "Uitlijning",
                    "Rechts",
                    "Gecentreerd",
                    "Links",
                    "--Leeg--",
                    "Src",
                    "Titel",
                    "Alternatieve tekst",
                    "Link",
                    "Link in nieuwe tab openen",
                    "Afbeelding",
                    "Bestand",
                    "Geavanceerd",
                    "Afbeeldingseigenschappen",
                    "Annuleren",
                    "OK",
                    "Deze code lijkt op HTML. Als HTML behouden?",
                    "Invoegen als HTML",
                    "Origineel behouden",
                    "Opschonen",
                    "Als tekst invoegen",
                    "Als onopgemaakte tekst invoegen",
                    "Word-tekst gedetecteerd",
                    "De geplakte tekst is afkomstig van een Microsoft Word/Excel document. Wil je de opmaak behouden of opschonen?",
                    "Bestandsbrowser",
                    "Fout bij het laden van de lijst",
                    "Fout bij het laden van de mappenlijst",
                    "Weet je het zeker?",
                    "Geef de map een naam",
                    "Map aanmaken",
                    "Type naam",
                    "Sleep hier een afbeelding naartoe",
                    "Sleep hier een bestand naartoe",
                    "of klik",
                    "Alternatieve tekst",
                    "Bladeren",
                    "Uploaden",
                    "Achtergrond",
                    "Tekst",
                    "Boven",
                    "Midden",
                    "Onder",
                    "Kolom invoegen (voor)",
                    "Kolom invoegen (na)",
                    "Rij invoegen (boven)",
                    "Rij invoegen (onder)",
                    "Tabel verwijderen",
                    "Rij verwijderen",
                    "Kolom verwijderen",
                    "Cel leegmaken",
                    "Broncode",
                    "vet",
                    "cursief",
                    "kwast",
                    "link",
                    "ongedaan maken",
                    "opnieuw",
                    "tabel",
                    "afbeelding",
                    "gum",
                    "paragraaf",
                    "lettergrootte",
                    "video",
                    "lettertype",
                    "over",
                    "afdrukken",
                    "onderstreept",
                    "doorgestreept",
                    "inspringen",
                    "minder inspringen",
                    "volledige grootte",
                    "kleiner maken",
                    "horizontale lijn",
                    "lijst",
                    "genummerde lijst",
                    "knip",
                    "alles selecteren",
                    "Embed code",
                    "link openen",
                    "link aanpassen",
                    "niet volgen",
                    "link verwijderen",
                    "Recensie",
                    "Om te bewerken",
                    "Updaten",
                    " URL",
                    "Bewerken",
                    "Horizontaal uitlijnen",
                    "Filteren",
                    "Sorteren op wijzigingsdatum",
                    "Sorteren op naam",
                    "Sorteren op grootte",
                    "Map toevoegen",
                    "Herstellen",
                    "Opslaan",
                    "Opslaan als ...",
                    "Grootte aanpassen",
                    "Bijknippen",
                    "Breedte",
                    "Hoogte",
                    "Verhouding behouden",
                    "Ja",
                    "Nee",
                    "Verwijderen",
                    "Selecteren",
                    "Tekens: %d",
                    "Woorden: %d",
                    "Alles",
                    "Selecteer: %s",
                    "Selecteer alles",
                    "Verticaal uitlijnen",
                    "Splitsen",
                    "Verticaal splitsen",
                    "Horizontaal splitsen",
                    "Samenvoegen",
                    "Kolom toevoegen",
                    "Rij toevoegen",
                    "Verwijderen",
                    "Rand",
                    null,
                    "Doorstrepen",
                    "Onderstrepen",
                    "Superscript",
                    "Subscript",
                    "Selectie knippen",
                    "Enter",
                    "Zoek naar",
                    "Vervangen door",
                    "Vervangen",
                    "Plakken",
                    "Kies content om te plakken",
                    "Je kunt alleen je eigen afbeeldingen aanpassen. Deze afbeelding downloaden?",
                    "De afbeelding is succesvol ge\xfcploadet!",
                    "Palette",
                    "Er zijn geen bestanden in deze map.",
                    "Hongaars",
                    "Voer een nieuwe naam in",
                    "voorvertoning",
                    "Download",
                    "Plakken van klembord",
                    "Uw browser ondersteunt geen directe toegang tot het klembord.",
                    "Selectie kopi\xebren",
                    "kopi\xebren",
                    "Border radius",
                    "Toon alle",
                    "Toepassing",
                    "Vul dit veld",
                    "Voer een webadres",
                    "Standaard",
                    "Cirkel",
                    "Dot",
                    "Quadrate",
                    "Zoeken",
                    "Vorige Zoeken",
                    "Volgende Zoeken",
                    "Voeg de klassenaam in",
                    "Druk op Alt voor aangepaste grootte"
                ];
            },
            96891: function(e) {
                e.exports.default = [
                    "Napisz co\u015B",
                    "O Jodit",
                    "Edytor Jodit",
                    null,
                    "Instrukcja Jodit",
                    "zawiera szczeg\xf3\u0142owe informacje dotycz\u0105ce u\u017Cytkowania.",
                    "Odwied\u017A nasz\u0105 stron\u0119, aby uzyska\u0107 wi\u0119cej informacji na temat licencji:",
                    "Zakup pe\u0142nej wersji",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Wszystkie prawa zastrze\u017Cone.",
                    "Kotwica",
                    "Otw\xf3rz w nowej zak\u0142adce",
                    "Otw\xf3rz edytor w pe\u0142nym rozmiarze",
                    "Wyczy\u015B\u0107 formatowanie",
                    "Kolor wype\u0142nienia lub ustaw kolor tekstu",
                    "Pon\xf3w",
                    "Cofnij",
                    "Pogrubienie",
                    "Kursywa",
                    "Wstaw list\u0119 wypunktowan\u0105",
                    "Wstaw list\u0119 numeryczn\u0105",
                    "Wy\u015Brodkuj",
                    "Wyjustuj",
                    "Wyr\xf3wnaj do lewej",
                    "Wyr\xf3wnaj do prawej",
                    "Wstaw lini\u0119 poziom\u0105",
                    "Wstaw grafik\u0119",
                    "Wstaw plik",
                    "Wstaw film Youtube/vimeo",
                    "Wstaw link",
                    "Rozmiar tekstu",
                    "Kr\xf3j czcionki",
                    "Wstaw formatowanie",
                    "Normalne",
                    "Nag\u0142\xf3wek 1",
                    "Nag\u0142\xf3wek 2",
                    "Nag\u0142\xf3wek 3",
                    "Nag\u0142\xf3wek 4",
                    "Cytat",
                    "Kod",
                    "Wstaw",
                    "Wstaw tabel\u0119",
                    "Zmniejsz wci\u0119cie",
                    "Zwi\u0119ksz wci\u0119cie",
                    "Wybierz znak specjalny",
                    "Wstaw znak specjalny",
                    "Malarz format\xf3w",
                    "Zmie\u0144 tryb",
                    "Marginesy",
                    "G\xf3rny",
                    "Prawy",
                    "Dolny",
                    "Levy",
                    "Style CSS",
                    "Klasy CSS",
                    "Wyr\xf3wnanie",
                    "Prawa",
                    "\u015Brodek",
                    "Lewa",
                    "brak",
                    "\u0179r\xf3d\u0142o",
                    "Tytu\u0142",
                    "Tekst alternatywny",
                    "Link",
                    "Otw\xf3rz w nowej zak\u0142adce",
                    "Grafika",
                    "Plik",
                    "Zaawansowane",
                    "W\u0142a\u015Bciwo\u015Bci grafiki",
                    "Anuluj",
                    "OK",
                    "Tw\xf3j kod wygl\u0105da jak HTML. Zachowa\u0107 HTML?",
                    "Wklei\u0107 jako HTML?",
                    "Oryginalny tekst",
                    "Wyczy\u015B\u0107",
                    "Wstaw jako tekst",
                    "Wstaw tylko tre\u015B\u0107",
                    "Wykryto tekst w formacie Word",
                    "Wklejany tekst pochodzi z dokumentu Microsoft Word/Excel. Chcesz zachowa\u0107 ten format czy wyczy\u015Bci\u0107 go? ",
                    "Przegl\u0105darka plik\xf3w",
                    "B\u0142\u0105d \u0142adowania listy plik\xf3w",
                    "B\u0142\u0105d \u0142adowania folder\xf3w",
                    "Czy jeste\u015B pewien?",
                    "Wprowad\u017A nazw\u0119 folderu",
                    "Utw\xf3rz folder",
                    "wprowad\u017A nazw\u0119",
                    "Upu\u015B\u0107 plik graficzny",
                    "Upu\u015B\u0107 plik",
                    "lub kliknij tu",
                    "Tekst alternatywny",
                    "Przegl\u0105daj",
                    "Wczytaj",
                    "T\u0142o",
                    "Tre\u015B\u0107",
                    "G\xf3ra",
                    "\u015Arodek",
                    "D\xf3\u0142",
                    "Wstaw kolumn\u0119 przed",
                    "Wstaw kolumn\u0119 po",
                    "Wstaw wiersz przed",
                    "Wstaw wiersz po",
                    "Usu\u0144 tabel\u0119",
                    "Usu\u0144 wiersz",
                    "Usu\u0144 kolumn\u0119",
                    "Wyczy\u015B\u0107 kom\xf3rk\u0119",
                    "HTML",
                    "pogrubienie",
                    "kursywa",
                    "p\u0119dzel",
                    "link",
                    "cofnij",
                    "pon\xf3w",
                    "tabela",
                    "grafika",
                    "wyczy\u015B\u0107",
                    "akapit",
                    "rozmiar czcionki",
                    "wideo",
                    "czcionka",
                    "O programie",
                    "drukuj",
                    "podkre\u015Blenie",
                    "przekre\u015Blenie",
                    "wci\u0119cie",
                    "wyci\u0119cie",
                    "pe\u0142en rozmiar",
                    "przytnij",
                    "linia pozioma",
                    "lista",
                    "lista numerowana",
                    "wytnij",
                    "zaznacz wszystko",
                    "Wstaw kod",
                    "otw\xf3rz link",
                    "edytuj link",
                    "Atrybut no-follow",
                    "Usu\u0144 link",
                    "szukaj",
                    "edytuj",
                    "Aktualizuj",
                    "URL",
                    "Edytuj",
                    "Wyr\xf3wnywanie w poziomie",
                    "Filtruj",
                    "Sortuj wg zmiany",
                    "Sortuj wg nazwy",
                    "Sortuj wg rozmiaru",
                    "Dodaj folder",
                    "wyczy\u015B\u0107",
                    "zapisz",
                    "zapisz jako",
                    "Zmie\u0144 rozmiar",
                    "Przytnij",
                    "Szeroko\u015B\u0107",
                    "Wysoko\u015B\u0107",
                    "Zachowaj proporcje",
                    "Tak",
                    "Nie",
                    "Usu\u0144",
                    "Wybierz",
                    "Znaki: %d",
                    "S\u0142owa: %d",
                    "Wszystko",
                    "Wybierz: %s",
                    "Wybierz wszystko",
                    "Wyr\xf3wnywanie w pionie",
                    "Podziel",
                    "Podziel w pionie",
                    "Podziel w poziomie",
                    "Scal",
                    "Dodaj kolumn\u0119",
                    "Dodaj wiersz",
                    "Usu\u0144",
                    "Obramowanie",
                    null,
                    "Przekre\u015Blenie",
                    "Podkre\u015Blenie",
                    "indeks g\xf3rny",
                    "index dolny",
                    "Wytnij zaznaczenie",
                    "Przerwa",
                    "Szukaj",
                    "Zamie\u0144 na",
                    "Wymieni\u0107",
                    "Wklej",
                    "Wybierz zawarto\u015B\u0107 do wklejenia",
                    "Mo\u017Cesz edytowa\u0107 tylko swoje grafiki. Czy chcesz pobra\u0107 t\u0105 grafik\u0119?",
                    "Grafika zosta\u0142a pomy\u015Blnienie dodana na serwer",
                    "Paleta",
                    "Brak plik\xf3w.",
                    "zmie\u0144 nazw\u0119",
                    "Wprowad\u017A now\u0105 nazw\u0119",
                    "podgl\u0105d",
                    "pobierz",
                    "Wklej ze schowka",
                    "Twoja przegl\u0105darka nie obs\u0142uguje schowka",
                    "Kopiuj zaznaczenie",
                    "kopiuj",
                    "Zaokr\u0105glenie kraw\u0119dzi",
                    "Poka\u017C wszystkie",
                    "Zastosuj",
                    "Prosz\u0119 wype\u0142ni\u0107 to pole",
                    "Prosz\u0119, wpisz adres sieci web",
                    "Domy\u015Blnie",
                    "Ko\u0142o",
                    "Punkt",
                    "Kwadrat",
                    "Znale\u017A\u0107",
                    "Znale\u017A\u0107 Poprzednie",
                    "Znajd\u017A Dalej",
                    "Wstaw nazw\u0119 zaj\u0119\u0107",
                    "Naci\u015Bnij Alt, aby zmieni\u0107 rozmiar"
                ];
            },
            31211: function(e) {
                e.exports.default = [
                    "Escreva algo...",
                    "Sobre o Jodit",
                    "Editor Jodit",
                    null,
                    "Guia de usu\xe1rio Jodit",
                    "cont\xe9m ajuda detalhada para o uso.",
                    "Para informa\xe7\xe3o sobre a licen\xe7a, por favor visite nosso site:",
                    "Compre a vers\xe3o completa",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. Todos os direitos reservados.",
                    "Link",
                    "Abrir em nova aba",
                    "Abrir editor em tela cheia",
                    "Limpar formata\xe7\xe3o",
                    "Cor de preenchimento ou cor do texto",
                    "Refazer",
                    "Desfazer",
                    "Negrito",
                    "It\xe1lico",
                    "Inserir lista n\xe3o ordenada",
                    "Inserir lista ordenada",
                    "Centralizar",
                    "Justificar",
                    "Alinhar \xe0 Esquerda",
                    "Alinhar \xe0 Direita",
                    "Inserir linha horizontal",
                    "Inserir imagem",
                    "Inserir arquivo",
                    "Inserir v\xeddeo do Youtube/vimeo",
                    "Inserir link",
                    "Tamanho da letra",
                    "Fonte",
                    "Inserir bloco",
                    "Normal",
                    "Cabe\xe7alho 1",
                    "Cabe\xe7alho 2",
                    "Cabe\xe7alho 3",
                    "Cabe\xe7alho 4",
                    "Cita\xe7\xe3o",
                    "C\xf3digo",
                    "Inserir",
                    "Inserir tabela",
                    "Diminuir recuo",
                    "Aumentar recuo",
                    "Selecionar caractere especial",
                    "Inserir caractere especial",
                    "Copiar formato",
                    "Mudar modo",
                    "Margens",
                    "cima",
                    "direta",
                    "baixo",
                    "esquerda",
                    "Estilos CSS",
                    "Classes CSS",
                    "Alinhamento",
                    "Direita",
                    "Centro",
                    "Esquerda",
                    "--N\xe3o Estabelecido--",
                    "Fonte",
                    "T\xedtulo",
                    "Texto Alternativo",
                    "Link",
                    "Abrir link em nova aba",
                    "Imagem",
                    "Arquivo",
                    "Avan\xe7ado",
                    "Propriedades da imagem",
                    "Cancelar",
                    "Ok",
                    "Seu c\xf3digo \xe9 similar ao HTML. Manter como HTML?",
                    "Colar como HTML?",
                    "Manter",
                    "Limpar",
                    "Inserir como Texto",
                    "Inserir somente o Texto",
                    "Colado do Word Detectado",
                    "O conte\xfado colado veio de um documento Microsoft Word/Excel. Voc\xea deseja manter o formato ou limpa-lo?",
                    "Procurar arquivo",
                    "Erro ao carregar a lista",
                    "Erro ao carregar as pastas",
                    "Voc\xea tem certeza?",
                    "Escreva o nome da pasta",
                    "Criar pasta",
                    "Escreva seu nome",
                    "Soltar imagem",
                    "Soltar arquivo",
                    "ou clique",
                    "Texto alternativo",
                    "Explorar",
                    "Upload",
                    "Fundo",
                    "Texto",
                    "Cima",
                    "Meio",
                    "Baixo",
                    "Inserir coluna antes",
                    "Inserir coluna depois",
                    "Inserir linha acima",
                    "Inserir linha abaixo",
                    "Excluir tabela",
                    "Excluir linha",
                    "Excluir coluna",
                    "Limpar c\xe9lula",
                    "HTML",
                    "negrito",
                    "it\xe1lico",
                    "pincel",
                    "link",
                    "desfazer",
                    "refazer",
                    "tabela",
                    "imagem",
                    "apagar",
                    "par\xe1grafo",
                    "tamanho da letra",
                    "v\xeddeo",
                    "fonte",
                    "Sobre de",
                    "Imprimir",
                    "sublinhar",
                    "tachado",
                    "recuar",
                    "diminuir recuo",
                    "Tamanho completo",
                    "diminuir",
                    "linha horizontal",
                    "lista n\xe3o ordenada",
                    "lista ordenada",
                    "Cortar",
                    "Selecionar tudo",
                    "Incluir c\xf3digo",
                    "Abrir link",
                    "Editar link",
                    "N\xe3o siga",
                    "Remover link",
                    "Visualizar",
                    "Editar",
                    "Atualizar",
                    "URL",
                    "Editar",
                    "Alinhamento horizontal",
                    "filtrar",
                    "Ordenar por modifica\xe7\xe3o",
                    "Ordenar por nome",
                    "Ordenar por tamanho",
                    "Adicionar pasta",
                    "Resetar",
                    "Salvar",
                    "Salvar como...",
                    "Redimensionar",
                    "Recortar",
                    "Largura",
                    "Altura",
                    "Manter a propor\xe7\xe3o",
                    "Sim",
                    "N\xe3o",
                    "Remover",
                    "Selecionar",
                    "Caracteres: %d",
                    "Palavras: %d",
                    "Tudo",
                    "Selecionar: %s",
                    "Selecionar tudo",
                    "Alinhamento vertical",
                    "Dividir",
                    "Dividir vertical",
                    "Dividir horizontal",
                    "Mesclar",
                    "Adicionar coluna",
                    "Adicionar linha",
                    "Excluir",
                    "Borda",
                    null,
                    "Tachado",
                    "Sublinhar",
                    "sobrescrito",
                    "subscrito",
                    "Cortar sele\xe7\xe3o",
                    "Pausa",
                    "Procurar por",
                    "Substituir com",
                    "Substituir",
                    "Colar",
                    "Escolher conte\xfado para colar",
                    "Voc\xea s\xf3 pode editar suas pr\xf3prias imagens. Baixar essa imagem pro servidor?",
                    "A imagem foi enviada com sucesso para o servidor!",
                    "Palette",
                    "N\xe3o h\xe1 arquivos nesse diret\xf3rio.",
                    "H\xfangara",
                    "Digite um novo nome",
                    "preview",
                    "Baixar",
                    "Colar da \xe1rea de transfer\xeancia",
                    "O seu navegador n\xe3o oferece suporte a acesso direto para a \xe1rea de transfer\xeancia.",
                    "Selec\xe7\xe3o de c\xf3pia",
                    "c\xf3pia",
                    "Border radius",
                    "Mostrar todos os",
                    "Aplicar",
                    "Por favor, preencha este campo",
                    "Por favor introduza um endere\xe7o web",
                    "Padr\xe3o",
                    "C\xedrculo",
                    "Ponto",
                    "Quadro",
                    "Encontrar",
                    "Encontrar Anteriores",
                    "Localizar Pr\xf3xima",
                    "Insira o nome da classe",
                    "Pressione Alt para redimensionamento personalizado"
                ];
            },
            31109: function(e) {
                e.exports.default = [
                    "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0447\u0442\u043E-\u043B\u0438\u0431\u043E",
                    "\u041E Jodit",
                    "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 Jodit",
                    null,
                    "Jodit \u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
                    "\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0434\u0435\u0442\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043F\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044E",
                    "\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043E \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0438 , \u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u043D\u0430 \u043D\u0430\u0448 \u0441\u0430\u0439\u0442:",
                    "\u041A\u0443\u043F\u0438\u0442\u044C \u043F\u043E\u043B\u043D\u0443\u044E \u0432\u0435\u0440\u0441\u0438\u044E",
                    "\u0410\u0432\u0442\u043E\u0440\u0441\u043A\u0438\u0435 \u043F\u0440\u0430\u0432\u0430 \xa9 XDSoft.net - \u0427\u0443\u043F\u0443\u0440\u043D\u043E\u0432 \u0412\u0430\u043B\u0435\u0440\u0438\u0439. \u0412\u0441\u0435 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u044B.",
                    "\u0410\u043D\u043A\u043E\u0440",
                    "\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u0432 \u043D\u043E\u0432\u043E\u0439 \u0432\u043A\u043B\u0430\u0434\u043A\u0435",
                    "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u0440\u0430\u0437\u043C\u0435\u0440\u0435",
                    "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
                    "\u0426\u0432\u0435\u0442 \u0437\u0430\u043B\u0438\u0432\u043A\u0438 \u0438\u043B\u0438 \u0446\u0432\u0435\u0442 \u0442\u0435\u043A\u0441\u0442\u0430",
                    "\u041F\u043E\u0432\u0442\u043E\u0440",
                    "\u041E\u0442\u043C\u0435\u043D\u0430",
                    "\u0416\u0438\u0440\u043D\u044B\u0439",
                    "\u041D\u0430\u043A\u043B\u043E\u043D\u043D\u044B\u0439",
                    "\u0412\u0441\u0442\u0430\u0432\u043A\u0430 \u043C\u0430\u0440\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0441\u043F\u0438\u0441\u043A\u0430",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0443\u043C\u0435\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A",
                    "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u0446\u0435\u043D\u0442\u0440\u0443",
                    "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u0448\u0438\u0440\u0438\u043D\u0435",
                    "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u043B\u0435\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                    "\u0412\u044B\u0440\u043E\u0432\u043D\u044F\u0442\u044C \u043F\u043E \u043F\u0440\u0430\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u0443\u044E \u043B\u0438\u043D\u0438\u044E",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0444\u0430\u0439\u043B",
                    "\u0412\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0432\u0438\u0434\u0435\u043E",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                    "\u0420\u0430\u0437\u043C\u0435\u0440 \u0448\u0440\u0438\u0444\u0442\u0430",
                    "\u0428\u0440\u0438\u0444\u0442",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0431\u043B\u043E\u0447\u043D\u044B\u0439 \u044D\u043B\u0435\u043C\u0435\u043D\u0442",
                    "\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442",
                    "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 1",
                    "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 2",
                    "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 3",
                    "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A 4",
                    "\u0426\u0438\u0442\u0430\u0442\u0430",
                    "\u041A\u043E\u0434",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0443",
                    "\u0423\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u044C \u043E\u0442\u0441\u0442\u0443\u043F",
                    "\u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043E\u0442\u0441\u0442\u0443\u043F",
                    "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0438\u043C\u0432\u043E\u043B",
                    "\u0424\u043E\u0440\u043C\u0430\u0442 \u043A\u0440\u0430\u0441\u043A\u0438",
                    "\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A",
                    "\u041E\u0442\u0441\u0442\u0443\u043F\u044B",
                    "\u0441\u0432\u0435\u0440\u0445\u0443",
                    "\u0441\u043F\u0440\u0430\u0432\u0430",
                    "\u0441\u043D\u0438\u0437\u0443",
                    "\u0441\u043B\u0435\u0432\u0430",
                    "\u0421\u0442\u0438\u043B\u0438",
                    "\u041A\u043B\u0430\u0441\u0441\u044B",
                    "\u0412\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
                    "\u041F\u043E \u043F\u0440\u0430\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                    "\u041F\u043E \u0446\u0435\u043D\u0442\u0440\u0443",
                    "\u041F\u043E \u043B\u0435\u0432\u043E\u043C\u0443 \u043A\u0440\u0430\u044E",
                    "--\u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C--",
                    "src",
                    "\u0417\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A",
                    "\u0410\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442 (alt)",
                    "\u0421\u0441\u044B\u043B\u043A\u0430",
                    "\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443 \u0432 \u043D\u043E\u0432\u043E\u043C \u043E\u043A\u043D\u0435",
                    null,
                    "\u0424\u0430\u0439\u043B",
                    "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0435",
                    "\u0421\u0432\u043E\u0439\u0441\u0442\u0432\u0430 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F",
                    "\u041E\u0442\u043C\u0435\u043D\u0430",
                    "\u041E\u043A",
                    "\u0412\u0430\u0448 \u0442\u0435\u043A\u0441\u0442, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u043F\u044B\u0442\u0430\u0435\u0442\u0435\u0441\u044C \u0432\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0445\u043E\u0436 \u043D\u0430 HTML. \u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0435\u0433\u043E \u043A\u0430\u043A HTML?",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043A HTML?",
                    "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043E\u0440\u0438\u0433\u0438\u043D\u0430\u043B",
                    "\u041F\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043A\u0430\u043A \u0442\u0435\u043A\u0441\u0442",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u0435\u043A\u0441\u0442",
                    "\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u044D\u0442\u043E \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442 Word \u0438\u043B\u0438 Excel",
                    "\u041A\u043E\u043D\u0442\u0435\u043D\u0442 \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u0432\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0435 \u043F\u043E\u0441\u0442\u0443\u043F\u0430\u0435\u0442 \u0438\u0437 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 Microsoft Word / Excel. \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0430\u0442 \u0438\u043B\u0438 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0435\u0433\u043E?",
                    "\u0411\u0440\u0430\u0443\u0437\u0435\u0440 \u0444\u0430\u0439\u043B\u043E\u0432",
                    "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0441\u043F\u0438\u0441\u043A\u0430 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0439",
                    "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0441\u043F\u0438\u0441\u043A\u0430 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438\u0439",
                    "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B?",
                    "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438\u0438",
                    "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0438\u044E",
                    "\u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
                    "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0441\u044E\u0434\u0430 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
                    "\u041F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0441\u044E\u0434\u0430 \u0444\u0430\u0439\u043B",
                    "\u0438\u043B\u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435",
                    "\u0410\u043B\u044C\u0442\u0435\u0440\u043D\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442",
                    "\u0421\u0435\u0440\u0432\u0435\u0440",
                    "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430",
                    "\u0424\u043E\u043D",
                    "\u0422\u0435\u043A\u0441\u0442",
                    " \u041A \u0432\u0435\u0440\u0445\u0443",
                    "\u041F\u043E \u0441\u0435\u0440\u0435\u0434\u0438\u043D\u0435",
                    "\u041A \u043D\u0438\u0437\u0443",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 \u0434\u043E",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446 \u043F\u043E\u0441\u043B\u0435",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0440\u044F\u0434 \u0432\u044B\u0448\u0435",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0440\u044F\u0434 \u043D\u0438\u0436\u0435",
                    "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0430\u0431\u043B\u0438\u0446\u0443",
                    "\u0423\u0434\u0430\u043B\u044F\u0442\u044C \u0440\u044F\u0434",
                    "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446",
                    "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u044F\u0447\u0435\u0439\u043A\u0443",
                    "HTML",
                    "\u0436\u0438\u0440\u043D\u044B\u0439",
                    "\u043A\u0443\u0440\u0441\u0438\u0432",
                    "\u0437\u0430\u043B\u0438\u0432\u043A\u0430",
                    "\u0441\u0441\u044B\u043B\u043A\u0430",
                    "\u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C",
                    "\u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
                    "\u0442\u0430\u0431\u043B\u0438\u0446\u0430",
                    "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435",
                    "\u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                    "\u043F\u0430\u0440\u0430\u0433\u0440\u0430\u0444",
                    "\u0440\u0430\u0437\u043C\u0435\u0440 \u0448\u0440\u0438\u0444\u0442\u0430",
                    "\u0432\u0438\u0434\u0435\u043E",
                    "\u0448\u0440\u0438\u0444\u0442",
                    "\u043E \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0435",
                    "\u043F\u0435\u0447\u0430\u0442\u044C",
                    "\u043F\u043E\u0434\u0447\u0435\u0440\u043A\u043D\u0443\u0442\u044B\u0439",
                    "\u043F\u0435\u0440\u0435\u0447\u0435\u0440\u043A\u043D\u0443\u0442\u044B\u0439",
                    "\u043E\u0442\u0441\u0442\u0443\u043F",
                    "\u0432\u044B\u0441\u0442\u0443\u043F",
                    "\u0432\u043E \u0432\u0435\u0441\u044C \u044D\u043A\u0440\u0430\u043D",
                    "\u043E\u0431\u044B\u0447\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440",
                    "\u043B\u0438\u043D\u0438\u044F",
                    "\u0421\u043F\u0438\u0441\u043E\u043A",
                    "\u041D\u0443\u043C\u0435\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A",
                    "\u0412\u044B\u0440\u0435\u0437\u0430\u0442\u044C",
                    "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435",
                    "\u041A\u043E\u0434",
                    "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                    "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                    "\u0410\u0442\u0440\u0438\u0431\u0443\u0442 nofollow",
                    "\u0423\u0431\u0440\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
                    "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                    "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                    "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C",
                    "URL",
                    "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
                    "\u0413\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
                    "\u0424\u0438\u043B\u044C\u0442\u0440",
                    "\u041F\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044E",
                    "\u041F\u043E \u0438\u043C\u0435\u043D\u0438",
                    "\u041F\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0443",
                    "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043F\u0430\u043F\u043A\u0443",
                    "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C",
                    "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C",
                    "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u043A\u0430\u043A",
                    "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440",
                    "\u041E\u0431\u0440\u0435\u0437\u0430\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440",
                    "\u0428\u0438\u0440\u0438\u043D\u0430",
                    "\u0412\u044B\u0441\u043E\u0442\u0430",
                    "\u0421\u043E\u0445\u0440\u0430\u043D\u044F\u0442\u044C \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u0438",
                    "\u0414\u0430",
                    "\u041D\u0435\u0442",
                    "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                    "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C",
                    "\u0421\u0438\u043C\u0432\u043E\u043B\u043E\u0432: %d",
                    "\u0421\u043B\u043E\u0432: %d",
                    "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435",
                    "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C: %s",
                    "\u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C \u0432\u0441\u0435",
                    "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435",
                    "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C",
                    "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u043F\u043E \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u0438",
                    "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u043F\u043E \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u0438",
                    "\u041E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u0432 \u043E\u0434\u043D\u0443",
                    "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u043E\u043B\u0431\u0435\u0446",
                    "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u043A\u0443",
                    "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
                    "\u0420\u0430\u043C\u043A\u0430",
                    "\u041B\u0438\u0446\u0435\u043D\u0437\u0438\u044F: %s",
                    "\u041F\u0435\u0440\u0435\u0447\u0435\u0440\u043A\u043D\u0443\u0442\u044C",
                    "\u041F\u043E\u0434\u0447\u0435\u0440\u043A\u0438\u0432\u0430\u043D\u0438\u0435",
                    "\u0432\u0435\u0440\u0445\u043D\u0438\u0439 \u0438\u043D\u0434\u0435\u043A\u0441",
                    "\u0438\u043D\u0434\u0435\u043A\u0441",
                    "\u0412\u044B\u0440\u0435\u0437\u0430\u0442\u044C",
                    "\u0420\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C",
                    "\u041D\u0430\u0439\u0442\u0438",
                    "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u043D\u0430",
                    "\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C",
                    "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u043A\u043E\u043D\u0442\u0435\u043D\u0442 \u0434\u043B\u044F \u0432\u0441\u0442\u0430\u0432\u043A\u0438",
                    "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0441\u0432\u043E\u0438 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F. \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u044D\u0442\u043E \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448 \u0441\u0435\u0440\u0432\u0435\u0440?",
                    "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043E \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440!",
                    "\u043F\u0430\u043B\u0438\u0442\u0440\u0430",
                    "\u0412 \u0434\u0430\u043D\u043D\u043E\u043C \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0435 \u043D\u0435\u0442 \u0444\u0430\u0439\u043B\u043E\u0432",
                    "\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C",
                    "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u043E\u0432\u043E\u0435 \u0438\u043C\u044F",
                    "\u041F\u0440\u0435\u0434\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440",
                    "\u0421\u043A\u0430\u0447\u0430\u0442\u044C",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u0438\u0437 \u0431\u0443\u0444\u0435\u0440\u0430 \u043E\u0431\u043C\u0435\u043D\u0430",
                    "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043F\u0440\u044F\u043C\u043E\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u0431\u0443\u0444\u0435\u0440\u0443 \u043E\u0431\u043C\u0435\u043D\u0430.",
                    "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0435",
                    "\u043A\u043E\u043F\u0438\u044F",
                    "\u0420\u0430\u0434\u0438\u0443\u0441 \u0433\u0440\u0430\u043D\u0438\u0446\u044B",
                    "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435",
                    "\u041F\u0440\u0438\u043C\u0435\u043D\u0438\u0442\u044C",
                    "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u0435 \u044D\u0442\u043E \u043F\u043E\u043B\u0435",
                    "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u0432\u0435\u0431-\u0430\u0434\u0440\u0435\u0441",
                    "\u041F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E",
                    "\u041A\u0440\u0443\u0433",
                    "\u0422\u043E\u0447\u043A\u0430",
                    "\u041A\u0432\u0430\u0434\u0440\u0430\u0442",
                    "\u041D\u0430\u0439\u0442\u0438",
                    "\u041D\u0430\u0439\u0442\u0438 \u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435",
                    "\u041D\u0430\u0439\u0442\u0438 \u0414\u0430\u043B\u0435\u0435",
                    "\u0412\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0430\u0441\u0441\u0430",
                    "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 Alt \u0434\u043B\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0433\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u0430"
                ];
            },
            79375: function(e) {
                e.exports.default = [
                    "Bir \u015Feyler yaz",
                    "Jodit Hakk\u0131nda",
                    "Jodit Editor",
                    null,
                    "Jodit Kullan\u0131m K\u0131lavuzu",
                    "kullan\u0131m i\xe7in detayl\u0131 bilgiler i\xe7erir",
                    "Lisans hakk\u0131nda bilgi i\xe7in l\xfctfen web sitemize gidin:",
                    "Tam versiyonunu sat\u0131n al",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. T\xfcm haklar\u0131 sakl\u0131d\u0131r.",
                    "Ba\u011Flant\u0131",
                    "Yeni sekmede a\xe7",
                    "Edit\xf6r\xfc tam ekranda a\xe7",
                    "Stili temizle",
                    "Renk doldur veya yaz\u0131 rengi se\xe7",
                    "Yinele",
                    "Geri Al",
                    "Kal\u0131n",
                    "\u0130talik",
                    "S\u0131ras\u0131z Liste Ekle",
                    "S\u0131ral\u0131 Liste Ekle",
                    "Ortala",
                    "Kenarlara Yasla",
                    "Sola Yasla",
                    "Sa\u011Fa Yasla",
                    "Yatay \xc7izgi Ekle",
                    "Resim Ekle",
                    "Dosya Ekle",
                    "Youtube/Vimeo Videosu Ekle",
                    "Ba\u011Flant\u0131 Ekle",
                    "Font Boyutu",
                    "Font Ailesi",
                    "Blok Ekle",
                    "Normal",
                    "Ba\u015Fl\u0131k 1",
                    "Ba\u015Fl\u0131k 2",
                    "Ba\u015Fl\u0131k 3",
                    "Ba\u015Fl\u0131k 4",
                    "Al\u0131nt\u0131",
                    "Kod",
                    "Ekle",
                    "Tablo Ekle",
                    "Girintiyi Azalt",
                    "Girintiyi Artt\u0131r",
                    "\xd6zel Karakter Se\xe7",
                    "\xd6zel Karakter Ekle",
                    "Resim Bi\xe7imi",
                    "Mod De\u011Fi\u015Ftir",
                    "Bo\u015Fluklar",
                    "\xdcst",
                    "Sa\u011F",
                    "Alt",
                    "Sol",
                    "CSS Stilleri",
                    "CSS S\u0131n\u0131flar\u0131",
                    "Hizalama",
                    "Sa\u011F",
                    "Ortal\u0131",
                    "Sol",
                    "Belirsiz",
                    "Kaynak",
                    "Ba\u015Fl\u0131k",
                    "Alternatif Yaz\u0131",
                    "Link",
                    "Ba\u011Flant\u0131y\u0131 yeni sekmede a\xe7",
                    "Resim",
                    "Dosya",
                    "Geli\u015Fmi\u015F",
                    "Resim \xf6zellikleri",
                    "\u0130ptal",
                    "Tamam",
                    "Kodunuz HTML koduna benziyor. HTML olarak devam etmek ister misiniz?",
                    "HTML olarak yap\u0131\u015Ft\u0131r",
                    "Sakla",
                    "Temizle",
                    "Yaz\u0131 olarak ekle",
                    "Sadece yaz\u0131y\u0131 ekle",
                    "Word bi\xe7iminde yap\u0131\u015Ft\u0131rma alg\u0131land\u0131",
                    "Der Inhalt, den Sie einf\xfcgen, stammt aus einem Microsoft Word / Excel-Dokument. M\xf6chten Sie das Format erhalten oder l\xf6schen?",
                    "Dosya Listeleyici",
                    "Liste y\xfcklenirken hata olu\u015Ftu",
                    "Klas\xf6rler y\xfcklenirken hata olu\u015Ftur",
                    "Emin misiniz?",
                    "Dizin yolu giriniz",
                    "Dizin olu\u015Ftur",
                    "\u0130sim yaz",
                    "Resim b\u0131rak",
                    "Dosya b\u0131rak",
                    "veya t\u0131kla",
                    "Alternatif yaz\u0131",
                    "G\xf6zat",
                    "Y\xfckle",
                    "Arka plan",
                    "Yaz\u0131",
                    "\xdcst",
                    "Orta",
                    "A\u015Fa\u011F\u0131",
                    "\xd6ncesine kolon ekle",
                    "Sonras\u0131na kolon ekle",
                    "\xdcst\xfcne sat\u0131r ekle",
                    "Alt\u0131na sat\u0131r ekle",
                    "Tabloyu sil",
                    "Sat\u0131r\u0131 sil",
                    "Kolonu sil",
                    "H\xfccreyi temizle",
                    "Kaynak",
                    "Kal\u0131n",
                    "italik",
                    "F\u0131r\xe7a",
                    "Ba\u011Flant\u0131",
                    "Geri al",
                    "Yinele",
                    "Tablo",
                    "Resim",
                    "Silgi",
                    "Paragraf",
                    "Font boyutu",
                    "Video",
                    "Font",
                    "Hakk\u0131nda",
                    "Yazd\u0131r",
                    "Alt \xe7izgi",
                    "\xdcst\xfc \xe7izili",
                    "Girinti",
                    "\xc7\u0131k\u0131nt\u0131",
                    "Tam ekran",
                    "K\xfc\xe7\xfclt",
                    "Ayra\xe7",
                    "S\u0131ras\u0131z liste",
                    "S\u0131ral\u0131 liste",
                    "Kes",
                    "T\xfcm\xfcn\xfc se\xe7",
                    "Kod ekle",
                    "Ba\u011Flant\u0131y\u0131 a\xe7",
                    "Ba\u011Flant\u0131y\u0131 d\xfczenle",
                    "Nofollow \xf6zelli\u011Fi",
                    "Ba\u011Flant\u0131y\u0131 kald\u0131r",
                    "Yorumu",
                    "D\xfczenlemek i\xe7in",
                    "G\xfcncelle",
                    "URL",
                    "D\xfczenle",
                    "Yatay hizala",
                    "Filtre",
                    "De\u011Fi\u015Fime g\xf6re s\u0131rala",
                    "\u0130sme g\xf6re s\u0131rala",
                    "Boyuta g\xf6re s\u0131rala",
                    "Klas\xf6r ekle",
                    "S\u0131f\u0131rla",
                    "Kaydet",
                    "Farkl\u0131 kaydet",
                    "Boyutland\u0131r",
                    "K\u0131rp",
                    "Geni\u015Flik",
                    "Y\xfckseklik",
                    "En boy oran\u0131n\u0131 koru",
                    "Evet",
                    "Hay\u0131r",
                    "Sil",
                    "Se\xe7",
                    "Harfler: %d",
                    "Kelimeler: %d",
                    "T\xfcm\xfc",
                    "Se\xe7: %s",
                    "T\xfcm\xfcn\xfc se\xe7",
                    "Dikey hizala",
                    "Ay\u0131r",
                    "Dikey ay\u0131r",
                    "Yatay ay\u0131r",
                    "Birle\u015Ftir",
                    "Kolon ekle",
                    "Sat\u0131r ekle",
                    "Sil",
                    "Kenarl\u0131k",
                    null,
                    "\xdcst\xfc \xe7izili",
                    "Alt \xe7izgi",
                    "\xdcst yaz\u0131",
                    "Alt yaz\u0131",
                    "Se\xe7ilimi kes",
                    "Sat\u0131r sonu",
                    "Ara",
                    "\u015Eununla de\u011Fi\u015Ftir",
                    "De\u011Fi\u015Ftir",
                    "Yap\u0131\u015Ft\u0131r",
                    "Yap\u0131\u015Ft\u0131r\u0131lacak i\xe7erik se\xe7",
                    "Sadece kendi resimlerinizi d\xfczenleyebilirsiniz. Bu g\xf6rseli kendi hostunuza indirmek ister misiniz?",
                    "G\xf6rsel ba\u015Far\u0131yla hostunuza y\xfcklendi",
                    "Palet",
                    "Bu dizinde dosya yok",
                    "Yeniden isimlendir",
                    "Yeni isim girin",
                    "\xd6n izleme",
                    "\u0130ndir",
                    "Panodan yap\u0131\u015Ft\u0131r ",
                    "Taray\u0131c\u0131n\u0131z panoya do\u011Frudan eri\u015Fimi desteklemiyor.",
                    "Se\xe7imi kopyala",
                    "Kopyala",
                    "S\u0131n\u0131r yar\u0131\xe7ap\u0131",
                    "T\xfcm\xfcn\xfc G\xf6ster",
                    "Uygula",
                    "L\xfctfen bu alan\u0131 doldurun",
                    "L\xfctfen bir web adresi girin",
                    "Varsay\u0131lan",
                    "Daire",
                    "Nokta",
                    "Kare",
                    "Bul",
                    "\xd6ncekini Bul",
                    "Sonrakini Bul",
                    "S\u0131n\u0131f ad\u0131 girin",
                    "\xd6zel yeniden boyutland\u0131rma i\xe7in Alt tu\u015Funa bas\u0131n"
                ];
            },
            21042: function(e) {
                e.exports.default = [
                    "\u8F93\u5165\u4E00\u4E9B\u5185\u5BB9",
                    "\u5173\u4E8EJodit",
                    "Jodit Editor",
                    "Free Non-commercial Version",
                    "\u5F00\u53D1\u8005\u6307\u5357",
                    "\u4F7F\u7528\u5E2E\u52A9",
                    "\u6709\u5173\u8BB8\u53EF\u8BC1\u7684\u4FE1\u606F\uFF0C\u8BF7\u8BBF\u95EE\u6211\u4EEC\u7684\u7F51\u7AD9\uFF1A",
                    "\u8D2D\u4E70\u5B8C\u6574\u7248\u672C",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. \u7248\u6743\u6240\u6709",
                    "Anchor",
                    "\u5728\u65B0\u7A97\u53E3\u6253\u5F00",
                    "\u5168\u5C4F\u7F16\u8F91",
                    "\u6E05\u9664\u6837\u5F0F",
                    "\u989C\u8272",
                    "\u91CD\u505A",
                    "\u64A4\u9500",
                    "\u7C97\u4F53",
                    "\u659C\u4F53",
                    "\u7B26\u53F7\u5217\u8868",
                    "\u7F16\u53F7",
                    "\u5C45\u4E2D",
                    "\u5BF9\u9F50\u6587\u672C",
                    "\u5DE6\u5BF9\u9F50",
                    "\u53F3\u5BF9\u9F50",
                    "\u5206\u5272\u7EBF",
                    "\u56FE\u7247",
                    "\u6587\u4EF6",
                    "\u89C6\u9891",
                    "\u94FE\u63A5",
                    "\u5B57\u53F7",
                    "\u5B57\u4F53",
                    "\u683C\u5F0F\u5757",
                    "\u9ED8\u8BA4",
                    "\u6807\u98981",
                    "\u6807\u98982",
                    "\u6807\u98983",
                    "\u6807\u98984",
                    "\u5F15\u7528",
                    "\u4EE3\u7801",
                    "\u63D2\u5165",
                    "\u8868\u683C",
                    "\u51CF\u5C11\u7F29\u8FDB",
                    "\u589E\u52A0\u7F29\u8FDB",
                    "\u9009\u62E9\u7279\u6B8A\u7B26\u53F7",
                    "\u7279\u6B8A\u7B26\u53F7",
                    "\u683C\u5F0F\u590D\u5236",
                    "\u6539\u53D8\u6A21\u5F0F",
                    "\u5916\u8FB9\u8DDD\uFF08Margins\uFF09",
                    "top",
                    "right",
                    "bottom",
                    "left",
                    "\u6837\u5F0F",
                    "Classes",
                    "\u5BF9\u9F50\u65B9\u5F0F",
                    "\u5C45\u53F3",
                    "\u5C45\u4E2D",
                    "\u5C45\u5DE6",
                    "\u65E0",
                    "Src",
                    "Title",
                    "Alternative",
                    "Link",
                    "\u5728\u65B0\u7A97\u53E3\u6253\u5F00\u94FE\u63A5",
                    "\u56FE\u7247",
                    "file",
                    "\u9AD8\u7EA7",
                    "\u56FE\u7247\u5C5E\u6027",
                    "\u53D6\u6D88",
                    "\u786E\u5B9A",
                    "\u4F60\u7C98\u8D34\u7684\u6587\u672C\u662F\u4E00\u6BB5html\u4EE3\u7801\uFF0C\u662F\u5426\u4FDD\u7559\u6E90\u683C\u5F0F",
                    "html\u7C98\u8D34",
                    "\u4FDD\u7559\u6E90\u683C\u5F0F",
                    "\u5339\u914D\u76EE\u6807\u683C\u5F0F",
                    "\u628Ahtml\u4EE3\u7801\u89C6\u4E3A\u666E\u901A\u6587\u672C",
                    "\u53EA\u4FDD\u7559\u6587\u672C",
                    "\u6587\u672C\u7C98\u8D34",
                    "\u6B63\u5728\u7C98\u8D34 Word/Excel \u7684\u6587\u672C\uFF0C\u662F\u5426\u4FDD\u7559\u6E90\u683C\u5F0F\uFF1F",
                    "\u6587\u4EF6\u7BA1\u7406",
                    "\u52A0\u8F7Dlist\u9519\u8BEF",
                    "\u52A0\u8F7Dfolders\u9519\u8BEF",
                    "\u4F60\u786E\u5B9A\u5417\uFF1F",
                    "\u8F93\u5165\u8DEF\u5F84",
                    "\u521B\u5EFA\u8DEF\u5F84",
                    "type name",
                    "\u62D6\u52A8\u56FE\u7247\u5230\u6B64",
                    "\u62D6\u52A8\u6587\u4EF6\u5230\u6B64",
                    "\u6216\u70B9\u51FB",
                    "Alternative text",
                    "\u6D4F\u89C8",
                    "\u4E0A\u4F20",
                    "\u80CC\u666F\u8272",
                    "\u6587\u5B57",
                    "\u9876\u90E8",
                    "\u4E2D\u95F4",
                    "\u5E95\u90E8",
                    "\u5728\u4E4B\u524D\u63D2\u5165\u5217",
                    "\u5728\u4E4B\u540E\u63D2\u5165\u5217",
                    "\u5728\u4E4B\u524D\u63D2\u5165\u884C",
                    "\u5728\u4E4B\u540E\u63D2\u5165\u884C",
                    "\u5220\u9664\u8868\u683C",
                    "\u5220\u9664\u884C",
                    "\u5220\u9664\u5217",
                    "\u6E05\u9664\u5185\u5BB9",
                    "\u6E90\u7801",
                    "\u7C97\u4F53",
                    "\u659C\u4F53",
                    "\u989C\u8272",
                    "\u94FE\u63A5",
                    "\u64A4\u9500",
                    "\u91CD\u505A",
                    "\u8868\u683C",
                    "\u56FE\u7247",
                    "\u6A61\u76AE\u64E6",
                    "\u6BB5\u843D",
                    "\u5B57\u53F7",
                    "\u89C6\u9891",
                    "\u5B57\u4F53",
                    "\u5173\u4E8E",
                    "\u6253\u5370",
                    "\u4E0B\u5212\u7EBF",
                    "\u4E0A\u51FA\u73B0",
                    "\u589E\u52A0\u7F29\u8FDB",
                    "\u51CF\u5C11\u7F29\u8FDB",
                    "\u5168\u5C4F",
                    "\u6536\u7F29",
                    "\u5206\u5272\u7EBF",
                    "\u65E0\u5E8F\u5217\u8868",
                    "\u987A\u5E8F\u5217\u8868",
                    "\u526A\u5207",
                    "\u5168\u9009",
                    "\u5D4C\u5165\u4EE3\u7801",
                    "\u6253\u5F00\u94FE\u63A5",
                    "\u7F16\u8F91\u94FE\u63A5",
                    "No follow",
                    "\u53D6\u6D88\u94FE\u63A5",
                    "\u9884\u89C8",
                    "\u94C5\u7B14",
                    "\u66F4\u65B0",
                    "URL",
                    "\u7F16\u8F91",
                    "\u6C34\u5E73\u5BF9\u9F50",
                    "\u7B5B\u9009",
                    "\u4FEE\u6539\u65F6\u95F4\u6392\u5E8F",
                    "\u540D\u79F0\u6392\u5E8F",
                    "\u5927\u5C0F\u6392\u5E8F",
                    "\u65B0\u5EFA\u6587\u4EF6\u5939",
                    "\u91CD\u7F6E",
                    "\u4FDD\u5B58",
                    "\u4FDD\u5B58\u4E3A",
                    "\u8C03\u6574\u5927\u5C0F",
                    "\u526A\u5207",
                    "\u5BBD",
                    "\u9AD8",
                    "\u4FDD\u6301\u957F\u5BBD\u6BD4",
                    "\u662F",
                    "\u4E0D",
                    "\u79FB\u9664",
                    "\u9009\u62E9",
                    "\u5B57\u7B26\u6570: %d",
                    "\u5355\u8BCD\u6570: %d",
                    "\u5168\u90E8",
                    "\u9009\u62E9: %s",
                    "\u5168\u9009",
                    "\u5782\u76F4\u5BF9\u9F50",
                    "\u62C6\u5206",
                    "\u5782\u76F4\u62C6\u5206",
                    "\u6C34\u5E73\u62C6\u5206",
                    "\u5408\u5E76",
                    "\u6DFB\u52A0\u5217",
                    "\u6DFB\u52A0\u884C",
                    "\u5220\u9664",
                    "\u8FB9\u6846",
                    null,
                    "\u5220\u9664\u7EBF",
                    "\u4E0B\u5212\u7EBF",
                    "\u4E0A\u6807",
                    "\u4E0B\u6807",
                    "\u526A\u5207",
                    "Break",
                    "\u67E5\u627E",
                    "\u66FF\u6362\u4E3A",
                    "\u66FF\u6362",
                    "\u7C98\u8D34",
                    "\u9009\u62E9\u5185\u5BB9\u5E76\u7C98\u8D34",
                    "\u4F60\u53EA\u80FD\u7F16\u8F91\u4F60\u81EA\u5DF1\u7684\u56FE\u7247\u3002Download this image on the host?",
                    "\u56FE\u7247\u4E0A\u4F20\u6210\u529F",
                    "\u8C03\u8272\u677F",
                    "\u6B64\u76EE\u5F55\u4E2D\u6C92\u6709\u6587\u4EF6\u3002",
                    "\u91CD\u547D\u540D",
                    "\u8F93\u5165\u65B0\u540D\u79F0",
                    "\u9884\u89C8",
                    "\u4E0B\u8F7D",
                    "\u7C98\u8D34\u4ECE\u526A\u8D34\u677F",
                    "\u4F60\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u76F4\u63A5\u8BBF\u95EE\u7684\u526A\u8D34\u677F\u3002",
                    "\u590D\u5236\u9009\u4E2D\u5185\u5BB9",
                    "\u590D\u5236",
                    "\u8FB9\u754C\u534A\u5F84",
                    "\u663E\u793A\u6240\u6709",
                    "\u5E94\u7528",
                    "\u8BF7\u586B\u5199\u8FD9\u4E2A\u5B57\u6BB5",
                    "\u8BF7\u8F93\u5165\u4E00\u4E2A\u7F51\u5740",
                    "\u9ED8\u8BA4",
                    "\u5706\u5708",
                    "\u70B9",
                    "\u65B9\u5F62",
                    "\u641C\u7D22",
                    "\u67E5\u627E\u4E0A\u4E00\u4E2A",
                    "\u67E5\u627E\u4E0B\u4E00\u4E2A",
                    "\u63D2\u5165\u73ED\u7EA7\u540D\u79F0",
                    "\u6309Alt\u81EA\u5B9A\u4E49\u8C03\u6574\u5927\u5C0F"
                ];
            },
            73895: function(e) {
                e.exports.default = [
                    "\u8F38\u5165\u4E00\u4E9B\u5167\u5BB9",
                    "\u95DC\u65BCJodit",
                    "Jodit Editor",
                    null,
                    "\u958B\u767C\u8005\u6307\u5357",
                    "\u4F7F\u7528\u5E6B\u52A9",
                    "\u6709\u95DC\u8A31\u53EF\u8B49\u7684\u4FE1\u606F\uFF0C\u8ACB\u8A2A\u554F\u6211\u5011\u7684\u7DB2\u7AD9\uFF1A",
                    "\u8CFC\u8CB7\u5B8C\u6574\u7248\u672C",
                    "Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                    "Anchor",
                    "\u5728\u65B0\u7A97\u53E3\u6253\u958B",
                    "\u5168\u5C4F\u7DE8\u8F2F",
                    "\u6E05\u9664\u6A23\u5F0F",
                    "\u984F\u8272",
                    "\u91CD\u505A",
                    "\u64A4\u92B7",
                    "\u7C97\u9AD4",
                    "\u659C\u9AD4",
                    "\u7B26\u865F\u5217\u8868",
                    "\u7DE8\u865F",
                    "\u5C45\u4E2D",
                    "\u5C0D\u9F4A\u6587\u672C",
                    "\u5DE6\u5C0D\u9F4A",
                    "\u53F3\u5C0D\u9F4A",
                    "\u5206\u5272\u7DDA",
                    "\u5716\u7247",
                    "\u6587\u4EF6",
                    "youtube/vimeo \u5F71\u7247",
                    "\u93C8\u63A5",
                    "\u5B57\u865F",
                    "\u5B57\u9AD4",
                    "\u683C\u5F0F\u584A",
                    "\u6587\u672C",
                    "\u6A19\u984C1",
                    "\u6A19\u984C2",
                    "\u6A19\u984C3",
                    "\u6A19\u984C4",
                    "\u5F15\u7528",
                    "\u4EE3\u78BC",
                    "\u63D2\u5165",
                    "\u8868\u683C",
                    "\u6E1B\u5C11\u7E2E\u9032",
                    "\u589E\u52A0\u7E2E\u9032",
                    "\u9078\u64C7\u7279\u6B8A\u7B26\u865F",
                    "\u7279\u6B8A\u7B26\u865F",
                    "\u683C\u5F0F\u8907\u88FD",
                    "\u6539\u8B8A\u6A21\u5F0F",
                    "\u5916\u908A\u8DDD\uFF08Margins\uFF09",
                    "top",
                    "right",
                    "bottom",
                    "left",
                    "\u6A23\u5F0F",
                    "Classes",
                    "\u5C0D\u9F4A\u65B9\u5F0F",
                    "\u5C45\u53F3",
                    "\u5C45\u4E2D",
                    "\u5C45\u5DE6",
                    "\u7121",
                    "Src",
                    "Title",
                    "\u66FF\u4EE3",
                    "Link",
                    "\u5728\u65B0\u7A97\u53E3\u6253\u958B\u93C8\u63A5",
                    "\u5716\u7247",
                    "file",
                    "\u9AD8\u7D1A",
                    "\u5716\u7247\u5C6C\u6027",
                    "\u53D6\u6D88",
                    "\u78BA\u5B9A",
                    "\u4F60\u9ECF\u8CBC\u7684\u6587\u672C\u662F\u4E00\u6BB5html\u4EE3\u78BC\uFF0C\u662F\u5426\u4FDD\u7559\u6E90\u683C\u5F0F",
                    "html\u9ECF\u8CBC",
                    "\u4FDD\u7559\u6E90\u683C\u5F0F",
                    "\u5339\u914D\u76EE\u6A19\u683C\u5F0F",
                    "\u628Ahtml\u4EE3\u78BC\u8996\u70BA\u666E\u901A\u6587\u672C",
                    "\u53EA\u4FDD\u7559\u6587\u672C",
                    "\u6587\u672C\u9ECF\u8CBC",
                    "\u6B63\u5728\u9ECF\u8CBC Word/Excel \u7684\u6587\u672C\uFF0C\u662F\u5426\u4FDD\u7559\u6E90\u683C\u5F0F\uFF1F",
                    "\u6587\u4EF6\u7BA1\u7406",
                    "\u52A0\u8F09list\u932F\u8AA4",
                    "\u52A0\u8F09folders\u932F\u8AA4",
                    "\u4F60\u78BA\u5B9A\u55CE\uFF1F",
                    "\u8F38\u5165\u8DEF\u5F91",
                    "\u5275\u5EFA\u8DEF\u5F91",
                    "type name",
                    "\u62D6\u52D5\u5716\u7247\u5230\u6B64",
                    "\u62D6\u52D5\u6587\u4EF6\u5230\u6B64",
                    "\u6216\u9EDE\u64CA",
                    "\u66FF\u4EE3\u6587\u5B57",
                    "\u700F\u89BD",
                    "\u4E0A\u50B3",
                    "\u80CC\u666F\u8272",
                    "\u6587\u5B57",
                    "\u9802\u90E8",
                    "\u4E2D\u9593",
                    "\u5E95\u90E8",
                    "\u5728\u4E4B\u524D\u63D2\u5165\u5217",
                    "\u5728\u4E4B\u5F8C\u63D2\u5165\u5217",
                    "\u5728\u4E4B\u524D\u63D2\u5165\u884C",
                    "\u5728\u4E4B\u5F8C\u63D2\u5165\u884C",
                    "\u522A\u9664\u8868\u683C",
                    "\u522A\u9664\u884C",
                    "\u522A\u9664\u5217",
                    "\u6E05\u9664\u5167\u5BB9",
                    "\u6E90\u78BC",
                    "\u7C97\u9AD4",
                    "\u659C\u9AD4",
                    "\u984F\u8272",
                    "\u93C8\u63A5",
                    "\u64A4\u92B7",
                    "\u91CD\u505A",
                    "\u8868\u683C",
                    "\u5716\u7247",
                    "\u6A61\u76AE\u64E6",
                    "\u6BB5\u843D",
                    "\u5B57\u865F",
                    "\u5F71\u7247",
                    "\u5B57\u9AD4",
                    "\u95DC\u65BC",
                    "\u6253\u5370",
                    "\u4E0B\u5283\u7DDA",
                    "\u4E0A\u51FA\u73FE",
                    "\u589E\u52A0\u7E2E\u9032",
                    "\u6E1B\u5C11\u7E2E\u9032",
                    "\u5168\u5C4F",
                    "\u6536\u7E2E",
                    "\u5206\u5272\u7DDA",
                    "\u7121\u5E8F\u5217\u8868",
                    "\u9806\u5E8F\u5217\u8868",
                    "\u526A\u5207",
                    "\u5168\u9078",
                    "\u5D4C\u5165\u4EE3\u78BC",
                    "\u6253\u958B\u93C8\u63A5",
                    "\u7DE8\u8F2F\u93C8\u63A5",
                    "No follow",
                    "\u53D6\u6D88\u9023\u7D50",
                    "\u56DE\u9867",
                    "\u925B\u7B46",
                    "\u66F4\u65B0",
                    "URL",
                    null,
                    "\u6C34\u5E73\u5C0D\u9F4A",
                    "\u7BE9\u9078",
                    "\u4FEE\u6539\u6642\u9593\u6392\u5E8F",
                    "\u540D\u7A31\u6392\u5E8F",
                    "\u5927\u5C0F\u6392\u5E8F",
                    "\u65B0\u5EFA\u6587\u4EF6\u593E",
                    "\u91CD\u7F6E",
                    "\u4FDD\u5B58",
                    "\u4FDD\u5B58\u70BA",
                    "\u8ABF\u6574\u5927\u5C0F",
                    "Crop",
                    "\u5BEC",
                    "\u9AD8",
                    "\u4FDD\u5B58\u9577\u5BEC\u6BD4",
                    "\u662F",
                    "\u4E0D",
                    "\u79FB\u9664",
                    "\u9078\u64C7",
                    "\u5B57\u7B26\u6578: %d",
                    "\u55AE\u8A5E\u6578: %d",
                    "\u5168\u90E8",
                    "\u9078\u64C7: %s",
                    "\u5168\u9078",
                    "\u5782\u76F4\u5C0D\u9F4A",
                    "\u62C6\u5206",
                    "\u5782\u76F4\u62C6\u5206",
                    "\u6C34\u5E73\u62C6\u5206",
                    "\u5408\u4F75",
                    "\u6DFB\u52A0\u5217",
                    "\u6DFB\u52A0\u884C",
                    "\u522A\u9664",
                    "\u908A\u6846",
                    null,
                    "\u522A\u9664\u7DDA",
                    "\u4E0B\u5283\u7DDA",
                    "\u4E0A\u6A19",
                    "\u4E0B\u6A19",
                    "\u526A\u5207",
                    "Pause",
                    "\u67E5\u627E",
                    "\u66FF\u63DB\u70BA",
                    "\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48",
                    "\u9ECF\u8CBC",
                    "\u9078\u64C7\u5167\u5BB9\u4E26\u9ECF\u8CBC",
                    "\u4F60\u53EA\u80FD\u7DE8\u8F2F\u4F60\u81EA\u5DF1\u7684\u5716\u7247\u3002\u662F\u5426\u4E0B\u8F09\u6B64\u5716\u7247\u5230\u672C\u5730?",
                    "\u5716\u7247\u4E0A\u50B3\u6210\u529F",
                    "\u8ABF\u8272\u677F",
                    "\u6B64\u76EE\u9304\u4E2D\u6C92\u6709\u6587\u4EF6\u3002",
                    "\u91CD\u547D\u540D",
                    "\u8F38\u5165\u65B0\u540D\u7A31",
                    "\u9810\u89BD",
                    "\u4E0B\u8F09",
                    "\u5F9E\u526A\u8CBC\u677F\u8CBC\u4E0A",
                    "\u700F\u89BD\u5668\u7121\u6CD5\u5B58\u53D6\u526A\u8D34\u677F\u3002",
                    "\u8907\u88FD\u5DF2\u9078\u53D6\u9805\u76EE",
                    "\u8907\u88FD",
                    "\u908A\u6846\u5713\u89D2",
                    "\u986F\u793A\u6240\u6709",
                    "\u61C9\u7528",
                    "\u0E44\u0E14\u0E49\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E19\u0E35\u0E49",
                    "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E15\u0E34\u0E21\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E40\u0E27\u0E47\u0E1A",
                    "\u0E04\u0E48\u0E32\u0E1B\u0E23\u0E34\u0E22\u0E32\u0E22",
                    "\u0E27\u0E07\u0E01\u0E25\u0E21",
                    "\u0E08\u0E38\u0E14",
                    "Quadrate",
                    "\u0E04\u0E49\u0E19\u0E2B\u0E32",
                    "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49",
                    "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E16\u0E31\u0E14\u0E44\u0E1B",
                    "\u0E43\u0E2A\u0E48\u0E0A\u0E37\u0E48\u0E2D\u0E04\u0E25\u0E32\u0E2A",
                    "\u0E01\u0E14\u0E2D\u0E31\u0E25\u0E17\u0E4C\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E02\u0E19\u0E32\u0E14\u0E17\u0E35\u0E48\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E40\u0E2D\u0E07"
                ];
            },
            3610: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M621 1280h595v-595zm-45-45l595-595h-595v595zm1152 77v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"/> </svg>';
            },
            56170: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <g transform="translate(-251.000000, -443.000000)"> <g transform="translate(215.000000, 119.000000)"/> <path d="M252,448 L256,448 L256,444 L252,444 L252,448 Z M257,448 L269,448 L269,446 L257,446 L257,448 Z M257,464 L269,464 L269,462 L257,462 L257,464 Z M270,444 L270,448 L274,448 L274,444 L270,444 Z M252,462 L252,466 L256,466 L256,462 L252,462 Z M270,462 L270,466 L274,466 L274,462 L270,462 Z M254,461 L256,461 L256,449 L254,449 L254,461 Z M270,461 L272,461 L272,449 L270,449 L270,461 Z"/> </g> </svg>';
            },
            95331: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' x="0px" y="0px" viewBox="0 0 459 459"> <g> <path d="M229.5,0C102,0,0,102,0,229.5S102,459,229.5,459c20.4,0,38.25-17.85,38.25-38.25c0-10.2-2.55-17.85-10.2-25.5 c-5.1-7.65-10.2-15.3-10.2-25.5c0-20.4,17.851-38.25,38.25-38.25h45.9c71.4,0,127.5-56.1,127.5-127.5C459,91.8,357,0,229.5,0z M89.25,229.5c-20.4,0-38.25-17.85-38.25-38.25S68.85,153,89.25,153s38.25,17.85,38.25,38.25S109.65,229.5,89.25,229.5z M165.75,127.5c-20.4,0-38.25-17.85-38.25-38.25S145.35,51,165.75,51S204,68.85,204,89.25S186.15,127.5,165.75,127.5z M293.25,127.5c-20.4,0-38.25-17.85-38.25-38.25S272.85,51,293.25,51s38.25,17.85,38.25,38.25S313.65,127.5,293.25,127.5z M369.75,229.5c-20.4,0-38.25-17.85-38.25-38.25S349.35,153,369.75,153S408,170.85,408,191.25S390.15,229.5,369.75,229.5z" /> </g> </svg>';
            },
            84279: function(e) {
                e.exports = '<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"> <path d="M1088 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"/> </svg>';
            },
            11257: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 128 128" xml:space="preserve"> <polygon points="112.4560547,23.3203125 112.4560547,75.8154297 31.4853516,75.8154297 31.4853516,61.953125 16.0131836,72.6357422 0.5410156,83.3164063 16.0131836,93.9990234 31.4853516,104.6796875 31.4853516,90.8183594 112.4560547,90.8183594 112.4560547,90.8339844 127.4589844,90.8339844 127.4589844,23.3203125"/> </svg>';
            },
            25141: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"/> </svg>';
            },
            24557: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"/> </svg>';
            },
            10859: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"/> </svg>';
            },
            9813: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm639 217v206h-514l-4-27q-3-45-3-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 80-65 188-65 110 0 178 59.5t68 158.5q0 66-34.5 118.5t-84 86-99.5 62.5-87 63-41 73h232v-80h126z"/> </svg>';
            },
            93395: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1025 1369v167h-248l-159-252-24-42q-8-9-11-21h-3l-9 21q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zm637-679v206h-514l-3-27q-4-28-4-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 83-65 188-65 110 0 178 59.5t68 158.5q0 56-24.5 103t-62 76.5-81.5 58.5-82 50.5-65.5 51.5-30.5 63h232v-80h126z"/> </svg>';
            },
            98213: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"/> </svg>';
            },
            20026: function(e) {
                e.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M36 4h-24c-2.21 0-4 1.79-4 4v32c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-32c0-2.21-1.79-4-4-4zm-24 4h10v16l-5-3-5 3v-16z"/> </svg>';
            },
            66911: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"/> </svg>';
            },
            50018: function(e) {
                e.exports = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89,6.61H22.31V4.47A2.47,2.47,0,0,0,19.84,2H6.78A2.47,2.47,0,0,0,4.31,4.47V22.92a2.47,2.47,0,0,0,2.47,2.47H9.69V27.2a2.8,2.8,0,0,0,2.8,2.8h12.4a2.8,2.8,0,0,0,2.8-2.8V9.41A2.8,2.8,0,0,0,24.89,6.61ZM6.78,23.52a.61.61,0,0,1-.61-.6V4.47a.61.61,0,0,1,.61-.6H19.84a.61.61,0,0,1,.61.6V6.61h-8a2.8,2.8,0,0,0-2.8,2.8V23.52Zm19,3.68a.94.94,0,0,1-.94.93H12.49a.94.94,0,0,1-.94-.93V9.41a.94.94,0,0,1,.94-.93h12.4a.94.94,0,0,1,.94.93Z"/> <path d="M23.49,13.53h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,17.37h-9.6a.94.94,0,1,0,0,1.87h9.6a.94.94,0,1,0,0-1.87Z"/> <path d="M23.49,21.22h-9.6a.93.93,0,1,0,0,1.86h9.6a.93.93,0,1,0,0-1.86Z"/> </svg>';
            },
            99738: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zm300 64l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zm-681-260q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zm-85 745q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zm178-613l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zm224 224l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zm704 416l128-64-520-408-177 138q-2 3-13 7z"/> </svg>';
            },
            9185: function(e) {
                e.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"> <path stroke-width="0" d="M10.5 20H2a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h1V3l2.03-.4a3 3 0 0 1 5.94 0L13 3v1h1a2 2 0 0 1 2 2v1h-2V6h-1v1H3V6H2v12h5v2h3.5zM8 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm2 4h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8c0-1.1.9-2 2-2zm0 2v8h8v-8h-8z"/> </svg>';
            },
            8619: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 18 18"> <g fill-rule="evenodd" stroke="none" stroke-width="1"> <g transform="translate(-381.000000, -381.000000)"> <g transform="translate(381.000000, 381.000000)"> <path d="M0,2 L2,2 L2,0 C0.9,0 0,0.9 0,2 L0,2 Z M0,10 L2,10 L2,8 L0,8 L0,10 L0,10 Z M4,18 L6,18 L6,16 L4,16 L4,18 L4,18 Z M0,6 L2,6 L2,4 L0,4 L0,6 L0,6 Z M10,0 L8,0 L8,2 L10,2 L10,0 L10,0 Z M16,0 L16,2 L18,2 C18,0.9 17.1,0 16,0 L16,0 Z M2,18 L2,16 L0,16 C0,17.1 0.9,18 2,18 L2,18 Z M0,14 L2,14 L2,12 L0,12 L0,14 L0,14 Z M6,0 L4,0 L4,2 L6,2 L6,0 L6,0 Z M8,18 L10,18 L10,16 L8,16 L8,18 L8,18 Z M16,10 L18,10 L18,8 L16,8 L16,10 L16,10 Z M16,18 C17.1,18 18,17.1 18,16 L16,16 L16,18 L16,18 Z M16,6 L18,6 L18,4 L16,4 L16,6 L16,6 Z M16,14 L18,14 L18,12 L16,12 L16,14 L16,14 Z M12,18 L14,18 L14,16 L12,16 L12,18 L12,18 Z M12,2 L14,2 L14,0 L12,0 L12,2 L12,2 Z M4,14 L14,14 L14,4 L4,4 L4,14 L4,14 Z M6,6 L12,6 L12,12 L6,12 L6,6 L6,6 Z"/> </g> </g> </g> </svg>';
            },
            73894: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zm512-128q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"/> </svg>';
            },
            83301: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 16 16"> <path stroke-width="0" d="M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"/> </svg>';
            },
            84142: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 4-.5 13t-.5 13q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"/> </svg>';
            },
            57292: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zm-1663-1279l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5.5t107.5.5h293q6 0 21 .5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 .5t14 .5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-.5-16.5.5q-17 0-66.5-.5t-74.5-.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 .5-15.5t.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z"/> </svg>';
            },
            18019: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1534 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"/></svg>';
            },
            45146: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24"> <path stroke-width="0" d="M22,20.6L3.4,2H8V0H0v8h2V3.4L20.6,22H16v2h8v-8h-2V20.6z M16,0v2h4.7l-6.3,6.3l1.4,1.4L22,3.5V8h2V0H16z M8.3,14.3L2,20.6V16H0v8h8v-2H3.5l6.3-6.3L8.3,14.3z"/> </svg>';
            },
            53576: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"/> </svg>';
            },
            14655: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"/> </svg>';
            },
            53477: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"/> </svg>';
            },
            90053: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zm1440 480v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
            },
            72230: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zm1408 768v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
            },
            78321: function(e) {
                e.exports = '<svg viewBox="0 0 18.151 18.151" xmlns="http://www.w3.org/2000/svg"> <g> <path stroke-width="0" d="M6.237,16.546H3.649V1.604h5.916v5.728c0.474-0.122,0.968-0.194,1.479-0.194 c0.042,0,0.083,0.006,0.125,0.006V0H2.044v18.15h5.934C7.295,17.736,6.704,17.19,6.237,16.546z"/> <path stroke-width="0" d="M11.169,8.275c-2.723,0-4.938,2.215-4.938,4.938s2.215,4.938,4.938,4.938s4.938-2.215,4.938-4.938 S13.892,8.275,11.169,8.275z M11.169,16.81c-1.983,0-3.598-1.612-3.598-3.598c0-1.983,1.614-3.597,3.598-3.597 s3.597,1.613,3.597,3.597C14.766,15.198,13.153,16.81,11.169,16.81z"/> <polygon stroke-width="0" points="11.792,11.073 10.502,11.073 10.502,12.578 9.03,12.578 9.03,13.868 10.502,13.868 10.502,15.352 11.792,15.352 11.792,13.868 13.309,13.868 13.309,12.578 11.792,12.578 "/> </g> </svg>';
            },
            77654: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 432 432"> <g> <polygon points="203.688,96 0,96 0,144 155.688,144 "/> <polygon points="155.719,288 0,288 0,336 203.719,336 "/> <path d="M97.844,230.125c-3.701-3.703-5.856-8.906-5.856-14.141s2.154-10.438,5.856-14.141l9.844-9.844H0v48h107.719 L97.844,230.125z"/> <polygon points="232,176 232,96 112,216 232,336 232,256 432,256 432,176"/> </g> </svg>';
            },
            43371: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 312 312"> <g transform="translate(0.000000,312.000000) scale(0.100000,-0.100000)" stroke="none"> <path d="M50 3109 c0 -7 -11 -22 -25 -35 l-25 -23 0 -961 0 -961 32 -29 32 -30 501 -2 500 -3 3 -502 2 -502 31 -30 31 -31 958 0 958 0 23 25 c13 13 30 25 37 25 9 0 12 199 12 960 0 686 -3 960 -11 960 -6 0 -24 12 -40 28 l-29 27 -503 5 -502 5 -5 502 -5 503 -28 29 c-15 16 -27 34 -27 40 0 8 -274 11 -960 11 -710 0 -960 -3 -960 -11z m1738 -698 l2 -453 -40 -40 c-22 -22 -40 -43 -40 -47 0 -4 36 -42 79 -85 88 -87 82 -87 141 -23 l26 27 455 -2 454 -3 0 -775 0 -775 -775 0 -775 0 -3 450 -2 449 47 48 47 48 -82 80 c-44 44 -84 80 -87 80 -3 0 -25 -18 -48 -40 l-41 -40 -456 2 -455 3 -3 765 c-1 421 0 771 3 778 3 10 164 12 777 10 l773 -3 3 -454z"/> <path d="M607 2492 c-42 -42 -77 -82 -77 -87 0 -6 86 -96 190 -200 105 -104 190 -197 190 -205 0 -8 -41 -56 -92 -107 -65 -65 -87 -94 -77 -98 8 -3 138 -4 289 -3 l275 3 3 275 c1 151 0 281 -3 289 -4 10 -35 -14 -103 -82 -54 -53 -103 -97 -109 -97 -7 0 -99 88 -206 195 -107 107 -196 195 -198 195 -3 0 -39 -35 -82 -78z"/> <path d="M1470 1639 c-47 -49 -87 -91 -89 -94 -5 -6 149 -165 160 -165 9 0 189 179 189 188 0 12 -154 162 -165 161 -6 0 -48 -41 -95 -90z"/> <path d="M1797 1303 c-9 -8 -9 -568 0 -576 4 -4 50 36 103 88 54 52 101 95 106 95 5 0 95 -85 199 -190 104 -104 194 -190 200 -190 6 0 46 36 90 80 l79 79 -197 196 c-108 108 -197 199 -197 203 0 4 45 52 99 106 55 55 98 103 95 108 -6 10 -568 11 -577 1z"/> </g> </svg>';
            },
            44563: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 42h4v-4h-4v4zm4-28h-4v4h4v-4zm-4 20h4v-4h-4v4zm8 8h4v-4h-4v4zm-4-36h-4v4h4v-4zm8 0h-4v4h4v-4zm16 0h-4v4h4v-4zm-8 8h-4v4h4v-4zm0-8h-4v4h4v-4zm12 28h4v-4h-4v4zm-16 8h4v-4h-4v4zm-16-16h36v-4h-36v4zm32-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-16 16h4v-4h-4v4zm8 8h4v-4h-4v4zm8 0h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg>';
            },
            53183: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 48 48"> <path d="M6 18h4v-4h-4v4zm0-8h4v-4h-4v4zm8 32h4v-4h-4v4zm0-16h4v-4h-4v4zm-8 0h4v-4h-4v4zm0 16h4v-4h-4v4zm0-8h4v-4h-4v4zm8-24h4v-4h-4v4zm24 24h4v-4h-4v4zm-16 8h4v-36h-4v36zm16 0h4v-4h-4v4zm0-16h4v-4h-4v4zm0-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-8-8h4v-4h-4v4zm0 32h4v-4h-4v4zm0-16h4v-4h-4v4z"/> <path d="M0 0h48v48h-48z" fill="none"/> </svg>';
            },
            18548: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm-1280-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z"/> </svg>';
            },
            52242: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z"/> </svg>';
            },
            87498: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z"/> </svg>';
            },
            7986: function(e) {
                e.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <path d="M5.09668 6.99707H7.17358L4.17358 3.99707L1.17358 6.99707H3.09668V17.0031H1.15881L4.15881 20.0031L7.15881 17.0031H5.09668V6.99707Z"/> <path d="M22.8412 7H8.84119V5H22.8412V7Z"/> <path d="M22.8412 11H8.84119V9H22.8412V11Z"/> <path d="M8.84119 15H22.8412V13H8.84119V15Z"/> <path d="M22.8412 19H8.84119V17H22.8412V19Z"/> </svg>';
            },
            23075: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"/> </svg>';
            },
            10655: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"/> </svg>';
            },
            15476: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
            },
            59403: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path stroke-width="0" d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"/> </svg>';
            },
            22860: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"/> </svg>';
            },
            95600: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 14 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"/> </svg>';
            },
            76214: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"/> </svg>';
            },
            41197: function(e) {
                e.exports = '<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg"> <path clip-rule="evenodd" d="M306.39,154.09c19.628,4.543,35.244,21.259,39.787,39.523 c1.551,8.54,8.998,14.989,17.904,14.989c9.991,0,18.168-8.175,18.168-18.17c0-13.083-10.991-32.98-25.985-47.881 c-14.719-14.537-32.252-24.802-46.695-24.802c-9.991,0-18.172,8.45-18.172,18.446C291.396,145.094,297.847,152.546,306.39,154.09z M56.629,392.312c-14.09,14.08-14.09,36.979,0,51.059c14.08,14.092,36.981,14.092,50.965,0l104.392-104.303 c24.347,15.181,53.062,23.991,83.953,23.991c87.857,0,158.995-71.142,158.995-158.999c0-87.854-71.138-158.995-158.995-158.995 c-87.856,0-158.995,71.141-158.995,158.995c0,30.802,8.819,59.606,23.992,83.953L56.629,392.312z M182.371,204.06 c0-62.687,50.875-113.568,113.568-113.568s113.569,50.881,113.569,113.568c0,62.694-50.876,113.569-113.569,113.569 S182.371,266.754,182.371,204.06z" fill-rule="evenodd"/> </svg>';
            },
            9342: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"/> </svg>';
            },
            69546: function(e) {
                e.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path d="M24.89 32h4.18L18.86 6h-3.71L4.93 32h4.18l2.25-6h11.29l2.24 6zM12.86 22L17 10.95 21.14 22h-8.28zm30.31 1.17L27 39.34 19.66 32l-2.83 2.83L27 45l19-19-2.83-2.83z"/> </svg>';
            },
            43158: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 270 270"> <path d="m240.443652,220.45085l-47.410809,0l0,-10.342138c13.89973,-8.43655 25.752896,-19.844464 34.686646,-33.469923c11.445525,-17.455846 17.496072,-37.709239 17.496072,-58.570077c0,-59.589197 -49.208516,-108.068714 -109.693558,-108.068714s-109.69263,48.479517 -109.69263,108.069628c0,20.860839 6.050547,41.113316 17.497001,58.570077c8.93375,13.625459 20.787845,25.032458 34.686646,33.469008l0,10.342138l-47.412666,0c-10.256959,0 -18.571354,8.191376 -18.571354,18.296574c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.98402,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574l0,-39.496814c0,-7.073455 -4.137698,-13.51202 -10.626529,-16.537358c-25.24497,-11.772016 -41.557118,-37.145704 -41.557118,-64.643625c0,-39.411735 32.545369,-71.476481 72.549922,-71.476481c40.004553,0 72.550851,32.064746 72.550851,71.476481c0,27.497006 -16.312149,52.87161 -41.557118,64.643625c-6.487902,3.026253 -10.6256,9.464818 -10.6256,16.537358l0,39.496814c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.982163,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574c0,-10.105198 -8.314395,-18.296574 -18.571354,-18.296574z"/> </svg>';
            },
            51716: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"/> </svg>';
            },
            49222: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"/> </svg>';
            },
            1755: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg>';
            },
            74911: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"/> </svg>';
            },
            8805: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg>';
            },
            16547: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"/> </svg>';
            },
            10856: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/> </svg>';
            },
            98441: function(e) {
                e.exports = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg"> <g stroke="none" stroke-width="1"> <path d="M14,1.4 L12.6,0 L7,5.6 L1.4,0 L0,1.4 L5.6,7 L0,12.6 L1.4,14 L7,8.4 L12.6,14 L14,12.6 L8.4,7 L14,1.4 Z"/> </g> </svg>';
            },
            52488: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"/> </svg>';
            },
            9370: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"/> </svg>';
            },
            66543: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 10 10"> <path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/> </svg>';
            },
            608: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 24 24" > <circle cx="12" cy="12" r="2.2"/> <circle cx="12" cy="5" r="2.2"/> <circle cx="12" cy="19" r="2.2"/> </svg>';
            },
            42840: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"/> </svg>';
            },
            79096: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 512v-472q22 14 36 28l408 408q14 14 28 36h-472zm-128 32q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z"/> </svg>';
            },
            33014: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"/> </svg>';
            },
            91677: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"/> </svg>';
            },
            8259: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg>';
            },
            64467: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"/></svg>';
            },
            86934: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 32 32"> <path d="M27 4l-15 15-7-7-5 5 12 12 20-20z"/> </svg>';
            },
            76133: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"/></svg>';
            },
            45519: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"><path d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"/></svg>';
            },
            90265: function(e) {
                e.exports = '<svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg"> <path d="M5.9814 11.8049C5.59087 11.4144 5.59087 10.7812 5.9814 10.3907L10.224 6.14806C10.6146 5.75754 11.2477 5.75754 11.6383 6.14806C12.0288 6.53859 12.0288 7.17175 11.6383 7.56228L7.39561 11.8049C7.00509 12.1954 6.37192 12.1954 5.9814 11.8049Z"/> <path d="M0.707107 12.0208C0.316582 11.6303 0.316582 10.9971 0.707107 10.6066L10.6066 0.707121C10.9971 0.316597 11.6303 0.316596 12.0208 0.707121C12.4113 1.09764 12.4113 1.73081 12.0208 2.12133L2.12132 12.0208C1.7308 12.4114 1.09763 12.4114 0.707107 12.0208Z"/> </svg>';
            },
            81279: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"/> </svg>';
            },
            68899: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"/> </svg>';
            },
            70744: function(e) {
                e.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"> <path stroke="null" d="m42.276011,26.302547c0.098397,-0.76605 0.172194,-1.54407 0.172194,-2.33406s-0.073797,-1.56801 -0.172194,-2.33406l5.202718,-3.961917c0.467384,-0.359086 0.602679,-1.005441 0.29519,-1.532101l-4.919828,-8.29489c-0.307489,-0.51469 -0.947067,-0.730142 -1.500548,-0.51469l-6.125186,2.405877c-1.266856,-0.945594 -2.656707,-1.747553 -4.157255,-2.357999l-0.922468,-6.343855c-0.110696,-0.562568 -0.614979,-1.005441 -1.229957,-1.005441l-9.839656,0c-0.614979,0 -1.119261,0.442873 -1.217657,1.005441l-0.922468,6.343855c-1.500548,0.610446 -2.890399,1.400436 -4.157255,2.357999l-6.125186,-2.405877c-0.553481,-0.203482 -1.193058,0 -1.500548,0.51469l-4.919828,8.29489c-0.307489,0.51469 -0.172194,1.161045 0.29519,1.532101l5.190419,3.961917c-0.098397,0.76605 -0.172194,1.54407 -0.172194,2.33406s0.073797,1.56801 0.172194,2.33406l-5.190419,3.961917c-0.467384,0.359086 -0.602679,1.005441 -0.29519,1.532101l4.919828,8.29489c0.307489,0.51469 0.947067,0.730142 1.500548,0.51469l6.125186,-2.405877c1.266856,0.945594 2.656707,1.747553 4.157255,2.357999l0.922468,6.343855c0.098397,0.562568 0.602679,1.005441 1.217657,1.005441l9.839656,0c0.614979,0 1.119261,-0.442873 1.217657,-1.005441l0.922468,-6.343855c1.500548,-0.610446 2.890399,-1.400436 4.157255,-2.357999l6.125186,2.405877c0.553481,0.203482 1.193058,0 1.500548,-0.51469l4.919828,-8.29489c0.307489,-0.51469 0.172194,-1.161045 -0.29519,-1.532101l-5.190419,-3.961917zm-18.277162,6.044617c-4.759934,0 -8.609699,-3.746465 -8.609699,-8.378677s3.849766,-8.378677 8.609699,-8.378677s8.609699,3.746465 8.609699,8.378677s-3.849766,8.378677 -8.609699,8.378677z"/> </svg>';
            },
            19201: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"/> </svg>';
            },
            84930: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/> </svg>';
            },
            99704: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z"/> </svg>';
            },
            2304: function(e) {
                e.exports = '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 1792 1792"> <path d="M1216 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"/> </svg>';
            },
            93330: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            45066: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            99895: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            87682: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            50905: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            70446: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            18984: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            4591: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            64194: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            70375: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            90235: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            88477: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            50197: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            39008: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            47086: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            16462: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            40692: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            27452: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            51422: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            62820: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            63421: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            32115: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            53362: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            48904: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            85796: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            28654: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            60819: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            96410: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            33126: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            30724: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            14320: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            9947: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            45109: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            71708: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            51629: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            54860: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            47818: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            6316: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            88582: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            30962: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            68197: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            60057: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            33393: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            51057: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            64618: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            90176: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            91147: function(e, t, o) {
                "use strict";
                o.r(t);
            },
            70631: function(e, t) {
                "use strict";
                function o(e) {
                    return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, o(e);
                }
                function n(e, t, n) {
                    var r = n.value;
                    if ("function" != typeof r) throw new TypeError("@boundMethod decorator can only be applied to methods not: ".concat(o(r)));
                    var i = !1;
                    return {
                        configurable: !0,
                        get: function() {
                            if (i || this === e.prototype || this.hasOwnProperty(t) || "function" != typeof r) return r;
                            var o = r.bind(this);
                            return i = !0, Object.defineProperty(this, t, {
                                configurable: !0,
                                get: function() {
                                    return o;
                                },
                                set: function(e) {
                                    r = e, delete this[t];
                                }
                            }), i = !1, o;
                        },
                        set: function(e) {
                            r = e;
                        }
                    };
                }
                function r(e) {
                    var t;
                    return "undefined" != typeof Reflect && "function" == typeof Reflect.ownKeys ? t = Reflect.ownKeys(e.prototype) : (t = Object.getOwnPropertyNames(e.prototype), "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(e.prototype)))), t.forEach(function(t) {
                        if ("constructor" !== t) {
                            var o = Object.getOwnPropertyDescriptor(e.prototype, t);
                            "function" == typeof o.value && Object.defineProperty(e.prototype, t, n(e, t, o));
                        }
                    }), e;
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.boundClass = t.boundMethod = void 0, t.boundMethod = n, t.boundClass = r, t.default = function() {
                    return 1 === arguments.length ? r.apply(void 0, arguments) : n.apply(void 0, arguments);
                };
            },
            61227: function() {
                "use strict";
                "document" in window.self && ((!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) && function(e) {
                    if ("Element" in e) {
                        var t = "classList", o = e.Element.prototype, n = Object, r = String.prototype.trim || function() {
                            return this.replace(/^\s+|\s+$/g, "");
                        }, i = Array.prototype.indexOf || function(e) {
                            for(var t = 0, o = this.length; o > t; t++)if (t in this && this[t] === e) return t;
                            return -1;
                        }, a = function(e, t) {
                            this.name = e, this.code = DOMException[e], this.message = t;
                        }, s = function(e, t) {
                            if ("" === t) throw new a("SYNTAX_ERR", "An invalid or illegal string was specified");
                            if (/\s/.test(t)) throw new a("INVALID_CHARACTER_ERR", "String contains an invalid character");
                            return i.call(e, t);
                        }, l = function(e) {
                            for(var t = r.call(e.getAttribute("class") || ""), o = t ? t.split(/\s+/) : [], n = 0, i = o.length; i > n; n++)this.push(o[n]);
                            this._updateClassName = function() {
                                e.setAttribute("class", this.toString());
                            };
                        }, c = l.prototype = [], u = function() {
                            return new l(this);
                        };
                        if (a.prototype = Error.prototype, c.item = function(e) {
                            return this[e] || null;
                        }, c.contains = function(e) {
                            return -1 !== s(this, e += "");
                        }, c.add = function() {
                            var e, t = arguments, o = 0, n = t.length, r = !1;
                            do -1 === s(this, e = t[o] + "") && (this.push(e), r = !0);
                            while (++o < n);
                            r && this._updateClassName();
                        }, c.remove = function() {
                            var e, t, o = arguments, n = 0, r = o.length, i = !1;
                            do for(t = s(this, e = o[n] + ""); -1 !== t;)this.splice(t, 1), i = !0, t = s(this, e);
                            while (++n < r);
                            i && this._updateClassName();
                        }, c.toggle = function(e, t) {
                            var o = this.contains(e += ""), n = o ? !0 !== t && "remove" : !1 !== t && "add";
                            return n && this[n](e), !0 === t || !1 === t ? t : !o;
                        }, c.toString = function() {
                            return this.join(" ");
                        }, n.defineProperty) {
                            var d = {
                                get: u,
                                enumerable: !0,
                                configurable: !0
                            };
                            try {
                                n.defineProperty(o, t, d);
                            } catch (e) {
                                void 0 !== e.number && -2146823252 !== e.number || (d.enumerable = !1, n.defineProperty(o, t, d));
                            }
                        } else n.prototype.__defineGetter__ && o.__defineGetter__(t, u);
                    }
                }(window.self), function() {
                    var e = document.createElement("_");
                    if (e.classList.add("c1", "c2"), !e.classList.contains("c2")) {
                        var t = function(e) {
                            var t = DOMTokenList.prototype[e];
                            DOMTokenList.prototype[e] = function(e) {
                                var o, n = arguments.length;
                                for(o = 0; n > o; o++)t.call(this, e = arguments[o]);
                            };
                        };
                        t("add"), t("remove");
                    }
                    if (e.classList.toggle("c3", !1), e.classList.contains("c3")) {
                        var o = DOMTokenList.prototype.toggle;
                        DOMTokenList.prototype.toggle = function(e, t) {
                            return 1 in arguments && !this.contains(e) == !t ? t : o.call(this, e);
                        };
                    }
                    e = null;
                }());
            },
            69220: function(e, t, o) {
                "use strict";
                o(22513);
                var n = o(56599);
                e.exports = n("Array", "findIndex");
            },
            10444: function(e, t, o) {
                "use strict";
                o(52867), o(70057);
                var n = o(31116);
                e.exports = n.Array.from;
            },
            66622: function(e, t, o) {
                "use strict";
                o(54166), o(32044), o(95661), o(28424), o(64514), o(30733), o(40327), o(53639), o(6147), o(7290), o(95122), o(61322), o(39605), o(49341), o(28809), o(82658), o(43967), o(90217), o(73477), o(93697);
                var n = o(31116);
                e.exports = n.Symbol;
            },
            98061: function(e, t, o) {
                "use strict";
                var n = o(794), r = o(98418), i = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw i(r(e) + " is not a function");
                };
            },
            75839: function(e, t, o) {
                "use strict";
                var n = o(794), r = String, i = TypeError;
                e.exports = function(e) {
                    if ("object" == typeof e || n(e)) return e;
                    throw i("Can't set " + r(e) + " as a prototype");
                };
            },
            15179: function(e, t, o) {
                "use strict";
                var n = o(19517), r = o(93503), i = o(73252).f, a = n("unscopables"), s = Array.prototype;
                null == s[a] && i(s, a, {
                    configurable: !0,
                    value: r(null)
                }), e.exports = function(e) {
                    s[a][e] = !0;
                };
            },
            52313: function(e, t, o) {
                "use strict";
                var n = o(8148), r = String, i = TypeError;
                e.exports = function(e) {
                    if (n(e)) return e;
                    throw i(r(e) + " is not an object");
                };
            },
            92707: function(e, t, o) {
                "use strict";
                var n = o(40207), r = o(9093), i = o(68488), a = o(79665), s = o(84997), l = o(15333), c = o(15050), u = o(89476), d = o(27395), p = o(81058), f = Array;
                e.exports = function(e) {
                    var t = i(e), o = l(this), h = arguments.length, m = h > 1 ? arguments[1] : void 0, v = void 0 !== m;
                    v && (m = n(m, h > 2 ? arguments[2] : void 0));
                    var g, y, _, b, w, S, C = p(t), j = 0;
                    if (!C || this === f && s(C)) for(g = c(t), y = o ? new this(g) : f(g); g > j; j++)S = v ? m(t[j], j) : t[j], u(y, j, S);
                    else for(w = (b = d(t, C)).next, y = o ? new this : []; !(_ = r(w, b)).done; j++)S = v ? a(b, m, [
                        _.value,
                        j
                    ], !0) : _.value, u(y, j, S);
                    return y.length = j, y;
                };
            },
            79327: function(e, t, o) {
                "use strict";
                var n = o(98651), r = o(10586), i = o(15050), a = function(e) {
                    return function(t, o, a) {
                        var s, l = n(t), c = i(l), u = r(a, c);
                        if (e && o != o) {
                            for(; c > u;)if ((s = l[u++]) != s) return !0;
                        } else for(; c > u; u++)if ((e || u in l) && l[u] === o) return e || u || 0;
                        return !e && -1;
                    };
                };
                e.exports = {
                    includes: a(!0),
                    indexOf: a(!1)
                };
            },
            56881: function(e, t, o) {
                "use strict";
                var n = o(40207), r = o(90838), i = o(25049), a = o(68488), s = o(15050), l = o(6429), c = r([].push), u = function(e) {
                    var t = 1 == e, o = 2 == e, r = 3 == e, u = 4 == e, d = 6 == e, p = 7 == e, f = 5 == e || d;
                    return function(h, m, v, g) {
                        for(var y, _, b = a(h), w = i(b), S = n(m, v), C = s(w), j = 0, E = g || l, x = t ? E(h, C) : o || p ? E(h, 0) : void 0; C > j; j++)if ((f || j in w) && (_ = S(y = w[j], j, b), e)) {
                            if (t) x[j] = _;
                            else if (_) switch(e){
                                case 3:
                                    return !0;
                                case 5:
                                    return y;
                                case 6:
                                    return j;
                                case 2:
                                    c(x, y);
                            }
                            else switch(e){
                                case 4:
                                    return !1;
                                case 7:
                                    c(x, y);
                            }
                        }
                        return d ? -1 : r || u ? u : x;
                    };
                };
                e.exports = {
                    forEach: u(0),
                    map: u(1),
                    filter: u(2),
                    some: u(3),
                    every: u(4),
                    find: u(5),
                    findIndex: u(6),
                    filterReject: u(7)
                };
            },
            63833: function(e, t, o) {
                "use strict";
                var n = o(75834), r = o(19517), i = o(65190), a = r("species");
                e.exports = function(e) {
                    return i >= 51 || !n(function() {
                        var t = [];
                        return (t.constructor = {})[a] = function() {
                            return {
                                foo: 1
                            };
                        }, 1 !== t[e](Boolean).foo;
                    });
                };
            },
            57652: function(e, t, o) {
                "use strict";
                var n = o(10586), r = o(15050), i = o(89476), a = Array, s = Math.max;
                e.exports = function(e, t, o) {
                    for(var l = r(e), c = n(t, l), u = n(void 0 === o ? l : o, l), d = a(s(u - c, 0)), p = 0; u > c; c++, p++)i(d, p, e[c]);
                    return d.length = p, d;
                };
            },
            54832: function(e, t, o) {
                "use strict";
                var n = o(90838);
                e.exports = n([].slice);
            },
            22506: function(e, t, o) {
                "use strict";
                var n = o(36222), r = o(15333), i = o(8148), a = o(19517)("species"), s = Array;
                e.exports = function(e) {
                    var t;
                    return n(e) && (r(t = e.constructor) && (t === s || n(t.prototype)) || i(t) && null === (t = t[a])) && (t = void 0), void 0 === t ? s : t;
                };
            },
            6429: function(e, t, o) {
                "use strict";
                var n = o(22506);
                e.exports = function(e, t) {
                    return new (n(e))(0 === t ? 0 : t);
                };
            },
            79665: function(e, t, o) {
                "use strict";
                var n = o(52313), r = o(11274);
                e.exports = function(e, t, o, i) {
                    try {
                        return i ? t(n(o)[0], o[1]) : t(o);
                    } catch (t) {
                        r(e, "throw", t);
                    }
                };
            },
            7581: function(e, t, o) {
                "use strict";
                var n = o(19517)("iterator"), r = !1;
                try {
                    var i = 0, a = {
                        next: function() {
                            return {
                                done: !!i++
                            };
                        },
                        return: function() {
                            r = !0;
                        }
                    };
                    a[n] = function() {
                        return this;
                    }, Array.from(a, function() {
                        throw 2;
                    });
                } catch (e) {}
                e.exports = function(e, t) {
                    if (!t && !r) return !1;
                    var o = !1;
                    try {
                        var i = {};
                        i[n] = function() {
                            return {
                                next: function() {
                                    return {
                                        done: o = !0
                                    };
                                }
                            };
                        }, e(i);
                    } catch (e) {}
                    return o;
                };
            },
            6285: function(e, t, o) {
                "use strict";
                var n = o(90838), r = n({}.toString), i = n("".slice);
                e.exports = function(e) {
                    return i(r(e), 8, -1);
                };
            },
            8652: function(e, t, o) {
                "use strict";
                var n = o(6424), r = o(794), i = o(6285), a = o(19517)("toStringTag"), s = Object, l = "Arguments" == i(function() {
                    return arguments;
                }());
                e.exports = n ? i : function(e) {
                    var t, o, n;
                    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (o = function(e, t) {
                        try {
                            return e[t];
                        } catch (e) {}
                    }(t = s(e), a)) ? o : l ? i(t) : "Object" == (n = i(t)) && r(t.callee) ? "Arguments" : n;
                };
            },
            58392: function(e, t, o) {
                "use strict";
                var n = o(14434), r = o(86671), i = o(36999), a = o(73252);
                e.exports = function(e, t, o) {
                    for(var s = r(t), l = a.f, c = i.f, u = 0; s.length > u; u++){
                        var d = s[u];
                        n(e, d) || o && n(o, d) || l(e, d, c(t, d));
                    }
                };
            },
            27259: function(e, t, o) {
                "use strict";
                var n = o(75834);
                e.exports = !n(function() {
                    function e() {}
                    return e.prototype.constructor = null, Object.getPrototypeOf(new e) !== e.prototype;
                });
            },
            17427: function(e) {
                "use strict";
                e.exports = function(e, t) {
                    return {
                        value: e,
                        done: t
                    };
                };
            },
            45840: function(e, t, o) {
                "use strict";
                var n = o(13873), r = o(73252), i = o(32500);
                e.exports = n ? function(e, t, o) {
                    return r.f(e, t, i(1, o));
                } : function(e, t, o) {
                    return e[t] = o, e;
                };
            },
            32500: function(e) {
                "use strict";
                e.exports = function(e, t) {
                    return {
                        enumerable: !(1 & e),
                        configurable: !(2 & e),
                        writable: !(4 & e),
                        value: t
                    };
                };
            },
            89476: function(e, t, o) {
                "use strict";
                var n = o(43836), r = o(73252), i = o(32500);
                e.exports = function(e, t, o) {
                    var a = n(t);
                    a in e ? r.f(e, a, i(0, o)) : e[a] = o;
                };
            },
            97548: function(e, t, o) {
                "use strict";
                var n = o(40846), r = o(73252);
                e.exports = function(e, t, o) {
                    return o.get && n(o.get, t, {
                        getter: !0
                    }), o.set && n(o.set, t, {
                        setter: !0
                    }), r.f(e, t, o);
                };
            },
            35065: function(e, t, o) {
                "use strict";
                var n = o(794), r = o(73252), i = o(40846), a = o(25379);
                e.exports = function(e, t, o, s) {
                    s || (s = {});
                    var l = s.enumerable, c = void 0 !== s.name ? s.name : t;
                    if (n(o) && i(o, c, s), s.global) l ? e[t] = o : a(t, o);
                    else {
                        try {
                            s.unsafe ? e[t] && (l = !0) : delete e[t];
                        } catch (e) {}
                        l ? e[t] = o : r.f(e, t, {
                            value: o,
                            enumerable: !1,
                            configurable: !s.nonConfigurable,
                            writable: !s.nonWritable
                        });
                    }
                    return e;
                };
            },
            25379: function(e, t, o) {
                "use strict";
                var n = o(37042), r = Object.defineProperty;
                e.exports = function(e, t) {
                    try {
                        r(n, e, {
                            value: t,
                            configurable: !0,
                            writable: !0
                        });
                    } catch (o) {
                        n[e] = t;
                    }
                    return t;
                };
            },
            13873: function(e, t, o) {
                "use strict";
                var n = o(75834);
                e.exports = !n(function() {
                    return 7 != Object.defineProperty({}, 1, {
                        get: function() {
                            return 7;
                        }
                    })[1];
                });
            },
            12062: function(e) {
                "use strict";
                var t = "object" == typeof document && document.all;
                e.exports = {
                    all: t,
                    IS_HTMLDDA: void 0 === t && void 0 !== t
                };
            },
            15192: function(e, t, o) {
                "use strict";
                var n = o(37042), r = o(8148), i = n.document, a = r(i) && r(i.createElement);
                e.exports = function(e) {
                    return a ? i.createElement(e) : {};
                };
            },
            39505: function(e) {
                "use strict";
                var t = TypeError;
                e.exports = function(e) {
                    if (e > 9007199254740991) throw t("Maximum allowed index exceeded");
                    return e;
                };
            },
            21473: function(e) {
                "use strict";
                e.exports = "undefined" != typeof navigator && String(navigator.userAgent) || "";
            },
            65190: function(e, t, o) {
                "use strict";
                var n, r, i = o(37042), a = o(21473), s = i.process, l = i.Deno, c = s && s.versions || l && l.version, u = c && c.v8;
                u && (r = (n = u.split("."))[0] > 0 && 4 > n[0] ? 1 : +(n[0] + n[1])), !r && a && ((n = a.match(/Edge\/(\d+)/)) && 74 > n[1] || (n = a.match(/Chrome\/(\d+)/)) && (r = +n[1])), e.exports = r;
            },
            56599: function(e, t, o) {
                "use strict";
                var n = o(37042), r = o(90838);
                e.exports = function(e, t) {
                    return r(n[e].prototype[t]);
                };
            },
            64456: function(e) {
                "use strict";
                e.exports = [
                    "constructor",
                    "hasOwnProperty",
                    "isPrototypeOf",
                    "propertyIsEnumerable",
                    "toLocaleString",
                    "toString",
                    "valueOf"
                ];
            },
            50791: function(e, t, o) {
                "use strict";
                var n = o(37042), r = o(36999).f, i = o(45840), a = o(35065), s = o(25379), l = o(58392), c = o(56930);
                e.exports = function(e, t) {
                    var o, u, d, p, f, h = e.target, m = e.global, v = e.stat;
                    if (o = m ? n : v ? n[h] || s(h, {}) : (n[h] || {}).prototype) for(u in t){
                        if (p = t[u], d = e.dontCallGetSet ? (f = r(o, u)) && f.value : o[u], !c(m ? u : h + (v ? "." : "#") + u, e.forced) && void 0 !== d) {
                            if (typeof p == typeof d) continue;
                            l(p, d);
                        }
                        (e.sham || d && d.sham) && i(p, "sham", !0), a(o, u, p, e);
                    }
                };
            },
            75834: function(e) {
                "use strict";
                e.exports = function(e) {
                    try {
                        return !!e();
                    } catch (e) {
                        return !0;
                    }
                };
            },
            55101: function(e, t, o) {
                "use strict";
                var n = o(32610), r = Function.prototype, i = r.apply, a = r.call;
                e.exports = "object" == typeof Reflect && Reflect.apply || (n ? a.bind(i) : function() {
                    return a.apply(i, arguments);
                });
            },
            40207: function(e, t, o) {
                "use strict";
                var n = o(75114), r = o(98061), i = o(32610), a = n(n.bind);
                e.exports = function(e, t) {
                    return r(e), void 0 === t ? e : i ? a(e, t) : function() {
                        return e.apply(t, arguments);
                    };
                };
            },
            32610: function(e, t, o) {
                "use strict";
                var n = o(75834);
                e.exports = !n(function() {
                    var e = (function() {}).bind();
                    return "function" != typeof e || e.hasOwnProperty("prototype");
                });
            },
            9093: function(e, t, o) {
                "use strict";
                var n = o(32610), r = Function.prototype.call;
                e.exports = n ? r.bind(r) : function() {
                    return r.apply(r, arguments);
                };
            },
            84521: function(e, t, o) {
                "use strict";
                var n = o(13873), r = o(14434), i = Function.prototype, a = n && Object.getOwnPropertyDescriptor, s = r(i, "name"), l = s && "something" === (function() {}).name, c = s && (!n || n && a(i, "name").configurable);
                e.exports = {
                    EXISTS: s,
                    PROPER: l,
                    CONFIGURABLE: c
                };
            },
            47448: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(98061);
                e.exports = function(e, t, o) {
                    try {
                        return n(r(Object.getOwnPropertyDescriptor(e, t)[o]));
                    } catch (e) {}
                };
            },
            75114: function(e, t, o) {
                "use strict";
                var n = o(6285), r = o(90838);
                e.exports = function(e) {
                    if ("Function" === n(e)) return r(e);
                };
            },
            90838: function(e, t, o) {
                "use strict";
                var n = o(32610), r = Function.prototype, i = r.call, a = n && r.bind.bind(i, i);
                e.exports = n ? a : function(e) {
                    return function() {
                        return i.apply(e, arguments);
                    };
                };
            },
            98945: function(e, t, o) {
                "use strict";
                var n = o(37042), r = o(794), i = function(e) {
                    return r(e) ? e : void 0;
                };
                e.exports = function(e, t) {
                    return 2 > arguments.length ? i(n[e]) : n[e] && n[e][t];
                };
            },
            81058: function(e, t, o) {
                "use strict";
                var n = o(8652), r = o(20156), i = o(8140), a = o(84922), s = o(19517)("iterator");
                e.exports = function(e) {
                    if (!i(e)) return r(e, s) || r(e, "@@iterator") || a[n(e)];
                };
            },
            27395: function(e, t, o) {
                "use strict";
                var n = o(9093), r = o(98061), i = o(52313), a = o(98418), s = o(81058), l = TypeError;
                e.exports = function(e, t) {
                    var o = 2 > arguments.length ? s(e) : t;
                    if (r(o)) return i(n(o, e));
                    throw l(a(e) + " is not iterable");
                };
            },
            6693: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(36222), i = o(794), a = o(6285), s = o(63046), l = n([].push);
                e.exports = function(e) {
                    if (i(e)) return e;
                    if (r(e)) {
                        for(var t = e.length, o = [], n = 0; t > n; n++){
                            var c = e[n];
                            "string" == typeof c ? l(o, c) : "number" != typeof c && "Number" != a(c) && "String" != a(c) || l(o, s(c));
                        }
                        var u = o.length, d = !0;
                        return function(e, t) {
                            if (d) return d = !1, t;
                            if (r(this)) return t;
                            for(var n = 0; u > n; n++)if (o[n] === e) return t;
                        };
                    }
                };
            },
            20156: function(e, t, o) {
                "use strict";
                var n = o(98061), r = o(8140);
                e.exports = function(e, t) {
                    var o = e[t];
                    return r(o) ? void 0 : n(o);
                };
            },
            37042: function(e, t, o) {
                "use strict";
                var n = function(e) {
                    return e && e.Math == Math && e;
                };
                e.exports = n("object" == typeof globalThis && globalThis) || n("object" == typeof window && window) || n("object" == typeof self && self) || n("object" == typeof o.g && o.g) || function() {
                    return this;
                }() || Function("return this")();
            },
            14434: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(68488), i = n({}.hasOwnProperty);
                e.exports = Object.hasOwn || function(e, t) {
                    return i(r(e), t);
                };
            },
            48889: function(e) {
                "use strict";
                e.exports = {};
            },
            36249: function(e, t, o) {
                "use strict";
                var n = o(98945);
                e.exports = n("document", "documentElement");
            },
            12816: function(e, t, o) {
                "use strict";
                var n = o(13873), r = o(75834), i = o(15192);
                e.exports = !n && !r(function() {
                    return 7 != Object.defineProperty(i("div"), "a", {
                        get: function() {
                            return 7;
                        }
                    }).a;
                });
            },
            25049: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(75834), i = o(6285), a = Object, s = n("".split);
                e.exports = r(function() {
                    return !a("z").propertyIsEnumerable(0);
                }) ? function(e) {
                    return "String" == i(e) ? s(e, "") : a(e);
                } : a;
            },
            92355: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(794), i = o(45752), a = n(Function.toString);
                r(i.inspectSource) || (i.inspectSource = function(e) {
                    return a(e);
                }), e.exports = i.inspectSource;
            },
            56113: function(e, t, o) {
                "use strict";
                var n, r, i, a = o(95473), s = o(37042), l = o(8148), c = o(45840), u = o(14434), d = o(45752), p = o(85475), f = o(48889), h = "Object already initialized", m = s.TypeError;
                if (a || d.state) {
                    var v = d.state || (d.state = new s.WeakMap);
                    v.get = v.get, v.has = v.has, v.set = v.set, n = function(e, t) {
                        if (v.has(e)) throw m(h);
                        return t.facade = e, v.set(e, t), t;
                    }, r = function(e) {
                        return v.get(e) || {};
                    }, i = function(e) {
                        return v.has(e);
                    };
                } else {
                    var g = p("state");
                    f[g] = !0, n = function(e, t) {
                        if (u(e, g)) throw m(h);
                        return t.facade = e, c(e, g, t), t;
                    }, r = function(e) {
                        return u(e, g) ? e[g] : {};
                    }, i = function(e) {
                        return u(e, g);
                    };
                }
                e.exports = {
                    set: n,
                    get: r,
                    has: i,
                    enforce: function(e) {
                        return i(e) ? r(e) : n(e, {});
                    },
                    getterFor: function(e) {
                        return function(t) {
                            var o;
                            if (!l(t) || (o = r(t)).type !== e) throw m("Incompatible receiver, " + e + " required");
                            return o;
                        };
                    }
                };
            },
            84997: function(e, t, o) {
                "use strict";
                var n = o(19517), r = o(84922), i = n("iterator"), a = Array.prototype;
                e.exports = function(e) {
                    return void 0 !== e && (r.Array === e || a[i] === e);
                };
            },
            36222: function(e, t, o) {
                "use strict";
                var n = o(6285);
                e.exports = Array.isArray || function(e) {
                    return "Array" == n(e);
                };
            },
            794: function(e, t, o) {
                "use strict";
                var n = o(12062), r = n.all;
                e.exports = n.IS_HTMLDDA ? function(e) {
                    return "function" == typeof e || e === r;
                } : function(e) {
                    return "function" == typeof e;
                };
            },
            15333: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(75834), i = o(794), a = o(8652), s = o(98945), l = o(92355), c = function() {}, u = [], d = s("Reflect", "construct"), p = /^\s*(?:class|function)\b/, f = n(p.exec), h = !p.exec(c), m = function(e) {
                    if (!i(e)) return !1;
                    try {
                        return d(c, u, e), !0;
                    } catch (e) {
                        return !1;
                    }
                }, v = function(e) {
                    if (!i(e)) return !1;
                    switch(a(e)){
                        case "AsyncFunction":
                        case "GeneratorFunction":
                        case "AsyncGeneratorFunction":
                            return !1;
                    }
                    try {
                        return h || !!f(p, l(e));
                    } catch (e) {
                        return !0;
                    }
                };
                v.sham = !0, e.exports = !d || r(function() {
                    var e;
                    return m(m.call) || !m(Object) || !m(function() {
                        e = !0;
                    }) || e;
                }) ? v : m;
            },
            56930: function(e, t, o) {
                "use strict";
                var n = o(75834), r = o(794), i = /#|\.prototype\./, a = function(e, t) {
                    var o = l[s(e)];
                    return o == u || o != c && (r(t) ? n(t) : !!t);
                }, s = a.normalize = function(e) {
                    return String(e).replace(i, ".").toLowerCase();
                }, l = a.data = {}, c = a.NATIVE = "N", u = a.POLYFILL = "P";
                e.exports = a;
            },
            8140: function(e) {
                "use strict";
                e.exports = function(e) {
                    return null == e;
                };
            },
            8148: function(e, t, o) {
                "use strict";
                var n = o(794), r = o(12062), i = r.all;
                e.exports = r.IS_HTMLDDA ? function(e) {
                    return "object" == typeof e ? null !== e : n(e) || e === i;
                } : function(e) {
                    return "object" == typeof e ? null !== e : n(e);
                };
            },
            70852: function(e) {
                "use strict";
                e.exports = !1;
            },
            88253: function(e, t, o) {
                "use strict";
                var n = o(98945), r = o(794), i = o(54671), a = o(57982), s = Object;
                e.exports = a ? function(e) {
                    return "symbol" == typeof e;
                } : function(e) {
                    var t = n("Symbol");
                    return r(t) && i(t.prototype, s(e));
                };
            },
            11274: function(e, t, o) {
                "use strict";
                var n = o(9093), r = o(52313), i = o(20156);
                e.exports = function(e, t, o) {
                    var a, s;
                    r(e);
                    try {
                        if (!(a = i(e, "return"))) {
                            if ("throw" === t) throw o;
                            return o;
                        }
                        a = n(a, e);
                    } catch (e) {
                        s = !0, a = e;
                    }
                    if ("throw" === t) throw o;
                    if (s) throw a;
                    return r(a), o;
                };
            },
            60928: function(e, t, o) {
                "use strict";
                var n = o(77831).IteratorPrototype, r = o(93503), i = o(32500), a = o(44532), s = o(84922), l = function() {
                    return this;
                };
                e.exports = function(e, t, o, c) {
                    var u = t + " Iterator";
                    return e.prototype = r(n, {
                        next: i(+!c, o)
                    }), a(e, u, !1, !0), s[u] = l, e;
                };
            },
            13759: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(9093), i = o(70852), a = o(84521), s = o(794), l = o(60928), c = o(1074), u = o(482), d = o(44532), p = o(45840), f = o(35065), h = o(19517), m = o(84922), v = o(77831), g = a.PROPER, y = a.CONFIGURABLE, _ = v.IteratorPrototype, b = v.BUGGY_SAFARI_ITERATORS, w = h("iterator"), S = "keys", C = "values", j = "entries", E = function() {
                    return this;
                };
                e.exports = function(e, t, o, a, h, v, x) {
                    l(o, t, a);
                    var k, T, I, P = function(e) {
                        if (e === h && A) return A;
                        if (!b && e in O) return O[e];
                        switch(e){
                            case S:
                            case C:
                            case j:
                                return function() {
                                    return new o(this, e);
                                };
                        }
                        return function() {
                            return new o(this);
                        };
                    }, M = t + " Iterator", D = !1, O = e.prototype, z = O[w] || O["@@iterator"] || h && O[h], A = !b && z || P(h), L = "Array" == t && O.entries || z;
                    if (L && (k = c(L.call(new e))) !== Object.prototype && k.next && (i || c(k) === _ || (u ? u(k, _) : s(k[w]) || f(k, w, E)), d(k, M, !0, !0), i && (m[M] = E)), g && h == C && z && z.name !== C && (!i && y ? p(O, "name", C) : (D = !0, A = function() {
                        return r(z, this);
                    })), h) {
                        if (T = {
                            values: P(C),
                            keys: v ? A : P(S),
                            entries: P(j)
                        }, x) for(I in T)(b || D || !(I in O)) && f(O, I, T[I]);
                        else n({
                            target: t,
                            proto: !0,
                            forced: b || D
                        }, T);
                    }
                    return i && !x || O[w] === A || f(O, w, A, {
                        name: h
                    }), m[t] = A, T;
                };
            },
            77831: function(e, t, o) {
                "use strict";
                var n, r, i, a = o(75834), s = o(794), l = o(8148), c = o(93503), u = o(1074), d = o(35065), p = o(19517), f = o(70852), h = p("iterator"), m = !1;
                [].keys && ("next" in (i = [].keys()) ? (r = u(u(i))) !== Object.prototype && (n = r) : m = !0), !l(n) || a(function() {
                    var e = {};
                    return n[h].call(e) !== e;
                }) ? n = {} : f && (n = c(n)), s(n[h]) || d(n, h, function() {
                    return this;
                }), e.exports = {
                    IteratorPrototype: n,
                    BUGGY_SAFARI_ITERATORS: m
                };
            },
            84922: function(e) {
                "use strict";
                e.exports = {};
            },
            15050: function(e, t, o) {
                "use strict";
                var n = o(24431);
                e.exports = function(e) {
                    return n(e.length);
                };
            },
            40846: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(75834), i = o(794), a = o(14434), s = o(13873), l = o(84521).CONFIGURABLE, c = o(92355), u = o(56113), d = u.enforce, p = u.get, f = String, h = Object.defineProperty, m = n("".slice), v = n("".replace), g = n([].join), y = s && !r(function() {
                    return 8 !== h(function() {}, "length", {
                        value: 8
                    }).length;
                }), _ = String(String).split("String"), b = e.exports = function(e, t, o) {
                    "Symbol(" === m(f(t), 0, 7) && (t = "[" + v(f(t), /^Symbol\(([^)]*)\)/, "$1") + "]"), o && o.getter && (t = "get " + t), o && o.setter && (t = "set " + t), (!a(e, "name") || l && e.name !== t) && (s ? h(e, "name", {
                        value: t,
                        configurable: !0
                    }) : e.name = t), y && o && a(o, "arity") && e.length !== o.arity && h(e, "length", {
                        value: o.arity
                    });
                    try {
                        o && a(o, "constructor") && o.constructor ? s && h(e, "prototype", {
                            writable: !1
                        }) : e.prototype && (e.prototype = void 0);
                    } catch (e) {}
                    var n = d(e);
                    return a(n, "source") || (n.source = g(_, "string" == typeof t ? t : "")), e;
                };
                Function.prototype.toString = b(function() {
                    return i(this) && p(this).source || c(this);
                }, "toString");
            },
            43932: function(e) {
                "use strict";
                var t = Math.ceil, o = Math.floor;
                e.exports = Math.trunc || function(e) {
                    var n = +e;
                    return (n > 0 ? o : t)(n);
                };
            },
            93503: function(e, t, o) {
                "use strict";
                var n, r = o(52313), i = o(5770), a = o(64456), s = o(48889), l = o(36249), c = o(15192), u = o(85475)("IE_PROTO"), d = function() {}, p = function(e) {
                    return "<script>" + e + "<\/script>";
                }, f = function(e) {
                    e.write(p("")), e.close();
                    var t = e.parentWindow.Object;
                    return e = null, t;
                }, h = function() {
                    try {
                        n = new ActiveXObject("htmlfile");
                    } catch (e) {}
                    var e, t;
                    h = "undefined" != typeof document ? document.domain && n ? f(n) : ((t = c("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(p("document.F=Object")), e.close(), e.F) : f(n);
                    for(var o = a.length; o--;)delete h.prototype[a[o]];
                    return h();
                };
                s[u] = !0, e.exports = Object.create || function(e, t) {
                    var o;
                    return null !== e ? (d.prototype = r(e), o = new d, d.prototype = null, o[u] = e) : o = h(), void 0 === t ? o : i.f(o, t);
                };
            },
            5770: function(e, t, o) {
                "use strict";
                var n = o(13873), r = o(63142), i = o(73252), a = o(52313), s = o(98651), l = o(3385);
                t.f = n && !r ? Object.defineProperties : function(e, t) {
                    a(e);
                    for(var o, n = s(t), r = l(t), c = r.length, u = 0; c > u;)i.f(e, o = r[u++], n[o]);
                    return e;
                };
            },
            73252: function(e, t, o) {
                "use strict";
                var n = o(13873), r = o(12816), i = o(63142), a = o(52313), s = o(43836), l = TypeError, c = Object.defineProperty, u = Object.getOwnPropertyDescriptor;
                t.f = n ? i ? function(e, t, o) {
                    if (a(e), t = s(t), a(o), "function" == typeof e && "prototype" === t && "value" in o && "writable" in o && !o.writable) {
                        var n = u(e, t);
                        n && n.writable && (e[t] = o.value, o = {
                            configurable: "configurable" in o ? o.configurable : n.configurable,
                            enumerable: "enumerable" in o ? o.enumerable : n.enumerable,
                            writable: !1
                        });
                    }
                    return c(e, t, o);
                } : c : function(e, t, o) {
                    if (a(e), t = s(t), a(o), r) try {
                        return c(e, t, o);
                    } catch (e) {}
                    if ("get" in o || "set" in o) throw l("Accessors not supported");
                    return "value" in o && (e[t] = o.value), e;
                };
            },
            36999: function(e, t, o) {
                "use strict";
                var n = o(13873), r = o(9093), i = o(33244), a = o(32500), s = o(98651), l = o(43836), c = o(14434), u = o(12816), d = Object.getOwnPropertyDescriptor;
                t.f = n ? d : function(e, t) {
                    if (e = s(e), t = l(t), u) try {
                        return d(e, t);
                    } catch (e) {}
                    if (c(e, t)) return a(!r(i.f, e, t), e[t]);
                };
            },
            53305: function(e, t, o) {
                "use strict";
                var n = o(6285), r = o(98651), i = o(7792).f, a = o(57652), s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
                e.exports.f = function(e) {
                    return s && "Window" == n(e) ? function(e) {
                        try {
                            return i(e);
                        } catch (e) {
                            return a(s);
                        }
                    }(e) : i(r(e));
                };
            },
            7792: function(e, t, o) {
                "use strict";
                var n = o(84729), r = o(64456).concat("length", "prototype");
                t.f = Object.getOwnPropertyNames || function(e) {
                    return n(e, r);
                };
            },
            23953: function(e, t) {
                "use strict";
                t.f = Object.getOwnPropertySymbols;
            },
            1074: function(e, t, o) {
                "use strict";
                var n = o(14434), r = o(794), i = o(68488), a = o(85475), s = o(27259), l = a("IE_PROTO"), c = Object, u = c.prototype;
                e.exports = s ? c.getPrototypeOf : function(e) {
                    var t = i(e);
                    if (n(t, l)) return t[l];
                    var o = t.constructor;
                    return r(o) && t instanceof o ? o.prototype : t instanceof c ? u : null;
                };
            },
            54671: function(e, t, o) {
                "use strict";
                var n = o(90838);
                e.exports = n({}.isPrototypeOf);
            },
            84729: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(14434), i = o(98651), a = o(79327).indexOf, s = o(48889), l = n([].push);
                e.exports = function(e, t) {
                    var o, n = i(e), c = 0, u = [];
                    for(o in n)!r(s, o) && r(n, o) && l(u, o);
                    for(; t.length > c;)r(n, o = t[c++]) && (~a(u, o) || l(u, o));
                    return u;
                };
            },
            3385: function(e, t, o) {
                "use strict";
                var n = o(84729), r = o(64456);
                e.exports = Object.keys || function(e) {
                    return n(e, r);
                };
            },
            33244: function(e, t) {
                "use strict";
                var o = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor, r = n && !o.call({
                    1: 2
                }, 1);
                t.f = r ? function(e) {
                    var t = n(this, e);
                    return !!t && t.enumerable;
                } : o;
            },
            482: function(e, t, o) {
                "use strict";
                var n = o(47448), r = o(52313), i = o(75839);
                e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                    var e, t = !1, o = {};
                    try {
                        (e = n(Object.prototype, "__proto__", "set"))(o, []), t = o instanceof Array;
                    } catch (e) {}
                    return function(o, n) {
                        return r(o), i(n), t ? e(o, n) : o.__proto__ = n, o;
                    };
                }() : void 0);
            },
            57555: function(e, t, o) {
                "use strict";
                var n = o(6424), r = o(8652);
                e.exports = n ? ({}).toString : function() {
                    return "[object " + r(this) + "]";
                };
            },
            82472: function(e, t, o) {
                "use strict";
                var n = o(9093), r = o(794), i = o(8148), a = TypeError;
                e.exports = function(e, t) {
                    var o, s;
                    if ("string" === t && r(o = e.toString) && !i(s = n(o, e))) return s;
                    if (r(o = e.valueOf) && !i(s = n(o, e))) return s;
                    if ("string" !== t && r(o = e.toString) && !i(s = n(o, e))) return s;
                    throw a("Can't convert object to primitive value");
                };
            },
            86671: function(e, t, o) {
                "use strict";
                var n = o(98945), r = o(90838), i = o(7792), a = o(23953), s = o(52313), l = r([].concat);
                e.exports = n("Reflect", "ownKeys") || function(e) {
                    var t = i.f(s(e)), o = a.f;
                    return o ? l(t, o(e)) : t;
                };
            },
            31116: function(e, t, o) {
                "use strict";
                var n = o(37042);
                e.exports = n;
            },
            60265: function(e, t, o) {
                "use strict";
                var n = o(8140), r = TypeError;
                e.exports = function(e) {
                    if (n(e)) throw r("Can't call method on " + e);
                    return e;
                };
            },
            44532: function(e, t, o) {
                "use strict";
                var n = o(73252).f, r = o(14434), i = o(19517)("toStringTag");
                e.exports = function(e, t, o) {
                    e && !o && (e = e.prototype), e && !r(e, i) && n(e, i, {
                        configurable: !0,
                        value: t
                    });
                };
            },
            85475: function(e, t, o) {
                "use strict";
                var n = o(95138), r = o(15257), i = n("keys");
                e.exports = function(e) {
                    return i[e] || (i[e] = r(e));
                };
            },
            45752: function(e, t, o) {
                "use strict";
                var n = o(37042), r = o(25379), i = "__core-js_shared__", a = n[i] || r(i, {});
                e.exports = a;
            },
            95138: function(e, t, o) {
                "use strict";
                var n = o(70852), r = o(45752);
                (e.exports = function(e, t) {
                    return r[e] || (r[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                    version: "3.28.0",
                    mode: n ? "pure" : "global",
                    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
                    license: "https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE",
                    source: "https://github.com/zloirock/core-js"
                });
            },
            41397: function(e, t, o) {
                "use strict";
                var n = o(90838), r = o(27876), i = o(63046), a = o(60265), s = n("".charAt), l = n("".charCodeAt), c = n("".slice), u = function(e) {
                    return function(t, o) {
                        var n, u, d = i(a(t)), p = r(o), f = d.length;
                        return 0 > p || p >= f ? e ? "" : void 0 : 55296 > (n = l(d, p)) || n > 56319 || p + 1 === f || 56320 > (u = l(d, p + 1)) || u > 57343 ? e ? s(d, p) : n : e ? c(d, p, p + 2) : u - 56320 + (n - 55296 << 10) + 65536;
                    };
                };
                e.exports = {
                    codeAt: u(!1),
                    charAt: u(!0)
                };
            },
            73800: function(e, t, o) {
                "use strict";
                var n = o(65190), r = o(75834);
                e.exports = !!Object.getOwnPropertySymbols && !r(function() {
                    var e = Symbol();
                    return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && 41 > n;
                });
            },
            13829: function(e, t, o) {
                "use strict";
                var n = o(9093), r = o(98945), i = o(19517), a = o(35065);
                e.exports = function() {
                    var e = r("Symbol"), t = e && e.prototype, o = t && t.valueOf, s = i("toPrimitive");
                    t && !t[s] && a(t, s, function(e) {
                        return n(o, this);
                    }, {
                        arity: 1
                    });
                };
            },
            31948: function(e, t, o) {
                "use strict";
                var n = o(73800);
                e.exports = n && !!Symbol.for && !!Symbol.keyFor;
            },
            10586: function(e, t, o) {
                "use strict";
                var n = o(27876), r = Math.max, i = Math.min;
                e.exports = function(e, t) {
                    var o = n(e);
                    return 0 > o ? r(o + t, 0) : i(o, t);
                };
            },
            98651: function(e, t, o) {
                "use strict";
                var n = o(25049), r = o(60265);
                e.exports = function(e) {
                    return n(r(e));
                };
            },
            27876: function(e, t, o) {
                "use strict";
                var n = o(43932);
                e.exports = function(e) {
                    var t = +e;
                    return t != t || 0 === t ? 0 : n(t);
                };
            },
            24431: function(e, t, o) {
                "use strict";
                var n = o(27876), r = Math.min;
                e.exports = function(e) {
                    return e > 0 ? r(n(e), 9007199254740991) : 0;
                };
            },
            68488: function(e, t, o) {
                "use strict";
                var n = o(60265), r = Object;
                e.exports = function(e) {
                    return r(n(e));
                };
            },
            11261: function(e, t, o) {
                "use strict";
                var n = o(9093), r = o(8148), i = o(88253), a = o(20156), s = o(82472), l = o(19517), c = TypeError, u = l("toPrimitive");
                e.exports = function(e, t) {
                    if (!r(e) || i(e)) return e;
                    var o, l = a(e, u);
                    if (l) {
                        if (void 0 === t && (t = "default"), o = n(l, e, t), !r(o) || i(o)) return o;
                        throw c("Can't convert object to primitive value");
                    }
                    return void 0 === t && (t = "number"), s(e, t);
                };
            },
            43836: function(e, t, o) {
                "use strict";
                var n = o(11261), r = o(88253);
                e.exports = function(e) {
                    var t = n(e, "string");
                    return r(t) ? t : t + "";
                };
            },
            6424: function(e, t, o) {
                "use strict";
                var n = {};
                n[o(19517)("toStringTag")] = "z", e.exports = "[object z]" === String(n);
            },
            63046: function(e, t, o) {
                "use strict";
                var n = o(8652), r = String;
                e.exports = function(e) {
                    if ("Symbol" === n(e)) throw TypeError("Cannot convert a Symbol value to a string");
                    return r(e);
                };
            },
            98418: function(e) {
                "use strict";
                var t = String;
                e.exports = function(e) {
                    try {
                        return t(e);
                    } catch (e) {
                        return "Object";
                    }
                };
            },
            15257: function(e, t, o) {
                "use strict";
                var n = o(90838), r = 0, i = Math.random(), a = n(1..toString);
                e.exports = function(e) {
                    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++r + i, 36);
                };
            },
            57982: function(e, t, o) {
                "use strict";
                var n = o(73800);
                e.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator;
            },
            63142: function(e, t, o) {
                "use strict";
                var n = o(13873), r = o(75834);
                e.exports = n && r(function() {
                    return 42 != Object.defineProperty(function() {}, "prototype", {
                        value: 42,
                        writable: !1
                    }).prototype;
                });
            },
            95473: function(e, t, o) {
                "use strict";
                var n = o(37042), r = o(794), i = n.WeakMap;
                e.exports = r(i) && /native code/.test(String(i));
            },
            89633: function(e, t, o) {
                "use strict";
                var n = o(31116), r = o(14434), i = o(96767), a = o(73252).f;
                e.exports = function(e) {
                    var t = n.Symbol || (n.Symbol = {});
                    r(t, e) || a(t, e, {
                        value: i.f(e)
                    });
                };
            },
            96767: function(e, t, o) {
                "use strict";
                var n = o(19517);
                t.f = n;
            },
            19517: function(e, t, o) {
                "use strict";
                var n = o(37042), r = o(95138), i = o(14434), a = o(15257), s = o(73800), l = o(57982), c = n.Symbol, u = r("wks"), d = l ? c.for || c : c && c.withoutSetter || a;
                e.exports = function(e) {
                    return i(u, e) || (u[e] = s && i(c, e) ? c[e] : d("Symbol." + e)), u[e];
                };
            },
            54166: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(75834), i = o(36222), a = o(8148), s = o(68488), l = o(15050), c = o(39505), u = o(89476), d = o(6429), p = o(63833), f = o(19517), h = o(65190), m = f("isConcatSpreadable"), v = h >= 51 || !r(function() {
                    var e = [];
                    return e[m] = !1, e.concat()[0] !== e;
                }), g = function(e) {
                    if (!a(e)) return !1;
                    var t = e[m];
                    return void 0 !== t ? !!t : i(e);
                };
                n({
                    target: "Array",
                    proto: !0,
                    arity: 1,
                    forced: !v || !p("concat")
                }, {
                    concat: function(e) {
                        var t, o, n, r, i, a = s(this), p = d(a, 0), f = 0;
                        for(t = -1, n = arguments.length; n > t; t++)if (g(i = -1 === t ? a : arguments[t])) for(r = l(i), c(f + r), o = 0; r > o; o++, f++)o in i && u(p, f, i[o]);
                        else c(f + 1), u(p, f++, i);
                        return p.length = f, p;
                    }
                });
            },
            22513: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(56881).findIndex, i = o(15179), a = "findIndex", s = !0;
                a in [] && Array(1).findIndex(function() {
                    s = !1;
                }), n({
                    target: "Array",
                    proto: !0,
                    forced: s
                }, {
                    findIndex: function(e) {
                        return r(this, e, arguments.length > 1 ? arguments[1] : void 0);
                    }
                }), i(a);
            },
            70057: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(92707);
                n({
                    target: "Array",
                    stat: !0,
                    forced: !o(7581)(function(e) {
                        Array.from(e);
                    })
                }, {
                    from: r
                });
            },
            67507: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(98945), i = o(55101), a = o(9093), s = o(90838), l = o(75834), c = o(794), u = o(88253), d = o(54832), p = o(6693), f = o(73800), h = String, m = r("JSON", "stringify"), v = s(/./.exec), g = s("".charAt), y = s("".charCodeAt), _ = s("".replace), b = s(1..toString), w = /[\uD800-\uDFFF]/g, S = /^[\uD800-\uDBFF]$/, C = /^[\uDC00-\uDFFF]$/, j = !f || l(function() {
                    var e = r("Symbol")();
                    return "[null]" != m([
                        e
                    ]) || "{}" != m({
                        a: e
                    }) || "{}" != m(Object(e));
                }), E = l(function() {
                    return '"\\udf06\\ud834"' !== m("\udf06\ud834") || '"\\udead"' !== m("\udead");
                }), x = function(e, t) {
                    var o = d(arguments), n = p(t);
                    if (c(n) || void 0 !== e && !u(e)) return o[1] = function(e, t) {
                        if (c(n) && (t = a(n, this, h(e), t)), !u(t)) return t;
                    }, i(m, null, o);
                }, k = function(e, t, o) {
                    var n = g(o, t - 1), r = g(o, t + 1);
                    return v(S, e) && !v(C, r) || v(C, e) && !v(S, n) ? "\\u" + b(y(e, 0), 16) : e;
                };
                m && n({
                    target: "JSON",
                    stat: !0,
                    arity: 3,
                    forced: j || E
                }, {
                    stringify: function(e, t, o) {
                        var n = d(arguments), r = i(j ? x : m, null, n);
                        return E && "string" == typeof r ? _(r, w, k) : r;
                    }
                });
            },
            90217: function(e, t, o) {
                "use strict";
                var n = o(37042);
                o(44532)(n.JSON, "JSON", !0);
            },
            73477: function(e, t, o) {
                "use strict";
                o(44532)(Math, "Math", !0);
            },
            30165: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(73800), i = o(75834), a = o(23953), s = o(68488);
                n({
                    target: "Object",
                    stat: !0,
                    forced: !r || i(function() {
                        a.f(1);
                    })
                }, {
                    getOwnPropertySymbols: function(e) {
                        var t = a.f;
                        return t ? t(s(e)) : [];
                    }
                });
            },
            32044: function(e, t, o) {
                "use strict";
                var n = o(6424), r = o(35065), i = o(57555);
                n || r(Object.prototype, "toString", i, {
                    unsafe: !0
                });
            },
            93697: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(37042), i = o(44532);
                n({
                    global: !0
                }, {
                    Reflect: {}
                }), i(r.Reflect, "Reflect", !0);
            },
            52867: function(e, t, o) {
                "use strict";
                var n = o(41397).charAt, r = o(63046), i = o(56113), a = o(13759), s = o(17427), l = "String Iterator", c = i.set, u = i.getterFor(l);
                a(String, "String", function(e) {
                    c(this, {
                        type: l,
                        string: r(e),
                        index: 0
                    });
                }, function() {
                    var e, t = u(this), o = t.string, r = t.index;
                    return o.length > r ? (e = n(o, r), t.index += e.length, s(e, !1)) : s(void 0, !0);
                });
            },
            28424: function(e, t, o) {
                "use strict";
                o(89633)("asyncIterator");
            },
            9656: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(37042), i = o(9093), a = o(90838), s = o(70852), l = o(13873), c = o(73800), u = o(75834), d = o(14434), p = o(54671), f = o(52313), h = o(98651), m = o(43836), v = o(63046), g = o(32500), y = o(93503), _ = o(3385), b = o(7792), w = o(53305), S = o(23953), C = o(36999), j = o(73252), E = o(5770), x = o(33244), k = o(35065), T = o(97548), I = o(95138), P = o(85475), M = o(48889), D = o(15257), O = o(19517), z = o(96767), A = o(89633), L = o(13829), N = o(44532), R = o(56113), B = o(56881).forEach, q = P("hidden"), F = "Symbol", H = R.set, V = R.getterFor(F), U = Object.prototype, W = r.Symbol, Y = W && W.prototype, G = r.TypeError, K = r.QObject, X = C.f, J = j.f, $ = w.f, Z = x.f, Q = a([].push), ee = I("symbols"), te = I("op-symbols"), oe = I("wks"), ne = !K || !K.prototype || !K.prototype.findChild, re = l && u(function() {
                    return 7 != y(J({}, "a", {
                        get: function() {
                            return J(this, "a", {
                                value: 7
                            }).a;
                        }
                    })).a;
                }) ? function(e, t, o) {
                    var n = X(U, t);
                    n && delete U[t], J(e, t, o), n && e !== U && J(U, t, n);
                } : J, ie = function(e, t) {
                    var o = ee[e] = y(Y);
                    return H(o, {
                        type: F,
                        tag: e,
                        description: t
                    }), l || (o.description = t), o;
                }, ae = function(e, t, o) {
                    e === U && ae(te, t, o), f(e);
                    var n = m(t);
                    return f(o), d(ee, n) ? (o.enumerable ? (d(e, q) && e[q][n] && (e[q][n] = !1), o = y(o, {
                        enumerable: g(0, !1)
                    })) : (d(e, q) || J(e, q, g(1, {})), e[q][n] = !0), re(e, n, o)) : J(e, n, o);
                }, se = function(e, t) {
                    f(e);
                    var o = h(t), n = _(o).concat(de(o));
                    return B(n, function(t) {
                        l && !i(le, o, t) || ae(e, t, o[t]);
                    }), e;
                }, le = function(e) {
                    var t = m(e), o = i(Z, this, t);
                    return !(this === U && d(ee, t) && !d(te, t)) && (!(o || !d(this, t) || !d(ee, t) || d(this, q) && this[q][t]) || o);
                }, ce = function(e, t) {
                    var o = h(e), n = m(t);
                    if (o !== U || !d(ee, n) || d(te, n)) {
                        var r = X(o, n);
                        return !r || !d(ee, n) || d(o, q) && o[q][n] || (r.enumerable = !0), r;
                    }
                }, ue = function(e) {
                    var t = $(h(e)), o = [];
                    return B(t, function(e) {
                        d(ee, e) || d(M, e) || Q(o, e);
                    }), o;
                }, de = function(e) {
                    var t = e === U, o = $(t ? te : h(e)), n = [];
                    return B(o, function(e) {
                        !d(ee, e) || t && !d(U, e) || Q(n, ee[e]);
                    }), n;
                };
                c || (W = function() {
                    if (p(Y, this)) throw G("Symbol is not a constructor");
                    var e = arguments.length && void 0 !== arguments[0] ? v(arguments[0]) : void 0, t = D(e), o = function(e) {
                        this === U && i(o, te, e), d(this, q) && d(this[q], t) && (this[q][t] = !1), re(this, t, g(1, e));
                    };
                    return l && ne && re(U, t, {
                        configurable: !0,
                        set: o
                    }), ie(t, e);
                }, k(Y = W.prototype, "toString", function() {
                    return V(this).tag;
                }), k(W, "withoutSetter", function(e) {
                    return ie(D(e), e);
                }), x.f = le, j.f = ae, E.f = se, C.f = ce, b.f = w.f = ue, S.f = de, z.f = function(e) {
                    return ie(O(e), e);
                }, l && (T(Y, "description", {
                    configurable: !0,
                    get: function() {
                        return V(this).description;
                    }
                }), s || k(U, "propertyIsEnumerable", le, {
                    unsafe: !0
                }))), n({
                    global: !0,
                    constructor: !0,
                    wrap: !0,
                    forced: !c,
                    sham: !c
                }, {
                    Symbol: W
                }), B(_(oe), function(e) {
                    A(e);
                }), n({
                    target: F,
                    stat: !0,
                    forced: !c
                }, {
                    useSetter: function() {
                        ne = !0;
                    },
                    useSimple: function() {
                        ne = !1;
                    }
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c,
                    sham: !l
                }, {
                    create: function(e, t) {
                        return void 0 === t ? y(e) : se(y(e), t);
                    },
                    defineProperty: ae,
                    defineProperties: se,
                    getOwnPropertyDescriptor: ce
                }), n({
                    target: "Object",
                    stat: !0,
                    forced: !c
                }, {
                    getOwnPropertyNames: ue
                }), L(), N(W, F), M[q] = !0;
            },
            64514: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(13873), i = o(37042), a = o(90838), s = o(14434), l = o(794), c = o(54671), u = o(63046), d = o(97548), p = o(58392), f = i.Symbol, h = f && f.prototype;
                if (r && l(f) && (!("description" in h) || void 0 !== f().description)) {
                    var m = {}, v = function() {
                        var e = 1 > arguments.length || void 0 === arguments[0] ? void 0 : u(arguments[0]), t = c(h, this) ? new f(e) : void 0 === e ? f() : f(e);
                        return "" === e && (m[t] = !0), t;
                    };
                    p(v, f), v.prototype = h, h.constructor = v;
                    var g = "Symbol(test)" == String(f("test")), y = a(h.valueOf), _ = a(h.toString), b = /^Symbol\((.*)\)[^)]+$/, w = a("".replace), S = a("".slice);
                    d(h, "description", {
                        configurable: !0,
                        get: function() {
                            var e = y(this);
                            if (s(m, e)) return "";
                            var t = _(e), o = g ? S(t, 7, -1) : w(t, b, "$1");
                            return "" === o ? void 0 : o;
                        }
                    }), n({
                        global: !0,
                        constructor: !0,
                        forced: !0
                    }, {
                        Symbol: v
                    });
                }
            },
            56202: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(98945), i = o(14434), a = o(63046), s = o(95138), l = o(31948), c = s("string-to-symbol-registry"), u = s("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    for: function(e) {
                        var t = a(e);
                        if (i(c, t)) return c[t];
                        var o = r("Symbol")(t);
                        return c[t] = o, u[o] = t, o;
                    }
                });
            },
            30733: function(e, t, o) {
                "use strict";
                o(89633)("hasInstance");
            },
            40327: function(e, t, o) {
                "use strict";
                o(89633)("isConcatSpreadable");
            },
            53639: function(e, t, o) {
                "use strict";
                o(89633)("iterator");
            },
            95661: function(e, t, o) {
                "use strict";
                o(9656), o(56202), o(71940), o(67507), o(30165);
            },
            71940: function(e, t, o) {
                "use strict";
                var n = o(50791), r = o(14434), i = o(88253), a = o(98418), s = o(95138), l = o(31948), c = s("symbol-to-string-registry");
                n({
                    target: "Symbol",
                    stat: !0,
                    forced: !l
                }, {
                    keyFor: function(e) {
                        if (!i(e)) throw TypeError(a(e) + " is not a symbol");
                        if (r(c, e)) return c[e];
                    }
                });
            },
            7290: function(e, t, o) {
                "use strict";
                o(89633)("matchAll");
            },
            6147: function(e, t, o) {
                "use strict";
                o(89633)("match");
            },
            95122: function(e, t, o) {
                "use strict";
                o(89633)("replace");
            },
            61322: function(e, t, o) {
                "use strict";
                o(89633)("search");
            },
            39605: function(e, t, o) {
                "use strict";
                o(89633)("species");
            },
            49341: function(e, t, o) {
                "use strict";
                o(89633)("split");
            },
            28809: function(e, t, o) {
                "use strict";
                var n = o(89633), r = o(13829);
                n("toPrimitive"), r();
            },
            82658: function(e, t, o) {
                "use strict";
                var n = o(98945), r = o(89633), i = o(44532);
                r("toStringTag"), i(n("Symbol"), "Symbol");
            },
            43967: function(e, t, o) {
                "use strict";
                o(89633)("unscopables");
            },
            690: function(e, t, o) {
                "use strict";
                e.exports = o(26002).polyfill();
            },
            26002: function(e, t, o) {
                "use strict";
                e.exports = function() {
                    function e(e) {
                        return "function" == typeof e;
                    }
                    var t = Array.isArray ? Array.isArray : function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e);
                    }, n = 0, r = void 0, i = void 0, a = function(e, t) {
                        f[n] = e, f[n + 1] = t, 2 === (n += 2) && (i ? i(h) : _());
                    }, s = "undefined" != typeof window ? window : void 0, l = s || {}, c = l.MutationObserver || l.WebKitMutationObserver, u = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === ({}).toString.call(process), d = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel;
                    function p() {
                        var e = setTimeout;
                        return function() {
                            return e(h, 1);
                        };
                    }
                    var f = new Array(1e3);
                    function h() {
                        for(var e = 0; n > e; e += 2)(0, f[e])(f[e + 1]), f[e] = void 0, f[e + 1] = void 0;
                        n = 0;
                    }
                    var m, v, g, y, _ = void 0;
                    function b(e, t) {
                        var o = this, n = new this.constructor(C);
                        void 0 === n[S] && z(n);
                        var r = o._state;
                        if (r) {
                            var i = arguments[r - 1];
                            a(function() {
                                return D(r, n, i, o._result);
                            });
                        } else P(o, n, e, t);
                        return n;
                    }
                    function w(e) {
                        if (e && "object" == typeof e && e.constructor === this) return e;
                        var t = new this(C);
                        return x(t, e), t;
                    }
                    _ = u ? function() {
                        return process.nextTick(h);
                    } : c ? (v = 0, g = new c(h), y = document.createTextNode(""), g.observe(y, {
                        characterData: !0
                    }), function() {
                        y.data = v = ++v % 2;
                    }) : d ? ((m = new MessageChannel).port1.onmessage = h, function() {
                        return m.port2.postMessage(0);
                    }) : void 0 === s ? function() {
                        try {
                            var e = Function("return this")().require("vertx");
                            return void 0 !== (r = e.runOnLoop || e.runOnContext) ? function() {
                                r(h);
                            } : p();
                        } catch (e) {
                            return p();
                        }
                    }() : p();
                    var S = Math.random().toString(36).substring(2);
                    function C() {}
                    var j = void 0;
                    function E(t, o, n) {
                        o.constructor === t.constructor && n === b && o.constructor.resolve === w ? function(e, t) {
                            1 === t._state ? T(e, t._result) : 2 === t._state ? I(e, t._result) : P(t, void 0, function(t) {
                                return x(e, t);
                            }, function(t) {
                                return I(e, t);
                            });
                        }(t, o) : void 0 === n ? T(t, o) : e(n) ? function(e, t, o) {
                            a(function(e) {
                                var n = !1, r = function(o, r, i, a) {
                                    try {
                                        o.call(r, function(o) {
                                            n || (n = !0, t !== o ? x(e, o) : T(e, o));
                                        }, function(t) {
                                            n || (n = !0, I(e, t));
                                        });
                                    } catch (e) {
                                        return e;
                                    }
                                }(o, t);
                                !n && r && (n = !0, I(e, r));
                            }, e);
                        }(t, o, n) : T(t, o);
                    }
                    function x(e, t) {
                        if (e === t) I(e, new TypeError("You cannot resolve a promise with itself"));
                        else if (r = typeof (n = t), null === n || "object" !== r && "function" !== r) T(e, t);
                        else {
                            var o = void 0;
                            try {
                                o = t.then;
                            } catch (t) {
                                return void I(e, t);
                            }
                            E(e, t, o);
                        }
                        var n, r;
                    }
                    function k(e) {
                        e._onerror && e._onerror(e._result), M(e);
                    }
                    function T(e, t) {
                        e._state === j && (e._result = t, e._state = 1, 0 !== e._subscribers.length && a(M, e));
                    }
                    function I(e, t) {
                        e._state === j && (e._state = 2, e._result = t, a(k, e));
                    }
                    function P(e, t, o, n) {
                        var r = e._subscribers, i = r.length;
                        e._onerror = null, r[i] = t, r[i + 1] = o, r[i + 2] = n, 0 === i && e._state && a(M, e);
                    }
                    function M(e) {
                        var t = e._subscribers, o = e._state;
                        if (0 !== t.length) {
                            for(var n = void 0, r = void 0, i = e._result, a = 0; t.length > a; a += 3)r = t[a + o], (n = t[a]) ? D(o, n, r, i) : r(i);
                            e._subscribers.length = 0;
                        }
                    }
                    function D(t, o, n, r) {
                        var i = e(n), a = void 0, s = void 0, l = !0;
                        if (i) {
                            try {
                                a = n(r);
                            } catch (e) {
                                l = !1, s = e;
                            }
                            if (o === a) return void I(o, new TypeError("A promises callback cannot return that same promise."));
                        } else a = r;
                        o._state !== j || (i && l ? x(o, a) : !1 === l ? I(o, s) : 1 === t ? T(o, a) : 2 === t && I(o, a));
                    }
                    var O = 0;
                    function z(e) {
                        e[S] = O++, e._state = void 0, e._result = void 0, e._subscribers = [];
                    }
                    var A = function() {
                        function e(e, o) {
                            this._instanceConstructor = e, this.promise = new e(C), this.promise[S] || z(this.promise), t(o) ? (this.length = o.length, this._remaining = o.length, this._result = new Array(this.length), 0 === this.length ? T(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(o), 0 === this._remaining && T(this.promise, this._result))) : I(this.promise, new Error("Array Methods must be provided an Array"));
                        }
                        return e.prototype._enumerate = function(e) {
                            for(var t = 0; this._state === j && e.length > t; t++)this._eachEntry(e[t], t);
                        }, e.prototype._eachEntry = function(e, t) {
                            var o = this._instanceConstructor, n = o.resolve;
                            if (n === w) {
                                var r = void 0, i = void 0, a = !1;
                                try {
                                    r = e.then;
                                } catch (e) {
                                    a = !0, i = e;
                                }
                                if (r === b && e._state !== j) this._settledAt(e._state, t, e._result);
                                else if ("function" != typeof r) this._remaining--, this._result[t] = e;
                                else if (o === L) {
                                    var s = new o(C);
                                    a ? I(s, i) : E(s, e, r), this._willSettleAt(s, t);
                                } else this._willSettleAt(new o(function(t) {
                                    return t(e);
                                }), t);
                            } else this._willSettleAt(n(e), t);
                        }, e.prototype._settledAt = function(e, t, o) {
                            var n = this.promise;
                            n._state === j && (this._remaining--, 2 === e ? I(n, o) : this._result[t] = o), 0 === this._remaining && T(n, this._result);
                        }, e.prototype._willSettleAt = function(e, t) {
                            var o = this;
                            P(e, void 0, function(e) {
                                return o._settledAt(1, t, e);
                            }, function(e) {
                                return o._settledAt(2, t, e);
                            });
                        }, e;
                    }(), L = function() {
                        function t(e) {
                            this[S] = O++, this._result = this._state = void 0, this._subscribers = [], C !== e && ("function" != typeof e && function() {
                                throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
                            }(), this instanceof t ? function(e, t) {
                                try {
                                    t(function(t) {
                                        x(e, t);
                                    }, function(t) {
                                        I(e, t);
                                    });
                                } catch (t) {
                                    I(e, t);
                                }
                            }(this, e) : function() {
                                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                            }());
                        }
                        return t.prototype.catch = function(e) {
                            return this.then(null, e);
                        }, t.prototype.finally = function(t) {
                            var o = this, n = o.constructor;
                            return e(t) ? o.then(function(e) {
                                return n.resolve(t()).then(function() {
                                    return e;
                                });
                            }, function(e) {
                                return n.resolve(t()).then(function() {
                                    throw e;
                                });
                            }) : o.then(t, t);
                        }, t;
                    }();
                    return L.prototype.then = b, L.all = function(e) {
                        return new A(this, e).promise;
                    }, L.race = function(e) {
                        var o = this;
                        return t(e) ? new o(function(t, n) {
                            for(var r = e.length, i = 0; r > i; i++)o.resolve(e[i]).then(t, n);
                        }) : new o(function(e, t) {
                            return t(new TypeError("You must pass an array to race."));
                        });
                    }, L.resolve = w, L.reject = function(e) {
                        var t = new this(C);
                        return I(t, e), t;
                    }, L._setScheduler = function(e) {
                        i = e;
                    }, L._setAsap = function(e) {
                        a = e;
                    }, L._asap = a, L.polyfill = function() {
                        var e = void 0;
                        if (void 0 !== o.g) e = o.g;
                        else if ("undefined" != typeof self) e = self;
                        else try {
                            e = Function("return this")();
                        } catch (e) {
                            throw new Error("polyfill failed because global object is unavailable in this environment");
                        }
                        var t = e.Promise;
                        if (t) {
                            var n = null;
                            try {
                                n = Object.prototype.toString.call(t.resolve());
                            } catch (e) {}
                            if ("[object Promise]" === n && !t.cast) return;
                        }
                        e.Promise = L;
                    }, L.Promise = L, L;
                }();
            },
            20255: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.__classPrivateFieldIn = t.__classPrivateFieldSet = t.__classPrivateFieldGet = t.__importDefault = t.__importStar = t.__makeTemplateObject = t.__asyncValues = t.__asyncDelegator = t.__asyncGenerator = t.__await = t.__spreadArray = t.__spreadArrays = t.__spread = t.__read = t.__values = t.__exportStar = t.__createBinding = t.__generator = t.__awaiter = t.__metadata = t.__setFunctionName = t.__propKey = t.__runInitializers = t.__esDecorate = t.__param = t.__decorate = t.__rest = t.__assign = t.__extends = void 0;
                var o = function(e, t) {
                    return o = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(e, t) {
                        e.__proto__ = t;
                    } || function(e, t) {
                        for(var o in t)Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                    }, o(e, t);
                };
                function n(e) {
                    var t = "function" == typeof Symbol && Symbol.iterator, o = t && e[t], n = 0;
                    if (o) return o.call(e);
                    if (e && "number" == typeof e.length) return {
                        next: function() {
                            return e && n >= e.length && (e = void 0), {
                                value: e && e[n++],
                                done: !e
                            };
                        }
                    };
                    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                }
                function r(e, t) {
                    var o = "function" == typeof Symbol && e[Symbol.iterator];
                    if (!o) return e;
                    var n, r, i = o.call(e), a = [];
                    try {
                        for(; (void 0 === t || t-- > 0) && !(n = i.next()).done;)a.push(n.value);
                    } catch (e) {
                        r = {
                            error: e
                        };
                    } finally{
                        try {
                            n && !n.done && (o = i.return) && o.call(i);
                        } finally{
                            if (r) throw r.error;
                        }
                    }
                    return a;
                }
                function i(e) {
                    return this instanceof i ? (this.v = e, this) : new i(e);
                }
                t.__extends = function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                        this.constructor = e;
                    }
                    o(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
                }, t.__assign = function() {
                    return t.__assign = Object.assign || function(e) {
                        for(var t, o = 1, n = arguments.length; n > o; o++)for(var r in t = arguments[o])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                        return e;
                    }, t.__assign.apply(this, arguments);
                }, t.__rest = function(e, t) {
                    var o = {};
                    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && 0 > t.indexOf(n) && (o[n] = e[n]);
                    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                        var r = 0;
                        for(n = Object.getOwnPropertySymbols(e); n.length > r; r++)0 > t.indexOf(n[r]) && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (o[n[r]] = e[n[r]]);
                    }
                    return o;
                }, t.__decorate = function(e, t, o, n) {
                    var r, i = arguments.length, a = 3 > i ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, o) : n;
                    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, o, n);
                    else for(var s = e.length - 1; s >= 0; s--)(r = e[s]) && (a = (3 > i ? r(a) : i > 3 ? r(t, o, a) : r(t, o)) || a);
                    return i > 3 && a && Object.defineProperty(t, o, a), a;
                }, t.__param = function(e, t) {
                    return function(o, n) {
                        t(o, n, e);
                    };
                }, t.__esDecorate = function(e, t, o, n, r, i) {
                    function a(e) {
                        if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
                        return e;
                    }
                    for(var s, l = n.kind, c = "getter" === l ? "get" : "setter" === l ? "set" : "value", u = !t && e ? n.static ? e : e.prototype : null, d = t || (u ? Object.getOwnPropertyDescriptor(u, n.name) : {}), p = !1, f = o.length - 1; f >= 0; f--){
                        var h = {};
                        for(var m in n)h[m] = "access" === m ? {} : n[m];
                        for(var m in n.access)h.access[m] = n.access[m];
                        h.addInitializer = function(e) {
                            if (p) throw new TypeError("Cannot add initializers after decoration has completed");
                            i.push(a(e || null));
                        };
                        var v = (0, o[f])("accessor" === l ? {
                            get: d.get,
                            set: d.set
                        } : d[c], h);
                        if ("accessor" === l) {
                            if (void 0 === v) continue;
                            if (null === v || "object" != typeof v) throw new TypeError("Object expected");
                            (s = a(v.get)) && (d.get = s), (s = a(v.set)) && (d.set = s), (s = a(v.init)) && r.push(s);
                        } else (s = a(v)) && ("field" === l ? r.push(s) : d[c] = s);
                    }
                    u && Object.defineProperty(u, n.name, d), p = !0;
                }, t.__runInitializers = function(e, t, o) {
                    for(var n = arguments.length > 2, r = 0; t.length > r; r++)o = n ? t[r].call(e, o) : t[r].call(e);
                    return n ? o : void 0;
                }, t.__propKey = function(e) {
                    return "symbol" == typeof e ? e : "".concat(e);
                }, t.__setFunctionName = function(e, t, o) {
                    return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
                        configurable: !0,
                        value: o ? "".concat(o, " ", t) : t
                    });
                }, t.__metadata = function(e, t) {
                    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
                }, t.__awaiter = function(e, t, o, n) {
                    return new (o || (o = Promise))(function(r, i) {
                        function a(e) {
                            try {
                                l(n.next(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function s(e) {
                            try {
                                l(n.throw(e));
                            } catch (e) {
                                i(e);
                            }
                        }
                        function l(e) {
                            var t;
                            e.done ? r(e.value) : (t = e.value, t instanceof o ? t : new o(function(e) {
                                e(t);
                            })).then(a, s);
                        }
                        l((n = n.apply(e, t || [])).next());
                    });
                }, t.__generator = function(e, t) {
                    var o, n, r, i, a = {
                        label: 0,
                        sent: function() {
                            if (1 & r[0]) throw r[1];
                            return r[1];
                        },
                        trys: [],
                        ops: []
                    };
                    return i = {
                        next: s(0),
                        throw: s(1),
                        return: s(2)
                    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                        return this;
                    }), i;
                    function s(s) {
                        return function(l) {
                            return function(s) {
                                if (o) throw new TypeError("Generator is already executing.");
                                for(; i && (i = 0, s[0] && (a = 0)), a;)try {
                                    if (o = 1, n && (r = 2 & s[0] ? n.return : s[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, s[1])).done) return r;
                                    switch(n = 0, r && (s = [
                                        2 & s[0],
                                        r.value
                                    ]), s[0]){
                                        case 0:
                                        case 1:
                                            r = s;
                                            break;
                                        case 4:
                                            return a.label++, {
                                                value: s[1],
                                                done: !1
                                            };
                                        case 5:
                                            a.label++, n = s[1], s = [
                                                0
                                            ];
                                            continue;
                                        case 7:
                                            s = a.ops.pop(), a.trys.pop();
                                            continue;
                                        default:
                                            if (!((r = (r = a.trys).length > 0 && r[r.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                                                a = 0;
                                                continue;
                                            }
                                            if (3 === s[0] && (!r || s[1] > r[0] && r[3] > s[1])) {
                                                a.label = s[1];
                                                break;
                                            }
                                            if (6 === s[0] && r[1] > a.label) {
                                                a.label = r[1], r = s;
                                                break;
                                            }
                                            if (r && r[2] > a.label) {
                                                a.label = r[2], a.ops.push(s);
                                                break;
                                            }
                                            r[2] && a.ops.pop(), a.trys.pop();
                                            continue;
                                    }
                                    s = t.call(e, a);
                                } catch (e) {
                                    s = [
                                        6,
                                        e
                                    ], n = 0;
                                } finally{
                                    o = r = 0;
                                }
                                if (5 & s[0]) throw s[1];
                                return {
                                    value: s[0] ? s[1] : void 0,
                                    done: !0
                                };
                            }([
                                s,
                                l
                            ]);
                        };
                    }
                }, t.__createBinding = Object.create ? function(e, t, o, n) {
                    void 0 === n && (n = o);
                    var r = Object.getOwnPropertyDescriptor(t, o);
                    r && !("get" in r ? !t.__esModule : r.writable || r.configurable) || (r = {
                        enumerable: !0,
                        get: function() {
                            return t[o];
                        }
                    }), Object.defineProperty(e, n, r);
                } : function(e, t, o, n) {
                    void 0 === n && (n = o), e[n] = t[o];
                }, t.__exportStar = function(e, o) {
                    for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(o, n) || (0, t.__createBinding)(o, e, n);
                }, t.__values = n, t.__read = r, t.__spread = function() {
                    for(var e = [], t = 0; arguments.length > t; t++)e = e.concat(r(arguments[t]));
                    return e;
                }, t.__spreadArrays = function() {
                    for(var e = 0, t = 0, o = arguments.length; o > t; t++)e += arguments[t].length;
                    var n = Array(e), r = 0;
                    for(t = 0; o > t; t++)for(var i = arguments[t], a = 0, s = i.length; s > a; a++, r++)n[r] = i[a];
                    return n;
                }, t.__spreadArray = function(e, t, o) {
                    if (o || 2 === arguments.length) for(var n, r = 0, i = t.length; i > r; r++)!n && r in t || (n || (n = Array.prototype.slice.call(t, 0, r)), n[r] = t[r]);
                    return e.concat(n || Array.prototype.slice.call(t));
                }, t.__await = i, t.__asyncGenerator = function(e, t, o) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var n, r = o.apply(e, t || []), a = [];
                    return n = {}, s("next"), s("throw"), s("return"), n[Symbol.asyncIterator] = function() {
                        return this;
                    }, n;
                    function s(e) {
                        r[e] && (n[e] = function(t) {
                            return new Promise(function(o, n) {
                                a.push([
                                    e,
                                    t,
                                    o,
                                    n
                                ]) > 1 || l(e, t);
                            });
                        });
                    }
                    function l(e, t) {
                        try {
                            (o = r[e](t)).value instanceof i ? Promise.resolve(o.value.v).then(c, u) : d(a[0][2], o);
                        } catch (e) {
                            d(a[0][3], e);
                        }
                        var o;
                    }
                    function c(e) {
                        l("next", e);
                    }
                    function u(e) {
                        l("throw", e);
                    }
                    function d(e, t) {
                        e(t), a.shift(), a.length && l(a[0][0], a[0][1]);
                    }
                }, t.__asyncDelegator = function(e) {
                    var t, o;
                    return t = {}, n("next"), n("throw", function(e) {
                        throw e;
                    }), n("return"), t[Symbol.iterator] = function() {
                        return this;
                    }, t;
                    function n(n, r) {
                        t[n] = e[n] ? function(t) {
                            return (o = !o) ? {
                                value: i(e[n](t)),
                                done: !1
                            } : r ? r(t) : t;
                        } : r;
                    }
                }, t.__asyncValues = function(e) {
                    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                    var t, o = e[Symbol.asyncIterator];
                    return o ? o.call(e) : (e = n(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function() {
                        return this;
                    }, t);
                    function r(o) {
                        t[o] = e[o] && function(t) {
                            return new Promise(function(n, r) {
                                !function(e, t, o, n) {
                                    Promise.resolve(n).then(function(t) {
                                        e({
                                            value: t,
                                            done: o
                                        });
                                    }, t);
                                }(n, r, (t = e[o](t)).done, t.value);
                            });
                        };
                    }
                }, t.__makeTemplateObject = function(e, t) {
                    return Object.defineProperty ? Object.defineProperty(e, "raw", {
                        value: t
                    }) : e.raw = t, e;
                };
                var a = Object.create ? function(e, t) {
                    Object.defineProperty(e, "default", {
                        enumerable: !0,
                        value: t
                    });
                } : function(e, t) {
                    e.default = t;
                };
                t.__importStar = function(e) {
                    if (e && e.__esModule) return e;
                    var o = {};
                    if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && (0, t.__createBinding)(o, e, n);
                    return a(o, e), o;
                }, t.__importDefault = function(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }, t.__classPrivateFieldGet = function(e, t, o, n) {
                    if ("a" === o && !n) throw new TypeError("Private accessor was defined without a getter");
                    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                    return "m" === o ? n : "a" === o ? n.call(e) : n ? n.value : t.get(e);
                }, t.__classPrivateFieldSet = function(e, t, o, n, r) {
                    if ("m" === n) throw new TypeError("Private method is not writable");
                    if ("a" === n && !r) throw new TypeError("Private accessor was defined without a setter");
                    if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                    return "a" === n ? r.call(e, o) : r ? r.value = o : t.set(e, o), o;
                }, t.__classPrivateFieldIn = function(e, t) {
                    if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
                    return "function" == typeof e ? t === e : e.has(t);
                };
            },
            93166: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Config = void 0;
                var n = o(86893), r = o(86893), i = function() {
                    function e() {
                        this.defaultTimeout = 100, this.namespace = "", this.safeMode = !1, this.width = "auto", this.height = "auto", this.safePluginsList = [
                            "about",
                            "enter",
                            "backspace",
                            "size"
                        ], this.license = "", this.preset = "custom", this.presets = {
                            inline: {
                                inline: !0,
                                toolbar: !1,
                                toolbarInline: !0,
                                toolbarInlineForSelection: !0,
                                showXPathInStatusbar: !1,
                                showCharsCounter: !1,
                                showWordsCounter: !1,
                                showPlaceholder: !1
                            }
                        }, this.ownerDocument = "undefined" != typeof document ? document : null, this.ownerWindow = "undefined" != typeof window ? window : null, this.shadowRoot = null, this.zIndex = 0, this.readonly = !1, this.disabled = !1, this.activeButtonsInReadOnly = [
                            "source",
                            "fullsize",
                            "print",
                            "about",
                            "dots",
                            "selectall"
                        ], this.allowCommandsInReadOnly = [
                            "selectall",
                            "preview",
                            "print"
                        ], this.toolbarButtonSize = "middle", this.allowTabNavigation = !1, this.inline = !1, this.theme = "default", this.saveModeInStorage = !1, this.editorClassName = !1, this.editorCssClass = !1, this.className = !1, this.style = !1, this.containerStyle = !1, this.styleValues = {}, this.triggerChangeEvent = !0, this.direction = "", this.language = "auto", this.debugLanguage = !1, this.i18n = !1, this.tabIndex = -1, this.toolbar = !0, this.statusbar = !0, this.showTooltip = !0, this.showTooltipDelay = 1e3, this.useNativeTooltip = !1, this.defaultActionOnPaste = r.INSERT_AS_HTML, this.enter = n.PARAGRAPH, this.iframe = !1, this.editHTMLDocumentMode = !1, this.enterBlock = "br" !== this.enter ? this.enter : n.PARAGRAPH, this.defaultMode = n.MODE_WYSIWYG, this.useSplitMode = !1, this.colors = {
                            greyscale: [
                                "#000000",
                                "#434343",
                                "#666666",
                                "#999999",
                                "#B7B7B7",
                                "#CCCCCC",
                                "#D9D9D9",
                                "#EFEFEF",
                                "#F3F3F3",
                                "#FFFFFF"
                            ],
                            palette: [
                                "#980000",
                                "#FF0000",
                                "#FF9900",
                                "#FFFF00",
                                "#00F0F0",
                                "#00FFFF",
                                "#4A86E8",
                                "#0000FF",
                                "#9900FF",
                                "#FF00FF"
                            ],
                            full: [
                                "#E6B8AF",
                                "#F4CCCC",
                                "#FCE5CD",
                                "#FFF2CC",
                                "#D9EAD3",
                                "#D0E0E3",
                                "#C9DAF8",
                                "#CFE2F3",
                                "#D9D2E9",
                                "#EAD1DC",
                                "#DD7E6B",
                                "#EA9999",
                                "#F9CB9C",
                                "#FFE599",
                                "#B6D7A8",
                                "#A2C4C9",
                                "#A4C2F4",
                                "#9FC5E8",
                                "#B4A7D6",
                                "#D5A6BD",
                                "#CC4125",
                                "#E06666",
                                "#F6B26B",
                                "#FFD966",
                                "#93C47D",
                                "#76A5AF",
                                "#6D9EEB",
                                "#6FA8DC",
                                "#8E7CC3",
                                "#C27BA0",
                                "#A61C00",
                                "#CC0000",
                                "#E69138",
                                "#F1C232",
                                "#6AA84F",
                                "#45818E",
                                "#3C78D8",
                                "#3D85C6",
                                "#674EA7",
                                "#A64D79",
                                "#85200C",
                                "#990000",
                                "#B45F06",
                                "#BF9000",
                                "#38761D",
                                "#134F5C",
                                "#1155CC",
                                "#0B5394",
                                "#351C75",
                                "#733554",
                                "#5B0F00",
                                "#660000",
                                "#783F04",
                                "#7F6000",
                                "#274E13",
                                "#0C343D",
                                "#1C4587",
                                "#073763",
                                "#20124D",
                                "#4C1130"
                            ]
                        }, this.colorPickerDefaultTab = "background", this.imageDefaultWidth = 300, this.removeButtons = [], this.disablePlugins = [], this.extraPlugins = [], this.extraButtons = [], this.extraIcons = {}, this.createAttributes = {
                            table: {
                                style: "border-collapse:collapse;width: 100%;"
                            }
                        }, this.sizeLG = 900, this.sizeMD = 700, this.sizeSM = 400, this.buttons = [
                            {
                                group: "font-style",
                                buttons: []
                            },
                            {
                                group: "list",
                                buttons: []
                            },
                            {
                                group: "font",
                                buttons: []
                            },
                            "---",
                            {
                                group: "script",
                                buttons: []
                            },
                            {
                                group: "media",
                                buttons: []
                            },
                            "\n",
                            {
                                group: "state",
                                buttons: []
                            },
                            {
                                group: "clipboard",
                                buttons: []
                            },
                            {
                                group: "insert",
                                buttons: []
                            },
                            {
                                group: "indent",
                                buttons: []
                            },
                            {
                                group: "color",
                                buttons: []
                            },
                            {
                                group: "form",
                                buttons: []
                            },
                            "---",
                            {
                                group: "history",
                                buttons: []
                            },
                            {
                                group: "search",
                                buttons: []
                            },
                            {
                                group: "source",
                                buttons: []
                            },
                            {
                                group: "other",
                                buttons: []
                            },
                            {
                                group: "info",
                                buttons: []
                            }
                        ], this.buttonsMD = [
                            "bold",
                            "italic",
                            "|",
                            "ul",
                            "ol",
                            "eraser",
                            "|",
                            "font",
                            "fontsize",
                            "---",
                            "image",
                            "table",
                            "|",
                            "link",
                            "\n",
                            "brush",
                            "paragraph",
                            "align",
                            "|",
                            "hr",
                            "copyformat",
                            "fullsize",
                            "---",
                            "undo",
                            "redo",
                            "|",
                            "dots"
                        ], this.buttonsSM = [
                            "bold",
                            "italic",
                            "|",
                            "ul",
                            "ol",
                            "eraser",
                            "|",
                            "fontsize",
                            "brush",
                            "paragraph",
                            "---",
                            "image",
                            "table",
                            "\n",
                            "link",
                            "|",
                            "align",
                            "|",
                            "undo",
                            "redo",
                            "|",
                            "copyformat",
                            "fullsize",
                            "---",
                            "dots"
                        ], this.buttonsXS = [
                            "bold",
                            "brush",
                            "paragraph",
                            "eraser",
                            "|",
                            "fontsize",
                            "---",
                            "image",
                            "\n",
                            "align",
                            "undo",
                            "redo",
                            "|",
                            "link",
                            "table",
                            "---",
                            "dots"
                        ], this.events = {}, this.textIcons = !1, this.showBrowserColorPicker = !0;
                    }
                    return Object.defineProperty(e, "defaultOptions", {
                        get: function() {
                            return e.__defaultOptions || (e.__defaultOptions = new e), e.__defaultOptions;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e;
                }();
                t.Config = i, i.prototype.controls = {};
            },
            77536: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Async = void 0;
                var n = o(20255), r = o(4696), i = o(42096), a = o(79736), s = o(26335), l = o(24421), c = o(61817), u = (o(52378), function() {
                    function e() {
                        var e, t, o, n, r = this;
                        this.timers = new Map, this.__callbacks = new Map, this.promisesRejections = new Set, this.requestsIdle = new Set, this.requestsRaf = new Set, this.requestIdleCallbackNative = null !== (t = null === (e = window.requestIdleCallback) || void 0 === e ? void 0 : e.bind(window)) && void 0 !== t ? t : function(e, t) {
                            var o, n = Date.now();
                            return r.setTimeout(function() {
                                e({
                                    didTimeout: !1,
                                    timeRemaining: function() {
                                        return Math.max(0, 50 - (Date.now() - n));
                                    }
                                });
                            }, null !== (o = null == t ? void 0 : t.timeout) && void 0 !== o ? o : 1);
                        }, this.cancelIdleCallbackNative = null !== (n = null === (o = window.cancelIdleCallback) || void 0 === o ? void 0 : o.bind(window)) && void 0 !== n ? n : function(e) {
                            r.clearTimeout(e);
                        }, this.isDestructed = !1;
                    }
                    return e.prototype.delay = function(e) {
                        var t = this;
                        return this.promise(function(o) {
                            return t.setTimeout(o, e);
                        });
                    }, e.prototype.setTimeout = function(e, t) {
                        for(var o = [], i = 2; arguments.length > i; i++)o[i - 2] = arguments[i];
                        if (this.isDestructed) return 0;
                        var a = {};
                        (0, c.isNumber)(t) || (t = (a = t).timeout || 0), a.label && this.clearLabel(a.label);
                        var s = r.setTimeout.apply(void 0, n.__spreadArray([
                            e,
                            t
                        ], n.__read(o), !1)), l = a.label || s;
                        return this.timers.set(l, s), this.__callbacks.set(l, e), s;
                    }, e.prototype.updateTimeout = function(e, t) {
                        if (!e || !this.timers.has(e)) return null;
                        var o = this.__callbacks.get(e);
                        return this.setTimeout(o, {
                            label: e,
                            timeout: t
                        });
                    }, e.prototype.clearLabel = function(e) {
                        e && this.timers.has(e) && ((0, r.clearTimeout)(this.timers.get(e)), this.timers.delete(e), this.__callbacks.delete(e));
                    }, e.prototype.clearTimeout = function(e) {
                        if ((0, l.isString)(e)) return this.clearLabel(e);
                        (0, r.clearTimeout)(e), this.timers.delete(e), this.__callbacks.delete(e);
                    }, e.prototype.debounce = function(e, t, o) {
                        var l = this;
                        void 0 === o && (o = !1);
                        var c = 0, u = !1, d = [], p = function() {
                            for(var t = [], o = 0; arguments.length > o; o++)t[o] = arguments[o];
                            if (!u) {
                                c = 0;
                                var r = e.apply(void 0, n.__spreadArray([], n.__read(t), !1));
                                if (u = !0, d.length) {
                                    var i = function() {
                                        d.forEach(function(e) {
                                            return e();
                                        }), d.length = 0;
                                    };
                                    (0, s.isPromise)(r) ? r.finally(i) : i();
                                }
                            }
                        }, f = function() {
                            for(var a = [], s = 0; arguments.length > s; s++)a[s] = arguments[s];
                            u = !1, t ? (!c && o && p.apply(void 0, n.__spreadArray([], n.__read(a), !1)), (0, r.clearTimeout)(c), c = l.setTimeout(function() {
                                return p.apply(void 0, n.__spreadArray([], n.__read(a), !1));
                            }, (0, i.isFunction)(t) ? t() : t), l.timers.set(e, c)) : p.apply(void 0, n.__spreadArray([], n.__read(a), !1));
                        };
                        return (0, a.isPlainObject)(t) && t.promisify ? function() {
                            for(var e = [], t = 0; arguments.length > t; t++)e[t] = arguments[t];
                            var o = l.promise(function(e) {
                                d.push(e);
                            });
                            return f.apply(void 0, n.__spreadArray([], n.__read(e), !1)), o;
                        } : f;
                    }, e.prototype.throttle = function(e, t, o) {
                        var r = this;
                        void 0 === o && (o = !1);
                        var a, s, l, c = null;
                        return function() {
                            for(var o = [], u = 0; arguments.length > u; u++)o[u] = arguments[u];
                            a = !0, l = o, t ? c || (s = function() {
                                a ? (e.apply(void 0, n.__spreadArray([], n.__read(l), !1)), a = !1, c = r.setTimeout(s, (0, i.isFunction)(t) ? t() : t), r.timers.set(s, c)) : c = null;
                            })() : e.apply(void 0, n.__spreadArray([], n.__read(l), !1));
                        };
                    }, e.prototype.promise = function(e) {
                        var t = this, o = function() {}, n = new Promise(function(n, r) {
                            return t.promisesRejections.add(r), o = r, e(n, r);
                        });
                        return n.finally || (n.finally = function(e) {
                            return n.then(e).catch(e), n;
                        }), n.finally(function() {
                            t.promisesRejections.delete(o);
                        }).catch(function() {
                            return null;
                        }), n.rejectCallback = o, n;
                    }, e.prototype.promiseState = function(e) {
                        var t = this;
                        if (e.status) return e.status;
                        if (!Promise.race) return new Promise(function(o) {
                            e.then(function(e) {
                                return o("fulfilled"), e;
                            }, function(e) {
                                throw o("rejected"), e;
                            }), t.setTimeout(function() {
                                o("pending");
                            }, 100);
                        });
                        var o = {};
                        return Promise.race([
                            e,
                            o
                        ]).then(function(e) {
                            return e === o ? "pending" : "fulfilled";
                        }, function() {
                            return "rejected";
                        });
                    }, e.prototype.requestIdleCallback = function(e, t) {
                        var o = this.requestIdleCallbackNative(e, t);
                        return this.requestsIdle.add(o), o;
                    }, e.prototype.requestIdlePromise = function(e) {
                        var t = this;
                        return this.promise(function(o) {
                            var n = t.requestIdleCallback(function() {
                                return o(n);
                            }, e);
                        });
                    }, e.prototype.cancelIdleCallback = function(e) {
                        return this.requestsIdle.delete(e), this.cancelIdleCallbackNative(e);
                    }, e.prototype.requestAnimationFrame = function(e) {
                        var t = requestAnimationFrame(e);
                        return this.requestsRaf.add(t), t;
                    }, e.prototype.cancelAnimationFrame = function(e) {
                        this.requestsRaf.delete(e), cancelAnimationFrame(e);
                    }, e.prototype.clear = function() {
                        var e = this;
                        this.requestsIdle.forEach(function(t) {
                            return e.cancelIdleCallback(t);
                        }), this.requestsRaf.forEach(function(t) {
                            return e.cancelAnimationFrame(t);
                        }), this.timers.forEach(function(t) {
                            return (0, r.clearTimeout)(e.timers.get(t));
                        }), this.timers.clear(), this.promisesRejections.forEach(function(e) {
                            return e();
                        }), this.promisesRejections.clear();
                    }, e.prototype.destruct = function() {
                        this.clear(), this.isDestructed = !0;
                    }, e;
                }());
                t.Async = u;
            },
            22630: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(77536), t);
            },
            45113: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Component = void 0;
                var n = o(40332), r = o(17332), i = o(29411), a = o(22630), s = new Map, l = function() {
                    function e() {
                        this.async = new a.Async, this.ownerWindow = window, this.__componentStatus = i.STATUSES.beforeInit, this.uid = "jodit-uid-" + (0, r.uniqueUid)();
                    }
                    return Object.defineProperty(e.prototype, "componentName", {
                        get: function() {
                            return this.__componentName || (this.__componentName = "jodit-" + (0, n.kebabCase)(((0, n.isFunction)(this.className) ? this.className() : "") || (0, n.getClassName)(this))), this.__componentName;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.getFullElName = function(e, t, o) {
                        var r = [
                            this.componentName
                        ];
                        return e && (e = e.replace(/[^a-z0-9-]/gi, "-"), r.push("__".concat(e))), t && (r.push("_", t), r.push("_", (0, n.isVoid)(o) ? "true" : o.toString())), r.join("");
                    }, Object.defineProperty(e.prototype, "ownerDocument", {
                        get: function() {
                            return this.ow.document;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "od", {
                        get: function() {
                            return this.ownerDocument;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "ow", {
                        get: function() {
                            return this.ownerWindow;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.get = function(e, t) {
                        return (0, n.get)(e, t || this);
                    }, Object.defineProperty(e.prototype, "isReady", {
                        get: function() {
                            return this.componentStatus === i.STATUSES.ready;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "isDestructed", {
                        get: function() {
                            return this.componentStatus === i.STATUSES.destructed;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "isInDestruct", {
                        get: function() {
                            return i.STATUSES.beforeDestruct === this.componentStatus || i.STATUSES.destructed === this.componentStatus;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.bindDestruct = function(e) {
                        var t = this;
                        return e.hookStatus(i.STATUSES.beforeDestruct, function() {
                            return !t.isInDestruct && t.destruct();
                        }), this;
                    }, e.prototype.destruct = function() {
                        this.setStatus(i.STATUSES.destructed), this.async.destruct(), s.get(this) && s.delete(this);
                    }, Object.defineProperty(e.prototype, "componentStatus", {
                        get: function() {
                            return this.__componentStatus;
                        },
                        set: function(e) {
                            this.setStatus(e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.setStatus = function(e) {
                        return this.setStatusComponent(e, this);
                    }, e.prototype.setStatusComponent = function(e, t) {
                        if (e !== this.__componentStatus) {
                            t === this && (this.__componentStatus = e);
                            var o = Object.getPrototypeOf(this);
                            o && (0, n.isFunction)(o.setStatusComponent) && o.setStatusComponent(e, t);
                            var r = s.get(this), i = null == r ? void 0 : r[e];
                            i && i.length && i.forEach(function(e) {
                                return e(t);
                            });
                        }
                    }, e.prototype.hookStatus = function(e, t) {
                        var o = s.get(this);
                        o || s.set(this, o = {}), o[e] || (o[e] = []), o[e].push(t);
                    }, e.isInstanceOf = function(e, t) {
                        return e instanceof t;
                    }, e.STATUSES = i.STATUSES, e;
                }();
                t.Component = l;
            },
            56562: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(29411), t), n.__exportStar(o(45113), t), n.__exportStar(o(39840), t);
            },
            29411: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.STATUSES = void 0, t.STATUSES = {
                    beforeInit: "beforeInit",
                    ready: "ready",
                    beforeDestruct: "beforeDestruct",
                    destructed: "destructed"
                };
            },
            39840: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ViewComponent = void 0;
                var n = o(20255), r = function(e) {
                    function t(t) {
                        var o = e.call(this) || this;
                        return o.setParentView(t), o;
                    }
                    return n.__extends(t, e), Object.defineProperty(t.prototype, "j", {
                        get: function() {
                            return this.jodit;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "defaultTimeout", {
                        get: function() {
                            return this.j.defaultTimeout;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.i18n = function(e) {
                        for(var t, o = [], r = 1; arguments.length > r; r++)o[r - 1] = arguments[r];
                        return (t = this.j).i18n.apply(t, n.__spreadArray([
                            e
                        ], n.__read(o), !1));
                    }, t.prototype.setParentView = function(e) {
                        return this.jodit = e, e.components.add(this), this;
                    }, t.prototype.destruct = function() {
                        return this.j.components.delete(this), e.prototype.destruct.call(this);
                    }, t;
                }(o(45113).Component);
                t.ViewComponent = r;
            },
            86893: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.CLIPBOARD_ID = t.lang = t.TEMP_ATTR = t.BASE_PATH = t.KEY_ALIASES = t.IS_MAC = t.SAFE_COUNT_CHANGE_CALL = t.INSERT_ONLY_TEXT = t.INSERT_AS_TEXT = t.INSERT_CLEAR_HTML = t.INSERT_AS_HTML = t.EMULATE_DBLCLICK_TIMEOUT = t.MARKER_CLASS = t.TEXT_RTF = t.TEXT_HTML = t.TEXT_PLAIN = t.IS_IE = t.MODE_SPLIT = t.MODE_SOURCE = t.MODE_WYSIWYG = t.PARAGRAPH = t.BR = t.COMMAND_KEYS = t.ACCURACY = t.NEARBY = t.KEY_F3 = t.KEY_DELETE = t.KEY_SPACE = t.KEY_DOWN = t.KEY_RIGHT = t.KEY_UP = t.KEY_LEFT = t.KEY_ALT = t.KEY_ESC = t.KEY_ENTER = t.KEY_TAB = t.KEY_BACKSPACE = t.KEY_META = t.NO_EMPTY_TAGS = t.INSEPARABLE_TAGS = t.IS_INLINE = t.IS_BLOCK = t.SPACE_REG_EXP_END = t.SPACE_REG_EXP_START = t.SPACE_REG_EXP = t.INVISIBLE_SPACE_REG_EXP_START = t.INVISIBLE_SPACE_REG_EXP_END = t.INVISIBLE_SPACE_REG_EXP = t.NBSP_SPACE = t.INVISIBLE_SPACE = void 0, t.SOURCE_CONSUMER = void 0;
                var n = o(20255);
                t.INVISIBLE_SPACE = "\ufeff", t.NBSP_SPACE = "\xa0", t.INVISIBLE_SPACE_REG_EXP = function() {
                    return /[\uFEFF]/g;
                }, t.INVISIBLE_SPACE_REG_EXP_END = function() {
                    return /[\uFEFF]+$/g;
                }, t.INVISIBLE_SPACE_REG_EXP_START = function() {
                    return /^[\uFEFF]+/g;
                }, t.SPACE_REG_EXP = function() {
                    return /[\s\n\t\r\uFEFF\u200b]+/g;
                }, t.SPACE_REG_EXP_START = function() {
                    return /^[\s\n\t\r\uFEFF\u200b]+/g;
                }, t.SPACE_REG_EXP_END = function() {
                    return /[\s\n\t\r\uFEFF\u200b]+$/g;
                }, t.IS_BLOCK = /^(ADDRESS|ARTICLE|ASIDE|BLOCKQUOTE|CANVAS|DD|DFN|DIV|DL|DT|FIELDSET|FIGCAPTION|FIGURE|FOOTER|FORM|H[1-6]|HEADER|HGROUP|HR|LI|MAIN|NAV|NOSCRIPT|OUTPUT|P|PRE|RUBY|SCRIPT|STYLE|OBJECT|OL|SECTION|IFRAME|JODIT|JODIT-MEDIA|UL|TR|TD|TH|TBODY|THEAD|TFOOT|TABLE|BODY|HTML|VIDEO)$/i, t.IS_INLINE = /^(STRONG|SPAN|I|EM|B|SUP|SUB|A|U)$/i;
                var r = [
                    "img",
                    "video",
                    "svg",
                    "iframe",
                    "script",
                    "input",
                    "textarea",
                    "link",
                    "jodit",
                    "jodit-media"
                ];
                t.INSEPARABLE_TAGS = new Set(n.__spreadArray(n.__spreadArray([], n.__read(r), !1), [
                    "br",
                    "hr"
                ], !1)), t.NO_EMPTY_TAGS = new Set(r), t.KEY_META = "Meta", t.KEY_BACKSPACE = "Backspace", t.KEY_TAB = "Tab", t.KEY_ENTER = "Enter", t.KEY_ESC = "Escape", t.KEY_ALT = "Alt", t.KEY_LEFT = "ArrowLeft", t.KEY_UP = "ArrowUp", t.KEY_RIGHT = "ArrowRight", t.KEY_DOWN = "ArrowDown", t.KEY_SPACE = "Space", t.KEY_DELETE = "Delete", t.KEY_F3 = "F3", t.NEARBY = 5, t.ACCURACY = 10, t.COMMAND_KEYS = [
                    t.KEY_META,
                    t.KEY_BACKSPACE,
                    t.KEY_DELETE,
                    t.KEY_UP,
                    t.KEY_DOWN,
                    t.KEY_RIGHT,
                    t.KEY_LEFT,
                    t.KEY_ENTER,
                    t.KEY_ESC,
                    t.KEY_F3,
                    t.KEY_TAB
                ], t.BR = "br", t.PARAGRAPH = "p", t.MODE_WYSIWYG = 1, t.MODE_SOURCE = 2, t.MODE_SPLIT = 3, t.IS_IE = "undefined" != typeof navigator && (-1 !== navigator.userAgent.indexOf("MSIE") || /rv:11.0/i.test(navigator.userAgent)), t.TEXT_PLAIN = t.IS_IE ? "text" : "text/plain", t.TEXT_HTML = t.IS_IE ? "html" : "text/html", t.TEXT_RTF = t.IS_IE ? "rtf" : "text/rtf", t.MARKER_CLASS = "jodit-selection_marker", t.EMULATE_DBLCLICK_TIMEOUT = 300, t.INSERT_AS_HTML = "insert_as_html", t.INSERT_CLEAR_HTML = "insert_clear_html", t.INSERT_AS_TEXT = "insert_as_text", t.INSERT_ONLY_TEXT = "insert_only_text", t.SAFE_COUNT_CHANGE_CALL = 10, t.IS_MAC = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), t.KEY_ALIASES = {
                    add: "+",
                    break: "pause",
                    cmd: "meta",
                    command: "meta",
                    ctl: "control",
                    ctrl: "control",
                    del: "delete",
                    down: "arrowdown",
                    esc: "escape",
                    ins: "insert",
                    left: "arrowleft",
                    mod: t.IS_MAC ? "meta" : "control",
                    opt: "alt",
                    option: "alt",
                    return: "enter",
                    right: "arrowright",
                    space: " ",
                    spacebar: " ",
                    up: "arrowup",
                    win: "meta",
                    windows: "meta"
                }, t.BASE_PATH = function() {
                    if ("undefined" == typeof document) return "";
                    var e = document.currentScript, t = function(e) {
                        var t = e.split("/");
                        return /\.js/.test(t[t.length - 1]) ? t.slice(0, t.length - 1).join("/") + "/" : e;
                    };
                    if (e) return t(e.src);
                    var o = document.querySelectorAll("script[src]");
                    return o && o.length ? t(o[o.length - 1].src) : window.location.href;
                }(), t.TEMP_ATTR = "data-jodit-temp", t.lang = {}, t.CLIPBOARD_ID = "clipboard", t.SOURCE_CONSUMER = "source-consumer";
            },
            31897: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Create = void 0;
                var n = o(40332), r = (o(52378), o(64968)), i = o(86893), a = function() {
                    function e(e, t) {
                        this.document = e, this.createAttributes = t;
                    }
                    return Object.defineProperty(e.prototype, "doc", {
                        get: function() {
                            return (0, n.isFunction)(this.document) ? this.document() : this.document;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.element = function(e, t, o) {
                        var r = this, i = this.doc.createElement(e.toLowerCase());
                        return this.applyCreateAttributes(i), t && ((0, n.isPlainObject)(t) ? (0, n.attr)(i, t) : o = t), o && (0, n.asArray)(o).forEach(function(e) {
                            return i.appendChild((0, n.isString)(e) ? r.fromHTML(e) : e);
                        }), i;
                    }, e.prototype.div = function(e, t, o) {
                        var n = this.element("div", t, o);
                        return e && (n.className = e), n;
                    }, e.prototype.sandbox = function() {
                        var e, t = this.element("iframe", {
                            sandbox: "allow-same-origin"
                        });
                        this.doc.body.appendChild(t);
                        var o = null === (e = t.contentWindow) || void 0 === e ? void 0 : e.document;
                        if (!o) throw Error("Iframe error");
                        return o.open(), o.write("<!DOCTYPE html><html><head></head><body></body></html>"), o.close(), o.body;
                    }, e.prototype.span = function(e, t, o) {
                        var n = this.element("span", t, o);
                        return e && (n.className = e), n;
                    }, e.prototype.a = function(e, t, o) {
                        var n = this.element("a", t, o);
                        return e && (n.className = e), n;
                    }, e.prototype.text = function(e) {
                        return this.doc.createTextNode(e);
                    }, e.prototype.fake = function() {
                        return this.text(i.INVISIBLE_SPACE);
                    }, e.prototype.fragment = function() {
                        return this.doc.createDocumentFragment();
                    }, e.prototype.fromHTML = function(e, t) {
                        var o = this.div();
                        o.innerHTML = e.toString();
                        var i = o.firstChild === o.lastChild && o.firstChild ? o.firstChild : o;
                        if (r.Dom.safeRemove(i), t) {
                            var a = (0, n.refs)(i);
                            Object.keys(t).forEach(function(e) {
                                var o = a[e];
                                o && !1 === t[e] && r.Dom.hide(o);
                            });
                        }
                        return i;
                    }, e.prototype.applyCreateAttributes = function(e) {
                        if (this.createAttributes) {
                            var t = this.createAttributes;
                            if (t && t[e.tagName.toLowerCase()]) {
                                var o = t[e.tagName.toLowerCase()];
                                (0, n.isFunction)(o) ? o(e) : (0, n.isPlainObject)(o) && (0, n.attr)(e, o);
                            }
                        }
                    }, e;
                }();
                t.Create = a;
            },
            42841: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(31897), t);
            },
            32358: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.cache = void 0;
                var n = o(40332);
                t.cache = function(e, t, o) {
                    var r = o.get;
                    if (!r) throw (0, n.error)("Getter property descriptor expected");
                    o.get = function() {
                        var e = r.call(this);
                        return e && !0 === e.noCache || Object.defineProperty(this, t, {
                            configurable: o.configurable,
                            enumerable: o.enumerable,
                            writable: !1,
                            value: e
                        }), e;
                    };
                };
            },
            11441: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.component = void 0;
                var n = o(20255);
                t.component = function(e) {
                    var t = function(e) {
                        function t() {
                            for(var o = [], r = 0; arguments.length > r; r++)o[r] = arguments[r];
                            var i = e.apply(this, n.__spreadArray([], n.__read(o), !1)) || this, a = i.constructor === t;
                            return a && (i instanceof t || Object.setPrototypeOf(i, t.prototype), i.setStatus("ready")), i;
                        }
                        return n.__extends(t, e), t;
                    }(e);
                    return t;
                };
            },
            55773: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.throttle = t.debounce = void 0;
                var n = o(10172), r = o(56562), i = o(56964);
                function a(e, t, o) {
                    return void 0 === t && (t = !1), void 0 === o && (o = "debounce"), function(a, s) {
                        var l = a[s];
                        if (!(0, n.isFunction)(l)) throw (0, i.error)("Handler must be a Function");
                        return a.hookStatus(r.STATUSES.ready, function(r) {
                            var i = r.async, a = (0, n.isFunction)(e) ? e(r) : e;
                            Object.defineProperty(r, s, {
                                configurable: !0,
                                value: i[o](r[s].bind(r), (0, n.isNumber)(a) || (0, n.isPlainObject)(a) ? a : r.defaultTimeout, t)
                            });
                        }), {
                            configurable: !0,
                            get: function() {
                                return l.bind(this);
                            }
                        };
                    };
                }
                o(52378), t.debounce = a, t.throttle = function(e, t) {
                    return void 0 === t && (t = !1), a(e, t, "throttle");
                };
            },
            70669: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.derive = void 0;
                var n = o(20255), r = o(10172);
                t.derive = function() {
                    for(var e = [], t = 0; arguments.length > t; t++)e[t] = arguments[t];
                    return function(t) {
                        for(var o = t.prototype, i = 0; e.length > i; i++)for(var a = e[i], s = Object.getOwnPropertyNames(a.prototype), l = function(e) {
                            var t = s[e], i = Object.getOwnPropertyDescriptor(a.prototype, t);
                            null != i && (0, r.isFunction)(i.value) && !(0, r.isFunction)(o[t]) && Object.defineProperty(o, t, {
                                enumerable: !0,
                                configurable: !0,
                                writable: !0,
                                value: function() {
                                    for(var e, t = [], o = 0; arguments.length > o; o++)t[o] = arguments[o];
                                    return (e = i.value).call.apply(e, n.__spreadArray([
                                        this
                                    ], n.__read(t), !1));
                                }
                            });
                        }, c = 0; s.length > c; c++)l(c);
                    };
                };
            },
            64522: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hook = void 0;
                var n = o(10172), r = o(56964);
                t.hook = function(e) {
                    return function(t, o) {
                        if (!(0, n.isFunction)(t[o])) throw (0, r.error)("Handler must be a Function");
                        t.hookStatus(e, function(e) {
                            e[o].call(e);
                        });
                    };
                };
            },
            58682: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.idle = void 0;
                var n = o(20255), r = o(56562), i = o(40332);
                t.idle = function() {
                    return function(e, t) {
                        if (!(0, i.isFunction)(e[t])) throw (0, i.error)("Handler must be a Function");
                        e.hookStatus(r.STATUSES.ready, function(e) {
                            var o = e.async, r = e[t];
                            e[t] = function() {
                                for(var t = [], i = 0; arguments.length > i; i++)t[i] = arguments[i];
                                return o.requestIdleCallback(r.bind.apply(r, n.__spreadArray([
                                    e
                                ], n.__read(t), !1)));
                            };
                        });
                    };
                };
            },
            43441: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.autobind = void 0;
                var n = o(20255);
                n.__exportStar(o(32358), t), n.__exportStar(o(11441), t), n.__exportStar(o(55773), t), n.__exportStar(o(58682), t), n.__exportStar(o(64522), t), n.__exportStar(o(91627), t), n.__exportStar(o(31418), t), n.__exportStar(o(67587), t), n.__exportStar(o(46163), t), n.__exportStar(o(70669), t);
                var r = o(70631);
                Object.defineProperty(t, "autobind", {
                    enumerable: !0,
                    get: function() {
                        return r.default;
                    }
                });
            },
            91627: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.nonenumerable = void 0, t.nonenumerable = function(e, t) {
                    !1 !== (Object.getOwnPropertyDescriptor(e, t) || {}).enumerable && Object.defineProperty(e, t, {
                        enumerable: !1,
                        set: function(e) {
                            Object.defineProperty(this, t, {
                                enumerable: !1,
                                writable: !0,
                                value: e
                            });
                        }
                    });
                };
            },
            31418: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.persistent = void 0;
                var n = o(56562), r = o(96574);
                t.persistent = function(e, t) {
                    e.hookStatus(n.STATUSES.ready, function(e) {
                        var o = (0, r.isViewObject)(e) ? e : e.jodit, n = "".concat(o.options.namespace).concat(e.componentName, "_prop_").concat(t), i = e[t];
                        Object.defineProperty(e, t, {
                            get: function() {
                                var e;
                                return null !== (e = o.storage.get(n)) && void 0 !== e ? e : i;
                            },
                            set: function(e) {
                                o.storage.set(n, e);
                            }
                        });
                    });
                };
            },
            67587: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wait = void 0;
                var n = o(20255), r = o(40332), i = o(56562);
                t.wait = function(e) {
                    return function(t, o) {
                        if (!(0, r.isFunction)(t[o])) throw (0, r.error)("Handler must be a Function");
                        t.hookStatus(i.STATUSES.ready, function(t) {
                            var r = t.async, i = t[o], a = 0;
                            Object.defineProperty(t, o, {
                                configurable: !0,
                                value: function o() {
                                    for(var s = [], l = 0; arguments.length > l; l++)s[l] = arguments[l];
                                    r.clearTimeout(a), e(t) ? i.apply(t, s) : a = r.setTimeout(function() {
                                        return o.apply(void 0, n.__spreadArray([], n.__read(s), !1));
                                    }, 10);
                                }
                            });
                        });
                    };
                };
            },
            46163: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.watch = t.getPropertyDescriptor = void 0;
                var n = o(20255), r = o(42096), i = o(79736), a = o(96574), s = o(88418), l = o(29411), c = o(14556), u = o(56964);
                function d(e, t) {
                    var o;
                    do o = Object.getOwnPropertyDescriptor(e, t), e = Object.getPrototypeOf(e);
                    while (!o && e);
                    return o;
                }
                function p(e, t) {
                    return function(o, p) {
                        if (!(0, r.isFunction)(o[p])) throw (0, u.error)("Handler must be a Function");
                        var f = function(l) {
                            var u = function(e) {
                                for(var t, o = [], r = 1; arguments.length > r; r++)o[r - 1] = arguments[r];
                                if (!l.isInDestruct) return (t = l)[p].apply(t, n.__spreadArray([
                                    e
                                ], n.__read(o), !1));
                            };
                            (0, c.splitArray)(e).forEach(function(e) {
                                if (/:/.test(e)) {
                                    var c = n.__read(e.split(":"), 2), p = c[0], f = c[1], h = t, m = (0, a.isViewObject)(l) ? l : l.jodit;
                                    return p.length && (h = l.get(p)), (0, r.isFunction)(h) && (h = h(l)), m.events.on(h || l, f, u), h || m.events.on(f, u), void l.hookStatus("beforeDestruct", function() {
                                        m.events.off(h || l, f, u).off(f, u);
                                    });
                                }
                                var v = e.split("."), g = n.__read(v, 1)[0], y = v.slice(1), _ = l[g];
                                (0, i.isPlainObject)(_) && (0, s.observable)(_).on("change.".concat(y.join(".")), u);
                                var b = d(o, g);
                                Object.defineProperty(l, g, {
                                    configurable: !0,
                                    set: function(e) {
                                        var t = _;
                                        t !== e && (_ = e, b && b.set && b.set.call(l, e), (0, i.isPlainObject)(_) && (_ = (0, s.observable)(_)).on("change.".concat(y.join(".")), u), u(g, t, _));
                                    },
                                    get: function() {
                                        return b && b.get ? b.get.call(l) : _;
                                    }
                                });
                            });
                        };
                        (0, r.isFunction)(o.hookStatus) ? o.hookStatus(l.STATUSES.ready, f) : f(o);
                    };
                }
                t.getPropertyDescriptor = d, t.watch = p, t.default = p;
            },
            24263: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Dom = void 0;
                var n = o(20255), r = o(86893), i = o(10172), a = o(12557), s = o(19035), l = o(76502), c = o(37204), u = o(86893), d = function() {
                    function e() {}
                    return e.detach = function(e) {
                        for(; e.firstChild;)e.removeChild(e.firstChild);
                    }, e.wrapInline = function(t, o, n) {
                        var r, a = t, s = t;
                        n.s.save();
                        var l = !1;
                        do l = !1, (r = a.previousSibling) && !e.isBlock(r) && (l = !0, a = r);
                        while (l);
                        do l = !1, (r = s.nextSibling) && !e.isBlock(r) && (l = !0, s = r);
                        while (l);
                        var c = (0, i.isString)(o) ? n.createInside.element(o) : o;
                        a.parentNode && a.parentNode.insertBefore(c, a);
                        for(var u = a; u && (u = a.nextSibling, c.appendChild(a), a !== s && u);)a = u;
                        return n.s.restore(), c;
                    }, e.wrap = function(t, o, n) {
                        var r = (0, i.isString)(o) ? n.element(o) : o;
                        if (e.isNode(t)) {
                            if (!t.parentNode) throw (0, l.error)("Element should be in DOM");
                            t.parentNode.insertBefore(r, t), r.appendChild(t);
                        } else {
                            var a = t.extractContents();
                            t.insertNode(r), r.appendChild(a);
                        }
                        return r;
                    }, e.unwrap = function(t) {
                        var o = t.parentNode;
                        if (o) {
                            for(; t.firstChild;)o.insertBefore(t.firstChild, t);
                            e.safeRemove(t);
                        }
                    }, e.between = function(e, t, o) {
                        for(var n = e; n && n !== t && (e === n || !o(n));){
                            var r = n.firstChild || n.nextSibling;
                            if (!r) {
                                for(; n && !n.nextSibling;)n = n.parentNode;
                                r = null == n ? void 0 : n.nextSibling;
                            }
                            n = r;
                        }
                    }, e.replace = function(t, o, n, r, s) {
                        void 0 === r && (r = !1), void 0 === s && (s = !1), (0, i.isHTML)(o) && (o = n.fromHTML(o));
                        var l = (0, i.isString)(o) ? n.element(o) : o;
                        if (!s) for(; t.firstChild;)l.appendChild(t.firstChild);
                        return r && e.isElement(t) && e.isElement(l) && (0, a.toArray)(t.attributes).forEach(function(e) {
                            l.setAttribute(e.name, e.value);
                        }), t.parentNode && t.parentNode.replaceChild(l, t), l;
                    }, e.isEmptyTextNode = function(t) {
                        return e.isText(t) && (!t.nodeValue || 0 === t.nodeValue.replace(r.INVISIBLE_SPACE_REG_EXP(), "").trim().length);
                    }, e.isEmptyContent = function(t) {
                        return e.each(t, function(t) {
                            return e.isEmptyTextNode(t);
                        });
                    }, e.isContentEditable = function(t, o) {
                        return e.isNode(t) && !e.closest(t, function(t) {
                            return e.isElement(t) && "false" === t.getAttribute("contenteditable");
                        }, o);
                    }, e.isEmpty = function(t, o) {
                        if (void 0 === o && (o = u.NO_EMPTY_TAGS), !t) return !0;
                        var n;
                        n = (0, i.isFunction)(o) ? o : function(e) {
                            return o.has(e.nodeName.toLowerCase());
                        };
                        var r = function(e) {
                            return null == e.nodeValue || 0 === (0, s.trim)(e.nodeValue).length;
                        };
                        return e.isText(t) ? r(t) : !(e.isElement(t) && n(t)) && e.each(t, function(t) {
                            if (e.isText(t) && !r(t) || e.isElement(t) && n(t)) return !1;
                        });
                    }, e.isNode = function(e) {
                        return Boolean(e && (0, i.isString)(e.nodeName) && "number" == typeof e.nodeType && e.childNodes && (0, i.isFunction)(e.appendChild));
                    }, e.isCell = function(t) {
                        return e.isNode(t) && /^(td|th)$/i.test(t.nodeName);
                    }, e.isImage = function(t) {
                        return e.isNode(t) && /^(img|svg|picture|canvas)$/i.test(t.nodeName);
                    }, e.isBlock = function(t) {
                        return !(0, i.isVoid)(t) && "object" == typeof t && e.isNode(t) && r.IS_BLOCK.test(t.nodeName);
                    }, e.isText = function(e) {
                        return Boolean(e && e.nodeType === Node.TEXT_NODE);
                    }, e.isElement = function(t) {
                        var o;
                        if (!e.isNode(t)) return !1;
                        var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                        return Boolean(n && t.nodeType === Node.ELEMENT_NODE);
                    }, e.isFragment = function(t) {
                        var o;
                        if (!e.isNode(t)) return !1;
                        var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                        return Boolean(n && t.nodeType === Node.DOCUMENT_FRAGMENT_NODE);
                    }, e.isHTMLElement = function(t) {
                        var o;
                        if (!e.isNode(t)) return !1;
                        var n = null === (o = t.ownerDocument) || void 0 === o ? void 0 : o.defaultView;
                        return Boolean(n && t instanceof n.HTMLElement);
                    }, e.isInlineBlock = function(t) {
                        return e.isElement(t) && !/^(BR|HR)$/i.test(t.tagName) && -1 !== [
                            "inline",
                            "inline-block"
                        ].indexOf((0, l.css)(t, "display").toString());
                    }, e.canSplitBlock = function(t) {
                        return !(0, i.isVoid)(t) && e.isHTMLElement(t) && e.isBlock(t) && !/^(TD|TH|CAPTION|FORM)$/.test(t.nodeName) && void 0 !== t.style && !/^(fixed|absolute)/i.test(t.style.position);
                    }, e.last = function(e, t) {
                        var o = null == e ? void 0 : e.lastChild;
                        if (!o) return null;
                        do {
                            if (t(o)) return o;
                            var n = o.lastChild;
                            if (n || (n = o.previousSibling), !n && o.parentNode !== e) {
                                do o = o.parentNode;
                                while (o && !(null == o ? void 0 : o.previousSibling) && o.parentNode !== e);
                                n = null == o ? void 0 : o.previousSibling;
                            }
                            o = n;
                        }while (o);
                        return null;
                    }, e.prev = function(t, o, n, r) {
                        return void 0 === r && (r = !0), e.find(t, o, n, !1, r);
                    }, e.next = function(t, o, n, r) {
                        return void 0 === r && (r = !0), e.find(t, o, n, !0, r);
                    }, e.prevWithClass = function(t, o) {
                        return e.prev(t, function(t) {
                            return e.isElement(t) && t.classList.contains(o);
                        }, t.parentNode);
                    }, e.nextWithClass = function(t, o) {
                        return e.next(t, function(t) {
                            return e.isElement(t) && t.classList.contains(o);
                        }, t.parentNode);
                    }, e.find = function(e, t, o, n, r) {
                        void 0 === n && (n = !0), void 0 === r && (r = !0);
                        for(var i = this.nextGen(e, o, n, r), a = i.next(); !a.done;){
                            if (t(a.value)) return a.value;
                            a = i.next();
                        }
                        return null;
                    }, e.nextGen = function(e, t, o, r) {
                        var i, a, s;
                        return void 0 === o && (o = !0), void 0 === r && (r = !0), n.__generator(this, function(l) {
                            switch(l.label){
                                case 0:
                                    i = [], a = e, l.label = 1;
                                case 1:
                                    for(s = o ? a.nextSibling : a.previousSibling; s;)i.unshift(s), s = o ? s.nextSibling : s.previousSibling;
                                    return [
                                        5,
                                        n.__values(this.runInStack(e, i, o, r))
                                    ];
                                case 2:
                                    l.sent(), a = a.parentNode, l.label = 3;
                                case 3:
                                    if (a && a !== t) return [
                                        3,
                                        1
                                    ];
                                    l.label = 4;
                                case 4:
                                    return [
                                        2,
                                        null
                                    ];
                            }
                        });
                    }, e.each = function(e, t, o) {
                        void 0 === o && (o = !0);
                        for(var n = this.eachGen(e, o), r = n.next(); !r.done;){
                            if (!1 === t(r.value)) return !1;
                            r = n.next();
                        }
                        return !0;
                    }, e.eachGen = function(e, t) {
                        return void 0 === t && (t = !0), this.runInStack(e, [
                            e
                        ], t);
                    }, e.runInStack = function(e, t, o, r) {
                        var i, a;
                        return void 0 === r && (r = !0), n.__generator(this, function(n) {
                            switch(n.label){
                                case 0:
                                    if (!t.length) return [
                                        3,
                                        3
                                    ];
                                    if (i = t.pop(), r) for(a = o ? i.lastChild : i.firstChild; a;)t.push(a), a = o ? a.previousSibling : a.nextSibling;
                                    return e === i ? [
                                        3,
                                        2
                                    ] : [
                                        4,
                                        i
                                    ];
                                case 1:
                                    n.sent(), n.label = 2;
                                case 2:
                                    return [
                                        3,
                                        0
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }, e.findWithCurrent = function(t, o, n, r, i) {
                        void 0 === r && (r = "nextSibling"), void 0 === i && (i = "firstChild");
                        var a = t;
                        do {
                            if (o(a)) return a || null;
                            if (i && a && a[i]) {
                                var s = e.findWithCurrent(a[i], o, a, r, i);
                                if (s) return s;
                            }
                            for(; a && !a[r] && a !== n;)a = a.parentNode;
                            a && a[r] && a !== n && (a = a[r]);
                        }while (a && a !== n);
                        return null;
                    }, e.findSibling = function(t, o, n) {
                        void 0 === o && (o = !0), void 0 === n && (n = function(t) {
                            return !e.isEmptyTextNode(t);
                        });
                        for(var r = e.sibling(t, o); r && !n(r);)r = e.sibling(r, o);
                        return r && n(r) ? r : null;
                    }, e.findNotEmptySibling = function(t, o) {
                        return e.findSibling(t, o, function(t) {
                            var o;
                            return !e.isEmptyTextNode(t) && Boolean(!e.isText(t) || (null === (o = t.nodeValue) || void 0 === o ? void 0 : o.length) && (0, s.trim)(t.nodeValue));
                        });
                    }, e.findNotEmptyNeighbor = function(t, o, n) {
                        return (0, l.call)(o ? e.prev : e.next, t, function(t) {
                            return Boolean(t && (!e.isText(t) || (0, s.trim)((null == t ? void 0 : t.nodeValue) || "").length));
                        }, n);
                    }, e.sibling = function(e, t) {
                        return t ? e.previousSibling : e.nextSibling;
                    }, e.up = function(e, t, o, n) {
                        void 0 === n && (n = !1);
                        var r = e;
                        if (!r) return null;
                        do {
                            if (t(r)) return r;
                            if (r === o || !r.parentNode) break;
                            r = r.parentNode;
                        }while (r && r !== o);
                        return r === o && n && t(r) ? r : null;
                    }, e.closest = function(t, o, n) {
                        var r, a = function(e) {
                            return e.toLowerCase();
                        };
                        if ((0, i.isFunction)(o)) r = o;
                        else if ((0, i.isArray)(o)) {
                            var s = new Set(o.map(a));
                            r = function(e) {
                                return Boolean(e && s.has(a(e.nodeName)));
                            };
                        } else r = function(e) {
                            return Boolean(e && a(o) === a(e.nodeName));
                        };
                        return e.up(t, r, n);
                    }, e.furthest = function(e, t, o) {
                        for(var n = null, r = null == e ? void 0 : e.parentElement; r && r !== o;)t(r) && (n = r), r = null == r ? void 0 : r.parentElement;
                        return n;
                    }, e.appendChildFirst = function(e, t) {
                        var o = e.firstChild;
                        o ? o !== t && e.insertBefore(t, o) : e.appendChild(t);
                    }, e.after = function(e, t) {
                        var o = e.parentNode;
                        o && (o.lastChild === e ? o.appendChild(t) : o.insertBefore(t, e.nextSibling));
                    }, e.before = function(e, t) {
                        var o = e.parentNode;
                        o && o.insertBefore(t, e);
                    }, e.prepend = function(e, t) {
                        e.insertBefore(t, e.firstChild);
                    }, e.append = function(e, t) {
                        var o = this;
                        (0, i.isArray)(t) ? t.forEach(function(t) {
                            o.append(e, t);
                        }) : e.appendChild(t);
                    }, e.moveContent = function(t, o, n, r) {
                        void 0 === n && (n = !1), void 0 === r && (r = function() {
                            return !0;
                        });
                        var i = (t.ownerDocument || document).createDocumentFragment();
                        (0, a.toArray)(t.childNodes).filter(function(t) {
                            return !!r(t) || (e.safeRemove(t), !1);
                        }).forEach(function(e) {
                            i.appendChild(e);
                        }), n && o.firstChild ? o.insertBefore(i, o.firstChild) : o.appendChild(i);
                    }, e.isOrContains = function(e, t, o) {
                        return void 0 === o && (o = !1), e === t ? !o : Boolean(t && e && this.up(t, function(t) {
                            return t === e;
                        }, e, !0));
                    }, e.safeRemove = function() {
                        for(var t = [], o = 0; arguments.length > o; o++)t[o] = arguments[o];
                        t.forEach(function(t) {
                            return e.isNode(t) && t.parentNode && t.parentNode.removeChild(t);
                        });
                    }, e.safeInsertNode = function(t, o) {
                        t.collapsed || t.deleteContents(), t.insertNode(o), t.setStartBefore(o), t.collapse(!0), [
                            o.nextSibling,
                            o.previousSibling
                        ].forEach(function(t) {
                            return e.isText(t) && !t.nodeValue && e.safeRemove(t);
                        });
                    }, e.hide = function(e) {
                        e && ((0, l.dataBind)(e, "__old_display", e.style.display), e.style.display = "none");
                    }, e.show = function(e) {
                        if (e) {
                            var t = (0, l.dataBind)(e, "__old_display");
                            "none" === e.style.display && (e.style.display = t || "");
                        }
                    }, e.isTag = function(e, t) {
                        if (!this.isElement(e)) return !1;
                        var o = e.tagName.toLowerCase(), n = e.tagName.toUpperCase();
                        if (t instanceof Set) return t.has(o) || t.has(n);
                        for(var r = (0, a.asArray)(t).map(function(e) {
                            return String(e).toLowerCase();
                        }), i = 0; r.length > i; i += 1)if (o === r[i] || n === r[i]) return !0;
                        return !1;
                    }, e.markTemporary = function(e, t) {
                        return t && (0, l.attr)(e, t), (0, l.attr)(e, u.TEMP_ATTR, !0), e;
                    }, e.isTemporary = function(t) {
                        return !!e.isElement(t) && ((0, c.isMarker)(t) || "true" === (0, l.attr)(t, u.TEMP_ATTR));
                    }, e.replaceTemporaryFromString = function(e) {
                        return e.replace(/<([a-z]+)[^>]+data-jodit-temp[^>]+>(.+?)<\/\1>/gi, "$2");
                    }, e.temporaryList = function(e) {
                        return (0, l.$$)("[".concat(u.TEMP_ATTR, "]"), e);
                    }, e;
                }();
                t.Dom = d;
            },
            64968: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(24263), t), n.__exportStar(o(33841), t);
            },
            33841: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LazyWalker = void 0;
                var n = o(20255), r = o(73852), i = o(43441), a = o(24263), s = function(e) {
                    function t(t, o) {
                        void 0 === o && (o = {});
                        var n = e.call(this) || this;
                        return n.async = t, n.options = o, n.workNodes = null, n.hadAffect = !1, n.isWorked = !1, n.isFinished = !1, n.idleId = 0, n;
                    }
                    return n.__extends(t, e), t.prototype.setWork = function(e) {
                        return this.isWorked && this.break(), this.workNodes = a.Dom.eachGen(e, !this.options.reverse), this.isFinished = !1, this.startIdleRequest(), this;
                    }, t.prototype.startIdleRequest = function() {
                        var e;
                        this.idleId = this.async.requestIdleCallback(this.workPerform, {
                            timeout: null !== (e = this.options.timeout) && void 0 !== e ? e : 10
                        });
                    }, t.prototype.break = function(e) {
                        this.isWorked && (this.stop(), this.emit("break", e));
                    }, t.prototype.end = function() {
                        this.isWorked && (this.stop(), this.emit("end", this.hadAffect), this.hadAffect = !1);
                    }, t.prototype.stop = function() {
                        this.isWorked = !1, this.isFinished = !0, this.workNodes = null, this.async.cancelIdleCallback(this.idleId);
                    }, t.prototype.destruct = function() {
                        e.prototype.destruct.call(this), this.stop();
                    }, t.prototype.workPerform = function(e) {
                        var t;
                        if (this.workNodes) {
                            this.isWorked = !0;
                            for(var o = 0, n = null !== (t = this.options.timeoutChunkSize) && void 0 !== t ? t : 50; !this.isFinished && (e.timeRemaining() > 0 || e.didTimeout && n >= o);){
                                var r = this.workNodes.next();
                                if (o += 1, this.visitNode(r.value) && (this.hadAffect = !0), r.done) return void this.end();
                            }
                        } else this.end();
                        this.isFinished || this.startIdleRequest();
                    }, t.prototype.visitNode = function(e) {
                        var t;
                        return !(!e || void 0 !== this.options.whatToShow && e.nodeType !== this.options.whatToShow) && null !== (t = this.emit("visit", e)) && void 0 !== t && t;
                    }, n.__decorate([
                        i.autobind
                    ], t.prototype, "workPerform", null), t;
                }(r.Eventify);
                t.LazyWalker = s;
            },
            3808: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventEmitter = void 0;
                var n = o(20255), r = o(83611), i = o(24421), a = o(42096), s = o(49781), l = o(56964), c = o(14556), u = function() {
                    function e(e) {
                        var t = this;
                        this.__mutedEvents = new Set, this.__key = "__JoditEventEmitterNamespaces", this.__doc = document, this.__prepareEvent = function(e) {
                            e.cancelBubble || (e.composed && (0, a.isFunction)(e.composedPath) && e.composedPath()[0] && Object.defineProperty(e, "target", {
                                value: e.composedPath()[0],
                                configurable: !0,
                                enumerable: !0
                            }), e.type.match(/^touch/) && e.changedTouches && e.changedTouches.length && [
                                "clientX",
                                "clientY",
                                "pageX",
                                "pageY"
                            ].forEach(function(t) {
                                Object.defineProperty(e, t, {
                                    value: e.changedTouches[0][t],
                                    configurable: !0,
                                    enumerable: !0
                                });
                            }), e.originalEvent || (e.originalEvent = e), "paste" === e.type && void 0 === e.clipboardData && t.__doc.defaultView.clipboardData && Object.defineProperty(e, "clipboardData", {
                                get: function() {
                                    return t.__doc.defaultView.clipboardData;
                                },
                                configurable: !0,
                                enumerable: !0
                            }));
                        }, this.currents = [], this.__stopped = [], this.__isDestructed = !1, e && (this.__doc = e), this.__key += (new Date).getTime();
                    }
                    return e.prototype.mute = function(e) {
                        return this.__mutedEvents.add(null != e ? e : "*"), this;
                    }, e.prototype.isMuted = function(e) {
                        return !(!e || !this.__mutedEvents.has(e)) || this.__mutedEvents.has("*");
                    }, e.prototype.unmute = function(e) {
                        return this.__mutedEvents.delete(null != e ? e : "*"), this;
                    }, e.prototype.__eachEvent = function(e, t) {
                        var o = this;
                        (0, c.splitArray)(e).map(function(e) {
                            return e.trim();
                        }).forEach(function(e) {
                            var n = e.split(".");
                            t.call(o, n[0], n[1] || r.defaultNameSpace);
                        });
                    }, e.prototype.__getStore = function(e) {
                        if (!e) throw (0, l.error)("Need subject");
                        if (void 0 === e[this.__key]) {
                            var t = new r.EventHandlersStore;
                            Object.defineProperty(e, this.__key, {
                                enumerable: !1,
                                configurable: !0,
                                writable: !0,
                                value: t
                            });
                        }
                        return e[this.__key];
                    }, e.prototype.__removeStoreFromSubject = function(e) {
                        void 0 !== e[this.__key] && Object.defineProperty(e, this.__key, {
                            enumerable: !1,
                            configurable: !0,
                            writable: !0,
                            value: void 0
                        });
                    }, e.prototype.__triggerNativeEvent = function(e, t) {
                        var o = this.__doc.createEvent("HTMLEvents");
                        (0, i.isString)(t) ? o.initEvent(t, !0, !0) : (o.initEvent(t.type, t.bubbles, t.cancelable), [
                            "screenX",
                            "screenY",
                            "clientX",
                            "clientY",
                            "target",
                            "srcElement",
                            "currentTarget",
                            "timeStamp",
                            "which",
                            "keyCode"
                        ].forEach(function(e) {
                            Object.defineProperty(o, e, {
                                value: t[e],
                                enumerable: !0
                            });
                        }), Object.defineProperty(o, "originalEvent", {
                            value: t,
                            enumerable: !0
                        })), e.dispatchEvent(o);
                    }, Object.defineProperty(e.prototype, "current", {
                        get: function() {
                            return this.currents[this.currents.length - 1];
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.on = function(e, t, o, r) {
                        var c, u, d, p, f = this;
                        if ((0, i.isString)(e) || (0, i.isStringArray)(e) ? (c = this, u = e, d = t, p = o) : (c = e, u = t, d = o, p = r), !(0, i.isString)(u) && !(0, i.isStringArray)(u) || 0 === u.length) throw (0, l.error)("Need events names");
                        if (!(0, a.isFunction)(d)) throw (0, l.error)("Need event handler");
                        if ((0, s.isArray)(c)) return c.forEach(function(e) {
                            f.on(e, u, d, p);
                        }), this;
                        var h = c, m = this.__getStore(h), v = (0, a.isFunction)(h.addEventListener), g = this, y = function(e) {
                            for(var t = [], o = 1; arguments.length > o; o++)t[o - 1] = arguments[o];
                            if (!g.isMuted(e)) return d && d.call.apply(d, n.__spreadArray([
                                this
                            ], n.__read(t), !1));
                        };
                        return v && (y = function(e) {
                            if (!g.isMuted(e.type)) return g.__prepareEvent(e), d && !1 === d.call(this, e) ? (e.preventDefault(), e.stopImmediatePropagation(), !1) : void 0;
                        }), this.__eachEvent(u, function(e, t) {
                            if (0 === e.length) throw (0, l.error)("Need event name");
                            if (!1 === m.indexOf(e, t, d) && (m.set(e, t, {
                                event: e,
                                originalCallback: d,
                                syntheticCallback: y
                            }, null == p ? void 0 : p.top), v)) {
                                var o = !![
                                    "touchstart",
                                    "touchend",
                                    "scroll",
                                    "mousewheel",
                                    "mousemove",
                                    "touchmove"
                                ].includes(e) && {
                                    passive: !0
                                };
                                h.addEventListener(e, y, o);
                            }
                        }), this;
                    }, e.prototype.one = function(e, t, o, r) {
                        var a, s, l, c, u = this;
                        (0, i.isString)(e) || (0, i.isStringArray)(e) ? (a = this, s = e, l = t, c = o) : (a = e, s = t, l = o, c = r);
                        var d = function() {
                            for(var e = [], t = 0; arguments.length > t; t++)e[t] = arguments[t];
                            return u.off(a, s, d), l.apply(void 0, n.__spreadArray([], n.__read(e), !1));
                        };
                        return this.on(a, s, d, c), this;
                    }, e.prototype.off = function(e, t, o) {
                        var n, l, c, u = this;
                        if ((0, i.isString)(e) || (0, i.isStringArray)(e) ? (n = this, l = e, c = t) : (n = e, l = t, c = o), (0, s.isArray)(n)) return n.forEach(function(e) {
                            u.off(e, l, c);
                        }), this;
                        var d = n, p = this.__getStore(d);
                        if (!(0, i.isString)(l) && !(0, i.isStringArray)(l) || 0 === l.length) return p.namespaces().forEach(function(e) {
                            u.off(d, "." + e);
                        }), this.__removeStoreFromSubject(d), this;
                        var f = (0, a.isFunction)(d.removeEventListener), h = function(e) {
                            f && d.removeEventListener(e.event, e.syntheticCallback, !1);
                        }, m = function(e, t) {
                            if ("" !== e) {
                                var o = p.get(e, t);
                                if (o && o.length) {
                                    if ((0, a.isFunction)(c)) {
                                        var n = p.indexOf(e, t, c);
                                        !1 !== n && (h(o[n]), o.splice(n, 1), o.length || p.clearEvents(t, e));
                                    } else o.forEach(h), o.length = 0, p.clearEvents(t, e);
                                }
                            } else p.events(t).forEach(function(e) {
                                "" !== e && m(e, t);
                            });
                        };
                        return this.__eachEvent(l, function(e, t) {
                            t === r.defaultNameSpace ? p.namespaces().forEach(function(t) {
                                m(e, t);
                            }) : m(e, t);
                        }), p.isEmpty() && this.__removeStoreFromSubject(d), this;
                    }, e.prototype.stopPropagation = function(e, t) {
                        var o = this, n = (0, i.isString)(e) ? this : e, a = (0, i.isString)(e) ? e : t;
                        if ("string" != typeof a) throw (0, l.error)("Need event names");
                        var s = this.__getStore(n);
                        this.__eachEvent(a, function(e, t) {
                            var i = s.get(e, t);
                            i && o.__stopped.push(i), t === r.defaultNameSpace && s.namespaces(!0).forEach(function(t) {
                                return o.stopPropagation(n, e + "." + t);
                            });
                        });
                    }, e.prototype.__removeStop = function(e) {
                        if (e) {
                            var t = this.__stopped.indexOf(e);
                            -1 !== t && this.__stopped.splice(0, t + 1);
                        }
                    }, e.prototype.__isStopped = function(e) {
                        return void 0 !== e && -1 !== this.__stopped.indexOf(e);
                    }, e.prototype.fire = function(e, t) {
                        for(var o, s, c = this, u = [], d = 2; arguments.length > d; d++)u[d - 2] = arguments[d];
                        var p = (0, i.isString)(e) ? this : e, f = (0, i.isString)(e) ? e : t, h = (0, i.isString)(e) ? n.__spreadArray([
                            t
                        ], n.__read(u), !1) : u, m = (0, a.isFunction)(p.dispatchEvent);
                        if (!m && !(0, i.isString)(f)) throw (0, l.error)("Need events names");
                        var v = this.__getStore(p);
                        return !(0, i.isString)(f) && m ? this.__triggerNativeEvent(p, t) : this.__eachEvent(f, function(e, t) {
                            if (m) c.__triggerNativeEvent(p, e);
                            else {
                                var i = v.get(e, t);
                                if (i) try {
                                    n.__spreadArray([], n.__read(i), !1).every(function(t) {
                                        var r;
                                        return !c.__isStopped(i) && (c.currents.push(e), s = (r = t.syntheticCallback).call.apply(r, n.__spreadArray([
                                            p,
                                            e
                                        ], n.__read(h), !1)), c.currents.pop(), void 0 !== s && (o = s), !0);
                                    });
                                } finally{
                                    c.__removeStop(i);
                                }
                                t !== r.defaultNameSpace || m || v.namespaces().filter(function(e) {
                                    return e !== t;
                                }).forEach(function(t) {
                                    var r = c.fire.apply(c, n.__spreadArray([
                                        p,
                                        e + "." + t
                                    ], n.__read(h), !1));
                                    void 0 !== r && (o = r);
                                });
                            }
                        }), o;
                    }, e.prototype.destruct = function() {
                        this.__isDestructed && (this.__isDestructed = !0, this.off(this), this.__getStore(this).clear(), this.__removeStoreFromSubject(this));
                    }, e;
                }();
                t.EventEmitter = u;
            },
            73852: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Eventify = void 0;
                var n = o(20255), r = function() {
                    function e() {
                        this.__map = new Map;
                    }
                    return e.prototype.on = function(e, t) {
                        var o;
                        return this.__map.has(e) || this.__map.set(e, new Set), null === (o = this.__map.get(e)) || void 0 === o || o.add(t), this;
                    }, e.prototype.off = function(e, t) {
                        var o;
                        return this.__map.has(e) && (null === (o = this.__map.get(e)) || void 0 === o || o.delete(t)), this;
                    }, e.prototype.destruct = function() {
                        this.__map.clear();
                    }, e.prototype.emit = function(e) {
                        for(var t, o, r = [], i = 1; arguments.length > i; i++)r[i - 1] = arguments[i];
                        return this.__map.has(e) && (null === (t = this.__map.get(e)) || void 0 === t || t.forEach(function(e) {
                            o = e.apply(void 0, n.__spreadArray([], n.__read(r), !1));
                        })), o;
                    }, e;
                }();
                t.Eventify = r;
            },
            55395: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(3808), t), n.__exportStar(o(73852), t), n.__exportStar(o(88418), t), n.__exportStar(o(83611), t);
            },
            88418: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.observable = void 0;
                var n = o(20255), r = o(49781), i = o(32756), a = o(79736), s = o(46163), l = Symbol("observable-object");
                function c(e) {
                    return void 0 !== e[l];
                }
                t.observable = function(e) {
                    if (c(e)) return e;
                    var t = {}, o = {}, u = function(t, n) {
                        return (0, r.isArray)(t) ? (t.map(function(e) {
                            return u(e, n);
                        }), e) : (o[t] || (o[t] = []), o[t].push(n), e);
                    }, d = function(i) {
                        for(var a = [], s = 1; arguments.length > s; s++)a[s - 1] = arguments[s];
                        if ((0, r.isArray)(i)) i.map(function(e) {
                            return d.apply(void 0, n.__spreadArray([
                                e
                            ], n.__read(a), !1));
                        });
                        else try {
                            !t[i] && o[i] && (t[i] = !0, o[i].forEach(function(t) {
                                return t.call.apply(t, n.__spreadArray([
                                    e
                                ], n.__read(a), !1));
                            }));
                        } finally{
                            t[i] = !1;
                        }
                    }, p = function(t, o) {
                        void 0 === o && (o = []);
                        var r = {};
                        c(t) || (Object.defineProperty(t, l, {
                            enumerable: !1,
                            value: !0
                        }), Object.keys(t).forEach(function(l) {
                            var c = l, u = o.concat(c).filter(function(e) {
                                return e.length;
                            });
                            r[c] = t[c];
                            var f = (0, s.getPropertyDescriptor)(t, c);
                            Object.defineProperty(t, c, {
                                set: function(t) {
                                    var o = r[c];
                                    if (!(0, i.isFastEqual)(r[c], t)) {
                                        d([
                                            "beforeChange",
                                            "beforeChange.".concat(u.join("."))
                                        ], c, t), (0, a.isPlainObject)(t) && p(t, u), f && f.set ? f.set.call(e, t) : r[c] = t;
                                        var s = [];
                                        d(n.__spreadArray([
                                            "change"
                                        ], n.__read(u.reduce(function(e, t) {
                                            return s.push(t), e.push("change.".concat(s.join("."))), e;
                                        }, [])), !1), u.join("."), o, (null == t ? void 0 : t.valueOf) ? t.valueOf() : t);
                                    }
                                },
                                get: function() {
                                    return f && f.get ? f.get.call(e) : r[c];
                                },
                                enumerable: !0,
                                configurable: !0
                            }), (0, a.isPlainObject)(r[c]) && p(r[c], u);
                        }), Object.defineProperty(e, "on", {
                            value: u
                        }));
                    };
                    return p(e), e;
                };
            },
            83611: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventHandlersStore = t.defaultNameSpace = void 0, o(52378);
                var n = o(1853);
                t.defaultNameSpace = "JoditEventDefaultNamespace";
                var r = function() {
                    function e() {
                        this.__store = new Map;
                    }
                    return e.prototype.get = function(e, t) {
                        if (this.__store.has(t)) return this.__store.get(t)[e];
                    }, e.prototype.indexOf = function(e, t, o) {
                        var n = this.get(e, t);
                        if (n) {
                            for(var r = 0; n.length > r; r += 1)if (n[r].originalCallback === o) return r;
                        }
                        return !1;
                    }, e.prototype.namespaces = function(e) {
                        void 0 === e && (e = !1);
                        var o = (0, n.toArray)(this.__store.keys());
                        return e ? o.filter(function(e) {
                            return e !== t.defaultNameSpace;
                        }) : o;
                    }, e.prototype.events = function(e) {
                        var t = this.__store.get(e);
                        return t ? Object.keys(t) : [];
                    }, e.prototype.set = function(e, t, o, n) {
                        void 0 === n && (n = !1);
                        var r = this.__store.get(t);
                        r || this.__store.set(t, r = {}), void 0 === r[e] && (r[e] = []), n ? r[e].unshift(o) : r[e].push(o);
                    }, e.prototype.clear = function() {
                        this.__store.clear();
                    }, e.prototype.clearEvents = function(e, t) {
                        var o = this.__store.get(e);
                        o && o[t] && (delete o[t], Object.keys(o).length || this.__store.delete(e));
                    }, e.prototype.isEmpty = function() {
                        return 0 === this.__store.size;
                    }, e;
                }();
                t.EventHandlersStore = r;
            },
            17332: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.eventEmitter = t.getContainer = t.extendLang = t.modules = t.pluginSystem = t.uniqueUid = t.instances = void 0;
                var n = o(44540), r = o(64968), i = o(55395), a = o(77892), s = o(96574), l = o(87247), c = o(11278), u = o(86893);
                t.instances = {};
                var d = 1, p = new Set;
                t.uniqueUid = function() {
                    function e() {
                        return d += 10 * (Math.random() + 1), Math.round(d).toString(16);
                    }
                    for(var t = e(); p.has(t);)t = e();
                    return p.add(t), t;
                }, t.pluginSystem = new n.PluginSystem, t.modules = {}, t.extendLang = function(e) {
                    Object.keys(e).forEach(function(t) {
                        u.lang[t] ? Object.assign(u.lang[t], e[t]) : u.lang[t] = e[t];
                    });
                };
                var f = new WeakMap;
                t.getContainer = function(e, t, o, n) {
                    void 0 === o && (o = "div"), void 0 === n && (n = !1);
                    var i = t ? (0, l.getClassName)(t.prototype) : "jodit-utils", u = f.get(e) || {}, d = i + o, p = (0, s.isViewObject)(e) ? e : e.j;
                    if (!u[d]) {
                        var h = p.c, m = (0, a.isJoditObject)(e) && e.o.shadowRoot ? e.o.shadowRoot : e.od.body;
                        if (n && (0, a.isJoditObject)(e) && e.od !== e.ed) {
                            h = e.createInside;
                            var v = "style" === o ? e.ed.head : e.ed.body;
                            m = (0, a.isJoditObject)(e) && e.o.shadowRoot ? e.o.shadowRoot : v;
                        }
                        var g = h.element(o, {
                            className: "jodit jodit-".concat((0, c.kebabCase)(i), "-container jodit-box")
                        });
                        g.classList.add("jodit_theme_".concat(p.o.theme || "default")), m.appendChild(g), u[d] = g, e.hookStatus("beforeDestruct", function() {
                            r.Dom.safeRemove(g), delete u[d], Object.keys(u).length && f.delete(e);
                        }), f.set(e, u);
                    }
                    return u[d].classList.remove("jodit_theme_default", "jodit_theme_dark"), u[d].classList.add("jodit_theme_".concat(p.o.theme || "default")), u[d];
                }, t.eventEmitter = new i.EventEmitter;
            },
            34578: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.asArray = void 0;
                var n = o(49781);
                t.asArray = function(e) {
                    return (0, n.isArray)(e) ? e : [
                        e
                    ];
                };
            },
            12557: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toArray = t.splitArray = t.asArray = void 0;
                var n = o(34578);
                Object.defineProperty(t, "asArray", {
                    enumerable: !0,
                    get: function() {
                        return n.asArray;
                    }
                });
                var r = o(14556);
                Object.defineProperty(t, "splitArray", {
                    enumerable: !0,
                    get: function() {
                        return r.splitArray;
                    }
                });
                var i = o(1853);
                Object.defineProperty(t, "toArray", {
                    enumerable: !0,
                    get: function() {
                        return i.toArray;
                    }
                });
            },
            14556: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.splitArray = void 0, t.splitArray = function(e) {
                    return Array.isArray(e) ? e : e.split(/[,\s]+/);
                };
            },
            1853: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toArray = void 0;
                var n = o(80861), r = o(28069);
                t.toArray = function() {
                    for(var e, t = [], o = 0; arguments.length > o; o++)t[o] = arguments[o];
                    var i = (0, r.isNativeFunction)(Array.from) ? Array.from : null !== (e = (0, n.reset)("Array.from")) && void 0 !== e ? e : Array.from;
                    return i.apply(Array, t);
                };
            },
            4696: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(27512), t);
            },
            27512: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.clearTimeout = t.setTimeout = void 0;
                var n = o(20255);
                t.setTimeout = function(e, t) {
                    for(var o = [], r = 2; arguments.length > r; r++)o[r - 2] = arguments[r];
                    return t ? window.setTimeout.apply(window, n.__spreadArray([
                        e,
                        t
                    ], n.__read(o), !1)) : (e.call.apply(e, n.__spreadArray([
                        null
                    ], n.__read(o), !1)), 0);
                }, t.clearTimeout = function(e) {
                    window.clearTimeout(e);
                };
            },
            31553: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hasBrowserColorPicker = void 0, t.hasBrowserColorPicker = function() {
                    var e = !0;
                    try {
                        var t = document.createElement("input");
                        t.type = "color", t.value = "!", e = "color" === t.type && "!" !== t.value;
                    } catch (t) {
                        e = !1;
                    }
                    return e;
                };
            },
            10172: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(31553), t), n.__exportStar(o(49781), t), n.__exportStar(o(67749), t), n.__exportStar(o(32756), t), n.__exportStar(o(42096), t), n.__exportStar(o(66869), t), n.__exportStar(o(72543), t), n.__exportStar(o(33156), t), n.__exportStar(o(93578), t), n.__exportStar(o(77892), t), n.__exportStar(o(96574), t), n.__exportStar(o(60280), t), n.__exportStar(o(28069), t), n.__exportStar(o(61817), t), n.__exportStar(o(57649), t), n.__exportStar(o(79736), t), n.__exportStar(o(26335), t), n.__exportStar(o(24421), t), n.__exportStar(o(64350), t), n.__exportStar(o(19179), t), n.__exportStar(o(24021), t), n.__exportStar(o(85994), t), n.__exportStar(o(37204), t);
            },
            49781: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isArray = void 0, t.isArray = function(e) {
                    return Array.isArray(e);
                };
            },
            67749: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isBoolean = void 0, t.isBoolean = function(e) {
                    return "boolean" == typeof e;
                };
            },
            32756: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFastEqual = t.isEqual = void 0;
                var n = o(42554);
                t.isEqual = function(e, t) {
                    return e === t || (0, n.stringify)(e) === (0, n.stringify)(t);
                }, t.isFastEqual = function(e, t) {
                    return e === t;
                };
            },
            42096: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFunction = void 0, t.isFunction = function(e) {
                    return "function" == typeof e;
                };
            },
            72543: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isHtmlFromWord = void 0, t.isHtmlFromWord = function(e) {
                    return -1 !== e.search(/<meta.*?Microsoft Excel\s[\d].*?>/) || -1 !== e.search(/<meta.*?Microsoft Word\s[\d].*?>/) || -1 !== e.search(/style="[^"]*mso-/) && -1 !== e.search(/<font/);
                };
            },
            66869: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isHTML = void 0;
                var n = o(24421);
                t.isHTML = function(e) {
                    return (0, n.isString)(e) && /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/m.test(e.replace(/[\r\n]/g, ""));
                };
            },
            33156: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hasContainer = t.isDestructable = t.isInitable = void 0;
                var n = o(42096), r = o(24263), i = o(24021);
                t.isInitable = function(e) {
                    return !(0, i.isVoid)(e) && (0, n.isFunction)(e.init);
                }, t.isDestructable = function(e) {
                    return !(0, i.isVoid)(e) && (0, n.isFunction)(e.destruct);
                }, t.hasContainer = function(e) {
                    return !(0, i.isVoid)(e) && r.Dom.isElement(e.container);
                };
            },
            93578: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isInt = void 0;
                var n = o(57649), r = o(24421);
                t.isInt = function(e) {
                    return (0, r.isString)(e) && (0, n.isNumeric)(e) && (e = parseFloat(e)), "number" == typeof e && Number.isFinite(e) && !(e % 1);
                };
            },
            77892: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isJoditObject = void 0;
                var n = o(42096);
                t.isJoditObject = function(e) {
                    return Boolean(e && e instanceof Object && (0, n.isFunction)(e.constructor) && ("undefined" != typeof Jodit && e instanceof Jodit || e.isJodit));
                };
            },
            60280: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isLicense = void 0;
                var n = o(24421);
                t.isLicense = function(e) {
                    return (0, n.isString)(e) && 23 === e.length && /^[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}-[a-z0-9]{5}$/i.test(e);
                };
            },
            37204: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isMarker = void 0;
                var n = o(24263), r = o(86893);
                t.isMarker = function(e) {
                    return n.Dom.isNode(e) && n.Dom.isTag(e, "span") && e.hasAttribute("data-" + r.MARKER_CLASS);
                };
            },
            28069: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNativeFunction = void 0, t.isNativeFunction = function(e) {
                    return Boolean(e) && "function" === (typeof e).toLowerCase() && (e === Function.prototype || /^\s*function\s*(\b[a-z$_][a-z0-9$_]*\b)*\s*\((|([a-z$_][a-z0-9$_]*)(\s*,[a-z$_][a-z0-9$_]*)*)\)\s*{\s*\[native code]\s*}\s*$/i.test(String(e)));
                };
            },
            61817: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNumber = void 0, t.isNumber = function(e) {
                    return "number" == typeof e && !isNaN(e) && isFinite(e);
                };
            },
            57649: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNumeric = void 0;
                var n = o(24421);
                t.isNumeric = function(e) {
                    if ((0, n.isString)(e)) {
                        if (!e.match(/^([+-])?[0-9]+(\.?)([0-9]+)?(e[0-9]+)?$/)) return !1;
                        e = parseFloat(e);
                    }
                    return "number" == typeof e && !isNaN(e) && isFinite(e);
                };
            },
            79736: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isPlainObject = void 0;
                var n = o(85994);
                t.isPlainObject = function(e) {
                    return !(!e || "object" != typeof e || e.nodeType || (0, n.isWindow)(e) || e.constructor && !({}).hasOwnProperty.call(e.constructor.prototype, "isPrototypeOf"));
                };
            },
            26335: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isPromise = void 0, t.isPromise = function(e) {
                    return e && "function" == typeof e.then;
                };
            },
            24421: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isStringArray = t.isString = void 0;
                var n = o(49781);
                function r(e) {
                    return "string" == typeof e;
                }
                t.isString = r, t.isStringArray = function(e) {
                    return (0, n.isArray)(e) && r(e[0]);
                };
            },
            64350: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isURL = void 0, t.isURL = function(e) {
                    if (e.includes(" ")) return !1;
                    if ("undefined" != typeof URL) try {
                        var t = new URL(e);
                        return [
                            "https:",
                            "http:",
                            "ftp:",
                            "file:",
                            "rtmp:"
                        ].includes(t.protocol);
                    } catch (e) {
                        return !1;
                    }
                    var o = document.createElement("a");
                    return o.href = e, Boolean(o.hostname);
                };
            },
            19179: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isValidName = void 0, t.isValidName = function(e) {
                    return !!e.length && !/[^0-9A-Za-zа-яА-ЯЁё\w\-_.]/.test(e);
                };
            },
            96574: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isViewObject = void 0;
                var n = o(42096);
                t.isViewObject = function(e) {
                    return Boolean(e && e instanceof Object && (0, n.isFunction)(e.constructor) && e.isView);
                };
            },
            24021: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isVoid = void 0, t.isVoid = function(e) {
                    return null == e;
                };
            },
            85994: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isWindow = void 0, t.isWindow = function(e) {
                    return null != e && e === e.window;
                };
            },
            13203: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.colorToHex = void 0, t.colorToHex = function(e) {
                    if ("rgba(0, 0, 0, 0)" === e || "" === e) return !1;
                    if (!e) return "#000000";
                    if ("#" === e.substr(0, 1)) return e;
                    var t = /([\s\n\t\r]*?)rgb\((\d+), (\d+), (\d+)\)/.exec(e) || /([\s\n\t\r]*?)rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/.exec(e);
                    if (!t) return "#000000";
                    for(var o = parseInt(t[2], 10), n = parseInt(t[3], 10), r = (parseInt(t[4], 10) | n << 8 | o << 16).toString(16).toUpperCase(); 6 > r.length;)r = "0" + r;
                    return t[1] + "#" + r;
                };
            },
            61354: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(13203), t);
            },
            66546: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.applyStyles = void 0;
                var n = o(24263), r = o(76502), i = o(33941);
                function a(e) {
                    return e.replace(/mso-[a-z-]+:[\s]*[^;]+;/gi, "").replace(/mso-[a-z-]+:[\s]*[^";']+$/gi, "").replace(/border[a-z-]*:[\s]*[^;]+;/gi, "").replace(/([0-9.]+)(pt|cm)/gi, function(e, t, o) {
                        switch(o.toLowerCase()){
                            case "pt":
                                return (1.328 * parseFloat(t)).toFixed(0) + "px";
                            case "cm":
                                return (.02645833 * parseFloat(t)).toFixed(0) + "px";
                        }
                        return e;
                    });
                }
                t.applyStyles = function(e) {
                    if (-1 === e.indexOf("<html ")) return e;
                    e = (e = e.substring(e.indexOf("<html "), e.length)).substring(0, e.lastIndexOf("</html>") + 7);
                    var t = document.createElement("iframe");
                    t.style.display = "none", document.body.appendChild(t);
                    var o = "";
                    try {
                        var s = t.contentDocument || (t.contentWindow ? t.contentWindow.document : null);
                        if (s) {
                            s.open(), s.write(e), s.close();
                            try {
                                for(var l = function(e) {
                                    for(var t = s.styleSheets[e].cssRules, o = function(e) {
                                        if ("" === t[e].selectorText) return "continue";
                                        (0, r.$$)(t[e].selectorText, s.body).forEach(function(o) {
                                            o.style.cssText = a(t[e].style.cssText + ";" + o.style.cssText);
                                        });
                                    }, n = 0; t.length > n; n += 1)o(n);
                                }, c = 0; s.styleSheets.length > c; c += 1)l(c);
                            } catch (e) {}
                            n.Dom.each(s.body, function(e) {
                                if (n.Dom.isElement(e)) {
                                    var t = e, o = t.getAttribute("style");
                                    o && (t.style.cssText = a(o)), t.hasAttribute("style") && !t.getAttribute("style") && t.removeAttribute("style");
                                }
                            }), o = s.firstChild ? (0, i.trim)(s.body.innerHTML) : "";
                        }
                    } catch (e) {} finally{
                        n.Dom.safeRemove(t);
                    }
                    return o && (e = o), (0, i.trim)(e.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, ""));
                };
            },
            33316: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.cleanFromWord = void 0;
                var n = o(24263), r = o(33941), i = o(1853);
                t.cleanFromWord = function(e) {
                    -1 !== e.indexOf("<html ") && (e = (e = e.substring(e.indexOf("<html "), e.length)).substring(0, e.lastIndexOf("</html>") + 7));
                    var t = "";
                    try {
                        var o = document.createElement("div");
                        o.innerHTML = e;
                        var a = [];
                        o.firstChild && n.Dom.each(o, function(e) {
                            if (e) switch(e.nodeType){
                                case Node.ELEMENT_NODE:
                                    switch(e.nodeName){
                                        case "STYLE":
                                        case "LINK":
                                        case "META":
                                            a.push(e);
                                            break;
                                        case "W:SDT":
                                        case "W:SDTPR":
                                        case "FONT":
                                            n.Dom.unwrap(e);
                                            break;
                                        default:
                                            (0, i.toArray)(e.attributes).forEach(function(t) {
                                                -1 === [
                                                    "src",
                                                    "href",
                                                    "rel",
                                                    "content"
                                                ].indexOf(t.name.toLowerCase()) && e.removeAttribute(t.name);
                                            });
                                    }
                                    break;
                                case Node.TEXT_NODE:
                                    break;
                                default:
                                    a.push(e);
                            }
                        }), n.Dom.safeRemove.apply(null, a), t = o.innerHTML;
                    } catch (e) {}
                    return t && (e = t), (e = e.split(/(\n)/).filter(r.trim).join("\n")).replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, "");
                };
            },
            46639: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.htmlspecialchars = void 0, t.htmlspecialchars = function(e) {
                    var t = document.createElement("div");
                    return t.textContent = e, t.innerHTML;
                };
            },
            13098: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(66546), t), n.__exportStar(o(33316), t), n.__exportStar(o(46639), t), n.__exportStar(o(11336), t), n.__exportStar(o(67128), t), n.__exportStar(o(86645), t);
            },
            86645: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.nl2br = void 0, t.nl2br = function(e) {
                    return e.replace(/\r\n|\r|\n/g, "<br/>");
                };
            },
            67128: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sanitizeHTMLElement = t.safeHTML = void 0;
                var n = o(76502), r = o(24263);
                function i(e, t) {
                    var o = void 0 === t ? {
                        safeJavaScriptLink: !0,
                        removeOnError: !0
                    } : t, i = o.safeJavaScriptLink, a = o.removeOnError;
                    if (!r.Dom.isElement(e)) return !1;
                    var s = !1;
                    a && e.hasAttribute("onerror") && ((0, n.attr)(e, "onerror", null), s = !0);
                    var l = e.getAttribute("href");
                    return i && l && 0 === l.trim().indexOf("javascript") && ((0, n.attr)(e, "href", location.protocol + "//" + l), s = !0), s;
                }
                t.safeHTML = function(e, t) {
                    (r.Dom.isElement(e) || r.Dom.isFragment(e)) && (t.removeOnError && (i(e), (0, n.$$)("[onerror]", e).forEach(function(e) {
                        return i(e, t);
                    })), t.safeJavaScriptLink && (i(e), (0, n.$$)('a[href^="javascript"]', e).forEach(function(e) {
                        return i(e, t);
                    })));
                }, t.sanitizeHTMLElement = i;
            },
            11336: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.stripTags = void 0;
                var n = o(24421), r = o(76502), i = o(33941), a = o(24263), s = new Set([
                    "div",
                    "p",
                    "br",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "hr"
                ]), l = new Set([
                    "script",
                    "style"
                ]);
                t.stripTags = function e(t, o, c) {
                    void 0 === o && (o = document), void 0 === c && (c = null);
                    var u = o.createElement("div");
                    return (0, n.isString)(t) ? u.innerHTML = t : u.appendChild(t), (0, r.$$)("*", u).forEach(function(t) {
                        var n = t.parentNode;
                        if (n) {
                            if (c && a.Dom.isTag(t, c)) {
                                var r = t.nodeName.toLowerCase(), i = a.Dom.isTag(t, [
                                    "br",
                                    "hr",
                                    "input"
                                ]) ? "%%%jodit-single-".concat(r, "%%%") : "%%%jodit-".concat(r, "%%%").concat(e(t.innerHTML, o, c), "%%%/jodit-").concat(r, "%%%");
                                return a.Dom.before(t, o.createTextNode(i)), void a.Dom.safeRemove(t);
                            }
                            if (a.Dom.isTag(t, l)) a.Dom.safeRemove(t);
                            else if (a.Dom.isTag(t, s)) {
                                var u = t.nextSibling;
                                a.Dom.isText(u) && /^\s/.test(u.nodeValue || "") || u && n.insertBefore(o.createTextNode(" "), u);
                            }
                        }
                    }), (0, i.trim)(u.innerText).replace(/%%%(\/)?jodit(-single)?-([\w\n]+)%%%/g, function(e, t, o, n) {
                        return "<".concat(t ? "/" : "").concat(n, ">");
                    });
                };
            },
            40332: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(76502), t), n.__exportStar(o(12557), t), n.__exportStar(o(4696), t), n.__exportStar(o(10172), t), n.__exportStar(o(61354), t), n.__exportStar(o(13098), t), n.__exportStar(o(89693), t), n.__exportStar(o(90954), t), n.__exportStar(o(19035), t);
            },
            89693: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(48926), t), n.__exportStar(o(78648), t), n.__exportStar(o(74504), t), n.__exportStar(o(50870), t), n.__exportStar(o(76787), t), n.__exportStar(o(93251), t), n.__exportStar(o(91518), t), n.__exportStar(o(49353), t), n.__exportStar(o(64274), t);
            },
            64274: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeColor = void 0;
                var n = o(61354), r = o(19035);
                t.normalizeColor = function(e) {
                    var t = [
                        "#"
                    ], o = (0, n.colorToHex)(e);
                    if (!o) return !1;
                    if (3 === (o = (o = (0, r.trim)(o.toUpperCase())).substr(1)).length) {
                        for(var i = 0; 3 > i; i += 1)t.push(o[i]), t.push(o[i]);
                        return t.join("");
                    }
                    return o.length > 6 && (o = o.substr(0, 6)), "#" + o;
                };
            },
            49353: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeCssValue = t.normalizeCssNumericValue = t.NUMBER_FIELDS_REG = void 0;
                var n = o(57649), r = o(11278), i = o(13203), a = o(24021);
                t.NUMBER_FIELDS_REG = /^(left|top|bottom|right|width|min|max|height|margin|padding|fontsize|font-size)/i, t.normalizeCssNumericValue = function(e, o) {
                    return !(0, a.isVoid)(o) && t.NUMBER_FIELDS_REG.test(e) && (0, n.isNumeric)(o.toString()) ? parseInt(o.toString(), 10) + "px" : o;
                }, t.normalizeCssValue = function(e, t) {
                    if ("font-weight" === (0, r.kebabCase)(e)) {
                        switch(t.toString().toLowerCase()){
                            case "700":
                            case "bold":
                                return 700;
                            case "400":
                            case "normal":
                                return 400;
                            case "900":
                            case "heavy":
                                return 900;
                        }
                        return (0, n.isNumeric)(t) ? Number(t) : t;
                    }
                    return /color/i.test(e) && /^rgb/i.test(t.toString()) && (0, i.colorToHex)(t.toString()) || t;
                };
            },
            48926: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeKeyAliases = void 0;
                var n = o(33941), r = o(86893);
                t.normalizeKeyAliases = function(e) {
                    var t = {}, o = {
                        meta: 1,
                        ctrl: 2,
                        control: 2,
                        alt: 3,
                        shift: 4
                    };
                    return e.replace(/\+\+/g, "+add").split(/[\s]*\+[\s]*/).map(function(e) {
                        return (0, n.trim)(e.toLowerCase());
                    }).map(function(e) {
                        return r.KEY_ALIASES[e] || e;
                    }).sort(function(e, t) {
                        return o[e] && !o[t] ? -1 : !o[e] && o[t] ? 1 : o[e] && o[t] ? o[e] - o[t] : e > t ? 1 : -1;
                    }).filter(function(e) {
                        return !t[e] && "" !== e && (t[e] = !0);
                    }).join("+");
                };
            },
            78648: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeLicense = void 0, t.normalizeLicense = function(e, t) {
                    void 0 === t && (t = 8);
                    for(var o = []; e.length;)o.push(e.substr(0, t)), e = e.substr(t);
                    return o[1] = o[1].replace(/./g, "*"), o[2] = o[2].replace(/./g, "*"), o.join("-");
                };
            },
            74504: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeNode = void 0;
                var n = o(86893), r = o(24263);
                t.normalizeNode = function e(t) {
                    if (t) {
                        if (r.Dom.isText(t) && null != t.nodeValue && t.parentNode) for(; r.Dom.isText(t.nextSibling);)null != t.nextSibling.nodeValue && (t.nodeValue += t.nextSibling.nodeValue), t.nodeValue = t.nodeValue.replace((0, n.INVISIBLE_SPACE_REG_EXP)(), ""), r.Dom.safeRemove(t.nextSibling);
                        else e(t.firstChild);
                        e(t.nextSibling);
                    }
                };
            },
            50870: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizePath = void 0;
                var n = o(19035);
                t.normalizePath = function() {
                    for(var e = [], t = 0; arguments.length > t; t++)e[t] = arguments[t];
                    return e.filter(function(e) {
                        return (0, n.trim)(e).length;
                    }).map(function(t, o) {
                        return t = t.replace(/([^:])[\\/]+/g, "$1/"), o && (t = t.replace(/^\//, "")), o !== e.length - 1 && (t = t.replace(/\/$/, "")), t;
                    }).join("/");
                };
            },
            76787: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeRelativePath = void 0, t.normalizeRelativePath = function(e) {
                    return e.split("/").reduce(function(e, t) {
                        switch(t){
                            case "":
                            case ".":
                                break;
                            case "..":
                                e.pop();
                                break;
                            default:
                                e.push(t);
                        }
                        return e;
                    }, []).join("/") + (e.endsWith("/") ? "/" : "");
                };
            },
            93251: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeSize = void 0, t.normalizeSize = function(e) {
                    return /^[0-9]+$/.test(e.toString()) ? e + "px" : e.toString();
                };
            },
            91518: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeUrl = void 0, t.normalizeUrl = function() {
                    for(var e = [], t = 0; arguments.length > t; t++)e[t] = arguments[t];
                    return e.filter(function(e) {
                        return e.length;
                    }).map(function(e) {
                        return e.replace(/\/$/, "");
                    }).join("/").replace(/([^:])[\\/]+/g, "$1/");
                };
            },
            1684: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getContentWidth = void 0, t.getContentWidth = function(e, t) {
                    var o = function(e) {
                        return parseInt(e, 10);
                    }, n = t.getComputedStyle(e);
                    return e.offsetWidth - o(n.getPropertyValue("padding-left") || "0") - o(n.getPropertyValue("padding-right") || "0");
                };
            },
            73874: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getScrollParent = void 0;
                var n = o(76502), r = o(24263);
                t.getScrollParent = function e(t) {
                    if (!t) return null;
                    var o = r.Dom.isHTMLElement(t), i = o && (0, n.css)(t, "overflowY");
                    return o && "visible" !== i && "hidden" !== i && t.scrollHeight >= t.clientHeight ? t : e(t.parentNode) || document.scrollingElement || document.body;
                };
            },
            90954: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(1684), t), n.__exportStar(o(73874), t), n.__exportStar(o(83810), t), n.__exportStar(o(98701), t), n.__exportStar(o(81710), t), n.__exportStar(o(16492), t);
            },
            83810: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.innerWidth = void 0, t.innerWidth = function(e, t) {
                    var o = t.getComputedStyle(e);
                    return e.clientWidth - (parseFloat(o.paddingLeft || "0") + parseFloat(o.paddingRight || "0"));
                };
            },
            16492: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.size = void 0;
                var n = o(10172);
                t.size = function(e) {
                    return (0, n.isString)(e) || (0, n.isArray)(e) ? e.length : (0, n.isPlainObject)(e) ? Object.keys(e).length : 0;
                };
            },
            98701: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.offset = void 0, t.offset = function(e, o, n, r) {
                    var i;
                    void 0 === r && (r = !1);
                    try {
                        i = e.getBoundingClientRect();
                    } catch (e) {
                        i = {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0,
                            width: 0,
                            height: 0
                        };
                    }
                    var a, s, l = n.body, c = n.documentElement || {
                        clientTop: 0,
                        clientLeft: 0,
                        scrollTop: 0,
                        scrollLeft: 0
                    }, u = n.defaultView || n.parentWindow, d = u.pageYOffset || c.scrollTop || l.scrollTop, p = u.pageXOffset || c.scrollLeft || l.scrollLeft, f = c.clientTop || l.clientTop || 0, h = c.clientLeft || l.clientLeft || 0, m = o.iframe;
                    if (!r && o && o.options && o.o.iframe && m) {
                        var v = (0, t.offset)(m, o, o.od, !0);
                        a = i.top + v.top, s = i.left + v.left;
                    } else a = i.top + d - f, s = i.left + p - h;
                    return {
                        top: Math.round(a),
                        left: Math.round(s),
                        width: i.width,
                        height: i.height
                    };
                };
            },
            81710: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.position = void 0;
                var n = o(77892);
                t.position = function e(t, o, r) {
                    void 0 === r && (r = !1);
                    var i = t.getBoundingClientRect(), a = i.left, s = i.top;
                    if ((0, n.isJoditObject)(o) && o.iframe && o.ed.body.contains(t) && !r) {
                        var l = e(o.iframe, o, !0);
                        a += l.left, s += l.top;
                    }
                    return {
                        left: Math.round(a),
                        top: Math.round(s),
                        width: Math.round(t.offsetWidth),
                        height: Math.round(t.offsetHeight)
                    };
                };
            },
            26596: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.camelCase = void 0, t.camelCase = function(e) {
                    return e.replace(/([-_])(.)/g, function(e, t, o) {
                        return o.toUpperCase();
                    });
                };
            },
            93163: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.fuzzySearchIndex = void 0;
                var n = o(86893);
                t.fuzzySearchIndex = function(e, t, o, r) {
                    void 0 === o && (o = 0), void 0 === r && (r = 1);
                    var i = 0, a = 0, s = -1, l = 0, c = 0;
                    for(a = o; e.length > i && t.length > a;)e[i].toLowerCase() === t[a].toLowerCase() ? (i++, l++, c = 0, -1 === s && (s = a)) : i > 0 && (r > c || t[a] === n.INVISIBLE_SPACE ? (c++, l++) : (i = 0, s = -1, l = 0, c = 0, a--)), a++;
                    return i === e.length ? [
                        s,
                        l
                    ] : [
                        -1,
                        0
                    ];
                };
            },
            11625: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.i18n = t.sprintf = void 0;
                var n = o(93166), r = o(76502), i = o(24421), a = o(13449), s = o(86893);
                t.sprintf = function(e, t) {
                    if (!t || !t.length) return e;
                    for(var o = /%([sd])/g, n = o.exec(e), r = e, i = 0; n && void 0 !== t[i];)r = r.replace(n[0], t[i].toString()), i += 1, n = o.exec(e);
                    return r;
                }, t.i18n = function(e, o, l) {
                    if (!(0, i.isString)(e)) throw (0, r.error)("i18n: Need string in first argument");
                    if (!e.length) return e;
                    var c = Boolean(null == l ? void 0 : l.debugLanguage), u = {}, d = function(e) {
                        return o && o.length ? (0, t.sprintf)(e, o) : e;
                    }, p = (0, r.defaultLanguage)(n.Config.defaultOptions.language, n.Config.defaultOptions.language), f = (0, r.defaultLanguage)(null == l ? void 0 : l.language, p), h = function(t) {
                        if (t) {
                            if ((0, i.isString)(t[e])) return d(t[e]);
                            var o = e.toLowerCase();
                            if ((0, i.isString)(t[o])) return d(t[o]);
                            var n = (0, a.ucfirst)(e);
                            return (0, i.isString)(t[n]) ? d(t[n]) : void 0;
                        }
                    };
                    void 0 !== s.lang[f] ? u = s.lang[f] : c || (u = void 0 !== s.lang[p] ? s.lang[p] : s.lang.en);
                    var m = null == l ? void 0 : l.i18n;
                    if (m && m[f]) {
                        var v = h(m[f]);
                        if (v) return v;
                    }
                    return h(u) || (!c && s.lang.en && (0, i.isString)(s.lang.en[e]) && s.lang.en[e] ? d(s.lang.en[e]) : c ? "{" + e + "}" : d(e));
                };
            },
            19035: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(26596), t), n.__exportStar(o(93163), t), n.__exportStar(o(11625), t), n.__exportStar(o(11278), t), n.__exportStar(o(42554), t), n.__exportStar(o(33941), t), n.__exportStar(o(13449), t);
            },
            11278: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.CamelCaseToKebabCase = t.kebabCase = void 0, t.kebabCase = function(e) {
                    return e.replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
                }, t.CamelCaseToKebabCase = function(e) {
                    return e.replace(/([A-Z])([A-Z])([a-z])/g, "$1-$2$3").replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
                };
            },
            42554: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.stringify = void 0, t.stringify = function(e, t) {
                    if (void 0 === t && (t = {}), "object" != typeof e) return String(e);
                    var o = new Set(t.excludeKeys), n = new WeakMap;
                    return JSON.stringify(e, function(e, t) {
                        if (!o.has(e)) {
                            if ("object" == typeof t && null != t) {
                                if (n.get(t)) return "[refObject]";
                                n.set(t, !0);
                            }
                            return t;
                        }
                    }, t.prettify);
                };
            },
            33941: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.trimInv = t.trim = void 0;
                var n = o(86893);
                t.trim = function(e) {
                    return e.replace((0, n.SPACE_REG_EXP_END)(), "").replace((0, n.SPACE_REG_EXP_START)(), "");
                }, t.trimInv = function(e) {
                    return e.replace((0, n.INVISIBLE_SPACE_REG_EXP_END)(), "").replace((0, n.INVISIBLE_SPACE_REG_EXP_START)(), "");
                };
            },
            13449: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ucfirst = void 0, t.ucfirst = function(e) {
                    return e.length ? e[0].toUpperCase() + e.substr(1) : "";
                };
            },
            60303: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.alignElement = t.clearAlign = t.hAlignElement = void 0;
                var n = o(64968), r = o(26911);
                function i(e) {
                    n.Dom.each(e, function(e) {
                        n.Dom.isHTMLElement(e) && e.style.textAlign && (e.style.textAlign = "", e.style.cssText.trim().length || e.removeAttribute("style"));
                    });
                }
                t.hAlignElement = function(e, t) {
                    t && "normal" !== t ? "center" !== t ? ((0, r.css)(e, "float", t), (0, r.clearCenterAlign)(e)) : (0, r.css)(e, {
                        float: "",
                        display: "block",
                        marginLeft: "auto",
                        marginRight: "auto"
                    }) : ((0, r.css)(e, "float") && -1 !== [
                        "right",
                        "left"
                    ].indexOf((0, r.css)(e, "float").toString().toLowerCase()) && (0, r.css)(e, "float", ""), (0, r.clearCenterAlign)(e));
                }, t.clearAlign = i, t.alignElement = function(e, t) {
                    if (n.Dom.isNode(t) && n.Dom.isElement(t)) switch(i(t), e.toLowerCase()){
                        case "justifyfull":
                            t.style.textAlign = "justify";
                            break;
                        case "justifyright":
                            t.style.textAlign = "right";
                            break;
                        case "justifyleft":
                            t.style.textAlign = "left";
                            break;
                        case "justifycenter":
                            t.style.textAlign = "center";
                    }
                };
            },
            62462: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.loadNextStyle = t.loadNext = t.appendStyleAsync = t.appendScriptAsync = t.appendScript = void 0;
                var n = o(20255), r = o(48240), i = o(42096), a = o(24421), s = new Map, l = function(e) {
                    return function(t, o) {
                        return n.__awaiter(void 0, void 0, Promise, function() {
                            var r;
                            return n.__generator(this, function(n) {
                                return s.has(o) ? [
                                    2,
                                    s.get(o)
                                ] : (r = e(t, o), s.set(o, r), [
                                    2,
                                    r
                                ]);
                            });
                        });
                    };
                };
                t.appendScript = function(e, t, o) {
                    var n = e.c.element("script");
                    return n.type = "text/javascript", n.async = !0, (0, i.isFunction)(o) && !e.isInDestruct && e.e.on(n, "load", o), n.src || (n.src = (0, r.completeUrl)(t)), e.od.body.appendChild(n), {
                        callback: o,
                        element: n
                    };
                }, t.appendScriptAsync = l(function(e, o) {
                    return new Promise(function(n, r) {
                        var i = (0, t.appendScript)(e, o, n).element;
                        !e.isInDestruct && e.e.on(i, "error", r);
                    });
                }), t.appendStyleAsync = l(function(e, t) {
                    return new Promise(function(o, n) {
                        var i = e.c.element("link");
                        i.rel = "stylesheet", i.media = "all", i.crossOrigin = "anonymous", !e.isInDestruct && e.e.on(i, "load", function() {
                            return o(i);
                        }).on(i, "error", n), i.href = (0, r.completeUrl)(t), e.o.shadowRoot ? e.o.shadowRoot.appendChild(i) : e.od.body.appendChild(i);
                    });
                }), t.loadNext = function(e, o, n) {
                    return void 0 === n && (n = 0), (0, a.isString)(o[n]) ? (0, t.appendScriptAsync)(e, o[n]).then(function() {
                        return (0, t.loadNext)(e, o, n + 1);
                    }) : Promise.resolve();
                }, t.loadNextStyle = function(e, o, n) {
                    return void 0 === n && (n = 0), (0, a.isString)(o[n]) ? (0, t.appendStyleAsync)(e, o[n]).then(function() {
                        return (0, t.loadNextStyle)(e, o, n + 1);
                    }) : Promise.resolve();
                };
            },
            603: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.assert = void 0;
                var n = o(20255), r = function(e) {
                    function t(t) {
                        var o = e.call(this, t) || this;
                        return o.name = "AssertionError", o;
                    }
                    return n.__extends(t, e), t;
                }(Error);
                t.assert = function(e, t) {
                    if (!e) throw new r("Assertion failed: ".concat(t));
                };
            },
            37682: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.browser = void 0, t.browser = function(e) {
                    var t = navigator.userAgent.toLowerCase(), o = /(firefox)[\s/]([\w.]+)/.exec(t) || /(chrome)[\s/]([\w.]+)/.exec(t) || /(webkit)[\s/]([\w.]+)/.exec(t) || /(opera)(?:.*version)[\s/]([\w.]+)/.exec(t) || /(msie)[\s]([\w.]+)/.exec(t) || /(trident)\/([\w.]+)/.exec(t) || 0 > t.indexOf("compatible") || [];
                    return "version" === e ? o[2] : "webkit" === e ? "chrome" === o[1] || "webkit" === o[1] : "ff" === e ? "firefox" === o[1] : "msie" === e ? "trident" === o[1] || "msie" === o[1] : o[1] === e;
                };
            },
            71567: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildQuery = void 0;
                var n = o(79736);
                t.buildQuery = function(e, o) {
                    var r = [], i = encodeURIComponent;
                    for(var a in e)if (Object.prototype.hasOwnProperty.call(e, a)) {
                        var s = o ? o + "[" + a + "]" : a, l = e[a];
                        r.push((0, n.isPlainObject)(l) ? (0, t.buildQuery)(l, s) : i(s) + "=" + i(l));
                    }
                    return r.join("&");
                };
            },
            48240: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.completeUrl = void 0, t.completeUrl = function(e) {
                    return "file:" === window.location.protocol && /^\/\//.test(e) && (e = "https:" + e), e;
                };
            },
            64981: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ConfigFlatten = t.ConfigProto = void 0;
                var n = o(20255), r = o(7935), i = o(49781), a = o(79736), s = o(24421), l = o(24021), c = o(93166), u = o(67309);
                t.ConfigProto = function e(t, o, u) {
                    if (void 0 === u && (u = 0), Object.getPrototypeOf(t) !== Object.prototype) return t;
                    var d = c.Config.defaultOptions;
                    if ((0, s.isString)(t.preset)) {
                        if (void 0 !== d.presets[t.preset]) {
                            var p = d.presets[t.preset];
                            Object.keys(p).forEach(function(e) {
                                (0, l.isVoid)(t[e]) && (t[e] = p[e]);
                            });
                        }
                        delete t.preset;
                    }
                    var f = {};
                    return Object.keys(t).forEach(function(s) {
                        var l = t[s], c = o ? o[s] : null;
                        f[s] = (0, a.isPlainObject)(l) && (0, a.isPlainObject)(c) && !(0, r.isAtom)(l) ? e(l, c, u + 1) : 0 !== u && (0, i.isArray)(l) && !(0, r.isAtom)(l) && (0, i.isArray)(c) ? n.__spreadArray(n.__spreadArray([], n.__read(l), !1), n.__read(c.slice(l.length)), !1) : l;
                    }), Object.setPrototypeOf(f, o), f;
                }, t.ConfigFlatten = function(e) {
                    return (0, u.keys)(e, !1).reduce(function(t, o) {
                        return t[o] = e[o], t;
                    }, {});
                };
            },
            42051: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.convertMediaUrlToVideoEmbed = void 0;
                var n = o(64350), r = o(67285);
                t.convertMediaUrlToVideoEmbed = function(e, t, o) {
                    if (void 0 === t && (t = 400), void 0 === o && (o = 345), !(0, n.isURL)(e)) return e;
                    var i = document.createElement("a"), a = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
                    i.href = e, t || (t = 400), o || (o = 345);
                    var s = i.protocol || "";
                    switch(i.hostname){
                        case "www.vimeo.com":
                        case "vimeo.com":
                            return a.test(e) ? e.replace(a, '<iframe width="' + t + '" height="' + o + '" src="' + s + '//player.vimeo.com/video/$1" frameborder="0" allowfullscreen></iframe>') : e;
                        case "youtube.com":
                        case "www.youtube.com":
                        case "youtu.be":
                        case "www.youtu.be":
                            var l = i.search ? (0, r.parseQuery)(i.search) : {
                                v: i.pathname.substr(1)
                            };
                            return l.v ? '<iframe width="' + t + '" height="' + o + '" src="' + s + "//www.youtube.com/embed/" + l.v + '" frameborder="0" allowfullscreen></iframe>' : e;
                    }
                    return e;
                };
            },
            26911: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.clearCenterAlign = t.css = void 0;
                var n = o(79736), r = o(67749), i = o(49353), a = o(26596), s = o(11278);
                function l(e, t, o, c) {
                    if (void 0 === c && (c = !1), (0, r.isBoolean)(o) && (c = o, o = void 0), (0, n.isPlainObject)(t) || void 0 !== o) {
                        var u = function(e, t, o) {
                            void 0 === (o = (0, i.normalizeCssNumericValue)(t, o)) || null != o && l(e, t, !0) === (0, i.normalizeCssValue)(t, o) || (e.style[t] = o);
                        };
                        if ((0, n.isPlainObject)(t)) for(var d = Object.keys(t), p = 0; d.length > p; p += 1)u(e, (0, a.camelCase)(d[p]), t[d[p]]);
                        else u(e, (0, a.camelCase)(t), o);
                        return "";
                    }
                    var f = (0, s.kebabCase)(t), h = e.ownerDocument || document, m = !!h && (h.defaultView || h.parentWindow), v = e.style[t], g = "";
                    return void 0 !== v && "" !== v ? g = v : m && !c && (g = m.getComputedStyle(e).getPropertyValue(f)), i.NUMBER_FIELDS_REG.test(t) && /^[-+]?[0-9.]+px$/.test(g.toString()) && (g = parseInt(g.toString(), 10)), (0, i.normalizeCssValue)(t, g);
                }
                t.css = l, t.clearCenterAlign = function(e) {
                    "block" === l(e, "display") && l(e, "display", "");
                    var t = e.style;
                    "auto" === t.marginLeft && "auto" === t.marginRight && (t.marginLeft = "", t.marginRight = "");
                };
            },
            2522: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ctrlKey = void 0, t.ctrlKey = function(e) {
                    if ("undefined" != typeof navigator && -1 !== navigator.userAgent.indexOf("Mac OS X")) {
                        if (e.metaKey && !e.altKey) return !0;
                    } else if (e.ctrlKey && !e.altKey) return !0;
                    return !1;
                };
            },
            63122: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.dataBind = void 0;
                var n = o(96574), r = new WeakMap;
                t.dataBind = function(e, t, o) {
                    var i = r.get(e);
                    if (!i) {
                        r.set(e, i = {});
                        var a = null;
                        (0, n.isViewObject)(e.j) && (a = e.j.e), (0, n.isViewObject)(e) && (a = e.e), a && a.on("beforeDestruct", function() {
                            r.delete(e);
                        });
                    }
                    return void 0 === o ? i[t] : (i[t] = o, o);
                };
            },
            93351: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.defaultLanguage = void 0;
                var n = o(24421);
                t.defaultLanguage = function(e, t) {
                    return void 0 === t && (t = "en"), "auto" !== e && (0, n.isString)(e) ? e : document.documentElement && document.documentElement.lang ? document.documentElement.lang : navigator.language ? navigator.language.substring(0, 2) : t;
                };
            },
            41579: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isAbort = t.abort = t.options = t.connection = t.error = void 0;
                var n = o(45339);
                t.error = function(e) {
                    return new TypeError(e);
                }, t.connection = function(e) {
                    return new n.ConnectionError(e);
                }, t.options = function(e) {
                    return new n.OptionsError(e);
                }, t.abort = function(e) {
                    return new n.AbortError(e);
                }, t.isAbort = function(e) {
                    return e instanceof n.AbortError;
                };
            },
            86768: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AbortError = void 0;
                var n = o(20255), r = function(e) {
                    function t(o) {
                        var n = e.call(this, o) || this;
                        return Object.setPrototypeOf(n, t.prototype), n;
                    }
                    return n.__extends(t, e), t;
                }(Error);
                t.AbortError = r;
            },
            43380: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ConnectionError = void 0;
                var n = o(20255), r = function(e) {
                    function t(o) {
                        var n = e.call(this, o) || this;
                        return Object.setPrototypeOf(n, t.prototype), n;
                    }
                    return n.__extends(t, e), t;
                }(Error);
                t.ConnectionError = r;
            },
            45339: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(86768), t), n.__exportStar(o(43380), t), n.__exportStar(o(47403), t);
            },
            47403: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.OptionsError = void 0;
                var n = o(20255), r = function(e) {
                    function t(o) {
                        var n = e.call(this, o) || this;
                        return Object.setPrototypeOf(n, t.prototype), n;
                    }
                    return n.__extends(t, e), t;
                }(TypeError);
                t.OptionsError = r;
            },
            56964: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(41579), t), n.__exportStar(o(45339), t);
            },
            7935: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.fastClone = t.markAsAtomic = t.isAtom = void 0;
                var n = o(42554);
                t.isAtom = function(e) {
                    return e && e.isAtom;
                }, t.markAsAtomic = function(e) {
                    return Object.defineProperty(e, "isAtom", {
                        enumerable: !1,
                        value: !0,
                        configurable: !1
                    }), e;
                }, t.fastClone = function(e) {
                    return JSON.parse((0, n.stringify)(e));
                };
            },
            87247: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getClassName = t.keepNames = void 0;
                var n = o(42096);
                t.keepNames = new Map, t.getClassName = function(e) {
                    var o;
                    if ((0, n.isFunction)(e.className)) return e.className();
                    var r = (null === (o = e.constructor) || void 0 === o ? void 0 : o.originalConstructor) || e.constructor;
                    if (t.keepNames.has(r)) return t.keepNames.get(r);
                    if (r.name) return r.name;
                    var i = new RegExp(/^\s*function\s*(\S*)\s*\(/), a = r.toString().match(i);
                    return a ? a[1] : "";
                };
            },
            69384: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.get = void 0;
                var n = o(20255), r = o(24421), i = o(24021);
                t.get = function(e, t) {
                    var o, a;
                    if (!(0, r.isString)(e) || !e.length) return null;
                    var s = e.split("."), l = t;
                    try {
                        try {
                            for(var c = n.__values(s), u = c.next(); !u.done; u = c.next()){
                                var d = u.value;
                                if ((0, i.isVoid)(l[d])) return null;
                                l = l[d];
                            }
                        } catch (e) {
                            o = {
                                error: e
                            };
                        } finally{
                            try {
                                u && !u.done && (a = c.return) && a.call(c);
                            } finally{
                                if (o) throw o.error;
                            }
                        }
                    } catch (e) {
                        return null;
                    }
                    return (0, i.isVoid)(l) ? null : l;
                };
            },
            6102: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.humanSizeToBytes = void 0, t.humanSizeToBytes = function(e) {
                    if (/^[0-9.]+$/.test(e.toString())) return parseFloat(e);
                    var t = e.substr(-2, 2).toUpperCase(), o = [
                        "KB",
                        "MB",
                        "GB",
                        "TB"
                    ], n = parseFloat(e.substr(0, e.length - 2));
                    return -1 !== o.indexOf(t) ? n * Math.pow(1024, o.indexOf(t) + 1) : parseInt(e, 10);
                };
            },
            76502: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(60303), t), n.__exportStar(o(62462), t), n.__exportStar(o(52378), t), n.__exportStar(o(37682), t), n.__exportStar(o(71567), t), n.__exportStar(o(48240), t), n.__exportStar(o(64981), t), n.__exportStar(o(42051), t), n.__exportStar(o(26911), t), n.__exportStar(o(2522), t), n.__exportStar(o(63122), t), n.__exportStar(o(93351), t), n.__exportStar(o(56964), t), n.__exportStar(o(7935), t), n.__exportStar(o(69384), t), n.__exportStar(o(87247), t), n.__exportStar(o(6102), t), n.__exportStar(o(47580), t), n.__exportStar(o(67285), t), n.__exportStar(o(21498), t), n.__exportStar(o(80861), t), n.__exportStar(o(9005), t), n.__exportStar(o(54188), t), n.__exportStar(o(21518), t), n.__exportStar(o(37228), t), n.__exportStar(o(67309), t), n.__exportStar(o(22362), t);
            },
            47580: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.markDeprecated = t.cns = void 0;
                var n = o(20255);
                t.cns = console, t.markDeprecated = function(e, o, r) {
                    return void 0 === o && (o = [
                        ""
                    ]), void 0 === r && (r = null), function() {
                        for(var i = [], a = 0; arguments.length > a; a++)i[a] = arguments[a];
                        return t.cns.warn('Method "'.concat(o[0], '" deprecated.') + (o[1] ? ' Use "'.concat(o[1], '" instead') : "")), e.call.apply(e, n.__spreadArray([
                            r
                        ], n.__read(i), !1));
                    };
                };
            },
            67285: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseQuery = void 0, t.parseQuery = function(e) {
                    for(var t = {}, o = e.substring(1).split("&"), n = 0; o.length > n; n += 1){
                        var r = o[n].split("=");
                        t[decodeURIComponent(r[0])] = decodeURIComponent(r[1] || "");
                    }
                    return t;
                };
            },
            21498: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.previewBox = void 0;
                var n = o(24421), r = o(24263), i = o(26911), a = o(67309), s = o(54188);
                t.previewBox = function(e, t, o, l) {
                    void 0 === o && (o = "px"), void 0 === l && (l = null);
                    var c = function(e, t) {
                        var o = [];
                        try {
                            (0, s.$$)("img", e.editor).forEach(function(n) {
                                var i = [
                                    (0, a.attr)(n, "width"),
                                    (0, a.attr)(n, "height"),
                                    n.src
                                ];
                                (0, a.attr)(n, {
                                    width: n.offsetWidth + t,
                                    height: n.offsetHeight + t
                                });
                                var s = e.createInside.a();
                                e.ed.body.appendChild(s), s.href = n.src, n.src = s.href, r.Dom.safeRemove(s), o.push(function() {
                                    var e;
                                    n.src = null !== (e = i[2]) && void 0 !== e ? e : "", (0, a.attr)(n, {
                                        width: i[0] || null,
                                        height: i[1] || null
                                    });
                                });
                            });
                        } catch (e) {
                            throw o.forEach(function(e) {
                                return e();
                            }), o.length = 0, e;
                        }
                        return o;
                    }(e, o);
                    try {
                        var u = e.e.fire("beforePreviewBox", t, o);
                        if (null != u) return u;
                        var d = e.c.div("jodit__preview-box jodit-context");
                        l && l.appendChild(d), (0, i.css)(d, {
                            position: "relative",
                            padding: 16
                        });
                        var p = e.value || "<div style='position: absolute;left:50%;top:50%;transform: translateX(-50%) translateY(-50%);color:#ccc;'>".concat(e.i18n("Empty"), "</div>");
                        if (e.iframe) {
                            var f = e.create.element("iframe");
                            (0, i.css)(f, {
                                minWidth: 800,
                                minHeight: 600,
                                border: 0
                            }), d.appendChild(f);
                            var h = f.contentWindow;
                            if (h && (e.e.fire("generateDocumentStructure.iframe", h.document, e), d = h.document.body, "function" == typeof ResizeObserver)) {
                                var m = new ResizeObserver(function(e) {
                                    f.style.height = h.document.body.offsetHeight + 20 + "px";
                                });
                                m.observe(h.document.body), e.e.on("beforeDestruct", function() {
                                    m.unobserve(h.document.body);
                                });
                            }
                        } else (0, i.css)(d, {
                            minWidth: 1024,
                            minHeight: 600,
                            border: 0
                        });
                        var v = function(t, o) {
                            var i = (0, n.isString)(o) ? e.c.div() : o;
                            (0, n.isString)(o) && (i.innerHTML = o);
                            for(var s = 0; i.childNodes.length > s; s += 1){
                                var l = i.childNodes[s];
                                if (r.Dom.isElement(l)) {
                                    for(var c = t.ownerDocument.createElement(l.nodeName), u = 0; l.attributes.length > u; u += 1)(0, a.attr)(c, l.attributes[u].nodeName, l.attributes[u].nodeValue);
                                    0 === l.childNodes.length || r.Dom.isTag(l, [
                                        "table"
                                    ]) ? "SCRIPT" === l.nodeName ? l.textContent && (c.textContent = l.textContent) : l.innerHTML && (c.innerHTML = l.innerHTML) : v(c, l);
                                    try {
                                        t.appendChild(c);
                                    } catch (e) {}
                                } else try {
                                    t.appendChild(l.cloneNode(!0));
                                } catch (e) {}
                            }
                        };
                        return v(d, p), e.e.fire("afterPreviewBox", d), d;
                    } finally{
                        c.forEach(function(e) {
                            return e();
                        });
                    }
                };
            },
            80861: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.reset = void 0;
                var n = o(69384), r = o(42096), i = {};
                t.reset = function(e) {
                    var t, o;
                    if (!(e in i)) {
                        var a = document.createElement("iframe");
                        try {
                            if (a.src = "about:blank", document.body.appendChild(a), !a.contentWindow) return null;
                            var s = (0, n.get)(e, a.contentWindow), l = (0, n.get)(e.split(".").slice(0, -1).join("."), a.contentWindow);
                            (0, r.isFunction)(s) && (i[e] = s.bind(l));
                        } catch (e) {} finally{
                            null === (t = a.parentNode) || void 0 === t || t.removeChild(a);
                        }
                    }
                    return null !== (o = i[e]) && void 0 !== o ? o : null;
                };
            },
            9005: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.scrollIntoViewIfNeeded = t.inView = void 0;
                var n = o(24263);
                t.inView = function(e, t, o) {
                    var n = e.getBoundingClientRect(), r = e, i = n.top, a = n.height;
                    do if (r && r.parentNode) {
                        if ((n = (r = r.parentNode).getBoundingClientRect()).bottom < i) return !1;
                        if (n.top >= i + a) return !1;
                    }
                    while (r && r !== t && r.parentNode);
                    return (o.documentElement && o.documentElement.clientHeight || 0) >= i;
                }, t.scrollIntoViewIfNeeded = function(e, o, r) {
                    n.Dom.isHTMLElement(e) && !(0, t.inView)(e, o, r) && (o.clientHeight !== o.scrollHeight && (o.scrollTop = e.offsetTop), (0, t.inView)(e, o, r) || e.scrollIntoView());
                };
            },
            54188: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.resolveElement = t.cssPath = t.refs = t.getXPathByElement = t.$$ = void 0;
                var n = o(86893), r = o(24421), i = o(76502), a = o(24263), s = o(26596), l = o(1853), c = o(53929), u = o(45113), d = 1;
                function p(e, t) {
                    var o;
                    if (!/:scope/.test(e) || !n.IS_IE || t && t.nodeType === Node.DOCUMENT_NODE) o = t.querySelectorAll(e);
                    else {
                        var r = t.id, i = r || "_selector_id_" + String(Math.random()).slice(2) + ++d;
                        e = e.replace(/:scope/g, "#" + i), !r && t.setAttribute("id", i), o = t.parentNode.querySelectorAll(e), r || t.removeAttribute("id");
                    }
                    return [].slice.call(o);
                }
                t.$$ = p, t.getXPathByElement = function(e, o) {
                    if (!e || e.nodeType !== Node.ELEMENT_NODE) return "";
                    if (!e.parentNode || o === e) return "";
                    if (e.id) return "//*[@id='" + e.id + "']";
                    var n = [].filter.call(e.parentNode.childNodes, function(t) {
                        return t.nodeName === e.nodeName;
                    });
                    return (0, t.getXPathByElement)(e.parentNode, o) + "/" + e.nodeName.toLowerCase() + (n.length > 1 ? "[" + ((0, l.toArray)(n).indexOf(e) + 1) + "]" : "");
                }, t.refs = function(e) {
                    return u.Component.isInstanceOf(e, c.UIElement) && (e = e.container), p("[ref],[data-ref]", e).reduce(function(e, t) {
                        var o = (0, i.attr)(t, "-ref");
                        return o && (0, r.isString)(o) && (e[(0, s.camelCase)(o)] = t, e[o] = t), e;
                    }, {});
                }, t.cssPath = function(e) {
                    if (!a.Dom.isElement(e)) return null;
                    for(var t = [], o = e; o && o.nodeType === Node.ELEMENT_NODE;){
                        var n = o.nodeName.toLowerCase();
                        if (o.id) {
                            t.unshift(n += "#" + o.id);
                            break;
                        }
                        var r = o, i = 1;
                        do (r = r.previousElementSibling) && r.nodeName.toLowerCase() === n && i++;
                        while (r);
                        t.unshift(n += ":nth-of-type(" + i + ")"), o = o.parentNode;
                    }
                    return t.join(" > ");
                }, t.resolveElement = function(e, t) {
                    var o = e;
                    if ((0, r.isString)(e)) try {
                        o = t.querySelector(e);
                    } catch (t) {
                        throw (0, i.error)('String "' + e + '" should be valid HTML selector');
                    }
                    if (!o || "object" != typeof o || !a.Dom.isElement(o) || !o.cloneNode) throw (0, i.error)('Element "' + e + '" should be string or HTMLElement instance');
                    return o;
                };
            },
            21518: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.set = void 0;
                var n = o(24421), r = o(57649), i = o(49781), a = o(79736);
                t.set = function(e, t, o) {
                    if ((0, n.isString)(e) && e.length) {
                        for(var s = e.split("."), l = o, c = s[0], u = 0; s.length - 1 > u; u += 1)(0, i.isArray)(l[c = s[u]]) || (0, a.isPlainObject)(l[c]) || (l[c] = (0, r.isNumeric)(s[u + 1]) ? [] : {}), l = l[c];
                        l && (l[s[s.length - 1]] = t);
                    }
                };
            },
            37228: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LimitedStack = void 0;
                var o = function() {
                    function e(e) {
                        this.limit = e, this.stack = [];
                    }
                    return e.prototype.push = function(e) {
                        return this.stack.push(e), this.stack.length > this.limit && this.stack.shift(), this;
                    }, e.prototype.pop = function() {
                        return this.stack.pop();
                    }, e.prototype.find = function(e) {
                        return this.stack.find(e);
                    }, e;
                }();
                t.LimitedStack = o;
            },
            67309: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getDataTransfer = t.memorizeExec = t.keys = t.loadImage = t.callPromise = t.markOwner = t.attr = t.call = void 0;
                var n = o(20255), r = o(42096), i = o(26335), a = o(24021), s = o(79736), l = o(24421), c = o(63122), u = o(26911), d = o(11278);
                function p(e, t, o) {
                    if (!e || !(0, r.isFunction)(e.getAttribute)) return null;
                    if (!(0, l.isString)(t)) return Object.keys(t).forEach(function(o) {
                        var n = t[o];
                        (0, s.isPlainObject)(n) && "style" === o ? (0, u.css)(e, n) : ("className" === o && (o = "class"), p(e, o, n));
                    }), null;
                    var n = (0, d.CamelCaseToKebabCase)(t);
                    if (/^-/.test(n)) {
                        var i = p(e, "data".concat(n));
                        if (i) return i;
                        n = n.substr(1);
                    }
                    if (void 0 !== o) {
                        if (null != o) return e.setAttribute(n, o.toString()), o.toString();
                        e.hasAttribute(n) && e.removeAttribute(n);
                    }
                    return e.getAttribute(n);
                }
                t.call = function(e) {
                    for(var t = [], o = 1; arguments.length > o; o++)t[o - 1] = arguments[o];
                    return e.apply(void 0, n.__spreadArray([], n.__read(t), !1));
                }, t.attr = p, t.markOwner = function(e, t) {
                    p(t, "data-editor_id", e.id), !t.component && Object.defineProperty(t, "jodit", {
                        value: e
                    });
                }, t.callPromise = function(e, t) {
                    return (0, i.isPromise)(e) ? e.finally(t) : t();
                }, t.loadImage = function(e, t) {
                    return t.async.promise(function(o, n) {
                        var r = new Image, i = function() {
                            t.e.off(r), null == n || n();
                        }, a = function() {
                            t.e.off(r), o(r);
                        };
                        t.e.one(r, "load", a).one(r, "error", i).one(r, "abort", i), r.src = e, r.complete && a();
                    });
                }, t.keys = function(e, t) {
                    if (void 0 === t && (t = !0), t) return Object.keys(e);
                    var o = [];
                    for(var n in e)o.push(n);
                    return o;
                }, t.memorizeExec = function(e, t, o, n) {
                    var r, i = o.control, s = "button".concat(i.command), l = null !== (r = i.args && i.args[0]) && void 0 !== r ? r : (0, c.dataBind)(e, s);
                    if ((0, a.isVoid)(l)) return !1;
                    (0, c.dataBind)(e, s, l), n && (l = n(l)), e.execCommand(i.command, !1, null != l ? l : void 0);
                }, t.getDataTransfer = function(e) {
                    if (e.clipboardData) return e.clipboardData;
                    try {
                        return e.dataTransfer || new DataTransfer;
                    } catch (e) {
                        return null;
                    }
                };
            },
            22362: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.val = void 0, t.val = function(e, t, o) {
                    var n = e.querySelector(t);
                    return n ? (o && (n.value = o), n.value) : "";
                };
            },
            33286: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.init = t.initInstance = void 0;
                var n = o(10172), r = o(90338);
                function i(e, t, o, i, a) {
                    var s = o.requires;
                    if ((null == s ? void 0 : s.length) && !s.every(function(e) {
                        return i.has(e);
                    })) return a[t] = o, !1;
                    if ((0, n.isInitable)(o)) try {
                        o.init(e);
                    } catch (e) {}
                    return i.add(t), delete a[t], o.hasStyle && (0, r.loadStyle)(e, t).catch(function(e) {}), !0;
                }
                t.initInstance = function(e, t, o, n, r) {
                    i(e, t, o, n, r) && Object.keys(r).forEach(function(t) {
                        i(e, t, r[t], n, r);
                    });
                }, t.init = i;
            },
            90338: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.loadExtras = t.loadStyle = void 0;
                var n = o(20255), r = o(62462), i = o(11278), a = o(93498), s = new Set;
                function l(e, t, o) {
                    return t = (0, i.kebabCase)(t), e.basePath + "plugins/" + t + "/" + t + "." + (o ? "js" : "css");
                }
                t.loadStyle = function(e, t) {
                    return n.__awaiter(this, void 0, Promise, function() {
                        var o;
                        return n.__generator(this, function(n) {
                            return o = l(e, t, !1), s.has(o) ? [
                                2
                            ] : (s.add(o), [
                                2,
                                (0, r.appendStyleAsync)(e, o)
                            ]);
                        });
                    });
                }, t.loadExtras = function(e, t, o, n) {
                    try {
                        var i = o.filter(function(t) {
                            return !e.has((0, a.normalizeName)(t.name));
                        });
                        i.length && function(e, t, o) {
                            t.map(function(t) {
                                var n = t.url || l(e, t.name, !0);
                                return (0, r.appendScriptAsync)(e, n).then(o).catch(function() {
                                    return null;
                                });
                            });
                        }(t, i, n);
                    } catch (e) {}
                };
            },
            24342: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.makeInstance = void 0;
                var n = o(10172);
                t.makeInstance = function(e, t) {
                    try {
                        try {
                            return (0, n.isFunction)(t) ? new t(e) : t;
                        } catch (o) {
                            if ((0, n.isFunction)(t) && !t.prototype) return t(e);
                        }
                    } catch (e) {}
                    return null;
                };
            },
            93498: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.normalizeName = void 0;
                var n = o(11278);
                t.normalizeName = function(e) {
                    return (0, n.kebabCase)(e).toLowerCase();
                };
            },
            57549: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(44540), t), n.__exportStar(o(85605), t);
            },
            13573: function() {},
            44540: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PluginSystem = void 0;
                var n = o(20255);
                o(13573);
                var r = o(10172), i = o(12557), a = o(17332), s = o(90338), l = o(93498), c = o(24342), u = o(33286), d = function() {
                    function e() {
                        this.__items = new Map;
                    }
                    return e.prototype.add = function(e, t) {
                        this.__items.set((0, l.normalizeName)(e), t), a.eventEmitter.fire("plugin:".concat(e, ":ready"));
                    }, e.prototype.get = function(e) {
                        return this.__items.get((0, l.normalizeName)(e));
                    }, e.prototype.remove = function(e) {
                        this.__items.delete((0, l.normalizeName)(e));
                    }, e.prototype.__filter = function(e) {
                        var t = [];
                        return this.__items.forEach(function(o, n) {
                            e && !e.has(n) || t.push([
                                n,
                                o
                            ]);
                        }), t;
                    }, e.prototype.__init = function(e) {
                        var t = this, o = function(e) {
                            return {
                                extrasList: e.o.extraPlugins.map(function(e) {
                                    return (0, r.isString)(e) ? {
                                        name: e
                                    } : e;
                                }),
                                disableList: new Set((0, i.splitArray)(e.o.disablePlugins).map(l.normalizeName)),
                                filter: e.o.safeMode ? new Set(e.o.safePluginsList) : null
                            };
                        }(e), a = o.extrasList, d = o.disableList, p = o.filter, f = new Set, h = {}, m = {};
                        e.__plugins = m;
                        var v = function() {
                            if (!e.isInDestruct) {
                                var o = !1;
                                t.__filter(p).forEach(function(t) {
                                    var i = n.__read(t, 2), a = i[0], s = i[1];
                                    if (!(d.has(a) || f.has(a) || h[a])) {
                                        var l = null == s ? void 0 : s.requires;
                                        if (!(l && (0, r.isArray)(l) && Boolean(l.some(function(e) {
                                            return d.has(e);
                                        })))) {
                                            o = !0;
                                            var p = (0, c.makeInstance)(e, s);
                                            if (!p) return f.add(a), void delete h[a];
                                            (0, u.initInstance)(e, a, p, f, h), m[a] = p;
                                        }
                                    }
                                }), o && e.e.fire("updatePlugins");
                            }
                        };
                        a && a.length || (0, s.loadExtras)(this.__items, e, a, v), v(), function(e, t) {
                            e.e.on("beforeDestruct", function() {
                                Object.keys(t).forEach(function(o) {
                                    var n = t[o];
                                    (0, r.isDestructable)(n) && n.destruct(e), delete t[o];
                                }), delete e.__plugins;
                            });
                        }(e, m);
                    }, e.prototype.wait = function(e) {
                        var t = this;
                        return new Promise(function(o) {
                            if (t.get(e)) return o();
                            var n = function() {
                                o(), a.eventEmitter.off("plugin:".concat(e, ":ready"), n);
                            };
                            a.eventEmitter.on("plugin:".concat(e, ":ready"), n);
                        });
                    }, e;
                }();
                t.PluginSystem = d;
            },
            85605: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Plugin = void 0;
                var n = o(20255), r = o(56562), i = o(43441), a = o(40332), s = function(e) {
                    function t(t) {
                        var o = e.call(this, t) || this;
                        return o.requires = [], o.buttons = [], o.hasStyle = !1, t.e.on("afterPluginSystemInit", function() {
                            var e;
                            (0, a.isJoditObject)(t) && (null === (e = o.buttons) || void 0 === e || e.forEach(function(e) {
                                t.registerButton(e);
                            }));
                        }).on("afterInit", function() {
                            o.setStatus(r.STATUSES.ready), o.afterInit(t);
                        }).on("beforeDestruct", o.destruct), o;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "";
                    }, t.prototype.init = function(e) {}, t.prototype.destruct = function() {
                        var t, o, n;
                        if (this.isReady) {
                            this.setStatus(r.STATUSES.beforeDestruct);
                            var i = this.j;
                            (0, a.isJoditObject)(i) && (null === (t = this.buttons) || void 0 === t || t.forEach(function(e) {
                                null == i || i.unregisterButton(e);
                            })), null === (n = null === (o = this.j) || void 0 === o ? void 0 : o.events) || void 0 === n || n.off("beforeDestruct", this.destruct), this.beforeDestruct(this.j), e.prototype.destruct.call(this);
                        }
                    }, n.__decorate([
                        i.autobind
                    ], t.prototype, "destruct", null), t;
                }(r.ViewComponent);
                t.Plugin = s;
            },
            9917: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Ajax = void 0;
                var n = o(20255), r = o(93166), i = o(40332), a = o(56964), s = o(86101), l = o(22630), c = o(43441);
                o(12144);
                var u = function() {
                    function e(e, t) {
                        void 0 === t && (t = r.Config.prototype.defaultAjaxOptions), this.__async = new l.Async, this.__isFulfilled = !1, this.__activated = !1, this.__isDestructed = !1, this.options = (0, i.ConfigProto)(e || {}, t), this.xhr = this.o.xhr ? this.o.xhr() : new XMLHttpRequest;
                    }
                    return e.prototype.__buildParams = function(e, t) {
                        return (0, i.isPlainObject)(e) && this.options.contentType && this.options.contentType.includes("application/json") ? JSON.stringify(e) : (0, i.isFunction)(this.o.queryBuild) ? this.o.queryBuild.call(this, e, t) : (0, i.isString)(e) || e instanceof window.FormData || "object" == typeof e && null != e && (0, i.isFunction)(e.append) ? e : (0, i.buildQuery)(e);
                    }, Object.defineProperty(e.prototype, "o", {
                        get: function() {
                            return this.options;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.abort = function() {
                        if (this.__isFulfilled) return this;
                        try {
                            this.__isFulfilled = !0, this.xhr.abort();
                        } catch (e) {}
                        return this;
                    }, e.prototype.send = function() {
                        var e = this;
                        this.__activated = !0;
                        var t = this.xhr, o = this.o, r = this.prepareRequest();
                        return this.__async.promise(function(l, c) {
                            return n.__awaiter(e, void 0, void 0, function() {
                                var e, u, d, p, f, h = this;
                                return n.__generator(this, function(n) {
                                    switch(n.label){
                                        case 0:
                                            return e = function() {
                                                h.__isFulfilled = !0, c(a.connection("Connection error"));
                                            }, t.onload = u = function() {
                                                h.__isFulfilled = !0, l(new s.Response(r, t.status, t.statusText, t.responseType ? t.response : t.responseText));
                                            }, t.onabort = function() {
                                                h.__isFulfilled = !0, c(a.abort("Abort connection"));
                                            }, t.onerror = e, t.ontimeout = e, o.responseType && (t.responseType = o.responseType), t.onprogress = function(e) {
                                                var t, o, n = 0;
                                                e.lengthComputable && (n = e.loaded / e.total * 100), null === (o = (t = h.options).onProgress) || void 0 === o || o.call(t, n);
                                            }, t.onreadystatechange = function() {
                                                var e, n;
                                                null === (n = (e = h.options).onProgress) || void 0 === n || n.call(e, 10), t.readyState === XMLHttpRequest.DONE && (o.successStatuses.includes(t.status) ? u() : t.statusText && (h.__isFulfilled = !0, c(a.connection(t.statusText))));
                                            }, t.withCredentials = null !== (f = o.withCredentials) && void 0 !== f && f, d = r.data, t.open(r.method, r.url, !0), o.contentType && t.setRequestHeader && t.setRequestHeader("Content-type", o.contentType), (0, i.isFunction)(p = o.headers) ? [
                                                4,
                                                p.call(this)
                                            ] : [
                                                3,
                                                2
                                            ];
                                        case 1:
                                            p = n.sent(), n.label = 2;
                                        case 2:
                                            return p && t.setRequestHeader && Object.keys(p).forEach(function(e) {
                                                t.setRequestHeader(e, p[e]);
                                            }), this.__async.setTimeout(function() {
                                                t.send(d ? h.__buildParams(d) : void 0);
                                            }, 0), [
                                                2
                                            ];
                                    }
                                });
                            });
                        });
                    }, e.prototype.prepareRequest = function() {
                        if (!this.o.url) throw a.error("Need URL for AJAX request");
                        var t = this.o.url, o = this.o.data, r = (this.o.method || "get").toLowerCase();
                        if ("get" === r && o && (0, i.isPlainObject)(o)) {
                            var s = t.indexOf("?");
                            if (-1 !== s) {
                                var l = (0, i.parseQuery)(t);
                                t = t.substring(0, s) + "?" + (0, i.buildQuery)(n.__assign(n.__assign({}, l), o));
                            } else t += "?" + (0, i.buildQuery)(this.o.data);
                        }
                        var c = {
                            url: t,
                            method: r,
                            data: o
                        };
                        return e.log.splice(100), e.log.push(c), c;
                    }, e.prototype.destruct = function() {
                        this.__isDestructed || (this.__isDestructed = !0, this.__activated && !this.__isFulfilled && (this.abort(), this.__isFulfilled = !0), this.__async.destruct());
                    }, e.log = [], n.__decorate([
                        c.autobind
                    ], e.prototype, "destruct", null), e;
                }();
                t.Ajax = u;
            },
            12144: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.defaultAjaxOptions = {
                    successStatuses: [
                        200,
                        201,
                        202
                    ],
                    method: "GET",
                    url: "",
                    data: null,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    headers: {
                        "X-REQUESTED-WITH": "XMLHttpRequest"
                    },
                    withCredentials: !1,
                    xhr: function() {
                        return new XMLHttpRequest;
                    }
                };
            },
            30056: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(9917), t), n.__exportStar(o(86101), t);
            },
            86101: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Response = void 0;
                var n = o(20255), r = function() {
                    function e(e, t, o, n) {
                        this.request = e, this.status = t, this.statusText = o, this.body = n;
                    }
                    return Object.defineProperty(e.prototype, "url", {
                        get: function() {
                            return this.request.url;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.json = function() {
                        return n.__awaiter(this, void 0, Promise, function() {
                            return n.__generator(this, function(e) {
                                return [
                                    2,
                                    JSON.parse(this.body)
                                ];
                            });
                        });
                    }, e.prototype.text = function() {
                        return Promise.resolve(this.body);
                    }, e.prototype.blob = function() {
                        return n.__awaiter(this, void 0, Promise, function() {
                            return n.__generator(this, function(e) {
                                return [
                                    2,
                                    this.body
                                ];
                            });
                        });
                    }, e;
                }();
                t.Response = r;
            },
            10109: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(287), t), n.__exportStar(o(10264), t);
            },
            287: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.moveNodeInsideStart = void 0;
                var n = o(64968), r = o(86893);
                t.moveNodeInsideStart = function(e, t, o) {
                    for(var i = n.Dom.findSibling(t, o), a = n.Dom.findSibling(t, !o); n.Dom.isElement(i) && !n.Dom.isTag(i, r.INSEPARABLE_TAGS) && n.Dom.isContentEditable(i, e.editor) && (!a || !n.Dom.closest(t, n.Dom.isElement, e.editor));)o || !i.firstChild ? i.appendChild(t) : n.Dom.before(i.firstChild, t), i = n.Dom.sibling(t, o), a = n.Dom.sibling(t, !o);
                };
            },
            10264: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.moveTheNodeAlongTheEdgeOutward = void 0;
                var n = o(64968);
                t.moveTheNodeAlongTheEdgeOutward = function(e, t, o) {
                    for(var r = e; r && r !== o;){
                        if (n.Dom.findSibling(r, t)) return;
                        (r = r.parentElement) && r !== o && (t ? n.Dom.before(r, e) : n.Dom.after(r, e));
                    }
                };
            },
            2123: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(70851), t), n.__exportStar(o(77627), t);
            },
            2047: function() {},
            77627: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Select = void 0;
                var n = o(20255), r = o(86893), i = o(86893), a = o(64968), s = o(40332), l = o(70851), c = o(43441), u = o(10109), d = (o(52378), o(10172));
                o(2047);
                var p = function() {
                    function e(e) {
                        var t = this;
                        this.jodit = e, e.e.on("removeMarkers", function() {
                            t.removeMarkers();
                        });
                    }
                    return Object.defineProperty(e.prototype, "j", {
                        get: function() {
                            return this.jodit;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.errorNode = function(e) {
                        if (!a.Dom.isNode(e)) throw (0, s.error)("Parameter node must be instance of Node");
                    }, Object.defineProperty(e.prototype, "area", {
                        get: function() {
                            return this.j.editor;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "win", {
                        get: function() {
                            return this.j.ew;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "doc", {
                        get: function() {
                            return this.j.ed;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "sel", {
                        get: function() {
                            return this.j.o.shadowRoot && (0, d.isFunction)(this.j.o.shadowRoot.getSelection) ? this.j.o.shadowRoot.getSelection() : this.win.getSelection();
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "range", {
                        get: function() {
                            var e = this.sel;
                            return e && e.rangeCount ? e.getRangeAt(0) : this.createRange();
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "isInsideArea", {
                        get: function() {
                            var e = this.sel, t = (null == e ? void 0 : e.rangeCount) ? e.getRangeAt(0) : null;
                            return !(!t || !a.Dom.isOrContains(this.area, t.startContainer));
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.createRange = function(e) {
                        void 0 === e && (e = !1);
                        var t = this.doc.createRange();
                        return e && this.selectRange(t), t;
                    }, e.prototype.remove = function() {
                        var e = this.sel, t = this.current();
                        if (e && t) for(var o = 0; e.rangeCount > o; o += 1)e.getRangeAt(o).deleteContents(), e.getRangeAt(o).collapse(!0);
                    }, e.prototype.clear = function() {
                        var e, t;
                        (null === (e = this.sel) || void 0 === e ? void 0 : e.rangeCount) && (null === (t = this.sel) || void 0 === t || t.removeAllRanges());
                    }, e.prototype.removeNode = function(e) {
                        if (!a.Dom.isOrContains(this.j.editor, e, !0)) throw (0, s.error)("Selection.removeNode can remove only editor's children");
                        a.Dom.safeRemove(e), this.j.e.fire("afterRemoveNode", e);
                    }, e.prototype.insertCursorAtPoint = function(e, t) {
                        var o = this;
                        this.removeMarkers();
                        try {
                            var n = this.createRange();
                            return function() {
                                if (o.doc.caretPositionFromPoint && (r = o.doc.caretPositionFromPoint(e, t))) n.setStart(r.offsetNode, r.offset);
                                else if (o.doc.caretRangeFromPoint) {
                                    var r = o.doc.caretRangeFromPoint(e, t);
                                    n.setStart(r.startContainer, r.startOffset);
                                }
                            }(), n.collapse(!0), this.selectRange(n), !0;
                        } catch (e) {}
                        return !1;
                    }, Object.defineProperty(e.prototype, "hasMarkers", {
                        get: function() {
                            return Boolean(this.markers.length);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "markers", {
                        get: function() {
                            return (0, s.$$)("span[data-" + r.MARKER_CLASS + "]", this.area);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.removeMarkers = function() {
                        a.Dom.safeRemove.apply(null, this.markers);
                    }, e.prototype.marker = function(e, t) {
                        void 0 === e && (e = !1);
                        var o = null;
                        t && (o = t.cloneRange()).collapse(e);
                        var n = this.j.createInside.span();
                        return n.id = r.MARKER_CLASS + "_" + Number(new Date) + "_" + String(Math.random()).slice(2), n.style.lineHeight = "0", n.style.display = "none", a.Dom.markTemporary(n), (0, s.attr)(n, "data-" + r.MARKER_CLASS, e ? "start" : "end"), n.appendChild(this.j.createInside.text(r.INVISIBLE_SPACE)), o && a.Dom.isOrContains(this.area, e ? o.startContainer : o.endContainer) && o.insertNode(n), n;
                    }, e.prototype.restore = function() {
                        var e = !1, t = function(e) {
                            return "span[data-".concat(r.MARKER_CLASS, "=").concat(e ? "start" : "end", "]");
                        }, o = this.area.querySelector(t(!0)), n = this.area.querySelector(t(!1));
                        if (o) {
                            if (e = this.createRange(), n) e.setStartAfter(o), a.Dom.safeRemove(o), e.setEndBefore(n), a.Dom.safeRemove(n);
                            else {
                                var i = o.previousSibling;
                                a.Dom.isText(i) ? e.setStart(i, i.nodeValue ? i.nodeValue.length : 0) : e.setStartBefore(o), a.Dom.safeRemove(o), e.collapse(!0);
                            }
                            e && this.selectRange(e);
                        }
                    }, e.prototype.save = function(e) {
                        if (void 0 === e && (e = !1), this.hasMarkers) return [];
                        var t = this.sel;
                        if (!t || !t.rangeCount) return [];
                        for(var o = [], n = t.rangeCount, r = [], i = 0; n > i; i += 1)if (r[i] = t.getRangeAt(i), r[i].collapsed) {
                            var a = this.marker(!0, r[i]);
                            o[i] = {
                                startId: a.id,
                                collapsed: !0,
                                startMarker: a.outerHTML
                            };
                        } else {
                            a = this.marker(!0, r[i]);
                            var s = this.marker(!1, r[i]);
                            o[i] = {
                                startId: a.id,
                                endId: s.id,
                                collapsed: !1,
                                startMarker: a.outerHTML,
                                endMarker: s.outerHTML
                            };
                        }
                        if (!e) for(t.removeAllRanges(), i = n - 1; i >= 0; --i){
                            var l = this.doc.getElementById(o[i].startId);
                            if (l) {
                                if (o[i].collapsed) r[i].setStartAfter(l), r[i].collapse(!0);
                                else if (r[i].setStartBefore(l), o[i].endId) {
                                    var c = this.doc.getElementById(o[i].endId);
                                    c && r[i].setEndAfter(c);
                                }
                            }
                            try {
                                t.addRange(r[i].cloneRange());
                            } catch (e) {}
                        }
                        return o;
                    }, e.prototype.focus = function(e) {
                        var t, o;
                        if (void 0 === e && (e = {
                            preventScroll: !0
                        }), !this.isFocused()) {
                            var n = (0, s.getScrollParent)(this.j.container), r = null == n ? void 0 : n.scrollTop;
                            this.j.iframe && "complete" === this.doc.readyState && this.j.iframe.focus(e), this.win.focus(), this.area.focus(e), r && (null == n ? void 0 : n.scrollTo) && n.scrollTo(0, r);
                            var i = this.sel, l = (null == i ? void 0 : i.rangeCount) ? null == i ? void 0 : i.getRangeAt(0) : null;
                            if (!l || !a.Dom.isOrContains(this.area, l.startContainer)) {
                                var c = this.createRange();
                                c.setStart(this.area, 0), c.collapse(!0), this.selectRange(c, !1);
                            }
                            return this.j.editorIsActive || null === (o = null === (t = this.j) || void 0 === t ? void 0 : t.events) || void 0 === o || o.fire("focus"), !0;
                        }
                        return !1;
                    }, e.prototype.isCollapsed = function() {
                        for(var e = this.sel, t = 0; e && e.rangeCount > t; t += 1)if (!e.getRangeAt(t).collapsed) return !1;
                        return !0;
                    }, e.prototype.isFocused = function() {
                        return this.doc.hasFocus && this.doc.hasFocus() && this.area === this.doc.activeElement;
                    }, e.prototype.current = function(e) {
                        if (void 0 === e && (e = !0), this.j.getRealMode() === r.MODE_WYSIWYG) {
                            var t = this.sel;
                            if (!t || 0 === t.rangeCount) return null;
                            var o = t.getRangeAt(0), n = o.startContainer, i = !1, s = function(e) {
                                return i ? e.lastChild : e.firstChild;
                            };
                            if (a.Dom.isTag(n, "br") && t.isCollapsed) return n;
                            if (!a.Dom.isText(n)) {
                                if ((n = o.startContainer.childNodes[o.startOffset]) || (n = o.startContainer.childNodes[o.startOffset - 1], i = !0), n && t.isCollapsed && !a.Dom.isText(n)) {
                                    if (!i && a.Dom.isText(n.previousSibling)) n = n.previousSibling;
                                    else if (e) for(var l = s(n); l;){
                                        if (l && a.Dom.isText(l)) {
                                            n = l;
                                            break;
                                        }
                                        l = s(l);
                                    }
                                }
                                if (n && !t.isCollapsed && !a.Dom.isText(n)) {
                                    var c = n, u = n;
                                    do c = c.firstChild, u = u.lastChild;
                                    while (c && u && !a.Dom.isText(c));
                                    c === u && c && a.Dom.isText(c) && (n = c);
                                }
                            }
                            if (n && a.Dom.isOrContains(this.area, n)) return n;
                        }
                        return null;
                    }, e.prototype.insertNode = function(e, t, o) {
                        var n = this;
                        void 0 === t && (t = !0), void 0 === o && (o = !0), this.errorNode(e), this.j.e.fire("safeHTML", e), !this.isFocused() && this.j.isEditorMode() && (this.focus(), this.restore());
                        var r = this.sel;
                        this.j.history.snapshot.transaction(function() {
                            var o;
                            if (n.isCollapsed() || n.j.execCommand("Delete"), n.j.e.fire("beforeInsertNode", e), r && r.rangeCount) {
                                var s = r.getRangeAt(0);
                                a.Dom.isOrContains(n.area, s.commonAncestorContainer) ? a.Dom.isTag(s.startContainer, i.INSEPARABLE_TAGS) && s.collapsed ? null === (o = s.startContainer.parentNode) || void 0 === o || o.insertBefore(e, s.startContainer) : a.Dom.safeInsertNode(s, e) : n.area.appendChild(e);
                            } else n.area.appendChild(e);
                            t && (e.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? e.lastChild && n.setCursorAfter(e.lastChild) : n.setCursorAfter(e));
                        }), o && this.j.events && this.j.__imdSynchronizeValues(), this.j.events && this.j.e.fire("afterInsertNode", e);
                    }, e.prototype.insertHTML = function(e, t) {
                        if (void 0 === t && (t = !0), "" !== e) {
                            var o, n = this.j.createInside.div(), r = this.j.createInside.fragment();
                            if (!this.isFocused() && this.j.isEditorMode() && (this.focus(), this.restore()), a.Dom.isNode(e) ? n.appendChild(e) : n.innerHTML = e.toString(), (this.j.isEditorMode() || !1 !== this.j.e.fire("insertHTML", n.innerHTML)) && (o = n.lastChild)) {
                                for(; n.firstChild;)o = n.firstChild, r.appendChild(n.firstChild);
                                this.insertNode(r.firstChild && r.firstChild === r.lastChild ? r.lastChild : r, !1, !1), t && (o ? this.setCursorAfter(o) : this.setCursorIn(r)), this.j.__imdSynchronizeValues();
                            }
                        }
                    }, e.prototype.insertImage = function(e, t, o) {
                        void 0 === t && (t = null), void 0 === o && (o = null);
                        var n = (0, d.isString)(e) ? this.j.createInside.element("img") : e;
                        if ((0, d.isString)(e) && n.setAttribute("src", e), null != o) {
                            var r = o.toString();
                            r && "auto" !== r && 0 > String(r).indexOf("px") && 0 > String(r).indexOf("%") && (r += "px"), (0, s.call)(this.j.o.resizer.forImageChangeAttributes ? s.attr : s.css, n, "width", r);
                        }
                        t && "object" == typeof t && (0, s.css)(n, t);
                        var i = function() {
                            (n.offsetHeight > n.naturalHeight || n.offsetWidth > n.naturalWidth) && (n.style.width = "", n.style.height = ""), n.removeEventListener("load", i);
                        };
                        this.j.e.on(n, "load", i), n.complete && i(), this.insertNode(n), this.j.e.fire("afterInsertImage", n);
                    }, e.prototype.eachSelection = function(e) {
                        var t, o = this, n = this.sel;
                        if (n && n.rangeCount) {
                            var r = n.getRangeAt(0), l = r.commonAncestorContainer;
                            a.Dom.isHTMLElement(l) || (l = l.parentElement);
                            var c = [], u = r.startOffset, p = l.childNodes.length, f = r.startContainer === this.area ? l.childNodes[p > u ? u : p - 1] : r.startContainer, h = r.endContainer === this.area ? l.childNodes[r.endOffset - 1] : r.endContainer;
                            a.Dom.isText(f) && f === r.startContainer && r.startOffset === (null === (t = f.nodeValue) || void 0 === t ? void 0 : t.length) && f.nextSibling && (f = f.nextSibling), a.Dom.isText(h) && h === r.endContainer && 0 === r.endOffset && h.previousSibling && (h = h.previousSibling);
                            var m = function(e) {
                                !e || e === l || a.Dom.isEmptyTextNode(e) || (0, d.isMarker)(e) || c.push(e);
                            };
                            m(f), f !== h && a.Dom.isOrContains(l, f, !0) && a.Dom.find(f, function(e) {
                                return m(e), e === h || e && e.contains && e.contains(h);
                            }, l, !0, !1);
                            var v = function(t) {
                                if (a.Dom.isOrContains(o.j.editor, t, !0)) {
                                    if (t.nodeName.match(/^(UL|OL)$/)) return (0, s.toArray)(t.childNodes).forEach(v);
                                    if (a.Dom.isTag(t, "li")) {
                                        if (t.firstChild) t = t.firstChild;
                                        else {
                                            var n = o.j.createInside.text(i.INVISIBLE_SPACE);
                                            t.appendChild(n), t = n;
                                        }
                                    }
                                    e(t);
                                }
                            };
                            0 === c.length && a.Dom.isEmptyTextNode(f) && c.push(f), 0 === c.length && f.firstChild && c.push(f.firstChild), c.forEach(v);
                        }
                    }, e.prototype.cursorInTheEdge = function(e, t, o) {
                        var n, r, l = this;
                        void 0 === o && (o = null);
                        var c = !e, u = null === (n = this.sel) || void 0 === n ? void 0 : n.getRangeAt(0);
                        if (null != o || (o = this.current(!1)), !u || !o || !a.Dom.isOrContains(t, o, !0)) return null;
                        var d = e ? u.startContainer : u.endContainer, p = e ? u.startOffset : u.endOffset, f = function(e) {
                            return Boolean(e && !a.Dom.isTag(e, "br") && !a.Dom.isEmptyTextNode(e) && !a.Dom.isTemporary(e) && !(a.Dom.isElement(e) && !0 === l.j.e.fire("isInvisibleForCursor", e)));
                        };
                        if (a.Dom.isText(d)) {
                            var h = (null === (r = d.nodeValue) || void 0 === r ? void 0 : r.length) ? d.nodeValue : "";
                            if (c && h.replace((0, i.INVISIBLE_SPACE_REG_EXP_END)(), "").length > p) return !1;
                            var m = (0, i.INVISIBLE_SPACE_REG_EXP_START)().exec(h);
                            if (e && (m && p > m[0].length || !m && p > 0)) return !1;
                        } else {
                            var v = (0, s.toArray)(d.childNodes);
                            if (c) {
                                if (v.slice(p).some(f)) return !1;
                            } else if (v.slice(0, p).some(f)) return !1;
                        }
                        for(var g = o; g && g !== t;){
                            var y = a.Dom.sibling(g, e);
                            if (y) {
                                if ((g = y) && f(g)) return !1;
                            } else g = g.parentNode;
                        }
                        return !0;
                    }, e.prototype.cursorOnTheLeft = function(e, t) {
                        return this.cursorInTheEdge(!0, e, t);
                    }, e.prototype.cursorOnTheRight = function(e, t) {
                        return this.cursorInTheEdge(!1, e, t);
                    }, e.prototype.setCursorAfter = function(e) {
                        return this.setCursorNearWith(e, !1);
                    }, e.prototype.setCursorBefore = function(e) {
                        return this.setCursorNearWith(e, !0);
                    }, e.prototype.setCursorNearWith = function(e, t) {
                        var o, n, i = this;
                        if (this.errorNode(e), !a.Dom.up(e, function(e) {
                            return e === i.area || e && e.parentNode === i.area;
                        }, this.area)) throw (0, s.error)("Node element must be in editor");
                        var l = this.createRange(), c = null;
                        return a.Dom.isText(e) ? t ? l.setStart(e, 0) : l.setEnd(e, null !== (n = null === (o = e.nodeValue) || void 0 === o ? void 0 : o.length) && void 0 !== n ? n : 0) : (c = this.j.createInside.text(r.INVISIBLE_SPACE), t ? l.setStartBefore(e) : l.setEndAfter(e), l.collapse(t), a.Dom.safeInsertNode(l, c), l.selectNode(c)), l.collapse(t), this.selectRange(l), c;
                    }, e.prototype.setCursorIn = function(e, t) {
                        var o = this;
                        if (void 0 === t && (t = !1), this.errorNode(e), !a.Dom.up(e, function(e) {
                            return e === o.area || e && e.parentNode === o.area;
                        }, this.area)) throw (0, s.error)("Node element must be in editor");
                        var n = this.createRange(), i = e, l = e;
                        do {
                            if (a.Dom.isText(i)) break;
                            l = i, i = t ? i.firstChild : i.lastChild;
                        }while (i);
                        if (!i) {
                            var c = this.j.createInside.text(r.INVISIBLE_SPACE);
                            /^(img|br|input)$/i.test(l.nodeName) ? i = l : (l.appendChild(c), l = c);
                        }
                        return n.selectNodeContents(i || l), n.collapse(t), this.selectRange(n), l;
                    }, e.prototype.selectRange = function(e, t) {
                        void 0 === t && (t = !0);
                        var o = this.sel;
                        return t && !this.isFocused() && this.focus(), o && (o.removeAllRanges(), o.addRange(e)), this.j.e.fire("changeSelection"), this;
                    }, e.prototype.select = function(e, t) {
                        var o = this;
                        if (void 0 === t && (t = !1), this.errorNode(e), !a.Dom.up(e, function(e) {
                            return e === o.area || e && e.parentNode === o.area;
                        }, this.area)) throw (0, s.error)("Node element must be in editor");
                        var n = this.createRange();
                        return n[t ? "selectNodeContents" : "selectNode"](e), this.selectRange(n);
                    }, Object.defineProperty(e.prototype, "html", {
                        get: function() {
                            var e = this.sel;
                            if (e && e.rangeCount > 0) {
                                var t = e.getRangeAt(0).cloneContents(), o = this.j.createInside.div();
                                return o.appendChild(t), o.innerHTML;
                            }
                            return "";
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.wrapInTagGen = function() {
                        var e, t, o, r, l, c, u, p, f, h, m;
                        return n.__generator(this, function(v) {
                            switch(v.label){
                                case 0:
                                    return this.isCollapsed() ? (c = this.jodit.createInside.element("font", i.INVISIBLE_SPACE), this.insertNode(c, !1, !1), e = n.__read(this.markers, 1), (t = e[0]) ? c.appendChild(t) : (this.setCursorIn(c), this.save()), [
                                        4,
                                        c
                                    ]) : [
                                        3,
                                        2
                                    ];
                                case 1:
                                    return v.sent(), a.Dom.unwrap(c), [
                                        2
                                    ];
                                case 2:
                                    (0, s.$$)("*[style*=font-size]", this.area).forEach(function(e) {
                                        (0, s.attr)(e, "data-font-size", e.style.fontSize.toString()), e.style.removeProperty("font-size");
                                    }), this.isCollapsed() ? (c = this.j.createInside.element("font"), (0, s.attr)(c, "size", 7), this.insertNode(c, !1, !1)) : this.j.nativeExecCommand("fontsize", !1, "7"), (0, s.$$)("*[data-font-size]", this.area).forEach(function(e) {
                                        var t = (0, s.attr)(e, "data-font-size");
                                        t && (e.style.fontSize = t, (0, s.attr)(e, "data-font-size", null));
                                    }), o = (0, s.$$)('font[size="7"]', this.area), v.label = 3;
                                case 3:
                                    v.trys.push([
                                        3,
                                        8,
                                        9,
                                        10
                                    ]), r = n.__values(o), l = r.next(), v.label = 4;
                                case 4:
                                    return l.done ? [
                                        3,
                                        7
                                    ] : (p = (c = l.value).lastChild, (u = c.firstChild) && u === p && (0, d.isMarker)(u) ? (a.Dom.unwrap(c), [
                                        3,
                                        6
                                    ]) : (u && (0, d.isMarker)(u) && a.Dom.before(c, u), p && (0, d.isMarker)(p) && a.Dom.after(c, p), [
                                        4,
                                        c
                                    ]));
                                case 5:
                                    v.sent(), a.Dom.unwrap(c), v.label = 6;
                                case 6:
                                    return l = r.next(), [
                                        3,
                                        4
                                    ];
                                case 7:
                                    return [
                                        3,
                                        10
                                    ];
                                case 8:
                                    return f = v.sent(), h = {
                                        error: f
                                    }, [
                                        3,
                                        10
                                    ];
                                case 9:
                                    try {
                                        l && !l.done && (m = r.return) && m.call(r);
                                    } finally{
                                        if (h) throw h.error;
                                    }
                                    return [
                                        7
                                    ];
                                case 10:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }, e.prototype.wrapInTag = function(e) {
                        var t, o, r = [];
                        try {
                            for(var i = n.__values(this.wrapInTagGen()), s = i.next(); !s.done; s = i.next()){
                                var l = s.value;
                                try {
                                    if (l.firstChild && l.firstChild === l.lastChild && (0, d.isMarker)(l.firstChild)) continue;
                                    (0, d.isFunction)(e) ? e(l) : r.push(a.Dom.replace(l, e, this.j.createInside));
                                } finally{
                                    var c = l.parentNode;
                                    c && (a.Dom.unwrap(l), a.Dom.isEmpty(c) && a.Dom.unwrap(c));
                                }
                            }
                        } catch (e) {
                            t = {
                                error: e
                            };
                        } finally{
                            try {
                                s && !s.done && (o = i.return) && o.call(i);
                            } finally{
                                if (t) throw t.error;
                            }
                        }
                        return r;
                    }, e.prototype.commitStyle = function(e) {
                        new l.CommitStyle(e).apply(this.j);
                    }, e.prototype.applyStyle = function(e, t) {
                        void 0 === t && (t = {}), this.commitStyle(n.__assign({
                            style: e
                        }, t));
                    }, e.prototype.splitSelection = function(e, t) {
                        if (!this.isCollapsed()) return null;
                        var o = this.createRange(), n = this.range;
                        o.setStartBefore(e);
                        var r = this.cursorOnTheRight(e, t), i = this.cursorOnTheLeft(e, t), s = this.j.createInside.element("br"), l = this.j.createInside.fake(), c = l.cloneNode();
                        try {
                            if (r || i) {
                                t ? a.Dom.before(t, s) : a.Dom.safeInsertNode(n, s);
                                var u = function(e, t) {
                                    for(var o = t(e); o;){
                                        var n = t(o);
                                        if (!o || !a.Dom.isTag(o, "br") && !a.Dom.isEmptyTextNode(o)) break;
                                        a.Dom.safeRemove(o), o = n;
                                    }
                                };
                                u(s, function(e) {
                                    return e.nextSibling;
                                }), u(s, function(e) {
                                    return e.previousSibling;
                                }), a.Dom.after(s, c), a.Dom.before(s, l), r ? (o.setEndBefore(s), n.setEndBefore(s)) : (o.setEndAfter(s), n.setEndAfter(s));
                            } else o.setEnd(n.startContainer, n.startOffset);
                            var d = o.extractContents(), p = function(e) {
                                return a.Dom.each(e, function(e) {
                                    return a.Dom.isEmptyTextNode(e) && a.Dom.safeRemove(e);
                                });
                            };
                            try {
                                if (p(d), p(e), e.parentNode.insertBefore(d, e), !t && r && (null == s ? void 0 : s.parentNode)) {
                                    var f = this.createRange();
                                    f.setStartBefore(s), this.selectRange(f);
                                }
                            } catch (e) {}
                            var h = function(e) {
                                var t, o, n;
                                (null === (t = null == e ? void 0 : e.parentNode) || void 0 === t ? void 0 : t.firstChild) === (null === (o = null == e ? void 0 : e.parentNode) || void 0 === o ? void 0 : o.lastChild) && (null === (n = null == e ? void 0 : e.parentNode) || void 0 === n || n.appendChild(s.cloneNode()));
                            };
                            h(l), h(c);
                        } finally{
                            a.Dom.safeRemove(l), a.Dom.safeRemove(c);
                        }
                        return e.previousElementSibling;
                    }, e.prototype.expandSelection = function() {
                        var e = this;
                        if (this.isCollapsed()) return this;
                        var t = this.range, o = t.cloneRange();
                        if (!a.Dom.isOrContains(this.j.editor, t.commonAncestorContainer, !0)) return this;
                        var n = function(o) {
                            var n = e.j.createInside.fake(), r = t.cloneRange();
                            return r.collapse(o), a.Dom.safeInsertNode(r, n), (0, u.moveTheNodeAlongTheEdgeOutward)(n, o, e.j.editor), n;
                        }, r = n(!0), i = n(!1);
                        o.setStartAfter(r), o.setEndBefore(i);
                        var s = a.Dom.findSibling(r, !1), l = a.Dom.findSibling(i, !0);
                        if (s !== l) {
                            var c = a.Dom.isElement(s) && a.Dom.isOrContains(s, i), d = !c && a.Dom.isElement(l) && a.Dom.isOrContains(l, r);
                            if (c || d) {
                                for(var p = c ? s : l, f = p; a.Dom.isElement(p);)(p = c ? p.firstElementChild : p.lastElementChild) && a.Dom.isOrContains(p, c ? i : r) && (f = p);
                                c ? o.setStart(f, 0) : o.setEnd(f, f.childNodes.length);
                            }
                        }
                        return this.selectRange(o), a.Dom.safeRemove(r, i), this;
                    }, n.__decorate([
                        c.autobind
                    ], e.prototype, "createRange", null), n.__decorate([
                        c.autobind
                    ], e.prototype, "focus", null), n.__decorate([
                        c.autobind
                    ], e.prototype, "setCursorAfter", null), n.__decorate([
                        c.autobind
                    ], e.prototype, "setCursorBefore", null), n.__decorate([
                        c.autobind
                    ], e.prototype, "setCursorIn", null), e;
                }();
                t.Select = p;
            },
            77846: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.extractSelectedPart = void 0;
                var n = o(67309), r = o(33941), i = o(24263), a = o(37204);
                function s(e, t, o) {
                    var a = t.extractContents();
                    a.textContent && (0, r.trim)(a.textContent).length || !a.firstChild || i.Dom.unwrap(a.firstChild), e.parentNode && (0, n.call)(o ? i.Dom.before : i.Dom.after, e, a);
                }
                t.extractSelectedPart = function(e, t, o) {
                    var n = o.s.createRange(), r = (0, a.isMarker)(t.previousSibling) ? t.previousSibling : t;
                    n.setStartBefore(e), n.setEndBefore(r), s(e, n, !0);
                    var i = (0, a.isMarker)(t.nextSibling) ? t.nextSibling : t;
                    n.setStartAfter(i), n.setEndAfter(e), s(e, n, !1);
                };
            },
            95901: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FiniteStateMachine = void 0, o(24421), o(603);
                var n = function() {
                    function e(e, t) {
                        this.transitions = t, this.silent = !0, this.__previewsStates = new Set, this.setState(e);
                    }
                    return e.prototype.setState = function(e) {
                        this.__previewsStates.add(e), this.__state = e;
                    }, e.prototype.getState = function() {
                        return this.__state;
                    }, e.prototype.disableSilent = function() {
                        this.silent = !1;
                    }, e.prototype.dispatch = function(e, t) {
                        var o = this.transitions[this.getState()][e];
                        if (o) {
                            var n = o.call(this, t);
                            return this.setState(n.next), n;
                        }
                        throw new Error("invalid action: ".concat(this.getState(), ".").concat(e.toString()));
                    }, e;
                }();
                t.FiniteStateMachine = n;
            },
            65774: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getSuitChild = void 0;
                var n = o(24263), r = o(63150), i = o(74477);
                t.getSuitChild = function(e, t) {
                    for(var o = t.firstChild; o && !(0, r.isNormalNode)(o);)if (!(o = o.nextSibling)) return null;
                    return o && !n.Dom.next(o, r.isNormalNode, t) && (0, i.isSuitElement)(e, o, !1) ? o : null;
                };
            },
            66277: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getSuitParent = void 0;
                var n = o(24263), r = o(63150), i = o(74477);
                t.getSuitParent = function e(t, o, a) {
                    var s = o.parentNode;
                    return s === a || !n.Dom.isHTMLElement(s) || n.Dom.next(o, r.isNormalNode, s) || n.Dom.prev(o, r.isNormalNode, s) ? null : t.isElementCommit && t.elementIsBlock && !n.Dom.isBlock(s) ? e(t, s, a) : !(0, i.isSuitElement)(t, s, !1) || n.Dom.isBlock(s) && !t.elementIsBlock ? t.isElementCommit && !n.Dom.isBlock(s) ? e(t, s, a) : null : s;
                };
            },
            18387: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hasSameStyleKeys = t.hasSameStyle = void 0;
                var n = o(26911), r = o(24021), i = o(49353), a = o(24263);
                o(52378), t.hasSameStyle = function(e, t) {
                    return Boolean(!a.Dom.isTag(e, "font") && a.Dom.isHTMLElement(e) && Object.keys(t).every(function(o) {
                        var a = (0, n.css)(e, o, !0);
                        return "" === a && ("" === t[o] || null == t[o]) || !(0, r.isVoid)(a) && "" !== a && !(0, r.isVoid)(t[o]) && (0, i.normalizeCssValue)(o, t[o]).toString().toLowerCase() === a.toString().toLowerCase();
                    }));
                }, document.createElement("div").style.color = "red", t.hasSameStyleKeys = function(e, t) {
                    return Boolean(!a.Dom.isTag(e, "font") && a.Dom.isHTMLElement(e) && Object.keys(t).every(function(t) {
                        var o = (0, n.css)(e, t, !0);
                        return !(0, r.isVoid)(o);
                    }));
                };
            },
            66162: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(93217), t), n.__exportStar(o(11651), t), n.__exportStar(o(29271), t), n.__exportStar(o(18387), t), n.__exportStar(o(77846), t), n.__exportStar(o(95901), t), n.__exportStar(o(65774), t), n.__exportStar(o(66277), t), n.__exportStar(o(76991), t), n.__exportStar(o(47508), t), n.__exportStar(o(63150), t), n.__exportStar(o(74477), t), n.__exportStar(o(26707), t), n.__exportStar(o(8298), t), n.__exportStar(o(6278), t);
            },
            76991: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isInsideInvisibleElement = void 0;
                var n = o(24263);
                t.isInsideInvisibleElement = function(e, t) {
                    return Boolean(n.Dom.closest(e, [
                        "style",
                        "script"
                    ], t));
                };
            },
            63150: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isNormalNode = void 0;
                var n = o(24263), r = o(37204);
                t.isNormalNode = function(e) {
                    return Boolean(e && !n.Dom.isEmptyTextNode(e) && !n.Dom.isTemporary(e) && !(0, r.isMarker)(e));
                };
            },
            47508: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.elementsEqualAttributes = t.isSameAttributes = void 0;
                var n = o(76502), r = o(16492), i = (o(52378), o(18387));
                t.isSameAttributes = function(e, t) {
                    return !e.attributes.length && !(0, r.size)(t) || !(0, r.size)(t) || Object.keys(t).every(function(o) {
                        return "class" === o ? e.classList.contains(t[o]) : "style" === o ? (0, i.hasSameStyle)(e, t[o]) : (0, n.attr)(e, o) === t[o];
                    });
                }, t.elementsEqualAttributes = function(e, t) {
                    return e.attributes.length === t.attributes.length && Array.from(e.attributes).every(function(e) {
                        return t.hasAttribute(e.name) && t.getAttribute(e.name) === e.value;
                    });
                };
            },
            74477: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isSameStyleChild = t.findSuitClosest = t.isSuitElement = void 0;
                var n = o(24263), r = o(63150), i = o(18387);
                function a(e, t, o) {
                    var a;
                    if (!t) return !1;
                    var s = e.element, l = e.elementIsDefault, c = e.options, u = Boolean((null === (a = c.attributes) || void 0 === a ? void 0 : a.style) && (0, i.hasSameStyle)(t, c.attributes.style)), d = t.nodeName.toLowerCase() === s || n.Dom.isTag(t, [
                        "ul",
                        "ol"
                    ]) && e.elementIsList;
                    return !((l && o || !d) && (!u || !(0, r.isNormalNode)(t) || e.elementIsList)) || Boolean(!d && !o && l && n.Dom.isInlineBlock(t));
                }
                t.isSuitElement = a, t.findSuitClosest = function(e, t, o) {
                    return n.Dom.closest(t, function(t) {
                        return a(e, t, !0);
                    }, o);
                }, t.isSameStyleChild = function(e, t) {
                    var o, n, a = e.element, s = e.options;
                    if (!t || !(0, r.isNormalNode)(t)) return !1;
                    var l = t.nodeName.toLowerCase() === a, c = Boolean((null === (o = s.attributes) || void 0 === o ? void 0 : o.style) && (0, i.hasSameStyleKeys)(t, null === (n = s.attributes) || void 0 === n ? void 0 : n.style));
                    return l && c;
                };
            },
            11651: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toggleOrderedList = void 0;
                var n = o(24263), r = (o(52378), o(77846)), i = o(70851), a = o(93217), s = o(66162);
                function l(e, t, o, a, s) {
                    return a.e.fire("".concat(i._PREFIX, "BeforeUnwrapList"), e, t, s) || ((0, r.extractSelectedPart)(t, o, a), n.Dom.unwrap(o.parentElement), n.Dom.replace(o, a.o.enter, a.createInside));
                }
                t.toggleOrderedList = function(e, t, o, n) {
                    if (!t) return n;
                    var r = t.parentElement;
                    if (!r) return n;
                    var c = o.e.fire("".concat(i._PREFIX, "BeforeToggleList"), n, e, r);
                    if (void 0 !== c) return c;
                    var u = o.e.fire.bind(o.e, "".concat(i._PREFIX, "AfterToggleList"));
                    if (n !== i.UNWRAP) {
                        var d = (0, a.toggleAttributes)(e, t.parentElement, o, i.INITIAL, !0) === i.CHANGE;
                        if (n === i.REPLACE || d || r.tagName.toLowerCase() !== e.element) {
                            var p = l(i.REPLACE, r, t, o, e), f = (0, s.wrapList)(e, p, o);
                            return u(i.REPLACE, f, e), i.REPLACE;
                        }
                    }
                    var h = l(i.UNWRAP, r, t, o, e);
                    return u(i.UNWRAP, h, e), i.UNWRAP;
                };
            },
            29271: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wrapList = void 0;
                var n = o(64968), r = o(70851), i = o(66162);
                t.wrapList = function(e, t, o) {
                    var a = o.e.fire("".concat(r._PREFIX, "BeforeWrapList"), r.REPLACE, t, e), s = null != a ? a : n.Dom.replace(t, "li", o.createInside), l = s.previousElementSibling, c = s.nextElementSibling, u = n.Dom.isTag(l, e.element) ? l : null;
                    return null != u || (u = n.Dom.isTag(c, e.element) ? c : null), n.Dom.isTag(u, [
                        "ul",
                        "ol"
                    ]) && (0, i.isSameAttributes)(u, e.options.attributes) || (u = o.createInside.element(e.element), (0, i.toggleAttributes)(e, u, o, r.INITIAL), n.Dom.before(s, u)), l === u ? n.Dom.append(u, s) : n.Dom.prepend(u, s), n.Dom.isTag(u.nextElementSibling, e.element) && (0, i.elementsEqualAttributes)(u, u.nextElementSibling) && (n.Dom.append(u, Array.from(u.nextElementSibling.childNodes)), n.Dom.safeRemove(u.nextElementSibling)), o.e.fire("".concat(r._PREFIX, "AfterWrapList"), r.WRAP, u, e), u;
                };
            },
            93217: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toggleAttributes = void 0;
                var n = o(76502), r = o(26911), i = o(63122), a = o(11278), s = o(49353), l = o(16492), c = o(24263), u = o(70851), d = o(17332), p = (o(10172), "toggleAttributes");
                function f(e, t, o) {
                    return (0, n.attr)(t, "style") || ((0, n.attr)(t, "style", null), t.tagName.toLowerCase() === e.defaultTag && (c.Dom.unwrap(t), o = u.UNWRAP)), o;
                }
                t.toggleAttributes = function(e, t, o, h, m) {
                    if (void 0 === m && (m = !1), !m && e.isApplied(t, p)) return h;
                    !m && e.setApplied(t, p);
                    var v = e.options.attributes;
                    return v && (0, l.size)(v) > 0 && Object.keys(v).forEach(function(l) {
                        var p = v[l];
                        switch(l){
                            case "style":
                                h = function(e, t, o, n, l, p) {
                                    return Object.keys(o).forEach(function(h) {
                                        var m = n.style.getPropertyValue((0, a.kebabCase)(h)), v = o[h];
                                        if ("" !== m || null != v) {
                                            if (function(e, t, o) {
                                                var n = e.create.element(t.tagName.toLowerCase());
                                                n.style.cssText = t.style.cssText, (function(e) {
                                                    var t;
                                                    if (void 0 !== (0, i.dataBind)(e, "shadowRoot")) return (0, i.dataBind)(e, "shadowRoot");
                                                    var o = (0, d.getContainer)(e), n = document.createElement("iframe");
                                                    (0, r.css)(n, {
                                                        width: 0,
                                                        height: 0,
                                                        position: "absolute",
                                                        border: 0
                                                    }), n.src = "about:blank", o.appendChild(n);
                                                    var a = null === (t = n.contentWindow) || void 0 === t ? void 0 : t.document, s = a ? a.body : e.od.body;
                                                    return (0, i.dataBind)(e, "shadowRoot", s), s;
                                                })(e).appendChild(n);
                                                var a = (0, r.css)(n, o);
                                                return c.Dom.safeRemove(n), a;
                                            }(t, n, h) === (0, s.normalizeCssValue)(h, v)) {
                                                if (!m) return;
                                                return !l && (0, r.css)(n, h, null), void (p = f(e, n, p = u.UNSET));
                                            }
                                            p = u.CHANGE, l || ((0, r.css)(n, h, v), p = f(e, n, p));
                                        }
                                    }), p;
                                }(e, o, p, t, m, h);
                                break;
                            case "class":
                                h = function(e, t, o, r, i) {
                                    var a = e.e.fire.bind(e.e, "".concat(u._PREFIX, "AfterToggleAttribute"));
                                    return o.classList.contains(t.toString()) ? (r = u.UNSET, i || (o.classList.remove(t), 0 === o.classList.length && ((0, n.attr)(o, "class", null), a(r, o, "class", null)))) : (r = u.CHANGE, i || (o.classList.add(t), a(r, o, "class", t))), r;
                                }(o, p, t, h, m);
                                break;
                            default:
                                h = function(e, t, o, r, i, a) {
                                    var s = e.e.fire.bind(e.e, "".concat(u._PREFIX, "AfterToggleAttribute"));
                                    return (0, n.attr)(o, r) === t ? (!i && (0, n.attr)(o, r, null), a = u.UNSET, !i && s(a, o, r, t), a) : (a = u.CHANGE, i || ((0, n.attr)(o, r, t), s(a, o, r, t)), a);
                                }(o, p, t, l, m, h);
                        }
                    }), h;
                };
            },
            26707: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.unwrapChildren = void 0;
                var n = o(24263), r = o(40332), i = o(18387), a = o(74477);
                t.unwrapChildren = function(e, t) {
                    var o, s, l = [], c = [], u = null === (o = e.options.attributes) || void 0 === o ? void 0 : o.style;
                    if (t.firstChild) for(var d = n.Dom.eachGen(t), p = d.next(), f = function() {
                        var t = p.value;
                        !(0, a.isSuitElement)(e, t, !0) || u && !(0, i.hasSameStyleKeys)(t, u) ? u && (0, a.isSameStyleChild)(e, t) ? (void 0 === s && (s = !1), c.push(function() {
                            (0, r.css)(t, Object.keys(u).reduce(function(e, t) {
                                return e[t] = null, e;
                            }, {})), (0, r.attr)(t, "style") || (0, r.attr)(t, "style", null), (0, r.attr)(t, "style") || t.nodeName.toLowerCase() !== e.element || l.push(t);
                        })) : n.Dom.isEmptyTextNode(t) || void 0 === s && (s = !1) : (void 0 === s && (s = !0), l.push(t)), p = d.next();
                    }; !p.done;)f();
                    return c.forEach(function(e) {
                        return e();
                    }), l.forEach(n.Dom.unwrap), Boolean(s);
                };
            },
            6278: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wrapUnwrappedText = void 0;
                var n = o(24263), r = o(37204);
                t.wrapUnwrappedText = function(e, t, o) {
                    var i = o.editor, a = o.createInside, s = function(e, t) {
                        void 0 === t && (t = "previousSibling");
                        for(var a = e, s = e; s && !(0, r.isMarker)(s) && !n.Dom.isTag(s, o.o.enter) && (a = s, s = s[t] ? s[t] : s.parentNode && !n.Dom.isBlock(s.parentNode) && s.parentNode !== i ? s.parentNode : null, !n.Dom.isBlock(s)););
                        return a;
                    }, l = s(t), c = s(t, "nextSibling"), u = o.s.createRange();
                    u.setStartBefore(l), u.setEndAfter(c);
                    var d = u.extractContents(), p = a.element(e.element);
                    return p.appendChild(d), n.Dom.safeInsertNode(u, p), e.elementIsBlock && n.Dom.isEmpty(p) && !n.Dom.isTag(p.firstElementChild, "br") && p.appendChild(a.element("br")), p;
                };
            },
            8298: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wrap = void 0;
                var n = o(64968), r = o(6278), i = o(67309), a = o(29271);
                t.wrap = function(e, t, o) {
                    var s = function(e, t, o) {
                        return e.elementIsBlock ? n.Dom.up(t, function(e) {
                            return n.Dom.isBlock(e) && !n.Dom.isTag(e, [
                                "td",
                                "th",
                                "tr",
                                "tbody",
                                "table",
                                "li",
                                "ul",
                                "ol"
                            ]);
                        }, o.editor) || (0, r.wrapUnwrappedText)(e, t, o) : ((0, i.attr)(t, "size", null), t);
                    }(e, t, o);
                    return e.elementIsList ? (0, a.wrapList)(e, s, o) : n.Dom.replace(s, e.element, o.createInside, !0);
                };
            },
            3097: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ApplyStyle = void 0;
                var n = o(74504), r = o(66162), i = o(33090), a = o(70851);
                t.ApplyStyle = function(e, t) {
                    var o = e.s, s = e.editor;
                    o.save(), (0, n.normalizeNode)(s.firstChild);
                    for(var l = e.s.wrapInTagGen(), c = l.next(), u = {
                        mode: a.INITIAL,
                        element: c.value,
                        next: i.states.START,
                        jodit: e,
                        style: t
                    }; c && !c.done;){
                        var d = new r.FiniteStateMachine(i.states.START, i.transactions);
                        for(u.element = c.value; d.getState() !== i.states.END;)u = d.dispatch("exec", u);
                        c = l.next();
                    }
                    o.restore();
                };
            },
            70851: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.CommitStyle = t._PREFIX = t.REPLACE = t.INITIAL = t.UNSET = t.CHANGE = t.UNWRAP = t.WRAP = void 0;
                var n = o(86893), r = o(26596), i = o(3097);
                t.WRAP = "wrap", t.UNWRAP = "unwrap", t.CHANGE = "change", t.UNSET = "unset", t.INITIAL = "initial", t.REPLACE = "replace", t._PREFIX = "commitStyle";
                var a = function() {
                    function e(e) {
                        var t, o, n, r;
                        this.options = e, this.__applyMap = new WeakMap, e.attributes = (t = e.attributes, r = (o = this.options).className, (n = o.style) && (t ? t.style = n : t = {
                            style: n
                        }, delete this.options.style), r && (t ? t.class = r : t = {
                            class: r
                        }, delete this.options.className), t);
                    }
                    return e.prototype.isApplied = function(e, t) {
                        var o = this.__applyMap.get(e);
                        return !!o && o[t];
                    }, e.prototype.setApplied = function(e, t) {
                        var o, n = null !== (o = this.__applyMap.get(e)) && void 0 !== o ? o : {};
                        n[t] = !0, this.__applyMap.set(e, n);
                    }, Object.defineProperty(e.prototype, "elementIsList", {
                        get: function() {
                            return Boolean(this.options.element && [
                                "ul",
                                "ol"
                            ].includes(this.options.element));
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "element", {
                        get: function() {
                            return this.options.element || this.defaultTag;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "elementIsBlock", {
                        get: function() {
                            return Boolean(this.options.element && n.IS_BLOCK.test(this.options.element));
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "isElementCommit", {
                        get: function() {
                            return Boolean(this.options.element && this.options.element !== this.options.defaultTag);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "defaultTag", {
                        get: function() {
                            return this.options.defaultTag ? this.options.defaultTag : this.elementIsBlock ? "p" : "span";
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "elementIsDefault", {
                        get: function() {
                            return this.element === this.defaultTag;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.apply = function(e) {
                        var o = this.options.hooks;
                        try {
                            o && Object.keys(o).forEach(function(n) {
                                e.e.on((0, r.camelCase)(t._PREFIX + "_" + n), o[n]);
                            }), (0, i.ApplyStyle)(e, this);
                        } finally{
                            o && Object.keys(o).forEach(function(n) {
                                e.e.off((0, r.camelCase)(t._PREFIX + "_" + n), o[n]);
                            }), this.__applyMap = new WeakMap;
                        }
                    }, e;
                }();
                t.CommitStyle = a;
            },
            33090: function(e, t, o) {
                "use strict";
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.transactions = t.states = void 0;
                var r = o(20255), i = o(2123), a = o(66162), s = o(64968), l = o(2123);
                o(52378), t.states = {
                    START: "START",
                    ELEMENT: "ELEMENT",
                    UNWRAP: "UNWRAP",
                    UNWRAP_CHILDREN: "UNWRAP_CHILDREN",
                    CHANGE: "CHANGE",
                    REPLACE_DEFAULT: "REPLACE_DEFAULT",
                    LIST: "LIST",
                    TOGGLE_LIST: "TOGGLE_LIST",
                    WRAP: "WRAP",
                    EXTRACT: "EXTRACT",
                    END: "END"
                }, t.transactions = ((n = {})[t.states.START] = {
                    exec: function(e) {
                        var o = e.element, n = e.jodit, i = e.style, c = e.mode;
                        if ((0, a.isInsideInvisibleElement)(o, n.editor) || s.Dom.isEmptyContent(o)) return r.__assign(r.__assign({}, e), {
                            next: t.states.END
                        });
                        var u = (0, a.getSuitParent)(i, o, n.editor) || (0, a.getSuitChild)(i, o);
                        if (u) return r.__assign(r.__assign({}, e), {
                            next: t.states.ELEMENT,
                            element: u
                        });
                        var d = (0, a.findSuitClosest)(i, o, n.editor);
                        return i.elementIsList && s.Dom.isTag(d, [
                            "ul",
                            "ol"
                        ]) ? r.__assign(r.__assign({}, e), {
                            next: t.states.LIST
                        }) : r.__assign(r.__assign({}, e), d ? {
                            next: t.states.EXTRACT
                        } : {
                            next: c !== l.UNWRAP ? t.states.UNWRAP_CHILDREN : t.states.END
                        });
                    }
                }, n[t.states.LIST] = {
                    exec: function(e) {
                        var o = e.element, n = e.jodit, a = e.mode;
                        if (a !== l.INITIAL && a !== l.UNWRAP && a !== i.REPLACE) return r.__assign(r.__assign({}, e), {
                            next: t.states.END
                        });
                        var c = s.Dom.closest(o, "li", n.editor);
                        if (!c) return r.__assign(r.__assign({}, e), {
                            next: t.states.END
                        });
                        var u = s.Dom.closest(o, [
                            "ul",
                            "ol"
                        ], n.editor);
                        return r.__assign(r.__assign({}, e), u ? {
                            element: c,
                            next: t.states.TOGGLE_LIST
                        } : {
                            next: t.states.END
                        });
                    }
                }, n[t.states.TOGGLE_LIST] = {
                    exec: function(e) {
                        return r.__assign(r.__assign({}, e), {
                            mode: (0, a.toggleOrderedList)(e.style, e.element, e.jodit, e.mode),
                            next: t.states.END
                        });
                    }
                }, n[t.states.EXTRACT] = {
                    exec: function(e) {
                        var o = e.element, n = e.jodit, i = e.style, s = (0, a.findSuitClosest)(i, o, n.editor);
                        return i.elementIsBlock || (0, a.extractSelectedPart)(s, o, n), r.__assign(r.__assign({}, e), {
                            element: s,
                            next: t.states.ELEMENT
                        });
                    }
                }, n[t.states.UNWRAP_CHILDREN] = {
                    exec: function(e) {
                        return (0, a.unwrapChildren)(e.style, e.element) ? r.__assign(r.__assign({}, e), {
                            mode: l.UNWRAP,
                            next: t.states.END
                        }) : r.__assign(r.__assign({}, e), {
                            next: t.states.WRAP
                        });
                    }
                }, n[t.states.WRAP] = {
                    exec: function(e) {
                        var o = e.style, n = (0, a.wrap)(o, e.element, e.jodit);
                        return r.__assign(r.__assign({}, e), {
                            next: o.elementIsList ? t.states.END : t.states.CHANGE,
                            mode: l.WRAP,
                            element: n
                        });
                    }
                }, n[t.states.ELEMENT] = {
                    exec: function(e) {
                        var o = e.style, n = e.element;
                        return (0, a.toggleAttributes)(o, n, e.jodit, l.INITIAL, !0) !== l.INITIAL ? r.__assign(r.__assign({}, e), {
                            next: t.states.CHANGE
                        }) : s.Dom.isTag(n, o.element) ? r.__assign(r.__assign({}, e), {
                            next: t.states.UNWRAP
                        }) : r.__assign(r.__assign({}, e), {
                            next: t.states.END
                        });
                    }
                }, n[t.states.CHANGE] = {
                    exec: function(e) {
                        var o = e.style, n = e.element, i = e.mode, c = (0, a.toggleAttributes)(o, n, e.jodit, e.mode);
                        return i !== l.WRAP && c === l.UNSET && !n.attributes.length && s.Dom.isTag(n, o.element) ? r.__assign(r.__assign({}, e), {
                            next: t.states.UNWRAP
                        }) : r.__assign(r.__assign({}, e), {
                            mode: c,
                            next: t.states.END
                        });
                    }
                }, n[t.states.UNWRAP] = {
                    exec: function(e) {
                        return e.element.attributes.length && s.Dom.isTag(e.element, e.style.element) ? r.__assign(r.__assign({}, e), {
                            next: t.states.REPLACE_DEFAULT
                        }) : (s.Dom.unwrap(e.element), r.__assign(r.__assign({}, e), {
                            mode: l.UNWRAP,
                            next: t.states.END
                        }));
                    }
                }, n[t.states.REPLACE_DEFAULT] = {
                    exec: function(e) {
                        return s.Dom.replace(e.element, e.style.defaultTag, e.jodit.createInside, !0), r.__assign(r.__assign({}, e), {
                            mode: i.REPLACE,
                            next: t.states.END
                        });
                    }
                }, n[t.states.END] = {
                    exec: function(e) {
                        return e;
                    }
                }, n);
            },
            75764: function(e, t) {
                "use strict";
                var o;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LocalStorageProvider = t.canUsePersistentStorage = void 0, t.canUsePersistentStorage = function() {
                    return void 0 === o && (o = function() {
                        var e = "___Jodit___" + Math.random().toString();
                        try {
                            localStorage.setItem(e, "1");
                            var t = "1" === localStorage.getItem(e);
                            return localStorage.removeItem(e), t;
                        } catch (e) {}
                        return !1;
                    }()), o;
                };
                var n = function() {
                    function e(e) {
                        this.rootKey = e;
                    }
                    return e.prototype.set = function(e, t) {
                        try {
                            var o = localStorage.getItem(this.rootKey), n = o ? JSON.parse(o) : {};
                            n[e] = t, localStorage.setItem(this.rootKey, JSON.stringify(n));
                        } catch (e) {}
                        return this;
                    }, e.prototype.delete = function(e) {
                        try {
                            localStorage.removeItem(this.rootKey);
                        } catch (e) {}
                        return this;
                    }, e.prototype.get = function(e) {
                        try {
                            var t = localStorage.getItem(this.rootKey), o = t ? JSON.parse(t) : {};
                            return void 0 !== o[e] ? o[e] : null;
                        } catch (e) {}
                    }, e.prototype.exists = function(e) {
                        return null != this.get(e);
                    }, e.prototype.clear = function() {
                        try {
                            localStorage.removeItem(this.rootKey);
                        } catch (e) {}
                        return this;
                    }, e;
                }();
                t.LocalStorageProvider = n;
            },
            79905: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.MemoryStorageProvider = void 0;
                var o = function() {
                    function e() {
                        this.data = new Map;
                    }
                    return e.prototype.set = function(e, t) {
                        return this.data.set(e, t), this;
                    }, e.prototype.delete = function(e) {
                        return this.data.delete(e), this;
                    }, e.prototype.get = function(e) {
                        return this.data.get(e);
                    }, e.prototype.exists = function(e) {
                        return this.data.has(e);
                    }, e.prototype.clear = function() {
                        return this.data.clear(), this;
                    }, e;
                }();
                t.MemoryStorageProvider = o;
            },
            77462: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(79905), t), n.__exportStar(o(75764), t), n.__exportStar(o(52015), t);
            },
            52015: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Storage = t.StorageKey = void 0;
                var n = o(40332), r = o(75764), i = o(79905);
                t.StorageKey = "Jodit_";
                var a = function() {
                    function e(e, o) {
                        this.provider = e, this.prefix = t.StorageKey, o && (this.prefix += o);
                    }
                    return e.prototype.set = function(e, t) {
                        return this.provider.set((0, n.camelCase)(this.prefix + e), t), this;
                    }, e.prototype.delete = function(e) {
                        return this.provider.delete((0, n.camelCase)(this.prefix + e)), this;
                    }, e.prototype.get = function(e) {
                        return this.provider.get((0, n.camelCase)(this.prefix + e));
                    }, e.prototype.exists = function(e) {
                        return this.provider.exists((0, n.camelCase)(this.prefix + e));
                    }, e.prototype.clear = function() {
                        return this.provider.clear(), this;
                    }, e.makeStorage = function(o, n) {
                        var a;
                        return void 0 === o && (o = !1), o && (0, r.canUsePersistentStorage)() && (a = new r.LocalStorageProvider(t.StorageKey + n)), a || (a = new i.MemoryStorageProvider), new e(a, n);
                    }, e;
                }();
                t.Storage = a;
            },
            59363: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Dlgs = void 0;
                var n = o(20255), r = o(87837), i = o(40332), a = function() {
                    function e() {}
                    return e.prototype.dlg = function(e) {
                        var t = new r.Dialog(n.__assign({
                            language: this.o.language,
                            shadowRoot: this.o.shadowRoot,
                            ownerWindow: this.o.ownerWindow,
                            defaultTimeout: this.o.defaultTimeout,
                            theme: this.o.theme,
                            globalFullSize: this.o.globalFullSize
                        }, e));
                        return (0, i.markOwner)(this, t.container), t.parent = this, t.bindDestruct(this);
                    }, e.prototype.confirm = function(e, t, o) {
                        return (0, i.isString)(t) && (t = this.i18n(t)), r.Confirm.call(this.dlg(), this.i18n(e), t, o);
                    }, e.prototype.prompt = function(e, t, o, n, a) {
                        return (0, i.isString)(t) && (t = this.i18n(t)), (0, i.isString)(n) && (n = this.i18n(n)), r.Prompt.call(this.dlg(), this.i18n(e), t, o, n, a);
                    }, e.prototype.alert = function(e, t, o, n) {
                        return (0, i.isString)(e) && (e = this.i18n(e)), (0, i.isString)(t) && (t = this.i18n(t)), r.Alert.call(this.dlg(), e, t, o, n);
                    }, e;
                }();
                t.Dlgs = a;
            },
            14089: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Elms = void 0;
                var n = o(1853), r = function() {
                    function e() {}
                    return e.prototype.getElm = function(e) {
                        return this.container.querySelector(".".concat(this.getFullElName(e)));
                    }, e.prototype.getElms = function(e) {
                        return (0, n.toArray)(this.container.querySelectorAll(".".concat(this.getFullElName(e))));
                    }, e;
                }();
                t.Elms = r;
            },
            59829: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(14089), t), n.__exportStar(o(41681), t), n.__exportStar(o(59363), t);
            },
            41681: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Mods = void 0;
                var n = o(1853), r = o(24021), i = function() {
                    function e() {}
                    return e.prototype.afterSetMod = function(e, t) {}, e.prototype.setMod = function(e, t, o) {
                        if (e = e.toLowerCase(), this.mods[e] === t) return this;
                        var i = "".concat(this.componentName, "_").concat(e), a = (o || this.container).classList;
                        return (0, n.toArray)(a).forEach(function(e) {
                            0 === e.indexOf(i) && a.remove(e);
                        }), !(0, r.isVoid)(t) && "" !== t && a.add("".concat(i, "_").concat(t.toString().toLowerCase())), this.mods[e] = t, this.afterSetMod(e, t), this;
                    }, e.prototype.getMod = function(e) {
                        var t;
                        return null !== (t = this.mods[e]) && void 0 !== t ? t : null;
                    }, e;
                }();
                t.Mods = i;
            },
            96031: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Button = t.UIButton = t.UIButtonState = void 0;
                var n = o(20255);
                o(93330);
                var r = o(53929), i = o(24263), a = o(76502), s = o(24421), l = o(42096), c = o(77904), u = o(47970), d = o(43441), p = o(29411);
                t.UIButtonState = function() {
                    return {
                        size: "middle",
                        type: "button",
                        name: "",
                        value: "",
                        variant: "initial",
                        disabled: !1,
                        activated: !1,
                        icon: {
                            name: "empty",
                            fill: "",
                            iconURL: ""
                        },
                        tooltip: "",
                        text: "",
                        tabIndex: void 0
                    };
                };
                var f = function(e) {
                    function o(o, n) {
                        var r = e.call(this, o) || this;
                        return r.isButton = !0, r.state = (0, t.UIButtonState)(), r.actionHandlers = [], r.updateSize(), r.onChangeSize(), r.onChangeStatus(), n && r.hookStatus(p.STATUSES.ready, function() {
                            r.setState(n);
                        }), r;
                    }
                    return n.__extends(o, e), o.prototype.className = function() {
                        return "UIButton";
                    }, o.prototype.setState = function(e) {
                        return Object.assign(this.state, e), this;
                    }, o.prototype.onChangeSize = function() {
                        this.setMod("size", this.state.size);
                    }, o.prototype.onChangeType = function() {
                        (0, a.attr)(this.container, "type", this.state.type);
                    }, o.prototype.updateSize = function() {
                        var e = this.closest(u.UIList);
                        e && (this.state.size = e.buttonSize);
                    }, o.prototype.onChangeStatus = function() {
                        this.setMod("variant", this.state.variant);
                    }, o.prototype.onChangeText = function() {
                        this.text.textContent = this.jodit.i18n(this.state.text);
                    }, o.prototype.onChangeTextSetMode = function() {
                        this.setMod("text-icons", Boolean(this.state.text.trim().length));
                    }, o.prototype.onChangeDisabled = function() {
                        (0, a.attr)(this.container, "disabled", this.state.disabled || null);
                    }, o.prototype.onChangeActivated = function() {
                        (0, a.attr)(this.container, "aria-pressed", this.state.activated);
                    }, o.prototype.onChangeName = function() {
                        this.container.classList.add("".concat(this.componentName, "_").concat(this.clearName(this.state.name))), this.name = this.state.name, (0, a.attr)(this.container, "data-ref", this.state.name), (0, a.attr)(this.container, "ref", this.state.name);
                    }, o.prototype.onChangeTooltip = function() {
                        this.get("j.o.useNativeTooltip") && (0, a.attr)(this.container, "title", this.state.tooltip), (0, a.attr)(this.container, "aria-label", this.state.tooltip);
                    }, o.prototype.onChangeTabIndex = function() {
                        (0, a.attr)(this.container, "tabindex", this.state.tabIndex);
                    }, o.prototype.onChangeIcon = function() {
                        var e = this.get("j.o.textIcons");
                        if (!(!0 === e || (0, l.isFunction)(e) && e(this.state.name))) {
                            i.Dom.detach(this.icon);
                            var t = c.Icon.makeIcon(this.j, this.state.icon);
                            t && this.icon.appendChild(t);
                        }
                    }, o.prototype.focus = function() {
                        this.container.focus();
                    }, o.prototype.isFocused = function() {
                        var e = this.od.activeElement;
                        return Boolean(e && i.Dom.isOrContains(this.container, e));
                    }, o.prototype.createContainer = function() {
                        var e = this.componentName, t = this.j.c.element("button", {
                            class: e,
                            type: "button",
                            role: "button",
                            ariaPressed: !1
                        });
                        return this.icon = this.j.c.span(e + "__icon"), this.text = this.j.c.span(e + "__text"), t.appendChild(this.icon), t.appendChild(this.text), this.j.e.on(t, "click", this.onActionFire), t;
                    }, o.prototype.destruct = function() {
                        return this.j.e.off(this.container), e.prototype.destruct.call(this);
                    }, o.prototype.onAction = function(e) {
                        return this.actionHandlers.push(e), this;
                    }, o.prototype.onActionFire = function(e) {
                        var t = this;
                        e.buffer = {
                            actionTrigger: this
                        }, this.actionHandlers.forEach(function(o) {
                            return o.call(t, e);
                        });
                    }, n.__decorate([
                        (0, d.watch)("state.size")
                    ], o.prototype, "onChangeSize", null), n.__decorate([
                        (0, d.watch)("state.type")
                    ], o.prototype, "onChangeType", null), n.__decorate([
                        (0, d.watch)("parentElement")
                    ], o.prototype, "updateSize", null), n.__decorate([
                        (0, d.watch)("state.variant")
                    ], o.prototype, "onChangeStatus", null), n.__decorate([
                        (0, d.watch)("state.text")
                    ], o.prototype, "onChangeText", null), n.__decorate([
                        (0, d.watch)("state.text")
                    ], o.prototype, "onChangeTextSetMode", null), n.__decorate([
                        (0, d.watch)("state.disabled")
                    ], o.prototype, "onChangeDisabled", null), n.__decorate([
                        (0, d.watch)("state.activated")
                    ], o.prototype, "onChangeActivated", null), n.__decorate([
                        (0, d.watch)("state.name")
                    ], o.prototype, "onChangeName", null), n.__decorate([
                        (0, d.watch)("state.tooltip")
                    ], o.prototype, "onChangeTooltip", null), n.__decorate([
                        (0, d.watch)("state.tabIndex")
                    ], o.prototype, "onChangeTabIndex", null), n.__decorate([
                        (0, d.watch)("state.icon")
                    ], o.prototype, "onChangeIcon", null), n.__decorate([
                        d.autobind
                    ], o.prototype, "onActionFire", null), n.__decorate([
                        d.component
                    ], o);
                }(r.UIElement);
                t.UIButton = f, t.Button = function(e, t, o, n) {
                    var r = new f(e);
                    return r.state.tabIndex = e.o.allowTabNavigation ? 0 : -1, (0, s.isString)(t) ? (r.state.icon.name = t, r.state.name = t, n && (r.state.variant = n), o && (r.state.text = o)) : r.setState(t), r;
                };
            },
            67252: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIButtonGroup = void 0;
                var n = o(20255);
                o(45066);
                var r = o(61479), i = o(11441), a = o(96031), s = (o(52378), function(e) {
                    function t(t, o) {
                        void 0 === o && (o = {
                            radio: !0
                        });
                        var n, r, i = this;
                        return (i = e.call(this, t, null === (n = o.options) || void 0 === n ? void 0 : n.map(function(e) {
                            var o = new a.UIButton(t, {
                                text: e.text,
                                value: e.value,
                                variant: "primary"
                            });
                            return o.onAction(function() {
                                i.select(e.value);
                            }), o;
                        }), o) || this).options = o, i.select(null !== (r = o.value) && void 0 !== r ? r : 0), i;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UIButtonGroup";
                    }, t.prototype.render = function(e) {
                        return '<div>\n\t\t\t<div class="&__label">~'.concat(e.label, '~</div>\n\t\t\t<div class="&__options"></div>\n\t\t</div>');
                    }, t.prototype.appendChildToContainer = function(e) {
                        this.getElm("options").appendChild(e);
                    }, t.prototype.select = function(e) {
                        var t, o, n = this;
                        this.elements.forEach(function(t, o) {
                            o === e || t.state.value === e ? t.state.activated = !0 : n.options.radio && (t.state.activated = !1);
                        });
                        var r = this.elements.filter(function(e) {
                            return e.state.activated;
                        }).map(function(e) {
                            return {
                                text: e.state.text,
                                value: e.state.value
                            };
                        });
                        this.jodit.e.fire(this, "select", r), null === (o = (t = this.options).onChange) || void 0 === o || o.call(t, r);
                    }, n.__decorate([
                        i.component
                    ], t);
                }(r.UIGroup));
                t.UIButtonGroup = s;
            },
            96516: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(96031), t), n.__exportStar(o(67252), t), n.__exportStar(o(33627), t);
            },
            33627: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UITooltip = void 0;
                var n = o(20255);
                o(99895);
                var r = o(40332), i = o(17332), a = o(43441), s = function(e) {
                    function t(o) {
                        var n = e.call(this, o) || this;
                        n.__isOpened = !1, n.__useCount = 1, n.__delayShowTimeout = 0, (0, i.getContainer)(o, t).appendChild(n.container);
                        var r = 0;
                        return o.e.off(".tooltip").on("showTooltip.tooltip", function(e, t) {
                            o.async.clearTimeout(r), n.__open(e, t);
                        }).on("delayShowTooltip.tooltip", n.__delayOpen).on("escape.tooltip", n.__close).on("hideTooltip.tooltip change.tooltip scroll.tooltip changePlace.tooltip hidePopup.tooltip closeAllPopups.tooltip", function() {
                            n.j.async.clearTimeout(n.__delayShowTimeout), r = o.async.setTimeout(n.__close, n.j.defaultTimeout);
                        }), n;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UITooltip";
                    }, t.make = function(e) {
                        var o = (0, r.dataBind)(e, "ui-tooltip");
                        return o ? (o.__useCount += 1, o) : (o = new t(e), (0, r.dataBind)(e, "ui-tooltip", o), o);
                    }, t.prototype.__delayOpen = function(e, t) {
                        var o = this, n = this.j.o.showTooltipDelay || this.j.defaultTimeout;
                        this.j.async.clearTimeout(this.__delayShowTimeout), this.__delayShowTimeout = this.j.async.setTimeout(function() {
                            return o.__open(e, t);
                        }, {
                            timeout: n,
                            label: "tooltip"
                        });
                    }, t.prototype.__open = function(e, t) {
                        this.setMod("visible", !0), this.container.innerHTML = t, this.__isOpened = !0, this.__setPosition(e);
                    }, t.prototype.__setPosition = function(e) {
                        var t = e();
                        (0, r.css)(this.container, {
                            left: t.x,
                            top: t.y
                        });
                    }, t.prototype.__close = function() {
                        this.j.async.clearTimeout(this.__delayShowTimeout), this.__isOpened && (this.__isOpened = !1, this.setMod("visible", !1), (0, r.css)(this.container, {
                            left: -5000
                        }));
                    }, t.prototype.destruct = function() {
                        var t;
                        this.__useCount--, this.__useCount || (null === (t = this.j) || void 0 === t || t.e.off(".tooltip"), this.__close(), e.prototype.destruct.call(this));
                    }, n.__decorate([
                        a.autobind
                    ], t.prototype, "__delayOpen", null), n.__decorate([
                        a.autobind
                    ], t.prototype, "__close", null), t;
                }(o(53929).UIElement);
                t.UITooltip = s;
            },
            53929: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIElement = void 0;
                var n = o(20255), r = o(56562), i = o(24263), a = o(59829), s = o(24421), l = o(77904), c = o(43441), u = function(e) {
                    function t(t, o) {
                        var n = e.call(this, t) || this;
                        return n.name = "", n.__parentElement = null, n.mods = {}, n.container = n.createContainer(o), Object.defineProperty(n.container, "component", {
                            value: n,
                            configurable: !0
                        }), n;
                    }
                    var o;
                    return n.__extends(t, e), o = t, Object.defineProperty(t.prototype, "parentElement", {
                        get: function() {
                            return this.__parentElement;
                        },
                        set: function(e) {
                            var t = this;
                            this.__parentElement = e, e && e.hookStatus("beforeDestruct", function() {
                                return t.destruct();
                            }), this.updateParentElement(this);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.bubble = function(e) {
                        for(var t = this.parentElement; t;)e(t), t = t.parentElement;
                        return this;
                    }, t.prototype.updateParentElement = function(e) {
                        var t;
                        return null === (t = this.__parentElement) || void 0 === t || t.updateParentElement(e), this;
                    }, t.prototype.get = function(t, o) {
                        return e.prototype.get.call(this, t, o) || this.getElm(t);
                    }, t.prototype.closest = function(e) {
                        for(var t = "object" == typeof e ? function(t) {
                            return t === e;
                        } : function(t) {
                            return r.Component.isInstanceOf(t, e);
                        }, n = this.__parentElement; n;){
                            if (t(n)) return n;
                            n = !n.parentElement && n.container.parentElement ? o.closestElement(n.container.parentElement, o) : n.parentElement;
                        }
                        return null;
                    }, t.closestElement = function(e, t) {
                        var o = i.Dom.up(e, function(e) {
                            if (e) {
                                var o = e.component;
                                return o && r.Component.isInstanceOf(o, t);
                            }
                            return !1;
                        });
                        return o ? null == o ? void 0 : o.component : null;
                    }, t.prototype.update = function() {}, t.prototype.appendTo = function(e) {
                        return e.appendChild(this.container), this;
                    }, t.prototype.clearName = function(e) {
                        return e.replace(/[^a-zA-Z0-9]/g, "_");
                    }, t.prototype.render = function(e) {
                        return this.j.c.div(this.componentName);
                    }, t.prototype.createContainer = function(e) {
                        var t = this.render(e);
                        if ((0, s.isString)(t)) {
                            var o = this.parseTemplate(t);
                            return o.classList.add(this.componentName), o;
                        }
                        return t;
                    }, t.prototype.parseTemplate = function(e) {
                        var t = this;
                        return this.j.c.fromHTML(e.replace(/\*([^*]+?)\*/g, function(e, t) {
                            return l.Icon.get(t) || "";
                        }).replace(/&__/g, this.componentName + "__").replace(/~([^~]+?)~/g, function(e, o) {
                            return t.i18n(o);
                        }));
                    }, t.prototype.destruct = function() {
                        return i.Dom.safeRemove(this.container), this.parentElement = null, e.prototype.destruct.call(this);
                    }, o = n.__decorate([
                        (0, c.derive)(a.Mods, a.Elms)
                    ], t);
                }(r.ViewComponent);
                t.UIElement = u;
            },
            38318: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIBlock = void 0;
                var n = o(20255);
                o(87682);
                var r = o(61479), i = o(76502), a = o(11441), s = function(e) {
                    function t(t, o, n) {
                        void 0 === n && (n = {
                            align: "left"
                        });
                        var r = e.call(this, t, o) || this;
                        return r.options = n, r.setMod("align", r.options.align || "left"), r.setMod("width", r.options.width || ""), r.options.mod && r.setMod(r.options.mod, !0), r.options.className && r.container.classList.add(r.options.className), (0, i.attr)(r.container, "data-ref", n.ref), (0, i.attr)(r.container, "ref", n.ref), r;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UIBlock";
                    }, n.__decorate([
                        a.component
                    ], t);
                }(r.UIGroup);
                t.UIBlock = s;
            },
            26207: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIForm = void 0;
                var n = o(20255), r = o(61479), i = o(30194), a = o(75840), s = o(76502), l = o(11441), c = o(45113), u = function(e) {
                    function t() {
                        for(var t = [], o = 0; arguments.length > o; o++)t[o] = arguments[o];
                        var r, i, a = this;
                        return (null === (r = (a = e.apply(this, n.__spreadArray([], n.__read(t), !1)) || this).options) || void 0 === r ? void 0 : r.className) && a.container.classList.add(null === (i = a.options) || void 0 === i ? void 0 : i.className), a;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UIForm";
                    }, t.prototype.submit = function() {
                        this.j.e.fire(this.container, "submit");
                    }, t.prototype.validate = function() {
                        var e, t, o, r, s = this.allChildren.filter(function(e) {
                            return c.Component.isInstanceOf(e, i.UIInput);
                        });
                        try {
                            for(var l = n.__values(s), u = l.next(); !u.done; u = l.next())if (!u.value.validate()) return !1;
                        } catch (t) {
                            e = {
                                error: t
                            };
                        } finally{
                            try {
                                u && !u.done && (t = l.return) && t.call(l);
                            } finally{
                                if (e) throw e.error;
                            }
                        }
                        var d = this.allChildren.filter(function(e) {
                            return c.Component.isInstanceOf(e, a.UISelect);
                        });
                        try {
                            for(var p = n.__values(d), f = p.next(); !f.done; f = p.next())if (!f.value.validate()) return !1;
                        } catch (e) {
                            o = {
                                error: e
                            };
                        } finally{
                            try {
                                f && !f.done && (r = p.return) && r.call(p);
                            } finally{
                                if (o) throw o.error;
                            }
                        }
                        return !0;
                    }, t.prototype.onSubmit = function(e) {
                        var t = this;
                        this.j.e.on(this.container, "submit", function() {
                            var o = t.allChildren.filter(function(e) {
                                return c.Component.isInstanceOf(e, i.UIInput);
                            });
                            return !!t.validate() && (e(o.reduce(function(e, t) {
                                return e[t.state.name] = t.value, e;
                            }, {})), !1);
                        });
                    }, t.prototype.createContainer = function() {
                        var e = this.j.c.element("form");
                        return e.classList.add(this.componentName), (0, s.attr)(e, "dir", this.j.o.direction || "auto"), e;
                    }, n.__decorate([
                        l.component
                    ], t);
                }(r.UIGroup);
                t.UIForm = u;
            },
            95963: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(26207), t), n.__exportStar(o(63034), t), n.__exportStar(o(38318), t);
            },
            21639: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UITextArea = void 0;
                var n = o(20255);
                o(50905);
                var r = o(30194), i = o(11441), a = function(e) {
                    function t(t, r) {
                        var i = e.call(this, t, r) || this;
                        return i.state = n.__assign({}, o.defaultState), Object.assign(i.state, r), !1 === i.state.resizable && (i.nativeInput.style.resize = "none"), i;
                    }
                    var o;
                    return n.__extends(t, e), o = t, t.prototype.className = function() {
                        return "UITextArea";
                    }, t.prototype.createContainer = function(t) {
                        return this.nativeInput = this.j.create.element("textarea"), e.prototype.createContainer.call(this, t);
                    }, t.defaultState = n.__assign(n.__assign({}, r.UIInput.defaultState), {
                        size: 5,
                        resizable: !0
                    }), o = n.__decorate([
                        i.component
                    ], t);
                }(r.UIInput);
                t.UITextArea = a;
            },
            63747: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UICheckbox = void 0;
                var n = o(20255);
                o(70446);
                var r = o(30194), i = o(43441), a = o(24263), s = function(e) {
                    function t(t, r) {
                        var i = e.call(this, t, n.__assign(n.__assign({}, r), {
                            type: "checkbox"
                        })) || this;
                        return i.state = n.__assign({}, o.defaultState), Object.assign(i.state, r), i;
                    }
                    var o;
                    return n.__extends(t, e), o = t, t.prototype.className = function() {
                        return "UICheckbox";
                    }, t.prototype.render = function() {
                        return this.j.c.element("label", {
                            className: this.componentName
                        });
                    }, t.prototype.onChangeChecked = function() {
                        this.value = this.state.checked.toString(), this.nativeInput.checked = this.state.checked, this.setMod("checked", this.state.checked);
                    }, t.prototype.onChangeNativeCheckBox = function() {
                        this.state.checked = this.nativeInput.checked;
                    }, t.prototype.onChangeSwitch = function() {
                        this.setMod("switch", this.state.switch);
                        var e = this.getElm("switch-slider");
                        this.state.switch ? (e || (e = this.j.c.div(this.getFullElName("switch-slider"))), a.Dom.after(this.nativeInput, e)) : a.Dom.safeRemove(e);
                    }, t.defaultState = n.__assign(n.__assign({}, r.UIInput.defaultState), {
                        checked: !1,
                        switch: !1
                    }), n.__decorate([
                        (0, i.watch)("state.checked"),
                        (0, i.hook)("ready")
                    ], t.prototype, "onChangeChecked", null), n.__decorate([
                        (0, i.watch)("nativeInput:change")
                    ], t.prototype, "onChangeNativeCheckBox", null), n.__decorate([
                        (0, i.watch)("state.switch"),
                        (0, i.hook)("ready")
                    ], t.prototype, "onChangeSwitch", null), o = n.__decorate([
                        i.component
                    ], t);
                }(r.UIInput);
                t.UICheckbox = s;
            },
            41374: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIFileInput = void 0;
                var n = o(20255);
                o(18984);
                var r = o(30194), i = o(11441), a = o(96031), s = function(e) {
                    function t(t, o) {
                        var i = e.call(this, t, n.__assign({
                            type: "file"
                        }, o)) || this;
                        return i.state = n.__assign(n.__assign({}, r.UIInput.defaultState), {
                            type: "file",
                            onlyImages: !0
                        }), i;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UIFileInput";
                    }, t.prototype.createContainer = function(e) {
                        this.button = new a.UIButton(this.j, {
                            icon: {
                                name: "plus"
                            }
                        });
                        var t = this.button.container;
                        this.nativeInput || (this.nativeInput = this.createNativeInput(e));
                        var o = this.nativeInput;
                        return o.classList.add(this.getFullElName("input")), t.classList.add(this.componentName), t.appendChild(o), t;
                    }, t.prototype.createNativeInput = function(e) {
                        return this.j.create.fromHTML('<input\n\t\t\ttype="file"\n\t\t\taccept="'.concat(e.onlyImages ? "image/*" : "*", '"\n\t\t\ttabindex="-1"\n\t\t\tdir="auto"\n\t\t\tmultiple=""\n\t\t/>'));
                    }, n.__decorate([
                        i.component
                    ], t);
                }(r.UIInput);
                t.UIFileInput = s;
            },
            63034: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(30194), t), n.__exportStar(o(21639), t), n.__exportStar(o(63747), t), n.__exportStar(o(75840), t), n.__exportStar(o(41374), t);
            },
            30194: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIInput = void 0;
                var n = o(20255);
                o(4591);
                var r = o(53929), i = o(76502), a = o(1853), s = o(24263), l = o(43441), c = o(77904), u = o(60081), d = function(e) {
                    function t(t, r) {
                        var i = e.call(this, t, r) || this;
                        return i.label = i.j.c.span(i.getFullElName("label")), i.icon = i.j.c.span(i.getFullElName("icon")), i.clearButton = i.j.c.span(i.getFullElName("clear"), c.Icon.get("cancel")), i.state = n.__assign({}, o.defaultState), i.__errorBox = i.j.c.span(i.getFullElName("error")), i.validators = new Set([]), void 0 !== (null == r ? void 0 : r.value) && (r.value = r.value.toString()), Object.assign(i.state, r), void 0 !== i.state.clearButton && (i.j.e.on(i.clearButton, "click", function(e) {
                            e.preventDefault(), i.nativeInput.value = "", i.j.e.fire(i.nativeInput, "input"), i.focus();
                        }).on(i.nativeInput, "input", function() {
                            i.state.clearButton = Boolean(i.value.length);
                        }), i.state.clearButton = Boolean(i.value.length)), i.j.e.on(i.nativeInput, "focus blur", function() {
                            i.onChangeFocus();
                        }).on(i.nativeInput, "input change", i.onChangeValue), i.onChangeState(), i.onChangeClassName(), i.onChangeStateValue(), i;
                    }
                    var o;
                    return n.__extends(t, e), o = t, t.prototype.className = function() {
                        return "UIInput";
                    }, t.prototype.onChangeClear = function() {
                        this.state.clearButton ? s.Dom.after(this.nativeInput, this.clearButton) : s.Dom.safeRemove(this.clearButton);
                    }, t.prototype.onChangeClassName = function(e, t) {
                        t && this.container.classList.remove(t), this.state.className && this.container.classList.add(this.state.className);
                    }, t.prototype.onChangeState = function() {
                        this.name = this.state.name;
                        var e = this.nativeInput, t = this.state, o = t.name, n = t.icon, r = t.type, a = t.ref, l = t.required, u = t.placeholder, d = t.autocomplete, p = t.label;
                        (0, i.attr)(e, "name", o), (0, i.attr)(e, "type", r), (0, i.attr)(e, "data-ref", a || o), (0, i.attr)(e, "ref", a || o), (0, i.attr)(e, "required", l || null), (0, i.attr)(e, "autocomplete", d ? null : "off"), (0, i.attr)(e, "placeholder", u ? this.j.i18n(u) : ""), n && c.Icon.exists(n) ? (s.Dom.before(e, this.icon), this.icon.innerHTML = c.Icon.get(n)) : s.Dom.safeRemove(this.icon), p ? (s.Dom.before(this.wrapper, this.label), this.label.innerText = this.j.i18n(p)) : s.Dom.safeRemove(this.label), this.updateValidators();
                    }, t.prototype.updateValidators = function() {
                        var e, t = this;
                        this.validators.clear(), this.state.required && this.validators.add(u.inputValidators.required), null === (e = this.state.validators) || void 0 === e || e.forEach(function(e) {
                            var o = u.inputValidators[e];
                            o && t.validators.add(o);
                        });
                    }, Object.defineProperty(t.prototype, "error", {
                        set: function(e) {
                            this.setMod("has-error", Boolean(e)), e ? (this.__errorBox.innerText = this.j.i18n(e, this.j.i18n(this.state.label || "")), this.container.appendChild(this.__errorBox)) : s.Dom.safeRemove(this.__errorBox);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "value", {
                        get: function() {
                            return this.nativeInput.value;
                        },
                        set: function(e) {
                            this.value !== e && (this.nativeInput.value = e, this.onChangeValue());
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.onChangeStateValue = function() {
                        var e = this.state.value.toString();
                        e !== this.value && (this.value = e);
                    }, t.prototype.onChangeValue = function() {
                        var e, t, o = this.value;
                        this.state.value !== o && (this.state.value = o, this.j.e.fire(this, "change", o), null === (t = (e = this.state).onChange) || void 0 === t || t.call(e, o));
                    }, t.prototype.validate = function() {
                        var e = this;
                        return this.error = "", (0, a.toArray)(this.validators).every(function(t) {
                            return t(e);
                        });
                    }, t.prototype.createContainer = function(t) {
                        var o = e.prototype.createContainer.call(this);
                        this.wrapper = this.j.c.div(this.getFullElName("wrapper")), this.nativeInput || (this.nativeInput = this.createNativeInput());
                        var n = this.nativeInput;
                        return n.classList.add(this.getFullElName("input")), this.wrapper.appendChild(n), o.appendChild(this.wrapper), (0, i.attr)(n, "dir", this.j.o.direction || "auto"), o;
                    }, t.prototype.createNativeInput = function(e) {
                        return this.j.create.element("input");
                    }, t.prototype.focus = function() {
                        this.nativeInput.focus();
                    }, Object.defineProperty(t.prototype, "isFocused", {
                        get: function() {
                            return this.nativeInput === this.j.od.activeElement;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.onChangeFocus = function() {
                        this.setMod("focused", this.isFocused);
                    }, t.defaultState = {
                        className: "",
                        autocomplete: !0,
                        name: "",
                        value: "",
                        icon: "",
                        label: "",
                        ref: "",
                        type: "text",
                        placeholder: "",
                        required: !1,
                        validators: []
                    }, n.__decorate([
                        (0, l.watch)("state.clearButton")
                    ], t.prototype, "onChangeClear", null), n.__decorate([
                        (0, l.watch)("state.className")
                    ], t.prototype, "onChangeClassName", null), n.__decorate([
                        (0, l.watch)([
                            "state.name",
                            "state.type",
                            "state.label",
                            "state.placeholder",
                            "state.autocomplete",
                            "state.icon"
                        ]),
                        (0, l.debounce)()
                    ], t.prototype, "onChangeState", null), n.__decorate([
                        (0, l.watch)("state.value")
                    ], t.prototype, "onChangeStateValue", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "onChangeValue", null), o = n.__decorate([
                        l.component
                    ], t);
                }(r.UIElement);
                t.UIInput = d;
            },
            75840: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UISelect = void 0;
                var n = o(20255);
                o(64194);
                var r = o(67309), i = o(11441), a = o(30194), s = o(60081), l = function(e) {
                    function t(t, r) {
                        var i = e.call(this, t, r) || this;
                        return i.state = n.__assign({}, o.defaultState), Object.assign(i.state, r), i;
                    }
                    var o;
                    return n.__extends(t, e), o = t, t.prototype.className = function() {
                        return "UISelect";
                    }, t.prototype.createContainer = function(t) {
                        var o, n = e.prototype.createContainer.call(this, t), i = this.j, a = this.nativeInput, s = function() {
                            return i.create.element("option");
                        };
                        if (void 0 !== t.placeholder) {
                            var l = s();
                            l.value = "", l.text = i.i18n(t.placeholder), a.add(l);
                        }
                        return null === (o = t.options) || void 0 === o || o.forEach(function(e) {
                            var t = s();
                            t.value = e.value.toString(), t.text = i.i18n(e.text), a.add(t);
                        }), t.size && t.size > 0 && (0, r.attr)(a, "size", t.size), t.multiple && (0, r.attr)(a, "multiple", ""), n;
                    }, t.prototype.createNativeInput = function() {
                        return this.j.create.element("select");
                    }, t.prototype.updateValidators = function() {
                        e.prototype.updateValidators.call(this), this.state.required && (this.validators.delete(s.inputValidators.required), this.validators.add(s.selectValidators.required));
                    }, t.defaultState = n.__assign(n.__assign({}, a.UIInput.defaultState), {
                        options: [],
                        size: 1,
                        multiple: !1
                    }), o = n.__decorate([
                        i.component
                    ], t);
                }(a.UIInput);
                t.UISelect = l;
            },
            60081: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.selectValidators = t.inputValidators = void 0, t.inputValidators = o(63355), t.selectValidators = o(65935);
            },
            63355: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.url = t.required = void 0;
                var n = o(64350), r = o(33941);
                t.required = function(e) {
                    return !!(0, r.trim)(e.value).length || (e.error = "Please fill out this field", !1);
                }, t.url = function(e) {
                    return !!(0, n.isURL)((0, r.trim)(e.value)) || (e.error = "Please enter a web address", !1);
                };
            },
            65935: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.required = void 0;
                var n = o(33941);
                t.required = function(e) {
                    return !!(0, n.trim)(e.value).length || (e.error = "Please fill out this field", !1);
                };
            },
            61479: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIGroup = void 0;
                var n = o(20255);
                o(70375);
                var r = o(53929), i = o(43441), a = o(40332), s = (o(52378), o(24263)), l = o(45113), c = function(e) {
                    function t(t, o, n) {
                        var r = e.call(this, t, n) || this;
                        return r.options = n, r.syncMod = !1, r.elements = [], r.buttonSize = "middle", null == o || o.forEach(function(e) {
                            return e && r.append(e);
                        }), (null == n ? void 0 : n.name) && (r.name = n.name), r;
                    }
                    var o;
                    return n.__extends(t, e), o = t, t.prototype.className = function() {
                        return "UIGroup";
                    }, Object.defineProperty(t.prototype, "allChildren", {
                        get: function() {
                            for(var e = [], t = n.__spreadArray([], n.__read(this.elements), !1); t.length;){
                                var r = t.shift();
                                (0, a.isArray)(r) ? t.push.apply(t, n.__spreadArray([], n.__read(r), !1)) : l.Component.isInstanceOf(r, o) ? t.push.apply(t, n.__spreadArray([], n.__read(r.elements), !1)) : r && e.push(r);
                            }
                            return e;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.update = function() {
                        this.elements.forEach(function(e) {
                            return e.update();
                        }), this.setMod("size", this.buttonSize);
                    }, t.prototype.append = function(e, t) {
                        var o = this;
                        return (0, a.isArray)(e) ? (e.forEach(function(e) {
                            return o.append(e, t);
                        }), this) : (this.elements.push(e), e.name && e.container.classList.add(this.getFullElName(e.name)), t ? this.getElm(t).appendChild(e.container) : this.appendChildToContainer(e.container), e.parentElement = this, e.update(), this);
                    }, t.prototype.afterSetMod = function(e, t) {
                        this.syncMod && this.elements.forEach(function(o) {
                            return o.setMod(e, t);
                        });
                    }, t.prototype.appendChildToContainer = function(e) {
                        this.container.appendChild(e);
                    }, t.prototype.remove = function(e) {
                        var t = this.elements.indexOf(e);
                        return -1 !== t && (this.elements.splice(t, 1), s.Dom.safeRemove(e.container), e.parentElement = null), this;
                    }, t.prototype.clear = function() {
                        return this.elements.forEach(function(e) {
                            return e.destruct();
                        }), this.elements.length = 0, this;
                    }, t.prototype.destruct = function() {
                        return this.clear(), e.prototype.destruct.call(this);
                    }, n.__decorate([
                        (0, i.watch)("buttonSize")
                    ], t.prototype, "update", null), o = n.__decorate([
                        i.component
                    ], t);
                }(r.UIElement);
                t.UIGroup = c;
            },
            3249: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(61479), t), n.__exportStar(o(47970), t), n.__exportStar(o(75018), t), n.__exportStar(o(58495), t);
            },
            47970: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIList = void 0;
                var n = o(20255);
                o(90235);
                var r = o(32070), i = o(43441), a = o(61479), s = o(75018), l = o(58495), c = o(96031), u = o(97642), d = o(38546), p = o(14556), f = o(45113), h = function(e) {
                    function t(t) {
                        var o = e.call(this, t) || this;
                        return o.mode = "horizontal", o.removeButtons = [], o.onChangeMode(), o;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UIList";
                    }, t.prototype.onChangeMode = function() {
                        this.setMod("mode", this.mode);
                    }, t.prototype.makeGroup = function() {
                        return new a.UIGroup(this.jodit);
                    }, Object.defineProperty(t.prototype, "buttons", {
                        get: function() {
                            return this.allChildren.filter(function(e) {
                                return f.Component.isInstanceOf(e, c.UIButton);
                            });
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.getButtonsNames = function() {
                        return this.buttons.map(function(e) {
                            return e instanceof c.UIButton && e.state.name || "";
                        }).filter(function(e) {
                            return "" !== e;
                        });
                    }, t.prototype.setRemoveButtons = function(e) {
                        return this.removeButtons = e || [], this;
                    }, t.prototype.build = function(e, t) {
                        var o = this;
                        void 0 === t && (t = null), e = (0, p.splitArray)(e), this.clear();
                        var n, i = !1, a = this.makeGroup();
                        this.append(a), a.setMod("line", !0);
                        var c = function(e) {
                            var r = null;
                            switch(e.name){
                                case "\n":
                                    (a = o.makeGroup()).setMod("line", !0), n = o.makeGroup(), a.append(n), o.append(a);
                                    break;
                                case "|":
                                    i || (i = !0, r = new s.UISeparator(o.j));
                                    break;
                                case "---":
                                    n.setMod("before-spacer", !0);
                                    var c = new l.UISpacer(o.j);
                                    a.append(c), n = o.makeGroup(), a.append(n), i = !1;
                                    break;
                                default:
                                    i = !1, r = o.makeButton(e, t);
                            }
                            r && (n || (n = o.makeGroup(), a.append(n)), n.append(r));
                        }, f = function(e) {
                            return !o.removeButtons.includes(e.name);
                        };
                        return e.forEach(function(e) {
                            if ((0, u.isButtonGroup)(e)) {
                                var t = e.buttons.filter(function(e) {
                                    return e;
                                });
                                t.length && ((n = o.makeGroup()).setMod("separated", !0).setMod("group", e.group), a.append(n), (0, r.getStrongControlTypes)(t, o.j.o.controls).filter(f).forEach(c));
                            } else {
                                n || (n = o.makeGroup(), a.append(n));
                                var i = (0, d.getControlType)(e, o.j.o.controls);
                                f(i) && c(i);
                            }
                        }), this.update(), this;
                    }, t.prototype.makeButton = function(e, t) {
                        return new c.UIButton(this.j);
                    }, n.__decorate([
                        (0, i.watch)("mode")
                    ], t.prototype, "onChangeMode", null), n.__decorate([
                        i.component
                    ], t);
                }(a.UIGroup);
                t.UIList = h;
            },
            75018: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UISeparator = void 0;
                var n = o(20255), r = o(53929), i = o(11441), a = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UISeparator";
                    }, n.__decorate([
                        i.component
                    ], t);
                }(r.UIElement);
                t.UISeparator = a;
            },
            58495: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UISpacer = void 0;
                var n = o(20255), r = o(53929), i = o(11441), a = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UISpacer";
                    }, n.__decorate([
                        i.component
                    ], t);
                }(r.UIElement);
                t.UISpacer = a;
            },
            97642: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.flatButtonsSet = t.isButtonGroup = void 0;
                var n = o(20255), r = o(49781);
                t.isButtonGroup = function(e) {
                    return (0, r.isArray)(e.buttons);
                }, t.flatButtonsSet = function(e, o) {
                    var r = o.getRegisteredButtonGroups();
                    return new Set(e.reduce(function(e, o) {
                        var i;
                        return (0, t.isButtonGroup)(o) ? e = e.concat(n.__spreadArray(n.__spreadArray([], n.__read(o.buttons), !1), n.__read(null !== (i = r[o.group]) && void 0 !== i ? i : []), !1)) : e.push(o), e;
                    }, []));
                };
            },
            38546: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.findControlType = t.getControlType = void 0;
                var n = o(20255), r = o(40332), i = o(93166);
                function a(e, t) {
                    var o = n.__read(e.split(/\./), 2), i = o[0], a = o[1], s = t;
                    return null != a ? void 0 !== t[i] && (s = t[i]) : a = i, s[a] ? n.__assign({
                        name: a
                    }, (0, r.ConfigFlatten)(s[a])) : void 0;
                }
                t.getControlType = function(e, t) {
                    var o;
                    return t || (t = i.Config.defaultOptions.controls), (0, r.isString)(e) ? o = a(e, t) || {
                        name: e,
                        command: e,
                        tooltip: e
                    } : void 0 !== t[(o = n.__assign({
                        name: "empty"
                    }, (0, r.ConfigFlatten)(e))).name] && (o = n.__assign(n.__assign({}, (0, r.ConfigFlatten)(t[o.name])), (0, r.ConfigFlatten)(o))), o;
                }, t.findControlType = a;
            },
            32070: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getStrongControlTypes = void 0;
                var n = o(38546), r = o(93166), i = o(49781), a = o(76502);
                t.getStrongControlTypes = function(e, t) {
                    return ((0, i.isArray)(e) ? e : (0, a.keys)(e, !1).map(function(t) {
                        return (0, a.ConfigProto)({
                            name: t
                        }, e[t] || {});
                    })).map(function(e) {
                        return (0, n.getControlType)(e, t || r.Config.defaultOptions.controls);
                    });
                };
            },
            77904: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Icon = void 0;
                var n = o(26911), r = o(40332), i = function() {
                    function e() {}
                    return e.getIcon = function(t) {
                        return /<svg/i.test(t) ? t : e.icons[t] || e.icons[t.replace(/-/g, "_")] || e.icons[t.replace(/_/g, "-")] || e.icons[(0, r.camelCase)(t)] || e.icons[(0, r.kebabCase)(t)] || e.icons[t.toLowerCase()];
                    }, e.exists = function(e) {
                        return void 0 !== this.getIcon(e);
                    }, e.get = function(e, t) {
                        return void 0 === t && (t = "<span></span>"), this.getIcon(e) || t;
                    }, e.set = function(e, t) {
                        return this.icons[e.replace("_", "-")] = t, this;
                    }, e.makeIcon = function(t, o) {
                        var r, i;
                        if (o) {
                            var a = o.name.replace(/[^a-zA-Z0-9]/g, "_");
                            if (o.iconURL) i = t.c.span(), (0, n.css)(i, "backgroundImage", "url(" + o.iconURL.replace("{basePath}", (null == t ? void 0 : t.basePath) || "") + ")");
                            else {
                                var s = t.e.fire("getIcon", o.name, o, a) || e.get(o.name, "") || (null === (r = t.o.extraIcons) || void 0 === r ? void 0 : r[o.name]);
                                s && (i = t.c.fromHTML(s.trim()), /^<svg/i.test(o.name) || i.classList.add("jodit-icon_" + a));
                            }
                        }
                        return i && (i.classList.add("jodit-icon"), i.style.fill = o.fill), i;
                    }, e.icons = {}, e;
                }();
                t.Icon = i;
            },
            2074: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(53929), t), n.__exportStar(o(96516), t), n.__exportStar(o(35799), t), n.__exportStar(o(3249), t), n.__exportStar(o(95963), t), n.__exportStar(o(77904), t), n.__exportStar(o(63682), t);
            },
            35799: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(12680), t);
            },
            12680: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Popup = void 0;
                var n = o(20255);
                o(88477);
                var r = o(24263), i = o(40332), a = (o(52378), o(53929)), s = o(43441), l = o(45113), c = o(17332), u = function(e) {
                    function t(t, o) {
                        void 0 === o && (o = !0);
                        var n = e.call(this, t) || this;
                        return n.smart = o, n.isOpened = !1, n.strategy = "leftBottom", n.viewBound = function() {
                            return {
                                left: 0,
                                top: 0,
                                width: n.ow.innerWidth,
                                height: n.ow.innerHeight
                            };
                        }, n.childrenPopups = new Set, (0, i.attr)(n.container, "role", "popup"), n;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "Popup";
                    }, t.prototype.updateParentElement = function(o) {
                        var n = this;
                        return o !== this && l.Component.isInstanceOf(o, t) && (this.childrenPopups.forEach(function(e) {
                            !o.closest(e) && e.isOpened && e.close();
                        }), this.childrenPopups.has(o) || this.j.e.on(o, "beforeClose", function() {
                            n.childrenPopups.delete(o);
                        }), this.childrenPopups.add(o)), e.prototype.updateParentElement.call(this, o);
                    }, t.prototype.setContent = function(e) {
                        r.Dom.detach(this.container);
                        var t, o = this.j.c.div("".concat(this.componentName, "__content"));
                        return l.Component.isInstanceOf(e, a.UIElement) ? (t = e.container, e.parentElement = this) : t = (0, i.isString)(e) ? this.j.c.fromHTML(e) : e, o.appendChild(t), this.container.appendChild(o), this.updatePosition(), this;
                    }, t.prototype.open = function(e, o, n) {
                        if (void 0 === o && (o = !1), (0, i.markOwner)(this.jodit, this.container), this.calculateZIndex(), this.isOpened = !0, this.addGlobalListeners(), this.targetBound = o ? this.getKeepBound(e) : e, n) n.appendChild(this.container);
                        else {
                            var r = (0, c.getContainer)(this.jodit, t);
                            n !== this.container.parentElement && r.appendChild(this.container);
                        }
                        return this.updatePosition(), this.j.e.fire(this, "afterOpen"), this;
                    }, t.prototype.calculateZIndex = function() {
                        var e = this;
                        if (!this.container.style.zIndex) {
                            var t = function(t) {
                                var o = t.container.style.zIndex || t.o.zIndex;
                                return !!o && (e.setZIndex(1 + parseInt(o.toString(), 10)), !0);
                            }, o = this.j;
                            if (!t(o)) for(var n = this.parentElement; n;){
                                if (t(o)) return;
                                if (n.container.style.zIndex) return void this.setZIndex(1 + parseInt(n.container.style.zIndex.toString(), 10));
                                if (!n.parentElement && n.container.parentElement) {
                                    var r = a.UIElement.closestElement(n.container.parentElement, a.UIElement);
                                    if (r) {
                                        n = r;
                                        continue;
                                    }
                                }
                                n = n.parentElement;
                            }
                        }
                    }, t.prototype.getKeepBound = function(e) {
                        var t = this, o = e(), a = this.od.elementFromPoint(o.left, o.top);
                        if (!a) return e;
                        var s = r.Dom.isHTMLElement(a) ? a : a.parentElement, l = (0, i.position)(s, this.j);
                        return function() {
                            var o = e(), r = (0, i.position)(s, t.j);
                            return n.__assign(n.__assign({}, o), {
                                top: o.top + (r.top - l.top),
                                left: o.left + (r.left - l.left)
                            });
                        };
                    }, t.prototype.updatePosition = function() {
                        if (!this.isOpened) return this;
                        var e = n.__read(this.calculatePosition(this.targetBound(), this.viewBound(), (0, i.position)(this.container, this.j)), 2), t = e[0];
                        return this.setMod("strategy", e[1]), (0, i.css)(this.container, {
                            left: t.left,
                            top: t.top
                        }), this.childrenPopups.forEach(function(e) {
                            return e.updatePosition();
                        }), this;
                    }, t.prototype.throttleUpdatePosition = function() {
                        this.updatePosition();
                    }, t.prototype.calculatePosition = function(e, o, r, a) {
                        void 0 === a && (a = this.strategy);
                        var s = {
                            left: e.left,
                            right: e.left - (r.width - e.width)
                        }, l = {
                            bottom: e.top + e.height,
                            top: e.top - r.height
                        }, c = Object.keys(s).reduce(function(e, t) {
                            return e.concat(Object.keys(l).map(function(e) {
                                return "".concat(t).concat((0, i.ucfirst)(e));
                            }));
                        }, []), u = function(e) {
                            var t = n.__read((0, i.kebabCase)(e).split("-"), 2);
                            return {
                                left: s[t[0]],
                                top: l[t[1]],
                                width: r.width,
                                height: r.height
                            };
                        }, d = function(e) {
                            return t.boxInView(u(a), e) ? a : c.find(function(o) {
                                if (t.boxInView(u(o), e)) return o;
                            }) || null;
                        }, p = d((0, i.position)(this.j.container, this.j));
                        return p && t.boxInView(u(p), o) || (p = d(o) || p || a), [
                            u(p),
                            p
                        ];
                    }, t.boxInView = function(e, t) {
                        return !(-2 > e.top - t.top || -2 > e.left - t.left || -2 > t.top + t.height - (e.top + e.height) || -2 > t.left + t.width - (e.left + e.width));
                    }, t.prototype.close = function() {
                        return this.isOpened ? (this.isOpened = !1, this.childrenPopups.forEach(function(e) {
                            return e.close();
                        }), this.j.e.fire(this, "beforeClose"), this.j.e.fire("beforePopupClose", this), this.removeGlobalListeners(), r.Dom.safeRemove(this.container), this) : this;
                    }, t.prototype.closeOnOutsideClick = function(e) {
                        this.isOpened && !this.isOwnClick(e) && this.close();
                    }, t.prototype.isOwnClick = function(e) {
                        if (!e.target) return !1;
                        var o = a.UIElement.closestElement(e.target, t);
                        return Boolean(o && (this === o || o.closest(this)));
                    }, t.prototype.addGlobalListeners = function() {
                        var e = this, t = this.throttleUpdatePosition, o = this.ow;
                        c.eventEmitter.on("closeAllPopups", this.close), this.smart && this.j.e.on("escape", this.close).on("mousedown touchstart", this.closeOnOutsideClick).on(o, "mousedown touchstart", this.closeOnOutsideClick), this.j.e.on("closeAllPopups", this.close).on("resize", t).on(this.container, "scroll mousewheel", t).on(o, "scroll", t).on(o, "resize", t), r.Dom.up(this.j.container, function(o) {
                            o && e.j.e.on(o, "scroll mousewheel", t);
                        });
                    }, t.prototype.removeGlobalListeners = function() {
                        var e = this, t = this.throttleUpdatePosition, o = this.ow;
                        c.eventEmitter.off("closeAllPopups", this.close), this.smart && this.j.e.off("escape", this.close).off("mousedown touchstart", this.closeOnOutsideClick).off(o, "mousedown touchstart", this.closeOnOutsideClick), this.j.e.off("closeAllPopups", this.close).off("resize", t).off(this.container, "scroll mousewheel", t).off(o, "scroll", t).off(o, "resize", t), r.Dom.up(this.j.container, function(o) {
                            o && e.j.e.off(o, "scroll mousewheel", t);
                        });
                    }, t.prototype.setZIndex = function(e) {
                        this.container.style.zIndex = e.toString();
                    }, t.prototype.destruct = function() {
                        return this.close(), e.prototype.destruct.call(this);
                    }, n.__decorate([
                        s.autobind
                    ], t.prototype, "updatePosition", null), n.__decorate([
                        (0, s.throttle)(10),
                        s.autobind
                    ], t.prototype, "throttleUpdatePosition", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "close", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "closeOnOutsideClick", null), t;
                }(a.UIElement);
                t.Popup = u;
            },
            63682: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ProgressBar = void 0;
                var n = o(20255);
                o(50197);
                var r = o(24263), i = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "ProgressBar";
                    }, t.prototype.render = function() {
                        return "<div><div></div></div>";
                    }, t.prototype.show = function() {
                        return (this.j.workplace || this.j.container).appendChild(this.container), this;
                    }, t.prototype.hide = function() {
                        return r.Dom.safeRemove(this.container), this;
                    }, t.prototype.progress = function(e) {
                        return this.container.style.width = e.toFixed(2) + "%", this;
                    }, t.prototype.destruct = function() {
                        return this.hide(), e.prototype.destruct.call(this);
                    }, t;
                }(o(53929).UIElement);
                t.ProgressBar = i;
            },
            43608: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ViewWithToolbar = void 0;
                var n = o(20255);
                o(39008);
                var r = o(75902), i = o(40332), a = o(64968), s = o(81438), l = o(56562), c = o(97642), u = o(43441), d = function(e) {
                    function t(t, o) {
                        void 0 === o && (o = !1);
                        var n = e.call(this, t, o) || this;
                        return n.toolbar = (0, s.makeCollection)(n), n.defaultToolbarContainer = n.c.div("jodit-toolbar__box"), n.registeredButtons = new Set, n.groupToButtons = {}, n.isJodit = !1, n.isJodit = o, n.e.on("beforeToolbarBuild", n.beforeToolbarBuild), n;
                    }
                    return n.__extends(t, e), Object.defineProperty(t.prototype, "toolbarContainer", {
                        get: function() {
                            return this.o.fullsize || !(0, i.isString)(this.o.toolbar) && !a.Dom.isHTMLElement(this.o.toolbar) ? (this.o.toolbar && a.Dom.appendChildFirst(this.container, this.defaultToolbarContainer), this.defaultToolbarContainer) : (0, i.resolveElement)(this.o.toolbar, this.o.shadowRoot || this.od);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.setPanel = function(e) {
                        this.o.toolbar = e, this.buildToolbar();
                    }, t.prototype.buildToolbar = function() {
                        if (this.o.toolbar) {
                            var e = this.o.buttons ? (0, i.splitArray)(this.o.buttons) : [];
                            this.toolbar.setRemoveButtons(this.o.removeButtons).build(e.concat(this.o.extraButtons || [])).appendTo(this.toolbarContainer);
                        }
                    }, t.prototype.getRegisteredButtonGroups = function() {
                        return this.groupToButtons;
                    }, t.prototype.registerButton = function(e) {
                        var t;
                        this.registeredButtons.add(e);
                        var o = null !== (t = e.group) && void 0 !== t ? t : "other";
                        return this.groupToButtons[o] || (this.groupToButtons[o] = []), null != e.position ? this.groupToButtons[o][e.position] = e.name : this.groupToButtons[o].push(e.name), this;
                    }, t.prototype.unregisterButton = function(e) {
                        var t;
                        this.registeredButtons.delete(e);
                        var o = null !== (t = e.group) && void 0 !== t ? t : "other", n = this.groupToButtons[o];
                        if (n) {
                            var r = n.indexOf(e.name);
                            -1 !== r && n.splice(r, 1), 0 === n.length && delete this.groupToButtons[o];
                        }
                        return this;
                    }, t.prototype.beforeToolbarBuild = function(e) {
                        var t = this;
                        if (Object.keys(this.groupToButtons).length) return e.map(function(e) {
                            return (0, c.isButtonGroup)(e) && e.group && t.groupToButtons[e.group] ? {
                                group: e.group,
                                buttons: n.__spreadArray(n.__spreadArray([], n.__read(e.buttons), !1), n.__read(t.groupToButtons[e.group]), !1)
                            } : e;
                        });
                    }, t.prototype.destruct = function() {
                        this.isDestructed || (this.setStatus(l.STATUSES.beforeDestruct), this.e.off("beforeToolbarBuild", this.beforeToolbarBuild), this.toolbar.destruct(), e.prototype.destruct.call(this));
                    }, n.__decorate([
                        u.autobind
                    ], t.prototype, "beforeToolbarBuild", null), t;
                }(r.View);
                t.ViewWithToolbar = d;
            },
            75902: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.View = void 0;
                var n = o(20255), r = o(77462), i = o(40332), a = o(86893), s = o(87837), l = o(17332), c = o(43441), u = o(59829), d = o(55395), p = o(71014), f = function(e) {
                    function t(t, n) {
                        void 0 === n && (n = !1);
                        var i = e.call(this) || this;
                        return i.isJodit = n, i.isView = !0, i.parent = null, i.mods = {}, i.components = new Set, i.version = "3.24.9", i.buffer = r.Storage.makeStorage(), i.storage = r.Storage.makeStorage(!0, i.componentName), i.OPTIONS = o.defaultOptions, i.__isFullSize = !1, i.__whoLocked = "", i.isLockedNotBy = function(e) {
                            return i.isLocked && i.__whoLocked !== e;
                        }, i.__modulesInstances = new Map, i.id = (new Date).getTime().toString(), i.buffer = r.Storage.makeStorage(), i.initOptions(t), i.initOwners(), i.events = new d.EventEmitter(i.od), i.create = new s.Create(i.od), i.container = i.c.div("jodit ".concat(i.componentName)), i.progressbar = new s.ProgressBar(i), i.message = new p.UIMessages(i, i.container), i;
                    }
                    var o;
                    return n.__extends(t, e), o = t, Object.defineProperty(t.prototype, "basePath", {
                        get: function() {
                            return this.o.basePath ? this.o.basePath : a.BASE_PATH;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "defaultTimeout", {
                        get: function() {
                            return (0, i.isVoid)(this.o.defaultTimeout) ? 100 : this.o.defaultTimeout;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "c", {
                        get: function() {
                            return this.create;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "container", {
                        get: function() {
                            return this.__container;
                        },
                        set: function(e) {
                            this.__container = e;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "e", {
                        get: function() {
                            return this.events;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "options", {
                        get: function() {
                            return this.__options;
                        },
                        set: function(e) {
                            this.__options = e;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "o", {
                        get: function() {
                            return this.options;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.i18n = function(e) {
                        for(var t = [], o = 1; arguments.length > o; o++)t[o - 1] = arguments[o];
                        return (0, i.i18n)(e, t, this.options);
                    }, t.prototype.toggleFullSize = function(e) {
                        void 0 === e && (e = !this.__isFullSize), e !== this.__isFullSize && (this.__isFullSize = e, this.e.fire("toggleFullSize", e));
                    }, Object.defineProperty(t.prototype, "isLocked", {
                        get: function() {
                            return "" !== this.__whoLocked;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.lock = function(e) {
                        return void 0 === e && (e = "any"), !this.isLocked && (this.__whoLocked = e, !0);
                    }, t.prototype.unlock = function() {
                        return !!this.isLocked && (this.__whoLocked = "", !0);
                    }, Object.defineProperty(t.prototype, "isFullSize", {
                        get: function() {
                            return this.__isFullSize;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.getVersion = function() {
                        return "3.24.9";
                    }, t.getVersion = function() {
                        return "3.24.9";
                    }, t.prototype.initOptions = function(e) {
                        this.options = (0, i.ConfigProto)(e || {}, (0, i.ConfigProto)(this.options || {}, o.defaultOptions));
                    }, t.prototype.initOwners = function() {
                        var e;
                        this.ownerWindow = null !== (e = this.o.ownerWindow) && void 0 !== e ? e : window;
                    }, t.prototype.attachEvents = function(e) {
                        var t = this;
                        if (e) {
                            var o = null == e ? void 0 : e.events;
                            o && Object.keys(o).forEach(function(e) {
                                return t.e.on(e, o[e]);
                            });
                        }
                    }, t.prototype.getInstance = function(e, t) {
                        var o = this.e.fire((0, i.camelCase)("getInstance_" + e), t);
                        if (o) return o;
                        var n = l.modules[e], r = this.__modulesInstances;
                        if (!(0, i.isFunction)(n)) throw (0, i.error)("Need real module name");
                        if (!r.has(e)) {
                            var a = n.prototype instanceof s.ViewComponent ? new n(this, t) : new n(t);
                            this.components.add(a), r.set(e, a);
                        }
                        return r.get(e);
                    }, t.prototype.addDisclaimer = function(e) {
                        this.container.appendChild(e);
                    }, t.prototype.beforeDestruct = function() {
                        this.e.fire(s.STATUSES.beforeDestruct, this), this.components.forEach(function(e) {
                            (0, i.isDestructable)(e) && !e.isInDestruct && e.destruct();
                        }), this.components.clear();
                    }, t.prototype.destruct = function() {
                        this.isDestructed || (this.progressbar.destruct(), this.message.destruct(), this.async && this.async.destruct(), this.events && this.e.destruct(), this.buffer && this.buffer.clear(), s.Dom.safeRemove(this.container), e.prototype.destruct.call(this));
                    }, t.esNext = !1, n.__decorate([
                        (0, c.hook)(s.STATUSES.beforeDestruct)
                    ], t.prototype, "beforeDestruct", null), o = n.__decorate([
                        (0, c.derive)(u.Mods, u.Elms)
                    ], t);
                }(s.Component);
                t.View = f, f.defaultOptions = {
                    extraButtons: [],
                    textIcons: !1,
                    namespace: "",
                    removeButtons: [],
                    zIndex: 100002,
                    defaultTimeout: 100,
                    fullsize: !1,
                    showTooltip: !0,
                    useNativeTooltip: !1,
                    buttons: [],
                    globalFullSize: !0,
                    language: "auto"
                };
            },
            37920: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Jodit = void 0;
                var n = o(20255), r = o(93166), i = o(86893), a = o(87837), s = o(40332), l = o(77462), c = o(86893), u = o(17332), d = o(43441), p = o(59829), f = o(30056), h = "data-jodit-default-style-display", m = "data-jodit-default-classes", Jodit1 = function(e) {
                    function Jodit1(o, n) {
                        var r = e.call(this, n, !0) || this;
                        r.isJodit = !0, r.commands = new Map, r.__selectionLocked = null, r.__wasReadOnly = !1, r.createInside = new a.Create(function() {
                            return r.ed;
                        }, r.o.createAttributes), r.editorIsActive = !1, r.__mode = i.MODE_WYSIWYG, r.__callChangeCount = 0, r.__isSilentChange = !1, r.__elementToPlace = new Map;
                        try {
                            var c = (0, s.resolveElement)(o, r.o.shadowRoot || r.od);
                            if (t.isJoditAssigned(c)) return c.component;
                        } catch (e) {
                            throw r.destruct(), e;
                        }
                        r.setStatus(a.STATUSES.beforeInit), r.id = (0, s.attr)((0, s.resolveElement)(o, r.o.shadowRoot || r.od), "id") || (new Date).getTime().toString(), u.instances[r.id] = r, r.storage = l.Storage.makeStorage(!0, r.id), r.attachEvents(n), r.e.on(r.ow, "resize", function() {
                            r.e && r.e.fire("resize");
                        }), r.e.on("prepareWYSIWYGEditor", r.__prepareWYSIWYGEditor), r.selection = new a.Select(r);
                        var d = r.beforeInitHook();
                        return (0, s.callPromise)(d, function() {
                            r.e.fire("beforeInit", r), u.pluginSystem.__init(r), r.e.fire("afterPluginSystemInit", r), r.e.on("changePlace", function() {
                                r.setReadOnly(r.o.readonly), r.setDisabled(r.o.disabled);
                            }), r.places.length = 0;
                            var e = r.addPlace(o, n);
                            u.instances[r.id] = r, (0, s.callPromise)(e, function() {
                                r.e && r.e.fire("afterInit", r), r.afterInitHook(), r.setStatus(a.STATUSES.ready), r.e.fire("afterConstructor", r);
                            });
                        }), r;
                    }
                    var t;
                    return n.__extends(Jodit1, e), t = Jodit1, Jodit1.prototype.className = function() {
                        return "Jodit";
                    }, Jodit1.prototype.waitForReady = function() {
                        var e = this;
                        return this.isReady ? Promise.resolve(this) : this.async.promise(function(t) {
                            e.hookStatus("ready", function() {
                                return t(e);
                            });
                        });
                    }, Object.defineProperty(Jodit1, "ready", {
                        get: function() {
                            return new Promise(function(e) {
                                u.eventEmitter.on("oditready", e);
                            });
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "text", {
                        get: function() {
                            if (this.editor) return this.editor.innerText || "";
                            var e = this.createInside.div();
                            return e.innerHTML = this.getElementValue(), e.innerText || "";
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "defaultTimeout", {
                        get: function() {
                            return (0, s.isNumber)(this.o.defaultTimeout) ? this.o.defaultTimeout : r.Config.defaultOptions.defaultTimeout;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Jodit1.atom = function(e) {
                        return (0, s.markAsAtomic)(e);
                    }, Jodit1.make = function(e, t) {
                        return new this(e, t);
                    }, Jodit1.isJoditAssigned = function(e) {
                        return e && (0, s.isJoditObject)(e.component) && !e.component.isInDestruct;
                    }, Object.defineProperty(Jodit1, "defaultOptions", {
                        get: function() {
                            return r.Config.defaultOptions;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Jodit1.prototype.__setPlaceField = function(e, t) {
                        this.currentPlace || (this.currentPlace = {}, this.places = [
                            this.currentPlace
                        ]), this.currentPlace[e] = t;
                    }, Object.defineProperty(Jodit1.prototype, "element", {
                        get: function() {
                            return this.currentPlace.element;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "editor", {
                        get: function() {
                            return this.currentPlace.editor;
                        },
                        set: function(e) {
                            this.__setPlaceField("editor", e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "container", {
                        get: function() {
                            return this.currentPlace.container;
                        },
                        set: function(e) {
                            this.__setPlaceField("container", e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "workplace", {
                        get: function() {
                            return this.currentPlace.workplace;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "statusbar", {
                        get: function() {
                            return this.currentPlace.statusbar;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "iframe", {
                        get: function() {
                            return this.currentPlace.iframe;
                        },
                        set: function(e) {
                            this.__setPlaceField("iframe", e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "history", {
                        get: function() {
                            return this.currentPlace.history;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "observer", {
                        get: function() {
                            return this.history;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "editorWindow", {
                        get: function() {
                            return this.currentPlace.editorWindow;
                        },
                        set: function(e) {
                            this.__setPlaceField("editorWindow", e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "ew", {
                        get: function() {
                            return this.editorWindow;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "editorDocument", {
                        get: function() {
                            return this.currentPlace.editorWindow.document;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "ed", {
                        get: function() {
                            return this.editorDocument;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "options", {
                        get: function() {
                            return this.currentPlace.options;
                        },
                        set: function(e) {
                            this.__setPlaceField("options", e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "s", {
                        get: function() {
                            return this.selection;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "uploader", {
                        get: function() {
                            return this.getInstance("Uploader", this.o.uploader);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "filebrowser", {
                        get: function() {
                            var e = this, t = (0, s.ConfigProto)({
                                defaultTimeout: e.defaultTimeout,
                                uploader: e.o.uploader,
                                language: e.o.language,
                                license: e.o.license,
                                theme: e.o.theme,
                                shadowRoot: e.o.shadowRoot,
                                defaultCallback: function(t) {
                                    t.files && t.files.length && t.files.forEach(function(o, n) {
                                        var r = t.baseurl + o;
                                        t.isImages && t.isImages[n] ? e.s.insertImage(r, null, e.o.imageDefaultWidth) : e.s.insertNode(e.createInside.fromHTML("<a href='".concat(r, "' title='").concat(r, "'>").concat(r, "</a>")));
                                    });
                                }
                            }, this.o.filebrowser);
                            return e.getInstance("FileBrowser", t);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(Jodit1.prototype, "mode", {
                        get: function() {
                            return this.__mode;
                        },
                        set: function(e) {
                            this.setMode(e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Jodit1.prototype.getNativeEditorValue = function() {
                        var e = this.e.fire("beforeGetNativeEditorValue");
                        return (0, s.isString)(e) ? e : this.editor ? this.editor.innerHTML : this.getElementValue();
                    }, Jodit1.prototype.setNativeEditorValue = function(e) {
                        var t = {
                            value: e
                        };
                        this.e.fire("beforeSetNativeEditorValue", t) || this.editor && (this.editor.innerHTML = t.value);
                    }, Object.defineProperty(Jodit1.prototype, "value", {
                        get: function() {
                            return this.getEditorValue();
                        },
                        set: function(e) {
                            this.setEditorValue(e), this.history.__processChanges();
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Jodit1.prototype.synchronizeValues = function() {
                        this.__imdSynchronizeValues();
                    }, Jodit1.prototype.__imdSynchronizeValues = function() {
                        this.setEditorValue();
                    }, Jodit1.prototype.getEditorValue = function(e, t) {
                        var o;
                        if (void 0 === e && (e = !0), void 0 !== (o = this.e.fire("beforeGetValueFromEditor", t))) return o;
                        o = this.getNativeEditorValue().replace(i.INVISIBLE_SPACE_REG_EXP(), ""), e && (o = o.replace(/<span[^>]+id="jodit-selection_marker_[^>]+><\/span>/g, "")), "<br>" === o && (o = "");
                        var n = {
                            value: o
                        };
                        return this.e.fire("afterGetValueFromEditor", n, t), n.value;
                    }, Jodit1.prototype.setEditorValue = function(e) {
                        var t = this.e.fire("beforeSetValueToEditor", e);
                        if (!1 !== t) {
                            if ((0, s.isString)(t) && (e = t), this.editor) {
                                if (!(0, s.isString)(e) && !(0, s.isVoid)(e)) throw (0, s.error)("value must be string");
                                (0, s.isVoid)(e) || this.getNativeEditorValue() === e || this.setNativeEditorValue(e), this.e.fire("postProcessSetEditorValue");
                                var o = this.getElementValue(), n = this.getEditorValue();
                                if (!this.__isSilentChange && o !== n && i.SAFE_COUNT_CHANGE_CALL > this.__callChangeCount) {
                                    this.__setElementValue(n), this.__callChangeCount += 1;
                                    try {
                                        this.history.__upTick(), this.e.fire("change", n, o), this.e.fire(this.history, "change", n, o);
                                    } finally{
                                        this.__callChangeCount = 0;
                                    }
                                }
                            } else void 0 !== e && this.__setElementValue(e);
                        }
                    }, Jodit1.prototype.updateElementValue = function() {
                        this.__setElementValue(this.getEditorValue());
                    }, Jodit1.prototype.getElementValue = function() {
                        return void 0 !== this.element.value ? this.element.value : this.element.innerHTML;
                    }, Jodit1.prototype.setElementValue = function(e) {
                        var t = this.getElementValue();
                        return (void 0 === e || (0, s.isString)(e) && e !== t) && (null != e || (e = t), e !== this.getEditorValue() && this.setEditorValue(e)), this.__setElementValue(e);
                    }, Jodit1.prototype.__setElementValue = function(e) {
                        var t = this;
                        if (!(0, s.isString)(e)) throw (0, s.error)("value must be string");
                        if (this.element !== this.container && e !== this.getElementValue()) {
                            var o = {
                                value: e
                            }, n = this.e.fire("beforeSetElementValue", o);
                            (0, s.callPromise)(n, function() {
                                void 0 !== t.element.value ? t.element.value = o.value : t.element.innerHTML = o.value, t.e.fire("afterSetElementValue", o);
                            });
                        }
                    }, Jodit1.prototype.registerCommand = function(e, t, o) {
                        var n = e.toLowerCase(), r = this.commands.get(n);
                        if (void 0 === r && this.commands.set(n, r = []), r.push(t), !(0, s.isFunction)(t)) {
                            var i = this.o.commandToHotkeys[n] || this.o.commandToHotkeys[e] || t.hotkeys;
                            i && this.registerHotkeyToCommand(i, n, null == o ? void 0 : o.stopPropagation);
                        }
                        return this;
                    }, Jodit1.prototype.registerHotkeyToCommand = function(e, t, o) {
                        var n = this;
                        void 0 === o && (o = !0);
                        var r = (0, s.asArray)(e).map(s.normalizeKeyAliases).map(function(e) {
                            return e + ".hotkey";
                        }).join(" ");
                        this.e.off(r).on(r, function(e, r) {
                            return r && (r.shouldStop = null == o || o), n.execCommand(t);
                        });
                    }, Jodit1.prototype.execCommand = function(e, t, o) {
                        for(var r, i = [], a = 3; arguments.length > a; a++)i[a - 3] = arguments[a];
                        if (this.s.isFocused() || this.s.focus(), !this.o.readonly || this.o.allowCommandsInReadOnly.includes(e)) {
                            var s;
                            if (e = e.toLowerCase(), !1 !== (s = (r = this.e).fire.apply(r, n.__spreadArray([
                                "beforeCommand",
                                e,
                                t,
                                o
                            ], n.__read(i), !1))) && (s = this.__execCustomCommands.apply(this, n.__spreadArray([
                                e,
                                t,
                                o
                            ], n.__read(i), !1))), !1 !== s) {
                                if (this.s.focus(), "selectall" === e) this.s.select(this.editor, !0), this.s.expandSelection();
                                else try {
                                    s = this.nativeExecCommand(e, t, o);
                                } catch (e) {}
                            }
                            return this.e.fire("afterCommand", e, t, o), this.setEditorValue(), s;
                        }
                    }, Jodit1.prototype.nativeExecCommand = function(e, t, o) {
                        this.__isSilentChange = !0;
                        try {
                            return this.ed.execCommand(e, t, o);
                        } finally{
                            this.__isSilentChange = !1;
                        }
                    }, Jodit1.prototype.__execCustomCommands = function(e, t, o) {
                        for(var r = this, i = [], a = 3; arguments.length > a; a++)i[a - 3] = arguments[a];
                        e = e.toLowerCase();
                        var l, c = this.commands.get(e);
                        if (void 0 !== c) return c.forEach(function(a) {
                            var c, u = (c = (0, s.isFunction)(a) ? a : a.exec).call.apply(c, n.__spreadArray([
                                r,
                                e,
                                t,
                                o
                            ], n.__read(i), !1));
                            void 0 !== u && (l = u);
                        }), l;
                    }, Jodit1.prototype.lock = function(t) {
                        return void 0 === t && (t = "any"), !!e.prototype.lock.call(this, t) && (this.__selectionLocked = this.s.save(), this.s.clear(), this.editor.classList.add("jodit_lock"), this.e.fire("lock", !0), !0);
                    }, Jodit1.prototype.unlock = function() {
                        return !!e.prototype.unlock.call(this) && (this.editor.classList.remove("jodit_lock"), this.__selectionLocked && this.s.restore(), this.e.fire("lock", !1), !0);
                    }, Jodit1.prototype.getMode = function() {
                        return this.mode;
                    }, Jodit1.prototype.isEditorMode = function() {
                        return this.getRealMode() === i.MODE_WYSIWYG;
                    }, Jodit1.prototype.getRealMode = function() {
                        if (this.getMode() !== i.MODE_SPLIT) return this.getMode();
                        var e = this.od.activeElement;
                        return e && (e === this.iframe || a.Dom.isOrContains(this.editor, e) || a.Dom.isOrContains(this.toolbar.container, e)) ? i.MODE_WYSIWYG : i.MODE_SOURCE;
                    }, Jodit1.prototype.setMode = function(e) {
                        var t = this, o = this.getMode(), n = {
                            mode: parseInt(e.toString(), 10)
                        }, r = [
                            "jodit-wysiwyg_mode",
                            "jodit-source__mode",
                            "jodit_split_mode"
                        ];
                        !1 !== this.e.fire("beforeSetMode", n) && (this.__mode = [
                            i.MODE_SOURCE,
                            i.MODE_WYSIWYG,
                            i.MODE_SPLIT
                        ].includes(n.mode) ? n.mode : i.MODE_WYSIWYG, this.o.saveModeInStorage && this.storage.set("jodit_default_mode", this.mode), r.forEach(function(e) {
                            t.container.classList.remove(e);
                        }), this.container.classList.add(r[this.mode - 1]), o !== this.getMode() && this.e.fire("afterSetMode"));
                    }, Jodit1.prototype.toggleMode = function() {
                        var e = this.getMode();
                        [
                            i.MODE_SOURCE,
                            i.MODE_WYSIWYG,
                            this.o.useSplitMode ? i.MODE_SPLIT : 9
                        ].includes(e + 1) ? e += 1 : e = i.MODE_WYSIWYG, this.setMode(e);
                    }, Jodit1.prototype.setDisabled = function(e) {
                        this.o.disabled = e;
                        var t = this.__wasReadOnly;
                        this.setReadOnly(e || t), this.__wasReadOnly = t, this.editor && (this.editor.setAttribute("aria-disabled", e.toString()), this.container.classList.toggle("jodit_disabled", e), this.e.fire("disabled", e));
                    }, Jodit1.prototype.getDisabled = function() {
                        return this.o.disabled;
                    }, Jodit1.prototype.setReadOnly = function(e) {
                        this.__wasReadOnly !== e && (this.__wasReadOnly = e, this.o.readonly = e, e ? this.editor && this.editor.removeAttribute("contenteditable") : this.editor && this.editor.setAttribute("contenteditable", "true"), this.e && this.e.fire("readonly", e));
                    }, Jodit1.prototype.getReadOnly = function() {
                        return this.o.readonly;
                    }, Jodit1.prototype.focus = function() {
                        this.getMode() !== i.MODE_SOURCE && this.s.focus();
                    }, Object.defineProperty(Jodit1.prototype, "isFocused", {
                        get: function() {
                            return this.s.isFocused();
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Jodit1.prototype.beforeInitHook = function() {}, Jodit1.prototype.afterInitHook = function() {}, Jodit1.prototype.initOptions = function(e) {
                        this.options = (0, s.ConfigProto)(e || {}, r.Config.defaultOptions);
                    }, Jodit1.prototype.initOwners = function() {
                        this.editorWindow = this.o.ownerWindow, this.ownerWindow = this.o.ownerWindow;
                    }, Jodit1.prototype.addPlace = function(e, t) {
                        var o = this, n = (0, s.resolveElement)(e, this.o.shadowRoot || this.od);
                        this.attachEvents(t), n.attributes && (0, s.toArray)(n.attributes).forEach(function(e) {
                            var n = e.name, i = e.value;
                            void 0 === r.Config.defaultOptions[n] || t && void 0 !== t[n] || (-1 !== [
                                "readonly",
                                "disabled"
                            ].indexOf(n) && (i = "" === i || "true" === i), /^[0-9]+(\.)?([0-9]+)?$/.test(i.toString()) && (i = Number(i)), o.options[n] = i);
                        });
                        var i = this.c.div("jodit-container");
                        i.classList.add("jodit"), i.classList.add("jodit-container"), i.classList.add("jodit_theme_".concat(this.o.theme || "default")), v(this.o.className, i), this.o.containerStyle && (0, s.css)(i, this.o.containerStyle);
                        var l = this.o.styleValues;
                        Object.keys(l).forEach(function(e) {
                            var t = (0, s.kebabCase)(e);
                            i.style.setProperty("--jd-".concat(t), l[e]);
                        }), i.setAttribute("contenteditable", "false");
                        var c = null;
                        this.o.inline && (-1 === [
                            "TEXTAREA",
                            "INPUT"
                        ].indexOf(n.nodeName) && (i = n, n.setAttribute(m, n.className.toString()), c = i.innerHTML, i.innerHTML = ""), i.classList.add("jodit_inline"), i.classList.add("jodit-container")), n !== i && (n.style.display && n.setAttribute(h, n.style.display), n.style.display = "none");
                        var u = this.c.div("jodit-workplace", {
                            contenteditable: !1
                        });
                        i.appendChild(u), this.message.destruct(), this.message = new a.UIMessages(this, u), n.parentNode && n !== i && n.parentNode.insertBefore(i, n), Object.defineProperty(n, "component", {
                            enumerable: !1,
                            configurable: !0,
                            value: this
                        });
                        var d = this.c.div("jodit-wysiwyg", {
                            contenteditable: !0,
                            "aria-disabled": !1,
                            tabindex: this.o.tabIndex
                        });
                        u.appendChild(d);
                        var p = {
                            editor: d,
                            element: n,
                            container: i,
                            workplace: u,
                            statusbar: new a.StatusBar(this, i),
                            options: this.isReady ? (0, s.ConfigProto)(t || {}, r.Config.defaultOptions) : this.options,
                            history: new a.History(this),
                            editorWindow: this.ow
                        };
                        this.__elementToPlace.set(d, p), this.setCurrentPlace(p), this.places.push(p), this.setNativeEditorValue(this.getElementValue());
                        var f = this.__initEditor(c), g = this.options;
                        return (0, s.callPromise)(f, function() {
                            g.enableDragAndDropFileToEditor && g.uploader && (g.uploader.url || g.uploader.insertImageAsBase64URI) && o.uploader.bind(o.editor), o.__elementToPlace.get(o.editor) || o.__elementToPlace.set(o.editor, p), o.e.fire("afterAddPlace", p);
                        });
                    }, Jodit1.prototype.addDisclaimer = function(e) {
                        this.workplace.appendChild(e);
                    }, Jodit1.prototype.setCurrentPlace = function(e) {
                        this.currentPlace !== e && (this.isEditorMode() || this.setMode(i.MODE_WYSIWYG), this.currentPlace = e, this.buildToolbar(), this.isReady && this.e.fire("changePlace", e));
                    }, Jodit1.prototype.__initEditor = function(e) {
                        var t = this, o = this.__createEditor();
                        return (0, s.callPromise)(o, function() {
                            if (!t.isInDestruct) {
                                if (t.element !== t.container) {
                                    var o = t.getElementValue();
                                    o !== t.getEditorValue() && t.setEditorValue(o);
                                } else null != e && t.setEditorValue(e);
                                var n = t.o.defaultMode;
                                if (t.o.saveModeInStorage) {
                                    var r = t.storage.get("jodit_default_mode");
                                    "string" == typeof r && (n = parseInt(r, 10));
                                }
                                t.setMode(n), t.o.readonly && (t.__wasReadOnly = !1, t.setReadOnly(!0)), t.o.disabled && t.setDisabled(!0);
                                try {
                                    t.ed.execCommand("defaultParagraphSeparator", !1, t.o.enter.toLowerCase());
                                } catch (e) {}
                                try {
                                    t.ed.execCommand("enableObjectResizing", !1, "false");
                                } catch (e) {}
                                try {
                                    t.ed.execCommand("enableInlineTableEditing", !1, "false");
                                } catch (e) {}
                            }
                        });
                    }, Jodit1.prototype.__createEditor = function() {
                        var e = this, t = this.editor, o = this.e.fire("createEditor", this);
                        return (0, s.callPromise)(o, function() {
                            if (!e.isInDestruct) {
                                if ((!1 === o || (0, s.isPromise)(o)) && a.Dom.safeRemove(t), v(e.o.editorClassName || e.o.editorCssClass, e.editor), e.o.editorCssClass && e.editor.classList.add(e.o.editorCssClass), e.o.style && (0, s.css)(e.editor, e.o.style), e.e.on("synchro", function() {
                                    e.setEditorValue();
                                }).on("focus", function() {
                                    e.editorIsActive = !0;
                                }).on("blur", function() {
                                    return e.editorIsActive = !1;
                                }), e.__prepareWYSIWYGEditor(), e.o.direction) {
                                    var n = "rtl" === e.o.direction.toLowerCase() ? "rtl" : "ltr";
                                    e.container.style.direction = n, e.container.setAttribute("dir", n), e.toolbar.setDirection(n);
                                }
                                e.o.triggerChangeEvent && e.e.on("change", e.async.debounce(function() {
                                    e.e && e.e.fire(e.element, "change");
                                }, e.defaultTimeout));
                            }
                        });
                    }, Jodit1.prototype.__prepareWYSIWYGEditor = function() {
                        var e = this, t = this.editor;
                        if (this.o.direction) {
                            var o = "rtl" === this.o.direction.toLowerCase() ? "rtl" : "ltr";
                            this.editor.style.direction = o, this.editor.setAttribute("dir", o);
                        }
                        this.e.on(t, "mousedown touchstart focus", function() {
                            var o = e.__elementToPlace.get(t);
                            o && e.setCurrentPlace(o);
                        }).on(t, "compositionend", this.synchronizeValues).on(t, "selectionchange selectionstart keydown keyup input keypress dblclick mousedown mouseup click copy cut dragstart drop dragover paste resize touchstart touchend focus blur", function(t) {
                            if (!e.o.readonly && !e.__isSilentChange && !(t instanceof e.ew.KeyboardEvent && t.isComposing) && e.e && e.e.fire) {
                                if (!1 === e.e.fire(t.type, t)) return !1;
                                e.synchronizeValues();
                            }
                        });
                    }, Jodit1.prototype.fetch = function(e, t) {
                        var o = this, r = new f.Ajax(n.__assign({
                            url: e
                        }, t), this.o.defaultAjaxOptions), i = function() {
                            o.e.off("beforeDestruct", i), o.progressbar.progress(100).hide(), r.destruct();
                        };
                        this.e.one("beforeDestruct", i), this.progressbar.show().progress(30);
                        var a = r.send();
                        return a.finally(i).catch(function() {
                            return null;
                        }), a;
                    }, Jodit1.prototype.destruct = function() {
                        var t = this;
                        if (!this.isInDestruct && (this.setStatus(a.STATUSES.beforeDestruct), this.__elementToPlace.clear(), this.editor)) {
                            var o = this.getEditorValue();
                            this.storage.clear(), this.buffer.clear(), this.commands.clear(), this.__selectionLocked = null, this.e.off(this.ow, "resize"), this.e.off(this.ow), this.e.off(this.od), this.e.off(this.od.body), this.places.forEach(function(e) {
                                var n = e.container, r = e.workplace, i = e.statusbar, l = e.element, c = e.iframe, u = e.editor, d = e.history;
                                if (l !== n) {
                                    if (l.hasAttribute(h)) {
                                        var p = (0, s.attr)(l, h);
                                        p && (l.style.display = p, l.removeAttribute(h));
                                    } else l.style.display = "";
                                } else l.hasAttribute(m) && (l.className = (0, s.attr)(l, m) || "", l.removeAttribute(m));
                                l.hasAttribute("style") && !(0, s.attr)(l, "style") && l.removeAttribute("style"), i.destruct(), t.e.off(n), t.e.off(l), t.e.off(u), a.Dom.safeRemove(r), a.Dom.safeRemove(u), n !== l && a.Dom.safeRemove(n), Object.defineProperty(l, "component", {
                                    enumerable: !1,
                                    configurable: !0,
                                    value: null
                                }), a.Dom.safeRemove(c), n === l && (l.innerHTML = o), d.destruct();
                            }), this.places.length = 0, this.currentPlace = {}, delete u.instances[this.id], e.prototype.destruct.call(this);
                        }
                    }, Jodit1.fatMode = !1, Jodit1.plugins = u.pluginSystem, Jodit1.modules = u.modules, Jodit1.ns = u.modules, Jodit1.decorators = {}, Jodit1.constants = i, Jodit1.instances = u.instances, Jodit1.lang = c.lang, Jodit1.core = {
                        Plugin: a.Plugin
                    }, n.__decorate([
                        d.cache
                    ], Jodit1.prototype, "uploader", null), n.__decorate([
                        d.cache
                    ], Jodit1.prototype, "filebrowser", null), n.__decorate([
                        (0, d.throttle)()
                    ], Jodit1.prototype, "synchronizeValues", null), n.__decorate([
                        (0, d.watch)(":internalChange")
                    ], Jodit1.prototype, "updateElementValue", null), n.__decorate([
                        d.autobind
                    ], Jodit1.prototype, "__prepareWYSIWYGEditor", null), t = n.__decorate([
                        (0, d.derive)(p.Dlgs)
                    ], Jodit1);
                }(a.ViewWithToolbar);
                function v(e, t) {
                    e && e.split(/\s+/).forEach(function(e) {
                        return t.classList.add(e);
                    });
                }
                t.Jodit = Jodit1;
            },
            26435: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(10172), r = {}, i = o(90643), a = o(52532), s = o(75178), l = o(51048), c = o(22999), u = o(34145), d = o(40272), p = o(2978), f = o(99113), h = o(51923), m = o(21268), v = o(37289), g = o(26501), y = o(17084), _ = o(96891), b = o(31211), w = o(31109), S = o(79375), C = o(21042), j = o(73895);
                r = {
                    ar: i,
                    cs_cz: a,
                    de: s,
                    en: l,
                    es: c,
                    fr: u,
                    he: d,
                    hu: p,
                    id: f,
                    it: h,
                    ja: m,
                    ko: v,
                    mn: g,
                    nl: y,
                    pl: _,
                    pt_br: b,
                    ru: w,
                    tr: S,
                    zh_cn: C,
                    zh_tw: j
                };
                var E = o(11399), x = function(e) {
                    return e ? e.default || e : {};
                }, k = {};
                (0, n.isArray)(x(E)) && x(E).forEach(function(e, t) {
                    k[t] = e;
                }), Object.keys(r).forEach(function(e) {
                    var t = x(r[e]);
                    (0, n.isArray)(t) ? (r[e] = {}, t.forEach(function(t, o) {
                        r[e][k[o]] = t;
                    })) : r[e] = t;
                }), t.default = r;
            },
            60403: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ContextMenu = void 0;
                var n = o(20255);
                o(47086);
                var r = o(35799), i = o(96516), a = o(10172), s = o(11441), l = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "ContextMenu";
                    }, t.prototype.show = function(e, t, o) {
                        var n = this, r = this, s = this.j.c.div(this.getFullElName("actions"));
                        (0, a.isArray)(o) && (o.forEach(function(e) {
                            if (e) {
                                var t = (0, i.Button)(n.jodit, e.icon || "empty", e.title);
                                n.jodit && t.setParentView(n.jodit), t.setMod("context", "menu"), t.onAction(function(t) {
                                    var o;
                                    return null === (o = e.exec) || void 0 === o || o.call(r, t), r.close(), !1;
                                }), s.appendChild(t.container);
                            }
                        }), this.setContent(s).open(function() {
                            return {
                                left: e,
                                top: t,
                                width: 0,
                                height: 0
                            };
                        }, !0));
                    }, n.__decorate([
                        s.component
                    ], t);
                }(r.Popup);
                t.ContextMenu = l;
            },
            97528: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Alert = void 0;
                var n = o(6690), r = o(40332), i = o(64968), a = o(2074);
                t.Alert = function(e, t, o, s) {
                    void 0 === s && (s = "jodit-dialog_alert"), (0, r.isFunction)(t) && (o = t, t = void 0);
                    var l = this instanceof n.Dialog ? this : new n.Dialog, c = l.c.div(s), u = (0, a.Button)(l, "ok", "Ok");
                    return (0, r.asArray)(e).forEach(function(e) {
                        c.appendChild(i.Dom.isNode(e) ? e : l.c.fromHTML(e));
                    }), u.onAction(function() {
                        o && (0, r.isFunction)(o) && !1 === o(l) || l.close();
                    }), l.setFooter([
                        u
                    ]), l.open(c, t || "&nbsp;", !0, !0), u.focus(), l;
                };
            },
            47360: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Confirm = void 0;
                var n = o(6690), r = o(42096), i = o(96031);
                t.Confirm = function(e, t, o) {
                    var a = this instanceof n.Dialog ? this : new n.Dialog, s = a.c.fromHTML('<form class="jodit-dialog_prompt"></form>'), l = a.c.element("label");
                    (0, r.isFunction)(t) && (o = t, t = void 0), l.appendChild(a.c.fromHTML(e)), s.appendChild(l);
                    var c = function(e) {
                        return function() {
                            o && !1 === o(e) || a.close();
                        };
                    }, u = (0, i.Button)(a, "cancel", "Cancel"), d = (0, i.Button)(a, "ok", "Yes");
                    return u.onAction(c(!1)), d.onAction(c(!0)), a.e.on(s, "submit", function() {
                        return c(!0)(), !1;
                    }), a.setFooter([
                        d,
                        u
                    ]), a.open(s, t || "&nbsp;", !0, !0), d.focus(), a;
                };
            },
            6690: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Dialog = void 0;
                var n = o(20255);
                o(16462);
                var r = o(93166), i = o(86893), a = o(40332), s = (o(52378), o(43608)), l = o(64968), c = o(56562), u = o(17332), d = o(43441), p = o(75902), f = o(2074), h = o(71014);
                r.Config.prototype.dialog = {
                    namespace: "",
                    extraButtons: [],
                    resizable: !0,
                    draggable: !0,
                    buttons: [
                        "dialog.close"
                    ],
                    removeButtons: [],
                    toolbarButtonSize: "middle",
                    zIndex: "inherit"
                }, r.Config.prototype.controls.dialog = {
                    close: {
                        icon: "cancel",
                        exec: function(e) {
                            e.close();
                        }
                    }
                };
                var m = function(e) {
                    function t(t) {
                        void 0 === t && (t = {});
                        var o = e.call(this, t) || this;
                        o.destroyAfterClose = !1, o.moved = !1, o.resizable = !1, o.draggable = !1, o.startX = 0, o.startY = 0, o.startPoint = {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0
                        }, o.lockSelect = function() {
                            o.setMod("moved", !0);
                        }, o.unlockSelect = function() {
                            o.setMod("moved", !1);
                        }, o.onResize = function() {
                            o.options && o.o.resizable && !o.moved && o.isOpened && !o.offsetX && !o.offsetY && o.setPosition();
                        }, o.isModal = !1, o.isOpened = !1;
                        var n = o;
                        n.options = (0, a.ConfigProto)(t, (0, a.ConfigProto)(r.Config.prototype.dialog, p.View.defaultOptions)), l.Dom.safeRemove(n.container);
                        var i = o.getFullElName.bind(o);
                        n.container = o.c.fromHTML('<div class="jodit jodit-dialog '.concat(o.componentName, '">\n\t\t\t\t<div class="').concat(i("overlay"), '"></div>\n\t\t\t\t<div class="').concat(o.getFullElName("panel"), '">\n\t\t\t\t\t<div class="').concat(i("header"), '">\n\t\t\t\t\t\t<div class="').concat(i("header-title"), '"></div>\n\t\t\t\t\t\t<div class="').concat(i("header-toolbar"), '"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="').concat(i("content"), '"></div>\n\t\t\t\t\t<div class="').concat(i("footer"), '"></div>\n\t\t\t\t\t<div class="').concat(i("resizer"), '">').concat(f.Icon.get("resize_handler"), "</div>\n\t\t\t\t</div>\n\t\t\t</div>")), o.o.zIndex && (o.container.style.zIndex = o.o.zIndex.toString()), (0, a.attr)(n.container, "role", "dialog"), Object.defineProperty(n.container, "component", {
                            value: o
                        }), n.setMod("theme", n.o.theme || "default").setMod("resizable", Boolean(n.o.resizable));
                        var s = n.getElm("panel"), c = n.getElm("resizer"), d = n.getElm("header-title"), m = n.getElm("content"), v = n.getElm("footer"), g = n.getElm("header-toolbar");
                        o.message.destruct(), o.message = new h.UIMessages(o, s), o.dialog = s, o.resizer = c, o.dialogbox_header = d, o.dialogbox_content = m, o.dialogbox_footer = v, o.dialogbox_toolbar = g, (0, a.css)(n.dialog, {
                            maxWidth: n.options.maxWidth,
                            minHeight: n.options.minHeight,
                            minWidth: n.options.minWidth
                        });
                        var y = n.getElm("header");
                        y && n.e.on(y, "pointerdown touchstart", n.onHeaderMouseDown), n.e.on(n.resizer, "mousedown touchstart", n.onResizerMouseDown);
                        var _ = u.pluginSystem.get("fullsize");
                        return (0, a.isFunction)(_) && _(n), o.e.on(n.container, "close_dialog", n.close).on(o.ow, "keydown", o.onEsc).on(o.ow, "resize", o.onResize), o;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "Dialog";
                    }, Object.defineProperty(t.prototype, "destination", {
                        get: function() {
                            var e;
                            return null !== (e = this.o.shadowRoot) && void 0 !== e ? e : this.od.body;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.setElements = function(e, t) {
                        var o = this, n = [];
                        (0, a.asArray)(t).forEach(function(t) {
                            if ((0, a.isArray)(t)) {
                                var r = o.c.div(o.getFullElName("column"));
                                return n.push(r), e.appendChild(r), o.setElements(r, t);
                            }
                            var i;
                            i = (0, a.isString)(t) ? o.c.fromHTML(t) : (0, a.hasContainer)(t) ? t.container : t, n.push(i), i.parentNode !== e && e.appendChild(i);
                        }), (0, a.toArray)(e.childNodes).forEach(function(t) {
                            -1 === n.indexOf(t) && e.removeChild(t);
                        });
                    }, t.prototype.onMouseUp = function() {
                        (this.draggable || this.resizable) && (this.removeGlobalResizeListeners(), this.draggable = !1, this.resizable = !1, this.unlockSelect(), this.e && (this.removeGlobalResizeListeners(), this.e.fire(this, "endResize endMove")));
                    }, t.prototype.onHeaderMouseDown = function(e) {
                        var t = e.target;
                        !this.o.draggable || t && t.nodeName.match(/^(INPUT|SELECT)$/) || (this.draggable = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.x = (0, a.css)(this.dialog, "left"), this.startPoint.y = (0, a.css)(this.dialog, "top"), this.setMaxZIndex(), e.cancelable && e.preventDefault(), this.lockSelect(), this.addGlobalResizeListeners(), this.e && this.e.fire(this, "startMove"));
                    }, t.prototype.onMouseMove = function(e) {
                        this.draggable && this.o.draggable && (this.setPosition(this.startPoint.x + e.clientX - this.startX, this.startPoint.y + e.clientY - this.startY), this.e && this.e.fire(this, "move", e.clientX - this.startX, e.clientY - this.startY), e.stopImmediatePropagation()), this.resizable && this.o.resizable && (this.setSize(this.startPoint.w + e.clientX - this.startX, this.startPoint.h + e.clientY - this.startY), this.e && this.e.fire(this, "resizeDialog", e.clientX - this.startX, e.clientY - this.startY));
                    }, t.prototype.onEsc = function(e) {
                        if (this.isOpened && e.key === i.KEY_ESC && !0 !== this.getMod("static")) {
                            var t = this.getMaxZIndexDialog();
                            t ? t.close() : this.close(), e.stopImmediatePropagation();
                        }
                    }, t.prototype.onResizerMouseDown = function(e) {
                        this.resizable = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.w = this.dialog.offsetWidth, this.startPoint.h = this.dialog.offsetHeight, this.lockSelect(), this.addGlobalResizeListeners(), this.e && this.e.fire(this, "startResize");
                    }, t.prototype.addGlobalResizeListeners = function() {
                        var e = this;
                        e.e.on(e.ow, "pointermove touchmove", e.onMouseMove).on(e.ow, "pointerup touchend", e.onMouseUp);
                    }, t.prototype.removeGlobalResizeListeners = function() {
                        var e = this;
                        e.e.off(e.ow, "mousemove pointermove", e.onMouseMove).off(e.ow, "mouseup pointerup", e.onMouseUp);
                    }, t.prototype.setSize = function(e, t) {
                        return null == e && (e = this.dialog.offsetWidth), null == t && (t = this.dialog.offsetHeight), (0, a.css)(this.dialog, {
                            width: e,
                            height: t
                        }), this;
                    }, t.prototype.calcAutoSize = function() {
                        return this.setSize("auto", "auto"), this.setSize(), this;
                    }, t.prototype.setPosition = function(e, t) {
                        var o = this.ow.innerWidth / 2 - this.dialog.offsetWidth / 2, n = this.ow.innerHeight / 2 - this.dialog.offsetHeight / 2;
                        return 0 > o && (o = 0), 0 > n && (n = 0), void 0 !== e && void 0 !== t && (this.offsetX = e, this.offsetY = t, this.moved = Math.abs(e - o) > 100 || Math.abs(t - n) > 100), this.dialog.style.left = (e || o) + "px", this.dialog.style.top = (t || n) + "px", this;
                    }, t.prototype.setHeader = function(e) {
                        return this.setElements(this.dialogbox_header, e), this;
                    }, t.prototype.setContent = function(e) {
                        return this.setElements(this.dialogbox_content, e), this;
                    }, t.prototype.setFooter = function(e) {
                        return this.setElements(this.dialogbox_footer, e), this.setMod("footer", Boolean(e)), this;
                    }, t.prototype.getZIndex = function() {
                        return parseInt((0, a.css)(this.container, "zIndex"), 10) || 0;
                    }, t.prototype.getMaxZIndexDialog = function() {
                        var e, t, o = 0, n = this;
                        return (0, a.$$)(".jodit-dialog", this.destination).forEach(function(r) {
                            e = r.component, t = parseInt((0, a.css)(r, "zIndex"), 10), e.isOpened && !isNaN(t) && t > o && (n = e, o = t);
                        }), n;
                    }, t.prototype.setMaxZIndex = function() {
                        if (!this.getMod("static")) {
                            var e = 20000004, t = 0;
                            (0, a.$$)(".jodit-dialog", this.destination).forEach(function(o) {
                                t = parseInt((0, a.css)(o, "zIndex"), 10), e = Math.max(isNaN(t) ? 0 : t, e);
                            }), this.container.style.zIndex = (e + 1).toString();
                        }
                    }, t.prototype.toggleFullSize = function(t) {
                        (0, a.isVoid)(t) && (t = !this.getMod("fullsize")), this.setMod("fullsize", t), e.prototype.toggleFullSize.call(this, t);
                    }, t.prototype.open = function(e, t, o, n) {
                        if (u.eventEmitter.fire("closeAllPopups hideHelpers"), !1 === this.e.fire(this, "beforeOpen")) return this;
                        (0, a.isBoolean)(e) && (o = e), (0, a.isBoolean)(t) && (n = t), this.destroyAfterClose = !0 === o;
                        var r = (0, a.isBoolean)(e) ? void 0 : e, i = (0, a.isBoolean)(t) ? void 0 : t;
                        return void 0 !== i && this.setHeader(i), r && this.setContent(r), this.setMod("active", !0), this.isOpened = !0, this.setModal(n), this.destination.appendChild(this.container), !0 !== this.getMod("static") ? (this.setPosition(this.offsetX, this.offsetY), this.setMaxZIndex()) : this.container.style.removeProperty("z-index"), this.o.fullsize && this.toggleFullSize(!0), this.e.fire("afterOpen", this), this;
                    }, t.prototype.setModal = function(e) {
                        return this.isModal = Boolean(e), this.setMod("modal", this.isModal), this;
                    }, t.prototype.close = function() {
                        return this.isDestructed || !this.isOpened || !0 === this.getMod("static") || !1 === this.e.fire("beforeClose", this) || (this.setMod("active", !1), this.isOpened = !1, this.isFullSize && this.toggleFullSize(!1), l.Dom.safeRemove(this.container), this.removeGlobalResizeListeners(), this.destroyAfterClose && this.destruct(), this.e.fire(this, "afterClose"), this.e.fire(this.ow, "joditCloseDialog")), this;
                    }, t.prototype.buildToolbar = function() {
                        this.o.buttons && this.toolbar.build((0, a.splitArray)(this.o.buttons)).setMod("mode", "header").appendTo(this.dialogbox_toolbar);
                    }, t.prototype.destruct = function() {
                        this.isInDestruct || (this.setStatus(c.STATUSES.beforeDestruct), this.isOpened && this.close(), this.events && (this.removeGlobalResizeListeners(), this.events.off(this.container, "close_dialog", self.close).off(this.ow, "keydown", this.onEsc).off(this.ow, "resize", this.onResize)), e.prototype.destruct.call(this));
                    }, n.__decorate([
                        d.autobind
                    ], t.prototype, "onMouseUp", null), n.__decorate([
                        d.autobind
                    ], t.prototype, "onHeaderMouseDown", null), n.__decorate([
                        d.autobind
                    ], t.prototype, "onMouseMove", null), n.__decorate([
                        d.autobind
                    ], t.prototype, "onEsc", null), n.__decorate([
                        d.autobind
                    ], t.prototype, "onResizerMouseDown", null), n.__decorate([
                        d.autobind
                    ], t.prototype, "close", null), n.__decorate([
                        (0, d.hook)("ready")
                    ], t.prototype, "buildToolbar", null), n.__decorate([
                        d.component
                    ], t);
                }(s.ViewWithToolbar);
                t.Dialog = m;
            },
            92080: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Confirm = t.Prompt = t.Alert = t.Dialog = void 0;
                var n = o(6690);
                Object.defineProperty(t, "Dialog", {
                    enumerable: !0,
                    get: function() {
                        return n.Dialog;
                    }
                });
                var r = o(97528);
                Object.defineProperty(t, "Alert", {
                    enumerable: !0,
                    get: function() {
                        return r.Alert;
                    }
                });
                var i = o(35789);
                Object.defineProperty(t, "Prompt", {
                    enumerable: !0,
                    get: function() {
                        return i.Prompt;
                    }
                });
                var a = o(47360);
                Object.defineProperty(t, "Confirm", {
                    enumerable: !0,
                    get: function() {
                        return a.Confirm;
                    }
                });
            },
            35789: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Prompt = void 0;
                var n = o(92080), r = o(2074), i = o(40332);
                t.Prompt = function(e, t, o, a, s) {
                    var l = this instanceof n.Dialog ? this : new n.Dialog, c = (0, r.Button)(l, "cancel", "Cancel"), u = (0, r.Button)(l, "ok", "Ok"), d = l.c.element("form", {
                        class: "jodit-dialog_prompt"
                    }), p = l.c.element("input", {
                        autofocus: !0,
                        class: "jodit-input"
                    }), f = l.c.element("label");
                    (0, i.isFunction)(t) && (o = t, t = void 0), a && (0, i.attr)(p, "placeholder", a), f.appendChild(l.c.text(e)), d.appendChild(f), d.appendChild(p), c.onAction(l.close);
                    var h = function() {
                        o && (0, i.isFunction)(o) && !1 === o(p.value) || l.close();
                    };
                    return u.onAction(h), l.e.on(d, "submit", function() {
                        return h(), !1;
                    }), l.setFooter([
                        u,
                        c
                    ]), l.open(d, t || "&nbsp;", !0, !0), p.focus(), void 0 !== s && s.length && (p.value = s, p.select()), l;
                };
            },
            34468: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255), r = o(64968), i = o(40332), a = o(46341), s = o(2074), l = o(21347), c = o(35503), u = o(66267), d = o(36303), p = o(48096), f = "jodit-filebrowser-preview", h = function(e, t) {
                    return void 0 === e && (e = "next"), void 0 === t && (t = "right"), '<div class="'.concat(f, "__navigation ").concat(f, "__navigation_arrow_").concat(e, '">') + "" + s.Icon.get("angle-" + t) + "</a>";
                };
                t.default = function(e) {
                    if (!e.o.contextMenu) return function() {};
                    var t = (0, a.makeContextMenu)(e);
                    return function(o) {
                        var a = (0, l.getItem)(o.target, e.container);
                        if (a) {
                            var s = a, m = e.options, v = function(e) {
                                return (0, i.attr)(s, e) || "";
                            };
                            return e.async.setTimeout(function() {
                                var g = (0, l.elementToItem)(a, (0, u.elementsMap)(e));
                                g && (e.state.activeElements = [
                                    g
                                ], t.show(o.clientX, o.clientY, [
                                    !("1" === v("data-is-file") || !m.editImage || !e.dataProvider.canI("ImageResize") && !e.dataProvider.canI("ImageCrop")) && {
                                        icon: "pencil",
                                        title: "Edit",
                                        exec: function() {
                                            return c.openImageEditor.call(e, v("href"), v("data-name"), v("data-path"), v("data-source"));
                                        }
                                    },
                                    !!e.dataProvider.canI("FileRename") && {
                                        icon: "italic",
                                        title: "Rename",
                                        exec: function() {
                                            e.e.fire("fileRename.filebrowser", v("data-name"), v("data-path"), v("data-source"));
                                        }
                                    },
                                    !!e.dataProvider.canI("FileRemove") && {
                                        icon: "bin",
                                        title: "Delete",
                                        exec: function() {
                                            return n.__awaiter(void 0, void 0, Promise, function() {
                                                var t;
                                                return n.__generator(this, function(o) {
                                                    switch(o.label){
                                                        case 0:
                                                            return o.trys.push([
                                                                0,
                                                                2,
                                                                ,
                                                                3
                                                            ]), [
                                                                4,
                                                                (0, p.deleteFile)(e, v("data-name"), v("data-source"))
                                                            ];
                                                        case 1:
                                                            return o.sent(), [
                                                                3,
                                                                3
                                                            ];
                                                        case 2:
                                                            return t = o.sent(), [
                                                                2,
                                                                e.status(t)
                                                            ];
                                                        case 3:
                                                            return e.state.activeElements = [], [
                                                                2,
                                                                (0, d.loadTree)(e).catch(e.status)
                                                            ];
                                                    }
                                                });
                                            });
                                        }
                                    },
                                    !!m.preview && {
                                        icon: "eye",
                                        title: "Preview",
                                        exec: function() {
                                            var t = e.dlg({
                                                buttons: [
                                                    "fullsize",
                                                    "dialog.close"
                                                ]
                                            }), o = e.c.div(f, '<div class="jodit-icon_loader"></div>'), n = e.c.div(f + "__box"), a = e.c.fromHTML(h()), l = e.c.fromHTML(h("prev", "left")), c = function(i) {
                                                var c = e.c.element("img");
                                                c.setAttribute("src", i);
                                                var u = function() {
                                                    var i;
                                                    e.isInDestruct || (e.e.off(c, "load"), r.Dom.detach(o), m.showPreviewNavigation && (r.Dom.prevWithClass(s, e.files.getFullElName("item")) && o.appendChild(l), r.Dom.nextWithClass(s, e.files.getFullElName("item")) && o.appendChild(a)), o.appendChild(n), n.appendChild(c), t.setPosition(), null === (i = null == e ? void 0 : e.events) || void 0 === i || i.fire("previewOpenedAndLoaded"));
                                                };
                                                e.e.on(c, "load", u), c.complete && u();
                                            };
                                            e.e.on([
                                                a,
                                                l
                                            ], "click", function() {
                                                if (!(s = this === a ? r.Dom.nextWithClass(s, e.files.getFullElName("item")) : r.Dom.prevWithClass(s, e.files.getFullElName("item")))) throw (0, i.error)("Need element");
                                                r.Dom.detach(o), r.Dom.detach(n), o.innerHTML = '<div class="jodit-icon_loader"></div>', c(v("href"));
                                            }), e.e.on("beforeDestruct", function() {
                                                t.destruct();
                                            }), t.container.classList.add(f + "__dialog"), t.setContent(o), t.setPosition(), t.open(), c(v("href")), e.events.on("beforeDestruct", function() {
                                                t.destruct();
                                            }).fire("previewOpened");
                                        }
                                    },
                                    {
                                        icon: "upload",
                                        title: "Download",
                                        exec: function() {
                                            var t = v("href");
                                            t && e.ow.open(t);
                                        }
                                    }
                                ]));
                            }, e.defaultTimeout), e.e.on("beforeClose", function() {
                                return t.close();
                            }).on("beforeDestruct", function() {
                                return t.destruct();
                            }), o.stopPropagation(), o.preventDefault(), !1;
                        }
                    };
                };
            },
            66267: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.elementsMap = void 0;
                var o = new WeakMap;
                t.elementsMap = function(e) {
                    var t = o.get(e);
                    return t || o.set(e, t = {}), t;
                };
            },
            63511: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FileBrowserItem = void 0;
                var n = o(40332), r = function() {
                    function e(e) {
                        var t = this;
                        this.data = e, Object.keys(e).forEach(function(o) {
                            t[o] = e[o];
                        });
                    }
                    return e.create = function(t) {
                        return t instanceof e ? t : new e(t);
                    }, Object.defineProperty(e.prototype, "path", {
                        get: function() {
                            return (0, n.normalizePath)(this.data.source.path ? this.data.source.path + "/" : "/");
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "imageURL", {
                        get: function() {
                            var e = this.time || (new Date).getTime().toString(), t = this.data, o = t.source, r = t.thumb || t.file;
                            return t.thumbIsAbsolute && r ? r : (0, n.normalizeUrl)(o.baseurl, o.path, r || "") + "?_tmst=" + encodeURIComponent(e);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "fileURL", {
                        get: function() {
                            var e = this.data.name, t = this.data, o = t.file, r = t.source;
                            return void 0 !== o && (e = o), t.fileIsAbsolute && e ? e : (0, n.normalizeUrl)(r.baseurl, r.path, e || "");
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "time", {
                        get: function() {
                            var e = this.data.changed;
                            return e && ("number" == typeof e ? new Date(e).toLocaleString() : e) || "";
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(e.prototype, "uniqueHashKey", {
                        get: function() {
                            var e = this.data;
                            return [
                                e.sourceName,
                                e.name,
                                e.file,
                                this.time,
                                e.thumb
                            ].join("_").toLowerCase().replace(/[^0-9a-z\-.]/g, "-");
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.toJSON = function() {
                        return this.data;
                    }, e;
                }();
                t.FileBrowserItem = r;
            },
            38097: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255), r = o(93166), i = o(10172), a = o(41374), s = o(6102);
                r.Config.prototype.filebrowser = {
                    namespace: "",
                    extraButtons: [],
                    filter: function(e, t) {
                        return t = t.toLowerCase(), (0, i.isString)(e) ? -1 !== e.toLowerCase().indexOf(t) : (0, i.isString)(e.name) ? -1 !== e.name.toLowerCase().indexOf(t) : !(0, i.isString)(e.file) || -1 !== e.file.toLowerCase().indexOf(t);
                    },
                    sortBy: "changed-desc",
                    sort: function(e, t, o) {
                        var r = n.__read(o.toLowerCase().split("-"), 2), a = r[0], l = "asc" === r[1], c = function(e, t) {
                            return t > e ? l ? -1 : 1 : e > t ? l ? 1 : -1 : 0;
                        };
                        if ((0, i.isString)(e)) return c(e.toLowerCase(), t.toLowerCase());
                        if (void 0 === e[a] || "name" === a) return (0, i.isString)(e.name) ? c(e.name.toLowerCase(), t.name.toLowerCase()) : (0, i.isString)(e.file) ? c(e.file.toLowerCase(), t.file.toLowerCase()) : 0;
                        switch(a){
                            case "changed":
                                var u = new Date(e.changed).getTime(), d = new Date(t.changed).getTime();
                                return l ? u - d : d - u;
                            case "size":
                                return u = (0, s.humanSizeToBytes)(e.size), d = (0, s.humanSizeToBytes)(t.size), l ? u - d : d - u;
                        }
                        return 0;
                    },
                    editImage: !0,
                    preview: !0,
                    showPreviewNavigation: !0,
                    showSelectButtonInPreview: !0,
                    contextMenu: !0,
                    howLongShowMsg: 3e3,
                    createNewFolder: !0,
                    deleteFolder: !0,
                    renameFolder: !0,
                    moveFolder: !0,
                    moveFile: !0,
                    permissionsPresets: {
                        allowFileDownload: void 0,
                        allowFileMove: void 0,
                        allowFileRemove: void 0,
                        allowFileRename: void 0,
                        allowFileUpload: void 0,
                        allowFileUploadRemote: void 0,
                        allowFiles: void 0,
                        allowFolderCreate: void 0,
                        allowFolderMove: void 0,
                        allowFolderRemove: void 0,
                        allowFolderRename: void 0,
                        allowFolderTree: void 0,
                        allowFolders: void 0,
                        allowGeneratePdf: void 0,
                        allowImageCrop: void 0,
                        allowImageResize: void 0
                    },
                    showFoldersPanel: !0,
                    storeLastOpenedFolder: !0,
                    width: 859,
                    height: 400,
                    buttons: [
                        "filebrowser.upload",
                        "filebrowser.remove",
                        "filebrowser.update",
                        "filebrowser.select",
                        "filebrowser.edit",
                        "|",
                        "filebrowser.tiles",
                        "filebrowser.list",
                        "|",
                        "filebrowser.filter",
                        "|",
                        "filebrowser.sort"
                    ],
                    removeButtons: [],
                    fullsize: !1,
                    showTooltip: !0,
                    view: null,
                    isSuccess: function(e) {
                        return e.success;
                    },
                    getMessage: function(e) {
                        return void 0 !== e.data.messages && (0, i.isArray)(e.data.messages) ? e.data.messages.join(" ") : "";
                    },
                    showFileName: !0,
                    showFileSize: !0,
                    showFileChangeTime: !0,
                    saveStateInStorage: {
                        storeLastOpenedFolder: !0,
                        storeView: !0,
                        storeSortBy: !0
                    },
                    pixelOffsetLoadNewChunk: 200,
                    getThumbTemplate: function(e, t, o) {
                        var n = this.options, r = this.files.getFullElName("item"), i = n.showFileName, a = n.showFileSize && e.size, s = n.showFileChangeTime && e.time, l = "";
                        void 0 !== e.file && (l = e.file);
                        var c = '<div class="'.concat(r, '-info">').concat(i ? '<span class="'.concat(r, '-info-filename">').concat(l, "</span>") : "").concat(a ? '<span class="'.concat(r, '-info-filesize">').concat(e.size, "</span>") : "").concat(s ? '<span class="'.concat(r, '-info-filechanged">').concat(s, "</span>") : "", "</div>");
                        return '<a\n\t\t\tdata-jodit-filebrowser-item="true"\n\t\t\tdata-is-file="'.concat(e.isImage ? 0 : 1, '"\n\t\t\tdraggable="true"\n\t\t\tclass="').concat(r, '"\n\t\t\thref="').concat(e.fileURL, '"\n\t\t\tdata-source="').concat(o, '"\n\t\t\tdata-path="').concat(e.path, '"\n\t\t\tdata-name="').concat(l, '"\n\t\t\ttitle="').concat(l, '"\n\t\t\tdata-url="').concat(e.fileURL, '">\n\t\t\t\t<img\n\t\t\t\t\tdata-is-file="').concat(e.isImage ? 0 : 1, '"\n\t\t\t\t\tdata-src="').concat(e.fileURL, '"\n\t\t\t\t\tsrc="').concat(e.imageURL, '"\n\t\t\t\t\talt="').concat(l, '"\n\t\t\t\t\tloading="lazy"\n\t\t\t\t/>\n\t\t\t\t').concat(i || a || s ? c : "", "\n\t\t\t</a>");
                    },
                    ajax: n.__assign(n.__assign({}, r.Config.prototype.defaultAjaxOptions), {
                        url: "",
                        data: {},
                        cache: !0,
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        method: "POST",
                        processData: !0,
                        headers: {},
                        prepareData: function(e) {
                            return e;
                        },
                        process: function(e) {
                            return e;
                        }
                    }),
                    create: {
                        data: {
                            action: "folderCreate"
                        }
                    },
                    getLocalFileByUrl: {
                        data: {
                            action: "getLocalFileByUrl"
                        }
                    },
                    resize: {
                        data: {
                            action: "imageResize"
                        }
                    },
                    crop: {
                        data: {
                            action: "imageCrop"
                        }
                    },
                    fileMove: {
                        data: {
                            action: "fileMove"
                        }
                    },
                    folderMove: {
                        data: {
                            action: "folderMove"
                        }
                    },
                    fileRename: {
                        data: {
                            action: "fileRename"
                        }
                    },
                    folderRename: {
                        data: {
                            action: "folderRename"
                        }
                    },
                    fileRemove: {
                        data: {
                            action: "fileRemove"
                        }
                    },
                    folderRemove: {
                        data: {
                            action: "folderRemove"
                        }
                    },
                    items: {
                        data: {
                            action: "files"
                        }
                    },
                    folder: {
                        data: {
                            action: "folders"
                        }
                    },
                    permissions: {
                        data: {
                            action: "permissions"
                        }
                    }
                }, r.Config.prototype.controls.filebrowser = {
                    upload: {
                        icon: "plus",
                        isInput: !0,
                        isDisabled: function(e) {
                            return !e.dataProvider.canI("FileUpload");
                        },
                        getContent: function(e) {
                            var t = new a.UIFileInput(e, {
                                onlyImages: e.state.onlyImages
                            });
                            return e.e.fire("bindUploader.filebrowser", t.container), t.container;
                        }
                    },
                    remove: {
                        icon: "bin",
                        isDisabled: function(e) {
                            return !e.state.activeElements.length || !e.dataProvider.canI("FileRemove");
                        },
                        exec: function(e) {
                            e.e.fire("fileRemove.filebrowser");
                        }
                    },
                    update: {
                        exec: function(e) {
                            e.e.fire("update.filebrowser");
                        }
                    },
                    select: {
                        icon: "check",
                        isDisabled: function(e) {
                            return !e.state.activeElements.length;
                        },
                        exec: function(e) {
                            e.e.fire("select.filebrowser");
                        }
                    },
                    edit: {
                        icon: "pencil",
                        isDisabled: function(e) {
                            var t = e.state.activeElements;
                            return 1 !== t.length || !t[0].isImage || !(e.dataProvider.canI("ImageCrop") || e.dataProvider.canI("ImageResize"));
                        },
                        exec: function(e) {
                            e.e.fire("edit.filebrowser");
                        }
                    },
                    tiles: {
                        icon: "th",
                        isActive: function(e) {
                            return "tiles" === e.state.view;
                        },
                        exec: function(e) {
                            e.e.fire("view.filebrowser", "tiles");
                        }
                    },
                    list: {
                        icon: "th-list",
                        isActive: function(e) {
                            return "list" === e.state.view;
                        },
                        exec: function(e) {
                            e.e.fire("view.filebrowser", "list");
                        }
                    },
                    filter: {
                        isInput: !0,
                        getContent: function(e, t, o) {
                            var n = o.container.querySelector(".jodit-input");
                            if (n) return n;
                            var r = e.c.element("input", {
                                class: "jodit-input",
                                placeholder: e.i18n("Filter")
                            });
                            return r.value = e.state.filterWord, e.e.on(r, "keydown mousedown", e.async.debounce(function() {
                                e.e.fire("filter.filebrowser", r.value);
                            }, e.defaultTimeout)), r;
                        }
                    },
                    sort: {
                        isInput: !0,
                        getContent: function(e) {
                            var t = e.c.fromHTML('<select class="jodit-input jodit-select">' + '<option value="changed-asc">'.concat(e.i18n("Sort by changed"), " (\u2B06)</option>") + '<option value="changed-desc">'.concat(e.i18n("Sort by changed"), " (\u2B07)</option>") + '<option value="name-asc">'.concat(e.i18n("Sort by name"), " (\u2B06)</option>") + '<option value="name-desc">'.concat(e.i18n("Sort by name"), " (\u2B07)</option>") + '<option value="size-asc">'.concat(e.i18n("Sort by size"), " (\u2B06)</option>") + '<option value="size-desc">'.concat(e.i18n("Sort by size"), " (\u2B07)</option>") + "</select>");
                            return t.value = e.state.sortBy, e.e.on("sort.filebrowser", function(e) {
                                t.value !== e && (t.value = e);
                            }).on(t, "change", function() {
                                e.e.fire("sort.filebrowser", t.value);
                            }), t;
                        }
                    }
                };
            },
            82530: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.DEFAULT_SOURCE_NAME = void 0;
                var n = o(20255), r = o(40332), i = o(30056), a = o(43441), s = o(63511);
                t.DEFAULT_SOURCE_NAME = "default";
                var l = function() {
                    function e(e, t) {
                        this.parent = e, this.options = t, this.__currentPermissions = null, this.ajaxInstances = new Map, this.progressHandler = function(e) {};
                    }
                    return Object.defineProperty(e.prototype, "o", {
                        get: function() {
                            return this.options;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.get = function(e) {
                        var t = this, o = this.ajaxInstances;
                        if (o.has(e)) {
                            var n = o.get(e);
                            null == n || n.abort(), o.delete(e);
                        }
                        var a = (0, r.ConfigProto)(void 0 !== this.options[e] ? this.options[e] : {}, (0, r.ConfigProto)({
                            onProgress: this.progressHandler
                        }, this.o.ajax));
                        a.prepareData && (a.data = a.prepareData.call(this, a.data));
                        var s = new i.Ajax(a);
                        o.set(e, s);
                        var l = s.send();
                        return l.finally(function() {
                            s.destruct(), o.delete(e), t.progressHandler(100);
                        }).catch(function() {
                            return null;
                        }), l.then(function(e) {
                            return e.json();
                        }).then(function(e) {
                            if (e && !t.isSuccess(e)) throw new Error(t.getMessage(e));
                            return e;
                        });
                    }, e.prototype.onProgress = function(e) {
                        this.progressHandler = e;
                    }, e.prototype.permissions = function(e, t) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            var o = this;
                            return n.__generator(this, function(n) {
                                return this.o.permissions ? (this.o.permissions.data.path = e, this.o.permissions.data.source = t, this.o.permissions.url ? [
                                    2,
                                    this.get("permissions").then(function(e) {
                                        var t = o.o.permissions.process;
                                        if (t || (t = o.o.ajax.process), t) {
                                            var n = t.call(self, e);
                                            n.data.permissions && (o.__currentPermissions = n.data.permissions);
                                        }
                                        return o.__currentPermissions;
                                    })
                                ] : [
                                    2,
                                    null
                                ]) : [
                                    2,
                                    null
                                ];
                            });
                        });
                    }, e.prototype.canI = function(e) {
                        var t = "allow" + e, o = this.o.permissionsPresets[t];
                        return void 0 !== o ? o : null == this.__currentPermissions || void 0 === this.__currentPermissions[t] || this.__currentPermissions[t];
                    }, e.prototype.__items = function(e, t, o, n) {
                        var r = this, i = this.options;
                        return i.items ? (i.items.data.path = e, i.items.data.source = t, i.items.data.mods = o, this.get("items").then(function(e) {
                            var t = r.o.items.process;
                            return t || (t = r.o.ajax.process), t && (e = t.call(self, e)), n(e);
                        })) : Promise.reject("Set Items api options");
                    }, e.prototype.items = function(e, t, o) {
                        var n = this;
                        return void 0 === o && (o = {}), this.__items(e, t, o, function(e) {
                            return n.generateItemsList(e.data.sources, o);
                        });
                    }, e.prototype.itemsEx = function(e, t, o) {
                        var n = this;
                        return void 0 === o && (o = {}), this.__items(e, t, o, function(e) {
                            var t;
                            return {
                                items: n.generateItemsList(e.data.sources, o),
                                loadedTotal: (t = e.data.sources, t.reduce(function(e, t) {
                                    return e + t.files.length;
                                }, 0))
                            };
                        });
                    }, e.prototype.generateItemsList = function(e, t) {
                        var o = this;
                        void 0 === t && (t = {});
                        var i = [];
                        return e.forEach(function(e) {
                            if (e.files && e.files.length) {
                                var a = o.o.sort;
                                (0, r.isFunction)(a) && t.sortBy && e.files.sort(function(e, o) {
                                    return a(e, o, t.sortBy);
                                }), e.files.forEach(function(r) {
                                    (function(e) {
                                        var n;
                                        return !(null === (n = t.filterWord) || void 0 === n ? void 0 : n.length) || void 0 === o.o.filter || o.o.filter(e, t.filterWord);
                                    })(r) && function(e) {
                                        return "folder" === e.type || !t.onlyImages || void 0 === e.isImage || e.isImage;
                                    }(r) && i.push(s.FileBrowserItem.create(n.__assign(n.__assign({}, r), {
                                        sourceName: e.name,
                                        source: e
                                    })));
                                });
                            }
                        }), i;
                    }, e.prototype.tree = function(e, t) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            var o = this;
                            return n.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return e = (0, r.normalizeRelativePath)(e), this.o.folder ? [
                                            4,
                                            this.permissions(e, t)
                                        ] : [
                                            2,
                                            Promise.reject("Set Folder Api options")
                                        ];
                                    case 1:
                                        return n.sent(), this.o.folder.data.path = e, this.o.folder.data.source = t, [
                                            2,
                                            this.get("folder").then(function(e) {
                                                var t = o.o.folder.process;
                                                return t || (t = o.o.ajax.process), t && (e = t.call(self, e)), e.data.sources;
                                            })
                                        ];
                                }
                            });
                        });
                    }, e.prototype.getPathByUrl = function(e) {
                        var t = this;
                        return (0, r.set)("options.getLocalFileByUrl.data.url", e, this), this.get("getLocalFileByUrl").then(function(e) {
                            if (t.isSuccess(e)) return e.data;
                            throw (0, r.error)(t.getMessage(e));
                        });
                    }, e.prototype.createFolder = function(e, t, o) {
                        var n = this, i = this.o.create;
                        if (!i) throw (0, r.error)("Set Create api options");
                        return i.data.source = o, i.data.path = t, i.data.name = e, this.get("create").then(function(e) {
                            if (n.isSuccess(e)) return !0;
                            throw (0, r.error)(n.getMessage(e));
                        });
                    }, e.prototype.move = function(e, t, o, n) {
                        var i = this, a = n ? "fileMove" : "folderMove", s = this.options[a];
                        if (!s) throw (0, r.error)("Set Move api options");
                        return s.data.from = e, s.data.path = t, s.data.source = o, this.get(a).then(function(e) {
                            if (i.isSuccess(e)) return !0;
                            throw (0, r.error)(i.getMessage(e));
                        });
                    }, e.prototype.remove = function(e, t, o, n) {
                        var i = this, a = this.o[e];
                        if (!a) throw (0, r.error)('Set "'.concat(e, '" api options'));
                        return a.data.path = t, a.data.name = o, a.data.source = n, this.get(e).then(function(e) {
                            return a.process && (e = a.process.call(i, e)), i.getMessage(e);
                        });
                    }, e.prototype.fileRemove = function(e, t, o) {
                        return this.remove("fileRemove", e, t, o);
                    }, e.prototype.folderRemove = function(e, t, o) {
                        return this.remove("folderRemove", e, t, o);
                    }, e.prototype.rename = function(e, t, o, n, i) {
                        var a = this, s = this.o[e];
                        if (!s) throw (0, r.error)('Set "'.concat(e, '" api options'));
                        return s.data.path = t, s.data.name = o, s.data.newname = n, s.data.source = i, this.get(e).then(function(e) {
                            return s.process && (e = s.process.call(self, e)), a.getMessage(e);
                        });
                    }, e.prototype.folderRename = function(e, t, o, n) {
                        return this.rename("folderRename", e, t, o, n);
                    }, e.prototype.fileRename = function(e, t, o, n) {
                        return this.rename("fileRename", e, t, o, n);
                    }, e.prototype.changeImage = function(e, t, o, n, r, i) {
                        this.o[e] || (this.o[e] = {
                            data: {}
                        });
                        var a = this.o[e];
                        return void 0 === a.data && (a.data = {
                            action: e
                        }), a.data.newname = r || n, i && (a.data.box = i), a.data.path = t, a.data.name = n, a.data.source = o, this.get(e).then(function() {
                            return !0;
                        });
                    }, e.prototype.crop = function(e, t, o, n, r) {
                        return this.changeImage("crop", e, t, o, n, r);
                    }, e.prototype.resize = function(e, t, o, n, r) {
                        return this.changeImage("resize", e, t, o, n, r);
                    }, e.prototype.getMessage = function(e) {
                        return this.options.getMessage(e);
                    }, e.prototype.isSuccess = function(e) {
                        return this.options.isSuccess(e);
                    }, e.prototype.destruct = function() {
                        this.ajaxInstances.forEach(function(e) {
                            return e.destruct();
                        }), this.ajaxInstances.clear();
                    }, n.__decorate([
                        a.autobind
                    ], e);
                }();
                t.default = l;
            },
            46341: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.makeContextMenu = t.makeDataProvider = void 0;
                var n = o(82530), r = o(60403);
                t.makeDataProvider = function(e, t) {
                    return new n.default(e, t);
                }, t.makeContextMenu = function(e) {
                    return new r.ContextMenu(e);
                };
            },
            48096: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.deleteFile = void 0, t.deleteFile = function(e, t, o) {
                    return e.dataProvider.fileRemove(e.state.currentPath, t, o).then(function(o) {
                        e.status(o || e.i18n('File "%s" was deleted', t), !0);
                    }).catch(e.status);
                };
            },
            4253: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.loadItems = void 0, t.loadItems = function(e) {
                    return e.files.setMod("active", !0), e.files.setMod("loading", !0), e.dataProvider.items(e.state.currentPath, e.state.currentSource, {
                        sortBy: e.state.sortBy,
                        onlyImages: e.state.onlyImages,
                        filterWord: e.state.filterWord
                    }).then(function(t) {
                        t && (e.state.elements = t, e.state.activeElements = []);
                    }).catch(e.status).finally(function() {
                        return e.files.setMod("loading", !1);
                    });
                };
            },
            36303: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.loadTree = void 0;
                var n = o(20255), r = o(64968), i = o(4253);
                t.loadTree = function(e) {
                    return n.__awaiter(this, void 0, Promise, function() {
                        var t, o;
                        return n.__generator(this, function(n) {
                            return e.tree.setMod("active", !0), r.Dom.detach(e.tree.container), t = (0, i.loadItems)(e), e.o.showFoldersPanel ? (e.tree.setMod("loading", !0), o = e.dataProvider.tree(e.state.currentPath, e.state.currentSource).then(function(t) {
                                e.state.sources = t;
                            }).catch(e.status).finally(function() {
                                return e.tree.setMod("loading", !1);
                            }), [
                                2,
                                Promise.all([
                                    o,
                                    t
                                ])
                            ]) : (e.tree.setMod("active", !1), [
                                2,
                                t
                            ]);
                        });
                    });
                };
            },
            50885: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isFileBrowserFilesItem = t.FileBrowser = void 0;
                var n = o(20255);
                o(40692);
                var r = o(93166), i = o(86893), a = o(77462), s = o(40332), l = o(64968), c = o(46341), u = o(86774), d = o(21347), p = o(44734), f = o(82530), h = o(43441), m = o(98782), v = o(55395), g = o(36303), y = o(4253), _ = o(56562), b = o(59829), w = o(43608);
                o(38097);
                var S = function(e) {
                    function t(t) {
                        var o, n = this;
                        (n = e.call(this, t) || this).browser = n.c.div(n.componentName), n.status_line = n.c.div(n.getFullElName("status")), n.tree = new m.FileBrowserTree(n), n.files = new m.FileBrowserFiles(n), n.state = (0, v.observable)({
                            currentPath: "",
                            currentSource: f.DEFAULT_SOURCE_NAME,
                            currentBaseUrl: "",
                            activeElements: [],
                            elements: [],
                            sources: [],
                            view: "tiles",
                            sortBy: "changed-desc",
                            filterWord: "",
                            onlyImages: !1
                        }), n.errorHandler = function(e) {
                            (0, s.isAbort)(e) || (e instanceof Error ? n.status(n.i18n(e.message)) : n.status(n.dataProvider.getMessage(e)));
                        }, n.close = function() {
                            n._dialog.close();
                        }, n.attachEvents(t);
                        var i = n;
                        i.options = (0, s.ConfigProto)(t || {}, r.Config.defaultOptions.filebrowser), i.storage = a.Storage.makeStorage(Boolean(n.o.saveStateInStorage), n.componentName), i.dataProvider = (0, c.makeDataProvider)(i, i.options), i._dialog = n.dlg({
                            minWidth: Math.min(700, screen.width),
                            minHeight: 300,
                            buttons: null !== (o = n.o.headerButtons) && void 0 !== o ? o : [
                                "fullsize",
                                "dialog.close"
                            ]
                        }), n.proxyDialogEvents(i), i.browser.component = n, i.container = i.browser, i.o.showFoldersPanel && i.browser.appendChild(i.tree.container), i.browser.appendChild(i.files.container), i.browser.appendChild(i.status_line), p.selfListeners.call(i), d.nativeListeners.call(i), u.stateListeners.call(i), i._dialog.setSize(i.o.width, i.o.height), [
                            "getLocalFileByUrl",
                            "crop",
                            "resize",
                            "create",
                            "fileMove",
                            "folderMove",
                            "fileRename",
                            "folderRename",
                            "fileRemove",
                            "folderRemove",
                            "folder",
                            "items",
                            "permissions"
                        ].forEach(function(e) {
                            null != n.options[e] && (n.options[e] = (0, s.ConfigProto)(n.options[e], n.o.ajax));
                        });
                        var l = n.o.saveStateInStorage || {
                            storeLastOpenedFolder: !1,
                            storeView: !1,
                            storeSortBy: !1
                        }, h = l.storeSortBy, g = l.storeLastOpenedFolder, y = l.storeView && n.storage.get("view");
                        i.state.view = y && null == n.o.view ? "list" === y ? "list" : "tiles" : "list" === i.o.view ? "list" : "tiles", i.files.setMod("view", i.state.view);
                        var b = h && i.storage.get("sortBy");
                        if (b) {
                            var w = b.split("-");
                            i.state.sortBy = [
                                "changed",
                                "name",
                                "size"
                            ].includes(w[0]) ? b : "changed-desc";
                        } else i.state.sortBy = i.o.sortBy || "changed-desc";
                        if (g) {
                            var S = i.storage.get("currentPath"), C = i.storage.get("currentSource");
                            i.state.currentPath = null != S ? S : "", i.state.currentSource = null != C ? C : "";
                        }
                        return i.initUploader(i), i.setStatus(_.STATUSES.ready), n;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "Filebrowser";
                    }, t.prototype.onSelect = function(e) {
                        var t = this;
                        return function() {
                            if (t.state.activeElements.length) {
                                var o = [], n = [];
                                t.state.activeElements.forEach(function(e) {
                                    var t = e.fileURL;
                                    t && (o.push(t), n.push(e.isImage || !1));
                                }), t.close();
                                var r = {
                                    baseurl: "",
                                    files: o,
                                    isImages: n
                                };
                                (0, s.isFunction)(e) && e(r), t.close();
                            }
                            return !1;
                        };
                    }, Object.defineProperty(t.prototype, "isOpened", {
                        get: function() {
                            return this._dialog.isOpened && "none" !== this.browser.style.display;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.status = function(e, t) {
                        e && !(0, s.isAbort)(e) && ((0, s.isString)(e) || (e = e.message), (0, s.isString)(e) && (0, s.trim)(e).length && this.message.message(e, t ? "success" : "error", this.o.howLongShowMsg));
                    }, t.prototype.open = function(e, t) {
                        var o = this;
                        return void 0 === e && (e = this.o.defaultCallback), void 0 === t && (t = !1), this.state.onlyImages = t, this.async.promise(function(t, n) {
                            if (!o.o.items || !o.o.items.url) throw (0, s.error)("Need set options.filebrowser.ajax.url");
                            var r = 0;
                            o.e.off(o.files.container, "dblclick").on(o.files.container, "dblclick", o.onSelect(e)).on(o.files.container, "touchstart", function() {
                                var t = (new Date).getTime();
                                i.EMULATE_DBLCLICK_TIMEOUT > t - r && o.onSelect(e)(), r = t;
                            }).off("select.filebrowser").on("select.filebrowser", o.onSelect(e));
                            var a = o.c.div();
                            o.toolbar.build(o.__getButtons()).appendTo(a), o._dialog.open(o.browser, a), o.e.fire("sort.filebrowser", o.state.sortBy), (0, g.loadTree)(o).then(t, n);
                        });
                    }, t.prototype.__getButtons = function() {
                        var e, t = this;
                        return (null !== (e = this.o.buttons) && void 0 !== e ? e : []).filter(function(e) {
                            if (!(0, s.isString)(e)) return !0;
                            switch(e){
                                case "filebrowser.upload":
                                    return t.dataProvider.canI("FileUpload");
                                case "filebrowser.edit":
                                    return t.dataProvider.canI("ImageResize") || t.dataProvider.canI("ImageCrop");
                                case "filebrowser.remove":
                                    return t.dataProvider.canI("FileRemove");
                            }
                            return !0;
                        });
                    }, t.prototype.initUploader = function(e) {
                        var t, o = this, n = this, i = null === (t = null == e ? void 0 : e.options) || void 0 === t ? void 0 : t.uploader, a = (0, s.ConfigProto)(i || {}, r.Config.defaultOptions.uploader), l = function() {
                            return (0, y.loadItems)(o);
                        };
                        n.uploader = n.getInstance("Uploader", a), n.uploader.setPath(n.state.currentPath).setSource(n.state.currentSource).bind(n.browser, l, n.errorHandler), this.state.on([
                            "change.currentPath",
                            "change.currentSource"
                        ], function() {
                            o.uploader.setPath(o.state.currentPath).setSource(o.state.currentSource);
                        }), n.e.on("bindUploader.filebrowser", function(e) {
                            n.uploader.bind(e, l, n.errorHandler);
                        });
                    }, t.prototype.proxyDialogEvents = function(e) {
                        var t = this;
                        [
                            "afterClose",
                            "beforeOpen"
                        ].forEach(function(o) {
                            e._dialog.events.on(e.dlg, o, function() {
                                t.e.fire(o);
                            });
                        });
                    }, t.prototype.destruct = function() {
                        this.isInDestruct || (e.prototype.destruct.call(this), this._dialog.destruct(), this.events && this.e.off(".filebrowser"), this.uploader && this.uploader.destruct());
                    }, n.__decorate([
                        h.autobind
                    ], t.prototype, "status", null), n.__decorate([
                        h.autobind
                    ], t.prototype, "open", null), n.__decorate([
                        (0, h.derive)(b.Dlgs)
                    ], t);
                }(w.ViewWithToolbar);
                t.FileBrowser = S, t.isFileBrowserFilesItem = function(e) {
                    return l.Dom.isElement(e) && e.classList.contains(m.FileBrowserFiles.prototype.getFullElName("item"));
                };
            },
            63463: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(50885), t);
            },
            21347: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.nativeListeners = t.elementToItem = t.getItem = void 0;
                var n = o(20255), r = o(40332), i = o(34468), a = o(64968), s = o(66267), l = o(36303);
                t.getItem = function(e, t, o) {
                    return void 0 === o && (o = "a"), a.Dom.closest(e, function(e) {
                        return a.Dom.isTag(e, o);
                    }, t);
                }, t.elementToItem = function(e, t) {
                    return t[e.dataset.key || ""].item;
                }, t.nativeListeners = function() {
                    var e = this, o = !1, a = (0, s.elementsMap)(this), c = this;
                    c.e.on(c.tree.container, "dragstart", function(e) {
                        var n = (0, t.getItem)(e.target, c.container);
                        n && c.o.moveFolder && (o = n);
                    }).on(c.tree.container, "drop", function(n) {
                        if ((c.o.moveFile || c.o.moveFolder) && o) {
                            var i = (0, r.attr)(o, "-path") || "";
                            if (!c.o.moveFolder && o.classList.contains(e.tree.getFullElName("item"))) return !1;
                            if (o.classList.contains(e.files.getFullElName("item")) && (i += (0, r.attr)(o, "-name"), !c.o.moveFile)) return !1;
                            var a = (0, t.getItem)(n.target, c.container);
                            if (!a) return;
                            c.dataProvider.move(i, (0, r.attr)(a, "-path") || "", (0, r.attr)(a, "-source") || "", o.classList.contains(e.files.getFullElName("item"))).then(function() {
                                return (0, l.loadTree)(e);
                            }).catch(c.status), o = !1;
                        }
                    }).on(c.files.container, "contextmenu", (0, i.default)(c)).on(c.files.container, "click", function(t) {
                        (0, r.ctrlKey)(t) || (e.state.activeElements = []);
                    }).on(c.files.container, "click", function(e) {
                        var o = (0, t.getItem)(e.target, c.container);
                        if (o) {
                            var i = (0, t.elementToItem)(o, a);
                            if (i) return c.state.activeElements = (0, r.ctrlKey)(e) ? n.__spreadArray(n.__spreadArray([], n.__read(c.state.activeElements), !1), [
                                i
                            ], !1) : [
                                i
                            ], e.stopPropagation(), !1;
                        }
                    }).on(c.files.container, "dragstart", function(e) {
                        if (c.o.moveFile) {
                            var n = (0, t.getItem)(e.target, c.container);
                            if (!n) return;
                            o = n;
                        }
                    }).on(c.container, "drop", function(e) {
                        return e.preventDefault();
                    });
                };
            },
            44734: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.selfListeners = void 0;
                var n = o(20255), r = o(10172), i = o(40332), a = o(82530), s = o(35503), l = o(36303), c = o(4253), u = o(48096);
                t.selfListeners = function() {
                    var e = this, t = this.state, o = this.dataProvider, d = this;
                    d.e.on("view.filebrowser", function(e) {
                        e !== t.view && (t.view = e);
                    }).on("sort.filebrowser", function(e) {
                        e !== t.sortBy && (t.sortBy = e, (0, c.loadItems)(d));
                    }).on("filter.filebrowser", function(e) {
                        e !== t.filterWord && (t.filterWord = e, (0, c.loadItems)(d));
                    }).on("openFolder.filebrowser", function(e) {
                        var t;
                        t = ".." === e.name ? e.path.split("/").filter(function(e) {
                            return e.length;
                        }).slice(0, -1).join("/") : (0, i.normalizePath)(e.path, e.name), d.state.currentPath = t, d.state.currentSource = "." === e.name ? a.DEFAULT_SOURCE_NAME : e.source;
                    }).on("removeFolder.filebrowser", function(e) {
                        d.confirm("Are you sure?", "Delete", function(t) {
                            t && o.folderRemove(e.path, e.name, e.source).then(function(e) {
                                return d.status(e, !0), (0, l.loadTree)(d);
                            }).catch(d.status);
                        });
                    }).on("renameFolder.filebrowser", function(e) {
                        d.prompt("Enter new name", "Rename", function(t) {
                            if (!(0, r.isValidName)(t)) return d.status(d.i18n("Enter new name")), !1;
                            o.folderRename(e.path, e.name, t, e.source).then(function(e) {
                                return d.state.activeElements = [], d.status(e, !0), (0, l.loadTree)(d);
                            }).catch(d.status);
                        }, "type name", e.name);
                    }).on("addFolder.filebrowser", function(e) {
                        d.prompt("Enter Directory name", "Create directory", function(t) {
                            o.createFolder(t, e.path, e.source).then(function() {
                                return (0, l.loadTree)(d);
                            }).catch(d.status);
                        }, "type name");
                    }).on("fileRemove.filebrowser", function() {
                        d.state.activeElements.length && d.confirm("Are you sure?", "", function(e) {
                            if (e) {
                                var t = [];
                                d.state.activeElements.forEach(function(e) {
                                    t.push((0, u.deleteFile)(d, e.file || e.name || "", e.sourceName));
                                }), d.state.activeElements = [], Promise.all(t).then(function() {
                                    return (0, l.loadTree)(d).catch(d.status);
                                }, d.status);
                            }
                        });
                    }).on("edit.filebrowser", function() {
                        if (1 === d.state.activeElements.length) {
                            var t = n.__read(e.state.activeElements, 1)[0];
                            s.openImageEditor.call(d, t.fileURL, t.file || "", t.path, t.sourceName);
                        }
                    }).on("fileRename.filebrowser", function(e, t, n) {
                        1 === d.state.activeElements.length && d.prompt("Enter new name", "Rename", function(i) {
                            if (!(0, r.isValidName)(i)) return d.status(d.i18n("Enter new name")), !1;
                            o.fileRename(t, e, i, n).then(function(e) {
                                d.state.activeElements = [], d.status(e, !0), (0, c.loadItems)(d);
                            }).catch(d.status);
                        }, "type name", e);
                    }).on("update.filebrowser", function() {
                        (0, l.loadTree)(e).then(e.status, e.status);
                    });
                };
            },
            86774: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.stateListeners = void 0;
                var n = o(64968), r = o(89693), i = o(2074), a = o(66267), s = o(36303);
                t.stateListeners = function() {
                    var e = this, t = (0, a.elementsMap)(this), o = this, l = o.state, c = o.files, u = o.create, d = o.options;
                    l.on([
                        "change.currentPath",
                        "change.currentSource"
                    ], this.async.debounce(function() {
                        e.o.saveStateInStorage && e.o.saveStateInStorage.storeLastOpenedFolder && e.storage.set("currentPath", e.state.currentPath).set("currentSource", e.state.currentSource), (0, s.loadTree)(e).catch(e.status);
                    }, this.defaultTimeout)).on("beforeChange.activeElements", function() {
                        l.activeElements.forEach(function(e) {
                            var o = t[e.uniqueHashKey].elm;
                            o && o.classList.remove(c.getFullElName("item", "active", !0));
                        });
                    }).on("change.activeElements", function() {
                        e.e.fire("changeSelection"), l.activeElements.forEach(function(e) {
                            var o = t[e.uniqueHashKey].elm;
                            o && o.classList.add(c.getFullElName("item", "active", !0));
                        });
                    }).on("change.view", function() {
                        c.setMod("view", l.view), e.o.saveStateInStorage && e.o.saveStateInStorage.storeView && e.storage.set("view", l.view);
                    }).on("change.sortBy", function() {
                        e.o.saveStateInStorage && e.o.saveStateInStorage.storeSortBy && e.storage.set("sortBy", l.sortBy);
                    }).on("change.elements", this.async.debounce(function() {
                        n.Dom.detach(c.container), l.elements.length ? l.elements.forEach(function(o) {
                            e.files.container.appendChild(function(o) {
                                var n = o.uniqueHashKey;
                                if (t[n]) return t[n].elm;
                                var r = u.fromHTML(d.getThumbTemplate.call(e, o, o.source, o.sourceName.toString()));
                                return r.dataset.key = n, t[n] = {
                                    item: o,
                                    elm: r
                                }, t[n].elm;
                            }(o));
                        }) : c.container.appendChild(u.div(e.componentName + "_no-files_true", e.i18n("There are no files")));
                    }, this.defaultTimeout)).on("change.sources", this.async.debounce(function() {
                        n.Dom.detach(e.tree.container), l.sources.forEach(function(t) {
                            var o = t.name;
                            if (o && "default" !== o && e.tree.container.appendChild(u.div(e.tree.getFullElName("source-title"), o)), t.folders.forEach(function(n) {
                                var a, s = u.a(e.tree.getFullElName("item"), {
                                    draggable: "draggable",
                                    href: "#",
                                    "data-path": (0, r.normalizePath)(t.path, n + "/"),
                                    "data-name": n,
                                    "data-source": o,
                                    "data-source-path": t.path
                                }, u.span(e.tree.getFullElName("item-title"), n)), l = function(i) {
                                    return function(a) {
                                        e.e.fire("".concat(i, ".filebrowser"), {
                                            name: n,
                                            path: (0, r.normalizePath)(t.path + "/"),
                                            source: o
                                        }), a.stopPropagation(), a.preventDefault();
                                    };
                                };
                                e.e.on(s, "click", l("openFolder")), e.tree.container.appendChild(s), ".." !== n && "." !== n && (d.renameFolder && e.dataProvider.canI("FolderRename") && ((a = (0, i.Button)(e, {
                                    icon: {
                                        name: "pencil"
                                    },
                                    name: "rename",
                                    tooltip: "Rename",
                                    size: "tiny"
                                })).onAction(l("renameFolder")), s.appendChild(a.container)), d.deleteFolder && e.dataProvider.canI("FolderRemove") && ((a = (0, i.Button)(e, {
                                    icon: {
                                        name: "cancel"
                                    },
                                    name: "remove",
                                    tooltip: "Delete",
                                    size: "tiny"
                                })).onAction(l("removeFolder")), s.appendChild(a.container)));
                            }), d.createNewFolder && e.dataProvider.canI("FolderCreate")) {
                                var n = (0, i.Button)(e, "plus", "Add folder", "secondary");
                                n.onAction(function() {
                                    e.e.fire("addFolder", {
                                        path: (0, r.normalizePath)(t.path + "/"),
                                        source: o
                                    });
                                }), e.tree.append(n);
                            }
                        });
                    }, this.defaultTimeout));
                };
            },
            21505: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FileBrowserFiles = void 0;
                var n = o(20255);
                o(27452);
                var r = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "FilebrowserFiles";
                    }, t;
                }(o(2074).UIGroup);
                t.FileBrowserFiles = r;
            },
            98782: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(21505), t), n.__exportStar(o(42472), t);
            },
            42472: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FileBrowserTree = void 0;
                var n = o(20255);
                o(51422);
                var r = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "FilebrowserTree";
                    }, t;
                }(o(2074).UIGroup);
                t.FileBrowserTree = r;
            },
            3107: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Command = void 0;
                var o = function() {
                    function e(e, t, o, n) {
                        this.oldValue = e, this.newValue = t, this.history = o, this.tick = n;
                    }
                    return e.prototype.undo = function() {
                        this.history.snapshot.restore(this.oldValue);
                    }, e.prototype.redo = function() {
                        this.history.snapshot.restore(this.newValue);
                    }, e;
                }();
                t.Command = o;
            },
            15432: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.History = void 0;
                var n = o(20255), r = o(93166), i = o(56562), a = o(31648), s = o(3621), l = o(3107), c = o(43441);
                r.Config.prototype.history = {
                    enable: !0,
                    maxHistoryLength: 1 / 0,
                    timeout: 1e3
                }, r.Config.prototype.observer = r.Config.prototype.history;
                var u = function(e) {
                    function t(t, o, n) {
                        void 0 === o && (o = new s.Stack(t.o.history.maxHistoryLength)), void 0 === n && (n = new a.Snapshot(t));
                        var r = e.call(this, t) || this;
                        return r.updateTick = 0, r.__stack = o, r.snapshot = n, t.o.history.enable && t.e.on("afterAddPlace.history", function() {
                            r.isInDestruct || (r.startValue = r.snapshot.make(), t.events.on("internalChange internalUpdate", function() {
                                r.startValue = r.snapshot.make();
                            }).on(t.editor, [
                                "changeSelection",
                                "selectionstart",
                                "selectionchange",
                                "mousedown",
                                "mouseup",
                                "keydown",
                                "keyup"
                            ].map(function(e) {
                                return e + ".history";
                            }).join(" "), function() {
                                r.startValue.html === r.j.getNativeEditorValue() && (r.startValue = r.snapshot.make());
                            }).on(r, "change.history", r.onChange));
                        }), r;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "History";
                    }, Object.defineProperty(t.prototype, "startValue", {
                        get: function() {
                            return this.__startValue;
                        },
                        set: function(e) {
                            this.__startValue = e;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.__upTick = function() {
                        this.updateTick += 1;
                    }, t.prototype.onChange = function() {
                        this.__processChanges();
                    }, t.prototype.__processChanges = function() {
                        !this.snapshot.isBlocked && this.j.o.history.enable && this.updateStack();
                    }, t.prototype.updateStack = function(e) {
                        void 0 === e && (e = !1);
                        var t = this.snapshot.make();
                        if (!a.Snapshot.equal(t, this.startValue)) {
                            var o = new l.Command(this.startValue, t, this, this.updateTick);
                            if (e) {
                                var n = this.__stack.current();
                                n && this.updateTick === n.tick && this.__stack.replace(o);
                            } else this.__stack.push(o);
                            this.startValue = t, this.fireChangeStack();
                        }
                    }, t.prototype.redo = function() {
                        this.__stack.redo() && (this.startValue = this.snapshot.make(), this.fireChangeStack());
                    }, t.prototype.canRedo = function() {
                        return this.__stack.canRedo();
                    }, t.prototype.undo = function() {
                        this.__stack.undo() && (this.startValue = this.snapshot.make(), this.fireChangeStack());
                    }, t.prototype.canUndo = function() {
                        return this.__stack.canUndo();
                    }, t.prototype.clear = function() {
                        this.startValue = this.snapshot.make(), this.__stack.clear(), this.fireChangeStack();
                    }, Object.defineProperty(t.prototype, "length", {
                        get: function() {
                            return this.__stack.length;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.fireChangeStack = function() {
                        var e;
                        this.j && !this.j.isInDestruct && (null === (e = this.j.events) || void 0 === e || e.fire("changeStack"));
                    }, t.prototype.destruct = function() {
                        this.isInDestruct || (this.j.events && this.j.e.off(".history"), this.snapshot.destruct(), e.prototype.destruct.call(this));
                    }, n.__decorate([
                        (0, c.debounce)()
                    ], t.prototype, "onChange", null), t;
                }(i.ViewComponent);
                t.History = u;
            },
            31648: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Snapshot = void 0;
                var n = o(20255), r = o(56562), i = o(64968), a = o(86893), s = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.__isBlocked = !1, t;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "Snapshot";
                    }, t.equal = function(e, t) {
                        return e.html === t.html && JSON.stringify(e.range) === JSON.stringify(t.range);
                    }, t.countNodesBeforeInParent = function(e) {
                        if (!e.parentNode) return 0;
                        for(var t = e.parentNode.childNodes, o = 0, n = null, r = 0; t.length > r; r += 1){
                            if (!n || this.isIgnoredNode(t[r]) || i.Dom.isText(n) && i.Dom.isText(t[r]) || (o += 1), t[r] === e) return o;
                            n = t[r];
                        }
                        return 0;
                    }, t.strokeOffset = function(e, t) {
                        for(; i.Dom.isText(e);)i.Dom.isText(e = e.previousSibling) && e.nodeValue && (t += e.nodeValue.length);
                        return t;
                    }, t.prototype.calcHierarchyLadder = function(e) {
                        var o = [];
                        if (!e || !e.parentNode || !i.Dom.isOrContains(this.j.editor, e)) return [];
                        for(; e && e !== this.j.editor;)e && !t.isIgnoredNode(e) && o.push(t.countNodesBeforeInParent(e)), e = e.parentNode;
                        return o.reverse();
                    }, t.prototype.getElementByLadder = function(e) {
                        var t, o = this.j.editor;
                        for(t = 0; o && e.length > t; t += 1)o = o.childNodes[e[t]];
                        return o;
                    }, Object.defineProperty(t.prototype, "isBlocked", {
                        get: function() {
                            return this.__isBlocked;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.__block = function(e) {
                        this.__isBlocked = e;
                    }, t.prototype.transaction = function(e) {
                        this.__block(!0);
                        try {
                            e();
                        } catch (e) {}
                        this.__block(!1);
                    }, t.prototype.make = function() {
                        var e = {
                            html: "",
                            range: {
                                startContainer: [],
                                startOffset: 0,
                                endContainer: [],
                                endOffset: 0
                            }
                        };
                        e.html = this.removeJoditSelection(this.j.editor);
                        var o = this.j.s.sel;
                        if (o && o.rangeCount) {
                            var n = o.getRangeAt(0), r = this.calcHierarchyLadder(n.startContainer), i = this.calcHierarchyLadder(n.endContainer), a = t.strokeOffset(n.startContainer, n.startOffset), s = t.strokeOffset(n.endContainer, n.endOffset);
                            r.length || n.startContainer === this.j.editor || (a = 0), i.length || n.endContainer === this.j.editor || (s = 0), e.range = {
                                startContainer: r,
                                startOffset: a,
                                endContainer: i,
                                endOffset: s
                            };
                        }
                        return e;
                    }, t.prototype.restore = function(e) {
                        var t = this;
                        this.transaction(function() {
                            var o = t.storeScrollState();
                            t.j.getNativeEditorValue() !== e.html && (t.j.value = e.html), t.restoreOnlySelection(e), t.restoreScrollState(o);
                        });
                    }, t.prototype.storeScrollState = function() {
                        return [
                            this.j.ow.scrollY,
                            this.j.editor.scrollTop
                        ];
                    }, t.prototype.restoreScrollState = function(e) {
                        var t = this.j, o = t.ow;
                        o.scrollTo(o.scrollX, e[0]), t.editor.scrollTop = e[1];
                    }, t.prototype.restoreOnlySelection = function(e) {
                        try {
                            if (e.range) {
                                var t = this.j.ed.createRange();
                                t.setStart(this.getElementByLadder(e.range.startContainer), e.range.startOffset), t.setEnd(this.getElementByLadder(e.range.endContainer), e.range.endOffset), this.j.s.selectRange(t);
                            }
                        } catch (e) {
                            this.j.editor.lastChild && this.j.s.setCursorAfter(this.j.editor.lastChild);
                        }
                    }, t.prototype.destruct = function() {
                        this.__block(!1), e.prototype.destruct.call(this);
                    }, t.isIgnoredNode = function(e) {
                        return i.Dom.isText(e) && !e.nodeValue || i.Dom.isTemporary(e);
                    }, t.prototype.removeJoditSelection = function(e) {
                        var t = e.cloneNode(!0);
                        return t.querySelectorAll("[".concat(a.TEMP_ATTR, "]")).forEach(i.Dom.unwrap), t.innerHTML;
                    }, t;
                }(r.ViewComponent);
                t.Snapshot = s;
            },
            3621: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Stack = void 0;
                var o = function() {
                    function e(e) {
                        this.size = e, this.commands = [], this.stackPosition = -1;
                    }
                    return Object.defineProperty(e.prototype, "length", {
                        get: function() {
                            return this.commands.length;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.clearRedo = function() {
                        this.commands.length = this.stackPosition + 1;
                    }, e.prototype.clear = function() {
                        this.commands.length = 0, this.stackPosition = -1;
                    }, e.prototype.push = function(e) {
                        this.clearRedo(), this.commands.push(e), this.stackPosition += 1, this.commands.length > this.size && (this.commands.shift(), this.stackPosition -= 1);
                    }, e.prototype.replace = function(e) {
                        this.commands[this.stackPosition] = e;
                    }, e.prototype.current = function() {
                        return this.commands[this.stackPosition];
                    }, e.prototype.undo = function() {
                        return !!this.canUndo() && (this.commands[this.stackPosition] && this.commands[this.stackPosition].undo(), this.stackPosition -= 1, !0);
                    }, e.prototype.redo = function() {
                        return !!this.canRedo() && (this.stackPosition += 1, this.commands[this.stackPosition] && this.commands[this.stackPosition].redo(), !0);
                    }, e.prototype.canUndo = function() {
                        return this.stackPosition >= 0;
                    }, e.prototype.canRedo = function() {
                        return this.commands.length - 1 > this.stackPosition;
                    }, e;
                }();
                t.Stack = o;
            },
            95356: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(77904);
                n.Config.prototype.imageeditor = {
                    min_width: 20,
                    min_height: 20,
                    closeAfterSave: !1,
                    width: "85%",
                    height: "85%",
                    crop: !0,
                    resize: !0,
                    resizeUseRatio: !0,
                    resizeMinWidth: 20,
                    resizeMinHeight: 20,
                    cropUseRatio: !0,
                    cropDefaultWidth: "70%",
                    cropDefaultHeight: "70%"
                }, r.Icon.set("crop", o(3610)).set("resize", o(56170));
            },
            35503: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.openImageEditor = t.ImageEditor = void 0;
                var n = o(20255);
                o(62820);
                var r = o(93166), i = o(56562), a = o(40332), s = o(64968), l = o(96516), c = o(9249), u = o(43441);
                o(95356);
                var d = "jodit-image-editor", p = "resize", f = "crop", h = function(e) {
                    function t(t) {
                        var n = e.call(this, t) || this;
                        n.resizeUseRatio = !0, n.cropUseRatio = !0, n.clicked = !1, n.start_x = 0, n.start_y = 0, n.top_x = 0, n.top_y = 0, n.width = 0, n.height = 0, n.activeTab = p, n.naturalWidth = 0, n.naturalHeight = 0, n.ratio = 0, n.new_h = 0, n.new_w = 0, n.diff_x = 0, n.diff_y = 0, n.cropBox = {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0
                        }, n.resizeBox = {
                            w: 0,
                            h: 0
                        }, n.calcCropBox = function() {
                            var e = n.crop_box.parentNode, t = .8 * e.offsetWidth, o = .8 * e.offsetHeight, r = t, i = o, s = n.naturalWidth, l = n.naturalHeight;
                            t > s && o > l ? (r = s, i = l) : n.ratio > t / o ? (r = t, i = l * (t / s)) : (r = s * (o / l), i = o), (0, a.css)(n.crop_box, {
                                width: r,
                                height: i
                            });
                        }, n.showCrop = function() {
                            if (n.cropImage) {
                                n.calcCropBox();
                                var e = n.cropImage.offsetWidth || n.image.offsetWidth || n.image.naturalWidth;
                                n.new_w = o.calcValueByPercent(e, n.o.cropDefaultWidth);
                                var t = n.cropImage.offsetHeight || n.image.offsetHeight || n.image.naturalHeight;
                                n.new_h = n.cropUseRatio ? n.new_w / n.ratio : o.calcValueByPercent(t, n.o.cropDefaultHeight), (0, a.css)(n.cropHandler, {
                                    backgroundImage: "url(" + (0, a.attr)(n.cropImage, "src") + ")",
                                    width: n.new_w,
                                    height: n.new_h,
                                    left: e / 2 - n.new_w / 2,
                                    top: t / 2 - n.new_h / 2
                                }), n.j.e.fire(n.cropHandler, "updatesize");
                            }
                        }, n.updateCropBox = function() {
                            if (n.cropImage) {
                                var e = n.cropImage.offsetWidth / n.naturalWidth, t = n.cropImage.offsetHeight / n.naturalHeight;
                                n.cropBox.x = (0, a.css)(n.cropHandler, "left") / e, n.cropBox.y = (0, a.css)(n.cropHandler, "top") / t, n.cropBox.w = n.cropHandler.offsetWidth / e, n.cropBox.h = n.cropHandler.offsetHeight / t, n.sizes.textContent = n.cropBox.w.toFixed(0) + "x" + n.cropBox.h.toFixed(0);
                            }
                        }, n.updateResizeBox = function() {
                            n.resizeBox.w = n.image.offsetWidth || n.naturalWidth, n.resizeBox.h = n.image.offsetHeight || n.naturalHeight;
                        }, n.setHandlers = function() {
                            var e = n, t = (0, a.refs)(n.editor), o = t.widthInput, r = t.heightInput;
                            e.j.e.on([
                                e.editor.querySelector(".jodit_bottomright"),
                                e.cropHandler
                            ], "mousedown.".concat(d), n.onResizeHandleMouseDown).on(n.j.ow, "resize.".concat(d), function() {
                                n.j.e.fire(e.resizeHandler, "updatesize"), e.showCrop(), n.j.e.fire(e.cropHandler, "updatesize");
                            }), e.j.e.on((0, a.toArray)(n.editor.querySelectorAll(".".concat(d, "__slider-title"))), "click", n.onTitleModeClick).on([
                                o,
                                r
                            ], "input", n.onChangeSizeInput);
                            var i = (0, a.refs)(n.editor), s = i.keepAspectRatioResize, l = i.keepAspectRatioCrop;
                            s && s.addEventListener("change", function() {
                                n.resizeUseRatio = s.checked;
                            }), l && l.addEventListener("change", function() {
                                n.cropUseRatio = l.checked;
                            }), e.j.e.on(e.resizeHandler, "updatesize", function() {
                                (0, a.css)(e.resizeHandler, {
                                    top: 0,
                                    left: 0,
                                    width: e.image.offsetWidth || e.naturalWidth,
                                    height: e.image.offsetHeight || e.naturalHeight
                                }), n.updateResizeBox();
                            }).on(e.cropHandler, "updatesize", function() {
                                if (e.cropImage) {
                                    var t = (0, a.css)(e.cropHandler, "left"), o = (0, a.css)(e.cropHandler, "top"), n = e.cropHandler.offsetWidth, r = e.cropHandler.offsetHeight;
                                    0 > t && (t = 0), 0 > o && (o = 0), t + n > e.cropImage.offsetWidth && (n = e.cropImage.offsetWidth - t, e.cropUseRatio && (r = n / e.ratio)), o + r > e.cropImage.offsetHeight && (r = e.cropImage.offsetHeight - o, e.cropUseRatio && (n = r * e.ratio)), (0, a.css)(e.cropHandler, {
                                        width: n,
                                        height: r,
                                        left: t,
                                        top: o,
                                        backgroundPosition: -t - 1 + "px " + (-o - 1) + "px",
                                        backgroundSize: e.cropImage.offsetWidth + "px " + e.cropImage.offsetHeight + "px"
                                    }), e.updateCropBox();
                                }
                            }), Object.values(e.buttons).forEach(function(t) {
                                t.onAction(function() {
                                    var n = {
                                        action: e.activeTab,
                                        box: e.activeTab === p ? e.resizeBox : e.cropBox
                                    };
                                    switch(t){
                                        case e.buttons.saveas:
                                            e.j.prompt("Enter new name", "Save in new file", function(t) {
                                                if (!(0, a.trim)(t)) return e.j.alert("The name should not be empty"), !1;
                                                e.onSave(t, n, e.hide, function(t) {
                                                    e.j.alert(t.message);
                                                });
                                            });
                                            break;
                                        case e.buttons.save:
                                            e.onSave(void 0, n, e.hide, function(t) {
                                                e.j.alert(t.message);
                                            });
                                            break;
                                        case e.buttons.reset:
                                            e.activeTab === p ? ((0, a.css)(e.image, {
                                                width: null,
                                                height: null
                                            }), o.value = e.naturalWidth.toString(), r.value = e.naturalHeight.toString(), e.j.e.fire(e.resizeHandler, "updatesize")) : e.showCrop();
                                    }
                                });
                            });
                        }, n.options = t && t.o && t.o.imageeditor ? t.o.imageeditor : r.Config.defaultOptions.imageeditor;
                        var i = n.options;
                        n.resizeUseRatio = i.resizeUseRatio, n.cropUseRatio = i.cropUseRatio, n.buttons = {
                            reset: (0, l.Button)(n.j, "update", "Reset"),
                            save: (0, l.Button)(n.j, "save", "Save"),
                            saveas: (0, l.Button)(n.j, "save", "Save as ...")
                        }, n.activeTab = i.resize ? p : f, n.editor = (0, c.form)(n.j, n.options);
                        var s = (0, a.refs)(n.editor), u = s.cropBox;
                        return n.resize_box = s.resizeBox, n.crop_box = u, n.sizes = n.editor.querySelector(".".concat(d, "__area.").concat(d, "__area_crop .jodit-image-editor__sizes")), n.resizeHandler = n.editor.querySelector(".".concat(d, "__resizer")), n.cropHandler = n.editor.querySelector(".".concat(d, "__croper")), n._dialog = n.j.dlg({
                            buttons: [
                                "fullsize",
                                "dialog.close"
                            ]
                        }), n._dialog.setContent(n.editor), n._dialog.setSize(n.o.width, n.o.height), n._dialog.setHeader([
                            n.buttons.reset,
                            n.buttons.save,
                            n.buttons.saveas
                        ]), n.setHandlers(), n;
                    }
                    var o;
                    return n.__extends(t, e), o = t, t.prototype.className = function() {
                        return "ImageEditor";
                    }, t.prototype.onTitleModeClick = function(e) {
                        var t = this, o = e.target, n = null == o ? void 0 : o.parentElement;
                        if (n) {
                            (0, a.$$)(".".concat(d, "__slider,.").concat(d, "__area"), t.editor).forEach(function(e) {
                                return e.classList.remove("".concat(d, "_active"));
                            }), n.classList.add("".concat(d, "_active")), this.activeTab = (0, a.attr)(n, "-area") || p;
                            var r = t.editor.querySelector(".".concat(d, "__area.").concat(d, "__area_") + t.activeTab);
                            r && r.classList.add("".concat(d, "_active")), t.activeTab === f && t.showCrop();
                        }
                    }, t.prototype.onChangeSizeInput = function(e) {
                        var t, o = this, n = e.target, r = (0, a.refs)(this.editor), i = r.widthInput, s = r.heightInput, l = "widthInput" === (0, a.attr)(n, "data-ref"), c = parseInt(n.value, 10), u = l ? o.o.min_height : o.o.min_width;
                        c > (l ? o.o.min_width : o.o.min_height) && ((0, a.css)(o.image, l ? "width" : "height", c), o.resizeUseRatio && (t = l ? Math.round(c / o.ratio) : Math.round(c * o.ratio)) > u && ((0, a.css)(o.image, l ? "height" : "width", t), l ? s.value = t.toString() : i.value = t.toString())), this.j.e.fire(o.resizeHandler, "updatesize");
                    }, t.prototype.onResizeHandleMouseDown = function(e) {
                        var t = this;
                        t.target = e.target, e.preventDefault(), e.stopImmediatePropagation(), t.clicked = !0, t.start_x = e.clientX, t.start_y = e.clientY, t.activeTab === f ? (t.top_x = (0, a.css)(t.cropHandler, "left"), t.top_y = (0, a.css)(t.cropHandler, "top"), t.width = t.cropHandler.offsetWidth, t.height = t.cropHandler.offsetHeight) : (t.width = t.image.offsetWidth, t.height = t.image.offsetHeight), t.j.e.on(this.j.ow, "mousemove", this.onGlobalMouseMove).one(this.j.ow, "mouseup", this.onGlobalMouseUp);
                    }, t.prototype.onGlobalMouseUp = function(e) {
                        this.clicked && (this.clicked = !1, e.stopImmediatePropagation(), this.j.e.off(this.j.ow, "mousemove", this.onGlobalMouseMove));
                    }, t.prototype.onGlobalMouseMove = function(e) {
                        var t = this;
                        if (t.clicked) {
                            var o = (0, a.refs)(this.editor), n = o.widthInput, r = o.heightInput;
                            t.diff_x = e.clientX - t.start_x, t.diff_y = e.clientY - t.start_y, t.activeTab === p && t.resizeUseRatio || t.activeTab === f && t.cropUseRatio ? t.diff_x ? (t.new_w = t.width + t.diff_x, t.new_h = Math.round(t.new_w / t.ratio)) : (t.new_h = t.height + t.diff_y, t.new_w = Math.round(t.new_h * t.ratio)) : (t.new_w = t.width + t.diff_x, t.new_h = t.height + t.diff_y), t.activeTab === p ? (t.new_w > t.o.resizeMinWidth && ((0, a.css)(t.image, "width", t.new_w + "px"), n.value = t.new_w.toString()), t.new_h > t.o.resizeMinHeight && ((0, a.css)(t.image, "height", t.new_h + "px"), r.value = t.new_h.toString()), this.j.e.fire(t.resizeHandler, "updatesize")) : (t.target !== t.cropHandler ? (t.top_x + t.new_w > t.cropImage.offsetWidth && (t.new_w = t.cropImage.offsetWidth - t.top_x), t.top_y + t.new_h > t.cropImage.offsetHeight && (t.new_h = t.cropImage.offsetHeight - t.top_y), (0, a.css)(t.cropHandler, {
                                width: t.new_w,
                                height: t.new_h
                            })) : (t.top_x + t.diff_x + t.cropHandler.offsetWidth > t.cropImage.offsetWidth && (t.diff_x = t.cropImage.offsetWidth - t.top_x - t.cropHandler.offsetWidth), (0, a.css)(t.cropHandler, "left", t.top_x + t.diff_x), t.top_y + t.diff_y + t.cropHandler.offsetHeight > t.cropImage.offsetHeight && (t.diff_y = t.cropImage.offsetHeight - t.top_y - t.cropHandler.offsetHeight), (0, a.css)(t.cropHandler, "top", t.top_y + t.diff_y)), this.j.e.fire(t.cropHandler, "updatesize"));
                        }
                    }, Object.defineProperty(t.prototype, "o", {
                        get: function() {
                            return this.options;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.hide = function() {
                        this._dialog.close();
                    }, t.prototype.open = function(e, t) {
                        var o = this;
                        return this.j.async.promise(function(n) {
                            var r = (new Date).getTime();
                            o.image = o.j.c.element("img"), (0, a.$$)("img,.jodit-icon_loader", o.resize_box).forEach(s.Dom.safeRemove), (0, a.$$)("img,.jodit-icon_loader", o.crop_box).forEach(s.Dom.safeRemove), (0, a.css)(o.cropHandler, "background", "transparent"), o.onSave = t, o.resize_box.appendChild(o.j.c.element("i", {
                                class: "jodit-icon_loader"
                            })), o.crop_box.appendChild(o.j.c.element("i", {
                                class: "jodit-icon_loader"
                            })), /\?/.test(e) ? e += "&_tst=" + r : e += "?_tst=" + r, o.image.setAttribute("src", e), o._dialog.open();
                            var i = (0, a.refs)(o.editor), l = i.widthInput, c = i.heightInput, u = function() {
                                o.isDestructed || (o.image.removeEventListener("load", u), o.naturalWidth = o.image.naturalWidth, o.naturalHeight = o.image.naturalHeight, l.value = o.naturalWidth.toString(), c.value = o.naturalHeight.toString(), o.ratio = o.naturalWidth / o.naturalHeight, o.resize_box.appendChild(o.image), o.cropImage = o.image.cloneNode(!0), o.crop_box.appendChild(o.cropImage), s.Dom.safeRemove.apply(null, (0, a.$$)(".jodit-icon_loader", o.editor)), o.activeTab === f && o.showCrop(), o.j.e.fire(o.resizeHandler, "updatesize"), o.j.e.fire(o.cropHandler, "updatesize"), o._dialog.setPosition(), o.j.e.fire("afterImageEditor"), n(o._dialog));
                            };
                            o.image.addEventListener("load", u), o.image.complete && u();
                        });
                    }, t.prototype.destruct = function() {
                        this.isDestructed || (this._dialog && !this._dialog.isInDestruct && this._dialog.destruct(), s.Dom.safeRemove(this.editor), this.j.e && this.j.e.off(this.j.ow, "mousemove", this.onGlobalMouseMove).off(this.j.ow, "mouseup", this.onGlobalMouseUp).off(this.ow, ".".concat(d)).off(".".concat(d)), e.prototype.destruct.call(this));
                    }, t.calcValueByPercent = function(e, t) {
                        var o, n = t.toString(), r = parseFloat(e.toString());
                        return (o = /^[-+]?[0-9]+(px)?$/.exec(n)) ? parseInt(n, 10) : (o = /^([-+]?[0-9.]+)%$/.exec(n)) ? Math.round(r * (parseFloat(o[1]) / 100)) : r || 0;
                    }, n.__decorate([
                        u.autobind
                    ], t.prototype, "onTitleModeClick", null), n.__decorate([
                        (0, u.debounce)(),
                        u.autobind
                    ], t.prototype, "onChangeSizeInput", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onResizeHandleMouseDown", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onGlobalMouseUp", null), n.__decorate([
                        (0, u.throttle)(10)
                    ], t.prototype, "onGlobalMouseMove", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "hide", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "open", null), o = n.__decorate([
                        u.component
                    ], t);
                }(i.ViewComponent);
                t.ImageEditor = h, t.openImageEditor = function(e, t, o, n, r, i) {
                    var s = this;
                    return this.getInstance("ImageEditor", this.o).open(e, function(e, l, c, u) {
                        return (0, a.call)("resize" === l.action ? s.dataProvider.resize : s.dataProvider.crop, o, n, t, e, l.box).then(function(e) {
                            e && (c(), r && r());
                        }).catch(function(e) {
                            u(e), i && i(e);
                        });
                    });
                };
            },
            9249: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.form = void 0;
                var n = o(2074), r = "jodit-image-editor", i = n.Icon.get.bind(n.Icon), a = function(e, t) {
                    return void 0 === t && (t = "jodti-image-editor_active"), e ? t : "";
                };
                t.form = function(e, t) {
                    var o = e.i18n.bind(e), n = function(e, t, n) {
                        return void 0 === n && (n = !0), '<div class="jodit-form__group">\n\t\t\t<label>'.concat(o(e), "</label>\n\n\t\t\t<label class='jodit-switcher'>\n\t\t\t\t<input ").concat(a(n, "checked"), ' data-ref="').concat(t, '" type="checkbox"/>\n\t\t\t\t<span class="jodit-switcher__slider"></span>\n\t\t\t</label>\n\t</div>');
                    };
                    return e.create.fromHTML('<form class="'.concat(r, ' jodit-properties">\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-3-4 jodit_col-sm-5-5">\n\t\t\t').concat(t.resize ? '<div class="'.concat(r, "__area ").concat(r, "__area_resize ").concat(r, '_active">\n\t\t\t\t\t\t\t<div data-ref="resizeBox" class="').concat(r, '__box"></div>\n\t\t\t\t\t\t\t<div class="').concat(r, '__resizer">\n\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>') : "", "\n\t\t\t").concat(t.crop ? '<div class="'.concat(r, "__area ").concat(r, "__area_crop ").concat(a(!t.resize), '">\n\t\t\t\t\t\t\t<div data-ref="cropBox" class="').concat(r, '__box">\n\t\t\t\t\t\t\t\t<div class="').concat(r, '__croper">\n\t\t\t\t\t\t\t\t\t<i class="jodit_bottomright"></i>\n\t\t\t\t\t\t\t\t\t<i class="').concat(r, '__sizes"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>') : "", '\n\t\t\t</div>\n\t\t\t<div class="jodit_col-lg-1-4 jodit_col-sm-5-5">\n\t\t\t').concat(t.resize ? '<div data-area="resize" class="'.concat(r, "__slider ").concat(r, '_active">\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-title">\n\t\t\t\t\t\t\t\t').concat(i("resize"), "\n\t\t\t\t\t\t\t\t").concat(o("Resize"), '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-content">\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t').concat(o("Width"), '\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="widthInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="jodit-form__group">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t').concat(o("Height"), '\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t<input type="number" data-ref="heightInput" class="jodit-input"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t').concat(n("Keep Aspect Ratio", "keepAspectRatioResize"), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>") : "", "\n\t\t\t").concat(t.crop ? '<div data-area="crop" class="'.concat(r, "__slider ").concat(a(!t.resize), '\'">\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-title">\n\t\t\t\t\t\t\t\t').concat(i("crop"), "\n\t\t\t\t\t\t\t\t").concat(o("Crop"), '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="').concat(r, '__slider-content">\n\t\t\t\t\t\t\t\t').concat(n("Keep Aspect Ratio", "keepAspectRatioCrop"), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>") : "", "\n\t\t\t</div>\n\t\t</div>\n\t</form>"));
                };
            },
            87837: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PluginSystem = t.UIMessages = t.Uploader = t.ToolbarCollection = t.ToolbarEditorCollection = t.Table = t.StatusBar = t.CommitStyle = t.Select = t.Snapshot = t.History = t.ImageEditor = t.Helpers = t.ViewWithToolbar = t.View = t.Icon = t.ProgressBar = t.UIBlock = t.UICheckbox = t.UITextArea = t.UIInput = t.UIForm = t.UIList = t.UIGroup = t.UISeparator = t.Popup = t.UIButton = t.UIElement = t.Create = t.Plugin = t.LazyWalker = t.Dom = t.ContextMenu = t.STATUSES = t.ViewComponent = t.Component = t.Async = void 0;
                var n = o(20255);
                n.__exportStar(o(55395), t);
                var r = o(22630);
                Object.defineProperty(t, "Async", {
                    enumerable: !0,
                    get: function() {
                        return r.Async;
                    }
                }), n.__exportStar(o(30056), t);
                var i = o(56562);
                Object.defineProperty(t, "Component", {
                    enumerable: !0,
                    get: function() {
                        return i.Component;
                    }
                }), Object.defineProperty(t, "ViewComponent", {
                    enumerable: !0,
                    get: function() {
                        return i.ViewComponent;
                    }
                }), Object.defineProperty(t, "STATUSES", {
                    enumerable: !0,
                    get: function() {
                        return i.STATUSES;
                    }
                });
                var a = o(60403);
                Object.defineProperty(t, "ContextMenu", {
                    enumerable: !0,
                    get: function() {
                        return a.ContextMenu;
                    }
                }), n.__exportStar(o(92080), t);
                var s = o(64968);
                Object.defineProperty(t, "Dom", {
                    enumerable: !0,
                    get: function() {
                        return s.Dom;
                    }
                }), Object.defineProperty(t, "LazyWalker", {
                    enumerable: !0,
                    get: function() {
                        return s.LazyWalker;
                    }
                });
                var l = o(57549);
                Object.defineProperty(t, "Plugin", {
                    enumerable: !0,
                    get: function() {
                        return l.Plugin;
                    }
                });
                var c = o(42841);
                Object.defineProperty(t, "Create", {
                    enumerable: !0,
                    get: function() {
                        return c.Create;
                    }
                });
                var u = o(2074);
                Object.defineProperty(t, "UIElement", {
                    enumerable: !0,
                    get: function() {
                        return u.UIElement;
                    }
                }), Object.defineProperty(t, "UIButton", {
                    enumerable: !0,
                    get: function() {
                        return u.UIButton;
                    }
                }), Object.defineProperty(t, "Popup", {
                    enumerable: !0,
                    get: function() {
                        return u.Popup;
                    }
                }), Object.defineProperty(t, "UISeparator", {
                    enumerable: !0,
                    get: function() {
                        return u.UISeparator;
                    }
                }), Object.defineProperty(t, "UIGroup", {
                    enumerable: !0,
                    get: function() {
                        return u.UIGroup;
                    }
                }), Object.defineProperty(t, "UIList", {
                    enumerable: !0,
                    get: function() {
                        return u.UIList;
                    }
                }), Object.defineProperty(t, "UIForm", {
                    enumerable: !0,
                    get: function() {
                        return u.UIForm;
                    }
                }), Object.defineProperty(t, "UIInput", {
                    enumerable: !0,
                    get: function() {
                        return u.UIInput;
                    }
                }), Object.defineProperty(t, "UITextArea", {
                    enumerable: !0,
                    get: function() {
                        return u.UITextArea;
                    }
                }), Object.defineProperty(t, "UICheckbox", {
                    enumerable: !0,
                    get: function() {
                        return u.UICheckbox;
                    }
                }), Object.defineProperty(t, "UIBlock", {
                    enumerable: !0,
                    get: function() {
                        return u.UIBlock;
                    }
                }), Object.defineProperty(t, "ProgressBar", {
                    enumerable: !0,
                    get: function() {
                        return u.ProgressBar;
                    }
                }), Object.defineProperty(t, "Icon", {
                    enumerable: !0,
                    get: function() {
                        return u.Icon;
                    }
                });
                var d = o(75902);
                Object.defineProperty(t, "View", {
                    enumerable: !0,
                    get: function() {
                        return d.View;
                    }
                });
                var p = o(43608);
                Object.defineProperty(t, "ViewWithToolbar", {
                    enumerable: !0,
                    get: function() {
                        return p.ViewWithToolbar;
                    }
                }), n.__exportStar(o(63463), t);
                var f = o(40332);
                t.Helpers = f;
                var h = o(35503);
                Object.defineProperty(t, "ImageEditor", {
                    enumerable: !0,
                    get: function() {
                        return h.ImageEditor;
                    }
                });
                var m = o(15432);
                Object.defineProperty(t, "History", {
                    enumerable: !0,
                    get: function() {
                        return m.History;
                    }
                });
                var v = o(31648);
                Object.defineProperty(t, "Snapshot", {
                    enumerable: !0,
                    get: function() {
                        return v.Snapshot;
                    }
                });
                var g = o(2123);
                Object.defineProperty(t, "Select", {
                    enumerable: !0,
                    get: function() {
                        return g.Select;
                    }
                }), Object.defineProperty(t, "CommitStyle", {
                    enumerable: !0,
                    get: function() {
                        return g.CommitStyle;
                    }
                });
                var y = o(38603);
                Object.defineProperty(t, "StatusBar", {
                    enumerable: !0,
                    get: function() {
                        return y.StatusBar;
                    }
                });
                var _ = o(25120);
                Object.defineProperty(t, "Table", {
                    enumerable: !0,
                    get: function() {
                        return _.Table;
                    }
                });
                var b = o(81698);
                Object.defineProperty(t, "ToolbarEditorCollection", {
                    enumerable: !0,
                    get: function() {
                        return b.ToolbarEditorCollection;
                    }
                });
                var w = o(72719);
                Object.defineProperty(t, "ToolbarCollection", {
                    enumerable: !0,
                    get: function() {
                        return w.ToolbarCollection;
                    }
                }), n.__exportStar(o(3890), t);
                var S = o(50454);
                Object.defineProperty(t, "Uploader", {
                    enumerable: !0,
                    get: function() {
                        return S.Uploader;
                    }
                });
                var C = o(71014);
                Object.defineProperty(t, "UIMessages", {
                    enumerable: !0,
                    get: function() {
                        return C.UIMessages;
                    }
                });
                var j = o(44540);
                Object.defineProperty(t, "PluginSystem", {
                    enumerable: !0,
                    get: function() {
                        return j.PluginSystem;
                    }
                });
            },
            37762: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIMessage = void 0;
                var n = o(20255), r = o(2074), i = o(11441), a = function(e) {
                    function t(t, o) {
                        var n = e.call(this, t) || this;
                        return n.setMod("active", !0), n.setMod("variant", o.variant), n.container.textContent = o.text, n;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UIMessage";
                    }, n.__decorate([
                        i.component
                    ], t);
                }(r.UIElement);
                t.UIMessage = a;
            },
            71014: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UIMessages = void 0;
                var n = o(20255);
                o(63421);
                var r = o(26911), i = o(61479), a = o(11441), s = o(46163), l = o(37762), c = function(e) {
                    function t(t, o, n) {
                        void 0 === n && (n = {
                            defaultTimeout: 3e3,
                            defaultOffset: 5
                        });
                        var r = e.call(this, t) || this;
                        return r.__box = o, r.options = n, r.__messages = new Set, r;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UIMessages";
                    }, t.prototype.info = function(e, t) {
                        this.__message(e, "info", t);
                    }, t.prototype.success = function(e, t) {
                        this.__message(e, "success", t);
                    }, t.prototype.error = function(e, t) {
                        this.__message(e, "error", t);
                    }, t.prototype.message = function(e, t, o) {
                        this.__message(e, t, o);
                    }, t.prototype.__message = function(e, t, o) {
                        void 0 === t && (t = "info");
                        var n = e + ":" + t;
                        if (this.__messages.has(n)) this.async.updateTimeout(n, o || this.options.defaultTimeout);
                        else {
                            this.__box.appendChild(this.container);
                            var r = new l.UIMessage(this.j, {
                                text: e,
                                variant: t
                            });
                            this.append(r), this.__calcOffsets(), this.__messages.add(n);
                            var i = this.__getRemoveCallback(r, n);
                            this.j.e.on(r.container, "pointerdown", i), this.async.setTimeout(i, {
                                label: n,
                                timeout: o || this.options.defaultTimeout
                            });
                        }
                    }, t.prototype.__getRemoveCallback = function(e, t) {
                        var o = this, n = function(r) {
                            r && r.preventDefault(), e.isInDestruct || (o.async.clearTimeout(t), o.j.e.off(e.container, "pointerdown", n), o.__messages.delete(t), e.setMod("active", !1), o.async.setTimeout(function() {
                                o.remove(e), e.destruct(), o.__calcOffsets();
                            }, 300));
                        };
                        return n;
                    }, t.prototype.__calcOffsets = function() {
                        var e = this, t = 5;
                        this.elements.forEach(function(o) {
                            (0, r.css)(o.container, "bottom", t + "px"), t += o.container.offsetHeight + e.options.defaultOffset;
                        });
                    }, n.__decorate([
                        (0, s.watch)(":errorMessage")
                    ], t.prototype, "__message", null), n.__decorate([
                        a.component
                    ], t);
                }(i.UIGroup);
                t.UIMessages = c;
            },
            38603: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.StatusBar = void 0;
                var n = o(20255);
                o(32115);
                var r = o(56562), i = o(64968), a = o(59829), s = o(43441), l = function(e) {
                    function t(t, o) {
                        var n = e.call(this, t) || this;
                        return n.target = o, n.mods = {}, n.container = t.c.div("jodit-status-bar"), o.appendChild(n.container), n.hide(), n;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "StatusBar";
                    }, t.prototype.hide = function() {
                        this.container.classList.add("jodit_hidden");
                    }, t.prototype.show = function() {
                        this.container.classList.remove("jodit_hidden");
                    }, Object.defineProperty(t.prototype, "isShown", {
                        get: function() {
                            return !this.container.classList.contains("jodit_hidden");
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.getHeight = function() {
                        var e, t;
                        return null !== (t = null === (e = this.container) || void 0 === e ? void 0 : e.offsetHeight) && void 0 !== t ? t : 0;
                    }, t.prototype.findEmpty = function(e) {
                        void 0 === e && (e = !1);
                        for(var t = this.getElms(e ? "item-right" : "item"), o = 0; t.length > o; o += 1)if (!t[o].innerHTML.trim().length) return t[o];
                    }, t.prototype.append = function(e, t) {
                        var o;
                        void 0 === t && (t = !1);
                        var n = this.findEmpty(t) || this.j.c.div(this.getFullElName("item"));
                        t && n.classList.add(this.getFullElName("item-right")), n.appendChild(e), null === (o = this.container) || void 0 === o || o.appendChild(n), this.j.o.statusbar && this.show(), this.j.e.fire("resize");
                    }, t.prototype.destruct = function() {
                        this.isInDestruct || (this.setStatus(r.STATUSES.beforeDestruct), i.Dom.safeRemove(this.container), e.prototype.destruct.call(this));
                    }, n.__decorate([
                        s.component,
                        (0, s.derive)(a.Mods, a.Elms)
                    ], t);
                }(r.ViewComponent);
                t.StatusBar = l;
            },
            25120: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Table = void 0;
                var n = o(20255), r = o(86893), i = o(64968), a = o(40332), s = o(56562), l = o(17332), c = o(43441), u = new WeakMap, d = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.selected = new Set, t;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "Table";
                    }, t.prototype.recalculateStyles = function() {
                        var e = (0, l.getContainer)(this.j, t, "style", !0), o = [];
                        this.selected.forEach(function(e) {
                            var t = (0, a.cssPath)(e);
                            t && o.push(t);
                        }), e.innerHTML = o.length ? o.join(",") + "{".concat(this.jodit.options.table.selectionCellStyle, "}") : "";
                    }, t.prototype.addSelection = function(e) {
                        this.selected.add(e), this.recalculateStyles();
                        var o = i.Dom.closest(e, "table", this.j.editor);
                        if (o) {
                            var n = t.selectedByTable.get(o) || new Set;
                            n.add(e), t.selectedByTable.set(o, n);
                        }
                    }, t.prototype.removeSelection = function(e) {
                        this.selected.delete(e), this.recalculateStyles();
                        var o = i.Dom.closest(e, "table", this.j.editor);
                        if (o) {
                            var n = t.selectedByTable.get(o);
                            n && (n.delete(e), n.size || t.selectedByTable.delete(o));
                        }
                    }, t.prototype.getAllSelectedCells = function() {
                        return (0, a.toArray)(this.selected);
                    }, t.getSelectedCellsByTable = function(e) {
                        var o = t.selectedByTable.get(e);
                        return o ? (0, a.toArray)(o) : [];
                    }, t.prototype.destruct = function() {
                        return this.selected.clear(), e.prototype.destruct.call(this);
                    }, t.getRowsCount = function(e) {
                        return e.rows.length;
                    }, t.getColumnsCount = function(e) {
                        return t.formalMatrix(e).reduce(function(e, t) {
                            return Math.max(e, t.length);
                        }, 0);
                    }, t.formalMatrix = function(e, t) {
                        for(var o = [
                            []
                        ], n = (0, a.toArray)(e.rows), r = function(e, n) {
                            void 0 === o[n] && (o[n] = []);
                            for(var r, i, a = e.colSpan, s = e.rowSpan, l = 0; o[n][l];)l += 1;
                            for(i = 0; s > i; i += 1)for(r = 0; a > r; r += 1){
                                if (void 0 === o[n + i] && (o[n + i] = []), t && !1 === t(e, n + i, l + r, a, s)) return !1;
                                o[n + i][l + r] = e;
                            }
                        }, i = 0; n.length > i; i += 1)for(var s = (0, a.toArray)(n[i].cells), l = 0; s.length > l; l += 1)if (!1 === r(s[l], i)) return o;
                        return o;
                    }, t.formalCoordinate = function(e, o, n) {
                        void 0 === n && (n = !1);
                        var r = 0, i = 0, a = 1, s = 1;
                        return t.formalMatrix(e, function(e, t, l, c, u) {
                            if (o === e) return r = t, i = l, a = c || 1, s = u || 1, n && (i += (c || 1) - 1, r += (u || 1) - 1), !1;
                        }), [
                            r,
                            i,
                            a,
                            s
                        ];
                    }, t.appendRow = function(e, o, n, r) {
                        var i, s;
                        if (o) s = o.cloneNode(!0), (0, a.$$)("td,th", o).forEach(function(e) {
                            var t = (0, a.attr)(e, "rowspan");
                            if (t && parseInt(t, 10) > 1) {
                                var o = parseInt(t, 10) - 1;
                                (0, a.attr)(e, "rowspan", o > 1 ? o : null);
                            }
                        }), (0, a.$$)("td,th", s).forEach(function(e) {
                            e.innerHTML = "";
                        });
                        else {
                            var l = t.getColumnsCount(e);
                            s = r.element("tr");
                            for(var c = 0; l > c; c += 1)s.appendChild(r.element("td"));
                        }
                        n && o && o.nextSibling ? o.parentNode && o.parentNode.insertBefore(s, o.nextSibling) : !n && o ? o.parentNode && o.parentNode.insertBefore(s, o) : ((null === (i = e.getElementsByTagName("tbody")) || void 0 === i ? void 0 : i[0]) || e).appendChild(s);
                    }, t.removeRow = function(e, o) {
                        var n, r = t.formalMatrix(e), s = e.rows[o];
                        r[o].forEach(function(t, l) {
                            if (n = !1, 0 > o - 1 || r[o - 1][l] !== t) {
                                if (r[o + 1] && r[o + 1][l] === t) {
                                    if (t.parentNode === s && t.parentNode.nextSibling) {
                                        n = !0;
                                        for(var c = l + 1; r[o + 1][c] === t;)c += 1;
                                        var u = i.Dom.next(t.parentNode, function(e) {
                                            return i.Dom.isTag(e, "tr");
                                        }, e);
                                        u && (r[o + 1][c] ? u.insertBefore(t, r[o + 1][c]) : u.appendChild(t));
                                    }
                                } else i.Dom.safeRemove(t);
                            } else n = !0;
                            if (n && (t.parentNode === s || t !== r[o][l - 1])) {
                                var d = t.rowSpan;
                                (0, a.attr)(t, "rowspan", d - 1 > 1 ? d - 1 : null);
                            }
                        }), i.Dom.safeRemove(s);
                    }, t.appendColumn = function(e, o, n, r) {
                        var s, l = t.formalMatrix(e);
                        for((void 0 === o || 0 > o) && (o = t.getColumnsCount(e) - 1), s = 0; l.length > s; s += 1){
                            var c = r.element("td"), u = l[s][o], d = !1;
                            n ? (l[s] && u && o + 1 >= l[s].length || u !== l[s][o + 1]) && (u.nextSibling ? i.Dom.before(u.nextSibling, c) : u.parentNode && u.parentNode.appendChild(c), d = !0) : (0 > o - 1 || l[s][o] !== l[s][o - 1] && l[s][o].parentNode) && (i.Dom.before(l[s][o], c), d = !0), d || (0, a.attr)(l[s][o], "colspan", parseInt((0, a.attr)(l[s][o], "colspan") || "1", 10) + 1);
                        }
                    }, t.removeColumn = function(e, o) {
                        var n, r = t.formalMatrix(e);
                        r.forEach(function(e, t) {
                            var s = e[o];
                            if (n = !1, 0 > o - 1 || r[t][o - 1] !== s ? e.length > o + 1 && r[t][o + 1] === s ? n = !0 : i.Dom.safeRemove(s) : n = !0, n && (0 > t - 1 || s !== r[t - 1][o])) {
                                var l = s.colSpan;
                                (0, a.attr)(s, "colspan", l - 1 > 1 ? (l - 1).toString() : null);
                            }
                        });
                    }, t.getSelectedBound = function(e, o) {
                        var n, r, i, a = [
                            [
                                1 / 0,
                                1 / 0
                            ],
                            [
                                0,
                                0
                            ]
                        ], s = t.formalMatrix(e);
                        for(n = 0; s.length > n; n += 1)for(r = 0; s[n] && s[n].length > r; r += 1)o.includes(s[n][r]) && (a[0][0] = Math.min(n, a[0][0]), a[0][1] = Math.min(r, a[0][1]), a[1][0] = Math.max(n, a[1][0]), a[1][1] = Math.max(r, a[1][1]));
                        for(n = a[0][0]; a[1][0] >= n; n += 1)for(i = 1, r = a[0][1]; a[1][1] >= r; r += 1){
                            for(; s[n] && s[n][r - i] && s[n][r] === s[n][r - i];)a[0][1] = Math.min(r - i, a[0][1]), a[1][1] = Math.max(r - i, a[1][1]), i += 1;
                            for(i = 1; s[n] && s[n][r + i] && s[n][r] === s[n][r + i];)a[0][1] = Math.min(r + i, a[0][1]), a[1][1] = Math.max(r + i, a[1][1]), i += 1;
                            for(i = 1; s[n - i] && s[n][r] === s[n - i][r];)a[0][0] = Math.min(n - i, a[0][0]), a[1][0] = Math.max(n - i, a[1][0]), i += 1;
                            for(i = 1; s[n + i] && s[n][r] === s[n + i][r];)a[0][0] = Math.min(n + i, a[0][0]), a[1][0] = Math.max(n + i, a[1][0]), i += 1;
                        }
                        return a;
                    }, t.normalizeTable = function(e) {
                        var o, n, r, i, s = [], l = t.formalMatrix(e);
                        for(n = 0; l[0].length > n; n += 1){
                            for(r = 1e6, i = !1, o = 0; l.length > o; o += 1)if (void 0 !== l[o][n]) {
                                if (2 > l[o][n].colSpan) {
                                    i = !0;
                                    break;
                                }
                                r = Math.min(r, l[o][n].colSpan);
                            }
                            if (!i) for(o = 0; l.length > o; o += 1)void 0 !== l[o][n] && t.mark(l[o][n], "colspan", l[o][n].colSpan - r + 1, s);
                        }
                        for(o = 0; l.length > o; o += 1){
                            for(r = 1e6, i = !1, n = 0; l[o].length > n; n += 1)if (void 0 !== l[o][n]) {
                                if (2 > l[o][n].rowSpan) {
                                    i = !0;
                                    break;
                                }
                                r = Math.min(r, l[o][n].rowSpan);
                            }
                            if (!i) for(n = 0; l[o].length > n; n += 1)void 0 !== l[o][n] && t.mark(l[o][n], "rowspan", l[o][n].rowSpan - r + 1, s);
                        }
                        for(o = 0; l.length > o; o += 1)for(n = 0; l[o].length > n; n += 1)void 0 !== l[o][n] && (l[o][n].hasAttribute("rowspan") && 1 === l[o][n].rowSpan && (0, a.attr)(l[o][n], "rowspan", null), l[o][n].hasAttribute("colspan") && 1 === l[o][n].colSpan && (0, a.attr)(l[o][n], "colspan", null), l[o][n].hasAttribute("class") && !(0, a.attr)(l[o][n], "class") && (0, a.attr)(l[o][n], "class", null));
                        t.unmark(s);
                    }, t.mergeSelected = function(e, o) {
                        var n, s = [], l = t.getSelectedBound(e, t.getSelectedCellsByTable(e)), c = 0, u = null, d = 0, f = 0, h = 0, m = new Set, v = [];
                        l && (l[0][0] - l[1][0] || l[0][1] - l[1][1]) && (t.formalMatrix(e, function(e, r, i, g, y) {
                            if (!(l[0][0] > r || r > l[1][0] || l[0][1] > i || i > l[1][1])) {
                                if (m.has(n = e)) return;
                                m.add(n), r === l[0][0] && n.style.width && (c += n.offsetWidth), "" !== (0, a.trim)(e.innerHTML.replace(/<br(\/)?>/g, "")) && s.push(e.innerHTML), g > 1 && (f += g - 1), y > 1 && (h += y - 1), u ? (t.mark(n, "remove", 1, v), p(o).removeSelection(n)) : (u = e, d = i);
                            }
                        }), f = l[1][1] - l[0][1] + 1, h = l[1][0] - l[0][0] + 1, u && (f > 1 && t.mark(u, "colspan", f, v), h > 1 && t.mark(u, "rowspan", h, v), c && (t.mark(u, "width", (c / e.offsetWidth * 100).toFixed(r.ACCURACY) + "%", v), d && t.setColumnWidthByDelta(e, d, 0, !0, v)), u.innerHTML = s.join("<br/>"), p(o).addSelection(u), m.delete(u), t.unmark(v), t.normalizeTable(e), (0, a.toArray)(e.rows).forEach(function(e, t) {
                            e.cells.length || i.Dom.safeRemove(e);
                        })));
                    }, t.splitHorizontal = function(e, o) {
                        var n, r, a, s, l, c = [];
                        t.getSelectedCellsByTable(e).forEach(function(u) {
                            (r = o.createInside.element("td")).appendChild(o.createInside.element("br")), a = o.createInside.element("tr"), n = t.formalCoordinate(e, u), 2 > u.rowSpan ? (t.formalMatrix(e, function(e, o, r) {
                                n[0] === o && n[1] !== r && e !== u && t.mark(e, "rowspan", e.rowSpan + 1, c);
                            }), i.Dom.after(i.Dom.closest(u, "tr", e), a), a.appendChild(r)) : (t.mark(u, "rowspan", u.rowSpan - 1, c), t.formalMatrix(e, function(t, o, r) {
                                o > n[0] && n[0] + u.rowSpan > o && n[1] > r && t.parentNode.rowIndex === o && (l = t), o > n[0] && t === u && (s = e.rows[o]);
                            }), l ? i.Dom.after(l, r) : s.insertBefore(r, s.firstChild)), u.colSpan > 1 && t.mark(r, "colspan", u.colSpan, c), t.unmark(c), p(o).removeSelection(u);
                        }), this.normalizeTable(e);
                    }, t.splitVertical = function(e, o) {
                        var n, a, s, l = [];
                        t.getSelectedCellsByTable(e).forEach(function(c) {
                            n = t.formalCoordinate(e, c), 2 > c.colSpan ? t.formalMatrix(e, function(e, o, r) {
                                n[1] === r && n[0] !== o && e !== c && t.mark(e, "colspan", e.colSpan + 1, l);
                            }) : t.mark(c, "colspan", c.colSpan - 1, l), (a = o.createInside.element("td")).appendChild(o.createInside.element("br")), c.rowSpan > 1 && t.mark(a, "rowspan", c.rowSpan, l);
                            var u = c.offsetWidth;
                            i.Dom.after(c, a), t.mark(c, "width", (100 * (s = u / e.offsetWidth / 2)).toFixed(r.ACCURACY) + "%", l), t.mark(a, "width", (100 * s).toFixed(r.ACCURACY) + "%", l), t.unmark(l), p(o).removeSelection(c);
                        }), t.normalizeTable(e);
                    }, t.setColumnWidthByDelta = function(e, o, n, i, a) {
                        for(var s = t.formalMatrix(e), l = 0, c = 0; s.length > c; c += 1)if (1 >= (u = s[c][o]).colSpan || 1 >= s.length) {
                            t.mark(u, "width", ((u.offsetWidth + n) / e.offsetWidth * 100).toFixed(r.ACCURACY) + "%", a), l = c;
                            break;
                        }
                        for(c = l + 1; s.length > c; c += 1){
                            var u;
                            t.mark(u = s[c][o], "width", null, a);
                        }
                        i || t.unmark(a);
                    }, t.mark = function(e, t, o, n) {
                        var r;
                        n.push(e);
                        var i = null !== (r = u.get(e)) && void 0 !== r ? r : {};
                        i[t] = void 0 === o ? 1 : o, u.set(e, i);
                    }, t.unmark = function(e) {
                        e.forEach(function(e) {
                            var t = u.get(e);
                            t && (Object.keys(t).forEach(function(o) {
                                var n = t[o];
                                switch(o){
                                    case "remove":
                                        i.Dom.safeRemove(e);
                                        break;
                                    case "rowspan":
                                        (0, a.attr)(e, "rowspan", (0, a.isNumber)(n) && n > 1 ? n : null);
                                        break;
                                    case "colspan":
                                        (0, a.attr)(e, "colspan", (0, a.isNumber)(n) && n > 1 ? n : null);
                                        break;
                                    case "width":
                                        null == n ? (e.style.removeProperty("width"), (0, a.attr)(e, "style") || (0, a.attr)(e, "style", null)) : e.style.width = n.toString();
                                }
                                delete t[o];
                            }), u.delete(e));
                        });
                    }, t.selectedByTable = new WeakMap, n.__decorate([
                        (0, c.debounce)()
                    ], t.prototype, "recalculateStyles", null), t;
                }(s.ViewComponent);
                t.Table = d;
                var p = function(e) {
                    return e.getInstance("Table", e.o);
                };
            },
            48197: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ToolbarButton = void 0;
                var n = o(20255);
                o(53362);
                var r = o(96516), i = o(43441), a = o(64968), s = o(12680), l = o(81438), c = o(40332), u = o(77904), d = o(72719), p = o(29411), f = o(38546), h = function(e) {
                    function t(t, o, i) {
                        void 0 === i && (i = null);
                        var a = e.call(this, t) || this;
                        return a.control = o, a.target = i, a.state = n.__assign(n.__assign({}, (0, r.UIButtonState)()), {
                            theme: "toolbar",
                            currentValue: "",
                            hasTrigger: !1
                        }), a.openedPopup = null, t.e.on([
                            a.button,
                            a.trigger
                        ], "mousedown", function(e) {
                            return e.preventDefault();
                        }), a.onAction(a.onClick), a.hookStatus(p.STATUSES.ready, function() {
                            a.initFromControl(), a.initTooltip(), a.update();
                        }), o.mods && Object.keys(o.mods).forEach(function(e) {
                            o.mods && a.setMod(e, o.mods[e]);
                        }), a;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "ToolbarButton";
                    }, Object.defineProperty(t.prototype, "toolbar", {
                        get: function() {
                            return this.closest(d.ToolbarCollection);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "button", {
                        get: function() {
                            return this.container.querySelector("button.".concat(this.componentName, "__button"));
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.update = function() {
                        var t = this.control, o = this.state, n = this.closest(d.ToolbarCollection);
                        o.disabled = this.calculateDisabledStatus(n), o.activated = this.calculateActivatedStatus(n), (0, c.isFunction)(t.update) && n && t.update(this, n.jodit), e.prototype.update.call(this);
                    }, t.prototype.calculateActivatedStatus = function(e) {
                        return !((0, c.isJoditObject)(this.j) && !this.j.editorIsActive) && (!(!(0, c.isFunction)(this.control.isActive) || !this.control.isActive(this.j, this.control, this)) || Boolean(e && e.shouldBeActive(this)));
                    }, t.prototype.calculateDisabledStatus = function(e) {
                        return !!this.j.o.disabled || !(!this.j.o.readonly || this.j.o.activeButtonsInReadOnly && this.j.o.activeButtonsInReadOnly.includes(this.control.name)) || !(!(0, c.isFunction)(this.control.isDisabled) || !this.control.isDisabled(this.j, this.control, this)) || Boolean(e && e.shouldBeDisabled(this));
                    }, t.prototype.onChangeActivated = function() {
                        (0, c.attr)(this.button, "aria-pressed", this.state.activated), e.prototype.onChangeActivated.call(this);
                    }, t.prototype.onChangeText = function() {
                        (0, c.isFunction)(this.control.template) ? this.text.innerHTML = this.control.template(this.j, this.control.name, this.j.i18n(this.state.text)) : e.prototype.onChangeText.call(this), this.setMod("text-icons", Boolean(this.text.innerText.trim().length));
                    }, t.prototype.onChangeTabIndex = function() {
                        (0, c.attr)(this.button, "tabindex", this.state.tabIndex);
                    }, t.prototype.onChangeTooltip = function() {
                        (0, c.attr)(this.button, "aria-label", this.state.tooltip), e.prototype.onChangeTooltip.call(this);
                    }, t.prototype.createContainer = function() {
                        var t = this.componentName, o = this.j.c.span(t), n = e.prototype.createContainer.call(this);
                        return (0, c.attr)(o, "role", "listitem"), n.classList.remove(t), n.classList.add(t + "__button"), Object.defineProperty(n, "component", {
                            value: this
                        }), o.appendChild(n), this.trigger = this.j.c.fromHTML('<span role="trigger" class="'.concat(t, '__trigger">').concat(u.Icon.get("chevron"), "</span>")), o;
                    }, t.prototype.focus = function() {
                        var e;
                        null === (e = this.container.querySelector("button")) || void 0 === e || e.focus();
                    }, t.prototype.onChangeHasTrigger = function() {
                        this.state.hasTrigger ? this.container.appendChild(this.trigger) : a.Dom.safeRemove(this.trigger), this.setMod("with-trigger", this.state.hasTrigger || null);
                    }, t.prototype.onChangeDisabled = function() {
                        var e = this.state.disabled ? "disabled" : null;
                        (0, c.attr)(this.trigger, "disabled", e), (0, c.attr)(this.button, "disabled", e), (0, c.attr)(this.container, "disabled", e);
                    }, t.prototype.initTooltip = function() {
                        var e = this;
                        this.j.o.textIcons || !this.j.o.showTooltip || this.j.o.useNativeTooltip || this.j.e.off(this.container, "mouseenter mouseleave").on(this.container, "mousemove", function(t) {
                            e.state.tooltip && !e.state.disabled && e.j.e.fire("delayShowTooltip", function() {
                                return {
                                    x: t.clientX + 10,
                                    y: t.clientY + 10
                                };
                            }, e.state.tooltip);
                        }).on(this.container, "mouseleave", function() {
                            e.j.e.fire("hideTooltip");
                        });
                    }, t.prototype.initFromControl = function() {
                        var e, t = this.control, o = this.state;
                        this.updateSize(), o.name = t.name;
                        var n = this.j.o.textIcons;
                        if (!0 === n || (0, c.isFunction)(n) && n(t.name) || t.template) o.icon = (0, r.UIButtonState)().icon, o.text = t.text || t.name;
                        else {
                            if (t.iconURL) o.icon.iconURL = t.iconURL;
                            else {
                                var i = t.icon || t.name;
                                o.icon.name = u.Icon.exists(i) || (null === (e = this.j.o.extraIcons) || void 0 === e ? void 0 : e[i]) ? i : "";
                            }
                            t.iconURL || o.icon.name || (o.text = t.text || t.name);
                        }
                        t.tooltip && (o.tooltip = this.j.i18n((0, c.isFunction)(t.tooltip) ? t.tooltip(this.j, t, this) : t.tooltip)), o.hasTrigger = Boolean(t.list || t.popup && t.exec);
                    }, t.prototype.onTriggerClick = function(e) {
                        var t, o, n, r = this;
                        if (this.openedPopup) this.closePopup();
                        else {
                            var i = this.control;
                            if (e.buffer = {
                                actionTrigger: this
                            }, i.list) return this.openControlList(i);
                            if ((0, c.isFunction)(i.popup)) {
                                var a = this.openPopup();
                                if (a.parentElement = this, !1 !== this.j.e.fire((0, c.camelCase)("before-".concat(i.name, "-open-popup")), this.target, i, a)) {
                                    var s = null !== (n = null !== (o = null === (t = this.toolbar) || void 0 === t ? void 0 : t.getTarget(this)) && void 0 !== o ? o : this.target) && void 0 !== n ? n : null, l = i.popup(this.j, s, i, this.closePopup, this);
                                    l && a.setContent((0, c.isString)(l) ? this.j.c.fromHTML(l) : l).open(function() {
                                        return (0, c.position)(r.container);
                                    }, !1, this.j.o.allowTabNavigation ? this.container : void 0);
                                }
                                this.j.e.fire((0, c.camelCase)("after-".concat(i.name, "-open-popup")), a.container);
                            }
                        }
                    }, t.prototype.openControlList = function(e) {
                        var t, o = this, r = null !== (t = this.jodit.options.controls) && void 0 !== t ? t : {}, i = function(e) {
                            return (0, f.findControlType)(e, r);
                        }, a = e.list, s = this.openPopup(), u = (0, l.makeCollection)(this.j);
                        s.parentElement = this, u.parentElement = s, u.mode = "vertical";
                        var d = function(t, r) {
                            if ((0, c.isString)(r) && i(r)) return n.__assign({
                                name: r.toString()
                            }, i(r));
                            if ((0, c.isString)(t) && i(t)) return n.__assign(n.__assign({
                                name: t.toString()
                            }, i(t)), "object" == typeof r ? r : {});
                            (function(e) {
                                return (0, c.isPlainObject)(e) && "title" in e && "value" in e;
                            })(t) && (r = t.value, t = t.title);
                            var a = e.childTemplate, s = {
                                name: t.toString(),
                                template: a && function(e, t, n) {
                                    return a(e, t, n, o);
                                },
                                exec: e.childExec ? function(t, o, r) {
                                    var i;
                                    return null === (i = e.childExec) || void 0 === i ? void 0 : i.call(e, t, o, n.__assign(n.__assign({}, r), {
                                        parentControl: e
                                    }));
                                } : e.exec,
                                data: e.data,
                                command: e.command,
                                isActive: e.isChildActive,
                                isDisabled: e.isChildDisabled,
                                mode: e.mode,
                                args: n.__spreadArray(n.__spreadArray([], n.__read(e.args ? e.args : []), !1), [
                                    t,
                                    r
                                ], !1)
                            };
                            return (0, c.isString)(r) && (s.text = r), s;
                        };
                        u.build((0, c.isArray)(a) ? a.map(d) : (0, c.keys)(a, !1).map(function(e) {
                            return d(e, a[e]);
                        }), this.target), s.setContent(u.container).open(function() {
                            return (0, c.position)(o.container);
                        }, !1, this.j.o.allowTabNavigation ? this.container : void 0), this.state.activated = !0;
                    }, t.prototype.onOutsideClick = function(e) {
                        this.openedPopup && (e && a.Dom.isNode(e.target) && (a.Dom.isOrContains(this.container, e.target) || this.openedPopup.isOwnClick(e)) || this.closePopup());
                    }, t.prototype.openPopup = function() {
                        return this.closePopup(), this.openedPopup = new s.Popup(this.j, !1), this.j.e.on(this.ow, "mousedown touchstart", this.onOutsideClick).on("escape closeAllPopups", this.onOutsideClick), this.openedPopup;
                    }, t.prototype.closePopup = function() {
                        this.openedPopup && (this.j.e.off(this.ow, "mousedown touchstart", this.onOutsideClick).off("escape closeAllPopups", this.onOutsideClick), this.state.activated = !1, this.openedPopup.close(), this.openedPopup.destruct(), this.openedPopup = null);
                    }, t.prototype.onClick = function(e) {
                        var t, o, n, r, i, a, s, l = this.control;
                        if ((0, c.isFunction)(l.exec)) {
                            var u = null !== (n = null !== (o = null === (t = this.toolbar) || void 0 === t ? void 0 : t.getTarget(this)) && void 0 !== o ? o : this.target) && void 0 !== n ? n : null, d = l.exec(this.j, u, {
                                control: l,
                                originalEvent: e,
                                button: this
                            });
                            if (!1 !== d && !0 !== d && (null === (i = null === (r = this.j) || void 0 === r ? void 0 : r.e) || void 0 === i || i.fire("synchro"), this.parentElement && this.parentElement.update(), null === (s = null === (a = this.j) || void 0 === a ? void 0 : a.e) || void 0 === s || s.fire("closeAllPopups afterExec")), !1 !== d) return;
                        }
                        return l.list ? this.openControlList(l) : (0, c.isFunction)(l.popup) ? this.onTriggerClick(e) : void ((l.command || l.name) && ((0, c.call)((0, c.isJoditObject)(this.j) ? this.j.execCommand.bind(this.j) : this.j.od.execCommand.bind(this.j.od), l.command || l.name, !1, l.args && l.args[0]), this.j.e.fire("closeAllPopups")));
                    }, t.prototype.destruct = function() {
                        return this.closePopup(), e.prototype.destruct.call(this);
                    }, n.__decorate([
                        (0, i.watch)("state.tooltip")
                    ], t.prototype, "onChangeTooltip", null), n.__decorate([
                        (0, i.watch)("state.hasTrigger")
                    ], t.prototype, "onChangeHasTrigger", null), n.__decorate([
                        (0, i.watch)("trigger:click")
                    ], t.prototype, "onTriggerClick", null), n.__decorate([
                        i.autobind
                    ], t.prototype, "onOutsideClick", null), n.__decorate([
                        i.autobind
                    ], t.prototype, "closePopup", null), n.__decorate([
                        i.component
                    ], t);
                }(r.UIButton);
                t.ToolbarButton = h;
            },
            34375: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ToolbarContent = void 0;
                var n = o(20255);
                o(48904);
                var r = o(96516), i = o(64968), a = o(40332), s = o(43441), l = function(e) {
                    function t(t, o, n) {
                        void 0 === n && (n = null);
                        var r = e.call(this, t) || this;
                        return r.control = o, r.target = n, r.container.classList.add("".concat(r.componentName, "_").concat(r.clearName(o.name))), (0, a.attr)(r.container, "role", "content"), r;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "ToolbarContent";
                    }, t.prototype.update = function() {
                        var t = this.control.getContent(this.j, this.control, this);
                        ((0, a.isString)(t) || t.parentNode !== this.container) && (i.Dom.detach(this.container), this.container.appendChild((0, a.isString)(t) ? this.j.create.fromHTML(t) : t)), e.prototype.update.call(this);
                    }, t.prototype.createContainer = function() {
                        return this.j.c.span(this.componentName);
                    }, n.__decorate([
                        s.component
                    ], t);
                }(r.UIButton);
                t.ToolbarContent = l;
            },
            3890: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(48197), t), n.__exportStar(o(34375), t);
            },
            72719: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ToolbarCollection = void 0;
                var n = o(20255);
                o(85796);
                var r = o(40332), i = o(2074), a = o(81438), s = o(43441), l = function(e) {
                    function t(t) {
                        var o = e.call(this, t) || this;
                        return o.__listenEvents = "updatePlugins updateToolbar changeStack mousedown mouseup keydown change afterInit readonly afterResize selectionchange changeSelection focus afterSetMode touchstart focus blur", o.update = o.j.async.debounce(o.__immediateUpdate, function() {
                            return o.j.defaultTimeout;
                        }), o.__tooltip = null, o.__initEvents(), o.__tooltip = i.UITooltip.make(t), o;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "ToolbarCollection";
                    }, Object.defineProperty(t.prototype, "firstButton", {
                        get: function() {
                            return n.__read(this.buttons, 1)[0] || null;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.makeButton = function(e, t) {
                        return void 0 === t && (t = null), (0, a.makeButton)(this.j, e, t);
                    }, t.prototype.shouldBeActive = function(e) {}, t.prototype.shouldBeDisabled = function(e) {}, t.prototype.getTarget = function(e) {
                        return e.target || null;
                    }, t.prototype.__immediateUpdate = function() {
                        this.isDestructed || this.j.isLocked || (e.prototype.update.call(this), this.j.e.fire("afterUpdateToolbar"));
                    }, t.prototype.setDirection = function(e) {
                        this.container.style.direction = e, this.container.setAttribute("dir", e);
                    }, t.prototype.__initEvents = function() {
                        this.j.e.on(this.__listenEvents, this.update).on("afterSetMode focus", this.__immediateUpdate);
                    }, t.prototype.hide = function() {
                        this.container.remove();
                    }, t.prototype.show = function() {
                        this.appendTo(this.j.toolbarContainer);
                    }, t.prototype.showInline = function(e) {
                        throw (0, r.error)("The method is not implemented for this class.");
                    }, t.prototype.build = function(t, o) {
                        void 0 === o && (o = null);
                        var n = this.j.e.fire("beforeToolbarBuild", t);
                        return n && (t = n), e.prototype.build.call(this, t, o), this;
                    }, t.prototype.destruct = function() {
                        var t;
                        this.isDestructed || (null === (t = this.__tooltip) || void 0 === t || t.destruct(), this.j.e.off(this.__listenEvents, this.update).off("afterSetMode focus", this.__immediateUpdate), e.prototype.destruct.call(this));
                    }, n.__decorate([
                        s.autobind
                    ], t.prototype, "__immediateUpdate", null), n.__decorate([
                        s.component
                    ], t);
                }(i.UIList);
                t.ToolbarCollection = l;
            },
            81698: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ToolbarEditorCollection = void 0;
                var n = o(20255), r = o(72719), i = o(86893), a = o(64968), s = o(40332), l = o(43441), c = function(e) {
                    function t(t) {
                        var o = e.call(this, t) || this;
                        return o.checkActiveStatus = function(e, t) {
                            var n = 0, r = 0;
                            return Object.keys(e).forEach(function(i) {
                                var a = e[i];
                                (0, s.isFunction)(a) ? a(o.j, (0, s.css)(t, i).toString()) && (n += 1) : -1 !== a.indexOf((0, s.css)(t, i).toString()) && (n += 1), r += 1;
                            }), r === n;
                        }, o.prependInvisibleInput(o.container), o;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "ToolbarEditorCollection";
                    }, t.prototype.shouldBeDisabled = function(t) {
                        var o = e.prototype.shouldBeDisabled.call(this, t);
                        if (void 0 !== o) return o;
                        var n = void 0 === t.control.mode ? i.MODE_WYSIWYG : t.control.mode;
                        return !(n === i.MODE_SPLIT || n === this.j.getRealMode());
                    }, t.prototype.shouldBeActive = function(t) {
                        var o = this, n = e.prototype.shouldBeActive.call(this, t);
                        if (void 0 !== n) return n;
                        var r = this.j.selection ? this.j.s.current() : null;
                        if (!r) return !1;
                        if (t.control.tags) {
                            var i = t.control.tags;
                            if (a.Dom.up(r, function(e) {
                                if (e && -1 !== i.indexOf(e.nodeName.toLowerCase())) return !0;
                            }, this.j.editor)) return !0;
                        }
                        if (t.control.css) {
                            var s = t.control.css;
                            if (a.Dom.up(r, function(e) {
                                if (e && !a.Dom.isText(e)) return o.checkActiveStatus(s, e);
                            }, this.j.editor)) return !0;
                        }
                        return !1;
                    }, t.prototype.getTarget = function(e) {
                        return e.target || this.j.s.current() || null;
                    }, t.prototype.prependInvisibleInput = function(e) {
                        var t = this.j.create.element("input", {
                            tabIndex: -1,
                            disabled: !0,
                            style: "width: 0; height:0; position: absolute; visibility: hidden;"
                        });
                        a.Dom.appendChildFirst(e, t);
                    }, t.prototype.showInline = function(e) {
                        this.jodit.e.fire("showInlineToolbar", e);
                    }, t.prototype.hide = function() {
                        this.jodit.e.fire("hidePopup"), e.prototype.hide.call(this), this.jodit.e.fire("toggleToolbar");
                    }, t.prototype.show = function() {
                        e.prototype.show.call(this), this.jodit.e.fire("toggleToolbar");
                    }, n.__decorate([
                        l.component
                    ], t);
                }(r.ToolbarCollection);
                t.ToolbarEditorCollection = c;
            },
            81438: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.makeButton = t.makeCollection = void 0;
                var n = o(40332), r = o(72719), i = o(81698), a = o(48197), s = o(34375);
                t.makeCollection = function(e, t) {
                    var o = (0, n.isJoditObject)(e) ? new i.ToolbarEditorCollection(e) : new r.ToolbarCollection(e);
                    return e.o.textIcons && o.container.classList.add("jodit_text_icons"), t && (o.parentElement = t), e.o.toolbarButtonSize && (o.buttonSize = e.o.toolbarButtonSize), o;
                }, t.makeButton = function(e, t, o) {
                    if (void 0 === o && (o = null), (0, n.isFunction)(t.getContent)) return new s.ToolbarContent(e, t, o);
                    var r = new a.ToolbarButton(e, t, o);
                    return r.state.tabIndex = e.o.allowTabNavigation ? 0 : -1, r;
                };
            },
            36262: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255), r = o(93166), i = o(49781), a = o(77892);
                r.Config.prototype.enableDragAndDropFileToEditor = !0, r.Config.prototype.uploader = {
                    url: "",
                    insertImageAsBase64URI: !1,
                    imagesExtensions: [
                        "jpg",
                        "png",
                        "jpeg",
                        "gif"
                    ],
                    headers: null,
                    data: null,
                    filesVariableName: function(e) {
                        return "files[".concat(e, "]");
                    },
                    withCredentials: !1,
                    pathVariableName: "path",
                    format: "json",
                    method: "POST",
                    prepareData: function(e) {
                        return e;
                    },
                    isSuccess: function(e) {
                        return e.success;
                    },
                    getMessage: function(e) {
                        return void 0 !== e.data.messages && (0, i.isArray)(e.data.messages) ? e.data.messages.join(" ") : "";
                    },
                    processFileName: function(e, t, o) {
                        return [
                            e,
                            t,
                            o
                        ];
                    },
                    process: function(e) {
                        return e.data;
                    },
                    error: function(e) {
                        this.j.e.fire("errorMessage", e.message, "error", 4e3);
                    },
                    getDisplayName: function(e, t) {
                        return e + t;
                    },
                    defaultHandlerSuccess: function(e) {
                        var t = this, o = this.j || this;
                        (0, a.isJoditObject)(o) && e.files && e.files.length && e.files.forEach(function(r, i) {
                            var a = n.__read(e.isImages && e.isImages[i] ? [
                                "img",
                                "src"
                            ] : [
                                "a",
                                "href"
                            ], 2), s = a[0], l = a[1], c = o.createInside.element(s);
                            c.setAttribute(l, e.baseurl + r), "a" === s && (c.textContent = o.o.uploader.getDisplayName.call(t, e.baseurl, r)), "img" === s ? o.s.insertImage(c, null, o.o.imageDefaultWidth) : o.s.insertNode(c);
                        });
                    },
                    defaultHandlerError: function(e) {
                        this.j.e.fire("errorMessage", e.message);
                    },
                    contentType: function(e) {
                        return (void 0 === this.ow.FormData || "string" == typeof e) && "application/x-www-form-urlencoded; charset=UTF-8";
                    }
                };
            },
            55778: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.buildData = void 0;
                var n = o(40332);
                t.buildData = function(e, t) {
                    if ((0, n.isFunction)(e.o.buildData)) return e.o.buildData.call(e, t);
                    var o = e.ow.FormData;
                    if (void 0 !== o) {
                        if (t instanceof o) return t;
                        if ((0, n.isString)(t)) return t;
                        var r = new o;
                        return Object.keys(t).forEach(function(e) {
                            r.append(e, t[e]);
                        }), r;
                    }
                    return t;
                };
            },
            98099: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.dataURItoBlob = void 0, t.dataURItoBlob = function(e) {
                    for(var t = atob(e.split(",")[1]), o = e.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), r = new Uint8Array(n), i = 0; t.length > i; i += 1)r[i] = t.charCodeAt(i);
                    return new Blob([
                        r
                    ], {
                        type: o
                    });
                };
            },
            41566: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hasItems = t.hasFiles = void 0;
                var n = o(20255);
                n.__exportStar(o(32937), t), n.__exportStar(o(98099), t), n.__exportStar(o(55778), t), n.__exportStar(o(30863), t), n.__exportStar(o(20704), t), t.hasFiles = function(e) {
                    return Boolean(e && e.files && e.files.length > 0);
                }, t.hasItems = function(e) {
                    return Boolean(e && e.items && e.items.length > 0);
                };
            },
            32937: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.processOldBrowserDrag = void 0;
                var n = o(86893), r = o(17332), i = o(40332), a = o(64968), s = o(41566);
                t.processOldBrowserDrag = function(e, t, o, l, c) {
                    if (t && (!t.types.length || t.types[0] !== n.TEXT_PLAIN)) {
                        var u = e.j.c.div("", {
                            tabindex: -1,
                            style: "left: -9999px; top: 0; width: 0; height: 100%;line-height: 140%; overflow: hidden; position: fixed; z-index: 2147483647; word-break: break-all;",
                            contenteditable: !0
                        });
                        (0, r.getContainer)(e.j, e.constructor).appendChild(u);
                        var d = (0, i.isJoditObject)(e.j) ? e.j.s.save() : null;
                        u.focus(), e.j.async.setTimeout(function() {
                            var t = u.firstChild;
                            if (a.Dom.safeRemove(u), t && t.hasAttribute("src")) {
                                var n = (0, i.attr)(t, "src") || "";
                                d && (0, i.isJoditObject)(e.j) && e.j.s.restore(), (0, s.sendFiles)(e, [
                                    (0, s.dataURItoBlob)(n)
                                ], o, l).finally(c);
                            }
                        }, e.j.defaultTimeout);
                    }
                };
            },
            20704: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sendFiles = void 0;
                var n = o(20255), r = o(40332), i = o(30863);
                t.sendFiles = function(e, t, o, a, s) {
                    if (!t) return Promise.reject((0, r.error)("Need files"));
                    var l = e.o, c = (0, r.toArray)(t);
                    if (!c.length) return Promise.reject((0, r.error)("Need files"));
                    var u = [];
                    if (l.insertImageAsBase64URI) {
                        var d, p = void 0, f = function() {
                            if ((d = c[p]) && d.type) {
                                var t = d.type.match(/\/([a-z0-9]+)/i), n = t[1] ? t[1].toLowerCase() : "";
                                if (l.imagesExtensions.includes(n)) {
                                    var i = new FileReader;
                                    u.push(e.j.async.promise(function(t, n) {
                                        i.onerror = n, i.onloadend = function() {
                                            var n = {
                                                baseurl: "",
                                                files: [
                                                    i.result
                                                ],
                                                isImages: [
                                                    !0
                                                ]
                                            };
                                            ((0, r.isFunction)(o) ? o : l.defaultHandlerSuccess).call(e, n), t(n);
                                        }, i.readAsDataURL(d);
                                    })), c[p] = null;
                                }
                            }
                        };
                        for(p = 0; c.length > p; p += 1)f();
                    }
                    if ((c = c.filter(function(e) {
                        return e;
                    })).length) {
                        var h = new FormData;
                        h.append(l.pathVariableName, e.path), h.append("source", e.source);
                        var m = void 0;
                        for(p = 0; c.length > p; p += 1)if (m = c[p]) {
                            var v = /\.[\d\w]+$/.test(m.name), g = m.type.match(/\/([a-z0-9]+)/i), y = g && g[1] ? g[1].toLowerCase() : "", _ = c[p].name || Math.random().toString().replace(".", "");
                            if (!v && y) {
                                var b = y;
                                [
                                    "jpeg",
                                    "jpg"
                                ].includes(b) && (b = "jpeg|jpg"), new RegExp(".(" + b + ")$", "i").test(_) || (_ += "." + y);
                            }
                            var w = n.__read(l.processFileName.call(e, l.filesVariableName(p), c[p], _), 3);
                            h.append(w[0], w[1], w[2]);
                        }
                        s && s(h), l.data && (0, r.isPlainObject)(l.data) && Object.keys(l.data).forEach(function(e) {
                            h.append(e, l.data[e]);
                        }), l.prepareData.call(e, h), u.push((0, i.send)(e, h).then(function(t) {
                            return l.isSuccess.call(e, t) ? (((0, r.isFunction)(o) ? o : l.defaultHandlerSuccess).call(e, l.process.call(e, t)), t) : (((0, r.isFunction)(a) ? a : l.defaultHandlerError).call(e, (0, r.error)(l.getMessage.call(e, t))), t);
                        }).then(function() {
                            e.j.events && e.j.e.fire("filesWereUploaded");
                        }));
                    }
                    return Promise.all(u);
                };
            },
            30863: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.send = t.ajaxInstances = void 0;
                var n = o(30056), r = o(40332), i = o(55778);
                t.ajaxInstances = new WeakMap, t.send = function(e, o) {
                    var a = (0, i.buildData)(e, o), s = function(o) {
                        var i = new n.Ajax({
                            xhr: function() {
                                var t = new XMLHttpRequest;
                                return void 0 !== e.j.ow.FormData && t.upload ? (e.j.progressbar.show().progress(10), t.upload.addEventListener("progress", function(t) {
                                    if (t.lengthComputable) {
                                        var o = t.loaded / t.total;
                                        o *= 100, e.j.progressbar.show().progress(o), 100 > o || e.j.progressbar.hide();
                                    }
                                }, !1)) : e.j.progressbar.hide(), t;
                            },
                            method: e.o.method || "POST",
                            data: o,
                            url: (0, r.isFunction)(e.o.url) ? e.o.url(o) : e.o.url,
                            headers: e.o.headers,
                            queryBuild: e.o.queryBuild,
                            contentType: e.o.contentType.call(e, o),
                            withCredentials: e.o.withCredentials || !1
                        }), a = t.ajaxInstances.get(e);
                        return a || (a = new Set, t.ajaxInstances.set(e, a)), a.add(i), e.j.e.one("beforeDestruct", i.destruct), i.send().then(function(e) {
                            return e.json();
                        }).catch(function(t) {
                            e.o.error.call(e, t);
                        }).finally(function() {
                            i.destruct(), null == a || a.delete(i);
                        });
                    };
                    return (0, r.isPromise)(a) ? a.then(s).catch(function(t) {
                        e.o.error.call(e, t);
                    }) : s(a);
                };
            },
            50454: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Uploader = void 0;
                var n = o(20255);
                o(28654);
                var r = o(93166), i = o(86893), a = o(40332), s = o(56562), l = o(41566);
                o(36262);
                var c = function(e) {
                    function t(t, o) {
                        var n = e.call(this, t) || this;
                        return n.path = "", n.source = "default", n.options = (0, a.ConfigProto)(o || {}, (0, a.ConfigProto)(r.Config.defaultOptions.uploader, (0, a.isJoditObject)(t) ? t.o.uploader : {})), n;
                    }
                    return n.__extends(t, e), Object.defineProperty(t.prototype, "j", {
                        get: function() {
                            return this.jodit;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.className = function() {
                        return "Uploader";
                    }, Object.defineProperty(t.prototype, "o", {
                        get: function() {
                            return this.options;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.setPath = function(e) {
                        return this.path = e, this;
                    }, t.prototype.setSource = function(e) {
                        return this.source = e, this;
                    }, t.prototype.bind = function(e, t, o) {
                        var n = function() {
                            e.classList.remove("jodit_drag_hover");
                        }, r = this, a = function(e) {
                            var a, s, c, u = e.clipboardData, d = function(e) {
                                s && (e.append("extension", c), e.append("mimetype", s.type));
                            };
                            if (!i.IS_IE && (0, l.hasFiles)(u)) return (0, l.sendFiles)(r, u.files, t, o).finally(n), !1;
                            if (i.IS_IE) return (0, l.processOldBrowserDrag)(r, u, t, o, n);
                            if ((0, l.hasItems)(u)) {
                                var p = u.items;
                                for(a = 0; p.length > a; a += 1)if ("file" === p[a].kind && "image/png" === p[a].type) {
                                    if (s = p[a].getAsFile()) {
                                        var f = s.type.match(/\/([a-z0-9]+)/i);
                                        c = f[1] ? f[1].toLowerCase() : "", (0, l.sendFiles)(r, [
                                            s
                                        ], t, o, d).finally(n);
                                    }
                                    e.preventDefault();
                                    break;
                                }
                            }
                        };
                        r.j && r.j.editor !== e ? r.j.e.on(e, "paste", a) : r.j.e.on("beforePaste", a), this.attachEvents(e, t, o, n);
                    }, t.prototype.attachEvents = function(e, t, o, n) {
                        var r = this;
                        r.j.e.on(e, "dragend dragover dragenter dragleave drop", function(e) {
                            e.preventDefault();
                        }).on(e, "dragover", function(t) {
                            ((0, l.hasFiles)(t.dataTransfer) || (0, l.hasItems)(t.dataTransfer)) && (e.classList.add("jodit_drag_hover"), t.preventDefault());
                        }).on(e, "dragend dragleave", function(t) {
                            e.classList.remove("jodit_drag_hover"), (0, l.hasFiles)(t.dataTransfer) && t.preventDefault();
                        }).on(e, "drop", function(i) {
                            e.classList.remove("jodit_drag_hover"), (0, l.hasFiles)(i.dataTransfer) && (i.preventDefault(), i.stopImmediatePropagation(), (0, l.sendFiles)(r, i.dataTransfer.files, t, o).finally(n));
                        });
                        var i = e.querySelector("input[type=file]");
                        i && r.j.e.on(i, "change", function() {
                            (0, l.sendFiles)(r, i.files, t, o).then(function() {
                                i.value = "", /safari/i.test(navigator.userAgent) || (i.type = "", i.type = "file");
                            }).finally(n);
                        });
                    }, t.prototype.uploadRemoteImage = function(e, t, o) {
                        var n = this, r = n.o, i = (0, a.isFunction)(o) ? o : r.defaultHandlerError;
                        (0, l.send)(n, {
                            action: "fileUploadRemote",
                            url: e
                        }).then(function(e) {
                            r.isSuccess.call(n, e) ? ((0, a.isFunction)(t) ? t : r.defaultHandlerSuccess).call(n, r.process.call(n, e)) : i.call(n, (0, a.error)(r.getMessage.call(n, e)));
                        }).catch(function(e) {
                            return i.call(n, e);
                        });
                    }, t.prototype.destruct = function() {
                        this.setStatus(s.STATUSES.beforeDestruct);
                        var t = l.ajaxInstances.get(this);
                        t && (t.forEach(function(e) {
                            try {
                                e.destruct();
                            } catch (e) {}
                        }), t.clear()), e.prototype.destruct.call(this);
                    }, t;
                }(s.ViewComponent);
                t.Uploader = c;
            },
            75243: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ColorPickerWidget = void 0, o(60819);
                var n = o(40332), r = o(2074), i = o(64968);
                r.Icon.set("palette", o(95331)), t.ColorPickerWidget = function(e, t, o) {
                    var a = "jodit-color-picker", s = (0, n.normalizeColor)(o), l = e.c.div(a), c = e.o.textIcons ? "<span>".concat(e.i18n("palette"), "</span>") : r.Icon.get("palette"), u = function(e) {
                        var t = [];
                        return (0, n.isPlainObject)(e) ? Object.keys(e).forEach(function(o) {
                            t.push('<div class="'.concat(a, "__group ").concat(a, "__group-").concat(o, '">')), t.push(u(e[o])), t.push("</div>");
                        }) : (0, n.isArray)(e) && e.forEach(function(e) {
                            t.push("<span class='".concat(a, "__color-item ").concat(s === e ? a + "__color-item_active_true" : "", "' title=\"").concat(e, '" style="background-color:').concat(e, '" data-color="').concat(e, '"></span>'));
                        }), t.join("");
                    };
                    l.appendChild(e.c.fromHTML('<div class="'.concat(a, '__groups">').concat(u(e.o.colors), "</div>"))), l.appendChild(e.c.fromHTML('<div data-ref="extra" class="'.concat(a, '__extra"></div>')));
                    var d = (0, n.refs)(l).extra;
                    return e.o.showBrowserColorPicker && (0, n.hasBrowserColorPicker)() && (d.appendChild(e.c.fromHTML('<div class="'.concat(a, '__native">').concat(c, '<input type="color" value="#ffffff"/></div>'))), e.e.on(l, "change", function(e) {
                        e.stopPropagation();
                        var o = e.target;
                        if (o && o.tagName && i.Dom.isTag(o, "input")) {
                            var r = o.value || "";
                            (0, n.isFunction)(t) && t(r), e.preventDefault();
                        }
                    })), e.e.on(l, "mousedown touchend", function(o) {
                        o.stopPropagation(), o.preventDefault();
                        var r = o.target;
                        if (r && r.tagName && !i.Dom.isTag(r, "svg") && !i.Dom.isTag(r, "path") || !r.parentNode || (r = i.Dom.closest(r.parentNode, "span", e.editor)), i.Dom.isTag(r, "span") && r.classList.contains(a + "__color-item")) {
                            var s = (0, n.attr)(r, "-color") || "";
                            t && (0, n.isFunction)(t) && t(s);
                        }
                    }), e.e.fire("afterGenerateColorPicker", l, d, t, s), l;
                };
            },
            83029: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FileSelectorWidget = void 0;
                var n = o(40332), r = o(64968), i = o(2074), a = o(60929);
                t.FileSelectorWidget = function(e, t, o, s, l) {
                    var c;
                    void 0 === l && (l = !0);
                    var u = [];
                    if (t.upload && e.o.uploader && (e.o.uploader.url || e.o.uploader.insertImageAsBase64URI)) {
                        var d = e.c.fromHTML('<div class="jodit-drag-and-drop__file-box">' + "<strong>".concat(e.i18n(l ? "Drop image" : "Drop file"), "</strong>") + "<span><br>".concat(e.i18n("or click"), "</span>") + '<input type="file" accept="'.concat(l ? "image/*" : "*", '" tabindex="-1" dir="auto" multiple=""/>') + "</div>");
                        e.uploader.bind(d, function(o) {
                            var r = (0, n.isFunction)(t.upload) ? t.upload : e.o.uploader.defaultHandlerSuccess;
                            (0, n.isFunction)(r) && r.call(e, o), e.e.fire("closeAllPopups");
                        }, function(t) {
                            e.e.fire("errorMessage", t.message), e.e.fire("closeAllPopups");
                        }), u.push({
                            icon: "upload",
                            name: "Upload",
                            content: d
                        });
                    }
                    if (t.filebrowser && (e.o.filebrowser.ajax.url || e.o.filebrowser.items.url) && u.push({
                        icon: "folder",
                        name: "Browse",
                        content: function() {
                            s && s(), t.filebrowser && e.filebrowser.open(t.filebrowser, l);
                        }
                    }), t.url) {
                        var p = new i.UIButton(e, {
                            type: "submit",
                            variant: "primary",
                            text: "Insert"
                        }), f = new i.UIForm(e, [
                            new i.UIInput(e, {
                                required: !0,
                                label: "URL",
                                name: "url",
                                type: "text",
                                placeholder: "https://"
                            }),
                            new i.UIInput(e, {
                                name: "text",
                                label: "Alternative text"
                            }),
                            new i.UIBlock(e, [
                                p
                            ])
                        ]);
                        c = null, o && !r.Dom.isText(o) && (r.Dom.isTag(o, "img") || (0, n.$$)("img", o).length) && (c = "IMG" === o.tagName ? o : (0, n.$$)("img", o)[0], (0, n.val)(f.container, "input[name=url]", (0, n.attr)(c, "src")), (0, n.val)(f.container, "input[name=text]", (0, n.attr)(c, "alt")), p.state.text = "Update"), o && r.Dom.isTag(o, "a") && ((0, n.val)(f.container, "input[name=url]", (0, n.attr)(o, "href")), (0, n.val)(f.container, "input[name=text]", (0, n.attr)(o, "title")), p.state.text = "Update"), f.onSubmit(function(o) {
                            (0, n.isFunction)(t.url) && t.url.call(e, o.url, o.text);
                        }), u.push({
                            icon: "link",
                            name: "URL",
                            content: f.container
                        });
                    }
                    return (0, a.TabsWidget)(e, u);
                };
            },
            718: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(75243), t), n.__exportStar(o(60929), t), n.__exportStar(o(83029), t);
            },
            60929: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TabsWidget = void 0, o(96410);
                var n = o(40332), r = o(42096), i = o(2074), a = o(56562), s = o(24263);
                t.TabsWidget = function(e, t, o) {
                    var l = e.c.div("jodit-tabs"), c = e.c.div("jodit-tabs__wrapper"), u = e.c.div("jodit-tabs__buttons"), d = {}, p = [], f = "", h = 0;
                    l.appendChild(u), l.appendChild(c);
                    var m = function(e) {
                        d[e] && (p.forEach(function(e) {
                            e.state.activated = !1;
                        }), (0, n.$$)(".jodit-tab", c).forEach(function(e) {
                            e.classList.remove("jodit-tab_active");
                        }), d[e].button.state.activated = !0, d[e].tab.classList.add("jodit-tab_active"));
                    };
                    if (t.forEach(function(n) {
                        var l = n.icon, v = n.name, g = n.content, y = e.c.div("jodit-tab"), _ = (0, i.Button)(e, l || v, v);
                        e.e.on(_.container, "mousedown", function(e) {
                            return e.preventDefault();
                        }), f || (f = v), u.appendChild(_.container), p.push(_), _.container.classList.add("jodit-tabs__button", "jodit-tabs__button_columns_" + t.length), (0, r.isFunction)(g) ? y.appendChild(e.c.div("jodit-tab_empty")) : y.appendChild(a.Component.isInstanceOf(g, i.UIElement) ? g.container : g), c.appendChild(y), _.onAction(function() {
                            return m(v), (0, r.isFunction)(g) && !s.Dom.isElement(g) && g.call(e), o && (o.__activeTab = v), !1;
                        }), d[v] = {
                            button: _,
                            tab: y
                        }, h += 1;
                    }), !h) return l;
                    if ((0, n.$$)("a", u).forEach(function(e) {
                        e.style.width = (100 / h).toFixed(10) + "%";
                    }), m(o && o.__activeTab && d[o.__activeTab] ? o.__activeTab : f), o) {
                        var v = o.__activeTab;
                        Object.defineProperty(o, "__activeTab", {
                            configurable: !0,
                            enumerable: !1,
                            get: function() {
                                return v;
                            },
                            set: function(e) {
                                v = e, m(e);
                            }
                        });
                    }
                    return l;
                };
            },
            55692: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(33126);
                var n = o(93166), r = o(40332), i = o(86893), a = o(17332), s = o(77904);
                n.Config.prototype.controls.about = {
                    exec: function(e) {
                        var t = e.dlg(), o = e.i18n.bind(e);
                        t.setMod("theme", e.o.theme).setHeader(o("About Jodit")).setContent('<div class="jodit-about">\n\t\t\t\t\t<div>'.concat(o("Jodit Editor"), " v.").concat(e.getVersion(), "</div>\n\t\t\t\t\t<div>").concat(o("License: %s", (0, r.isLicense)(e.o.license) ? (0, r.normalizeLicense)(e.o.license) : "MIT"), '</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="').concat("https://xdsoft.net/jodit/", '" target="_blank">').concat("https://xdsoft.net/jodit/", '</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<a href="https://xdsoft.net/jodit/docs/" target="_blank">').concat(o("Jodit User's Guide"), "</a>\n\t\t\t\t\t\t").concat(o("contains detailed help for using"), "\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>").concat(o("Copyright \xa9 XDSoft.net - Chupurnov Valeriy. All rights reserved."), "</div>\n\t\t\t\t</div>")), (0, r.css)(t.dialog, {
                            minHeight: 200,
                            minWidth: 420
                        }), t.open(!0);
                    },
                    tooltip: "About Jodit",
                    mode: i.MODE_SOURCE + i.MODE_WYSIWYG
                }, a.pluginSystem.add("about", function(e) {
                    e.registerButton({
                        name: "about",
                        group: "info"
                    });
                }), s.Icon.set("about", o(84279));
            },
            66031: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.addNewLine = void 0;
                var n = o(20255);
                o(30724);
                var r = o(87837), i = o(40332), a = o(43441), s = o(17332);
                o(46360);
                var l = "addnewline", c = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.line = t.j.c.fromHTML('<div role="button" tabindex="-1" title="'.concat(t.j.i18n("Break"), '" class="jodit-add-new-line"><span>').concat(r.Icon.get("enter"), "</span></div>")), t.isMatchedTag = function(e) {
                            return Boolean(e && t.j.o.addNewLineTagsTriggers.includes(e.nodeName.toLowerCase()));
                        }, t.preview = !1, t.lineInFocus = !1, t.isShown = !1, t.hideForce = function() {
                            t.isShown && (t.isShown = !1, t.j.async.clearTimeout(t.timeout), t.lineInFocus = !1, r.Dom.safeRemove(t.line), t.line.style.setProperty("--jd-offset-handle", "0"));
                        }, t.canGetFocus = function(e) {
                            return null != e && r.Dom.isBlock(e) && !/^(img|table|iframe|hr)$/i.test(e.nodeName);
                        }, t.onClickLine = function(e) {
                            var o = t.j, n = o.createInside.element(o.o.enter);
                            t.preview && t.current && t.current.parentNode ? t.current === o.editor ? r.Dom.prepend(o.editor, n) : t.current.parentNode.insertBefore(n, t.current) : o.editor.appendChild(n), o.s.setCursorIn(n), (0, i.scrollIntoViewIfNeeded)(n, o.editor, o.ed), o.synchronizeValues(), t.hideForce(), e.preventDefault();
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.show = function() {
                        this.isShown || this.j.o.readonly || this.j.isLocked || (this.isShown = !0, this.j.async.clearTimeout(this.timeout), this.line.classList.toggle("jodit-add-new-line_after", !this.preview), this.j.container.appendChild(this.line), this.line.style.width = this.j.container.clientWidth + "px");
                    }, t.prototype.onLock = function(e) {
                        e && this.isShown && this.hideForce();
                    }, t.prototype.hide = function() {
                        this.isShown && !this.lineInFocus && (this.timeout = this.j.async.setTimeout(this.hideForce, {
                            timeout: 500,
                            label: "add-new-line-hide"
                        }));
                    }, t.prototype.afterInit = function(e) {
                        var t = this;
                        e.o.addNewLine && (e.e.on(this.line, "mousemove", function(e) {
                            e.stopPropagation();
                        }).on(this.line, "mousedown touchstart", this.onClickLine).on("change", this.hideForce).on(this.line, "mouseenter", function() {
                            t.j.async.clearTimeout(t.timeout), t.lineInFocus = !0;
                        }).on(this.line, "mouseleave", function() {
                            t.lineInFocus = !1;
                        }).on("changePlace", this.addEventListeners.bind(this)), this.addEventListeners());
                    }, t.prototype.addEventListeners = function() {
                        var e = this.j;
                        e.e.off(e.editor, "." + l).off(e.container, "." + l).on([
                            e.ow,
                            e.ew,
                            e.editor
                        ], "scroll." + l, this.hideForce).on(e.editor, "click." + l, this.hide).on(e.container, "mouseleave." + l, this.hide).on(e.editor, "mousemove." + l, this.onMouseMove);
                    }, t.prototype.onDblClickEditor = function(e) {
                        var t = this.j;
                        if (!t.o.readonly && t.o.addNewLineOnDBLClick && e.target === t.editor && t.s.isCollapsed()) {
                            var o = (0, i.offset)(t.editor, t, t.ed), n = e.pageY - t.ew.pageYOffset, r = t.createInside.element(t.o.enter);
                            Math.abs(n - o.top) < Math.abs(n - (o.height + o.top)) && t.editor.firstChild ? t.editor.insertBefore(r, t.editor.firstChild) : t.editor.appendChild(r), t.s.setCursorIn(r), t.synchronizeValues(), this.hideForce(), e.preventDefault();
                        }
                    }, t.prototype.onMouseMove = function(e) {
                        var t = this.j, o = t.ed.elementFromPoint(e.clientX, e.clientY);
                        if (r.Dom.isHTMLElement(o) && !r.Dom.isOrContains(this.line, o) && r.Dom.isOrContains(t.editor, o)) {
                            if (t.editor === o || this.isMatchedTag(o) || (o = r.Dom.closest(o, this.isMatchedTag, t.editor)), o) {
                                if (this.isMatchedTag(o)) {
                                    var n = r.Dom.up(o, r.Dom.isBlock, t.editor);
                                    n && n !== t.editor && (o = n);
                                }
                                var a = (0, i.position)(o, this.j), s = !1, l = e.clientY, c = e.clientX;
                                if (this.j.iframe) {
                                    var u = (0, i.position)(this.j.iframe, this.j, !0);
                                    l += u.top, c += u.left;
                                }
                                var d = this.j.o.addNewLineDeltaShow;
                                Math.abs(l - a.top) > d || (s = a.top, this.preview = !0), Math.abs(l - (a.top + a.height)) > d || (s = a.top + a.height, this.preview = !1), !1 === s || (t.editor !== o || this.preview) && (0, i.call)(this.preview ? r.Dom.prev : r.Dom.next, o, this.canGetFocus, t.editor) ? (this.current = !1, this.hide()) : (this.line.style.top = s + "px", this.current = o, this.show(), this.line.style.setProperty("--jd-offset-handle", c - a.left - 10 + "px"));
                            } else this.hide();
                        }
                    }, t.prototype.beforeDestruct = function() {
                        this.j.async.clearTimeout(this.timeout), this.j.e.off(this.line).off("changePlace", this.addEventListeners), r.Dom.safeRemove(this.line), this.j.e.off([
                            this.j.ow,
                            this.j.ew,
                            this.j.editor
                        ], "." + l).off(this.j.container, "." + l);
                    }, n.__decorate([
                        (0, a.watch)(":lock")
                    ], t.prototype, "onLock", null), n.__decorate([
                        a.autobind
                    ], t.prototype, "hide", null), n.__decorate([
                        (0, a.watch)(":dblclick")
                    ], t.prototype, "onDblClickEditor", null), n.__decorate([
                        (0, a.debounce)(function(e) {
                            return 5 * e.defaultTimeout;
                        })
                    ], t.prototype, "onMouseMove", null), t;
                }(r.Plugin);
                t.addNewLine = c, s.pluginSystem.add("addNewLine", c);
            },
            46360: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(2074);
                n.Config.prototype.addNewLine = !0, n.Config.prototype.addNewLineOnDBLClick = !0, n.Config.prototype.addNewLineTagsTriggers = [
                    "table",
                    "iframe",
                    "img",
                    "hr",
                    "pre",
                    "jodit"
                ], n.Config.prototype.addNewLineDeltaShow = 20, r.Icon.set("enter", o(11257));
            },
            91241: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.backspace = void 0;
                var n = o(20255), r = o(57549), i = o(64968), a = o(86893), s = o(40332), l = o(10109), c = o(17332), u = o(90089), d = o(95441);
                o(48229);
                var p = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.requires = [
                            "hotkeys"
                        ], t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.e.on("afterCommand.delete", function(e) {
                            "delete" === e && t.afterDeleteCommand();
                        }), e.registerCommand("deleteButton", {
                            exec: function() {
                                return t.onDelete(!1);
                            },
                            hotkeys: e.o.delete.hotkeys.delete
                        }, {
                            stopPropagation: !1
                        }).registerCommand("backspaceButton", {
                            exec: function() {
                                return t.onDelete(!0);
                            },
                            hotkeys: e.o.delete.hotkeys.backspace
                        }, {
                            stopPropagation: !1
                        }).registerCommand("deleteWordButton", {
                            exec: function() {
                                return t.onDelete(!1, "word");
                            },
                            hotkeys: e.o.delete.hotkeys.deleteWord
                        }).registerCommand("backspaceWordButton", {
                            exec: function() {
                                return t.onDelete(!0, "word");
                            },
                            hotkeys: e.o.delete.hotkeys.backspaceWord
                        }).registerCommand("deleteSentenceButton", {
                            exec: function() {
                                return t.onDelete(!1, "sentence");
                            },
                            hotkeys: e.o.delete.hotkeys.deleteSentence
                        }).registerCommand("backspaceSentenceButton", {
                            exec: function() {
                                return t.onDelete(!0, "sentence");
                            },
                            hotkeys: e.o.delete.hotkeys.backspaceSentence
                        });
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off("afterCommand.delete");
                    }, t.prototype.afterDeleteCommand = function() {
                        var e = this.j, t = e.s.current();
                        if (t && i.Dom.isTag(t.firstChild, "br") && e.s.removeNode(t.firstChild), !((0, s.trim)(e.editor.textContent || "") || e.editor.querySelector("img,table,jodit,iframe,hr") || t && i.Dom.closest(t, "table", e.editor))) {
                            e.editor.innerHTML = "";
                            var o = e.s.setCursorIn(e.editor);
                            e.s.removeNode(o);
                        }
                    }, t.prototype.onDelete = function(e, t) {
                        void 0 === t && (t = "char");
                        var o = this.j, n = o.selection;
                        if (n.isFocused() || n.focus(), (0, d.checkNotCollapsed)(o)) return !1;
                        var r = n.range, c = o.createInside.text(a.INVISIBLE_SPACE);
                        try {
                            if (i.Dom.safeInsertNode(r, c), !i.Dom.isOrContains(o.editor, c)) return;
                            if (o.e.fire("backSpaceBeforeCases", e, c)) return !1;
                            if ((0, l.moveNodeInsideStart)(o, c, e), u.cases.some(function(n) {
                                if ((0, s.isFunction)(n) && n(o, c, e, t)) return !0;
                            })) return !1;
                        } catch (e) {
                            throw e;
                        } finally{
                            o.e.fire("backSpaceAfterDelete", e, c), this.safeRemoveEmptyNode(c);
                        }
                        return !1;
                    }, t.prototype.safeRemoveEmptyNode = function(e) {
                        var t, o, n = this.j.s.range;
                        n.startContainer === e && (e.previousSibling ? i.Dom.isText(e.previousSibling) ? n.setStart(e.previousSibling, null !== (o = null === (t = e.previousSibling.nodeValue) || void 0 === t ? void 0 : t.length) && void 0 !== o ? o : 0) : n.setStartAfter(e.previousSibling) : e.nextSibling && (i.Dom.isText(e.nextSibling) ? n.setStart(e.nextSibling, 0) : n.setStartBefore(e.nextSibling)), n.collapse(!0), this.j.s.selectRange(n)), i.Dom.safeRemove(e);
                    }, t;
                }(r.Plugin);
                t.backspace = p, c.pluginSystem.add("backspace", p);
            },
            31078: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkJoinNeighbors = void 0;
                var n = o(24263), r = o(30861);
                function i(e, t, o, i) {
                    if (t && n.Dom.isElement(o)) {
                        n.Dom.moveContent(t, o, !i, (0, r.getMoveFilter)(e));
                        for(var a = t; a && a !== e.editor && n.Dom.isEmpty(a);){
                            var s = a.parentElement;
                            n.Dom.safeRemove(a), a = s;
                        }
                        return !0;
                    }
                    return !1;
                }
                t.checkJoinNeighbors = function(e, t, o) {
                    for(var r = t, a = r; r && !n.Dom.findNotEmptySibling(r, o) && r.parentElement !== e.editor;)a = r = r.parentElement;
                    if (n.Dom.isElement(a) && n.Dom.isContentEditable(a, e.editor)) {
                        var s = n.Dom.findNotEmptySibling(a, o);
                        if (s && (function(e, t, o, r) {
                            var a = n.Dom.isTag(o, [
                                "ol",
                                "ul"
                            ]), s = n.Dom.isTag(t, [
                                "ol",
                                "ul"
                            ]), l = function(e, t) {
                                return t ? e.firstElementChild : e.lastElementChild;
                            };
                            return s ? (o = e.createInside.element(e.o.enterBlock), n.Dom.before(t, o), i(e, l(t, r), o, r)) : !(!o || !a || s) && i(e, t, l(o, !r), r);
                        }(e, a, s, o) || i(e, a, s, o))) return e.s.setCursorBefore(t), !0;
                    }
                    return !1;
                };
            },
            92156: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkJoinTwoLists = void 0;
                var n = o(24263), r = o(67309), i = o(30861);
                t.checkJoinTwoLists = function(e, t, o) {
                    var a = n.Dom.findSibling(t, o), s = n.Dom.findSibling(t, !o);
                    if (!n.Dom.closest(t, n.Dom.isElement, e.editor) && n.Dom.isTag(a, [
                        "ul",
                        "ol"
                    ]) && n.Dom.isTag(s, [
                        "ul",
                        "ol"
                    ]) && n.Dom.isTag(a.lastElementChild, "li") && n.Dom.isTag(s.firstElementChild, "li")) {
                        var l = e.s, c = l.setCursorBefore, u = l.setCursorAfter, d = a.lastElementChild;
                        return (0, r.call)(o ? n.Dom.prepend : n.Dom.append, s.firstElementChild, t), n.Dom.moveContent(s, a, !o, (0, i.getMoveFilter)(e)), n.Dom.safeRemove(s), (0, r.call)(o ? n.Dom.append : n.Dom.prepend, d, t), (0, r.call)(o ? c : u, t), !0;
                    }
                    return !1;
                };
            },
            95441: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkNotCollapsed = void 0, t.checkNotCollapsed = function(e) {
                    return !e.s.isCollapsed() && (e.execCommand("Delete"), !0);
                };
            },
            13116: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkRemoveChar = void 0;
                var n = o(64968), r = o(40332), i = o(86893), a = o(30861);
                t.checkRemoveChar = function e(t, o, s, l) {
                    var c, u, d, p, f = s ? -1 : 1, h = n.Dom.sibling(o, !s), m = n.Dom.sibling(o, s), v = null, g = !1, y = function(e) {
                        var o = n.Dom.sibling(e, s);
                        return !o && e.parentNode && e.parentNode !== t.editor && (o = (0, a.findMostNestedNeighbor)(e, !s, t.editor, !0)), o;
                    };
                    for(m || (m = y(o)); m && (n.Dom.isText(m) || n.Dom.isInlineBlock(m));){
                        for(; n.Dom.isInlineBlock(m);)m = s ? null == m ? void 0 : m.lastChild : null == m ? void 0 : m.firstChild;
                        if (!m) break;
                        if (null === (c = m.nodeValue) || void 0 === c ? void 0 : c.length) {
                            var _ = (0, r.toArray)(m.nodeValue), b = _.length, w = s ? b - 1 : 0;
                            if (_[w] === i.INVISIBLE_SPACE) for(; _[w] === i.INVISIBLE_SPACE;)w += f;
                            if (p = _[w], _[w + f] === i.INVISIBLE_SPACE) {
                                for(w += f; _[w] === i.INVISIBLE_SPACE;)w += f;
                                w += s ? 1 : -1;
                            }
                            if (_ = s && 0 > w ? [] : _.slice(s ? 0 : w + 1, s ? w : b), !h || !n.Dom.isText(h) || (s ? /^ / : / $/).test(null !== (u = h.nodeValue) && void 0 !== u ? u : "") || !(0, r.trimInv)(h.nodeValue || "").length) for(var S = s ? _.length - 1 : 0; (s ? S >= 0 : _.length > S) && " " === _[S]; S += s ? -1 : 1)_[S] = i.NBSP_SPACE;
                            m.nodeValue = _.join("");
                        }
                        if ((null === (d = m.nodeValue) || void 0 === d ? void 0 : d.length) || (v = m), !(0, r.isVoid)(p) && p !== i.INVISIBLE_SPACE) {
                            g = !0, (0, r.call)(s ? n.Dom.after : n.Dom.before, m, o), ("sentence" === l || "word" === l && " " !== p && p !== i.NBSP_SPACE) && e(t, o, s, l);
                            break;
                        }
                        var C = y(m);
                        v && (n.Dom.safeRemove(v), v = null), m = C;
                    }
                    return v && (n.Dom.safeRemove(v), v = null), g && (function(e, t) {
                        for(var o = e.parentElement; o && n.Dom.isInlineBlock(o) && n.Dom.isTag(o, t);){
                            var r = o.parentElement;
                            n.Dom.isEmpty(o) && (n.Dom.after(o, e), n.Dom.safeRemove(o)), o = r;
                        }
                    }(o, [
                        "a"
                    ]), function(e, t) {
                        t.parentElement !== e.editor && n.Dom.isBlock(t.parentElement) && n.Dom.each(t.parentElement, n.Dom.isEmptyTextNode) && n.Dom.after(t, e.createInside.element("br"));
                    }(t, o), t.s.setCursorBefore(o), n.Dom.isTag(o.previousSibling, "br") && !n.Dom.findNotEmptySibling(o, !1) && n.Dom.after(o, t.createInside.element("br"))), g;
                };
            },
            74217: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkRemoveContentNotEditable = void 0;
                var n = o(64968), r = o(40332), i = o(10109);
                t.checkRemoveContentNotEditable = function(e, t, o) {
                    var a = n.Dom.findSibling(t, o);
                    return !a && t.parentElement && t.parentElement !== e.editor && (a = n.Dom.findSibling(t.parentElement, o)), !(!n.Dom.isElement(a) || n.Dom.isContentEditable(a, e.editor) || ((0, r.call)(o ? n.Dom.before : n.Dom.after, a, t), n.Dom.safeRemove(a), (0, i.moveNodeInsideStart)(e, t, o), (0, r.call)(o ? e.s.setCursorBefore : e.s.setCursorAfter, t), 0));
                };
            },
            34181: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkRemoveEmptyNeighbor = void 0;
                var n = o(24263);
                t.checkRemoveEmptyNeighbor = function(e, t, o) {
                    var r = n.Dom.closest(t, n.Dom.isElement, e.editor);
                    if (!r) return !1;
                    var i = n.Dom.findNotEmptySibling(r, o);
                    return !(!i || !n.Dom.isEmpty(i) || (n.Dom.safeRemove(i), e.s.setCursorBefore(t), 0));
                };
            },
            13890: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkRemoveEmptyParent = void 0;
                var n = o(64968), r = o(86893), i = o(92156);
                t.checkRemoveEmptyParent = function(e, t, o) {
                    var a = !1, s = e.s, l = s.setCursorBefore, c = s.setCursorIn, u = n.Dom.closest(t, n.Dom.isElement, e.editor);
                    if (!u || !n.Dom.isEmpty(u)) return !1;
                    var d = n.Dom.findNotEmptyNeighbor(t, o, e.editor);
                    do {
                        if (!u || !n.Dom.isEmpty(u) || n.Dom.isCell(u)) break;
                        n.Dom.after(u, t);
                        var p = n.Dom.closest(u, function(e) {
                            return n.Dom.isElement(e) && e !== u;
                        }, e.editor);
                        n.Dom.safeRemove(u), a = !0, u = p;
                    }while (u);
                    return !(!a || !(0, i.checkJoinTwoLists)(e, t, o)) || (!d || n.Dom.isText(d) || n.Dom.isTag(d, r.INSEPARABLE_TAGS) ? l(t) : c(d, !o), a);
                };
            },
            8249: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkRemoveUnbreakableElement = void 0;
                var n = o(24263), r = o(86893), i = o(13890);
                t.checkRemoveUnbreakableElement = function(e, t, o) {
                    var a = n.Dom.findSibling(t, o);
                    return !(!n.Dom.isElement(a) || !n.Dom.isTag(a, r.INSEPARABLE_TAGS) && !n.Dom.isEmpty(a) || (n.Dom.safeRemove(a), n.Dom.isTag(a, "br") && !n.Dom.findNotEmptySibling(t, !1) && n.Dom.after(t, e.createInside.element("br")), e.s.setCursorBefore(t), n.Dom.isTag(a, "br") && (0, i.checkRemoveEmptyParent)(e, t, o), 0));
                };
            },
            58368: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkTableCell = void 0;
                var n = o(24263);
                t.checkTableCell = function(e, t) {
                    return !!n.Dom.isCell(t.parentElement);
                };
            },
            6028: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkUnwrapFirstListItem = void 0;
                var n = o(24263), r = o(76502);
                t.checkUnwrapFirstListItem = function(e, t, o) {
                    var i, a = n.Dom.closest(t, n.Dom.isElement, e.editor), s = e.s;
                    if (n.Dom.isTag(a, "li") && (null === (i = null == a ? void 0 : a.parentElement) || void 0 === i ? void 0 : i[o ? "firstElementChild" : "lastElementChild"]) === a && s.cursorInTheEdge(o, a)) {
                        var l = a.parentElement, c = e.createInside.element(e.o.enterBlock);
                        return (0, r.call)(o ? n.Dom.before : n.Dom.after, l, c), n.Dom.moveContent(a, c), n.Dom.safeRemove(a), n.Dom.isEmpty(l) && n.Dom.safeRemove(l), (0, r.call)(o ? s.setCursorBefore : s.setCursorAfter, t), !0;
                    }
                    return !1;
                };
            },
            90089: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.cases = void 0;
                var n = o(8249), r = o(74217), i = o(13116), a = o(58368), s = o(13890), l = o(34181), c = o(92156), u = o(31078), d = o(6028);
                t.cases = [
                    n.checkRemoveUnbreakableElement,
                    r.checkRemoveContentNotEditable,
                    i.checkRemoveChar,
                    a.checkTableCell,
                    s.checkRemoveEmptyParent,
                    l.checkRemoveEmptyNeighbor,
                    c.checkJoinTwoLists,
                    u.checkJoinNeighbors,
                    d.checkUnwrapFirstListItem
                ];
            },
            48229: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.delete = {
                    hotkeys: {
                        delete: [
                            "delete",
                            "cmd+backspace"
                        ],
                        deleteWord: [
                            "ctrl+delete",
                            "cmd+alt+backspace",
                            "ctrl+alt+backspace"
                        ],
                        deleteSentence: [
                            "ctrl+shift+delete",
                            "cmd+shift+delete"
                        ],
                        backspace: [
                            "backspace"
                        ],
                        backspaceWord: [
                            "ctrl+backspace"
                        ],
                        backspaceSentence: [
                            "ctrl+shift+backspace",
                            "cmd+shift+backspace"
                        ]
                    }
                };
            },
            30861: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getMoveFilter = t.findMostNestedNeighbor = void 0;
                var n = o(64968);
                t.findMostNestedNeighbor = function(e, t, o, r) {
                    void 0 === r && (r = !1);
                    var i = function(e) {
                        return t ? e.firstChild : e.lastChild;
                    }, a = n.Dom.findNotEmptyNeighbor(e, !t, o);
                    if (r && n.Dom.isElement(a) && !n.Dom.isInlineBlock(a)) return null;
                    if (a) do {
                        if (!i(a)) return a;
                        a = i(a);
                    }while (a);
                    return null;
                }, t.getMoveFilter = function(e) {
                    return function(t) {
                        return !0 !== e.e.fire("backSpaceIsMovedIgnore", t);
                    };
                };
            },
            87565: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.bold = void 0;
                var n = o(20255), r = o(93166), i = o(40332), a = o(17332), s = o(77904);
                function l(e) {
                    var t = function(t) {
                        var o, a = r.Config.defaultOptions.controls[t], s = n.__assign({}, a.css);
                        return Object.keys(s).forEach(function(e) {
                            o || (o = {}), o[e] = (0, i.isArray)(s[e]) ? s[e][0] : s[e];
                        }), e.s.applyStyle(o, {
                            element: a.tags ? a.tags[0] : void 0
                        }), e.synchronizeValues(), !1;
                    };
                    [
                        "bold",
                        "italic",
                        "underline",
                        "strikethrough"
                    ].forEach(function(t) {
                        e.registerButton({
                            name: t,
                            group: "font-style"
                        });
                    }), [
                        "superscript",
                        "subscript"
                    ].forEach(function(t) {
                        e.registerButton({
                            name: t,
                            group: "script"
                        });
                    }), e.registerCommand("bold", {
                        exec: t,
                        hotkeys: [
                            "ctrl+b",
                            "cmd+b"
                        ]
                    }).registerCommand("italic", {
                        exec: t,
                        hotkeys: [
                            "ctrl+i",
                            "cmd+i"
                        ]
                    }).registerCommand("underline", {
                        exec: t,
                        hotkeys: [
                            "ctrl+u",
                            "cmd+u"
                        ]
                    }).registerCommand("strikethrough", {
                        exec: t
                    }).registerCommand("subscript", {
                        exec: t
                    }).registerCommand("superscript", {
                        exec: t
                    });
                }
                o(58334), o(90740), t.bold = l, a.pluginSystem.add("bold", l), s.Icon.set("bold", o(25141)).set("italic", o(24557)).set("strikethrough", o(10859)).set("subscript", o(9813)).set("superscript", o(93395)).set("underline", o(98213));
            },
            90740: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.controls.subscript = {
                    tags: [
                        "sub"
                    ],
                    tooltip: "subscript"
                }, n.Config.prototype.controls.superscript = {
                    tags: [
                        "sup"
                    ],
                    tooltip: "superscript"
                }, n.Config.prototype.controls.bold = {
                    tagRegExp: /^(strong|b)$/i,
                    tags: [
                        "strong",
                        "b"
                    ],
                    css: {
                        "font-weight": [
                            "bold",
                            "700"
                        ]
                    },
                    tooltip: "Bold"
                }, n.Config.prototype.controls.italic = {
                    tagRegExp: /^(em|i)$/i,
                    tags: [
                        "em",
                        "i"
                    ],
                    css: {
                        "font-style": "italic"
                    },
                    tooltip: "Italic"
                }, n.Config.prototype.controls.underline = {
                    tagRegExp: /^(u)$/i,
                    tags: [
                        "u"
                    ],
                    css: {
                        "text-decoration-line": "underline"
                    },
                    tooltip: "Underline"
                }, n.Config.prototype.controls.strikethrough = {
                    tagRegExp: /^(s)$/i,
                    tags: [
                        "s"
                    ],
                    css: {
                        "text-decoration-line": "line-through"
                    },
                    tooltip: "Strike through"
                };
            },
            58334: function() {},
            60894: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.classSpan = void 0;
                var n = o(20255), r = o(57549), i = o(93166), a = o(64968), s = o(40332), l = o(17332), c = o(2074);
                i.Config.prototype.controls.classSpan = {
                    command: "applyClassName",
                    exec: s.memorizeExec,
                    list: [
                        "enabled",
                        "disabled",
                        "activated",
                        "text-left",
                        "text-center",
                        "text-right",
                        "warning",
                        "error"
                    ],
                    isChildActive: function(e, t) {
                        var o = e.s.current();
                        if (o) {
                            var n = a.Dom.closest(o, a.Dom.isElement, e.editor) || e.editor;
                            return Boolean(t.args && n.classList.contains(t.args[0].toString()));
                        }
                        return !1;
                    },
                    isActive: function(e, t) {
                        var o = e.s.current();
                        if (o) {
                            var n = a.Dom.closest(o, a.Dom.isElement, e.editor) || e.editor, r = !1;
                            return t.list && Object.keys(t.list).forEach(function(e) {
                                n.classList.contains(e) && (r = !0);
                            }), Boolean(n && n !== e.editor && void 0 !== t.list && r);
                        }
                        return !1;
                    },
                    childTemplate: function(e, t, o) {
                        return '<span class="'.concat(t, '">').concat(e.i18n(o), "</span>");
                    },
                    tooltip: "Insert className"
                };
                var u = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.buttons = [
                            {
                                name: "classSpan",
                                group: "font"
                            }
                        ], t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        e.registerCommand("applyClassName", function(t, o, n) {
                            return e.s.applyStyle(void 0, {
                                className: n
                            }), !1;
                        });
                    }, t.prototype.beforeDestruct = function() {}, t;
                }(r.Plugin);
                t.classSpan = u, l.pluginSystem.add("classSpan", u), c.Icon.set("class-span", o(20026));
            },
            90302: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.cleanHtml = void 0;
                var n = o(20255), r = o(67128), i = o(85605), a = o(43441), s = o(33841), l = o(17332), c = o(24263), u = o(57713);
                o(98889);
                var d = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.buttons = [
                            {
                                name: "eraser",
                                group: "font-style"
                            }
                        ], t.currentSelectionNode = null, t.walker = new s.LazyWalker(t.j.async, {
                            timeout: t.j.o.cleanHTML.timeout
                        }), t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {}, Object.defineProperty(t.prototype, "isEditMode", {
                        get: function() {
                            return !(this.j.isInDestruct || !this.j.isEditorMode() || this.j.getReadOnly());
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.onChangeCleanHTML = function() {
                        if (this.isEditMode) {
                            var e = this.j;
                            this.walker.setWork(e.editor), this.currentSelectionNode = e.s.current();
                        }
                    }, t.prototype.startWalker = function() {
                        var e = this, t = this.jodit, o = (0, u.getHash)(this.j.o.cleanHTML.allowTags), n = (0, u.getHash)(this.j.o.cleanHTML.denyTags);
                        this.walker.on("visit", function(r) {
                            return (0, u.visitNodeWalker)(t, r, o, n, e.currentSelectionNode);
                        }).on("end", function(t) {
                            e.j.e.fire(t ? "internalChange finishedCleanHTMLWorker" : "finishedCleanHTMLWorker");
                        });
                    }, t.prototype.beforeCommand = function(e) {
                        if ("removeformat" === e.toLowerCase()) return this.j.s.isCollapsed() ? (0, u.removeFormatForCollapsedSelection)(this.j) : (0, u.removeFormatForSelection)(this.j), !1;
                    }, t.prototype.onBeforeSetNativeEditorValue = function(e) {
                        var t = this.j.o.cleanHTML.useIframeSandbox ? this.j.createInside.sandbox() : this.j.createInside.div();
                        return t.innerHTML = e.value, this.onSafeHTML(t), e.value = t.innerHTML, (0, r.safeHTML)(t, {
                            safeJavaScriptLink: !0,
                            removeOnError: !0
                        }), c.Dom.safeRemove(t), !1;
                    }, t.prototype.onSafeHTML = function(e) {
                        (0, r.safeHTML)(e, this.j.o.cleanHTML);
                    }, t.prototype.beforeDestruct = function() {
                        this.walker.destruct();
                    }, n.__decorate([
                        (0, a.watch)([
                            ":change",
                            ":afterSetMode",
                            ":afterInit",
                            ":mousedown",
                            ":keydown"
                        ])
                    ], t.prototype, "onChangeCleanHTML", null), n.__decorate([
                        (0, a.hook)("ready")
                    ], t.prototype, "startWalker", null), n.__decorate([
                        (0, a.watch)(":beforeCommand")
                    ], t.prototype, "beforeCommand", null), n.__decorate([
                        (0, a.watch)(":beforeSetNativeEditorValue")
                    ], t.prototype, "onBeforeSetNativeEditorValue", null), n.__decorate([
                        (0, a.watch)(":safeHTML")
                    ], t.prototype, "onSafeHTML", null), t;
                }(i.Plugin);
                t.cleanHtml = d, l.pluginSystem.add("cleanHtml", d);
            },
            98889: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(77904);
                n.Config.prototype.cleanHTML = {
                    timeout: 300,
                    removeEmptyElements: !0,
                    fillEmptyParagraph: !0,
                    replaceNBSP: !0,
                    replaceOldTags: {
                        i: "em",
                        b: "strong"
                    },
                    allowTags: !1,
                    denyTags: "script",
                    useIframeSandbox: !1,
                    removeOnError: !0,
                    safeJavaScriptLink: !0,
                    disableCleanFilter: null
                }, n.Config.prototype.controls.eraser = {
                    command: "removeFormat",
                    tooltip: "Clear Formatting"
                }, r.Icon.set("eraser", o(66911));
            },
            38655: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getHash = void 0;
                var n = o(33941), r = o(24421);
                t.getHash = function(e) {
                    var t = /([^[]*)\[([^\]]+)]/, o = /[\s]*,[\s]*/, i = /^(.*)[\s]*=[\s]*(.*)$/, a = {};
                    return (0, r.isString)(e) ? (e.split(o).map(function(e) {
                        e = (0, n.trim)(e);
                        var r = t.exec(e), s = {};
                        if (r) {
                            var l = r[2].split(o);
                            r[1] && (l.forEach(function(e) {
                                e = (0, n.trim)(e);
                                var t = i.exec(e);
                                t ? s[t[1]] = t[2] : s[e] = !0;
                            }), a[r[1].toUpperCase()] = s);
                        } else a[e.toUpperCase()] = !0;
                    }), a) : !!e && (Object.keys(e).forEach(function(t) {
                        a[t.toUpperCase()] = e[t];
                    }), a);
                };
            },
            57713: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(38655), t), n.__exportStar(o(72170), t), n.__exportStar(o(87783), t), n.__exportStar(o(88972), t);
            },
            72170: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isInlineBlock = t.removeFormatForCollapsedSelection = void 0;
                var n = o(24263), r = o(86893);
                function i(e) {
                    return n.Dom.isInlineBlock(e) && !n.Dom.isTag(e, r.INSEPARABLE_TAGS);
                }
                t.removeFormatForCollapsedSelection = function(e, t) {
                    var o = e.s, r = t;
                    if (!r) {
                        r = e.createInside.fake();
                        var a = o.range;
                        n.Dom.safeInsertNode(a, r), a.collapse();
                    }
                    var s = n.Dom.furthest(r, i, e.editor);
                    if (s) {
                        if (o.cursorOnTheLeft(s)) n.Dom.before(s, r);
                        else if (o.cursorOnTheRight(s)) n.Dom.after(s, r);
                        else {
                            var l = o.splitSelection(s);
                            l && n.Dom.after(l, r);
                        }
                    }
                    t || (o.setCursorBefore(r), n.Dom.safeRemove(r));
                }, t.isInlineBlock = i;
            },
            87783: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.removeFormatForSelection = void 0;
                var n = o(24263), r = o(76502), i = o(72170);
                t.removeFormatForSelection = function(e) {
                    var t = e.s, o = e.editor, a = e.createInside, s = t.range, l = s.cloneRange(), c = s.cloneRange(), u = a.fake(), d = a.fake();
                    l.collapse(!0), c.collapse(!1), n.Dom.safeInsertNode(l, u), n.Dom.safeInsertNode(c, d), s.setStartBefore(u), s.collapse(!0), t.selectRange(s), (0, i.removeFormatForCollapsedSelection)(e, u), s.setEndAfter(d), s.collapse(!1), t.selectRange(s), (0, i.removeFormatForCollapsedSelection)(e, d);
                    var p = [];
                    n.Dom.between(u, d, function(e) {
                        (0, i.isInlineBlock)(e) && !n.Dom.isTag(e, [
                            "a"
                        ]) && p.push(e), n.Dom.isElement(e) && (0, r.attr)(e, "style") && (0, r.attr)(e, "style", null);
                    }), p.forEach(function(e) {
                        return n.Dom.unwrap(e);
                    });
                    var f = function(e, t) {
                        if (!n.Dom.findNotEmptySibling(e, t)) {
                            var i = e.parentNode;
                            if (i && i !== o && (0, r.attr)(i, "style")) return (0, r.attr)(i, "style", null), f(i, t), !0;
                        }
                    };
                    f(u, !0) && f(d, !1), s.setStartAfter(u), s.setEndBefore(d), t.selectRange(s), n.Dom.safeRemove(u), n.Dom.safeRemove(d);
                };
            },
            9948: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.allowAttributes = void 0;
                var n = o(24263);
                t.allowAttributes = function(e, t, o, r) {
                    if (r && n.Dom.isElement(t) && !0 !== r[t.nodeName]) {
                        var i = t.attributes;
                        if (i && i.length) {
                            for(var a = [], s = 0; i.length > s; s += 1){
                                var l = r[t.nodeName][i[s].name];
                                (!l || !0 !== l && l !== i[s].value) && a.push(i[s].name);
                            }
                            a.length && (o = !0), a.forEach(function(e) {
                                t.removeAttribute(e);
                            });
                        }
                    }
                    return o;
                };
            },
            74722: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.fillEmptyParagraph = void 0;
                var n = o(24263), r = o(86893);
                t.fillEmptyParagraph = function(e, t, o) {
                    if (e.o.cleanHTML.fillEmptyParagraph && n.Dom.isBlock(t) && n.Dom.isEmpty(t, r.INSEPARABLE_TAGS)) {
                        var i = e.createInside.element("br");
                        return t.appendChild(i), !0;
                    }
                    return o;
                };
            },
            2549: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(55901), t), n.__exportStar(o(9948), t), n.__exportStar(o(74722), t), n.__exportStar(o(75096), t), n.__exportStar(o(28194), t), n.__exportStar(o(94254), t), n.__exportStar(o(64701), t);
            },
            28194: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.removeEmptyTextNode = void 0;
                var n = o(24263);
                t.removeEmptyTextNode = function(e, t, o, r, i, a) {
                    return n.Dom.isText(t) && !t.nodeValue ? (t === a && e.s.isCollapsed() && e.s.setCursorAfter(t), n.Dom.safeRemove(t), !0) : o;
                };
            },
            94254: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.removeInvTextNodes = void 0;
                var n = o(86893), r = o(24263);
                t.removeInvTextNodes = function(e, t, o, i, a, s) {
                    return s !== t && r.Dom.isText(t) && null != t.nodeValue && (0, n.INVISIBLE_SPACE_REG_EXP)().test(t.nodeValue) ? (t.nodeValue = t.nodeValue.replace((0, n.INVISIBLE_SPACE_REG_EXP)(), ""), t === s && e.s.isCollapsed() && e.s.setCursorAfter(t), t.nodeValue || r.Dom.safeRemove(t), !0) : o;
                };
            },
            55901: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.replaceOldTags = void 0;
                var n = o(24263);
                t.replaceOldTags = function(e, t, o) {
                    var r = function(e, t, o) {
                        if (!o || !n.Dom.isHTMLElement(t)) return t;
                        var r = o[t.nodeName.toLowerCase()] || o[t.nodeName];
                        return r ? n.Dom.replace(t, r, e.createInside, !0, !1) : t;
                    }(e, t, e.o.cleanHTML.replaceOldTags);
                    return t !== r ? (t = r, !0) : o;
                };
            },
            64701: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sanitizeAttributes = void 0;
                var n = o(24263), r = o(40332);
                t.sanitizeAttributes = function(e, t, o) {
                    return !(!n.Dom.isElement(t) || !(0, r.sanitizeHTMLElement)(t, {
                        safeJavaScriptLink: e.options.cleanHTML.safeJavaScriptLink,
                        removeOnError: e.options.cleanHTML.removeOnError
                    })) || o;
                };
            },
            75096: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.tryRemoveNode = void 0;
                var n = o(24263), r = o(86893), i = o(33941);
                t.tryRemoveNode = function(e, t, o, a, s, l) {
                    return function(e, t, o, a, s) {
                        return !(n.Dom.isText(t) || !(a && !a[t.nodeName] || s && s[t.nodeName])) || e.o.cleanHTML.removeEmptyElements && n.Dom.isElement(t) && null != t.nodeName.match(r.IS_INLINE) && !n.Dom.isTemporary(t) && 0 === (0, i.trim)(t.innerHTML).length && (null == o || !n.Dom.isOrContains(t, o));
                    }(e, t, l, a, s) ? (n.Dom.safeRemove(t), !0) : o;
                };
            },
            88972: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.visitNodeWalker = void 0;
                var n = o(20255), r = o(2549), i = Object.keys(r);
                t.visitNodeWalker = function(e, t, o, a, s) {
                    var l, c, u = !1, d = e.o.cleanHTML.disableCleanFilter;
                    try {
                        for(var p = n.__values(i), f = p.next(); !f.done; f = p.next()){
                            var h = f.value;
                            if (!(d && d.has(h) || (u = (0, r[h])(e, t, u, o, a, s), t.isConnected))) return !0;
                        }
                    } catch (e) {
                        l = {
                            error: e
                        };
                    } finally{
                        try {
                            f && !f.done && (c = p.return) && c.call(p);
                        } finally{
                            if (l) throw l.error;
                        }
                    }
                    return u;
                };
            },
            92138: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.clipboard = void 0;
                var n = o(86893), r = o(40332), i = o(17332);
                o(31473);
                var a = function() {
                    function e() {
                        this.buttons = [
                            {
                                name: "cut",
                                group: "clipboard"
                            },
                            {
                                name: "copy",
                                group: "clipboard"
                            },
                            {
                                name: "paste",
                                group: "clipboard"
                            },
                            {
                                name: "selectall",
                                group: "clipboard"
                            }
                        ];
                    }
                    return e.prototype.init = function(e) {
                        var t;
                        null === (t = this.buttons) || void 0 === t || t.forEach(function(t) {
                            return e.registerButton(t);
                        }), e.e.off("copy.".concat(n.CLIPBOARD_ID, " cut.").concat(n.CLIPBOARD_ID)).on("copy.".concat(n.CLIPBOARD_ID, " cut.").concat(n.CLIPBOARD_ID), function(t) {
                            var o, i = e.s.html, a = (0, r.getDataTransfer)(t) || (0, r.getDataTransfer)(e.ew) || (0, r.getDataTransfer)(t.originalEvent);
                            a && (a.setData(n.TEXT_PLAIN, (0, r.stripTags)(i)), a.setData(n.TEXT_HTML, i)), e.buffer.set(n.CLIPBOARD_ID, i), e.e.fire("pasteStack", {
                                html: i,
                                action: e.o.defaultActionOnPaste || n.INSERT_AS_HTML
                            }), "cut" === t.type && (e.s.remove(), e.s.focus()), t.preventDefault(), null === (o = null == e ? void 0 : e.events) || void 0 === o || o.fire("afterCopy", i);
                        });
                    }, e.prototype.destruct = function(e) {
                        var t, o;
                        null === (t = null == e ? void 0 : e.buffer) || void 0 === t || t.set(n.CLIPBOARD_ID, ""), null === (o = null == e ? void 0 : e.events) || void 0 === o || o.off("." + n.CLIPBOARD_ID);
                    }, e;
                }();
                t.clipboard = a, i.pluginSystem.add("clipboard", a);
            },
            31473: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(77904);
                n.Config.prototype.controls.cut = {
                    command: "cut",
                    isDisabled: function(e) {
                        return e.s.isCollapsed();
                    },
                    tooltip: "Cut selection"
                }, n.Config.prototype.controls.copy = {
                    command: "copy",
                    isDisabled: function(e) {
                        return e.s.isCollapsed();
                    },
                    tooltip: "Copy selection"
                }, n.Config.prototype.controls.selectall = {
                    icon: "select-all",
                    command: "selectall",
                    tooltip: "Select all"
                }, r.Icon.set("copy", o(50018)).set("cut", o(99738)).set("paste", o(9185)).set("select-all", o(8619));
            },
            88412: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.color = void 0;
                var n = o(40332), r = o(17332);
                function i(e) {
                    e.registerButton({
                        name: "brush",
                        group: "color"
                    });
                    var t = function(t, o, r) {
                        var i = (0, n.normalizeColor)(r);
                        switch(t){
                            case "background":
                                e.s.applyStyle({
                                    backgroundColor: i || ""
                                });
                                break;
                            case "forecolor":
                                e.s.applyStyle({
                                    color: i || ""
                                });
                        }
                        return e.synchronizeValues(), !1;
                    };
                    e.registerCommand("forecolor", t).registerCommand("background", t);
                }
                o(21924), t.color = i, r.pluginSystem.add("color", i);
            },
            21924: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(40332), i = o(718), a = o(77904), s = o(24263);
                a.Icon.set("brush", o(73894)), n.Config.prototype.controls.brush = {
                    update: function(e, t) {
                        var o = (0, r.dataBind)(e, "color"), n = function(o, n) {
                            n && n !== (0, r.css)(t.editor, o).toString() && (e.state.icon.fill = n);
                        };
                        if (o) {
                            var i = (0, r.dataBind)(e, "color");
                            n("color" === i ? i : "background-color", o);
                        } else {
                            var a = t.s.current();
                            if (a && !e.state.disabled) {
                                var l = s.Dom.closest(a, s.Dom.isElement, t.editor) || t.editor;
                                n("color", (0, r.css)(l, "color").toString()), n("background-color", (0, r.css)(l, "background-color").toString());
                            }
                            e.state.icon.fill = "", e.state.activated = !1;
                        }
                    },
                    popup: function(e, t, o, n, a) {
                        var l = "", c = "", u = [], d = null;
                        return t && t !== e.editor && s.Dom.isNode(t) && (s.Dom.isElement(t) && e.s.isCollapsed() && !s.Dom.isTag(t, [
                            "br",
                            "hr"
                        ]) && (d = t), s.Dom.up(t, function(e) {
                            if (s.Dom.isHTMLElement(e)) {
                                var t = (0, r.css)(e, "color", !0), o = (0, r.css)(e, "background-color", !0);
                                if (t) return l = t.toString(), !0;
                                if (o) return c = o.toString(), !0;
                            }
                        }, e.editor)), u = [
                            {
                                name: "Background",
                                content: (0, i.ColorPickerWidget)(e, function(t) {
                                    d ? d.style.backgroundColor = t : e.execCommand("background", !1, t), (0, r.dataBind)(a, "color", t), (0, r.dataBind)(a, "color-mode", "background"), n();
                                }, c)
                            },
                            {
                                name: "Text",
                                content: (0, i.ColorPickerWidget)(e, function(t) {
                                    d ? d.style.color = t : e.execCommand("forecolor", !1, t), (0, r.dataBind)(a, "color", t), (0, r.dataBind)(a, "color-mode", "color"), n();
                                }, l)
                            }
                        ], "background" !== e.o.colorPickerDefaultTab && (u = u.reverse()), (0, i.TabsWidget)(e, u, d);
                    },
                    exec: function(e, t, o) {
                        var n = o.button, i = (0, r.dataBind)(n, "color-mode"), a = (0, r.dataBind)(n, "color");
                        if (!i) return !1;
                        if (t && t !== e.editor && s.Dom.isNode(t) && s.Dom.isElement(t)) switch(i){
                            case "color":
                                t.style.color = a;
                                break;
                            case "background":
                                t.style.backgroundColor = a;
                        }
                        else e.execCommand("background" === i ? i : "forecolor", !1, a);
                    },
                    tooltip: "Fill color or set the text color"
                };
            },
            79308: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.copyFormat = void 0;
                var n = o(93166), r = o(24263), i = o(26911), a = o(17332), s = o(77904), l = "copy-format", c = [
                    "fontWeight",
                    "fontStyle",
                    "fontSize",
                    "color",
                    "margin",
                    "padding",
                    "borderWidth",
                    "borderStyle",
                    "borderColor",
                    "borderRadius",
                    "backgroundColor",
                    "textDecorationLine",
                    "fontFamily"
                ], u = function(e, t, o, n) {
                    var r = (0, i.css)(o, t);
                    return r === n[t] && (r = o.parentNode && o !== e.editor && o.parentNode !== e.editor ? u(e, t, o.parentNode, n) : void 0), r;
                };
                function d(e) {
                    e.registerButton({
                        name: "copyformat",
                        group: "clipboard"
                    }), (0, a.extendLang)(o(9188));
                }
                n.Config.prototype.controls.copyformat = {
                    exec: function(e, t, o) {
                        var n = o.button;
                        if (t) {
                            if (e.buffer.exists(l)) e.buffer.delete(l), e.e.off(e.editor, "mouseup." + l);
                            else {
                                var a = {}, s = r.Dom.up(t, function(e) {
                                    return e && !r.Dom.isText(e);
                                }, e.editor) || e.editor, d = e.createInside.span();
                                e.editor.appendChild(d), c.forEach(function(e) {
                                    a[e] = (0, i.css)(d, e);
                                }), d !== e.editor && r.Dom.safeRemove(d);
                                var p = function(e, t, o) {
                                    var n = {};
                                    return t && c.forEach(function(r) {
                                        n[r] = u(e, r, t, o), r.match(/border(Style|Color)/) && !n.borderWidth && (n[r] = void 0);
                                    }), n;
                                }(e, s, a);
                                e.e.on(e.editor, "mouseup." + l, function() {
                                    e.buffer.delete(l);
                                    var t = e.s.current();
                                    t && (r.Dom.isTag(t, "img") ? (0, i.css)(t, p) : e.s.applyStyle(p)), e.e.off(e.editor, "mouseup." + l);
                                }), e.buffer.set(l, !0);
                            }
                            n.update();
                        }
                    },
                    isActive: function(e) {
                        return e.buffer.exists(l);
                    },
                    tooltip: "Paint format"
                }, t.copyFormat = d, a.pluginSystem.add("copyformat", d), s.Icon.set("copyformat", o(83301));
            },
            9188: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
                var n = o(80078);
                t.ar = n;
                var r = o(16986);
                t.cs_cz = r;
                var i = o(59347);
                t.de = i;
                var a = o(63640);
                t.es = a;
                var s = o(53434);
                t.fa = s;
                var l = o(85638);
                t.fr = l;
                var c = o(31743);
                t.he = c;
                var u = o(66219);
                t.hu = u;
                var d = o(50331);
                t.id = d;
                var p = o(25582);
                t.it = p;
                var f = o(82066);
                t.ja = f;
                var h = o(71925);
                t.ko = h;
                var m = o(12689);
                t.mn = m;
                var v = o(65274);
                t.nl = v;
                var g = o(58548);
                t.pl = g;
                var y = o(82958);
                t.pt_br = y;
                var _ = o(52315);
                t.ru = _;
                var b = o(87727);
                t.tr = b;
                var w = o(9396);
                t.zh_cn = w;
                var S = o(28765);
                t.zh_tw = S;
            },
            9412: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.draggableTags = [
                    "img",
                    "jodit-media",
                    "jodit"
                ];
            },
            30598: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.dragAndDropElement = void 0;
                var n, r = o(20255), i = o(40332), a = o(57549), s = o(64968), l = o(17332), c = o(43441);
                o(9412), function(e) {
                    e[e.IDLE = 0] = "IDLE", e[e.WAIT_DRAGGING = 1] = "WAIT_DRAGGING", e[e.DRAGGING = 2] = "DRAGGING";
                }(n || (n = {}));
                var u = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.dragList = [], t.draggable = null, t.isCopyMode = !1, t.diffStep = 10, t.startX = 0, t.startY = 0, t.state = n.IDLE, t;
                    }
                    return r.__extends(t, e), t.prototype.afterInit = function() {
                        this.dragList = this.j.o.draggableTags ? (0, i.splitArray)(this.j.o.draggableTags).filter(Boolean).map(function(e) {
                            return e.toLowerCase();
                        }) : [], this.dragList.length && this.j.e.on("mousedown dragstart", this.onDragStart);
                    }, t.prototype.onDragStart = function(e) {
                        var t = this;
                        if ("dragstart" === e.type && this.draggable) return !1;
                        if (n.IDLE >= this.state) {
                            var o = e.target;
                            if (this.dragList.length && o) {
                                var r = function(e) {
                                    return Boolean(e && t.dragList.includes(e.nodeName.toLowerCase()));
                                }, a = s.Dom.furthest(o, r, this.j.editor) || (r(o) ? o : null);
                                a && (s.Dom.isTag(a.parentElement, "a") && a.parentElement.firstChild === a && a.parentElement.lastChild === a && (a = a.parentElement), this.startX = e.clientX, this.startY = e.clientY, this.isCopyMode = (0, i.ctrlKey)(e), this.draggable = a.cloneNode(!0), (0, i.dataBind)(this.draggable, "target", a), this.state = n.WAIT_DRAGGING, this.addDragListeners());
                            }
                        }
                    }, t.prototype.onDrag = function(e) {
                        var o, r;
                        if (this.draggable && this.state !== n.IDLE) {
                            var a = e.clientY;
                            if (this.state !== n.WAIT_DRAGGING || Math.sqrt(Math.pow(e.clientX - this.startX, 2) + Math.pow(a - this.startY, 2)) >= this.diffStep) {
                                if (this.state === n.WAIT_DRAGGING && (this.j.lock("drag-and-drop-element"), this.state = n.DRAGGING), this.j.e.fire("hidePopup hideResizer"), !this.draggable.parentNode) {
                                    var s = (0, i.dataBind)(this.draggable, "target");
                                    (0, i.css)(this.draggable, {
                                        zIndex: 1e13,
                                        pointerEvents: "none",
                                        pointer: "drag",
                                        position: "fixed",
                                        opacity: .7,
                                        display: "inline-block",
                                        left: e.clientX,
                                        top: e.clientY,
                                        width: null !== (o = null == s ? void 0 : s.offsetWidth) && void 0 !== o ? o : 100,
                                        height: null !== (r = null == s ? void 0 : s.offsetHeight) && void 0 !== r ? r : 100
                                    }), (0, l.getContainer)(this.j, t).appendChild(this.draggable);
                                }
                                (0, i.css)(this.draggable, {
                                    left: e.clientX,
                                    top: e.clientY
                                }), this.j.s.insertCursorAtPoint(e.clientX, e.clientY);
                            }
                        }
                    }, t.prototype.onDragEnd = function() {
                        this.isInDestruct || (this.removeDragListeners(), this.j.unlock(), this.state = n.IDLE, this.draggable && (s.Dom.safeRemove(this.draggable), this.draggable = null));
                    }, t.prototype.onDrop = function() {
                        if (this.draggable && this.state >= n.DRAGGING) {
                            var e = (0, i.dataBind)(this.draggable, "target");
                            this.onDragEnd(), this.isCopyMode && (e = e.cloneNode(!0));
                            var t = e.parentElement;
                            this.j.s.insertNode(e, !0, !1), t && s.Dom.isEmpty(t) && !s.Dom.isTag(t, [
                                "td",
                                "th"
                            ]) && s.Dom.safeRemove(t), s.Dom.isTag(e, "img") && this.j.e && this.j.e.fire("afterInsertImage", e), this.j.e.fire("synchro");
                        } else this.onDragEnd();
                    }, t.prototype.addDragListeners = function() {
                        this.j.e.on(this.j.editor, "mousemove", this.onDrag).on("mouseup", this.onDrop).on([
                            this.j.ew,
                            this.ow
                        ], "mouseup", this.onDragEnd);
                    }, t.prototype.removeDragListeners = function() {
                        this.j.e.off(this.j.editor, "mousemove", this.onDrag).off("mouseup", this.onDrop).off([
                            this.j.ew,
                            this.ow
                        ], "mouseup", this.onDragEnd);
                    }, t.prototype.beforeDestruct = function() {
                        this.onDragEnd(), this.j.e.off("mousedown dragstart", this.onDragStart), this.removeDragListeners();
                    }, r.__decorate([
                        c.autobind
                    ], t.prototype, "onDragStart", null), r.__decorate([
                        (0, c.throttle)(function(e) {
                            return e.defaultTimeout / 10;
                        })
                    ], t.prototype, "onDrag", null), r.__decorate([
                        c.autobind
                    ], t.prototype, "onDragEnd", null), r.__decorate([
                        c.autobind
                    ], t.prototype, "onDrop", null), t;
                }(a.Plugin);
                t.dragAndDropElement = u, l.pluginSystem.add("dragAndDropElement", u);
            },
            19268: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.dragAndDrop = void 0;
                var n = o(20255), r = o(86893), i = o(24263), a = o(40332), s = o(57549), l = o(43441), c = o(63463), u = o(17332), d = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.isFragmentFromEditor = !1, t.isCopyMode = !1, t.startDragPoint = {
                            x: 0,
                            y: 0
                        }, t.draggable = null, t.bufferRange = null, t.getText = function(e) {
                            var t = (0, a.getDataTransfer)(e);
                            return t ? t.getData(r.TEXT_HTML) || t.getData(r.TEXT_PLAIN) : null;
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function() {
                        this.j.e.on([
                            window,
                            this.j.ed,
                            this.j.editor
                        ], "dragstart.DragAndDrop", this.onDragStart);
                    }, t.prototype.onDragStart = function(e) {
                        var t = e.target;
                        if (this.onDragEnd(), this.isFragmentFromEditor = i.Dom.isOrContains(this.j.editor, t, !0), this.isCopyMode = !this.isFragmentFromEditor || (0, a.ctrlKey)(e), this.isFragmentFromEditor) {
                            var o = this.j.s.sel, n = o && o.rangeCount ? o.getRangeAt(0) : null;
                            n && (this.bufferRange = n.cloneRange());
                        } else this.bufferRange = null;
                        this.startDragPoint.x = e.clientX, this.startDragPoint.y = e.clientY, (0, c.isFileBrowserFilesItem)(t) && (t = t.querySelector("img")), i.Dom.isTag(t, "img") && (this.draggable = t.cloneNode(!0), (0, a.dataBind)(this.draggable, "target", t)), this.addDragListeners();
                    }, t.prototype.addDragListeners = function() {
                        this.j.e.on("dragover", this.onDrag).on("drop.DragAndDrop", this.onDrop).on(window, "dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop", this.onDragEnd);
                    }, t.prototype.removeDragListeners = function() {
                        this.j.e.off("dragover", this.onDrag).off("drop.DragAndDrop", this.onDrop).off(window, "dragend.DragAndDrop drop.DragAndDrop mouseup.DragAndDrop", this.onDragEnd);
                    }, t.prototype.onDrag = function(e) {
                        this.draggable && (this.j.e.fire("hidePopup"), this.j.s.insertCursorAtPoint(e.clientX, e.clientY), e.preventDefault(), e.stopPropagation());
                    }, t.prototype.onDragEnd = function() {
                        this.draggable && (i.Dom.safeRemove(this.draggable), this.draggable = null), this.isCopyMode = !1, this.removeDragListeners();
                    }, t.prototype.onDrop = function(e) {
                        if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) {
                            if (!this.isFragmentFromEditor && !this.draggable) return this.j.e.fire("paste", e), e.preventDefault(), e.stopPropagation(), !1;
                            var t = this.j.s.sel, o = this.bufferRange || (t && t.rangeCount ? t.getRangeAt(0) : null), r = null;
                            if (!this.draggable && o) r = this.isCopyMode ? o.cloneContents() : o.extractContents();
                            else if (this.draggable) {
                                if (this.isCopyMode) {
                                    var s = n.__read("1" === (0, a.attr)(this.draggable, "-is-file") ? [
                                        "a",
                                        "href"
                                    ] : [
                                        "img",
                                        "src"
                                    ], 2), l = s[0], c = s[1];
                                    (r = this.j.createInside.element(l)).setAttribute(c, (0, a.attr)(this.draggable, "data-src") || (0, a.attr)(this.draggable, "src") || ""), "a" === l && (r.textContent = (0, a.attr)(r, c) || "");
                                } else r = (0, a.dataBind)(this.draggable, "target");
                            } else this.getText(e) && (r = this.j.createInside.fromHTML(this.getText(e)));
                            t && t.removeAllRanges(), this.j.s.insertCursorAtPoint(e.clientX, e.clientY), r && (this.j.s.insertNode(r, !1, !1), o && r.firstChild && r.lastChild && (o.setStartBefore(r.firstChild), o.setEndAfter(r.lastChild), this.j.s.selectRange(o), this.j.e.fire("synchro")), i.Dom.isTag(r, "img") && this.j.events && this.j.e.fire("afterInsertImage", r)), e.preventDefault(), e.stopPropagation();
                        }
                        this.isFragmentFromEditor = !1, this.removeDragListeners();
                    }, t.prototype.beforeDestruct = function() {
                        this.onDragEnd(), this.j.e.off(window, ".DragAndDrop").off(".DragAndDrop").off([
                            window,
                            this.j.ed,
                            this.j.editor
                        ], "dragstart.DragAndDrop", this.onDragStart);
                    }, n.__decorate([
                        l.autobind
                    ], t.prototype, "onDragStart", null), n.__decorate([
                        (0, l.throttle)(function(e) {
                            return e.defaultTimeout / 10;
                        })
                    ], t.prototype, "onDrag", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "onDragEnd", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "onDrop", null), t;
                }(s.Plugin);
                t.dragAndDrop = d, u.pluginSystem.add("dragAndDrop", d);
            },
            95049: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(69516), t);
            },
            69516: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.removeExtraBr = void 0;
                var n = o(24263);
                t.removeExtraBr = function(e, t) {
                    if (e.o.dtd.removeExtraBr && !n.Dom.isTag(t, "br")) {
                        var o = n.Dom.furthest(t, n.Dom.isBlock, e.editor);
                        if (o && !n.Dom.isTag(o, [
                            "table",
                            "pre",
                            "blockquote",
                            "code"
                        ])) {
                            var r = n.Dom.isTag(t, "br") ? t : n.Dom.findNotEmptySibling(t, !1);
                            if (!n.Dom.isTag(r, "br")) return;
                            e.s.setCursorBefore(r), n.Dom.safeRemove(r);
                        }
                    }
                };
            },
            73967: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkBlockNesting = void 0;
                var n = o(24263);
                t.checkBlockNesting = function(e, t) {
                    if (n.Dom.isFragment(t) && (t = t.firstChild), e.o.dtd.checkBlockNesting && n.Dom.isBlock(t)) {
                        var o = n.Dom.furthest(e.s.current(), n.Dom.isBlock, e.editor);
                        o && !e.o.dtd.blockLimits[o.tagName.toLowerCase()] && (e.s.setCursorAfter(o), n.Dom.isEmpty(o) && n.Dom.safeRemove(o));
                    }
                };
            },
            73690: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(73967), t);
            },
            20173: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.dtd = {
                    removeExtraBr: !0,
                    checkBlockNesting: !0,
                    blockLimits: {
                        article: 1,
                        aside: 1,
                        audio: 1,
                        body: 1,
                        caption: 1,
                        details: 1,
                        dir: 1,
                        div: 1,
                        dl: 1,
                        fieldset: 1,
                        figcaption: 1,
                        figure: 1,
                        footer: 1,
                        form: 1,
                        header: 1,
                        hgroup: 1,
                        main: 1,
                        menu: 1,
                        nav: 1,
                        ol: 1,
                        section: 1,
                        table: 1,
                        td: 1,
                        th: 1,
                        tr: 1,
                        ul: 1,
                        video: 1
                    }
                };
            },
            96899: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255), r = o(57549), i = o(17332), a = o(46163);
                o(20173);
                var s = o(73690), l = o(95049), c = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {}, t.prototype.beforeDestruct = function(e) {}, t.prototype.__onBeforeInsertNode = function(e) {
                        var t = this;
                        Object.keys(s).forEach(function(o) {
                            s[o](t.j, e);
                        });
                    }, t.prototype.__onAfterInsertNode = function(e) {
                        var t = this;
                        Object.keys(l).forEach(function(o) {
                            l[o](t.j, e);
                        });
                    }, n.__decorate([
                        (0, a.watch)(":beforeInsertNode")
                    ], t.prototype, "__onBeforeInsertNode", null), n.__decorate([
                        (0, a.watch)(":afterInsertNode")
                    ], t.prototype, "__onAfterInsertNode", null), t;
                }(r.Plugin);
                i.pluginSystem.add("dtd", c);
            },
            33122: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.enter = void 0;
                var n = o(20255), r = o(24263), i = o(85605), a = o(86893), s = o(43441), l = o(67749), c = o(23217), u = o(17332);
                o(26231);
                var d = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this, o = e.o.enter.toLowerCase(), n = o === a.BR.toLowerCase();
                        e.o.enterBlock || (e.o.enterBlock = n ? a.PARAGRAPH : o), e.registerCommand("enter", function(e, o, n) {
                            return void 0 === n && (n = {}), t.onEnter(n);
                        });
                    }, t.prototype.onEnterKeyDown = function(e) {
                        if (e.key === a.KEY_ENTER) {
                            var t = this.j, o = t.e.fire("beforeEnter", e);
                            return void 0 !== o ? o : (t.s.isCollapsed() || t.execCommand("Delete"), t.s.focus(), this.onEnter(e), t.e.fire("afterEnter", e), t.synchronizeValues(), !1);
                        }
                    }, t.prototype.onEnter = function(e) {
                        var t = this.jodit, o = t.createInside.fake();
                        try {
                            r.Dom.safeInsertNode(t.s.range, o), (0, c.moveCursorOutFromSpecialTags)(t, o, [
                                "a"
                            ]);
                            var n = (0, c.getBlockWrapper)(o, t), i = r.Dom.isTag(n, "li");
                            if ((!i || (null == e ? void 0 : e.shiftKey)) && (0, c.checkBR)(o, t, null == e ? void 0 : e.shiftKey)) return !1;
                            if (n || (0, c.hasPreviousBlock)(o, t) || (n = (0, c.wrapText)(o, t)), !n) return (0, c.insertParagraph)(o, t, i ? "li" : t.o.enter), !1;
                            if (!(0, c.checkUnsplittableBox)(o, t, n)) return !1;
                            if (i && this.__isEmptyListLeaf(n)) return (0, c.processEmptyLILeaf)(o, t, n), !1;
                            (0, c.splitFragment)(o, t, n);
                        } finally{
                            o.isConnected && t.s.setCursorBefore(o), r.Dom.safeRemove(o);
                        }
                    }, t.prototype.__isEmptyListLeaf = function(e) {
                        var t = this.j.e.fire("enterIsEmptyListLeaf", e);
                        return (0, l.isBoolean)(t) ? t : r.Dom.isEmpty(e);
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off("keydown.enter");
                    }, n.__decorate([
                        (0, s.watch)(":keydown.enter")
                    ], t.prototype, "onEnterKeyDown", null), t;
                }(i.Plugin);
                t.enter = d, u.pluginSystem.add("enter", d);
            },
            94149: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkBR = void 0;
                var n = o(24263), r = o(9005), i = o(86893);
                function a(e) {
                    if (!e) return !1;
                    var t = n.Dom.findSibling(e, !0);
                    return !(!t || !n.Dom.isTag(t, "br")) && t;
                }
                t.checkBR = function(e, t, o) {
                    var s = Boolean(n.Dom.closest(e, [
                        "pre",
                        "blockquote"
                    ], t.editor));
                    if (t.o.enter.toLowerCase() === i.BR.toLowerCase() || o && !s || !o && s) {
                        if (s && function(e) {
                            var t = a(a(e));
                            return !!t && (n.Dom.safeRemove(a(e)), n.Dom.safeRemove(t), !0);
                        }(e)) return !1;
                        var l = t.createInside.element("br");
                        if (n.Dom.before(e, l), !n.Dom.findNotEmptySibling(l, !1)) {
                            var c = l.cloneNode();
                            n.Dom.after(l, c), n.Dom.before(c, e);
                        }
                        return (0, r.scrollIntoViewIfNeeded)(l, t.editor, t.ed), !0;
                    }
                    return !1;
                };
            },
            58921: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.checkUnsplittableBox = void 0;
                var n = o(24263);
                t.checkUnsplittableBox = function(e, t, o) {
                    return !!n.Dom.canSplitBlock(o) || (n.Dom.before(e, t.createInside.element("br")), !1);
                };
            },
            70638: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getBlockWrapper = void 0;
                var n = o(86893), r = o(24263);
                t.getBlockWrapper = function e(t, o, i) {
                    void 0 === i && (i = n.IS_BLOCK);
                    var a = t, s = o.editor;
                    do {
                        if (!a || a === s) break;
                        if (i.test(a.nodeName)) return r.Dom.isTag(a, "li") ? a : e(a.parentNode, o, /^li$/i) || a;
                        a = a.parentNode;
                    }while (a && a !== s);
                    return null;
                };
            },
            50781: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hasPreviousBlock = void 0;
                var n = o(24263);
                t.hasPreviousBlock = function(e, t) {
                    return Boolean(n.Dom.prev(e, function(e) {
                        return n.Dom.isBlock(e) || n.Dom.isImage(e);
                    }, t.editor));
                };
            },
            23217: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(94149), t), n.__exportStar(o(58921), t), n.__exportStar(o(92291), t), n.__exportStar(o(70638), t), n.__exportStar(o(50781), t), n.__exportStar(o(90443), t), n.__exportStar(o(52521), t), n.__exportStar(o(81512), t), n.__exportStar(o(29575), t);
            },
            90443: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.insertParagraph = void 0;
                var n = o(24263), r = o(9005);
                t.insertParagraph = function(e, t, o, i) {
                    var a = "br" === o.toLowerCase(), s = t.createInside, l = s.element(o), c = s.element("br");
                    return a || l.appendChild(c), i && i.cssText && l.setAttribute("style", i.cssText), n.Dom.after(e, l), n.Dom.before(a ? l : c, e), (0, r.scrollIntoViewIfNeeded)(l, t.editor, t.ed), l;
                };
            },
            29575: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.moveCursorOutFromSpecialTags = void 0;
                var n = o(24263);
                t.moveCursorOutFromSpecialTags = function(e, t, o) {
                    var r = e.s, i = n.Dom.closest(t, o, e.editor);
                    i && (r.cursorOnTheRight(i, t) ? n.Dom.after(i, t) : r.cursorOnTheLeft(i, t) && n.Dom.before(i, t));
                };
            },
            92291: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.processEmptyLILeaf = void 0;
                var n = o(24263), r = o(54188), i = o(90443);
                t.processEmptyLILeaf = function(e, t, o) {
                    var a = n.Dom.closest(o, [
                        "ol",
                        "ul"
                    ], t.editor);
                    if (a) {
                        var s = a.parentElement, l = n.Dom.isTag(s, "li"), c = l ? s : a, u = t.s.createRange();
                        u.setStartAfter(o), u.setEndAfter(a);
                        var d = u.extractContents();
                        n.Dom.after(c, e), n.Dom.safeRemove(o), (0, r.$$)("li", a).length || n.Dom.safeRemove(a);
                        var p = (0, i.insertParagraph)(e, t, l ? "li" : t.o.enter);
                        d.querySelector("li") && (l ? p.appendChild(d) : n.Dom.after(p, d));
                    }
                };
            },
            52521: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.splitFragment = void 0;
                var n = o(9005), r = o(24263), i = o(90443);
                t.splitFragment = function(e, t, o) {
                    var a = t.s, s = t.o.enter.toLowerCase(), l = r.Dom.isTag(o, "li"), c = o.tagName.toLowerCase() === s || l, u = a.cursorOnTheRight(o, e), d = a.cursorOnTheLeft(o, e);
                    if (!c && (u || d)) return u ? r.Dom.after(o, e) : r.Dom.before(o, e), (0, i.insertParagraph)(e, t, s), void (d && !u && r.Dom.prepend(o, e));
                    var p = a.splitSelection(o, e);
                    (0, n.scrollIntoViewIfNeeded)(p, t.editor, t.ed);
                };
            },
            81512: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.wrapText = void 0;
                var n = o(24263);
                t.wrapText = function(e, t) {
                    var o = e;
                    n.Dom.up(o, function(e) {
                        e && e.hasChildNodes() && e !== t.editor && (o = e);
                    }, t.editor);
                    var r = n.Dom.wrapInline(o, t.o.enter, t);
                    if (n.Dom.isEmpty(r)) {
                        var i = t.createInside.element("br");
                        r.appendChild(i), n.Dom.before(i, e);
                    }
                    return r;
                };
            },
            26231: function() {},
            10135: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.file = void 0;
                var n = o(93166), r = o(24263), i = o(718), a = o(17332);
                function s(e) {
                    e.registerButton({
                        name: "file",
                        group: "media"
                    });
                }
                n.Config.prototype.controls.file = {
                    popup: function(e, t, o, n) {
                        var a = function(t, o) {
                            void 0 === o && (o = ""), e.s.insertNode(e.createInside.fromHTML('<a href="'.concat(t, '" title="').concat(o, '">').concat(o || t, "</a>")));
                        }, s = null;
                        return t && (r.Dom.isTag(t, "a") || r.Dom.closest(t, "a", e.editor)) && (s = r.Dom.isTag(t, "a") ? t : r.Dom.closest(t, "a", e.editor)), (0, i.FileSelectorWidget)(e, {
                            filebrowser: function(e) {
                                e.files && e.files.forEach(function(t) {
                                    return a(e.baseurl + t);
                                }), n();
                            },
                            upload: !0,
                            url: function(e, t) {
                                s ? (s.setAttribute("href", e), s.setAttribute("title", t)) : a(e, t), n();
                            }
                        }, s, n, !1);
                    },
                    tags: [
                        "a"
                    ],
                    tooltip: "Insert file"
                }, t.file = s, a.pluginSystem.add("file", s);
            },
            66994: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.focus = void 0;
                var n = o(93166), r = o(64968), i = o(17332);
                function a(e) {
                    e.o.saveSelectionOnBlur && e.e.on("blur", function() {
                        e.isEditorMode() && e.s.save(!0);
                    }).on("focus", function() {
                        e.s.restore();
                    });
                    var t = function() {
                        if (e.s.focus(), "end" === e.o.cursorAfterAutofocus) {
                            var t = r.Dom.last(e.editor, function(e) {
                                return r.Dom.isText(e);
                            });
                            t && e.s.setCursorIn(t, !1);
                        }
                    };
                    e.e.on("afterInit", function() {
                        e.o.autofocus && (e.defaultTimeout ? e.async.setTimeout(t, 300) : t());
                    }), e.e.on("afterInit afterAddPlace", function() {
                        e.e.off(e.editor, "mousedown.autofocus").on(e.editor, "mousedown.autofocus", function(t) {
                            e.isEditorMode() && t.target && r.Dom.isBlock(t.target) && !t.target.childNodes.length && (e.editor === t.target ? e.s.focus() : e.s.setCursorIn(t.target));
                        });
                    });
                }
                n.Config.prototype.autofocus = !1, n.Config.prototype.cursorAfterAutofocus = "end", n.Config.prototype.saveSelectionOnBlur = !0, t.focus = a, i.pluginSystem.add("focus", a);
            },
            8082: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255), r = o(93166), i = o(24263), a = o(76502), s = o(77904);
                r.Config.prototype.defaultFontSizePoints = "px", s.Icon.set("font", o(84142)).set("fontsize", o(57292)), r.Config.prototype.controls.fontsize = {
                    command: "fontsize",
                    data: {
                        cssRule: "font-size"
                    },
                    list: [
                        "8",
                        "9",
                        "10",
                        "11",
                        "12",
                        "14",
                        "16",
                        "18",
                        "24",
                        "30",
                        "36",
                        "48",
                        "60",
                        "72",
                        "96"
                    ],
                    exec: function(e, t, o) {
                        var n = o.control;
                        return (0, a.memorizeExec)(e, t, {
                            control: n
                        }, function(t) {
                            var o;
                            return "fontsize" === (null === (o = n.command) || void 0 === o ? void 0 : o.toLowerCase()) ? "".concat(t).concat(e.o.defaultFontSizePoints) : t;
                        });
                    },
                    childTemplate: function(e, t, o) {
                        return "".concat(o).concat(e.o.defaultFontSizePoints);
                    },
                    tooltip: "Font size",
                    isChildActive: function(e, t) {
                        var o, n, r = e.s.current(), s = (null === (o = t.data) || void 0 === o ? void 0 : o.cssRule) || "font-size", l = (null === (n = t.data) || void 0 === n ? void 0 : n.normalize) || function(t) {
                            return /pt$/i.test(t) && "pt" === e.o.defaultFontSizePoints ? t.replace(/pt$/i, "") : t;
                        };
                        if (r) {
                            var c = i.Dom.closest(r, i.Dom.isElement, e.editor) || e.editor, u = (0, a.css)(c, s);
                            return Boolean(u && t.args && l(t.args[0].toString()) === l(u.toString()));
                        }
                        return !1;
                    }
                }, r.Config.prototype.controls.font = n.__assign(n.__assign({}, r.Config.prototype.controls.fontsize), {
                    command: "fontname",
                    list: {
                        "": "Default",
                        "helvetica,sans-serif": "Helvetica",
                        "arial,helvetica,sans-serif": "Arial",
                        "georgia,palatino,serif": "Georgia",
                        "impact,charcoal,sans-serif": "Impact",
                        "tahoma,geneva,sans-serif": "Tahoma",
                        "times new roman,times,serif": "Times New Roman",
                        "verdana,geneva,sans-serif": "Verdana"
                    },
                    childTemplate: function(e, t, o) {
                        var n = !1;
                        try {
                            n = -1 === t.indexOf("dings") && document.fonts.check("16px ".concat(t), o);
                        } catch (e) {}
                        return '<span data-style="'.concat(t, '" style="').concat(n ? "font-family: ".concat(t, "!important;") : "", '">').concat(o, "</span>");
                    },
                    data: {
                        cssRule: "font-family",
                        normalize: function(e) {
                            return e.toLowerCase().replace(/['"]+/g, "").replace(/[^a-z0-9]+/g, ",");
                        }
                    },
                    tooltip: "Font family"
                });
            },
            54798: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.font = void 0;
                var n = o(40332), r = o(17332);
                function i(e) {
                    e.registerButton({
                        name: "font",
                        group: "font"
                    }).registerButton({
                        name: "fontsize",
                        group: "font"
                    });
                    var t = function(t, o, r) {
                        switch(t){
                            case "fontsize":
                                e.s.applyStyle({
                                    fontSize: (0, n.normalizeSize)(r)
                                });
                                break;
                            case "fontname":
                                e.s.applyStyle({
                                    fontFamily: r
                                });
                        }
                        return e.synchronizeValues(), !1;
                    };
                    e.registerCommand("fontsize", t).registerCommand("fontname", t);
                }
                o(8082), t.font = i, r.pluginSystem.add("font", i);
            },
            12908: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formatBlock = void 0;
                var n = o(93166), r = o(87837), i = o(40332), a = o(17332);
                function s(e) {
                    e.registerButton({
                        name: "paragraph",
                        group: "font"
                    }), e.registerCommand("formatblock", function(t, o, n) {
                        return e.s.applyStyle(void 0, {
                            element: n
                        }), e.synchronizeValues(), !1;
                    });
                }
                o(77904).Icon.set("paragraph", o(18019)), n.Config.prototype.controls.paragraph = {
                    command: "formatBlock",
                    update: function(e, t) {
                        var o = e.control, n = t.s.current();
                        if (n && t.o.textIcons) {
                            var i = (r.Dom.closest(n, r.Dom.isBlock, t.editor) || t.editor).nodeName.toLowerCase(), a = o.list;
                            e && o.data && o.data.currentValue !== i && a && a[i] && (t.o.textIcons ? e.state.text = i : e.state.icon.name = i, o.data.currentValue = i);
                        }
                        return !1;
                    },
                    exec: i.memorizeExec,
                    data: {
                        currentValue: "left"
                    },
                    list: {
                        p: "Normal",
                        h1: "Heading 1",
                        h2: "Heading 2",
                        h3: "Heading 3",
                        h4: "Heading 4",
                        blockquote: "Quote",
                        pre: "Code"
                    },
                    isChildActive: function(e, t) {
                        var o = e.s.current();
                        if (o) {
                            var n = r.Dom.closest(o, r.Dom.isBlock, e.editor);
                            return Boolean(n && n !== e.editor && void 0 !== t.args && n.nodeName.toLowerCase() === t.args[0]);
                        }
                        return !1;
                    },
                    isActive: function(e, t) {
                        var o = e.s.current();
                        if (o) {
                            var n = r.Dom.closest(o, r.Dom.isBlock, e.editor);
                            return Boolean(n && n !== e.editor && void 0 !== t.list && !r.Dom.isTag(n, "p") && void 0 !== t.list[n.nodeName.toLowerCase()]);
                        }
                        return !1;
                    },
                    childTemplate: function(e, t, o) {
                        return "<".concat(t, ' style="margin:0;padding:0"><span>').concat(e.i18n(o), "</span></").concat(t, ">");
                    },
                    tooltip: "Insert format block"
                }, t.formatBlock = s, a.pluginSystem.add("formatBlock", s);
            },
            15045: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(14320);
                var n = o(93166), r = o(86893), i = o(77904);
                n.Config.prototype.fullsize = !1, n.Config.prototype.globalFullSize = !0, i.Icon.set("fullsize", o(45146)).set("shrink", o(53576)), n.Config.prototype.controls.fullsize = {
                    exec: function(e) {
                        e.toggleFullSize();
                    },
                    update: function(e, t) {
                        var o = t.isFullSize ? "shrink" : "fullsize";
                        e.state.activated = t.isFullSize, t.o.textIcons ? e.state.text = o : e.state.icon.name = o;
                    },
                    tooltip: "Open in fullsize",
                    mode: r.MODE_SOURCE + r.MODE_WYSIWYG
                };
            },
            65123: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.fullsize = void 0, o(14320);
                var n = o(26911), r = o(77892), i = o(17332);
                o(15045);
                var a = new Set;
                function s(e) {
                    e.registerButton({
                        name: "fullsize"
                    });
                    var t = !1, o = 0, i = 0, s = !1, l = function() {
                        var r = e.container;
                        e.events && (t ? (o = (0, n.css)(r, "height", !0), i = (0, n.css)(r, "width", !0), (0, n.css)(r, {
                            height: e.ow.innerHeight,
                            width: e.ow.innerWidth
                        }), s = !0) : s && (0, n.css)(r, {
                            height: o || "auto",
                            width: i || "auto"
                        }));
                    }, c = function(o) {
                        var i = e.container, s = e.events;
                        if (i) {
                            if (void 0 === o && (o = !i.classList.contains("jodit_fullsize")), e.setMod("fullsize", o), e.o.fullsize = o, t = o, i.classList.toggle("jodit_fullsize", o), e.toolbar && ((0, r.isJoditObject)(e) && e.toolbarContainer.appendChild(e.toolbar.container), (0, n.css)(e.toolbar.container, "width", "auto")), o ? a.add(i) : a.delete(i), e.o.globalFullSize && (1 === a.size && o || 0 === a.size && !o)) {
                                for(var c = i.parentNode; c && c.nodeType !== Node.DOCUMENT_NODE && c.nodeType !== Node.DOCUMENT_FRAGMENT_NODE;)c.classList.toggle("jodit_fullsize-box_true", o), c = c.parentNode;
                                l();
                            }
                            s.fire("afterResize");
                        }
                    };
                    e.o.globalFullSize && e.e.on(e.ow, "resize", l), e.e.on("afterInit afterOpen", function() {
                        var t;
                        e.toggleFullSize(null === (t = null == e ? void 0 : e.options) || void 0 === t ? void 0 : t.fullsize);
                    }).on("toggleFullSize", c).on("beforeDestruct", function() {
                        t && c(!1);
                    }).on("beforeDestruct", function() {
                        e.events && e.e.off(e.ow, "resize", l);
                    });
                }
                t.fullsize = s, i.pluginSystem.add("fullsize", s);
            },
            16829: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.commandToHotkeys = {
                    removeFormat: [
                        "ctrl+shift+m",
                        "cmd+shift+m"
                    ],
                    insertOrderedList: [
                        "ctrl+shift+7",
                        "cmd+shift+7"
                    ],
                    insertUnorderedList: [
                        "ctrl+shift+8, cmd+shift+8"
                    ],
                    selectall: [
                        "ctrl+a",
                        "cmd+a"
                    ]
                };
            },
            83228: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hotkeys = void 0;
                var n = o(20255), r = o(57549), i = o(40332), a = o(86893), s = o(17332);
                o(16829);
                var l = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.onKeyPress = function(e) {
                            var o = t.specialKeys[e.which], n = (e.key || String.fromCharCode(e.which)).toLowerCase(), r = [
                                o || n
                            ];
                            return [
                                "alt",
                                "ctrl",
                                "shift",
                                "meta"
                            ].forEach(function(t) {
                                e[t + "Key"] && o !== t && r.push(t);
                            }), (0, i.normalizeKeyAliases)(r.join("+"));
                        }, t.specialKeys = {
                            8: "backspace",
                            9: "tab",
                            10: "return",
                            13: "return",
                            16: "shift",
                            17: "ctrl",
                            18: "alt",
                            19: "pause",
                            20: "capslock",
                            27: "esc",
                            32: "space",
                            33: "pageup",
                            34: "pagedown",
                            35: "end",
                            36: "home",
                            37: "left",
                            38: "up",
                            39: "right",
                            40: "down",
                            45: "insert",
                            46: "del",
                            59: ";",
                            61: "=",
                            91: "meta",
                            96: "0",
                            97: "1",
                            98: "2",
                            99: "3",
                            100: "4",
                            101: "5",
                            102: "6",
                            103: "7",
                            104: "8",
                            105: "9",
                            106: "*",
                            107: "+",
                            109: "-",
                            110: ".",
                            111: "/",
                            112: "f1",
                            113: "f2",
                            114: "f3",
                            115: "f4",
                            116: "f5",
                            117: "f6",
                            118: "f7",
                            119: "f8",
                            120: "f9",
                            121: "f10",
                            122: "f11",
                            123: "f12",
                            144: "numlock",
                            145: "scroll",
                            173: "-",
                            186: ";",
                            187: "=",
                            188: ",",
                            189: "-",
                            190: ".",
                            191: "/",
                            192: "`",
                            219: "[",
                            220: "\\",
                            221: "]",
                            222: "'"
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        (0, i.keys)(e.o.commandToHotkeys, !1).forEach(function(t) {
                            var o = e.o.commandToHotkeys[t];
                            o && ((0, i.isArray)(o) || (0, i.isString)(o)) && e.registerHotkeyToCommand(o, t);
                        });
                        var o = !1;
                        e.e.off(".hotkeys").on([
                            e.ow,
                            e.ew
                        ], "keydown.hotkeys", function(e) {
                            if (e.key === a.KEY_ESC) return t.j.e.fire("escape", e);
                        }).on("keydown.hotkeys", function(n) {
                            var r = t.onKeyPress(n), i = {
                                shouldStop: !0
                            };
                            if (!1 === t.j.e.fire(r + ".hotkey", n.type, i)) {
                                if (i.shouldStop) return o = !0, e.e.stopPropagation("keydown"), !1;
                                n.preventDefault();
                            }
                        }, {
                            top: !0
                        }).on("keyup.hotkeys", function() {
                            if (o) return o = !1, e.e.stopPropagation("keyup"), !1;
                        }, {
                            top: !0
                        });
                    }, t.prototype.beforeDestruct = function(e) {
                        e.events && e.e.off(".hotkeys");
                    }, t;
                }(r.Plugin);
                t.hotkeys = l, s.pluginSystem.add("hotkeys", l);
            },
            43889: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.hr = void 0;
                var n = o(93166), r = o(64968), i = o(17332);
                function a(e) {
                    e.registerButton({
                        name: "hr",
                        group: "insert"
                    }), e.registerCommand("insertHorizontalRule", function() {
                        var t = e.createInside.element("hr");
                        e.s.insertNode(t, !1, !1);
                        var o = r.Dom.closest(t.parentElement, r.Dom.isBlock, e.editor);
                        o && r.Dom.isEmpty(o) && o !== e.editor && (r.Dom.after(o, t), r.Dom.safeRemove(o));
                        var n = r.Dom.next(t, r.Dom.isBlock, e.editor, !1);
                        return n || (n = e.createInside.element(e.o.enter), r.Dom.after(t, n)), e.s.setCursorIn(n), !1;
                    });
                }
                o(77904).Icon.set("hr", o(14655)), n.Config.prototype.controls.hr = {
                    command: "insertHorizontalRule",
                    tags: [
                        "hr"
                    ],
                    tooltip: "Insert Horizontal Line"
                }, t.hr = a, i.pluginSystem.add("hr", a);
            },
            2509: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.iframeBaseUrl = "", n.Config.prototype.iframeTitle = "Jodit Editor", n.Config.prototype.iframeDoctype = "<!DOCTYPE html>", n.Config.prototype.iframeDefaultSrc = "about:blank", n.Config.prototype.iframeStyle = 'html{margin:0;padding:0;min-height: 100%;}body{box-sizing:border-box;font-size:13px;line-height:1.6;padding:10px;margin:0;background:transparent;color:#000;position:relative;z-index:2;user-select:auto;margin:0px;overflow:auto;outline:none;}table{width:100%;border:none;border-collapse:collapse;empty-cells: show;max-width: 100%;}th,td{padding: 2px 5px;border:1px solid #ccc;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}p{margin-top:0;}.jodit_editor .jodit_iframe_wrapper{display: block;clear: both;user-select: none;position: relative;}.jodit_editor .jodit_iframe_wrapper:after {position:absolute;content:"";z-index:1;top:0;left:0;right: 0;bottom: 0;cursor: pointer;display: block;background: rgba(0, 0, 0, 0);} .jodit_disabled{user-select: none;-o-user-select: none;-moz-user-select: none;-khtml-user-select: none;-webkit-user-select: none;-ms-user-select: none}', n.Config.prototype.iframeCSSLinks = [];
            },
            93300: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.iframe = void 0;
                var n = o(40332), r = o(40332), i = o(86893), a = o(17332);
                function s(e) {
                    var t = e.options;
                    e.e.on("afterSetMode", function() {
                        e.isEditorMode() && e.s.focus();
                    }).on("generateDocumentStructure.iframe", function(e, o) {
                        var r = e || o.iframe.contentWindow.document;
                        if (r.open(), r.write(t.iframeDoctype + '<html dir="'.concat(t.direction, '" class="jodit" lang="').concat((0, n.defaultLanguage)(t.language), '">') + "<head>" + "<title>".concat(t.iframeTitle, "</title>") + (t.iframeBaseUrl ? '<base href="'.concat(t.iframeBaseUrl, '"/>') : "") + '</head><body class="jodit-wysiwyg"></body></html>'), r.close(), t.iframeCSSLinks && t.iframeCSSLinks.forEach(function(e) {
                            var t = r.createElement("link");
                            t.setAttribute("rel", "stylesheet"), t.setAttribute("href", e), r.head && r.head.appendChild(t);
                        }), t.iframeStyle) {
                            var i = r.createElement("style");
                            i.innerHTML = t.iframeStyle, r.head && r.head.appendChild(i);
                        }
                    }).on("createEditor", function() {
                        if (t.iframe) {
                            var o = e.c.element("iframe");
                            o.style.display = "block", o.src = "about:blank", o.className = "jodit-wysiwyg_iframe", o.setAttribute("allowtransparency", "true"), o.setAttribute("tabindex", t.tabIndex.toString()), o.setAttribute("frameborder", "0"), e.workplace.appendChild(o), e.iframe = o;
                            var a = e.e.fire("generateDocumentStructure.iframe", null, e);
                            return (0, n.callPromise)(a, function() {
                                if (!e.iframe) return !1;
                                var o = e.iframe.contentWindow.document;
                                e.editorWindow = e.iframe.contentWindow;
                                var a = function() {
                                    (0, n.attr)(o.body, "contenteditable", e.getMode() !== i.MODE_SOURCE && !e.getReadOnly() || null);
                                }, s = function(e) {
                                    var t = /<body.*<\/body>/im, o = "{%%BODY%%}", n = t.exec(e);
                                    return n && (e = e.replace(t, o).replace(/<span([^>]*?)>(.*?)<\/span>/gim, "").replace(/&lt;span([^&]*?)&gt;(.*?)&lt;\/span&gt;/gim, "").replace(o, n[0].replace(/(<body[^>]+?)min-height["'\s]*:[\s"']*[0-9]+(px|%)/im, "$1").replace(/(<body[^>]+?)([\s]*["'])?contenteditable["'\s]*=[\s"']*true["']?/im, "$1").replace(/<(style|script|span)[^>]+jodit[^>]+>.*?<\/\1>/g, "")).replace(/(class\s*=\s*)(['"])([^"']*)(jodit-wysiwyg|jodit)([^"']*\2)/g, "$1$2$3$5").replace(/(<[^<]+?)\sclass="[\s]*"/gim, "$1").replace(/(<[^<]+?)\sstyle="[\s;]*"/gim, "$1").replace(/(<[^<]+?)\sdir="[\s]*"/gim, "$1")), e;
                                };
                                if (t.editHTMLDocumentMode) {
                                    var l = e.element.tagName;
                                    if ("TEXTAREA" !== l && "INPUT" !== l) throw (0, r.error)("If enable `editHTMLDocumentMode` - source element should be INPUT or TEXTAREA");
                                    e.e.on("beforeGetNativeEditorValue", function() {
                                        return s(e.o.iframeDoctype + o.documentElement.outerHTML);
                                    }).on("beforeSetNativeEditorValue", function(t) {
                                        var n = t.value;
                                        return !e.isLocked && (/<(html|body)/i.test(n) ? s(o.documentElement.outerHTML) !== s(n) && (o.open(), o.write(e.o.iframeDoctype + s(n)), o.close(), e.editor = o.body, e.e.fire("safeHTML", e.editor), a(), e.e.fire("prepareWYSIWYGEditor"), e.e.stopPropagation("beforeSetNativeEditorValue")) : o.body.innerHTML = n, !0);
                                    }, {
                                        top: !0
                                    });
                                }
                                if (e.editor = o.body, e.e.on("afterSetMode afterInit afterAddPlace", a), "auto" === t.height) {
                                    o.documentElement && (o.documentElement.style.overflowY = "hidden");
                                    var c = e.async.throttle(function() {
                                        if (e.editor && e.iframe && "auto" === t.height) {
                                            var o = e.ew.getComputedStyle(e.editor), r = parseInt(o.marginTop || "0", 10) + parseInt(o.marginBottom || "0", 10);
                                            (0, n.css)(e.iframe, "height", e.editor.offsetHeight + r);
                                        }
                                    }, e.defaultTimeout / 2);
                                    if (e.e.on("change afterInit afterSetMode resize", c).on([
                                        e.iframe,
                                        e.ew,
                                        o.documentElement
                                    ], "load", c).on(o, "readystatechange DOMContentLoaded", c), "function" == typeof ResizeObserver) {
                                        var u = new ResizeObserver(c);
                                        u.observe(o.body), e.e.on("beforeDestruct", function() {
                                            u.unobserve(o.body);
                                        });
                                    }
                                }
                                return o.documentElement && e.e.on(o.documentElement, "mousedown touchend", function() {
                                    e.s.isFocused() || (e.s.focus(), e.editor === o.body && e.s.setCursorIn(o.body));
                                }).on(e.ew, "mousedown touchstart keydown keyup touchend click mouseup mousemove scroll", function(t) {
                                    var o;
                                    null === (o = e.events) || void 0 === o || o.fire(e.ow, t);
                                }), !1;
                            });
                        }
                    });
                }
                o(2509), t.iframe = s, a.pluginSystem.add("iframe", s);
            },
            18226: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.imageProcessor = {
                    replaceDataURIToBlobIdInView: !0
                };
            },
            92575: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.imageProcessor = void 0;
                var n = o(20255), r = o(40332), i = o(57549), a = o(43441), s = o(86893), l = o(17332);
                o(18226);
                var c = "__jodit_imageprocessor_binded", u = "__jodit_imageprocessor_bindedblob-id", d = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {}, t.prototype.beforeDestruct = function(e) {
                        var t, o, r = e.buffer.get(u);
                        if (r) {
                            var i = Object.keys(r);
                            try {
                                for(var a = n.__values(i), s = a.next(); !s.done; s = a.next())URL.revokeObjectURL(s.value);
                            } catch (e) {
                                t = {
                                    error: e
                                };
                            } finally{
                                try {
                                    s && !s.done && (o = a.return) && o.call(a);
                                } finally{
                                    if (t) throw t.error;
                                }
                            }
                            e.buffer.delete(u);
                        }
                    }, t.prototype.onAfterGetValueFromEditor = function(e, t) {
                        if (t !== s.SOURCE_CONSUMER) return this.onBeforeSetElementValue(e);
                    }, t.prototype.onBeforeSetElementValue = function(e) {
                        var t, o, r = this.jodit;
                        if (r.o.imageProcessor.replaceDataURIToBlobIdInView) {
                            var i = r.buffer.get(u);
                            if (i) {
                                var a = Object.keys(i);
                                try {
                                    for(var s = n.__values(a), l = s.next(); !l.done; l = s.next())for(var c = l.value; e.value.includes(c);)e.value = e.value.replace(c, i[c]);
                                } catch (e) {
                                    t = {
                                        error: e
                                    };
                                } finally{
                                    try {
                                        l && !l.done && (o = s.return) && o.call(s);
                                    } finally{
                                        if (t) throw t.error;
                                    }
                                }
                            }
                        }
                    }, t.prototype.afterChange = function(e) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            var e;
                            return n.__generator(this, function(t) {
                                return (e = this.jodit).editor ? ((0, r.$$)("img", e.editor).forEach(function(t) {
                                    (0, r.dataBind)(t, c) || ((0, r.dataBind)(t, c, !0), t.complete || e.e.on(t, "load", function o() {
                                        var n;
                                        !e.isInDestruct && (null === (n = e.e) || void 0 === n || n.fire("resize")), e.e.off(t, "load", o);
                                    }), t.src && /^data:/.test(t.src) && function(e, t) {
                                        if (e.o.imageProcessor.replaceDataURIToBlobIdInView && "undefined" != typeof ArrayBuffer && "undefined" != typeof URL) {
                                            var o = t.src, n = function(e) {
                                                for(var t = atob(e.split(",")[1]), o = e.split(",")[0].split(":")[1].split(";")[0], n = new ArrayBuffer(t.length), r = new Uint8Array(n), i = 0; t.length > i; i++)r[i] = t.charCodeAt(i);
                                                return new Blob([
                                                    n
                                                ], {
                                                    type: o
                                                });
                                            }(o);
                                            t.src = URL.createObjectURL(n), e.e.fire("internalUpdate");
                                            var r = e.buffer.get(u) || {};
                                            r[t.src] = o, e.buffer.set(u, r);
                                        }
                                    }(e, t), e.e.on(t, "mousedown touchstart", function() {
                                        e.s.select(t);
                                    }));
                                }), [
                                    2
                                ]) : [
                                    2
                                ];
                            });
                        });
                    }, n.__decorate([
                        (0, a.watch)(":afterGetValueFromEditor")
                    ], t.prototype, "onAfterGetValueFromEditor", null), n.__decorate([
                        (0, a.watch)(":beforeSetElementValue")
                    ], t.prototype, "onBeforeSetElementValue", null), n.__decorate([
                        (0, a.watch)([
                            ":change",
                            ":afterInit",
                            ":changePlace"
                        ]),
                        (0, a.debounce)()
                    ], t.prototype, "afterChange", null), t;
                }(i.Plugin);
                t.imageProcessor = d, l.pluginSystem.add("imageProcessor", d);
            },
            1601: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.image = {
                    dialogWidth: 600,
                    openOnDblClick: !0,
                    editSrc: !0,
                    useImageEditor: !0,
                    editTitle: !0,
                    editAlt: !0,
                    editLink: !0,
                    editSize: !0,
                    editBorderRadius: !0,
                    editMargins: !0,
                    editClass: !0,
                    availableClasses: [],
                    editStyle: !0,
                    editId: !0,
                    editAlign: !0,
                    showPreview: !0,
                    selectImageAfterClose: !0
                };
            },
            15747: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.imageProperties = void 0;
                var n = o(20255);
                o(9947);
                var r = o(87837), i = o(40332), a = o(718), s = o(96516), l = o(43441), c = o(35503), u = o(17332), d = o(49391), p = o(27506), f = o(50109);
                o(1601);
                var h = function(e) {
                    return e = (0, i.trim)(e), /^[0-9]+$/.test(e) ? e + "px" : e;
                }, m = function(e) {
                    return /^[-+]?[0-9.]+px$/.test(e.toString()) ? parseFloat(e.toString()) : e;
                }, v = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.state = {
                            image: new Image,
                            get ratio () {
                                return this.image.naturalWidth / this.image.naturalHeight || 1;
                            },
                            sizeIsLocked: !0,
                            marginIsLocked: !0
                        }, t.activeTabState = {
                            __activeTab: "Image"
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.onChangeMarginIsLocked = function() {
                        var e = this;
                        if (this.form) {
                            var t = (0, i.refs)(this.form), o = t.lockMargin;
                            [
                                t.marginRight,
                                t.marginBottom,
                                t.marginLeft
                            ].forEach(function(t) {
                                (0, i.attr)(t, "disabled", e.state.marginIsLocked || null);
                            }), o.innerHTML = r.Icon.get(this.state.marginIsLocked ? "lock" : "unlock");
                        }
                    }, t.prototype.onChangeSizeIsLocked = function() {
                        if (this.form) {
                            var e = (0, i.refs)(this.form), t = e.lockSize, o = e.imageWidth;
                            t.innerHTML = r.Icon.get(this.state.sizeIsLocked ? "lock" : "unlock"), t.classList.remove("jodit-properties__lock"), t.classList.remove("jodit-properties__unlock"), t.classList.add(this.state.sizeIsLocked ? "jodit-properties__lock" : "jodit-properties__unlock"), this.j.e.fire(o, "change");
                        }
                    }, t.prototype.open = function() {
                        return this.makeForm(), this.activeTabState.__activeTab = "Image", this.j.e.fire("hidePopup"), (0, i.markOwner)(this.j, this.dialog.container), this.state.marginIsLocked = !0, this.state.sizeIsLocked = !0, this.onChangeMarginIsLocked(), this.onChangeSizeIsLocked(), this.updateValues(), this.dialog.open().setModal(!0).setPosition(), !1;
                    }, t.prototype.makeForm = function() {
                        var e = this;
                        if (!this.dialog) {
                            this.dialog = this.j.dlg({
                                minWidth: Math.min(400, screen.width),
                                minHeight: 590,
                                buttons: [
                                    "fullsize",
                                    "dialog.close"
                                ]
                            });
                            var t = this.j, o = t.o, n = t.i18n.bind(t), r = {
                                check: (0, s.Button)(t, "ok", "Apply", "primary"),
                                remove: (0, s.Button)(t, "bin", "Delete")
                            };
                            t.e.on(this.dialog, "afterClose", function() {
                                e.state.image.parentNode && o.image.selectImageAfterClose && t.s.select(e.state.image);
                            }), r.remove.onAction(function() {
                                t.s.removeNode(e.state.image), e.dialog.close();
                            });
                            var l = this.dialog;
                            l.setHeader(n("Image properties"));
                            var c = (0, d.form)(t);
                            this.form = c, l.setContent(c);
                            var u = (0, i.refs)(this.form).tabsBox;
                            u && u.appendChild((0, a.TabsWidget)(t, [
                                {
                                    name: "Image",
                                    content: (0, p.mainTab)(t)
                                },
                                {
                                    name: "Advanced",
                                    content: (0, f.positionTab)(t)
                                }
                            ], this.activeTabState)), r.check.onAction(this.onApply);
                            var h = (0, i.refs)(this.form), m = h.editImage;
                            t.e.on(h.changeImage, "click", this.openImagePopup), o.image.useImageEditor && t.e.on(m, "click", this.openImageEditor);
                            var v = (0, i.refs)(c), g = v.lockSize, y = v.lockMargin, _ = v.imageWidth, b = v.imageHeight;
                            g && t.e.on(g, "click", function() {
                                e.state.sizeIsLocked = !e.state.sizeIsLocked;
                            }), t.e.on(y, "click", function(t) {
                                e.state.marginIsLocked = !e.state.marginIsLocked, t.preventDefault();
                            });
                            var w = function(t) {
                                if ((0, i.isNumeric)(_.value) && (0, i.isNumeric)(b.value)) {
                                    var o = parseFloat(_.value), n = parseFloat(b.value);
                                    t.target === _ ? b.value = Math.round(o / e.state.ratio).toString() : _.value = Math.round(n * e.state.ratio).toString();
                                }
                            };
                            t.e.on([
                                _,
                                b
                            ], "change keydown mousedown paste", function(o) {
                                e.state.sizeIsLocked && t.async.setTimeout(w.bind(e, o), {
                                    timeout: t.defaultTimeout,
                                    label: "image-properties-changeSize"
                                });
                            }), l.setFooter([
                                r.remove,
                                r.check
                            ]), l.setSize(this.j.o.image.dialogWidth);
                        }
                    }, t.prototype.updateValues = function() {
                        var e, t, o = this, n = this.j.o, a = this.state.image, s = (0, i.refs)(this.form), l = s.marginTop, c = s.marginRight, u = s.marginBottom, d = s.marginLeft, p = s.imageSrc, f = s.id, h = s.classes, v = s.align, g = s.style, y = s.imageTitle, _ = s.imageAlt, b = s.borderRadius, w = s.imageLink, S = s.imageWidth, C = s.imageHeight, j = s.imageLinkOpenInNewTab, E = s.imageViewSrc, x = s.lockSize;
                        s.lockMargin.checked = o.state.marginIsLocked, x.checked = o.state.sizeIsLocked, p.value = (0, i.attr)(a, "src") || "", E && (0, i.attr)(E, "src", (0, i.attr)(a, "src") || ""), function() {
                            y.value = (0, i.attr)(a, "title") || "", _.value = (0, i.attr)(a, "alt") || "";
                            var e = r.Dom.closest(a, "a", o.j.editor);
                            e ? (w.value = (0, i.attr)(e, "href") || "", j.checked = "_blank" === (0, i.attr)(e, "target")) : (w.value = "", j.checked = !1);
                        }(), e = (0, i.attr)(a, "width") || (0, i.css)(a, "width", !0) || !1, t = (0, i.attr)(a, "height") || (0, i.css)(a, "height", !0) || !1, S.value = !1 !== e ? m(e).toString() : a.offsetWidth.toString(), C.value = !1 !== t ? m(t).toString() : a.offsetHeight.toString(), o.state.sizeIsLocked = function() {
                            if (!(0, i.isNumeric)(S.value) || !(0, i.isNumeric)(C.value)) return !1;
                            var e = parseFloat(S.value), t = parseFloat(C.value);
                            return 1 > Math.abs(e - t * o.state.ratio);
                        }(), function() {
                            if (n.image.editMargins) {
                                var e = !0, t = !1;
                                [
                                    l,
                                    c,
                                    u,
                                    d
                                ].forEach(function(o) {
                                    var n = (0, i.attr)(o, "data-ref") || "", r = a.style.getPropertyValue((0, i.kebabCase)(n));
                                    if (!r) return t = !0, void (o.value = "");
                                    /^[0-9]+(px)?$/.test(r) && (r = parseInt(r, 10)), o.value = r.toString() || "", (t && o.value || e && "marginTop" !== n && o.value !== l.value) && (e = !1);
                                }), o.state.marginIsLocked = e;
                            }
                        }(), h.value = ((0, i.attr)(a, "class") || "").replace(/jodit_focused_image[\s]*/, ""), f.value = (0, i.attr)(a, "id") || "", b.value = (parseInt(a.style.borderRadius || "0", 10) || "0").toString(), a.style.cssFloat && -1 !== [
                            "left",
                            "right"
                        ].indexOf(a.style.cssFloat.toLowerCase()) ? v.value = (0, i.css)(a, "float") : "block" === (0, i.css)(a, "display") && "auto" === a.style.marginLeft && "auto" === a.style.marginRight && (v.value = "center"), g.value = (0, i.attr)(a, "style") || "";
                    }, t.prototype.onApply = function() {
                        var e = (0, i.refs)(this.form), t = e.imageSrc, o = e.borderRadius, n = e.imageTitle, a = e.imageAlt, s = e.imageLink, l = e.imageWidth, c = e.imageHeight, u = e.marginTop, d = e.marginRight, p = e.marginBottom, f = e.marginLeft, m = e.imageLinkOpenInNewTab, v = e.align, g = e.classes, y = e.id, _ = this.j.o, b = this.state.image;
                        if (_.image.editStyle && (0, i.attr)(b, "style", e.style.value || null), !t.value) return r.Dom.safeRemove(b), void this.dialog.close();
                        (0, i.attr)(b, "src", t.value), b.style.borderRadius = "0" !== o.value && /^[0-9]+$/.test(o.value) ? o.value + "px" : "", (0, i.attr)(b, "title", n.value || null), (0, i.attr)(b, "alt", a.value || null);
                        var w = r.Dom.closest(b, "a", this.j.editor);
                        if (s.value ? (w || (w = r.Dom.wrap(b, "a", this.j.createInside)), (0, i.attr)(w, "href", s.value), (0, i.attr)(w, "target", m.checked ? "_blank" : null)) : w && w.parentNode && w.parentNode.replaceChild(b, w), l.value !== b.offsetWidth.toString() || c.value !== b.offsetHeight.toString()) {
                            var S = (0, i.trim)(l.value) ? h(l.value) : null, C = (0, i.trim)(c.value) ? h(c.value) : null;
                            (0, i.css)(b, {
                                width: S,
                                height: C
                            }), (0, i.attr)(b, "width", (0, i.attr)(b, "width") ? S : null), (0, i.attr)(b, "height", (0, i.attr)(b, "height") ? C : null);
                        }
                        var j = [
                            u,
                            d,
                            p,
                            f
                        ];
                        _.image.editMargins && (this.state.marginIsLocked ? (0, i.css)(b, "margin", h(u.value)) : j.forEach(function(e) {
                            var t = (0, i.attr)(e, "data-ref") || "";
                            (0, i.css)(b, t, h(e.value));
                        })), _.image.editClass && (0, i.attr)(b, "class", g.value || null), _.image.editId && (0, i.attr)(b, "id", y.value || null), _.image.editAlign && (0, i.hAlignElement)(b, v.value), this.j.synchronizeValues(), this.dialog.close();
                    }, t.prototype.openImageEditor = function() {
                        var e = this, t = (0, i.attr)(this.state.image, "src") || "", o = this.j.c.element("a"), n = function() {
                            o.host === location.host || e.j.confirm("You can only edit your own images. Download this image on the host?", function(t) {
                                t && e.j.uploader && e.j.uploader.uploadRemoteImage(o.href.toString(), function(t) {
                                    e.j.alert("The image has been successfully uploaded to the host!", function() {
                                        (0, i.isString)(t.newfilename) && ((0, i.attr)(e.state.image, "src", t.baseurl + t.newfilename), e.updateValues());
                                    });
                                }, function(t) {
                                    e.j.alert("There was an error loading %s", t.message);
                                });
                            });
                        };
                        o.href = t, this.j.filebrowser.dataProvider.getPathByUrl(o.href.toString()).then(function(n) {
                            c.openImageEditor.call(e.j.filebrowser, o.href, n.name, n.path, n.source, function() {
                                var o = (new Date).getTime();
                                (0, i.attr)(e.state.image, "src", t + (-1 !== t.indexOf("?") ? "" : "?") + "&_tmp=" + o.toString()), e.updateValues();
                            }, function(t) {
                                e.j.alert(t.message);
                            });
                        }).catch(function(t) {
                            e.j.alert(t.message, n);
                        });
                    }, t.prototype.openImagePopup = function(e) {
                        var t = this, o = new r.Popup(this.j), n = (0, i.refs)(this.form).changeImage;
                        o.setZIndex(this.dialog.getZIndex() + 1), o.setContent((0, a.FileSelectorWidget)(this.j, {
                            upload: function(e) {
                                e.files && e.files.length && (0, i.attr)(t.state.image, "src", e.baseurl + e.files[0]), t.updateValues(), o.close();
                            },
                            filebrowser: function(e) {
                                e && (0, i.isArray)(e.files) && e.files.length && ((0, i.attr)(t.state.image, "src", e.files[0]), o.close(), t.updateValues());
                            }
                        }, this.state.image, o.close)).open(function() {
                            return (0, i.position)(n);
                        }), e.stopPropagation();
                    }, t.prototype.afterInit = function(e) {
                        var t = this, o = this;
                        e.e.on("afterConstructor changePlace", function() {
                            e.e.off(e.editor, ".imageproperties").on(e.editor, "dblclick.imageproperties", function(n) {
                                var i = n.target;
                                if (r.Dom.isTag(i, "img")) {
                                    if (e.o.image.openOnDblClick) {
                                        if (!1 === t.j.e.fire("openOnDblClick", i)) return;
                                        o.state.image = i, e.o.readonly || (n.stopImmediatePropagation(), n.preventDefault(), o.open());
                                    } else n.stopImmediatePropagation(), e.s.select(i);
                                }
                            });
                        }).on("openImageProperties.imageproperties", function(e) {
                            t.state.image = e, t.open();
                        });
                    }, t.prototype.beforeDestruct = function(e) {
                        this.dialog && this.dialog.destruct(), e.e.off(e.editor, ".imageproperties").off(".imageproperties");
                    }, n.__decorate([
                        (0, l.watch)("state.marginIsLocked")
                    ], t.prototype, "onChangeMarginIsLocked", null), n.__decorate([
                        (0, l.watch)("state.sizeIsLocked")
                    ], t.prototype, "onChangeSizeIsLocked", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "onApply", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "openImageEditor", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "openImagePopup", null), t;
                }(r.Plugin);
                t.imageProperties = v, u.pluginSystem.add("imageProperties", v);
            },
            49391: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.form = void 0;
                var n = o(77904);
                t.form = function(e) {
                    var t = e.o.image, o = t.showPreview, r = t.editSize, i = n.Icon.get.bind(n.Icon);
                    return e.c.fromHTML('<form class="jodit-properties">\n\t\t<div class="jodit-grid jodit-grid_xs-column">\n\t\t\t<div class="jodit_col-lg-2-5 jodit_col-xs-5-5">\n\t\t\t\t<div class="jodit-properties_view_box">\n\t\t\t\t\t<div style="'.concat(o ? "" : "display:none", '" class="jodit-properties_image_view">\n\t\t\t\t\t\t<img data-ref="imageViewSrc" src="" alt=""/>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div style="').concat(r ? "" : "display:none", '" class="jodit-form__group jodit-properties_image_sizes">\n\t\t\t\t\t\t<input data-ref="imageWidth" type="text" class="jodit-input"/>\n\t\t\t\t\t\t<a data-ref="lockSize" class="jodit-properties__lock">').concat(i("lock"), '</a>\n\t\t\t\t\t\t<input data-ref="imageHeight" type="text" class="imageHeight jodit-input"/>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div data-ref="tabsBox" class="jodit_col-lg-3-5 jodit_col-xs-5-5"></div>\n\t\t</div>\n\t</form>'));
                };
            },
            27506: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mainTab = void 0;
                var n = o(77904);
                t.mainTab = function(e) {
                    var t = e.o, o = e.i18n.bind(e), r = n.Icon.get.bind(n.Icon), i = t.filebrowser.ajax.url || t.uploader.url, a = t.image.useImageEditor;
                    return e.c.fromHTML('<div style="'.concat(t.image.editSrc ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Src"), '</label>\n\t\t\t<div class="jodit-input_group">\n\t\t\t\t<input data-ref="imageSrc" class="jodit-input" type="text"/>\n\t\t\t\t<div\n\t\t\t\t\tclass="jodit-input_group-buttons"\n\t\t\t\t\tstyle="').concat(i ? "" : "display: none", '"\n\t\t\t\t>\n\t\t\t\t\t\t<a\n\t\t\t\t\t\t\tdata-ref="changeImage"\n\t\t\t\t\t\t\tclass="jodit-button"\n\t\t\t\t\t\t>').concat(r("image"), '</a>\n\t\t\t\t\t\t<a\n\t\t\t\t\t\t\tdata-ref="editImage"\n\t\t\t\t\t\t\tclass="jodit-button"\n\t\t\t\t\t\t\tstyle="').concat(a ? "" : "display: none", '"\n\t\t\t\t\t\t>').concat(r("crop"), '</a>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div style="').concat(t.image.editTitle ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Title"), '</label>\n\t\t\t<input data-ref="imageTitle" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editAlt ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Alternative"), '</label>\n\t\t\t<input data-ref="imageAlt" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editLink ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Link"), '</label>\n\t\t\t<input data-ref="imageLink" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editLink ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label class="jodit_vertical_middle">\n\t\t\t\t<input data-ref="imageLinkOpenInNewTab" type="checkbox" class="jodit-checkbox"/>\n\t\t\t\t<span>').concat(o("Open link in new tab"), "</span>\n\t\t\t</label>\n\t\t</div>"));
                };
            },
            50109: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.positionTab = void 0;
                var n = o(77904);
                t.positionTab = function(e) {
                    var t = e.o, o = e.i18n.bind(e), r = n.Icon.get.bind(n.Icon), i = [];
                    return t.image.availableClasses.length > 0 ? (i.push('<select data-ref="classes" class="jodit-input jodit-select">'), t.image.availableClasses.forEach(function(e) {
                        i.push("string" == typeof e ? '<option value="'.concat(e, '">').concat(e, "</option>") : '<option value="'.concat(e[0], '">').concat(e[1], "</option>"));
                    }), i.push("</select>")) : i.push('<input data-ref="classes" type="text" class="jodit-input"/>'), e.c.fromHTML('<div style="'.concat(t.image.editMargins ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Margins"), '</label>\n\t\t\t<div class="jodit-grid jodit_vertical_middle">\n\t\t\t\t<input class="jodit_col-lg-1-5 jodit-input" data-ref="marginTop" type="text" placeholder="').concat(o("top"), '"/>\n\t\t\t\t<a style="text-align: center;" data-ref="lockMargin" class="jodit-properties__lock jodit_col-lg-1-5">').concat(r("lock"), '</a>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginRight" type="text" placeholder="').concat(o("right"), '"/>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginBottom" type="text" placeholder="').concat(o("bottom"), '"/>\n\t\t\t\t<input disabled="true" class="jodit_col-lg-1-5 jodit-input" data-ref="marginLeft" type="text" placeholder="').concat(o("left"), '"/>\n\t\t\t</div>\n\t\t</div>\n\t\t<div\n\t\t\tstyle="').concat(t.image.editAlign ? "" : "display:none", '"\n\t\t\tclass="jodit-form__group"\n\t\t>\n\t\t\t<label>').concat(o("Align"), '</label>\n\t\t\t<select data-ref="align" class="jodit-select">\n\t\t\t\t<option value="">').concat(o("--Not Set--"), '</option>\n\t\t\t\t<option value="left">').concat(o("Left"), '</option>\n\t\t\t\t<option value="center">').concat(o("Center"), '</option>\n\t\t\t\t<option value="right">').concat(o("Right"), '</option>\n\t\t\t</select>\n\t\t</div>\n\t\t<div style="').concat(t.image.editStyle ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Styles"), '</label>\n\t\t\t<input data-ref="style" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div style="').concat(t.image.editClass ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>').concat(o("Classes"), "</label>\n\t\t\t").concat(i.join(""), '\n\t\t</div>\n\t\t<div style="').concat(t.image.editId ? "" : "display:none", '" class="jodit-form__group">\n\t\t\t<label>Id</label>\n\t\t\t<input data-ref="id" type="text" class="jodit-input"/>\n\t\t</div>\n\t\t<div\n\t\t\tstyle="').concat(t.image.editBorderRadius ? "" : "display:none", '"\n\t\t\tclass="jodit-form__group"\n\t\t>\n\t\t\t<label>').concat(o("Border radius"), '</label>\n\t\t\t\t<input data-ref="borderRadius" type="number" class="jodit-input"/>\n\t\t</div>'));
                };
            },
            67547: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.image = void 0;
                var n = o(20255), r = o(64968), i = o(40332), a = o(718), s = o(93166), l = o(17332);
                function c(e) {
                    e.registerButton({
                        name: "image",
                        group: "media"
                    });
                }
                o(77904).Icon.set("image", o(53477)), s.Config.prototype.controls.image = {
                    popup: function(e, t, o, s) {
                        var l = null;
                        return t && !r.Dom.isText(t) && r.Dom.isHTMLElement(t) && (r.Dom.isTag(t, "img") || (0, i.$$)("img", t).length) && (l = r.Dom.isTag(t, "img") ? t : (0, i.$$)("img", t)[0]), e.s.save(), (0, a.FileSelectorWidget)(e, {
                            filebrowser: function(t) {
                                e.s.restore(), t.files && t.files.forEach(function(o) {
                                    return e.s.insertImage(t.baseurl + o, null, e.o.imageDefaultWidth);
                                }), s();
                            },
                            upload: !0,
                            url: function(t, o) {
                                return n.__awaiter(void 0, void 0, void 0, function() {
                                    var r;
                                    return n.__generator(this, function(n) {
                                        switch(n.label){
                                            case 0:
                                                return e.s.restore(), /^[a-z\d_-]+(\.[a-z\d_-]+)+/i.test(t) && (t = "//" + t), (r = l || e.createInside.element("img")).setAttribute("src", t), r.setAttribute("alt", o), l ? [
                                                    3,
                                                    2
                                                ] : [
                                                    4,
                                                    e.s.insertImage(r, null, e.o.imageDefaultWidth)
                                                ];
                                            case 1:
                                                n.sent(), n.label = 2;
                                            case 2:
                                                return s(), [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            }
                        }, l, s);
                    },
                    tags: [
                        "img"
                    ],
                    tooltip: "Insert Image"
                }, t.image = c, l.pluginSystem.add("image", c);
            },
            2916: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(64968), i = o(77904), a = o(26011);
                i.Icon.set("indent", o(90053)).set("outdent", o(72230)), n.Config.prototype.controls.indent = {
                    tooltip: "Increase Indent"
                }, n.Config.prototype.controls.outdent = {
                    isDisabled: function(e) {
                        var t = e.s.current();
                        if (t) {
                            var o = r.Dom.closest(t, r.Dom.isBlock, e.editor);
                            if (o) {
                                var n = (0, a.getKey)(e.o.direction, o);
                                return !o.style[n] || 0 >= parseInt(o.style[n], 10);
                            }
                        }
                        return !0;
                    },
                    tooltip: "Decrease Indent"
                }, n.Config.prototype.indentMargin = 10;
            },
            26011: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.getKey = void 0;
                var n = o(24263);
                t.getKey = function(e, t) {
                    return "".concat(n.Dom.isCell(t) ? "padding" : "margin").concat("rtl" === e ? "Right" : "Left");
                };
            },
            71838: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.indent = void 0;
                var n = o(86893), r = o(64968), i = o(40332), a = o(17332);
                o(2916);
                var s = o(26011);
                function l(e) {
                    e.registerButton({
                        name: "indent",
                        group: "indent"
                    }).registerButton({
                        name: "outdent",
                        group: "indent"
                    });
                    var t = function(t) {
                        var o = [];
                        return e.s.eachSelection(function(a) {
                            e.s.save();
                            var l = !!a && r.Dom.up(a, r.Dom.isBlock, e.editor), c = e.o.enter;
                            if (!l && a && (l = r.Dom.wrapInline(a, c !== n.BR ? c : n.PARAGRAPH, e)), !l) return e.s.restore(), !1;
                            var u = o.includes(l);
                            if (l && !u) {
                                var d = (0, s.getKey)(e.o.direction, l);
                                o.push(l);
                                var p = l.style[d] ? parseInt(l.style[d], 10) : 0;
                                l.style[d] = (p += e.o.indentMargin * ("outdent" === t ? -1 : 1)) > 0 ? p + "px" : "", (0, i.attr)(l, "style") || (0, i.attr)(l, "style", null);
                            }
                            e.s.restore();
                        }), e.synchronizeValues(), !1;
                    };
                    e.registerCommand("indent", {
                        exec: t,
                        hotkeys: [
                            "ctrl+]",
                            "cmd+]"
                        ]
                    }), e.registerCommand("outdent", {
                        exec: t,
                        hotkeys: [
                            "ctrl+[",
                            "cmd+["
                        ]
                    });
                }
                t.indent = l, a.pluginSystem.add("indent", l);
            },
            70022: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(55692), o(66031), o(91241), o(87565), o(60894), o(90302), o(92138), o(88412), o(79308), o(19268), o(30598), o(33122), o(10135), o(66994), o(54798), o(12908), o(65123), o(83228), o(43889), o(93300), o(67547), o(92575), o(15747), o(71838), o(54752), o(54452), o(46324), o(27738), o(61421), o(27582), o(76303), o(19806), o(52598), o(19483), o(15428), o(47224), o(83211), o(88297), o(72930), o(51197), o(2327), o(47608), o(90523), o(69257), o(14889), o(95323), o(37458), o(71003), o(86030), o(17002), o(1557), o(82808), o(48560), o(32246), o(45842), o(23308), o(19889), o(20728), o(96899), o(18238);
            },
            35387: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(77904);
                n.Config.prototype.toolbarInline = !0, n.Config.prototype.toolbarInlineForSelection = !1, n.Config.prototype.toolbarInlineDisableFor = [], n.Config.prototype.toolbarInlineDisabledButtons = [
                    "source"
                ], r.Icon.set("addcolumn", o(78321)).set("addrow", o(77654)).set("merge", o(43371)).set("th", o(52242)).set("splitg", o(44563)).set("splitv", o(53183)).set("th-list", o(18548)), n.Config.prototype.popup = {
                    a: o(27487).Z,
                    img: o(97425).default,
                    cells: o(59500).Z,
                    toolbar: o(55350).Z,
                    jodit: o(66686).Z,
                    iframe: o(66686).Z,
                    "jodit-media": o(66686).Z,
                    selection: [
                        "bold",
                        "underline",
                        "italic",
                        "ul",
                        "ol",
                        "\n",
                        "outdent",
                        "indent",
                        "fontsize",
                        "brush",
                        "cut",
                        "\n",
                        "paragraph",
                        "link",
                        "align",
                        "dots"
                    ]
                };
            },
            27487: function(e, t, o) {
                "use strict";
                var n = o(76502);
                t.Z = [
                    {
                        name: "eye",
                        tooltip: "Open link",
                        exec: function(e, t) {
                            var o = (0, n.attr)(t, "href");
                            t && o && e.ow.open(o);
                        }
                    },
                    {
                        name: "link",
                        tooltip: "Edit link",
                        icon: "pencil"
                    },
                    "unlink",
                    "brush",
                    "file"
                ];
            },
            59500: function(e, t, o) {
                "use strict";
                var n = o(10172), r = o(26911), i = o(718), a = function(e) {
                    return e.args && (0, n.isString)(e.args[0]) ? e.args[0].toLowerCase() : "";
                };
                t.Z = [
                    {
                        name: "brush",
                        popup: function(e, t, o, a) {
                            if ((0, n.isJoditObject)(e)) {
                                var s = e.getInstance("Table", e.o).getAllSelectedCells();
                                if (!s.length) return !1;
                                var l = function(t) {
                                    return (0, i.ColorPickerWidget)(e, function(o) {
                                        s.forEach(function(e) {
                                            (0, r.css)(e, t, o);
                                        }), e.lock(), e.synchronizeValues(), a(), e.unlock();
                                    }, (0, r.css)(s[0], t));
                                };
                                return (0, i.TabsWidget)(e, [
                                    {
                                        name: "Background",
                                        content: l("background-color")
                                    },
                                    {
                                        name: "Text",
                                        content: l("color")
                                    },
                                    {
                                        name: "Border",
                                        content: l("border-color")
                                    }
                                ]);
                            }
                        },
                        tooltip: "Background"
                    },
                    {
                        name: "valign",
                        list: [
                            "Top",
                            "Middle",
                            "Bottom",
                            "Normal"
                        ],
                        childTemplate: function(e, t, o) {
                            return o;
                        },
                        exec: function(e, t, o) {
                            var n = a(o.control);
                            e.getInstance("Table", e.o).getAllSelectedCells().forEach(function(e) {
                                (0, r.css)(e, "vertical-align", "normal" === n ? "" : n);
                            });
                        },
                        tooltip: "Vertical align"
                    },
                    {
                        name: "splitv",
                        list: {
                            tablesplitv: "Split vertical",
                            tablesplitg: "Split horizontal"
                        },
                        tooltip: "Split"
                    },
                    {
                        name: "align",
                        icon: "left"
                    },
                    "\n",
                    {
                        name: "merge",
                        command: "tablemerge",
                        tooltip: "Merge"
                    },
                    {
                        name: "addcolumn",
                        list: {
                            tableaddcolumnbefore: "Insert column before",
                            tableaddcolumnafter: "Insert column after"
                        },
                        exec: function(e, t, o) {
                            var r = o.control;
                            if ((0, n.isJoditObject)(e)) {
                                var i = a(r);
                                e.execCommand(i, !1, t);
                            }
                        },
                        tooltip: "Add column"
                    },
                    {
                        name: "addrow",
                        list: {
                            tableaddrowbefore: "Insert row above",
                            tableaddrowafter: "Insert row below"
                        },
                        exec: function(e, t, o) {
                            var r = o.control;
                            if ((0, n.isJoditObject)(e)) {
                                var i = a(r);
                                e.execCommand(i, !1, t);
                            }
                        },
                        tooltip: "Add row"
                    },
                    {
                        name: "delete",
                        icon: "bin",
                        list: {
                            tablebin: "Delete table",
                            tablebinrow: "Delete row",
                            tablebincolumn: "Delete column",
                            tableempty: "Empty cell"
                        },
                        exec: function(e, t, o) {
                            var r = o.control;
                            if ((0, n.isJoditObject)(e)) {
                                var i = a(r);
                                e.execCommand(i, !1, t), e.e.fire("hidePopup");
                            }
                        },
                        tooltip: "Delete"
                    }
                ];
            },
            66686: function(e, t, o) {
                "use strict";
                var n = o(97425);
                t.Z = [
                    {
                        name: "bin",
                        tooltip: "Delete",
                        exec: function(e, t) {
                            t && e.s.removeNode(t);
                        }
                    },
                    n.align
                ];
            },
            97425: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.align = void 0;
                var n = o(64968), r = o(24421), i = o(26911), a = o(60303);
                t.align = {
                    name: "left",
                    childTemplate: function(e, t, o) {
                        return o;
                    },
                    list: [
                        "Left",
                        "Right",
                        "Center",
                        "Normal"
                    ],
                    exec: function(e, t, o) {
                        var i = o.control;
                        if (n.Dom.isTag(t, [
                            "img",
                            "jodit",
                            "jodit-media"
                        ])) {
                            var s = i.args && (0, r.isString)(i.args[0]) ? i.args[0].toLowerCase() : "";
                            if (!s) return !1;
                            (0, a.hAlignElement)(t, s), n.Dom.isTag(t, [
                                "jodit",
                                "jodit-media"
                            ]) && t.firstElementChild && (0, a.hAlignElement)(t.firstElementChild, s), e.synchronizeValues(), e.e.fire("recalcPositionPopup");
                        }
                    },
                    tooltip: "Horizontal align"
                }, t.default = [
                    {
                        name: "delete",
                        icon: "bin",
                        tooltip: "Delete",
                        exec: function(e, t) {
                            t && e.s.removeNode(t);
                        }
                    },
                    {
                        name: "pencil",
                        exec: function(e, t) {
                            "img" === t.tagName.toLowerCase() && e.e.fire("openImageProperties", t);
                        },
                        tooltip: "Edit"
                    },
                    {
                        name: "valign",
                        list: [
                            "Top",
                            "Middle",
                            "Bottom",
                            "Normal"
                        ],
                        tooltip: "Vertical align",
                        exec: function(e, t, o) {
                            var a = o.control;
                            if (n.Dom.isTag(t, "img")) {
                                var s = a.args && (0, r.isString)(a.args[0]) ? a.args[0].toLowerCase() : "";
                                if (!s) return !1;
                                (0, i.css)(t, "vertical-align", "normal" === s ? "" : s), e.e.fire("recalcPositionPopup");
                            }
                        }
                    },
                    t.align
                ];
            },
            55350: function(e, t) {
                "use strict";
                t.Z = [
                    "bold",
                    "italic",
                    "|",
                    "ul",
                    "ol",
                    "eraser",
                    "|",
                    "fontsize",
                    "brush",
                    "paragraph",
                    "---",
                    "image",
                    "table",
                    "\n",
                    "link",
                    "|",
                    "align",
                    "|",
                    "undo",
                    "redo",
                    "|",
                    "copyformat",
                    "fullsize",
                    "---",
                    "dots"
                ];
            },
            54752: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.inlinePopup = void 0;
                var n = o(20255);
                o(45109);
                var r = o(57549), i = o(81438), a = o(35799), s = o(40332), l = o(64968), c = o(2074), u = o(43441), d = o(17332);
                o(35387);
                var p = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.requires = [
                            "select"
                        ], t.type = null, t.popup = new a.Popup(t.jodit, !1), t.toolbar = (0, i.makeCollection)(t.jodit, t.popup), t.snapRange = null, t.elmsList = (0, s.keys)(t.j.o.popup, !1).filter(function(e) {
                            return !t.isExcludedTarget(e);
                        }), t;
                    }
                    return n.__extends(t, e), t.prototype.onClick = function(e) {
                        var t = this, o = this.elmsList, n = l.Dom.isTag(e, "img") ? e : l.Dom.closest(e, o, this.j.editor);
                        if (n && this.canShowPopupForType(n.nodeName.toLowerCase())) return this.showPopup(function() {
                            return (0, s.position)(n, t.j);
                        }, n.nodeName.toLowerCase(), n), !1;
                    }, t.prototype.showPopup = function(e, t, o) {
                        if (t = t.toLowerCase(), !this.canShowPopupForType(t)) return !1;
                        if (this.type !== t || o !== this.previousTarget) {
                            this.previousTarget = o;
                            var n = this.j.o.popup[t], r = void 0;
                            r = (0, s.isFunction)(n) ? n(this.j, o, this.popup.close) : n, (0, s.isArray)(r) && (this.toolbar.build(r, o), this.toolbar.buttonSize = this.j.o.toolbarButtonSize, r = this.toolbar.container), this.popup.setContent(r), this.type = t;
                        }
                        return this.popup.open(e), !0;
                    }, t.prototype.hidePopup = function(e) {
                        (0, s.isString)(e) && e !== this.type || this.popup.close();
                    }, t.prototype.onOutsideClick = function() {
                        this.popup.close();
                    }, t.prototype.canShowPopupForType = function(e) {
                        var t = this.j.o.popup[e.toLowerCase()];
                        return !(this.j.o.readonly || !this.j.o.toolbarInline || !t || this.isExcludedTarget(e));
                    }, t.prototype.isExcludedTarget = function(e) {
                        return (0, s.splitArray)(this.j.o.toolbarInlineDisableFor).map(function(e) {
                            return e.toLowerCase();
                        }).includes(e.toLowerCase());
                    }, t.prototype.afterInit = function(e) {
                        var t = this;
                        this.j.e.on("getDiffButtons.mobile", function(o) {
                            if (t.toolbar === o) {
                                var n = t.toolbar.getButtonsNames();
                                return (0, s.toArray)(e.registeredButtons).filter(function(e) {
                                    return !t.j.o.toolbarInlineDisabledButtons.includes(e.name);
                                }).filter(function(e) {
                                    var t = (0, s.isString)(e) ? e : e.name;
                                    return t && "|" !== t && "\n" !== t && !n.includes(t);
                                });
                            }
                        }).on("hidePopup", this.hidePopup).on("showInlineToolbar", this.showInlineToolbar).on("showPopup", function(e, o, n) {
                            t.showPopup(o, n || ((0, s.isString)(e) ? e : e.nodeName), (0, s.isString)(e) ? void 0 : e);
                        }).on("mousedown keydown", this.onSelectionStart).on("change", function() {
                            t.popup.isOpened && t.previousTarget && !t.previousTarget.parentNode && (t.hidePopup(), t.previousTarget = void 0);
                        }).on([
                            this.j.ew,
                            this.j.ow
                        ], "mouseup keyup", this.onSelectionEnd), this.addListenersForElements();
                    }, t.prototype.onSelectionStart = function() {
                        this.snapRange = this.j.s.range.cloneRange();
                    }, t.prototype.onSelectionEnd = function(e) {
                        if (!(e && e.target && c.UIElement.closestElement(e.target, a.Popup))) {
                            var t = this.snapRange, o = this.j.s.range;
                            t && !o.collapsed && o.startContainer === t.startContainer && o.startOffset === t.startOffset && o.endContainer === t.endContainer && o.endOffset === t.endOffset || this.onSelectionChange();
                        }
                    }, t.prototype.onSelectionChange = function() {
                        if (this.j.o.toolbarInlineForSelection) {
                            var e = "selection", t = this.j.s.sel, o = this.j.s.range;
                            (null == t ? void 0 : t.isCollapsed) || this.isSelectedTarget(o) || this.tableModule.getAllSelectedCells().length ? this.type === e && this.popup.isOpened && this.hidePopup() : this.j.s.current() && this.showPopup(function() {
                                return o.getBoundingClientRect();
                            }, e);
                        }
                    }, t.prototype.isSelectedTarget = function(e) {
                        var t = e.startContainer;
                        return l.Dom.isElement(t) && t === e.endContainer && l.Dom.isTag(t.childNodes[e.startOffset], (0, s.keys)(this.j.o.popup, !1)) && e.startOffset === e.endOffset - 1;
                    }, Object.defineProperty(t.prototype, "tableModule", {
                        get: function() {
                            return this.j.getInstance("Table", this.j.o);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.beforeDestruct = function(e) {
                        e.e.off("showPopup").off([
                            this.j.ew,
                            this.j.ow
                        ], "mouseup keyup", this.onSelectionEnd), this.removeListenersForElements();
                    }, t.prototype._eventsList = function() {
                        var e = this.elmsList;
                        return e.map(function(e) {
                            return (0, s.camelCase)("click_".concat(e));
                        }).concat(e.map(function(e) {
                            return (0, s.camelCase)("touchstart_".concat(e));
                        })).join(" ");
                    }, t.prototype.addListenersForElements = function() {
                        this.j.e.on(this._eventsList(), this.onClick);
                    }, t.prototype.removeListenersForElements = function() {
                        this.j.e.off(this._eventsList(), this.onClick);
                    }, t.prototype.showInlineToolbar = function(e) {
                        var t = this;
                        this.showPopup(function() {
                            return e || t.j.s.range.getBoundingClientRect();
                        }, "toolbar");
                    }, n.__decorate([
                        u.autobind
                    ], t.prototype, "onClick", null), n.__decorate([
                        (0, u.wait)(function(e) {
                            return !e.j.isLocked;
                        })
                    ], t.prototype, "showPopup", null), n.__decorate([
                        (0, u.watch)(":clickEditor"),
                        u.autobind
                    ], t.prototype, "hidePopup", null), n.__decorate([
                        (0, u.watch)(":outsideClick")
                    ], t.prototype, "onOutsideClick", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onSelectionStart", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onSelectionEnd", null), n.__decorate([
                        (0, u.debounce)(function(e) {
                            return e.defaultTimeout;
                        })
                    ], t.prototype, "onSelectionChange", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "showInlineToolbar", null), t;
                }(r.Plugin);
                t.inlinePopup = p, d.pluginSystem.add("inlinePopup", p);
            },
            54452: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.justify = void 0;
                var n = o(93166), r = o(24263), i = o(26911), a = o(60303), s = o(17332);
                function l(e) {
                    e.registerButton({
                        name: "align",
                        group: "indent"
                    });
                    var t = function(t) {
                        return e.s.focus(), e.s.eachSelection(function(o) {
                            if (o) {
                                var n = r.Dom.up(o, r.Dom.isBlock, e.editor);
                                n || (n = r.Dom.wrapInline(o, e.o.enterBlock, e)), (0, a.alignElement)(t, n);
                            }
                        }), !1;
                    };
                    e.registerCommand("justifyfull", t), e.registerCommand("justifyright", t), e.registerCommand("justifyleft", t), e.registerCommand("justifycenter", t);
                }
                o(77904).Icon.set("justify", o(87498)), n.Config.prototype.controls.align = {
                    name: "left",
                    tooltip: "Align",
                    update: function(e, t) {
                        var o = e.control, n = t.s.current();
                        if (n) {
                            var a = r.Dom.closest(n, r.Dom.isBlock, t.editor) || t.editor, s = (0, i.css)(a, "text-align").toString();
                            o.defaultValue && -1 !== o.defaultValue.indexOf(s) && (s = "left"), o.data && o.data.currentValue !== s && o.list && -1 !== o.list.indexOf(s) && (t.o.textIcons ? e.state.text = s : e.state.icon.name = s, o.data.currentValue = s);
                        }
                    },
                    isActive: function(e, t) {
                        var o = e.s.current();
                        if (o && t.defaultValue) {
                            var n = r.Dom.closest(o, r.Dom.isBlock, e.editor) || e.editor;
                            return -1 === t.defaultValue.indexOf((0, i.css)(n, "text-align").toString());
                        }
                        return !1;
                    },
                    defaultValue: [
                        "left",
                        "start",
                        "inherit"
                    ],
                    data: {
                        currentValue: "left"
                    },
                    list: [
                        "center",
                        "left",
                        "right",
                        "justify"
                    ]
                }, n.Config.prototype.controls.center = {
                    command: "justifyCenter",
                    css: {
                        "text-align": "center"
                    },
                    tooltip: "Align Center"
                }, n.Config.prototype.controls.justify = {
                    command: "justifyFull",
                    css: {
                        "text-align": "justify"
                    },
                    tooltip: "Align Justify"
                }, n.Config.prototype.controls.left = {
                    command: "justifyLeft",
                    css: {
                        "text-align": "left"
                    },
                    tooltip: "Align Left"
                }, n.Config.prototype.controls.right = {
                    command: "justifyRight",
                    css: {
                        "text-align": "right"
                    },
                    tooltip: "Align Right"
                }, t.justify = l, s.pluginSystem.add("justify", l);
            },
            46324: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.keyArrowOutside = void 0;
                var n = o(20255), r = o(57549), i = o(43441), a = o(86893), s = o(24263), l = o(17332), c = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {}, t.prototype.beforeDestruct = function(e) {}, t.prototype.onKeyDownArrow = function(e) {
                        var t;
                        if (e.key === a.KEY_RIGHT && this.j.selection.isCollapsed()) {
                            var o = this.j.selection.range, n = o.endContainer, r = o.endOffset;
                            if (s.Dom.isText(n) && (null === (t = n.nodeValue) || void 0 === t ? void 0 : t.length) === r) {
                                var i = n.parentNode;
                                s.Dom.isInlineBlock(i) && !s.Dom.findNotEmptyNeighbor(i, !1, this.j.editor) && s.Dom.after(i, this.j.createInside.text(a.NBSP_SPACE));
                            }
                        }
                    }, n.__decorate([
                        (0, i.watch)(":keydown")
                    ], t.prototype, "onKeyDownArrow", null), t;
                }(r.Plugin);
                t.keyArrowOutside = c, l.pluginSystem.add("keyArrowOutside", c);
            },
            19250: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.limitWords = !1, n.Config.prototype.limitChars = !1, n.Config.prototype.limitHTML = !1;
            },
            27738: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.limit = void 0;
                var n = o(20255), r = o(57549), i = o(86893), a = o(43441), s = o(17332);
                o(19250);
                var l = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this, o = e.o;
                        if (e && (o.limitWords || o.limitChars)) {
                            var n = null;
                            e.e.off(".limit").on("beforePaste.limit", function() {
                                n = e.history.snapshot.make();
                            }).on("keydown.limit keyup.limit beforeEnter.limit", this.checkPreventKeyPressOrPaste).on("change.limit", this.checkPreventChanging).on("afterPaste.limit", function() {
                                if (t.__shouldDenyInput(!0) && n) return e.history.snapshot.restore(n), e.e.fire("denyPaste.limit"), !1;
                            });
                        }
                    }, t.prototype.shouldPreventInsertHTML = function(e) {
                        return (!e || !(i.COMMAND_KEYS.includes(e.key) || e.ctrlKey || e.metaKey)) && this.__shouldDenyInput(!1);
                    }, t.prototype.__shouldDenyInput = function(e) {
                        var t = this.jodit, o = t.o, n = o.limitWords, r = o.limitChars, i = this.__splitWords(t.o.limitHTML ? t.value : t.text);
                        if (n && c(i.length, n, e)) return t.e.fire("denyWords.limit limit.limit"), !0;
                        var a = Boolean(r && c(i.join("").length, r, e));
                        return a && t.e.fire("denyChars.limit limit.limit"), a;
                    }, t.prototype.checkPreventKeyPressOrPaste = function(e) {
                        if (this.shouldPreventInsertHTML(e)) return !1;
                    }, t.prototype.checkPreventChanging = function(e, t) {
                        var o = this.jodit;
                        this.__shouldDenyInput(!0) && (o.value = t);
                    }, t.prototype.__splitWords = function(e) {
                        return e.replace((0, i.INVISIBLE_SPACE_REG_EXP)(), "").split((0, i.SPACE_REG_EXP)()).filter(function(e) {
                            return e.length;
                        });
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off(".limit");
                    }, n.__decorate([
                        a.autobind
                    ], t.prototype, "checkPreventKeyPressOrPaste", null), n.__decorate([
                        a.autobind
                    ], t.prototype, "checkPreventChanging", null), t;
                }(r.Plugin);
                function c(e, t, o) {
                    return o ? e > t : e >= t;
                }
                t.limit = l, s.pluginSystem.add("limit", l);
            },
            29490: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(40332), i = o(77904);
                n.Config.prototype.defaultLineHeight = null, i.Icon.set("line-height", o(7986)), n.Config.prototype.controls.lineHeight = {
                    command: "applyLineHeight",
                    tags: [
                        "ol"
                    ],
                    tooltip: "Line height",
                    list: [
                        1,
                        1.1,
                        1.2,
                        1.3,
                        1.4,
                        1.5,
                        2
                    ],
                    exec: function(e, t, o) {
                        return (0, r.memorizeExec)(e, t, {
                            control: o.control
                        }, function(e) {
                            return e;
                        });
                    }
                };
            },
            26752: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
                var n = o(47762);
                t.ar = n;
                var r = o(97495);
                t.cs_cz = r;
                var i = o(80131);
                t.de = i;
                var a = o(1201);
                t.es = a;
                var s = o(89912);
                t.fa = s;
                var l = o(3405);
                t.fr = l;
                var c = o(14129);
                t.he = c;
                var u = o(93729);
                t.hu = u;
                var d = o(16106);
                t.id = d;
                var p = o(89690);
                t.it = p;
                var f = o(33216);
                t.ja = f;
                var h = o(17282);
                t.ko = h;
                var m = o(52841);
                t.mn = m;
                var v = o(91761);
                t.nl = v;
                var g = o(61675);
                t.pl = g;
                var y = o(69709);
                t.pt_br = y;
                var _ = o(82591);
                t.ru = _;
                var b = o(87649);
                t.tr = b;
                var w = o(60268);
                t.zh_cn = w;
                var S = o(58214);
                t.zh_tw = S;
            },
            61421: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.lineHeight = void 0;
                var n = o(20255), r = o(57549), i = o(40332), a = o(43441), s = o(24263), l = o(17332);
                o(29490);
                var c = function(e) {
                    function t(t) {
                        var n = e.call(this, t) || this;
                        return n.buttons = [
                            {
                                name: "lineHeight",
                                group: "font"
                            }
                        ], (0, l.extendLang)(o(26752)), n;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        (0, i.css)(e.editor, {
                            lineHeight: e.o.defaultLineHeight
                        }), e.registerCommand("applyLineHeight", this.applyLineHeight);
                    }, t.prototype.applyLineHeight = function(e, t, o) {
                        var n, r = this.j, a = r.s, l = r.createInside, c = r.editor, u = r.o;
                        a.isFocused() || a.focus(), a.save();
                        var d = function(e) {
                            var t = s.Dom.closest(e, s.Dom.isBlock, c);
                            t || (t = s.Dom.wrap(e, u.enter, l));
                            var r = (0, i.css)(t, "lineHeight");
                            void 0 === n && (n = r.toString() !== o.toString()), (0, i.css)(t, "lineHeight", n ? o : null);
                        };
                        try {
                            if (a.isCollapsed()) {
                                var p = l.fake();
                                a.insertNode(p, !1, !1), d(p), s.Dom.safeRemove(p);
                            } else a.eachSelection(d);
                        } finally{
                            a.restore();
                        }
                    }, t.prototype.beforeDestruct = function(e) {
                        (0, i.css)(e.editor, {
                            lineHeight: null
                        });
                    }, n.__decorate([
                        a.autobind
                    ], t.prototype, "applyLineHeight", null), t;
                }(r.Plugin);
                t.lineHeight = c, l.pluginSystem.add("lineHeight", c);
            },
            56367: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(54238), i = o(24263), a = o(77904);
                n.Config.prototype.link = {
                    formTemplate: r.formTemplate,
                    followOnDblClick: !1,
                    processVideoLink: !0,
                    processPastedLink: !0,
                    noFollowCheckbox: !0,
                    openInNewTabCheckbox: !0,
                    modeClassName: "input",
                    selectMultipleClassName: !0,
                    selectSizeClassName: 3,
                    selectOptionsClassName: [],
                    hotkeys: [
                        "ctrl+k",
                        "cmd+k"
                    ]
                }, a.Icon.set("link", o(23075)).set("unlink", o(10655)), n.Config.prototype.controls.unlink = {
                    exec: function(e, t) {
                        var o = i.Dom.closest(t, "a", e.editor);
                        o && i.Dom.unwrap(o), e.synchronizeValues(), e.e.fire("hidePopup");
                    },
                    tooltip: "Unlink"
                }, n.Config.prototype.controls.link = {
                    isActive: function(e) {
                        var t = e.s.current();
                        return Boolean(t && i.Dom.closest(t, "a", e.editor));
                    },
                    popup: function(e, t, o, n) {
                        return e.e.fire("generateLinkForm.link", t, n);
                    },
                    tags: [
                        "a"
                    ],
                    tooltip: "Insert link"
                };
            },
            27582: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.link = void 0;
                var n = o(20255), r = o(64968), i = o(40332), a = o(57549), s = o(43441), l = o(17332);
                o(56367);
                var c = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.buttons = [
                            {
                                name: "link",
                                group: "insert"
                            }
                        ], t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.o.link.followOnDblClick && e.e.on("dblclick.link", this.onDblClickOnLink), e.o.link.processPastedLink && e.e.on("processPaste.link", this.onProcessPasteLink), e.e.on("generateLinkForm.link", this.__generateForm), e.registerCommand("openLinkDialog", {
                            exec: function() {
                                var o = e.dlg({
                                    resizable: !1
                                }), n = t.__generateForm(e.s.current(), function() {
                                    o.close();
                                });
                                n.container.classList.add("jodit-dialog_alert"), o.setContent(n), o.open(), e.async.requestIdleCallback(function() {
                                    var e = (0, i.refs)(n.container).url_input;
                                    null == e || e.focus();
                                });
                            },
                            hotkeys: e.o.link.hotkeys
                        });
                    }, t.prototype.onDblClickOnLink = function(e) {
                        if (r.Dom.isTag(e.target, "a")) {
                            var t = (0, i.attr)(e.target, "href");
                            t && (location.href = t, e.preventDefault());
                        }
                    }, t.prototype.onProcessPasteLink = function(e, t) {
                        var o = this.jodit;
                        if ((0, i.isURL)(t) && o.o.link.processPastedLink) {
                            if (o.e.stopPropagation("processPaste"), o.o.link.processVideoLink) {
                                var n = (0, i.convertMediaUrlToVideoEmbed)(t);
                                if (n !== t) return o.createInside.fromHTML(n);
                            }
                            if (o.s.isCollapsed()) {
                                var r = o.createInside.element("a");
                                return r.setAttribute("href", t), r.textContent = t, o.e.fire("applyLink", o, r, null), r;
                            }
                            return o.s.applyStyle(void 0, {
                                element: "a",
                                attributes: {
                                    href: t
                                }
                            }), !0;
                        }
                    }, t.prototype.__generateForm = function(e, t) {
                        var o, n = this.jodit, a = n.i18n.bind(n), s = n.o.link, l = s.openInNewTabCheckbox, c = s.noFollowCheckbox, u = s.formClassName, d = s.modeClassName, p = (0, s.formTemplate)(n), f = (0, i.isString)(p) ? n.c.fromHTML(p, {
                            target_checkbox_box: l,
                            nofollow_checkbox_box: c
                        }) : p, h = r.Dom.isElement(f) ? f : f.container, m = (0, i.refs)(h), v = m.insert, g = m.unlink, y = m.content_input_box, _ = m.target_checkbox, b = m.nofollow_checkbox, w = m.url_input, S = r.Dom.isImage(e), C = m.content_input, j = m.className_input, E = m.className_select;
                        C || (C = n.c.element("input", {
                            type: "hidden",
                            ref: "content_input"
                        })), u && h.classList.add(u), S && r.Dom.hide(y);
                        var x = function() {
                            return o ? o.innerText : (0, i.stripTags)(n.s.range.cloneContents(), n.ed);
                        };
                        if (o = !(!e || !r.Dom.closest(e, "a", n.editor)) && r.Dom.closest(e, "a", n.editor), !S && e && (C.value = x()), o) {
                            if (w.value = (0, i.attr)(o, "href") || "", d) switch(d){
                                case "input":
                                    j && (j.value = (0, i.attr)(o, "class") || "");
                                    break;
                                case "select":
                                    if (E) {
                                        for(var k = 0; E.selectedOptions.length > k; k++){
                                            var T = E.options.item(k);
                                            T && (T.selected = !1);
                                        }
                                        ((0, i.attr)(o, "class") || "").split(" ").forEach(function(e) {
                                            if (e) for(var t = 0; E.options.length > t; t++){
                                                var o = E.options.item(t);
                                                (null == o ? void 0 : o.value) && o.value === e && (o.selected = !0);
                                            }
                                        });
                                    }
                            }
                            l && _ && (_.checked = "_blank" === (0, i.attr)(o, "target")), c && b && (b.checked = "nofollow" === (0, i.attr)(o, "rel")), v.textContent = a("Update");
                        } else r.Dom.hide(g);
                        n.editor.normalize();
                        var I = n.history.snapshot.make();
                        g && n.e.on(g, "click", function(e) {
                            n.s.restore(), n.history.snapshot.restore(I), o && r.Dom.unwrap(o), n.synchronizeValues(), t(), e.preventDefault();
                        });
                        var P = function() {
                            if (!w.value.trim().length) return w.focus(), w.classList.add("jodit_error"), !1;
                            var e;
                            n.s.restore(), n.s.removeMarkers(), n.editor.normalize(), n.history.snapshot.restore(I);
                            var a = x() !== C.value.trim(), s = n.createInside;
                            if (o) e = [
                                o
                            ];
                            else {
                                if (n.s.isCollapsed()) {
                                    var u = s.element("a");
                                    n.s.insertNode(u, !1, !1), e = [
                                        u
                                    ];
                                } else {
                                    var p = n.s.current();
                                    e = r.Dom.isTag(p, [
                                        "img"
                                    ]) ? [
                                        r.Dom.wrap(p, "a", s)
                                    ] : n.s.wrapInTag("a");
                                }
                                e.forEach(function(e) {
                                    return n.s.select(e);
                                });
                            }
                            return e.forEach(function(e) {
                                var t;
                                if ((0, i.attr)(e, "href", w.value), d && (null != j ? j : E)) {
                                    if ("input" === d) "" === j.value && e.hasAttribute("class") && (0, i.attr)(e, "class", null), "" !== j.value && (0, i.attr)(e, "class", j.value);
                                    else if ("select" === d) {
                                        e.hasAttribute("class") && (0, i.attr)(e, "class", null);
                                        for(var o = 0; E.selectedOptions.length > o; o++){
                                            var r = null === (t = E.selectedOptions.item(o)) || void 0 === t ? void 0 : t.value;
                                            r && e.classList.add(r);
                                        }
                                    }
                                }
                                if (!S) {
                                    var s = e.textContent;
                                    C.value.trim().length ? a && (s = C.value) : s = w.value, s !== e.textContent && (e.textContent = s);
                                }
                                l && _ && (0, i.attr)(e, "target", _.checked ? "_blank" : null), c && b && (0, i.attr)(e, "rel", b.checked ? "nofollow" : null), n.e.fire("applyLink", n, e, f);
                            }), n.synchronizeValues(), t(), !1;
                        };
                        return r.Dom.isElement(f) ? n.e.on(f, "submit", function(e) {
                            return e.preventDefault(), e.stopImmediatePropagation(), P(), !1;
                        }) : f.onSubmit(P), f;
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off("generateLinkForm.link", this.__generateForm).off("dblclick.link", this.onDblClickOnLink).off("processPaste.link", this.onProcessPasteLink);
                    }, n.__decorate([
                        s.autobind
                    ], t.prototype, "onDblClickOnLink", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "onProcessPasteLink", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "__generateForm", null), t;
                }(a.Plugin);
                t.link = c, l.pluginSystem.add("link", c);
            },
            54238: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.formTemplate = void 0;
                var n = o(95963), r = o(96516);
                t.formTemplate = function(e) {
                    var t = e.o.link, o = t.openInNewTabCheckbox, i = t.noFollowCheckbox, a = t.modeClassName, s = t.selectSizeClassName, l = t.selectMultipleClassName, c = t.selectOptionsClassName;
                    return new n.UIForm(e, [
                        new n.UIBlock(e, [
                            new n.UIInput(e, {
                                name: "url",
                                type: "text",
                                ref: "url_input",
                                label: "URL",
                                placeholder: "http://",
                                required: !0
                            })
                        ]),
                        new n.UIBlock(e, [
                            new n.UIInput(e, {
                                name: "content",
                                ref: "content_input",
                                label: "Text"
                            })
                        ], {
                            ref: "content_input_box"
                        }),
                        a ? new n.UIBlock(e, [
                            "input" === a ? new n.UIInput(e, {
                                name: "className",
                                ref: "className_input",
                                label: "Class name"
                            }) : "select" === a ? new n.UISelect(e, {
                                name: "className",
                                ref: "className_select",
                                label: "Class name",
                                size: s,
                                multiple: l,
                                options: c
                            }) : null
                        ]) : null,
                        o ? new n.UICheckbox(e, {
                            name: "target",
                            ref: "target_checkbox",
                            label: "Open in new tab"
                        }) : null,
                        i ? new n.UICheckbox(e, {
                            name: "nofollow",
                            ref: "nofollow_checkbox",
                            label: "No follow"
                        }) : null,
                        new n.UIBlock(e, [
                            new r.UIButton(e, {
                                name: "unlink",
                                variant: "default",
                                text: "Unlink"
                            }),
                            new r.UIButton(e, {
                                name: "insert",
                                type: "submit",
                                variant: "primary",
                                text: "Insert"
                            })
                        ], {
                            align: "full"
                        })
                    ]);
                };
            },
            11737: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.mediaFakeTag = "jodit-media", n.Config.prototype.mediaInFakeBlock = !0, n.Config.prototype.mediaBlocks = [
                    "video",
                    "audio"
                ];
            },
            76303: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.media = void 0;
                var n = o(86893), r = o(76502), i = o(17332);
                function a(e) {
                    var t = "jodit_fake_wrapper", o = e.options, i = o.mediaFakeTag, a = o.mediaBlocks;
                    o.mediaInFakeBlock && e.e.on("afterGetValueFromEditor", function(e) {
                        var o = new RegExp("<".concat(i, "[^>]+data-").concat(t, "[^>]+>([^]+?)</").concat(i, ">"), "ig");
                        o.test(e.value) && (e.value = e.value.replace(o, "$1"));
                    }).on("change afterInit afterSetMode changePlace", e.async.debounce(function() {
                        e.isDestructed || e.getMode() === n.MODE_SOURCE || (0, r.$$)(a.join(","), e.editor).forEach(function(o) {
                            (0, r.dataBind)(o, t) || ((0, r.dataBind)(o, t, !0), function(o) {
                                var n;
                                if (o.parentNode && (0, r.attr)(o.parentNode, "data-jodit_iframe_wrapper")) o = o.parentNode;
                                else {
                                    var a = e.createInside.element(i, ((n = {
                                        "data-jodit-temp": 1,
                                        contenteditable: !1,
                                        draggable: !0
                                    })["data-".concat(t)] = 1, n));
                                    (0, r.attr)(a, "style", (0, r.attr)(o, "style")), a.style.display = "inline-block" === o.style.display ? "inline-block" : "block", a.style.width = o.offsetWidth + "px", a.style.height = o.offsetHeight + "px", o.parentNode && o.parentNode.insertBefore(a, o), a.appendChild(o), o = a;
                                }
                                e.e.off(o, "mousedown.select touchstart.select").on(o, "mousedown.select touchstart.select", function() {
                                    e.s.setCursorAfter(o);
                                });
                            }(o));
                        });
                    }, e.defaultTimeout));
                }
                o(11737), t.media = a, i.pluginSystem.add("media", a);
            },
            8860: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(86893), i = o(81438), a = o(40332), s = o(72719);
                n.Config.prototype.mobileTapTimeout = 300, n.Config.prototype.toolbarAdaptive = !0, n.Config.prototype.controls.dots = {
                    mode: r.MODE_SOURCE + r.MODE_WYSIWYG,
                    popup: function(e, t, o, n, r) {
                        var l = o.data;
                        return void 0 === l && (l = {
                            toolbar: (0, i.makeCollection)(e),
                            rebuild: function() {
                                var t;
                                if (r) {
                                    var o = e.e.fire("getDiffButtons.mobile", r.closest(s.ToolbarCollection));
                                    if (o && l) {
                                        l.toolbar.build((0, a.splitArray)(o));
                                        var n = (null === (t = e.toolbar.firstButton) || void 0 === t ? void 0 : t.container.offsetWidth) || 36;
                                        l.toolbar.container.style.width = 3 * (n + 4) + "px";
                                    }
                                }
                            }
                        }, o.data = l), l.rebuild(), l.toolbar;
                    },
                    tooltip: "Show all"
                };
            },
            19806: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mobile = void 0;
                var n = o(40332), r = o(97642), i = o(17332);
                function a(e) {
                    var t = 0, o = (0, n.splitArray)(e.o.buttons);
                    e.o.mobileTapTimeout && e.e.on("touchend", function(o) {
                        if (o.changedTouches && o.changedTouches.length) {
                            var n = (new Date).getTime(), r = n - t;
                            r > e.o.mobileTapTimeout && (t = n, 1.5 * e.o.mobileTapTimeout > r && e.s.insertCursorAtPoint(o.clientX, o.clientY));
                        }
                    }), e.e.on("getDiffButtons.mobile", function(t) {
                        if (t === e.toolbar) {
                            var i = (0, r.flatButtonsSet)((0, n.splitArray)(e.o.buttons), e), a = (0, r.flatButtonsSet)(o, e);
                            return (0, n.toArray)(i).reduce(function(e, t) {
                                return a.has(t) || e.push(t), e;
                            }, []);
                        }
                    }), e.o.toolbarAdaptive && e.e.on("resize afterInit recalcAdaptive changePlace afterAddPlace", function() {
                        var t;
                        if (e.o.toolbar) {
                            var r = (null !== (t = e.container.parentElement) && void 0 !== t ? t : e.container).offsetWidth, i = (0, n.splitArray)(e.isFullSize || r >= e.o.sizeLG ? e.o.buttons : e.o.sizeMD > r ? e.o.sizeSM > r ? e.o.buttonsXS : e.o.buttonsSM : e.o.buttonsMD);
                            i.toString() !== o.toString() && (o = i, e.e.fire("closeAllPopups"), e.toolbar.setRemoveButtons(e.o.removeButtons).build(o.concat(e.o.extraButtons)));
                        }
                    }).on(e.ow, "load resize", function() {
                        return e.e.fire("recalcAdaptive");
                    });
                }
                o(8860), t.mobile = a, i.pluginSystem.add("mobile", a);
            },
            73013: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(63122), i = function(e, t, o) {
                    var n, i = o.control, a = "button".concat(i.command), s = null !== (n = i.args && i.args[0]) && void 0 !== n ? n : (0, r.dataBind)(e, a);
                    (0, r.dataBind)(e, a, s), e.execCommand(i.command, !1, "default" === s ? null : s);
                };
                o(77904).Icon.set("ol", o(15476)).set("ul", o(59403)), n.Config.prototype.controls.ul = {
                    command: "insertUnorderedList",
                    tags: [
                        "ul"
                    ],
                    tooltip: "Insert Unordered List",
                    list: {
                        default: "Default",
                        circle: "Circle",
                        disc: "Dot",
                        square: "Quadrate"
                    },
                    exec: i
                }, n.Config.prototype.controls.ol = {
                    command: "insertOrderedList",
                    tags: [
                        "ol"
                    ],
                    tooltip: "Insert Ordered List",
                    list: {
                        default: "Default",
                        "lower-alpha": "Lower Alpha",
                        "lower-greek": "Lower Greek",
                        "lower-roman": "Lower Roman",
                        "upper-alpha": "Upper Alpha",
                        "upper-roman": "Upper Roman"
                    },
                    exec: i
                };
            },
            52598: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.orderedList = void 0;
                var n = o(20255), r = o(57549), i = o(43441), a = o(17332);
                o(73013);
                var s = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.buttons = [
                            {
                                name: "ul",
                                group: "list"
                            },
                            {
                                name: "ol",
                                group: "list"
                            }
                        ], t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        e.registerCommand("insertUnorderedList", this.onCommand).registerCommand("insertOrderedList", this.onCommand);
                    }, t.prototype.onCommand = function(e, t, o) {
                        return this.jodit.s.applyStyle({
                            listStyleType: null != o ? o : null
                        }, {
                            element: "insertunorderedlist" === e ? "ul" : "ol"
                        }), this.jodit.synchronizeValues(), !1;
                    }, t.prototype.beforeDestruct = function(e) {}, n.__decorate([
                        i.autobind
                    ], t.prototype, "onCommand", null), t;
                }(r.Plugin);
                t.orderedList = s, a.pluginSystem.add("orderedList", s);
            },
            47470: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(86893);
                n.Config.prototype.askBeforePasteFromWord = !0, n.Config.prototype.processPasteFromWord = !0, n.Config.prototype.defaultActionOnPasteFromWord = null, n.Config.prototype.pasteFromWordActionList = [
                    {
                        value: r.INSERT_AS_HTML,
                        text: "Keep"
                    },
                    {
                        value: r.INSERT_AS_TEXT,
                        text: "Clean"
                    },
                    {
                        value: r.INSERT_ONLY_TEXT,
                        text: "Insert only Text"
                    }
                ];
            },
            15428: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pasteFromWord = void 0;
                var n = o(20255), r = o(57549), i = o(40332), a = o(86893), s = o(43441), l = o(64280), c = o(17332);
                o(47470);
                var u = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.requires = [
                            "paste"
                        ], t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {}, t.prototype.beforeDestruct = function(e) {}, t.prototype.processWordHTML = function(e, t, o) {
                        var n = this, r = this.j, a = r.o, s = a.askBeforePasteFromWord, c = a.defaultActionOnPasteFromWord, u = a.defaultActionOnPaste, d = a.pasteFromWordActionList;
                        return !(!a.processPasteFromWord || !(0, i.isHtmlFromWord)(t) || (s ? (0, l.askInsertTypeDialog)(r, "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?", "Word Paste Detected", function(r) {
                            n.insertFromWordByType(e, t, r, o);
                        }, d) : this.insertFromWordByType(e, t, c || u, o), 0));
                    }, t.prototype.insertFromWordByType = function(e, t, o, n) {
                        var r;
                        switch(o){
                            case a.INSERT_AS_HTML:
                                t = (0, i.applyStyles)(t);
                                var s = null === (r = this.j.events) || void 0 === r ? void 0 : r.fire("beautifyHTML", t);
                                (0, i.isString)(s) && (t = s);
                                break;
                            case a.INSERT_AS_TEXT:
                                t = (0, i.cleanFromWord)(t);
                                break;
                            case a.INSERT_ONLY_TEXT:
                                t = (0, i.stripTags)((0, i.cleanFromWord)(t));
                        }
                        (0, l.pasteInsertHtml)(e, this.j, t);
                    }, n.__decorate([
                        (0, s.watch)(":processHTML")
                    ], t.prototype, "processWordHTML", null), t;
                }(r.Plugin);
                t.pasteFromWord = u, c.pluginSystem.add("pasteFromWord", u);
            },
            47224: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.pasteStorage = void 0;
                var n = o(20255);
                o(71708);
                var r = o(86893), i = o(85605), a = o(24263), s = o(40332), l = o(96031), c = o(17332), u = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.currentIndex = 0, t.list = [], t.container = null, t.listBox = null, t.previewBox = null, t.dialog = null, t.paste = function() {
                            if (t.j.s.focus(), t.j.s.insertHTML(t.list[t.currentIndex]), 0 !== t.currentIndex) {
                                var e = t.list[0];
                                t.list[0] = t.list[t.currentIndex], t.list[t.currentIndex] = e;
                            }
                            t.dialog && t.dialog.close(), t.j.synchronizeValues(), t.j.e.fire("afterPaste");
                        }, t.onKeyDown = function(e) {
                            var o = t.currentIndex;
                            -1 !== [
                                r.KEY_UP,
                                r.KEY_DOWN,
                                r.KEY_ENTER
                            ].indexOf(e.key) && (e.key === r.KEY_UP && (0 === o ? o = t.list.length - 1 : o -= 1), e.key === r.KEY_DOWN && (o === t.list.length - 1 ? o = 0 : o += 1), e.key !== r.KEY_ENTER ? (o !== t.currentIndex && t.selectIndex(o), e.stopImmediatePropagation(), e.preventDefault()) : t.paste());
                        }, t.selectIndex = function(e) {
                            t.listBox && (0, s.toArray)(t.listBox.childNodes).forEach(function(o, n) {
                                o.classList.remove("jodit_active"), e === n && t.previewBox && (o.classList.add("jodit_active"), t.previewBox.innerHTML = t.list[e], o.focus());
                            }), t.currentIndex = e;
                        }, t.showDialog = function() {
                            2 > t.list.length || (t.dialog || t.createDialog(), t.listBox && (t.listBox.innerHTML = ""), t.previewBox && (t.previewBox.innerHTML = ""), t.list.forEach(function(e, o) {
                                var n = t.j.c.element("a");
                                n.textContent = o + 1 + ". " + e.replace((0, r.SPACE_REG_EXP)(), ""), t.j.e.on(n, "keydown", t.onKeyDown), (0, s.attr)(n, "href", "#"), (0, s.attr)(n, "data-index", o.toString()), (0, s.attr)(n, "tab-index", "-1"), t.listBox && t.listBox.appendChild(n);
                            }), t.dialog && t.dialog.open(), t.j.async.setTimeout(function() {
                                t.selectIndex(0);
                            }, 100));
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.createDialog = function() {
                        var e = this;
                        this.dialog = this.j.dlg();
                        var t = (0, l.Button)(this.j, "paste", "Paste", "primary");
                        t.onAction(this.paste);
                        var o = (0, l.Button)(this.j, "", "Cancel");
                        o.onAction(this.dialog.close), this.container = this.j.c.div(), this.container.classList.add("jodit-paste-storage"), this.listBox = this.j.c.div(), this.previewBox = this.j.c.div(), this.container.appendChild(this.listBox), this.container.appendChild(this.previewBox), this.dialog.setHeader(this.j.i18n("Choose Content to Paste")), this.dialog.setContent(this.container), this.dialog.setFooter([
                            t,
                            o
                        ]), this.j.e.on(this.listBox, "click dblclick", function(t) {
                            var o = t.target;
                            return a.Dom.isTag(o, "a") && o.hasAttribute("data-index") && e.selectIndex(parseInt((0, s.attr)(o, "-index") || "0", 10)), "dblclick" === t.type && e.paste(), !1;
                        });
                    }, t.prototype.afterInit = function() {
                        var e = this;
                        this.j.e.off("afterCopy.paste-storage").on("pasteStorageList.paste-storage", function() {
                            return e.list.length;
                        }).on("afterCopy.paste-storage", function(t) {
                            -1 !== e.list.indexOf(t) && e.list.splice(e.list.indexOf(t), 1), e.list.unshift(t), e.list.length > 5 && (e.list.length = 5);
                        }), this.j.registerCommand("showPasteStorage", {
                            exec: this.showDialog,
                            hotkeys: [
                                "ctrl+shift+v",
                                "cmd+shift+v"
                            ]
                        });
                    }, t.prototype.beforeDestruct = function() {
                        this.dialog && this.dialog.destruct(), this.j.e.off(".paste-storage"), a.Dom.safeRemove(this.previewBox), a.Dom.safeRemove(this.listBox), a.Dom.safeRemove(this.container), this.container = null, this.listBox = null, this.previewBox = null, this.dialog = null, this.list = [];
                    }, t;
                }(i.Plugin);
                t.pasteStorage = u, c.pluginSystem.add("pasteStorage", u);
            },
            24703: function(e, t, o) {
                "use strict";
                var n;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var r = o(20255), i = o(86893), a = o(93166), s = o(64280);
                a.Config.prototype.askBeforePasteHTML = !0, a.Config.prototype.processPasteHTML = !0, a.Config.prototype.pasteHTMLActionList = [
                    {
                        value: i.INSERT_AS_HTML,
                        text: "Keep"
                    },
                    {
                        value: i.INSERT_AS_TEXT,
                        text: "Insert as Text"
                    },
                    {
                        value: i.INSERT_ONLY_TEXT,
                        text: "Insert only Text"
                    }
                ], a.Config.prototype.memorizeChoiceWhenPasteFragment = !1, a.Config.prototype.nl2brInPlainText = !0;
                var l = "pasteStorage";
                a.Config.prototype.controls.paste = {
                    tooltip: "Paste from clipboard",
                    exec: function(e, t, o) {
                        var n = o.control;
                        return r.__awaiter(this, void 0, void 0, function() {
                            var t, o, a, c, u;
                            return r.__generator(this, function(r) {
                                switch(r.label){
                                    case 0:
                                        if (n.name === l) return e.execCommand("showPasteStorage"), [
                                            2
                                        ];
                                        if (e.s.focus(), t = "", o = !0, !navigator.clipboard) return [
                                            3,
                                            11
                                        ];
                                        r.label = 1;
                                    case 1:
                                        return r.trys.push([
                                            1,
                                            6,
                                            ,
                                            7
                                        ]), [
                                            4,
                                            navigator.clipboard.read()
                                        ];
                                    case 2:
                                        return (a = r.sent()) && a.length ? [
                                            4,
                                            a[0].getType(i.TEXT_PLAIN)
                                        ] : [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return c = r.sent(), [
                                            4,
                                            new Response(c).text()
                                        ];
                                    case 4:
                                        t = r.sent(), r.label = 5;
                                    case 5:
                                        return o = !1, [
                                            3,
                                            7
                                        ];
                                    case 6:
                                        return r.sent(), [
                                            3,
                                            7
                                        ];
                                    case 7:
                                        if (!o) return [
                                            3,
                                            11
                                        ];
                                        r.label = 8;
                                    case 8:
                                        return r.trys.push([
                                            8,
                                            10,
                                            ,
                                            11
                                        ]), [
                                            4,
                                            navigator.clipboard.readText()
                                        ];
                                    case 9:
                                        return t = r.sent(), o = !1, [
                                            3,
                                            11
                                        ];
                                    case 10:
                                        return r.sent(), [
                                            3,
                                            11
                                        ];
                                    case 11:
                                        return o && (t = e.buffer.get(i.CLIPBOARD_ID) || "", o = 0 === t.length), u = e.value, o ? (e.ed.execCommand("paste"), !(o = u === e.value) && e.e.fire("afterPaste")) : t.length ? ((0, s.pasteInsertHtml)(null, e, t), e.e.fire("afterPaste")) : o && e.alert("Your browser doesn't support direct access to the clipboard.", function() {
                                            e.s.focus();
                                        }), [
                                            2
                                        ];
                                }
                            });
                        });
                    },
                    list: (n = {}, n[l] = "Paste Storage", n),
                    isChildDisabled: function(e) {
                        return 2 > e.e.fire("pasteStorageList");
                    }
                };
            },
            64280: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.askInsertTypeDialog = t.getAllTypes = t.pasteInsertHtml = void 0;
                var n = o(20255), r = o(10172), i = o(24263), a = o(86893), s = o(96031);
                t.pasteInsertHtml = function(e, t, o) {
                    if (!t.isInDestruct) {
                        (function(e) {
                            return Boolean(e && "drop" === e.type);
                        })(e) && t.s.insertCursorAtPoint(e.clientX, e.clientY);
                        var n = t.e.fire("beforePasteInsert", o);
                        !(0, r.isVoid)(n) && ((0, r.isString)(n) || (0, r.isNumber)(n) || i.Dom.isNode(n)) && (o = n), (0, r.isString)(o) && (o = function(e) {
                            var t = (e = e.replace(/<meta[^>]+?>/g, "")).search(/<!--StartFragment-->/i);
                            -1 !== t && (e = e.substring(t + 20));
                            var o = e.search(/<!--EndFragment-->/i);
                            return -1 !== o && (e = e.substring(0, o)), e;
                        }(o)), t.s.insertHTML(o);
                    }
                }, t.getAllTypes = function(e) {
                    var t = e.types, o = "";
                    if ((0, r.isArray)(t) || "[object DOMStringList]" === ({}).toString.call(t)) for(var n = 0; t.length > n; n += 1)o += t[n] + ";";
                    else o = (t || a.TEXT_PLAIN).toString() + ";";
                    return o;
                }, t.askInsertTypeDialog = function(e, t, o, r, i) {
                    if (!1 !== e.e.fire("beforeOpenPasteDialog", t, o, r, i)) {
                        var a = e.confirm('<div style="word-break: normal; white-space: normal">'.concat(e.i18n(t), "</div>"), e.i18n(o)), l = i.map(function(t) {
                            var o = t.text, n = t.value;
                            return (0, s.Button)(e, {
                                text: o,
                                name: o.toLowerCase(),
                                tabIndex: 0
                            }).onAction(function() {
                                a.close(), r(n);
                            });
                        });
                        a.e.one(a, "afterClose", function() {
                            e.s.isFocused() || e.s.focus();
                        });
                        var c = (0, s.Button)(e, {
                            text: "Cancel",
                            tabIndex: 0
                        }).onAction(function() {
                            a.close();
                        });
                        return a.setFooter(n.__spreadArray(n.__spreadArray([], n.__read(l), !1), [
                            c
                        ], !1)), l[0].focus(), l[0].state.variant = "primary", e.e.fire("afterOpenPasteDialog", a, t, o, r, i), a;
                    }
                };
            },
            19483: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.paste = void 0;
                var n = o(20255), r = o(85605), i = o(86893), a = o(24263), s = o(43441), l = o(40332), c = o(17332), u = o(64280);
                o(24703);
                var d = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.pasteStack = new l.LimitedStack(20), t._isDialogOpened = !1, t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.e.on("paste.paste", this.onPaste).on("pasteStack.paste", function(e) {
                            return t.pasteStack.push(e);
                        }), e.o.nl2brInPlainText && this.j.e.on("processPaste.paste", this.onProcessPasteReplaceNl2Br);
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off("paste.paste", this.onPaste).off("processPaste.paste", this.onProcessPasteReplaceNl2Br).off(".paste");
                    }, t.prototype.onPaste = function(e) {
                        try {
                            if (!1 === this.customPasteProcess(e) || !1 === this.j.e.fire("beforePaste", e)) return e.preventDefault(), !1;
                            this.defaultPasteProcess(e);
                        } finally{
                            this.j.e.fire("afterPaste", e);
                        }
                    }, t.prototype.customPasteProcess = function(e) {
                        if (this.j.o.processPasteHTML) {
                            var t, o = (0, l.getDataTransfer)(e), n = {
                                html: null == o ? void 0 : o.getData(i.TEXT_HTML),
                                plain: null == o ? void 0 : o.getData(i.TEXT_PLAIN),
                                rtf: null == o ? void 0 : o.getData(i.TEXT_RTF)
                            };
                            for(t in n){
                                var r = n[t];
                                if ((0, l.isHTML)(r) && (this.j.e.fire("processHTML", e, r, n) || this.processHTML(e, r))) return !1;
                            }
                        }
                    }, t.prototype.defaultPasteProcess = function(e) {
                        var t = (0, l.getDataTransfer)(e), o = (null == t ? void 0 : t.getData(i.TEXT_HTML)) || (null == t ? void 0 : t.getData(i.TEXT_PLAIN));
                        if (t && o && "" !== (0, l.trim)(o)) {
                            var n = this.j.e.fire("processPaste", e, o, (0, u.getAllTypes)(t));
                            void 0 !== n && (o = n), ((0, l.isString)(o) || a.Dom.isNode(o)) && this.insertByType(e, o, this.j.o.defaultActionOnPaste), e.preventDefault(), e.stopPropagation();
                        }
                    }, t.prototype.processHTML = function(e, t) {
                        var o = this;
                        if (this.j.o.askBeforePasteHTML) {
                            if (this.j.o.memorizeChoiceWhenPasteFragment) {
                                var n = this.pasteStack.find(function(e) {
                                    return e.html === t;
                                });
                                if (n) return this.insertByType(e, t, n.action || this.j.o.defaultActionOnPaste), !0;
                            }
                            if (this._isDialogOpened) return !0;
                            var r = (0, u.askInsertTypeDialog)(this.j, "Your code is similar to HTML. Keep as HTML?", "Paste as HTML", function(n) {
                                o._isDialogOpened = !1, o.insertByType(e, t, n);
                            }, this.j.o.pasteHTMLActionList);
                            return r && (this._isDialogOpened = !0, r.e.on("beforeClose", function() {
                                o._isDialogOpened = !1;
                            })), !0;
                        }
                        return !1;
                    }, t.prototype.insertByType = function(e, t, o) {
                        if (this.pasteStack.push({
                            html: t,
                            action: o
                        }), (0, l.isString)(t)) switch(this.j.buffer.set(i.CLIPBOARD_ID, t), o){
                            case i.INSERT_CLEAR_HTML:
                                t = (0, l.cleanFromWord)(t);
                                break;
                            case i.INSERT_ONLY_TEXT:
                                t = (0, l.stripTags)(t);
                                break;
                            case i.INSERT_AS_TEXT:
                                t = (0, l.htmlspecialchars)(t);
                        }
                        (0, u.pasteInsertHtml)(e, this.j, t);
                    }, t.prototype.onProcessPasteReplaceNl2Br = function(e, t, o) {
                        if (o === i.TEXT_PLAIN + ";" && !(0, l.isHTML)(t)) return (0, l.nl2br)(t);
                    }, n.__decorate([
                        s.autobind
                    ], t.prototype, "onPaste", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "onProcessPasteReplaceNl2Br", null), t;
                }(r.Plugin);
                t.paste = d, c.pluginSystem.add("paste", d);
            },
            76952: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.showPlaceholder = !0, n.Config.prototype.placeholder = "Type something", n.Config.prototype.useInputsPlaceholder = !0;
            },
            83211: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.placeholder = t.isEditorEmpty = void 0;
                var n = o(20255);
                o(51629);
                var r = o(86893), i = o(67309), a = o(26911), s = o(37204), l = o(24263), c = o(85605), u = o(86893), d = o(43441), p = o(17332);
                function f(e) {
                    var t;
                    if (!e.firstChild) return !0;
                    var o = e.firstChild;
                    if (u.INSEPARABLE_TAGS.has(null === (t = o.nodeName) || void 0 === t ? void 0 : t.toLowerCase()) || /^(TABLE)$/i.test(o.nodeName)) return !1;
                    var n = l.Dom.next(o, function(e) {
                        return e && !l.Dom.isEmptyTextNode(e);
                    }, e);
                    return l.Dom.isText(o) && !n ? l.Dom.isEmptyTextNode(o) : !n && l.Dom.each(o, function(e) {
                        return !l.Dom.isTag(e, [
                            "ul",
                            "li",
                            "ol"
                        ]) && (l.Dom.isEmpty(e) || l.Dom.isTag(e, "br"));
                    });
                }
                o(76952), t.isEditorEmpty = f;
                var h = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.addNativeListeners = function() {
                            t.j.e.off(t.j.editor, "input.placeholder keydown.placeholder").on(t.j.editor, "input.placeholder keydown.placeholder", t.toggle);
                        }, t.addEvents = function() {
                            var e = t.j;
                            e.o.useInputsPlaceholder && e.element.hasAttribute("placeholder") && (t.placeholderElm.innerHTML = (0, i.attr)(e.element, "placeholder") || ""), e.e.fire("placeholder", t.placeholderElm.innerHTML), e.e.off(".placeholder").on("changePlace.placeholder", t.addNativeListeners).on("change.placeholder focus.placeholder keyup.placeholder mouseup.placeholder keydown.placeholder mousedown.placeholder afterSetMode.placeholder changePlace.placeholder", t.toggle).on(window, "load", t.toggle), t.addNativeListeners(), t.toggle();
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.o.showPlaceholder && (this.placeholderElm = e.c.fromHTML('<span data-ref="placeholder" style="display: none;" class="jodit-placeholder">'.concat(e.i18n(e.o.placeholder), "</span>")), "rtl" === e.o.direction && (this.placeholderElm.style.right = "0px", this.placeholderElm.style.direction = "rtl"), e.e.on("readonly", function(e) {
                            e ? t.hide() : t.toggle();
                        }).on("changePlace", this.addEvents), this.addEvents());
                    }, t.prototype.show = function() {
                        var e = this.j;
                        if (!e.o.readonly) {
                            var t = 0, o = 0, n = e.s.current(), r = n && l.Dom.closest(n, l.Dom.isBlock, e.editor) || e.editor, i = e.ew.getComputedStyle(r), c = e.ew.getComputedStyle(e.editor);
                            e.workplace.appendChild(this.placeholderElm);
                            var u = e.editor.firstChild;
                            if (l.Dom.isElement(u) && !(0, s.isMarker)(u)) {
                                var d = e.ew.getComputedStyle(u);
                                t = parseInt(d.getPropertyValue("margin-top"), 10), o = parseInt(d.getPropertyValue("margin-left"), 10), this.placeholderElm.style.fontSize = parseInt(d.getPropertyValue("font-size"), 10) + "px", this.placeholderElm.style.lineHeight = d.getPropertyValue("line-height");
                            } else this.placeholderElm.style.fontSize = parseInt(i.getPropertyValue("font-size"), 10) + "px", this.placeholderElm.style.lineHeight = i.getPropertyValue("line-height");
                            (0, a.css)(this.placeholderElm, {
                                display: "block",
                                textAlign: i.getPropertyValue("text-align"),
                                paddingTop: parseInt(c.paddingTop, 10) + "px",
                                paddingLeft: parseInt(c.paddingLeft, 10) + "px",
                                paddingRight: parseInt(c.paddingRight, 10) + "px",
                                marginTop: Math.max(parseInt(i.getPropertyValue("margin-top"), 10), t),
                                marginLeft: Math.max(parseInt(i.getPropertyValue("margin-left"), 10), o)
                            });
                        }
                    }, t.prototype.hide = function() {
                        l.Dom.safeRemove(this.placeholderElm);
                    }, t.prototype.toggle = function() {
                        var e = this.j;
                        e.editor && !e.isInDestruct && (e.getRealMode() === r.MODE_WYSIWYG && f(e.editor) ? this.show() : this.hide());
                    }, t.prototype.beforeDestruct = function(e) {
                        this.hide(), e.e.off(".placeholder").off(window, "load", this.toggle);
                    }, n.__decorate([
                        (0, d.debounce)(function(e) {
                            return e.defaultTimeout / 10;
                        }, !0)
                    ], t.prototype, "toggle", null), t;
                }(c.Plugin);
                t.placeholder = h, p.pluginSystem.add("placeholder", h);
            },
            88297: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.poweredByJodit = void 0;
                var n = o(17332);
                function r(e) {
                    var t = e.o;
                    t.hidePoweredByJodit || t.inline || !(t.showCharsCounter || t.showWordsCounter || t.showXPathInStatusbar) || e.hookStatus("ready", function() {
                        e.statusbar.append(e.create.fromHTML('<a\n\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\tstyle="text-transform: uppercase"\n\t\t\t\t\t\tclass="jodit-status-bar-link"\n\t\t\t\t\t\ttarget="_blank"\n\t\t\t\t\t\thref="https://xdsoft.net/jodit/">\n\t\t\t\t\t\t\tPowered by Jodit\n\t\t\t\t\t\t</a>'), !0);
                    });
                }
                t.poweredByJodit = r, n.pluginSystem.add("poweredByJodit", r);
            },
            72930: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.preview = void 0, o(54860);
                var n = o(93166), r = o(86893), i = o(21498), a = o(17332);
                function s(e) {
                    e.registerButton({
                        name: "preview"
                    }), e.registerCommand("preview", function(t, o, n) {
                        var r = e.dlg();
                        r.setSize(1024, 600).open("", e.i18n("Preview")).setModal(!0), (0, i.previewBox)(e, n, "px", r.getElm("content"));
                    });
                }
                n.Config.prototype.controls.preview = {
                    icon: "eye",
                    command: "preview",
                    mode: r.MODE_SOURCE + r.MODE_WYSIWYG,
                    tooltip: "Preview"
                }, t.preview = s, a.pluginSystem.add("preview", s);
            },
            20137: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.generateCriticalCSS = void 0;
                var n = o(20255), r = o(1853);
                t.generateCriticalCSS = function(e) {
                    var t = function(e, t) {
                        return void 0 === t && (t = e.ownerDocument.styleSheets), (0, r.toArray)(t).map(function(e) {
                            try {
                                return (0, r.toArray)(e.cssRules);
                            } catch (e) {}
                            return [];
                        }).flat().filter(function(t) {
                            try {
                                return Boolean(t && e.matches(t.selectorText));
                            } catch (e) {}
                            return !1;
                        });
                    }, o = function() {
                        function o(o, r, i) {
                            var a = this;
                            this.css = {};
                            var s = i || {}, l = function(t) {
                                var o = t.selectorText.split(",").map(function(e) {
                                    return e.trim();
                                }).sort().join(",");
                                !1 === Boolean(a.css[o]) && (a.css[o] = {});
                                for(var r = t.style.cssText.split(/;(?![A-Za-z0-9])/), i = 0; r.length > i; i++)if (r[i]) {
                                    var s = r[i].split(":");
                                    s[0] = s[0].trim(), s[1] = s[1].trim(), a.css[o][s[0]] = s[1].replace(/var\(([^)]+)\)/g, function(t, o) {
                                        var r = n.__read(o.split(","), 2), i = r[0], a = r[1];
                                        return (e.ew.getComputedStyle(e.editor).getPropertyValue(i.trim()) || a || t).trim();
                                    });
                                }
                            };
                            !function() {
                                for(var n = o.innerHeight, i = r.createTreeWalker(e.editor, NodeFilter.SHOW_ELEMENT, function() {
                                    return NodeFilter.FILTER_ACCEPT;
                                }); i.nextNode();){
                                    var a = i.currentNode;
                                    if (n > a.getBoundingClientRect().top || s.scanFullPage) {
                                        var c = t(a);
                                        if (c) for(var u = 0; c.length > u; u++)l(c[u]);
                                    }
                                }
                            }();
                        }
                        return o.prototype.generateCSS = function() {
                            var e = "";
                            for(var t in this.css)if (!/:not\(/.test(t)) {
                                for(var o in e += t + " { ", this.css[t])e += o + ": " + this.css[t][o] + "; ";
                                e += "}\n";
                            }
                            return e;
                        }, o;
                    }();
                    try {
                        return new o(e.ew, e.ed, {
                            scanFullPage: !0
                        }).generateCSS();
                    } catch (e) {}
                    return "";
                };
            },
            51197: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.print = void 0;
                var n = o(93166), r = o(17332), i = o(64968), a = o(93351), s = o(86893), l = o(17332), c = o(77904), u = o(20137), d = o(21498);
                function p(e) {
                    e.registerButton({
                        name: "print"
                    });
                }
                c.Icon.set("print", o(22860)), n.Config.prototype.controls.print = {
                    exec: function(e) {
                        var t = e.create.element("iframe");
                        Object.assign(t.style, {
                            position: "fixed",
                            right: 0,
                            bottom: 0,
                            width: 0,
                            height: 0,
                            border: 0
                        }), (0, r.getContainer)(e, n.Config).appendChild(t);
                        var o = function() {
                            e.e.off(e.ow, "mousemove", o), i.Dom.safeRemove(t);
                        }, s = t.contentWindow;
                        if (s) {
                            e.e.on(s, "onbeforeunload onafterprint", o).on(e.ow, "mousemove", o), e.o.iframe ? (e.e.fire("generateDocumentStructure.iframe", s.document, e), s.document.body.innerHTML = e.value) : (s.document.write('<!doctype html><html lang="' + (0, a.defaultLanguage)(e.o.language) + '"><head><title></title></head><style>' + (0, u.generateCriticalCSS)(e) + "</style><body></body></html>"), s.document.close(), (0, d.previewBox)(e, void 0, "px", s.document.body));
                            var l = s.document.createElement("style");
                            l.innerHTML = "@media print {\n\t\t\t\t\tbody {\n\t\t\t\t\t\t\t-webkit-print-color-adjust: exact;\n\t\t\t\t\t}\n\t\t\t}", s.document.head.appendChild(l), s.focus(), s.print();
                        }
                    },
                    mode: s.MODE_SOURCE + s.MODE_WYSIWYG,
                    tooltip: "Print"
                }, t.print = p, l.pluginSystem.add("print", p);
            },
            2327: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.redoUndo = void 0;
                var n = o(20255), r = o(93166), i = o(86893), a = o(85605), s = o(17332);
                o(77904).Icon.set("redo", o(95600)).set("undo", o(76214)), r.Config.prototype.controls.redo = {
                    mode: i.MODE_SPLIT,
                    isDisabled: function(e) {
                        return !e.history.canRedo();
                    },
                    tooltip: "Redo"
                }, r.Config.prototype.controls.undo = {
                    mode: i.MODE_SPLIT,
                    isDisabled: function(e) {
                        return !e.history.canUndo();
                    },
                    tooltip: "Undo"
                };
                var l = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.buttons = [
                            {
                                name: "undo",
                                group: "history"
                            },
                            {
                                name: "redo",
                                group: "history"
                            }
                        ], t;
                    }
                    return n.__extends(t, e), t.prototype.beforeDestruct = function() {}, t.prototype.afterInit = function(e) {
                        var t = function(t) {
                            return e.history[t](), !1;
                        };
                        e.registerCommand("redo", {
                            exec: t,
                            hotkeys: [
                                "ctrl+y",
                                "ctrl+shift+z",
                                "cmd+y",
                                "cmd+shift+z"
                            ]
                        }), e.registerCommand("undo", {
                            exec: t,
                            hotkeys: [
                                "ctrl+z",
                                "cmd+z"
                            ]
                        });
                    }, t;
                }(a.Plugin);
                t.redoUndo = l, s.pluginSystem.add("redoUndo", l);
            },
            52444: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.tableAllowCellResize = !0;
            },
            47608: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.resizeCells = void 0;
                var n = o(20255);
                o(47818);
                var r = o(86893), i = o(87837), a = o(40332), s = o(43441), l = o(24263), c = o(17332);
                o(52444);
                var u = "table_processor_observer-resize", d = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.selectMode = !1, t.resizeDelta = 0, t.createResizeHandle = function() {
                            t.resizeHandler || (t.resizeHandler = t.j.c.div("jodit-table-resizer"), t.j.e.on(t.resizeHandler, "mousedown.table touchstart.table", t.onHandleMouseDown).on(t.resizeHandler, "mouseenter.table", function() {
                                t.j.async.clearTimeout(t.hideTimeout);
                            }));
                        }, t.hideTimeout = 0, t.drag = !1, t.minX = 0, t.maxX = 0, t.startX = 0, t;
                    }
                    return n.__extends(t, e), Object.defineProperty(t.prototype, "module", {
                        get: function() {
                            return this.j.getInstance("Table", this.j.o);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "isRTL", {
                        get: function() {
                            return "rtl" === this.j.o.direction;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.showResizeHandle = function() {
                        this.j.async.clearTimeout(this.hideTimeout), this.j.workplace.appendChild(this.resizeHandler);
                    }, t.prototype.hideResizeHandle = function() {
                        var e = this;
                        this.hideTimeout = this.j.async.setTimeout(function() {
                            l.Dom.safeRemove(e.resizeHandler);
                        }, {
                            timeout: this.j.defaultTimeout,
                            label: "hideResizer"
                        });
                    }, t.prototype.onHandleMouseDown = function(e) {
                        var t = this;
                        if (!this.j.isLocked) {
                            this.drag = !0, this.j.e.on(this.j.ow, "mouseup.resize-cells touchend.resize-cells", this.onMouseUp).on(this.j.ew, "mousemove.table touchmove.table", this.onMouseMove), this.startX = e.clientX, this.j.lock(u), this.resizeHandler.classList.add("jodit-table-resizer_moved");
                            var o, n = this.workTable.getBoundingClientRect();
                            if (this.minX = 0, this.maxX = 1e6, null != this.wholeTable) n = this.workTable.parentNode.getBoundingClientRect(), this.minX = n.left, this.maxX = this.minX + n.width;
                            else {
                                var a = i.Table.formalCoordinate(this.workTable, this.workCell, !0);
                                i.Table.formalMatrix(this.workTable, function(e, n, i) {
                                    a[1] === i && (o = e.getBoundingClientRect(), t.minX = Math.max(o.left + r.NEARBY / 2, t.minX)), a[1] + (t.isRTL ? -1 : 1) === i && (o = e.getBoundingClientRect(), t.maxX = Math.min(o.left + o.width - r.NEARBY / 2, t.maxX));
                                });
                            }
                            return !1;
                        }
                    }, t.prototype.onMouseMove = function(e) {
                        if (this.drag) {
                            this.j.e.fire("closeAllPopups");
                            var t = e.clientX, o = (0, a.offset)(this.resizeHandler.parentNode || this.j.od.documentElement, this.j, this.j.od, !0);
                            this.minX > t && (t = this.minX), t > this.maxX && (t = this.maxX), this.resizeDelta = t - this.startX + (this.j.o.iframe ? o.left : 0), this.resizeHandler.style.left = t - (this.j.o.iframe ? 0 : o.left) + "px";
                            var n = this.j.s.sel;
                            n && n.removeAllRanges();
                        }
                    }, t.prototype.onMouseUp = function(e) {
                        (this.selectMode || this.drag) && (this.selectMode = !1, this.j.unlock()), this.resizeHandler && this.drag && (this.drag = !1, this.j.e.off(this.j.ew, "mousemove.table touchmove.table", this.onMouseMove), this.resizeHandler.classList.remove("jodit-table-resizer_moved"), this.startX !== e.clientX && (null == this.wholeTable ? this.resizeColumns() : this.resizeTable()), this.j.synchronizeValues(), this.j.s.focus());
                    }, t.prototype.resizeColumns = function() {
                        var e = this.resizeDelta, t = [];
                        i.Table.setColumnWidthByDelta(this.workTable, i.Table.formalCoordinate(this.workTable, this.workCell, !0)[1], e, !0, t);
                        var o = (0, a.call)(this.isRTL ? l.Dom.prev : l.Dom.next, this.workCell, l.Dom.isCell, this.workCell.parentNode);
                        i.Table.setColumnWidthByDelta(this.workTable, i.Table.formalCoordinate(this.workTable, o)[1], -e, !1, t);
                    }, t.prototype.resizeTable = function() {
                        var e = this.resizeDelta * (this.isRTL ? -1 : 1), t = this.workTable.offsetWidth, o = (0, a.getContentWidth)(this.workTable.parentNode, this.j.ew), n = !this.wholeTable;
                        if (this.isRTL ? !n : n) this.workTable.style.width = (t + e) / o * 100 + "%";
                        else {
                            var r = this.isRTL ? "marginRight" : "marginLeft", i = parseInt(this.j.ew.getComputedStyle(this.workTable)[r] || "0", 10);
                            this.workTable.style.width = (t - e) / o * 100 + "%", this.workTable.style[r] = (i + e) / o * 100 + "%";
                        }
                    }, t.prototype.setWorkCell = function(e, t) {
                        void 0 === t && (t = null), this.wholeTable = t, this.workCell = e, this.workTable = l.Dom.up(e, function(e) {
                            return l.Dom.isTag(e, "table");
                        }, this.j.editor);
                    }, t.prototype.calcHandlePosition = function(e, t, o, n) {
                        void 0 === o && (o = 0), void 0 === n && (n = 0);
                        var i = (0, a.offset)(t, this.j, this.j.ed);
                        if (o > r.NEARBY && i.width - r.NEARBY > o) this.hideResizeHandle();
                        else {
                            var s = (0, a.offset)(this.j.workplace, this.j, this.j.od, !0), c = (0, a.offset)(e, this.j, this.j.ed);
                            if (this.resizeHandler.style.left = (o > r.NEARBY ? i.left + i.width : i.left) - s.left + n + "px", Object.assign(this.resizeHandler.style, {
                                height: c.height + "px",
                                top: c.top - s.top + "px"
                            }), this.showResizeHandle(), o > r.NEARBY) {
                                var u = (0, a.call)(this.isRTL ? l.Dom.prev : l.Dom.next, t, l.Dom.isCell, t.parentNode);
                                this.setWorkCell(t, !!u && null);
                            } else {
                                var d = (0, a.call)(this.isRTL ? l.Dom.next : l.Dom.prev, t, l.Dom.isCell, t.parentNode);
                                this.setWorkCell(d || t, !d || null);
                            }
                        }
                    }, t.prototype.afterInit = function(e) {
                        var t = this;
                        e.o.tableAllowCellResize && e.e.off(this.j.ow, ".resize-cells").off(".resize-cells").on("change.resize-cells afterCommand.resize-cells afterSetMode.resize-cells", function() {
                            (0, a.$$)("table", e.editor).forEach(t.observe);
                        }).on(this.j.ow, "scroll.resize-cells", function() {
                            if (t.drag) {
                                var o = l.Dom.up(t.workCell, function(e) {
                                    return l.Dom.isTag(e, "table");
                                }, e.editor);
                                if (o) {
                                    var n = o.getBoundingClientRect();
                                    t.resizeHandler.style.top = n.top + "px";
                                }
                            }
                        }).on("beforeSetMode.resize-cells", function() {
                            t.module.getAllSelectedCells().forEach(function(o) {
                                t.module.removeSelection(o), i.Table.normalizeTable(l.Dom.closest(o, "table", e.editor));
                            });
                        });
                    }, t.prototype.observe = function(e) {
                        var t = this;
                        (0, a.dataBind)(e, u) || ((0, a.dataBind)(e, u, !0), this.j.e.on(e, "mouseleave.resize-cells", function(e) {
                            t.resizeHandler && t.resizeHandler !== e.relatedTarget && t.hideResizeHandle();
                        }).on(e, "mousemove.resize-cells touchmove.resize-cells", this.j.async.throttle(function(o) {
                            if (!t.j.isLocked) {
                                var n = l.Dom.up(o.target, l.Dom.isCell, e);
                                n && t.calcHandlePosition(e, n, o.offsetX);
                            }
                        }, {
                            timeout: this.j.defaultTimeout
                        })), this.createResizeHandle());
                    }, t.prototype.beforeDestruct = function(e) {
                        e.events && (e.e.off(this.j.ow, ".resize-cells"), e.e.off(".resize-cells"));
                    }, n.__decorate([
                        s.autobind
                    ], t.prototype, "onHandleMouseDown", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "onMouseMove", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "onMouseUp", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "observe", null), t;
                }(i.Plugin);
                t.resizeCells = d, c.pluginSystem.add("resizeCells", d);
            },
            91637: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.allowResizeX = !1, n.Config.prototype.allowResizeY = !0;
            },
            90523: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.resizeHandler = void 0;
                var n = o(20255), r = o(57549), i = o(64968), a = o(43441), s = o(2074), l = o(17332);
                o(91637);
                var c = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.isResized = !1, t.start = {
                            x: 0,
                            y: 0,
                            w: 0,
                            h: 0
                        }, t.handle = t.j.c.div("jodit-editor__resize", s.Icon.get("resize_handler")), t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this, o = e.o, n = o.height, r = o.width, i = e.o.allowResizeY;
                        "auto" === n && "auto" !== r && (i = !1), "auto" === n && "auto" === r || !o.allowResizeX && !i || (e.statusbar.setMod("resize-handle", !0), e.e.on("toggleFullSize.resizeHandler", function() {
                            t.handle.style.display = e.isFullSize ? "none" : "block";
                        }).on(this.handle, "mousedown touchstart", this.onHandleResizeStart).on(e.ow, "mouseup touchend", this.onHandleResizeEnd), e.container.appendChild(this.handle));
                    }, t.prototype.onHandleResizeStart = function(e) {
                        this.isResized = !0, this.start.x = e.clientX, this.start.y = e.clientY, this.start.w = this.j.container.offsetWidth, this.start.h = this.j.container.offsetHeight, this.j.lock(), this.j.e.on(this.j.ow, "mousemove touchmove", this.onHandleResize), e.preventDefault();
                    }, t.prototype.onHandleResize = function(e) {
                        this.isResized && (this.j.o.allowResizeY && this.j.e.fire("setHeight", this.start.h + e.clientY - this.start.y), this.j.o.allowResizeX && this.j.e.fire("setWidth", this.start.w + e.clientX - this.start.x), this.j.e.fire("resize"));
                    }, t.prototype.onHandleResizeEnd = function() {
                        this.isResized && (this.isResized = !1, this.j.e.off(this.j.ow, "mousemove touchmove", this.onHandleResize), this.j.unlock());
                    }, t.prototype.beforeDestruct = function() {
                        i.Dom.safeRemove(this.handle), this.j.e.off(this.j.ow, "mouseup touchsend", this.onHandleResizeEnd);
                    }, t.requires = [
                        "size"
                    ], n.__decorate([
                        a.autobind
                    ], t);
                }(r.Plugin);
                t.resizeHandler = c, l.pluginSystem.add("resizeHandler", c);
            },
            36560: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.allowResizeTags = [
                    "img",
                    "iframe",
                    "table",
                    "jodit"
                ], n.Config.prototype.resizer = {
                    showSize: !0,
                    hideSizeTimeout: 1e3,
                    forImageChangeAttributes: !0,
                    min_width: 10,
                    min_height: 10,
                    useAspectRatio: [
                        "img"
                    ]
                };
            },
            69257: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.resizer = void 0;
                var n = o(20255);
                o(6316);
                var r = o(86893), i = o(86893), a = o(24263), s = o(40332), l = o(85605), c = o(17332), u = o(43441), d = o(17332);
                o(36560);
                var p = "__jodit-resizer_binded", f = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.LOCK_KEY = "resizer", t.element = null, t.isResizeMode = !1, t.isShown = !1, t.startX = 0, t.startY = 0, t.width = 0, t.height = 0, t.ratio = 0, t.rect = t.j.c.fromHTML('<div title="'.concat(t.j.i18n("Press Alt for custom resizing"), '" class="jodit-resizer">\n\t\t\t\t<div class="jodit-resizer__top-left"></div>\n\t\t\t\t<div class="jodit-resizer__top-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-right"></div>\n\t\t\t\t<div class="jodit-resizer__bottom-left"></div>\n\t\t\t\t<span>100x100</span>\n\t\t\t</div>')), t.sizeViewer = t.rect.getElementsByTagName("span")[0], t.pointerX = 0, t.pointerY = 0, t.isAltMode = !1, t.onClickElement = function(e) {
                            t.isResizeMode || t.element === e && t.isShown || (t.element = e, t.show(), a.Dom.isTag(t.element, "img") && !t.element.complete && t.j.e.one(t.element, "load", t.updateSize));
                        }, t.updateSize = function() {
                            if (!t.isInDestruct && t.isShown && t.element && t.rect) {
                                var e = t.getWorkplacePosition(), o = (0, s.offset)(t.element, t.j, t.j.ed), n = parseInt(t.rect.style.left || "0", 10), r = parseInt(t.rect.style.top || "0", 10), i = o.top - e.top, a = o.left - e.left;
                                r === i && n === a && t.rect.offsetWidth === t.element.offsetWidth && t.rect.offsetHeight === t.element.offsetHeight || ((0, s.css)(t.rect, {
                                    top: i,
                                    left: a,
                                    width: t.element.offsetWidth,
                                    height: t.element.offsetHeight
                                }), t.j.events && (t.j.e.fire(t.element, "changesize"), isNaN(n) || t.j.e.fire("resize")));
                            }
                        }, t.hideSizeViewer = function() {
                            t.sizeViewer.style.opacity = "0";
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        (0, s.$$)("div", this.rect).forEach(function(o) {
                            e.e.on(o, "mousedown.resizer touchstart.resizer", t.onStartResizing.bind(t, o));
                        }), c.eventEmitter.on("hideHelpers", this.hide), e.e.on("readonly", function(e) {
                            e && t.hide();
                        }).on("afterInit changePlace", this.addEventListeners.bind(this)).on("afterGetValueFromEditor.resizer", function(e) {
                            var t = /<jodit[^>]+data-jodit_iframe_wrapper[^>]+>(.*?<iframe[^>]*>.*?<\/iframe>.*?)<\/jodit>/gi;
                            t.test(e.value) && (e.value = e.value.replace(t, "$1"));
                        }).on("hideResizer", this.hide).on("change afterInit afterSetMode", this.onChangeEditor), this.addEventListeners(), this.onChangeEditor();
                    }, t.prototype.onEditorClick = function(e) {
                        for(var t = e.target, o = this.j, n = o.editor, r = o.options.allowResizeTags; t && t !== n;){
                            if (a.Dom.isTag(t, r)) return this.bind(t), void this.onClickElement(t);
                            t = t.parentNode;
                        }
                    }, t.prototype.addEventListeners = function() {
                        var e = this, t = this.j;
                        t.e.off(t.editor, ".resizer").off(t.ow, ".resizer").on(t.editor, "keydown.resizer", function(t) {
                            e.isShown && t.key === r.KEY_DELETE && e.element && !a.Dom.isTag(e.element, "table") && e.onDelete(t);
                        }).on(t.ow, "resize.resizer", this.updateSize).on("resize.resizer", this.updateSize).on([
                            t.ow,
                            t.editor
                        ], "scroll.resizer", function() {
                            e.isShown && !e.isResizeMode && e.hide();
                        }).on(t.ow, "keydown.resizer", this.onKeyDown).on(t.ow, "keyup.resizer", this.onKeyUp).on(t.ow, "mouseup.resizer touchend.resizer", this.onClickOutside);
                    }, t.prototype.onStartResizing = function(e, t) {
                        if (!this.element || !this.element.parentNode) return this.hide(), !1;
                        this.handle = e, t.cancelable && t.preventDefault(), t.stopImmediatePropagation(), this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.ratio = this.width / this.height, this.isResizeMode = !0, this.startX = t.clientX, this.startY = t.clientY, this.pointerX = t.clientX, this.pointerY = t.clientY;
                        var o = this.j;
                        o.e.fire("hidePopup"), o.lock(this.LOCK_KEY), o.e.on(o.ow, "mousemove.resizer touchmove.resizer", this.onResize);
                    }, t.prototype.onEndResizing = function() {
                        var e = this.j;
                        e.unlock(), this.isResizeMode = !1, this.isAltMode = !1, e.synchronizeValues(), e.e.off(e.ow, "mousemove.resizer touchmove.resizer", this.onResize);
                    }, t.prototype.onResize = function(e) {
                        if (this.isResizeMode) {
                            if (!this.element) return;
                            this.pointerX = e.clientX, this.pointerY = e.clientY;
                            var t = void 0, o = void 0;
                            if (this.j.options.iframe) {
                                var n = this.getWorkplacePosition();
                                t = e.clientX + n.left - this.startX, o = e.clientY + n.top - this.startY;
                            } else t = this.pointerX - this.startX, o = this.pointerY - this.startY;
                            var r = this.handle.className, i = 0, l = 0, c = this.j.o.resizer.useAspectRatio;
                            !this.isAltMode && (!0 === c || Array.isArray(c) && a.Dom.isTag(this.element, c)) ? (t ? (i = this.width + (r.match(/left/) ? -1 : 1) * t, l = Math.round(i / this.ratio)) : (l = this.height + (r.match(/top/) ? -1 : 1) * o, i = Math.round(l * this.ratio)), i > (0, s.innerWidth)(this.j.editor, this.j.ow) && (i = (0, s.innerWidth)(this.j.editor, this.j.ow), l = Math.round(i / this.ratio))) : (i = this.width + (r.match(/left/) ? -1 : 1) * t, l = this.height + (r.match(/top/) ? -1 : 1) * o), i > this.j.o.resizer.min_width && this.applySize(this.element, "width", this.rect.parentNode.offsetWidth > i ? i : "100%"), l > this.j.o.resizer.min_height && this.applySize(this.element, "height", l), this.updateSize(), this.showSizeViewer(this.element.offsetWidth, this.element.offsetHeight), e.stopImmediatePropagation();
                        }
                    }, t.prototype.onKeyDown = function(e) {
                        this.isAltMode = e.key === i.KEY_ALT, !this.isAltMode && this.isResizeMode && this.onEndResizing();
                    }, t.prototype.onKeyUp = function() {
                        this.isAltMode && this.isResizeMode && this.element && (this.width = this.element.offsetWidth, this.height = this.element.offsetHeight, this.ratio = this.width / this.height, this.startX = this.pointerX, this.startY = this.pointerY), this.isAltMode = !1;
                    }, t.prototype.onClickOutside = function(e) {
                        if (this.isShown) {
                            if (!this.isResizeMode) return this.hide();
                            e.stopImmediatePropagation(), this.onEndResizing();
                        }
                    }, t.prototype.getWorkplacePosition = function() {
                        return (0, s.offset)(this.rect.parentNode || this.j.od.documentElement, this.j, this.j.od, !0);
                    }, t.prototype.applySize = function(e, t, o) {
                        var n = a.Dom.isImage(e) && this.j.o.resizer.forImageChangeAttributes;
                        n && (0, s.attr)(e, t, o), n && !e.style[t] || (0, s.css)(e, t, o);
                    }, t.prototype.onDelete = function(e) {
                        this.element && ("JODIT" !== this.element.tagName ? this.j.s.select(this.element) : (a.Dom.safeRemove(this.element), this.hide(), e.preventDefault()));
                    }, t.prototype.onChangeEditor = function() {
                        this.isShown && (this.element && this.element.parentNode ? this.updateSize() : this.hide()), (0, s.$$)("iframe", this.j.editor).forEach(this.bind);
                    }, t.prototype.bind = function(e) {
                        var t = this;
                        if (a.Dom.isHTMLElement(e) && this.j.o.allowResizeTags.includes(e.tagName.toLowerCase()) && !(0, s.dataBind)(e, p)) {
                            var o;
                            if ((0, s.dataBind)(e, p, !0), a.Dom.isTag(e, "iframe")) {
                                var n = e;
                                a.Dom.isHTMLElement(e.parentNode) && (0, s.attr)(e.parentNode, "-jodit_iframe_wrapper") ? e = e.parentNode : (o = this.j.createInside.element("jodit", {
                                    "data-jodit-temp": 1,
                                    contenteditable: !1,
                                    draggable: !0,
                                    "data-jodit_iframe_wrapper": 1
                                }), (0, s.attr)(o, "style", (0, s.attr)(e, "style")), (0, s.css)(o, {
                                    display: "inline-block" === e.style.display ? "inline-block" : "block",
                                    width: e.offsetWidth,
                                    height: e.offsetHeight
                                }), e.parentNode && e.parentNode.insertBefore(o, e), o.appendChild(e), this.j.e.on(o, "click", function() {
                                    (0, s.attr)(o, "data-jodit-wrapper_active", !0);
                                }), e = o), this.j.e.off(e, "mousedown.select touchstart.select").on(e, "mousedown.select touchstart.select", function() {
                                    t.j.s.select(e);
                                }).off(e, "changesize").on(e, "changesize", function() {
                                    n.setAttribute("width", e.offsetWidth + "px"), n.setAttribute("height", e.offsetHeight + "px");
                                });
                            }
                            this.j.e.on(e, "dragstart", this.hide), i.IS_IE && this.j.e.on(e, "mousedown", function(t) {
                                a.Dom.isTag(e, "img") && t.preventDefault();
                            });
                        }
                    }, t.prototype.showSizeViewer = function(e, t) {
                        this.j.o.resizer.showSize && (this.sizeViewer.offsetWidth > e || this.sizeViewer.offsetHeight > t ? this.hideSizeViewer() : (this.sizeViewer.style.opacity = "1", this.sizeViewer.textContent = "".concat(e, " x ").concat(t), this.j.async.setTimeout(this.hideSizeViewer, {
                            timeout: this.j.o.resizer.hideSizeTimeout,
                            label: "hideSizeViewer"
                        })));
                    }, t.prototype.show = function() {
                        this.j.o.readonly || this.isShown || (this.isShown = !0, this.rect.parentNode || ((0, s.markOwner)(this.j, this.rect), this.j.workplace.appendChild(this.rect)), this.j.isFullSize && (this.rect.style.zIndex = (0, s.css)(this.j.container, "zIndex").toString()), this.updateSize());
                    }, t.prototype.hide = function() {
                        this.isResizeMode || (this.isResizeMode = !1, this.isShown = !1, this.element = null, a.Dom.safeRemove(this.rect), (0, s.$$)("[data-jodit-wrapper_active='true']", this.j.editor).forEach(function(e) {
                            return (0, s.attr)(e, "data-jodit-wrapper_active", !1);
                        }));
                    }, t.prototype.beforeDestruct = function(e) {
                        this.hide(), c.eventEmitter.off("hideHelpers", this.hide), e.e.off(this.j.ow, ".resizer").off(".resizer");
                    }, n.__decorate([
                        (0, u.watch)(":click")
                    ], t.prototype, "onEditorClick", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onStartResizing", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onEndResizing", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onResize", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onKeyDown", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onKeyUp", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "onClickOutside", null), n.__decorate([
                        (0, u.debounce)()
                    ], t.prototype, "onChangeEditor", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "bind", null), n.__decorate([
                        u.autobind
                    ], t.prototype, "hide", null), t;
                }(l.Plugin);
                t.resizer = f, d.pluginSystem.add("resizer", f);
            },
            61975: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(77904);
                o(59535), n.Config.prototype.useSearch = !0, n.Config.prototype.search = {
                    lazyIdleTimeout: 0
                }, r.Icon.set("search", o(41197)), n.Config.prototype.controls.find = {
                    tooltip: "Find",
                    icon: "search",
                    exec: function(e, t, o) {
                        var n = o.control;
                        switch(n.args && n.args[0]){
                            case "findPrevious":
                                e.e.fire("searchPrevious");
                                break;
                            case "findNext":
                                e.e.fire("searchNext");
                                break;
                            case "replace":
                                e.execCommand("openReplaceDialog");
                                break;
                            default:
                                e.execCommand("openSearchDialog");
                        }
                    },
                    list: {
                        search: "Find",
                        findNext: "Find Next",
                        findPrevious: "Find Previous",
                        replace: "Replace"
                    },
                    childTemplate: function(e, t, o) {
                        return o;
                    }
                };
            },
            73934: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(18562), t), n.__exportStar(o(3928), t);
            },
            18562: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SentenceFinder = void 0;
                var n = o(20255), r = o(93163), i = function() {
                    function e(e) {
                        void 0 === e && (e = r.fuzzySearchIndex), this.searchIndex = e, this.queue = [], this.value = "";
                    }
                    return e.prototype.add = function(e) {
                        var t, o = (null !== (t = e.nodeValue) && void 0 !== t ? t : "").toLowerCase();
                        if (o.length) {
                            var n = this.value.length;
                            this.queue.push({
                                startIndex: n,
                                endIndex: n + o.length,
                                node: e
                            }), this.value += o;
                        }
                    }, e.prototype.ranges = function(e, t) {
                        var o;
                        void 0 === t && (t = 0);
                        var r = [], i = t, a = 0, s = 0;
                        do if (a = (o = n.__read(this.searchIndex(e, this.value, i), 2))[1], -1 !== (i = o[0])) {
                            for(var l = void 0, c = 0, u = void 0, d = 0, p = s; this.queue.length > p; p += 1)if (!l && this.queue[p].endIndex > i && (l = this.queue[p].node, c = i - this.queue[p].startIndex), l && this.queue[p].endIndex >= i + a) {
                                u = this.queue[p].node, d = i + a - this.queue[p].startIndex, s = p;
                                break;
                            }
                            l && u && r.push({
                                startContainer: l,
                                startOffset: c,
                                endContainer: u,
                                endOffset: d
                            }), i += a;
                        }
                        while (-1 !== i);
                        return 0 === r.length ? null : r;
                    }, e;
                }();
                t.SentenceFinder = i;
            },
            3928: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.isSelectionWrapper = t.clearSelectionWrappersFromHTML = t.clearSelectionWrappers = t.getSelectionWrappers = t.wrapRangesTextsInTmpSpan = void 0;
                var n = o(20255), r = o(24263), i = o(54188), a = "jd-tmp-selection";
                function s(e) {
                    return (0, i.$$)("[".concat(a, "]"), e);
                }
                function l(e) {
                    return r.Dom.isElement(e) && e.hasAttribute(a);
                }
                t.wrapRangesTextsInTmpSpan = function(e, t, o, i) {
                    var s, c, u;
                    if (null != e.startContainer.nodeValue && null != e.endContainer.nodeValue) {
                        var d = o.element("span", ((s = {})[a] = !0, s));
                        r.Dom.markTemporary(d);
                        var p = e.startContainer.nodeValue, f = 0;
                        if (0 !== e.startOffset) {
                            var h = o.text(p.substring(0, e.startOffset));
                            e.startContainer.nodeValue = p.substring(e.startOffset), r.Dom.before(e.startContainer, h), e.startContainer === e.endContainer && (e.endOffset -= f = e.startOffset), e.startOffset = 0;
                        }
                        var m = e.endContainer.nodeValue;
                        if (e.endOffset !== m.length) {
                            h = o.text(m.substring(e.endOffset)), e.endContainer.nodeValue = m.substring(0, e.endOffset), r.Dom.after(e.endContainer, h);
                            try {
                                for(var v = n.__values(t), g = v.next(); !g.done; g = v.next()){
                                    var y = g.value;
                                    if (y.startContainer !== e.endContainer) break;
                                    y.startContainer = h, y.startOffset = y.startOffset - e.endOffset - f, y.endContainer === e.endContainer && (y.endContainer = h, y.endOffset = y.endOffset - e.endOffset - f);
                                }
                            } catch (e) {
                                c = {
                                    error: e
                                };
                            } finally{
                                try {
                                    g && !g.done && (u = v.return) && u.call(v);
                                } finally{
                                    if (c) throw c.error;
                                }
                            }
                            e.endOffset = e.endContainer.nodeValue.length;
                        }
                        var _ = e.startContainer;
                        do {
                            if (!_) break;
                            if (r.Dom.isText(_) && !l(_.parentNode) && r.Dom.wrap(_, d.cloneNode(), o), _ === e.endContainer) break;
                            var b = _.firstChild || _.nextSibling;
                            if (!b) {
                                for(; _ && !_.nextSibling && _ !== i;)_ = _.parentNode;
                                b = null == _ ? void 0 : _.nextSibling;
                            }
                            _ = b;
                        }while (_ && _ !== i);
                    }
                }, t.getSelectionWrappers = s, t.clearSelectionWrappers = function(e) {
                    s(e).forEach(function(e) {
                        return r.Dom.unwrap(e);
                    });
                }, t.clearSelectionWrappersFromHTML = function(e) {
                    return e.replace(RegExp("<span[^>]+".concat(a, "[^>]+>(.*?)</span>"), "g"), "$1");
                }, t.isSelectionWrapper = l;
            },
            59535: function() {},
            14889: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.search = void 0;
                var n = o(20255), r = o(64968), i = o(57549), a = o(43441), s = o(72235), l = o(40332), c = o(17332), u = o(73934);
                o(61975);
                var d = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.buttons = [
                            {
                                name: "find",
                                group: "search"
                            }
                        ], t.previousQuery = "", t.drawPromise = null, t.walker = null, t.walkerCount = null, t.cache = {}, t.wrapFrameRequest = 0, t;
                    }
                    return n.__extends(t, e), Object.defineProperty(t.prototype, "ui", {
                        get: function() {
                            return new s.UISearch(this.j);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.updateCounters = function() {
                        return n.__awaiter(this, void 0, Promise, function() {
                            var e;
                            return n.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return this.ui.isOpened ? (e = this.ui, [
                                            4,
                                            this.calcCounts(this.ui.query)
                                        ]) : [
                                            2
                                        ];
                                    case 1:
                                        return e.count = t.sent(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, t.prototype.onPressReplaceButton = function() {
                        this.findAndReplace(this.ui.query), this.updateCounters();
                    }, t.prototype.tryScrollToElement = function(e) {
                        var t = r.Dom.closest(e, r.Dom.isElement, this.j.editor);
                        t || (t = r.Dom.prev(e, r.Dom.isElement, this.j.editor)), t && t !== this.j.editor && (0, l.scrollIntoViewIfNeeded)(t, this.j.editor, this.j.ed);
                    }, t.prototype.calcCounts = function(e) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            return n.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return [
                                            4,
                                            this.findQueryBounds(e, "walkerCount")
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            t.sent().length
                                        ];
                                }
                            });
                        });
                    }, t.prototype.findQueryBounds = function(e, t) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            var o;
                            return n.__generator(this, function(n) {
                                return (o = this[t]) && o.break(), o = new r.LazyWalker(this.j.async, {
                                    timeout: this.j.o.search.lazyIdleTimeout
                                }), this[t] = o, [
                                    2,
                                    this.find(o, e).catch(function(e) {
                                        return [];
                                    })
                                ];
                            });
                        });
                    }, t.prototype.findAndReplace = function(e) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            var t, o, i, a, s;
                            return n.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return [
                                            4,
                                            this.findQueryBounds(e, "walker")
                                        ];
                                    case 1:
                                        if (!(t = n.sent()).length) return [
                                            2,
                                            !1
                                        ];
                                        if (-1 === (o = this.findCurrentIndexInRanges(t, this.j.s.range)) && (o = 0), !(i = t[o])) return [
                                            3,
                                            6
                                        ];
                                        n.label = 2;
                                    case 2:
                                        return n.trys.push([
                                            2,
                                            ,
                                            4,
                                            5
                                        ]), (a = this.j.ed.createRange()).setStart(i.startContainer, i.startOffset), a.setEnd(i.endContainer, i.endOffset), a.deleteContents(), s = this.j.createInside.text(this.ui.replace), r.Dom.safeInsertNode(a, s), (0, u.clearSelectionWrappers)(this.j.editor), this.j.s.setCursorAfter(s), this.tryScrollToElement(s), this.cache = {}, this.ui.currentIndex = o, [
                                            4,
                                            this.findAndSelect(e, !0).catch(function(e) {
                                                return null;
                                            })
                                        ];
                                    case 3:
                                        return n.sent(), [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        return this.j.synchronizeValues(), [
                                            7
                                        ];
                                    case 5:
                                        return this.j.e.fire("afterFindAndReplace"), [
                                            2,
                                            !0
                                        ];
                                    case 6:
                                        return [
                                            2,
                                            !1
                                        ];
                                }
                            });
                        });
                    }, t.prototype.findAndSelect = function(e, t) {
                        var o;
                        return n.__awaiter(this, void 0, Promise, function() {
                            var r, i, a, s;
                            return n.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return [
                                            4,
                                            this.findQueryBounds(e, "walker")
                                        ];
                                    case 1:
                                        if (!(r = n.sent()).length) return [
                                            2,
                                            !1
                                        ];
                                        if (this.previousQuery === e && (0, u.getSelectionWrappers)(this.j.editor).length || (null === (o = this.drawPromise) || void 0 === o || o.rejectCallback(), this.j.async.cancelAnimationFrame(this.wrapFrameRequest), (0, u.clearSelectionWrappers)(this.j.editor), this.drawPromise = this.drawSelectionRanges(r)), this.previousQuery = e, this.ui.currentIndex = (i = -1 == (i = this.ui.currentIndex - 1) ? 0 : t ? i === r.length - 1 ? 0 : i + 1 : 0 === i ? r.length - 1 : i - 1) + 1, !(a = r[i])) return [
                                            3,
                                            4
                                        ];
                                        s = this.j.ed.createRange();
                                        try {
                                            s.setStart(a.startContainer, a.startOffset), s.setEnd(a.endContainer, a.endOffset), this.j.s.selectRange(s);
                                        } catch (e) {}
                                        return this.tryScrollToElement(a.startContainer), [
                                            4,
                                            this.updateCounters()
                                        ];
                                    case 2:
                                        return n.sent(), [
                                            4,
                                            this.drawPromise
                                        ];
                                    case 3:
                                        return n.sent(), this.j.e.fire("afterFindAndSelect"), [
                                            2,
                                            !0
                                        ];
                                    case 4:
                                        return [
                                            2,
                                            !1
                                        ];
                                }
                            });
                        });
                    }, t.prototype.findCurrentIndexInRanges = function(e, t) {
                        return e.findIndex(function(e) {
                            return e.startContainer === t.startContainer && e.startOffset === t.startOffset && e.endContainer === t.startContainer && e.endOffset === t.endOffset;
                        });
                    }, t.prototype.isValidCache = function(e) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            return n.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return [
                                            4,
                                            e
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            t.sent().every(function(e) {
                                                var t, o, n, r;
                                                return e.startContainer.isConnected && e.startOffset <= (null !== (o = null === (t = e.startContainer.nodeValue) || void 0 === t ? void 0 : t.length) && void 0 !== o ? o : 0) && e.endContainer.isConnected && e.endOffset <= (null !== (r = null === (n = e.endContainer.nodeValue) || void 0 === n ? void 0 : n.length) && void 0 !== r ? r : 0);
                                            })
                                        ];
                                }
                            });
                        });
                    }, t.prototype.find = function(e, t) {
                        return n.__awaiter(this, void 0, Promise, function() {
                            var o, i, a = this;
                            return n.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return t.length ? (i = o = this.cache[t]) ? [
                                            4,
                                            this.isValidCache(o)
                                        ] : [
                                            3,
                                            2
                                        ] : [
                                            2,
                                            []
                                        ];
                                    case 1:
                                        i = n.sent(), n.label = 2;
                                    case 2:
                                        return i ? [
                                            2,
                                            o
                                        ] : (this.cache[t] = this.j.async.promise(function(o) {
                                            var n = new u.SentenceFinder(a.j.o.search.fuzzySearch);
                                            e.on("break", function() {
                                                o([]);
                                            }).on("visit", function(e) {
                                                return r.Dom.isText(e) && n.add(e), !1;
                                            }).on("end", function() {
                                                var e;
                                                o(null !== (e = n.ranges(t)) && void 0 !== e ? e : []);
                                            }).setWork(a.j.editor);
                                        }), [
                                            2,
                                            this.cache[t]
                                        ]);
                                }
                            });
                        });
                    }, t.prototype.drawSelectionRanges = function(e) {
                        var t = this, o = this.j, r = o.async, i = o.createInside, a = o.editor;
                        r.cancelAnimationFrame(this.wrapFrameRequest);
                        var s, l = n.__spreadArray([], n.__read(e), !1), c = 0;
                        return r.promise(function(e) {
                            var o = function() {
                                do (s = l.shift()) && (0, u.wrapRangesTextsInTmpSpan)(s, l, i, a), c += 1;
                                while (s && 5 >= c);
                                l.length ? t.wrapFrameRequest = r.requestAnimationFrame(o) : e();
                            };
                            o();
                        });
                    }, t.prototype.onAfterGetValueFromEditor = function(e) {
                        e.value = (0, u.clearSelectionWrappersFromHTML)(e.value);
                    }, t.prototype.afterInit = function(e) {
                        var t = this;
                        if (e.o.useSearch) {
                            var o = this;
                            e.e.on("beforeSetMode.search", function() {
                                t.ui.close();
                            }).on(this.ui, "afterClose", function() {
                                (0, u.clearSelectionWrappers)(e.editor), t.ui.currentIndex = 0, t.ui.count = 0, t.cache = {};
                            }).on("click", function() {
                                t.ui.currentIndex = 0, (0, u.clearSelectionWrappers)(e.editor);
                            }).on("change.search", function() {
                                t.cache = {};
                            }).on("keydown.search mousedown.search", e.async.debounce(function() {
                                t.ui.selInfo && (e.s.removeMarkers(), t.ui.selInfo = null), t.ui.isOpened && t.updateCounters();
                            }, e.defaultTimeout)).on("searchNext.search searchPrevious.search", function() {
                                return t.ui.isOpened || t.ui.open(), o.findAndSelect(o.ui.query, "searchNext" === e.e.current).catch(function(e) {});
                            }).on("search.search", function(e, n) {
                                return void 0 === n && (n = !0), t.ui.currentIndex = 0, o.findAndSelect(e || "", n).catch(function(e) {});
                            }), e.registerCommand("search", {
                                exec: function(e, t, n) {
                                    return void 0 === n && (n = !0), t && o.findAndSelect(t, n).catch(function(e) {}), !1;
                                }
                            }).registerCommand("openSearchDialog", {
                                exec: function(e, t) {
                                    return o.ui.open(t), !1;
                                },
                                hotkeys: [
                                    "ctrl+f",
                                    "cmd+f"
                                ]
                            }).registerCommand("openReplaceDialog", {
                                exec: function(t, n, r) {
                                    return e.o.readonly || o.ui.open(n, r, !0), !1;
                                },
                                hotkeys: [
                                    "ctrl+h",
                                    "cmd+h"
                                ]
                            });
                        }
                    }, t.prototype.beforeDestruct = function(e) {
                        this.ui.destruct(), e.e.off(".search");
                    }, n.__decorate([
                        a.cache
                    ], t.prototype, "ui", null), n.__decorate([
                        (0, a.watch)("ui:needUpdateCounters")
                    ], t.prototype, "updateCounters", null), n.__decorate([
                        (0, a.watch)("ui:pressReplaceButton")
                    ], t.prototype, "onPressReplaceButton", null), n.__decorate([
                        a.autobind
                    ], t.prototype, "findQueryBounds", null), n.__decorate([
                        a.autobind
                    ], t.prototype, "findAndReplace", null), n.__decorate([
                        a.autobind
                    ], t.prototype, "findAndSelect", null), n.__decorate([
                        a.autobind
                    ], t.prototype, "find", null), n.__decorate([
                        (0, a.watch)(":afterGetValueFromEditor")
                    ], t.prototype, "onAfterGetValueFromEditor", null), t;
                }(i.Plugin);
                t.search = d, c.pluginSystem.add("search", d);
            },
            72235: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.UISearch = void 0;
                var n = o(20255);
                o(88582);
                var r = o(2074), i = o(40332), a = o(86893), s = o(86893), l = o(43441), c = o(64968), u = function(e) {
                    function t(t) {
                        var o = e.call(this, t) || this;
                        o.selInfo = null, o._currentIndex = 0, o.isOpened = !1;
                        var n = (0, i.refs)(o.container), r = n.replace, a = n.cancel, l = n.next, c = n.prev, u = n.replaceBtn, d = n.current, p = n.count;
                        return o.queryInput = n.query, o.replaceInput = r, o.closeButton = a, o.replaceButton = u, o.currentBox = d, o.countBox = p, t.e.on(o.closeButton, "pointerdown", function() {
                            return o.close(), !1;
                        }).on(o.queryInput, "input", function() {
                            o.currentIndex = 0;
                        }).on(o.queryInput, "pointerdown", function() {
                            t.s.isFocused() && (t.s.removeMarkers(), o.selInfo = t.s.save());
                        }).on(o.replaceButton, "pointerdown", function() {
                            return t.e.fire(o, "pressReplaceButton"), !1;
                        }).on(l, "pointerdown", function() {
                            return t.e.fire("searchNext"), !1;
                        }).on(c, "pointerdown", function() {
                            return t.e.fire("searchPrevious"), !1;
                        }).on(o.queryInput, "input", function() {
                            o.setMod("empty-query", !(0, i.trim)(o.queryInput.value).length);
                        }).on(o.queryInput, "keydown", o.j.async.debounce(function(e) {
                            e.key === s.KEY_ENTER ? (e.preventDefault(), e.stopImmediatePropagation(), t.e.fire("searchNext") && o.close()) : t.e.fire(o, "needUpdateCounters");
                        }, o.j.defaultTimeout)), o;
                    }
                    return n.__extends(t, e), t.prototype.className = function() {
                        return "UISearch";
                    }, t.prototype.render = function() {
                        return '<div>\n\t\t\t<div class="&__box">\n\t\t\t\t<div class="&__inputs">\n\t\t\t\t\t<input data-ref="query" tabindex="0" placeholder="~Search for~" type="text"/>\n\t\t\t\t\t<input data-ref="replace" tabindex="0" placeholder="~Replace with~" type="text"/>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__counts">\n\t\t\t\t\t<span data-ref="counter-box">\n\t\t\t\t\t\t<span data-ref="current">0</span><span>/</span><span data-ref="count">0</span>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<div class="&__buttons">\n\t\t\t\t\t<button data-ref="next" tabindex="0" type="button">'.concat(r.Icon.get("angle-down"), '</button>\n\t\t\t\t\t<button data-ref="prev" tabindex="0" type="button">').concat(r.Icon.get("angle-up"), '</button>\n\t\t\t\t\t<button data-ref="cancel" tabindex="0" type="button">').concat(r.Icon.get("cancel"), '</button>\n\t\t\t\t\t<button data-ref="replace-btn" tabindex="0" type="button" class="jodit-ui-button">~Replace~</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>');
                    }, Object.defineProperty(t.prototype, "currentIndex", {
                        get: function() {
                            return this._currentIndex;
                        },
                        set: function(e) {
                            this._currentIndex = e, this.currentBox.innerText = e.toString();
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "count", {
                        set: function(e) {
                            this.countBox.innerText = e.toString();
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "query", {
                        get: function() {
                            return this.queryInput.value;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), Object.defineProperty(t.prototype, "replace", {
                        get: function() {
                            return this.replaceInput.value;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.onEditorKeyDown = function(e) {
                        if (this.isOpened) {
                            var t = this.j;
                            if (t.getRealMode() === a.MODE_WYSIWYG) switch(e.key){
                                case s.KEY_ESC:
                                    this.close();
                                    break;
                                case s.KEY_F3:
                                    this.queryInput.value && (t.e.fire(e.shiftKey ? "searchPrevious" : "searchNext"), e.preventDefault());
                            }
                        }
                    }, t.prototype.open = function(e, t, o) {
                        void 0 === o && (o = !1), this.isOpened || (this.j.workplace.appendChild(this.container), this.isOpened = !0), this.calcSticky(this.j.e.fire("getStickyState.sticky") || !1), this.j.e.fire("hidePopup"), this.setMod("replace", o);
                        var n = null != e ? e : (this.j.s.sel || "").toString();
                        n && (this.queryInput.value = n), t && (this.replaceInput.value = t), this.setMod("empty-query", !n.length), this.j.e.fire(this, "needUpdateCounters"), n ? this.queryInput.select() : this.queryInput.focus();
                    }, t.prototype.close = function() {
                        this.isOpened && (this.j.s.restore(), c.Dom.safeRemove(this.container), this.isOpened = !1, this.j.e.fire(this, "afterClose"));
                    }, t.prototype.calcSticky = function(e) {
                        if (this.isOpened) {
                            if (this.setMod("sticky", e), e) {
                                var t = (0, i.position)(this.j.toolbarContainer);
                                (0, i.css)(this.container, {
                                    top: t.top + t.height,
                                    left: t.left + t.width
                                });
                            } else (0, i.css)(this.container, {
                                top: null,
                                left: null
                            });
                        }
                    }, n.__decorate([
                        (0, l.watch)([
                            ":keydown",
                            "queryInput:keydown"
                        ])
                    ], t.prototype, "onEditorKeyDown", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "open", null), n.__decorate([
                        l.autobind
                    ], t.prototype, "close", null), n.__decorate([
                        (0, l.watch)(":toggleSticky")
                    ], t.prototype, "calcSticky", null), n.__decorate([
                        l.component
                    ], t);
                }(r.UIElement);
                t.UISearch = u;
            },
            14189: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.tableAllowCellSelection = !0;
            },
            37458: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.selectCells = void 0;
                var n = o(20255), r = o(57549), i = o(87837), a = o(24263), s = o(40332), l = o(86893), c = o(43441), u = o(17332);
                o(14189);
                var d = "table_processor_observer", p = "onMoveTableSelectCell", f = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.requires = [
                            "select"
                        ], t.selectedCell = null, t.isSelectionMode = !1, t;
                    }
                    return n.__extends(t, e), Object.defineProperty(t.prototype, "module", {
                        get: function() {
                            return this.j.getInstance("Table", this.j.o);
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.o.tableAllowCellSelection && e.e.on("keydown.select-cells", function(e) {
                            e.key === l.KEY_TAB && t.unselectCells();
                        }).on("beforeCommand.select-cells", this.onExecCommand).on("afterCommand.select-cells", this.onAfterCommand).on([
                            "clickEditor",
                            "mousedownTd",
                            "mousedownTh",
                            "touchstartTd",
                            "touchstartTh"
                        ].map(function(e) {
                            return e + ".select-cells";
                        }).join(" "), this.onStartSelection).on("clickTr clickTbody", function() {
                            var e, o = t.module.getAllSelectedCells().length;
                            if (o) return o > 1 && (null === (e = t.j.s.sel) || void 0 === e || e.removeAllRanges()), !1;
                        });
                    }, t.prototype.onStartSelection = function(e) {
                        if (!this.j.o.readonly && (this.unselectCells(), e !== this.j.editor)) {
                            var t = a.Dom.closest(e, "table", this.j.editor);
                            if (e && t) return e.firstChild || e.appendChild(this.j.createInside.element("br")), this.isSelectionMode = !0, this.selectedCell = e, this.module.addSelection(e), this.j.e.on(t, "mousemove.select-cells touchmove.select-cells", this.j.async.throttle(this.onMove.bind(this, t), {
                                label: p,
                                timeout: this.j.defaultTimeout / 2
                            })).on(t, "mouseup.select-cells touchend.select-cells", this.onStopSelection.bind(this, t)), !1;
                        }
                    }, t.prototype.onOutsideClick = function() {
                        this.selectedCell = null, this.onRemoveSelection();
                    }, t.prototype.onChange = function() {
                        this.j.isLocked || this.isSelectionMode || this.onRemoveSelection();
                    }, t.prototype.onMove = function(e, t) {
                        var o, n = this;
                        if ((!this.j.o.readonly || this.j.isLocked) && !this.j.isLockedNotBy(d)) {
                            var r = this.j.ed.elementFromPoint(t.clientX, t.clientY);
                            if (r) {
                                var s = a.Dom.closest(r, [
                                    "td",
                                    "th"
                                ], e);
                                if (s && this.selectedCell) {
                                    s !== this.selectedCell && this.j.lock(d), this.unselectCells();
                                    for(var l = i.Table.getSelectedBound(e, [
                                        s,
                                        this.selectedCell
                                    ]), c = i.Table.formalMatrix(e), u = l[0][0]; l[1][0] >= u; u += 1)for(var p = l[0][1]; l[1][1] >= p; p += 1)this.module.addSelection(c[u][p]);
                                    var f;
                                    this.module.getAllSelectedCells().length > 1 && (null === (o = this.j.s.sel) || void 0 === o || o.removeAllRanges()), this.j.e.fire("hidePopup"), t.stopPropagation(), f = n.j.createInside.fromHTML('<div style="color:rgba(0,0,0,0.01);width:0;height:0">&nbsp;</div>'), s.appendChild(f), n.j.async.setTimeout(function() {
                                        var e;
                                        null === (e = f.parentNode) || void 0 === e || e.removeChild(f);
                                    }, n.j.defaultTimeout / 5);
                                }
                            }
                        }
                    }, t.prototype.onRemoveSelection = function(e) {
                        var t;
                        if (!(null === (t = null == e ? void 0 : e.buffer) || void 0 === t ? void 0 : t.actionTrigger) && !this.selectedCell && this.module.getAllSelectedCells().length) return this.j.unlock(), this.unselectCells(), void this.j.e.fire("hidePopup", "cells");
                        this.isSelectionMode = !1, this.selectedCell = null;
                    }, t.prototype.onStopSelection = function(e, t) {
                        var o = this;
                        if (this.selectedCell) {
                            this.isSelectionMode = !1, this.j.unlock();
                            var n = this.j.ed.elementFromPoint(t.clientX, t.clientY);
                            if (n) {
                                var r = a.Dom.closest(n, [
                                    "td",
                                    "th"
                                ], e);
                                if (r) {
                                    var l = a.Dom.closest(r, "table", e);
                                    if (!l || l === e) {
                                        var c = i.Table.getSelectedBound(e, [
                                            r,
                                            this.selectedCell
                                        ]), u = i.Table.formalMatrix(e), d = u[c[1][0]][c[1][1]], f = u[c[0][0]][c[0][1]];
                                        this.j.e.fire("showPopup", e, function() {
                                            var e = (0, s.position)(f, o.j), t = (0, s.position)(d, o.j);
                                            return {
                                                left: e.left,
                                                top: e.top,
                                                width: t.left - e.left + t.width,
                                                height: t.top - e.top + t.height
                                            };
                                        }, "cells"), (0, s.$$)("table", this.j.editor).forEach(function(e) {
                                            o.j.e.off(e, "mousemove.select-cells touchmove.select-cells mouseup.select-cells touchend.select-cells");
                                        }), this.j.async.clearTimeout(p);
                                    }
                                }
                            }
                        }
                    }, t.prototype.unselectCells = function(e) {
                        var t = this.module, o = t.getAllSelectedCells();
                        o.length && o.forEach(function(o) {
                            e && e === o || t.removeSelection(o);
                        });
                    }, t.prototype.onExecCommand = function(e) {
                        if (/table(splitv|splitg|merge|empty|bin|binrow|bincolumn|addcolumn|addrow)/.test(e)) {
                            e = e.replace("table", "");
                            var t = this.module.getAllSelectedCells();
                            if (t.length) {
                                var o = n.__read(t, 1)[0];
                                if (!o) return;
                                var r = a.Dom.closest(o, "table", this.j.editor);
                                if (!r) return;
                                switch(e){
                                    case "splitv":
                                        i.Table.splitVertical(r, this.j);
                                        break;
                                    case "splitg":
                                        i.Table.splitHorizontal(r, this.j);
                                        break;
                                    case "merge":
                                        i.Table.mergeSelected(r, this.j);
                                        break;
                                    case "empty":
                                        t.forEach(function(e) {
                                            return a.Dom.detach(e);
                                        });
                                        break;
                                    case "bin":
                                        a.Dom.safeRemove(r);
                                        break;
                                    case "binrow":
                                        new Set(t.map(function(e) {
                                            return e.parentNode;
                                        })).forEach(function(e) {
                                            i.Table.removeRow(r, e.rowIndex);
                                        });
                                        break;
                                    case "bincolumn":
                                        var s = new Set;
                                        t.reduce(function(e, t) {
                                            return s.has(t.cellIndex) || (e.push(t), s.add(t.cellIndex)), e;
                                        }, []).forEach(function(e) {
                                            i.Table.removeColumn(r, e.cellIndex);
                                        });
                                        break;
                                    case "addcolumnafter":
                                    case "addcolumnbefore":
                                        i.Table.appendColumn(r, o.cellIndex, "addcolumnafter" === e, this.j.createInside);
                                        break;
                                    case "addrowafter":
                                    case "addrowbefore":
                                        i.Table.appendRow(r, o.parentNode, "addrowafter" === e, this.j.createInside);
                                }
                            }
                            return !1;
                        }
                    }, t.prototype.onAfterCommand = function(e) {
                        /^justify/.test(e) && this.module.getAllSelectedCells().forEach(function(t) {
                            return (0, s.alignElement)(e, t);
                        });
                    }, t.prototype.beforeDestruct = function(e) {
                        this.onRemoveSelection(), e.e.off(".select-cells");
                    }, n.__decorate([
                        c.autobind
                    ], t.prototype, "onStartSelection", null), n.__decorate([
                        (0, c.watch)(":outsideClick")
                    ], t.prototype, "onOutsideClick", null), n.__decorate([
                        (0, c.watch)(":change")
                    ], t.prototype, "onChange", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "onRemoveSelection", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "onStopSelection", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "onExecCommand", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "onAfterCommand", null), t;
                }(r.Plugin);
                t.selectCells = f, u.pluginSystem.add("selectCells", f);
            },
            33100: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.select = {
                    normalizeSelectionBeforeCutAndCopy: !1
                };
            },
            95323: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.select = void 0;
                var n = o(20255), r = o(57549), i = o(43441), a = o(26596), s = o(24263), l = o(2074), c = o(17332);
                o(33100);
                var u = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.proxyEventsList = [
                            "click",
                            "mousedown",
                            "touchstart",
                            "mouseup",
                            "touchend"
                        ], t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        this.proxyEventsList.forEach(function(o) {
                            e.e.on(o + ".select", t.onStartSelection);
                        });
                    }, t.prototype.beforeDestruct = function(e) {
                        var t = this;
                        this.proxyEventsList.forEach(function(o) {
                            e.e.on(o + ".select", t.onStartSelection);
                        });
                    }, t.prototype.onStartSelection = function(e) {
                        for(var t, o = this.j, n = e.target; void 0 === t && n && n !== o.editor;)t = o.e.fire((0, a.camelCase)(e.type + "_" + n.nodeName.toLowerCase()), n, e), n = n.parentElement;
                        "click" === e.type && void 0 === t && n === o.editor && o.e.fire(e.type + "Editor", n, e);
                    }, t.prototype.onOutsideClick = function(e) {
                        var t = this, o = e.target;
                        s.Dom.up(o, function(e) {
                            return e === t.j.editor;
                        }) || l.UIElement.closestElement(o, l.Popup) || this.j.e.fire("outsideClick", e);
                    }, t.prototype.beforeCommandCut = function(e) {
                        var t = this.j.s;
                        if ("cut" === e && !t.isCollapsed()) {
                            var o = t.current();
                            o && s.Dom.isOrContains(this.j.editor, o) && this.onCopyNormalizeSelectionBound();
                        }
                    }, t.prototype.onCopyNormalizeSelectionBound = function(e) {
                        var t = this.j, o = t.editor;
                        t.o.select.normalizeSelectionBeforeCutAndCopy && !t.s.isCollapsed() && (!e || e.isTrusted && s.Dom.isNode(e.target) && s.Dom.isOrContains(o, e.target)) && this.jodit.s.expandSelection();
                    }, n.__decorate([
                        i.autobind
                    ], t.prototype, "onStartSelection", null), n.__decorate([
                        (0, i.watch)("ow:click")
                    ], t.prototype, "onOutsideClick", null), n.__decorate([
                        (0, i.watch)([
                            ":beforeCommand"
                        ])
                    ], t.prototype, "beforeCommandCut", null), n.__decorate([
                        (0, i.watch)([
                            ":copy",
                            ":cut"
                        ])
                    ], t.prototype, "onCopyNormalizeSelectionBound", null), t;
                }(r.Plugin);
                t.select = u, c.pluginSystem.add("select", u);
            },
            53387: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.minWidth = 200, n.Config.prototype.maxWidth = "100%", n.Config.prototype.minHeight = 200, n.Config.prototype.maxHeight = "auto", n.Config.prototype.saveHeightInStorage = !1;
            },
            71003: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.size = void 0;
                var n = o(20255);
                o(30962);
                var r = o(61817), i = o(26911), a = o(85605), s = o(43441), l = o(17332);
                o(53387);
                var c = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.__resizeWorkspaces = t.j.async.debounce(t.__resizeWorkspaceImd, t.j.defaultTimeout, !0), t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        e.e.on("setHeight.size", this.__setHeight).on("setWidth.size", this.__setWidth).on("afterInit.size changePlace.size", this.__initialize, {
                            top: !0
                        }).on(e.ow, "load.size", this.__resizeWorkspaces).on("afterInit.size resize.size afterUpdateToolbar.size scroll.size afterResize.size", this.__resizeWorkspaces).on("toggleFullSize.size toggleToolbar.size", this.__resizeWorkspaceImd), this.__initialize();
                    }, t.prototype.__initialize = function() {
                        var e = this.j;
                        if (!e.o.inline) {
                            var t = e.o.height;
                            if (e.o.saveHeightInStorage && "auto" !== t) {
                                var o = e.storage.get("height");
                                o && (t = o);
                            }
                            (0, i.css)(e.editor, {
                                minHeight: "100%"
                            }), (0, i.css)(e.container, {
                                minHeight: e.o.minHeight,
                                maxHeight: e.o.maxHeight,
                                minWidth: e.o.minWidth,
                                maxWidth: e.o.maxWidth
                            }), this.__setHeight(t), this.__setWidth(e.o.width);
                        }
                    }, t.prototype.__setHeight = function(e) {
                        if ((0, r.isNumber)(e)) {
                            var t = this.j.o, o = t.minHeight, n = t.maxHeight;
                            (0, r.isNumber)(o) && o > e && (e = o), (0, r.isNumber)(n) && e > n && (e = n);
                        }
                        (0, i.css)(this.j.container, "height", e), this.j.o.saveHeightInStorage && this.j.storage.set("height", e), this.__resizeWorkspaceImd();
                    }, t.prototype.__setWidth = function(e) {
                        if ((0, r.isNumber)(e)) {
                            var t = this.j.o, o = t.minWidth, n = t.maxWidth;
                            (0, r.isNumber)(o) && o > e && (e = o), (0, r.isNumber)(n) && e > n && (e = n);
                        }
                        (0, i.css)(this.j.container, "width", e), this.__resizeWorkspaceImd();
                    }, t.prototype.__getNotWorkHeight = function() {
                        var e, t;
                        return ((null === (e = this.j.toolbarContainer) || void 0 === e ? void 0 : e.offsetHeight) || 0) + ((null === (t = this.j.statusbar) || void 0 === t ? void 0 : t.getHeight()) || 0) + 2;
                    }, t.prototype.__resizeWorkspaceImd = function() {
                        if (this.j && !this.j.isDestructed && this.j.o && !this.j.o.inline && this.j.container && this.j.container.parentNode) {
                            var e = ((0, i.css)(this.j.container, "minHeight") || 0) - this.__getNotWorkHeight();
                            if ((0, r.isNumber)(e) && e > 0 && ([
                                this.j.workplace,
                                this.j.iframe,
                                this.j.editor
                            ].map(function(t) {
                                t && (0, i.css)(t, "minHeight", e);
                            }), this.j.e.fire("setMinHeight", e)), (0, r.isNumber)(this.j.o.maxHeight)) {
                                var t = this.j.o.maxHeight - this.__getNotWorkHeight();
                                [
                                    this.j.workplace,
                                    this.j.iframe,
                                    this.j.editor
                                ].map(function(e) {
                                    e && (0, i.css)(e, "maxHeight", t);
                                }), this.j.e.fire("setMaxHeight", t);
                            }
                            this.j.container && (0, i.css)(this.j.workplace, "height", "auto" !== this.j.o.height || this.j.isFullSize ? this.j.container.offsetHeight - this.__getNotWorkHeight() : "auto");
                        }
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off(e.ow, "load.size", this.__resizeWorkspaces).off(".size");
                    }, n.__decorate([
                        (0, s.throttle)()
                    ], t.prototype, "__initialize", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "__resizeWorkspaceImd", null), n.__decorate([
                        s.autobind
                    ], t);
                }(a.Plugin);
                t.size = c, l.pluginSystem.add("size", c);
            },
            13985: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(86893), i = o(77904);
                n.Config.prototype.beautifyHTML = !r.IS_IE, n.Config.prototype.sourceEditor = "ace", n.Config.prototype.sourceEditorNativeOptions = {
                    showGutter: !0,
                    theme: "ace/theme/idle_fingers",
                    mode: "ace/mode/html",
                    wrap: !0,
                    highlightActiveLine: !0
                }, n.Config.prototype.sourceEditorCDNUrlsJS = [
                    "https://cdnjs.cloudflare.com/ajax/libs/ace/1.4.2/ace.js"
                ], n.Config.prototype.beautifyHTMLCDNUrlsJS = [
                    "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify.min.js",
                    "https://cdnjs.cloudflare.com/ajax/libs/js-beautify/1.14.4/beautify-html.min.js"
                ], i.Icon.set("source", o(9342)), n.Config.prototype.controls.source = {
                    mode: r.MODE_SPLIT,
                    exec: function(e) {
                        e.toggleMode();
                    },
                    isActive: function(e) {
                        return e.getRealMode() === r.MODE_SOURCE;
                    },
                    tooltip: "Change mode"
                };
            },
            34186: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.AceEditor = void 0;
                var n = o(20255), r = o(86893), i = o(40332), a = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.className = "jodit_ace_editor", t.proxyOnBlur = function(e) {
                            t.j.e.fire("blur", e);
                        }, t.proxyOnFocus = function(e) {
                            t.j.e.fire("focus", e);
                        }, t.proxyOnMouseDown = function(e) {
                            t.j.e.fire("mousedown", e);
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.aceExists = function() {
                        return void 0 !== this.j.ow.ace;
                    }, t.prototype.getLastColumnIndex = function(e) {
                        return this.instance.session.getLine(e).length;
                    }, t.prototype.getLastColumnIndices = function() {
                        for(var e = this.instance.session.getLength(), t = [], o = 0, n = 0; e > n; n++)o += this.getLastColumnIndex(n), n > 0 && (o += 1), t[n] = o;
                        return t;
                    }, t.prototype.getRowColumnIndices = function(e) {
                        var t = this.getLastColumnIndices();
                        if (t[0] >= e) return {
                            row: 0,
                            column: e
                        };
                        for(var o = 1, n = 1; t.length > n; n++)e > t[n] && (o = n + 1);
                        return {
                            row: o,
                            column: e - t[o - 1] - 1
                        };
                    }, t.prototype.setSelectionRangeIndices = function(e, t) {
                        var o = this.getRowColumnIndices(e), n = this.getRowColumnIndices(t);
                        this.instance.getSelection().setSelectionRange({
                            start: o,
                            end: n
                        });
                    }, t.prototype.getIndexByRowColumn = function(e, t) {
                        return this.getLastColumnIndices()[e] - this.getLastColumnIndex(e) + t;
                    }, t.prototype.init = function(e) {
                        var t = this, o = function() {
                            if (void 0 === t.instance && t.aceExists()) {
                                var o = t.j.c.div("jodit-source__mirror-fake");
                                t.container.appendChild(o), t.instance = e.ow.ace.edit(o), t.instance.setTheme(e.o.sourceEditorNativeOptions.theme), t.instance.renderer.setShowGutter(e.o.sourceEditorNativeOptions.showGutter), t.instance.getSession().setMode(e.o.sourceEditorNativeOptions.mode), t.instance.setHighlightActiveLine(e.o.sourceEditorNativeOptions.highlightActiveLine), t.instance.getSession().setUseWrapMode(!0), t.instance.setOption("indentedSoftWrap", !1), t.instance.setOption("wrap", e.o.sourceEditorNativeOptions.wrap), t.instance.getSession().setUseWorker(!1), t.instance.$blockScrolling = 1 / 0, t.instance.on("change", t.toWYSIWYG), t.instance.on("focus", t.proxyOnFocus), t.instance.on("mousedown", t.proxyOnMouseDown), t.instance.on("blur", t.proxyOnBlur), e.getRealMode() !== r.MODE_WYSIWYG && t.setValue(t.getValue());
                                var n = t.j.async.debounce(function() {
                                    e.isInDestruct || (t.instance.setOption("maxLines", "auto" !== e.o.height ? e.workplace.offsetHeight / t.instance.renderer.lineHeight : 1 / 0), t.instance.resize());
                                }, 2 * t.j.defaultTimeout);
                                e.e.on("afterResize afterSetMode", n), n(), t.onReady();
                            }
                        };
                        e.e.on("afterSetMode", function() {
                            e.getRealMode() !== r.MODE_SOURCE && e.getMode() !== r.MODE_SPLIT || (t.fromWYSIWYG(), o());
                        }), o(), this.aceExists() || (0, i.loadNext)(e, e.o.sourceEditorCDNUrlsJS).then(function() {
                            e.isInDestruct || o();
                        }).catch(function() {
                            return null;
                        });
                    }, t.prototype.destruct = function() {
                        var e, t;
                        this.instance.off("change", this.toWYSIWYG), this.instance.off("focus", this.proxyOnFocus), this.instance.off("mousedown", this.proxyOnMouseDown), this.instance.destroy(), null === (t = null === (e = this.j) || void 0 === e ? void 0 : e.events) || void 0 === t || t.off("aceInited.source");
                    }, t.prototype.setValue = function(e) {
                        if (!this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
                            var t = this.j.e.fire("beautifyHTML", e);
                            (0, i.isString)(t) && (e = t);
                        }
                        this.instance.setValue(e), this.instance.clearSelection();
                    }, t.prototype.getValue = function() {
                        return this.instance.getValue();
                    }, t.prototype.setReadOnly = function(e) {
                        this.instance.setReadOnly(e);
                    }, Object.defineProperty(t.prototype, "isFocused", {
                        get: function() {
                            return this.instance.isFocused();
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.focus = function() {
                        this.instance.focus();
                    }, t.prototype.blur = function() {
                        this.instance.blur();
                    }, t.prototype.getSelectionStart = function() {
                        var e = this.instance.selection.getRange();
                        return this.getIndexByRowColumn(e.start.row, e.start.column);
                    }, t.prototype.getSelectionEnd = function() {
                        var e = this.instance.selection.getRange();
                        return this.getIndexByRowColumn(e.end.row, e.end.column);
                    }, t.prototype.selectAll = function() {
                        this.instance.selection.selectAll();
                    }, t.prototype.insertRaw = function(e) {
                        var t = this.instance.selection.getCursor(), o = this.instance.session.insert(t, e);
                        this.instance.selection.setRange({
                            start: t,
                            end: o
                        }, !1);
                    }, t.prototype.setSelectionRange = function(e, t) {
                        this.setSelectionRangeIndices(e, t);
                    }, t.prototype.setPlaceHolder = function(e) {}, t.prototype.replaceUndoManager = function() {
                        var e = this.jodit.history;
                        this.instance.commands.addCommand({
                            name: "Undo",
                            bindKey: {
                                win: "Ctrl-Z",
                                mac: "Command-Z"
                            },
                            exec: function() {
                                e.undo();
                            }
                        }), this.instance.commands.addCommand({
                            name: "Redo",
                            bindKey: {
                                win: "Ctrl-Shift-Z",
                                mac: "Command-Shift-Z"
                            },
                            exec: function() {
                                e.redo();
                            }
                        });
                    }, t;
                }(o(36729).SourceEditor);
                t.AceEditor = a;
            },
            58633: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.TextAreaEditor = void 0;
                var n = o(20255), r = o(26911), i = o(24263), a = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.autosize = t.j.async.debounce(function() {
                            t.instance.style.height = "auto", t.instance.style.height = t.instance.scrollHeight + "px";
                        }, t.j.defaultTimeout), t;
                    }
                    return n.__extends(t, e), t.prototype.init = function(e) {
                        var t = this;
                        this.instance = e.c.element("textarea", {
                            class: "jodit-source__mirror"
                        }), this.container.appendChild(this.instance), e.e.on(this.instance, "mousedown keydown touchstart input", e.async.debounce(this.toWYSIWYG, e.defaultTimeout)).on("setMinHeight.source", function(e) {
                            (0, r.css)(t.instance, "minHeight", e);
                        }).on(this.instance, "change keydown mousedown touchstart input", this.autosize).on("afterSetMode.source", this.autosize).on(this.instance, "mousedown focus", function(t) {
                            e.e.fire(t.type, t);
                        }), this.autosize(), this.onReady();
                    }, t.prototype.destruct = function() {
                        i.Dom.safeRemove(this.instance);
                    }, t.prototype.getValue = function() {
                        return this.instance.value;
                    }, t.prototype.setValue = function(e) {
                        this.instance.value = e;
                    }, t.prototype.insertRaw = function(e) {
                        var t = this.getValue();
                        if (0 > this.getSelectionStart()) this.setValue(t + e);
                        else {
                            var o = this.getSelectionStart(), n = this.getSelectionEnd();
                            this.setValue(t.substring(0, o) + e + t.substring(n, t.length));
                        }
                    }, t.prototype.getSelectionStart = function() {
                        return this.instance.selectionStart;
                    }, t.prototype.getSelectionEnd = function() {
                        return this.instance.selectionEnd;
                    }, t.prototype.setSelectionRange = function(e, t) {
                        void 0 === t && (t = e), this.instance.setSelectionRange(e, t);
                    }, Object.defineProperty(t.prototype, "isFocused", {
                        get: function() {
                            return this.instance === this.j.od.activeElement;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), t.prototype.focus = function() {
                        this.instance.focus();
                    }, t.prototype.blur = function() {
                        this.instance.blur();
                    }, t.prototype.setPlaceHolder = function(e) {
                        this.instance.setAttribute("placeholder", e);
                    }, t.prototype.setReadOnly = function(e) {
                        e ? this.instance.setAttribute("readonly", "true") : this.instance.removeAttribute("readonly");
                    }, t.prototype.selectAll = function() {
                        this.instance.select();
                    }, t.prototype.replaceUndoManager = function() {
                        var e = this, t = this.jodit.history;
                        this.j.e.on(this.instance, "keydown", function(o) {
                            if ((o.ctrlKey || o.metaKey) && "z" === o.key) return o.shiftKey ? t.redo() : t.undo(), e.setSelectionRange(e.getValue().length), !1;
                        });
                    }, t;
                }(o(36729).SourceEditor);
                t.TextAreaEditor = a;
            },
            52834: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                n.__exportStar(o(58633), t), n.__exportStar(o(34186), t);
            },
            94785: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createSourceEditor = void 0;
                var n = o(40332), r = o(52834);
                t.createSourceEditor = function(e, t, o, i, a) {
                    var s;
                    if ((0, n.isFunction)(e)) s = e(t);
                    else switch(e){
                        case "ace":
                            if (!t.o.shadowRoot) {
                                s = new r.AceEditor(t, o, i, a);
                                break;
                            }
                        default:
                            s = new r.TextAreaEditor(t, o, i, a);
                    }
                    return s.init(t), s.onReadyAlways(function() {
                        s.setReadOnly(t.o.readonly);
                    }), s;
                };
            },
            36729: function(e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.SourceEditor = void 0;
                var o = function() {
                    function e(e, t, o, n) {
                        this.jodit = e, this.container = t, this.toWYSIWYG = o, this.fromWYSIWYG = n, this.className = "", this.isReady = !1;
                    }
                    return Object.defineProperty(e.prototype, "j", {
                        get: function() {
                            return this.jodit;
                        },
                        enumerable: !1,
                        configurable: !0
                    }), e.prototype.onReady = function() {
                        this.replaceUndoManager(), this.isReady = !0, this.j.e.fire(this, "ready");
                    }, e.prototype.onReadyAlways = function(e) {
                        var t;
                        this.isReady ? e() : null === (t = this.j.events) || void 0 === t || t.on(this, "ready", e);
                    }, e;
                }();
                t.SourceEditor = o;
            },
            86030: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.source = void 0;
                var n = o(20255);
                o(68197);
                var r = o(86893), i = o(86893), a = o(57549), s = o(24263), l = o(40332), c = o(43441), u = o(17332), d = o(94785);
                o(13985);
                var p = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.buttons = [
                            {
                                name: "source",
                                group: "source"
                            }
                        ], t.__lock = !1, t.__oldMirrorValue = "", t.tempMarkerStart = "{start-jodit-selection}", t.tempMarkerStartReg = /{start-jodit-selection}/g, t.tempMarkerEnd = "{end-jodit-selection}", t.tempMarkerEndReg = /{end-jodit-selection}/g, t.getSelectionStart = function() {
                            var e, o;
                            return null !== (o = null === (e = t.sourceEditor) || void 0 === e ? void 0 : e.getSelectionStart()) && void 0 !== o ? o : 0;
                        }, t.getSelectionEnd = function() {
                            var e, o;
                            return null !== (o = null === (e = t.sourceEditor) || void 0 === e ? void 0 : e.getSelectionEnd()) && void 0 !== o ? o : 0;
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.onInsertHTML = function(e) {
                        var t;
                        if (!this.j.o.readonly && !this.j.isEditorMode()) return null === (t = this.sourceEditor) || void 0 === t || t.insertRaw(e), this.toWYSIWYG(), !1;
                    }, t.prototype.fromWYSIWYG = function(e) {
                        if (void 0 === e && (e = !1), !this.__lock || !0 === e) {
                            this.__lock = !0;
                            var t = this.j.getEditorValue(!1, i.SOURCE_CONSUMER);
                            t !== this.getMirrorValue() && this.setMirrorValue(t), this.__lock = !1;
                        }
                    }, t.prototype.toWYSIWYG = function() {
                        if (!this.__lock) {
                            var e = this.getMirrorValue();
                            e !== this.__oldMirrorValue && (this.__lock = !0, this.j.value = e, this.__lock = !1, this.__oldMirrorValue = e);
                        }
                    }, t.prototype.getNormalPosition = function(e, t) {
                        for(t = t.replace(/<(script|style|iframe)[^>]*>[^]*?<\/\1>/im, function(e) {
                            for(var t = "", o = 0; e.length > o; o += 1)t += i.INVISIBLE_SPACE;
                            return t;
                        }); e > 0 && t[e] === i.INVISIBLE_SPACE;)e--;
                        for(var o = e; o > 0;){
                            if ("<" === t[--o] && void 0 !== t[o + 1] && t[o + 1].match(/[\w/]+/i)) return o;
                            if (">" === t[o]) return e;
                        }
                        return e;
                    }, t.prototype.clnInv = function(e) {
                        return e.replace(r.INVISIBLE_SPACE_REG_EXP(), "");
                    }, t.prototype.onSelectAll = function(e) {
                        var t;
                        if ("selectall" === e.toLowerCase() && this.j.getRealMode() === i.MODE_SOURCE) return null === (t = this.sourceEditor) || void 0 === t || t.selectAll(), !1;
                    }, t.prototype.getMirrorValue = function() {
                        var e;
                        return (null === (e = this.sourceEditor) || void 0 === e ? void 0 : e.getValue()) || "";
                    }, t.prototype.setMirrorValue = function(e) {
                        var t;
                        null === (t = this.sourceEditor) || void 0 === t || t.setValue(e);
                    }, t.prototype.setFocusToMirror = function() {
                        var e;
                        null === (e = this.sourceEditor) || void 0 === e || e.focus();
                    }, t.prototype.saveSelection = function() {
                        if (this.j.getRealMode() === r.MODE_WYSIWYG) this.j.s.save(), this.j.synchronizeValues(), this.fromWYSIWYG(!0);
                        else {
                            if (this.j.o.editHTMLDocumentMode) return;
                            var e = this.getMirrorValue();
                            if (this.getSelectionStart() === this.getSelectionEnd()) {
                                var t = this.j.s.marker(!0), o = this.getNormalPosition(this.getSelectionStart(), this.getMirrorValue());
                                this.setMirrorValue(e.substring(0, o) + this.clnInv(t.outerHTML) + e.substring(o));
                            } else {
                                var n = this.j.s.marker(!0), i = this.j.s.marker(!1), a = (o = this.getNormalPosition(this.getSelectionStart(), e), this.getNormalPosition(this.getSelectionEnd(), e));
                                this.setMirrorValue(e.substring(0, o) + this.clnInv(n.outerHTML) + e.substring(o, a - o) + this.clnInv(i.outerHTML) + e.substring(a));
                            }
                            this.toWYSIWYG();
                        }
                    }, t.prototype.removeSelection = function() {
                        if (this.j.getRealMode() === r.MODE_WYSIWYG) return this.__lock = !0, this.j.s.restore(), void (this.__lock = !1);
                        var e = this.getMirrorValue(), t = 0, o = 0;
                        try {
                            if (e = e.replace(/<span[^>]+data-jodit-selection_marker=(["'])start\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerStart).replace(/<span[^>]+data-jodit-selection_marker=(["'])end\1[^>]*>[<>]*?<\/span>/gim, this.tempMarkerEnd), !this.j.o.editHTMLDocumentMode && this.j.o.beautifyHTML) {
                                var n = this.j.e.fire("beautifyHTML", e);
                                (0, l.isString)(n) && (e = n);
                            }
                            if (o = t = e.indexOf(this.tempMarkerStart), e = e.replace(this.tempMarkerStartReg, ""), -1 !== t) {
                                var i = e.indexOf(this.tempMarkerEnd);
                                -1 !== i && (o = i);
                            }
                            e = e.replace(this.tempMarkerEndReg, "");
                        } finally{
                            e = e.replace(this.tempMarkerEndReg, "").replace(this.tempMarkerStartReg, "");
                        }
                        this.setMirrorValue(e), this.setMirrorSelectionRange(t, o), this.toWYSIWYG(), this.setFocusToMirror();
                    }, t.prototype.setMirrorSelectionRange = function(e, t) {
                        var o;
                        null === (o = this.sourceEditor) || void 0 === o || o.setSelectionRange(e, t);
                    }, t.prototype.onReadonlyReact = function() {
                        var e;
                        null === (e = this.sourceEditor) || void 0 === e || e.setReadOnly(this.j.o.readonly);
                    }, t.prototype.afterInit = function(e) {
                        var t = this;
                        if (this.mirrorContainer = e.c.div("jodit-source"), e.workplace.appendChild(this.mirrorContainer), e.e.on("afterAddPlace changePlace afterInit", function() {
                            e.workplace.appendChild(t.mirrorContainer);
                        }), this.sourceEditor = (0, d.createSourceEditor)("area", e, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG), e.e.on(e.ow, "keydown", function(e) {
                            var o;
                            e.key === i.KEY_ESC && (null === (o = t.sourceEditor) || void 0 === o ? void 0 : o.isFocused) && t.sourceEditor.blur();
                        }), this.onReadonlyReact(), e.e.on("placeholder.source", function(e) {
                            var o;
                            null === (o = t.sourceEditor) || void 0 === o || o.setPlaceHolder(e);
                        }).on("change.source", this.syncValueFromWYSIWYG).on("beautifyHTML", function(e) {
                            return e;
                        }), e.o.beautifyHTML) {
                            var o = function() {
                                var t, o = e.ow.html_beautify;
                                return !(!o || e.isInDestruct || (null === (t = e.events) || void 0 === t || t.off("beautifyHTML").on("beautifyHTML", function(e) {
                                    return o(e);
                                }), 0));
                            };
                            o() || (0, l.loadNext)(e, e.o.beautifyHTMLCDNUrlsJS).then(o);
                        }
                        this.syncValueFromWYSIWYG(!0), this.initSourceEditor(e);
                    }, t.prototype.syncValueFromWYSIWYG = function(e) {
                        void 0 === e && (e = !1);
                        var t = this.j;
                        t.getMode() !== i.MODE_SPLIT && t.getMode() !== i.MODE_SOURCE || this.fromWYSIWYG(e);
                    }, t.prototype.initSourceEditor = function(e) {
                        var t, o = this;
                        if ("area" !== e.o.sourceEditor) {
                            var n = (0, d.createSourceEditor)(e.o.sourceEditor, e, this.mirrorContainer, this.toWYSIWYG, this.fromWYSIWYG);
                            n.onReadyAlways(function() {
                                var t, r;
                                null === (t = o.sourceEditor) || void 0 === t || t.destruct(), o.sourceEditor = n, o.syncValueFromWYSIWYG(!0), null === (r = e.events) || void 0 === r || r.fire("sourceEditorReady", e);
                            });
                        } else null === (t = this.sourceEditor) || void 0 === t || t.onReadyAlways(function() {
                            var t;
                            o.syncValueFromWYSIWYG(!0), null === (t = e.events) || void 0 === t || t.fire("sourceEditorReady", e);
                        });
                    }, t.prototype.beforeDestruct = function() {
                        this.sourceEditor && (this.sourceEditor.destruct(), delete this.sourceEditor), s.Dom.safeRemove(this.mirrorContainer);
                    }, n.__decorate([
                        (0, c.watch)(":insertHTML.source")
                    ], t.prototype, "onInsertHTML", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "fromWYSIWYG", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "toWYSIWYG", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "getNormalPosition", null), n.__decorate([
                        (0, c.watch)(":beforeCommand.source")
                    ], t.prototype, "onSelectAll", null), n.__decorate([
                        (0, c.watch)(":beforeSetMode.source")
                    ], t.prototype, "saveSelection", null), n.__decorate([
                        (0, c.watch)(":afterSetMode.source")
                    ], t.prototype, "removeSelection", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "setMirrorSelectionRange", null), n.__decorate([
                        (0, c.watch)(":readonly.source")
                    ], t.prototype, "onReadonlyReact", null), n.__decorate([
                        c.autobind
                    ], t.prototype, "syncValueFromWYSIWYG", null), t;
                }(a.Plugin);
                t.source = p, u.pluginSystem.add("source", p);
            },
            50876: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(77904);
                n.Config.prototype.spellcheck = !1, r.Icon.set("spellcheck", o(69546)), n.Config.prototype.controls.spellcheck = {
                    isActive: function(e) {
                        return e.o.spellcheck;
                    },
                    icon: o(69546),
                    name: "spellcheck",
                    command: "toggleSpellcheck",
                    tooltip: "Spellcheck"
                };
            },
            87882: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
                var n = o(5586);
                t.ar = n;
                var r = o(66023);
                t.cs_cz = r;
                var i = o(65860);
                t.de = i;
                var a = o(86055);
                t.es = a;
                var s = o(50037);
                t.fa = s;
                var l = o(7118);
                t.fr = l;
                var c = o(30298);
                t.he = c;
                var u = o(52107);
                t.hu = u;
                var d = o(31240);
                t.id = d;
                var p = o(4101);
                t.it = p;
                var f = o(69286);
                t.ja = f;
                var h = o(13402);
                t.ko = h;
                var m = o(1242);
                t.mn = m;
                var v = o(89574);
                t.nl = v;
                var g = o(63630);
                t.pl = g;
                var y = o(72212);
                t.pt_br = y;
                var _ = o(82570);
                t.ru = _;
                var b = o(19323);
                t.tr = b;
                var w = o(50279);
                t.zh_cn = w;
                var S = o(98364);
                t.zh_tw = S;
            },
            17002: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.spellcheck = void 0;
                var n = o(20255), r = o(57549), i = o(67309), a = o(43441), s = o(17332);
                o(50876);
                var l = function(e) {
                    function t(t) {
                        var n = e.call(this, t) || this;
                        return n.buttons = [
                            {
                                group: "state",
                                name: "spellcheck"
                            }
                        ], (0, s.extendLang)(o(87882)), n;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.e.on("afterInit afterAddPlace prepareWYSIWYGEditor", this.toggleSpellcheck), this.toggleSpellcheck(), e.registerCommand("toggleSpellcheck", function() {
                            t.jodit.o.spellcheck = !t.jodit.o.spellcheck, t.toggleSpellcheck(), t.j.e.fire("updateToolbar");
                        });
                    }, t.prototype.toggleSpellcheck = function() {
                        (0, i.attr)(this.jodit.editor, "spellcheck", this.jodit.o.spellcheck);
                    }, t.prototype.beforeDestruct = function(e) {}, n.__decorate([
                        a.autobind
                    ], t.prototype, "toggleSpellcheck", null), t;
                }(r.Plugin);
                t.spellcheck = l, s.pluginSystem.add("spellcheck", l);
            },
            59818: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.showCharsCounter = !0, n.Config.prototype.countHTMLChars = !1, n.Config.prototype.showWordsCounter = !0;
            },
            1557: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.stat = void 0;
                var n = o(20255), r = o(86893), i = o(85605), a = o(24263), s = o(17332);
                o(59818);
                var l = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.charCounter = null, t.wordCounter = null, t.reInit = function() {
                            t.j.o.showCharsCounter && t.charCounter && t.j.statusbar.append(t.charCounter, !0), t.j.o.showWordsCounter && t.wordCounter && t.j.statusbar.append(t.wordCounter, !0), t.j.e.off("change keyup", t.calc).on("change keyup", t.calc), t.calc();
                        }, t.calc = t.j.async.throttle(function() {
                            var e = t.j.text;
                            if (t.j.o.showCharsCounter && t.charCounter) {
                                var o = t.j.o.countHTMLChars ? t.j.value : e.replace((0, r.SPACE_REG_EXP)(), "");
                                t.charCounter.textContent = t.j.i18n("Chars: %d", o.length);
                            }
                            t.j.o.showWordsCounter && t.wordCounter && (t.wordCounter.textContent = t.j.i18n("Words: %d", e.replace((0, r.INVISIBLE_SPACE_REG_EXP)(), "").split((0, r.SPACE_REG_EXP)()).filter(function(e) {
                                return e.length;
                            }).length));
                        }, t.j.defaultTimeout), t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function() {
                        this.charCounter = this.j.c.span(), this.wordCounter = this.j.c.span(), this.j.e.on("afterInit changePlace afterAddPlace", this.reInit), this.reInit();
                    }, t.prototype.beforeDestruct = function() {
                        a.Dom.safeRemove(this.charCounter), a.Dom.safeRemove(this.wordCounter), this.j.e.off("afterInit changePlace afterAddPlace", this.reInit), this.charCounter = null, this.wordCounter = null;
                    }, t;
                }(i.Plugin);
                t.stat = l, s.pluginSystem.add("stat", l);
            },
            40790: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166);
                n.Config.prototype.toolbarSticky = !0, n.Config.prototype.toolbarDisableStickyForMobile = !0, n.Config.prototype.toolbarStickyOffset = 0;
            },
            82808: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.sticky = void 0;
                var n = o(20255);
                o(60057);
                var r = o(86893), i = o(85605), a = o(24263), s = o(40332), l = o(43441), c = o(17332);
                o(40790);
                var u = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.isToolbarSticked = !1, t.createDummy = function(e) {
                            r.IS_IE && !t.dummyBox && (t.dummyBox = t.j.c.div(), t.dummyBox.classList.add("jodit_sticky-dummy_toolbar"), t.j.container.insertBefore(t.dummyBox, e));
                        }, t.addSticky = function(e) {
                            t.isToolbarSticked || (t.createDummy(e), t.j.container.classList.add("jodit_sticky"), t.isToolbarSticked = !0), (0, s.css)(e, {
                                top: t.j.o.toolbarStickyOffset || null,
                                width: t.j.container.offsetWidth - 2
                            }), r.IS_IE && t.dummyBox && (0, s.css)(t.dummyBox, {
                                height: e.offsetHeight
                            });
                        }, t.removeSticky = function(e) {
                            t.isToolbarSticked && ((0, s.css)(e, {
                                width: "",
                                top: ""
                            }), t.j.container.classList.remove("jodit_sticky"), t.isToolbarSticked = !1);
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.e.on(e.ow, "scroll.sticky wheel.sticky mousewheel.sticky resize.sticky", this.onScroll).on("getStickyState.sticky", function() {
                            return t.isToolbarSticked;
                        });
                    }, t.prototype.onScroll = function() {
                        var e = this.jodit, t = e.ow.pageYOffset || e.od.documentElement && e.od.documentElement.scrollTop || 0, o = (0, s.offset)(e.container, e, e.od, !0), n = e.getMode() === r.MODE_WYSIWYG && t + e.o.toolbarStickyOffset > o.top && o.top + o.height > t + e.o.toolbarStickyOffset && !(e.o.toolbarDisableStickyForMobile && this.isMobile());
                        if (e.o.toolbarSticky && !0 === e.o.toolbar && this.isToolbarSticked !== n) {
                            var i = e.toolbarContainer;
                            i && (n ? this.addSticky(i) : this.removeSticky(i)), e.e.fire("toggleSticky", n);
                        }
                    }, t.prototype.isMobile = function() {
                        return this.j && this.j.options && this.j.container && this.j.o.sizeSM >= this.j.container.offsetWidth;
                    }, t.prototype.beforeDestruct = function(e) {
                        this.dummyBox && a.Dom.safeRemove(this.dummyBox), e.e.off(e.ow, "scroll.sticky wheel.sticky mousewheel.sticky resize.sticky", this.onScroll).off(".sticky");
                    }, n.__decorate([
                        (0, l.throttle)()
                    ], t.prototype, "onScroll", null), t;
                }(i.Plugin);
                t.sticky = u, c.pluginSystem.add("sticky", u);
            },
            31750: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(77904);
                n.Config.prototype.usePopupForSpecialCharacters = !1, n.Config.prototype.specialCharacters = [
                    "!",
                    "&quot;",
                    "#",
                    "$",
                    "%",
                    "&amp;",
                    "'",
                    "(",
                    ")",
                    "*",
                    "+",
                    "-",
                    ".",
                    "/",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    ":",
                    ";",
                    "&lt;",
                    "=",
                    "&gt;",
                    "?",
                    "@",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "[",
                    "]",
                    "^",
                    "_",
                    "`",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "{",
                    "|",
                    "}",
                    "~",
                    "&euro;",
                    "&lsquo;",
                    "&rsquo;",
                    "&ldquo;",
                    "&rdquo;",
                    "&ndash;",
                    "&mdash;",
                    "&iexcl;",
                    "&cent;",
                    "&pound;",
                    "&curren;",
                    "&yen;",
                    "&brvbar;",
                    "&sect;",
                    "&uml;",
                    "&copy;",
                    "&ordf;",
                    "&laquo;",
                    "&raquo;",
                    "&not;",
                    "&reg;",
                    "&macr;",
                    "&deg;",
                    "&sup2;",
                    "&sup3;",
                    "&acute;",
                    "&micro;",
                    "&para;",
                    "&middot;",
                    "&cedil;",
                    "&sup1;",
                    "&ordm;",
                    "&frac14;",
                    "&frac12;",
                    "&frac34;",
                    "&iquest;",
                    "&Agrave;",
                    "&Aacute;",
                    "&Acirc;",
                    "&Atilde;",
                    "&Auml;",
                    "&Aring;",
                    "&AElig;",
                    "&Ccedil;",
                    "&Egrave;",
                    "&Eacute;",
                    "&Ecirc;",
                    "&Euml;",
                    "&Igrave;",
                    "&Iacute;",
                    "&Icirc;",
                    "&Iuml;",
                    "&ETH;",
                    "&Ntilde;",
                    "&Ograve;",
                    "&Oacute;",
                    "&Ocirc;",
                    "&Otilde;",
                    "&Ouml;",
                    "&times;",
                    "&Oslash;",
                    "&Ugrave;",
                    "&Uacute;",
                    "&Ucirc;",
                    "&Uuml;",
                    "&Yacute;",
                    "&THORN;",
                    "&szlig;",
                    "&agrave;",
                    "&aacute;",
                    "&acirc;",
                    "&atilde;",
                    "&auml;",
                    "&aring;",
                    "&aelig;",
                    "&ccedil;",
                    "&egrave;",
                    "&eacute;",
                    "&ecirc;",
                    "&euml;",
                    "&igrave;",
                    "&iacute;",
                    "&icirc;",
                    "&iuml;",
                    "&eth;",
                    "&ntilde;",
                    "&ograve;",
                    "&oacute;",
                    "&ocirc;",
                    "&otilde;",
                    "&ouml;",
                    "&divide;",
                    "&oslash;",
                    "&ugrave;",
                    "&uacute;",
                    "&ucirc;",
                    "&uuml;",
                    "&yacute;",
                    "&thorn;",
                    "&yuml;",
                    "&OElig;",
                    "&oelig;",
                    "&#372;",
                    "&#374",
                    "&#373",
                    "&#375;",
                    "&sbquo;",
                    "&#8219;",
                    "&bdquo;",
                    "&hellip;",
                    "&trade;",
                    "&#9658;",
                    "&bull;",
                    "&rarr;",
                    "&rArr;",
                    "&hArr;",
                    "&diams;",
                    "&asymp;"
                ], r.Icon.set("symbols", o(43158)), n.Config.prototype.controls.symbols = {
                    hotkeys: [
                        "ctrl+shift+i",
                        "cmd+shift+i"
                    ],
                    tooltip: "Insert Special Character",
                    popup: function(e, t, o, n) {
                        var r = e.e.fire("generateSpecialCharactersTable.symbols");
                        if (r) {
                            if (e.o.usePopupForSpecialCharacters) {
                                var i = e.c.div();
                                return i.classList.add("jodit-symbols"), i.appendChild(r), e.e.on(r, "close_dialog", n), i;
                            }
                            e.alert(r, "Select Special Character", void 0, "jodit-symbols").bindDestruct(e);
                            var a = r.querySelector("a");
                            a && a.focus();
                        }
                    }
                };
            },
            21236: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.zh_tw = t.zh_cn = t.tr = t.ru = t.pt_br = t.pl = t.nl = t.mn = t.ko = t.ja = t.it = t.id = t.hu = t.he = t.fr = t.fa = t.es = t.de = t.cs_cz = t.ar = void 0;
                var n = o(54261);
                t.ar = n;
                var r = o(60425);
                t.cs_cz = r;
                var i = o(7057);
                t.de = i;
                var a = o(48356);
                t.es = a;
                var s = o(11428);
                t.fa = s;
                var l = o(29084);
                t.fr = l;
                var c = o(22876);
                t.he = c;
                var u = o(20890);
                t.hu = u;
                var d = o(75987);
                t.id = d;
                var p = o(60379);
                t.it = p;
                var f = o(99950);
                t.ja = f;
                var h = o(60934);
                t.ko = h;
                var m = o(45913);
                t.mn = m;
                var v = o(21994);
                t.nl = v;
                var g = o(38128);
                t.pl = g;
                var y = o(71515);
                t.pt_br = y;
                var _ = o(58194);
                t.ru = _;
                var b = o(65802);
                t.tr = b;
                var w = o(86628);
                t.zh_cn = w;
                var S = o(32210);
                t.zh_tw = S;
            },
            48560: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.symbols = void 0;
                var n = o(20255);
                o(33393);
                var r = o(86893), i = o(85605), a = o(24263), s = o(76502), l = o(17332);
                o(31750);
                var c = function(e) {
                    function t(t) {
                        var n = e.call(this, t) || this;
                        return n.buttons = [
                            {
                                name: "symbols",
                                group: "insert"
                            }
                        ], n.countInRow = 17, (0, l.extendLang)(o(21236)), n;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        var t = this;
                        e.e.on("generateSpecialCharactersTable.symbols", function() {
                            for(var o = e.c.fromHTML('<div class="jodit-symbols__container">\n\t\t\t\t\t\t<div class="jodit-symbols__container_table">\n\t\t\t\t\t\t\t<table class="jodit-symbols__table"><tbody></tbody></table>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jodit-symbols__container_preview">\n\t\t\t\t\t\t\t<div class="jodit-symbols__preview"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>'), n = o.querySelector(".jodit-symbols__preview"), i = o.querySelector("table").tBodies[0], l = [], c = 0; e.o.specialCharacters.length > c;){
                                for(var u = e.c.element("tr"), d = 0; t.countInRow > d && e.o.specialCharacters.length > c; d += 1, c += 1){
                                    var p = e.c.element("td"), f = e.c.fromHTML('<a\n\t\t\t\t\t\t\t\t\tdata-index="'.concat(c, '"\n\t\t\t\t\t\t\t\t\tdata-index-j="').concat(d, '"\n\t\t\t\t\t\t\t\t\trole="option"\n\t\t\t\t\t\t\t\t\ttabindex="-1"\n\t\t\t\t\t\t\t>').concat(e.o.specialCharacters[c], "</a>"));
                                    l.push(f), p.appendChild(f), u.appendChild(p);
                                }
                                i.appendChild(u);
                            }
                            var h = t;
                            return e.e.on(l, "focus", function() {
                                n.innerHTML = this.innerHTML;
                            }).on(l, "mousedown", function(t) {
                                a.Dom.isTag(this, "a") && (e.s.focus(), e.s.insertHTML(this.innerHTML), e.e.fire(this, "close_dialog"), t && t.preventDefault(), t && t.stopImmediatePropagation());
                            }).on(l, "mouseenter", function() {
                                a.Dom.isTag(this, "a") && this.focus();
                            }).on(l, "keydown", function(t) {
                                var o = t.target;
                                if (a.Dom.isTag(o, "a")) {
                                    var n = parseInt((0, s.attr)(o, "-index") || "0", 10), i = parseInt((0, s.attr)(o, "data-index-j") || "0", 10), c = void 0;
                                    switch(t.key){
                                        case r.KEY_UP:
                                        case r.KEY_DOWN:
                                            void 0 === l[c = t.key === r.KEY_UP ? n - h.countInRow : n + h.countInRow] && (c = t.key === r.KEY_UP ? Math.floor(l.length / h.countInRow) * h.countInRow + i : i) > l.length - 1 && (c -= h.countInRow), l[c] && l[c].focus();
                                            break;
                                        case r.KEY_RIGHT:
                                        case r.KEY_LEFT:
                                            void 0 === l[c = t.key === r.KEY_LEFT ? n - 1 : n + 1] && (c = t.key === r.KEY_LEFT ? l.length - 1 : 0), l[c] && l[c].focus();
                                            break;
                                        case r.KEY_ENTER:
                                            e.e.fire(o, "mousedown"), t.stopImmediatePropagation(), t.preventDefault();
                                    }
                                }
                            }), o;
                        });
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off("generateSpecialCharactersTable.symbols");
                    }, t;
                }(i.Plugin);
                t.symbols = c, l.pluginSystem.add("symbols", c);
            },
            15797: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(20255).__exportStar(o(41170), t);
            },
            41170: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.onTabInsideLi = void 0;
                var n = o(20255), r = o(24263);
                o(603), t.onTabInsideLi = function(e, t) {
                    if (void 0 === t && (t = !1), !e.o.tab.tabInsideLiInsertNewList) return !1;
                    var o = n.__read(function(e) {
                        var t = e.createInside.fake(), o = e.createInside.fake(), n = e.s.range.cloneRange();
                        n.collapse(!0), n.insertNode(t);
                        var r = e.s.range.cloneRange();
                        return r.collapse(!1), r.insertNode(o), [
                            t,
                            o
                        ];
                    }(e), 2), i = o[0], a = o[1];
                    try {
                        var s = function(e, t, o) {
                            var n = r.Dom.closest(t, "li", e.editor);
                            return !!n && !(!o && !r.Dom.isTag(n.previousElementSibling, "li")) && !(o && !r.Dom.closest(n, "li", e.editor)) && n;
                        }(e, i, t);
                        if (!s) return !1;
                        if (!function(e, t, o) {
                            var n = r.Dom.closest(o, "li", t.editor);
                            return !(!n || n !== e && !e.contains(n));
                        }(s, e, i)) return !1;
                        var l = r.Dom.closest(s, [
                            "ol",
                            "ul"
                        ], e.editor);
                        return !(!l || t && !r.Dom.closest(l, "li", e.editor) || (t ? function(e, t, o) {
                            var n = r.Dom.closest(t, "li", e.editor), i = Array.from(t.children).filter(function(e) {
                                return r.Dom.isTag(e, "li");
                            });
                            r.Dom.after(n, o);
                            var a = i.indexOf(o);
                            if (0 !== a && 1 !== i.length || r.Dom.safeRemove(t), a !== i.length - 1) {
                                var s = t.cloneNode();
                                r.Dom.append(o, s);
                                for(var l = a + 1; i.length > l; l += 1)r.Dom.append(s, i[l]);
                            }
                        }(e, l, s) : function(e, t, o) {
                            var n = o.previousElementSibling, i = n.lastElementChild, a = r.Dom.isTag(i, t.tagName) ? i : e.createInside.element(t.tagName, Array.from(t.attributes).reduce(function(e, t) {
                                return e[t.name] = t.value, e;
                            }, {}));
                            a.appendChild(o), i !== a && n.appendChild(a);
                        }(e, l, s), 0));
                    } finally{
                        var c = e.s.createRange();
                        c.setStartAfter(i), c.setEndBefore(a), e.s.selectRange(c), r.Dom.safeRemove(i), r.Dom.safeRemove(a);
                    }
                    return !1;
                };
            },
            56198: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.tab = {
                    tabInsideLiInsertNewList: !0
                };
            },
            32246: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255), r = o(57549), i = o(43441), a = o(86893), s = o(17332), l = o(15797);
                o(56198);
                var c = function(e) {
                    function t() {
                        return null !== e && e.apply(this, arguments) || this;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {}, t.prototype.__onTab = function(e) {
                        if (e.key === a.KEY_TAB && this.__onShift(e.shiftKey)) return !1;
                    }, t.prototype.__onCommand = function(e) {
                        if (("indent" === e || "outdent" === e) && this.__onShift("outdent" === e)) return !1;
                    }, t.prototype.__onShift = function(e) {
                        var t = (0, l.onTabInsideLi)(this.j, e);
                        return t && this.j.e.fire("afterTab", e), t;
                    }, t.prototype.beforeDestruct = function(e) {}, n.__decorate([
                        (0, i.watch)(":keydown.tab")
                    ], t.prototype, "__onTab", null), n.__decorate([
                        (0, i.watch)(":beforeCommand.tab")
                    ], t.prototype, "__onCommand", null), t;
                }(r.Plugin);
                s.pluginSystem.add("tab", c);
            },
            23308: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.tableKeyboardNavigation = void 0;
                var n = o(86893), r = o(24263), i = o(25120), a = o(17332);
                function s(e) {
                    e.e.off(".tableKeyboardNavigation").on("keydown.tableKeyboardNavigation", function(t) {
                        var o, a;
                        if ((t.key === n.KEY_TAB || t.key === n.KEY_LEFT || t.key === n.KEY_RIGHT || t.key === n.KEY_UP || t.key === n.KEY_DOWN) && (o = e.s.current(), a = r.Dom.up(o, function(e) {
                            return e && e.nodeName && /^td|th$/i.test(e.nodeName);
                        }, e.editor))) {
                            var s = e.s.range;
                            if (t.key === n.KEY_TAB || o === a || (t.key !== n.KEY_LEFT && t.key !== n.KEY_UP || !(r.Dom.prev(o, function(e) {
                                return t.key === n.KEY_UP ? r.Dom.isTag(e, "br") : Boolean(e);
                            }, a) || t.key !== n.KEY_UP && r.Dom.isText(o) && 0 !== s.startOffset)) && (t.key !== n.KEY_RIGHT && t.key !== n.KEY_DOWN || !(r.Dom.next(o, function(e) {
                                return t.key === n.KEY_DOWN ? r.Dom.isTag(e, "br") : Boolean(e);
                            }, a) || t.key !== n.KEY_DOWN && r.Dom.isText(o) && o.nodeValue && s.startOffset !== o.nodeValue.length))) {
                                var l = r.Dom.up(a, function(e) {
                                    return e && /^table$/i.test(e.nodeName);
                                }, e.editor), c = null;
                                switch(t.key){
                                    case n.KEY_TAB:
                                    case n.KEY_LEFT:
                                        var u = t.key === n.KEY_LEFT || t.shiftKey ? "prev" : "next";
                                        (c = r.Dom[u](a, function(e) {
                                            return e && /^td|th$/i.test(e.tagName);
                                        }, l)) || (i.Table.appendRow(l, "next" !== u && l.querySelector("tr"), "next" === u, e.createInside), c = r.Dom[u](a, r.Dom.isCell, l));
                                        break;
                                    case n.KEY_UP:
                                    case n.KEY_DOWN:
                                        var d = 0, p = 0, f = i.Table.formalMatrix(l, function(e, t, o) {
                                            e === a && (d = t, p = o);
                                        });
                                        t.key === n.KEY_UP ? void 0 !== f[d - 1] && (c = f[d - 1][p]) : void 0 !== f[d + 1] && (c = f[d + 1][p]);
                                }
                                if (c) {
                                    if (c.firstChild) t.key === n.KEY_TAB ? e.s.select(c, !0) : e.s.setCursorIn(c, t.key === n.KEY_RIGHT || t.key === n.KEY_DOWN);
                                    else {
                                        var h = e.createInside.element("br");
                                        c.appendChild(h), e.s.setCursorBefore(h);
                                    }
                                    return !1;
                                }
                            }
                        }
                    });
                }
                t.tableKeyboardNavigation = s, a.pluginSystem.add("tableKeyboardNavigation", s);
            },
            30739: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(64968), i = o(76502), a = o(40332), s = o(77904);
                n.Config.prototype.table = {
                    selectionCellStyle: "border: 1px double #1e88e5 !important;",
                    useExtraClassesOptions: !1
                }, s.Icon.set("table", o(51716)), n.Config.prototype.controls.table = {
                    data: {
                        cols: 10,
                        rows: 10,
                        classList: {
                            "table table-bordered": "Bootstrap Bordered",
                            "table table-striped": "Bootstrap Striped",
                            "table table-dark": "Bootstrap Dark"
                        }
                    },
                    popup: function(e, t, o, n, s) {
                        for(var l = o.data && o.data.rows ? o.data.rows : 10, c = o.data && o.data.cols ? o.data.cols : 10, u = e.c.fromHTML('<form class="jodit-form jodit-form__inserter"><div class="jodit-form__table-creator-box"><div class="jodit-form__container"></div><div class="jodit-form__options">' + function() {
                            if (!e.o.table.useExtraClassesOptions) return "";
                            var t = [];
                            if (o.data) {
                                var n = o.data.classList;
                                Object.keys(n).forEach(function(e) {
                                    t.push('<label class="jodit_vertical_middle"><input class="jodit-checkbox" value="'.concat(e, '" type="checkbox"/>').concat(n[e], "</label>"));
                                });
                            }
                            return t.join("");
                        }() + '</div></div><label class="jodit-form__center"><span>1</span> &times; <span>1</span></label></form>'), d = u.querySelectorAll("span")[0], p = u.querySelectorAll("span")[1], f = u.querySelector(".jodit-form__container"), h = u.querySelector(".jodit-form__options"), m = [], v = l * c, g = 0; v > g; g += 1)m[g] || m.push(e.c.element("span", {
                            dataIndex: g
                        }));
                        if (e.e.on(f, "mousemove", function(e, t) {
                            var o = e.target;
                            if (r.Dom.isTag(o, "span")) {
                                for(var n = void 0 === t || isNaN(t) ? parseInt((0, i.attr)(o, "-index") || "0", 10) : t || 0, a = Math.ceil((n + 1) / c), s = n % c + 1, l = 0; m.length > l; l += 1)m[l].className = l % c + 1 > s || a < Math.ceil((l + 1) / c) ? "" : "jodit_hovered";
                                p.textContent = s.toString(), d.textContent = a.toString();
                            }
                        }).on(f, "touchstart mousedown", function(t) {
                            var o = t.target;
                            if (t.preventDefault(), t.stopImmediatePropagation(), r.Dom.isTag(o, "span")) {
                                var s = parseInt((0, i.attr)(o, "-index") || "0", 10), l = Math.ceil((s + 1) / c), u = s % c + 1, d = e.createInside, p = d.element("tbody"), f = d.element("table");
                                f.appendChild(p);
                                for(var m, v, g = null, y = 1; l >= y; y += 1){
                                    m = d.element("tr");
                                    for(var _ = 1; u >= _; _ += 1)v = d.element("td"), g || (g = v), (0, a.css)(v, "width", (100 / u).toFixed(4) + "%"), v.appendChild(d.element("br")), m.appendChild(d.text("\n")), m.appendChild(d.text("\t")), m.appendChild(v);
                                    p.appendChild(d.text("\n")), p.appendChild(m);
                                }
                                (0, a.$$)("input[type=checkbox]:checked", h).forEach(function(e) {
                                    e.value.split(/[\s]+/).forEach(function(e) {
                                        f.classList.add(e);
                                    });
                                }), e.editor.firstChild && e.s.insertNode(d.text("\n"), !1, !1), e.s.insertNode(f, !1), g && (e.s.setCursorIn(g), (0, a.scrollIntoViewIfNeeded)(g, e.editor, e.ed)), n();
                            }
                        }), s && s.parentElement) {
                            for(g = 0; l > g; g += 1){
                                for(var y = e.c.div(), _ = 0; c > _; _ += 1)y.appendChild(m[g * c + _]);
                                f.appendChild(y);
                            }
                            m[0] && (m[0].className = "hovered");
                        }
                        return u;
                    },
                    tooltip: "Insert table"
                };
            },
            45842: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.table = void 0, o(51057);
                var n = o(17332);
                function r(e) {
                    e.registerButton({
                        name: "table",
                        group: "insert"
                    });
                }
                o(30739), t.table = r, n.pluginSystem.add("table", r);
            },
            79114: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(93166), r = o(718), i = o(40332), a = o(95963), s = o(96516);
                o(77904).Icon.set("video", o(49222)), n.Config.prototype.controls.video = {
                    popup: function(e, t, o, n) {
                        var l = new a.UIForm(e, [
                            new a.UIBlock(e, [
                                new a.UIInput(e, {
                                    name: "url",
                                    required: !0,
                                    label: "URL",
                                    placeholder: "https://",
                                    validators: [
                                        "url"
                                    ]
                                })
                            ]),
                            new a.UIBlock(e, [
                                (0, s.Button)(e, "", "Insert", "primary").onAction(function() {
                                    return l.submit();
                                })
                            ])
                        ]), c = new a.UIForm(e, [
                            new a.UIBlock(e, [
                                new a.UITextArea(e, {
                                    name: "code",
                                    required: !0,
                                    label: "Embed code"
                                })
                            ]),
                            new a.UIBlock(e, [
                                (0, s.Button)(e, "", "Insert", "primary").onAction(function() {
                                    return c.submit();
                                })
                            ])
                        ]), u = [], d = function(t) {
                            e.s.restore(), e.s.insertHTML(t), n();
                        };
                        return e.s.save(), u.push({
                            icon: "link",
                            name: "Link",
                            content: l.container
                        }, {
                            icon: "source",
                            name: "Code",
                            content: c.container
                        }), l.onSubmit(function(e) {
                            d((0, i.convertMediaUrlToVideoEmbed)(e.url));
                        }), c.onSubmit(function(e) {
                            d(e.code);
                        }), (0, r.TabsWidget)(e, u);
                    },
                    tags: [
                        "iframe"
                    ],
                    tooltip: "Insert youtube/vimeo video"
                };
            },
            19889: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(17332);
                o(79114), n.pluginSystem.add("video", function(e) {
                    e.registerButton({
                        name: "video",
                        group: "media"
                    });
                });
            },
            64401: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.wrapNodes = {
                    exclude: [
                        "hr",
                        "style",
                        "br"
                    ],
                    emptyBlockAfterInit: !0
                };
            },
            20728: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255), r = o(57549), i = o(64968), a = o(24421), s = o(43441), l = o(17332);
                o(64401);
                var c = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.isSuitableStart = function(e) {
                            return i.Dom.isText(e) && (0, a.isString)(e.nodeValue) && /[^\s]/.test(e.nodeValue) || t.isNotClosed(e) && !i.Dom.isTemporary(e);
                        }, t.isSuitable = function(e) {
                            return i.Dom.isText(e) || t.isNotClosed(e);
                        }, t.isNotClosed = function(e) {
                            return i.Dom.isElement(e) && !(i.Dom.isBlock(e) || i.Dom.isTag(e, t.j.o.wrapNodes.exclude));
                        }, t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function(e) {
                        "br" !== e.o.enter.toLowerCase() && e.e.on("drop.wtn focus.wtn keydown.wtn mousedown.wtn afterInit.wtn", this.preprocessInput, {
                            top: !0
                        }).on("afterInit.wtn postProcessSetEditorValue.wtn", this.postProcessSetEditorValue);
                    }, t.prototype.beforeDestruct = function(e) {
                        e.e.off(".wtn");
                    }, t.prototype.postProcessSetEditorValue = function() {
                        var e = this.jodit;
                        if (e.isEditorMode()) {
                            for(var t = e.editor.firstChild, o = !1; t;){
                                if (t = this.checkAloneListLeaf(t, e), this.isSuitableStart(t)) {
                                    o || e.s.save(), o = !0;
                                    var n = e.createInside.element(e.o.enter);
                                    for(i.Dom.before(t, n); t && this.isSuitable(t);){
                                        var r = t.nextSibling;
                                        n.appendChild(t), t = r;
                                    }
                                    n.normalize(), t = n;
                                }
                                t = t && t.nextSibling;
                            }
                            o && (e.s.restore(), "afterInit" === e.e.current && e.e.fire("internalChange"));
                        }
                    }, t.prototype.checkAloneListLeaf = function(e, t) {
                        var o = e, n = e;
                        do {
                            if (!i.Dom.isElement(n) || !i.Dom.isTag(n, "li") || i.Dom.isTag(n.parentElement, [
                                "ul",
                                "ol"
                            ])) break;
                            var r = i.Dom.findNotEmptySibling(n, !1);
                            i.Dom.isTag(o, "ul") ? o.appendChild(n) : o = i.Dom.wrap(n, "ul", t.createInside), n = r;
                        }while (n);
                        return o;
                    }, t.prototype.preprocessInput = function() {
                        var e = this.jodit, t = "afterInit" === e.e.current;
                        if (e.isEditorMode() && !e.editor.firstChild && (e.o.wrapNodes.emptyBlockAfterInit || !t)) {
                            var o = e.createInside.element(e.o.enter), n = e.createInside.element("br");
                            i.Dom.append(o, n), i.Dom.append(e.editor, o), e.s.isFocused() && e.s.setCursorBefore(n), e.e.fire("internalChange");
                        }
                    }, n.__decorate([
                        s.autobind
                    ], t.prototype, "postProcessSetEditorValue", null), n.__decorate([
                        s.autobind
                    ], t.prototype, "preprocessInput", null), t;
                }(r.Plugin);
                l.pluginSystem.add("wrapNodes", c);
            },
            71707: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(93166).Config.prototype.showXPathInStatusbar = !0;
            },
            18238: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = o(20255);
                o(64618);
                var r = o(86893), i = o(60403), a = o(64968), s = o(40332), l = o(57549), c = o(81438), u = o(17332);
                o(71707);
                var d = function(e) {
                    function t() {
                        var t = null !== e && e.apply(this, arguments) || this;
                        return t.onContext = function(e, o) {
                            return t.menu || (t.menu = new i.ContextMenu(t.j)), t.menu.show(o.clientX, o.clientY, [
                                {
                                    icon: "bin",
                                    title: e === t.j.editor ? "Clear" : "Remove",
                                    exec: function() {
                                        e !== t.j.editor ? a.Dom.safeRemove(e) : t.j.value = "", t.j.synchronizeValues();
                                    }
                                },
                                {
                                    icon: "select-all",
                                    title: "Select",
                                    exec: function() {
                                        t.j.s.select(e);
                                    }
                                }
                            ]), !1;
                        }, t.onSelectPath = function(e, o) {
                            t.j.s.focus();
                            var n = (0, s.attr)(o.target, "-path") || "/";
                            if ("/" === n) return t.j.execCommand("selectall"), !1;
                            try {
                                var r = t.j.ed.evaluate(n, t.j.editor, null, XPathResult.ANY_TYPE, null).iterateNext();
                                if (r) return t.j.s.select(r), !1;
                            } catch (e) {}
                            return t.j.s.select(e), !1;
                        }, t.tpl = function(e, o, n, r) {
                            var i = t.j.c.fromHTML('<span class="jodit-xpath__item"><a role="button" data-path="'.concat(o, '" title="').concat(r, '" tabindex="-1"\'>').concat((0, s.trim)(n), "</a></span>")), a = i.firstChild;
                            return t.j.e.on(a, "click", t.onSelectPath.bind(t, e)).on(a, "contextmenu", t.onContext.bind(t, e)), i;
                        }, t.removeSelectAll = function() {
                            t.selectAllButton && (t.selectAllButton.destruct(), delete t.selectAllButton);
                        }, t.appendSelectAll = function() {
                            t.removeSelectAll(), t.selectAllButton = (0, c.makeButton)(t.j, n.__assign({
                                name: "selectall"
                            }, t.j.o.controls.selectall)), t.selectAllButton.state.size = "tiny", t.container && t.container.insertBefore(t.selectAllButton.container, t.container.firstChild);
                        }, t.calcPathImd = function() {
                            if (!t.isDestructed) {
                                var e, o, n, i = t.j.s.current();
                                t.container && (t.container.innerHTML = r.INVISIBLE_SPACE), i && a.Dom.up(i, function(r) {
                                    r && t.j.editor !== r && !a.Dom.isText(r) && (e = r.nodeName.toLowerCase(), o = (0, s.getXPathByElement)(r, t.j.editor).replace(/^\//, ""), n = t.tpl(r, o, e, t.j.i18n("Select %s", e)), t.container && t.container.insertBefore(n, t.container.firstChild));
                                }, t.j.editor), t.appendSelectAll();
                            }
                        }, t.calcPath = t.j.async.debounce(t.calcPathImd, 2 * t.j.defaultTimeout), t;
                    }
                    return n.__extends(t, e), t.prototype.afterInit = function() {
                        var e = this;
                        this.j.o.showXPathInStatusbar && (this.container = this.j.c.div("jodit-xpath"), this.j.e.off(".xpath").on("mouseup.xpath change.xpath keydown.xpath changeSelection.xpath", this.calcPath).on("afterSetMode.xpath afterInit.xpath changePlace.xpath", function() {
                            e.j.o.showXPathInStatusbar && e.container && (e.j.statusbar.append(e.container), e.j.getRealMode() === r.MODE_WYSIWYG ? e.calcPath() : (e.container && (e.container.innerHTML = r.INVISIBLE_SPACE), e.appendSelectAll()));
                        }), this.calcPath());
                    }, t.prototype.beforeDestruct = function() {
                        this.j && this.j.events && this.j.e.off(".xpath"), this.removeSelectAll(), this.menu && this.menu.destruct(), a.Dom.safeRemove(this.container), delete this.menu, delete this.container;
                    }, t;
                }(l.Plugin);
                u.pluginSystem.add("xpath", d);
            },
            89019: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), o(61227), o(690), o(66622), o(69220), o(10444), Array.prototype.includes || (Array.prototype.includes = function(e) {
                    return this.indexOf(e) > -1;
                }), "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
                    value: function(e, t) {
                        if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                        for(var o = Object(e), n = 1; arguments.length > n; n++){
                            var r = arguments[n];
                            if (null != r) for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && (o[i] = r[i]);
                        }
                        return o;
                    },
                    writable: !0,
                    configurable: !0
                }), Array.prototype.find || (Array.prototype.find = function(e) {
                    return this.indexOf(e) > -1 ? e : void 0;
                }), String.prototype.endsWith || (String.prototype.endsWith = function(e) {
                    return this[this.length - 1] === e;
                });
            },
            15261: function(e, t, o) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.valign = t.upload = t.update = t.unlock = t.settings = t.save = t.right = t.resize_handler = t.plus = t.pencil = t.ok = t.lock = t.left = t.info_circle = t.folder = t.file = t.eye = t.dots = t.chevron = t.check = t.center = t.cancel = t.bin = t.angle_up = t.angle_right = t.angle_left = t.angle_down = void 0;
                var n = o(1755);
                t.angle_down = n;
                var r = o(74911);
                t.angle_left = r;
                var i = o(8805);
                t.angle_right = i;
                var a = o(16547);
                t.angle_up = a;
                var s = o(10856);
                t.bin = s;
                var l = o(98441);
                t.cancel = l;
                var c = o(52488);
                t.center = c;
                var u = o(9370);
                t.check = u;
                var d = o(66543);
                t.chevron = d;
                var p = o(608);
                t.dots = p;
                var f = o(42840);
                t.eye = f;
                var h = o(79096);
                t.file = h;
                var m = o(33014);
                t.folder = m;
                var v = o(91677);
                t.info_circle = v;
                var g = o(8259);
                t.left = g;
                var y = o(64467);
                t.lock = y;
                var _ = o(86934);
                t.ok = _;
                var b = o(76133);
                t.pencil = b;
                var w = o(45519);
                t.plus = w;
                var S = o(90265);
                t.resize_handler = S;
                var C = o(81279);
                t.right = C;
                var j = o(68899);
                t.save = j;
                var E = o(70744);
                t.settings = E;
                var x = o(19201);
                t.unlock = x;
                var k = o(84930);
                t.update = k;
                var T = o(99704);
                t.upload = T;
                var I = o(2304);
                t.valign = I;
            },
            80078: function(e) {
                e.exports = {
                    "copy-format": "\u0646\u0633\u062E \u0627\u0644\u062A\u0646\u0633\u064A\u0642"
                };
            },
            16986: function(e) {
                e.exports = {
                    "copy-format": "Kop\xedrovat form\xe1t"
                };
            },
            59347: function(e) {
                e.exports = {
                    "copy-format": "Format kopieren\u0442"
                };
            },
            63640: function(e) {
                e.exports = {
                    "copy-format": "Copiar formato"
                };
            },
            53434: function(e) {
                e.exports = {
                    "copy-format": "\u06A9\u067E\u06CC \u06A9\u0631\u062F\u0646 \u0642\u0627\u0644\u0628"
                };
            },
            85638: function(e) {
                e.exports = {
                    "copy-format": "Format de copie"
                };
            },
            31743: function(e) {
                e.exports = {
                    "copy-format": "\u05D4\u05E2\u05EA\u05E7 \u05E2\u05D9\u05E6\u05D5\u05D1"
                };
            },
            66219: function(e) {
                e.exports = {
                    "copy-format": "Form\xe1tum m\xe1sol\xe1s"
                };
            },
            50331: function(e) {
                e.exports = {
                    "copy-format": "salin format"
                };
            },
            25582: function(e) {
                e.exports = {
                    "copy-format": "Copia il formato"
                };
            },
            82066: function(e) {
                e.exports = {
                    "copy-format": "copyformat"
                };
            },
            71925: function(e) {
                e.exports = {
                    "copy-format": "\uBCF5\uC0AC \uD615\uC2DD"
                };
            },
            12689: function(e) {
                e.exports = {
                    "copy-format": "\u0424\u043E\u0440\u043C\u0430\u0442 \u0445\u0443\u0443\u043B\u0430\u0445"
                };
            },
            65274: function(e) {
                e.exports = {
                    "copy-format": "opmaak kopi\xebren"
                };
            },
            58548: function(e) {
                e.exports = {
                    "copy-format": "format kopii"
                };
            },
            82958: function(e) {
                e.exports = {
                    "copy-format": "Copiar formato"
                };
            },
            52315: function(e) {
                e.exports = {
                    "copy-format": "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0430\u0442"
                };
            },
            87727: function(e) {
                e.exports = {
                    "copy-format": "Kopyalama Bi\xe7imi"
                };
            },
            9396: function(e) {
                e.exports = {
                    "copy-format": "\u590D\u5236\u683C\u5F0F"
                };
            },
            28765: function(e) {
                e.exports = {
                    "copy-format": "\u8907\u88FD\u683C\u5F0F"
                };
            },
            47762: function(e) {
                e.exports = {
                    "Line height": "\u0627\u0631\u062A\u0641\u0627\u0639 \u0627\u0644\u062E\u0637"
                };
            },
            97495: function(e) {
                e.exports = {
                    "Line height": "V\xfd\u0161ka \u010D\xe1ry"
                };
            },
            80131: function(e) {
                e.exports = {
                    "Line height": "Zeilenh\xf6he"
                };
            },
            1201: function(e) {
                e.exports = {
                    "Line height": "Altura de la l\xednea"
                };
            },
            89912: function(e) {
                e.exports = {
                    "Line height": "\u0627\u0631\u062A\u0641\u0627\u0639 \u062E\u0637"
                };
            },
            3405: function(e) {
                e.exports = {
                    "Line height": "Hauteur de ligne"
                };
            },
            14129: function(e) {
                e.exports = {
                    "Line height": "\u05D2\u05D5\u05D1\u05D4 \u05E9\u05D5\u05E8\u05D4"
                };
            },
            93729: function(e) {
                e.exports = {
                    "Line height": "Vonal magass\xe1ga"
                };
            },
            16106: function(e) {
                e.exports = {
                    "Line height": "Tinggi baris"
                };
            },
            89690: function(e) {
                e.exports = {
                    "Line height": "Altezza linea"
                };
            },
            33216: function(e) {
                e.exports = {
                    "Line height": "\u30E9\u30A4\u30F3\u306E\u9AD8\u3055"
                };
            },
            17282: function(e) {
                e.exports = {
                    "Line height": "\uC120 \uB192\uC774"
                };
            },
            52841: function(e) {
                e.exports = {
                    "Line height": "\u0417\u0443\u0440\u0430\u0430\u0441\u043D\u044B \u04E9\u043D\u0434\u04E9\u0440"
                };
            },
            91761: function(e) {
                e.exports = {
                    "Line height": "Lijnhoogte"
                };
            },
            61675: function(e) {
                e.exports = {
                    "Line height": "Wysoko\u015B\u0107 linii"
                };
            },
            69709: function(e) {
                e.exports = {
                    "Line height": "Altura da linha"
                };
            },
            82591: function(e) {
                e.exports = {
                    "Line height": "\u0412\u044B\u0441\u043E\u0442\u0430 \u043B\u0438\u043D\u0438\u0438"
                };
            },
            87649: function(e) {
                e.exports = {
                    "Line height": "\xc7izgi y\xfcksekli\u011Fi"
                };
            },
            60268: function(e) {
                e.exports = {
                    "Line height": "\u7EBF\u9AD8"
                };
            },
            58214: function(e) {
                e.exports = {
                    "Line height": "\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E07\u0E40\u0E2A\u0E49\u0E19"
                };
            },
            5586: function(e) {
                e.exports = {
                    Spellcheck: "\u0627\u0644\u062A\u062F\u0642\u064A\u0642 \u0627\u0644\u0625\u0645\u0644\u0627\u0626\u064A"
                };
            },
            66023: function(e) {
                e.exports = {
                    Spellcheck: "Kontrola pravopisu"
                };
            },
            65860: function(e) {
                e.exports = {
                    Spellcheck: "Rechtschreibpr\xfcfung"
                };
            },
            86055: function(e) {
                e.exports = {
                    Spellcheck: "Correcci\xf3n ortogr\xe1fica"
                };
            },
            50037: function(e) {
                e.exports = {
                    Spellcheck: "\u063A\u0644\u0637\u06CC\u0627\u0628\u06CC \u0627\u0645\u0644\u0627\u06CC\u06CC"
                };
            },
            7118: function(e) {
                e.exports = {
                    Spellcheck: "V\xe9rification Orthographique"
                };
            },
            30298: function(e) {
                e.exports = {
                    Spellcheck: "\u05D1\u05D3\u05D9\u05E7\u05EA \u05D0\u05D9\u05D5\u05EA"
                };
            },
            52107: function(e) {
                e.exports = {
                    Spellcheck: "Helyes\xedr\xe1s-ellen\u0151rz\xe9s"
                };
            },
            31240: function(e) {
                e.exports = {
                    Spellcheck: "Spellchecking"
                };
            },
            4101: function(e) {
                e.exports = {
                    Spellcheck: "Controllo ortografico"
                };
            },
            69286: function(e) {
                e.exports = {
                    Spellcheck: "\u30B9\u30DA\u30EB\u30C1\u30A7\u30C3\u30AF"
                };
            },
            13402: function(e) {
                e.exports = {
                    Spellcheck: "\uB9DE\uCDA4\uBC95 \uAC80\uC0AC"
                };
            },
            1242: function(e) {
                e.exports = {
                    Spellcheck: "\u0414\u04AF\u0440\u043C\u0438\u0439\u043D \u0430\u043B\u0434\u0430\u0430 \u0448\u0430\u043B\u0433\u0430\u0445"
                };
            },
            89574: function(e) {
                e.exports = {
                    Spellcheck: "Spellingcontrole"
                };
            },
            63630: function(e) {
                e.exports = {
                    Spellcheck: "Sprawdzanie pisowni"
                };
            },
            72212: function(e) {
                e.exports = {
                    Spellcheck: "Verifica\xe7\xe3o ortogr\xe1fica"
                };
            },
            82570: function(e) {
                e.exports = {
                    Spellcheck: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043E\u0440\u0444\u043E\u0433\u0440\u0430\u0444\u0438\u0438"
                };
            },
            19323: function(e) {
                e.exports = {
                    Spellcheck: "Yaz\u0131m denetimi"
                };
            },
            50279: function(e) {
                e.exports = {
                    Spellcheck: "\u62FC\u5199\u68C0\u67E5"
                };
            },
            98364: function(e) {
                e.exports = {
                    Spellcheck: "\u0E2A\u0E30\u0E01\u0E14\u0E04\u0E33"
                };
            },
            54261: function(e) {
                e.exports = {
                    symbols: "\u0631\u0645\u0632"
                };
            },
            60425: function(e) {
                e.exports = {
                    symbols: "symbol"
                };
            },
            7057: function(e) {
                e.exports = {
                    symbols: "Symbol"
                };
            },
            48356: function(e) {
                e.exports = {
                    symbols: "S\xedmbolo"
                };
            },
            11428: function(e) {
                e.exports = {
                    symbols: "\u0633\u0645\u0628\u0644"
                };
            },
            29084: function(e) {
                e.exports = {
                    symbols: "caract\xe8re"
                };
            },
            22876: function(e) {
                e.exports = {
                    symbols: "\u05EA\u05D5 \u05DE\u05D9\u05D5\u05D7\u05D3"
                };
            },
            20890: function(e) {
                e.exports = {
                    symbols: "Szimb\xf3lum"
                };
            },
            75987: function(e) {
                e.exports = {
                    symbols: "simbol"
                };
            },
            60379: function(e) {
                e.exports = {
                    symbols: "Simbolo"
                };
            },
            99950: function(e) {
                e.exports = {
                    symbols: "symbol"
                };
            },
            60934: function(e) {
                e.exports = {
                    symbols: "\uAE30\uD638"
                };
            },
            45913: function(e) {
                e.exports = {
                    symbols: "\u0442\u044D\u043C\u0434\u044D\u0433\u0442"
                };
            },
            21994: function(e) {
                e.exports = {
                    symbols: "symbool"
                };
            },
            38128: function(e) {
                e.exports = {
                    symbols: "symbol"
                };
            },
            71515: function(e) {
                e.exports = {
                    symbols: "S\xedmbolo"
                };
            },
            58194: function(e) {
                e.exports = {
                    symbols: "\u0441\u0438\u043C\u0432\u043E\u043B"
                };
            },
            65802: function(e) {
                e.exports = {
                    symbols: "Sembol"
                };
            },
            86628: function(e) {
                e.exports = {
                    symbols: "\u7B26\u53F7"
                };
            },
            32210: function(e) {
                e.exports = {
                    symbols: "\u7B26\u865F"
                };
            },
            52378: function(e) {
                "use strict";
                e.exports = {
                    assert () {}
                };
            }
        }, o = {};
        function n(e) {
            var r = o[e];
            if (void 0 !== r) return r.exports;
            var i = o[e] = {
                exports: {}
            };
            return t[e].call(i.exports, i, i.exports, n), i.exports;
        }
        n.m = t, e = [], n.O = function(t, o, r, i) {
            if (!o) {
                var a = 1 / 0;
                for(u = 0; e.length > u; u++){
                    o = e[u][0], r = e[u][1], i = e[u][2];
                    for(var s = !0, l = 0; o.length > l; l++)(!1 & i || a >= i) && Object.keys(n.O).every(function(e) {
                        return n.O[e](o[l]);
                    }) ? o.splice(l--, 1) : (s = !1, a > i && (a = i));
                    if (s) {
                        e.splice(u--, 1);
                        var c = r();
                        void 0 !== c && (t = c);
                    }
                }
                return t;
            }
            i = i || 0;
            for(var u = e.length; u > 0 && e[u - 1][2] > i; u--)e[u] = e[u - 1];
            e[u] = [
                o,
                r,
                i
            ];
        }, n.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (e) {
                if ("object" == typeof window) return window;
            }
        }(), n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, function() {
            var e = {
                670: 0
            };
            n.O.j = function(t) {
                return 0 === e[t];
            };
            var t = function(t, o) {
                var r, i, a = o[0], s = o[1], l = o[2], c = 0;
                if (a.some(function(t) {
                    return 0 !== e[t];
                })) {
                    for(r in s)n.o(s, r) && (n.m[r] = s[r]);
                    if (l) var u = l(n);
                }
                for(t && t(o); a.length > c; c++)n.o(e, i = a[c]) && e[i] && e[i][0](), e[i] = 0;
                return n.O(u);
            }, o = self.webpackChunkjodit = self.webpackChunkjodit || [];
            o.forEach(t.bind(null, 0)), o.push = t.bind(null, o.push.bind(o));
        }();
        var r = {};
        return function() {
            "use strict";
            var e = r;
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.CommitMode = e.Jodit = void 0, n(90176), "undefined" != typeof window && n(89019);
            var t = n(37920);
            Object.defineProperty(e, "Jodit", {
                enumerable: !0,
                get: function() {
                    return t.Jodit;
                }
            });
            var o = n(26435), i = n(43441), a = n(86893), s = n(87837), l = n(15261);
            n(70022), n(91147), Object.keys(a).forEach(function(e) {
                t.Jodit[e] = a[e];
            });
            var c = function(e) {
                return "__esModule" !== e;
            };
            Object.keys(l).filter(c).forEach(function(e) {
                s.Icon.set(e.replace("_", "-"), l[e]);
            }), Object.keys(s).filter(c).forEach(function(e) {
                t.Jodit.modules[e] = s[e];
            }), Object.keys(i).filter(c).forEach(function(e) {
                t.Jodit.decorators[e] = i[e];
            }), [
                "Confirm",
                "Alert",
                "Prompt"
            ].forEach(function(e) {
                t.Jodit[e] = s[e];
            }), Object.keys(o.default).filter(c).forEach(function(e) {
                t.Jodit.lang[e] = o.default[e];
            }), e.CommitMode = function() {};
        }(), n.O(r);
    }();
});

},{"cd2d3d4629ff93e8":"5jT8D"}],"4LYin":[function() {},{}],"9AoSb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Button);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const Button = (0, _material.withStyles)({
    root: {
        boxShadow: 'none',
        border: 'solid 1px #d6dbdf',
        backgroundColor: '#fff',
        height: 25,
        "&.cancel": {
            border: 'solid 1px #1d9be5',
            backgroundColor: '#1d9be5',
            color: '#fff'
        },
        borderRadius: 2,
        color: '#68728b',
        '& svg': {
            marginTop: -3
        },
        '&:hover': {
            backgroundColor: '#c7dcef',
            boxShadow: 'none'
        }
    },
    label: {
        textTransform: 'none'
    }
})((0, _buttonDefault.default));

},{"react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4GsI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddAnswer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
const AddButton = (0, _material.withStyles)({
    root: {
        boxShadow: 'none',
        border: 'solid 1px #d6dbdf',
        backgroundColor: '#fff',
        borderRadius: 2,
        color: '#68728b',
        '& svg': {
            marginTop: -3
        },
        '&:hover': {
            backgroundColor: '#c7dcef',
            boxShadow: 'none'
        }
    },
    label: {
        textTransform: 'none'
    }
})((0, _buttonDefault.default));
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            marginTop: 20
        },
        button: {
            flexGrow: 1
        },
        addIcon: {
            fontSize: '14pt'
        }
    }));
function AddAnswer({ context, question, index, onAddChoice }) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AddButton, {
            variant: "contained",
            color: "primary",
            onClick: onAddChoice,
            className: classes.button,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {
                    className: classes.addIcon
                }),
                context.translate('add-pair')
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@mui/icons-material/Add":"jrNj7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUyAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanksQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _styles = require("./fill-in-the-blanks/styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _button = require("./fill-in-the-blanks/button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _premise = require("./fill-in-the-blanks/premise");
var _premiseDefault = parcelHelpers.interopDefault(_premise);
var _indexJsx = require("../preview-questions/fill-in-the-blanks/index.jsx");
var _indexJsxDefault = parcelHelpers.interopDefault(_indexJsx);
function FillInTheBlanksQuestion(props) {
    const { index, context, question, onPropertyChange } = props;
    const { translate, quizQuestions = {} } = context;
    const classes = (0, _stylesDefault.default)();
    const config = {
        readonly: false
    };
    const premiseText = question.premise.text || '';
    const phrases = question.answer.phrases || [];
    async function handlePremiseChanged(text) {
        const premise = {
            text
        };
        const answer = {
            phrases: text.split(' ').map((phrase)=>({
                    phrase,
                    blanked: false
                }))
        };
        props.updateProperties && props.updateProperties({
            id: question.id,
            premise,
            answer,
            textpremise: text
        }, {
            premise: {
                $set: premise
            },
            answer: {
                $set: answer
            },
            textpremise: {
                $set: text
            }
        });
    }
    async function handleJoinPhrases(id, tail) {
        const joinPhrases = {
            phrases: {
                $splice: [
                    [
                        id,
                        1
                    ]
                ],
                [id - 1]: {
                    $apply: ({ phrase, blanked })=>({
                            blanked,
                            phrase: `${phrase} ${tail}`
                        })
                }
            }
        };
        const answer = (0, _immutabilityHelperDefault.default)(question.answer, joinPhrases);
        props.updateProperties && props.updateProperties({
            id: question.id,
            answer
        }, {
            answer: joinPhrases
        });
    }
    async function handleBlankWord(id, blanked) {
        const blankPhrase = {
            phrases: {
                [id]: {
                    blanked: {
                        $set: blanked
                    }
                }
            }
        };
        const answer = (0, _immutabilityHelperDefault.default)(question.answer, blankPhrase);
        props.updateProperties && props.updateProperties({
            id: question.id,
            answer
        }, {
            answer: blankPhrase
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "true-or-false"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('premise'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "instructions",
                        children: translate('fill-in-the-blanks-premise-instructions')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _premiseDefault.default), {
                        context: context,
                        premise: premiseText,
                        onPremiseChange: handlePremiseChanged
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.answer, "answer"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('blanks'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "instructions",
                        children: translate('fill-in-the-blanks-instructions')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        className: "button",
                        onClick: ()=>handlePremiseChanged(premiseText),
                        children: translate('reset')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "phrases",
                        children: phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    index > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: "joiner",
                                        onClick: ()=>handleJoinPhrases(index, phrase),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faArrowsAltH)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: (0, _clsxDefault.default)("phrase", {
                                            blanked
                                        }),
                                        onClick: ()=>handleBlankWord(index, !blanked),
                                        children: phrase
                                    })
                                ]
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.preview, "preview"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _indexJsxDefault.default), {
                    context: context,
                    question: question
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./fill-in-the-blanks/styles":"eppS1","./fill-in-the-blanks/button":"ihdXI","./fill-in-the-blanks/premise":"9Yopq","../preview-questions/fill-in-the-blanks/index.jsx":"beBvQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eppS1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column',
            '& .label': {
                color: '#69738c',
                fontWeight: 'bold',
                marginBottom: 8
            },
            '& textarea': {
                resize: 'none',
                width: 'auto',
                padding: 8,
                flexGrow: 1,
                borderRadius: '4px',
                border: 'solid 1px #c2c7ca'
            },
            "& .instructions": {
                color: "#958e8e",
                fontSize: "11pt"
            }
        },
        premise: {
            marginTop: 35,
            "& .comments": {
                flexGrow: 1,
                display: 'flex'
            },
            "& .edit-premise.editing": {
                display: 'none',
                flexDirection: 'column',
                marginTop: 25,
                "&.editing": {
                    display: 'flex'
                },
                "& > .footer": {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    "& > .button": {
                        marginTop: 10
                    },
                    "& > .save": {
                        marginLeft: 15
                    }
                }
            },
            "& .view-premise": {
                display: 'flex',
                flexDirection: 'column',
                marginBottom: 25,
                "&.editing": {
                    display: 'none'
                },
                "& .header": {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    height: 25,
                    marginBottom: 10,
                    "& .edit-icon": {
                        color: '#2ca5ec',
                        fontSize: '14pt',
                        cursor: 'pointer',
                        "&:hover": {
                            transform: 'scale(1.1)'
                        }
                    }
                }
            }
        },
        answer: {
            marginTop: 35,
            "& .button": {
                marginTop: 20,
                height: 30
            },
            "& .phrases": {
                marginTop: 20,
                display: "flex",
                flexWrap: "wrap"
            },
            "& .phrase": {
                cursor: 'pointer',
                color: '#69738c',
                "&.blanked": {
                    fontWeight: "bold"
                },
                "&:hover": {
                    textDecoration: "underline"
                }
            },
            "& .joiner": {
                marginLeft: 7,
                marginRight: 7,
                cursor: 'pointer',
                "&:hover": {
                    transform: "scale(1.2)"
                }
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihdXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Button);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const Button = (0, _material.withStyles)({
    root: {
        boxShadow: 'none',
        border: 'solid 1px #d6dbdf',
        backgroundColor: '#fff',
        height: 25,
        "&.cancel": {
            border: 'solid 1px #1d9be5',
            backgroundColor: '#1d9be5',
            color: '#fff'
        },
        borderRadius: 2,
        color: '#68728b',
        '& svg': {
            marginTop: -3
        },
        '&:hover': {
            backgroundColor: '#c7dcef',
            boxShadow: 'none'
        }
    },
    label: {
        textTransform: 'none'
    }
})((0, _buttonDefault.default));

},{"react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Yopq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Premise);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _clickAwayListener = require("@mui/material/ClickAwayListener");
var _clickAwayListenerDefault = parcelHelpers.interopDefault(_clickAwayListener);
var _button = require("./button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
function Premise(props) {
    const { context, onPremiseChange } = props;
    const { translate } = context;
    const [editing, setEditing] = (0, _reactDefault.default).useState(true);
    const [premise, setPremise] = (0, _reactDefault.default).useState(props.premise);
    const editPremise = (0, _reactDefault.default).useRef();
    function handleChange(e) {
        setPremise(e.target.value);
    }
    function handleSave() {
        if (props.premise != premise) onPremiseChange && onPremiseChange(premise);
    }
    function handleCancel() {
        setPremise(props.premise);
    }
    (0, _reactDefault.default).useEffect(()=>{
        if (premise != props.premise) setPremise(props.premise || '');
    }, [
        props.premise
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            editing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)('edit-premise', {
                    editing
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: "comments",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                        ref: editPremise,
                        maxRows: 5,
                        minRows: 5,
                        value: premise,
                        onKeyPress: ({ key })=>{
                            key == 'Enter' && handleSave();
                        },
                        onChange: handleChange,
                        onBlur: handleSave
                    })
                })
            }),
            !editing && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)('view-premise', {
                    editing
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "header",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "edit-icon",
                            onClick: ()=>{
                                setEditing(true);
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faEdit)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "comments",
                        onClick: ()=>{
                            setEditing(true);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                            maxRows: 5,
                            minRows: 5,
                            value: premise,
                            readOnly: true
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","@mui/material/Fade":"8DwqP","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/ClickAwayListener":"g3Gd7","./button":"ihdXI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2bsCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoiceQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _styles = require("./multiple-choice/styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _choice = require("./multiple-choice/choice");
var _choiceDefault = parcelHelpers.interopDefault(_choice);
var _addAnswer = require("./multiple-choice/add-answer");
var _addAnswerDefault = parcelHelpers.interopDefault(_addAnswer);
var _editableHtml = require("components/quiz/components/editable-html");
var _editableHtmlDefault = parcelHelpers.interopDefault(_editableHtml);
var _utils = require("helpers/utils");
function MultipleChoiceQuestion(props) {
    const { index, questionPath, onPropertyChange, updateProperties } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, at } = context;
    const [question] = at(questionPath);
    const classes = (0, _stylesDefault.default)();
    const config = {
        readonly: false
    };
    const premiseText = question.premise.html || '';
    function handlePremiseChanged(html, textpremise) {
        const premise = {
            html
        };
        updateProperties({
            id: question.id,
            premise,
            textpremise
        }, {
            premise: {
                $set: premise
            },
            textpremise: {
                $set: textpremise
            }
        });
    }
    function handleChoiceMove(drag, hover) {
        const [question] = at(questionPath);
        const choice = question.answer.choices[drag];
        updateProperties(false, {
            answer: {
                choices: {
                    $splice: [
                        [
                            drag,
                            1
                        ],
                        [
                            hover,
                            0,
                            choice
                        ]
                    ]
                }
            }
        });
    }
    function handleChoiceDrop() {
        const [question] = at(questionPath);
        const answer = question.answer;
        updateProperties({
            id: question.id,
            answer
        });
    }
    function handleAddAnswer() {
        const [question] = at(questionPath);
        const newChoice = {
            html: '',
            correct: false,
            id: (0, _utils.uuid)()
        };
        const command = question.answer.choices ? '$push' : '$set';
        const updateCommand = {
            answer: {
                choices: {
                    [command]: [
                        newChoice
                    ]
                }
            }
        };
        const { answer } = (0, _immutabilityHelperDefault.default)(question, updateCommand);
        updateProperties({
            id: question.id,
            answer
        }, updateCommand);
    }
    function handleDeleteChoice(id) {
        const [question] = at(questionPath);
        const index = question.answer.choices.findIndex((c)=>c.id == id);
        const updateCommand = {
            answer: {
                choices: {
                    $splice: [
                        [
                            index,
                            1
                        ]
                    ]
                }
            }
        };
        const { answer } = (0, _immutabilityHelperDefault.default)(question, updateCommand);
        updateProperties({
            id: question.id,
            answer
        }, updateCommand);
    }
    function handleChoiceTextChange(id, html) {
        const [question] = at(questionPath);
        const index = question.answer.choices.findIndex((c)=>c.id == id);
        const updateCommand = {
            answer: {
                choices: {
                    [index]: {
                        html: {
                            $set: html
                        }
                    }
                }
            }
        };
        const { answer } = (0, _immutabilityHelperDefault.default)(question, updateCommand);
        updateProperties({
            id: question.id,
            answer
        }, updateCommand);
    }
    function handleChoiceCorrectChange(id, correct) {
        const [question] = at(questionPath);
        const index = question.answer.choices.findIndex((c)=>c.id == id);
        const updateCorrect = {
            answer: {
                choices: {
                    [index]: {
                        correct: {
                            $set: correct
                        }
                    }
                }
            }
        };
        const { answer } = (0, _immutabilityHelperDefault.default)(question, updateCorrect);
        updateProperties({
            id: question.id,
            answer
        }, updateCorrect);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "multiple-choice"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('premise'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                        context: context,
                        html: premiseText,
                        onChange: handlePremiseChanged
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.answer, "answer"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('quiz-options'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "choices",
                        children: question.answer.choices && question.answer.choices.map((choice, index, { length })=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choiceDefault.default), {
                                onChoiceMove: handleChoiceMove,
                                onChoiceDropped: handleChoiceDrop,
                                onChoiceTextChange: handleChoiceTextChange,
                                onChoiceCorrectChange: handleChoiceCorrectChange,
                                onDeleteChoice: handleDeleteChoice,
                                questionCount: length,
                                index,
                                choice,
                                context,
                                question
                            }, choice.id);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addAnswerDefault.default), {
                        context: context,
                        question: question,
                        index: index,
                        onAddAnswer: handleAddAnswer
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","teacher/context":"5LKDx","./multiple-choice/styles":"jGu1a","./multiple-choice/choice":"hbUqC","./multiple-choice/add-answer":"iuqqo","components/quiz/components/editable-html":"6jWHH","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGu1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            '& .label': {
                color: '#69738c',
                fontWeight: 'bold'
            }
        },
        premise: {
            "& > .label": {
                marginBottom: 20
            }
        },
        answer: {
            marginTop: 25,
            flexGrow: 1,
            color: '#828dab',
            "& .choice": {
                display: 'flex',
                marginTop: 20,
                padding: '10px 15px',
                flexGrow: 1,
                borderRadius: 4,
                background: '#edf6fd',
                flexDirection: 'column',
                "& .header": {
                    display: 'flex',
                    "& .sorter": {
                        fontSize: '14pt',
                        cursor: 'pointer'
                    },
                    "& .filler": {
                        flexGrow: 1
                    },
                    "& .delete": {
                        fontSize: '14pt',
                        cursor: 'pointer',
                        color: '#ff3a3a',
                        '&:hover': {
                            transform: 'scale(1.1)'
                        }
                    }
                },
                "& .index": {
                    color: '#6a748d',
                    margin: '15px 5px 8px 0',
                    fontWeight: 'bold'
                },
                "& .correct": {
                    marginTop: 9
                }
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hbUqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Choice);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDnd = require("react-dnd");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _editableHtml = require("../../components/editable-html");
var _editableHtmlDefault = parcelHelpers.interopDefault(_editableHtml);
function Choice(props) {
    const { index, questionCount, context, question, choice, onChoiceMove, onChoiceTextChange, onChoiceCorrectChange, onChoiceDropped, onDeleteChoice } = props;
    const { id } = question;
    const { translate } = context;
    const type = context.quizQuestionTypes.find((t)=>t.id == question.type);
    const canDelete = questionCount > type.properties.minChoices;
    const ref = (0, _react.useRef)(null);
    const config = {
        readonly: false
    };
    const [{ isDragging, dragIndex }, drag, preview] = (0, _reactDnd.useDrag)({
        item: {
            type: 'CHOICE',
            index
        },
        collect: (monitor, item)=>{
            const { index } = monitor.getItem() || {};
            return {
                isDragging: monitor.isDragging(),
                dragIndex: index
            };
        }
    });
    const [, drop] = (0, _reactDnd.useDrop)({
        accept: 'CHOICE',
        hover (item, monitor) {
            if (item.index == index) return;
            const { current } = ref;
            if (!current) return;
            const { top, bottom } = current.getBoundingClientRect();
            const middle = (bottom - top) / 2;
            const { y } = monitor.getClientOffset();
            const dY = y - top;
            const goingUp = item.index > index;
            if (goingUp && dY < middle) return;
            if (!goingUp && dY > middle) return;
            onChoiceMove && onChoiceMove(item.index, index);
            item.index = index;
        },
        drop (item, monitor) {
            !monitor.didDrop() && onChoiceDropped && onChoiceDropped();
        }
    });
    const opacity = isDragging ? 0 : 1;
    preview(drop(ref));
    const answerIndex = String.fromCharCode(Math.min(isDragging ? dragIndex : index, 20) + 97);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        id: choice.id,
        ref: ref,
        style: {
            opacity
        },
        className: "choice",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "sorter",
                        ref: drag,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faSort)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "filler"
                    }),
                    canDelete && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "delete",
                        onClick: (e)=>{
                            e.stopPropagation();
                            onDeleteChoice && onDeleteChoice(choice.id);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTrashAlt)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "index",
                children: [
                    answerIndex,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "editor",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                    context: context,
                    html: choice.html || '',
                    onChange: (text)=>onChoiceTextChange && onChoiceTextChange(choice.id, text)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "correct",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                    control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                        checked: choice.correct,
                        onChange: (e)=>onChoiceCorrectChange && onChoiceCorrectChange(choice.id, e.target.checked)
                    }),
                    label: translate('correct-answer')
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-dnd":"9NZ1L","external/material":"6yEDE","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/FormControlLabel":"kemIW","@mui/material/Checkbox":"4sdMA","../../components/editable-html":"6jWHH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iuqqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddAnswer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
const AddButton = (0, _material.withStyles)({
    root: {
        boxShadow: 'none',
        border: 'solid 1px #d6dbdf',
        backgroundColor: '#fff',
        borderRadius: 2,
        color: '#68728b',
        '& svg': {
            marginTop: -3
        },
        '&:hover': {
            backgroundColor: '#c7dcef',
            boxShadow: 'none'
        }
    },
    label: {
        textTransform: 'none'
    }
})((0, _buttonDefault.default));
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            marginTop: 20
        },
        button: {
            flexGrow: 1
        },
        addIcon: {
            fontSize: '14pt'
        }
    }));
function AddAnswer({ context, question, index, onAddAnswer }) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AddButton, {
            variant: "contained",
            color: "primary",
            onClick: onAddAnswer,
            className: classes.button,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {
                    className: classes.addIcon
                }),
                context.translate('add-answer')
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@mui/icons-material/Add":"jrNj7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Ovx6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _editableHtml = require("../components/editable-html");
var _editableHtmlDefault = parcelHelpers.interopDefault(_editableHtml);
var _styles = require("./open-question/styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function OpenQuestion({ context, question, onPropertyChange, updateProperties }) {
    const { translate, quizQuestions = {} } = context;
    const classes = (0, _stylesDefault.default)();
    const answerEditor = (0, _react.useRef)(null);
    const config = {
        readonly: false
    };
    const premiseText = question.premise.html || '';
    const answerText = question.answer.html || '';
    function handlePremiseChanged(html, textpremise) {
        const premise = {
            html
        };
        updateProperties && updateProperties({
            id: question.id,
            premise,
            textpremise
        }, {
            premise: {
                $set: premise
            },
            textpremise: {
                $set: textpremise
            }
        });
    }
    function handleAnswerChanged(html) {
        onPropertyChange('answer', {
            html
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "true-or-false"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('question'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                        context: context,
                        html: premiseText,
                        onChange: handlePremiseChanged
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.answer, "answer"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('suggested-answer'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                        context: context,
                        html: answerText,
                        onChange: handleAnswerChanged
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","../components/editable-html":"6jWHH","./open-question/styles":"7km1c","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7km1c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column',
            '& .label': {
                color: '#69738c',
                fontWeight: 'bold',
                marginBottom: 8
            }
        },
        premise: {
            marginTop: 25
        },
        answer: {
            marginTop: 35
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kyWOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalseQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _editableHtml = require("../components/editable-html");
var _editableHtmlDefault = parcelHelpers.interopDefault(_editableHtml);
var _styles = require("./true-or-false/styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function TrueOrFalseQuestion({ context, question, onPropertyChange, updateProperties }) {
    const { translate, quizQuestions = {} } = context;
    const classes = (0, _stylesDefault.default)();
    const answerValue = question.answer.value == undefined ? '' : question.answer.value;
    function handlePremiseChanged(html, textpremise) {
        const premise = {
            html
        };
        updateProperties && updateProperties({
            id: question.id,
            premise,
            textpremise
        }, {
            premise: {
                $set: premise
            },
            textpremise: {
                $set: textpremise
            }
        });
    }
    function handleAnswerChanged(e) {
        onPropertyChange('answer', {
            value: e.target.value == "true"
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, "question", "true-or-false"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.premise, "premise"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('premise'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                        context: context,
                        html: question.premise.html || '',
                        onChange: handlePremiseChanged
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.answer, "answer"),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            translate('answer'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
                        className: "content",
                        value: answerValue,
                        onChange: handleAnswerChanged,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: true,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('true')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: false,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('false')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","../components/editable-html":"6jWHH","./true-or-false/styles":"g0X2J","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0X2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            '& .label': {
                color: '#69738c',
                fontWeight: 'bold'
            }
        },
        premise: {
            '& > .label': {
                marginBottom: 20
            }
        },
        answer: {
            marginTop: 25,
            '& .content': {
                paddingLeft: 10
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iTKh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddStandard);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _accordion = require("@mui/material/Accordion");
var _accordionDefault = parcelHelpers.interopDefault(_accordion);
var _accordionSummary = require("@mui/material/AccordionSummary");
var _accordionSummaryDefault = parcelHelpers.interopDefault(_accordionSummary);
var _accordionDetails = require("@mui/material/AccordionDetails");
var _accordionDetailsDefault = parcelHelpers.interopDefault(_accordionDetails);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _context = require("teacher/context");
var _utils = require("helpers/utils");
var _addStandards = require("teacher/components/add-standards");
var _addStandardsDefault = parcelHelpers.interopDefault(_addStandards);
var _standard = require("./standard");
var _standardDefault = parcelHelpers.interopDefault(_standard);
const useStyles = (0, _material.makeStyles)(standardStyles);
const useAccordionStyles = (0, _material.makeStyles)(accordionStyles);
const useAccordionDetailsStyles = (0, _material.makeStyles)(accordionDetailsStyles);
const useAccordionSummaryStyles = (0, _material.makeStyles)(accordionSummaryStyles);
function AddStandard({ onStandardsChange, question }) {
    const classes = useStyles();
    const accordionClasses = useAccordionStyles();
    const accordionDetailsClasses = useAccordionDetailsStyles();
    const accordionSummaryClasses = useAccordionSummaryStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, link, linkQuery, updateState, sectionName, operation } = context;
    const { standards = [] } = question.properties || {};
    const [firstStandard = {}] = standards;
    const deleteStandard = (id)=>{
        onStandardsChange(standards.filter((s)=>s.id != id));
    };
    const backPath = link({}, '/:languageId/:role/:page/:tab/:sectionName?/:questionId?');
    const standardsQuery = firstStandard.id ? {
        subject: firstStandard.subject,
        grade: firstStandard.grade,
        standard: firstStandard.standard
    } : {
        subject: question.subject,
        grade: question.course ? question.course.substr(-3) : undefined
    };
    const standardLink = linkQuery(`${backPath}/add-standards`, standardsQuery);
    function handleOpenStandardsClick(e) {
        e.stopPropagation();
        const selected = standards.reduce((acc, standard)=>({
                ...acc,
                [standard.id]: standard
            }), {});
        updateState({
            standardsContext: {
                selectStandards: {
                    selected: {
                        $set: selected
                    }
                }
            }
        });
    }
    const sortedStandards = (0, _lodash.sortBy)(standards, (s)=>{
        const iteratee = `${s.expectation || s.id}-${s.code || '00'}`;
        return iteratee;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStandardsDefault.default), {
                backPath: backPath,
                onSaveStandards: onStandardsChange,
                open: operation == 'add-standards'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionDefault.default), {
                defaultExpanded: true,
                square: true,
                classes: accordionClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _accordionSummaryDefault.default), {
                        expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {}),
                        "aria-label": "Expand",
                        "aria-controls": "expand-standards",
                        id: "expand-standards",
                        classes: accordionSummaryClasses,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: classes.addStandardLabel,
                                children: [
                                    translate("standards"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: classes.addStandard,
                                to: standardLink,
                                onFocus: (e)=>e.stopPropagation(),
                                onClick: handleOpenStandardsClick,
                                children: "+"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accordionDetailsDefault.default), {
                        classes: accordionDetailsClasses,
                        children: sortedStandards.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _clsxDefault.default)(classes.wrapper, classes.content),
                            children: sortedStandards.map((standard, index)=>{
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardDefault.default), {
                                    index: index,
                                    deleteStandard: deleteStandard,
                                    ...standard
                                }, index);
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function accordionStyles() {
    return {
        root: {
            border: 'none',
            boxShadow: 'none',
            borderBottom: 'solid 1px #e2ecf2'
        }
    };
}
function accordionSummaryStyles() {
    return {
        root: {
            padding: 0
        }
    };
}
function accordionDetailsStyles() {
    return {
        root: {
            padding: '8px 0'
        }
    };
}
function standardStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            padding: 0
        },
        item: {
            display: 'flex',
            flexDirection: 'column'
        },
        head: {
            color: '#868c9c',
            padding: '8px 20px 15px 20px',
            borderBottom: 'solid 1px #e2ecf2'
        },
        addStandardLabel: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: '#69738c',
            fontWeight: 'bold',
            flexGrow: 1
        },
        addStandard: {
            borderRadius: 4,
            textDecoration: 'none',
            color: '#a5b9de',
            textAlign: 'center',
            fontSize: '15pt',
            backgroundColor: '#f0f7ff',
            border: 'solid 1px #a5b9de',
            padding: '4px 8px',
            "&:hover": {
                transform: 'scale(1.01)',
                fontWeight: 'bold'
            }
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            padding: '0 0 0 0'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Accordion":"lkcQj","@mui/material/AccordionSummary":"ggBKJ","@mui/material/AccordionDetails":"96rKf","@mui/material/FormControlLabel":"kemIW","@mui/material/Typography":"2wCD5","@mui/icons-material/ExpandMore":"gUaK6","teacher/context":"5LKDx","helpers/utils":"gGc98","teacher/components/add-standards":"3JEDu","./standard":"kRCrj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3JEDu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddStandards);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("external/react");
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _context = require("teacher/context");
var _standardsSelector = require("components/standards-selector/components/StandardsSelector");
var _standardsSelectorDefault = parcelHelpers.interopDefault(_standardsSelector);
var _selectionCjs = require("components/standards-selector/domain/selection.cjs");
const useStyles = (0, _material.makeStyles)(createStyles);
const useDialogStyles = (0, _material.makeStyles)(createDialogStyles);
function AddStandards({ open, backPath, onSaveStandards }) {
    const classes = useStyles();
    const dialogClasses = useDialogStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, standardsContext, updateState, query, languageId } = (0, _react.useContext)((0, _context.TeacherContext));
    const [filters, setFilters] = (0, _react.useState)(query);
    const [selected, setSelected] = (0, _react.useState)(standardsContext.selectStandards.selected || {});
    (0, _react.useEffect)(()=>{
        if (open) {
            setFilters(query);
            setSelected(standardsContext.selectStandards.selected || {});
        }
    }, [
        open
    ]);
    const load = (0, _react.useCallback)((entity, parameters)=>(0, _commandDefault.default)('de', entity)({
            language: languageId,
            ...parameters
        }), [
        languageId
    ]);
    async function closeDialog() {
        await updateState({
            standardsContext: {
                selectStandards: {
                    selected: {
                        $set: {}
                    },
                    questionStandards: {
                        $set: {}
                    }
                }
            }
        });
        history.push(backPath);
    }
    async function save() {
        const result = (0, _selectionCjs.selectedItems)(selected);
        await closeDialog();
        if (onSaveStandards) await onSaveStandards(result);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        classes: dialogClasses,
        maxWidth: "md",
        open: open,
        onClose: closeDialog,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                className: classes.title,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                    className: classes.titleActions,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            className: (0, _clsxDefault.default)(classes.button, 'cancel'),
                            onClick: closeDialog,
                            children: translate('cancel')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            className: (0, _clsxDefault.default)(classes.button, 'create'),
                            onClick: save,
                            children: translate('save')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                className: classes.root,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsSelectorDefault.default), {
                    language: languageId,
                    load: load,
                    mode: "quiz",
                    filters: filters,
                    onFiltersChange: setFilters,
                    selected: selected,
                    onSelectionChange: setSelected
                })
            })
        ]
    });
}
function createStyles() {
    return {
        root: {
            overflowY: 'auto',
            flexGrow: 1,
            minHeight: 0
        },
        title: {
            borderBottom: '1px solid #ccc',
            marginBottom: 10
        },
        titleActions: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        button: {
            width: 120,
            fontSize: '13pt',
            textTransform: 'none',
            boxShadow: 'none',
            borderRadius: 4,
            '&:first-child': {
                marginRight: 10
            },
            '&.cancel': {
                border: 'solid 1px #3d4556',
                backgroundColor: '#fff',
                color: '#3d4556',
                '&:hover': {
                    color: '#000',
                    border: 'solid 1px #000',
                    backgroundColor: '#eaf5ff'
                }
            },
            '&.create': {
                color: '#fff',
                border: 'solid 1px #2c75bd',
                backgroundColor: '#2c75bd',
                '&:hover': {
                    backgroundColor: '#71a7c7',
                    borderColor: '#71a7c7',
                    boxShadow: 'none'
                }
            }
        }
    };
}
function createDialogStyles() {
    return {
        container: {
            display: 'flex',
            color: '#626d88',
            width: '100%',
            height: '100%',
            justifyContent: 'center'
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            border: 'solid 1px #dce1ec',
            height: 'calc(100% - 120px)',
            minWidth: 600,
            maxWidth: 1600,
            borderRadius: 2,
            width: '80%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","external/react":"k16GP","react-router-dom":"3uzXR","external/material":"6yEDE","helpers/command":"f3cbG","teacher/context":"5LKDx","components/standards-selector/components/StandardsSelector":"c5fch","components/standards-selector/domain/selection.cjs":"bqeL1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kRCrj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Standard);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _makeStyles = require("@mui/styles/makeStyles");
var _makeStylesDefault = parcelHelpers.interopDefault(_makeStyles);
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("teacher/context");
const useStyles = (0, _makeStylesDefault.default)(standardStyles);
function Standard(props) {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    const { id, code, description, deleteStandard } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _clsxDefault.default)(classes.item, classes.content),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.code,
                        children: code == undefined ? translate("expectation") : code
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.description,
                        title: description,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                            text: description,
                            maxLine: 3,
                            ellipsis: "...",
                            trimRight: true,
                            basedOn: "letters"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)(classes.item, classes.actions),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: classes.delete,
                    onClick: ()=>deleteStandard && deleteStandard(id),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTrashAlt)
                    })
                })
            })
        ]
    });
}
function standardStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            borderBottom: 'solid 1px #e2ecf2',
            "&:last-child": {
                borderBottom: 'none'
            }
        },
        item: {
            display: 'flex',
            flexDirection: 'column'
        },
        content: {
            cursor: 'default',
            flexGrow: 1,
            color: '#4e576e',
            overflowX: 'hidden',
            padding: '12px 10px 12px 20px'
        },
        code: {
            textTransform: 'uppercase',
            fontWeight: 'bold'
        },
        description: {
            color: '#838999',
            fontSize: '10.5pt',
            wordWrap: 'break-word'
        },
        actions: {
            justifyContent: 'center',
            paddingRight: 10
        },
        delete: {
            cursor: 'pointer',
            color: '#dd3636',
            padding: '8px 9px',
            "&:hover": {
                transform: 'scale(1.10)'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/styles/makeStyles":"hRYSM","react-lines-ellipsis":"ikp0X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lcA89":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NewBankQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _questionProperties = require("./question-properties");
var _questionPropertiesDefault = parcelHelpers.interopDefault(_questionProperties);
var _questionTitle = require("components/quiz/components/question-title");
var _questionTitleDefault = parcelHelpers.interopDefault(_questionTitle);
var _questionValue = require("components/quiz/components/question-value");
var _questionValueDefault = parcelHelpers.interopDefault(_questionValue);
var _responsiveFullscreenDialog = require("components/quiz/components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _command = require("helpers/command");
var _matching = require("components/quiz/edit-questions/matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
var _fillInTheBlanks = require("components/quiz/edit-questions/fill-in-the-blanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _multipleChoice = require("components/quiz/edit-questions/multiple-choice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _openQuestion = require("components/quiz/edit-questions/open-question");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _trueOrFalse = require("components/quiz/edit-questions/true-or-false");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _buttons = require("./buttons");
var _buttonsDefault = parcelHelpers.interopDefault(_buttons);
var _context = require("teacher/context");
var _addStandard = require("../add-standard");
var _addStandardDefault = parcelHelpers.interopDefault(_addStandard);
const questionHandlers = {
    'matching': (0, _matchingDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'true-or-false': (0, _trueOrFalseDefault.default)
};
const useStyles = (0, _material.makeStyles)(newQuestionStyles);
function NewBankQuestion(props) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState, quizQuestionTypes, at, questionId, link, linkQuery, query } = context;
    const questionPath = 'quizNewBankQuestion';
    const [question] = at(questionPath);
    const questionType = quizQuestionTypes.find((type)=>type.id == question.type) || {};
    const Handler = questionHandlers[questionType.name];
    function closeDialog(saved) {
        updateState({
            quizSearchQuestionBankCalls: {
                $apply: (a)=>a + 1
            }
        });
        history.push(link({}, '/:languageId/:role/:page/:tab', {
            query: {
                id: saved ? question.id : undefined
            },
            preserveQuery: !saved
        }));
    }
    async function handleCancel() {
        await (0, _command.createPost)('quiz', 'deleteBankQuestion')({
            id: question.id
        });
        closeDialog();
    }
    async function updateProperties(request, updateCommand) {
        const [updatedId] = request ? await (0, _command.createPost)('quiz', 'updateQuestionProperties')(request) : [
            question.id
        ];
        if (updateCommand && updatedId == question.id) updateState({
            quizNewBankQuestion: updateCommand
        });
    }
    const handlePropertyChange = (name, value)=>updateProperties({
            id: question.id,
            [name]: value
        }, {
            [name]: {
                $set: value
            }
        });
    const onStandardsChange = (standards)=>updateProperties({
            id: question.id,
            properties: {
                ...question.properties,
                standards
            }
        }, {
            properties: {
                standards: {
                    $set: standards
                }
            }
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: props.open,
        close: closeDialog,
        dialogClasses: classes,
        dialogMaxWidth: "lg",
        TitleComponent: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "caption",
                        children: translate('bank-question-title')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonsDefault.default), {
                        onCreate: closeDialog,
                        onCancel: handleCancel
                    })
                ]
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: "content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: "properties-container",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionPropertiesDefault.default), {
                            question: question,
                            context: context
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: "value-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionValueDefault.default), {
                                context: context,
                                className: "value",
                                question: question,
                                updateProperties: updateProperties
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: "standards",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStandardDefault.default), {
                        question: question,
                        onStandardsChange: onStandardsChange
                    })
                }),
                Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                    context: context,
                    onPropertyChange: handlePropertyChange,
                    updateProperties: updateProperties,
                    question: question,
                    questionPath: questionPath
                })
            ]
        })
    });
}
function newQuestionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            "& .header": {
                display: "flex",
                color: '#69738c',
                "& .close-icon": {
                    padding: '0 6px',
                    "& svg": {
                        fontSize: '13pt'
                    }
                },
                "& .caption": {
                    flexGrow: 1,
                    ...verticalCentering
                }
            },
            "& .standards": {
                marginBottom: 10
            },
            '& .properties-container': {
                display: 'flex',
                marginTop: 20,
                marginBottom: 30
            },
            '& .value-wrapper': {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 10,
                '& > .value': {
                    width: 75,
                    '& > .valueLabel': {
                        color: '#4e566b'
                    },
                    '& > .valueInput': {
                        display: 'flex',
                        // border: 'solid 1px black',
                        marginTop: 10,
                        borderRadius: 4,
                        cursor: 'text',
                        padding: 4,
                        '& .control': {
                            display: 'flex'
                        },
                        '& .input-wrapper': {
                            flexGrow: 1,
                            ...verticalCentering
                        },
                        '& .input': {
                            border: 'none',
                            width: '100%',
                            flexGrow: 1,
                            '&:focus': {
                                outline: 'none'
                            }
                        },
                        '& .addornment': {
                            cursor: 'pointer',
                            marginTop: -3,
                            ...verticalCentering
                        }
                    }
                }
            }
        },
        paper: {
            width: 'calc(100% - 64px)'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","external/material":"6yEDE","@mui/icons-material/Close":"acjz6","@mui/material/IconButton":"bXjnZ","./question-properties":"dUIpN","components/quiz/components/question-title":"2JUeL","components/quiz/components/question-value":"7x3pd","components/quiz/components/responsive-fullscreen-dialog":"5zam1","helpers/command":"f3cbG","components/quiz/edit-questions/matching":"GKV70","components/quiz/edit-questions/fill-in-the-blanks":"gUyAx","components/quiz/edit-questions/multiple-choice":"2bsCX","components/quiz/edit-questions/open-question":"6Ovx6","components/quiz/edit-questions/true-or-false":"kyWOK","./buttons":"8l0XN","teacher/context":"5LKDx","../add-standard":"iTKh1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dUIpN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionProperties);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _command = require("helpers/command");
var _utils = require("helpers/utils");
const useStyles = (0, _material.makeStyles)(questionStyles);
function QuestionProperties(props) {
    const { question, context } = props;
    const { translate, subjects, myCourses, updateState } = context;
    const classes = useStyles();
    async function updateProperties(properties, updateCommand) {
        const [updatedId] = await (0, _command.createPost)('quiz', 'updateBankQuestionProperties')({
            id: question.id,
            ...properties
        });
        if (updatedId == question.id) updateState({
            quizNewBankQuestion: updateCommand
        });
    }
    function handleSubjectChange(e) {
        const request = {
            subject: e.target.value,
            course: undefined
        };
        const updateCommand = {
            subject: {
                $set: e.target.value
            },
            course: {
                $set: undefined
            },
            courseName: {
                $set: undefined
            }
        };
        updateProperties(request, updateCommand);
    }
    function handleCourseChange(e) {
        const { course, courseName } = myCourses.find(({ course })=>course == e.target.value);
        const request = {
            course
        };
        const updateCommand = {
            course: {
                $set: course
            },
            courseName: {
                $set: courseName
            }
        };
        updateProperties(request, updateCommand);
    }
    const courses = question.subject ? myCourses.filter(({ course })=>course.substring(0, 2) == question.subject) : myCourses;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectProperty, {
                controlMargin: "dense",
                controlClassName: (0, _clsxDefault.default)(classes.select, classes.subject),
                selectValue: question.subject == null ? '' : question.subject,
                selectOnChange: handleSubjectChange,
                caption: translate('subject_label'),
                children: subjects.map((subject, key)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: subject.id,
                        children: subject.name
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectProperty, {
                controlMargin: "dense",
                controlClassName: (0, _clsxDefault.default)(classes.select, classes.course),
                selectValue: question.course == null ? '' : question.course,
                selectOnChange: handleCourseChange,
                caption: translate('courseName-header'),
                children: courses.map((course, key)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: course.course,
                        children: course.courseName
                    }, key);
                })
            })
        ]
    });
}
function SelectProperty(props) {
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const labelAttributes = (0, _utils.pickAttributes)(props, 'label');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    const labelId = `${props.id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
        ...controlAttributes,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _inputLabelDefault.default), {
                shrink: true,
                id: labelId,
                ...labelAttributes,
                className: "label",
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                labelId: labelId,
                id: props.id,
                ...selectAttributes,
                className: "select",
                children: props.children
            })
        ]
    });
}
function questionStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1
        },
        select: {
            marginLeft: 15,
            minWidth: 200,
            '& .MuiInputBase-formControl': {
                margin: '11px 0'
            },
            '&:first-child': {
                marginLeft: 0
            },
            '& .MuiInput-underline:before': {
                content: 'none',
                border: 'none'
            },
            '& .MuiSelect-select': {
                border: 'solid 1px #aab7bf',
                borderRadius: 4,
                padding: '4px 24px 4px 8px'
            },
            '& > .label': {
                fontSize: '15pt',
                color: '#4e566b'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","@mui/material/Select":"aY7hn","@mui/material/InputLabel":"iTW3B","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","@mui/material/MenuItem":"a18vm","@mui/material/Box":"73kto","helpers/command":"f3cbG","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8l0XN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Buttons);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _material = require("external/material");
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(buttonsStyles);
function Buttons(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { onCancel, onCreate } = props;
    const { translate } = context;
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                className: (0, _clsxDefault.default)(classes.button, "create"),
                onClick: onCreate,
                children: translate('create')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                variant: "contained",
                className: (0, _clsxDefault.default)(classes.button, "cancel"),
                onClick: onCancel,
                children: translate('cancel')
            })
        ]
    });
}
function buttonsStyles(theme) {
    return {
        root: {
            display: 'flex'
        },
        button: {
            width: 120,
            fontSize: "12pt",
            textTransform: "none",
            boxShadow: 'none',
            borderRadius: 4,
            "&:first-child": {
                marginRight: 10
            },
            "&:last-child": {
                marginLeft: 10
            },
            "&.cancel": {
                border: "solid 1px #3d4556",
                backgroundColor: '#fff',
                color: "#3d4556",
                '&:hover': {
                    color: "#000",
                    border: "solid 1px #000",
                    backgroundColor: '#eaf5ff'
                }
            },
            "&.create": {
                color: "#fff",
                border: 'solid 1px #1d9be5',
                backgroundColor: '#1d9be5',
                color: '#fff',
                '&:hover': {
                    backgroundColor: '#29739f',
                    borderColor: '#29739f',
                    boxShadow: 'none'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","external/material":"6yEDE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ESYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _arrowDropDown = require("@mui/icons-material/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _arrowDropUp = require("@mui/icons-material/ArrowDropUp");
var _arrowDropUpDefault = parcelHelpers.interopDefault(_arrowDropUp);
var _share = require("@mui/icons-material/Share");
var _shareDefault = parcelHelpers.interopDefault(_share);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("teacher/context");
var _previewQuestion = require("components/quiz/components/preview-question");
var _previewQuestionDefault = parcelHelpers.interopDefault(_previewQuestion);
var _command = require("helpers/command");
var _utils = require("helpers/utils");
var _settings = require("./settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question(props) {
    const [expanded, setExpanded] = (0, _react.useState)(false);
    const history = (0, _reactRouterDom.useHistory)();
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { courseName, typeName, repository, owned, textpremise, shared } = props;
    const { translate, link, linkQuery, query, quizQuestionBankCart: cart, updateState } = context;
    const cartIndex = cart.findIndex((q)=>q.id == props.id);
    const inCart = cartIndex >= 0;
    const expandClick = ()=>setExpanded(!expanded);
    const premiseLabel = (0, _utils.isEmpty)(textpremise) ? translate(typeName) : textpremise;
    const [saving, setSaving] = (0, _reactDefault.default).useState(false);
    async function saveToPersonal() {
        setSaving(true);
        const [updatedId, cloned] = await (0, _command.createPost)('quiz', 'saveBankQuestionToPersonal')({
            id: props.id
        });
        if (updatedId == props.id) {
            setSaving(false);
            history.push(linkQuery(link('quiz', 'question-bank'), {
                id: cloned.id
            }, true));
        }
    }
    function handleSaveToPersonal() {
        if (!saving) saveToPersonal();
    }
    function onCartClick() {
        const updateCommand = inCart ? cart.length == 1 ? {
            quizQuestionBankCart: {
                $splice: [
                    [
                        cartIndex,
                        1
                    ]
                ]
            },
            quizQuestionBankCartEl: {
                $set: null
            }
        } : {
            quizQuestionBankCart: {
                $splice: [
                    [
                        cartIndex,
                        1
                    ]
                ]
            }
        } : {
            quizQuestionBankCart: {
                $push: [
                    props
                ]
            }
        };
        updateState(updateCommand);
    }
    (0, _reactDefault.default).useEffect(()=>{
        if ((0, _utils.isEmpty)(textpremise)) setExpanded(true);
    }, [
        textpremise
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, {
            expanded
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.cart,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.cartButton, {
                                inCart
                            }),
                            onClick: onCartClick,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: inCart ? (0, _freeSolidSvgIcons.faMinusCircle) : (0, _freeSolidSvgIcons.faPlusCircle)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: (0, _clsxDefault.default)(classes.cartLabel, {
                                        inCart
                                    }),
                                    children: translate(inCart ? 'remove-from-question-bank-cart' : 'add-to-question-bank-cart')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.filler
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.expand,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            className: classes.button,
                            startIcon: expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDropUpDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDropDownDefault.default), {}),
                            onClick: expandClick,
                            children: translate(expanded ? 'view-less' : 'view-more')
                        })
                    }),
                    !owned && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.splitWrapper,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.split
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: classes.saveToPersonal,
                                onClick: handleSaveToPersonal,
                                children: [
                                    !saving && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faFileExport)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: context.translate('save-to-personal')
                                            })
                                        ]
                                    }),
                                    saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faSpinner),
                                            spin: true
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    owned && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.splitWrapper,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.split
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.edit,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                    title: translate('edit-question-tooltip'),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: link({
                                            sectionName: 'edit-question',
                                            questionId: props.id
                                        }, '/:languageId/:role/:page/:tab/:sectionName/:questionId', {
                                            query
                                        }),
                                        className: (0, _clsxDefault.default)(classes.link, classes.editLink),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faEdit)
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.splitWrapper,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.split
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.shareWrapper,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.sharedLink,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            className: (0, _clsxDefault.default)(classes.sharedIcon, {
                                                shared
                                            }),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareDefault.default), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            className: classes.sharedText,
                                            children: shared ? translate('shared') : '-'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.settingsLink,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {
                                    classes: classes,
                                    question: props
                                })
                            })
                        ]
                    })
                ]
            }),
            !expanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.textPremise,
                children: premiseLabel
            }),
            expanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewQuestionDefault.default), {
                    headless: true,
                    showPoints: true,
                    showStandards: true,
                    context: context,
                    question: props
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.footer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.courseName,
                        children: [
                            translate('course_assessment_header'),
                            ": ",
                            courseName
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.type,
                        children: [
                            translate('type-header'),
                            ": ",
                            translate(typeName)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.repository,
                        children: [
                            translate('repository'),
                            ": ",
                            translate(owned ? 'personal' : repository)
                        ]
                    })
                ]
            })
        ]
    });
}
function questionStyles() {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            marginTop: 10,
            '&:first-child': {
                marginTop: 0
            },
            display: 'flex',
            flexDirection: 'column',
            border: 'solid 1px #becfd7',
            width: '100%',
            backgroundColor: '#fff'
        },
        saveToPersonal: {
            display: 'flex',
            flexDirection: 'row !important',
            justifyContent: 'flex-end',
            fontSize: '10pt',
            color: '#2ca5ec',
            cursor: 'pointer',
            '& span': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& svg': {
                height: '18px',
                marginTop: -3,
                marginRight: 8
            }
        },
        cart: {
            paddingLeft: 8
        },
        cartButton: {
            display: 'flex',
            cursor: 'pointer',
            color: '#2a92eb',
            '&.inCart': {
                color: '#d33d60'
            },
            '& svg': {
                marginTop: 4
            }
        },
        cartLabel: {
            marginTop: 3,
            marginLeft: 5,
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        button: {
            color: '#2a92eb',
            fontSize: '9pt',
            textTransform: 'none',
            '& .MuiButton-startIcon': {
                marginRight: 5
            }
        },
        editLink: {
            color: '#2a92eb'
        },
        header: {
            padding: 10,
            display: 'flex',
            '& > div': {
                ...verticalCentering
            }
        },
        filler: {
            flexGrow: 1
        },
        split: {
            marginLeft: 15,
            marginRight: 15,
            backgroundColor: '#d4d3d9',
            width: 1,
            height: '45%'
        },
        sharedLink: {
            display: 'flex',
            marginRight: 20,
            color: '#4d586e'
        },
        sharedIcon: {
            ...verticalCentering,
            color: '#c4c4c4',
            marginRight: 10,
            '& .MuiSvgIcon-root': {
                fontSize: '13.5pt'
            },
            '&.shared': {
                color: '#ea8511'
            }
        },
        sharedText: {
            ...verticalCentering,
            cursor: 'default',
            textAlign: 'center',
            marginRight: 10,
            width: 50,
            "&.selected": {
                color: "#fff"
            }
        },
        moreSettings: {
            ...verticalCentering
        },
        moreSettingsButton: {
            ...verticalCentering,
            color: '#a2a6b2',
            cursor: 'pointer',
            "&.selected": {
                color: '#fff'
            },
            '& .MuiSvgIcon-root': {
                fontSize: '16pt'
            }
        },
        content: {
            '& .section': {
                border: 0
            }
        },
        textPremise: {
            fontSize: '12pt',
            color: '#494f67',
            padding: '0 20px 20px 20px'
        },
        footer: {
            display: 'flex',
            backgroundColor: '#f7fbfe',
            color: '#494f67',
            fontSize: '10.5pt',
            borderTop: 'solid 1px #cfe0e8',
            padding: '10px',
            '& > div': {
                marginLeft: 15,
                borderLeft: 'solid 1px #cfe0e8',
                paddingLeft: 15,
                '&:first-child': {
                    marginLeft: 10,
                    borderLeft: 0,
                    paddingLeft: 0
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@mui/material/Tooltip":"7bRLE","@mui/icons-material/ArrowDropDown":"6qreH","@mui/icons-material/ArrowDropUp":"diWR2","@mui/icons-material/Share":"hf4BL","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","teacher/context":"5LKDx","components/quiz/components/preview-question":"4tE9v","helpers/command":"f3cbG","helpers/utils":"gGc98","./settings":"8kBZh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"diWR2":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("5c9cbe7b5d908ed2");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("927999e318a1fc78"));
var _jsxRuntime = require("51dbd20068a7147a");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "m7 14 5-5 5 5z"
}), 'ArrowDropUp');

},{"5c9cbe7b5d908ed2":"kZ6eK","927999e318a1fc78":"2vOnF","51dbd20068a7147a":"1dlk8"}],"8kBZh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Settings);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _responsiveFullscreenDialog = require("components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _previewQuestion = require("components/quiz/components/preview-question");
var _previewQuestionDefault = parcelHelpers.interopDefault(_previewQuestion);
var _context = require("teacher/context");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
function Settings(props) {
    const { question, classes } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const [deleteOpened, openDeleteQuestionBank] = (0, _reactDefault.default).useState(false);
    const [moveToDirectoryOpened, openMoveToDirectory] = (0, _reactDefault.default).useState(false);
    const [directory, setDirectory] = (0, _reactDefault.default).useState(question.directory || "");
    const openRowSettingsMenu = (e)=>{
        setAnchorEl(e.currentTarget);
    };
    const closeRowSettingsMenu = (e, reason)=>{
        setDirectory(question.directory || "");
        setAnchorEl(null);
    };
    function handleOpenDelete() {
        closeRowSettingsMenu();
        openDeleteQuestionBank(true);
    }
    async function handleDelete(confirmed) {
        openDeleteQuestionBank(false);
        if (!confirmed) return;
        await (0, _commandDefault.default)('quiz', 'deleteBankQuestion')({
            id: question.id
        });
        updateState({
            quizSearchQuestionBankCalls: {
                $apply: (n)=>n + 1
            }
        });
    }
    async function handleShare() {
        closeRowSettingsMenu();
        const shared = !question.shared;
        const [sharedId] = await (0, _commandDefault.default)('quiz', 'shareBankQuestion')({
            id: question.id,
            shared
        });
        if (sharedId == question.id) {
            const index = context.quizQuestionBank.findIndex(({ id })=>id == sharedId);
            if (index >= 0) updateState({
                quizQuestionBank: {
                    [index]: {
                        shared: {
                            $set: shared
                        }
                    }
                }
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.moreSettings,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.moreSettingsButton,
                onClick: openRowSettingsMenu,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                id: "settings-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: closeRowSettingsMenu,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleShare,
                        children: context.translate(question.shared ? 'unshare' : 'share')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenDelete,
                        children: context.translate('delete')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: deleteOpened,
                close: handleDelete,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>handleDelete(true),
                    children: translate('delete')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: ()=>handleDelete(),
                    children: translate('cancel')
                }),
                title: translate('confirm_delete_item'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewQuestionDefault.default), {
                    headless: true,
                    showPoints: true,
                    context: context,
                    question: question
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","immutability-helper":"hwjCt","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/icons-material/MoreVert":"22WtH","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","components/responsive-fullscreen-dialog":"9pRHY","components/quiz/components/preview-question":"4tE9v","teacher/context":"5LKDx","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eKVvD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assignments);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _createAssessment = require("./create-assessment");
var _createAssessmentDefault = parcelHelpers.interopDefault(_createAssessment);
var _assessmentFilters = require("./assessment-filters");
var _assessmentFiltersDefault = parcelHelpers.interopDefault(_assessmentFilters);
var _assignmentsHead = require("./assignments-head");
var _assignmentsHeadDefault = parcelHelpers.interopDefault(_assignmentsHead);
var _assignmentsBody = require("./assignments-body");
var _assignmentsBodyDefault = parcelHelpers.interopDefault(_assignmentsBody);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _filterChip = require("../components/filter-chip");
var _filterChipDefault = parcelHelpers.interopDefault(_filterChip);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _quiz = require("helpers/quiz");
var _reassign = require("./reassign");
var _reassignDefault = parcelHelpers.interopDefault(_reassign);
const useStyles = (0, _material.makeStyles)({
    root: {
        flexGrow: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff'
    },
    content: {
        display: 'flex',
        flexGrow: 1,
        overflow: 'hidden'
    },
    container: {
        flexGrow: 1,
        overflow: 'auto'
    },
    chips: {
        '&.hasChip': {
            padding: '8px 15px',
            marginTop: 0
        },
        '& .filter-chip': {
            backgroundColor: '#de3434',
            color: '#fff',
            '& .MuiChip-label': {
                padding: '0 20px'
            },
            '& .MuiChip-deleteIcon': {}
        }
    },
    filters: {
        display: 'flex',
        padding: '0 15px 8px 15px',
        "& .create-quiz-wrapper": {
            display: "flex",
            marginTop: -6,
            flexDirection: "column",
            justifyContent: "center",
            paddingLeft: 15
        }
    }
});
function Assignments(props) {
    const { translate } = props.context;
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const validateStatus = (0, _quiz.createValidateStatus)(props.context);
    const context = {
        ...props.context,
        validateStatus
    };
    const from = context.link();
    const hasStandardsChip = Object.values(props.context.quizStandardFilters).some((a)=>a.length > 0);
    const hasChip = !(!context.query.pattern && !context.query.id && !hasStandardsChip);
    function clearStandardFilters() {
        props.context.updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: {
                expectations: {
                    $set: []
                },
                indicators: {
                    $set: []
                },
                standards: {
                    $set: []
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.filters,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentFiltersDefault.default), {
                        context: context
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "create-quiz-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createAssessmentDefault.default), {
                            context: context,
                            simple: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reassignDefault.default), {
                        context: context
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.chips, {
                    hasChip
                }),
                children: [
                    context.query.pattern && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "pattern",
                        context: context,
                        from: from
                    }),
                    context.query.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "id",
                        context: context,
                        createLabel: ()=>translate('new-assignment'),
                        from: from
                    }),
                    hasStandardsChip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "standards",
                        context: context,
                        createLabel: ()=>translate('standards-filter-chip'),
                        from: from,
                        onDelete: clearStandardFilters
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                    className: classes.container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                        in: !context.quizSearch.assignments,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                            className: classes.table,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentsHeadDefault.default), {
                                    context: context
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentsBodyDefault.default), {
                                    context: context
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","./create-assessment":"e8dJn","./assessment-filters":"6kXOK","./assignments-head":"brSAl","./assignments-body":"jzG7Y","@mui/material/Fade":"8DwqP","@mui/material/TableContainer":"2Kmn7","@mui/material/Table":"if4Vw","../components/filter-chip":"i3UT5","helpers/command":"f3cbG","helpers/quiz":"2gdOk","./reassign":"8I0Lb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"brSAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssignmentsHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
const headCells = [
    {
        id: 'title',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'groupName',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'studentCount',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'type',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'start',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'status',
        align: 'center',
        disablePadding: false,
        notSortable: true
    }
];
const useStyles = (0, _material.makeStyles)((theme)=>({
        headersRow: {
            color: '#50566e',
            '& > th': {
                borderTop: 'solid 1px #becfd7',
                backgroundColor: '#ffffff'
            }
        },
        headerLabel: {
            color: '#4f576e',
            fontWeight: 500
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));
function AssignmentsHead({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { query, translate, navigate } = context;
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderBy = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    const createSortHandler = (property)=>(event)=>{
            history.push(context.link(undefined, undefined, {
                query: {
                    ...query,
                    page: 1,
                    orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`
                }
            }));
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
            className: classes.headersRow,
            children: [
                headCells.map(({ id, align, disablePadding, notSortable })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                        align: align,
                        padding: disablePadding ? 'none' : 'normal',
                        sortDirection: order,
                        style: {
                            top: 92
                        },
                        children: [
                            notSortable && translate(`${id}-header`),
                            !notSortable && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableSortLabelDefault.default), {
                                className: classes.headerLabel,
                                active: orderBy === id,
                                direction: order,
                                onClick: createSortHandler(id),
                                children: [
                                    translate(`${id}-header`),
                                    orderBy === id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: classes.visuallyHidden,
                                        children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                                    }) : null
                                ]
                            })
                        ]
                    }, id)),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.actions,
                    style: {
                        top: 92
                    }
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/TableSortLabel":"3xCAT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jzG7Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssignmentsBody);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactRouterDom = require("react-router-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _avatar = require("@mui/material/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _done = require("@mui/icons-material/Done");
var _doneDefault = parcelHelpers.interopDefault(_done);
var _rateReview = require("@mui/icons-material/RateReview");
var _rateReviewDefault = parcelHelpers.interopDefault(_rateReview);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _icons = require("resources/icons");
var _command = require("helpers/command");
var _assignmentRowSettings = require("./assignment-row-settings");
var _assignmentRowSettingsDefault = parcelHelpers.interopDefault(_assignmentRowSettings);
var _assignmentAssessment = require("../assignment-assessment");
var _assignmentAssessmentDefault = parcelHelpers.interopDefault(_assignmentAssessment);
var _updateAssignment = require("./update-assignment");
var _updateAssignmentDefault = parcelHelpers.interopDefault(_updateAssignment);
var _editStudentAssignment = require("./EditStudentAssignment");
var _editStudentAssignmentDefault = parcelHelpers.interopDefault(_editStudentAssignment);
const useStyles = (0, _material.makeStyles)(bodyStyles);
function AssignmentsBody({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { quizAssignments, translate, link } = context;
    const groupsStudentCount = context.groups.reduce((acc, { id, students })=>{
        acc[id] = students.length;
        return acc;
    }, {});
    function typeName(type) {
        const { name = "" } = context.quizTypes.find(({ id })=>id == type) || {};
        return name;
    }
    async function handleOpenModify(assignment) {
        const canModify = await context.validateStatus(assignment);
        if (canModify) context.updateState({
            quizAssignmentToModify: {
                $set: assignment
            },
            quizDialogs: {
                ['edit-assignment']: {
                    $set: true
                }
            }
        });
    }
    function formatDate(date) {
        return (0, _momentDefault.default)(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
    }
    function dateCell({ start, finish }) {
        return (0, _momentDefault.default)(start).isSame(finish, 'day') ? formatDate(start) : `${formatDate(start)} - ${formatDate(finish)}`;
    }
    function assessmentLink(assessment, action, sectionId) {
        return sectionId ? link({
            assessment,
            action,
            sectionId
        }, '/:languageId/:role/:page/:assessment/:action/:sectionId') : link({
            assessment,
            action
        }, '/:languageId/:role/:page/:assessment/:action');
    }
    async function handleEditClick(assignment, link) {
        const canModify = await context.validateStatus(assignment);
        if (canModify) {
            await (0, _command.createPost)('quiz', 'updateAssessmentProperties')({
                id: assignment.assessment,
                properties: {
                    ...assignment.assessmentProperties,
                    validated: false
                }
            });
            await context.updateState({
                quizEditFrom: {
                    $set: '/:languageId/:role/:page/assigned'
                },
                quizEditFromQuery: {
                    $set: {
                        ...context.query
                    }
                }
            });
            history.push(assessmentLink(assignment.assessment, 'edit', assignment.firstSection));
        }
    }
    function handleEditStudentAssignmentClick(assignment) {
        context.updateState({
            quizAssignmentToModify: {
                $set: assignment
            }
        }, {
            quizDialogs: {
                ['edit-student-assignment']: {
                    $set: true
                }
            }
        });
    }
    function handlePreviewClick() {
        context.setState({
            quizPreviewFrom: '/:languageId/:role/:page/assigned',
            quizPreviewFromQuery: {
                ...context.query
            }
        });
    }
    const standardsLink = (assessment)=>link({
            assessment,
            sectionName: 'standards'
        }, '/:languageId/:role/:page/:tab/:assessment/:sectionName', {
            preserveQuery: true
        });
    /*
  React.useEffect(() => {
    if (context.quizAssignments.length > 1) {
      context.updateState(
        {quizAssignmentToModify: {$set: context.quizAssignments[1]}},
        {quizDialogs: {['edit-student-assignment']: {$set: true}}}
      )
    }
  }, [context.quizAssignments])
  */ return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableBodyDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentAssessmentDefault.default), {
                context: context
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateAssignmentDefault.default), {
                context: context
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editStudentAssignmentDefault.default), {
                context: context
            }),
            quizAssignments.map((assignment)=>{
                const open = context.assignmentId == assignment.id;
                const assignmentId = open ? undefined : assignment.id;
                const expandHref = '#' + context.link({
                    assignmentId
                }, '/:languageId/:role/:page/assigned/:assignmentId?', {
                    preserveQuery: true
                });
                const { validated } = assignment.assessmentProperties || {};
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                        className: (0, _clsxDefault.default)(classes.row, "assignment"),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.cell, classes.title),
                                align: "left",
                                scope: "row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: classes.titleContainer,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: classes.assessmentIcon,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                                                fill: validated ? '#3295ce' : '#ff3a3a'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: (0, _clsxDefault.default)(classes.titleText, {
                                                validated
                                            }),
                                            children: assignment.title
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.cell, classes.group),
                                align: "left",
                                scope: "row",
                                children: assignment.groupName
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.cell, classes.studentCount),
                                align: "left",
                                scope: "row",
                                children: [
                                    assignment.studentCount,
                                    "/",
                                    groupsStudentCount[assignment.group]
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.cell, classes.type),
                                align: "left",
                                scope: "row",
                                children: translate(`${typeName(assignment.type)}-label`)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.cell, classes.date),
                                align: "left",
                                scope: "row",
                                children: dateCell(assignment)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.cell, classes.status),
                                align: "center",
                                scope: "row",
                                children: assignment.status.started > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.statusWrapper,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                                        className: (0, _clsxDefault.default)(classes.statusDot, {
                                            pending: assignment.status.pending > 0
                                        }),
                                        children: assignment.status.pending > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "R"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _doneDefault.default), {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.cell, classes.actions),
                                align: "right",
                                scope: "row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: classes.links,
                                    children: [
                                        assignment.startedCount < 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: translate('edit-assignment-tooltip'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                onClick: ()=>handleOpenModify(assignment),
                                                className: (0, _clsxDefault.default)(classes.link, classes.scheduleLink),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                                                })
                                            })
                                        }),
                                        assignment.startedCount < 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: translate('edit-assessment-tooltip'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                onClick: ()=>handleEditClick(assignment),
                                                className: (0, _clsxDefault.default)(classes.link, classes.editLink),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faEdit)
                                                })
                                            })
                                        }),
                                        assignment.startedCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                    title: translate('review-assignment-assessments-tooltip'),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                        size: "small",
                                                        href: expandHref,
                                                        className: (0, _clsxDefault.default)(classes.link, classes.reviewLink, {
                                                            visible: assignment.startedCount > 0
                                                        }),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rateReviewDefault.default), {})
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                                    title: translate('edit-student-assignment-tooltip'),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        onClick: ()=>handleEditStudentAssignmentClick(assignment),
                                                        className: (0, _clsxDefault.default)(classes.link, classes.editStudentAssignmentLink),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                            icon: (0, _freeSolidSvgIcons.faUser)
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: translate('standards-tooltip'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                to: standardsLink(assignment.assessment),
                                                className: classes.link,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faInfoCircle)
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: translate('preview-tooltip'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                onClick: handlePreviewClick,
                                                to: assessmentLink(assignment.assessment, 'preview', assignment.firstSection),
                                                className: (0, _clsxDefault.default)(classes.link, classes.previewLink),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PreviewIcon), {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: classes.settingsLink,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignmentRowSettingsDefault.default), {
                                                context,
                                                assignment,
                                                classes
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }, assignment.id);
            })
        ]
    });
}
function bodyStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        row: {
            '&:hover': {
                backgroundColor: '#def2ff'
            }
        },
        titleContainer: {
            display: 'flex'
        },
        assessmentIcon: {
            ...verticalCentering,
            marginTop: -5,
            marginRight: 15
        },
        titleText: {
            ...verticalCentering,
            color: '#ff3a3a',
            "&.validated": {
                color: '#000'
            }
        },
        expand: {
            marginRight: 8,
            visibility: 'hidden',
            '&.visible': {
                visibility: 'visible'
            }
        },
        statusWrapper: {
            display: 'flex',
            justifyContent: 'center'
        },
        statusDot: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            width: 20,
            height: 20,
            fontSize: '9pt',
            color: '#fff',
            backgroundColor: '#00bbe7',
            "& > span": {
                marginTop: 1,
                marginLeft: 1
            },
            "& > svg": {
                fontSize: '11.5pt'
            },
            "&.pending": {
                backgroundColor: '#ff3a3a'
            }
        },
        links: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        },
        link: {
            color: '#009dd8',
            fontSize: '16pt',
            marginRight: 20,
            width: 25,
            cursor: 'pointer',
            ...verticalCentering
        },
        sharedLink: {
            display: 'flex',
            marginRight: 20,
            color: '#4d586e'
        },
        sharedIcon: {
            ...verticalCentering,
            color: '#c4c4c4',
            marginRight: 10,
            '&.shared': {
                color: '#ea8511'
            }
        },
        sharedText: {
            ...verticalCentering,
            cursor: 'default',
            textAlign: 'center',
            marginRight: 10,
            width: 50
        },
        moreSettingsButton: {
            color: '#a2a6b2',
            cursor: 'pointer'
        },
        studentAssessments: {
            padding: 0,
            backgroundColor: '#f5f9fa',
            '&.collapsed': {
                borderBottom: 0,
                paddingBottom: 0,
                paddingTop: 0
            },
            '&.opened': {
                paddingTop: 0,
                paddingBottom: 20
            }
        },
        studentHeading: {
            color: '#707789',
            fontWeight: 'bold'
        },
        studentCell: {
            borderBottom: 0,
            '&.points.pending': {
                color: '#e91010'
            },
            '&.actions': {
                display: 'flex',
                '& .actionsContainer': {
                    display: 'flex',
                    padding: '5px 7px',
                    flexGrow: '1',
                    justifyContent: 'flex-end'
                }
            }
        },
        statusChip: {
            color: "#fff",
            fontSize: '9pt',
            padding: '5px 7px',
            "&.pending-review": {
                backgroundColor: "#ef3a3a"
            },
            "&.published": {
                backgroundColor: "#43b869"
            },
            "&.not-published": {
                backgroundColor: "#00bbe7"
            },
            "&.started": {
                backgroundColor: "#00bbe7"
            }
        },
        studentLink: {
            color: '#009dd8',
            textDecoration: 'none',
            fontSize: '11pt',
            cursor: 'pointer',
            ...verticalCentering
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","helpers/moment":"jwdju","react-router-dom":"3uzXR","clsx":"5PNR8","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Tooltip":"7bRLE","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableRow":"4f4VX","@mui/material/Avatar":"4ltr6","@mui/icons-material/Done":"6GFTq","@mui/icons-material/RateReview":"3K6yC","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","resources/icons":"7BMUb","helpers/command":"f3cbG","./assignment-row-settings":"iyTGQ","../assignment-assessment":"EUosd","./update-assignment":"kGxLy","./EditStudentAssignment":"ieGsn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jwdju":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var monthsShortDot$2 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'), monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
var monthsParse$3 = [
    /^ene/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
];
var monthsRegex$3 = /^(Enero|Febrero|Marzo|Abril|Mayo|Junio|Julio|Agosto|Septiembre|Octubre|Noviembre|Diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
(0, _momentDefault.default).defineLocale('es', {
    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
    monthsShort: function(m, format) {
        if (!m) return monthsShortDot$2;
        else if (/-MMM-/.test(format)) return monthsShort$3[m.month()];
        else return monthsShortDot$2[m.month()];
    },
    monthsRegex: monthsRegex$3,
    monthsShortRegex: monthsRegex$3,
    monthsStrictRegex: /^(Enero|Febrero|Marzo|Abril|Mayo|Junio|Julio|Agosto|Septiembre|Octubre|Noviembre|Diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse$3,
    longMonthsParse: monthsParse$3,
    shortMonthsParse: monthsParse$3,
    weekdays: "domingo_lunes_martes_mi\xe9rcoles_jueves_viernes_s\xe1bado".split('_'),
    weekdaysShort: "dom._lun._mar._mi\xe9._jue._vie._s\xe1b.".split('_'),
    weekdaysMin: 'd_l_m_mi_j_v_s'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
        LT: 'H:mm',
        LTS: 'H:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D [de] MMMM [de] YYYY',
        LLL: 'D [de] MMMM [de] YYYY H:mm',
        LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar: {
        sameDay: function() {
            return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
        },
        nextDay: function() {
            return "[ma\xf1ana a la" + (this.hours() !== 1 ? 's' : '') + '] LT';
        },
        nextWeek: function() {
            return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
        },
        lastDay: function() {
            return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
        },
        lastWeek: function() {
            return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
        },
        sameElse: 'L'
    },
    relativeTime: {
        future: 'en %s',
        past: 'hace %s',
        s: 'unos segundos',
        ss: '%d segundos',
        m: 'un minuto',
        mm: '%d minutos',
        h: 'una hora',
        hh: '%d horas',
        d: "un d\xeda",
        dd: "%d d\xedas",
        M: 'un mes',
        MM: '%d meses',
        y: "un a\xf1o",
        yy: "%d a\xf1os"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xba",
    week: {
        dow: 1,
        // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});
exports.default = (0, _momentDefault.default);

},{"moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ltr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _avatarDefault.default));
parcelHelpers.export(exports, "avatarClasses", ()=>(0, _avatarClassesDefault.default));
var _avatar = require("./Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _avatarClasses = require("./avatarClasses");
var _avatarClassesDefault = parcelHelpers.interopDefault(_avatarClasses);
parcelHelpers.exportAll(_avatarClasses, exports);
'use client';

},{"./Avatar":"3VJs4","./avatarClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3VJs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _zeroStyled = require("../zero-styled");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _person = require("../internal/svg-icons/Person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _avatarClasses = require("./avatarClasses");
var _useSlot = require("../utils/useSlot");
var _useSlotDefault = parcelHelpers.interopDefault(_useSlot);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _avatarClasses.getAvatarUtilityClass), classes);
};
const AvatarRoot = (0, _zeroStyled.styled)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, _extendsDefault.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, _extendsDefault.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles('dark', {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const AvatarImg = (0, _zeroStyled.styled)('img', {
    name: 'MuiAvatar',
    slot: 'Img',
    overridesResolver: (props, styles)=>styles.img
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const AvatarFallback = (0, _zeroStyled.styled)((0, _personDefault.default), {
    name: 'MuiAvatar',
    slot: 'Fallback',
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: '75%',
    height: '75%'
});
function useLoaded({ crossOrigin, referrerPolicy, src, srcSet }) {
    const [loaded, setLoaded] = _react.useState(false);
    _react.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const Avatar = /*#__PURE__*/ _react.forwardRef(function Avatar(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt, children: childrenProp, className, component = 'div', slots = {}, slotProps = {}, imgProps, sizes, src, srcSet, variant = 'circular' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = useLoaded((0, _extendsDefault.default)({}, imgProps, {
        src,
        srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    const ownerState = (0, _extendsDefault.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, _useSlotDefault.default)('img', {
        className: classes.img,
        elementType: AvatarImg,
        externalForwardedProps: {
            slots,
            slotProps: {
                img: (0, _extendsDefault.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt,
            src,
            srcSet,
            sizes
        },
        ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImgSlot, (0, _extendsDefault.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(AvatarRoot, (0, _extendsDefault.default)({
        as: component,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
exports.default = Avatar;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../zero-styled":"89fxU","../DefaultPropsProvider":"ff3VX","../internal/svg-icons/Person":"ce9zJ","./avatarClasses":"4VEkX","../utils/useSlot":"29rI6","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ce9zJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4VEkX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAvatarUtilityClass", ()=>getAvatarUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAvatarUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiAvatar', slot);
}
const avatarClasses = (0, _generateUtilityClassesDefault.default)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
exports.default = avatarClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3K6yC":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("e062d8cb4c04502");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("baca9d4c25fe2951"));
var _jsxRuntime = require("ead7e35e7035556c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14zm12 0h-7.5l2-2H18z"
}), 'RateReview');

},{"e062d8cb4c04502":"kZ6eK","baca9d4c25fe2951":"2vOnF","ead7e35e7035556c":"1dlk8"}],"iyTGQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssignmentRowSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _textInput = require("components/text-input");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _responsiveFullscreenDialog = require("components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _context = require("teacher/context");
function AssignmentRowSettings({ context, assignment, classes }) {
    const history = (0, _reactRouterDom.useHistory)();
    const { translate } = context;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const [deleteOpened, openDeleteAssignment] = (0, _reactDefault.default).useState(false);
    const openRowSettingsMenu = (e)=>{
        setAnchorEl(e.currentTarget);
    };
    const closeRowSettingsMenu = (e, reason)=>{
        setAnchorEl(null);
    };
    function handleOpenDelete() {
        closeRowSettingsMenu();
        openDeleteAssignment(true);
    }
    async function handleDelete(confirmed) {
        openDeleteAssignment(false);
        if (confirmed) {
            const canModify = await context.validateStatus(assignment);
            if (canModify) {
                const [deletedId] = await (0, _commandDefault.default)('quiz', 'deleteAssignment')({
                    id: assignment.id
                });
                if (deletedId == assignment.id) {
                    if (context.query.id) context.navigate({}, undefined, {
                        query: {
                            ...context.query,
                            id: undefined
                        }
                    });
                    else context.setState({
                        quizAssignmentCalls: context.quizAssignmentCalls + 1
                    });
                }
            }
        }
    }
    function handleOpenReassign() {
        context.setState({
            quizAssignmentToReassign: assignment
        });
        closeRowSettingsMenu();
    }
    function handlePublishAll() {
        if (context.quizStudentAssessments.length > 0) {
            context.updateState({
                quizStudentAssessments: {
                    $apply: (s)=>s.map((a)=>(0, _immutabilityHelperDefault.default)(a, {
                                properties: {
                                    published: {
                                        $set: true
                                    }
                                }
                            }))
                }
            });
            (0, _commandDefault.default)('quiz', 'publishAllReviewed')({
                id: assignment.id
            });
        }
        closeRowSettingsMenu();
    }
    async function handlePrintBlankAssessmentPdf() {
        closeRowSettingsMenu();
        await (0, _commandDefault.default)('quiz', 'startTestAssessment')({
            id: assignment.assessment
        });
        context.updateState({
            quizBlankAssessmentForPdfId: {
                $set: assignment.assessment
            }
        });
    }
    const canPublish = assignment.id == context.assignmentId && context.quizStudentAssessments.findIndex((a)=>{
        const results = Object.values(a.results || {});
        return results.every((r)=>!r.pending);
    }) >= 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.moreSettings,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.moreSettingsButton,
                onClick: openRowSettingsMenu,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                id: "settings-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: closeRowSettingsMenu,
                children: [
                    assignment.startedCount < 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenDelete,
                        children: context.translate('delete')
                    }),
                    assignment.startedCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenReassign,
                        children: context.translate('reassign')
                    }),
                    canPublish > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handlePublishAll,
                        children: context.translate('publish-all')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handlePrintBlankAssessmentPdf,
                        children: context.translate('blank-assessment-pdf')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: deleteOpened,
                close: handleDelete,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>handleDelete(true),
                    children: translate('delete')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: ()=>handleDelete(),
                    children: translate('cancel')
                }),
                title: translate('confirm_delete_item'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    children: translate('delete-assignment-message', assignment)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/icons-material/MoreVert":"22WtH","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/material/DialogContentText":"5nWzR","components/text-input":"gF58h","components/responsive-fullscreen-dialog":"9pRHY","helpers/command":"f3cbG","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"EUosd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewBlankPdf);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _body = require("./Body");
var _bodyDefault = parcelHelpers.interopDefault(_body);
const useStyles = (0, _material.makeStyles)(previewStyles);
const useTitleStyles = (0, _material.makeStyles)(titleStyles);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
function PreviewBlankPdf({ context }) {
    const theme = (0, _material.useTheme)();
    const history = (0, _reactRouterDom.useHistory)();
    const contentRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    const fullScreen = (0, _useMediaQueryDefault.default)(theme.breakpoints.down('md'));
    const { translate, assignmentId, quizStudentAssessments: assessments, link, linkQuery } = context;
    const assignment = context.quizAssignments.find((a)=>a.id == assignmentId) || {};
    const title = assignment.id != undefined ? `${assignment.title} - ${assignment.groupName}` : translate('assessment');
    const classes = useStyles();
    const titleClasses = useTitleStyles();
    const dialogClasses = useDialogStyles();
    const isOpen = assignmentId != undefined && assessments.length > 0 && context.quizStudentAssessmentAssignmentId == assignmentId;
    function close() {
        let href = link({}, '/:languageId/:role/:page/:tab');
        if (context.quizReviewFrom) {
            href = linkQuery(context.quizReviewFrom, context.quizReviewFromQuery);
            context.updateState({
                quizReviewFrom: {
                    $set: undefined
                },
                quizReviewFromQuery: {
                    $set: {}
                }
            });
        }
        history.push(href);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        fullScreen: fullScreen,
        open: isOpen,
        onClose: (e)=>close(),
        classes: dialogClasses,
        "aria-labelledby": "assignment-assessments-title",
        maxWidth: "lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                id: "assignment-assessments-title",
                classes: titleClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.close,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            onClick: close,
                            size: "large",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                className: classes.contentWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.content,
                    ref: contentRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bodyDefault.default), {
                        context: context
                    })
                })
            })
        ]
    });
}
function dialogStyles(theme) {
    return {
        paper: {
            width: '100%',
            padding: 0,
            height: 'calc(100% - 100px)'
        }
    };
}
function titleStyles(theme) {
    return {
        root: {
            display: 'flex',
            padding: '10px 10px 10px 24px',
            fontSize: '14pt',
            fontWeight: 'bold',
            borderBottom: 'solid 1px #f3f3f3',
            color: '#525b6c',
            background: '#fdfdfd'
        }
    };
}
function previewStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        close: {
            ...verticalCentering,
            color: '#69738',
            padding: 0,
            "& svg": {
                fontSize: '14pt'
            }
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {},
            '& .icon': {
                marginTop: -1,
                marginRight: 4,
                fontSize: '8pt'
            }
        },
        contentWrapper: {
            padding: 0,
            marginTop: 5
        },
        content: {
            display: 'flex'
        },
        actions: {
            padding: 24
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Button":"c6Y0y","@mui/material/Dialog":"255tO","@mui/material/DialogTitle":"5sOv1","@mui/material/DialogActions":"5WZHz","@mui/material/DialogContent":"gD0J9","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/IconButton":"bXjnZ","@mui/icons-material/Close":"acjz6","@mui/material/useMediaQuery":"bnRpi","./Body":"foCZj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"foCZj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssignmentAssessmentsBody);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _command = require("../../../helpers/command");
var _utils = require("../../../helpers/utils");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const useStyles = (0, _material.makeStyles)(bodyStyles);
function AssignmentAssessmentsBody({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { quizAssignments, translate, link, query, assignmentId, standardsContext } = context;
    const { assessmentStandards } = standardsContext;
    const standardsFound = assessmentStandards.items.length > 0;
    function formatDate(date) {
        return (0, _momentDefault.default)(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
        className: (0, _clsxDefault.default)(classes.studentAssessmentsTable),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: (0, _clsxDefault.default)(classes.studentHeading),
                            children: translate('student')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: (0, _clsxDefault.default)(classes.studentHeading),
                            children: translate('assessment-start-date')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: (0, _clsxDefault.default)(classes.studentHeading),
                            children: translate('assessment-sent-date')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: (0, _clsxDefault.default)(classes.studentHeading),
                            children: translate('points')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: (0, _clsxDefault.default)(classes.studentHeading),
                            children: translate('total')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: (0, _clsxDefault.default)(classes.studentHeading),
                            align: "center",
                            children: translate('status')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: (0, _clsxDefault.default)(classes.studentHeading),
                            align: "center",
                            children: translate('state')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                children: context.quizStudentAssessments.map((studentAssessment, index)=>{
                    const { id, results, finished, started, properties = {} } = studentAssessment;
                    const { bonus = 0, published = false } = properties;
                    const { points, total, pending } = Object.values(results || {}).reduce((acc, result)=>{
                        return {
                            points: acc.points + result.points,
                            total: acc.total + result.total,
                            pending: acc.pending + (result.pending ? 1 : 0)
                        };
                    }, {
                        points: bonus || 0,
                        total: 0,
                        pending: 0
                    });
                    function savePageReference() {
                        context.setState({
                            quizEditFrom: link({
                                assignmentId
                            }, '/:languageId/:role/:page/:tab/:assignmentId'),
                            quizEditFromQuery: {
                                ...query
                            }
                        });
                    }
                    function saveToPdf() {
                        context.updateState({
                            quizAssessmentForPdfId: {
                                $set: id
                            }
                        });
                    }
                    const status = !finished && 'started' || pending > 0 && 'pending-review' || published && 'published' || 'not-published';
                    const stateDisabled = [
                        'pending-review',
                        'started'
                    ].indexOf(status) >= 0 ? {
                        disabled: true,
                        inputProps: {
                            'aria-label': 'disabled checkbox'
                        }
                    } : {};
                    async function handleStateChange(e) {
                        const updated = await context.updateState({
                            quizStudentAssessments: {
                                [index]: {
                                    properties: {
                                        published: {
                                            $set: e.target.checked
                                        }
                                    }
                                }
                            }
                        });
                        const { id, properties } = updated.quizStudentAssessments[index];
                        (0, _command.createPost)('quiz', 'saveReviewProperties')({
                            id,
                            properties
                        });
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                        className: (0, _clsxDefault.default)(classes.row, "student"),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "name"),
                                children: studentAssessment.studentName
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "started"),
                                children: formatDate(started)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "finished"),
                                children: finished && formatDate(finished)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "points"),
                                children: finished && (0, _utils.toDisplayPoints)(points)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "total"),
                                children: finished && total
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "status"),
                                align: "center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                                    label: translate(`${status}-chip`),
                                    className: (0, _clsxDefault.default)(classes.statusChip, {
                                        [status]: true
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "state"),
                                align: "center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                    ...stateDisabled,
                                    color: "primary",
                                    checked: status == 'published',
                                    onChange: handleStateChange
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                                className: (0, _clsxDefault.default)(classes.studentCell, "actions"),
                                align: "right",
                                scope: "row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: "actionsContainer",
                                    children: [
                                        status != 'started' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: translate('review-assessment-tooltip'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                onClick: savePageReference,
                                                to: link({
                                                    assessment: id,
                                                    action: 'review'
                                                }, '/:languageId/:role/:page/:assessment/:action'),
                                                className: (0, _clsxDefault.default)(classes.studentLink, "review"),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faEye)
                                                })
                                            })
                                        }),
                                        status != 'started' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                            title: translate('standards-results-tooltip'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                                onClick: savePageReference,
                                                to: link({
                                                    assessment: id,
                                                    action: 'standards-results'
                                                }, '/:languageId/:role/:page/:assessment/:action'),
                                                className: (0, _clsxDefault.default)(classes.studentLink, !standardsFound ? classes.linkDisabled : ''),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                    icon: (0, _freeSolidSvgIcons.faPoll)
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }, studentAssessment.id);
                })
            })
        ]
    });
}
function bodyStyles(theme) {
    // removed-dreyfous-filter context.profile.domain == 'dreyfous' && (
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        row: {
            '&:hover': {
                backgroundColor: '#def2ff'
            }
        },
        title: {
            paddingLeft: 8
        },
        titleContainer: {
            display: 'flex'
        },
        assessmentIcon: {
            ...verticalCentering,
            marginTop: -5,
            marginRight: 15
        },
        titleText: {
            ...verticalCentering,
            color: '#ff3a3a',
            "&.validated": {
                color: '#000'
            }
        },
        expand: {
            marginRight: 8,
            visibility: 'hidden',
            '&.visible': {
                visibility: 'visible'
            }
        },
        statusWrapper: {
            display: 'flex',
            justifyContent: 'center'
        },
        statusDot: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            width: 20,
            height: 20,
            fontSize: '9pt',
            color: '#fff',
            backgroundColor: '#00bbe7',
            "& > span": {
                marginTop: 1,
                marginLeft: 1
            },
            "& > svg": {
                fontSize: '11.5pt'
            },
            "&.pending": {
                backgroundColor: '#ff3a3a'
            }
        },
        links: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-end'
        },
        link: {
            color: '#009dd8',
            fontSize: '16pt',
            marginRight: 20,
            width: 25,
            cursor: 'pointer',
            ...verticalCentering
        },
        sharedLink: {
            display: 'flex',
            marginRight: 20,
            color: '#4d586e'
        },
        sharedIcon: {
            ...verticalCentering,
            color: '#c4c4c4',
            marginRight: 10,
            '&.shared': {
                color: '#ea8511'
            }
        },
        sharedText: {
            ...verticalCentering,
            cursor: 'default',
            textAlign: 'center',
            marginRight: 10,
            width: 50
        },
        moreSettingsButton: {
            color: '#a2a6b2',
            cursor: 'pointer'
        },
        studentAssessments: {
            padding: 0,
            backgroundColor: '#f5f9fa'
        },
        studentHeading: {
            color: '#707789',
            fontWeight: 'bold'
        },
        studentCell: {
            borderBottom: 0,
            '&.points.pending': {
                color: '#e91010'
            },
            '&.actions': {
                '& .actionsContainer': {
                    display: 'flex',
                    padding: '5px 7px',
                    flexGrow: '1',
                    justifyContent: 'flex-end'
                }
            }
        },
        statusChip: {
            color: "#fff",
            fontSize: '9pt',
            padding: '5px 7px',
            "&.pending-review": {
                backgroundColor: "#ef3a3a"
            },
            "&.published": {
                backgroundColor: "#43b869"
            },
            "&.not-published": {
                backgroundColor: "#00bbe7"
            },
            "&.started": {
                backgroundColor: "#00bbe7"
            }
        },
        studentLink: {
            color: '#009dd8',
            textDecoration: 'none',
            fontSize: '1.9em',
            cursor: 'pointer',
            margin: '0 7px',
            ...verticalCentering
        },
        linkDisabled: {
            cursor: 'default',
            opacity: '0.5',
            textDecoration: 'none',
            pointerEvents: 'none'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","helpers/moment":"jwdju","react":"9njXz","react-router-dom":"3uzXR","clsx":"5PNR8","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Tooltip":"7bRLE","@mui/material/Table":"if4Vw","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/Chip":"eSSCi","@mui/material/Checkbox":"4sdMA","../../../helpers/command":"f3cbG","../../../helpers/utils":"gGc98","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"joPR3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8I0Lb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assign);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tabs = require("@mui/material/Tabs");
var _tabsDefault = parcelHelpers.interopDefault(_tabs);
var _tab = require("@mui/material/Tab");
var _tabDefault = parcelHelpers.interopDefault(_tab);
var _infoBar = require("./info-bar");
var _infoBarDefault = parcelHelpers.interopDefault(_infoBar);
var _selectStudents = require("./select-students");
var _selectStudentsDefault = parcelHelpers.interopDefault(_selectStudents);
var _writeComments = require("./write-comments");
var _writeCommentsDefault = parcelHelpers.interopDefault(_writeComments);
var _command = require("helpers/command");
var _responsiveFullscreenDialog = require("../../components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
const useDialogStyles = (0, _material.makeStyles)((theme)=>({
        paper: {
            width: '100%',
            padding: '20px 0',
            height: 'calc(100% - 100px)'
        }
    }));
const useDialogActionsStyles = (0, _material.makeStyles)({
    root: {
        padding: 0
    }
});
const useDialogTitleStyles = (0, _material.makeStyles)({
    root: {
        padding: 0
    }
});
const useDialogContentStyles = (0, _material.makeStyles)({
    root: {
        padding: 0,
        display: 'flex'
    }
});
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexDirection: 'column',
            color: '#4f576e',
            flexGrow: 1
        }
    }));
const Tabs = (0, _material.withStyles)({
    root: {
        flexShrink: 0,
        borderBottom: 'solid 1px #dbe3e6'
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        flexGrow: 1
    },
    flexContainer: {
        flexGrow: 1
    }
})((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabsDefault.default), {
        ...props,
        TabIndicatorProps: {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        }
    }));
const Tab = (0, _material.withStyles)((theme)=>({
        root: {
            padding: '0 5px',
            margin: 0,
            maxWidth: 'initial',
            flexShrink: 1,
            flexGrow: 1,
            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            backgroundColor: '#f8f8f8',
            fontSize: theme.typography.pxToRem(18),
            [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.pxToRem(15)
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: theme.typography.pxToRem(12)
            },
            '&:first-child': {
                borderRight: 'solid 1px #dbe3e6'
            },
            '&:focus': {
                opacity: 1
            }
        },
        wrapper: {
            flexDirection: 'row'
        },
        selected: {
            opacity: 1,
            backgroundColor: 'transparent'
        }
    }))((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabDefault.default), {
        disableRipple: true,
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CircleIcon, {
            ...props
        }),
        ...props
    }));
const useCircleStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            borderRadius: 50,
            flexShrink: 0,
            color: '#fff',
            width: '25px',
            height: '25px',
            fontSize: '11pt',
            lineHeight: '1.8',
            marginRight: '20px',
            backgroundColor: '#a6a6a6',
            [theme.breakpoints.down('sm')]: {
                marginRight: '8px'
            }
        },
        selected: {
            backgroundColor: '#e27a1b'
        }
    }));
function CircleIcon(props) {
    const classes = useCircleStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, {
            [classes.selected]: props.selected
        }),
        children: props.value + 1
    });
}
const initialState = ()=>({
        group: '',
        start: (0, _momentDefault.default)().toDate(),
        finish: (0, _momentDefault.default)().endOf('day').toDate(),
        maxDuration: (0, _momentDefault.default)().endOf('day').diff((0, _momentDefault.default)(), 'seconds'),
        duration: 3600,
        comments: '',
        students: [],
        selectedStudents: [],
        checkedStudents: {},
        tab: 0
    });
function Assign({ context }) {
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, quizAssignmentToReassign: assignment, groups } = context;
    const classes = useStyles();
    const dialogClasses = useDialogStyles();
    const dialogActionsClasses = useDialogActionsStyles();
    const dialogTitleClasses = useDialogTitleStyles();
    const dialogContentClasses = useDialogContentStyles();
    const isOpen = assignment !== false;
    const [state, setState] = (0, _reactDefault.default).useState(initialState());
    function handleTimeChange({ hours, minutes }) {
        const duration = Math.min(minutes * 60 + hours * 3600, state.maxDuration);
        setState({
            ...state,
            duration
        });
    }
    function handleStartChange(start) {
        const finish = (0, _momentDefault.default)(state.finish).isAfter(start) ? state.finish : (0, _momentDefault.default)(start).endOf('day').toDate();
        const maxDuration = (0, _momentDefault.default)(finish).diff((0, _momentDefault.default)(start), 'seconds');
        const duration = Math.min(state.duration, maxDuration);
        setState({
            ...state,
            start,
            finish,
            duration,
            maxDuration
        });
    }
    function handleFinishChange(finish) {
        const maxDuration = (0, _momentDefault.default)(finish).diff((0, _momentDefault.default)(state.start), 'seconds');
        const duration = Math.min(state.duration, maxDuration);
        setState({
            ...state,
            finish,
            duration,
            maxDuration
        });
    }
    function handleTabChange(e, tab) {
        setState({
            ...state,
            tab
        });
    }
    function handleCancel() {
        context.setState({
            quizAssignmentToReassign: false
        });
        setState(initialState());
    }
    function handleContinue() {
        setState({
            ...state,
            tab: 1
        });
    }
    function handleBack() {
        setState({
            ...state,
            tab: 0
        });
    }
    function handleGroupChange(e) {
        const group = groups.find((g)=>g.id == e.target.value) || {};
        const students = group.students || [];
        const checkedStudents = students.reduce((acc, student)=>{
            acc[student.id] = false;
            return acc;
        }, {});
        setState({
            ...state,
            group: e.target.value,
            students,
            selectedStudents: [],
            checkedStudents
        });
    }
    function handleStudentsChecked(id, value) {
        setState({
            ...state,
            checkedStudents: {
                ...state.checkedStudents,
                [id]: value
            }
        });
    }
    function handleStudentsChange({ left, right }) {
        setState({
            ...state,
            students: left,
            selectedStudents: right
        });
    }
    function handleCommentsChange(e) {
        setState({
            ...state,
            comments: e.target.value
        });
    }
    async function handleSend() {
        try {
            const { id } = assignment;
            const { comments, duration } = state;
            const start = (0, _momentDefault.default)(state.start).toISOString();
            const finish = (0, _momentDefault.default)(state.finish).toISOString();
            const students = state.selectedStudents.map((s)=>s.id);
            const [result] = await (0, _command.createPost)('quiz', 'reassign')({
                id,
                start,
                finish,
                duration,
                comments,
                students
            });
            if (result) context.navigate(undefined, undefined, {
                query: {
                    id: result.assignment
                }
            });
            handleCancel();
        } catch (e) {
            console.log(e);
            handleCancel();
        }
    }
    (0, _reactDefault.default).useEffect(()=>{
        if (assignment) {
            const { group, duration, properties } = assignment;
            const { comments } = properties;
            const { students = [] } = context.groups.find((g)=>g.id == group) || {};
            const selectedStudents = [];
            const checkedStudents = students.reduce((acc, s)=>{
                acc[s.id] = false;
                return acc;
            }, {});
            setState({
                ...state,
                group,
                duration,
                comments,
                students,
                checkedStudents,
                selectedStudents
            });
        }
    }, [
        assignment
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: handleCancel,
        dialogClasses: dialogClasses,
        contentClasses: dialogContentClasses,
        headClasses: dialogTitleClasses,
        actionsClasses: dialogActionsClasses,
        dialogMaxWidth: "lg",
        TitleComponent: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBarDefault.default), {
                context: context
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Tabs, {
                    value: state.tab,
                    onChange: handleTabChange,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tab, {
                            label: translate('select-students-tab')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(Tab, {
                            label: translate('comments-tab')
                        })
                    ]
                }),
                state.tab == 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectStudentsDefault.default), {
                    selectedGroup: state.group,
                    students: state.students,
                    selectedStudents: state.selectedStudents,
                    checkedStudents: state.checkedStudents,
                    onGroupChange: handleGroupChange,
                    onStudentsChecked: handleStudentsChecked,
                    onStudentsChange: handleStudentsChange,
                    onCancel: handleCancel,
                    onContinue: handleContinue,
                    context: context
                }),
                state.tab == 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _writeCommentsDefault.default), {
                    selectedStudents: state.selectedStudents,
                    newComments: state.comments,
                    start: state.start,
                    finish: state.finish,
                    duration: state.duration,
                    onCommentsChange: handleCommentsChange,
                    onStartChange: handleStartChange,
                    onFinishChange: handleFinishChange,
                    onTimeChange: handleTimeChange,
                    onCancel: handleCancel,
                    onSend: handleSend,
                    context: context
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-router-dom":"3uzXR","clsx":"5PNR8","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Tabs":"g7Izf","@mui/material/Tab":"bmkB3","./info-bar":"cM1fa","./select-students":"bUq0O","./write-comments":"lyNoR","helpers/command":"f3cbG","../../components/responsive-fullscreen-dialog":"5zam1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cM1fa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _icons = require("../../../../resources/icons");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            borderBottom: 'solid 1px #dbe3e6',
            minHeight: '60px',
            paddingLeft: '15px'
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        label: {
            paddingTop: '4px',
            marginLeft: '20px',
            fontSize: '14pt',
            [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.pxToRem(15)
            }
        }
    }));
function InfoBar({ context }) {
    const { quizAssignmentToReassign } = context;
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.middle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AssignedContentIcon), {
                    fill: "#4f576e"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: `${classes.middle} ${classes.label}`,
                children: quizAssignmentToReassign.title
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../../resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bUq0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectStudents);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _select = require("../../../select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _transferList = require("../../../transfer-list");
var _transferListDefault = parcelHelpers.interopDefault(_transferList);
var _checklist = require("./checklist");
var _checklistDefault = parcelHelpers.interopDefault(_checklist);
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: '0 20px',
            overflow: 'hidden'
        },
        group: {
            padding: '20px 0',
            maxWidth: 'calc(50% - 56px)',
            [theme.breakpoints.down('sm')]: {
                maxWidth: 'initial'
            }
        },
        students: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto'
        },
        buttons: {
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center'
            }
        },
        cancel: {
            width: '120px',
            marginRight: '10px',
            boxShadow: 'none',
            [theme.breakpoints.down('sm')]: {
                marginRight: '20px'
            }
        },
        continue: {
            width: '120px',
            color: '#fff',
            boxShadow: 'none',
            backgroundColor: '#2ca5ec'
        }
    }));
function SelectStudents(props) {
    const { selectedGroup, context } = props;
    const { groups, translate } = context;
    const classes = useStyles();
    const group = groups.find((g)=>g.id == selectedGroup) || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.group,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        children: [
                            translate('group_label'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "value",
                        children: group.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.students,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                        smDown: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transferListDefault.default), {
                            label: ({ name })=>name,
                            left: props.students,
                            LeftHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.studentsHeader,
                                    children: [
                                        translate('students'),
                                        ":"
                                    ]
                                }),
                            RightHeader: (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.selectedHeader,
                                    children: [
                                        translate('selected'),
                                        ":"
                                    ]
                                }),
                            right: props.selectedStudents,
                            checklist: props.checkedStudents,
                            onChecked: props.onStudentsChecked,
                            onTransfer: props.onStudentsChange
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                        smUp: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checklistDefault.default), {
                            items: (0, _lodash.chain)(props.students).concat(props.selectedStudents).map((s)=>({
                                    ...s,
                                    label: s.alias || s.email
                                })).orderBy([
                                'label',
                                'id'
                            ]).value(),
                            selectAllTitle: translate('students_label'),
                            onChecked: props.onStudentsChange,
                            checklist: props.selectedStudents.map((s)=>s.id)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onCancel,
                        variant: "contained",
                        className: classes.cancel,
                        children: translate('cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onContinue,
                        disabled: props.selectedStudents.length == 0,
                        variant: "contained",
                        className: classes.continue,
                        children: translate('continue_label')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Hidden":"kijsg","@mui/material/Fade":"8DwqP","@mui/material/Button":"c6Y0y","../../../select":"k4sBU","../../../transfer-list":"kQWaU","./checklist":"k2Y3t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k2Y3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckList);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _card = require("@mui/material/Card");
var _cardDefault = parcelHelpers.interopDefault(_card);
var _divider = require("@mui/material/Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _cardHeader = require("@mui/material/CardHeader");
var _cardHeaderDefault = parcelHelpers.interopDefault(_cardHeader);
const useStyles = (0, _material.makeStyles)((theme)=>({
        card: {
            flexGrow: 1,
            border: 'solid 1px #b0b0b0',
            boxShadow: 'none',
            overflowY: 'auto',
            height: '100%',
            flexGrow: 1
        }
    }));
function ListElem(props) {
    const { id, label, checked, onClick } = props;
    const labelId = `transfer-list-item-${id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
        role: "listitem",
        button: true,
        onClick: onClick,
        className: props.className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    checked: checked,
                    tabIndex: -1,
                    disableRipple: true,
                    inputProps: {
                        'aria-labelledby': labelId
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                id: labelId,
                primary: label
            })
        ]
    });
}
function CheckList(props) {
    const classes = useStyles();
    const { checklist, selectAllTitle, id = (elem)=>typeof elem == 'object' ? elem.id : elem, label = (elem)=>typeof elem == 'object' ? elem.label : elem, ListItem = ListElem, onChecked } = props;
    const isChecked = (elem)=>checklist.indexOf(id(elem)) >= 0;
    const isNotChecked = (elem)=>checklist.indexOf(id(elem)) < 0;
    const items = props.items.map((item)=>({
            id: id(item),
            checked: isChecked(item),
            item
        }));
    const createItem = ({ id, checked, item })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListItem, {
            id: id,
            label: label(item),
            checked: checked,
            className: (0, _clsxDefault.default)({
                [classes.checked]: checked
            }),
            onClick: ()=>{
                const left = items.filter((i)=>i.id != id && !i.checked).map((i)=>i.item);
                const right = items.filter((i)=>i.id != id && i.checked).map((i)=>i.item);
                if (checked) onChecked({
                    left: [
                        ...left,
                        item
                    ],
                    right
                });
                else onChecked({
                    left,
                    right: [
                        ...right,
                        item
                    ]
                });
            }
        }, id);
    };
    const allChecked = (0, _lodash.every)(items, (item)=>item.checked);
    const noneChecked = (0, _lodash.every)(items, (item)=>!item.checked);
    const someChecked = !allChecked && !noneChecked;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardDefault.default), {
        className: classes.card,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardHeaderDefault.default), {
                className: classes.cardHeader,
                avatar: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    onClick: ()=>{
                        if (noneChecked || someChecked) onChecked({
                            left: [],
                            right: [
                                ...props.items
                            ]
                        });
                        else onChecked({
                            left: [
                                ...props.items
                            ],
                            right: []
                        });
                    },
                    checked: allChecked,
                    indeterminate: someChecked,
                    disabled: items.length === 0,
                    inputProps: {
                        'aria-label': 'all items selected'
                    }
                }),
                title: selectAllTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dividerDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listDefault.default), {
                dense: true,
                component: "div",
                role: "list",
                children: items.map(createItem)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Grid":"ggUwv","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemText":"8IBhx","@mui/material/Checkbox":"4sdMA","@mui/material/Card":"1fzLS","@mui/material/Divider":"5Ykub","@mui/material/CardHeader":"kanB9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lyNoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WriteComments);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _locale = require("date-fns/locale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: '0 20px',
            overflow: 'hidden'
        },
        label: {
            padding: '20px 0'
        },
        comments: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto',
            '& textarea': {
                flexGrow: 1,
                resize: 'none'
            }
        },
        buttons: {
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center'
            }
        },
        cancel: {
            width: '120px',
            marginRight: '20px',
            boxShadow: 'none',
            [theme.breakpoints.down('sm')]: {
                marginRight: '30px'
            }
        },
        send: {
            width: '120px',
            color: '#fff',
            boxShadow: 'none',
            backgroundColor: '#2ca5ec'
        },
        dateDuration: {
            display: 'flex',
            marginTop: 20,
            marginBottom: 20
        },
        dates: {
            display: 'flex'
        },
        datePicker: {
            marginTop: 10,
            marginRight: 20,
            "& .date-input": {
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                padding: 5
            },
            "& svg": {
                marginRight: 5
            }
        },
        durationInput: {
            marginTop: 10,
            marginRight: 20,
            "& input": {
                padding: '3px 5px',
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                fontSize: '1rem',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: '0.00938em'
            }
        },
        duration: {
            display: 'flex'
        }
    }));
function WriteComments(props) {
    const { newComments, context } = props;
    const hours = Math.floor(props.duration / 3600);
    const minutes = Math.floor(props.duration % 3600 / 60);
    const { translate } = context;
    const classes = useStyles();
    const canSave = props.selectedStudents.length > 0 && props.duration > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.dateDuration,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.dates,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "from",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("start")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                            locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                            selected: (0, _momentDefault.default)(props.start).toDate(),
                                            minDate: new Date(),
                                            maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                            showTimeInput: true,
                                            dateFormat: "MM/dd/yyyy h:mm aa",
                                            onChange: props.onStartChange
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "to",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("end")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.datePicker,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                            locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                            selected: (0, _momentDefault.default)(props.finish).toDate(),
                                            minDate: (0, _momentDefault.default)(props.start).toDate(),
                                            maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                            showTimeInput: true,
                                            dateFormat: "MM/dd/yyyy h:mm aa",
                                            timeIntervals: 60,
                                            onChange: props.onFinishChange
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.duration,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "hours",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("hours")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: hours,
                                            onChange: (e)=>{
                                                const value = parseInt(e.target.value);
                                                const hours = isNaN(value) ? 0 : value;
                                                props.onTimeChange({
                                                    hours,
                                                    minutes
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "minutes",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate("minutes")
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: classes.durationInput,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: minutes,
                                            onChange: (e)=>{
                                                const value = parseInt(e.target.value);
                                                const minutes = isNaN(value) ? 0 : value;
                                                props.onTimeChange({
                                                    hours,
                                                    minutes
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.label,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                    children: translate('comment')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.comments,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                    autoFocus: true,
                    value: newComments,
                    onChange: props.onCommentsChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onCancel,
                        variant: "contained",
                        className: classes.cancel,
                        children: translate('cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        onClick: props.onSend,
                        disabled: !canSave,
                        variant: "contained",
                        className: classes.send,
                        children: translate('save_label')
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","date-fns/locale":"dElgW","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Hidden":"kijsg","@mui/material/Typography":"2wCD5","@mui/material/Button":"c6Y0y","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-datepicker/dist/react-datepicker.css":"chsuV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"1PWgo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewBlankPdf);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _html2PdfJs = require("html2pdf.js");
var _html2PdfJsDefault = parcelHelpers.interopDefault(_html2PdfJs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _material = require("external/material");
var _preview = require("./Preview");
var _previewDefault = parcelHelpers.interopDefault(_preview);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _pictureAsPdf = require("@mui/icons-material/PictureAsPdf");
var _pictureAsPdfDefault = parcelHelpers.interopDefault(_pictureAsPdf);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _latinise = require("helpers/latinise");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
const useStyles = (0, _material.makeStyles)(previewStyles);
const useTitleStyles = (0, _material.makeStyles)(titleStyles);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
function PreviewBlankPdf({ context }) {
    const [saving, setSaving] = (0, _reactDefault.default).useState(false);
    const theme = (0, _material.useTheme)();
    const contentRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    const fullScreen = (0, _useMediaQueryDefault.default)(theme.breakpoints.down('md'));
    const { translate, updateState, quizBlankAssessmentForPdfId: assessmentId, quizBlankAssessmentForPdf: assessment } = context;
    const title = assessment.content && assessment.content.title || translate('assessment');
    const classes = useStyles();
    const titleClasses = useTitleStyles();
    const dialogClasses = useDialogStyles();
    const isOpen = assessmentId != undefined && assessment.id != undefined && assessmentId == assessment.assessmentId;
    function close() {
        updateState({
            quizBlankAssessmentForPdf: {
                $set: {}
            },
            quizBlankAssessmentForPdfId: {
                $set: undefined
            }
        });
    }
    async function savePdf() {
        if (!contentRef.current) return;
        if (saving) return;
        const filename = `${(0, _latinise.latinise)(title).replace(' ', '_')}.pdf`;
        setSaving(true);
        const document = await (0, _html2PdfJsDefault.default)().from(contentRef.current).set({
            image: {
                type: 'png'
            },
            margin: 0.8,
            jsPDF: {
                unit: 'in',
                format: 'letter',
                orientation: 'portrait'
            },
            pagebreak: {
                mode: [
                    'css',
                    'avoid-all'
                ]
            }
        }).toPdf().get('pdf').then(processPdf).save(filename);
        setSaving(false);
    }
    function processPdf(pdf) {
        const totalPages = pdf.internal.getNumberOfPages();
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        const addText = (text, x, y, align = 'left', size = 10, color = '#ccc')=>{
            pdf.setFontSize(size);
            pdf.setTextColor(color);
            pdf.text(text, x, y, {
                align: 'right'
            });
        };
        for(let i = 1; i <= totalPages; i++){
            pdf.setPage(i);
            addText(`${title}`, width - 0.5, 0.5, 'right', 11, '#000');
            addText(`${i} / ${totalPages}`, width - 0.5, height - 0.5, 'right');
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        fullScreen: fullScreen,
        open: isOpen,
        onClose: (e)=>close(),
        classes: dialogClasses,
        "aria-labelledby": "blank-assessment-pdf-dialog-title",
        maxWidth: "lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                id: "blank-assessment-pdf-dialog-title",
                classes: titleClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.close,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            onClick: close,
                            size: "large",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                className: classes.contentWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.content,
                    ref: contentRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewDefault.default), {
                        assessment,
                        context
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), {
                className: classes.actions,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    onClick: savePdf,
                    className: (0, _clsxDefault.default)(classes.button, classes.save),
                    disabled: saving,
                    children: [
                        !saving && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pictureAsPdfDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "label",
                                    children: translate('download')
                                })
                            ]
                        }),
                        saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "icon",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faSpinner),
                                spin: true
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function dialogStyles(theme) {
    return {
        paper: {
            width: '100%',
            padding: 0,
            height: 'calc(100% - 100px)'
        }
    };
}
function titleStyles(theme) {
    return {
        root: {
            display: 'flex',
            padding: '10px 10px 10px 24px',
            fontSize: '14pt',
            fontWeight: 'bold',
            borderBottom: 'solid 1px #f3f3f3',
            color: '#525b6c',
            background: '#fdfdfd'
        }
    };
}
function previewStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        close: {
            ...verticalCentering,
            color: '#69738',
            padding: 0,
            "& svg": {
                fontSize: '14pt'
            }
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {},
            '& .icon': {
                marginTop: -1,
                marginRight: 4,
                fontSize: '8pt'
            }
        },
        contentWrapper: {
            marginTop: 5
        },
        content: {
            display: 'flex'
        },
        actions: {
            padding: 24
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","moment":"1e4qG","html2pdf.js":"27lym","react":"9njXz","@mui/material/Button":"c6Y0y","@mui/material/Dialog":"255tO","@mui/material/DialogTitle":"5sOv1","@mui/material/DialogActions":"5WZHz","@mui/material/DialogContent":"gD0J9","external/material":"6yEDE","./Preview":"8N9g4","@mui/material/Box":"73kto","@mui/material/IconButton":"bXjnZ","@mui/icons-material/Close":"acjz6","@mui/icons-material/PictureAsPdf":"as9ed","@mui/material/useMediaQuery":"bnRpi","helpers/latinise":"1YzXG","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"27lym":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var process = require("1553fa0bbb51bb94");
/**
 * html2pdf.js v0.9.3
 * Copyright (c) 2021 Erik Koopmans
 * Released under the MIT License.
 */ (function(global, factory) {
    module.exports = factory(require("891c8385c9547d2c"), require("3af49d75da587f8"));
})(this, function(jsPDF, html2canvas) {
    'use strict';
    jsPDF = jsPDF && jsPDF.hasOwnProperty('default') ? jsPDF['default'] : jsPDF;
    html2canvas = html2canvas && html2canvas.hasOwnProperty('default') ? html2canvas['default'] : html2canvas;
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    // Determine the type of a variable/object.
    var objType = function objType(obj) {
        var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
        if (type === 'undefined') return 'undefined';
        else if (type === 'string' || obj instanceof String) return 'string';
        else if (type === 'number' || obj instanceof Number) return 'number';
        else if (type === 'function' || obj instanceof Function) return 'function';
        else if (!!obj && obj.constructor === Array) return 'array';
        else if (obj && obj.nodeType === 1) return 'element';
        else if (type === 'object') return 'object';
        else return 'unknown';
    };
    // Create an HTML element with optional className, innerHTML, and style.
    var createElement = function createElement(tagName, opt) {
        var el = document.createElement(tagName);
        if (opt.className) el.className = opt.className;
        if (opt.innerHTML) {
            el.innerHTML = opt.innerHTML;
            var scripts = el.getElementsByTagName('script');
            for(var i = scripts.length; i-- > 0;)scripts[i].parentNode.removeChild(scripts[i]);
        }
        for(var key in opt.style)el.style[key] = opt.style[key];
        return el;
    };
    // Deep-clone a node and preserve contents/properties.
    var cloneNode = function cloneNode(node, javascriptEnabled) {
        // Recursively clone the node.
        var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);
        for(var child = node.firstChild; child; child = child.nextSibling)if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT') clone.appendChild(cloneNode(child, javascriptEnabled));
        if (node.nodeType === 1) {
            // Preserve contents/properties of special nodes.
            if (node.nodeName === 'CANVAS') {
                clone.width = node.width;
                clone.height = node.height;
                clone.getContext('2d').drawImage(node, 0, 0);
            } else if (node.nodeName === 'TEXTAREA' || node.nodeName === 'SELECT') clone.value = node.value;
            // Preserve the node's scroll position when it loads.
            clone.addEventListener('load', function() {
                clone.scrollTop = node.scrollTop;
                clone.scrollLeft = node.scrollLeft;
            }, true);
        }
        // Return the cloned node.
        return clone;
    };
    // Convert units from px using the conversion value 'k' from jsPDF.
    var unitConvert = function unitConvert(obj, k) {
        if (objType(obj) === 'number') return obj * 72 / 96 / k;
        else {
            var newObj = {};
            for(var key in obj)newObj[key] = obj[key] * 72 / 96 / k;
            return newObj;
        }
    };
    // Convert units to px using the conversion value 'k' from jsPDF.
    var toPx = function toPx(val, k) {
        return Math.floor(val * k / 72 * 96);
    };
    var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
    function commonjsRequire() {
        throw new Error('Dynamic requires are not currently supported by rollup-plugin-commonjs');
    }
    function createCommonjsModule(fn, module1) {
        return module1 = {
            exports: {}
        }, fn(module1, module1.exports), module1.exports;
    }
    var es6Promise = createCommonjsModule(function(module1, exports) {
        /*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.5+7f2b526d
 */ (function(global, factory) {
            module1.exports = factory();
        })(commonjsGlobal, function() {
            function objectOrFunction(x) {
                var type = typeof x;
                return x !== null && (type === 'object' || type === 'function');
            }
            function isFunction(x) {
                return typeof x === 'function';
            }
            var _isArray = void 0;
            if (Array.isArray) _isArray = Array.isArray;
            else _isArray = function(x) {
                return Object.prototype.toString.call(x) === '[object Array]';
            };
            var isArray = _isArray;
            var len = 0;
            var vertxNext = void 0;
            var customSchedulerFn = void 0;
            var asap = function asap(callback, arg) {
                queue[len] = callback;
                queue[len + 1] = arg;
                len += 2;
                if (len === 2) {
                    // If len is 2, that means that we need to schedule an async flush.
                    // If additional callbacks are queued before the queue is flushed, they
                    // will be processed by this flush that we are scheduling.
                    if (customSchedulerFn) customSchedulerFn(flush);
                    else scheduleFlush();
                }
            };
            function setScheduler(scheduleFn) {
                customSchedulerFn = scheduleFn;
            }
            function setAsap(asapFn) {
                asap = asapFn;
            }
            var browserWindow = typeof window !== 'undefined' ? window : undefined;
            var browserGlobal = browserWindow || {};
            var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
            var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';
            // test for web worker but not in IE10
            var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
            // node
            function useNextTick() {
                // node version 0.10.x displays a deprecation warning when nextTick is used recursively
                // see https://github.com/cujojs/when/issues/410 for details
                return function() {
                    return process.nextTick(flush);
                };
            }
            // vertx
            function useVertxTimer() {
                if (typeof vertxNext !== 'undefined') return function() {
                    vertxNext(flush);
                };
                return useSetTimeout();
            }
            function useMutationObserver() {
                var iterations = 0;
                var observer = new BrowserMutationObserver(flush);
                var node = document.createTextNode('');
                observer.observe(node, {
                    characterData: true
                });
                return function() {
                    node.data = iterations = ++iterations % 2;
                };
            }
            // web worker
            function useMessageChannel() {
                var channel = new MessageChannel();
                channel.port1.onmessage = flush;
                return function() {
                    return channel.port2.postMessage(0);
                };
            }
            function useSetTimeout() {
                // Store setTimeout reference so es6-promise will be unaffected by
                // other code modifying setTimeout (like sinon.useFakeTimers())
                var globalSetTimeout = setTimeout;
                return function() {
                    return globalSetTimeout(flush, 1);
                };
            }
            var queue = new Array(1000);
            function flush() {
                for(var i = 0; i < len; i += 2){
                    var callback = queue[i];
                    var arg = queue[i + 1];
                    callback(arg);
                    queue[i] = undefined;
                    queue[i + 1] = undefined;
                }
                len = 0;
            }
            function attemptVertx() {
                try {
                    var vertx = Function('return this')().require('vertx');
                    vertxNext = vertx.runOnLoop || vertx.runOnContext;
                    return useVertxTimer();
                } catch (e) {
                    return useSetTimeout();
                }
            }
            var scheduleFlush = void 0;
            // Decide what async method to use to triggering processing of queued callbacks:
            if (isNode) scheduleFlush = useNextTick();
            else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
            else if (isWorker) scheduleFlush = useMessageChannel();
            else if (browserWindow === undefined && typeof commonjsRequire === 'function') scheduleFlush = attemptVertx();
            else scheduleFlush = useSetTimeout();
            function then(onFulfillment, onRejection) {
                var parent = this;
                var child = new this.constructor(noop);
                if (child[PROMISE_ID] === undefined) makePromise(child);
                var _state = parent._state;
                if (_state) {
                    var callback = arguments[_state - 1];
                    asap(function() {
                        return invokeCallback(_state, child, callback, parent._result);
                    });
                } else subscribe(parent, child, onFulfillment, onRejection);
                return child;
            }
            /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
                /*jshint validthis:true */ var Constructor = this;
                if (object && typeof object === 'object' && object.constructor === Constructor) return object;
                var promise = new Constructor(noop);
                resolve(promise, object);
                return promise;
            }
            var PROMISE_ID = Math.random().toString(36).substring(2);
            function noop() {}
            var PENDING = void 0;
            var FULFILLED = 1;
            var REJECTED = 2;
            var TRY_CATCH_ERROR = {
                error: null
            };
            function selfFulfillment() {
                return new TypeError("You cannot resolve a promise with itself");
            }
            function cannotReturnOwn() {
                return new TypeError('A promises callback cannot return that same promise.');
            }
            function getThen(promise) {
                try {
                    return promise.then;
                } catch (error) {
                    TRY_CATCH_ERROR.error = error;
                    return TRY_CATCH_ERROR;
                }
            }
            function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
                try {
                    then$$1.call(value, fulfillmentHandler, rejectionHandler);
                } catch (e) {
                    return e;
                }
            }
            function handleForeignThenable(promise, thenable, then$$1) {
                asap(function(promise) {
                    var sealed = false;
                    var error = tryThen(then$$1, thenable, function(value) {
                        if (sealed) return;
                        sealed = true;
                        if (thenable !== value) resolve(promise, value);
                        else fulfill(promise, value);
                    }, function(reason) {
                        if (sealed) return;
                        sealed = true;
                        reject(promise, reason);
                    }, 'Settle: ' + (promise._label || ' unknown promise'));
                    if (!sealed && error) {
                        sealed = true;
                        reject(promise, error);
                    }
                }, promise);
            }
            function handleOwnThenable(promise, thenable) {
                if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
                else if (thenable._state === REJECTED) reject(promise, thenable._result);
                else subscribe(thenable, undefined, function(value) {
                    return resolve(promise, value);
                }, function(reason) {
                    return reject(promise, reason);
                });
            }
            function handleMaybeThenable(promise, maybeThenable, then$$1) {
                if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
                else {
                    if (then$$1 === TRY_CATCH_ERROR) {
                        reject(promise, TRY_CATCH_ERROR.error);
                        TRY_CATCH_ERROR.error = null;
                    } else if (then$$1 === undefined) fulfill(promise, maybeThenable);
                    else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
                    else fulfill(promise, maybeThenable);
                }
            }
            function resolve(promise, value) {
                if (promise === value) reject(promise, selfFulfillment());
                else if (objectOrFunction(value)) handleMaybeThenable(promise, value, getThen(value));
                else fulfill(promise, value);
            }
            function publishRejection(promise) {
                if (promise._onerror) promise._onerror(promise._result);
                publish(promise);
            }
            function fulfill(promise, value) {
                if (promise._state !== PENDING) return;
                promise._result = value;
                promise._state = FULFILLED;
                if (promise._subscribers.length !== 0) asap(publish, promise);
            }
            function reject(promise, reason) {
                if (promise._state !== PENDING) return;
                promise._state = REJECTED;
                promise._result = reason;
                asap(publishRejection, promise);
            }
            function subscribe(parent, child, onFulfillment, onRejection) {
                var _subscribers = parent._subscribers;
                var length = _subscribers.length;
                parent._onerror = null;
                _subscribers[length] = child;
                _subscribers[length + FULFILLED] = onFulfillment;
                _subscribers[length + REJECTED] = onRejection;
                if (length === 0 && parent._state) asap(publish, parent);
            }
            function publish(promise) {
                var subscribers = promise._subscribers;
                var settled = promise._state;
                if (subscribers.length === 0) return;
                var child = void 0, callback = void 0, detail = promise._result;
                for(var i = 0; i < subscribers.length; i += 3){
                    child = subscribers[i];
                    callback = subscribers[i + settled];
                    if (child) invokeCallback(settled, child, callback, detail);
                    else callback(detail);
                }
                promise._subscribers.length = 0;
            }
            function tryCatch(callback, detail) {
                try {
                    return callback(detail);
                } catch (e) {
                    TRY_CATCH_ERROR.error = e;
                    return TRY_CATCH_ERROR;
                }
            }
            function invokeCallback(settled, promise, callback, detail) {
                var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = void 0, failed = void 0;
                if (hasCallback) {
                    value = tryCatch(callback, detail);
                    if (value === TRY_CATCH_ERROR) {
                        failed = true;
                        error = value.error;
                        value.error = null;
                    } else succeeded = true;
                    if (promise === value) {
                        reject(promise, cannotReturnOwn());
                        return;
                    }
                } else {
                    value = detail;
                    succeeded = true;
                }
                if (promise._state !== PENDING) ;
                else if (hasCallback && succeeded) resolve(promise, value);
                else if (failed) reject(promise, error);
                else if (settled === FULFILLED) fulfill(promise, value);
                else if (settled === REJECTED) reject(promise, value);
            }
            function initializePromise(promise, resolver) {
                try {
                    resolver(function resolvePromise(value) {
                        resolve(promise, value);
                    }, function rejectPromise(reason) {
                        reject(promise, reason);
                    });
                } catch (e) {
                    reject(promise, e);
                }
            }
            var id = 0;
            function nextId() {
                return id++;
            }
            function makePromise(promise) {
                promise[PROMISE_ID] = id++;
                promise._state = undefined;
                promise._result = undefined;
                promise._subscribers = [];
            }
            function validationError() {
                return new Error('Array Methods must be provided an Array');
            }
            var Enumerator = function() {
                function Enumerator(Constructor, input) {
                    this._instanceConstructor = Constructor;
                    this.promise = new Constructor(noop);
                    if (!this.promise[PROMISE_ID]) makePromise(this.promise);
                    if (isArray(input)) {
                        this.length = input.length;
                        this._remaining = input.length;
                        this._result = new Array(this.length);
                        if (this.length === 0) fulfill(this.promise, this._result);
                        else {
                            this.length = this.length || 0;
                            this._enumerate(input);
                            if (this._remaining === 0) fulfill(this.promise, this._result);
                        }
                    } else reject(this.promise, validationError());
                }
                Enumerator.prototype._enumerate = function _enumerate(input) {
                    for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
                };
                Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
                    var c = this._instanceConstructor;
                    var resolve$$1 = c.resolve;
                    if (resolve$$1 === resolve$1) {
                        var _then = getThen(entry);
                        if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                        else if (typeof _then !== 'function') {
                            this._remaining--;
                            this._result[i] = entry;
                        } else if (c === Promise$1) {
                            var promise = new c(noop);
                            handleMaybeThenable(promise, entry, _then);
                            this._willSettleAt(promise, i);
                        } else this._willSettleAt(new c(function(resolve$$1) {
                            return resolve$$1(entry);
                        }), i);
                    } else this._willSettleAt(resolve$$1(entry), i);
                };
                Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
                    var promise = this.promise;
                    if (promise._state === PENDING) {
                        this._remaining--;
                        if (state === REJECTED) reject(promise, value);
                        else this._result[i] = value;
                    }
                    if (this._remaining === 0) fulfill(promise, this._result);
                };
                Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
                    var enumerator = this;
                    subscribe(promise, undefined, function(value) {
                        return enumerator._settledAt(FULFILLED, i, value);
                    }, function(reason) {
                        return enumerator._settledAt(REJECTED, i, reason);
                    });
                };
                return Enumerator;
            }();
            /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
                return new Enumerator(this, entries).promise;
            }
            /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
                /*jshint validthis:true */ var Constructor = this;
                if (!isArray(entries)) return new Constructor(function(_, reject) {
                    return reject(new TypeError('You must pass an array to race.'));
                });
                else return new Constructor(function(resolve, reject) {
                    var length = entries.length;
                    for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
                });
            }
            /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
                /*jshint validthis:true */ var Constructor = this;
                var promise = new Constructor(noop);
                reject(promise, reason);
                return promise;
            }
            function needsResolver() {
                throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
            }
            function needsNew() {
                throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
            }
            /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
                function Promise(resolver) {
                    this[PROMISE_ID] = nextId();
                    this._result = this._state = undefined;
                    this._subscribers = [];
                    if (noop !== resolver) {
                        typeof resolver !== 'function' && needsResolver();
                        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
                    }
                }
                /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
                    return this.then(null, onRejection);
                };
                /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
                    var promise = this;
                    var constructor = promise.constructor;
                    if (isFunction(callback)) return promise.then(function(value) {
                        return constructor.resolve(callback()).then(function() {
                            return value;
                        });
                    }, function(reason) {
                        return constructor.resolve(callback()).then(function() {
                            throw reason;
                        });
                    });
                    return promise.then(callback, callback);
                };
                return Promise;
            }();
            Promise$1.prototype.then = then;
            Promise$1.all = all;
            Promise$1.race = race;
            Promise$1.resolve = resolve$1;
            Promise$1.reject = reject$1;
            Promise$1._setScheduler = setScheduler;
            Promise$1._setAsap = setAsap;
            Promise$1._asap = asap;
            /*global self*/ function polyfill() {
                var local = void 0;
                if (typeof commonjsGlobal !== 'undefined') local = commonjsGlobal;
                else if (typeof self !== 'undefined') local = self;
                else try {
                    local = Function('return this')();
                } catch (e) {
                    throw new Error('polyfill failed because global object is unavailable in this environment');
                }
                var P = local.Promise;
                if (P) {
                    var promiseToString = null;
                    try {
                        promiseToString = Object.prototype.toString.call(P.resolve());
                    } catch (e) {
                    // silently ignored
                    }
                    if (promiseToString === '[object Promise]' && !P.cast) return;
                }
                local.Promise = Promise$1;
            }
            // Strange compat..
            Promise$1.polyfill = polyfill;
            Promise$1.Promise = Promise$1;
            return Promise$1;
        });
    });
    var Promise$1 = es6Promise.Promise;
    /* ----- CONSTRUCTOR ----- */ var Worker = function Worker(opt) {
        // Create the root parent for the proto chain, and the starting Worker.
        var root = _extends(Worker.convert(Promise$1.resolve()), JSON.parse(JSON.stringify(Worker.template)));
        var self1 = Worker.convert(Promise$1.resolve(), root);
        // Set progress, optional settings, and return.
        self1 = self1.setProgress(1, Worker, 1, [
            Worker
        ]);
        self1 = self1.set(opt);
        return self1;
    };
    // Boilerplate for subclassing Promise.
    Worker.prototype = Object.create(Promise$1.prototype);
    Worker.prototype.constructor = Worker;
    // Converts/casts promises into Workers.
    Worker.convert = function convert(promise, inherit) {
        // Uses prototypal inheritance to receive changes made to ancestors' properties.
        promise.__proto__ = inherit || Worker.prototype;
        return promise;
    };
    Worker.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: 'file.pdf',
            margin: [
                0,
                0,
                0,
                0
            ],
            image: {
                type: 'jpeg',
                quality: 0.95
            },
            enableLinks: true,
            html2canvas: {},
            jsPDF: {}
        }
    };
    /* ----- FROM / TO ----- */ Worker.prototype.from = function from(src, type) {
        function getType(src) {
            switch(objType(src)){
                case 'string':
                    return 'string';
                case 'element':
                    return src.nodeName.toLowerCase === 'canvas' ? 'canvas' : 'element';
                default:
                    return 'unknown';
            }
        }
        return this.then(function from_main() {
            type = type || getType(src);
            switch(type){
                case 'string':
                    return this.set({
                        src: createElement('div', {
                            innerHTML: src
                        })
                    });
                case 'element':
                    return this.set({
                        src: src
                    });
                case 'canvas':
                    return this.set({
                        canvas: src
                    });
                case 'img':
                    return this.set({
                        img: src
                    });
                default:
                    return this.error('Unknown source type.');
            }
        });
    };
    Worker.prototype.to = function to(target) {
        // Route the 'to' request to the appropriate method.
        switch(target){
            case 'container':
                return this.toContainer();
            case 'canvas':
                return this.toCanvas();
            case 'img':
                return this.toImg();
            case 'pdf':
                return this.toPdf();
            default:
                return this.error('Invalid target.');
        }
    };
    Worker.prototype.toContainer = function toContainer() {
        // Set up function prerequisites.
        var prereqs = [
            function checkSrc() {
                return this.prop.src || this.error('Cannot duplicate - no source HTML.');
            },
            function checkPageSize() {
                return this.prop.pageSize || this.setPageSize();
            }
        ];
        return this.thenList(prereqs).then(function toContainer_main() {
            // Define the CSS styles for the container and its overlay parent.
            var overlayCSS = {
                position: 'fixed',
                overflow: 'hidden',
                zIndex: 1000,
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                backgroundColor: 'rgba(0,0,0,0.8)'
            };
            var containerCSS = {
                position: 'absolute',
                width: this.prop.pageSize.inner.width + this.prop.pageSize.unit,
                left: 0,
                right: 0,
                top: 0,
                height: 'auto',
                margin: 'auto',
                backgroundColor: 'white'
            };
            // Set the overlay to hidden (could be changed in the future to provide a print preview).
            overlayCSS.opacity = 0;
            // Create and attach the elements.
            var source = cloneNode(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            this.prop.overlay = createElement('div', {
                className: 'html2pdf__overlay',
                style: overlayCSS
            });
            this.prop.container = createElement('div', {
                className: 'html2pdf__container',
                style: containerCSS
            });
            this.prop.container.appendChild(source);
            this.prop.overlay.appendChild(this.prop.container);
            document.body.appendChild(this.prop.overlay);
        });
    };
    Worker.prototype.toCanvas = function toCanvas() {
        // Set up function prerequisites.
        var prereqs = [
            function checkContainer() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        // Fulfill prereqs then create the canvas.
        return this.thenList(prereqs).then(function toCanvas_main() {
            // Handle old-fashioned 'onrendered' argument.
            var options = _extends({}, this.opt.html2canvas);
            delete options.onrendered;
            return html2canvas(this.prop.container, options);
        }).then(function toCanvas_post(canvas) {
            // Handle old-fashioned 'onrendered' argument.
            var onRendered = this.opt.html2canvas.onrendered || function() {};
            onRendered(canvas);
            this.prop.canvas = canvas;
            document.body.removeChild(this.prop.overlay);
        });
    };
    Worker.prototype.toImg = function toImg() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toImg_main() {
            var imgData = this.prop.canvas.toDataURL('image/' + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement('img');
            this.prop.img.src = imgData;
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        // Set up function prerequisites.
        var prereqs = [
            function checkCanvas() {
                return this.prop.canvas || this.toCanvas();
            }
        ];
        // Fulfill prereqs then create the image.
        return this.thenList(prereqs).then(function toPdf_main() {
            // Create local copies of frequently used properties.
            var canvas = this.prop.canvas;
            var opt = this.opt;
            // Calculate the number of pages.
            var pxFullHeight = canvas.height;
            var pxPageHeight = Math.floor(canvas.width * this.prop.pageSize.inner.ratio);
            var nPages = Math.ceil(pxFullHeight / pxPageHeight);
            // Define pageHeight separately so it can be trimmed on the final page.
            var pageHeight = this.prop.pageSize.inner.height;
            // Create a one-page canvas to split up the full image.
            var pageCanvas = document.createElement('canvas');
            var pageCtx = pageCanvas.getContext('2d');
            pageCanvas.width = canvas.width;
            pageCanvas.height = pxPageHeight;
            // Initialize the PDF.
            this.prop.pdf = this.prop.pdf || new jsPDF(opt.jsPDF);
            for(var page = 0; page < nPages; page++){
                // Trim the final page to reduce file size.
                if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
                    pageCanvas.height = pxFullHeight % pxPageHeight;
                    pageHeight = pageCanvas.height * this.prop.pageSize.inner.width / pageCanvas.width;
                }
                // Display the page.
                var w = pageCanvas.width;
                var h = pageCanvas.height;
                pageCtx.fillStyle = 'white';
                pageCtx.fillRect(0, 0, w, h);
                pageCtx.drawImage(canvas, 0, page * pxPageHeight, w, h, 0, 0, w, h);
                // Add the page to the PDF.
                if (page) this.prop.pdf.addPage();
                var imgData = pageCanvas.toDataURL('image/' + opt.image.type, opt.image.quality);
                this.prop.pdf.addImage(imgData, opt.image.type, opt.margin[1], opt.margin[0], this.prop.pageSize.inner.width, pageHeight);
            }
        });
    };
    /* ----- OUTPUT / SAVE ----- */ Worker.prototype.output = function output(type, options, src) {
        // Redirect requests to the correct function (outputPdf / outputImg).
        src = src || 'pdf';
        if (src.toLowerCase() === 'img' || src.toLowerCase() === 'image') return this.outputImg(type, options);
        else return this.outputPdf(type, options);
    };
    Worker.prototype.outputPdf = function outputPdf(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputPdf_main() {
            /* Currently implemented output types:
     *    https://rawgit.com/MrRio/jsPDF/master/docs/jspdf.js.html#line992
     *  save(options), arraybuffer, blob, bloburi/bloburl,
     *  datauristring/dataurlstring, dataurlnewwindow, datauri/dataurl
     */ return this.prop.pdf.output(type, options);
        });
    };
    Worker.prototype.outputImg = function outputImg(type, options) {
        // Set up function prerequisites.
        var prereqs = [
            function checkImg() {
                return this.prop.img || this.toImg();
            }
        ];
        // Fulfill prereqs then perform the appropriate output.
        return this.thenList(prereqs).then(function outputImg_main() {
            switch(type){
                case undefined:
                case 'img':
                    return this.prop.img;
                case 'datauristring':
                case 'dataurlstring':
                    return this.prop.img.src;
                case 'datauri':
                case 'dataurl':
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + type + '" is not supported.';
            }
        });
    };
    Worker.prototype.save = function save(filename) {
        // Set up function prerequisites.
        var prereqs = [
            function checkPdf() {
                return this.prop.pdf || this.toPdf();
            }
        ];
        // Fulfill prereqs, update the filename (if provided), and save the PDF.
        return this.thenList(prereqs).set(filename ? {
            filename: filename
        } : null).then(function save_main() {
            this.prop.pdf.save(this.opt.filename);
        });
    };
    /* ----- SET / GET ----- */ Worker.prototype.set = function set$$1(opt) {
        // TODO: Implement ordered pairs?
        // Silently ignore invalid or empty input.
        if (objType(opt) !== 'object') return this;
        // Build an array of setter functions to queue.
        var fns = Object.keys(opt || {}).map(function(key) {
            if (key in Worker.template.prop) // Set pre-defined properties.
            return function set_prop() {
                this.prop[key] = opt[key];
            };
            else switch(key){
                case 'margin':
                    return this.setMargin.bind(this, opt.margin);
                case 'jsPDF':
                    return function set_jsPDF() {
                        this.opt.jsPDF = opt.jsPDF;
                        return this.setPageSize();
                    };
                case 'pageSize':
                    return this.setPageSize.bind(this, opt.pageSize);
                default:
                    // Set any other properties in opt.
                    return function set_opt() {
                        this.opt[key] = opt[key];
                    };
            }
        }, this);
        // Set properties within the promise chain.
        return this.then(function set_main() {
            return this.thenList(fns);
        });
    };
    Worker.prototype.get = function get$$1(key, cbk) {
        return this.then(function get_main() {
            // Fetch the requested property, either as a predefined prop or in opt.
            var val = key in Worker.template.prop ? this.prop[key] : this.opt[key];
            return cbk ? cbk(val) : val;
        });
    };
    Worker.prototype.setMargin = function setMargin(margin) {
        return this.then(function setMargin_main() {
            // Parse the margin property: [top, left, bottom, right].
            switch(objType(margin)){
                case 'number':
                    margin = [
                        margin,
                        margin,
                        margin,
                        margin
                    ];
                case 'array':
                    if (margin.length === 2) margin = [
                        margin[0],
                        margin[1],
                        margin[0],
                        margin[1]
                    ];
                    if (margin.length === 4) break;
                default:
                    return this.error('Invalid margin array.');
            }
            // Set the margin property, then update pageSize.
            this.opt.margin = margin;
        }).then(this.setPageSize);
    };
    Worker.prototype.setPageSize = function setPageSize(pageSize) {
        return this.then(function setPageSize_main() {
            // Retrieve page-size based on jsPDF settings, if not explicitly provided.
            pageSize = pageSize || jsPDF.getPageSize(this.opt.jsPDF);
            // Add 'inner' field if not present.
            if (!pageSize.hasOwnProperty('inner')) {
                pageSize.inner = {
                    width: pageSize.width - this.opt.margin[1] - this.opt.margin[3],
                    height: pageSize.height - this.opt.margin[0] - this.opt.margin[2]
                };
                pageSize.inner.px = {
                    width: toPx(pageSize.inner.width, pageSize.k),
                    height: toPx(pageSize.inner.height, pageSize.k)
                };
                pageSize.inner.ratio = pageSize.inner.height / pageSize.inner.width;
            }
            // Attach pageSize to this.
            this.prop.pageSize = pageSize;
        });
    };
    Worker.prototype.setProgress = function setProgress(val, state, n, stack) {
        // Immediately update all progress values.
        if (val != null) this.progress.val = val;
        if (state != null) this.progress.state = state;
        if (n != null) this.progress.n = n;
        if (stack != null) this.progress.stack = stack;
        this.progress.ratio = this.progress.val / this.progress.state;
        // Return this for command chaining.
        return this;
    };
    Worker.prototype.updateProgress = function updateProgress(val, state, n, stack) {
        // Immediately update all progress values, using setProgress.
        return this.setProgress(val ? this.progress.val + val : null, state ? state : null, n ? this.progress.n + n : null, stack ? this.progress.stack.concat(stack) : null);
    };
    /* ----- PROMISE MAPPING ----- */ Worker.prototype.then = function then(onFulfilled, onRejected) {
        // Wrap `this` for encapsulation.
        var self1 = this;
        return this.thenCore(onFulfilled, onRejected, function then_main(onFulfilled, onRejected) {
            // Update progress while queuing, calling, and resolving `then`.
            self1.updateProgress(null, null, 1, [
                onFulfilled
            ]);
            return Promise$1.prototype.then.call(this, function then_pre(val) {
                self1.updateProgress(null, onFulfilled);
                return val;
            }).then(onFulfilled, onRejected).then(function then_post(val) {
                self1.updateProgress(1);
                return val;
            });
        });
    };
    Worker.prototype.thenCore = function thenCore(onFulfilled, onRejected, thenBase) {
        // Handle optional thenBase parameter.
        thenBase = thenBase || Promise$1.prototype.then;
        // Wrap `this` for encapsulation and bind it to the promise handlers.
        var self1 = this;
        if (onFulfilled) onFulfilled = onFulfilled.bind(self1);
        if (onRejected) onRejected = onRejected.bind(self1);
        // Cast self into a Promise to avoid polyfills recursively defining `then`.
        var isNative = Promise$1.toString().indexOf('[native code]') !== -1 && Promise$1.name === 'Promise';
        var selfPromise = isNative ? self1 : Worker.convert(_extends({}, self1), Promise$1.prototype);
        // Return the promise, after casting it into a Worker and preserving props.
        var returnVal = thenBase.call(selfPromise, onFulfilled, onRejected);
        return Worker.convert(returnVal, self1.__proto__);
    };
    Worker.prototype.thenExternal = function thenExternal(onFulfilled, onRejected) {
        // Call `then` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype.then.call(this, onFulfilled, onRejected);
    };
    Worker.prototype.thenList = function thenList(fns) {
        // Queue a series of promise 'factories' into the promise chain.
        var self1 = this;
        fns.forEach(function thenList_forEach(fn) {
            self1 = self1.thenCore(fn);
        });
        return self1;
    };
    Worker.prototype['catch'] = function(onRejected) {
        // Bind `this` to the promise handler, call `catch`, and return a Worker.
        if (onRejected) onRejected = onRejected.bind(this);
        var returnVal = Promise$1.prototype['catch'].call(this, onRejected);
        return Worker.convert(returnVal, this);
    };
    Worker.prototype.catchExternal = function catchExternal(onRejected) {
        // Call `catch` and return a standard promise (exits the Worker chain).
        return Promise$1.prototype['catch'].call(this, onRejected);
    };
    Worker.prototype.error = function error(msg) {
        // Throw the error in the Promise chain.
        return this.then(function error_main() {
            throw new Error(msg);
        });
    };
    /* ----- ALIASES ----- */ Worker.prototype.using = Worker.prototype.set;
    Worker.prototype.saveAs = Worker.prototype.save;
    Worker.prototype.export = Worker.prototype.output;
    Worker.prototype.run = Worker.prototype.then;
    // Import dependencies.
    // Get dimensions of a PDF page, as determined by jsPDF.
    jsPDF.getPageSize = function(orientation, unit, format) {
        // Decode options object
        if ((typeof orientation === 'undefined' ? 'undefined' : _typeof(orientation)) === 'object') {
            var options = orientation;
            orientation = options.orientation;
            unit = options.unit || unit;
            format = options.format || format;
        }
        // Default options
        unit = unit || 'mm';
        format = format || 'a4';
        orientation = ('' + (orientation || 'P')).toLowerCase();
        var format_as_string = ('' + format).toLowerCase();
        // Size in pt of various paper formats
        var pageFormats = {
            'a0': [
                2383.94,
                3370.39
            ],
            'a1': [
                1683.78,
                2383.94
            ],
            'a2': [
                1190.55,
                1683.78
            ],
            'a3': [
                841.89,
                1190.55
            ],
            'a4': [
                595.28,
                841.89
            ],
            'a5': [
                419.53,
                595.28
            ],
            'a6': [
                297.64,
                419.53
            ],
            'a7': [
                209.76,
                297.64
            ],
            'a8': [
                147.40,
                209.76
            ],
            'a9': [
                104.88,
                147.40
            ],
            'a10': [
                73.70,
                104.88
            ],
            'b0': [
                2834.65,
                4008.19
            ],
            'b1': [
                2004.09,
                2834.65
            ],
            'b2': [
                1417.32,
                2004.09
            ],
            'b3': [
                1000.63,
                1417.32
            ],
            'b4': [
                708.66,
                1000.63
            ],
            'b5': [
                498.90,
                708.66
            ],
            'b6': [
                354.33,
                498.90
            ],
            'b7': [
                249.45,
                354.33
            ],
            'b8': [
                175.75,
                249.45
            ],
            'b9': [
                124.72,
                175.75
            ],
            'b10': [
                87.87,
                124.72
            ],
            'c0': [
                2599.37,
                3676.54
            ],
            'c1': [
                1836.85,
                2599.37
            ],
            'c2': [
                1298.27,
                1836.85
            ],
            'c3': [
                918.43,
                1298.27
            ],
            'c4': [
                649.13,
                918.43
            ],
            'c5': [
                459.21,
                649.13
            ],
            'c6': [
                323.15,
                459.21
            ],
            'c7': [
                229.61,
                323.15
            ],
            'c8': [
                161.57,
                229.61
            ],
            'c9': [
                113.39,
                161.57
            ],
            'c10': [
                79.37,
                113.39
            ],
            'dl': [
                311.81,
                623.62
            ],
            'letter': [
                612,
                792
            ],
            'government-letter': [
                576,
                756
            ],
            'legal': [
                612,
                1008
            ],
            'junior-legal': [
                576,
                360
            ],
            'ledger': [
                1224,
                792
            ],
            'tabloid': [
                792,
                1224
            ],
            'credit-card': [
                153,
                243
            ]
        };
        // Unit conversion
        switch(unit){
            case 'pt':
                var k = 1;
                break;
            case 'mm':
                var k = 72 / 25.4;
                break;
            case 'cm':
                var k = 72 / 2.54;
                break;
            case 'in':
                var k = 72;
                break;
            case 'px':
                var k = 0.75;
                break;
            case 'pc':
                var k = 12;
                break;
            case 'em':
                var k = 12;
                break;
            case 'ex':
                var k = 6;
                break;
            default:
                throw 'Invalid unit: ' + unit;
        }
        // Dimensions are stored as user units and converted to points on output
        if (pageFormats.hasOwnProperty(format_as_string)) {
            var pageHeight = pageFormats[format_as_string][1] / k;
            var pageWidth = pageFormats[format_as_string][0] / k;
        } else try {
            var pageHeight = format[1];
            var pageWidth = format[0];
        } catch (err) {
            throw new Error('Invalid format: ' + format);
        }
        // Handle page orientation
        if (orientation === 'p' || orientation === 'portrait') {
            orientation = 'p';
            if (pageWidth > pageHeight) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else if (orientation === 'l' || orientation === 'landscape') {
            orientation = 'l';
            if (pageHeight > pageWidth) {
                var tmp = pageWidth;
                pageWidth = pageHeight;
                pageHeight = tmp;
            }
        } else throw 'Invalid orientation: ' + orientation;
        // Return information (k is the unit conversion ratio from pts)
        var info = {
            'width': pageWidth,
            'height': pageHeight,
            'unit': unit,
            'k': k
        };
        return info;
    };
    /* Pagebreak plugin:

    Adds page-break functionality to the html2pdf library. Page-breaks can be
    enabled by CSS styles, set on individual elements using selectors, or
    avoided from breaking inside all elements.

    Options on the `opt.pagebreak` object:

    mode:   String or array of strings: 'avoid-all', 'css', and/or 'legacy'
            Default: ['css', 'legacy']

    before: String or array of CSS selectors for which to add page-breaks
            before each element. Can be a specific element with an ID
            ('#myID'), all elements of a type (e.g. 'img'), all of a class
            ('.myClass'), or even '*' to match every element.

    after:  Like 'before', but adds a page-break immediately after the element.

    avoid:  Like 'before', but avoids page-breaks on these elements. You can
            enable this feature on every element using the 'avoid-all' mode.
*/ // Refs to original functions.
    var orig = {
        toContainer: Worker.prototype.toContainer
    };
    // Add pagebreak default options to the Worker template.
    Worker.template.opt.pagebreak = {
        mode: [
            'css',
            'legacy'
        ],
        before: [],
        after: [],
        avoid: []
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig.toContainer.call(this).then(function toContainer_pagebreak() {
            // Setup root element and inner page height.
            var root = this.prop.container;
            var pxPageHeight = this.prop.pageSize.inner.px.height;
            // Check all requested modes.
            var modeSrc = [].concat(this.opt.pagebreak.mode);
            var mode = {
                avoidAll: modeSrc.indexOf('avoid-all') !== -1,
                css: modeSrc.indexOf('css') !== -1,
                legacy: modeSrc.indexOf('legacy') !== -1
            };
            // Get arrays of all explicitly requested elements.
            var select = {};
            var self1 = this;
            [
                'before',
                'after',
                'avoid'
            ].forEach(function(key) {
                var all = mode.avoidAll && key === 'avoid';
                select[key] = all ? [] : [].concat(self1.opt.pagebreak[key] || []);
                if (select[key].length > 0) select[key] = Array.prototype.slice.call(root.querySelectorAll(select[key].join(', ')));
            });
            // Get all legacy page-break elements.
            var legacyEls = root.querySelectorAll('.html2pdf__page-break');
            legacyEls = Array.prototype.slice.call(legacyEls);
            // Loop through all elements.
            var els = root.querySelectorAll('*');
            Array.prototype.forEach.call(els, function pagebreak_loop(el) {
                // Setup pagebreak rules based on legacy and avoidAll modes.
                var rules = {
                    before: false,
                    after: mode.legacy && legacyEls.indexOf(el) !== -1,
                    avoid: mode.avoidAll
                };
                // Add rules for css mode.
                if (mode.css) {
                    // TODO: Check if this is valid with iFrames.
                    var style = window.getComputedStyle(el);
                    // TODO: Handle 'left' and 'right' correctly.
                    // TODO: Add support for 'avoid' on breakBefore/After.
                    var breakOpt = [
                        'always',
                        'page',
                        'left',
                        'right'
                    ];
                    var avoidOpt = [
                        'avoid',
                        'avoid-page'
                    ];
                    rules = {
                        before: rules.before || breakOpt.indexOf(style.breakBefore || style.pageBreakBefore) !== -1,
                        after: rules.after || breakOpt.indexOf(style.breakAfter || style.pageBreakAfter) !== -1,
                        avoid: rules.avoid || avoidOpt.indexOf(style.breakInside || style.pageBreakInside) !== -1
                    };
                }
                // Add rules for explicit requests.
                Object.keys(rules).forEach(function(key) {
                    rules[key] = rules[key] || select[key].indexOf(el) !== -1;
                });
                // Get element position on the screen.
                // TODO: Subtract the top of the container from clientRect.top/bottom?
                var clientRect = el.getBoundingClientRect();
                // Avoid: Check if a break happens mid-element.
                if (rules.avoid && !rules.before) {
                    var startPage = Math.floor(clientRect.top / pxPageHeight);
                    var endPage = Math.floor(clientRect.bottom / pxPageHeight);
                    var nPages = Math.abs(clientRect.bottom - clientRect.top) / pxPageHeight;
                    // Turn on rules.before if the el is broken and is at most one page long.
                    if (endPage !== startPage && nPages <= 1) rules.before = true;
                }
                // Before: Create a padding div to push the element to the next page.
                if (rules.before) {
                    var pad = createElement('div', {
                        style: {
                            display: 'block',
                            height: pxPageHeight - clientRect.top % pxPageHeight + 'px'
                        }
                    });
                    el.parentNode.insertBefore(pad, el);
                }
                // After: Create a padding div to fill the remaining page.
                if (rules.after) {
                    var pad = createElement('div', {
                        style: {
                            display: 'block',
                            height: pxPageHeight - clientRect.bottom % pxPageHeight + 'px'
                        }
                    });
                    el.parentNode.insertBefore(pad, el.nextSibling);
                }
            });
        });
    };
    // Add hyperlink functionality to the PDF creation.
    // Main link array, and refs to original functions.
    var linkInfo = [];
    var orig$1 = {
        toContainer: Worker.prototype.toContainer,
        toPdf: Worker.prototype.toPdf
    };
    Worker.prototype.toContainer = function toContainer() {
        return orig$1.toContainer.call(this).then(function toContainer_hyperlink() {
            // Retrieve hyperlink info if the option is enabled.
            if (this.opt.enableLinks) {
                // Find all anchor tags and get the container's bounds for reference.
                var container = this.prop.container;
                var links = container.querySelectorAll('a');
                var containerRect = unitConvert(container.getBoundingClientRect(), this.prop.pageSize.k);
                linkInfo = [];
                // Loop through each anchor tag.
                Array.prototype.forEach.call(links, function(link) {
                    // Treat each client rect as a separate link (for text-wrapping).
                    var clientRects = link.getClientRects();
                    for(var i = 0; i < clientRects.length; i++){
                        var clientRect = unitConvert(clientRects[i], this.prop.pageSize.k);
                        clientRect.left -= containerRect.left;
                        clientRect.top -= containerRect.top;
                        var page = Math.floor(clientRect.top / this.prop.pageSize.inner.height) + 1;
                        var top = this.opt.margin[0] + clientRect.top % this.prop.pageSize.inner.height;
                        var left = this.opt.margin[1] + clientRect.left;
                        linkInfo.push({
                            page: page,
                            top: top,
                            left: left,
                            clientRect: clientRect,
                            link: link
                        });
                    }
                }, this);
            }
        });
    };
    Worker.prototype.toPdf = function toPdf() {
        return orig$1.toPdf.call(this).then(function toPdf_hyperlink() {
            // Add hyperlinks if the option is enabled.
            if (this.opt.enableLinks) {
                // Attach each anchor tag based on info from toContainer().
                linkInfo.forEach(function(l) {
                    this.prop.pdf.setPage(l.page);
                    this.prop.pdf.link(l.left, l.top, l.clientRect.width, l.clientRect.height, {
                        url: l.link.href
                    });
                }, this);
                // Reset the active page of the PDF to the final page.
                var nPages = this.prop.pdf.internal.getNumberOfPages();
                this.prop.pdf.setPage(nPages);
            }
        });
    };
    /**
 * Generate a PDF from an HTML element or string using html2canvas and jsPDF.
 *
 * @param {Element|string} source The source element or HTML string.
 * @param {Object=} opt An object of optional settings: 'margin', 'filename',
 *    'image' ('type' and 'quality'), and 'html2canvas' / 'jspdf', which are
 *    sent as settings to their corresponding functions.
 */ var html2pdf = function html2pdf(src, opt) {
        // Create a new worker with the given options.
        var worker = new html2pdf.Worker(opt);
        if (src) // If src is specified, perform the traditional 'simple' operation.
        return worker.from(src).save();
        else // Otherwise, return the worker for new Promise-based operation.
        return worker;
    };
    html2pdf.Worker = Worker;
    return html2pdf;
});

},{"1553fa0bbb51bb94":"5jT8D","891c8385c9547d2c":"eKPE3","3af49d75da587f8":"4KZDF"}],"eKPE3":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var process = require("e1c0f5b21ad461de");
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t, y, e, I, i, o, a, h, C, T, d, p, F, n, r, s, c, P, E, q, g, m, w, l, v, b, x, S, u, k, _, f, A, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y, X, J, K, Q, Z, vt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $ = function(pt) {
        var gt = "1.3", mt = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        function wt(o) {
            var a = {};
            this.subscribe = function(t, e, n) {
                if ("function" != typeof e) return !1;
                a.hasOwnProperty(t) || (a[t] = {});
                var r = Math.random().toString(35);
                return a[t][r] = [
                    e,
                    !!n
                ], r;
            }, this.unsubscribe = function(t) {
                for(var e in a)if (a[e][t]) return delete a[e][t], !0;
                return !1;
            }, this.publish = function(t) {
                if (a.hasOwnProperty(t)) {
                    var e = Array.prototype.slice.call(arguments, 1), n = [];
                    for(var r in a[t]){
                        var i = a[t][r];
                        try {
                            i[0].apply(o, e);
                        } catch (t) {
                            pt.console && console.error("jsPDF PubSub Error", t.message, t);
                        }
                        i[1] && n.push(r);
                    }
                    n.length && n.forEach(this.unsubscribe);
                }
            };
        }
        function yt(t, e, n, r) {
            var i = {};
            "object" === (void 0 === t ? "undefined" : vt(t)) && (t = (i = t).orientation, e = i.unit || e, n = i.format || n, r = i.compress || i.compressPdf || r), e = e || "mm", n = n || "a4", t = ("" + (t || "P")).toLowerCase();
            ("" + n).toLowerCase();
            var K, w, y, o, u, v, a, s, h, c, l, f = !!r && "function" == typeof Uint8Array, Q = i.textColor || "0 g", d = i.drawColor || "0 G", Z = i.fontSize || 16, $ = i.charSpace || 0, tt = i.R2L || !1, et = i.lineHeight || 1.15, p = i.lineWidth || .200025, g = "00000000000000000000000000000000", m = 2, b = !1, x = [], nt = {}, S = {}, k = 0, _ = [], A = [], I = [], C = [], T = [], F = 0, P = 0, E = 0, q = {
                title: "",
                subject: "",
                author: "",
                keywords: "",
                creator: ""
            }, O = {}, rt = new wt(O), B = i.hotfixes || [], R = function(t) {
                var e, n = t.ch1, r = t.ch2, i = t.ch3, o = t.ch4, a = (t.precision, "draw" === t.pdfColorType ? [
                    "G",
                    "RG",
                    "K"
                ] : [
                    "g",
                    "rg",
                    "k"
                ]);
                if ("string" == typeof n && "#" !== n.charAt(0)) {
                    var s = new RGBColor(n);
                    s.ok && (n = s.toHex());
                }
                if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
                    var h = parseInt(n.substr(1), 16);
                    n = h >> 16 & 255, r = h >> 8 & 255, i = 255 & h;
                }
                if (void 0 === r || void 0 === o && n === r && r === i) {
                    if ("string" == typeof n) e = n + " " + a[0];
                    else switch(t.precision){
                        case 2:
                            e = N(n / 255) + " " + a[0];
                            break;
                        case 3:
                        default:
                            e = z(n / 255) + " " + a[0];
                    }
                } else if (void 0 === o || "object" === (void 0 === o ? "undefined" : vt(o))) {
                    if ("string" == typeof n) e = [
                        n,
                        r,
                        i,
                        a[1]
                    ].join(" ");
                    else switch(t.precision){
                        case 2:
                            e = [
                                N(n / 255),
                                N(r / 255),
                                N(i / 255),
                                a[1]
                            ].join(" ");
                            break;
                        default:
                        case 3:
                            e = [
                                z(n / 255),
                                z(r / 255),
                                z(i / 255),
                                a[1]
                            ].join(" ");
                    }
                    o && 0 === o.a && (e = [
                        "255",
                        "255",
                        "255",
                        a[1]
                    ].join(" "));
                } else if ("string" == typeof n) e = [
                    n,
                    r,
                    i,
                    o,
                    a[2]
                ].join(" ");
                else switch(t.precision){
                    case 2:
                        e = [
                            N(n),
                            N(r),
                            N(i),
                            N(o),
                            a[2]
                        ].join(" ");
                        break;
                    case 3:
                    default:
                        e = [
                            z(n),
                            z(r),
                            z(i),
                            z(o),
                            a[2]
                        ].join(" ");
                }
                return e;
            }, j = function(t) {
                var e = function(t) {
                    return ("0" + parseInt(t)).slice(-2);
                }, n = t.getTimezoneOffset(), r = n < 0 ? "+" : "-", i = Math.floor(Math.abs(n / 60)), o = Math.abs(n % 60), a = [
                    r,
                    e(i),
                    "'",
                    e(o),
                    "'"
                ].join("");
                return [
                    "D:",
                    t.getFullYear(),
                    e(t.getMonth() + 1),
                    e(t.getDate()),
                    e(t.getHours()),
                    e(t.getMinutes()),
                    e(t.getSeconds()),
                    a
                ].join("");
            }, D = function(t) {
                var e;
                return void 0 === (void 0 === t ? "undefined" : vt(t)) && (t = new Date), e = "object" === (void 0 === t ? "undefined" : vt(t)) && "[object Date]" === Object.prototype.toString.call(t) ? j(t) : /^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t) ? t : j(new Date), c = e;
            }, M = function(t) {
                var e = c;
                return "jsDate" === t && (e = function(t) {
                    var e = parseInt(t.substr(2, 4), 10), n = parseInt(t.substr(6, 2), 10) - 1, r = parseInt(t.substr(8, 2), 10), i = parseInt(t.substr(10, 2), 10), o = parseInt(t.substr(12, 2), 10), a = parseInt(t.substr(14, 2), 10);
                    parseInt(t.substr(16, 2), 10), parseInt(t.substr(20, 2), 10);
                    return new Date(e, n, r, i, o, a, 0);
                }(c)), e;
            }, U = function(t) {
                return t = t || "12345678901234567890123456789012".split("").map(function() {
                    return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
                }).join(""), g = t;
            }, N = function(t) {
                return t.toFixed(2);
            }, z = function(t) {
                return t.toFixed(3);
            }, it = function(t) {
                t = "string" == typeof t ? t : t.toString(), b ? _[o].push(t) : (E += t.length + 1, C.push(t));
            }, L = function() {
                return x[++m] = E, it(m + " 0 obj"), m;
            }, H = function(t) {
                it("stream"), it(t), it("endstream");
            }, W = function() {
                for(var t in it("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), it("/Font <<"), nt)nt.hasOwnProperty(t) && it("/" + t + " " + nt[t].objectNumber + " 0 R");
                it(">>"), it("/XObject <<"), rt.publish("putXobjectDict"), it(">>");
            }, G = function() {
                !function() {
                    for(var t in nt)nt.hasOwnProperty(t) && (e = nt[t], rt.publish("putFont", {
                        font: e,
                        out: it,
                        newObject: L
                    }), !0 !== e.isAlreadyPutted && (e.objectNumber = L(), it("<<"), it("/Type /Font"), it("/BaseFont /" + e.postScriptName), it("/Subtype /Type1"), "string" == typeof e.encoding && it("/Encoding /" + e.encoding), it("/FirstChar 32"), it("/LastChar 255"), it(">>"), it("endobj")));
                    var e;
                }(), rt.publish("putResources"), x[2] = E, it("2 0 obj"), it("<<"), W(), it(">>"), it("endobj"), rt.publish("postPutResources");
            }, V = function(t, e, n) {
                S.hasOwnProperty(e) || (S[e] = {}), S[e][n] = t;
            }, Y = function(t, e, n, r) {
                var i = "F" + (Object.keys(nt).length + 1).toString(10), o = nt[i] = {
                    id: i,
                    postScriptName: t,
                    fontName: e,
                    fontStyle: n,
                    encoding: r,
                    metadata: {}
                };
                return V(i, e, n), rt.publish("addFont", o), i;
            }, ot = function(t, e) {
                return (function(t, e) {
                    var n, r, i, o, a, s, h, c, l;
                    if (i = (e = e || {}).sourceEncoding || "Unicode", a = e.outputEncoding, (e.autoencode || a) && nt[K].metadata && nt[K].metadata[i] && nt[K].metadata[i].encoding && (o = nt[K].metadata[i].encoding, !a && nt[K].encoding && (a = nt[K].encoding), !a && o.codePages && (a = o.codePages[0]), "string" == typeof a && (a = o[a]), a)) {
                        for(h = !1, s = [], n = 0, r = t.length; n < r; n++)(c = a[t.charCodeAt(n)]) ? s.push(String.fromCharCode(c)) : s.push(t[n]), s[n].charCodeAt(0) >> 8 && (h = !0);
                        t = s.join("");
                    }
                    for(n = t.length; void 0 === h && 0 !== n;)t.charCodeAt(n - 1) >> 8 && (h = !0), n--;
                    if (!h) return t;
                    for(s = e.noBOM ? [] : [
                        254,
                        255
                    ], n = 0, r = t.length; n < r; n++){
                        if ((l = (c = t.charCodeAt(n)) >> 8) >> 8) throw new Error("Character at position " + n + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
                        s.push(l), s.push(c - (l << 8));
                    }
                    return String.fromCharCode.apply(void 0, s);
                })(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
            }, X = function() {
                (function(t, e) {
                    var n = "string" == typeof e && e.toLowerCase();
                    if ("string" == typeof t) {
                        var r = t.toLowerCase();
                        mt.hasOwnProperty(r) && (t = mt[r][0] / w, e = mt[r][1] / w);
                    }
                    if (Array.isArray(t) && (e = t[1], t = t[0]), n) {
                        switch(n.substr(0, 1)){
                            case "l":
                                t < e && (n = "s");
                                break;
                            case "p":
                                e < t && (n = "s");
                        }
                        "s" === n && (y = t, t = e, e = y);
                    }
                    b = !0, _[++k] = [], I[k] = {
                        width: Number(t) || u,
                        height: Number(e) || v
                    }, A[k] = {}, J(k);
                }).apply(this, arguments), it(N(p * w) + " w"), it(d), 0 !== F && it(F + " J"), 0 !== P && it(P + " j"), rt.publish("addPage", {
                    pageNumber: k
                });
            }, J = function(t) {
                0 < t && t <= k && (u = I[o = t].width, v = I[t].height);
            }, at = function(t, e, n) {
                var r, i = void 0;
                return n = n || {}, t = void 0 !== t ? t : nt[K].fontName, e = void 0 !== e ? e : nt[K].fontStyle, r = t.toLowerCase(), void 0 !== S[r] && void 0 !== S[r][e] ? i = S[r][e] : void 0 !== S[t] && void 0 !== S[t][e] ? i = S[t][e] : !1 === n.disableWarning && console.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), i || n.noFallback || null == (i = S.times[e]) && (i = S.times.normal), i;
            }, st = function() {
                b = !1, m = 2, E = 0, C = [], x = [], T = [], rt.publish("buildDocument"), it("%PDF-" + gt), it("%\xba\xdf\xac\xe0"), function() {
                    var t, e, n, r, i, o, a, s, h, c = [];
                    for(a = pt.adler32cs || yt.API.adler32cs, f && void 0 === a && (f = !1), t = 1; t <= k; t++){
                        if (c.push(L()), s = (u = I[t].width) * w, h = (v = I[t].height) * w, it("<</Type /Page"), it("/Parent 1 0 R"), it("/Resources 2 0 R"), it("/MediaBox [0 0 " + N(s) + " " + N(h) + "]"), rt.publish("putPage", {
                            pageNumber: t,
                            page: _[t]
                        }), it("/Contents " + (m + 1) + " 0 R"), it(">>"), it("endobj"), e = _[t].join("\n"), L(), f) {
                            for(n = [], r = e.length; r--;)n[r] = e.charCodeAt(r);
                            o = a.from(e), (i = new Deflater(6)).append(new Uint8Array(n)), e = i.flush(), (n = new Uint8Array(e.length + 6)).set(new Uint8Array([
                                120,
                                156
                            ])), n.set(e, 2), n.set(new Uint8Array([
                                255 & o,
                                o >> 8 & 255,
                                o >> 16 & 255,
                                o >> 24 & 255
                            ]), e.length + 2), e = String.fromCharCode.apply(null, n), it("<</Length " + e.length + " /Filter [/FlateDecode]>>");
                        } else it("<</Length " + e.length + ">>");
                        H(e), it("endobj");
                    }
                    x[1] = E, it("1 0 obj"), it("<</Type /Pages");
                    var l = "/Kids [";
                    for(r = 0; r < k; r++)l += c[r] + " 0 R ";
                    it(l + "]"), it("/Count " + k), it(">>"), it("endobj"), rt.publish("postPutPages");
                }(), function() {
                    rt.publish("putAdditionalObjects");
                    for(var t = 0; t < T.length; t++){
                        var e = T[t];
                        x[e.objId] = E, it(e.objId + " 0 obj"), it(e.content), it("endobj");
                    }
                    m += T.length, rt.publish("postPutAdditionalObjects");
                }(), G(), L(), it("<<"), function() {
                    for(var t in it("/Producer (jsPDF " + yt.version + ")"), q)q.hasOwnProperty(t) && q[t] && it("/" + t.substr(0, 1).toUpperCase() + t.substr(1) + " (" + ot(q[t]) + ")");
                    it("/CreationDate (" + c + ")");
                }(), it(">>"), it("endobj"), L(), it("<<"), function() {
                    switch(it("/Type /Catalog"), it("/Pages 1 0 R"), s || (s = "fullwidth"), s){
                        case "fullwidth":
                            it("/OpenAction [3 0 R /FitH null]");
                            break;
                        case "fullheight":
                            it("/OpenAction [3 0 R /FitV null]");
                            break;
                        case "fullpage":
                            it("/OpenAction [3 0 R /Fit]");
                            break;
                        case "original":
                            it("/OpenAction [3 0 R /XYZ null null 1]");
                            break;
                        default:
                            var t = "" + s;
                            "%" === t.substr(t.length - 1) && (s = parseInt(s) / 100), "number" == typeof s && it("/OpenAction [3 0 R /XYZ null null " + N(s) + "]");
                    }
                    switch(h || (h = "continuous"), h){
                        case "continuous":
                            it("/PageLayout /OneColumn");
                            break;
                        case "single":
                            it("/PageLayout /SinglePage");
                            break;
                        case "two":
                        case "twoleft":
                            it("/PageLayout /TwoColumnLeft");
                            break;
                        case "tworight":
                            it("/PageLayout /TwoColumnRight");
                    }
                    a && it("/PageMode /" + a), rt.publish("putCatalog");
                }(), it(">>"), it("endobj");
                var t, e = E, n = "0000000000";
                for(it("xref"), it("0 " + (m + 1)), it(n + " 65535 f "), t = 1; t <= m; t++){
                    var r = x[t];
                    it("function" == typeof r ? (n + x[t]()).slice(-10) + " 00000 n " : (n + x[t]).slice(-10) + " 00000 n ");
                }
                return it("trailer"), it("<<"), it("/Size " + (m + 1)), it("/Root " + m + " 0 R"), it("/Info " + (m - 1) + " 0 R"), it("/ID [ <" + g + "> <" + g + "> ]"), it(">>"), it("startxref"), it("" + e), it("%%EOF"), b = !0, C.join("\n");
            }, ht = function(t) {
                var e = "S";
                return "F" === t ? e = "f" : "FD" === t || "DF" === t ? e = "B" : "f" !== t && "f*" !== t && "B" !== t && "B*" !== t || (e = t), e;
            }, ct = function() {
                for(var t = st(), e = t.length, n = new ArrayBuffer(e), r = new Uint8Array(n); e--;)r[e] = t.charCodeAt(e);
                return n;
            }, lt = function() {
                return new Blob([
                    ct()
                ], {
                    type: "application/pdf"
                });
            }, ut = ((l = function(t, e) {
                var n = "dataur" === ("" + t).substr(0, 6) ? "data:application/pdf;base64," + btoa(st()) : 0;
                switch(t){
                    case void 0:
                        return st();
                    case "save":
                        if ("object" === ("undefined" == typeof navigator ? "undefined" : vt(navigator)) && navigator.getUserMedia && (void 0 === pt.URL || void 0 === pt.URL.createObjectURL)) return O.output("dataurlnewwindow");
                        bt(lt(), e), "function" == typeof bt.unload && pt.setTimeout && setTimeout(bt.unload, 911);
                        break;
                    case "arraybuffer":
                        return ct();
                    case "blob":
                        return lt();
                    case "bloburi":
                    case "bloburl":
                        return pt.URL && pt.URL.createObjectURL(lt()) || void 0;
                    case "datauristring":
                    case "dataurlstring":
                        return n;
                    case "dataurlnewwindow":
                        var r = pt.open(n);
                        if (r || "undefined" == typeof safari) return r;
                    case "datauri":
                    case "dataurl":
                        return pt.document.location.href = n;
                    default:
                        throw new Error('Output type "' + t + '" is not supported.');
                }
            }).foo = function() {
                try {
                    return l.apply(this, arguments);
                } catch (t) {
                    var e = t.stack || "";
                    ~e.indexOf(" at ") && (e = e.split(" at ")[1]);
                    var n = "Error in function " + e.split("\n")[0].split("<")[0] + ": " + t.message;
                    if (!pt.console) throw new Error(n);
                    pt.console.error(n, t), pt.alert && alert(n);
                }
            }, (l.foo.bar = l).foo), ft = function(t) {
                return !0 === Array.isArray(B) && -1 < B.indexOf(t);
            };
            switch(e){
                case "pt":
                    w = 1;
                    break;
                case "mm":
                    w = 72 / 25.4;
                    break;
                case "cm":
                    w = 72 / 2.54;
                    break;
                case "in":
                    w = 72;
                    break;
                case "px":
                    w = 1 == ft("px_scaling") ? .75 : 96 / 72;
                    break;
                case "pc":
                case "em":
                    w = 12;
                    break;
                case "ex":
                    w = 6;
                    break;
                default:
                    throw "Invalid unit: " + e;
            }
            for(var dt in D(), U(), O.internal = {
                pdfEscape: ot,
                getStyle: ht,
                getFont: function() {
                    return nt[at.apply(O, arguments)];
                },
                getFontSize: function() {
                    return Z;
                },
                getCharSpace: function() {
                    return $;
                },
                getTextColor: function() {
                    var t = Q.split(" ");
                    if (2 === t.length && "g" === t[1]) {
                        var e = parseFloat(t[0]);
                        t = [
                            e,
                            e,
                            e,
                            "r"
                        ];
                    }
                    for(var n = "#", r = 0; r < 3; r++)n += ("0" + Math.floor(255 * parseFloat(t[r])).toString(16)).slice(-2);
                    return n;
                },
                getLineHeight: function() {
                    return Z * et;
                },
                write: function(t) {
                    it(1 === arguments.length ? t : Array.prototype.join.call(arguments, " "));
                },
                getCoordinateString: function(t) {
                    return N(t * w);
                },
                getVerticalCoordinateString: function(t) {
                    return N((v - t) * w);
                },
                collections: {},
                newObject: L,
                newAdditionalObject: function() {
                    var t = 2 * _.length + 1, e = {
                        objId: t += T.length,
                        content: ""
                    };
                    return T.push(e), e;
                },
                newObjectDeferred: function() {
                    return x[++m] = function() {
                        return E;
                    }, m;
                },
                newObjectDeferredBegin: function(t) {
                    x[t] = E;
                },
                putStream: H,
                events: rt,
                scaleFactor: w,
                pageSize: {
                    getWidth: function() {
                        return u;
                    },
                    getHeight: function() {
                        return v;
                    }
                },
                output: function(t, e) {
                    return ut(t, e);
                },
                getNumberOfPages: function() {
                    return _.length - 1;
                },
                pages: _,
                out: it,
                f2: N,
                getPageInfo: function(t) {
                    return {
                        objId: 2 * (t - 1) + 3,
                        pageNumber: t,
                        pageContext: A[t]
                    };
                },
                getCurrentPageInfo: function() {
                    return {
                        objId: 2 * (o - 1) + 3,
                        pageNumber: o,
                        pageContext: A[o]
                    };
                },
                getPDFVersion: function() {
                    return gt;
                },
                hasHotfix: ft
            }, O.addPage = function() {
                return X.apply(this, arguments), this;
            }, O.setPage = function() {
                return J.apply(this, arguments), this;
            }, O.insertPage = function(t) {
                return this.addPage(), this.movePage(o, t), this;
            }, O.movePage = function(t, e) {
                if (e < t) {
                    for(var n = _[t], r = I[t], i = A[t], o = t; e < o; o--)_[o] = _[o - 1], I[o] = I[o - 1], A[o] = A[o - 1];
                    _[e] = n, I[e] = r, A[e] = i, this.setPage(e);
                } else if (t < e) {
                    for(n = _[t], r = I[t], i = A[t], o = t; o < e; o++)_[o] = _[o + 1], I[o] = I[o + 1], A[o] = A[o + 1];
                    _[e] = n, I[e] = r, A[e] = i, this.setPage(e);
                }
                return this;
            }, O.deletePage = function() {
                return (function(t) {
                    0 < t && t <= k && (_.splice(t, 1), I.splice(t, 1), --k < o && (o = k), this.setPage(o));
                }).apply(this, arguments), this;
            }, O.setCreationDate = function(t) {
                return D(t), this;
            }, O.getCreationDate = function(t) {
                return M(t);
            }, O.setFileId = function(t) {
                return U(t), this;
            }, O.getFileId = function() {
                return g;
            }, O.setDisplayMode = function(t, e, n) {
                if (s = t, h = e, -1 == [
                    void 0,
                    null,
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "FullScreen"
                ].indexOf(a = n)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + n + '" is not recognized.');
                return this;
            }, O.text = function(t, e, n, i) {
                var r, o, a = "", s = et, h = this;
                function c(t) {
                    for(var e, n = t.concat(), r = [], i = n.length; i--;)"string" == typeof (e = n.shift()) ? r.push(e) : "[object Array]" === Object.prototype.toString.call(t) && 1 === e.length ? r.push(e[0]) : r.push([
                        e[0],
                        e[1],
                        e[2]
                    ]);
                    return r;
                }
                function l(t, e) {
                    var n;
                    if ("string" == typeof t) n = e(t)[0];
                    else if ("[object Array]" === Object.prototype.toString.call(t)) {
                        for(var r, i, o = t.concat(), a = [], s = o.length; s--;)"string" == typeof (r = o.shift()) ? a.push(e(r)[0]) : "[object Array]" === Object.prototype.toString.call(r) && "string" === r[0] && (i = e(r[0], r[1], r[2]), a.push([
                            i[0],
                            i[1],
                            i[2]
                        ]));
                        n = a;
                    }
                    return n;
                }
                "number" == typeof t && (o = n, n = e, e = t, t = o);
                var u = i, f = arguments[4], d = arguments[5];
                "object" === (void 0 === u ? "undefined" : vt(u)) && null !== u || ("string" == typeof f && (d = f, f = null), "string" == typeof u && (d = u, u = null), "number" == typeof u && (f = u, u = null), i = {
                    flags: u,
                    angle: f,
                    align: d
                });
                var p = !1, g = !0;
                if ("string" == typeof t) p = !0;
                else if ("[object Array]" === Object.prototype.toString.call(t)) {
                    for(var m, w = t.concat(), y = [], v = w.length; v--;)("string" != typeof (m = w.shift()) || "[object Array]" === Object.prototype.toString.call(m) && "string" != typeof m[0]) && (g = !1);
                    p = g;
                }
                if (!1 === p) throw new Error('Type of text must be string or Array. "' + t + '" is not recognized.');
                var b = nt[K].encoding;
                "WinAnsiEncoding" !== b && "StandardEncoding" !== b || (t = l(t, function(t, e, n) {
                    var r;
                    return [
                        (r = t, r = r.split("\t").join(Array(i.TabLen || 9).join(" ")), ot(r, u)),
                        e,
                        n
                    ];
                })), "string" == typeof t && (t = t.match(/[\r?\n]/) ? t.split(/\r\n|\r|\n/g) : [
                    t
                ]), 0 < (j = i.maxWidth || 0) && ("string" == typeof t ? t = h.splitTextToSize(t, j) : "[object Array]" === Object.prototype.toString.call(t) && (t = h.splitTextToSize(t.join(" "), j)));
                var x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("preProcessText", x), t = x.text;
                f = (i = x.options).angle;
                var S = h.internal.scaleFactor, k = (h.internal.pageSize.getHeight(), []);
                if (f) {
                    f *= Math.PI / 180;
                    var _ = Math.cos(f), A = Math.sin(f), I = function(t) {
                        return t.toFixed(2);
                    };
                    k = [
                        I(_),
                        I(A),
                        I(-1 * A),
                        I(_)
                    ];
                }
                void 0 !== (R = i.charSpace) && (a += R + " Tc\n");
                i.lang;
                var C = -1, T = i.renderingMode || i.stroke, F = h.internal.getCurrentPageInfo().pageContext;
                switch(T){
                    case 0:
                    case !1:
                    case "fill":
                        C = 0;
                        break;
                    case 1:
                    case !0:
                    case "stroke":
                        C = 1;
                        break;
                    case 2:
                    case "fillThenStroke":
                        C = 2;
                        break;
                    case 3:
                    case "invisible":
                        C = 3;
                        break;
                    case 4:
                    case "fillAndAddForClipping":
                        C = 4;
                        break;
                    case 5:
                    case "strokeAndAddPathForClipping":
                        C = 5;
                        break;
                    case 6:
                    case "fillThenStrokeAndAddToPathForClipping":
                        C = 6;
                        break;
                    case 7:
                    case "addToPathForClipping":
                        C = 7;
                }
                var P = F.usedRenderingMode || -1;
                -1 !== C ? a += C + " Tr\n" : -1 !== P && (a += "0 Tr\n"), -1 !== C && (F.usedRenderingMode = C);
                d = i.align || "left";
                var E = Z * s, q = h.internal.pageSize.getHeight(), O = h.internal.pageSize.getWidth(), B = (S = h.internal.scaleFactor, nt[K]), R = i.charSpace || $, j = i.maxWidth || 0, D = (u = {}, []);
                if ("[object Array]" === Object.prototype.toString.call(t)) {
                    var M, U;
                    y = c(t);
                    "left" !== d && (U = y.map(function(t) {
                        return h.getStringUnitWidth(t, {
                            font: B,
                            charSpace: R,
                            fontSize: Z
                        }) * Z / S;
                    }));
                    var N, z = Math.max.apply(Math, U), L = 0;
                    if ("right" === d) {
                        e -= U[0], t = [];
                        var H = 0;
                        for(v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("center" === d) {
                        e -= U[0] / 2, t = [];
                        for(H = 0, v = y.length; H < v; H++)U[H], 0 === H ? (N = e * S, M = (q - n) * S) : (N = (L - U[H]) / 2 * S, M = -E), t.push([
                            y[H],
                            N,
                            M
                        ]), L = U[H];
                    } else if ("left" === d) {
                        t = [];
                        for(H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, t.push(y[H]);
                    } else {
                        if ("justify" !== d) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                        t = [];
                        for(j = 0 !== j ? j : O, H = 0, v = y.length; H < v; H++)M = 0 === H ? (q - n) * S : -E, N = 0 === H ? e * S : 0, H < v - 1 && D.push(((j - U[H]) / (y[H].split(" ").length - 1) * S).toFixed(2)), t.push([
                            y[H],
                            N,
                            M
                        ]);
                    }
                }
                !0 === ("boolean" == typeof i.R2L ? i.R2L : tt) && (t = l(t, function(t, e, n) {
                    return [
                        t.split("").reverse().join(""),
                        e,
                        n
                    ];
                }));
                x = {
                    text: t,
                    x: e,
                    y: n,
                    options: i,
                    mutex: {
                        pdfEscape: ot,
                        activeFontKey: K,
                        fonts: nt,
                        activeFontSize: Z
                    }
                };
                rt.publish("postProcessText", x), t = x.text, r = x.mutex.isHex;
                y = c(t);
                t = [];
                var W, G, V, Y = 0, X = (v = y.length, "");
                for(H = 0; H < v; H++)X = "", "[object Array]" !== Object.prototype.toString.call(y[H]) ? (W = parseFloat(e * S).toFixed(2), G = parseFloat((q - n) * S).toFixed(2), V = (r ? "<" : "(") + y[H] + (r ? ">" : ")")) : "[object Array]" === Object.prototype.toString.call(y[H]) && (W = parseFloat(y[H][1]).toFixed(2), G = parseFloat(y[H][2]).toFixed(2), V = (r ? "<" : "(") + y[H][0] + (r ? ">" : ")"), Y = 1), void 0 !== D && void 0 !== D[H] && (X = D[H] + " Tw\n"), 0 !== k.length && 0 === H ? t.push(X + k.join(" ") + " " + W + " " + G + " Tm\n" + V) : 1 === Y || 0 === Y && 0 === H ? t.push(X + W + " " + G + " Td\n" + V) : t.push(X + V);
                t = 0 === Y ? t.join(" Tj\nT* ") : t.join(" Tj\n"), t += " Tj\n";
                var J = "BT\n/" + K + " " + Z + " Tf\n" + (Z * s).toFixed(2) + " TL\n" + Q + "\n";
                return J += a, J += t, it(J += "ET"), h;
            }, O.lstext = function(t, e, n, r) {
                console.warn("jsPDF.lstext is deprecated");
                for(var i = 0, o = t.length; i < o; i++, e += r)this.text(t[i], e, n);
                return this;
            }, O.line = function(t, e, n, r) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ]
                ], t, e);
            }, O.clip = function() {
                it("W"), it("S");
            }, O.clip_fixed = function(t) {
                it("evenodd" === t ? "W*" : "W"), it("n");
            }, O.lines = function(t, e, n, r, i, o) {
                var a, s, h, c, l, u, f, d, p, g, m;
                for("number" == typeof t && (y = n, n = e, e = t, t = y), r = r || [
                    1,
                    1
                ], it(z(e * w) + " " + z((v - n) * w) + " m "), a = r[0], s = r[1], c = t.length, g = e, m = n, h = 0; h < c; h++)2 === (l = t[h]).length ? (g = l[0] * a + g, m = l[1] * s + m, it(z(g * w) + " " + z((v - m) * w) + " l")) : (u = l[0] * a + g, f = l[1] * s + m, d = l[2] * a + g, p = l[3] * s + m, g = l[4] * a + g, m = l[5] * s + m, it(z(u * w) + " " + z((v - f) * w) + " " + z(d * w) + " " + z((v - p) * w) + " " + z(g * w) + " " + z((v - m) * w) + " c"));
                return o && it(" h"), null !== i && it(ht(i)), this;
            }, O.rect = function(t, e, n, r, i) {
                ht(i);
                return it([
                    N(t * w),
                    N((v - e) * w),
                    N(n * w),
                    N(-r * w),
                    "re"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.triangle = function(t, e, n, r, i, o, a) {
                return this.lines([
                    [
                        n - t,
                        r - e
                    ],
                    [
                        i - n,
                        o - r
                    ],
                    [
                        t - i,
                        e - o
                    ]
                ], t, e, [
                    1,
                    1
                ], a, !0), this;
            }, O.roundedRect = function(t, e, n, r, i, o, a) {
                var s = 4 / 3 * (Math.SQRT2 - 1);
                return this.lines([
                    [
                        n - 2 * i,
                        0
                    ],
                    [
                        i * s,
                        0,
                        i,
                        o - o * s,
                        i,
                        o
                    ],
                    [
                        0,
                        r - 2 * o
                    ],
                    [
                        0,
                        o * s,
                        -i * s,
                        o,
                        -i,
                        o
                    ],
                    [
                        2 * i - n,
                        0
                    ],
                    [
                        -i * s,
                        0,
                        -i,
                        -o * s,
                        -i,
                        -o
                    ],
                    [
                        0,
                        2 * o - r
                    ],
                    [
                        0,
                        -o * s,
                        i * s,
                        -o,
                        i,
                        -o
                    ]
                ], t + i, e, [
                    1,
                    1
                ], a), this;
            }, O.ellipse = function(t, e, n, r, i) {
                var o = 4 / 3 * (Math.SQRT2 - 1) * n, a = 4 / 3 * (Math.SQRT2 - 1) * r;
                return it([
                    N((t + n) * w),
                    N((v - e) * w),
                    "m",
                    N((t + n) * w),
                    N((v - (e - a)) * w),
                    N((t + o) * w),
                    N((v - (e - r)) * w),
                    N(t * w),
                    N((v - (e - r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t - o) * w),
                    N((v - (e - r)) * w),
                    N((t - n) * w),
                    N((v - (e - a)) * w),
                    N((t - n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), it([
                    N((t - n) * w),
                    N((v - (e + a)) * w),
                    N((t - o) * w),
                    N((v - (e + r)) * w),
                    N(t * w),
                    N((v - (e + r)) * w),
                    "c"
                ].join(" ")), it([
                    N((t + o) * w),
                    N((v - (e + r)) * w),
                    N((t + n) * w),
                    N((v - (e + a)) * w),
                    N((t + n) * w),
                    N((v - e) * w),
                    "c"
                ].join(" ")), null !== i && it(ht(i)), this;
            }, O.circle = function(t, e, n, r) {
                return this.ellipse(t, e, n, n, r);
            }, O.setProperties = function(t) {
                for(var e in q)q.hasOwnProperty(e) && t[e] && (q[e] = t[e]);
                return this;
            }, O.setFontSize = function(t) {
                return Z = t, this;
            }, O.setFont = function(t, e) {
                return K = at(t, e), this;
            }, O.setFontStyle = O.setFontType = function(t) {
                return K = at(void 0, t), this;
            }, O.getFontList = function() {
                var t, e, n, r = {};
                for(t in S)if (S.hasOwnProperty(t)) for(e in r[t] = n = [], S[t])S[t].hasOwnProperty(e) && n.push(e);
                return r;
            }, O.addFont = function(t, e, n, r) {
                Y(t, e, n, r = r || "Identity-H");
            }, O.setLineWidth = function(t) {
                return it((t * w).toFixed(2) + " w"), this;
            }, O.setDrawColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "draw",
                    precision: 2
                })), this;
            }, O.setFillColor = function(t, e, n, r) {
                return it(R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "fill",
                    precision: 2
                })), this;
            }, O.setTextColor = function(t, e, n, r) {
                return Q = R({
                    ch1: t,
                    ch2: e,
                    ch3: n,
                    ch4: r,
                    pdfColorType: "text",
                    precision: 3
                }), this;
            }, O.setCharSpace = function(t) {
                return $ = t, this;
            }, O.setR2L = function(t) {
                return tt = t, this;
            }, O.CapJoinStyles = {
                0: 0,
                butt: 0,
                but: 0,
                miter: 0,
                1: 1,
                round: 1,
                rounded: 1,
                circle: 1,
                2: 2,
                projecting: 2,
                project: 2,
                square: 2,
                bevel: 2
            }, O.setLineCap = function(t) {
                var e = this.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((F = e) + " J"), this;
            }, O.setLineJoin = function(t) {
                var e = this.CapJoinStyles[t];
                if (void 0 === e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
                return it((P = e) + " j"), this;
            }, O.output = ut, O.save = function(t) {
                O.output("save", t);
            }, yt.API)yt.API.hasOwnProperty(dt) && ("events" === dt && yt.API.events.length ? function(t, e) {
                var n, r, i;
                for(i = e.length - 1; -1 !== i; i--)n = e[i][0], r = e[i][1], t.subscribe.apply(t, [
                    n
                ].concat("function" == typeof r ? [
                    r
                ] : r));
            }(rt, yt.API.events) : O[dt] = yt.API[dt]);
            return function() {
                for(var t = "helvetica", e = "times", n = "courier", r = "normal", i = "bold", o = "italic", a = "bolditalic", s = [
                    [
                        "Helvetica",
                        t,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Bold",
                        t,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-Oblique",
                        t,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Helvetica-BoldOblique",
                        t,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier",
                        n,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Bold",
                        n,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-Oblique",
                        n,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Courier-BoldOblique",
                        n,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Roman",
                        e,
                        r,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Bold",
                        e,
                        i,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-Italic",
                        e,
                        o,
                        "WinAnsiEncoding"
                    ],
                    [
                        "Times-BoldItalic",
                        e,
                        a,
                        "WinAnsiEncoding"
                    ],
                    [
                        "ZapfDingbats",
                        "zapfdingbats",
                        r,
                        null
                    ],
                    [
                        "Symbol",
                        "symbol",
                        r,
                        null
                    ]
                ], h = 0, c = s.length; h < c; h++){
                    var l = Y(s[h][0], s[h][1], s[h][2], s[h][3]), u = s[h][0].split("-");
                    V(l, u[0], u[1] || "");
                }
                rt.publish("addFonts", {
                    fonts: nt,
                    dictionary: S
                });
            }(), K = "F1", X(n, t), rt.publish("initialized"), O;
        }
        return yt.API = {
            events: []
        }, yt.version = "0.0.0", "function" == typeof define && define.amd ? define("jsPDF", function() {
            return yt;
        }) : (0, module.exports) ? (module.exports = yt, module.exports.jsPDF = yt) : pt.jsPDF = yt, yt;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof global && global || Function('return typeof this === "object" && this.content')() || Function("return this")());
    /** @preserve
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.4.1 Built on 2018-06-06T07:49:34.040Z
   *                           CommitID 3233f44044
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */ /**
   * jsPDF AcroForm Plugin Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ !function(n, t) {
        var l, a, e = 1, r = function(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
        }, s = function(t) {
            return t * (e / 1);
        }, h = function(t) {
            var e = new I, n = N.internal.getHeight(t) || 0, r = N.internal.getWidth(t) || 0;
            return e.BBox = [
                0,
                0,
                r.toFixed(2),
                n.toFixed(2)
            ], e;
        }, i = function(t, e, n) {
            t = t || 0;
            var r = 1;
            if (r <<= e - 1, 1 == (n = n || 1)) t = t | r;
            else t = t & ~r;
            return t;
        }, o = function(t, e, n) {
            n = n || 1.3, t = t || 0;
            return 1 == e.readOnly && (t = i(t, 1)), 1 == e.required && (t = i(t, 2)), 1 == e.noExport && (t = i(t, 3)), 1 == e.multiline && (t = i(t, 13)), e.password && (t = i(t, 14)), e.noToggleToOff && (t = i(t, 15)), e.radio && (t = i(t, 16)), e.pushbutton && (t = i(t, 17)), e.combo && (t = i(t, 18)), e.edit && (t = i(t, 19)), e.sort && (t = i(t, 20)), e.fileSelect && 1.4 <= n && (t = i(t, 21)), e.multiSelect && 1.4 <= n && (t = i(t, 22)), e.doNotSpellCheck && 1.4 <= n && (t = i(t, 23)), 1 == e.doNotScroll && 1.4 <= n && (t = i(t, 24)), e.richText && 1.4 <= n && (t = i(t, 25)), t;
        }, u = function(t) {
            var e = t[0], n = t[1], r = t[2], i = t[3], o = {};
            return Array.isArray(e) ? (e[0] = s(e[0]), e[1] = s(e[1]), e[2] = s(e[2]), e[3] = s(e[3])) : (e = s(e), n = s(n), r = s(r), i = s(i)), o.lowerLeft_X = e || 0, o.lowerLeft_Y = s(a) - n - i || 0, o.upperRight_X = e + r || 0, o.upperRight_Y = s(a) - n || 0, [
                o.lowerLeft_X.toFixed(2),
                o.lowerLeft_Y.toFixed(2),
                o.upperRight_X.toFixed(2),
                o.upperRight_Y.toFixed(2)
            ];
        }, f = function(t) {
            if (t.appearanceStreamContent) return t.appearanceStreamContent;
            if (t.V || t.DV) {
                var e = [], n = t.V || t.DV, r = c(t, n);
                e.push("/Tx BMC"), e.push("q"), e.push("/F1 " + r.fontSize.toFixed(2) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push("BT"), e.push(r.text), e.push("ET"), e.push("Q"), e.push("EMC");
                var i = new h(t);
                return i.stream = e.join("\n"), i;
            }
        }, c = function(t, e, i, n) {
            n = n || 12, i = i || "helvetica";
            var r = {
                text: "",
                fontSize: ""
            }, o = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" "), a = n, s = N.internal.getHeight(t) || 0;
            s = s < 0 ? -s : s;
            var h = N.internal.getWidth(t) || 0;
            h = h < 0 ? -h : h;
            var c = function(t, e, n) {
                if (t + 1 < o.length) {
                    var r = e + " " + o[t + 1];
                    return A(r, n + "px", i).width <= h - 4;
                }
                return !1;
            };
            a++;
            t: for(;;){
                e = "";
                var l = A("3", --a + "px", i).height, u = t.multiline ? s - a : (s - l) / 2, f = -2, d = u += 2, p = 0, g = 0, m = 0;
                if (a <= 0) {
                    a = 12, e = "(...) Tj\n", e += "% Width of Text: " + A(e, "1px").width + ", FieldWidth:" + h + "\n";
                    break;
                }
                m = A(o[0] + " ", a + "px", i).width;
                var w = "", y = 0;
                for(var v in o){
                    w = " " == (w += o[v] + " ").substr(w.length - 1) ? w.substr(0, w.length - 1) : w;
                    var b = parseInt(v);
                    m = A(w + " ", a + "px", i).width;
                    var x = c(b, w, a), S = v >= o.length - 1;
                    if (!x || S) {
                        if (x || S) {
                            if (S) g = b;
                            else if (t.multiline && s < (l + 2) * (y + 2) + 2) continue t;
                        } else {
                            if (!t.multiline) continue t;
                            if (s < (l + 2) * (y + 2) + 2) continue t;
                            g = b;
                        }
                        for(var k = "", _ = p; _ <= g; _++)k += o[_] + " ";
                        switch(k = " " == k.substr(k.length - 1) ? k.substr(0, k.length - 1) : k, m = A(k, a + "px", i).width, t.Q){
                            case 2:
                                f = h - m - 2;
                                break;
                            case 1:
                                f = (h - m) / 2;
                                break;
                            case 0:
                            default:
                                f = 2;
                        }
                        e += f.toFixed(2) + " " + d.toFixed(2) + " Td\n", e += "(" + k + ") Tj\n", e += -f.toFixed(2) + " 0 Td\n", d = -(a + 2), m = 0, p = g + 1, y++, w = "";
                    } else w += " ";
                }
                break;
            }
            return r.text = e, r.fontSize = a, r;
        }, A = function(t, e, n) {
            n = n || "helvetica";
            var r = l.internal.getFont(n), i = l.getStringUnitWidth(t, {
                font: r,
                fontSize: parseFloat(e),
                charSpace: 0
            }) * parseFloat(e);
            return {
                height: l.getStringUnitWidth("3", {
                    font: r,
                    fontSize: parseFloat(e),
                    charSpace: 0
                }) * parseFloat(e) * 1.5,
                width: i
            };
        }, d = {
            fields: [],
            xForms: [],
            acroFormDictionaryRoot: null,
            printedOut: !1,
            internal: null,
            isInitialized: !1
        }, p = function() {
            for(var t in l.internal.acroformPlugin.acroFormDictionaryRoot.Fields){
                var e = l.internal.acroformPlugin.acroFormDictionaryRoot.Fields[t];
                e.hasAnnotation && m.call(l, e);
            }
        }, g = function(t) {
            l.internal.acroformPlugin.printedOut && (l.internal.acroformPlugin.printedOut = !1, l.internal.acroformPlugin.acroFormDictionaryRoot = null), l.internal.acroformPlugin.acroFormDictionaryRoot || x.call(l), l.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t);
        }, m = function(t) {
            var e = {
                type: "reference",
                object: t
            };
            l.annotationPlugin.annotations[l.internal.getPageInfo(t.page).pageNumber].push(e);
        }, w = function() {
            void 0 !== l.internal.acroformPlugin.acroFormDictionaryRoot ? l.internal.write("/AcroForm " + l.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R") : console.log("Root missing...");
        }, y = function() {
            l.internal.events.unsubscribe(l.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete l.internal.acroformPlugin.acroFormDictionaryRoot._eventID, l.internal.acroformPlugin.printedOut = !0;
        }, v = function(t) {
            var e = !t;
            t || (l.internal.newObjectDeferredBegin(l.internal.acroformPlugin.acroFormDictionaryRoot.objId), l.internal.out(l.internal.acroformPlugin.acroFormDictionaryRoot.getString()));
            t = t || l.internal.acroformPlugin.acroFormDictionaryRoot.Kids;
            for(var n in t){
                var r = t[n], i = r.Rect;
                r.Rect && (r.Rect = u.call(this, r.Rect)), l.internal.newObjectDeferredBegin(r.objId);
                var o = r.objId + " 0 obj\n<<\n";
                if ("object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getContent && (o += r.getContent()), r.Rect = i, r.hasAppearanceStream && !r.appearanceStreamContent) {
                    var a = f.call(this, r);
                    o += "/AP << /N " + a + " >>\n", l.internal.acroformPlugin.xForms.push(a);
                }
                if (r.appearanceStreamContent) {
                    for(var s in o += "/AP << ", r.appearanceStreamContent){
                        var h = r.appearanceStreamContent[s];
                        if (o += "/" + s + " ", o += "<< ", 1 <= Object.keys(h).length || Array.isArray(h)) for(var n in h){
                            var c;
                            "function" == typeof (c = h[n]) && (c = c.call(this, r)), o += "/" + n + " " + c + " ", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        }
                        else "function" == typeof (c = h) && (c = c.call(this, r)), o += "/" + n + " " + c + " \n", 0 <= l.internal.acroformPlugin.xForms.indexOf(c) || l.internal.acroformPlugin.xForms.push(c);
                        o += " >>\n";
                    }
                    o += ">>\n";
                }
                o += ">>\nendobj\n", l.internal.out(o);
            }
            e && b.call(this, l.internal.acroformPlugin.xForms);
        }, b = function(t) {
            for(var e in t){
                var n = e, r = t[e];
                l.internal.newObjectDeferredBegin(r && r.objId);
                var i = "";
                "object" === (void 0 === r ? "undefined" : vt(r)) && "function" == typeof r.getString && (i = r.getString()), l.internal.out(i), delete t[n];
            }
        }, x = function() {
            if (void 0 !== this.internal && (void 0 === this.internal.acroformPlugin || !1 === this.internal.acroformPlugin.isInitialized)) {
                if (l = this, T.FieldNum = 0, this.internal.acroformPlugin = JSON.parse(JSON.stringify(d)), this.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
                e = l.internal.scaleFactor, a = l.internal.pageSize.getHeight(), l.internal.acroformPlugin.acroFormDictionaryRoot = new C, l.internal.acroformPlugin.acroFormDictionaryRoot._eventID = l.internal.events.subscribe("postPutResources", y), l.internal.events.subscribe("buildDocument", p), l.internal.events.subscribe("putCatalog", w), l.internal.events.subscribe("postPutPages", v), l.internal.acroformPlugin.isInitialized = !0;
            }
        }, S = function(t) {
            if (Array.isArray(t)) {
                var e = " [";
                for(var n in t)e += t[n].toString(), e += n < t.length - 1 ? " " : "";
                return e += "]";
            }
        }, k = function(t) {
            return 0 !== (t = t || "").indexOf("(") && (t = "(" + t), ")" != t.substring(t.length - 1) && (t += ")"), t;
        }, _ = function() {
            var t;
            Object.defineProperty(this, "objId", {
                get: function() {
                    return t || (t = l.internal.newObjectDeferred()), t || console.log("Couldn't create Object ID"), t;
                },
                configurable: !1
            });
        };
        _.prototype.toString = function() {
            return this.objId + " 0 R";
        }, _.prototype.getString = function() {
            var t = this.objId + " 0 obj\n<<";
            return t += this.getContent() + ">>\n", this.stream && (t += "stream\n", t += this.stream, t += "\nendstream\n"), t += "endobj\n";
        }, _.prototype.getContent = function() {
            var t = "";
            return t += function(t) {
                var e = "", n = Object.keys(t).filter(function(t) {
                    return "content" != t && "appearanceStreamContent" != t && "_" != t.substring(0, 1);
                });
                for(var r in n){
                    var i = n[r], o = t[i];
                    o && (Array.isArray(o) ? e += "/" + i + " " + S(o) + "\n" : e += o instanceof _ ? "/" + i + " " + o.objId + " 0 R\n" : "/" + i + " " + o + "\n");
                }
                return e;
            }(this);
        };
        var I = function() {
            var e;
            _.call(this), this.Type = "/XObject", this.Subtype = "/Form", this.FormType = 1, this.BBox, this.Matrix, this.Resources = "2 0 R", this.PieceInfo, Object.defineProperty(this, "Length", {
                enumerable: !0,
                get: function() {
                    return void 0 !== e ? e.length : 0;
                }
            }), Object.defineProperty(this, "stream", {
                enumerable: !1,
                set: function(t) {
                    e = t.trim();
                },
                get: function() {
                    return e || null;
                }
            });
        };
        r(I, _);
        var C = function() {
            _.call(this);
            var t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return 0 < t.length ? t : void 0;
                }
            }), Object.defineProperty(this, "Fields", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return t;
                }
            }), this.DA;
        };
        r(C, _);
        var T = function t() {
            var e;
            _.call(this), Object.defineProperty(this, "Rect", {
                enumerable: !0,
                configurable: !1,
                get: function() {
                    if (e) return e;
                },
                set: function(t) {
                    e = t;
                }
            });
            var n, r, i, o, a = "";
            Object.defineProperty(this, "FT", {
                enumerable: !0,
                set: function(t) {
                    a = t;
                },
                get: function() {
                    return a;
                }
            }), Object.defineProperty(this, "T", {
                enumerable: !0,
                configurable: !1,
                set: function(t) {
                    n = t;
                },
                get: function() {
                    if (!n || n.length < 1) {
                        if (this instanceof j) return;
                        return "(FieldObject" + t.FieldNum++ + ")";
                    }
                    return "(" == n.substring(0, 1) && n.substring(n.length - 1) ? n : "(" + n + ")";
                }
            }), Object.defineProperty(this, "DA", {
                enumerable: !0,
                get: function() {
                    if (r) return "(" + r + ")";
                },
                set: function(t) {
                    r = t;
                }
            }), Object.defineProperty(this, "DV", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    if (i) return i;
                },
                set: function(t) {
                    i = t;
                }
            }), Object.defineProperty(this, "V", {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    if (o) return o;
                },
                set: function(t) {
                    o = t;
                }
            }), Object.defineProperty(this, "Type", {
                enumerable: !0,
                get: function() {
                    return this.hasAnnotation ? "/Annot" : null;
                }
            }), Object.defineProperty(this, "Subtype", {
                enumerable: !0,
                get: function() {
                    return this.hasAnnotation ? "/Widget" : null;
                }
            }), this.BG, Object.defineProperty(this, "hasAnnotation", {
                enumerable: !1,
                get: function() {
                    return !!(this.Rect || this.BC || this.BG);
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            }), Object.defineProperty(this, "page", {
                enumerable: !1,
                configurable: !0,
                writable: !0
            });
        };
        r(T, _);
        var F = function() {
            T.call(this), this.FT = "/Ch", this.Opt = [], this.V = "()", this.TI = 0;
            var e = !1;
            Object.defineProperty(this, "combo", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "edit", {
                enumerable: !0,
                set: function(t) {
                    1 == t ? (this._edit = !0, this.combo = !0) : this._edit = !1;
                },
                get: function() {
                    return !!this._edit && this._edit;
                },
                configurable: !1
            }), this.hasAppearanceStream = !0;
        };
        r(F, T);
        var P = function() {
            F.call(this), this.combo = !1;
        };
        r(P, F);
        var E = function() {
            P.call(this), this.combo = !0;
        };
        r(E, P);
        var q = function() {
            E.call(this), this.edit = !0;
        };
        r(q, E);
        var O = function() {
            T.call(this), this.FT = "/Btn";
        };
        r(O, T);
        var B = function() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "pushbutton", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        r(B, O);
        var R = function() {
            O.call(this);
            var e = !0;
            Object.defineProperty(this, "radio", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
            var n, t = [];
            Object.defineProperty(this, "Kids", {
                enumerable: !0,
                get: function() {
                    if (0 < t.length) return t;
                }
            }), Object.defineProperty(this, "__Kids", {
                get: function() {
                    return t;
                }
            }), Object.defineProperty(this, "noToggleToOff", {
                enumerable: !1,
                get: function() {
                    return n;
                },
                set: function(t) {
                    n = t;
                }
            });
        };
        r(R, O);
        var j = function(t, e) {
            T.call(this), this.Parent = t, this._AppearanceType = N.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(e), this.F = i(this.F, 3, 1), this.MK = this._AppearanceType.createMK(), this.AS = "/Off", this._Name = e;
        };
        r(j, T), R.prototype.setAppearance = function(t) {
            if ("createAppearanceStream" in t && "createMK" in t) for(var e in this.__Kids){
                var n = this.__Kids[e];
                n.appearanceStreamContent = t.createAppearanceStream(n._Name), n.MK = t.createMK();
            }
            else console.log("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
        }, R.prototype.createOption = function(t) {
            this.__Kids.length;
            var e = new j(this, t);
            return this.__Kids.push(e), n.addField(e), e;
        };
        var D = function() {
            O.call(this), this.appearanceStreamContent = N.CheckBox.createAppearanceStream(), this.MK = N.CheckBox.createMK(), this.AS = "/On", this.V = "/On";
        };
        r(D, O);
        var M = function() {
            var e, n;
            T.call(this), this.DA = N.createDefaultAppearanceStream(), this.F = 4, Object.defineProperty(this, "V", {
                get: function() {
                    return e ? k(e) : e;
                },
                enumerable: !0,
                set: function(t) {
                    e = t;
                }
            }), Object.defineProperty(this, "DV", {
                get: function() {
                    return n ? k(n) : n;
                },
                enumerable: !0,
                set: function(t) {
                    n = t;
                }
            });
            var r = !1;
            Object.defineProperty(this, "multiline", {
                enumerable: !1,
                get: function() {
                    return r;
                },
                set: function(t) {
                    r = t;
                }
            });
            var i = !1;
            Object.defineProperty(this, "fileSelect", {
                enumerable: !1,
                get: function() {
                    return i;
                },
                set: function(t) {
                    i = t;
                }
            });
            var o = !1;
            Object.defineProperty(this, "doNotSpellCheck", {
                enumerable: !1,
                get: function() {
                    return o;
                },
                set: function(t) {
                    o = t;
                }
            });
            var a = !1;
            Object.defineProperty(this, "doNotScroll", {
                enumerable: !1,
                get: function() {
                    return a;
                },
                set: function(t) {
                    a = t;
                }
            });
            var s = !1;
            Object.defineProperty(this, "MaxLen", {
                enumerable: !0,
                get: function() {
                    return s;
                },
                set: function(t) {
                    s = t;
                }
            }), Object.defineProperty(this, "hasAppearanceStream", {
                enumerable: !1,
                get: function() {
                    return this.V || this.DV;
                }
            });
        };
        r(M, T);
        var U = function() {
            M.call(this);
            var e = !0;
            Object.defineProperty(this, "password", {
                enumerable: !1,
                get: function() {
                    return e;
                },
                set: function(t) {
                    e = t;
                }
            });
        };
        r(U, M);
        var N = {
            CheckBox: {
                createAppearanceStream: function() {
                    return {
                        N: {
                            On: N.CheckBox.YesNormal
                        },
                        D: {
                            On: N.CheckBox.YesPushDown,
                            Off: N.CheckBox.OffPushDown
                        }
                    };
                },
                createMK: function() {
                    return "<< /CA (3)>>";
                },
                YesPushDown: function(t) {
                    var e = h(t), n = [], r = l.internal.getFont("zapfdingbats", "normal").id;
                    t.Q = 1;
                    var i = c(t, "3", "ZapfDingbats", 50);
                    return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), n.push("BMC"), n.push("q"), n.push("0 0 1 rg"), n.push("/" + r + " " + i.fontSize.toFixed(2) + " Tf 0 g"), n.push("BT"), n.push(i.text), n.push("ET"), n.push("Q"), n.push("EMC"), e.stream = n.join("\n"), e;
                },
                YesNormal: function(t) {
                    var e = h(t), n = l.internal.getFont("zapfdingbats", "normal").id, r = [];
                    t.Q = 1;
                    var i = N.internal.getHeight(t), o = N.internal.getWidth(t), a = c(t, "3", "ZapfDingbats", .9 * i);
                    return r.push("1 g"), r.push("0 0 " + o.toFixed(2) + " " + i.toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("0 0 1 rg"), r.push("0 0 " + (o - 1).toFixed(2) + " " + (i - 1).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push("0 g"), r.push("BT"), r.push("/" + n + " " + a.fontSize.toFixed(2) + " Tf 0 g"), r.push(a.text), r.push("ET"), r.push("Q"), e.stream = r.join("\n"), e;
                },
                OffPushDown: function(t) {
                    var e = h(t), n = [];
                    return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                }
            },
            RadioButton: {
                Circle: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Circle.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Circle.YesNormal, e.D[t] = N.RadioButton.Circle.YesPushDown, e;
                    },
                    createMK: function() {
                        return "<< /CA (l)>>";
                    },
                    YesNormal: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4;
                        r *= .9;
                        var i = N.internal.Bezier_C;
                        return n.push("q"), n.push("1 0 0 1 " + N.internal.getWidth(t) / 2 + " " + N.internal.getHeight(t) / 2 + " cm"), n.push(r + " 0 m"), n.push(r + " " + r * i + " " + r * i + " " + r + " 0 " + r + " c"), n.push("-" + r * i + " " + r + " -" + r + " " + r * i + " -" + r + " 0 c"), n.push("-" + r + " -" + r * i + " -" + r * i + " -" + r + " 0 -" + r + " c"), n.push(r * i + " -" + r + " " + r + " -" + r * i + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C, a = r * N.internal.Bezier_C;
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), n.push("0 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(r + " 0 m"), n.push(r + " " + a + " " + a + " " + r + " 0 " + r + " c"), n.push("-" + a + " " + r + " -" + r + " " + a + " -" + r + " 0 c"), n.push("-" + r + " -" + a + " -" + a + " -" + r + " 0 -" + r + " c"), n.push(a + " -" + r + " " + r + " -" + a + " " + r + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = h(t), n = [], r = N.internal.getWidth(t) <= N.internal.getHeight(t) ? N.internal.getWidth(t) / 4 : N.internal.getHeight(t) / 4, i = 2 * (r *= .9), o = i * N.internal.Bezier_C;
                        return n.push("0.749023 g"), n.push("q"), n.push("1 0 0 1 " + (N.internal.getWidth(t) / 2).toFixed(2) + " " + (N.internal.getHeight(t) / 2).toFixed(2) + " cm"), n.push(i + " 0 m"), n.push(i + " " + o + " " + o + " " + i + " 0 " + i + " c"), n.push("-" + o + " " + i + " -" + i + " " + o + " -" + i + " 0 c"), n.push("-" + i + " -" + o + " -" + o + " -" + i + " 0 -" + i + " c"), n.push(o + " -" + i + " " + i + " -" + o + " " + i + " 0 c"), n.push("f"), n.push("Q"), e.stream = n.join("\n"), e;
                    }
                },
                Cross: {
                    createAppearanceStream: function(t) {
                        var e = {
                            D: {
                                Off: N.RadioButton.Cross.OffPushDown
                            },
                            N: {}
                        };
                        return e.N[t] = N.RadioButton.Cross.YesNormal, e.D[t] = N.RadioButton.Cross.YesPushDown, e;
                    },
                    createMK: function() {
                        return "<< /CA (8)>>";
                    },
                    YesNormal: function(t) {
                        var e = h(t), n = [], r = N.internal.calculateCross(t);
                        return n.push("q"), n.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), n.push("W"), n.push("n"), n.push(r.x1.x.toFixed(2) + " " + r.x1.y.toFixed(2) + " m"), n.push(r.x2.x.toFixed(2) + " " + r.x2.y.toFixed(2) + " l"), n.push(r.x4.x.toFixed(2) + " " + r.x4.y.toFixed(2) + " m"), n.push(r.x3.x.toFixed(2) + " " + r.x3.y.toFixed(2) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
                    },
                    YesPushDown: function(t) {
                        var e = h(t), n = N.internal.calculateCross(t), r = [];
                        return r.push("0.749023 g"), r.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), r.push("f"), r.push("q"), r.push("1 1 " + (N.internal.getWidth(t) - 2).toFixed(2) + " " + (N.internal.getHeight(t) - 2).toFixed(2) + " re"), r.push("W"), r.push("n"), r.push(n.x1.x.toFixed(2) + " " + n.x1.y.toFixed(2) + " m"), r.push(n.x2.x.toFixed(2) + " " + n.x2.y.toFixed(2) + " l"), r.push(n.x4.x.toFixed(2) + " " + n.x4.y.toFixed(2) + " m"), r.push(n.x3.x.toFixed(2) + " " + n.x3.y.toFixed(2) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
                    },
                    OffPushDown: function(t) {
                        var e = h(t), n = [];
                        return n.push("0.749023 g"), n.push("0 0 " + N.internal.getWidth(t).toFixed(2) + " " + N.internal.getHeight(t).toFixed(2) + " re"), n.push("f"), e.stream = n.join("\n"), e;
                    }
                }
            },
            createDefaultAppearanceStream: function(t) {
                return "/F1 0 Tf 0 g";
            }
        };
        N.internal = {
            Bezier_C: .551915024494,
            calculateCross: function(t) {
                var e, n, r = N.internal.getWidth(t), i = N.internal.getHeight(t), o = (n = i) < (e = r) ? n : e;
                return {
                    x1: {
                        x: (r - o) / 2,
                        y: (i - o) / 2 + o
                    },
                    x2: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2
                    },
                    x3: {
                        x: (r - o) / 2,
                        y: (i - o) / 2
                    },
                    x4: {
                        x: (r - o) / 2 + o,
                        y: (i - o) / 2 + o
                    }
                };
            }
        }, N.internal.getWidth = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[2])), e;
        }, N.internal.getHeight = function(t) {
            var e = 0;
            return "object" === (void 0 === t ? "undefined" : vt(t)) && (e = s(t.Rect[3])), e;
        }, n.addField = function(t) {
            return x.call(this), t instanceof M ? this.addTextField.call(this, t) : t instanceof F ? this.addChoiceField.call(this, t) : t instanceof O ? this.addButton.call(this, t) : t instanceof j ? g.call(this, t) : t && g.call(this, t), t.page = l.internal.getCurrentPageInfo().pageNumber, this;
        }, n.addButton = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Btn", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addTextField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Tx", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, n.addChoiceField = function(t) {
            x.call(this);
            var e = t || new T;
            e.FT = "/Ch", e.Ff = o(e.Ff, t, l.internal.getPDFVersion()), g.call(this, e);
        }, "object" == (void 0 === t ? "undefined" : vt(t)) && (t.ChoiceField = F, t.ListBox = P, t.ComboBox = E, t.EditBox = q, t.Button = O, t.PushButton = B, t.RadioButton = R, t.CheckBox = D, t.TextField = M, t.PasswordField = U, t.AcroForm = {
            Appearance: N
        }), n.AcroFormChoiceField = F, n.AcroFormListBox = P, n.AcroFormComboBox = E, n.AcroFormEditBox = q, n.AcroFormButton = O, n.AcroFormPushButton = B, n.AcroFormRadioButton = R, n.AcroFormCheckBox = D, n.AcroFormTextField = M, n.AcroFormPasswordField = U, n.AcroForm = {
            ChoiceField: F,
            ListBox: P,
            ComboBox: E,
            EditBox: q,
            Button: O,
            PushButton: B,
            RadioButton: R,
            CheckBox: D,
            TextField: M,
            PasswordField: U
        };
    }($.API, "undefined" != typeof window && window || "undefined" != typeof global && global), $.API.addHTML = function(t, p, g, s, m) {
        if ("undefined" == typeof html2canvas && "undefined" == typeof rasterizeHTML) throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");
        "number" != typeof p && (s = p, m = g), "function" == typeof s && (m = s, s = null), "function" != typeof m && (m = function() {});
        var e = this.internal, w = e.scaleFactor, y = e.pageSize.getWidth(), v = e.pageSize.getHeight();
        if ((s = s || {}).onrendered = (function(h) {
            p = parseInt(p) || 0, g = parseInt(g) || 0;
            var t = s.dim || {}, c = Object.assign({
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                useFor: "content"
            }, s.margin), e = t.h || Math.min(v, h.height / w), l = t.w || Math.min(y, h.width / w) - p, u = s.format || "JPEG", f = s.imageCompression || "SLOW";
            if (h.height > v - c.top - c.bottom && s.pagesplit) {
                var d = function(t, e, n, r, i) {
                    var o = document.createElement("canvas");
                    o.height = i, o.width = r;
                    var a = o.getContext("2d");
                    return a.mozImageSmoothingEnabled = !1, a.webkitImageSmoothingEnabled = !1, a.msImageSmoothingEnabled = !1, a.imageSmoothingEnabled = !1, a.fillStyle = s.backgroundColor || "#ffffff", a.fillRect(0, 0, r, i), a.drawImage(t, e, n, r, i, 0, 0, r, i), o;
                }, n = (function() {
                    for(var t, e, n = 0, r = 0, i = {}, o = !1;;){
                        var a;
                        if (r = 0, i.top = 0 !== n ? c.top : g, i.left = 0 !== n ? c.left : p, o = (y - c.left - c.right) * w < h.width, "content" === c.useFor ? 0 === n ? (t = Math.min((y - c.left) * w, h.width), e = Math.min((v - c.top) * w, h.height - n)) : (t = Math.min(y * w, h.width), e = Math.min(v * w, h.height - n), i.top = 0) : (t = Math.min((y - c.left - c.right) * w, h.width), e = Math.min((v - c.bottom - c.top) * w, h.height - n)), o) for(;;){
                            "content" === c.useFor && (0 === r ? t = Math.min((y - c.left) * w, h.width) : (t = Math.min(y * w, h.width - r), i.left = 0));
                            var s = [
                                a = d(h, r, n, t, e),
                                i.left,
                                i.top,
                                a.width / w,
                                a.height / w,
                                u,
                                null,
                                f
                            ];
                            if (this.addImage.apply(this, s), (r += t) >= h.width) break;
                            this.addPage();
                        }
                        else s = [
                            a = d(h, 0, n, t, e),
                            i.left,
                            i.top,
                            a.width / w,
                            a.height / w,
                            u,
                            null,
                            f
                        ], this.addImage.apply(this, s);
                        if ((n += e) >= h.height) break;
                        this.addPage();
                    }
                    m(l, n, null, s);
                }).bind(this);
                if ("CANVAS" === h.nodeName) {
                    var r = new Image;
                    r.onload = n, r.src = h.toDataURL("image/png"), h = r;
                } else n();
            } else {
                var i = Math.random().toString(35), o = [
                    h,
                    p,
                    g,
                    l,
                    e,
                    u,
                    i,
                    f
                ];
                this.addImage.apply(this, o), m(l, e, i, o);
            }
        }).bind(this), "undefined" != typeof html2canvas && !s.rstz) return html2canvas(t, s);
        if ("undefined" != typeof rasterizeHTML) {
            var n = "drawDocument";
            return "string" == typeof t && (n = /^http/.test(t) ? "drawURL" : "drawHTML"), s.width = s.width || y * w, rasterizeHTML[n](t, void 0, s).then(function(t) {
                s.onrendered(t.image);
            }, function(t) {
                m(null, t);
            });
        }
        return null;
    }, /** @preserve
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */ function(b) {
        var x = "addImage_", h = {
            PNG: [
                [
                    137,
                    80,
                    78,
                    71
                ]
            ],
            TIFF: [
                [
                    77,
                    77,
                    0,
                    42
                ],
                [
                    73,
                    73,
                    42,
                    0
                ]
            ],
            JPEG: [
                [
                    255,
                    216,
                    255,
                    224,
                    void 0,
                    void 0,
                    74,
                    70,
                    73,
                    70,
                    0
                ],
                [
                    255,
                    216,
                    255,
                    225,
                    void 0,
                    void 0,
                    69,
                    120,
                    105,
                    102,
                    0,
                    0
                ]
            ],
            JPEG2000: [
                [
                    0,
                    0,
                    0,
                    12,
                    106,
                    80,
                    32,
                    32
                ]
            ],
            GIF87a: [
                [
                    71,
                    73,
                    70,
                    56,
                    55,
                    97
                ]
            ],
            GIF89a: [
                [
                    71,
                    73,
                    70,
                    56,
                    57,
                    97
                ]
            ],
            BMP: [
                [
                    66,
                    77
                ],
                [
                    66,
                    65
                ],
                [
                    67,
                    73
                ],
                [
                    67,
                    80
                ],
                [
                    73,
                    67
                ],
                [
                    80,
                    84
                ]
            ]
        };
        b.getImageFileTypeByImageData = function(t, e) {
            var n, r;
            e = e || "UNKNOWN";
            var i, o, a, s = "UNKNOWN";
            for(a in h)for(i = h[a], n = 0; n < i.length; n += 1){
                for(o = !0, r = 0; r < i[n].length; r += 1)if (void 0 !== i[n][r] && i[n][r] !== t.charCodeAt(r)) {
                    o = !1;
                    break;
                }
                if (!0 === o) {
                    s = a;
                    break;
                }
            }
            return "UNKOWN" === s && "UNKNOWN" !== e && (console.warn('FileType of Image not recognized. Processing image as "' + e + '".'), s = e), s;
        };
        var n = function t(e) {
            var n = this.internal.newObject(), r = this.internal.write, i = this.internal.putStream;
            if (e.n = n, r("<</Type /XObject"), r("/Subtype /Image"), r("/Width " + e.w), r("/Height " + e.h), e.cs === this.color_spaces.INDEXED ? r("/ColorSpace [/Indexed /DeviceRGB " + (e.pal.length / 3 - 1) + " " + ("smask" in e ? n + 2 : n + 1) + " 0 R]") : (r("/ColorSpace /" + e.cs), e.cs === this.color_spaces.DEVICE_CMYK && r("/Decode [1 0 1 0 1 0 1 0]")), r("/BitsPerComponent " + e.bpc), "f" in e && r("/Filter /" + e.f), "dp" in e && r("/DecodeParms <<" + e.dp + ">>"), "trns" in e && e.trns.constructor == Array) {
                for(var o = "", a = 0, s = e.trns.length; a < s; a++)o += e.trns[a] + " " + e.trns[a] + " ";
                r("/Mask [" + o + "]");
            }
            if ("smask" in e && r("/SMask " + (n + 1) + " 0 R"), r("/Length " + e.data.length + ">>"), i(e.data), r("endobj"), "smask" in e) {
                var h = "/Predictor " + e.p + " /Colors 1 /BitsPerComponent " + e.bpc + " /Columns " + e.w, c = {
                    w: e.w,
                    h: e.h,
                    cs: "DeviceGray",
                    bpc: e.bpc,
                    dp: h,
                    data: e.smask
                };
                "f" in e && (c.f = e.f), t.call(this, c);
            }
            e.cs === this.color_spaces.INDEXED && (this.internal.newObject(), r("<< /Length " + e.pal.length + ">>"), i(this.arrayBufferToBinaryString(new Uint8Array(e.pal))), r("endobj"));
        }, S = function() {
            var t = this.internal.collections[x + "images"];
            for(var e in t)n.call(this, t[e]);
        }, k = function() {
            var t, e = this.internal.collections[x + "images"], n = this.internal.write;
            for(var r in e)n("/I" + (t = e[r]).i, t.n, "0", "R");
        }, _ = function(t) {
            return "function" == typeof b["process" + t.toUpperCase()];
        }, A = function(t) {
            return "object" === (void 0 === t ? "undefined" : vt(t)) && 1 === t.nodeType;
        }, I = function(t, e) {
            if ("IMG" === t.nodeName && t.hasAttribute("src")) {
                var n = "" + t.getAttribute("src");
                if (0 === n.indexOf("data:image/")) return n;
                !e && /\.png(?:[?#].*)?$/i.test(n) && (e = "png");
            }
            if ("CANVAS" === t.nodeName) var r = t;
            else {
                (r = document.createElement("canvas")).width = t.clientWidth || t.width, r.height = t.clientHeight || t.height;
                var i = r.getContext("2d");
                if (!i) throw "addImage requires canvas to be supported by browser.";
                i.drawImage(t, 0, 0, r.width, r.height);
            }
            return r.toDataURL("png" == ("" + e).toLowerCase() ? "image/png" : "image/jpeg");
        }, C = function(t, e) {
            var n;
            if (e) {
                for(var r in e)if (t === e[r].alias) {
                    n = e[r];
                    break;
                }
            }
            return n;
        };
        b.color_spaces = {
            DEVICE_RGB: "DeviceRGB",
            DEVICE_GRAY: "DeviceGray",
            DEVICE_CMYK: "DeviceCMYK",
            CAL_GREY: "CalGray",
            CAL_RGB: "CalRGB",
            LAB: "Lab",
            ICC_BASED: "ICCBased",
            INDEXED: "Indexed",
            PATTERN: "Pattern",
            SEPARATION: "Separation",
            DEVICE_N: "DeviceN"
        }, b.decode = {
            DCT_DECODE: "DCTDecode",
            FLATE_DECODE: "FlateDecode",
            LZW_DECODE: "LZWDecode",
            JPX_DECODE: "JPXDecode",
            JBIG2_DECODE: "JBIG2Decode",
            ASCII85_DECODE: "ASCII85Decode",
            ASCII_HEX_DECODE: "ASCIIHexDecode",
            RUN_LENGTH_DECODE: "RunLengthDecode",
            CCITT_FAX_DECODE: "CCITTFaxDecode"
        }, b.image_compression = {
            NONE: "NONE",
            FAST: "FAST",
            MEDIUM: "MEDIUM",
            SLOW: "SLOW"
        }, b.sHashCode = function(t) {
            return t = t || "", Array.prototype.reduce && t.split("").reduce(function(t, e) {
                return (t = (t << 5) - t + e.charCodeAt(0)) & t;
            }, 0);
        }, b.isString = function(t) {
            return "string" == typeof t;
        }, b.validateStringAsBase64 = function(t) {
            var e = !0;
            return (t = t || "").length % 4 != 0 && (e = !1), !1 === /[A-Za-z0-9\/]+/.test(t.substr(0, t.length - 2)) && (e = !1), !1 === /[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==/.test(t.substr(-2)) && (e = !1), e;
        }, b.extractInfoFromBase64DataURI = function(t) {
            return /^data:([\w]+?\/([\w]+?));base64,(.+)$/g.exec(t);
        }, b.supportsArrayBuffer = function() {
            return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
        }, b.isArrayBuffer = function(t) {
            return !!this.supportsArrayBuffer() && t instanceof ArrayBuffer;
        }, b.isArrayBufferView = function(t) {
            return !!this.supportsArrayBuffer() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
        }, b.binaryStringToUint8Array = function(t) {
            for(var e = t.length, n = new Uint8Array(e), r = 0; r < e; r++)n[r] = t.charCodeAt(r);
            return n;
        }, b.arrayBufferToBinaryString = function(t) {
            if ("function" == typeof atob) return atob(this.arrayBufferToBase64(t));
            if ("function" == typeof TextDecoder) {
                var e = new TextDecoder("ascii");
                if ("ascii" === e.encoding) return e.decode(t);
            }
            for(var n = this.isArrayBuffer(t) ? t : new Uint8Array(t), r = 20480, i = "", o = Math.ceil(n.byteLength / r), a = 0; a < o; a++)i += String.fromCharCode.apply(null, n.slice(a * r, a * r + r));
            return i;
        }, b.arrayBufferToBase64 = function(t) {
            for(var e, n = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", i = new Uint8Array(t), o = i.byteLength, a = o % 3, s = o - a, h = 0; h < s; h += 3)n += r[(16515072 & (e = i[h] << 16 | i[h + 1] << 8 | i[h + 2])) >> 18] + r[(258048 & e) >> 12] + r[(4032 & e) >> 6] + r[63 & e];
            return 1 == a ? n += r[(252 & (e = i[s])) >> 2] + r[(3 & e) << 4] + "==" : 2 == a && (n += r[(64512 & (e = i[s] << 8 | i[s + 1])) >> 10] + r[(1008 & e) >> 4] + r[(15 & e) << 2] + "="), n;
        }, b.createImageInfo = function(t, e, n, r, i, o, a, s, h, c, l, u, f) {
            var d = {
                alias: s,
                w: e,
                h: n,
                cs: r,
                bpc: i,
                i: a,
                data: t
            };
            return o && (d.f = o), h && (d.dp = h), c && (d.trns = c), l && (d.pal = l), u && (d.smask = u), f && (d.p = f), d;
        }, b.addImage = function(t, e, n, r, i, o, a, s, h) {
            var c = "";
            if ("string" != typeof e) {
                var l = o;
                o = i, i = r, r = n, n = e, e = l;
            }
            if ("object" === (void 0 === t ? "undefined" : vt(t)) && !A(t) && "imageData" in t) {
                var u = t;
                t = u.imageData, e = u.format || e, n = u.x || n || 0, r = u.y || r || 0, i = u.w || i, o = u.h || o, a = u.alias || a, s = u.compression || s, h = u.rotation || u.angle || h;
            }
            if (isNaN(n) || isNaN(r)) throw console.error("jsPDF.addImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addImage");
            var f, d, p, g, m, w, y, v = (function() {
                var t = this.internal.collections[x + "images"];
                return t || (this.internal.collections[x + "images"] = t = {}, this.internal.events.subscribe("putResources", S), this.internal.events.subscribe("putXobjectDict", k)), t;
            }).call(this);
            if (!(f = C(t, v)) && (A(t) && (t = I(t, e)), (null == (y = a) || 0 === y.length) && (a = "string" == typeof (w = t) && b.sHashCode(w)), !(f = C(a, v)))) {
                if (this.isString(t) && ("" !== (c = this.convertStringToImageData(t)) ? t = c : void 0 !== (c = this.loadImageFile(t)) && (t = c)), e = this.getImageFileTypeByImageData(t, e), !_(e)) throw new Error("addImage does not support files of type '" + e + "', please ensure that a plugin for '" + e + "' support is added.");
                if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (d = t, t = this.binaryStringToUint8Array(t))), !(f = this["process" + e.toUpperCase()](t, (m = 0, (g = v) && (m = Object.keys ? Object.keys(g).length : function(t) {
                    var e = 0;
                    for(var n in t)t.hasOwnProperty(n) && e++;
                    return e;
                }(g)), m), a, ((p = s) && "string" == typeof p && (p = p.toUpperCase()), p in b.image_compression ? p : b.image_compression.NONE), d))) throw new Error("An unkwown error occurred whilst processing the image");
            }
            return (function(t, e, n, r, i, o, a, s) {
                var h = (function(t, e, n) {
                    return t || e || (e = t = -96), t < 0 && (t = -1 * n.w * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * n.h * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * n.w / n.h), 0 === e && (e = t * n.h / n.w), [
                        t,
                        e
                    ];
                }).call(this, n, r, i), c = this.internal.getCoordinateString, l = this.internal.getVerticalCoordinateString;
                if (n = h[0], r = h[1], a[o] = i, s) {
                    s *= Math.PI / 180;
                    var u = Math.cos(s), f = Math.sin(s), d = function(t) {
                        return t.toFixed(4);
                    }, p = [
                        d(u),
                        d(f),
                        d(-1 * f),
                        d(u),
                        0,
                        0,
                        "cm"
                    ];
                }
                this.internal.write("q"), s ? (this.internal.write([
                    1,
                    "0",
                    "0",
                    1,
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    "0",
                    "0",
                    "cm"
                ].join(" "))) : this.internal.write([
                    c(n),
                    "0",
                    "0",
                    c(r),
                    c(t),
                    l(e + r),
                    "cm"
                ].join(" ")), this.internal.write("/I" + i.i + " Do"), this.internal.write("Q");
            }).call(this, n, r, i, o, f, f.i, v, h), this;
        }, b.convertStringToImageData = function(t) {
            var e, n = "";
            this.isString(t) && (null !== (e = this.extractInfoFromBase64DataURI(t)) ? b.validateStringAsBase64(e[3]) && (n = atob(e[3])) : b.validateStringAsBase64(t) && (n = atob(t)));
            return n;
        };
        var c = function(t, e) {
            return t.subarray(e, e + 5);
        };
        b.processJPEG = function(t, e, n, r, i, o) {
            var a, s = this.decode.DCT_DECODE;
            if (!this.isString(t) && !this.isArrayBuffer(t) && !this.isArrayBufferView(t)) return null;
            if (this.isString(t) && (a = function(t) {
                var e;
                if ((t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3), !t.charCodeAt(6) === "J".charCodeAt(0)) || !t.charCodeAt(7) === "F".charCodeAt(0) || !t.charCodeAt(8) === "I".charCodeAt(0) || !t.charCodeAt(9) === "F".charCodeAt(0) || (t.charCodeAt(10), false)) throw new Error("getJpegSize requires a binary string jpeg file");
                for(var n = 256 * t.charCodeAt(4) + t.charCodeAt(5), r = 4, i = t.length; r < i;){
                    if (r += n, 255 !== t.charCodeAt(r)) throw new Error("getJpegSize could not find the size of the image");
                    if (192 === t.charCodeAt(r + 1) || 193 === t.charCodeAt(r + 1) || 194 === t.charCodeAt(r + 1) || 195 === t.charCodeAt(r + 1) || 196 === t.charCodeAt(r + 1) || 197 === t.charCodeAt(r + 1) || 198 === t.charCodeAt(r + 1) || 199 === t.charCodeAt(r + 1)) return e = 256 * t.charCodeAt(r + 5) + t.charCodeAt(r + 6), [
                        256 * t.charCodeAt(r + 7) + t.charCodeAt(r + 8),
                        e,
                        t.charCodeAt(r + 9)
                    ];
                    r += 2, n = 256 * t.charCodeAt(r) + t.charCodeAt(r + 1);
                }
            }(t)), this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t) && (a = function(t) {
                if (65496 != (t[0] << 8 | t[1])) throw new Error("Supplied data is not a JPEG");
                for(var e, n = t.length, r = (t[4] << 8) + t[5], i = 4; i < n;){
                    if (r = ((e = c(t, i += r))[2] << 8) + e[3], (192 === e[1] || 194 === e[1]) && 255 === e[0] && 7 < r) return {
                        width: ((e = c(t, i + 5))[2] << 8) + e[3],
                        height: (e[0] << 8) + e[1],
                        numcomponents: e[4]
                    };
                    i += 2;
                }
                throw new Error("getJpegSizeFromBytes could not find the size of the image");
            }(t), t = i || this.arrayBufferToBinaryString(t)), void 0 === o) switch(a.numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                default:
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            return this.createImageInfo(t, a.width, a.height, o, 8, s, e, n);
        }, b.processJPG = function() {
            return this.processJPEG.apply(this, arguments);
        }, b.loadImageFile = function(t, e, n) {
            e = e || !0, n = n || function() {};
            Object.prototype.toString.call("undefined" != typeof process ? process : 0);
            if (void 0 !== ("undefined" == typeof window ? "undefined" : vt(window)) && "object" === ("undefined" == typeof location ? "undefined" : vt(location)) && "http" === location.protocol.substr(0, 4)) return function(t, e, n) {
                var r = new XMLHttpRequest, i = [], o = 0, a = function(t) {
                    var e = t.length, n = String.fromCharCode;
                    for(o = 0; o < e; o += 1)i.push(n(255 & t.charCodeAt(o)));
                    return i.join("");
                };
                if (r.open("GET", t, !e), r.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (r.onload = function() {
                    return a(this.responseText);
                }), r.send(null), 200 === r.status) return e ? a(r.responseText) : void 0;
                console.warn('Unable to load file "' + t + '"');
            }(t, e);
        }, b.getImageProperties = function(t) {
            var e, n, r = "";
            if (A(t) && (t = I(t)), this.isString(t) && ("" !== (r = this.convertStringToImageData(t)) ? t = r : void 0 !== (r = this.loadImageFile(t)) && (t = r)), n = this.getImageFileTypeByImageData(t), !_(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
            if (this.supportsArrayBuffer() && (t instanceof Uint8Array || (t = this.binaryStringToUint8Array(t))), !(e = this["process" + n.toUpperCase()](t))) throw new Error("An unkwown error occurred whilst processing the image");
            return {
                fileType: n,
                width: e.w,
                height: e.h,
                colorSpace: e.cs,
                compressionMode: e.f,
                bitsPerComponent: e.bpc
            };
        };
    }($.API), /**
   * jsPDF Annotations PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ t = $.API, y = {
        annotations: [],
        f2: function(t) {
            return t.toFixed(2);
        },
        notEmpty: function(t) {
            if (void 0 !== t && "" != t) return !0;
        }
    }, $.API.annotationPlugin = y, $.API.events.push([
        "addPage",
        function(t) {
            this.annotationPlugin.annotations[t.pageNumber] = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var e = this.annotationPlugin.annotations[t.pageNumber], n = !1, r = 0; r < e.length && !n; r++)switch((h = e[r]).type){
                case "link":
                    if (y.notEmpty(h.options.url) || y.notEmpty(h.options.pageNumber)) {
                        n = !0;
                        break;
                    }
                case "reference":
                case "text":
                case "freetext":
                    n = !0;
            }
            if (0 != n) {
                this.internal.write("/Annots [");
                var i = this.annotationPlugin.f2, o = this.internal.scaleFactor, a = this.internal.pageSize.getHeight(), s = this.internal.getPageInfo(t.pageNumber);
                for(r = 0; r < e.length; r++){
                    var h;
                    switch((h = e[r]).type){
                        case "reference":
                            this.internal.write(" " + h.object.objId + " 0 R ");
                            break;
                        case "text":
                            var c = this.internal.newAdditionalObject(), l = this.internal.newAdditionalObject(), u = h.title || "Note";
                            m = "<</Type /Annot /Subtype /Text " + (d = "/Rect [" + i(h.bounds.x * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w) * o) + " " + i((a - h.bounds.y) * o) + "] ") + "/Contents (" + h.contents + ")", m += " /Popup " + l.objId + " 0 R", m += " /P " + s.objId + " 0 R", m += " /T (" + u + ") >>", c.content = m;
                            var f = c.objId + " 0 R";
                            m = "<</Type /Annot /Subtype /Popup " + (d = "/Rect [" + i((h.bounds.x + 30) * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + " " + i((h.bounds.x + h.bounds.w + 30) * o) + " " + i((a - h.bounds.y) * o) + "] ") + " /Parent " + f, h.open && (m += " /Open true"), m += " >>", l.content = m, this.internal.write(c.objId, "0 R", l.objId, "0 R");
                            break;
                        case "freetext":
                            var d = "/Rect [" + i(h.bounds.x * o) + " " + i((a - h.bounds.y) * o) + " " + i(h.bounds.x + h.bounds.w * o) + " " + i(a - (h.bounds.y + h.bounds.h) * o) + "] ", p = h.color || "#000000";
                            m = "<</Type /Annot /Subtype /FreeText " + d + "/Contents (" + h.contents + ")", m += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + p + ")", m += " /Border [0 0 0]", m += " >>", this.internal.write(m);
                            break;
                        case "link":
                            if (h.options.name) {
                                var g = this.annotations._nameMap[h.options.name];
                                h.options.pageNumber = g.page, h.options.top = g.y;
                            } else h.options.top || (h.options.top = 0);
                            d = "/Rect [" + i(h.x * o) + " " + i((a - h.y) * o) + " " + i((h.x + h.w) * o) + " " + i((a - (h.y + h.h)) * o) + "] ";
                            var m = "";
                            if (h.options.url) m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /A <</S /URI /URI (" + h.options.url + ") >>";
                            else if (h.options.pageNumber) switch(m = "<</Type /Annot /Subtype /Link " + d + "/Border [0 0 0] /Dest [" + (t = this.internal.getPageInfo(h.options.pageNumber)).objId + " 0 R", h.options.magFactor = h.options.magFactor || "XYZ", h.options.magFactor){
                                case "Fit":
                                    m += " /Fit]";
                                    break;
                                case "FitH":
                                    m += " /FitH " + h.options.top + "]";
                                    break;
                                case "FitV":
                                    h.options.left = h.options.left || 0, m += " /FitV " + h.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var w = i((a - h.options.top) * o);
                                    h.options.left = h.options.left || 0, void 0 === h.options.zoom && (h.options.zoom = 0), m += " /XYZ " + h.options.left + " " + w + " " + h.options.zoom + "]";
                            }
                            "" != m && (m += " >>", this.internal.write(m));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push(t);
        }
    }, t.link = function(t, e, n, r, i) {
        this.annotationPlugin.annotations[this.internal.getCurrentPageInfo().pageNumber].push({
            x: t,
            y: e,
            w: n,
            h: r,
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, n, r) {
        var i = this.getTextWidth(t), o = this.internal.getLineHeight() / this.internal.scaleFactor;
        return this.text(t, e, n), n += .2 * o, this.link(e, n - o, i, o, r), i;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    }, t.getLineHeight = function() {
        return this.internal.getLineHeight();
    }, function(t) {
        var a = Object.keys({
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            ur: "Urdu"
        }), u = {
            1569: [
                65152
            ],
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1572: [
                65157,
                65158
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1574: [
                65161,
                65162,
                65163,
                65164
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ],
            1576: [
                65167,
                65168,
                65169,
                65170
            ],
            1577: [
                65171,
                65172
            ],
            1578: [
                65173,
                65174,
                65175,
                65176
            ],
            1579: [
                65177,
                65178,
                65179,
                65180
            ],
            1580: [
                65181,
                65182,
                65183,
                65184
            ],
            1581: [
                65185,
                65186,
                65187,
                65188
            ],
            1582: [
                65189,
                65190,
                65191,
                65192
            ],
            1583: [
                65193,
                65194,
                65193
            ],
            1584: [
                65195,
                65196,
                65195
            ],
            1585: [
                65197,
                65198,
                65197
            ],
            1586: [
                65199,
                65200,
                65199
            ],
            1587: [
                65201,
                65202,
                65203,
                65204
            ],
            1588: [
                65205,
                65206,
                65207,
                65208
            ],
            1589: [
                65209,
                65210,
                65211,
                65212
            ],
            1590: [
                65213,
                65214,
                65215,
                65216
            ],
            1591: [
                65217,
                65218,
                65219,
                65220
            ],
            1592: [
                65221,
                65222,
                65223,
                65224
            ],
            1593: [
                65225,
                65226,
                65227,
                65228
            ],
            1594: [
                65229,
                65230,
                65231,
                65232
            ],
            1601: [
                65233,
                65234,
                65235,
                65236
            ],
            1602: [
                65237,
                65238,
                65239,
                65240
            ],
            1603: [
                65241,
                65242,
                65243,
                65244
            ],
            1604: [
                65245,
                65246,
                65247,
                65248
            ],
            1605: [
                65249,
                65250,
                65251,
                65252
            ],
            1606: [
                65253,
                65254,
                65255,
                65256
            ],
            1607: [
                65257,
                65258,
                65259,
                65260
            ],
            1608: [
                65261,
                65262,
                65261
            ],
            1609: [
                65263,
                65264,
                64488,
                64489
            ],
            1610: [
                65265,
                65266,
                65267,
                65268
            ],
            1649: [
                64336,
                64337
            ],
            1655: [
                64477
            ],
            1657: [
                64358,
                64359,
                64360,
                64361
            ],
            1658: [
                64350,
                64351,
                64352,
                64353
            ],
            1659: [
                64338,
                64339,
                64340,
                64341
            ],
            1662: [
                64342,
                64343,
                64344,
                64345
            ],
            1663: [
                64354,
                64355,
                64356,
                64357
            ],
            1664: [
                64346,
                64347,
                64348,
                64349
            ],
            1667: [
                64374,
                64375,
                64376,
                64377
            ],
            1668: [
                64370,
                64371,
                64372,
                64373
            ],
            1670: [
                64378,
                64379,
                64380,
                64381
            ],
            1671: [
                64382,
                64383,
                64384,
                64385
            ],
            1672: [
                64392,
                64393
            ],
            1676: [
                64388,
                64389
            ],
            1677: [
                64386,
                64387
            ],
            1678: [
                64390,
                64391
            ],
            1681: [
                64396,
                64397
            ],
            1688: [
                64394,
                64395,
                64394
            ],
            1700: [
                64362,
                64363,
                64364,
                64365
            ],
            1702: [
                64366,
                64367,
                64368,
                64369
            ],
            1705: [
                64398,
                64399,
                64400,
                64401
            ],
            1709: [
                64467,
                64468,
                64469,
                64470
            ],
            1711: [
                64402,
                64403,
                64404,
                64405
            ],
            1713: [
                64410,
                64411,
                64412,
                64413
            ],
            1715: [
                64406,
                64407,
                64408,
                64409
            ],
            1722: [
                64414,
                64415
            ],
            1723: [
                64416,
                64417,
                64418,
                64419
            ],
            1726: [
                64426,
                64427,
                64428,
                64429
            ],
            1728: [
                64420,
                64421
            ],
            1729: [
                64422,
                64423,
                64424,
                64425
            ],
            1733: [
                64480,
                64481
            ],
            1734: [
                64473,
                64474
            ],
            1735: [
                64471,
                64472
            ],
            1736: [
                64475,
                64476
            ],
            1737: [
                64482,
                64483
            ],
            1739: [
                64478,
                64479
            ],
            1740: [
                64508,
                64509,
                64510,
                64511
            ],
            1744: [
                64484,
                64485,
                64486,
                64487
            ],
            1746: [
                64430,
                64431
            ],
            1747: [
                64432,
                64433
            ]
        }, f = {
            1570: [
                65269,
                65270,
                65269,
                65270
            ],
            1571: [
                65271,
                65272,
                65271,
                65272
            ],
            1573: [
                65273,
                65274,
                65273,
                65274
            ],
            1575: [
                65275,
                65276,
                65275,
                65276
            ]
        }, d = {
            1570: [
                65153,
                65154,
                65153,
                65154
            ],
            1571: [
                65155,
                65156,
                65155,
                65156
            ],
            1573: [
                65159,
                65160,
                65159,
                65160
            ],
            1575: [
                65165,
                65166,
                65165,
                65166
            ]
        }, p = {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }, e = [
            1570,
            1571,
            1573,
            1575
        ], n = [
            1569,
            1570,
            1571,
            1572,
            1573,
            1575,
            1577,
            1583,
            1584,
            1585,
            1586,
            1608,
            1688
        ], o = 0, s = 1, h = 2, c = 3;
        function g(t) {
            return void 0 !== t && void 0 !== u[t.charCodeAt(0)];
        }
        function l(t) {
            return void 0 !== t && 0 <= n.indexOf(t.charCodeAt(0));
        }
        function m(t) {
            return void 0 !== t && 0 <= e.indexOf(t.charCodeAt(0));
        }
        function w(t) {
            return g(t) && 2 <= u[t.charCodeAt(0)].length;
        }
        function y(t, e, n, r) {
            var i;
            return g(t) ? (r = r || {}, u = Object.assign(u, r), !w(t) || !g(e) && !g(n) || !g(n) && l(e) || l(t) && !g(e) || l(t) && m(e) || l(t) && l(e) ? (u = Object.assign(u, d), o) : g(i = t) && 4 == u[i.charCodeAt(0)].length && g(e) && !l(e) && g(n) && w(n) ? (u = Object.assign(u, d), c) : l(t) || !g(n) ? (u = Object.assign(u, d), s) : (u = Object.assign(u, d), h)) : -1;
        }
        var v = t.processArabic = function(t, e) {
            t = t || "", e = e || !1;
            var n, r, i, o = "", a = 0, s = 0, h = "", c = "", l = "";
            for(a = 0; a < t.length; a += 1)h = t[a], c = t[a - 1], l = t[a + 1], g(h) ? void 0 !== c && 1604 === c.charCodeAt(0) && m(h) ? (s = y(h, t[a - 2], t[a + 1], f), n = String.fromCharCode(f[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : void 0 !== c && 1617 === c.charCodeAt(0) && void 0 !== (r = h) && void 0 !== p[r.charCodeAt(0)] ? (s = y(h, t[a - 2], t[a + 1], d), n = String.fromCharCode(p[h.charCodeAt(0)][s]), o = o.substr(0, o.length - 1) + n) : (s = y(h, c, l, d), o += String.fromCharCode(u[h.charCodeAt(0)][s])) : o += e ? ({
                "(": ")",
                ")": "("
            })[i = h] || i : h;
            return e ? o.split("").reverse().join("") : o;
        };
        t.events.push([
            "preProcessText",
            function(t) {
                var e = t.text, n = (t.x, t.y, t.options || {}), r = (t.mutex, n.lang), i = [];
                if (0 <= a.indexOf(r)) {
                    if ("[object Array]" === Object.prototype.toString.call(e)) {
                        var o = 0;
                        for(i = [], o = 0; o < e.length; o += 1)"[object Array]" === Object.prototype.toString.call(e[o]) ? i.push([
                            v(e[o][0], !0),
                            e[o][1],
                            e[o][2]
                        ]) : i.push([
                            v(e[o], !0)
                        ]);
                        t.text = i;
                    } else t.text = v(e, !0);
                    void 0 === n.charSpace && (t.options.charSpace = 0), !0 === n.R2L && (t.options.R2L = !1);
                }
            }
        ]);
    }($.API), $.API.autoPrint = function(t) {
        var e;
        switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
            case "javascript":
                this.addJS("print({});");
                break;
            case "non-conform":
            default:
                this.internal.events.subscribe("postPutResources", function() {
                    e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
                }), this.internal.events.subscribe("putCatalog", function() {
                    this.internal.out("/OpenAction " + e + " 0 R");
                });
        }
        return this;
    }, /**
   * jsPDF Canvas PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (e = $.API).events.push([
        "initialized",
        function() {
            this.canvas.pdf = this;
        }
    ]), e.canvas = {
        getContext: function(t) {
            return (this.pdf.context2d._canvas = this).pdf.context2d;
        },
        childNodes: []
    }, Object.defineProperty(e.canvas, "width", {
        get: function() {
            return this._width;
        },
        set: function(t) {
            this._width = t, this.getContext("2d").pageWrapX = t + 1;
        }
    }), Object.defineProperty(e.canvas, "height", {
        get: function() {
            return this._height;
        },
        set: function(t) {
            this._height = t, this.getContext("2d").pageWrapY = t + 1;
        }
    }), /** ====================================================================
   * jsPDF Cell plugin
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */ I = $.API, C = {
        x: void 0,
        y: void 0,
        w: void 0,
        h: void 0,
        ln: void 0
    }, T = 1, d = function(t, e, n, r, i) {
        C = {
            x: t,
            y: e,
            w: n,
            h: r,
            ln: i
        };
    }, p = function() {
        return C;
    }, F = {
        left: 0,
        top: 0,
        bottom: 0
    }, I.setHeaderFunction = function(t) {
        h = t;
    }, I.getTextDimensions = function(e) {
        i = this.internal.getFont().fontName, o = this.table_font_size || this.internal.getFontSize(), a = this.internal.getFont().fontStyle;
        var t, n, r = 19.049976 / 25.4;
        (n = document.createElement("font")).id = "jsPDFCell";
        try {
            n.style.fontStyle = a;
        } catch (t) {
            n.style.fontWeight = a;
        }
        n.style.fontSize = o + "pt", n.style.fontFamily = i;
        try {
            n.textContent = e;
        } catch (t) {
            n.innerText = e;
        }
        return document.body.appendChild(n), t = {
            w: (n.offsetWidth + 1) * r,
            h: (n.offsetHeight + 1) * r
        }, document.body.removeChild(n), t;
    }, I.cellAddPage = function() {
        var t = this.margins || F;
        this.addPage(), d(t.left, t.top, void 0, void 0), T += 1;
    }, I.cellInitialize = function() {
        C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1;
    }, I.cell = function(t, e, n, r, i, o, a) {
        var s = p(), h = !1;
        if (void 0 !== s.ln) {
            if (s.ln === o) t = s.x + s.w, e = s.y;
            else {
                var c = this.margins || F;
                s.y + s.h + r + 13 >= this.internal.pageSize.getHeight() - c.bottom && (this.cellAddPage(), h = !0, this.printHeaders && this.tableHeaderRow && this.printHeaderRow(o, !0)), e = p().y + p().h, h && (e = 23);
            }
        }
        if (void 0 !== i[0]) {
            if (this.printingHeaderRow ? this.rect(t, e, n, r, "FD") : this.rect(t, e, n, r), "right" === a) {
                i instanceof Array || (i = [
                    i
                ]);
                for(var l = 0; l < i.length; l++){
                    var u = i[l], f = this.getStringUnitWidth(u) * this.internal.getFontSize();
                    this.text(u, t + n - f - 3, e + this.internal.getLineHeight() * (l + 1));
                }
            } else this.text(i, t + 3, e + this.internal.getLineHeight());
        }
        return d(t, e, n, r, o), this;
    }, I.arrayMax = function(t, e) {
        var n, r, i, o = t[0];
        for(n = 0, r = t.length; n < r; n += 1)i = t[n], e ? -1 === e(o, i) && (o = i) : o < i && (o = i);
        return o;
    }, I.table = function(t, e, n, r, i) {
        if (!n) throw "No data for PDF table";
        var o, a, s, h, c, l, u, f, d, p, g = [], m = [], w = {}, y = {}, v = [], b = [], x = !1, S = !0, k = 12, _ = F;
        if (_.width = this.internal.pageSize.getWidth(), i && (!0 === i.autoSize && (x = !0), !1 === i.printHeaders && (S = !1), i.fontSize && (k = i.fontSize), i.css && void 0 !== i.css["font-size"] && (k = 16 * i.css["font-size"]), i.margins && (_ = i.margins)), this.lnMod = 0, C = {
            x: void 0,
            y: void 0,
            w: void 0,
            h: void 0,
            ln: void 0
        }, T = 1, this.printHeaders = S, this.margins = _, this.setFontSize(k), this.table_font_size = k, null == r) g = Object.keys(n[0]);
        else if (r[0] && "string" != typeof r[0]) for(a = 0, s = r.length; a < s; a += 1)o = r[a], g.push(o.name), m.push(o.prompt), y[o.name] = o.width * (19.049976 / 25.4);
        else g = r;
        if (x) for(p = function(t) {
            return t[o];
        }, a = 0, s = g.length; a < s; a += 1){
            for(w[o = g[a]] = n.map(p), v.push(this.getTextDimensions(m[a] || o).w), u = 0, h = (l = w[o]).length; u < h; u += 1)c = l[u], v.push(this.getTextDimensions(c).w);
            y[o] = I.arrayMax(v), v = [];
        }
        if (S) {
            var A = this.calculateLineHeight(g, y, m.length ? m : g);
            for(a = 0, s = g.length; a < s; a += 1)o = g[a], b.push([
                t,
                e,
                y[o],
                A,
                String(m.length ? m[a] : o)
            ]);
            this.setTableHeaderRow(b), this.printHeaderRow(1, !1);
        }
        for(a = 0, s = n.length; a < s; a += 1)for(f = n[a], A = this.calculateLineHeight(g, y, f), u = 0, d = g.length; u < d; u += 1)o = g[u], this.cell(t, e, y[o], A, f[o], a + 2, o.align);
        return this.lastCellPos = C, this.table_x = t, this.table_y = e, this;
    }, I.calculateLineHeight = function(t, e, n) {
        for(var r, i = 0, o = 0; o < t.length; o++){
            n[r = t[o]] = this.splitTextToSize(String(n[r]), e[r] - 3);
            var a = this.internal.getLineHeight() * n[r].length + 3;
            i < a && (i = a);
        }
        return i;
    }, I.setTableHeaderRow = function(t) {
        this.tableHeaderRow = t;
    }, I.printHeaderRow = function(t, e) {
        if (!this.tableHeaderRow) throw "Property tableHeaderRow does not exist.";
        var n, r, i, o;
        if (this.printingHeaderRow = !0, void 0 !== h) {
            var a = h(this, T);
            d(a[0], a[1], a[2], a[3], -1);
        }
        this.setFontStyle("bold");
        var s = [];
        for(i = 0, o = this.tableHeaderRow.length; i < o; i += 1)this.setFillColor(200, 200, 200), n = this.tableHeaderRow[i], e && (this.margins.top = 13, n[1] = this.margins && this.margins.top || 0, s.push(n)), r = [].concat(n), this.cell.apply(this, r.concat(t));
        0 < s.length && this.setTableHeaderRow(s), this.setFontStyle("normal"), this.printingHeaderRow = !1;
    }, /**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */ function(t) {
        t.events.push([
            "initialized",
            function() {
                ((this.context2d.pdf = this).context2d.internal.pdf = this).context2d.ctx = new e, this.context2d.ctxStack = [], this.context2d.path = [];
            }
        ]), t.context2d = {
            pageWrapXEnabled: !1,
            pageWrapYEnabled: !1,
            pageWrapX: 9999999,
            pageWrapY: 9999999,
            ctx: new e,
            f2: function(t) {
                return t.toFixed(2);
            },
            fillRect: function(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "f");
                }
            },
            strokeRect: function(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.pdf.rect(i.x, i.y, i.w, i.h, "s");
                }
            },
            clearRect: function(t, e, n, r) {
                if (!this.ctx.ignoreClearRect) {
                    t = this._wrapX(t), e = this._wrapY(e);
                    var i = this._matrix_map_rect(this.ctx._transform, {
                        x: t,
                        y: e,
                        w: n,
                        h: r
                    });
                    this.save(), this.setFillStyle("#ffffff"), this.pdf.rect(i.x, i.y, i.w, i.h, "f"), this.restore();
                }
            },
            save: function() {
                this.ctx._fontSize = this.pdf.internal.getFontSize();
                var t = new e;
                t.copy(this.ctx), this.ctxStack.push(this.ctx), this.ctx = t;
            },
            restore: function() {
                this.ctx = this.ctxStack.pop(), this.setFillStyle(this.ctx.fillStyle), this.setStrokeStyle(this.ctx.strokeStyle), this.setFont(this.ctx.font), this.pdf.setFontSize(this.ctx._fontSize), this.setLineCap(this.ctx.lineCap), this.setLineWidth(this.ctx.lineWidth), this.setLineJoin(this.ctx.lineJoin);
            },
            rect: function(t, e, n, r) {
                this.moveTo(t, e), this.lineTo(t + n, e), this.lineTo(t + n, e + r), this.lineTo(t, e + r), this.lineTo(t, e), this.closePath();
            },
            beginPath: function() {
                this.path = [];
            },
            closePath: function() {
                this.path.push({
                    type: "close"
                });
            },
            _getRGBA: function(t) {
                var e, n, r, i, o = new RGBColor(t);
                if (!t) return {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0,
                    style: t
                };
                if (this.internal.rxTransparent.test(t)) i = r = n = e = 0;
                else {
                    var a = this.internal.rxRgb.exec(t);
                    null != a ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = 1) : null != (a = this.internal.rxRgba.exec(t)) ? (e = parseInt(a[1]), n = parseInt(a[2]), r = parseInt(a[3]), i = parseFloat(a[4])) : (i = 1, "#" != t.charAt(0) && (t = o.ok ? o.toHex() : "#000000"), 4 === t.length ? (e = t.substring(1, 2), e += e, n = t.substring(2, 3), n += n, r = t.substring(3, 4), r += r) : (e = t.substring(1, 3), n = t.substring(3, 5), r = t.substring(5, 7)), e = parseInt(e, 16), n = parseInt(n, 16), r = parseInt(r, 16));
                }
                return {
                    r: e,
                    g: n,
                    b: r,
                    a: i,
                    style: t
                };
            },
            setFillStyle: function(t) {
                var e = this._getRGBA(t);
                this.ctx.fillStyle = t, this.ctx._isFillTransparent = 0 === e.a, this.ctx._fillOpacity = e.a, this.pdf.setFillColor(e.r, e.g, e.b, {
                    a: e.a
                }), this.pdf.setTextColor(e.r, e.g, e.b, {
                    a: e.a
                });
            },
            setStrokeStyle: function(t) {
                var e = this._getRGBA(t);
                this.ctx.strokeStyle = e.style, this.ctx._isStrokeTransparent = 0 === e.a, this.ctx._strokeOpacity = e.a, 0 === e.a ? this.pdf.setDrawColor(255, 255, 255) : (e.a, this.pdf.setDrawColor(e.r, e.g, e.b));
            },
            fillText: function(t, e, n, r) {
                if (!this._isFillTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (h < .01) this.pdf.text(t, e, this._getBaseline(n), null, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), null, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            strokeText: function(t, e, n, r) {
                if (!this._isStrokeTransparent()) {
                    e = this._wrapX(e), n = this._wrapY(n);
                    var i = this._matrix_map_point(this.ctx._transform, [
                        e,
                        n
                    ]);
                    e = i[0], n = i[1];
                    var o = 57.2958 * this._matrix_rotation(this.ctx._transform);
                    if (0 < this.ctx._clip_path.length) {
                        var a;
                        (a = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                        var s = this.path;
                        this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(null, !0), this.ctx._clip_path = this.path, this.path = s;
                    }
                    var h = 1;
                    try {
                        h = this._matrix_decompose(this._getTransform()).scale[0];
                    } catch (t) {
                        console.warn(t);
                    }
                    if (1 === h) this.pdf.text(t, e, this._getBaseline(n), {
                        stroke: !0
                    }, o);
                    else {
                        var c = this.pdf.internal.getFontSize();
                        this.pdf.setFontSize(c * h), this.pdf.text(t, e, this._getBaseline(n), {
                            stroke: !0
                        }, o), this.pdf.setFontSize(c);
                    }
                    0 < this.ctx._clip_path.length && a.push("Q");
                }
            },
            setFont: function(t) {
                if (this.ctx.font = t, null != (c = /\s*(\w+)\s+(\w+)\s+(\w+)\s+([\d\.]+)(px|pt|em)\s+(.*)?/.exec(t))) {
                    var e = c[1], n = (c[2], c[3]), r = c[4], i = c[5], o = c[6];
                    r = "px" === i ? Math.floor(parseFloat(r)) : "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(r)), this.pdf.setFontSize(r), "bold" === n || "700" === n ? this.pdf.setFontStyle("bold") : "italic" === e ? this.pdf.setFontStyle("italic") : this.pdf.setFontStyle("normal"), l = "bold" === n || "700" === n ? "italic" === e ? "bolditalic" : "bold" : "italic" === e ? "italic" : "normal";
                    for(var a = o.toLowerCase().split(/\s*,\s*/), s = "Times", h = 0; h < a.length; h++){
                        if (void 0 !== this.pdf.internal.getFont(a[h], l, {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h];
                            break;
                        }
                        if ("bolditalic" === l && void 0 !== this.pdf.internal.getFont(a[h], "bold", {
                            noFallback: !0,
                            disableWarning: !0
                        })) s = a[h], l = "bold";
                        else if (void 0 !== this.pdf.internal.getFont(a[h], "normal", {
                            noFallback: !0,
                            disableWarning: !0
                        })) {
                            s = a[h], l = "normal";
                            break;
                        }
                    }
                    this.pdf.setFont(s, l);
                } else {
                    var c = /\s*(\d+)(pt|px|em)\s+([\w "]+)\s*([\w "]+)?/.exec(t);
                    if (null != c) {
                        var l, u = c[1], f = (c[2], c[3]);
                        (l = c[4]) || (l = "normal"), u = "em" === i ? Math.floor(parseFloat(r) * this.pdf.getFontSize()) : Math.floor(parseFloat(u)), this.pdf.setFontSize(u), this.pdf.setFont(f, l);
                    }
                }
            },
            setTextBaseline: function(t) {
                this.ctx.textBaseline = t;
            },
            getTextBaseline: function() {
                return this.ctx.textBaseline;
            },
            setTextAlign: function(t) {
                this.ctx.textAlign = t;
            },
            getTextAlign: function() {
                return this.ctx.textAlign;
            },
            setLineWidth: function(t) {
                this.ctx.lineWidth = t, this.pdf.setLineWidth(t);
            },
            setLineCap: function(t) {
                this.ctx.lineCap = t, this.pdf.setLineCap(t);
            },
            setLineJoin: function(t) {
                this.ctx.lineJoin = t, this.pdf.setLineJoin(t);
            },
            moveTo: function(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "mt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            _wrapX: function(t) {
                return this.pageWrapXEnabled ? t % this.pageWrapX : t;
            },
            _wrapY: function(t) {
                return this.pageWrapYEnabled ? (this._gotoPage(this._page(t)), (t - this.lastBreak) % this.pageWrapY) : t;
            },
            transform: function(t, e, n, r, i, o) {
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ]);
            },
            setTransform: function(t, e, n, r, i, o) {
                this.ctx._transform = [
                    t,
                    e,
                    n,
                    r,
                    i,
                    o
                ];
            },
            _getTransform: function() {
                return this.ctx._transform;
            },
            lastBreak: 0,
            pageBreaks: [],
            _page: function(t) {
                if (this.pageWrapYEnabled) {
                    for(var e = this.lastBreak = 0, n = 0, r = 0; r < this.pageBreaks.length; r++)if (t >= this.pageBreaks[r]) {
                        e++, 0 === this.lastBreak && n++;
                        var i = this.pageBreaks[r] - this.lastBreak;
                        this.lastBreak = this.pageBreaks[r], n += Math.floor(i / this.pageWrapY);
                    }
                    if (0 === this.lastBreak) n += Math.floor(t / this.pageWrapY) + 1;
                    return n + e;
                }
                return this.pdf.internal.getCurrentPageInfo().pageNumber;
            },
            _gotoPage: function(t) {},
            lineTo: function(t, e) {
                t = this._wrapX(t), e = this._wrapY(e);
                var n = this._matrix_map_point(this.ctx._transform, [
                    t,
                    e
                ]), r = {
                    type: "lt",
                    x: t = n[0],
                    y: e = n[1]
                };
                this.path.push(r);
            },
            bezierCurveTo: function(t, e, n, r, i, o) {
                var a;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), i = this._wrapX(i), o = this._wrapY(o), i = (a = this._matrix_map_point(this.ctx._transform, [
                    i,
                    o
                ]))[0], o = a[1];
                var s = {
                    type: "bct",
                    x1: t = (a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = a[1],
                    x2: n = (a = this._matrix_map_point(this.ctx._transform, [
                        n,
                        r
                    ]))[0],
                    y2: r = a[1],
                    x: i,
                    y: o
                };
                this.path.push(s);
            },
            quadraticCurveTo: function(t, e, n, r) {
                var i;
                t = this._wrapX(t), e = this._wrapY(e), n = this._wrapX(n), r = this._wrapY(r), n = (i = this._matrix_map_point(this.ctx._transform, [
                    n,
                    r
                ]))[0], r = i[1];
                var o = {
                    type: "qct",
                    x1: t = (i = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]))[0],
                    y1: e = i[1],
                    x: n,
                    y: r
                };
                this.path.push(o);
            },
            arc: function(t, e, n, r, i, o) {
                if (t = this._wrapX(t), e = this._wrapY(e), !this._matrix_is_identity(this.ctx._transform)) {
                    var a = this._matrix_map_point(this.ctx._transform, [
                        t,
                        e
                    ]);
                    t = a[0], e = a[1];
                    var s = this._matrix_map_point(this.ctx._transform, [
                        0,
                        0
                    ]), h = this._matrix_map_point(this.ctx._transform, [
                        0,
                        n
                    ]);
                    n = Math.sqrt(Math.pow(h[0] - s[0], 2) + Math.pow(h[1] - s[1], 2));
                }
                var c = {
                    type: "arc",
                    x: t,
                    y: e,
                    radius: n,
                    startAngle: r,
                    endAngle: i,
                    anticlockwise: o
                };
                this.path.push(c);
            },
            drawImage: function(t, e, n, r, i, o, a, s, h) {
                void 0 !== o && (e = o, n = a, r = s, i = h), e = this._wrapX(e), n = this._wrapY(n);
                var c, l = this._matrix_map_rect(this.ctx._transform, {
                    x: e,
                    y: n,
                    w: r,
                    h: i
                }), u = (this._matrix_map_rect(this.ctx._transform, {
                    x: o,
                    y: a,
                    w: s,
                    h: h
                }), /data:image\/(\w+).*/i.exec(t));
                c = null != u ? u[1] : "png", this.pdf.addImage(t, c, l.x, l.y, l.w, l.h);
            },
            _matrix_multiply: function(t, e) {
                var n = e[0], r = e[1], i = e[2], o = e[3], a = e[4], s = e[5], h = n * t[0] + r * t[2], c = i * t[0] + o * t[2], l = a * t[0] + s * t[2] + t[4];
                return r = n * t[1] + r * t[3], o = i * t[1] + o * t[3], s = a * t[1] + s * t[3] + t[5], [
                    n = h,
                    r,
                    i = c,
                    o,
                    a = l,
                    s
                ];
            },
            _matrix_rotation: function(t) {
                return Math.atan2(t[2], t[0]);
            },
            _matrix_decompose: function(t) {
                var e = t[0], n = t[1], r = t[2], i = t[3], o = Math.sqrt(e * e + n * n), a = (e /= o) * r + (n /= o) * i;
                r -= e * a, i -= n * a;
                var s = Math.sqrt(r * r + i * i);
                return a /= s, e * (i /= s) < n * (r /= s) && (e = -e, n = -n, a = -a, o = -o), {
                    scale: [
                        o,
                        0,
                        0,
                        s,
                        0,
                        0
                    ],
                    translate: [
                        1,
                        0,
                        0,
                        1,
                        t[4],
                        t[5]
                    ],
                    rotate: [
                        e,
                        n,
                        -n,
                        e,
                        0,
                        0
                    ],
                    skew: [
                        1,
                        0,
                        a,
                        1,
                        0,
                        0
                    ]
                };
            },
            _matrix_map_point: function(t, e) {
                var n = t[0], r = t[1], i = t[2], o = t[3], a = t[4], s = t[5], h = e[0], c = e[1];
                return [
                    h * n + c * i + a,
                    h * r + c * o + s
                ];
            },
            _matrix_map_point_obj: function(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]);
                return {
                    x: n[0],
                    y: n[1]
                };
            },
            _matrix_map_rect: function(t, e) {
                var n = this._matrix_map_point(t, [
                    e.x,
                    e.y
                ]), r = this._matrix_map_point(t, [
                    e.x + e.w,
                    e.y + e.h
                ]);
                return {
                    x: n[0],
                    y: n[1],
                    w: r[0] - n[0],
                    h: r[1] - n[1]
                };
            },
            _matrix_is_identity: function(t) {
                return 1 == t[0] && 0 == t[1] && 0 == t[2] && 1 == t[3] && 0 == t[4] && 0 == t[5];
            },
            rotate: function(t) {
                var e = [
                    Math.cos(t),
                    Math.sin(t),
                    -Math.sin(t),
                    Math.cos(t),
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, e);
            },
            scale: function(t, e) {
                var n = [
                    t,
                    0,
                    0,
                    e,
                    0,
                    0
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            translate: function(t, e) {
                var n = [
                    1,
                    0,
                    0,
                    1,
                    t,
                    e
                ];
                this.ctx._transform = this._matrix_multiply(this.ctx._transform, n);
            },
            stroke: function() {
                if (0 < this.ctx._clip_path.length) {
                    var t;
                    (t = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var e = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._stroke(!0), this.ctx._clip_path = this.path, this.path = e, this._stroke(!1), t.push("Q");
                } else this._stroke(!1);
            },
            _stroke: function(t) {
                if (t || !this._isStrokeTransparent()) {
                    for(var e = [], n = this.path, r = 0; r < n.length; r++){
                        var i = n[r];
                        switch(i.type){
                            case "mt":
                                e.push({
                                    start: i,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var o = [
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o), e[e.length - 1].abs.push(i);
                                break;
                            case "bct":
                                o = [
                                    i.x1 - n[r - 1].x,
                                    i.y1 - n[r - 1].y,
                                    i.x2 - n[r - 1].x,
                                    i.y2 - n[r - 1].y,
                                    i.x - n[r - 1].x,
                                    i.y - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "qct":
                                var a = n[r - 1].x + 2 / 3 * (i.x1 - n[r - 1].x), s = n[r - 1].y + 2 / 3 * (i.y1 - n[r - 1].y), h = i.x + 2 / 3 * (i.x1 - i.x), c = i.y + 2 / 3 * (i.y1 - i.y), l = i.x, u = i.y;
                                o = [
                                    a - n[r - 1].x,
                                    s - n[r - 1].y,
                                    h - n[r - 1].x,
                                    c - n[r - 1].y,
                                    l - n[r - 1].x,
                                    u - n[r - 1].y
                                ];
                                e[e.length - 1].deltas.push(o);
                                break;
                            case "arc":
                                0 == e.length && e.push({
                                    start: {
                                        x: 0,
                                        y: 0
                                    },
                                    deltas: [],
                                    abs: []
                                }), e[e.length - 1].arc = !0, Array.isArray(e[e.length - 1].abs) && e[e.length - 1].abs.push(i);
                        }
                    }
                    for(r = 0; r < e.length; r++){
                        var f;
                        if (f = r == e.length - 1 ? "s" : null, e[r].arc) for(var d = e[r].abs, p = 0; p < d.length; p++){
                            var g = d[p], m = 360 * g.startAngle / (2 * Math.PI), w = 360 * g.endAngle / (2 * Math.PI), y = g.x, v = g.y;
                            this.internal.arc2(this, y, v, g.radius, m, w, g.anticlockwise, f, t);
                        }
                        else {
                            y = e[r].start.x, v = e[r].start.y;
                            t ? (this.pdf.lines(e[r].deltas, y, v, null, null), this.pdf.clip_fixed()) : this.pdf.lines(e[r].deltas, y, v, null, f);
                        }
                    }
                }
            },
            _isFillTransparent: function() {
                return this.ctx._isFillTransparent || 0 == this.globalAlpha;
            },
            _isStrokeTransparent: function() {
                return this.ctx._isStrokeTransparent || 0 == this.globalAlpha;
            },
            fill: function(t) {
                if (0 < this.ctx._clip_path.length) {
                    var e;
                    (e = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage()).push("q");
                    var n = this.path;
                    this.path = this.ctx._clip_path, this.ctx._clip_path = [], this._fill(t, !0), this.ctx._clip_path = this.path, this.path = n, this._fill(t, !1), e.push("Q");
                } else this._fill(t, !1);
            },
            _fill: function(t, e) {
                if (!this._isFillTransparent()) {
                    var n, r = "function" == typeof this.pdf.internal.newObject2;
                    n = window.outIntercept ? "group" === window.outIntercept.type ? window.outIntercept.stream : window.outIntercept : this.internal.getCurrentPage();
                    var i = [], o = window.outIntercept;
                    if (r) switch(this.ctx.globalCompositeOperation){
                        case "normal":
                        case "source-over":
                            break;
                        case "destination-in":
                        case "destination-out":
                            var a = this.pdf.internal.newStreamObject(), s = this.pdf.internal.newObject2();
                            s.push("<</Type /ExtGState"), s.push("/SMask <</S /Alpha /G " + a.objId + " 0 R>>"), s.push(">>");
                            var h = "MASK" + s.objId;
                            this.pdf.internal.addGraphicsState(h, s.objId);
                            var c = "/" + h + " gs";
                            n.splice(0, 0, "q"), n.splice(1, 0, c), n.push("Q"), window.outIntercept = a;
                            break;
                        default:
                            var l = "/" + this.pdf.internal.blendModeMap[this.ctx.globalCompositeOperation.toUpperCase()];
                            l && this.pdf.internal.out(l + " gs");
                    }
                    var u = this.ctx.globalAlpha;
                    if (this.ctx._fillOpacity < 1 && (u = this.ctx._fillOpacity), r) {
                        var f = this.pdf.internal.newObject2();
                        f.push("<</Type /ExtGState"), f.push("/CA " + u), f.push("/ca " + u), f.push(">>");
                        h = "GS_O_" + f.objId;
                        this.pdf.internal.addGraphicsState(h, f.objId), this.pdf.internal.out("/" + h + " gs");
                    }
                    for(var d = this.path, p = 0; p < d.length; p++){
                        var g = d[p];
                        switch(g.type){
                            case "mt":
                                i.push({
                                    start: g,
                                    deltas: [],
                                    abs: []
                                });
                                break;
                            case "lt":
                                var m = [
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m), i[i.length - 1].abs.push(g);
                                break;
                            case "bct":
                                m = [
                                    g.x1 - d[p - 1].x,
                                    g.y1 - d[p - 1].y,
                                    g.x2 - d[p - 1].x,
                                    g.y2 - d[p - 1].y,
                                    g.x - d[p - 1].x,
                                    g.y - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "qct":
                                var w = d[p - 1].x + 2 / 3 * (g.x1 - d[p - 1].x), y = d[p - 1].y + 2 / 3 * (g.y1 - d[p - 1].y), v = g.x + 2 / 3 * (g.x1 - g.x), b = g.y + 2 / 3 * (g.y1 - g.y), x = g.x, S = g.y;
                                m = [
                                    w - d[p - 1].x,
                                    y - d[p - 1].y,
                                    v - d[p - 1].x,
                                    b - d[p - 1].y,
                                    x - d[p - 1].x,
                                    S - d[p - 1].y
                                ];
                                i[i.length - 1].deltas.push(m);
                                break;
                            case "arc":
                                0 === i.length && i.push({
                                    deltas: [],
                                    abs: []
                                }), i[i.length - 1].arc = !0, Array.isArray(i[i.length - 1].abs) && i[i.length - 1].abs.push(g);
                                break;
                            case "close":
                                i.push({
                                    close: !0
                                });
                        }
                    }
                    for(p = 0; p < i.length; p++){
                        var k;
                        if (p == i.length - 1 ? (k = "f", "evenodd" === t && (k += "*")) : k = null, i[p].close) this.pdf.internal.out("h"), k && this.pdf.internal.out(k);
                        else if (i[p].arc) {
                            i[p].start && this.internal.move2(this, i[p].start.x, i[p].start.y);
                            for(var _ = i[p].abs, A = 0; A < _.length; A++){
                                var I = _[A];
                                if (void 0 !== I.startAngle) {
                                    var C = 360 * I.startAngle / (2 * Math.PI), T = 360 * I.endAngle / (2 * Math.PI), F = I.x, P = I.y;
                                    if (0 === A && this.internal.move2(this, F, P), this.internal.arc2(this, F, P, I.radius, C, T, I.anticlockwise, null, e), A === _.length - 1 && i[p].start) {
                                        F = i[p].start.x, P = i[p].start.y;
                                        this.internal.line2(E, F, P);
                                    }
                                } else this.internal.line2(E, I.x, I.y);
                            }
                        } else {
                            F = i[p].start.x, P = i[p].start.y;
                            e ? (this.pdf.lines(i[p].deltas, F, P, null, null), this.pdf.clip_fixed()) : this.pdf.lines(i[p].deltas, F, P, null, k);
                        }
                    }
                    window.outIntercept = o;
                }
            },
            pushMask: function() {
                if ("function" == typeof this.pdf.internal.newObject2) {
                    var t = this.pdf.internal.newStreamObject(), e = this.pdf.internal.newObject2();
                    e.push("<</Type /ExtGState"), e.push("/SMask <</S /Alpha /G " + t.objId + " 0 R>>"), e.push(">>");
                    var n = "MASK" + e.objId;
                    this.pdf.internal.addGraphicsState(n, e.objId);
                    var r = "/" + n + " gs";
                    this.pdf.internal.out(r);
                } else console.log("jsPDF v2 not enabled");
            },
            clip: function() {
                if (0 < this.ctx._clip_path.length) for(var t = 0; t < this.path.length; t++)this.ctx._clip_path.push(this.path[t]);
                else this.ctx._clip_path = this.path;
                this.path = [];
            },
            measureText: function(n) {
                var r = this.pdf;
                return {
                    getWidth: function() {
                        var t = r.internal.getFontSize(), e = r.getStringUnitWidth(n) * t / r.internal.scaleFactor;
                        return e *= 1.3333;
                    },
                    get width () {
                        return this.getWidth(n);
                    }
                };
            },
            _getBaseline: function(t) {
                var e = parseInt(this.pdf.internal.getFontSize()), n = .25 * e;
                switch(this.ctx.textBaseline){
                    case "bottom":
                        return t - n;
                    case "top":
                        return t + e;
                    case "hanging":
                        return t + e - n;
                    case "middle":
                        return t + e / 2 - n;
                    case "ideographic":
                        return t;
                    case "alphabetic":
                    default:
                        return t;
                }
            }
        };
        var E = t.context2d;
        function e() {
            this._isStrokeTransparent = !1, this._strokeOpacity = 1, this.strokeStyle = "#000000", this.fillStyle = "#000000", this._isFillTransparent = !1, this._fillOpacity = 1, this.font = "12pt times", this.textBaseline = "alphabetic", this.textAlign = "start", this.lineWidth = 1, this.lineJoin = "miter", this.lineCap = "butt", this._transform = [
                1,
                0,
                0,
                1,
                0,
                0
            ], this.globalCompositeOperation = "normal", this.globalAlpha = 1, this._clip_path = [], this.ignoreClearRect = !1, this.copy = function(t) {
                this._isStrokeTransparent = t._isStrokeTransparent, this._strokeOpacity = t._strokeOpacity, this.strokeStyle = t.strokeStyle, this._isFillTransparent = t._isFillTransparent, this._fillOpacity = t._fillOpacity, this.fillStyle = t.fillStyle, this.font = t.font, this.lineWidth = t.lineWidth, this.lineJoin = t.lineJoin, this.lineCap = t.lineCap, this.textBaseline = t.textBaseline, this.textAlign = t.textAlign, this._fontSize = t._fontSize, this._transform = t._transform.slice(0), this.globalCompositeOperation = t.globalCompositeOperation, this.globalAlpha = t.globalAlpha, this._clip_path = t._clip_path.slice(0), this.ignoreClearRect = t.ignoreClearRect;
            };
        }
        Object.defineProperty(E, "fillStyle", {
            set: function(t) {
                this.setFillStyle(t);
            },
            get: function() {
                return this.ctx.fillStyle;
            }
        }), Object.defineProperty(E, "strokeStyle", {
            set: function(t) {
                this.setStrokeStyle(t);
            },
            get: function() {
                return this.ctx.strokeStyle;
            }
        }), Object.defineProperty(E, "lineWidth", {
            set: function(t) {
                this.setLineWidth(t);
            },
            get: function() {
                return this.ctx.lineWidth;
            }
        }), Object.defineProperty(E, "lineCap", {
            set: function(t) {
                this.setLineCap(t);
            },
            get: function() {
                return this.ctx.lineCap;
            }
        }), Object.defineProperty(E, "lineJoin", {
            set: function(t) {
                this.setLineJoin(t);
            },
            get: function() {
                return this.ctx.lineJoin;
            }
        }), Object.defineProperty(E, "miterLimit", {
            set: function(t) {
                this.ctx.miterLimit = t;
            },
            get: function() {
                return this.ctx.miterLimit;
            }
        }), Object.defineProperty(E, "textBaseline", {
            set: function(t) {
                this.setTextBaseline(t);
            },
            get: function() {
                return this.getTextBaseline();
            }
        }), Object.defineProperty(E, "textAlign", {
            set: function(t) {
                this.setTextAlign(t);
            },
            get: function() {
                return this.getTextAlign();
            }
        }), Object.defineProperty(E, "font", {
            set: function(t) {
                this.setFont(t);
            },
            get: function() {
                return this.ctx.font;
            }
        }), Object.defineProperty(E, "globalCompositeOperation", {
            set: function(t) {
                this.ctx.globalCompositeOperation = t;
            },
            get: function() {
                return this.ctx.globalCompositeOperation;
            }
        }), Object.defineProperty(E, "globalAlpha", {
            set: function(t) {
                this.ctx.globalAlpha = t;
            },
            get: function() {
                return this.ctx.globalAlpha;
            }
        }), Object.defineProperty(E, "canvas", {
            get: function() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        }), Object.defineProperty(E, "ignoreClearRect", {
            set: function(t) {
                this.ctx.ignoreClearRect = t;
            },
            get: function() {
                return this.ctx.ignoreClearRect;
            }
        }), E.internal = {}, E.internal.rxRgb = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/, E.internal.rxRgba = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/, E.internal.rxTransparent = /transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/, E.internal.arc = function(t, e, n, r, i, o, a, s) {
            for(var h = this.pdf.internal.scaleFactor, c = this.pdf.internal.pageSize.getHeight(), l = this.pdf.internal.f2, u = i * (Math.PI / 180), f = o * (Math.PI / 180), d = this.createArc(r, u, f, a), p = 0; p < d.length; p++){
                var g = d[p];
                0 === p ? this.pdf.internal.out([
                    l((g.x1 + e) * h),
                    l((c - (g.y1 + n)) * h),
                    "m",
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")) : this.pdf.internal.out([
                    l((g.x2 + e) * h),
                    l((c - (g.y2 + n)) * h),
                    l((g.x3 + e) * h),
                    l((c - (g.y3 + n)) * h),
                    l((g.x4 + e) * h),
                    l((c - (g.y4 + n)) * h),
                    "c"
                ].join(" ")), t._lastPoint = {
                    x: e,
                    y: n
                };
            }
            null !== s && this.pdf.internal.out(this.pdf.internal.getStyle(s));
        }, E.internal.arc2 = function(t, e, n, r, i, o, a, s, h) {
            var c = e, l = n;
            h ? (this.arc(t, c, l, r, i, o, a, null), this.pdf.clip_fixed()) : this.arc(t, c, l, r, i, o, a, s);
        }, E.internal.move2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2;
            this.pdf.internal.out([
                o(e * r),
                o((i - n) * r),
                "m"
            ].join(" ")), t._lastPoint = {
                x: e,
                y: n
            };
        }, E.internal.line2 = function(t, e, n) {
            var r = this.pdf.internal.scaleFactor, i = this.pdf.internal.pageSize.getHeight(), o = this.pdf.internal.f2, a = {
                x: e,
                y: n
            };
            this.pdf.internal.out([
                o(a.x * r),
                o((i - a.y) * r),
                "l"
            ].join(" ")), t._lastPoint = a;
        }, E.internal.createArc = function(t, e, n, r) {
            var i = 2 * Math.PI, o = Math.PI / 2, a = e;
            for((a < i || i < a) && (a %= i), a < 0 && (a = i + a); n < e;)e -= i;
            var s = Math.abs(n - e);
            s < i && r && (s = i - s);
            for(var h = [], c = r ? -1 : 1, l = a; 1e-5 < s;){
                var u = l + c * Math.min(s, o);
                h.push(this.createSmallArc(t, l, u)), s -= Math.abs(u - l), l = u;
            }
            return h;
        }, E.internal.getCurrentPage = function() {
            return this.pdf.internal.pages[this.pdf.internal.getCurrentPageInfo().pageNumber];
        }, E.internal.createSmallArc = function(t, e, n) {
            var r = (n - e) / 2, i = t * Math.cos(r), o = t * Math.sin(r), a = i, s = -o, h = a * a + s * s, c = h + a * i + s * o, l = 4 / 3 * (Math.sqrt(2 * h * c) - c) / (a * o - s * i), u = a - l * s, f = s + l * a, d = u, p = -f, g = r + e, m = Math.cos(g), w = Math.sin(g);
            return {
                x1: t * Math.cos(e),
                y1: t * Math.sin(e),
                x2: u * m - f * w,
                y2: u * w + f * m,
                x3: d * m - p * w,
                y3: d * w + p * m,
                x4: t * Math.cos(n),
                y4: t * Math.sin(n)
            };
        };
    }($.API, "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof global && global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /** @preserve
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * 
   * ====================================================================
   */ function(t) {
        var T, F, i, a, s, h, c, l, P, v, f, u, d, n, E, q, p, g, m, O;
        T = function() {
            return function(t) {
                return e.prototype = t, new e;
            };
            function e() {}
        }(), v = function(t) {
            var e, n, r, i, o, a, s;
            for(n = 0, r = t.length, e = void 0, a = i = !1; !i && n !== r;)(e = t[n] = t[n].trimLeft()) && (i = !0), n++;
            for(n = r - 1; r && !a && -1 !== n;)(e = t[n] = t[n].trimRight()) && (a = !0), n--;
            for(o = /\s+$/g, s = !0, n = 0; n !== r;)"\u2028" != t[n] && (e = t[n].replace(/\s+/g, " "), s && (e = e.trimLeft()), e && (s = o.test(e)), t[n] = e), n++;
            return t;
        }, u = function(t) {
            var e, n, r;
            for(e = void 0, n = (r = t.split(",")).shift(); !e && n;)e = i[n.trim().toLowerCase()], n = r.shift();
            return e;
        }, d = function(t) {
            var e;
            return -1 < (t = "auto" === t ? "0px" : t).indexOf("em") && !isNaN(Number(t.replace("em", ""))) && (t = 18.719 * Number(t.replace("em", "")) + "px"), -1 < t.indexOf("pt") && !isNaN(Number(t.replace("pt", ""))) && (t = 1.333 * Number(t.replace("pt", "")) + "px"), (e = n[t]) ? e : void 0 !== (e = ({
                "xx-small": 9,
                "x-small": 11,
                small: 13,
                medium: 16,
                large: 19,
                "x-large": 23,
                "xx-large": 28,
                auto: 0
            })[t]) ? n[t] = e / 16 : (e = parseFloat(t)) ? n[t] = e / 16 : (e = t.match(/([\d\.]+)(px)/), Array.isArray(e) && 3 === e.length ? n[t] = parseFloat(e[1]) / 16 : n[t] = 1);
        }, P = function(t) {
            var e, n, r, i, o;
            return o = t, i = document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(o, null) : o.currentStyle ? o.currentStyle : o.style, n = void 0, (e = {})["font-family"] = u((r = function(t) {
                return t = t.replace(/-\D/g, function(t) {
                    return t.charAt(1).toUpperCase();
                }), i[t];
            })("font-family")) || "times", e["font-style"] = a[r("font-style")] || "normal", e["text-align"] = s[r("text-align")] || "left", "bold" === (n = h[r("font-weight")] || "normal") && ("normal" === e["font-style"] ? e["font-style"] = n : e["font-style"] = n + e["font-style"]), e["font-size"] = d(r("font-size")) || 1, e["line-height"] = d(r("line-height")) || 1, e.display = "inline" === r("display") ? "inline" : "block", n = "block" === e.display, e["margin-top"] = n && d(r("margin-top")) || 0, e["margin-bottom"] = n && d(r("margin-bottom")) || 0, e["padding-top"] = n && d(r("padding-top")) || 0, e["padding-bottom"] = n && d(r("padding-bottom")) || 0, e["margin-left"] = n && d(r("margin-left")) || 0, e["margin-right"] = n && d(r("margin-right")) || 0, e["padding-left"] = n && d(r("padding-left")) || 0, e["padding-right"] = n && d(r("padding-right")) || 0, e["page-break-before"] = r("page-break-before") || "auto", e.float = c[r("cssFloat")] || "none", e.clear = l[r("clear")] || "none", e.color = r("color"), e;
        }, E = function(t, e, n) {
            var r, i, o, a, s;
            if (o = !1, a = i = void 0, r = n["#" + t.id]) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            if (r = n[t.nodeName], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            for(s = "string" == typeof t.className ? t.className.split(" ") : [], i = 0; i < s.length; i++)if (r = n["." + s[i]], !o && r) {
                if ("function" == typeof r) o = r(t, e);
                else for(i = 0, a = r.length; !o && i !== a;)o = r[i](t, e), i++;
            }
            return o;
        }, O = function(t, e) {
            var n, r, i, o, a, s, h, c, l;
            for(n = [], r = [], i = 0, l = t.rows[0].cells.length, h = t.clientWidth; i < l;)c = t.rows[0].cells[i], r[i] = {
                name: c.textContent.toLowerCase().replace(/\s+/g, ""),
                prompt: c.textContent.replace(/\r?\n/g, ""),
                width: c.clientWidth / h * e.pdf.internal.pageSize.getWidth()
            }, i++;
            for(i = 1; i < t.rows.length;){
                for(s = t.rows[i], a = {}, o = 0; o < s.cells.length;)a[r[o].name] = s.cells[o].textContent.replace(/\r?\n/g, ""), o++;
                n.push(a), i++;
            }
            return {
                rows: n,
                headers: r
            };
        };
        var B = {
            SCRIPT: 1,
            STYLE: 1,
            NOSCRIPT: 1,
            OBJECT: 1,
            EMBED: 1,
            SELECT: 1
        }, R = 1;
        F = function(t, i, e) {
            var n, r, o, a, s, h, c, l;
            for(r = t.childNodes, n = void 0, (s = "block" === (o = P(t)).display) && (i.setBlockBoundary(), i.setBlockStyle(o)), a = 0, h = r.length; a < h;){
                if ("object" === (void 0 === (n = r[a]) ? "undefined" : vt(n))) {
                    if (i.executeWatchFunctions(n), 1 === n.nodeType && "HEADER" === n.nodeName) {
                        var u = n, f = i.pdf.margins_doc.top;
                        i.pdf.internal.events.subscribe("addPage", function(t) {
                            i.y = f, F(u, i, e), i.pdf.margins_doc.top = i.y + 10, i.y += 10;
                        }, !1);
                    }
                    if (8 === n.nodeType && "#comment" === n.nodeName) ~n.textContent.indexOf("ADD_PAGE") && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top);
                    else if (1 !== n.nodeType || B[n.nodeName]) {
                        if (3 === n.nodeType) {
                            var d = n.nodeValue;
                            if (n.nodeValue && "LI" === n.parentNode.nodeName) {
                                if ("OL" === n.parentNode.parentNode.nodeName) d = R++ + ". " + d;
                                else {
                                    var p = o["font-size"], g = (3 - .75 * p) * i.pdf.internal.scaleFactor, m = .75 * p * i.pdf.internal.scaleFactor, w = 1.74 * p / i.pdf.internal.scaleFactor;
                                    l = function(t, e) {
                                        this.pdf.circle(t + g, e + m, w, "FD");
                                    };
                                }
                            }
                            16 & n.ownerDocument.body.compareDocumentPosition(n) && i.addText(d, o);
                        } else "string" == typeof n && i.addText(n, o);
                    } else {
                        var y;
                        if ("IMG" === n.nodeName) {
                            var v = n.getAttribute("src");
                            y = q[i.pdf.sHashCode(v) || v];
                        }
                        if (y) {
                            i.pdf.internal.pageSize.getHeight() - i.pdf.margins_doc.bottom < i.y + n.height && i.y > i.pdf.margins_doc.top && (i.pdf.addPage(), i.y = i.pdf.margins_doc.top, i.executeWatchFunctions(n));
                            var b = P(n), x = i.x, S = 12 / i.pdf.internal.scaleFactor, k = (b["margin-left"] + b["padding-left"]) * S, _ = (b["margin-right"] + b["padding-right"]) * S, A = (b["margin-top"] + b["padding-top"]) * S, I = (b["margin-bottom"] + b["padding-bottom"]) * S;
                            void 0 !== b.float && "right" === b.float ? x += i.settings.width - n.width - _ : x += k, i.pdf.addImage(y, x, i.y + A, n.width, n.height), y = void 0, "right" === b.float || "left" === b.float ? (i.watchFunctions.push((function(t, e, n, r) {
                                return i.y >= e ? (i.x += t, i.settings.width += n, !0) : !!(r && 1 === r.nodeType && !B[r.nodeName] && i.x + r.width > i.pdf.margins_doc.left + i.pdf.margins_doc.width) && (i.x += t, i.y = e, i.settings.width += n, !0);
                            }).bind(this, "left" === b.float ? -n.width - k - _ : 0, i.y + n.height + A + I, n.width)), i.watchFunctions.push((function(t, e, n) {
                                return !(i.y < t && e === i.pdf.internal.getNumberOfPages()) || 1 === n.nodeType && "both" === P(n).clear && (i.y = t, !0);
                            }).bind(this, i.y + n.height, i.pdf.internal.getNumberOfPages())), i.settings.width -= n.width + k + _, "left" === b.float && (i.x += n.width + k + _)) : i.y += n.height + A + I;
                        } else if ("TABLE" === n.nodeName) c = O(n, i), i.y += 10, i.pdf.table(i.x, i.y, c.rows, c.headers, {
                            autoSize: !1,
                            printHeaders: e.printHeaders,
                            margins: i.pdf.margins_doc,
                            css: P(n)
                        }), i.y = i.pdf.lastCellPos.y + i.pdf.lastCellPos.h + 20;
                        else if ("OL" === n.nodeName || "UL" === n.nodeName) R = 1, E(n, i, e) || F(n, i, e), i.y += 10;
                        else if ("LI" === n.nodeName) {
                            var C = i.x;
                            i.x += 20 / i.pdf.internal.scaleFactor, i.y += 3, E(n, i, e) || F(n, i, e), i.x = C;
                        } else "BR" === n.nodeName ? (i.y += o["font-size"] * i.pdf.internal.scaleFactor, i.addText("\u2028", T(o))) : E(n, i, e) || F(n, i, e);
                    }
                }
                a++;
            }
            if (e.outY = i.y, s) return i.setBlockBoundary(l);
        }, q = {}, p = function(t, o, e, n) {
            var a, r = t.getElementsByTagName("img"), i = r.length, s = 0;
            function h() {
                o.pdf.internal.events.publish("imagesLoaded"), n(a);
            }
            function c(e, n, r) {
                if (e) {
                    var i = new Image;
                    a = ++s, i.crossOrigin = "", i.onerror = i.onload = function() {
                        if (i.complete && (0 === i.src.indexOf("data:image/") && (i.width = n || i.width || 0, i.height = r || i.height || 0), i.width + i.height)) {
                            var t = o.pdf.sHashCode(e) || e;
                            q[t] = q[t] || i;
                        }
                        --s || h();
                    }, i.src = e;
                }
            }
            for(; i--;)c(r[i].getAttribute("src"), r[i].width, r[i].height);
            return s || h();
        }, g = function(t, o, a) {
            var s = t.getElementsByTagName("footer");
            if (0 < s.length) {
                s = s[0];
                var e = o.pdf.internal.write, n = o.y;
                o.pdf.internal.write = function() {}, F(s, o, a);
                var h = Math.ceil(o.y - n) + 5;
                o.y = n, o.pdf.internal.write = e, o.pdf.margins_doc.bottom += h;
                for(var r = function(t) {
                    var e = void 0 !== t ? t.pageNumber : 1, n = o.y;
                    o.y = o.pdf.internal.pageSize.getHeight() - o.pdf.margins_doc.bottom, o.pdf.margins_doc.bottom -= h;
                    for(var r = s.getElementsByTagName("span"), i = 0; i < r.length; ++i)-1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" pageCounter ") && (r[i].innerHTML = e), -1 < (" " + r[i].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && (r[i].innerHTML = "###jsPDFVarTotalPages###");
                    F(s, o, a), o.pdf.margins_doc.bottom += h, o.y = n;
                }, i = s.getElementsByTagName("span"), c = 0; c < i.length; ++c)-1 < (" " + i[c].className + " ").replace(/[\n\t]/g, " ").indexOf(" totalPages ") && o.pdf.internal.events.subscribe("htmlRenderingFinished", o.pdf.putTotalPages.bind(o.pdf, "###jsPDFVarTotalPages###"), !0);
                o.pdf.internal.events.subscribe("addPage", r, !1), r(), B.FOOTER = 1;
            }
        }, m = function(t, e, n, r, i, o) {
            if (!e) return !1;
            var a, s, h, c;
            "string" == typeof e || e.parentNode || (e = "" + e.innerHTML), "string" == typeof e && (a = e.replace(/<\/?script[^>]*?>/gi, ""), c = "jsPDFhtmlText" + Date.now().toString() + (1e3 * Math.random()).toFixed(0), (h = document.createElement("div")).style.cssText = "position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;", h.innerHTML = '<iframe style="height:1px;width:1px" name="' + c + '" />', document.body.appendChild(h), (s = window.frames[c]).document.open(), s.document.writeln(a), s.document.close(), e = s.document.body);
            var l, u = new f(t, n, r, i);
            return p.call(this, e, u, i.elementHandlers, function(t) {
                g(e, u, i.elementHandlers), F(e, u, i.elementHandlers), u.pdf.internal.events.publish("htmlRenderingFinished"), l = u.dispose(), "function" == typeof o ? o(l) : t && console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!");
            }), l || {
                x: u.x,
                y: u.y
            };
        }, (f = function(t, e, n, r) {
            return this.pdf = t, this.x = e, this.y = n, this.settings = r, this.watchFunctions = [], this.init(), this;
        }).prototype.init = function() {
            return this.paragraph = {
                text: [],
                style: []
            }, this.pdf.internal.write("q");
        }, f.prototype.dispose = function() {
            return this.pdf.internal.write("Q"), {
                x: this.x,
                y: this.y,
                ready: !0
            };
        }, f.prototype.executeWatchFunctions = function(t) {
            var e = !1, n = [];
            if (0 < this.watchFunctions.length) {
                for(var r = 0; r < this.watchFunctions.length; ++r)!0 === this.watchFunctions[r](t) ? e = !0 : n.push(this.watchFunctions[r]);
                this.watchFunctions = n;
            }
            return e;
        }, f.prototype.splitFragmentsIntoLines = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f, d, p, g;
            for(u = this.pdf.internal.scaleFactor, o = {}, s = h = c = g = a = i = l = r = void 0, d = [
                f = []
            ], n = 0, p = this.settings.width; t.length;)if (a = t.shift(), g = e.shift(), a) {
                if ((i = o[(r = g["font-family"]) + (l = g["font-style"])]) || (i = this.pdf.internal.getFont(r, l).metadata.Unicode, o[r + l] = i), c = {
                    widths: i.widths,
                    kerning: i.kerning,
                    fontSize: 12 * g["font-size"],
                    textIndent: n
                }, h = this.pdf.getStringUnitWidth(a, c) * c.fontSize / u, "\u2028" == a) f = [], d.push(f);
                else if (p < n + h) {
                    for(s = this.pdf.splitTextToSize(a, p, c), f.push([
                        s.shift(),
                        g
                    ]); s.length;)f = [
                        [
                            s.shift(),
                            g
                        ]
                    ], d.push(f);
                    n = this.pdf.getStringUnitWidth(f[0][0], c) * c.fontSize / u;
                } else f.push([
                    a,
                    g
                ]), n += h;
            }
            if (void 0 !== g["text-align"] && ("center" === g["text-align"] || "right" === g["text-align"] || "justify" === g["text-align"])) for(var m = 0; m < d.length; ++m){
                var w = this.pdf.getStringUnitWidth(d[m][0][0], c) * c.fontSize / u;
                0 < m && (d[m][0][1] = T(d[m][0][1]));
                var y = p - w;
                if ("right" === g["text-align"]) d[m][0][1]["margin-left"] = y;
                else if ("center" === g["text-align"]) d[m][0][1]["margin-left"] = y / 2;
                else if ("justify" === g["text-align"]) {
                    var v = d[m][0][0].split(" ").length - 1;
                    d[m][0][1]["word-spacing"] = y / v, m === d.length - 1 && (d[m][0][1]["word-spacing"] = 0);
                }
            }
            return d;
        }, f.prototype.RenderTextFragment = function(t, e) {
            var n, r;
            r = 0, this.pdf.internal.pageSize.getHeight() - this.pdf.margins_doc.bottom < this.y + this.pdf.internal.getFontSize() && (this.pdf.internal.write("ET", "Q"), this.pdf.addPage(), this.y = this.pdf.margins_doc.top, this.pdf.internal.write("q", "BT", this.getPdfColor(e.color), this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td"), r = Math.max(r, e["line-height"], e["font-size"]), this.pdf.internal.write(0, (-12 * r).toFixed(2), "Td")), n = this.pdf.internal.getFont(e["font-family"], e["font-style"]);
            var i = this.getPdfColor(e.color);
            i !== this.lastTextColor && (this.pdf.internal.write(i), this.lastTextColor = i), void 0 !== e["word-spacing"] && 0 < e["word-spacing"] && this.pdf.internal.write(e["word-spacing"].toFixed(2), "Tw"), this.pdf.internal.write("/" + n.id, (12 * e["font-size"]).toFixed(2), "Tf", "(" + this.pdf.internal.pdfEscape(t) + ") Tj"), void 0 !== e["word-spacing"] && this.pdf.internal.write(0, "Tw");
        }, f.prototype.getPdfColor = function(t) {
            var e, n, r, i = new RGBColor(t), o = /rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);
            if (null != o ? (e = parseInt(o[1]), n = parseInt(o[2]), r = parseInt(o[3])) : ("#" != t.charAt(0) && (t = i.ok ? i.toHex() : "#000000"), e = t.substring(1, 3), e = parseInt(e, 16), n = t.substring(3, 5), n = parseInt(n, 16), r = t.substring(5, 7), r = parseInt(r, 16)), "string" == typeof e && /^#[0-9A-Fa-f]{6}$/.test(e)) {
                var a = parseInt(e.substr(1), 16);
                e = a >> 16 & 255, n = a >> 8 & 255, r = 255 & a;
            }
            var s = this.f3;
            return 0 === e && 0 === n && 0 === r || void 0 === n ? s(e / 255) + " g" : [
                s(e / 255),
                s(n / 255),
                s(r / 255),
                "rg"
            ].join(" ");
        }, f.prototype.f3 = function(t) {
            return t.toFixed(3);
        }, f.prototype.renderParagraph = function(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d;
            if (r = v(this.paragraph.text), f = this.paragraph.style, e = this.paragraph.blockstyle, this.paragraph.priorblockstyle, this.paragraph = {
                text: [],
                style: [],
                blockstyle: {},
                priorblockstyle: e
            }, r.join("").trim()) {
                s = this.splitFragmentsIntoLines(r, f), h = a = void 0, n = 12 / this.pdf.internal.scaleFactor, this.priorMarginBottom = this.priorMarginBottom || 0, u = (Math.max((e["margin-top"] || 0) - this.priorMarginBottom, 0) + (e["padding-top"] || 0)) * n, l = ((e["margin-bottom"] || 0) + (e["padding-bottom"] || 0)) * n, this.priorMarginBottom = e["margin-bottom"] || 0, "always" === e["page-break-before"] && (this.pdf.addPage(), this.y = 0, u = ((e["margin-top"] || 0) + (e["padding-top"] || 0)) * n), c = this.pdf.internal.write, o = i = void 0, this.y += u, c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                for(var p = 0; s.length;){
                    for(i = h = 0, o = (a = s.shift()).length; i !== o;)a[i][0].trim() && (h = Math.max(h, a[i][1]["line-height"], a[i][1]["font-size"]), d = 7 * a[i][1]["font-size"]), i++;
                    var g = 0, m = 0;
                    for(void 0 !== a[0][1]["margin-left"] && 0 < a[0][1]["margin-left"] && (g = (m = this.pdf.internal.getCoordinateString(a[0][1]["margin-left"])) - p, p = m), c(g + Math.max(e["margin-left"] || 0, 0) * n, (-12 * h).toFixed(2), "Td"), i = 0, o = a.length; i !== o;)a[i][0] && this.RenderTextFragment(a[i][0], a[i][1]), i++;
                    if (this.y += h * n, this.executeWatchFunctions(a[0][1]) && 0 < s.length) {
                        var w = [], y = [];
                        s.forEach(function(t) {
                            for(var e = 0, n = t.length; e !== n;)t[e][0] && (w.push(t[e][0] + " "), y.push(t[e][1])), ++e;
                        }), s = this.splitFragmentsIntoLines(v(w), y), c("ET", "Q"), c("q", "BT 0 g", this.pdf.internal.getCoordinateString(this.x), this.pdf.internal.getVerticalCoordinateString(this.y), "Td");
                    }
                }
                return t && "function" == typeof t && t.call(this, this.x - 9, this.y - d / 2), c("ET", "Q"), this.y += l;
            }
        }, f.prototype.setBlockBoundary = function(t) {
            return this.renderParagraph(t);
        }, f.prototype.setBlockStyle = function(t) {
            return this.paragraph.blockstyle = t;
        }, f.prototype.addText = function(t, e) {
            return this.paragraph.text.push(t), this.paragraph.style.push(e);
        }, i = {
            helvetica: "helvetica",
            "sans-serif": "helvetica",
            "times new roman": "times",
            serif: "times",
            times: "times",
            monospace: "courier",
            courier: "courier"
        }, h = {
            100: "normal",
            200: "normal",
            300: "normal",
            400: "normal",
            500: "bold",
            600: "bold",
            700: "bold",
            800: "bold",
            900: "bold",
            normal: "normal",
            bold: "bold",
            bolder: "bold",
            lighter: "normal"
        }, a = {
            normal: "normal",
            italic: "italic",
            oblique: "italic"
        }, s = {
            left: "left",
            right: "right",
            center: "center",
            justify: "justify"
        }, c = {
            none: "none",
            right: "right",
            left: "left"
        }, l = {
            none: "none",
            both: "both"
        }, n = {
            normal: 1
        }, t.fromHTML = function(t, e, n, r, i, o) {
            return this.margins_doc = o || {
                top: 0,
                bottom: 0
            }, r || (r = {}), r.elementHandlers || (r.elementHandlers = {}), m(this, t, isNaN(e) ? 4 : e, isNaN(n) ? 4 : n, r, i);
        };
    }($.API), $.API.addJS = function(t) {
        return s = t, this.internal.events.subscribe("postPutResources", function(t) {
            n = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + (n + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), r = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + s + ")"), this.internal.out(">>"), this.internal.out("endobj");
        }), this.internal.events.subscribe("putCatalog", function() {
            void 0 !== n && void 0 !== r && this.internal.out("/Names <</JavaScript " + n + " 0 R>>");
        }), this;
    }, /**
   * jsPDF Outline PlugIn
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (c = $.API).events.push([
        "postPutResources",
        function() {
            var t = this, e = /^(\d+) 0 obj$/;
            if (0 < this.outline.root.children.length) for(var n = t.outline.render().split(/\r\n/), r = 0; r < n.length; r++){
                var i = n[r], o = e.exec(i);
                if (null != o) {
                    var a = o[1];
                    t.internal.newObjectDeferredBegin(a);
                }
                t.internal.write(i);
            }
            if (this.outline.createNamedDestinations) {
                var s = this.internal.pages.length, h = [];
                for(r = 0; r < s; r++){
                    var c = t.internal.newObject();
                    h.push(c);
                    var l = t.internal.getPageInfo(r + 1);
                    t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var u = t.internal.newObject();
                for(t.internal.write("<< /Names [ "), r = 0; r < h.length; r++)t.internal.write("(page_" + (r + 1) + ")" + h[r] + " 0 R");
                t.internal.write(" ] >>", "endobj"), t.internal.newObject(), t.internal.write("<< /Dests " + u + " 0 R"), t.internal.write(">>", "endobj");
            }
        }
    ]), c.events.push([
        "putCatalog",
        function() {
            0 < this.outline.root.children.length && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + namesOid + " 0 R"));
        }
    ]), c.events.push([
        "initialized",
        function() {
            var o = this;
            o.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, o.outline.add = function(t, e, n) {
                var r = {
                    title: e,
                    options: n,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(r), r;
            }, o.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = o, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, o.outline.genIds_r = function(t) {
                t.id = o.internal.newObjectDeferred();
                for(var e = 0; e < t.children.length; e++)this.genIds_r(t.children[e]);
            }, o.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), 0 < t.children.length && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, o.outline.renderItems = function(t) {
                for(var e = 0; e < t.children.length; e++){
                    var n = t.children[e];
                    this.objStart(n), this.line("/Title " + this.makeString(n.title)), this.line("/Parent " + this.makeRef(t)), 0 < e && this.line("/Prev " + this.makeRef(t.children[e - 1])), e < t.children.length - 1 && this.line("/Next " + this.makeRef(t.children[e + 1])), 0 < n.children.length && (this.line("/First " + this.makeRef(n.children[0])), this.line("/Last " + this.makeRef(n.children[n.children.length - 1])));
                    var r = this.count = this.count_r({
                        count: 0
                    }, n);
                    if (0 < r && this.line("/Count " + r), n.options && n.options.pageNumber) {
                        var i = o.internal.getPageInfo(n.options.pageNumber);
                        this.line("/Dest [" + i.objId + " 0 R /XYZ 0 " + this.ctx.pdf.internal.pageSize.getHeight() * this.ctx.pdf.internal.scaleFactor + " 0]");
                    }
                    this.objEnd();
                }
                for(e = 0; e < t.children.length; e++)n = t.children[e], this.renderItems(n);
            }, o.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, o.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, o.outline.makeString = function(t) {
                return "(" + o.internal.pdfEscape(t) + ")";
            }, o.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, o.outline.objEnd = function(t) {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, o.outline.count_r = function(t, e) {
                for(var n = 0; n < e.children.length; n++)t.count++, this.count_r(t, e.children[n]);
                return t.count;
            };
        }
    ]), /**@preserve
   *  ====================================================================
   * jsPDF PNG PlugIn
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */ P = $.API, E = function() {
        var t = "function" == typeof Deflater;
        if (!t) throw new Error("requires deflate.js for compression");
        return t;
    }, q = function(t, e, n, r) {
        var i = 5, o = b;
        switch(r){
            case P.image_compression.FAST:
                i = 3, o = v;
                break;
            case P.image_compression.MEDIUM:
                i = 6, o = x;
                break;
            case P.image_compression.SLOW:
                i = 9, o = S;
        }
        t = w(t, e, n, o);
        var a = new Uint8Array(g(i)), s = m(t), h = new Deflater(i), c = h.append(t), l = h.flush(), u = a.length + c.length + l.length, f = new Uint8Array(u + 4);
        return f.set(a), f.set(c, a.length), f.set(l, a.length + c.length), f[u++] = s >>> 24 & 255, f[u++] = s >>> 16 & 255, f[u++] = s >>> 8 & 255, f[u++] = 255 & s, P.arrayBufferToBinaryString(f);
    }, g = function(t, e) {
        var n = Math.LOG2E * Math.log(32768) - 8 << 4 | 8, r = n << 8;
        return r |= Math.min(3, (e - 1 & 255) >> 1) << 6, r |= 0, [
            n,
            255 & (r += 31 - r % 31)
        ];
    }, m = function(t, e) {
        for(var n, r = 1, i = 0, o = t.length, a = 0; 0 < o;){
            for(o -= n = e < o ? e : o; i += r += t[a++], --n;);
            r %= 65521, i %= 65521;
        }
        return (i << 16 | r) >>> 0;
    }, w = function(t, e, n, r) {
        for(var i, o, a, s = t.length / e, h = new Uint8Array(t.length + s), c = k(), l = 0; l < s; l++){
            if (a = l * e, i = t.subarray(a, a + e), r) h.set(r(i, n, o), a + l);
            else {
                for(var u = 0, f = c.length, d = []; u < f; u++)d[u] = c[u](i, n, o);
                var p = _(d.concat());
                h.set(d[p], a + l);
            }
            o = i;
        }
        return h;
    }, l = function(t, e, n) {
        var r = Array.apply([], t);
        return r.unshift(0), r;
    }, v = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 1; o < a; o++)r = t[o - e] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, b = function(t, e, n) {
        var r, i = [], o = 0, a = t.length;
        for(i[0] = 2; o < a; o++)r = n && n[o] || 0, i[o + 1] = t[o] - r + 256 & 255;
        return i;
    }, x = function(t, e, n) {
        var r, i, o = [], a = 0, s = t.length;
        for(o[0] = 3; a < s; a++)r = t[a - e] || 0, i = n && n[a] || 0, o[a + 1] = t[a] + 256 - (r + i >>> 1) & 255;
        return o;
    }, S = function(t, e, n) {
        var r, i, o, a, s = [], h = 0, c = t.length;
        for(s[0] = 4; h < c; h++)r = t[h - e] || 0, i = n && n[h] || 0, o = n && n[h - e] || 0, a = u(r, i, o), s[h + 1] = t[h] - a + 256 & 255;
        return s;
    }, u = function(t, e, n) {
        var r = t + e - n, i = Math.abs(r - t), o = Math.abs(r - e), a = Math.abs(r - n);
        return i <= o && i <= a ? t : o <= a ? e : n;
    }, k = function() {
        return [
            l,
            v,
            b,
            x,
            S
        ];
    }, _ = function(t) {
        for(var e, n, r, i = 0, o = t.length; i < o;)((e = f(t[i].slice(1))) < n || !n) && (n = e, r = i), i++;
        return r;
    }, f = function(t) {
        for(var e = 0, n = t.length, r = 0; e < n;)r += Math.abs(t[e++]);
        return r;
    }, P.processPNG = function(t, e, n, r, i) {
        var o, a, s, h, c, l, u = this.color_spaces.DEVICE_RGB, f = this.decode.FLATE_DECODE, d = 8;
        if (this.isArrayBuffer(t) && (t = new Uint8Array(t)), this.isArrayBufferView(t)) {
            if ("function" != typeof PNG || "function" != typeof kt) throw new Error("PNG support requires png.js and zlib.js");
            if (t = (o = new PNG(t)).imgData, d = o.bits, u = o.colorSpace, h = o.colors, -1 !== [
                4,
                6
            ].indexOf(o.colorType)) {
                if (8 === o.bits) for(var p, g = (I = 32 == o.pixelBitlength ? new Uint32Array(o.decodePixels().buffer) : 16 == o.pixelBitlength ? new Uint16Array(o.decodePixels().buffer) : new Uint8Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * o.colors), w = new Uint8Array(g), y = o.pixelBitlength - o.bits, v = 0, b = 0; v < g; v++){
                    for(x = I[v], p = 0; p < y;)m[b++] = x >>> p & 255, p += o.bits;
                    w[v] = x >>> p & 255;
                }
                if (16 === o.bits) {
                    g = (I = new Uint32Array(o.decodePixels().buffer)).length, m = new Uint8Array(g * (32 / o.pixelBitlength) * o.colors), w = new Uint8Array(g * (32 / o.pixelBitlength));
                    for(var x, S = 1 < o.colors, k = b = v = 0; v < g;)x = I[v++], m[b++] = x >>> 0 & 255, S && (m[b++] = x >>> 16 & 255, x = I[v++], m[b++] = x >>> 0 & 255), w[k++] = x >>> 16 & 255;
                    d = 8;
                }
                r !== P.image_compression.NONE && E() ? (t = q(m, o.width * o.colors, o.colors, r), l = q(w, o.width, 1, r)) : (t = m, l = w, f = null);
            }
            if (3 === o.colorType && (u = this.color_spaces.INDEXED, c = o.palette, o.transparency.indexed)) {
                var _ = o.transparency.indexed, A = 0;
                for(v = 0, g = _.length; v < g; ++v)A += _[v];
                if ((A /= 255) == g - 1 && -1 !== _.indexOf(0)) s = [
                    _.indexOf(0)
                ];
                else if (A !== g) {
                    var I = o.decodePixels();
                    for(w = new Uint8Array(I.length), v = 0, g = I.length; v < g; v++)w[v] = _[I[v]];
                    l = q(w, o.width, 1);
                }
            }
            var C = function(t) {
                var e;
                switch(t){
                    case P.image_compression.FAST:
                        e = 11;
                        break;
                    case P.image_compression.MEDIUM:
                        e = 13;
                        break;
                    case P.image_compression.SLOW:
                        e = 14;
                        break;
                    default:
                        e = 12;
                }
                return e;
            }(r);
            return a = f === this.decode.FLATE_DECODE ? "/Predictor " + C + " /Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width : "/Colors " + h + " /BitsPerComponent " + d + " /Columns " + o.width, (this.isArrayBuffer(t) || this.isArrayBufferView(t)) && (t = this.arrayBufferToBinaryString(t)), (l && this.isArrayBuffer(l) || this.isArrayBufferView(l)) && (l = this.arrayBufferToBinaryString(l)), this.createImageInfo(t, o.width, o.height, u, d, f, e, n, a, s, c, l, C);
        }
        throw new Error("Unsupported PNG image data, try using JPEG instead.");
    }, /**
   * jsPDF gif Support PlugIn
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (A = $.API).processGIF89A = function(t, e, n, r, i) {
        var o = new mt(t), a = o.width, s = o.height, h = [];
        o.decodeAndBlitFrameRGBA(0, h);
        var c = {
            data: h,
            width: a,
            height: s
        }, l = new yt(100).encode(c, 100);
        return A.processJPEG.call(this, l, e, n, r);
    }, A.processGIF87A = A.processGIF89A, /**
   * jsPDF bmp Support PlugIn
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */ (O = $.API).processBMP = function(t, e, n, r, i) {
        var o = new xt(t, !1), a = o.width, s = o.height, h = {
            data: o.getData(),
            width: a,
            height: s
        }, c = new yt(100).encode(h, 100);
        return O.processJPEG.call(this, c, e, n, r);
    }, $.API.setLanguage = function(t) {
        return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
            af: "Afrikaans",
            sq: "Albanian",
            ar: "Arabic (Standard)",
            "ar-DZ": "Arabic (Algeria)",
            "ar-BH": "Arabic (Bahrain)",
            "ar-EG": "Arabic (Egypt)",
            "ar-IQ": "Arabic (Iraq)",
            "ar-JO": "Arabic (Jordan)",
            "ar-KW": "Arabic (Kuwait)",
            "ar-LB": "Arabic (Lebanon)",
            "ar-LY": "Arabic (Libya)",
            "ar-MA": "Arabic (Morocco)",
            "ar-OM": "Arabic (Oman)",
            "ar-QA": "Arabic (Qatar)",
            "ar-SA": "Arabic (Saudi Arabia)",
            "ar-SY": "Arabic (Syria)",
            "ar-TN": "Arabic (Tunisia)",
            "ar-AE": "Arabic (U.A.E.)",
            "ar-YE": "Arabic (Yemen)",
            an: "Aragonese",
            hy: "Armenian",
            as: "Assamese",
            ast: "Asturian",
            az: "Azerbaijani",
            eu: "Basque",
            be: "Belarusian",
            bn: "Bengali",
            bs: "Bosnian",
            br: "Breton",
            bg: "Bulgarian",
            my: "Burmese",
            ca: "Catalan",
            ch: "Chamorro",
            ce: "Chechen",
            zh: "Chinese",
            "zh-HK": "Chinese (Hong Kong)",
            "zh-CN": "Chinese (PRC)",
            "zh-SG": "Chinese (Singapore)",
            "zh-TW": "Chinese (Taiwan)",
            cv: "Chuvash",
            co: "Corsican",
            cr: "Cree",
            hr: "Croatian",
            cs: "Czech",
            da: "Danish",
            nl: "Dutch (Standard)",
            "nl-BE": "Dutch (Belgian)",
            en: "English",
            "en-AU": "English (Australia)",
            "en-BZ": "English (Belize)",
            "en-CA": "English (Canada)",
            "en-IE": "English (Ireland)",
            "en-JM": "English (Jamaica)",
            "en-NZ": "English (New Zealand)",
            "en-PH": "English (Philippines)",
            "en-ZA": "English (South Africa)",
            "en-TT": "English (Trinidad & Tobago)",
            "en-GB": "English (United Kingdom)",
            "en-US": "English (United States)",
            "en-ZW": "English (Zimbabwe)",
            eo: "Esperanto",
            et: "Estonian",
            fo: "Faeroese",
            fj: "Fijian",
            fi: "Finnish",
            fr: "French (Standard)",
            "fr-BE": "French (Belgium)",
            "fr-CA": "French (Canada)",
            "fr-FR": "French (France)",
            "fr-LU": "French (Luxembourg)",
            "fr-MC": "French (Monaco)",
            "fr-CH": "French (Switzerland)",
            fy: "Frisian",
            fur: "Friulian",
            gd: "Gaelic (Scots)",
            "gd-IE": "Gaelic (Irish)",
            gl: "Galacian",
            ka: "Georgian",
            de: "German (Standard)",
            "de-AT": "German (Austria)",
            "de-DE": "German (Germany)",
            "de-LI": "German (Liechtenstein)",
            "de-LU": "German (Luxembourg)",
            "de-CH": "German (Switzerland)",
            el: "Greek",
            gu: "Gujurati",
            ht: "Haitian",
            he: "Hebrew",
            hi: "Hindi",
            hu: "Hungarian",
            is: "Icelandic",
            id: "Indonesian",
            iu: "Inuktitut",
            ga: "Irish",
            it: "Italian (Standard)",
            "it-CH": "Italian (Switzerland)",
            ja: "Japanese",
            kn: "Kannada",
            ks: "Kashmiri",
            kk: "Kazakh",
            km: "Khmer",
            ky: "Kirghiz",
            tlh: "Klingon",
            ko: "Korean",
            "ko-KP": "Korean (North Korea)",
            "ko-KR": "Korean (South Korea)",
            la: "Latin",
            lv: "Latvian",
            lt: "Lithuanian",
            lb: "Luxembourgish",
            mk: "FYRO Macedonian",
            ms: "Malay",
            ml: "Malayalam",
            mt: "Maltese",
            mi: "Maori",
            mr: "Marathi",
            mo: "Moldavian",
            nv: "Navajo",
            ng: "Ndonga",
            ne: "Nepali",
            no: "Norwegian",
            nb: "Norwegian (Bokmal)",
            nn: "Norwegian (Nynorsk)",
            oc: "Occitan",
            or: "Oriya",
            om: "Oromo",
            fa: "Persian",
            "fa-IR": "Persian/Iran",
            pl: "Polish",
            pt: "Portuguese",
            "pt-BR": "Portuguese (Brazil)",
            pa: "Punjabi",
            "pa-IN": "Punjabi (India)",
            "pa-PK": "Punjabi (Pakistan)",
            qu: "Quechua",
            rm: "Rhaeto-Romanic",
            ro: "Romanian",
            "ro-MO": "Romanian (Moldavia)",
            ru: "Russian",
            "ru-MO": "Russian (Moldavia)",
            sz: "Sami (Lappish)",
            sg: "Sango",
            sa: "Sanskrit",
            sc: "Sardinian",
            sd: "Sindhi",
            si: "Singhalese",
            sr: "Serbian",
            sk: "Slovak",
            sl: "Slovenian",
            so: "Somani",
            sb: "Sorbian",
            es: "Spanish",
            "es-AR": "Spanish (Argentina)",
            "es-BO": "Spanish (Bolivia)",
            "es-CL": "Spanish (Chile)",
            "es-CO": "Spanish (Colombia)",
            "es-CR": "Spanish (Costa Rica)",
            "es-DO": "Spanish (Dominican Republic)",
            "es-EC": "Spanish (Ecuador)",
            "es-SV": "Spanish (El Salvador)",
            "es-GT": "Spanish (Guatemala)",
            "es-HN": "Spanish (Honduras)",
            "es-MX": "Spanish (Mexico)",
            "es-NI": "Spanish (Nicaragua)",
            "es-PA": "Spanish (Panama)",
            "es-PY": "Spanish (Paraguay)",
            "es-PE": "Spanish (Peru)",
            "es-PR": "Spanish (Puerto Rico)",
            "es-ES": "Spanish (Spain)",
            "es-UY": "Spanish (Uruguay)",
            "es-VE": "Spanish (Venezuela)",
            sx: "Sutu",
            sw: "Swahili",
            sv: "Swedish",
            "sv-FI": "Swedish (Finland)",
            "sv-SV": "Swedish (Sweden)",
            ta: "Tamil",
            tt: "Tatar",
            te: "Teluga",
            th: "Thai",
            tig: "Tigre",
            ts: "Tsonga",
            tn: "Tswana",
            tr: "Turkish",
            tk: "Turkmen",
            uk: "Ukrainian",
            hsb: "Upper Sorbian",
            ur: "Urdu",
            ve: "Venda",
            vi: "Vietnamese",
            vo: "Volapuk",
            wa: "Walloon",
            cy: "Welsh",
            xh: "Xhosa",
            ji: "Yiddish",
            zu: "Zulu"
        })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
        }), this.internal.languageSettings.isSubscribed = !0)), this;
    }, /** @preserve
   * jsPDF split_text_to_size plugin - MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   */ B = $.API, R = B.getCharWidthsArray = function(t, e) {
        var n, r, i, o = (e = e || {}).font || this.internal.getFont(), a = e.fontSize || this.internal.getFontSize(), s = e.charSpace || this.internal.getCharSpace(), h = e.widths ? e.widths : o.metadata.Unicode.widths, c = h.fof ? h.fof : 1, l = e.kerning ? e.kerning : o.metadata.Unicode.kerning, u = l.fof ? l.fof : 1, f = 0, d = h[0] || c, p = [];
        for(n = 0, r = t.length; n < r; n++)i = t.charCodeAt(n), "function" == typeof o.metadata.widthOfString ? p.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i)) + s * (1e3 / a) || 0) / 1e3) : p.push((h[i] || d) / c + (l[i] && l[i][f] || 0) / u), f = i;
        return p;
    }, j = B.getArraySum = function(t) {
        for(var e = t.length, n = 0; e;)n += t[--e];
        return n;
    }, D = B.getStringUnitWidth = function(t, e) {
        var n = (e = e || {}).fontSize || this.internal.getFontSize(), r = e.font || this.internal.getFont(), i = e.charSpace || this.internal.getCharSpace();
        return "function" == typeof r.metadata.widthOfString ? r.metadata.widthOfString(t, n, i) / n : j(R.apply(this, arguments));
    }, M = function(t, e, n, r) {
        for(var i = [], o = 0, a = t.length, s = 0; o !== a && s + e[o] < n;)s += e[o], o++;
        i.push(t.slice(0, o));
        var h = o;
        for(s = 0; o !== a;)s + e[o] > r && (i.push(t.slice(h, o)), s = 0, h = o), s += e[o], o++;
        return h !== o && i.push(t.slice(h, o)), i;
    }, U = function(t, e, n) {
        n || (n = {});
        var r, i, o, a, s, h, c = [], l = [
            c
        ], u = n.textIndent || 0, f = 0, d = 0, p = t.split(" "), g = R.apply(this, [
            " ",
            n
        ])[0];
        if (h = -1 === n.lineIndent ? p[0].length + 2 : n.lineIndent || 0) {
            var m = Array(h).join(" "), w = [];
            p.map(function(t) {
                1 < (t = t.split(/\s*\n/)).length ? w = w.concat(t.map(function(t, e) {
                    return (e && t.length ? "\n" : "") + t;
                })) : w.push(t[0]);
            }), p = w, h = D.apply(this, [
                m,
                n
            ]);
        }
        for(o = 0, a = p.length; o < a; o++){
            var y = 0;
            if (r = p[o], h && "\n" == r[0] && (r = r.substr(1), y = 1), i = R.apply(this, [
                r,
                n
            ]), e < u + f + (d = j(i)) || y) {
                if (e < d) {
                    for(s = M.apply(this, [
                        r,
                        i,
                        e - (u + f),
                        e
                    ]), c.push(s.shift()), c = [
                        s.pop()
                    ]; s.length;)l.push([
                        s.shift()
                    ]);
                    d = j(i.slice(r.length - (c[0] ? c[0].length : 0)));
                } else c = [
                    r
                ];
                l.push(c), u = d + h, f = g;
            } else c.push(r), u += f + d, f = g;
        }
        if (h) var v = function(t, e) {
            return (e ? m : "") + t.join(" ");
        };
        else v = function(t) {
            return t.join(" ");
        };
        return l.map(v);
    }, B.splitTextToSize = function(t, e, n) {
        var r, i = (n = n || {}).fontSize || this.internal.getFontSize(), o = (function(t) {
            var e = {
                0: 1
            }, n = {};
            if (t.widths && t.kerning) return {
                widths: t.widths,
                kerning: t.kerning
            };
            var r = this.internal.getFont(t.fontName, t.fontStyle), i = "Unicode";
            return r.metadata[i] ? {
                widths: r.metadata[i].widths || e,
                kerning: r.metadata[i].kerning || n
            } : {
                font: r.metadata,
                fontSize: this.internal.getFontSize(),
                charSpace: this.internal.getCharSpace()
            };
        }).call(this, n);
        r = Array.isArray(t) ? t : t.split(/\r?\n/);
        var a = 1 * this.internal.scaleFactor * e / i;
        o.textIndent = n.textIndent ? 1 * n.textIndent * this.internal.scaleFactor / i : 0, o.lineIndent = n.lineIndent;
        var s, h, c = [];
        for(s = 0, h = r.length; s < h; s++)c = c.concat(U.apply(this, [
            r[s],
            a,
            o
        ]));
        return c;
    }, /** @preserve 
  jsPDF standard_fonts_metrics plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  MIT license.
  */ N = $.API, L = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: (z = function(t) {
            for(var e = "klmnopqrstuvwxyz", n = {}, r = 0; r < e.length; r++)n[e[r]] = "0123456789abcdef"[r];
            var i, o, a, s, h, c = {}, l = 1, u = c, f = [], d = "", p = "", g = t.length - 1;
            for(r = 1; r != g;)h = t[r], r += 1, "'" == h ? o ? (s = o.join(""), o = i) : o = [] : o ? o.push(h) : "{" == h ? (f.push([
                u,
                s
            ]), u = {}, s = i) : "}" == h ? ((a = f.pop())[0][a[1]] = u, s = i, u = a[0]) : "-" == h ? l = -1 : s === i ? n.hasOwnProperty(h) ? (d += n[h], s = parseInt(d, 16) * l, l = 1, d = "") : d += h : n.hasOwnProperty(h) ? (p += n[h], u[s] = parseInt(p, 16) * l, l = 1, s = i, p = "") : p += h;
            return c;
        })("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, H = {
        Unicode: {
            Courier: L,
            "Courier-Bold": L,
            "Courier-BoldOblique": L,
            "Courier-Oblique": L,
            Helvetica: L,
            "Helvetica-Bold": L,
            "Helvetica-BoldOblique": L,
            "Helvetica-Oblique": L,
            "Times-Roman": L,
            "Times-Bold": L,
            "Times-BoldItalic": L,
            "Times-Italic": L
        }
    }, W = {
        Unicode: {
            "Courier-Oblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": z("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": z("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: z("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": z("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: z("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": z("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": z("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": z("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": z("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    }, N.events.push([
        "addFont",
        function(t) {
            var e, n, r, i = "Unicode";
            (e = W[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).widths = e.widths, n.kerning = e.kerning), (r = H[i][t.postScriptName]) && ((n = t.metadata[i] ? t.metadata[i] : t.metadata[i] = {}).encoding = r).codePages && r.codePages.length && (t.encoding = r.codePages[0]);
        }
    ]), G = $, "undefined" != typeof self && self || "undefined" != typeof global && global || "undefined" != typeof window && window || Function("return this")(), G.API.events.push([
        "addFont",
        function(t) {
            G.API.existsFileInVFS(t.postScriptName) ? (t.metadata = G.API.TTFFont.open(t.postScriptName, t.fontName, G.API.getFileFromVFS(t.postScriptName), t.encoding), t.metadata.Unicode = t.metadata.Unicode || {
                encoding: {},
                kerning: {},
                widths: []
            }) : 14 < t.id.slice(1) && console.error("Font does not exist in FileInVFS, import fonts or remove declaration doc.addFont('" + t.postScriptName + "').");
        }
    ]), /** @preserve
  jsPDF SVG plugin
  Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
  */ (V = $.API).addSvg = function(t, e, n, r, i) {
        if (void 0 === e || void 0 === n) throw new Error("addSVG needs values for 'x' and 'y'");
        function o(t) {
            for(var e = parseFloat(t[1]), n = parseFloat(t[2]), r = [], i = 3, o = t.length; i < o;)"c" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2]),
                parseFloat(t[i + 3]),
                parseFloat(t[i + 4]),
                parseFloat(t[i + 5]),
                parseFloat(t[i + 6])
            ]), i += 7) : "l" === t[i] ? (r.push([
                parseFloat(t[i + 1]),
                parseFloat(t[i + 2])
            ]), i += 3) : i += 1;
            return [
                e,
                n,
                r
            ];
        }
        var a, s, h, c, l, u, f, d, p = (c = document, d = c.createElement("iframe"), l = ".jsPDF_sillysvg_iframe {display:none;position:absolute;}", (f = (u = c).createElement("style")).type = "text/css", f.styleSheet ? f.styleSheet.cssText = l : f.appendChild(u.createTextNode(l)), u.getElementsByTagName("head")[0].appendChild(f), d.name = "childframe", d.setAttribute("width", 0), d.setAttribute("height", 0), d.setAttribute("frameborder", "0"), d.setAttribute("scrolling", "no"), d.setAttribute("seamless", "seamless"), d.setAttribute("class", "jsPDF_sillysvg_iframe"), c.body.appendChild(d), d), g = (a = t, (h = ((s = p).contentWindow || s.contentDocument).document).write(a), h.close(), h.getElementsByTagName("svg")[0]), m = [
            1,
            1
        ], w = parseFloat(g.getAttribute("width")), y = parseFloat(g.getAttribute("height"));
        w && y && (r && i ? m = [
            r / w,
            i / y
        ] : r ? m = [
            r / w,
            r / w
        ] : i && (m = [
            i / y,
            i / y
        ]));
        var v, b, x, S, k = g.childNodes;
        for(v = 0, b = k.length; v < b; v++)(x = k[v]).tagName && "PATH" === x.tagName.toUpperCase() && ((S = o(x.getAttribute("d").split(" ")))[0] = S[0] * m[0] + e, S[1] = S[1] * m[1] + n, this.lines.call(this, S[2], S[0], S[1], m));
        return this;
    }, V.addSVG = V.addSvg, V.addSvgAsImage = function(t, e, n, r, i, o, a, s) {
        if (isNaN(e) || isNaN(n)) throw console.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(r) || isNaN(i)) throw console.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = r, h.height = i;
        var c = h.getContext("2d");
        return c.fillStyle = "#fff", c.fillRect(0, 0, h.width, h.height), canvg(h, t, {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0,
            ignoreClear: !0
        }), this.addImage(h.toDataURL("image/jpeg", 1), e, n, r, i, a, s), this;
    }, $.API.putTotalPages = function(t) {
        for(var e = new RegExp(t, "g"), n = 1; n <= this.internal.getNumberOfPages(); n++)for(var r = 0; r < this.internal.pages[n].length; r++)this.internal.pages[n][r] = this.internal.pages[n][r].replace(e, this.internal.getNumberOfPages());
        return this;
    }, $.API.viewerPreferences = function(t, e) {
        var n;
        t = t || {}, e = e || !1;
        var r, i, o = {
            HideToolbar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideMenubar: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            HideWindowUI: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            FitWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            CenterWindow: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.3
            },
            DisplayDocTitle: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.4
            },
            NonFullScreenPageMode: {
                defaultValue: "UseNone",
                value: "UseNone",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "UseNone",
                    "UseOutlines",
                    "UseThumbs",
                    "UseOC"
                ],
                pdfVersion: 1.3
            },
            Direction: {
                defaultValue: "L2R",
                value: "L2R",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "L2R",
                    "R2L"
                ],
                pdfVersion: 1.3
            },
            ViewArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            ViewClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintArea: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintClip: {
                defaultValue: "CropBox",
                value: "CropBox",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "MediaBox",
                    "CropBox",
                    "TrimBox",
                    "BleedBox",
                    "ArtBox"
                ],
                pdfVersion: 1.4
            },
            PrintScaling: {
                defaultValue: "AppDefault",
                value: "AppDefault",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "AppDefault",
                    "None"
                ],
                pdfVersion: 1.6
            },
            Duplex: {
                defaultValue: "",
                value: "none",
                type: "name",
                explicitSet: !1,
                valueSet: [
                    "Simplex",
                    "DuplexFlipShortEdge",
                    "DuplexFlipLongEdge",
                    "none"
                ],
                pdfVersion: 1.7
            },
            PickTrayByPDFSize: {
                defaultValue: !1,
                value: !1,
                type: "boolean",
                explicitSet: !1,
                valueSet: [
                    !0,
                    !1
                ],
                pdfVersion: 1.7
            },
            PrintPageRange: {
                defaultValue: "",
                value: "",
                type: "array",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            },
            NumCopies: {
                defaultValue: 1,
                value: 1,
                type: "integer",
                explicitSet: !1,
                valueSet: null,
                pdfVersion: 1.7
            }
        }, a = Object.keys(o), s = [], h = 0, c = 0, l = 0, u = !0;
        function f(t, e) {
            var n, r = !1;
            for(n = 0; n < t.length; n += 1)t[n] === e && (r = !0);
            return r;
        }
        if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(o)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === t || !0 === e) {
            var d = a.length;
            for(l = 0; l < d; l += 1)n[a[l]].value = n[a[l]].defaultValue, n[a[l]].explicitSet = !1;
        }
        if ("object" === (void 0 === t ? "undefined" : vt(t))) {
            for(r in t)if (i = t[r], f(a, r) && void 0 !== i) {
                if ("boolean" === n[r].type && "boolean" == typeof i) n[r].value = i;
                else if ("name" === n[r].type && f(n[r].valueSet, i)) n[r].value = i;
                else if ("integer" === n[r].type && Number.isInteger(i)) n[r].value = i;
                else if ("array" === n[r].type) {
                    for(h = 0; h < i.length; h += 1)if (u = !0, 1 === i[h].length && "number" == typeof i[h][0]) s.push(String(i[h]));
                    else if (1 < i[h].length) {
                        for(c = 0; c < i[h].length; c += 1)"number" != typeof i[h][c] && (u = !1);
                        !0 === u && s.push(String(i[h].join("-")));
                    }
                    n[r].value = String(s);
                } else n[r].value = n[r].defaultValue;
                n[r].explicitSet = !0;
            }
        }
        return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
            var t, e = [];
            for(t in n)!0 === n[t].explicitSet && ("name" === n[t].type ? e.push("/" + t + " /" + n[t].value) : e.push("/" + t + " " + n[t].value));
            0 !== e.length && this.internal.write("/ViewerPreferences\n<<\n" + e.join("\n") + "\n>>");
        }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
    }, /** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */ Y = $.API, K = J = X = "", Y.addMetadata = function(t, e) {
        return J = e || "http://jspdf.default.namespaceuri/", X = t, this.internal.events.subscribe("postPutResources", function() {
            if (X) {
                var t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + J + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), n = unescape(encodeURIComponent(t)), r = unescape(encodeURIComponent(X)), i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), o = unescape(encodeURIComponent("</x:xmpmeta>")), a = n.length + r.length + i.length + e.length + o.length;
                K = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + a + " >>"), this.internal.write("stream"), this.internal.write(e + n + r + i + o), this.internal.write("endstream"), this.internal.write("endobj");
            } else K = "";
        }), this.internal.events.subscribe("putCatalog", function() {
            K && this.internal.write("/Metadata " + K + " 0 R");
        }), this;
    }, function(l, t) {
        var e = l.API, m = [
            0
        ];
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "Identity-H" === t.encoding) {
                        for(var r = t.metadata.Unicode.widths, i = t.metadata.subset.encode(m), o = "", a = 0; a < i.length; a++)o += String.fromCharCode(i[a]);
                        var s = n();
                        e("<<"), e("/Length " + o.length), e("/Length1 " + o.length), e(">>"), e("stream"), e(o), e("endstream"), e("endobj");
                        var h = n();
                        e("<<"), e("/Type /FontDescriptor"), e("/FontName /" + t.fontName), e("/FontFile2 " + s + " 0 R"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/Flags " + t.metadata.flags), e("/StemV " + t.metadata.stemV), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e(">>"), e("endobj");
                        var c = n();
                        e("<<"), e("/Type /Font"), e("/BaseFont /" + t.fontName), e("/FontDescriptor " + h + " 0 R"), e("/W " + l.API.PDFObject.convert(r)), e("/CIDToGIDMap /Identity"), e("/DW 1000"), e("/Subtype /CIDFontType2"), e("/CIDSystemInfo"), e("<<"), e("/Supplement 0"), e("/Registry (Adobe)"), e("/Ordering (" + t.encoding + ")"), e(">>"), e(">>"), e("endobj"), t.objectNumber = n(), e("<<"), e("/Type /Font"), e("/Subtype /Type0"), e("/BaseFont /" + t.fontName), e("/Encoding /" + t.encoding), e("/DescendantFonts [" + c + " 0 R]"), e(">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        e.events.push([
            "putFont",
            function(t) {
                !function(t, e, n) {
                    if (t.metadata instanceof l.API.TTFFont && "WinAnsiEncoding" === t.encoding) {
                        t.metadata.Unicode.widths;
                        for(var r = t.metadata.rawData, i = "", o = 0; o < r.length; o++)i += String.fromCharCode(r[o]);
                        var a = n();
                        e("<<"), e("/Length " + i.length), e("/Length1 " + i.length), e(">>"), e("stream"), e(i), e("endstream"), e("endobj");
                        var s = n();
                        for(e("<<"), e("/Descent " + t.metadata.decender), e("/CapHeight " + t.metadata.capHeight), e("/StemV " + t.metadata.stemV), e("/Type /FontDescriptor"), e("/FontFile2 " + a + " 0 R"), e("/Flags 96"), e("/FontBBox " + l.API.PDFObject.convert(t.metadata.bbox)), e("/FontName /" + t.fontName), e("/ItalicAngle " + t.metadata.italicAngle), e("/Ascent " + t.metadata.ascender), e(">>"), e("endobj"), t.objectNumber = n(), o = 0; o < t.metadata.hmtx.widths.length; o++)t.metadata.hmtx.widths[o] = parseInt(t.metadata.hmtx.widths[o] * (1e3 / t.metadata.head.unitsPerEm));
                        e("<</Subtype/TrueType/Type/Font/BaseFont/" + t.fontName + "/FontDescriptor " + s + " 0 R/Encoding/" + t.encoding + " /FirstChar 29 /LastChar 255 /Widths " + l.API.PDFObject.convert(t.metadata.hmtx.widths) + ">>"), e("endobj"), t.isAlreadyPutted = !0;
                    }
                }(t.font, t.out, t.newObject);
            }
        ]);
        var c = function(t) {
            var e, n, r = t.text || "", i = t.x, o = t.y, a = t.options || {}, s = t.mutex || {}, h = s.pdfEscape, c = s.activeFontKey, l = s.fonts, u = (s.activeFontSize, ""), f = 0, d = "", p = l[n = c].encoding;
            if ("Identity-H" !== l[n].encoding) return {
                text: r,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
            for(d = r, n = c, "[object Array]" === Object.prototype.toString.call(r) && (d = r[0]), f = 0; f < d.length; f += 1)l[n].metadata.hasOwnProperty("cmap") && (e = l[n].metadata.cmap.unicode.codeMap[d[f].charCodeAt(0)]), e ? u += d[f] : d[f].charCodeAt(0) < 256 && l[n].metadata.hasOwnProperty("Unicode") ? u += d[f] : u += "";
            var g = "";
            return parseInt(n.slice(1)) < 14 || "WinAnsiEncoding" === p ? g = function(t) {
                for(var e = "", n = 0; n < t.length; n++)e += "" + t.charCodeAt(n).toString(16);
                return e;
            }(h(u, n)) : "Identity-H" === p && (g = function(t, e) {
                for(var n, r = e.metadata.Unicode.widths, i = [
                    "",
                    "0",
                    "00",
                    "000",
                    "0000"
                ], o = [
                    ""
                ], a = 0, s = t.length; a < s; ++a){
                    if (n = e.metadata.characterToGlyph(t.charCodeAt(a)), m.push(n), -1 == r.indexOf(n) && (r.push(n), r.push([
                        parseInt(e.metadata.widthOfGlyph(n), 10)
                    ])), "0" == n) return o.join("");
                    n = n.toString(16), o.push(i[4 - n.length], n);
                }
                return o.join("");
            }(u, l[n])), s.isHex = !0, {
                text: g,
                x: i,
                y: o,
                options: a,
                mutex: s
            };
        };
        e.events.push([
            "postProcessText",
            function(t) {
                var e = t.text || "", n = t.x, r = t.y, i = t.options, o = t.mutex, a = (i.lang, []), s = {
                    text: e,
                    x: n,
                    y: r,
                    options: i,
                    mutex: o
                };
                if ("[object Array]" === Object.prototype.toString.call(e)) {
                    var h = 0;
                    for(h = 0; h < e.length; h += 1)"[object Array]" === Object.prototype.toString.call(e[h]) && 3 === e[h].length ? a.push([
                        c(Object.assign({}, s, {
                            text: e[h][0]
                        })).text,
                        e[h][1],
                        e[h][2]
                    ]) : a.push(c(Object.assign({}, s, {
                        text: e[h]
                    })).text);
                    t.text = a;
                } else t.text = c(Object.assign({}, s, {
                    text: e
                })).text;
            }
        ]);
    }($, "undefined" != typeof self && self || "undefined" != typeof global && global || "undefined" != typeof window && window || Function("return this")()), Q = $.API, Z = {}, Q.existsFileInVFS = function(t) {
        return Z.hasOwnProperty(t);
    }, Q.addFileToVFS = function(t, e) {
        return Z[t] = e, this;
    }, Q.getFileFromVFS = function(t) {
        return Z.hasOwnProperty(t) ? Z[t] : null;
    }, function(t) {
        if (t.URL = t.URL || t.webkitURL, t.Blob && t.URL) try {
            return new Blob;
        } catch (t) {}
        var s = t.BlobBuilder || t.WebKitBlobBuilder || t.MozBlobBuilder || function(t) {
            var s = function(t) {
                return Object.prototype.toString.call(t).match(/^\[object\s(.*)\]$/)[1];
            }, e = function() {
                this.data = [];
            }, h = function(t, e, n) {
                this.data = t, this.size = t.length, this.type = e, this.encoding = n;
            }, n = e.prototype, r = h.prototype, c = t.FileReaderSync, l = function(t) {
                this.code = this[this.name = t];
            }, i = "NOT_FOUND_ERR SECURITY_ERR ABORT_ERR NOT_READABLE_ERR ENCODING_ERR NO_MODIFICATION_ALLOWED_ERR INVALID_STATE_ERR SYNTAX_ERR".split(" "), o = i.length, a = t.URL || t.webkitURL || t, u = a.createObjectURL, f = a.revokeObjectURL, d = a, p = t.btoa, g = t.atob, m = t.ArrayBuffer, w = t.Uint8Array, y = /^[\w-]+:\/*\[?[\w\.:-]+\]?(?::[0-9]+)?/;
            for(h.fake = r.fake = !0; o--;)l.prototype[i[o]] = o + 1;
            return a.createObjectURL || (d = t.URL = function(t) {
                var e, n = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                return n.href = t, "origin" in n || ("data:" === n.protocol.toLowerCase() ? n.origin = null : (e = t.match(y), n.origin = e && e[1])), n;
            }), d.createObjectURL = function(t) {
                var e, n = t.type;
                return null === n && (n = "application/octet-stream"), t instanceof h ? (e = "data:" + n, "base64" === t.encoding ? e + ";base64," + t.data : "URI" === t.encoding ? e + "," + decodeURIComponent(t.data) : p ? e + ";base64," + p(t.data) : e + "," + encodeURIComponent(t.data)) : u ? u.call(a, t) : void 0;
            }, d.revokeObjectURL = function(t) {
                "data:" !== t.substring(0, 5) && f && f.call(a, t);
            }, n.append = function(t) {
                var e = this.data;
                if (w && (t instanceof m || t instanceof w)) {
                    for(var n = "", r = new w(t), i = 0, o = r.length; i < o; i++)n += String.fromCharCode(r[i]);
                    e.push(n);
                } else if ("Blob" === s(t) || "File" === s(t)) {
                    if (!c) throw new l("NOT_READABLE_ERR");
                    var a = new c;
                    e.push(a.readAsBinaryString(t));
                } else t instanceof h ? "base64" === t.encoding && g ? e.push(g(t.data)) : "URI" === t.encoding ? e.push(decodeURIComponent(t.data)) : "raw" === t.encoding && e.push(t.data) : ("string" != typeof t && (t += ""), e.push(unescape(encodeURIComponent(t))));
            }, n.getBlob = function(t) {
                return arguments.length || (t = null), new h(this.data.join(""), t, "raw");
            }, n.toString = function() {
                return "[object BlobBuilder]";
            }, r.slice = function(t, e, n) {
                var r = arguments.length;
                return r < 3 && (n = null), new h(this.data.slice(t, 1 < r ? e : this.data.length), n, this.encoding);
            }, r.toString = function() {
                return "[object Blob]";
            }, r.close = function() {
                this.size = 0, delete this.data;
            }, e;
        }(t);
        t.Blob = function(t, e) {
            var n = e && e.type || "", r = new s;
            if (t) for(var i = 0, o = t.length; i < o; i++)Uint8Array && t[i] instanceof Uint8Array ? r.append(t[i].buffer) : r.append(t[i]);
            var a = r.getBlob(n);
            return !a.slice && a.webkitSlice && (a.slice = a.webkitSlice), a;
        };
        var e = Object.getPrototypeOf || function(t) {
            return t.__proto__;
        };
        t.Blob.prototype = e(new t.Blob);
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content || window);
    var tt, et, nt, rt, it, ot, at, st, ht, ct, lt, ut, ft, dt, pt, gt, bt = bt || function(s) {
        if (!(void 0 === s || "undefined" != typeof navigator && /MSIE [1-9]\./.test(navigator.userAgent))) {
            var t = s.document, h = function() {
                return s.URL || s.webkitURL || s;
            }, c = t.createElementNS("http://www.w3.org/1999/xhtml", "a"), l = "download" in c, u = /constructor/i.test(s.HTMLElement) || s.safari, f = /CriOS\/[\d]+/.test(navigator.userAgent), d = function(t) {
                (s.setImmediate || s.setTimeout)(function() {
                    throw t;
                }, 0);
            }, p = function(t) {
                setTimeout(function() {
                    "string" == typeof t ? h().revokeObjectURL(t) : t.remove();
                }, 4e4);
            }, g = function(t) {
                return /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type) ? new Blob([
                    String.fromCharCode(65279),
                    t
                ], {
                    type: t.type
                }) : t;
            }, r = function(t, n, e) {
                e || (t = g(t));
                var r, i = this, o = "application/octet-stream" === t.type, a = function() {
                    !function(t, e, n) {
                        for(var r = (e = [].concat(e)).length; r--;){
                            var i = t["on" + e[r]];
                            if ("function" == typeof i) try {
                                i.call(t, n || t);
                            } catch (t) {
                                d(t);
                            }
                        }
                    }(i, "writestart progress write writeend".split(" "));
                };
                if (i.readyState = i.INIT, l) return r = h().createObjectURL(t), void setTimeout(function() {
                    var t, e;
                    c.href = r, c.download = n, t = c, e = new MouseEvent("click"), t.dispatchEvent(e), a(), p(r), i.readyState = i.DONE;
                });
                !function() {
                    if ((f || o && u) && s.FileReader) {
                        var e = new FileReader;
                        return e.onloadend = function() {
                            var t = f ? e.result : e.result.replace(/^data:[^;]*;/, "data:attachment/file;");
                            s.open(t, "_blank") || (s.location.href = t), t = void 0, i.readyState = i.DONE, a();
                        }, e.readAsDataURL(t), i.readyState = i.INIT;
                    }
                    r || (r = h().createObjectURL(t)), o ? s.location.href = r : s.open(r, "_blank") || (s.location.href = r);
                    i.readyState = i.DONE, a(), p(r);
                }();
            }, e = r.prototype;
            return "undefined" != typeof navigator && navigator.msSaveOrOpenBlob ? function(t, e, n) {
                return e = e || t.name || "download", n || (t = g(t)), navigator.msSaveOrOpenBlob(t, e);
            } : (e.abort = function() {}, e.readyState = e.INIT = 0, e.WRITING = 1, e.DONE = 2, e.error = e.onwritestart = e.onprogress = e.onwrite = e.onabort = e.onerror = e.onwriteend = null, function(t, e, n) {
                return new r(t, e || t.name || "download", n);
            });
        }
    }("undefined" != typeof self && self || "undefined" != typeof window && window || window.content);
    function mt(x) {
        var t = 0;
        if (71 !== x[t++] || 73 !== x[t++] || 70 !== x[t++] || 56 !== x[t++] || 56 != (x[t++] + 1 & 253) || 97 !== x[t++]) throw "Invalid GIF 87a/89a header.";
        var S = x[t++] | x[t++] << 8, e = x[t++] | x[t++] << 8, n = x[t++], r = n >> 7, i = 1 << (7 & n) + 1;
        x[t++];
        x[t++];
        var o = null;
        r && (o = t, t += 3 * i);
        var a = !0, s = [], h = 0, c = null, l = 0, u = null;
        for(this.width = S, this.height = e; a && t < x.length;)switch(x[t++]){
            case 33:
                switch(x[t++]){
                    case 255:
                        if (11 !== x[t] || 78 == x[t + 1] && 69 == x[t + 2] && 84 == x[t + 3] && 83 == x[t + 4] && 67 == x[t + 5] && 65 == x[t + 6] && 80 == x[t + 7] && 69 == x[t + 8] && 50 == x[t + 9] && 46 == x[t + 10] && 48 == x[t + 11] && 3 == x[t + 12] && 1 == x[t + 13] && 0 == x[t + 16]) t += 14, u = x[t++] | x[t++] << 8, t++;
                        else for(t += 12;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    case 249:
                        if (4 !== x[t++] || 0 !== x[t + 4]) throw "Invalid graphics extension block.";
                        var f = x[t++];
                        h = x[t++] | x[t++] << 8, c = x[t++], 0 == (1 & f) && (c = null), l = f >> 2 & 7, t++;
                        break;
                    case 254:
                        for(;;){
                            if (0 === (_ = x[t++])) break;
                            t += _;
                        }
                        break;
                    default:
                        throw "Unknown graphic control label: 0x" + x[t - 1].toString(16);
                }
                break;
            case 44:
                var d = x[t++] | x[t++] << 8, p = x[t++] | x[t++] << 8, g = x[t++] | x[t++] << 8, m = x[t++] | x[t++] << 8, w = x[t++], y = w >> 6 & 1, v = o, b = !1;
                if (w >> 7) {
                    b = !0;
                    v = t, t += 3 * (1 << (7 & w) + 1);
                }
                var k = t;
                for(t++;;){
                    var _;
                    if (0 === (_ = x[t++])) break;
                    t += _;
                }
                s.push({
                    x: d,
                    y: p,
                    width: g,
                    height: m,
                    has_local_palette: b,
                    palette_offset: v,
                    data_offset: k,
                    data_length: t - k,
                    transparent_index: c,
                    interlaced: !!y,
                    delay: h,
                    disposal: l
                });
                break;
            case 59:
                a = !1;
                break;
            default:
                throw "Unknown gif block: 0x" + x[t - 1].toString(16);
        }
        this.numFrames = function() {
            return s.length;
        }, this.loopCount = function() {
            return u;
        }, this.frameInfo = function(t) {
            if (t < 0 || t >= s.length) throw "Frame index out of range.";
            return s[t];
        }, this.decodeAndBlitFrameBGRA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = b, e[f++] = v, e[f++] = y, e[f++] = 255;
                }
                --c;
            }
        }, this.decodeAndBlitFrameRGBA = function(t, e) {
            var n = this.frameInfo(t), r = n.width * n.height, i = new Uint8Array(r);
            wt(x, n.data_offset, i, r);
            var o = n.palette_offset, a = n.transparent_index;
            null === a && (a = 256);
            var s = n.width, h = S - s, c = s, l = 4 * (n.y * S + n.x), u = 4 * ((n.y + n.height) * S + n.x), f = l, d = 4 * h;
            !0 === n.interlaced && (d += 4 * (s + h) * 7);
            for(var p = 8, g = 0, m = i.length; g < m; ++g){
                var w = i[g];
                if (0 === c && (c = s, u <= (f += d) && (d = h + 4 * (s + h) * (p - 1), f = l + (s + h) * (p << 1), p >>= 1)), w === a) f += 4;
                else {
                    var y = x[o + 3 * w], v = x[o + 3 * w + 1], b = x[o + 3 * w + 2];
                    e[f++] = y, e[f++] = v, e[f++] = b, e[f++] = 255;
                }
                --c;
            }
        };
    }
    function wt(t, e, n, r) {
        for(var i = t[e++], o = 1 << i, a = o + 1, s = a + 1, h = i + 1, c = (1 << h) - 1, l = 0, u = 0, f = 0, d = t[e++], p = new Int32Array(4096), g = null;;){
            for(; l < 16 && 0 !== d;)u |= t[e++] << l, l += 8, 1 === d ? d = t[e++] : --d;
            if (l < h) break;
            var m = u & c;
            if (u >>= h, l -= h, m !== o) {
                if (m === a) break;
                for(var w = m < s ? m : g, y = 0, v = w; o < v;)v = p[v] >> 8, ++y;
                var b = v;
                if (r < f + y + (w !== m ? 1 : 0)) return void console.log("Warning, gif stream longer than expected.");
                n[f++] = b;
                var x = f += y;
                for(w !== m && (n[f++] = b), v = w; y--;)v = p[v], n[--x] = 255 & v, v >>= 8;
                null !== g && s < 4096 && (p[s++] = g << 8 | b, c + 1 <= s && h < 12 && (++h, c = c << 1 | 1)), g = m;
            } else s = a + 1, c = (1 << (h = i + 1)) - 1, g = null;
        }
        return f !== r && console.log("Warning, gif stream shorter than expected."), n;
    }
    (0, module.exports) ? module.exports.saveAs = bt : "undefined" != typeof define && null !== define && null !== define.amd && define("FileSaver.js", function() {
        return bt;
    }), $.API.adler32cs = (ot = "function" == typeof ArrayBuffer && "function" == typeof Uint8Array, at = null, st = function() {
        if (!ot) return function() {
            return !1;
        };
        try {
            var t = {};
            "function" == typeof t.Buffer && (at = t.Buffer);
        } catch (t) {}
        return function(t) {
            return t instanceof ArrayBuffer || null !== at && t instanceof at;
        };
    }(), ht = null !== at ? function(t) {
        return new at(t, "utf8").toString("binary");
    } : function(t) {
        return unescape(encodeURIComponent(t));
    }, ct = 65521, lt = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + (255 & e.charCodeAt(i))) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, ut = function(t, e) {
        for(var n = 65535 & t, r = t >>> 16, i = 0, o = e.length; i < o; i++)n = (n + e[i]) % ct, r = (r + n) % ct;
        return (r << 16 | n) >>> 0;
    }, dt = (ft = {}).Adler32 = (((it = (rt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!isFinite(t = null == t ? 1 : +t)) throw new Error("First arguments needs to be a finite number.");
        this.checksum = t >>> 0;
    }).prototype = {}).constructor = rt).from = ((tt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        this.checksum = lt(1, t.toString());
    }).prototype = it, tt), rt.fromUtf8 = ((et = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        this.checksum = lt(1, e);
    }).prototype = it, et), ot && (rt.fromBuffer = ((nt = function(t) {
        if (!(this instanceof rt)) throw new TypeError("Constructor cannot called be as a function.");
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(1, e);
    }).prototype = it, nt)), it.update = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return t = t.toString(), this.checksum = lt(this.checksum, t);
    }, it.updateUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return this.checksum = lt(this.checksum, e);
    }, ot && (it.updateBuffer = function(t) {
        if (!st(t)) throw new Error("First argument needs to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return this.checksum = ut(this.checksum, e);
    }), it.clone = function() {
        return new dt(this.checksum);
    }, rt), ft.from = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        return lt(1, t.toString());
    }, ft.fromUtf8 = function(t) {
        if (null == t) throw new Error("First argument needs to be a string.");
        var e = ht(t.toString());
        return lt(1, e);
    }, ot && (ft.fromBuffer = function(t) {
        if (!st(t)) throw new Error("First argument need to be ArrayBuffer.");
        var e = new Uint8Array(t);
        return ut(1, e);
    }), ft);
    try {
        exports.GifWriter = function(w, t, e, n) {
            var y = 0, r = void 0 === (n = void 0 === n ? {} : n).loop ? null : n.loop, v = void 0 === n.palette ? null : n.palette;
            if (t <= 0 || e <= 0 || 65535 < t || 65535 < e) throw "Width/Height invalid.";
            function b(t) {
                var e = t.length;
                if (e < 2 || 256 < e || e & e - 1) throw "Invalid code/color length, must be power of 2 and 2 .. 256.";
                return e;
            }
            w[y++] = 71, w[y++] = 73, w[y++] = 70, w[y++] = 56, w[y++] = 57, w[y++] = 97;
            var i = 0, o = 0;
            if (null !== v) {
                for(var a = b(v); a >>= 1;)++i;
                if (a = 1 << i, --i, void 0 !== n.background) {
                    if (a <= (o = n.background)) throw "Background index out of range.";
                    if (0 === o) throw "Background index explicitly passed as 0.";
                }
            }
            if (w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = (null !== v ? 128 : 0) | i, w[y++] = o, w[y++] = 0, null !== v) for(var s = 0, h = v.length; s < h; ++s){
                var c = v[s];
                w[y++] = c >> 16 & 255, w[y++] = c >> 8 & 255, w[y++] = 255 & c;
            }
            if (null !== r) {
                if (r < 0 || 65535 < r) throw "Loop count invalid.";
                w[y++] = 33, w[y++] = 255, w[y++] = 11, w[y++] = 78, w[y++] = 69, w[y++] = 84, w[y++] = 83, w[y++] = 67, w[y++] = 65, w[y++] = 80, w[y++] = 69, w[y++] = 50, w[y++] = 46, w[y++] = 48, w[y++] = 3, w[y++] = 1, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = 0;
            }
            var x = !1;
            this.addFrame = function(t, e, n, r, i, o) {
                if (!0 === x && (--y, x = !1), o = void 0 === o ? {} : o, t < 0 || e < 0 || 65535 < t || 65535 < e) throw "x/y invalid.";
                if (n <= 0 || r <= 0 || 65535 < n || 65535 < r) throw "Width/Height invalid.";
                if (i.length < n * r) throw "Not enough pixels for the frame size.";
                var a = !0, s = o.palette;
                if (null == s && (a = !1, s = v), null == s) throw "Must supply either a local or global palette.";
                for(var h = b(s), c = 0; h >>= 1;)++c;
                h = 1 << c;
                var l = void 0 === o.delay ? 0 : o.delay, u = void 0 === o.disposal ? 0 : o.disposal;
                if (u < 0 || 3 < u) throw "Disposal out of range.";
                var f = !1, d = 0;
                if (void 0 !== o.transparent && null !== o.transparent && (f = !0, (d = o.transparent) < 0 || h <= d)) throw "Transparent color index.";
                if ((0 !== u || f || 0 !== l) && (w[y++] = 33, w[y++] = 249, w[y++] = 4, w[y++] = u << 2 | (!0 === f ? 1 : 0), w[y++] = 255 & l, w[y++] = l >> 8 & 255, w[y++] = d, w[y++] = 0), w[y++] = 44, w[y++] = 255 & t, w[y++] = t >> 8 & 255, w[y++] = 255 & e, w[y++] = e >> 8 & 255, w[y++] = 255 & n, w[y++] = n >> 8 & 255, w[y++] = 255 & r, w[y++] = r >> 8 & 255, w[y++] = !0 === a ? 128 | c - 1 : 0, !0 === a) for(var p = 0, g = s.length; p < g; ++p){
                    var m = s[p];
                    w[y++] = m >> 16 & 255, w[y++] = m >> 8 & 255, w[y++] = 255 & m;
                }
                y = function(e, n, t, r) {
                    e[n++] = t;
                    var i = n++, o = 1 << t, a = o - 1, s = o + 1, h = s + 1, c = t + 1, l = 0, u = 0;
                    function f(t) {
                        for(; t <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === i + 256 && (e[i] = 255, i = n++);
                    }
                    function d(t) {
                        u |= t << l, l += c, f(8);
                    }
                    var p = r[0] & a, g = {};
                    d(o);
                    for(var m = 1, w = r.length; m < w; ++m){
                        var y = r[m] & a, v = p << 8 | y, b = g[v];
                        if (void 0 === b) {
                            for(u |= p << l, l += c; 8 <= l;)e[n++] = 255 & u, u >>= 8, l -= 8, n === i + 256 && (e[i] = 255, i = n++);
                            4096 === h ? (d(o), h = s + 1, c = t + 1, g = {}) : (1 << c <= h && ++c, g[v] = h++), p = y;
                        } else p = b;
                    }
                    return d(p), d(s), f(1), i + 1 === n ? e[i] = 0 : (e[i] = n - i - 1, e[n++] = 0), n;
                }(w, y, c < 2 ? 2 : c, i);
            }, this.end = function() {
                return !1 === x && (w[y++] = 59, x = !0), y;
            };
        }, exports.GifReader = mt;
    } catch (t) {}
    /*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */ function yt(t) {
        var S, k, _, A, e, u = Math.floor, I = new Array(64), C = new Array(64), T = new Array(64), F = new Array(64), w = new Array(65535), y = new Array(65535), Q = new Array(64), v = new Array(64), P = [], E = 0, q = 7, O = new Array(64), B = new Array(64), R = new Array(64), n = new Array(256), j = new Array(2048), b = [
            0,
            1,
            5,
            6,
            14,
            15,
            27,
            28,
            2,
            4,
            7,
            13,
            16,
            26,
            29,
            42,
            3,
            8,
            12,
            17,
            25,
            30,
            41,
            43,
            9,
            11,
            18,
            24,
            31,
            40,
            44,
            53,
            10,
            19,
            23,
            32,
            39,
            45,
            52,
            54,
            20,
            22,
            33,
            38,
            46,
            51,
            55,
            60,
            21,
            34,
            37,
            47,
            50,
            56,
            59,
            61,
            35,
            36,
            48,
            49,
            57,
            58,
            62,
            63
        ], D = [
            0,
            0,
            1,
            5,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], M = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], U = [
            0,
            0,
            2,
            1,
            3,
            3,
            2,
            4,
            3,
            5,
            5,
            4,
            4,
            0,
            0,
            1,
            125
        ], N = [
            1,
            2,
            3,
            0,
            4,
            17,
            5,
            18,
            33,
            49,
            65,
            6,
            19,
            81,
            97,
            7,
            34,
            113,
            20,
            50,
            129,
            145,
            161,
            8,
            35,
            66,
            177,
            193,
            21,
            82,
            209,
            240,
            36,
            51,
            98,
            114,
            130,
            9,
            10,
            22,
            23,
            24,
            25,
            26,
            37,
            38,
            39,
            40,
            41,
            42,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            225,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            241,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ], z = [
            0,
            0,
            3,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            1,
            0,
            0,
            0,
            0,
            0
        ], L = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ], H = [
            0,
            0,
            2,
            1,
            2,
            4,
            4,
            3,
            4,
            7,
            5,
            4,
            4,
            0,
            1,
            2,
            119
        ], W = [
            0,
            1,
            2,
            3,
            17,
            4,
            5,
            33,
            49,
            6,
            18,
            65,
            81,
            7,
            97,
            113,
            19,
            34,
            50,
            129,
            8,
            20,
            66,
            145,
            161,
            177,
            193,
            9,
            35,
            51,
            82,
            240,
            21,
            98,
            114,
            209,
            10,
            22,
            36,
            52,
            225,
            37,
            241,
            23,
            24,
            25,
            26,
            38,
            39,
            40,
            41,
            42,
            53,
            54,
            55,
            56,
            57,
            58,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            90,
            99,
            100,
            101,
            102,
            103,
            104,
            105,
            106,
            115,
            116,
            117,
            118,
            119,
            120,
            121,
            122,
            130,
            131,
            132,
            133,
            134,
            135,
            136,
            137,
            138,
            146,
            147,
            148,
            149,
            150,
            151,
            152,
            153,
            154,
            162,
            163,
            164,
            165,
            166,
            167,
            168,
            169,
            170,
            178,
            179,
            180,
            181,
            182,
            183,
            184,
            185,
            186,
            194,
            195,
            196,
            197,
            198,
            199,
            200,
            201,
            202,
            210,
            211,
            212,
            213,
            214,
            215,
            216,
            217,
            218,
            226,
            227,
            228,
            229,
            230,
            231,
            232,
            233,
            234,
            242,
            243,
            244,
            245,
            246,
            247,
            248,
            249,
            250
        ];
        function r(t, e) {
            for(var n = 0, r = 0, i = new Array, o = 1; o <= 16; o++){
                for(var a = 1; a <= t[o]; a++)i[e[r]] = [], i[e[r]][0] = n, i[e[r]][1] = o, r++, n++;
                n *= 2;
            }
            return i;
        }
        function G(t) {
            for(var e = t[0], n = t[1] - 1; 0 <= n;)e & 1 << n && (E |= 1 << q), n--, --q < 0 && (255 == E ? (V(255), V(0)) : V(E), q = 7, E = 0);
        }
        function V(t) {
            P.push(t);
        }
        function Y(t) {
            V(t >> 8 & 255), V(255 & t);
        }
        function X(t, e, n, r, i) {
            for(var o, a = i[0], s = i[240], h = function(t, e) {
                var n, r, i, o, a, s, h, c, l, u, f = 0;
                for(l = 0; l < 8; ++l){
                    n = t[f], r = t[f + 1], i = t[f + 2], o = t[f + 3], a = t[f + 4], s = t[f + 5], h = t[f + 6];
                    var d = n + (c = t[f + 7]), p = n - c, g = r + h, m = r - h, w = i + s, y = i - s, v = o + a, b = o - a, x = d + v, S = d - v, k = g + w, _ = g - w;
                    t[f] = x + k, t[f + 4] = x - k;
                    var A = .707106781 * (_ + S);
                    t[f + 2] = S + A, t[f + 6] = S - A;
                    var I = .382683433 * ((x = b + y) - (_ = m + p)), C = .5411961 * x + I, T = 1.306562965 * _ + I, F = .707106781 * (k = y + m), P = p + F, E = p - F;
                    t[f + 5] = E + C, t[f + 3] = E - C, t[f + 1] = P + T, t[f + 7] = P - T, f += 8;
                }
                for(l = f = 0; l < 8; ++l){
                    n = t[f], r = t[f + 8], i = t[f + 16], o = t[f + 24], a = t[f + 32], s = t[f + 40], h = t[f + 48];
                    var q = n + (c = t[f + 56]), O = n - c, B = r + h, R = r - h, j = i + s, D = i - s, M = o + a, U = o - a, N = q + M, z = q - M, L = B + j, H = B - j;
                    t[f] = N + L, t[f + 32] = N - L;
                    var W = .707106781 * (H + z);
                    t[f + 16] = z + W, t[f + 48] = z - W;
                    var G = .382683433 * ((N = U + D) - (H = R + O)), V = .5411961 * N + G, Y = 1.306562965 * H + G, X = .707106781 * (L = D + R), J = O + X, K = O - X;
                    t[f + 40] = K + V, t[f + 24] = K - V, t[f + 8] = J + Y, t[f + 56] = J - Y, f++;
                }
                for(l = 0; l < 64; ++l)u = t[l] * e[l], Q[l] = 0 < u ? u + .5 | 0 : u - .5 | 0;
                return Q;
            }(t, e), c = 0; c < 64; ++c)v[b[c]] = h[c];
            var l = v[0] - n;
            n = v[0], 0 == l ? G(r[0]) : (G(r[y[o = 32767 + l]]), G(w[o]));
            for(var u = 63; 0 < u && 0 == v[u]; u--);
            if (0 == u) return G(a), n;
            for(var f, d = 1; d <= u;){
                for(var p = d; 0 == v[d] && d <= u; ++d);
                var g = d - p;
                if (16 <= g) {
                    f = g >> 4;
                    for(var m = 1; m <= f; ++m)G(s);
                    g &= 15;
                }
                o = 32767 + v[d], G(i[(g << 4) + y[o]]), G(w[o]), d++;
            }
            return 63 != u && G(a), n;
        }
        function J(t) {
            if (t <= 0 && (t = 1), 100 < t && (t = 100), e != t) (function(t) {
                for(var e = [
                    16,
                    11,
                    10,
                    16,
                    24,
                    40,
                    51,
                    61,
                    12,
                    12,
                    14,
                    19,
                    26,
                    58,
                    60,
                    55,
                    14,
                    13,
                    16,
                    24,
                    40,
                    57,
                    69,
                    56,
                    14,
                    17,
                    22,
                    29,
                    51,
                    87,
                    80,
                    62,
                    18,
                    22,
                    37,
                    56,
                    68,
                    109,
                    103,
                    77,
                    24,
                    35,
                    55,
                    64,
                    81,
                    104,
                    113,
                    92,
                    49,
                    64,
                    78,
                    87,
                    103,
                    121,
                    120,
                    101,
                    72,
                    92,
                    95,
                    98,
                    112,
                    100,
                    103,
                    99
                ], n = 0; n < 64; n++){
                    var r = u((e[n] * t + 50) / 100);
                    r < 1 ? r = 1 : 255 < r && (r = 255), I[b[n]] = r;
                }
                for(var i = [
                    17,
                    18,
                    24,
                    47,
                    99,
                    99,
                    99,
                    99,
                    18,
                    21,
                    26,
                    66,
                    99,
                    99,
                    99,
                    99,
                    24,
                    26,
                    56,
                    99,
                    99,
                    99,
                    99,
                    99,
                    47,
                    66,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99,
                    99
                ], o = 0; o < 64; o++){
                    var a = u((i[o] * t + 50) / 100);
                    a < 1 ? a = 1 : 255 < a && (a = 255), C[b[o]] = a;
                }
                for(var s = [
                    1,
                    1.387039845,
                    1.306562965,
                    1.175875602,
                    1,
                    .785694958,
                    .5411961,
                    .275899379
                ], h = 0, c = 0; c < 8; c++)for(var l = 0; l < 8; l++)T[h] = 1 / (I[b[h]] * s[c] * s[l] * 8), F[h] = 1 / (C[b[h]] * s[c] * s[l] * 8), h++;
            })(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), e = t;
        }
        this.encode = function(t, e) {
            var n, r;
            (new Date).getTime();
            e && J(e), P = new Array, E = 0, q = 7, Y(65496), Y(65504), Y(16), V(74), V(70), V(73), V(70), V(0), V(1), V(1), V(0), Y(1), Y(1), V(0), V(0), function() {
                Y(65499), Y(132), V(0);
                for(var t = 0; t < 64; t++)V(I[t]);
                V(1);
                for(var e = 0; e < 64; e++)V(C[e]);
            }(), n = t.width, r = t.height, Y(65472), Y(17), V(8), Y(r), Y(n), V(3), V(1), V(17), V(0), V(2), V(17), V(1), V(3), V(17), V(1), function() {
                Y(65476), Y(418), V(0);
                for(var t = 0; t < 16; t++)V(D[t + 1]);
                for(var e = 0; e <= 11; e++)V(M[e]);
                V(16);
                for(var n = 0; n < 16; n++)V(U[n + 1]);
                for(var r = 0; r <= 161; r++)V(N[r]);
                V(1);
                for(var i = 0; i < 16; i++)V(z[i + 1]);
                for(var o = 0; o <= 11; o++)V(L[o]);
                V(17);
                for(var a = 0; a < 16; a++)V(H[a + 1]);
                for(var s = 0; s <= 161; s++)V(W[s]);
            }(), Y(65498), Y(12), V(3), V(1), V(0), V(2), V(17), V(3), V(17), V(0), V(63), V(0);
            var i = 0, o = 0, a = 0;
            E = 0, q = 7, this.encode.displayName = "_encode_";
            for(var s, h, c, l, u, f, d, p, g, m = t.data, w = t.width, y = t.height, v = 4 * w, b = 0; b < y;){
                for(s = 0; s < v;){
                    for(f = u = v * b + s, d = -1, g = p = 0; g < 64; g++)f = u + (p = g >> 3) * v + (d = 4 * (7 & g)), y <= b + p && (f -= v * (b + 1 + p - y)), v <= s + d && (f -= s + d - v + 4), h = m[f++], c = m[f++], l = m[f++], O[g] = (j[h] + j[c + 256 >> 0] + j[l + 512 >> 0] >> 16) - 128, B[g] = (j[h + 768 >> 0] + j[c + 1024 >> 0] + j[l + 1280 >> 0] >> 16) - 128, R[g] = (j[h + 1280 >> 0] + j[c + 1536 >> 0] + j[l + 1792 >> 0] >> 16) - 128;
                    i = X(O, T, i, S, _), o = X(B, F, o, k, A), a = X(R, F, a, k, A), s += 32;
                }
                b += 8;
            }
            if (0 <= q) {
                var x = [];
                x[1] = q + 1, x[0] = (1 << q + 1) - 1, G(x);
            }
            return Y(65497), new Uint8Array(P);
        }, function() {
            (new Date).getTime();
            t || (t = 50), function() {
                for(var t = String.fromCharCode, e = 0; e < 256; e++)n[e] = t(e);
            }(), S = r(D, M), k = r(z, L), _ = r(U, N), A = r(H, W), function() {
                for(var t = 1, e = 2, n = 1; n <= 15; n++){
                    for(var r = t; r < e; r++)y[32767 + r] = n, w[32767 + r] = [], w[32767 + r][1] = n, w[32767 + r][0] = r;
                    for(var i = -(e - 1); i <= -t; i++)y[32767 + i] = n, w[32767 + i] = [], w[32767 + i][1] = n, w[32767 + i][0] = e - 1 + i;
                    t <<= 1, e <<= 1;
                }
            }(), function() {
                for(var t = 0; t < 256; t++)j[t] = 19595 * t, j[t + 256 >> 0] = 38470 * t, j[t + 512 >> 0] = 7471 * t + 32768, j[t + 768 >> 0] = -11059 * t, j[t + 1024 >> 0] = -21709 * t, j[t + 1280 >> 0] = 32768 * t + 8421375, j[t + 1536 >> 0] = -27439 * t, j[t + 1792 >> 0] = -5329 * t;
            }(), J(t), (new Date).getTime();
        }();
    }
    try {
        module.exports = yt;
    } catch (t) {}
    function xt(t, e) {
        if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
            "BM",
            "BA",
            "CI",
            "CP",
            "IC",
            "PT"
        ].indexOf(this.flag)) throw new Error("Invalid BMP File");
        this.parseHeader(), this.parseBGR();
    }
    xt.prototype.parseHeader = function() {
        if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
            var t = 0 === this.colors ? 1 << this.bitPP : this.colors;
            this.palette = new Array(t);
            for(var e = 0; e < t; e++){
                var n = this.datav.getUint8(this.pos++, !0), r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0);
                this.palette[e] = {
                    red: i,
                    green: r,
                    blue: n,
                    quad: o
                };
            }
        }
        this.height < 0 && (this.height *= -1, this.bottom_up = !1);
    }, xt.prototype.parseBGR = function() {
        this.pos = this.offset;
        try {
            var t = "bit" + this.bitPP, e = this.width * this.height * 4;
            this.data = new Uint8Array(e), this[t]();
        } catch (t) {
            console.log("bit decode error:" + t);
        }
    }, xt.prototype.bit1 = function() {
        var t = Math.ceil(this.width / 8), e = t % 4, n = 0 <= this.height ? this.height - 1 : -this.height;
        for(n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++)for(var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 8 * i * 4, s = 0; s < 8 && 8 * i + s < this.width; s++){
                var h = this.palette[o >> 7 - s & 1];
                this.data[a + 4 * s] = h.blue, this.data[a + 4 * s + 1] = h.green, this.data[a + 4 * s + 2] = h.red, this.data[a + 4 * s + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit4 = function() {
        for(var t = Math.ceil(this.width / 2), e = t % 4, n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < t; i++){
                var o = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 2 * i * 4, s = o >> 4, h = 15 & o, c = this.palette[s];
                if (this.data[a] = c.blue, this.data[a + 1] = c.green, this.data[a + 2] = c.red, this.data[a + 3] = 255, 2 * i + 1 >= this.width) break;
                c = this.palette[h], this.data[a + 4] = c.blue, this.data[a + 4 + 1] = c.green, this.data[a + 4 + 2] = c.red, this.data[a + 4 + 3] = 255;
            }
            0 != e && (this.pos += 4 - e);
        }
    }, xt.prototype.bit8 = function() {
        for(var t = this.width % 4, e = this.height - 1; 0 <= e; e--){
            for(var n = this.bottom_up ? e : this.height - 1 - e, r = 0; r < this.width; r++){
                var i = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 4 * r;
                if (i < this.palette.length) {
                    var a = this.palette[i];
                    this.data[o] = a.red, this.data[o + 1] = a.green, this.data[o + 2] = a.blue, this.data[o + 3] = 255;
                } else this.data[o] = 255, this.data[o + 1] = 255, this.data[o + 2] = 255, this.data[o + 3] = 255;
            }
            0 != t && (this.pos += 4 - t);
        }
    }, xt.prototype.bit15 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = this.height - 1; 0 <= n; n--){
            for(var r = this.bottom_up ? n : this.height - 1 - n, i = 0; i < this.width; i++){
                var o = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var a = (o & e) / e * 255 | 0, s = (o >> 5 & e) / e * 255 | 0, h = (o >> 10 & e) / e * 255 | 0, c = o >> 15 ? 255 : 0, l = r * this.width * 4 + 4 * i;
                this.data[l] = h, this.data[l + 1] = s, this.data[l + 2] = a, this.data[l + 3] = c;
            }
            this.pos += t;
        }
    }, xt.prototype.bit16 = function() {
        for(var t = this.width % 3, e = parseInt("11111", 2), n = parseInt("111111", 2), r = this.height - 1; 0 <= r; r--){
            for(var i = this.bottom_up ? r : this.height - 1 - r, o = 0; o < this.width; o++){
                var a = this.datav.getUint16(this.pos, !0);
                this.pos += 2;
                var s = (a & e) / e * 255 | 0, h = (a >> 5 & n) / n * 255 | 0, c = (a >> 11) / e * 255 | 0, l = i * this.width * 4 + 4 * o;
                this.data[l] = c, this.data[l + 1] = h, this.data[l + 2] = s, this.data[l + 3] = 255;
            }
            this.pos += t;
        }
    }, xt.prototype.bit24 = function() {
        for(var t = this.height - 1; 0 <= t; t--){
            for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
                var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = e * this.width * 4 + 4 * n;
                this.data[a] = o, this.data[a + 1] = i, this.data[a + 2] = r, this.data[a + 3] = 255;
            }
            this.pos += this.width % 4;
        }
    }, xt.prototype.bit32 = function() {
        for(var t = this.height - 1; 0 <= t; t--)for(var e = this.bottom_up ? t : this.height - 1 - t, n = 0; n < this.width; n++){
            var r = this.datav.getUint8(this.pos++, !0), i = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * n;
            this.data[s] = o, this.data[s + 1] = i, this.data[s + 2] = r, this.data[s + 3] = a;
        }
    }, xt.prototype.getData = function() {
        return this.data;
    };
    try {
        module.exports = function(t) {
            var e = new xt(t);
            return {
                data: e.getData(),
                width: e.width,
                height: e.height
            };
        };
    } catch (t) {}
    /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ /*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */ !function(t) {
        var p = 15, g = 573, e = [
            0,
            1,
            2,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            8,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            9,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            10,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            11,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            15,
            0,
            0,
            16,
            17,
            18,
            18,
            19,
            19,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29,
            29
        ];
        function ut() {
            var d = this;
            function h(t, e) {
                for(var n = 0; n |= 1 & t, t >>>= 1, n <<= 1, 0 < --e;);
                return n >>> 1;
            }
            d.build_tree = function(t) {
                var e, n, r, i = d.dyn_tree, o = d.stat_desc.static_tree, a = d.stat_desc.elems, s = -1;
                for(t.heap_len = 0, t.heap_max = g, e = 0; e < a; e++)0 !== i[2 * e] ? (t.heap[++t.heap_len] = s = e, t.depth[e] = 0) : i[2 * e + 1] = 0;
                for(; t.heap_len < 2;)i[2 * (r = t.heap[++t.heap_len] = s < 2 ? ++s : 0)] = 1, t.depth[r] = 0, t.opt_len--, o && (t.static_len -= o[2 * r + 1]);
                for(d.max_code = s, e = Math.floor(t.heap_len / 2); 1 <= e; e--)t.pqdownheap(i, e);
                for(r = a; e = t.heap[1], t.heap[1] = t.heap[t.heap_len--], t.pqdownheap(i, 1), n = t.heap[1], t.heap[--t.heap_max] = e, t.heap[--t.heap_max] = n, i[2 * r] = i[2 * e] + i[2 * n], t.depth[r] = Math.max(t.depth[e], t.depth[n]) + 1, i[2 * e + 1] = i[2 * n + 1] = r, t.heap[1] = r++, t.pqdownheap(i, 1), 2 <= t.heap_len;);
                t.heap[--t.heap_max] = t.heap[1], function(t) {
                    var e, n, r, i, o, a, s = d.dyn_tree, h = d.stat_desc.static_tree, c = d.stat_desc.extra_bits, l = d.stat_desc.extra_base, u = d.stat_desc.max_length, f = 0;
                    for(i = 0; i <= p; i++)t.bl_count[i] = 0;
                    for(s[2 * t.heap[t.heap_max] + 1] = 0, e = t.heap_max + 1; e < g; e++)u < (i = s[2 * s[2 * (n = t.heap[e]) + 1] + 1] + 1) && (i = u, f++), s[2 * n + 1] = i, n > d.max_code || (t.bl_count[i]++, o = 0, l <= n && (o = c[n - l]), a = s[2 * n], t.opt_len += a * (i + o), h && (t.static_len += a * (h[2 * n + 1] + o)));
                    if (0 !== f) {
                        do {
                            for(i = u - 1; 0 === t.bl_count[i];)i--;
                            t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[u]--, f -= 2;
                        }while (0 < f);
                        for(i = u; 0 !== i; i--)for(n = t.bl_count[i]; 0 !== n;)(r = t.heap[--e]) > d.max_code || (s[2 * r + 1] != i && (t.opt_len += (i - s[2 * r + 1]) * s[2 * r], s[2 * r + 1] = i), n--);
                    }
                }(t), function(t, e, n) {
                    var r, i, o, a = [], s = 0;
                    for(r = 1; r <= p; r++)a[r] = s = s + n[r - 1] << 1;
                    for(i = 0; i <= e; i++)0 !== (o = t[2 * i + 1]) && (t[2 * i] = h(a[o]++, o));
                }(i, d.max_code, t.bl_count);
            };
        }
        function ft(t, e, n, r, i) {
            var o = this;
            o.static_tree = t, o.extra_bits = e, o.extra_base = n, o.elems = r, o.max_length = i;
        }
        ut._length_code = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            12,
            12,
            13,
            13,
            13,
            13,
            14,
            14,
            14,
            14,
            15,
            15,
            15,
            15,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            16,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            17,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            18,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            22,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            23,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            26,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            27,
            28
        ], ut.base_length = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            10,
            12,
            14,
            16,
            20,
            24,
            28,
            32,
            40,
            48,
            56,
            64,
            80,
            96,
            112,
            128,
            160,
            192,
            224,
            0
        ], ut.base_dist = [
            0,
            1,
            2,
            3,
            4,
            6,
            8,
            12,
            16,
            24,
            32,
            48,
            64,
            96,
            128,
            192,
            256,
            384,
            512,
            768,
            1024,
            1536,
            2048,
            3072,
            4096,
            6144,
            8192,
            12288,
            16384,
            24576
        ], ut.d_code = function(t) {
            return t < 256 ? e[t] : e[256 + (t >>> 7)];
        }, ut.extra_lbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0
        ], ut.extra_dbits = [
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13
        ], ut.extra_blbits = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            3,
            7
        ], ut.bl_order = [
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ], ft.static_ltree = [
            12,
            8,
            140,
            8,
            76,
            8,
            204,
            8,
            44,
            8,
            172,
            8,
            108,
            8,
            236,
            8,
            28,
            8,
            156,
            8,
            92,
            8,
            220,
            8,
            60,
            8,
            188,
            8,
            124,
            8,
            252,
            8,
            2,
            8,
            130,
            8,
            66,
            8,
            194,
            8,
            34,
            8,
            162,
            8,
            98,
            8,
            226,
            8,
            18,
            8,
            146,
            8,
            82,
            8,
            210,
            8,
            50,
            8,
            178,
            8,
            114,
            8,
            242,
            8,
            10,
            8,
            138,
            8,
            74,
            8,
            202,
            8,
            42,
            8,
            170,
            8,
            106,
            8,
            234,
            8,
            26,
            8,
            154,
            8,
            90,
            8,
            218,
            8,
            58,
            8,
            186,
            8,
            122,
            8,
            250,
            8,
            6,
            8,
            134,
            8,
            70,
            8,
            198,
            8,
            38,
            8,
            166,
            8,
            102,
            8,
            230,
            8,
            22,
            8,
            150,
            8,
            86,
            8,
            214,
            8,
            54,
            8,
            182,
            8,
            118,
            8,
            246,
            8,
            14,
            8,
            142,
            8,
            78,
            8,
            206,
            8,
            46,
            8,
            174,
            8,
            110,
            8,
            238,
            8,
            30,
            8,
            158,
            8,
            94,
            8,
            222,
            8,
            62,
            8,
            190,
            8,
            126,
            8,
            254,
            8,
            1,
            8,
            129,
            8,
            65,
            8,
            193,
            8,
            33,
            8,
            161,
            8,
            97,
            8,
            225,
            8,
            17,
            8,
            145,
            8,
            81,
            8,
            209,
            8,
            49,
            8,
            177,
            8,
            113,
            8,
            241,
            8,
            9,
            8,
            137,
            8,
            73,
            8,
            201,
            8,
            41,
            8,
            169,
            8,
            105,
            8,
            233,
            8,
            25,
            8,
            153,
            8,
            89,
            8,
            217,
            8,
            57,
            8,
            185,
            8,
            121,
            8,
            249,
            8,
            5,
            8,
            133,
            8,
            69,
            8,
            197,
            8,
            37,
            8,
            165,
            8,
            101,
            8,
            229,
            8,
            21,
            8,
            149,
            8,
            85,
            8,
            213,
            8,
            53,
            8,
            181,
            8,
            117,
            8,
            245,
            8,
            13,
            8,
            141,
            8,
            77,
            8,
            205,
            8,
            45,
            8,
            173,
            8,
            109,
            8,
            237,
            8,
            29,
            8,
            157,
            8,
            93,
            8,
            221,
            8,
            61,
            8,
            189,
            8,
            125,
            8,
            253,
            8,
            19,
            9,
            275,
            9,
            147,
            9,
            403,
            9,
            83,
            9,
            339,
            9,
            211,
            9,
            467,
            9,
            51,
            9,
            307,
            9,
            179,
            9,
            435,
            9,
            115,
            9,
            371,
            9,
            243,
            9,
            499,
            9,
            11,
            9,
            267,
            9,
            139,
            9,
            395,
            9,
            75,
            9,
            331,
            9,
            203,
            9,
            459,
            9,
            43,
            9,
            299,
            9,
            171,
            9,
            427,
            9,
            107,
            9,
            363,
            9,
            235,
            9,
            491,
            9,
            27,
            9,
            283,
            9,
            155,
            9,
            411,
            9,
            91,
            9,
            347,
            9,
            219,
            9,
            475,
            9,
            59,
            9,
            315,
            9,
            187,
            9,
            443,
            9,
            123,
            9,
            379,
            9,
            251,
            9,
            507,
            9,
            7,
            9,
            263,
            9,
            135,
            9,
            391,
            9,
            71,
            9,
            327,
            9,
            199,
            9,
            455,
            9,
            39,
            9,
            295,
            9,
            167,
            9,
            423,
            9,
            103,
            9,
            359,
            9,
            231,
            9,
            487,
            9,
            23,
            9,
            279,
            9,
            151,
            9,
            407,
            9,
            87,
            9,
            343,
            9,
            215,
            9,
            471,
            9,
            55,
            9,
            311,
            9,
            183,
            9,
            439,
            9,
            119,
            9,
            375,
            9,
            247,
            9,
            503,
            9,
            15,
            9,
            271,
            9,
            143,
            9,
            399,
            9,
            79,
            9,
            335,
            9,
            207,
            9,
            463,
            9,
            47,
            9,
            303,
            9,
            175,
            9,
            431,
            9,
            111,
            9,
            367,
            9,
            239,
            9,
            495,
            9,
            31,
            9,
            287,
            9,
            159,
            9,
            415,
            9,
            95,
            9,
            351,
            9,
            223,
            9,
            479,
            9,
            63,
            9,
            319,
            9,
            191,
            9,
            447,
            9,
            127,
            9,
            383,
            9,
            255,
            9,
            511,
            9,
            0,
            7,
            64,
            7,
            32,
            7,
            96,
            7,
            16,
            7,
            80,
            7,
            48,
            7,
            112,
            7,
            8,
            7,
            72,
            7,
            40,
            7,
            104,
            7,
            24,
            7,
            88,
            7,
            56,
            7,
            120,
            7,
            4,
            7,
            68,
            7,
            36,
            7,
            100,
            7,
            20,
            7,
            84,
            7,
            52,
            7,
            116,
            7,
            3,
            8,
            131,
            8,
            67,
            8,
            195,
            8,
            35,
            8,
            163,
            8,
            99,
            8,
            227,
            8
        ], ft.static_dtree = [
            0,
            5,
            16,
            5,
            8,
            5,
            24,
            5,
            4,
            5,
            20,
            5,
            12,
            5,
            28,
            5,
            2,
            5,
            18,
            5,
            10,
            5,
            26,
            5,
            6,
            5,
            22,
            5,
            14,
            5,
            30,
            5,
            1,
            5,
            17,
            5,
            9,
            5,
            25,
            5,
            5,
            5,
            21,
            5,
            13,
            5,
            29,
            5,
            3,
            5,
            19,
            5,
            11,
            5,
            27,
            5,
            7,
            5,
            23,
            5
        ], ft.static_l_desc = new ft(ft.static_ltree, ut.extra_lbits, 257, 286, p), ft.static_d_desc = new ft(ft.static_dtree, ut.extra_dbits, 0, 30, p), ft.static_bl_desc = new ft(null, ut.extra_blbits, 0, 19, 7);
        function n(t, e, n, r, i) {
            var o = this;
            o.good_length = t, o.max_lazy = e, o.nice_length = n, o.max_chain = r, o.func = i;
        }
        var dt = [
            new n(0, 0, 0, 0, 0),
            new n(4, 4, 8, 4, 1),
            new n(4, 5, 16, 8, 1),
            new n(4, 6, 32, 32, 1),
            new n(4, 4, 16, 16, 2),
            new n(8, 16, 32, 32, 2),
            new n(8, 16, 128, 128, 2),
            new n(8, 32, 128, 256, 2),
            new n(32, 128, 258, 1024, 2),
            new n(32, 258, 258, 4096, 2)
        ], pt = [
            "need dictionary",
            "stream end",
            "",
            "",
            "stream error",
            "data error",
            "",
            "buffer error",
            "",
            ""
        ], gt = 262;
        function mt(t, e, n, r) {
            var i = t[2 * e], o = t[2 * n];
            return i < o || i == o && r[e] <= r[n];
        }
        function r() {
            var h, c, l, u, f, d, p, g, i, m, w, y, v, a, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, s, j, D, M, U, N, z, o, L, H, W, G = this, V = new ut, Y = new ut, X = new ut;
            function J() {
                var t;
                for(t = 0; t < 286; t++)s[2 * t] = 0;
                for(t = 0; t < 30; t++)j[2 * t] = 0;
                for(t = 0; t < 19; t++)D[2 * t] = 0;
                s[512] = 1, G.opt_len = G.static_len = 0, N = o = 0;
            }
            function K(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), t[2 * (e + 1) + 1] = 65535, n = 0; n <= e; n++)r = o, o = t[2 * (n + 1) + 1], ++a < s && r == o || (a < h ? D[2 * r] += a : 0 !== r ? (r != i && D[2 * r]++, D[32]++) : a <= 10 ? D[34]++ : D[36]++, i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4));
            }
            function Q(t) {
                G.pending_buf[G.pending++] = t;
            }
            function Z(t) {
                Q(255 & t), Q(t >>> 8 & 255);
            }
            function $(t, e) {
                var n, r = e;
                16 - r < W ? (Z(H |= (n = t) << W & 65535), H = n >>> 16 - W, W += r - 16) : (H |= t << W & 65535, W += r);
            }
            function tt(t, e) {
                var n = 2 * t;
                $(65535 & e[n], 65535 & e[n + 1]);
            }
            function et(t, e) {
                var n, r, i = -1, o = t[1], a = 0, s = 7, h = 4;
                for(0 === o && (s = 138, h = 3), n = 0; n <= e; n++)if (r = o, o = t[2 * (n + 1) + 1], !(++a < s && r == o)) {
                    if (a < h) for(; tt(r, D), 0 != --a;);
                    else 0 !== r ? (r != i && (tt(r, D), a--), tt(16, D), $(a - 3, 2)) : a <= 10 ? (tt(17, D), $(a - 3, 3)) : (tt(18, D), $(a - 11, 7));
                    i = r, (a = 0) === o ? (s = 138, h = 3) : r == o ? (s = 6, h = 3) : (s = 7, h = 4);
                }
            }
            function nt() {
                16 == W ? (Z(H), W = H = 0) : 8 <= W && (Q(255 & H), H >>>= 8, W -= 8);
            }
            function rt(t, e) {
                var n, r, i;
                if (G.pending_buf[z + 2 * N] = t >>> 8 & 255, G.pending_buf[z + 2 * N + 1] = 255 & t, G.pending_buf[M + N] = 255 & e, N++, 0 === t ? s[2 * e]++ : (o++, t--, s[2 * (ut._length_code[e] + 256 + 1)]++, j[2 * ut.d_code(t)]++), 0 == (8191 & N) && 2 < q) {
                    for(n = 8 * N, r = I - S, i = 0; i < 30; i++)n += j[2 * i] * (5 + ut.extra_dbits[i]);
                    if (n >>>= 3, o < Math.floor(N / 2) && n < Math.floor(r / 2)) return !0;
                }
                return N == U - 1;
            }
            function it(t, e) {
                var n, r, i, o, a = 0;
                if (0 !== N) for(; n = G.pending_buf[z + 2 * a] << 8 & 65280 | 255 & G.pending_buf[z + 2 * a + 1], r = 255 & G.pending_buf[M + a], a++, 0 === n ? tt(r, t) : (tt((i = ut._length_code[r]) + 256 + 1, t), 0 !== (o = ut.extra_lbits[i]) && $(r -= ut.base_length[i], o), tt(i = ut.d_code(--n), e), 0 !== (o = ut.extra_dbits[i]) && $(n -= ut.base_dist[i], o)), a < N;);
                tt(256, t), L = t[513];
            }
            function ot() {
                8 < W ? Z(H) : 0 < W && Q(255 & H), W = H = 0;
            }
            function at(t, e, n) {
                var r, i, o;
                $(0 + (n ? 1 : 0), 3), r = t, i = e, o = !0, ot(), L = 8, o && (Z(i), Z(~i)), G.pending_buf.set(g.subarray(r, r + i), G.pending), G.pending += i;
            }
            function e(t, e, n) {
                var r, i, o = 0;
                0 < q ? (V.build_tree(G), Y.build_tree(G), o = function() {
                    var t;
                    for(K(s, V.max_code), K(j, Y.max_code), X.build_tree(G), t = 18; 3 <= t && 0 === D[2 * ut.bl_order[t] + 1]; t--);
                    return G.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                }(), r = G.opt_len + 3 + 7 >>> 3, (i = G.static_len + 3 + 7 >>> 3) <= r && (r = i)) : r = i = e + 5, e + 4 <= r && -1 != t ? at(t, e, n) : i == r ? ($(2 + (n ? 1 : 0), 3), it(ft.static_ltree, ft.static_dtree)) : ($(4 + (n ? 1 : 0), 3), function(t, e, n) {
                    var r;
                    for($(t - 257, 5), $(e - 1, 5), $(n - 4, 4), r = 0; r < n; r++)$(D[2 * ut.bl_order[r] + 1], 3);
                    et(s, t - 1), et(j, e - 1);
                }(V.max_code + 1, Y.max_code + 1, o + 1), it(s, j)), J(), n && ot();
            }
            function st(t) {
                e(0 <= S ? S : -1, I - S, t), S = I, h.flush_pending();
            }
            function ht() {
                var t, e, n, r;
                do {
                    if (0 === (r = i - T - I) && 0 === I && 0 === T) r = f;
                    else if (-1 == r) r--;
                    else if (f + f - gt <= I) {
                        for(g.set(g.subarray(f, f + f), 0), C -= f, I -= f, S -= f, n = t = v; e = 65535 & w[--n], w[n] = f <= e ? e - f : 0, 0 != --t;);
                        for(n = t = f; e = 65535 & m[--n], m[n] = f <= e ? e - f : 0, 0 != --t;);
                        r += f;
                    }
                    if (0 === h.avail_in) return;
                    t = h.read_buf(g, I + T, r), 3 <= (T += t) && (y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b);
                }while (T < gt && 0 !== h.avail_in);
            }
            function ct(t) {
                var e, n, r = P, i = I, o = F, a = f - gt < I ? I - (f - gt) : 0, s = R, h = p, c = I + 258, l = g[i + o - 1], u = g[i + o];
                B <= F && (r >>= 2), T < s && (s = T);
                do if (g[(e = t) + o] == u && g[e + o - 1] == l && g[e] == g[i] && g[++e] == g[i + 1]) {
                    i += 2, e++;
                    do ;
                    while (g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && g[++i] == g[++e] && i < c);
                    if (n = 258 - (c - i), i = c - 258, o < n) {
                        if (C = t, s <= (o = n)) break;
                        l = g[i + o - 1], u = g[i + o];
                    }
                }
                while ((t = 65535 & m[t & h]) > a && 0 != --r);
                return o <= T ? o : T;
            }
            function lt(t) {
                return t.total_in = t.total_out = 0, t.msg = null, G.pending = 0, G.pending_out = 0, c = 113, u = 0, V.dyn_tree = s, V.stat_desc = ft.static_l_desc, Y.dyn_tree = j, Y.stat_desc = ft.static_d_desc, X.dyn_tree = D, X.stat_desc = ft.static_bl_desc, W = H = 0, L = 8, J(), function() {
                    var t;
                    for(i = 2 * f, t = w[v - 1] = 0; t < v - 1; t++)w[t] = 0;
                    E = dt[q].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain, k = F = 2, y = A = T = S = I = 0;
                }(), 0;
            }
            G.depth = [], G.bl_count = [], G.heap = [], s = [], j = [], D = [], G.pqdownheap = function(t, e) {
                for(var n = G.heap, r = n[e], i = e << 1; i <= G.heap_len && (i < G.heap_len && mt(t, n[i + 1], n[i], G.depth) && i++, !mt(t, r, n[i], G.depth));)n[e] = n[i], e = i, i <<= 1;
                n[e] = r;
            }, G.deflateInit = function(t, e, n, r, i, o) {
                return r || (r = 8), i || (i = 8), o || (o = 0), t.msg = null, -1 == e && (e = 6), i < 1 || 9 < i || 8 != r || n < 9 || 15 < n || e < 0 || 9 < e || o < 0 || 2 < o ? -2 : (t.dstate = G, p = (f = 1 << (d = n)) - 1, b = (v = 1 << (a = i + 7)) - 1, x = Math.floor((a + 3 - 1) / 3), g = new Uint8Array(2 * f), m = [], w = [], U = 1 << i + 6, G.pending_buf = new Uint8Array(4 * U), l = 4 * U, z = Math.floor(U / 2), M = 3 * U, q = e, O = o, lt(t));
            }, G.deflateEnd = function() {
                return 42 != c && 113 != c && 666 != c ? -2 : (G.pending_buf = null, g = m = w = null, G.dstate = null, 113 == c ? -3 : 0);
            }, G.deflateParams = function(t, e, n) {
                var r = 0;
                return -1 == e && (e = 6), e < 0 || 9 < e || n < 0 || 2 < n ? -2 : (dt[q].func != dt[e].func && 0 !== t.total_in && (r = t.deflate(1)), q != e && (E = dt[q = e].max_lazy, B = dt[q].good_length, R = dt[q].nice_length, P = dt[q].max_chain), O = n, r);
            }, G.deflateSetDictionary = function(t, e, n) {
                var r, i = n, o = 0;
                if (!e || 42 != c) return -2;
                if (i < 3) return 0;
                for(f - gt < i && (o = n - (i = f - gt)), g.set(e.subarray(o, o + i), 0), S = I = i, y = ((y = 255 & g[0]) << x ^ 255 & g[1]) & b, r = 0; r <= i - 3; r++)y = (y << x ^ 255 & g[r + 2]) & b, m[r & p] = w[y], w[y] = r;
                return 0;
            }, G.deflate = function(t, e) {
                var n, r, i, o, a, s;
                if (4 < e || e < 0) return -2;
                if (!t.next_out || !t.next_in && 0 !== t.avail_in || 666 == c && 4 != e) return t.msg = pt[4], -2;
                if (0 === t.avail_out) return t.msg = pt[7], -5;
                if (h = t, o = u, u = e, 42 == c && (r = 8 + (d - 8 << 4) << 8, 3 < (i = (q - 1 & 255) >> 1) && (i = 3), r |= i << 6, 0 !== I && (r |= 32), c = 113, Q((s = r += 31 - r % 31) >> 8 & 255), Q(255 & s)), 0 !== G.pending) {
                    if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                } else if (0 === h.avail_in && e <= o && 4 != e) return h.msg = pt[7], -5;
                if (666 == c && 0 !== h.avail_in) return t.msg = pt[7], -5;
                if (0 !== h.avail_in || 0 !== T || 0 != e && 666 != c) {
                    switch(a = -1, dt[q].func){
                        case 0:
                            a = function(t) {
                                var e, n = 65535;
                                for(l - 5 < n && (n = l - 5);;){
                                    if (T <= 1) {
                                        if (ht(), 0 === T && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (I += T, e = S + n, ((T = 0) === I || e <= I) && (T = I - e, I = e, st(!1), 0 === h.avail_out)) return 0;
                                    if (f - gt <= I - S && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 1:
                            a = function(t) {
                                for(var e, n = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 !== n && (I - n & 65535) <= f - gt && 2 != O && (k = ct(n)), 3 <= k) {
                                        if (e = rt(I - C, k - 3), T -= k, k <= E && 3 <= T) {
                                            for(k--; y = (y << x ^ 255 & g[++I + 2]) & b, n = 65535 & w[y], m[I & p] = w[y], w[y] = I, 0 != --k;);
                                            I++;
                                        } else I += k, k = 0, y = ((y = 255 & g[I]) << x ^ 255 & g[I + 1]) & b;
                                    } else e = rt(0, 255 & g[I]), T--, I++;
                                    if (e && (st(!1), 0 === h.avail_out)) return 0;
                                }
                                return st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                            break;
                        case 2:
                            a = function(t) {
                                for(var e, n, r = 0;;){
                                    if (T < gt) {
                                        if (ht(), T < gt && 0 == t) return 0;
                                        if (0 === T) break;
                                    }
                                    if (3 <= T && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), F = k, _ = C, k = 2, 0 !== r && F < E && (I - r & 65535) <= f - gt && (2 != O && (k = ct(r)), k <= 5 && (1 == O || 3 == k && 4096 < I - C) && (k = 2)), 3 <= F && k <= F) {
                                        for(n = I + T - 3, e = rt(I - 1 - _, F - 3), T -= F - 1, F -= 2; ++I <= n && (y = (y << x ^ 255 & g[I + 2]) & b, r = 65535 & w[y], m[I & p] = w[y], w[y] = I), 0 != --F;);
                                        if (A = 0, k = 2, I++, e && (st(!1), 0 === h.avail_out)) return 0;
                                    } else if (0 !== A) {
                                        if ((e = rt(0, 255 & g[I - 1])) && st(!1), I++, T--, 0 === h.avail_out) return 0;
                                    } else A = 1, I++, T--;
                                }
                                return 0 !== A && (e = rt(0, 255 & g[I - 1]), A = 0), st(4 == t), 0 === h.avail_out ? 4 == t ? 2 : 0 : 4 == t ? 3 : 1;
                            }(e);
                    }
                    if (2 != a && 3 != a || (c = 666), 0 == a || 2 == a) return 0 === h.avail_out && (u = -1), 0;
                    if (1 == a) {
                        if (1 == e) $(2, 3), tt(256, ft.static_ltree), nt(), 1 + L + 10 - W < 9 && ($(2, 3), tt(256, ft.static_ltree), nt()), L = 7;
                        else if (at(0, 0, !1), 3 == e) for(n = 0; n < v; n++)w[n] = 0;
                        if (h.flush_pending(), 0 === h.avail_out) return u = -1, 0;
                    }
                }
                return 4 != e ? 0 : 1;
            };
        }
        function i() {
            var t = this;
            t.next_in_index = 0, t.next_out_index = 0, t.avail_in = 0, t.total_in = 0, t.avail_out = 0, t.total_out = 0;
        }
        i.prototype = {
            deflateInit: function(t, e) {
                return this.dstate = new r, e || (e = p), this.dstate.deflateInit(this, t, e);
            },
            deflate: function(t) {
                return this.dstate ? this.dstate.deflate(this, t) : -2;
            },
            deflateEnd: function() {
                if (!this.dstate) return -2;
                var t = this.dstate.deflateEnd();
                return this.dstate = null, t;
            },
            deflateParams: function(t, e) {
                return this.dstate ? this.dstate.deflateParams(this, t, e) : -2;
            },
            deflateSetDictionary: function(t, e) {
                return this.dstate ? this.dstate.deflateSetDictionary(this, t, e) : -2;
            },
            read_buf: function(t, e, n) {
                var r = this, i = r.avail_in;
                return n < i && (i = n), 0 === i ? 0 : (r.avail_in -= i, t.set(r.next_in.subarray(r.next_in_index, r.next_in_index + i), e), r.next_in_index += i, r.total_in += i, i);
            },
            flush_pending: function() {
                var t = this, e = t.dstate.pending;
                e > t.avail_out && (e = t.avail_out), 0 !== e && (t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out, t.dstate.pending_out + e), t.next_out_index), t.next_out_index += e, t.dstate.pending_out += e, t.total_out += e, t.avail_out -= e, t.dstate.pending -= e, 0 === t.dstate.pending && (t.dstate.pending_out = 0));
            }
        };
        var o = t.zip || t;
        o.Deflater = o._jzlib_Deflater = function(t) {
            var s = new i, h = new Uint8Array(512), e = t ? t.level : -1;
            void 0 === e && (e = -1), s.deflateInit(e), s.next_out = h, this.append = function(t, e) {
                var n, r = [], i = 0, o = 0, a = 0;
                if (t.length) {
                    s.next_in_index = 0, s.next_in = t, s.avail_in = t.length;
                    do {
                        if (s.next_out_index = 0, s.avail_out = 512, 0 != s.deflate(0)) throw new Error("deflating: " + s.msg);
                        s.next_out_index && (512 == s.next_out_index ? r.push(new Uint8Array(h)) : r.push(new Uint8Array(h.subarray(0, s.next_out_index)))), a += s.next_out_index, e && 0 < s.next_in_index && s.next_in_index != i && (e(s.next_in_index), i = s.next_in_index);
                    }while (0 < s.avail_in || 0 === s.avail_out);
                    return n = new Uint8Array(a), r.forEach(function(t) {
                        n.set(t, o), o += t.length;
                    }), n;
                }
            }, this.flush = function() {
                var t, e, n = [], r = 0, i = 0;
                do {
                    if (s.next_out_index = 0, s.avail_out = 512, 1 != (t = s.deflate(4)) && 0 != t) throw new Error("deflating: " + s.msg);
                    0 < 512 - s.avail_out && n.push(new Uint8Array(h.subarray(0, s.next_out_index))), i += s.next_out_index;
                }while (0 < s.avail_in || 0 === s.avail_out);
                return s.deflateEnd(), e = new Uint8Array(i), n.forEach(function(t) {
                    e.set(t, r), r += t.length;
                }), e;
            };
        };
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof global && global || Function('return typeof this === "object" && this.content')() || Function("return this")()), /**
   * A class to parse color values
   * @author Stoyan Stefanov <sstoo@gmail.com>
   * @link   http://www.phpied.com/rgb-color-parser-in-javascript/
   * @license Use it if you like it
   */ function(t) {
        function f(t) {
            var e;
            this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6)), t = (t = t.replace(/ /g, "")).toLowerCase();
            var l = {
                aliceblue: "f0f8ff",
                antiquewhite: "faebd7",
                aqua: "00ffff",
                aquamarine: "7fffd4",
                azure: "f0ffff",
                beige: "f5f5dc",
                bisque: "ffe4c4",
                black: "000000",
                blanchedalmond: "ffebcd",
                blue: "0000ff",
                blueviolet: "8a2be2",
                brown: "a52a2a",
                burlywood: "deb887",
                cadetblue: "5f9ea0",
                chartreuse: "7fff00",
                chocolate: "d2691e",
                coral: "ff7f50",
                cornflowerblue: "6495ed",
                cornsilk: "fff8dc",
                crimson: "dc143c",
                cyan: "00ffff",
                darkblue: "00008b",
                darkcyan: "008b8b",
                darkgoldenrod: "b8860b",
                darkgray: "a9a9a9",
                darkgreen: "006400",
                darkkhaki: "bdb76b",
                darkmagenta: "8b008b",
                darkolivegreen: "556b2f",
                darkorange: "ff8c00",
                darkorchid: "9932cc",
                darkred: "8b0000",
                darksalmon: "e9967a",
                darkseagreen: "8fbc8f",
                darkslateblue: "483d8b",
                darkslategray: "2f4f4f",
                darkturquoise: "00ced1",
                darkviolet: "9400d3",
                deeppink: "ff1493",
                deepskyblue: "00bfff",
                dimgray: "696969",
                dodgerblue: "1e90ff",
                feldspar: "d19275",
                firebrick: "b22222",
                floralwhite: "fffaf0",
                forestgreen: "228b22",
                fuchsia: "ff00ff",
                gainsboro: "dcdcdc",
                ghostwhite: "f8f8ff",
                gold: "ffd700",
                goldenrod: "daa520",
                gray: "808080",
                green: "008000",
                greenyellow: "adff2f",
                honeydew: "f0fff0",
                hotpink: "ff69b4",
                indianred: "cd5c5c",
                indigo: "4b0082",
                ivory: "fffff0",
                khaki: "f0e68c",
                lavender: "e6e6fa",
                lavenderblush: "fff0f5",
                lawngreen: "7cfc00",
                lemonchiffon: "fffacd",
                lightblue: "add8e6",
                lightcoral: "f08080",
                lightcyan: "e0ffff",
                lightgoldenrodyellow: "fafad2",
                lightgrey: "d3d3d3",
                lightgreen: "90ee90",
                lightpink: "ffb6c1",
                lightsalmon: "ffa07a",
                lightseagreen: "20b2aa",
                lightskyblue: "87cefa",
                lightslateblue: "8470ff",
                lightslategray: "778899",
                lightsteelblue: "b0c4de",
                lightyellow: "ffffe0",
                lime: "00ff00",
                limegreen: "32cd32",
                linen: "faf0e6",
                magenta: "ff00ff",
                maroon: "800000",
                mediumaquamarine: "66cdaa",
                mediumblue: "0000cd",
                mediumorchid: "ba55d3",
                mediumpurple: "9370d8",
                mediumseagreen: "3cb371",
                mediumslateblue: "7b68ee",
                mediumspringgreen: "00fa9a",
                mediumturquoise: "48d1cc",
                mediumvioletred: "c71585",
                midnightblue: "191970",
                mintcream: "f5fffa",
                mistyrose: "ffe4e1",
                moccasin: "ffe4b5",
                navajowhite: "ffdead",
                navy: "000080",
                oldlace: "fdf5e6",
                olive: "808000",
                olivedrab: "6b8e23",
                orange: "ffa500",
                orangered: "ff4500",
                orchid: "da70d6",
                palegoldenrod: "eee8aa",
                palegreen: "98fb98",
                paleturquoise: "afeeee",
                palevioletred: "d87093",
                papayawhip: "ffefd5",
                peachpuff: "ffdab9",
                peru: "cd853f",
                pink: "ffc0cb",
                plum: "dda0dd",
                powderblue: "b0e0e6",
                purple: "800080",
                red: "ff0000",
                rosybrown: "bc8f8f",
                royalblue: "4169e1",
                saddlebrown: "8b4513",
                salmon: "fa8072",
                sandybrown: "f4a460",
                seagreen: "2e8b57",
                seashell: "fff5ee",
                sienna: "a0522d",
                silver: "c0c0c0",
                skyblue: "87ceeb",
                slateblue: "6a5acd",
                slategray: "708090",
                snow: "fffafa",
                springgreen: "00ff7f",
                steelblue: "4682b4",
                tan: "d2b48c",
                teal: "008080",
                thistle: "d8bfd8",
                tomato: "ff6347",
                turquoise: "40e0d0",
                violet: "ee82ee",
                violetred: "d02090",
                wheat: "f5deb3",
                white: "ffffff",
                whitesmoke: "f5f5f5",
                yellow: "ffff00",
                yellowgreen: "9acd32"
            };
            for(var n in l)t == n && (t = l[n]);
            for(var u = [
                {
                    re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                    example: [
                        "rgb(123, 234, 45)",
                        "rgb(255,234,245)"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1]),
                            parseInt(t[2]),
                            parseInt(t[3])
                        ];
                    }
                },
                {
                    re: /^(\w{2})(\w{2})(\w{2})$/,
                    example: [
                        "#00ff00",
                        "336699"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1], 16),
                            parseInt(t[2], 16),
                            parseInt(t[3], 16)
                        ];
                    }
                },
                {
                    re: /^(\w{1})(\w{1})(\w{1})$/,
                    example: [
                        "#fb0",
                        "f0f"
                    ],
                    process: function(t) {
                        return [
                            parseInt(t[1] + t[1], 16),
                            parseInt(t[2] + t[2], 16),
                            parseInt(t[3] + t[3], 16)
                        ];
                    }
                }
            ], r = 0; r < u.length; r++){
                var i = u[r].re, o = u[r].process, a = i.exec(t);
                a && (e = o(a), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
            }
            this.r = this.r < 0 || isNaN(this.r) ? 0 : 255 < this.r ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : 255 < this.g ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : 255 < this.b ? 255 : this.b, this.toRGB = function() {
                return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
            }, this.toHex = function() {
                var t = this.r.toString(16), e = this.g.toString(16), n = this.b.toString(16);
                return 1 == t.length && (t = "0" + t), 1 == e.length && (e = "0" + e), 1 == n.length && (n = "0" + n), "#" + t + e + n;
            }, this.getHelpXML = function() {
                for(var t = new Array, e = 0; e < u.length; e++)for(var n = u[e].example, r = 0; r < n.length; r++)t[t.length] = n[r];
                for(var i in l)t[t.length] = i;
                var o = document.createElement("ul");
                o.setAttribute("id", "rgbcolor-examples");
                for(e = 0; e < t.length; e++)try {
                    var a = document.createElement("li"), s = new f(t[e]), h = document.createElement("div");
                    h.style.cssText = "margin: 3px; border: 1px solid black; background:" + s.toHex() + "; color:" + s.toHex(), h.appendChild(document.createTextNode("test"));
                    var c = document.createTextNode(" " + t[e] + " -> " + s.toRGB() + " -> " + s.toHex());
                    a.appendChild(h), a.appendChild(c), o.appendChild(a);
                } catch (t) {}
                return o;
            };
        }
        "undefined" != typeof define && define.amd ? define("RGBColor", function() {
            return f;
        }) : (0, module.exports) && (module.exports = f), t.RGBColor = f;
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof global && global || Function('return typeof this === "object" && this.content')() || Function("return this")()), function(t) {
        var e;
        module.exports = t();
    }(function() {
        return (function o(a, s, h) {
            function c(n, t) {
                if (!s[n]) {
                    if (!a[n]) {
                        var e = undefined;
                        if (!t && e) return e(n, !0);
                        if (l) return l(n, !0);
                        var r = new Error("Cannot find module '" + n + "'");
                        throw r.code = "MODULE_NOT_FOUND", r;
                    }
                    var i = s[n] = {
                        exports: {}
                    };
                    a[n][0].call(i.exports, function(t) {
                        var e = a[n][1][t];
                        return c(e || t);
                    }, i, i.exports, o, a, s, h);
                }
                return s[n].exports;
            }
            for(var l = undefined, t = 0; t < h.length; t++)c(h[t]);
            return c;
        })({
            1: [
                function(t, q, O) {
                    (function(E) {
                        !function(t) {
                            var e = "object" == typeof O && O, n = "object" == typeof q && q && q.exports == e && q, r = "object" == typeof E && E;
                            r.global !== r && r.window !== r || (t = r);
                            var i, o, w = 2147483647, y = 36, v = 1, b = 26, a = 38, s = 700, x = 72, S = 128, k = "-", h = /^xn--/, c = /[^ -~]/, l = /\x2E|\u3002|\uFF0E|\uFF61/g, u = {
                                overflow: "Overflow: input needs wider integers to process",
                                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                                "invalid-input": "Invalid input"
                            }, f = y - v, _ = Math.floor, A = String.fromCharCode;
                            function I(t) {
                                throw RangeError(u[t]);
                            }
                            function d(t, e) {
                                for(var n = t.length; n--;)t[n] = e(t[n]);
                                return t;
                            }
                            function p(t, e) {
                                return d(t.split(l), e).join(".");
                            }
                            function C(t) {
                                for(var e, n, r = [], i = 0, o = t.length; i < o;)55296 <= (e = t.charCodeAt(i++)) && e <= 56319 && i < o ? 56320 == (64512 & (n = t.charCodeAt(i++))) ? r.push(((1023 & e) << 10) + (1023 & n) + 65536) : (r.push(e), i--) : r.push(e);
                                return r;
                            }
                            function T(t) {
                                return d(t, function(t) {
                                    var e = "";
                                    return 65535 < t && (e += A((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += A(t);
                                }).join("");
                            }
                            function F(t, e) {
                                return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
                            }
                            function P(t, e, n) {
                                var r = 0;
                                for(t = n ? _(t / s) : t >> 1, t += _(t / e); f * b >> 1 < t; r += y)t = _(t / f);
                                return _(r + (f + 1) * t / (t + a));
                            }
                            function g(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f = [], d = t.length, p = 0, g = S, m = x;
                                for((n = t.lastIndexOf(k)) < 0 && (n = 0), r = 0; r < n; ++r)128 <= t.charCodeAt(r) && I("not-basic"), f.push(t.charCodeAt(r));
                                for(i = 0 < n ? n + 1 : 0; i < d;){
                                    for(o = p, a = 1, s = y; d <= i && I("invalid-input"), u = t.charCodeAt(i++), (y <= (h = u - 48 < 10 ? u - 22 : u - 65 < 26 ? u - 65 : u - 97 < 26 ? u - 97 : y) || h > _((w - p) / a)) && I("overflow"), p += h * a, !(h < (c = s <= m ? v : m + b <= s ? b : s - m)); s += y)a > _(w / (l = y - c)) && I("overflow"), a *= l;
                                    m = P(p - o, e = f.length + 1, 0 == o), _(p / e) > w - g && I("overflow"), g += _(p / e), p %= e, f.splice(p++, 0, g);
                                }
                                return T(f);
                            }
                            function m(t) {
                                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g, m = [];
                                for(f = (t = C(t)).length, e = S, o = x, a = n = 0; a < f; ++a)(u = t[a]) < 128 && m.push(A(u));
                                for(r = i = m.length, i && m.push(k); r < f;){
                                    for(s = w, a = 0; a < f; ++a)e <= (u = t[a]) && u < s && (s = u);
                                    for(s - e > _((w - n) / (d = r + 1)) && I("overflow"), n += (s - e) * d, e = s, a = 0; a < f; ++a)if ((u = t[a]) < e && ++n > w && I("overflow"), u == e) {
                                        for(h = n, c = y; !(h < (l = c <= o ? v : o + b <= c ? b : c - o)); c += y)g = h - l, p = y - l, m.push(A(F(l + g % p, 0))), h = _(g / p);
                                        m.push(A(F(h, 0))), o = P(n, d, r == i), n = 0, ++r;
                                    }
                                    ++n, ++e;
                                }
                                return m.join("");
                            }
                            if (i = {
                                version: "1.2.4",
                                ucs2: {
                                    decode: C,
                                    encode: T
                                },
                                decode: g,
                                encode: m,
                                toASCII: function(t) {
                                    return p(t, function(t) {
                                        return c.test(t) ? "xn--" + m(t) : t;
                                    });
                                },
                                toUnicode: function(t) {
                                    return p(t, function(t) {
                                        return h.test(t) ? g(t.slice(4).toLowerCase()) : t;
                                    });
                                }
                            }, e && !e.nodeType) {
                                if (n) n.exports = i;
                                else for(o in i)i.hasOwnProperty(o) && (e[o] = i[o]);
                            } else t.punycode = i;
                        }(this);
                    }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
                },
                {}
            ],
            2: [
                function(t, e, n) {
                    var i = t("./log");
                    function u(t, e) {
                        for(var n = 3 === t.nodeType ? document.createTextNode(t.nodeValue) : t.cloneNode(!1), r = t.firstChild; r;)!0 !== e && 1 === r.nodeType && "SCRIPT" === r.nodeName || n.appendChild(u(r, e)), r = r.nextSibling;
                        return 1 === t.nodeType && (n._scrollTop = t.scrollTop, n._scrollLeft = t.scrollLeft, "CANVAS" === t.nodeName ? function(e, t) {
                            try {
                                t && (t.width = e.width, t.height = e.height, t.getContext("2d").putImageData(e.getContext("2d").getImageData(0, 0, e.width, e.height), 0, 0));
                            } catch (t) {
                                i("Unable to copy canvas content from", e, t);
                            }
                        }(t, n) : "TEXTAREA" !== t.nodeName && "SELECT" !== t.nodeName || (n.value = t.value)), n;
                    }
                    e.exports = function(o, t, e, n, a, s, h) {
                        var c = u(o.documentElement, a.javascriptEnabled), l = t.createElement("iframe");
                        return l.className = "html2canvas-container", l.style.visibility = "hidden", l.style.position = "fixed", l.style.left = "-10000px", l.style.top = "0px", l.style.border = "0", l.width = e, l.height = n, l.scrolling = "no", t.body.appendChild(l), new Promise(function(e) {
                            var t, n, r, i = l.contentWindow.document;
                            l.contentWindow.onload = l.onload = function() {
                                var t = setInterval(function() {
                                    0 < i.body.childNodes.length && (!function t(e) {
                                        if (1 === e.nodeType) {
                                            e.scrollTop = e._scrollTop, e.scrollLeft = e._scrollLeft;
                                            for(var n = e.firstChild; n;)t(n), n = n.nextSibling;
                                        }
                                    }(i.documentElement), clearInterval(t), "view" === a.type && (l.contentWindow.scrollTo(s, h), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || l.contentWindow.scrollY === h && l.contentWindow.scrollX === s || (i.documentElement.style.top = -h + "px", i.documentElement.style.left = -s + "px", i.documentElement.style.position = "absolute")), e(l));
                                }, 50);
                            }, i.open(), i.write("<!DOCTYPE html><html></html>"), n = s, r = h, !(t = o).defaultView || n === t.defaultView.pageXOffset && r === t.defaultView.pageYOffset || t.defaultView.scrollTo(n, r), i.replaceChild(i.adoptNode(c), i.documentElement), i.close();
                        });
                    };
                },
                {
                    "./log": 13
                }
            ],
            3: [
                function(t, e, n) {
                    function r(t) {
                        this.r = 0, this.g = 0, this.b = 0, this.a = null;
                        this.fromArray(t) || this.namedColor(t) || this.rgb(t) || this.rgba(t) || this.hex6(t) || this.hex3(t);
                    }
                    r.prototype.darken = function(t) {
                        var e = 1 - t;
                        return new r([
                            Math.round(this.r * e),
                            Math.round(this.g * e),
                            Math.round(this.b * e),
                            this.a
                        ]);
                    }, r.prototype.isTransparent = function() {
                        return 0 === this.a;
                    }, r.prototype.isBlack = function() {
                        return 0 === this.r && 0 === this.g && 0 === this.b;
                    }, r.prototype.fromArray = function(t) {
                        return Array.isArray(t) && (this.r = Math.min(t[0], 255), this.g = Math.min(t[1], 255), this.b = Math.min(t[2], 255), 3 < t.length && (this.a = t[3])), Array.isArray(t);
                    };
                    var i = /^#([a-f0-9]{3})$/i;
                    r.prototype.hex3 = function(t) {
                        var e;
                        return null !== (e = t.match(i)) && (this.r = parseInt(e[1][0] + e[1][0], 16), this.g = parseInt(e[1][1] + e[1][1], 16), this.b = parseInt(e[1][2] + e[1][2], 16)), null !== e;
                    };
                    var o = /^#([a-f0-9]{6})$/i;
                    r.prototype.hex6 = function(t) {
                        var e = null;
                        return null !== (e = t.match(o)) && (this.r = parseInt(e[1].substring(0, 2), 16), this.g = parseInt(e[1].substring(2, 4), 16), this.b = parseInt(e[1].substring(4, 6), 16)), null !== e;
                    };
                    var a = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    r.prototype.rgb = function(t) {
                        var e;
                        return null !== (e = t.match(a)) && (this.r = Number(e[1]), this.g = Number(e[2]), this.b = Number(e[3])), null !== e;
                    };
                    var s = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
                    r.prototype.rgba = function(t) {
                        var e;
                        return null !== (e = t.match(s)) && (this.r = Number(e[1]), this.g = Number(e[2]), this.b = Number(e[3]), this.a = Number(e[4])), null !== e;
                    }, r.prototype.toString = function() {
                        return null !== this.a && 1 !== this.a ? "rgba(" + [
                            this.r,
                            this.g,
                            this.b,
                            this.a
                        ].join(",") + ")" : "rgb(" + [
                            this.r,
                            this.g,
                            this.b
                        ].join(",") + ")";
                    }, r.prototype.namedColor = function(t) {
                        t = t.toLowerCase();
                        var e = h[t];
                        if (e) this.r = e[0], this.g = e[1], this.b = e[2];
                        else if ("transparent" === t) return this.r = this.g = this.b = this.a = 0, !0;
                        return !!e;
                    }, r.prototype.isColor = !0;
                    var h = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ],
                        yellowgreen: [
                            154,
                            205,
                            50
                        ]
                    };
                    e.exports = r;
                },
                {}
            ],
            4: [
                function(t, e, n) {
                    var p = t("./support"), d = t("./renderers/canvas"), g = t("./imageloader"), m = t("./nodeparser"), r = t("./nodecontainer"), w = t("./log"), i = t("./utils"), y = t("./clone"), v = t("./proxy").loadUrlDocument, b = i.getBounds, x = "data-html2canvas-node", S = 0;
                    function o(t, e) {
                        var n, r, i = S++;
                        if ((e = e || {}).logging && (w.options.logging = !0, w.options.start = Date.now()), e.async = void 0 === e.async || e.async, e.allowTaint = void 0 !== e.allowTaint && e.allowTaint, e.removeContainer = void 0 === e.removeContainer || e.removeContainer, e.javascriptEnabled = void 0 !== e.javascriptEnabled && e.javascriptEnabled, e.imageTimeout = void 0 === e.imageTimeout ? 1e4 : e.imageTimeout, e.renderer = "function" == typeof e.renderer ? e.renderer : d, e.strict = !!e.strict, "string" == typeof t) {
                            if ("string" != typeof e.proxy) return Promise.reject("Proxy must be used when rendering url");
                            var o = null != e.width ? e.width : window.innerWidth, a = null != e.height ? e.height : window.innerHeight;
                            return v((n = t, r = document.createElement("a"), r.href = n, r.href = r.href, r), e.proxy, document, o, a, e).then(function(t) {
                                return k(t.contentWindow.document.documentElement, t, e, o, a);
                            });
                        }
                        var s, h, c, l, u, f = (void 0 === t ? [
                            document.documentElement
                        ] : t.length ? t : [
                            t
                        ])[0];
                        return f.setAttribute(x + i, i), (s = f.ownerDocument, h = e, c = f.ownerDocument.defaultView.innerWidth, l = f.ownerDocument.defaultView.innerHeight, u = i, y(s, s, c, l, h, s.defaultView.pageXOffset, s.defaultView.pageYOffset).then(function(t) {
                            w("Document cloned");
                            var e = x + u, n = "[" + e + "='" + u + "']";
                            s.querySelector(n).removeAttribute(e);
                            var r = t.contentWindow, i = r.document.querySelector(n), o = "function" == typeof h.onclone ? Promise.resolve(h.onclone(r.document)) : Promise.resolve(!0);
                            return o.then(function() {
                                return k(i, t, h, c, l);
                            });
                        })).then(function(t) {
                            return "function" == typeof e.onrendered && (w("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas"), e.onrendered(t)), t;
                        });
                    }
                    o.CanvasRenderer = d, o.NodeContainer = r, o.log = w, o.utils = i;
                    var a = "undefined" == typeof document || "function" != typeof Object.create || "function" != typeof document.createElement("canvas").getContext ? function() {
                        return Promise.reject("No canvas support");
                    } : o;
                    function k(n, r, i, t, e) {
                        var o, a, s = r.contentWindow, h = new p(s.document), c = new g(i, h), l = b(n), u = "view" === i.type ? t : (o = s.document, Math.max(Math.max(o.body.scrollWidth, o.documentElement.scrollWidth), Math.max(o.body.offsetWidth, o.documentElement.offsetWidth), Math.max(o.body.clientWidth, o.documentElement.clientWidth))), f = "view" === i.type ? e : (a = s.document, Math.max(Math.max(a.body.scrollHeight, a.documentElement.scrollHeight), Math.max(a.body.offsetHeight, a.documentElement.offsetHeight), Math.max(a.body.clientHeight, a.documentElement.clientHeight))), d = new i.renderer(u, f, c, i, document);
                        return new m(n, d, h, c, i).ready.then(function() {
                            var t, e;
                            return w("Finished rendering"), t = "view" === i.type ? _(d.canvas, {
                                width: d.canvas.width,
                                height: d.canvas.height,
                                top: 0,
                                left: 0,
                                x: 0,
                                y: 0
                            }) : n === s.document.body || n === s.document.documentElement || null != i.canvas ? d.canvas : _(d.canvas, {
                                width: null != i.width ? i.width : l.width,
                                height: null != i.height ? i.height : l.height,
                                top: l.top,
                                left: l.left,
                                x: 0,
                                y: 0
                            }), e = r, i.removeContainer && (e.parentNode.removeChild(e), w("Cleaned up container")), t;
                        });
                    }
                    function _(t, e) {
                        var n = document.createElement("canvas"), r = Math.min(t.width - 1, Math.max(0, e.left)), i = Math.min(t.width, Math.max(1, e.left + e.width)), o = Math.min(t.height - 1, Math.max(0, e.top)), a = Math.min(t.height, Math.max(1, e.top + e.height));
                        n.width = e.width, n.height = e.height;
                        var s = i - r, h = a - o;
                        return w("Cropping canvas at:", "left:", e.left, "top:", e.top, "width:", s, "height:", h), w("Resulting crop with width", e.width, "and height", e.height, "with x", r, "and y", o), n.getContext("2d").drawImage(t, r, o, s, h, e.x, e.y, s, h), n;
                    }
                    e.exports = a;
                },
                {
                    "./clone": 2,
                    "./imageloader": 11,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./nodeparser": 15,
                    "./proxy": 16,
                    "./renderers/canvas": 20,
                    "./support": 22,
                    "./utils": 26
                }
            ],
            5: [
                function(t, e, n) {
                    var r = t("./log"), i = t("./utils").smallImage;
                    e.exports = function t(e) {
                        if (this.src = e, r("DummyImageContainer for", e), !this.promise || !this.image) {
                            r("Initiating DummyImageContainer"), t.prototype.image = new Image;
                            var n = this.image;
                            t.prototype.promise = new Promise(function(t, e) {
                                n.onload = t, n.onerror = e, n.src = i(), !0 === n.complete && t(n);
                            });
                        }
                    };
                },
                {
                    "./log": 13,
                    "./utils": 26
                }
            ],
            6: [
                function(t, e, n) {
                    var h = t("./utils").smallImage;
                    e.exports = function(t, e) {
                        var n, r, i = document.createElement("div"), o = document.createElement("img"), a = document.createElement("span"), s = "Hidden Text";
                        i.style.visibility = "hidden", i.style.fontFamily = t, i.style.fontSize = e, i.style.margin = 0, i.style.padding = 0, document.body.appendChild(i), o.src = h(), o.width = 1, o.height = 1, o.style.margin = 0, o.style.padding = 0, o.style.verticalAlign = "baseline", a.style.fontFamily = t, a.style.fontSize = e, a.style.margin = 0, a.style.padding = 0, a.appendChild(document.createTextNode(s)), i.appendChild(a), i.appendChild(o), n = o.offsetTop - a.offsetTop + 1, i.removeChild(a), i.appendChild(document.createTextNode(s)), i.style.lineHeight = "normal", o.style.verticalAlign = "super", r = o.offsetTop - i.offsetTop + 1, document.body.removeChild(i), this.baseline = n, this.lineWidth = 1, this.middle = r;
                    };
                },
                {
                    "./utils": 26
                }
            ],
            7: [
                function(t, e, n) {
                    var r = t("./font");
                    function i() {
                        this.data = {};
                    }
                    i.prototype.getMetrics = function(t, e) {
                        return void 0 === this.data[t + "-" + e] && (this.data[t + "-" + e] = new r(t, e)), this.data[t + "-" + e];
                    }, e.exports = i;
                },
                {
                    "./font": 6
                }
            ],
            8: [
                function(o, t, e) {
                    var a = o("./utils").getBounds, i = o("./proxy").loadUrlDocument;
                    function n(e, t, n) {
                        this.image = null, this.src = e;
                        var r = this, i = a(e);
                        this.promise = (t ? new Promise(function(t) {
                            "about:blank" === e.contentWindow.document.URL || null == e.contentWindow.document.documentElement ? e.contentWindow.onload = e.onload = function() {
                                t(e);
                            } : t(e);
                        }) : this.proxyLoad(n.proxy, i, n)).then(function(t) {
                            return o("./core")(t.contentWindow.document.documentElement, {
                                type: "view",
                                width: t.width,
                                height: t.height,
                                proxy: n.proxy,
                                javascriptEnabled: n.javascriptEnabled,
                                removeContainer: n.removeContainer,
                                allowTaint: n.allowTaint,
                                imageTimeout: n.imageTimeout / 2
                            });
                        }).then(function(t) {
                            return r.image = t;
                        });
                    }
                    n.prototype.proxyLoad = function(t, e, n) {
                        var r = this.src;
                        return i(r.src, t, r.ownerDocument, e.width, e.height, n);
                    }, t.exports = n;
                },
                {
                    "./core": 4,
                    "./proxy": 16,
                    "./utils": 26
                }
            ],
            9: [
                function(t, e, n) {
                    function r(t) {
                        this.src = t.value, this.colorStops = [], this.type = null, this.x0 = .5, this.y0 = .5, this.x1 = .5, this.y1 = .5, this.promise = Promise.resolve(!0);
                    }
                    r.TYPES = {
                        LINEAR: 1,
                        RADIAL: 2
                    }, r.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i, e.exports = r;
                },
                {}
            ],
            10: [
                function(t, e, n) {
                    e.exports = function(n, r) {
                        this.src = n, this.image = new Image;
                        var i = this;
                        this.tainted = null, this.promise = new Promise(function(t, e) {
                            i.image.onload = t, i.image.onerror = e, r && (i.image.crossOrigin = "anonymous"), i.image.src = n, !0 === i.image.complete && t(i.image);
                        });
                    };
                },
                {}
            ],
            11: [
                function(t, e, n) {
                    var o = t("./log"), r = t("./imagecontainer"), i = t("./dummyimagecontainer"), a = t("./proxyimagecontainer"), s = t("./framecontainer"), h = t("./svgcontainer"), c = t("./svgnodecontainer"), l = t("./lineargradientcontainer"), u = t("./webkitgradientcontainer"), f = t("./utils").bind;
                    function d(t, e) {
                        this.link = null, this.options = t, this.support = e, this.origin = this.getOrigin(window.location.href);
                    }
                    d.prototype.findImages = function(t) {
                        var e = [];
                        return t.reduce(function(t, e) {
                            switch(e.node.nodeName){
                                case "IMG":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node.src
                                            ],
                                            method: "url"
                                        }
                                    ]);
                                case "svg":
                                case "IFRAME":
                                    return t.concat([
                                        {
                                            args: [
                                                e.node
                                            ],
                                            method: e.node.nodeName
                                        }
                                    ]);
                            }
                            return t;
                        }, []).forEach(this.addImage(e, this.loadImage), this), e;
                    }, d.prototype.findBackgroundImage = function(t, e) {
                        return e.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(t, this.loadImage), this), t;
                    }, d.prototype.addImage = function(n, r) {
                        return function(e) {
                            e.args.forEach(function(t) {
                                this.imageExists(n, t) || (n.splice(0, 0, r.call(this, e)), o("Added image #" + n.length, "string" == typeof t ? t.substring(0, 100) : t));
                            }, this);
                        };
                    }, d.prototype.hasImageBackground = function(t) {
                        return "none" !== t.method;
                    }, d.prototype.loadImage = function(t) {
                        if ("url" === t.method) {
                            var e = t.args[0];
                            return !this.isSVG(e) || this.support.svg || this.options.allowTaint ? e.match(/data:image\/.*;base64,/i) ? new r(e.replace(/url\(['"]{0,}|['"]{0,}\)$/gi, ""), !1) : this.isSameOrigin(e) || !0 === this.options.allowTaint || this.isSVG(e) ? new r(e, !1) : this.support.cors && !this.options.allowTaint && this.options.useCORS ? new r(e, !0) : this.options.proxy ? new a(e, this.options.proxy) : new i(e) : new h(e);
                        }
                        return "linear-gradient" === t.method ? new l(t) : "gradient" === t.method ? new u(t) : "svg" === t.method ? new c(t.args[0], this.support.svg) : "IFRAME" === t.method ? new s(t.args[0], this.isSameOrigin(t.args[0].src), this.options) : new i(t);
                    }, d.prototype.isSVG = function(t) {
                        return "svg" === t.substring(t.length - 3).toLowerCase() || h.prototype.isInline(t);
                    }, d.prototype.imageExists = function(t, e) {
                        return t.some(function(t) {
                            return t.src === e;
                        });
                    }, d.prototype.isSameOrigin = function(t) {
                        return this.getOrigin(t) === this.origin;
                    }, d.prototype.getOrigin = function(t) {
                        var e = this.link || (this.link = document.createElement("a"));
                        return e.href = t, e.href = e.href, e.protocol + e.hostname + e.port;
                    }, d.prototype.getPromise = function(e) {
                        return this.timeout(e, this.options.imageTimeout).catch(function() {
                            return new i(e.src).promise.then(function(t) {
                                e.image = t;
                            });
                        });
                    }, d.prototype.get = function(e) {
                        var n = null;
                        return this.images.some(function(t) {
                            return (n = t).src === e;
                        }) ? n : null;
                    }, d.prototype.fetch = function(t) {
                        return this.images = t.reduce(f(this.findBackgroundImage, this), this.findImages(t)), this.images.forEach(function(e, n) {
                            e.promise.then(function() {
                                o("Succesfully loaded image #" + (n + 1), e);
                            }, function(t) {
                                o("Failed loading image #" + (n + 1), e, t);
                            });
                        }), this.ready = Promise.all(this.images.map(this.getPromise, this)), o("Finished searching images"), this;
                    }, d.prototype.timeout = function(n, r) {
                        var i, t = Promise.race([
                            n.promise,
                            new Promise(function(t, e) {
                                i = setTimeout(function() {
                                    o("Timed out loading image", n), e(n);
                                }, r);
                            })
                        ]).then(function(t) {
                            return clearTimeout(i), t;
                        });
                        return t.catch(function() {
                            clearTimeout(i);
                        }), t;
                    }, e.exports = d;
                },
                {
                    "./dummyimagecontainer": 5,
                    "./framecontainer": 8,
                    "./imagecontainer": 10,
                    "./lineargradientcontainer": 12,
                    "./log": 13,
                    "./proxyimagecontainer": 17,
                    "./svgcontainer": 23,
                    "./svgnodecontainer": 24,
                    "./utils": 26,
                    "./webkitgradientcontainer": 27
                }
            ],
            12: [
                function(t, e, n) {
                    var i = t("./gradientcontainer"), o = t("./color");
                    function r(t) {
                        i.apply(this, arguments), this.type = i.TYPES.LINEAR;
                        var e = r.REGEXP_DIRECTION.test(t.args[0]) || !i.REGEXP_COLORSTOP.test(t.args[0]);
                        e ? t.args[0].split(/\s+/).reverse().forEach(function(t, e) {
                            switch(t){
                                case "left":
                                    this.x0 = 0, this.x1 = 1;
                                    break;
                                case "top":
                                    this.y0 = 0, this.y1 = 1;
                                    break;
                                case "right":
                                    this.x0 = 1, this.x1 = 0;
                                    break;
                                case "bottom":
                                    this.y0 = 1, this.y1 = 0;
                                    break;
                                case "to":
                                    var n = this.y0, r = this.x0;
                                    this.y0 = this.y1, this.x0 = this.x1, this.x1 = r, this.y1 = n;
                                    break;
                                case "center":
                                    break;
                                default:
                                    var i = .01 * parseFloat(t, 10);
                                    if (isNaN(i)) break;
                                    0 === e ? (this.y0 = i, this.y1 = 1 - this.y0) : (this.x0 = i, this.x1 = 1 - this.x0);
                            }
                        }, this) : (this.y0 = 0, this.y1 = 1), this.colorStops = t.args.slice(e ? 1 : 0).map(function(t) {
                            var e = t.match(i.REGEXP_COLORSTOP), n = +e[2], r = 0 === n ? "%" : e[3];
                            return {
                                color: new o(e[1]),
                                stop: "%" === r ? n / 100 : null
                            };
                        }), null === this.colorStops[0].stop && (this.colorStops[0].stop = 0), null === this.colorStops[this.colorStops.length - 1].stop && (this.colorStops[this.colorStops.length - 1].stop = 1), this.colorStops.forEach(function(n, r) {
                            null === n.stop && this.colorStops.slice(r).some(function(t, e) {
                                return null !== t.stop && (n.stop = (t.stop - this.colorStops[r - 1].stop) / (e + 1) + this.colorStops[r - 1].stop, !0);
                            }, this);
                        }, this);
                    }
                    r.prototype = Object.create(i.prototype), r.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i, e.exports = r;
                },
                {
                    "./color": 3,
                    "./gradientcontainer": 9
                }
            ],
            13: [
                function(t, e, n) {
                    var r = function() {
                        r.options.logging && window.console && window.console.log && Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [
                            Date.now() - r.options.start + "ms",
                            "html2canvas:"
                        ].concat([].slice.call(arguments, 0)));
                    };
                    r.options = {
                        logging: !1
                    }, e.exports = r;
                },
                {}
            ],
            14: [
                function(t, e, n) {
                    var o = t("./color"), r = t("./utils"), i = r.getBounds, a = r.parseBackgrounds, s = r.offsetBounds;
                    function h(t, e) {
                        this.node = t, this.parent = e, this.stack = null, this.bounds = null, this.borders = null, this.clip = [], this.backgroundClip = [], this.offsetBounds = null, this.visible = null, this.computedStyles = null, this.colors = {}, this.styles = {}, this.backgroundImages = null, this.transformData = null, this.transformMatrix = null, this.isPseudoElement = !1, this.opacity = null;
                    }
                    function c(t) {
                        return -1 !== t.toString().indexOf("%");
                    }
                    function l(t) {
                        return t.replace("px", "");
                    }
                    function u(t) {
                        return parseFloat(t);
                    }
                    h.prototype.cloneTo = function(t) {
                        t.visible = this.visible, t.borders = this.borders, t.bounds = this.bounds, t.clip = this.clip, t.backgroundClip = this.backgroundClip, t.computedStyles = this.computedStyles, t.styles = this.styles, t.backgroundImages = this.backgroundImages, t.opacity = this.opacity;
                    }, h.prototype.getOpacity = function() {
                        return null === this.opacity ? this.opacity = this.cssFloat("opacity") : this.opacity;
                    }, h.prototype.assignStack = function(t) {
                        (this.stack = t).children.push(this);
                    }, h.prototype.isElementVisible = function() {
                        return this.node.nodeType === Node.TEXT_NODE ? this.parent.visible : "none" !== this.css("display") && "hidden" !== this.css("visibility") && !this.node.hasAttribute("data-html2canvas-ignore") && ("INPUT" !== this.node.nodeName || "hidden" !== this.node.getAttribute("type"));
                    }, h.prototype.css = function(t) {
                        return this.computedStyles || (this.computedStyles = this.isPseudoElement ? this.parent.computedStyle(this.before ? ":before" : ":after") : this.computedStyle(null)), this.styles[t] || (this.styles[t] = this.computedStyles[t]);
                    }, h.prototype.prefixedCss = function(e) {
                        var n = this.css(e);
                        return void 0 === n && [
                            "webkit",
                            "moz",
                            "ms",
                            "o"
                        ].some(function(t) {
                            return void 0 !== (n = this.css(t + e.substr(0, 1).toUpperCase() + e.substr(1)));
                        }, this), void 0 === n ? null : n;
                    }, h.prototype.computedStyle = function(t) {
                        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, t);
                    }, h.prototype.cssInt = function(t) {
                        var e = parseInt(this.css(t), 10);
                        return isNaN(e) ? 0 : e;
                    }, h.prototype.color = function(t) {
                        return this.colors[t] || (this.colors[t] = new o(this.css(t)));
                    }, h.prototype.cssFloat = function(t) {
                        var e = parseFloat(this.css(t));
                        return isNaN(e) ? 0 : e;
                    }, h.prototype.fontWeight = function() {
                        var t = this.css("fontWeight");
                        switch(parseInt(t, 10)){
                            case 401:
                                t = "bold";
                                break;
                            case 400:
                                t = "normal";
                        }
                        return t;
                    }, h.prototype.parseClip = function() {
                        var t = this.css("clip").match(this.CLIP);
                        return t ? {
                            top: parseInt(t[1], 10),
                            right: parseInt(t[2], 10),
                            bottom: parseInt(t[3], 10),
                            left: parseInt(t[4], 10)
                        } : null;
                    }, h.prototype.parseBackgroundImages = function() {
                        return this.backgroundImages || (this.backgroundImages = a(this.css("backgroundImage")));
                    }, h.prototype.cssList = function(t, e) {
                        var n = (this.css(t) || "").split(",");
                        return 1 === (n = (n = n[e || 0] || n[0] || "auto").trim().split(" ")).length && (n = [
                            n[0],
                            c(n[0]) ? "auto" : n[0]
                        ]), n;
                    }, h.prototype.parseBackgroundSize = function(t, e, n) {
                        var r, i, o = this.cssList("backgroundSize", n);
                        if (c(o[0])) r = t.width * parseFloat(o[0]) / 100;
                        else {
                            if (/contain|cover/.test(o[0])) {
                                var a = t.width / t.height, s = e.width / e.height;
                                return a < s ^ "contain" === o[0] ? {
                                    width: t.height * s,
                                    height: t.height
                                } : {
                                    width: t.width,
                                    height: t.width / s
                                };
                            }
                            r = parseInt(o[0], 10);
                        }
                        return i = "auto" === o[0] && "auto" === o[1] ? e.height : "auto" === o[1] ? r / e.width * e.height : c(o[1]) ? t.height * parseFloat(o[1]) / 100 : parseInt(o[1], 10), "auto" === o[0] && (r = i / e.height * e.width), {
                            width: r,
                            height: i
                        };
                    }, h.prototype.parseBackgroundPosition = function(t, e, n, r) {
                        var i, o, a = this.cssList("backgroundPosition", n);
                        return i = c(a[0]) ? (t.width - (r || e).width) * (parseFloat(a[0]) / 100) : parseInt(a[0], 10), o = "auto" === a[1] ? i / e.width * e.height : c(a[1]) ? (t.height - (r || e).height) * parseFloat(a[1]) / 100 : parseInt(a[1], 10), "auto" === a[0] && (i = o / e.height * e.width), {
                            left: i,
                            top: o
                        };
                    }, h.prototype.parseBackgroundRepeat = function(t) {
                        return this.cssList("backgroundRepeat", t)[0];
                    }, h.prototype.parseTextShadows = function() {
                        var t = this.css("textShadow"), e = [];
                        if (t && "none" !== t) for(var n = t.match(this.TEXT_SHADOW_PROPERTY), r = 0; n && r < n.length; r++){
                            var i = n[r].match(this.TEXT_SHADOW_VALUES);
                            e.push({
                                color: new o(i[0]),
                                offsetX: i[1] ? parseFloat(i[1].replace("px", "")) : 0,
                                offsetY: i[2] ? parseFloat(i[2].replace("px", "")) : 0,
                                blur: i[3] ? i[3].replace("px", "") : 0
                            });
                        }
                        return e;
                    }, h.prototype.parseTransform = function() {
                        if (!this.transformData) {
                            if (this.hasTransform()) {
                                var t = this.parseBounds(), e = this.prefixedCss("transformOrigin").split(" ").map(l).map(u);
                                e[0] += t.left, e[1] += t.top, this.transformData = {
                                    origin: e,
                                    matrix: this.parseTransformMatrix()
                                };
                            } else this.transformData = {
                                origin: [
                                    0,
                                    0
                                ],
                                matrix: [
                                    1,
                                    0,
                                    0,
                                    1,
                                    0,
                                    0
                                ]
                            };
                        }
                        return this.transformData;
                    }, h.prototype.parseTransformMatrix = function() {
                        if (!this.transformMatrix) {
                            var t = this.prefixedCss("transform"), e = t ? function(t) {
                                if (t && "matrix" === t[1]) return t[2].split(",").map(function(t) {
                                    return parseFloat(t.trim());
                                });
                                if (t && "matrix3d" === t[1]) {
                                    var e = t[2].split(",").map(function(t) {
                                        return parseFloat(t.trim());
                                    });
                                    return [
                                        e[0],
                                        e[1],
                                        e[4],
                                        e[5],
                                        e[12],
                                        e[13]
                                    ];
                                }
                            }(t.match(this.MATRIX_PROPERTY)) : null;
                            this.transformMatrix = e || [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ];
                        }
                        return this.transformMatrix;
                    }, h.prototype.parseBounds = function() {
                        return this.bounds || (this.bounds = this.hasTransform() ? s(this.node) : i(this.node));
                    }, h.prototype.hasTransform = function() {
                        return "1,0,0,1,0,0" !== this.parseTransformMatrix().join(",") || this.parent && this.parent.hasTransform();
                    }, h.prototype.getValue = function() {
                        var t, e, n = this.node.value || "";
                        return "SELECT" === this.node.tagName ? (t = this.node, n = (e = t.options[t.selectedIndex || 0]) && e.text || "") : "password" === this.node.type && (n = Array(n.length + 1).join("\u2022")), 0 === n.length ? this.node.placeholder || "" : n;
                    }, h.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/, h.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g, h.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g, h.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/, e.exports = h;
                },
                {
                    "./color": 3,
                    "./utils": 26
                }
            ],
            15: [
                function(t, e, n) {
                    var s = t("./log"), h = t("punycode"), c = t("./nodecontainer"), f = t("./textcontainer"), d = t("./pseudoelementcontainer"), l = t("./fontmetrics"), u = t("./color"), p = t("./stackingcontext"), r = t("./utils"), g = r.bind, a = r.getBounds, m = r.parseBackgrounds, w = r.offsetBounds;
                    function i(t, e, n, r, i) {
                        s("Starting NodeParser"), this.renderer = e, this.options = i, this.range = null, this.support = n, this.renderQueue = [], this.stack = new p(!0, 1, t.ownerDocument, null);
                        var o = new c(t, null);
                        if (i.background && e.rectangle(0, 0, e.width, e.height, new u(i.background)), t === t.ownerDocument.documentElement) {
                            var a = new c(o.color("backgroundColor").isTransparent() ? t.ownerDocument.body : t.ownerDocument.documentElement, null);
                            e.rectangle(0, 0, e.width, e.height, a.color("backgroundColor"));
                        }
                        o.visibile = o.isElementVisible(), this.createPseudoHideStyles(t.ownerDocument), this.disableAnimations(t.ownerDocument), this.nodes = L([
                            o
                        ].concat(this.getChildren(o)).filter(function(t) {
                            return t.visible = t.isElementVisible();
                        }).map(this.getPseudoElements, this)), this.fontMetrics = new l, s("Fetched nodes, total:", this.nodes.length), s("Calculate overflow clips"), this.calculateOverflowClips(), s("Start fetching images"), this.images = r.fetch(this.nodes.filter(j)), this.ready = this.images.ready.then(g(function() {
                            return s("Images loaded, starting parsing"), s("Creating stacking contexts"), this.createStackingContexts(), s("Sorting stacking contexts"), this.sortStackingContexts(this.stack), this.parse(this.stack), s("Render queue created with " + this.renderQueue.length + " items"), new Promise(g(function(t) {
                                i.async ? "function" == typeof i.async ? i.async.call(this, this.renderQueue, t) : 0 < this.renderQueue.length ? (this.renderIndex = 0, this.asyncRenderer(this.renderQueue, t)) : t() : (this.renderQueue.forEach(this.paint, this), t());
                            }, this));
                        }, this));
                    }
                    function o(t) {
                        return t.parent && t.parent.clip.length;
                    }
                    function y() {}
                    i.prototype.calculateOverflowClips = function() {
                        this.nodes.forEach(function(t) {
                            if (j(t)) {
                                D(t) && t.appendToDOM(), t.borders = this.parseBorders(t);
                                var e = "hidden" === t.css("overflow") ? [
                                    t.borders.clip
                                ] : [], n = t.parseClip();
                                n && -1 !== [
                                    "absolute",
                                    "fixed"
                                ].indexOf(t.css("position")) && e.push([
                                    [
                                        "rect",
                                        t.bounds.left + n.left,
                                        t.bounds.top + n.top,
                                        n.right - n.left,
                                        n.bottom - n.top
                                    ]
                                ]), t.clip = o(t) ? t.parent.clip.concat(e) : e, t.backgroundClip = "hidden" !== t.css("overflow") ? t.clip.concat([
                                    t.borders.clip
                                ]) : t.clip, D(t) && t.cleanDOM();
                            } else M(t) && (t.clip = o(t) ? t.parent.clip : []);
                            D(t) || (t.bounds = null);
                        }, this);
                    }, i.prototype.asyncRenderer = function(t, e, n) {
                        n = n || Date.now(), this.paint(t[this.renderIndex++]), t.length === this.renderIndex ? e() : n + 20 > Date.now() ? this.asyncRenderer(t, e, n) : setTimeout(g(function() {
                            this.asyncRenderer(t, e);
                        }, this), 0);
                    }, i.prototype.createPseudoHideStyles = function(t) {
                        this.createStyles(t, "." + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }.' + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');
                    }, i.prototype.disableAnimations = function(t) {
                        this.createStyles(t, "* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; -webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}");
                    }, i.prototype.createStyles = function(t, e) {
                        var n = t.createElement("style");
                        n.innerHTML = e, t.body.appendChild(n);
                    }, i.prototype.getPseudoElements = function(t) {
                        var e = [
                            [
                                t
                            ]
                        ];
                        if (t.node.nodeType === Node.ELEMENT_NODE) {
                            var n = this.getPseudoElement(t, ":before"), r = this.getPseudoElement(t, ":after");
                            n && e.push(n), r && e.push(r);
                        }
                        return L(e);
                    }, i.prototype.getPseudoElement = function(t, e) {
                        var n = t.computedStyle(e);
                        if (!n || !n.content || "none" === n.content || "-moz-alt-content" === n.content || "none" === n.display) return null;
                        for(var r, i, o = (r = n.content, (i = r.substr(0, 1)) === r.substr(r.length - 1) && i.match(/'|"/) ? r.substr(1, r.length - 2) : r), a = "url" === o.substr(0, 3), s = document.createElement(a ? "img" : "html2canvaspseudoelement"), h = new d(s, t, e), c = n.length - 1; 0 <= c; c--){
                            var l = n.item(c).replace(/(\-[a-z])/g, function(t) {
                                return t.toUpperCase().replace("-", "");
                            });
                            s.style[l] = n[l];
                        }
                        if (s.className = d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + d.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER, a) return s.src = m(o)[0].args[0], [
                            h
                        ];
                        var u = document.createTextNode(o);
                        return s.appendChild(u), [
                            h,
                            new f(u, h)
                        ];
                    }, i.prototype.getChildren = function(n) {
                        return L([].filter.call(n.node.childNodes, q).map(function(t) {
                            var e = [
                                t.nodeType === Node.TEXT_NODE ? new f(t, n) : new c(t, n)
                            ].filter(z);
                            return t.nodeType === Node.ELEMENT_NODE && e.length && "TEXTAREA" !== t.tagName ? e[0].isElementVisible() ? e.concat(this.getChildren(e[0])) : [] : e;
                        }, this));
                    }, i.prototype.newStackingContext = function(t, e) {
                        var n = new p(e, t.getOpacity(), t.node, t.parent);
                        t.cloneTo(n), (e ? n.getParentStack(this) : n.parent.stack).contexts.push(n), t.stack = n;
                    }, i.prototype.createStackingContexts = function() {
                        this.nodes.forEach(function(t) {
                            var e, n;
                            j(t) && (this.isRootElement(t) || t.getOpacity() < 1 || (n = (e = t).css("position"), "auto" !== (-1 !== [
                                "absolute",
                                "relative",
                                "fixed"
                            ].indexOf(n) ? e.css("zIndex") : "auto")) || this.isBodyWithTransparentRoot(t) || t.hasTransform()) ? this.newStackingContext(t, !0) : j(t) && (O(t) && T(t) || -1 !== [
                                "inline-block",
                                "inline-table"
                            ].indexOf(t.css("display")) || B(t)) ? this.newStackingContext(t, !1) : t.assignStack(t.parent.stack);
                        }, this);
                    }, i.prototype.isBodyWithTransparentRoot = function(t) {
                        return "BODY" === t.node.nodeName && t.parent.color("backgroundColor").isTransparent();
                    }, i.prototype.isRootElement = function(t) {
                        return null === t.parent;
                    }, i.prototype.sortStackingContexts = function(t) {
                        var n;
                        t.contexts.sort((n = t.contexts.slice(0), function(t, e) {
                            return t.cssInt("zIndex") + n.indexOf(t) / n.length - (e.cssInt("zIndex") + n.indexOf(e) / n.length);
                        })), t.contexts.forEach(this.sortStackingContexts, this);
                    }, i.prototype.parseTextBounds = function(a) {
                        return function(t, e, n) {
                            if ("none" !== a.parent.css("textDecoration").substr(0, 4) || 0 !== t.trim().length) {
                                if (this.support.rangeBounds && !a.parent.hasTransform()) {
                                    var r = n.slice(0, e).join("").length;
                                    return this.getRangeBounds(a.node, r, t.length);
                                }
                                if (a.node && "string" == typeof a.node.data) {
                                    var i = a.node.splitText(t.length), o = this.getWrapperBounds(a.node, a.parent.hasTransform());
                                    return a.node = i, o;
                                }
                            } else this.support.rangeBounds && !a.parent.hasTransform() || (a.node = a.node.splitText(t.length));
                            return {};
                        };
                    }, i.prototype.getWrapperBounds = function(t, e) {
                        var n = t.ownerDocument.createElement("html2canvaswrapper"), r = t.parentNode, i = t.cloneNode(!0);
                        n.appendChild(t.cloneNode(!0)), r.replaceChild(n, t);
                        var o = e ? w(n) : a(n);
                        return r.replaceChild(i, n), o;
                    }, i.prototype.getRangeBounds = function(t, e, n) {
                        var r = this.range || (this.range = t.ownerDocument.createRange());
                        return r.setStart(t, e), r.setEnd(t, e + n), r.getBoundingClientRect();
                    }, i.prototype.parse = function(t) {
                        var e = t.contexts.filter(I), n = t.children.filter(j), r = n.filter(R(B)), i = r.filter(R(O)).filter(R(F)), o = n.filter(R(O)).filter(B), a = r.filter(R(O)).filter(F), s = t.contexts.concat(r.filter(O)).filter(T), h = t.children.filter(M).filter(E), c = t.contexts.filter(C);
                        e.concat(i).concat(o).concat(a).concat(s).concat(h).concat(c).forEach(function(t) {
                            this.renderQueue.push(t), P(t) && (this.parse(t), this.renderQueue.push(new y));
                        }, this);
                    }, i.prototype.paint = function(t) {
                        try {
                            t instanceof y ? this.renderer.ctx.restore() : M(t) ? (D(t.parent) && t.parent.appendToDOM(), this.paintText(t), D(t.parent) && t.parent.cleanDOM()) : this.paintNode(t);
                        } catch (t) {
                            if (s(t), this.options.strict) throw t;
                        }
                    }, i.prototype.paintNode = function(t) {
                        P(t) && (this.renderer.setOpacity(t.opacity), this.renderer.ctx.save(), t.hasTransform() && this.renderer.setTransform(t.parseTransform())), "INPUT" === t.node.nodeName && "checkbox" === t.node.type ? this.paintCheckbox(t) : "INPUT" === t.node.nodeName && "radio" === t.node.type ? this.paintRadio(t) : this.paintElement(t);
                    }, i.prototype.paintElement = function(n) {
                        var r = n.parseBounds();
                        this.renderer.clip(n.backgroundClip, function() {
                            this.renderer.renderBackground(n, r, n.borders.borders.map(N));
                        }, this), this.renderer.clip(n.clip, function() {
                            this.renderer.renderBorders(n.borders.borders);
                        }, this), this.renderer.clip(n.backgroundClip, function() {
                            switch(n.node.nodeName){
                                case "svg":
                                case "IFRAME":
                                    var t = this.images.get(n.node);
                                    t ? this.renderer.renderImage(n, r, n.borders, t) : s("Error loading <" + n.node.nodeName + ">", n.node);
                                    break;
                                case "IMG":
                                    var e = this.images.get(n.node.src);
                                    e ? this.renderer.renderImage(n, r, n.borders, e) : s("Error loading <img>", n.node.src);
                                    break;
                                case "CANVAS":
                                    this.renderer.renderImage(n, r, n.borders, {
                                        image: n.node
                                    });
                                    break;
                                case "SELECT":
                                case "INPUT":
                                case "TEXTAREA":
                                    this.paintFormValue(n);
                            }
                        }, this);
                    }, i.prototype.paintCheckbox = function(t) {
                        var e = t.parseBounds(), n = Math.min(e.width, e.height), r = {
                            width: n - 1,
                            height: n - 1,
                            top: e.top,
                            left: e.left
                        }, i = [
                            3,
                            3
                        ], o = [
                            i,
                            i,
                            i,
                            i
                        ], a = [
                            1,
                            1,
                            1,
                            1
                        ].map(function(t) {
                            return {
                                color: new u("#A5A5A5"),
                                width: t
                            };
                        }), s = S(r, o, a);
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.rectangle(r.left + 1, r.top + 1, r.width - 2, r.height - 2, new u("#DEDEDE")), this.renderer.renderBorders(b(a, r, s, o)), t.node.checked && (this.renderer.font(new u("#424242"), "normal", "normal", "bold", n - 3 + "px", "arial"), this.renderer.text("\u2714", r.left + n / 6, r.top + n - 1));
                        }, this);
                    }, i.prototype.paintRadio = function(t) {
                        var e = t.parseBounds(), n = Math.min(e.width, e.height) - 2;
                        this.renderer.clip(t.backgroundClip, function() {
                            this.renderer.circleStroke(e.left + 1, e.top + 1, n, new u("#DEDEDE"), 1, new u("#A5A5A5")), t.node.checked && this.renderer.circle(Math.ceil(e.left + n / 4) + 1, Math.ceil(e.top + n / 4) + 1, Math.floor(n / 2), new u("#424242"));
                        }, this);
                    }, i.prototype.paintFormValue = function(e) {
                        var t = e.getValue();
                        if (0 < t.length) {
                            var n = e.node.ownerDocument, r = n.createElement("html2canvaswrapper");
                            [
                                "lineHeight",
                                "textAlign",
                                "fontFamily",
                                "fontWeight",
                                "fontSize",
                                "color",
                                "paddingLeft",
                                "paddingTop",
                                "paddingRight",
                                "paddingBottom",
                                "width",
                                "height",
                                "borderLeftStyle",
                                "borderTopStyle",
                                "borderLeftWidth",
                                "borderTopWidth",
                                "boxSizing",
                                "whiteSpace",
                                "wordWrap"
                            ].forEach(function(t) {
                                try {
                                    r.style[t] = e.css(t);
                                } catch (t) {
                                    s("html2canvas: Parse: Exception caught in renderFormValue: " + t.message);
                                }
                            });
                            var i = e.parseBounds();
                            r.style.position = "fixed", r.style.left = i.left + "px", r.style.top = i.top + "px", r.textContent = t, n.body.appendChild(r), this.paintText(new f(r.firstChild, e)), n.body.removeChild(r);
                        }
                    }, i.prototype.paintText = function(n) {
                        n.applyTextTransform();
                        var t, e = h.ucs2.decode(n.node.data), r = this.options.letterRendering && !/^(normal|none|0px)$/.test(n.parent.css("letterSpacing")) || (t = n.node.data, /[^\u0000-\u00ff]/.test(t)) ? e.map(function(t) {
                            return h.ucs2.encode([
                                t
                            ]);
                        }) : function(t) {
                            var e, n = [], r = 0, i = !1;
                            for(; t.length;)o = t[r], -1 !== [
                                32,
                                13,
                                10,
                                9,
                                45
                            ].indexOf(o) === i ? ((e = t.splice(0, r)).length && n.push(h.ucs2.encode(e)), i = !i, r = 0) : r++, r >= t.length && (e = t.splice(0, r)).length && n.push(h.ucs2.encode(e));
                            var o;
                            return n;
                        }(e), i = n.parent.fontWeight(), o = n.parent.css("fontSize"), a = n.parent.css("fontFamily"), s = n.parent.parseTextShadows();
                        this.renderer.font(n.parent.color("color"), n.parent.css("fontStyle"), n.parent.css("fontVariant"), i, o, a), s.length ? this.renderer.fontShadow(s[0].color, s[0].offsetX, s[0].offsetY, s[0].blur) : this.renderer.clearShadow(), this.renderer.clip(n.parent.clip, function() {
                            r.map(this.parseTextBounds(n), this).forEach(function(t, e) {
                                t && !1 === /^\s*$/.test(r[e]) && (this.renderer.text(r[e], t.left, t.bottom), this.renderTextDecoration(n.parent, t, this.fontMetrics.getMetrics(a, o)));
                            }, this);
                        }, this);
                    }, i.prototype.renderTextDecoration = function(t, e, n) {
                        switch(t.css("textDecoration").split(" ")[0]){
                            case "underline":
                                this.renderer.rectangle(e.left, Math.round(e.top + n.baseline + n.lineWidth), e.width, 1, t.color("color"));
                                break;
                            case "overline":
                                this.renderer.rectangle(e.left, Math.round(e.top), e.width, 1, t.color("color"));
                                break;
                            case "line-through":
                                this.renderer.rectangle(e.left, Math.ceil(e.top + n.middle + n.lineWidth), e.width, 1, t.color("color"));
                        }
                    };
                    var v = {
                        inset: [
                            [
                                "darken",
                                .6
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .1
                            ],
                            [
                                "darken",
                                .6
                            ]
                        ]
                    };
                    function b(a, s, h, c) {
                        return a.map(function(t, e) {
                            if (0 < t.width) {
                                var n = s.left, r = s.top, i = s.width, o = s.height - a[2].width;
                                switch(e){
                                    case 0:
                                        o = a[0].width, t.args = _({
                                            c1: [
                                                n,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r
                                            ],
                                            c3: [
                                                n + i - a[1].width,
                                                r + o
                                            ],
                                            c4: [
                                                n + a[3].width,
                                                r + o
                                            ]
                                        }, c[0], c[1], h.topLeftOuter, h.topLeftInner, h.topRightOuter, h.topRightInner);
                                        break;
                                    case 1:
                                        n = s.left + s.width - a[1].width, i = a[1].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r
                                            ],
                                            c2: [
                                                n + i,
                                                r + o + a[2].width
                                            ],
                                            c3: [
                                                n,
                                                r + o
                                            ],
                                            c4: [
                                                n,
                                                r + a[0].width
                                            ]
                                        }, c[1], c[2], h.topRightOuter, h.topRightInner, h.bottomRightOuter, h.bottomRightInner);
                                        break;
                                    case 2:
                                        r = r + s.height - a[2].width, o = a[2].width, t.args = _({
                                            c1: [
                                                n + i,
                                                r + o
                                            ],
                                            c2: [
                                                n,
                                                r + o
                                            ],
                                            c3: [
                                                n + a[3].width,
                                                r
                                            ],
                                            c4: [
                                                n + i - a[3].width,
                                                r
                                            ]
                                        }, c[2], c[3], h.bottomRightOuter, h.bottomRightInner, h.bottomLeftOuter, h.bottomLeftInner);
                                        break;
                                    case 3:
                                        i = a[3].width, t.args = _({
                                            c1: [
                                                n,
                                                r + o + a[2].width
                                            ],
                                            c2: [
                                                n,
                                                r
                                            ],
                                            c3: [
                                                n + i,
                                                r + a[0].width
                                            ],
                                            c4: [
                                                n + i,
                                                r + o
                                            ]
                                        }, c[3], c[0], h.bottomLeftOuter, h.bottomLeftInner, h.topLeftOuter, h.topLeftInner);
                                }
                            }
                            return t;
                        });
                    }
                    function x(t, e, n, r) {
                        var i = (Math.sqrt(2) - 1) / 3 * 4, o = n * i, a = r * i, s = t + n, h = e + r;
                        return {
                            topLeft: k({
                                x: t,
                                y: h
                            }, {
                                x: t,
                                y: h - a
                            }, {
                                x: s - o,
                                y: e
                            }, {
                                x: s,
                                y: e
                            }),
                            topRight: k({
                                x: t,
                                y: e
                            }, {
                                x: t + o,
                                y: e
                            }, {
                                x: s,
                                y: h - a
                            }, {
                                x: s,
                                y: h
                            }),
                            bottomRight: k({
                                x: s,
                                y: e
                            }, {
                                x: s,
                                y: e + a
                            }, {
                                x: t + o,
                                y: h
                            }, {
                                x: t,
                                y: h
                            }),
                            bottomLeft: k({
                                x: s,
                                y: h
                            }, {
                                x: s - o,
                                y: h
                            }, {
                                x: t,
                                y: e + a
                            }, {
                                x: t,
                                y: e
                            })
                        };
                    }
                    function S(t, e, n) {
                        var r = t.left, i = t.top, o = t.width, a = t.height, s = e[0][0] < o / 2 ? e[0][0] : o / 2, h = e[0][1] < a / 2 ? e[0][1] : a / 2, c = e[1][0] < o / 2 ? e[1][0] : o / 2, l = e[1][1] < a / 2 ? e[1][1] : a / 2, u = e[2][0] < o / 2 ? e[2][0] : o / 2, f = e[2][1] < a / 2 ? e[2][1] : a / 2, d = e[3][0] < o / 2 ? e[3][0] : o / 2, p = e[3][1] < a / 2 ? e[3][1] : a / 2, g = o - c, m = a - f, w = o - u, y = a - p;
                        return {
                            topLeftOuter: x(r, i, s, h).topLeft.subdivide(.5),
                            topLeftInner: x(r + n[3].width, i + n[0].width, Math.max(0, s - n[3].width), Math.max(0, h - n[0].width)).topLeft.subdivide(.5),
                            topRightOuter: x(r + g, i, c, l).topRight.subdivide(.5),
                            topRightInner: x(r + Math.min(g, o + n[3].width), i + n[0].width, g > o + n[3].width ? 0 : c - n[3].width, l - n[0].width).topRight.subdivide(.5),
                            bottomRightOuter: x(r + w, i + m, u, f).bottomRight.subdivide(.5),
                            bottomRightInner: x(r + Math.min(w, o - n[3].width), i + Math.min(m, a + n[0].width), Math.max(0, u - n[1].width), f - n[2].width).bottomRight.subdivide(.5),
                            bottomLeftOuter: x(r, i + y, d, p).bottomLeft.subdivide(.5),
                            bottomLeftInner: x(r + n[3].width, i + y, Math.max(0, d - n[3].width), p - n[2].width).bottomLeft.subdivide(.5)
                        };
                    }
                    function k(s, h, c, l) {
                        var u = function(t, e, n) {
                            return {
                                x: t.x + (e.x - t.x) * n,
                                y: t.y + (e.y - t.y) * n
                            };
                        };
                        return {
                            start: s,
                            startControl: h,
                            endControl: c,
                            end: l,
                            subdivide: function(t) {
                                var e = u(s, h, t), n = u(h, c, t), r = u(c, l, t), i = u(e, n, t), o = u(n, r, t), a = u(i, o, t);
                                return [
                                    k(s, e, i, a),
                                    k(a, o, r, l)
                                ];
                            },
                            curveTo: function(t) {
                                t.push([
                                    "bezierCurve",
                                    h.x,
                                    h.y,
                                    c.x,
                                    c.y,
                                    l.x,
                                    l.y
                                ]);
                            },
                            curveToReversed: function(t) {
                                t.push([
                                    "bezierCurve",
                                    c.x,
                                    c.y,
                                    h.x,
                                    h.y,
                                    s.x,
                                    s.y
                                ]);
                            }
                        };
                    }
                    function _(t, e, n, r, i, o, a) {
                        var s = [];
                        return 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            r[1].start.x,
                            r[1].start.y
                        ]), r[1].curveTo(s)) : s.push([
                            "line",
                            t.c1[0],
                            t.c1[1]
                        ]), 0 < n[0] || 0 < n[1] ? (s.push([
                            "line",
                            o[0].start.x,
                            o[0].start.y
                        ]), o[0].curveTo(s), s.push([
                            "line",
                            a[0].end.x,
                            a[0].end.y
                        ]), a[0].curveToReversed(s)) : (s.push([
                            "line",
                            t.c2[0],
                            t.c2[1]
                        ]), s.push([
                            "line",
                            t.c3[0],
                            t.c3[1]
                        ])), 0 < e[0] || 0 < e[1] ? (s.push([
                            "line",
                            i[1].end.x,
                            i[1].end.y
                        ]), i[1].curveToReversed(s)) : s.push([
                            "line",
                            t.c4[0],
                            t.c4[1]
                        ]), s;
                    }
                    function A(t, e, n, r, i, o, a) {
                        0 < e[0] || 0 < e[1] ? (t.push([
                            "line",
                            r[0].start.x,
                            r[0].start.y
                        ]), r[0].curveTo(t), r[1].curveTo(t)) : t.push([
                            "line",
                            o,
                            a
                        ]), (0 < n[0] || 0 < n[1]) && t.push([
                            "line",
                            i[0].start.x,
                            i[0].start.y
                        ]);
                    }
                    function I(t) {
                        return t.cssInt("zIndex") < 0;
                    }
                    function C(t) {
                        return 0 < t.cssInt("zIndex");
                    }
                    function T(t) {
                        return 0 === t.cssInt("zIndex");
                    }
                    function F(t) {
                        return -1 !== [
                            "inline",
                            "inline-block",
                            "inline-table"
                        ].indexOf(t.css("display"));
                    }
                    function P(t) {
                        return t instanceof p;
                    }
                    function E(t) {
                        return 0 < t.node.data.trim().length;
                    }
                    function q(t) {
                        return t.nodeType === Node.TEXT_NODE || t.nodeType === Node.ELEMENT_NODE;
                    }
                    function O(t) {
                        return "static" !== t.css("position");
                    }
                    function B(t) {
                        return "none" !== t.css("float");
                    }
                    function R(t) {
                        var e = this;
                        return function() {
                            return !t.apply(e, arguments);
                        };
                    }
                    function j(t) {
                        return t.node.nodeType === Node.ELEMENT_NODE;
                    }
                    function D(t) {
                        return !0 === t.isPseudoElement;
                    }
                    function M(t) {
                        return t.node.nodeType === Node.TEXT_NODE;
                    }
                    function U(t) {
                        return parseInt(t, 10);
                    }
                    function N(t) {
                        return t.width;
                    }
                    function z(t) {
                        return t.node.nodeType !== Node.ELEMENT_NODE || -1 === [
                            "SCRIPT",
                            "HEAD",
                            "TITLE",
                            "OBJECT",
                            "BR",
                            "OPTION"
                        ].indexOf(t.node.nodeName);
                    }
                    function L(t) {
                        return [].concat.apply([], t);
                    }
                    i.prototype.parseBorders = function(o) {
                        var r, t = o.parseBounds(), e = (r = o, [
                            "TopLeft",
                            "TopRight",
                            "BottomRight",
                            "BottomLeft"
                        ].map(function(t) {
                            var e = r.css("border" + t + "Radius"), n = e.split(" ");
                            return n.length <= 1 && (n[1] = n[0]), n.map(U);
                        })), n = [
                            "Top",
                            "Right",
                            "Bottom",
                            "Left"
                        ].map(function(t, e) {
                            var n = o.css("border" + t + "Style"), r = o.color("border" + t + "Color");
                            "inset" === n && r.isBlack() && (r = new u([
                                255,
                                255,
                                255,
                                r.a
                            ]));
                            var i = v[n] ? v[n][e] : null;
                            return {
                                width: o.cssInt("border" + t + "Width"),
                                color: i ? r[i[0]](i[1]) : r,
                                args: null
                            };
                        }), i = S(t, e, n);
                        return {
                            clip: this.parseBackgroundClip(o, i, n, e, t),
                            borders: b(n, t, i, e)
                        };
                    }, i.prototype.parseBackgroundClip = function(t, e, n, r, i) {
                        var o = [];
                        switch(t.css("backgroundClip")){
                            case "content-box":
                            case "padding-box":
                                A(o, r[0], r[1], e.topLeftInner, e.topRightInner, i.left + n[3].width, i.top + n[0].width), A(o, r[1], r[2], e.topRightInner, e.bottomRightInner, i.left + i.width - n[1].width, i.top + n[0].width), A(o, r[2], r[3], e.bottomRightInner, e.bottomLeftInner, i.left + i.width - n[1].width, i.top + i.height - n[2].width), A(o, r[3], r[0], e.bottomLeftInner, e.topLeftInner, i.left + n[3].width, i.top + i.height - n[2].width);
                                break;
                            default:
                                A(o, r[0], r[1], e.topLeftOuter, e.topRightOuter, i.left, i.top), A(o, r[1], r[2], e.topRightOuter, e.bottomRightOuter, i.left + i.width, i.top), A(o, r[2], r[3], e.bottomRightOuter, e.bottomLeftOuter, i.left + i.width, i.top + i.height), A(o, r[3], r[0], e.bottomLeftOuter, e.topLeftOuter, i.left, i.top + i.height);
                        }
                        return o;
                    }, e.exports = i;
                },
                {
                    "./color": 3,
                    "./fontmetrics": 7,
                    "./log": 13,
                    "./nodecontainer": 14,
                    "./pseudoelementcontainer": 18,
                    "./stackingcontext": 21,
                    "./textcontainer": 25,
                    "./utils": 26,
                    punycode: 1
                }
            ],
            16: [
                function(t, e, n) {
                    var a = t("./xhr"), r = t("./utils"), s = t("./log"), h = t("./clone"), c = r.decode64;
                    function l(t, e, n) {
                        var r = "withCredentials" in new XMLHttpRequest;
                        if (!e) return Promise.reject("No proxy configured");
                        var i = f(r), o = d(e, t, i);
                        return r ? a(o) : u(n, o, i).then(function(t) {
                            return c(t.content);
                        });
                    }
                    var i = 0;
                    function u(i, o, a) {
                        return new Promise(function(e, n) {
                            var t = i.createElement("script"), r = function() {
                                delete window.html2canvas.proxy[a], i.body.removeChild(t);
                            };
                            window.html2canvas.proxy[a] = function(t) {
                                r(), e(t);
                            }, t.src = o, t.onerror = function(t) {
                                r(), n(t);
                            }, i.body.appendChild(t);
                        });
                    }
                    function f(t) {
                        return t ? "" : "html2canvas_" + Date.now() + "_" + ++i + "_" + Math.round(1e5 * Math.random());
                    }
                    function d(t, e, n) {
                        return t + "?url=" + encodeURIComponent(e) + (n.length ? "&callback=html2canvas.proxy." + n : "");
                    }
                    n.Proxy = l, n.ProxyURL = function(t, e, n) {
                        var r = "crossOrigin" in new Image, i = f(r), o = d(e, t, i);
                        return r ? Promise.resolve(o) : u(n, o, i).then(function(t) {
                            return "data:" + t.type + ";base64," + t.content;
                        });
                    }, n.loadUrlDocument = function(t, e, n, r, i, o) {
                        var a;
                        return new l(t, e, window.document).then((a = t, function(e) {
                            var n, t = new DOMParser;
                            try {
                                n = t.parseFromString(e, "text/html");
                            } catch (t) {
                                s("DOMParser not supported, falling back to createHTMLDocument"), n = document.implementation.createHTMLDocument("");
                                try {
                                    n.open(), n.write(e), n.close();
                                } catch (t) {
                                    s("createHTMLDocument write not supported, falling back to document.body.innerHTML"), n.body.innerHTML = e;
                                }
                            }
                            var r = n.querySelector("base");
                            if (!r || !r.href.host) {
                                var i = n.createElement("base");
                                i.href = a, n.head.insertBefore(i, n.head.firstChild);
                            }
                            return n;
                        })).then(function(t) {
                            return h(t, n, r, i, o, 0, 0);
                        });
                    };
                },
                {
                    "./clone": 2,
                    "./log": 13,
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            17: [
                function(t, e, n) {
                    var o = t("./proxy").ProxyURL;
                    e.exports = function(n, r) {
                        var t = document.createElement("a");
                        t.href = n, n = t.href, this.src = n, this.image = new Image;
                        var i = this;
                        this.promise = new Promise(function(t, e) {
                            i.image.crossOrigin = "Anonymous", i.image.onload = t, i.image.onerror = e, new o(n, r, document).then(function(t) {
                                i.image.src = t;
                            }).catch(e);
                        });
                    };
                },
                {
                    "./proxy": 16
                }
            ],
            18: [
                function(t, e, n) {
                    var r = t("./nodecontainer");
                    function i(t, e, n) {
                        r.call(this, t, e), this.isPseudoElement = !0, this.before = ":before" === n;
                    }
                    i.prototype.cloneTo = function(t) {
                        i.prototype.cloneTo.call(this, t), t.isPseudoElement = !0, t.before = this.before;
                    }, (i.prototype = Object.create(r.prototype)).appendToDOM = function() {
                        this.before ? this.parent.node.insertBefore(this.node, this.parent.node.firstChild) : this.parent.node.appendChild(this.node), this.parent.node.className += " " + this.getHideClass();
                    }, i.prototype.cleanDOM = function() {
                        this.node.parentNode.removeChild(this.node), this.parent.node.className = this.parent.node.className.replace(this.getHideClass(), "");
                    }, i.prototype.getHideClass = function() {
                        return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before ? "BEFORE" : "AFTER")];
                    }, i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before", i.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after", e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            19: [
                function(t, e, n) {
                    var h = t("./log");
                    function r(t, e, n, r, i) {
                        this.width = t, this.height = e, this.images = n, this.options = r, this.document = i;
                    }
                    r.prototype.renderImage = function(t, e, n, r) {
                        var i = t.cssInt("paddingLeft"), o = t.cssInt("paddingTop"), a = t.cssInt("paddingRight"), s = t.cssInt("paddingBottom"), h = n.borders, c = e.width - (h[1].width + h[3].width + i + a), l = e.height - (h[0].width + h[2].width + o + s);
                        this.drawImage(r, 0, 0, r.image.width || c, r.image.height || l, e.left + i + h[3].width, e.top + o + h[0].width, c, l);
                    }, r.prototype.renderBackground = function(t, e, n) {
                        0 < e.height && 0 < e.width && (this.renderBackgroundColor(t, e), this.renderBackgroundImage(t, e, n));
                    }, r.prototype.renderBackgroundColor = function(t, e) {
                        var n = t.color("backgroundColor");
                        n.isTransparent() || this.rectangle(e.left, e.top, e.width, e.height, n);
                    }, r.prototype.renderBorders = function(t) {
                        t.forEach(this.renderBorder, this);
                    }, r.prototype.renderBorder = function(t) {
                        t.color.isTransparent() || null === t.args || this.drawShape(t.args, t.color);
                    }, r.prototype.renderBackgroundImage = function(o, a, s) {
                        o.parseBackgroundImages().reverse().forEach(function(t, e, n) {
                            switch(t.method){
                                case "url":
                                    var r = this.images.get(t.args[0]);
                                    r ? this.renderBackgroundRepeating(o, a, r, n.length - (e + 1), s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "linear-gradient":
                                case "gradient":
                                    var i = this.images.get(t.value);
                                    i ? this.renderBackgroundGradient(i, a, s) : h("Error loading background-image", t.args[0]);
                                    break;
                                case "none":
                                    break;
                                default:
                                    h("Unknown background-image type", t.args[0]);
                            }
                        }, this);
                    }, r.prototype.renderBackgroundRepeating = function(t, e, n, r, i) {
                        var o = t.parseBackgroundSize(e, n.image, r), a = t.parseBackgroundPosition(e, n.image, r, o);
                        switch(t.parseBackgroundRepeat(r)){
                            case "repeat-x":
                            case "repeat no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + i[3], e.top + a.top + i[0], 99999, o.height, i);
                                break;
                            case "repeat-y":
                            case "no-repeat repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + i[0], o.width, 99999, i);
                                break;
                            case "no-repeat":
                                this.backgroundRepeatShape(n, a, o, e, e.left + a.left + i[3], e.top + a.top + i[0], o.width, o.height, i);
                                break;
                            default:
                                this.renderBackgroundRepeat(n, a, o, {
                                    top: e.top,
                                    left: e.left
                                }, i[3], i[0]);
                        }
                    }, e.exports = r;
                },
                {
                    "./log": 13
                }
            ],
            20: [
                function(t, e, n) {
                    var r = t("../renderer"), i = t("../lineargradientcontainer"), o = t("../log");
                    function a(t, e) {
                        r.apply(this, arguments), this.canvas = this.options.canvas || this.document.createElement("canvas"), this.options.canvas || (this.canvas.width = t, this.canvas.height = e), this.ctx = this.canvas.getContext("2d"), this.taintCtx = this.document.createElement("canvas").getContext("2d"), this.ctx.textBaseline = "bottom", this.variables = {}, o("Initialized CanvasRenderer with size", t, "x", e);
                    }
                    function s(t) {
                        return 0 < t.length;
                    }
                    (a.prototype = Object.create(r.prototype)).setFillStyle = function(t) {
                        return this.ctx.fillStyle = "object" == typeof t && t.isColor ? t.toString() : t, this.ctx;
                    }, a.prototype.rectangle = function(t, e, n, r, i) {
                        this.setFillStyle(i).fillRect(t, e, n, r);
                    }, a.prototype.circle = function(t, e, n, r) {
                        this.setFillStyle(r), this.ctx.beginPath(), this.ctx.arc(t + n / 2, e + n / 2, n / 2, 0, 2 * Math.PI, !0), this.ctx.closePath(), this.ctx.fill();
                    }, a.prototype.circleStroke = function(t, e, n, r, i, o) {
                        this.circle(t, e, n, r), this.ctx.strokeStyle = o.toString(), this.ctx.stroke();
                    }, a.prototype.drawShape = function(t, e) {
                        this.shape(t), this.setFillStyle(e).fill();
                    }, a.prototype.taints = function(e) {
                        if (null === e.tainted) {
                            this.taintCtx.drawImage(e.image, 0, 0);
                            try {
                                this.taintCtx.getImageData(0, 0, 1, 1), e.tainted = !1;
                            } catch (t) {
                                this.taintCtx = document.createElement("canvas").getContext("2d"), e.tainted = !0;
                            }
                        }
                        return e.tainted;
                    }, a.prototype.drawImage = function(t, e, n, r, i, o, a, s, h) {
                        this.taints(t) && !this.options.allowTaint || this.ctx.drawImage(t.image, e, n, r, i, o, a, s, h);
                    }, a.prototype.clip = function(t, e, n) {
                        this.ctx.save(), t.filter(s).forEach(function(t) {
                            this.shape(t).clip();
                        }, this), e.call(n), this.ctx.restore();
                    }, a.prototype.shape = function(t) {
                        return this.ctx.beginPath(), t.forEach(function(t, e) {
                            "rect" === t[0] ? this.ctx.rect.apply(this.ctx, t.slice(1)) : this.ctx[0 === e ? "moveTo" : t[0] + "To"].apply(this.ctx, t.slice(1));
                        }, this), this.ctx.closePath(), this.ctx;
                    }, a.prototype.font = function(t, e, n, r, i, o) {
                        this.setFillStyle(t).font = [
                            e,
                            n,
                            r,
                            i,
                            o
                        ].join(" ").split(",")[0];
                    }, a.prototype.fontShadow = function(t, e, n, r) {
                        this.setVariable("shadowColor", t.toString()).setVariable("shadowOffsetY", e).setVariable("shadowOffsetX", n).setVariable("shadowBlur", r);
                    }, a.prototype.clearShadow = function() {
                        this.setVariable("shadowColor", "rgba(0,0,0,0)");
                    }, a.prototype.setOpacity = function(t) {
                        this.ctx.globalAlpha = t;
                    }, a.prototype.setTransform = function(t) {
                        this.ctx.translate(t.origin[0], t.origin[1]), this.ctx.transform.apply(this.ctx, t.matrix), this.ctx.translate(-t.origin[0], -t.origin[1]);
                    }, a.prototype.setVariable = function(t, e) {
                        return this.variables[t] !== e && (this.variables[t] = this.ctx[t] = e), this;
                    }, a.prototype.text = function(t, e, n) {
                        this.ctx.fillText(t, e, n);
                    }, a.prototype.backgroundRepeatShape = function(t, e, n, r, i, o, a, s, h) {
                        var c = [
                            [
                                "line",
                                Math.round(i),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(o)
                            ],
                            [
                                "line",
                                Math.round(i + a),
                                Math.round(s + o)
                            ],
                            [
                                "line",
                                Math.round(i),
                                Math.round(s + o)
                            ]
                        ];
                        this.clip([
                            c
                        ], function() {
                            this.renderBackgroundRepeat(t, e, n, r, h[3], h[0]);
                        }, this);
                    }, a.prototype.renderBackgroundRepeat = function(t, e, n, r, i, o) {
                        var a = Math.round(r.left + e.left + i), s = Math.round(r.top + e.top + o);
                        this.setFillStyle(this.ctx.createPattern(this.resizeImage(t, n), "repeat")), this.ctx.translate(a, s), this.ctx.fill(), this.ctx.translate(-a, -s);
                    }, a.prototype.renderBackgroundGradient = function(t, e) {
                        if (t instanceof i) {
                            var n = this.ctx.createLinearGradient(e.left + e.width * t.x0, e.top + e.height * t.y0, e.left + e.width * t.x1, e.top + e.height * t.y1);
                            t.colorStops.forEach(function(t) {
                                n.addColorStop(t.stop, t.color.toString());
                            }), this.rectangle(e.left, e.top, e.width, e.height, n);
                        }
                    }, a.prototype.resizeImage = function(t, e) {
                        var n = t.image;
                        if (n.width === e.width && n.height === e.height) return n;
                        var r = document.createElement("canvas");
                        return r.width = e.width, r.height = e.height, r.getContext("2d").drawImage(n, 0, 0, n.width, n.height, 0, 0, e.width, e.height), r;
                    }, e.exports = a;
                },
                {
                    "../lineargradientcontainer": 12,
                    "../log": 13,
                    "../renderer": 19
                }
            ],
            21: [
                function(t, e, n) {
                    var i = t("./nodecontainer");
                    function r(t, e, n, r) {
                        i.call(this, n, r), this.ownStacking = t, this.contexts = [], this.children = [], this.opacity = (this.parent ? this.parent.stack.opacity : 1) * e;
                    }
                    (r.prototype = Object.create(i.prototype)).getParentStack = function(t) {
                        var e = this.parent ? this.parent.stack : null;
                        return e ? e.ownStacking ? e : e.getParentStack(t) : t.stack;
                    }, e.exports = r;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            22: [
                function(t, e, n) {
                    function r(t) {
                        this.rangeBounds = this.testRangeBounds(t), this.cors = this.testCORS(), this.svg = this.testSVG();
                    }
                    r.prototype.testRangeBounds = function(t) {
                        var e, n, r = !1;
                        return t.createRange && (e = t.createRange()).getBoundingClientRect && ((n = t.createElement("boundtest")).style.height = "123px", n.style.display = "block", t.body.appendChild(n), e.selectNode(n), 123 === e.getBoundingClientRect().height && (r = !0), t.body.removeChild(n)), r;
                    }, r.prototype.testCORS = function() {
                        return void 0 !== (new Image).crossOrigin;
                    }, r.prototype.testSVG = function() {
                        var t = new Image, e = document.createElement("canvas"), n = e.getContext("2d");
                        t.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
                        try {
                            n.drawImage(t, 0, 0), e.toDataURL();
                        } catch (t) {
                            return !1;
                        }
                        return !0;
                    }, e.exports = r;
                },
                {}
            ],
            23: [
                function(t, e, n) {
                    var r = t("./xhr"), i = t("./utils").decode64;
                    function o(t) {
                        this.src = t, this.image = null;
                        var n = this;
                        this.promise = this.hasFabric().then(function() {
                            return n.isInline(t) ? Promise.resolve(n.inlineFormatting(t)) : r(t);
                        }).then(function(e) {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.loadSVGFromString(e, n.createCanvas.call(n, t));
                            });
                        });
                    }
                    o.prototype.hasFabric = function() {
                        return window.html2canvas.svg && window.html2canvas.svg.fabric ? Promise.resolve() : Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg"));
                    }, o.prototype.inlineFormatting = function(t) {
                        return /^data:image\/svg\+xml;base64,/.test(t) ? this.decode64(this.removeContentType(t)) : this.removeContentType(t);
                    }, o.prototype.removeContentType = function(t) {
                        return t.replace(/^data:image\/svg\+xml(;base64)?,/, "");
                    }, o.prototype.isInline = function(t) {
                        return /^data:image\/svg\+xml/i.test(t);
                    }, o.prototype.createCanvas = function(r) {
                        var i = this;
                        return function(t, e) {
                            var n = new window.html2canvas.svg.fabric.StaticCanvas("c");
                            i.image = n.lowerCanvasEl, n.setWidth(e.width).setHeight(e.height).add(window.html2canvas.svg.fabric.util.groupSVGElements(t, e)).renderAll(), r(n.lowerCanvasEl);
                        };
                    }, o.prototype.decode64 = function(t) {
                        return "function" == typeof window.atob ? window.atob(t) : i(t);
                    }, e.exports = o;
                },
                {
                    "./utils": 26,
                    "./xhr": 28
                }
            ],
            24: [
                function(t, e, n) {
                    var r = t("./svgcontainer");
                    function i(n, t) {
                        this.src = n, this.image = null;
                        var r = this;
                        this.promise = t ? new Promise(function(t, e) {
                            r.image = new Image, r.image.onload = t, r.image.onerror = e, r.image.src = "data:image/svg+xml," + (new XMLSerializer).serializeToString(n), !0 === r.image.complete && t(r.image);
                        }) : this.hasFabric().then(function() {
                            return new Promise(function(t) {
                                window.html2canvas.svg.fabric.parseSVGDocument(n, r.createCanvas.call(r, t));
                            });
                        });
                    }
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./svgcontainer": 23
                }
            ],
            25: [
                function(t, e, n) {
                    var r = t("./nodecontainer");
                    function i(t, e) {
                        r.call(this, t, e);
                    }
                    function o(t, e, n) {
                        if (0 < t.length) return e + n.toUpperCase();
                    }
                    (i.prototype = Object.create(r.prototype)).applyTextTransform = function() {
                        this.node.data = this.transform(this.parent.css("textTransform"));
                    }, i.prototype.transform = function(t) {
                        var e = this.node.data;
                        switch(t){
                            case "lowercase":
                                return e.toLowerCase();
                            case "capitalize":
                                return e.replace(/(^|\s|:|-|\(|\))([a-z])/g, o);
                            case "uppercase":
                                return e.toUpperCase();
                            default:
                                return e;
                        }
                    }, e.exports = i;
                },
                {
                    "./nodecontainer": 14
                }
            ],
            26: [
                function(t, e, n) {
                    n.smallImage = function() {
                        return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
                    }, n.bind = function(t, e) {
                        return function() {
                            return t.apply(e, arguments);
                        };
                    }, /*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */ n.decode64 = function(t) {
                        var e, n, r, i, o, a, s, h = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = t.length, l = "";
                        for(e = 0; e < c; e += 4)o = h.indexOf(t[e]) << 2 | (n = h.indexOf(t[e + 1])) >> 4, a = (15 & n) << 4 | (r = h.indexOf(t[e + 2])) >> 2, s = (3 & r) << 6 | (i = h.indexOf(t[e + 3])), l += 64 === r ? String.fromCharCode(o) : 64 === i || -1 === i ? String.fromCharCode(o, a) : String.fromCharCode(o, a, s);
                        return l;
                    }, n.getBounds = function(t) {
                        if (t.getBoundingClientRect) {
                            var e = t.getBoundingClientRect(), n = null == t.offsetWidth ? e.width : t.offsetWidth;
                            return {
                                top: e.top,
                                bottom: e.bottom || e.top + e.height,
                                right: e.left + n,
                                left: e.left,
                                width: n,
                                height: null == t.offsetHeight ? e.height : t.offsetHeight
                            };
                        }
                        return {};
                    }, n.offsetBounds = function(t) {
                        var e = t.offsetParent ? n.offsetBounds(t.offsetParent) : {
                            top: 0,
                            left: 0
                        };
                        return {
                            top: t.offsetTop + e.top,
                            bottom: t.offsetTop + t.offsetHeight + e.top,
                            right: t.offsetLeft + e.left + t.offsetWidth,
                            left: t.offsetLeft + e.left,
                            width: t.offsetWidth,
                            height: t.offsetHeight
                        };
                    }, n.parseBackgrounds = function(t) {
                        var e, n, r, i, o, a, s, h = [], c = 0, l = 0, u = function() {
                            e && ('"' === n.substr(0, 1) && (n = n.substr(1, n.length - 2)), n && s.push(n), "-" === e.substr(0, 1) && 0 < (i = e.indexOf("-", 1) + 1) && (r = e.substr(0, i), e = e.substr(i)), h.push({
                                prefix: r,
                                method: e.toLowerCase(),
                                value: o,
                                args: s,
                                image: null
                            })), s = [], e = r = n = o = "";
                        };
                        return s = [], e = r = n = o = "", t.split("").forEach(function(t) {
                            if (!(0 === c && -1 < " \r\n\t".indexOf(t))) {
                                switch(t){
                                    case '"':
                                        a ? a === t && (a = null) : a = t;
                                        break;
                                    case "(":
                                        if (a) break;
                                        if (0 === c) return c = 1, void (o += t);
                                        l++;
                                        break;
                                    case ")":
                                        if (a) break;
                                        if (1 === c) {
                                            if (0 === l) return c = 0, o += t, void u();
                                            l--;
                                        }
                                        break;
                                    case ",":
                                        if (a) break;
                                        if (0 === c) return void u();
                                        if (1 === c && 0 === l && !e.match(/^url$/i)) return s.push(n), n = "", void (o += t);
                                }
                                o += t, 0 === c ? e += t : n += t;
                            }
                        }), u(), h;
                    };
                },
                {}
            ],
            27: [
                function(t, e, n) {
                    var r = t("./gradientcontainer");
                    function i(t) {
                        r.apply(this, arguments), this.type = "linear" === t.args[0] ? r.TYPES.LINEAR : r.TYPES.RADIAL;
                    }
                    i.prototype = Object.create(r.prototype), e.exports = i;
                },
                {
                    "./gradientcontainer": 9
                }
            ],
            28: [
                function(t, e, n) {
                    e.exports = function(r) {
                        return new Promise(function(t, e) {
                            var n = new XMLHttpRequest;
                            n.open("GET", r), n.onload = function() {
                                200 === n.status ? t(n.responseText) : e(new Error(n.statusText));
                            }, n.onerror = function() {
                                e(new Error("Network Error"));
                            }, n.send();
                        });
                    };
                },
                {}
            ]
        }, {}, [
            4
        ])(4);
    }), function(t) {
        var n = "+".charCodeAt(0), r = "/".charCodeAt(0), i = "0".charCodeAt(0), o = "a".charCodeAt(0), a = "A".charCodeAt(0), s = "-".charCodeAt(0), h = "_".charCodeAt(0), l = function(t) {
            var e = t.charCodeAt(0);
            return e === n || e === s ? 62 : e === r || e === h ? 63 : e < i ? -1 : e < i + 10 ? e - i + 26 + 26 : e < a + 26 ? e - a : e < o + 26 ? e - o + 26 : void 0;
        };
        t.API.TTFFont = function() {
            function i(t, e, n) {
                var r;
                if (this.rawData = t, r = this.contents = new X(t), this.contents.pos = 4, "ttcf" === r.readString(4)) {
                    if (!e) throw new Error("Must specify a font name for TTC files.");
                    throw new Error("Font " + e + " not found in TTC file.");
                }
                r.pos = 0, this.parse(), this.subset = new T(this), this.registerTTF();
            }
            return i.open = function(t, e, n, r) {
                return new i(function(t) {
                    var e, n, r, i, o, a;
                    if (0 < t.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
                    var s = t.length;
                    o = "=" === t.charAt(s - 2) ? 2 : "=" === t.charAt(s - 1) ? 1 : 0, a = new Uint8Array(3 * t.length / 4 - o), r = 0 < o ? t.length - 4 : t.length;
                    var h = 0;
                    function c(t) {
                        a[h++] = t;
                    }
                    for(n = e = 0; e < r; e += 4, n += 3)c((16711680 & (i = l(t.charAt(e)) << 18 | l(t.charAt(e + 1)) << 12 | l(t.charAt(e + 2)) << 6 | l(t.charAt(e + 3)))) >> 16), c((65280 & i) >> 8), c(255 & i);
                    return 2 === o ? c(255 & (i = l(t.charAt(e)) << 2 | l(t.charAt(e + 1)) >> 4)) : 1 === o && (c((i = l(t.charAt(e)) << 10 | l(t.charAt(e + 1)) << 4 | l(t.charAt(e + 2)) >> 2) >> 8 & 255), c(255 & i)), a;
                }(n), e, r);
            }, i.prototype.parse = function() {
                return this.directory = new e(this.contents), this.head = new d(this), this.name = new b(this), this.cmap = new m(this), this.hhea = new g(this), this.maxp = new x(this), this.hmtx = new S(this), this.post = new y(this), this.os2 = new w(this), this.loca = new C(this), this.glyf = new _(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
                    this.head.xMin,
                    this.head.yMin,
                    this.head.xMax,
                    this.head.yMax
                ];
            }, i.prototype.registerTTF = function() {
                var i, t, e, n, r;
                if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.bbox).length; t < e; t++)i = n[t], r.push(Math.round(i * this.scaleFactor));
                    return r;
                }).call(this), this.stemV = 0, this.post.exists ? (e = 255 & (n = this.post.italic_angle), !0 & (t = n >> 16) && (t = -(1 + (65535 ^ t))), this.italicAngle = +(t + "." + e)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (r = this.familyClass) || 2 === r || 3 === r || 4 === r || 5 === r || 7 === r, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
            }, i.prototype.characterToGlyph = function(t) {
                var e;
                return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
            }, i.prototype.widthOfGlyph = function(t) {
                var e;
                return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
            }, i.prototype.widthOfString = function(t, e, n) {
                var r, i, o, a, s;
                for(i = a = o = 0, s = (t = "" + t).length; 0 <= s ? a < s : s < a; i = 0 <= s ? ++a : --a)r = t.charCodeAt(i), o += this.widthOfGlyph(this.characterToGlyph(r)) + n * (1e3 / e) || 0;
                return o * (e / 1e3);
            }, i.prototype.lineHeight = function(t, e) {
                var n;
                return null == e && (e = !1), n = e ? this.lineGap : 0, (this.ascender + n - this.decender) / 1e3 * t;
            }, i;
        }();
        var c, X = function() {
            function t(t) {
                this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
            }
            return t.prototype.readByte = function() {
                return this.data[this.pos++];
            }, t.prototype.writeByte = function(t) {
                return this.data[this.pos++] = t;
            }, t.prototype.readUInt32 = function() {
                return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
            }, t.prototype.writeUInt32 = function(t) {
                return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt32 = function() {
                var t;
                return 2147483648 <= (t = this.readUInt32()) ? t - 4294967296 : t;
            }, t.prototype.writeInt32 = function(t) {
                return t < 0 && (t += 4294967296), this.writeUInt32(t);
            }, t.prototype.readUInt16 = function() {
                return this.readByte() << 8 | this.readByte();
            }, t.prototype.writeUInt16 = function(t) {
                return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
            }, t.prototype.readInt16 = function() {
                var t;
                return 32768 <= (t = this.readUInt16()) ? t - 65536 : t;
            }, t.prototype.writeInt16 = function(t) {
                return t < 0 && (t += 65536), this.writeUInt16(t);
            }, t.prototype.readString = function(t) {
                var e, n, r;
                for(n = [], e = r = 0; 0 <= t ? r < t : t < r; e = 0 <= t ? ++r : --r)n[e] = String.fromCharCode(this.readByte());
                return n.join("");
            }, t.prototype.writeString = function(t) {
                var e, n, r, i;
                for(i = [], e = n = 0, r = t.length; 0 <= r ? n < r : r < n; e = 0 <= r ? ++n : --n)i.push(this.writeByte(t.charCodeAt(e)));
                return i;
            }, t.prototype.readShort = function() {
                return this.readInt16();
            }, t.prototype.writeShort = function(t) {
                return this.writeInt16(t);
            }, t.prototype.readLongLong = function() {
                var t, e, n, r, i, o, a, s;
                return t = this.readByte(), e = this.readByte(), n = this.readByte(), r = this.readByte(), i = this.readByte(), o = this.readByte(), a = this.readByte(), s = this.readByte(), 128 & t ? -1 * (72057594037927940 * (255 ^ t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ n) + 4294967296 * (255 ^ r) + 16777216 * (255 ^ i) + 65536 * (255 ^ o) + 256 * (255 ^ a) + (255 ^ s) + 1) : 72057594037927940 * t + 281474976710656 * e + 1099511627776 * n + 4294967296 * r + 16777216 * i + 65536 * o + 256 * a + s;
            }, t.prototype.readInt = function() {
                return this.readInt32();
            }, t.prototype.writeInt = function(t) {
                return this.writeInt32(t);
            }, t.prototype.read = function(t) {
                var e, n;
                for(e = [], n = 0; 0 <= t ? n < t : t < n; 0 <= t ? ++n : --n)e.push(this.readByte());
                return e;
            }, t.prototype.write = function(t) {
                var e, n, r, i;
                for(i = [], n = 0, r = t.length; n < r; n++)e = t[n], i.push(this.writeByte(e));
                return i;
            }, t;
        }(), e = function() {
            var p;
            function t(t) {
                var e, n, r;
                for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, n = 0, r = this.tableCount; 0 <= r ? n < r : r < n; 0 <= r ? ++n : --n)e = {
                    tag: t.readString(4),
                    checksum: t.readInt(),
                    offset: t.readInt(),
                    length: t.readInt()
                }, this.tables[e.tag] = e;
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d;
                for(d in u = Object.keys(t).length, a = Math.log(2), c = 16 * Math.floor(Math.log(u) / a), i = Math.floor(c / a), h = 16 * u - c, (n = new X).writeInt(this.scalarType), n.writeShort(u), n.writeShort(c), n.writeShort(i), n.writeShort(h), r = 16 * u, s = n.pos + r, o = null, f = [], t)for(l = t[d], n.writeString(d), n.writeInt(p(l)), n.writeInt(s), n.writeInt(l.length), f = f.concat(l), "head" === d && (o = s), s += l.length; s % 4;)f.push(0), s++;
                return n.write(f), e = 2981146554 - p(n.data), n.pos = o + 8, n.writeUInt32(e), n.data;
            }, p = function(t) {
                var e, n, r, i;
                for(t = k.call(t); t.length % 4;)t.push(0);
                for(n = new X(t), r = e = 0, i = t.length; r < i; r += 4)e += n.readUInt32();
                return 4294967295 & e;
            }, t;
        }(), u = {}.hasOwnProperty, f = function(t, e) {
            for(var n in e)u.call(e, n) && (t[n] = e[n]);
            function r() {
                this.constructor = t;
            }
            return r.prototype = e.prototype, t.prototype = new r, t.__super__ = e.prototype, t;
        };
        c = function() {
            function t(t) {
                var e;
                this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
            }
            return t.prototype.parse = function() {}, t.prototype.encode = function() {}, t.prototype.raw = function() {
                return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
            }, t;
        }();
        var d = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "head", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
            }, e;
        }(), p = function() {
            function t(n, t) {
                var e, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v;
                switch(this.platformID = n.readUInt16(), this.encodingID = n.readShort(), this.offset = t + n.readInt(), l = n.pos, n.pos = this.offset, this.format = n.readUInt16(), this.length = n.readUInt16(), this.language = n.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
                    case 0:
                        for(s = m = 0; m < 256; s = ++m)this.codeMap[s] = n.readByte();
                        break;
                    case 4:
                        for(f = n.readUInt16(), u = f / 2, n.pos += 6, i = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), n.pos += 2, p = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), h = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), c = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= u ? t < u : u < t; s = 0 <= u ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), r = (this.length - n.pos + this.offset) / 2, a = function() {
                            var t, e;
                            for(e = [], s = t = 0; 0 <= r ? t < r : r < t; s = 0 <= r ? ++t : --t)e.push(n.readUInt16());
                            return e;
                        }(), s = w = 0, v = i.length; w < v; s = ++w)for(g = i[s], e = y = d = p[s]; d <= g ? y <= g : g <= y; e = d <= g ? ++y : --y)0 === c[s] ? o = e + h[s] : 0 !== (o = a[c[s] / 2 + (e - d) - (u - s)] || 0) && (o += h[s]), this.codeMap[e] = 65535 & o;
                }
                n.pos = l;
            }
            return t.encode = function(t, e) {
                var n, r, i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A, I, C, T, F, P, E, q, O, B, R, j, D, M, U, N, z, L, H, W, G, V, Y;
                switch(F = new X, o = Object.keys(t).sort(function(t, e) {
                    return t - e;
                }), e){
                    case "macroman":
                        for(p = 0, g = function() {
                            var t, e;
                            for(e = [], d = t = 0; t < 256; d = ++t)e.push(0);
                            return e;
                        }(), w = {
                            0: 0
                        }, i = {}, P = 0, B = o.length; P < B; P++)null == w[W = t[r = o[P]]] && (w[W] = ++p), i[r] = {
                            old: t[r],
                            new: w[t[r]]
                        }, g[r] = w[t[r]];
                        return F.writeUInt16(1), F.writeUInt16(0), F.writeUInt32(12), F.writeUInt16(0), F.writeUInt16(262), F.writeUInt16(0), F.write(g), {
                            charMap: i,
                            subtable: F.data,
                            maxGlyphID: p + 1
                        };
                    case "unicode":
                        for(C = [], l = [], w = {}, n = {}, m = h = null, E = y = 0, R = o.length; E < R; E++)null == w[b = t[r = o[E]]] && (w[b] = ++y), n[r] = {
                            old: b,
                            new: w[b]
                        }, a = w[b] - r, null != m && a === h || (m && l.push(m), C.push(r), h = a), m = r;
                        for(m && l.push(m), l.push(65535), C.push(65535), A = 2 * (_ = C.length), k = 2 * Math.pow(Math.log(_) / Math.LN2, 2), u = Math.log(k / 2) / Math.LN2, S = 2 * _ - k, s = [], x = [], f = [], d = q = 0, j = C.length; q < j; d = ++q){
                            if (I = C[d], c = l[d], 65535 === I) {
                                s.push(0), x.push(0);
                                break;
                            }
                            if (32768 <= I - (T = n[I].new)) for(s.push(0), x.push(2 * (f.length + _ - d)), r = O = I; I <= c ? O <= c : c <= O; r = I <= c ? ++O : --O)f.push(n[r].new);
                            else s.push(T - I), x.push(0);
                        }
                        for(F.writeUInt16(3), F.writeUInt16(1), F.writeUInt32(12), F.writeUInt16(4), F.writeUInt16(16 + 8 * _ + 2 * f.length), F.writeUInt16(0), F.writeUInt16(A), F.writeUInt16(k), F.writeUInt16(u), F.writeUInt16(S), L = 0, D = l.length; L < D; L++)r = l[L], F.writeUInt16(r);
                        for(F.writeUInt16(0), H = 0, M = C.length; H < M; H++)r = C[H], F.writeUInt16(r);
                        for(G = 0, U = s.length; G < U; G++)a = s[G], F.writeUInt16(a);
                        for(V = 0, N = x.length; V < N; V++)v = x[V], F.writeUInt16(v);
                        for(Y = 0, z = f.length; Y < z; Y++)p = f[Y], F.writeUInt16(p);
                        return {
                            charMap: n,
                            subtable: F.data,
                            maxGlyphID: y + 1
                        };
                }
            }, t;
        }(), m = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
                var e, n, r;
                for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : n < r; 0 <= n ? ++r : --r)e = new p(t, this.offset), this.tables.push(e), e.isUnicode && null == this.unicode && (this.unicode = e);
                return !0;
            }, e.encode = function(t, e) {
                var n, r;
                return null == e && (e = "macroman"), n = p.encode(t, e), (r = new X).writeUInt16(0), r.writeUInt16(1), n.table = r.data.concat(n.subtable), n;
            }, e;
        }(), g = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
            }, e;
        }(), w = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "OS/2", e.prototype.parse = function(n) {
                if (n.pos = this.offset, this.version = n.readUInt16(), this.averageCharWidth = n.readShort(), this.weightClass = n.readUInt16(), this.widthClass = n.readUInt16(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort(), this.ySubscriptYSize = n.readShort(), this.ySubscriptXOffset = n.readShort(), this.ySubscriptYOffset = n.readShort(), this.ySuperscriptXSize = n.readShort(), this.ySuperscriptYSize = n.readShort(), this.ySuperscriptXOffset = n.readShort(), this.ySuperscriptYOffset = n.readShort(), this.yStrikeoutSize = n.readShort(), this.yStrikeoutPosition = n.readShort(), this.familyClass = n.readShort(), this.panose = function() {
                    var t, e;
                    for(e = [], t = 0; t < 10; ++t)e.push(n.readByte());
                    return e;
                }(), this.charRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(n.readInt());
                    return e;
                }(), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), 0 < this.version && (this.ascent = n.readShort(), this.descent = n.readShort(), this.lineGap = n.readShort(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = function() {
                    var t, e;
                    for(e = [], t = 0; t < 2; ++t)e.push(n.readInt());
                    return e;
                }(), 1 < this.version)) return this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort();
            }, e;
        }(), y = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "post", e.prototype.parse = function(r) {
                var t, e, n, i;
                switch(r.pos = this.offset, this.format = r.readInt(), this.italicAngle = r.readInt(), this.underlinePosition = r.readShort(), this.underlineThickness = r.readShort(), this.isFixedPitch = r.readInt(), this.minMemType42 = r.readInt(), this.maxMemType42 = r.readInt(), this.minMemType1 = r.readInt(), this.maxMemType1 = r.readInt(), this.format){
                    case 65536:
                        break;
                    case 131072:
                        for(e = r.readUInt16(), this.glyphNameIndex = [], n = 0; 0 <= e ? n < e : e < n; 0 <= e ? ++n : --n)this.glyphNameIndex.push(r.readUInt16());
                        for(this.names = [], i = []; r.pos < this.offset + this.length;)t = r.readByte(), i.push(this.names.push(r.readString(t)));
                        return i;
                    case 151552:
                        return e = r.readUInt16(), this.offsets = r.read(e);
                    case 196608:
                        break;
                    case 262144:
                        return this.map = (function() {
                            var t, e, n;
                            for(n = [], t = 0, e = this.file.maxp.numGlyphs; 0 <= e ? t < e : e < t; 0 <= e ? ++t : --t)n.push(r.readUInt32());
                            return n;
                        }).call(this);
                }
            }, e;
        }(), v = function(t, e) {
            this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
        }, b = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "name", e.prototype.parse = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f;
                for(t.pos = this.offset, t.readShort(), e = t.readShort(), a = t.readShort(), n = [], i = c = 0; 0 <= e ? c < e : e < c; i = 0 <= e ? ++c : --c)n.push({
                    platformID: t.readShort(),
                    encodingID: t.readShort(),
                    languageID: t.readShort(),
                    nameID: t.readShort(),
                    length: t.readShort(),
                    offset: this.offset + a + t.readShort()
                });
                for(s = {}, i = l = 0, u = n.length; l < u; i = ++l)r = n[i], t.pos = r.offset, h = t.readString(r.length), o = new v(h, r), null == s[f = r.nameID] && (s[f] = []), s[r.nameID].push(o);
                return this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5], this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, ""), this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
            }, e;
        }(), x = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
                return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
            }, e;
        }(), S = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "hmtx", e.prototype.parse = function(n) {
                var t, r, i, e, o, a, s;
                for(n.pos = this.offset, this.metrics = [], e = 0, a = this.file.hhea.numberOfMetrics; 0 <= a ? e < a : a < e; 0 <= a ? ++e : --e)this.metrics.push({
                    advance: n.readUInt16(),
                    lsb: n.readInt16()
                });
                for(r = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
                    var t, e;
                    for(e = [], t = 0; 0 <= r ? t < r : r < t; 0 <= r ? ++t : --t)e.push(n.readInt16());
                    return e;
                }(), this.widths = (function() {
                    var t, e, n, r;
                    for(r = [], t = 0, e = (n = this.metrics).length; t < e; t++)i = n[t], r.push(i.advance);
                    return r;
                }).call(this), t = this.widths[this.widths.length - 1], s = [], o = 0; 0 <= r ? o < r : r < o; 0 <= r ? ++o : --o)s.push(this.widths.push(t));
                return s;
            }, e.prototype.forGlyph = function(t) {
                return t in this.metrics ? this.metrics[t] : {
                    advance: this.metrics[this.metrics.length - 1].advance,
                    lsb: this.leftSideBearings[t - this.metrics.length]
                };
            }, e;
        }(), k = [].slice, _ = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "glyf", e.prototype.parse = function(t) {
                return this.cache = {};
            }, e.prototype.glyphFor = function(t) {
                var e, n, r, i, o, a, s, h, c, l;
                return t in this.cache ? this.cache[t] : (i = this.file.loca, e = this.file.contents, n = i.indexOf(t), 0 === (r = i.lengthOf(t)) ? this.cache[t] = null : (e.pos = this.offset + n, o = (a = new X(e.read(r))).readShort(), h = a.readShort(), l = a.readShort(), s = a.readShort(), c = a.readShort(), this.cache[t] = -1 === o ? new I(a, h, l, s, c) : new A(a, o, h, l, s, c), this.cache[t]));
            }, e.prototype.encode = function(t, e, n) {
                var r, i, o, a, s;
                for(o = [], i = [], a = 0, s = e.length; a < s; a++)r = t[e[a]], i.push(o.length), r && (o = o.concat(r.encode(n)));
                return i.push(o.length), {
                    table: o,
                    offsets: i
                };
            }, e;
        }(), A = function() {
            function t(t, e, n, r, i, o) {
                this.raw = t, this.numberOfContours = e, this.xMin = n, this.yMin = r, this.xMax = i, this.yMax = o, this.compound = !1;
            }
            return t.prototype.encode = function() {
                return this.raw.data;
            }, t;
        }(), I = function() {
            function t(t, e, n, r, i) {
                var o, a;
                for(this.raw = t, this.xMin = e, this.yMin = n, this.xMax = r, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], o = this.raw; a = o.readShort(), this.glyphOffsets.push(o.pos), this.glyphIDs.push(o.readShort()), 32 & a;)o.pos += 1 & a ? 4 : 2, 128 & a ? o.pos += 8 : 64 & a ? o.pos += 4 : 8 & a && (o.pos += 2);
            }
            return t.prototype.encode = function(t) {
                var e, n, r, i, o;
                for(n = new X(k.call(this.raw.data)), e = r = 0, i = (o = this.glyphIDs).length; r < i; e = ++r)o[e], n.pos = this.glyphOffsets[e];
                return n.data;
            }, t;
        }(), C = function(t) {
            function e() {
                return e.__super__.constructor.apply(this, arguments);
            }
            return f(e, c), e.prototype.tag = "loca", e.prototype.parse = function(r) {
                var t;
                return r.pos = this.offset, t = this.file.head.indexToLocFormat, this.offsets = 0 === t ? (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 2)n.push(2 * r.readUInt16());
                    return n;
                }).call(this) : (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = this.length; t < e; t += 4)n.push(r.readUInt32());
                    return n;
                }).call(this);
            }, e.prototype.indexOf = function(t) {
                return this.offsets[t];
            }, e.prototype.lengthOf = function(t) {
                return this.offsets[t + 1] - this.offsets[t];
            }, e.prototype.encode = function(t, e) {
                for(var n = new Uint32Array(this.offsets.length), r = 0, i = 0, o = 0; o < n.length; ++o)if (n[o] = r, i < e.length && e[i] == o) {
                    ++i, n[o] = r;
                    var a = this.offsets[o], s = this.offsets[o + 1] - a;
                    0 < s && (r += s);
                }
                for(var h = new Array(4 * n.length), c = 0; c < n.length; ++c)h[4 * c + 3] = 255 & n[c], h[4 * c + 2] = (65280 & n[c]) >> 8, h[4 * c + 1] = (16711680 & n[c]) >> 16, h[4 * c] = (4278190080 & n[c]) >> 24;
                return h;
            }, e;
        }(), T = function() {
            function t(t) {
                this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
            }
            return t.prototype.generateCmap = function() {
                var t, e, n, r, i;
                for(e in r = this.font.cmap.tables[0].codeMap, t = {}, i = this.subset)n = i[e], t[e] = r[n];
                return t;
            }, t.prototype.glyphsFor = function(t) {
                var e, n, r, i, o, a, s;
                for(r = {}, o = 0, a = t.length; o < a; o++)r[i = t[o]] = this.font.glyf.glyphFor(i);
                for(i in e = [], r)(null != (n = r[i]) ? n.compound : void 0) && e.push.apply(e, n.glyphIDs);
                if (0 < e.length) for(i in s = this.glyphsFor(e))n = s[i], r[i] = n;
                return r;
            }, t.prototype.encode = function(t) {
                var e, n, r, i, o, a, s, h, c, l, u, f, d, p, g;
                for(n in e = m.encode(this.generateCmap(), "unicode"), i = this.glyphsFor(t), u = {
                    0: 0
                }, g = e.charMap)u[(a = g[n]).old] = a.new;
                for(f in l = e.maxGlyphID, i)f in u || (u[f] = l++);
                return h = function(t) {
                    var e, n;
                    for(e in n = {}, t)n[t[e]] = e;
                    return n;
                }(u), c = Object.keys(h).sort(function(t, e) {
                    return t - e;
                }), d = function() {
                    var t, e, n;
                    for(n = [], t = 0, e = c.length; t < e; t++)o = c[t], n.push(h[o]);
                    return n;
                }(), r = this.font.glyf.encode(i, d, u), s = this.font.loca.encode(r.offsets, d), p = {
                    cmap: this.font.cmap.raw(),
                    glyf: r.table,
                    loca: s,
                    hmtx: this.font.hmtx.raw(),
                    hhea: this.font.hhea.raw(),
                    maxp: this.font.maxp.raw(),
                    post: this.font.post.raw(),
                    name: this.font.name.raw(),
                    head: this.font.head.raw()
                }, this.font.os2.exists && (p["OS/2"] = this.font.os2.raw()), this.font.directory.encode(p);
            }, t;
        }();
        t.API.PDFObject = function() {
            var o;
            function a() {}
            return o = function(t, e) {
                return (Array(e + 1).join("0") + t).slice(-e);
            }, a.convert = function(r) {
                var i, t, e, n;
                if (Array.isArray(r)) return "[" + (function() {
                    var t, e, n;
                    for(n = [], t = 0, e = r.length; t < e; t++)i = r[t], n.push(a.convert(i));
                    return n;
                })().join(" ") + "]";
                if ("string" == typeof r) return "/" + r;
                if (null != r ? r.isString : void 0) return "(" + r + ")";
                if (r instanceof Date) return "(D:" + o(r.getUTCFullYear(), 4) + o(r.getUTCMonth(), 2) + o(r.getUTCDate(), 2) + o(r.getUTCHours(), 2) + o(r.getUTCMinutes(), 2) + o(r.getUTCSeconds(), 2) + "Z)";
                if ("[object Object]" === ({}).toString.call(r)) {
                    for(t in e = [
                        "<<"
                    ], r)n = r[t], e.push("/" + t + " " + a.convert(n));
                    return e.push(">>"), e.join("\n");
                }
                return "" + r;
            }, a;
        }();
    }($), /*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */ pt = "undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof global && global || Function('return typeof this === "object" && this.content')() || Function("return this")(), gt = function() {
        var c, n, r;
        function i(t) {
            var e, n, r, i, o, a, s, h, c, l, u, f, d, p;
            for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, a = null;;){
                switch(e = this.readUInt32(), c = (function() {
                    var t, e;
                    for(e = [], t = 0; t < 4; ++t)e.push(String.fromCharCode(this.data[this.pos++]));
                    return e;
                }).call(this).join("")){
                    case "IHDR":
                        this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                        break;
                    case "acTL":
                        this.animation = {
                            numFrames: this.readUInt32(),
                            numPlays: this.readUInt32() || 1 / 0,
                            frames: []
                        };
                        break;
                    case "PLTE":
                        this.palette = this.read(e);
                        break;
                    case "fcTL":
                        a && this.animation.frames.push(a), this.pos += 4, a = {
                            width: this.readUInt32(),
                            height: this.readUInt32(),
                            xOffset: this.readUInt32(),
                            yOffset: this.readUInt32()
                        }, o = this.readUInt16(), i = this.readUInt16() || 100, a.delay = 1e3 * o / i, a.disposeOp = this.data[this.pos++], a.blendOp = this.data[this.pos++], a.data = [];
                        break;
                    case "IDAT":
                    case "fdAT":
                        for("fdAT" === c && (this.pos += 4, e -= 4), t = (null != a ? a.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : e < f; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                        break;
                    case "tRNS":
                        switch(this.transparency = {}, this.colorType){
                            case 3:
                                if (r = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > r) throw new Error("More transparent colors than palette size");
                                if (0 < (l = r - this.transparency.indexed.length)) for(d = 0; 0 <= l ? d < l : l < d; 0 <= l ? ++d : --d)this.transparency.indexed.push(255);
                                break;
                            case 0:
                                this.transparency.grayscale = this.read(e)[0];
                                break;
                            case 2:
                                this.transparency.rgb = this.read(e);
                        }
                        break;
                    case "tEXt":
                        s = (u = this.read(e)).indexOf(0), h = String.fromCharCode.apply(String, u.slice(0, s)), this.text[h] = String.fromCharCode.apply(String, u.slice(s + 1));
                        break;
                    case "IEND":
                        return a && this.animation.frames.push(a), this.colors = (function() {
                            switch(this.colorType){
                                case 0:
                                case 3:
                                case 4:
                                    return 1;
                                case 2:
                                case 6:
                                    return 3;
                            }
                        }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, n = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * n, this.colorSpace = (function() {
                            switch(this.colors){
                                case 1:
                                    return "DeviceGray";
                                case 3:
                                    return "DeviceRGB";
                            }
                        }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                    default:
                        this.pos += e;
                }
                if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
            }
        }
        i.load = function(t, e, n) {
            var r;
            return "function" == typeof e && (n = e), (r = new XMLHttpRequest).open("GET", t, !0), r.responseType = "arraybuffer", r.onload = function() {
                var t;
                return t = new i(new Uint8Array(r.response || r.mozResponseArrayBuffer)), "function" == typeof (null != e ? e.getContext : void 0) && t.render(e), "function" == typeof n ? n(t) : void 0;
            }, r.send(null);
        }, i.prototype.read = function(t) {
            var e, n;
            for(n = [], e = 0; 0 <= t ? e < t : t < e; 0 <= t ? ++e : --e)n.push(this.data[this.pos++]);
            return n;
        }, i.prototype.readUInt32 = function() {
            return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.readUInt16 = function() {
            return this.data[this.pos++] << 8 | this.data[this.pos++];
        }, i.prototype.decodePixels = function(E) {
            var q = this.pixelBitlength / 8, O = new Uint8Array(this.width * this.height * q), B = 0, R = this;
            if (null == E && (E = this.imgData), 0 === E.length) return new Uint8Array(0);
            function t(t, e, n, r) {
                var i, o, a, s, h, c, l, u, f, d, p, g, m, w, y, v, b, x, S, k, _, A = Math.ceil((R.width - t) / n), I = Math.ceil((R.height - e) / r), C = R.width == A && R.height == I;
                for(w = q * A, g = C ? O : new Uint8Array(w * I), c = E.length, o = m = 0; m < I && B < c;){
                    switch(E[B++]){
                        case 0:
                            for(s = b = 0; b < w; s = b += 1)g[o++] = E[B++];
                            break;
                        case 1:
                            for(s = x = 0; x < w; s = x += 1)i = E[B++], h = s < q ? 0 : g[o - q], g[o++] = (i + h) % 256;
                            break;
                        case 2:
                            for(s = S = 0; S < w; s = S += 1)i = E[B++], a = (s - s % q) / q, y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (y + i) % 256;
                            break;
                        case 3:
                            for(s = k = 0; k < w; s = k += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], y = m && g[(m - 1) * w + a * q + s % q], g[o++] = (i + Math.floor((h + y) / 2)) % 256;
                            break;
                        case 4:
                            for(s = _ = 0; _ < w; s = _ += 1)i = E[B++], a = (s - s % q) / q, h = s < q ? 0 : g[o - q], 0 === m ? y = v = 0 : (y = g[(m - 1) * w + a * q + s % q], v = a && g[(m - 1) * w + (a - 1) * q + s % q]), l = h + y - v, u = Math.abs(l - h), d = Math.abs(l - y), p = Math.abs(l - v), f = u <= d && u <= p ? h : d <= p ? y : v, g[o++] = (i + f) % 256;
                            break;
                        default:
                            throw new Error("Invalid filter algorithm: " + E[B - 1]);
                    }
                    if (!C) {
                        var T = ((e + m * r) * R.width + t) * q, F = m * w;
                        for(s = 0; s < A; s += 1){
                            for(var P = 0; P < q; P += 1)O[T++] = g[F++];
                            T += (n - 1) * q;
                        }
                    }
                    m++;
                }
            }
            return E = (E = new kt(E)).getBytes(), 1 == R.interlaceMethod ? (t(0, 0, 8, 8), t(4, 0, 8, 8), t(0, 4, 4, 8), t(2, 0, 4, 4), t(0, 2, 2, 4), t(1, 0, 2, 2), t(0, 1, 1, 2)) : t(0, 0, 1, 1), O;
        }, i.prototype.decodePalette = function() {
            var t, e, n, r, i, o, a, s, h;
            for(n = this.palette, o = this.transparency.indexed || [], i = new Uint8Array((o.length || 0) + n.length), r = 0, n.length, e = a = t = 0, s = n.length; a < s; e = a += 3)i[r++] = n[e], i[r++] = n[e + 1], i[r++] = n[e + 2], i[r++] = null != (h = o[t++]) ? h : 255;
            return i;
        }, i.prototype.copyToImageData = function(t, e) {
            var n, r, i, o, a, s, h, c, l, u, f;
            if (r = this.colors, l = null, n = this.hasAlphaChannel, this.palette.length && (l = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), r = 4, n = !0), c = (i = t.data || t).length, a = l || e, o = s = 0, 1 === r) for(; o < c;)h = l ? 4 * e[o / 4] : s, u = a[h++], i[o++] = u, i[o++] = u, i[o++] = u, i[o++] = n ? a[h++] : 255, s = h;
            else for(; o < c;)h = l ? 4 * e[o / 4] : s, i[o++] = a[h++], i[o++] = a[h++], i[o++] = a[h++], i[o++] = n ? a[h++] : 255, s = h;
        }, i.prototype.decode = function() {
            var t;
            return t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(t, this.decodePixels()), t;
        };
        try {
            n = pt.document.createElement("canvas"), r = n.getContext("2d");
        } catch (t) {
            return -1;
        }
        return c = function(t) {
            var e;
            return r.width = t.width, r.height = t.height, r.clearRect(0, 0, t.width, t.height), r.putImageData(t, 0, 0), (e = new Image).src = n.toDataURL(), e;
        }, i.prototype.decodeFrames = function(t) {
            var e, n, r, i, o, a, s, h;
            if (this.animation) {
                for(h = [], n = o = 0, a = (s = this.animation.frames).length; o < a; n = ++o)e = s[n], r = t.createImageData(e.width, e.height), i = this.decodePixels(new Uint8Array(e.data)), this.copyToImageData(r, i), e.imageData = r, h.push(e.image = c(r));
                return h;
            }
        }, i.prototype.renderFrame = function(t, e) {
            var n, r, i;
            return n = (r = this.animation.frames)[e], i = r[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != i ? i.disposeOp : void 0) ? t.clearRect(i.xOffset, i.yOffset, i.width, i.height) : 2 === (null != i ? i.disposeOp : void 0) && t.putImageData(i.imageData, i.xOffset, i.yOffset), 0 === n.blendOp && t.clearRect(n.xOffset, n.yOffset, n.width, n.height), t.drawImage(n.image, n.xOffset, n.yOffset);
        }, i.prototype.animate = function(n) {
            var r, i, o, a, s, t, h = this;
            return i = 0, t = this.animation, a = t.numFrames, o = t.frames, s = t.numPlays, (r = function() {
                var t, e;
                if (t = i++ % a, e = o[t], h.renderFrame(n, t), 1 < a && i / a < s) return h.animation._timeout = setTimeout(r, e.delay);
            })();
        }, i.prototype.stopAnimation = function() {
            var t;
            return clearTimeout(null != (t = this.animation) ? t._timeout : void 0);
        }, i.prototype.render = function(t) {
            var e, n;
            return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (n = e.createImageData(this.width, this.height), this.copyToImageData(n, this.decodePixels()), e.putImageData(n, 0, 0));
        }, i;
    }(), pt.PNG = gt;
    /*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */ var St = function() {
        function t() {
            this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = null;
        }
        return t.prototype = {
            ensureBuffer: function(t) {
                var e = this.buffer, n = e ? e.byteLength : 0;
                if (t < n) return e;
                for(var r = 512; r < t;)r <<= 1;
                for(var i = new Uint8Array(r), o = 0; o < n; ++o)i[o] = e[o];
                return this.buffer = i;
            },
            getByte: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return this.buffer[this.pos++];
            },
            getBytes: function(t) {
                var e = this.pos;
                if (t) {
                    this.ensureBuffer(e + t);
                    for(var n = e + t; !this.eof && this.bufferLength < n;)this.readBlock();
                    var r = this.bufferLength;
                    r < n && (n = r);
                } else {
                    for(; !this.eof;)this.readBlock();
                    n = this.bufferLength;
                }
                return this.pos = n, this.buffer.subarray(e, n);
            },
            lookChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos]);
            },
            getChar: function() {
                for(var t = this.pos; this.bufferLength <= t;){
                    if (this.eof) return null;
                    this.readBlock();
                }
                return String.fromCharCode(this.buffer[this.pos++]);
            },
            makeSubStream: function(t, e, n) {
                for(var r = t + e; this.bufferLength <= r && !this.eof;)this.readBlock();
                return new Stream(this.buffer, t, e, n);
            },
            skip: function(t) {
                t || (t = 1), this.pos += t;
            },
            reset: function() {
                this.pos = 0;
            }
        }, t;
    }(), kt = function() {
        if ("undefined" != typeof Uint32Array) {
            var F = new Uint32Array([
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ]), P = new Uint32Array([
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                65547,
                65549,
                65551,
                65553,
                131091,
                131095,
                131099,
                131103,
                196643,
                196651,
                196659,
                196667,
                262211,
                262227,
                262243,
                262259,
                327811,
                327843,
                327875,
                327907,
                258,
                258,
                258
            ]), E = new Uint32Array([
                1,
                2,
                3,
                4,
                65541,
                65543,
                131081,
                131085,
                196625,
                196633,
                262177,
                262193,
                327745,
                327777,
                393345,
                393409,
                459009,
                459137,
                524801,
                525057,
                590849,
                591361,
                657409,
                658433,
                724993,
                727041,
                794625,
                798721,
                868353,
                876545
            ]), q = [
                new Uint32Array([
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590016,
                    459016,
                    524384,
                    524320,
                    589984,
                    524288,
                    524416,
                    524352,
                    590048,
                    459012,
                    524376,
                    524312,
                    589968,
                    459028,
                    524408,
                    524344,
                    590032,
                    459020,
                    524392,
                    524328,
                    59e4,
                    524296,
                    524424,
                    524360,
                    590064,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590024,
                    459018,
                    524388,
                    524324,
                    589992,
                    524292,
                    524420,
                    524356,
                    590056,
                    459014,
                    524380,
                    524316,
                    589976,
                    459030,
                    524412,
                    524348,
                    590040,
                    459022,
                    524396,
                    524332,
                    590008,
                    524300,
                    524428,
                    524364,
                    590072,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590020,
                    459017,
                    524386,
                    524322,
                    589988,
                    524290,
                    524418,
                    524354,
                    590052,
                    459013,
                    524378,
                    524314,
                    589972,
                    459029,
                    524410,
                    524346,
                    590036,
                    459021,
                    524394,
                    524330,
                    590004,
                    524298,
                    524426,
                    524362,
                    590068,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590028,
                    459019,
                    524390,
                    524326,
                    589996,
                    524294,
                    524422,
                    524358,
                    590060,
                    459015,
                    524382,
                    524318,
                    589980,
                    459031,
                    524414,
                    524350,
                    590044,
                    459023,
                    524398,
                    524334,
                    590012,
                    524302,
                    524430,
                    524366,
                    590076,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590018,
                    459016,
                    524385,
                    524321,
                    589986,
                    524289,
                    524417,
                    524353,
                    590050,
                    459012,
                    524377,
                    524313,
                    589970,
                    459028,
                    524409,
                    524345,
                    590034,
                    459020,
                    524393,
                    524329,
                    590002,
                    524297,
                    524425,
                    524361,
                    590066,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590026,
                    459018,
                    524389,
                    524325,
                    589994,
                    524293,
                    524421,
                    524357,
                    590058,
                    459014,
                    524381,
                    524317,
                    589978,
                    459030,
                    524413,
                    524349,
                    590042,
                    459022,
                    524397,
                    524333,
                    590010,
                    524301,
                    524429,
                    524365,
                    590074,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590022,
                    459017,
                    524387,
                    524323,
                    589990,
                    524291,
                    524419,
                    524355,
                    590054,
                    459013,
                    524379,
                    524315,
                    589974,
                    459029,
                    524411,
                    524347,
                    590038,
                    459021,
                    524395,
                    524331,
                    590006,
                    524299,
                    524427,
                    524363,
                    590070,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590030,
                    459019,
                    524391,
                    524327,
                    589998,
                    524295,
                    524423,
                    524359,
                    590062,
                    459015,
                    524383,
                    524319,
                    589982,
                    459031,
                    524415,
                    524351,
                    590046,
                    459023,
                    524399,
                    524335,
                    590014,
                    524303,
                    524431,
                    524367,
                    590078,
                    459008,
                    524368,
                    524304,
                    524568,
                    459024,
                    524400,
                    524336,
                    590017,
                    459016,
                    524384,
                    524320,
                    589985,
                    524288,
                    524416,
                    524352,
                    590049,
                    459012,
                    524376,
                    524312,
                    589969,
                    459028,
                    524408,
                    524344,
                    590033,
                    459020,
                    524392,
                    524328,
                    590001,
                    524296,
                    524424,
                    524360,
                    590065,
                    459010,
                    524372,
                    524308,
                    524572,
                    459026,
                    524404,
                    524340,
                    590025,
                    459018,
                    524388,
                    524324,
                    589993,
                    524292,
                    524420,
                    524356,
                    590057,
                    459014,
                    524380,
                    524316,
                    589977,
                    459030,
                    524412,
                    524348,
                    590041,
                    459022,
                    524396,
                    524332,
                    590009,
                    524300,
                    524428,
                    524364,
                    590073,
                    459009,
                    524370,
                    524306,
                    524570,
                    459025,
                    524402,
                    524338,
                    590021,
                    459017,
                    524386,
                    524322,
                    589989,
                    524290,
                    524418,
                    524354,
                    590053,
                    459013,
                    524378,
                    524314,
                    589973,
                    459029,
                    524410,
                    524346,
                    590037,
                    459021,
                    524394,
                    524330,
                    590005,
                    524298,
                    524426,
                    524362,
                    590069,
                    459011,
                    524374,
                    524310,
                    524574,
                    459027,
                    524406,
                    524342,
                    590029,
                    459019,
                    524390,
                    524326,
                    589997,
                    524294,
                    524422,
                    524358,
                    590061,
                    459015,
                    524382,
                    524318,
                    589981,
                    459031,
                    524414,
                    524350,
                    590045,
                    459023,
                    524398,
                    524334,
                    590013,
                    524302,
                    524430,
                    524366,
                    590077,
                    459008,
                    524369,
                    524305,
                    524569,
                    459024,
                    524401,
                    524337,
                    590019,
                    459016,
                    524385,
                    524321,
                    589987,
                    524289,
                    524417,
                    524353,
                    590051,
                    459012,
                    524377,
                    524313,
                    589971,
                    459028,
                    524409,
                    524345,
                    590035,
                    459020,
                    524393,
                    524329,
                    590003,
                    524297,
                    524425,
                    524361,
                    590067,
                    459010,
                    524373,
                    524309,
                    524573,
                    459026,
                    524405,
                    524341,
                    590027,
                    459018,
                    524389,
                    524325,
                    589995,
                    524293,
                    524421,
                    524357,
                    590059,
                    459014,
                    524381,
                    524317,
                    589979,
                    459030,
                    524413,
                    524349,
                    590043,
                    459022,
                    524397,
                    524333,
                    590011,
                    524301,
                    524429,
                    524365,
                    590075,
                    459009,
                    524371,
                    524307,
                    524571,
                    459025,
                    524403,
                    524339,
                    590023,
                    459017,
                    524387,
                    524323,
                    589991,
                    524291,
                    524419,
                    524355,
                    590055,
                    459013,
                    524379,
                    524315,
                    589975,
                    459029,
                    524411,
                    524347,
                    590039,
                    459021,
                    524395,
                    524331,
                    590007,
                    524299,
                    524427,
                    524363,
                    590071,
                    459011,
                    524375,
                    524311,
                    524575,
                    459027,
                    524407,
                    524343,
                    590031,
                    459019,
                    524391,
                    524327,
                    589999,
                    524295,
                    524423,
                    524359,
                    590063,
                    459015,
                    524383,
                    524319,
                    589983,
                    459031,
                    524415,
                    524351,
                    590047,
                    459023,
                    524399,
                    524335,
                    590015,
                    524303,
                    524431,
                    524367,
                    590079
                ]),
                9
            ], O = [
                new Uint32Array([
                    327680,
                    327696,
                    327688,
                    327704,
                    327684,
                    327700,
                    327692,
                    327708,
                    327682,
                    327698,
                    327690,
                    327706,
                    327686,
                    327702,
                    327694,
                    0,
                    327681,
                    327697,
                    327689,
                    327705,
                    327685,
                    327701,
                    327693,
                    327709,
                    327683,
                    327699,
                    327691,
                    327707,
                    327687,
                    327703,
                    327695,
                    0
                ]),
                5
            ];
            return (t.prototype = Object.create(St.prototype)).getBits = function(t) {
                for(var e, n = this.codeSize, r = this.codeBuf, i = this.bytes, o = this.bytesPos; n < t;)void 0 === (e = i[o++]) && B("Bad encoding in flate stream"), r |= e << n, n += 8;
                return e = r & (1 << t) - 1, this.codeBuf = r >> t, this.codeSize = n -= t, this.bytesPos = o, e;
            }, t.prototype.getCode = function(t) {
                for(var e = t[0], n = t[1], r = this.codeSize, i = this.codeBuf, o = this.bytes, a = this.bytesPos; r < n;){
                    var s;
                    void 0 === (s = o[a++]) && B("Bad encoding in flate stream"), i |= s << r, r += 8;
                }
                var h = e[i & (1 << n) - 1], c = h >> 16, l = 65535 & h;
                return (0 == r || r < c || 0 == c) && B("Bad encoding in flate stream"), this.codeBuf = i >> c, this.codeSize = r - c, this.bytesPos = a, l;
            }, t.prototype.generateHuffmanTable = function(t) {
                for(var e = t.length, n = 0, r = 0; r < e; ++r)t[r] > n && (n = t[r]);
                for(var i = 1 << n, o = new Uint32Array(i), a = 1, s = 0, h = 2; a <= n; ++a, s <<= 1, h <<= 1)for(var c = 0; c < e; ++c)if (t[c] == a) {
                    var l = 0, u = s;
                    for(r = 0; r < a; ++r)l = l << 1 | 1 & u, u >>= 1;
                    for(r = l; r < i; r += h)o[r] = a << 16 | c;
                    ++s;
                }
                return [
                    o,
                    n
                ];
            }, t.prototype.readBlock = function() {
                function t(t, e, n, r, i) {
                    for(var o = t.getBits(n) + r; 0 < o--;)e[h++] = i;
                }
                var e = this.getBits(3);
                if (1 & e && (this.eof = !0), 0 != (e >>= 1)) {
                    var n, r;
                    if (1 == e) n = q, r = O;
                    else if (2 == e) {
                        for(var i = this.getBits(5) + 257, o = this.getBits(5) + 1, a = this.getBits(4) + 4, s = Array(F.length), h = 0; h < a;)s[F[h++]] = this.getBits(3);
                        for(var c = this.generateHuffmanTable(s), l = 0, u = (h = 0, i + o), f = new Array(u); h < u;){
                            var d = this.getCode(c);
                            16 == d ? t(this, f, 2, 3, l) : 17 == d ? t(this, f, 3, 3, l = 0) : 18 == d ? t(this, f, 7, 11, l = 0) : f[h++] = l = d;
                        }
                        n = this.generateHuffmanTable(f.slice(0, i)), r = this.generateHuffmanTable(f.slice(i, u));
                    } else B("Unknown block type in flate stream");
                    for(var p = (I = this.buffer) ? I.length : 0, g = this.bufferLength;;){
                        var m = this.getCode(n);
                        if (m < 256) p <= g + 1 && (p = (I = this.ensureBuffer(g + 1)).length), I[g++] = m;
                        else {
                            if (256 == m) return void (this.bufferLength = g);
                            var w = (m = P[m -= 257]) >> 16;
                            0 < w && (w = this.getBits(w));
                            l = (65535 & m) + w;
                            m = this.getCode(r), 0 < (w = (m = E[m]) >> 16) && (w = this.getBits(w));
                            var y = (65535 & m) + w;
                            p <= g + l && (p = (I = this.ensureBuffer(g + l)).length);
                            for(var v = 0; v < l; ++v, ++g)I[g] = I[g - y];
                        }
                    }
                } else {
                    var b, x = this.bytes, S = this.bytesPos;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var k = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), k |= b << 8, void 0 === (b = x[S++]) && B("Bad block header in flate stream");
                    var _ = b;
                    void 0 === (b = x[S++]) && B("Bad block header in flate stream"), (_ |= b << 8) != (65535 & ~k) && B("Bad uncompressed block length in flate stream"), this.codeBuf = 0, this.codeSize = 0;
                    var A = this.bufferLength, I = this.ensureBuffer(A + k), C = A + k;
                    this.bufferLength = C;
                    for(var T = A; T < C; ++T){
                        if (void 0 === (b = x[S++])) {
                            this.eof = !0;
                            break;
                        }
                        I[T] = b;
                    }
                    this.bytesPos = S;
                }
            }, t;
        }
        function B(t) {
            throw new Error(t);
        }
        function t(t) {
            var e = 0, n = t[e++], r = t[e++];
            -1 != n && -1 != r || B("Invalid header in flate stream"), 8 != (15 & n) && B("Unknown compression method in flate stream"), ((n << 8) + r) % 31 != 0 && B("Bad FCHECK in flate stream"), 32 & r && B("FDICT bit set in flate stream"), this.bytes = t, this.bytesPos = 2, this.codeSize = 0, this.codeBuf = 0, St.call(this);
        }
    }();
    return function(t) {
        if ("object" != typeof t.console) {
            t.console = {};
            for(var e, n, r = t.console, i = function() {}, o = [
                "memory"
            ], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = o.pop();)r[e] || (r[e] = {});
            for(; n = a.pop();)r[n] || (r[n] = i);
        }
        var s, h, c, l, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        void 0 === t.btoa && (t.btoa = function(t) {
            var e, n, r, i, o, a = 0, s = 0, h = "", c = [];
            if (!t) return t;
            for(; e = (o = t.charCodeAt(a++) << 16 | t.charCodeAt(a++) << 8 | t.charCodeAt(a++)) >> 18 & 63, n = o >> 12 & 63, r = o >> 6 & 63, i = 63 & o, c[s++] = u.charAt(e) + u.charAt(n) + u.charAt(r) + u.charAt(i), a < t.length;);
            h = c.join("");
            var l = t.length % 3;
            return (l ? h.slice(0, l - 3) : h) + "===".slice(l || 3);
        }), void 0 === t.atob && (t.atob = function(t) {
            var e, n, r, i, o, a, s = 0, h = 0, c = [];
            if (!t) return t;
            for(t += ""; e = (a = u.indexOf(t.charAt(s++)) << 18 | u.indexOf(t.charAt(s++)) << 12 | (i = u.indexOf(t.charAt(s++))) << 6 | (o = u.indexOf(t.charAt(s++)))) >> 16 & 255, n = a >> 8 & 255, r = 255 & a, c[h++] = 64 == i ? String.fromCharCode(e) : 64 == o ? String.fromCharCode(e, n) : String.fromCharCode(e, n, r), s < t.length;);
            return c.join("");
        }), Array.prototype.map || (Array.prototype.map = function(t) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var e = Object(this), n = e.length >>> 0, r = new Array(n), i = 1 < arguments.length ? arguments[1] : void 0, o = 0; o < n; o++)o in e && (r[o] = t.call(i, e[o], o, e));
            return r;
        }), Array.isArray || (Array.isArray = function(t) {
            return "[object Array]" === Object.prototype.toString.call(t);
        }), Array.prototype.forEach || (Array.prototype.forEach = function(t, e) {
            if (null == this || "function" != typeof t) throw new TypeError;
            for(var n = Object(this), r = n.length >>> 0, i = 0; i < r; i++)i in n && t.call(e, n[i], i, n);
        }), Object.keys || (Object.keys = (s = Object.prototype.hasOwnProperty, h = !({
            toString: null
        }).propertyIsEnumerable("toString"), l = (c = [
            "toString",
            "toLocaleString",
            "valueOf",
            "hasOwnProperty",
            "isPrototypeOf",
            "propertyIsEnumerable",
            "constructor"
        ]).length, function(t) {
            if ("object" != typeof t && ("function" != typeof t || null === t)) throw new TypeError;
            var e, n, r = [];
            for(e in t)s.call(t, e) && r.push(e);
            if (h) for(n = 0; n < l; n++)s.call(t, c[n]) && r.push(c[n]);
            return r;
        })), "function" != typeof Object.assign && (Object.assign = function(t) {
            if (null == t) throw new TypeError("Cannot convert undefined or null to object");
            t = Object(t);
            for(var e = 1; e < arguments.length; e++){
                var n = arguments[e];
                if (null != n) for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
            }
            return t;
        }), String.prototype.trim || (String.prototype.trim = function() {
            return this.replace(/^\s+|\s+$/g, "");
        }), String.prototype.trimLeft || (String.prototype.trimLeft = function() {
            return this.replace(/^\s+/g, "");
        }), String.prototype.trimRight || (String.prototype.trimRight = function() {
            return this.replace(/\s+$/g, "");
        });
    }("undefined" != typeof self && self || "undefined" != typeof window && window || "undefined" != typeof global && global || Function('return typeof this === "object" && this.content')() || Function("return this")()), $;
});

},{"e1c0f5b21ad461de":"5jT8D"}],"4KZDF":[function(require,module,exports,__globalThis) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

},{}],"8N9g4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewResultsAssessment);
parcelHelpers.export(exports, "assessmentStyles", ()=>assessmentStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _utils = require("../../../helpers/utils");
var _section = require("./Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
const useStyles = (0, _material.makeStyles)(assessmentStyles);
function PreviewResultsAssessment({ assessment, context }) {
    const classes = useStyles();
    const { assessmentId } = assessment;
    const { translate, link, quizTypesMap } = context;
    const { content = {}, results = {}, studentName = '' } = assessment;
    const { title, type } = content;
    const assessmentLoaded = !context.quizSearch['assessment-results'];
    const typeName = translate(quizTypesMap[type]);
    const orderedSections = assessment.assessmentId == assessmentId ? (0, _lodash.orderBy)(Object.values(content.sections || {}), 'index') : [];
    const sections = orderedSections.reduce((sections, section)=>{
        const last = sections.length > 0 ? sections[sections.length - 1] : {
            sectionEnds: -1
        };
        const sectionStarts = last.sectionEnds + 1;
        const sectionEnds = sectionStarts + section.questions.length;
        sections.push({
            ...section,
            sectionStarts,
            sectionEnds
        });
        return sections;
    }, []);
    return(// <Fade in={assessmentLoaded}>
    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: classes.preview,
            children: sections.map((section, sectionIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDefault.default), {
                    context,
                    assessment,
                    section,
                    sectionIndex,
                    sections
                }, section.id))
        })
    }));
}
function assessmentStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        header: {
            padding: '10px 20px 10px 10px',
            display: 'flex',
            flexDirection: 'column',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start'
            }
        },
        pointsWrapper: {
            flexGrow: 1
        },
        label: {
            color: '#4d5361',
            fontSize: '13pt',
            fontWeight: 'bold'
        },
        percentage: {
            marginTop: 5,
            fontSize: '50pt',
            color: '#df7317'
        },
        points: {
            color: '#4d5361',
            fontSize: '10pt'
        },
        notice: {
            color: '#4d5361',
            fontSize: '10pt'
        },
        filler: {
            flexGrow: 1
        },
        preview: {
            display: 'flex',
            flexDirection: 'column',
            padding: 10,
            flexGrow: 1,
            overflowY: 'auto'
        },
        question: {
            marginTop: 20,
            border: 'solid 1px #ccc',
            borderRadius: 2,
            backgroundColor: '#fff',
            '&:first-child': {
                marginTop: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","../../../helpers/utils":"gGc98","./Section":"9I67x","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9I67x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
var _question = require("./Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ assessment, sections, section, sectionIndex, context }) {
    const classes = useStyles();
    const { translate } = context;
    const questions = section.questions.map((q)=>({
            ...q,
            sectionId: section.id
        }));
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title;
    const instructions = section && ((0, _utils.isEmpty)(section.instructions) ? false : section.instructions);
    const defaultInstructions = translate('default-section-instructions');
    const hasDefaultInstructions = defaultInstructions != 'default-section-instructions';
    const hasInstructions = instructions != false || hasDefaultInstructions;
    const displayHeader = sections.length > 1;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.root,
                children: [
                    displayHeader && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.header,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.title,
                            children: title
                        })
                    }),
                    hasInstructions && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.instructionsWrapper, {
                            displayHeader
                        }),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.label,
                                children: translate('instructions')
                            }),
                            instructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: classes.instructions,
                                dangerouslySetInnerHTML: {
                                    __html: instructions
                                }
                            }),
                            !instructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.instructions,
                                children: defaultInstructions
                            })
                        ]
                    })
                ]
            }),
            questions.map((question, questionIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.question,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                        assessment,
                        context,
                        section,
                        sections,
                        question,
                        questionIndex
                    })
                }, question.id))
        ]
    });
}
function sectionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#000',
            marginTop: 50,
            "&:first-child": {
                marginTop: 0
            }
        },
        header: {
            display: 'flex',
            fontSize: '1rem',
            padding: '10px 20px',
            backgroundColor: '#2c75bd',
            border: 'solid 1px #2c75bd',
            borderBottom: 0,
            color: '#fff'
        },
        label: {
            fontWeight: 'bold'
        },
        instructionsWrapper: {
            flexGrow: 1,
            overflowY: 'auto',
            "&.displayHeader": {
                padding: 30
            }
        },
        instructions: {
            flexGrow: 1,
            padding: 15
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","./Question":"ePYcV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePYcV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _utils = require("../../../helpers/utils");
var _questionHandlers = require("./question-handlers");
var _questionHandlersDefault = parcelHelpers.interopDefault(_questionHandlers);
var _command = require("../../../helpers/command");
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question({ assessment, question, section, sections, context, questionIndex }) {
    const { id: questionId, sectionId } = question;
    const { translate, quizQuestionTypes } = context;
    const classes = useStyles();
    const globalIndex = section.sectionStarts + questionIndex;
    const count = sections.reduce((a, b)=>a + b.questions.length, 0);
    const { html } = question && question.premise || {};
    const premiseHtml = (0, _utils.isEmpty)(html) ? false : html;
    const type = quizQuestionTypes.find((t)=>t.id == question.type) || {};
    const title = translate(type.name);
    const indexLabel = `${globalIndex + 1}`;
    const Handler = (0, _questionHandlersDefault.default)[type.name];
    const defaultPremiseLabel = `${type.name}-default-premise`;
    const defaultPremise = translate(defaultPremiseLabel);
    const hasDefaultPremise = defaultPremiseLabel != defaultPremise;
    const handlerAsPremise = !premiseHtml && !hasDefaultPremise;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.title,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: classes.index,
                            children: [
                                indexLabel,
                                "."
                            ]
                        }),
                        premiseHtml && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.premise,
                            dangerouslySetInnerHTML: {
                                __html: premiseHtml
                            }
                        }),
                        !premiseHtml && hasDefaultPremise && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.premise,
                            children: defaultPremise
                        }),
                        handlerAsPremise && Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                            assessment,
                            context,
                            question,
                            section,
                            questionIndex
                        })
                    ]
                })
            }),
            !handlerAsPremise && Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.question,
                    children: Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                        assessment,
                        context,
                        question,
                        section,
                        questionIndex
                    })
                })
            })
        ]
    }, question.id);
}
function questionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            marginTop: 50,
            flexDirection: 'column',
            color: '#000'
        },
        header: {
            display: 'flex',
            fontSize: '11pt',
            fontWeight: 600,
            padding: 0
        },
        question: {
            display: 'flex',
            flexGrow: 1,
            paddingLeft: 15
        },
        title: {
            flexGrow: 1,
            fontSize: '1rem',
            display: 'flex'
        },
        index: {
            marginRight: 5,
            ...verticalCentering
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 15,
            display: 'flex',
            flexDirection: 'column'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextField":"amnzu","../../../helpers/utils":"gGc98","./question-handlers":"1A6Oz","../../../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1A6Oz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trueOrFalse = require("./TrueOrFalse");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _fillInTheBlanks = require("./FillInTheBlanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _openQuestion = require("./OpenQuestion");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _multipleChoice = require("./MultipleChoice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _matching = require("./Matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'matching': (0, _matchingDefault.default)
};
exports.default = handlers;

},{"./TrueOrFalse":"jT5GS","./FillInTheBlanks":"9EkaO","./OpenQuestion":"hw7fe","./MultipleChoice":"6s8tY","./Matching":"hDq3G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jT5GS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("../Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(trueOrFalseStyles);
function TrueOrFalse(props) {
    const { context } = props;
    const classes = useStyles();
    const { translate } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
            className: "content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.option,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: false,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                checked: false
                            }),
                            label: translate('true')
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.option,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: false,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                checked: false
                            }),
                            label: translate('false')
                        })
                    })
                })
            ]
        })
    });
}
function trueOrFalseStyles(theme) {
    return {
        root: {},
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../Radio":"7Huag","@mui/material/RadioGroup":"9W1hX","@mui/material/Fade":"8DwqP","@mui/material/FormControlLabel":"kemIW","../StatusIcon":"gz9Ja","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Huag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Radio);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
const filled = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBMEKngL/84AAALtSURBVEjH3ZXLT1NREIe/uaWNFlxJMFFjjHGHCUZxa/GBiVDSFlP/ADU+V2LwvejGFxrcuEAj/0AxfSCtC420LEFdaIgLJfEVNSgrrEbKvePi3tsmFmh1p5Pc5GTO78x3MjN3DvzrJkttNkfjvpVmQ0RUQ8AWhLUAKB+AZ6qkZryF1OTQ/rk/BuwIZ/ZZQh+wocolpxCrN5/oStYEiEbjni9F/zUVOeW4Xqgy6PF4Hnln5Q1AcYWuN01ztwiHgE2O7nq+ZeIssZi1JKAtPHLDCf4TlZP5zeO3fz9UsljMCDxvPYrKTcCH0JdPdJ5ZFOCk5R7wE9G9+URwtJZCbo9kdwr6APCJSiSX6khVAJqjcV/jfP1LYIPAsVyyc8DdC4SyXRj0ILrNLrJMYNGfT3fcL0MyJwRuIfr6q+d7s1t4wxWsNBsiTkFf5Fom7pSCd2cuY+gwaBtKPUo9aBuGDgciI5dc3aq6wgDoJCobG+f9IddfAogSdpZ33ZwHQtkulHNLdPn5tkgmCDA0tN8EGXTSUgkA3QJgWfKI8m5PtfwrZY2gD22ftC4EWA3g8S1/V/ZZrTXUuKQpmuZbJ9aaBQB/beou5otep2nEWgAgHwHMuR/ryj7jSQ2Akmb5Mss9+6kSoLZQRNvLGaK/WnRDtL8cQvY4i/EKgELaBnAoGo17AOw+18uLDzK5NJoIZtwRA3oAQAwZrgDMeAspYArYNG36j7j+fDJ4QaALGAX9Zn88NkSDuWTHRVc3bfqPgzQDr2Ybm9ILjopA9/0IaiSAOUX2jiU7HtdS5R3hB7sssbKAV0XDY4ng8KLDLhDJ9AG9NoSeVXWFAfsnqrRoNO6ZNv3HUbkB+BSujiU7zy39HsRiRuD5tisop53qTIIMCvqQuvo3dj8W1ivSDnrQSYsK0pdrGT9fdVyXx3Y2rIZ1HZWNVTL0yoDe0WRn+o+fzK2Hn3gbvnwOC4QU2Qq61jn2HngqIunZxqb00zutRf5b+wV5ISBgnOIuJAAAAABJRU5ErkJggg==" style="width: 24px;">';
const empty = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBMCCPsxGawAAAGOSURBVEjH3dU9TxRRFMbxn6zaghIjCTYSMSaLUWPEl8IPIIbKgi/nJ7DTaCylEikNa4MWRDQI6EosTIywNM8ks+uwu8za6E02Z+Zu7vnfec65z+VfHycG/N/AHJqYxnjm9/AJLaxhvw7gKhZwdsAmvuJ5QEMBxvAA9/O+hVWso525M5jFPKYyt4wX6AwCPEzy33iGld5FPevvYDFyvgqkS+NeWRaT/DHeDlHHTWzgOmbwGTtlOcqwhTw/xYdjNMv7fG2hQKMKMJeCbuFNjY5cwRdMpuv+ABSTq3007zcOstZRgOnE9RHOVbH2QhWgOETtEQDtnlxdgL/pDAdVgL3SIao7JhJ/VAE2E2dHAFxO/FgFeJc4X1O6MdzKc6sKsBbjmsLtGoC7OI/d0ma7rKKTOlzLp27g25DJL2EpRX6C7aO8aBuncTHe8jO+3+kjy70kL8zudT+zK3zlVIzrSgzwJH7l18A53MAj3MzOl/HyOBdOM8Y1OUCe3Vw4rbpXZrN0ZRZ9/j1t3UpB9/234xCyrVCqDls8ZwAAAABJRU5ErkJggg==" style="width: 24px;">';
const useStyles = (0, _material.makeStyles)(radioStyles);
function Radio(props) {
    const classes = useStyles();
    const icon = props.checked ? filled : empty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        dangerouslySetInnerHTML: {
            __html: icon
        }
    });
}
function radioStyles(theme) {
    return {
        root: {
            padding: 9
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gz9Ja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "markIcon", ()=>markIcon);
parcelHelpers.export(exports, "correctIcon", ()=>correctIcon);
parcelHelpers.export(exports, "incorrectIcon", ()=>incorrectIcon);
parcelHelpers.export(exports, "filledCheckboxIcon", ()=>filledCheckboxIcon);
parcelHelpers.export(exports, "default", ()=>StatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const markIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxQ+qDnYo4pChOlkoVcRRq1CECqFWaNXB5NIvaNKQpLg4Cq4FBz8Wqw4uzro6uAqC4AeIk6OToouU+L+k0CLWg+N+vLv3uHsHCPUy06yuKKDptplKxMVMdlXseUUfQhhEFDGZWcacJCXRcXzdw8fXuwjP6nzuzzGg5iwG+ETiWWaYNvEG8fSmbXDeJw6yoqwSnxNPmHRB4keuKx6/cS64LPDMoJlOzRMHicVCGyttzIqmRjxFHFY1nfKFjMcq5y3OWrnKmvfkLwzk9JVlrtMcRQKLWIIEEQqqKKEMGxFadVIspGg/3sE/4volcinkKoGRYwEVaJBdP/gf/O7Wyk/GvKRAHOh+cZyPMaBnF2jUHOf72HEaJ4D/GbjSW/5KHZj5JL3W0sJHwNA2cHHd0pQ94HIHCD0Zsim7kp+mkM8D72f0TVlg+BboX/N6a+7j9AFIU1fJG+DgEBgvUPZ6h3f3tvf275lmfz/UXHLOH5AJxAAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGA42Fq7q5xsAAAIqSURBVDjLrZTNTlNRFIW/fe6FIsEBURBKAiEISKptwSoD40BjIo6Y6Uv4ALyBOJWn0KEjCOjEmNgE5M8GkUlrpFD8AQIVbrk92wkglFsqxDU6uTvnu2eftfYRyqghlapz/OoBrPYjegUAkVWBpGVnNBeL5YP2SemH1rlMfcF6Q8BToLbM/34DIzVaNZzubd8oC2yc/xw1RXkN0sY/SGHZGDO4Er06dQLYMv0lXhTeAXWcTVvW6t21vu7ZQ2DrXKa+oN4MSivnkmY8342tJzo2DUDBekMVYVYiwHRwUdpqXH8IQBpSqTpnryp3igEArMa7pCW5cMkPORMC8SCjVHYajVOoflQJdqDl/p6fIRO6D0wFlGuNXnjoYvQWeqKFJ2r1VxD0a7RtPTy5OGAdeYMQLXH9tquqzVISx9V456vTTppNdP9o+rj0QETfK3QeQYYN/1muiKyUttw0s/S4tOVcX9fEwTo8uXjZik4cPx2AZF2BpJ7M1UsxwWO6P5qjcPz+AIzqB+O7e2P7s1lRLcmFS5713gI3A8r5otkdN98jkW1gpBKsaWYpUgw542UyiKi8yMVieQNQo1XDoJkK4/UJ6C1TTO8WzXMAA5Dubd+wlkFg6xzGblnHDq4nOjYPgQBrfd2zaop3gPQZYN/EmHtrN67NHRpzLBrRnnnPd+KCDgP5U0B5UXnm+c71o29h4Iv9N2vZWnW3BxT6QZsPciZoUvyLY9lEODAZfwDi89ZoyG6fUQAAAABJRU5ErkJggg==" style="width: 20px;" />';
const correctIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxQ+qDnYo4pChOlkoVcRRq1CECqFWaNXB5NIvaNKQpLg4Cq4FBz8Wqw4uzro6uAqC4AeIk6OToouU+L+k0CLWg+N+vLv3uHsHCPUy06yuKKDptplKxMVMdlXseUUfQhhEFDGZWcacJCXRcXzdw8fXuwjP6nzuzzGg5iwG+ETiWWaYNvEG8fSmbXDeJw6yoqwSnxNPmHRB4keuKx6/cS64LPDMoJlOzRMHicVCGyttzIqmRjxFHFY1nfKFjMcq5y3OWrnKmvfkLwzk9JVlrtMcRQKLWIIEEQqqKKEMGxFadVIspGg/3sE/4volcinkKoGRYwEVaJBdP/gf/O7Wyk/GvKRAHOh+cZyPMaBnF2jUHOf72HEaJ4D/GbjSW/5KHZj5JL3W0sJHwNA2cHHd0pQ94HIHCD0Zsim7kp+mkM8D72f0TVlg+BboX/N6a+7j9AFIU1fJG+DgEBgvUPZ6h3f3tvf275lmfz/UXHLOH5AJxAAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGA44Hj6yQqcAAAIzSURBVDjLpZQ9TJNRFIaf833w1fCTyKLBQeKgkxESSFpKG2k0gJOJhqHVGBKNLu7i4s8kq2EzUUnAYoKTk+gASQHbaCPUTWKC8T86SGgJfKX3OEgrlFKovts9yXnuzT3veYVt1DnRW+c6To+qehH2AyDyTdQk0umqZ6nu4UypPikuBGKRBmNpvyJXgZpt7ltWGNzjOgOToaFf2wK98fAxKydPgSZ2Jf1sjJxOBKPJLUD/dKRFIQbUUZmWbGMFp4IjcwVgIBZpyFnMAgf5N31wPdnmZNvYogWQs+X6f8AAmpwVpx9AOid661ad6u9lBlBK743NKTvHOYWb+UFl0vY+y3WquiuFra2ZUMIXnZ/piN4C5tfrNbX1pstSsbyVwl4df/wRoH0qfAM4XJi5qtdSpXGTEeChUe0S+LkjTOR2kQcPWMVNcf+RS4nA6IucrSeAH7uF5WWJ8HXD+ZBv5t0FgIRvNGVsPakQN7Z07gam8EX80+GzijzZUDcKF+Md0aHihnKw9V0/Yznu2jiwvOnVcN83HemrCKZkMkvWc2syNJZWGNzyFfCgfSZ8ZX0tr5WFASLcTXUPZ+RPVPXtXXXc2RKhYER4o0rrDnZacD3ZlmTb2KL8ja3zzTnLxID6SsPB2BpI+EZTAAXbTAVH5hDpABYqgH0yhlAetgkI8NL/6K3rybagMoCSKTcARO+4nuzRjVlYMrHzan19uaZ6Jd1jiXoVaSz4TCThOrXjybZ7y6X6fgNKDPQHUNzxMQAAAABJRU5ErkJggg==" style="width: 20px;" />';
const incorrectIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxQ+qDnYo4pChOlkoVcRRq1CECqFWaNXB5NIvaNKQpLg4Cq4FBz8Wqw4uzro6uAqC4AeIk6OToouU+L+k0CLWg+N+vLv3uHsHCPUy06yuKKDptplKxMVMdlXseUUfQhhEFDGZWcacJCXRcXzdw8fXuwjP6nzuzzGg5iwG+ETiWWaYNvEG8fSmbXDeJw6yoqwSnxNPmHRB4keuKx6/cS64LPDMoJlOzRMHicVCGyttzIqmRjxFHFY1nfKFjMcq5y3OWrnKmvfkLwzk9JVlrtMcRQKLWIIEEQqqKKEMGxFadVIspGg/3sE/4volcinkKoGRYwEVaJBdP/gf/O7Wyk/GvKRAHOh+cZyPMaBnF2jUHOf72HEaJ4D/GbjSW/5KHZj5JL3W0sJHwNA2cHHd0pQ94HIHCD0Zsim7kp+mkM8D72f0TVlg+BboX/N6a+7j9AFIU1fJG+DgEBgvUPZ6h3f3tvf275lmfz/UXHLOH5AJxAAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGA45GM7K1tMAAAJFSURBVDjLnZS9TxRhEMZ/8wp4HFdo48cVILsk3nl+XLS4wljYKB1BEgNGG2obtZD4D0AjFPa0RBMxsRJbqyvAEwOeCbtAoiAdBO7O42PHYvfIuncQ4KnezMz7vO/MMzPCAZjLZBKtZbo9s5cDOQ9gPP6oaL6t1PLpwtpsqdE9iRqW26+d3W3aHQKeAvED3isDb4x3eqRzqbB+IKHbefm6ivkIdHA0/FbRni6nOF1HuHgpk/WM9wVIcDxsipo71uLct33CIM0C0M7JsAzVG7brbhiAoGYRMhkFeQxsh4w7ovIEGIsQdkBsCEDmMplErOKt/S+AjNru/AuABTvdK8pb3679tlucBHCsK69Bn4eFais1nzOxyt79qJqifK2du5wfH0AHQAdqZAFmIr+MbyV27jWJSk4jzaOi446VKtcIbLf4PuxfsNO9qI7X9aCSMyqabFDkZpB3jpV6FHU4VqovKEFL1KdC0oDoIerpcaQ2HmpEWW3g2wF9aLvFiajDT1/7/Zi6H64aFc3X10IGwwI4VqrPsVJ9IdJJURlsQJg3f1tPTQWzGRblZojsAcgEyMSCne5tFBOglNhq/iz+pfQI8DISMCYqMyo67ou039iDAdmzSF7Dtjv/Svw5zp7xTLVwjKUQxRJUs/uj17lUWBc1PcDmCcg2Rb0e23U3AEzN6m8Lve2/dlToLxW9ay3+nN1vnUhLfIdqFmQEKB3CVAIZhu2r4V3YcGPXsJK8Fa/ESt0gORUuBqO1okI+XolPJVemy43u/QMsPOw9IHq1qgAAAABJRU5ErkJggg==" style="width: 20px;"/>';
const filledCheckboxIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBImMs0XS48AAAETSURBVEjH7ZU9bsIwGIbfz8oA7LCUnqESB0BhzRYqMSChqkuuABsZuQKdqVTJA11I1vQMVU8AezbEAPmYIhIhJ46Tbryb/VnP4z/ZwCMloWxj+Bo6lCQfAJ4MeQcweT/fTph2iJwtSdY14ADQB/E62yHuBtTPc5HANL+qQgMCkhR3Bszw/0FAkuL2NIpGZyHyF6YBwQ1uj3c+M5YVBfxXAP/SgSsFzPB71vGFwJ+Kmc904EqBIGpLObl0reNbXqK3LeUrAM9tN1ilEgAbE3jhGTB4bo93vpSTC8WddxM4AFhFRWYsbTdoRdvRAgCqwksFmZWcUmHVy2zpDDIBN/0WaQsODTD3agGTV1OyJ8B7/OOVcgVQVoSGTb3EPwAAAABJRU5ErkJggg==" style="width: 40px;">';
const useStyles = (0, _material.makeStyles)(statusIconStyles);
function StatusIcon({ value, answer, correctAnswer }) {
    const classes = useStyles();
    function getStatus() {
        if (value != correctAnswer && value == answer) return 'incorrect';
        if (value == correctAnswer && value == answer) return 'correct';
        if (value == correctAnswer && value != answer) return 'mark';
        return 'dummy';
    }
    const status = getStatus();
    const icon = {
        incorrect: incorrectIcon,
        correct: correctIcon,
        mark: markIcon,
        dummy: incorrectIcon
    }[status];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, status),
        dangerouslySetInnerHTML: {
            __html: icon
        }
    });
}
function statusIconStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: "#fff",
            marginRight: 20,
            fontSize: '20px',
            '&.dummy': {
                visibility: 'hidden'
            },
            '&.mark': {
                '& svg': {
                    color: '#18d0da'
                }
            },
            '&.incorrect': {
                '& svg': {
                    color: '#dd2229'
                }
            },
            '&.correct': {
                '& svg': {
                    color: '#39c55a'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9EkaO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanks);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(fillInTheBlanksStyles);
function FillInTheBlanks({ assessment, context, question }) {
    const classes = useStyles();
    const { answer = {} } = question;
    const { phrases = [] } = answer;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: classes.studentAnswer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.wrapper,
                children: phrases.map(({ phrase, blanked }, index)=>{
                    const text = blanked ? phrase.split('').map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.space
                        }, i)) : phrase;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.phrase, {
                            blanked
                        }),
                        children: text
                    }, index);
                })
            })
        })
    });
}
function fillInTheBlanksStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap'
        },
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        phrase: {
            ...verticalCentering,
            marginRight: 10,
            '&:last-child': {
                marginLeft: 0
            },
            '&.blanked': {
                display: 'flex',
                flexDirection: 'row',
                borderBottom: 'solid 1px black'
            }
        },
        space: {
            width: 15
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hw7fe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _utils = require("../../../../helpers/utils");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(openQuestionStyles);
function OpenQuestion() {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: classes.studentAnswer
        })
    });
}
function openQuestionStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            minHeight: 300
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","../../../../helpers/utils":"gGc98","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6s8tY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("../Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
var _checkbox = require("../Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
const useStyles = (0, _material.makeStyles)(multipleChoiceStyles);
function MultipleChoice({ assessment, context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const { properties: { singleOption } } = question;
    const { choices = [] } = question.answer;
    const Choices = singleOption ? RadioChoice : CheckboxChoice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
            question: question,
            context: context,
            choices: choices,
            answer: assessment.answers[question.id]
        })
    });
}
function RadioChoice({ context, choices, answer }) {
    const classes = useStyles();
    const correctChoice = choices.find((c)=>c.correct) || {};
    const selected = answer ? answer.selected : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: selected,
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: choice.id,
                            className: "choice",
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                color: "primary",
                                checked: selected == choice.id
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: choice.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function CheckboxChoice({ context, question, choices, answer }) {
    const classes = useStyles();
    const { assessment } = context;
    const correct = (0, _lodash.difference)(choices.filter((c)=>c.correct).map((c)=>c.id), answer.selectedOptions).length == 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: choices.map((option, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.checkbox,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                checked: false
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: option.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function multipleChoiceStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            fontSize: '1rem'
        },
        index: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 6
        },
        incorrect: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            visibility: 'hidden',
            color: "#fff",
            marginRight: 10,
            '& svg': {
                fill: '#f30d2a'
            },
            '&.visible': {
                visibility: 'visible'
            }
        },
        correct: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '& svg': {
                fill: '#27bc58'
            },
            marginRight: 10,
            visibility: 'hidden',
            '&.visible': {
                visibility: 'visible'
            }
        },
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../Radio":"7Huag","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@mui/material/FormGroup":"1gJha","../StatusIcon":"gz9Ja","../Checkbox":"dps40","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dps40":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckBox);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
const filled = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBImMs0XS48AAAETSURBVEjH7ZU9bsIwGIbfz8oA7LCUnqESB0BhzRYqMSChqkuuABsZuQKdqVTJA11I1vQMVU8AezbEAPmYIhIhJ46Tbryb/VnP4z/ZwCMloWxj+Bo6lCQfAJ4MeQcweT/fTph2iJwtSdY14ADQB/E62yHuBtTPc5HANL+qQgMCkhR3Bszw/0FAkuL2NIpGZyHyF6YBwQ1uj3c+M5YVBfxXAP/SgSsFzPB71vGFwJ+Kmc904EqBIGpLObl0reNbXqK3LeUrAM9tN1ilEgAbE3jhGTB4bo93vpSTC8WddxM4AFhFRWYsbTdoRdvRAgCqwksFmZWcUmHVy2zpDDIBN/0WaQsODTD3agGTV1OyJ8B7/OOVcgVQVoSGTb3EPwAAAABJRU5ErkJggg==" style="width: 24px;">';
const empty = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBI4Kgo67AYAAAB5SURBVEjHY2AYBQQAIxpfg4GBIZiBgYGfTPM+MjAwrGVgYLgBE2BCU0CJ4QxQvUHIAixYFDAwMDCUkWlBFwMDgwCyABOt42DUglELRi0YtWAwWMCCpTznh5aK5IIPyBxmNMnXDAwMigwMDBwUGL6WgYHh7WhdTjQAABdWCyOOwnh2AAAAAElFTkSuQmCC" style="width: 24px;">';
const useStyles = (0, _material.makeStyles)(checkboxStyles);
function CheckBox({ checked }) {
    const classes = useStyles();
    const icon = checked ? filled : empty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        dangerouslySetInnerHTML: {
            __html: icon
        }
    });
}
function checkboxStyles(theme) {
    return {
        root: {
            padding: 9
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hDq3G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Matching);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _select = require("../Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(matchingStyles);
function Matching({ assessment, context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    const terms = answer.terms.map((term, index)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.selectAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.answer,
                        children: "\xa0"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    dangerouslySetInnerHTML: {
                        __html: term.term || ''
                    }
                })
            ]
        });
    });
    const definitions = answer.definitions.map(({ definition }, index)=>{
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionIndex, {
                        selected: answer.selected.indexOf(index) > -1
                    }),
                    size: "small",
                    children: [
                        answerIndex,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    dangerouslySetInnerHTML: {
                        __html: definition || ''
                    }
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _boxDefault.default),
            className: classes.tableContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                className: classes.table,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: (0, _lodash.zip)(terms, definitions).map(([term, definition], index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            className: classes.pair,
                            children: [
                                term,
                                definition
                            ]
                        }, index);
                    })
                })
            })
        })
    });
}
function matchingStyles(theme) {
    return {
        root: {
            display: 'flex',
            marginTop: 10,
            flexGrow: 1
        },
        tableContainer: {
            flexShrink: 0,
            maxWidth: 1280,
            display: 'flex',
            fontSize: '11pt'
        },
        cell: {
            borderBottom: 0,
            padding: '16px 0',
            verticalAlign: 'top'
        },
        selectAnswer: {
            width: 20
        },
        answer: {
            width: 20,
            maxWidth: 20,
            borderBottom: 'solid 1px black',
            flexGrow: 0
        },
        definitionIndex: {
            width: 20,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 20
        },
        table: {
            maxWidth: 1280
        },
        term: {
            display: 'flex'
        },
        termHtml: {
            paddingLeft: 10,
            '& > p': {
                margin: 0
            }
        },
        definitionValue: {
            paddingLeft: 0,
            '& > p': {
                margin: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableRow":"4f4VX","@mui/material/Table":"if4Vw","../Select":"78r3y","../StatusIcon":"gz9Ja","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78r3y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
const caret = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBMJOUkbwF0AAABQSURBVEjHY2AYBaNgFAx9wEhA3oGBgcGLgJrdUIwVMBPQ/ICBgeE3AwODKjmGE2MBPksIGk6sBdgsIcpwUiyAWcLAwMBwj1jDR8EoGAV0AgCKXg7pFIpDaAAAAABJRU5ErkJggg==" style="width: 24px;">';
const useStyles = (0, _material.makeStyles)(selectStyles);
function Select(props) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(props.className, classes.root),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.value,
                children: props.value
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.caret,
                dangerouslySetInnerHTML: {
                    __html: caret
                }
            })
        ]
    });
}
function selectStyles(theme) {
    return {
        root: {
            display: 'flex',
            padding: '9px 0px 9px 9px',
            border: 'solid 1px #e0e5e9',
            borderRadius: 3,
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }
        },
        value: {
            justifyContent: 'center',
            flexGrow: 1
        },
        caret: {
            flexShrink: 0
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"as9ed":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("966a34921d2be71c");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6b45a60d7db330ff"));
var _jsxRuntime = require("91831f06b9d01c46");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5zm4-3H19v1h1.5V11H19v2h-1.5V7h3zM9 9.5h1v-1H9zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4zm10 5.5h1v-3h-1z"
}), 'PictureAsPdf');

},{"966a34921d2be71c":"kZ6eK","6b45a60d7db330ff":"2vOnF","91831f06b9d01c46":"1dlk8"}],"1YzXG":[function(require,module,exports,__globalThis) {
// Generated from latin_map.pl Sun Jun 20 20:17:18 2010
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "latinise", ()=>latinise);
parcelHelpers.export(exports, "isLatin", ()=>isLatin);
const Latinise = {};
Latinise.latin_map = {
    "\xc1": 'A',
    // LATIN CAPITAL LETTER A WITH ACUTE
    "\u0102": 'A',
    // LATIN CAPITAL LETTER A WITH BREVE
    "\u1EAE": 'A',
    // LATIN CAPITAL LETTER A WITH BREVE AND ACUTE
    "\u1EB6": 'A',
    // LATIN CAPITAL LETTER A WITH BREVE AND DOT BELOW
    "\u1EB0": 'A',
    // LATIN CAPITAL LETTER A WITH BREVE AND GRAVE
    "\u1EB2": 'A',
    // LATIN CAPITAL LETTER A WITH BREVE AND HOOK ABOVE
    "\u1EB4": 'A',
    // LATIN CAPITAL LETTER A WITH BREVE AND TILDE
    "\u01CD": 'A',
    // LATIN CAPITAL LETTER A WITH CARON
    "\xc2": 'A',
    // LATIN CAPITAL LETTER A WITH CIRCUMFLEX
    "\u1EA4": 'A',
    // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND ACUTE
    "\u1EAC": 'A',
    // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND DOT BELOW
    "\u1EA6": 'A',
    // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND GRAVE
    "\u1EA8": 'A',
    // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE
    "\u1EAA": 'A',
    // LATIN CAPITAL LETTER A WITH CIRCUMFLEX AND TILDE
    "\xc4": 'A',
    // LATIN CAPITAL LETTER A WITH DIAERESIS
    "\u01DE": 'A',
    // LATIN CAPITAL LETTER A WITH DIAERESIS AND MACRON
    "\u0226": 'A',
    // LATIN CAPITAL LETTER A WITH DOT ABOVE
    "\u01E0": 'A',
    // LATIN CAPITAL LETTER A WITH DOT ABOVE AND MACRON
    "\u1EA0": 'A',
    // LATIN CAPITAL LETTER A WITH DOT BELOW
    "\u0200": 'A',
    // LATIN CAPITAL LETTER A WITH DOUBLE GRAVE
    "\xc0": 'A',
    // LATIN CAPITAL LETTER A WITH GRAVE
    "\u1EA2": 'A',
    // LATIN CAPITAL LETTER A WITH HOOK ABOVE
    "\u0202": 'A',
    // LATIN CAPITAL LETTER A WITH INVERTED BREVE
    "\u0100": 'A',
    // LATIN CAPITAL LETTER A WITH MACRON
    "\u0104": 'A',
    // LATIN CAPITAL LETTER A WITH OGONEK
    "\xc5": 'A',
    // LATIN CAPITAL LETTER A WITH RING ABOVE
    "\u01FA": 'A',
    // LATIN CAPITAL LETTER A WITH RING ABOVE AND ACUTE
    "\u1E00": 'A',
    // LATIN CAPITAL LETTER A WITH RING BELOW
    "\u023A": 'A',
    // LATIN CAPITAL LETTER A WITH STROKE
    "\xc3": 'A',
    // LATIN CAPITAL LETTER A WITH TILDE
    "\uA732": 'AA',
    // LATIN CAPITAL LETTER AA
    "\xc6": 'AE',
    // LATIN CAPITAL LETTER AE
    "\u01FC": 'AE',
    // LATIN CAPITAL LETTER AE WITH ACUTE
    "\u01E2": 'AE',
    // LATIN CAPITAL LETTER AE WITH MACRON
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER AFRICAN D' (Ɖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ALPHA' (Ɑ)
    "\uA734": 'AO',
    // LATIN CAPITAL LETTER AO
    "\uA736": 'AU',
    // LATIN CAPITAL LETTER AU
    "\uA738": 'AV',
    // LATIN CAPITAL LETTER AV
    "\uA73A": 'AV',
    // LATIN CAPITAL LETTER AV WITH HORIZONTAL BAR
    "\uA73C": 'AY',
    // LATIN CAPITAL LETTER AY
    "\u1E02": 'B',
    // LATIN CAPITAL LETTER B WITH DOT ABOVE
    "\u1E04": 'B',
    // LATIN CAPITAL LETTER B WITH DOT BELOW
    "\u0181": 'B',
    // LATIN CAPITAL LETTER B WITH HOOK
    "\u1E06": 'B',
    // LATIN CAPITAL LETTER B WITH LINE BELOW
    "\u0243": 'B',
    // LATIN CAPITAL LETTER B WITH STROKE
    "\u0182": 'B',
    // LATIN CAPITAL LETTER B WITH TOPBAR
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER BROKEN L' (Ꝇ)
    "\u0106": 'C',
    // LATIN CAPITAL LETTER C WITH ACUTE
    "\u010C": 'C',
    // LATIN CAPITAL LETTER C WITH CARON
    "\xc7": 'C',
    // LATIN CAPITAL LETTER C WITH CEDILLA
    "\u1E08": 'C',
    // LATIN CAPITAL LETTER C WITH CEDILLA AND ACUTE
    "\u0108": 'C',
    // LATIN CAPITAL LETTER C WITH CIRCUMFLEX
    "\u010A": 'C',
    // LATIN CAPITAL LETTER C WITH DOT ABOVE
    "\u0187": 'C',
    // LATIN CAPITAL LETTER C WITH HOOK
    "\u023B": 'C',
    // LATIN CAPITAL LETTER C WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CON' (Ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO' (Ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER CUATRILLO WITH COMMA' (Ꜯ)
    "\u010E": 'D',
    // LATIN CAPITAL LETTER D WITH CARON
    "\u1E10": 'D',
    // LATIN CAPITAL LETTER D WITH CEDILLA
    "\u1E12": 'D',
    // LATIN CAPITAL LETTER D WITH CIRCUMFLEX BELOW
    "\u1E0A": 'D',
    // LATIN CAPITAL LETTER D WITH DOT ABOVE
    "\u1E0C": 'D',
    // LATIN CAPITAL LETTER D WITH DOT BELOW
    "\u018A": 'D',
    // LATIN CAPITAL LETTER D WITH HOOK
    "\u1E0E": 'D',
    // LATIN CAPITAL LETTER D WITH LINE BELOW
    "\u01F2": 'D',
    // LATIN CAPITAL LETTER D WITH SMALL LETTER Z
    "\u01C5": 'D',
    // LATIN CAPITAL LETTER D WITH SMALL LETTER Z WITH CARON
    "\u0110": 'D',
    // LATIN CAPITAL LETTER D WITH STROKE
    "\u018B": 'D',
    // LATIN CAPITAL LETTER D WITH TOPBAR
    "\u01F1": 'DZ',
    // LATIN CAPITAL LETTER DZ
    "\u01C4": 'DZ',
    // LATIN CAPITAL LETTER DZ WITH CARON
    "\xc9": 'E',
    // LATIN CAPITAL LETTER E WITH ACUTE
    "\u0114": 'E',
    // LATIN CAPITAL LETTER E WITH BREVE
    "\u011A": 'E',
    // LATIN CAPITAL LETTER E WITH CARON
    "\u0228": 'E',
    // LATIN CAPITAL LETTER E WITH CEDILLA
    "\u1E1C": 'E',
    // LATIN CAPITAL LETTER E WITH CEDILLA AND BREVE
    "\xca": 'E',
    // LATIN CAPITAL LETTER E WITH CIRCUMFLEX
    "\u1EBE": 'E',
    // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND ACUTE
    "\u1EC6": 'E',
    // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND DOT BELOW
    "\u1EC0": 'E',
    // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND GRAVE
    "\u1EC2": 'E',
    // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE
    "\u1EC4": 'E',
    // LATIN CAPITAL LETTER E WITH CIRCUMFLEX AND TILDE
    "\u1E18": 'E',
    // LATIN CAPITAL LETTER E WITH CIRCUMFLEX BELOW
    "\xcb": 'E',
    // LATIN CAPITAL LETTER E WITH DIAERESIS
    "\u0116": 'E',
    // LATIN CAPITAL LETTER E WITH DOT ABOVE
    "\u1EB8": 'E',
    // LATIN CAPITAL LETTER E WITH DOT BELOW
    "\u0204": 'E',
    // LATIN CAPITAL LETTER E WITH DOUBLE GRAVE
    "\xc8": 'E',
    // LATIN CAPITAL LETTER E WITH GRAVE
    "\u1EBA": 'E',
    // LATIN CAPITAL LETTER E WITH HOOK ABOVE
    "\u0206": 'E',
    // LATIN CAPITAL LETTER E WITH INVERTED BREVE
    "\u0112": 'E',
    // LATIN CAPITAL LETTER E WITH MACRON
    "\u1E16": 'E',
    // LATIN CAPITAL LETTER E WITH MACRON AND ACUTE
    "\u1E14": 'E',
    // LATIN CAPITAL LETTER E WITH MACRON AND GRAVE
    "\u0118": 'E',
    // LATIN CAPITAL LETTER E WITH OGONEK
    "\u0246": 'E',
    // LATIN CAPITAL LETTER E WITH STROKE
    "\u1EBC": 'E',
    // LATIN CAPITAL LETTER E WITH TILDE
    "\u1E1A": 'E',
    // LATIN CAPITAL LETTER E WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL AIN' (Ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EGYPTOLOGICAL ALEF' (Ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ENG' (Ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ESH' (Ʃ)
    "\uA76A": 'ET',
    // LATIN CAPITAL LETTER ET
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER ETH' (Ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH' (Ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH REVERSED' (Ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER EZH WITH CARON' (Ǯ)
    "\u1E1E": 'F',
    // LATIN CAPITAL LETTER F WITH DOT ABOVE
    "\u0191": 'F',
    // LATIN CAPITAL LETTER F WITH HOOK
    "\u01F4": 'G',
    // LATIN CAPITAL LETTER G WITH ACUTE
    "\u011E": 'G',
    // LATIN CAPITAL LETTER G WITH BREVE
    "\u01E6": 'G',
    // LATIN CAPITAL LETTER G WITH CARON
    "\u0122": 'G',
    // LATIN CAPITAL LETTER G WITH CEDILLA
    "\u011C": 'G',
    // LATIN CAPITAL LETTER G WITH CIRCUMFLEX
    "\u0120": 'G',
    // LATIN CAPITAL LETTER G WITH DOT ABOVE
    "\u0193": 'G',
    // LATIN CAPITAL LETTER G WITH HOOK
    "\u1E20": 'G',
    // LATIN CAPITAL LETTER G WITH MACRON
    "\u01E4": 'G',
    // LATIN CAPITAL LETTER G WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GAMMA' (Ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER GLOTTAL STOP' (Ɂ)
    "\u1E2A": 'H',
    // LATIN CAPITAL LETTER H WITH BREVE BELOW
    "\u021E": 'H',
    // LATIN CAPITAL LETTER H WITH CARON
    "\u1E28": 'H',
    // LATIN CAPITAL LETTER H WITH CEDILLA
    "\u0124": 'H',
    // LATIN CAPITAL LETTER H WITH CIRCUMFLEX
    "\u2C67": 'H',
    // LATIN CAPITAL LETTER H WITH DESCENDER
    "\u1E26": 'H',
    // LATIN CAPITAL LETTER H WITH DIAERESIS
    "\u1E22": 'H',
    // LATIN CAPITAL LETTER H WITH DOT ABOVE
    "\u1E24": 'H',
    // LATIN CAPITAL LETTER H WITH DOT BELOW
    "\u0126": 'H',
    // LATIN CAPITAL LETTER H WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HALF H' (Ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HENG' (Ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER HWAIR' (Ƕ)
    "\xcd": 'I',
    // LATIN CAPITAL LETTER I WITH ACUTE
    "\u012C": 'I',
    // LATIN CAPITAL LETTER I WITH BREVE
    "\u01CF": 'I',
    // LATIN CAPITAL LETTER I WITH CARON
    "\xce": 'I',
    // LATIN CAPITAL LETTER I WITH CIRCUMFLEX
    "\xcf": 'I',
    // LATIN CAPITAL LETTER I WITH DIAERESIS
    "\u1E2E": 'I',
    // LATIN CAPITAL LETTER I WITH DIAERESIS AND ACUTE
    "\u0130": 'I',
    // LATIN CAPITAL LETTER I WITH DOT ABOVE
    "\u1ECA": 'I',
    // LATIN CAPITAL LETTER I WITH DOT BELOW
    "\u0208": 'I',
    // LATIN CAPITAL LETTER I WITH DOUBLE GRAVE
    "\xcc": 'I',
    // LATIN CAPITAL LETTER I WITH GRAVE
    "\u1EC8": 'I',
    // LATIN CAPITAL LETTER I WITH HOOK ABOVE
    "\u020A": 'I',
    // LATIN CAPITAL LETTER I WITH INVERTED BREVE
    "\u012A": 'I',
    // LATIN CAPITAL LETTER I WITH MACRON
    "\u012E": 'I',
    // LATIN CAPITAL LETTER I WITH OGONEK
    "\u0197": 'I',
    // LATIN CAPITAL LETTER I WITH STROKE
    "\u0128": 'I',
    // LATIN CAPITAL LETTER I WITH TILDE
    "\u1E2C": 'I',
    // LATIN CAPITAL LETTER I WITH TILDE BELOW
    "\uA779": 'D',
    // LATIN CAPITAL LETTER INSULAR D
    "\uA77B": 'F',
    // LATIN CAPITAL LETTER INSULAR F
    "\uA77D": 'G',
    // LATIN CAPITAL LETTER INSULAR G
    "\uA782": 'R',
    // LATIN CAPITAL LETTER INSULAR R
    "\uA784": 'S',
    // LATIN CAPITAL LETTER INSULAR S
    "\uA786": 'T',
    // LATIN CAPITAL LETTER INSULAR T
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER IOTA' (Ɩ)
    "\uA76C": 'IS',
    // LATIN CAPITAL LETTER IS
    "\u0134": 'J',
    // LATIN CAPITAL LETTER J WITH CIRCUMFLEX
    "\u0248": 'J',
    // LATIN CAPITAL LETTER J WITH STROKE
    "\u1E30": 'K',
    // LATIN CAPITAL LETTER K WITH ACUTE
    "\u01E8": 'K',
    // LATIN CAPITAL LETTER K WITH CARON
    "\u0136": 'K',
    // LATIN CAPITAL LETTER K WITH CEDILLA
    "\u2C69": 'K',
    // LATIN CAPITAL LETTER K WITH DESCENDER
    "\uA742": 'K',
    // LATIN CAPITAL LETTER K WITH DIAGONAL STROKE
    "\u1E32": 'K',
    // LATIN CAPITAL LETTER K WITH DOT BELOW
    "\u0198": 'K',
    // LATIN CAPITAL LETTER K WITH HOOK
    "\u1E34": 'K',
    // LATIN CAPITAL LETTER K WITH LINE BELOW
    "\uA740": 'K',
    // LATIN CAPITAL LETTER K WITH STROKE
    "\uA744": 'K',
    // LATIN CAPITAL LETTER K WITH STROKE AND DIAGONAL STROKE
    "\u0139": 'L',
    // LATIN CAPITAL LETTER L WITH ACUTE
    "\u023D": 'L',
    // LATIN CAPITAL LETTER L WITH BAR
    "\u013D": 'L',
    // LATIN CAPITAL LETTER L WITH CARON
    "\u013B": 'L',
    // LATIN CAPITAL LETTER L WITH CEDILLA
    "\u1E3C": 'L',
    // LATIN CAPITAL LETTER L WITH CIRCUMFLEX BELOW
    "\u1E36": 'L',
    // LATIN CAPITAL LETTER L WITH DOT BELOW
    "\u1E38": 'L',
    // LATIN CAPITAL LETTER L WITH DOT BELOW AND MACRON
    "\u2C60": 'L',
    // LATIN CAPITAL LETTER L WITH DOUBLE BAR
    "\uA748": 'L',
    // LATIN CAPITAL LETTER L WITH HIGH STROKE
    "\u1E3A": 'L',
    // LATIN CAPITAL LETTER L WITH LINE BELOW
    "\u013F": 'L',
    // LATIN CAPITAL LETTER L WITH MIDDLE DOT
    "\u2C62": 'L',
    // LATIN CAPITAL LETTER L WITH MIDDLE TILDE
    "\u01C8": 'L',
    // LATIN CAPITAL LETTER L WITH SMALL LETTER J
    "\u0141": 'L',
    // LATIN CAPITAL LETTER L WITH STROKE
    "\u01C7": 'LJ',
    // LATIN CAPITAL LETTER LJ
    "\u1E3E": 'M',
    // LATIN CAPITAL LETTER M WITH ACUTE
    "\u1E40": 'M',
    // LATIN CAPITAL LETTER M WITH DOT ABOVE
    "\u1E42": 'M',
    // LATIN CAPITAL LETTER M WITH DOT BELOW
    "\u2C6E": 'M',
    // LATIN CAPITAL LETTER M WITH HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH LL' (Ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER MIDDLE-WELSH V' (Ỽ)
    "\u0143": 'N',
    // LATIN CAPITAL LETTER N WITH ACUTE
    "\u0147": 'N',
    // LATIN CAPITAL LETTER N WITH CARON
    "\u0145": 'N',
    // LATIN CAPITAL LETTER N WITH CEDILLA
    "\u1E4A": 'N',
    // LATIN CAPITAL LETTER N WITH CIRCUMFLEX BELOW
    "\u1E44": 'N',
    // LATIN CAPITAL LETTER N WITH DOT ABOVE
    "\u1E46": 'N',
    // LATIN CAPITAL LETTER N WITH DOT BELOW
    "\u01F8": 'N',
    // LATIN CAPITAL LETTER N WITH GRAVE
    "\u019D": 'N',
    // LATIN CAPITAL LETTER N WITH LEFT HOOK
    "\u1E48": 'N',
    // LATIN CAPITAL LETTER N WITH LINE BELOW
    "\u0220": 'N',
    // LATIN CAPITAL LETTER N WITH LONG RIGHT LEG
    "\u01CB": 'N',
    // LATIN CAPITAL LETTER N WITH SMALL LETTER J
    "\xd1": 'N',
    // LATIN CAPITAL LETTER N WITH TILDE
    "\u01CA": 'NJ',
    // LATIN CAPITAL LETTER NJ
    "\xd3": 'O',
    // LATIN CAPITAL LETTER O WITH ACUTE
    "\u014E": 'O',
    // LATIN CAPITAL LETTER O WITH BREVE
    "\u01D1": 'O',
    // LATIN CAPITAL LETTER O WITH CARON
    "\xd4": 'O',
    // LATIN CAPITAL LETTER O WITH CIRCUMFLEX
    "\u1ED0": 'O',
    // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND ACUTE
    "\u1ED8": 'O',
    // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND DOT BELOW
    "\u1ED2": 'O',
    // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND GRAVE
    "\u1ED4": 'O',
    // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE
    "\u1ED6": 'O',
    // LATIN CAPITAL LETTER O WITH CIRCUMFLEX AND TILDE
    "\xd6": 'O',
    // LATIN CAPITAL LETTER O WITH DIAERESIS
    "\u022A": 'O',
    // LATIN CAPITAL LETTER O WITH DIAERESIS AND MACRON
    "\u022E": 'O',
    // LATIN CAPITAL LETTER O WITH DOT ABOVE
    "\u0230": 'O',
    // LATIN CAPITAL LETTER O WITH DOT ABOVE AND MACRON
    "\u1ECC": 'O',
    // LATIN CAPITAL LETTER O WITH DOT BELOW
    "\u0150": 'O',
    // LATIN CAPITAL LETTER O WITH DOUBLE ACUTE
    "\u020C": 'O',
    // LATIN CAPITAL LETTER O WITH DOUBLE GRAVE
    "\xd2": 'O',
    // LATIN CAPITAL LETTER O WITH GRAVE
    "\u1ECE": 'O',
    // LATIN CAPITAL LETTER O WITH HOOK ABOVE
    "\u01A0": 'O',
    // LATIN CAPITAL LETTER O WITH HORN
    "\u1EDA": 'O',
    // LATIN CAPITAL LETTER O WITH HORN AND ACUTE
    "\u1EE2": 'O',
    // LATIN CAPITAL LETTER O WITH HORN AND DOT BELOW
    "\u1EDC": 'O',
    // LATIN CAPITAL LETTER O WITH HORN AND GRAVE
    "\u1EDE": 'O',
    // LATIN CAPITAL LETTER O WITH HORN AND HOOK ABOVE
    "\u1EE0": 'O',
    // LATIN CAPITAL LETTER O WITH HORN AND TILDE
    "\u020E": 'O',
    // LATIN CAPITAL LETTER O WITH INVERTED BREVE
    "\uA74A": 'O',
    // LATIN CAPITAL LETTER O WITH LONG STROKE OVERLAY
    "\uA74C": 'O',
    // LATIN CAPITAL LETTER O WITH LOOP
    "\u014C": 'O',
    // LATIN CAPITAL LETTER O WITH MACRON
    "\u1E52": 'O',
    // LATIN CAPITAL LETTER O WITH MACRON AND ACUTE
    "\u1E50": 'O',
    // LATIN CAPITAL LETTER O WITH MACRON AND GRAVE
    "\u019F": 'O',
    // LATIN CAPITAL LETTER O WITH MIDDLE TILDE
    "\u01EA": 'O',
    // LATIN CAPITAL LETTER O WITH OGONEK
    "\u01EC": 'O',
    // LATIN CAPITAL LETTER O WITH OGONEK AND MACRON
    "\xd8": 'O',
    // LATIN CAPITAL LETTER O WITH STROKE
    "\u01FE": 'O',
    // LATIN CAPITAL LETTER O WITH STROKE AND ACUTE
    "\xd5": 'O',
    // LATIN CAPITAL LETTER O WITH TILDE
    "\u1E4C": 'O',
    // LATIN CAPITAL LETTER O WITH TILDE AND ACUTE
    "\u1E4E": 'O',
    // LATIN CAPITAL LETTER O WITH TILDE AND DIAERESIS
    "\u022C": 'O',
    // LATIN CAPITAL LETTER O WITH TILDE AND MACRON
    "\u01A2": 'OI',
    // LATIN CAPITAL LETTER OI
    "\uA74E": 'OO',
    // LATIN CAPITAL LETTER OO
    "\u0190": 'E',
    // LATIN CAPITAL LETTER OPEN E
    "\u0186": 'O',
    // LATIN CAPITAL LETTER OPEN O
    "\u0222": 'OU',
    // LATIN CAPITAL LETTER OU
    "\u1E54": 'P',
    // LATIN CAPITAL LETTER P WITH ACUTE
    "\u1E56": 'P',
    // LATIN CAPITAL LETTER P WITH DOT ABOVE
    "\uA752": 'P',
    // LATIN CAPITAL LETTER P WITH FLOURISH
    "\u01A4": 'P',
    // LATIN CAPITAL LETTER P WITH HOOK
    "\uA754": 'P',
    // LATIN CAPITAL LETTER P WITH SQUIRREL TAIL
    "\u2C63": 'P',
    // LATIN CAPITAL LETTER P WITH STROKE
    "\uA750": 'P',
    // LATIN CAPITAL LETTER P WITH STROKE THROUGH DESCENDER
    "\uA758": 'Q',
    // LATIN CAPITAL LETTER Q WITH DIAGONAL STROKE
    "\uA756": 'Q',
    // LATIN CAPITAL LETTER Q WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER R ROTUNDA' (Ꝛ)
    "\u0154": 'R',
    // LATIN CAPITAL LETTER R WITH ACUTE
    "\u0158": 'R',
    // LATIN CAPITAL LETTER R WITH CARON
    "\u0156": 'R',
    // LATIN CAPITAL LETTER R WITH CEDILLA
    "\u1E58": 'R',
    // LATIN CAPITAL LETTER R WITH DOT ABOVE
    "\u1E5A": 'R',
    // LATIN CAPITAL LETTER R WITH DOT BELOW
    "\u1E5C": 'R',
    // LATIN CAPITAL LETTER R WITH DOT BELOW AND MACRON
    "\u0210": 'R',
    // LATIN CAPITAL LETTER R WITH DOUBLE GRAVE
    "\u0212": 'R',
    // LATIN CAPITAL LETTER R WITH INVERTED BREVE
    "\u1E5E": 'R',
    // LATIN CAPITAL LETTER R WITH LINE BELOW
    "\u024C": 'R',
    // LATIN CAPITAL LETTER R WITH STROKE
    "\u2C64": 'R',
    // LATIN CAPITAL LETTER R WITH TAIL
    "\uA73E": 'C',
    // LATIN CAPITAL LETTER REVERSED C WITH DOT
    "\u018E": 'E',
    // LATIN CAPITAL LETTER REVERSED E
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER RUM ROTUNDA' (Ꝝ)
    "\u015A": 'S',
    // LATIN CAPITAL LETTER S WITH ACUTE
    "\u1E64": 'S',
    // LATIN CAPITAL LETTER S WITH ACUTE AND DOT ABOVE
    "\u0160": 'S',
    // LATIN CAPITAL LETTER S WITH CARON
    "\u1E66": 'S',
    // LATIN CAPITAL LETTER S WITH CARON AND DOT ABOVE
    "\u015E": 'S',
    // LATIN CAPITAL LETTER S WITH CEDILLA
    "\u015C": 'S',
    // LATIN CAPITAL LETTER S WITH CIRCUMFLEX
    "\u0218": 'S',
    // LATIN CAPITAL LETTER S WITH COMMA BELOW
    "\u1E60": 'S',
    // LATIN CAPITAL LETTER S WITH DOT ABOVE
    "\u1E62": 'S',
    // LATIN CAPITAL LETTER S WITH DOT BELOW
    "\u1E68": 'S',
    // LATIN CAPITAL LETTER S WITH DOT BELOW AND DOT ABOVE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SALTILLO' (Ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SCHWA' (Ə)
    "\u1E9E": 'SS',
    // LATIN CAPITAL LETTER SHARP S
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER SMALL Q WITH HOOK TAIL' (Ɋ)
    "\u0164": 'T',
    // LATIN CAPITAL LETTER T WITH CARON
    "\u0162": 'T',
    // LATIN CAPITAL LETTER T WITH CEDILLA
    "\u1E70": 'T',
    // LATIN CAPITAL LETTER T WITH CIRCUMFLEX BELOW
    "\u021A": 'T',
    // LATIN CAPITAL LETTER T WITH COMMA BELOW
    "\u023E": 'T',
    // LATIN CAPITAL LETTER T WITH DIAGONAL STROKE
    "\u1E6A": 'T',
    // LATIN CAPITAL LETTER T WITH DOT ABOVE
    "\u1E6C": 'T',
    // LATIN CAPITAL LETTER T WITH DOT BELOW
    "\u01AC": 'T',
    // LATIN CAPITAL LETTER T WITH HOOK
    "\u1E6E": 'T',
    // LATIN CAPITAL LETTER T WITH LINE BELOW
    "\u01AE": 'T',
    // LATIN CAPITAL LETTER T WITH RETROFLEX HOOK
    "\u0166": 'T',
    // LATIN CAPITAL LETTER T WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN' (Þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE' (Ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER THORN WITH STROKE THROUGH DESCENDER' (Ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE FIVE' (Ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE SIX' (Ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TONE TWO' (Ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TRESILLO' (Ꜫ)
    "\u2C6F": 'A',
    // LATIN CAPITAL LETTER TURNED A
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER TURNED INSULAR G' (Ꝿ)
    "\uA780": 'L',
    // LATIN CAPITAL LETTER TURNED L
    "\u019C": 'M',
    // LATIN CAPITAL LETTER TURNED M
    "\u0245": 'V',
    // LATIN CAPITAL LETTER TURNED V
    "\uA728": 'TZ',
    // LATIN CAPITAL LETTER TZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER U BAR' (Ʉ)
    "\xda": 'U',
    // LATIN CAPITAL LETTER U WITH ACUTE
    "\u016C": 'U',
    // LATIN CAPITAL LETTER U WITH BREVE
    "\u01D3": 'U',
    // LATIN CAPITAL LETTER U WITH CARON
    "\xdb": 'U',
    // LATIN CAPITAL LETTER U WITH CIRCUMFLEX
    "\u1E76": 'U',
    // LATIN CAPITAL LETTER U WITH CIRCUMFLEX BELOW
    "\xdc": 'U',
    // LATIN CAPITAL LETTER U WITH DIAERESIS
    "\u01D7": 'U',
    // LATIN CAPITAL LETTER U WITH DIAERESIS AND ACUTE
    "\u01D9": 'U',
    // LATIN CAPITAL LETTER U WITH DIAERESIS AND CARON
    "\u01DB": 'U',
    // LATIN CAPITAL LETTER U WITH DIAERESIS AND GRAVE
    "\u01D5": 'U',
    // LATIN CAPITAL LETTER U WITH DIAERESIS AND MACRON
    "\u1E72": 'U',
    // LATIN CAPITAL LETTER U WITH DIAERESIS BELOW
    "\u1EE4": 'U',
    // LATIN CAPITAL LETTER U WITH DOT BELOW
    "\u0170": 'U',
    // LATIN CAPITAL LETTER U WITH DOUBLE ACUTE
    "\u0214": 'U',
    // LATIN CAPITAL LETTER U WITH DOUBLE GRAVE
    "\xd9": 'U',
    // LATIN CAPITAL LETTER U WITH GRAVE
    "\u1EE6": 'U',
    // LATIN CAPITAL LETTER U WITH HOOK ABOVE
    "\u01AF": 'U',
    // LATIN CAPITAL LETTER U WITH HORN
    "\u1EE8": 'U',
    // LATIN CAPITAL LETTER U WITH HORN AND ACUTE
    "\u1EF0": 'U',
    // LATIN CAPITAL LETTER U WITH HORN AND DOT BELOW
    "\u1EEA": 'U',
    // LATIN CAPITAL LETTER U WITH HORN AND GRAVE
    "\u1EEC": 'U',
    // LATIN CAPITAL LETTER U WITH HORN AND HOOK ABOVE
    "\u1EEE": 'U',
    // LATIN CAPITAL LETTER U WITH HORN AND TILDE
    "\u0216": 'U',
    // LATIN CAPITAL LETTER U WITH INVERTED BREVE
    "\u016A": 'U',
    // LATIN CAPITAL LETTER U WITH MACRON
    "\u1E7A": 'U',
    // LATIN CAPITAL LETTER U WITH MACRON AND DIAERESIS
    "\u0172": 'U',
    // LATIN CAPITAL LETTER U WITH OGONEK
    "\u016E": 'U',
    // LATIN CAPITAL LETTER U WITH RING ABOVE
    "\u0168": 'U',
    // LATIN CAPITAL LETTER U WITH TILDE
    "\u1E78": 'U',
    // LATIN CAPITAL LETTER U WITH TILDE AND ACUTE
    "\u1E74": 'U',
    // LATIN CAPITAL LETTER U WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER UPSILON' (Ʊ)
    "\uA75E": 'V',
    // LATIN CAPITAL LETTER V WITH DIAGONAL STROKE
    "\u1E7E": 'V',
    // LATIN CAPITAL LETTER V WITH DOT BELOW
    "\u01B2": 'V',
    // LATIN CAPITAL LETTER V WITH HOOK
    "\u1E7C": 'V',
    // LATIN CAPITAL LETTER V WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VEND' (Ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER VISIGOTHIC Z' (Ꝣ)
    "\uA760": 'VY',
    // LATIN CAPITAL LETTER VY
    "\u1E82": 'W',
    // LATIN CAPITAL LETTER W WITH ACUTE
    "\u0174": 'W',
    // LATIN CAPITAL LETTER W WITH CIRCUMFLEX
    "\u1E84": 'W',
    // LATIN CAPITAL LETTER W WITH DIAERESIS
    "\u1E86": 'W',
    // LATIN CAPITAL LETTER W WITH DOT ABOVE
    "\u1E88": 'W',
    // LATIN CAPITAL LETTER W WITH DOT BELOW
    "\u1E80": 'W',
    // LATIN CAPITAL LETTER W WITH GRAVE
    "\u2C72": 'W',
    // LATIN CAPITAL LETTER W WITH HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER WYNN' (Ƿ)
    "\u1E8C": 'X',
    // LATIN CAPITAL LETTER X WITH DIAERESIS
    "\u1E8A": 'X',
    // LATIN CAPITAL LETTER X WITH DOT ABOVE
    "\xdd": 'Y',
    // LATIN CAPITAL LETTER Y WITH ACUTE
    "\u0176": 'Y',
    // LATIN CAPITAL LETTER Y WITH CIRCUMFLEX
    "\u0178": 'Y',
    // LATIN CAPITAL LETTER Y WITH DIAERESIS
    "\u1E8E": 'Y',
    // LATIN CAPITAL LETTER Y WITH DOT ABOVE
    "\u1EF4": 'Y',
    // LATIN CAPITAL LETTER Y WITH DOT BELOW
    "\u1EF2": 'Y',
    // LATIN CAPITAL LETTER Y WITH GRAVE
    "\u01B3": 'Y',
    // LATIN CAPITAL LETTER Y WITH HOOK
    "\u1EF6": 'Y',
    // LATIN CAPITAL LETTER Y WITH HOOK ABOVE
    "\u1EFE": 'Y',
    // LATIN CAPITAL LETTER Y WITH LOOP
    "\u0232": 'Y',
    // LATIN CAPITAL LETTER Y WITH MACRON
    "\u024E": 'Y',
    // LATIN CAPITAL LETTER Y WITH STROKE
    "\u1EF8": 'Y',
    // LATIN CAPITAL LETTER Y WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CAPITAL LETTER YOGH' (Ȝ)
    "\u0179": 'Z',
    // LATIN CAPITAL LETTER Z WITH ACUTE
    "\u017D": 'Z',
    // LATIN CAPITAL LETTER Z WITH CARON
    "\u1E90": 'Z',
    // LATIN CAPITAL LETTER Z WITH CIRCUMFLEX
    "\u2C6B": 'Z',
    // LATIN CAPITAL LETTER Z WITH DESCENDER
    "\u017B": 'Z',
    // LATIN CAPITAL LETTER Z WITH DOT ABOVE
    "\u1E92": 'Z',
    // LATIN CAPITAL LETTER Z WITH DOT BELOW
    "\u0224": 'Z',
    // LATIN CAPITAL LETTER Z WITH HOOK
    "\u1E94": 'Z',
    // LATIN CAPITAL LETTER Z WITH LINE BELOW
    "\u01B5": 'Z',
    // LATIN CAPITAL LETTER Z WITH STROKE
    "\u0132": 'IJ',
    // LATIN CAPITAL LIGATURE IJ
    "\u0152": 'OE',
    // LATIN CAPITAL LIGATURE OE
    // CANNOT FIND APPROXIMATION FOR 'LATIN CROSS' (✝)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER ARCHAIC M' (ꟿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER I LONGA' (ꟾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER INVERTED M' (ꟽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED F' (ꟻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN EPIGRAPHIC LETTER REVERSED P' (ꟼ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER AIN' (ᴥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER ALVEOLAR CLICK' (ǂ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BIDENTAL PERCUSSIVE' (ʭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL CLICK' (ʘ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER BILABIAL PERCUSSIVE' (ʬ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER DENTAL CLICK' (ǀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP' (ʔ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER GLOTTAL STOP WITH STROKE' (ʡ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP' (ʖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER INVERTED GLOTTAL STOP WITH STROKE' (ƾ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER LATERAL CLICK' (ǁ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER PHARYNGEAL VOICED FRICATIVE' (ʕ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER RETROFLEX CLICK' (ǃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED ESH LOOP' (ƪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER REVERSED GLOTTAL STOP WITH STROKE' (ʢ)
    "\u1D00": 'A',
    // LATIN LETTER SMALL CAPITAL A
    "\u1D01": 'AE',
    // LATIN LETTER SMALL CAPITAL AE
    "\u0299": 'B',
    // LATIN LETTER SMALL CAPITAL B
    "\u1D03": 'B',
    // LATIN LETTER SMALL CAPITAL BARRED B
    "\u1D04": 'C',
    // LATIN LETTER SMALL CAPITAL C
    "\u1D05": 'D',
    // LATIN LETTER SMALL CAPITAL D
    "\u1D07": 'E',
    // LATIN LETTER SMALL CAPITAL E
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL ETH' (ᴆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL EZH' (ᴣ)
    "\uA730": 'F',
    // LATIN LETTER SMALL CAPITAL F
    "\u0262": 'G',
    // LATIN LETTER SMALL CAPITAL G
    "\u029B": 'G',
    // LATIN LETTER SMALL CAPITAL G WITH HOOK
    "\u029C": 'H',
    // LATIN LETTER SMALL CAPITAL H
    "\u026A": 'I',
    // LATIN LETTER SMALL CAPITAL I
    "\u0281": 'R',
    // LATIN LETTER SMALL CAPITAL INVERTED R
    "\u1D0A": 'J',
    // LATIN LETTER SMALL CAPITAL J
    "\u1D0B": 'K',
    // LATIN LETTER SMALL CAPITAL K
    "\u029F": 'L',
    // LATIN LETTER SMALL CAPITAL L
    "\u1D0C": 'L',
    // LATIN LETTER SMALL CAPITAL L WITH STROKE
    "\u1D0D": 'M',
    // LATIN LETTER SMALL CAPITAL M
    "\u0274": 'N',
    // LATIN LETTER SMALL CAPITAL N
    "\u1D0F": 'O',
    // LATIN LETTER SMALL CAPITAL O
    "\u0276": 'OE',
    // LATIN LETTER SMALL CAPITAL OE
    "\u1D10": 'O',
    // LATIN LETTER SMALL CAPITAL OPEN O
    "\u1D15": 'OU',
    // LATIN LETTER SMALL CAPITAL OU
    "\u1D18": 'P',
    // LATIN LETTER SMALL CAPITAL P
    "\u0280": 'R',
    // LATIN LETTER SMALL CAPITAL R
    "\u1D0E": 'N',
    // LATIN LETTER SMALL CAPITAL REVERSED N
    "\u1D19": 'R',
    // LATIN LETTER SMALL CAPITAL REVERSED R
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER SMALL CAPITAL RUM' (ꝶ)
    "\uA731": 'S',
    // LATIN LETTER SMALL CAPITAL S
    "\u1D1B": 'T',
    // LATIN LETTER SMALL CAPITAL T
    "\u2C7B": 'E',
    // LATIN LETTER SMALL CAPITAL TURNED E
    "\u1D1A": 'R',
    // LATIN LETTER SMALL CAPITAL TURNED R
    "\u1D1C": 'U',
    // LATIN LETTER SMALL CAPITAL U
    "\u1D20": 'V',
    // LATIN LETTER SMALL CAPITAL V
    "\u1D21": 'W',
    // LATIN LETTER SMALL CAPITAL W
    "\u028F": 'Y',
    // LATIN LETTER SMALL CAPITAL Y
    "\u1D22": 'Z',
    // LATIN LETTER SMALL CAPITAL Z
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER STRETCHED C' (ʗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER TWO WITH STROKE' (ƻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER VOICED LARYNGEAL SPIRANT' (ᴤ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER WYNN' (ƿ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN LETTER YR' (Ʀ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER I WITH STROKE' (ᵻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL CAPITAL LETTER U WITH STROKE' (ᵾ)
    "\xe1": 'a',
    // LATIN SMALL LETTER A WITH ACUTE
    "\u0103": 'a',
    // LATIN SMALL LETTER A WITH BREVE
    "\u1EAF": 'a',
    // LATIN SMALL LETTER A WITH BREVE AND ACUTE
    "\u1EB7": 'a',
    // LATIN SMALL LETTER A WITH BREVE AND DOT BELOW
    "\u1EB1": 'a',
    // LATIN SMALL LETTER A WITH BREVE AND GRAVE
    "\u1EB3": 'a',
    // LATIN SMALL LETTER A WITH BREVE AND HOOK ABOVE
    "\u1EB5": 'a',
    // LATIN SMALL LETTER A WITH BREVE AND TILDE
    "\u01CE": 'a',
    // LATIN SMALL LETTER A WITH CARON
    "\xe2": 'a',
    // LATIN SMALL LETTER A WITH CIRCUMFLEX
    "\u1EA5": 'a',
    // LATIN SMALL LETTER A WITH CIRCUMFLEX AND ACUTE
    "\u1EAD": 'a',
    // LATIN SMALL LETTER A WITH CIRCUMFLEX AND DOT BELOW
    "\u1EA7": 'a',
    // LATIN SMALL LETTER A WITH CIRCUMFLEX AND GRAVE
    "\u1EA9": 'a',
    // LATIN SMALL LETTER A WITH CIRCUMFLEX AND HOOK ABOVE
    "\u1EAB": 'a',
    // LATIN SMALL LETTER A WITH CIRCUMFLEX AND TILDE
    "\xe4": 'a',
    // LATIN SMALL LETTER A WITH DIAERESIS
    "\u01DF": 'a',
    // LATIN SMALL LETTER A WITH DIAERESIS AND MACRON
    "\u0227": 'a',
    // LATIN SMALL LETTER A WITH DOT ABOVE
    "\u01E1": 'a',
    // LATIN SMALL LETTER A WITH DOT ABOVE AND MACRON
    "\u1EA1": 'a',
    // LATIN SMALL LETTER A WITH DOT BELOW
    "\u0201": 'a',
    // LATIN SMALL LETTER A WITH DOUBLE GRAVE
    "\xe0": 'a',
    // LATIN SMALL LETTER A WITH GRAVE
    "\u1EA3": 'a',
    // LATIN SMALL LETTER A WITH HOOK ABOVE
    "\u0203": 'a',
    // LATIN SMALL LETTER A WITH INVERTED BREVE
    "\u0101": 'a',
    // LATIN SMALL LETTER A WITH MACRON
    "\u0105": 'a',
    // LATIN SMALL LETTER A WITH OGONEK
    "\u1D8F": 'a',
    // LATIN SMALL LETTER A WITH RETROFLEX HOOK
    "\u1E9A": 'a',
    // LATIN SMALL LETTER A WITH RIGHT HALF RING
    "\xe5": 'a',
    // LATIN SMALL LETTER A WITH RING ABOVE
    "\u01FB": 'a',
    // LATIN SMALL LETTER A WITH RING ABOVE AND ACUTE
    "\u1E01": 'a',
    // LATIN SMALL LETTER A WITH RING BELOW
    "\u2C65": 'a',
    // LATIN SMALL LETTER A WITH STROKE
    "\xe3": 'a',
    // LATIN SMALL LETTER A WITH TILDE
    "\uA733": 'aa',
    // LATIN SMALL LETTER AA
    "\xe6": 'ae',
    // LATIN SMALL LETTER AE
    "\u01FD": 'ae',
    // LATIN SMALL LETTER AE WITH ACUTE
    "\u01E3": 'ae',
    // LATIN SMALL LETTER AE WITH MACRON
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA' (ɑ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ALPHA WITH RETROFLEX HOOK' (ᶐ)
    "\uA735": 'ao',
    // LATIN SMALL LETTER AO
    "\uA737": 'au',
    // LATIN SMALL LETTER AU
    "\uA739": 'av',
    // LATIN SMALL LETTER AV
    "\uA73B": 'av',
    // LATIN SMALL LETTER AV WITH HORIZONTAL BAR
    "\uA73D": 'ay',
    // LATIN SMALL LETTER AY
    "\u1E03": 'b',
    // LATIN SMALL LETTER B WITH DOT ABOVE
    "\u1E05": 'b',
    // LATIN SMALL LETTER B WITH DOT BELOW
    "\u0253": 'b',
    // LATIN SMALL LETTER B WITH HOOK
    "\u1E07": 'b',
    // LATIN SMALL LETTER B WITH LINE BELOW
    "\u1D6C": 'b',
    // LATIN SMALL LETTER B WITH MIDDLE TILDE
    "\u1D80": 'b',
    // LATIN SMALL LETTER B WITH PALATAL HOOK
    "\u0180": 'b',
    // LATIN SMALL LETTER B WITH STROKE
    "\u0183": 'b',
    // LATIN SMALL LETTER B WITH TOPBAR
    "\u0275": 'o',
    // LATIN SMALL LETTER BARRED O
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BOTTOM HALF O' (ᴗ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER BROKEN L' (ꝇ)
    "\u0107": 'c',
    // LATIN SMALL LETTER C WITH ACUTE
    "\u010D": 'c',
    // LATIN SMALL LETTER C WITH CARON
    "\xe7": 'c',
    // LATIN SMALL LETTER C WITH CEDILLA
    "\u1E09": 'c',
    // LATIN SMALL LETTER C WITH CEDILLA AND ACUTE
    "\u0109": 'c',
    // LATIN SMALL LETTER C WITH CIRCUMFLEX
    "\u0255": 'c',
    // LATIN SMALL LETTER C WITH CURL
    "\u010B": 'c',
    // LATIN SMALL LETTER C WITH DOT ABOVE
    "\u0188": 'c',
    // LATIN SMALL LETTER C WITH HOOK
    "\u023C": 'c',
    // LATIN SMALL LETTER C WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OMEGA' (ɷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED OPEN E' (ʚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CLOSED REVERSED OPEN E' (ɞ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CON' (ꝯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO' (ꜭ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER CUATRILLO WITH COMMA' (ꜯ)
    "\u010F": 'd',
    // LATIN SMALL LETTER D WITH CARON
    "\u1E11": 'd',
    // LATIN SMALL LETTER D WITH CEDILLA
    "\u1E13": 'd',
    // LATIN SMALL LETTER D WITH CIRCUMFLEX BELOW
    "\u0221": 'd',
    // LATIN SMALL LETTER D WITH CURL
    "\u1E0B": 'd',
    // LATIN SMALL LETTER D WITH DOT ABOVE
    "\u1E0D": 'd',
    // LATIN SMALL LETTER D WITH DOT BELOW
    "\u0257": 'd',
    // LATIN SMALL LETTER D WITH HOOK
    "\u1D91": 'd',
    // LATIN SMALL LETTER D WITH HOOK AND TAIL
    "\u1E0F": 'd',
    // LATIN SMALL LETTER D WITH LINE BELOW
    "\u1D6D": 'd',
    // LATIN SMALL LETTER D WITH MIDDLE TILDE
    "\u1D81": 'd',
    // LATIN SMALL LETTER D WITH PALATAL HOOK
    "\u0111": 'd',
    // LATIN SMALL LETTER D WITH STROKE
    "\u0256": 'd',
    // LATIN SMALL LETTER D WITH TAIL
    "\u018C": 'd',
    // LATIN SMALL LETTER D WITH TOPBAR
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DB DIGRAPH' (ȸ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DELTA' (ẟ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DEZH DIGRAPH' (ʤ)
    "\u0131": 'i',
    // LATIN SMALL LETTER DOTLESS I
    "\u0237": 'j',
    // LATIN SMALL LETTER DOTLESS J
    "\u025F": 'j',
    // LATIN SMALL LETTER DOTLESS J WITH STROKE
    "\u0284": 'j',
    // LATIN SMALL LETTER DOTLESS J WITH STROKE AND HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DUM' (ꝱ)
    "\u01F3": 'dz',
    // LATIN SMALL LETTER DZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH' (ʣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER DZ DIGRAPH WITH CURL' (ʥ)
    "\u01C6": 'dz',
    // LATIN SMALL LETTER DZ WITH CARON
    "\xe9": 'e',
    // LATIN SMALL LETTER E WITH ACUTE
    "\u0115": 'e',
    // LATIN SMALL LETTER E WITH BREVE
    "\u011B": 'e',
    // LATIN SMALL LETTER E WITH CARON
    "\u0229": 'e',
    // LATIN SMALL LETTER E WITH CEDILLA
    "\u1E1D": 'e',
    // LATIN SMALL LETTER E WITH CEDILLA AND BREVE
    "\xea": 'e',
    // LATIN SMALL LETTER E WITH CIRCUMFLEX
    "\u1EBF": 'e',
    // LATIN SMALL LETTER E WITH CIRCUMFLEX AND ACUTE
    "\u1EC7": 'e',
    // LATIN SMALL LETTER E WITH CIRCUMFLEX AND DOT BELOW
    "\u1EC1": 'e',
    // LATIN SMALL LETTER E WITH CIRCUMFLEX AND GRAVE
    "\u1EC3": 'e',
    // LATIN SMALL LETTER E WITH CIRCUMFLEX AND HOOK ABOVE
    "\u1EC5": 'e',
    // LATIN SMALL LETTER E WITH CIRCUMFLEX AND TILDE
    "\u1E19": 'e',
    // LATIN SMALL LETTER E WITH CIRCUMFLEX BELOW
    "\xeb": 'e',
    // LATIN SMALL LETTER E WITH DIAERESIS
    "\u0117": 'e',
    // LATIN SMALL LETTER E WITH DOT ABOVE
    "\u1EB9": 'e',
    // LATIN SMALL LETTER E WITH DOT BELOW
    "\u0205": 'e',
    // LATIN SMALL LETTER E WITH DOUBLE GRAVE
    "\xe8": 'e',
    // LATIN SMALL LETTER E WITH GRAVE
    "\u1EBB": 'e',
    // LATIN SMALL LETTER E WITH HOOK ABOVE
    "\u0207": 'e',
    // LATIN SMALL LETTER E WITH INVERTED BREVE
    "\u0113": 'e',
    // LATIN SMALL LETTER E WITH MACRON
    "\u1E17": 'e',
    // LATIN SMALL LETTER E WITH MACRON AND ACUTE
    "\u1E15": 'e',
    // LATIN SMALL LETTER E WITH MACRON AND GRAVE
    "\u2C78": 'e',
    // LATIN SMALL LETTER E WITH NOTCH
    "\u0119": 'e',
    // LATIN SMALL LETTER E WITH OGONEK
    "\u1D92": 'e',
    // LATIN SMALL LETTER E WITH RETROFLEX HOOK
    "\u0247": 'e',
    // LATIN SMALL LETTER E WITH STROKE
    "\u1EBD": 'e',
    // LATIN SMALL LETTER E WITH TILDE
    "\u1E1B": 'e',
    // LATIN SMALL LETTER E WITH TILDE BELOW
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL AIN' (ꜥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EGYPTOLOGICAL ALEF' (ꜣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ENG' (ŋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH' (ʃ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH CURL' (ʆ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH PALATAL HOOK' (ᶋ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ESH WITH RETROFLEX HOOK' (ᶘ)
    "\uA76B": 'et',
    // LATIN SMALL LETTER ET
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER ETH' (ð)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH' (ʒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH REVERSED' (ƹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CARON' (ǯ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH CURL' (ʓ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH RETROFLEX HOOK' (ᶚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER EZH WITH TAIL' (ƺ)
    "\u1E1F": 'f',
    // LATIN SMALL LETTER F WITH DOT ABOVE
    "\u0192": 'f',
    // LATIN SMALL LETTER F WITH HOOK
    "\u1D6E": 'f',
    // LATIN SMALL LETTER F WITH MIDDLE TILDE
    "\u1D82": 'f',
    // LATIN SMALL LETTER F WITH PALATAL HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER FENG DIGRAPH' (ʩ)
    "\u01F5": 'g',
    // LATIN SMALL LETTER G WITH ACUTE
    "\u011F": 'g',
    // LATIN SMALL LETTER G WITH BREVE
    "\u01E7": 'g',
    // LATIN SMALL LETTER G WITH CARON
    "\u0123": 'g',
    // LATIN SMALL LETTER G WITH CEDILLA
    "\u011D": 'g',
    // LATIN SMALL LETTER G WITH CIRCUMFLEX
    "\u0121": 'g',
    // LATIN SMALL LETTER G WITH DOT ABOVE
    "\u0260": 'g',
    // LATIN SMALL LETTER G WITH HOOK
    "\u1E21": 'g',
    // LATIN SMALL LETTER G WITH MACRON
    "\u1D83": 'g',
    // LATIN SMALL LETTER G WITH PALATAL HOOK
    "\u01E5": 'g',
    // LATIN SMALL LETTER G WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GAMMA' (ɣ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER GLOTTAL STOP' (ɂ)
    "\u1E2B": 'h',
    // LATIN SMALL LETTER H WITH BREVE BELOW
    "\u021F": 'h',
    // LATIN SMALL LETTER H WITH CARON
    "\u1E29": 'h',
    // LATIN SMALL LETTER H WITH CEDILLA
    "\u0125": 'h',
    // LATIN SMALL LETTER H WITH CIRCUMFLEX
    "\u2C68": 'h',
    // LATIN SMALL LETTER H WITH DESCENDER
    "\u1E27": 'h',
    // LATIN SMALL LETTER H WITH DIAERESIS
    "\u1E23": 'h',
    // LATIN SMALL LETTER H WITH DOT ABOVE
    "\u1E25": 'h',
    // LATIN SMALL LETTER H WITH DOT BELOW
    "\u0266": 'h',
    // LATIN SMALL LETTER H WITH HOOK
    "\u1E96": 'h',
    // LATIN SMALL LETTER H WITH LINE BELOW
    "\u0127": 'h',
    // LATIN SMALL LETTER H WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HALF H' (ⱶ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG' (ꜧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER HENG WITH HOOK' (ɧ)
    "\u0195": 'hv',
    // LATIN SMALL LETTER HV
    "\xed": 'i',
    // LATIN SMALL LETTER I WITH ACUTE
    "\u012D": 'i',
    // LATIN SMALL LETTER I WITH BREVE
    "\u01D0": 'i',
    // LATIN SMALL LETTER I WITH CARON
    "\xee": 'i',
    // LATIN SMALL LETTER I WITH CIRCUMFLEX
    "\xef": 'i',
    // LATIN SMALL LETTER I WITH DIAERESIS
    "\u1E2F": 'i',
    // LATIN SMALL LETTER I WITH DIAERESIS AND ACUTE
    "\u1ECB": 'i',
    // LATIN SMALL LETTER I WITH DOT BELOW
    "\u0209": 'i',
    // LATIN SMALL LETTER I WITH DOUBLE GRAVE
    "\xec": 'i',
    // LATIN SMALL LETTER I WITH GRAVE
    "\u1EC9": 'i',
    // LATIN SMALL LETTER I WITH HOOK ABOVE
    "\u020B": 'i',
    // LATIN SMALL LETTER I WITH INVERTED BREVE
    "\u012B": 'i',
    // LATIN SMALL LETTER I WITH MACRON
    "\u012F": 'i',
    // LATIN SMALL LETTER I WITH OGONEK
    "\u1D96": 'i',
    // LATIN SMALL LETTER I WITH RETROFLEX HOOK
    "\u0268": 'i',
    // LATIN SMALL LETTER I WITH STROKE
    "\u0129": 'i',
    // LATIN SMALL LETTER I WITH TILDE
    "\u1E2D": 'i',
    // LATIN SMALL LETTER I WITH TILDE BELOW
    "\uA77A": 'd',
    // LATIN SMALL LETTER INSULAR D
    "\uA77C": 'f',
    // LATIN SMALL LETTER INSULAR F
    "\u1D79": 'g',
    // LATIN SMALL LETTER INSULAR G
    "\uA783": 'r',
    // LATIN SMALL LETTER INSULAR R
    "\uA785": 's',
    // LATIN SMALL LETTER INSULAR S
    "\uA787": 't',
    // LATIN SMALL LETTER INSULAR T
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA' (ɩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER IOTA WITH STROKE' (ᵼ)
    "\uA76D": 'is',
    // LATIN SMALL LETTER IS
    "\u01F0": 'j',
    // LATIN SMALL LETTER J WITH CARON
    "\u0135": 'j',
    // LATIN SMALL LETTER J WITH CIRCUMFLEX
    "\u029D": 'j',
    // LATIN SMALL LETTER J WITH CROSSED-TAIL
    "\u0249": 'j',
    // LATIN SMALL LETTER J WITH STROKE
    "\u1E31": 'k',
    // LATIN SMALL LETTER K WITH ACUTE
    "\u01E9": 'k',
    // LATIN SMALL LETTER K WITH CARON
    "\u0137": 'k',
    // LATIN SMALL LETTER K WITH CEDILLA
    "\u2C6A": 'k',
    // LATIN SMALL LETTER K WITH DESCENDER
    "\uA743": 'k',
    // LATIN SMALL LETTER K WITH DIAGONAL STROKE
    "\u1E33": 'k',
    // LATIN SMALL LETTER K WITH DOT BELOW
    "\u0199": 'k',
    // LATIN SMALL LETTER K WITH HOOK
    "\u1E35": 'k',
    // LATIN SMALL LETTER K WITH LINE BELOW
    "\u1D84": 'k',
    // LATIN SMALL LETTER K WITH PALATAL HOOK
    "\uA741": 'k',
    // LATIN SMALL LETTER K WITH STROKE
    "\uA745": 'k',
    // LATIN SMALL LETTER K WITH STROKE AND DIAGONAL STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER KRA' (ĸ)
    "\u013A": 'l',
    // LATIN SMALL LETTER L WITH ACUTE
    "\u019A": 'l',
    // LATIN SMALL LETTER L WITH BAR
    "\u026C": 'l',
    // LATIN SMALL LETTER L WITH BELT
    "\u013E": 'l',
    // LATIN SMALL LETTER L WITH CARON
    "\u013C": 'l',
    // LATIN SMALL LETTER L WITH CEDILLA
    "\u1E3D": 'l',
    // LATIN SMALL LETTER L WITH CIRCUMFLEX BELOW
    "\u0234": 'l',
    // LATIN SMALL LETTER L WITH CURL
    "\u1E37": 'l',
    // LATIN SMALL LETTER L WITH DOT BELOW
    "\u1E39": 'l',
    // LATIN SMALL LETTER L WITH DOT BELOW AND MACRON
    "\u2C61": 'l',
    // LATIN SMALL LETTER L WITH DOUBLE BAR
    "\uA749": 'l',
    // LATIN SMALL LETTER L WITH HIGH STROKE
    "\u1E3B": 'l',
    // LATIN SMALL LETTER L WITH LINE BELOW
    "\u0140": 'l',
    // LATIN SMALL LETTER L WITH MIDDLE DOT
    "\u026B": 'l',
    // LATIN SMALL LETTER L WITH MIDDLE TILDE
    "\u1D85": 'l',
    // LATIN SMALL LETTER L WITH PALATAL HOOK
    "\u026D": 'l',
    // LATIN SMALL LETTER L WITH RETROFLEX HOOK
    "\u0142": 'l',
    // LATIN SMALL LETTER L WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LAMBDA WITH STROKE' (ƛ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LEZH' (ɮ)
    "\u01C9": 'lj',
    // LATIN SMALL LETTER LJ
    "\u017F": 's',
    // LATIN SMALL LETTER LONG S
    "\u1E9C": 's',
    // LATIN SMALL LETTER LONG S WITH DIAGONAL STROKE
    "\u1E9B": 's',
    // LATIN SMALL LETTER LONG S WITH DOT ABOVE
    "\u1E9D": 's',
    // LATIN SMALL LETTER LONG S WITH HIGH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LS DIGRAPH' (ʪ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LUM' (ꝲ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER LZ DIGRAPH' (ʫ)
    "\u1E3F": 'm',
    // LATIN SMALL LETTER M WITH ACUTE
    "\u1E41": 'm',
    // LATIN SMALL LETTER M WITH DOT ABOVE
    "\u1E43": 'm',
    // LATIN SMALL LETTER M WITH DOT BELOW
    "\u0271": 'm',
    // LATIN SMALL LETTER M WITH HOOK
    "\u1D6F": 'm',
    // LATIN SMALL LETTER M WITH MIDDLE TILDE
    "\u1D86": 'm',
    // LATIN SMALL LETTER M WITH PALATAL HOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH LL' (ỻ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MIDDLE-WELSH V' (ỽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER MUM' (ꝳ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER N PRECEDED BY APOSTROPHE' (ŉ)
    "\u0144": 'n',
    // LATIN SMALL LETTER N WITH ACUTE
    "\u0148": 'n',
    // LATIN SMALL LETTER N WITH CARON
    "\u0146": 'n',
    // LATIN SMALL LETTER N WITH CEDILLA
    "\u1E4B": 'n',
    // LATIN SMALL LETTER N WITH CIRCUMFLEX BELOW
    "\u0235": 'n',
    // LATIN SMALL LETTER N WITH CURL
    "\u1E45": 'n',
    // LATIN SMALL LETTER N WITH DOT ABOVE
    "\u1E47": 'n',
    // LATIN SMALL LETTER N WITH DOT BELOW
    "\u01F9": 'n',
    // LATIN SMALL LETTER N WITH GRAVE
    "\u0272": 'n',
    // LATIN SMALL LETTER N WITH LEFT HOOK
    "\u1E49": 'n',
    // LATIN SMALL LETTER N WITH LINE BELOW
    "\u019E": 'n',
    // LATIN SMALL LETTER N WITH LONG RIGHT LEG
    "\u1D70": 'n',
    // LATIN SMALL LETTER N WITH MIDDLE TILDE
    "\u1D87": 'n',
    // LATIN SMALL LETTER N WITH PALATAL HOOK
    "\u0273": 'n',
    // LATIN SMALL LETTER N WITH RETROFLEX HOOK
    "\xf1": 'n',
    // LATIN SMALL LETTER N WITH TILDE
    "\u01CC": 'nj',
    // LATIN SMALL LETTER NJ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER NUM' (ꝴ)
    "\xf3": 'o',
    // LATIN SMALL LETTER O WITH ACUTE
    "\u014F": 'o',
    // LATIN SMALL LETTER O WITH BREVE
    "\u01D2": 'o',
    // LATIN SMALL LETTER O WITH CARON
    "\xf4": 'o',
    // LATIN SMALL LETTER O WITH CIRCUMFLEX
    "\u1ED1": 'o',
    // LATIN SMALL LETTER O WITH CIRCUMFLEX AND ACUTE
    "\u1ED9": 'o',
    // LATIN SMALL LETTER O WITH CIRCUMFLEX AND DOT BELOW
    "\u1ED3": 'o',
    // LATIN SMALL LETTER O WITH CIRCUMFLEX AND GRAVE
    "\u1ED5": 'o',
    // LATIN SMALL LETTER O WITH CIRCUMFLEX AND HOOK ABOVE
    "\u1ED7": 'o',
    // LATIN SMALL LETTER O WITH CIRCUMFLEX AND TILDE
    "\xf6": 'o',
    // LATIN SMALL LETTER O WITH DIAERESIS
    "\u022B": 'o',
    // LATIN SMALL LETTER O WITH DIAERESIS AND MACRON
    "\u022F": 'o',
    // LATIN SMALL LETTER O WITH DOT ABOVE
    "\u0231": 'o',
    // LATIN SMALL LETTER O WITH DOT ABOVE AND MACRON
    "\u1ECD": 'o',
    // LATIN SMALL LETTER O WITH DOT BELOW
    "\u0151": 'o',
    // LATIN SMALL LETTER O WITH DOUBLE ACUTE
    "\u020D": 'o',
    // LATIN SMALL LETTER O WITH DOUBLE GRAVE
    "\xf2": 'o',
    // LATIN SMALL LETTER O WITH GRAVE
    "\u1ECF": 'o',
    // LATIN SMALL LETTER O WITH HOOK ABOVE
    "\u01A1": 'o',
    // LATIN SMALL LETTER O WITH HORN
    "\u1EDB": 'o',
    // LATIN SMALL LETTER O WITH HORN AND ACUTE
    "\u1EE3": 'o',
    // LATIN SMALL LETTER O WITH HORN AND DOT BELOW
    "\u1EDD": 'o',
    // LATIN SMALL LETTER O WITH HORN AND GRAVE
    "\u1EDF": 'o',
    // LATIN SMALL LETTER O WITH HORN AND HOOK ABOVE
    "\u1EE1": 'o',
    // LATIN SMALL LETTER O WITH HORN AND TILDE
    "\u020F": 'o',
    // LATIN SMALL LETTER O WITH INVERTED BREVE
    "\uA74B": 'o',
    // LATIN SMALL LETTER O WITH LONG STROKE OVERLAY
    "\uA74D": 'o',
    // LATIN SMALL LETTER O WITH LOOP
    "\u2C7A": 'o',
    // LATIN SMALL LETTER O WITH LOW RING INSIDE
    "\u014D": 'o',
    // LATIN SMALL LETTER O WITH MACRON
    "\u1E53": 'o',
    // LATIN SMALL LETTER O WITH MACRON AND ACUTE
    "\u1E51": 'o',
    // LATIN SMALL LETTER O WITH MACRON AND GRAVE
    "\u01EB": 'o',
    // LATIN SMALL LETTER O WITH OGONEK
    "\u01ED": 'o',
    // LATIN SMALL LETTER O WITH OGONEK AND MACRON
    "\xf8": 'o',
    // LATIN SMALL LETTER O WITH STROKE
    "\u01FF": 'o',
    // LATIN SMALL LETTER O WITH STROKE AND ACUTE
    "\xf5": 'o',
    // LATIN SMALL LETTER O WITH TILDE
    "\u1E4D": 'o',
    // LATIN SMALL LETTER O WITH TILDE AND ACUTE
    "\u1E4F": 'o',
    // LATIN SMALL LETTER O WITH TILDE AND DIAERESIS
    "\u022D": 'o',
    // LATIN SMALL LETTER O WITH TILDE AND MACRON
    "\u01A3": 'oi',
    // LATIN SMALL LETTER OI
    "\uA74F": 'oo',
    // LATIN SMALL LETTER OO
    "\u025B": 'e',
    // LATIN SMALL LETTER OPEN E
    "\u1D93": 'e',
    // LATIN SMALL LETTER OPEN E WITH RETROFLEX HOOK
    "\u0254": 'o',
    // LATIN SMALL LETTER OPEN O
    "\u1D97": 'o',
    // LATIN SMALL LETTER OPEN O WITH RETROFLEX HOOK
    "\u0223": 'ou',
    // LATIN SMALL LETTER OU
    "\u1E55": 'p',
    // LATIN SMALL LETTER P WITH ACUTE
    "\u1E57": 'p',
    // LATIN SMALL LETTER P WITH DOT ABOVE
    "\uA753": 'p',
    // LATIN SMALL LETTER P WITH FLOURISH
    "\u01A5": 'p',
    // LATIN SMALL LETTER P WITH HOOK
    "\u1D71": 'p',
    // LATIN SMALL LETTER P WITH MIDDLE TILDE
    "\u1D88": 'p',
    // LATIN SMALL LETTER P WITH PALATAL HOOK
    "\uA755": 'p',
    // LATIN SMALL LETTER P WITH SQUIRREL TAIL
    "\u1D7D": 'p',
    // LATIN SMALL LETTER P WITH STROKE
    "\uA751": 'p',
    // LATIN SMALL LETTER P WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER PHI' (ɸ)
    "\uA759": 'q',
    // LATIN SMALL LETTER Q WITH DIAGONAL STROKE
    "\u02A0": 'q',
    // LATIN SMALL LETTER Q WITH HOOK
    "\u024B": 'q',
    // LATIN SMALL LETTER Q WITH HOOK TAIL
    "\uA757": 'q',
    // LATIN SMALL LETTER Q WITH STROKE THROUGH DESCENDER
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER QP DIGRAPH' (ȹ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER R ROTUNDA' (ꝛ)
    "\u0155": 'r',
    // LATIN SMALL LETTER R WITH ACUTE
    "\u0159": 'r',
    // LATIN SMALL LETTER R WITH CARON
    "\u0157": 'r',
    // LATIN SMALL LETTER R WITH CEDILLA
    "\u1E59": 'r',
    // LATIN SMALL LETTER R WITH DOT ABOVE
    "\u1E5B": 'r',
    // LATIN SMALL LETTER R WITH DOT BELOW
    "\u1E5D": 'r',
    // LATIN SMALL LETTER R WITH DOT BELOW AND MACRON
    "\u0211": 'r',
    // LATIN SMALL LETTER R WITH DOUBLE GRAVE
    "\u027E": 'r',
    // LATIN SMALL LETTER R WITH FISHHOOK
    "\u1D73": 'r',
    // LATIN SMALL LETTER R WITH FISHHOOK AND MIDDLE TILDE
    "\u0213": 'r',
    // LATIN SMALL LETTER R WITH INVERTED BREVE
    "\u1E5F": 'r',
    // LATIN SMALL LETTER R WITH LINE BELOW
    "\u027C": 'r',
    // LATIN SMALL LETTER R WITH LONG LEG
    "\u1D72": 'r',
    // LATIN SMALL LETTER R WITH MIDDLE TILDE
    "\u1D89": 'r',
    // LATIN SMALL LETTER R WITH PALATAL HOOK
    "\u024D": 'r',
    // LATIN SMALL LETTER R WITH STROKE
    "\u027D": 'r',
    // LATIN SMALL LETTER R WITH TAIL
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RAMS HORN' (ɤ)
    "\u2184": 'c',
    // LATIN SMALL LETTER REVERSED C
    "\uA73F": 'c',
    // LATIN SMALL LETTER REVERSED C WITH DOT
    "\u0258": 'e',
    // LATIN SMALL LETTER REVERSED E
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E' (ɜ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH HOOK' (ɝ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER REVERSED OPEN E WITH RETROFLEX HOOK' (ᶔ)
    "\u027F": 'r',
    // LATIN SMALL LETTER REVERSED R WITH FISHHOOK
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM' (ꝵ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER RUM ROTUNDA' (ꝝ)
    "\u015B": 's',
    // LATIN SMALL LETTER S WITH ACUTE
    "\u1E65": 's',
    // LATIN SMALL LETTER S WITH ACUTE AND DOT ABOVE
    "\u0161": 's',
    // LATIN SMALL LETTER S WITH CARON
    "\u1E67": 's',
    // LATIN SMALL LETTER S WITH CARON AND DOT ABOVE
    "\u015F": 's',
    // LATIN SMALL LETTER S WITH CEDILLA
    "\u015D": 's',
    // LATIN SMALL LETTER S WITH CIRCUMFLEX
    "\u0219": 's',
    // LATIN SMALL LETTER S WITH COMMA BELOW
    "\u1E61": 's',
    // LATIN SMALL LETTER S WITH DOT ABOVE
    "\u1E63": 's',
    // LATIN SMALL LETTER S WITH DOT BELOW
    "\u1E69": 's',
    // LATIN SMALL LETTER S WITH DOT BELOW AND DOT ABOVE
    "\u0282": 's',
    // LATIN SMALL LETTER S WITH HOOK
    "\u1D74": 's',
    // LATIN SMALL LETTER S WITH MIDDLE TILDE
    "\u1D8A": 's',
    // LATIN SMALL LETTER S WITH PALATAL HOOK
    "\u023F": 's',
    // LATIN SMALL LETTER S WITH SWASH TAIL
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SALTILLO' (ꞌ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA' (ə)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH HOOK' (ɚ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SCHWA WITH RETROFLEX HOOK' (ᶕ)
    "\u0261": 'g',
    // LATIN SMALL LETTER SCRIPT G
    "\xdf": 'ss',
    // LATIN SMALL LETTER SHARP S
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS DIAERESIZED U' (ᴞ)
    "\u1D11": 'o',
    // LATIN SMALL LETTER SIDEWAYS O
    "\u1D13": 'o',
    // LATIN SMALL LETTER SIDEWAYS O WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS OPEN O' (ᴒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SIDEWAYS TURNED M' (ᴟ)
    "\u1D1D": 'u',
    // LATIN SMALL LETTER SIDEWAYS U
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER SQUAT REVERSED ESH' (ʅ)
    "\u0165": 't',
    // LATIN SMALL LETTER T WITH CARON
    "\u0163": 't',
    // LATIN SMALL LETTER T WITH CEDILLA
    "\u1E71": 't',
    // LATIN SMALL LETTER T WITH CIRCUMFLEX BELOW
    "\u021B": 't',
    // LATIN SMALL LETTER T WITH COMMA BELOW
    "\u0236": 't',
    // LATIN SMALL LETTER T WITH CURL
    "\u1E97": 't',
    // LATIN SMALL LETTER T WITH DIAERESIS
    "\u2C66": 't',
    // LATIN SMALL LETTER T WITH DIAGONAL STROKE
    "\u1E6B": 't',
    // LATIN SMALL LETTER T WITH DOT ABOVE
    "\u1E6D": 't',
    // LATIN SMALL LETTER T WITH DOT BELOW
    "\u01AD": 't',
    // LATIN SMALL LETTER T WITH HOOK
    "\u1E6F": 't',
    // LATIN SMALL LETTER T WITH LINE BELOW
    "\u1D75": 't',
    // LATIN SMALL LETTER T WITH MIDDLE TILDE
    "\u01AB": 't',
    // LATIN SMALL LETTER T WITH PALATAL HOOK
    "\u0288": 't',
    // LATIN SMALL LETTER T WITH RETROFLEX HOOK
    "\u0167": 't',
    // LATIN SMALL LETTER T WITH STROKE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TAILLESS PHI' (ⱷ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TC DIGRAPH WITH CURL' (ʨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TESH DIGRAPH' (ʧ)
    "\u1D7A": 'th',
    // LATIN SMALL LETTER TH WITH STRIKETHROUGH
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN' (þ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE' (ꝥ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER THORN WITH STROKE THROUGH DESCENDER' (ꝧ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE FIVE' (ƽ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE SIX' (ƅ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TONE TWO' (ƨ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TOP HALF O' (ᴖ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TRESILLO' (ꜫ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TS DIGRAPH' (ʦ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TUM' (ꝷ)
    "\u0250": 'a',
    // LATIN SMALL LETTER TURNED A
    "\u1D02": 'ae',
    // LATIN SMALL LETTER TURNED AE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED ALPHA' (ɒ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED DELTA' (ƍ)
    "\u01DD": 'e',
    // LATIN SMALL LETTER TURNED E
    "\u1D77": 'g',
    // LATIN SMALL LETTER TURNED G
    "\u0265": 'h',
    // LATIN SMALL LETTER TURNED H
    "\u02AE": 'h',
    // LATIN SMALL LETTER TURNED H WITH FISHHOOK
    "\u02AF": 'h',
    // LATIN SMALL LETTER TURNED H WITH FISHHOOK AND TAIL
    "\u1D09": 'i',
    // LATIN SMALL LETTER TURNED I
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED INSULAR G' (ꝿ)
    "\u029E": 'k',
    // LATIN SMALL LETTER TURNED K
    "\uA781": 'l',
    // LATIN SMALL LETTER TURNED L
    "\u026F": 'm',
    // LATIN SMALL LETTER TURNED M
    "\u0270": 'm',
    // LATIN SMALL LETTER TURNED M WITH LONG LEG
    "\u1D14": 'oe',
    // LATIN SMALL LETTER TURNED OE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER TURNED OPEN E' (ᴈ)
    "\u0279": 'r',
    // LATIN SMALL LETTER TURNED R
    "\u027B": 'r',
    // LATIN SMALL LETTER TURNED R WITH HOOK
    "\u027A": 'r',
    // LATIN SMALL LETTER TURNED R WITH LONG LEG
    "\u2C79": 'r',
    // LATIN SMALL LETTER TURNED R WITH TAIL
    "\u0287": 't',
    // LATIN SMALL LETTER TURNED T
    "\u028C": 'v',
    // LATIN SMALL LETTER TURNED V
    "\u028D": 'w',
    // LATIN SMALL LETTER TURNED W
    "\u028E": 'y',
    // LATIN SMALL LETTER TURNED Y
    "\uA729": 'tz',
    // LATIN SMALL LETTER TZ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER U BAR' (ʉ)
    "\xfa": 'u',
    // LATIN SMALL LETTER U WITH ACUTE
    "\u016D": 'u',
    // LATIN SMALL LETTER U WITH BREVE
    "\u01D4": 'u',
    // LATIN SMALL LETTER U WITH CARON
    "\xfb": 'u',
    // LATIN SMALL LETTER U WITH CIRCUMFLEX
    "\u1E77": 'u',
    // LATIN SMALL LETTER U WITH CIRCUMFLEX BELOW
    "\xfc": 'u',
    // LATIN SMALL LETTER U WITH DIAERESIS
    "\u01D8": 'u',
    // LATIN SMALL LETTER U WITH DIAERESIS AND ACUTE
    "\u01DA": 'u',
    // LATIN SMALL LETTER U WITH DIAERESIS AND CARON
    "\u01DC": 'u',
    // LATIN SMALL LETTER U WITH DIAERESIS AND GRAVE
    "\u01D6": 'u',
    // LATIN SMALL LETTER U WITH DIAERESIS AND MACRON
    "\u1E73": 'u',
    // LATIN SMALL LETTER U WITH DIAERESIS BELOW
    "\u1EE5": 'u',
    // LATIN SMALL LETTER U WITH DOT BELOW
    "\u0171": 'u',
    // LATIN SMALL LETTER U WITH DOUBLE ACUTE
    "\u0215": 'u',
    // LATIN SMALL LETTER U WITH DOUBLE GRAVE
    "\xf9": 'u',
    // LATIN SMALL LETTER U WITH GRAVE
    "\u1EE7": 'u',
    // LATIN SMALL LETTER U WITH HOOK ABOVE
    "\u01B0": 'u',
    // LATIN SMALL LETTER U WITH HORN
    "\u1EE9": 'u',
    // LATIN SMALL LETTER U WITH HORN AND ACUTE
    "\u1EF1": 'u',
    // LATIN SMALL LETTER U WITH HORN AND DOT BELOW
    "\u1EEB": 'u',
    // LATIN SMALL LETTER U WITH HORN AND GRAVE
    "\u1EED": 'u',
    // LATIN SMALL LETTER U WITH HORN AND HOOK ABOVE
    "\u1EEF": 'u',
    // LATIN SMALL LETTER U WITH HORN AND TILDE
    "\u0217": 'u',
    // LATIN SMALL LETTER U WITH INVERTED BREVE
    "\u016B": 'u',
    // LATIN SMALL LETTER U WITH MACRON
    "\u1E7B": 'u',
    // LATIN SMALL LETTER U WITH MACRON AND DIAERESIS
    "\u0173": 'u',
    // LATIN SMALL LETTER U WITH OGONEK
    "\u1D99": 'u',
    // LATIN SMALL LETTER U WITH RETROFLEX HOOK
    "\u016F": 'u',
    // LATIN SMALL LETTER U WITH RING ABOVE
    "\u0169": 'u',
    // LATIN SMALL LETTER U WITH TILDE
    "\u1E79": 'u',
    // LATIN SMALL LETTER U WITH TILDE AND ACUTE
    "\u1E75": 'u',
    // LATIN SMALL LETTER U WITH TILDE BELOW
    "\u1D6B": 'ue',
    // LATIN SMALL LETTER UE
    "\uA778": 'um',
    // LATIN SMALL LETTER UM
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON' (ʊ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER UPSILON WITH STROKE' (ᵿ)
    "\u2C74": 'v',
    // LATIN SMALL LETTER V WITH CURL
    "\uA75F": 'v',
    // LATIN SMALL LETTER V WITH DIAGONAL STROKE
    "\u1E7F": 'v',
    // LATIN SMALL LETTER V WITH DOT BELOW
    "\u028B": 'v',
    // LATIN SMALL LETTER V WITH HOOK
    "\u1D8C": 'v',
    // LATIN SMALL LETTER V WITH PALATAL HOOK
    "\u2C71": 'v',
    // LATIN SMALL LETTER V WITH RIGHT HOOK
    "\u1E7D": 'v',
    // LATIN SMALL LETTER V WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VEND' (ꝩ)
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER VISIGOTHIC Z' (ꝣ)
    "\uA761": 'vy',
    // LATIN SMALL LETTER VY
    "\u1E83": 'w',
    // LATIN SMALL LETTER W WITH ACUTE
    "\u0175": 'w',
    // LATIN SMALL LETTER W WITH CIRCUMFLEX
    "\u1E85": 'w',
    // LATIN SMALL LETTER W WITH DIAERESIS
    "\u1E87": 'w',
    // LATIN SMALL LETTER W WITH DOT ABOVE
    "\u1E89": 'w',
    // LATIN SMALL LETTER W WITH DOT BELOW
    "\u1E81": 'w',
    // LATIN SMALL LETTER W WITH GRAVE
    "\u2C73": 'w',
    // LATIN SMALL LETTER W WITH HOOK
    "\u1E98": 'w',
    // LATIN SMALL LETTER W WITH RING ABOVE
    "\u1E8D": 'x',
    // LATIN SMALL LETTER X WITH DIAERESIS
    "\u1E8B": 'x',
    // LATIN SMALL LETTER X WITH DOT ABOVE
    "\u1D8D": 'x',
    // LATIN SMALL LETTER X WITH PALATAL HOOK
    "\xfd": 'y',
    // LATIN SMALL LETTER Y WITH ACUTE
    "\u0177": 'y',
    // LATIN SMALL LETTER Y WITH CIRCUMFLEX
    "\xff": 'y',
    // LATIN SMALL LETTER Y WITH DIAERESIS
    "\u1E8F": 'y',
    // LATIN SMALL LETTER Y WITH DOT ABOVE
    "\u1EF5": 'y',
    // LATIN SMALL LETTER Y WITH DOT BELOW
    "\u1EF3": 'y',
    // LATIN SMALL LETTER Y WITH GRAVE
    "\u01B4": 'y',
    // LATIN SMALL LETTER Y WITH HOOK
    "\u1EF7": 'y',
    // LATIN SMALL LETTER Y WITH HOOK ABOVE
    "\u1EFF": 'y',
    // LATIN SMALL LETTER Y WITH LOOP
    "\u0233": 'y',
    // LATIN SMALL LETTER Y WITH MACRON
    "\u1E99": 'y',
    // LATIN SMALL LETTER Y WITH RING ABOVE
    "\u024F": 'y',
    // LATIN SMALL LETTER Y WITH STROKE
    "\u1EF9": 'y',
    // LATIN SMALL LETTER Y WITH TILDE
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LETTER YOGH' (ȝ)
    "\u017A": 'z',
    // LATIN SMALL LETTER Z WITH ACUTE
    "\u017E": 'z',
    // LATIN SMALL LETTER Z WITH CARON
    "\u1E91": 'z',
    // LATIN SMALL LETTER Z WITH CIRCUMFLEX
    "\u0291": 'z',
    // LATIN SMALL LETTER Z WITH CURL
    "\u2C6C": 'z',
    // LATIN SMALL LETTER Z WITH DESCENDER
    "\u017C": 'z',
    // LATIN SMALL LETTER Z WITH DOT ABOVE
    "\u1E93": 'z',
    // LATIN SMALL LETTER Z WITH DOT BELOW
    "\u0225": 'z',
    // LATIN SMALL LETTER Z WITH HOOK
    "\u1E95": 'z',
    // LATIN SMALL LETTER Z WITH LINE BELOW
    "\u1D76": 'z',
    // LATIN SMALL LETTER Z WITH MIDDLE TILDE
    "\u1D8E": 'z',
    // LATIN SMALL LETTER Z WITH PALATAL HOOK
    "\u0290": 'z',
    // LATIN SMALL LETTER Z WITH RETROFLEX HOOK
    "\u01B6": 'z',
    // LATIN SMALL LETTER Z WITH STROKE
    "\u0240": 'z',
    // LATIN SMALL LETTER Z WITH SWASH TAIL
    "\uFB00": 'ff',
    // LATIN SMALL LIGATURE FF
    "\uFB03": 'ffi',
    // LATIN SMALL LIGATURE FFI
    "\uFB04": 'ffl',
    // LATIN SMALL LIGATURE FFL
    "\uFB01": 'fi',
    // LATIN SMALL LIGATURE FI
    "\uFB02": 'fl',
    // LATIN SMALL LIGATURE FL
    "\u0133": 'ij',
    // LATIN SMALL LIGATURE IJ
    // CANNOT FIND APPROXIMATION FOR 'LATIN SMALL LIGATURE LONG S T' (ﬅ)
    "\u0153": 'oe',
    // LATIN SMALL LIGATURE OE
    "\uFB06": 'st',
    // LATIN SMALL LIGATURE ST
    "\u2090": 'a',
    // LATIN SUBSCRIPT SMALL LETTER A
    "\u2091": 'e',
    // LATIN SUBSCRIPT SMALL LETTER E
    "\u1D62": 'i',
    // LATIN SUBSCRIPT SMALL LETTER I
    "\u2C7C": 'j',
    // LATIN SUBSCRIPT SMALL LETTER J
    "\u2092": 'o',
    // LATIN SUBSCRIPT SMALL LETTER O
    "\u1D63": 'r',
    // LATIN SUBSCRIPT SMALL LETTER R
    // CANNOT FIND APPROXIMATION FOR 'LATIN SUBSCRIPT SMALL LETTER SCHWA' (ₔ)
    "\u1D64": 'u',
    // LATIN SUBSCRIPT SMALL LETTER U
    "\u1D65": 'v',
    // LATIN SUBSCRIPT SMALL LETTER V
    "\u2093": 'x' // LATIN SUBSCRIPT SMALL LETTER X
};
function latinise(str) {
    return str.replace(/[^A-Za-z0-9\[\] ]/g, (x)=>Latinise.latin_map[x] || x);
}
function isLatin(str) {
    return str == latinise(str);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kQL9D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assessment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _assessmentHeader = require("./assessment-header");
var _assessmentHeaderDefault = parcelHelpers.interopDefault(_assessmentHeader);
var _assessmentProperties = require("./AssessmentProperties");
var _assessmentPropertiesDefault = parcelHelpers.interopDefault(_assessmentProperties);
var _assessmentSections = require("./assessment-sections");
var _assessmentSectionsDefault = parcelHelpers.interopDefault(_assessmentSections);
var _assessmentSection = require("./assessment-section");
var _assessmentSectionDefault = parcelHelpers.interopDefault(_assessmentSection);
var _assessmentQuestion = require("./assessment-question");
var _assessmentQuestionDefault = parcelHelpers.interopDefault(_assessmentQuestion);
var _assessmentStandards = require("components/quiz/components/assessment-standards");
var _assessmentStandardsDefault = parcelHelpers.interopDefault(_assessmentStandards);
var _standardsSearch = require("teacher/components/standards-search");
var _standardsSearchDefault = parcelHelpers.interopDefault(_standardsSearch);
var _fullScreenDialog = require("components/FullScreenDialog");
var _fullScreenDialogDefault = parcelHelpers.interopDefault(_fullScreenDialog);
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflow: 'hidden',
            padding: '15px 10px'
        },
        content: {
            display: 'flex',
            overflowY: 'hidden',
            flexGrow: 1
        },
        left: {
            display: 'flex',
            flexShrink: 0
        },
        right: {
            flexGrow: 1,
            display: 'flex',
            marginLeft: 8
        },
        dialog: {
            "& .MuiDialog-paperScrollPaper": {
                overflow: 'hidden',
                backgroundColor: '#ecf1f5'
            }
        }
    }));
function Assessment({ context }) {
    const classes = useStyles();
    const location = (0, _reactRouterDom.useLocation)();
    const { questionId, assessment, sectionId, sectionName, quizSections: sections = [], link } = context;
    const inStandards = sectionName == 'standards';
    const isSection = sectionId != undefined && !questionId;
    const isQuestion = questionId != undefined;
    const [firstSection] = sections;
    const redirecting = !inStandards && !isSection && !isQuestion;
    const redirectTo = redirecting && firstSection && link({
        sectionId: firstSection.id
    });
    function handleSearchStandards(filters) {
        return updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: mapValues(filters, (v)=>({
                    $set: v
                }))
        });
    }
    const standardSearchClosePath = link(undefined, '/:languageId/:role/:page(quiz)/:assessment/:action/:sectionId?/:questionId?');
    return redirecting && redirectTo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
        to: redirectTo
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenDialogDefault.default), {
        className: classes.dialog,
        open: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsSearchDefault.default), {
                    open: sectionName == 'standards-search',
                    closePath: standardSearchClosePath,
                    onSearchStandards: handleSearchStandards
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentHeaderDefault.default), {
                    context: context
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentPropertiesDefault.default), {
                    context: context
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.content,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.left,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentSectionsDefault.default), {
                                context: context
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.right,
                            children: [
                                inStandards && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentStandardsDefault.default), {}),
                                isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentSectionDefault.default), {
                                    context: context
                                }),
                                isQuestion && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentQuestionDefault.default), {
                                    context: context
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","./assessment-header":"lclr6","./AssessmentProperties":"f2Fwf","./assessment-sections":"3pHfL","./assessment-section":"j82pk","./assessment-question":"9FDJI","components/quiz/components/assessment-standards":"dynnL","teacher/components/standards-search":"iSLCk","components/FullScreenDialog":"cr6Y6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lclr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _assessmentHeaderTitle = require("../components/assessment-header-title");
var _assessmentHeaderTitleDefault = parcelHelpers.interopDefault(_assessmentHeaderTitle);
var _saveAssessment = require("./SaveAssessment");
var _saveAssessmentDefault = parcelHelpers.interopDefault(_saveAssessment);
var _assessmentConfiguration = require("./AssessmentConfiguration");
var _assessmentConfigurationDefault = parcelHelpers.interopDefault(_assessmentConfiguration);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _quiz = require("helpers/quiz");
const useStyles = (0, _material.makeStyles)(assessmentHeaderStyles);
function AssessmentHeader({ context, onSave, onCancel }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const [opened, setOpened] = (0, _reactDefault.default).useState(false);
    const [errors, setErrors] = (0, _reactDefault.default).useState([]);
    const [assessmentErrors, setAssessmentErrors] = (0, _reactDefault.default).useState([]);
    function handleOpen() {
        setOpened(true);
    }
    function handleClose() {
        setOpened(false);
    }
    const { link, translate, quizAssessment: assessment, action } = context;
    async function handleRetitle(newTitle) {
        if (assessment.title != newTitle && newTitle.length > 0) {
            const [updatedId] = await (0, _commandDefault.default)('quiz', 'retitleAssessment')({
                id: assessment.id,
                newTitle
            });
            if (updatedId == assessment.id) {
                const quizAssessment = (0, _immutabilityHelperDefault.default)(context.quizAssessment, {
                    title: {
                        $set: newTitle
                    }
                });
                context.setState({
                    quizAssessment
                });
            }
        }
    }
    const isSection = context.sectionId && !context.questionId;
    const isQuestion = context.questionId != undefined;
    const section = isSection ? `${context.sectionId}` : isQuestion ? `${context.sectionId}/${context.questionId}` : '';
    const previewLink = context.sectionName == 'standards' ? link({
        action: 'preview'
    }, '/:languageId/:role/:page/:assessment/:action') : context.sectionName != 'standards-search' ? link({
        action: 'preview'
    }) : '';
    function handlePreviewClick() {
        const quizPreviewFrom = context.sectionName == 'standards' ? '/:languageId/:role/:page/:assessment/edit/standards' : `/:languageId/:role/:page/:assessment/edit/${section}`;
        context.setState({
            quizPreviewFrom,
            quizPreviewFromQuery: {
                ...context.query
            }
        });
    }
    async function handleSaveClick() {
        const { assessmentErrors, questionErrors } = (0, _quiz.validateAssessment)(context.quizQuestions, context);
        const hasErrors = assessmentErrors.length > 0 || questionErrors.length > 0;
        if (hasErrors) {
            setAssessmentErrors(assessmentErrors);
            setErrors(questionErrors);
            handleOpen();
        } else {
            const properties = (0, _immutabilityHelperDefault.default)(assessment.properties, {
                validated: {
                    $set: true
                }
            });
            await (0, _command.createPost)('quiz', 'updateAssessmentProperties')({
                id: assessment.id,
                properties
            });
            history.push(link({}, context.quizEditFrom || '/:languageId/:role/:page/assessments', {
                query: context.quizEditFromQuery
            }));
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.title, action),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: "container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentHeaderTitleDefault.default), {
                        className: "title-control",
                        context: context,
                        onChange: handleRetitle
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentConfigurationDefault.default), {
                className: classes.configuration,
                context: context
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: (0, _clsxDefault.default)(classes.preview, classes.button),
                onClick: handlePreviewClick,
                to: previewLink,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)("button", "preview", action),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            className: "icon",
                            icon: (0, _freeSolidSvgIcons.faEye)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: "label",
                            children: translate('preview')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.close, classes.button),
                onClick: handleSaveClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)("button", "close"),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            className: "icon",
                            icon: (0, _freeSolidSvgIcons.faSave)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: "label",
                            children: translate('finalize')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _saveAssessmentDefault.default), {
                isOpen: opened,
                context: context,
                errors: errors,
                assessmentErrors: assessmentErrors,
                onClose: handleClose
            })
        ]
    });
}
function assessmentHeaderStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            display: 'flex'
        },
        configuration: {
            marginRight: 15
        },
        button: {
            flexShrink: 0,
            width: 115,
            height: 35,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            cursor: 'pointer',
            border: 'solid 1px #ccc',
            backgroundColor: '#fff',
            borderRadius: 4,
            textDecoration: 'none',
            '& .button': {
                display: 'flex',
                justifyContent: 'center',
                textDecoration: 'none',
                color: '#69748a',
                '& .icon': {
                    fontSize: '15pt',
                    margin: '0 2px'
                }
            }
        },
        close: {
            marginLeft: 20
        },
        title: {
            ...verticalCentering,
            flexGrow: 1,
            '& .container': {
                display: 'flex'
            },
            '& .title-control': {
                display: 'flex'
            },
            '& .titlelabel': {
                color: '#69738c',
                fontWeight: 'bold',
                ...verticalCentering
            },
            '& .titleInput': {
                marginLeft: 10,
                color: '#6b728c',
                cursor: 'text',
                ...verticalCentering
            },
            '& .control': {
                display: 'flex',
                borderBottom: 'solid 1px',
                flexGrow: 1
            },
            '& .input-wrapper': {
                flexGrow: 1,
                ...verticalCentering
            },
            '& .input': {
                background: 'none',
                border: 'none',
                width: '100%',
                fontSize: '10pt',
                flexGrow: 1,
                '&:focus': {
                    outline: 'none'
                }
            },
            '& .addornment': {
                cursor: 'pointer',
                marginTop: -3,
                ...verticalCentering
            },
            '& .icon': {
                marginTop: -2,
                marginLeft: 4,
                fontSize: 9,
                color: '#69748a',
                cursor: 'pointer',
                '&.editing': {
                    display: 'none'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../components/assessment-header-title":"g2BBR","./SaveAssessment":"df6HU","./AssessmentConfiguration":"8Tjmt","helpers/command":"f3cbG","helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g2BBR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentTitle);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _editableCaption = require("./editable-caption");
var _editableCaptionDefault = parcelHelpers.interopDefault(_editableCaption);
function AssessmentTitle({ context, className, onChange }) {
    const { translate, quizAssessment: assessment, action } = context;
    const [editingTitle, setEditingTitle] = (0, _reactDefault.default).useState(false);
    const title = assessment.title || '';
    function onEditTitleClick() {
        setEditingTitle(action == 'edit' && true);
    }
    function closeEditTitle() {
        setEditingTitle(false);
    }
    async function handleTitleChange(title) {
        if (assessment.title != title) onChange && onChange(title);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: className,
        onClick: onEditTitleClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: "titleLabel",
                children: [
                    translate('title'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "titleInput",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableCaptionDefault.default), {
                    editing: editingTitle,
                    value: assessment.title || '',
                    onCancel: closeEditTitle,
                    onConfirm: (title)=>handleTitleChange(title) && closeEditTitle(),
                    className: "inputTitle"
                })
            }),
            action == 'edit' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)("icon", {
                    "editing": editingTitle
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faEdit)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./editable-caption":"5oy5y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"df6HU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SaveAssessment);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _responsiveFullscreenDialog = require("components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _command = require("helpers/command");
var _section = require("./Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _assessmentError = require("./AssessmentError");
var _assessmentErrorDefault = parcelHelpers.interopDefault(_assessmentError);
const useStyles = (0, _material.makeStyles)(saveAssessmentStyles);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
function SaveAssessment({ isOpen, onClose, context, errors, assessmentErrors }) {
    const dialogClasses = useDialogStyles();
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, quizAssessment: assessment, assessment: assessmentId, quizSections: sections } = context;
    async function handleSave() {
        const properties = (0, _immutabilityHelperDefault.default)(assessment.properties, {
            validated: {
                $set: false
            }
        });
        await (0, _command.createPost)('quiz', 'updateAssessmentProperties')({
            id: assessmentId,
            properties
        });
        history.push(context.link({}, context.quizEditFrom || '/:languageId/:role/:page/assessments', {
            query: context.quizEditFromQuery
        }));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: onClose,
        dialogMaxWidth: "lg",
        actionsClassName: classes.actions,
        dialogClasses: dialogClasses,
        confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            className: (0, _clsxDefault.default)(classes.button, "create"),
            color: "primary",
            onClick: handleSave,
            children: translate('save')
        }),
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            className: (0, _clsxDefault.default)(classes.button, "cancel"),
            onClick: onClose,
            children: translate('cancel')
        }),
        title: translate('save-with-errors-dialog-title'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            children: [
                assessmentErrors.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.assessment,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.label,
                            children: translate('assessment-errors-label')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.errors,
                            children: assessmentErrors.map((error, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentErrorDefault.default), {
                                    error,
                                    context
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.sections,
                    children: errors.map((section)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDefault.default), {
                            section,
                            context
                        }, section.id))
                })
            ]
        })
    });
}
function saveAssessmentStyles(theme) {
    return {
        actions: {
            marginTop: 20
        },
        label: {
            color: '#68728b',
            fontWeight: 'bold',
            fontSize: '13pt'
        },
        errors: {
            display: 'flex',
            flexDirection: 'column',
            padding: 10
        },
        button: {
            "&.create": {
                marginLeft: 20
            }
        },
        sections: {}
    };
}
function dialogStyles(theme) {
    return {
        paper: {
            padding: 20
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","components/responsive-fullscreen-dialog":"9pRHY","helpers/command":"f3cbG","./Section":"f1BNA","./AssessmentError":"gLn3Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1BNA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _question = require("./Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ section, context }) {
    const classes = useStyles();
    const { translate, quizSections: sections = [] } = context;
    const sectionIndex = sections.findIndex((s)=>s.id == section.id);
    const { title } = sectionIndex >= 0 && sections[sectionIndex] || {};
    const sectionTitle = `${sectionIndex + 1}. ${title || translate('section')}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.section,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.sectionTitle,
                children: sectionTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.questions,
                children: section.questions.map((question)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                        question,
                        context
                    }, question.id))
            })
        ]
    });
}
function sectionStyles(theme) {
    return {
        sectionTitle: {
            color: '#68728b',
            fontWeight: 'bold',
            fontSize: '13pt'
        },
        questions: {
            display: 'flex',
            flexDirection: 'column',
            padding: 10
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","./Question":"1Pjat","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Pjat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../../helpers/utils");
var _error = require("./Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question({ question, context }) {
    const classes = useStyles();
    const { translate } = context;
    const typeName = translate(question.typeName);
    const title = (0, _utils.isEmpty)(question.textpremise) ? typeName : `${typeName}: ${question.textpremise}`;
    const section = context.quizQuestions[question.section] || [];
    const questionIndex = section.findIndex((q)=>q.id == question.id);
    const questionTitle = `${questionIndex + 1}. ${title}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.question,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.questionTitle,
                children: questionTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.errors,
                children: question.errors.map((error, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                        error,
                        question,
                        context
                    }, index))
            })
        ]
    });
}
function questionStyles(theme) {
    return {
        questionTitle: {
            color: '#69738c',
            fontSize: '12pt'
        },
        errors: {
            display: 'flex',
            flexDirection: 'column',
            padding: 10
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../../helpers/utils":"gGc98","./Error":"fjq8w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjq8w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Error);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(errorStyles);
function Error({ error, question, context }) {
    const classes = useStyles();
    const { translate } = context;
    return typeof error == 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.error,
        children: translate(error, question)
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: error(question, context).map((message, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.error,
                children: message
            }, index))
    });
}
function errorStyles(theme) {
    return {
        error: {
            marginTop: 5,
            color: 'red',
            fontSize: '11pt',
            fontStyle: 'italic',
            "&:first-child": {
                marginTop: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gLn3Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentError);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(errorStyles);
function AssessmentError({ error, context }) {
    const classes = useStyles();
    const { translate } = context;
    return typeof error == 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.error,
        children: translate(error)
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: error(context).map((message, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.error,
                children: message
            }, index))
    });
}
function errorStyles(theme) {
    return {
        error: {
            marginTop: 5,
            color: 'red',
            fontSize: '11pt',
            fontStyle: 'italic',
            "&:first-child": {
                marginTop: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Tjmt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentConfiguration);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _settings = require("@mui/icons-material/Settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
var _command = require("../../../../helpers/command");
var _configurationDialog = require("./ConfigurationDialog");
var _configurationDialogDefault = parcelHelpers.interopDefault(_configurationDialog);
const useStyles = (0, _material.makeStyles)(configurationStyles);
function AssessmentConfiguration({ className, context }) {
    const [opened, open] = (0, _reactDefault.default).useState(false);
    const { translate, quizAssessment: assessment } = context;
    const classes = useStyles();
    async function updateAssessmentProperty(property, value) {
        const { quizAssessment: { properties = {} } } = await context.updateState({
            quizAssessment: {
                properties: {
                    [property]: {
                        $set: value
                    }
                }
            }
        });
        (0, _command.createPost)('quiz', 'updateAssessmentProperties')({
            id: assessment.id,
            properties
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.button,
                onClick: ()=>open(true),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "label",
                        children: translate('configuration')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _configurationDialogDefault.default), {
                isOpen: opened,
                onClose: ()=>open(false),
                context,
                updateAssessmentProperty
            })
        ]
    });
}
function configurationStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            ...verticalCentering
        },
        button: {
            cursor: 'pointer',
            display: 'flex',
            color: '#69748a',
            "& > div": {
                ...verticalCentering
            },
            "& .icon": {
                fontSize: '15pt',
                marginTop: -2,
                marginRight: 6
            },
            "&:hover": {
                color: '#1d9be5',
                "& .icon": {
                    transform: 'scale(1.1)'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","lodash":"1qc47","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/icons-material/Settings":"jkTfg","../../../../helpers/command":"f3cbG","./ConfigurationDialog":"cv2zk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jkTfg":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("83add5e7a9a15fcc");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("6a10f8af21bc9756"));
var _jsxRuntime = require("2eb7196f2f0dc3f3");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6"
}), 'Settings');

},{"83add5e7a9a15fcc":"kZ6eK","6a10f8af21bc9756":"2vOnF","2eb7196f2f0dc3f3":"1dlk8"}],"cv2zk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConfigurationDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _responsiveFullscreenDialog = require("../../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
const useStyles = (0, _material.makeStyles)(configurationStyles);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
function ConfigurationDialog({ isOpen, onClose, context, updateAssessmentProperty }) {
    const dialogClasses = useDialogStyles();
    const classes = useStyles();
    const { translate, quizAssessment: assessment } = context;
    const { randomize = false } = assessment.properties || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: onClose,
        dialogMaxWidth: "lg",
        actionsClassName: classes.actions,
        dialogClasses: dialogClasses,
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            className: (0, _clsxDefault.default)(classes.button, "close"),
            onClick: onClose,
            children: translate('close')
        }),
        title: translate('assessment-configuration-dialog-title'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: classes.root,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                size: "small",
                className: classes.randomizeOption,
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    size: "small",
                    color: "primary",
                    checked: randomize,
                    onChange: (e)=>updateAssessmentProperty('randomize', e.target.checked)
                }),
                label: translate('randomize-assessment')
            })
        })
    });
}
function configurationStyles(theme) {
    return {
        root: {
            color: '#4c4f58'
        },
        actions: {
            marginTop: 20
        }
    };
}
function dialogStyles(theme) {
    return {
        paper: {
            padding: 20
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/material/FormControlLabel":"kemIW","@mui/material/Checkbox":"4sdMA","../../../responsive-fullscreen-dialog":"9pRHY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f2Fwf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentProperties);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _command = require("helpers/command");
var _unit = require("./Unit");
var _unitDefault = parcelHelpers.interopDefault(_unit);
var _points = require("./Points");
var _pointsDefault = parcelHelpers.interopDefault(_points);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
const useStyles = (0, _material.makeStyles)(propertiesStyles);
function AssessmentProperties({ context }) {
    const { translate, quizAssessment: assessment, mySubjects, myCourses, quizTypes } = context;
    const classes = useStyles();
    async function updateProperties(properties) {
        const [updatedId] = await (0, _command.createPost)('quiz', 'updateAssessmentProperties')({
            id: assessment.id,
            ...properties
        });
        if (updatedId == assessment.id) {
            const quizAssessment = (0, _immutabilityHelperDefault.default)(context.quizAssessment, (0, _lodash.mapValues)(properties, (value)=>({
                    $set: value || ''
                })));
            context.setState({
                quizAssessment
            });
        }
    }
    function handleChange(name, properties) {
        properties = properties || ((e)=>({
                [name]: e.target.value
            }));
        return (e)=>{
            updateProperties(properties(e));
        };
    }
    const courses = assessment.subject ? myCourses.filter(({ course })=>course.substring(0, 2) == assessment.subject) : myCourses;
    return(// <Fade in={!context.quizSearch.assessment}>
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: classes.root,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        className: classes.type,
                        controlMargin: "dense",
                        id: "type",
                        caption: translate('type_label'),
                        selectValue: assessment.type || '',
                        selectOnChange: handleChange('type', (e)=>({
                                type: parseInt(e.target.value)
                            })),
                        options: context.quizTypes,
                        mapValue: (o)=>o.id,
                        mapText: (o)=>translate(`${o.name}-label`)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        className: classes.subject,
                        controlMargin: "dense",
                        selectValue: assessment.subject || '',
                        selectOnChange: handleChange('subject', (e)=>({
                                subject: e.target.value,
                                course: undefined
                            })),
                        caption: translate('subject_label'),
                        options: context.mySubjects,
                        mapValue: (o)=>o.id,
                        mapText: (o)=>o.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        className: classes.course,
                        controlMargin: "dense",
                        nullable: true,
                        selectValue: assessment.course || '',
                        selectOnChange: handleChange('course'),
                        caption: translate('course_assessment_header'),
                        options: courses,
                        mapValue: (o)=>o.course,
                        mapText: (o)=>o.courseName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitDefault.default), {
                        className: classes.unit,
                        context,
                        onChange: handleChange('unit', (unit)=>({
                                unit
                            }))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pointsDefault.default), {
                        className: classes.points,
                        context: context
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: classes.standards,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    className: (0, _clsxDefault.default)(classes.standardsLink, {
                        selected: context.sectionName == 'standards'
                    }),
                    to: context.link({
                        sectionName: 'standards'
                    }, '/:languageId/:role/:page/:assessment/:action/:sectionName'),
                    children: translate('standards')
                })
            })
        ]
    }));
}
function propertiesStyles(theme) {
    return {
        container: {
            marginTop: 20,
            marginBottom: 20,
            padding: '25px 15px',
            display: 'flex',
            flexDirection: 'column'
        },
        root: {
            display: 'flex',
            "& > div": {
                display: 'flex',
                flexDirection: 'column',
                marginLeft: 15,
                width: 75,
                "& > .label": {
                    fontSize: '11pt',
                    color: '#878ea1',
                    marginBottom: 3
                },
                "& > .input": {
                    display: 'flex'
                }
            }
        },
        standards: {
            paddingTop: 10,
            display: 'flex',
            justifyContent: 'flex-end'
        },
        standardsLink: {
            textDecoration: 'none',
            color: '#1d9be5',
            fontWeight: 'bold'
        },
        type: {
            flexGrow: 1,
            marginLeft: '0 !important'
        },
        subject: {
            flexGrow: 1
        },
        course: {
            flexGrow: 2
        },
        points: {
            width: '120px !important'
        },
        unit: {
            flexGrow: 3
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/MenuItem":"a18vm","@mui/material/Paper":"arHf6","@mui/material/Fade":"8DwqP","helpers/command":"f3cbG","./Unit":"0tPeO","./Points":"3L3mw","./Select":"kluKY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"0tPeO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Unit);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
var _editableCaption = require("../../components/editable-caption");
var _editableCaptionDefault = parcelHelpers.interopDefault(_editableCaption);
const useStyles = (0, _material.makeStyles)(unitStyles);
function Unit({ context, className, onChange }) {
    const classes = useStyles();
    const { translate, quizAssessment: assessment } = context;
    const [editingUnit, setEditingUnit] = (0, _reactDefault.default).useState(false);
    const unit = assessment.unit || '';
    function onEditUnitClick() {
        setEditingUnit(true);
    }
    function closeEditUnit() {
        setEditingUnit(false);
    }
    async function handleUnitChange(unit) {
        if (assessment.unit != unit) onChange && onChange(unit);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, className),
        onClick: onEditUnitClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    translate('unit'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableCaptionDefault.default), {
                    editing: editingUnit,
                    value: assessment.unit || '',
                    onCancel: closeEditUnit,
                    onConfirm: (unit)=>handleUnitChange(unit) && closeEditUnit(),
                    className: classes.unit
                })
            })
        ]
    });
}
function unitStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            width: 75
        },
        unit: {
            flexGrow: 1,
            display: 'flex',
            overflow: 'hidden',
            minHeight: 19
        },
        input: {
            display: 'flex',
            border: 'solid 1px #aab7bf',
            borderRadius: 4,
            cursor: 'text',
            padding: 5,
            '& .control': {
                display: 'flex',
                flexGrow: 1
            },
            '& .input-wrapper': {
                flexGrow: 1,
                ...verticalCentering
            },
            '& .input': {
                border: 'none',
                width: '100%',
                flexGrow: 1,
                '&:focus': {
                    outline: 'none'
                }
            },
            '& .addornment': {
                cursor: 'pointer',
                marginTop: -3,
                ...verticalCentering
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","external/material":"6yEDE","../../components/editable-caption":"5oy5y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3L3mw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Points);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(pointsStyles);
function Points({ className, context }) {
    const classes = useStyles();
    const { translate } = context;
    const points = Object.values(context.quizQuestions).reduce((acc, section)=>{
        return section.reduce((acc, { value })=>acc + value, acc);
    }, 0);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    translate('total-points'),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: points
            })
        ]
    });
}
function pointsStyles(theme) {
    return {
        root: {},
        input: {
            display: 'flex',
            border: 'solid 1px #edf4fe',
            backgroundColor: '#edf4fe',
            borderRadius: 4,
            cursor: 'text',
            color: '#4f5a70',
            padding: 5
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kluKY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(selectStyles);
function Select(props) {
    const classes = useStyles();
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    const labelId = `${props.id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: props.options.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlDefault.default), {
                    ...controlAttributes,
                    className: classes.control,
                    children: (props.nullable || selectAttributes.value) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        labelId: labelId,
                        id: props.id,
                        ...selectAttributes,
                        className: (0, _clsxDefault.default)(classes.select, "select"),
                        children: props.options.map((option, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: props.mapValue(option),
                                children: props.mapText(option)
                            }, key))
                    })
                })
            })
        ]
    });
}
function selectStyles(theme) {
    return {
        root: {
            '& .MuiInput-underline:before': {
                content: 'none',
                border: 'none'
            },
            '& .MuiSelect-select': {
                border: 'solid 1px #aab7bf',
                borderRadius: 4,
                padding: 5,
                paddingRight: 24
            }
        },
        control: {
            margin: 0,
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Select":"aY7hn","@mui/material/FormControl":"kkska","@mui/material/MenuItem":"a18vm","@mui/material/Box":"73kto","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3pHfL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentSections);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _createSection = require("./create-section");
var _createSectionDefault = parcelHelpers.interopDefault(_createSection);
var _section = require("./section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _responsiveFullscreenDialog = require("../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _searchAndSelectQuestion = require("components/quiz/components/search-and-select-question");
var _searchAndSelectQuestionDefault = parcelHelpers.interopDefault(_searchAndSelectQuestion);
var _quiz = require("helpers/quiz");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            minWidth: 300,
            border: 'solid 1px #dfdfdf',
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            display: 'flex',
            padding: '15px 10px'
        },
        standardsLink: {
            color: '#1d9be5',
            fontSize: '27pt',
            padding: '1px 2px 1px 10px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            "&:hover": {
                color: '#3977ba'
            },
            "&.selected": {
                color: '#01507e'
            }
        },
        sections: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'auto'
        }
    }));
function AssessmentSections({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { quizSections: sections, translate, updateState } = context;
    const hasSections = sections.length > 0;
    const [deleteQuestionState, setDeleteQuestionState] = (0, _reactDefault.default).useState({
        question: undefined,
        opened: false
    });
    async function handleCreateSection() {
        const assessment = context.quizAssessment.id;
        const [newSection] = await (0, _commandDefault.default)('quiz', 'createSection')({
            assessment
        });
        const quizSections = (0, _immutabilityHelperDefault.default)(context.quizSections, {
            $push: [
                newSection
            ]
        });
        context.setState({
            quizSections
        });
    }
    function handleSectionMove(drag, hover) {
        const section = context.quizSections[drag];
        const quizSections = (0, _immutabilityHelperDefault.default)(context.quizSections, {
            $splice: [
                [
                    drag,
                    1
                ],
                [
                    hover,
                    0,
                    section
                ]
            ]
        });
        context.setState({
            quizSections
        });
    }
    async function handleSectionDropped() {
        const assessment = context.quizAssessment.id;
        const sections = context.quizSections.map((section, index)=>({
                id: section.id,
                index: section.index == index ? false : index
            })).filter((section)=>section.index !== false);
        const movedSections = await (0, _command.createPost)('quiz', 'reorderSections')({
            assessment,
            sections
        });
        const quizSections = movedSections.reduce((sections, section)=>{
            const index = context.quizSections.findIndex(({ id })=>section.id == id);
            return (0, _immutabilityHelperDefault.default)(sections, {
                [index]: {
                    index: {
                        $set: section.index
                    }
                }
            });
        }, context.quizSections);
        context.setState({
            quizSections
        });
    }
    async function handleQuestionMoved(drag, hover) {
        const question = (0, _immutabilityHelperDefault.default)(context.quizQuestions[drag.section][drag.index], {
            section: {
                $set: hover.section
            }
        });
        const moveQuestion = hover.index == undefined ? {
            $set: [
                question
            ]
        } : {
            $splice: [
                [
                    hover.index,
                    0,
                    question
                ]
            ]
        };
        const removeQuestion = {
            $splice: [
                [
                    drag.index,
                    1
                ]
            ]
        };
        let quizQuestions = (0, _immutabilityHelperDefault.default)(context.quizQuestions, {
            [drag.section]: removeQuestion
        });
        quizQuestions = (0, _immutabilityHelperDefault.default)(quizQuestions, {
            [hover.section]: moveQuestion
        });
        context.setState({
            quizQuestions
        });
    }
    async function handleQuestionDropped() {
        const questions = Object.values(context.quizQuestions).reduce((acc, questions)=>{
            return acc.concat(questions.map((question, index)=>({
                    id: question.id,
                    section: question.section,
                    index: question.index == index ? false : index
                })).filter((question)=>question.index !== false));
        }, []);
        if (questions.length > 0) {
            const movedQuestions = await (0, _command.createPost)('quiz', 'reorderQuestions')({
                questions
            });
            const quizQuestions = movedQuestions.reduce((questions, question)=>{
                const index = context.quizQuestions[question.section].findIndex(({ id })=>question.question == id);
                return (0, _immutabilityHelperDefault.default)(questions, {
                    [question.section]: {
                        [index]: {
                            index: {
                                $set: question.index
                            }
                        }
                    }
                });
            }, context.quizQuestions);
            context.setState({
                quizQuestions
            });
        }
    }
    function handleToggleSection(id) {
        const index = context.quizSections.findIndex((section)=>section.id == id);
        const quizSections = (0, _immutabilityHelperDefault.default)(context.quizSections, {
            [index]: {
                opened: {
                    $apply: (a)=>!a
                }
            }
        });
        context.setState({
            quizSections
        });
    }
    function handleOpenDeleteQuestion(question) {
        setDeleteQuestionState({
            opened: true,
            question
        });
    }
    async function handleDeleteQuestion(confirmed) {
        if (confirmed) {
            const { id, section } = deleteQuestionState.question;
            const questionIndex = context.quizQuestions[section].findIndex((q)=>q.id == id);
            const goToQuestion = context.quizQuestions[section][questionIndex == 0 ? 1 : questionIndex - 1];
            const [deletedId] = await (0, _commandDefault.default)('quiz', 'deleteQuestion')({
                id
            });
            if (deletedId == id) {
                const questions = (questions)=>questions.filter((q)=>q.id != id).map((q, index)=>(0, _immutabilityHelperDefault.default)(q, {
                            index: {
                                $set: index
                            }
                        }));
                const quizQuestions = (0, _immutabilityHelperDefault.default)(context.quizQuestions, {
                    [section]: {
                        $apply: questions
                    }
                });
                context.setState({
                    quizQuestions
                });
                history.push(context.link({}, goToQuestion ? `/:languageId/:role/:page/:assessment/edit/:sectionId/${goToQuestion.id}` : `/:languageId/:role/:page/:assessment/edit/${section}`));
            }
        }
        setDeleteQuestionState({
            opened: false,
            question: undefined
        });
    }
    (0, _reactDefault.default).useEffect(()=>{
        const targets = Object.entries(context.quizQuestions).reduce((targets, [section, questions])=>{
            return targets.concat(questions.map((q, index)=>q.id != context.questionId && q.isNew && {
                    section,
                    index
                }).filter((q)=>q));
        }, []);
        if (targets.length > 0) {
            const updates = targets.reduce((acc, q)=>{
                acc[q.section] = acc[q.section] || {};
                acc[q.section][q.index] = {
                    isNew: {
                        $set: false
                    }
                };
                return acc;
            }, {});
            context.updateState({
                quizQuestions: updates
            });
        }
    }, [
        context.questionId
    ]);
    async function handleSelectQuestion(question, section) {
        if (!question || !section) return;
        const [data] = await (0, _commandDefault.default)('quiz', 'addQuestionFromBank')({
            question,
            section
        });
        if (data) {
            const init = (0, _quiz.initQuestion)(context);
            const command = context.quizQuestions[section] ? '$push' : '$set';
            updateState({
                quizQuestions: {
                    [section]: {
                        [command]: [
                            init({
                                ...data,
                                isNew: {
                                    $set: true
                                }
                            })
                        ]
                    }
                }
            });
            history.push(context.link('quiz', context.assessment, 'edit', section, data.id));
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchAndSelectQuestionDefault.default), {
                onSelect: handleSelectQuestion
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createSectionDefault.default), {
                    caption: translate('create-section'),
                    onClick: handleCreateSection
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.sections,
                children: sections.map((section, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDefault.default), {
                        index: index,
                        context: context,
                        onSectionMove: handleSectionMove,
                        onSectionDropped: handleSectionDropped,
                        onDeleteQuestion: handleOpenDeleteQuestion,
                        onQuestionMove: handleQuestionMoved,
                        onQuestionDropped: handleQuestionDropped,
                        onToggleSection: handleToggleSection,
                        section: section,
                        questions: context.quizQuestions[section.id],
                        translate: translate
                    }, section.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: deleteQuestionState.opened,
                close: handleDeleteQuestion,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>handleDeleteQuestion(true),
                    children: translate('delete')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: ()=>handleDeleteQuestion(),
                    children: translate('cancel')
                }),
                title: translate('confirm_delete_item'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    children: translate('delete-question-message', deleteQuestionState.question)
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","@mui/material/Button":"c6Y0y","@mui/material/Fade":"8DwqP","@fortawesome/react-fontawesome":"32SD5","helpers/command":"f3cbG","./create-section":"9Mn7Z","./section":"9ccDq","@mui/material/DialogContentText":"5nWzR","../../responsive-fullscreen-dialog":"9pRHY","components/quiz/components/search-and-select-question":"9HiJZ","helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Mn7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateSection);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
const AddButton = (0, _material.withStyles)({
    root: {
        flexGrow: 1,
        borderColor: '#1d9be5',
        backgroundColor: '#1d9be5',
        borderRadius: 4,
        boxShadow: 'none',
        color: '#fff',
        '& svg': {
            marginTop: -3
        },
        '& .addIcon': {
            fontSize: '14pt'
        },
        '&:hover': {
            backgroundColor: '#29739f',
            borderColor: '#29739f',
            boxShadow: 'none'
        }
    },
    label: {
        textTransform: 'none'
    }
})((0, _buttonDefault.default));
function CreateSection({ onClick, className, caption }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AddButton, {
        "aria-controls": "customized-menu",
        "aria-haspopup": "true",
        variant: "contained",
        onClick: onClick,
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {
                className: "addIcon"
            }),
            caption
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/icons-material/Add":"jrNj7","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ccDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactDnd = require("react-dnd");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _editableCaption = require("../components/editable-caption");
var _editableCaptionDefault = parcelHelpers.interopDefault(_editableCaption);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _addQuestion = require("./add-question");
var _addQuestionDefault = parcelHelpers.interopDefault(_addQuestion);
var _question = require("./question");
var _questionDefault = parcelHelpers.interopDefault(_question);
const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        section: {
            display: 'flex',
            flexDirection: 'column'
        },
        sectionName: {
            display: 'flex',
            borderTop: 'solid 1px #c6d6e3',
            borderBottom: 'solid 1px #c6d6e3',
            color: '#68728b',
            '& > .sortIcon': {
                fontSize: '14pt',
                padding: '0 5px 0 10px',
                color: '#d8d9dd',
                cursor: 'pointer',
                ...verticalCentering
            },
            '& > .caretIcon': {
                fontSize: '12pt',
                padding: '0 8px',
                cursor: 'pointer',
                ...verticalCentering
            },
            '& > .folderIcon': {
                marginLeft: 10,
                fontSize: '15pt',
                cursor: 'pointer',
                ...verticalCentering
            },
            '& > .label': {
                marginLeft: 10,
                textDecoration: 'none',
                fontWeight: 'bold',
                color: '#68728b',
                padding: '15px 4px',
                flexGrow: 1,
                '&:hover': {
                    textDecoration: 'underline'
                }
            },
            '&.selected': {
                backgroundColor: '#1d9be5',
                '& > .label': {
                    color: '#fff',
                    cursor: 'default',
                    '&:hover': {
                        textDecoration: 'none'
                    }
                },
                '& > .folderIcon': {
                    color: '#fff'
                },
                '& .inputTitle': {
                    color: '#fff'
                }
            }
        },
        sectionContent: {
            display: 'none',
            flexGrow: 1,
            '&.opened': {
                display: 'flex'
            }
        },
        questions: {
            flexGrow: 1
        }
    }));
function Section(props) {
    const classes = useStyles();
    const { context, section, index, onToggleSection, onDeleteQuestion, onQuestionDropped, onQuestionMove, onTitleChange, onSectionMove, onSectionDropped, questions = [] } = props;
    const { translate, updateState } = context;
    const { id, title, opened } = section;
    const [{ isDragging }, drag, preview] = (0, _reactDnd.useDrag)({
        item: {
            type: 'SECTION',
            id,
            index
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            })
    });
    const folderRef = (0, _react.useRef)(null);
    const [, folderDrop] = (0, _reactDnd.useDrop)({
        accept: [
            'SECTION'
        ],
        hover (item, monitor) {
            if (item.index == index) return;
            const { current } = folderRef;
            if (!current) return;
            const { top, bottom } = current.getBoundingClientRect();
            const middle = (bottom - top) / 2;
            const { y } = monitor.getClientOffset();
            const dY = y - top;
            const goingUp = item.index > index;
            if (goingUp && dY < middle) return;
            if (!goingUp && dY > middle) return;
            onSectionMove && onSectionMove(item.index, index);
            item.index = index;
        },
        drop (item, monitor) {
            if (!monitor.didDrop()) onSectionDropped && onSectionDropped();
        }
    });
    folderDrop(folderRef);
    const opacity = isDragging ? 0 : 1;
    const sectionLabel = `${index + 1}. ${title || translate('section')}`;
    const selected = context.sectionId == id && !context.questionId;
    const link = context.link({
        sectionId: id
    }, `/:languageId/:role/:page/:assessment/edit/:sectionId`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        ref: preview,
        style: {
            opacity
        },
        className: (0, _clsxDefault.default)(classes.section, {
            selected
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                ref: folderRef,
                onClick: ()=>onToggleSection && onToggleSection(id),
                className: (0, _clsxDefault.default)(classes.sectionName, {
                    selected
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        ref: drag,
                        className: "sortIcon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faSort)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "folderIcon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: opened ? (0, _freeSolidSvgIcons.faFolderOpen) : (0, _freeSolidSvgIcons.faFolder)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                        to: link,
                        className: "label",
                        onClick: (e)=>e.stopPropagation(),
                        children: sectionLabel
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "caretIcon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: opened ? (0, _freeSolidSvgIcons.faCaretDown) : (0, _freeSolidSvgIcons.faCaretLeft)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.sectionContent, {
                    opened
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.questions,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addQuestionDefault.default), {
                            context: context,
                            section: section
                        }),
                        questions.map((question, index)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                                index: index,
                                question: question,
                                section: section,
                                context: context,
                                onQuestionMove: onQuestionMove,
                                onQuestionDropped: onQuestionDropped,
                                onDeleteQuestion: onDeleteQuestion
                            }, question.id);
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","react-dnd":"9NZ1L","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","../components/editable-caption":"5oy5y","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./add-question":"8e4Bf","./question":"1pIJZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8e4Bf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _quiz = require("helpers/quiz");
const AddButton = (0, _material.withStyles)({
    root: {
        borderColor: '#fff7ea',
        backgroundColor: '#fff7ea',
        borderRadius: 0,
        color: '#68728b',
        '& svg': {
            marginTop: -3
        },
        '&:hover': {
            backgroundColor: '#ccbda5',
            borderColor: '#ccbda5',
            boxShadow: 'none'
        }
    },
    label: {
        textTransform: 'none'
    }
})((0, _buttonDefault.default));
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexGrow: 1
        },
        button: {
            flexGrow: 1
        },
        menu: {},
        addIcon: {
            fontSize: '14pt'
        }
    }));
const StyledMenu = (0, _material.withStyles)({
    paper: {
        border: '1px solid #d3d4d5'
    }
})((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        },
        ...props
    }));
const StyledMenuItem = (0, _material.withStyles)((theme)=>({
        root: {
            '&:focus': {
                backgroundColor: theme.palette.primary.main,
                '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                    color: theme.palette.common.white
                }
            }
        }
    }))((0, _menuItemDefault.default));
function AddQuestion({ context, section }) {
    const { link, assessment: assessmentId, updateState } = context;
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    async function addQuestion(questionType) {
        const [data] = await (0, _commandDefault.default)('quiz', 'addQuestion')({
            type: questionType.id,
            section: section.id
        });
        if (data) {
            const question = (0, _immutabilityHelperDefault.default)(data, {
                isNew: {
                    $set: true
                }
            });
            const init = (0, _quiz.initQuestion)(context);
            const quizQuestions = context.quizQuestions[section.id] ? (0, _immutabilityHelperDefault.default)(context.quizQuestions, {
                [section.id]: {
                    $push: [
                        init(question)
                    ]
                }
            }) : (0, _immutabilityHelperDefault.default)(context.quizQuestions, {
                [section.id]: {
                    $set: [
                        init(question)
                    ]
                }
            });
            context.setState({
                quizQuestions
            });
            history.push(link({
                questionId: question.id
            }));
        }
        handleClose();
    }
    function handleSearchQuestion() {
        updateState({
            quizDialogs: {
                'search-and-select-question': {
                    $set: true
                }
            },
            searchAndSelectSection: {
                $set: section.id
            }
        });
        handleClose();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AddButton, {
                "aria-controls": "customized-menu",
                "aria-haspopup": "true",
                variant: "contained",
                color: "primary",
                onClick: handleClick,
                className: classes.button,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {
                        className: classes.addIcon
                    }),
                    context.translate('add-question')
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                id: "customized-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    context.quizQuestionTypes.map((questionType, index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            onClick: ()=>addQuestion(questionType),
                            children: context.translate(questionType.name)
                        }, index);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleSearchQuestion,
                        children: context.translate('question-bank')
                    })
                ]
            })
        ]
    });
} //{true && (// removed-dreyfous-filter context.profile.domain == 'dreyfous' }

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/icons-material/Add":"jrNj7","helpers/command":"f3cbG","helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1pIJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactDnd = require("react-dnd");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _addQuestion = require("./add-question");
var _addQuestionDefault = parcelHelpers.interopDefault(_addQuestion);
var _quiz = require("helpers/quiz");
var _utils = require("helpers/utils");
const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        question: {
            display: 'flex',
            cursor: 'pointer',
            borderBottom: 'solid 1px #c6d6e5',
            backgroundColor: '#f2f9ff',
            '&:hover': {
                backgroundColor: '#c7dcef'
            },
            '&.selected': {
                color: '#fff',
                backgroundColor: '#4cadff'
            }
        },
        questionLink: {
            flexGrow: 1,
            textDecoration: 'none',
            color: '#69738c',
            '&.selected': {
                color: '#fff'
            },
            display: 'flex',
            '& > div': {
                ...verticalCentering
            },
            '& > .index': {
                padding: '12px 8px'
            },
            '& > .label': {
                padding: '8px 0',
                maxWidth: 200,
                overflow: 'hidden',
                flexGrow: 1
            },
            '& > .sorter': {
                backgroundColor: '#e2eff8',
                padding: 8,
                color: '#abbecd'
            },
            '& > .delete': {
                marginLeft: 5,
                marginRight: 8
            },
            '&.invalid': {
                '& > .label': {
                    color: 'red'
                }
            }
        },
        recentlyCreated: {
            fontWeight: 'bold'
        }
    }));
function Question(props) {
    const classes = useStyles();
    const { context, section, index, question, onDeleteQuestion, onQuestionMove, onQuestionDropped } = props;
    const { name: typeName } = context.quizQuestionTypes.find((t)=>t.id == question.type) || {};
    const { id, opened } = question;
    const { translate } = context;
    const truncate = (0, _utils.truncateText)(69);
    const ref = (0, _react.useRef)(null);
    const [, drop] = (0, _reactDnd.useDrop)({
        accept: 'QUESTION',
        hover (item, monitor) {
            if (!ref.current) return;
            const dragIndex = item.index;
            const hoverIndex = index;
            if (dragIndex === hoverIndex) return;
            const hoverBoundingRect = ref.current.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
            onQuestionMove && onQuestionMove({
                index: dragIndex,
                section: item.section
            }, {
                index: hoverIndex,
                section: section.id
            });
            item.section = section.id;
            item.index = hoverIndex;
        },
        drop (item, monitor) {
            !monitor.didDrop() && onQuestionDropped && onQuestionDropped();
        }
    });
    const [{ isDragging }, drag, preview] = (0, _reactDnd.useDrag)({
        item: {
            type: 'QUESTION',
            index,
            section: section.id
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            })
    });
    preview(drop(ref));
    const opacity = isDragging ? 0 : 1;
    const selected = context.questionId == id;
    const questionIndex = index + 1;
    const questionLabel = truncate(`${question.textpremise || translate(typeName)}`);
    const link = context.link({
        questionId: question.id,
        sectionId: question.section
    }, `/:languageId/:role/:page/:assessment/edit/:sectionId/:questionId`);
    const invalid = !question.isNew && !(0, _quiz.isValidQuestion)(question, typeName);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        id: id,
        ref: ref,
        style: {
            opacity
        },
        className: (0, _clsxDefault.default)(classes.question, {
            selected
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
            className: (0, _clsxDefault.default)(classes.questionLink, {
                selected,
                invalid
            }),
            to: link,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: "sorter",
                    ref: drag,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faBars)
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: "index",
                    children: [
                        questionIndex,
                        "."
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: (0, _clsxDefault.default)("label", {
                        [classes.recentlyCreated]: question.isNew
                    }),
                    children: questionLabel
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: "delete",
                    onClick: (e)=>{
                        e.stopPropagation();
                        e.preventDefault();
                        onDeleteQuestion && onDeleteQuestion(question);
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTrashAlt)
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","react-dnd":"9NZ1L","external/material":"6yEDE","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./add-question":"8e4Bf","helpers/quiz":"2gdOk","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9HiJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentStandardsDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _reactRouterDom = require("react-router-dom");
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _context = require("teacher/context");
var _utils = require("helpers/utils");
var _content = require("./content");
var _contentDefault = parcelHelpers.interopDefault(_content);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
const useDialogTitleStyles = (0, _material.makeStyles)(dialogTitleStyles);
const useDialogContentStyles = (0, _material.makeStyles)(dialogContentStyles);
function AssessmentStandardsDialog(props) {
    const location = (0, _reactRouterDom.useLocation)();
    const history = (0, _reactRouterDom.useHistory)();
    const dialogClasses = useDialogStyles();
    const dialogTitleClasses = useDialogTitleStyles();
    const dialogContentClasses = useDialogContentStyles();
    const theme = (0, _material.useTheme)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const fullScreen = (0, _useMediaQueryDefault.default)(theme.breakpoints.down('md'));
    const { translate, quizDialogs, updateState } = context;
    const open = quizDialogs['search-and-select-question'];
    const handleClose = ()=>{
        updateState({
            quizDialogs: {
                'search-and-select-question': {
                    $set: false
                }
            },
            searchAndSelectSection: {
                $set: undefined
            }
        });
        if (location.search.length > 0) history.push(location.pathname);
    };
    function handleSelect(question) {
        props.onSelect && props.onSelect(question, context.searchAndSelectSection);
        handleClose();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        fullScreen: fullScreen,
        open: open,
        classes: !fullScreen ? dialogClasses : undefined,
        onClose: handleClose,
        "aria-labelledby": "search-and-select-question-dialog-title",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                id: "search-and-select-question-dialog-title",
                classes: dialogTitleClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typographyDefault.default), {
                        variant: "h5",
                        component: "div",
                        className: "title",
                        children: translate('search-and-select-question')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                        "aria-label": "close",
                        className: "closeButton",
                        onClick: handleClose,
                        size: "large",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                classes: dialogContentClasses,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contentDefault.default), {
                    onSelect: handleSelect
                })
            })
        ]
    });
}
function dialogTitleStyles(theme) {
    return {
        root: {
            borderBottom: 'solid 1px #e0e0e0',
            padding: '16px 3px 16px 24px',
            display: 'flex',
            "& .title": {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                color: '#3f5250',
                flexGrow: 1
            }
        }
    };
}
function dialogContentStyles() {
    return {
        root: {
            display: 'flex',
            justifyContent: 'center',
            padding: 0,
            "& .contentWrapper": {
                display: 'flex',
                flexGrow: 1
            }
        }
    };
}
function dialogStyles(theme) {
    return {
        container: {
            display: 'flex',
            color: '#626d88',
            width: '100%',
            height: '100%',
            justifyContent: 'center'
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            border: 'solid 1px #dce1ec',
            height: 'calc(100% - 40px)',
            minWidth: 600,
            maxWidth: 1024,
            borderRadius: 2,
            width: '80%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","react-router-dom":"3uzXR","@mui/material/Dialog":"255tO","@mui/material/DialogActions":"5WZHz","@mui/material/DialogContent":"gD0J9","@mui/material/DialogTitle":"5sOv1","@mui/material/Typography":"2wCD5","@mui/material/useMediaQuery":"bnRpi","@mui/material/IconButton":"bXjnZ","@mui/icons-material/Close":"acjz6","teacher/context":"5LKDx","helpers/utils":"gGc98","./content":"jmXtQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jmXtQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SearchAndSelectQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _filters = require("./components/filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _questions = require("./components/questions");
var _questionsDefault = parcelHelpers.interopDefault(_questions);
var _footer = require("./components/footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _standardsSearch = require("teacher/components/standards-search");
var _standardsSearchDefault = parcelHelpers.interopDefault(_standardsSearch);
const useStyles = (0, _material.makeStyles)(questionBankStyles);
function SearchAndSelectQuestion(props) {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const location = (0, _reactRouterDom.useLocation)();
    const { quizSearch, quizQuestionBank, translate, updateState, sectionName } = context;
    const searchingDone = !quizSearch['question-bank'];
    const questionsFound = quizQuestionBank.length > 0;
    async function handleSearchStandards(filters) {
        return updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: (0, _lodash.mapValues)(filters, (v)=>({
                    $set: v
                }))
        });
    }
    const closePath = location.pathname.replace(/\/standards-search.*/, '');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsSearchDefault.default), {
                open: sectionName == 'standards-search',
                closePath: closePath,
                onSearchStandards: handleSearchStandards
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.filters,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.container,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                    in: searchingDone,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.content, {
                            questionsFound
                        }),
                        children: [
                            !questionsFound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.noQuestionsFound,
                                children: translate('no-questions-found')
                            }),
                            questionsFound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionsDefault.default), {
                                onSelect: props.onSelect
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.footer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footerDefault.default), {
                    context: context
                })
            })
        ]
    });
}
function questionBankStyles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
        },
        noQuestionsFound: {
            flexGrow: 1,
            backgroundColor: '#f9f9f9',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            justifyContent: 'center',
            fontSize: '28pt',
            color: '#8990a0'
        },
        container: {
            display: 'flex',
            flexGrow: 1,
            overflow: 'hidden'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            flexGrow: 1,
            '&.questionsFound': {
                padding: '10px 10px 10px 0',
                '&::-webkit-scrollbar': {
                    width: 6
                },
                '&::-webkit-scrollbar-track': {
                    background: '#fff',
                    padding: 2
                }
            }
        },
        filters: {
            display: 'flex',
            backgroundColor: '#fff',
            borderBottom: 'solid 1px #becfd7'
        },
        footer: {
            display: 'flex',
            borderTop: 'solid 1px #becfd7',
            padding: '10px 16px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","teacher/context":"5LKDx","./components/filters":"5vHwq","./components/questions":"cgJyG","./components/footer":"fAuX5","teacher/components/standards-search":"iSLCk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5vHwq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionBankFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _repository = require("./repository");
var _repositoryDefault = parcelHelpers.interopDefault(_repository);
var _subject = require("./subject");
var _subjectDefault = parcelHelpers.interopDefault(_subject);
var _course = require("./course");
var _courseDefault = parcelHelpers.interopDefault(_course);
var _unit = require("./unit");
var _unitDefault = parcelHelpers.interopDefault(_unit);
var _lesson = require("./lesson");
var _lessonDefault = parcelHelpers.interopDefault(_lesson);
var _questionType = require("./question-type");
var _questionTypeDefault = parcelHelpers.interopDefault(_questionType);
var _pattern = require("./pattern");
var _patternDefault = parcelHelpers.interopDefault(_pattern);
var _filterChip = require("components/quiz/components/filter-chip");
var _filterChipDefault = parcelHelpers.interopDefault(_filterChip);
const useStyles = (0, _material.makeStyles)((0, _stylesDefault.default));
function QuestionBankFilters() {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const location = (0, _reactRouterDom.useLocation)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { tab, link, linkQuery, translate, updateState } = context;
    const createFilterHandler = (name, mapQuery)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            const query = mapQuery ? mapQuery(context.query, value) : {
                ...context.query,
                [name]: value
            };
            history.push(linkQuery(location.pathname, {
                ...query
            }));
        };
    function clearStandardFilters() {
        updateState({
            quizStandardFiltersCalls: {
                $apply: (i)=>i + 1
            },
            quizStandardFilters: {
                expectations: {
                    $set: []
                },
                indicators: {
                    $set: []
                },
                standards: {
                    $set: []
                }
            }
        });
    }
    const hasStandardsChip = Object.values(context.quizStandardFilters).some((a)=>a.length > 0);
    const hasChips = !(!context.query.pattern && !context.query.id && !hasStandardsChip);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.filters,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.top,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _repositoryDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('repository')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _patternDefault.default), {
                        classes: classes
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.filler
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.bottom,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subjectDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('subject', (query, subject)=>({
                                ...query,
                                course: undefined,
                                unit: undefined,
                                lesson: undefined,
                                subject
                            }))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _courseDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('course', (query, course)=>{
                            return course ? {
                                ...query,
                                course,
                                subject: course.substring(0, 2),
                                unit: undefined,
                                lesson: undefined
                            } : {
                                ...query,
                                course: undefined,
                                unit: undefined,
                                lesson: undefined
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('unit', (query, unit)=>{
                            return unit ? {
                                ...query,
                                unit
                            } : {
                                ...query,
                                unit: undefined,
                                lesson: undefined
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('lesson', (query, lesson)=>{
                            return lesson ? {
                                ...query,
                                lesson
                            } : {
                                ...query,
                                lesson: undefined
                            };
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionTypeDefault.default), {
                        classes: classes,
                        onChange: createFilterHandler('type')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.filler
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.chips, {
                    hasChips
                }),
                children: [
                    context.query.pattern && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "pattern",
                        context: context,
                        from: location.pathname
                    }),
                    context.query.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "id",
                        context: context,
                        createLabel: ()=>translate('new-bank-question'),
                        from: location.pathname
                    }),
                    hasStandardsChip && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "standards",
                        context: context,
                        createLabel: ()=>translate('standards-filter-chip'),
                        from: location.pathname,
                        onDelete: clearStandardFilters
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","teacher/context":"5LKDx","./styles":"9fYzl","./repository":"7DKmS","./subject":"iyaGE","./course":"68oGz","./unit":"bpQ5g","./lesson":"6ZqI3","./question-type":"lCJWy","./pattern":"9P60L","components/quiz/components/filter-chip":"i3UT5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9fYzl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>filterStyles);
function filterStyles(theme) {
    return {
        filters: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column'
        },
        top: {
            display: 'flex',
            padding: '15px 10px 0 20px'
        },
        filler: {
            flexGrow: 1
        },
        bottom: {
            display: 'flex',
            padding: '0 10px 15px 20px'
        },
        select: {
            marginLeft: 15,
            width: 150,
            '&:first-child': {
                marginLeft: 0
            }
        },
        patternFilter: {
            display: 'flex',
            margin: 15,
            paddingTop: 3
        },
        patternInput: {
            borderRadius: 5,
            border: 'solid 1px #becfd7'
        },
        standardsSearch: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginLeft: 8
        },
        standardsSearchLink: {
            color: '#009dd8',
            fontSize: '9.5pt'
        },
        chips: {
            display: 'none',
            '&.hasChips': {
                display: 'flex',
                borderTop: 'solid 1px #becfd7',
                display: 'flex',
                padding: '10px 15px'
            },
            '& .filter-chip': {
                backgroundColor: '#de3434',
                color: '#fff',
                '& .MuiChip-label': {
                    padding: '0 20px'
                },
                '& .MuiChip-deleteIcon': {}
            }
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7DKmS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>RepositoryFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function RepositoryFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _clearableSelectDefault.default), {
        id: "question-bank-repository-filter",
        className: (0, _clsxDefault.default)(classes.select, "repository"),
        value: context.query.repository || "",
        onChange: onChange,
        caption: translate('repository'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: "dreyfous",
                children: translate('dreyfous')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: "institution",
                children: translate('institution')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: "personal",
                children: translate('personal')
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyaGE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SubjectFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function SubjectFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { subjects, translate } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-subject-filter",
        className: (0, _clsxDefault.default)(classes.select, "subject"),
        value: context.query.subject || "",
        caption: translate('subject_label'),
        onChange: onChange,
        children: subjects.map((subject, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: subject.id,
                children: subject.name
            }, key))
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68oGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CourseFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _lodash = require("external/lodash");
var _quiz = require("helpers/quiz");
var _context = require("teacher/context");
function CourseFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { myCourses, query, translate } = context;
    const courses = query.subject ? myCourses.filter(({ course })=>course.substring(0, 2) == query.subject) : myCourses;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-course-filter",
        className: (0, _clsxDefault.default)(classes.select, "course"),
        value: query.course || "",
        onChange: onChange,
        caption: translate('course_assessment_header'),
        children: (0, _lodash.orderBy)(courses, [
            'course'
        ]).map((course, key)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: course.course,
                children: (0, _quiz.selectCourseLabel)(course)
            }, key);
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","external/lodash":"5bCAQ","helpers/quiz":"2gdOk","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bpQ5g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UnitFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function UnitFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, translate } = context;
    const units = context.units[query.course] || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-unit-filter",
        className: (0, _clsxDefault.default)(classes.select, "unit"),
        value: query.unit || "",
        onChange: onChange,
        caption: translate('unitName-header'),
        children: units.map((unit, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: `${context.query.course}U${unit.code}`,
                children: unit.name
            }, key))
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ZqI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LessonFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function LessonFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, translate } = context;
    const lessons = query.unit ? (context.lessons[query.course] || []).filter(({ id })=>id.substring(0, 10) == query.unit) : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-lesson-filter",
        className: (0, _clsxDefault.default)(classes.select, "lesson"),
        value: query.lesson || "",
        onChange: onChange,
        caption: translate('lesson-header'),
        children: lessons.map((lesson, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: lesson.id,
                children: lesson.name
            }, key))
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCJWy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionTypeFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
function QuestionTypeFilter(props) {
    const { classes, onChange } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, translate, quizQuestionTypes: questionTypes } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
        id: "question-bank-type-filter",
        className: (0, _clsxDefault.default)(classes.select, "question-type"),
        value: query.type || "",
        onChange: onChange,
        caption: translate('question-type'),
        children: questionTypes.map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                value: type.id,
                children: translate(type.name)
            }, type.id))
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/clearable-select":"jWvEj","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9P60L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PatternFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _activeFiltersCjs = require("components/standards-selector/domain/active-filters.cjs");
var _reactRouterDom = require("react-router-dom");
var _searchPattern = require("components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
function PatternFilter(props) {
    const { classes, onChange } = props;
    const location = (0, _reactRouterDom.useLocation)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { tab, link, linkQuery, query, translate, quizQuestionTypes: questionTypes } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.patternFilter,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.patternInput,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                    path: location.pathname,
                    context: context
                })
            }),
            !(0, _activeFiltersCjs.hasActiveStandardsFilter)(context.quizStandardFilters) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.standardsSearch,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                    to: linkQuery(`${location.pathname}/standards-search`),
                    className: classes.standardsSearchLink,
                    children: translate('standards-search')
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","components/standards-selector/domain/active-filters.cjs":"9Ycmg","react-router-dom":"3uzXR","components/search-pattern":"lUZFT","@mui/material/Box":"73kto","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cgJyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Questions);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _question = require("./question");
var _questionDefault = parcelHelpers.interopDefault(_question);
const useStyles = (0, _material.makeStyles)(questionsStyles);
function Questions(props) {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { quizQuestionBank: questions, quizNewBankQuestion: question, sectionName, questionId } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: questions.map((question, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                ...question,
                onSelect: props.onSelect
            }, index))
    });
}
function questionsStyles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            paddingLeft: 10,
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","teacher/context":"5LKDx","./question":"cNy4Z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cNy4Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _arrowDropDown = require("@mui/icons-material/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _arrowDropUp = require("@mui/icons-material/ArrowDropUp");
var _arrowDropUpDefault = parcelHelpers.interopDefault(_arrowDropUp);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("teacher/context");
var _previewQuestion = require("components/quiz/components/preview-question");
var _previewQuestionDefault = parcelHelpers.interopDefault(_previewQuestion);
var _command = require("helpers/command");
var _utils = require("helpers/utils");
var _settings = require("./settings");
var _settingsDefault = parcelHelpers.interopDefault(_settings);
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question(props) {
    const [expanded, setExpanded] = (0, _react.useState)(false);
    const history = (0, _reactRouterDom.useHistory)();
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { courseName, typeName, repository, owned, textpremise, shared } = props;
    const { translate, updateState } = context;
    const expandClick = ()=>setExpanded(!expanded);
    const premiseLabel = (0, _utils.isEmpty)(textpremise) ? translate(typeName) : textpremise;
    function handleSelectQuestion() {
        props.onSelect && props.onSelect(props.id);
    }
    (0, _reactDefault.default).useEffect(()=>{
        if ((0, _utils.isEmpty)(textpremise)) setExpanded(true);
    }, [
        textpremise
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, {
            expanded
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.filler
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.expand,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            className: classes.button,
                            startIcon: expanded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDropUpDefault.default), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _arrowDropDownDefault.default), {}),
                            onClick: expandClick,
                            children: translate(expanded ? 'view-less' : 'view-more')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.splitWrapper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.split
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.selectWrapper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.selectLink,
                            onClick: handleSelectQuestion,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.selectIcon,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faFileExport)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.selectText,
                                    children: translate('select')
                                })
                            ]
                        })
                    })
                ]
            }),
            !expanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.textPremise,
                children: premiseLabel
            }),
            expanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewQuestionDefault.default), {
                    headless: true,
                    showPoints: true,
                    showStandards: true,
                    context: context,
                    question: props
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.footer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.courseName,
                        children: [
                            translate('course_assessment_header'),
                            ": ",
                            courseName
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.type,
                        children: [
                            translate('type-header'),
                            ": ",
                            translate(typeName)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.repository,
                        children: [
                            translate('repository'),
                            ": ",
                            translate(owned ? 'personal' : repository)
                        ]
                    })
                ]
            })
        ]
    });
}
function questionStyles() {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            marginTop: 10,
            '&:first-child': {
                marginTop: 0
            },
            display: 'flex',
            flexDirection: 'column',
            border: 'solid 1px #becfd7',
            width: '100%',
            backgroundColor: '#fff'
        },
        button: {
            color: '#2a92eb',
            fontSize: '9pt',
            textTransform: 'none',
            '& .MuiButton-startIcon': {
                marginRight: 5
            }
        },
        header: {
            padding: 10,
            display: 'flex',
            '& > div': {
                ...verticalCentering
            }
        },
        filler: {
            flexGrow: 1
        },
        split: {
            marginLeft: 15,
            marginRight: 15,
            backgroundColor: '#d4d3d9',
            width: 1,
            height: '45%'
        },
        selectLink: {
            display: 'flex',
            marginRight: 20,
            cursor: 'pointer',
            color: '#4595e7',
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        selectIcon: {
            ...verticalCentering,
            marginTop: -2,
            marginRight: 6,
            fontSize: '10.5pt'
        },
        selectText: {
            ...verticalCentering,
            textAlign: 'center',
            fontSize: '9pt',
            marginRight: 10,
            width: 50,
            "&.selected": {
                color: "#fff"
            }
        },
        content: {
            '& .section': {
                border: 0
            }
        },
        textPremise: {
            fontSize: '12pt',
            color: '#494f67',
            padding: '0 20px 20px 20px'
        },
        footer: {
            display: 'flex',
            backgroundColor: '#f7fbfe',
            color: '#494f67',
            fontSize: '10.5pt',
            borderTop: 'solid 1px #cfe0e8',
            padding: '10px',
            '& > div': {
                marginLeft: 15,
                borderLeft: 'solid 1px #cfe0e8',
                paddingLeft: 15,
                '&:first-child': {
                    marginLeft: 10,
                    borderLeft: 0,
                    paddingLeft: 0
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","@mui/material/Tooltip":"7bRLE","@mui/icons-material/ArrowDropDown":"6qreH","@mui/icons-material/ArrowDropUp":"diWR2","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","teacher/context":"5LKDx","components/quiz/components/preview-question":"4tE9v","helpers/command":"f3cbG","helpers/utils":"gGc98","./settings":"cIQqj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cIQqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Settings);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _moreVert = require("@mui/icons-material/MoreVert");
var _moreVertDefault = parcelHelpers.interopDefault(_moreVert);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _responsiveFullscreenDialog = require("components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _previewQuestion = require("components/quiz/components/preview-question");
var _previewQuestionDefault = parcelHelpers.interopDefault(_previewQuestion);
var _context = require("teacher/context");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
function Settings(props) {
    const { question, classes } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const [deleteOpened, openDeleteQuestionBank] = (0, _reactDefault.default).useState(false);
    const [moveToDirectoryOpened, openMoveToDirectory] = (0, _reactDefault.default).useState(false);
    const [directory, setDirectory] = (0, _reactDefault.default).useState(question.directory || "");
    const openRowSettingsMenu = (e)=>{
        setAnchorEl(e.currentTarget);
    };
    const closeRowSettingsMenu = (e, reason)=>{
        setDirectory(question.directory || "");
        setAnchorEl(null);
    };
    function handleOpenDelete() {
        closeRowSettingsMenu();
        openDeleteQuestionBank(true);
    }
    async function handleDelete(confirmed) {
        openDeleteQuestionBank(false);
        if (!confirmed) return;
        await (0, _commandDefault.default)('quiz', 'deleteBankQuestion')({
            id: question.id
        });
        updateState({
            quizSearchQuestionBankCalls: {
                $apply: (n)=>n + 1
            }
        });
    }
    async function handleShare() {
        closeRowSettingsMenu();
        const shared = !question.shared;
        const [sharedId] = await (0, _commandDefault.default)('quiz', 'shareBankQuestion')({
            id: question.id,
            shared
        });
        if (sharedId == question.id) {
            const index = context.quizQuestionBank.findIndex(({ id })=>id == sharedId);
            if (index >= 0) updateState({
                quizQuestionBank: {
                    [index]: {
                        shared: {
                            $set: shared
                        }
                    }
                }
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.moreSettings,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.moreSettingsButton,
                onClick: openRowSettingsMenu,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreVertDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                id: "settings-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: closeRowSettingsMenu,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleShare,
                        children: context.translate(question.shared ? 'unshare' : 'share')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleOpenDelete,
                        children: context.translate('delete')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: deleteOpened,
                close: handleDelete,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>handleDelete(true),
                    children: translate('delete')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: ()=>handleDelete(),
                    children: translate('cancel')
                }),
                title: translate('confirm_delete_item'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewQuestionDefault.default), {
                    headless: true,
                    showPoints: true,
                    context: context,
                    question: question
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","immutability-helper":"hwjCt","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/icons-material/MoreVert":"22WtH","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","components/responsive-fullscreen-dialog":"9pRHY","components/quiz/components/preview-question":"4tE9v","teacher/context":"5LKDx","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fAuX5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _pagination = require("./pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            color: '#4f576e',
            fontSize: '12pt'
        },
        count: {
            display: 'flex'
        },
        countIcon: {
            ...verticalCentering,
            marginTop: -5,
            marginRight: 5
        },
        questionsLabel: {
            ...verticalCentering
        },
        countLabel: {
            ...verticalCentering
        },
        pagination: {
            flexGrow: 1
        }
    }));
function Footer({ context }) {
    const { tab } = context;
    const classes = useStyles();
    const page = parseInt(context.query.page);
    const { recordCount, pageSize } = context.quizPaging;
    const pageCount = Math.ceil(recordCount / pageSize);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                className: classes.count,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: classes.questionsLabel,
                        children: context.translate('question-bank-pagination-label')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        className: classes.countLabel,
                        children: [
                            ": ",
                            recordCount
                        ]
                    })
                ]
            }),
            pageCount > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: classes.pagination,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paginationDefault.default), {
                    context: context,
                    page: isNaN(page) ? 1 : page,
                    count: pageCount
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./pagination":"3XeZu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3XeZu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuizPaginationComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _pagination = require("@mui/material/Pagination");
var _paginationDefault = parcelHelpers.interopDefault(_pagination);
var _paginationItem = require("@mui/material/PaginationItem");
var _paginationItemDefault = parcelHelpers.interopDefault(_paginationItem);
const QuizPagination = (0, _material.withStyles)((theme)=>({
        ul: {
            justifyContent: 'center'
        }
    }))((0, _paginationDefault.default));
const QuizPaginationItem = (0, _material.withStyles)((theme)=>({
        root: {
            color: '#4f576e',
            fontSize: '12pt',
            fontWeight: theme.typography.fontWeightRegular,
            marginRight: theme.spacing(1),
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"'
            ].join(','),
            '&:hover': {
                borderRadius: 3
            }
        },
        outlined: {
            backgroundColor: '#fff',
            borderRadius: 3,
            border: 'solid 1px #909ebb'
        },
        page: {},
        selected: {
            borderRadius: 3,
            backgroundColor: '#c9f1fd !important'
        }
    }))((0, _paginationItemDefault.default));
function QuizPaginationComponent({ context, page, count }) {
    const history = (0, _reactRouterDom.useHistory)();
    const location = (0, _reactRouterDom.useLocation)();
    const handleChange = (event, page)=>{
        history.push(context.linkQuery(location.pathname, {
            ...context.query,
            page
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizPagination, {
        count: count,
        page: page,
        onChange: handleChange,
        renderItem: (item)=>{
            const variant = [
                'next',
                'previous'
            ].indexOf(item.type) >= 0 ? 'outlined' : 'text';
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(QuizPaginationItem, {
                ...item,
                variant
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Pagination":"bePWZ","@mui/material/PaginationItem":"feAT5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j82pk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentSection);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialogContentText = require("@mui/material/DialogContentText");
var _dialogContentTextDefault = parcelHelpers.interopDefault(_dialogContentText);
var _responsiveFullscreenDialog = require("../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _editableCaption = require("../components/editable-caption");
var _editableCaptionDefault = parcelHelpers.interopDefault(_editableCaption);
var _editableHtml = require("../components/editable-html");
var _editableHtmlDefault = parcelHelpers.interopDefault(_editableHtml);
const useStyles = (0, _material.makeStyles)(assessmentSectionStyles);
function AssessmentSection({ context }) {
    const { translate } = context;
    const sectionIndex = context.quizSections.findIndex((s)=>s.id == context.sectionId);
    const section = context.quizSections[sectionIndex] || {};
    const questions = context.quizQuestions[section.id] || [];
    const loaded = section.id != undefined;
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const sectionLabel = `${section.index + 1}.`;
    const [deleteSectionOpened, openDeleteSection] = (0, _reactDefault.default).useState(false);
    const [instructions, setInstructions] = (0, _reactDefault.default).useState(undefined);
    function handleOpenDeleteSection(question) {
        openDeleteSection(true);
    }
    async function handleDeleteSection(confirmed) {
        if (confirmed) {
            (0, _commandDefault.default)('quiz', 'deleteSection')({
                id: section.id
            });
            const { quizSections } = await context.updateState({
                quizSections: {
                    $apply: (sections)=>sections.filter((q)=>q.id != section.id).map((section, index)=>({
                                ...section,
                                index
                            }))
                }
            });
            const { id: sectionId } = quizSections[sectionIndex > 0 ? sectionIndex - 1 : 0] || {};
            history.push(context.link({
                sectionId
            }, `/:languageId/teacher/:page/:assessment/edit/:sectionId`));
        }
        openDeleteSection(false);
    }
    function handleInstructionsChanged(instructions) {
        context.updateState({
            quizSections: {
                [sectionIndex]: {
                    instructions: {
                        $set: instructions
                    }
                }
            }
        });
        (0, _command.createPost)('quiz', 'updateInstructions')({
            id: section.id,
            instructions
        });
    }
    return(// <Fade in={loaded}>
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.sectionName,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: "label",
                                children: sectionLabel
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Title, {
                                className: "title",
                                context,
                                section,
                                sectionIndex
                            })
                        ]
                    }),
                    context.quizSections.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "delete",
                        onClick: handleOpenDeleteSection,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTrashAlt)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: "instructions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: "label",
                            children: [
                                translate('instructions'),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableHtmlDefault.default), {
                            context: context,
                            html: section.instructions || '',
                            onChange: handleInstructionsChanged
                        }, section.id)
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
                open: deleteSectionOpened,
                close: handleDeleteSection,
                confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>handleDeleteSection(true),
                    children: translate('delete')
                }),
                cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    variant: "contained",
                    color: "secondary",
                    onClick: ()=>handleDeleteSection(),
                    children: translate('cancel')
                }),
                title: translate('confirm_delete_item'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentTextDefault.default), {
                    children: translate('delete-section-message', {
                        title: section.title || translate('unnamed'),
                        questions: questions.length
                    })
                })
            })
        ]
    }));
}
function Title({ context, className, section, sectionIndex }) {
    const { translate } = context;
    const [editingTitle, setEditingTitle] = (0, _reactDefault.default).useState(false);
    function onEditTitleClick() {
        setEditingTitle(true);
    }
    function closeEditTitle() {
        setEditingTitle(false);
    }
    async function handleRetitle(newTitle) {
        if (newTitle == section.title) return;
        context.updateState({
            quizSections: {
                [sectionIndex]: {
                    title: {
                        $set: newTitle
                    }
                }
            }
        });
        (0, _commandDefault.default)('quiz', 'retitleSection')({
            id: section.id,
            newTitle
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: className,
        onClick: onEditTitleClick,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editableCaptionDefault.default), {
                    editing: editingTitle,
                    value: section.title || translate('section'),
                    onCancel: closeEditTitle,
                    onConfirm: (newTitle)=>handleRetitle(newTitle) && closeEditTitle(),
                    className: "inputTitle"
                })
            }),
            !editingTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "icon",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faEdit)
                })
            })
        ]
    });
}
function assessmentSectionStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            display: 'flex',
            padding: '15px 20px',
            borderBottom: 'solid 1px #aab7bf',
            color: '#69748a',
            '& .delete': {
                fontSize: '14pt',
                cursor: 'pointer'
            }
        },
        sectionName: {
            display: 'flex',
            flexGrow: 1,
            '& > .label': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                fontSize: '13pt',
                fontWeight: 'bold'
            },
            '& > .title': {
                flexGrow: 1,
                display: 'flex',
                marginLeft: 8,
                fontSize: '12.5pt',
                '& > div': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '& > .title': {
                    justifyContent: 'center'
                },
                '& > .icon': {
                    marginLeft: 5,
                    fontSize: '10pt',
                    justifyContent: 'flex-start',
                    cursor: 'pointer'
                },
                "& .inputTitle": {
                    '& > .control': {
                        display: 'flex'
                    },
                    '& .input': {
                        border: 'none',
                        color: '#69748a',
                        borderBottom: '1px solid #69748',
                        '&:focus': {
                            outline: 'none'
                        }
                    },
                    '& .addornment': {
                        cursor: 'pointer',
                        borderBottom: '1px solid #69748'
                    }
                }
            }
        },
        content: {
            padding: 30,
            display: 'flex',
            flexDirection: 'column',
            '& > .instructions': {
                display: 'flex',
                flexDirection: 'column',
                '& > .label': {
                    color: '#69748a',
                    fontSize: '12pt',
                    marginBottom: 15
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Paper":"arHf6","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","helpers/command":"f3cbG","@mui/material/Button":"c6Y0y","@mui/material/DialogContentText":"5nWzR","../../responsive-fullscreen-dialog":"9pRHY","../components/editable-caption":"5oy5y","../components/editable-html":"6jWHH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9FDJI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AssessmentQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _addStandard = require("./add-standard");
var _addStandardDefault = parcelHelpers.interopDefault(_addStandard);
var _utils = require("helpers/utils");
var _command = require("helpers/command");
var _quiz = require("helpers/quiz");
var _context = require("teacher/context");
var _questionValue = require("components/quiz/components/question-value");
var _questionValueDefault = parcelHelpers.interopDefault(_questionValue);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _editQuestions = require("components/quiz/edit-questions");
var _editQuestionsDefault = parcelHelpers.interopDefault(_editQuestions);
var _questionValidations = require("./QuestionValidations");
var _questionValidationsDefault = parcelHelpers.interopDefault(_questionValidations);
function findQuestionIndex(id, questions = {}) {
    for(let section in questions){
        const index = questions[section].findIndex((q)=>q.id == id);
        if (index >= 0) return {
            index,
            section
        };
    }
    return {
        index: undefined,
        section: undefined
    };
}
function AssessmentQuestion() {
    const classes = (0, _stylesDefault.default)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { at, questionId, quizQuestions, translate } = context;
    const { index, section } = findQuestionIndex(questionId, quizQuestions);
    const questionPath = `quizQuestions[${section}][${index}]`;
    const [question = {}] = at(questionPath);
    const questionType = context.quizQuestionTypes.find((type)=>type.id == question.type) || {};
    const Handler = (0, _editQuestionsDefault.default)[questionType.name];
    const PropertyHandler = (0, _editQuestions.propertyHandlers)[questionType.name];
    const truncate = (0, _utils.truncateText)(69);
    const [saving, setSaving] = (0, _reactDefault.default).useState(false);
    async function saveToBank(replace) {
        setSaving(true);
        const [updatedId, template] = replace ? await (0, _command.createPost)('quiz', 'updateBankQuestion')({
            question
        }) : await (0, _command.createPost)('quiz', 'saveQuestionToBank')({
            id: question.id
        });
        setSaving(false);
        if (updatedId == question.id) context.updateState({
            quizQuestions: {
                [question.section]: {
                    [index]: {
                        template: {
                            $set: template.id
                        }
                    }
                }
            },
            quizQuestionTemplate: {
                $set: template
            }
        });
    }
    function handleSaveToBank() {
        if (!saving) saveToBank();
    }
    async function updateProperties(request, updateCommand) {
        if (updateCommand) await context.updateState({
            quizQuestions: {
                [question.section]: {
                    [index]: {
                        ...updateCommand,
                        modifications: {
                            $apply: (i)=>i + 1
                        }
                    }
                }
            }
        });
        if (request) (0, _command.createPost)('quiz', 'updateQuestionProperties')(request);
    }
    const handlePropertyChange = (name, value)=>updateProperties({
            id: question.id,
            [name]: value
        }, {
            [name]: {
                $set: value
            }
        });
    const onStandardsChange = async (standards)=>{
        const newContext = await context.updateState({
            quizQuestions: {
                [question.section]: {
                    [index]: {
                        properties: {
                            standards: {
                                $set: standards
                            }
                        }
                    }
                }
            }
        });
        await context.updateState({
            quizQuestionStandards: {
                $set: (0, _quiz.getQuizQuestionStandards)(newContext)
            }
        });
        (0, _command.createPost)('quiz', 'updateQuestionProperties')({
            id: question.id,
            properties: {
                ...question.properties,
                standards
            }
        });
    };
    const questionTypeName = context.translate(questionType.name) || '';
    const questionTitle = (0, _utils.isEmpty)(question.textpremise) ? questionTypeName : `${questionTypeName}: ${truncate(question.textpremise)}`;
    const canSaveToBank = (0, _quiz.isValidQuestion)(question, questionType.name);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.questionName,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "indexLabel",
                                children: [
                                    question.index + 1,
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: "title",
                                children: questionTitle
                            })
                        ]
                    }),
                    canSaveToBank && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "saveToBank",
                        onClick: handleSaveToBank,
                        children: [
                            !saving && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                            icon: (0, _freeSolidSvgIcons.faFileExport)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label",
                                        children: context.translate('save-to-bank')
                                    })
                                ]
                            }),
                            saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faSpinner),
                                    spin: true
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "top-properties",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "properties",
                                children: [
                                    PropertyHandler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(PropertyHandler, {
                                        id: question.id,
                                        context: context,
                                        question: question,
                                        updateProperties: updateProperties
                                    }),
                                    !question.isNew && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionValidationsDefault.default), {
                                        question,
                                        type: questionType,
                                        context
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.filler
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: "value-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: "value-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionValueDefault.default), {
                                            id: question.id,
                                            context: context,
                                            className: "value",
                                            question: question,
                                            updateProperties: updateProperties
                                        }),
                                        questionType.name == 'matching' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "value-disclaimer",
                                            children: translate('matching-value-disclaimer')
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "standards",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStandardDefault.default), {
                            onStandardsChange: onStandardsChange,
                            question: question
                        })
                    }),
                    Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                        index: index,
                        context: context,
                        onPropertyChange: handlePropertyChange,
                        updateProperties: updateProperties,
                        question: question,
                        questionPath: questionPath
                    })
                ]
            })
        ]
    }, question.id);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Paper":"arHf6","@mui/material/Box":"73kto","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./add-standard":"dx8rK","helpers/utils":"gGc98","helpers/command":"f3cbG","helpers/quiz":"2gdOk","teacher/context":"5LKDx","components/quiz/components/question-value":"7x3pd","./styles":"eUnf6","components/quiz/edit-questions":"2OWlU","./QuestionValidations":"6BQOT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dx8rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddStandard);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("external/react");
var _questionSummaryCjs = require("components/standards-selector/domain/question-summary.cjs");
var _editionsCjs = require("components/standards-selector/domain/editions.cjs");
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _expandMore = require("@mui/icons-material/ExpandMore");
var _expandMoreDefault = parcelHelpers.interopDefault(_expandMore);
var _context = require("teacher/context");
var _utils = require("helpers/utils");
var _addStandards = require("teacher/components/add-standards");
var _addStandardsDefault = parcelHelpers.interopDefault(_addStandards);
var _standard = require("./standard");
var _standardDefault = parcelHelpers.interopDefault(_standard);
const useStyles = (0, _material.makeStyles)(standardStyles);
const useAccordionStyles = (0, _material.makeStyles)(accordionStyles);
const useAccordionDetailsStyles = (0, _material.makeStyles)(accordionDetailsStyles);
const useAccordionSummaryStyles = (0, _material.makeStyles)(accordionSummaryStyles);
function AddStandard({ onStandardsChange, question }) {
    const classes = useStyles();
    const accordionClasses = useAccordionStyles();
    const accordionDetailsClasses = useAccordionDetailsStyles();
    const accordionSummaryClasses = useAccordionSummaryStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, link, updateState, assessment, operation, quizAssessment, quizQuestionStandards } = context;
    const deleteStandard = (id)=>{
        onStandardsChange(standards.filter((s)=>s.id != id));
    };
    const backPath = link({
        operation: undefined
    });
    const { standards = [] } = question.properties || {};
    const standardIndex = quizQuestionStandards.findIndex((q)=>q.id == question.id) || -1;
    // Search through the standards for the closest question with a specified standard
    const quizStandards = (0, _lodash.orderBy)(quizQuestionStandards.map((q, i)=>({
            ...q,
            relevance: Math.abs(standardIndex - i)
        })).filter((q)=>q.standards.length > 0), [
        'relevance'
    ]);
    const [firstQuizStandard = {}] = quizStandards;
    const [firstStandard] = firstQuizStandard.standards || [];
    const standardLinkQuery = firstStandard ? {
        subject: firstStandard.subject,
        grade: firstStandard.grade,
        standard: firstStandard.standard,
        standard_set: (0, _editionsCjs.resolveItemEdition)(firstStandard)
    } : {
        subject: quizAssessment.subject,
        grade: quizAssessment.course ? quizAssessment.course.substring(quizAssessment.course.length - 3) : undefined
    };
    const standardLink = link({
        operation: 'add-standards'
    }, undefined, {
        query: standardLinkQuery
    });
    function handleOpenStandardsClick(e) {
        e.stopPropagation();
        const selected = standards.reduce((acc, standard)=>({
                ...acc,
                [standard.id]: standard
            }), {});
        const questionStandards = quizStandards.reduce((acc, { index, sectionIndex, standards })=>{
            standards.forEach(({ id })=>{
                if (acc[id]) acc[id].push({
                    index,
                    sectionIndex
                });
                else acc[id] = [
                    {
                        index,
                        sectionIndex
                    }
                ];
            });
            return acc;
        }, {});
        updateState({
            standardsContext: {
                selectStandards: {
                    selected: {
                        $set: selected
                    },
                    questionStandards: {
                        $set: questionStandards
                    }
                }
            }
        });
    }
    const editionGroups = (0, _questionSummaryCjs.groupQuestionStandards)(standards);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStandardsDefault.default), {
                backPath: backPath,
                onSaveStandards: onStandardsChange,
                open: operation == 'add-standards'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Accordion), {
                defaultExpanded: true,
                square: true,
                classes: accordionClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.AccordionSummary), {
                        expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expandMoreDefault.default), {}),
                        "aria-label": "Expand",
                        "aria-controls": "expand-standards",
                        id: "expand-standards",
                        classes: accordionSummaryClasses,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: classes.addStandardLabel,
                                children: [
                                    translate("standards"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: classes.addStandard,
                                to: standardLink,
                                onFocus: (e)=>e.stopPropagation(),
                                onClick: handleOpenStandardsClick,
                                children: "+"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AccordionDetails), {
                        classes: accordionDetailsClasses,
                        children: editionGroups.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _clsxDefault.default)(classes.wrapper, classes.content),
                            children: editionGroups.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: classes.editionHeading,
                                            children: [
                                                translate('standards'),
                                                " \xb7 ",
                                                group.year
                                            ]
                                        }),
                                        group.items.map((standard, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardDefault.default), {
                                                index: index,
                                                deleteStandard: deleteStandard,
                                                ...standard
                                            }, `${group.id}:${standard.id}`))
                                    ]
                                }, group.id))
                        })
                    })
                ]
            })
        ]
    });
}
function accordionStyles() {
    return {
        root: {
            border: 'none',
            boxShadow: 'none',
            borderBottom: 'solid 1px #e2ecf2'
        }
    };
}
function accordionSummaryStyles() {
    return {
        root: {
            padding: 0
        }
    };
}
function accordionDetailsStyles() {
    return {
        root: {
            padding: '8px 0'
        }
    };
}
function standardStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            padding: 0
        },
        item: {
            display: 'flex',
            flexDirection: 'column'
        },
        head: {
            color: '#868c9c',
            padding: '8px 20px 15px 20px',
            borderBottom: 'solid 1px #e2ecf2'
        },
        addStandardLabel: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: '#69738c',
            fontWeight: 'bold',
            flexGrow: 1
        },
        addStandard: {
            borderRadius: 4,
            textDecoration: 'none',
            color: '#a5b9de',
            textAlign: 'center',
            fontSize: '15pt',
            backgroundColor: '#f0f7ff',
            border: 'solid 1px #a5b9de',
            padding: '4px 8px',
            "&:hover": {
                transform: 'scale(1.01)',
                fontWeight: 'bold'
            }
        },
        editionHeading: {
            color: '#69738c',
            fontWeight: 'bold',
            padding: '12px 20px 6px',
            borderBottom: 'solid 1px #e2ecf2'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            padding: '0 0 0 0'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","external/react":"k16GP","components/standards-selector/domain/question-summary.cjs":"aAcRI","components/standards-selector/domain/editions.cjs":"Ul5PW","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/icons-material/ExpandMore":"gUaK6","teacher/context":"5LKDx","helpers/utils":"gGc98","teacher/components/add-standards":"3JEDu","./standard":"dnH0v","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aAcRI":[function(require,module,exports,__globalThis) {
const { groupByEdition } = require("cb16b94735b430e7");
function groupQuestionStandards(items = []) {
    return groupByEdition(items).map((group)=>({
            ...group,
            items: [
                ...group.items
            ].sort((a, b)=>{
                const left = `${a.expectation || a.id}-${a.code || '00'}`;
                const right = `${b.expectation || b.id}-${b.code || '00'}`;
                return left.localeCompare(right);
            })
        }));
}
module.exports = {
    groupQuestionStandards
};

},{"cb16b94735b430e7":"Ul5PW"}],"dnH0v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Standard);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("teacher/context");
var _addStandards = require("teacher/components/add-standards");
var _addStandardsDefault = parcelHelpers.interopDefault(_addStandards);
var _utils = require("helpers/utils");
const useStyles = (0, _material.makeStyles)(standardStyles);
function Standard(props) {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    const { id, code, description, deleteStandard } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _clsxDefault.default)(classes.item, classes.content),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.code,
                        children: code == undefined ? translate("expectation") : code
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.description,
                        title: description,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                            text: description,
                            maxLine: 3,
                            ellipsis: "...",
                            trimRight: true,
                            basedOn: "letters"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)(classes.item, classes.actions),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: classes.delete,
                    onClick: ()=>deleteStandard && deleteStandard(id),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTrashAlt)
                    })
                })
            })
        ]
    });
}
function standardStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            borderBottom: 'solid 1px #e2ecf2',
            "&:last-child": {
                borderBottom: 'none'
            }
        },
        item: {
            display: 'flex',
            flexDirection: 'column'
        },
        content: {
            cursor: 'default',
            flexGrow: 1,
            color: '#4e576e',
            overflowX: 'hidden',
            padding: '12px 10px 12px 20px'
        },
        code: {
            textTransform: 'uppercase',
            fontWeight: 'bold'
        },
        description: {
            color: '#838999',
            fontSize: '10.5pt',
            wordWrap: 'break-word'
        },
        actions: {
            justifyContent: 'center',
            paddingRight: 10
        },
        delete: {
            cursor: 'pointer',
            color: '#dd3636',
            padding: '8px 9px',
            "&:hover": {
                transform: 'scale(1.10)'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","react-lines-ellipsis":"ikp0X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","teacher/context":"5LKDx","teacher/components/add-standards":"3JEDu","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eUnf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            display: 'flex',
            padding: '15px 20px',
            borderBottom: 'solid 1px #aab7bf',
            color: '#69748a',
            '& .saveToBank': {
                display: 'flex',
                justifyContent: 'flex-end',
                fontSize: '12pt',
                color: '#2ca5ec',
                cursor: 'pointer',
                '& span': {
                    ...verticalCentering
                },
                '& svg': {
                    marginRight: 5,
                    ...verticalCentering
                }
            }
        },
        questionName: {
            display: 'flex',
            flexGrow: 1,
            '& > .label': {
                ...verticalCentering,
                fontSize: '13pt',
                fontWeight: 'bold'
            },
            '& .indexLabel': {
                fontSize: '12.5pt'
            },
            '& > .title': {
                flexGrow: 1,
                display: 'flex',
                marginLeft: 8,
                paddingRight: 10,
                fontSize: '12.5pt',
                '& > div': {
                    display: 'flex',
                    flexDirection: 'column'
                },
                '& > .title': {
                    justifyContent: 'center'
                },
                '& > .icon': {
                    marginLeft: 5,
                    fontSize: '10pt',
                    justifyContent: 'flex-start',
                    cursor: 'pointer'
                },
                "& .inputTitle": {
                    '& > .control': {
                        display: 'flex'
                    },
                    '& .input': {
                        border: 'none',
                        borderBottom: '1px solid #69748a',
                        color: '#69748a',
                        '&:focus': {
                            outline: 'none'
                        }
                    },
                    '& .addornment': {
                        cursor: 'pointer',
                        borderBottom: '1px solid #69748a'
                    }
                }
            }
        },
        content: {
            padding: '20px 30px',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto',
            '& > .standards': {
                marginTop: 10,
                marginBottom: 20
            },
            '& > .top-properties': {
                display: 'flex',
                '& > .value-wrapper': {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    '& > .value-container': {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        '& .value-disclaimer': {
                            fontSize: '9pt',
                            color: '#2ca5ec'
                        },
                        '& > .value': {
                            width: 75,
                            '& > .valueLabel': {
                                color: '#4e566b'
                            },
                            '& > .valueInput': {
                                display: 'flex',
                                borderRadius: 4,
                                cursor: 'text',
                                padding: 4,
                                "& .MuiInput-underline:before": {
                                    borderBottom: "none"
                                }
                            }
                        }
                    }
                }
            }
        },
        filler: {
            flexGrow: 1
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2OWlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>handlers);
parcelHelpers.export(exports, "propertyHandlers", ()=>propertyHandlers);
var _trueOrFalse = require("./true-or-false");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _multipleChoice = require("./multiple-choice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _properties = require("./multiple-choice/properties");
var _propertiesDefault = parcelHelpers.interopDefault(_properties);
var _fillInTheBlanks = require("./fill-in-the-blanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _matching = require("./matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
var _openQuestion = require("./open-question");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'matching': (0, _matchingDefault.default),
    'open-question': (0, _openQuestionDefault.default)
};
const propertyHandlers = {
    'multiple-choice': (0, _propertiesDefault.default)
};

},{"./true-or-false":"kyWOK","./multiple-choice":"2bsCX","./multiple-choice/properties":"7BsYJ","./fill-in-the-blanks":"gUyAx","./matching":"GKV70","./open-question":"6Ovx6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7BsYJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoiceProperties);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
const useStyles = (0, _material.makeStyles)(multipleChoicePropertiesStyles);
function MultipleChoiceProperties({ context, question, updateProperties }) {
    const classes = useStyles();
    const { translate } = context;
    const { properties = {}, answer = {} } = question;
    const { choices = [] } = answer;
    const correctCount = choices.reduce((a, c)=>a + (c.correct ? 1 : 0), 0);
    const singleOption = properties.singleOption;
    function changeSingleOption(checked) {
        const singleOption = correctCount < 2 && !checked;
        const command = {
            singleOption: {
                $set: singleOption
            }
        };
        const properties = (0, _immutabilityHelperDefault.default)(question.properties, command);
        updateProperties && updateProperties({
            id: question.id,
            properties
        }, {
            properties: command
        });
    }
    function changeShuffle(checked) {
        const command = {
            shuffle: {
                $set: checked
            }
        };
        const properties = (0, _immutabilityHelperDefault.default)(question.properties, command);
        updateProperties && updateProperties({
            id: question.id,
            properties
        }, {
            properties: command
        });
    }
    /*
  React.useEffect(() => {
    if (singleOption != properties.singleOption) {
      changeSingleOption(singleOption)
    }
  }, [singleOption])
  */ return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                size: "small",
                className: classes.singleOption,
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    size: "small",
                    color: "primary",
                    checked: !singleOption,
                    onChange: (e)=>changeSingleOption(e.target.checked)
                }),
                label: translate('allow-multiple-selections')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                size: "small",
                className: classes.shuffle,
                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                    size: "small",
                    color: "primary",
                    checked: properties.shuffle == true,
                    onChange: (e)=>changeShuffle(e.target.checked)
                }),
                label: translate('randomize-choices')
            })
        ]
    });
}
function multipleChoicePropertiesStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            display: 'flex',
            "& .filler": {
                flexGrow: 1
            }
        },
        multipleSelection: {
            color: '#4c4f58'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/FormControlLabel":"kemIW","@mui/material/Checkbox":"4sdMA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BQOT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionValidations);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _quiz = require("../../../../helpers/quiz");
const useStyles = (0, _material.makeStyles)(questionValidationsStyles);
function QuestionValidations({ question, type, context }) {
    const classes = useStyles();
    const { translate } = context;
    const validations = (0, _quiz.validationHandlers)[type.name] || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: validations.filter(([validate])=>!validate(question)).map(([_, message], index)=>{
            const simple = typeof message == 'string';
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                children: [
                    simple && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.validation,
                        children: translate(message, question)
                    }),
                    !simple && message(question, context).map((message, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.validation,
                            children: message
                        }, index))
                ]
            }, index);
        })
    });
}
function questionValidationsStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column'
        },
        validation: {
            marginTop: 5,
            color: 'red',
            fontSize: '10pt',
            "&:last-child": {
                marginBottom: 20
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../../helpers/quiz":"2gdOk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cr6Y6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FullScreenDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
function FullScreenDialog(props) {
    const { open, closePosition = 'start', className, handleClose, TransitionComponent, children } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        open: open,
        onClose: handleClose,
        className: (0, _material.clsx)('dialog-root', className),
        TransitionComponent: TransitionComponent,
        fullScreen: true,
        disableEscapeKeyDown: true,
        children: [
            handleClose && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                sx: {
                    position: 'fixed',
                    right: 6,
                    top: 6
                },
                edge: closePosition,
                color: "inherit",
                onClick: handleClose,
                "aria-label": "close",
                className: "dialog-close-button",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CloseIcon), {})
            }),
            children
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"isGfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewAssessment);
parcelHelpers.export(exports, "assessmentStyles", ()=>assessmentStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _navigation = require("./Navigation");
var _navigationDefault = parcelHelpers.interopDefault(_navigation);
var _timer = require("./Timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
var _sections = require("./Sections");
var _sectionsDefault = parcelHelpers.interopDefault(_sections);
var _section = require("./Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _question = require("./Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
var _questionIndicators = require("./components/question-indicators");
var _questionIndicatorsDefault = parcelHelpers.interopDefault(_questionIndicators);
var _fullScreenDialog = require("../../FullScreenDialog");
var _fullScreenDialogDefault = parcelHelpers.interopDefault(_fullScreenDialog);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
const useStyles = (0, _material.makeStyles)(assessmentStyles);
function PreviewAssessment({ context, imported }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { quizAssessment: assessment, quizSections, quizQuestions, assessment: assessmentId, translate, sectionId, link, quizTypesMap, sectionName } = context;
    const { title, type } = assessment;
    const assessmentLoaded = !context.quizSearch.assessment;
    const sections = assessment.id == assessmentId ? (0, _lodash.orderBy)(quizSections.filter((s)=>quizQuestions[s.id] && quizQuestions[s.id].length > 0), 'index').map((section)=>{
        const questions = (0, _lodash.orderBy)(quizQuestions[section.id] || [], 'index');
        return {
            ...section,
            questions
        };
    }) : [];
    const redirect = !imported && sections.length > 0 && !sectionId;
    const redirectLink = redirect && link({
        sectionId: sections[0].id
    });
    const typeName = imported ? context.languageId === 'es' ? 'Examen' : 'Exam' : translate(quizTypesMap[type]);
    const isSection = !context.questionId;
    const closeLink = imported ? imported.closeLink : link({}, context.quizPreviewFrom || '/:languageId/:role/:page/assessments', {
        query: context.quizPreviewFromQuery
    });
    async function handleTakeTest() {
        if (imported) return imported.onStart();
        const [id] = await (0, _commandDefault.default)('quiz', 'startTestAssessment')({
            id: assessment.id
        });
        if (id) history.push(context.link({
            action: 'take',
            sectionId: undefined,
            questionId: undefined
        }));
    }
    async function handleSave() {
        const [id] = await (0, _commandDefault.default)('quiz', 'duplicateAssessment')({
            id: assessment.id,
            title: assessment.title
        });
        context.navigate({
            tab: 'assessments'
        }, '/:languageId/:role/:page/:tab', {
            query: {
                id
            }
        });
    }
    return redirectLink ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
        to: redirectLink
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenDialogDefault.default), {
        TransitionComponent: undefined,
        open: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.label,
                            children: translate('preview-header')
                        }),
                        sections.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.button, classes.take),
                            onClick: handleTakeTest,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "label",
                                children: [
                                    translate('take-test-exam'),
                                    " ",
                                    typeName
                                ]
                            })
                        }),
                        !imported && !assessment.owned && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.button, classes.save),
                            onClick: handleSave,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faFileExport)
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "label",
                                    children: translate('save-assessment')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            className: (0, _clsxDefault.default)(classes.button, classes.close),
                            to: closeLink,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "label",
                                    children: translate('close')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.preview,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
                            className: classes.view,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.viewHeader,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: "type",
                                            children: [
                                                typeName,
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            className: "title",
                                            children: title
                                        }),
                                        !isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionIndicatorsDefault.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.viewContent,
                                    children: [
                                        isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDefault.default), {
                                            sections,
                                            context
                                        }),
                                        !isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                                            sections,
                                            context
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.viewNavigation,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationDefault.default), {
                                        sections,
                                        context
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.side,
                            children: [
                                assessment.isAssignment && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timerDefault.default), {
                                    context: context
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionsDefault.default), {
                                    sections,
                                    context
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function assessmentStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        header: {
            padding: 10,
            display: 'flex'
        },
        label: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flexGrow: 1,
            color: '#4d5361',
            fontSize: '13pt',
            fontWeight: 'bold'
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {}
        },
        save: {
            marginLeft: 20,
            '& .icon': {
                marginTop: -3,
                marginRight: 3,
                fontSize: '12pt'
            }
        },
        close: {
            marginLeft: 20,
            '& .icon': {
                marginTop: -3,
                marginRight: 3,
                fontSize: '8pt'
            }
        },
        preview: {
            display: 'flex',
            padding: 10,
            flexGrow: 1,
            overflowY: 'hidden'
        },
        view: {
            flexGrow: 1,
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        viewHeader: {
            display: 'flex',
            color: '#4d5361',
            fontSize: '13pt',
            padding: 20,
            borderBottom: 'solid 1px #d3d8db',
            "& .type": {
                fontWeight: 'bold'
            },
            "& .title": {
                marginLeft: 3,
                flexGrow: 1
            }
        },
        viewContent: {
            display: 'flex',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        viewNavigation: {
            borderTop: 'solid 1px #d3d8db',
            padding: 20
        },
        side: {
            marginLeft: 25,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 255,
            maxWidth: 255
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","@mui/icons-material/Close":"acjz6","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./Navigation":"eSB3u","./Timer":"doVGc","./Sections":"bp8Uy","./Section":"fSpuw","./Question":"13cYm","./components/question-indicators":"51Uwd","../../FullScreenDialog":"cr6Y6","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eSB3u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigation);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _icons = require("../../../resources/icons");
const useStyles = (0, _material.makeStyles)(navigationStyles);
function Navigation({ sections, context }) {
    const { questionId, sectionId, translate } = context;
    const link = (sectionId, questionId)=>context.link({
            sectionId,
            questionId
        });
    const classes = useStyles();
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const questionIndex = questionId && section ? section.questions.findIndex((q)=>q.id == questionId) : -1;
    const question = questionIndex >= 0 && section.questions[questionIndex];
    const isFirst = !questionId && sectionIndex == 0;
    const isLastSection = sectionIndex == sections.length - 1;
    const isLastQuestion = section && questionIndex == section.questions.length - 1;
    const isLast = isLastSection && isLastQuestion;
    const nextTo = ()=>{
        if (!section) return '#';
        if (questionId) return isLastQuestion ? link(sections[sectionIndex + 1].id) : link(sectionId, section.questions[questionIndex + 1].id);
        return link(sectionId, section.questions[0].id);
    };
    const previousTo = ()=>{
        if (!section) return '#';
        if (questionId) return questionIndex == 0 ? link(sectionId) : link(sectionId, section.questions[questionIndex - 1].id);
        const previousSection = sections[sectionIndex - 1];
        const lastQuestion = previousSection.questions[previousSection.questions.length - 1];
        if (lastQuestion) return link(previousSection.id, lastQuestion.id);
        return '#';
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "filler"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    !isFirst && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NavigationButton, {
                        name: "previous",
                        to: previousTo(),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.buttonIcon,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowLeftIcon), {
                                    width: "16px",
                                    height: "25px",
                                    fill: "#6278f0"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.buttonLabel, "previous"),
                                children: translate('previous')
                            })
                        ]
                    }),
                    !isLast && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NavigationButton, {
                        name: "next",
                        to: nextTo(),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.buttonLabel, "next"),
                                children: translate('next')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.buttonIcon,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowRightIcon), {
                                    width: "16px",
                                    height: "25px",
                                    fill: "#6278f0"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function NavigationButton(props) {
    const { name, onClick, to } = props;
    const classes = useStyles();
    const Elem = to ? (0, _reactRouterDom.Link) : (0, _boxDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Elem, {
        to: to,
        onClick: onClick,
        className: (0, _clsxDefault.default)(classes.button, name),
        children: props.children
    });
}
function navigationStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            display: 'flex',
            "& .filler": {
                flexGrow: 1
            }
        },
        buttons: {
            display: 'flex'
        },
        button: {
            display: 'flex',
            padding: '5px',
            fontSize: '12pt',
            backgroundColor: '#f0f0f0',
            color: '#6278f0',
            borderRadius: 3,
            width: 110,
            textDecoration: 'none',
            "&:last-child": {
                marginLeft: 20
            }
        },
        buttonLabel: {
            flexGrow: 1,
            ...verticalCentering,
            textAlign: 'center'
        },
        buttonIcon: {
            ...verticalCentering
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/FormControlLabel":"kemIW","@mui/material/Checkbox":"4sdMA","../../../resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"doVGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Timer);
parcelHelpers.export(exports, "timerStyles", ()=>timerStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("../../../helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _intervalHook = require("../../../helpers/interval-hook");
var _intervalHookDefault = parcelHelpers.interopDefault(_intervalHook);
const useStyles = (0, _material.makeStyles)(timerStyles);
function Timer({ context }) {
    const classes = useStyles();
    const { quizAssessment: assessment, translate } = context;
    const { assignment = {} } = assessment;
    const [count, setCount] = (0, _reactDefault.default).useState(0);
    (0, _intervalHookDefault.default)(()=>{
        setCount(count - 1);
    }, count > 0 ? 1000 : null);
    const duration = (0, _momentDefault.default).duration(assignment.duration, 'seconds').humanize();
    (0, _reactDefault.default).useEffect(()=>{
        if (assignment) {
            const deadline = (0, _momentDefault.default)().add(assignment.duration, 'seconds');
            const remaining = (0, _momentDefault.default).duration(deadline.diff((0, _momentDefault.default)()));
            const countdown = Math.floor(remaining.asSeconds());
            setCount(countdown);
        }
    }, [
        assignment
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.countdown,
                children: formatCountDown(count)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.duration,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.durationLabel,
                        children: [
                            translate('assessment-duration'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        children: duration
                    })
                ]
            })
        ]
    });
}
function formatCountDown(time) {
    const hours = Math.floor(time / 3600).toString().padStart(2, 0);
    const minutes = Math.floor(time % 3600 / 60).toString().padStart(2, 0);
    const seconds = Math.floor(time % 60).toString().padStart(2, 0);
    return `${hours}:${minutes}:${seconds}`;
}
function timerStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 18,
            padding: 25,
            color: '#505163'
        },
        countdown: {
            display: 'flex',
            justifyContent: 'center',
            fontSize: '18pt',
            fontWeight: 'bold',
            color: '#1e4c97'
        },
        duration: {
            marginTop: 10,
            fontSize: '9pt',
            display: 'flex'
        },
        "durationLabel": {
            marginRight: 3
        }
    };
}

},{"react/jsx-runtime":"1dlk8","../../../helpers/moment":"jwdju","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","../../../helpers/interval-hook":"5BIPQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5BIPQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useInterval);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useInterval(callback, delay) {
    const savedCallback = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, _react.useEffect)(()=>{
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bp8Uy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Sections);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _sectionLink = require("./SectionLink");
var _sectionLinkDefault = parcelHelpers.interopDefault(_sectionLink);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Sections({ sections, context }) {
    const classes = useStyles();
    const createSection = (section, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionLinkDefault.default), {
            key: section.id,
            index,
            section,
            context,
            sections
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.label,
                    children: context.translate('questions')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.sections,
                children: sections.map(createSection)
            })
        ]
    });
}
function sectionStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            display: 'flex',
            padding: 10,
            color: '#555764',
            fontSize: '12pt'
        },
        label: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        sections: {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","./SectionLink":"hCpuh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hCpuh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
parcelHelpers.export(exports, "sectionStyles", ()=>sectionStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
var _questionLink = require("./QuestionLink");
var _questionLinkDefault = parcelHelpers.interopDefault(_questionLink);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ index, section, sections, context }) {
    const classes = useStyles();
    const { translate } = context;
    const { questions = [] } = section;
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${index + 1}` : section.title;
    const chunkSize = 4;
    const questionRows = (0, _lodash.chunk)(questions.map((question, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionLinkDefault.default), {
            index,
            section,
            question,
            context,
            sections
        }, question.id)), chunkSize);
    const addDummies = (row)=>{
        const missing = chunkSize - row.length;
        const newRow = missing == 0 ? row : row.concat((0, _lodash.range)(missing).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionLink.QuestionLinkDummy), {}, row.length + index)));
        return newRow;
    };
    const sectionLink = context.link({
        sectionId: section.id,
        questionId: null
    });
    const selected = section.id == context.sectionId && !context.questionId;
    function handleClick(e) {
        selected && e.preventDefault();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: (0, _clsxDefault.default)(classes.title, {
                    selected
                }),
                onClick: handleClick,
                to: sectionLink,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.questions,
                children: questionRows.map((row, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.questionRow,
                        children: addDummies(row)
                    }, index))
            })
        ]
    });
}
function sectionStyles(theme) {
    return {
        title: {
            display: 'flex',
            padding: 10,
            textDecoration: 'none',
            color: '#5c6fcd',
            fontSize: '11pt',
            borderTop: 'solid 1px #e1e5e8',
            borderBottom: 'solid 1px #e1e5e8',
            borderLeft: 'solid 4px #577ee3',
            backgroundColor: '#fff7f3',
            "&.selected": {
                backgroundColor: '#577ee3',
                color: '#fff',
                cursor: 'default'
            }
        },
        questions: {
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 5px'
        },
        questionRow: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: 10
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","./QuestionLink":"4ZKzy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ZKzy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionLink);
parcelHelpers.export(exports, "QuestionLinkDummy", ()=>QuestionLinkDummy);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _fab = require("@mui/material/Fab");
var _fabDefault = parcelHelpers.interopDefault(_fab);
var _utils = require("./utils");
const useStyles = (0, _material.makeStyles)(linkStyles);
function QuestionLink({ section, sections, context, question, index }) {
    const classes = useStyles();
    const { answers = {} } = context.assessment;
    const answer = answers[question.id] || {};
    const selected = question.id == context.questionId && section.id == context.sectionId;
    const marked = answer.pending == true;
    const answered = answer.completed && !marked;
    const onClick = (e)=>selected && e.preventDefault();
    const className = (0, _clsxDefault.default)(classes.root, {
        selected,
        marked,
        answered
    });
    const href = '#' + context.link({
        sectionId: section.id,
        questionId: question.id
    });
    const globalIndex = (0, _utils.findGlobalIndex)(question.id, sections);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fabDefault.default), {
        size: 'small',
        onClick,
        className,
        href,
        children: globalIndex + 1
    });
}
function QuestionLinkDummy() {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fabDefault.default), {
        size: "small",
        className: (0, _clsxDefault.default)(classes.root, "dummy"),
        children: "0"
    });
}
function linkStyles(theme) {
    return {
        root: {
            backgroundColor: '#f3f4f6',
            color: '#a3aab0',
            boxShadow: 'none',
            marginRight: 10,
            "& .MuiFab-label": {
                paddingTop: 2
            },
            "&:last-child": {
                marginRight: 0
            },
            "&.dummy": {
                visibility: 'hidden'
            },
            "&.marked": {
                backgroundColor: '#ef0e0a',
                color: '#fff'
            },
            "&.answered": {
                backgroundColor: '#52aa5e',
                color: '#fff'
            },
            "&.selected": {
                backgroundColor: '#000',
                color: '#fff',
                cursor: 'default'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Fab":"9QkHI","./utils":"kJZMw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9QkHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _fabDefault.default));
parcelHelpers.export(exports, "fabClasses", ()=>(0, _fabClassesDefault.default));
var _fab = require("./Fab");
var _fabDefault = parcelHelpers.interopDefault(_fab);
var _fabClasses = require("./fabClasses");
var _fabClassesDefault = parcelHelpers.interopDefault(_fabClasses);
parcelHelpers.exportAll(_fabClasses, exports);
'use client';

},{"./Fab":"5qRFK","./fabClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5qRFK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _buttonBase = require("../ButtonBase");
var _buttonBaseDefault = parcelHelpers.interopDefault(_buttonBase);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _fabClasses = require("./fabClasses");
var _fabClassesDefault = parcelHelpers.interopDefault(_fabClasses);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableFocusRipple",
    "focusVisibleClassName",
    "size",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { color, variant, classes, size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, _capitalizeDefault.default)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, _composeClassesDefault.default)(slots, (0, _fabClasses.getFabUtilityClass), classes);
    return (0, _extendsDefault.default)({}, classes, composedClasses);
};
const FabRoot = (0, _styledDefault.default)((0, _buttonBaseDefault.default), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, _styled.rootShouldForwardProp)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, _capitalizeDefault.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, _capitalizeDefault.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})(({ theme, ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    return (0, _extendsDefault.default)({}, theme.typography.button, {
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, _fabClassesDefault.default).focusVisible}`]: {
            boxShadow: (theme.vars || theme).shadows[6]
        }
    }, ownerState.size === 'small' && {
        width: 40,
        height: 40
    }, ownerState.size === 'medium' && {
        width: 48,
        height: 48
    }, ownerState.variant === 'extended' && {
        borderRadius: 24,
        padding: '0 16px',
        width: 'auto',
        minHeight: 'auto',
        minWidth: 48,
        height: 48
    }, ownerState.variant === 'extended' && ownerState.size === 'small' && {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 17,
        minWidth: 34,
        height: 34
    }, ownerState.variant === 'extended' && ownerState.size === 'medium' && {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 20,
        minWidth: 40,
        height: 40
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    });
}, ({ theme, ownerState })=>(0, _extendsDefault.default)({}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (theme.vars || theme).palette[ownerState.color] != null && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }), ({ theme })=>({
        [`&.${(0, _fabClassesDefault.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    }));
const Fab = /*#__PURE__*/ _react.forwardRef(function Fab(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children, className, color = 'default', component = 'button', disabled = false, disableFocusRipple = false, focusVisibleClassName, size = 'large', variant = 'circular' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        component,
        disabled,
        disableFocusRipple,
        size,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FabRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, _clsxDefault.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other, {
        classes: classes,
        children: children
    }));
});
exports.default = Fab;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","../ButtonBase":"ajcyv","../utils/capitalize":"hBZko","../DefaultPropsProvider":"ff3VX","./fabClasses":"fVGsQ","../styles/styled":"bTnxF","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fVGsQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFabUtilityClass", ()=>getFabUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getFabUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiFab', slot);
}
const fabClasses = (0, _generateUtilityClassesDefault.default)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
exports.default = fabClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kJZMw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findGlobalIndex", ()=>findGlobalIndex);
function findGlobalIndex(id, sections = []) {
    let j = 0;
    for(let i = 0; i < sections.length; i++){
        const section = sections[i];
        const index = section.questions.findIndex((q)=>q.id == id);
        if (index >= 0) return j + index;
        j += section.questions.length;
    }
    return -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fSpuw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ sections, context }) {
    const { sectionId, translate } = context;
    const classes = useStyles();
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title;
    const instructions = section && ((0, _utils.isEmpty)(section.instructions) ? false : section.instructions);
    const defaultInstructions = translate('default-section-instructions');
    const hasDefaultInstructions = defaultInstructions != 'default-section-instructions';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.title,
                    children: title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    (instructions || hasDefaultInstructions) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.label,
                        children: translate('instructions')
                    }),
                    instructions && (context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        className: classes.instructions,
                        html: instructions
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.instructions,
                        dangerouslySetInnerHTML: {
                            __html: instructions
                        }
                    })),
                    !instructions && hasDefaultInstructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.instructions,
                        children: defaultInstructions
                    })
                ]
            })
        ]
    });
}
function sectionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '13pt',
            padding: '10px 20px',
            borderBottom: 'solid 1px #d0d5d8'
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: '90px 120px',
            display: 'flex',
            flexDirection: 'column'
        },
        label: {
            fontWeight: 'bold',
            fontSize: '12pt',
            marginBottom: 40
        },
        instructions: {
            fontSize: '11pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cDby1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MathHtml);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _katex = require("external/katex");
function MathHtml({ html = '', ...props }) {
    const element = (0, _react.useRef)(null);
    const content = html || '';
    (0, _react.useEffect)(()=>{
        if (!element.current) return;
        try {
            (0, _katex.renderMathInElement)(element.current, {
                delimiters: [
                    {
                        left: '\\(',
                        right: '\\)',
                        display: false
                    },
                    {
                        left: '\\[',
                        right: '\\]',
                        display: true
                    }
                ],
                throwOnError: false,
                ignoredTags: [
                    'script',
                    'noscript',
                    'style',
                    'textarea',
                    'pre',
                    'code',
                    'option'
                ]
            });
        } catch (error) {
            console.warn('Unable to render imported-assessment mathematics', error);
        }
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ...props,
        ref: element,
        dangerouslySetInnerHTML: {
            __html: content
        }
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/katex":"bNl7I","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bNl7I":[function(require,module,exports,__globalThis) {
// Centralized KaTeX dependency boundary for imported-assessment mathematics.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderMathInElement", ()=>(0, _autoRenderMjsDefault.default));
var _autoRenderMjs = require("katex/dist/contrib/auto-render.mjs");
var _autoRenderMjsDefault = parcelHelpers.interopDefault(_autoRenderMjs);
var _katexMinCss = require("katex/dist/katex.min.css");

},{"katex/dist/contrib/auto-render.mjs":"hfiGg","katex/dist/katex.min.css":"6lnPH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfiGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>renderMathInElement);
var _katexMjs = require("../katex.mjs");
var _katexMjsDefault = parcelHelpers.interopDefault(_katexMjs);
/* eslint no-constant-condition:0 */ var findEndOfMath = function findEndOfMath(delimiter, text, startIndex) {
    // Adapted from
    // https://github.com/Khan/perseus/blob/master/src/perseus-markdown.jsx
    var index = startIndex;
    var braceLevel = 0;
    var delimLength = delimiter.length;
    while(index < text.length){
        var character = text[index];
        if (braceLevel <= 0 && text.slice(index, index + delimLength) === delimiter) return index;
        else if (character === "\\") index++;
        else if (character === "{") braceLevel++;
        else if (character === "}") braceLevel--;
        index++;
    }
    return -1;
};
var escapeRegex = function escapeRegex(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
};
var amsRegex = /^\\begin{/;
var splitAtDelimiters = function splitAtDelimiters(text, delimiters) {
    var index;
    var data = [];
    var regexLeft = new RegExp("(" + delimiters.map((x)=>escapeRegex(x.left)).join("|") + ")");
    while(true){
        index = text.search(regexLeft);
        if (index === -1) break;
        if (index > 0) {
            data.push({
                type: "text",
                data: text.slice(0, index)
            });
            text = text.slice(index); // now text starts with delimiter
        } // ... so this always succeeds:
        var i = delimiters.findIndex((delim)=>text.startsWith(delim.left));
        index = findEndOfMath(delimiters[i].right, text, delimiters[i].left.length);
        if (index === -1) break;
        var rawData = text.slice(0, index + delimiters[i].right.length);
        var math = amsRegex.test(rawData) ? rawData : text.slice(delimiters[i].left.length, index);
        data.push({
            type: "math",
            data: math,
            rawData,
            display: delimiters[i].display
        });
        text = text.slice(index + delimiters[i].right.length);
    }
    if (text !== "") data.push({
        type: "text",
        data: text
    });
    return data;
};
/* eslint no-console:0 */ /* Note: optionsCopy is mutated by this method. If it is ever exposed in the
 * API, we should copy it before mutating.
 */ var renderMathInText = function renderMathInText(text, optionsCopy) {
    var data = splitAtDelimiters(text, optionsCopy.delimiters);
    if (data.length === 1 && data[0].type === 'text') // There is no formula in the text.
    // Let's return null which means there is no need to replace
    // the current text node with a new one.
    return null;
    var fragment = document.createDocumentFragment();
    for(var i = 0; i < data.length; i++)if (data[i].type === "text") fragment.appendChild(document.createTextNode(data[i].data));
    else {
        var span = document.createElement("span");
        var math = data[i].data; // Override any display mode defined in the settings with that
        // defined by the text itself
        optionsCopy.displayMode = data[i].display;
        try {
            if (optionsCopy.preProcess) math = optionsCopy.preProcess(math);
            (0, _katexMjsDefault.default).render(math, span, optionsCopy);
        } catch (e) {
            if (!(e instanceof (0, _katexMjsDefault.default).ParseError)) throw e;
            optionsCopy.errorCallback("KaTeX auto-render: Failed to parse `" + data[i].data + "` with ", e);
            fragment.appendChild(document.createTextNode(data[i].rawData));
            continue;
        }
        fragment.appendChild(span);
    }
    return fragment;
};
var renderElem = function renderElem(elem, optionsCopy) {
    for(var i = 0; i < elem.childNodes.length; i++){
        var childNode = elem.childNodes[i];
        if (childNode.nodeType === 3) {
            // Text node
            // Concatenate all sibling text nodes.
            // Webkit browsers split very large text nodes into smaller ones,
            // so the delimiters may be split across different nodes.
            var textContentConcat = childNode.textContent;
            var sibling = childNode.nextSibling;
            var nSiblings = 0;
            while(sibling && sibling.nodeType === Node.TEXT_NODE){
                textContentConcat += sibling.textContent;
                sibling = sibling.nextSibling;
                nSiblings++;
            }
            var frag = renderMathInText(textContentConcat, optionsCopy);
            if (frag) {
                // Remove extra text nodes
                for(var j = 0; j < nSiblings; j++)childNode.nextSibling.remove();
                i += frag.childNodes.length - 1;
                elem.replaceChild(frag, childNode);
            } else // If the concatenated text does not contain math
            // the siblings will not either
            i += nSiblings;
        } else if (childNode.nodeType === 1) (function() {
            // Element node
            var className = ' ' + childNode.className + ' ';
            var shouldRender = optionsCopy.ignoredTags.indexOf(childNode.nodeName.toLowerCase()) === -1 && optionsCopy.ignoredClasses.every((x)=>className.indexOf(' ' + x + ' ') === -1);
            if (shouldRender) renderElem(childNode, optionsCopy);
        })();
         // Otherwise, it's something else, and ignore it.
    }
};
var renderMathInElement = function renderMathInElement(elem, options) {
    if (!elem) throw new Error("No element provided to render");
    var optionsCopy = {}; // Object.assign(optionsCopy, option)
    for(var option in options)if (options.hasOwnProperty(option)) optionsCopy[option] = options[option];
     // default options
    optionsCopy.delimiters = optionsCopy.delimiters || [
        {
            left: "$$",
            right: "$$",
            display: true
        },
        {
            left: "\\(",
            right: "\\)",
            display: false
        },
        // {left: "$", right: "$", display: false},
        // $ must come after $$
        // Render AMS environments even if outside $$…$$ delimiters.
        {
            left: "\\begin{equation}",
            right: "\\end{equation}",
            display: true
        },
        {
            left: "\\begin{align}",
            right: "\\end{align}",
            display: true
        },
        {
            left: "\\begin{alignat}",
            right: "\\end{alignat}",
            display: true
        },
        {
            left: "\\begin{gather}",
            right: "\\end{gather}",
            display: true
        },
        {
            left: "\\begin{CD}",
            right: "\\end{CD}",
            display: true
        },
        {
            left: "\\[",
            right: "\\]",
            display: true
        }
    ];
    optionsCopy.ignoredTags = optionsCopy.ignoredTags || [
        "script",
        "noscript",
        "style",
        "textarea",
        "pre",
        "code",
        "option"
    ];
    optionsCopy.ignoredClasses = optionsCopy.ignoredClasses || [];
    optionsCopy.errorCallback = optionsCopy.errorCallback || console.error; // Enable sharing of global macros defined via `\gdef` between different
    // math elements within a single call to `renderMathInElement`.
    optionsCopy.macros = optionsCopy.macros || {};
    renderElem(elem, optionsCopy);
};

},{"../katex.mjs":"jrq1o","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrq1o":[function(require,module,exports,__globalThis) {
/**
 * Lexing or parsing positional information for error reporting.
 * This object is immutable.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParseError", ()=>ParseError);
parcelHelpers.export(exports, "SETTINGS_SCHEMA", ()=>SETTINGS_SCHEMA);
parcelHelpers.export(exports, "__defineFunction", ()=>defineFunction);
parcelHelpers.export(exports, "__defineMacro", ()=>defineMacro);
parcelHelpers.export(exports, "__defineSymbol", ()=>defineSymbol);
parcelHelpers.export(exports, "__domTree", ()=>__domTree);
parcelHelpers.export(exports, "__parse", ()=>generateParseTree);
parcelHelpers.export(exports, "__renderToDomTree", ()=>renderToDomTree);
parcelHelpers.export(exports, "__renderToHTMLTree", ()=>renderToHTMLTree);
parcelHelpers.export(exports, "__setFontMetrics", ()=>setFontMetrics);
parcelHelpers.export(exports, "default", ()=>katex);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "renderToString", ()=>renderToString);
parcelHelpers.export(exports, "version", ()=>version);
class SourceLocation {
    // The + prefix indicates that these fields aren't writeable
    // Lexer holding the input string.
    // Start offset, zero-based inclusive.
    // End offset, zero-based exclusive.
    constructor(lexer, start, end){
        this.lexer = void 0;
        this.start = void 0;
        this.end = void 0;
        this.lexer = lexer;
        this.start = start;
        this.end = end;
    }
    /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */ static range(first, second) {
        if (!second) return first && first.loc;
        else if (!first || !first.loc || !second.loc || first.loc.lexer !== second.loc.lexer) return null;
        else return new SourceLocation(first.loc.lexer, first.loc.start, second.loc.end);
    }
}
/**
 * Interface required to break circular dependency between Token, Lexer, and
 * ParseError.
 */ /**
 * The resulting token returned from `lex`.
 *
 * It consists of the token text plus some position information.
 * The position information is essentially a range in an input string,
 * but instead of referencing the bare input string, we refer to the lexer.
 * That way it is possible to attach extra metadata to the input string,
 * like for example a file name or similar.
 *
 * The position information is optional, so it is OK to construct synthetic
 * tokens if appropriate. Not providing available position information may
 * lead to degraded error reporting, though.
 */ class Token {
    // don't expand the token
    // used in \noexpand
    constructor(text, loc){
        this.text = void 0;
        this.loc = void 0;
        this.noexpand = void 0;
        this.treatAsRelax = void 0;
        this.text = text;
        this.loc = loc;
    }
    /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */ range(endToken, text // the text of the newly constructed token
    ) {
        return new Token(text, SourceLocation.range(this, endToken));
    }
}
/**
 * This is the ParseError class, which is the main error thrown by KaTeX
 * functions when something has gone wrong. This is used to distinguish internal
 * errors from errors in the expression that the user provided.
 *
 * If possible, a caller should provide a Token or ParseNode with information
 * about where in the source string the problem occurred.
 */ class ParseError {
    // Error start position based on passed-in Token or ParseNode.
    // Length of affected text based on passed-in Token or ParseNode.
    // The underlying error message without any context added.
    constructor(message, token // An object providing position information
    ){
        this.name = void 0;
        this.position = void 0;
        this.length = void 0;
        this.rawMessage = void 0;
        var error = "KaTeX parse error: " + message;
        var start;
        var end;
        var loc = token && token.loc;
        if (loc && loc.start <= loc.end) {
            // If we have the input and a position, make the error a bit fancier
            // Get the input
            var input = loc.lexer.input; // Prepend some information
            start = loc.start;
            end = loc.end;
            if (start === input.length) error += " at end of input: ";
            else error += " at position " + (start + 1) + ": ";
             // Underline token in question using combining underscores
            var underlined = input.slice(start, end).replace(/[^]/g, "$&\u0332"); // Extract some context from the input and add it to the error
            var left;
            if (start > 15) left = "\u2026" + input.slice(start - 15, start);
            else left = input.slice(0, start);
            var right;
            if (end + 15 < input.length) right = input.slice(end, end + 15) + "\u2026";
            else right = input.slice(end);
            error += left + underlined + right;
        } // Some hackery to make ParseError a prototype of Error
        // See http://stackoverflow.com/a/8460753
        // $FlowFixMe
        var self = new Error(error);
        self.name = "ParseError"; // $FlowFixMe
        self.__proto__ = ParseError.prototype;
        self.position = start;
        if (start != null && end != null) self.length = end - start;
        self.rawMessage = message;
        return self;
    }
} // $FlowFixMe More hackery
ParseError.prototype.__proto__ = Error.prototype;
/**
 * This file contains a list of utility functions which are useful in other
 * files.
 */ /**
 * Provide a default value if a setting is undefined
 * NOTE: Couldn't use `T` as the output type due to facebook/flow#5022.
 */ var deflt = function deflt(setting, defaultIfUndefined) {
    return setting === undefined ? defaultIfUndefined : setting;
}; // hyphenate and escape adapted from Facebook's React under Apache 2 license
var uppercase = /([A-Z])/g;
var hyphenate = function hyphenate(str) {
    return str.replace(uppercase, "-$1").toLowerCase();
};
var ESCAPE_LOOKUP = {
    "&": "&amp;",
    ">": "&gt;",
    "<": "&lt;",
    "\"": "&quot;",
    "'": "&#x27;"
};
var ESCAPE_REGEX = /[&><"']/g;
/**
 * Escapes text to prevent scripting attacks.
 */ function escape(text) {
    return String(text).replace(ESCAPE_REGEX, (match)=>ESCAPE_LOOKUP[match]);
}
/**
 * Sometimes we want to pull out the innermost element of a group. In most
 * cases, this will just be the group itself, but when ordgroups and colors have
 * a single element, we want to pull that out.
 */ var getBaseElem = function getBaseElem(group) {
    if (group.type === "ordgroup") {
        if (group.body.length === 1) return getBaseElem(group.body[0]);
        else return group;
    } else if (group.type === "color") {
        if (group.body.length === 1) return getBaseElem(group.body[0]);
        else return group;
    } else if (group.type === "font") return getBaseElem(group.body);
    else return group;
};
/**
 * TeXbook algorithms often reference "character boxes", which are simply groups
 * with a single character in them. To decide if something is a character box,
 * we find its innermost group, and see if it is a single character.
 */ var isCharacterBox = function isCharacterBox(group) {
    var baseElem = getBaseElem(group); // These are all they types of groups which hold single characters
    return baseElem.type === "mathord" || baseElem.type === "textord" || baseElem.type === "atom";
};
var assert = function assert(value) {
    if (!value) throw new Error('Expected non-null, but got ' + String(value));
    return value;
};
/**
 * Return the protocol of a URL, or "_relative" if the URL does not specify a
 * protocol (and thus is relative), or `null` if URL has invalid protocol
 * (so should be outright rejected).
 */ var protocolFromUrl = function protocolFromUrl(url) {
    // Check for possible leading protocol.
    // https://url.spec.whatwg.org/#url-parsing strips leading whitespace
    // (U+20) or C0 control (U+00-U+1F) characters.
    // eslint-disable-next-line no-control-regex
    var protocol = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(url);
    if (!protocol) return "_relative";
     // Reject weird colons
    if (protocol[2] !== ":") return null;
     // Reject invalid characters in scheme according to
    // https://datatracker.ietf.org/doc/html/rfc3986#section-3.1
    if (!/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(protocol[1])) return null;
     // Lowercase the protocol
    return protocol[1].toLowerCase();
};
var utils = {
    deflt,
    escape,
    hyphenate,
    getBaseElem,
    isCharacterBox,
    protocolFromUrl
};
/* eslint no-console:0 */ // TODO: automatically generate documentation
// TODO: check all properties on Settings exist
// TODO: check the type of a property on Settings matches
var SETTINGS_SCHEMA = {
    displayMode: {
        type: "boolean",
        description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
        cli: "-d, --display-mode"
    },
    output: {
        type: {
            enum: [
                "htmlAndMathml",
                "html",
                "mathml"
            ]
        },
        description: "Determines the markup language of the output.",
        cli: "-F, --format <type>"
    },
    leqno: {
        type: "boolean",
        description: "Render display math in leqno style (left-justified tags)."
    },
    fleqn: {
        type: "boolean",
        description: "Render display math flush left."
    },
    throwOnError: {
        type: "boolean",
        default: true,
        cli: "-t, --no-throw-on-error",
        cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
    },
    errorColor: {
        type: "string",
        default: "#cc0000",
        cli: "-c, --error-color <color>",
        cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
        cliProcessor: (color)=>"#" + color
    },
    macros: {
        type: "object",
        cli: "-m, --macro <def>",
        cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
        cliDefault: [],
        cliProcessor: (def, defs)=>{
            defs.push(def);
            return defs;
        }
    },
    minRuleThickness: {
        type: "number",
        description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
        processor: (t)=>Math.max(0, t),
        cli: "--min-rule-thickness <size>",
        cliProcessor: parseFloat
    },
    colorIsTextColor: {
        type: "boolean",
        description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
        cli: "-b, --color-is-text-color"
    },
    strict: {
        type: [
            {
                enum: [
                    "warn",
                    "ignore",
                    "error"
                ]
            },
            "boolean",
            "function"
        ],
        description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
        cli: "-S, --strict",
        cliDefault: false
    },
    trust: {
        type: [
            "boolean",
            "function"
        ],
        description: "Trust the input, enabling all HTML features such as \\url.",
        cli: "-T, --trust"
    },
    maxSize: {
        type: "number",
        default: Infinity,
        description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
        processor: (s)=>Math.max(0, s),
        cli: "-s, --max-size <n>",
        cliProcessor: parseInt
    },
    maxExpand: {
        type: "number",
        default: 1000,
        description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
        processor: (n)=>Math.max(0, n),
        cli: "-e, --max-expand <n>",
        cliProcessor: (n)=>n === "Infinity" ? Infinity : parseInt(n)
    },
    globalGroup: {
        type: "boolean",
        cli: false
    }
};
function getDefaultValue(schema) {
    if (schema.default) return schema.default;
    var type = schema.type;
    var defaultType = Array.isArray(type) ? type[0] : type;
    if (typeof defaultType !== 'string') return defaultType.enum[0];
    switch(defaultType){
        case 'boolean':
            return false;
        case 'string':
            return '';
        case 'number':
            return 0;
        case 'object':
            return {};
    }
}
/**
 * The main Settings object
 *
 * The current options stored are:
 *  - displayMode: Whether the expression should be typeset as inline math
 *                 (false, the default), meaning that the math starts in
 *                 \textstyle and is placed in an inline-block); or as display
 *                 math (true), meaning that the math starts in \displaystyle
 *                 and is placed in a block with vertical margin.
 */ class Settings {
    constructor(options){
        this.displayMode = void 0;
        this.output = void 0;
        this.leqno = void 0;
        this.fleqn = void 0;
        this.throwOnError = void 0;
        this.errorColor = void 0;
        this.macros = void 0;
        this.minRuleThickness = void 0;
        this.colorIsTextColor = void 0;
        this.strict = void 0;
        this.trust = void 0;
        this.maxSize = void 0;
        this.maxExpand = void 0;
        this.globalGroup = void 0;
        // allow null options
        options = options || {};
        for(var prop in SETTINGS_SCHEMA)if (SETTINGS_SCHEMA.hasOwnProperty(prop)) {
            // $FlowFixMe
            var schema = SETTINGS_SCHEMA[prop]; // TODO: validate options
            // $FlowFixMe
            this[prop] = options[prop] !== undefined ? schema.processor ? schema.processor(options[prop]) : options[prop] : getDefaultValue(schema);
        }
    }
    /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */ reportNonstrict(errorCode, errorMsg, token) {
        var strict = this.strict;
        if (typeof strict === "function") // Allow return value of strict function to be boolean or string
        // (or null/undefined, meaning no further processing).
        strict = strict(errorCode, errorMsg, token);
        if (!strict || strict === "ignore") return;
        else if (strict === true || strict === "error") throw new ParseError("LaTeX-incompatible input and strict mode is set to 'error': " + (errorMsg + " [" + errorCode + "]"), token);
        else if (strict === "warn") typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (errorMsg + " [" + errorCode + "]"));
        else // won't happen in type-safe code
        typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + strict + "': " + errorMsg + " [" + errorCode + "]"));
    }
    /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */ useStrictBehavior(errorCode, errorMsg, token) {
        var strict = this.strict;
        if (typeof strict === "function") // Allow return value of strict function to be boolean or string
        // (or null/undefined, meaning no further processing).
        // But catch any exceptions thrown by function, treating them
        // like "error".
        try {
            strict = strict(errorCode, errorMsg, token);
        } catch (error) {
            strict = "error";
        }
        if (!strict || strict === "ignore") return false;
        else if (strict === true || strict === "error") return true;
        else if (strict === "warn") {
            typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (errorMsg + " [" + errorCode + "]"));
            return false;
        } else {
            // won't happen in type-safe code
            typeof console !== "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + strict + "': " + errorMsg + " [" + errorCode + "]"));
            return false;
        }
    }
    /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */ isTrusted(context) {
        if (context.url && !context.protocol) {
            var protocol = utils.protocolFromUrl(context.url);
            if (protocol == null) return false;
            context.protocol = protocol;
        }
        var trust = typeof this.trust === "function" ? this.trust(context) : this.trust;
        return Boolean(trust);
    }
}
/**
 * This file contains information and classes for the various kinds of styles
 * used in TeX. It provides a generic `Style` class, which holds information
 * about a specific style. It then provides instances of all the different kinds
 * of styles possible, and provides functions to move between them and get
 * information about them.
 */ /**
 * The main style class. Contains a unique id for the style, a size (which is
 * the same for cramped and uncramped version of a style), and a cramped flag.
 */ class Style {
    constructor(id, size, cramped){
        this.id = void 0;
        this.size = void 0;
        this.cramped = void 0;
        this.id = id;
        this.size = size;
        this.cramped = cramped;
    }
    /**
   * Get the style of a superscript given a base in the current style.
   */ sup() {
        return styles[sup[this.id]];
    }
    /**
   * Get the style of a subscript given a base in the current style.
   */ sub() {
        return styles[sub[this.id]];
    }
    /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */ fracNum() {
        return styles[fracNum[this.id]];
    }
    /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */ fracDen() {
        return styles[fracDen[this.id]];
    }
    /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */ cramp() {
        return styles[cramp[this.id]];
    }
    /**
   * Get a text or display version of this style.
   */ text() {
        return styles[text$1[this.id]];
    }
    /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */ isTight() {
        return this.size >= 2;
    }
} // Export an interface for type checking, but don't expose the implementation.
// This way, no more styles can be generated.
// IDs of the different styles
var D = 0;
var Dc = 1;
var T = 2;
var Tc = 3;
var S = 4;
var Sc = 5;
var SS = 6;
var SSc = 7; // Instances of the different styles
var styles = [
    new Style(D, 0, false),
    new Style(Dc, 0, true),
    new Style(T, 1, false),
    new Style(Tc, 1, true),
    new Style(S, 2, false),
    new Style(Sc, 2, true),
    new Style(SS, 3, false),
    new Style(SSc, 3, true)
]; // Lookup tables for switching from one style to another
var sup = [
    S,
    Sc,
    S,
    Sc,
    SS,
    SSc,
    SS,
    SSc
];
var sub = [
    Sc,
    Sc,
    Sc,
    Sc,
    SSc,
    SSc,
    SSc,
    SSc
];
var fracNum = [
    T,
    Tc,
    S,
    Sc,
    SS,
    SSc,
    SS,
    SSc
];
var fracDen = [
    Tc,
    Tc,
    Sc,
    Sc,
    SSc,
    SSc,
    SSc,
    SSc
];
var cramp = [
    Dc,
    Dc,
    Tc,
    Tc,
    Sc,
    Sc,
    SSc,
    SSc
];
var text$1 = [
    D,
    Dc,
    T,
    Tc,
    T,
    Tc,
    T,
    Tc
]; // We only export some of the styles.
var Style$1 = {
    DISPLAY: styles[D],
    TEXT: styles[T],
    SCRIPT: styles[S],
    SCRIPTSCRIPT: styles[SS]
};
/*
 * This file defines the Unicode scripts and script families that we
 * support. To add new scripts or families, just add a new entry to the
 * scriptData array below. Adding scripts to the scriptData array allows
 * characters from that script to appear in \text{} environments.
 */ /**
 * Each script or script family has a name and an array of blocks.
 * Each block is an array of two numbers which specify the start and
 * end points (inclusive) of a block of Unicode codepoints.
 */ /**
 * Unicode block data for the families of scripts we support in \text{}.
 * Scripts only need to appear here if they do not have font metrics.
 */ var scriptData = [
    {
        // Latin characters beyond the Latin-1 characters we have metrics for.
        // Needed for Czech, Hungarian and Turkish text, for example.
        name: 'latin',
        blocks: [
            [
                0x0100,
                0x024f
            ],
            [
                0x0300,
                0x036f
            ] // Combining Diacritical marks
        ]
    },
    {
        // The Cyrillic script used by Russian and related languages.
        // A Cyrillic subset used to be supported as explicitly defined
        // symbols in symbols.js
        name: 'cyrillic',
        blocks: [
            [
                0x0400,
                0x04ff
            ]
        ]
    },
    {
        // Armenian
        name: 'armenian',
        blocks: [
            [
                0x0530,
                0x058F
            ]
        ]
    },
    {
        // The Brahmic scripts of South and Southeast Asia
        // Devanagari (0900–097F)
        // Bengali (0980–09FF)
        // Gurmukhi (0A00–0A7F)
        // Gujarati (0A80–0AFF)
        // Oriya (0B00–0B7F)
        // Tamil (0B80–0BFF)
        // Telugu (0C00–0C7F)
        // Kannada (0C80–0CFF)
        // Malayalam (0D00–0D7F)
        // Sinhala (0D80–0DFF)
        // Thai (0E00–0E7F)
        // Lao (0E80–0EFF)
        // Tibetan (0F00–0FFF)
        // Myanmar (1000–109F)
        name: 'brahmic',
        blocks: [
            [
                0x0900,
                0x109F
            ]
        ]
    },
    {
        name: 'georgian',
        blocks: [
            [
                0x10A0,
                0x10ff
            ]
        ]
    },
    {
        // Chinese and Japanese.
        // The "k" in cjk is for Korean, but we've separated Korean out
        name: "cjk",
        blocks: [
            [
                0x3000,
                0x30FF
            ],
            [
                0x4E00,
                0x9FAF
            ],
            [
                0xFF00,
                0xFF60
            ] // Fullwidth punctuation
        ]
    },
    {
        // Korean
        name: 'hangul',
        blocks: [
            [
                0xAC00,
                0xD7AF
            ]
        ]
    }
];
/**
 * Given a codepoint, return the name of the script or script family
 * it is from, or null if it is not part of a known block
 */ function scriptFromCodepoint(codepoint) {
    for(var i = 0; i < scriptData.length; i++){
        var script = scriptData[i];
        for(var _i = 0; _i < script.blocks.length; _i++){
            var block = script.blocks[_i];
            if (codepoint >= block[0] && codepoint <= block[1]) return script.name;
        }
    }
    return null;
}
/**
 * A flattened version of all the supported blocks in a single array.
 * This is an optimization to make supportedCodepoint() fast.
 */ var allBlocks = [];
scriptData.forEach((s)=>s.blocks.forEach((b)=>allBlocks.push(...b)));
/**
 * Given a codepoint, return true if it falls within one of the
 * scripts or script families defined above and false otherwise.
 *
 * Micro benchmarks shows that this is faster than
 * /[\u3000-\u30FF\u4E00-\u9FAF\uFF00-\uFF60\uAC00-\uD7AF\u0900-\u109F]/.test()
 * in Firefox, Chrome and Node.
 */ function supportedCodepoint(codepoint) {
    for(var i = 0; i < allBlocks.length; i += 2){
        if (codepoint >= allBlocks[i] && codepoint <= allBlocks[i + 1]) return true;
    }
    return false;
}
/**
 * This file provides support to domTree.js and delimiter.js.
 * It's a storehouse of path geometry for SVG images.
 */ // In all paths below, the viewBox-to-em scale is 1000:1.
var hLinePad = 80; // padding above a sqrt vinculum. Prevents image cropping.
// The vinculum of a \sqrt can be made thicker by a KaTeX rendering option.
// Think of variable extraVinculum as two detours in the SVG path.
// The detour begins at the lower left of the area labeled extraVinculum below.
// The detour proceeds one extraVinculum distance up and slightly to the right,
// displacing the radiused corner between surd and vinculum. The radius is
// traversed as usual, then the detour resumes. It goes right, to the end of
// the very long vinculum, then down one extraVinculum distance,
// after which it resumes regular path geometry for the radical.
/*                                                  vinculum
                                                   /
         /▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒←extraVinculum
        / █████████████████████←0.04em (40 unit) std vinculum thickness
       / /
      / /
     / /\
    / / surd
*/ var sqrtMain = function sqrtMain(extraVinculum, hLinePad) {
    // sqrtMain path geometry is from glyph U221A in the font KaTeX Main
    return "M95," + (622 + extraVinculum + hLinePad) + "\nc-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14\nc0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54\nc44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10\ns173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429\nc69,-144,104.5,-217.7,106.5,-221\nl" + extraVinculum / 2.075 + " -" + extraVinculum + "\nc5.3,-9.3,12,-14,20,-14\nH400000v" + (40 + extraVinculum) + "H845.2724\ns-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7\nc-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z\nM" + (834 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
};
var sqrtSize1 = function sqrtSize1(extraVinculum, hLinePad) {
    // size1 is from glyph U221A in the font KaTeX_Size1-Regular
    return "M263," + (601 + extraVinculum + hLinePad) + "c0.7,0,18,39.7,52,119\nc34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120\nc340,-704.7,510.7,-1060.3,512,-1067\nl" + extraVinculum / 2.084 + " -" + extraVinculum + "\nc4.7,-7.3,11,-11,19,-11\nH40000v" + (40 + extraVinculum) + "H1012.3\ns-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232\nc-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1\ns-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26\nc-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z\nM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
};
var sqrtSize2 = function sqrtSize2(extraVinculum, hLinePad) {
    // size2 is from glyph U221A in the font KaTeX_Size2-Regular
    return "M983 " + (10 + extraVinculum + hLinePad) + "\nl" + extraVinculum / 3.13 + " -" + extraVinculum + "\nc4,-6.7,10,-10,18,-10 H400000v" + (40 + extraVinculum) + "\nH1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7\ns-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744\nc-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30\nc26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722\nc56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5\nc53.7,-170.3,84.5,-266.8,92.5,-289.5z\nM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "h-400000z";
};
var sqrtSize3 = function sqrtSize3(extraVinculum, hLinePad) {
    // size3 is from glyph U221A in the font KaTeX_Size3-Regular
    return "M424," + (2398 + extraVinculum + hLinePad) + "\nc-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514\nc0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20\ns-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121\ns209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081\nl" + extraVinculum / 4.223 + " -" + extraVinculum + "c4,-6.7,10,-10,18,-10 H400000\nv" + (40 + extraVinculum) + "H1014.6\ns-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185\nc-2,6,-10,9,-24,9\nc-8,0,-12,-0.7,-12,-2z M" + (1001 + extraVinculum) + " " + hLinePad + "\nh400000v" + (40 + extraVinculum) + "h-400000z";
};
var sqrtSize4 = function sqrtSize4(extraVinculum, hLinePad) {
    // size4 is from glyph U221A in the font KaTeX_Size4-Regular
    return "M473," + (2713 + extraVinculum + hLinePad) + "\nc339.3,-1799.3,509.3,-2700,510,-2702 l" + extraVinculum / 5.298 + " -" + extraVinculum + "\nc3.3,-7.3,9.3,-11,18,-11 H400000v" + (40 + extraVinculum) + "H1017.7\ns-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9\nc-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200\nc0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26\ns76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,\n606zM" + (1001 + extraVinculum) + " " + hLinePad + "h400000v" + (40 + extraVinculum) + "H1017.7z";
};
var phasePath = function phasePath(y) {
    var x = y / 2; // x coordinate at top of angle
    return "M400000 " + y + " H0 L" + x + " 0 l65 45 L145 " + (y - 80) + " H400000z";
};
var sqrtTall = function sqrtTall(extraVinculum, hLinePad, viewBoxHeight) {
    // sqrtTall is from glyph U23B7 in the font KaTeX_Size4-Regular
    // One path edge has a variable length. It runs vertically from the vinculum
    // to a point near (14 units) the bottom of the surd. The vinculum
    // is normally 40 units thick. So the length of the line in question is:
    var vertSegment = viewBoxHeight - 54 - hLinePad - extraVinculum;
    return "M702 " + (extraVinculum + hLinePad) + "H400000" + (40 + extraVinculum) + "\nH742v" + vertSegment + "l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1\nh-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170\nc-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667\n219 661 l218 661zM702 " + hLinePad + "H400000v" + (40 + extraVinculum) + "H742z";
};
var sqrtPath = function sqrtPath(size, extraVinculum, viewBoxHeight) {
    extraVinculum = 1000 * extraVinculum; // Convert from document ems to viewBox.
    var path = "";
    switch(size){
        case "sqrtMain":
            path = sqrtMain(extraVinculum, hLinePad);
            break;
        case "sqrtSize1":
            path = sqrtSize1(extraVinculum, hLinePad);
            break;
        case "sqrtSize2":
            path = sqrtSize2(extraVinculum, hLinePad);
            break;
        case "sqrtSize3":
            path = sqrtSize3(extraVinculum, hLinePad);
            break;
        case "sqrtSize4":
            path = sqrtSize4(extraVinculum, hLinePad);
            break;
        case "sqrtTall":
            path = sqrtTall(extraVinculum, hLinePad, viewBoxHeight);
    }
    return path;
};
var innerPath = function innerPath(name, height) {
    // The inner part of stretchy tall delimiters
    switch(name){
        case "\u239c":
            return "M291 0 H417 V" + height + " H291z M291 0 H417 V" + height + " H291z";
        case "\u2223":
            return "M145 0 H188 V" + height + " H145z M145 0 H188 V" + height + " H145z";
        case "\u2225":
            return "M145 0 H188 V" + height + " H145z M145 0 H188 V" + height + " H145z" + ("M367 0 H410 V" + height + " H367z M367 0 H410 V" + height + " H367z");
        case "\u239f":
            return "M457 0 H583 V" + height + " H457z M457 0 H583 V" + height + " H457z";
        case "\u23a2":
            return "M319 0 H403 V" + height + " H319z M319 0 H403 V" + height + " H319z";
        case "\u23a5":
            return "M263 0 H347 V" + height + " H263z M263 0 H347 V" + height + " H263z";
        case "\u23aa":
            return "M384 0 H504 V" + height + " H384z M384 0 H504 V" + height + " H384z";
        case "\u23d0":
            return "M312 0 H355 V" + height + " H312z M312 0 H355 V" + height + " H312z";
        case "\u2016":
            return "M257 0 H300 V" + height + " H257z M257 0 H300 V" + height + " H257z" + ("M478 0 H521 V" + height + " H478z M478 0 H521 V" + height + " H478z");
        default:
            return "";
    }
};
var path = {
    // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
    doubleleftarrow: "M262 157\nl10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3\n 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28\n 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5\nc2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5\n 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87\n-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7\n-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z\nm8 0v40h399730v-40zm0 194v40h399730v-40z",
    // doublerightarrow is from glyph U+21D2 in font KaTeX Main
    doublerightarrow: "M399738 392l\n-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5\n 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88\n-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68\n-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18\n-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782\nc-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3\n-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z",
    // leftarrow is from glyph U+2190 in font KaTeX Main
    leftarrow: "M400000 241H110l3-3c68.7-52.7 113.7-120\n 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8\n-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247\nc-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208\n 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3\n 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202\n l-3-3h399890zM100 241v40h399900v-40z",
    // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
    leftbrace: "M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117\n-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7\n 5-6 9-10 13-.7 1-7.3 1-20 1H6z",
    leftbraceunder: "M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13\n 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688\n 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7\n-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z",
    // overgroup is from the MnSymbol package (public domain)
    leftgroup: "M400000 80\nH435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0\n 435 0h399565z",
    leftgroupunder: "M400000 262\nH435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219\n 435 219h399565z",
    // Harpoons are from glyph U+21BD in font KaTeX Main
    leftharpoon: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3\n-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5\n-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7\n-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z",
    leftharpoonplus: "M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5\n 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3\n-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7\n-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z\nm0 0v40h400000v-40z",
    leftharpoondown: "M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333\n 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5\n 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667\n-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z",
    leftharpoondownplus: "M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12\n 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7\n-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0\nv40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z",
    // hook is from glyph U+21A9 in font KaTeX Main
    lefthook: "M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5\n-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3\n-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21\n 71.5 23h399859zM103 281v-40h399897v40z",
    leftlinesegment: "M40 281 V428 H0 V94 H40 V241 H400000 v40z\nM40 281 V428 H0 V94 H40 V241 H400000 v40z",
    leftmapsto: "M40 281 V448H0V74H40V241H400000v40z\nM40 281 V448H0V74H40V241H400000v40z",
    // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
    leftToFrom: "M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23\n-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8\nc28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3\n 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z",
    longequal: "M0 50 h400000 v40H0z m0 194h40000v40H0z\nM0 50 h400000 v40H0z m0 194h40000v40H0z",
    midbrace: "M200428 334\nc-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14\n-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7\n 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11\n 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z",
    midbraceunder: "M199572 214\nc100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14\n 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3\n 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0\n-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z",
    oiintSize1: "M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6\n-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z\nm368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8\n60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z",
    oiintSize2: "M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8\n-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z\nm502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2\nc0 110 84 276 504 276s502.4-166 502.4-276z",
    oiiintSize1: "M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6\n-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z\nm525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0\n85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z",
    oiiintSize2: "M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8\n-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z\nm770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1\nc0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z",
    rightarrow: "M0 241v40h399891c-47.3 35.3-84 78-110 128\n-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20\n 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7\n 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85\n-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n 151.7 139 205zm0 0v40h399900v-40z",
    rightbrace: "M400000 542l\n-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5\ns-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1\nc124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z",
    rightbraceunder: "M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3\n 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237\n-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z",
    rightgroup: "M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0\n 3-1 3-3v-38c-76-158-257-219-435-219H0z",
    rightgroupunder: "M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18\n 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z",
    rightharpoon: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3\n-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2\n-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58\n 69.2 92 94.5zm0 0v40h399900v-40z",
    rightharpoonplus: "M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11\n-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7\n 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z\nm0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z",
    rightharpoondown: "M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8\n 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5\n-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95\n-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z",
    rightharpoondownplus: "M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8\n 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3\n 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3\n-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z\nm0-194v40h400000v-40zm0 0v40h400000v-40z",
    righthook: "M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3\n 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0\n-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21\n 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z",
    rightlinesegment: "M399960 241 V94 h40 V428 h-40 V281 H0 v-40z\nM399960 241 V94 h40 V428 h-40 V281 H0 v-40z",
    rightToFrom: "M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23\n 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32\n-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142\n-167z M100 147v40h399900v-40zM0 341v40h399900v-40z",
    // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
    twoheadleftarrow: "M0 167c68 40\n 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69\n-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3\n-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19\n-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101\n 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z",
    twoheadrightarrow: "M400000 167\nc-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3\n 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42\n 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333\n-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70\n 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z",
    // tilde1 is a modified version of a glyph from the MnSymbol package
    tilde1: "M200 55.538c-77 0-168 73.953-177 73.953-3 0-7\n-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0\n 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0\n 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128\n-68.267.847-113-73.952-191-73.952z",
    // ditto tilde2, tilde3, & tilde4
    tilde2: "M344 55.266c-142 0-300.638 81.316-311.5 86.418\n-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9\n 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114\nc1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751\n 181.476 676 181.476c-149 0-189-126.21-332-126.21z",
    tilde3: "M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457\n-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0\n 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697\n 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696\n -338 0-409-156.573-744-156.573z",
    tilde4: "M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345\n-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409\n 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9\n 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409\n -175.236-744-175.236z",
    // vec is from glyph U+20D7 in font KaTeX Main
    vec: "M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5\n3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11\n10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63\n-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1\n-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59\nH213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359\nc-16-25.333-24-45-24-59z",
    // widehat1 is a modified version of a glyph from the MnSymbol package
    widehat1: "M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22\nc-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z",
    // ditto widehat2, widehat3, & widehat4
    widehat2: "M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    widehat3: "M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    widehat4: "M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10\n-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z",
    // widecheck paths are all inverted versions of widehat
    widecheck1: "M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,\n-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z",
    widecheck2: "M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    widecheck3: "M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    widecheck4: "M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,\n-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z",
    // The next ten paths support reaction arrows from the mhchem package.
    // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
    // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
    baraboveleftarrow: "M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202\nc4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5\nc-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130\ns-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47\n121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6\ns2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11\nc0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z\nM100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z",
    // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
    rightarrowabovebar: "M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32\n-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0\n13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39\n-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5\n-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5\n-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67\n151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z",
    // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
    // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
    baraboveshortleftharpoon: "M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17\nc2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21\nc-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40\nc-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z\nM0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z",
    rightharpoonaboveshortbar: "M0,241 l0,40c399126,0,399993,0,399993,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z",
    shortbaraboveleftharpoon: "M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11\nc1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,\n1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,\n-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z\nM93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z",
    shortrightharpoonabovebar: "M53,241l0,40c398570,0,399437,0,399437,0\nc4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,\n-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6\nc-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z\nM500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z"
};
var tallDelim = function tallDelim(label, midHeight) {
    switch(label){
        case "lbrack":
            return "M403 1759 V84 H666 V0 H319 V1759 v" + midHeight + " v1759 h347 v-84\nH403z M403 1759 V0 H319 V1759 v" + midHeight + " v1759 h84z";
        case "rbrack":
            return "M347 1759 V0 H0 V84 H263 V1759 v" + midHeight + " v1759 H0 v84 H347z\nM347 1759 V0 H263 V1759 v" + midHeight + " v1759 h84z";
        case "vert":
            return "M145 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M188 15 H145 v585 v" + midHeight + " v585 h43z";
        case "doublevert":
            return "M145 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M188 15 H145 v585 v" + midHeight + " v585 h43z\nM367 15 v585 v" + midHeight + " v585 c2.667,10,9.667,15,21,15\nc10,0,16.667,-5,20,-15 v-585 v" + -midHeight + " v-585 c-2.667,-10,-9.667,-15,-21,-15\nc-10,0,-16.667,5,-20,15z M410 15 H367 v585 v" + midHeight + " v585 h43z";
        case "lfloor":
            return "M319 602 V0 H403 V602 v" + midHeight + " v1715 h263 v84 H319z\nMM319 602 V0 H403 V602 v" + midHeight + " v1715 H319z";
        case "rfloor":
            return "M319 602 V0 H403 V602 v" + midHeight + " v1799 H0 v-84 H319z\nMM319 602 V0 H403 V602 v" + midHeight + " v1715 H319z";
        case "lceil":
            return "M403 1759 V84 H666 V0 H319 V1759 v" + midHeight + " v602 h84z\nM403 1759 V0 H319 V1759 v" + midHeight + " v602 h84z";
        case "rceil":
            return "M347 1759 V0 H0 V84 H263 V1759 v" + midHeight + " v602 h84z\nM347 1759 V0 h-84 V1759 v" + midHeight + " v602 h84z";
        case "lparen":
            return "M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1\nc-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,\n-36,557 l0," + (midHeight + 84) + "c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,\n949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9\nc0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,\n-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189\nl0,-" + (midHeight + 92) + "c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,\n-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z";
        case "rparen":
            return "M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,\n63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5\nc11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0," + (midHeight + 9) + "\nc-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664\nc-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11\nc0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17\nc242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558\nl0,-" + (midHeight + 144) + "c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,\n-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z";
        default:
            // We should not ever get here.
            throw new Error("Unknown stretchy delimiter.");
    }
};
// To ensure that all nodes have compatible signatures for these methods.
/**
 * This node represents a document fragment, which contains elements, but when
 * placed into the DOM doesn't have any representation itself. It only contains
 * children and doesn't have any DOM node properties.
 */ class DocumentFragment {
    // Never used; needed for satisfying interface.
    constructor(children){
        this.children = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        this.children = children;
        this.classes = [];
        this.height = 0;
        this.depth = 0;
        this.maxFontSize = 0;
        this.style = {};
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    /** Convert the fragment into a node. */ toNode() {
        var frag = document.createDocumentFragment();
        for(var i = 0; i < this.children.length; i++)frag.appendChild(this.children[i].toNode());
        return frag;
    }
    /** Convert the fragment into HTML markup. */ toMarkup() {
        var markup = ""; // Simply concatenate the markup for the children together.
        for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
        return markup;
    }
    /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */ toText() {
        // To avoid this, we would subclass documentFragment separately for
        // MathML, but polyfills for subclassing is expensive per PR 1469.
        // $FlowFixMe: Only works for ChildType = MathDomNode.
        var toText = (child)=>child.toText();
        return this.children.map(toText).join("");
    }
}
// This file is GENERATED by buildMetrics.sh. DO NOT MODIFY.
var fontMetricsData = {
    "AMS-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "65": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "66": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "67": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "68": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "69": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "70": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "71": [
            0,
            0.68889,
            0,
            0,
            0.77778
        ],
        "72": [
            0,
            0.68889,
            0,
            0,
            0.77778
        ],
        "73": [
            0,
            0.68889,
            0,
            0,
            0.38889
        ],
        "74": [
            0.16667,
            0.68889,
            0,
            0,
            0.5
        ],
        "75": [
            0,
            0.68889,
            0,
            0,
            0.77778
        ],
        "76": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "77": [
            0,
            0.68889,
            0,
            0,
            0.94445
        ],
        "78": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "79": [
            0.16667,
            0.68889,
            0,
            0,
            0.77778
        ],
        "80": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "81": [
            0.16667,
            0.68889,
            0,
            0,
            0.77778
        ],
        "82": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "83": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "84": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "85": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "86": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "87": [
            0,
            0.68889,
            0,
            0,
            1.0
        ],
        "88": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "89": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "90": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "107": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "165": [
            0,
            0.675,
            0.025,
            0,
            0.75
        ],
        "174": [
            0.15559,
            0.69224,
            0,
            0,
            0.94666
        ],
        "240": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "295": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ],
        "710": [
            0,
            0.825,
            0,
            0,
            2.33334
        ],
        "732": [
            0,
            0.9,
            0,
            0,
            2.33334
        ],
        "770": [
            0,
            0.825,
            0,
            0,
            2.33334
        ],
        "771": [
            0,
            0.9,
            0,
            0,
            2.33334
        ],
        "989": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "1008": [
            0,
            0.43056,
            0.04028,
            0,
            0.66667
        ],
        "8245": [
            0,
            0.54986,
            0,
            0,
            0.275
        ],
        "8463": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ],
        "8487": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "8498": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "8502": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "8503": [
            0,
            0.68889,
            0,
            0,
            0.44445
        ],
        "8504": [
            0,
            0.68889,
            0,
            0,
            0.66667
        ],
        "8513": [
            0,
            0.68889,
            0,
            0,
            0.63889
        ],
        "8592": [
            -0.03598,
            0.46402,
            0,
            0,
            0.5
        ],
        "8594": [
            -0.03598,
            0.46402,
            0,
            0,
            0.5
        ],
        "8602": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8603": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8606": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8608": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8610": [
            0.01354,
            0.52239,
            0,
            0,
            1.11111
        ],
        "8611": [
            0.01354,
            0.52239,
            0,
            0,
            1.11111
        ],
        "8619": [
            0,
            0.54986,
            0,
            0,
            1.0
        ],
        "8620": [
            0,
            0.54986,
            0,
            0,
            1.0
        ],
        "8621": [
            -0.13313,
            0.37788,
            0,
            0,
            1.38889
        ],
        "8622": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8624": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "8625": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "8630": [
            0,
            0.43056,
            0,
            0,
            1.0
        ],
        "8631": [
            0,
            0.43056,
            0,
            0,
            1.0
        ],
        "8634": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8635": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8638": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8639": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8642": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8643": [
            0.19444,
            0.69224,
            0,
            0,
            0.41667
        ],
        "8644": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8646": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8647": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8648": [
            0.19444,
            0.69224,
            0,
            0,
            0.83334
        ],
        "8649": [
            0.1808,
            0.675,
            0,
            0,
            1.0
        ],
        "8650": [
            0.19444,
            0.69224,
            0,
            0,
            0.83334
        ],
        "8651": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8652": [
            0.01354,
            0.52239,
            0,
            0,
            1.0
        ],
        "8653": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8654": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8655": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8666": [
            0.13667,
            0.63667,
            0,
            0,
            1.0
        ],
        "8667": [
            0.13667,
            0.63667,
            0,
            0,
            1.0
        ],
        "8669": [
            -0.13313,
            0.37788,
            0,
            0,
            1.0
        ],
        "8672": [
            -0.064,
            0.437,
            0,
            0,
            1.334
        ],
        "8674": [
            -0.064,
            0.437,
            0,
            0,
            1.334
        ],
        "8705": [
            0,
            0.825,
            0,
            0,
            0.5
        ],
        "8708": [
            0,
            0.68889,
            0,
            0,
            0.55556
        ],
        "8709": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8717": [
            0,
            0.43056,
            0,
            0,
            0.42917
        ],
        "8722": [
            -0.03598,
            0.46402,
            0,
            0,
            0.5
        ],
        "8724": [
            0.08198,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8726": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8733": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8736": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8737": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8738": [
            0.03517,
            0.52239,
            0,
            0,
            0.72222
        ],
        "8739": [
            0.08167,
            0.58167,
            0,
            0,
            0.22222
        ],
        "8740": [
            0.25142,
            0.74111,
            0,
            0,
            0.27778
        ],
        "8741": [
            0.08167,
            0.58167,
            0,
            0,
            0.38889
        ],
        "8742": [
            0.25142,
            0.74111,
            0,
            0,
            0.5
        ],
        "8756": [
            0,
            0.69224,
            0,
            0,
            0.66667
        ],
        "8757": [
            0,
            0.69224,
            0,
            0,
            0.66667
        ],
        "8764": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "8765": [
            -0.13313,
            0.37788,
            0,
            0,
            0.77778
        ],
        "8769": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "8770": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8774": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8776": [
            -0.01688,
            0.48312,
            0,
            0,
            0.77778
        ],
        "8778": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8782": [
            0.06062,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8783": [
            0.06062,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8785": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8786": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8787": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8790": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8791": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8796": [
            0.08198,
            0.91667,
            0,
            0,
            0.77778
        ],
        "8806": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "8807": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "8808": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "8809": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "8812": [
            0.25583,
            0.75583,
            0,
            0,
            0.5
        ],
        "8814": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8815": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8816": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8817": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8818": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8819": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8822": [
            0.1808,
            0.675,
            0,
            0,
            0.77778
        ],
        "8823": [
            0.1808,
            0.675,
            0,
            0,
            0.77778
        ],
        "8828": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8829": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8830": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8831": [
            0.22958,
            0.72958,
            0,
            0,
            0.77778
        ],
        "8832": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8833": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8840": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8841": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8842": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8843": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8847": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8848": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8858": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8859": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8861": [
            0.08198,
            0.58198,
            0,
            0,
            0.77778
        ],
        "8862": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8863": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8864": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8865": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "8872": [
            0,
            0.69224,
            0,
            0,
            0.61111
        ],
        "8873": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8874": [
            0,
            0.69224,
            0,
            0,
            0.88889
        ],
        "8876": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "8877": [
            0,
            0.68889,
            0,
            0,
            0.61111
        ],
        "8878": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "8879": [
            0,
            0.68889,
            0,
            0,
            0.72222
        ],
        "8882": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8883": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8884": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8885": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8888": [
            0,
            0.54986,
            0,
            0,
            1.11111
        ],
        "8890": [
            0.19444,
            0.43056,
            0,
            0,
            0.55556
        ],
        "8891": [
            0.19444,
            0.69224,
            0,
            0,
            0.61111
        ],
        "8892": [
            0.19444,
            0.69224,
            0,
            0,
            0.61111
        ],
        "8901": [
            0,
            0.54986,
            0,
            0,
            0.27778
        ],
        "8903": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8905": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8906": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "8907": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8908": [
            0,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8909": [
            -0.03598,
            0.46402,
            0,
            0,
            0.77778
        ],
        "8910": [
            0,
            0.54986,
            0,
            0,
            0.76042
        ],
        "8911": [
            0,
            0.54986,
            0,
            0,
            0.76042
        ],
        "8912": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8913": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "8914": [
            0,
            0.54986,
            0,
            0,
            0.66667
        ],
        "8915": [
            0,
            0.54986,
            0,
            0,
            0.66667
        ],
        "8916": [
            0,
            0.69224,
            0,
            0,
            0.66667
        ],
        "8918": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8919": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8920": [
            0.03517,
            0.54986,
            0,
            0,
            1.33334
        ],
        "8921": [
            0.03517,
            0.54986,
            0,
            0,
            1.33334
        ],
        "8922": [
            0.38569,
            0.88569,
            0,
            0,
            0.77778
        ],
        "8923": [
            0.38569,
            0.88569,
            0,
            0,
            0.77778
        ],
        "8926": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8927": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "8928": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8929": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8934": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8935": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8936": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8937": [
            0.23222,
            0.74111,
            0,
            0,
            0.77778
        ],
        "8938": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8939": [
            0.20576,
            0.70576,
            0,
            0,
            0.77778
        ],
        "8940": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8941": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "8994": [
            0.19444,
            0.69224,
            0,
            0,
            0.77778
        ],
        "8995": [
            0.19444,
            0.69224,
            0,
            0,
            0.77778
        ],
        "9416": [
            0.15559,
            0.69224,
            0,
            0,
            0.90222
        ],
        "9484": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "9488": [
            0,
            0.69224,
            0,
            0,
            0.5
        ],
        "9492": [
            0,
            0.37788,
            0,
            0,
            0.5
        ],
        "9496": [
            0,
            0.37788,
            0,
            0,
            0.5
        ],
        "9585": [
            0.19444,
            0.68889,
            0,
            0,
            0.88889
        ],
        "9586": [
            0.19444,
            0.74111,
            0,
            0,
            0.88889
        ],
        "9632": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "9633": [
            0,
            0.675,
            0,
            0,
            0.77778
        ],
        "9650": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9651": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9654": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "9660": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9661": [
            0,
            0.54986,
            0,
            0,
            0.72222
        ],
        "9664": [
            0.03517,
            0.54986,
            0,
            0,
            0.77778
        ],
        "9674": [
            0.11111,
            0.69224,
            0,
            0,
            0.66667
        ],
        "9733": [
            0.19444,
            0.69224,
            0,
            0,
            0.94445
        ],
        "10003": [
            0,
            0.69224,
            0,
            0,
            0.83334
        ],
        "10016": [
            0,
            0.69224,
            0,
            0,
            0.83334
        ],
        "10731": [
            0.11111,
            0.69224,
            0,
            0,
            0.66667
        ],
        "10846": [
            0.19444,
            0.75583,
            0,
            0,
            0.61111
        ],
        "10877": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10878": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10885": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10886": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10887": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "10888": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "10889": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10890": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10891": [
            0.48256,
            0.98256,
            0,
            0,
            0.77778
        ],
        "10892": [
            0.48256,
            0.98256,
            0,
            0,
            0.77778
        ],
        "10901": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10902": [
            0.13667,
            0.63667,
            0,
            0,
            0.77778
        ],
        "10933": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10934": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10935": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10936": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10937": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10938": [
            0.26167,
            0.75726,
            0,
            0,
            0.77778
        ],
        "10949": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10950": [
            0.25583,
            0.75583,
            0,
            0,
            0.77778
        ],
        "10955": [
            0.28481,
            0.79383,
            0,
            0,
            0.77778
        ],
        "10956": [
            0.28481,
            0.79383,
            0,
            0,
            0.77778
        ],
        "57350": [
            0.08167,
            0.58167,
            0,
            0,
            0.22222
        ],
        "57351": [
            0.08167,
            0.58167,
            0,
            0,
            0.38889
        ],
        "57352": [
            0.08167,
            0.58167,
            0,
            0,
            0.77778
        ],
        "57353": [
            0,
            0.43056,
            0.04028,
            0,
            0.66667
        ],
        "57356": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57357": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57358": [
            0.41951,
            0.91951,
            0,
            0,
            0.77778
        ],
        "57359": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "57360": [
            0.30274,
            0.79383,
            0,
            0,
            0.77778
        ],
        "57361": [
            0.41951,
            0.91951,
            0,
            0,
            0.77778
        ],
        "57366": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57367": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57368": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57369": [
            0.25142,
            0.75726,
            0,
            0,
            0.77778
        ],
        "57370": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "57371": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ]
    },
    "Caligraphic-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "65": [
            0,
            0.68333,
            0,
            0.19445,
            0.79847
        ],
        "66": [
            0,
            0.68333,
            0.03041,
            0.13889,
            0.65681
        ],
        "67": [
            0,
            0.68333,
            0.05834,
            0.13889,
            0.52653
        ],
        "68": [
            0,
            0.68333,
            0.02778,
            0.08334,
            0.77139
        ],
        "69": [
            0,
            0.68333,
            0.08944,
            0.11111,
            0.52778
        ],
        "70": [
            0,
            0.68333,
            0.09931,
            0.11111,
            0.71875
        ],
        "71": [
            0.09722,
            0.68333,
            0.0593,
            0.11111,
            0.59487
        ],
        "72": [
            0,
            0.68333,
            0.00965,
            0.11111,
            0.84452
        ],
        "73": [
            0,
            0.68333,
            0.07382,
            0,
            0.54452
        ],
        "74": [
            0.09722,
            0.68333,
            0.18472,
            0.16667,
            0.67778
        ],
        "75": [
            0,
            0.68333,
            0.01445,
            0.05556,
            0.76195
        ],
        "76": [
            0,
            0.68333,
            0,
            0.13889,
            0.68972
        ],
        "77": [
            0,
            0.68333,
            0,
            0.13889,
            1.2009
        ],
        "78": [
            0,
            0.68333,
            0.14736,
            0.08334,
            0.82049
        ],
        "79": [
            0,
            0.68333,
            0.02778,
            0.11111,
            0.79611
        ],
        "80": [
            0,
            0.68333,
            0.08222,
            0.08334,
            0.69556
        ],
        "81": [
            0.09722,
            0.68333,
            0,
            0.11111,
            0.81667
        ],
        "82": [
            0,
            0.68333,
            0,
            0.08334,
            0.8475
        ],
        "83": [
            0,
            0.68333,
            0.075,
            0.13889,
            0.60556
        ],
        "84": [
            0,
            0.68333,
            0.25417,
            0,
            0.54464
        ],
        "85": [
            0,
            0.68333,
            0.09931,
            0.08334,
            0.62583
        ],
        "86": [
            0,
            0.68333,
            0.08222,
            0,
            0.61278
        ],
        "87": [
            0,
            0.68333,
            0.08222,
            0.08334,
            0.98778
        ],
        "88": [
            0,
            0.68333,
            0.14643,
            0.13889,
            0.7133
        ],
        "89": [
            0.09722,
            0.68333,
            0.08222,
            0.08334,
            0.66834
        ],
        "90": [
            0,
            0.68333,
            0.07944,
            0.13889,
            0.72473
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ]
    },
    "Fraktur-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69141,
            0,
            0,
            0.29574
        ],
        "34": [
            0,
            0.69141,
            0,
            0,
            0.21471
        ],
        "38": [
            0,
            0.69141,
            0,
            0,
            0.73786
        ],
        "39": [
            0,
            0.69141,
            0,
            0,
            0.21201
        ],
        "40": [
            0.24982,
            0.74947,
            0,
            0,
            0.38865
        ],
        "41": [
            0.24982,
            0.74947,
            0,
            0,
            0.38865
        ],
        "42": [
            0,
            0.62119,
            0,
            0,
            0.27764
        ],
        "43": [
            0.08319,
            0.58283,
            0,
            0,
            0.75623
        ],
        "44": [
            0,
            0.10803,
            0,
            0,
            0.27764
        ],
        "45": [
            0.08319,
            0.58283,
            0,
            0,
            0.75623
        ],
        "46": [
            0,
            0.10803,
            0,
            0,
            0.27764
        ],
        "47": [
            0.24982,
            0.74947,
            0,
            0,
            0.50181
        ],
        "48": [
            0,
            0.47534,
            0,
            0,
            0.50181
        ],
        "49": [
            0,
            0.47534,
            0,
            0,
            0.50181
        ],
        "50": [
            0,
            0.47534,
            0,
            0,
            0.50181
        ],
        "51": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "52": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "53": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "54": [
            0,
            0.69141,
            0,
            0,
            0.50181
        ],
        "55": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "56": [
            0,
            0.69141,
            0,
            0,
            0.50181
        ],
        "57": [
            0.18906,
            0.47534,
            0,
            0,
            0.50181
        ],
        "58": [
            0,
            0.47534,
            0,
            0,
            0.21606
        ],
        "59": [
            0.12604,
            0.47534,
            0,
            0,
            0.21606
        ],
        "61": [
            -0.13099,
            0.36866,
            0,
            0,
            0.75623
        ],
        "63": [
            0,
            0.69141,
            0,
            0,
            0.36245
        ],
        "65": [
            0,
            0.69141,
            0,
            0,
            0.7176
        ],
        "66": [
            0,
            0.69141,
            0,
            0,
            0.88397
        ],
        "67": [
            0,
            0.69141,
            0,
            0,
            0.61254
        ],
        "68": [
            0,
            0.69141,
            0,
            0,
            0.83158
        ],
        "69": [
            0,
            0.69141,
            0,
            0,
            0.66278
        ],
        "70": [
            0.12604,
            0.69141,
            0,
            0,
            0.61119
        ],
        "71": [
            0,
            0.69141,
            0,
            0,
            0.78539
        ],
        "72": [
            0.06302,
            0.69141,
            0,
            0,
            0.7203
        ],
        "73": [
            0,
            0.69141,
            0,
            0,
            0.55448
        ],
        "74": [
            0.12604,
            0.69141,
            0,
            0,
            0.55231
        ],
        "75": [
            0,
            0.69141,
            0,
            0,
            0.66845
        ],
        "76": [
            0,
            0.69141,
            0,
            0,
            0.66602
        ],
        "77": [
            0,
            0.69141,
            0,
            0,
            1.04953
        ],
        "78": [
            0,
            0.69141,
            0,
            0,
            0.83212
        ],
        "79": [
            0,
            0.69141,
            0,
            0,
            0.82699
        ],
        "80": [
            0.18906,
            0.69141,
            0,
            0,
            0.82753
        ],
        "81": [
            0.03781,
            0.69141,
            0,
            0,
            0.82699
        ],
        "82": [
            0,
            0.69141,
            0,
            0,
            0.82807
        ],
        "83": [
            0,
            0.69141,
            0,
            0,
            0.82861
        ],
        "84": [
            0,
            0.69141,
            0,
            0,
            0.66899
        ],
        "85": [
            0,
            0.69141,
            0,
            0,
            0.64576
        ],
        "86": [
            0,
            0.69141,
            0,
            0,
            0.83131
        ],
        "87": [
            0,
            0.69141,
            0,
            0,
            1.04602
        ],
        "88": [
            0,
            0.69141,
            0,
            0,
            0.71922
        ],
        "89": [
            0.18906,
            0.69141,
            0,
            0,
            0.83293
        ],
        "90": [
            0.12604,
            0.69141,
            0,
            0,
            0.60201
        ],
        "91": [
            0.24982,
            0.74947,
            0,
            0,
            0.27764
        ],
        "93": [
            0.24982,
            0.74947,
            0,
            0,
            0.27764
        ],
        "94": [
            0,
            0.69141,
            0,
            0,
            0.49965
        ],
        "97": [
            0,
            0.47534,
            0,
            0,
            0.50046
        ],
        "98": [
            0,
            0.69141,
            0,
            0,
            0.51315
        ],
        "99": [
            0,
            0.47534,
            0,
            0,
            0.38946
        ],
        "100": [
            0,
            0.62119,
            0,
            0,
            0.49857
        ],
        "101": [
            0,
            0.47534,
            0,
            0,
            0.40053
        ],
        "102": [
            0.18906,
            0.69141,
            0,
            0,
            0.32626
        ],
        "103": [
            0.18906,
            0.47534,
            0,
            0,
            0.5037
        ],
        "104": [
            0.18906,
            0.69141,
            0,
            0,
            0.52126
        ],
        "105": [
            0,
            0.69141,
            0,
            0,
            0.27899
        ],
        "106": [
            0,
            0.69141,
            0,
            0,
            0.28088
        ],
        "107": [
            0,
            0.69141,
            0,
            0,
            0.38946
        ],
        "108": [
            0,
            0.69141,
            0,
            0,
            0.27953
        ],
        "109": [
            0,
            0.47534,
            0,
            0,
            0.76676
        ],
        "110": [
            0,
            0.47534,
            0,
            0,
            0.52666
        ],
        "111": [
            0,
            0.47534,
            0,
            0,
            0.48885
        ],
        "112": [
            0.18906,
            0.52396,
            0,
            0,
            0.50046
        ],
        "113": [
            0.18906,
            0.47534,
            0,
            0,
            0.48912
        ],
        "114": [
            0,
            0.47534,
            0,
            0,
            0.38919
        ],
        "115": [
            0,
            0.47534,
            0,
            0,
            0.44266
        ],
        "116": [
            0,
            0.62119,
            0,
            0,
            0.33301
        ],
        "117": [
            0,
            0.47534,
            0,
            0,
            0.5172
        ],
        "118": [
            0,
            0.52396,
            0,
            0,
            0.5118
        ],
        "119": [
            0,
            0.52396,
            0,
            0,
            0.77351
        ],
        "120": [
            0.18906,
            0.47534,
            0,
            0,
            0.38865
        ],
        "121": [
            0.18906,
            0.47534,
            0,
            0,
            0.49884
        ],
        "122": [
            0.18906,
            0.47534,
            0,
            0,
            0.39054
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "8216": [
            0,
            0.69141,
            0,
            0,
            0.21471
        ],
        "8217": [
            0,
            0.69141,
            0,
            0,
            0.21471
        ],
        "58112": [
            0,
            0.62119,
            0,
            0,
            0.49749
        ],
        "58113": [
            0,
            0.62119,
            0,
            0,
            0.4983
        ],
        "58114": [
            0.18906,
            0.69141,
            0,
            0,
            0.33328
        ],
        "58115": [
            0.18906,
            0.69141,
            0,
            0,
            0.32923
        ],
        "58116": [
            0.18906,
            0.47534,
            0,
            0,
            0.50343
        ],
        "58117": [
            0,
            0.69141,
            0,
            0,
            0.33301
        ],
        "58118": [
            0,
            0.62119,
            0,
            0,
            0.33409
        ],
        "58119": [
            0,
            0.47534,
            0,
            0,
            0.50073
        ]
    },
    "Main-Bold": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.35
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.60278
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.95833
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.575
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            0.95833
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.575
        ],
        "43": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "44": [
            0.19444,
            0.15556,
            0,
            0,
            0.31944
        ],
        "45": [
            0,
            0.44444,
            0,
            0,
            0.38333
        ],
        "46": [
            0,
            0.15556,
            0,
            0,
            0.31944
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "48": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "49": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "50": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "51": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "52": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "53": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "55": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "57": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "58": [
            0,
            0.44444,
            0,
            0,
            0.31944
        ],
        "59": [
            0.19444,
            0.44444,
            0,
            0,
            0.31944
        ],
        "60": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "61": [
            -0.10889,
            0.39111,
            0,
            0,
            0.89444
        ],
        "62": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.54305
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "65": [
            0,
            0.68611,
            0,
            0,
            0.86944
        ],
        "66": [
            0,
            0.68611,
            0,
            0,
            0.81805
        ],
        "67": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "68": [
            0,
            0.68611,
            0,
            0,
            0.88194
        ],
        "69": [
            0,
            0.68611,
            0,
            0,
            0.75555
        ],
        "70": [
            0,
            0.68611,
            0,
            0,
            0.72361
        ],
        "71": [
            0,
            0.68611,
            0,
            0,
            0.90416
        ],
        "72": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "73": [
            0,
            0.68611,
            0,
            0,
            0.43611
        ],
        "74": [
            0,
            0.68611,
            0,
            0,
            0.59444
        ],
        "75": [
            0,
            0.68611,
            0,
            0,
            0.90138
        ],
        "76": [
            0,
            0.68611,
            0,
            0,
            0.69166
        ],
        "77": [
            0,
            0.68611,
            0,
            0,
            1.09166
        ],
        "78": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "79": [
            0,
            0.68611,
            0,
            0,
            0.86388
        ],
        "80": [
            0,
            0.68611,
            0,
            0,
            0.78611
        ],
        "81": [
            0.19444,
            0.68611,
            0,
            0,
            0.86388
        ],
        "82": [
            0,
            0.68611,
            0,
            0,
            0.8625
        ],
        "83": [
            0,
            0.68611,
            0,
            0,
            0.63889
        ],
        "84": [
            0,
            0.68611,
            0,
            0,
            0.8
        ],
        "85": [
            0,
            0.68611,
            0,
            0,
            0.88472
        ],
        "86": [
            0,
            0.68611,
            0.01597,
            0,
            0.86944
        ],
        "87": [
            0,
            0.68611,
            0.01597,
            0,
            1.18888
        ],
        "88": [
            0,
            0.68611,
            0,
            0,
            0.86944
        ],
        "89": [
            0,
            0.68611,
            0.02875,
            0,
            0.86944
        ],
        "90": [
            0,
            0.68611,
            0,
            0,
            0.70277
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "92": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "95": [
            0.31,
            0.13444,
            0.03194,
            0,
            0.575
        ],
        "97": [
            0,
            0.44444,
            0,
            0,
            0.55902
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "99": [
            0,
            0.44444,
            0,
            0,
            0.51111
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "101": [
            0,
            0.44444,
            0,
            0,
            0.52708
        ],
        "102": [
            0,
            0.69444,
            0.10903,
            0,
            0.35139
        ],
        "103": [
            0.19444,
            0.44444,
            0.01597,
            0,
            0.575
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "105": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "106": [
            0.19444,
            0.69444,
            0,
            0,
            0.35139
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.60694
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "109": [
            0,
            0.44444,
            0,
            0,
            0.95833
        ],
        "110": [
            0,
            0.44444,
            0,
            0,
            0.63889
        ],
        "111": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "112": [
            0.19444,
            0.44444,
            0,
            0,
            0.63889
        ],
        "113": [
            0.19444,
            0.44444,
            0,
            0,
            0.60694
        ],
        "114": [
            0,
            0.44444,
            0,
            0,
            0.47361
        ],
        "115": [
            0,
            0.44444,
            0,
            0,
            0.45361
        ],
        "116": [
            0,
            0.63492,
            0,
            0,
            0.44722
        ],
        "117": [
            0,
            0.44444,
            0,
            0,
            0.63889
        ],
        "118": [
            0,
            0.44444,
            0.01597,
            0,
            0.60694
        ],
        "119": [
            0,
            0.44444,
            0.01597,
            0,
            0.83055
        ],
        "120": [
            0,
            0.44444,
            0,
            0,
            0.60694
        ],
        "121": [
            0.19444,
            0.44444,
            0.01597,
            0,
            0.60694
        ],
        "122": [
            0,
            0.44444,
            0,
            0,
            0.51111
        ],
        "123": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "124": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "125": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "126": [
            0.35,
            0.34444,
            0,
            0,
            0.575
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "163": [
            0,
            0.69444,
            0,
            0,
            0.86853
        ],
        "168": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "172": [
            0,
            0.44444,
            0,
            0,
            0.76666
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.86944
        ],
        "177": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.51111
        ],
        "198": [
            0,
            0.68611,
            0,
            0,
            1.04166
        ],
        "215": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "216": [
            0.04861,
            0.73472,
            0,
            0,
            0.89444
        ],
        "223": [
            0,
            0.69444,
            0,
            0,
            0.59722
        ],
        "230": [
            0,
            0.44444,
            0,
            0,
            0.83055
        ],
        "247": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "248": [
            0.09722,
            0.54167,
            0,
            0,
            0.575
        ],
        "305": [
            0,
            0.44444,
            0,
            0,
            0.31944
        ],
        "338": [
            0,
            0.68611,
            0,
            0,
            1.16944
        ],
        "339": [
            0,
            0.44444,
            0,
            0,
            0.89444
        ],
        "567": [
            0.19444,
            0.44444,
            0,
            0,
            0.35139
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "711": [
            0,
            0.63194,
            0,
            0,
            0.575
        ],
        "713": [
            0,
            0.59611,
            0,
            0,
            0.575
        ],
        "714": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "729": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.86944
        ],
        "732": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.575
        ],
        "915": [
            0,
            0.68611,
            0,
            0,
            0.69166
        ],
        "916": [
            0,
            0.68611,
            0,
            0,
            0.95833
        ],
        "920": [
            0,
            0.68611,
            0,
            0,
            0.89444
        ],
        "923": [
            0,
            0.68611,
            0,
            0,
            0.80555
        ],
        "926": [
            0,
            0.68611,
            0,
            0,
            0.76666
        ],
        "928": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "931": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "933": [
            0,
            0.68611,
            0,
            0,
            0.89444
        ],
        "934": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "936": [
            0,
            0.68611,
            0,
            0,
            0.89444
        ],
        "937": [
            0,
            0.68611,
            0,
            0,
            0.83055
        ],
        "8211": [
            0,
            0.44444,
            0.03194,
            0,
            0.575
        ],
        "8212": [
            0,
            0.44444,
            0.03194,
            0,
            1.14999
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.31944
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.60278
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.60278
        ],
        "8224": [
            0.19444,
            0.69444,
            0,
            0,
            0.51111
        ],
        "8225": [
            0.19444,
            0.69444,
            0,
            0,
            0.51111
        ],
        "8242": [
            0,
            0.55556,
            0,
            0,
            0.34444
        ],
        "8407": [
            0,
            0.72444,
            0.15486,
            0,
            0.575
        ],
        "8463": [
            0,
            0.69444,
            0,
            0,
            0.66759
        ],
        "8465": [
            0,
            0.69444,
            0,
            0,
            0.83055
        ],
        "8467": [
            0,
            0.69444,
            0,
            0,
            0.47361
        ],
        "8472": [
            0.19444,
            0.44444,
            0,
            0,
            0.74027
        ],
        "8476": [
            0,
            0.69444,
            0,
            0,
            0.83055
        ],
        "8501": [
            0,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8592": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8593": [
            0.19444,
            0.69444,
            0,
            0,
            0.575
        ],
        "8594": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8595": [
            0.19444,
            0.69444,
            0,
            0,
            0.575
        ],
        "8596": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8597": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8598": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8599": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8600": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8601": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "8636": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8637": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8640": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8641": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8656": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8657": [
            0.19444,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8658": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8659": [
            0.19444,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8660": [
            -0.10889,
            0.39111,
            0,
            0,
            1.14999
        ],
        "8661": [
            0.25,
            0.75,
            0,
            0,
            0.70277
        ],
        "8704": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "8706": [
            0,
            0.69444,
            0.06389,
            0,
            0.62847
        ],
        "8707": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "8709": [
            0.05556,
            0.75,
            0,
            0,
            0.575
        ],
        "8711": [
            0,
            0.68611,
            0,
            0,
            0.95833
        ],
        "8712": [
            0.08556,
            0.58556,
            0,
            0,
            0.76666
        ],
        "8715": [
            0.08556,
            0.58556,
            0,
            0,
            0.76666
        ],
        "8722": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8723": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8725": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8726": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8727": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "8728": [
            -0.02639,
            0.47361,
            0,
            0,
            0.575
        ],
        "8729": [
            -0.02639,
            0.47361,
            0,
            0,
            0.575
        ],
        "8730": [
            0.18,
            0.82,
            0,
            0,
            0.95833
        ],
        "8733": [
            0,
            0.44444,
            0,
            0,
            0.89444
        ],
        "8734": [
            0,
            0.44444,
            0,
            0,
            1.14999
        ],
        "8736": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8739": [
            0.25,
            0.75,
            0,
            0,
            0.31944
        ],
        "8741": [
            0.25,
            0.75,
            0,
            0,
            0.575
        ],
        "8743": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8744": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8745": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8746": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8747": [
            0.19444,
            0.69444,
            0.12778,
            0,
            0.56875
        ],
        "8764": [
            -0.10889,
            0.39111,
            0,
            0,
            0.89444
        ],
        "8768": [
            0.19444,
            0.69444,
            0,
            0,
            0.31944
        ],
        "8771": [
            0.00222,
            0.50222,
            0,
            0,
            0.89444
        ],
        "8773": [
            0.027,
            0.638,
            0,
            0,
            0.894
        ],
        "8776": [
            0.02444,
            0.52444,
            0,
            0,
            0.89444
        ],
        "8781": [
            0.00222,
            0.50222,
            0,
            0,
            0.89444
        ],
        "8801": [
            0.00222,
            0.50222,
            0,
            0,
            0.89444
        ],
        "8804": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8805": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8810": [
            0.08556,
            0.58556,
            0,
            0,
            1.14999
        ],
        "8811": [
            0.08556,
            0.58556,
            0,
            0,
            1.14999
        ],
        "8826": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8827": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8834": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8835": [
            0.08556,
            0.58556,
            0,
            0,
            0.89444
        ],
        "8838": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8839": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8846": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8849": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8850": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "8851": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8852": [
            0,
            0.55556,
            0,
            0,
            0.76666
        ],
        "8853": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8854": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8855": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8856": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8857": [
            0.13333,
            0.63333,
            0,
            0,
            0.89444
        ],
        "8866": [
            0,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8867": [
            0,
            0.69444,
            0,
            0,
            0.70277
        ],
        "8868": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "8869": [
            0,
            0.69444,
            0,
            0,
            0.89444
        ],
        "8900": [
            -0.02639,
            0.47361,
            0,
            0,
            0.575
        ],
        "8901": [
            -0.02639,
            0.47361,
            0,
            0,
            0.31944
        ],
        "8902": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "8968": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8969": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8970": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8971": [
            0.25,
            0.75,
            0,
            0,
            0.51111
        ],
        "8994": [
            -0.13889,
            0.36111,
            0,
            0,
            1.14999
        ],
        "8995": [
            -0.13889,
            0.36111,
            0,
            0,
            1.14999
        ],
        "9651": [
            0.19444,
            0.69444,
            0,
            0,
            1.02222
        ],
        "9657": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "9661": [
            0.19444,
            0.69444,
            0,
            0,
            1.02222
        ],
        "9667": [
            -0.02778,
            0.47222,
            0,
            0,
            0.575
        ],
        "9711": [
            0.19444,
            0.69444,
            0,
            0,
            1.14999
        ],
        "9824": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9825": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9826": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9827": [
            0.12963,
            0.69444,
            0,
            0,
            0.89444
        ],
        "9837": [
            0,
            0.75,
            0,
            0,
            0.44722
        ],
        "9838": [
            0.19444,
            0.69444,
            0,
            0,
            0.44722
        ],
        "9839": [
            0.19444,
            0.69444,
            0,
            0,
            0.44722
        ],
        "10216": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "10217": [
            0.25,
            0.75,
            0,
            0,
            0.44722
        ],
        "10815": [
            0,
            0.68611,
            0,
            0,
            0.9
        ],
        "10927": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "10928": [
            0.19667,
            0.69667,
            0,
            0,
            0.89444
        ],
        "57376": [
            0.19444,
            0.69444,
            0,
            0,
            0
        ]
    },
    "Main-BoldItalic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0.11417,
            0,
            0.38611
        ],
        "34": [
            0,
            0.69444,
            0.07939,
            0,
            0.62055
        ],
        "35": [
            0.19444,
            0.69444,
            0.06833,
            0,
            0.94444
        ],
        "37": [
            0.05556,
            0.75,
            0.12861,
            0,
            0.94444
        ],
        "38": [
            0,
            0.69444,
            0.08528,
            0,
            0.88555
        ],
        "39": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "40": [
            0.25,
            0.75,
            0.15806,
            0,
            0.47333
        ],
        "41": [
            0.25,
            0.75,
            0.03306,
            0,
            0.47333
        ],
        "42": [
            0,
            0.75,
            0.14333,
            0,
            0.59111
        ],
        "43": [
            0.10333,
            0.60333,
            0.03306,
            0,
            0.88555
        ],
        "44": [
            0.19444,
            0.14722,
            0,
            0,
            0.35555
        ],
        "45": [
            0,
            0.44444,
            0.02611,
            0,
            0.41444
        ],
        "46": [
            0,
            0.14722,
            0,
            0,
            0.35555
        ],
        "47": [
            0.25,
            0.75,
            0.15806,
            0,
            0.59111
        ],
        "48": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "49": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "50": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "51": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "52": [
            0.19444,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "53": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "54": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "55": [
            0.19444,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "56": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "57": [
            0,
            0.64444,
            0.13167,
            0,
            0.59111
        ],
        "58": [
            0,
            0.44444,
            0.06695,
            0,
            0.35555
        ],
        "59": [
            0.19444,
            0.44444,
            0.06695,
            0,
            0.35555
        ],
        "61": [
            -0.10889,
            0.39111,
            0.06833,
            0,
            0.88555
        ],
        "63": [
            0,
            0.69444,
            0.11472,
            0,
            0.59111
        ],
        "64": [
            0,
            0.69444,
            0.09208,
            0,
            0.88555
        ],
        "65": [
            0,
            0.68611,
            0,
            0,
            0.86555
        ],
        "66": [
            0,
            0.68611,
            0.0992,
            0,
            0.81666
        ],
        "67": [
            0,
            0.68611,
            0.14208,
            0,
            0.82666
        ],
        "68": [
            0,
            0.68611,
            0.09062,
            0,
            0.87555
        ],
        "69": [
            0,
            0.68611,
            0.11431,
            0,
            0.75666
        ],
        "70": [
            0,
            0.68611,
            0.12903,
            0,
            0.72722
        ],
        "71": [
            0,
            0.68611,
            0.07347,
            0,
            0.89527
        ],
        "72": [
            0,
            0.68611,
            0.17208,
            0,
            0.8961
        ],
        "73": [
            0,
            0.68611,
            0.15681,
            0,
            0.47166
        ],
        "74": [
            0,
            0.68611,
            0.145,
            0,
            0.61055
        ],
        "75": [
            0,
            0.68611,
            0.14208,
            0,
            0.89499
        ],
        "76": [
            0,
            0.68611,
            0,
            0,
            0.69777
        ],
        "77": [
            0,
            0.68611,
            0.17208,
            0,
            1.07277
        ],
        "78": [
            0,
            0.68611,
            0.17208,
            0,
            0.8961
        ],
        "79": [
            0,
            0.68611,
            0.09062,
            0,
            0.85499
        ],
        "80": [
            0,
            0.68611,
            0.0992,
            0,
            0.78721
        ],
        "81": [
            0.19444,
            0.68611,
            0.09062,
            0,
            0.85499
        ],
        "82": [
            0,
            0.68611,
            0.02559,
            0,
            0.85944
        ],
        "83": [
            0,
            0.68611,
            0.11264,
            0,
            0.64999
        ],
        "84": [
            0,
            0.68611,
            0.12903,
            0,
            0.7961
        ],
        "85": [
            0,
            0.68611,
            0.17208,
            0,
            0.88083
        ],
        "86": [
            0,
            0.68611,
            0.18625,
            0,
            0.86555
        ],
        "87": [
            0,
            0.68611,
            0.18625,
            0,
            1.15999
        ],
        "88": [
            0,
            0.68611,
            0.15681,
            0,
            0.86555
        ],
        "89": [
            0,
            0.68611,
            0.19803,
            0,
            0.86555
        ],
        "90": [
            0,
            0.68611,
            0.14208,
            0,
            0.70888
        ],
        "91": [
            0.25,
            0.75,
            0.1875,
            0,
            0.35611
        ],
        "93": [
            0.25,
            0.75,
            0.09972,
            0,
            0.35611
        ],
        "94": [
            0,
            0.69444,
            0.06709,
            0,
            0.59111
        ],
        "95": [
            0.31,
            0.13444,
            0.09811,
            0,
            0.59111
        ],
        "97": [
            0,
            0.44444,
            0.09426,
            0,
            0.59111
        ],
        "98": [
            0,
            0.69444,
            0.07861,
            0,
            0.53222
        ],
        "99": [
            0,
            0.44444,
            0.05222,
            0,
            0.53222
        ],
        "100": [
            0,
            0.69444,
            0.10861,
            0,
            0.59111
        ],
        "101": [
            0,
            0.44444,
            0.085,
            0,
            0.53222
        ],
        "102": [
            0.19444,
            0.69444,
            0.21778,
            0,
            0.4
        ],
        "103": [
            0.19444,
            0.44444,
            0.105,
            0,
            0.53222
        ],
        "104": [
            0,
            0.69444,
            0.09426,
            0,
            0.59111
        ],
        "105": [
            0,
            0.69326,
            0.11387,
            0,
            0.35555
        ],
        "106": [
            0.19444,
            0.69326,
            0.1672,
            0,
            0.35555
        ],
        "107": [
            0,
            0.69444,
            0.11111,
            0,
            0.53222
        ],
        "108": [
            0,
            0.69444,
            0.10861,
            0,
            0.29666
        ],
        "109": [
            0,
            0.44444,
            0.09426,
            0,
            0.94444
        ],
        "110": [
            0,
            0.44444,
            0.09426,
            0,
            0.64999
        ],
        "111": [
            0,
            0.44444,
            0.07861,
            0,
            0.59111
        ],
        "112": [
            0.19444,
            0.44444,
            0.07861,
            0,
            0.59111
        ],
        "113": [
            0.19444,
            0.44444,
            0.105,
            0,
            0.53222
        ],
        "114": [
            0,
            0.44444,
            0.11111,
            0,
            0.50167
        ],
        "115": [
            0,
            0.44444,
            0.08167,
            0,
            0.48694
        ],
        "116": [
            0,
            0.63492,
            0.09639,
            0,
            0.385
        ],
        "117": [
            0,
            0.44444,
            0.09426,
            0,
            0.62055
        ],
        "118": [
            0,
            0.44444,
            0.11111,
            0,
            0.53222
        ],
        "119": [
            0,
            0.44444,
            0.11111,
            0,
            0.76777
        ],
        "120": [
            0,
            0.44444,
            0.12583,
            0,
            0.56055
        ],
        "121": [
            0.19444,
            0.44444,
            0.105,
            0,
            0.56166
        ],
        "122": [
            0,
            0.44444,
            0.13889,
            0,
            0.49055
        ],
        "126": [
            0.35,
            0.34444,
            0.11472,
            0,
            0.59111
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.69444,
            0.11473,
            0,
            0.59111
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.94888
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.53222
        ],
        "198": [
            0,
            0.68611,
            0.11431,
            0,
            1.02277
        ],
        "216": [
            0.04861,
            0.73472,
            0.09062,
            0,
            0.88555
        ],
        "223": [
            0.19444,
            0.69444,
            0.09736,
            0,
            0.665
        ],
        "230": [
            0,
            0.44444,
            0.085,
            0,
            0.82666
        ],
        "248": [
            0.09722,
            0.54167,
            0.09458,
            0,
            0.59111
        ],
        "305": [
            0,
            0.44444,
            0.09426,
            0,
            0.35555
        ],
        "338": [
            0,
            0.68611,
            0.11431,
            0,
            1.14054
        ],
        "339": [
            0,
            0.44444,
            0.085,
            0,
            0.82666
        ],
        "567": [
            0.19444,
            0.44444,
            0.04611,
            0,
            0.385
        ],
        "710": [
            0,
            0.69444,
            0.06709,
            0,
            0.59111
        ],
        "711": [
            0,
            0.63194,
            0.08271,
            0,
            0.59111
        ],
        "713": [
            0,
            0.59444,
            0.10444,
            0,
            0.59111
        ],
        "714": [
            0,
            0.69444,
            0.08528,
            0,
            0.59111
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.59111
        ],
        "728": [
            0,
            0.69444,
            0.10333,
            0,
            0.59111
        ],
        "729": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.94888
        ],
        "732": [
            0,
            0.69444,
            0.11472,
            0,
            0.59111
        ],
        "733": [
            0,
            0.69444,
            0.11472,
            0,
            0.59111
        ],
        "915": [
            0,
            0.68611,
            0.12903,
            0,
            0.69777
        ],
        "916": [
            0,
            0.68611,
            0,
            0,
            0.94444
        ],
        "920": [
            0,
            0.68611,
            0.09062,
            0,
            0.88555
        ],
        "923": [
            0,
            0.68611,
            0,
            0,
            0.80666
        ],
        "926": [
            0,
            0.68611,
            0.15092,
            0,
            0.76777
        ],
        "928": [
            0,
            0.68611,
            0.17208,
            0,
            0.8961
        ],
        "931": [
            0,
            0.68611,
            0.11431,
            0,
            0.82666
        ],
        "933": [
            0,
            0.68611,
            0.10778,
            0,
            0.88555
        ],
        "934": [
            0,
            0.68611,
            0.05632,
            0,
            0.82666
        ],
        "936": [
            0,
            0.68611,
            0.10778,
            0,
            0.88555
        ],
        "937": [
            0,
            0.68611,
            0.0992,
            0,
            0.82666
        ],
        "8211": [
            0,
            0.44444,
            0.09811,
            0,
            0.59111
        ],
        "8212": [
            0,
            0.44444,
            0.09811,
            0,
            1.18221
        ],
        "8216": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "8217": [
            0,
            0.69444,
            0.12945,
            0,
            0.35555
        ],
        "8220": [
            0,
            0.69444,
            0.16772,
            0,
            0.62055
        ],
        "8221": [
            0,
            0.69444,
            0.07939,
            0,
            0.62055
        ]
    },
    "Main-Italic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "34": [
            0,
            0.69444,
            0.06961,
            0,
            0.51444
        ],
        "35": [
            0.19444,
            0.69444,
            0.06616,
            0,
            0.81777
        ],
        "37": [
            0.05556,
            0.75,
            0.13639,
            0,
            0.81777
        ],
        "38": [
            0,
            0.69444,
            0.09694,
            0,
            0.76666
        ],
        "39": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "40": [
            0.25,
            0.75,
            0.16194,
            0,
            0.40889
        ],
        "41": [
            0.25,
            0.75,
            0.03694,
            0,
            0.40889
        ],
        "42": [
            0,
            0.75,
            0.14917,
            0,
            0.51111
        ],
        "43": [
            0.05667,
            0.56167,
            0.03694,
            0,
            0.76666
        ],
        "44": [
            0.19444,
            0.10556,
            0,
            0,
            0.30667
        ],
        "45": [
            0,
            0.43056,
            0.02826,
            0,
            0.35778
        ],
        "46": [
            0,
            0.10556,
            0,
            0,
            0.30667
        ],
        "47": [
            0.25,
            0.75,
            0.16194,
            0,
            0.51111
        ],
        "48": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "49": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "50": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "51": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "52": [
            0.19444,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "53": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "54": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "55": [
            0.19444,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "56": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "57": [
            0,
            0.64444,
            0.13556,
            0,
            0.51111
        ],
        "58": [
            0,
            0.43056,
            0.0582,
            0,
            0.30667
        ],
        "59": [
            0.19444,
            0.43056,
            0.0582,
            0,
            0.30667
        ],
        "61": [
            -0.13313,
            0.36687,
            0.06616,
            0,
            0.76666
        ],
        "63": [
            0,
            0.69444,
            0.1225,
            0,
            0.51111
        ],
        "64": [
            0,
            0.69444,
            0.09597,
            0,
            0.76666
        ],
        "65": [
            0,
            0.68333,
            0,
            0,
            0.74333
        ],
        "66": [
            0,
            0.68333,
            0.10257,
            0,
            0.70389
        ],
        "67": [
            0,
            0.68333,
            0.14528,
            0,
            0.71555
        ],
        "68": [
            0,
            0.68333,
            0.09403,
            0,
            0.755
        ],
        "69": [
            0,
            0.68333,
            0.12028,
            0,
            0.67833
        ],
        "70": [
            0,
            0.68333,
            0.13305,
            0,
            0.65277
        ],
        "71": [
            0,
            0.68333,
            0.08722,
            0,
            0.77361
        ],
        "72": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "73": [
            0,
            0.68333,
            0.15806,
            0,
            0.38555
        ],
        "74": [
            0,
            0.68333,
            0.14028,
            0,
            0.525
        ],
        "75": [
            0,
            0.68333,
            0.14528,
            0,
            0.76888
        ],
        "76": [
            0,
            0.68333,
            0,
            0,
            0.62722
        ],
        "77": [
            0,
            0.68333,
            0.16389,
            0,
            0.89666
        ],
        "78": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "79": [
            0,
            0.68333,
            0.09403,
            0,
            0.76666
        ],
        "80": [
            0,
            0.68333,
            0.10257,
            0,
            0.67833
        ],
        "81": [
            0.19444,
            0.68333,
            0.09403,
            0,
            0.76666
        ],
        "82": [
            0,
            0.68333,
            0.03868,
            0,
            0.72944
        ],
        "83": [
            0,
            0.68333,
            0.11972,
            0,
            0.56222
        ],
        "84": [
            0,
            0.68333,
            0.13305,
            0,
            0.71555
        ],
        "85": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "86": [
            0,
            0.68333,
            0.18361,
            0,
            0.74333
        ],
        "87": [
            0,
            0.68333,
            0.18361,
            0,
            0.99888
        ],
        "88": [
            0,
            0.68333,
            0.15806,
            0,
            0.74333
        ],
        "89": [
            0,
            0.68333,
            0.19383,
            0,
            0.74333
        ],
        "90": [
            0,
            0.68333,
            0.14528,
            0,
            0.61333
        ],
        "91": [
            0.25,
            0.75,
            0.1875,
            0,
            0.30667
        ],
        "93": [
            0.25,
            0.75,
            0.10528,
            0,
            0.30667
        ],
        "94": [
            0,
            0.69444,
            0.06646,
            0,
            0.51111
        ],
        "95": [
            0.31,
            0.12056,
            0.09208,
            0,
            0.51111
        ],
        "97": [
            0,
            0.43056,
            0.07671,
            0,
            0.51111
        ],
        "98": [
            0,
            0.69444,
            0.06312,
            0,
            0.46
        ],
        "99": [
            0,
            0.43056,
            0.05653,
            0,
            0.46
        ],
        "100": [
            0,
            0.69444,
            0.10333,
            0,
            0.51111
        ],
        "101": [
            0,
            0.43056,
            0.07514,
            0,
            0.46
        ],
        "102": [
            0.19444,
            0.69444,
            0.21194,
            0,
            0.30667
        ],
        "103": [
            0.19444,
            0.43056,
            0.08847,
            0,
            0.46
        ],
        "104": [
            0,
            0.69444,
            0.07671,
            0,
            0.51111
        ],
        "105": [
            0,
            0.65536,
            0.1019,
            0,
            0.30667
        ],
        "106": [
            0.19444,
            0.65536,
            0.14467,
            0,
            0.30667
        ],
        "107": [
            0,
            0.69444,
            0.10764,
            0,
            0.46
        ],
        "108": [
            0,
            0.69444,
            0.10333,
            0,
            0.25555
        ],
        "109": [
            0,
            0.43056,
            0.07671,
            0,
            0.81777
        ],
        "110": [
            0,
            0.43056,
            0.07671,
            0,
            0.56222
        ],
        "111": [
            0,
            0.43056,
            0.06312,
            0,
            0.51111
        ],
        "112": [
            0.19444,
            0.43056,
            0.06312,
            0,
            0.51111
        ],
        "113": [
            0.19444,
            0.43056,
            0.08847,
            0,
            0.46
        ],
        "114": [
            0,
            0.43056,
            0.10764,
            0,
            0.42166
        ],
        "115": [
            0,
            0.43056,
            0.08208,
            0,
            0.40889
        ],
        "116": [
            0,
            0.61508,
            0.09486,
            0,
            0.33222
        ],
        "117": [
            0,
            0.43056,
            0.07671,
            0,
            0.53666
        ],
        "118": [
            0,
            0.43056,
            0.10764,
            0,
            0.46
        ],
        "119": [
            0,
            0.43056,
            0.10764,
            0,
            0.66444
        ],
        "120": [
            0,
            0.43056,
            0.12042,
            0,
            0.46389
        ],
        "121": [
            0.19444,
            0.43056,
            0.08847,
            0,
            0.48555
        ],
        "122": [
            0,
            0.43056,
            0.12292,
            0,
            0.40889
        ],
        "126": [
            0.35,
            0.31786,
            0.11585,
            0,
            0.51111
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.66786,
            0.10474,
            0,
            0.51111
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.83129
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.46
        ],
        "198": [
            0,
            0.68333,
            0.12028,
            0,
            0.88277
        ],
        "216": [
            0.04861,
            0.73194,
            0.09403,
            0,
            0.76666
        ],
        "223": [
            0.19444,
            0.69444,
            0.10514,
            0,
            0.53666
        ],
        "230": [
            0,
            0.43056,
            0.07514,
            0,
            0.71555
        ],
        "248": [
            0.09722,
            0.52778,
            0.09194,
            0,
            0.51111
        ],
        "338": [
            0,
            0.68333,
            0.12028,
            0,
            0.98499
        ],
        "339": [
            0,
            0.43056,
            0.07514,
            0,
            0.71555
        ],
        "710": [
            0,
            0.69444,
            0.06646,
            0,
            0.51111
        ],
        "711": [
            0,
            0.62847,
            0.08295,
            0,
            0.51111
        ],
        "713": [
            0,
            0.56167,
            0.10333,
            0,
            0.51111
        ],
        "714": [
            0,
            0.69444,
            0.09694,
            0,
            0.51111
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.51111
        ],
        "728": [
            0,
            0.69444,
            0.10806,
            0,
            0.51111
        ],
        "729": [
            0,
            0.66786,
            0.11752,
            0,
            0.30667
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.83129
        ],
        "732": [
            0,
            0.66786,
            0.11585,
            0,
            0.51111
        ],
        "733": [
            0,
            0.69444,
            0.1225,
            0,
            0.51111
        ],
        "915": [
            0,
            0.68333,
            0.13305,
            0,
            0.62722
        ],
        "916": [
            0,
            0.68333,
            0,
            0,
            0.81777
        ],
        "920": [
            0,
            0.68333,
            0.09403,
            0,
            0.76666
        ],
        "923": [
            0,
            0.68333,
            0,
            0,
            0.69222
        ],
        "926": [
            0,
            0.68333,
            0.15294,
            0,
            0.66444
        ],
        "928": [
            0,
            0.68333,
            0.16389,
            0,
            0.74333
        ],
        "931": [
            0,
            0.68333,
            0.12028,
            0,
            0.71555
        ],
        "933": [
            0,
            0.68333,
            0.11111,
            0,
            0.76666
        ],
        "934": [
            0,
            0.68333,
            0.05986,
            0,
            0.71555
        ],
        "936": [
            0,
            0.68333,
            0.11111,
            0,
            0.76666
        ],
        "937": [
            0,
            0.68333,
            0.10257,
            0,
            0.71555
        ],
        "8211": [
            0,
            0.43056,
            0.09208,
            0,
            0.51111
        ],
        "8212": [
            0,
            0.43056,
            0.09208,
            0,
            1.02222
        ],
        "8216": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "8217": [
            0,
            0.69444,
            0.12417,
            0,
            0.30667
        ],
        "8220": [
            0,
            0.69444,
            0.1685,
            0,
            0.51444
        ],
        "8221": [
            0,
            0.69444,
            0.06961,
            0,
            0.51444
        ],
        "8463": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ]
    },
    "Main-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.83334
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.5
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            0.83334
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.5
        ],
        "43": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "44": [
            0.19444,
            0.10556,
            0,
            0,
            0.27778
        ],
        "45": [
            0,
            0.43056,
            0,
            0,
            0.33333
        ],
        "46": [
            0,
            0.10556,
            0,
            0,
            0.27778
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "48": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "49": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "50": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "51": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "52": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "53": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "55": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "57": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "58": [
            0,
            0.43056,
            0,
            0,
            0.27778
        ],
        "59": [
            0.19444,
            0.43056,
            0,
            0,
            0.27778
        ],
        "60": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "61": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "62": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.47222
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "65": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "66": [
            0,
            0.68333,
            0,
            0,
            0.70834
        ],
        "67": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "68": [
            0,
            0.68333,
            0,
            0,
            0.76389
        ],
        "69": [
            0,
            0.68333,
            0,
            0,
            0.68056
        ],
        "70": [
            0,
            0.68333,
            0,
            0,
            0.65278
        ],
        "71": [
            0,
            0.68333,
            0,
            0,
            0.78472
        ],
        "72": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "73": [
            0,
            0.68333,
            0,
            0,
            0.36111
        ],
        "74": [
            0,
            0.68333,
            0,
            0,
            0.51389
        ],
        "75": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "76": [
            0,
            0.68333,
            0,
            0,
            0.625
        ],
        "77": [
            0,
            0.68333,
            0,
            0,
            0.91667
        ],
        "78": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "79": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "80": [
            0,
            0.68333,
            0,
            0,
            0.68056
        ],
        "81": [
            0.19444,
            0.68333,
            0,
            0,
            0.77778
        ],
        "82": [
            0,
            0.68333,
            0,
            0,
            0.73611
        ],
        "83": [
            0,
            0.68333,
            0,
            0,
            0.55556
        ],
        "84": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "85": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "86": [
            0,
            0.68333,
            0.01389,
            0,
            0.75
        ],
        "87": [
            0,
            0.68333,
            0.01389,
            0,
            1.02778
        ],
        "88": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "89": [
            0,
            0.68333,
            0.025,
            0,
            0.75
        ],
        "90": [
            0,
            0.68333,
            0,
            0,
            0.61111
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "92": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "95": [
            0.31,
            0.12056,
            0.02778,
            0,
            0.5
        ],
        "97": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "99": [
            0,
            0.43056,
            0,
            0,
            0.44445
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "101": [
            0,
            0.43056,
            0,
            0,
            0.44445
        ],
        "102": [
            0,
            0.69444,
            0.07778,
            0,
            0.30556
        ],
        "103": [
            0.19444,
            0.43056,
            0.01389,
            0,
            0.5
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "105": [
            0,
            0.66786,
            0,
            0,
            0.27778
        ],
        "106": [
            0.19444,
            0.66786,
            0,
            0,
            0.30556
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.52778
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "109": [
            0,
            0.43056,
            0,
            0,
            0.83334
        ],
        "110": [
            0,
            0.43056,
            0,
            0,
            0.55556
        ],
        "111": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "112": [
            0.19444,
            0.43056,
            0,
            0,
            0.55556
        ],
        "113": [
            0.19444,
            0.43056,
            0,
            0,
            0.52778
        ],
        "114": [
            0,
            0.43056,
            0,
            0,
            0.39167
        ],
        "115": [
            0,
            0.43056,
            0,
            0,
            0.39445
        ],
        "116": [
            0,
            0.61508,
            0,
            0,
            0.38889
        ],
        "117": [
            0,
            0.43056,
            0,
            0,
            0.55556
        ],
        "118": [
            0,
            0.43056,
            0.01389,
            0,
            0.52778
        ],
        "119": [
            0,
            0.43056,
            0.01389,
            0,
            0.72222
        ],
        "120": [
            0,
            0.43056,
            0,
            0,
            0.52778
        ],
        "121": [
            0.19444,
            0.43056,
            0.01389,
            0,
            0.52778
        ],
        "122": [
            0,
            0.43056,
            0,
            0,
            0.44445
        ],
        "123": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "124": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "125": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "126": [
            0.35,
            0.31786,
            0,
            0,
            0.5
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "163": [
            0,
            0.69444,
            0,
            0,
            0.76909
        ],
        "167": [
            0.19444,
            0.69444,
            0,
            0,
            0.44445
        ],
        "168": [
            0,
            0.66786,
            0,
            0,
            0.5
        ],
        "172": [
            0,
            0.43056,
            0,
            0,
            0.66667
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.75
        ],
        "177": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "182": [
            0.19444,
            0.69444,
            0,
            0,
            0.61111
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.44445
        ],
        "198": [
            0,
            0.68333,
            0,
            0,
            0.90278
        ],
        "215": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "216": [
            0.04861,
            0.73194,
            0,
            0,
            0.77778
        ],
        "223": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "230": [
            0,
            0.43056,
            0,
            0,
            0.72222
        ],
        "247": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "248": [
            0.09722,
            0.52778,
            0,
            0,
            0.5
        ],
        "305": [
            0,
            0.43056,
            0,
            0,
            0.27778
        ],
        "338": [
            0,
            0.68333,
            0,
            0,
            1.01389
        ],
        "339": [
            0,
            0.43056,
            0,
            0,
            0.77778
        ],
        "567": [
            0.19444,
            0.43056,
            0,
            0,
            0.30556
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "711": [
            0,
            0.62847,
            0,
            0,
            0.5
        ],
        "713": [
            0,
            0.56778,
            0,
            0,
            0.5
        ],
        "714": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "729": [
            0,
            0.66786,
            0,
            0,
            0.27778
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.75
        ],
        "732": [
            0,
            0.66786,
            0,
            0,
            0.5
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "915": [
            0,
            0.68333,
            0,
            0,
            0.625
        ],
        "916": [
            0,
            0.68333,
            0,
            0,
            0.83334
        ],
        "920": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "923": [
            0,
            0.68333,
            0,
            0,
            0.69445
        ],
        "926": [
            0,
            0.68333,
            0,
            0,
            0.66667
        ],
        "928": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "931": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "933": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "934": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "936": [
            0,
            0.68333,
            0,
            0,
            0.77778
        ],
        "937": [
            0,
            0.68333,
            0,
            0,
            0.72222
        ],
        "8211": [
            0,
            0.43056,
            0.02778,
            0,
            0.5
        ],
        "8212": [
            0,
            0.43056,
            0.02778,
            0,
            1.0
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "8224": [
            0.19444,
            0.69444,
            0,
            0,
            0.44445
        ],
        "8225": [
            0.19444,
            0.69444,
            0,
            0,
            0.44445
        ],
        "8230": [
            0,
            0.123,
            0,
            0,
            1.172
        ],
        "8242": [
            0,
            0.55556,
            0,
            0,
            0.275
        ],
        "8407": [
            0,
            0.71444,
            0.15382,
            0,
            0.5
        ],
        "8463": [
            0,
            0.68889,
            0,
            0,
            0.54028
        ],
        "8465": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "8467": [
            0,
            0.69444,
            0,
            0.11111,
            0.41667
        ],
        "8472": [
            0.19444,
            0.43056,
            0,
            0.11111,
            0.63646
        ],
        "8476": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "8501": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8592": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8593": [
            0.19444,
            0.69444,
            0,
            0,
            0.5
        ],
        "8594": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8595": [
            0.19444,
            0.69444,
            0,
            0,
            0.5
        ],
        "8596": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8597": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8598": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8599": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8600": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8601": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "8614": [
            0.011,
            0.511,
            0,
            0,
            1.0
        ],
        "8617": [
            0.011,
            0.511,
            0,
            0,
            1.126
        ],
        "8618": [
            0.011,
            0.511,
            0,
            0,
            1.126
        ],
        "8636": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8637": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8640": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8641": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8652": [
            0.011,
            0.671,
            0,
            0,
            1.0
        ],
        "8656": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8657": [
            0.19444,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8658": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8659": [
            0.19444,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8660": [
            -0.13313,
            0.36687,
            0,
            0,
            1.0
        ],
        "8661": [
            0.25,
            0.75,
            0,
            0,
            0.61111
        ],
        "8704": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "8706": [
            0,
            0.69444,
            0.05556,
            0.08334,
            0.5309
        ],
        "8707": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "8709": [
            0.05556,
            0.75,
            0,
            0,
            0.5
        ],
        "8711": [
            0,
            0.68333,
            0,
            0,
            0.83334
        ],
        "8712": [
            0.0391,
            0.5391,
            0,
            0,
            0.66667
        ],
        "8715": [
            0.0391,
            0.5391,
            0,
            0,
            0.66667
        ],
        "8722": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8723": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8725": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8726": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8727": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "8728": [
            -0.05555,
            0.44445,
            0,
            0,
            0.5
        ],
        "8729": [
            -0.05555,
            0.44445,
            0,
            0,
            0.5
        ],
        "8730": [
            0.2,
            0.8,
            0,
            0,
            0.83334
        ],
        "8733": [
            0,
            0.43056,
            0,
            0,
            0.77778
        ],
        "8734": [
            0,
            0.43056,
            0,
            0,
            1.0
        ],
        "8736": [
            0,
            0.69224,
            0,
            0,
            0.72222
        ],
        "8739": [
            0.25,
            0.75,
            0,
            0,
            0.27778
        ],
        "8741": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "8743": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8744": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8745": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8746": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8747": [
            0.19444,
            0.69444,
            0.11111,
            0,
            0.41667
        ],
        "8764": [
            -0.13313,
            0.36687,
            0,
            0,
            0.77778
        ],
        "8768": [
            0.19444,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8771": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8773": [
            -0.022,
            0.589,
            0,
            0,
            0.778
        ],
        "8776": [
            -0.01688,
            0.48312,
            0,
            0,
            0.77778
        ],
        "8781": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8784": [
            -0.133,
            0.673,
            0,
            0,
            0.778
        ],
        "8801": [
            -0.03625,
            0.46375,
            0,
            0,
            0.77778
        ],
        "8804": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8805": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8810": [
            0.0391,
            0.5391,
            0,
            0,
            1.0
        ],
        "8811": [
            0.0391,
            0.5391,
            0,
            0,
            1.0
        ],
        "8826": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8827": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8834": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8835": [
            0.0391,
            0.5391,
            0,
            0,
            0.77778
        ],
        "8838": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8839": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8846": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8849": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8850": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "8851": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8852": [
            0,
            0.55556,
            0,
            0,
            0.66667
        ],
        "8853": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8854": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8855": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8856": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8857": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "8866": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8867": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "8868": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "8869": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "8872": [
            0.249,
            0.75,
            0,
            0,
            0.867
        ],
        "8900": [
            -0.05555,
            0.44445,
            0,
            0,
            0.5
        ],
        "8901": [
            -0.05555,
            0.44445,
            0,
            0,
            0.27778
        ],
        "8902": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "8904": [
            0.005,
            0.505,
            0,
            0,
            0.9
        ],
        "8942": [
            0.03,
            0.903,
            0,
            0,
            0.278
        ],
        "8943": [
            -0.19,
            0.313,
            0,
            0,
            1.172
        ],
        "8945": [
            -0.1,
            0.823,
            0,
            0,
            1.282
        ],
        "8968": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8969": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8970": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8971": [
            0.25,
            0.75,
            0,
            0,
            0.44445
        ],
        "8994": [
            -0.14236,
            0.35764,
            0,
            0,
            1.0
        ],
        "8995": [
            -0.14236,
            0.35764,
            0,
            0,
            1.0
        ],
        "9136": [
            0.244,
            0.744,
            0,
            0,
            0.412
        ],
        "9137": [
            0.244,
            0.745,
            0,
            0,
            0.412
        ],
        "9651": [
            0.19444,
            0.69444,
            0,
            0,
            0.88889
        ],
        "9657": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "9661": [
            0.19444,
            0.69444,
            0,
            0,
            0.88889
        ],
        "9667": [
            -0.03472,
            0.46528,
            0,
            0,
            0.5
        ],
        "9711": [
            0.19444,
            0.69444,
            0,
            0,
            1.0
        ],
        "9824": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9825": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9826": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9827": [
            0.12963,
            0.69444,
            0,
            0,
            0.77778
        ],
        "9837": [
            0,
            0.75,
            0,
            0,
            0.38889
        ],
        "9838": [
            0.19444,
            0.69444,
            0,
            0,
            0.38889
        ],
        "9839": [
            0.19444,
            0.69444,
            0,
            0,
            0.38889
        ],
        "10216": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "10217": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "10222": [
            0.244,
            0.744,
            0,
            0,
            0.412
        ],
        "10223": [
            0.244,
            0.745,
            0,
            0,
            0.412
        ],
        "10229": [
            0.011,
            0.511,
            0,
            0,
            1.609
        ],
        "10230": [
            0.011,
            0.511,
            0,
            0,
            1.638
        ],
        "10231": [
            0.011,
            0.511,
            0,
            0,
            1.859
        ],
        "10232": [
            0.024,
            0.525,
            0,
            0,
            1.609
        ],
        "10233": [
            0.024,
            0.525,
            0,
            0,
            1.638
        ],
        "10234": [
            0.024,
            0.525,
            0,
            0,
            1.858
        ],
        "10236": [
            0.011,
            0.511,
            0,
            0,
            1.638
        ],
        "10815": [
            0,
            0.68333,
            0,
            0,
            0.75
        ],
        "10927": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "10928": [
            0.13597,
            0.63597,
            0,
            0,
            0.77778
        ],
        "57376": [
            0.19444,
            0.69444,
            0,
            0,
            0
        ]
    },
    "Math-BoldItalic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "48": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "49": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "50": [
            0,
            0.44444,
            0,
            0,
            0.575
        ],
        "51": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "52": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "53": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "55": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.575
        ],
        "57": [
            0.19444,
            0.44444,
            0,
            0,
            0.575
        ],
        "65": [
            0,
            0.68611,
            0,
            0,
            0.86944
        ],
        "66": [
            0,
            0.68611,
            0.04835,
            0,
            0.8664
        ],
        "67": [
            0,
            0.68611,
            0.06979,
            0,
            0.81694
        ],
        "68": [
            0,
            0.68611,
            0.03194,
            0,
            0.93812
        ],
        "69": [
            0,
            0.68611,
            0.05451,
            0,
            0.81007
        ],
        "70": [
            0,
            0.68611,
            0.15972,
            0,
            0.68889
        ],
        "71": [
            0,
            0.68611,
            0,
            0,
            0.88673
        ],
        "72": [
            0,
            0.68611,
            0.08229,
            0,
            0.98229
        ],
        "73": [
            0,
            0.68611,
            0.07778,
            0,
            0.51111
        ],
        "74": [
            0,
            0.68611,
            0.10069,
            0,
            0.63125
        ],
        "75": [
            0,
            0.68611,
            0.06979,
            0,
            0.97118
        ],
        "76": [
            0,
            0.68611,
            0,
            0,
            0.75555
        ],
        "77": [
            0,
            0.68611,
            0.11424,
            0,
            1.14201
        ],
        "78": [
            0,
            0.68611,
            0.11424,
            0,
            0.95034
        ],
        "79": [
            0,
            0.68611,
            0.03194,
            0,
            0.83666
        ],
        "80": [
            0,
            0.68611,
            0.15972,
            0,
            0.72309
        ],
        "81": [
            0.19444,
            0.68611,
            0,
            0,
            0.86861
        ],
        "82": [
            0,
            0.68611,
            0.00421,
            0,
            0.87235
        ],
        "83": [
            0,
            0.68611,
            0.05382,
            0,
            0.69271
        ],
        "84": [
            0,
            0.68611,
            0.15972,
            0,
            0.63663
        ],
        "85": [
            0,
            0.68611,
            0.11424,
            0,
            0.80027
        ],
        "86": [
            0,
            0.68611,
            0.25555,
            0,
            0.67778
        ],
        "87": [
            0,
            0.68611,
            0.15972,
            0,
            1.09305
        ],
        "88": [
            0,
            0.68611,
            0.07778,
            0,
            0.94722
        ],
        "89": [
            0,
            0.68611,
            0.25555,
            0,
            0.67458
        ],
        "90": [
            0,
            0.68611,
            0.06979,
            0,
            0.77257
        ],
        "97": [
            0,
            0.44444,
            0,
            0,
            0.63287
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.52083
        ],
        "99": [
            0,
            0.44444,
            0,
            0,
            0.51342
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.60972
        ],
        "101": [
            0,
            0.44444,
            0,
            0,
            0.55361
        ],
        "102": [
            0.19444,
            0.69444,
            0.11042,
            0,
            0.56806
        ],
        "103": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.5449
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.66759
        ],
        "105": [
            0,
            0.69326,
            0,
            0,
            0.4048
        ],
        "106": [
            0.19444,
            0.69326,
            0.0622,
            0,
            0.47083
        ],
        "107": [
            0,
            0.69444,
            0.01852,
            0,
            0.6037
        ],
        "108": [
            0,
            0.69444,
            0.0088,
            0,
            0.34815
        ],
        "109": [
            0,
            0.44444,
            0,
            0,
            1.0324
        ],
        "110": [
            0,
            0.44444,
            0,
            0,
            0.71296
        ],
        "111": [
            0,
            0.44444,
            0,
            0,
            0.58472
        ],
        "112": [
            0.19444,
            0.44444,
            0,
            0,
            0.60092
        ],
        "113": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.54213
        ],
        "114": [
            0,
            0.44444,
            0.03194,
            0,
            0.5287
        ],
        "115": [
            0,
            0.44444,
            0,
            0,
            0.53125
        ],
        "116": [
            0,
            0.63492,
            0,
            0,
            0.41528
        ],
        "117": [
            0,
            0.44444,
            0,
            0,
            0.68102
        ],
        "118": [
            0,
            0.44444,
            0.03704,
            0,
            0.56666
        ],
        "119": [
            0,
            0.44444,
            0.02778,
            0,
            0.83148
        ],
        "120": [
            0,
            0.44444,
            0,
            0,
            0.65903
        ],
        "121": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.59028
        ],
        "122": [
            0,
            0.44444,
            0.04213,
            0,
            0.55509
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "915": [
            0,
            0.68611,
            0.15972,
            0,
            0.65694
        ],
        "916": [
            0,
            0.68611,
            0,
            0,
            0.95833
        ],
        "920": [
            0,
            0.68611,
            0.03194,
            0,
            0.86722
        ],
        "923": [
            0,
            0.68611,
            0,
            0,
            0.80555
        ],
        "926": [
            0,
            0.68611,
            0.07458,
            0,
            0.84125
        ],
        "928": [
            0,
            0.68611,
            0.08229,
            0,
            0.98229
        ],
        "931": [
            0,
            0.68611,
            0.05451,
            0,
            0.88507
        ],
        "933": [
            0,
            0.68611,
            0.15972,
            0,
            0.67083
        ],
        "934": [
            0,
            0.68611,
            0,
            0,
            0.76666
        ],
        "936": [
            0,
            0.68611,
            0.11653,
            0,
            0.71402
        ],
        "937": [
            0,
            0.68611,
            0.04835,
            0,
            0.8789
        ],
        "945": [
            0,
            0.44444,
            0,
            0,
            0.76064
        ],
        "946": [
            0.19444,
            0.69444,
            0.03403,
            0,
            0.65972
        ],
        "947": [
            0.19444,
            0.44444,
            0.06389,
            0,
            0.59003
        ],
        "948": [
            0,
            0.69444,
            0.03819,
            0,
            0.52222
        ],
        "949": [
            0,
            0.44444,
            0,
            0,
            0.52882
        ],
        "950": [
            0.19444,
            0.69444,
            0.06215,
            0,
            0.50833
        ],
        "951": [
            0.19444,
            0.44444,
            0.03704,
            0,
            0.6
        ],
        "952": [
            0,
            0.69444,
            0.03194,
            0,
            0.5618
        ],
        "953": [
            0,
            0.44444,
            0,
            0,
            0.41204
        ],
        "954": [
            0,
            0.44444,
            0,
            0,
            0.66759
        ],
        "955": [
            0,
            0.69444,
            0,
            0,
            0.67083
        ],
        "956": [
            0.19444,
            0.44444,
            0,
            0,
            0.70787
        ],
        "957": [
            0,
            0.44444,
            0.06898,
            0,
            0.57685
        ],
        "958": [
            0.19444,
            0.69444,
            0.03021,
            0,
            0.50833
        ],
        "959": [
            0,
            0.44444,
            0,
            0,
            0.58472
        ],
        "960": [
            0,
            0.44444,
            0.03704,
            0,
            0.68241
        ],
        "961": [
            0.19444,
            0.44444,
            0,
            0,
            0.6118
        ],
        "962": [
            0.09722,
            0.44444,
            0.07917,
            0,
            0.42361
        ],
        "963": [
            0,
            0.44444,
            0.03704,
            0,
            0.68588
        ],
        "964": [
            0,
            0.44444,
            0.13472,
            0,
            0.52083
        ],
        "965": [
            0,
            0.44444,
            0.03704,
            0,
            0.63055
        ],
        "966": [
            0.19444,
            0.44444,
            0,
            0,
            0.74722
        ],
        "967": [
            0.19444,
            0.44444,
            0,
            0,
            0.71805
        ],
        "968": [
            0.19444,
            0.69444,
            0.03704,
            0,
            0.75833
        ],
        "969": [
            0,
            0.44444,
            0.03704,
            0,
            0.71782
        ],
        "977": [
            0,
            0.69444,
            0,
            0,
            0.69155
        ],
        "981": [
            0.19444,
            0.69444,
            0,
            0,
            0.7125
        ],
        "982": [
            0,
            0.44444,
            0.03194,
            0,
            0.975
        ],
        "1009": [
            0.19444,
            0.44444,
            0,
            0,
            0.6118
        ],
        "1013": [
            0,
            0.44444,
            0,
            0,
            0.48333
        ],
        "57649": [
            0,
            0.44444,
            0,
            0,
            0.39352
        ],
        "57911": [
            0.19444,
            0.44444,
            0,
            0,
            0.43889
        ]
    },
    "Math-Italic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "48": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "49": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "50": [
            0,
            0.43056,
            0,
            0,
            0.5
        ],
        "51": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "52": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "53": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "54": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "55": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "56": [
            0,
            0.64444,
            0,
            0,
            0.5
        ],
        "57": [
            0.19444,
            0.43056,
            0,
            0,
            0.5
        ],
        "65": [
            0,
            0.68333,
            0,
            0.13889,
            0.75
        ],
        "66": [
            0,
            0.68333,
            0.05017,
            0.08334,
            0.75851
        ],
        "67": [
            0,
            0.68333,
            0.07153,
            0.08334,
            0.71472
        ],
        "68": [
            0,
            0.68333,
            0.02778,
            0.05556,
            0.82792
        ],
        "69": [
            0,
            0.68333,
            0.05764,
            0.08334,
            0.7382
        ],
        "70": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.64306
        ],
        "71": [
            0,
            0.68333,
            0,
            0.08334,
            0.78625
        ],
        "72": [
            0,
            0.68333,
            0.08125,
            0.05556,
            0.83125
        ],
        "73": [
            0,
            0.68333,
            0.07847,
            0.11111,
            0.43958
        ],
        "74": [
            0,
            0.68333,
            0.09618,
            0.16667,
            0.55451
        ],
        "75": [
            0,
            0.68333,
            0.07153,
            0.05556,
            0.84931
        ],
        "76": [
            0,
            0.68333,
            0,
            0.02778,
            0.68056
        ],
        "77": [
            0,
            0.68333,
            0.10903,
            0.08334,
            0.97014
        ],
        "78": [
            0,
            0.68333,
            0.10903,
            0.08334,
            0.80347
        ],
        "79": [
            0,
            0.68333,
            0.02778,
            0.08334,
            0.76278
        ],
        "80": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.64201
        ],
        "81": [
            0.19444,
            0.68333,
            0,
            0.08334,
            0.79056
        ],
        "82": [
            0,
            0.68333,
            0.00773,
            0.08334,
            0.75929
        ],
        "83": [
            0,
            0.68333,
            0.05764,
            0.08334,
            0.6132
        ],
        "84": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.58438
        ],
        "85": [
            0,
            0.68333,
            0.10903,
            0.02778,
            0.68278
        ],
        "86": [
            0,
            0.68333,
            0.22222,
            0,
            0.58333
        ],
        "87": [
            0,
            0.68333,
            0.13889,
            0,
            0.94445
        ],
        "88": [
            0,
            0.68333,
            0.07847,
            0.08334,
            0.82847
        ],
        "89": [
            0,
            0.68333,
            0.22222,
            0,
            0.58056
        ],
        "90": [
            0,
            0.68333,
            0.07153,
            0.08334,
            0.68264
        ],
        "97": [
            0,
            0.43056,
            0,
            0,
            0.52859
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.42917
        ],
        "99": [
            0,
            0.43056,
            0,
            0.05556,
            0.43276
        ],
        "100": [
            0,
            0.69444,
            0,
            0.16667,
            0.52049
        ],
        "101": [
            0,
            0.43056,
            0,
            0.05556,
            0.46563
        ],
        "102": [
            0.19444,
            0.69444,
            0.10764,
            0.16667,
            0.48959
        ],
        "103": [
            0.19444,
            0.43056,
            0.03588,
            0.02778,
            0.47697
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.57616
        ],
        "105": [
            0,
            0.65952,
            0,
            0,
            0.34451
        ],
        "106": [
            0.19444,
            0.65952,
            0.05724,
            0,
            0.41181
        ],
        "107": [
            0,
            0.69444,
            0.03148,
            0,
            0.5206
        ],
        "108": [
            0,
            0.69444,
            0.01968,
            0.08334,
            0.29838
        ],
        "109": [
            0,
            0.43056,
            0,
            0,
            0.87801
        ],
        "110": [
            0,
            0.43056,
            0,
            0,
            0.60023
        ],
        "111": [
            0,
            0.43056,
            0,
            0.05556,
            0.48472
        ],
        "112": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.50313
        ],
        "113": [
            0.19444,
            0.43056,
            0.03588,
            0.08334,
            0.44641
        ],
        "114": [
            0,
            0.43056,
            0.02778,
            0.05556,
            0.45116
        ],
        "115": [
            0,
            0.43056,
            0,
            0.05556,
            0.46875
        ],
        "116": [
            0,
            0.61508,
            0,
            0.08334,
            0.36111
        ],
        "117": [
            0,
            0.43056,
            0,
            0.02778,
            0.57246
        ],
        "118": [
            0,
            0.43056,
            0.03588,
            0.02778,
            0.48472
        ],
        "119": [
            0,
            0.43056,
            0.02691,
            0.08334,
            0.71592
        ],
        "120": [
            0,
            0.43056,
            0,
            0.02778,
            0.57153
        ],
        "121": [
            0.19444,
            0.43056,
            0.03588,
            0.05556,
            0.49028
        ],
        "122": [
            0,
            0.43056,
            0.04398,
            0.05556,
            0.46505
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "915": [
            0,
            0.68333,
            0.13889,
            0.08334,
            0.61528
        ],
        "916": [
            0,
            0.68333,
            0,
            0.16667,
            0.83334
        ],
        "920": [
            0,
            0.68333,
            0.02778,
            0.08334,
            0.76278
        ],
        "923": [
            0,
            0.68333,
            0,
            0.16667,
            0.69445
        ],
        "926": [
            0,
            0.68333,
            0.07569,
            0.08334,
            0.74236
        ],
        "928": [
            0,
            0.68333,
            0.08125,
            0.05556,
            0.83125
        ],
        "931": [
            0,
            0.68333,
            0.05764,
            0.08334,
            0.77986
        ],
        "933": [
            0,
            0.68333,
            0.13889,
            0.05556,
            0.58333
        ],
        "934": [
            0,
            0.68333,
            0,
            0.08334,
            0.66667
        ],
        "936": [
            0,
            0.68333,
            0.11,
            0.05556,
            0.61222
        ],
        "937": [
            0,
            0.68333,
            0.05017,
            0.08334,
            0.7724
        ],
        "945": [
            0,
            0.43056,
            0.0037,
            0.02778,
            0.6397
        ],
        "946": [
            0.19444,
            0.69444,
            0.05278,
            0.08334,
            0.56563
        ],
        "947": [
            0.19444,
            0.43056,
            0.05556,
            0,
            0.51773
        ],
        "948": [
            0,
            0.69444,
            0.03785,
            0.05556,
            0.44444
        ],
        "949": [
            0,
            0.43056,
            0,
            0.08334,
            0.46632
        ],
        "950": [
            0.19444,
            0.69444,
            0.07378,
            0.08334,
            0.4375
        ],
        "951": [
            0.19444,
            0.43056,
            0.03588,
            0.05556,
            0.49653
        ],
        "952": [
            0,
            0.69444,
            0.02778,
            0.08334,
            0.46944
        ],
        "953": [
            0,
            0.43056,
            0,
            0.05556,
            0.35394
        ],
        "954": [
            0,
            0.43056,
            0,
            0,
            0.57616
        ],
        "955": [
            0,
            0.69444,
            0,
            0,
            0.58334
        ],
        "956": [
            0.19444,
            0.43056,
            0,
            0.02778,
            0.60255
        ],
        "957": [
            0,
            0.43056,
            0.06366,
            0.02778,
            0.49398
        ],
        "958": [
            0.19444,
            0.69444,
            0.04601,
            0.11111,
            0.4375
        ],
        "959": [
            0,
            0.43056,
            0,
            0.05556,
            0.48472
        ],
        "960": [
            0,
            0.43056,
            0.03588,
            0,
            0.57003
        ],
        "961": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.51702
        ],
        "962": [
            0.09722,
            0.43056,
            0.07986,
            0.08334,
            0.36285
        ],
        "963": [
            0,
            0.43056,
            0.03588,
            0,
            0.57141
        ],
        "964": [
            0,
            0.43056,
            0.1132,
            0.02778,
            0.43715
        ],
        "965": [
            0,
            0.43056,
            0.03588,
            0.02778,
            0.54028
        ],
        "966": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.65417
        ],
        "967": [
            0.19444,
            0.43056,
            0,
            0.05556,
            0.62569
        ],
        "968": [
            0.19444,
            0.69444,
            0.03588,
            0.11111,
            0.65139
        ],
        "969": [
            0,
            0.43056,
            0.03588,
            0,
            0.62245
        ],
        "977": [
            0,
            0.69444,
            0,
            0.08334,
            0.59144
        ],
        "981": [
            0.19444,
            0.69444,
            0,
            0.08334,
            0.59583
        ],
        "982": [
            0,
            0.43056,
            0.02778,
            0,
            0.82813
        ],
        "1009": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.51702
        ],
        "1013": [
            0,
            0.43056,
            0,
            0.05556,
            0.4059
        ],
        "57649": [
            0,
            0.43056,
            0,
            0.02778,
            0.32246
        ],
        "57911": [
            0.19444,
            0.43056,
            0,
            0.08334,
            0.38403
        ]
    },
    "SansSerif-Bold": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.36667
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.55834
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.91667
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.55
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            1.02912
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.83056
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.42778
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.42778
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.55
        ],
        "43": [
            0.11667,
            0.61667,
            0,
            0,
            0.85556
        ],
        "44": [
            0.10556,
            0.13056,
            0,
            0,
            0.30556
        ],
        "45": [
            0,
            0.45833,
            0,
            0,
            0.36667
        ],
        "46": [
            0,
            0.13056,
            0,
            0,
            0.30556
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.55
        ],
        "48": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "49": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "50": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "51": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "52": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "53": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "54": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "55": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "56": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "57": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "58": [
            0,
            0.45833,
            0,
            0,
            0.30556
        ],
        "59": [
            0.10556,
            0.45833,
            0,
            0,
            0.30556
        ],
        "61": [
            -0.09375,
            0.40625,
            0,
            0,
            0.85556
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.51945
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "65": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "66": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "67": [
            0,
            0.69444,
            0,
            0,
            0.70278
        ],
        "68": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "69": [
            0,
            0.69444,
            0,
            0,
            0.64167
        ],
        "70": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "71": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "72": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "73": [
            0,
            0.69444,
            0,
            0,
            0.33056
        ],
        "74": [
            0,
            0.69444,
            0,
            0,
            0.51945
        ],
        "75": [
            0,
            0.69444,
            0,
            0,
            0.76389
        ],
        "76": [
            0,
            0.69444,
            0,
            0,
            0.58056
        ],
        "77": [
            0,
            0.69444,
            0,
            0,
            0.97778
        ],
        "78": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "79": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "80": [
            0,
            0.69444,
            0,
            0,
            0.70278
        ],
        "81": [
            0.10556,
            0.69444,
            0,
            0,
            0.79445
        ],
        "82": [
            0,
            0.69444,
            0,
            0,
            0.70278
        ],
        "83": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "84": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "85": [
            0,
            0.69444,
            0,
            0,
            0.76389
        ],
        "86": [
            0,
            0.69444,
            0.01528,
            0,
            0.73334
        ],
        "87": [
            0,
            0.69444,
            0.01528,
            0,
            1.03889
        ],
        "88": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "89": [
            0,
            0.69444,
            0.0275,
            0,
            0.73334
        ],
        "90": [
            0,
            0.69444,
            0,
            0,
            0.67223
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.34306
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.34306
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "95": [
            0.35,
            0.10833,
            0.03056,
            0,
            0.55
        ],
        "97": [
            0,
            0.45833,
            0,
            0,
            0.525
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.56111
        ],
        "99": [
            0,
            0.45833,
            0,
            0,
            0.48889
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.56111
        ],
        "101": [
            0,
            0.45833,
            0,
            0,
            0.51111
        ],
        "102": [
            0,
            0.69444,
            0.07639,
            0,
            0.33611
        ],
        "103": [
            0.19444,
            0.45833,
            0.01528,
            0,
            0.55
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.56111
        ],
        "105": [
            0,
            0.69444,
            0,
            0,
            0.25556
        ],
        "106": [
            0.19444,
            0.69444,
            0,
            0,
            0.28611
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.53056
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.25556
        ],
        "109": [
            0,
            0.45833,
            0,
            0,
            0.86667
        ],
        "110": [
            0,
            0.45833,
            0,
            0,
            0.56111
        ],
        "111": [
            0,
            0.45833,
            0,
            0,
            0.55
        ],
        "112": [
            0.19444,
            0.45833,
            0,
            0,
            0.56111
        ],
        "113": [
            0.19444,
            0.45833,
            0,
            0,
            0.56111
        ],
        "114": [
            0,
            0.45833,
            0.01528,
            0,
            0.37222
        ],
        "115": [
            0,
            0.45833,
            0,
            0,
            0.42167
        ],
        "116": [
            0,
            0.58929,
            0,
            0,
            0.40417
        ],
        "117": [
            0,
            0.45833,
            0,
            0,
            0.56111
        ],
        "118": [
            0,
            0.45833,
            0.01528,
            0,
            0.5
        ],
        "119": [
            0,
            0.45833,
            0.01528,
            0,
            0.74445
        ],
        "120": [
            0,
            0.45833,
            0,
            0,
            0.5
        ],
        "121": [
            0.19444,
            0.45833,
            0.01528,
            0,
            0.5
        ],
        "122": [
            0,
            0.45833,
            0,
            0,
            0.47639
        ],
        "126": [
            0.35,
            0.34444,
            0,
            0,
            0.55
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "180": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.48889
        ],
        "305": [
            0,
            0.45833,
            0,
            0,
            0.25556
        ],
        "567": [
            0.19444,
            0.45833,
            0,
            0,
            0.28611
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "711": [
            0,
            0.63542,
            0,
            0,
            0.55
        ],
        "713": [
            0,
            0.63778,
            0,
            0,
            0.55
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "729": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "732": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.55
        ],
        "915": [
            0,
            0.69444,
            0,
            0,
            0.58056
        ],
        "916": [
            0,
            0.69444,
            0,
            0,
            0.91667
        ],
        "920": [
            0,
            0.69444,
            0,
            0,
            0.85556
        ],
        "923": [
            0,
            0.69444,
            0,
            0,
            0.67223
        ],
        "926": [
            0,
            0.69444,
            0,
            0,
            0.73334
        ],
        "928": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "931": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "933": [
            0,
            0.69444,
            0,
            0,
            0.85556
        ],
        "934": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "936": [
            0,
            0.69444,
            0,
            0,
            0.85556
        ],
        "937": [
            0,
            0.69444,
            0,
            0,
            0.79445
        ],
        "8211": [
            0,
            0.45833,
            0.03056,
            0,
            0.55
        ],
        "8212": [
            0,
            0.45833,
            0.03056,
            0,
            1.10001
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.30556
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.55834
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.55834
        ]
    },
    "SansSerif-Italic": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0.05733,
            0,
            0.31945
        ],
        "34": [
            0,
            0.69444,
            0.00316,
            0,
            0.5
        ],
        "35": [
            0.19444,
            0.69444,
            0.05087,
            0,
            0.83334
        ],
        "36": [
            0.05556,
            0.75,
            0.11156,
            0,
            0.5
        ],
        "37": [
            0.05556,
            0.75,
            0.03126,
            0,
            0.83334
        ],
        "38": [
            0,
            0.69444,
            0.03058,
            0,
            0.75834
        ],
        "39": [
            0,
            0.69444,
            0.07816,
            0,
            0.27778
        ],
        "40": [
            0.25,
            0.75,
            0.13164,
            0,
            0.38889
        ],
        "41": [
            0.25,
            0.75,
            0.02536,
            0,
            0.38889
        ],
        "42": [
            0,
            0.75,
            0.11775,
            0,
            0.5
        ],
        "43": [
            0.08333,
            0.58333,
            0.02536,
            0,
            0.77778
        ],
        "44": [
            0.125,
            0.08333,
            0,
            0,
            0.27778
        ],
        "45": [
            0,
            0.44444,
            0.01946,
            0,
            0.33333
        ],
        "46": [
            0,
            0.08333,
            0,
            0,
            0.27778
        ],
        "47": [
            0.25,
            0.75,
            0.13164,
            0,
            0.5
        ],
        "48": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "49": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "50": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "51": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "52": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "53": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "54": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "55": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "56": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "57": [
            0,
            0.65556,
            0.11156,
            0,
            0.5
        ],
        "58": [
            0,
            0.44444,
            0.02502,
            0,
            0.27778
        ],
        "59": [
            0.125,
            0.44444,
            0.02502,
            0,
            0.27778
        ],
        "61": [
            -0.13,
            0.37,
            0.05087,
            0,
            0.77778
        ],
        "63": [
            0,
            0.69444,
            0.11809,
            0,
            0.47222
        ],
        "64": [
            0,
            0.69444,
            0.07555,
            0,
            0.66667
        ],
        "65": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "66": [
            0,
            0.69444,
            0.08293,
            0,
            0.66667
        ],
        "67": [
            0,
            0.69444,
            0.11983,
            0,
            0.63889
        ],
        "68": [
            0,
            0.69444,
            0.07555,
            0,
            0.72223
        ],
        "69": [
            0,
            0.69444,
            0.11983,
            0,
            0.59722
        ],
        "70": [
            0,
            0.69444,
            0.13372,
            0,
            0.56945
        ],
        "71": [
            0,
            0.69444,
            0.11983,
            0,
            0.66667
        ],
        "72": [
            0,
            0.69444,
            0.08094,
            0,
            0.70834
        ],
        "73": [
            0,
            0.69444,
            0.13372,
            0,
            0.27778
        ],
        "74": [
            0,
            0.69444,
            0.08094,
            0,
            0.47222
        ],
        "75": [
            0,
            0.69444,
            0.11983,
            0,
            0.69445
        ],
        "76": [
            0,
            0.69444,
            0,
            0,
            0.54167
        ],
        "77": [
            0,
            0.69444,
            0.08094,
            0,
            0.875
        ],
        "78": [
            0,
            0.69444,
            0.08094,
            0,
            0.70834
        ],
        "79": [
            0,
            0.69444,
            0.07555,
            0,
            0.73611
        ],
        "80": [
            0,
            0.69444,
            0.08293,
            0,
            0.63889
        ],
        "81": [
            0.125,
            0.69444,
            0.07555,
            0,
            0.73611
        ],
        "82": [
            0,
            0.69444,
            0.08293,
            0,
            0.64584
        ],
        "83": [
            0,
            0.69444,
            0.09205,
            0,
            0.55556
        ],
        "84": [
            0,
            0.69444,
            0.13372,
            0,
            0.68056
        ],
        "85": [
            0,
            0.69444,
            0.08094,
            0,
            0.6875
        ],
        "86": [
            0,
            0.69444,
            0.1615,
            0,
            0.66667
        ],
        "87": [
            0,
            0.69444,
            0.1615,
            0,
            0.94445
        ],
        "88": [
            0,
            0.69444,
            0.13372,
            0,
            0.66667
        ],
        "89": [
            0,
            0.69444,
            0.17261,
            0,
            0.66667
        ],
        "90": [
            0,
            0.69444,
            0.11983,
            0,
            0.61111
        ],
        "91": [
            0.25,
            0.75,
            0.15942,
            0,
            0.28889
        ],
        "93": [
            0.25,
            0.75,
            0.08719,
            0,
            0.28889
        ],
        "94": [
            0,
            0.69444,
            0.0799,
            0,
            0.5
        ],
        "95": [
            0.35,
            0.09444,
            0.08616,
            0,
            0.5
        ],
        "97": [
            0,
            0.44444,
            0.00981,
            0,
            0.48056
        ],
        "98": [
            0,
            0.69444,
            0.03057,
            0,
            0.51667
        ],
        "99": [
            0,
            0.44444,
            0.08336,
            0,
            0.44445
        ],
        "100": [
            0,
            0.69444,
            0.09483,
            0,
            0.51667
        ],
        "101": [
            0,
            0.44444,
            0.06778,
            0,
            0.44445
        ],
        "102": [
            0,
            0.69444,
            0.21705,
            0,
            0.30556
        ],
        "103": [
            0.19444,
            0.44444,
            0.10836,
            0,
            0.5
        ],
        "104": [
            0,
            0.69444,
            0.01778,
            0,
            0.51667
        ],
        "105": [
            0,
            0.67937,
            0.09718,
            0,
            0.23889
        ],
        "106": [
            0.19444,
            0.67937,
            0.09162,
            0,
            0.26667
        ],
        "107": [
            0,
            0.69444,
            0.08336,
            0,
            0.48889
        ],
        "108": [
            0,
            0.69444,
            0.09483,
            0,
            0.23889
        ],
        "109": [
            0,
            0.44444,
            0.01778,
            0,
            0.79445
        ],
        "110": [
            0,
            0.44444,
            0.01778,
            0,
            0.51667
        ],
        "111": [
            0,
            0.44444,
            0.06613,
            0,
            0.5
        ],
        "112": [
            0.19444,
            0.44444,
            0.0389,
            0,
            0.51667
        ],
        "113": [
            0.19444,
            0.44444,
            0.04169,
            0,
            0.51667
        ],
        "114": [
            0,
            0.44444,
            0.10836,
            0,
            0.34167
        ],
        "115": [
            0,
            0.44444,
            0.0778,
            0,
            0.38333
        ],
        "116": [
            0,
            0.57143,
            0.07225,
            0,
            0.36111
        ],
        "117": [
            0,
            0.44444,
            0.04169,
            0,
            0.51667
        ],
        "118": [
            0,
            0.44444,
            0.10836,
            0,
            0.46111
        ],
        "119": [
            0,
            0.44444,
            0.10836,
            0,
            0.68334
        ],
        "120": [
            0,
            0.44444,
            0.09169,
            0,
            0.46111
        ],
        "121": [
            0.19444,
            0.44444,
            0.10836,
            0,
            0.46111
        ],
        "122": [
            0,
            0.44444,
            0.08752,
            0,
            0.43472
        ],
        "126": [
            0.35,
            0.32659,
            0.08826,
            0,
            0.5
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.67937,
            0.06385,
            0,
            0.5
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.73752
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.44445
        ],
        "305": [
            0,
            0.44444,
            0.04169,
            0,
            0.23889
        ],
        "567": [
            0.19444,
            0.44444,
            0.04169,
            0,
            0.26667
        ],
        "710": [
            0,
            0.69444,
            0.0799,
            0,
            0.5
        ],
        "711": [
            0,
            0.63194,
            0.08432,
            0,
            0.5
        ],
        "713": [
            0,
            0.60889,
            0.08776,
            0,
            0.5
        ],
        "714": [
            0,
            0.69444,
            0.09205,
            0,
            0.5
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "728": [
            0,
            0.69444,
            0.09483,
            0,
            0.5
        ],
        "729": [
            0,
            0.67937,
            0.07774,
            0,
            0.27778
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.73752
        ],
        "732": [
            0,
            0.67659,
            0.08826,
            0,
            0.5
        ],
        "733": [
            0,
            0.69444,
            0.09205,
            0,
            0.5
        ],
        "915": [
            0,
            0.69444,
            0.13372,
            0,
            0.54167
        ],
        "916": [
            0,
            0.69444,
            0,
            0,
            0.83334
        ],
        "920": [
            0,
            0.69444,
            0.07555,
            0,
            0.77778
        ],
        "923": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "926": [
            0,
            0.69444,
            0.12816,
            0,
            0.66667
        ],
        "928": [
            0,
            0.69444,
            0.08094,
            0,
            0.70834
        ],
        "931": [
            0,
            0.69444,
            0.11983,
            0,
            0.72222
        ],
        "933": [
            0,
            0.69444,
            0.09031,
            0,
            0.77778
        ],
        "934": [
            0,
            0.69444,
            0.04603,
            0,
            0.72222
        ],
        "936": [
            0,
            0.69444,
            0.09031,
            0,
            0.77778
        ],
        "937": [
            0,
            0.69444,
            0.08293,
            0,
            0.72222
        ],
        "8211": [
            0,
            0.44444,
            0.08616,
            0,
            0.5
        ],
        "8212": [
            0,
            0.44444,
            0.08616,
            0,
            1.0
        ],
        "8216": [
            0,
            0.69444,
            0.07816,
            0,
            0.27778
        ],
        "8217": [
            0,
            0.69444,
            0.07816,
            0,
            0.27778
        ],
        "8220": [
            0,
            0.69444,
            0.14205,
            0,
            0.5
        ],
        "8221": [
            0,
            0.69444,
            0.00316,
            0,
            0.5
        ]
    },
    "SansSerif-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "33": [
            0,
            0.69444,
            0,
            0,
            0.31945
        ],
        "34": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "35": [
            0.19444,
            0.69444,
            0,
            0,
            0.83334
        ],
        "36": [
            0.05556,
            0.75,
            0,
            0,
            0.5
        ],
        "37": [
            0.05556,
            0.75,
            0,
            0,
            0.83334
        ],
        "38": [
            0,
            0.69444,
            0,
            0,
            0.75834
        ],
        "39": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "40": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "41": [
            0.25,
            0.75,
            0,
            0,
            0.38889
        ],
        "42": [
            0,
            0.75,
            0,
            0,
            0.5
        ],
        "43": [
            0.08333,
            0.58333,
            0,
            0,
            0.77778
        ],
        "44": [
            0.125,
            0.08333,
            0,
            0,
            0.27778
        ],
        "45": [
            0,
            0.44444,
            0,
            0,
            0.33333
        ],
        "46": [
            0,
            0.08333,
            0,
            0,
            0.27778
        ],
        "47": [
            0.25,
            0.75,
            0,
            0,
            0.5
        ],
        "48": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "49": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "50": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "51": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "52": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "53": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "54": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "55": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "56": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "57": [
            0,
            0.65556,
            0,
            0,
            0.5
        ],
        "58": [
            0,
            0.44444,
            0,
            0,
            0.27778
        ],
        "59": [
            0.125,
            0.44444,
            0,
            0,
            0.27778
        ],
        "61": [
            -0.13,
            0.37,
            0,
            0,
            0.77778
        ],
        "63": [
            0,
            0.69444,
            0,
            0,
            0.47222
        ],
        "64": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "65": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "66": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "67": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "68": [
            0,
            0.69444,
            0,
            0,
            0.72223
        ],
        "69": [
            0,
            0.69444,
            0,
            0,
            0.59722
        ],
        "70": [
            0,
            0.69444,
            0,
            0,
            0.56945
        ],
        "71": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "72": [
            0,
            0.69444,
            0,
            0,
            0.70834
        ],
        "73": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "74": [
            0,
            0.69444,
            0,
            0,
            0.47222
        ],
        "75": [
            0,
            0.69444,
            0,
            0,
            0.69445
        ],
        "76": [
            0,
            0.69444,
            0,
            0,
            0.54167
        ],
        "77": [
            0,
            0.69444,
            0,
            0,
            0.875
        ],
        "78": [
            0,
            0.69444,
            0,
            0,
            0.70834
        ],
        "79": [
            0,
            0.69444,
            0,
            0,
            0.73611
        ],
        "80": [
            0,
            0.69444,
            0,
            0,
            0.63889
        ],
        "81": [
            0.125,
            0.69444,
            0,
            0,
            0.73611
        ],
        "82": [
            0,
            0.69444,
            0,
            0,
            0.64584
        ],
        "83": [
            0,
            0.69444,
            0,
            0,
            0.55556
        ],
        "84": [
            0,
            0.69444,
            0,
            0,
            0.68056
        ],
        "85": [
            0,
            0.69444,
            0,
            0,
            0.6875
        ],
        "86": [
            0,
            0.69444,
            0.01389,
            0,
            0.66667
        ],
        "87": [
            0,
            0.69444,
            0.01389,
            0,
            0.94445
        ],
        "88": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "89": [
            0,
            0.69444,
            0.025,
            0,
            0.66667
        ],
        "90": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "91": [
            0.25,
            0.75,
            0,
            0,
            0.28889
        ],
        "93": [
            0.25,
            0.75,
            0,
            0,
            0.28889
        ],
        "94": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "95": [
            0.35,
            0.09444,
            0.02778,
            0,
            0.5
        ],
        "97": [
            0,
            0.44444,
            0,
            0,
            0.48056
        ],
        "98": [
            0,
            0.69444,
            0,
            0,
            0.51667
        ],
        "99": [
            0,
            0.44444,
            0,
            0,
            0.44445
        ],
        "100": [
            0,
            0.69444,
            0,
            0,
            0.51667
        ],
        "101": [
            0,
            0.44444,
            0,
            0,
            0.44445
        ],
        "102": [
            0,
            0.69444,
            0.06944,
            0,
            0.30556
        ],
        "103": [
            0.19444,
            0.44444,
            0.01389,
            0,
            0.5
        ],
        "104": [
            0,
            0.69444,
            0,
            0,
            0.51667
        ],
        "105": [
            0,
            0.67937,
            0,
            0,
            0.23889
        ],
        "106": [
            0.19444,
            0.67937,
            0,
            0,
            0.26667
        ],
        "107": [
            0,
            0.69444,
            0,
            0,
            0.48889
        ],
        "108": [
            0,
            0.69444,
            0,
            0,
            0.23889
        ],
        "109": [
            0,
            0.44444,
            0,
            0,
            0.79445
        ],
        "110": [
            0,
            0.44444,
            0,
            0,
            0.51667
        ],
        "111": [
            0,
            0.44444,
            0,
            0,
            0.5
        ],
        "112": [
            0.19444,
            0.44444,
            0,
            0,
            0.51667
        ],
        "113": [
            0.19444,
            0.44444,
            0,
            0,
            0.51667
        ],
        "114": [
            0,
            0.44444,
            0.01389,
            0,
            0.34167
        ],
        "115": [
            0,
            0.44444,
            0,
            0,
            0.38333
        ],
        "116": [
            0,
            0.57143,
            0,
            0,
            0.36111
        ],
        "117": [
            0,
            0.44444,
            0,
            0,
            0.51667
        ],
        "118": [
            0,
            0.44444,
            0.01389,
            0,
            0.46111
        ],
        "119": [
            0,
            0.44444,
            0.01389,
            0,
            0.68334
        ],
        "120": [
            0,
            0.44444,
            0,
            0,
            0.46111
        ],
        "121": [
            0.19444,
            0.44444,
            0.01389,
            0,
            0.46111
        ],
        "122": [
            0,
            0.44444,
            0,
            0,
            0.43472
        ],
        "126": [
            0.35,
            0.32659,
            0,
            0,
            0.5
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "168": [
            0,
            0.67937,
            0,
            0,
            0.5
        ],
        "176": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "184": [
            0.17014,
            0,
            0,
            0,
            0.44445
        ],
        "305": [
            0,
            0.44444,
            0,
            0,
            0.23889
        ],
        "567": [
            0.19444,
            0.44444,
            0,
            0,
            0.26667
        ],
        "710": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "711": [
            0,
            0.63194,
            0,
            0,
            0.5
        ],
        "713": [
            0,
            0.60889,
            0,
            0,
            0.5
        ],
        "714": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "715": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "728": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "729": [
            0,
            0.67937,
            0,
            0,
            0.27778
        ],
        "730": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "732": [
            0,
            0.67659,
            0,
            0,
            0.5
        ],
        "733": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "915": [
            0,
            0.69444,
            0,
            0,
            0.54167
        ],
        "916": [
            0,
            0.69444,
            0,
            0,
            0.83334
        ],
        "920": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "923": [
            0,
            0.69444,
            0,
            0,
            0.61111
        ],
        "926": [
            0,
            0.69444,
            0,
            0,
            0.66667
        ],
        "928": [
            0,
            0.69444,
            0,
            0,
            0.70834
        ],
        "931": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "933": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "934": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "936": [
            0,
            0.69444,
            0,
            0,
            0.77778
        ],
        "937": [
            0,
            0.69444,
            0,
            0,
            0.72222
        ],
        "8211": [
            0,
            0.44444,
            0.02778,
            0,
            0.5
        ],
        "8212": [
            0,
            0.44444,
            0.02778,
            0,
            1.0
        ],
        "8216": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8217": [
            0,
            0.69444,
            0,
            0,
            0.27778
        ],
        "8220": [
            0,
            0.69444,
            0,
            0,
            0.5
        ],
        "8221": [
            0,
            0.69444,
            0,
            0,
            0.5
        ]
    },
    "Script-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "65": [
            0,
            0.7,
            0.22925,
            0,
            0.80253
        ],
        "66": [
            0,
            0.7,
            0.04087,
            0,
            0.90757
        ],
        "67": [
            0,
            0.7,
            0.1689,
            0,
            0.66619
        ],
        "68": [
            0,
            0.7,
            0.09371,
            0,
            0.77443
        ],
        "69": [
            0,
            0.7,
            0.18583,
            0,
            0.56162
        ],
        "70": [
            0,
            0.7,
            0.13634,
            0,
            0.89544
        ],
        "71": [
            0,
            0.7,
            0.17322,
            0,
            0.60961
        ],
        "72": [
            0,
            0.7,
            0.29694,
            0,
            0.96919
        ],
        "73": [
            0,
            0.7,
            0.19189,
            0,
            0.80907
        ],
        "74": [
            0.27778,
            0.7,
            0.19189,
            0,
            1.05159
        ],
        "75": [
            0,
            0.7,
            0.31259,
            0,
            0.91364
        ],
        "76": [
            0,
            0.7,
            0.19189,
            0,
            0.87373
        ],
        "77": [
            0,
            0.7,
            0.15981,
            0,
            1.08031
        ],
        "78": [
            0,
            0.7,
            0.3525,
            0,
            0.9015
        ],
        "79": [
            0,
            0.7,
            0.08078,
            0,
            0.73787
        ],
        "80": [
            0,
            0.7,
            0.08078,
            0,
            1.01262
        ],
        "81": [
            0,
            0.7,
            0.03305,
            0,
            0.88282
        ],
        "82": [
            0,
            0.7,
            0.06259,
            0,
            0.85
        ],
        "83": [
            0,
            0.7,
            0.19189,
            0,
            0.86767
        ],
        "84": [
            0,
            0.7,
            0.29087,
            0,
            0.74697
        ],
        "85": [
            0,
            0.7,
            0.25815,
            0,
            0.79996
        ],
        "86": [
            0,
            0.7,
            0.27523,
            0,
            0.62204
        ],
        "87": [
            0,
            0.7,
            0.27523,
            0,
            0.80532
        ],
        "88": [
            0,
            0.7,
            0.26006,
            0,
            0.94445
        ],
        "89": [
            0,
            0.7,
            0.2939,
            0,
            0.70961
        ],
        "90": [
            0,
            0.7,
            0.24037,
            0,
            0.8212
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ]
    },
    "Size1-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            0.35001,
            0.85,
            0,
            0,
            0.45834
        ],
        "41": [
            0.35001,
            0.85,
            0,
            0,
            0.45834
        ],
        "47": [
            0.35001,
            0.85,
            0,
            0,
            0.57778
        ],
        "91": [
            0.35001,
            0.85,
            0,
            0,
            0.41667
        ],
        "92": [
            0.35001,
            0.85,
            0,
            0,
            0.57778
        ],
        "93": [
            0.35001,
            0.85,
            0,
            0,
            0.41667
        ],
        "123": [
            0.35001,
            0.85,
            0,
            0,
            0.58334
        ],
        "125": [
            0.35001,
            0.85,
            0,
            0,
            0.58334
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "732": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "770": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "771": [
            0,
            0.72222,
            0,
            0,
            0.55556
        ],
        "8214": [
            -0.00099,
            0.601,
            0,
            0,
            0.77778
        ],
        "8593": [
            1e-05,
            0.6,
            0,
            0,
            0.66667
        ],
        "8595": [
            1e-05,
            0.6,
            0,
            0,
            0.66667
        ],
        "8657": [
            1e-05,
            0.6,
            0,
            0,
            0.77778
        ],
        "8659": [
            1e-05,
            0.6,
            0,
            0,
            0.77778
        ],
        "8719": [
            0.25001,
            0.75,
            0,
            0,
            0.94445
        ],
        "8720": [
            0.25001,
            0.75,
            0,
            0,
            0.94445
        ],
        "8721": [
            0.25001,
            0.75,
            0,
            0,
            1.05556
        ],
        "8730": [
            0.35001,
            0.85,
            0,
            0,
            1.0
        ],
        "8739": [
            -0.00599,
            0.606,
            0,
            0,
            0.33333
        ],
        "8741": [
            -0.00599,
            0.606,
            0,
            0,
            0.55556
        ],
        "8747": [
            0.30612,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8748": [
            0.306,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8749": [
            0.306,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8750": [
            0.30612,
            0.805,
            0.19445,
            0,
            0.47222
        ],
        "8896": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8897": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8898": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8899": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "8968": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "8969": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "8970": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "8971": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "9168": [
            -0.00099,
            0.601,
            0,
            0,
            0.66667
        ],
        "10216": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "10217": [
            0.35001,
            0.85,
            0,
            0,
            0.47222
        ],
        "10752": [
            0.25001,
            0.75,
            0,
            0,
            1.11111
        ],
        "10753": [
            0.25001,
            0.75,
            0,
            0,
            1.11111
        ],
        "10754": [
            0.25001,
            0.75,
            0,
            0,
            1.11111
        ],
        "10756": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ],
        "10758": [
            0.25001,
            0.75,
            0,
            0,
            0.83334
        ]
    },
    "Size2-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            0.65002,
            1.15,
            0,
            0,
            0.59722
        ],
        "41": [
            0.65002,
            1.15,
            0,
            0,
            0.59722
        ],
        "47": [
            0.65002,
            1.15,
            0,
            0,
            0.81111
        ],
        "91": [
            0.65002,
            1.15,
            0,
            0,
            0.47222
        ],
        "92": [
            0.65002,
            1.15,
            0,
            0,
            0.81111
        ],
        "93": [
            0.65002,
            1.15,
            0,
            0,
            0.47222
        ],
        "123": [
            0.65002,
            1.15,
            0,
            0,
            0.66667
        ],
        "125": [
            0.65002,
            1.15,
            0,
            0,
            0.66667
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "732": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "770": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "771": [
            0,
            0.75,
            0,
            0,
            1.0
        ],
        "8719": [
            0.55001,
            1.05,
            0,
            0,
            1.27778
        ],
        "8720": [
            0.55001,
            1.05,
            0,
            0,
            1.27778
        ],
        "8721": [
            0.55001,
            1.05,
            0,
            0,
            1.44445
        ],
        "8730": [
            0.65002,
            1.15,
            0,
            0,
            1.0
        ],
        "8747": [
            0.86225,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8748": [
            0.862,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8749": [
            0.862,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8750": [
            0.86225,
            1.36,
            0.44445,
            0,
            0.55556
        ],
        "8896": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8897": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8898": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8899": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "8968": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "8969": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "8970": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "8971": [
            0.65002,
            1.15,
            0,
            0,
            0.52778
        ],
        "10216": [
            0.65002,
            1.15,
            0,
            0,
            0.61111
        ],
        "10217": [
            0.65002,
            1.15,
            0,
            0,
            0.61111
        ],
        "10752": [
            0.55001,
            1.05,
            0,
            0,
            1.51112
        ],
        "10753": [
            0.55001,
            1.05,
            0,
            0,
            1.51112
        ],
        "10754": [
            0.55001,
            1.05,
            0,
            0,
            1.51112
        ],
        "10756": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ],
        "10758": [
            0.55001,
            1.05,
            0,
            0,
            1.11111
        ]
    },
    "Size3-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            0.95003,
            1.45,
            0,
            0,
            0.73611
        ],
        "41": [
            0.95003,
            1.45,
            0,
            0,
            0.73611
        ],
        "47": [
            0.95003,
            1.45,
            0,
            0,
            1.04445
        ],
        "91": [
            0.95003,
            1.45,
            0,
            0,
            0.52778
        ],
        "92": [
            0.95003,
            1.45,
            0,
            0,
            1.04445
        ],
        "93": [
            0.95003,
            1.45,
            0,
            0,
            0.52778
        ],
        "123": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ],
        "125": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "732": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "770": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "771": [
            0,
            0.75,
            0,
            0,
            1.44445
        ],
        "8730": [
            0.95003,
            1.45,
            0,
            0,
            1.0
        ],
        "8968": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "8969": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "8970": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "8971": [
            0.95003,
            1.45,
            0,
            0,
            0.58334
        ],
        "10216": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ],
        "10217": [
            0.95003,
            1.45,
            0,
            0,
            0.75
        ]
    },
    "Size4-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "40": [
            1.25003,
            1.75,
            0,
            0,
            0.79167
        ],
        "41": [
            1.25003,
            1.75,
            0,
            0,
            0.79167
        ],
        "47": [
            1.25003,
            1.75,
            0,
            0,
            1.27778
        ],
        "91": [
            1.25003,
            1.75,
            0,
            0,
            0.58334
        ],
        "92": [
            1.25003,
            1.75,
            0,
            0,
            1.27778
        ],
        "93": [
            1.25003,
            1.75,
            0,
            0,
            0.58334
        ],
        "123": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "125": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.25
        ],
        "710": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "732": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "770": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "771": [
            0,
            0.825,
            0,
            0,
            1.8889
        ],
        "8730": [
            1.25003,
            1.75,
            0,
            0,
            1.0
        ],
        "8968": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "8969": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "8970": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "8971": [
            1.25003,
            1.75,
            0,
            0,
            0.63889
        ],
        "9115": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9116": [
            1e-05,
            0.6,
            0,
            0,
            0.875
        ],
        "9117": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9118": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9119": [
            1e-05,
            0.6,
            0,
            0,
            0.875
        ],
        "9120": [
            0.64502,
            1.155,
            0,
            0,
            0.875
        ],
        "9121": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9122": [
            -0.00099,
            0.601,
            0,
            0,
            0.66667
        ],
        "9123": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9124": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9125": [
            -0.00099,
            0.601,
            0,
            0,
            0.66667
        ],
        "9126": [
            0.64502,
            1.155,
            0,
            0,
            0.66667
        ],
        "9127": [
            1e-05,
            0.9,
            0,
            0,
            0.88889
        ],
        "9128": [
            0.65002,
            1.15,
            0,
            0,
            0.88889
        ],
        "9129": [
            0.90001,
            0,
            0,
            0,
            0.88889
        ],
        "9130": [
            0,
            0.3,
            0,
            0,
            0.88889
        ],
        "9131": [
            1e-05,
            0.9,
            0,
            0,
            0.88889
        ],
        "9132": [
            0.65002,
            1.15,
            0,
            0,
            0.88889
        ],
        "9133": [
            0.90001,
            0,
            0,
            0,
            0.88889
        ],
        "9143": [
            0.88502,
            0.915,
            0,
            0,
            1.05556
        ],
        "10216": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "10217": [
            1.25003,
            1.75,
            0,
            0,
            0.80556
        ],
        "57344": [
            -0.00499,
            0.605,
            0,
            0,
            1.05556
        ],
        "57345": [
            -0.00499,
            0.605,
            0,
            0,
            1.05556
        ],
        "57680": [
            0,
            0.12,
            0,
            0,
            0.45
        ],
        "57681": [
            0,
            0.12,
            0,
            0,
            0.45
        ],
        "57682": [
            0,
            0.12,
            0,
            0,
            0.45
        ],
        "57683": [
            0,
            0.12,
            0,
            0,
            0.45
        ]
    },
    "Typewriter-Regular": {
        "32": [
            0,
            0,
            0,
            0,
            0.525
        ],
        "33": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "34": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "35": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "36": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "37": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "38": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "39": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "40": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "41": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "42": [
            0,
            0.52083,
            0,
            0,
            0.525
        ],
        "43": [
            -0.08056,
            0.53055,
            0,
            0,
            0.525
        ],
        "44": [
            0.13889,
            0.125,
            0,
            0,
            0.525
        ],
        "45": [
            -0.08056,
            0.53055,
            0,
            0,
            0.525
        ],
        "46": [
            0,
            0.125,
            0,
            0,
            0.525
        ],
        "47": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "48": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "49": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "50": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "51": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "52": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "53": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "54": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "55": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "56": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "57": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "58": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "59": [
            0.13889,
            0.43056,
            0,
            0,
            0.525
        ],
        "60": [
            -0.05556,
            0.55556,
            0,
            0,
            0.525
        ],
        "61": [
            -0.19549,
            0.41562,
            0,
            0,
            0.525
        ],
        "62": [
            -0.05556,
            0.55556,
            0,
            0,
            0.525
        ],
        "63": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "64": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "65": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "66": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "67": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "68": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "69": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "70": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "71": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "72": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "73": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "74": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "75": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "76": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "77": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "78": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "79": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "80": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "81": [
            0.13889,
            0.61111,
            0,
            0,
            0.525
        ],
        "82": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "83": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "84": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "85": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "86": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "87": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "88": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "89": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "90": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "91": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "92": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "93": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "94": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "95": [
            0.09514,
            0,
            0,
            0,
            0.525
        ],
        "96": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "97": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "98": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "99": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "100": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "101": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "102": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "103": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "104": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "105": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "106": [
            0.22222,
            0.61111,
            0,
            0,
            0.525
        ],
        "107": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "108": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "109": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "110": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "111": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "112": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "113": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "114": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "115": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "116": [
            0,
            0.55358,
            0,
            0,
            0.525
        ],
        "117": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "118": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "119": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "120": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "121": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "122": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "123": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "124": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "125": [
            0.08333,
            0.69444,
            0,
            0,
            0.525
        ],
        "126": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "127": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "160": [
            0,
            0,
            0,
            0,
            0.525
        ],
        "176": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "184": [
            0.19445,
            0,
            0,
            0,
            0.525
        ],
        "305": [
            0,
            0.43056,
            0,
            0,
            0.525
        ],
        "567": [
            0.22222,
            0.43056,
            0,
            0,
            0.525
        ],
        "711": [
            0,
            0.56597,
            0,
            0,
            0.525
        ],
        "713": [
            0,
            0.56555,
            0,
            0,
            0.525
        ],
        "714": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "715": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "728": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "730": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "770": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "771": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "776": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "915": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "916": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "920": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "923": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "926": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "928": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "931": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "933": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "934": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "936": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "937": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "8216": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "8217": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "8242": [
            0,
            0.61111,
            0,
            0,
            0.525
        ],
        "9251": [
            0.11111,
            0.21944,
            0,
            0,
            0.525
        ]
    }
};
/**
 * This file contains metrics regarding fonts and individual symbols. The sigma
 * and xi variables, as well as the metricMap map contain data extracted from
 * TeX, TeX font metrics, and the TTF files. These data are then exposed via the
 * `metrics` variable and the getCharacterMetrics function.
 */ // In TeX, there are actually three sets of dimensions, one for each of
// textstyle (size index 5 and higher: >=9pt), scriptstyle (size index 3 and 4:
// 7-8pt), and scriptscriptstyle (size index 1 and 2: 5-6pt).  These are
// provided in the arrays below, in that order.
//
// The font metrics are stored in fonts cmsy10, cmsy7, and cmsy5 respectively.
// This was determined by running the following script:
//
//     latex -interaction=nonstopmode \
//     '\documentclass{article}\usepackage{amsmath}\begin{document}' \
//     '$a$ \expandafter\show\the\textfont2' \
//     '\expandafter\show\the\scriptfont2' \
//     '\expandafter\show\the\scriptscriptfont2' \
//     '\stop'
//
// The metrics themselves were retrieved using the following commands:
//
//     tftopl cmsy10
//     tftopl cmsy7
//     tftopl cmsy5
//
// The output of each of these commands is quite lengthy.  The only part we
// care about is the FONTDIMEN section. Each value is measured in EMs.
var sigmasAndXis = {
    slant: [
        0.250,
        0.250,
        0.250
    ],
    // sigma1
    space: [
        0.000,
        0.000,
        0.000
    ],
    // sigma2
    stretch: [
        0.000,
        0.000,
        0.000
    ],
    // sigma3
    shrink: [
        0.000,
        0.000,
        0.000
    ],
    // sigma4
    xHeight: [
        0.431,
        0.431,
        0.431
    ],
    // sigma5
    quad: [
        1.000,
        1.171,
        1.472
    ],
    // sigma6
    extraSpace: [
        0.000,
        0.000,
        0.000
    ],
    // sigma7
    num1: [
        0.677,
        0.732,
        0.925
    ],
    // sigma8
    num2: [
        0.394,
        0.384,
        0.387
    ],
    // sigma9
    num3: [
        0.444,
        0.471,
        0.504
    ],
    // sigma10
    denom1: [
        0.686,
        0.752,
        1.025
    ],
    // sigma11
    denom2: [
        0.345,
        0.344,
        0.532
    ],
    // sigma12
    sup1: [
        0.413,
        0.503,
        0.504
    ],
    // sigma13
    sup2: [
        0.363,
        0.431,
        0.404
    ],
    // sigma14
    sup3: [
        0.289,
        0.286,
        0.294
    ],
    // sigma15
    sub1: [
        0.150,
        0.143,
        0.200
    ],
    // sigma16
    sub2: [
        0.247,
        0.286,
        0.400
    ],
    // sigma17
    supDrop: [
        0.386,
        0.353,
        0.494
    ],
    // sigma18
    subDrop: [
        0.050,
        0.071,
        0.100
    ],
    // sigma19
    delim1: [
        2.390,
        1.700,
        1.980
    ],
    // sigma20
    delim2: [
        1.010,
        1.157,
        1.420
    ],
    // sigma21
    axisHeight: [
        0.250,
        0.250,
        0.250
    ],
    // sigma22
    // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
    // they correspond to the font parameters of the extension fonts (family 3).
    // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
    // match cmex7, we'd use cmex7.tfm values for script and scriptscript
    // values.
    defaultRuleThickness: [
        0.04,
        0.049,
        0.049
    ],
    // xi8; cmex7: 0.049
    bigOpSpacing1: [
        0.111,
        0.111,
        0.111
    ],
    // xi9
    bigOpSpacing2: [
        0.166,
        0.166,
        0.166
    ],
    // xi10
    bigOpSpacing3: [
        0.2,
        0.2,
        0.2
    ],
    // xi11
    bigOpSpacing4: [
        0.6,
        0.611,
        0.611
    ],
    // xi12; cmex7: 0.611
    bigOpSpacing5: [
        0.1,
        0.143,
        0.143
    ],
    // xi13; cmex7: 0.143
    // The \sqrt rule width is taken from the height of the surd character.
    // Since we use the same font at all sizes, this thickness doesn't scale.
    sqrtRuleThickness: [
        0.04,
        0.04,
        0.04
    ],
    // This value determines how large a pt is, for metrics which are defined
    // in terms of pts.
    // This value is also used in katex.scss; if you change it make sure the
    // values match.
    ptPerEm: [
        10.0,
        10.0,
        10.0
    ],
    // The space between adjacent `|` columns in an array definition. From
    // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
    doubleRuleSep: [
        0.2,
        0.2,
        0.2
    ],
    // The width of separator lines in {array} environments. From
    // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
    arrayRuleWidth: [
        0.04,
        0.04,
        0.04
    ],
    // Two values from LaTeX source2e:
    fboxsep: [
        0.3,
        0.3,
        0.3
    ],
    //        3 pt / ptPerEm
    fboxrule: [
        0.04,
        0.04,
        0.04
    ] // 0.4 pt / ptPerEm
}; // This map contains a mapping from font name and character code to character
// should have Latin-1 and Cyrillic characters, but may not depending on the
// operating system.  The metrics do not account for extra height from the
// accents.  In the case of Cyrillic characters which have both ascenders and
// descenders we prefer approximations with ascenders, primarily to prevent
// the fraction bar or root line from intersecting the glyph.
// TODO(kevinb) allow union of multiple glyph metrics for better accuracy.
var extraCharacterMap = {
    // Latin-1
    "\xc5": 'A',
    "\xd0": 'D',
    "\xde": 'o',
    "\xe5": 'a',
    "\xf0": 'd',
    "\xfe": 'o',
    // Cyrillic
    "\u0410": 'A',
    "\u0411": 'B',
    "\u0412": 'B',
    "\u0413": 'F',
    "\u0414": 'A',
    "\u0415": 'E',
    "\u0416": 'K',
    "\u0417": '3',
    "\u0418": 'N',
    "\u0419": 'N',
    "\u041A": 'K',
    "\u041B": 'N',
    "\u041C": 'M',
    "\u041D": 'H',
    "\u041E": 'O',
    "\u041F": 'N',
    "\u0420": 'P',
    "\u0421": 'C',
    "\u0422": 'T',
    "\u0423": 'y',
    "\u0424": 'O',
    "\u0425": 'X',
    "\u0426": 'U',
    "\u0427": 'h',
    "\u0428": 'W',
    "\u0429": 'W',
    "\u042A": 'B',
    "\u042B": 'X',
    "\u042C": 'B',
    "\u042D": '3',
    "\u042E": 'X',
    "\u042F": 'R',
    "\u0430": 'a',
    "\u0431": 'b',
    "\u0432": 'a',
    "\u0433": 'r',
    "\u0434": 'y',
    "\u0435": 'e',
    "\u0436": 'm',
    "\u0437": 'e',
    "\u0438": 'n',
    "\u0439": 'n',
    "\u043A": 'n',
    "\u043B": 'n',
    "\u043C": 'm',
    "\u043D": 'n',
    "\u043E": 'o',
    "\u043F": 'n',
    "\u0440": 'p',
    "\u0441": 'c',
    "\u0442": 'o',
    "\u0443": 'y',
    "\u0444": 'b',
    "\u0445": 'x',
    "\u0446": 'n',
    "\u0447": 'n',
    "\u0448": 'w',
    "\u0449": 'w',
    "\u044A": 'a',
    "\u044B": 'm',
    "\u044C": 'a',
    "\u044D": 'e',
    "\u044E": 'm',
    "\u044F": 'r'
};
/**
 * This function adds new font metrics to default metricMap
 * It can also override existing metrics
 */ function setFontMetrics(fontName, metrics) {
    fontMetricsData[fontName] = metrics;
}
/**
 * This function is a convenience function for looking up information in the
 * metricMap table. It takes a character as a string, and a font.
 *
 * Note: the `width` property may be undefined if fontMetricsData.js wasn't
 * built using `Make extended_metrics`.
 */ function getCharacterMetrics(character, font, mode) {
    if (!fontMetricsData[font]) throw new Error("Font metrics not found for font: " + font + ".");
    var ch = character.charCodeAt(0);
    var metrics = fontMetricsData[font][ch];
    if (!metrics && character[0] in extraCharacterMap) {
        ch = extraCharacterMap[character[0]].charCodeAt(0);
        metrics = fontMetricsData[font][ch];
    }
    if (!metrics && mode === 'text') // We don't typically have font metrics for Asian scripts.
    // But since we support them in text mode, we need to return
    // some sort of metrics.
    // So if the character is in a script we support but we
    // don't have metrics for it, just use the metrics for
    // the Latin capital letter M. This is close enough because
    // we (currently) only care about the height of the glyph
    // not its width.
    {
        if (supportedCodepoint(ch)) metrics = fontMetricsData[font][77]; // 77 is the charcode for 'M'
    }
    if (metrics) return {
        depth: metrics[0],
        height: metrics[1],
        italic: metrics[2],
        skew: metrics[3],
        width: metrics[4]
    };
}
var fontMetricsBySizeIndex = {};
/**
 * Get the font metrics for a given size.
 */ function getGlobalMetrics(size) {
    var sizeIndex;
    if (size >= 5) sizeIndex = 0;
    else if (size >= 3) sizeIndex = 1;
    else sizeIndex = 2;
    if (!fontMetricsBySizeIndex[sizeIndex]) {
        var metrics = fontMetricsBySizeIndex[sizeIndex] = {
            cssEmPerMu: sigmasAndXis.quad[sizeIndex] / 18
        };
        for(var key in sigmasAndXis)if (sigmasAndXis.hasOwnProperty(key)) metrics[key] = sigmasAndXis[key][sizeIndex];
    }
    return fontMetricsBySizeIndex[sizeIndex];
}
/**
 * This file contains information about the options that the Parser carries
 * around with it while parsing. Data is held in an `Options` object, and when
 * recursing, a new `Options` object can be created with the `.with*` and
 * `.reset` functions.
 */ var sizeStyleMap = [
    // The size mappings are taken from TeX with \normalsize=10pt.
    [
        1,
        1,
        1
    ],
    [
        2,
        1,
        1
    ],
    [
        3,
        1,
        1
    ],
    [
        4,
        2,
        1
    ],
    [
        5,
        2,
        1
    ],
    [
        6,
        3,
        1
    ],
    [
        7,
        4,
        2
    ],
    [
        8,
        6,
        3
    ],
    [
        9,
        7,
        6
    ],
    [
        10,
        8,
        7
    ],
    [
        11,
        10,
        9
    ] // size11: [24.88, 20.74, 17.28] \HUGE
];
var sizeMultipliers = [
    // you change size indexes, change that function.
    0.5,
    0.6,
    0.7,
    0.8,
    0.9,
    1.0,
    1.2,
    1.44,
    1.728,
    2.074,
    2.488
];
var sizeAtStyle = function sizeAtStyle(size, style) {
    return style.size < 2 ? size : sizeStyleMap[size - 1][style.size - 1];
}; // In these types, "" (empty string) means "no change".
/**
 * This is the main options class. It contains the current style, size, color,
 * and font.
 *
 * Options objects should not be modified. To create a new Options with
 * different properties, call a `.having*` method.
 */ class Options {
    // A font family applies to a group of fonts (i.e. SansSerif), while a font
    // represents a specific font (i.e. SansSerif Bold).
    // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
    /**
   * The base size index.
   */ constructor(data){
        this.style = void 0;
        this.color = void 0;
        this.size = void 0;
        this.textSize = void 0;
        this.phantom = void 0;
        this.font = void 0;
        this.fontFamily = void 0;
        this.fontWeight = void 0;
        this.fontShape = void 0;
        this.sizeMultiplier = void 0;
        this.maxSize = void 0;
        this.minRuleThickness = void 0;
        this._fontMetrics = void 0;
        this.style = data.style;
        this.color = data.color;
        this.size = data.size || Options.BASESIZE;
        this.textSize = data.textSize || this.size;
        this.phantom = !!data.phantom;
        this.font = data.font || "";
        this.fontFamily = data.fontFamily || "";
        this.fontWeight = data.fontWeight || '';
        this.fontShape = data.fontShape || '';
        this.sizeMultiplier = sizeMultipliers[this.size - 1];
        this.maxSize = data.maxSize;
        this.minRuleThickness = data.minRuleThickness;
        this._fontMetrics = undefined;
    }
    /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */ extend(extension) {
        var data = {
            style: this.style,
            size: this.size,
            textSize: this.textSize,
            color: this.color,
            phantom: this.phantom,
            font: this.font,
            fontFamily: this.fontFamily,
            fontWeight: this.fontWeight,
            fontShape: this.fontShape,
            maxSize: this.maxSize,
            minRuleThickness: this.minRuleThickness
        };
        for(var key in extension)if (extension.hasOwnProperty(key)) data[key] = extension[key];
        return new Options(data);
    }
    /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */ havingStyle(style) {
        if (this.style === style) return this;
        else return this.extend({
            style: style,
            size: sizeAtStyle(this.textSize, style)
        });
    }
    /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */ havingCrampedStyle() {
        return this.havingStyle(this.style.cramp());
    }
    /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */ havingSize(size) {
        if (this.size === size && this.textSize === size) return this;
        else return this.extend({
            style: this.style.text(),
            size: size,
            textSize: size,
            sizeMultiplier: sizeMultipliers[size - 1]
        });
    }
    /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */ havingBaseStyle(style) {
        style = style || this.style.text();
        var wantSize = sizeAtStyle(Options.BASESIZE, style);
        if (this.size === wantSize && this.textSize === Options.BASESIZE && this.style === style) return this;
        else return this.extend({
            style: style,
            size: wantSize
        });
    }
    /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */ havingBaseSizing() {
        var size;
        switch(this.style.id){
            case 4:
            case 5:
                size = 3; // normalsize in scriptstyle
                break;
            case 6:
            case 7:
                size = 1; // normalsize in scriptscriptstyle
                break;
            default:
                size = 6;
        }
        return this.extend({
            style: this.style.text(),
            size: size
        });
    }
    /**
   * Create a new options object with the given color.
   */ withColor(color) {
        return this.extend({
            color: color
        });
    }
    /**
   * Create a new options object with "phantom" set to true.
   */ withPhantom() {
        return this.extend({
            phantom: true
        });
    }
    /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */ withFont(font) {
        return this.extend({
            font
        });
    }
    /**
   * Create a new options objects with the given fontFamily.
   */ withTextFontFamily(fontFamily) {
        return this.extend({
            fontFamily,
            font: ""
        });
    }
    /**
   * Creates a new options object with the given font weight
   */ withTextFontWeight(fontWeight) {
        return this.extend({
            fontWeight,
            font: ""
        });
    }
    /**
   * Creates a new options object with the given font weight
   */ withTextFontShape(fontShape) {
        return this.extend({
            fontShape,
            font: ""
        });
    }
    /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */ sizingClasses(oldOptions) {
        if (oldOptions.size !== this.size) return [
            "sizing",
            "reset-size" + oldOptions.size,
            "size" + this.size
        ];
        else return [];
    }
    /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */ baseSizingClasses() {
        if (this.size !== Options.BASESIZE) return [
            "sizing",
            "reset-size" + this.size,
            "size" + Options.BASESIZE
        ];
        else return [];
    }
    /**
   * Return the font metrics for this size.
   */ fontMetrics() {
        if (!this._fontMetrics) this._fontMetrics = getGlobalMetrics(this.size);
        return this._fontMetrics;
    }
    /**
   * Gets the CSS color of the current options object
   */ getColor() {
        if (this.phantom) return "transparent";
        else return this.color;
    }
}
Options.BASESIZE = 6;
/**
 * This file does conversion between units.  In particular, it provides
 * calculateSize to convert other units into ems.
 */ // Thus, multiplying a length by this number converts the length from units
// into pts.  Dividing the result by ptPerEm gives the number of ems
// *assuming* a font size of ptPerEm (normal size, normal style).
var ptPerUnit = {
    // https://en.wikibooks.org/wiki/LaTeX/Lengths and
    // https://tex.stackexchange.com/a/8263
    "pt": 1,
    // TeX point
    "mm": 7227 / 2540,
    // millimeter
    "cm": 7227 / 254,
    // centimeter
    "in": 72.27,
    // inch
    "bp": 1.00375,
    // big (PostScript) points
    "pc": 12,
    // pica
    "dd": 1238 / 1157,
    // didot
    "cc": 14856 / 1157,
    // cicero (12 didot)
    "nd": 685 / 642,
    // new didot
    "nc": 1370 / 107,
    // new cicero (12 new didot)
    "sp": 1 / 65536,
    // scaled point (TeX's internal smallest unit)
    // https://tex.stackexchange.com/a/41371
    "px": 1.00375 // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
}; // Dictionary of relative units, for fast validity testing.
var relativeUnit = {
    "ex": true,
    "em": true,
    "mu": true
};
/**
 * Determine whether the specified unit (either a string defining the unit
 * or a "size" parse node containing a unit field) is valid.
 */ var validUnit = function validUnit(unit) {
    if (typeof unit !== "string") unit = unit.unit;
    return unit in ptPerUnit || unit in relativeUnit || unit === "ex";
};
/*
 * Convert a "size" parse node (with numeric "number" and string "unit" fields,
 * as parsed by functions.js argType "size") into a CSS em value for the
 * current style/scale.  `options` gives the current options.
 */ var calculateSize = function calculateSize(sizeValue, options) {
    var scale;
    if (sizeValue.unit in ptPerUnit) // Absolute units
    scale = ptPerUnit[sizeValue.unit] // Convert unit to pt
     / options.fontMetrics().ptPerEm // Convert pt to CSS em
     / options.sizeMultiplier; // Unscale to make absolute units
    else if (sizeValue.unit === "mu") // `mu` units scale with scriptstyle/scriptscriptstyle.
    scale = options.fontMetrics().cssEmPerMu;
    else {
        // Other relative units always refer to the *textstyle* font
        // in the current size.
        var unitOptions;
        if (options.style.isTight()) // isTight() means current style is script/scriptscript.
        unitOptions = options.havingStyle(options.style.text());
        else unitOptions = options;
         // TODO: In TeX these units are relative to the quad of the current
        // *text* font, e.g. cmr10. KaTeX instead uses values from the
        // comparably-sized *Computer Modern symbol* font. At 10pt, these
        // match. At 7pt and 5pt, they differ: cmr7=1.138894, cmsy7=1.170641;
        // cmr5=1.361133, cmsy5=1.472241. Consider $\scriptsize a\kern1emb$.
        // TeX \showlists shows a kern of 1.13889 * fontsize;
        // KaTeX shows a kern of 1.171 * fontsize.
        if (sizeValue.unit === "ex") scale = unitOptions.fontMetrics().xHeight;
        else if (sizeValue.unit === "em") scale = unitOptions.fontMetrics().quad;
        else throw new ParseError("Invalid unit: '" + sizeValue.unit + "'");
        if (unitOptions !== options) scale *= unitOptions.sizeMultiplier / options.sizeMultiplier;
    }
    return Math.min(sizeValue.number * scale, options.maxSize);
};
/**
 * Round `n` to 4 decimal places, or to the nearest 1/10,000th em. See
 * https://github.com/KaTeX/KaTeX/pull/2460.
 */ var makeEm = function makeEm(n) {
    return +n.toFixed(4) + "em";
};
/**
 * These objects store the data about the DOM nodes we create, as well as some
 * extra data. They can then be transformed into real DOM nodes with the
 * `toNode` function or HTML markup using `toMarkup`. They are useful for both
 * storing extra properties on the nodes, as well as providing a way to easily
 * work with the DOM.
 *
 * Similar functions for working with MathML nodes exist in mathMLTree.js.
 *
 * TODO: refactor `span` and `anchor` into common superclass when
 * target environments support class inheritance
 */ /**
 * Create an HTML className based on a list of classes. In addition to joining
 * with spaces, we also remove empty classes.
 */ var createClass = function createClass(classes) {
    return classes.filter((cls)=>cls).join(" ");
};
var initNode = function initNode(classes, options, style) {
    this.classes = classes || [];
    this.attributes = {};
    this.height = 0;
    this.depth = 0;
    this.maxFontSize = 0;
    this.style = style || {};
    if (options) {
        if (options.style.isTight()) this.classes.push("mtight");
        var color = options.getColor();
        if (color) this.style.color = color;
    }
};
/**
 * Convert into an HTML node
 */ var toNode = function toNode(tagName) {
    var node = document.createElement(tagName); // Apply the class
    node.className = createClass(this.classes); // Apply inline styles
    for(var style in this.style)if (this.style.hasOwnProperty(style)) // $FlowFixMe Flow doesn't seem to understand span.style's type.
    node.style[style] = this.style[style];
     // Apply attributes
    for(var attr in this.attributes)if (this.attributes.hasOwnProperty(attr)) node.setAttribute(attr, this.attributes[attr]);
     // Append the children, also as HTML nodes
    for(var i = 0; i < this.children.length; i++)node.appendChild(this.children[i].toNode());
    return node;
};
/**
 * https://w3c.github.io/html-reference/syntax.html#syntax-attributes
 *
 * > Attribute Names must consist of one or more characters
 * other than the space characters, U+0000 NULL,
 * '"', "'", ">", "/", "=", the control characters,
 * and any characters that are not defined by Unicode.
 */ var invalidAttributeNameRegex = /[\s"'>/=\x00-\x1f]/;
/**
 * Convert into an HTML markup string
 */ var toMarkup = function toMarkup(tagName) {
    var markup = "<" + tagName; // Add the class
    if (this.classes.length) markup += " class=\"" + utils.escape(createClass(this.classes)) + "\"";
    var styles = ""; // Add the styles, after hyphenation
    for(var style in this.style)if (this.style.hasOwnProperty(style)) styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
    if (styles) markup += " style=\"" + utils.escape(styles) + "\"";
     // Add the attributes
    for(var attr in this.attributes)if (this.attributes.hasOwnProperty(attr)) {
        if (invalidAttributeNameRegex.test(attr)) throw new ParseError("Invalid attribute name '" + attr + "'");
        markup += " " + attr + "=\"" + utils.escape(this.attributes[attr]) + "\"";
    }
    markup += ">"; // Add the markup of the children, also as markup
    for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
    markup += "</" + tagName + ">";
    return markup;
}; // Making the type below exact with all optional fields doesn't work due to
// - https://github.com/facebook/flow/issues/4582
// - https://github.com/facebook/flow/issues/5688
// However, since *all* fields are optional, $Shape<> works as suggested in 5688
// above.
// This type does not include all CSS properties. Additional properties should
// be added as needed.
/**
 * This node represents a span node, with a className, a list of children, and
 * an inline style. It also contains information about its height, depth, and
 * maxFontSize.
 *
 * Represents two types with different uses: SvgSpan to wrap an SVG and DomSpan
 * otherwise. This typesafety is important when HTML builders access a span's
 * children.
 */ class Span {
    constructor(classes, children, options, style){
        this.children = void 0;
        this.attributes = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.width = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        initNode.call(this, classes, options, style);
        this.children = children || [];
    }
    /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */ setAttribute(attribute, value) {
        this.attributes[attribute] = value;
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    toNode() {
        return toNode.call(this, "span");
    }
    toMarkup() {
        return toMarkup.call(this, "span");
    }
}
/**
 * This node represents an anchor (<a>) element with a hyperlink.  See `span`
 * for further details.
 */ class Anchor {
    constructor(href, classes, children, options){
        this.children = void 0;
        this.attributes = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        initNode.call(this, classes, options);
        this.children = children || [];
        this.setAttribute('href', href);
    }
    setAttribute(attribute, value) {
        this.attributes[attribute] = value;
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    toNode() {
        return toNode.call(this, "a");
    }
    toMarkup() {
        return toMarkup.call(this, "a");
    }
}
/**
 * This node represents an image embed (<img>) element.
 */ class Img {
    constructor(src, alt, style){
        this.src = void 0;
        this.alt = void 0;
        this.classes = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.maxFontSize = void 0;
        this.style = void 0;
        this.alt = alt;
        this.src = src;
        this.classes = [
            "mord"
        ];
        this.style = style;
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    toNode() {
        var node = document.createElement("img");
        node.src = this.src;
        node.alt = this.alt;
        node.className = "mord"; // Apply inline styles
        for(var style in this.style)if (this.style.hasOwnProperty(style)) // $FlowFixMe
        node.style[style] = this.style[style];
        return node;
    }
    toMarkup() {
        var markup = "<img src=\"" + utils.escape(this.src) + "\"" + (" alt=\"" + utils.escape(this.alt) + "\""); // Add the styles, after hyphenation
        var styles = "";
        for(var style in this.style)if (this.style.hasOwnProperty(style)) styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
        if (styles) markup += " style=\"" + utils.escape(styles) + "\"";
        markup += "'/>";
        return markup;
    }
}
var iCombinations = {
    "\xee": '\u0131\u0302',
    "\xef": '\u0131\u0308',
    "\xed": '\u0131\u0301',
    // 'ī': '\u0131\u0304', // enable when we add Extended Latin
    "\xec": '\u0131\u0300'
};
/**
 * A symbol node contains information about a single symbol. It either renders
 * to a single text node, or a span with a single text node in it, depending on
 * whether it has CSS classes, styles, or needs italic correction.
 */ class SymbolNode {
    constructor(text, height, depth, italic, skew, width, classes, style){
        this.text = void 0;
        this.height = void 0;
        this.depth = void 0;
        this.italic = void 0;
        this.skew = void 0;
        this.width = void 0;
        this.maxFontSize = void 0;
        this.classes = void 0;
        this.style = void 0;
        this.text = text;
        this.height = height || 0;
        this.depth = depth || 0;
        this.italic = italic || 0;
        this.skew = skew || 0;
        this.width = width || 0;
        this.classes = classes || [];
        this.style = style || {};
        this.maxFontSize = 0; // Mark text from non-Latin scripts with specific classes so that we
        // can specify which fonts to use.  This allows us to render these
        // characters with a serif font in situations where the browser would
        // either default to a sans serif or render a placeholder character.
        // We use CSS class names like cjk_fallback, hangul_fallback and
        // brahmic_fallback. See ./unicodeScripts.js for the set of possible
        // script names
        var script = scriptFromCodepoint(this.text.charCodeAt(0));
        if (script) this.classes.push(script + "_fallback");
        if (/[îïíì]/.test(this.text)) // add ī when we add Extended Latin
        this.text = iCombinations[this.text];
    }
    hasClass(className) {
        return this.classes.includes(className);
    }
    /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */ toNode() {
        var node = document.createTextNode(this.text);
        var span = null;
        if (this.italic > 0) {
            span = document.createElement("span");
            span.style.marginRight = makeEm(this.italic);
        }
        if (this.classes.length > 0) {
            span = span || document.createElement("span");
            span.className = createClass(this.classes);
        }
        for(var style in this.style)if (this.style.hasOwnProperty(style)) {
            span = span || document.createElement("span"); // $FlowFixMe Flow doesn't seem to understand span.style's type.
            span.style[style] = this.style[style];
        }
        if (span) {
            span.appendChild(node);
            return span;
        } else return node;
    }
    /**
   * Creates markup for a symbol node.
   */ toMarkup() {
        // TODO(alpert): More duplication than I'd like from
        // span.prototype.toMarkup and symbolNode.prototype.toNode...
        var needsSpan = false;
        var markup = "<span";
        if (this.classes.length) {
            needsSpan = true;
            markup += " class=\"";
            markup += utils.escape(createClass(this.classes));
            markup += "\"";
        }
        var styles = "";
        if (this.italic > 0) styles += "margin-right:" + this.italic + "em;";
        for(var style in this.style)if (this.style.hasOwnProperty(style)) styles += utils.hyphenate(style) + ":" + this.style[style] + ";";
        if (styles) {
            needsSpan = true;
            markup += " style=\"" + utils.escape(styles) + "\"";
        }
        var escaped = utils.escape(this.text);
        if (needsSpan) {
            markup += ">";
            markup += escaped;
            markup += "</span>";
            return markup;
        } else return escaped;
    }
}
/**
 * SVG nodes are used to render stretchy wide elements.
 */ class SvgNode {
    constructor(children, attributes){
        this.children = void 0;
        this.attributes = void 0;
        this.children = children || [];
        this.attributes = attributes || {};
    }
    toNode() {
        var svgNS = "http://www.w3.org/2000/svg";
        var node = document.createElementNS(svgNS, "svg"); // Apply attributes
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) node.setAttribute(attr, this.attributes[attr]);
        for(var i = 0; i < this.children.length; i++)node.appendChild(this.children[i].toNode());
        return node;
    }
    toMarkup() {
        var markup = "<svg xmlns=\"http://www.w3.org/2000/svg\""; // Apply attributes
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) markup += " " + attr + "=\"" + utils.escape(this.attributes[attr]) + "\"";
        markup += ">";
        for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
        markup += "</svg>";
        return markup;
    }
}
class PathNode {
    constructor(pathName, alternate){
        this.pathName = void 0;
        this.alternate = void 0;
        this.pathName = pathName;
        this.alternate = alternate; // Used only for \sqrt, \phase, & tall delims
    }
    toNode() {
        var svgNS = "http://www.w3.org/2000/svg";
        var node = document.createElementNS(svgNS, "path");
        if (this.alternate) node.setAttribute("d", this.alternate);
        else node.setAttribute("d", path[this.pathName]);
        return node;
    }
    toMarkup() {
        if (this.alternate) return "<path d=\"" + utils.escape(this.alternate) + "\"/>";
        else return "<path d=\"" + utils.escape(path[this.pathName]) + "\"/>";
    }
}
class LineNode {
    constructor(attributes){
        this.attributes = void 0;
        this.attributes = attributes || {};
    }
    toNode() {
        var svgNS = "http://www.w3.org/2000/svg";
        var node = document.createElementNS(svgNS, "line"); // Apply attributes
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) node.setAttribute(attr, this.attributes[attr]);
        return node;
    }
    toMarkup() {
        var markup = "<line";
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) markup += " " + attr + "=\"" + utils.escape(this.attributes[attr]) + "\"";
        markup += "/>";
        return markup;
    }
}
function assertSymbolDomNode(group) {
    if (group instanceof SymbolNode) return group;
    else throw new Error("Expected symbolNode but got " + String(group) + ".");
}
function assertSpan(group) {
    if (group instanceof Span) return group;
    else throw new Error("Expected span<HtmlDomNode> but got " + String(group) + ".");
}
/**
 * This file holds a list of all no-argument functions and single-character
 * symbols (like 'a' or ';').
 *
 * For each of the symbols, there are three properties they can have:
 * - font (required): the font to be used for this symbol. Either "main" (the
     normal font), or "ams" (the ams fonts).
 * - group (required): the ParseNode group type the symbol should have (i.e.
     "textord", "mathord", etc).
     See https://github.com/KaTeX/KaTeX/wiki/Examining-TeX#group-types
 * - replace: the character that this symbol or function should be
 *   replaced with (i.e. "\phi" has a replace value of "\u03d5", the phi
 *   character in the main font).
 *
 * The outermost map in the table indicates what mode the symbols should be
 * accepted in (e.g. "math" or "text").
 */ // Some of these have a "-token" suffix since these are also used as `ParseNode`
// types for raw text tokens, and we want to avoid conflicts with higher-level
// `ParseNode` types. These `ParseNode`s are constructed within `Parser` by
// looking up the `symbols` map.
var ATOMS = {
    "bin": 1,
    "close": 1,
    "inner": 1,
    "open": 1,
    "punct": 1,
    "rel": 1
};
var NON_ATOMS = {
    "accent-token": 1,
    "mathord": 1,
    "op-token": 1,
    "spacing": 1,
    "textord": 1
};
var symbols = {
    "math": {},
    "text": {}
};
/** `acceptUnicodeChar = true` is only applicable if `replace` is set. */ function defineSymbol(mode, font, group, replace, name, acceptUnicodeChar) {
    symbols[mode][name] = {
        font,
        group,
        replace
    };
    if (acceptUnicodeChar && replace) symbols[mode][replace] = symbols[mode][name];
} // Some abbreviations for commonly used strings.
// This helps minify the code, and also spotting typos using jshint.
// modes:
var math = "math";
var text = "text"; // fonts:
var main = "main";
var ams = "ams"; // groups:
var accent = "accent-token";
var bin = "bin";
var close = "close";
var inner = "inner";
var mathord = "mathord";
var op = "op-token";
var open = "open";
var punct = "punct";
var rel = "rel";
var spacing = "spacing";
var textord = "textord"; // Now comes the symbol table
// Relation Symbols
defineSymbol(math, main, rel, "\u2261", "\\equiv", true);
defineSymbol(math, main, rel, "\u227a", "\\prec", true);
defineSymbol(math, main, rel, "\u227b", "\\succ", true);
defineSymbol(math, main, rel, "\u223c", "\\sim", true);
defineSymbol(math, main, rel, "\u22a5", "\\perp");
defineSymbol(math, main, rel, "\u2aaf", "\\preceq", true);
defineSymbol(math, main, rel, "\u2ab0", "\\succeq", true);
defineSymbol(math, main, rel, "\u2243", "\\simeq", true);
defineSymbol(math, main, rel, "\u2223", "\\mid", true);
defineSymbol(math, main, rel, "\u226a", "\\ll", true);
defineSymbol(math, main, rel, "\u226b", "\\gg", true);
defineSymbol(math, main, rel, "\u224d", "\\asymp", true);
defineSymbol(math, main, rel, "\u2225", "\\parallel");
defineSymbol(math, main, rel, "\u22c8", "\\bowtie", true);
defineSymbol(math, main, rel, "\u2323", "\\smile", true);
defineSymbol(math, main, rel, "\u2291", "\\sqsubseteq", true);
defineSymbol(math, main, rel, "\u2292", "\\sqsupseteq", true);
defineSymbol(math, main, rel, "\u2250", "\\doteq", true);
defineSymbol(math, main, rel, "\u2322", "\\frown", true);
defineSymbol(math, main, rel, "\u220b", "\\ni", true);
defineSymbol(math, main, rel, "\u221d", "\\propto", true);
defineSymbol(math, main, rel, "\u22a2", "\\vdash", true);
defineSymbol(math, main, rel, "\u22a3", "\\dashv", true);
defineSymbol(math, main, rel, "\u220b", "\\owns"); // Punctuation
defineSymbol(math, main, punct, "\u002e", "\\ldotp");
defineSymbol(math, main, punct, "\u22c5", "\\cdotp"); // Misc Symbols
defineSymbol(math, main, textord, "\u0023", "\\#");
defineSymbol(text, main, textord, "\u0023", "\\#");
defineSymbol(math, main, textord, "\u0026", "\\&");
defineSymbol(text, main, textord, "\u0026", "\\&");
defineSymbol(math, main, textord, "\u2135", "\\aleph", true);
defineSymbol(math, main, textord, "\u2200", "\\forall", true);
defineSymbol(math, main, textord, "\u210f", "\\hbar", true);
defineSymbol(math, main, textord, "\u2203", "\\exists", true);
defineSymbol(math, main, textord, "\u2207", "\\nabla", true);
defineSymbol(math, main, textord, "\u266d", "\\flat", true);
defineSymbol(math, main, textord, "\u2113", "\\ell", true);
defineSymbol(math, main, textord, "\u266e", "\\natural", true);
defineSymbol(math, main, textord, "\u2663", "\\clubsuit", true);
defineSymbol(math, main, textord, "\u2118", "\\wp", true);
defineSymbol(math, main, textord, "\u266f", "\\sharp", true);
defineSymbol(math, main, textord, "\u2662", "\\diamondsuit", true);
defineSymbol(math, main, textord, "\u211c", "\\Re", true);
defineSymbol(math, main, textord, "\u2661", "\\heartsuit", true);
defineSymbol(math, main, textord, "\u2111", "\\Im", true);
defineSymbol(math, main, textord, "\u2660", "\\spadesuit", true);
defineSymbol(math, main, textord, "\u00a7", "\\S", true);
defineSymbol(text, main, textord, "\u00a7", "\\S");
defineSymbol(math, main, textord, "\u00b6", "\\P", true);
defineSymbol(text, main, textord, "\u00b6", "\\P"); // Math and Text
defineSymbol(math, main, textord, "\u2020", "\\dag");
defineSymbol(text, main, textord, "\u2020", "\\dag");
defineSymbol(text, main, textord, "\u2020", "\\textdagger");
defineSymbol(math, main, textord, "\u2021", "\\ddag");
defineSymbol(text, main, textord, "\u2021", "\\ddag");
defineSymbol(text, main, textord, "\u2021", "\\textdaggerdbl"); // Large Delimiters
defineSymbol(math, main, close, "\u23b1", "\\rmoustache", true);
defineSymbol(math, main, open, "\u23b0", "\\lmoustache", true);
defineSymbol(math, main, close, "\u27ef", "\\rgroup", true);
defineSymbol(math, main, open, "\u27ee", "\\lgroup", true); // Binary Operators
defineSymbol(math, main, bin, "\u2213", "\\mp", true);
defineSymbol(math, main, bin, "\u2296", "\\ominus", true);
defineSymbol(math, main, bin, "\u228e", "\\uplus", true);
defineSymbol(math, main, bin, "\u2293", "\\sqcap", true);
defineSymbol(math, main, bin, "\u2217", "\\ast");
defineSymbol(math, main, bin, "\u2294", "\\sqcup", true);
defineSymbol(math, main, bin, "\u25ef", "\\bigcirc", true);
defineSymbol(math, main, bin, "\u2219", "\\bullet", true);
defineSymbol(math, main, bin, "\u2021", "\\ddagger");
defineSymbol(math, main, bin, "\u2240", "\\wr", true);
defineSymbol(math, main, bin, "\u2a3f", "\\amalg");
defineSymbol(math, main, bin, "\u0026", "\\And"); // from amsmath
// Arrow Symbols
defineSymbol(math, main, rel, "\u27f5", "\\longleftarrow", true);
defineSymbol(math, main, rel, "\u21d0", "\\Leftarrow", true);
defineSymbol(math, main, rel, "\u27f8", "\\Longleftarrow", true);
defineSymbol(math, main, rel, "\u27f6", "\\longrightarrow", true);
defineSymbol(math, main, rel, "\u21d2", "\\Rightarrow", true);
defineSymbol(math, main, rel, "\u27f9", "\\Longrightarrow", true);
defineSymbol(math, main, rel, "\u2194", "\\leftrightarrow", true);
defineSymbol(math, main, rel, "\u27f7", "\\longleftrightarrow", true);
defineSymbol(math, main, rel, "\u21d4", "\\Leftrightarrow", true);
defineSymbol(math, main, rel, "\u27fa", "\\Longleftrightarrow", true);
defineSymbol(math, main, rel, "\u21a6", "\\mapsto", true);
defineSymbol(math, main, rel, "\u27fc", "\\longmapsto", true);
defineSymbol(math, main, rel, "\u2197", "\\nearrow", true);
defineSymbol(math, main, rel, "\u21a9", "\\hookleftarrow", true);
defineSymbol(math, main, rel, "\u21aa", "\\hookrightarrow", true);
defineSymbol(math, main, rel, "\u2198", "\\searrow", true);
defineSymbol(math, main, rel, "\u21bc", "\\leftharpoonup", true);
defineSymbol(math, main, rel, "\u21c0", "\\rightharpoonup", true);
defineSymbol(math, main, rel, "\u2199", "\\swarrow", true);
defineSymbol(math, main, rel, "\u21bd", "\\leftharpoondown", true);
defineSymbol(math, main, rel, "\u21c1", "\\rightharpoondown", true);
defineSymbol(math, main, rel, "\u2196", "\\nwarrow", true);
defineSymbol(math, main, rel, "\u21cc", "\\rightleftharpoons", true); // AMS Negated Binary Relations
defineSymbol(math, ams, rel, "\u226e", "\\nless", true); // Symbol names preceded by "@" each have a corresponding macro.
defineSymbol(math, ams, rel, "\ue010", "\\@nleqslant");
defineSymbol(math, ams, rel, "\ue011", "\\@nleqq");
defineSymbol(math, ams, rel, "\u2a87", "\\lneq", true);
defineSymbol(math, ams, rel, "\u2268", "\\lneqq", true);
defineSymbol(math, ams, rel, "\ue00c", "\\@lvertneqq");
defineSymbol(math, ams, rel, "\u22e6", "\\lnsim", true);
defineSymbol(math, ams, rel, "\u2a89", "\\lnapprox", true);
defineSymbol(math, ams, rel, "\u2280", "\\nprec", true); // unicode-math maps \u22e0 to \npreccurlyeq. We'll use the AMS synonym.
defineSymbol(math, ams, rel, "\u22e0", "\\npreceq", true);
defineSymbol(math, ams, rel, "\u22e8", "\\precnsim", true);
defineSymbol(math, ams, rel, "\u2ab9", "\\precnapprox", true);
defineSymbol(math, ams, rel, "\u2241", "\\nsim", true);
defineSymbol(math, ams, rel, "\ue006", "\\@nshortmid");
defineSymbol(math, ams, rel, "\u2224", "\\nmid", true);
defineSymbol(math, ams, rel, "\u22ac", "\\nvdash", true);
defineSymbol(math, ams, rel, "\u22ad", "\\nvDash", true);
defineSymbol(math, ams, rel, "\u22ea", "\\ntriangleleft");
defineSymbol(math, ams, rel, "\u22ec", "\\ntrianglelefteq", true);
defineSymbol(math, ams, rel, "\u228a", "\\subsetneq", true);
defineSymbol(math, ams, rel, "\ue01a", "\\@varsubsetneq");
defineSymbol(math, ams, rel, "\u2acb", "\\subsetneqq", true);
defineSymbol(math, ams, rel, "\ue017", "\\@varsubsetneqq");
defineSymbol(math, ams, rel, "\u226f", "\\ngtr", true);
defineSymbol(math, ams, rel, "\ue00f", "\\@ngeqslant");
defineSymbol(math, ams, rel, "\ue00e", "\\@ngeqq");
defineSymbol(math, ams, rel, "\u2a88", "\\gneq", true);
defineSymbol(math, ams, rel, "\u2269", "\\gneqq", true);
defineSymbol(math, ams, rel, "\ue00d", "\\@gvertneqq");
defineSymbol(math, ams, rel, "\u22e7", "\\gnsim", true);
defineSymbol(math, ams, rel, "\u2a8a", "\\gnapprox", true);
defineSymbol(math, ams, rel, "\u2281", "\\nsucc", true); // unicode-math maps \u22e1 to \nsucccurlyeq. We'll use the AMS synonym.
defineSymbol(math, ams, rel, "\u22e1", "\\nsucceq", true);
defineSymbol(math, ams, rel, "\u22e9", "\\succnsim", true);
defineSymbol(math, ams, rel, "\u2aba", "\\succnapprox", true); // unicode-math maps \u2246 to \simneqq. We'll use the AMS synonym.
defineSymbol(math, ams, rel, "\u2246", "\\ncong", true);
defineSymbol(math, ams, rel, "\ue007", "\\@nshortparallel");
defineSymbol(math, ams, rel, "\u2226", "\\nparallel", true);
defineSymbol(math, ams, rel, "\u22af", "\\nVDash", true);
defineSymbol(math, ams, rel, "\u22eb", "\\ntriangleright");
defineSymbol(math, ams, rel, "\u22ed", "\\ntrianglerighteq", true);
defineSymbol(math, ams, rel, "\ue018", "\\@nsupseteqq");
defineSymbol(math, ams, rel, "\u228b", "\\supsetneq", true);
defineSymbol(math, ams, rel, "\ue01b", "\\@varsupsetneq");
defineSymbol(math, ams, rel, "\u2acc", "\\supsetneqq", true);
defineSymbol(math, ams, rel, "\ue019", "\\@varsupsetneqq");
defineSymbol(math, ams, rel, "\u22ae", "\\nVdash", true);
defineSymbol(math, ams, rel, "\u2ab5", "\\precneqq", true);
defineSymbol(math, ams, rel, "\u2ab6", "\\succneqq", true);
defineSymbol(math, ams, rel, "\ue016", "\\@nsubseteqq");
defineSymbol(math, ams, bin, "\u22b4", "\\unlhd");
defineSymbol(math, ams, bin, "\u22b5", "\\unrhd"); // AMS Negated Arrows
defineSymbol(math, ams, rel, "\u219a", "\\nleftarrow", true);
defineSymbol(math, ams, rel, "\u219b", "\\nrightarrow", true);
defineSymbol(math, ams, rel, "\u21cd", "\\nLeftarrow", true);
defineSymbol(math, ams, rel, "\u21cf", "\\nRightarrow", true);
defineSymbol(math, ams, rel, "\u21ae", "\\nleftrightarrow", true);
defineSymbol(math, ams, rel, "\u21ce", "\\nLeftrightarrow", true); // AMS Misc
defineSymbol(math, ams, rel, "\u25b3", "\\vartriangle");
defineSymbol(math, ams, textord, "\u210f", "\\hslash");
defineSymbol(math, ams, textord, "\u25bd", "\\triangledown");
defineSymbol(math, ams, textord, "\u25ca", "\\lozenge");
defineSymbol(math, ams, textord, "\u24c8", "\\circledS");
defineSymbol(math, ams, textord, "\u00ae", "\\circledR");
defineSymbol(text, ams, textord, "\u00ae", "\\circledR");
defineSymbol(math, ams, textord, "\u2221", "\\measuredangle", true);
defineSymbol(math, ams, textord, "\u2204", "\\nexists");
defineSymbol(math, ams, textord, "\u2127", "\\mho");
defineSymbol(math, ams, textord, "\u2132", "\\Finv", true);
defineSymbol(math, ams, textord, "\u2141", "\\Game", true);
defineSymbol(math, ams, textord, "\u2035", "\\backprime");
defineSymbol(math, ams, textord, "\u25b2", "\\blacktriangle");
defineSymbol(math, ams, textord, "\u25bc", "\\blacktriangledown");
defineSymbol(math, ams, textord, "\u25a0", "\\blacksquare");
defineSymbol(math, ams, textord, "\u29eb", "\\blacklozenge");
defineSymbol(math, ams, textord, "\u2605", "\\bigstar");
defineSymbol(math, ams, textord, "\u2222", "\\sphericalangle", true);
defineSymbol(math, ams, textord, "\u2201", "\\complement", true); // unicode-math maps U+F0 to \matheth. We map to AMS function \eth
defineSymbol(math, ams, textord, "\u00f0", "\\eth", true);
defineSymbol(text, main, textord, "\u00f0", "\u00f0");
defineSymbol(math, ams, textord, "\u2571", "\\diagup");
defineSymbol(math, ams, textord, "\u2572", "\\diagdown");
defineSymbol(math, ams, textord, "\u25a1", "\\square");
defineSymbol(math, ams, textord, "\u25a1", "\\Box");
defineSymbol(math, ams, textord, "\u25ca", "\\Diamond"); // unicode-math maps U+A5 to \mathyen. We map to AMS function \yen
defineSymbol(math, ams, textord, "\u00a5", "\\yen", true);
defineSymbol(text, ams, textord, "\u00a5", "\\yen", true);
defineSymbol(math, ams, textord, "\u2713", "\\checkmark", true);
defineSymbol(text, ams, textord, "\u2713", "\\checkmark"); // AMS Hebrew
defineSymbol(math, ams, textord, "\u2136", "\\beth", true);
defineSymbol(math, ams, textord, "\u2138", "\\daleth", true);
defineSymbol(math, ams, textord, "\u2137", "\\gimel", true); // AMS Greek
defineSymbol(math, ams, textord, "\u03dd", "\\digamma", true);
defineSymbol(math, ams, textord, "\u03f0", "\\varkappa"); // AMS Delimiters
defineSymbol(math, ams, open, "\u250c", "\\@ulcorner", true);
defineSymbol(math, ams, close, "\u2510", "\\@urcorner", true);
defineSymbol(math, ams, open, "\u2514", "\\@llcorner", true);
defineSymbol(math, ams, close, "\u2518", "\\@lrcorner", true); // AMS Binary Relations
defineSymbol(math, ams, rel, "\u2266", "\\leqq", true);
defineSymbol(math, ams, rel, "\u2a7d", "\\leqslant", true);
defineSymbol(math, ams, rel, "\u2a95", "\\eqslantless", true);
defineSymbol(math, ams, rel, "\u2272", "\\lesssim", true);
defineSymbol(math, ams, rel, "\u2a85", "\\lessapprox", true);
defineSymbol(math, ams, rel, "\u224a", "\\approxeq", true);
defineSymbol(math, ams, bin, "\u22d6", "\\lessdot");
defineSymbol(math, ams, rel, "\u22d8", "\\lll", true);
defineSymbol(math, ams, rel, "\u2276", "\\lessgtr", true);
defineSymbol(math, ams, rel, "\u22da", "\\lesseqgtr", true);
defineSymbol(math, ams, rel, "\u2a8b", "\\lesseqqgtr", true);
defineSymbol(math, ams, rel, "\u2251", "\\doteqdot");
defineSymbol(math, ams, rel, "\u2253", "\\risingdotseq", true);
defineSymbol(math, ams, rel, "\u2252", "\\fallingdotseq", true);
defineSymbol(math, ams, rel, "\u223d", "\\backsim", true);
defineSymbol(math, ams, rel, "\u22cd", "\\backsimeq", true);
defineSymbol(math, ams, rel, "\u2ac5", "\\subseteqq", true);
defineSymbol(math, ams, rel, "\u22d0", "\\Subset", true);
defineSymbol(math, ams, rel, "\u228f", "\\sqsubset", true);
defineSymbol(math, ams, rel, "\u227c", "\\preccurlyeq", true);
defineSymbol(math, ams, rel, "\u22de", "\\curlyeqprec", true);
defineSymbol(math, ams, rel, "\u227e", "\\precsim", true);
defineSymbol(math, ams, rel, "\u2ab7", "\\precapprox", true);
defineSymbol(math, ams, rel, "\u22b2", "\\vartriangleleft");
defineSymbol(math, ams, rel, "\u22b4", "\\trianglelefteq");
defineSymbol(math, ams, rel, "\u22a8", "\\vDash", true);
defineSymbol(math, ams, rel, "\u22aa", "\\Vvdash", true);
defineSymbol(math, ams, rel, "\u2323", "\\smallsmile");
defineSymbol(math, ams, rel, "\u2322", "\\smallfrown");
defineSymbol(math, ams, rel, "\u224f", "\\bumpeq", true);
defineSymbol(math, ams, rel, "\u224e", "\\Bumpeq", true);
defineSymbol(math, ams, rel, "\u2267", "\\geqq", true);
defineSymbol(math, ams, rel, "\u2a7e", "\\geqslant", true);
defineSymbol(math, ams, rel, "\u2a96", "\\eqslantgtr", true);
defineSymbol(math, ams, rel, "\u2273", "\\gtrsim", true);
defineSymbol(math, ams, rel, "\u2a86", "\\gtrapprox", true);
defineSymbol(math, ams, bin, "\u22d7", "\\gtrdot");
defineSymbol(math, ams, rel, "\u22d9", "\\ggg", true);
defineSymbol(math, ams, rel, "\u2277", "\\gtrless", true);
defineSymbol(math, ams, rel, "\u22db", "\\gtreqless", true);
defineSymbol(math, ams, rel, "\u2a8c", "\\gtreqqless", true);
defineSymbol(math, ams, rel, "\u2256", "\\eqcirc", true);
defineSymbol(math, ams, rel, "\u2257", "\\circeq", true);
defineSymbol(math, ams, rel, "\u225c", "\\triangleq", true);
defineSymbol(math, ams, rel, "\u223c", "\\thicksim");
defineSymbol(math, ams, rel, "\u2248", "\\thickapprox");
defineSymbol(math, ams, rel, "\u2ac6", "\\supseteqq", true);
defineSymbol(math, ams, rel, "\u22d1", "\\Supset", true);
defineSymbol(math, ams, rel, "\u2290", "\\sqsupset", true);
defineSymbol(math, ams, rel, "\u227d", "\\succcurlyeq", true);
defineSymbol(math, ams, rel, "\u22df", "\\curlyeqsucc", true);
defineSymbol(math, ams, rel, "\u227f", "\\succsim", true);
defineSymbol(math, ams, rel, "\u2ab8", "\\succapprox", true);
defineSymbol(math, ams, rel, "\u22b3", "\\vartriangleright");
defineSymbol(math, ams, rel, "\u22b5", "\\trianglerighteq");
defineSymbol(math, ams, rel, "\u22a9", "\\Vdash", true);
defineSymbol(math, ams, rel, "\u2223", "\\shortmid");
defineSymbol(math, ams, rel, "\u2225", "\\shortparallel");
defineSymbol(math, ams, rel, "\u226c", "\\between", true);
defineSymbol(math, ams, rel, "\u22d4", "\\pitchfork", true);
defineSymbol(math, ams, rel, "\u221d", "\\varpropto");
defineSymbol(math, ams, rel, "\u25c0", "\\blacktriangleleft"); // unicode-math says that \therefore is a mathord atom.
// We kept the amssymb atom type, which is rel.
defineSymbol(math, ams, rel, "\u2234", "\\therefore", true);
defineSymbol(math, ams, rel, "\u220d", "\\backepsilon");
defineSymbol(math, ams, rel, "\u25b6", "\\blacktriangleright"); // unicode-math says that \because is a mathord atom.
// We kept the amssymb atom type, which is rel.
defineSymbol(math, ams, rel, "\u2235", "\\because", true);
defineSymbol(math, ams, rel, "\u22d8", "\\llless");
defineSymbol(math, ams, rel, "\u22d9", "\\gggtr");
defineSymbol(math, ams, bin, "\u22b2", "\\lhd");
defineSymbol(math, ams, bin, "\u22b3", "\\rhd");
defineSymbol(math, ams, rel, "\u2242", "\\eqsim", true);
defineSymbol(math, main, rel, "\u22c8", "\\Join");
defineSymbol(math, ams, rel, "\u2251", "\\Doteq", true); // AMS Binary Operators
defineSymbol(math, ams, bin, "\u2214", "\\dotplus", true);
defineSymbol(math, ams, bin, "\u2216", "\\smallsetminus");
defineSymbol(math, ams, bin, "\u22d2", "\\Cap", true);
defineSymbol(math, ams, bin, "\u22d3", "\\Cup", true);
defineSymbol(math, ams, bin, "\u2a5e", "\\doublebarwedge", true);
defineSymbol(math, ams, bin, "\u229f", "\\boxminus", true);
defineSymbol(math, ams, bin, "\u229e", "\\boxplus", true);
defineSymbol(math, ams, bin, "\u22c7", "\\divideontimes", true);
defineSymbol(math, ams, bin, "\u22c9", "\\ltimes", true);
defineSymbol(math, ams, bin, "\u22ca", "\\rtimes", true);
defineSymbol(math, ams, bin, "\u22cb", "\\leftthreetimes", true);
defineSymbol(math, ams, bin, "\u22cc", "\\rightthreetimes", true);
defineSymbol(math, ams, bin, "\u22cf", "\\curlywedge", true);
defineSymbol(math, ams, bin, "\u22ce", "\\curlyvee", true);
defineSymbol(math, ams, bin, "\u229d", "\\circleddash", true);
defineSymbol(math, ams, bin, "\u229b", "\\circledast", true);
defineSymbol(math, ams, bin, "\u22c5", "\\centerdot");
defineSymbol(math, ams, bin, "\u22ba", "\\intercal", true);
defineSymbol(math, ams, bin, "\u22d2", "\\doublecap");
defineSymbol(math, ams, bin, "\u22d3", "\\doublecup");
defineSymbol(math, ams, bin, "\u22a0", "\\boxtimes", true); // AMS Arrows
// Note: unicode-math maps \u21e2 to their own function \rightdasharrow.
// We'll map it to AMS function \dashrightarrow. It produces the same atom.
defineSymbol(math, ams, rel, "\u21e2", "\\dashrightarrow", true); // unicode-math maps \u21e0 to \leftdasharrow. We'll use the AMS synonym.
defineSymbol(math, ams, rel, "\u21e0", "\\dashleftarrow", true);
defineSymbol(math, ams, rel, "\u21c7", "\\leftleftarrows", true);
defineSymbol(math, ams, rel, "\u21c6", "\\leftrightarrows", true);
defineSymbol(math, ams, rel, "\u21da", "\\Lleftarrow", true);
defineSymbol(math, ams, rel, "\u219e", "\\twoheadleftarrow", true);
defineSymbol(math, ams, rel, "\u21a2", "\\leftarrowtail", true);
defineSymbol(math, ams, rel, "\u21ab", "\\looparrowleft", true);
defineSymbol(math, ams, rel, "\u21cb", "\\leftrightharpoons", true);
defineSymbol(math, ams, rel, "\u21b6", "\\curvearrowleft", true); // unicode-math maps \u21ba to \acwopencirclearrow. We'll use the AMS synonym.
defineSymbol(math, ams, rel, "\u21ba", "\\circlearrowleft", true);
defineSymbol(math, ams, rel, "\u21b0", "\\Lsh", true);
defineSymbol(math, ams, rel, "\u21c8", "\\upuparrows", true);
defineSymbol(math, ams, rel, "\u21bf", "\\upharpoonleft", true);
defineSymbol(math, ams, rel, "\u21c3", "\\downharpoonleft", true);
defineSymbol(math, main, rel, "\u22b6", "\\origof", true); // not in font
defineSymbol(math, main, rel, "\u22b7", "\\imageof", true); // not in font
defineSymbol(math, ams, rel, "\u22b8", "\\multimap", true);
defineSymbol(math, ams, rel, "\u21ad", "\\leftrightsquigarrow", true);
defineSymbol(math, ams, rel, "\u21c9", "\\rightrightarrows", true);
defineSymbol(math, ams, rel, "\u21c4", "\\rightleftarrows", true);
defineSymbol(math, ams, rel, "\u21a0", "\\twoheadrightarrow", true);
defineSymbol(math, ams, rel, "\u21a3", "\\rightarrowtail", true);
defineSymbol(math, ams, rel, "\u21ac", "\\looparrowright", true);
defineSymbol(math, ams, rel, "\u21b7", "\\curvearrowright", true); // unicode-math maps \u21bb to \cwopencirclearrow. We'll use the AMS synonym.
defineSymbol(math, ams, rel, "\u21bb", "\\circlearrowright", true);
defineSymbol(math, ams, rel, "\u21b1", "\\Rsh", true);
defineSymbol(math, ams, rel, "\u21ca", "\\downdownarrows", true);
defineSymbol(math, ams, rel, "\u21be", "\\upharpoonright", true);
defineSymbol(math, ams, rel, "\u21c2", "\\downharpoonright", true);
defineSymbol(math, ams, rel, "\u21dd", "\\rightsquigarrow", true);
defineSymbol(math, ams, rel, "\u21dd", "\\leadsto");
defineSymbol(math, ams, rel, "\u21db", "\\Rrightarrow", true);
defineSymbol(math, ams, rel, "\u21be", "\\restriction");
defineSymbol(math, main, textord, "\u2018", "`");
defineSymbol(math, main, textord, "$", "\\$");
defineSymbol(text, main, textord, "$", "\\$");
defineSymbol(text, main, textord, "$", "\\textdollar");
defineSymbol(math, main, textord, "%", "\\%");
defineSymbol(text, main, textord, "%", "\\%");
defineSymbol(math, main, textord, "_", "\\_");
defineSymbol(text, main, textord, "_", "\\_");
defineSymbol(text, main, textord, "_", "\\textunderscore");
defineSymbol(math, main, textord, "\u2220", "\\angle", true);
defineSymbol(math, main, textord, "\u221e", "\\infty", true);
defineSymbol(math, main, textord, "\u2032", "\\prime");
defineSymbol(math, main, textord, "\u25b3", "\\triangle");
defineSymbol(math, main, textord, "\u0393", "\\Gamma", true);
defineSymbol(math, main, textord, "\u0394", "\\Delta", true);
defineSymbol(math, main, textord, "\u0398", "\\Theta", true);
defineSymbol(math, main, textord, "\u039b", "\\Lambda", true);
defineSymbol(math, main, textord, "\u039e", "\\Xi", true);
defineSymbol(math, main, textord, "\u03a0", "\\Pi", true);
defineSymbol(math, main, textord, "\u03a3", "\\Sigma", true);
defineSymbol(math, main, textord, "\u03a5", "\\Upsilon", true);
defineSymbol(math, main, textord, "\u03a6", "\\Phi", true);
defineSymbol(math, main, textord, "\u03a8", "\\Psi", true);
defineSymbol(math, main, textord, "\u03a9", "\\Omega", true);
defineSymbol(math, main, textord, "A", "\u0391");
defineSymbol(math, main, textord, "B", "\u0392");
defineSymbol(math, main, textord, "E", "\u0395");
defineSymbol(math, main, textord, "Z", "\u0396");
defineSymbol(math, main, textord, "H", "\u0397");
defineSymbol(math, main, textord, "I", "\u0399");
defineSymbol(math, main, textord, "K", "\u039A");
defineSymbol(math, main, textord, "M", "\u039C");
defineSymbol(math, main, textord, "N", "\u039D");
defineSymbol(math, main, textord, "O", "\u039F");
defineSymbol(math, main, textord, "P", "\u03A1");
defineSymbol(math, main, textord, "T", "\u03A4");
defineSymbol(math, main, textord, "X", "\u03A7");
defineSymbol(math, main, textord, "\u00ac", "\\neg", true);
defineSymbol(math, main, textord, "\u00ac", "\\lnot");
defineSymbol(math, main, textord, "\u22a4", "\\top");
defineSymbol(math, main, textord, "\u22a5", "\\bot");
defineSymbol(math, main, textord, "\u2205", "\\emptyset");
defineSymbol(math, ams, textord, "\u2205", "\\varnothing");
defineSymbol(math, main, mathord, "\u03b1", "\\alpha", true);
defineSymbol(math, main, mathord, "\u03b2", "\\beta", true);
defineSymbol(math, main, mathord, "\u03b3", "\\gamma", true);
defineSymbol(math, main, mathord, "\u03b4", "\\delta", true);
defineSymbol(math, main, mathord, "\u03f5", "\\epsilon", true);
defineSymbol(math, main, mathord, "\u03b6", "\\zeta", true);
defineSymbol(math, main, mathord, "\u03b7", "\\eta", true);
defineSymbol(math, main, mathord, "\u03b8", "\\theta", true);
defineSymbol(math, main, mathord, "\u03b9", "\\iota", true);
defineSymbol(math, main, mathord, "\u03ba", "\\kappa", true);
defineSymbol(math, main, mathord, "\u03bb", "\\lambda", true);
defineSymbol(math, main, mathord, "\u03bc", "\\mu", true);
defineSymbol(math, main, mathord, "\u03bd", "\\nu", true);
defineSymbol(math, main, mathord, "\u03be", "\\xi", true);
defineSymbol(math, main, mathord, "\u03bf", "\\omicron", true);
defineSymbol(math, main, mathord, "\u03c0", "\\pi", true);
defineSymbol(math, main, mathord, "\u03c1", "\\rho", true);
defineSymbol(math, main, mathord, "\u03c3", "\\sigma", true);
defineSymbol(math, main, mathord, "\u03c4", "\\tau", true);
defineSymbol(math, main, mathord, "\u03c5", "\\upsilon", true);
defineSymbol(math, main, mathord, "\u03d5", "\\phi", true);
defineSymbol(math, main, mathord, "\u03c7", "\\chi", true);
defineSymbol(math, main, mathord, "\u03c8", "\\psi", true);
defineSymbol(math, main, mathord, "\u03c9", "\\omega", true);
defineSymbol(math, main, mathord, "\u03b5", "\\varepsilon", true);
defineSymbol(math, main, mathord, "\u03d1", "\\vartheta", true);
defineSymbol(math, main, mathord, "\u03d6", "\\varpi", true);
defineSymbol(math, main, mathord, "\u03f1", "\\varrho", true);
defineSymbol(math, main, mathord, "\u03c2", "\\varsigma", true);
defineSymbol(math, main, mathord, "\u03c6", "\\varphi", true);
defineSymbol(math, main, bin, "\u2217", "*", true);
defineSymbol(math, main, bin, "+", "+");
defineSymbol(math, main, bin, "\u2212", "-", true);
defineSymbol(math, main, bin, "\u22c5", "\\cdot", true);
defineSymbol(math, main, bin, "\u2218", "\\circ", true);
defineSymbol(math, main, bin, "\u00f7", "\\div", true);
defineSymbol(math, main, bin, "\u00b1", "\\pm", true);
defineSymbol(math, main, bin, "\u00d7", "\\times", true);
defineSymbol(math, main, bin, "\u2229", "\\cap", true);
defineSymbol(math, main, bin, "\u222a", "\\cup", true);
defineSymbol(math, main, bin, "\u2216", "\\setminus", true);
defineSymbol(math, main, bin, "\u2227", "\\land");
defineSymbol(math, main, bin, "\u2228", "\\lor");
defineSymbol(math, main, bin, "\u2227", "\\wedge", true);
defineSymbol(math, main, bin, "\u2228", "\\vee", true);
defineSymbol(math, main, textord, "\u221a", "\\surd");
defineSymbol(math, main, open, "\u27e8", "\\langle", true);
defineSymbol(math, main, open, "\u2223", "\\lvert");
defineSymbol(math, main, open, "\u2225", "\\lVert");
defineSymbol(math, main, close, "?", "?");
defineSymbol(math, main, close, "!", "!");
defineSymbol(math, main, close, "\u27e9", "\\rangle", true);
defineSymbol(math, main, close, "\u2223", "\\rvert");
defineSymbol(math, main, close, "\u2225", "\\rVert");
defineSymbol(math, main, rel, "=", "=");
defineSymbol(math, main, rel, ":", ":");
defineSymbol(math, main, rel, "\u2248", "\\approx", true);
defineSymbol(math, main, rel, "\u2245", "\\cong", true);
defineSymbol(math, main, rel, "\u2265", "\\ge");
defineSymbol(math, main, rel, "\u2265", "\\geq", true);
defineSymbol(math, main, rel, "\u2190", "\\gets");
defineSymbol(math, main, rel, ">", "\\gt", true);
defineSymbol(math, main, rel, "\u2208", "\\in", true);
defineSymbol(math, main, rel, "\ue020", "\\@not");
defineSymbol(math, main, rel, "\u2282", "\\subset", true);
defineSymbol(math, main, rel, "\u2283", "\\supset", true);
defineSymbol(math, main, rel, "\u2286", "\\subseteq", true);
defineSymbol(math, main, rel, "\u2287", "\\supseteq", true);
defineSymbol(math, ams, rel, "\u2288", "\\nsubseteq", true);
defineSymbol(math, ams, rel, "\u2289", "\\nsupseteq", true);
defineSymbol(math, main, rel, "\u22a8", "\\models");
defineSymbol(math, main, rel, "\u2190", "\\leftarrow", true);
defineSymbol(math, main, rel, "\u2264", "\\le");
defineSymbol(math, main, rel, "\u2264", "\\leq", true);
defineSymbol(math, main, rel, "<", "\\lt", true);
defineSymbol(math, main, rel, "\u2192", "\\rightarrow", true);
defineSymbol(math, main, rel, "\u2192", "\\to");
defineSymbol(math, ams, rel, "\u2271", "\\ngeq", true);
defineSymbol(math, ams, rel, "\u2270", "\\nleq", true);
defineSymbol(math, main, spacing, "\u00a0", "\\ ");
defineSymbol(math, main, spacing, "\u00a0", "\\space"); // Ref: LaTeX Source 2e: \DeclareRobustCommand{\nobreakspace}{%
defineSymbol(math, main, spacing, "\u00a0", "\\nobreakspace");
defineSymbol(text, main, spacing, "\u00a0", "\\ ");
defineSymbol(text, main, spacing, "\u00a0", " ");
defineSymbol(text, main, spacing, "\u00a0", "\\space");
defineSymbol(text, main, spacing, "\u00a0", "\\nobreakspace");
defineSymbol(math, main, spacing, null, "\\nobreak");
defineSymbol(math, main, spacing, null, "\\allowbreak");
defineSymbol(math, main, punct, ",", ",");
defineSymbol(math, main, punct, ";", ";");
defineSymbol(math, ams, bin, "\u22bc", "\\barwedge", true);
defineSymbol(math, ams, bin, "\u22bb", "\\veebar", true);
defineSymbol(math, main, bin, "\u2299", "\\odot", true);
defineSymbol(math, main, bin, "\u2295", "\\oplus", true);
defineSymbol(math, main, bin, "\u2297", "\\otimes", true);
defineSymbol(math, main, textord, "\u2202", "\\partial", true);
defineSymbol(math, main, bin, "\u2298", "\\oslash", true);
defineSymbol(math, ams, bin, "\u229a", "\\circledcirc", true);
defineSymbol(math, ams, bin, "\u22a1", "\\boxdot", true);
defineSymbol(math, main, bin, "\u25b3", "\\bigtriangleup");
defineSymbol(math, main, bin, "\u25bd", "\\bigtriangledown");
defineSymbol(math, main, bin, "\u2020", "\\dagger");
defineSymbol(math, main, bin, "\u22c4", "\\diamond");
defineSymbol(math, main, bin, "\u22c6", "\\star");
defineSymbol(math, main, bin, "\u25c3", "\\triangleleft");
defineSymbol(math, main, bin, "\u25b9", "\\triangleright");
defineSymbol(math, main, open, "{", "\\{");
defineSymbol(text, main, textord, "{", "\\{");
defineSymbol(text, main, textord, "{", "\\textbraceleft");
defineSymbol(math, main, close, "}", "\\}");
defineSymbol(text, main, textord, "}", "\\}");
defineSymbol(text, main, textord, "}", "\\textbraceright");
defineSymbol(math, main, open, "{", "\\lbrace");
defineSymbol(math, main, close, "}", "\\rbrace");
defineSymbol(math, main, open, "[", "\\lbrack", true);
defineSymbol(text, main, textord, "[", "\\lbrack", true);
defineSymbol(math, main, close, "]", "\\rbrack", true);
defineSymbol(text, main, textord, "]", "\\rbrack", true);
defineSymbol(math, main, open, "(", "\\lparen", true);
defineSymbol(math, main, close, ")", "\\rparen", true);
defineSymbol(text, main, textord, "<", "\\textless", true); // in T1 fontenc
defineSymbol(text, main, textord, ">", "\\textgreater", true); // in T1 fontenc
defineSymbol(math, main, open, "\u230a", "\\lfloor", true);
defineSymbol(math, main, close, "\u230b", "\\rfloor", true);
defineSymbol(math, main, open, "\u2308", "\\lceil", true);
defineSymbol(math, main, close, "\u2309", "\\rceil", true);
defineSymbol(math, main, textord, "\\", "\\backslash");
defineSymbol(math, main, textord, "\u2223", "|");
defineSymbol(math, main, textord, "\u2223", "\\vert");
defineSymbol(text, main, textord, "|", "\\textbar", true); // in T1 fontenc
defineSymbol(math, main, textord, "\u2225", "\\|");
defineSymbol(math, main, textord, "\u2225", "\\Vert");
defineSymbol(text, main, textord, "\u2225", "\\textbardbl");
defineSymbol(text, main, textord, "~", "\\textasciitilde");
defineSymbol(text, main, textord, "\\", "\\textbackslash");
defineSymbol(text, main, textord, "^", "\\textasciicircum");
defineSymbol(math, main, rel, "\u2191", "\\uparrow", true);
defineSymbol(math, main, rel, "\u21d1", "\\Uparrow", true);
defineSymbol(math, main, rel, "\u2193", "\\downarrow", true);
defineSymbol(math, main, rel, "\u21d3", "\\Downarrow", true);
defineSymbol(math, main, rel, "\u2195", "\\updownarrow", true);
defineSymbol(math, main, rel, "\u21d5", "\\Updownarrow", true);
defineSymbol(math, main, op, "\u2210", "\\coprod");
defineSymbol(math, main, op, "\u22c1", "\\bigvee");
defineSymbol(math, main, op, "\u22c0", "\\bigwedge");
defineSymbol(math, main, op, "\u2a04", "\\biguplus");
defineSymbol(math, main, op, "\u22c2", "\\bigcap");
defineSymbol(math, main, op, "\u22c3", "\\bigcup");
defineSymbol(math, main, op, "\u222b", "\\int");
defineSymbol(math, main, op, "\u222b", "\\intop");
defineSymbol(math, main, op, "\u222c", "\\iint");
defineSymbol(math, main, op, "\u222d", "\\iiint");
defineSymbol(math, main, op, "\u220f", "\\prod");
defineSymbol(math, main, op, "\u2211", "\\sum");
defineSymbol(math, main, op, "\u2a02", "\\bigotimes");
defineSymbol(math, main, op, "\u2a01", "\\bigoplus");
defineSymbol(math, main, op, "\u2a00", "\\bigodot");
defineSymbol(math, main, op, "\u222e", "\\oint");
defineSymbol(math, main, op, "\u222f", "\\oiint");
defineSymbol(math, main, op, "\u2230", "\\oiiint");
defineSymbol(math, main, op, "\u2a06", "\\bigsqcup");
defineSymbol(math, main, op, "\u222b", "\\smallint");
defineSymbol(text, main, inner, "\u2026", "\\textellipsis");
defineSymbol(math, main, inner, "\u2026", "\\mathellipsis");
defineSymbol(text, main, inner, "\u2026", "\\ldots", true);
defineSymbol(math, main, inner, "\u2026", "\\ldots", true);
defineSymbol(math, main, inner, "\u22ef", "\\@cdots", true);
defineSymbol(math, main, inner, "\u22f1", "\\ddots", true); // \vdots is a macro that uses one of these two symbols (with made-up names):
defineSymbol(math, main, textord, "\u22ee", "\\varvdots");
defineSymbol(text, main, textord, "\u22ee", "\\varvdots");
defineSymbol(math, main, accent, "\u02ca", "\\acute");
defineSymbol(math, main, accent, "\u02cb", "\\grave");
defineSymbol(math, main, accent, "\u00a8", "\\ddot");
defineSymbol(math, main, accent, "\u007e", "\\tilde");
defineSymbol(math, main, accent, "\u02c9", "\\bar");
defineSymbol(math, main, accent, "\u02d8", "\\breve");
defineSymbol(math, main, accent, "\u02c7", "\\check");
defineSymbol(math, main, accent, "\u005e", "\\hat");
defineSymbol(math, main, accent, "\u20d7", "\\vec");
defineSymbol(math, main, accent, "\u02d9", "\\dot");
defineSymbol(math, main, accent, "\u02da", "\\mathring"); // \imath and \jmath should be invariant to \mathrm, \mathbf, etc., so use PUA
defineSymbol(math, main, mathord, "\ue131", "\\@imath");
defineSymbol(math, main, mathord, "\ue237", "\\@jmath");
defineSymbol(math, main, textord, "\u0131", "\u0131");
defineSymbol(math, main, textord, "\u0237", "\u0237");
defineSymbol(text, main, textord, "\u0131", "\\i", true);
defineSymbol(text, main, textord, "\u0237", "\\j", true);
defineSymbol(text, main, textord, "\u00df", "\\ss", true);
defineSymbol(text, main, textord, "\u00e6", "\\ae", true);
defineSymbol(text, main, textord, "\u0153", "\\oe", true);
defineSymbol(text, main, textord, "\u00f8", "\\o", true);
defineSymbol(text, main, textord, "\u00c6", "\\AE", true);
defineSymbol(text, main, textord, "\u0152", "\\OE", true);
defineSymbol(text, main, textord, "\u00d8", "\\O", true);
defineSymbol(text, main, accent, "\u02ca", "\\'"); // acute
defineSymbol(text, main, accent, "\u02cb", "\\`"); // grave
defineSymbol(text, main, accent, "\u02c6", "\\^"); // circumflex
defineSymbol(text, main, accent, "\u02dc", "\\~"); // tilde
defineSymbol(text, main, accent, "\u02c9", "\\="); // macron
defineSymbol(text, main, accent, "\u02d8", "\\u"); // breve
defineSymbol(text, main, accent, "\u02d9", "\\."); // dot above
defineSymbol(text, main, accent, "\u00b8", "\\c"); // cedilla
defineSymbol(text, main, accent, "\u02da", "\\r"); // ring above
defineSymbol(text, main, accent, "\u02c7", "\\v"); // caron
defineSymbol(text, main, accent, "\u00a8", '\\"'); // diaeresis
defineSymbol(text, main, accent, "\u02dd", "\\H"); // double acute
defineSymbol(text, main, accent, "\u25ef", "\\textcircled"); // \bigcirc glyph
// These ligatures are detected and created in Parser.js's `formLigatures`.
var ligatures = {
    "--": true,
    "---": true,
    "``": true,
    "''": true
};
defineSymbol(text, main, textord, "\u2013", "--", true);
defineSymbol(text, main, textord, "\u2013", "\\textendash");
defineSymbol(text, main, textord, "\u2014", "---", true);
defineSymbol(text, main, textord, "\u2014", "\\textemdash");
defineSymbol(text, main, textord, "\u2018", "`", true);
defineSymbol(text, main, textord, "\u2018", "\\textquoteleft");
defineSymbol(text, main, textord, "\u2019", "'", true);
defineSymbol(text, main, textord, "\u2019", "\\textquoteright");
defineSymbol(text, main, textord, "\u201c", "``", true);
defineSymbol(text, main, textord, "\u201c", "\\textquotedblleft");
defineSymbol(text, main, textord, "\u201d", "''", true);
defineSymbol(text, main, textord, "\u201d", "\\textquotedblright"); //  \degree from gensymb package
defineSymbol(math, main, textord, "\u00b0", "\\degree", true);
defineSymbol(text, main, textord, "\u00b0", "\\degree"); // \textdegree from inputenc package
defineSymbol(text, main, textord, "\u00b0", "\\textdegree", true); // TODO: In LaTeX, \pounds can generate a different character in text and math
// mode, but among our fonts, only Main-Regular defines this character "163".
defineSymbol(math, main, textord, "\u00a3", "\\pounds");
defineSymbol(math, main, textord, "\u00a3", "\\mathsterling", true);
defineSymbol(text, main, textord, "\u00a3", "\\pounds");
defineSymbol(text, main, textord, "\u00a3", "\\textsterling", true);
defineSymbol(math, ams, textord, "\u2720", "\\maltese");
defineSymbol(text, ams, textord, "\u2720", "\\maltese"); // There are lots of symbols which are the same, so we add them in afterwards.
// All of these are textords in math mode
var mathTextSymbols = "0123456789/@.\"";
for(var i = 0; i < mathTextSymbols.length; i++){
    var ch = mathTextSymbols.charAt(i);
    defineSymbol(math, main, textord, ch, ch);
} // All of these are textords in text mode
var textSymbols = "0123456789!@*()-=+\";:?/.,";
for(var _i = 0; _i < textSymbols.length; _i++){
    var _ch = textSymbols.charAt(_i);
    defineSymbol(text, main, textord, _ch, _ch);
} // All of these are textords in text mode, and mathords in math mode
var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for(var _i2 = 0; _i2 < letters.length; _i2++){
    var _ch2 = letters.charAt(_i2);
    defineSymbol(math, main, mathord, _ch2, _ch2);
    defineSymbol(text, main, textord, _ch2, _ch2);
} // Blackboard bold and script letters in Unicode range
defineSymbol(math, ams, textord, "C", "\u2102"); // blackboard bold
defineSymbol(text, ams, textord, "C", "\u2102");
defineSymbol(math, ams, textord, "H", "\u210D");
defineSymbol(text, ams, textord, "H", "\u210D");
defineSymbol(math, ams, textord, "N", "\u2115");
defineSymbol(text, ams, textord, "N", "\u2115");
defineSymbol(math, ams, textord, "P", "\u2119");
defineSymbol(text, ams, textord, "P", "\u2119");
defineSymbol(math, ams, textord, "Q", "\u211A");
defineSymbol(text, ams, textord, "Q", "\u211A");
defineSymbol(math, ams, textord, "R", "\u211D");
defineSymbol(text, ams, textord, "R", "\u211D");
defineSymbol(math, ams, textord, "Z", "\u2124");
defineSymbol(text, ams, textord, "Z", "\u2124");
defineSymbol(math, main, mathord, "h", "\u210E"); // italic h, Planck constant
defineSymbol(text, main, mathord, "h", "\u210E"); // The next loop loads wide (surrogate pair) characters.
// We support some letters in the Unicode range U+1D400 to U+1D7FF,
// Mathematical Alphanumeric Symbols.
// Some editors do not deal well with wide characters. So don't write the
// string into this file. Instead, create the string from the surrogate pair.
var wideChar = "";
for(var _i3 = 0; _i3 < letters.length; _i3++){
    var _ch3 = letters.charAt(_i3); // The hex numbers in the next line are a surrogate pair.
    // 0xD835 is the high surrogate for all letters in the range we support.
    // 0xDC00 is the low surrogate for bold A.
    wideChar = String.fromCharCode(0xD835, 0xDC00 + _i3); // A-Z a-z bold
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDC34 + _i3); // A-Z a-z italic
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDC68 + _i3); // A-Z a-z bold italic
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDD04 + _i3); // A-Z a-z Fraktur
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDD6C + _i3); // A-Z a-z bold Fraktur
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDDA0 + _i3); // A-Z a-z sans-serif
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDDD4 + _i3); // A-Z a-z sans bold
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDE08 + _i3); // A-Z a-z sans italic
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDE70 + _i3); // A-Z a-z monospace
    defineSymbol(math, main, mathord, _ch3, wideChar);
    defineSymbol(text, main, textord, _ch3, wideChar);
    if (_i3 < 26) {
        // KaTeX fonts have only capital letters for blackboard bold and script.
        // See exception for k below.
        wideChar = String.fromCharCode(0xD835, 0xDD38 + _i3); // A-Z double struck
        defineSymbol(math, main, mathord, _ch3, wideChar);
        defineSymbol(text, main, textord, _ch3, wideChar);
        wideChar = String.fromCharCode(0xD835, 0xDC9C + _i3); // A-Z script
        defineSymbol(math, main, mathord, _ch3, wideChar);
        defineSymbol(text, main, textord, _ch3, wideChar);
    } // TODO: Add bold script when it is supported by a KaTeX font.
} // "k" is the only double struck lower case letter in the KaTeX fonts.
wideChar = String.fromCharCode(0xD835, 0xDD5C); // k double struck
defineSymbol(math, main, mathord, "k", wideChar);
defineSymbol(text, main, textord, "k", wideChar); // Next, some wide character numerals
for(var _i4 = 0; _i4 < 10; _i4++){
    var _ch4 = _i4.toString();
    wideChar = String.fromCharCode(0xD835, 0xDFCE + _i4); // 0-9 bold
    defineSymbol(math, main, mathord, _ch4, wideChar);
    defineSymbol(text, main, textord, _ch4, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDFE2 + _i4); // 0-9 sans serif
    defineSymbol(math, main, mathord, _ch4, wideChar);
    defineSymbol(text, main, textord, _ch4, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDFEC + _i4); // 0-9 bold sans
    defineSymbol(math, main, mathord, _ch4, wideChar);
    defineSymbol(text, main, textord, _ch4, wideChar);
    wideChar = String.fromCharCode(0xD835, 0xDFF6 + _i4); // 0-9 monospace
    defineSymbol(math, main, mathord, _ch4, wideChar);
    defineSymbol(text, main, textord, _ch4, wideChar);
} // We add these Latin-1 letters as symbols for backwards-compatibility,
// but they are not actually in the font, nor are they supported by the
// Unicode accent mechanism, so they fall back to Times font and look ugly.
// TODO(edemaine): Fix this.
var extraLatin = "\u00d0\u00de\u00fe";
for(var _i5 = 0; _i5 < extraLatin.length; _i5++){
    var _ch5 = extraLatin.charAt(_i5);
    defineSymbol(math, main, mathord, _ch5, _ch5);
    defineSymbol(text, main, textord, _ch5, _ch5);
}
/**
 * This file provides support for Unicode range U+1D400 to U+1D7FF,
 * Mathematical Alphanumeric Symbols.
 *
 * Function wideCharacterFont takes a wide character as input and returns
 * the font information necessary to render it properly.
 */ /**
 * Data below is from https://www.unicode.org/charts/PDF/U1D400.pdf
 * That document sorts characters into groups by font type, say bold or italic.
 *
 * In the arrays below, each subarray consists three elements:
 *      * The CSS class of that group when in math mode.
 *      * The CSS class of that group when in text mode.
 *      * The font name, so that KaTeX can get font metrics.
 */ var wideLatinLetterData = [
    [
        "mathbf",
        "textbf",
        "Main-Bold"
    ],
    [
        "mathbf",
        "textbf",
        "Main-Bold"
    ],
    [
        "mathnormal",
        "textit",
        "Math-Italic"
    ],
    [
        "mathnormal",
        "textit",
        "Math-Italic"
    ],
    [
        "boldsymbol",
        "boldsymbol",
        "Main-BoldItalic"
    ],
    [
        "boldsymbol",
        "boldsymbol",
        "Main-BoldItalic"
    ],
    // Map fancy A-Z letters to script, not calligraphic.
    // This aligns with unicode-math and math fonts (except Cambria Math).
    [
        "mathscr",
        "textscr",
        "Script-Regular"
    ],
    [
        "",
        "",
        ""
    ],
    [
        "",
        "",
        ""
    ],
    [
        "",
        "",
        ""
    ],
    [
        "mathfrak",
        "textfrak",
        "Fraktur-Regular"
    ],
    [
        "mathfrak",
        "textfrak",
        "Fraktur-Regular"
    ],
    [
        "mathbb",
        "textbb",
        "AMS-Regular"
    ],
    [
        "mathbb",
        "textbb",
        "AMS-Regular"
    ],
    // Note that we are using a bold font, but font metrics for regular Fraktur.
    [
        "mathboldfrak",
        "textboldfrak",
        "Fraktur-Regular"
    ],
    [
        "mathboldfrak",
        "textboldfrak",
        "Fraktur-Regular"
    ],
    [
        "mathsf",
        "textsf",
        "SansSerif-Regular"
    ],
    [
        "mathsf",
        "textsf",
        "SansSerif-Regular"
    ],
    [
        "mathboldsf",
        "textboldsf",
        "SansSerif-Bold"
    ],
    [
        "mathboldsf",
        "textboldsf",
        "SansSerif-Bold"
    ],
    [
        "mathitsf",
        "textitsf",
        "SansSerif-Italic"
    ],
    [
        "mathitsf",
        "textitsf",
        "SansSerif-Italic"
    ],
    [
        "",
        "",
        ""
    ],
    [
        "",
        "",
        ""
    ],
    [
        "mathtt",
        "texttt",
        "Typewriter-Regular"
    ],
    [
        "mathtt",
        "texttt",
        "Typewriter-Regular"
    ] // a-z monospace
];
var wideNumeralData = [
    [
        "mathbf",
        "textbf",
        "Main-Bold"
    ],
    [
        "",
        "",
        ""
    ],
    [
        "mathsf",
        "textsf",
        "SansSerif-Regular"
    ],
    [
        "mathboldsf",
        "textboldsf",
        "SansSerif-Bold"
    ],
    [
        "mathtt",
        "texttt",
        "Typewriter-Regular"
    ] // 0-9 monospace
];
var wideCharacterFont = function wideCharacterFont(wideChar, mode) {
    // IE doesn't support codePointAt(). So work with the surrogate pair.
    var H = wideChar.charCodeAt(0); // high surrogate
    var L = wideChar.charCodeAt(1); // low surrogate
    var codePoint = (H - 0xD800) * 0x400 + (L - 0xDC00) + 0x10000;
    var j = mode === "math" ? 0 : 1; // column index for CSS class.
    if (0x1D400 <= codePoint && codePoint < 0x1D6A4) {
        // wideLatinLetterData contains exactly 26 chars on each row.
        // So we can calculate the relevant row. No traverse necessary.
        var i = Math.floor((codePoint - 0x1D400) / 26);
        return [
            wideLatinLetterData[i][2],
            wideLatinLetterData[i][j]
        ];
    } else if (0x1D7CE <= codePoint && codePoint <= 0x1D7FF) {
        // Numerals, ten per row.
        var _i = Math.floor((codePoint - 0x1D7CE) / 10);
        return [
            wideNumeralData[_i][2],
            wideNumeralData[_i][j]
        ];
    } else if (codePoint === 0x1D6A5 || codePoint === 0x1D6A6) // dotless i or j
    return [
        wideLatinLetterData[0][2],
        wideLatinLetterData[0][j]
    ];
    else if (0x1D6A6 < codePoint && codePoint < 0x1D7CE) // Greek letters. Not supported, yet.
    return [
        "",
        ""
    ];
    else // We don't support any wide characters outside 1D400–1D7FF.
    throw new ParseError("Unsupported character: " + wideChar);
};
/* eslint no-console:0 */ /**
 * Looks up the given symbol in fontMetrics, after applying any symbol
 * replacements defined in symbol.js
 */ var lookupSymbol = function lookupSymbol(value, fontName, mode) {
    // Replace the value with its replaced value from symbol.js
    if (symbols[mode][value] && symbols[mode][value].replace) value = symbols[mode][value].replace;
    return {
        value: value,
        metrics: getCharacterMetrics(value, fontName, mode)
    };
};
/**
 * Makes a symbolNode after translation via the list of symbols in symbols.js.
 * Correctly pulls out metrics for the character, and optionally takes a list of
 * classes to be attached to the node.
 *
 * TODO: make argument order closer to makeSpan
 * TODO: add a separate argument for math class (e.g. `mop`, `mbin`), which
 * should if present come first in `classes`.
 * TODO(#953): Make `options` mandatory and always pass it in.
 */ var makeSymbol = function makeSymbol(value, fontName, mode, options, classes) {
    var lookup = lookupSymbol(value, fontName, mode);
    var metrics = lookup.metrics;
    value = lookup.value;
    var symbolNode;
    if (metrics) {
        var italic = metrics.italic;
        if (mode === "text" || options && options.font === "mathit") italic = 0;
        symbolNode = new SymbolNode(value, metrics.height, metrics.depth, italic, metrics.skew, metrics.width, classes);
    } else {
        // TODO(emily): Figure out a good way to only print this in development
        typeof console !== "undefined" && console.warn("No character metrics " + ("for '" + value + "' in style '" + fontName + "' and mode '" + mode + "'"));
        symbolNode = new SymbolNode(value, 0, 0, 0, 0, 0, classes);
    }
    if (options) {
        symbolNode.maxFontSize = options.sizeMultiplier;
        if (options.style.isTight()) symbolNode.classes.push("mtight");
        var color = options.getColor();
        if (color) symbolNode.style.color = color;
    }
    return symbolNode;
};
/**
 * Makes a symbol in Main-Regular or AMS-Regular.
 * Used for rel, bin, open, close, inner, and punct.
 */ var mathsym = function mathsym(value, mode, options, classes) {
    if (classes === void 0) classes = [];
    // Decide what font to render the symbol in by its entry in the symbols
    // table.
    // Have a special case for when the value = \ because the \ is used as a
    // textord in unsupported command errors but cannot be parsed as a regular
    // text ordinal and is therefore not present as a symbol in the symbols
    // table for text, as well as a special case for boldsymbol because it
    // can be used for bold + and -
    if (options.font === "boldsymbol" && lookupSymbol(value, "Main-Bold", mode).metrics) return makeSymbol(value, "Main-Bold", mode, options, classes.concat([
        "mathbf"
    ]));
    else if (value === "\\" || symbols[mode][value].font === "main") return makeSymbol(value, "Main-Regular", mode, options, classes);
    else return makeSymbol(value, "AMS-Regular", mode, options, classes.concat([
        "amsrm"
    ]));
};
/**
 * Determines which of the two font names (Main-Bold and Math-BoldItalic) and
 * corresponding style tags (mathbf or boldsymbol) to use for font "boldsymbol",
 * depending on the symbol.  Use this function instead of fontMap for font
 * "boldsymbol".
 */ var boldsymbol = function boldsymbol(value, mode, options, classes, type) {
    if (type !== "textord" && lookupSymbol(value, "Math-BoldItalic", mode).metrics) return {
        fontName: "Math-BoldItalic",
        fontClass: "boldsymbol"
    };
    else // Some glyphs do not exist in Math-BoldItalic so we need to use
    // Main-Bold instead.
    return {
        fontName: "Main-Bold",
        fontClass: "mathbf"
    };
};
/**
 * Makes either a mathord or textord in the correct font and color.
 */ var makeOrd = function makeOrd(group, options, type) {
    var mode = group.mode;
    var text = group.text;
    var classes = [
        "mord"
    ]; // Math mode or Old font (i.e. \rm)
    var isFont = mode === "math" || mode === "text" && options.font;
    var fontOrFamily = isFont ? options.font : options.fontFamily;
    var wideFontName = "";
    var wideFontClass = "";
    if (text.charCodeAt(0) === 0xD835) [wideFontName, wideFontClass] = wideCharacterFont(text, mode);
    if (wideFontName.length > 0) // surrogate pairs get special treatment
    return makeSymbol(text, wideFontName, mode, options, classes.concat(wideFontClass));
    else if (fontOrFamily) {
        var fontName;
        var fontClasses;
        if (fontOrFamily === "boldsymbol") {
            var fontData = boldsymbol(text, mode, options, classes, type);
            fontName = fontData.fontName;
            fontClasses = [
                fontData.fontClass
            ];
        } else if (isFont) {
            fontName = fontMap[fontOrFamily].fontName;
            fontClasses = [
                fontOrFamily
            ];
        } else {
            fontName = retrieveTextFontName(fontOrFamily, options.fontWeight, options.fontShape);
            fontClasses = [
                fontOrFamily,
                options.fontWeight,
                options.fontShape
            ];
        }
        if (lookupSymbol(text, fontName, mode).metrics) return makeSymbol(text, fontName, mode, options, classes.concat(fontClasses));
        else if (ligatures.hasOwnProperty(text) && fontName.slice(0, 10) === "Typewriter") {
            // Deconstruct ligatures in monospace fonts (\texttt, \tt).
            var parts = [];
            for(var i = 0; i < text.length; i++)parts.push(makeSymbol(text[i], fontName, mode, options, classes.concat(fontClasses)));
            return makeFragment(parts);
        }
    } // Makes a symbol in the default font for mathords and textords.
    if (type === "mathord") return makeSymbol(text, "Math-Italic", mode, options, classes.concat([
        "mathnormal"
    ]));
    else if (type === "textord") {
        var font = symbols[mode][text] && symbols[mode][text].font;
        if (font === "ams") {
            var _fontName = retrieveTextFontName("amsrm", options.fontWeight, options.fontShape);
            return makeSymbol(text, _fontName, mode, options, classes.concat("amsrm", options.fontWeight, options.fontShape));
        } else if (font === "main" || !font) {
            var _fontName2 = retrieveTextFontName("textrm", options.fontWeight, options.fontShape);
            return makeSymbol(text, _fontName2, mode, options, classes.concat(options.fontWeight, options.fontShape));
        } else {
            // fonts added by plugins
            var _fontName3 = retrieveTextFontName(font, options.fontWeight, options.fontShape); // We add font name as a css class
            return makeSymbol(text, _fontName3, mode, options, classes.concat(_fontName3, options.fontWeight, options.fontShape));
        }
    } else throw new Error("unexpected type: " + type + " in makeOrd");
};
/**
 * Returns true if subsequent symbolNodes have the same classes, skew, maxFont,
 * and styles.
 */ var canCombine = (prev, next)=>{
    if (createClass(prev.classes) !== createClass(next.classes) || prev.skew !== next.skew || prev.maxFontSize !== next.maxFontSize) return false;
     // If prev and next both are just "mbin"s or "mord"s we don't combine them
    // so that the proper spacing can be preserved.
    if (prev.classes.length === 1) {
        var cls = prev.classes[0];
        if (cls === "mbin" || cls === "mord") return false;
    }
    for(var style in prev.style){
        if (prev.style.hasOwnProperty(style) && prev.style[style] !== next.style[style]) return false;
    }
    for(var _style in next.style){
        if (next.style.hasOwnProperty(_style) && prev.style[_style] !== next.style[_style]) return false;
    }
    return true;
};
/**
 * Combine consecutive domTree.symbolNodes into a single symbolNode.
 * Note: this function mutates the argument.
 */ var tryCombineChars = (chars)=>{
    for(var i = 0; i < chars.length - 1; i++){
        var prev = chars[i];
        var next = chars[i + 1];
        if (prev instanceof SymbolNode && next instanceof SymbolNode && canCombine(prev, next)) {
            prev.text += next.text;
            prev.height = Math.max(prev.height, next.height);
            prev.depth = Math.max(prev.depth, next.depth); // Use the last character's italic correction since we use
            // it to add padding to the right of the span created from
            // the combined characters.
            prev.italic = next.italic;
            chars.splice(i + 1, 1);
            i--;
        }
    }
    return chars;
};
/**
 * Calculate the height, depth, and maxFontSize of an element based on its
 * children.
 */ var sizeElementFromChildren = function sizeElementFromChildren(elem) {
    var height = 0;
    var depth = 0;
    var maxFontSize = 0;
    for(var i = 0; i < elem.children.length; i++){
        var child = elem.children[i];
        if (child.height > height) height = child.height;
        if (child.depth > depth) depth = child.depth;
        if (child.maxFontSize > maxFontSize) maxFontSize = child.maxFontSize;
    }
    elem.height = height;
    elem.depth = depth;
    elem.maxFontSize = maxFontSize;
};
/**
 * Makes a span with the given list of classes, list of children, and options.
 *
 * TODO(#953): Ensure that `options` is always provided (currently some call
 * sites don't pass it) and make the type below mandatory.
 * TODO: add a separate argument for math class (e.g. `mop`, `mbin`), which
 * should if present come first in `classes`.
 */ var makeSpan$2 = function makeSpan(classes, children, options, style) {
    var span = new Span(classes, children, options, style);
    sizeElementFromChildren(span);
    return span;
}; // SVG one is simpler -- doesn't require height, depth, max-font setting.
// This is also a separate method for typesafety.
var makeSvgSpan = (classes, children, options, style)=>new Span(classes, children, options, style);
var makeLineSpan = function makeLineSpan(className, options, thickness) {
    var line = makeSpan$2([
        className
    ], [], options);
    line.height = Math.max(thickness || options.fontMetrics().defaultRuleThickness, options.minRuleThickness);
    line.style.borderBottomWidth = makeEm(line.height);
    line.maxFontSize = 1.0;
    return line;
};
/**
 * Makes an anchor with the given href, list of classes, list of children,
 * and options.
 */ var makeAnchor = function makeAnchor(href, classes, children, options) {
    var anchor = new Anchor(href, classes, children, options);
    sizeElementFromChildren(anchor);
    return anchor;
};
/**
 * Makes a document fragment with the given list of children.
 */ var makeFragment = function makeFragment(children) {
    var fragment = new DocumentFragment(children);
    sizeElementFromChildren(fragment);
    return fragment;
};
/**
 * Wraps group in a span if it's a document fragment, allowing to apply classes
 * and styles
 */ var wrapFragment = function wrapFragment(group, options) {
    if (group instanceof DocumentFragment) return makeSpan$2([], [
        group
    ], options);
    return group;
}; // These are exact object types to catch typos in the names of the optional fields.
// Computes the updated `children` list and the overall depth.
//
// This helper function for makeVList makes it easier to enforce type safety by
// allowing early exits (returns) in the logic.
var getVListChildrenAndDepth = function getVListChildrenAndDepth(params) {
    if (params.positionType === "individualShift") {
        var oldChildren = params.children;
        var children = [
            oldChildren[0]
        ]; // Add in kerns to the list of params.children to get each element to be
        // shifted to the correct specified shift
        var _depth = -oldChildren[0].shift - oldChildren[0].elem.depth;
        var currPos = _depth;
        for(var i = 1; i < oldChildren.length; i++){
            var diff = -oldChildren[i].shift - currPos - oldChildren[i].elem.depth;
            var size = diff - (oldChildren[i - 1].elem.height + oldChildren[i - 1].elem.depth);
            currPos = currPos + diff;
            children.push({
                type: "kern",
                size
            });
            children.push(oldChildren[i]);
        }
        return {
            children,
            depth: _depth
        };
    }
    var depth;
    if (params.positionType === "top") {
        // We always start at the bottom, so calculate the bottom by adding up
        // all the sizes
        var bottom = params.positionData;
        for(var _i = 0; _i < params.children.length; _i++){
            var child = params.children[_i];
            bottom -= child.type === "kern" ? child.size : child.elem.height + child.elem.depth;
        }
        depth = bottom;
    } else if (params.positionType === "bottom") depth = -params.positionData;
    else {
        var firstChild = params.children[0];
        if (firstChild.type !== "elem") throw new Error('First child must have type "elem".');
        if (params.positionType === "shift") depth = -firstChild.elem.depth - params.positionData;
        else if (params.positionType === "firstBaseline") depth = -firstChild.elem.depth;
        else throw new Error("Invalid positionType " + params.positionType + ".");
    }
    return {
        children: params.children,
        depth
    };
};
/**
 * Makes a vertical list by stacking elements and kerns on top of each other.
 * Allows for many different ways of specifying the positioning method.
 *
 * See VListParam documentation above.
 */ var makeVList = function makeVList(params, options) {
    var { children, depth } = getVListChildrenAndDepth(params); // Create a strut that is taller than any list item. The strut is added to
    // each item, where it will determine the item's baseline. Since it has
    // `overflow:hidden`, the strut's top edge will sit on the item's line box's
    // top edge and the strut's bottom edge will sit on the item's baseline,
    // with no additional line-height spacing. This allows the item baseline to
    // be positioned precisely without worrying about font ascent and
    // line-height.
    var pstrutSize = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if (child.type === "elem") {
            var elem = child.elem;
            pstrutSize = Math.max(pstrutSize, elem.maxFontSize, elem.height);
        }
    }
    pstrutSize += 2;
    var pstrut = makeSpan$2([
        "pstrut"
    ], []);
    pstrut.style.height = makeEm(pstrutSize); // Create a new list of actual children at the correct offsets
    var realChildren = [];
    var minPos = depth;
    var maxPos = depth;
    var currPos = depth;
    for(var _i2 = 0; _i2 < children.length; _i2++){
        var _child = children[_i2];
        if (_child.type === "kern") currPos += _child.size;
        else {
            var _elem = _child.elem;
            var classes = _child.wrapperClasses || [];
            var style = _child.wrapperStyle || {};
            var childWrap = makeSpan$2(classes, [
                pstrut,
                _elem
            ], undefined, style);
            childWrap.style.top = makeEm(-pstrutSize - currPos - _elem.depth);
            if (_child.marginLeft) childWrap.style.marginLeft = _child.marginLeft;
            if (_child.marginRight) childWrap.style.marginRight = _child.marginRight;
            realChildren.push(childWrap);
            currPos += _elem.height + _elem.depth;
        }
        minPos = Math.min(minPos, currPos);
        maxPos = Math.max(maxPos, currPos);
    } // The vlist contents go in a table-cell with `vertical-align:bottom`.
    // This cell's bottom edge will determine the containing table's baseline
    // without overly expanding the containing line-box.
    var vlist = makeSpan$2([
        "vlist"
    ], realChildren);
    vlist.style.height = makeEm(maxPos); // A second row is used if necessary to represent the vlist's depth.
    var rows;
    if (minPos < 0) {
        // We will define depth in an empty span with display: table-cell.
        // It should render with the height that we define. But Chrome, in
        // contenteditable mode only, treats that span as if it contains some
        // text content. And that min-height over-rides our desired height.
        // So we put another empty span inside the depth strut span.
        var emptySpan = makeSpan$2([], []);
        var depthStrut = makeSpan$2([
            "vlist"
        ], [
            emptySpan
        ]);
        depthStrut.style.height = makeEm(-minPos); // Safari wants the first row to have inline content; otherwise it
        // puts the bottom of the *second* row on the baseline.
        var topStrut = makeSpan$2([
            "vlist-s"
        ], [
            new SymbolNode("\u200b")
        ]);
        rows = [
            makeSpan$2([
                "vlist-r"
            ], [
                vlist,
                topStrut
            ]),
            makeSpan$2([
                "vlist-r"
            ], [
                depthStrut
            ])
        ];
    } else rows = [
        makeSpan$2([
            "vlist-r"
        ], [
            vlist
        ])
    ];
    var vtable = makeSpan$2([
        "vlist-t"
    ], rows);
    if (rows.length === 2) vtable.classes.push("vlist-t2");
    vtable.height = maxPos;
    vtable.depth = -minPos;
    return vtable;
}; // Glue is a concept from TeX which is a flexible space between elements in
// either a vertical or horizontal list. In KaTeX, at least for now, it's
// static space between elements in a horizontal layout.
var makeGlue = (measurement, options)=>{
    // Make an empty span for the space
    var rule = makeSpan$2([
        "mspace"
    ], [], options);
    var size = calculateSize(measurement, options);
    rule.style.marginRight = makeEm(size);
    return rule;
}; // Takes font options, and returns the appropriate fontLookup name
var retrieveTextFontName = function retrieveTextFontName(fontFamily, fontWeight, fontShape) {
    var baseFontName = "";
    switch(fontFamily){
        case "amsrm":
            baseFontName = "AMS";
            break;
        case "textrm":
            baseFontName = "Main";
            break;
        case "textsf":
            baseFontName = "SansSerif";
            break;
        case "texttt":
            baseFontName = "Typewriter";
            break;
        default:
            baseFontName = fontFamily;
    }
    var fontStylesName;
    if (fontWeight === "textbf" && fontShape === "textit") fontStylesName = "BoldItalic";
    else if (fontWeight === "textbf") fontStylesName = "Bold";
    else if (fontWeight === "textit") fontStylesName = "Italic";
    else fontStylesName = "Regular";
    return baseFontName + "-" + fontStylesName;
};
/**
 * Maps TeX font commands to objects containing:
 * - variant: string used for "mathvariant" attribute in buildMathML.js
 * - fontName: the "style" parameter to fontMetrics.getCharacterMetrics
 */ // A map between tex font commands an MathML mathvariant attribute values
var fontMap = {
    // styles
    "mathbf": {
        variant: "bold",
        fontName: "Main-Bold"
    },
    "mathrm": {
        variant: "normal",
        fontName: "Main-Regular"
    },
    "textit": {
        variant: "italic",
        fontName: "Main-Italic"
    },
    "mathit": {
        variant: "italic",
        fontName: "Main-Italic"
    },
    "mathnormal": {
        variant: "italic",
        fontName: "Math-Italic"
    },
    "mathsfit": {
        variant: "sans-serif-italic",
        fontName: "SansSerif-Italic"
    },
    // "boldsymbol" is missing because they require the use of multiple fonts:
    // Math-BoldItalic and Main-Bold.  This is handled by a special case in
    // makeOrd which ends up calling boldsymbol.
    // families
    "mathbb": {
        variant: "double-struck",
        fontName: "AMS-Regular"
    },
    "mathcal": {
        variant: "script",
        fontName: "Caligraphic-Regular"
    },
    "mathfrak": {
        variant: "fraktur",
        fontName: "Fraktur-Regular"
    },
    "mathscr": {
        variant: "script",
        fontName: "Script-Regular"
    },
    "mathsf": {
        variant: "sans-serif",
        fontName: "SansSerif-Regular"
    },
    "mathtt": {
        variant: "monospace",
        fontName: "Typewriter-Regular"
    }
};
var svgData = {
    //   path, width, height
    vec: [
        "vec",
        0.471,
        0.714
    ],
    // values from the font glyph
    oiintSize1: [
        "oiintSize1",
        0.957,
        0.499
    ],
    // oval to overlay the integrand
    oiintSize2: [
        "oiintSize2",
        1.472,
        0.659
    ],
    oiiintSize1: [
        "oiiintSize1",
        1.304,
        0.499
    ],
    oiiintSize2: [
        "oiiintSize2",
        1.98,
        0.659
    ]
};
var staticSvg = function staticSvg(value, options) {
    // Create a span with inline SVG for the element.
    var [pathName, width, height] = svgData[value];
    var path = new PathNode(pathName);
    var svgNode = new SvgNode([
        path
    ], {
        "width": makeEm(width),
        "height": makeEm(height),
        // Override CSS rule `.katex svg { width: 100% }`
        "style": "width:" + makeEm(width),
        "viewBox": "0 0 " + 1000 * width + " " + 1000 * height,
        "preserveAspectRatio": "xMinYMin"
    });
    var span = makeSvgSpan([
        "overlay"
    ], [
        svgNode
    ], options);
    span.height = height;
    span.style.height = makeEm(height);
    span.style.width = makeEm(width);
    return span;
};
var buildCommon = {
    fontMap,
    makeSymbol,
    mathsym,
    makeSpan: makeSpan$2,
    makeSvgSpan,
    makeLineSpan,
    makeAnchor,
    makeFragment,
    wrapFragment,
    makeVList,
    makeOrd,
    makeGlue,
    staticSvg,
    svgData,
    tryCombineChars
};
/**
 * Describes spaces between different classes of atoms.
 */ var thinspace = {
    number: 3,
    unit: "mu"
};
var mediumspace = {
    number: 4,
    unit: "mu"
};
var thickspace = {
    number: 5,
    unit: "mu"
}; // Making the type below exact with all optional fields doesn't work due to
// - https://github.com/facebook/flow/issues/4582
// - https://github.com/facebook/flow/issues/5688
// However, since *all* fields are optional, $Shape<> works as suggested in 5688
// above.
// Spacing relationships for display and text styles
var spacings = {
    mord: {
        mop: thinspace,
        mbin: mediumspace,
        mrel: thickspace,
        minner: thinspace
    },
    mop: {
        mord: thinspace,
        mop: thinspace,
        mrel: thickspace,
        minner: thinspace
    },
    mbin: {
        mord: mediumspace,
        mop: mediumspace,
        mopen: mediumspace,
        minner: mediumspace
    },
    mrel: {
        mord: thickspace,
        mop: thickspace,
        mopen: thickspace,
        minner: thickspace
    },
    mopen: {},
    mclose: {
        mop: thinspace,
        mbin: mediumspace,
        mrel: thickspace,
        minner: thinspace
    },
    mpunct: {
        mord: thinspace,
        mop: thinspace,
        mrel: thickspace,
        mopen: thinspace,
        mclose: thinspace,
        mpunct: thinspace,
        minner: thinspace
    },
    minner: {
        mord: thinspace,
        mop: thinspace,
        mbin: mediumspace,
        mrel: thickspace,
        mopen: thinspace,
        mpunct: thinspace,
        minner: thinspace
    }
}; // Spacing relationships for script and scriptscript styles
var tightSpacings = {
    mord: {
        mop: thinspace
    },
    mop: {
        mord: thinspace,
        mop: thinspace
    },
    mbin: {},
    mrel: {},
    mopen: {},
    mclose: {
        mop: thinspace
    },
    mpunct: {},
    minner: {
        mop: thinspace
    }
};
/** Context provided to function handlers for error messages. */ // Note: reverse the order of the return type union will cause a flow error.
// See https://github.com/facebook/flow/issues/3663.
// More general version of `HtmlBuilder` for nodes (e.g. \sum, accent types)
// whose presence impacts super/subscripting. In this case, ParseNode<"supsub">
// delegates its HTML building to the HtmlBuilder corresponding to these nodes.
/**
 * Final function spec for use at parse time.
 * This is almost identical to `FunctionPropSpec`, except it
 * 1. includes the function handler, and
 * 2. requires all arguments except argTypes.
 * It is generated by `defineFunction()` below.
 */ /**
 * All registered functions.
 * `functions.js` just exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary.
 */ var _functions = {};
/**
 * All HTML builders. Should be only used in the `define*` and the `build*ML`
 * functions.
 */ var _htmlGroupBuilders = {};
/**
 * All MathML builders. Should be only used in the `define*` and the `build*ML`
 * functions.
 */ var _mathmlGroupBuilders = {};
function defineFunction(_ref) {
    var { type, names, props, handler, htmlBuilder, mathmlBuilder } = _ref;
    // Set default values of functions
    var data = {
        type,
        numArgs: props.numArgs,
        argTypes: props.argTypes,
        allowedInArgument: !!props.allowedInArgument,
        allowedInText: !!props.allowedInText,
        allowedInMath: props.allowedInMath === undefined ? true : props.allowedInMath,
        numOptionalArgs: props.numOptionalArgs || 0,
        infix: !!props.infix,
        primitive: !!props.primitive,
        handler: handler
    };
    for(var i = 0; i < names.length; ++i)_functions[names[i]] = data;
    if (type) {
        if (htmlBuilder) _htmlGroupBuilders[type] = htmlBuilder;
        if (mathmlBuilder) _mathmlGroupBuilders[type] = mathmlBuilder;
    }
}
/**
 * Use this to register only the HTML and MathML builders for a function (e.g.
 * if the function's ParseNode is generated in Parser.js rather than via a
 * stand-alone handler provided to `defineFunction`).
 */ function defineFunctionBuilders(_ref2) {
    var { type, htmlBuilder, mathmlBuilder } = _ref2;
    defineFunction({
        type,
        names: [],
        props: {
            numArgs: 0
        },
        handler () {
            throw new Error('Should never be called.');
        },
        htmlBuilder,
        mathmlBuilder
    });
}
var normalizeArgument = function normalizeArgument(arg) {
    return arg.type === "ordgroup" && arg.body.length === 1 ? arg.body[0] : arg;
}; // Since the corresponding buildHTML/buildMathML function expects a
// list of elements, we normalize for different kinds of arguments
var ordargument = function ordargument(arg) {
    return arg.type === "ordgroup" ? arg.body : [
        arg
    ];
};
/**
 * This file does the main work of building a domTree structure from a parse
 * tree. The entry point is the `buildHTML` function, which takes a parse tree.
 * Then, the buildExpression, buildGroup, and various groupBuilders functions
 * are called, to produce a final HTML tree.
 */ var makeSpan$1 = buildCommon.makeSpan; // Binary atoms (first class `mbin`) change into ordinary atoms (`mord`)
// depending on their surroundings. See TeXbook pg. 442-446, Rules 5 and 6,
// and the text before Rule 19.
var binLeftCanceller = [
    "leftmost",
    "mbin",
    "mopen",
    "mrel",
    "mop",
    "mpunct"
];
var binRightCanceller = [
    "rightmost",
    "mrel",
    "mclose",
    "mpunct"
];
var styleMap$1 = {
    "display": Style$1.DISPLAY,
    "text": Style$1.TEXT,
    "script": Style$1.SCRIPT,
    "scriptscript": Style$1.SCRIPTSCRIPT
};
var DomEnum = {
    mord: "mord",
    mop: "mop",
    mbin: "mbin",
    mrel: "mrel",
    mopen: "mopen",
    mclose: "mclose",
    mpunct: "mpunct",
    minner: "minner"
};
/**
 * Take a list of nodes, build them in order, and return a list of the built
 * nodes. documentFragments are flattened into their contents, so the
 * returned list contains no fragments. `isRealGroup` is true if `expression`
 * is a real group (no atoms will be added on either side), as opposed to
 * a partial group (e.g. one created by \color). `surrounding` is an array
 * consisting type of nodes that will be added to the left and right.
 */ var buildExpression$1 = function buildExpression(expression, options, isRealGroup, surrounding) {
    if (surrounding === void 0) surrounding = [
        null,
        null
    ];
    // Parse expressions into `groups`.
    var groups = [];
    for(var i = 0; i < expression.length; i++){
        var output = buildGroup$1(expression[i], options);
        if (output instanceof DocumentFragment) {
            var children = output.children;
            groups.push(...children);
        } else groups.push(output);
    } // Combine consecutive domTree.symbolNodes into a single symbolNode.
    buildCommon.tryCombineChars(groups); // If `expression` is a partial group, let the parent handle spacings
    // to avoid processing groups multiple times.
    if (!isRealGroup) return groups;
    var glueOptions = options;
    if (expression.length === 1) {
        var node = expression[0];
        if (node.type === "sizing") glueOptions = options.havingSize(node.size);
        else if (node.type === "styling") glueOptions = options.havingStyle(styleMap$1[node.style]);
    } // Dummy spans for determining spacings between surrounding atoms.
    // If `expression` has no atoms on the left or right, class "leftmost"
    // or "rightmost", respectively, is used to indicate it.
    var dummyPrev = makeSpan$1([
        surrounding[0] || "leftmost"
    ], [], options);
    var dummyNext = makeSpan$1([
        surrounding[1] || "rightmost"
    ], [], options); // TODO: These code assumes that a node's math class is the first element
    // of its `classes` array. A later cleanup should ensure this, for
    // instance by changing the signature of `makeSpan`.
    // Before determining what spaces to insert, perform bin cancellation.
    // Binary operators change to ordinary symbols in some contexts.
    var isRoot = isRealGroup === "root";
    traverseNonSpaceNodes(groups, (node, prev)=>{
        var prevType = prev.classes[0];
        var type = node.classes[0];
        if (prevType === "mbin" && binRightCanceller.includes(type)) prev.classes[0] = "mord";
        else if (type === "mbin" && binLeftCanceller.includes(prevType)) node.classes[0] = "mord";
    }, {
        node: dummyPrev
    }, dummyNext, isRoot);
    traverseNonSpaceNodes(groups, (node, prev)=>{
        var prevType = getTypeOfDomTree(prev);
        var type = getTypeOfDomTree(node); // 'mtight' indicates that the node is script or scriptscript style.
        var space = prevType && type ? node.hasClass("mtight") ? tightSpacings[prevType][type] : spacings[prevType][type] : null;
        if (space) // Insert glue (spacing) after the `prev`.
        return buildCommon.makeGlue(space, glueOptions);
    }, {
        node: dummyPrev
    }, dummyNext, isRoot);
    return groups;
}; // Depth-first traverse non-space `nodes`, calling `callback` with the current and
// previous node as arguments, optionally returning a node to insert after the
// previous node. `prev` is an object with the previous node and `insertAfter`
// function to insert after it. `next` is a node that will be added to the right.
// Used for bin cancellation and inserting spacings.
var traverseNonSpaceNodes = function traverseNonSpaceNodes(nodes, callback, prev, next, isRoot) {
    if (next) // temporarily append the right node, if exists
    nodes.push(next);
    var i = 0;
    for(; i < nodes.length; i++){
        var node = nodes[i];
        var partialGroup = checkPartialGroup(node);
        if (partialGroup) {
            // Recursive DFS
            // $FlowFixMe: make nodes a $ReadOnlyArray by returning a new array
            traverseNonSpaceNodes(partialGroup.children, callback, prev, null, isRoot);
            continue;
        } // Ignore explicit spaces (e.g., \;, \,) when determining what implicit
        // spacing should go between atoms of different classes
        var nonspace = !node.hasClass("mspace");
        if (nonspace) {
            var result = callback(node, prev.node);
            if (result) {
                if (prev.insertAfter) prev.insertAfter(result);
                else {
                    // insert at front
                    nodes.unshift(result);
                    i++;
                }
            }
        }
        if (nonspace) prev.node = node;
        else if (isRoot && node.hasClass("newline")) prev.node = makeSpan$1([
            "leftmost"
        ]); // treat like beginning of line
        prev.insertAfter = ((index)=>(n)=>{
                nodes.splice(index + 1, 0, n);
                i++;
            })(i);
    }
    if (next) nodes.pop();
}; // Check if given node is a partial group, i.e., does not affect spacing around.
var checkPartialGroup = function checkPartialGroup(node) {
    if (node instanceof DocumentFragment || node instanceof Anchor || node instanceof Span && node.hasClass("enclosing")) return node;
    return null;
}; // Return the outermost node of a domTree.
var getOutermostNode = function getOutermostNode(node, side) {
    var partialGroup = checkPartialGroup(node);
    if (partialGroup) {
        var children = partialGroup.children;
        if (children.length) {
            if (side === "right") return getOutermostNode(children[children.length - 1], "right");
            else if (side === "left") return getOutermostNode(children[0], "left");
        }
    }
    return node;
}; // Return math atom class (mclass) of a domTree.
// If `side` is given, it will get the type of the outermost node at given side.
var getTypeOfDomTree = function getTypeOfDomTree(node, side) {
    if (!node) return null;
    if (side) node = getOutermostNode(node, side);
     // This makes a lot of assumptions as to where the type of atom
    // appears.  We should do a better job of enforcing this.
    return DomEnum[node.classes[0]] || null;
};
var makeNullDelimiter = function makeNullDelimiter(options, classes) {
    var moreClasses = [
        "nulldelimiter"
    ].concat(options.baseSizingClasses());
    return makeSpan$1(classes.concat(moreClasses));
};
/**
 * buildGroup is the function that takes a group and calls the correct groupType
 * function for it. It also handles the interaction of size and style changes
 * between parents and children.
 */ var buildGroup$1 = function buildGroup(group, options, baseOptions) {
    if (!group) return makeSpan$1();
    if (_htmlGroupBuilders[group.type]) {
        // Call the groupBuilders function
        // $FlowFixMe
        var groupNode = _htmlGroupBuilders[group.type](group, options); // If the size changed between the parent and the current group, account
        // for that size difference.
        if (baseOptions && options.size !== baseOptions.size) {
            groupNode = makeSpan$1(options.sizingClasses(baseOptions), [
                groupNode
            ], options);
            var multiplier = options.sizeMultiplier / baseOptions.sizeMultiplier;
            groupNode.height *= multiplier;
            groupNode.depth *= multiplier;
        }
        return groupNode;
    } else throw new ParseError("Got group of unknown type: '" + group.type + "'");
};
/**
 * Combine an array of HTML DOM nodes (e.g., the output of `buildExpression`)
 * into an unbreakable HTML node of class .base, with proper struts to
 * guarantee correct vertical extent.  `buildHTML` calls this repeatedly to
 * make up the entire expression as a sequence of unbreakable units.
 */ function buildHTMLUnbreakable(children, options) {
    // Compute height and depth of this chunk.
    var body = makeSpan$1([
        "base"
    ], children, options); // Add strut, which ensures that the top of the HTML element falls at
    // the height of the expression, and the bottom of the HTML element
    // falls at the depth of the expression.
    var strut = makeSpan$1([
        "strut"
    ]);
    strut.style.height = makeEm(body.height + body.depth);
    if (body.depth) strut.style.verticalAlign = makeEm(-body.depth);
    body.children.unshift(strut);
    return body;
}
/**
 * Take an entire parse tree, and build it into an appropriate set of HTML
 * nodes.
 */ function buildHTML(tree, options) {
    // Strip off outer tag wrapper for processing below.
    var tag = null;
    if (tree.length === 1 && tree[0].type === "tag") {
        tag = tree[0].tag;
        tree = tree[0].body;
    } // Build the expression contained in the tree
    var expression = buildExpression$1(tree, options, "root");
    var eqnNum;
    if (expression.length === 2 && expression[1].hasClass("tag")) // An environment with automatic equation numbers, e.g. {gather}.
    eqnNum = expression.pop();
    var children = []; // Create one base node for each chunk between potential line breaks.
    // The TeXBook [p.173] says "A formula will be broken only after a
    // relation symbol like $=$ or $<$ or $\rightarrow$, or after a binary
    // operation symbol like $+$ or $-$ or $\times$, where the relation or
    // binary operation is on the ``outer level'' of the formula (i.e., not
    // enclosed in {...} and not part of an \over construction)."
    var parts = [];
    for(var i = 0; i < expression.length; i++){
        parts.push(expression[i]);
        if (expression[i].hasClass("mbin") || expression[i].hasClass("mrel") || expression[i].hasClass("allowbreak")) {
            // Put any post-operator glue on same line as operator.
            // Watch for \nobreak along the way, and stop at \newline.
            var nobreak = false;
            while(i < expression.length - 1 && expression[i + 1].hasClass("mspace") && !expression[i + 1].hasClass("newline")){
                i++;
                parts.push(expression[i]);
                if (expression[i].hasClass("nobreak")) nobreak = true;
            } // Don't allow break if \nobreak among the post-operator glue.
            if (!nobreak) {
                children.push(buildHTMLUnbreakable(parts, options));
                parts = [];
            }
        } else if (expression[i].hasClass("newline")) {
            // Write the line except the newline
            parts.pop();
            if (parts.length > 0) {
                children.push(buildHTMLUnbreakable(parts, options));
                parts = [];
            } // Put the newline at the top level
            children.push(expression[i]);
        }
    }
    if (parts.length > 0) children.push(buildHTMLUnbreakable(parts, options));
     // Now, if there was a tag, build it too and append it as a final child.
    var tagChild;
    if (tag) {
        tagChild = buildHTMLUnbreakable(buildExpression$1(tag, options, true));
        tagChild.classes = [
            "tag"
        ];
        children.push(tagChild);
    } else if (eqnNum) children.push(eqnNum);
    var htmlNode = makeSpan$1([
        "katex-html"
    ], children);
    htmlNode.setAttribute("aria-hidden", "true"); // Adjust the strut of the tag to be the maximum height of all children
    // (the height of the enclosing htmlNode) for proper vertical alignment.
    if (tagChild) {
        var strut = tagChild.children[0];
        strut.style.height = makeEm(htmlNode.height + htmlNode.depth);
        if (htmlNode.depth) strut.style.verticalAlign = makeEm(-htmlNode.depth);
    }
    return htmlNode;
}
/**
 * These objects store data about MathML nodes. This is the MathML equivalent
 * of the types in domTree.js. Since MathML handles its own rendering, and
 * since we're mainly using MathML to improve accessibility, we don't manage
 * any of the styling state that the plain DOM nodes do.
 *
 * The `toNode` and `toMarkup` functions work similarly to how they do in
 * domTree.js, creating namespaced DOM nodes and HTML text markup respectively.
 */ function newDocumentFragment(children) {
    return new DocumentFragment(children);
}
/**
 * This node represents a general purpose MathML node of any type. The
 * constructor requires the type of node to create (for example, `"mo"` or
 * `"mspace"`, corresponding to `<mo>` and `<mspace>` tags).
 */ class MathNode {
    constructor(type, children, classes){
        this.type = void 0;
        this.attributes = void 0;
        this.children = void 0;
        this.classes = void 0;
        this.type = type;
        this.attributes = {};
        this.children = children || [];
        this.classes = classes || [];
    }
    /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */ setAttribute(name, value) {
        this.attributes[name] = value;
    }
    /**
   * Gets an attribute on a MathML node.
   */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
   * Converts the math node into a MathML-namespaced DOM element.
   */ toNode() {
        var node = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) node.setAttribute(attr, this.attributes[attr]);
        if (this.classes.length > 0) node.className = createClass(this.classes);
        for(var i = 0; i < this.children.length; i++)// Combine multiple TextNodes into one TextNode, to prevent
        // screen readers from reading each as a separate word [#3995]
        if (this.children[i] instanceof TextNode && this.children[i + 1] instanceof TextNode) {
            var text = this.children[i].toText() + this.children[++i].toText();
            while(this.children[i + 1] instanceof TextNode)text += this.children[++i].toText();
            node.appendChild(new TextNode(text).toNode());
        } else node.appendChild(this.children[i].toNode());
        return node;
    }
    /**
   * Converts the math node into an HTML markup string.
   */ toMarkup() {
        var markup = "<" + this.type; // Add the attributes
        for(var attr in this.attributes)if (Object.prototype.hasOwnProperty.call(this.attributes, attr)) {
            markup += " " + attr + "=\"";
            markup += utils.escape(this.attributes[attr]);
            markup += "\"";
        }
        if (this.classes.length > 0) markup += " class =\"" + utils.escape(createClass(this.classes)) + "\"";
        markup += ">";
        for(var i = 0; i < this.children.length; i++)markup += this.children[i].toMarkup();
        markup += "</" + this.type + ">";
        return markup;
    }
    /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */ toText() {
        return this.children.map((child)=>child.toText()).join("");
    }
}
/**
 * This node represents a piece of text.
 */ class TextNode {
    constructor(text){
        this.text = void 0;
        this.text = text;
    }
    /**
   * Converts the text node into a DOM text node.
   */ toNode() {
        return document.createTextNode(this.text);
    }
    /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */ toMarkup() {
        return utils.escape(this.toText());
    }
    /**
   * Converts the text node into a string
   * (representing the text itself).
   */ toText() {
        return this.text;
    }
}
/**
 * This node represents a space, but may render as <mspace.../> or as text,
 * depending on the width.
 */ class SpaceNode {
    /**
   * Create a Space node with width given in CSS ems.
   */ constructor(width){
        this.width = void 0;
        this.character = void 0;
        this.width = width; // See https://www.w3.org/TR/2000/WD-MathML2-20000328/chapter6.html
        // for a table of space-like characters.  We use Unicode
        // representations instead of &LongNames; as it's not clear how to
        // make the latter via document.createTextNode.
        if (width >= 0.05555 && width <= 0.05556) this.character = "\u200a"; // &VeryThinSpace;
        else if (width >= 0.1666 && width <= 0.1667) this.character = "\u2009"; // &ThinSpace;
        else if (width >= 0.2222 && width <= 0.2223) this.character = "\u2005"; // &MediumSpace;
        else if (width >= 0.2777 && width <= 0.2778) this.character = "\u2005\u200a"; // &ThickSpace;
        else if (width >= -0.05556 && width <= -0.05555) this.character = "\u200a\u2063"; // &NegativeVeryThinSpace;
        else if (width >= -0.1667 && width <= -0.1666) this.character = "\u2009\u2063"; // &NegativeThinSpace;
        else if (width >= -0.2223 && width <= -0.2222) this.character = "\u205f\u2063"; // &NegativeMediumSpace;
        else if (width >= -0.2778 && width <= -0.2777) this.character = "\u2005\u2063"; // &NegativeThickSpace;
        else this.character = null;
    }
    /**
   * Converts the math node into a MathML-namespaced DOM element.
   */ toNode() {
        if (this.character) return document.createTextNode(this.character);
        else {
            var node = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
            node.setAttribute("width", makeEm(this.width));
            return node;
        }
    }
    /**
   * Converts the math node into an HTML markup string.
   */ toMarkup() {
        if (this.character) return "<mtext>" + this.character + "</mtext>";
        else return "<mspace width=\"" + makeEm(this.width) + "\"/>";
    }
    /**
   * Converts the math node into a string, similar to innerText.
   */ toText() {
        if (this.character) return this.character;
        else return " ";
    }
}
var mathMLTree = {
    MathNode,
    TextNode,
    SpaceNode,
    newDocumentFragment
};
/**
 * This file converts a parse tree into a corresponding MathML tree. The main
 * entry point is the `buildMathML` function, which takes a parse tree from the
 * parser.
 */ /**
 * Takes a symbol and converts it into a MathML text node after performing
 * optional replacement from symbols.js.
 */ var makeText = function makeText(text, mode, options) {
    if (symbols[mode][text] && symbols[mode][text].replace && text.charCodeAt(0) !== 0xD835 && !(ligatures.hasOwnProperty(text) && options && (options.fontFamily && options.fontFamily.slice(4, 6) === "tt" || options.font && options.font.slice(4, 6) === "tt"))) text = symbols[mode][text].replace;
    return new mathMLTree.TextNode(text);
};
/**
 * Wrap the given array of nodes in an <mrow> node if needed, i.e.,
 * unless the array has length 1.  Always returns a single node.
 */ var makeRow = function makeRow(body) {
    if (body.length === 1) return body[0];
    else return new mathMLTree.MathNode("mrow", body);
};
/**
 * Returns the math variant as a string or null if none is required.
 */ var getVariant = function getVariant(group, options) {
    // Handle \text... font specifiers as best we can.
    // MathML has a limited list of allowable mathvariant specifiers; see
    // https://www.w3.org/TR/MathML3/chapter3.html#presm.commatt
    if (options.fontFamily === "texttt") return "monospace";
    else if (options.fontFamily === "textsf") {
        if (options.fontShape === "textit" && options.fontWeight === "textbf") return "sans-serif-bold-italic";
        else if (options.fontShape === "textit") return "sans-serif-italic";
        else if (options.fontWeight === "textbf") return "bold-sans-serif";
        else return "sans-serif";
    } else if (options.fontShape === "textit" && options.fontWeight === "textbf") return "bold-italic";
    else if (options.fontShape === "textit") return "italic";
    else if (options.fontWeight === "textbf") return "bold";
    var font = options.font;
    if (!font || font === "mathnormal") return null;
    var mode = group.mode;
    if (font === "mathit") return "italic";
    else if (font === "boldsymbol") return group.type === "textord" ? "bold" : "bold-italic";
    else if (font === "mathbf") return "bold";
    else if (font === "mathbb") return "double-struck";
    else if (font === "mathsfit") return "sans-serif-italic";
    else if (font === "mathfrak") return "fraktur";
    else if (font === "mathscr" || font === "mathcal") // MathML makes no distinction between script and calligraphic
    return "script";
    else if (font === "mathsf") return "sans-serif";
    else if (font === "mathtt") return "monospace";
    var text = group.text;
    if ([
        "\\imath",
        "\\jmath"
    ].includes(text)) return null;
    if (symbols[mode][text] && symbols[mode][text].replace) text = symbols[mode][text].replace;
    var fontName = buildCommon.fontMap[font].fontName;
    if (getCharacterMetrics(text, fontName, mode)) return buildCommon.fontMap[font].variant;
    return null;
};
/**
 * Check for <mi>.</mi> which is how a dot renders in MathML,
 * or <mo separator="true" lspace="0em" rspace="0em">,</mo>
 * which is how a braced comma {,} renders in MathML
 */ function isNumberPunctuation(group) {
    if (!group) return false;
    if (group.type === 'mi' && group.children.length === 1) {
        var child = group.children[0];
        return child instanceof TextNode && child.text === '.';
    } else if (group.type === 'mo' && group.children.length === 1 && group.getAttribute('separator') === 'true' && group.getAttribute('lspace') === '0em' && group.getAttribute('rspace') === '0em') {
        var _child = group.children[0];
        return _child instanceof TextNode && _child.text === ',';
    } else return false;
}
/**
 * Takes a list of nodes, builds them, and returns a list of the generated
 * MathML nodes.  Also combine consecutive <mtext> outputs into a single
 * <mtext> tag.
 */ var buildExpression = function buildExpression(expression, options, isOrdgroup) {
    if (expression.length === 1) {
        var group = buildGroup(expression[0], options);
        if (isOrdgroup && group instanceof MathNode && group.type === "mo") {
            // When TeX writers want to suppress spacing on an operator,
            // they often put the operator by itself inside braces.
            group.setAttribute("lspace", "0em");
            group.setAttribute("rspace", "0em");
        }
        return [
            group
        ];
    }
    var groups = [];
    var lastGroup;
    for(var i = 0; i < expression.length; i++){
        var _group = buildGroup(expression[i], options);
        if (_group instanceof MathNode && lastGroup instanceof MathNode) {
            // Concatenate adjacent <mtext>s
            if (_group.type === 'mtext' && lastGroup.type === 'mtext' && _group.getAttribute('mathvariant') === lastGroup.getAttribute('mathvariant')) {
                lastGroup.children.push(..._group.children);
                continue; // Concatenate adjacent <mn>s
            } else if (_group.type === 'mn' && lastGroup.type === 'mn') {
                lastGroup.children.push(..._group.children);
                continue; // Concatenate <mn>...</mn> followed by <mi>.</mi>
            } else if (isNumberPunctuation(_group) && lastGroup.type === 'mn') {
                lastGroup.children.push(..._group.children);
                continue; // Concatenate <mi>.</mi> followed by <mn>...</mn>
            } else if (_group.type === 'mn' && isNumberPunctuation(lastGroup)) {
                _group.children = [
                    ...lastGroup.children,
                    ..._group.children
                ];
                groups.pop(); // Put preceding <mn>...</mn> or <mi>.</mi> inside base of
            // <msup><mn>...base...</mn>...exponent...</msup> (or <msub>)
            } else if ((_group.type === 'msup' || _group.type === 'msub') && _group.children.length >= 1 && (lastGroup.type === 'mn' || isNumberPunctuation(lastGroup))) {
                var base = _group.children[0];
                if (base instanceof MathNode && base.type === 'mn') {
                    base.children = [
                        ...lastGroup.children,
                        ...base.children
                    ];
                    groups.pop();
                } // \not
            } else if (lastGroup.type === 'mi' && lastGroup.children.length === 1) {
                var lastChild = lastGroup.children[0];
                if (lastChild instanceof TextNode && lastChild.text === '\u0338' && (_group.type === 'mo' || _group.type === 'mi' || _group.type === 'mn')) {
                    var child = _group.children[0];
                    if (child instanceof TextNode && child.text.length > 0) {
                        // Overlay with combining character long solidus
                        child.text = child.text.slice(0, 1) + "\u0338" + child.text.slice(1);
                        groups.pop();
                    }
                }
            }
        }
        groups.push(_group);
        lastGroup = _group;
    }
    return groups;
};
/**
 * Equivalent to buildExpression, but wraps the elements in an <mrow>
 * if there's more than one.  Returns a single node instead of an array.
 */ var buildExpressionRow = function buildExpressionRow(expression, options, isOrdgroup) {
    return makeRow(buildExpression(expression, options, isOrdgroup));
};
/**
 * Takes a group from the parser and calls the appropriate groupBuilders function
 * on it to produce a MathML node.
 */ var buildGroup = function buildGroup(group, options) {
    if (!group) return new mathMLTree.MathNode("mrow");
    if (_mathmlGroupBuilders[group.type]) {
        // Call the groupBuilders function
        // $FlowFixMe
        var result = _mathmlGroupBuilders[group.type](group, options); // $FlowFixMe
        return result;
    } else throw new ParseError("Got group of unknown type: '" + group.type + "'");
};
/**
 * Takes a full parse tree and settings and builds a MathML representation of
 * it. In particular, we put the elements from building the parse tree into a
 * <semantics> tag so we can also include that TeX source as an annotation.
 *
 * Note that we actually return a domTree element with a `<math>` inside it so
 * we can do appropriate styling.
 */ function buildMathML(tree, texExpression, options, isDisplayMode, forMathmlOnly) {
    var expression = buildExpression(tree, options); // TODO: Make a pass thru the MathML similar to buildHTML.traverseNonSpaceNodes
    // and add spacing nodes. This is necessary only adjacent to math operators
    // like \sin or \lim or to subsup elements that contain math operators.
    // MathML takes care of the other spacing issues.
    // Wrap up the expression in an mrow so it is presented in the semantics
    // tag correctly, unless it's a single <mrow> or <mtable>.
    var wrapper;
    if (expression.length === 1 && expression[0] instanceof MathNode && [
        "mrow",
        "mtable"
    ].includes(expression[0].type)) wrapper = expression[0];
    else wrapper = new mathMLTree.MathNode("mrow", expression);
     // Build a TeX annotation of the source
    var annotation = new mathMLTree.MathNode("annotation", [
        new mathMLTree.TextNode(texExpression)
    ]);
    annotation.setAttribute("encoding", "application/x-tex");
    var semantics = new mathMLTree.MathNode("semantics", [
        wrapper,
        annotation
    ]);
    var math = new mathMLTree.MathNode("math", [
        semantics
    ]);
    math.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML");
    if (isDisplayMode) math.setAttribute("display", "block");
     // You can't style <math> nodes, so we wrap the node in a span.
    // NOTE: The span class is not typed to have <math> nodes as children, and
    // we don't want to make the children type more generic since the children
    // of span are expected to have more fields in `buildHtml` contexts.
    var wrapperClass = forMathmlOnly ? "katex" : "katex-mathml"; // $FlowFixMe
    return buildCommon.makeSpan([
        wrapperClass
    ], [
        math
    ]);
}
var optionsFromSettings = function optionsFromSettings(settings) {
    return new Options({
        style: settings.displayMode ? Style$1.DISPLAY : Style$1.TEXT,
        maxSize: settings.maxSize,
        minRuleThickness: settings.minRuleThickness
    });
};
var displayWrap = function displayWrap(node, settings) {
    if (settings.displayMode) {
        var classes = [
            "katex-display"
        ];
        if (settings.leqno) classes.push("leqno");
        if (settings.fleqn) classes.push("fleqn");
        node = buildCommon.makeSpan(classes, [
            node
        ]);
    }
    return node;
};
var buildTree = function buildTree(tree, expression, settings) {
    var options = optionsFromSettings(settings);
    var katexNode;
    if (settings.output === "mathml") return buildMathML(tree, expression, options, settings.displayMode, true);
    else if (settings.output === "html") {
        var htmlNode = buildHTML(tree, options);
        katexNode = buildCommon.makeSpan([
            "katex"
        ], [
            htmlNode
        ]);
    } else {
        var mathMLNode = buildMathML(tree, expression, options, settings.displayMode, false);
        var _htmlNode = buildHTML(tree, options);
        katexNode = buildCommon.makeSpan([
            "katex"
        ], [
            mathMLNode,
            _htmlNode
        ]);
    }
    return displayWrap(katexNode, settings);
};
var buildHTMLTree = function buildHTMLTree(tree, expression, settings) {
    var options = optionsFromSettings(settings);
    var htmlNode = buildHTML(tree, options);
    var katexNode = buildCommon.makeSpan([
        "katex"
    ], [
        htmlNode
    ]);
    return displayWrap(katexNode, settings);
};
/**
 * This file provides support to buildMathML.js and buildHTML.js
 * for stretchy wide elements rendered from SVG files
 * and other CSS trickery.
 */ var stretchyCodePoint = {
    widehat: "^",
    widecheck: "\u02C7",
    widetilde: "~",
    utilde: "~",
    overleftarrow: "\u2190",
    underleftarrow: "\u2190",
    xleftarrow: "\u2190",
    overrightarrow: "\u2192",
    underrightarrow: "\u2192",
    xrightarrow: "\u2192",
    underbrace: "\u23df",
    overbrace: "\u23de",
    overgroup: "\u23e0",
    undergroup: "\u23e1",
    overleftrightarrow: "\u2194",
    underleftrightarrow: "\u2194",
    xleftrightarrow: "\u2194",
    Overrightarrow: "\u21d2",
    xRightarrow: "\u21d2",
    overleftharpoon: "\u21bc",
    xleftharpoonup: "\u21bc",
    overrightharpoon: "\u21c0",
    xrightharpoonup: "\u21c0",
    xLeftarrow: "\u21d0",
    xLeftrightarrow: "\u21d4",
    xhookleftarrow: "\u21a9",
    xhookrightarrow: "\u21aa",
    xmapsto: "\u21a6",
    xrightharpoondown: "\u21c1",
    xleftharpoondown: "\u21bd",
    xrightleftharpoons: "\u21cc",
    xleftrightharpoons: "\u21cb",
    xtwoheadleftarrow: "\u219e",
    xtwoheadrightarrow: "\u21a0",
    xlongequal: "=",
    xtofrom: "\u21c4",
    xrightleftarrows: "\u21c4",
    xrightequilibrium: "\u21cc",
    // Not a perfect match.
    xleftequilibrium: "\u21cb",
    // None better available.
    "\\cdrightarrow": "\u2192",
    "\\cdleftarrow": "\u2190",
    "\\cdlongequal": "="
};
var mathMLnode = function mathMLnode(label) {
    var node = new mathMLTree.MathNode("mo", [
        new mathMLTree.TextNode(stretchyCodePoint[label.replace(/^\\/, '')])
    ]);
    node.setAttribute("stretchy", "true");
    return node;
}; // Many of the KaTeX SVG images have been adapted from glyphs in KaTeX fonts.
// Copyright (c) 2009-2010, Design Science, Inc. (<www.mathjax.org>)
// Copyright (c) 2014-2017 Khan Academy (<www.khanacademy.org>)
// Licensed under the SIL Open Font License, Version 1.1.
// See \nhttp://scripts.sil.org/OFL
// Very Long SVGs
//    Many of the KaTeX stretchy wide elements use a long SVG image and an
//    overflow: hidden tactic to achieve a stretchy image while avoiding
//    distortion of arrowheads or brace corners.
//    The SVG typically contains a very long (400 em) arrow.
//    The SVG is in a container span that has overflow: hidden, so the span
//    acts like a window that exposes only part of the  SVG.
//    The SVG always has a longer, thinner aspect ratio than the container span.
//    After the SVG fills 100% of the height of the container span,
//    there is a long arrow shaft left over. That left-over shaft is not shown.
//    Instead, it is sliced off because the span's CSS has overflow: hidden.
//    Thus, the reader sees an arrow that matches the subject matter width
//    without distortion.
//    Some functions, such as \cancel, need to vary their aspect ratio. These
//    functions do not get the overflow SVG treatment.
// Second Brush Stroke
//    Low resolution monitors struggle to display images in fine detail.
//    So browsers apply anti-aliasing. A long straight arrow shaft therefore
//    will sometimes appear as if it has a blurred edge.
//    To mitigate this, these SVG files contain a second "brush-stroke" on the
//    arrow shafts. That is, a second long thin rectangular SVG path has been
//    written directly on top of each arrow shaft. This reinforcement causes
//    some of the screen pixels to display as black instead of the anti-aliased
//    gray pixel that a  single path would generate. So we get arrow shafts
//    whose edges appear to be sharper.
// In the katexImagesData object just below, the dimensions all
// correspond to path geometry inside the relevant SVG.
// For example, \overrightarrow uses the same arrowhead as glyph U+2192
// from the KaTeX Main font. The scaling factor is 1000.
// That is, inside the font, that arrowhead is 522 units tall, which
// corresponds to 0.522 em inside the document.
var katexImagesData = {
    //   path(s), minWidth, height, align
    overrightarrow: [
        [
            "rightarrow"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    overleftarrow: [
        [
            "leftarrow"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    underrightarrow: [
        [
            "rightarrow"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    underleftarrow: [
        [
            "leftarrow"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    xrightarrow: [
        [
            "rightarrow"
        ],
        1.469,
        522,
        "xMaxYMin"
    ],
    "\\cdrightarrow": [
        [
            "rightarrow"
        ],
        3.0,
        522,
        "xMaxYMin"
    ],
    // CD minwwidth2.5pc
    xleftarrow: [
        [
            "leftarrow"
        ],
        1.469,
        522,
        "xMinYMin"
    ],
    "\\cdleftarrow": [
        [
            "leftarrow"
        ],
        3.0,
        522,
        "xMinYMin"
    ],
    Overrightarrow: [
        [
            "doublerightarrow"
        ],
        0.888,
        560,
        "xMaxYMin"
    ],
    xRightarrow: [
        [
            "doublerightarrow"
        ],
        1.526,
        560,
        "xMaxYMin"
    ],
    xLeftarrow: [
        [
            "doubleleftarrow"
        ],
        1.526,
        560,
        "xMinYMin"
    ],
    overleftharpoon: [
        [
            "leftharpoon"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    xleftharpoonup: [
        [
            "leftharpoon"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    xleftharpoondown: [
        [
            "leftharpoondown"
        ],
        0.888,
        522,
        "xMinYMin"
    ],
    overrightharpoon: [
        [
            "rightharpoon"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    xrightharpoonup: [
        [
            "rightharpoon"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    xrightharpoondown: [
        [
            "rightharpoondown"
        ],
        0.888,
        522,
        "xMaxYMin"
    ],
    xlongequal: [
        [
            "longequal"
        ],
        0.888,
        334,
        "xMinYMin"
    ],
    "\\cdlongequal": [
        [
            "longequal"
        ],
        3.0,
        334,
        "xMinYMin"
    ],
    xtwoheadleftarrow: [
        [
            "twoheadleftarrow"
        ],
        0.888,
        334,
        "xMinYMin"
    ],
    xtwoheadrightarrow: [
        [
            "twoheadrightarrow"
        ],
        0.888,
        334,
        "xMaxYMin"
    ],
    overleftrightarrow: [
        [
            "leftarrow",
            "rightarrow"
        ],
        0.888,
        522
    ],
    overbrace: [
        [
            "leftbrace",
            "midbrace",
            "rightbrace"
        ],
        1.6,
        548
    ],
    underbrace: [
        [
            "leftbraceunder",
            "midbraceunder",
            "rightbraceunder"
        ],
        1.6,
        548
    ],
    underleftrightarrow: [
        [
            "leftarrow",
            "rightarrow"
        ],
        0.888,
        522
    ],
    xleftrightarrow: [
        [
            "leftarrow",
            "rightarrow"
        ],
        1.75,
        522
    ],
    xLeftrightarrow: [
        [
            "doubleleftarrow",
            "doublerightarrow"
        ],
        1.75,
        560
    ],
    xrightleftharpoons: [
        [
            "leftharpoondownplus",
            "rightharpoonplus"
        ],
        1.75,
        716
    ],
    xleftrightharpoons: [
        [
            "leftharpoonplus",
            "rightharpoondownplus"
        ],
        1.75,
        716
    ],
    xhookleftarrow: [
        [
            "leftarrow",
            "righthook"
        ],
        1.08,
        522
    ],
    xhookrightarrow: [
        [
            "lefthook",
            "rightarrow"
        ],
        1.08,
        522
    ],
    overlinesegment: [
        [
            "leftlinesegment",
            "rightlinesegment"
        ],
        0.888,
        522
    ],
    underlinesegment: [
        [
            "leftlinesegment",
            "rightlinesegment"
        ],
        0.888,
        522
    ],
    overgroup: [
        [
            "leftgroup",
            "rightgroup"
        ],
        0.888,
        342
    ],
    undergroup: [
        [
            "leftgroupunder",
            "rightgroupunder"
        ],
        0.888,
        342
    ],
    xmapsto: [
        [
            "leftmapsto",
            "rightarrow"
        ],
        1.5,
        522
    ],
    xtofrom: [
        [
            "leftToFrom",
            "rightToFrom"
        ],
        1.75,
        528
    ],
    // The next three arrows are from the mhchem package.
    // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
    // document as \xrightarrow or \xrightleftharpoons. Those have
    // min-length = 1.75em, so we set min-length on these next three to match.
    xrightleftarrows: [
        [
            "baraboveleftarrow",
            "rightarrowabovebar"
        ],
        1.75,
        901
    ],
    xrightequilibrium: [
        [
            "baraboveshortleftharpoon",
            "rightharpoonaboveshortbar"
        ],
        1.75,
        716
    ],
    xleftequilibrium: [
        [
            "shortbaraboveleftharpoon",
            "shortrightharpoonabovebar"
        ],
        1.75,
        716
    ]
};
var groupLength = function groupLength(arg) {
    if (arg.type === "ordgroup") return arg.body.length;
    else return 1;
};
var svgSpan = function svgSpan(group, options) {
    // Create a span with inline SVG for the element.
    function buildSvgSpan_() {
        var viewBoxWidth = 400000; // default
        var label = group.label.slice(1);
        if ([
            "widehat",
            "widecheck",
            "widetilde",
            "utilde"
        ].includes(label)) {
            // Each type in the `if` statement corresponds to one of the ParseNode
            // types below. This narrowing is required to access `grp.base`.
            // $FlowFixMe
            var grp = group; // There are four SVG images available for each function.
            // Choose a taller image when there are more characters.
            var numChars = groupLength(grp.base);
            var viewBoxHeight;
            var pathName;
            var _height;
            if (numChars > 5) {
                if (label === "widehat" || label === "widecheck") {
                    viewBoxHeight = 420;
                    viewBoxWidth = 2364;
                    _height = 0.42;
                    pathName = label + "4";
                } else {
                    viewBoxHeight = 312;
                    viewBoxWidth = 2340;
                    _height = 0.34;
                    pathName = "tilde4";
                }
            } else {
                var imgIndex = [
                    1,
                    1,
                    2,
                    2,
                    3,
                    3
                ][numChars];
                if (label === "widehat" || label === "widecheck") {
                    viewBoxWidth = [
                        0,
                        1062,
                        2364,
                        2364,
                        2364
                    ][imgIndex];
                    viewBoxHeight = [
                        0,
                        239,
                        300,
                        360,
                        420
                    ][imgIndex];
                    _height = [
                        0,
                        0.24,
                        0.3,
                        0.3,
                        0.36,
                        0.42
                    ][imgIndex];
                    pathName = label + imgIndex;
                } else {
                    viewBoxWidth = [
                        0,
                        600,
                        1033,
                        2339,
                        2340
                    ][imgIndex];
                    viewBoxHeight = [
                        0,
                        260,
                        286,
                        306,
                        312
                    ][imgIndex];
                    _height = [
                        0,
                        0.26,
                        0.286,
                        0.3,
                        0.306,
                        0.34
                    ][imgIndex];
                    pathName = "tilde" + imgIndex;
                }
            }
            var path = new PathNode(pathName);
            var svgNode = new SvgNode([
                path
            ], {
                "width": "100%",
                "height": makeEm(_height),
                "viewBox": "0 0 " + viewBoxWidth + " " + viewBoxHeight,
                "preserveAspectRatio": "none"
            });
            return {
                span: buildCommon.makeSvgSpan([], [
                    svgNode
                ], options),
                minWidth: 0,
                height: _height
            };
        } else {
            var spans = [];
            var data = katexImagesData[label];
            var [paths, _minWidth, _viewBoxHeight] = data;
            var _height2 = _viewBoxHeight / 1000;
            var numSvgChildren = paths.length;
            var widthClasses;
            var aligns;
            if (numSvgChildren === 1) {
                // $FlowFixMe: All these cases must be of the 4-tuple type.
                var align1 = data[3];
                widthClasses = [
                    "hide-tail"
                ];
                aligns = [
                    align1
                ];
            } else if (numSvgChildren === 2) {
                widthClasses = [
                    "halfarrow-left",
                    "halfarrow-right"
                ];
                aligns = [
                    "xMinYMin",
                    "xMaxYMin"
                ];
            } else if (numSvgChildren === 3) {
                widthClasses = [
                    "brace-left",
                    "brace-center",
                    "brace-right"
                ];
                aligns = [
                    "xMinYMin",
                    "xMidYMin",
                    "xMaxYMin"
                ];
            } else throw new Error("Correct katexImagesData or update code here to support\n                    " + numSvgChildren + " children.");
            for(var i = 0; i < numSvgChildren; i++){
                var _path = new PathNode(paths[i]);
                var _svgNode = new SvgNode([
                    _path
                ], {
                    "width": "400em",
                    "height": makeEm(_height2),
                    "viewBox": "0 0 " + viewBoxWidth + " " + _viewBoxHeight,
                    "preserveAspectRatio": aligns[i] + " slice"
                });
                var _span = buildCommon.makeSvgSpan([
                    widthClasses[i]
                ], [
                    _svgNode
                ], options);
                if (numSvgChildren === 1) return {
                    span: _span,
                    minWidth: _minWidth,
                    height: _height2
                };
                else {
                    _span.style.height = makeEm(_height2);
                    spans.push(_span);
                }
            }
            return {
                span: buildCommon.makeSpan([
                    "stretchy"
                ], spans, options),
                minWidth: _minWidth,
                height: _height2
            };
        }
    } // buildSvgSpan_()
    var { span, minWidth, height } = buildSvgSpan_(); // Note that we are returning span.depth = 0.
    // Any adjustments relative to the baseline must be done in buildHTML.
    span.height = height;
    span.style.height = makeEm(height);
    if (minWidth > 0) span.style.minWidth = makeEm(minWidth);
    return span;
};
var encloseSpan = function encloseSpan(inner, label, topPad, bottomPad, options) {
    // Return an image span for \cancel, \bcancel, \xcancel, \fbox, or \angl
    var img;
    var totalHeight = inner.height + inner.depth + topPad + bottomPad;
    if (/fbox|color|angl/.test(label)) {
        img = buildCommon.makeSpan([
            "stretchy",
            label
        ], [], options);
        if (label === "fbox") {
            var color = options.color && options.getColor();
            if (color) img.style.borderColor = color;
        }
    } else {
        // \cancel, \bcancel, or \xcancel
        // Since \cancel's SVG is inline and it omits the viewBox attribute,
        // its stroke-width will not vary with span area.
        var lines = [];
        if (/^[bx]cancel$/.test(label)) lines.push(new LineNode({
            "x1": "0",
            "y1": "0",
            "x2": "100%",
            "y2": "100%",
            "stroke-width": "0.046em"
        }));
        if (/^x?cancel$/.test(label)) lines.push(new LineNode({
            "x1": "0",
            "y1": "100%",
            "x2": "100%",
            "y2": "0",
            "stroke-width": "0.046em"
        }));
        var svgNode = new SvgNode(lines, {
            "width": "100%",
            "height": makeEm(totalHeight)
        });
        img = buildCommon.makeSvgSpan([], [
            svgNode
        ], options);
    }
    img.height = totalHeight;
    img.style.height = makeEm(totalHeight);
    return img;
};
var stretchy = {
    encloseSpan,
    mathMLnode,
    svgSpan
};
/**
 * Asserts that the node is of the given type and returns it with stricter
 * typing. Throws if the node's type does not match.
 */ function assertNodeType(node, type) {
    if (!node || node.type !== type) throw new Error("Expected node of type " + type + ", but got " + (node ? "node of type " + node.type : String(node)));
     // $FlowFixMe, >=0.125
    return node;
}
/**
 * Returns the node more strictly typed iff it is of the given type. Otherwise,
 * returns null.
 */ function assertSymbolNodeType(node) {
    var typedNode = checkSymbolNodeType(node);
    if (!typedNode) throw new Error("Expected node of symbol group type, but got " + (node ? "node of type " + node.type : String(node)));
    return typedNode;
}
/**
 * Returns the node more strictly typed iff it is of the given type. Otherwise,
 * returns null.
 */ function checkSymbolNodeType(node) {
    if (node && (node.type === "atom" || NON_ATOMS.hasOwnProperty(node.type))) // $FlowFixMe
    return node;
    return null;
}
// NOTE: Unlike most `htmlBuilder`s, this one handles not only "accent", but
// also "supsub" since an accent can affect super/subscripting.
var htmlBuilder$a = (grp, options)=>{
    // Accents are handled in the TeXbook pg. 443, rule 12.
    var base;
    var group;
    var supSubGroup;
    if (grp && grp.type === "supsub") {
        // If our base is a character box, and we have superscripts and
        // subscripts, the supsub will defer to us. In particular, we want
        // to attach the superscripts and subscripts to the inner body (so
        // that the position of the superscripts and subscripts won't be
        // affected by the height of the accent). We accomplish this by
        // sticking the base of the accent into the base of the supsub, and
        // rendering that, while keeping track of where the accent is.
        // The real accent group is the base of the supsub group
        group = assertNodeType(grp.base, "accent"); // The character box is the base of the accent group
        base = group.base; // Stick the character box into the base of the supsub group
        grp.base = base; // Rerender the supsub group with its new base, and store that
        // result.
        supSubGroup = assertSpan(buildGroup$1(grp, options)); // reset original base
        grp.base = group;
    } else {
        group = assertNodeType(grp, "accent");
        base = group.base;
    } // Build the base group
    var body = buildGroup$1(base, options.havingCrampedStyle()); // Does the accent need to shift for the skew of a character?
    var mustShift = group.isShifty && utils.isCharacterBox(base); // Calculate the skew of the accent. This is based on the line "If the
    // nucleus is not a single character, let s = 0; otherwise set s to the
    // kern amount for the nucleus followed by the \skewchar of its font."
    // Note that our skew metrics are just the kern between each character
    // and the skewchar.
    var skew = 0;
    if (mustShift) {
        // If the base is a character box, then we want the skew of the
        // innermost character. To do that, we find the innermost character:
        var baseChar = utils.getBaseElem(base); // Then, we render its group to get the symbol inside it
        var baseGroup = buildGroup$1(baseChar, options.havingCrampedStyle()); // Finally, we pull the skew off of the symbol.
        skew = assertSymbolDomNode(baseGroup).skew; // Note that we now throw away baseGroup, because the layers we
    // removed with getBaseElem might contain things like \color which
    // we can't get rid of.
    // TODO(emily): Find a better way to get the skew
    }
    var accentBelow = group.label === "\\c"; // calculate the amount of space between the body and the accent
    var clearance = accentBelow ? body.height + body.depth : Math.min(body.height, options.fontMetrics().xHeight); // Build the accent
    var accentBody;
    if (!group.isStretchy) {
        var accent;
        var width;
        if (group.label === "\\vec") {
            // Before version 0.9, \vec used the combining font glyph U+20D7.
            // But browsers, especially Safari, are not consistent in how they
            // render combining characters when not preceded by a character.
            // So now we use an SVG.
            // If Safari reforms, we should consider reverting to the glyph.
            accent = buildCommon.staticSvg("vec", options);
            width = buildCommon.svgData.vec[1];
        } else {
            accent = buildCommon.makeOrd({
                mode: group.mode,
                text: group.label
            }, options, "textord");
            accent = assertSymbolDomNode(accent); // Remove the italic correction of the accent, because it only serves to
            // shift the accent over to a place we don't want.
            accent.italic = 0;
            width = accent.width;
            if (accentBelow) clearance += accent.depth;
        }
        accentBody = buildCommon.makeSpan([
            "accent-body"
        ], [
            accent
        ]); // "Full" accents expand the width of the resulting symbol to be
        // at least the width of the accent, and overlap directly onto the
        // character without any vertical offset.
        var accentFull = group.label === "\\textcircled";
        if (accentFull) {
            accentBody.classes.push('accent-full');
            clearance = body.height;
        } // Shift the accent over by the skew.
        var left = skew; // CSS defines `.katex .accent .accent-body:not(.accent-full) { width: 0 }`
        // so that the accent doesn't contribute to the bounding box.
        // We need to shift the character by its width (effectively half
        // its width) to compensate.
        if (!accentFull) left -= width / 2;
        accentBody.style.left = makeEm(left); // \textcircled uses the \bigcirc glyph, so it needs some
        // vertical adjustment to match LaTeX.
        if (group.label === "\\textcircled") accentBody.style.top = ".2em";
        accentBody = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: body
                },
                {
                    type: "kern",
                    size: -clearance
                },
                {
                    type: "elem",
                    elem: accentBody
                }
            ]
        }, options);
    } else {
        accentBody = stretchy.svgSpan(group, options);
        accentBody = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: body
                },
                {
                    type: "elem",
                    elem: accentBody,
                    wrapperClasses: [
                        "svg-align"
                    ],
                    wrapperStyle: skew > 0 ? {
                        width: "calc(100% - " + makeEm(2 * skew) + ")",
                        marginLeft: makeEm(2 * skew)
                    } : undefined
                }
            ]
        }, options);
    }
    var accentWrap = buildCommon.makeSpan([
        "mord",
        "accent"
    ], [
        accentBody
    ], options);
    if (supSubGroup) {
        // Here, we replace the "base" child of the supsub with our newly
        // generated accent.
        supSubGroup.children[0] = accentWrap; // Since we don't rerun the height calculation after replacing the
        // accent, we manually recalculate height.
        supSubGroup.height = Math.max(accentWrap.height, supSubGroup.height); // Accents should always be ords, even when their innards are not.
        supSubGroup.classes[0] = "mord";
        return supSubGroup;
    } else return accentWrap;
};
var mathmlBuilder$9 = (group, options)=>{
    var accentNode = group.isStretchy ? stretchy.mathMLnode(group.label) : new mathMLTree.MathNode("mo", [
        makeText(group.label, group.mode)
    ]);
    var node = new mathMLTree.MathNode("mover", [
        buildGroup(group.base, options),
        accentNode
    ]);
    node.setAttribute("accent", "true");
    return node;
};
var NON_STRETCHY_ACCENT_REGEX = new RegExp([
    "\\acute",
    "\\grave",
    "\\ddot",
    "\\tilde",
    "\\bar",
    "\\breve",
    "\\check",
    "\\hat",
    "\\vec",
    "\\dot",
    "\\mathring"
].map((accent)=>"\\" + accent).join("|")); // Accents
defineFunction({
    type: "accent",
    names: [
        "\\acute",
        "\\grave",
        "\\ddot",
        "\\tilde",
        "\\bar",
        "\\breve",
        "\\check",
        "\\hat",
        "\\vec",
        "\\dot",
        "\\mathring",
        "\\widecheck",
        "\\widehat",
        "\\widetilde",
        "\\overrightarrow",
        "\\overleftarrow",
        "\\Overrightarrow",
        "\\overleftrightarrow",
        "\\overgroup",
        "\\overlinesegment",
        "\\overleftharpoon",
        "\\overrightharpoon"
    ],
    props: {
        numArgs: 1
    },
    handler: (context, args)=>{
        var base = normalizeArgument(args[0]);
        var isStretchy = !NON_STRETCHY_ACCENT_REGEX.test(context.funcName);
        var isShifty = !isStretchy || context.funcName === "\\widehat" || context.funcName === "\\widetilde" || context.funcName === "\\widecheck";
        return {
            type: "accent",
            mode: context.parser.mode,
            label: context.funcName,
            isStretchy: isStretchy,
            isShifty: isShifty,
            base: base
        };
    },
    htmlBuilder: htmlBuilder$a,
    mathmlBuilder: mathmlBuilder$9
}); // Text-mode accents
defineFunction({
    type: "accent",
    names: [
        "\\'",
        "\\`",
        "\\^",
        "\\~",
        "\\=",
        "\\u",
        "\\.",
        '\\"',
        "\\c",
        "\\r",
        "\\H",
        "\\v",
        "\\textcircled"
    ],
    props: {
        numArgs: 1,
        allowedInText: true,
        allowedInMath: true,
        // unless in strict mode
        argTypes: [
            "primitive"
        ]
    },
    handler: (context, args)=>{
        var base = args[0];
        var mode = context.parser.mode;
        if (mode === "math") {
            context.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + context.funcName + " works only in text mode");
            mode = "text";
        }
        return {
            type: "accent",
            mode: mode,
            label: context.funcName,
            isStretchy: false,
            isShifty: true,
            base: base
        };
    },
    htmlBuilder: htmlBuilder$a,
    mathmlBuilder: mathmlBuilder$9
});
// Horizontal overlap functions
defineFunction({
    type: "accentUnder",
    names: [
        "\\underleftarrow",
        "\\underrightarrow",
        "\\underleftrightarrow",
        "\\undergroup",
        "\\underlinesegment",
        "\\utilde"
    ],
    props: {
        numArgs: 1
    },
    handler: (_ref, args)=>{
        var { parser, funcName } = _ref;
        var base = args[0];
        return {
            type: "accentUnder",
            mode: parser.mode,
            label: funcName,
            base: base
        };
    },
    htmlBuilder: (group, options)=>{
        // Treat under accents much like underlines.
        var innerGroup = buildGroup$1(group.base, options);
        var accentBody = stretchy.svgSpan(group, options);
        var kern = group.label === "\\utilde" ? 0.12 : 0; // Generate the vlist, with the appropriate kerns
        var vlist = buildCommon.makeVList({
            positionType: "top",
            positionData: innerGroup.height,
            children: [
                {
                    type: "elem",
                    elem: accentBody,
                    wrapperClasses: [
                        "svg-align"
                    ]
                },
                {
                    type: "kern",
                    size: kern
                },
                {
                    type: "elem",
                    elem: innerGroup
                }
            ]
        }, options);
        return buildCommon.makeSpan([
            "mord",
            "accentunder"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        var accentNode = stretchy.mathMLnode(group.label);
        var node = new mathMLTree.MathNode("munder", [
            buildGroup(group.base, options),
            accentNode
        ]);
        node.setAttribute("accentunder", "true");
        return node;
    }
});
// Helper function
var paddedNode = (group)=>{
    var node = new mathMLTree.MathNode("mpadded", group ? [
        group
    ] : []);
    node.setAttribute("width", "+0.6em");
    node.setAttribute("lspace", "0.3em");
    return node;
}; // Stretchy arrows with an optional argument
defineFunction({
    type: "xArrow",
    names: [
        "\\xleftarrow",
        "\\xrightarrow",
        "\\xLeftarrow",
        "\\xRightarrow",
        "\\xleftrightarrow",
        "\\xLeftrightarrow",
        "\\xhookleftarrow",
        "\\xhookrightarrow",
        "\\xmapsto",
        "\\xrightharpoondown",
        "\\xrightharpoonup",
        "\\xleftharpoondown",
        "\\xleftharpoonup",
        "\\xrightleftharpoons",
        "\\xleftrightharpoons",
        "\\xlongequal",
        "\\xtwoheadrightarrow",
        "\\xtwoheadleftarrow",
        "\\xtofrom",
        // Direct use of these functions is discouraged and may break someday.
        "\\xrightleftarrows",
        "\\xrightequilibrium",
        "\\xleftequilibrium",
        "\\\\cdrightarrow",
        "\\\\cdleftarrow",
        "\\\\cdlongequal"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1
    },
    handler (_ref, args, optArgs) {
        var { parser, funcName } = _ref;
        return {
            type: "xArrow",
            mode: parser.mode,
            label: funcName,
            body: args[0],
            below: optArgs[0]
        };
    },
    // Flow is unable to correctly infer the type of `group`, even though it's
    // unambiguously determined from the passed-in `type` above.
    htmlBuilder (group, options) {
        var style = options.style; // Build the argument groups in the appropriate style.
        // Ref: amsmath.dtx:   \hbox{$\scriptstyle\mkern#3mu{#6}\mkern#4mu$}%
        // Some groups can return document fragments.  Handle those by wrapping
        // them in a span.
        var newOptions = options.havingStyle(style.sup());
        var upperGroup = buildCommon.wrapFragment(buildGroup$1(group.body, newOptions, options), options);
        var arrowPrefix = group.label.slice(0, 2) === "\\x" ? "x" : "cd";
        upperGroup.classes.push(arrowPrefix + "-arrow-pad");
        var lowerGroup;
        if (group.below) {
            // Build the lower group
            newOptions = options.havingStyle(style.sub());
            lowerGroup = buildCommon.wrapFragment(buildGroup$1(group.below, newOptions, options), options);
            lowerGroup.classes.push(arrowPrefix + "-arrow-pad");
        }
        var arrowBody = stretchy.svgSpan(group, options); // Re shift: Note that stretchy.svgSpan returned arrowBody.depth = 0.
        // The point we want on the math axis is at 0.5 * arrowBody.height.
        var arrowShift = -options.fontMetrics().axisHeight + 0.5 * arrowBody.height; // 2 mu kern. Ref: amsmath.dtx: #7\if0#2\else\mkern#2mu\fi
        var upperShift = -options.fontMetrics().axisHeight - 0.5 * arrowBody.height - 0.111; // 0.111 em = 2 mu
        if (upperGroup.depth > 0.25 || group.label === "\\xleftequilibrium") upperShift -= upperGroup.depth; // shift up if depth encroaches
         // Generate the vlist
        var vlist;
        if (lowerGroup) {
            var lowerShift = -options.fontMetrics().axisHeight + lowerGroup.height + 0.5 * arrowBody.height + 0.111;
            vlist = buildCommon.makeVList({
                positionType: "individualShift",
                children: [
                    {
                        type: "elem",
                        elem: upperGroup,
                        shift: upperShift
                    },
                    {
                        type: "elem",
                        elem: arrowBody,
                        shift: arrowShift
                    },
                    {
                        type: "elem",
                        elem: lowerGroup,
                        shift: lowerShift
                    }
                ]
            }, options);
        } else vlist = buildCommon.makeVList({
            positionType: "individualShift",
            children: [
                {
                    type: "elem",
                    elem: upperGroup,
                    shift: upperShift
                },
                {
                    type: "elem",
                    elem: arrowBody,
                    shift: arrowShift
                }
            ]
        }, options);
         // $FlowFixMe: Replace this with passing "svg-align" into makeVList.
        vlist.children[0].children[0].children[1].classes.push("svg-align");
        return buildCommon.makeSpan([
            "mrel",
            "x-arrow"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder (group, options) {
        var arrowNode = stretchy.mathMLnode(group.label);
        arrowNode.setAttribute("minsize", group.label.charAt(0) === "x" ? "1.75em" : "3.0em");
        var node;
        if (group.body) {
            var upperNode = paddedNode(buildGroup(group.body, options));
            if (group.below) {
                var lowerNode = paddedNode(buildGroup(group.below, options));
                node = new mathMLTree.MathNode("munderover", [
                    arrowNode,
                    lowerNode,
                    upperNode
                ]);
            } else node = new mathMLTree.MathNode("mover", [
                arrowNode,
                upperNode
            ]);
        } else if (group.below) {
            var _lowerNode = paddedNode(buildGroup(group.below, options));
            node = new mathMLTree.MathNode("munder", [
                arrowNode,
                _lowerNode
            ]);
        } else {
            // This should never happen.
            // Parser.js throws an error if there is no argument.
            node = paddedNode();
            node = new mathMLTree.MathNode("mover", [
                arrowNode,
                node
            ]);
        }
        return node;
    }
});
var makeSpan = buildCommon.makeSpan;
function htmlBuilder$9(group, options) {
    var elements = buildExpression$1(group.body, options, true);
    return makeSpan([
        group.mclass
    ], elements, options);
}
function mathmlBuilder$8(group, options) {
    var node;
    var inner = buildExpression(group.body, options);
    if (group.mclass === "minner") node = new mathMLTree.MathNode("mpadded", inner);
    else if (group.mclass === "mord") {
        if (group.isCharacterBox) {
            node = inner[0];
            node.type = "mi";
        } else node = new mathMLTree.MathNode("mi", inner);
    } else {
        if (group.isCharacterBox) {
            node = inner[0];
            node.type = "mo";
        } else node = new mathMLTree.MathNode("mo", inner);
         // Set spacing based on what is the most likely adjacent atom type.
        // See TeXbook p170.
        if (group.mclass === "mbin") {
            node.attributes.lspace = "0.22em"; // medium space
            node.attributes.rspace = "0.22em";
        } else if (group.mclass === "mpunct") {
            node.attributes.lspace = "0em";
            node.attributes.rspace = "0.17em"; // thinspace
        } else if (group.mclass === "mopen" || group.mclass === "mclose") {
            node.attributes.lspace = "0em";
            node.attributes.rspace = "0em";
        } else if (group.mclass === "minner") {
            node.attributes.lspace = "0.0556em"; // 1 mu is the most likely option
            node.attributes.width = "+0.1111em";
        } // MathML <mo> default space is 5/18 em, so <mrel> needs no action.
    // Ref: https://developer.mozilla.org/en-US/docs/Web/MathML/Element/mo
    }
    return node;
} // Math class commands except \mathop
defineFunction({
    type: "mclass",
    names: [
        "\\mathord",
        "\\mathbin",
        "\\mathrel",
        "\\mathopen",
        "\\mathclose",
        "\\mathpunct",
        "\\mathinner"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler (_ref, args) {
        var { parser, funcName } = _ref;
        var body = args[0];
        return {
            type: "mclass",
            mode: parser.mode,
            mclass: "m" + funcName.slice(5),
            // TODO(kevinb): don't prefix with 'm'
            body: ordargument(body),
            isCharacterBox: utils.isCharacterBox(body)
        };
    },
    htmlBuilder: htmlBuilder$9,
    mathmlBuilder: mathmlBuilder$8
});
var binrelClass = (arg)=>{
    // \binrel@ spacing varies with (bin|rel|ord) of the atom in the argument.
    // (by rendering separately and with {}s before and after, and measuring
    // the change in spacing).  We'll do roughly the same by detecting the
    // atom type directly.
    var atom = arg.type === "ordgroup" && arg.body.length ? arg.body[0] : arg;
    if (atom.type === "atom" && (atom.family === "bin" || atom.family === "rel")) return "m" + atom.family;
    else return "mord";
}; // \@binrel{x}{y} renders like y but as mbin/mrel/mord if x is mbin/mrel/mord.
// This is equivalent to \binrel@{x}\binrel@@{y} in AMSTeX.
defineFunction({
    type: "mclass",
    names: [
        "\\@binrel"
    ],
    props: {
        numArgs: 2
    },
    handler (_ref2, args) {
        var { parser } = _ref2;
        return {
            type: "mclass",
            mode: parser.mode,
            mclass: binrelClass(args[0]),
            body: ordargument(args[1]),
            isCharacterBox: utils.isCharacterBox(args[1])
        };
    }
}); // Build a relation or stacked op by placing one symbol on top of another
defineFunction({
    type: "mclass",
    names: [
        "\\stackrel",
        "\\overset",
        "\\underset"
    ],
    props: {
        numArgs: 2
    },
    handler (_ref3, args) {
        var { parser, funcName } = _ref3;
        var baseArg = args[1];
        var shiftedArg = args[0];
        var mclass;
        if (funcName !== "\\stackrel") // LaTeX applies \binrel spacing to \overset and \underset.
        mclass = binrelClass(baseArg);
        else mclass = "mrel"; // for \stackrel
        var baseOp = {
            type: "op",
            mode: baseArg.mode,
            limits: true,
            alwaysHandleSupSub: true,
            parentIsSupSub: false,
            symbol: false,
            suppressBaseShift: funcName !== "\\stackrel",
            body: ordargument(baseArg)
        };
        var supsub = {
            type: "supsub",
            mode: shiftedArg.mode,
            base: baseOp,
            sup: funcName === "\\underset" ? null : shiftedArg,
            sub: funcName === "\\underset" ? shiftedArg : null
        };
        return {
            type: "mclass",
            mode: parser.mode,
            mclass,
            body: [
                supsub
            ],
            isCharacterBox: utils.isCharacterBox(supsub)
        };
    },
    htmlBuilder: htmlBuilder$9,
    mathmlBuilder: mathmlBuilder$8
});
// \pmb is a simulation of bold font.
// The version of \pmb in ambsy.sty works by typesetting three copies
// with small offsets. We use CSS text-shadow.
// It's a hack. Not as good as a real bold font. Better than nothing.
defineFunction({
    type: "pmb",
    names: [
        "\\pmb"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser } = _ref;
        return {
            type: "pmb",
            mode: parser.mode,
            mclass: binrelClass(args[0]),
            body: ordargument(args[0])
        };
    },
    htmlBuilder (group, options) {
        var elements = buildExpression$1(group.body, options, true);
        var node = buildCommon.makeSpan([
            group.mclass
        ], elements, options);
        node.style.textShadow = "0.02em 0.01em 0.04px";
        return node;
    },
    mathmlBuilder (group, style) {
        var inner = buildExpression(group.body, style); // Wrap with an <mstyle> element.
        var node = new mathMLTree.MathNode("mstyle", inner);
        node.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px");
        return node;
    }
});
var cdArrowFunctionName = {
    ">": "\\\\cdrightarrow",
    "<": "\\\\cdleftarrow",
    "=": "\\\\cdlongequal",
    "A": "\\uparrow",
    "V": "\\downarrow",
    "|": "\\Vert",
    ".": "no arrow"
};
var newCell = ()=>{
    // Create an empty cell, to be filled below with parse nodes.
    // The parseTree from this module must be constructed like the
    // one created by parseArray(), so an empty CD cell must
    // be a ParseNode<"styling">. And CD is always displaystyle.
    // So these values are fixed and flow can do implicit typing.
    return {
        type: "styling",
        body: [],
        mode: "math",
        style: "display"
    };
};
var isStartOfArrow = (node)=>{
    return node.type === "textord" && node.text === "@";
};
var isLabelEnd = (node, endChar)=>{
    return (node.type === "mathord" || node.type === "atom") && node.text === endChar;
};
function cdArrow(arrowChar, labels, parser) {
    // Return a parse tree of an arrow and its labels.
    // This acts in a way similar to a macro expansion.
    var funcName = cdArrowFunctionName[arrowChar];
    switch(funcName){
        case "\\\\cdrightarrow":
        case "\\\\cdleftarrow":
            return parser.callFunction(funcName, [
                labels[0]
            ], [
                labels[1]
            ]);
        case "\\uparrow":
        case "\\downarrow":
            var leftLabel = parser.callFunction("\\\\cdleft", [
                labels[0]
            ], []);
            var bareArrow = {
                type: "atom",
                text: funcName,
                mode: "math",
                family: "rel"
            };
            var sizedArrow = parser.callFunction("\\Big", [
                bareArrow
            ], []);
            var rightLabel = parser.callFunction("\\\\cdright", [
                labels[1]
            ], []);
            var arrowGroup = {
                type: "ordgroup",
                mode: "math",
                body: [
                    leftLabel,
                    sizedArrow,
                    rightLabel
                ]
            };
            return parser.callFunction("\\\\cdparent", [
                arrowGroup
            ], []);
        case "\\\\cdlongequal":
            return parser.callFunction("\\\\cdlongequal", [], []);
        case "\\Vert":
            var arrow = {
                type: "textord",
                text: "\\Vert",
                mode: "math"
            };
            return parser.callFunction("\\Big", [
                arrow
            ], []);
        default:
            return {
                type: "textord",
                text: " ",
                mode: "math"
            };
    }
}
function parseCD(parser) {
    // Get the array's parse nodes with \\ temporarily mapped to \cr.
    var parsedRows = [];
    parser.gullet.beginGroup();
    parser.gullet.macros.set("\\cr", "\\\\\\relax");
    parser.gullet.beginGroup();
    while(true){
        // eslint-disable-line no-constant-condition
        // Get the parse nodes for the next row.
        parsedRows.push(parser.parseExpression(false, "\\\\"));
        parser.gullet.endGroup();
        parser.gullet.beginGroup();
        var next = parser.fetch().text;
        if (next === "&" || next === "\\\\") parser.consume();
        else if (next === "\\end") {
            if (parsedRows[parsedRows.length - 1].length === 0) parsedRows.pop(); // final row ended in \\
            break;
        } else throw new ParseError("Expected \\\\ or \\cr or \\end", parser.nextToken);
    }
    var row = [];
    var body = [
        row
    ]; // Loop thru the parse nodes. Collect them into cells and arrows.
    for(var i = 0; i < parsedRows.length; i++){
        // Start a new row.
        var rowNodes = parsedRows[i]; // Create the first cell.
        var cell = newCell();
        for(var j = 0; j < rowNodes.length; j++)if (!isStartOfArrow(rowNodes[j])) // If a parseNode is not an arrow, it goes into a cell.
        cell.body.push(rowNodes[j]);
        else {
            // Parse node j is an "@", the start of an arrow.
            // Before starting on the arrow, push the cell into `row`.
            row.push(cell); // Now collect parseNodes into an arrow.
            // The character after "@" defines the arrow type.
            j += 1;
            var arrowChar = assertSymbolNodeType(rowNodes[j]).text; // Create two empty label nodes. We may or may not use them.
            var labels = new Array(2);
            labels[0] = {
                type: "ordgroup",
                mode: "math",
                body: []
            };
            labels[1] = {
                type: "ordgroup",
                mode: "math",
                body: []
            }; // Process the arrow.
            if ("=|.".indexOf(arrowChar) > -1) ;
            else if ("<>AV".indexOf(arrowChar) > -1) // Four arrows, `@>>>`, `@<<<`, `@AAA`, and `@VVV`, each take
            // two optional labels. E.g. the right-point arrow syntax is
            // really:  @>{optional label}>{optional label}>
            // Collect parseNodes into labels.
            for(var labelNum = 0; labelNum < 2; labelNum++){
                var inLabel = true;
                for(var k = j + 1; k < rowNodes.length; k++){
                    if (isLabelEnd(rowNodes[k], arrowChar)) {
                        inLabel = false;
                        j = k;
                        break;
                    }
                    if (isStartOfArrow(rowNodes[k])) throw new ParseError("Missing a " + arrowChar + " character to complete a CD arrow.", rowNodes[k]);
                    labels[labelNum].body.push(rowNodes[k]);
                }
                if (inLabel) // isLabelEnd never returned a true.
                throw new ParseError("Missing a " + arrowChar + " character to complete a CD arrow.", rowNodes[j]);
            }
            else throw new ParseError("Expected one of \"<>AV=|.\" after @", rowNodes[j]);
             // Now join the arrow to its labels.
            var arrow = cdArrow(arrowChar, labels, parser); // Wrap the arrow in  ParseNode<"styling">.
            // This is done to match parseArray() behavior.
            var wrappedArrow = {
                type: "styling",
                body: [
                    arrow
                ],
                mode: "math",
                style: "display" // CD is always displaystyle.
            };
            row.push(wrappedArrow); // In CD's syntax, cells are implicit. That is, everything that
            // is not an arrow gets collected into a cell. So create an empty
            // cell now. It will collect upcoming parseNodes.
            cell = newCell();
        }
        if (i % 2 === 0) // Even-numbered rows consist of: cell, arrow, cell, arrow, ... cell
        // The last cell is not yet pushed into `row`, so:
        row.push(cell);
        else // Odd-numbered rows consist of: vert arrow, empty cell, ... vert arrow
        // Remove the empty cell that was placed at the beginning of `row`.
        row.shift();
        row = [];
        body.push(row);
    } // End row group
    parser.gullet.endGroup(); // End array group defining \\
    parser.gullet.endGroup(); // define column separation.
    var cols = new Array(body[0].length).fill({
        type: "align",
        align: "c",
        pregap: 0.25,
        // CD package sets \enskip between columns.
        postgap: 0.25 // So pre and post each get half an \enskip, i.e. 0.25em.
    });
    return {
        type: "array",
        mode: "math",
        body,
        arraystretch: 1,
        addJot: true,
        rowGaps: [
            null
        ],
        cols,
        colSeparationType: "CD",
        hLinesBeforeRow: new Array(body.length + 1).fill([])
    };
} // The functions below are not available for general use.
// They are here only for internal use by the {CD} environment in placing labels
// next to vertical arrows.
// We don't need any such functions for horizontal arrows because we can reuse
// the functionality that already exists for extensible arrows.
defineFunction({
    type: "cdlabel",
    names: [
        "\\\\cdleft",
        "\\\\cdright"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref, args) {
        var { parser, funcName } = _ref;
        return {
            type: "cdlabel",
            mode: parser.mode,
            side: funcName.slice(4),
            label: args[0]
        };
    },
    htmlBuilder (group, options) {
        var newOptions = options.havingStyle(options.style.sup());
        var label = buildCommon.wrapFragment(buildGroup$1(group.label, newOptions, options), options);
        label.classes.push("cd-label-" + group.side);
        label.style.bottom = makeEm(0.8 - label.depth); // Zero out label height & depth, so vertical align of arrow is set
        // by the arrow height, not by the label.
        label.height = 0;
        label.depth = 0;
        return label;
    },
    mathmlBuilder (group, options) {
        var label = new mathMLTree.MathNode("mrow", [
            buildGroup(group.label, options)
        ]);
        label = new mathMLTree.MathNode("mpadded", [
            label
        ]);
        label.setAttribute("width", "0");
        if (group.side === "left") label.setAttribute("lspace", "-1width");
         // We have to guess at vertical alignment. We know the arrow is 1.8em tall,
        // But we don't know the height or depth of the label.
        label.setAttribute("voffset", "0.7em");
        label = new mathMLTree.MathNode("mstyle", [
            label
        ]);
        label.setAttribute("displaystyle", "false");
        label.setAttribute("scriptlevel", "1");
        return label;
    }
});
defineFunction({
    type: "cdlabelparent",
    names: [
        "\\\\cdparent"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref2, args) {
        var { parser } = _ref2;
        return {
            type: "cdlabelparent",
            mode: parser.mode,
            fragment: args[0]
        };
    },
    htmlBuilder (group, options) {
        // Wrap the vertical arrow and its labels.
        // The parent gets position: relative. The child gets position: absolute.
        // So CSS can locate the label correctly.
        var parent = buildCommon.wrapFragment(buildGroup$1(group.fragment, options), options);
        parent.classes.push("cd-vert-arrow");
        return parent;
    },
    mathmlBuilder (group, options) {
        return new mathMLTree.MathNode("mrow", [
            buildGroup(group.fragment, options)
        ]);
    }
});
// {123} and converts into symbol with code 123.  It is used by the *macro*
// \char defined in macros.js.
defineFunction({
    type: "textord",
    names: [
        "\\@char"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser } = _ref;
        var arg = assertNodeType(args[0], "ordgroup");
        var group = arg.body;
        var number = "";
        for(var i = 0; i < group.length; i++){
            var node = assertNodeType(group[i], "textord");
            number += node.text;
        }
        var code = parseInt(number);
        var text;
        if (isNaN(code)) throw new ParseError("\\@char has non-numeric argument " + number); // If we drop IE support, the following code could be replaced with
        else if (code < 0 || code >= 0x10ffff) throw new ParseError("\\@char with invalid code point " + number);
        else if (code <= 0xffff) text = String.fromCharCode(code);
        else {
            // Astral code point; split into surrogate halves
            code -= 0x10000;
            text = String.fromCharCode((code >> 10) + 0xd800, (code & 0x3ff) + 0xdc00);
        }
        return {
            type: "textord",
            mode: parser.mode,
            text: text
        };
    }
});
var htmlBuilder$8 = (group, options)=>{
    var elements = buildExpression$1(group.body, options.withColor(group.color), false); // \color isn't supposed to affect the type of the elements it contains.
    // To accomplish this, we wrap the results in a fragment, so the inner
    // elements will be able to directly interact with their neighbors. For
    // example, `\color{red}{2 +} 3` has the same spacing as `2 + 3`
    return buildCommon.makeFragment(elements);
};
var mathmlBuilder$7 = (group, options)=>{
    var inner = buildExpression(group.body, options.withColor(group.color));
    var node = new mathMLTree.MathNode("mstyle", inner);
    node.setAttribute("mathcolor", group.color);
    return node;
};
defineFunction({
    type: "color",
    names: [
        "\\textcolor"
    ],
    props: {
        numArgs: 2,
        allowedInText: true,
        argTypes: [
            "color",
            "original"
        ]
    },
    handler (_ref, args) {
        var { parser } = _ref;
        var color = assertNodeType(args[0], "color-token").color;
        var body = args[1];
        return {
            type: "color",
            mode: parser.mode,
            color,
            body: ordargument(body)
        };
    },
    htmlBuilder: htmlBuilder$8,
    mathmlBuilder: mathmlBuilder$7
});
defineFunction({
    type: "color",
    names: [
        "\\color"
    ],
    props: {
        numArgs: 1,
        allowedInText: true,
        argTypes: [
            "color"
        ]
    },
    handler (_ref2, args) {
        var { parser, breakOnTokenText } = _ref2;
        var color = assertNodeType(args[0], "color-token").color; // Set macro \current@color in current namespace to store the current
        // color, mimicking the behavior of color.sty.
        // This is currently used just to correctly color a \right
        // that follows a \color command.
        parser.gullet.macros.set("\\current@color", color); // Parse out the implicit body that should be colored.
        var body = parser.parseExpression(true, breakOnTokenText);
        return {
            type: "color",
            mode: parser.mode,
            color,
            body
        };
    },
    htmlBuilder: htmlBuilder$8,
    mathmlBuilder: mathmlBuilder$7
});
// Row breaks within tabular environments, and line breaks at top level
defineFunction({
    type: "cr",
    names: [
        "\\\\"
    ],
    props: {
        numArgs: 0,
        numOptionalArgs: 0,
        allowedInText: true
    },
    handler (_ref, args, optArgs) {
        var { parser } = _ref;
        var size = parser.gullet.future().text === "[" ? parser.parseSizeGroup(true) : null;
        var newLine = !parser.settings.displayMode || !parser.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
        return {
            type: "cr",
            mode: parser.mode,
            newLine,
            size: size && assertNodeType(size, "size").value
        };
    },
    // The following builders are called only at the top level,
    // not within tabular/array environments.
    htmlBuilder (group, options) {
        var span = buildCommon.makeSpan([
            "mspace"
        ], [], options);
        if (group.newLine) {
            span.classes.push("newline");
            if (group.size) span.style.marginTop = makeEm(calculateSize(group.size, options));
        }
        return span;
    },
    mathmlBuilder (group, options) {
        var node = new mathMLTree.MathNode("mspace");
        if (group.newLine) {
            node.setAttribute("linebreak", "newline");
            if (group.size) node.setAttribute("height", makeEm(calculateSize(group.size, options)));
        }
        return node;
    }
});
var globalMap = {
    "\\global": "\\global",
    "\\long": "\\\\globallong",
    "\\\\globallong": "\\\\globallong",
    "\\def": "\\gdef",
    "\\gdef": "\\gdef",
    "\\edef": "\\xdef",
    "\\xdef": "\\xdef",
    "\\let": "\\\\globallet",
    "\\futurelet": "\\\\globalfuture"
};
var checkControlSequence = (tok)=>{
    var name = tok.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(name)) throw new ParseError("Expected a control sequence", tok);
    return name;
};
var getRHS = (parser)=>{
    var tok = parser.gullet.popToken();
    if (tok.text === "=") {
        // consume optional equals
        tok = parser.gullet.popToken();
        if (tok.text === " ") // consume one optional space
        tok = parser.gullet.popToken();
    }
    return tok;
};
var letCommand = (parser, name, tok, global)=>{
    var macro = parser.gullet.macros.get(tok.text);
    if (macro == null) {
        // don't expand it later even if a macro with the same name is defined
        // e.g., \let\foo=\frac \def\frac{\relax} \frac12
        tok.noexpand = true;
        macro = {
            tokens: [
                tok
            ],
            numArgs: 0,
            // reproduce the same behavior in expansion
            unexpandable: !parser.gullet.isExpandable(tok.text)
        };
    }
    parser.gullet.macros.set(name, macro, global);
}; // <assignment> -> <non-macro assignment>|<macro assignment>
// <non-macro assignment> -> <simple assignment>|\global<non-macro assignment>
// <macro assignment> -> <definition>|<prefix><macro assignment>
// <prefix> -> \global|\long|\outer
defineFunction({
    type: "internal",
    names: [
        "\\global",
        "\\long",
        "\\\\globallong" // can’t be entered directly
    ],
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler (_ref) {
        var { parser, funcName } = _ref;
        parser.consumeSpaces();
        var token = parser.fetch();
        if (globalMap[token.text]) {
            // KaTeX doesn't have \par, so ignore \long
            if (funcName === "\\global" || funcName === "\\\\globallong") token.text = globalMap[token.text];
            return assertNodeType(parser.parseFunction(), "internal");
        }
        throw new ParseError("Invalid token after macro prefix", token);
    }
}); // Basic support for macro definitions: \def, \gdef, \edef, \xdef
// <definition> -> <def><control sequence><definition text>
// <def> -> \def|\gdef|\edef|\xdef
// <definition text> -> <parameter text><left brace><balanced text><right brace>
defineFunction({
    type: "internal",
    names: [
        "\\def",
        "\\gdef",
        "\\edef",
        "\\xdef"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref2) {
        var { parser, funcName } = _ref2;
        var tok = parser.gullet.popToken();
        var name = tok.text;
        if (/^(?:[\\{}$&#^_]|EOF)$/.test(name)) throw new ParseError("Expected a control sequence", tok);
        var numArgs = 0;
        var insert;
        var delimiters = [
            []
        ]; // <parameter text> contains no braces
        while(parser.gullet.future().text !== "{"){
            tok = parser.gullet.popToken();
            if (tok.text === "#") {
                // If the very last character of the <parameter text> is #, so that
                // this # is immediately followed by {, TeX will behave as if the {
                // had been inserted at the right end of both the parameter text
                // and the replacement text.
                if (parser.gullet.future().text === "{") {
                    insert = parser.gullet.future();
                    delimiters[numArgs].push("{");
                    break;
                } // A parameter, the first appearance of # must be followed by 1,
                // the next by 2, and so on; up to nine #’s are allowed
                tok = parser.gullet.popToken();
                if (!/^[1-9]$/.test(tok.text)) throw new ParseError("Invalid argument number \"" + tok.text + "\"");
                if (parseInt(tok.text) !== numArgs + 1) throw new ParseError("Argument number \"" + tok.text + "\" out of order");
                numArgs++;
                delimiters.push([]);
            } else if (tok.text === "EOF") throw new ParseError("Expected a macro definition");
            else delimiters[numArgs].push(tok.text);
        } // replacement text, enclosed in '{' and '}' and properly nested
        var { tokens } = parser.gullet.consumeArg();
        if (insert) tokens.unshift(insert);
        if (funcName === "\\edef" || funcName === "\\xdef") {
            tokens = parser.gullet.expandTokens(tokens);
            tokens.reverse(); // to fit in with stack order
        } // Final arg is the expansion of the macro
        parser.gullet.macros.set(name, {
            tokens,
            numArgs,
            delimiters
        }, funcName === globalMap[funcName]);
        return {
            type: "internal",
            mode: parser.mode
        };
    }
}); // <simple assignment> -> <let assignment>
// <let assignment> -> \futurelet<control sequence><token><token>
//     | \let<control sequence><equals><one optional space><token>
// <equals> -> <optional spaces>|<optional spaces>=
defineFunction({
    type: "internal",
    names: [
        "\\let",
        "\\\\globallet" // can’t be entered directly
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref3) {
        var { parser, funcName } = _ref3;
        var name = checkControlSequence(parser.gullet.popToken());
        parser.gullet.consumeSpaces();
        var tok = getRHS(parser);
        letCommand(parser, name, tok, funcName === "\\\\globallet");
        return {
            type: "internal",
            mode: parser.mode
        };
    }
}); // ref: https://www.tug.org/TUGboat/tb09-3/tb22bechtolsheim.pdf
defineFunction({
    type: "internal",
    names: [
        "\\futurelet",
        "\\\\globalfuture" // can’t be entered directly
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref4) {
        var { parser, funcName } = _ref4;
        var name = checkControlSequence(parser.gullet.popToken());
        var middle = parser.gullet.popToken();
        var tok = parser.gullet.popToken();
        letCommand(parser, name, tok, funcName === "\\\\globalfuture");
        parser.gullet.pushToken(tok);
        parser.gullet.pushToken(middle);
        return {
            type: "internal",
            mode: parser.mode
        };
    }
});
/**
 * This file deals with creating delimiters of various sizes. The TeXbook
 * discusses these routines on page 441-442, in the "Another subroutine sets box
 * x to a specified variable delimiter" paragraph.
 *
 * There are three main routines here. `makeSmallDelim` makes a delimiter in the
 * normal font, but in either text, script, or scriptscript style.
 * `makeLargeDelim` makes a delimiter in textstyle, but in one of the Size1,
 * Size2, Size3, or Size4 fonts. `makeStackedDelim` makes a delimiter out of
 * smaller pieces that are stacked on top of one another.
 *
 * The functions take a parameter `center`, which determines if the delimiter
 * should be centered around the axis.
 *
 * Then, there are three exposed functions. `sizedDelim` makes a delimiter in
 * one of the given sizes. This is used for things like `\bigl`.
 * `customSizedDelim` makes a delimiter with a given total height+depth. It is
 * called in places like `\sqrt`. `leftRightDelim` makes an appropriate
 * delimiter which surrounds an expression of a given height an depth. It is
 * used in `\left` and `\right`.
 */ /**
 * Get the metrics for a given symbol and font, after transformation (i.e.
 * after following replacement from symbols.js)
 */ var getMetrics = function getMetrics(symbol, font, mode) {
    var replace = symbols.math[symbol] && symbols.math[symbol].replace;
    var metrics = getCharacterMetrics(replace || symbol, font, mode);
    if (!metrics) throw new Error("Unsupported symbol " + symbol + " and font size " + font + ".");
    return metrics;
};
/**
 * Puts a delimiter span in a given style, and adds appropriate height, depth,
 * and maxFontSizes.
 */ var styleWrap = function styleWrap(delim, toStyle, options, classes) {
    var newOptions = options.havingBaseStyle(toStyle);
    var span = buildCommon.makeSpan(classes.concat(newOptions.sizingClasses(options)), [
        delim
    ], options);
    var delimSizeMultiplier = newOptions.sizeMultiplier / options.sizeMultiplier;
    span.height *= delimSizeMultiplier;
    span.depth *= delimSizeMultiplier;
    span.maxFontSize = newOptions.sizeMultiplier;
    return span;
};
var centerSpan = function centerSpan(span, options, style) {
    var newOptions = options.havingBaseStyle(style);
    var shift = (1 - options.sizeMultiplier / newOptions.sizeMultiplier) * options.fontMetrics().axisHeight;
    span.classes.push("delimcenter");
    span.style.top = makeEm(shift);
    span.height -= shift;
    span.depth += shift;
};
/**
 * Makes a small delimiter. This is a delimiter that comes in the Main-Regular
 * font, but is restyled to either be in textstyle, scriptstyle, or
 * scriptscriptstyle.
 */ var makeSmallDelim = function makeSmallDelim(delim, style, center, options, mode, classes) {
    var text = buildCommon.makeSymbol(delim, "Main-Regular", mode, options);
    var span = styleWrap(text, style, options, classes);
    if (center) centerSpan(span, options, style);
    return span;
};
/**
 * Builds a symbol in the given font size (note size is an integer)
 */ var mathrmSize = function mathrmSize(value, size, mode, options) {
    return buildCommon.makeSymbol(value, "Size" + size + "-Regular", mode, options);
};
/**
 * Makes a large delimiter. This is a delimiter that comes in the Size1, Size2,
 * Size3, or Size4 fonts. It is always rendered in textstyle.
 */ var makeLargeDelim = function makeLargeDelim(delim, size, center, options, mode, classes) {
    var inner = mathrmSize(delim, size, mode, options);
    var span = styleWrap(buildCommon.makeSpan([
        "delimsizing",
        "size" + size
    ], [
        inner
    ], options), Style$1.TEXT, options, classes);
    if (center) centerSpan(span, options, Style$1.TEXT);
    return span;
};
/**
 * Make a span from a font glyph with the given offset and in the given font.
 * This is used in makeStackedDelim to make the stacking pieces for the delimiter.
 */ var makeGlyphSpan = function makeGlyphSpan(symbol, font, mode) {
    var sizeClass; // Apply the correct CSS class to choose the right font.
    if (font === "Size1-Regular") sizeClass = "delim-size1";
    else sizeClass = "delim-size4";
    var corner = buildCommon.makeSpan([
        "delimsizinginner",
        sizeClass
    ], [
        buildCommon.makeSpan([], [
            buildCommon.makeSymbol(symbol, font, mode)
        ])
    ]); // Since this will be passed into `makeVList` in the end, wrap the element
    // in the appropriate tag that VList uses.
    return {
        type: "elem",
        elem: corner
    };
};
var makeInner = function makeInner(ch, height, options) {
    // Create a span with inline SVG for the inner part of a tall stacked delimiter.
    var width = fontMetricsData['Size4-Regular'][ch.charCodeAt(0)] ? fontMetricsData['Size4-Regular'][ch.charCodeAt(0)][4] : fontMetricsData['Size1-Regular'][ch.charCodeAt(0)][4];
    var path = new PathNode("inner", innerPath(ch, Math.round(1000 * height)));
    var svgNode = new SvgNode([
        path
    ], {
        "width": makeEm(width),
        "height": makeEm(height),
        // Override CSS rule `.katex svg { width: 100% }`
        "style": "width:" + makeEm(width),
        "viewBox": "0 0 " + 1000 * width + " " + Math.round(1000 * height),
        "preserveAspectRatio": "xMinYMin"
    });
    var span = buildCommon.makeSvgSpan([], [
        svgNode
    ], options);
    span.height = height;
    span.style.height = makeEm(height);
    span.style.width = makeEm(width);
    return {
        type: "elem",
        elem: span
    };
}; // Helpers for makeStackedDelim
var lapInEms = 0.008;
var lap = {
    type: "kern",
    size: -1 * lapInEms
};
var verts = [
    "|",
    "\\lvert",
    "\\rvert",
    "\\vert"
];
var doubleVerts = [
    "\\|",
    "\\lVert",
    "\\rVert",
    "\\Vert"
];
/**
 * Make a stacked delimiter out of a given delimiter, with the total height at
 * least `heightTotal`. This routine is mentioned on page 442 of the TeXbook.
 */ var makeStackedDelim = function makeStackedDelim(delim, heightTotal, center, options, mode, classes) {
    // There are four parts, the top, an optional middle, a repeated part, and a
    // bottom.
    var top;
    var middle;
    var repeat;
    var bottom;
    var svgLabel = "";
    var viewBoxWidth = 0;
    top = repeat = bottom = delim;
    middle = null; // Also keep track of what font the delimiters are in
    var font = "Size1-Regular"; // We set the parts and font based on the symbol. Note that we use
    // '\u23d0' instead of '|' and '\u2016' instead of '\\|' for the
    // repeats of the arrows
    if (delim === "\\uparrow") repeat = bottom = "\u23d0";
    else if (delim === "\\Uparrow") repeat = bottom = "\u2016";
    else if (delim === "\\downarrow") top = repeat = "\u23d0";
    else if (delim === "\\Downarrow") top = repeat = "\u2016";
    else if (delim === "\\updownarrow") {
        top = "\\uparrow";
        repeat = "\u23d0";
        bottom = "\\downarrow";
    } else if (delim === "\\Updownarrow") {
        top = "\\Uparrow";
        repeat = "\u2016";
        bottom = "\\Downarrow";
    } else if (verts.includes(delim)) {
        repeat = "\u2223";
        svgLabel = "vert";
        viewBoxWidth = 333;
    } else if (doubleVerts.includes(delim)) {
        repeat = "\u2225";
        svgLabel = "doublevert";
        viewBoxWidth = 556;
    } else if (delim === "[" || delim === "\\lbrack") {
        top = "\u23a1";
        repeat = "\u23a2";
        bottom = "\u23a3";
        font = "Size4-Regular";
        svgLabel = "lbrack";
        viewBoxWidth = 667;
    } else if (delim === "]" || delim === "\\rbrack") {
        top = "\u23a4";
        repeat = "\u23a5";
        bottom = "\u23a6";
        font = "Size4-Regular";
        svgLabel = "rbrack";
        viewBoxWidth = 667;
    } else if (delim === "\\lfloor" || delim === "\u230a") {
        repeat = top = "\u23a2";
        bottom = "\u23a3";
        font = "Size4-Regular";
        svgLabel = "lfloor";
        viewBoxWidth = 667;
    } else if (delim === "\\lceil" || delim === "\u2308") {
        top = "\u23a1";
        repeat = bottom = "\u23a2";
        font = "Size4-Regular";
        svgLabel = "lceil";
        viewBoxWidth = 667;
    } else if (delim === "\\rfloor" || delim === "\u230b") {
        repeat = top = "\u23a5";
        bottom = "\u23a6";
        font = "Size4-Regular";
        svgLabel = "rfloor";
        viewBoxWidth = 667;
    } else if (delim === "\\rceil" || delim === "\u2309") {
        top = "\u23a4";
        repeat = bottom = "\u23a5";
        font = "Size4-Regular";
        svgLabel = "rceil";
        viewBoxWidth = 667;
    } else if (delim === "(" || delim === "\\lparen") {
        top = "\u239b";
        repeat = "\u239c";
        bottom = "\u239d";
        font = "Size4-Regular";
        svgLabel = "lparen";
        viewBoxWidth = 875;
    } else if (delim === ")" || delim === "\\rparen") {
        top = "\u239e";
        repeat = "\u239f";
        bottom = "\u23a0";
        font = "Size4-Regular";
        svgLabel = "rparen";
        viewBoxWidth = 875;
    } else if (delim === "\\{" || delim === "\\lbrace") {
        top = "\u23a7";
        middle = "\u23a8";
        bottom = "\u23a9";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\}" || delim === "\\rbrace") {
        top = "\u23ab";
        middle = "\u23ac";
        bottom = "\u23ad";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\lgroup" || delim === "\u27ee") {
        top = "\u23a7";
        bottom = "\u23a9";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\rgroup" || delim === "\u27ef") {
        top = "\u23ab";
        bottom = "\u23ad";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\lmoustache" || delim === "\u23b0") {
        top = "\u23a7";
        bottom = "\u23ad";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } else if (delim === "\\rmoustache" || delim === "\u23b1") {
        top = "\u23ab";
        bottom = "\u23a9";
        repeat = "\u23aa";
        font = "Size4-Regular";
    } // Get the metrics of the four sections
    var topMetrics = getMetrics(top, font, mode);
    var topHeightTotal = topMetrics.height + topMetrics.depth;
    var repeatMetrics = getMetrics(repeat, font, mode);
    var repeatHeightTotal = repeatMetrics.height + repeatMetrics.depth;
    var bottomMetrics = getMetrics(bottom, font, mode);
    var bottomHeightTotal = bottomMetrics.height + bottomMetrics.depth;
    var middleHeightTotal = 0;
    var middleFactor = 1;
    if (middle !== null) {
        var middleMetrics = getMetrics(middle, font, mode);
        middleHeightTotal = middleMetrics.height + middleMetrics.depth;
        middleFactor = 2; // repeat symmetrically above and below middle
    } // Calculate the minimal height that the delimiter can have.
    // It is at least the size of the top, bottom, and optional middle combined.
    var minHeight = topHeightTotal + bottomHeightTotal + middleHeightTotal; // Compute the number of copies of the repeat symbol we will need
    var repeatCount = Math.max(0, Math.ceil((heightTotal - minHeight) / (middleFactor * repeatHeightTotal))); // Compute the total height of the delimiter including all the symbols
    var realHeightTotal = minHeight + repeatCount * middleFactor * repeatHeightTotal; // The center of the delimiter is placed at the center of the axis. Note
    // that in this context, "center" means that the delimiter should be
    // centered around the axis in the current style, while normally it is
    // centered around the axis in textstyle.
    var axisHeight = options.fontMetrics().axisHeight;
    if (center) axisHeight *= options.sizeMultiplier;
     // Calculate the depth
    var depth = realHeightTotal / 2 - axisHeight; // Now, we start building the pieces that will go into the vlist
    // Keep a list of the pieces of the stacked delimiter
    var stack = [];
    if (svgLabel.length > 0) {
        // Instead of stacking glyphs, create a single SVG.
        // This evades browser problems with imprecise positioning of spans.
        var midHeight = realHeightTotal - topHeightTotal - bottomHeightTotal;
        var viewBoxHeight = Math.round(realHeightTotal * 1000);
        var pathStr = tallDelim(svgLabel, Math.round(midHeight * 1000));
        var path = new PathNode(svgLabel, pathStr);
        var width = (viewBoxWidth / 1000).toFixed(3) + "em";
        var height = (viewBoxHeight / 1000).toFixed(3) + "em";
        var svg = new SvgNode([
            path
        ], {
            "width": width,
            "height": height,
            "viewBox": "0 0 " + viewBoxWidth + " " + viewBoxHeight
        });
        var wrapper = buildCommon.makeSvgSpan([], [
            svg
        ], options);
        wrapper.height = viewBoxHeight / 1000;
        wrapper.style.width = width;
        wrapper.style.height = height;
        stack.push({
            type: "elem",
            elem: wrapper
        });
    } else {
        // Stack glyphs
        // Start by adding the bottom symbol
        stack.push(makeGlyphSpan(bottom, font, mode));
        stack.push(lap); // overlap
        if (middle === null) {
            // The middle section will be an SVG. Make it an extra 0.016em tall.
            // We'll overlap by 0.008em at top and bottom.
            var innerHeight = realHeightTotal - topHeightTotal - bottomHeightTotal + 2 * lapInEms;
            stack.push(makeInner(repeat, innerHeight, options));
        } else {
            // When there is a middle bit, we need the middle part and two repeated
            // sections
            var _innerHeight = (realHeightTotal - topHeightTotal - bottomHeightTotal - middleHeightTotal) / 2 + 2 * lapInEms;
            stack.push(makeInner(repeat, _innerHeight, options)); // Now insert the middle of the brace.
            stack.push(lap);
            stack.push(makeGlyphSpan(middle, font, mode));
            stack.push(lap);
            stack.push(makeInner(repeat, _innerHeight, options));
        } // Add the top symbol
        stack.push(lap);
        stack.push(makeGlyphSpan(top, font, mode));
    } // Finally, build the vlist
    var newOptions = options.havingBaseStyle(Style$1.TEXT);
    var inner = buildCommon.makeVList({
        positionType: "bottom",
        positionData: depth,
        children: stack
    }, newOptions);
    return styleWrap(buildCommon.makeSpan([
        "delimsizing",
        "mult"
    ], [
        inner
    ], newOptions), Style$1.TEXT, options, classes);
}; // All surds have 0.08em padding above the vinculum inside the SVG.
// That keeps browser span height rounding error from pinching the line.
var vbPad = 80; // padding above the surd, measured inside the viewBox.
var emPad = 0.08; // padding, in ems, measured in the document.
var sqrtSvg = function sqrtSvg(sqrtName, height, viewBoxHeight, extraVinculum, options) {
    var path = sqrtPath(sqrtName, extraVinculum, viewBoxHeight);
    var pathNode = new PathNode(sqrtName, path);
    var svg = new SvgNode([
        pathNode
    ], {
        // Note: 1000:1 ratio of viewBox to document em width.
        "width": "400em",
        "height": makeEm(height),
        "viewBox": "0 0 400000 " + viewBoxHeight,
        "preserveAspectRatio": "xMinYMin slice"
    });
    return buildCommon.makeSvgSpan([
        "hide-tail"
    ], [
        svg
    ], options);
};
/**
 * Make a sqrt image of the given height,
 */ var makeSqrtImage = function makeSqrtImage(height, options) {
    // Define a newOptions that removes the effect of size changes such as \Huge.
    // We don't pick different a height surd for \Huge. For it, we scale up.
    var newOptions = options.havingBaseSizing(); // Pick the desired surd glyph from a sequence of surds.
    var delim = traverseSequence("\\surd", height * newOptions.sizeMultiplier, stackLargeDelimiterSequence, newOptions);
    var sizeMultiplier = newOptions.sizeMultiplier; // default
    // The standard sqrt SVGs each have a 0.04em thick vinculum.
    // If Settings.minRuleThickness is larger than that, we add extraVinculum.
    var extraVinculum = Math.max(0, options.minRuleThickness - options.fontMetrics().sqrtRuleThickness); // Create a span containing an SVG image of a sqrt symbol.
    var span;
    var spanHeight = 0;
    var texHeight = 0;
    var viewBoxHeight = 0;
    var advanceWidth; // We create viewBoxes with 80 units of "padding" above each surd.
    // Then browser rounding error on the parent span height will not
    // encroach on the ink of the vinculum. But that padding is not
    // included in the TeX-like `height` used for calculation of
    // vertical alignment. So texHeight = span.height < span.style.height.
    if (delim.type === "small") {
        // Get an SVG that is derived from glyph U+221A in font KaTeX-Main.
        // 1000 unit normal glyph height.
        viewBoxHeight = 1000 + 1000 * extraVinculum + vbPad;
        if (height < 1.0) sizeMultiplier = 1.0; // mimic a \textfont radical
        else if (height < 1.4) sizeMultiplier = 0.7; // mimic a \scriptfont radical
        spanHeight = (1.0 + extraVinculum + emPad) / sizeMultiplier;
        texHeight = (1.00 + extraVinculum) / sizeMultiplier;
        span = sqrtSvg("sqrtMain", spanHeight, viewBoxHeight, extraVinculum, options);
        span.style.minWidth = "0.853em";
        advanceWidth = 0.833 / sizeMultiplier; // from the font.
    } else if (delim.type === "large") {
        // These SVGs come from fonts: KaTeX_Size1, _Size2, etc.
        viewBoxHeight = (1000 + vbPad) * sizeToMaxHeight[delim.size];
        texHeight = (sizeToMaxHeight[delim.size] + extraVinculum) / sizeMultiplier;
        spanHeight = (sizeToMaxHeight[delim.size] + extraVinculum + emPad) / sizeMultiplier;
        span = sqrtSvg("sqrtSize" + delim.size, spanHeight, viewBoxHeight, extraVinculum, options);
        span.style.minWidth = "1.02em";
        advanceWidth = 1.0 / sizeMultiplier; // 1.0 from the font.
    } else {
        // Tall sqrt. In TeX, this would be stacked using multiple glyphs.
        // We'll use a single SVG to accomplish the same thing.
        spanHeight = height + extraVinculum + emPad;
        texHeight = height + extraVinculum;
        viewBoxHeight = Math.floor(1000 * height + extraVinculum) + vbPad;
        span = sqrtSvg("sqrtTall", spanHeight, viewBoxHeight, extraVinculum, options);
        span.style.minWidth = "0.742em";
        advanceWidth = 1.056;
    }
    span.height = texHeight;
    span.style.height = makeEm(spanHeight);
    return {
        span,
        advanceWidth,
        // Calculate the actual line width.
        // This actually should depend on the chosen font -- e.g. \boldmath
        // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
        // have thicker rules.
        ruleWidth: (options.fontMetrics().sqrtRuleThickness + extraVinculum) * sizeMultiplier
    };
}; // There are three kinds of delimiters, delimiters that stack when they become
// too large
var stackLargeDelimiters = [
    "(",
    "\\lparen",
    ")",
    "\\rparen",
    "[",
    "\\lbrack",
    "]",
    "\\rbrack",
    "\\{",
    "\\lbrace",
    "\\}",
    "\\rbrace",
    "\\lfloor",
    "\\rfloor",
    "\u230a",
    "\u230b",
    "\\lceil",
    "\\rceil",
    "\u2308",
    "\u2309",
    "\\surd"
]; // delimiters that always stack
var stackAlwaysDelimiters = [
    "\\uparrow",
    "\\downarrow",
    "\\updownarrow",
    "\\Uparrow",
    "\\Downarrow",
    "\\Updownarrow",
    "|",
    "\\|",
    "\\vert",
    "\\Vert",
    "\\lvert",
    "\\rvert",
    "\\lVert",
    "\\rVert",
    "\\lgroup",
    "\\rgroup",
    "\u27ee",
    "\u27ef",
    "\\lmoustache",
    "\\rmoustache",
    "\u23b0",
    "\u23b1"
]; // and delimiters that never stack
var stackNeverDelimiters = [
    "<",
    ">",
    "\\langle",
    "\\rangle",
    "/",
    "\\backslash",
    "\\lt",
    "\\gt"
]; // Metrics of the different sizes. Found by looking at TeX's output of
// $\bigl| // \Bigl| \biggl| \Biggl| \showlists$
// Used to create stacked delimiters of appropriate sizes in makeSizedDelim.
var sizeToMaxHeight = [
    0,
    1.2,
    1.8,
    2.4,
    3.0
];
/**
 * Used to create a delimiter of a specific size, where `size` is 1, 2, 3, or 4.
 */ var makeSizedDelim = function makeSizedDelim(delim, size, options, mode, classes) {
    // < and > turn into \langle and \rangle in delimiters
    if (delim === "<" || delim === "\\lt" || delim === "\u27e8") delim = "\\langle";
    else if (delim === ">" || delim === "\\gt" || delim === "\u27e9") delim = "\\rangle";
     // Sized delimiters are never centered.
    if (stackLargeDelimiters.includes(delim) || stackNeverDelimiters.includes(delim)) return makeLargeDelim(delim, size, false, options, mode, classes);
    else if (stackAlwaysDelimiters.includes(delim)) return makeStackedDelim(delim, sizeToMaxHeight[size], false, options, mode, classes);
    else throw new ParseError("Illegal delimiter: '" + delim + "'");
};
/**
 * There are three different sequences of delimiter sizes that the delimiters
 * follow depending on the kind of delimiter. This is used when creating custom
 * sized delimiters to decide whether to create a small, large, or stacked
 * delimiter.
 *
 * In real TeX, these sequences aren't explicitly defined, but are instead
 * defined inside the font metrics. Since there are only three sequences that
 * are possible for the delimiters that TeX defines, it is easier to just encode
 * them explicitly here.
 */ // Delimiters that never stack try small delimiters and large delimiters only
var stackNeverDelimiterSequence = [
    {
        type: "small",
        style: Style$1.SCRIPTSCRIPT
    },
    {
        type: "small",
        style: Style$1.SCRIPT
    },
    {
        type: "small",
        style: Style$1.TEXT
    },
    {
        type: "large",
        size: 1
    },
    {
        type: "large",
        size: 2
    },
    {
        type: "large",
        size: 3
    },
    {
        type: "large",
        size: 4
    }
]; // Delimiters that always stack try the small delimiters first, then stack
var stackAlwaysDelimiterSequence = [
    {
        type: "small",
        style: Style$1.SCRIPTSCRIPT
    },
    {
        type: "small",
        style: Style$1.SCRIPT
    },
    {
        type: "small",
        style: Style$1.TEXT
    },
    {
        type: "stack"
    }
]; // Delimiters that stack when large try the small and then large delimiters, and
// stack afterwards
var stackLargeDelimiterSequence = [
    {
        type: "small",
        style: Style$1.SCRIPTSCRIPT
    },
    {
        type: "small",
        style: Style$1.SCRIPT
    },
    {
        type: "small",
        style: Style$1.TEXT
    },
    {
        type: "large",
        size: 1
    },
    {
        type: "large",
        size: 2
    },
    {
        type: "large",
        size: 3
    },
    {
        type: "large",
        size: 4
    },
    {
        type: "stack"
    }
];
/**
 * Get the font used in a delimiter based on what kind of delimiter it is.
 * TODO(#963) Use more specific font family return type once that is introduced.
 */ var delimTypeToFont = function delimTypeToFont(type) {
    if (type.type === "small") return "Main-Regular";
    else if (type.type === "large") return "Size" + type.size + "-Regular";
    else if (type.type === "stack") return "Size4-Regular";
    else throw new Error("Add support for delim type '" + type.type + "' here.");
};
/**
 * Traverse a sequence of types of delimiters to decide what kind of delimiter
 * should be used to create a delimiter of the given height+depth.
 */ var traverseSequence = function traverseSequence(delim, height, sequence, options) {
    // Here, we choose the index we should start at in the sequences. In smaller
    // sizes (which correspond to larger numbers in style.size) we start earlier
    // in the sequence. Thus, scriptscript starts at index 3-3=0, script starts
    // at index 3-2=1, text starts at 3-1=2, and display starts at min(2,3-0)=2
    var start = Math.min(2, 3 - options.style.size);
    for(var i = start; i < sequence.length; i++){
        if (sequence[i].type === "stack") break;
        var metrics = getMetrics(delim, delimTypeToFont(sequence[i]), "math");
        var heightDepth = metrics.height + metrics.depth; // Small delimiters are scaled down versions of the same font, so we
        // account for the style change size.
        if (sequence[i].type === "small") {
            var newOptions = options.havingBaseStyle(sequence[i].style);
            heightDepth *= newOptions.sizeMultiplier;
        } // Check if the delimiter at this size works for the given height.
        if (heightDepth > height) return sequence[i];
    } // If we reached the end of the sequence, return the last sequence element.
    return sequence[sequence.length - 1];
};
/**
 * Make a delimiter of a given height+depth, with optional centering. Here, we
 * traverse the sequences, and create a delimiter that the sequence tells us to.
 */ var makeCustomSizedDelim = function makeCustomSizedDelim(delim, height, center, options, mode, classes) {
    if (delim === "<" || delim === "\\lt" || delim === "\u27e8") delim = "\\langle";
    else if (delim === ">" || delim === "\\gt" || delim === "\u27e9") delim = "\\rangle";
     // Decide what sequence to use
    var sequence;
    if (stackNeverDelimiters.includes(delim)) sequence = stackNeverDelimiterSequence;
    else if (stackLargeDelimiters.includes(delim)) sequence = stackLargeDelimiterSequence;
    else sequence = stackAlwaysDelimiterSequence;
     // Look through the sequence
    var delimType = traverseSequence(delim, height, sequence, options); // Get the delimiter from font glyphs.
    // Depending on the sequence element we decided on, call the
    // appropriate function.
    if (delimType.type === "small") return makeSmallDelim(delim, delimType.style, center, options, mode, classes);
    else if (delimType.type === "large") return makeLargeDelim(delim, delimType.size, center, options, mode, classes);
    else return makeStackedDelim(delim, height, center, options, mode, classes);
};
/**
 * Make a delimiter for use with `\left` and `\right`, given a height and depth
 * of an expression that the delimiters surround.
 */ var makeLeftRightDelim = function makeLeftRightDelim(delim, height, depth, options, mode, classes) {
    // We always center \left/\right delimiters, so the axis is always shifted
    var axisHeight = options.fontMetrics().axisHeight * options.sizeMultiplier; // Taken from TeX source, tex.web, function make_left_right
    var delimiterFactor = 901;
    var delimiterExtend = 5.0 / options.fontMetrics().ptPerEm;
    var maxDistFromAxis = Math.max(height - axisHeight, depth + axisHeight);
    var totalHeight = Math.max(// 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    maxDistFromAxis / 500 * delimiterFactor, 2 * maxDistFromAxis - delimiterExtend); // Finally, we defer to `makeCustomSizedDelim` with our calculated total
    // height
    return makeCustomSizedDelim(delim, totalHeight, true, options, mode, classes);
};
var delimiter = {
    sqrtImage: makeSqrtImage,
    sizedDelim: makeSizedDelim,
    sizeToMaxHeight: sizeToMaxHeight,
    customSizedDelim: makeCustomSizedDelim,
    leftRightDelim: makeLeftRightDelim
};
// Extra data needed for the delimiter handler down below
var delimiterSizes = {
    "\\bigl": {
        mclass: "mopen",
        size: 1
    },
    "\\Bigl": {
        mclass: "mopen",
        size: 2
    },
    "\\biggl": {
        mclass: "mopen",
        size: 3
    },
    "\\Biggl": {
        mclass: "mopen",
        size: 4
    },
    "\\bigr": {
        mclass: "mclose",
        size: 1
    },
    "\\Bigr": {
        mclass: "mclose",
        size: 2
    },
    "\\biggr": {
        mclass: "mclose",
        size: 3
    },
    "\\Biggr": {
        mclass: "mclose",
        size: 4
    },
    "\\bigm": {
        mclass: "mrel",
        size: 1
    },
    "\\Bigm": {
        mclass: "mrel",
        size: 2
    },
    "\\biggm": {
        mclass: "mrel",
        size: 3
    },
    "\\Biggm": {
        mclass: "mrel",
        size: 4
    },
    "\\big": {
        mclass: "mord",
        size: 1
    },
    "\\Big": {
        mclass: "mord",
        size: 2
    },
    "\\bigg": {
        mclass: "mord",
        size: 3
    },
    "\\Bigg": {
        mclass: "mord",
        size: 4
    }
};
var delimiters = [
    "(",
    "\\lparen",
    ")",
    "\\rparen",
    "[",
    "\\lbrack",
    "]",
    "\\rbrack",
    "\\{",
    "\\lbrace",
    "\\}",
    "\\rbrace",
    "\\lfloor",
    "\\rfloor",
    "\u230a",
    "\u230b",
    "\\lceil",
    "\\rceil",
    "\u2308",
    "\u2309",
    "<",
    ">",
    "\\langle",
    "\u27e8",
    "\\rangle",
    "\u27e9",
    "\\lt",
    "\\gt",
    "\\lvert",
    "\\rvert",
    "\\lVert",
    "\\rVert",
    "\\lgroup",
    "\\rgroup",
    "\u27ee",
    "\u27ef",
    "\\lmoustache",
    "\\rmoustache",
    "\u23b0",
    "\u23b1",
    "/",
    "\\backslash",
    "|",
    "\\vert",
    "\\|",
    "\\Vert",
    "\\uparrow",
    "\\Uparrow",
    "\\downarrow",
    "\\Downarrow",
    "\\updownarrow",
    "\\Updownarrow",
    "."
];
// Delimiter functions
function checkDelimiter(delim, context) {
    var symDelim = checkSymbolNodeType(delim);
    if (symDelim && delimiters.includes(symDelim.text)) return symDelim;
    else if (symDelim) throw new ParseError("Invalid delimiter '" + symDelim.text + "' after '" + context.funcName + "'", delim);
    else throw new ParseError("Invalid delimiter type '" + delim.type + "'", delim);
}
defineFunction({
    type: "delimsizing",
    names: [
        "\\bigl",
        "\\Bigl",
        "\\biggl",
        "\\Biggl",
        "\\bigr",
        "\\Bigr",
        "\\biggr",
        "\\Biggr",
        "\\bigm",
        "\\Bigm",
        "\\biggm",
        "\\Biggm",
        "\\big",
        "\\Big",
        "\\bigg",
        "\\Bigg"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "primitive"
        ]
    },
    handler: (context, args)=>{
        var delim = checkDelimiter(args[0], context);
        return {
            type: "delimsizing",
            mode: context.parser.mode,
            size: delimiterSizes[context.funcName].size,
            mclass: delimiterSizes[context.funcName].mclass,
            delim: delim.text
        };
    },
    htmlBuilder: (group, options)=>{
        if (group.delim === ".") // Empty delimiters still count as elements, even though they don't
        // show anything.
        return buildCommon.makeSpan([
            group.mclass
        ]);
         // Use delimiter.sizedDelim to generate the delimiter.
        return delimiter.sizedDelim(group.delim, group.size, options, group.mode, [
            group.mclass
        ]);
    },
    mathmlBuilder: (group)=>{
        var children = [];
        if (group.delim !== ".") children.push(makeText(group.delim, group.mode));
        var node = new mathMLTree.MathNode("mo", children);
        if (group.mclass === "mopen" || group.mclass === "mclose") // Only some of the delimsizing functions act as fences, and they
        // return "mopen" or "mclose" mclass.
        node.setAttribute("fence", "true");
        else // Explicitly disable fencing if it's not a fence, to override the
        // defaults.
        node.setAttribute("fence", "false");
        node.setAttribute("stretchy", "true");
        var size = makeEm(delimiter.sizeToMaxHeight[group.size]);
        node.setAttribute("minsize", size);
        node.setAttribute("maxsize", size);
        return node;
    }
});
function assertParsed(group) {
    if (!group.body) throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
defineFunction({
    type: "leftright-right",
    names: [
        "\\right"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (context, args)=>{
        // \left case below triggers parsing of \right in
        //   `const right = parser.parseFunction();`
        // uses this return value.
        var color = context.parser.gullet.macros.get("\\current@color");
        if (color && typeof color !== "string") throw new ParseError("\\current@color set to non-string in \\right");
        return {
            type: "leftright-right",
            mode: context.parser.mode,
            delim: checkDelimiter(args[0], context).text,
            color
        };
    }
});
defineFunction({
    type: "leftright",
    names: [
        "\\left"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (context, args)=>{
        var delim = checkDelimiter(args[0], context);
        var parser = context.parser; // Parse out the implicit body
        ++parser.leftrightDepth; // parseExpression stops before '\\right'
        var body = parser.parseExpression(false);
        --parser.leftrightDepth; // Check the next token
        parser.expect("\\right", false);
        var right = assertNodeType(parser.parseFunction(), "leftright-right");
        return {
            type: "leftright",
            mode: parser.mode,
            body,
            left: delim.text,
            right: right.delim,
            rightColor: right.color
        };
    },
    htmlBuilder: (group, options)=>{
        assertParsed(group); // Build the inner expression
        var inner = buildExpression$1(group.body, options, true, [
            "mopen",
            "mclose"
        ]);
        var innerHeight = 0;
        var innerDepth = 0;
        var hadMiddle = false; // Calculate its height and depth
        for(var i = 0; i < inner.length; i++)// Property `isMiddle` not defined on `span`. See comment in
        // "middle"'s htmlBuilder.
        // $FlowFixMe
        if (inner[i].isMiddle) hadMiddle = true;
        else {
            innerHeight = Math.max(inner[i].height, innerHeight);
            innerDepth = Math.max(inner[i].depth, innerDepth);
        }
         // The size of delimiters is the same, regardless of what style we are
        // in. Thus, to correctly calculate the size of delimiter we need around
        // a group, we scale down the inner size based on the size.
        innerHeight *= options.sizeMultiplier;
        innerDepth *= options.sizeMultiplier;
        var leftDelim;
        if (group.left === ".") // Empty delimiters in \left and \right make null delimiter spaces.
        leftDelim = makeNullDelimiter(options, [
            "mopen"
        ]);
        else // Otherwise, use leftRightDelim to generate the correct sized
        // delimiter.
        leftDelim = delimiter.leftRightDelim(group.left, innerHeight, innerDepth, options, group.mode, [
            "mopen"
        ]);
         // Add it to the beginning of the expression
        inner.unshift(leftDelim); // Handle middle delimiters
        if (hadMiddle) for(var _i = 1; _i < inner.length; _i++){
            var middleDelim = inner[_i]; // Property `isMiddle` not defined on `span`. See comment in
            // "middle"'s htmlBuilder.
            // $FlowFixMe
            var isMiddle = middleDelim.isMiddle;
            if (isMiddle) // Apply the options that were active when \middle was called
            inner[_i] = delimiter.leftRightDelim(isMiddle.delim, innerHeight, innerDepth, isMiddle.options, group.mode, []);
        }
        var rightDelim; // Same for the right delimiter, but using color specified by \color
        if (group.right === ".") rightDelim = makeNullDelimiter(options, [
            "mclose"
        ]);
        else {
            var colorOptions = group.rightColor ? options.withColor(group.rightColor) : options;
            rightDelim = delimiter.leftRightDelim(group.right, innerHeight, innerDepth, colorOptions, group.mode, [
                "mclose"
            ]);
        } // Add it to the end of the expression.
        inner.push(rightDelim);
        return buildCommon.makeSpan([
            "minner"
        ], inner, options);
    },
    mathmlBuilder: (group, options)=>{
        assertParsed(group);
        var inner = buildExpression(group.body, options);
        if (group.left !== ".") {
            var leftNode = new mathMLTree.MathNode("mo", [
                makeText(group.left, group.mode)
            ]);
            leftNode.setAttribute("fence", "true");
            inner.unshift(leftNode);
        }
        if (group.right !== ".") {
            var rightNode = new mathMLTree.MathNode("mo", [
                makeText(group.right, group.mode)
            ]);
            rightNode.setAttribute("fence", "true");
            if (group.rightColor) rightNode.setAttribute("mathcolor", group.rightColor);
            inner.push(rightNode);
        }
        return makeRow(inner);
    }
});
defineFunction({
    type: "middle",
    names: [
        "\\middle"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (context, args)=>{
        var delim = checkDelimiter(args[0], context);
        if (!context.parser.leftrightDepth) throw new ParseError("\\middle without preceding \\left", delim);
        return {
            type: "middle",
            mode: context.parser.mode,
            delim: delim.text
        };
    },
    htmlBuilder: (group, options)=>{
        var middleDelim;
        if (group.delim === ".") middleDelim = makeNullDelimiter(options, []);
        else {
            middleDelim = delimiter.sizedDelim(group.delim, 1, options, group.mode, []);
            var isMiddle = {
                delim: group.delim,
                options
            }; // Property `isMiddle` not defined on `span`. It is only used in
            // this file above.
            // TODO: Fix this violation of the `span` type and possibly rename
            // things since `isMiddle` sounds like a boolean, but is a struct.
            // $FlowFixMe
            middleDelim.isMiddle = isMiddle;
        }
        return middleDelim;
    },
    mathmlBuilder: (group, options)=>{
        // A Firefox \middle will stretch a character vertically only if it
        // is in the fence part of the operator dictionary at:
        // https://www.w3.org/TR/MathML3/appendixc.html.
        // So we need to avoid U+2223 and use plain "|" instead.
        var textNode = group.delim === "\\vert" || group.delim === "|" ? makeText("|", "text") : makeText(group.delim, group.mode);
        var middleNode = new mathMLTree.MathNode("mo", [
            textNode
        ]);
        middleNode.setAttribute("fence", "true"); // MathML gives 5/18em spacing to each <mo> element.
        // \middle should get delimiter spacing instead.
        middleNode.setAttribute("lspace", "0.05em");
        middleNode.setAttribute("rspace", "0.05em");
        return middleNode;
    }
});
var htmlBuilder$7 = (group, options)=>{
    // \cancel, \bcancel, \xcancel, \sout, \fbox, \colorbox, \fcolorbox, \phase
    // Some groups can return document fragments.  Handle those by wrapping
    // them in a span.
    var inner = buildCommon.wrapFragment(buildGroup$1(group.body, options), options);
    var label = group.label.slice(1);
    var scale = options.sizeMultiplier;
    var img;
    var imgShift = 0; // In the LaTeX cancel package, line geometry is slightly different
    // depending on whether the subject is wider than it is tall, or vice versa.
    // We don't know the width of a group, so as a proxy, we test if
    // the subject is a single character. This captures most of the
    // subjects that should get the "tall" treatment.
    var isSingleChar = utils.isCharacterBox(group.body);
    if (label === "sout") {
        img = buildCommon.makeSpan([
            "stretchy",
            "sout"
        ]);
        img.height = options.fontMetrics().defaultRuleThickness / scale;
        imgShift = -0.5 * options.fontMetrics().xHeight;
    } else if (label === "phase") {
        // Set a couple of dimensions from the steinmetz package.
        var lineWeight = calculateSize({
            number: 0.6,
            unit: "pt"
        }, options);
        var clearance = calculateSize({
            number: 0.35,
            unit: "ex"
        }, options); // Prevent size changes like \Huge from affecting line thickness
        var newOptions = options.havingBaseSizing();
        scale = scale / newOptions.sizeMultiplier;
        var angleHeight = inner.height + inner.depth + lineWeight + clearance; // Reserve a left pad for the angle.
        inner.style.paddingLeft = makeEm(angleHeight / 2 + lineWeight); // Create an SVG
        var viewBoxHeight = Math.floor(1000 * angleHeight * scale);
        var path = phasePath(viewBoxHeight);
        var svgNode = new SvgNode([
            new PathNode("phase", path)
        ], {
            "width": "400em",
            "height": makeEm(viewBoxHeight / 1000),
            "viewBox": "0 0 400000 " + viewBoxHeight,
            "preserveAspectRatio": "xMinYMin slice"
        }); // Wrap it in a span with overflow: hidden.
        img = buildCommon.makeSvgSpan([
            "hide-tail"
        ], [
            svgNode
        ], options);
        img.style.height = makeEm(angleHeight);
        imgShift = inner.depth + lineWeight + clearance;
    } else {
        // Add horizontal padding
        if (/cancel/.test(label)) {
            if (!isSingleChar) inner.classes.push("cancel-pad");
        } else if (label === "angl") inner.classes.push("anglpad");
        else inner.classes.push("boxpad");
         // Add vertical padding
        var topPad = 0;
        var bottomPad = 0;
        var ruleThickness = 0; // ref: cancel package: \advance\totalheight2\p@ % "+2"
        if (/box/.test(label)) {
            ruleThickness = Math.max(options.fontMetrics().fboxrule, options.minRuleThickness // User override.
            );
            topPad = options.fontMetrics().fboxsep + (label === "colorbox" ? 0 : ruleThickness);
            bottomPad = topPad;
        } else if (label === "angl") {
            ruleThickness = Math.max(options.fontMetrics().defaultRuleThickness, options.minRuleThickness);
            topPad = 4 * ruleThickness; // gap = 3 × line, plus the line itself.
            bottomPad = Math.max(0, 0.25 - inner.depth);
        } else {
            topPad = isSingleChar ? 0.2 : 0;
            bottomPad = topPad;
        }
        img = stretchy.encloseSpan(inner, label, topPad, bottomPad, options);
        if (/fbox|boxed|fcolorbox/.test(label)) {
            img.style.borderStyle = "solid";
            img.style.borderWidth = makeEm(ruleThickness);
        } else if (label === "angl" && ruleThickness !== 0.049) {
            img.style.borderTopWidth = makeEm(ruleThickness);
            img.style.borderRightWidth = makeEm(ruleThickness);
        }
        imgShift = inner.depth + bottomPad;
        if (group.backgroundColor) {
            img.style.backgroundColor = group.backgroundColor;
            if (group.borderColor) img.style.borderColor = group.borderColor;
        }
    }
    var vlist;
    if (group.backgroundColor) vlist = buildCommon.makeVList({
        positionType: "individualShift",
        children: [
            {
                type: "elem",
                elem: img,
                shift: imgShift
            },
            {
                type: "elem",
                elem: inner,
                shift: 0
            }
        ]
    }, options);
    else {
        var classes = /cancel|phase/.test(label) ? [
            "svg-align"
        ] : [];
        vlist = buildCommon.makeVList({
            positionType: "individualShift",
            children: [
                {
                    type: "elem",
                    elem: inner,
                    shift: 0
                },
                {
                    type: "elem",
                    elem: img,
                    shift: imgShift,
                    wrapperClasses: classes
                }
            ]
        }, options);
    }
    if (/cancel/.test(label)) {
        // The cancel package documentation says that cancel lines add their height
        // to the expression, but tests show that isn't how it actually works.
        vlist.height = inner.height;
        vlist.depth = inner.depth;
    }
    if (/cancel/.test(label) && !isSingleChar) // cancel does not create horiz space for its line extension.
    return buildCommon.makeSpan([
        "mord",
        "cancel-lap"
    ], [
        vlist
    ], options);
    else return buildCommon.makeSpan([
        "mord"
    ], [
        vlist
    ], options);
};
var mathmlBuilder$6 = (group, options)=>{
    var fboxsep = 0;
    var node = new mathMLTree.MathNode(group.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [
        buildGroup(group.body, options)
    ]);
    switch(group.label){
        case "\\cancel":
            node.setAttribute("notation", "updiagonalstrike");
            break;
        case "\\bcancel":
            node.setAttribute("notation", "downdiagonalstrike");
            break;
        case "\\phase":
            node.setAttribute("notation", "phasorangle");
            break;
        case "\\sout":
            node.setAttribute("notation", "horizontalstrike");
            break;
        case "\\fbox":
            node.setAttribute("notation", "box");
            break;
        case "\\angl":
            node.setAttribute("notation", "actuarial");
            break;
        case "\\fcolorbox":
        case "\\colorbox":
            // <menclose> doesn't have a good notation option. So use <mpadded>
            // instead. Set some attributes that come included with <menclose>.
            fboxsep = options.fontMetrics().fboxsep * options.fontMetrics().ptPerEm;
            node.setAttribute("width", "+" + 2 * fboxsep + "pt");
            node.setAttribute("height", "+" + 2 * fboxsep + "pt");
            node.setAttribute("lspace", fboxsep + "pt"); //
            node.setAttribute("voffset", fboxsep + "pt");
            if (group.label === "\\fcolorbox") {
                var thk = Math.max(options.fontMetrics().fboxrule, options.minRuleThickness // user override
                );
                node.setAttribute("style", "border: " + thk + "em solid " + String(group.borderColor));
            }
            break;
        case "\\xcancel":
            node.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
            break;
    }
    if (group.backgroundColor) node.setAttribute("mathbackground", group.backgroundColor);
    return node;
};
defineFunction({
    type: "enclose",
    names: [
        "\\colorbox"
    ],
    props: {
        numArgs: 2,
        allowedInText: true,
        argTypes: [
            "color",
            "text"
        ]
    },
    handler (_ref, args, optArgs) {
        var { parser, funcName } = _ref;
        var color = assertNodeType(args[0], "color-token").color;
        var body = args[1];
        return {
            type: "enclose",
            mode: parser.mode,
            label: funcName,
            backgroundColor: color,
            body
        };
    },
    htmlBuilder: htmlBuilder$7,
    mathmlBuilder: mathmlBuilder$6
});
defineFunction({
    type: "enclose",
    names: [
        "\\fcolorbox"
    ],
    props: {
        numArgs: 3,
        allowedInText: true,
        argTypes: [
            "color",
            "color",
            "text"
        ]
    },
    handler (_ref2, args, optArgs) {
        var { parser, funcName } = _ref2;
        var borderColor = assertNodeType(args[0], "color-token").color;
        var backgroundColor = assertNodeType(args[1], "color-token").color;
        var body = args[2];
        return {
            type: "enclose",
            mode: parser.mode,
            label: funcName,
            backgroundColor,
            borderColor,
            body
        };
    },
    htmlBuilder: htmlBuilder$7,
    mathmlBuilder: mathmlBuilder$6
});
defineFunction({
    type: "enclose",
    names: [
        "\\fbox"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "hbox"
        ],
        allowedInText: true
    },
    handler (_ref3, args) {
        var { parser } = _ref3;
        return {
            type: "enclose",
            mode: parser.mode,
            label: "\\fbox",
            body: args[0]
        };
    }
});
defineFunction({
    type: "enclose",
    names: [
        "\\cancel",
        "\\bcancel",
        "\\xcancel",
        "\\sout",
        "\\phase"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref4, args) {
        var { parser, funcName } = _ref4;
        var body = args[0];
        return {
            type: "enclose",
            mode: parser.mode,
            label: funcName,
            body
        };
    },
    htmlBuilder: htmlBuilder$7,
    mathmlBuilder: mathmlBuilder$6
});
defineFunction({
    type: "enclose",
    names: [
        "\\angl"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "hbox"
        ],
        allowedInText: false
    },
    handler (_ref5, args) {
        var { parser } = _ref5;
        return {
            type: "enclose",
            mode: parser.mode,
            label: "\\angl",
            body: args[0]
        };
    }
});
/**
 * All registered environments.
 * `environments.js` exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary via `environments.js`.
 */ var _environments = {};
function defineEnvironment(_ref) {
    var { type, names, props, handler, htmlBuilder, mathmlBuilder } = _ref;
    // Set default values of environments.
    var data = {
        type,
        numArgs: props.numArgs || 0,
        allowedInText: false,
        numOptionalArgs: 0,
        handler
    };
    for(var i = 0; i < names.length; ++i)// TODO: The value type of _environments should be a type union of all
    // possible `EnvSpec<>` possibilities instead of `EnvSpec<*>`, which is
    // an existential type.
    _environments[names[i]] = data;
    if (htmlBuilder) _htmlGroupBuilders[type] = htmlBuilder;
    if (mathmlBuilder) _mathmlGroupBuilders[type] = mathmlBuilder;
}
/**
 * All registered global/built-in macros.
 * `macros.js` exports this same dictionary again and makes it public.
 * `Parser.js` requires this dictionary via `macros.js`.
 */ var _macros = {}; // This function might one day accept an additional argument and do more things.
function defineMacro(name, body) {
    _macros[name] = body;
}
// Helper functions
function getHLines(parser) {
    // Return an array. The array length = number of hlines.
    // Each element in the array tells if the line is dashed.
    var hlineInfo = [];
    parser.consumeSpaces();
    var nxt = parser.fetch().text;
    if (nxt === "\\relax") {
        // \relax is an artifact of the \cr macro below
        parser.consume();
        parser.consumeSpaces();
        nxt = parser.fetch().text;
    }
    while(nxt === "\\hline" || nxt === "\\hdashline"){
        parser.consume();
        hlineInfo.push(nxt === "\\hdashline");
        parser.consumeSpaces();
        nxt = parser.fetch().text;
    }
    return hlineInfo;
}
var validateAmsEnvironmentContext = (context)=>{
    var settings = context.parser.settings;
    if (!settings.displayMode) throw new ParseError("{" + context.envName + "} can be used only in" + " display mode.");
}; // autoTag (an argument to parseArray) can be one of three values:
// * undefined: Regular (not-top-level) array; no tags on each row
// * true: Automatic equation numbering, overridable by \tag
// * false: Tags allowed on each row, but no automatic numbering
// This function *doesn't* work with the "split" environment name.
function getAutoTag(name) {
    if (name.indexOf("ed") === -1) return name.indexOf("*") === -1;
     // return undefined;
}
/**
 * Parse the body of the environment, with rows delimited by \\ and
 * columns delimited by &, and create a nested list in row-major order
 * with one group per cell.  If given an optional argument style
 * ("text", "display", etc.), then each cell is cast into that style.
 */ function parseArray(parser, _ref, style) {
    var { hskipBeforeAndAfter, addJot, cols, arraystretch, colSeparationType, autoTag, singleRow, emptySingleRow, maxNumCols, leqno } = _ref;
    parser.gullet.beginGroup();
    if (!singleRow) // \cr is equivalent to \\ without the optional size argument (see below)
    // TODO: provide helpful error when \cr is used outside array environment
    parser.gullet.macros.set("\\cr", "\\\\\\relax");
     // Get current arraystretch if it's not set by the environment
    if (!arraystretch) {
        var stretch = parser.gullet.expandMacroAsText("\\arraystretch");
        if (stretch == null) // Default \arraystretch from lttab.dtx
        arraystretch = 1;
        else {
            arraystretch = parseFloat(stretch);
            if (!arraystretch || arraystretch < 0) throw new ParseError("Invalid \\arraystretch: " + stretch);
        }
    } // Start group for first cell
    parser.gullet.beginGroup();
    var row = [];
    var body = [
        row
    ];
    var rowGaps = [];
    var hLinesBeforeRow = [];
    var tags = autoTag != null ? [] : undefined; // amsmath uses \global\@eqnswtrue and \global\@eqnswfalse to represent
    // whether this row should have an equation number.  Simulate this with
    // a \@eqnsw macro set to 1 or 0.
    function beginRow() {
        if (autoTag) parser.gullet.macros.set("\\@eqnsw", "1", true);
    }
    function endRow() {
        if (tags) {
            if (parser.gullet.macros.get("\\df@tag")) {
                tags.push(parser.subparse([
                    new Token("\\df@tag")
                ]));
                parser.gullet.macros.set("\\df@tag", undefined, true);
            } else tags.push(Boolean(autoTag) && parser.gullet.macros.get("\\@eqnsw") === "1");
        }
    }
    beginRow(); // Test for \hline at the top of the array.
    hLinesBeforeRow.push(getHLines(parser));
    while(true){
        // eslint-disable-line no-constant-condition
        // Parse each cell in its own group (namespace)
        var cell = parser.parseExpression(false, singleRow ? "\\end" : "\\\\");
        parser.gullet.endGroup();
        parser.gullet.beginGroup();
        cell = {
            type: "ordgroup",
            mode: parser.mode,
            body: cell
        };
        if (style) cell = {
            type: "styling",
            mode: parser.mode,
            style,
            body: [
                cell
            ]
        };
        row.push(cell);
        var next = parser.fetch().text;
        if (next === "&") {
            if (maxNumCols && row.length === maxNumCols) {
                if (singleRow || colSeparationType) // {equation} or {split}
                throw new ParseError("Too many tab characters: &", parser.nextToken);
                else // {array} environment
                parser.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
            }
            parser.consume();
        } else if (next === "\\end") {
            endRow(); // Arrays terminate newlines with `\crcr` which consumes a `\cr` if
            // the last line is empty.  However, AMS environments keep the
            // empty row if it's the only one.
            // NOTE: Currently, `cell` is the last item added into `row`.
            if (row.length === 1 && cell.type === "styling" && cell.body[0].body.length === 0 && (body.length > 1 || !emptySingleRow)) body.pop();
            if (hLinesBeforeRow.length < body.length + 1) hLinesBeforeRow.push([]);
            break;
        } else if (next === "\\\\") {
            parser.consume();
            var size = void 0; // \def\Let@{\let\\\math@cr}
            // \def\math@cr{...\math@cr@}
            // \def\math@cr@{\new@ifnextchar[\math@cr@@{\math@cr@@[\z@]}}
            // \def\math@cr@@[#1]{...\math@cr@@@...}
            // \def\math@cr@@@{\cr}
            if (parser.gullet.future().text !== " ") size = parser.parseSizeGroup(true);
            rowGaps.push(size ? size.value : null);
            endRow(); // check for \hline(s) following the row separator
            hLinesBeforeRow.push(getHLines(parser));
            row = [];
            body.push(row);
            beginRow();
        } else throw new ParseError("Expected & or \\\\ or \\cr or \\end", parser.nextToken);
    } // End cell group
    parser.gullet.endGroup(); // End array group defining \cr
    parser.gullet.endGroup();
    return {
        type: "array",
        mode: parser.mode,
        addJot,
        arraystretch,
        body,
        cols,
        rowGaps,
        hskipBeforeAndAfter,
        hLinesBeforeRow,
        colSeparationType,
        tags,
        leqno
    };
} // Decides on a style for cells in an array according to whether the given
// environment name starts with the letter 'd'.
function dCellStyle(envName) {
    if (envName.slice(0, 1) === "d") return "display";
    else return "text";
}
var htmlBuilder$6 = function htmlBuilder(group, options) {
    var r;
    var c;
    var nr = group.body.length;
    var hLinesBeforeRow = group.hLinesBeforeRow;
    var nc = 0;
    var body = new Array(nr);
    var hlines = [];
    var ruleThickness = Math.max(options.fontMetrics().arrayRuleWidth, options.minRuleThickness // User override.
    ); // Horizontal spacing
    var pt = 1 / options.fontMetrics().ptPerEm;
    var arraycolsep = 5 * pt; // default value, i.e. \arraycolsep in article.cls
    if (group.colSeparationType && group.colSeparationType === "small") {
        // We're in a {smallmatrix}. Default column space is \thickspace,
        // i.e. 5/18em = 0.2778em, per amsmath.dtx for {smallmatrix}.
        // But that needs adjustment because LaTeX applies \scriptstyle to the
        // entire array, including the colspace, but this function applies
        // \scriptstyle only inside each element.
        var localMultiplier = options.havingStyle(Style$1.SCRIPT).sizeMultiplier;
        arraycolsep = 0.2778 * (localMultiplier / options.sizeMultiplier);
    } // Vertical spacing
    var baselineskip = group.colSeparationType === "CD" ? calculateSize({
        number: 3,
        unit: "ex"
    }, options) : 12 * pt; // see size10.clo
    // Default \jot from ltmath.dtx
    // TODO(edemaine): allow overriding \jot via \setlength (#687)
    var jot = 3 * pt;
    var arrayskip = group.arraystretch * baselineskip;
    var arstrutHeight = 0.7 * arrayskip; // \strutbox in ltfsstrc.dtx and
    var arstrutDepth = 0.3 * arrayskip; // \@arstrutbox in lttab.dtx
    var totalHeight = 0; // Set a position for \hline(s) at the top of the array, if any.
    function setHLinePos(hlinesInGap) {
        for(var i = 0; i < hlinesInGap.length; ++i){
            if (i > 0) totalHeight += 0.25;
            hlines.push({
                pos: totalHeight,
                isDashed: hlinesInGap[i]
            });
        }
    }
    setHLinePos(hLinesBeforeRow[0]);
    for(r = 0; r < group.body.length; ++r){
        var inrow = group.body[r];
        var height = arstrutHeight; // \@array adds an \@arstrut
        var depth = arstrutDepth; // to each tow (via the template)
        if (nc < inrow.length) nc = inrow.length;
        var outrow = new Array(inrow.length);
        for(c = 0; c < inrow.length; ++c){
            var elt = buildGroup$1(inrow[c], options);
            if (depth < elt.depth) depth = elt.depth;
            if (height < elt.height) height = elt.height;
            outrow[c] = elt;
        }
        var rowGap = group.rowGaps[r];
        var gap = 0;
        if (rowGap) {
            gap = calculateSize(rowGap, options);
            if (gap > 0) {
                // \@argarraycr
                gap += arstrutDepth;
                if (depth < gap) depth = gap; // \@xargarraycr
                gap = 0;
            }
        } // In AMS multiline environments such as aligned and gathered, rows
        // correspond to lines that have additional \jot added to the
        // \baselineskip via \openup.
        if (group.addJot) depth += jot;
        outrow.height = height;
        outrow.depth = depth;
        totalHeight += height;
        outrow.pos = totalHeight;
        totalHeight += depth + gap; // \@yargarraycr
        body[r] = outrow; // Set a position for \hline(s), if any.
        setHLinePos(hLinesBeforeRow[r + 1]);
    }
    var offset = totalHeight / 2 + options.fontMetrics().axisHeight;
    var colDescriptions = group.cols || [];
    var cols = [];
    var colSep;
    var colDescrNum;
    var tagSpans = [];
    if (group.tags && group.tags.some((tag)=>tag)) // An environment with manual tags and/or automatic equation numbers.
    // Create node(s), the latter of which trigger CSS counter increment.
    for(r = 0; r < nr; ++r){
        var rw = body[r];
        var shift = rw.pos - offset;
        var tag = group.tags[r];
        var tagSpan = void 0;
        if (tag === true) // automatic numbering
        tagSpan = buildCommon.makeSpan([
            "eqn-num"
        ], [], options);
        else if (tag === false) // \nonumber/\notag or starred environment
        tagSpan = buildCommon.makeSpan([], [], options);
        else // manual \tag
        tagSpan = buildCommon.makeSpan([], buildExpression$1(tag, options, true), options);
        tagSpan.depth = rw.depth;
        tagSpan.height = rw.height;
        tagSpans.push({
            type: "elem",
            elem: tagSpan,
            shift
        });
    }
    for(c = 0, colDescrNum = 0; // descriptions, so trailing separators don't get lost.
    c < nc || colDescrNum < colDescriptions.length; ++c, ++colDescrNum){
        var colDescr = colDescriptions[colDescrNum] || {};
        var firstSeparator = true;
        while(colDescr.type === "separator"){
            // If there is more than one separator in a row, add a space
            // between them.
            if (!firstSeparator) {
                colSep = buildCommon.makeSpan([
                    "arraycolsep"
                ], []);
                colSep.style.width = makeEm(options.fontMetrics().doubleRuleSep);
                cols.push(colSep);
            }
            if (colDescr.separator === "|" || colDescr.separator === ":") {
                var lineType = colDescr.separator === "|" ? "solid" : "dashed";
                var separator = buildCommon.makeSpan([
                    "vertical-separator"
                ], [], options);
                separator.style.height = makeEm(totalHeight);
                separator.style.borderRightWidth = makeEm(ruleThickness);
                separator.style.borderRightStyle = lineType;
                separator.style.margin = "0 " + makeEm(-ruleThickness / 2);
                var _shift = totalHeight - offset;
                if (_shift) separator.style.verticalAlign = makeEm(-_shift);
                cols.push(separator);
            } else throw new ParseError("Invalid separator type: " + colDescr.separator);
            colDescrNum++;
            colDescr = colDescriptions[colDescrNum] || {};
            firstSeparator = false;
        }
        if (c >= nc) continue;
        var sepwidth = void 0;
        if (c > 0 || group.hskipBeforeAndAfter) {
            sepwidth = utils.deflt(colDescr.pregap, arraycolsep);
            if (sepwidth !== 0) {
                colSep = buildCommon.makeSpan([
                    "arraycolsep"
                ], []);
                colSep.style.width = makeEm(sepwidth);
                cols.push(colSep);
            }
        }
        var col = [];
        for(r = 0; r < nr; ++r){
            var row = body[r];
            var elem = row[c];
            if (!elem) continue;
            var _shift2 = row.pos - offset;
            elem.depth = row.depth;
            elem.height = row.height;
            col.push({
                type: "elem",
                elem: elem,
                shift: _shift2
            });
        }
        col = buildCommon.makeVList({
            positionType: "individualShift",
            children: col
        }, options);
        col = buildCommon.makeSpan([
            "col-align-" + (colDescr.align || "c")
        ], [
            col
        ]);
        cols.push(col);
        if (c < nc - 1 || group.hskipBeforeAndAfter) {
            sepwidth = utils.deflt(colDescr.postgap, arraycolsep);
            if (sepwidth !== 0) {
                colSep = buildCommon.makeSpan([
                    "arraycolsep"
                ], []);
                colSep.style.width = makeEm(sepwidth);
                cols.push(colSep);
            }
        }
    }
    body = buildCommon.makeSpan([
        "mtable"
    ], cols); // Add \hline(s), if any.
    if (hlines.length > 0) {
        var line = buildCommon.makeLineSpan("hline", options, ruleThickness);
        var dashes = buildCommon.makeLineSpan("hdashline", options, ruleThickness);
        var vListElems = [
            {
                type: "elem",
                elem: body,
                shift: 0
            }
        ];
        while(hlines.length > 0){
            var hline = hlines.pop();
            var lineShift = hline.pos - offset;
            if (hline.isDashed) vListElems.push({
                type: "elem",
                elem: dashes,
                shift: lineShift
            });
            else vListElems.push({
                type: "elem",
                elem: line,
                shift: lineShift
            });
        }
        body = buildCommon.makeVList({
            positionType: "individualShift",
            children: vListElems
        }, options);
    }
    if (tagSpans.length === 0) return buildCommon.makeSpan([
        "mord"
    ], [
        body
    ], options);
    else {
        var eqnNumCol = buildCommon.makeVList({
            positionType: "individualShift",
            children: tagSpans
        }, options);
        eqnNumCol = buildCommon.makeSpan([
            "tag"
        ], [
            eqnNumCol
        ], options);
        return buildCommon.makeFragment([
            body,
            eqnNumCol
        ]);
    }
};
var alignMap = {
    c: "center ",
    l: "left ",
    r: "right "
};
var mathmlBuilder$5 = function mathmlBuilder(group, options) {
    var tbl = [];
    var glue = new mathMLTree.MathNode("mtd", [], [
        "mtr-glue"
    ]);
    var tag = new mathMLTree.MathNode("mtd", [], [
        "mml-eqn-num"
    ]);
    for(var i = 0; i < group.body.length; i++){
        var rw = group.body[i];
        var row = [];
        for(var j = 0; j < rw.length; j++)row.push(new mathMLTree.MathNode("mtd", [
            buildGroup(rw[j], options)
        ]));
        if (group.tags && group.tags[i]) {
            row.unshift(glue);
            row.push(glue);
            if (group.leqno) row.unshift(tag);
            else row.push(tag);
        }
        tbl.push(new mathMLTree.MathNode("mtr", row));
    }
    var table = new mathMLTree.MathNode("mtable", tbl); // Set column alignment, row spacing, column spacing, and
    // array lines by setting attributes on the table element.
    // Set the row spacing. In MathML, we specify a gap distance.
    // We do not use rowGap[] because MathML automatically increases
    // cell height with the height/depth of the element content.
    // LaTeX \arraystretch multiplies the row baseline-to-baseline distance.
    // We simulate this by adding (arraystretch - 1)em to the gap. This
    // does a reasonable job of adjusting arrays containing 1 em tall content.
    // The 0.16 and 0.09 values are found empirically. They produce an array
    // similar to LaTeX and in which content does not interfere with \hlines.
    var gap = group.arraystretch === 0.5 ? 0.1 // {smallmatrix}, {subarray}
     : 0.16 + group.arraystretch - 1 + (group.addJot ? 0.09 : 0);
    table.setAttribute("rowspacing", makeEm(gap)); // MathML table lines go only between cells.
    // To place a line on an edge we'll use <menclose>, if necessary.
    var menclose = "";
    var align = "";
    if (group.cols && group.cols.length > 0) {
        // Find column alignment, column spacing, and  vertical lines.
        var cols = group.cols;
        var columnLines = "";
        var prevTypeWasAlign = false;
        var iStart = 0;
        var iEnd = cols.length;
        if (cols[0].type === "separator") {
            menclose += "top ";
            iStart = 1;
        }
        if (cols[cols.length - 1].type === "separator") {
            menclose += "bottom ";
            iEnd -= 1;
        }
        for(var _i = iStart; _i < iEnd; _i++){
            if (cols[_i].type === "align") {
                align += alignMap[cols[_i].align];
                if (prevTypeWasAlign) columnLines += "none ";
                prevTypeWasAlign = true;
            } else if (cols[_i].type === "separator") // MathML accepts only single lines between cells.
            // So we read only the first of consecutive separators.
            {
                if (prevTypeWasAlign) {
                    columnLines += cols[_i].separator === "|" ? "solid " : "dashed ";
                    prevTypeWasAlign = false;
                }
            }
        }
        table.setAttribute("columnalign", align.trim());
        if (/[sd]/.test(columnLines)) table.setAttribute("columnlines", columnLines.trim());
    } // Set column spacing.
    if (group.colSeparationType === "align") {
        var _cols = group.cols || [];
        var spacing = "";
        for(var _i2 = 1; _i2 < _cols.length; _i2++)spacing += _i2 % 2 ? "0em " : "1em ";
        table.setAttribute("columnspacing", spacing.trim());
    } else if (group.colSeparationType === "alignat" || group.colSeparationType === "gather") table.setAttribute("columnspacing", "0em");
    else if (group.colSeparationType === "small") table.setAttribute("columnspacing", "0.2778em");
    else if (group.colSeparationType === "CD") table.setAttribute("columnspacing", "0.5em");
    else table.setAttribute("columnspacing", "1em");
     // Address \hline and \hdashline
    var rowLines = "";
    var hlines = group.hLinesBeforeRow;
    menclose += hlines[0].length > 0 ? "left " : "";
    menclose += hlines[hlines.length - 1].length > 0 ? "right " : "";
    for(var _i3 = 1; _i3 < hlines.length - 1; _i3++)rowLines += hlines[_i3].length === 0 ? "none " // MathML accepts only a single line between rows. Read one element.
     : hlines[_i3][0] ? "dashed " : "solid ";
    if (/[sd]/.test(rowLines)) table.setAttribute("rowlines", rowLines.trim());
    if (menclose !== "") {
        table = new mathMLTree.MathNode("menclose", [
            table
        ]);
        table.setAttribute("notation", menclose.trim());
    }
    if (group.arraystretch && group.arraystretch < 1) {
        // A small array. Wrap in scriptstyle so row gap is not too large.
        table = new mathMLTree.MathNode("mstyle", [
            table
        ]);
        table.setAttribute("scriptlevel", "1");
    }
    return table;
}; // Convenience function for align, align*, aligned, alignat, alignat*, alignedat.
var alignedHandler = function alignedHandler(context, args) {
    if (context.envName.indexOf("ed") === -1) validateAmsEnvironmentContext(context);
    var cols = [];
    var separationType = context.envName.indexOf("at") > -1 ? "alignat" : "align";
    var isSplit = context.envName === "split";
    var res = parseArray(context.parser, {
        cols,
        addJot: true,
        autoTag: isSplit ? undefined : getAutoTag(context.envName),
        emptySingleRow: true,
        colSeparationType: separationType,
        maxNumCols: isSplit ? 2 : undefined,
        leqno: context.parser.settings.leqno
    }, "display"); // Determining number of columns.
    // 1. If the first argument is given, we use it as a number of columns,
    //    and makes sure that each row doesn't exceed that number.
    // 2. Otherwise, just count number of columns = maximum number
    //    of cells in each row ("aligned" mode -- isAligned will be true).
    //
    // At the same time, prepend empty group {} at beginning of every second
    // cell in each row (starting with second cell) so that operators become
    // binary.  This behavior is implemented in amsmath's \start@aligned.
    var numMaths;
    var numCols = 0;
    var emptyGroup = {
        type: "ordgroup",
        mode: context.mode,
        body: []
    };
    if (args[0] && args[0].type === "ordgroup") {
        var arg0 = "";
        for(var i = 0; i < args[0].body.length; i++){
            var textord = assertNodeType(args[0].body[i], "textord");
            arg0 += textord.text;
        }
        numMaths = Number(arg0);
        numCols = numMaths * 2;
    }
    var isAligned = !numCols;
    res.body.forEach(function(row) {
        for(var _i4 = 1; _i4 < row.length; _i4 += 2){
            // Modify ordgroup node within styling node
            var styling = assertNodeType(row[_i4], "styling");
            var ordgroup = assertNodeType(styling.body[0], "ordgroup");
            ordgroup.body.unshift(emptyGroup);
        }
        if (!isAligned) {
            // Case 1
            var curMaths = row.length / 2;
            if (numMaths < curMaths) throw new ParseError("Too many math in a row: " + ("expected " + numMaths + ", but got " + curMaths), row[0]);
        } else if (numCols < row.length) // Case 2
        numCols = row.length;
    }); // Adjusting alignment.
    // In aligned mode, we add one \qquad between columns;
    // otherwise we add nothing.
    for(var _i5 = 0; _i5 < numCols; ++_i5){
        var align = "r";
        var pregap = 0;
        if (_i5 % 2 === 1) align = "l";
        else if (_i5 > 0 && isAligned) // "aligned" mode.
        pregap = 1; // add one \quad
        cols[_i5] = {
            type: "align",
            align: align,
            pregap: pregap,
            postgap: 0
        };
    }
    res.colSeparationType = isAligned ? "align" : "alignat";
    return res;
}; // Arrays are part of LaTeX, defined in lttab.dtx so its documentation
// is part of the source2e.pdf file of LaTeX2e source documentation.
// {darray} is an {array} environment where cells are set in \displaystyle,
// as defined in nccmath.sty.
defineEnvironment({
    type: "array",
    names: [
        "array",
        "darray"
    ],
    props: {
        numArgs: 1
    },
    handler (context, args) {
        // Since no types are specified above, the two possibilities are
        // - The argument is wrapped in {} or [], in which case Parser's
        //   parseGroup() returns an "ordgroup" wrapping some symbol node.
        // - The argument is a bare symbol node.
        var symNode = checkSymbolNodeType(args[0]);
        var colalign = symNode ? [
            args[0]
        ] : assertNodeType(args[0], "ordgroup").body;
        var cols = colalign.map(function(nde) {
            var node = assertSymbolNodeType(nde);
            var ca = node.text;
            if ("lcr".indexOf(ca) !== -1) return {
                type: "align",
                align: ca
            };
            else if (ca === "|") return {
                type: "separator",
                separator: "|"
            };
            else if (ca === ":") return {
                type: "separator",
                separator: ":"
            };
            throw new ParseError("Unknown column alignment: " + ca, nde);
        });
        var res = {
            cols,
            hskipBeforeAndAfter: true,
            // \@preamble in lttab.dtx
            maxNumCols: cols.length
        };
        return parseArray(context.parser, res, dCellStyle(context.envName));
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
}); // The matrix environments of amsmath builds on the array environment
// of LaTeX, which is discussed above.
// The mathtools package adds starred versions of the same environments.
// These have an optional argument to choose left|center|right justification.
defineEnvironment({
    type: "array",
    names: [
        "matrix",
        "pmatrix",
        "bmatrix",
        "Bmatrix",
        "vmatrix",
        "Vmatrix",
        "matrix*",
        "pmatrix*",
        "bmatrix*",
        "Bmatrix*",
        "vmatrix*",
        "Vmatrix*"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        var delimiters = {
            "matrix": null,
            "pmatrix": [
                "(",
                ")"
            ],
            "bmatrix": [
                "[",
                "]"
            ],
            "Bmatrix": [
                "\\{",
                "\\}"
            ],
            "vmatrix": [
                "|",
                "|"
            ],
            "Vmatrix": [
                "\\Vert",
                "\\Vert"
            ]
        }[context.envName.replace("*", "")]; // \hskip -\arraycolsep in amsmath
        var colAlign = "c";
        var payload = {
            hskipBeforeAndAfter: false,
            cols: [
                {
                    type: "align",
                    align: colAlign
                }
            ]
        };
        if (context.envName.charAt(context.envName.length - 1) === "*") {
            // It's one of the mathtools starred functions.
            // Parse the optional alignment argument.
            var parser = context.parser;
            parser.consumeSpaces();
            if (parser.fetch().text === "[") {
                parser.consume();
                parser.consumeSpaces();
                colAlign = parser.fetch().text;
                if ("lcr".indexOf(colAlign) === -1) throw new ParseError("Expected l or c or r", parser.nextToken);
                parser.consume();
                parser.consumeSpaces();
                parser.expect("]");
                parser.consume();
                payload.cols = [
                    {
                        type: "align",
                        align: colAlign
                    }
                ];
            }
        }
        var res = parseArray(context.parser, payload, dCellStyle(context.envName)); // Populate cols with the correct number of column alignment specs.
        var numCols = Math.max(0, ...res.body.map((row)=>row.length));
        res.cols = new Array(numCols).fill({
            type: "align",
            align: colAlign
        });
        return delimiters ? {
            type: "leftright",
            mode: context.mode,
            body: [
                res
            ],
            left: delimiters[0],
            right: delimiters[1],
            rightColor: undefined // \right uninfluenced by \color in array
        } : res;
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
    type: "array",
    names: [
        "smallmatrix"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        var payload = {
            arraystretch: 0.5
        };
        var res = parseArray(context.parser, payload, "script");
        res.colSeparationType = "small";
        return res;
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
    type: "array",
    names: [
        "subarray"
    ],
    props: {
        numArgs: 1
    },
    handler (context, args) {
        // Parsing of {subarray} is similar to {array}
        var symNode = checkSymbolNodeType(args[0]);
        var colalign = symNode ? [
            args[0]
        ] : assertNodeType(args[0], "ordgroup").body;
        var cols = colalign.map(function(nde) {
            var node = assertSymbolNodeType(nde);
            var ca = node.text; // {subarray} only recognizes "l" & "c"
            if ("lc".indexOf(ca) !== -1) return {
                type: "align",
                align: ca
            };
            throw new ParseError("Unknown column alignment: " + ca, nde);
        });
        if (cols.length > 1) throw new ParseError("{subarray} can contain only one column");
        var res = {
            cols,
            hskipBeforeAndAfter: false,
            arraystretch: 0.5
        };
        res = parseArray(context.parser, res, "script");
        if (res.body.length > 0 && res.body[0].length > 1) throw new ParseError("{subarray} can contain only one column");
        return res;
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
}); // A cases environment (in amsmath.sty) is almost equivalent to
// \def\arraystretch{1.2}%
// \left\{\begin{array}{@{}l@{\quad}l@{}} … \end{array}\right.
// {dcases} is a {cases} environment where cells are set in \displaystyle,
// as defined in mathtools.sty.
// {rcases} is another mathtools environment. It's brace is on the right side.
defineEnvironment({
    type: "array",
    names: [
        "cases",
        "dcases",
        "rcases",
        "drcases"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        var payload = {
            arraystretch: 1.2,
            cols: [
                {
                    type: "align",
                    align: "l",
                    pregap: 0,
                    // TODO(kevinb) get the current style.
                    // For now we use the metrics for TEXT style which is what we were
                    // doing before.  Before attempting to get the current style we
                    // should look at TeX's behavior especially for \over and matrices.
                    postgap: 1.0
                },
                {
                    type: "align",
                    align: "l",
                    pregap: 0,
                    postgap: 0
                }
            ]
        };
        var res = parseArray(context.parser, payload, dCellStyle(context.envName));
        return {
            type: "leftright",
            mode: context.mode,
            body: [
                res
            ],
            left: context.envName.indexOf("r") > -1 ? "." : "\\{",
            right: context.envName.indexOf("r") > -1 ? "\\}" : ".",
            rightColor: undefined
        };
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
}); // In the align environment, one uses ampersands, &, to specify number of
// columns in each row, and to locate spacing between each column.
// align gets automatic numbering. align* and aligned do not.
// The alignedat environment can be used in math mode.
// Note that we assume \nomallineskiplimit to be zero,
// so that \strut@ is the same as \strut.
defineEnvironment({
    type: "array",
    names: [
        "align",
        "align*",
        "aligned",
        "split"
    ],
    props: {
        numArgs: 0
    },
    handler: alignedHandler,
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
}); // A gathered environment is like an array environment with one centered
// column, but where rows are considered lines so get \jot line spacing
// and contents are set in \displaystyle.
defineEnvironment({
    type: "array",
    names: [
        "gathered",
        "gather",
        "gather*"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        if ([
            "gather",
            "gather*"
        ].includes(context.envName)) validateAmsEnvironmentContext(context);
        var res = {
            cols: [
                {
                    type: "align",
                    align: "c"
                }
            ],
            addJot: true,
            colSeparationType: "gather",
            autoTag: getAutoTag(context.envName),
            emptySingleRow: true,
            leqno: context.parser.settings.leqno
        };
        return parseArray(context.parser, res, "display");
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
}); // alignat environment is like an align environment, but one must explicitly
// specify maximum number of columns in each row, and can adjust spacing between
// each columns.
defineEnvironment({
    type: "array",
    names: [
        "alignat",
        "alignat*",
        "alignedat"
    ],
    props: {
        numArgs: 1
    },
    handler: alignedHandler,
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
    type: "array",
    names: [
        "equation",
        "equation*"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        validateAmsEnvironmentContext(context);
        var res = {
            autoTag: getAutoTag(context.envName),
            emptySingleRow: true,
            singleRow: true,
            maxNumCols: 1,
            leqno: context.parser.settings.leqno
        };
        return parseArray(context.parser, res, "display");
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
});
defineEnvironment({
    type: "array",
    names: [
        "CD"
    ],
    props: {
        numArgs: 0
    },
    handler (context) {
        validateAmsEnvironmentContext(context);
        return parseCD(context.parser);
    },
    htmlBuilder: htmlBuilder$6,
    mathmlBuilder: mathmlBuilder$5
});
defineMacro("\\nonumber", "\\gdef\\@eqnsw{0}");
defineMacro("\\notag", "\\nonumber"); // Catch \hline outside array environment
defineFunction({
    type: "text",
    // Doesn't matter what this is.
    names: [
        "\\hline",
        "\\hdashline"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInMath: true
    },
    handler (context, args) {
        throw new ParseError(context.funcName + " valid only within array environment");
    }
});
var environments = _environments;
// defineEnvironment definitions.
defineFunction({
    type: "environment",
    names: [
        "\\begin",
        "\\end"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "text"
        ]
    },
    handler (_ref, args) {
        var { parser, funcName } = _ref;
        var nameGroup = args[0];
        if (nameGroup.type !== "ordgroup") throw new ParseError("Invalid environment name", nameGroup);
        var envName = "";
        for(var i = 0; i < nameGroup.body.length; ++i)envName += assertNodeType(nameGroup.body[i], "textord").text;
        if (funcName === "\\begin") {
            // begin...end is similar to left...right
            if (!environments.hasOwnProperty(envName)) throw new ParseError("No such environment: " + envName, nameGroup);
             // Build the environment object. Arguments and other information will
            // be made available to the begin and end methods using properties.
            var env = environments[envName];
            var { args: _args, optArgs } = parser.parseArguments("\\begin{" + envName + "}", env);
            var context = {
                mode: parser.mode,
                envName,
                parser
            };
            var result = env.handler(context, _args, optArgs);
            parser.expect("\\end", false);
            var endNameToken = parser.nextToken;
            var end = assertNodeType(parser.parseFunction(), "environment");
            if (end.name !== envName) throw new ParseError("Mismatch: \\begin{" + envName + "} matched by \\end{" + end.name + "}", endNameToken);
             // $FlowFixMe, "environment" handler returns an environment ParseNode
            return result;
        }
        return {
            type: "environment",
            mode: parser.mode,
            name: envName,
            nameGroup
        };
    }
});
// TODO(kevinb): implement \\sl and \\sc
var htmlBuilder$5 = (group, options)=>{
    var font = group.font;
    var newOptions = options.withFont(font);
    return buildGroup$1(group.body, newOptions);
};
var mathmlBuilder$4 = (group, options)=>{
    var font = group.font;
    var newOptions = options.withFont(font);
    return buildGroup(group.body, newOptions);
};
var fontAliases = {
    "\\Bbb": "\\mathbb",
    "\\bold": "\\mathbf",
    "\\frak": "\\mathfrak",
    "\\bm": "\\boldsymbol"
};
defineFunction({
    type: "font",
    names: [
        "\\mathrm",
        "\\mathit",
        "\\mathbf",
        "\\mathnormal",
        "\\mathsfit",
        "\\mathbb",
        "\\mathcal",
        "\\mathfrak",
        "\\mathscr",
        "\\mathsf",
        "\\mathtt",
        "\\Bbb",
        "\\bold",
        "\\frak"
    ],
    props: {
        numArgs: 1,
        allowedInArgument: true
    },
    handler: (_ref, args)=>{
        var { parser, funcName } = _ref;
        var body = normalizeArgument(args[0]);
        var func = funcName;
        if (func in fontAliases) func = fontAliases[func];
        return {
            type: "font",
            mode: parser.mode,
            font: func.slice(1),
            body
        };
    },
    htmlBuilder: htmlBuilder$5,
    mathmlBuilder: mathmlBuilder$4
});
defineFunction({
    type: "mclass",
    names: [
        "\\boldsymbol",
        "\\bm"
    ],
    props: {
        numArgs: 1
    },
    handler: (_ref2, args)=>{
        var { parser } = _ref2;
        var body = args[0];
        var isCharacterBox = utils.isCharacterBox(body); // amsbsy.sty's \boldsymbol uses \binrel spacing to inherit the
        // argument's bin|rel|ord status
        return {
            type: "mclass",
            mode: parser.mode,
            mclass: binrelClass(body),
            body: [
                {
                    type: "font",
                    mode: parser.mode,
                    font: "boldsymbol",
                    body
                }
            ],
            isCharacterBox: isCharacterBox
        };
    }
}); // Old font changing functions
defineFunction({
    type: "font",
    names: [
        "\\rm",
        "\\sf",
        "\\tt",
        "\\bf",
        "\\it",
        "\\cal"
    ],
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler: (_ref3, args)=>{
        var { parser, funcName, breakOnTokenText } = _ref3;
        var { mode } = parser;
        var body = parser.parseExpression(true, breakOnTokenText);
        var style = "math" + funcName.slice(1);
        return {
            type: "font",
            mode: mode,
            font: style,
            body: {
                type: "ordgroup",
                mode: parser.mode,
                body
            }
        };
    },
    htmlBuilder: htmlBuilder$5,
    mathmlBuilder: mathmlBuilder$4
});
var adjustStyle = (size, originalStyle)=>{
    // Figure out what style this fraction should be in based on the
    // function used
    var style = originalStyle;
    if (size === "display") // Get display style as a default.
    // If incoming style is sub/sup, use style.text() to get correct size.
    style = style.id >= Style$1.SCRIPT.id ? style.text() : Style$1.DISPLAY;
    else if (size === "text" && style.size === Style$1.DISPLAY.size) // We're in a \tfrac but incoming style is displaystyle, so:
    style = Style$1.TEXT;
    else if (size === "script") style = Style$1.SCRIPT;
    else if (size === "scriptscript") style = Style$1.SCRIPTSCRIPT;
    return style;
};
var htmlBuilder$4 = (group, options)=>{
    // Fractions are handled in the TeXbook on pages 444-445, rules 15(a-e).
    var style = adjustStyle(group.size, options.style);
    var nstyle = style.fracNum();
    var dstyle = style.fracDen();
    var newOptions;
    newOptions = options.havingStyle(nstyle);
    var numerm = buildGroup$1(group.numer, newOptions, options);
    if (group.continued) {
        // \cfrac inserts a \strut into the numerator.
        // Get \strut dimensions from TeXbook page 353.
        var hStrut = 8.5 / options.fontMetrics().ptPerEm;
        var dStrut = 3.5 / options.fontMetrics().ptPerEm;
        numerm.height = numerm.height < hStrut ? hStrut : numerm.height;
        numerm.depth = numerm.depth < dStrut ? dStrut : numerm.depth;
    }
    newOptions = options.havingStyle(dstyle);
    var denomm = buildGroup$1(group.denom, newOptions, options);
    var rule;
    var ruleWidth;
    var ruleSpacing;
    if (group.hasBarLine) {
        if (group.barSize) {
            ruleWidth = calculateSize(group.barSize, options);
            rule = buildCommon.makeLineSpan("frac-line", options, ruleWidth);
        } else rule = buildCommon.makeLineSpan("frac-line", options);
        ruleWidth = rule.height;
        ruleSpacing = rule.height;
    } else {
        rule = null;
        ruleWidth = 0;
        ruleSpacing = options.fontMetrics().defaultRuleThickness;
    } // Rule 15b
    var numShift;
    var clearance;
    var denomShift;
    if (style.size === Style$1.DISPLAY.size || group.size === "display") {
        numShift = options.fontMetrics().num1;
        if (ruleWidth > 0) clearance = 3 * ruleSpacing;
        else clearance = 7 * ruleSpacing;
        denomShift = options.fontMetrics().denom1;
    } else {
        if (ruleWidth > 0) {
            numShift = options.fontMetrics().num2;
            clearance = ruleSpacing;
        } else {
            numShift = options.fontMetrics().num3;
            clearance = 3 * ruleSpacing;
        }
        denomShift = options.fontMetrics().denom2;
    }
    var frac;
    if (!rule) {
        // Rule 15c
        var candidateClearance = numShift - numerm.depth - (denomm.height - denomShift);
        if (candidateClearance < clearance) {
            numShift += 0.5 * (clearance - candidateClearance);
            denomShift += 0.5 * (clearance - candidateClearance);
        }
        frac = buildCommon.makeVList({
            positionType: "individualShift",
            children: [
                {
                    type: "elem",
                    elem: denomm,
                    shift: denomShift
                },
                {
                    type: "elem",
                    elem: numerm,
                    shift: -numShift
                }
            ]
        }, options);
    } else {
        // Rule 15d
        var axisHeight = options.fontMetrics().axisHeight;
        if (numShift - numerm.depth - (axisHeight + 0.5 * ruleWidth) < clearance) numShift += clearance - (numShift - numerm.depth - (axisHeight + 0.5 * ruleWidth));
        if (axisHeight - 0.5 * ruleWidth - (denomm.height - denomShift) < clearance) denomShift += clearance - (axisHeight - 0.5 * ruleWidth - (denomm.height - denomShift));
        var midShift = -(axisHeight - 0.5 * ruleWidth);
        frac = buildCommon.makeVList({
            positionType: "individualShift",
            children: [
                {
                    type: "elem",
                    elem: denomm,
                    shift: denomShift
                },
                {
                    type: "elem",
                    elem: rule,
                    shift: midShift
                },
                {
                    type: "elem",
                    elem: numerm,
                    shift: -numShift
                }
            ]
        }, options);
    } // Since we manually change the style sometimes (with \dfrac or \tfrac),
    // account for the possible size change here.
    newOptions = options.havingStyle(style);
    frac.height *= newOptions.sizeMultiplier / options.sizeMultiplier;
    frac.depth *= newOptions.sizeMultiplier / options.sizeMultiplier; // Rule 15e
    var delimSize;
    if (style.size === Style$1.DISPLAY.size) delimSize = options.fontMetrics().delim1;
    else if (style.size === Style$1.SCRIPTSCRIPT.size) delimSize = options.havingStyle(Style$1.SCRIPT).fontMetrics().delim2;
    else delimSize = options.fontMetrics().delim2;
    var leftDelim;
    var rightDelim;
    if (group.leftDelim == null) leftDelim = makeNullDelimiter(options, [
        "mopen"
    ]);
    else leftDelim = delimiter.customSizedDelim(group.leftDelim, delimSize, true, options.havingStyle(style), group.mode, [
        "mopen"
    ]);
    if (group.continued) rightDelim = buildCommon.makeSpan([]); // zero width for \cfrac
    else if (group.rightDelim == null) rightDelim = makeNullDelimiter(options, [
        "mclose"
    ]);
    else rightDelim = delimiter.customSizedDelim(group.rightDelim, delimSize, true, options.havingStyle(style), group.mode, [
        "mclose"
    ]);
    return buildCommon.makeSpan([
        "mord"
    ].concat(newOptions.sizingClasses(options)), [
        leftDelim,
        buildCommon.makeSpan([
            "mfrac"
        ], [
            frac
        ]),
        rightDelim
    ], options);
};
var mathmlBuilder$3 = (group, options)=>{
    var node = new mathMLTree.MathNode("mfrac", [
        buildGroup(group.numer, options),
        buildGroup(group.denom, options)
    ]);
    if (!group.hasBarLine) node.setAttribute("linethickness", "0px");
    else if (group.barSize) {
        var ruleWidth = calculateSize(group.barSize, options);
        node.setAttribute("linethickness", makeEm(ruleWidth));
    }
    var style = adjustStyle(group.size, options.style);
    if (style.size !== options.style.size) {
        node = new mathMLTree.MathNode("mstyle", [
            node
        ]);
        var isDisplay = style.size === Style$1.DISPLAY.size ? "true" : "false";
        node.setAttribute("displaystyle", isDisplay);
        node.setAttribute("scriptlevel", "0");
    }
    if (group.leftDelim != null || group.rightDelim != null) {
        var withDelims = [];
        if (group.leftDelim != null) {
            var leftOp = new mathMLTree.MathNode("mo", [
                new mathMLTree.TextNode(group.leftDelim.replace("\\", ""))
            ]);
            leftOp.setAttribute("fence", "true");
            withDelims.push(leftOp);
        }
        withDelims.push(node);
        if (group.rightDelim != null) {
            var rightOp = new mathMLTree.MathNode("mo", [
                new mathMLTree.TextNode(group.rightDelim.replace("\\", ""))
            ]);
            rightOp.setAttribute("fence", "true");
            withDelims.push(rightOp);
        }
        return makeRow(withDelims);
    }
    return node;
};
defineFunction({
    type: "genfrac",
    names: [
        "\\dfrac",
        "\\frac",
        "\\tfrac",
        "\\dbinom",
        "\\binom",
        "\\tbinom",
        "\\\\atopfrac",
        "\\\\bracefrac",
        "\\\\brackfrac" // ditto
    ],
    props: {
        numArgs: 2,
        allowedInArgument: true
    },
    handler: (_ref, args)=>{
        var { parser, funcName } = _ref;
        var numer = args[0];
        var denom = args[1];
        var hasBarLine;
        var leftDelim = null;
        var rightDelim = null;
        var size = "auto";
        switch(funcName){
            case "\\dfrac":
            case "\\frac":
            case "\\tfrac":
                hasBarLine = true;
                break;
            case "\\\\atopfrac":
                hasBarLine = false;
                break;
            case "\\dbinom":
            case "\\binom":
            case "\\tbinom":
                hasBarLine = false;
                leftDelim = "(";
                rightDelim = ")";
                break;
            case "\\\\bracefrac":
                hasBarLine = false;
                leftDelim = "\\{";
                rightDelim = "\\}";
                break;
            case "\\\\brackfrac":
                hasBarLine = false;
                leftDelim = "[";
                rightDelim = "]";
                break;
            default:
                throw new Error("Unrecognized genfrac command");
        }
        switch(funcName){
            case "\\dfrac":
            case "\\dbinom":
                size = "display";
                break;
            case "\\tfrac":
            case "\\tbinom":
                size = "text";
                break;
        }
        return {
            type: "genfrac",
            mode: parser.mode,
            continued: false,
            numer,
            denom,
            hasBarLine,
            leftDelim,
            rightDelim,
            size,
            barSize: null
        };
    },
    htmlBuilder: htmlBuilder$4,
    mathmlBuilder: mathmlBuilder$3
});
defineFunction({
    type: "genfrac",
    names: [
        "\\cfrac"
    ],
    props: {
        numArgs: 2
    },
    handler: (_ref2, args)=>{
        var { parser, funcName } = _ref2;
        var numer = args[0];
        var denom = args[1];
        return {
            type: "genfrac",
            mode: parser.mode,
            continued: true,
            numer,
            denom,
            hasBarLine: true,
            leftDelim: null,
            rightDelim: null,
            size: "display",
            barSize: null
        };
    }
}); // Infix generalized fractions -- these are not rendered directly, but replaced
// immediately by one of the variants above.
defineFunction({
    type: "infix",
    names: [
        "\\over",
        "\\choose",
        "\\atop",
        "\\brace",
        "\\brack"
    ],
    props: {
        numArgs: 0,
        infix: true
    },
    handler (_ref3) {
        var { parser, funcName, token } = _ref3;
        var replaceWith;
        switch(funcName){
            case "\\over":
                replaceWith = "\\frac";
                break;
            case "\\choose":
                replaceWith = "\\binom";
                break;
            case "\\atop":
                replaceWith = "\\\\atopfrac";
                break;
            case "\\brace":
                replaceWith = "\\\\bracefrac";
                break;
            case "\\brack":
                replaceWith = "\\\\brackfrac";
                break;
            default:
                throw new Error("Unrecognized infix genfrac command");
        }
        return {
            type: "infix",
            mode: parser.mode,
            replaceWith,
            token
        };
    }
});
var stylArray = [
    "display",
    "text",
    "script",
    "scriptscript"
];
var delimFromValue = function delimFromValue(delimString) {
    var delim = null;
    if (delimString.length > 0) {
        delim = delimString;
        delim = delim === "." ? null : delim;
    }
    return delim;
};
defineFunction({
    type: "genfrac",
    names: [
        "\\genfrac"
    ],
    props: {
        numArgs: 6,
        allowedInArgument: true,
        argTypes: [
            "math",
            "math",
            "size",
            "text",
            "math",
            "math"
        ]
    },
    handler (_ref4, args) {
        var { parser } = _ref4;
        var numer = args[4];
        var denom = args[5]; // Look into the parse nodes to get the desired delimiters.
        var leftNode = normalizeArgument(args[0]);
        var leftDelim = leftNode.type === "atom" && leftNode.family === "open" ? delimFromValue(leftNode.text) : null;
        var rightNode = normalizeArgument(args[1]);
        var rightDelim = rightNode.type === "atom" && rightNode.family === "close" ? delimFromValue(rightNode.text) : null;
        var barNode = assertNodeType(args[2], "size");
        var hasBarLine;
        var barSize = null;
        if (barNode.isBlank) // \genfrac acts differently than \above.
        // \genfrac treats an empty size group as a signal to use a
        // standard bar size. \above would see size = 0 and omit the bar.
        hasBarLine = true;
        else {
            barSize = barNode.value;
            hasBarLine = barSize.number > 0;
        } // Find out if we want displaystyle, textstyle, etc.
        var size = "auto";
        var styl = args[3];
        if (styl.type === "ordgroup") {
            if (styl.body.length > 0) {
                var textOrd = assertNodeType(styl.body[0], "textord");
                size = stylArray[Number(textOrd.text)];
            }
        } else {
            styl = assertNodeType(styl, "textord");
            size = stylArray[Number(styl.text)];
        }
        return {
            type: "genfrac",
            mode: parser.mode,
            numer,
            denom,
            continued: false,
            hasBarLine,
            barSize,
            leftDelim,
            rightDelim,
            size
        };
    },
    htmlBuilder: htmlBuilder$4,
    mathmlBuilder: mathmlBuilder$3
}); // \above is an infix fraction that also defines a fraction bar size.
defineFunction({
    type: "infix",
    names: [
        "\\above"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "size"
        ],
        infix: true
    },
    handler (_ref5, args) {
        var { parser, funcName, token } = _ref5;
        return {
            type: "infix",
            mode: parser.mode,
            replaceWith: "\\\\abovefrac",
            size: assertNodeType(args[0], "size").value,
            token
        };
    }
});
defineFunction({
    type: "genfrac",
    names: [
        "\\\\abovefrac"
    ],
    props: {
        numArgs: 3,
        argTypes: [
            "math",
            "size",
            "math"
        ]
    },
    handler: (_ref6, args)=>{
        var { parser, funcName } = _ref6;
        var numer = args[0];
        var barSize = assert(assertNodeType(args[1], "infix").size);
        var denom = args[2];
        var hasBarLine = barSize.number > 0;
        return {
            type: "genfrac",
            mode: parser.mode,
            numer,
            denom,
            continued: false,
            hasBarLine,
            barSize,
            leftDelim: null,
            rightDelim: null,
            size: "auto"
        };
    },
    htmlBuilder: htmlBuilder$4,
    mathmlBuilder: mathmlBuilder$3
});
// NOTE: Unlike most `htmlBuilder`s, this one handles not only "horizBrace", but
// also "supsub" since an over/underbrace can affect super/subscripting.
var htmlBuilder$3 = (grp, options)=>{
    var style = options.style; // Pull out the `ParseNode<"horizBrace">` if `grp` is a "supsub" node.
    var supSubGroup;
    var group;
    if (grp.type === "supsub") {
        // Ref: LaTeX source2e: }}}}\limits}
        // i.e. LaTeX treats the brace similar to an op and passes it
        // with \limits, so we need to assign supsub style.
        supSubGroup = grp.sup ? buildGroup$1(grp.sup, options.havingStyle(style.sup()), options) : buildGroup$1(grp.sub, options.havingStyle(style.sub()), options);
        group = assertNodeType(grp.base, "horizBrace");
    } else group = assertNodeType(grp, "horizBrace");
     // Build the base group
    var body = buildGroup$1(group.base, options.havingBaseStyle(Style$1.DISPLAY)); // Create the stretchy element
    var braceBody = stretchy.svgSpan(group, options); // Generate the vlist, with the appropriate kerns        ┏━━━━━━━━┓
    // This first vlist contains the content and the brace:   equation
    var vlist;
    if (group.isOver) {
        vlist = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: body
                },
                {
                    type: "kern",
                    size: 0.1
                },
                {
                    type: "elem",
                    elem: braceBody
                }
            ]
        }, options); // $FlowFixMe: Replace this with passing "svg-align" into makeVList.
        vlist.children[0].children[0].children[1].classes.push("svg-align");
    } else {
        vlist = buildCommon.makeVList({
            positionType: "bottom",
            positionData: body.depth + 0.1 + braceBody.height,
            children: [
                {
                    type: "elem",
                    elem: braceBody
                },
                {
                    type: "kern",
                    size: 0.1
                },
                {
                    type: "elem",
                    elem: body
                }
            ]
        }, options); // $FlowFixMe: Replace this with passing "svg-align" into makeVList.
        vlist.children[0].children[0].children[0].classes.push("svg-align");
    }
    if (supSubGroup) {
        // To write the supsub, wrap the first vlist in another vlist:
        // They can't all go in the same vlist, because the note might be
        // wider than the equation. We want the equation to control the
        // brace width.
        //      note          long note           long note
        //   ┏━━━━━━━━┓   or    ┏━━━┓     not    ┏━━━━━━━━━┓
        //    equation           eqn                 eqn
        var vSpan = buildCommon.makeSpan([
            "mord",
            group.isOver ? "mover" : "munder"
        ], [
            vlist
        ], options);
        if (group.isOver) vlist = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: vSpan
                },
                {
                    type: "kern",
                    size: 0.2
                },
                {
                    type: "elem",
                    elem: supSubGroup
                }
            ]
        }, options);
        else vlist = buildCommon.makeVList({
            positionType: "bottom",
            positionData: vSpan.depth + 0.2 + supSubGroup.height + supSubGroup.depth,
            children: [
                {
                    type: "elem",
                    elem: supSubGroup
                },
                {
                    type: "kern",
                    size: 0.2
                },
                {
                    type: "elem",
                    elem: vSpan
                }
            ]
        }, options);
    }
    return buildCommon.makeSpan([
        "mord",
        group.isOver ? "mover" : "munder"
    ], [
        vlist
    ], options);
};
var mathmlBuilder$2 = (group, options)=>{
    var accentNode = stretchy.mathMLnode(group.label);
    return new mathMLTree.MathNode(group.isOver ? "mover" : "munder", [
        buildGroup(group.base, options),
        accentNode
    ]);
}; // Horizontal stretchy braces
defineFunction({
    type: "horizBrace",
    names: [
        "\\overbrace",
        "\\underbrace"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref, args) {
        var { parser, funcName } = _ref;
        return {
            type: "horizBrace",
            mode: parser.mode,
            label: funcName,
            isOver: /^\\over/.test(funcName),
            base: args[0]
        };
    },
    htmlBuilder: htmlBuilder$3,
    mathmlBuilder: mathmlBuilder$2
});
defineFunction({
    type: "href",
    names: [
        "\\href"
    ],
    props: {
        numArgs: 2,
        argTypes: [
            "url",
            "original"
        ],
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser } = _ref;
        var body = args[1];
        var href = assertNodeType(args[0], "url").url;
        if (!parser.settings.isTrusted({
            command: "\\href",
            url: href
        })) return parser.formatUnsupportedCmd("\\href");
        return {
            type: "href",
            mode: parser.mode,
            href,
            body: ordargument(body)
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = buildExpression$1(group.body, options, false);
        return buildCommon.makeAnchor(group.href, [], elements, options);
    },
    mathmlBuilder: (group, options)=>{
        var math = buildExpressionRow(group.body, options);
        if (!(math instanceof MathNode)) math = new MathNode("mrow", [
            math
        ]);
        math.setAttribute("href", group.href);
        return math;
    }
});
defineFunction({
    type: "href",
    names: [
        "\\url"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "url"
        ],
        allowedInText: true
    },
    handler: (_ref2, args)=>{
        var { parser } = _ref2;
        var href = assertNodeType(args[0], "url").url;
        if (!parser.settings.isTrusted({
            command: "\\url",
            url: href
        })) return parser.formatUnsupportedCmd("\\url");
        var chars = [];
        for(var i = 0; i < href.length; i++){
            var c = href[i];
            if (c === "~") c = "\\textasciitilde";
            chars.push({
                type: "textord",
                mode: "text",
                text: c
            });
        }
        var body = {
            type: "text",
            mode: parser.mode,
            font: "\\texttt",
            body: chars
        };
        return {
            type: "href",
            mode: parser.mode,
            href,
            body: ordargument(body)
        };
    }
});
// In LaTeX, \vcenter can act only on a box, as in
// \vcenter{\hbox{$\frac{a+b}{\dfrac{c}{d}}$}}
// This function by itself doesn't do anything but prevent a soft line break.
defineFunction({
    type: "hbox",
    names: [
        "\\hbox"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "text"
        ],
        allowedInText: true,
        primitive: true
    },
    handler (_ref, args) {
        var { parser } = _ref;
        return {
            type: "hbox",
            mode: parser.mode,
            body: ordargument(args[0])
        };
    },
    htmlBuilder (group, options) {
        var elements = buildExpression$1(group.body, options, false);
        return buildCommon.makeFragment(elements);
    },
    mathmlBuilder (group, options) {
        return new mathMLTree.MathNode("mrow", buildExpression(group.body, options));
    }
});
defineFunction({
    type: "html",
    names: [
        "\\htmlClass",
        "\\htmlId",
        "\\htmlStyle",
        "\\htmlData"
    ],
    props: {
        numArgs: 2,
        argTypes: [
            "raw",
            "original"
        ],
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser, funcName, token } = _ref;
        var value = assertNodeType(args[0], "raw").string;
        var body = args[1];
        if (parser.settings.strict) parser.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
        var trustContext;
        var attributes = {};
        switch(funcName){
            case "\\htmlClass":
                attributes.class = value;
                trustContext = {
                    command: "\\htmlClass",
                    class: value
                };
                break;
            case "\\htmlId":
                attributes.id = value;
                trustContext = {
                    command: "\\htmlId",
                    id: value
                };
                break;
            case "\\htmlStyle":
                attributes.style = value;
                trustContext = {
                    command: "\\htmlStyle",
                    style: value
                };
                break;
            case "\\htmlData":
                var data = value.split(",");
                for(var i = 0; i < data.length; i++){
                    var keyVal = data[i].split("=");
                    if (keyVal.length !== 2) throw new ParseError("Error parsing key-value for \\htmlData");
                    attributes["data-" + keyVal[0].trim()] = keyVal[1].trim();
                }
                trustContext = {
                    command: "\\htmlData",
                    attributes
                };
                break;
            default:
                throw new Error("Unrecognized html command");
        }
        if (!parser.settings.isTrusted(trustContext)) return parser.formatUnsupportedCmd(funcName);
        return {
            type: "html",
            mode: parser.mode,
            attributes,
            body: ordargument(body)
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = buildExpression$1(group.body, options, false);
        var classes = [
            "enclosing"
        ];
        if (group.attributes.class) classes.push(...group.attributes.class.trim().split(/\s+/));
        var span = buildCommon.makeSpan(classes, elements, options);
        for(var attr in group.attributes)if (attr !== "class" && group.attributes.hasOwnProperty(attr)) span.setAttribute(attr, group.attributes[attr]);
        return span;
    },
    mathmlBuilder: (group, options)=>{
        return buildExpressionRow(group.body, options);
    }
});
defineFunction({
    type: "htmlmathml",
    names: [
        "\\html@mathml"
    ],
    props: {
        numArgs: 2,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser } = _ref;
        return {
            type: "htmlmathml",
            mode: parser.mode,
            html: ordargument(args[0]),
            mathml: ordargument(args[1])
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = buildExpression$1(group.html, options, false);
        return buildCommon.makeFragment(elements);
    },
    mathmlBuilder: (group, options)=>{
        return buildExpressionRow(group.mathml, options);
    }
});
var sizeData = function sizeData(str) {
    if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(str)) // str is a number with no unit specified.
    // default unit is bp, per graphix package.
    return {
        number: +str,
        unit: "bp"
    };
    else {
        var match = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(str);
        if (!match) throw new ParseError("Invalid size: '" + str + "' in \\includegraphics");
        var data = {
            number: +(match[1] + match[2]),
            // sign + magnitude, cast to number
            unit: match[3]
        };
        if (!validUnit(data)) throw new ParseError("Invalid unit: '" + data.unit + "' in \\includegraphics.");
        return data;
    }
};
defineFunction({
    type: "includegraphics",
    names: [
        "\\includegraphics"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1,
        argTypes: [
            "raw",
            "url"
        ],
        allowedInText: false
    },
    handler: (_ref, args, optArgs)=>{
        var { parser } = _ref;
        var width = {
            number: 0,
            unit: "em"
        };
        var height = {
            number: 0.9,
            unit: "em"
        }; // sorta character sized.
        var totalheight = {
            number: 0,
            unit: "em"
        };
        var alt = "";
        if (optArgs[0]) {
            var attributeStr = assertNodeType(optArgs[0], "raw").string; // Parser.js does not parse key/value pairs. We get a string.
            var attributes = attributeStr.split(",");
            for(var i = 0; i < attributes.length; i++){
                var keyVal = attributes[i].split("=");
                if (keyVal.length === 2) {
                    var str = keyVal[1].trim();
                    switch(keyVal[0].trim()){
                        case "alt":
                            alt = str;
                            break;
                        case "width":
                            width = sizeData(str);
                            break;
                        case "height":
                            height = sizeData(str);
                            break;
                        case "totalheight":
                            totalheight = sizeData(str);
                            break;
                        default:
                            throw new ParseError("Invalid key: '" + keyVal[0] + "' in \\includegraphics.");
                    }
                }
            }
        }
        var src = assertNodeType(args[0], "url").url;
        if (alt === "") {
            // No alt given. Use the file name. Strip away the path.
            alt = src;
            alt = alt.replace(/^.*[\\/]/, '');
            alt = alt.substring(0, alt.lastIndexOf('.'));
        }
        if (!parser.settings.isTrusted({
            command: "\\includegraphics",
            url: src
        })) return parser.formatUnsupportedCmd("\\includegraphics");
        return {
            type: "includegraphics",
            mode: parser.mode,
            alt: alt,
            width: width,
            height: height,
            totalheight: totalheight,
            src: src
        };
    },
    htmlBuilder: (group, options)=>{
        var height = calculateSize(group.height, options);
        var depth = 0;
        if (group.totalheight.number > 0) depth = calculateSize(group.totalheight, options) - height;
        var width = 0;
        if (group.width.number > 0) width = calculateSize(group.width, options);
        var style = {
            height: makeEm(height + depth)
        };
        if (width > 0) style.width = makeEm(width);
        if (depth > 0) style.verticalAlign = makeEm(-depth);
        var node = new Img(group.src, group.alt, style);
        node.height = height;
        node.depth = depth;
        return node;
    },
    mathmlBuilder: (group, options)=>{
        var node = new mathMLTree.MathNode("mglyph", []);
        node.setAttribute("alt", group.alt);
        var height = calculateSize(group.height, options);
        var depth = 0;
        if (group.totalheight.number > 0) {
            depth = calculateSize(group.totalheight, options) - height;
            node.setAttribute("valign", makeEm(-depth));
        }
        node.setAttribute("height", makeEm(height + depth));
        if (group.width.number > 0) {
            var width = calculateSize(group.width, options);
            node.setAttribute("width", makeEm(width));
        }
        node.setAttribute("src", group.src);
        return node;
    }
});
// Horizontal spacing commands
defineFunction({
    type: "kern",
    names: [
        "\\kern",
        "\\mkern",
        "\\hskip",
        "\\mskip"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "size"
        ],
        primitive: true,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser, funcName } = _ref;
        var size = assertNodeType(args[0], "size");
        if (parser.settings.strict) {
            var mathFunction = funcName[1] === 'm'; // \mkern, \mskip
            var muUnit = size.value.unit === 'mu';
            if (mathFunction) {
                if (!muUnit) parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " supports only mu units, " + ("not " + size.value.unit + " units"));
                if (parser.mode !== "math") parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " works only in math mode");
            } else // !mathFunction
            if (muUnit) parser.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + funcName + " doesn't support mu units");
        }
        return {
            type: "kern",
            mode: parser.mode,
            dimension: size.value
        };
    },
    htmlBuilder (group, options) {
        return buildCommon.makeGlue(group.dimension, options);
    },
    mathmlBuilder (group, options) {
        var dimension = calculateSize(group.dimension, options);
        return new mathMLTree.SpaceNode(dimension);
    }
});
// Horizontal overlap functions
defineFunction({
    type: "lap",
    names: [
        "\\mathllap",
        "\\mathrlap",
        "\\mathclap"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser, funcName } = _ref;
        var body = args[0];
        return {
            type: "lap",
            mode: parser.mode,
            alignment: funcName.slice(5),
            body
        };
    },
    htmlBuilder: (group, options)=>{
        // mathllap, mathrlap, mathclap
        var inner;
        if (group.alignment === "clap") {
            // ref: https://www.math.lsu.edu/~aperlis/publications/mathclap/
            inner = buildCommon.makeSpan([], [
                buildGroup$1(group.body, options)
            ]); // wrap, since CSS will center a .clap > .inner > span
            inner = buildCommon.makeSpan([
                "inner"
            ], [
                inner
            ], options);
        } else inner = buildCommon.makeSpan([
            "inner"
        ], [
            buildGroup$1(group.body, options)
        ]);
        var fix = buildCommon.makeSpan([
            "fix"
        ], []);
        var node = buildCommon.makeSpan([
            group.alignment
        ], [
            inner,
            fix
        ], options); // At this point, we have correctly set horizontal alignment of the
        // two items involved in the lap.
        // Next, use a strut to set the height of the HTML bounding box.
        // Otherwise, a tall argument may be misplaced.
        // This code resolved issue #1153
        var strut = buildCommon.makeSpan([
            "strut"
        ]);
        strut.style.height = makeEm(node.height + node.depth);
        if (node.depth) strut.style.verticalAlign = makeEm(-node.depth);
        node.children.unshift(strut); // Next, prevent vertical misplacement when next to something tall.
        // This code resolves issue #1234
        node = buildCommon.makeSpan([
            "thinbox"
        ], [
            node
        ], options);
        return buildCommon.makeSpan([
            "mord",
            "vbox"
        ], [
            node
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        // mathllap, mathrlap, mathclap
        var node = new mathMLTree.MathNode("mpadded", [
            buildGroup(group.body, options)
        ]);
        if (group.alignment !== "rlap") {
            var offset = group.alignment === "llap" ? "-1" : "-0.5";
            node.setAttribute("lspace", offset + "width");
        }
        node.setAttribute("width", "0px");
        return node;
    }
});
defineFunction({
    type: "styling",
    names: [
        "\\(",
        "$"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInMath: false
    },
    handler (_ref, args) {
        var { funcName, parser } = _ref;
        var outerMode = parser.mode;
        parser.switchMode("math");
        var close = funcName === "\\(" ? "\\)" : "$";
        var body = parser.parseExpression(false, close);
        parser.expect(close);
        parser.switchMode(outerMode);
        return {
            type: "styling",
            mode: parser.mode,
            style: "text",
            body
        };
    }
}); // Check for extra closing math delimiters
defineFunction({
    type: "text",
    // Doesn't matter what this is.
    names: [
        "\\)",
        "\\]"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInMath: false
    },
    handler (context, args) {
        throw new ParseError("Mismatched " + context.funcName);
    }
});
var chooseMathStyle = (group, options)=>{
    switch(options.style.size){
        case Style$1.DISPLAY.size:
            return group.display;
        case Style$1.TEXT.size:
            return group.text;
        case Style$1.SCRIPT.size:
            return group.script;
        case Style$1.SCRIPTSCRIPT.size:
            return group.scriptscript;
        default:
            return group.text;
    }
};
defineFunction({
    type: "mathchoice",
    names: [
        "\\mathchoice"
    ],
    props: {
        numArgs: 4,
        primitive: true
    },
    handler: (_ref, args)=>{
        var { parser } = _ref;
        return {
            type: "mathchoice",
            mode: parser.mode,
            display: ordargument(args[0]),
            text: ordargument(args[1]),
            script: ordargument(args[2]),
            scriptscript: ordargument(args[3])
        };
    },
    htmlBuilder: (group, options)=>{
        var body = chooseMathStyle(group, options);
        var elements = buildExpression$1(body, options, false);
        return buildCommon.makeFragment(elements);
    },
    mathmlBuilder: (group, options)=>{
        var body = chooseMathStyle(group, options);
        return buildExpressionRow(body, options);
    }
});
var assembleSupSub = (base, supGroup, subGroup, options, style, slant, baseShift)=>{
    base = buildCommon.makeSpan([], [
        base
    ]);
    var subIsSingleCharacter = subGroup && utils.isCharacterBox(subGroup);
    var sub;
    var sup; // We manually have to handle the superscripts and subscripts. This,
    // aside from the kern calculations, is copied from supsub.
    if (supGroup) {
        var elem = buildGroup$1(supGroup, options.havingStyle(style.sup()), options);
        sup = {
            elem,
            kern: Math.max(options.fontMetrics().bigOpSpacing1, options.fontMetrics().bigOpSpacing3 - elem.depth)
        };
    }
    if (subGroup) {
        var _elem = buildGroup$1(subGroup, options.havingStyle(style.sub()), options);
        sub = {
            elem: _elem,
            kern: Math.max(options.fontMetrics().bigOpSpacing2, options.fontMetrics().bigOpSpacing4 - _elem.height)
        };
    } // Build the final group as a vlist of the possible subscript, base,
    // and possible superscript.
    var finalGroup;
    if (sup && sub) {
        var bottom = options.fontMetrics().bigOpSpacing5 + sub.elem.height + sub.elem.depth + sub.kern + base.depth + baseShift;
        finalGroup = buildCommon.makeVList({
            positionType: "bottom",
            positionData: bottom,
            children: [
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                },
                {
                    type: "elem",
                    elem: sub.elem,
                    marginLeft: makeEm(-slant)
                },
                {
                    type: "kern",
                    size: sub.kern
                },
                {
                    type: "elem",
                    elem: base
                },
                {
                    type: "kern",
                    size: sup.kern
                },
                {
                    type: "elem",
                    elem: sup.elem,
                    marginLeft: makeEm(slant)
                },
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                }
            ]
        }, options);
    } else if (sub) {
        var top = base.height - baseShift; // Shift the limits by the slant of the symbol. Note
        // that we are supposed to shift the limits by 1/2 of the slant,
        // but since we are centering the limits adding a full slant of
        // margin will shift by 1/2 that.
        finalGroup = buildCommon.makeVList({
            positionType: "top",
            positionData: top,
            children: [
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                },
                {
                    type: "elem",
                    elem: sub.elem,
                    marginLeft: makeEm(-slant)
                },
                {
                    type: "kern",
                    size: sub.kern
                },
                {
                    type: "elem",
                    elem: base
                }
            ]
        }, options);
    } else if (sup) {
        var _bottom = base.depth + baseShift;
        finalGroup = buildCommon.makeVList({
            positionType: "bottom",
            positionData: _bottom,
            children: [
                {
                    type: "elem",
                    elem: base
                },
                {
                    type: "kern",
                    size: sup.kern
                },
                {
                    type: "elem",
                    elem: sup.elem,
                    marginLeft: makeEm(slant)
                },
                {
                    type: "kern",
                    size: options.fontMetrics().bigOpSpacing5
                }
            ]
        }, options);
    } else // This case probably shouldn't occur (this would mean the
    // supsub was sending us a group with no superscript or
    // subscript) but be safe.
    return base;
    var parts = [
        finalGroup
    ];
    if (sub && slant !== 0 && !subIsSingleCharacter) {
        // A negative margin-left was applied to the lower limit.
        // Avoid an overlap by placing a spacer on the left on the group.
        var spacer = buildCommon.makeSpan([
            "mspace"
        ], [], options);
        spacer.style.marginRight = makeEm(slant);
        parts.unshift(spacer);
    }
    return buildCommon.makeSpan([
        "mop",
        "op-limits"
    ], parts, options);
};
// Limits, symbols
// Most operators have a large successor symbol, but these don't.
var noSuccessor = [
    "\\smallint"
]; // NOTE: Unlike most `htmlBuilder`s, this one handles not only "op", but also
// "supsub" since some of them (like \int) can affect super/subscripting.
var htmlBuilder$2 = (grp, options)=>{
    // Operators are handled in the TeXbook pg. 443-444, rule 13(a).
    var supGroup;
    var subGroup;
    var hasLimits = false;
    var group;
    if (grp.type === "supsub") {
        // If we have limits, supsub will pass us its group to handle. Pull
        // out the superscript and subscript and set the group to the op in
        // its base.
        supGroup = grp.sup;
        subGroup = grp.sub;
        group = assertNodeType(grp.base, "op");
        hasLimits = true;
    } else group = assertNodeType(grp, "op");
    var style = options.style;
    var large = false;
    if (style.size === Style$1.DISPLAY.size && group.symbol && !noSuccessor.includes(group.name)) // Most symbol operators get larger in displaystyle (rule 13)
    large = true;
    var base;
    if (group.symbol) {
        // If this is a symbol, create the symbol.
        var fontName = large ? "Size2-Regular" : "Size1-Regular";
        var stash = "";
        if (group.name === "\\oiint" || group.name === "\\oiiint") {
            // No font glyphs yet, so use a glyph w/o the oval.
            // TODO: When font glyphs are available, delete this code.
            stash = group.name.slice(1);
            group.name = stash === "oiint" ? "\\iint" : "\\iiint";
        }
        base = buildCommon.makeSymbol(group.name, fontName, "math", options, [
            "mop",
            "op-symbol",
            large ? "large-op" : "small-op"
        ]);
        if (stash.length > 0) {
            // We're in \oiint or \oiiint. Overlay the oval.
            // TODO: When font glyphs are available, delete this code.
            var italic = base.italic;
            var oval = buildCommon.staticSvg(stash + "Size" + (large ? "2" : "1"), options);
            base = buildCommon.makeVList({
                positionType: "individualShift",
                children: [
                    {
                        type: "elem",
                        elem: base,
                        shift: 0
                    },
                    {
                        type: "elem",
                        elem: oval,
                        shift: large ? 0.08 : 0
                    }
                ]
            }, options);
            group.name = "\\" + stash;
            base.classes.unshift("mop"); // $FlowFixMe
            base.italic = italic;
        }
    } else if (group.body) {
        // If this is a list, compose that list.
        var inner = buildExpression$1(group.body, options, true);
        if (inner.length === 1 && inner[0] instanceof SymbolNode) {
            base = inner[0];
            base.classes[0] = "mop"; // replace old mclass
        } else base = buildCommon.makeSpan([
            "mop"
        ], inner, options);
    } else {
        // Otherwise, this is a text operator. Build the text from the
        // operator's name.
        var output = [];
        for(var i = 1; i < group.name.length; i++)output.push(buildCommon.mathsym(group.name[i], group.mode, options));
        base = buildCommon.makeSpan([
            "mop"
        ], output, options);
    } // If content of op is a single symbol, shift it vertically.
    var baseShift = 0;
    var slant = 0;
    if ((base instanceof SymbolNode || group.name === "\\oiint" || group.name === "\\oiiint") && !group.suppressBaseShift) {
        // We suppress the shift of the base of \overset and \underset. Otherwise,
        // shift the symbol so its center lies on the axis (rule 13). It
        // appears that our fonts have the centers of the symbols already
        // almost on the axis, so these numbers are very small. Note we
        // don't actually apply this here, but instead it is used either in
        // the vlist creation or separately when there are no limits.
        baseShift = (base.height - base.depth) / 2 - options.fontMetrics().axisHeight; // The slant of the symbol is just its italic correction.
        // $FlowFixMe
        slant = base.italic;
    }
    if (hasLimits) return assembleSupSub(base, supGroup, subGroup, options, style, slant, baseShift);
    else {
        if (baseShift) {
            base.style.position = "relative";
            base.style.top = makeEm(baseShift);
        }
        return base;
    }
};
var mathmlBuilder$1 = (group, options)=>{
    var node;
    if (group.symbol) {
        // This is a symbol. Just add the symbol.
        node = new MathNode("mo", [
            makeText(group.name, group.mode)
        ]);
        if (noSuccessor.includes(group.name)) node.setAttribute("largeop", "false");
    } else if (group.body) // This is an operator with children. Add them.
    node = new MathNode("mo", buildExpression(group.body, options));
    else {
        // This is a text operator. Add all of the characters from the
        // operator's name.
        node = new MathNode("mi", [
            new TextNode(group.name.slice(1))
        ]); // Append an <mo>&ApplyFunction;</mo>.
        // ref: https://www.w3.org/TR/REC-MathML/chap3_2.html#sec3.2.4
        var operator = new MathNode("mo", [
            makeText("\u2061", "text")
        ]);
        if (group.parentIsSupSub) node = new MathNode("mrow", [
            node,
            operator
        ]);
        else node = newDocumentFragment([
            node,
            operator
        ]);
    }
    return node;
};
var singleCharBigOps = {
    "\u220F": "\\prod",
    "\u2210": "\\coprod",
    "\u2211": "\\sum",
    "\u22c0": "\\bigwedge",
    "\u22c1": "\\bigvee",
    "\u22c2": "\\bigcap",
    "\u22c3": "\\bigcup",
    "\u2a00": "\\bigodot",
    "\u2a01": "\\bigoplus",
    "\u2a02": "\\bigotimes",
    "\u2a04": "\\biguplus",
    "\u2a06": "\\bigsqcup"
};
defineFunction({
    type: "op",
    names: [
        "\\coprod",
        "\\bigvee",
        "\\bigwedge",
        "\\biguplus",
        "\\bigcap",
        "\\bigcup",
        "\\intop",
        "\\prod",
        "\\sum",
        "\\bigotimes",
        "\\bigoplus",
        "\\bigodot",
        "\\bigsqcup",
        "\\smallint",
        "\u220F",
        "\u2210",
        "\u2211",
        "\u22c0",
        "\u22c1",
        "\u22c2",
        "\u22c3",
        "\u2a00",
        "\u2a01",
        "\u2a02",
        "\u2a04",
        "\u2a06"
    ],
    props: {
        numArgs: 0
    },
    handler: (_ref, args)=>{
        var { parser, funcName } = _ref;
        var fName = funcName;
        if (fName.length === 1) fName = singleCharBigOps[fName];
        return {
            type: "op",
            mode: parser.mode,
            limits: true,
            parentIsSupSub: false,
            symbol: true,
            name: fName
        };
    },
    htmlBuilder: htmlBuilder$2,
    mathmlBuilder: mathmlBuilder$1
}); // Note: calling defineFunction with a type that's already been defined only
// works because the same htmlBuilder and mathmlBuilder are being used.
defineFunction({
    type: "op",
    names: [
        "\\mathop"
    ],
    props: {
        numArgs: 1,
        primitive: true
    },
    handler: (_ref2, args)=>{
        var { parser } = _ref2;
        var body = args[0];
        return {
            type: "op",
            mode: parser.mode,
            limits: false,
            parentIsSupSub: false,
            symbol: false,
            body: ordargument(body)
        };
    },
    htmlBuilder: htmlBuilder$2,
    mathmlBuilder: mathmlBuilder$1
}); // There are 2 flags for operators; whether they produce limits in
// displaystyle, and whether they are symbols and should grow in
// displaystyle. These four groups cover the four possible choices.
var singleCharIntegrals = {
    "\u222b": "\\int",
    "\u222c": "\\iint",
    "\u222d": "\\iiint",
    "\u222e": "\\oint",
    "\u222f": "\\oiint",
    "\u2230": "\\oiiint"
}; // No limits, not symbols
defineFunction({
    type: "op",
    names: [
        "\\arcsin",
        "\\arccos",
        "\\arctan",
        "\\arctg",
        "\\arcctg",
        "\\arg",
        "\\ch",
        "\\cos",
        "\\cosec",
        "\\cosh",
        "\\cot",
        "\\cotg",
        "\\coth",
        "\\csc",
        "\\ctg",
        "\\cth",
        "\\deg",
        "\\dim",
        "\\exp",
        "\\hom",
        "\\ker",
        "\\lg",
        "\\ln",
        "\\log",
        "\\sec",
        "\\sin",
        "\\sinh",
        "\\sh",
        "\\tan",
        "\\tanh",
        "\\tg",
        "\\th"
    ],
    props: {
        numArgs: 0
    },
    handler (_ref3) {
        var { parser, funcName } = _ref3;
        return {
            type: "op",
            mode: parser.mode,
            limits: false,
            parentIsSupSub: false,
            symbol: false,
            name: funcName
        };
    },
    htmlBuilder: htmlBuilder$2,
    mathmlBuilder: mathmlBuilder$1
}); // Limits, not symbols
defineFunction({
    type: "op",
    names: [
        "\\det",
        "\\gcd",
        "\\inf",
        "\\lim",
        "\\max",
        "\\min",
        "\\Pr",
        "\\sup"
    ],
    props: {
        numArgs: 0
    },
    handler (_ref4) {
        var { parser, funcName } = _ref4;
        return {
            type: "op",
            mode: parser.mode,
            limits: true,
            parentIsSupSub: false,
            symbol: false,
            name: funcName
        };
    },
    htmlBuilder: htmlBuilder$2,
    mathmlBuilder: mathmlBuilder$1
}); // No limits, symbols
defineFunction({
    type: "op",
    names: [
        "\\int",
        "\\iint",
        "\\iiint",
        "\\oint",
        "\\oiint",
        "\\oiiint",
        "\u222b",
        "\u222c",
        "\u222d",
        "\u222e",
        "\u222f",
        "\u2230"
    ],
    props: {
        numArgs: 0
    },
    handler (_ref5) {
        var { parser, funcName } = _ref5;
        var fName = funcName;
        if (fName.length === 1) fName = singleCharIntegrals[fName];
        return {
            type: "op",
            mode: parser.mode,
            limits: false,
            parentIsSupSub: false,
            symbol: true,
            name: fName
        };
    },
    htmlBuilder: htmlBuilder$2,
    mathmlBuilder: mathmlBuilder$1
});
// NOTE: Unlike most `htmlBuilder`s, this one handles not only
// "operatorname", but also  "supsub" since \operatorname* can
// affect super/subscripting.
var htmlBuilder$1 = (grp, options)=>{
    // Operators are handled in the TeXbook pg. 443-444, rule 13(a).
    var supGroup;
    var subGroup;
    var hasLimits = false;
    var group;
    if (grp.type === "supsub") {
        // If we have limits, supsub will pass us its group to handle. Pull
        // out the superscript and subscript and set the group to the op in
        // its base.
        supGroup = grp.sup;
        subGroup = grp.sub;
        group = assertNodeType(grp.base, "operatorname");
        hasLimits = true;
    } else group = assertNodeType(grp, "operatorname");
    var base;
    if (group.body.length > 0) {
        var body = group.body.map((child)=>{
            // $FlowFixMe: Check if the node has a string `text` property.
            var childText = child.text;
            if (typeof childText === "string") return {
                type: "textord",
                mode: child.mode,
                text: childText
            };
            else return child;
        }); // Consolidate function names into symbol characters.
        var expression = buildExpression$1(body, options.withFont("mathrm"), true);
        for(var i = 0; i < expression.length; i++){
            var child = expression[i];
            if (child instanceof SymbolNode) // Per amsopn package,
            // change minus to hyphen and \ast to asterisk
            child.text = child.text.replace(/\u2212/, "-").replace(/\u2217/, "*");
        }
        base = buildCommon.makeSpan([
            "mop"
        ], expression, options);
    } else base = buildCommon.makeSpan([
        "mop"
    ], [], options);
    if (hasLimits) return assembleSupSub(base, supGroup, subGroup, options, options.style, 0, 0);
    else return base;
};
var mathmlBuilder = (group, options)=>{
    // The steps taken here are similar to the html version.
    var expression = buildExpression(group.body, options.withFont("mathrm")); // Is expression a string or has it something like a fraction?
    var isAllString = true; // default
    for(var i = 0; i < expression.length; i++){
        var node = expression[i];
        if (node instanceof mathMLTree.SpaceNode) ;
        else if (node instanceof mathMLTree.MathNode) switch(node.type){
            case "mi":
            case "mn":
            case "ms":
            case "mspace":
            case "mtext":
                break;
            // Do nothing yet.
            case "mo":
                var child = node.children[0];
                if (node.children.length === 1 && child instanceof mathMLTree.TextNode) child.text = child.text.replace(/\u2212/, "-").replace(/\u2217/, "*");
                else isAllString = false;
                break;
            default:
                isAllString = false;
        }
        else isAllString = false;
    }
    if (isAllString) {
        // Write a single TextNode instead of multiple nested tags.
        var word = expression.map((node)=>node.toText()).join("");
        expression = [
            new mathMLTree.TextNode(word)
        ];
    }
    var identifier = new mathMLTree.MathNode("mi", expression);
    identifier.setAttribute("mathvariant", "normal"); // \u2061 is the same as &ApplyFunction;
    // ref: https://www.w3schools.com/charsets/ref_html_entities_a.asp
    var operator = new mathMLTree.MathNode("mo", [
        makeText("\u2061", "text")
    ]);
    if (group.parentIsSupSub) return new mathMLTree.MathNode("mrow", [
        identifier,
        operator
    ]);
    else return mathMLTree.newDocumentFragment([
        identifier,
        operator
    ]);
}; // \operatorname
// amsopn.dtx: \mathop{#1\kern\z@\operator@font#3}\newmcodes@
defineFunction({
    type: "operatorname",
    names: [
        "\\operatorname@",
        "\\operatornamewithlimits"
    ],
    props: {
        numArgs: 1
    },
    handler: (_ref, args)=>{
        var { parser, funcName } = _ref;
        var body = args[0];
        return {
            type: "operatorname",
            mode: parser.mode,
            body: ordargument(body),
            alwaysHandleSupSub: funcName === "\\operatornamewithlimits",
            limits: false,
            parentIsSupSub: false
        };
    },
    htmlBuilder: htmlBuilder$1,
    mathmlBuilder
});
defineMacro("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
defineFunctionBuilders({
    type: "ordgroup",
    htmlBuilder (group, options) {
        if (group.semisimple) return buildCommon.makeFragment(buildExpression$1(group.body, options, false));
        return buildCommon.makeSpan([
            "mord"
        ], buildExpression$1(group.body, options, true), options);
    },
    mathmlBuilder (group, options) {
        return buildExpressionRow(group.body, options, true);
    }
});
defineFunction({
    type: "overline",
    names: [
        "\\overline"
    ],
    props: {
        numArgs: 1
    },
    handler (_ref, args) {
        var { parser } = _ref;
        var body = args[0];
        return {
            type: "overline",
            mode: parser.mode,
            body
        };
    },
    htmlBuilder (group, options) {
        // Overlines are handled in the TeXbook pg 443, Rule 9.
        // Build the inner group in the cramped style.
        var innerGroup = buildGroup$1(group.body, options.havingCrampedStyle()); // Create the line above the body
        var line = buildCommon.makeLineSpan("overline-line", options); // Generate the vlist, with the appropriate kerns
        var defaultRuleThickness = options.fontMetrics().defaultRuleThickness;
        var vlist = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: innerGroup
                },
                {
                    type: "kern",
                    size: 3 * defaultRuleThickness
                },
                {
                    type: "elem",
                    elem: line
                },
                {
                    type: "kern",
                    size: defaultRuleThickness
                }
            ]
        }, options);
        return buildCommon.makeSpan([
            "mord",
            "overline"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder (group, options) {
        var operator = new mathMLTree.MathNode("mo", [
            new mathMLTree.TextNode("\u203e")
        ]);
        operator.setAttribute("stretchy", "true");
        var node = new mathMLTree.MathNode("mover", [
            buildGroup(group.body, options),
            operator
        ]);
        node.setAttribute("accent", "true");
        return node;
    }
});
defineFunction({
    type: "phantom",
    names: [
        "\\phantom"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { parser } = _ref;
        var body = args[0];
        return {
            type: "phantom",
            mode: parser.mode,
            body: ordargument(body)
        };
    },
    htmlBuilder: (group, options)=>{
        var elements = buildExpression$1(group.body, options.withPhantom(), false); // \phantom isn't supposed to affect the elements it contains.
        // See "color" for more details.
        return buildCommon.makeFragment(elements);
    },
    mathmlBuilder: (group, options)=>{
        var inner = buildExpression(group.body, options);
        return new mathMLTree.MathNode("mphantom", inner);
    }
});
defineFunction({
    type: "hphantom",
    names: [
        "\\hphantom"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler: (_ref2, args)=>{
        var { parser } = _ref2;
        var body = args[0];
        return {
            type: "hphantom",
            mode: parser.mode,
            body
        };
    },
    htmlBuilder: (group, options)=>{
        var node = buildCommon.makeSpan([], [
            buildGroup$1(group.body, options.withPhantom())
        ]);
        node.height = 0;
        node.depth = 0;
        if (node.children) for(var i = 0; i < node.children.length; i++){
            node.children[i].height = 0;
            node.children[i].depth = 0;
        }
         // See smash for comment re: use of makeVList
        node = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: node
                }
            ]
        }, options); // For spacing, TeX treats \smash as a math group (same spacing as ord).
        return buildCommon.makeSpan([
            "mord"
        ], [
            node
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        var inner = buildExpression(ordargument(group.body), options);
        var phantom = new mathMLTree.MathNode("mphantom", inner);
        var node = new mathMLTree.MathNode("mpadded", [
            phantom
        ]);
        node.setAttribute("height", "0px");
        node.setAttribute("depth", "0px");
        return node;
    }
});
defineFunction({
    type: "vphantom",
    names: [
        "\\vphantom"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler: (_ref3, args)=>{
        var { parser } = _ref3;
        var body = args[0];
        return {
            type: "vphantom",
            mode: parser.mode,
            body
        };
    },
    htmlBuilder: (group, options)=>{
        var inner = buildCommon.makeSpan([
            "inner"
        ], [
            buildGroup$1(group.body, options.withPhantom())
        ]);
        var fix = buildCommon.makeSpan([
            "fix"
        ], []);
        return buildCommon.makeSpan([
            "mord",
            "rlap"
        ], [
            inner,
            fix
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        var inner = buildExpression(ordargument(group.body), options);
        var phantom = new mathMLTree.MathNode("mphantom", inner);
        var node = new mathMLTree.MathNode("mpadded", [
            phantom
        ]);
        node.setAttribute("width", "0px");
        return node;
    }
});
defineFunction({
    type: "raisebox",
    names: [
        "\\raisebox"
    ],
    props: {
        numArgs: 2,
        argTypes: [
            "size",
            "hbox"
        ],
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser } = _ref;
        var amount = assertNodeType(args[0], "size").value;
        var body = args[1];
        return {
            type: "raisebox",
            mode: parser.mode,
            dy: amount,
            body
        };
    },
    htmlBuilder (group, options) {
        var body = buildGroup$1(group.body, options);
        var dy = calculateSize(group.dy, options);
        return buildCommon.makeVList({
            positionType: "shift",
            positionData: -dy,
            children: [
                {
                    type: "elem",
                    elem: body
                }
            ]
        }, options);
    },
    mathmlBuilder (group, options) {
        var node = new mathMLTree.MathNode("mpadded", [
            buildGroup(group.body, options)
        ]);
        var dy = group.dy.number + group.dy.unit;
        node.setAttribute("voffset", dy);
        return node;
    }
});
defineFunction({
    type: "internal",
    names: [
        "\\relax"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        allowedInArgument: true
    },
    handler (_ref) {
        var { parser } = _ref;
        return {
            type: "internal",
            mode: parser.mode
        };
    }
});
defineFunction({
    type: "rule",
    names: [
        "\\rule"
    ],
    props: {
        numArgs: 2,
        numOptionalArgs: 1,
        allowedInText: true,
        allowedInMath: true,
        argTypes: [
            "size",
            "size",
            "size"
        ]
    },
    handler (_ref, args, optArgs) {
        var { parser } = _ref;
        var shift = optArgs[0];
        var width = assertNodeType(args[0], "size");
        var height = assertNodeType(args[1], "size");
        return {
            type: "rule",
            mode: parser.mode,
            shift: shift && assertNodeType(shift, "size").value,
            width: width.value,
            height: height.value
        };
    },
    htmlBuilder (group, options) {
        // Make an empty span for the rule
        var rule = buildCommon.makeSpan([
            "mord",
            "rule"
        ], [], options); // Calculate the shift, width, and height of the rule, and account for units
        var width = calculateSize(group.width, options);
        var height = calculateSize(group.height, options);
        var shift = group.shift ? calculateSize(group.shift, options) : 0; // Style the rule to the right size
        rule.style.borderRightWidth = makeEm(width);
        rule.style.borderTopWidth = makeEm(height);
        rule.style.bottom = makeEm(shift); // Record the height and width
        rule.width = width;
        rule.height = height + shift;
        rule.depth = -shift; // Font size is the number large enough that the browser will
        // reserve at least `absHeight` space above the baseline.
        // The 1.125 factor was empirically determined
        rule.maxFontSize = height * 1.125 * options.sizeMultiplier;
        return rule;
    },
    mathmlBuilder (group, options) {
        var width = calculateSize(group.width, options);
        var height = calculateSize(group.height, options);
        var shift = group.shift ? calculateSize(group.shift, options) : 0;
        var color = options.color && options.getColor() || "black";
        var rule = new mathMLTree.MathNode("mspace");
        rule.setAttribute("mathbackground", color);
        rule.setAttribute("width", makeEm(width));
        rule.setAttribute("height", makeEm(height));
        var wrapper = new mathMLTree.MathNode("mpadded", [
            rule
        ]);
        if (shift >= 0) wrapper.setAttribute("height", makeEm(shift));
        else {
            wrapper.setAttribute("height", makeEm(shift));
            wrapper.setAttribute("depth", makeEm(-shift));
        }
        wrapper.setAttribute("voffset", makeEm(shift));
        return wrapper;
    }
});
function sizingGroup(value, options, baseOptions) {
    var inner = buildExpression$1(value, options, false);
    var multiplier = options.sizeMultiplier / baseOptions.sizeMultiplier; // Add size-resetting classes to the inner list and set maxFontSize
    // manually. Handle nested size changes.
    for(var i = 0; i < inner.length; i++){
        var pos = inner[i].classes.indexOf("sizing");
        if (pos < 0) Array.prototype.push.apply(inner[i].classes, options.sizingClasses(baseOptions));
        else if (inner[i].classes[pos + 1] === "reset-size" + options.size) // This is a nested size change: e.g., inner[i] is the "b" in
        // `\Huge a \small b`. Override the old size (the `reset-` class)
        // but not the new size.
        inner[i].classes[pos + 1] = "reset-size" + baseOptions.size;
        inner[i].height *= multiplier;
        inner[i].depth *= multiplier;
    }
    return buildCommon.makeFragment(inner);
}
var sizeFuncs = [
    "\\tiny",
    "\\sixptsize",
    "\\scriptsize",
    "\\footnotesize",
    "\\small",
    "\\normalsize",
    "\\large",
    "\\Large",
    "\\LARGE",
    "\\huge",
    "\\Huge"
];
var htmlBuilder = (group, options)=>{
    // Handle sizing operators like \Huge. Real TeX doesn't actually allow
    // these functions inside of math expressions, so we do some special
    // handling.
    var newOptions = options.havingSize(group.size);
    return sizingGroup(group.body, newOptions, options);
};
defineFunction({
    type: "sizing",
    names: sizeFuncs,
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler: (_ref, args)=>{
        var { breakOnTokenText, funcName, parser } = _ref;
        var body = parser.parseExpression(false, breakOnTokenText);
        return {
            type: "sizing",
            mode: parser.mode,
            // Figure out what size to use based on the list of functions above
            size: sizeFuncs.indexOf(funcName) + 1,
            body
        };
    },
    htmlBuilder,
    mathmlBuilder: (group, options)=>{
        var newOptions = options.havingSize(group.size);
        var inner = buildExpression(group.body, newOptions);
        var node = new mathMLTree.MathNode("mstyle", inner); // TODO(emily): This doesn't produce the correct size for nested size
        // changes, because we don't keep state of what style we're currently
        // in, so we can't reset the size to normal before changing it.  Now
        // that we're passing an options parameter we should be able to fix
        // this.
        node.setAttribute("mathsize", makeEm(newOptions.sizeMultiplier));
        return node;
    }
});
// smash, with optional [tb], as in AMS
defineFunction({
    type: "smash",
    names: [
        "\\smash"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1,
        allowedInText: true
    },
    handler: (_ref, args, optArgs)=>{
        var { parser } = _ref;
        var smashHeight = false;
        var smashDepth = false;
        var tbArg = optArgs[0] && assertNodeType(optArgs[0], "ordgroup");
        if (tbArg) {
            // Optional [tb] argument is engaged.
            // ref: amsmath: \renewcommand{\smash}[1][tb]{%
            //               def\mb@t{\ht}\def\mb@b{\dp}\def\mb@tb{\ht\z@\z@\dp}%
            var letter = "";
            for(var i = 0; i < tbArg.body.length; ++i){
                var node = tbArg.body[i]; // $FlowFixMe: Not every node type has a `text` property.
                letter = node.text;
                if (letter === "t") smashHeight = true;
                else if (letter === "b") smashDepth = true;
                else {
                    smashHeight = false;
                    smashDepth = false;
                    break;
                }
            }
        } else {
            smashHeight = true;
            smashDepth = true;
        }
        var body = args[0];
        return {
            type: "smash",
            mode: parser.mode,
            body,
            smashHeight,
            smashDepth
        };
    },
    htmlBuilder: (group, options)=>{
        var node = buildCommon.makeSpan([], [
            buildGroup$1(group.body, options)
        ]);
        if (!group.smashHeight && !group.smashDepth) return node;
        if (group.smashHeight) {
            node.height = 0; // In order to influence makeVList, we have to reset the children.
            if (node.children) for(var i = 0; i < node.children.length; i++)node.children[i].height = 0;
        }
        if (group.smashDepth) {
            node.depth = 0;
            if (node.children) for(var _i = 0; _i < node.children.length; _i++)node.children[_i].depth = 0;
        } // At this point, we've reset the TeX-like height and depth values.
        // But the span still has an HTML line height.
        // makeVList applies "display: table-cell", which prevents the browser
        // from acting on that line height. So we'll call makeVList now.
        var smashedNode = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: node
                }
            ]
        }, options); // For spacing, TeX treats \hphantom as a math group (same spacing as ord).
        return buildCommon.makeSpan([
            "mord"
        ], [
            smashedNode
        ], options);
    },
    mathmlBuilder: (group, options)=>{
        var node = new mathMLTree.MathNode("mpadded", [
            buildGroup(group.body, options)
        ]);
        if (group.smashHeight) node.setAttribute("height", "0px");
        if (group.smashDepth) node.setAttribute("depth", "0px");
        return node;
    }
});
defineFunction({
    type: "sqrt",
    names: [
        "\\sqrt"
    ],
    props: {
        numArgs: 1,
        numOptionalArgs: 1
    },
    handler (_ref, args, optArgs) {
        var { parser } = _ref;
        var index = optArgs[0];
        var body = args[0];
        return {
            type: "sqrt",
            mode: parser.mode,
            body,
            index
        };
    },
    htmlBuilder (group, options) {
        // Square roots are handled in the TeXbook pg. 443, Rule 11.
        // First, we do the same steps as in overline to build the inner group
        // and line
        var inner = buildGroup$1(group.body, options.havingCrampedStyle());
        if (inner.height === 0) // Render a small surd.
        inner.height = options.fontMetrics().xHeight;
         // Some groups can return document fragments.  Handle those by wrapping
        // them in a span.
        inner = buildCommon.wrapFragment(inner, options); // Calculate the minimum size for the \surd delimiter
        var metrics = options.fontMetrics();
        var theta = metrics.defaultRuleThickness;
        var phi = theta;
        if (options.style.id < Style$1.TEXT.id) phi = options.fontMetrics().xHeight;
         // Calculate the clearance between the body and line
        var lineClearance = theta + phi / 4;
        var minDelimiterHeight = inner.height + inner.depth + lineClearance + theta; // Create a sqrt SVG of the required minimum size
        var { span: img, ruleWidth, advanceWidth } = delimiter.sqrtImage(minDelimiterHeight, options);
        var delimDepth = img.height - ruleWidth; // Adjust the clearance based on the delimiter size
        if (delimDepth > inner.height + inner.depth + lineClearance) lineClearance = (lineClearance + delimDepth - inner.height - inner.depth) / 2;
         // Shift the sqrt image
        var imgShift = img.height - inner.height - lineClearance - ruleWidth;
        inner.style.paddingLeft = makeEm(advanceWidth); // Overlay the image and the argument.
        var body = buildCommon.makeVList({
            positionType: "firstBaseline",
            children: [
                {
                    type: "elem",
                    elem: inner,
                    wrapperClasses: [
                        "svg-align"
                    ]
                },
                {
                    type: "kern",
                    size: -(inner.height + imgShift)
                },
                {
                    type: "elem",
                    elem: img
                },
                {
                    type: "kern",
                    size: ruleWidth
                }
            ]
        }, options);
        if (!group.index) return buildCommon.makeSpan([
            "mord",
            "sqrt"
        ], [
            body
        ], options);
        else {
            // Handle the optional root index
            // The index is always in scriptscript style
            var newOptions = options.havingStyle(Style$1.SCRIPTSCRIPT);
            var rootm = buildGroup$1(group.index, newOptions, options); // The amount the index is shifted by. This is taken from the TeX
            // source, in the definition of `\r@@t`.
            var toShift = 0.6 * (body.height - body.depth); // Build a VList with the superscript shifted up correctly
            var rootVList = buildCommon.makeVList({
                positionType: "shift",
                positionData: -toShift,
                children: [
                    {
                        type: "elem",
                        elem: rootm
                    }
                ]
            }, options); // Add a class surrounding it so we can add on the appropriate
            // kerning
            var rootVListWrap = buildCommon.makeSpan([
                "root"
            ], [
                rootVList
            ]);
            return buildCommon.makeSpan([
                "mord",
                "sqrt"
            ], [
                rootVListWrap,
                body
            ], options);
        }
    },
    mathmlBuilder (group, options) {
        var { body, index } = group;
        return index ? new mathMLTree.MathNode("mroot", [
            buildGroup(body, options),
            buildGroup(index, options)
        ]) : new mathMLTree.MathNode("msqrt", [
            buildGroup(body, options)
        ]);
    }
});
var styleMap = {
    "display": Style$1.DISPLAY,
    "text": Style$1.TEXT,
    "script": Style$1.SCRIPT,
    "scriptscript": Style$1.SCRIPTSCRIPT
};
defineFunction({
    type: "styling",
    names: [
        "\\displaystyle",
        "\\textstyle",
        "\\scriptstyle",
        "\\scriptscriptstyle"
    ],
    props: {
        numArgs: 0,
        allowedInText: true,
        primitive: true
    },
    handler (_ref, args) {
        var { breakOnTokenText, funcName, parser } = _ref;
        // parse out the implicit body
        var body = parser.parseExpression(true, breakOnTokenText); // TODO: Refactor to avoid duplicating styleMap in multiple places (e.g.
        // here and in buildHTML and de-dupe the enumeration of all the styles).
        // $FlowFixMe: The names above exactly match the styles.
        var style = funcName.slice(1, funcName.length - 5);
        return {
            type: "styling",
            mode: parser.mode,
            // Figure out what style to use by pulling out the style from
            // the function name
            style,
            body
        };
    },
    htmlBuilder (group, options) {
        // Style changes are handled in the TeXbook on pg. 442, Rule 3.
        var newStyle = styleMap[group.style];
        var newOptions = options.havingStyle(newStyle).withFont('');
        return sizingGroup(group.body, newOptions, options);
    },
    mathmlBuilder (group, options) {
        // Figure out what style we're changing to.
        var newStyle = styleMap[group.style];
        var newOptions = options.havingStyle(newStyle);
        var inner = buildExpression(group.body, newOptions);
        var node = new mathMLTree.MathNode("mstyle", inner);
        var styleAttributes = {
            "display": [
                "0",
                "true"
            ],
            "text": [
                "0",
                "false"
            ],
            "script": [
                "1",
                "false"
            ],
            "scriptscript": [
                "2",
                "false"
            ]
        };
        var attr = styleAttributes[group.style];
        node.setAttribute("scriptlevel", attr[0]);
        node.setAttribute("displaystyle", attr[1]);
        return node;
    }
});
/**
 * Sometimes, groups perform special rules when they have superscripts or
 * subscripts attached to them. This function lets the `supsub` group know that
 * Sometimes, groups perform special rules when they have superscripts or
 * its inner element should handle the superscripts and subscripts instead of
 * handling them itself.
 */ var htmlBuilderDelegate = function htmlBuilderDelegate(group, options) {
    var base = group.base;
    if (!base) return null;
    else if (base.type === "op") {
        // Operators handle supsubs differently when they have limits
        // (e.g. `\displaystyle\sum_2^3`)
        var delegate = base.limits && (options.style.size === Style$1.DISPLAY.size || base.alwaysHandleSupSub);
        return delegate ? htmlBuilder$2 : null;
    } else if (base.type === "operatorname") {
        var _delegate = base.alwaysHandleSupSub && (options.style.size === Style$1.DISPLAY.size || base.limits);
        return _delegate ? htmlBuilder$1 : null;
    } else if (base.type === "accent") return utils.isCharacterBox(base.base) ? htmlBuilder$a : null;
    else if (base.type === "horizBrace") {
        var isSup = !group.sub;
        return isSup === base.isOver ? htmlBuilder$3 : null;
    } else return null;
}; // Super scripts and subscripts, whose precise placement can depend on other
// functions that precede them.
defineFunctionBuilders({
    type: "supsub",
    htmlBuilder (group, options) {
        // Superscript and subscripts are handled in the TeXbook on page
        // 445-446, rules 18(a-f).
        // Here is where we defer to the inner group if it should handle
        // superscripts and subscripts itself.
        var builderDelegate = htmlBuilderDelegate(group, options);
        if (builderDelegate) return builderDelegate(group, options);
        var { base: valueBase, sup: valueSup, sub: valueSub } = group;
        var base = buildGroup$1(valueBase, options);
        var supm;
        var subm;
        var metrics = options.fontMetrics(); // Rule 18a
        var supShift = 0;
        var subShift = 0;
        var isCharacterBox = valueBase && utils.isCharacterBox(valueBase);
        if (valueSup) {
            var newOptions = options.havingStyle(options.style.sup());
            supm = buildGroup$1(valueSup, newOptions, options);
            if (!isCharacterBox) supShift = base.height - newOptions.fontMetrics().supDrop * newOptions.sizeMultiplier / options.sizeMultiplier;
        }
        if (valueSub) {
            var _newOptions = options.havingStyle(options.style.sub());
            subm = buildGroup$1(valueSub, _newOptions, options);
            if (!isCharacterBox) subShift = base.depth + _newOptions.fontMetrics().subDrop * _newOptions.sizeMultiplier / options.sizeMultiplier;
        } // Rule 18c
        var minSupShift;
        if (options.style === Style$1.DISPLAY) minSupShift = metrics.sup1;
        else if (options.style.cramped) minSupShift = metrics.sup3;
        else minSupShift = metrics.sup2;
         // scriptspace is a font-size-independent size, so scale it
        // appropriately for use as the marginRight.
        var multiplier = options.sizeMultiplier;
        var marginRight = makeEm(0.5 / metrics.ptPerEm / multiplier);
        var marginLeft = null;
        if (subm) {
            // Subscripts shouldn't be shifted by the base's italic correction.
            // Account for that by shifting the subscript back the appropriate
            // amount. Note we only do this when the base is a single symbol.
            var isOiint = group.base && group.base.type === "op" && group.base.name && (group.base.name === "\\oiint" || group.base.name === "\\oiiint");
            if (base instanceof SymbolNode || isOiint) // $FlowFixMe
            marginLeft = makeEm(-base.italic);
        }
        var supsub;
        if (supm && subm) {
            supShift = Math.max(supShift, minSupShift, supm.depth + 0.25 * metrics.xHeight);
            subShift = Math.max(subShift, metrics.sub2);
            var ruleWidth = metrics.defaultRuleThickness; // Rule 18e
            var maxWidth = 4 * ruleWidth;
            if (supShift - supm.depth - (subm.height - subShift) < maxWidth) {
                subShift = maxWidth - (supShift - supm.depth) + subm.height;
                var psi = 0.8 * metrics.xHeight - (supShift - supm.depth);
                if (psi > 0) {
                    supShift += psi;
                    subShift -= psi;
                }
            }
            var vlistElem = [
                {
                    type: "elem",
                    elem: subm,
                    shift: subShift,
                    marginRight,
                    marginLeft
                },
                {
                    type: "elem",
                    elem: supm,
                    shift: -supShift,
                    marginRight
                }
            ];
            supsub = buildCommon.makeVList({
                positionType: "individualShift",
                children: vlistElem
            }, options);
        } else if (subm) {
            // Rule 18b
            subShift = Math.max(subShift, metrics.sub1, subm.height - 0.8 * metrics.xHeight);
            var _vlistElem = [
                {
                    type: "elem",
                    elem: subm,
                    marginLeft,
                    marginRight
                }
            ];
            supsub = buildCommon.makeVList({
                positionType: "shift",
                positionData: subShift,
                children: _vlistElem
            }, options);
        } else if (supm) {
            // Rule 18c, d
            supShift = Math.max(supShift, minSupShift, supm.depth + 0.25 * metrics.xHeight);
            supsub = buildCommon.makeVList({
                positionType: "shift",
                positionData: -supShift,
                children: [
                    {
                        type: "elem",
                        elem: supm,
                        marginRight
                    }
                ]
            }, options);
        } else throw new Error("supsub must have either sup or sub.");
         // Wrap the supsub vlist in a span.msupsub to reset text-align.
        var mclass = getTypeOfDomTree(base, "right") || "mord";
        return buildCommon.makeSpan([
            mclass
        ], [
            base,
            buildCommon.makeSpan([
                "msupsub"
            ], [
                supsub
            ])
        ], options);
    },
    mathmlBuilder (group, options) {
        // Is the inner group a relevant horizontal brace?
        var isBrace = false;
        var isOver;
        var isSup;
        if (group.base && group.base.type === "horizBrace") {
            isSup = !!group.sup;
            if (isSup === group.base.isOver) {
                isBrace = true;
                isOver = group.base.isOver;
            }
        }
        if (group.base && (group.base.type === "op" || group.base.type === "operatorname")) group.base.parentIsSupSub = true;
        var children = [
            buildGroup(group.base, options)
        ];
        if (group.sub) children.push(buildGroup(group.sub, options));
        if (group.sup) children.push(buildGroup(group.sup, options));
        var nodeType;
        if (isBrace) nodeType = isOver ? "mover" : "munder";
        else if (!group.sub) {
            var base = group.base;
            if (base && base.type === "op" && base.limits && (options.style === Style$1.DISPLAY || base.alwaysHandleSupSub)) nodeType = "mover";
            else if (base && base.type === "operatorname" && base.alwaysHandleSupSub && (base.limits || options.style === Style$1.DISPLAY)) nodeType = "mover";
            else nodeType = "msup";
        } else if (!group.sup) {
            var _base = group.base;
            if (_base && _base.type === "op" && _base.limits && (options.style === Style$1.DISPLAY || _base.alwaysHandleSupSub)) nodeType = "munder";
            else if (_base && _base.type === "operatorname" && _base.alwaysHandleSupSub && (_base.limits || options.style === Style$1.DISPLAY)) nodeType = "munder";
            else nodeType = "msub";
        } else {
            var _base2 = group.base;
            if (_base2 && _base2.type === "op" && _base2.limits && options.style === Style$1.DISPLAY) nodeType = "munderover";
            else if (_base2 && _base2.type === "operatorname" && _base2.alwaysHandleSupSub && (options.style === Style$1.DISPLAY || _base2.limits)) nodeType = "munderover";
            else nodeType = "msubsup";
        }
        return new mathMLTree.MathNode(nodeType, children);
    }
});
defineFunctionBuilders({
    type: "atom",
    htmlBuilder (group, options) {
        return buildCommon.mathsym(group.text, group.mode, options, [
            "m" + group.family
        ]);
    },
    mathmlBuilder (group, options) {
        var node = new mathMLTree.MathNode("mo", [
            makeText(group.text, group.mode)
        ]);
        if (group.family === "bin") {
            var variant = getVariant(group, options);
            if (variant === "bold-italic") node.setAttribute("mathvariant", variant);
        } else if (group.family === "punct") node.setAttribute("separator", "true");
        else if (group.family === "open" || group.family === "close") // Delims built here should not stretch vertically.
        // See delimsizing.js for stretchy delims.
        node.setAttribute("stretchy", "false");
        return node;
    }
});
// "mathord" and "textord" ParseNodes created in Parser.js from symbol Groups in
// src/symbols.js.
var defaultVariant = {
    "mi": "italic",
    "mn": "normal",
    "mtext": "normal"
};
defineFunctionBuilders({
    type: "mathord",
    htmlBuilder (group, options) {
        return buildCommon.makeOrd(group, options, "mathord");
    },
    mathmlBuilder (group, options) {
        var node = new mathMLTree.MathNode("mi", [
            makeText(group.text, group.mode, options)
        ]);
        var variant = getVariant(group, options) || "italic";
        if (variant !== defaultVariant[node.type]) node.setAttribute("mathvariant", variant);
        return node;
    }
});
defineFunctionBuilders({
    type: "textord",
    htmlBuilder (group, options) {
        return buildCommon.makeOrd(group, options, "textord");
    },
    mathmlBuilder (group, options) {
        var text = makeText(group.text, group.mode, options);
        var variant = getVariant(group, options) || "normal";
        var node;
        if (group.mode === 'text') node = new mathMLTree.MathNode("mtext", [
            text
        ]);
        else if (/[0-9]/.test(group.text)) node = new mathMLTree.MathNode("mn", [
            text
        ]);
        else if (group.text === "\\prime") node = new mathMLTree.MathNode("mo", [
            text
        ]);
        else node = new mathMLTree.MathNode("mi", [
            text
        ]);
        if (variant !== defaultVariant[node.type]) node.setAttribute("mathvariant", variant);
        return node;
    }
});
var cssSpace = {
    "\\nobreak": "nobreak",
    "\\allowbreak": "allowbreak"
}; // A lookup table to determine whether a spacing function/symbol should be
// treated like a regular space character.  If a symbol or command is a key
// in this table, then it should be a regular space character.  Furthermore,
// the associated value may have a `className` specifying an extra CSS class
// to add to the created `span`.
var regularSpace = {
    " ": {},
    "\\ ": {},
    "~": {
        className: "nobreak"
    },
    "\\space": {},
    "\\nobreakspace": {
        className: "nobreak"
    }
}; // ParseNode<"spacing"> created in Parser.js from the "spacing" symbol Groups in
// src/symbols.js.
defineFunctionBuilders({
    type: "spacing",
    htmlBuilder (group, options) {
        if (regularSpace.hasOwnProperty(group.text)) {
            var className = regularSpace[group.text].className || ""; // Spaces are generated by adding an actual space. Each of these
            // things has an entry in the symbols table, so these will be turned
            // into appropriate outputs.
            if (group.mode === "text") {
                var ord = buildCommon.makeOrd(group, options, "textord");
                ord.classes.push(className);
                return ord;
            } else return buildCommon.makeSpan([
                "mspace",
                className
            ], [
                buildCommon.mathsym(group.text, group.mode, options)
            ], options);
        } else if (cssSpace.hasOwnProperty(group.text)) // Spaces based on just a CSS class.
        return buildCommon.makeSpan([
            "mspace",
            cssSpace[group.text]
        ], [], options);
        else throw new ParseError("Unknown type of space \"" + group.text + "\"");
    },
    mathmlBuilder (group, options) {
        var node;
        if (regularSpace.hasOwnProperty(group.text)) node = new mathMLTree.MathNode("mtext", [
            new mathMLTree.TextNode("\u00a0")
        ]);
        else if (cssSpace.hasOwnProperty(group.text)) // CSS-based MathML spaces (\nobreak, \allowbreak) are ignored
        return new mathMLTree.MathNode("mspace");
        else throw new ParseError("Unknown type of space \"" + group.text + "\"");
        return node;
    }
});
var pad = ()=>{
    var padNode = new mathMLTree.MathNode("mtd", []);
    padNode.setAttribute("width", "50%");
    return padNode;
};
defineFunctionBuilders({
    type: "tag",
    mathmlBuilder (group, options) {
        var table = new mathMLTree.MathNode("mtable", [
            new mathMLTree.MathNode("mtr", [
                pad(),
                new mathMLTree.MathNode("mtd", [
                    buildExpressionRow(group.body, options)
                ]),
                pad(),
                new mathMLTree.MathNode("mtd", [
                    buildExpressionRow(group.tag, options)
                ])
            ])
        ]);
        table.setAttribute("width", "100%");
        return table; // TODO: Left-aligned tags.
    // Currently, the group and options passed here do not contain
    // enough info to set tag alignment. `leqno` is in Settings but it is
    // not passed to Options. On the HTML side, leqno is
    // set by a CSS class applied in buildTree.js. That would have worked
    // in MathML if browsers supported <mlabeledtr>. Since they don't, we
    // need to rewrite the way this function is called.
    }
});
var textFontFamilies = {
    "\\text": undefined,
    "\\textrm": "textrm",
    "\\textsf": "textsf",
    "\\texttt": "texttt",
    "\\textnormal": "textrm"
};
var textFontWeights = {
    "\\textbf": "textbf",
    "\\textmd": "textmd"
};
var textFontShapes = {
    "\\textit": "textit",
    "\\textup": "textup"
};
var optionsWithFont = (group, options)=>{
    var font = group.font; // Checks if the argument is a font family or a font style.
    if (!font) return options;
    else if (textFontFamilies[font]) return options.withTextFontFamily(textFontFamilies[font]);
    else if (textFontWeights[font]) return options.withTextFontWeight(textFontWeights[font]);
    else if (font === "\\emph") return options.fontShape === "textit" ? options.withTextFontShape("textup") : options.withTextFontShape("textit");
    return options.withTextFontShape(textFontShapes[font]);
};
defineFunction({
    type: "text",
    names: [
        "\\text",
        "\\textrm",
        "\\textsf",
        "\\texttt",
        "\\textnormal",
        "\\textbf",
        "\\textmd",
        "\\textit",
        "\\textup",
        "\\emph"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "text"
        ],
        allowedInArgument: true,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser, funcName } = _ref;
        var body = args[0];
        return {
            type: "text",
            mode: parser.mode,
            body: ordargument(body),
            font: funcName
        };
    },
    htmlBuilder (group, options) {
        var newOptions = optionsWithFont(group, options);
        var inner = buildExpression$1(group.body, newOptions, true);
        return buildCommon.makeSpan([
            "mord",
            "text"
        ], inner, newOptions);
    },
    mathmlBuilder (group, options) {
        var newOptions = optionsWithFont(group, options);
        return buildExpressionRow(group.body, newOptions);
    }
});
defineFunction({
    type: "underline",
    names: [
        "\\underline"
    ],
    props: {
        numArgs: 1,
        allowedInText: true
    },
    handler (_ref, args) {
        var { parser } = _ref;
        return {
            type: "underline",
            mode: parser.mode,
            body: args[0]
        };
    },
    htmlBuilder (group, options) {
        // Underlines are handled in the TeXbook pg 443, Rule 10.
        // Build the inner group.
        var innerGroup = buildGroup$1(group.body, options); // Create the line to go below the body
        var line = buildCommon.makeLineSpan("underline-line", options); // Generate the vlist, with the appropriate kerns
        var defaultRuleThickness = options.fontMetrics().defaultRuleThickness;
        var vlist = buildCommon.makeVList({
            positionType: "top",
            positionData: innerGroup.height,
            children: [
                {
                    type: "kern",
                    size: defaultRuleThickness
                },
                {
                    type: "elem",
                    elem: line
                },
                {
                    type: "kern",
                    size: 3 * defaultRuleThickness
                },
                {
                    type: "elem",
                    elem: innerGroup
                }
            ]
        }, options);
        return buildCommon.makeSpan([
            "mord",
            "underline"
        ], [
            vlist
        ], options);
    },
    mathmlBuilder (group, options) {
        var operator = new mathMLTree.MathNode("mo", [
            new mathMLTree.TextNode("\u203e")
        ]);
        operator.setAttribute("stretchy", "true");
        var node = new mathMLTree.MathNode("munder", [
            buildGroup(group.body, options),
            operator
        ]);
        node.setAttribute("accentunder", "true");
        return node;
    }
});
defineFunction({
    type: "vcenter",
    names: [
        "\\vcenter"
    ],
    props: {
        numArgs: 1,
        argTypes: [
            "original"
        ],
        // In LaTeX, \vcenter can act only on a box.
        allowedInText: false
    },
    handler (_ref, args) {
        var { parser } = _ref;
        return {
            type: "vcenter",
            mode: parser.mode,
            body: args[0]
        };
    },
    htmlBuilder (group, options) {
        var body = buildGroup$1(group.body, options);
        var axisHeight = options.fontMetrics().axisHeight;
        var dy = 0.5 * (body.height - axisHeight - (body.depth + axisHeight));
        return buildCommon.makeVList({
            positionType: "shift",
            positionData: dy,
            children: [
                {
                    type: "elem",
                    elem: body
                }
            ]
        }, options);
    },
    mathmlBuilder (group, options) {
        // There is no way to do this in MathML.
        // Write a class as a breadcrumb in case some post-processor wants
        // to perform a vcenter adjustment.
        return new mathMLTree.MathNode("mpadded", [
            buildGroup(group.body, options)
        ], [
            "vcenter"
        ]);
    }
});
defineFunction({
    type: "verb",
    names: [
        "\\verb"
    ],
    props: {
        numArgs: 0,
        allowedInText: true
    },
    handler (context, args, optArgs) {
        // \verb and \verb* are dealt with directly in Parser.js.
        // If we end up here, it's because of a failure to match the two delimiters
        // in the regex in Lexer.js.  LaTeX raises the following error when \verb is
        // terminated by end of line (or file).
        throw new ParseError("\\verb ended by end of line instead of matching delimiter");
    },
    htmlBuilder (group, options) {
        var text = makeVerb(group);
        var body = []; // \verb enters text mode and therefore is sized like \textstyle
        var newOptions = options.havingStyle(options.style.text());
        for(var i = 0; i < text.length; i++){
            var c = text[i];
            if (c === '~') c = '\\textasciitilde';
            body.push(buildCommon.makeSymbol(c, "Typewriter-Regular", group.mode, newOptions, [
                "mord",
                "texttt"
            ]));
        }
        return buildCommon.makeSpan([
            "mord",
            "text"
        ].concat(newOptions.sizingClasses(options)), buildCommon.tryCombineChars(body), newOptions);
    },
    mathmlBuilder (group, options) {
        var text = new mathMLTree.TextNode(makeVerb(group));
        var node = new mathMLTree.MathNode("mtext", [
            text
        ]);
        node.setAttribute("mathvariant", "monospace");
        return node;
    }
});
/**
 * Converts verb group into body string.
 *
 * \verb* replaces each space with an open box \u2423
 * \verb replaces each space with a no-break space \xA0
 */ var makeVerb = (group)=>group.body.replace(/ /g, group.star ? '\u2423' : '\xA0');
/** Include this to ensure that all functions are defined. */ var functions = _functions;
/**
 * The Lexer class handles tokenizing the input in various ways. Since our
 * parser expects us to be able to backtrack, the lexer allows lexing from any
 * given starting point.
 *
 * Its main exposed function is the `lex` function, which takes a position to
 * lex from and a type of token to lex. It defers to the appropriate `_innerLex`
 * function.
 *
 * The various `_innerLex` functions perform the actual lexing of different
 * kinds.
 */ /* The following tokenRegex
 * - matches typical whitespace (but not NBSP etc.) using its first group
 * - does not match any control character \x00-\x1f except whitespace
 * - does not match a bare backslash
 * - matches any ASCII character except those just mentioned
 * - does not match the BMP private use area \uE000-\uF8FF
 * - does not match bare surrogate code units
 * - matches any BMP character except for those just described
 * - matches any valid Unicode surrogate pair
 * - matches a backslash followed by one or more whitespace characters
 * - matches a backslash followed by one or more letters then whitespace
 * - matches a backslash followed by any BMP character
 * Capturing groups:
 *   [1] regular whitespace
 *   [2] backslash followed by whitespace
 *   [3] anything else, which may include:
 *     [4] left character of \verb*
 *     [5] left character of \verb
 *     [6] backslash followed by word, excluding any trailing whitespace
 * Just because the Lexer matches something doesn't mean it's valid input:
 * If there is no matching function or symbol definition, the Parser will
 * still reject the input.
 */ var spaceRegexString = "[ \r\n\t]";
var controlWordRegexString = "\\\\[a-zA-Z@]+";
var controlSymbolRegexString = "\\\\[^\uD800-\uDFFF]";
var controlWordWhitespaceRegexString = "(" + controlWordRegexString + ")" + spaceRegexString + "*";
var controlSpaceRegexString = "\\\\(\n|[ \r\t]+\n?)[ \r\t]*";
var combiningDiacriticalMarkString = "[\u0300-\u036f]";
var combiningDiacriticalMarksEndRegex = new RegExp(combiningDiacriticalMarkString + "+$");
var tokenRegexString = "(" + spaceRegexString + "+)|" + (controlSpaceRegexString + "|") + // \whitespace
"([!-\\[\\]-\u2027\u202A-\uD7FF\uF900-\uFFFF]" + (combiningDiacriticalMarkString + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + (combiningDiacriticalMarkString + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4" + // \verb*
"|\\\\verb([^*a-zA-Z]).*?\\5" + ("|" + controlWordWhitespaceRegexString) + ("|" + controlSymbolRegexString + ")"); // \\, \', etc.
/** Main Lexer class */ class Lexer {
    // Category codes. The lexer only supports comment characters (14) for now.
    // MacroExpander additionally distinguishes active (13).
    constructor(input, settings){
        this.input = void 0;
        this.settings = void 0;
        this.tokenRegex = void 0;
        this.catcodes = void 0;
        // Separate accents from characters
        this.input = input;
        this.settings = settings;
        this.tokenRegex = new RegExp(tokenRegexString, 'g');
        this.catcodes = {
            "%": 14,
            // comment character
            "~": 13 // active character
        };
    }
    setCatcode(char, code) {
        this.catcodes[char] = code;
    }
    /**
   * This function lexes a single token.
   */ lex() {
        var input = this.input;
        var pos = this.tokenRegex.lastIndex;
        if (pos === input.length) return new Token("EOF", new SourceLocation(this, pos, pos));
        var match = this.tokenRegex.exec(input);
        if (match === null || match.index !== pos) throw new ParseError("Unexpected character: '" + input[pos] + "'", new Token(input[pos], new SourceLocation(this, pos, pos + 1)));
        var text = match[6] || match[3] || (match[2] ? "\\ " : " ");
        if (this.catcodes[text] === 14) {
            // comment character
            var nlIndex = input.indexOf('\n', this.tokenRegex.lastIndex);
            if (nlIndex === -1) {
                this.tokenRegex.lastIndex = input.length; // EOF
                this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)");
            } else this.tokenRegex.lastIndex = nlIndex + 1;
            return this.lex();
        }
        return new Token(text, new SourceLocation(this, pos, this.tokenRegex.lastIndex));
    }
}
/**
 * A `Namespace` refers to a space of nameable things like macros or lengths,
 * which can be `set` either globally or local to a nested group, using an
 * undo stack similar to how TeX implements this functionality.
 * Performance-wise, `get` and local `set` take constant time, while global
 * `set` takes time proportional to the depth of group nesting.
 */ class Namespace {
    /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */ constructor(builtins, globalMacros){
        if (builtins === void 0) builtins = {};
        if (globalMacros === void 0) globalMacros = {};
        this.current = void 0;
        this.builtins = void 0;
        this.undefStack = void 0;
        this.current = globalMacros;
        this.builtins = builtins;
        this.undefStack = [];
    }
    /**
   * Start a new nested group, affecting future local `set`s.
   */ beginGroup() {
        this.undefStack.push({});
    }
    /**
   * End current nested group, restoring values before the group began.
   */ endGroup() {
        if (this.undefStack.length === 0) throw new ParseError("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
        var undefs = this.undefStack.pop();
        for(var undef in undefs)if (undefs.hasOwnProperty(undef)) {
            if (undefs[undef] == null) delete this.current[undef];
            else this.current[undef] = undefs[undef];
        }
    }
    /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */ endGroups() {
        while(this.undefStack.length > 0)this.endGroup();
    }
    /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */ has(name) {
        return this.current.hasOwnProperty(name) || this.builtins.hasOwnProperty(name);
    }
    /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */ get(name) {
        if (this.current.hasOwnProperty(name)) return this.current[name];
        else return this.builtins[name];
    }
    /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */ set(name, value, global) {
        if (global === void 0) global = false;
        if (global) {
            // Global set is equivalent to setting in all groups.  Simulate this
            // by destroying any undos currently scheduled for this name,
            // and adding an undo with the *new* value (in case it later gets
            // locally reset within this environment).
            for(var i = 0; i < this.undefStack.length; i++)delete this.undefStack[i][name];
            if (this.undefStack.length > 0) this.undefStack[this.undefStack.length - 1][name] = value;
        } else {
            // Undo this set at end of this group (possibly to `undefined`),
            // unless an undo is already in place, in which case that older
            // value is the correct one.
            var top = this.undefStack[this.undefStack.length - 1];
            if (top && !top.hasOwnProperty(name)) top[name] = this.current[name];
        }
        if (value == null) delete this.current[name];
        else this.current[name] = value;
    }
}
/**
 * Predefined macros for KaTeX.
 * This can be used to define some commands in terms of others.
 */ var macros = _macros;
// macro tools
defineMacro("\\noexpand", function(context) {
    // The expansion is the token itself; but that token is interpreted
    // as if its meaning were ‘\relax’ if it is a control sequence that
    // would ordinarily be expanded by TeX’s expansion rules.
    var t = context.popToken();
    if (context.isExpandable(t.text)) {
        t.noexpand = true;
        t.treatAsRelax = true;
    }
    return {
        tokens: [
            t
        ],
        numArgs: 0
    };
});
defineMacro("\\expandafter", function(context) {
    // TeX first reads the token that comes immediately after \expandafter,
    // without expanding it; let’s call this token t. Then TeX reads the
    // token that comes after t (and possibly more tokens, if that token
    // has an argument), replacing it by its expansion. Finally TeX puts
    // t back in front of that expansion.
    var t = context.popToken();
    context.expandOnce(true); // expand only an expandable token
    return {
        tokens: [
            t
        ],
        numArgs: 0
    };
}); // LaTeX's \@firstoftwo{#1}{#2} expands to #1, skipping #2
// TeX source: \long\def\@firstoftwo#1#2{#1}
defineMacro("\\@firstoftwo", function(context) {
    var args = context.consumeArgs(2);
    return {
        tokens: args[0],
        numArgs: 0
    };
}); // LaTeX's \@secondoftwo{#1}{#2} expands to #2, skipping #1
// TeX source: \long\def\@secondoftwo#1#2{#2}
defineMacro("\\@secondoftwo", function(context) {
    var args = context.consumeArgs(2);
    return {
        tokens: args[1],
        numArgs: 0
    };
}); // LaTeX's \@ifnextchar{#1}{#2}{#3} looks ahead to the next (unexpanded)
// symbol that isn't a space, consuming any spaces but not consuming the
// first nonspace character.  If that nonspace character matches #1, then
// the macro expands to #2; otherwise, it expands to #3.
defineMacro("\\@ifnextchar", function(context) {
    var args = context.consumeArgs(3); // symbol, if, else
    context.consumeSpaces();
    var nextToken = context.future();
    if (args[0].length === 1 && args[0][0].text === nextToken.text) return {
        tokens: args[1],
        numArgs: 0
    };
    else return {
        tokens: args[2],
        numArgs: 0
    };
}); // LaTeX's \@ifstar{#1}{#2} looks ahead to the next (unexpanded) symbol.
// If it is `*`, then it consumes the symbol, and the macro expands to #1;
// otherwise, the macro expands to #2 (without consuming the symbol).
// TeX source: \def\@ifstar#1{\@ifnextchar *{\@firstoftwo{#1}}}
defineMacro("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}"); // LaTeX's \TextOrMath{#1}{#2} expands to #1 in text mode, #2 in math mode
defineMacro("\\TextOrMath", function(context) {
    var args = context.consumeArgs(2);
    if (context.mode === 'text') return {
        tokens: args[0],
        numArgs: 0
    };
    else return {
        tokens: args[1],
        numArgs: 0
    };
}); // Lookup table for parsing numbers in base 8 through 16
var digitToNumber = {
    "0": 0,
    "1": 1,
    "2": 2,
    "3": 3,
    "4": 4,
    "5": 5,
    "6": 6,
    "7": 7,
    "8": 8,
    "9": 9,
    "a": 10,
    "A": 10,
    "b": 11,
    "B": 11,
    "c": 12,
    "C": 12,
    "d": 13,
    "D": 13,
    "e": 14,
    "E": 14,
    "f": 15,
    "F": 15
}; // TeX \char makes a literal character (catcode 12) using the following forms:
// (see The TeXBook, p. 43)
//   \char123  -- decimal
//   \char'123 -- octal
//   \char"123 -- hex
//   \char`x   -- character that can be written (i.e. isn't active)
//   \char`\x  -- character that cannot be written (e.g. %)
// These all refer to characters from the font, so we turn them into special
// calls to a function \@char dealt with in the Parser.
defineMacro("\\char", function(context) {
    var token = context.popToken();
    var base;
    var number = '';
    if (token.text === "'") {
        base = 8;
        token = context.popToken();
    } else if (token.text === '"') {
        base = 16;
        token = context.popToken();
    } else if (token.text === "`") {
        token = context.popToken();
        if (token.text[0] === "\\") number = token.text.charCodeAt(1);
        else if (token.text === "EOF") throw new ParseError("\\char` missing argument");
        else number = token.text.charCodeAt(0);
    } else base = 10;
    if (base) {
        // Parse a number in the given base, starting with first `token`.
        number = digitToNumber[token.text];
        if (number == null || number >= base) throw new ParseError("Invalid base-" + base + " digit " + token.text);
        var digit;
        while((digit = digitToNumber[context.future().text]) != null && digit < base){
            number *= base;
            number += digit;
            context.popToken();
        }
    }
    return "\\@char{" + number + "}";
}); // \newcommand{\macro}[args]{definition}
// \renewcommand{\macro}[args]{definition}
// TODO: Optional arguments: \newcommand{\macro}[args][default]{definition}
var newcommand = (context, existsOK, nonexistsOK, skipIfExists)=>{
    var arg = context.consumeArg().tokens;
    if (arg.length !== 1) throw new ParseError("\\newcommand's first argument must be a macro name");
    var name = arg[0].text;
    var exists = context.isDefined(name);
    if (exists && !existsOK) throw new ParseError("\\newcommand{" + name + "} attempting to redefine " + (name + "; use \\renewcommand"));
    if (!exists && !nonexistsOK) throw new ParseError("\\renewcommand{" + name + "} when command " + name + " " + "does not yet exist; use \\newcommand");
    var numArgs = 0;
    arg = context.consumeArg().tokens;
    if (arg.length === 1 && arg[0].text === "[") {
        var argText = '';
        var token = context.expandNextToken();
        while(token.text !== "]" && token.text !== "EOF"){
            // TODO: Should properly expand arg, e.g., ignore {}s
            argText += token.text;
            token = context.expandNextToken();
        }
        if (!argText.match(/^\s*[0-9]+\s*$/)) throw new ParseError("Invalid number of arguments: " + argText);
        numArgs = parseInt(argText);
        arg = context.consumeArg().tokens;
    }
    if (!(exists && skipIfExists)) // Final arg is the expansion of the macro
    context.macros.set(name, {
        tokens: arg,
        numArgs
    });
    return '';
};
defineMacro("\\newcommand", (context)=>newcommand(context, false, true, false));
defineMacro("\\renewcommand", (context)=>newcommand(context, true, false, false));
defineMacro("\\providecommand", (context)=>newcommand(context, true, true, true)); // terminal (console) tools
defineMacro("\\message", (context)=>{
    var arg = context.consumeArgs(1)[0]; // eslint-disable-next-line no-console
    console.log(arg.reverse().map((token)=>token.text).join(""));
    return '';
});
defineMacro("\\errmessage", (context)=>{
    var arg = context.consumeArgs(1)[0]; // eslint-disable-next-line no-console
    console.error(arg.reverse().map((token)=>token.text).join(""));
    return '';
});
defineMacro("\\show", (context)=>{
    var tok = context.popToken();
    var name = tok.text; // eslint-disable-next-line no-console
    console.log(tok, context.macros.get(name), functions[name], symbols.math[name], symbols.text[name]);
    return '';
}); //////////////////////////////////////////////////////////////////////
// Grouping
// \let\bgroup={ \let\egroup=}
defineMacro("\\bgroup", "{");
defineMacro("\\egroup", "}"); // Symbols from latex.ltx:
// \def~{\nobreakspace{}}
// \def\lq{`}
// \def\rq{'}
// \def \aa {\r a}
// \def \AA {\r A}
defineMacro("~", "\\nobreakspace");
defineMacro("\\lq", "`");
defineMacro("\\rq", "'");
defineMacro("\\aa", "\\r a");
defineMacro("\\AA", "\\r A"); // Copyright (C) and registered (R) symbols. Use raw symbol in MathML.
// \DeclareTextCommandDefault{\textcopyright}{\textcircled{c}}
// \DeclareTextCommandDefault{\textregistered}{\textcircled{%
//      \check@mathfonts\fontsize\sf@size\z@\math@fontsfalse\selectfont R}}
// \DeclareRobustCommand{\copyright}{%
//    \ifmmode{\nfss@text{\textcopyright}}\else\textcopyright\fi}
defineMacro("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`\xa9}");
defineMacro("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
defineMacro("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`\xae}"); // Characters omitted from Unicode range 1D400–1D7FF
defineMacro("\u212C", "\\mathscr{B}"); // script
defineMacro("\u2130", "\\mathscr{E}");
defineMacro("\u2131", "\\mathscr{F}");
defineMacro("\u210B", "\\mathscr{H}");
defineMacro("\u2110", "\\mathscr{I}");
defineMacro("\u2112", "\\mathscr{L}");
defineMacro("\u2133", "\\mathscr{M}");
defineMacro("\u211B", "\\mathscr{R}");
defineMacro("\u212D", "\\mathfrak{C}"); // Fraktur
defineMacro("\u210C", "\\mathfrak{H}");
defineMacro("\u2128", "\\mathfrak{Z}"); // Define \Bbbk with a macro that works in both HTML and MathML.
defineMacro("\\Bbbk", "\\Bbb{k}"); // Unicode middle dot
// The KaTeX fonts do not contain U+00B7. Instead, \cdotp displays
// the dot at U+22C5 and gives it punct spacing.
defineMacro("\u00b7", "\\cdotp"); // \llap and \rlap render their contents in text mode
defineMacro("\\llap", "\\mathllap{\\textrm{#1}}");
defineMacro("\\rlap", "\\mathrlap{\\textrm{#1}}");
defineMacro("\\clap", "\\mathclap{\\textrm{#1}}"); // \mathstrut from the TeXbook, p 360
defineMacro("\\mathstrut", "\\vphantom{(}"); // \underbar from TeXbook p 353
defineMacro("\\underbar", "\\underline{\\text{#1}}"); // \not is defined by base/fontmath.ltx via
// \DeclareMathSymbol{\not}{\mathrel}{symbols}{"36}
// It's thus treated like a \mathrel, but defined by a symbol that has zero
// width but extends to the right.  We use \rlap to get that spacing.
// For MathML we write U+0338 here. buildMathML.js will then do the overlay.
defineMacro("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}'); // Negated symbols from base/fontmath.ltx:
// \def\neq{\not=} \let\ne=\neq
// \DeclareRobustCommand
//   \notin{\mathrel{\m@th\mathpalette\c@ncel\in}}
// \def\c@ncel#1#2{\m@th\ooalign{$\hfil#1\mkern1mu/\hfil$\crcr$#1#2$}}
defineMacro("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`\u2260}}");
defineMacro("\\ne", "\\neq");
defineMacro("\u2260", "\\neq");
defineMacro("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`\u2209}}");
defineMacro("\u2209", "\\notin"); // Unicode stacked relations
defineMacro("\u2258", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`\u2258}}");
defineMacro("\u2259", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`\u2258}}");
defineMacro("\u225A", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`\u225A}}");
defineMacro("\u225B", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`\u225B}}");
defineMacro("\u225D", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`\u225D}}");
defineMacro("\u225E", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`\u225E}}");
defineMacro("\u225F", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`\u225F}}"); // Misc Unicode
defineMacro("\u27C2", "\\perp");
defineMacro("\u203C", "\\mathclose{!\\mkern-0.8mu!}");
defineMacro("\u220C", "\\notni");
defineMacro("\u231C", "\\ulcorner");
defineMacro("\u231D", "\\urcorner");
defineMacro("\u231E", "\\llcorner");
defineMacro("\u231F", "\\lrcorner");
defineMacro("\u00A9", "\\copyright");
defineMacro("\u00AE", "\\textregistered");
defineMacro("\uFE0F", "\\textregistered"); // The KaTeX fonts have corners at codepoints that don't match Unicode.
// For MathML purposes, use the Unicode code point.
defineMacro("\\ulcorner", "\\html@mathml{\\@ulcorner}{\\mathop{\\char\"231c}}");
defineMacro("\\urcorner", "\\html@mathml{\\@urcorner}{\\mathop{\\char\"231d}}");
defineMacro("\\llcorner", "\\html@mathml{\\@llcorner}{\\mathop{\\char\"231e}}");
defineMacro("\\lrcorner", "\\html@mathml{\\@lrcorner}{\\mathop{\\char\"231f}}"); //////////////////////////////////////////////////////////////////////
// LaTeX_2ε
// \vdots{\vbox{\baselineskip4\p@  \lineskiplimit\z@
// \kern6\p@\hbox{.}\hbox{.}\hbox{.}}}
// We'll call \varvdots, which gets a glyph from symbols.js.
// The zero-width rule gets us an equivalent to the vertical 6pt kern.
defineMacro("\\vdots", "{\\varvdots\\rule{0pt}{15pt}}");
defineMacro("\u22ee", "\\vdots"); //////////////////////////////////////////////////////////////////////
// amsmath.sty
// http://mirrors.concertpass.com/tex-archive/macros/latex/required/amsmath/amsmath.pdf
// Italic Greek capital letters.  AMS defines these with \DeclareMathSymbol,
// but they are equivalent to \mathit{\Letter}.
defineMacro("\\varGamma", "\\mathit{\\Gamma}");
defineMacro("\\varDelta", "\\mathit{\\Delta}");
defineMacro("\\varTheta", "\\mathit{\\Theta}");
defineMacro("\\varLambda", "\\mathit{\\Lambda}");
defineMacro("\\varXi", "\\mathit{\\Xi}");
defineMacro("\\varPi", "\\mathit{\\Pi}");
defineMacro("\\varSigma", "\\mathit{\\Sigma}");
defineMacro("\\varUpsilon", "\\mathit{\\Upsilon}");
defineMacro("\\varPhi", "\\mathit{\\Phi}");
defineMacro("\\varPsi", "\\mathit{\\Psi}");
defineMacro("\\varOmega", "\\mathit{\\Omega}"); //\newcommand{\substack}[1]{\subarray{c}#1\endsubarray}
defineMacro("\\substack", "\\begin{subarray}{c}#1\\end{subarray}"); // \renewcommand{\colon}{\nobreak\mskip2mu\mathpunct{}\nonscript
// \mkern-\thinmuskip{:}\mskip6muplus1mu\relax}
defineMacro("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax"); // \newcommand{\boxed}[1]{\fbox{\m@th$\displaystyle#1$}}
defineMacro("\\boxed", "\\fbox{$\\displaystyle{#1}$}"); // \def\iff{\DOTSB\;\Longleftrightarrow\;}
// \def\implies{\DOTSB\;\Longrightarrow\;}
// \def\impliedby{\DOTSB\;\Longleftarrow\;}
defineMacro("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
defineMacro("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
defineMacro("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;"); // \def\dddot#1{{\mathop{#1}\limits^{\vbox to-1.4\ex@{\kern-\tw@\ex@
//  \hbox{\normalfont ...}\vss}}}}
// We use \overset which avoids the vertical shift of \mathop.
defineMacro("\\dddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}");
defineMacro("\\ddddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}"); // AMSMath's automatic \dots, based on \mdots@@ macro.
var dotsByToken = {
    ',': '\\dotsc',
    '\\not': '\\dotsb',
    // \keybin@ checks for the following:
    '+': '\\dotsb',
    '=': '\\dotsb',
    '<': '\\dotsb',
    '>': '\\dotsb',
    '-': '\\dotsb',
    '*': '\\dotsb',
    ':': '\\dotsb',
    // Symbols whose definition starts with \DOTSB:
    '\\DOTSB': '\\dotsb',
    '\\coprod': '\\dotsb',
    '\\bigvee': '\\dotsb',
    '\\bigwedge': '\\dotsb',
    '\\biguplus': '\\dotsb',
    '\\bigcap': '\\dotsb',
    '\\bigcup': '\\dotsb',
    '\\prod': '\\dotsb',
    '\\sum': '\\dotsb',
    '\\bigotimes': '\\dotsb',
    '\\bigoplus': '\\dotsb',
    '\\bigodot': '\\dotsb',
    '\\bigsqcup': '\\dotsb',
    '\\And': '\\dotsb',
    '\\longrightarrow': '\\dotsb',
    '\\Longrightarrow': '\\dotsb',
    '\\longleftarrow': '\\dotsb',
    '\\Longleftarrow': '\\dotsb',
    '\\longleftrightarrow': '\\dotsb',
    '\\Longleftrightarrow': '\\dotsb',
    '\\mapsto': '\\dotsb',
    '\\longmapsto': '\\dotsb',
    '\\hookrightarrow': '\\dotsb',
    '\\doteq': '\\dotsb',
    // Symbols whose definition starts with \mathbin:
    '\\mathbin': '\\dotsb',
    // Symbols whose definition starts with \mathrel:
    '\\mathrel': '\\dotsb',
    '\\relbar': '\\dotsb',
    '\\Relbar': '\\dotsb',
    '\\xrightarrow': '\\dotsb',
    '\\xleftarrow': '\\dotsb',
    // Symbols whose definition starts with \DOTSI:
    '\\DOTSI': '\\dotsi',
    '\\int': '\\dotsi',
    '\\oint': '\\dotsi',
    '\\iint': '\\dotsi',
    '\\iiint': '\\dotsi',
    '\\iiiint': '\\dotsi',
    '\\idotsint': '\\dotsi',
    // Symbols whose definition starts with \DOTSX:
    '\\DOTSX': '\\dotsx'
};
defineMacro("\\dots", function(context) {
    // TODO: If used in text mode, should expand to \textellipsis.
    // However, in KaTeX, \textellipsis and \ldots behave the same
    // (in text mode), and it's unlikely we'd see any of the math commands
    // that affect the behavior of \dots when in text mode.  So fine for now
    // (until we support \ifmmode ... \else ... \fi).
    var thedots = '\\dotso';
    var next = context.expandAfterFuture().text;
    if (next in dotsByToken) thedots = dotsByToken[next];
    else if (next.slice(0, 4) === '\\not') thedots = '\\dotsb';
    else if (next in symbols.math) {
        if ([
            'bin',
            'rel'
        ].includes(symbols.math[next].group)) thedots = '\\dotsb';
    }
    return thedots;
});
var spaceAfterDots = {
    // \rightdelim@ checks for the following:
    ')': true,
    ']': true,
    '\\rbrack': true,
    '\\}': true,
    '\\rbrace': true,
    '\\rangle': true,
    '\\rceil': true,
    '\\rfloor': true,
    '\\rgroup': true,
    '\\rmoustache': true,
    '\\right': true,
    '\\bigr': true,
    '\\biggr': true,
    '\\Bigr': true,
    '\\Biggr': true,
    // \extra@ also tests for the following:
    '$': true,
    // \extrap@ checks for the following:
    ';': true,
    '.': true,
    ',': true
};
defineMacro("\\dotso", function(context) {
    var next = context.future().text;
    if (next in spaceAfterDots) return "\\ldots\\,";
    else return "\\ldots";
});
defineMacro("\\dotsc", function(context) {
    var next = context.future().text; // \dotsc uses \extra@ but not \extrap@, instead specially checking for
    // ';' and '.', but doesn't check for ','.
    if (next in spaceAfterDots && next !== ',') return "\\ldots\\,";
    else return "\\ldots";
});
defineMacro("\\cdots", function(context) {
    var next = context.future().text;
    if (next in spaceAfterDots) return "\\@cdots\\,";
    else return "\\@cdots";
});
defineMacro("\\dotsb", "\\cdots");
defineMacro("\\dotsm", "\\cdots");
defineMacro("\\dotsi", "\\!\\cdots"); // amsmath doesn't actually define \dotsx, but \dots followed by a macro
// starting with \DOTSX implies \dotso, and then \extra@ detects this case
// and forces the added `\,`.
defineMacro("\\dotsx", "\\ldots\\,"); // \let\DOTSI\relax
// \let\DOTSB\relax
// \let\DOTSX\relax
defineMacro("\\DOTSI", "\\relax");
defineMacro("\\DOTSB", "\\relax");
defineMacro("\\DOTSX", "\\relax"); // Spacing, based on amsmath.sty's override of LaTeX defaults
// \DeclareRobustCommand{\tmspace}[3]{%
//   \ifmmode\mskip#1#2\else\kern#1#3\fi\relax}
defineMacro("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax"); // \renewcommand{\,}{\tmspace+\thinmuskip{.1667em}}
// TODO: math mode should use \thinmuskip
defineMacro("\\,", "\\tmspace+{3mu}{.1667em}"); // \let\thinspace\,
defineMacro("\\thinspace", "\\,"); // \def\>{\mskip\medmuskip}
// \renewcommand{\:}{\tmspace+\medmuskip{.2222em}}
// TODO: \> and math mode of \: should use \medmuskip = 4mu plus 2mu minus 4mu
defineMacro("\\>", "\\mskip{4mu}");
defineMacro("\\:", "\\tmspace+{4mu}{.2222em}"); // \let\medspace\:
defineMacro("\\medspace", "\\:"); // \renewcommand{\;}{\tmspace+\thickmuskip{.2777em}}
// TODO: math mode should use \thickmuskip = 5mu plus 5mu
defineMacro("\\;", "\\tmspace+{5mu}{.2777em}"); // \let\thickspace\;
defineMacro("\\thickspace", "\\;"); // \renewcommand{\!}{\tmspace-\thinmuskip{.1667em}}
// TODO: math mode should use \thinmuskip
defineMacro("\\!", "\\tmspace-{3mu}{.1667em}"); // \let\negthinspace\!
defineMacro("\\negthinspace", "\\!"); // \newcommand{\negmedspace}{\tmspace-\medmuskip{.2222em}}
// TODO: math mode should use \medmuskip
defineMacro("\\negmedspace", "\\tmspace-{4mu}{.2222em}"); // \newcommand{\negthickspace}{\tmspace-\thickmuskip{.2777em}}
// TODO: math mode should use \thickmuskip
defineMacro("\\negthickspace", "\\tmspace-{5mu}{.277em}"); // \def\enspace{\kern.5em }
defineMacro("\\enspace", "\\kern.5em "); // \def\enskip{\hskip.5em\relax}
defineMacro("\\enskip", "\\hskip.5em\\relax"); // \def\quad{\hskip1em\relax}
defineMacro("\\quad", "\\hskip1em\\relax"); // \def\qquad{\hskip2em\relax}
defineMacro("\\qquad", "\\hskip2em\\relax"); // \tag@in@display form of \tag
defineMacro("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
defineMacro("\\tag@paren", "\\tag@literal{({#1})}");
defineMacro("\\tag@literal", (context)=>{
    if (context.macros.get("\\df@tag")) throw new ParseError("Multiple \\tag");
    return "\\gdef\\df@tag{\\text{#1}}";
}); // \renewcommand{\bmod}{\nonscript\mskip-\medmuskip\mkern5mu\mathbin
//   {\operator@font mod}\penalty900
//   \mkern5mu\nonscript\mskip-\medmuskip}
// \newcommand{\pod}[1]{\allowbreak
//   \if@display\mkern18mu\else\mkern8mu\fi(#1)}
// \renewcommand{\pmod}[1]{\pod{{\operator@font mod}\mkern6mu#1}}
// \newcommand{\mod}[1]{\allowbreak\if@display\mkern18mu
//   \else\mkern12mu\fi{\operator@font mod}\,\,#1}
// TODO: math mode should use \medmuskip = 4mu plus 2mu minus 4mu
defineMacro("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
defineMacro("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
defineMacro("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
defineMacro("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1"); //////////////////////////////////////////////////////////////////////
// LaTeX source2e
// \expandafter\let\expandafter\@normalcr
//     \csname\expandafter\@gobble\string\\ \endcsname
// \DeclareRobustCommand\newline{\@normalcr\relax}
defineMacro("\\newline", "\\\\\\relax"); // \def\TeX{T\kern-.1667em\lower.5ex\hbox{E}\kern-.125emX\@}
// TODO: Doesn't normally work in math mode because \@ fails.  KaTeX doesn't
// support \@ yet, so that's omitted, and we add \text so that the result
// doesn't look funny in math mode.
defineMacro("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}"); // \DeclareRobustCommand{\LaTeX}{L\kern-.36em%
//         {\sbox\z@ T%
//          \vbox to\ht\z@{\hbox{\check@mathfonts
//                               \fontsize\sf@size\z@
//                               \math@fontsfalse\selectfont
//                               A}%
//                         \vss}%
//         }%
//         \kern-.15em%
//         \TeX}
// This code aligns the top of the A with the T (from the perspective of TeX's
// boxes, though visually the A appears to extend above slightly).
// We compute the corresponding \raisebox when A is rendered in \normalsize
// \scriptstyle, which has a scale factor of 0.7 (see Options.js).
var latexRaiseA = makeEm(fontMetricsData['Main-Regular']["T".charCodeAt(0)][1] - 0.7 * fontMetricsData['Main-Regular']["A".charCodeAt(0)][1]);
defineMacro("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}"); // New KaTeX logo based on tweaking LaTeX logo
defineMacro("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + latexRaiseA + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}"); // \DeclareRobustCommand\hspace{\@ifstar\@hspacer\@hspace}
// \def\@hspace#1{\hskip  #1\relax}
// \def\@hspacer#1{\vrule \@width\z@\nobreak
//                 \hskip #1\hskip \z@skip}
defineMacro("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
defineMacro("\\@hspace", "\\hskip #1\\relax");
defineMacro("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax"); //////////////////////////////////////////////////////////////////////
// mathtools.sty
//\providecommand\ordinarycolon{:}
defineMacro("\\ordinarycolon", ":"); //\def\vcentcolon{\mathrel{\mathop\ordinarycolon}}
//TODO(edemaine): Not yet centered. Fix via \raisebox or #726
defineMacro("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}"); // \providecommand*\dblcolon{\vcentcolon\mathrel{\mkern-.9mu}\vcentcolon}
defineMacro("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}'); // \providecommand*\coloneqq{\vcentcolon\mathrel{\mkern-1.2mu}=}
defineMacro("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}'); // ≔
// \providecommand*\Coloneqq{\dblcolon\mathrel{\mkern-1.2mu}=}
defineMacro("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}'); // \providecommand*\coloneq{\vcentcolon\mathrel{\mkern-1.2mu}\mathrel{-}}
defineMacro("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}'); // \providecommand*\Coloneq{\dblcolon\mathrel{\mkern-1.2mu}\mathrel{-}}
defineMacro("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}'); // \providecommand*\eqqcolon{=\mathrel{\mkern-1.2mu}\vcentcolon}
defineMacro("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}'); // ≕
// \providecommand*\Eqqcolon{=\mathrel{\mkern-1.2mu}\dblcolon}
defineMacro("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}'); // \providecommand*\eqcolon{\mathrel{-}\mathrel{\mkern-1.2mu}\vcentcolon}
defineMacro("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}'); // \providecommand*\Eqcolon{\mathrel{-}\mathrel{\mkern-1.2mu}\dblcolon}
defineMacro("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}'); // \providecommand*\colonapprox{\vcentcolon\mathrel{\mkern-1.2mu}\approx}
defineMacro("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}'); // \providecommand*\Colonapprox{\dblcolon\mathrel{\mkern-1.2mu}\approx}
defineMacro("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}'); // \providecommand*\colonsim{\vcentcolon\mathrel{\mkern-1.2mu}\sim}
defineMacro("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}'); // \providecommand*\Colonsim{\dblcolon\mathrel{\mkern-1.2mu}\sim}
defineMacro("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}'); // Some Unicode characters are implemented with macros to mathtools functions.
defineMacro("\u2237", "\\dblcolon"); // ::
defineMacro("\u2239", "\\eqcolon"); // -:
defineMacro("\u2254", "\\coloneqq"); // :=
defineMacro("\u2255", "\\eqqcolon"); // =:
defineMacro("\u2A74", "\\Coloneqq"); // ::=
//////////////////////////////////////////////////////////////////////
// colonequals.sty
// Alternate names for mathtools's macros:
defineMacro("\\ratio", "\\vcentcolon");
defineMacro("\\coloncolon", "\\dblcolon");
defineMacro("\\colonequals", "\\coloneqq");
defineMacro("\\coloncolonequals", "\\Coloneqq");
defineMacro("\\equalscolon", "\\eqqcolon");
defineMacro("\\equalscoloncolon", "\\Eqqcolon");
defineMacro("\\colonminus", "\\coloneq");
defineMacro("\\coloncolonminus", "\\Coloneq");
defineMacro("\\minuscolon", "\\eqcolon");
defineMacro("\\minuscoloncolon", "\\Eqcolon"); // \colonapprox name is same in mathtools and colonequals.
defineMacro("\\coloncolonapprox", "\\Colonapprox"); // \colonsim name is same in mathtools and colonequals.
defineMacro("\\coloncolonsim", "\\Colonsim"); // Additional macros, implemented by analogy with mathtools definitions:
defineMacro("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
defineMacro("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
defineMacro("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
defineMacro("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}"); // Present in newtxmath, pxfonts and txfonts
defineMacro("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`\u220C}}");
defineMacro("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
defineMacro("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}"); //////////////////////////////////////////////////////////////////////
// From amsopn.sty
defineMacro("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
defineMacro("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
defineMacro("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
defineMacro("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
defineMacro("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
defineMacro("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}"); //////////////////////////////////////////////////////////////////////
// MathML alternates for KaTeX glyphs in the Unicode private area
defineMacro("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{\u2269}");
defineMacro("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{\u2268}");
defineMacro("\\ngeqq", "\\html@mathml{\\@ngeqq}{\u2271}");
defineMacro("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{\u2271}");
defineMacro("\\nleqq", "\\html@mathml{\\@nleqq}{\u2270}");
defineMacro("\\nleqslant", "\\html@mathml{\\@nleqslant}{\u2270}");
defineMacro("\\nshortmid", "\\html@mathml{\\@nshortmid}{\u2224}");
defineMacro("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{\u2226}");
defineMacro("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{\u2288}");
defineMacro("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{\u2289}");
defineMacro("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{\u228A}");
defineMacro("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{\u2ACB}");
defineMacro("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{\u228B}");
defineMacro("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{\u2ACC}");
defineMacro("\\imath", "\\html@mathml{\\@imath}{\u0131}");
defineMacro("\\jmath", "\\html@mathml{\\@jmath}{\u0237}"); //////////////////////////////////////////////////////////////////////
// stmaryrd and semantic
// The stmaryrd and semantic packages render the next four items by calling a
// glyph. Those glyphs do not exist in the KaTeX fonts. Hence the macros.
defineMacro("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`\u27E6}}");
defineMacro("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`\u27E7}}");
defineMacro("\u27e6", "\\llbracket"); // blackboard bold [
defineMacro("\u27e7", "\\rrbracket"); // blackboard bold ]
defineMacro("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`\u2983}}");
defineMacro("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`\u2984}}");
defineMacro("\u2983", "\\lBrace"); // blackboard bold {
defineMacro("\u2984", "\\rBrace"); // blackboard bold }
// TODO: Create variable sized versions of the last two items. I believe that
// will require new font glyphs.
// The stmaryrd function `\minuso` provides a "Plimsoll" symbol that
// superimposes the characters \circ and \mathminus. Used in chemistry.
defineMacro("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`\u29B5}}");
defineMacro("\u29B5", "\\minuso"); //////////////////////////////////////////////////////////////////////
// texvc.sty
// The texvc package contains macros available in mediawiki pages.
// We omit the functions deprecated at
// https://en.wikipedia.org/wiki/Help:Displaying_a_formula#Deprecated_syntax
// We also omit texvc's \O, which conflicts with \text{\O}
defineMacro("\\darr", "\\downarrow");
defineMacro("\\dArr", "\\Downarrow");
defineMacro("\\Darr", "\\Downarrow");
defineMacro("\\lang", "\\langle");
defineMacro("\\rang", "\\rangle");
defineMacro("\\uarr", "\\uparrow");
defineMacro("\\uArr", "\\Uparrow");
defineMacro("\\Uarr", "\\Uparrow");
defineMacro("\\N", "\\mathbb{N}");
defineMacro("\\R", "\\mathbb{R}");
defineMacro("\\Z", "\\mathbb{Z}");
defineMacro("\\alef", "\\aleph");
defineMacro("\\alefsym", "\\aleph");
defineMacro("\\Alpha", "\\mathrm{A}");
defineMacro("\\Beta", "\\mathrm{B}");
defineMacro("\\bull", "\\bullet");
defineMacro("\\Chi", "\\mathrm{X}");
defineMacro("\\clubs", "\\clubsuit");
defineMacro("\\cnums", "\\mathbb{C}");
defineMacro("\\Complex", "\\mathbb{C}");
defineMacro("\\Dagger", "\\ddagger");
defineMacro("\\diamonds", "\\diamondsuit");
defineMacro("\\empty", "\\emptyset");
defineMacro("\\Epsilon", "\\mathrm{E}");
defineMacro("\\Eta", "\\mathrm{H}");
defineMacro("\\exist", "\\exists");
defineMacro("\\harr", "\\leftrightarrow");
defineMacro("\\hArr", "\\Leftrightarrow");
defineMacro("\\Harr", "\\Leftrightarrow");
defineMacro("\\hearts", "\\heartsuit");
defineMacro("\\image", "\\Im");
defineMacro("\\infin", "\\infty");
defineMacro("\\Iota", "\\mathrm{I}");
defineMacro("\\isin", "\\in");
defineMacro("\\Kappa", "\\mathrm{K}");
defineMacro("\\larr", "\\leftarrow");
defineMacro("\\lArr", "\\Leftarrow");
defineMacro("\\Larr", "\\Leftarrow");
defineMacro("\\lrarr", "\\leftrightarrow");
defineMacro("\\lrArr", "\\Leftrightarrow");
defineMacro("\\Lrarr", "\\Leftrightarrow");
defineMacro("\\Mu", "\\mathrm{M}");
defineMacro("\\natnums", "\\mathbb{N}");
defineMacro("\\Nu", "\\mathrm{N}");
defineMacro("\\Omicron", "\\mathrm{O}");
defineMacro("\\plusmn", "\\pm");
defineMacro("\\rarr", "\\rightarrow");
defineMacro("\\rArr", "\\Rightarrow");
defineMacro("\\Rarr", "\\Rightarrow");
defineMacro("\\real", "\\Re");
defineMacro("\\reals", "\\mathbb{R}");
defineMacro("\\Reals", "\\mathbb{R}");
defineMacro("\\Rho", "\\mathrm{P}");
defineMacro("\\sdot", "\\cdot");
defineMacro("\\sect", "\\S");
defineMacro("\\spades", "\\spadesuit");
defineMacro("\\sub", "\\subset");
defineMacro("\\sube", "\\subseteq");
defineMacro("\\supe", "\\supseteq");
defineMacro("\\Tau", "\\mathrm{T}");
defineMacro("\\thetasym", "\\vartheta"); // TODO: defineMacro("\\varcoppa", "\\\mbox{\\coppa}");
defineMacro("\\weierp", "\\wp");
defineMacro("\\Zeta", "\\mathrm{Z}"); //////////////////////////////////////////////////////////////////////
// statmath.sty
// https://ctan.math.illinois.edu/macros/latex/contrib/statmath/statmath.pdf
defineMacro("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
defineMacro("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
defineMacro("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits"); //////////////////////////////////////////////////////////////////////
// braket.sty
// http://ctan.math.washington.edu/tex-archive/macros/latex/contrib/braket/braket.pdf
defineMacro("\\bra", "\\mathinner{\\langle{#1}|}");
defineMacro("\\ket", "\\mathinner{|{#1}\\rangle}");
defineMacro("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
defineMacro("\\Bra", "\\left\\langle#1\\right|");
defineMacro("\\Ket", "\\left|#1\\right\\rangle");
var braketHelper = (one)=>(context)=>{
        var left = context.consumeArg().tokens;
        var middle = context.consumeArg().tokens;
        var middleDouble = context.consumeArg().tokens;
        var right = context.consumeArg().tokens;
        var oldMiddle = context.macros.get("|");
        var oldMiddleDouble = context.macros.get("\\|");
        context.macros.beginGroup();
        var midMacro = (double)=>(context)=>{
                if (one) {
                    // Only modify the first instance of | or \|
                    context.macros.set("|", oldMiddle);
                    if (middleDouble.length) context.macros.set("\\|", oldMiddleDouble);
                }
                var doubled = double;
                if (!double && middleDouble.length) {
                    // Mimic \@ifnextchar
                    var nextToken = context.future();
                    if (nextToken.text === "|") {
                        context.popToken();
                        doubled = true;
                    }
                }
                return {
                    tokens: doubled ? middleDouble : middle,
                    numArgs: 0
                };
            };
        context.macros.set("|", midMacro(false));
        if (middleDouble.length) context.macros.set("\\|", midMacro(true));
        var arg = context.consumeArg().tokens;
        var expanded = context.expandTokens([
            ...right,
            ...arg,
            ...left // reversed
        ]);
        context.macros.endGroup();
        return {
            tokens: expanded.reverse(),
            numArgs: 0
        };
    };
defineMacro("\\bra@ket", braketHelper(false));
defineMacro("\\bra@set", braketHelper(true));
defineMacro("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
defineMacro("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
defineMacro("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}"); // has no support for special || or \|
//////////////////////////////////////////////////////////////////////
// actuarialangle.dtx
defineMacro("\\angln", "{\\angl n}"); // Custom Khan Academy colors, should be moved to an optional package
defineMacro("\\blue", "\\textcolor{##6495ed}{#1}");
defineMacro("\\orange", "\\textcolor{##ffa500}{#1}");
defineMacro("\\pink", "\\textcolor{##ff00af}{#1}");
defineMacro("\\red", "\\textcolor{##df0030}{#1}");
defineMacro("\\green", "\\textcolor{##28ae7b}{#1}");
defineMacro("\\gray", "\\textcolor{gray}{#1}");
defineMacro("\\purple", "\\textcolor{##9d38bd}{#1}");
defineMacro("\\blueA", "\\textcolor{##ccfaff}{#1}");
defineMacro("\\blueB", "\\textcolor{##80f6ff}{#1}");
defineMacro("\\blueC", "\\textcolor{##63d9ea}{#1}");
defineMacro("\\blueD", "\\textcolor{##11accd}{#1}");
defineMacro("\\blueE", "\\textcolor{##0c7f99}{#1}");
defineMacro("\\tealA", "\\textcolor{##94fff5}{#1}");
defineMacro("\\tealB", "\\textcolor{##26edd5}{#1}");
defineMacro("\\tealC", "\\textcolor{##01d1c1}{#1}");
defineMacro("\\tealD", "\\textcolor{##01a995}{#1}");
defineMacro("\\tealE", "\\textcolor{##208170}{#1}");
defineMacro("\\greenA", "\\textcolor{##b6ffb0}{#1}");
defineMacro("\\greenB", "\\textcolor{##8af281}{#1}");
defineMacro("\\greenC", "\\textcolor{##74cf70}{#1}");
defineMacro("\\greenD", "\\textcolor{##1fab54}{#1}");
defineMacro("\\greenE", "\\textcolor{##0d923f}{#1}");
defineMacro("\\goldA", "\\textcolor{##ffd0a9}{#1}");
defineMacro("\\goldB", "\\textcolor{##ffbb71}{#1}");
defineMacro("\\goldC", "\\textcolor{##ff9c39}{#1}");
defineMacro("\\goldD", "\\textcolor{##e07d10}{#1}");
defineMacro("\\goldE", "\\textcolor{##a75a05}{#1}");
defineMacro("\\redA", "\\textcolor{##fca9a9}{#1}");
defineMacro("\\redB", "\\textcolor{##ff8482}{#1}");
defineMacro("\\redC", "\\textcolor{##f9685d}{#1}");
defineMacro("\\redD", "\\textcolor{##e84d39}{#1}");
defineMacro("\\redE", "\\textcolor{##bc2612}{#1}");
defineMacro("\\maroonA", "\\textcolor{##ffbde0}{#1}");
defineMacro("\\maroonB", "\\textcolor{##ff92c6}{#1}");
defineMacro("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
defineMacro("\\maroonD", "\\textcolor{##ca337c}{#1}");
defineMacro("\\maroonE", "\\textcolor{##9e034e}{#1}");
defineMacro("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
defineMacro("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
defineMacro("\\purpleC", "\\textcolor{##aa87ff}{#1}");
defineMacro("\\purpleD", "\\textcolor{##7854ab}{#1}");
defineMacro("\\purpleE", "\\textcolor{##543b78}{#1}");
defineMacro("\\mintA", "\\textcolor{##f5f9e8}{#1}");
defineMacro("\\mintB", "\\textcolor{##edf2df}{#1}");
defineMacro("\\mintC", "\\textcolor{##e0e5cc}{#1}");
defineMacro("\\grayA", "\\textcolor{##f6f7f7}{#1}");
defineMacro("\\grayB", "\\textcolor{##f0f1f2}{#1}");
defineMacro("\\grayC", "\\textcolor{##e3e5e6}{#1}");
defineMacro("\\grayD", "\\textcolor{##d6d8da}{#1}");
defineMacro("\\grayE", "\\textcolor{##babec2}{#1}");
defineMacro("\\grayF", "\\textcolor{##888d93}{#1}");
defineMacro("\\grayG", "\\textcolor{##626569}{#1}");
defineMacro("\\grayH", "\\textcolor{##3b3e40}{#1}");
defineMacro("\\grayI", "\\textcolor{##21242c}{#1}");
defineMacro("\\kaBlue", "\\textcolor{##314453}{#1}");
defineMacro("\\kaGreen", "\\textcolor{##71B307}{#1}");
/**
 * This file contains the “gullet” where macros are expanded
 * until only non-macro tokens remain.
 */ // List of commands that act like macros but aren't defined as a macro,
// function, or symbol.  Used in `isDefined`.
var implicitCommands = {
    "^": true,
    // Parser.js
    "_": true,
    // Parser.js
    "\\limits": true,
    // Parser.js
    "\\nolimits": true // Parser.js
};
class MacroExpander {
    constructor(input, settings, mode){
        this.settings = void 0;
        this.expansionCount = void 0;
        this.lexer = void 0;
        this.macros = void 0;
        this.stack = void 0;
        this.mode = void 0;
        this.settings = settings;
        this.expansionCount = 0;
        this.feed(input); // Make new global namespace
        this.macros = new Namespace(macros, settings.macros);
        this.mode = mode;
        this.stack = []; // contains tokens in REVERSE order
    }
    /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */ feed(input) {
        this.lexer = new Lexer(input, this.settings);
    }
    /**
   * Switches between "text" and "math" modes.
   */ switchMode(newMode) {
        this.mode = newMode;
    }
    /**
   * Start a new group nesting within all namespaces.
   */ beginGroup() {
        this.macros.beginGroup();
    }
    /**
   * End current group nesting within all namespaces.
   */ endGroup() {
        this.macros.endGroup();
    }
    /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */ endGroups() {
        this.macros.endGroups();
    }
    /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */ future() {
        if (this.stack.length === 0) this.pushToken(this.lexer.lex());
        return this.stack[this.stack.length - 1];
    }
    /**
   * Remove and return the next unexpanded token.
   */ popToken() {
        this.future(); // ensure non-empty stack
        return this.stack.pop();
    }
    /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */ pushToken(token) {
        this.stack.push(token);
    }
    /**
   * Append an array of tokens to the token stack.
   */ pushTokens(tokens) {
        this.stack.push(...tokens);
    }
    /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */ scanArgument(isOptional) {
        var start;
        var end;
        var tokens;
        if (isOptional) {
            this.consumeSpaces(); // \@ifnextchar gobbles any space following it
            if (this.future().text !== "[") return null;
            start = this.popToken(); // don't include [ in tokens
            ({ tokens, end } = this.consumeArg([
                "]"
            ]));
        } else ({ tokens, start, end } = this.consumeArg());
         // indicate the end of an argument
        this.pushToken(new Token("EOF", end.loc));
        this.pushTokens(tokens);
        return new Token("", SourceLocation.range(start, end));
    }
    /**
   * Consume all following space tokens, without expansion.
   */ consumeSpaces() {
        for(;;){
            var token = this.future();
            if (token.text === " ") this.stack.pop();
            else break;
        }
    }
    /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */ consumeArg(delims) {
        // The argument for a delimited parameter is the shortest (possibly
        // empty) sequence of tokens with properly nested {...} groups that is
        // followed ... by this particular list of non-parameter tokens.
        // The argument for an undelimited parameter is the next nonblank
        // token, unless that token is ‘{’, when the argument will be the
        // entire {...} group that follows.
        var tokens = [];
        var isDelimited = delims && delims.length > 0;
        if (!isDelimited) // Ignore spaces between arguments.  As the TeXbook says:
        // "After you have said ‘\def\row#1#2{...}’, you are allowed to
        //  put spaces between the arguments (e.g., ‘\row x n’), because
        //  TeX doesn’t use single spaces as undelimited arguments."
        this.consumeSpaces();
        var start = this.future();
        var tok;
        var depth = 0;
        var match = 0;
        do {
            tok = this.popToken();
            tokens.push(tok);
            if (tok.text === "{") ++depth;
            else if (tok.text === "}") {
                --depth;
                if (depth === -1) throw new ParseError("Extra }", tok);
            } else if (tok.text === "EOF") throw new ParseError("Unexpected end of input in a macro argument, expected '" + (delims && isDelimited ? delims[match] : "}") + "'", tok);
            if (delims && isDelimited) {
                if ((depth === 0 || depth === 1 && delims[match] === "{") && tok.text === delims[match]) {
                    ++match;
                    if (match === delims.length) {
                        // don't include delims in tokens
                        tokens.splice(-match, match);
                        break;
                    }
                } else match = 0;
            }
        }while (depth !== 0 || isDelimited); // If the argument found ... has the form ‘{<nested tokens>}’,
        // ... the outermost braces enclosing the argument are removed
        if (start.text === "{" && tokens[tokens.length - 1].text === "}") {
            tokens.pop();
            tokens.shift();
        }
        tokens.reverse(); // to fit in with stack order
        return {
            tokens,
            start,
            end: tok
        };
    }
    /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */ consumeArgs(numArgs, delimiters) {
        if (delimiters) {
            if (delimiters.length !== numArgs + 1) throw new ParseError("The length of delimiters doesn't match the number of args!");
            var delims = delimiters[0];
            for(var i = 0; i < delims.length; i++){
                var tok = this.popToken();
                if (delims[i] !== tok.text) throw new ParseError("Use of the macro doesn't match its definition", tok);
            }
        }
        var args = [];
        for(var _i = 0; _i < numArgs; _i++)args.push(this.consumeArg(delimiters && delimiters[_i + 1]).tokens);
        return args;
    }
    /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */ countExpansion(amount) {
        this.expansionCount += amount;
        if (this.expansionCount > this.settings.maxExpand) throw new ParseError("Too many expansions: infinite loop or need to increase maxExpand setting");
    }
    /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */ expandOnce(expandableOnly) {
        var topToken = this.popToken();
        var name = topToken.text;
        var expansion = !topToken.noexpand ? this._getExpansion(name) : null;
        if (expansion == null || expandableOnly && expansion.unexpandable) {
            if (expandableOnly && expansion == null && name[0] === "\\" && !this.isDefined(name)) throw new ParseError("Undefined control sequence: " + name);
            this.pushToken(topToken);
            return false;
        }
        this.countExpansion(1);
        var tokens = expansion.tokens;
        var args = this.consumeArgs(expansion.numArgs, expansion.delimiters);
        if (expansion.numArgs) {
            // paste arguments in place of the placeholders
            tokens = tokens.slice(); // make a shallow copy
            for(var i = tokens.length - 1; i >= 0; --i){
                var tok = tokens[i];
                if (tok.text === "#") {
                    if (i === 0) throw new ParseError("Incomplete placeholder at end of macro body", tok);
                    tok = tokens[--i]; // next token on stack
                    if (tok.text === "#") // ## → #
                    tokens.splice(i + 1, 1); // drop first #
                    else if (/^[1-9]$/.test(tok.text)) // replace the placeholder with the indicated argument
                    tokens.splice(i, 2, ...args[+tok.text - 1]);
                    else throw new ParseError("Not a valid argument number", tok);
                }
            }
        } // Concatenate expansion onto top of stack.
        this.pushTokens(tokens);
        return tokens.length;
    }
    /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */ expandAfterFuture() {
        this.expandOnce();
        return this.future();
    }
    /**
   * Recursively expand first token, then return first non-expandable token.
   */ expandNextToken() {
        for(;;)if (this.expandOnce() === false) {
            // fully expanded
            var token = this.stack.pop(); // the token after \noexpand is interpreted as if its meaning
            // were ‘\relax’
            if (token.treatAsRelax) token.text = "\\relax";
            return token;
        }
         // Flow unable to figure out that this pathway is impossible.
        // https://github.com/facebook/flow/issues/4808
        throw new Error(); // eslint-disable-line no-unreachable
    }
    /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */ expandMacro(name) {
        return this.macros.has(name) ? this.expandTokens([
            new Token(name)
        ]) : undefined;
    }
    /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */ expandTokens(tokens) {
        var output = [];
        var oldStackLength = this.stack.length;
        this.pushTokens(tokens);
        while(this.stack.length > oldStackLength)// Expand only expandable tokens
        if (this.expandOnce(true) === false) {
            // fully expanded
            var token = this.stack.pop();
            if (token.treatAsRelax) {
                // the expansion of \noexpand is the token itself
                token.noexpand = false;
                token.treatAsRelax = false;
            }
            output.push(token);
        }
         // Count all of these tokens as additional expansions, to prevent
        // exponential blowup from linearly many \edef's.
        this.countExpansion(output.length);
        return output;
    }
    /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */ expandMacroAsText(name) {
        var tokens = this.expandMacro(name);
        if (tokens) return tokens.map((token)=>token.text).join("");
        else return tokens;
    }
    /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */ _getExpansion(name) {
        var definition = this.macros.get(name);
        if (definition == null) // mainly checking for undefined here
        return definition;
         // If a single character has an associated catcode other than 13
        // (active character), then don't expand it.
        if (name.length === 1) {
            var catcode = this.lexer.catcodes[name];
            if (catcode != null && catcode !== 13) return;
        }
        var expansion = typeof definition === "function" ? definition(this) : definition;
        if (typeof expansion === "string") {
            var numArgs = 0;
            if (expansion.indexOf("#") !== -1) {
                var stripped = expansion.replace(/##/g, "");
                while(stripped.indexOf("#" + (numArgs + 1)) !== -1)++numArgs;
            }
            var bodyLexer = new Lexer(expansion, this.settings);
            var tokens = [];
            var tok = bodyLexer.lex();
            while(tok.text !== "EOF"){
                tokens.push(tok);
                tok = bodyLexer.lex();
            }
            tokens.reverse(); // to fit in with stack using push and pop
            var expanded = {
                tokens,
                numArgs
            };
            return expanded;
        }
        return expansion;
    }
    /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */ isDefined(name) {
        return this.macros.has(name) || functions.hasOwnProperty(name) || symbols.math.hasOwnProperty(name) || symbols.text.hasOwnProperty(name) || implicitCommands.hasOwnProperty(name);
    }
    /**
   * Determine whether a command is expandable.
   */ isExpandable(name) {
        var macro = this.macros.get(name);
        return macro != null ? typeof macro === "string" || typeof macro === "function" || !macro.unexpandable : functions.hasOwnProperty(name) && !functions[name].primitive;
    }
}
// Helpers for Parser.js handling of Unicode (sub|super)script characters.
var unicodeSubRegEx = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/;
var uSubsAndSups = Object.freeze({
    "\u208A": '+',
    "\u208B": '-',
    "\u208C": '=',
    "\u208D": '(',
    "\u208E": ')',
    "\u2080": '0',
    "\u2081": '1',
    "\u2082": '2',
    "\u2083": '3',
    "\u2084": '4',
    "\u2085": '5',
    "\u2086": '6',
    "\u2087": '7',
    "\u2088": '8',
    "\u2089": '9',
    '\u2090': 'a',
    '\u2091': 'e',
    '\u2095': 'h',
    '\u1D62': 'i',
    '\u2C7C': 'j',
    '\u2096': 'k',
    '\u2097': 'l',
    '\u2098': 'm',
    '\u2099': 'n',
    '\u2092': 'o',
    '\u209A': 'p',
    '\u1D63': 'r',
    '\u209B': 's',
    '\u209C': 't',
    '\u1D64': 'u',
    '\u1D65': 'v',
    '\u2093': 'x',
    '\u1D66': "\u03B2",
    '\u1D67': "\u03B3",
    '\u1D68': "\u03C1",
    '\u1D69': '\u03d5',
    '\u1D6A': "\u03C7",
    "\u207A": '+',
    "\u207B": '-',
    "\u207C": '=',
    "\u207D": '(',
    "\u207E": ')',
    "\u2070": '0',
    "\xb9": '1',
    "\xb2": '2',
    "\xb3": '3',
    "\u2074": '4',
    "\u2075": '5',
    "\u2076": '6',
    "\u2077": '7',
    "\u2078": '8',
    "\u2079": '9',
    '\u1D2C': 'A',
    '\u1D2E': 'B',
    '\u1D30': 'D',
    '\u1D31': 'E',
    '\u1D33': 'G',
    '\u1D34': 'H',
    '\u1D35': 'I',
    '\u1D36': 'J',
    '\u1D37': 'K',
    '\u1D38': 'L',
    '\u1D39': 'M',
    '\u1D3A': 'N',
    '\u1D3C': 'O',
    '\u1D3E': 'P',
    '\u1D3F': 'R',
    '\u1D40': 'T',
    '\u1D41': 'U',
    '\u2C7D': 'V',
    '\u1D42': 'W',
    '\u1D43': 'a',
    '\u1D47': 'b',
    '\u1D9C': 'c',
    '\u1D48': 'd',
    '\u1D49': 'e',
    '\u1DA0': 'f',
    '\u1D4D': 'g',
    '\u02B0': 'h',
    '\u2071': 'i',
    '\u02B2': 'j',
    '\u1D4F': 'k',
    '\u02E1': 'l',
    '\u1D50': 'm',
    '\u207F': 'n',
    '\u1D52': 'o',
    '\u1D56': 'p',
    '\u02B3': 'r',
    '\u02E2': 's',
    '\u1D57': 't',
    '\u1D58': 'u',
    '\u1D5B': 'v',
    '\u02B7': 'w',
    '\u02E3': 'x',
    '\u02B8': 'y',
    '\u1DBB': 'z',
    '\u1D5D': "\u03B2",
    '\u1D5E': "\u03B3",
    '\u1D5F': "\u03B4",
    '\u1D60': '\u03d5',
    '\u1D61': "\u03C7",
    '\u1DBF': "\u03B8"
});
/* eslint no-constant-condition:0 */ var unicodeAccents = {
    "\u0301": {
        "text": "\\'",
        "math": "\\acute"
    },
    "\u0300": {
        "text": "\\`",
        "math": "\\grave"
    },
    "\u0308": {
        "text": "\\\"",
        "math": "\\ddot"
    },
    "\u0303": {
        "text": "\\~",
        "math": "\\tilde"
    },
    "\u0304": {
        "text": "\\=",
        "math": "\\bar"
    },
    "\u0306": {
        "text": "\\u",
        "math": "\\breve"
    },
    "\u030C": {
        "text": "\\v",
        "math": "\\check"
    },
    "\u0302": {
        "text": "\\^",
        "math": "\\hat"
    },
    "\u0307": {
        "text": "\\.",
        "math": "\\dot"
    },
    "\u030A": {
        "text": "\\r",
        "math": "\\mathring"
    },
    "\u030B": {
        "text": "\\H"
    },
    "\u0327": {
        "text": "\\c"
    }
};
var unicodeSymbols = {
    "\xe1": "a\u0301",
    "\xe0": "a\u0300",
    "\xe4": "a\u0308",
    "\u01DF": "a\u0308\u0304",
    "\xe3": "a\u0303",
    "\u0101": "a\u0304",
    "\u0103": "a\u0306",
    "\u1EAF": "a\u0306\u0301",
    "\u1EB1": "a\u0306\u0300",
    "\u1EB5": "a\u0306\u0303",
    "\u01CE": "a\u030C",
    "\xe2": "a\u0302",
    "\u1EA5": "a\u0302\u0301",
    "\u1EA7": "a\u0302\u0300",
    "\u1EAB": "a\u0302\u0303",
    "\u0227": "a\u0307",
    "\u01E1": "a\u0307\u0304",
    "\xe5": "a\u030A",
    "\u01FB": "a\u030A\u0301",
    "\u1E03": "b\u0307",
    "\u0107": "c\u0301",
    "\u1E09": "c\u0327\u0301",
    "\u010D": "c\u030C",
    "\u0109": "c\u0302",
    "\u010B": "c\u0307",
    "\xe7": "c\u0327",
    "\u010F": "d\u030C",
    "\u1E0B": "d\u0307",
    "\u1E11": "d\u0327",
    "\xe9": "e\u0301",
    "\xe8": "e\u0300",
    "\xeb": "e\u0308",
    "\u1EBD": "e\u0303",
    "\u0113": "e\u0304",
    "\u1E17": "e\u0304\u0301",
    "\u1E15": "e\u0304\u0300",
    "\u0115": "e\u0306",
    "\u1E1D": "e\u0327\u0306",
    "\u011B": "e\u030C",
    "\xea": "e\u0302",
    "\u1EBF": "e\u0302\u0301",
    "\u1EC1": "e\u0302\u0300",
    "\u1EC5": "e\u0302\u0303",
    "\u0117": "e\u0307",
    "\u0229": "e\u0327",
    "\u1E1F": "f\u0307",
    "\u01F5": "g\u0301",
    "\u1E21": "g\u0304",
    "\u011F": "g\u0306",
    "\u01E7": "g\u030C",
    "\u011D": "g\u0302",
    "\u0121": "g\u0307",
    "\u0123": "g\u0327",
    "\u1E27": "h\u0308",
    "\u021F": "h\u030C",
    "\u0125": "h\u0302",
    "\u1E23": "h\u0307",
    "\u1E29": "h\u0327",
    "\xed": "i\u0301",
    "\xec": "i\u0300",
    "\xef": "i\u0308",
    "\u1E2F": "i\u0308\u0301",
    "\u0129": "i\u0303",
    "\u012B": "i\u0304",
    "\u012D": "i\u0306",
    "\u01D0": "i\u030C",
    "\xee": "i\u0302",
    "\u01F0": "j\u030C",
    "\u0135": "j\u0302",
    "\u1E31": "k\u0301",
    "\u01E9": "k\u030C",
    "\u0137": "k\u0327",
    "\u013A": "l\u0301",
    "\u013E": "l\u030C",
    "\u013C": "l\u0327",
    "\u1E3F": "m\u0301",
    "\u1E41": "m\u0307",
    "\u0144": "n\u0301",
    "\u01F9": "n\u0300",
    "\xf1": "n\u0303",
    "\u0148": "n\u030C",
    "\u1E45": "n\u0307",
    "\u0146": "n\u0327",
    "\xf3": "o\u0301",
    "\xf2": "o\u0300",
    "\xf6": "o\u0308",
    "\u022B": "o\u0308\u0304",
    "\xf5": "o\u0303",
    "\u1E4D": "o\u0303\u0301",
    "\u1E4F": "o\u0303\u0308",
    "\u022D": "o\u0303\u0304",
    "\u014D": "o\u0304",
    "\u1E53": "o\u0304\u0301",
    "\u1E51": "o\u0304\u0300",
    "\u014F": "o\u0306",
    "\u01D2": "o\u030C",
    "\xf4": "o\u0302",
    "\u1ED1": "o\u0302\u0301",
    "\u1ED3": "o\u0302\u0300",
    "\u1ED7": "o\u0302\u0303",
    "\u022F": "o\u0307",
    "\u0231": "o\u0307\u0304",
    "\u0151": "o\u030B",
    "\u1E55": "p\u0301",
    "\u1E57": "p\u0307",
    "\u0155": "r\u0301",
    "\u0159": "r\u030C",
    "\u1E59": "r\u0307",
    "\u0157": "r\u0327",
    "\u015B": "s\u0301",
    "\u1E65": "s\u0301\u0307",
    "\u0161": "s\u030C",
    "\u1E67": "s\u030C\u0307",
    "\u015D": "s\u0302",
    "\u1E61": "s\u0307",
    "\u015F": "s\u0327",
    "\u1E97": "t\u0308",
    "\u0165": "t\u030C",
    "\u1E6B": "t\u0307",
    "\u0163": "t\u0327",
    "\xfa": "u\u0301",
    "\xf9": "u\u0300",
    "\xfc": "u\u0308",
    "\u01D8": "u\u0308\u0301",
    "\u01DC": "u\u0308\u0300",
    "\u01D6": "u\u0308\u0304",
    "\u01DA": "u\u0308\u030C",
    "\u0169": "u\u0303",
    "\u1E79": "u\u0303\u0301",
    "\u016B": "u\u0304",
    "\u1E7B": "u\u0304\u0308",
    "\u016D": "u\u0306",
    "\u01D4": "u\u030C",
    "\xfb": "u\u0302",
    "\u016F": "u\u030A",
    "\u0171": "u\u030B",
    "\u1E7D": "v\u0303",
    "\u1E83": "w\u0301",
    "\u1E81": "w\u0300",
    "\u1E85": "w\u0308",
    "\u0175": "w\u0302",
    "\u1E87": "w\u0307",
    "\u1E98": "w\u030A",
    "\u1E8D": "x\u0308",
    "\u1E8B": "x\u0307",
    "\xfd": "y\u0301",
    "\u1EF3": "y\u0300",
    "\xff": "y\u0308",
    "\u1EF9": "y\u0303",
    "\u0233": "y\u0304",
    "\u0177": "y\u0302",
    "\u1E8F": "y\u0307",
    "\u1E99": "y\u030A",
    "\u017A": "z\u0301",
    "\u017E": "z\u030C",
    "\u1E91": "z\u0302",
    "\u017C": "z\u0307",
    "\xc1": "A\u0301",
    "\xc0": "A\u0300",
    "\xc4": "A\u0308",
    "\u01DE": "A\u0308\u0304",
    "\xc3": "A\u0303",
    "\u0100": "A\u0304",
    "\u0102": "A\u0306",
    "\u1EAE": "A\u0306\u0301",
    "\u1EB0": "A\u0306\u0300",
    "\u1EB4": "A\u0306\u0303",
    "\u01CD": "A\u030C",
    "\xc2": "A\u0302",
    "\u1EA4": "A\u0302\u0301",
    "\u1EA6": "A\u0302\u0300",
    "\u1EAA": "A\u0302\u0303",
    "\u0226": "A\u0307",
    "\u01E0": "A\u0307\u0304",
    "\xc5": "A\u030A",
    "\u01FA": "A\u030A\u0301",
    "\u1E02": "B\u0307",
    "\u0106": "C\u0301",
    "\u1E08": "C\u0327\u0301",
    "\u010C": "C\u030C",
    "\u0108": "C\u0302",
    "\u010A": "C\u0307",
    "\xc7": "C\u0327",
    "\u010E": "D\u030C",
    "\u1E0A": "D\u0307",
    "\u1E10": "D\u0327",
    "\xc9": "E\u0301",
    "\xc8": "E\u0300",
    "\xcb": "E\u0308",
    "\u1EBC": "E\u0303",
    "\u0112": "E\u0304",
    "\u1E16": "E\u0304\u0301",
    "\u1E14": "E\u0304\u0300",
    "\u0114": "E\u0306",
    "\u1E1C": "E\u0327\u0306",
    "\u011A": "E\u030C",
    "\xca": "E\u0302",
    "\u1EBE": "E\u0302\u0301",
    "\u1EC0": "E\u0302\u0300",
    "\u1EC4": "E\u0302\u0303",
    "\u0116": "E\u0307",
    "\u0228": "E\u0327",
    "\u1E1E": "F\u0307",
    "\u01F4": "G\u0301",
    "\u1E20": "G\u0304",
    "\u011E": "G\u0306",
    "\u01E6": "G\u030C",
    "\u011C": "G\u0302",
    "\u0120": "G\u0307",
    "\u0122": "G\u0327",
    "\u1E26": "H\u0308",
    "\u021E": "H\u030C",
    "\u0124": "H\u0302",
    "\u1E22": "H\u0307",
    "\u1E28": "H\u0327",
    "\xcd": "I\u0301",
    "\xcc": "I\u0300",
    "\xcf": "I\u0308",
    "\u1E2E": "I\u0308\u0301",
    "\u0128": "I\u0303",
    "\u012A": "I\u0304",
    "\u012C": "I\u0306",
    "\u01CF": "I\u030C",
    "\xce": "I\u0302",
    "\u0130": "I\u0307",
    "\u0134": "J\u0302",
    "\u1E30": "K\u0301",
    "\u01E8": "K\u030C",
    "\u0136": "K\u0327",
    "\u0139": "L\u0301",
    "\u013D": "L\u030C",
    "\u013B": "L\u0327",
    "\u1E3E": "M\u0301",
    "\u1E40": "M\u0307",
    "\u0143": "N\u0301",
    "\u01F8": "N\u0300",
    "\xd1": "N\u0303",
    "\u0147": "N\u030C",
    "\u1E44": "N\u0307",
    "\u0145": "N\u0327",
    "\xd3": "O\u0301",
    "\xd2": "O\u0300",
    "\xd6": "O\u0308",
    "\u022A": "O\u0308\u0304",
    "\xd5": "O\u0303",
    "\u1E4C": "O\u0303\u0301",
    "\u1E4E": "O\u0303\u0308",
    "\u022C": "O\u0303\u0304",
    "\u014C": "O\u0304",
    "\u1E52": "O\u0304\u0301",
    "\u1E50": "O\u0304\u0300",
    "\u014E": "O\u0306",
    "\u01D1": "O\u030C",
    "\xd4": "O\u0302",
    "\u1ED0": "O\u0302\u0301",
    "\u1ED2": "O\u0302\u0300",
    "\u1ED6": "O\u0302\u0303",
    "\u022E": "O\u0307",
    "\u0230": "O\u0307\u0304",
    "\u0150": "O\u030B",
    "\u1E54": "P\u0301",
    "\u1E56": "P\u0307",
    "\u0154": "R\u0301",
    "\u0158": "R\u030C",
    "\u1E58": "R\u0307",
    "\u0156": "R\u0327",
    "\u015A": "S\u0301",
    "\u1E64": "S\u0301\u0307",
    "\u0160": "S\u030C",
    "\u1E66": "S\u030C\u0307",
    "\u015C": "S\u0302",
    "\u1E60": "S\u0307",
    "\u015E": "S\u0327",
    "\u0164": "T\u030C",
    "\u1E6A": "T\u0307",
    "\u0162": "T\u0327",
    "\xda": "U\u0301",
    "\xd9": "U\u0300",
    "\xdc": "U\u0308",
    "\u01D7": "U\u0308\u0301",
    "\u01DB": "U\u0308\u0300",
    "\u01D5": "U\u0308\u0304",
    "\u01D9": "U\u0308\u030C",
    "\u0168": "U\u0303",
    "\u1E78": "U\u0303\u0301",
    "\u016A": "U\u0304",
    "\u1E7A": "U\u0304\u0308",
    "\u016C": "U\u0306",
    "\u01D3": "U\u030C",
    "\xdb": "U\u0302",
    "\u016E": "U\u030A",
    "\u0170": "U\u030B",
    "\u1E7C": "V\u0303",
    "\u1E82": "W\u0301",
    "\u1E80": "W\u0300",
    "\u1E84": "W\u0308",
    "\u0174": "W\u0302",
    "\u1E86": "W\u0307",
    "\u1E8C": "X\u0308",
    "\u1E8A": "X\u0307",
    "\xdd": "Y\u0301",
    "\u1EF2": "Y\u0300",
    "\u0178": "Y\u0308",
    "\u1EF8": "Y\u0303",
    "\u0232": "Y\u0304",
    "\u0176": "Y\u0302",
    "\u1E8E": "Y\u0307",
    "\u0179": "Z\u0301",
    "\u017D": "Z\u030C",
    "\u1E90": "Z\u0302",
    "\u017B": "Z\u0307",
    "\u03AC": "\u03B1\u0301",
    "\u1F70": "\u03B1\u0300",
    "\u1FB1": "\u03B1\u0304",
    "\u1FB0": "\u03B1\u0306",
    "\u03AD": "\u03B5\u0301",
    "\u1F72": "\u03B5\u0300",
    "\u03AE": "\u03B7\u0301",
    "\u1F74": "\u03B7\u0300",
    "\u03AF": "\u03B9\u0301",
    "\u1F76": "\u03B9\u0300",
    "\u03CA": "\u03B9\u0308",
    "\u0390": "\u03B9\u0308\u0301",
    "\u1FD2": "\u03B9\u0308\u0300",
    "\u1FD1": "\u03B9\u0304",
    "\u1FD0": "\u03B9\u0306",
    "\u03CC": "\u03BF\u0301",
    "\u1F78": "\u03BF\u0300",
    "\u03CD": "\u03C5\u0301",
    "\u1F7A": "\u03C5\u0300",
    "\u03CB": "\u03C5\u0308",
    "\u03B0": "\u03C5\u0308\u0301",
    "\u1FE2": "\u03C5\u0308\u0300",
    "\u1FE1": "\u03C5\u0304",
    "\u1FE0": "\u03C5\u0306",
    "\u03CE": "\u03C9\u0301",
    "\u1F7C": "\u03C9\u0300",
    "\u038E": "\u03A5\u0301",
    "\u1FEA": "\u03A5\u0300",
    "\u03AB": "\u03A5\u0308",
    "\u1FE9": "\u03A5\u0304",
    "\u1FE8": "\u03A5\u0306",
    "\u038F": "\u03A9\u0301",
    "\u1FFA": "\u03A9\u0300"
};
/**
 * This file contains the parser used to parse out a TeX expression from the
 * input. Since TeX isn't context-free, standard parsers don't work particularly
 * well.
 *
 * The strategy of this parser is as such:
 *
 * The main functions (the `.parse...` ones) take a position in the current
 * parse string to parse tokens from. The lexer (found in Lexer.js, stored at
 * this.gullet.lexer) also supports pulling out tokens at arbitrary places. When
 * individual tokens are needed at a position, the lexer is called to pull out a
 * token, which is then used.
 *
 * The parser has a property called "mode" indicating the mode that
 * the parser is currently in. Currently it has to be one of "math" or
 * "text", which denotes whether the current environment is a math-y
 * one or a text-y one (e.g. inside \text). Currently, this serves to
 * limit the functions which can be used in text mode.
 *
 * The main functions then return an object which contains the useful data that
 * was parsed at its given point, and a new position at the end of the parsed
 * data. The main functions can call each other and continue the parsing by
 * using the returned position as a new starting point.
 *
 * There are also extra `.handle...` functions, which pull out some reused
 * functionality into self-contained functions.
 *
 * The functions return ParseNodes.
 */ class Parser {
    constructor(input, settings){
        this.mode = void 0;
        this.gullet = void 0;
        this.settings = void 0;
        this.leftrightDepth = void 0;
        this.nextToken = void 0;
        // Start in math mode
        this.mode = "math"; // Create a new macro expander (gullet) and (indirectly via that) also a
        // new lexer (mouth) for this parser (stomach, in the language of TeX)
        this.gullet = new MacroExpander(input, settings, this.mode); // Store the settings for use in parsing
        this.settings = settings; // Count leftright depth (for \middle errors)
        this.leftrightDepth = 0;
    }
    /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */ expect(text, consume) {
        if (consume === void 0) consume = true;
        if (this.fetch().text !== text) throw new ParseError("Expected '" + text + "', got '" + this.fetch().text + "'", this.fetch());
        if (consume) this.consume();
    }
    /**
   * Discards the current lookahead token, considering it consumed.
   */ consume() {
        this.nextToken = null;
    }
    /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */ fetch() {
        if (this.nextToken == null) this.nextToken = this.gullet.expandNextToken();
        return this.nextToken;
    }
    /**
   * Switches between "text" and "math" modes.
   */ switchMode(newMode) {
        this.mode = newMode;
        this.gullet.switchMode(newMode);
    }
    /**
   * Main parsing function, which parses an entire input.
   */ parse() {
        if (!this.settings.globalGroup) // Create a group namespace for the math expression.
        // (LaTeX creates a new group for every $...$, $$...$$, \[...\].)
        this.gullet.beginGroup();
         // Use old \color behavior (same as LaTeX's \textcolor) if requested.
        // We do this within the group for the math expression, so it doesn't
        // pollute settings.macros.
        if (this.settings.colorIsTextColor) this.gullet.macros.set("\\color", "\\textcolor");
        try {
            // Try to parse the input
            var parse = this.parseExpression(false); // If we succeeded, make sure there's an EOF at the end
            this.expect("EOF"); // End the group namespace for the expression
            if (!this.settings.globalGroup) this.gullet.endGroup();
            return parse; // Close any leftover groups in case of a parse error.
        } finally{
            this.gullet.endGroups();
        }
    }
    /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */ subparse(tokens) {
        // Save the next token from the current job.
        var oldToken = this.nextToken;
        this.consume(); // Run the new job, terminating it with an excess '}'
        this.gullet.pushToken(new Token("}"));
        this.gullet.pushTokens(tokens);
        var parse = this.parseExpression(false);
        this.expect("}"); // Restore the next token from the current job.
        this.nextToken = oldToken;
        return parse;
    }
    /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence han infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */ parseExpression(breakOnInfix, breakOnTokenText) {
        var body = []; // Keep adding atoms to the body until we can't parse any more atoms (either
        // we reached the end, a }, or a \right)
        while(true){
            // Ignore spaces in math mode
            if (this.mode === "math") this.consumeSpaces();
            var lex = this.fetch();
            if (Parser.endOfExpression.indexOf(lex.text) !== -1) break;
            if (breakOnTokenText && lex.text === breakOnTokenText) break;
            if (breakOnInfix && functions[lex.text] && functions[lex.text].infix) break;
            var atom = this.parseAtom(breakOnTokenText);
            if (!atom) break;
            else if (atom.type === "internal") continue;
            body.push(atom);
        }
        if (this.mode === "text") this.formLigatures(body);
        return this.handleInfixNodes(body);
    }
    /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */ handleInfixNodes(body) {
        var overIndex = -1;
        var funcName;
        for(var i = 0; i < body.length; i++)if (body[i].type === "infix") {
            if (overIndex !== -1) throw new ParseError("only one infix operator per group", body[i].token);
            overIndex = i;
            funcName = body[i].replaceWith;
        }
        if (overIndex !== -1 && funcName) {
            var numerNode;
            var denomNode;
            var numerBody = body.slice(0, overIndex);
            var denomBody = body.slice(overIndex + 1);
            if (numerBody.length === 1 && numerBody[0].type === "ordgroup") numerNode = numerBody[0];
            else numerNode = {
                type: "ordgroup",
                mode: this.mode,
                body: numerBody
            };
            if (denomBody.length === 1 && denomBody[0].type === "ordgroup") denomNode = denomBody[0];
            else denomNode = {
                type: "ordgroup",
                mode: this.mode,
                body: denomBody
            };
            var node;
            if (funcName === "\\\\abovefrac") node = this.callFunction(funcName, [
                numerNode,
                body[overIndex],
                denomNode
            ], []);
            else node = this.callFunction(funcName, [
                numerNode,
                denomNode
            ], []);
            return [
                node
            ];
        } else return body;
    }
    /**
   * Handle a subscript or superscript with nice errors.
   */ handleSupSubscript(name // For error reporting.
    ) {
        var symbolToken = this.fetch();
        var symbol = symbolToken.text;
        this.consume();
        this.consumeSpaces(); // ignore spaces before sup/subscript argument
        // Skip over allowed internal nodes such as \relax
        var group;
        do {
            var _group;
            group = this.parseGroup(name);
        }while (((_group = group) == null ? void 0 : _group.type) === "internal");
        if (!group) throw new ParseError("Expected group after '" + symbol + "'", symbolToken);
        return group;
    }
    /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */ formatUnsupportedCmd(text) {
        var textordArray = [];
        for(var i = 0; i < text.length; i++)textordArray.push({
            type: "textord",
            mode: "text",
            text: text[i]
        });
        var textNode = {
            type: "text",
            mode: this.mode,
            body: textordArray
        };
        var colorNode = {
            type: "color",
            mode: this.mode,
            color: this.settings.errorColor,
            body: [
                textNode
            ]
        };
        return colorNode;
    }
    /**
   * Parses a group with optional super/subscripts.
   */ parseAtom(breakOnTokenText) {
        // The body of an atom is an implicit group, so that things like
        // \left(x\right)^2 work correctly.
        var base = this.parseGroup("atom", breakOnTokenText); // Internal nodes (e.g. \relax) cannot support super/subscripts.
        // Instead we will pick up super/subscripts with blank base next round.
        if ((base == null ? void 0 : base.type) === "internal") return base;
         // In text mode, we don't have superscripts or subscripts
        if (this.mode === "text") return base;
         // Note that base may be empty (i.e. null) at this point.
        var superscript;
        var subscript;
        while(true){
            // Guaranteed in math mode, so eat any spaces first.
            this.consumeSpaces(); // Lex the first token
            var lex = this.fetch();
            if (lex.text === "\\limits" || lex.text === "\\nolimits") {
                // We got a limit control
                if (base && base.type === "op") {
                    var limits = lex.text === "\\limits";
                    base.limits = limits;
                    base.alwaysHandleSupSub = true;
                } else if (base && base.type === "operatorname") {
                    if (base.alwaysHandleSupSub) base.limits = lex.text === "\\limits";
                } else throw new ParseError("Limit controls must follow a math operator", lex);
                this.consume();
            } else if (lex.text === "^") {
                // We got a superscript start
                if (superscript) throw new ParseError("Double superscript", lex);
                superscript = this.handleSupSubscript("superscript");
            } else if (lex.text === "_") {
                // We got a subscript start
                if (subscript) throw new ParseError("Double subscript", lex);
                subscript = this.handleSupSubscript("subscript");
            } else if (lex.text === "'") {
                // We got a prime
                if (superscript) throw new ParseError("Double superscript", lex);
                var prime = {
                    type: "textord",
                    mode: this.mode,
                    text: "\\prime"
                }; // Many primes can be grouped together, so we handle this here
                var primes = [
                    prime
                ];
                this.consume(); // Keep lexing tokens until we get something that's not a prime
                while(this.fetch().text === "'"){
                    // For each one, add another prime to the list
                    primes.push(prime);
                    this.consume();
                } // If there's a superscript following the primes, combine that
                // superscript in with the primes.
                if (this.fetch().text === "^") primes.push(this.handleSupSubscript("superscript"));
                 // Put everything into an ordgroup as the superscript
                superscript = {
                    type: "ordgroup",
                    mode: this.mode,
                    body: primes
                };
            } else if (uSubsAndSups[lex.text]) {
                // A Unicode subscript or superscript character.
                // We treat these similarly to the unicode-math package.
                // So we render a string of Unicode (sub|super)scripts the
                // same as a (sub|super)script of regular characters.
                var isSub = unicodeSubRegEx.test(lex.text);
                var subsupTokens = [];
                subsupTokens.push(new Token(uSubsAndSups[lex.text]));
                this.consume(); // Continue fetching tokens to fill out the string.
                while(true){
                    var token = this.fetch().text;
                    if (!uSubsAndSups[token]) break;
                    if (unicodeSubRegEx.test(token) !== isSub) break;
                    subsupTokens.unshift(new Token(uSubsAndSups[token]));
                    this.consume();
                } // Now create a (sub|super)script.
                var body = this.subparse(subsupTokens);
                if (isSub) subscript = {
                    type: "ordgroup",
                    mode: "math",
                    body
                };
                else superscript = {
                    type: "ordgroup",
                    mode: "math",
                    body
                };
            } else break;
        } // Base must be set if superscript or subscript are set per logic above,
        // but need to check here for type check to pass.
        if (superscript || subscript) // If we got either a superscript or subscript, create a supsub
        return {
            type: "supsub",
            mode: this.mode,
            base: base,
            sup: superscript,
            sub: subscript
        };
        else // Otherwise return the original body
        return base;
    }
    /**
   * Parses an entire function, including its base and all of its arguments.
   */ parseFunction(breakOnTokenText, name // For determining its context
    ) {
        var token = this.fetch();
        var func = token.text;
        var funcData = functions[func];
        if (!funcData) return null;
        this.consume(); // consume command token
        if (name && name !== "atom" && !funcData.allowedInArgument) throw new ParseError("Got function '" + func + "' with no arguments" + (name ? " as " + name : ""), token);
        else if (this.mode === "text" && !funcData.allowedInText) throw new ParseError("Can't use function '" + func + "' in text mode", token);
        else if (this.mode === "math" && funcData.allowedInMath === false) throw new ParseError("Can't use function '" + func + "' in math mode", token);
        var { args, optArgs } = this.parseArguments(func, funcData);
        return this.callFunction(func, args, optArgs, token, breakOnTokenText);
    }
    /**
   * Call a function handler with a suitable context and arguments.
   */ callFunction(name, args, optArgs, token, breakOnTokenText) {
        var context = {
            funcName: name,
            parser: this,
            token,
            breakOnTokenText
        };
        var func = functions[name];
        if (func && func.handler) return func.handler(context, args, optArgs);
        else throw new ParseError("No function handler for " + name);
    }
    /**
   * Parses the arguments of a function or environment
   */ parseArguments(func, funcData) {
        var totalArgs = funcData.numArgs + funcData.numOptionalArgs;
        if (totalArgs === 0) return {
            args: [],
            optArgs: []
        };
        var args = [];
        var optArgs = [];
        for(var i = 0; i < totalArgs; i++){
            var argType = funcData.argTypes && funcData.argTypes[i];
            var isOptional = i < funcData.numOptionalArgs;
            if (funcData.primitive && argType == null || // \sqrt expands into primitive if optional argument doesn't exist
            funcData.type === "sqrt" && i === 1 && optArgs[0] == null) argType = "primitive";
            var arg = this.parseGroupOfType("argument to '" + func + "'", argType, isOptional);
            if (isOptional) optArgs.push(arg);
            else if (arg != null) args.push(arg);
            else // should be unreachable
            throw new ParseError("Null argument, please report this as a bug");
        }
        return {
            args,
            optArgs
        };
    }
    /**
   * Parses a group when the mode is changing.
   */ parseGroupOfType(name, type, optional) {
        switch(type){
            case "color":
                return this.parseColorGroup(optional);
            case "size":
                return this.parseSizeGroup(optional);
            case "url":
                return this.parseUrlGroup(optional);
            case "math":
            case "text":
                return this.parseArgumentGroup(optional, type);
            case "hbox":
                // hbox argument type wraps the argument in the equivalent of
                // \hbox, which is like \text but switching to \textstyle size.
                var group = this.parseArgumentGroup(optional, "text");
                return group != null ? {
                    type: "styling",
                    mode: group.mode,
                    body: [
                        group
                    ],
                    style: "text" // simulate \textstyle
                } : null;
            case "raw":
                var token = this.parseStringGroup("raw", optional);
                return token != null ? {
                    type: "raw",
                    mode: "text",
                    string: token.text
                } : null;
            case "primitive":
                if (optional) throw new ParseError("A primitive argument cannot be optional");
                var _group2 = this.parseGroup(name);
                if (_group2 == null) throw new ParseError("Expected group as " + name, this.fetch());
                return _group2;
            case "original":
            case null:
            case undefined:
                return this.parseArgumentGroup(optional);
            default:
                throw new ParseError("Unknown group type as " + name, this.fetch());
        }
    }
    /**
   * Discard any space tokens, fetching the next non-space token.
   */ consumeSpaces() {
        while(this.fetch().text === " ")this.consume();
    }
    /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */ parseStringGroup(modeName, optional) {
        var argToken = this.gullet.scanArgument(optional);
        if (argToken == null) return null;
        var str = "";
        var nextToken;
        while((nextToken = this.fetch()).text !== "EOF"){
            str += nextToken.text;
            this.consume();
        }
        this.consume(); // consume the end of the argument
        argToken.text = str;
        return argToken;
    }
    /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */ parseRegexGroup(regex, modeName // Used to describe the mode in error messages.
    ) {
        var firstToken = this.fetch();
        var lastToken = firstToken;
        var str = "";
        var nextToken;
        while((nextToken = this.fetch()).text !== "EOF" && regex.test(str + nextToken.text)){
            lastToken = nextToken;
            str += lastToken.text;
            this.consume();
        }
        if (str === "") throw new ParseError("Invalid " + modeName + ": '" + firstToken.text + "'", firstToken);
        return firstToken.range(lastToken, str);
    }
    /**
   * Parses a color description.
   */ parseColorGroup(optional) {
        var res = this.parseStringGroup("color", optional);
        if (res == null) return null;
        var match = /^(#[a-f0-9]{3,4}|#[a-f0-9]{6}|#[a-f0-9]{8}|[a-f0-9]{6}|[a-z]+)$/i.exec(res.text);
        if (!match) throw new ParseError("Invalid color: '" + res.text + "'", res);
        var color = match[0];
        if (/^[0-9a-f]{6}$/i.test(color)) // We allow a 6-digit HTML color spec without a leading "#".
        // This follows the xcolor package's HTML color model.
        // Predefined color names are all missed by this RegEx pattern.
        color = "#" + color;
        return {
            type: "color-token",
            mode: this.mode,
            color
        };
    }
    /**
   * Parses a size specification, consisting of magnitude and unit.
   */ parseSizeGroup(optional) {
        var res;
        var isBlank = false; // don't expand before parseStringGroup
        this.gullet.consumeSpaces();
        if (!optional && this.gullet.future().text !== "{") res = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size");
        else res = this.parseStringGroup("size", optional);
        if (!res) return null;
        if (!optional && res.text.length === 0) {
            // Because we've tested for what is !optional, this block won't
            // affect \kern, \hspace, etc. It will capture the mandatory arguments
            // to \genfrac and \above.
            res.text = "0pt"; // Enable \above{}
            isBlank = true; // This is here specifically for \genfrac
        }
        var match = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(res.text);
        if (!match) throw new ParseError("Invalid size: '" + res.text + "'", res);
        var data = {
            number: +(match[1] + match[2]),
            // sign + magnitude, cast to number
            unit: match[3]
        };
        if (!validUnit(data)) throw new ParseError("Invalid unit: '" + data.unit + "'", res);
        return {
            type: "size",
            mode: this.mode,
            value: data,
            isBlank
        };
    }
    /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */ parseUrlGroup(optional) {
        this.gullet.lexer.setCatcode("%", 13); // active character
        this.gullet.lexer.setCatcode("~", 12); // other character
        var res = this.parseStringGroup("url", optional);
        this.gullet.lexer.setCatcode("%", 14); // comment character
        this.gullet.lexer.setCatcode("~", 13); // active character
        if (res == null) return null;
         // hyperref package allows backslashes alone in href, but doesn't
        // generate valid links in such cases; we interpret this as
        // "undefined" behaviour, and keep them as-is. Some browser will
        // replace backslashes with forward slashes.
        var url = res.text.replace(/\\([#$%&~_^{}])/g, '$1');
        return {
            type: "url",
            mode: this.mode,
            url
        };
    }
    /**
   * Parses an argument with the mode specified.
   */ parseArgumentGroup(optional, mode) {
        var argToken = this.gullet.scanArgument(optional);
        if (argToken == null) return null;
        var outerMode = this.mode;
        if (mode) // Switch to specified mode
        this.switchMode(mode);
        this.gullet.beginGroup();
        var expression = this.parseExpression(false, "EOF"); // TODO: find an alternative way to denote the end
        this.expect("EOF"); // expect the end of the argument
        this.gullet.endGroup();
        var result = {
            type: "ordgroup",
            mode: this.mode,
            loc: argToken.loc,
            body: expression
        };
        if (mode) // Switch mode back
        this.switchMode(outerMode);
        return result;
    }
    /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */ parseGroup(name, breakOnTokenText) {
        var firstToken = this.fetch();
        var text = firstToken.text;
        var result; // Try to parse an open brace or \begingroup
        if (text === "{" || text === "\\begingroup") {
            this.consume();
            var groupEnd = text === "{" ? "}" : "\\endgroup";
            this.gullet.beginGroup(); // If we get a brace, parse an expression
            var expression = this.parseExpression(false, groupEnd);
            var lastToken = this.fetch();
            this.expect(groupEnd); // Check that we got a matching closing brace
            this.gullet.endGroup();
            result = {
                type: "ordgroup",
                mode: this.mode,
                loc: SourceLocation.range(firstToken, lastToken),
                body: expression,
                // A group formed by \begingroup...\endgroup is a semi-simple group
                // which doesn't affect spacing in math mode, i.e., is transparent.
                // https://tex.stackexchange.com/questions/1930/when-should-one-
                // use-begingroup-instead-of-bgroup
                semisimple: text === "\\begingroup" || undefined
            };
        } else {
            // If there exists a function with this name, parse the function.
            // Otherwise, just return a nucleus
            result = this.parseFunction(breakOnTokenText, name) || this.parseSymbol();
            if (result == null && text[0] === "\\" && !implicitCommands.hasOwnProperty(text)) {
                if (this.settings.throwOnError) throw new ParseError("Undefined control sequence: " + text, firstToken);
                result = this.formatUnsupportedCmd(text);
                this.consume();
            }
        }
        return result;
    }
    /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */ formLigatures(group) {
        var n = group.length - 1;
        for(var i = 0; i < n; ++i){
            var a = group[i]; // $FlowFixMe: Not every node type has a `text` property.
            var v = a.text;
            if (v === "-" && group[i + 1].text === "-") {
                if (i + 1 < n && group[i + 2].text === "-") {
                    group.splice(i, 3, {
                        type: "textord",
                        mode: "text",
                        loc: SourceLocation.range(a, group[i + 2]),
                        text: "---"
                    });
                    n -= 2;
                } else {
                    group.splice(i, 2, {
                        type: "textord",
                        mode: "text",
                        loc: SourceLocation.range(a, group[i + 1]),
                        text: "--"
                    });
                    n -= 1;
                }
            }
            if ((v === "'" || v === "`") && group[i + 1].text === v) {
                group.splice(i, 2, {
                    type: "textord",
                    mode: "text",
                    loc: SourceLocation.range(a, group[i + 1]),
                    text: v + v
                });
                n -= 1;
            }
        }
    }
    /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */ parseSymbol() {
        var nucleus = this.fetch();
        var text = nucleus.text;
        if (/^\\verb[^a-zA-Z]/.test(text)) {
            this.consume();
            var arg = text.slice(5);
            var star = arg.charAt(0) === "*";
            if (star) arg = arg.slice(1);
             // Lexer's tokenRegex is constructed to always have matching
            // first/last characters.
            if (arg.length < 2 || arg.charAt(0) !== arg.slice(-1)) throw new ParseError("\\verb assertion failed --\n                    please report what input caused this bug");
            arg = arg.slice(1, -1); // remove first and last char
            return {
                type: "verb",
                mode: "text",
                body: arg,
                star
            };
        } // At this point, we should have a symbol, possibly with accents.
        // First expand any accented base symbol according to unicodeSymbols.
        if (unicodeSymbols.hasOwnProperty(text[0]) && !symbols[this.mode][text[0]]) {
            // This behavior is not strict (XeTeX-compatible) in math mode.
            if (this.settings.strict && this.mode === "math") this.settings.reportNonstrict("unicodeTextInMathMode", "Accented Unicode text character \"" + text[0] + "\" used in " + "math mode", nucleus);
            text = unicodeSymbols[text[0]] + text.slice(1);
        } // Strip off any combining characters
        var match = combiningDiacriticalMarksEndRegex.exec(text);
        if (match) {
            text = text.substring(0, match.index);
            if (text === 'i') text = '\u0131'; // dotless i, in math and text mode
            else if (text === 'j') text = '\u0237'; // dotless j, in math and text mode
        } // Recognize base symbol
        var symbol;
        if (symbols[this.mode][text]) {
            if (this.settings.strict && this.mode === 'math' && extraLatin.indexOf(text) >= 0) this.settings.reportNonstrict("unicodeTextInMathMode", "Latin-1/Unicode text character \"" + text[0] + "\" used in " + "math mode", nucleus);
            var group = symbols[this.mode][text].group;
            var loc = SourceLocation.range(nucleus);
            var s;
            if (ATOMS.hasOwnProperty(group)) {
                // $FlowFixMe
                var family = group;
                s = {
                    type: "atom",
                    mode: this.mode,
                    family,
                    loc,
                    text
                };
            } else // $FlowFixMe
            s = {
                type: group,
                mode: this.mode,
                loc,
                text
            };
             // $FlowFixMe
            symbol = s;
        } else if (text.charCodeAt(0) >= 0x80) {
            // no symbol for e.g. ^
            if (this.settings.strict) {
                if (!supportedCodepoint(text.charCodeAt(0))) this.settings.reportNonstrict("unknownSymbol", "Unrecognized Unicode character \"" + text[0] + "\"" + (" (" + text.charCodeAt(0) + ")"), nucleus);
                else if (this.mode === "math") this.settings.reportNonstrict("unicodeTextInMathMode", "Unicode text character \"" + text[0] + "\" used in math mode", nucleus);
            } // All nonmathematical Unicode characters are rendered as if they
            // are in text mode (wrapped in \text) because that's what it
            // takes to render them in LaTeX.  Setting `mode: this.mode` is
            // another natural choice (the user requested math mode), but
            // this makes it more difficult for getCharacterMetrics() to
            // distinguish Unicode characters without metrics and those for
            // which we want to simulate the letter M.
            symbol = {
                type: "textord",
                mode: "text",
                loc: SourceLocation.range(nucleus),
                text
            };
        } else return null; // EOF, ^, _, {, }, etc.
        this.consume(); // Transform combining characters into accents
        if (match) for(var i = 0; i < match[0].length; i++){
            var accent = match[0][i];
            if (!unicodeAccents[accent]) throw new ParseError("Unknown accent ' " + accent + "'", nucleus);
            var command = unicodeAccents[accent][this.mode] || unicodeAccents[accent].text;
            if (!command) throw new ParseError("Accent " + accent + " unsupported in " + this.mode + " mode", nucleus);
            symbol = {
                type: "accent",
                mode: this.mode,
                loc: SourceLocation.range(nucleus),
                label: command,
                isStretchy: false,
                isShifty: true,
                // $FlowFixMe
                base: symbol
            };
        }
         // $FlowFixMe
        return symbol;
    }
}
Parser.endOfExpression = [
    "}",
    "\\endgroup",
    "\\end",
    "\\right",
    "&"
];
/**
 * Provides a single function for parsing an expression using a Parser
 * TODO(emily): Remove this
 */ /**
 * Parses an expression using a Parser, then returns the parsed result.
 */ var parseTree = function parseTree(toParse, settings) {
    if (!(typeof toParse === 'string' || toParse instanceof String)) throw new TypeError('KaTeX can only parse string typed expression');
    var parser = new Parser(toParse, settings); // Blank out any \df@tag to avoid spurious "Duplicate \tag" errors
    delete parser.gullet.macros.current["\\df@tag"];
    var tree = parser.parse(); // Prevent a color definition from persisting between calls to katex.render().
    delete parser.gullet.macros.current["\\current@color"];
    delete parser.gullet.macros.current["\\color"]; // If the input used \tag, it will set the \df@tag macro to the tag.
    // In this case, we separately parse the tag and wrap the tree.
    if (parser.gullet.macros.get("\\df@tag")) {
        if (!settings.displayMode) throw new ParseError("\\tag works only in display equations");
        tree = [
            {
                type: "tag",
                mode: "text",
                body: tree,
                tag: parser.subparse([
                    new Token("\\df@tag")
                ])
            }
        ];
    }
    return tree;
};
/* eslint no-console:0 */ /**
 * Parse and build an expression, and place that expression in the DOM node
 * given.
 */ var render = function render(expression, baseNode, options) {
    baseNode.textContent = "";
    var node = renderToDomTree(expression, options).toNode();
    baseNode.appendChild(node);
}; // KaTeX's styles don't work properly in quirks mode. Print out an error, and
// disable rendering.
if (typeof document !== "undefined") {
    if (document.compatMode !== "CSS1Compat") {
        typeof console !== "undefined" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype.");
        render = function render() {
            throw new ParseError("KaTeX doesn't work in quirks mode.");
        };
    }
}
/**
 * Parse and build an expression, and return the markup for that.
 */ var renderToString = function renderToString(expression, options) {
    var markup = renderToDomTree(expression, options).toMarkup();
    return markup;
};
/**
 * Parse an expression and return the parse tree.
 */ var generateParseTree = function generateParseTree(expression, options) {
    var settings = new Settings(options);
    return parseTree(expression, settings);
};
/**
 * If the given error is a KaTeX ParseError and options.throwOnError is false,
 * renders the invalid LaTeX as a span with hover title giving the KaTeX
 * error message.  Otherwise, simply throws the error.
 */ var renderError = function renderError(error, expression, options) {
    if (options.throwOnError || !(error instanceof ParseError)) throw error;
    var node = buildCommon.makeSpan([
        "katex-error"
    ], [
        new SymbolNode(expression)
    ]);
    node.setAttribute("title", error.toString());
    node.setAttribute("style", "color:" + options.errorColor);
    return node;
};
/**
 * Generates and returns the katex build tree. This is used for advanced
 * use cases (like rendering to custom output).
 */ var renderToDomTree = function renderToDomTree(expression, options) {
    var settings = new Settings(options);
    try {
        var tree = parseTree(expression, settings);
        return buildTree(tree, expression, settings);
    } catch (error) {
        return renderError(error, expression, settings);
    }
};
/**
 * Generates and returns the katex build tree, with just HTML (no MathML).
 * This is used for advanced use cases (like rendering to custom output).
 */ var renderToHTMLTree = function renderToHTMLTree(expression, options) {
    var settings = new Settings(options);
    try {
        var tree = parseTree(expression, settings);
        return buildHTMLTree(tree, expression, settings);
    } catch (error) {
        return renderError(error, expression, settings);
    }
};
var version = "0.16.25";
var __domTree = {
    Span,
    Anchor,
    SymbolNode,
    SvgNode,
    PathNode,
    LineNode
}; // ESM exports
var katex = {
    /**
   * Current KaTeX version
   */ version,
    /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */ render,
    /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */ renderToString,
    /**
   * KaTeX error, usually during parsing.
   */ ParseError,
    /**
   * The schema of Settings
   */ SETTINGS_SCHEMA,
    /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __parse: generateParseTree,
    /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __renderToDomTree: renderToDomTree,
    /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __renderToHTMLTree: renderToHTMLTree,
    /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */ __setFontMetrics: setFontMetrics,
    /**
   * adds a new symbol to builtin symbols table
   */ __defineSymbol: defineSymbol,
    /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */ __defineFunction: defineFunction,
    /**
   * adds a new macro to builtin macro list
   */ __defineMacro: defineMacro,
    /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: These methods are not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */ __domTree
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6lnPH":[function() {},{}],"13cYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
var _utils1 = require("./utils");
var _questionHandlers = require("./question-handlers");
var _questionHandlersDefault = parcelHelpers.interopDefault(_questionHandlers);
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question({ sections, context }) {
    const { questionId, sectionId, translate, quizQuestionTypes } = context;
    const classes = useStyles();
    const assessmentLoaded = !context.quizSearch.assessment;
    const count = sections.reduce((a, b)=>a + b.questions.length, 0);
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const questionIndex = questionId && section ? section.questions.findIndex((q)=>q.id == questionId) : -1;
    const question = questionIndex >= 0 && section.questions[questionIndex];
    const { html } = question && question.premise || {};
    const premiseHtml = (0, _utils.isEmpty)(html) ? false : html;
    const type = quizQuestionTypes.find((t)=>t.id == question.type) || {};
    const title = translate(type.name);
    const globalIndex = (0, _utils1.findGlobalIndex)(question.id, sections);
    const indexLabel = `${translate('questions').substring(0, 1)}: ${globalIndex + 1}/${count}`;
    const Handler = (0, _questionHandlersDefault.default)[type.name];
    const defaultPremiseLabel = `${type.name}-default-premise`;
    const defaultPremise = translate(defaultPremiseLabel);
    const hasDefaultPremise = defaultPremiseLabel != defaultPremise;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.index,
                        children: indexLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    premiseHtml && (context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        className: classes.premise,
                        html: premiseHtml
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.premise,
                        dangerouslySetInnerHTML: {
                            __html: premiseHtml
                        }
                    })),
                    !premiseHtml && hasDefaultPremise && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.premise,
                        children: defaultPremise
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.question,
                        children: assessmentLoaded && Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                            context,
                            question,
                            section,
                            questionIndex
                        })
                    })
                ]
            })
        ]
    }, question.id);
}
function questionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '13pt',
            padding: '10px 20px',
            borderBottom: 'solid 1px #d0d5d8'
        },
        question: {
            display: 'flex',
            flexGrow: 1
        },
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        index: {
            fontSize: '10pt',
            ...verticalCentering
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 30,
            display: 'flex',
            flexDirection: 'column'
        },
        premise: {
            fontWeight: 'bold',
            fontSize: '12pt',
            marginBottom: 20
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","./utils":"kJZMw","./question-handlers":"4zR7b","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4zR7b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trueOrFalse = require("./TrueOrFalse");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _fillInTheBlanks = require("./FillInTheBlanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _openQuestion = require("./OpenQuestion");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _multipleChoice = require("./MultipleChoice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _matching = require("./Matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'matching': (0, _matchingDefault.default)
};
exports.default = handlers;

},{"./TrueOrFalse":"7LEi7","./FillInTheBlanks":"jQ9bJ","./OpenQuestion":"aNuOz","./MultipleChoice":"kXwod","./Matching":"ggnKA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LEi7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
const useStyles = (0, _material.makeStyles)(trueOrFalseStyles);
function TrueOrFalse({ context, section, question, questionIndex }) {
    const classes = useStyles();
    const [answer, setAnswer] = (0, _reactDefault.default).useState(question.answer.value);
    const { translate } = context;
    (0, _reactDefault.default).useEffect(()=>{
        setAnswer(question.answer.value);
    }, [
        question
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
            className: "content",
            value: question.answer.value,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.option,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: true,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                            label: translate('true')
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.option,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: false,
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                            label: translate('false')
                        })
                    })
                })
            ]
        })
    });
}
function trueOrFalseStyles(theme) {
    return {
        root: {},
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jQ9bJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanks);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(fillInTheBlanksStyles);
function FillInTheBlanks({ context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const [phrases, setPhrases] = (0, _reactDefault.default).useState(question.answer.phrases.map((p)=>({
            ...p,
            value: ''
        })));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: classes.wrapper,
            children: question.answer.phrases.map(({ phrase, blanked, value }, index)=>blanked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    className: (0, _clsxDefault.default)(classes.input, classes.phrase),
                    type: "text",
                    value: phrase,
                    readOnly: true
                }, index) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.phrase,
                    children: phrase
                }, index))
        })
    });
}
function fillInTheBlanksStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            padding: '35px 0',
            fontSize: '12pt'
        },
        wrapper: {
            display: 'flex'
        },
        phrase: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 10,
            '&:last-child': {
                marginLeft: 0
            }
        },
        input: {
            border: 'none',
            borderBottom: 'solid 1px black'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aNuOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(openQuestionStyles);
function OpenQuestion({ context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const text = (0, _utils.htmlToText)(question.answer.html);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
            className: classes.textarea,
            maxRows: 5,
            minRows: 5,
            readOnly: true,
            value: text
        })
    });
}
function openQuestionStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column'
        },
        textarea: {
            resize: 'none',
            width: 'auto',
            padding: 8,
            flexGrow: 1,
            borderRadius: '4px',
            border: 'solid 1px #c2c7ca'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kXwod":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(multipleChoiceStyles);
function MultipleChoice({ context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const { properties } = question;
    const { choices = [] } = question.answer;
    const Choices = question.properties.singleOption ? RadioChoice : CheckboxChoice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
            question: question,
            context: context,
            choices: choices
        })
    });
}
function RadioChoice({ context, choices }) {
    const classes = useStyles();
    const correctChoice = choices.find((c)=>c.correct) || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: correctChoice.id || '',
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.option,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.radio,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                        value: choice.id,
                        className: "choice",
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                            color: "primary"
                        }),
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.optionLabel,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: "index",
                                    children: [
                                        answerIndex,
                                        ")"
                                    ]
                                }),
                                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                                    className: "choice-caption",
                                    html: choice.html || ''
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "choice-caption",
                                    dangerouslySetInnerHTML: {
                                        __html: choice.html || ''
                                    }
                                })
                            ]
                        })
                    })
                })
            }, index);
        })
    });
}
function CheckboxChoice({ context, question, choices }) {
    const classes = useStyles();
    const { assessment } = context;
    const [selectedOptions, setOptions] = (0, _reactDefault.default).useState([]);
    (0, _reactDefault.default).useEffect(()=>{
        if (choices.length > 0) setOptions(choices.filter((c)=>c.correct).map((c)=>c.id));
    }, [
        choices
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: choices.map((option, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.option,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.checkbox,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                            color: "primary",
                            checked: selectedOptions.indexOf(option.id) >= 0
                        }),
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.optionLabel,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: "index",
                                    children: [
                                        answerIndex,
                                        ")"
                                    ]
                                }),
                                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                                    className: "choice-caption",
                                    html: option.html || ''
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "choice-caption",
                                    dangerouslySetInnerHTML: {
                                        __html: option.html || ''
                                    }
                                })
                            ]
                        })
                    })
                })
            }, index);
        })
    });
}
function multipleChoiceStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            paddingLeft: 10,
            fontSize: '12pt'
        },
        option: {
            display: 'flex'
        },
        optionLabel: {
            display: 'flex',
            "& > .index": {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginRight: 15
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@mui/material/FormGroup":"1gJha","@mui/material/Checkbox":"4sdMA","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ggnKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Matching);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(matchingStyles);
function Matching({ context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const { choices, assignDefinition } = useChoices(question.answer.choices || []);
    const terms = choices.terms.map(({ term, id }, index)=>{
        const value = choices.selected[index];
        const correctIndex = choices.definitions.findIndex((d)=>d.id == id);
        const answerIndex = String.fromCharCode(Math.min(correctIndex, 20) + 97);
        const cleared = value == -1;
        const correct = correctIndex == value;
        const incorrect = !cleared && correctIndex != value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.selectAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectDefinition, {
                        index: index,
                        definitions: choices.definitions,
                        value: choices.selected[index]
                    })
                }),
                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        html: term || ''
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    dangerouslySetInnerHTML: {
                        __html: term || ''
                    }
                })
            ]
        });
    });
    const definitions = choices.definitions.map(({ definition }, index)=>{
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionIndex, {
                        selected: choices.selected.indexOf(index) > -1
                    }),
                    size: "small",
                    children: [
                        answerIndex,
                        ")"
                    ]
                }),
                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        html: definition || ''
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    dangerouslySetInnerHTML: {
                        __html: definition || ''
                    }
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _boxDefault.default),
            className: classes.tableContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                className: classes.table,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: (0, _lodash.zip)(terms, definitions).map(([term, definition], index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            className: classes.pair,
                            children: [
                                term,
                                definition
                            ]
                        }, index);
                    })
                })
            })
        })
    });
}
function useChoices(choices) {
    const [state, setState] = (0, _reactDefault.default).useState({
        definitions: [],
        terms: [],
        selected: []
    });
    (0, _reactDefault.default).useEffect(()=>{
        if (choices) {
            const terms = (0, _utils.shuffleArray)(choices.map(([term, _, id], index)=>({
                    id,
                    term,
                    index
                })));
            const definitions = (0, _utils.shuffleArray)(choices.map(([_, definition, id], index)=>({
                    id,
                    definition,
                    index
                })));
            const selected = terms.map(({ id })=>definitions.findIndex((d)=>d.id == id));
            setState({
                terms,
                definitions,
                selected
            });
        }
    }, [
        choices
    ]);
    function assignDefinition(term, definition) {
        const selected = (0, _immutabilityHelperDefault.default)(state.selected, {
            [state.selected.indexOf(definition)]: {
                $set: -1
            },
            [term]: {
                $set: definition
            }
        });
        setState((0, _immutabilityHelperDefault.default)(state, {
            selected: {
                $set: selected
            }
        }));
    }
    return {
        choices: state,
        assignDefinition
    };
}
function SelectDefinition(props) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
        className: classes.termValue,
        value: props.value,
        readOnly: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                style: {
                    display: 'none'
                },
                value: -1,
                children: " "
            }),
            props.definitions.map((definition, index)=>{
                const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                    value: index,
                    children: answerIndex
                }, index);
            })
        ]
    });
}
function matchingStyles(theme) {
    return {
        root: {
            display: 'flex',
            marginTop: 10,
            flexGrow: 1
        },
        tableContainer: {
            flexShrink: 0,
            maxWidth: 1280,
            display: 'flex',
            fontSize: '12pt'
        },
        cell: {
            borderBottom: 0,
            padding: '16px 8px',
            verticalAlign: 'top'
        },
        correctAnswer: {
            width: 35,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 35
        },
        selectAnswer: {
            width: 45,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 45,
            '& .MuiSelect-select:focus': {
                backgroundColor: 'transparent'
            }
        },
        definitionIndex: {
            width: 20,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 20
        },
        table: {
            maxWidth: 1280
        },
        term: {
            display: 'flex'
        },
        termValue: {
            border: 'solid 1px #e0e5e9',
            borderRadius: 3,
            paddingLeft: 8,
            justifyContent: 'center',
            '&:focus': {
                backgroundColor: 'transparent'
            },
            '&:before': {
                borderBottom: '0 !important'
            },
            '&:after': {
                borderBottom: 0
            }
        },
        termHtml: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        },
        definitionValue: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/icons-material/CheckCircle":"crtKq","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableRow":"4f4VX","@mui/material/Table":"if4Vw","@mui/material/Select":"aY7hn","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51Uwd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Indicators);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(indicatorStyles);
function Indicators() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = useStyles();
    const { standardsContext, questionId } = context;
    const { assessmentIndicators } = standardsContext;
    const indicators = assessmentIndicators[questionId] || [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classes.root,
        children: indicators.map(({ id, code })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: classes.code,
                children: code
            }, id))
    });
}
function indicatorStyles() {
    return {
        root: {
            display: 'flex'
        },
        code: {
            marginLeft: 10,
            minWidth: 80,
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            backgroundColor: '#40f993',
            borderRadius: 3,
            fontSize: '11pt',
            padding: '3px 16px',
            color: '#4b5463'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"beT4s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ReviewAssessment);
parcelHelpers.export(exports, "assessmentStyles", ()=>assessmentStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _navigation = require("./Navigation");
var _navigationDefault = parcelHelpers.interopDefault(_navigation);
var _sections = require("./Sections");
var _sectionsDefault = parcelHelpers.interopDefault(_sections);
var _section = require("./Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _question = require("./Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
var _utils = require("../../../helpers/utils");
var _command = require("../../../helpers/command");
var _previewPdf = require("../preview-pdf");
var _previewPdfDefault = parcelHelpers.interopDefault(_previewPdf);
var _comments = require("./Comments");
var _commentsDefault = parcelHelpers.interopDefault(_comments);
var _standards = require("./Standards");
var _standardsDefault = parcelHelpers.interopDefault(_standards);
const useStyles = (0, _material.makeStyles)(assessmentStyles);
function ReviewAssessment({ context }) {
    const classes = useStyles();
    const [cleared, clear] = (0, _reactDefault.default).useState(false);
    const [commentsOpened, openComments] = (0, _reactDefault.default).useState(false);
    const { quizAssessmentToReview: assessment, assessment: assessmentId, translate, sectionId, link, quizTypesMap } = context;
    const { studentName, content = {}, results = {}, finished, properties = {} } = assessment;
    const { title, type } = content;
    const sections = assessment.id == assessmentId ? (0, _lodash.orderBy)(Object.values(content.sections || {}), 'index') : [];
    const redirect = sections.length > 0 && !sectionId;
    const redirectLink = redirect && link({
        sectionId: sections[0].id
    });
    const typeName = translate(quizTypesMap[type]);
    const isSection = !context.questionId;
    const closeLink = link({}, context.quizEditFrom || '/:languageId/:role/:page/assigned', {
        query: context.quizEditFromQuery
    });
    const { points, total } = Object.values(results).reduce((acc, { points, total })=>({
            total: acc.total + total,
            points: acc.points + points
        }), {
        total: 0,
        points: 0
    });
    const pointsText = `${(0, _utils.toDisplayPoints)(points + (properties.bonus || 0))}/${(0, _utils.toDisplayPoints)(total)}`;
    const changeBonus = (bonus)=>context.updateState({
            quizAssessmentToReview: {
                properties: {
                    bonus: {
                        $set: bonus
                    }
                }
            }
        });
    function handleBonusChange(e) {
        const cleared = e.target.value == '';
        const value1 = cleared ? 0 : parseInt(e.target.value);
        const points = Math.max(0, Math.min(value1, 9999));
        changeBonus(points);
        clear(cleared);
    }
    function handlePointsChange(e) {
        const points = Math.max(0, Math.min(value, result.total));
        changePoints(points, cleared);
    }
    function sendProperties() {
        (0, _command.createPost)('quiz', 'saveReviewProperties')({
            id: context.assessment,
            properties: context.quizAssessmentToReview.properties
        });
    }
    function saveToPdf() {
        context.updateState({
            quizAssessmentForPdfId: {
                $set: context.assessment
            }
        });
    }
    const displayBonus = cleared ? '' : (0, _utils.toDisplayPoints)(properties.bonus);
    return redirectLink ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
        to: redirectLink
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.preview,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
                    className: classes.view,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.viewHeader,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.studentNameAndActions,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            className: classes.studentName,
                                            children: studentName
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: classes.actions,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                    className: (0, _clsxDefault.default)(classes.button, classes.saveAsPdf),
                                                    onClick: saveToPdf,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                        className: "label",
                                                        children: translate('save-as-pdf')
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                    className: (0, _clsxDefault.default)(classes.button, classes.comment),
                                                    onClick: ()=>openComments(true),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                            className: "icon annotation",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                                                icon: (0, _freeSolidSvgIcons.faStickyNote)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                            className: "label",
                                                            children: translate('annotations')
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commentsDefault.default), {
                                                    isOpen: commentsOpened,
                                                    closeDialog: ()=>openComments(false),
                                                    context: context
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewPdfDefault.default), {
                                                    context: context
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.title,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: "type",
                                            children: [
                                                typeName,
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            className: "title",
                                            children: title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.results,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: classes.finished,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                    className: "label",
                                                    children: [
                                                        translate('assessment-sent-on'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                    className: "date",
                                                    children: (0, _momentDefault.default)(finished).format(translate('assessment-sent-on-format'))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: classes.bonus,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                    className: "label",
                                                    children: [
                                                        translate('bonus'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                                    className: "bonusInput",
                                                    InputProps: {
                                                        inputProps: {
                                                            min: 0,
                                                            max: 9999
                                                        }
                                                    },
                                                    value: displayBonus,
                                                    type: "number",
                                                    onChange: handleBonusChange,
                                                    onBlur: sendProperties
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: classes.points,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                                    className: "label",
                                                    children: [
                                                        translate('points'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                    className: "points",
                                                    children: pointsText
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.viewContent,
                            children: [
                                isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDefault.default), {
                                    sections,
                                    context
                                }),
                                !isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                                    sections,
                                    context
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.viewNavigation,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
                                direction: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                spacing: 2,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsDefault.default), {
                                        context: context
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationDefault.default), {
                                        sections,
                                        context
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.side,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.closeWrapper,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                className: (0, _clsxDefault.default)(classes.button, classes.close),
                                to: closeLink,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: "label",
                                        children: translate('close')
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionsDefault.default), {
                            sections,
                            context
                        })
                    ]
                })
            ]
        })
    });
}
function assessmentStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        closeWrapper: {
            display: 'flex',
            marginBottom: 15,
            justifyContent: 'flex-end'
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .icon': {
                marginTop: -3,
                marginRight: 3,
                fontSize: '8pt'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {}
        },
        bonus: {
            display: 'flex',
            marginRight: 20,
            '& .value': {
                marginLeft: 5,
                minWidth: 40,
                padding: '8px 5px 9px 5px',
                borderRadius: 2,
                backgroundColor: "#cfe1eb"
            },
            '& .bonusInput': {
                marginLeft: 5,
                paddingLeft: 5,
                minWidth: 40,
                backgroundColor: '#fff',
                borderRadius: 3,
                '& .MuiInput-underline:after': {
                    borderBottom: 0,
                    transition: 'none'
                },
                '& .MuiInput-underline:before': {
                    borderBottom: 0,
                    transition: 'none'
                }
            }
        },
        comment: {
            '& .icon': {
                marginTop: -2,
                marginRight: 8,
                fontSize: '12pt',
                color: '#fff'
            }
        },
        saveAsPdf: {
            marginRight: 20
        },
        preview: {
            display: 'flex',
            padding: 10,
            flexGrow: 1,
            overflowY: 'hidden'
        },
        view: {
            flexGrow: 1,
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        viewHeader: {
            display: 'flex',
            flexDirection: 'column',
            color: '#4d5361',
            padding: 20,
            borderBottom: 'solid 1px #d3d8db'
        },
        studentNameAndActions: {
            display: 'flex'
        },
        title: {
            display: 'flex',
            marginTop: 15,
            '& > .type': {
                fontWeight: 'bold',
                marginRight: 3
            }
        },
        studentName: {
            fontWeight: 'bold',
            fontSize: '14pt',
            flexGrow: 1
        },
        actions: {
            display: 'flex'
        },
        results: {
            marginTop: 10,
            display: 'flex',
            '& .label': {
                fontWeight: 'bold',
                marginRight: 3
            },
            '& > div > div': {
                ...verticalCentering
            }
        },
        finished: {
            display: 'flex',
            flexGrow: 1
        },
        points: {
            display: 'flex'
        },
        total: {
            marginLeft: 20,
            display: 'flex'
        },
        viewContent: {
            display: 'flex',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        viewNavigation: {
            borderTop: 'solid 1px #d3d8db',
            padding: 20
        },
        side: {
            marginLeft: 25,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 255,
            maxWidth: 255
        }
    };
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","@mui/icons-material/Close":"acjz6","@mui/material/TextField":"amnzu","@mui/material/Stack":"jY4TS","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./Navigation":"7aGh8","./Sections":"9Isq6","./Section":"38I7Z","./Question":"1oALJ","../../../helpers/utils":"gGc98","../../../helpers/command":"f3cbG","../preview-pdf":"8cJHL","./Comments":"tan1X","./Standards":"4Sao2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7aGh8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigation);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _icons = require("../../../resources/icons");
const useStyles = (0, _material.makeStyles)(navigationStyles);
function Navigation({ sections, context }) {
    const { questionId, sectionId, translate } = context;
    const link = (sectionId, questionId)=>context.link({
            sectionId,
            questionId
        });
    const classes = useStyles();
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const questionIndex = questionId && section ? section.questions.findIndex((q)=>q.id == questionId) : -1;
    const question = questionIndex >= 0 && section.questions[questionIndex];
    const isFirst = !questionId && sectionIndex == 0;
    const isLastSection = sectionIndex == sections.length - 1;
    const isLastQuestion = section && questionIndex == section.questions.length - 1;
    const isLast = isLastSection && isLastQuestion;
    const nextTo = ()=>{
        if (!section) return '#';
        if (questionId) return isLastQuestion ? link(sections[sectionIndex + 1].id) : link(sectionId, section.questions[questionIndex + 1].id);
        return link(sectionId, section.questions[0].id);
    };
    const previousTo = ()=>{
        if (!section) return '#';
        if (questionId) return questionIndex == 0 ? link(sectionId) : link(sectionId, section.questions[questionIndex - 1].id);
        const previousSection = sections[sectionIndex - 1];
        const lastQuestion = previousSection.questions[previousSection.questions.length - 1];
        if (lastQuestion) return link(previousSection.id, lastQuestion.id);
        return '#';
    };
    function handleFinalize() {}
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: "filler"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    !isFirst && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NavigationButton, {
                        name: "previous",
                        to: previousTo(),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.buttonIcon,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowLeftIcon), {
                                    width: "16px",
                                    height: "25px",
                                    fill: "#6278f0"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.buttonLabel, "previous"),
                                children: translate('previous')
                            })
                        ]
                    }),
                    !isLast && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NavigationButton, {
                        name: "next",
                        to: nextTo(),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.buttonLabel, "next"),
                                children: translate('next')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.buttonIcon,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowRightIcon), {
                                    width: "16px",
                                    height: "25px",
                                    fill: "#6278f0"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function NavigationButton(props) {
    const { name, onClick, to } = props;
    const classes = useStyles();
    const Elem = to ? (0, _reactRouterDom.Link) : (0, _boxDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Elem, {
        to: to,
        onClick: onClick,
        className: (0, _clsxDefault.default)(classes.button, name),
        children: props.children
    });
}
function navigationStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            display: 'flex',
            "& .filler": {
                flexGrow: 1
            }
        },
        buttons: {
            display: 'flex'
        },
        button: {
            display: 'flex',
            padding: '5px',
            fontSize: '12pt',
            backgroundColor: '#f0f0f0',
            color: '#6278f0',
            borderRadius: 3,
            width: 110,
            textDecoration: 'none',
            "&:last-child": {
                marginLeft: 20
            }
        },
        buttonLabel: {
            flexGrow: 1,
            ...verticalCentering,
            textAlign: 'center'
        },
        buttonIcon: {
            ...verticalCentering
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/FormControlLabel":"kemIW","@mui/material/Checkbox":"4sdMA","../../../resources/icons":"7BMUb","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Isq6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Sections);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _sectionLink = require("./SectionLink");
var _sectionLinkDefault = parcelHelpers.interopDefault(_sectionLink);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Sections({ sections, context }) {
    const classes = useStyles();
    const createSection = (section, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionLinkDefault.default), {
            key: section.id,
            index,
            section,
            context,
            sections
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: context.translate('questions')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.sections,
                children: sections.map(createSection)
            })
        ]
    });
}
function sectionStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            padding: 10,
            color: '#555764',
            fontSize: '12pt'
        },
        sections: {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","./SectionLink":"jYZOA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jYZOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
parcelHelpers.export(exports, "sectionStyles", ()=>sectionStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
var _questionLink = require("./QuestionLink");
var _questionLinkDefault = parcelHelpers.interopDefault(_questionLink);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ index, section, sections, context }) {
    const classes = useStyles();
    const { translate } = context;
    const { questions = [] } = section;
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${index + 1}` : section.title;
    const chunkSize = 4;
    const questionRows = (0, _lodash.chunk)(questions.map((question, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionLinkDefault.default), {
            index,
            section,
            question,
            context,
            sections
        }, question.id)), chunkSize);
    const addDummies = (row)=>{
        const missing = chunkSize - row.length;
        const newRow = missing == 0 ? row : row.concat((0, _lodash.range)(missing).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionLink.QuestionLinkDummy), {}, row.length + index)));
        return newRow;
    };
    const sectionLink = context.link({
        sectionId: section.id,
        questionId: null
    });
    const selected = section.id == context.sectionId && !context.questionId;
    function handleClick(e) {
        selected && e.preventDefault();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: (0, _clsxDefault.default)(classes.title, {
                    selected
                }),
                onClick: handleClick,
                to: sectionLink,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.questions,
                children: questionRows.map((row, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.questionRow,
                        children: addDummies(row)
                    }, index))
            })
        ]
    });
}
function sectionStyles(theme) {
    return {
        title: {
            display: 'flex',
            padding: 10,
            textDecoration: 'none',
            color: '#5c6fcd',
            fontSize: '11pt',
            borderTop: 'solid 1px #e1e5e8',
            borderBottom: 'solid 1px #e1e5e8',
            borderLeft: 'solid 4px #577ee3',
            backgroundColor: '#fff7f3',
            "&.selected": {
                backgroundColor: '#577ee3',
                color: '#fff',
                cursor: 'default'
            }
        },
        questions: {
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 5px'
        },
        questionRow: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: 10
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","./QuestionLink":"NQ0Fi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"NQ0Fi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionLink);
parcelHelpers.export(exports, "QuestionLinkDummy", ()=>QuestionLinkDummy);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _fab = require("@mui/material/Fab");
var _fabDefault = parcelHelpers.interopDefault(_fab);
var _utils = require("./utils");
const useStyles = (0, _material.makeStyles)(linkStyles);
function QuestionLink({ section, sections, context, question, index }) {
    const classes = useStyles();
    const { results = {} } = context.quizAssessmentToReview;
    const result = results[question.id] || {};
    const selected = question.id == context.questionId && section.id == context.sectionId;
    const reviewNeeded = result.pending == true;
    const correct = result.points > 0 && !reviewNeeded;
    const onClick = (e)=>selected && e.preventDefault();
    const className = (0, _clsxDefault.default)(classes.root, {
        selected,
        correct,
        reviewNeeded
    });
    const href = '#' + context.link({
        sectionId: section.id,
        questionId: question.id
    });
    const globalIndex = (0, _utils.findGlobalIndex)(question.id, sections);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fabDefault.default), {
        size: 'small',
        onClick,
        className,
        href,
        children: reviewNeeded ? 'R' : globalIndex + 1
    });
}
function QuestionLinkDummy() {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fabDefault.default), {
        size: "small",
        className: (0, _clsxDefault.default)(classes.root, "dummy"),
        children: "0"
    });
}
function linkStyles(theme) {
    return {
        root: {
            backgroundColor: '#f41822',
            color: '#fff',
            boxShadow: 'none',
            marginRight: 10,
            "& .MuiFab-label": {
                paddingTop: 2
            },
            "&:last-child": {
                marginRight: 0
            },
            "&.dummy": {
                visibility: 'hidden'
            },
            "&.reviewNeeded": {
                border: 'solid 1px #f41822',
                color: '#f41822',
                backgroundColor: '#fff'
            },
            "&.correct": {
                backgroundColor: '#52aa5e',
                color: '#fff'
            },
            "&.selected": {
                backgroundColor: '#000',
                color: '#fff',
                cursor: 'default'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Fab":"9QkHI","./utils":"cVN6n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVN6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findGlobalIndex", ()=>findGlobalIndex);
function findGlobalIndex(id, sections = []) {
    let j = 0;
    for(let i = 0; i < sections.length; i++){
        const section = sections[i];
        const index = section.questions.findIndex((q)=>q.id == id);
        if (index >= 0) return j + index;
        j += section.questions.length;
    }
    return -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38I7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ sections, context }) {
    const { sectionId, translate } = context;
    const classes = useStyles();
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title;
    const instructions = section && ((0, _utils.isEmpty)(section.instructions) ? false : section.instructions);
    const defaultInstructions = translate('default-section-instructions');
    const hasDefaultInstructions = defaultInstructions != 'default-section-instructions';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.title,
                    children: title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    (instructions || hasDefaultInstructions) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.label,
                        children: translate('instructions')
                    }),
                    instructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.instructions,
                        dangerouslySetInnerHTML: {
                            __html: instructions
                        }
                    }),
                    !instructions && hasDefaultInstructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.instructions,
                        children: defaultInstructions
                    })
                ]
            })
        ]
    });
}
function sectionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '13pt',
            padding: '10px 20px',
            borderBottom: 'solid 1px #d0d5d8'
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: '90px 120px',
            display: 'flex',
            flexDirection: 'column'
        },
        label: {
            fontWeight: 'bold',
            fontSize: '12pt',
            marginBottom: 40
        },
        instructions: {
            fontSize: '11pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1oALJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _utils = require("../../../helpers/utils");
var _utils1 = require("./utils");
var _questionHandlers = require("./question-handlers");
var _questionHandlersDefault = parcelHelpers.interopDefault(_questionHandlers);
var _command = require("../../../helpers/command");
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question({ sections, context }) {
    const { questionId, sectionId, translate, quizQuestionTypes, quizAssessmentToReview: assessment } = context;
    const classes = useStyles();
    const assessmentLoaded = !context.quizSearch['assessment-to-review'];
    const { results = {} } = assessment;
    const result = results[questionId] || {};
    const count = sections.reduce((a, b)=>a + b.questions.length, 0);
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const questionIndex = questionId && section ? section.questions.findIndex((q)=>q.id == questionId) : -1;
    const question = questionIndex >= 0 && section.questions[questionIndex];
    const { html } = question && question.premise || {};
    const premiseHtml = (0, _utils.isEmpty)(html) ? false : html;
    const type = quizQuestionTypes.find((t)=>t.id == question.type) || {};
    const title = translate(type.name);
    const globalIndex = (0, _utils1.findGlobalIndex)(question.id, sections);
    const indexLabel = `${translate('questions').substring(0, 1)}: ${globalIndex + 1}/${count}`;
    const Handler = (0, _questionHandlersDefault.default)[type.name];
    const canEditPoints = [
        'fill-in-the-blanks',
        'open-question'
    ].indexOf(type.name) >= 0;
    const changePoints = (points, cleared)=>{
        return context.updateState({
            quizAssessmentToReview: {
                results: {
                    [questionId]: {
                        points: {
                            $set: points
                        },
                        pending: {
                            $set: false
                        },
                        cleared: {
                            $set: cleared
                        }
                    }
                }
            }
        });
    };
    function handlePointsChange(e) {
        const cleared = e.target.value == '';
        const value = cleared ? 0 : parseInt(e.target.value);
        const points = Math.max(0, Math.min(value, result.total));
        changePoints(points, cleared);
    }
    function sendPoints() {
        (0, _command.createPost)('quiz', 'saveReviewResults')({
            id: context.assessment,
            results: context.quizAssessmentToReview.results
        });
    }
    const defaultPremiseLabel = `${type.name}-default-premise`;
    const defaultPremise = translate(defaultPremiseLabel);
    const hasDefaultPremise = defaultPremiseLabel != defaultPremise;
    const displayPoints = result.cleared ? '' : (0, _utils.toDisplayPoints)(result.points);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.index,
                        children: indexLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.pointsSection,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.points,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "label",
                                children: [
                                    translate('points'),
                                    ":"
                                ]
                            }),
                            !canEditPoints && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: "value",
                                children: (0, _utils.toDisplayPoints)(result.points)
                            }),
                            canEditPoints && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textFieldDefault.default), {
                                    className: "pointsInput",
                                    InputProps: {
                                        inputProps: {
                                            min: 0,
                                            max: result.total
                                        }
                                    },
                                    value: displayPoints,
                                    type: "number",
                                    onChange: handlePointsChange,
                                    onBlur: sendPoints
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.value,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                className: "label",
                                children: [
                                    translate('value'),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: "value",
                                children: result.total
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    premiseHtml && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.premise,
                        dangerouslySetInnerHTML: {
                            __html: premiseHtml
                        }
                    }),
                    !premiseHtml && hasDefaultPremise && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.premise,
                        children: defaultPremise
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.question,
                        children: assessmentLoaded && Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                            context,
                            question,
                            section,
                            questionIndex
                        })
                    })
                ]
            })
        ]
    }, question.id);
}
function questionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '12pt',
            padding: '10px 20px',
            borderBottom: 'solid 1px #d0d5d8'
        },
        pointsSection: {
            display: 'flex',
            padding: '15px 20px',
            fontSize: '11pt',
            color: '#485160',
            backgroundColor: '#edf3ff',
            borderBottom: 'solid 1px #bedbe9',
            '& .label': {
                marginRight: 3
            },
            '& > div': {
                display: 'flex',
                '& > div': {
                    ...verticalCentering
                },
                '&:first-child': {
                    flexGrow: 1
                }
            }
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {}
        },
        grant: {
            marginLeft: 20
        },
        points: {
            '& .value': {
                marginLeft: 5,
                minWidth: 40,
                padding: '8px 5px 9px 5px',
                borderRadius: 2,
                backgroundColor: "#cfe1eb"
            },
            '& .pointsInput': {
                marginLeft: 5,
                minWidth: 40,
                backgroundColor: '#fff',
                borderRadius: 3,
                '& .MuiInput-underline:after': {
                    borderBottom: 0,
                    transition: 'none'
                },
                '& .MuiInput-underline:before': {
                    borderBottom: 0,
                    transition: 'none'
                }
            }
        },
        question: {
            display: 'flex',
            flexGrow: 1
        },
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        index: {
            fontSize: '10pt',
            ...verticalCentering
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 30,
            display: 'flex',
            flexDirection: 'column'
        },
        premise: {
            fontWeight: 'bold',
            fontSize: '12pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextField":"amnzu","../../../helpers/utils":"gGc98","./utils":"cVN6n","./question-handlers":"2ji5B","../../../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ji5B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trueOrFalse = require("./TrueOrFalse");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _fillInTheBlanks = require("./FillInTheBlanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _openQuestion = require("./OpenQuestion");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _multipleChoice = require("./MultipleChoice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _matching = require("./Matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'matching': (0, _matchingDefault.default)
};
exports.default = handlers;

},{"./TrueOrFalse":"eWnjD","./FillInTheBlanks":"15iz7","./OpenQuestion":"lrVii","./MultipleChoice":"3ex3h","./Matching":"12xBd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eWnjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(trueOrFalseStyles);
function TrueOrFalse({ context, section, question, questionIndex }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate, questionId } = context;
    const { answers = {} } = assessment;
    const answer = answers[questionId] || {};
    const correct = question.answer.value == answer.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
            className: "content",
            value: answer.value,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: true,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: true,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('true')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: false,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: false,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('false')
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function trueOrFalseStyles(theme) {
    return {
        root: {},
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/Fade":"8DwqP","@mui/material/FormControlLabel":"kemIW","../StatusIcon":"i3Fd8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i3Fd8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(statusIconStyles);
function StatusIcon({ value, answer, correctAnswer }) {
    const classes = useStyles();
    function getStatus() {
        if (value != correctAnswer && value == answer) return 'incorrect';
        if (value == correctAnswer && value == answer) return 'correct';
        if (value == correctAnswer && value != answer) return 'mark';
        return 'dummy';
    }
    const status = getStatus();
    const icon = {
        incorrect: (0, _freeSolidSvgIcons.faTimesCircle),
        correct: (0, _freeSolidSvgIcons.faCheckCircle),
        mark: (0, _freeSolidSvgIcons.faArrowAltCircleRight),
        dummy: (0, _freeSolidSvgIcons.faTimesCircle)
    }[status];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, status),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            icon: icon
        })
    });
}
function statusIconStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: "#fff",
            marginRight: 20,
            fontSize: '20px',
            '&.dummy': {
                visibility: 'hidden'
            },
            '&.mark': {
                '& svg': {
                    color: '#18d0da'
                }
            },
            '&.incorrect': {
                '& svg': {
                    color: '#dd2229'
                }
            },
            '&.correct': {
                '& svg': {
                    color: '#39c55a'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"15iz7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanks);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(fillInTheBlanksStyles);
function FillInTheBlanks({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate, questionId } = context;
    const { answers = {} } = assessment;
    const answer = answers[questionId] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.wrapper,
                    children: answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.phrase, {
                                blanked
                            }),
                            children: phrase
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.wrapper,
                        children: question.answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.phrase, {
                                    blanked
                                }),
                                children: phrase
                            }, index))
                    })
                ]
            })
        ]
    });
}
function fillInTheBlanksStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            padding: '35px 0',
            fontSize: '12pt',
            "& .label": {
                display: "flex",
                marginBottom: 10,
                fontWeight: 'bold',
                '& > div': {
                    ...verticalCentering
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        correctAnswer: {
            marginTop: 30
        },
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        phrase: {
            ...verticalCentering,
            marginRight: 10,
            '&:last-child': {
                marginLeft: 0
            },
            '&.blanked': {
                borderBottom: 'solid 1px black'
            }
        },
        input: {
            border: 'none',
            borderBottom: 'solid 1px black'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lrVii":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _utils = require("../../../../helpers/utils");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(openQuestionStyles);
function OpenQuestion({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate, questionId } = context;
    const expected = (0, _utils.htmlToText)(question.answer.html);
    const { answers = {} } = assessment;
    const answer = answers[questionId] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                    className: classes.textarea,
                    maxRows: 5,
                    minRows: 5,
                    value: answer.value,
                    readOnly: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                        className: classes.textarea,
                        maxRows: 5,
                        minRows: 5,
                        value: expected,
                        readOnly: true
                    })
                ]
            })
        ]
    });
}
function openQuestionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                '&:last-child': {
                    marginTop: 20
                },
                '& .label': {
                    display: "flex",
                    marginBottom: 10,
                    fontWeight: 'bold',
                    '& > div': {
                        ...verticalCentering
                    }
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        textarea: {
            resize: 'none',
            width: 'auto',
            padding: 8,
            flexGrow: 1,
            borderRadius: '4px',
            border: 'solid 1px #c2c7ca'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","../../../../helpers/utils":"gGc98","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ex3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(multipleChoiceStyles);
function MultipleChoice({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate, questionId } = context;
    const { properties: { singleOption } } = question;
    const { choices = [] } = question.answer;
    const Choices = singleOption ? RadioChoice : CheckboxChoice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
            question: question,
            context: context,
            choices: choices,
            answer: assessment.answers[questionId] || {}
        })
    });
}
function RadioChoice(props) {
    const { context, choices, answer } = props;
    const classes = useStyles();
    const correctChoice = choices.find((c)=>c.correct) || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: answer.selected,
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: choice.id,
                        answer: answer.selected,
                        correctAnswer: correctChoice.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: choice.id,
                            className: "choice",
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                color: "primary"
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: choice.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function CheckboxChoice({ context, question, choices, answer }) {
    const classes = useStyles();
    const { assessment } = context;
    const correct = (0, _lodash.difference)(choices.filter((c)=>c.correct).map((c)=>c.id), answer.selectedOptions).length == 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: choices.map((option, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            const checked = answer.selectedOptions.indexOf(option.id) >= 0;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: option.id,
                        answer: checked && option.id,
                        correctAnswer: option.correct && option.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.checkbox,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                color: "primary",
                                checked: checked
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: option.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function multipleChoiceStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            paddingLeft: 10,
            fontSize: '12pt'
        },
        index: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 6
        },
        incorrect: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            visibility: 'hidden',
            color: "#fff",
            marginRight: 10,
            '& svg': {
                fill: '#f30d2a'
            },
            '&.visible': {
                visibility: 'visible'
            }
        },
        correct: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '& svg': {
                fill: '#27bc58'
            },
            marginRight: 10,
            visibility: 'hidden',
            '&.visible': {
                visibility: 'visible'
            }
        },
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@mui/material/FormGroup":"1gJha","@mui/material/Checkbox":"4sdMA","../StatusIcon":"i3Fd8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"12xBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Matching);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(matchingStyles);
function Matching({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate, questionId } = context;
    const { answers = {} } = assessment;
    const answer = answers[questionId] || {
        terms: [],
        definitions: []
    };
    const terms = answer.terms.map((term, index)=>{
        const value = answer.selected[index];
        const correctIndex = answer.definitions.findIndex((d)=>d.index == term.index);
        const indexToLetter = (index)=>String.fromCharCode(Math.min(index, 20) + 97);
        const answerIndex = indexToLetter(correctIndex);
        const correct = correctIndex == value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.correctAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.correct, {
                            correct
                        }),
                        children: answerIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.status),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: value,
                        answer: value,
                        correctAnswer: correctIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.selectAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.answer,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                            className: classes.termValue,
                            inputProps: {
                                readOnly: true
                            },
                            value: value,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: value,
                                children: value >= 0 ? indexToLetter(value) : ''
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    dangerouslySetInnerHTML: {
                        __html: term.term || ''
                    }
                })
            ]
        });
    });
    const definitions = answer.definitions.map(({ definition }, index)=>{
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionIndex, {
                        selected: answer.selected.indexOf(index) > -1
                    }),
                    size: "small",
                    children: [
                        answerIndex,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    dangerouslySetInnerHTML: {
                        __html: definition || ''
                    }
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _boxDefault.default),
            className: classes.tableContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                className: classes.table,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: (0, _lodash.zip)(terms, definitions).map(([term, definition], index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            className: classes.pair,
                            children: [
                                term,
                                definition
                            ]
                        }, index);
                    })
                })
            })
        })
    });
}
function matchingStyles(theme) {
    return {
        root: {
            display: 'flex',
            marginTop: 10,
            flexGrow: 1
        },
        tableContainer: {
            flexShrink: 0,
            maxWidth: 1280,
            display: 'flex',
            fontSize: '12pt'
        },
        correct: {
            display: 'flex',
            width: 35,
            height: 35,
            borderRadius: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            color: '#fff',
            backgroundColor: '#0bccd5',
            '&.correct': {
                visibility: 'hidden'
            }
        },
        cell: {
            borderBottom: 0,
            padding: '16px 8px',
            verticalAlign: 'top'
        },
        correctAnswer: {
            width: 35,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 35
        },
        status: {
            width: 30,
            maxWidth: 30,
            flexGrow: 0,
            flexShrink: 0,
            paddingTop: 22
        },
        selectAnswer: {
            width: 45,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 45
        },
        definitionIndex: {
            width: 20,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 20
        },
        table: {
            maxWidth: 1280
        },
        term: {
            display: 'flex'
        },
        termValue: {
            borderRadius: 3,
            paddingLeft: 8,
            justifyContent: 'center',
            '&:focus': {
                backgroundColor: 'transparent'
            },
            '&:before': {
                borderBottom: '0 !important'
            },
            '&:after': {
                borderBottom: 0
            }
        },
        termHtml: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        },
        definitionValue: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableRow":"4f4VX","@mui/material/Table":"if4Vw","@mui/material/Select":"aY7hn","../StatusIcon":"i3Fd8","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8cJHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewPdf);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _html2PdfJs = require("html2pdf.js");
var _html2PdfJsDefault = parcelHelpers.interopDefault(_html2PdfJs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _dialogActions = require("@mui/material/DialogActions");
var _dialogActionsDefault = parcelHelpers.interopDefault(_dialogActions);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _material = require("external/material");
var _preview = require("./Preview");
var _previewDefault = parcelHelpers.interopDefault(_preview);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _pictureAsPdf = require("@mui/icons-material/PictureAsPdf");
var _pictureAsPdfDefault = parcelHelpers.interopDefault(_pictureAsPdf);
var _useMediaQuery = require("@mui/material/useMediaQuery");
var _useMediaQueryDefault = parcelHelpers.interopDefault(_useMediaQuery);
var _latinise = require("helpers/latinise");
const useStyles = (0, _material.makeStyles)(previewStyles);
const useTitleStyles = (0, _material.makeStyles)(titleStyles);
const useDialogStyles = (0, _material.makeStyles)(dialogStyles);
function PreviewPdf({ context }) {
    const [saving, setSaving] = (0, _reactDefault.default).useState(false);
    const theme = (0, _material.useTheme)();
    const contentRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    const fullScreen = (0, _useMediaQueryDefault.default)(theme.breakpoints.down('md'));
    const { translate, updateState, quizAssessmentForPdfId: assessmentId, quizAssessmentForPdf: assessment } = context;
    const title = assessment.content && assessment.content.title || translate('assessment');
    const classes = useStyles();
    const titleClasses = useTitleStyles();
    const dialogClasses = useDialogStyles();
    const isOpen = assessmentId != undefined && assessment.id != undefined && assessmentId == assessment.id;
    function close() {
        updateState({
            quizAssessmentForPdf: {
                $set: {}
            },
            quizAssessmentForPdfId: {
                $set: undefined
            }
        });
    }
    async function savePdf() {
        if (!contentRef.current) return;
        if (saving) return;
        const filename = `${title}-${assessment.studentName}.pdf`;
        setSaving(true);
        const document = (0, _html2PdfJsDefault.default)().from(contentRef.current).set({
            image: {
                type: 'png'
            },
            margin: 0.8,
            jsPDF: {
                unit: 'in',
                format: 'letter',
                orientation: 'portrait'
            },
            pagebreak: {
                mode: [
                    'css',
                    'avoid-all'
                ]
            }
        }).toPdf().get('pdf').then(processPdf).save((0, _latinise.latinise)(filename).replace(' ', '_'));
        setSaving(false);
    }
    function processPdf(pdf) {
        const totalPages = pdf.internal.getNumberOfPages();
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        const addText = (text, x, y, align = 'left', size = 10, color = '#ccc')=>{
            pdf.setFontSize(size);
            pdf.setTextColor(color);
            pdf.text(text, x, y, {
                align: 'right'
            });
        };
        for(let i = 1; i <= totalPages; i++){
            pdf.setPage(i);
            addText(`${title} - ${assessment.studentName}`, width - 0.5, 0.5, 'right', 11, '#000');
            addText(`${i} / ${totalPages}`, width - 0.5, height - 0.5, 'right');
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
        fullScreen: fullScreen,
        open: isOpen,
        onClose: (e)=>close(),
        classes: dialogClasses,
        "aria-labelledby": "assessment-pdf-dialog-title",
        maxWidth: "lg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                id: "assessment-pdf-dialog-title",
                classes: titleClasses,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.title,
                        children: [
                            title,
                            " - ",
                            assessment.studentName
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.close,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                            onClick: close,
                            size: "large",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogContentDefault.default), {
                className: classes.contentWrapper,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.content,
                    ref: contentRef,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewDefault.default), {
                        assessment,
                        context
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dialogActionsDefault.default), {
                className: classes.actions,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    onClick: savePdf,
                    className: (0, _clsxDefault.default)(classes.button, classes.save),
                    disabled: saving,
                    children: [
                        !saving && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pictureAsPdfDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "label",
                                    children: translate('download')
                                })
                            ]
                        }),
                        saving && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: "icon",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FontAwesomeIcon, {
                                icon: faSpinner,
                                spin: true
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function dialogStyles(theme) {
    return {
        paper: {
            width: '100%',
            padding: 0,
            height: 'calc(100% - 100px)'
        }
    };
}
function titleStyles(theme) {
    return {
        root: {
            display: 'flex',
            padding: '10px 10px 10px 24px',
            fontSize: '14pt',
            fontWeight: 'bold',
            borderBottom: 'solid 1px #f3f3f3',
            color: '#525b6c',
            background: '#fdfdfd'
        }
    };
}
function previewStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        close: {
            ...verticalCentering,
            color: '#69738',
            padding: 0,
            "& svg": {
                fontSize: '14pt'
            }
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {},
            '& .icon': {
                marginTop: -1,
                marginRight: 4,
                fontSize: '8pt'
            }
        },
        contentWrapper: {
            marginTop: 5
        },
        content: {
            display: 'flex'
        },
        actions: {
            padding: 24
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","moment":"1e4qG","html2pdf.js":"27lym","react":"9njXz","@mui/material/Button":"c6Y0y","@mui/material/Dialog":"255tO","@mui/material/DialogTitle":"5sOv1","@mui/material/DialogActions":"5WZHz","@mui/material/DialogContent":"gD0J9","external/material":"6yEDE","./Preview":"8Y0Gf","@mui/material/Box":"73kto","@mui/material/IconButton":"bXjnZ","@mui/icons-material/Close":"acjz6","@mui/icons-material/PictureAsPdf":"as9ed","@mui/material/useMediaQuery":"bnRpi","helpers/latinise":"1YzXG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Y0Gf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewResultsAssessment);
parcelHelpers.export(exports, "assessmentStyles", ()=>assessmentStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _utils = require("../../../helpers/utils");
var _section = require("./Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
const useStyles = (0, _material.makeStyles)(assessmentStyles);
function PreviewResultsAssessment({ assessment, context }) {
    const classes = useStyles();
    const { assessmentId } = assessment;
    const { translate, link, quizTypesMap } = context;
    const { content = {}, results = {}, studentName = '', properties = {} } = assessment;
    const { title, type } = content;
    const assessmentLoaded = !context.quizSearch['assessment-results'];
    const typeName = translate(quizTypesMap[type]);
    const orderedSections = assessment.assessmentId == assessmentId ? (0, _lodash.orderBy)(Object.values(content.sections || {}), 'index') : [];
    const sections = orderedSections.reduce((sections, section)=>{
        const last = sections.length > 0 ? sections[sections.length - 1] : {
            sectionEnds: -1
        };
        const sectionStarts = last.sectionEnds + 1;
        const sectionEnds = sectionStarts + section.questions.length;
        sections.push({
            ...section,
            sectionStarts,
            sectionEnds
        });
        return sections;
    }, []);
    const { points, total } = Object.values(results).reduce((acc, { points, total })=>({
            total: acc.total + total,
            points: acc.points + points
        }), {
        total: 0,
        points: 0
    });
    const percentageText = `${Math.round(points / total * 100)}%`;
    const pointsText = `${translate('points')}: ${(0, _utils.toDisplayPoints)(points + (properties.bonus || 0))} ${translate('of')} ${(0, _utils.toDisplayPoints)(total)}`;
    return(// <Fade in={assessmentLoaded}>
    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.pointsWrapper,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.percentage,
                            children: percentageText
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.points,
                            children: pointsText
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.preview,
                children: sections.map((section, sectionIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDefault.default), {
                        context,
                        assessment,
                        section,
                        sectionIndex,
                        sections
                    }, section.id))
            })
        ]
    }));
}
function assessmentStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        header: {
            padding: '10px 20px 10px 10px',
            display: 'flex',
            flexDirection: 'column',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start'
            }
        },
        pointsWrapper: {
            flexGrow: 1
        },
        label: {
            color: '#4d5361',
            fontSize: '13pt',
            fontWeight: 'bold'
        },
        percentage: {
            marginTop: 5,
            fontSize: '50pt',
            color: '#df7317'
        },
        points: {
            color: '#4d5361',
            fontSize: '10pt'
        },
        notice: {
            color: '#4d5361',
            fontSize: '10pt'
        },
        filler: {
            flexGrow: 1
        },
        preview: {
            display: 'flex',
            flexDirection: 'column',
            padding: 10,
            flexGrow: 1,
            overflowY: 'auto'
        },
        question: {
            marginTop: 20,
            border: 'solid 1px #ccc',
            borderRadius: 2,
            backgroundColor: '#fff',
            '&:first-child': {
                marginTop: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","../../../helpers/utils":"gGc98","./Section":"1cYGK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cYGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
var _question = require("./Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ assessment, sections, section, sectionIndex, context }) {
    const classes = useStyles();
    const { translate } = context;
    const questions = section.questions.map((q)=>({
            ...q,
            sectionId: section.id
        }));
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title;
    const instructions = section && ((0, _utils.isEmpty)(section.instructions) ? false : section.instructions);
    const defaultInstructions = translate('default-section-instructions');
    const hasDefaultInstructions = defaultInstructions != 'default-section-instructions';
    const hasInstructions = instructions != false || hasDefaultInstructions;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.root,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.header,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.title,
                            children: title
                        })
                    }),
                    hasInstructions && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.instructionsWrapper,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.label,
                                children: translate('instructions')
                            }),
                            instructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: classes.instructions,
                                dangerouslySetInnerHTML: {
                                    __html: instructions
                                }
                            }),
                            !instructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.instructions,
                                children: defaultInstructions
                            })
                        ]
                    })
                ]
            }),
            questions.map((question, questionIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.question,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                        assessment,
                        context,
                        section,
                        sections,
                        question,
                        questionIndex
                    })
                }, question.id))
        ]
    });
}
function sectionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '12pt',
            padding: '10px 20px',
            backgroundColor: '#2c75bd',
            border: 'solid 1px #2c75bd',
            borderBottom: 0,
            color: '#fff'
        },
        label: {
            marginBottom: 10
        },
        instructionsWrapper: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 30,
            border: 'solid 1px #d0d5d8'
        },
        instructions: {
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","./Question":"cBfeR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cBfeR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _utils = require("../../../helpers/utils");
var _questionHandlers = require("./question-handlers");
var _questionHandlersDefault = parcelHelpers.interopDefault(_questionHandlers);
var _command = require("../../../helpers/command");
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question({ assessment, question, section, sections, context, questionIndex }) {
    const { id: questionId, sectionId } = question;
    const { translate, quizQuestionTypes } = context;
    const classes = useStyles();
    const assessmentLoaded = !context.quizSearch['assessment-results'];
    const { results = {} } = assessment;
    const result = results[questionId] || {};
    const globalIndex = section.sectionStarts + questionIndex;
    const count = sections.reduce((a, b)=>a + b.questions.length, 0);
    const { html } = question && question.premise || {};
    const premiseHtml = (0, _utils.isEmpty)(html) ? false : html;
    const type = quizQuestionTypes.find((t)=>t.id == question.type) || {};
    const title = translate(type.name);
    const indexLabel = `${translate('questions').substring(0, 1)}: ${globalIndex + 1}/${count}`;
    const Handler = (0, _questionHandlersDefault.default)[type.name];
    const defaultPremiseLabel = `${type.name}-default-premise`;
    const defaultPremise = translate(defaultPremiseLabel);
    const hasDefaultPremise = defaultPremiseLabel != defaultPremise;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.index,
                        children: indexLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    premiseHtml && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.premise,
                        dangerouslySetInnerHTML: {
                            __html: premiseHtml
                        }
                    }),
                    !premiseHtml && hasDefaultPremise && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.premise,
                        children: defaultPremise
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.question,
                        children: assessmentLoaded && Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                            assessment,
                            context,
                            question,
                            section,
                            questionIndex
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.pointsSection,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.points,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: "label",
                            children: [
                                translate('points'),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: "value",
                            children: [
                                (0, _utils.toDisplayPoints)(result.points),
                                " ",
                                translate('of'),
                                " ",
                                result.total
                            ]
                        })
                    ]
                })
            })
        ]
    }, question.id);
}
function questionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            marginTop: 20,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c',
            borderLeft: 'solid 1px #d0d5d8',
            borderRight: 'solid 1px #d0d5d8'
        },
        header: {
            display: 'flex',
            fontSize: '12pt',
            padding: '10px 20px',
            borderTop: 'solid 1px #d0d5d8',
            borderBottom: 'solid 1px #d0d5d8'
        },
        pointsSection: {
            display: 'flex',
            padding: '10px 20px',
            fontSize: '11pt',
            color: '#485160',
            backgroundColor: '#edf3ff',
            borderBottom: 'solid 1px #bedbe9',
            '& .label': {
                marginRight: 3
            },
            '& > div': {
                display: 'flex',
                '& > div': {
                    ...verticalCentering
                },
                '&:first-child': {
                    flexGrow: 1
                }
            }
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {}
        },
        grant: {
            marginLeft: 20
        },
        points: {},
        question: {
            display: 'flex',
            flexGrow: 1
        },
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        index: {
            fontSize: '10pt',
            ...verticalCentering
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 30,
            display: 'flex',
            flexDirection: 'column'
        },
        premise: {
            fontWeight: 'bold',
            fontSize: '12pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextField":"amnzu","../../../helpers/utils":"gGc98","./question-handlers":"5FPjG","../../../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5FPjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trueOrFalse = require("./TrueOrFalse");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _fillInTheBlanks = require("./FillInTheBlanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _openQuestion = require("./OpenQuestion");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _multipleChoice = require("./MultipleChoice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _matching = require("./Matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'matching': (0, _matchingDefault.default)
};
exports.default = handlers;

},{"./TrueOrFalse":"83MmP","./FillInTheBlanks":"gtUP0","./OpenQuestion":"lu7xu","./MultipleChoice":"5x1xx","./Matching":"8lPNP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"83MmP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("../Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(trueOrFalseStyles);
function TrueOrFalse(props) {
    const { assessment, context, section, question, questionIndex } = props;
    const classes = useStyles();
    const { translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    const correct = question.answer.value == answer.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
            className: "content",
            value: answer.value,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: true,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: true,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                    checked: true === answer.value
                                }),
                                label: translate('true')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: false,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: false,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                    checked: false === answer.value
                                }),
                                label: translate('false')
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function trueOrFalseStyles(theme) {
    return {
        root: {},
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../Radio":"coZ52","@mui/material/RadioGroup":"9W1hX","@mui/material/Fade":"8DwqP","@mui/material/FormControlLabel":"kemIW","../StatusIcon":"amAL7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"coZ52":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Radio);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
const filled = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBMEKngL/84AAALtSURBVEjH3ZXLT1NREIe/uaWNFlxJMFFjjHGHCUZxa/GBiVDSFlP/ADU+V2LwvejGFxrcuEAj/0AxfSCtC420LEFdaIgLJfEVNSgrrEbKvePi3tsmFmh1p5Pc5GTO78x3MjN3DvzrJkttNkfjvpVmQ0RUQ8AWhLUAKB+AZ6qkZryF1OTQ/rk/BuwIZ/ZZQh+wocolpxCrN5/oStYEiEbjni9F/zUVOeW4Xqgy6PF4Hnln5Q1AcYWuN01ztwiHgE2O7nq+ZeIssZi1JKAtPHLDCf4TlZP5zeO3fz9UsljMCDxvPYrKTcCH0JdPdJ5ZFOCk5R7wE9G9+URwtJZCbo9kdwr6APCJSiSX6khVAJqjcV/jfP1LYIPAsVyyc8DdC4SyXRj0ILrNLrJMYNGfT3fcL0MyJwRuIfr6q+d7s1t4wxWsNBsiTkFf5Fom7pSCd2cuY+gwaBtKPUo9aBuGDgciI5dc3aq6wgDoJCobG+f9IddfAogSdpZ33ZwHQtkulHNLdPn5tkgmCDA0tN8EGXTSUgkA3QJgWfKI8m5PtfwrZY2gD22ftC4EWA3g8S1/V/ZZrTXUuKQpmuZbJ9aaBQB/beou5otep2nEWgAgHwHMuR/ryj7jSQ2Akmb5Mss9+6kSoLZQRNvLGaK/WnRDtL8cQvY4i/EKgELaBnAoGo17AOw+18uLDzK5NJoIZtwRA3oAQAwZrgDMeAspYArYNG36j7j+fDJ4QaALGAX9Zn88NkSDuWTHRVc3bfqPgzQDr2Ybm9ILjopA9/0IaiSAOUX2jiU7HtdS5R3hB7sssbKAV0XDY4ng8KLDLhDJ9AG9NoSeVXWFAfsnqrRoNO6ZNv3HUbkB+BSujiU7zy39HsRiRuD5tisop53qTIIMCvqQuvo3dj8W1ivSDnrQSYsK0pdrGT9fdVyXx3Y2rIZ1HZWNVTL0yoDe0WRn+o+fzK2Hn3gbvnwOC4QU2Qq61jn2HngqIunZxqb00zutRf5b+wV5ISBgnOIuJAAAAABJRU5ErkJggg==" style="width: 24px;">';
const empty = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBMCCPsxGawAAAGOSURBVEjH3dU9TxRRFMbxn6zaghIjCTYSMSaLUWPEl8IPIIbKgi/nJ7DTaCylEikNa4MWRDQI6EosTIywNM8ks+uwu8za6E02Z+Zu7vnfec65z+VfHycG/N/AHJqYxnjm9/AJLaxhvw7gKhZwdsAmvuJ5QEMBxvAA9/O+hVWso525M5jFPKYyt4wX6AwCPEzy33iGld5FPevvYDFyvgqkS+NeWRaT/DHeDlHHTWzgOmbwGTtlOcqwhTw/xYdjNMv7fG2hQKMKMJeCbuFNjY5cwRdMpuv+ABSTq3007zcOstZRgOnE9RHOVbH2QhWgOETtEQDtnlxdgL/pDAdVgL3SIao7JhJ/VAE2E2dHAFxO/FgFeJc4X1O6MdzKc6sKsBbjmsLtGoC7OI/d0ma7rKKTOlzLp27g25DJL2EpRX6C7aO8aBuncTHe8jO+3+kjy70kL8zudT+zK3zlVIzrSgzwJH7l18A53MAj3MzOl/HyOBdOM8Y1OUCe3Vw4rbpXZrN0ZRZ9/j1t3UpB9/234xCyrVCqDls8ZwAAAABJRU5ErkJggg==" style="width: 24px;">';
const useStyles = (0, _material.makeStyles)(radioStyles);
function Radio(props) {
    const classes = useStyles();
    const icon = props.checked ? filled : empty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        dangerouslySetInnerHTML: {
            __html: icon
        }
    });
}
function radioStyles(theme) {
    return {
        root: {
            padding: 9
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"amAL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "markIcon", ()=>markIcon);
parcelHelpers.export(exports, "correctIcon", ()=>correctIcon);
parcelHelpers.export(exports, "incorrectIcon", ()=>incorrectIcon);
parcelHelpers.export(exports, "filledCheckboxIcon", ()=>filledCheckboxIcon);
parcelHelpers.export(exports, "default", ()=>StatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const markIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxQ+qDnYo4pChOlkoVcRRq1CECqFWaNXB5NIvaNKQpLg4Cq4FBz8Wqw4uzro6uAqC4AeIk6OToouU+L+k0CLWg+N+vLv3uHsHCPUy06yuKKDptplKxMVMdlXseUUfQhhEFDGZWcacJCXRcXzdw8fXuwjP6nzuzzGg5iwG+ETiWWaYNvEG8fSmbXDeJw6yoqwSnxNPmHRB4keuKx6/cS64LPDMoJlOzRMHicVCGyttzIqmRjxFHFY1nfKFjMcq5y3OWrnKmvfkLwzk9JVlrtMcRQKLWIIEEQqqKKEMGxFadVIspGg/3sE/4volcinkKoGRYwEVaJBdP/gf/O7Wyk/GvKRAHOh+cZyPMaBnF2jUHOf72HEaJ4D/GbjSW/5KHZj5JL3W0sJHwNA2cHHd0pQ94HIHCD0Zsim7kp+mkM8D72f0TVlg+BboX/N6a+7j9AFIU1fJG+DgEBgvUPZ6h3f3tvf275lmfz/UXHLOH5AJxAAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGA42Fq7q5xsAAAIqSURBVDjLrZTNTlNRFIW/fe6FIsEBURBKAiEISKptwSoD40BjIo6Y6Uv4ALyBOJWn0KEjCOjEmNgE5M8GkUlrpFD8AQIVbrk92wkglFsqxDU6uTvnu2eftfYRyqghlapz/OoBrPYjegUAkVWBpGVnNBeL5YP2SemH1rlMfcF6Q8BToLbM/34DIzVaNZzubd8oC2yc/xw1RXkN0sY/SGHZGDO4Er06dQLYMv0lXhTeAXWcTVvW6t21vu7ZQ2DrXKa+oN4MSivnkmY8342tJzo2DUDBekMVYVYiwHRwUdpqXH8IQBpSqTpnryp3igEArMa7pCW5cMkPORMC8SCjVHYajVOoflQJdqDl/p6fIRO6D0wFlGuNXnjoYvQWeqKFJ2r1VxD0a7RtPTy5OGAdeYMQLXH9tquqzVISx9V456vTTppNdP9o+rj0QETfK3QeQYYN/1muiKyUttw0s/S4tOVcX9fEwTo8uXjZik4cPx2AZF2BpJ7M1UsxwWO6P5qjcPz+AIzqB+O7e2P7s1lRLcmFS5713gI3A8r5otkdN98jkW1gpBKsaWYpUgw542UyiKi8yMVieQNQo1XDoJkK4/UJ6C1TTO8WzXMAA5Dubd+wlkFg6xzGblnHDq4nOjYPgQBrfd2zaop3gPQZYN/EmHtrN67NHRpzLBrRnnnPd+KCDgP5U0B5UXnm+c71o29h4Iv9N2vZWnW3BxT6QZsPciZoUvyLY9lEODAZfwDi89ZoyG6fUQAAAABJRU5ErkJggg==" style="width: 20px;" />';
const correctIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxQ+qDnYo4pChOlkoVcRRq1CECqFWaNXB5NIvaNKQpLg4Cq4FBz8Wqw4uzro6uAqC4AeIk6OToouU+L+k0CLWg+N+vLv3uHsHCPUy06yuKKDptplKxMVMdlXseUUfQhhEFDGZWcacJCXRcXzdw8fXuwjP6nzuzzGg5iwG+ETiWWaYNvEG8fSmbXDeJw6yoqwSnxNPmHRB4keuKx6/cS64LPDMoJlOzRMHicVCGyttzIqmRjxFHFY1nfKFjMcq5y3OWrnKmvfkLwzk9JVlrtMcRQKLWIIEEQqqKKEMGxFadVIspGg/3sE/4volcinkKoGRYwEVaJBdP/gf/O7Wyk/GvKRAHOh+cZyPMaBnF2jUHOf72HEaJ4D/GbjSW/5KHZj5JL3W0sJHwNA2cHHd0pQ94HIHCD0Zsim7kp+mkM8D72f0TVlg+BboX/N6a+7j9AFIU1fJG+DgEBgvUPZ6h3f3tvf275lmfz/UXHLOH5AJxAAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGA44Hj6yQqcAAAIzSURBVDjLpZQ9TJNRFIaf833w1fCTyKLBQeKgkxESSFpKG2k0gJOJhqHVGBKNLu7i4s8kq2EzUUnAYoKTk+gASQHbaCPUTWKC8T86SGgJfKX3OEgrlFKovts9yXnuzT3veYVt1DnRW+c6To+qehH2AyDyTdQk0umqZ6nu4UypPikuBGKRBmNpvyJXgZpt7ltWGNzjOgOToaFf2wK98fAxKydPgSZ2Jf1sjJxOBKPJLUD/dKRFIQbUUZmWbGMFp4IjcwVgIBZpyFnMAgf5N31wPdnmZNvYogWQs+X6f8AAmpwVpx9AOid661ad6u9lBlBK743NKTvHOYWb+UFl0vY+y3WquiuFra2ZUMIXnZ/piN4C5tfrNbX1pstSsbyVwl4df/wRoH0qfAM4XJi5qtdSpXGTEeChUe0S+LkjTOR2kQcPWMVNcf+RS4nA6IucrSeAH7uF5WWJ8HXD+ZBv5t0FgIRvNGVsPakQN7Z07gam8EX80+GzijzZUDcKF+Md0aHihnKw9V0/Yznu2jiwvOnVcN83HemrCKZkMkvWc2syNJZWGNzyFfCgfSZ8ZX0tr5WFASLcTXUPZ+RPVPXtXXXc2RKhYER4o0rrDnZacD3ZlmTb2KL8ja3zzTnLxID6SsPB2BpI+EZTAAXbTAVH5hDpABYqgH0yhlAetgkI8NL/6K3rybagMoCSKTcARO+4nuzRjVlYMrHzan19uaZ6Jd1jiXoVaSz4TCThOrXjybZ7y6X6fgNKDPQHUNzxMQAAAABJRU5ErkJggg==" style="width: 20px;" />';
const incorrectIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TxQ+qDnYo4pChOlkoVcRRq1CECqFWaNXB5NIvaNKQpLg4Cq4FBz8Wqw4uzro6uAqC4AeIk6OToouU+L+k0CLWg+N+vLv3uHsHCPUy06yuKKDptplKxMVMdlXseUUfQhhEFDGZWcacJCXRcXzdw8fXuwjP6nzuzzGg5iwG+ETiWWaYNvEG8fSmbXDeJw6yoqwSnxNPmHRB4keuKx6/cS64LPDMoJlOzRMHicVCGyttzIqmRjxFHFY1nfKFjMcq5y3OWrnKmvfkLwzk9JVlrtMcRQKLWIIEEQqqKKEMGxFadVIspGg/3sE/4volcinkKoGRYwEVaJBdP/gf/O7Wyk/GvKRAHOh+cZyPMaBnF2jUHOf72HEaJ4D/GbjSW/5KHZj5JL3W0sJHwNA2cHHd0pQ94HIHCD0Zsim7kp+mkM8D72f0TVlg+BboX/N6a+7j9AFIU1fJG+DgEBgvUPZ6h3f3tvf275lmfz/UXHLOH5AJxAAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGA45GM7K1tMAAAJFSURBVDjLnZS9TxRhEMZ/8wp4HFdo48cVILsk3nl+XLS4wljYKB1BEgNGG2obtZD4D0AjFPa0RBMxsRJbqyvAEwOeCbtAoiAdBO7O42PHYvfIuncQ4KnezMz7vO/MMzPCAZjLZBKtZbo9s5cDOQ9gPP6oaL6t1PLpwtpsqdE9iRqW26+d3W3aHQKeAvED3isDb4x3eqRzqbB+IKHbefm6ivkIdHA0/FbRni6nOF1HuHgpk/WM9wVIcDxsipo71uLct33CIM0C0M7JsAzVG7brbhiAoGYRMhkFeQxsh4w7ovIEGIsQdkBsCEDmMplErOKt/S+AjNru/AuABTvdK8pb3679tlucBHCsK69Bn4eFais1nzOxyt79qJqifK2du5wfH0AHQAdqZAFmIr+MbyV27jWJSk4jzaOi446VKtcIbLf4PuxfsNO9qI7X9aCSMyqabFDkZpB3jpV6FHU4VqovKEFL1KdC0oDoIerpcaQ2HmpEWW3g2wF9aLvFiajDT1/7/Zi6H64aFc3X10IGwwI4VqrPsVJ9IdJJURlsQJg3f1tPTQWzGRblZojsAcgEyMSCne5tFBOglNhq/iz+pfQI8DISMCYqMyo67ou039iDAdmzSF7Dtjv/Svw5zp7xTLVwjKUQxRJUs/uj17lUWBc1PcDmCcg2Rb0e23U3AEzN6m8Lve2/dlToLxW9ay3+nN1vnUhLfIdqFmQEKB3CVAIZhu2r4V3YcGPXsJK8Fa/ESt0gORUuBqO1okI+XolPJVemy43u/QMsPOw9IHq1qgAAAABJRU5ErkJggg==" style="width: 20px;"/>';
const filledCheckboxIcon = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBImMs0XS48AAAETSURBVEjH7ZU9bsIwGIbfz8oA7LCUnqESB0BhzRYqMSChqkuuABsZuQKdqVTJA11I1vQMVU8AezbEAPmYIhIhJ46Tbryb/VnP4z/ZwCMloWxj+Bo6lCQfAJ4MeQcweT/fTph2iJwtSdY14ADQB/E62yHuBtTPc5HANL+qQgMCkhR3Bszw/0FAkuL2NIpGZyHyF6YBwQ1uj3c+M5YVBfxXAP/SgSsFzPB71vGFwJ+Kmc904EqBIGpLObl0reNbXqK3LeUrAM9tN1ilEgAbE3jhGTB4bo93vpSTC8WddxM4AFhFRWYsbTdoRdvRAgCqwksFmZWcUmHVy2zpDDIBN/0WaQsODTD3agGTV1OyJ8B7/OOVcgVQVoSGTb3EPwAAAABJRU5ErkJggg==" style="width: 40px;">';
const useStyles = (0, _material.makeStyles)(statusIconStyles);
function StatusIcon({ value, answer, correctAnswer }) {
    const classes = useStyles();
    function getStatus() {
        if (value != correctAnswer && value == answer) return 'incorrect';
        if (value == correctAnswer && value == answer) return 'correct';
        if (value == correctAnswer && value != answer) return 'mark';
        return 'dummy';
    }
    const status = getStatus();
    const icon = {
        incorrect: incorrectIcon,
        correct: correctIcon,
        mark: markIcon,
        dummy: incorrectIcon
    }[status];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, status),
        dangerouslySetInnerHTML: {
            __html: icon
        }
    });
}
function statusIconStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: "#fff",
            marginRight: 20,
            fontSize: '20px',
            '&.dummy': {
                visibility: 'hidden'
            },
            '&.mark': {
                '& svg': {
                    color: '#18d0da'
                }
            },
            '&.incorrect': {
                '& svg': {
                    color: '#dd2229'
                }
            },
            '&.correct': {
                '& svg': {
                    color: '#39c55a'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gtUP0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanks);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(fillInTheBlanksStyles);
function FillInTheBlanks({ assessment, context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.wrapper,
                    children: answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.phrase, {
                                blanked
                            }),
                            children: phrase
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.wrapper,
                        children: question.answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.phrase, {
                                    blanked
                                }),
                                children: phrase
                            }, index))
                    })
                ]
            })
        ]
    });
}
function fillInTheBlanksStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            padding: '35px 0',
            fontSize: '12pt',
            "& .label": {
                display: "flex",
                marginBottom: 10,
                fontWeight: 'bold',
                '& > div': {
                    ...verticalCentering
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        correctAnswer: {
            marginTop: 30
        },
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        phrase: {
            ...verticalCentering,
            marginRight: 10,
            '&:last-child': {
                marginLeft: 0
            },
            '&.blanked': {
                borderBottom: 'solid 1px black'
            }
        },
        input: {
            border: 'none',
            borderBottom: 'solid 1px black'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lu7xu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _utils = require("../../../../helpers/utils");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(openQuestionStyles);
function OpenQuestion({ assessment, context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const expected = (0, _utils.htmlToText)(question.answer.html);
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                    className: classes.textarea,
                    maxRows: 5,
                    minRows: 5,
                    value: answer.value,
                    readOnly: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                        className: classes.textarea,
                        maxRows: 5,
                        minRows: 5,
                        value: expected,
                        readOnly: true
                    })
                ]
            })
        ]
    });
}
function openQuestionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                '&:last-child': {
                    marginTop: 20
                },
                '& .label': {
                    display: "flex",
                    marginBottom: 10,
                    fontWeight: 'bold',
                    '& > div': {
                        ...verticalCentering
                    }
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        textarea: {
            resize: 'none',
            width: 'auto',
            padding: 8,
            flexGrow: 1,
            borderRadius: '4px',
            border: 'solid 1px #c2c7ca'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","../../../../helpers/utils":"gGc98","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5x1xx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("../Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
var _checkbox = require("../Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
const useStyles = (0, _material.makeStyles)(multipleChoiceStyles);
function MultipleChoice({ assessment, context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const { properties: { singleOption } } = question;
    const { choices = [] } = question.answer;
    const Choices = singleOption ? RadioChoice : CheckboxChoice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
            question: question,
            context: context,
            choices: choices,
            answer: assessment.answers[question.id]
        })
    });
}
function RadioChoice({ context, choices, answer }) {
    const classes = useStyles();
    const correctChoice = choices.find((c)=>c.correct) || {};
    const selected = answer ? answer.selected : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: selected,
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: choice.id,
                        answer: selected,
                        correctAnswer: correctChoice.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: choice.id,
                            className: "choice",
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                color: "primary",
                                checked: selected == choice.id
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: choice.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function CheckboxChoice({ context, question, choices, answer }) {
    const classes = useStyles();
    const { assessment } = context;
    const correct = (0, _lodash.difference)(choices.filter((c)=>c.correct).map((c)=>c.id), answer.selectedOptions).length == 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: choices.map((option, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            const checked = answer.selectedOptions.indexOf(option.id) >= 0;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: option.id,
                        answer: checked && option.id,
                        correctAnswer: option.correct && option.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.checkbox,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                checked: checked
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: option.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function multipleChoiceStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            paddingLeft: 10,
            fontSize: '12pt'
        },
        index: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 6
        },
        incorrect: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            visibility: 'hidden',
            color: "#fff",
            marginRight: 10,
            '& svg': {
                fill: '#f30d2a'
            },
            '&.visible': {
                visibility: 'visible'
            }
        },
        correct: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '& svg': {
                fill: '#27bc58'
            },
            marginRight: 10,
            visibility: 'hidden',
            '&.visible': {
                visibility: 'visible'
            }
        },
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../Radio":"coZ52","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@mui/material/FormGroup":"1gJha","../StatusIcon":"amAL7","../Checkbox":"jyjPX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jyjPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckBox);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
const filled = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBImMs0XS48AAAETSURBVEjH7ZU9bsIwGIbfz8oA7LCUnqESB0BhzRYqMSChqkuuABsZuQKdqVTJA11I1vQMVU8AezbEAPmYIhIhJ46Tbryb/VnP4z/ZwCMloWxj+Bo6lCQfAJ4MeQcweT/fTph2iJwtSdY14ADQB/E62yHuBtTPc5HANL+qQgMCkhR3Bszw/0FAkuL2NIpGZyHyF6YBwQ1uj3c+M5YVBfxXAP/SgSsFzPB71vGFwJ+Kmc904EqBIGpLObl0reNbXqK3LeUrAM9tN1ilEgAbE3jhGTB4bo93vpSTC8WddxM4AFhFRWYsbTdoRdvRAgCqwksFmZWcUmHVy2zpDDIBN/0WaQsODTD3agGTV1OyJ8B7/OOVcgVQVoSGTb3EPwAAAABJRU5ErkJggg==" style="width: 24px;">';
const empty = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBI4Kgo67AYAAAB5SURBVEjHY2AYBQQAIxpfg4GBIZiBgYGfTPM+MjAwrGVgYLgBE2BCU0CJ4QxQvUHIAixYFDAwMDCUkWlBFwMDgwCyABOt42DUglELRi0YtWAwWMCCpTznh5aK5IIPyBxmNMnXDAwMigwMDBwUGL6WgYHh7WhdTjQAABdWCyOOwnh2AAAAAElFTkSuQmCC" style="width: 24px;">';
const useStyles = (0, _material.makeStyles)(checkboxStyles);
function CheckBox({ checked }) {
    const classes = useStyles();
    const icon = checked ? filled : empty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        dangerouslySetInnerHTML: {
            __html: icon
        }
    });
}
function checkboxStyles(theme) {
    return {
        root: {
            padding: 9
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8lPNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Matching);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _select = require("../Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(matchingStyles);
function Matching({ assessment, context, question }) {
    const classes = useStyles();
    const { translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {
        terms: [],
        definitions: []
    };
    const terms = answer.terms.map((term, index)=>{
        const value = answer.selected[index];
        const correctIndex = answer.definitions.findIndex((d)=>d.index == term.index);
        const indexToLetter = (index)=>String.fromCharCode(Math.min(index, 20) + 97);
        const answerIndex = indexToLetter(correctIndex);
        const correct = correctIndex == value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.correctAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.correct, {
                            correct
                        }),
                        children: answerIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.status),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: value,
                        answer: value,
                        correctAnswer: correctIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.selectAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.answer,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                            value: value >= 0 ? indexToLetter(value) : ' '
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    dangerouslySetInnerHTML: {
                        __html: term.term || ''
                    }
                })
            ]
        });
    });
    const definitions = answer.definitions.map(({ definition }, index)=>{
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionIndex, {
                        selected: answer.selected.indexOf(index) > -1
                    }),
                    size: "small",
                    children: [
                        answerIndex,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    dangerouslySetInnerHTML: {
                        __html: definition || ''
                    }
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _boxDefault.default),
            className: classes.tableContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                className: classes.table,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: (0, _lodash.zip)(terms, definitions).map(([term, definition], index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            className: classes.pair,
                            children: [
                                term,
                                definition
                            ]
                        }, index);
                    })
                })
            })
        })
    });
}
function matchingStyles(theme) {
    return {
        root: {
            display: 'flex',
            marginTop: 10,
            flexGrow: 1
        },
        tableContainer: {
            flexShrink: 0,
            maxWidth: 1280,
            display: 'flex',
            fontSize: '12pt'
        },
        correct: {
            display: 'flex',
            width: 35,
            height: 35,
            borderRadius: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            color: '#fff',
            backgroundColor: '#0bccd5',
            '&.correct': {
                visibility: 'hidden'
            }
        },
        cell: {
            borderBottom: 0,
            padding: '16px 8px',
            verticalAlign: 'top'
        },
        correctAnswer: {
            width: 35,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 35
        },
        status: {
            width: 30,
            maxWidth: 30,
            flexGrow: 0,
            flexShrink: 0,
            paddingTop: 22
        },
        selectAnswer: {
            width: 45,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 45
        },
        definitionIndex: {
            width: 20,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 20
        },
        table: {
            maxWidth: 1280
        },
        term: {
            display: 'flex'
        },
        termHtml: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        },
        definitionValue: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableRow":"4f4VX","@mui/material/Table":"if4Vw","../Select":"ioFXx","../StatusIcon":"amAL7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ioFXx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _material = require("external/material");
const caret = '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpSoVQTsUccjQOlkQFXHUKhShQqgVWnUwufQLmjQkKS6OgmvBwY/FqoOLs64OroIg+AHi5Oik6CIl/i8ptIj14Lgf7+497t4BQr3MNKtrHNB020wl4mImuyoGXtGLMAYRRURmljEnSUl0HF/38PH1LsazOp/7c/SrOYsBPpF4lhmmTbxBPL1pG5z3iUOsKKvE58RjJl2Q+JHrisdvnAsuCzwzZKZT88QhYrHQxkobs6KpEU8RR1RNp3wh47HKeYuzVq6y5j35C4M5fWWZ6zRHkMAiliBBhIIqSijDRoxWnRQLKdqPd/APu36JXAq5SmDkWEAFGmTXD/4Hv7u18pMTXlIwDnS/OM5HFAjsAo2a43wfO07jBPA/A1d6y1+pAzOfpNdaWuQIGNgGLq5bmrIHXO4A4SdDNmVX8tMU8nng/Yy+KQsM3QJ9a15vzX2cPgBp6ip5AxwcAqMFyl7v8O6e9t7+PdPs7wegFXK5XwEHOwAAAAlwSFlzAAAN1wAADdcBQiibeAAAAAd0SU1FB+QJGBMJOUkbwF0AAABQSURBVEjHY2AYBaNgFAx9wEhA3oGBgcGLgJrdUIwVMBPQ/ICBgeE3AwODKjmGE2MBPksIGk6sBdgsIcpwUiyAWcLAwMBwj1jDR8EoGAV0AgCKXg7pFIpDaAAAAABJRU5ErkJggg==" style="width: 24px;">';
const useStyles = (0, _material.makeStyles)(selectStyles);
function Select(props) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(props.className, classes.root),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.value,
                children: props.value
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.caret,
                dangerouslySetInnerHTML: {
                    __html: caret
                }
            })
        ]
    });
}
function selectStyles(theme) {
    return {
        root: {
            display: 'flex',
            padding: '9px 0px 9px 9px',
            border: 'solid 1px #e0e5e9',
            borderRadius: 3,
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }
        },
        value: {
            justifyContent: 'center',
            flexGrow: 1
        },
        caret: {
            flexShrink: 0
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","@mui/material/Box":"73kto","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"tan1X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Comments);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _infoBar = require("./info-bar");
var _infoBarDefault = parcelHelpers.interopDefault(_infoBar);
var _writeComments = require("./write-comments");
var _writeCommentsDefault = parcelHelpers.interopDefault(_writeComments);
var _responsiveFullscreenDialog = require("../../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
const useStyles = (0, _material.makeStyles)(commentsStyles);
function Comments(props) {
    const classes = useStyles();
    const { isOpen, closeDialog, context } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: closeDialog,
        dialogClassName: classes.root,
        dialogMaxWidth: "lg",
        TitleComponent: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBarDefault.default), {
                ...props
            }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _writeCommentsDefault.default), {
            context: context
        })
    });
}
function commentsStyles(theme) {
    return {
        root: {
            '& .MuiDialog-paper': {
                minHeight: 'calc(100% - 30px)',
                flexGrow: 1
            },
            '& .MuiDialogTitle-root': {
                padding: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","./info-bar":"gR10I","./write-comments":"knxdb","../../../responsive-fullscreen-dialog":"9pRHY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gR10I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _hidden = require("@mui/material/Hidden");
var _hiddenDefault = parcelHelpers.interopDefault(_hidden);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
const useStyles = (0, _material.makeStyles)(infoBarStyles);
function InfoBar({ context, closeDialog }) {
    const classes = useStyles();
    const { translate } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.middle, classes.icon),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiddenDefault.default), {
                    smDown: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faStickyNote)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.middle, classes.label, classes.info),
                children: translate('annotations')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.middle, classes.close),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                    onClick: closeDialog,
                    className: classes.closeButton,
                    size: "large",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                })
            })
        ]
    });
}
function infoBarStyles(theme) {
    return {
        root: {
            display: 'flex',
            borderBottom: 'solid 1px #dbe3e6',
            flexShrink: 0,
            padding: 15
        },
        icon: {
            color: '#4f576e'
        },
        info: {
            flexGrow: 1
        },
        close: {
            color: '#69738',
            padding: '0 6px',
            "& svg": {
                fontSize: '18pt'
            }
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        label: {
            paddingTop: '4px',
            marginLeft: '20px',
            fontSize: '14pt',
            [theme.breakpoints.down('md')]: {
                fontSize: theme.typography.pxToRem(15)
            },
            [theme.breakpoints.down('sm')]: {
                marginLeft: '10px'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Hidden":"kijsg","@mui/material/Box":"73kto","@mui/icons-material/Close":"acjz6","@mui/material/IconButton":"bXjnZ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"knxdb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WriteComments);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grow = require("@mui/material/Grow");
var _growDefault = parcelHelpers.interopDefault(_grow);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttons = require("./buttons");
var _editComment = require("./edit-comment");
var _editCommentDefault = parcelHelpers.interopDefault(_editComment);
var _comment = require("./comment");
var _commentDefault = parcelHelpers.interopDefault(_comment);
var _responsiveFullscreenDialog = require("../../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _command = require("../../../../helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(writeCommentsStyles);
function WriteComments({ context }) {
    const { quizAssessmentToReview: assessment = {}, translate } = context;
    const { comments = [] } = assessment.properties || {};
    const [newComment, setNewComment] = (0, _reactDefault.default).useState({
        comment: '',
        opened: false
    });
    const [deleteCommentState, setDeleteCommentState] = (0, _reactDefault.default).useState({
        open: false,
        comment: {}
    });
    const classes = useStyles();
    function handleNewCommentChange(e) {
        setNewComment({
            ...newComment,
            comment: e.target.value
        });
    }
    function handleNewCommentCancel() {
        setNewComment({
            comment: '',
            opened: false
        });
    }
    async function handleNewCommentSave() {
        if (newComment.comment && newComment.comment.length > 0) {
            const newComments = (0, _immutabilityHelperDefault.default)(comments, {
                $splice: [
                    [
                        0,
                        0,
                        {
                            id: (0, _utils.uuid)(),
                            comment: newComment.comment,
                            added: (0, _momentDefault.default)().toISOString()
                        }
                    ]
                ]
            });
            const { quizAssessmentToReview: { id, properties } } = await context.updateState({
                quizAssessmentToReview: {
                    properties: {
                        comments: {
                            $set: newComments
                        }
                    }
                }
            });
            (0, _command.createPost)('quiz', 'saveReviewProperties')({
                id,
                properties
            });
        }
        handleNewCommentCancel();
    }
    const openDeleteComment = (comment)=>setDeleteCommentState({
            open: true,
            comment
        });
    const cancelDeleteComment = ()=>setDeleteCommentState({
            open: false,
            comment: {}
        });
    async function deleteComment(comment) {
        const index = comments.findIndex((c)=>c.id == comment.id);
        if (index >= 0) {
            const newComments = (0, _immutabilityHelperDefault.default)(comments, {
                $splice: [
                    [
                        index,
                        1
                    ]
                ]
            });
            const { quizAssessmentToReview: { id, properties } } = await context.updateState({
                quizAssessmentToReview: {
                    properties: {
                        comments: {
                            $set: newComments
                        }
                    }
                }
            });
            (0, _command.createPost)('quiz', 'saveReviewProperties')({
                id,
                properties
            });
        }
        cancelDeleteComment();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.create,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.BlueButton), {
                    startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {}),
                    onClick: ()=>setNewComment({
                            text: '',
                            opened: true
                        }),
                    children: translate('add-annotation')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.newComment,
                children: newComment.opened && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editCommentDefault.default), {
                    comment: newComment.comment,
                    onChange: handleNewCommentChange,
                    onCancel: handleNewCommentCancel,
                    onSave: handleNewCommentSave,
                    context
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.comments,
                children: comments.map((comment, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commentDefault.default), {
                        onDeleteComment: openDeleteComment,
                        comment,
                        index,
                        context
                    }, comment.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeleteCommentDialog, {
                onCancel: cancelDeleteComment,
                onConfirm: deleteComment,
                open: deleteCommentState.open,
                comment: deleteCommentState.comment,
                context: context
            })
        ]
    });
}
function DeleteCommentDialog(props) {
    const { open, comment, context, onConfirm, onCancel } = props;
    const { translate } = context;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveFullscreenDialogDefault.default), {
        open: open,
        close: onCancel,
        confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            color: "primary",
            onClick: ()=>onConfirm(comment),
            children: translate('delete')
        }),
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            color: "secondary",
            onClick: onCancel,
            children: translate('cancel')
        }),
        title: translate('confirm_delete_item'),
        children: comment.comment && translate('delete-comment-message', {
            comment: comment.comment
        })
    });
}
function writeCommentsStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            padding: '0 20px',
            overflowY: 'auto',
            [theme.breakpoints.down('sm')]: {
                padding: '0 10px'
            }
        },
        create: {
            padding: '20px 0'
        },
        newComment: {
            '& textarea': {
                flexGrow: 1,
                resize: 'none'
            }
        },
        comments: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            '& > div': {
                marginTop: '20px'
            }
        },
        buttons: {
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","immutability-helper":"hwjCt","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/icons-material/Add":"jrNj7","@mui/material/Box":"73kto","@mui/material/Grow":"4LWtg","@mui/material/Typography":"2wCD5","@mui/material/Button":"c6Y0y","./buttons":"amesX","./edit-comment":"l1i7G","./comment":"154Vd","../../../responsive-fullscreen-dialog":"9pRHY","../../../../helpers/command":"f3cbG","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"amesX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlueButton", ()=>BlueButton);
parcelHelpers.export(exports, "WhiteButton", ()=>WhiteButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
const BlueButton = (0, _material.withStyles)((theme)=>({
        root: {
            color: '#fff',
            boxShadow: 'none',
            backgroundColor: '#2ca5ec',
            border: 'solid 1px #2ca5ec'
        }
    }))((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        ...props,
        variant: "contained",
        children: props.children
    }));
const WhiteButton = (0, _material.withStyles)((theme)=>({
        root: {
            color: '#4f576e',
            boxShadow: 'none',
            backgroundColor: '#fff',
            border: 'solid 1px #4f576e'
        }
    }))((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
        ...props,
        variant: "contained",
        children: props.children
    }));

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l1i7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>EditComment);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _buttons = require("./buttons");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
const useStyles = (0, _material.makeStyles)(editCommentStyles);
function EditComment(props) {
    const { translate } = props.context;
    const classes = useStyles();
    const date = props.added ? (0, _momentDefault.default)(props.added).format(translate('assessment-sent-on-format')) : translate('new-annotation');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.date,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: (0, _clsxDefault.default)(classes.middle, "icon"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faStickyNote)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: `${classes.middle} ${classes.dateLabel}`,
                        children: date
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.comment,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                    autoFocus: true,
                    value: props.comment,
                    onChange: props.onChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.buttons,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.WhiteButton), {
                        onClick: props.onCancel,
                        className: classes.cancel,
                        children: translate('cancel_label')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttons.BlueButton), {
                        onClick: props.onSave,
                        children: translate('save_label')
                    })
                ]
            })
        ]
    });
}
function editCommentStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            border: 'solid 1px #c2c7ca',
            borderRadius: '4px',
            padding: '20px',
            [theme.breakpoints.down('sm')]: {
                padding: '10px'
            }
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            "&.icon": {
                fontSize: '12pt',
                marginTop: -3,
                color: '#647f90'
            }
        },
        date: {
            display: 'flex',
            flexShrink: 0,
            color: '#647f90',
            fontSize: '12pt'
        },
        dateLabel: {
            marginLeft: '10px',
            paddingTop: '2px'
        },
        comment: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            minHeight: '100px',
            marginTop: '10px',
            '& > textarea': {
                resize: 'none',
                flexGrow: 1,
                borderRadius: '4px',
                border: 'solid 1px #c2c7ca'
            }
        },
        buttons: {
            paddingTop: '20px',
            display: 'flex',
            flexShrink: 0,
            justifyContent: 'flex-end',
            [theme.breakpoints.down('sm')]: {
                paddingTop: '10px',
                justifyContent: 'center'
            }
        },
        save: {
            width: '120px'
        },
        cancel: {
            width: '120px',
            marginRight: '30px',
            [theme.breakpoints.down('sm')]: {
                marginRight: '20px'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","moment":"1e4qG","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Typography":"2wCD5","./buttons":"amesX","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"154Vd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Comment);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _typography = require("@mui/material/Typography");
var _typographyDefault = parcelHelpers.interopDefault(_typography);
var _buttons = require("./buttons");
var _icons = require("../../../../resources/icons");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _command = require("../../../../helpers/command");
var _editComment = require("./edit-comment");
var _editCommentDefault = parcelHelpers.interopDefault(_editComment);
const useStyles = (0, _material.makeStyles)(commentStyles);
function Comment(props) {
    const { comment, index, context } = props;
    const { translate, settings, languageId } = context;
    const classes = useStyles();
    const [editing, setEditing] = (0, _reactDefault.default).useState(false);
    const [originalComment] = (0, _reactDefault.default).useState(comment.comment);
    const date = (0, _momentDefault.default)(comment.added).format(translate('assessment-sent-on-format'));
    function handleCommentChange(e) {
        context.updateState({
            quizAssessmentToReview: {
                properties: {
                    comments: {
                        [index]: {
                            comment: {
                                $set: e.target.value
                            }
                        }
                    }
                }
            }
        });
    }
    function handleCommentCancel() {
        context.updateState({
            quizAssessmentToReview: {
                properties: {
                    comments: {
                        [index]: {
                            comment: {
                                $set: originalComment
                            }
                        }
                    }
                }
            }
        });
        setEditing(false);
    }
    async function handleCommentSave() {
        if (comment.comment.length > 0) {
            const { quizAssessmentToReview: assessment } = context;
            const { id, properties } = assessment;
            (0, _command.createPost)('quiz', 'saveReviewProperties')({
                id,
                properties
            });
            setEditing(false);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.editComment,
                style: {
                    display: editing ? 'flex' : 'none'
                },
                children: editing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editCommentDefault.default), {
                    onChange: handleCommentChange,
                    onCancel: handleCommentCancel,
                    onSave: handleCommentSave,
                    ...comment,
                    context
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.root,
                style: {
                    display: editing ? 'none' : 'flex'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.date,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _clsxDefault.default)(classes.middle, "icon"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faStickyNote)
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `${classes.middle} ${classes.dateLabel}`,
                                children: date
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `${classes.middle} ${classes.edit}`,
                                onClick: ()=>setEditing(true),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.EditIcon), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: `${classes.middle} ${classes.delete}`,
                                onClick: ()=>props.onDeleteComment(comment),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.TrashIcon), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.comment,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                            readOnly: true,
                            value: comment.comment
                        })
                    })
                ]
            })
        ]
    });
}
function commentStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            border: 'solid 1px #c2c7ca',
            borderRadius: '4px',
            padding: '20px',
            [theme.breakpoints.down('sm')]: {
                padding: '10px'
            }
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            "&.icon": {
                marginTop: -3,
                fontSize: '12pt',
                color: '#647f90'
            }
        },
        date: {
            display: 'flex',
            flexShrink: 0,
            color: '#647f90',
            fontSize: '12pt'
        },
        dateLabel: {
            flexGrow: 1,
            marginLeft: '10px',
            paddingTop: '2px'
        },
        edit: {
            marginRight: '15px',
            cursor: 'pointer',
            '&:hover': {
                transform: 'scale(1.1)'
            }
        },
        delete: {
            cursor: 'pointer',
            '&:hover': {
                transform: 'scale(1.1)'
            }
        },
        editComment: {
            display: 'flex',
            flexGrow: 1
        },
        comment: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            minHeight: '100px',
            marginTop: '10px',
            '& > textarea': {
                resize: 'none',
                flexGrow: 1,
                borderRadius: '4px',
                border: 'solid 1px #c2c7ca'
            }
        },
        save: {
            width: '120px'
        },
        cancel: {
            width: '120px',
            marginRight: '30px',
            [theme.breakpoints.down('sm')]: {
                marginRight: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","moment":"1e4qG","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Fade":"8DwqP","@mui/material/Typography":"2wCD5","./buttons":"amesX","../../../../resources/icons":"7BMUb","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../../helpers/command":"f3cbG","./edit-comment":"l1i7G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Sao2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Standards);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(style);
function Standards({ context }) {
    const classes = useStyles();
    const { translate, standardsContext, questionId } = context;
    const { assessmentIndicators = {}, assessmentStandards = {} } = standardsContext;
    const hasIndicators = Object.keys(assessmentIndicators).length > 0;
    const expectations = assessmentStandards?.items[0]?.expectations || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.indicator,
        children: [
            questionId && hasIndicators && !!assessmentIndicators[questionId] ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.indicatorTitle,
                        children: [
                            translate('indicator-header'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.indicatorText,
                        children: assessmentIndicators[questionId][0].code
                    })
                ]
            }) : undefined,
            questionId && !hasIndicators && expectations.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.indicatorTitle,
                        children: [
                            translate('expectations'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.expectationText,
                        children: expectations.map((exp)=>exp.references.find((ref)=>ref.id == questionId) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                                text: exp.description,
                                maxLine: 2,
                                ellipsis: "...",
                                trimRight: true,
                                basedOn: "letters"
                            }) : undefined)
                    })
                ]
            }) : undefined
        ]
    });
}
function style(theme) {
    return {
        indicator: {
            display: 'flex'
        },
        indicatorTitle: {
            fontWeight: 'bold',
            marginRight: 3
        },
        indicatorText: {
            textTransform: 'uppercase'
        },
        expectationText: {
            textTransform: 'initial'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-lines-ellipsis":"ikp0X","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ga1yY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsResults);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _alert = require("@mui/material/Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
var _standardsHead = require("./standards-head");
var _standardsHeadDefault = parcelHelpers.interopDefault(_standardsHead);
var _standardsBody = require("./standards-body");
var _standardsBodyDefault = parcelHelpers.interopDefault(_standardsBody);
var _standardsChart = require("./standards-chart");
var _standardsChartDefault = parcelHelpers.interopDefault(_standardsChart);
var _standardsAssessment = require("./standards-assessment");
var _standardsAssessmentDefault = parcelHelpers.interopDefault(_standardsAssessment);
var _loading = require("./components/loading");
var _loadingDefault = parcelHelpers.interopDefault(_loading);
var _legend = require("./components/legend");
var _legendDefault = parcelHelpers.interopDefault(_legend);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function StandardsResults({ context }) {
    const classes = (0, _stylesDefault.default)();
    const { standardsContext, translate } = context;
    const { assessmentStandards } = standardsContext;
    const standardsFound = assessmentStandards.items.length > 0;
    const [loading, setLoading] = (0, _react.useState)(true);
    const assessmentLoaded = !context.quizSearch['assessment-to-review'];
    (0, _react.useEffect)(()=>{
        if (assessmentStandards.loaded) setTimeout(()=>{
            setLoading(false);
        }, 3000);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
            in: assessmentLoaded,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.preview,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.viewHeader,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsAssessmentDefault.default), {
                            context: context
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.section,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                container: true,
                                spacing: 2,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                                    item: true,
                                    xs: 12,
                                    children: translate('standards-domain')
                                })
                            }),
                            !loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _legendDefault.default), {
                                context: context
                            })
                        ]
                    }),
                    !loading && standardsFound && assessmentStandards.items.map((stds, index)=>{
                        var indicatorCode = [];
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.viewContent,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.viewHeaderTable,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsChartDefault.default), {
                                        context: context,
                                        standard: stds,
                                        standardIndex: index
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                                    className: classes.table,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsHeadDefault.default), {
                                            context: context
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsBodyDefault.default), {
                                            context: context,
                                            stds: stds,
                                            indicatorCode: indicatorCode
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    }),
                    !loading && !standardsFound && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.viewContent,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stackDefault.default), {
                            sx: {
                                width: '100%'
                            },
                            spacing: 2,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertDefault.default), {
                                severity: "info",
                                children: translate('no-standards-specified')
                            })
                        })
                    }),
                    loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loadingDefault.default), {})
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","@mui/material/Table":"if4Vw","@mui/material/Grid":"ggUwv","@mui/material/Alert":"4jouH","@mui/material/Stack":"jY4TS","./standards-head":"aoMrv","./standards-body":"6YfMI","./standards-chart":"alrFJ","./standards-assessment":"bRC5z","./components/loading":"dpBrQ","./components/legend":"44wLA","./styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4jouH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _alertDefault.default));
parcelHelpers.export(exports, "alertClasses", ()=>(0, _alertClassesDefault.default));
var _alert = require("./Alert");
var _alertDefault = parcelHelpers.interopDefault(_alert);
var _alertClasses = require("./alertClasses");
var _alertClassesDefault = parcelHelpers.interopDefault(_alertClasses);
parcelHelpers.exportAll(_alertClasses, exports);
'use client';

},{"./Alert":"eBwMd","./alertClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBwMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _colorManipulator = require("@mui/system/colorManipulator");
var _zeroStyled = require("../zero-styled");
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _useSlot = require("../utils/useSlot");
var _useSlotDefault = parcelHelpers.interopDefault(_useSlot);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _alertClasses = require("./alertClasses");
var _alertClassesDefault = parcelHelpers.interopDefault(_alertClasses);
var _iconButton = require("../IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _successOutlined = require("../internal/svg-icons/SuccessOutlined");
var _successOutlinedDefault = parcelHelpers.interopDefault(_successOutlined);
var _reportProblemOutlined = require("../internal/svg-icons/ReportProblemOutlined");
var _reportProblemOutlinedDefault = parcelHelpers.interopDefault(_reportProblemOutlined);
var _errorOutline = require("../internal/svg-icons/ErrorOutline");
var _errorOutlineDefault = parcelHelpers.interopDefault(_errorOutline);
var _infoOutlined = require("../internal/svg-icons/InfoOutlined");
var _infoOutlinedDefault = parcelHelpers.interopDefault(_infoOutlined);
var _close = require("../internal/svg-icons/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { variant, color, severity, classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalizeDefault.default)(color || severity)}`,
            `${variant}${(0, _capitalizeDefault.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _alertClasses.getAlertUtilityClass), classes);
};
const AlertRoot = (0, _zeroStyled.styled)((0, _paperDefault.default), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, _capitalizeDefault.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, _colorManipulator.darken) : (0, _colorManipulator.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, _colorManipulator.lighten) : (0, _colorManipulator.darken);
    return (0, _extendsDefault.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, _alertClassesDefault.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, _alertClassesDefault.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, _extendsDefault.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const AlertIcon = (0, _zeroStyled.styled)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const AlertMessage = (0, _zeroStyled.styled)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const AlertAction = (0, _zeroStyled.styled)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const defaultIconMapping = {
    success: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _successOutlinedDefault.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportProblemOutlinedDefault.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorOutlineDefault.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoOutlinedDefault.default), {
        fontSize: "inherit"
    })
};
const Alert = /*#__PURE__*/ _react.forwardRef(function Alert(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action, children, className, closeText = 'Close', color, components = {}, componentsProps = {}, icon, iconMapping = defaultIconMapping, onClose, role = 'alert', severity = 'success', slotProps = {}, slots = {}, variant = 'standard' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        severity,
        variant,
        colorSeverity: color || severity
    });
    const classes = useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, _extendsDefault.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, _extendsDefault.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, _useSlotDefault.default)('closeButton', {
        elementType: (0, _iconButtonDefault.default),
        externalForwardedProps,
        ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, _useSlotDefault.default)('closeIcon', {
        elementType: (0, _closeDefault.default),
        externalForwardedProps,
        ownerState
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(AlertRoot, (0, _extendsDefault.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseButtonSlot, (0, _extendsDefault.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CloseIconSlot, (0, _extendsDefault.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
exports.default = Alert;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system/colorManipulator":"dHYgR","../zero-styled":"89fxU","../DefaultPropsProvider":"ff3VX","../utils/useSlot":"29rI6","../utils/capitalize":"hBZko","../Paper":"arHf6","./alertClasses":"jJloL","../IconButton":"bXjnZ","../internal/svg-icons/SuccessOutlined":"bcFp5","../internal/svg-icons/ReportProblemOutlined":"QvNy2","../internal/svg-icons/ErrorOutline":"61x1N","../internal/svg-icons/InfoOutlined":"gXzI2","../internal/svg-icons/Close":"d80nh","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jJloL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlertUtilityClass", ()=>getAlertUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getAlertUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiAlert', slot);
}
const alertClasses = (0, _generateUtilityClassesDefault.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
exports.default = alertClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bcFp5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"QvNy2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61x1N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXzI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d80nh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _createSvgIcon = require("../../utils/createSvgIcon");
var _createSvgIconDefault = parcelHelpers.interopDefault(_createSvgIcon);
/**
 * @ignore - internal component.
 *
 * Alias to `Clear`.
 */ var _jsxRuntime = require("react/jsx-runtime");
'use client';
exports.default = (0, _createSvgIconDefault.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

},{"react":"9njXz","../../utils/createSvgIcon":"k1uMV","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aoMrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function StandardsHead({ context }) {
    const classes = (0, _stylesDefault.default)();
    const { translate, standardsContext } = context;
    const { assessmentIndicators } = standardsContext;
    const hasIndicators = Object.keys(assessmentIndicators).length > 0 || false;
    const headCells = [
        {
            id: hasIndicators ? 'indicator' : 'expectation',
            align: 'center',
            disablePadding: false,
            hide: false
        },
        {
            id: 'questions',
            align: 'center',
            disablePadding: false,
            hide: false
        },
        {
            id: 'percent',
            align: 'center',
            disablePadding: false,
            hide: false
        },
        {
            id: 'status',
            align: 'center',
            disablePadding: false,
            hide: false
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableRowDefault.default), {
            className: classes.tableHeader,
            children: headCells.map(({ id, align, disablePadding, hide })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: align,
                    padding: disablePadding ? 'none' : 'normal',
                    children: !hide ? translate(`${id}-header`) : ''
                }, id))
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","./styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"453Xc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStyles);
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)((theme)=>({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'scroll',
            backgroundColor: '#ffff'
        },
        viewContent: {
            margin: '3% 0'
        },
        viewHeaderTable: {
            border: '1px solid #e6e6e6',
            borderRadius: '14px 14px 0 0',
            padding: '0 30px 0 7px'
        },
        preview: {
            padding: '24px 20%'
        },
        studentName: {
            "& svg": {
                margin: '0 5px',
                color: '#2C75BD'
            }
        },
        section: {
            fontSize: '20px',
            textAlign: 'center',
            fontWeight: 'bold',
            margin: '5% 0 3%'
        },
        title: {
            fontWeight: 'bold',
            marginRight: 5
        },
        chart: {
            marginRight: '-15px'
        },
        chartTitle: {
            fontSize: 14,
            margin: 'auto 0'
        },
        chartSubTitle: {
            fontSize: 10,
            margin: 'auto 0'
        },
        close: {
            marginLeft: 'auto',
            color: '#505D63',
            '& .icon': {
                marginTop: -3,
                marginRight: 3,
                fontSize: '8pt'
            }
        },
        button: {
            textDecoration: 'none',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            borderRadius: 3,
            width: '28%',
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer'
        },
        grid: {
            display: 'flex'
        },
        table: {
            "& thead ": {
                "& tr": {
                    backgroundColor: '#ffffff',
                    border: '1px solid #E7EBF0'
                }
            }
        },
        tableHeader: {
            backgroundColor: '#E7EBF0',
            borderTop: '1px solid #E7EBF0'
        },
        tableTitle: {
            padding: '4%',
            fontWeight: 'bold',
            margin: 'auto 0'
        },
        tableBody: {
            borderRadius: '14px !important',
            border: '1px solid #E7EBF0',
            "& td": {
                border: 'none'
            }
        },
        tableCell: {
            textAlign: 'center'
        },
        tableCellIndicator: {
            maxWidth: '200px'
        },
        indicatorLabel: {
            height: 'auto',
            lineHeight: '1.5em',
            textAlign: 'start',
            padding: '7px',
            fontSize: '14px',
            minWidth: '180px',
            boxShadow: 'none'
        },
        expectationLabel: {
            textTransform: 'initial',
            height: 'auto',
            lineHeight: '1.5em',
            textAlign: 'start',
            padding: '7px 26px 7px 6px',
            fontSize: '14px',
            minWidth: '200px',
            boxShadow: 'none'
        },
        expectationButton: {
            backgroundColor: '#fff',
            borderLeft: '#83f2a1 9px solid',
            borderRadius: '9px',
            height: 'auto',
            maxHeigth: 85,
            display: 'inline'
        },
        legend: {
            fontSize: '.9rem',
            fontWeight: 'normal',
            direction: 'row',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            marginTop: '5%'
        },
        legendBox: {
            display: 'inline-flex',
            textAlign: 'left'
        },
        legendLabel: {
            marginLeft: 9,
            "& > span": {
                fontSize: '.7rem'
            }
        },
        legendDot: {
            display: 'inline-table',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            width: 15,
            height: 15,
            fontSize: '9pt',
            color: '#fff',
            margin: 5,
            backgroundColor: '#ff3a3a',
            "& > span": {
                marginTop: 1,
                marginLeft: 1
            }
        },
        statusDot: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            width: 20,
            height: 20,
            fontSize: '9pt',
            color: '#fff',
            backgroundColor: '#ff3a3a',
            "& > span": {
                marginTop: 1,
                marginLeft: 1
            },
            "& > svg": {
                fontSize: '11.5pt'
            }
        },
        statusWrapper: {
            display: 'inline-flex'
        },
        pendingCell: {
            maxWidth: 5
        },
        readMoreIcon: {
            position: 'absolute',
            fontSize: 23,
            right: 6,
            top: '34%',
            color: '#b4b4b4'
        },
        question: {
            margin: 30
        },
        questionBtn: {
            minWidth: 0,
            width: 45,
            border: 0,
            borderRadius: '100%',
            "&:hover": {
                border: 0
            }
        },
        questionDialog: {
            maxWidth: '60%'
        },
        questionStepper: {
        },
        '@media (max-width: 800px)': {
            viewContent: {
                display: 'inline-block'
            }
        },
        '@media (max-width: 480px)': {
            tableTitle: {
                padding: '4% 0 0'
            },
            preview: {
                padding: 0
            },
            button: {
                padding: 0,
                width: 'auto'
            },
            grid: {
                justifyContent: 'flex-start'
            }
        }
    }));

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6YfMI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsBody);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _standardsExpectation = require("./standards-expectation");
var _standardsExpectationDefault = parcelHelpers.interopDefault(_standardsExpectation);
var _standardsIndicators = require("./standards-indicators");
var _standardsIndicatorsDefault = parcelHelpers.interopDefault(_standardsIndicators);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function StandardsBody({ context, stds, indicatorCode }) {
    const classes = (0, _stylesDefault.default)();
    const { standardsContext, quizAssessmentToReview: standards } = context;
    const { assessmentIndicators } = standardsContext;
    const hasReferences = stds.references.length > 0;
    const hasIndicators = Object.keys(assessmentIndicators).length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableBodyDefault.default), {
        className: classes.tableBody,
        children: [
            hasReferences && hasIndicators && stds.references?.map((row, index)=>{
                let countAnswered = 0;
                let pending = false;
                let percent = 0;
                let countTotal = assessmentIndicators[row.id][0].references !== undefined ? assessmentIndicators[row.id][0].references.length : 0;
                assessmentIndicators[row.id][0]?.references.forEach((question)=>{
                    if (standards.results[question.id].points > 0) countAnswered++;
                    if (standards.results[question.id].pending) pending = true;
                });
                if (indicatorCode.indexOf(assessmentIndicators[row.id][0].code) === -1) {
                    indicatorCode.push(assessmentIndicators[row.id][0].code);
                    percent = countAnswered / countTotal * 100;
                } else return;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsIndicatorsDefault.default), {
                    context: context,
                    indicator: assessmentIndicators[row.id][0],
                    percent: percent,
                    pending: pending,
                    countAnswered: countAnswered,
                    countTotal: countTotal
                }, index);
            }),
            !hasIndicators && stds.expectations.map((expectation, index)=>{
                let countAnswered = 0;
                let pending = false;
                let percent = 0;
                let countTotal = expectation.references.length;
                expectation.references.forEach((question)=>{
                    if (standards.results[question.id].points > 0) countAnswered++;
                    if (standards.results[question.id].pending) pending = true;
                });
                if (indicatorCode.indexOf(expectation.description) === -1) {
                    indicatorCode.push(expectation.description);
                    percent = countAnswered / countTotal * 100;
                } else return;
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsExpectationDefault.default), {
                    context: context,
                    expectation: expectation,
                    percent: percent,
                    pending: pending,
                    countAnswered: countAnswered,
                    countTotal: countTotal
                }, index);
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/TableBody":"bPEEy","./standards-expectation":"XZ1rb","./standards-indicators":"hW59e","./styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"XZ1rb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsExpectation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _fab = require("@mui/material/Fab");
var _fabDefault = parcelHelpers.interopDefault(_fab);
var _avatar = require("@mui/material/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _standardsQuestions = require("./standards-questions");
var _standardsQuestionsDefault = parcelHelpers.interopDefault(_standardsQuestions);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function StandardsExpectation({ context, expectation, percent, pending, countAnswered, countTotal }) {
    const classes = (0, _stylesDefault.default)();
    const { quizStandardScale = {}, translate } = context;
    const { proficient, parcial, noProficient } = quizStandardScale[0] || {};
    const proScoreMaxLimit = proficient.maxValue || 100;
    const proScoreMinLimit = proficient.minValue || 75;
    const parcialScoreMaxLimit = parcial.maxValue || 74;
    const parcialScoreMinLimit = parcial.minValue || 60;
    const noProScoreMaxLimit = noProficient.maxValue || 59;
    const noProScoreMinLimit = noProficient.minValue || 0;
    const [isReadMore, setIsReadMore] = (0, _react.useState)(true);
    const toggleReadMore = ()=>{
        setIsReadMore(!isReadMore);
    };
    const indicatorState = (percent, pending)=>pending ? '#fff' : percent <= proScoreMaxLimit && percent >= proScoreMinLimit ? proficient.color : percent <= parcialScoreMaxLimit && percent >= parcialScoreMinLimit ? parcial.color : percent <= noProScoreMaxLimit && percent >= noProScoreMinLimit ? noProficient.color : '#fff';
    const [open, setOpen] = (0, _react.useState)(false);
    const [maxWidth, setMaxWidth] = (0, _react.useState)('md');
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                align: "center",
                className: (0, _clsxDefault.default)(classes.TableCell, classes.tableCellIndicator),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _fabDefault.default), {
                    variant: "extended",
                    size: "medium",
                    className: (0, _clsxDefault.default)(classes.expectationLabel, classes.expectationButton),
                    onClick: toggleReadMore,
                    style: {
                        "borderColor": indicatorState(percent, pending)
                    },
                    children: [
                        isReadMore && expectation.description.length > 110 ? expectation.description.slice(0, 110) + '...' : expectation.description,
                        expectation.description.length > 110 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.readMoreIcon,
                            children: isReadMore ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faAngleDown)
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faAngleUp)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                className: classes.tableCell,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        className: classes.questionBtn,
                        variant: "outlined",
                        onClick: handleClickOpen,
                        children: `${countAnswered}/${countTotal}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
                        onClose: handleClose,
                        fullWidth: "true",
                        maxWidth: maxWidth,
                        open: open,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                                id: "customized-dialog-title",
                                onClose: handleClose,
                                children: [
                                    expectation.description,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        onClick: handleClose,
                                        sx: {
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: (theme)=>theme.palette.grey[500]
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsQuestionsDefault.default), {
                                context: context,
                                questions: expectation.references
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: classes.tableCell,
                children: `${percent}%`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.tableCell, classes.pendingCell),
                children: pending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.statusWrapper,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                        className: classes.statusDot,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "R"
                        })
                    })
                })
            })
        ]
    }, expectation.id);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","@mui/material/TableCell":"8Htaw","@mui/material/TableRow":"4f4VX","@mui/material/Fab":"9QkHI","@mui/material/Avatar":"4ltr6","@mui/material/Box":"73kto","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"joPR3","@mui/material/Button":"c6Y0y","@mui/material/Dialog":"255tO","@mui/material/DialogTitle":"5sOv1","@mui/icons-material/Close":"acjz6","./standards-questions":"kU1yg","./styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kU1yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsQuestions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _dialogContent = require("@mui/material/DialogContent");
var _dialogContentDefault = parcelHelpers.interopDefault(_dialogContent);
var _mobileStepper = require("@mui/material/MobileStepper");
var _mobileStepperDefault = parcelHelpers.interopDefault(_mobileStepper);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _keyboardArrowLeft = require("@mui/icons-material/KeyboardArrowLeft");
var _keyboardArrowLeftDefault = parcelHelpers.interopDefault(_keyboardArrowLeft);
var _keyboardArrowRight = require("@mui/icons-material/KeyboardArrowRight");
var _keyboardArrowRightDefault = parcelHelpers.interopDefault(_keyboardArrowRight);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _questionHandlers = require("./question-handlers");
var _questionHandlersDefault = parcelHelpers.interopDefault(_questionHandlers);
var _utils = require("../../../helpers/utils");
function StandardsQuestions({ context, questions }) {
    const classes = (0, _stylesDefault.default)();
    const { translate, quizQuestionTypes, quizAssessmentToReview: assessment } = context;
    const { content = {} } = assessment;
    const { sections = {} } = content;
    const [activeStep, setActiveStep] = (0, _react.useState)(0);
    const maxSteps = questions.length;
    const handleNext = ()=>{
        setActiveStep((prevActiveStep)=>prevActiveStep + 1);
    };
    const handleBack = ()=>{
        setActiveStep((prevActiveStep)=>prevActiveStep - 1);
    };
    const result = questions.map((question)=>sections[question.section].questions.find((q)=>q.id == question.id));
    const type = quizQuestionTypes.find((t)=>t.id == result[activeStep].type) || {};
    const Handler = (0, _questionHandlersDefault.default)[type.name];
    const { html } = result[activeStep].premise || {};
    const premiseHtml = (0, _utils.isEmpty)(html) ? false : html;
    const defaultPremiseLabel = `${type.name}-default-premise`;
    const defaultPremise = translate(defaultPremiseLabel);
    const hasDefaultPremise = defaultPremiseLabel != defaultPremise;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogContentDefault.default), {
                dividers: true,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
                        square: true,
                        elevation: 0,
                        children: [
                            premiseHtml && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: classes.premise,
                                dangerouslySetInnerHTML: {
                                    __html: premiseHtml
                                }
                            }),
                            !premiseHtml && hasDefaultPremise && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.premise,
                                children: defaultPremise
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.question,
                        children: Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                            context: context,
                            question: result[activeStep]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileStepperDefault.default), {
                    variant: "text",
                    steps: maxSteps,
                    position: "static",
                    activeStep: activeStep,
                    className: classes.questionStepper,
                    dividers: true,
                    nextButton: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
                        size: "small",
                        onClick: handleNext,
                        disabled: activeStep === maxSteps - 1,
                        children: [
                            translate('next'),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowRightDefault.default), {})
                        ]
                    }),
                    backButton: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
                        size: "small",
                        onClick: handleBack,
                        disabled: activeStep === 0,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowLeftDefault.default), {}),
                            translate('back_label')
                        ]
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/DialogContent":"gD0J9","@mui/material/MobileStepper":"gyPBT","@mui/material/Paper":"arHf6","@mui/material/Button":"c6Y0y","@mui/icons-material/KeyboardArrowLeft":"aOCgM","@mui/icons-material/KeyboardArrowRight":"d6UJH","./styles":"453Xc","./question-handlers":"1rgAd","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gyPBT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _mobileStepperDefault.default));
parcelHelpers.export(exports, "mobileStepperClasses", ()=>(0, _mobileStepperClassesDefault.default));
var _mobileStepper = require("./MobileStepper");
var _mobileStepperDefault = parcelHelpers.interopDefault(_mobileStepper);
var _mobileStepperClasses = require("./mobileStepperClasses");
var _mobileStepperClassesDefault = parcelHelpers.interopDefault(_mobileStepperClasses);
parcelHelpers.exportAll(_mobileStepperClasses, exports);
'use client';

},{"./MobileStepper":"4uZyW","./mobileStepperClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4uZyW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _integerPropType = require("@mui/utils/integerPropType");
var _integerPropTypeDefault = parcelHelpers.interopDefault(_integerPropType);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _paper = require("../Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _linearProgress = require("../LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _mobileStepperClasses = require("./mobileStepperClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "activeStep",
    "backButton",
    "className",
    "LinearProgressProps",
    "nextButton",
    "position",
    "steps",
    "variant"
];
const useUtilityClasses = (ownerState)=>{
    const { classes, position } = ownerState;
    const slots = {
        root: [
            'root',
            `position${(0, _capitalizeDefault.default)(position)}`
        ],
        dots: [
            'dots'
        ],
        dot: [
            'dot'
        ],
        dotActive: [
            'dotActive'
        ],
        progress: [
            'progress'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _mobileStepperClasses.getMobileStepperUtilityClass), classes);
};
const MobileStepperRoot = (0, _styledDefault.default)((0, _paperDefault.default), {
    name: 'MuiMobileStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, _capitalizeDefault.default)(ownerState.position)}`]
        ];
    }
})(({ theme, ownerState })=>(0, _extendsDefault.default)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: (theme.vars || theme).palette.background.default,
        padding: 8
    }, ownerState.position === 'bottom' && {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }, ownerState.position === 'top' && {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: (theme.vars || theme).zIndex.mobileStepper
    }));
const MobileStepperDots = (0, _styledDefault.default)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dots',
    overridesResolver: (props, styles)=>styles.dots
})(({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === 'dots' && {
        display: 'flex',
        flexDirection: 'row'
    }));
const MobileStepperDot = (0, _styledDefault.default)('div', {
    name: 'MuiMobileStepper',
    slot: 'Dot',
    shouldForwardProp: (prop)=>(0, _styled.slotShouldForwardProp)(prop) && prop !== 'dotActive',
    overridesResolver: (props, styles)=>{
        const { dotActive } = props;
        return [
            styles.dot,
            dotActive && styles.dotActive
        ];
    }
})(({ theme, ownerState, dotActive })=>(0, _extendsDefault.default)({}, ownerState.variant === 'dots' && (0, _extendsDefault.default)({
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.action.disabled,
        borderRadius: '50%',
        width: 8,
        height: 8,
        margin: '0 2px'
    }, dotActive && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    })));
const MobileStepperProgress = (0, _styledDefault.default)((0, _linearProgressDefault.default), {
    name: 'MuiMobileStepper',
    slot: 'Progress',
    overridesResolver: (props, styles)=>styles.progress
})(({ ownerState })=>(0, _extendsDefault.default)({}, ownerState.variant === 'progress' && {
        width: '50%'
    }));
const MobileStepper = /*#__PURE__*/ _react.forwardRef(function MobileStepper(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiMobileStepper'
    });
    const { activeStep = 0, backButton, className, LinearProgressProps, nextButton, position = 'bottom', steps, variant = 'dots' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        activeStep,
        position,
        variant
    });
    let value;
    if (variant === 'progress') {
        if (steps === 1) value = 100;
        else value = Math.ceil(activeStep / (steps - 1) * 100);
    }
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(MobileStepperRoot, (0, _extendsDefault.default)({
        square: true,
        elevation: 0,
        className: (0, _clsxDefault.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            backButton,
            variant === 'text' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react.Fragment, {
                children: [
                    activeStep + 1,
                    " / ",
                    steps
                ]
            }),
            variant === 'dots' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileStepperDots, {
                ownerState: ownerState,
                className: classes.dots,
                children: [
                    ...new Array(steps)
                ].map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileStepperDot, {
                        className: (0, _clsxDefault.default)(classes.dot, index === activeStep && classes.dotActive),
                        ownerState: ownerState,
                        dotActive: index === activeStep
                    }, index))
            }),
            variant === 'progress' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileStepperProgress, (0, _extendsDefault.default)({
                ownerState: ownerState,
                className: classes.progress,
                variant: "determinate",
                value: value
            }, LinearProgressProps)),
            nextButton
        ]
    }));
});
exports.default = MobileStepper;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/integerPropType":"bc5x8","@mui/utils/composeClasses":"43D21","../Paper":"arHf6","../utils/capitalize":"hBZko","../LinearProgress":"a9Qej","../DefaultPropsProvider":"ff3VX","../styles/styled":"bTnxF","./mobileStepperClasses":"5glX1","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9Qej":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _linearProgressDefault.default));
parcelHelpers.export(exports, "linearProgressClasses", ()=>(0, _linearProgressClassesDefault.default));
var _linearProgress = require("./LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _linearProgressClasses = require("./linearProgressClasses");
var _linearProgressClassesDefault = parcelHelpers.interopDefault(_linearProgressClasses);
parcelHelpers.exportAll(_linearProgressClasses, exports);
'use client';

},{"./LinearProgress":"cGLXx","./linearProgressClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cGLXx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _system = require("@mui/system");
var _colorManipulator = require("@mui/system/colorManipulator");
var _rtlProvider = require("@mui/system/RtlProvider");
var _capitalize = require("../utils/capitalize");
var _capitalizeDefault = parcelHelpers.interopDefault(_capitalize);
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _linearProgressClasses = require("./linearProgressClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let _ = (t)=>t, _t, _t2, _t3, _t4, _t5, _t6;
const TRANSITION_DURATION = 4; // seconds
const indeterminate1Keyframe = (0, _system.keyframes)(_t || (_t = _`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = (0, _system.keyframes)(_t2 || (_t2 = _`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = (0, _system.keyframes)(_t3 || (_t3 = _`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, _capitalizeDefault.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, _capitalizeDefault.default)(color)}`
        ],
        bar1: [
            'bar',
            `barColor${(0, _capitalizeDefault.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            variant !== 'buffer' && `barColor${(0, _capitalizeDefault.default)(color)}`,
            variant === 'buffer' && `color${(0, _capitalizeDefault.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _linearProgressClasses.getLinearProgressUtilityClass), classes);
};
const getColorShade = (theme, color)=>{
    if (color === 'inherit') return 'currentColor';
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator.darken)(theme.palette[color].main, 0.5);
};
const LinearProgressRoot = (0, _styledDefault.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, _capitalizeDefault.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        '@media print': {
            colorAdjust: 'exact'
        },
        backgroundColor: getColorShade(theme, ownerState.color)
    }, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
        backgroundColor: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3
        }
    }, ownerState.variant === 'buffer' && {
        backgroundColor: 'transparent'
    }, ownerState.variant === 'query' && {
        transform: 'rotate(180deg)'
    }));
const LinearProgressDashed = (0, _styledDefault.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, _capitalizeDefault.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState, theme })=>{
    const backgroundColor = getColorShade(theme, ownerState.color);
    return (0, _extendsDefault.default)({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%'
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px'
    });
}, (0, _system.css)(_t4 || (_t4 = _`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = (0, _styledDefault.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, _capitalizeDefault.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'determinate' && {
        transition: `transform .${TRANSITION_DURATION}s linear`
    }, ownerState.variant === 'buffer' && {
        zIndex: 1,
        transition: `transform .${TRANSITION_DURATION}s linear`
    }), ({ ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, _system.css)(_t5 || (_t5 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = (0, _styledDefault.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, _capitalizeDefault.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})(({ ownerState, theme })=>(0, _extendsDefault.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left'
    }, ownerState.variant !== 'buffer' && {
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, ownerState.variant === 'buffer' && {
        backgroundColor: getColorShade(theme, ownerState.color),
        transition: `transform .${TRANSITION_DURATION}s linear`
    }), ({ ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, _system.css)(_t6 || (_t6 = _`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const LinearProgress = /*#__PURE__*/ _react.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className, color = 'primary', value, valueBuffer, variant = 'indeterminate' } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        color,
        variant
    });
    const classes = useUtilityClasses(ownerState);
    const isRtl = (0, _rtlProvider.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(LinearProgressRoot, (0, _extendsDefault.default)({
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
exports.default = LinearProgress;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","prop-types":"bnNSm","clsx":"bK0Bf","@mui/utils/composeClasses":"43D21","@mui/system":"5Hnj5","@mui/system/colorManipulator":"dHYgR","@mui/system/RtlProvider":"aMQRu","../utils/capitalize":"hBZko","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./linearProgressClasses":"1oMHw","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1oMHw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLinearProgressUtilityClass", ()=>getLinearProgressUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getLinearProgressUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiLinearProgress', slot);
}
const linearProgressClasses = (0, _generateUtilityClassesDefault.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
exports.default = linearProgressClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5glX1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMobileStepperUtilityClass", ()=>getMobileStepperUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getMobileStepperUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiMobileStepper', slot);
}
const mobileStepperClasses = (0, _generateUtilityClassesDefault.default)('MuiMobileStepper', [
    'root',
    'positionBottom',
    'positionTop',
    'positionStatic',
    'dots',
    'dot',
    'dotActive',
    'progress'
]);
exports.default = mobileStepperClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aOCgM":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("27b2404c577e1596");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("55a9743d3da36dc8"));
var _jsxRuntime = require("2ca9b5bc935cb2bf");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z"
}), 'KeyboardArrowLeft');

},{"27b2404c577e1596":"kZ6eK","55a9743d3da36dc8":"2vOnF","2ca9b5bc935cb2bf":"1dlk8"}],"d6UJH":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("2dfd7b2d38f9c33a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("b0c93802295799a4"));
var _jsxRuntime = require("3e900950a1367c45");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z"
}), 'KeyboardArrowRight');

},{"2dfd7b2d38f9c33a":"kZ6eK","b0c93802295799a4":"2vOnF","3e900950a1367c45":"1dlk8"}],"1rgAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trueOrFalse = require("./TrueOrFalse");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _fillInTheBlanks = require("./FillInTheBlanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _openQuestion = require("./OpenQuestion");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _multipleChoice = require("./MultipleChoice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _matching = require("./Matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'matching': (0, _matchingDefault.default)
};
exports.default = handlers;

},{"./TrueOrFalse":"2ypLq","./FillInTheBlanks":"7scDk","./OpenQuestion":"6bBDn","./MultipleChoice":"1Nolp","./Matching":"iibT3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ypLq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _statusIcon = require("../components/StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(trueOrFalseStyles);
function TrueOrFalse({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    const correct = question.answer.value == answer.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
            className: "content",
            value: answer.value,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: true,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: true,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('true')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: false,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: false,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('false')
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function trueOrFalseStyles(theme) {
    return {
        root: {},
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","../components/StatusIcon":"k6stP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k6stP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(statusIconStyles);
function StatusIcon({ value, answer, correctAnswer }) {
    const classes = useStyles();
    function getStatus() {
        if (value != correctAnswer && value == answer) return 'incorrect';
        if (value == correctAnswer && value == answer) return 'correct';
        if (value == correctAnswer && value != answer) return 'mark';
        return 'dummy';
    }
    const status = getStatus();
    const icon = {
        incorrect: (0, _freeSolidSvgIcons.faTimesCircle),
        correct: (0, _freeSolidSvgIcons.faCheckCircle),
        mark: (0, _freeSolidSvgIcons.faArrowAltCircleRight),
        dummy: (0, _freeSolidSvgIcons.faTimesCircle)
    }[status];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, status),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            icon: icon
        })
    });
}
function statusIconStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: "#fff",
            marginRight: 20,
            fontSize: '20px',
            '&.dummy': {
                visibility: 'hidden'
            },
            '&.mark': {
                '& svg': {
                    color: '#18d0da'
                }
            },
            '&.incorrect': {
                '& svg': {
                    color: '#dd2229'
                }
            },
            '&.correct': {
                '& svg': {
                    color: '#39c55a'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7scDk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanks);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(fillInTheBlanksStyles);
function FillInTheBlanks({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.wrapper,
                    children: answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.phrase, {
                                blanked
                            }),
                            children: phrase
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.wrapper,
                        children: question.answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.phrase, {
                                    blanked
                                }),
                                children: phrase
                            }, index))
                    })
                ]
            })
        ]
    });
}
function fillInTheBlanksStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            padding: '35px 0',
            fontSize: '12pt',
            "& .label": {
                display: "flex",
                marginBottom: 10,
                fontWeight: 'bold',
                '& > div': {
                    ...verticalCentering
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        correctAnswer: {
            marginTop: 30
        },
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        phrase: {
            ...verticalCentering,
            marginRight: 10,
            '&:last-child': {
                marginLeft: 0
            },
            '&.blanked': {
                borderBottom: 'solid 1px black'
            }
        },
        input: {
            border: 'none',
            borderBottom: 'solid 1px black'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6bBDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
var _utils = require("../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(openQuestionStyles);
function OpenQuestion({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate } = context;
    const expected = (0, _utils.htmlToText)(question.answer.html);
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                    className: classes.textarea,
                    maxRows: 5,
                    minRows: 5,
                    value: answer.value,
                    readOnly: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                        className: classes.textarea,
                        maxRows: 5,
                        minRows: 5,
                        value: expected,
                        readOnly: true
                    })
                ]
            })
        ]
    });
}
function openQuestionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                '&:last-child': {
                    marginTop: 20
                },
                '& .label': {
                    display: "flex",
                    marginBottom: 10,
                    fontWeight: 'bold',
                    '& > div': {
                        ...verticalCentering
                    }
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        textarea: {
            resize: 'none',
            width: 'auto',
            padding: 8,
            flexGrow: 1,
            borderRadius: '4px',
            border: 'solid 1px #c2c7ca'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","@mui/icons-material/CheckCircle":"crtKq","../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Nolp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _statusIcon = require("../components/StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(multipleChoiceStyles);
function MultipleChoice({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate } = context;
    const { properties: { singleOption } } = question;
    const { answers } = assessment;
    const { choices = [] } = question.answer;
    const Choices = singleOption ? RadioChoice : CheckboxChoice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
            context: context,
            question: question,
            choices: choices,
            answer: answers[question.id] || {}
        })
    });
}
function RadioChoice(props) {
    const { choices, answer } = props;
    const classes = useStyles();
    const correctChoice = choices.find((c)=>c.correct) || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: answer.selected,
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: choice.id,
                        answer: answer.selected,
                        correctAnswer: correctChoice.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: choice.id,
                            className: "choice",
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                color: "primary"
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: choice.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function CheckboxChoice({ context, question, choices, answer }) {
    const classes = useStyles();
    const { assessment } = context;
    const correct = (0, _lodash.difference)(choices.filter((c)=>c.correct).map((c)=>c.id), answer.selectedOptions).length == 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: choices.map((option, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            const checked = answer.selectedOptions.indexOf(option.id) >= 0;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: option.id,
                        answer: checked && option.id,
                        correctAnswer: option.correct && option.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.checkbox,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                color: "primary",
                                checked: checked
                            }),
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: option.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function multipleChoiceStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            paddingLeft: 10,
            fontSize: '12pt'
        },
        index: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 6
        },
        incorrect: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            visibility: 'hidden',
            color: "#fff",
            marginRight: 10,
            '& svg': {
                fill: '#f30d2a'
            },
            '&.visible': {
                visibility: 'visible'
            }
        },
        correct: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '& svg': {
                fill: '#27bc58'
            },
            marginRight: 10,
            visibility: 'hidden',
            '&.visible': {
                visibility: 'visible'
            }
        },
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@mui/material/FormGroup":"1gJha","@mui/material/Checkbox":"4sdMA","../components/StatusIcon":"k6stP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iibT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Matching);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _statusIcon = require("../components/StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(matchingStyles);
function Matching({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentToReview: assessment, translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {
        terms: [],
        definitions: []
    };
    const terms = answer.terms.map((term, index)=>{
        const value = answer.selected[index];
        const correctIndex = answer.definitions.findIndex((d)=>d.index == term.index);
        const indexToLetter = (index)=>String.fromCharCode(Math.min(index, 20) + 97);
        const answerIndex = indexToLetter(correctIndex);
        const correct = correctIndex == value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.correctAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.correct, {
                            correct
                        }),
                        children: answerIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.status),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: value,
                        answer: value,
                        correctAnswer: correctIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.selectAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.answer,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                            className: classes.termValue,
                            inputProps: {
                                readOnly: true
                            },
                            value: value,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: value,
                                children: value >= 0 ? indexToLetter(value) : ''
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    dangerouslySetInnerHTML: {
                        __html: term.term || ''
                    }
                })
            ]
        });
    });
    const definitions = answer.definitions.map(({ definition }, index)=>{
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionIndex, {
                        selected: answer.selected.indexOf(index) > -1
                    }),
                    size: "small",
                    children: [
                        answerIndex,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    dangerouslySetInnerHTML: {
                        __html: definition || ''
                    }
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _boxDefault.default),
            className: classes.tableContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                className: classes.table,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: (0, _lodash.zip)(terms, definitions).map(([term, definition], index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            className: classes.pair,
                            children: [
                                term,
                                definition
                            ]
                        }, index);
                    })
                })
            })
        })
    });
}
function matchingStyles(theme) {
    return {
        root: {
            display: 'flex',
            marginTop: 10,
            flexGrow: 1
        },
        tableContainer: {
            flexShrink: 0,
            maxWidth: 1280,
            display: 'flex',
            fontSize: '12pt'
        },
        correct: {
            display: 'flex',
            width: 35,
            height: 35,
            borderRadius: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            color: '#fff',
            backgroundColor: '#0bccd5',
            '&.correct': {
                visibility: 'hidden'
            }
        },
        cell: {
            borderBottom: 0,
            padding: '16px 8px',
            verticalAlign: 'top'
        },
        correctAnswer: {
            width: 35,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 35
        },
        status: {
            width: 30,
            maxWidth: 30,
            flexGrow: 0,
            flexShrink: 0,
            paddingTop: 22
        },
        selectAnswer: {
            width: 45,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 45
        },
        definitionIndex: {
            width: 20,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 20
        },
        table: {
            maxWidth: 1280
        },
        term: {
            display: 'flex'
        },
        termValue: {
            borderRadius: 3,
            paddingLeft: 8,
            justifyContent: 'center',
            '&:focus': {
                backgroundColor: 'transparent'
            },
            '&:before': {
                borderBottom: '0 !important'
            },
            '&:after': {
                borderBottom: 0
            }
        },
        termHtml: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        },
        definitionValue: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableRow":"4f4VX","@mui/material/Table":"if4Vw","@mui/material/Select":"aY7hn","../components/StatusIcon":"k6stP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hW59e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsIndicators);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _fab = require("@mui/material/Fab");
var _fabDefault = parcelHelpers.interopDefault(_fab);
var _avatar = require("@mui/material/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _dialog = require("@mui/material/Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _dialogTitle = require("@mui/material/DialogTitle");
var _dialogTitleDefault = parcelHelpers.interopDefault(_dialogTitle);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _standardsQuestions = require("./standards-questions");
var _standardsQuestionsDefault = parcelHelpers.interopDefault(_standardsQuestions);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function StandardsIndicators({ context, indicator, percent, pending, countAnswered, countTotal }) {
    const classes = (0, _stylesDefault.default)();
    const { quizStandardScale = {}, translate } = context;
    const { proficient, parcial, noProficient } = quizStandardScale[0] || {};
    const proScoreMaxLimit = proficient?.maxValue || 100;
    const proScoreMinLimit = proficient?.minValue || 75;
    const parcialScoreMaxLimit = parcial?.maxValue || 74;
    const parcialScoreMinLimit = parcial?.minValue || 60;
    const noProScoreMaxLimit = noProficient?.maxValue || 59;
    const noProScoreMinLimit = noProficient?.minValue || 0;
    const indicatorState = (percent, pending)=>pending ? '#fff' : percent <= proScoreMaxLimit && percent >= proScoreMinLimit ? proficient?.color : percent <= parcialScoreMaxLimit && percent >= parcialScoreMinLimit ? parcial?.color : percent <= noProScoreMaxLimit && percent >= noProScoreMinLimit ? noProficient?.color : '#fff';
    const [open, setOpen] = (0, _react.useState)(false);
    const [maxWidth, setMaxWidth] = (0, _react.useState)('md');
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: classes.tableCell,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fabDefault.default), {
                    variant: "extended",
                    size: "medium",
                    className: (0, _clsxDefault.default)(classes.indicatorLabel),
                    disableRipple: true,
                    disableFocusRipple: true,
                    style: {
                        "backgroundColor": indicatorState(percent, pending),
                        "cursor": "default"
                    },
                    children: indicator.code
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                className: classes.tableCell,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                        className: classes.questionBtn,
                        variant: "outlined",
                        onClick: handleClickOpen,
                        children: `${countAnswered}/${countTotal}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogDefault.default), {
                        onClose: handleClose,
                        fullWidth: "true",
                        maxWidth: maxWidth,
                        open: open,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _dialogTitleDefault.default), {
                                id: "customized-dialog-title",
                                onClose: handleClose,
                                children: [
                                    `${indicator.code}`,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                                        onClick: handleClose,
                                        sx: {
                                            position: 'absolute',
                                            right: 8,
                                            top: 8,
                                            color: (theme)=>theme.palette.grey[500]
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsQuestionsDefault.default), {
                                context: context,
                                questions: indicator.references
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: classes.tableCell,
                children: `${percent}%`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                className: (0, _clsxDefault.default)(classes.tableCell, classes.pendingCell),
                children: pending && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.statusWrapper,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                        className: classes.statusDot,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "R"
                        })
                    })
                })
            })
        ]
    }, indicator.id);
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","@mui/material/TableCell":"8Htaw","@mui/material/TableRow":"4f4VX","@mui/material/Fab":"9QkHI","@mui/material/Avatar":"4ltr6","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/material/Dialog":"255tO","@mui/material/DialogTitle":"5sOv1","@mui/icons-material/Close":"acjz6","./standards-questions":"kU1yg","./styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"alrFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsChart);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _chart = require("./components/chart");
var _chartDefault = parcelHelpers.interopDefault(_chart);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function StandardsChart({ context, standard, standardIndex }) {
    const classes = (0, _stylesDefault.default)();
    const { standardsContext, quizAssessmentToReview: standards, translate, quizStandardScale = {} } = context;
    const { assessmentIndicators, assessmentStandards } = standardsContext;
    const { proficient, parcial, noProficient } = quizStandardScale[0] || {};
    const proScoreMaxLimit = proficient?.maxValue || 100;
    const proScoreMinLimit = proficient?.minValue || 75;
    const parcialScoreMaxLimit = parcial?.maxValue || 74;
    const parcialScoreMinLimit = parcial?.minValue || 60;
    const noProScoreMaxLimit = noProficient?.maxValue || 59;
    const noProScoreMinLimit = noProficient?.minValue || 0;
    const scaleLabels = (value = 0)=>{
        return value <= proScoreMaxLimit && value >= proScoreMinLimit ? proficient : value <= parcialScoreMaxLimit && value >= parcialScoreMinLimit ? parcial : value <= noProScoreMaxLimit && value >= noProScoreMinLimit ? noProficient : '';
    };
    let countAnswered = 0;
    let countTotal = 0;
    let percent = 0;
    let chartValues = [];
    assessmentStandards.items.map((stds, index)=>{
        var pending = false;
        var codes = [];
        const hasReferences = stds.references.length > 0;
        const hasIndicators = Object.keys(assessmentIndicators).length > 0;
        chartValues.push({
            sectionId: stds.id,
            value: 0
        });
        if (hasReferences && hasIndicators) {
            countAnswered = 0;
            countTotal = 0;
            stds.references.map((row)=>{
                if (codes.indexOf(assessmentIndicators[row.id][0].code) === -1) {
                    codes.push(assessmentIndicators[row.id][0].code);
                    assessmentIndicators[row.id][0]?.references.forEach((question)=>{
                        if (standards.results[question.id].pending) pending = true;
                        else {
                            if (standards.results[question.id].points > 0) countAnswered++;
                            countTotal++;
                        }
                    });
                    percent = countAnswered / countTotal * 100;
                    chartValues[index].value = Math.round(percent);
                } else return;
            });
        } else {
            countAnswered = 0;
            countTotal = 0;
            stds.expectations.map((expectation)=>{
                if (codes.indexOf(expectation.description) === -1) {
                    codes.push(expectation.description);
                    expectation.references.forEach((question)=>{
                        if (standards.results[question.id].pending) pending = true;
                        else {
                            if (standards.results[question.id].points > 0) countAnswered++;
                            countTotal++;
                        }
                    });
                    percent = countAnswered / countTotal * 100;
                    chartValues[index].value = Math.round(percent);
                } else return;
            });
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        container: true,
        direction: "row",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                item: true,
                xs: 5,
                md: 5,
                className: classes.grid,
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.tableTitle,
                    children: standard.name
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                xs: 5,
                md: 5,
                className: classes.grid,
                justifyContent: "flex-end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.chart,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chartDefault.default), {
                            series: [
                                chartValues[standardIndex]?.value
                            ],
                            barColor: scaleLabels(chartValues[standardIndex]?.value)?.color,
                            color: "#66deba"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.chartTitle,
                        children: [
                            translate(`standards-${scaleLabels(chartValues[standardIndex]?.value)?.label}`),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.chartSubTitle,
                                children: `${scaleLabels(chartValues[standardIndex]?.value)?.maxValue}% - ${scaleLabels(chartValues[standardIndex]?.value)?.minValue}%`
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Box":"73kto","@mui/material/Grid":"ggUwv","./components/chart":"hK2O9","./styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hK2O9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Chart);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactApexcharts = require("react-apexcharts");
var _reactApexchartsDefault = parcelHelpers.interopDefault(_reactApexcharts);
const CHART_SIZE = {
    width: '125',
    height: '125'
};
function Chart(props) {
    const { type = "radialBar", series = [
        0
    ], barColor = '#111', color = '#888', subtitleText = "" } = props;
    const options = {
        series: [
            67
        ],
        colors: [
            barColor
        ],
        plotOptions: {
            radialBar: {
                hollow: {
                    margin: 15,
                    size: "50%"
                },
                dataLabels: {
                    showOn: "always",
                    name: {
                        show: false,
                        color,
                        fontSize: "16px"
                    },
                    value: {
                        offsetY: 7,
                        show: true,
                        color: "#000",
                        fontSize: "18px"
                    }
                }
            }
        },
        stroke: {
            lineCap: "round"
        },
        subtitle: {
            text: subtitleText,
            offsetY: 165,
            offsetX: 85,
            style: {
                fontSize: '1px',
                fontWeight: 'normal',
                color: '#9699a2'
            }
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactApexchartsDefault.default), {
        type: type,
        series: series,
        options: options,
        ...CHART_SIZE
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-apexcharts":"lEV8Y","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lEV8Y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), exports.default = Charts;
var _react = _interopRequireWildcard(require("a558e37992849081")), _apexcharts = _interopRequireDefault(require("da04fa78b9a71d7a")), _propTypes = _interopRequireDefault(require("2e2c019741f4d0")), _excluded = [
    "type",
    "width",
    "height",
    "series",
    "options"
];
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _getRequireWildcardCache(e) {
    var t, r;
    return "function" != typeof WeakMap ? null : (t = new WeakMap, r = new WeakMap, (_getRequireWildcardCache = function(e) {
        return e ? r : t;
    })(e));
}
function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        default: e
    };
    t = _getRequireWildcardCache(t);
    if (t && t.has(e)) return t.get(e);
    var r, n, o = {
        __proto__: null
    }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(r in e)"default" !== r && ({}).hasOwnProperty.call(e, r) && ((n = i ? Object.getOwnPropertyDescriptor(e, r) : null) && (n.get || n.set) ? Object.defineProperty(o, r, n) : o[r] = e[r]);
    return o.default = e, t && t.set(e, o), o;
}
function _extends() {
    return (_extends = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r, n = arguments[t];
            for(r in n)!({}).hasOwnProperty.call(n, r) || (e[r] = n[r]);
        }
        return e;
    }).apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var r, n = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) for(var o = Object.getOwnPropertySymbols(e), i = 0; i < o.length; i++)r = o[i], t.includes(r) || ({}).propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    return n;
}
function _objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var r, n = {};
    for(r in e)if (({}).hasOwnProperty.call(e, r)) {
        if (t.includes(r)) continue;
        n[r] = e[r];
    }
    return n;
}
function _typeof(e) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e;
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
}
function ownKeys(t, e) {
    var r, n = Object.keys(t);
    return Object.getOwnPropertySymbols && (r = Object.getOwnPropertySymbols(t), e && (r = r.filter(function(e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, r)), n;
}
function _objectSpread(t) {
    for(var e = 1; e < arguments.length; e++){
        var r = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ownKeys(Object(r), !0).forEach(function(e) {
            _defineProperty(t, e, r[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
        });
    }
    return t;
}
function _defineProperty(e, t, r) {
    return (t = _toPropertyKey(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function _toPropertyKey(e) {
    e = _toPrimitive(e, "string");
    return "symbol" == _typeof(e) ? e : e + "";
}
function _toPrimitive(e, t) {
    if ("object" != _typeof(e) || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 === r) return ("string" === t ? String : Number)(e);
    r = r.call(e, t || "default");
    if ("object" != _typeof(r)) return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
}
function omit(e, t) {
    var r = _objectSpread({}, e);
    return t.forEach(function(e) {
        delete r[e];
    }), r;
}
function deepEqual(e, t) {
    var r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : new WeakSet;
    if (e !== t) {
        if ("object" !== _typeof(e) || null === e || "object" !== _typeof(t) || null === t) return !1;
        if (!r.has(e) && !r.has(t)) {
            r.add(e), r.add(t);
            var n = Object.keys(e), o = Object.keys(t);
            if (n.length !== o.length) return !1;
            for(var i = 0, u = n; i < u.length; i++){
                var c = u[i];
                if (!o.includes(c) || !deepEqual(e[c], t[c], r)) return !1;
            }
        }
    }
    return !0;
}
function Charts(e) {
    function o(e) {
        return e && "object" === _typeof(e) && !Array.isArray(e);
    }
    var t = e.type, r = void 0 === t ? "line" : t, t = e.width, n = void 0 === t ? "100%" : t, t = e.height, i = void 0 === t ? "auto" : t, u = e.series, c = e.options, t = _objectWithoutProperties(e, _excluded), p = (0, _react.useRef)(null), a = (0, _react.useRef)(null), f = (0, _react.useRef)(), s = ((0, _react.useEffect)(function() {
        f.current = c;
        var e = p.current;
        return a.current = new _apexcharts.default(e, s()), a.current.render(), function() {
            a.current && "function" == typeof a.current.destroy && a.current.destroy();
        };
    }, []), (0, _react.useEffect)(function() {
        var e = !deepEqual(a.current.w.config.series, u), t = !deepEqual(f.current, c) || i !== a.current.opts.chart.height || n !== a.current.opts.chart.width;
        (e || t) && (!e || t ? a.current.updateOptions(s()) : a.current.updateSeries(u)), f.current = c;
    }, [
        c,
        u,
        i,
        n
    ]), function() {
        return l(c, {
            chart: {
                type: r,
                height: i,
                width: n
            },
            series: u
        });
    }), l = function(t, r) {
        var n = _objectSpread({}, t);
        return o(t) && o(r) && Object.keys(r).forEach(function(e) {
            o(r[e]) && e in t ? n[e] = l(t[e], r[e]) : Object.assign(n, _defineProperty({}, e, r[e]));
        }), n;
    }, e = omit(t, Object.keys(Charts.propTypes));
    return _react.default.createElement("div", _extends({
        ref: p
    }, e));
}
Charts.propTypes = {
    type: _propTypes.default.string.isRequired,
    series: _propTypes.default.array.isRequired,
    options: _propTypes.default.object.isRequired,
    width: _propTypes.default.oneOfType([
        _propTypes.default.string,
        _propTypes.default.number
    ]),
    height: _propTypes.default.oneOfType([
        _propTypes.default.string,
        _propTypes.default.number
    ])
};

},{"a558e37992849081":"9njXz","da04fa78b9a71d7a":"93box","2e2c019741f4d0":"bnNSm"}],"93box":[function(require,module,exports,__globalThis) {
/*!
 * ApexCharts v3.54.1
 * (c) 2018-2024 ApexCharts
 * Released under the MIT License.
 */ "use strict";
function t(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, a = Array(e); i < e; i++)a[i] = t[i];
    return a;
}
function e(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function i(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function a(t, e) {
    for(var i = 0; i < e.length; i++){
        var a = e[i];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, x(a.key), a);
    }
}
function s(t, e, i) {
    return e && a(t.prototype, e), i && a(t, i), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
function r(t, e) {
    var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (!i) {
        if (Array.isArray(t) || (i = v(t)) || e && t && "number" == typeof t.length) {
            i && (t = i);
            var a = 0, s = function() {};
            return {
                s: s,
                n: function() {
                    return a >= t.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t[a++]
                    };
                },
                e: function(t) {
                    throw t;
                },
                f: s
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r, o = !0, n = !1;
    return {
        s: function() {
            i = i.call(t);
        },
        n: function() {
            var t = i.next();
            return o = t.done, t;
        },
        e: function(t) {
            n = !0, r = t;
        },
        f: function() {
            try {
                o || null == i.return || i.return();
            } finally{
                if (n) throw r;
            }
        }
    };
}
function o(t) {
    var i = c();
    return function() {
        var a, s = l(t);
        if (i) {
            var r = l(this).constructor;
            a = Reflect.construct(s, arguments, r);
        } else a = s.apply(this, arguments);
        return function(t, i) {
            if (i && ("object" == typeof i || "function" == typeof i)) return i;
            if (void 0 !== i) throw new TypeError("Derived constructors may only return object or undefined");
            return e(t);
        }(this, a);
    };
}
function n(t, e, i) {
    return (e = x(e)) in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
function l(t) {
    return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, l(t);
}
function h(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && u(t, e);
}
function c() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (c = function() {
        return !!t;
    })();
}
function d(t, e) {
    var i = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        e && (a = a.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), i.push.apply(i, a);
    }
    return i;
}
function g(t) {
    for(var e = 1; e < arguments.length; e++){
        var i = null != arguments[e] ? arguments[e] : {};
        e % 2 ? d(Object(i), !0).forEach(function(e) {
            n(t, e, i[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : d(Object(i)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
        });
    }
    return t;
}
function u(t, e) {
    return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, u(t, e);
}
function f(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, e) {
        var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null != i) {
            var a, s, r, o, n = [], l = !0, h = !1;
            try {
                if (r = (i = i.call(t)).next, 0 === e) {
                    if (Object(i) !== i) return;
                    l = !1;
                } else for(; !(l = (a = r.call(i)).done) && (n.push(a.value), n.length !== e); l = !0);
            } catch (t) {
                h = !0, s = t;
            } finally{
                try {
                    if (!l && null != i.return && (o = i.return(), Object(o) !== o)) return;
                } finally{
                    if (h) throw s;
                }
            }
            return n;
        }
    }(t, e) || v(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function p(e) {
    return function(e) {
        if (Array.isArray(e)) return t(e);
    }(e) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(e) || v(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function x(t) {
    var e = function(t, e) {
        if ("object" != typeof t || !t) return t;
        var i = t[Symbol.toPrimitive];
        if (void 0 !== i) {
            var a = i.call(t, e || "default");
            if ("object" != typeof a) return a;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === e ? String : Number)(t);
    }(t, "string");
    return "symbol" == typeof e ? e : e + "";
}
function b(t) {
    return b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, b(t);
}
function v(e, i) {
    if (e) {
        if ("string" == typeof e) return t(e, i);
        var a = ({}).toString.call(e).slice(8, -1);
        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? t(e, i) : void 0;
    }
}
var m = function() {
    function t() {
        i(this, t);
    }
    return s(t, [
        {
            key: "shadeRGBColor",
            value: function(t, e) {
                var i = e.split(","), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = parseInt(i[0].slice(4), 10), o = parseInt(i[1], 10), n = parseInt(i[2], 10);
                return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - o) * s) + o) + "," + (Math.round((a - n) * s) + n) + ")";
            }
        },
        {
            key: "shadeHexColor",
            value: function(t, e) {
                var i = parseInt(e.slice(1), 16), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = i >> 16, o = i >> 8 & 255, n = 255 & i;
                return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - o) * s) + o) + (Math.round((a - n) * s) + n)).toString(16).slice(1);
            }
        },
        {
            key: "shadeColor",
            value: function(e, i) {
                return t.isColorHex(i) ? this.shadeHexColor(e, i) : this.shadeRGBColor(e, i);
            }
        }
    ], [
        {
            key: "bind",
            value: function(t, e) {
                return function() {
                    return t.apply(e, arguments);
                };
            }
        },
        {
            key: "isObject",
            value: function(t) {
                return t && "object" === b(t) && !Array.isArray(t) && null != t;
            }
        },
        {
            key: "is",
            value: function(t, e) {
                return Object.prototype.toString.call(e) === "[object " + t + "]";
            }
        },
        {
            key: "listToArray",
            value: function(t) {
                var e, i = [];
                for(e = 0; e < t.length; e++)i[e] = t[e];
                return i;
            }
        },
        {
            key: "extend",
            value: function(t, e) {
                var i = this;
                "function" != typeof Object.assign && (Object.assign = function(t) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for(var e = Object(t), i = 1; i < arguments.length; i++){
                        var a = arguments[i];
                        if (null != a) for(var s in a)a.hasOwnProperty(s) && (e[s] = a[s]);
                    }
                    return e;
                });
                var a = Object.assign({}, t);
                return this.isObject(t) && this.isObject(e) && Object.keys(e).forEach(function(s) {
                    i.isObject(e[s]) && s in t ? a[s] = i.extend(t[s], e[s]) : Object.assign(a, n({}, s, e[s]));
                }), a;
            }
        },
        {
            key: "extendArray",
            value: function(e, i) {
                var a = [];
                return e.map(function(e) {
                    a.push(t.extend(i, e));
                }), e = a;
            }
        },
        {
            key: "monthMod",
            value: function(t) {
                return t % 12;
            }
        },
        {
            key: "clone",
            value: function(e) {
                if (t.is("Array", e)) {
                    for(var i = [], a = 0; a < e.length; a++)i[a] = this.clone(e[a]);
                    return i;
                }
                if (t.is("Null", e)) return null;
                if (t.is("Date", e)) return e;
                if ("object" === b(e)) {
                    var s = {};
                    for(var r in e)e.hasOwnProperty(r) && (s[r] = this.clone(e[r]));
                    return s;
                }
                return e;
            }
        },
        {
            key: "log10",
            value: function(t) {
                return Math.log(t) / Math.LN10;
            }
        },
        {
            key: "roundToBase10",
            value: function(t) {
                return Math.pow(10, Math.floor(Math.log10(t)));
            }
        },
        {
            key: "roundToBase",
            value: function(t, e) {
                return Math.pow(e, Math.floor(Math.log(t) / Math.log(e)));
            }
        },
        {
            key: "parseNumber",
            value: function(t) {
                return null === t ? t : parseFloat(t);
            }
        },
        {
            key: "stripNumber",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
                return Number.isInteger(t) ? t : parseFloat(t.toPrecision(e));
            }
        },
        {
            key: "randomId",
            value: function() {
                return (Math.random() + 1).toString(36).substring(4);
            }
        },
        {
            key: "noExponents",
            value: function(t) {
                var e = String(t).split(/[eE]/);
                if (1 === e.length) return e[0];
                var i = "", a = t < 0 ? "-" : "", s = e[0].replace(".", ""), r = Number(e[1]) + 1;
                if (r < 0) {
                    for(i = a + "0."; r++;)i += "0";
                    return i + s.replace(/^-/, "");
                }
                for(r -= s.length; r--;)i += "0";
                return s + i;
            }
        },
        {
            key: "getDimensions",
            value: function(t) {
                var e = getComputedStyle(t, null), i = t.clientHeight, a = t.clientWidth;
                return i -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), [
                    a -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                    i
                ];
            }
        },
        {
            key: "getBoundingClientRect",
            value: function(t) {
                var e = t.getBoundingClientRect();
                return {
                    top: e.top,
                    right: e.right,
                    bottom: e.bottom,
                    left: e.left,
                    width: t.clientWidth,
                    height: t.clientHeight,
                    x: e.left,
                    y: e.top
                };
            }
        },
        {
            key: "getLargestStringFromArr",
            value: function(t) {
                return t.reduce(function(t, e) {
                    return Array.isArray(e) && (e = e.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    })), t.length > e.length ? t : e;
                }, 0);
            }
        },
        {
            key: "hexToRgba",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#999999", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .6;
                "#" !== t.substring(0, 1) && (t = "#999999");
                var i = t.replace("#", "");
                i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                for(var a = 0; a < i.length; a++)i[a] = parseInt(1 === i[a].length ? i[a] + i[a] : i[a], 16);
                return void 0 !== e && i.push(e), "rgba(" + i.join(",") + ")";
            }
        },
        {
            key: "getOpacityFromRGBA",
            value: function(t) {
                return parseFloat(t.replace(/^.*,(.+)\)/, "$1"));
            }
        },
        {
            key: "rgb2hex",
            value: function(t) {
                return (t = t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === t.length ? "#" + ("0" + parseInt(t[1], 10).toString(16)).slice(-2) + ("0" + parseInt(t[2], 10).toString(16)).slice(-2) + ("0" + parseInt(t[3], 10).toString(16)).slice(-2) : "";
            }
        },
        {
            key: "isColorHex",
            value: function(t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t);
            }
        },
        {
            key: "getPolygonPos",
            value: function(t, e) {
                for(var i = [], a = 2 * Math.PI / e, s = 0; s < e; s++){
                    var r = {};
                    r.x = t * Math.sin(s * a), r.y = -t * Math.cos(s * a), i.push(r);
                }
                return i;
            }
        },
        {
            key: "polarToCartesian",
            value: function(t, e, i, a) {
                var s = (a - 90) * Math.PI / 180;
                return {
                    x: t + i * Math.cos(s),
                    y: e + i * Math.sin(s)
                };
            }
        },
        {
            key: "escapeString",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x", i = t.toString().slice();
                return i = i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, e);
            }
        },
        {
            key: "negToZero",
            value: function(t) {
                return t < 0 ? 0 : t;
            }
        },
        {
            key: "moveIndexInArray",
            value: function(t, e, i) {
                if (i >= t.length) for(var a = i - t.length + 1; a--;)t.push(void 0);
                return t.splice(i, 0, t.splice(e, 1)[0]), t;
            }
        },
        {
            key: "extractNumber",
            value: function(t) {
                return parseFloat(t.replace(/[^\d.]*/g, ""));
            }
        },
        {
            key: "findAncestor",
            value: function(t, e) {
                for(; (t = t.parentElement) && !t.classList.contains(e););
                return t;
            }
        },
        {
            key: "setELstyles",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && (t.style.key = e[i]);
            }
        },
        {
            key: "preciseAddition",
            value: function(t, e) {
                var i = (String(t).split(".")[1] || "").length, a = (String(e).split(".")[1] || "").length, s = Math.pow(10, Math.max(i, a));
                return (Math.round(t * s) + Math.round(e * s)) / s;
            }
        },
        {
            key: "isNumber",
            value: function(t) {
                return !isNaN(t) && parseFloat(Number(t)) === t && !isNaN(parseInt(t, 10));
            }
        },
        {
            key: "isFloat",
            value: function(t) {
                return Number(t) === t && t % 1 != 0;
            }
        },
        {
            key: "isSafari",
            value: function() {
                return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        {
            key: "isFirefox",
            value: function() {
                return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
            }
        },
        {
            key: "isMsEdge",
            value: function() {
                var t = window.navigator.userAgent, e = t.indexOf("Edge/");
                return e > 0 && parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
            }
        },
        {
            key: "getGCD",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 7, a = Math.pow(10, i - Math.floor(Math.log10(Math.max(t, e))));
                for(t = Math.round(Math.abs(t) * a), e = Math.round(Math.abs(e) * a); e;){
                    var s = e;
                    e = t % e, t = s;
                }
                return t / a;
            }
        },
        {
            key: "getPrimeFactors",
            value: function(t) {
                for(var e = [], i = 2; t >= 2;)t % i == 0 ? (e.push(i), t /= i) : i++;
                return e;
            }
        },
        {
            key: "mod",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 7, a = Math.pow(10, i - Math.floor(Math.log10(Math.max(t, e))));
                return (t = Math.round(Math.abs(t) * a)) % (e = Math.round(Math.abs(e) * a)) / a;
            }
        }
    ]), t;
}(), y = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.setEasingFunctions();
    }
    return s(t, [
        {
            key: "setEasingFunctions",
            value: function() {
                var t;
                if (!this.w.globals.easing) {
                    switch(this.w.config.chart.animations.easing){
                        case "linear":
                            t = "-";
                            break;
                        case "easein":
                            t = "<";
                            break;
                        case "easeout":
                            t = ">";
                            break;
                        case "easeinout":
                        default:
                            t = "<>";
                            break;
                        case "swing":
                            t = function(t) {
                                var e = 1.70158;
                                return (t -= 1) * t * ((e + 1) * t + e) + 1;
                            };
                            break;
                        case "bounce":
                            t = function(t) {
                                return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
                            };
                            break;
                        case "elastic":
                            t = function(t) {
                                return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - .075) * (2 * Math.PI) / .3) + 1;
                            };
                    }
                    this.w.globals.easing = t;
                }
            }
        },
        {
            key: "animateLine",
            value: function(t, e, i, a) {
                t.attr(e).animate(a).attr(i);
            }
        },
        {
            key: "animateMarker",
            value: function(t, e, i, a) {
                t.attr({
                    opacity: 0
                }).animate(e, i).attr({
                    opacity: 1
                }).afterAll(function() {
                    a();
                });
            }
        },
        {
            key: "animateRect",
            value: function(t, e, i, a, s) {
                t.attr(e).animate(a).attr(i).afterAll(function() {
                    return s();
                });
            }
        },
        {
            key: "animatePathsGradually",
            value: function(t) {
                var e = t.el, i = t.realIndex, a = t.j, s = t.fill, r = t.pathFrom, o = t.pathTo, n = t.speed, l = t.delay, h = this.w, c = 0;
                h.config.chart.animations.animateGradually.enabled && (c = h.config.chart.animations.animateGradually.delay), h.config.chart.animations.dynamicAnimation.enabled && h.globals.dataChanged && "bar" !== h.config.chart.type && (c = 0), this.morphSVG(e, i, a, "line" !== h.config.chart.type || h.globals.comboCharts ? s : "stroke", r, o, n, l * c);
            }
        },
        {
            key: "showDelayedElements",
            value: function() {
                this.w.globals.delayedElements.forEach(function(t) {
                    var e = t.el;
                    e.classList.remove("apexcharts-element-hidden"), e.classList.add("apexcharts-hidden-element-shown");
                });
            }
        },
        {
            key: "animationCompleted",
            value: function(t) {
                var e = this.w;
                e.globals.animationEnded || (e.globals.animationEnded = !0, this.showDelayedElements(), "function" == typeof e.config.chart.events.animationEnd && e.config.chart.events.animationEnd(this.ctx, {
                    el: t,
                    w: e
                }));
            }
        },
        {
            key: "morphSVG",
            value: function(t, e, i, a, s, r, o, n) {
                var l = this, h = this.w;
                s || (s = t.attr("pathFrom")), r || (r = t.attr("pathTo"));
                var c = function(t) {
                    return "radar" === h.config.chart.type && (o = 1), "M 0 ".concat(h.globals.gridHeight);
                };
                (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = c()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = c()), h.globals.shouldAnimate || (o = 1), t.plot(s).animate(1, h.globals.easing, n).plot(s).animate(o, h.globals.easing, n).plot(r).afterAll(function() {
                    m.isNumber(i) ? i === h.globals.series[h.globals.maxValsInArrayIndex].length - 2 && h.globals.shouldAnimate && l.animationCompleted(t) : "none" !== a && h.globals.shouldAnimate && (!h.globals.comboCharts && e === h.globals.series.length - 1 || h.globals.comboCharts) && l.animationCompleted(t), l.showDelayedElements();
                });
            }
        }
    ]), t;
}(), w = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "getDefaultFilter",
            value: function(t, e) {
                var i = this.w;
                t.unfilter(!0), (new window.SVG.Filter).size("120%", "180%", "-5%", "-40%"), "none" !== i.config.states.normal.filter ? this.applyFilter(t, e, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addNormalFilter",
            value: function(t, e) {
                var i = this.w;
                i.config.chart.dropShadow.enabled && !t.node.classList.contains("apexcharts-marker") && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addLightenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: 1.5,
                            intercept: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "addDarkenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "applyFilter",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                switch(i){
                    case "none":
                        this.addNormalFilter(t, e);
                        break;
                    case "lighten":
                        this.addLightenFilter(t, e, {
                            intensity: a
                        });
                        break;
                    case "darken":
                        this.addDarkenFilter(t, e, {
                            intensity: a
                        });
                }
            }
        },
        {
            key: "addShadow",
            value: function(t, e, i) {
                var a, s = this.w, r = i.blur, o = i.top, n = i.left, l = i.color, h = i.opacity;
                if ((null === (a = s.config.chart.dropShadow.enabledOnSeries) || void 0 === a ? void 0 : a.length) > 0 && -1 === s.config.chart.dropShadow.enabledOnSeries.indexOf(e)) return t;
                var c = t.flood(Array.isArray(l) ? l[e] : l, h).composite(t.sourceAlpha, "in").offset(n, o).gaussianBlur(r).merge(t.source);
                return t.blend(t.source, c);
            }
        },
        {
            key: "dropShadow",
            value: function(t, e) {
                var i, a, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, r = e.top, o = e.left, n = e.blur, l = e.color, h = e.opacity, c = e.noUserSpaceOnUse, d = this.w;
                if (t.unfilter(!0), m.isMsEdge() && "radialBar" === d.config.chart.type) return t;
                if ((null === (i = d.config.chart.dropShadow.enabledOnSeries) || void 0 === i ? void 0 : i.length) > 0 && -1 === (null === (a = d.config.chart.dropShadow.enabledOnSeries) || void 0 === a ? void 0 : a.indexOf(s))) return t;
                return l = Array.isArray(l) ? l[s] : l, t.filter(function(t) {
                    var e = null;
                    e = m.isSafari() || m.isFirefox() || m.isMsEdge() ? t.flood(l, h).composite(t.sourceAlpha, "in").offset(o, r).gaussianBlur(n) : t.flood(l, h).composite(t.sourceAlpha, "in").offset(o, r).gaussianBlur(n).merge(t.source), t.blend(t.source, e);
                }), c || t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node), t;
            }
        },
        {
            key: "setSelectionFilter",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.globals.selectedDataPoints[e] && a.globals.selectedDataPoints[e].indexOf(i) > -1) {
                    t.node.setAttribute("selected", !0);
                    var s = a.config.states.active.filter;
                    "none" !== s && this.applyFilter(t, e, s.type, s.value);
                }
            }
        },
        {
            key: "_scaleFilterSize",
            value: function(t) {
                !function(e) {
                    for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
                }({
                    width: "200%",
                    height: "200%",
                    x: "-50%",
                    y: "-50%"
                });
            }
        }
    ]), t;
}(), k = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "roundPathCorners",
            value: function(t, e) {
                function i(t, e, i) {
                    var s = e.x - t.x, r = e.y - t.y, o = Math.sqrt(s * s + r * r);
                    return a(t, e, Math.min(1, i / o));
                }
                function a(t, e, i) {
                    return {
                        x: t.x + (e.x - t.x) * i,
                        y: t.y + (e.y - t.y) * i
                    };
                }
                function s(t, e) {
                    t.length > 2 && (t[t.length - 2] = e.x, t[t.length - 1] = e.y);
                }
                function r(t) {
                    return {
                        x: parseFloat(t[t.length - 2]),
                        y: parseFloat(t[t.length - 1])
                    };
                }
                t.indexOf("NaN") > -1 && (t = "");
                var o = t.split(/[,\s]/).reduce(function(t, e) {
                    var i = e.match("([a-zA-Z])(.+)");
                    return i ? (t.push(i[1]), t.push(i[2])) : t.push(e), t;
                }, []).reduce(function(t, e) {
                    return parseFloat(e) == e && t.length ? t[t.length - 1].push(e) : t.push([
                        e
                    ]), t;
                }, []), n = [];
                if (o.length > 1) {
                    var l = r(o[0]), h = null;
                    "Z" == o[o.length - 1][0] && o[0].length > 2 && (h = [
                        "L",
                        l.x,
                        l.y
                    ], o[o.length - 1] = h), n.push(o[0]);
                    for(var c = 1; c < o.length; c++){
                        var d = n[n.length - 1], g = o[c], u = g == h ? o[1] : o[c + 1];
                        if (u && d && d.length > 2 && "L" == g[0] && u.length > 2 && "L" == u[0]) {
                            var f, p, x = r(d), b = r(g), v = r(u);
                            f = i(b, x, e), p = i(b, v, e), s(g, f), g.origPoint = b, n.push(g);
                            var m = a(f, b, .5), y = a(b, p, .5), w = [
                                "C",
                                m.x,
                                m.y,
                                y.x,
                                y.y,
                                p.x,
                                p.y
                            ];
                            w.origPoint = b, n.push(w);
                        } else n.push(g);
                    }
                    if (h) {
                        var k = r(n[n.length - 1]);
                        n.push([
                            "Z"
                        ]), s(n[0], k);
                    }
                } else n = o;
                return n.reduce(function(t, e) {
                    return t + e.join(" ") + " ";
                }, "");
            }
        },
        {
            key: "drawLine",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "butt";
                return this.w.globals.dom.Paper.line().attr({
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: a,
                    stroke: s,
                    "stroke-dasharray": r,
                    "stroke-width": o,
                    "stroke-linecap": n
                });
            }
        },
        {
            key: "drawRect",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "#fefefe", o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null, h = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0, c = this.w.globals.dom.Paper.rect();
                return c.attr({
                    x: t,
                    y: e,
                    width: i > 0 ? i : 0,
                    height: a > 0 ? a : 0,
                    rx: s,
                    ry: s,
                    opacity: o,
                    "stroke-width": null !== n ? n : 0,
                    stroke: null !== l ? l : "none",
                    "stroke-dasharray": h
                }), c.node.setAttribute("fill", r), c;
            }
        },
        {
            key: "drawPolygon",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "none";
                return this.w.globals.dom.Paper.polygon(t).attr({
                    fill: a,
                    stroke: e,
                    "stroke-width": i
                });
            }
        },
        {
            key: "drawCircle",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                t < 0 && (t = 0);
                var i = this.w.globals.dom.Paper.circle(2 * t);
                return null !== e && i.attr(e), i;
            }
        },
        {
            key: "drawPath",
            value: function(t) {
                var e = t.d, i = void 0 === e ? "" : e, a = t.stroke, s = void 0 === a ? "#a8a8a8" : a, r = t.strokeWidth, o = void 0 === r ? 1 : r, n = t.fill, l = t.fillOpacity, h = void 0 === l ? 1 : l, c = t.strokeOpacity, d = void 0 === c ? 1 : c, g = t.classes, u = t.strokeLinecap, f = void 0 === u ? null : u, p = t.strokeDashArray, x = void 0 === p ? 0 : p, b = this.w;
                return null === f && (f = b.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(b.globals.gridHeight)), b.globals.dom.Paper.path(i).attr({
                    fill: n,
                    "fill-opacity": h,
                    stroke: s,
                    "stroke-opacity": d,
                    "stroke-linecap": f,
                    "stroke-width": o,
                    "stroke-dasharray": x,
                    class: g
                });
            }
        },
        {
            key: "group",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w.globals.dom.Paper.group();
                return null !== t && e.attr(t), e;
            }
        },
        {
            key: "move",
            value: function(t, e) {
                var i = [
                    "M",
                    t,
                    e
                ].join(" ");
                return i;
            }
        },
        {
            key: "line",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = null;
                return null === i ? a = [
                    " L",
                    t,
                    e
                ].join(" ") : "H" === i ? a = [
                    " H",
                    t
                ].join(" ") : "V" === i && (a = [
                    " V",
                    e
                ].join(" ")), a;
            }
        },
        {
            key: "curve",
            value: function(t, e, i, a, s, r) {
                var o = [
                    "C",
                    t,
                    e,
                    i,
                    a,
                    s,
                    r
                ].join(" ");
                return o;
            }
        },
        {
            key: "quadraticCurve",
            value: function(t, e, i, a) {
                return [
                    "Q",
                    t,
                    e,
                    i,
                    a
                ].join(" ");
            }
        },
        {
            key: "arc",
            value: function(t, e, i, a, s, r, o) {
                var n = "A";
                arguments.length > 7 && void 0 !== arguments[7] && arguments[7] && (n = "a");
                var l = [
                    n,
                    t,
                    e,
                    i,
                    a,
                    s,
                    r,
                    o
                ].join(" ");
                return l;
            }
        },
        {
            key: "renderPaths",
            value: function(t) {
                var e, i = t.j, a = t.realIndex, s = t.pathFrom, r = t.pathTo, o = t.stroke, n = t.strokeWidth, l = t.strokeLinecap, h = t.fill, c = t.animationDelay, d = t.initialSpeed, u = t.dataChangeSpeed, f = t.className, p = t.chartType, x = t.shouldClipToGrid, b = void 0 === x || x, v = t.bindEventsOnPaths, m = void 0 === v || v, k = t.drawShadow, A = void 0 === k || k, S = this.w, C = new w(this.ctx), L = new y(this.ctx), P = this.w.config.chart.animations.enabled, M = P && this.w.config.chart.animations.dynamicAnimation.enabled, I = !!(P && !S.globals.resized || M && S.globals.dataChanged && S.globals.shouldAnimate);
                I ? e = s : (e = r, S.globals.animationEnded = !0);
                var T = S.config.stroke.dashArray, z = 0;
                z = Array.isArray(T) ? T[a] : S.config.stroke.dashArray;
                var X = this.drawPath({
                    d: e,
                    stroke: o,
                    strokeWidth: n,
                    fill: h,
                    fillOpacity: 1,
                    classes: f,
                    strokeLinecap: l,
                    strokeDashArray: z
                });
                if (X.attr("index", a), b && ("bar" === p && !S.globals.isHorizontal || S.globals.comboCharts ? X.attr({
                    "clip-path": "url(#gridRectBarMask".concat(S.globals.cuid, ")")
                }) : X.attr({
                    "clip-path": "url(#gridRectMask".concat(S.globals.cuid, ")")
                })), "none" !== S.config.states.normal.filter.type) C.getDefaultFilter(X, a);
                else if (S.config.chart.dropShadow.enabled && A) {
                    var E = S.config.chart.dropShadow;
                    C.dropShadow(X, E, a);
                }
                m && (X.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, X)), X.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, X)), X.node.addEventListener("mousedown", this.pathMouseDown.bind(this, X))), X.attr({
                    pathTo: r,
                    pathFrom: s
                });
                var Y = {
                    el: X,
                    j: i,
                    realIndex: a,
                    pathFrom: s,
                    pathTo: r,
                    fill: h,
                    strokeWidth: n,
                    delay: c
                };
                return !P || S.globals.resized || S.globals.dataChanged ? !S.globals.resized && S.globals.dataChanged || L.showDelayedElements() : L.animatePathsGradually(g(g({}, Y), {}, {
                    speed: d
                })), S.globals.dataChanged && M && I && L.animatePathsGradually(g(g({}, Y), {}, {
                    speed: u
                })), X;
            }
        },
        {
            key: "drawPattern",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                return this.w.globals.dom.Paper.pattern(e, i, function(r) {
                    "horizontalLines" === t ? r.line(0, 0, i, 0).stroke({
                        color: a,
                        width: s + 1
                    }) : "verticalLines" === t ? r.line(0, 0, 0, e).stroke({
                        color: a,
                        width: s + 1
                    }) : "slantedLines" === t ? r.line(0, 0, e, i).stroke({
                        color: a,
                        width: s
                    }) : "squares" === t ? r.rect(e, i).fill("none").stroke({
                        color: a,
                        width: s
                    }) : "circles" === t && r.circle(e).fill("none").stroke({
                        color: a,
                        width: s
                    });
                });
            }
        },
        {
            key: "drawGradient",
            value: function(t, e, i, a, s) {
                var r, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, n = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, h = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, c = this.w;
                e.length < 9 && 0 === e.indexOf("#") && (e = m.hexToRgba(e, a)), i.length < 9 && 0 === i.indexOf("#") && (i = m.hexToRgba(i, s));
                var d = 0, g = 1, u = 1, f = null;
                null !== n && (d = void 0 !== n[0] ? n[0] / 100 : 0, g = void 0 !== n[1] ? n[1] / 100 : 1, u = void 0 !== n[2] ? n[2] / 100 : 1, f = void 0 !== n[3] ? n[3] / 100 : null);
                var p = !("donut" !== c.config.chart.type && "pie" !== c.config.chart.type && "polarArea" !== c.config.chart.type && "bubble" !== c.config.chart.type);
                if (r = null === l || 0 === l.length ? c.globals.dom.Paper.gradient(p ? "radial" : "linear", function(t) {
                    t.at(d, e, a), t.at(g, i, s), t.at(u, i, s), null !== f && t.at(f, e, a);
                }) : c.globals.dom.Paper.gradient(p ? "radial" : "linear", function(t) {
                    (Array.isArray(l[h]) ? l[h] : l).forEach(function(e) {
                        t.at(e.offset / 100, e.color, e.opacity);
                    });
                }), p) {
                    var x = c.globals.gridWidth / 2, b = c.globals.gridHeight / 2;
                    "bubble" !== c.config.chart.type ? r.attr({
                        gradientUnits: "userSpaceOnUse",
                        cx: x,
                        cy: b,
                        r: o
                    }) : r.attr({
                        cx: .5,
                        cy: .5,
                        r: .8,
                        fx: .2,
                        fy: .2
                    });
                } else "vertical" === t ? r.from(0, 0).to(0, 1) : "diagonal" === t ? r.from(0, 0).to(1, 1) : "horizontal" === t ? r.from(0, 1).to(1, 1) : "diagonal2" === t && r.from(1, 0).to(0, 1);
                return r;
            }
        },
        {
            key: "getTextBasedOnMaxWidth",
            value: function(t) {
                var e = t.text, i = t.maxWidth, a = t.fontSize, s = t.fontFamily, r = this.getTextRects(e, a, s), o = r.width / e.length, n = Math.floor(i / o);
                return i < r.width ? e.slice(0, n - 3) + "..." : e;
            }
        },
        {
            key: "drawText",
            value: function(t) {
                var e = this, i = t.x, a = t.y, s = t.text, r = t.textAnchor, o = t.fontSize, n = t.fontFamily, l = t.fontWeight, h = t.foreColor, c = t.opacity, d = t.maxWidth, u = t.cssClass, f = void 0 === u ? "" : u, p = t.isPlainText, x = void 0 === p || p, b = t.dominantBaseline, v = void 0 === b ? "auto" : b, m = this.w;
                void 0 === s && (s = "");
                var y = s;
                r || (r = "start"), h && h.length || (h = m.config.chart.foreColor), n = n || m.config.chart.fontFamily, l = l || "regular";
                var w, k = {
                    maxWidth: d,
                    fontSize: o = o || "11px",
                    fontFamily: n
                };
                return Array.isArray(s) ? w = m.globals.dom.Paper.text(function(t) {
                    for(var i = 0; i < s.length; i++)y = s[i], d && (y = e.getTextBasedOnMaxWidth(g({
                        text: s[i]
                    }, k))), 0 === i ? t.tspan(y) : t.tspan(y).newLine();
                }) : (d && (y = this.getTextBasedOnMaxWidth(g({
                    text: s
                }, k))), w = x ? m.globals.dom.Paper.plain(s) : m.globals.dom.Paper.text(function(t) {
                    return t.tspan(y);
                })), w.attr({
                    x: i,
                    y: a,
                    "text-anchor": r,
                    "dominant-baseline": v,
                    "font-size": o,
                    "font-family": n,
                    "font-weight": l,
                    fill: h,
                    class: "apexcharts-text " + f
                }), w.node.style.fontFamily = n, w.node.style.opacity = c, w;
            }
        },
        {
            key: "getMarkerPath",
            value: function(t, e, i, a) {
                var s = "";
                switch(i){
                    case "cross":
                        s = "M ".concat(t - (a /= 1.4), " ").concat(e - a, " L ").concat(t + a, " ").concat(e + a, "  M ").concat(t - a, " ").concat(e + a, " L ").concat(t + a, " ").concat(e - a);
                        break;
                    case "plus":
                        s = "M ".concat(t - (a /= 1.12), " ").concat(e, " L ").concat(t + a, " ").concat(e, "  M ").concat(t, " ").concat(e - a, " L ").concat(t, " ").concat(e + a);
                        break;
                    case "star":
                    case "sparkle":
                        var r = 5;
                        a *= 1.15, "sparkle" === i && (a /= 1.1, r = 4);
                        for(var o = Math.PI / r, n = 0; n <= 2 * r; n++){
                            var l = n * o, h = n % 2 == 0 ? a : a / 2;
                            s += (0 === n ? "M" : "L") + (t + h * Math.sin(l)) + "," + (e - h * Math.cos(l));
                        }
                        s += "Z";
                        break;
                    case "triangle":
                        s = "M ".concat(t, " ").concat(e - a, " \n             L ").concat(t + a, " ").concat(e + a, " \n             L ").concat(t - a, " ").concat(e + a, " \n             Z");
                        break;
                    case "square":
                    case "rect":
                        s = "M ".concat(t - (a /= 1.125), " ").concat(e - a, " \n           L ").concat(t + a, " ").concat(e - a, " \n           L ").concat(t + a, " ").concat(e + a, " \n           L ").concat(t - a, " ").concat(e + a, " \n           Z");
                        break;
                    case "diamond":
                        a *= 1.05, s = "M ".concat(t, " ").concat(e - a, " \n             L ").concat(t + a, " ").concat(e, " \n             L ").concat(t, " ").concat(e + a, " \n             L ").concat(t - a, " ").concat(e, " \n            Z");
                        break;
                    case "line":
                        s = "M ".concat(t - (a /= 1.1), " ").concat(e, " \n           L ").concat(t + a, " ").concat(e);
                        break;
                    default:
                        a *= 2, s = "M ".concat(t, ", ").concat(e, " \n           m -").concat(a / 2, ", 0 \n           a ").concat(a / 2, ",").concat(a / 2, " 0 1,0 ").concat(a, ",0 \n           a ").concat(a / 2, ",").concat(a / 2, " 0 1,0 -").concat(a, ",0");
                }
                return s;
            }
        },
        {
            key: "drawMarkerShape",
            value: function(t, e, i, a, s) {
                var r = this.drawPath({
                    d: this.getMarkerPath(t, e, i, a, s),
                    stroke: s.pointStrokeColor,
                    strokeDashArray: s.pointStrokeDashArray,
                    strokeWidth: s.pointStrokeWidth,
                    fill: s.pointFillColor,
                    fillOpacity: s.pointFillOpacity,
                    strokeOpacity: s.pointStrokeOpacity
                });
                return r.attr({
                    cx: t,
                    cy: e,
                    shape: s.shape,
                    class: s.class ? s.class : ""
                }), r;
            }
        },
        {
            key: "drawMarker",
            value: function(t, e, i) {
                t = t || 0;
                var a = i.pSize || 0;
                return m.isNumber(e) || (a = 0, e = 0), this.drawMarkerShape(t, e, null == i ? void 0 : i.shape, a, g(g({}, i), "line" === i.shape || "plus" === i.shape || "cross" === i.shape ? {
                    pointStrokeColor: i.pointFillColor,
                    pointStrokeOpacity: i.pointFillOpacity
                } : {}));
            }
        },
        {
            key: "pathMouseEnter",
            value: function(t, e) {
                var i = this.w, a = new w(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                if ("function" == typeof i.config.chart.events.dataPointMouseEnter && i.config.chart.events.dataPointMouseEnter(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), ("none" === i.config.states.active.filter.type || "true" !== t.node.getAttribute("selected")) && "none" !== i.config.states.hover.filter.type && !i.globals.isTouchDevice) {
                    var o = i.config.states.hover.filter;
                    a.applyFilter(t, s, o.type, o.value);
                }
            }
        },
        {
            key: "pathMouseLeave",
            value: function(t, e) {
                var i = this.w, a = new w(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                "function" == typeof i.config.chart.events.dataPointMouseLeave && i.config.chart.events.dataPointMouseLeave(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), "none" !== i.config.states.active.filter.type && "true" === t.node.getAttribute("selected") || "none" !== i.config.states.hover.filter.type && a.getDefaultFilter(t, s);
            }
        },
        {
            key: "pathMouseDown",
            value: function(t, e) {
                var i = this.w, a = new w(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10), o = "false";
                if ("true" === t.node.getAttribute("selected")) {
                    if (t.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                        var n = i.globals.selectedDataPoints[s].indexOf(r);
                        i.globals.selectedDataPoints[s].splice(n, 1);
                    }
                } else {
                    if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                        i.globals.selectedDataPoints = [];
                        var l = i.globals.dom.Paper.select(".apexcharts-series path").members, h = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members, c = function(t) {
                            Array.prototype.forEach.call(t, function(t) {
                                t.node.setAttribute("selected", "false"), a.getDefaultFilter(t, s);
                            });
                        };
                        c(l), c(h);
                    }
                    t.node.setAttribute("selected", "true"), o = "true", void 0 === i.globals.selectedDataPoints[s] && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                }
                if ("true" === o) {
                    var d = i.config.states.active.filter;
                    if ("none" !== d) a.applyFilter(t, s, d.type, d.value);
                    else if ("none" !== i.config.states.hover.filter && !i.globals.isTouchDevice) {
                        var g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                } else if ("none" !== i.config.states.active.filter.type) {
                    if ("none" === i.config.states.hover.filter.type || i.globals.isTouchDevice) a.getDefaultFilter(t, s);
                    else {
                        g = i.config.states.hover.filter;
                        a.applyFilter(t, s, g.type, g.value);
                    }
                }
                "function" == typeof i.config.chart.events.dataPointSelection && i.config.chart.events.dataPointSelection(e, this.ctx, {
                    selectedDataPoints: i.globals.selectedDataPoints,
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), e && this.ctx.events.fireEvent("dataPointSelection", [
                    e,
                    this.ctx,
                    {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]);
            }
        },
        {
            key: "rotateAroundCenter",
            value: function(t) {
                var e = {};
                return t && "function" == typeof t.getBBox && (e = t.getBBox()), {
                    x: e.x + e.width / 2,
                    y: e.y + e.height / 2
                };
            }
        },
        {
            key: "getTextRects",
            value: function(t, e, i, a) {
                var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = this.w, o = this.drawText({
                    x: -200,
                    y: -200,
                    text: t,
                    textAnchor: "start",
                    fontSize: e,
                    fontFamily: i,
                    foreColor: "#fff",
                    opacity: 0
                });
                a && o.attr("transform", a), r.globals.dom.Paper.add(o);
                var n = o.bbox();
                return s || (n = o.node.getBoundingClientRect()), o.remove(), {
                    width: n.width,
                    height: n.height
                };
            }
        },
        {
            key: "placeTextWithEllipsis",
            value: function(t, e, i) {
                if ("function" == typeof t.getComputedTextLength && (t.textContent = e, e.length > 0 && t.getComputedTextLength() >= i / 1.1)) {
                    for(var a = e.length - 3; a > 0; a -= 3)if (t.getSubStringLength(0, a) <= i / 1.1) return void (t.textContent = e.substring(0, a) + "...");
                    t.textContent = ".";
                }
            }
        }
    ], [
        {
            key: "setAttrs",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
            }
        }
    ]), t;
}(), A = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "getStackedSeriesTotals",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = this.w, i = [];
                if (0 === e.globals.series.length) return i;
                for(var a = 0; a < e.globals.series[e.globals.maxValsInArrayIndex].length; a++){
                    for(var s = 0, r = 0; r < e.globals.series.length; r++)void 0 !== e.globals.series[r][a] && -1 === t.indexOf(r) && (s += e.globals.series[r][a]);
                    i.push(s);
                }
                return i;
            }
        },
        {
            key: "getSeriesTotalByIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return null === t ? this.w.config.series.reduce(function(t, e) {
                    return t + e;
                }, 0) : this.w.globals.series[t].reduce(function(t, e) {
                    return t + e;
                }, 0);
            }
        },
        {
            key: "getStackedSeriesTotalsByGroups",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.globals.seriesGroups.forEach(function(a) {
                    var s = [];
                    e.config.series.forEach(function(t, i) {
                        a.indexOf(e.globals.seriesNames[i]) > -1 && s.push(i);
                    });
                    var r = e.globals.series.map(function(t, e) {
                        return -1 === s.indexOf(e) ? e : -1;
                    }).filter(function(t) {
                        return -1 !== t;
                    });
                    i.push(t.getStackedSeriesTotals(r));
                }), i;
            }
        },
        {
            key: "setSeriesYAxisMappings",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = [], a = [], s = [], r = t.series.length > e.yaxis.length || e.yaxis.some(function(t) {
                    return Array.isArray(t.seriesName);
                });
                e.series.forEach(function(t, e) {
                    s.push(e), a.push(null);
                }), e.yaxis.forEach(function(t, e) {
                    i[e] = [];
                });
                var o = [];
                e.yaxis.forEach(function(t, a) {
                    var n = !1;
                    if (t.seriesName) {
                        var l = [];
                        Array.isArray(t.seriesName) ? l = t.seriesName : l.push(t.seriesName), l.forEach(function(t) {
                            e.series.forEach(function(e, o) {
                                if (e.name === t) {
                                    var l = o;
                                    a === o || r ? !r || s.indexOf(o) > -1 ? i[a].push([
                                        a,
                                        o
                                    ]) : console.warn("Series '" + e.name + "' referenced more than once in what looks like the new style. That is, when using either seriesName: [], or when there are more series than yaxes.") : (i[o].push([
                                        o,
                                        a
                                    ]), l = a), n = !0, -1 !== (l = s.indexOf(l)) && s.splice(l, 1);
                                }
                            });
                        });
                    }
                    n || o.push(a);
                }), i = i.map(function(t, e) {
                    var i = [];
                    return t.forEach(function(t) {
                        a[t[1]] = t[0], i.push(t[1]);
                    }), i;
                });
                for(var n = e.yaxis.length - 1, l = 0; l < o.length && (n = o[l], i[n] = [], s); l++){
                    var h = s[0];
                    s.shift(), i[n].push(h), a[h] = n;
                }
                s.forEach(function(t) {
                    i[n].push(t), a[t] = n;
                }), t.seriesYAxisMap = i.map(function(t) {
                    return t;
                }), t.seriesYAxisReverseMap = a.map(function(t) {
                    return t;
                }), t.seriesYAxisMap.forEach(function(t, i) {
                    t.forEach(function(t) {
                        e.series[t] && void 0 === e.series[t].group && (e.series[t].group = "apexcharts-axis-".concat(i.toString()));
                    });
                });
            }
        },
        {
            key: "isSeriesNull",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return 0 === (null === t ? this.w.config.series.filter(function(t) {
                    return null !== t;
                }) : this.w.config.series[t].data.filter(function(t) {
                    return null !== t;
                })).length;
            }
        },
        {
            key: "seriesHaveSameValues",
            value: function(t) {
                return this.w.globals.series[t].every(function(t, e, i) {
                    return t === i[0];
                });
            }
        },
        {
            key: "getCategoryLabels",
            value: function(t) {
                var e = this.w, i = t.slice();
                return e.config.xaxis.convertedCatToNumeric && (i = t.map(function(t, i) {
                    return e.config.xaxis.labels.formatter(t - e.globals.minX + 1);
                })), i;
            }
        },
        {
            key: "getLargestSeries",
            value: function() {
                var t = this.w;
                t.globals.maxValsInArrayIndex = t.globals.series.map(function(t) {
                    return t.length;
                }).indexOf(Math.max.apply(Math, t.globals.series.map(function(t) {
                    return t.length;
                })));
            }
        },
        {
            key: "getLargestMarkerSize",
            value: function() {
                var t = this.w, e = 0;
                return t.globals.markers.size.forEach(function(t) {
                    e = Math.max(e, t);
                }), t.config.markers.discrete && t.config.markers.discrete.length && t.config.markers.discrete.forEach(function(t) {
                    e = Math.max(e, t.size);
                }), e > 0 && (t.config.markers.hover.size > 0 ? e = t.config.markers.hover.size : e += t.config.markers.hover.sizeOffset), t.globals.markers.largestSize = e, e;
            }
        },
        {
            key: "getSeriesTotals",
            value: function() {
                var t = this.w;
                t.globals.seriesTotals = t.globals.series.map(function(t, e) {
                    var i = 0;
                    if (Array.isArray(t)) for(var a = 0; a < t.length; a++)i += t[a];
                    else i += t;
                    return i;
                });
            }
        },
        {
            key: "getSeriesTotalsXRange",
            value: function(t, e) {
                var i = this.w;
                return i.globals.series.map(function(a, s) {
                    for(var r = 0, o = 0; o < a.length; o++)i.globals.seriesX[s][o] > t && i.globals.seriesX[s][o] < e && (r += a[o]);
                    return r;
                });
            }
        },
        {
            key: "getPercentSeries",
            value: function() {
                var t = this.w;
                t.globals.seriesPercent = t.globals.series.map(function(e, i) {
                    var a = [];
                    if (Array.isArray(e)) for(var s = 0; s < e.length; s++){
                        var r = t.globals.stackedSeriesTotals[s], o = 0;
                        r && (o = 100 * e[s] / r), a.push(o);
                    }
                    else {
                        var n = 100 * e / t.globals.seriesTotals.reduce(function(t, e) {
                            return t + e;
                        }, 0);
                        a.push(n);
                    }
                    return a;
                });
            }
        },
        {
            key: "getCalculatedRatios",
            value: function() {
                var t, e, i, a = this, s = this.w, r = s.globals, o = [], n = 0, l = [], h = .1, c = 0;
                if (r.yRange = [], r.isMultipleYAxis) for(var d = 0; d < r.minYArr.length; d++)r.yRange.push(Math.abs(r.minYArr[d] - r.maxYArr[d])), l.push(0);
                else r.yRange.push(Math.abs(r.minY - r.maxY));
                r.xRange = Math.abs(r.maxX - r.minX), r.zRange = Math.abs(r.maxZ - r.minZ);
                for(var g = 0; g < r.yRange.length; g++)o.push(r.yRange[g] / r.gridHeight);
                if (e = r.xRange / r.gridWidth, t = r.yRange / r.gridWidth, i = r.xRange / r.gridHeight, (n = r.zRange / r.gridHeight * 16) || (n = 1), r.minY !== Number.MIN_VALUE && 0 !== Math.abs(r.minY) && (r.hasNegs = !0), s.globals.seriesYAxisReverseMap.length > 0) {
                    var u = function(t, e) {
                        var i = s.config.yaxis[s.globals.seriesYAxisReverseMap[e]], r = t < 0 ? -1 : 1;
                        return t = Math.abs(t), i.logarithmic && (t = a.getBaseLog(i.logBase, t)), -r * t / o[e];
                    };
                    if (r.isMultipleYAxis) {
                        l = [];
                        for(var f = 0; f < o.length; f++)l.push(u(r.minYArr[f], f));
                    } else (l = []).push(u(r.minY, 0)), r.minY !== Number.MIN_VALUE && 0 !== Math.abs(r.minY) && (h = -r.minY / t, c = r.minX / e);
                } else (l = []).push(0), h = 0, c = 0;
                return {
                    yRatio: o,
                    invertedYRatio: t,
                    zRatio: n,
                    xRatio: e,
                    invertedXRatio: i,
                    baseLineInvertedY: h,
                    baseLineY: l,
                    baseLineX: c
                };
            }
        },
        {
            key: "getLogSeries",
            value: function(t) {
                var e = this, i = this.w;
                return i.globals.seriesLog = t.map(function(t, a) {
                    var s = i.globals.seriesYAxisReverseMap[a];
                    return i.config.yaxis[s] && i.config.yaxis[s].logarithmic ? t.map(function(t) {
                        return null === t ? null : e.getLogVal(i.config.yaxis[s].logBase, t, a);
                    }) : t;
                }), i.globals.invalidLogScale ? t : i.globals.seriesLog;
            }
        },
        {
            key: "getBaseLog",
            value: function(t, e) {
                return Math.log(e) / Math.log(t);
            }
        },
        {
            key: "getLogVal",
            value: function(t, e, i) {
                if (e <= 0) return 0;
                var a = this.w, s = 0 === a.globals.minYArr[i] ? -1 : this.getBaseLog(t, a.globals.minYArr[i]), r = (0 === a.globals.maxYArr[i] ? 0 : this.getBaseLog(t, a.globals.maxYArr[i])) - s;
                return e < 1 ? e / r : (this.getBaseLog(t, e) - s) / r;
            }
        },
        {
            key: "getLogYRatios",
            value: function(t) {
                var e = this, i = this.w, a = this.w.globals;
                return a.yLogRatio = t.slice(), a.logYRange = a.yRange.map(function(t, s) {
                    var r = i.globals.seriesYAxisReverseMap[s];
                    if (i.config.yaxis[r] && e.w.config.yaxis[r].logarithmic) {
                        var o, n = -Number.MAX_VALUE, l = Number.MIN_VALUE;
                        return a.seriesLog.forEach(function(t, e) {
                            t.forEach(function(t) {
                                i.config.yaxis[e] && i.config.yaxis[e].logarithmic && (n = Math.max(t, n), l = Math.min(t, l));
                            });
                        }), o = Math.pow(a.yRange[s], Math.abs(l - n) / a.yRange[s]), a.yLogRatio[s] = o / a.gridHeight, o;
                    }
                }), a.invalidLogScale ? t.slice() : a.yLogRatio;
            }
        },
        {
            key: "drawSeriesByGroup",
            value: function(t, e, i, a) {
                var s = this.w, r = [];
                return t.series.length > 0 && e.forEach(function(e) {
                    var o = [], n = [];
                    t.i.forEach(function(i, a) {
                        s.config.series[i].group === e && (o.push(t.series[a]), n.push(i));
                    }), o.length > 0 && r.push(a.draw(o, i, n));
                }), r;
            }
        }
    ], [
        {
            key: "checkComboSeries",
            value: function(t, e) {
                var i = !1, a = 0, s = 0;
                return void 0 === e && (e = "line"), t.length && void 0 !== t[0].type && t.forEach(function(t) {
                    "bar" !== t.type && "column" !== t.type && "candlestick" !== t.type && "boxPlot" !== t.type || a++, void 0 !== t.type && t.type !== e && s++;
                }), s > 0 && (i = !0), {
                    comboBarCount: a,
                    comboCharts: i
                };
            }
        },
        {
            key: "extendArrayProps",
            value: function(t, e, i) {
                var a, s, r, o, n, l;
                (null !== (a = e) && void 0 !== a && a.yaxis && (e = t.extendYAxis(e, i)), null !== (s = e) && void 0 !== s && s.annotations) && (e.annotations.yaxis && (e = t.extendYAxisAnnotations(e)), null !== (r = e) && void 0 !== r && null !== (o = r.annotations) && void 0 !== o && o.xaxis && (e = t.extendXAxisAnnotations(e)), null !== (n = e) && void 0 !== n && null !== (l = n.annotations) && void 0 !== l && l.points && (e = t.extendPointAnnotations(e)));
                return e;
            }
        }
    ]), t;
}(), S = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.annoCtx = e;
    }
    return s(t, [
        {
            key: "setOrientations",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.w;
                if ("vertical" === t.label.orientation) {
                    var a = null !== e ? e : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                    if (null !== s) {
                        var r = s.getBoundingClientRect();
                        s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4);
                        var o = "top" === t.label.position ? r.width : -r.width;
                        s.setAttribute("y", parseFloat(s.getAttribute("y")) + o);
                        var n = this.annoCtx.graphics.rotateAroundCenter(s), l = n.x, h = n.y;
                        s.setAttribute("transform", "rotate(-90 ".concat(l, " ").concat(h, ")"));
                    }
                }
            }
        },
        {
            key: "addBackgroundToAnno",
            value: function(t, e) {
                var i = this.w;
                if (!t || !e.label.text || !String(e.label.text).trim()) return null;
                var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = t.getBoundingClientRect(), r = e.label.style.padding, o = r.left, n = r.right, l = r.top, h = r.bottom;
                if ("vertical" === e.label.orientation) {
                    var c = [
                        o,
                        n,
                        l,
                        h
                    ];
                    l = c[0], h = c[1], o = c[2], n = c[3];
                }
                var d = s.left - a.left - o, g = s.top - a.top - l, u = this.annoCtx.graphics.drawRect(d - i.globals.barPadForNumericAxis, g, s.width + o + n, s.height + l + h, e.label.borderRadius, e.label.style.background, 1, e.label.borderWidth, e.label.borderColor, 0);
                return e.id && u.node.classList.add(e.id), u;
            }
        },
        {
            key: "annotationsBackground",
            value: function() {
                var t = this, e = this.w, i = function(i, a, s) {
                    var r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(a, "']"));
                    if (r) {
                        var o = r.parentNode, n = t.addBackgroundToAnno(r, i);
                        n && (o.insertBefore(n.node, r), i.label.mouseEnter && n.node.addEventListener("mouseenter", i.label.mouseEnter.bind(t, i)), i.label.mouseLeave && n.node.addEventListener("mouseleave", i.label.mouseLeave.bind(t, i)), i.label.click && n.node.addEventListener("click", i.label.click.bind(t, i)));
                    }
                };
                e.config.annotations.xaxis.forEach(function(t, e) {
                    return i(t, e, "xaxis");
                }), e.config.annotations.yaxis.forEach(function(t, e) {
                    return i(t, e, "yaxis");
                }), e.config.annotations.points.forEach(function(t, e) {
                    return i(t, e, "point");
                });
            }
        },
        {
            key: "getY1Y2",
            value: function(t, e) {
                var i, a = this.w, s = "y1" === t ? e.y : e.y2, r = !1;
                if (this.annoCtx.invertAxis) {
                    var o = a.config.xaxis.convertedCatToNumeric ? a.globals.categoryLabels : a.globals.labels, n = o.indexOf(s), l = a.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(".concat(n + 1, ")"));
                    i = l ? parseFloat(l.getAttribute("y")) : (a.globals.gridHeight / o.length - 1) * (n + 1) - a.globals.barHeight, void 0 !== e.seriesIndex && a.globals.barHeight && (i -= a.globals.barHeight / 2 * (a.globals.series.length - 1) - a.globals.barHeight * e.seriesIndex);
                } else {
                    var h, c = a.globals.seriesYAxisMap[e.yAxisIndex][0], d = a.config.yaxis[e.yAxisIndex].logarithmic ? new A(this.annoCtx.ctx).getLogVal(a.config.yaxis[e.yAxisIndex].logBase, s, c) / a.globals.yLogRatio[c] : (s - a.globals.minYArr[c]) / (a.globals.yRange[c] / a.globals.gridHeight);
                    i = a.globals.gridHeight - Math.min(Math.max(d, 0), a.globals.gridHeight), r = d > a.globals.gridHeight || d < 0, !e.marker || void 0 !== e.y && null !== e.y || (i = 0), null !== (h = a.config.yaxis[e.yAxisIndex]) && void 0 !== h && h.reversed && (i = d);
                }
                return "string" == typeof s && s.includes("px") && (i = parseFloat(s)), {
                    yP: i,
                    clipped: r
                };
            }
        },
        {
            key: "getX1X2",
            value: function(t, e) {
                var i = this.w, a = "x1" === t ? e.x : e.x2, s = this.annoCtx.invertAxis ? i.globals.minY : i.globals.minX, r = this.annoCtx.invertAxis ? i.globals.maxY : i.globals.maxX, o = this.annoCtx.invertAxis ? i.globals.yRange[0] : i.globals.xRange, n = !1, l = this.annoCtx.inversedReversedAxis ? (r - a) / (o / i.globals.gridWidth) : (a - s) / (o / i.globals.gridWidth);
                return "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || i.config.chart.sparkline.enabled || (l = this.getStringX(a)), "string" == typeof a && a.includes("px") && (l = parseFloat(a)), null == a && e.marker && (l = i.globals.gridWidth), void 0 !== e.seriesIndex && i.globals.barWidth && !this.annoCtx.invertAxis && (l -= i.globals.barWidth / 2 * (i.globals.series.length - 1) - i.globals.barWidth * e.seriesIndex), l > i.globals.gridWidth ? (l = i.globals.gridWidth, n = !0) : l < 0 && (l = 0, n = !0), {
                    x: l,
                    clipped: n
                };
            }
        },
        {
            key: "getStringX",
            value: function(t) {
                var e = this.w, i = t;
                e.config.xaxis.convertedCatToNumeric && e.globals.categoryLabels.length && (t = e.globals.categoryLabels.indexOf(t) + 1);
                var a = e.globals.labels.map(function(t) {
                    return Array.isArray(t) ? t.join(" ") : t;
                }).indexOf(t), s = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(".concat(a + 1, ")"));
                return s && (i = parseFloat(s.getAttribute("x"))), i;
            }
        }
    ]), t;
}(), C = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new S(this.annoCtx);
    }
    return s(t, [
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = this.helpers.getX1X2("x1", t), o = r.x, n = r.clipped, l = !0, h = t.label.text, c = t.strokeDashArray;
                if (m.isNumber(o)) {
                    if (null === t.x2 || void 0 === t.x2) {
                        if (!n) {
                            var d = this.annoCtx.graphics.drawLine(o + t.offsetX, 0 + t.offsetY, o + t.offsetX, s.globals.gridHeight + t.offsetY, t.borderColor, c, t.borderWidth);
                            e.appendChild(d.node), t.id && d.node.classList.add(t.id);
                        }
                    } else {
                        var g = this.helpers.getX1X2("x2", t);
                        if (a = g.x, l = g.clipped, !n || !l) {
                            if (a < o) {
                                var u = o;
                                o = a, a = u;
                            }
                            var f = this.annoCtx.graphics.drawRect(o + t.offsetX, 0 + t.offsetY, a - o, s.globals.gridHeight + t.offsetY, 0, t.fillColor, t.opacity, 1, t.borderColor, c);
                            f.node.classList.add("apexcharts-annotation-rect"), f.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(f.node), t.id && f.node.classList.add(t.id);
                        }
                    }
                    if (!n || !l) {
                        var p = this.annoCtx.graphics.getTextRects(h, parseFloat(t.label.style.fontSize)), x = "top" === t.label.position ? 4 : "center" === t.label.position ? s.globals.gridHeight / 2 + ("vertical" === t.label.orientation ? p.width / 2 : 0) : s.globals.gridHeight, b = this.annoCtx.graphics.drawText({
                            x: o + t.label.offsetX,
                            y: x + t.label.offsetY - ("vertical" === t.label.orientation ? "top" === t.label.position ? p.width / 2 - 12 : -p.width / 2 : 0),
                            text: h,
                            textAnchor: t.label.textAnchor,
                            fontSize: t.label.style.fontSize,
                            fontFamily: t.label.style.fontFamily,
                            fontWeight: t.label.style.fontWeight,
                            foreColor: t.label.style.color,
                            cssClass: "apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                        });
                        b.attr({
                            rel: i
                        }), e.appendChild(b.node), this.annoCtx.helpers.setOrientations(t, i);
                    }
                }
            }
        },
        {
            key: "drawXAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-xaxis-annotations"
                });
                return e.config.annotations.xaxis.map(function(e, a) {
                    t.addXaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), L = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.months31 = [
            1,
            3,
            5,
            7,
            8,
            10,
            12
        ], this.months30 = [
            2,
            4,
            6,
            9,
            11
        ], this.daysCntOfYear = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
    }
    return s(t, [
        {
            key: "isValidDate",
            value: function(t) {
                return "number" != typeof t && !isNaN(this.parseDate(t));
            }
        },
        {
            key: "getTimeStamp",
            value: function(t) {
                return Date.parse(t) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toISOString().substr(0, 25)).getTime() : new Date(t).getTime() : t;
            }
        },
        {
            key: "getDate",
            value: function(t) {
                return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toUTCString()) : new Date(t);
            }
        },
        {
            key: "parseDate",
            value: function(t) {
                var e = Date.parse(t);
                if (!isNaN(e)) return this.getTimeStamp(t);
                var i = Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                return i = this.getTimeStamp(i);
            }
        },
        {
            key: "parseDateWithTimezone",
            value: function(t) {
                return Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
            }
        },
        {
            key: "formatDate",
            value: function(t, e) {
                var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                    "\0"
                ].concat(p(i.months)), r = [
                    "\x01"
                ].concat(p(i.shortMonths)), o = [
                    "\x02"
                ].concat(p(i.days)), n = [
                    "\x03"
                ].concat(p(i.shortDays));
                function l(t, e) {
                    var i = t + "";
                    for(e = e || 2; i.length < e;)i = "0" + i;
                    return i;
                }
                var h = a ? t.getUTCFullYear() : t.getFullYear();
                e = (e = (e = e.replace(/(^|[^\\])yyyy+/g, "$1" + h)).replace(/(^|[^\\])yy/g, "$1" + h.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + h);
                var c = (a ? t.getUTCMonth() : t.getMonth()) + 1;
                e = (e = (e = (e = e.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + l(c))).replace(/(^|[^\\])M/g, "$1" + c);
                var d = a ? t.getUTCDate() : t.getDate();
                e = (e = (e = (e = e.replace(/(^|[^\\])dddd+/g, "$1" + o[0])).replace(/(^|[^\\])ddd/g, "$1" + n[0])).replace(/(^|[^\\])dd/g, "$1" + l(d))).replace(/(^|[^\\])d/g, "$1" + d);
                var g = a ? t.getUTCHours() : t.getHours(), u = g > 12 ? g - 12 : 0 === g ? 12 : g;
                e = (e = (e = (e = e.replace(/(^|[^\\])HH+/g, "$1" + l(g))).replace(/(^|[^\\])H/g, "$1" + g)).replace(/(^|[^\\])hh+/g, "$1" + l(u))).replace(/(^|[^\\])h/g, "$1" + u);
                var f = a ? t.getUTCMinutes() : t.getMinutes();
                e = (e = e.replace(/(^|[^\\])mm+/g, "$1" + l(f))).replace(/(^|[^\\])m/g, "$1" + f);
                var x = a ? t.getUTCSeconds() : t.getSeconds();
                e = (e = e.replace(/(^|[^\\])ss+/g, "$1" + l(x))).replace(/(^|[^\\])s/g, "$1" + x);
                var b = a ? t.getUTCMilliseconds() : t.getMilliseconds();
                e = e.replace(/(^|[^\\])fff+/g, "$1" + l(b, 3)), b = Math.round(b / 10), e = e.replace(/(^|[^\\])ff/g, "$1" + l(b)), b = Math.round(b / 10);
                var v = g < 12 ? "AM" : "PM";
                e = (e = (e = e.replace(/(^|[^\\])f/g, "$1" + b)).replace(/(^|[^\\])TT+/g, "$1" + v)).replace(/(^|[^\\])T/g, "$1" + v.charAt(0));
                var m = v.toLowerCase();
                e = (e = e.replace(/(^|[^\\])tt+/g, "$1" + m)).replace(/(^|[^\\])t/g, "$1" + m.charAt(0));
                var y = -t.getTimezoneOffset(), w = a || !y ? "Z" : y > 0 ? "+" : "-";
                if (!a) {
                    var k = (y = Math.abs(y)) % 60;
                    w += l(Math.floor(y / 60)) + ":" + l(k);
                }
                e = e.replace(/(^|[^\\])K/g, "$1" + w);
                var A = (a ? t.getUTCDay() : t.getDay()) + 1;
                return e = (e = (e = (e = (e = e.replace(new RegExp(o[0], "g"), o[A])).replace(new RegExp(n[0], "g"), n[A])).replace(new RegExp(s[0], "g"), s[c])).replace(new RegExp(r[0], "g"), r[c])).replace(/\\(.)/g, "$1");
            }
        },
        {
            key: "getTimeUnitsfromTimestamp",
            value: function(t, e, i) {
                var a = this.w;
                void 0 !== a.config.xaxis.min && (t = a.config.xaxis.min), void 0 !== a.config.xaxis.max && (e = a.config.xaxis.max);
                var s = this.getDate(t), r = this.getDate(e), o = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), n = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                return {
                    minMillisecond: parseInt(o[6], 10),
                    maxMillisecond: parseInt(n[6], 10),
                    minSecond: parseInt(o[5], 10),
                    maxSecond: parseInt(n[5], 10),
                    minMinute: parseInt(o[4], 10),
                    maxMinute: parseInt(n[4], 10),
                    minHour: parseInt(o[3], 10),
                    maxHour: parseInt(n[3], 10),
                    minDate: parseInt(o[2], 10),
                    maxDate: parseInt(n[2], 10),
                    minMonth: parseInt(o[1], 10) - 1,
                    maxMonth: parseInt(n[1], 10) - 1,
                    minYear: parseInt(o[0], 10),
                    maxYear: parseInt(n[0], 10)
                };
            }
        },
        {
            key: "isLeapYear",
            value: function(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
            }
        },
        {
            key: "calculcateLastDaysOfMonth",
            value: function(t, e, i) {
                return this.determineDaysOfMonths(t, e) - i;
            }
        },
        {
            key: "determineDaysOfYear",
            value: function(t) {
                var e = 365;
                return this.isLeapYear(t) && (e = 366), e;
            }
        },
        {
            key: "determineRemainingDaysOfYear",
            value: function(t, e, i) {
                var a = this.daysCntOfYear[e] + i;
                return e > 1 && this.isLeapYear() && a++, a;
            }
        },
        {
            key: "determineDaysOfMonths",
            value: function(t, e) {
                var i = 30;
                switch(t = m.monthMod(t), !0){
                    case this.months30.indexOf(t) > -1:
                        2 === t && (i = this.isLeapYear(e) ? 29 : 28);
                        break;
                    case this.months31.indexOf(t) > -1:
                    default:
                        i = 31;
                }
                return i;
            }
        }
    ]), t;
}(), P = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
    }
    return s(t, [
        {
            key: "xLabelFormat",
            value: function(t, e, i, a) {
                var s = this.w;
                if ("datetime" === s.config.xaxis.type && void 0 === s.config.xaxis.labels.formatter && void 0 === s.config.tooltip.x.formatter) {
                    var r = new L(this.ctx);
                    return r.formatDate(r.getDate(e), s.config.tooltip.x.format);
                }
                return t(e, i, a);
            }
        },
        {
            key: "defaultGeneralFormatter",
            value: function(t) {
                return Array.isArray(t) ? t.map(function(t) {
                    return t;
                }) : t;
            }
        },
        {
            key: "defaultYFormatter",
            value: function(t, e, i) {
                var a = this.w;
                if (m.isNumber(t)) {
                    if (0 !== a.globals.yValueDecimal) t = t.toFixed(void 0 !== e.decimalsInFloat ? e.decimalsInFloat : a.globals.yValueDecimal);
                    else {
                        var s = t.toFixed(0);
                        t = t == s ? s : t.toFixed(1);
                    }
                }
                return t;
            }
        },
        {
            key: "setLabelFormatters",
            value: function() {
                var t = this, e = this.w;
                return e.globals.xaxisTooltipFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttKeyFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttZFormatter = function(t) {
                    return t;
                }, e.globals.legendFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, void 0 !== e.config.xaxis.labels.formatter ? e.globals.xLabelFormatter = e.config.xaxis.labels.formatter : e.globals.xLabelFormatter = function(t) {
                    if (m.isNumber(t)) {
                        if (!e.config.xaxis.convertedCatToNumeric && "numeric" === e.config.xaxis.type) {
                            if (m.isNumber(e.config.xaxis.decimalsInFloat)) return t.toFixed(e.config.xaxis.decimalsInFloat);
                            var i = e.globals.maxX - e.globals.minX;
                            return i > 0 && i < 100 ? t.toFixed(1) : t.toFixed(0);
                        }
                        if (e.globals.isBarHorizontal) {
                            if (e.globals.maxY - e.globals.minYArr < 4) return t.toFixed(1);
                        }
                        return t.toFixed(0);
                    }
                    return t;
                }, "function" == typeof e.config.tooltip.x.formatter ? e.globals.ttKeyFormatter = e.config.tooltip.x.formatter : e.globals.ttKeyFormatter = e.globals.xLabelFormatter, "function" == typeof e.config.xaxis.tooltip.formatter && (e.globals.xaxisTooltipFormatter = e.config.xaxis.tooltip.formatter), (Array.isArray(e.config.tooltip.y) || void 0 !== e.config.tooltip.y.formatter) && (e.globals.ttVal = e.config.tooltip.y), void 0 !== e.config.tooltip.z.formatter && (e.globals.ttZFormatter = e.config.tooltip.z.formatter), void 0 !== e.config.legend.formatter && (e.globals.legendFormatter = e.config.legend.formatter), e.config.yaxis.forEach(function(i, a) {
                    void 0 !== i.labels.formatter ? e.globals.yLabelFormatters[a] = i.labels.formatter : e.globals.yLabelFormatters[a] = function(s) {
                        return e.globals.xyCharts ? Array.isArray(s) ? s.map(function(e) {
                            return t.defaultYFormatter(e, i, a);
                        }) : t.defaultYFormatter(s, i, a) : s;
                    };
                }), e.globals;
            }
        },
        {
            key: "heatmapLabelFormatters",
            value: function() {
                var t = this.w;
                if ("heatmap" === t.config.chart.type) {
                    t.globals.yAxisScale[0].result = t.globals.seriesNames.slice();
                    var e = t.globals.seriesNames.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0);
                    t.globals.yAxisScale[0].niceMax = e, t.globals.yAxisScale[0].niceMin = e;
                }
            }
        }
    ]), t;
}(), M = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "getLabel",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "12px", o = !(arguments.length > 6 && void 0 !== arguments[6]) || arguments[6], n = this.w, l = void 0 === t[a] ? "" : t[a], h = l, c = n.globals.xLabelFormatter, d = n.config.xaxis.labels.formatter, g = !1, u = new P(this.ctx), f = l;
                o && (h = u.xLabelFormat(c, l, f, {
                    i: a,
                    dateFormatter: new L(this.ctx).formatDate,
                    w: n
                }), void 0 !== d && (h = d(l, t[a], {
                    i: a,
                    dateFormatter: new L(this.ctx).formatDate,
                    w: n
                })));
                var p, x;
                e.length > 0 ? (p = e[a].unit, x = null, e.forEach(function(t) {
                    "month" === t.unit ? x = "year" : "day" === t.unit ? x = "month" : "hour" === t.unit ? x = "day" : "minute" === t.unit && (x = "hour");
                }), g = x === p, i = e[a].position, h = e[a].value) : "datetime" === n.config.xaxis.type && void 0 === d && (h = ""), void 0 === h && (h = ""), h = Array.isArray(h) ? h : h.toString();
                var b = new k(this.ctx), v = {};
                v = n.globals.rotateXLabels && o ? b.getTextRects(h, parseInt(r, 10), null, "rotate(".concat(n.config.xaxis.labels.rotate, " 0 0)"), !1) : b.getTextRects(h, parseInt(r, 10));
                var m = !n.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                return !Array.isArray(h) && ("NaN" === String(h) || s.indexOf(h) >= 0 && m) && (h = ""), {
                    x: i,
                    text: h,
                    textRect: v,
                    isBold: g
                };
            }
        },
        {
            key: "checkLabelBasedOnTickamount",
            value: function(t, e, i) {
                var a = this.w, s = a.config.xaxis.tickAmount;
                return "dataPoints" === s && (s = Math.round(a.globals.gridWidth / 120)), s > i || t % Math.round(i / (s + 1)) == 0 || (e.text = ""), e;
            }
        },
        {
            key: "checkForOverflowingLabels",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (0 === t && r.globals.skipFirstTimelinelabel && (e.text = ""), t === i - 1 && r.globals.skipLastTimelinelabel && (e.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                    var o = s[s.length - 1];
                    e.x < o.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + o.x && (e.text = "");
                }
                return e;
            }
        },
        {
            key: "checkForReversedLabels",
            value: function(t, e) {
                var i = this.w;
                return i.config.yaxis[t] && i.config.yaxis[t].reversed && e.reverse(), e;
            }
        },
        {
            key: "yAxisAllSeriesCollapsed",
            value: function(t) {
                var e = this.w.globals;
                return !e.seriesYAxisMap[t].some(function(t) {
                    return -1 === e.collapsedSeriesIndices.indexOf(t);
                });
            }
        },
        {
            key: "translateYAxisIndex",
            value: function(t) {
                var e = this.w, i = e.globals, a = e.config.yaxis;
                return i.series.length > a.length || a.some(function(t) {
                    return Array.isArray(t.seriesName);
                }) ? t : i.seriesYAxisReverseMap[t];
            }
        },
        {
            key: "isYAxisHidden",
            value: function(t) {
                var e = this.w, i = e.config.yaxis[t];
                if (!i.show || this.yAxisAllSeriesCollapsed(t)) return !0;
                if (!i.showForNullSeries) {
                    var a = e.globals.seriesYAxisMap[t], s = new A(this.ctx);
                    return a.every(function(t) {
                        return s.isSeriesNull(t);
                    });
                }
                return !1;
            }
        },
        {
            key: "getYAxisForeColor",
            value: function(t, e) {
                var i = this.w;
                return Array.isArray(t) && i.globals.yAxisScale[e] && this.ctx.theme.pushExtraColors(t, i.globals.yAxisScale[e].result.length, !1), t;
            }
        },
        {
            key: "drawYAxisTicks",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = new k(this.ctx), h = n.globals.translateY + n.config.yaxis[s].labels.offsetY;
                if (n.globals.isBarHorizontal ? h = 0 : "heatmap" === n.config.chart.type && (h += r / 2), a.show && e > 0) {
                    !0 === n.config.yaxis[s].opposite && (t += a.width);
                    for(var c = e; c >= 0; c--){
                        var d = l.drawLine(t + i.offsetX - a.width + a.offsetX, h + a.offsetY, t + i.offsetX + a.offsetX, h + a.offsetY, a.color);
                        o.add(d), h += r;
                    }
                }
            }
        }
    ]), t;
}(), I = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new S(this.annoCtx), this.axesUtils = new M(this.annoCtx);
    }
    return s(t, [
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = t.strokeDashArray, o = this.helpers.getY1Y2("y1", t), n = o.yP, l = o.clipped, h = !0, c = !1, d = t.label.text;
                if (null === t.y2 || void 0 === t.y2) {
                    if (!l) {
                        c = !0;
                        var g = this.annoCtx.graphics.drawLine(0 + t.offsetX, n + t.offsetY, this._getYAxisAnnotationWidth(t), n + t.offsetY, t.borderColor, r, t.borderWidth);
                        e.appendChild(g.node), t.id && g.node.classList.add(t.id);
                    }
                } else {
                    if (a = (o = this.helpers.getY1Y2("y2", t)).yP, h = o.clipped, a > n) {
                        var u = n;
                        n = a, a = u;
                    }
                    if (!l || !h) {
                        c = !0;
                        var f = this.annoCtx.graphics.drawRect(0 + t.offsetX, a + t.offsetY, this._getYAxisAnnotationWidth(t), n - a, 0, t.fillColor, t.opacity, 1, t.borderColor, r);
                        f.node.classList.add("apexcharts-annotation-rect"), f.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(f.node), t.id && f.node.classList.add(t.id);
                    }
                }
                if (c) {
                    var p = "right" === t.label.position ? s.globals.gridWidth : "center" === t.label.position ? s.globals.gridWidth / 2 : 0, x = this.annoCtx.graphics.drawText({
                        x: p + t.label.offsetX,
                        y: (null != a ? a : n) + t.label.offsetY - 3,
                        text: d,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    x.attr({
                        rel: i
                    }), e.appendChild(x.node);
                }
            }
        },
        {
            key: "_getYAxisAnnotationWidth",
            value: function(t) {
                var e = this.w;
                e.globals.gridWidth;
                return (t.width.indexOf("%") > -1 ? e.globals.gridWidth * parseInt(t.width, 10) / 100 : parseInt(t.width, 10)) + t.offsetX;
            }
        },
        {
            key: "drawYAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-yaxis-annotations"
                });
                return e.config.annotations.yaxis.forEach(function(e, a) {
                    e.yAxisIndex = t.axesUtils.translateYAxisIndex(e.yAxisIndex), t.axesUtils.isYAxisHidden(e.yAxisIndex) && t.axesUtils.yAxisAllSeriesCollapsed(e.yAxisIndex) || t.addYaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), T = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new S(this.annoCtx);
    }
    return s(t, [
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                if (!(this.w.globals.collapsedSeriesIndices.indexOf(t.seriesIndex) > -1)) {
                    var a = this.helpers.getX1X2("x1", t), s = a.x, r = a.clipped, o = (a = this.helpers.getY1Y2("y1", t)).yP, n = a.clipped;
                    if (m.isNumber(s) && !n && !r) {
                        var l = {
                            pSize: t.marker.size,
                            pointStrokeWidth: t.marker.strokeWidth,
                            pointFillColor: t.marker.fillColor,
                            pointStrokeColor: t.marker.strokeColor,
                            shape: t.marker.shape,
                            pRadius: t.marker.radius,
                            class: "apexcharts-point-annotation-marker ".concat(t.marker.cssClass, " ").concat(t.id ? t.id : "")
                        }, h = this.annoCtx.graphics.drawMarker(s + t.marker.offsetX, o + t.marker.offsetY, l);
                        e.appendChild(h.node);
                        var c = t.label.text ? t.label.text : "", d = this.annoCtx.graphics.drawText({
                            x: s + t.label.offsetX,
                            y: o + t.label.offsetY - t.marker.size - parseFloat(t.label.style.fontSize) / 1.6,
                            text: c,
                            textAnchor: t.label.textAnchor,
                            fontSize: t.label.style.fontSize,
                            fontFamily: t.label.style.fontFamily,
                            fontWeight: t.label.style.fontWeight,
                            foreColor: t.label.style.color,
                            cssClass: "apexcharts-point-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                        });
                        if (d.attr({
                            rel: i
                        }), e.appendChild(d.node), t.customSVG.SVG) {
                            var g = this.annoCtx.graphics.group({
                                class: "apexcharts-point-annotations-custom-svg " + t.customSVG.cssClass
                            });
                            g.attr({
                                transform: "translate(".concat(s + t.customSVG.offsetX, ", ").concat(o + t.customSVG.offsetY, ")")
                            }), g.node.innerHTML = t.customSVG.SVG, e.appendChild(g.node);
                        }
                        if (t.image.path) {
                            var u = t.image.width ? t.image.width : 20, f = t.image.height ? t.image.height : 20;
                            h = this.annoCtx.addImage({
                                x: s + t.image.offsetX - u / 2,
                                y: o + t.image.offsetY - f / 2,
                                width: u,
                                height: f,
                                path: t.image.path,
                                appendTo: ".apexcharts-point-annotations"
                            });
                        }
                        t.mouseEnter && h.node.addEventListener("mouseenter", t.mouseEnter.bind(this, t)), t.mouseLeave && h.node.addEventListener("mouseleave", t.mouseLeave.bind(this, t)), t.click && h.node.addEventListener("click", t.click.bind(this, t));
                    }
                }
            }
        },
        {
            key: "drawPointAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-point-annotations"
                });
                return e.config.annotations.points.map(function(e, a) {
                    t.addPointAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}();
var z = {
    name: "en",
    options: {
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        toolbar: {
            exportToSVG: "Download SVG",
            exportToPNG: "Download PNG",
            exportToCSV: "Download CSV",
            menu: "Menu",
            selection: "Selection",
            selectionZoom: "Selection Zoom",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out",
            pan: "Panning",
            reset: "Reset Zoom"
        }
    }
}, X = function() {
    function t() {
        i(this, t), this.yAxis = {
            show: !0,
            showAlways: !1,
            showForNullSeries: !0,
            seriesName: void 0,
            opposite: !1,
            reversed: !1,
            logarithmic: !1,
            logBase: 10,
            tickAmount: void 0,
            stepSize: void 0,
            forceNiceScale: !1,
            max: void 0,
            min: void 0,
            floating: !1,
            decimalsInFloat: void 0,
            labels: {
                show: !0,
                showDuplicates: !1,
                minWidth: 0,
                maxWidth: 160,
                offsetX: 0,
                offsetY: 0,
                align: void 0,
                rotate: 0,
                padding: 20,
                style: {
                    colors: [],
                    fontSize: "11px",
                    fontWeight: 400,
                    fontFamily: void 0,
                    cssClass: ""
                },
                formatter: void 0
            },
            axisBorder: {
                show: !1,
                color: "#e0e0e0",
                width: 1,
                offsetX: 0,
                offsetY: 0
            },
            axisTicks: {
                show: !1,
                color: "#e0e0e0",
                width: 6,
                offsetX: 0,
                offsetY: 0
            },
            title: {
                text: void 0,
                rotate: -90,
                offsetY: 0,
                offsetX: 0,
                style: {
                    color: void 0,
                    fontSize: "11px",
                    fontWeight: 900,
                    fontFamily: void 0,
                    cssClass: ""
                }
            },
            tooltip: {
                enabled: !1,
                offsetX: 0
            },
            crosshairs: {
                show: !0,
                position: "front",
                stroke: {
                    color: "#b6b6b6",
                    width: 1,
                    dashArray: 0
                }
            }
        }, this.pointAnnotation = {
            id: void 0,
            x: 0,
            y: null,
            yAxisIndex: 0,
            seriesIndex: void 0,
            mouseEnter: void 0,
            mouseLeave: void 0,
            click: void 0,
            marker: {
                size: 4,
                fillColor: "#fff",
                strokeWidth: 2,
                strokeColor: "#333",
                shape: "circle",
                offsetX: 0,
                offsetY: 0,
                cssClass: ""
            },
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            },
            customSVG: {
                SVG: void 0,
                cssClass: void 0,
                offsetX: 0,
                offsetY: 0
            },
            image: {
                path: void 0,
                width: 20,
                height: 20,
                offsetX: 0,
                offsetY: 0
            }
        }, this.yAxisAnnotation = {
            id: void 0,
            y: 0,
            y2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            width: "100%",
            yAxisIndex: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "end",
                position: "right",
                offsetX: 0,
                offsetY: -3,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.xAxisAnnotation = {
            id: void 0,
            x: 0,
            x2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                orientation: "vertical",
                position: "top",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.text = {
            x: 0,
            y: 0,
            text: "",
            textAnchor: "start",
            foreColor: void 0,
            fontSize: "13px",
            fontFamily: void 0,
            fontWeight: 400,
            appendTo: ".apexcharts-annotations",
            backgroundColor: "transparent",
            borderColor: "#c2c2c2",
            borderRadius: 0,
            borderWidth: 0,
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 2,
            paddingBottom: 2
        };
    }
    return s(t, [
        {
            key: "init",
            value: function() {
                return {
                    annotations: {
                        yaxis: [
                            this.yAxisAnnotation
                        ],
                        xaxis: [
                            this.xAxisAnnotation
                        ],
                        points: [
                            this.pointAnnotation
                        ],
                        texts: [],
                        images: [],
                        shapes: []
                    },
                    chart: {
                        animations: {
                            enabled: !0,
                            easing: "easeinout",
                            speed: 800,
                            animateGradually: {
                                delay: 150,
                                enabled: !0
                            },
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 350
                            }
                        },
                        background: "",
                        locales: [
                            z
                        ],
                        defaultLocale: "en",
                        dropShadow: {
                            enabled: !1,
                            enabledOnSeries: void 0,
                            top: 2,
                            left: 2,
                            blur: 4,
                            color: "#000",
                            opacity: .35
                        },
                        events: {
                            animationEnd: void 0,
                            beforeMount: void 0,
                            mounted: void 0,
                            updated: void 0,
                            click: void 0,
                            mouseMove: void 0,
                            mouseLeave: void 0,
                            xAxisLabelClick: void 0,
                            legendClick: void 0,
                            markerClick: void 0,
                            selection: void 0,
                            dataPointSelection: void 0,
                            dataPointMouseEnter: void 0,
                            dataPointMouseLeave: void 0,
                            beforeZoom: void 0,
                            beforeResetZoom: void 0,
                            zoomed: void 0,
                            scrolled: void 0,
                            brushScrolled: void 0
                        },
                        foreColor: "#373d3f",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        height: "auto",
                        parentHeightOffset: 15,
                        redrawOnParentResize: !0,
                        redrawOnWindowResize: !0,
                        id: void 0,
                        group: void 0,
                        nonce: void 0,
                        offsetX: 0,
                        offsetY: 0,
                        selection: {
                            enabled: !1,
                            type: "x",
                            fill: {
                                color: "#24292e",
                                opacity: .1
                            },
                            stroke: {
                                width: 1,
                                color: "#24292e",
                                opacity: .4,
                                dashArray: 3
                            },
                            xaxis: {
                                min: void 0,
                                max: void 0
                            },
                            yaxis: {
                                min: void 0,
                                max: void 0
                            }
                        },
                        sparkline: {
                            enabled: !1
                        },
                        brush: {
                            enabled: !1,
                            autoScaleYaxis: !0,
                            target: void 0,
                            targets: void 0
                        },
                        stacked: !1,
                        stackOnlyBar: !0,
                        stackType: "normal",
                        toolbar: {
                            show: !0,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: !0,
                                selection: !0,
                                zoom: !0,
                                zoomin: !0,
                                zoomout: !0,
                                pan: !0,
                                reset: !0,
                                customIcons: []
                            },
                            export: {
                                csv: {
                                    filename: void 0,
                                    columnDelimiter: ",",
                                    headerCategory: "category",
                                    headerValue: "value",
                                    categoryFormatter: void 0,
                                    valueFormatter: void 0
                                },
                                png: {
                                    filename: void 0
                                },
                                svg: {
                                    filename: void 0
                                },
                                scale: void 0,
                                width: void 0
                            },
                            autoSelected: "zoom"
                        },
                        type: "line",
                        width: "100%",
                        zoom: {
                            enabled: !0,
                            type: "x",
                            autoScaleYaxis: !1,
                            allowMouseWheelZoom: !0,
                            zoomedArea: {
                                fill: {
                                    color: "#90CAF9",
                                    opacity: .4
                                },
                                stroke: {
                                    color: "#0D47A1",
                                    opacity: .4,
                                    width: 1
                                }
                            }
                        }
                    },
                    plotOptions: {
                        line: {
                            isSlopeChart: !1
                        },
                        area: {
                            fillTo: "origin"
                        },
                        bar: {
                            horizontal: !1,
                            columnWidth: "70%",
                            barHeight: "70%",
                            distributed: !1,
                            borderRadius: 0,
                            borderRadiusApplication: "around",
                            borderRadiusWhenStacked: "last",
                            rangeBarOverlap: !0,
                            rangeBarGroupRows: !1,
                            hideZeroBarsWhenGrouped: !1,
                            isDumbbell: !1,
                            dumbbellColors: void 0,
                            isFunnel: !1,
                            isFunnel3d: !0,
                            colors: {
                                ranges: [],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                                backgroundBarRadius: 0
                            },
                            dataLabels: {
                                position: "top",
                                maxItems: 100,
                                hideOverflowingLabels: !0,
                                orientation: "horizontal",
                                total: {
                                    enabled: !1,
                                    formatter: void 0,
                                    offsetX: 0,
                                    offsetY: 0,
                                    style: {
                                        color: "#373d3f",
                                        fontSize: "12px",
                                        fontFamily: void 0,
                                        fontWeight: 600
                                    }
                                }
                            }
                        },
                        bubble: {
                            zScaling: !0,
                            minBubbleRadius: void 0,
                            maxBubbleRadius: void 0
                        },
                        candlestick: {
                            colors: {
                                upward: "#00B746",
                                downward: "#EF403C"
                            },
                            wick: {
                                useFillColor: !0
                            }
                        },
                        boxPlot: {
                            colors: {
                                upper: "#00E396",
                                lower: "#008FFB"
                            }
                        },
                        heatmap: {
                            radius: 2,
                            enableShades: !0,
                            shadeIntensity: .5,
                            reverseNegativeShade: !1,
                            distributed: !1,
                            useFillColorAsStroke: !1,
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        treemap: {
                            enableShades: !0,
                            shadeIntensity: .5,
                            distributed: !1,
                            reverseNegativeShade: !1,
                            useFillColorAsStroke: !1,
                            borderRadius: 4,
                            dataLabels: {
                                format: "scale"
                            },
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        radialBar: {
                            inverseOrder: !1,
                            startAngle: 0,
                            endAngle: 360,
                            offsetX: 0,
                            offsetY: 0,
                            hollow: {
                                margin: 5,
                                size: "50%",
                                background: "transparent",
                                image: void 0,
                                imageWidth: 150,
                                imageHeight: 150,
                                imageOffsetX: 0,
                                imageOffsetY: 0,
                                imageClipped: !0,
                                position: "front",
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            track: {
                                show: !0,
                                startAngle: void 0,
                                endAngle: void 0,
                                background: "#f2f2f2",
                                strokeWidth: "97%",
                                opacity: 1,
                                margin: 5,
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            dataLabels: {
                                show: !0,
                                name: {
                                    show: !0,
                                    fontSize: "16px",
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    color: void 0,
                                    offsetY: 0,
                                    formatter: function(t) {
                                        return t;
                                    }
                                },
                                value: {
                                    show: !0,
                                    fontSize: "14px",
                                    fontFamily: void 0,
                                    fontWeight: 400,
                                    color: void 0,
                                    offsetY: 16,
                                    formatter: function(t) {
                                        return t + "%";
                                    }
                                },
                                total: {
                                    show: !1,
                                    label: "Total",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    fontFamily: void 0,
                                    color: void 0,
                                    formatter: function(t) {
                                        return t.globals.seriesTotals.reduce(function(t, e) {
                                            return t + e;
                                        }, 0) / t.globals.series.length + "%";
                                    }
                                }
                            },
                            barLabels: {
                                enabled: !1,
                                offsetX: 0,
                                offsetY: 0,
                                useSeriesColors: !0,
                                fontFamily: void 0,
                                fontWeight: 600,
                                fontSize: "16px",
                                formatter: function(t) {
                                    return t;
                                },
                                onClick: void 0
                            }
                        },
                        pie: {
                            customScale: 1,
                            offsetX: 0,
                            offsetY: 0,
                            startAngle: 0,
                            endAngle: 360,
                            expandOnClick: !0,
                            dataLabels: {
                                offset: 0,
                                minAngleToShowLabel: 10
                            },
                            donut: {
                                size: "65%",
                                background: "transparent",
                                labels: {
                                    show: !1,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: -10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "20px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        showAlways: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 400,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(t) {
                                            return t.globals.seriesTotals.reduce(function(t, e) {
                                                return t + e;
                                            }, 0);
                                        }
                                    }
                                }
                            }
                        },
                        polarArea: {
                            rings: {
                                strokeWidth: 1,
                                strokeColor: "#e8e8e8"
                            },
                            spokes: {
                                strokeWidth: 1,
                                connectorColors: "#e8e8e8"
                            }
                        },
                        radar: {
                            size: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            polygons: {
                                strokeWidth: 1,
                                strokeColors: "#e8e8e8",
                                connectorColors: "#e8e8e8",
                                fill: {
                                    colors: void 0
                                }
                            }
                        }
                    },
                    colors: void 0,
                    dataLabels: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        formatter: function(t) {
                            return null !== t ? t : "";
                        },
                        textAnchor: "middle",
                        distributed: !1,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 600,
                            colors: void 0
                        },
                        background: {
                            enabled: !0,
                            foreColor: "#fff",
                            borderRadius: 2,
                            padding: 4,
                            opacity: .9,
                            borderWidth: 1,
                            borderColor: "#fff",
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: .45
                            }
                        },
                        dropShadow: {
                            enabled: !1,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: "#000",
                            opacity: .45
                        }
                    },
                    fill: {
                        type: "solid",
                        colors: void 0,
                        opacity: .85,
                        gradient: {
                            shade: "dark",
                            type: "horizontal",
                            shadeIntensity: .5,
                            gradientToColors: void 0,
                            inverseColors: !0,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                0,
                                50,
                                100
                            ],
                            colorStops: []
                        },
                        image: {
                            src: [],
                            width: void 0,
                            height: void 0
                        },
                        pattern: {
                            style: "squares",
                            width: 6,
                            height: 6,
                            strokeWidth: 2
                        }
                    },
                    forecastDataPoints: {
                        count: 0,
                        fillOpacity: .5,
                        strokeWidth: void 0,
                        dashArray: 4
                    },
                    grid: {
                        show: !0,
                        borderColor: "#e0e0e0",
                        strokeDashArray: 0,
                        position: "back",
                        xaxis: {
                            lines: {
                                show: !1
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        row: {
                            colors: void 0,
                            opacity: .5
                        },
                        column: {
                            colors: void 0,
                            opacity: .5
                        },
                        padding: {
                            top: 0,
                            right: 10,
                            bottom: 0,
                            left: 12
                        }
                    },
                    labels: [],
                    legend: {
                        show: !0,
                        showForSingleSeries: !1,
                        showForNullSeries: !0,
                        showForZeroSeries: !0,
                        floating: !1,
                        position: "bottom",
                        horizontalAlign: "center",
                        inverseOrder: !1,
                        fontSize: "12px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        width: void 0,
                        height: void 0,
                        formatter: void 0,
                        tooltipHoverFormatter: void 0,
                        offsetX: -20,
                        offsetY: 4,
                        customLegendItems: [],
                        labels: {
                            colors: void 0,
                            useSeriesColors: !1
                        },
                        markers: {
                            size: 7,
                            fillColors: void 0,
                            strokeWidth: 1,
                            shape: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            customHTML: void 0,
                            onClick: void 0
                        },
                        itemMargin: {
                            horizontal: 5,
                            vertical: 4
                        },
                        onItemClick: {
                            toggleDataSeries: !0
                        },
                        onItemHover: {
                            highlightDataSeries: !0
                        }
                    },
                    markers: {
                        discrete: [],
                        size: 0,
                        colors: void 0,
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        strokeOpacity: .9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        shape: "circle",
                        offsetX: 0,
                        offsetY: 0,
                        showNullDataPoints: !0,
                        onClick: void 0,
                        onDblClick: void 0,
                        hover: {
                            size: void 0,
                            sizeOffset: 3
                        }
                    },
                    noData: {
                        text: void 0,
                        align: "center",
                        verticalAlign: "middle",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: void 0,
                            fontSize: "14px",
                            fontFamily: void 0
                        }
                    },
                    responsive: [],
                    series: void 0,
                    states: {
                        normal: {
                            filter: {
                                type: "none",
                                value: 0
                            }
                        },
                        hover: {
                            filter: {
                                type: "lighten",
                                value: .1
                            }
                        },
                        active: {
                            allowMultipleDataPointsSelection: !1,
                            filter: {
                                type: "darken",
                                value: .5
                            }
                        }
                    },
                    title: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: !1,
                        style: {
                            fontSize: "14px",
                            fontWeight: 900,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    subtitle: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 30,
                        floating: !1,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    stroke: {
                        show: !0,
                        curve: "smooth",
                        lineCap: "butt",
                        width: 2,
                        colors: void 0,
                        dashArray: 0,
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: .85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: .5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    0,
                                    50,
                                    100
                                ],
                                colorStops: []
                            }
                        }
                    },
                    tooltip: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        shared: !0,
                        hideEmptySeries: !1,
                        followCursor: !1,
                        intersect: !1,
                        inverseOrder: !1,
                        custom: void 0,
                        fillSeriesColor: !1,
                        theme: "light",
                        cssClass: "",
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0
                        },
                        onDatasetHover: {
                            highlightDataSeries: !1
                        },
                        x: {
                            show: !0,
                            format: "dd MMM",
                            formatter: void 0
                        },
                        y: {
                            formatter: void 0,
                            title: {
                                formatter: function(t) {
                                    return t ? t + ": " : "";
                                }
                            }
                        },
                        z: {
                            formatter: void 0,
                            title: "Size: "
                        },
                        marker: {
                            show: !0,
                            fillColors: void 0
                        },
                        items: {
                            display: "flex"
                        },
                        fixed: {
                            enabled: !1,
                            position: "topRight",
                            offsetX: 0,
                            offsetY: 0
                        }
                    },
                    xaxis: {
                        type: "category",
                        categories: [],
                        convertedCatToNumeric: !1,
                        offsetX: 0,
                        offsetY: 0,
                        overwriteCategories: void 0,
                        labels: {
                            show: !0,
                            rotate: -45,
                            rotateAlways: !1,
                            hideOverlappingLabels: !0,
                            trim: !1,
                            minHeight: void 0,
                            maxHeight: 120,
                            showDuplicates: !0,
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            },
                            offsetX: 0,
                            offsetY: 0,
                            format: void 0,
                            formatter: void 0,
                            datetimeUTC: !0,
                            datetimeFormatter: {
                                year: "yyyy",
                                month: "MMM 'yy",
                                day: "dd MMM",
                                hour: "HH:mm",
                                minute: "HH:mm:ss",
                                second: "HH:mm:ss"
                            }
                        },
                        group: {
                            groups: [],
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        axisBorder: {
                            show: !0,
                            color: "#e0e0e0",
                            width: "100%",
                            height: 1,
                            offsetX: 0,
                            offsetY: 0
                        },
                        axisTicks: {
                            show: !0,
                            color: "#e0e0e0",
                            height: 6,
                            offsetX: 0,
                            offsetY: 0
                        },
                        stepSize: void 0,
                        tickAmount: void 0,
                        tickPlacement: "on",
                        min: void 0,
                        max: void 0,
                        range: void 0,
                        floating: !1,
                        decimalsInFloat: void 0,
                        position: "bottom",
                        title: {
                            text: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "12px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        crosshairs: {
                            show: !0,
                            width: 1,
                            position: "back",
                            opacity: .9,
                            stroke: {
                                color: "#b6b6b6",
                                width: 1,
                                dashArray: 3
                            },
                            fill: {
                                type: "solid",
                                color: "#B1B9C4",
                                gradient: {
                                    colorFrom: "#D8E3F0",
                                    colorTo: "#BED1E6",
                                    stops: [
                                        0,
                                        100
                                    ],
                                    opacityFrom: .4,
                                    opacityTo: .5
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                left: 0,
                                top: 0,
                                blur: 1,
                                opacity: .4
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            offsetY: 0,
                            formatter: void 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            }
                        }
                    },
                    yaxis: this.yAxis,
                    theme: {
                        mode: "",
                        palette: "palette1",
                        monochrome: {
                            enabled: !1,
                            color: "#008FFB",
                            shadeTo: "light",
                            shadeIntensity: .65
                        }
                    }
                };
            }
        }
    ]), t;
}(), E = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.graphics = new k(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new S(this), this.xAxisAnnotations = new C(this), this.yAxisAnnotations = new I(this), this.pointsAnnotations = new T(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
    }
    return s(t, [
        {
            key: "drawAxesAnnotations",
            value: function() {
                var t = this.w;
                if (t.globals.axisCharts && t.globals.dataPoints) {
                    for(var e = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = t.config.chart.animations.enabled, r = [
                        e,
                        i,
                        a
                    ], o = [
                        i.node,
                        e.node,
                        a.node
                    ], n = 0; n < 3; n++)t.globals.dom.elGraphical.add(r[n]), !s || t.globals.resized || t.globals.dataChanged || "scatter" !== t.config.chart.type && "bubble" !== t.config.chart.type && t.globals.dataPoints > 1 && o[n].classList.add("apexcharts-element-hidden"), t.globals.delayedElements.push({
                        el: o[n],
                        index: 0
                    });
                    this.helpers.annotationsBackground();
                }
            }
        },
        {
            key: "drawImageAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.images.map(function(e, i) {
                    t.addImage(e, i);
                });
            }
        },
        {
            key: "drawTextAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.texts.map(function(e, i) {
                    t.addText(e, i);
                });
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                this.xAxisAnnotations.addXaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                this.yAxisAnnotations.addYaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.pointsAnnotations.addPointAnnotation(t, e, i);
            }
        },
        {
            key: "addText",
            value: function(t, e) {
                var i = t.x, a = t.y, s = t.text, r = t.textAnchor, o = t.foreColor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.cssClass, d = t.backgroundColor, g = t.borderWidth, u = t.strokeDashArray, f = t.borderRadius, p = t.borderColor, x = t.appendTo, b = void 0 === x ? ".apexcharts-svg" : x, v = t.paddingLeft, m = void 0 === v ? 4 : v, y = t.paddingRight, w = void 0 === y ? 4 : y, k = t.paddingBottom, A = void 0 === k ? 2 : k, S = t.paddingTop, C = void 0 === S ? 2 : S, L = this.w, P = this.graphics.drawText({
                    x: i,
                    y: a,
                    text: s,
                    textAnchor: r || "start",
                    fontSize: n || "12px",
                    fontWeight: h || "regular",
                    fontFamily: l || L.config.chart.fontFamily,
                    foreColor: o || L.config.chart.foreColor,
                    cssClass: c
                }), M = L.globals.dom.baseEl.querySelector(b);
                M && M.appendChild(P.node);
                var I = P.bbox();
                if (s) {
                    var T = this.graphics.drawRect(I.x - m, I.y - C, I.width + m + w, I.height + A + C, f, d || "transparent", 1, g, p, u);
                    M.insertBefore(T.node, P.node);
                }
            }
        },
        {
            key: "addImage",
            value: function(t, e) {
                var i = this.w, a = t.path, s = t.x, r = void 0 === s ? 0 : s, o = t.y, n = void 0 === o ? 0 : o, l = t.width, h = void 0 === l ? 20 : l, c = t.height, d = void 0 === c ? 20 : c, g = t.appendTo, u = void 0 === g ? ".apexcharts-svg" : g, f = i.globals.dom.Paper.image(a);
                f.size(h, d).move(r, n);
                var p = i.globals.dom.baseEl.querySelector(u);
                return p && p.appendChild(f.node), f;
            }
        },
        {
            key: "addXaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "xaxis",
                    contextMethod: i.addXaxisAnnotation
                }), i;
            }
        },
        {
            key: "addYaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "yaxis",
                    contextMethod: i.addYaxisAnnotation
                }), i;
            }
        },
        {
            key: "addPointAnnotationExternal",
            value: function(t, e, i) {
                return void 0 === this.invertAxis && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "point",
                    contextMethod: i.addPointAnnotation
                }), i;
            }
        },
        {
            key: "addAnnotationExternal",
            value: function(t) {
                var e = t.params, i = t.pushToMemory, a = t.context, s = t.type, r = t.contextMethod, o = a, n = o.w, l = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), h = l.childNodes.length + 1, c = new X, d = Object.assign({}, "xaxis" === s ? c.xAxisAnnotation : "yaxis" === s ? c.yAxisAnnotation : c.pointAnnotation), g = m.extend(d, e);
                switch(s){
                    case "xaxis":
                        this.addXaxisAnnotation(g, l, h);
                        break;
                    case "yaxis":
                        this.addYaxisAnnotation(g, l, h);
                        break;
                    case "point":
                        this.addPointAnnotation(g, l, h);
                }
                var u = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(h, "']")), f = this.helpers.addBackgroundToAnno(u, g);
                return f && l.insertBefore(f.node, u), i && n.globals.memory.methodsToExec.push({
                    context: o,
                    id: g.id ? g.id : m.randomId(),
                    method: r,
                    label: "addAnnotation",
                    params: e
                }), a;
            }
        },
        {
            key: "clearAnnotations",
            value: function(t) {
                for(var e = t.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations"), a = e.globals.memory.methodsToExec.length - 1; a >= 0; a--)"addText" !== e.globals.memory.methodsToExec[a].label && "addAnnotation" !== e.globals.memory.methodsToExec[a].label || e.globals.memory.methodsToExec.splice(a, 1);
                i = m.listToArray(i), Array.prototype.forEach.call(i, function(t) {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                });
            }
        },
        {
            key: "removeAnnotation",
            value: function(t, e) {
                var i = t.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(e));
                a && (i.globals.memory.methodsToExec.map(function(t, a) {
                    t.id === e && i.globals.memory.methodsToExec.splice(a, 1);
                }), Array.prototype.forEach.call(a, function(t) {
                    t.parentElement.removeChild(t);
                }));
            }
        }
    ]), t;
}(), Y = function(t) {
    var e, i = t.isTimeline, a = t.ctx, s = t.seriesIndex, r = t.dataPointIndex, o = t.y1, n = t.y2, l = t.w, h = l.globals.seriesRangeStart[s][r], c = l.globals.seriesRangeEnd[s][r], d = l.globals.labels[r], g = l.config.series[s].name ? l.config.series[s].name : "", u = l.globals.ttKeyFormatter, f = l.config.tooltip.y.title.formatter, p = {
        w: l,
        seriesIndex: s,
        dataPointIndex: r,
        start: h,
        end: c
    };
    ("function" == typeof f && (g = f(g, p)), null !== (e = l.config.series[s].data[r]) && void 0 !== e && e.x && (d = l.config.series[s].data[r].x), i) || "datetime" === l.config.xaxis.type && (d = new P(a).xLabelFormat(l.globals.ttKeyFormatter, d, d, {
        i: void 0,
        dateFormatter: new L(a).formatDate,
        w: l
    }));
    "function" == typeof u && (d = u(d, p)), Number.isFinite(o) && Number.isFinite(n) && (h = o, c = n);
    var x = "", b = "", v = l.globals.colors[s];
    if (void 0 === l.config.tooltip.x.formatter) {
        if ("datetime" === l.config.xaxis.type) {
            var m = new L(a);
            x = m.formatDate(m.getDate(h), l.config.tooltip.x.format), b = m.formatDate(m.getDate(c), l.config.tooltip.x.format);
        } else x = h, b = c;
    } else x = l.config.tooltip.x.formatter(h), b = l.config.tooltip.x.formatter(c);
    return {
        start: h,
        end: c,
        startVal: x,
        endVal: b,
        ylabel: d,
        color: v,
        seriesName: g
    };
}, R = function(t) {
    var e = t.color, i = t.seriesName, a = t.ylabel, s = t.start, r = t.end, o = t.seriesIndex, n = t.dataPointIndex, l = t.ctx.tooltip.tooltipLabels.getFormatters(o);
    s = l.yLbFormatter(s), r = l.yLbFormatter(r);
    var h = l.yLbFormatter(t.w.globals.series[o][n]), c = '<span class="value start-value">\n  '.concat(s, '\n  </span> <span class="separator">-</span> <span class="value end-value">\n  ').concat(r, "\n  </span>");
    return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (i || "") + '</span></div><div> <span class="category">' + a + ": </span> " + (t.w.globals.comboCharts ? "rangeArea" === t.w.config.series[o].type || "rangeBar" === t.w.config.series[o].type ? c : "<span>".concat(h, "</span>") : c) + " </div></div>";
}, F = function() {
    function t(e) {
        i(this, t), this.opts = e;
    }
    return s(t, [
        {
            key: "hideYAxis",
            value: function() {
                this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
            }
        },
        {
            key: "line",
            value: function() {
                return {
                    chart: {
                        animations: {
                            easing: "swing"
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "sparkline",
            value: function(t) {
                this.hideYAxis();
                return m.extend(t, {
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    legend: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    },
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    }
                });
            }
        },
        {
            key: "slope",
            value: function() {
                return this.hideYAxis(), {
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !0,
                        formatter: function(t, e) {
                            var i = e.w.config.series[e.seriesIndex].name;
                            return null !== t ? i + ": " + t : "";
                        },
                        background: {
                            enabled: !1
                        },
                        offsetX: -5
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !1
                            }
                        }
                    },
                    xaxis: {
                        position: "top",
                        labels: {
                            style: {
                                fontSize: 14,
                                fontWeight: 900
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    },
                    markers: {
                        size: 8,
                        hover: {
                            sizeOffset: 1
                        }
                    },
                    legend: {
                        show: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    }
                };
            }
        },
        {
            key: "bar",
            value: function() {
                return {
                    chart: {
                        stacked: !1,
                        animations: {
                            easing: "swing"
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "round"
                    },
                    fill: {
                        opacity: .85
                    },
                    legend: {
                        markers: {
                            shape: "square"
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        },
                        tickPlacement: "between",
                        crosshairs: {
                            width: "barWidth",
                            position: "back",
                            fill: {
                                type: "gradient"
                            },
                            dropShadow: {
                                enabled: !1
                            },
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "funnel",
            value: function() {
                return this.hideYAxis(), g(g({}, this.bar()), {}, {
                    chart: {
                        animations: {
                            easing: "linear",
                            speed: 800,
                            animateGradually: {
                                enabled: !1
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: !0,
                            borderRadiusApplication: "around",
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    }
                });
            }
        },
        {
            key: "candlestick",
            value: function() {
                var t = this;
                return {
                    stroke: {
                        width: 1,
                        colors: [
                            "#333"
                        ]
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Open",
                                "High",
                                "",
                                "Low",
                                "Close"
                            ], "candlestick");
                        }
                    },
                    states: {
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "boxPlot",
            value: function() {
                var t = this;
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !1
                            }
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: [
                            "#24292e"
                        ]
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Minimum",
                                "Q1",
                                "Median",
                                "Q3",
                                "Maximum"
                            ], "boxPlot");
                        }
                    },
                    markers: {
                        size: 7,
                        strokeWidth: 1,
                        strokeColors: "#111"
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "rangeBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            animateGradually: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "square"
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        enabled: !1,
                        formatter: function(t, e) {
                            e.ctx;
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w, r = function() {
                                var t = s.globals.seriesRangeStart[i][a];
                                return s.globals.seriesRangeEnd[i][a] - t;
                            };
                            return s.globals.comboCharts ? "rangeBar" === s.config.series[i].type || "rangeArea" === s.config.series[i].type ? r() : t : r();
                        },
                        background: {
                            enabled: !1
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    markers: {
                        size: 10
                    },
                    tooltip: {
                        shared: !1,
                        followCursor: !0,
                        custom: function(t) {
                            return t.w.config.plotOptions && t.w.config.plotOptions.bar && t.w.config.plotOptions.bar.horizontal ? function(t) {
                                var e = Y(g(g({}, t), {}, {
                                    isTimeline: !0
                                })), i = e.color, a = e.seriesName, s = e.ylabel, r = e.startVal, o = e.endVal;
                                return R(g(g({}, t), {}, {
                                    color: i,
                                    seriesName: a,
                                    ylabel: s,
                                    start: r,
                                    end: o
                                }));
                            }(t) : function(t) {
                                var e = Y(t), i = e.color, a = e.seriesName, s = e.ylabel, r = e.start, o = e.end;
                                return R(g(g({}, t), {}, {
                                    color: i,
                                    seriesName: a,
                                    ylabel: s,
                                    start: r,
                                    end: o
                                }));
                            }(t);
                        }
                    },
                    xaxis: {
                        tickPlacement: "between",
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "dumbbell",
            value: function(t) {
                var e, i;
                return null !== (e = t.plotOptions.bar) && void 0 !== e && e.barHeight || (t.plotOptions.bar.barHeight = 2), null !== (i = t.plotOptions.bar) && void 0 !== i && i.columnWidth || (t.plotOptions.bar.columnWidth = 2), t;
            }
        },
        {
            key: "area",
            value: function() {
                return {
                    stroke: {
                        width: 4,
                        fill: {
                            type: "solid",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: .65,
                                opacityTo: .5,
                                stops: [
                                    0,
                                    100,
                                    100
                                ]
                            }
                        }
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            inverseColors: !1,
                            shade: "light",
                            type: "vertical",
                            opacityFrom: .65,
                            opacityTo: .5,
                            stops: [
                                0,
                                100,
                                100
                            ]
                        }
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    tooltip: {
                        followCursor: !1
                    }
                };
            }
        },
        {
            key: "rangeArea",
            value: function() {
                return {
                    stroke: {
                        curve: "straight",
                        width: 0
                    },
                    fill: {
                        type: "solid",
                        opacity: .6
                    },
                    markers: {
                        size: 0
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "none"
                            }
                        },
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    tooltip: {
                        intersect: !1,
                        shared: !0,
                        followCursor: !0,
                        custom: function(t) {
                            return function(t) {
                                var e = Y(t), i = e.color, a = e.seriesName, s = e.ylabel, r = e.start, o = e.end;
                                return R(g(g({}, t), {}, {
                                    color: i,
                                    seriesName: a,
                                    ylabel: s,
                                    start: r,
                                    end: o
                                }));
                            }(t);
                        }
                    }
                };
            }
        },
        {
            key: "brush",
            value: function(t) {
                return m.extend(t, {
                    chart: {
                        toolbar: {
                            autoSelected: "selection",
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 1
                    },
                    tooltip: {
                        enabled: !1
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        }
                    }
                });
            }
        },
        {
            key: "stacked100",
            value: function(t) {
                t.dataLabels = t.dataLabels || {}, t.dataLabels.formatter = t.dataLabels.formatter || void 0;
                var e = t.dataLabels.formatter;
                return t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }), "bar" === t.chart.type && (t.dataLabels.formatter = e || function(t) {
                    return "number" == typeof t && t ? t.toFixed(0) + "%" : t;
                }), t;
            }
        },
        {
            key: "stackedBars",
            value: function() {
                var t = this.bar();
                return g(g({}, t), {}, {
                    plotOptions: g(g({}, t.plotOptions), {}, {
                        bar: g(g({}, t.plotOptions.bar), {}, {
                            borderRadiusApplication: "end",
                            borderRadiusWhenStacked: "last"
                        })
                    })
                });
            }
        },
        {
            key: "convertCatToNumeric",
            value: function(t) {
                return t.xaxis.convertedCatToNumeric = !0, t;
            }
        },
        {
            key: "convertCatToNumericXaxis",
            value: function(t, e, i) {
                t.xaxis.type = "numeric", t.xaxis.labels = t.xaxis.labels || {}, t.xaxis.labels.formatter = t.xaxis.labels.formatter || function(t) {
                    return m.isNumber(t) ? Math.floor(t) : t;
                };
                var a = t.xaxis.labels.formatter, s = t.xaxis.categories && t.xaxis.categories.length ? t.xaxis.categories : t.labels;
                return i && i.length && (s = i.map(function(t) {
                    return Array.isArray(t) ? t : String(t);
                })), s && s.length && (t.xaxis.labels.formatter = function(t) {
                    return m.isNumber(t) ? a(s[Math.floor(t) - 1]) : a(t);
                }), t.xaxis.categories = [], t.labels = [], t.xaxis.tickAmount = t.xaxis.tickAmount || "dataPoints", t;
            }
        },
        {
            key: "bubble",
            value: function() {
                return {
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        crosshairs: {
                            width: 0
                        }
                    },
                    fill: {
                        type: "solid",
                        gradient: {
                            shade: "light",
                            inverse: !0,
                            shadeIntensity: .55,
                            opacityFrom: .4,
                            opacityTo: .8
                        }
                    }
                };
            }
        },
        {
            key: "scatter",
            value: function() {
                return {
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    markers: {
                        size: 6,
                        strokeWidth: 1,
                        hover: {
                            sizeOffset: 2
                        }
                    }
                };
            }
        },
        {
            key: "heatmap",
            value: function() {
                return {
                    chart: {
                        stacked: !1
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    tooltip: {
                        followCursor: !0,
                        marker: {
                            show: !1
                        },
                        x: {
                            show: !1
                        }
                    },
                    legend: {
                        position: "top",
                        markers: {
                            shape: "square"
                        }
                    },
                    grid: {
                        padding: {
                            right: 20
                        }
                    }
                };
            }
        },
        {
            key: "treemap",
            value: function() {
                return {
                    chart: {
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        style: {
                            fontSize: 14,
                            fontWeight: 600,
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        show: !0,
                        width: 2,
                        colors: [
                            "#fff"
                        ]
                    },
                    legend: {
                        show: !1
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        followCursor: !0,
                        x: {
                            show: !1
                        }
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        }
                    }
                };
            }
        },
        {
            key: "pie",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: !1
                                }
                            }
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "donut",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            shadeIntensity: .35,
                            stops: [
                                80,
                                100
                            ],
                            opacityFrom: 1,
                            opacityTo: 1
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "polarArea",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        enabled: !1
                    },
                    stroke: {
                        show: !0,
                        width: 2
                    },
                    fill: {
                        opacity: .7
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "radar",
            value: function() {
                return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                    dataLabels: {
                        enabled: !1,
                        style: {
                            fontSize: "11px"
                        }
                    },
                    stroke: {
                        width: 2
                    },
                    markers: {
                        size: 5,
                        strokeWidth: 1,
                        strokeOpacity: 1
                    },
                    fill: {
                        opacity: .2
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            formatter: function(t) {
                                return t;
                            },
                            style: {
                                colors: [
                                    "#a8a8a8"
                                ],
                                fontSize: "11px"
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    }
                };
            }
        },
        {
            key: "radialBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 800
                            }
                        },
                        toolbar: {
                            show: !1
                        }
                    },
                    fill: {
                        gradient: {
                            shade: "dark",
                            shadeIntensity: .4,
                            inverseColors: !1,
                            type: "diagonal2",
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                70,
                                98,
                                100
                            ]
                        }
                    },
                    legend: {
                        show: !1,
                        position: "right"
                    },
                    tooltip: {
                        enabled: !1,
                        fillSeriesColor: !0
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "_getBoxTooltip",
            value: function(t, e, i, a, s) {
                var r = t.globals.seriesCandleO[e][i], o = t.globals.seriesCandleH[e][i], n = t.globals.seriesCandleM[e][i], l = t.globals.seriesCandleL[e][i], h = t.globals.seriesCandleC[e][i];
                return t.config.series[e].type && t.config.series[e].type !== s ? '<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name ? t.config.series[e].name : "series-" + (e + 1), ": <strong>").concat(t.globals.series[e][i], "</strong>\n        </div>") : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + o + "</span></div>" + (n ? "<div>".concat(a[2], ': <span class="value">') + n + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + l + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + h + "</span></div></div>";
            }
        }
    ]), t;
}(), D = function() {
    function t(e) {
        i(this, t), this.opts = e;
    }
    return s(t, [
        {
            key: "init",
            value: function(t) {
                var e = t.responsiveOverride, i = this.opts, a = new X, s = new F(i);
                this.chartType = i.chart.type, i = this.extendYAxis(i), i = this.extendAnnotations(i);
                var r = a.init(), o = {};
                if (i && "object" === b(i)) {
                    var n, l, h, c, d, g, u, f, p, x, v = {};
                    v = -1 !== [
                        "line",
                        "area",
                        "bar",
                        "candlestick",
                        "boxPlot",
                        "rangeBar",
                        "rangeArea",
                        "bubble",
                        "scatter",
                        "heatmap",
                        "treemap",
                        "pie",
                        "polarArea",
                        "donut",
                        "radar",
                        "radialBar"
                    ].indexOf(i.chart.type) ? s[i.chart.type]() : s.line(), null !== (n = i.plotOptions) && void 0 !== n && null !== (l = n.bar) && void 0 !== l && l.isFunnel && (v = s.funnel()), i.chart.stacked && "bar" === i.chart.type && (v = s.stackedBars()), null !== (h = i.chart.brush) && void 0 !== h && h.enabled && (v = s.brush(v)), null !== (c = i.plotOptions) && void 0 !== c && null !== (d = c.line) && void 0 !== d && d.isSlopeChart && (v = s.slope()), i.chart.stacked && "100%" === i.chart.stackType && (i = s.stacked100(i)), null !== (g = i.plotOptions) && void 0 !== g && null !== (u = g.bar) && void 0 !== u && u.isDumbbell && (i = s.dumbbell(i)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(i), i.xaxis = i.xaxis || window.Apex.xaxis || {}, e || (i.xaxis.convertedCatToNumeric = !1), (null !== (f = (i = this.checkForCatToNumericXAxis(this.chartType, v, i)).chart.sparkline) && void 0 !== f && f.enabled || null !== (p = window.Apex.chart) && void 0 !== p && null !== (x = p.sparkline) && void 0 !== x && x.enabled) && (v = s.sparkline(v)), o = m.extend(r, v);
                }
                var y = m.extend(o, window.Apex);
                return r = m.extend(y, i), r = this.handleUserInputErrors(r);
            }
        },
        {
            key: "checkForCatToNumericXAxis",
            value: function(t, e, i) {
                var a, s, r = new F(i), o = ("bar" === t || "boxPlot" === t) && (null === (a = i.plotOptions) || void 0 === a || null === (s = a.bar) || void 0 === s ? void 0 : s.horizontal), n = "pie" === t || "polarArea" === t || "donut" === t || "radar" === t || "radialBar" === t || "heatmap" === t, l = "datetime" !== i.xaxis.type && "numeric" !== i.xaxis.type, h = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : e.xaxis && e.xaxis.tickPlacement;
                return o || n || !l || "between" === h || (i = r.convertCatToNumeric(i)), i;
            }
        },
        {
            key: "extendYAxis",
            value: function(t, e) {
                var i = new X;
                (void 0 === t.yaxis || !t.yaxis || Array.isArray(t.yaxis) && 0 === t.yaxis.length) && (t.yaxis = {}), t.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (t.yaxis = m.extend(t.yaxis, window.Apex.yaxis)), t.yaxis.constructor !== Array ? t.yaxis = [
                    m.extend(i.yAxis, t.yaxis)
                ] : t.yaxis = m.extendArray(t.yaxis, i.yAxis);
                var a = !1;
                t.yaxis.forEach(function(t) {
                    t.logarithmic && (a = !0);
                });
                var s = t.series;
                return e && !s && (s = e.config.series), a && s.length !== t.yaxis.length && s.length && (t.yaxis = s.map(function(e, a) {
                    if (e.name || (s[a].name = "series-".concat(a + 1)), t.yaxis[a]) return t.yaxis[a].seriesName = s[a].name, t.yaxis[a];
                    var r = m.extend(i.yAxis, t.yaxis[0]);
                    return r.show = !1, r;
                })), a && s.length > 1 && s.length !== t.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"), t;
            }
        },
        {
            key: "extendAnnotations",
            value: function(t) {
                return void 0 === t.annotations && (t.annotations = {}, t.annotations.yaxis = [], t.annotations.xaxis = [], t.annotations.points = []), t = this.extendYAxisAnnotations(t), t = this.extendXAxisAnnotations(t), t = this.extendPointAnnotations(t);
            }
        },
        {
            key: "extendYAxisAnnotations",
            value: function(t) {
                var e = new X;
                return t.annotations.yaxis = m.extendArray(void 0 !== t.annotations.yaxis ? t.annotations.yaxis : [], e.yAxisAnnotation), t;
            }
        },
        {
            key: "extendXAxisAnnotations",
            value: function(t) {
                var e = new X;
                return t.annotations.xaxis = m.extendArray(void 0 !== t.annotations.xaxis ? t.annotations.xaxis : [], e.xAxisAnnotation), t;
            }
        },
        {
            key: "extendPointAnnotations",
            value: function(t) {
                var e = new X;
                return t.annotations.points = m.extendArray(void 0 !== t.annotations.points ? t.annotations.points : [], e.pointAnnotation), t;
            }
        },
        {
            key: "checkForDarkTheme",
            value: function(t) {
                t.theme && "dark" === t.theme.mode && (t.tooltip || (t.tooltip = {}), "light" !== t.tooltip.theme && (t.tooltip.theme = "dark"), t.chart.foreColor || (t.chart.foreColor = "#f6f7f8"), t.theme.palette || (t.theme.palette = "palette4"));
            }
        },
        {
            key: "handleUserInputErrors",
            value: function(t) {
                var e = t;
                if (e.tooltip.shared && e.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                if ("bar" === e.chart.type && e.plotOptions.bar.horizontal) {
                    if (e.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                    e.yaxis[0].reversed && (e.yaxis[0].opposite = !0), e.xaxis.tooltip.enabled = !1, e.yaxis[0].tooltip.enabled = !1, e.chart.zoom.enabled = !1;
                }
                return "bar" !== e.chart.type && "rangeBar" !== e.chart.type || e.tooltip.shared && "barWidth" === e.xaxis.crosshairs.width && e.series.length > 1 && (e.xaxis.crosshairs.width = "tickWidth"), "candlestick" !== e.chart.type && "boxPlot" !== e.chart.type || e.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(e.chart.type, " chart is not supported.")), e.yaxis[0].reversed = !1), e;
            }
        }
    ]), t;
}(), H = function() {
    function t() {
        i(this, t);
    }
    return s(t, [
        {
            key: "initGlobalVars",
            value: function(t) {
                t.series = [], t.seriesCandleO = [], t.seriesCandleH = [], t.seriesCandleM = [], t.seriesCandleL = [], t.seriesCandleC = [], t.seriesRangeStart = [], t.seriesRangeEnd = [], t.seriesRange = [], t.seriesPercent = [], t.seriesGoals = [], t.seriesX = [], t.seriesZ = [], t.seriesNames = [], t.seriesTotals = [], t.seriesLog = [], t.seriesColors = [], t.stackedSeriesTotals = [], t.seriesXvalues = [], t.seriesYvalues = [], t.labels = [], t.hasXaxisGroups = !1, t.groups = [], t.barGroups = [], t.lineGroups = [], t.areaGroups = [], t.hasSeriesGroups = !1, t.seriesGroups = [], t.categoryLabels = [], t.timescaleLabels = [], t.noLabelsProvided = !1, t.resizeTimer = null, t.selectionResizeTimer = null, t.lastWheelExecution = 0, t.delayedElements = [], t.pointsArray = [], t.dataLabelsRects = [], t.isXNumeric = !1, t.skipLastTimelinelabel = !1, t.skipFirstTimelinelabel = !1, t.isDataXYZ = !1, t.isMultiLineX = !1, t.isMultipleYAxis = !1, t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE, t.minYArr = [], t.maxYArr = [], t.maxX = -Number.MAX_VALUE, t.minX = Number.MAX_VALUE, t.initialMaxX = -Number.MAX_VALUE, t.initialMinX = Number.MAX_VALUE, t.maxDate = 0, t.minDate = Number.MAX_VALUE, t.minZ = Number.MAX_VALUE, t.maxZ = -Number.MAX_VALUE, t.minXDiff = Number.MAX_VALUE, t.yAxisScale = [], t.xAxisScale = null, t.xAxisTicksPositions = [], t.yLabelsCoords = [], t.yTitleCoords = [], t.barPadForNumericAxis = 0, t.padHorizontal = 0, t.xRange = 0, t.yRange = [], t.zRange = 0, t.dataPoints = 0, t.xTickAmount = 0, t.multiAxisTickAmount = 0;
            }
        },
        {
            key: "globalVars",
            value: function(t) {
                return {
                    chartID: null,
                    cuid: null,
                    events: {
                        beforeMount: [],
                        mounted: [],
                        updated: [],
                        clicked: [],
                        selection: [],
                        dataPointSelection: [],
                        zoomed: [],
                        scrolled: []
                    },
                    colors: [],
                    clientX: null,
                    clientY: null,
                    fill: {
                        colors: []
                    },
                    stroke: {
                        colors: []
                    },
                    dataLabels: {
                        style: {
                            colors: []
                        }
                    },
                    radarPolygons: {
                        fill: {
                            colors: []
                        }
                    },
                    markers: {
                        colors: [],
                        size: t.markers.size,
                        largestSize: 0
                    },
                    animationEnded: !1,
                    isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                    isDirty: !1,
                    isExecCalled: !1,
                    initialConfig: null,
                    initialSeries: [],
                    lastXAxis: [],
                    lastYAxis: [],
                    columnSeries: null,
                    labels: [],
                    timescaleLabels: [],
                    noLabelsProvided: !1,
                    allSeriesCollapsed: !1,
                    collapsedSeries: [],
                    collapsedSeriesIndices: [],
                    ancillaryCollapsedSeries: [],
                    ancillaryCollapsedSeriesIndices: [],
                    risingSeries: [],
                    dataFormatXNumeric: !1,
                    capturedSeriesIndex: -1,
                    capturedDataPointIndex: -1,
                    selectedDataPoints: [],
                    invalidLogScale: !1,
                    ignoreYAxisIndexes: [],
                    maxValsInArrayIndex: 0,
                    radialSize: 0,
                    selection: void 0,
                    zoomEnabled: "zoom" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.zoom && t.chart.zoom.enabled,
                    panEnabled: "pan" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.pan,
                    selectionEnabled: "selection" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.selection,
                    yaxis: null,
                    mousedown: !1,
                    lastClientPosition: {},
                    visibleXRange: void 0,
                    yValueDecimal: 0,
                    total: 0,
                    SVGNS: "http://www.w3.org/2000/svg",
                    svgWidth: 0,
                    svgHeight: 0,
                    noData: !1,
                    locale: {},
                    dom: {},
                    memory: {
                        methodsToExec: []
                    },
                    shouldAnimate: !0,
                    skipLastTimelinelabel: !1,
                    skipFirstTimelinelabel: !1,
                    delayedElements: [],
                    axisCharts: !0,
                    isDataXYZ: !1,
                    isSlopeChart: t.plotOptions.line.isSlopeChart,
                    resized: !1,
                    resizeTimer: null,
                    comboCharts: !1,
                    dataChanged: !1,
                    previousPaths: [],
                    allSeriesHasEqualX: !0,
                    pointsArray: [],
                    dataLabelsRects: [],
                    lastDrawnDataLabelsIndexes: [],
                    hasNullValues: !1,
                    easing: null,
                    zoomed: !1,
                    gridWidth: 0,
                    gridHeight: 0,
                    rotateXLabels: !1,
                    defaultLabels: !1,
                    xLabelFormatter: void 0,
                    yLabelFormatters: [],
                    xaxisTooltipFormatter: void 0,
                    ttKeyFormatter: void 0,
                    ttVal: void 0,
                    ttZFormatter: void 0,
                    LINE_HEIGHT_RATIO: 1.618,
                    xAxisLabelsHeight: 0,
                    xAxisGroupLabelsHeight: 0,
                    xAxisLabelsWidth: 0,
                    yAxisLabelsWidth: 0,
                    scaleX: 1,
                    scaleY: 1,
                    translateX: 0,
                    translateY: 0,
                    translateYAxisX: [],
                    yAxisWidths: [],
                    translateXAxisY: 0,
                    translateXAxisX: 0,
                    tooltip: null,
                    niceScaleAllowedMagMsd: [
                        [
                            1,
                            1,
                            2,
                            5,
                            5,
                            5,
                            10,
                            10,
                            10,
                            10,
                            10
                        ],
                        [
                            1,
                            1,
                            2,
                            5,
                            5,
                            5,
                            10,
                            10,
                            10,
                            10,
                            10
                        ]
                    ],
                    niceScaleDefaultTicks: [
                        1,
                        2,
                        4,
                        4,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        24
                    ],
                    seriesYAxisMap: [],
                    seriesYAxisReverseMap: []
                };
            }
        },
        {
            key: "init",
            value: function(t) {
                var e = this.globalVars(t);
                return this.initGlobalVars(e), e.initialConfig = m.extend({}, t), e.initialSeries = m.clone(t.series), e.lastXAxis = m.clone(e.initialConfig.xaxis), e.lastYAxis = m.clone(e.initialConfig.yaxis), e;
            }
        }
    ]), t;
}(), O = function() {
    function t(e) {
        i(this, t), this.opts = e;
    }
    return s(t, [
        {
            key: "init",
            value: function() {
                var t = new D(this.opts).init({
                    responsiveOverride: !1
                });
                return {
                    config: t,
                    globals: (new H).init(t)
                };
            }
        }
    ]), t;
}(), N = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0, this.patternIDs = [];
    }
    return s(t, [
        {
            key: "clippedImgArea",
            value: function(t) {
                var e = this.w, i = e.config, a = parseInt(e.globals.gridWidth, 10), s = parseInt(e.globals.gridHeight, 10), r = a > s ? a : s, o = t.image, n = 0, l = 0;
                void 0 === t.width && void 0 === t.height ? void 0 !== i.fill.image.width && void 0 !== i.fill.image.height ? (n = i.fill.image.width + 1, l = i.fill.image.height) : (n = r + 1, l = r) : (n = t.width, l = t.height);
                var h = document.createElementNS(e.globals.SVGNS, "pattern");
                k.setAttrs(h, {
                    id: t.patternID,
                    patternUnits: t.patternUnits ? t.patternUnits : "userSpaceOnUse",
                    width: n + "px",
                    height: l + "px"
                });
                var c = document.createElementNS(e.globals.SVGNS, "image");
                h.appendChild(c), c.setAttributeNS(window.SVG.xlink, "href", o), k.setAttrs(c, {
                    x: 0,
                    y: 0,
                    preserveAspectRatio: "none",
                    width: n + "px",
                    height: l + "px"
                }), c.style.opacity = t.opacity, e.globals.dom.elDefs.node.appendChild(h);
            }
        },
        {
            key: "getSeriesIndex",
            value: function(t) {
                var e = this.w, i = e.config.chart.type;
                return ("bar" === i || "rangeBar" === i) && e.config.plotOptions.bar.distributed || "heatmap" === i || "treemap" === i ? this.seriesIndex = t.seriesNumber : this.seriesIndex = t.seriesNumber % e.globals.series.length, this.seriesIndex;
            }
        },
        {
            key: "fillPath",
            value: function(t) {
                var e = this.w;
                this.opts = t;
                var i, a, s, r = this.w.config;
                this.seriesIndex = this.getSeriesIndex(t);
                var o = this.getFillColors()[this.seriesIndex];
                void 0 !== e.globals.seriesColors[this.seriesIndex] && (o = e.globals.seriesColors[this.seriesIndex]), "function" == typeof o && (o = o({
                    seriesIndex: this.seriesIndex,
                    dataPointIndex: t.dataPointIndex,
                    value: t.value,
                    w: e
                }));
                var n = t.fillType ? t.fillType : this.getFillType(this.seriesIndex), l = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                t.color && (o = t.color), o || (o = "#fff", console.warn("undefined color - ApexCharts"));
                var h = o;
                if (-1 === o.indexOf("rgb") ? o.length < 9 && (h = m.hexToRgba(o, l)) : o.indexOf("rgba") > -1 && (l = m.getOpacityFromRGBA(o)), t.opacity && (l = t.opacity), "pattern" === n && (a = this.handlePatternFill({
                    fillConfig: t.fillConfig,
                    patternFill: a,
                    fillColor: o,
                    fillOpacity: l,
                    defaultColor: h
                })), "gradient" === n && (s = this.handleGradientFill({
                    fillConfig: t.fillConfig,
                    fillColor: o,
                    fillOpacity: l,
                    i: this.seriesIndex
                })), "image" === n) {
                    var c = r.fill.image.src, d = t.patternID ? t.patternID : "", g = "pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d);
                    -1 === this.patternIDs.indexOf(g) && (this.clippedImgArea({
                        opacity: l,
                        image: Array.isArray(c) ? t.seriesNumber < c.length ? c[t.seriesNumber] : c[0] : c,
                        width: t.width ? t.width : void 0,
                        height: t.height ? t.height : void 0,
                        patternUnits: t.patternUnits,
                        patternID: g
                    }), this.patternIDs.push(g)), i = "url(#".concat(g, ")");
                } else i = "gradient" === n ? s : "pattern" === n ? a : h;
                return t.solid && (i = h), i;
            }
        },
        {
            key: "getFillType",
            value: function(t) {
                var e = this.w;
                return Array.isArray(e.config.fill.type) ? e.config.fill.type[t] : e.config.fill.type;
            }
        },
        {
            key: "getFillColors",
            value: function() {
                var t = this.w, e = t.config, i = this.opts, a = [];
                return t.globals.comboCharts ? "line" === t.config.series[this.seriesIndex].type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors) : "line" === e.chart.type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors), void 0 !== i.fillColors && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
            }
        },
        {
            key: "handlePatternFill",
            value: function(t) {
                var e = t.fillConfig, i = t.patternFill, a = t.fillColor, s = t.fillOpacity, r = t.defaultColor, o = this.w.config.fill;
                e && (o = e);
                var n = this.opts, l = new k(this.ctx), h = Array.isArray(o.pattern.strokeWidth) ? o.pattern.strokeWidth[this.seriesIndex] : o.pattern.strokeWidth, c = a;
                Array.isArray(o.pattern.style) ? i = void 0 !== o.pattern.style[n.seriesNumber] ? l.drawPattern(o.pattern.style[n.seriesNumber], o.pattern.width, o.pattern.height, c, h, s) : r : i = l.drawPattern(o.pattern.style, o.pattern.width, o.pattern.height, c, h, s);
                return i;
            }
        },
        {
            key: "handleGradientFill",
            value: function(t) {
                var e = t.fillColor, i = t.fillOpacity, a = t.fillConfig, s = t.i, r = this.w.config.fill;
                a && (r = g(g({}, r), a));
                var o, n = this.opts, l = new k(this.ctx), h = new m, c = r.gradient.type, d = e, u = void 0 === r.gradient.opacityFrom ? i : Array.isArray(r.gradient.opacityFrom) ? r.gradient.opacityFrom[s] : r.gradient.opacityFrom;
                d.indexOf("rgba") > -1 && (u = m.getOpacityFromRGBA(d));
                var f = void 0 === r.gradient.opacityTo ? i : Array.isArray(r.gradient.opacityTo) ? r.gradient.opacityTo[s] : r.gradient.opacityTo;
                if (void 0 === r.gradient.gradientToColors || 0 === r.gradient.gradientToColors.length) o = "dark" === r.gradient.shade ? h.shadeColor(-1 * parseFloat(r.gradient.shadeIntensity), e.indexOf("rgb") > -1 ? m.rgb2hex(e) : e) : h.shadeColor(parseFloat(r.gradient.shadeIntensity), e.indexOf("rgb") > -1 ? m.rgb2hex(e) : e);
                else if (r.gradient.gradientToColors[n.seriesNumber]) {
                    var p = r.gradient.gradientToColors[n.seriesNumber];
                    o = p, p.indexOf("rgba") > -1 && (f = m.getOpacityFromRGBA(p));
                } else o = e;
                if (r.gradient.gradientFrom && (d = r.gradient.gradientFrom), r.gradient.gradientTo && (o = r.gradient.gradientTo), r.gradient.inverseColors) {
                    var x = d;
                    d = o, o = x;
                }
                return d.indexOf("rgb") > -1 && (d = m.rgb2hex(d)), o.indexOf("rgb") > -1 && (o = m.rgb2hex(o)), l.drawGradient(c, d, o, u, f, n.size, r.gradient.stops, r.gradient.colorStops, s);
            }
        }
    ]), t;
}(), W = function() {
    function t(e, a) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "setGlobalMarkerSize",
            value: function() {
                var t = this.w;
                if (t.globals.markers.size = Array.isArray(t.config.markers.size) ? t.config.markers.size : [
                    t.config.markers.size
                ], t.globals.markers.size.length > 0) {
                    if (t.globals.markers.size.length < t.globals.series.length + 1) for(var e = 0; e <= t.globals.series.length; e++)void 0 === t.globals.markers.size[e] && t.globals.markers.size.push(t.globals.markers.size[0]);
                } else t.globals.markers.size = t.config.series.map(function(e) {
                    return t.config.markers.size;
                });
            }
        },
        {
            key: "plotChartMarkers",
            value: function(t, e, i, a) {
                var s, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = this.w, n = e, l = t, h = null, c = new k(this.ctx), d = o.config.markers.discrete && o.config.markers.discrete.length;
                if ((o.globals.markers.size[e] > 0 || r || d) && (h = c.group({
                    class: r || d ? "" : "apexcharts-series-markers"
                })).attr("clip-path", "url(#gridRectMarkerMask".concat(o.globals.cuid, ")")), Array.isArray(l.x)) for(var g = 0; g < l.x.length; g++){
                    var u = i;
                    1 === i && 0 === g && (u = 0), 1 === i && 1 === g && (u = 1);
                    var f = "apexcharts-marker";
                    if ("line" !== o.config.chart.type && "area" !== o.config.chart.type || o.globals.comboCharts || o.config.tooltip.intersect || (f += " no-pointer-events"), (Array.isArray(o.config.markers.size) ? o.globals.markers.size[e] > 0 : o.config.markers.size > 0) || r || d) {
                        m.isNumber(l.y[g]) ? f += " w".concat(m.randomId()) : f = "apexcharts-nullpoint";
                        var p = this.getMarkerConfig({
                            cssClass: f,
                            seriesIndex: e,
                            dataPointIndex: u
                        });
                        o.config.series[n].data[u] && (o.config.series[n].data[u].fillColor && (p.pointFillColor = o.config.series[n].data[u].fillColor), o.config.series[n].data[u].strokeColor && (p.pointStrokeColor = o.config.series[n].data[u].strokeColor)), void 0 !== a && (p.pSize = a), (l.x[g] < -o.globals.markers.largestSize || l.x[g] > o.globals.gridWidth + o.globals.markers.largestSize || l.y[g] < -o.globals.markers.largestSize || l.y[g] > o.globals.gridHeight + o.globals.markers.largestSize) && (p.pSize = 0), (s = c.drawMarker(l.x[g], l.y[g], p)).attr("rel", u), s.attr("j", u), s.attr("index", e), s.node.setAttribute("default-marker-size", p.pSize), new w(this.ctx).setSelectionFilter(s, e, u), this.addEvents(s), h && h.add(s);
                    } else void 0 === o.globals.pointsArray[e] && (o.globals.pointsArray[e] = []), o.globals.pointsArray[e].push([
                        l.x[g],
                        l.y[g]
                    ]);
                }
                return h;
            }
        },
        {
            key: "getMarkerConfig",
            value: function(t) {
                var e = t.cssClass, i = t.seriesIndex, a = t.dataPointIndex, s = void 0 === a ? null : a, r = t.radius, o = void 0 === r ? null : r, n = t.size, l = void 0 === n ? null : n, h = t.strokeWidth, c = void 0 === h ? null : h, d = this.w, g = this.getMarkerStyle(i), u = null === l ? d.globals.markers.size[i] : l, f = d.config.markers;
                return null !== s && f.discrete.length && f.discrete.map(function(t) {
                    t.seriesIndex === i && t.dataPointIndex === s && (g.pointStrokeColor = t.strokeColor, g.pointFillColor = t.fillColor, u = t.size, g.pointShape = t.shape);
                }), {
                    pSize: null === o ? u : o,
                    pRadius: null !== o ? o : f.radius,
                    pointStrokeWidth: null !== c ? c : Array.isArray(f.strokeWidth) ? f.strokeWidth[i] : f.strokeWidth,
                    pointStrokeColor: g.pointStrokeColor,
                    pointFillColor: g.pointFillColor,
                    shape: g.pointShape || (Array.isArray(f.shape) ? f.shape[i] : f.shape),
                    class: e,
                    pointStrokeOpacity: Array.isArray(f.strokeOpacity) ? f.strokeOpacity[i] : f.strokeOpacity,
                    pointStrokeDashArray: Array.isArray(f.strokeDashArray) ? f.strokeDashArray[i] : f.strokeDashArray,
                    pointFillOpacity: Array.isArray(f.fillOpacity) ? f.fillOpacity[i] : f.fillOpacity,
                    seriesIndex: i
                };
            }
        },
        {
            key: "addEvents",
            value: function(t) {
                var e = this.w, i = new k(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, t)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, t)), t.node.addEventListener("click", e.config.markers.onClick), t.node.addEventListener("dblclick", e.config.markers.onDblClick), t.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, t), {
                    passive: !0
                });
            }
        },
        {
            key: "getMarkerStyle",
            value: function(t) {
                var e = this.w, i = e.globals.markers.colors, a = e.config.markers.strokeColor || e.config.markers.strokeColors;
                return {
                    pointStrokeColor: Array.isArray(a) ? a[t] : a,
                    pointFillColor: Array.isArray(i) ? i[t] : i
                };
            }
        }
    ]), t;
}(), B = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled;
    }
    return s(t, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this.w, s = new k(this.ctx), r = i.realIndex, o = i.pointsPos, n = i.zRatio, l = i.elParent, h = s.group({
                    class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                });
                if (h.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(o.x)) for(var c = 0; c < o.x.length; c++){
                    var d = e + 1, g = !0;
                    0 === e && 0 === c && (d = 0), 0 === e && 1 === c && (d = 1);
                    var u = a.globals.markers.size[r];
                    if (n !== 1 / 0) {
                        var f = a.config.plotOptions.bubble;
                        u = a.globals.seriesZ[r][d], f.zScaling && (u /= n), f.minBubbleRadius && u < f.minBubbleRadius && (u = f.minBubbleRadius), f.maxBubbleRadius && u > f.maxBubbleRadius && (u = f.maxBubbleRadius);
                    }
                    var p = o.x[c], x = o.y[c];
                    if (u = u || 0, null !== x && void 0 !== a.globals.series[r][d] || (g = !1), g) {
                        var b = this.drawPoint(p, x, u, r, d, e);
                        h.add(b);
                    }
                    l.add(h);
                }
            }
        },
        {
            key: "drawPoint",
            value: function(t, e, i, a, s, r) {
                var o = this.w, n = a, l = new y(this.ctx), h = new w(this.ctx), c = new N(this.ctx), d = new W(this.ctx), g = new k(this.ctx), u = d.getMarkerConfig({
                    cssClass: "apexcharts-marker",
                    seriesIndex: n,
                    dataPointIndex: s,
                    radius: "bubble" === o.config.chart.type || o.globals.comboCharts && o.config.series[a] && "bubble" === o.config.series[a].type ? i : null
                }), f = c.fillPath({
                    seriesNumber: a,
                    dataPointIndex: s,
                    color: u.pointFillColor,
                    patternUnits: "objectBoundingBox",
                    value: o.globals.series[a][r]
                }), p = g.drawMarker(t, e, u);
                if (o.config.series[n].data[s] && o.config.series[n].data[s].fillColor && (f = o.config.series[n].data[s].fillColor), p.attr({
                    fill: f
                }), o.config.chart.dropShadow.enabled) {
                    var x = o.config.chart.dropShadow;
                    h.dropShadow(p, x, a);
                }
                if (!this.initialAnim || o.globals.dataChanged || o.globals.resized) o.globals.animationEnded = !0;
                else {
                    var b = o.config.chart.animations.speed;
                    l.animateMarker(p, b, o.globals.easing, function() {
                        window.setTimeout(function() {
                            l.animationCompleted(p);
                        }, 100);
                    });
                }
                return p.attr({
                    rel: s,
                    j: s,
                    index: a,
                    "default-marker-size": u.pSize
                }), h.setSelectionFilter(p, a, s), d.addEvents(p), p.node.classList.add("apexcharts-marker"), p;
            }
        },
        {
            key: "centerTextInBubble",
            value: function(t) {
                var e = this.w;
                return {
                    y: t += parseInt(e.config.dataLabels.style.fontSize, 10) / 4
                };
            }
        }
    ]), t;
}(), G = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "dataLabelsCorrection",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = !1, h = new k(this.ctx).getTextRects(i, o), c = h.width, d = h.height;
                e < 0 && (e = 0), e > n.globals.gridHeight + d && (e = n.globals.gridHeight + d / 2), void 0 === n.globals.dataLabelsRects[a] && (n.globals.dataLabelsRects[a] = []), n.globals.dataLabelsRects[a].push({
                    x: t,
                    y: e,
                    width: c,
                    height: d
                });
                var g = n.globals.dataLabelsRects[a].length - 2, u = void 0 !== n.globals.lastDrawnDataLabelsIndexes[a] ? n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                if (void 0 !== n.globals.dataLabelsRects[a][g]) {
                    var f = n.globals.dataLabelsRects[a][u];
                    (t > f.x + f.width || e > f.y + f.height || e + d < f.y || t + c < f.x) && (l = !0);
                }
                return (0 === s || r) && (l = !0), {
                    x: t,
                    y: e,
                    textRects: h,
                    drawnextLabel: l
                };
            }
        },
        {
            key: "drawDataLabel",
            value: function(t) {
                var e = this, i = t.type, a = t.pos, s = t.i, r = t.j, o = t.isRangeStart, n = t.strokeWidth, l = void 0 === n ? 2 : n, h = this.w, c = new k(this.ctx), d = h.config.dataLabels, g = 0, u = 0, f = r, p = null;
                if (-1 !== h.globals.collapsedSeriesIndices.indexOf(s) || !d.enabled || !Array.isArray(a.x)) return p;
                p = c.group({
                    class: "apexcharts-data-labels"
                });
                for(var x = 0; x < a.x.length; x++)if (g = a.x[x] + d.offsetX, u = a.y[x] + d.offsetY + l, !isNaN(g)) {
                    1 === r && 0 === x && (f = 0), 1 === r && 1 === x && (f = 1);
                    var b = h.globals.series[s][f];
                    "rangeArea" === i && (b = o ? h.globals.seriesRangeStart[s][f] : h.globals.seriesRangeEnd[s][f]);
                    var v = "", m = function(t) {
                        return h.config.dataLabels.formatter(t, {
                            ctx: e.ctx,
                            seriesIndex: s,
                            dataPointIndex: f,
                            w: h
                        });
                    };
                    if ("bubble" === h.config.chart.type) v = m(b = h.globals.seriesZ[s][f]), u = a.y[x], u = new B(this.ctx).centerTextInBubble(u, s, f).y;
                    else void 0 !== b && (v = m(b));
                    var y = h.config.dataLabels.textAnchor;
                    h.globals.isSlopeChart && (y = 0 === f ? "end" : f === h.config.series[s].data.length - 1 ? "start" : "middle"), this.plotDataLabelsText({
                        x: g,
                        y: u,
                        text: v,
                        i: s,
                        j: f,
                        parent: p,
                        offsetCorrection: !0,
                        dataLabelsConfig: h.config.dataLabels,
                        textAnchor: y
                    });
                }
                return p;
            }
        },
        {
            key: "plotDataLabelsText",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = t.x, s = t.y, r = t.i, o = t.j, n = t.text, l = t.textAnchor, h = t.fontSize, c = t.parent, d = t.dataLabelsConfig, g = t.color, u = t.alwaysDrawDataLabel, f = t.offsetCorrection, p = t.className, x = null;
                if (Array.isArray(e.config.dataLabels.enabledOnSeries) && e.config.dataLabels.enabledOnSeries.indexOf(r) < 0) return x;
                var b = {
                    x: a,
                    y: s,
                    drawnextLabel: !0,
                    textRects: null
                };
                f && (b = this.dataLabelsCorrection(a, s, n, r, o, u, parseInt(d.style.fontSize, 10))), e.globals.zoomed || (a = b.x, s = b.y), b.textRects && (a < -20 - b.textRects.width || a > e.globals.gridWidth + b.textRects.width + 30) && (n = "");
                var v = e.globals.dataLabels.style.colors[r];
                (("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || e.config.dataLabels.distributed) && (v = e.globals.dataLabels.style.colors[o]), "function" == typeof v && (v = v({
                    series: e.globals.series,
                    seriesIndex: r,
                    dataPointIndex: o,
                    w: e
                })), g && (v = g);
                var m = d.offsetX, y = d.offsetY;
                if ("bar" !== e.config.chart.type && "rangeBar" !== e.config.chart.type || (m = 0, y = 0), e.globals.isSlopeChart && (0 !== o && (m = -2 * d.offsetX + 5), 0 !== o && o !== e.config.series[r].data.length - 1 && (m = 0)), b.drawnextLabel) {
                    if ((x = i.drawText({
                        width: 100,
                        height: parseInt(d.style.fontSize, 10),
                        x: a + m,
                        y: s + y,
                        foreColor: v,
                        textAnchor: l || d.textAnchor,
                        text: n,
                        fontSize: h || d.style.fontSize,
                        fontFamily: d.style.fontFamily,
                        fontWeight: d.style.fontWeight || "normal"
                    })).attr({
                        class: p || "apexcharts-datalabel",
                        cx: a,
                        cy: s
                    }), d.dropShadow.enabled) {
                        var A = d.dropShadow;
                        new w(this.ctx).dropShadow(x, A);
                    }
                    c.add(x), void 0 === e.globals.lastDrawnDataLabelsIndexes[r] && (e.globals.lastDrawnDataLabelsIndexes[r] = []), e.globals.lastDrawnDataLabelsIndexes[r].push(o);
                }
                return x;
            }
        },
        {
            key: "addBackgroundToDataLabel",
            value: function(t, e) {
                var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, o = e.width, n = e.height, l = new k(this.ctx).drawRect(e.x - s, e.y - r / 2, o + 2 * s, n + r, a.borderRadius, "transparent" !== i.config.chart.background && i.config.chart.background ? i.config.chart.background : "#fff", a.opacity, a.borderWidth, a.borderColor);
                a.dropShadow.enabled && new w(this.ctx).dropShadow(l, a.dropShadow);
                return l;
            }
        },
        {
            key: "dataLabelsBackground",
            value: function() {
                var t = this.w;
                if ("bubble" !== t.config.chart.type) for(var e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < e.length; i++){
                    var a = e[i], s = a.getBBox(), r = null;
                    if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                        a.parentNode.insertBefore(r.node, a);
                        var o = a.getAttribute("fill");
                        t.config.chart.animations.enabled && !t.globals.resized && !t.globals.dataChanged ? r.animate().attr({
                            fill: o
                        }) : r.attr({
                            fill: o
                        }), a.setAttribute("fill", t.config.dataLabels.background.foreColor);
                    }
                }
            }
        },
        {
            key: "bringForward",
            value: function() {
                for(var t = this.w, e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < e.length; a++)i && i.insertBefore(e[a], i.nextSibling);
            }
        }
    ]), t;
}(), V = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
    }
    return s(t, [
        {
            key: "getAllSeriesEls",
            value: function() {
                return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
            }
        },
        {
            key: "getSeriesByName",
            value: function(t) {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(m.escapeString(t), "']"));
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                var e = this.getSeriesByName(t), i = parseInt(e.getAttribute("data:realIndex"), 10);
                return {
                    isHidden: e.classList.contains("apexcharts-series-collapsed"),
                    realIndex: i
                };
            }
        },
        {
            key: "addCollapsedClassToSeries",
            value: function(t, e) {
                var i = this.w;
                function a(i) {
                    for(var a = 0; a < i.length; a++)i[a].index === e && t.node.classList.add("apexcharts-series-collapsed");
                }
                a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, e.isHidden), e.isHidden;
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !0);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !1);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w, s = m.clone(a.globals.initialSeries);
                a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, t && (e && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
            }
        },
        {
            key: "emptyCollapsedSeries",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)e.globals.collapsedSeriesIndices.indexOf(i) > -1 && (t[i].data = []);
                return t;
            }
        },
        {
            key: "highlightSeries",
            value: function(t) {
                var e = this.w, i = this.getSeriesByName(t), a = parseInt(null == i ? void 0 : i.getAttribute("data:realIndex"), 10), s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis"), r = null, o = null, n = null;
                if (e.globals.axisCharts || "radialBar" === e.config.chart.type) {
                    if (e.globals.axisCharts) {
                        r = e.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(a, "']")), o = e.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(a, "']"));
                        var l = e.globals.seriesYAxisReverseMap[a];
                        n = e.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(l, "']"));
                    } else r = e.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(a + 1, "']"));
                } else r = e.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(a + 1, "'] path"));
                for(var h = 0; h < s.length; h++)s[h].classList.add(this.legendInactiveClass);
                if (r) e.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), null !== o && o.classList.remove(this.legendInactiveClass), null !== n && n.classList.remove(this.legendInactiveClass);
                else for(var c = 0; c < s.length; c++)s[c].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "toggleSeriesOnHover",
            value: function(t, e) {
                var i = this.w;
                e || (e = t.target);
                var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis");
                if ("mousemove" === t.type) {
                    var s = parseInt(e.getAttribute("rel"), 10) - 1;
                    this.highlightSeries(i.globals.seriesNames[s]);
                } else if ("mouseout" === t.type) for(var r = 0; r < a.length; r++)a[r].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "highlightRangeInSeries",
            value: function(t, e) {
                var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(t) {
                    for(var e = 0; e < s.length; e++)s[e].classList[t](i.legendInactiveClass);
                };
                if ("mousemove" === t.type) {
                    var o = parseInt(e.getAttribute("rel"), 10) - 1;
                    r("add");
                    var n = a.config.plotOptions.heatmap.colorScale.ranges;
                    !function(t, e) {
                        for(var a = 0; a < s.length; a++){
                            var r = Number(s[a].getAttribute("val"));
                            r >= t.from && (r < t.to || t.to === e && r === e) && s[a].classList.remove(i.legendInactiveClass);
                        }
                    }(n[o], n.reduce(function(t, e) {
                        return Math.max(t, e.to);
                    }, 0));
                } else "mouseout" === t.type && r("remove");
            }
        },
        {
            key: "getActiveConfigSeriesIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "asc", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], i = this.w, a = 0;
                if (i.config.series.length > 1) {
                    for(var s = i.config.series.map(function(t, a) {
                        return t.data && t.data.length > 0 && -1 === i.globals.collapsedSeriesIndices.indexOf(a) && (!i.globals.comboCharts || 0 === e.length || e.length && e.indexOf(i.config.series[a].type) > -1) ? a : -1;
                    }), r = "asc" === t ? 0 : s.length - 1; "asc" === t ? r < s.length : r >= 0; "asc" === t ? r++ : r--)if (-1 !== s[r]) {
                        a = s[r];
                        break;
                    }
                }
                return a;
            }
        },
        {
            key: "getBarSeriesIndices",
            value: function() {
                return this.w.globals.comboCharts ? this.w.config.series.map(function(t, e) {
                    return "bar" === t.type || "column" === t.type ? e : -1;
                }).filter(function(t) {
                    return -1 !== t;
                }) : this.w.config.series.map(function(t, e) {
                    return e;
                });
            }
        },
        {
            key: "getPreviousPaths",
            value: function() {
                var t = this.w;
                function e(e, i, a) {
                    for(var s = e[i].childNodes, r = {
                        type: a,
                        paths: [],
                        realIndex: e[i].getAttribute("data:realIndex")
                    }, o = 0; o < s.length; o++)if (s[o].hasAttribute("pathTo")) {
                        var n = s[o].getAttribute("pathTo");
                        r.paths.push({
                            d: n
                        });
                    }
                    t.globals.previousPaths.push(r);
                }
                t.globals.previousPaths = [];
                [
                    "line",
                    "area",
                    "bar",
                    "rangebar",
                    "rangeArea",
                    "candlestick",
                    "radar"
                ].forEach(function(i) {
                    for(var a, s = (a = i, t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a, "-series .apexcharts-series"))), r = 0; r < s.length; r++)e(s, r, i);
                }), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series"));
                if (i.length > 0) for(var a = function(e) {
                    for(var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(e, "'] rect")), a = [], s = function(t) {
                        var e = function(e) {
                            return i[t].getAttribute(e);
                        }, s = {
                            x: parseFloat(e("x")),
                            y: parseFloat(e("y")),
                            width: parseFloat(e("width")),
                            height: parseFloat(e("height"))
                        };
                        a.push({
                            rect: s,
                            color: i[t].getAttribute("color")
                        });
                    }, r = 0; r < i.length; r++)s(r);
                    t.globals.previousPaths.push(a);
                }, s = 0; s < i.length; s++)a(s);
                t.globals.axisCharts || (t.globals.previousPaths = t.globals.series);
            }
        },
        {
            key: "handlePrevBubbleScatterPaths",
            value: function(t) {
                var e = this.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series"));
                if (i.length > 0) for(var a = 0; a < i.length; a++){
                    for(var s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series[data\\:realIndex='").concat(a, "'] circle")), r = [], o = 0; o < s.length; o++)r.push({
                        x: s[o].getAttribute("cx"),
                        y: s[o].getAttribute("cy"),
                        r: s[o].getAttribute("r")
                    });
                    e.globals.previousPaths.push(r);
                }
            }
        },
        {
            key: "clearPreviousPaths",
            value: function() {
                var t = this.w;
                t.globals.previousPaths = [], t.globals.allSeriesCollapsed = !1;
            }
        },
        {
            key: "handleNoData",
            value: function() {
                var t = this.w, e = t.config.noData, i = new k(this.ctx), a = t.globals.svgWidth / 2, s = t.globals.svgHeight / 2, r = "middle";
                if (t.globals.noData = !0, t.globals.animationEnded = !0, "left" === e.align ? (a = 10, r = "start") : "right" === e.align && (a = t.globals.svgWidth - 10, r = "end"), "top" === e.verticalAlign ? s = 50 : "bottom" === e.verticalAlign && (s = t.globals.svgHeight - 50), a += e.offsetX, s = s + parseInt(e.style.fontSize, 10) + 2 + e.offsetY, void 0 !== e.text && "" !== e.text) {
                    var o = i.drawText({
                        x: a,
                        y: s,
                        text: e.text,
                        textAnchor: r,
                        fontSize: e.style.fontSize,
                        fontFamily: e.style.fontFamily,
                        foreColor: e.style.color,
                        opacity: 1,
                        class: "apexcharts-text-nodata"
                    });
                    t.globals.dom.Paper.add(o);
                }
            }
        },
        {
            key: "setNullSeriesToZeroValues",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)if (0 === t[i].length) for(var a = 0; a < t[e.globals.maxValsInArrayIndex].length; a++)t[i].push(0);
                return t;
            }
        },
        {
            key: "hasAllSeriesEqualX",
            value: function() {
                for(var t = !0, e = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                    t = !1;
                    break;
                }
                return e.globals.allSeriesHasEqualX = t, t;
            }
        },
        {
            key: "filteredSeriesX",
            value: function() {
                var t = this.w.globals.seriesX.map(function(t) {
                    return t.length > 0 ? t : [];
                });
                return t;
            }
        }
    ]), t;
}(), _ = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new A(this.ctx);
    }
    return s(t, [
        {
            key: "isMultiFormat",
            value: function() {
                return this.isFormatXY() || this.isFormat2DArray();
            }
        },
        {
            key: "isFormatXY",
            value: function() {
                var t = this.w.config.series.slice(), e = new V(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && null !== t[this.activeSeriesIndex].data[0] && void 0 !== t[this.activeSeriesIndex].data[0].x && null !== t[this.activeSeriesIndex].data[0]) return !0;
            }
        },
        {
            key: "isFormat2DArray",
            value: function() {
                var t = this.w.config.series.slice(), e = new V(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && void 0 !== t[this.activeSeriesIndex].data[0] && null !== t[this.activeSeriesIndex].data[0] && t[this.activeSeriesIndex].data[0].constructor === Array) return !0;
            }
        },
        {
            key: "handleFormat2DArray",
            value: function(t, e) {
                for(var i = this.w.config, a = this.w.globals, s = "boxPlot" === i.chart.type || "boxPlot" === i.series[e].type, r = 0; r < t[e].data.length; r++)if (void 0 !== t[e].data[r][1] && (Array.isArray(t[e].data[r][1]) && 4 === t[e].data[r][1].length && !s ? this.twoDSeries.push(m.parseNumber(t[e].data[r][1][3])) : t[e].data[r].length >= 5 ? this.twoDSeries.push(m.parseNumber(t[e].data[r][4])) : this.twoDSeries.push(m.parseNumber(t[e].data[r][1])), a.dataFormatXNumeric = !0), "datetime" === i.xaxis.type) {
                    var o = new Date(t[e].data[r][0]);
                    o = new Date(o).getTime(), this.twoDSeriesX.push(o);
                } else this.twoDSeriesX.push(t[e].data[r][0]);
                for(var n = 0; n < t[e].data.length; n++)void 0 !== t[e].data[n][2] && (this.threeDSeries.push(t[e].data[n][2]), a.isDataXYZ = !0);
            }
        },
        {
            key: "handleFormatXY",
            value: function(t, e) {
                var i = this.w.config, a = this.w.globals, s = new L(this.ctx), r = e;
                a.collapsedSeriesIndices.indexOf(e) > -1 && (r = this.activeSeriesIndex);
                for(var o = 0; o < t[e].data.length; o++)void 0 !== t[e].data[o].y && (Array.isArray(t[e].data[o].y) ? this.twoDSeries.push(m.parseNumber(t[e].data[o].y[t[e].data[o].y.length - 1])) : this.twoDSeries.push(m.parseNumber(t[e].data[o].y))), void 0 !== t[e].data[o].goals && Array.isArray(t[e].data[o].goals) ? (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(t[e].data[o].goals)) : (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(null));
                for(var n = 0; n < t[r].data.length; n++){
                    var l = "string" == typeof t[r].data[n].x, h = Array.isArray(t[r].data[n].x), c = !h && !!s.isValidDate(t[r].data[n].x);
                    if (l || c) {
                        if (l || i.xaxis.convertedCatToNumeric) {
                            var d = a.isBarHorizontal && a.isRangeData;
                            "datetime" !== i.xaxis.type || d ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x), isNaN(t[r].data[n].x) || "category" === this.w.config.xaxis.type || "string" == typeof t[r].data[n].x || (a.isXNumeric = !0)) : this.twoDSeriesX.push(s.parseDate(t[r].data[n].x));
                        } else "datetime" === i.xaxis.type ? this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));
                    } else h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(t[r].data[n].x));
                }
                if (t[e].data[0] && void 0 !== t[e].data[0].z) {
                    for(var g = 0; g < t[e].data.length; g++)this.threeDSeries.push(t[e].data[g].z);
                    a.isDataXYZ = !0;
                }
            }
        },
        {
            key: "handleRangeData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", t, e)), i.seriesRangeStart.push(void 0 === a.start ? [] : a.start), i.seriesRangeEnd.push(void 0 === a.end ? [] : a.end), i.seriesRange.push(a.rangeUniques), i.seriesRange.forEach(function(t, e) {
                    t && t.forEach(function(t, e) {
                        t.y.forEach(function(e, i) {
                            for(var a = 0; a < t.y.length; a++)if (i !== a) {
                                var s = e.y1, r = e.y2, o = t.y[a].y1;
                                s <= t.y[a].y2 && o <= r && (t.overlaps.indexOf(e.rangeName) < 0 && t.overlaps.push(e.rangeName), t.overlaps.indexOf(t.y[a].rangeName) < 0 && t.overlaps.push(t.y[a].rangeName));
                            }
                        });
                    });
                }), a;
            }
        },
        {
            key: "handleCandleStickBoxData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", t, e)), i.seriesCandleO[e] = a.o, i.seriesCandleH[e] = a.h, i.seriesCandleM[e] = a.m, i.seriesCandleL[e] = a.l, i.seriesCandleC[e] = a.c, a;
            }
        },
        {
            key: "handleRangeDataFormat",
            value: function(t, e, i) {
                var a = [], s = [], r = e[i].data.filter(function(t, e, i) {
                    return e === i.findIndex(function(e) {
                        return e.x === t.x;
                    });
                }).map(function(t, e) {
                    return {
                        x: t.x,
                        overlaps: [],
                        y: []
                    };
                });
                if ("array" === t) for(var o = 0; o < e[i].data.length; o++)Array.isArray(e[i].data[o]) ? (a.push(e[i].data[o][1][0]), s.push(e[i].data[o][1][1])) : (a.push(e[i].data[o]), s.push(e[i].data[o]));
                else if ("xy" === t) for(var n = function(t) {
                    var o = Array.isArray(e[i].data[t].y), n = m.randomId(), l = e[i].data[t].x, h = {
                        y1: o ? e[i].data[t].y[0] : e[i].data[t].y,
                        y2: o ? e[i].data[t].y[1] : e[i].data[t].y,
                        rangeName: n
                    };
                    e[i].data[t].rangeName = n;
                    var c = r.findIndex(function(t) {
                        return t.x === l;
                    });
                    r[c].y.push(h), a.push(h.y1), s.push(h.y2);
                }, l = 0; l < e[i].data.length; l++)n(l);
                return {
                    start: a,
                    end: s,
                    rangeUniques: r
                };
            }
        },
        {
            key: "handleCandleStickBoxDataFormat",
            value: function(t, e, i) {
                var a = this.w, s = "boxPlot" === a.config.chart.type || "boxPlot" === a.config.series[i].type, r = [], o = [], n = [], l = [], h = [];
                if ("array" === t) {
                    if (s && 6 === e[i].data[0].length || !s && 5 === e[i].data[0].length) for(var c = 0; c < e[i].data.length; c++)r.push(e[i].data[c][1]), o.push(e[i].data[c][2]), s ? (n.push(e[i].data[c][3]), l.push(e[i].data[c][4]), h.push(e[i].data[c][5])) : (l.push(e[i].data[c][3]), h.push(e[i].data[c][4]));
                    else for(var d = 0; d < e[i].data.length; d++)Array.isArray(e[i].data[d][1]) && (r.push(e[i].data[d][1][0]), o.push(e[i].data[d][1][1]), s ? (n.push(e[i].data[d][1][2]), l.push(e[i].data[d][1][3]), h.push(e[i].data[d][1][4])) : (l.push(e[i].data[d][1][2]), h.push(e[i].data[d][1][3])));
                } else if ("xy" === t) for(var g = 0; g < e[i].data.length; g++)Array.isArray(e[i].data[g].y) && (r.push(e[i].data[g].y[0]), o.push(e[i].data[g].y[1]), s ? (n.push(e[i].data[g].y[2]), l.push(e[i].data[g].y[3]), h.push(e[i].data[g].y[4])) : (l.push(e[i].data[g].y[2]), h.push(e[i].data[g].y[3])));
                return {
                    o: r,
                    h: o,
                    m: n,
                    l: l,
                    c: h
                };
            }
        },
        {
            key: "parseDataAxisCharts",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.ctx, a = this.w.config, s = this.w.globals, r = new L(i), o = a.labels.length > 0 ? a.labels.slice() : a.xaxis.categories.slice();
                s.isRangeBar = "rangeBar" === a.chart.type && s.isBarHorizontal, s.hasXaxisGroups = "category" === a.xaxis.type && a.xaxis.group.groups.length > 0, s.hasXaxisGroups && (s.groups = a.xaxis.group.groups), t.forEach(function(t, e) {
                    void 0 !== t.name ? s.seriesNames.push(t.name) : s.seriesNames.push("series-" + parseInt(e + 1, 10));
                }), this.coreUtils.setSeriesYAxisMappings();
                var n = [], l = p(new Set(a.series.map(function(t) {
                    return t.group;
                })));
                a.series.forEach(function(t, e) {
                    var i = l.indexOf(t.group);
                    n[i] || (n[i] = []), n[i].push(s.seriesNames[e]);
                }), s.seriesGroups = n;
                for(var h = function() {
                    for(var t = 0; t < o.length; t++)if ("string" == typeof o[t]) {
                        if (!r.isValidDate(o[t])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                        e.twoDSeriesX.push(r.parseDate(o[t]));
                    } else e.twoDSeriesX.push(o[t]);
                }, c = 0; c < t.length; c++){
                    if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], void 0 === t[c].data) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                    if ("rangeBar" !== a.chart.type && "rangeArea" !== a.chart.type && "rangeBar" !== t[c].type && "rangeArea" !== t[c].type || (s.isRangeData = !0, "rangeBar" !== a.chart.type && "rangeArea" !== a.chart.type || this.handleRangeData(t, c)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(t, c) : this.isFormatXY() && this.handleFormatXY(t, c), "candlestick" !== a.chart.type && "candlestick" !== t[c].type && "boxPlot" !== a.chart.type && "boxPlot" !== t[c].type || this.handleCandleStickBoxData(t, c), s.series.push(this.twoDSeries), s.labels.push(this.twoDSeriesX), s.seriesX.push(this.twoDSeriesX), s.seriesGoals = this.seriesGoals, c !== this.activeSeriesIndex || this.fallbackToCategory || (s.isXNumeric = !0);
                    else {
                        "datetime" === a.xaxis.type ? (s.isXNumeric = !0, h(), s.seriesX.push(this.twoDSeriesX)) : "numeric" === a.xaxis.type && (s.isXNumeric = !0, o.length > 0 && (this.twoDSeriesX = o, s.seriesX.push(this.twoDSeriesX))), s.labels.push(this.twoDSeriesX);
                        var d = t[c].data.map(function(t) {
                            return m.parseNumber(t);
                        });
                        s.series.push(d);
                    }
                    s.seriesZ.push(this.threeDSeries), void 0 !== t[c].color ? s.seriesColors.push(t[c].color) : s.seriesColors.push(void 0);
                }
                return this.w;
            }
        },
        {
            key: "parseDataNonAxisCharts",
            value: function(t) {
                var e = this.w.globals, i = this.w.config;
                e.series = t.slice(), e.seriesNames = i.labels.slice();
                for(var a = 0; a < e.series.length; a++)void 0 === e.seriesNames[a] && e.seriesNames.push("series-" + (a + 1));
                return this.w;
            }
        },
        {
            key: "handleExternalLabelsData",
            value: function(t) {
                var e = this.w.config, i = this.w.globals;
                if (e.xaxis.categories.length > 0) i.labels = e.xaxis.categories;
                else if (e.labels.length > 0) i.labels = e.labels.slice();
                else if (this.fallbackToCategory) {
                    if (i.labels = i.labels[0], i.seriesRange.length && (i.seriesRange.map(function(t) {
                        t.forEach(function(t) {
                            i.labels.indexOf(t.x) < 0 && t.x && i.labels.push(t.x);
                        });
                    }), i.labels = Array.from(new Set(i.labels.map(JSON.stringify)), JSON.parse)), e.xaxis.convertedCatToNumeric) new F(e).convertCatToNumericXaxis(e, this.ctx, i.seriesX[0]), this._generateExternalLabels(t);
                } else this._generateExternalLabels(t);
            }
        },
        {
            key: "_generateExternalLabels",
            value: function(t) {
                var e = this.w.globals, i = this.w.config, a = [];
                if (e.axisCharts) {
                    if (e.series.length > 0) {
                        if (this.isFormatXY()) for(var s = i.series.map(function(t, e) {
                            return t.data.filter(function(t, e, i) {
                                return i.findIndex(function(e) {
                                    return e.x === t.x;
                                }) === e;
                            });
                        }), r = s.reduce(function(t, e, i, a) {
                            return a[t].length > e.length ? t : i;
                        }, 0), o = 0; o < s[r].length; o++)a.push(o + 1);
                        else for(var n = 0; n < e.series[e.maxValsInArrayIndex].length; n++)a.push(n + 1);
                    }
                    e.seriesX = [];
                    for(var l = 0; l < t.length; l++)e.seriesX.push(a);
                    this.w.globals.isBarHorizontal || (e.isXNumeric = !0);
                }
                if (0 === a.length) {
                    a = e.axisCharts ? [] : e.series.map(function(t, e) {
                        return e + 1;
                    });
                    for(var h = 0; h < t.length; h++)e.seriesX.push(a);
                }
                e.labels = a, i.xaxis.convertedCatToNumeric && (e.categoryLabels = a.map(function(t) {
                    return i.xaxis.labels.formatter(t);
                })), e.noLabelsProvided = !0;
            }
        },
        {
            key: "parseData",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? (this.parseDataAxisCharts(t), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(t), i.chart.stacked) {
                    var s = new V(this.ctx);
                    a.series = s.setNullSeriesToZeroValues(a.series);
                }
                this.coreUtils.getSeriesTotals(), a.axisCharts && (a.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals(), a.stackedSeriesTotalsByGroups = this.coreUtils.getStackedSeriesTotalsByGroups()), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && ("numeric" !== i.xaxis.type || 0 !== i.labels.length || 0 !== i.xaxis.categories.length) || this.handleExternalLabelsData(t);
                for(var r = this.coreUtils.getCategoryLabels(a.labels), o = 0; o < r.length; o++)if (Array.isArray(r[o])) {
                    a.isMultiLineX = !0;
                    break;
                }
            }
        },
        {
            key: "excludeCollapsedSeriesInYAxis",
            value: function() {
                var t = this.w, e = [];
                t.globals.seriesYAxisMap.forEach(function(i, a) {
                    var s = 0;
                    i.forEach(function(e) {
                        -1 !== t.globals.collapsedSeriesIndices.indexOf(e) && s++;
                    }), s > 0 && s == i.length && e.push(a);
                }), t.globals.ignoreYAxisIndexes = e.map(function(t) {
                    return t;
                });
            }
        }
    ]), t;
}(), U = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "scaleSvgNode",
            value: function(t, e) {
                var i = parseFloat(t.getAttributeNS(null, "width")), a = parseFloat(t.getAttributeNS(null, "height"));
                t.setAttributeNS(null, "width", i * e), t.setAttributeNS(null, "height", a * e), t.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
            }
        },
        {
            key: "getSvgString",
            value: function() {
                var t = this;
                return new Promise(function(e) {
                    var i = t.w, a = i.config.chart.toolbar.export.width, s = i.config.chart.toolbar.export.scale || a / i.globals.svgWidth;
                    s || (s = 1);
                    var r = t.w.globals.dom.Paper.svg(), o = t.w.globals.dom.Paper.node.cloneNode(!0);
                    1 !== s && t.scaleSvgNode(o, s), t.convertImagesToBase64(o).then(function() {
                        r = (new XMLSerializer).serializeToString(o), e(r.replace(/&nbsp;/g, "&#160;"));
                    });
                });
            }
        },
        {
            key: "convertImagesToBase64",
            value: function(t) {
                var e = this, i = t.getElementsByTagName("image"), a = Array.from(i).map(function(t) {
                    var i = t.getAttributeNS("http://www.w3.org/1999/xlink", "href");
                    return i && !i.startsWith("data:") ? e.getBase64FromUrl(i).then(function(e) {
                        t.setAttributeNS("http://www.w3.org/1999/xlink", "href", e);
                    }).catch(function(t) {
                        console.error("Error converting image to base64:", t);
                    }) : Promise.resolve();
                });
                return Promise.all(a);
            }
        },
        {
            key: "getBase64FromUrl",
            value: function(t) {
                return new Promise(function(e, i) {
                    var a = new Image;
                    a.crossOrigin = "Anonymous", a.onload = function() {
                        var t = document.createElement("canvas");
                        t.width = a.width, t.height = a.height, t.getContext("2d").drawImage(a, 0, 0), e(t.toDataURL());
                    }, a.onerror = i, a.src = t;
                });
            }
        },
        {
            key: "cleanup",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"), i = t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                Array.prototype.forEach.call(a, function(t) {
                    t.setAttribute("width", 0);
                }), e && e[0] && (e[0].setAttribute("x", -500), e[0].setAttribute("x1", -500), e[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100));
            }
        },
        {
            key: "svgUrl",
            value: function() {
                var t = this;
                return new Promise(function(e) {
                    t.cleanup(), t.getSvgString().then(function(t) {
                        var i = new Blob([
                            t
                        ], {
                            type: "image/svg+xml;charset=utf-8"
                        });
                        e(URL.createObjectURL(i));
                    });
                });
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                var e = this;
                return new Promise(function(i) {
                    var a = e.w, s = t ? t.scale || t.width / a.globals.svgWidth : 1;
                    e.cleanup();
                    var r = document.createElement("canvas");
                    r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                    var o = "transparent" !== a.config.chart.background && a.config.chart.background ? a.config.chart.background : "#fff", n = r.getContext("2d");
                    n.fillStyle = o, n.fillRect(0, 0, r.width * s, r.height * s), e.getSvgString().then(function(t) {
                        var e = "data:image/svg+xml," + encodeURIComponent(t), a = new Image;
                        a.crossOrigin = "anonymous", a.onload = function() {
                            if (n.drawImage(a, 0, 0), r.msToBlob) {
                                var t = r.msToBlob();
                                i({
                                    blob: t
                                });
                            } else {
                                var e = r.toDataURL("image/png");
                                i({
                                    imgURI: e
                                });
                            }
                        }, a.src = e;
                    });
                });
            }
        },
        {
            key: "exportToSVG",
            value: function() {
                var t = this;
                this.svgUrl().then(function(e) {
                    t.triggerDownload(e, t.w.config.chart.toolbar.export.svg.filename, ".svg");
                });
            }
        },
        {
            key: "exportToPng",
            value: function() {
                var t = this, e = this.w.config.chart.toolbar.export.scale, i = this.w.config.chart.toolbar.export.width, a = e ? {
                    scale: e
                } : i ? {
                    width: i
                } : void 0;
                this.dataURI(a).then(function(e) {
                    var i = e.imgURI, a = e.blob;
                    a ? navigator.msSaveOrOpenBlob(a, t.w.globals.chartID + ".png") : t.triggerDownload(i, t.w.config.chart.toolbar.export.png.filename, ".png");
                });
            }
        },
        {
            key: "exportToCSV",
            value: function(t) {
                var e = this, i = t.series, a = t.fileName, s = t.columnDelimiter, r = void 0 === s ? "," : s, o = t.lineDelimiter, n = void 0 === o ? "\n" : o, l = this.w;
                i || (i = l.config.series);
                var h, c, d = [], g = [], u = "", f = l.globals.series.map(function(t, e) {
                    return -1 === l.globals.collapsedSeriesIndices.indexOf(e) ? t : [];
                }), x = function(t) {
                    return "function" == typeof l.config.chart.toolbar.export.csv.categoryFormatter ? l.config.chart.toolbar.export.csv.categoryFormatter(t) : "datetime" === l.config.xaxis.type && String(t).length >= 10 ? new Date(t).toDateString() : m.isNumber(t) ? t : t.split(r).join("");
                }, b = function(t) {
                    return "function" == typeof l.config.chart.toolbar.export.csv.valueFormatter ? l.config.chart.toolbar.export.csv.valueFormatter(t) : t;
                }, v = Math.max.apply(Math, p(i.map(function(t) {
                    return t.data ? t.data.length : 0;
                }))), y = new _(this.ctx), w = new M(this.ctx), k = function(t) {
                    var i = "";
                    if (l.globals.axisCharts) {
                        if ("category" === l.config.xaxis.type || l.config.xaxis.convertedCatToNumeric) {
                            if (l.globals.isBarHorizontal) {
                                var a = l.globals.yLabelFormatters[0], s = new V(e.ctx).getActiveConfigSeriesIndex();
                                i = a(l.globals.labels[t], {
                                    seriesIndex: s,
                                    dataPointIndex: t,
                                    w: l
                                });
                            } else i = w.getLabel(l.globals.labels, l.globals.timescaleLabels, 0, t).text;
                        }
                        "datetime" === l.config.xaxis.type && (l.config.xaxis.categories.length ? i = l.config.xaxis.categories[t] : l.config.labels.length && (i = l.config.labels[t]));
                    } else i = l.config.labels[t];
                    return null === i ? "nullvalue" : (Array.isArray(i) && (i = i.join(" ")), m.isNumber(i) ? i : i.split(r).join(""));
                }, A = function(t, e) {
                    if (d.length && 0 === e && g.push(d.join(r)), t.data) {
                        t.data = t.data.length && t.data || p(Array(v)).map(function() {
                            return "";
                        });
                        for(var a = 0; a < t.data.length; a++){
                            d = [];
                            var s = k(a);
                            if ("nullvalue" !== s) {
                                if (s || (y.isFormatXY() ? s = i[e].data[a].x : y.isFormat2DArray() && (s = i[e].data[a] ? i[e].data[a][0] : "")), 0 === e) {
                                    d.push(x(s));
                                    for(var o = 0; o < l.globals.series.length; o++){
                                        var n, h = y.isFormatXY() ? null === (n = i[o].data[a]) || void 0 === n ? void 0 : n.y : f[o][a];
                                        d.push(b(h));
                                    }
                                }
                                ("candlestick" === l.config.chart.type || t.type && "candlestick" === t.type) && (d.pop(), d.push(l.globals.seriesCandleO[e][a]), d.push(l.globals.seriesCandleH[e][a]), d.push(l.globals.seriesCandleL[e][a]), d.push(l.globals.seriesCandleC[e][a])), ("boxPlot" === l.config.chart.type || t.type && "boxPlot" === t.type) && (d.pop(), d.push(l.globals.seriesCandleO[e][a]), d.push(l.globals.seriesCandleH[e][a]), d.push(l.globals.seriesCandleM[e][a]), d.push(l.globals.seriesCandleL[e][a]), d.push(l.globals.seriesCandleC[e][a])), "rangeBar" === l.config.chart.type && (d.pop(), d.push(l.globals.seriesRangeStart[e][a]), d.push(l.globals.seriesRangeEnd[e][a])), d.length && g.push(d.join(r));
                            }
                        }
                    }
                };
                d.push(l.config.chart.toolbar.export.csv.headerCategory), "boxPlot" === l.config.chart.type ? (d.push("minimum"), d.push("q1"), d.push("median"), d.push("q3"), d.push("maximum")) : "candlestick" === l.config.chart.type ? (d.push("open"), d.push("high"), d.push("low"), d.push("close")) : "rangeBar" === l.config.chart.type ? (d.push("minimum"), d.push("maximum")) : i.map(function(t, e) {
                    var i = (t.name ? t.name : "series-".concat(e)) + "";
                    l.globals.axisCharts && d.push(i.split(r).join("") ? i.split(r).join("") : "series-".concat(e));
                }), l.globals.axisCharts || (d.push(l.config.chart.toolbar.export.csv.headerValue), g.push(d.join(r))), l.globals.allSeriesHasEqualX || !l.globals.axisCharts || l.config.xaxis.categories.length || l.config.labels.length ? i.map(function(t, e) {
                    l.globals.axisCharts ? A(t, e) : ((d = []).push(x(l.globals.labels[e])), d.push(b(f[e])), g.push(d.join(r)));
                }) : (h = new Set, c = {}, i.forEach(function(t, e) {
                    null == t || t.data.forEach(function(t) {
                        var a, s;
                        if (y.isFormatXY()) a = t.x, s = t.y;
                        else {
                            if (!y.isFormat2DArray()) return;
                            a = t[0], s = t[1];
                        }
                        c[a] || (c[a] = Array(i.length).fill("")), c[a][e] = b(s), h.add(a);
                    });
                }), d.length && g.push(d.join(r)), Array.from(h).sort().forEach(function(t) {
                    g.push([
                        x(t),
                        c[t].join(r)
                    ]);
                })), u += g.join(n), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\ufeff" + u), a || l.config.chart.toolbar.export.csv.filename, ".csv");
            }
        },
        {
            key: "triggerDownload",
            value: function(t, e, i) {
                var a = document.createElement("a");
                a.href = t, a.download = (e || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
            }
        }
    ]), t;
}(), q = function() {
    function t(e, a) {
        i(this, t), this.ctx = e, this.elgrid = a, this.w = e.w;
        var s = this.w;
        this.axesUtils = new M(e), this.xaxisLabels = s.globals.labels.slice(), s.globals.timescaleLabels.length > 0 && !s.globals.isBarHorizontal && (this.xaxisLabels = s.globals.timescaleLabels.slice()), s.config.xaxis.overwriteCategories && (this.xaxisLabels = s.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], "top" === s.config.xaxis.position ? this.offY = 0 : this.offY = s.globals.gridHeight, this.offY = this.offY + s.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.xaxisBorderWidth = s.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = s.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = s.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = s.config.xaxis.axisBorder.height, this.yaxis = s.config.yaxis[0];
    }
    return s(t, [
        {
            key: "drawXaxis",
            value: function() {
                var t = this.w, e = new k(this.ctx), i = e.group({
                    class: "apexcharts-xaxis",
                    transform: "translate(".concat(t.config.xaxis.offsetX, ", ").concat(t.config.xaxis.offsetY, ")")
                }), a = e.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")")
                });
                i.add(a);
                for(var s = [], r = 0; r < this.xaxisLabels.length; r++)s.push(this.xaxisLabels[r]);
                if (this.drawXAxisLabelAndGroup(!0, e, a, s, t.globals.isXNumeric, function(t, e) {
                    return e;
                }), t.globals.hasXaxisGroups) {
                    var o = t.globals.groups;
                    s = [];
                    for(var n = 0; n < o.length; n++)s.push(o[n].title);
                    var l = {};
                    t.config.xaxis.group.style && (l.xaxisFontSize = t.config.xaxis.group.style.fontSize, l.xaxisFontFamily = t.config.xaxis.group.style.fontFamily, l.xaxisForeColors = t.config.xaxis.group.style.colors, l.fontWeight = t.config.xaxis.group.style.fontWeight, l.cssClass = t.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, e, a, s, !1, function(t, e) {
                        return o[t].cols * e;
                    }, l);
                }
                if (void 0 !== t.config.xaxis.title.text) {
                    var h = e.group({
                        class: "apexcharts-xaxis-title"
                    }), c = e.drawText({
                        x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX,
                        y: this.offY + parseFloat(this.xaxisFontSize) + ("bottom" === t.config.xaxis.position ? t.globals.xAxisLabelsHeight : -t.globals.xAxisLabelsHeight - 10) + t.config.xaxis.title.offsetY,
                        text: t.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: t.config.xaxis.title.style.fontSize,
                        fontFamily: t.config.xaxis.title.style.fontFamily,
                        fontWeight: t.config.xaxis.title.style.fontWeight,
                        foreColor: t.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + t.config.xaxis.title.style.cssClass
                    });
                    h.add(c), i.add(h);
                }
                if (t.config.xaxis.axisBorder.show) {
                    var d = t.globals.barPadForNumericAxis, g = e.drawLine(t.globals.padHorizontal + t.config.xaxis.axisBorder.offsetX - d, this.offY, this.xaxisBorderWidth + d, this.offY, t.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                    this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(g) : i.add(g);
                }
                return i;
            }
        },
        {
            key: "drawXAxisLabelAndGroup",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : {}, h = [], c = [], d = this.w, g = l.xaxisFontSize || this.xaxisFontSize, u = l.xaxisFontFamily || this.xaxisFontFamily, f = l.xaxisForeColors || this.xaxisForeColors, p = l.fontWeight || d.config.xaxis.labels.style.fontWeight, x = l.cssClass || d.config.xaxis.labels.style.cssClass, b = d.globals.padHorizontal, v = a.length, m = "category" === d.config.xaxis.type ? d.globals.dataPoints : v;
                if (0 === m && v > m && (m = v), s) {
                    var y = m > 1 ? m - 1 : m;
                    o = d.globals.gridWidth / Math.min(y, v - 1), b = b + r(0, o) / 2 + d.config.xaxis.labels.offsetX;
                } else o = d.globals.gridWidth / m, b = b + r(0, o) + d.config.xaxis.labels.offsetX;
                for(var w = function(s) {
                    var l = b - r(s, o) / 2 + d.config.xaxis.labels.offsetX;
                    0 === s && 1 === v && o / 2 === b && 1 === m && (l = d.globals.gridWidth / 2);
                    var y = n.axesUtils.getLabel(a, d.globals.timescaleLabels, l, s, h, g, t), w = 28;
                    d.globals.rotateXLabels && t && (w = 22), d.config.xaxis.title.text && "top" === d.config.xaxis.position && (w += parseFloat(d.config.xaxis.title.style.fontSize) + 2), t || (w = w + parseFloat(g) + (d.globals.xAxisLabelsHeight - d.globals.xAxisGroupLabelsHeight) + (d.globals.rotateXLabels ? 10 : 0)), y = void 0 !== d.config.xaxis.tickAmount && "dataPoints" !== d.config.xaxis.tickAmount && "datetime" !== d.config.xaxis.type ? n.axesUtils.checkLabelBasedOnTickamount(s, y, v) : n.axesUtils.checkForOverflowingLabels(s, y, v, h, c);
                    if (d.config.xaxis.labels.show) {
                        var k = e.drawText({
                            x: y.x,
                            y: n.offY + d.config.xaxis.labels.offsetY + w - ("top" === d.config.xaxis.position ? d.globals.xAxisHeight + d.config.xaxis.axisTicks.height - 2 : 0),
                            text: y.text,
                            textAnchor: "middle",
                            fontWeight: y.isBold ? 600 : p,
                            fontSize: g,
                            fontFamily: u,
                            foreColor: Array.isArray(f) ? t && d.config.xaxis.convertedCatToNumeric ? f[d.globals.minX + s - 1] : f[s] : f,
                            isPlainText: !1,
                            cssClass: (t ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + x
                        });
                        if (i.add(k), k.on("click", function(t) {
                            if ("function" == typeof d.config.chart.events.xAxisLabelClick) {
                                var e = Object.assign({}, d, {
                                    labelIndex: s
                                });
                                d.config.chart.events.xAxisLabelClick(t, n.ctx, e);
                            }
                        }), t) {
                            var A = document.createElementNS(d.globals.SVGNS, "title");
                            A.textContent = Array.isArray(y.text) ? y.text.join(" ") : y.text, k.node.appendChild(A), "" !== y.text && (h.push(y.text), c.push(y));
                        }
                    }
                    s < v - 1 && (b += r(s + 1, o));
                }, k = 0; k <= v - 1; k++)w(k);
            }
        },
        {
            key: "drawXaxisInversed",
            value: function(t) {
                var e, i, a = this, s = this.w, r = new k(this.ctx), o = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[t] : 0, n = r.group({
                    class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                    rel: t
                }), l = r.group({
                    class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                    transform: "translate(" + o + ", 0)"
                });
                n.add(l);
                var h = [];
                if (s.config.yaxis[t].show) for(var c = 0; c < this.xaxisLabels.length; c++)h.push(this.xaxisLabels[c]);
                e = s.globals.gridHeight / h.length, i = -e / 2.2;
                var d = s.globals.yLabelFormatters[0], g = s.config.yaxis[0].labels;
                if (g.show) for(var u = function(o) {
                    var n = void 0 === h[o] ? "" : h[o];
                    n = d(n, {
                        seriesIndex: t,
                        dataPointIndex: o,
                        w: s
                    });
                    var c = a.axesUtils.getYAxisForeColor(g.style.colors, t), u = 0;
                    Array.isArray(n) && (u = n.length / 2 * parseInt(g.style.fontSize, 10));
                    var f = g.offsetX - 15, p = "end";
                    a.yaxis.opposite && (p = "start"), "left" === s.config.yaxis[0].labels.align ? (f = g.offsetX, p = "start") : "center" === s.config.yaxis[0].labels.align ? (f = g.offsetX, p = "middle") : "right" === s.config.yaxis[0].labels.align && (p = "end");
                    var x = r.drawText({
                        x: f,
                        y: i + e + g.offsetY - u,
                        text: n,
                        textAnchor: p,
                        foreColor: Array.isArray(c) ? c[o] : c,
                        fontSize: g.style.fontSize,
                        fontFamily: g.style.fontFamily,
                        fontWeight: g.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + g.style.cssClass,
                        maxWidth: g.maxWidth
                    });
                    l.add(x), x.on("click", function(t) {
                        if ("function" == typeof s.config.chart.events.xAxisLabelClick) {
                            var e = Object.assign({}, s, {
                                labelIndex: o
                            });
                            s.config.chart.events.xAxisLabelClick(t, a.ctx, e);
                        }
                    });
                    var b = document.createElementNS(s.globals.SVGNS, "title");
                    if (b.textContent = Array.isArray(n) ? n.join(" ") : n, x.node.appendChild(b), 0 !== s.config.yaxis[t].labels.rotate) {
                        var v = r.rotateAroundCenter(x.node);
                        x.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[t].labels.rotate, " 0 ").concat(v.y, ")"));
                    }
                    i += e;
                }, f = 0; f <= h.length - 1; f++)u(f);
                if (void 0 !== s.config.yaxis[0].title.text) {
                    var p = r.group({
                        class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                        transform: "translate(" + o + ", 0)"
                    }), x = r.drawText({
                        x: s.config.yaxis[0].title.offsetX,
                        y: s.globals.gridHeight / 2 + s.config.yaxis[0].title.offsetY,
                        text: s.config.yaxis[0].title.text,
                        textAnchor: "middle",
                        foreColor: s.config.yaxis[0].title.style.color,
                        fontSize: s.config.yaxis[0].title.style.fontSize,
                        fontWeight: s.config.yaxis[0].title.style.fontWeight,
                        fontFamily: s.config.yaxis[0].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                    });
                    p.add(x), n.add(p);
                }
                var b = 0;
                this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (b = s.globals.gridWidth);
                var v = s.config.xaxis.axisBorder;
                if (v.show) {
                    var m = r.drawLine(s.globals.padHorizontal + v.offsetX + b, 1 + v.offsetY, s.globals.padHorizontal + v.offsetX + b, s.globals.gridHeight + v.offsetY, v.color, 0);
                    this.elgrid && this.elgrid.elGridBorders && s.config.grid.show ? this.elgrid.elGridBorders.add(m) : n.add(m);
                }
                return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(b, h.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, e, n), n;
            }
        },
        {
            key: "drawXaxisTicks",
            value: function(t, e, i) {
                var a = this.w, s = t;
                if (!(t < 0 || t - 2 > a.globals.gridWidth)) {
                    var r = this.offY + a.config.xaxis.axisTicks.offsetY;
                    if (e = e + r + a.config.xaxis.axisTicks.height, "top" === a.config.xaxis.position && (e = r - a.config.xaxis.axisTicks.height), a.config.xaxis.axisTicks.show) {
                        var o = new k(this.ctx).drawLine(t + a.config.xaxis.axisTicks.offsetX, r + a.config.xaxis.offsetY, s + a.config.xaxis.axisTicks.offsetX, e + a.config.xaxis.offsetY, a.config.xaxis.axisTicks.color);
                        i.add(o), o.node.classList.add("apexcharts-xaxis-tick");
                    }
                }
            }
        },
        {
            key: "getXAxisTicksPositions",
            value: function() {
                var t = this.w, e = [], i = this.xaxisLabels.length, a = t.globals.padHorizontal;
                if (t.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, e.push(a);
                else for(var r = i, o = 0; o < r; o++){
                    var n = r;
                    t.globals.isXNumeric && "bar" !== t.config.chart.type && (n -= 1), a += t.globals.gridWidth / n, e.push(a);
                }
                return e;
            }
        },
        {
            key: "xAxisLabelCorrections",
            value: function() {
                var t = this.w, e = new k(this.ctx), i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                if (t.globals.rotateXLabels || t.config.xaxis.labels.rotateAlways) for(var o = 0; o < a.length; o++){
                    var n = e.rotateAroundCenter(a[o]);
                    n.y = n.y - 1, n.x = n.x + 1, a[o].setAttribute("transform", "rotate(".concat(t.config.xaxis.labels.rotate, " ").concat(n.x, " ").concat(n.y, ")")), a[o].setAttribute("text-anchor", "end");
                    i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                    var l = a[o].childNodes;
                    t.config.xaxis.labels.trim && Array.prototype.forEach.call(l, function(i) {
                        e.placeTextWithEllipsis(i, i.textContent, t.globals.xAxisLabelsHeight - ("bottom" === t.config.legend.position ? 20 : 10));
                    });
                }
                else !function() {
                    for(var i = t.globals.gridWidth / (t.globals.labels.length + 1), s = 0; s < a.length; s++){
                        var r = a[s].childNodes;
                        t.config.xaxis.labels.trim && "datetime" !== t.config.xaxis.type && Array.prototype.forEach.call(r, function(t) {
                            e.placeTextWithEllipsis(t, t.textContent, i);
                        });
                    }
                }();
                if (s.length > 0) {
                    var h = s[s.length - 1].getBBox(), c = s[0].getBBox();
                    h.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), c.x + c.width > t.globals.gridWidth && !t.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                    for(var d = 0; d < r.length; d++)e.placeTextWithEllipsis(r[d], r[d].textContent, t.config.yaxis[0].labels.maxWidth - (t.config.yaxis[0].title.text ? 2 * parseFloat(t.config.yaxis[0].title.style.fontSize) : 0) - 15);
                }
            }
        }
    ]), t;
}(), Z = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.xaxisLabels = a.globals.labels.slice(), this.axesUtils = new M(e), this.isRangeBar = a.globals.seriesRange.length && a.globals.isBarHorizontal, a.globals.timescaleLabels.length > 0 && (this.xaxisLabels = a.globals.timescaleLabels.slice());
    }
    return s(t, [
        {
            key: "drawGridArea",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w, i = new k(this.ctx);
                t || (t = i.group({
                    class: "apexcharts-grid"
                }));
                var a = i.drawLine(e.globals.padHorizontal, 1, e.globals.padHorizontal, e.globals.gridHeight, "transparent"), s = i.drawLine(e.globals.padHorizontal, e.globals.gridHeight, e.globals.gridWidth, e.globals.gridHeight, "transparent");
                return t.add(s), t.add(a), t;
            }
        },
        {
            key: "drawGrid",
            value: function() {
                if (this.w.globals.axisCharts) {
                    var t = this.renderGrid();
                    return this.drawGridArea(t.el), t;
                }
                return null;
            }
        },
        {
            key: "createGridMask",
            value: function() {
                var t = this.w, e = t.globals, i = new k(this.ctx), a = Array.isArray(t.config.stroke.width) ? Math.max.apply(Math, p(t.config.stroke.width)) : t.config.stroke.width, s = function(t) {
                    var i = document.createElementNS(e.SVGNS, "clipPath");
                    return i.setAttribute("id", t), i;
                };
                e.dom.elGridRectMask = s("gridRectMask".concat(e.cuid)), e.dom.elGridRectBarMask = s("gridRectBarMask".concat(e.cuid)), e.dom.elGridRectMarkerMask = s("gridRectMarkerMask".concat(e.cuid)), e.dom.elForecastMask = s("forecastMask".concat(e.cuid)), e.dom.elNonForecastMask = s("nonForecastMask".concat(e.cuid));
                var r = 0, o = 0;
                ([
                    "bar",
                    "rangeBar",
                    "candlestick",
                    "boxPlot"
                ].includes(t.config.chart.type) || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && (r = Math.max(t.config.grid.padding.left, e.barPadForNumericAxis), o = Math.max(t.config.grid.padding.right, e.barPadForNumericAxis)), e.dom.elGridRect = i.drawRect(0, 0, e.gridWidth, e.gridHeight, 0, "#fff"), e.dom.elGridRectBar = i.drawRect(-a / 2 - r - 2, -a / 2 - 2, e.gridWidth + a + o + r + 4, e.gridHeight + a + 4, 0, "#fff");
                var n = t.globals.markers.largestSize;
                e.dom.elGridRectMarker = i.drawRect(-n, -n, e.gridWidth + 2 * n, e.gridHeight + 2 * n, 0, "#fff"), e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node), e.dom.elGridRectBarMask.appendChild(e.dom.elGridRectBar.node), e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);
                var l = e.dom.baseEl.querySelector("defs");
                l.appendChild(e.dom.elGridRectMask), l.appendChild(e.dom.elGridRectBarMask), l.appendChild(e.dom.elGridRectMarkerMask), l.appendChild(e.dom.elForecastMask), l.appendChild(e.dom.elNonForecastMask);
            }
        },
        {
            key: "_drawGridLines",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w;
                if (!(0 === e && l.globals.skipFirstTimelinelabel || e === o - 1 && l.globals.skipLastTimelinelabel && !l.config.xaxis.labels.formatter || "radar" === l.config.chart.type)) {
                    l.config.grid.xaxis.lines.show && this._drawGridLine({
                        i: e,
                        x1: i,
                        y1: a,
                        x2: s,
                        y2: r,
                        xCount: o,
                        parent: n
                    });
                    var h = 0;
                    if (l.globals.hasXaxisGroups && "between" === l.config.xaxis.tickPlacement) {
                        var c = l.globals.groups;
                        if (c) {
                            for(var d = 0, g = 0; d < e && g < c.length; g++)d += c[g].cols;
                            d === e && (h = .6 * l.globals.xAxisLabelsHeight);
                        }
                    }
                    new q(this.ctx).drawXaxisTicks(i, h, l.globals.dom.elGraphical);
                }
            }
        },
        {
            key: "_drawGridLine",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w, h = n.node.classList.contains("apexcharts-gridlines-horizontal"), c = l.globals.barPadForNumericAxis, d = 0 === a && 0 === r || 0 === i && 0 === s || a === l.globals.gridHeight && r === l.globals.gridHeight || l.globals.isBarHorizontal && (0 === e || e === o - 1), g = new k(this).drawLine(i - (h ? c : 0), a, s + (h ? c : 0), r, l.config.grid.borderColor, l.config.grid.strokeDashArray);
                g.node.classList.add("apexcharts-gridline"), d && l.config.grid.show ? this.elGridBorders.add(g) : n.add(g);
            }
        },
        {
            key: "_drawGridBandRect",
            value: function(t) {
                var e = t.c, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.type, n = this.w, l = new k(this.ctx), h = n.globals.barPadForNumericAxis, c = n.config.grid[o].colors[e], d = l.drawRect(i - ("row" === o ? h : 0), a, s + ("row" === o ? 2 * h : 0), r, 0, c, n.config.grid[o].opacity);
                this.elg.add(d), d.attr("clip-path", "url(#gridRectMask".concat(n.globals.cuid, ")")), d.node.classList.add("apexcharts-grid-".concat(o));
            }
        },
        {
            key: "_drawXYLines",
            value: function(t) {
                var e = this, i = t.xCount, a = t.tickAmount, s = this.w;
                if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                    var r, o = s.globals.padHorizontal, n = s.globals.gridHeight;
                    s.globals.timescaleLabels.length ? function(t) {
                        for(var a = t.xC, s = t.x1, r = t.y1, o = t.x2, n = t.y2, l = 0; l < a; l++)s = e.xaxisLabels[l].position, o = e.xaxisLabels[l].position, e._drawGridLines({
                            i: l,
                            x1: s,
                            y1: r,
                            x2: o,
                            y2: n,
                            xCount: i,
                            parent: e.elgridLinesV
                        });
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), function(t) {
                        for(var a = t.xC, r = t.x1, o = t.y1, n = t.x2, l = t.y2, h = 0; h < a + (s.globals.isXNumeric ? 0 : 1); h++)0 === h && 1 === a && 1 === s.globals.dataPoints && (n = r = s.globals.gridWidth / 2), e._drawGridLines({
                            i: h,
                            x1: r,
                            y1: o,
                            x2: n,
                            y2: l,
                            xCount: i,
                            parent: e.elgridLinesV
                        }), n = r += s.globals.gridWidth / (s.globals.isXNumeric ? a - 1 : a);
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }));
                }
                if (s.config.grid.yaxis.lines.show) {
                    var l = 0, h = 0, c = s.globals.gridWidth, d = a + 1;
                    this.isRangeBar && (d = s.globals.labels.length);
                    for(var g = 0; g < d + (this.isRangeBar ? 1 : 0); g++)this._drawGridLine({
                        i: g,
                        xCount: d + (this.isRangeBar ? 1 : 0),
                        x1: 0,
                        y1: l,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = l += s.globals.gridHeight / (this.isRangeBar ? d : a);
                }
            }
        },
        {
            key: "_drawInvertedXYLines",
            value: function(t) {
                var e = t.xCount, i = this.w;
                if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, o = 0; o < e + 1; o++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                    i: o,
                    xCount: e + 1,
                    x1: s,
                    y1: 0,
                    x2: a,
                    y2: r,
                    parent: this.elgridLinesV
                }), new q(this.ctx).drawXaxisTicks(s, 0, i.globals.dom.elGraphical), a = s += i.globals.gridWidth / e;
                if (i.config.grid.yaxis.lines.show) for(var n = 0, l = 0, h = i.globals.gridWidth, c = 0; c < i.globals.dataPoints + 1; c++)this._drawGridLine({
                    i: c,
                    xCount: i.globals.dataPoints + 1,
                    x1: 0,
                    y1: n,
                    x2: h,
                    y2: l,
                    parent: this.elgridLinesH
                }), l = n += i.globals.gridHeight / i.globals.dataPoints;
            }
        },
        {
            key: "renderGrid",
            value: function() {
                var t = this.w, e = t.globals, i = new k(this.ctx);
                this.elg = i.group({
                    class: "apexcharts-grid"
                }), this.elgridLinesH = i.group({
                    class: "apexcharts-gridlines-horizontal"
                }), this.elgridLinesV = i.group({
                    class: "apexcharts-gridlines-vertical"
                }), this.elGridBorders = i.group({
                    class: "apexcharts-grid-borders"
                }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), t.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
                for(var a = 0; a < e.seriesYAxisMap.length && e.ignoreYAxisIndexes.includes(a);)a++;
                a === e.seriesYAxisMap.length && (a = 0);
                var s, r = e.yAxisScale[a].result.length - 1;
                if (!e.isBarHorizontal || this.isRangeBar) {
                    var o, n, l;
                    if (s = this.xaxisLabels.length, this.isRangeBar) r = e.labels.length, t.config.xaxis.tickAmount && t.config.xaxis.labels.formatter && (s = t.config.xaxis.tickAmount), (null === (o = e.yAxisScale) || void 0 === o || null === (n = o[a]) || void 0 === n || null === (l = n.result) || void 0 === l ? void 0 : l.length) > 0 && "datetime" !== t.config.xaxis.type && (s = e.yAxisScale[a].result.length - 1);
                    this._drawXYLines({
                        xCount: s,
                        tickAmount: r
                    });
                } else s = r, r = e.xTickAmount, this._drawInvertedXYLines({
                    xCount: s,
                    tickAmount: r
                });
                return this.drawGridBands(s, r), {
                    el: this.elg,
                    elGridBorders: this.elGridBorders,
                    xAxisTickWidth: e.gridWidth / s
                };
            }
        },
        {
            key: "drawGridBands",
            value: function(t, e) {
                var i, a, s = this, r = this.w;
                if ((null === (i = r.config.grid.row.colors) || void 0 === i ? void 0 : i.length) > 0 && function(t, i, a, o, n, l) {
                    for(var h = 0, c = 0; h < i; h++, c++)c >= r.config.grid[t].colors.length && (c = 0), s._drawGridBandRect({
                        c: c,
                        x1: a,
                        y1: o,
                        x2: n,
                        y2: l,
                        type: t
                    }), o += r.globals.gridHeight / e;
                }("row", e, 0, 0, r.globals.gridWidth, r.globals.gridHeight / e), (null === (a = r.config.grid.column.colors) || void 0 === a ? void 0 : a.length) > 0) {
                    var o = r.globals.isBarHorizontal || "on" !== r.config.xaxis.tickPlacement || "category" !== r.config.xaxis.type && !r.config.xaxis.convertedCatToNumeric ? t : t - 1;
                    r.globals.isXNumeric && (o = r.globals.xAxisScale.result.length - 1);
                    for(var n = r.globals.padHorizontal, l = r.globals.padHorizontal + r.globals.gridWidth / o, h = r.globals.gridHeight, c = 0, d = 0; c < t; c++, d++){
                        var g;
                        if (d >= r.config.grid.column.colors.length && (d = 0), "datetime" === r.config.xaxis.type) n = this.xaxisLabels[c].position, l = ((null === (g = this.xaxisLabels[c + 1]) || void 0 === g ? void 0 : g.position) || r.globals.gridWidth) - this.xaxisLabels[c].position;
                        this._drawGridBandRect({
                            c: d,
                            x1: n,
                            y1: 0,
                            x2: l,
                            y2: h,
                            type: "column"
                        }), n += r.globals.gridWidth / o;
                    }
                }
            }
        }
    ]), t;
}(), $ = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.coreUtils = new A(this.ctx);
    }
    return s(t, [
        {
            key: "niceScale",
            value: function(t, e) {
                var i, a, s, r, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, n = 1e-11, l = this.w, h = l.globals;
                h.isBarHorizontal ? (i = l.config.xaxis, a = Math.max((h.svgWidth - 100) / 25, 2)) : (i = l.config.yaxis[o], a = Math.max((h.svgHeight - 100) / 15, 2)), m.isNumber(a) || (a = 10), s = void 0 !== i.min && null !== i.min, r = void 0 !== i.max && null !== i.min;
                var c = void 0 !== i.stepSize && null !== i.stepSize, d = void 0 !== i.tickAmount && null !== i.tickAmount, g = d ? i.tickAmount : h.niceScaleDefaultTicks[Math.min(Math.round(a / 2), h.niceScaleDefaultTicks.length - 1)];
                if (h.isMultipleYAxis && !d && h.multiAxisTickAmount > 0 && (g = h.multiAxisTickAmount, d = !0), g = "dataPoints" === g ? h.dataPoints - 1 : Math.abs(Math.round(g)), (t === Number.MIN_VALUE && 0 === e || !m.isNumber(t) && !m.isNumber(e) || t === Number.MIN_VALUE && e === -Number.MAX_VALUE) && (t = m.isNumber(i.min) ? i.min : 0, e = m.isNumber(i.max) ? i.max : t + g, h.allSeriesCollapsed = !1), t > e) {
                    console.warn("axis.min cannot be greater than axis.max: swapping min and max");
                    var u = e;
                    e = t, t = u;
                } else t === e && (t = 0 === t ? 0 : t - 1, e = 0 === e ? 2 : e + 1);
                var f = [];
                g < 1 && (g = 1);
                var p = g, x = Math.abs(e - t);
                !s && t > 0 && t / x < .15 && (t = 0, s = !0), !r && e < 0 && -e / x < .15 && (e = 0, r = !0);
                var b = (x = Math.abs(e - t)) / p, v = b, y = Math.floor(Math.log10(v)), w = Math.pow(10, y), k = Math.ceil(v / w);
                if (b = v = (k = h.niceScaleAllowedMagMsd[0 === h.yValueDecimal ? 0 : 1][k]) * w, h.isBarHorizontal && i.stepSize && "datetime" !== i.type ? (b = i.stepSize, c = !0) : c && (b = i.stepSize), c && i.forceNiceScale) {
                    var A = Math.floor(Math.log10(b));
                    b *= Math.pow(10, y - A);
                }
                if (s && r) {
                    var S = x / p;
                    if (d) {
                        if (c) {
                            if (0 != m.mod(x, b)) {
                                var C = m.getGCD(b, S);
                                b = S / C < 10 ? C : S;
                            } else 0 == m.mod(b, S) ? b = S : (S = b, d = !1);
                        } else b = S;
                    } else if (c) 0 == m.mod(x, b) ? S = b : b = S;
                    else if (0 == m.mod(x, b)) S = b;
                    else {
                        S = x / (p = Math.ceil(x / b));
                        var L = m.getGCD(x, b);
                        x / L < a && (S = L), b = S;
                    }
                    p = Math.round(x / b);
                } else {
                    if (s || r) {
                        if (r) {
                            if (d) t = e - b * p;
                            else {
                                var P = t;
                                t = b * Math.floor(t / b), Math.abs(e - t) / m.getGCD(x, b) > a && (t = e - b * g, t += b * Math.floor((P - t) / b));
                            }
                        } else if (s) {
                            if (d) e = t + b * p;
                            else {
                                var M = e;
                                e = b * Math.ceil(e / b), Math.abs(e - t) / m.getGCD(x, b) > a && (e = t + b * g, e += b * Math.ceil((M - e) / b));
                            }
                        }
                    } else if (h.isMultipleYAxis && d) {
                        var I = b * Math.floor(t / b), T = I + b * p;
                        T < e && (b *= 2), T = e, e = (t = I) + b * p, x = Math.abs(e - t), t > 0 && t < Math.abs(T - e) && (t = 0, e = b * p), e < 0 && -e < Math.abs(I - t) && (e = 0, t = -b * p);
                    } else t = b * Math.floor(t / b), e = b * Math.ceil(e / b);
                    x = Math.abs(e - t), b = m.getGCD(x, b), p = Math.round(x / b);
                }
                if (d || s || r || (p = Math.ceil((x - n) / (b + n))) > 16 && m.getPrimeFactors(p).length < 2 && p++, !d && i.forceNiceScale && 0 === h.yValueDecimal && p > x && (p = x, b = Math.round(x / p)), p > a && (!d && !c || i.forceNiceScale)) {
                    var z = m.getPrimeFactors(p), X = z.length - 1, E = p;
                    t: for(var Y = 0; Y < X; Y++)for(var R = 0; R <= X - Y; R++){
                        for(var F = Math.min(R + Y, X), D = E, H = 1, O = R; O <= F; O++)H *= z[O];
                        if ((D /= H) < a) {
                            E = D;
                            break t;
                        }
                    }
                    b = E === p ? x : x / E, p = Math.round(x / b);
                }
                h.isMultipleYAxis && 0 == h.multiAxisTickAmount && h.ignoreYAxisIndexes.indexOf(o) < 0 && (h.multiAxisTickAmount = p);
                var N = t - b, W = b * n;
                do N += b, f.push(m.stripNumber(N, 7));
                while (e - N > W);
                return {
                    result: f,
                    niceMin: f[0],
                    niceMax: f[f.length - 1]
                };
            }
        },
        {
            key: "linearScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : void 0, r = Math.abs(e - t), o = [];
                if (t === e) return {
                    result: o = [
                        t
                    ],
                    niceMin: o[0],
                    niceMax: o[o.length - 1]
                };
                "dataPoints" === (i = this._adjustTicksForSmallRange(i, a, r)) && (i = this.w.globals.dataPoints - 1), s || (s = r / i), s = Math.round(10 * (s + Number.EPSILON)) / 10, i === Number.MAX_VALUE && (i = 5, s = 1);
                for(var n = t; i >= 0;)o.push(n), n = m.preciseAddition(n, s), i -= 1;
                return {
                    result: o,
                    niceMin: o[0],
                    niceMax: o[o.length - 1]
                };
            }
        },
        {
            key: "logarithmicScaleNice",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.ceil(Math.log(e) / Math.log(i) + 1), r = Math.floor(Math.log(t) / Math.log(i)); r < s; r++)a.push(Math.pow(i, r));
                return {
                    result: a,
                    niceMin: a[0],
                    niceMax: a[a.length - 1]
                };
            }
        },
        {
            key: "logarithmicScale",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.log(e) / Math.log(i), r = Math.log(t) / Math.log(i), o = s - r, n = Math.round(o), l = o / n, h = 0, c = r; h < n; h++, c += l)a.push(Math.pow(i, c));
                return a.push(Math.pow(i, s)), {
                    result: a,
                    niceMin: t,
                    niceMax: e
                };
            }
        },
        {
            key: "_adjustTicksForSmallRange",
            value: function(t, e, i) {
                var a = t;
                if (void 0 !== e && this.w.config.yaxis[e].labels.formatter && void 0 === this.w.config.yaxis[e].tickAmount) {
                    var s = Number(this.w.config.yaxis[e].labels.formatter(1));
                    m.isNumber(s) && 0 === this.w.globals.yValueDecimal && (a = Math.ceil(i));
                }
                return a < t ? a : t;
            }
        },
        {
            key: "setYScaleForIndex",
            value: function(t, e, i) {
                var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[t];
                void 0 === a.yAxisScale[t] && (a.yAxisScale[t] = []);
                var o = Math.abs(i - e);
                r.logarithmic && o <= 5 && (a.invalidLogScale = !0), r.logarithmic && o > 5 ? (a.allSeriesCollapsed = !1, a.yAxisScale[t] = r.forceNiceScale ? this.logarithmicScaleNice(e, i, r.logBase) : this.logarithmicScale(e, i, r.logBase)) : i !== -Number.MAX_VALUE && m.isNumber(i) && e !== Number.MAX_VALUE && m.isNumber(e) ? (a.allSeriesCollapsed = !1, a.yAxisScale[t] = this.niceScale(e, i, t)) : a.yAxisScale[t] = this.niceScale(Number.MIN_VALUE, 0, t);
            }
        },
        {
            key: "setXScale",
            value: function(t, e) {
                var i = this.w, a = i.globals, s = Math.abs(e - t);
                if (e !== -Number.MAX_VALUE && m.isNumber(e)) {
                    var r = a.xTickAmount + 1;
                    s < 10 && s > 1 && (r = s), a.xAxisScale = this.linearScale(t, e, r, 0, i.config.xaxis.stepSize);
                } else a.xAxisScale = this.linearScale(0, 10, 10);
                return a.xAxisScale;
            }
        },
        {
            key: "scaleMultipleYAxes",
            value: function() {
                var t = this, e = this.w.config, i = this.w.globals;
                this.coreUtils.setSeriesYAxisMappings();
                var a = i.seriesYAxisMap, s = i.minYArr, r = i.maxYArr;
                i.allSeriesCollapsed = !0, i.barGroups = [], a.forEach(function(a, o) {
                    var n = [];
                    a.forEach(function(t) {
                        var i = e.series[t].group;
                        n.indexOf(i) < 0 && n.push(i);
                    }), a.length > 0 ? function() {
                        var l, h, c = Number.MAX_VALUE, d = -Number.MAX_VALUE, g = c, u = d;
                        if (e.chart.stacked) !function() {
                            var t = new Array(i.dataPoints).fill(0), s = [], r = [], f = [];
                            n.forEach(function() {
                                s.push(t.map(function() {
                                    return Number.MIN_VALUE;
                                })), r.push(t.map(function() {
                                    return Number.MIN_VALUE;
                                })), f.push(t.map(function() {
                                    return Number.MIN_VALUE;
                                }));
                            });
                            for(var p = function(t) {
                                !l && e.series[a[t]].type && (l = e.series[a[t]].type);
                                var c = a[t];
                                h = e.series[c].group ? e.series[c].group : "axis-".concat(o), !(i.collapsedSeriesIndices.indexOf(c) < 0 && i.ancillaryCollapsedSeriesIndices.indexOf(c) < 0) || (i.allSeriesCollapsed = !1, n.forEach(function(t, a) {
                                    if (e.series[c].group === t) for(var o = 0; o < i.series[c].length; o++){
                                        var n = i.series[c][o];
                                        n >= 0 ? r[a][o] += n : f[a][o] += n, s[a][o] += n, g = Math.min(g, n), u = Math.max(u, n);
                                    }
                                })), "bar" !== l && "column" !== l || i.barGroups.push(h);
                            }, x = 0; x < a.length; x++)p(x);
                            l || (l = e.chart.type), "bar" === l || "column" === l ? n.forEach(function(t, e) {
                                c = Math.min(c, Math.min.apply(null, f[e])), d = Math.max(d, Math.max.apply(null, r[e]));
                            }) : (n.forEach(function(t, e) {
                                g = Math.min(g, Math.min.apply(null, s[e])), u = Math.max(u, Math.max.apply(null, s[e]));
                            }), c = g, d = u), c === Number.MIN_VALUE && d === Number.MIN_VALUE && (d = -Number.MAX_VALUE);
                        }();
                        else for(var f = 0; f < a.length; f++){
                            var p = a[f];
                            c = Math.min(c, s[p]), d = Math.max(d, r[p]), !(i.collapsedSeriesIndices.indexOf(p) < 0 && i.ancillaryCollapsedSeriesIndices.indexOf(p) < 0) || (i.allSeriesCollapsed = !1);
                        }
                        void 0 !== e.yaxis[o].min && (c = "function" == typeof e.yaxis[o].min ? e.yaxis[o].min(c) : e.yaxis[o].min), void 0 !== e.yaxis[o].max && (d = "function" == typeof e.yaxis[o].max ? e.yaxis[o].max(d) : e.yaxis[o].max), i.barGroups = i.barGroups.filter(function(t, e, i) {
                            return i.indexOf(t) === e;
                        }), t.setYScaleForIndex(o, c, d), a.forEach(function(t) {
                            s[t] = i.yAxisScale[o].niceMin, r[t] = i.yAxisScale[o].niceMax;
                        });
                    }() : t.setYScaleForIndex(o, 0, -Number.MAX_VALUE);
                });
            }
        }
    ]), t;
}(), J = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.scales = new $(e);
    }
    return s(t, [
        {
            key: "init",
            value: function() {
                this.setYRange(), this.setXRange(), this.setZRange();
            }
        },
        {
            key: "getMinYMaxY",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w.config, r = this.w.globals, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                null === a && (a = t + 1);
                var l = r.series, h = l, c = l;
                "candlestick" === s.chart.type ? (h = r.seriesCandleL, c = r.seriesCandleH) : "boxPlot" === s.chart.type ? (h = r.seriesCandleO, c = r.seriesCandleC) : r.isRangeData && (h = r.seriesRangeStart, c = r.seriesRangeEnd);
                var d = !1;
                if (r.seriesX.length >= a) {
                    var g, u = null === (g = r.brushSource) || void 0 === g ? void 0 : g.w.config.chart.brush;
                    (s.chart.zoom.enabled && s.chart.zoom.autoScaleYaxis || null != u && u.enabled && null != u && u.autoScaleYaxis) && (d = !0);
                }
                for(var f = t; f < a; f++){
                    r.dataPoints = Math.max(r.dataPoints, l[f].length);
                    var p = s.series[f].type;
                    r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(t) {
                        return void 0 !== t;
                    }).length), r.labels.length && "datetime" !== s.xaxis.type && 0 !== r.series.reduce(function(t, e) {
                        return t + e.length;
                    }, 0) && (r.dataPoints = Math.max(r.dataPoints, r.labels.length));
                    var x = 0, b = l[f].length - 1;
                    if (d) {
                        if (s.xaxis.min) for(; x < b && r.seriesX[f][x] < s.xaxis.min; x++);
                        if (s.xaxis.max) for(; b > x && r.seriesX[f][b] > s.xaxis.max; b--);
                    }
                    for(var v = x; v <= b && v < r.series[f].length; v++){
                        var y = l[f][v];
                        if (null !== y && m.isNumber(y)) {
                            switch(void 0 !== c[f][v] && (o = Math.max(o, c[f][v]), e = Math.min(e, c[f][v])), void 0 !== h[f][v] && (e = Math.min(e, h[f][v]), i = Math.max(i, h[f][v])), p){
                                case "candlestick":
                                    void 0 !== r.seriesCandleC[f][v] && (o = Math.max(o, r.seriesCandleH[f][v]), e = Math.min(e, r.seriesCandleL[f][v]));
                                    break;
                                case "boxPlot":
                                    void 0 !== r.seriesCandleC[f][v] && (o = Math.max(o, r.seriesCandleC[f][v]), e = Math.min(e, r.seriesCandleO[f][v]));
                            }
                            p && "candlestick" !== p && "boxPlot" !== p && "rangeArea" !== p && "rangeBar" !== p && (o = Math.max(o, r.series[f][v]), e = Math.min(e, r.series[f][v])), i = o, r.seriesGoals[f] && r.seriesGoals[f][v] && Array.isArray(r.seriesGoals[f][v]) && r.seriesGoals[f][v].forEach(function(t) {
                                n !== Number.MIN_VALUE && (n = Math.min(n, t.value), e = n), o = Math.max(o, t.value), i = o;
                            }), m.isFloat(y) && (y = m.noExponents(y), r.yValueDecimal = Math.max(r.yValueDecimal, y.toString().split(".")[1].length)), n > h[f][v] && h[f][v] < 0 && (n = h[f][v]);
                        } else r.hasNullValues = !0;
                    }
                    "bar" !== p && "column" !== p || (n < 0 && o < 0 && (o = 0, i = Math.max(i, 0)), n === Number.MIN_VALUE && (n = 0, e = Math.min(e, 0)));
                }
                return "rangeBar" === s.chart.type && r.seriesRangeStart.length && r.isBarHorizontal && (n = e), "bar" === s.chart.type && (n < 0 && o < 0 && (o = 0), n === Number.MIN_VALUE && (n = 0)), {
                    minY: n,
                    maxY: o,
                    lowestY: e,
                    highestY: i
                };
            }
        },
        {
            key: "setYRange",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE;
                var i, a = Number.MAX_VALUE;
                if (t.isMultipleYAxis) {
                    a = Number.MAX_VALUE;
                    for(var s = 0; s < t.series.length; s++)i = this.getMinYMaxY(s), t.minYArr[s] = i.lowestY, t.maxYArr[s] = i.highestY, a = Math.min(a, i.lowestY);
                }
                if (i = this.getMinYMaxY(0, a, null, t.series.length), "bar" === e.chart.type ? (t.minY = i.minY, t.maxY = i.maxY) : (t.minY = i.lowestY, t.maxY = i.highestY), a = i.lowestY, e.chart.stacked && this._setStackedMinMax(), "line" === e.chart.type || "area" === e.chart.type || "scatter" === e.chart.type || "candlestick" === e.chart.type || "boxPlot" === e.chart.type || "rangeBar" === e.chart.type && !t.isBarHorizontal ? t.minY === Number.MIN_VALUE && a !== -Number.MAX_VALUE && a !== t.maxY && (t.minY = a) : t.minY = t.minY !== Number.MIN_VALUE ? Math.min(i.minY, t.minY) : i.minY, e.yaxis.forEach(function(e, i) {
                    void 0 !== e.max && ("number" == typeof e.max ? t.maxYArr[i] = e.max : "function" == typeof e.max && (t.maxYArr[i] = e.max(t.isMultipleYAxis ? t.maxYArr[i] : t.maxY)), t.maxY = t.maxYArr[i]), void 0 !== e.min && ("number" == typeof e.min ? t.minYArr[i] = e.min : "function" == typeof e.min && (t.minYArr[i] = e.min(t.isMultipleYAxis ? t.minYArr[i] === Number.MIN_VALUE ? 0 : t.minYArr[i] : t.minY)), t.minY = t.minYArr[i]);
                }), t.isBarHorizontal) [
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== e.xaxis[i] && "number" == typeof e.xaxis[i] && ("min" === i ? t.minY = e.xaxis[i] : t.maxY = e.xaxis[i]);
                });
                return t.isMultipleYAxis ? (this.scales.scaleMultipleYAxes(), t.minY = a) : (this.scales.setYScaleForIndex(0, t.minY, t.maxY), t.minY = t.yAxisScale[0].niceMin, t.maxY = t.yAxisScale[0].niceMax, t.minYArr[0] = t.minY, t.maxYArr[0] = t.maxY), t.barGroups = [], t.lineGroups = [], t.areaGroups = [], e.series.forEach(function(i) {
                    switch(i.type || e.chart.type){
                        case "bar":
                        case "column":
                            t.barGroups.push(i.group);
                            break;
                        case "line":
                            t.lineGroups.push(i.group);
                            break;
                        case "area":
                            t.areaGroups.push(i.group);
                    }
                }), t.barGroups = t.barGroups.filter(function(t, e, i) {
                    return i.indexOf(t) === e;
                }), t.lineGroups = t.lineGroups.filter(function(t, e, i) {
                    return i.indexOf(t) === e;
                }), t.areaGroups = t.areaGroups.filter(function(t, e, i) {
                    return i.indexOf(t) === e;
                }), {
                    minY: t.minY,
                    maxY: t.maxY,
                    minYArr: t.minYArr,
                    maxYArr: t.maxYArr,
                    yAxisScale: t.yAxisScale
                };
            }
        },
        {
            key: "setXRange",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = "numeric" === e.xaxis.type || "datetime" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided || t.noLabelsProvided || t.isXNumeric;
                if (t.isXNumeric && function() {
                    for(var e = 0; e < t.series.length; e++)if (t.labels[e]) for(var i = 0; i < t.labels[e].length; i++)null !== t.labels[e][i] && m.isNumber(t.labels[e][i]) && (t.maxX = Math.max(t.maxX, t.labels[e][i]), t.initialMaxX = Math.max(t.maxX, t.labels[e][i]), t.minX = Math.min(t.minX, t.labels[e][i]), t.initialMinX = Math.min(t.minX, t.labels[e][i]));
                }(), t.noLabelsProvided && 0 === e.xaxis.categories.length && (t.maxX = t.labels[t.labels.length - 1], t.initialMaxX = t.labels[t.labels.length - 1], t.minX = 1, t.initialMinX = 1), t.isXNumeric || t.noLabelsProvided || t.dataFormatXNumeric) {
                    var a = 10;
                    if (void 0 === e.xaxis.tickAmount) a = Math.round(t.svgWidth / 150), "numeric" === e.xaxis.type && t.dataPoints < 30 && (a = t.dataPoints - 1), a > t.dataPoints && 0 !== t.dataPoints && (a = t.dataPoints - 1);
                    else if ("dataPoints" === e.xaxis.tickAmount) {
                        if (t.series.length > 1 && (a = t.series[t.maxValsInArrayIndex].length - 1), t.isXNumeric) {
                            var s = t.maxX - t.minX;
                            s < 30 && (a = s - 1);
                        }
                    } else a = e.xaxis.tickAmount;
                    if (t.xTickAmount = a, void 0 !== e.xaxis.max && "number" == typeof e.xaxis.max && (t.maxX = e.xaxis.max), void 0 !== e.xaxis.min && "number" == typeof e.xaxis.min && (t.minX = e.xaxis.min), void 0 !== e.xaxis.range && (t.minX = t.maxX - e.xaxis.range), t.minX !== Number.MAX_VALUE && t.maxX !== -Number.MAX_VALUE) {
                        if (e.xaxis.convertedCatToNumeric && !t.dataFormatXNumeric) {
                            for(var r = [], o = t.minX - 1; o < t.maxX; o++)r.push(o + 1);
                            t.xAxisScale = {
                                result: r,
                                niceMin: r[0],
                                niceMax: r[r.length - 1]
                            };
                        } else t.xAxisScale = this.scales.setXScale(t.minX, t.maxX);
                    } else t.xAxisScale = this.scales.linearScale(0, a, a, 0, e.xaxis.stepSize), t.noLabelsProvided && t.labels.length > 0 && (t.xAxisScale = this.scales.linearScale(1, t.labels.length, a - 1, 0, e.xaxis.stepSize), t.seriesX = t.labels.slice());
                    i && (t.labels = t.xAxisScale.result.slice());
                }
                return t.isBarHorizontal && t.labels.length && (t.xTickAmount = t.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                    minX: t.minX,
                    maxX: t.maxX
                };
            }
        },
        {
            key: "setZRange",
            value: function() {
                var t = this.w.globals;
                if (t.isDataXYZ) {
                    for(var e = 0; e < t.series.length; e++)if (void 0 !== t.seriesZ[e]) for(var i = 0; i < t.seriesZ[e].length; i++)null !== t.seriesZ[e][i] && m.isNumber(t.seriesZ[e][i]) && (t.maxZ = Math.max(t.maxZ, t.seriesZ[e][i]), t.minZ = Math.min(t.minZ, t.seriesZ[e][i]));
                }
            }
        },
        {
            key: "_handleSingleDataPoint",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                if (t.minX === t.maxX) {
                    var i = new L(this.ctx);
                    if ("datetime" === e.xaxis.type) {
                        var a = i.getDate(t.minX);
                        e.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), t.minX = new Date(a).getTime();
                        var s = i.getDate(t.maxX);
                        e.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), t.maxX = new Date(s).getTime();
                    } else ("numeric" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided) && (t.minX = t.minX - 2, t.initialMinX = t.minX, t.maxX = t.maxX + 2, t.initialMaxX = t.maxX);
                }
            }
        },
        {
            key: "_getMinXDiff",
            value: function() {
                var t = this.w.globals;
                t.isXNumeric && t.seriesX.forEach(function(e, i) {
                    1 === e.length && e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length - 1]);
                    var a = e.slice();
                    a.sort(function(t, e) {
                        return t - e;
                    }), a.forEach(function(e, i) {
                        if (i > 0) {
                            var s = e - a[i - 1];
                            s > 0 && (t.minXDiff = Math.min(s, t.minXDiff));
                        }
                    }), 1 !== t.dataPoints && t.minXDiff !== Number.MAX_VALUE || (t.minXDiff = .5);
                });
            }
        },
        {
            key: "_setStackedMinMax",
            value: function() {
                var t = this, e = this.w.globals;
                if (e.series.length) {
                    var i = e.seriesGroups;
                    i.length || (i = [
                        this.w.globals.seriesNames.map(function(t) {
                            return t;
                        })
                    ]);
                    var a = {}, s = {};
                    i.forEach(function(i) {
                        a[i] = [], s[i] = [], t.w.config.series.map(function(t, a) {
                            return i.indexOf(e.seriesNames[a]) > -1 ? a : null;
                        }).filter(function(t) {
                            return null !== t;
                        }).forEach(function(r) {
                            for(var o = 0; o < e.series[e.maxValsInArrayIndex].length; o++){
                                var n, l, h, c;
                                void 0 === a[i][o] && (a[i][o] = 0, s[i][o] = 0), (t.w.config.chart.stacked && !e.comboCharts || t.w.config.chart.stacked && e.comboCharts && (!t.w.config.chart.stackOnlyBar || "bar" === (null === (n = t.w.config.series) || void 0 === n || null === (l = n[r]) || void 0 === l ? void 0 : l.type) || "column" === (null === (h = t.w.config.series) || void 0 === h || null === (c = h[r]) || void 0 === c ? void 0 : c.type))) && null !== e.series[r][o] && m.isNumber(e.series[r][o]) && (e.series[r][o] > 0 ? a[i][o] += parseFloat(e.series[r][o]) + 1e-4 : s[i][o] += parseFloat(e.series[r][o]));
                            }
                        });
                    }), Object.entries(a).forEach(function(t) {
                        var i = f(t, 1)[0];
                        a[i].forEach(function(t, r) {
                            e.maxY = Math.max(e.maxY, a[i][r]), e.minY = Math.min(e.minY, s[i][r]);
                        });
                    });
                }
            }
        }
    ]), t;
}(), Q = function() {
    function t(e, a) {
        i(this, t), this.ctx = e, this.elgrid = a, this.w = e.w;
        var s = this.w;
        this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.axisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xAxisoffX = "bottom" === s.config.xaxis.position ? s.globals.gridHeight : 0, this.drawnLabels = [], this.axesUtils = new M(e);
    }
    return s(t, [
        {
            key: "drawYaxis",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = e.config.yaxis[t].labels.style, s = a.fontSize, r = a.fontFamily, o = a.fontWeight, n = i.group({
                    class: "apexcharts-yaxis",
                    rel: t,
                    transform: "translate(".concat(e.globals.translateYAxisX[t], ", 0)")
                });
                if (this.axesUtils.isYAxisHidden(t)) return n;
                var l = i.group({
                    class: "apexcharts-yaxis-texts-g"
                });
                n.add(l);
                var h = e.globals.yAxisScale[t].result.length - 1, c = e.globals.gridHeight / h, d = e.globals.yLabelFormatters[t], g = this.axesUtils.checkForReversedLabels(t, e.globals.yAxisScale[t].result.slice());
                if (e.config.yaxis[t].labels.show) {
                    var u = e.globals.translateY + e.config.yaxis[t].labels.offsetY;
                    e.globals.isBarHorizontal ? u = 0 : "heatmap" === e.config.chart.type && (u -= c / 2), u += parseInt(s, 10) / 3;
                    for(var f = h; f >= 0; f--){
                        var p = d(g[f], f, e), x = e.config.yaxis[t].labels.padding;
                        e.config.yaxis[t].opposite && 0 !== e.config.yaxis.length && (x *= -1);
                        var b = this.getTextAnchor(e.config.yaxis[t].labels.align, e.config.yaxis[t].opposite), v = this.axesUtils.getYAxisForeColor(a.colors, t), y = Array.isArray(v) ? v[f] : v, w = m.listToArray(e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-label tspan"))).map(function(t) {
                            return t.textContent;
                        }), A = i.drawText({
                            x: x,
                            y: u,
                            text: w.includes(p) && !e.config.yaxis[t].labels.showDuplicates ? "" : p,
                            textAnchor: b,
                            fontSize: s,
                            fontFamily: r,
                            fontWeight: o,
                            maxWidth: e.config.yaxis[t].labels.maxWidth,
                            foreColor: y,
                            isPlainText: !1,
                            cssClass: "apexcharts-yaxis-label ".concat(a.cssClass)
                        });
                        l.add(A), this.addTooltip(A, p), 0 !== e.config.yaxis[t].labels.rotate && this.rotateLabel(i, A, firstLabel, e.config.yaxis[t].labels.rotate), u += c;
                    }
                }
                return this.addYAxisTitle(i, n, t), this.addAxisBorder(i, n, t, h, c), n;
            }
        },
        {
            key: "getTextAnchor",
            value: function(t, e) {
                return "left" === t ? "start" : "center" === t ? "middle" : "right" === t ? "end" : e ? "start" : "end";
            }
        },
        {
            key: "addTooltip",
            value: function(t, e) {
                var i = document.createElementNS(this.w.globals.SVGNS, "title");
                i.textContent = Array.isArray(e) ? e.join(" ") : e, t.node.appendChild(i);
            }
        },
        {
            key: "rotateLabel",
            value: function(t, e, i, a) {
                var s = t.rotateAroundCenter(i.node), r = t.rotateAroundCenter(e.node);
                e.node.setAttribute("transform", "rotate(".concat(a, " ").concat(s.x, " ").concat(r.y, ")"));
            }
        },
        {
            key: "addYAxisTitle",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.config.yaxis[i].title.text) {
                    var s = t.group({
                        class: "apexcharts-yaxis-title"
                    }), r = a.config.yaxis[i].opposite ? a.globals.translateYAxisX[i] : 0, o = t.drawText({
                        x: r,
                        y: a.globals.gridHeight / 2 + a.globals.translateY + a.config.yaxis[i].title.offsetY,
                        text: a.config.yaxis[i].title.text,
                        textAnchor: "end",
                        foreColor: a.config.yaxis[i].title.style.color,
                        fontSize: a.config.yaxis[i].title.style.fontSize,
                        fontWeight: a.config.yaxis[i].title.style.fontWeight,
                        fontFamily: a.config.yaxis[i].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text ".concat(a.config.yaxis[i].title.style.cssClass)
                    });
                    s.add(o), e.add(s);
                }
            }
        },
        {
            key: "addAxisBorder",
            value: function(t, e, i, a, s) {
                var r = this.w, o = r.config.yaxis[i].axisBorder, n = 31 + o.offsetX;
                if (r.config.yaxis[i].opposite && (n = -31 - o.offsetX), o.show) {
                    var l = t.drawLine(n, r.globals.translateY + o.offsetY - 2, n, r.globals.gridHeight + r.globals.translateY + o.offsetY + 2, o.color, 0, o.width);
                    e.add(l);
                }
                r.config.yaxis[i].axisTicks.show && this.axesUtils.drawYAxisTicks(n, a, o, r.config.yaxis[i].axisTicks, i, s, e);
            }
        },
        {
            key: "drawYaxisInversed",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = i.group({
                    class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                }), s = i.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                });
                a.add(s);
                var r = e.globals.yAxisScale[t].result.length - 1, o = e.globals.gridWidth / r + .1, n = o + e.config.xaxis.labels.offsetX, l = e.globals.xLabelFormatter, h = this.axesUtils.checkForReversedLabels(t, e.globals.yAxisScale[t].result.slice()), c = e.globals.timescaleLabels;
                if (c.length > 0 && (this.xaxisLabels = c.slice(), r = (h = c.slice()).length), e.config.xaxis.labels.show) for(var d = c.length ? 0 : r; c.length ? d < c.length : d >= 0; c.length ? d++ : d--){
                    var g = l(h[d], d, e), u = e.globals.gridWidth + e.globals.padHorizontal - (n - o + e.config.xaxis.labels.offsetX);
                    if (c.length) {
                        var f = this.axesUtils.getLabel(h, c, u, d, this.drawnLabels, this.xaxisFontSize);
                        u = f.x, g = f.text, this.drawnLabels.push(f.text), 0 === d && e.globals.skipFirstTimelinelabel && (g = ""), d === h.length - 1 && e.globals.skipLastTimelinelabel && (g = "");
                    }
                    var p = i.drawText({
                        x: u,
                        y: this.xAxisoffX + e.config.xaxis.labels.offsetY + 30 - ("top" === e.config.xaxis.position ? e.globals.xAxisHeight + e.config.xaxis.axisTicks.height - 2 : 0),
                        text: g,
                        textAnchor: "middle",
                        foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[t] : this.xaxisForeColors,
                        fontSize: this.xaxisFontSize,
                        fontFamily: this.xaxisFontFamily,
                        fontWeight: e.config.xaxis.labels.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-xaxis-label ".concat(e.config.xaxis.labels.style.cssClass)
                    });
                    s.add(p), p.tspan(g), this.addTooltip(p, g), n += o;
                }
                return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
            }
        },
        {
            key: "inversedYAxisBorder",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = e.config.xaxis.axisBorder;
                if (a.show) {
                    var s = 0;
                    "bar" === e.config.chart.type && e.globals.isXNumeric && (s -= 15);
                    var r = i.drawLine(e.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, e.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                    this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(r) : t.add(r);
                }
            }
        },
        {
            key: "inversedYAxisTitleText",
            value: function(t) {
                var e = this.w, i = new k(this.ctx);
                if (void 0 !== e.config.xaxis.title.text) {
                    var a = i.group({
                        class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                    }), s = i.drawText({
                        x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                        y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(e.config.xaxis.title.style.fontSize) + e.config.xaxis.title.offsetY + 20,
                        text: e.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: e.config.xaxis.title.style.fontSize,
                        fontFamily: e.config.xaxis.title.style.fontFamily,
                        fontWeight: e.config.xaxis.title.style.fontWeight,
                        foreColor: e.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text ".concat(e.config.xaxis.title.style.cssClass)
                    });
                    a.add(s), t.add(a);
                }
            }
        },
        {
            key: "yAxisTitleRotate",
            value: function(t, e) {
                var i = this.w, a = new k(this.ctx), s = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-texts-g")), r = s ? s.getBoundingClientRect() : {
                    width: 0,
                    height: 0
                }, o = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-title text")), n = o ? o.getBoundingClientRect() : {
                    width: 0,
                    height: 0
                };
                if (o) {
                    var l = this.xPaddingForYAxisTitle(t, r, n, e);
                    o.setAttribute("x", l.xPos - (e ? 10 : 0));
                    var h = a.rotateAroundCenter(o);
                    o.setAttribute("transform", "rotate(".concat(e ? -1 * i.config.yaxis[t].title.rotate : i.config.yaxis[t].title.rotate, " ").concat(h.x, " ").concat(h.y, ")"));
                }
            }
        },
        {
            key: "xPaddingForYAxisTitle",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = 10;
                return void 0 === s.config.yaxis[t].title.text || t < 0 ? {
                    xPos: r,
                    padd: 0
                } : (a ? r = e.width + s.config.yaxis[t].title.offsetX + i.width / 2 + o / 2 : (r = -1 * e.width + s.config.yaxis[t].title.offsetX + o / 2 + i.width / 2, s.globals.isBarHorizontal && (o = 25, r = -1 * e.width - s.config.yaxis[t].title.offsetX - o)), {
                    xPos: r,
                    padd: o
                });
            }
        },
        {
            key: "setYAxisXPosition",
            value: function(t, e) {
                var i = this.w, a = 0, s = 0, r = 18, o = 1;
                i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.forEach(function(n, l) {
                    var h = i.globals.ignoreYAxisIndexes.includes(l) || !n.show || n.floating || 0 === t[l].width, c = t[l].width + e[l].width;
                    n.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[l] = s - n.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + o, h || (o += c + 20), i.globals.translateYAxisX[l] = s - n.labels.offsetX + 20) : (a = i.globals.translateX - r, h || (r += c + 20), i.globals.translateYAxisX[l] = a + n.labels.offsetX);
                });
            }
        },
        {
            key: "setYAxisTextAlignments",
            value: function() {
                var t = this.w;
                m.listToArray(t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis")).forEach(function(e, i) {
                    var a = t.config.yaxis[i];
                    if (a && !a.floating && void 0 !== a.labels.align) {
                        var s = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-texts-g")), r = m.listToArray(t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-label"))), o = s.getBoundingClientRect();
                        r.forEach(function(t) {
                            t.setAttribute("text-anchor", a.labels.align);
                        }), "left" !== a.labels.align || a.opposite ? "center" === a.labels.align ? s.setAttribute("transform", "translate(".concat(o.width / 2 * (a.opposite ? 1 : -1), ", 0)")) : "right" === a.labels.align && a.opposite && s.setAttribute("transform", "translate(".concat(o.width, ", 0)")) : s.setAttribute("transform", "translate(-".concat(o.width, ", 0)"));
                    }
                });
            }
        }
    ]), t;
}(), K = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.documentEvent = m.bind(this.documentEvent, this);
    }
    return s(t, [
        {
            key: "addEventListener",
            value: function(t, e) {
                var i = this.w;
                i.globals.events.hasOwnProperty(t) ? i.globals.events[t].push(e) : i.globals.events[t] = [
                    e
                ];
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    var a = i.globals.events[t].indexOf(e);
                    -1 !== a && i.globals.events[t].splice(a, 1);
                }
            }
        },
        {
            key: "fireEvent",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    e && e.length || (e = []);
                    for(var a = i.globals.events[t], s = a.length, r = 0; r < s; r++)a[r].apply(null, e);
                }
            }
        },
        {
            key: "setupEventHandlers",
            value: function() {
                var t = this, e = this.w, i = this.ctx, a = e.globals.dom.baseEl.querySelector(e.globals.chartClass);
                this.ctx.eventList.forEach(function(t) {
                    a.addEventListener(t, function(t) {
                        var a = Object.assign({}, e, {
                            seriesIndex: e.globals.axisCharts ? e.globals.capturedSeriesIndex : 0,
                            dataPointIndex: e.globals.capturedDataPointIndex
                        });
                        "mousemove" === t.type || "touchmove" === t.type ? "function" == typeof e.config.chart.events.mouseMove && e.config.chart.events.mouseMove(t, i, a) : "mouseleave" === t.type || "touchleave" === t.type ? "function" == typeof e.config.chart.events.mouseLeave && e.config.chart.events.mouseLeave(t, i, a) : ("mouseup" === t.type && 1 === t.which || "touchend" === t.type) && ("function" == typeof e.config.chart.events.click && e.config.chart.events.click(t, i, a), i.ctx.events.fireEvent("click", [
                            t,
                            i,
                            a
                        ]));
                    }, {
                        capture: !1,
                        passive: !0
                    });
                }), this.ctx.eventList.forEach(function(i) {
                    e.globals.dom.baseEl.addEventListener(i, t.documentEvent, {
                        passive: !0
                    });
                }), this.ctx.core.setupBrushHandler();
            }
        },
        {
            key: "documentEvent",
            value: function(t) {
                var e = this.w, i = t.target.className;
                if ("click" === t.type) {
                    var a = e.globals.dom.baseEl.querySelector(".apexcharts-menu");
                    a && a.classList.contains("apexcharts-menu-open") && "apexcharts-menu-icon" !== i && a.classList.remove("apexcharts-menu-open");
                }
                e.globals.clientX = "touchmove" === t.type ? t.touches[0].clientX : t.clientX, e.globals.clientY = "touchmove" === t.type ? t.touches[0].clientY : t.clientY;
            }
        }
    ]), t;
}(), tt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "setCurrentLocaleValues",
            value: function(t) {
                var e = this.w.config.chart.locales;
                window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (e = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                var i = e.filter(function(e) {
                    return e.name === t;
                })[0];
                if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                var a = m.extend(z, i);
                this.w.globals.locale = a.options;
            }
        }
    ]), t;
}(), et = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "drawAxis",
            value: function(t, e) {
                var i, a, s = this, r = this.w.globals, o = this.w.config, n = new q(this.ctx, e), l = new Q(this.ctx, e);
                r.axisCharts && "radar" !== t && (r.isBarHorizontal ? (a = l.drawYaxisInversed(0), i = n.drawXaxisInversed(0), r.dom.elGraphical.add(i), r.dom.elGraphical.add(a)) : (i = n.drawXaxis(), r.dom.elGraphical.add(i), o.yaxis.map(function(t, e) {
                    if (-1 === r.ignoreYAxisIndexes.indexOf(e) && (a = l.drawYaxis(e), r.dom.Paper.add(a), "back" === s.w.config.grid.position)) {
                        var i = r.dom.Paper.children()[1];
                        i.remove(), r.dom.Paper.add(i);
                    }
                })));
            }
        }
    ]), t;
}(), it = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "drawXCrosshairs",
            value: function() {
                var t = this.w, e = new k(this.ctx), i = new w(this.ctx), a = t.config.xaxis.crosshairs.fill.gradient, s = t.config.xaxis.crosshairs.dropShadow, r = t.config.xaxis.crosshairs.fill.type, o = a.colorFrom, n = a.colorTo, l = a.opacityFrom, h = a.opacityTo, c = a.stops, d = s.enabled, g = s.left, u = s.top, f = s.blur, p = s.color, x = s.opacity, b = t.config.xaxis.crosshairs.fill.color;
                if (t.config.xaxis.crosshairs.show) {
                    "gradient" === r && (b = e.drawGradient("vertical", o, n, l, h, null, c, null));
                    var v = e.drawRect();
                    1 === t.config.xaxis.crosshairs.width && (v = e.drawLine());
                    var y = t.globals.gridHeight;
                    (!m.isNumber(y) || y < 0) && (y = 0);
                    var A = t.config.xaxis.crosshairs.width;
                    (!m.isNumber(A) || A < 0) && (A = 0), v.attr({
                        class: "apexcharts-xcrosshairs",
                        x: 0,
                        y: 0,
                        y2: y,
                        width: A,
                        height: y,
                        fill: b,
                        filter: "none",
                        "fill-opacity": t.config.xaxis.crosshairs.opacity,
                        stroke: t.config.xaxis.crosshairs.stroke.color,
                        "stroke-width": t.config.xaxis.crosshairs.stroke.width,
                        "stroke-dasharray": t.config.xaxis.crosshairs.stroke.dashArray
                    }), d && (v = i.dropShadow(v, {
                        left: g,
                        top: u,
                        blur: f,
                        color: p,
                        opacity: x
                    })), t.globals.dom.elGraphical.add(v);
                }
            }
        },
        {
            key: "drawYCrosshairs",
            value: function() {
                var t = this.w, e = new k(this.ctx), i = t.config.yaxis[0].crosshairs, a = t.globals.barPadForNumericAxis;
                if (t.config.yaxis[0].crosshairs.show) {
                    var s = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                    s.attr({
                        class: "apexcharts-ycrosshairs"
                    }), t.globals.dom.elGraphical.add(s);
                }
                var r = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                r.attr({
                    class: "apexcharts-ycrosshairs-hidden"
                }), t.globals.dom.elGraphical.add(r);
            }
        }
    ]), t;
}(), at = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "checkResponsiveConfig",
            value: function(t) {
                var e = this, i = this.w, a = i.config;
                if (0 !== a.responsive.length) {
                    var s = a.responsive.slice();
                    s.sort(function(t, e) {
                        return t.breakpoint > e.breakpoint ? 1 : e.breakpoint > t.breakpoint ? -1 : 0;
                    }).reverse();
                    var r = new D({}), o = function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = s[0].breakpoint, o = window.innerWidth > 0 ? window.innerWidth : screen.width;
                        if (o > a) {
                            var n = m.clone(i.globals.initialConfig);
                            n.series = m.clone(i.config.series);
                            var l = A.extendArrayProps(r, n, i);
                            t = m.extend(l, t), t = m.extend(i.config, t), e.overrideResponsiveOptions(t);
                        } else for(var h = 0; h < s.length; h++)o < s[h].breakpoint && (t = A.extendArrayProps(r, s[h].options, i), t = m.extend(i.config, t), e.overrideResponsiveOptions(t));
                    };
                    if (t) {
                        var n = A.extendArrayProps(r, t, i);
                        n = m.extend(i.config, n), o(n = m.extend(n, t));
                    } else o({});
                }
            }
        },
        {
            key: "overrideResponsiveOptions",
            value: function(t) {
                var e = new D(t).init({
                    responsiveOverride: !0
                });
                this.w.config = e;
            }
        }
    ]), t;
}(), st = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.colors = [], this.isColorFn = !1, this.isHeatmapDistributed = this.checkHeatmapDistributed(), this.isBarDistributed = this.checkBarDistributed();
    }
    return s(t, [
        {
            key: "checkHeatmapDistributed",
            value: function() {
                var t = this.w.config, e = t.chart, i = t.plotOptions;
                return "treemap" === e.type && i.treemap && i.treemap.distributed || "heatmap" === e.type && i.heatmap && i.heatmap.distributed;
            }
        },
        {
            key: "checkBarDistributed",
            value: function() {
                var t = this.w.config, e = t.chart, i = t.plotOptions;
                return i.bar && i.bar.distributed && ("bar" === e.type || "rangeBar" === e.type);
            }
        },
        {
            key: "init",
            value: function() {
                this.setDefaultColors();
            }
        },
        {
            key: "setDefaultColors",
            value: function() {
                var t = this.w, e = new m;
                t.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(t.config.theme.mode));
                var i = p(t.config.colors || t.config.fill.colors || []);
                t.globals.colors = this.getColors(i), this.applySeriesColors(t.globals.seriesColors, t.globals.colors), t.config.theme.monochrome.enabled && (t.globals.colors = this.getMonochromeColors(t.config.theme.monochrome, t.globals.series, e));
                var a = t.globals.colors.slice();
                this.pushExtraColors(t.globals.colors), this.applyColorTypes([
                    "fill",
                    "stroke"
                ], a), this.applyDataLabelsColors(a), this.applyRadarPolygonsColors(), this.applyMarkersColors(a);
            }
        },
        {
            key: "getColors",
            value: function(t) {
                var e = this, i = this.w;
                return t && 0 !== t.length ? Array.isArray(t) && t.length > 0 && "function" == typeof t[0] ? (this.isColorFn = !0, i.config.series.map(function(a, s) {
                    var r = t[s] || t[0];
                    return "function" == typeof r ? r({
                        value: i.globals.axisCharts ? i.globals.series[s][0] || 0 : i.globals.series[s],
                        seriesIndex: s,
                        dataPointIndex: s,
                        w: e.w
                    }) : r;
                })) : t : this.predefined();
            }
        },
        {
            key: "applySeriesColors",
            value: function(t, e) {
                t.forEach(function(t, i) {
                    t && (e[i] = t);
                });
            }
        },
        {
            key: "getMonochromeColors",
            value: function(t, e, i) {
                var a = t.color, s = t.shadeIntensity, r = t.shadeTo, o = this.isBarDistributed || this.isHeatmapDistributed ? e[0].length * e.length : e.length, n = 1 / (o / s), l = 0;
                return Array.from({
                    length: o
                }, function() {
                    var t = "dark" === r ? i.shadeColor(-1 * l, a) : i.shadeColor(l, a);
                    return l += n, t;
                });
            }
        },
        {
            key: "applyColorTypes",
            value: function(t, e) {
                var i = this, a = this.w;
                t.forEach(function(t) {
                    a.globals[t].colors = void 0 === a.config[t].colors ? i.isColorFn ? a.config.colors : e : a.config[t].colors.slice(), i.pushExtraColors(a.globals[t].colors);
                });
            }
        },
        {
            key: "applyDataLabelsColors",
            value: function(t) {
                var e = this.w;
                e.globals.dataLabels.style.colors = void 0 === e.config.dataLabels.style.colors ? t : e.config.dataLabels.style.colors.slice(), this.pushExtraColors(e.globals.dataLabels.style.colors, 50);
            }
        },
        {
            key: "applyRadarPolygonsColors",
            value: function() {
                var t = this.w;
                t.globals.radarPolygons.fill.colors = void 0 === t.config.plotOptions.radar.polygons.fill.colors ? [
                    "dark" === t.config.theme.mode ? "#424242" : "none"
                ] : t.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(t.globals.radarPolygons.fill.colors, 20);
            }
        },
        {
            key: "applyMarkersColors",
            value: function(t) {
                var e = this.w;
                e.globals.markers.colors = void 0 === e.config.markers.colors ? t : e.config.markers.colors.slice(), this.pushExtraColors(e.globals.markers.colors);
            }
        },
        {
            key: "pushExtraColors",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = e || a.globals.series.length;
                if (null === i && (i = this.isBarDistributed || this.isHeatmapDistributed || "heatmap" === a.config.chart.type && a.config.plotOptions.heatmap && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), t.length < s) for(var r = s - t.length, o = 0; o < r; o++)t.push(t[o]);
            }
        },
        {
            key: "updateThemeOptions",
            value: function(t) {
                t.chart = t.chart || {}, t.tooltip = t.tooltip || {};
                var e = t.theme.mode, i = "dark" === e ? "palette4" : "light" === e ? "palette1" : t.theme.palette || "palette1", a = "dark" === e ? "#f6f7f8" : "light" === e ? "#373d3f" : t.chart.foreColor || "#373d3f";
                return t.tooltip.theme = e || "light", t.chart.foreColor = a, t.theme.palette = i, t;
            }
        },
        {
            key: "predefined",
            value: function() {
                var t = {
                    palette1: [
                        "#008FFB",
                        "#00E396",
                        "#FEB019",
                        "#FF4560",
                        "#775DD0"
                    ],
                    palette2: [
                        "#3f51b5",
                        "#03a9f4",
                        "#4caf50",
                        "#f9ce1d",
                        "#FF9800"
                    ],
                    palette3: [
                        "#33b2df",
                        "#546E7A",
                        "#d4526e",
                        "#13d8aa",
                        "#A5978B"
                    ],
                    palette4: [
                        "#4ecdc4",
                        "#c7f464",
                        "#81D4FA",
                        "#fd6a6a",
                        "#546E7A"
                    ],
                    palette5: [
                        "#2b908f",
                        "#f9a3a4",
                        "#90ee7e",
                        "#fa4443",
                        "#69d2e7"
                    ],
                    palette6: [
                        "#449DD1",
                        "#F86624",
                        "#EA3546",
                        "#662E9B",
                        "#C5D86D"
                    ],
                    palette7: [
                        "#D7263D",
                        "#1B998B",
                        "#2E294E",
                        "#F46036",
                        "#E2C044"
                    ],
                    palette8: [
                        "#662E9B",
                        "#F86624",
                        "#F9C80E",
                        "#EA3546",
                        "#43BCCD"
                    ],
                    palette9: [
                        "#5C4742",
                        "#A5978B",
                        "#8D5B4C",
                        "#5A2A27",
                        "#C4BBAF"
                    ],
                    palette10: [
                        "#A300D6",
                        "#7D02EB",
                        "#5653FE",
                        "#2983FF",
                        "#00B1F2"
                    ],
                    default: [
                        "#008FFB",
                        "#00E396",
                        "#FEB019",
                        "#FF4560",
                        "#775DD0"
                    ]
                };
                return t[this.w.config.theme.palette] || t.default;
            }
        }
    ]), t;
}(), rt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "draw",
            value: function() {
                this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
            }
        },
        {
            key: "drawTitleSubtitle",
            value: function(t) {
                var e = this.w, i = "title" === t ? e.config.title : e.config.subtitle, a = e.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                if ("left" === i.align ? (a = 10, r = "start") : "right" === i.align && (a = e.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, void 0 !== i.text) {
                    var o = new k(this.ctx).drawText({
                        x: a,
                        y: s,
                        text: i.text,
                        textAnchor: r,
                        fontSize: i.style.fontSize,
                        fontFamily: i.style.fontFamily,
                        fontWeight: i.style.fontWeight,
                        foreColor: i.style.color,
                        opacity: 1
                    });
                    o.node.setAttribute("class", "apexcharts-".concat(t, "-text")), e.globals.dom.Paper.add(o);
                }
            }
        }
    ]), t;
}(), ot = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.dCtx = e;
    }
    return s(t, [
        {
            key: "getTitleSubtitleCoords",
            value: function(t) {
                var e = this.w, i = 0, a = 0, s = "title" === t ? e.config.title.floating : e.config.subtitle.floating, r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t, "-text"));
                if (null !== r && !s) {
                    var o = r.getBoundingClientRect();
                    i = o.width, a = e.globals.axisCharts ? o.height + 5 : o.height;
                }
                return {
                    width: i,
                    height: a
                };
            }
        },
        {
            key: "getLegendsRect",
            value: function() {
                var t = this.w, e = t.globals.dom.elLegendWrap;
                t.config.legend.height || "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || (e.style.maxHeight = t.globals.svgHeight / 2 + "px");
                var i = Object.assign({}, m.getBoundingClientRect(e));
                return null !== e && !t.config.legend.floating && t.config.legend.show ? this.dCtx.lgRect = {
                    x: i.x,
                    y: i.y,
                    height: i.height,
                    width: 0 === i.height ? 0 : i.width
                } : this.dCtx.lgRect = {
                    x: 0,
                    y: 0,
                    height: 0,
                    width: 0
                }, "left" !== t.config.legend.position && "right" !== t.config.legend.position || 1.5 * this.dCtx.lgRect.width > t.globals.svgWidth && (this.dCtx.lgRect.width = t.globals.svgWidth / 1.5), this.dCtx.lgRect;
            }
        },
        {
            key: "getDatalabelsRect",
            value: function() {
                var t = this, e = this.w, i = [];
                e.config.series.forEach(function(s, r) {
                    s.data.forEach(function(s, o) {
                        var n;
                        n = e.globals.series[r][o], a = e.config.dataLabels.formatter(n, {
                            ctx: t.dCtx.ctx,
                            seriesIndex: r,
                            dataPointIndex: o,
                            w: e
                        }), i.push(a);
                    });
                });
                var a = m.getLargestStringFromArr(i), s = new k(this.dCtx.ctx), r = e.config.dataLabels.style, o = s.getTextRects(a, parseInt(r.fontSize), r.fontFamily);
                return {
                    width: 1.05 * o.width,
                    height: o.height
                };
            }
        },
        {
            key: "getLargestStringFromMultiArr",
            value: function(t, e) {
                var i = t;
                if (this.w.globals.isMultiLineX) {
                    var a = e.map(function(t, e) {
                        return Array.isArray(t) ? t.length : 1;
                    }), s = Math.max.apply(Math, p(a));
                    i = e[a.indexOf(s)];
                }
                return i;
            }
        }
    ]), t;
}(), nt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.dCtx = e;
    }
    return s(t, [
        {
            key: "getxAxisLabelsCoords",
            value: function() {
                var t, e = this.w, i = e.globals.labels.slice();
                if (e.config.xaxis.convertedCatToNumeric && 0 === i.length && (i = e.globals.categoryLabels), e.globals.timescaleLabels.length > 0) {
                    var a = this.getxAxisTimeScaleLabelsCoords();
                    t = {
                        width: a.width,
                        height: a.height
                    }, e.globals.rotateXLabels = !1;
                } else {
                    this.dCtx.lgWidthForSideLegends = "left" !== e.config.legend.position && "right" !== e.config.legend.position || e.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                    var s = e.globals.xLabelFormatter, r = m.getLargestStringFromArr(i), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                    e.globals.isBarHorizontal && (o = r = e.globals.yAxisScale[0].result.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0));
                    var n = new P(this.dCtx.ctx), l = r;
                    r = n.xLabelFormat(s, r, l, {
                        i: void 0,
                        dateFormatter: new L(this.dCtx.ctx).formatDate,
                        w: e
                    }), o = n.xLabelFormat(s, o, l, {
                        i: void 0,
                        dateFormatter: new L(this.dCtx.ctx).formatDate,
                        w: e
                    }), (e.config.xaxis.convertedCatToNumeric && void 0 === r || "" === String(r).trim()) && (o = r = "1");
                    var h = new k(this.dCtx.ctx), c = h.getTextRects(r, e.config.xaxis.labels.style.fontSize), d = c;
                    if (r !== o && (d = h.getTextRects(o, e.config.xaxis.labels.style.fontSize)), (t = {
                        width: c.width >= d.width ? c.width : d.width,
                        height: c.height >= d.height ? c.height : d.height
                    }).width * i.length > e.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && 0 !== e.config.xaxis.labels.rotate || e.config.xaxis.labels.rotateAlways) {
                        if (!e.globals.isBarHorizontal) {
                            e.globals.rotateXLabels = !0;
                            var g = function(t) {
                                return h.getTextRects(t, e.config.xaxis.labels.style.fontSize, e.config.xaxis.labels.style.fontFamily, "rotate(".concat(e.config.xaxis.labels.rotate, " 0 0)"), !1);
                            };
                            c = g(r), r !== o && (d = g(o)), t.height = (c.height > d.height ? c.height : d.height) / 1.5, t.width = c.width > d.width ? c.width : d.width;
                        }
                    } else e.globals.rotateXLabels = !1;
                }
                return e.config.xaxis.labels.show || (t = {
                    width: 0,
                    height: 0
                }), {
                    width: t.width,
                    height: t.height
                };
            }
        },
        {
            key: "getxAxisGroupLabelsCoords",
            value: function() {
                var t, e = this.w;
                if (!e.globals.hasXaxisGroups) return {
                    width: 0,
                    height: 0
                };
                var i, a = (null === (t = e.config.xaxis.group.style) || void 0 === t ? void 0 : t.fontSize) || e.config.xaxis.labels.style.fontSize, s = e.globals.groups.map(function(t) {
                    return t.title;
                }), r = m.getLargestStringFromArr(s), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, s), n = new k(this.dCtx.ctx), l = n.getTextRects(r, a), h = l;
                return r !== o && (h = n.getTextRects(o, a)), i = {
                    width: l.width >= h.width ? l.width : h.width,
                    height: l.height >= h.height ? l.height : h.height
                }, e.config.xaxis.labels.show || (i = {
                    width: 0,
                    height: 0
                }), {
                    width: i.width,
                    height: i.height
                };
            }
        },
        {
            key: "getxAxisTitleCoords",
            value: function() {
                var t = this.w, e = 0, i = 0;
                if (void 0 !== t.config.xaxis.title.text) {
                    var a = new k(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text, t.config.xaxis.title.style.fontSize);
                    e = a.width, i = a.height;
                }
                return {
                    width: e,
                    height: i
                };
            }
        },
        {
            key: "getxAxisTimeScaleLabelsCoords",
            value: function() {
                var t, e = this.w;
                this.dCtx.timescaleLabels = e.globals.timescaleLabels.slice();
                var i = this.dCtx.timescaleLabels.map(function(t) {
                    return t.value;
                }), a = i.reduce(function(t, e) {
                    return void 0 === t ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : t.length > e.length ? t : e;
                }, 0);
                return 1.05 * (t = new k(this.dCtx.ctx).getTextRects(a, e.config.xaxis.labels.style.fontSize)).width * i.length > e.globals.gridWidth && 0 !== e.config.xaxis.labels.rotate && (e.globals.overlappingXLabels = !0), t;
            }
        },
        {
            key: "additionalPaddingXLabels",
            value: function(t) {
                var e = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, o = t.width;
                a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                var n = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, l = function(t, n) {
                    s.yaxis.length > 1 && function(t) {
                        return -1 !== a.collapsedSeriesIndices.indexOf(t);
                    }(n) || function(t) {
                        if (e.dCtx.timescaleLabels && e.dCtx.timescaleLabels.length) {
                            var n = e.dCtx.timescaleLabels[0], l = e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length - 1].position + o / 1.75 - e.dCtx.yAxisWidthRight, h = n.position - o / 1.75 + e.dCtx.yAxisWidthLeft, c = "right" === i.config.legend.position && e.dCtx.lgRect.width > 0 ? e.dCtx.lgRect.width : 0;
                            l > a.svgWidth - a.translateX - c && (a.skipLastTimelinelabel = !0), h < -(t.show && !t.floating || "bar" !== s.chart.type && "candlestick" !== s.chart.type && "rangeBar" !== s.chart.type && "boxPlot" !== s.chart.type ? 10 : o / 1.75) && (a.skipFirstTimelinelabel = !0);
                        } else "datetime" === r ? e.dCtx.gridPad.right < o && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : "datetime" !== r && e.dCtx.gridPad.right < o / 2 - e.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && (e.dCtx.xPadRight = o / 2 + 1);
                    }(t);
                };
                s.yaxis.forEach(function(t, i) {
                    n ? (e.dCtx.gridPad.left < o && (e.dCtx.xPadLeft = o / 2 + 1), e.dCtx.xPadRight = o / 2 + 1) : l(t, i);
                });
            }
        }
    ]), t;
}(), lt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.dCtx = e;
    }
    return s(t, [
        {
            key: "getyAxisLabelsCoords",
            value: function() {
                var t = this, e = this.w, i = [], a = 10, s = new M(this.dCtx.ctx);
                return e.config.yaxis.map(function(r, o) {
                    var n = {
                        seriesIndex: o,
                        dataPointIndex: -1,
                        w: e
                    }, l = e.globals.yAxisScale[o], h = 0;
                    if (!s.isYAxisHidden(o) && r.labels.show && void 0 !== r.labels.minWidth && (h = r.labels.minWidth), !s.isYAxisHidden(o) && r.labels.show && l.result.length) {
                        var c = e.globals.yLabelFormatters[o], d = l.niceMin === Number.MIN_VALUE ? 0 : l.niceMin, g = l.result.reduce(function(t, e) {
                            var i, a;
                            return (null === (i = String(c(t, n))) || void 0 === i ? void 0 : i.length) > (null === (a = String(c(e, n))) || void 0 === a ? void 0 : a.length) ? t : e;
                        }, d), u = g = c(g, n);
                        if (void 0 !== g && 0 !== g.length || (g = l.niceMax), e.globals.isBarHorizontal) {
                            a = 0;
                            var f = e.globals.labels.slice();
                            g = m.getLargestStringFromArr(f), g = c(g, {
                                seriesIndex: o,
                                dataPointIndex: -1,
                                w: e
                            }), u = t.dCtx.dimHelpers.getLargestStringFromMultiArr(g, f);
                        }
                        var p = new k(t.dCtx.ctx), x = "rotate(".concat(r.labels.rotate, " 0 0)"), b = p.getTextRects(g, r.labels.style.fontSize, r.labels.style.fontFamily, x, !1), v = b;
                        g !== u && (v = p.getTextRects(u, r.labels.style.fontSize, r.labels.style.fontFamily, x, !1)), i.push({
                            width: (h > v.width || h > b.width ? h : v.width > b.width ? v.width : b.width) + a,
                            height: v.height > b.height ? v.height : b.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getyAxisTitleCoords",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.config.yaxis.map(function(e, a) {
                    if (e.show && void 0 !== e.title.text) {
                        var s = new k(t.dCtx.ctx), r = "rotate(".concat(e.title.rotate, " 0 0)"), o = s.getTextRects(e.title.text, e.title.style.fontSize, e.title.style.fontFamily, r, !1);
                        i.push({
                            width: o.width,
                            height: o.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getTotalYAxisWidth",
            value: function() {
                var t = this.w, e = 0, i = 0, a = 0, s = t.globals.yAxisScale.length > 1 ? 10 : 0, r = new M(this.dCtx.ctx), o = function(o, n) {
                    var l = t.config.yaxis[n].floating, h = 0;
                    o.width > 0 && !l ? (h = o.width + s, function(e) {
                        return t.globals.ignoreYAxisIndexes.indexOf(e) > -1;
                    }(n) && (h = h - o.width - s)) : h = l || r.isYAxisHidden(n) ? 0 : 5, t.config.yaxis[n].opposite ? a += h : i += h, e += h;
                };
                return t.globals.yLabelsCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.yTitleCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.isBarHorizontal && !t.config.yaxis[0].floating && (e = t.globals.yLabelsCoords[0].width + t.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, e;
            }
        }
    ]), t;
}(), ht = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.dCtx = e;
    }
    return s(t, [
        {
            key: "gridPadForColumnsInNumericAxis",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (a.noData || a.collapsedSeries.length + a.ancillaryCollapsedSeries.length === i.series.length) return 0;
                var s = function(t) {
                    return [
                        "bar",
                        "rangeBar",
                        "candlestick",
                        "boxPlot"
                    ].includes(t);
                }, r = i.chart.type, o = 0, n = s(r) ? i.series.length : 1;
                a.comboBarCount > 0 && (n = a.comboBarCount), a.collapsedSeries.forEach(function(t) {
                    s(t.type) && (n -= 1);
                }), i.chart.stacked && (n = 1);
                var l = s(r) || a.comboBarCount > 0, h = Math.abs(a.initialMaxX - a.initialMinX);
                if (l && a.isXNumeric && !a.isBarHorizontal && n > 0 && 0 !== h) {
                    h <= 3 && (h = a.dataPoints);
                    var c = h / t, d = a.minXDiff && a.minXDiff / c > 0 ? a.minXDiff / c : 0;
                    d > t / 2 && (d /= 2), (o = d * parseInt(i.plotOptions.bar.columnWidth, 10) / 100) < 1 && (o = 1), a.barPadForNumericAxis = o;
                }
                return o;
            }
        },
        {
            key: "gridPadFortitleSubtitle",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dCtx.isSparkline || !i.axisCharts ? 0 : 10;
                [
                    "title",
                    "subtitle"
                ].forEach(function(s) {
                    void 0 !== e.config[s].text ? a += e.config[s].margin : a += t.dCtx.isSparkline || !i.axisCharts ? 0 : 5;
                }), !e.config.legend.show || "bottom" !== e.config.legend.position || e.config.legend.floating || i.axisCharts || (a += 10);
                var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                i.gridHeight -= s.height + r.height + a, i.translateY += s.height + r.height + a;
            }
        },
        {
            key: "setGridXPosForDualYAxis",
            value: function(t, e) {
                var i = this.w, a = new M(this.dCtx.ctx);
                i.config.yaxis.forEach(function(s, r) {
                    -1 !== i.globals.ignoreYAxisIndexes.indexOf(r) || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX -= e[r].width + t[r].width + parseInt(s.labels.style.fontSize, 10) / 1.2 + 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                });
            }
        }
    ]), t;
}(), ct = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new ot(this), this.dimYAxis = new lt(this), this.dimXAxis = new nt(this), this.dimGrid = new ht(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
    }
    return s(t, [
        {
            key: "plotCoords",
            value: function() {
                var t = this, e = this.w, i = e.globals;
                this.lgRect = this.dimHelpers.getLegendsRect(), this.datalabelsCoords = {
                    width: 0,
                    height: 0
                };
                var a = Array.isArray(e.config.stroke.width) ? Math.max.apply(Math, p(e.config.stroke.width)) : e.config.stroke.width;
                this.isSparkline && ((e.config.markers.discrete.length > 0 || e.config.markers.size > 0) && Object.entries(this.gridPad).forEach(function(e) {
                    var i = f(e, 2), a = i[0], s = i[1];
                    t.gridPad[a] = Math.max(s, t.w.globals.markers.largestSize / 1.5);
                }), this.gridPad.top = Math.max(a / 2, this.gridPad.top), this.gridPad.bottom = Math.max(a / 2, this.gridPad.bottom)), i.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), i.gridHeight = i.gridHeight - this.gridPad.top - this.gridPad.bottom, i.gridWidth = i.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                var s = this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);
                i.gridWidth = i.gridWidth - 2 * s, i.translateX = i.translateX + this.gridPad.left + this.xPadLeft + (s > 0 ? s : 0), i.translateY = i.translateY + this.gridPad.top;
            }
        },
        {
            key: "setDimensionsForAxisCharts",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                i.isSlopeChart && (this.datalabelsCoords = this.dimHelpers.getDatalabelsRect()), e.globals.yLabelsCoords = [], e.globals.yTitleCoords = [], e.config.yaxis.map(function(t, i) {
                    e.globals.yLabelsCoords.push({
                        width: a[i].width,
                        index: i
                    }), e.globals.yTitleCoords.push({
                        width: s[i].width,
                        index: i
                    });
                }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                var r = this.dimXAxis.getxAxisLabelsCoords(), o = this.dimXAxis.getxAxisGroupLabelsCoords(), n = this.dimXAxis.getxAxisTitleCoords();
                this.conditionalChecksForAxisCoords(r, n, o), i.translateXAxisY = e.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = e.globals.rotateXLabels && e.globals.isXNumeric && e.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, e.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(e.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + e.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + e.config.xaxis.labels.offsetX;
                var l = this.yAxisWidth, h = this.xAxisHeight;
                i.xAxisLabelsHeight = this.xAxisHeight - n.height, i.xAxisGroupLabelsHeight = i.xAxisLabelsHeight - r.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                var c = 10;
                ("radar" === e.config.chart.type || this.isSparkline) && (l = 0, h = 0), this.isSparkline && (this.lgRect = {
                    height: 0,
                    width: 0
                }), (this.isSparkline || "treemap" === e.config.chart.type) && (l = 0, h = 0, c = 0), this.isSparkline || "treemap" === e.config.chart.type || this.dimXAxis.additionalPaddingXLabels(r);
                var d = function() {
                    i.translateX = l + t.datalabelsCoords.width, i.gridHeight = i.svgHeight - t.lgRect.height - h - (t.isSparkline || "treemap" === e.config.chart.type ? 0 : e.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - l - 2 * t.datalabelsCoords.width;
                };
                switch("top" === e.config.xaxis.position && (c = i.xAxisHeight - e.config.xaxis.axisTicks.height - 5), e.config.legend.position){
                    case "bottom":
                        i.translateY = c, d();
                        break;
                    case "top":
                        i.translateY = this.lgRect.height + c, d();
                        break;
                    case "left":
                        i.translateY = c, i.translateX = this.lgRect.width + l + this.datalabelsCoords.width, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l - 2 * this.datalabelsCoords.width;
                        break;
                    case "right":
                        i.translateY = c, i.translateX = l + this.datalabelsCoords.width, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l - 2 * this.datalabelsCoords.width - 5;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
                this.dimGrid.setGridXPosForDualYAxis(s, a), new Q(this.ctx).setYAxisXPosition(a, s);
            }
        },
        {
            key: "setDimensionsForNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = 0;
                t.config.legend.show && !t.config.legend.floating && (a = 20);
                var s = "pie" === i.chart.type || "polarArea" === i.chart.type || "donut" === i.chart.type ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, o = i.plotOptions[s].offsetX;
                if (!i.legend.show || i.legend.floating) {
                    e.gridHeight = e.svgHeight;
                    var n = e.dom.elWrap.getBoundingClientRect().width;
                    return e.gridWidth = Math.min(n, e.gridHeight), e.translateY = r, void (e.translateX = o + (e.svgWidth - e.gridWidth) / 2);
                }
                switch(i.legend.position){
                    case "bottom":
                        e.gridHeight = e.svgHeight - this.lgRect.height, e.gridWidth = e.svgWidth, e.translateY = r - 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "top":
                        e.gridHeight = e.svgHeight - this.lgRect.height, e.gridWidth = e.svgWidth, e.translateY = this.lgRect.height + r + 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "left":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + this.lgRect.width + a;
                        break;
                    case "right":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a - 5, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + 10;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
            }
        },
        {
            key: "conditionalChecksForAxisCoords",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.hasXaxisGroups ? 2 : 1, r = i.height + t.height + e.height, o = a.globals.isMultiLineX ? 1.2 : a.globals.LINE_HEIGHT_RATIO, n = a.globals.rotateXLabels ? 22 : 10, l = a.globals.rotateXLabels && "bottom" === a.config.legend.position ? 10 : 0;
                this.xAxisHeight = r * o + s * n + l, this.xAxisWidth = t.width, this.xAxisHeight - e.height > a.config.xaxis.labels.maxHeight && (this.xAxisHeight = a.config.xaxis.labels.maxHeight), a.config.xaxis.labels.minHeight && this.xAxisHeight < a.config.xaxis.labels.minHeight && (this.xAxisHeight = a.config.xaxis.labels.minHeight), a.config.xaxis.floating && (this.xAxisHeight = 0);
                var h = 0, c = 0;
                a.config.yaxis.forEach(function(t) {
                    h += t.labels.minWidth, c += t.labels.maxWidth;
                }), this.yAxisWidth < h && (this.yAxisWidth = h), this.yAxisWidth > c && (this.yAxisWidth = c);
            }
        }
    ]), t;
}(), dt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.lgCtx = e;
    }
    return s(t, [
        {
            key: "getLegendStyles",
            value: function() {
                var t, e, i, a = document.createElement("style");
                a.setAttribute("type", "text/css");
                var s = (null === (t = this.lgCtx.ctx) || void 0 === t || null === (e = t.opts) || void 0 === e || null === (i = e.chart) || void 0 === i ? void 0 : i.nonce) || this.w.config.chart.nonce;
                s && a.setAttribute("nonce", s);
                var r = document.createTextNode("\n      .apexcharts-flip-y {\n        transform: scaleY(-1) translateY(-100%);\n        transform-origin: top;\n        transform-box: fill-box;\n      }\n      .apexcharts-flip-x {\n        transform: scaleX(-1);\n        transform-origin: center;\n        transform-box: fill-box;\n      }\n      .apexcharts-legend {\n        display: flex;\n        overflow: auto;\n        padding: 0 10px;\n      }\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\n        flex-wrap: wrap\n      }\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        flex-direction: column;\n        bottom: 0;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        justify-content: flex-start;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\n        justify-content: center;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\n        justify-content: flex-end;\n      }\n      .apexcharts-legend-series {\n        cursor: pointer;\n        line-height: normal;\n        display: flex;\n        align-items: center;\n      }\n      .apexcharts-legend-text {\n        position: relative;\n        font-size: 14px;\n      }\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\n        pointer-events: none;\n      }\n      .apexcharts-legend-marker {\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        margin-right: 1px;\n      }\n\n      .apexcharts-legend-series.apexcharts-no-click {\n        cursor: auto;\n      }\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\n        display: none !important;\n      }\n      .apexcharts-inactive-legend {\n        opacity: 0.45;\n      }");
                return a.appendChild(r), a;
            }
        },
        {
            key: "getLegendDimensions",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), e = t.width;
                return {
                    clwh: t.height,
                    clww: e
                };
            }
        },
        {
            key: "appendToForeignObject",
            value: function() {
                this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles());
            }
        },
        {
            key: "toggleDataSeries",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.axisCharts || "radialBar" === a.config.chart.type) {
                    a.globals.resized = !0;
                    var s = null, r = null;
                    if (a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), e) [
                        {
                            cs: a.globals.collapsedSeries,
                            csi: a.globals.collapsedSeriesIndices
                        },
                        {
                            cs: a.globals.ancillaryCollapsedSeries,
                            csi: a.globals.ancillaryCollapsedSeriesIndices
                        }
                    ].forEach(function(t) {
                        i.riseCollapsedSeries(t.cs, t.csi, r);
                    });
                    else this.hideSeries({
                        seriesEl: s,
                        realIndex: r
                    });
                } else {
                    var o = a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t + 1, "'] path")), n = a.config.chart.type;
                    if ("pie" === n || "polarArea" === n || "donut" === n) {
                        var l = a.config.plotOptions.pie.donut.labels;
                        new k(this.lgCtx.ctx).pathMouseDown(o.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node, l);
                    }
                    o.fire("click");
                }
            }
        },
        {
            key: "getSeriesAfterCollapsing",
            value: function(t) {
                var e = t.realIndex, i = this.w, a = i.globals, s = m.clone(i.config.series);
                if (a.axisCharts) {
                    var r = i.config.yaxis[a.seriesYAxisReverseMap[e]], o = {
                        index: e,
                        data: s[e].data.slice(),
                        type: s[e].type || i.config.chart.type
                    };
                    if (r && r.show && r.showAlways) a.ancillaryCollapsedSeriesIndices.indexOf(e) < 0 && (a.ancillaryCollapsedSeries.push(o), a.ancillaryCollapsedSeriesIndices.push(e));
                    else if (a.collapsedSeriesIndices.indexOf(e) < 0) {
                        a.collapsedSeries.push(o), a.collapsedSeriesIndices.push(e);
                        var n = a.risingSeries.indexOf(e);
                        a.risingSeries.splice(n, 1);
                    }
                } else a.collapsedSeries.push({
                    index: e,
                    data: s[e]
                }), a.collapsedSeriesIndices.push(e);
                return a.allSeriesCollapsed = a.collapsedSeries.length + a.ancillaryCollapsedSeries.length === i.config.series.length, this._getSeriesBasedOnCollapsedState(s);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                for(var e = t.seriesEl, i = t.realIndex, a = this.w, s = this.getSeriesAfterCollapsing({
                    realIndex: i
                }), r = e.childNodes, o = 0; o < r.length; o++)r[o].classList.contains("apexcharts-series-markers-wrap") && (r[o].classList.contains("apexcharts-hide") ? r[o].classList.remove("apexcharts-hide") : r[o].classList.add("apexcharts-hide"));
                this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
            }
        },
        {
            key: "riseCollapsedSeries",
            value: function(t, e, i) {
                var a = this.w, s = m.clone(a.config.series);
                if (t.length > 0) {
                    for(var r = 0; r < t.length; r++)t[r].index === i && (a.globals.axisCharts ? s[i].data = t[r].data.slice() : s[i] = t[r].data, s[i].hidden = !1, t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i));
                    s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            }
        },
        {
            key: "_getSeriesBasedOnCollapsedState",
            value: function(t) {
                var e = this.w, i = 0;
                return e.globals.axisCharts ? t.forEach(function(a, s) {
                    e.globals.collapsedSeriesIndices.indexOf(s) < 0 && e.globals.ancillaryCollapsedSeriesIndices.indexOf(s) < 0 || (t[s].data = [], i++);
                }) : t.forEach(function(a, s) {
                    !e.globals.collapsedSeriesIndices.indexOf(s) < 0 && (t[s] = 0, i++);
                }), e.globals.allSeriesCollapsed = i === t.length, t;
            }
        }
    ]), t;
}(), gt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = "bar" === this.w.config.chart.type && this.w.config.plotOptions.bar.distributed && 1 === this.w.config.series.length, this.legendHelpers = new dt(this);
    }
    return s(t, [
        {
            key: "init",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = i.legend.showForSingleSeries && 1 === e.series.length || this.isBarsDistributed || e.series.length > 1;
                if (this.legendHelpers.appendToForeignObject(), (a || !e.axisCharts) && i.legend.show) {
                    for(; e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);
                    this.drawLegends(), "bottom" === i.legend.position || "top" === i.legend.position ? this.legendAlignHorizontal() : "right" !== i.legend.position && "left" !== i.legend.position || this.legendAlignVertical();
                }
            }
        },
        {
            key: "createLegendMarker",
            value: function(t) {
                var e = t.i, i = t.fillcolor, a = this.w, s = document.createElement("span");
                s.classList.add("apexcharts-legend-marker");
                var r = a.config.legend.markers.shape || a.config.markers.shape, o = r;
                Array.isArray(r) && (o = r[e]);
                var n = Array.isArray(a.config.legend.markers.size) ? parseFloat(a.config.legend.markers.size[e]) : parseFloat(a.config.legend.markers.size), l = Array.isArray(a.config.legend.markers.offsetX) ? parseFloat(a.config.legend.markers.offsetX[e]) : parseFloat(a.config.legend.markers.offsetX), h = Array.isArray(a.config.legend.markers.offsetY) ? parseFloat(a.config.legend.markers.offsetY[e]) : parseFloat(a.config.legend.markers.offsetY), c = Array.isArray(a.config.legend.markers.strokeWidth) ? parseFloat(a.config.legend.markers.strokeWidth[e]) : parseFloat(a.config.legend.markers.strokeWidth), d = s.style;
                if (d.height = 2 * (n + c) + "px", d.width = 2 * (n + c) + "px", d.left = l + "px", d.top = h + "px", a.config.legend.markers.customHTML) d.background = "transparent", d.color = i[e], Array.isArray(a.config.legend.markers.customHTML) ? a.config.legend.markers.customHTML[e] && (s.innerHTML = a.config.legend.markers.customHTML[e]()) : s.innerHTML = a.config.legend.markers.customHTML();
                else {
                    var u = new W(this.ctx).getMarkerConfig({
                        cssClass: "apexcharts-legend-marker apexcharts-marker apexcharts-marker-".concat(o),
                        seriesIndex: e,
                        strokeWidth: c,
                        size: n
                    }), f = SVG(s).size("100%", "100%"), p = new k(this.ctx).drawMarker(0, 0, g(g({}, u), {}, {
                        pointFillColor: Array.isArray(i) ? i[e] : u.pointFillColor,
                        shape: o
                    }));
                    SVG.select(".apexcharts-legend-marker.apexcharts-marker").members.forEach(function(t) {
                        t.node.classList.contains("apexcharts-marker-triangle") ? t.node.style.transform = "translate(50%, 45%)" : t.node.style.transform = "translate(50%, 50%)";
                    }), f.add(p);
                }
                return s;
            }
        },
        {
            key: "drawLegends",
            value: function() {
                var t = this, e = this.w, i = e.config.legend.fontFamily, a = e.globals.seriesNames, s = e.config.legend.markers.fillColors ? e.config.legend.markers.fillColors.slice() : e.globals.colors.slice();
                if ("heatmap" === e.config.chart.type) {
                    var r = e.config.plotOptions.heatmap.colorScale.ranges;
                    a = r.map(function(t) {
                        return t.name ? t.name : t.from + " - " + t.to;
                    }), s = r.map(function(t) {
                        return t.color;
                    });
                } else this.isBarsDistributed && (a = e.globals.labels.slice());
                e.config.legend.customLegendItems.length && (a = e.config.legend.customLegendItems);
                for(var o = e.globals.legendFormatter, n = e.config.legend.inverseOrder, l = n ? a.length - 1 : 0; n ? l >= 0 : l <= a.length - 1; n ? l-- : l++){
                    var h, c = o(a[l], {
                        seriesIndex: l,
                        w: e
                    }), d = !1, g = !1;
                    if (e.globals.collapsedSeries.length > 0) for(var u = 0; u < e.globals.collapsedSeries.length; u++)e.globals.collapsedSeries[u].index === l && (d = !0);
                    if (e.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var f = 0; f < e.globals.ancillaryCollapsedSeriesIndices.length; f++)e.globals.ancillaryCollapsedSeriesIndices[f] === l && (g = !0);
                    var p = this.createLegendMarker({
                        i: l,
                        fillcolor: s
                    });
                    k.setAttrs(p, {
                        rel: l + 1,
                        "data:collapsed": d || g
                    }), (d || g) && p.classList.add("apexcharts-inactive-legend");
                    var x = document.createElement("div"), b = document.createElement("span");
                    b.classList.add("apexcharts-legend-text"), b.innerHTML = Array.isArray(c) ? c.join(" ") : c;
                    var v = e.config.legend.labels.useSeriesColors ? e.globals.colors[l] : Array.isArray(e.config.legend.labels.colors) ? null === (h = e.config.legend.labels.colors) || void 0 === h ? void 0 : h[l] : e.config.legend.labels.colors;
                    v || (v = e.config.chart.foreColor), b.style.color = v, b.style.fontSize = parseFloat(e.config.legend.fontSize) + "px", b.style.fontWeight = e.config.legend.fontWeight, b.style.fontFamily = i || e.config.chart.fontFamily, k.setAttrs(b, {
                        rel: l + 1,
                        i: l,
                        "data:default-text": encodeURIComponent(c),
                        "data:collapsed": d || g
                    }), x.appendChild(p), x.appendChild(b);
                    var y = new A(this.ctx);
                    if (!e.config.legend.showForZeroSeries) 0 === y.getSeriesTotalByIndex(l) && y.seriesHaveSameValues(l) && !y.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && x.classList.add("apexcharts-hidden-zero-series");
                    e.config.legend.showForNullSeries || y.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && x.classList.add("apexcharts-hidden-null-series"), e.globals.dom.elLegendWrap.appendChild(x), e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)), e.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + e.config.legend.position), x.classList.add("apexcharts-legend-series"), x.style.margin = "".concat(e.config.legend.itemMargin.vertical, "px ").concat(e.config.legend.itemMargin.horizontal, "px"), e.globals.dom.elLegendWrap.style.width = e.config.legend.width ? e.config.legend.width + "px" : "", e.globals.dom.elLegendWrap.style.height = e.config.legend.height ? e.config.legend.height + "px" : "", k.setAttrs(x, {
                        rel: l + 1,
                        seriesName: m.escapeString(a[l]),
                        "data:collapsed": d || g
                    }), (d || g) && x.classList.add("apexcharts-inactive-legend"), e.config.legend.onItemClick.toggleDataSeries || x.classList.add("apexcharts-no-click");
                }
                e.globals.dom.elWrap.addEventListener("click", t.onLegendClick, !0), e.config.legend.onItemHover.highlightDataSeries && 0 === e.config.legend.customLegendItems.length && (e.globals.dom.elWrap.addEventListener("mousemove", t.onLegendHovered, !0), e.globals.dom.elWrap.addEventListener("mouseout", t.onLegendHovered, !0));
            }
        },
        {
            key: "setLegendWrapXY",
            value: function(t, e) {
                var i = this.w, a = i.globals.dom.elLegendWrap, s = a.clientHeight, r = 0, o = 0;
                if ("bottom" === i.config.legend.position) o = i.globals.svgHeight - Math.min(s, i.globals.svgHeight / 2) - 5;
                else if ("top" === i.config.legend.position) {
                    var n = new ct(this.ctx), l = n.dimHelpers.getTitleSubtitleCoords("title").height, h = n.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                    o = (l > 0 ? l - 10 : 0) + (h > 0 ? h - 10 : 0);
                }
                a.style.position = "absolute", r = r + t + i.config.legend.offsetX, o = o + e + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = o + "px", "right" === i.config.legend.position && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px");
                [
                    "width",
                    "height"
                ].forEach(function(t) {
                    a.style[t] && (a.style[t] = parseInt(i.config.legend[t], 10) + "px");
                });
            }
        },
        {
            key: "legendAlignHorizontal",
            value: function() {
                var t = this.w;
                t.globals.dom.elLegendWrap.style.right = 0;
                var e = new ct(this.ctx), i = e.dimHelpers.getTitleSubtitleCoords("title"), a = e.dimHelpers.getTitleSubtitleCoords("subtitle"), s = 0;
                "top" === t.config.legend.position && (s = i.height + a.height + t.config.title.margin + t.config.subtitle.margin - 10), this.setLegendWrapXY(20, s);
            }
        },
        {
            key: "legendAlignVertical",
            value: function() {
                var t = this.w, e = this.legendHelpers.getLegendDimensions(), i = 0;
                "left" === t.config.legend.position && (i = 20), "right" === t.config.legend.position && (i = t.globals.svgWidth - e.clww - 10), this.setLegendWrapXY(i, 20);
            }
        },
        {
            key: "onLegendHovered",
            value: function(t) {
                var e = this.w, i = t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker");
                if ("heatmap" === e.config.chart.type || this.isBarsDistributed) {
                    if (i) {
                        var a = parseInt(t.target.getAttribute("rel"), 10) - 1;
                        this.ctx.events.fireEvent("legendHover", [
                            this.ctx,
                            a,
                            this.w
                        ]), new V(this.ctx).highlightRangeInSeries(t, t.target);
                    }
                } else !t.target.classList.contains("apexcharts-inactive-legend") && i && new V(this.ctx).toggleSeriesOnHover(t, t.target);
            }
        },
        {
            key: "onLegendClick",
            value: function(t) {
                var e = this.w;
                if (!e.config.legend.customLegendItems.length && (t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker"))) {
                    var i = parseInt(t.target.getAttribute("rel"), 10) - 1, a = "true" === t.target.getAttribute("data:collapsed"), s = this.w.config.chart.events.legendClick;
                    "function" == typeof s && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                        this.ctx,
                        i,
                        this.w
                    ]);
                    var r = this.w.config.legend.markers.onClick;
                    "function" == typeof r && t.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                        this.ctx,
                        i,
                        this.w
                    ])), "treemap" !== e.config.chart.type && "heatmap" !== e.config.chart.type && !this.isBarsDistributed && e.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                }
            }
        }
    ]), t;
}(), ut = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = a.globals.minX, this.maxX = a.globals.maxX;
    }
    return s(t, [
        {
            key: "createToolbar",
            value: function() {
                var t = this, e = this.w, i = function() {
                    return document.createElement("div");
                }, a = i();
                if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = e.config.chart.toolbar.offsetY + "px", a.style.right = 3 - e.config.chart.toolbar.offsetX + "px", e.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = e.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                var r = [], o = function(i, a, s) {
                    var o = i.toLowerCase();
                    t.t[o] && e.config.chart.zoom.enabled && r.push({
                        el: a,
                        icon: "string" == typeof t.t[o] ? t.t[o] : s,
                        title: t.localeValues[i],
                        class: "apexcharts-".concat(o, "-icon")
                    });
                };
                o("zoomIn", this.elZoomIn, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'), o("zoomOut", this.elZoomOut, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');
                var n = function(i) {
                    t.t[i] && e.config.chart[i].enabled && r.push({
                        el: "zoom" === i ? t.elZoom : t.elSelection,
                        icon: "string" == typeof t.t[i] ? t.t[i] : "zoom" === i ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>' : '<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',
                        title: t.localeValues["zoom" === i ? "selectionZoom" : "selection"],
                        class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(i, "-icon")
                    });
                };
                n("zoom"), n("selection"), this.t.pan && e.config.chart.zoom.enabled && r.push({
                    el: this.elPan,
                    icon: "string" == typeof this.t.pan ? this.t.pan : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',
                    title: this.localeValues.pan,
                    class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                }), o("reset", this.elZoomReset, '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'), this.t.download && r.push({
                    el: this.elMenuIcon,
                    icon: "string" == typeof this.t.download ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                    title: this.localeValues.menu,
                    class: "apexcharts-menu-icon"
                });
                for(var l = 0; l < this.elCustomIcons.length; l++)r.push({
                    el: this.elCustomIcons[l],
                    icon: this.t.customIcons[l].icon,
                    title: this.t.customIcons[l].title,
                    index: this.t.customIcons[l].index,
                    class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[l].class
                });
                r.forEach(function(t, e) {
                    t.index && m.moveIndexInArray(r, e, t.index);
                });
                for(var h = 0; h < r.length; h++)k.setAttrs(r[h].el, {
                    class: r[h].class,
                    title: r[h].title
                }), r[h].el.innerHTML = r[h].icon, a.appendChild(r[h].el);
                this._createHamburgerMenu(a), e.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : e.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : e.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
            }
        },
        {
            key: "_createHamburgerMenu",
            value: function(t) {
                this.elMenuItems = [], t.appendChild(this.elMenu), k.setAttrs(this.elMenu, {
                    class: "apexcharts-menu"
                });
                for(var e = [
                    {
                        name: "exportSVG",
                        title: this.localeValues.exportToSVG
                    },
                    {
                        name: "exportPNG",
                        title: this.localeValues.exportToPNG
                    },
                    {
                        name: "exportCSV",
                        title: this.localeValues.exportToCSV
                    }
                ], i = 0; i < e.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = e[i].title, k.setAttrs(this.elMenuItems[i], {
                    class: "apexcharts-menu-item ".concat(e[i].name),
                    title: e[i].title
                }), this.elMenu.appendChild(this.elMenuItems[i]);
            }
        },
        {
            key: "addToolbarEventListeners",
            value: function() {
                var t = this;
                this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(e) {
                    e.classList.contains("exportSVG") ? e.addEventListener("click", t.handleDownload.bind(t, "svg")) : e.classList.contains("exportPNG") ? e.addEventListener("click", t.handleDownload.bind(t, "png")) : e.classList.contains("exportCSV") && e.addEventListener("click", t.handleDownload.bind(t, "csv"));
                });
                for(var e = 0; e < this.t.customIcons.length; e++)this.elCustomIcons[e].addEventListener("click", this.t.customIcons[e].click.bind(this, this.ctx, this.ctx.w));
            }
        },
        {
            key: "toggleZoomSelection",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(e) {
                    e.ctx.toolbar.toggleOtherControls();
                    var i = "selection" === t ? e.ctx.toolbar.elSelection : e.ctx.toolbar.elZoom, a = "selection" === t ? "selectionEnabled" : "zoomEnabled";
                    e.w.globals[a] = !e.w.globals[a], i.classList.contains(e.ctx.toolbar.selectedClass) ? i.classList.remove(e.ctx.toolbar.selectedClass) : i.classList.add(e.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "getToolbarIconsReference",
            value: function() {
                var t = this.w;
                this.elZoom || (this.elZoom = t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
            }
        },
        {
            key: "enableZoomPanFromToolbar",
            value: function(t) {
                this.toggleOtherControls(), "pan" === t ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                var e = "pan" === t ? this.elPan : this.elZoom, i = "pan" === t ? this.elZoom : this.elPan;
                e && e.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
            }
        },
        {
            key: "togglePanning",
            value: function() {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    t.ctx.toolbar.toggleOtherControls(), t.w.globals.panEnabled = !t.w.globals.panEnabled, t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass) ? t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass) : t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "toggleOtherControls",
            value: function() {
                var t = this, e = this.w;
                e.globals.panEnabled = !1, e.globals.zoomEnabled = !1, e.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                    this.elPan,
                    this.elSelection,
                    this.elZoom
                ].forEach(function(e) {
                    e && e.classList.remove(t.selectedClass);
                });
            }
        },
        {
            key: "handleZoomIn",
            value: function() {
                var t = this.w;
                t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY);
                var e = (this.minX + this.maxX) / 2, i = (this.minX + e) / 2, a = (this.maxX + e) / 2, s = this._getNewMinXMaxX(i, a);
                t.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
            }
        },
        {
            key: "handleZoomOut",
            value: function() {
                var t = this.w;
                if (t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY), !("datetime" === t.config.xaxis.type && new Date(this.minX).getUTCFullYear() < 1e3)) {
                    var e = (this.minX + this.maxX) / 2, i = this.minX - (e - this.minX), a = this.maxX - (e - this.maxX), s = this._getNewMinXMaxX(i, a);
                    t.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            }
        },
        {
            key: "_getNewMinXMaxX",
            value: function(t, e) {
                var i = this.w.config.xaxis.convertedCatToNumeric;
                return {
                    minX: i ? Math.floor(t) : t,
                    maxX: i ? Math.floor(e) : e
                };
            }
        },
        {
            key: "zoomUpdateOptions",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== t || void 0 !== e) {
                    if (!(i.config.xaxis.convertedCatToNumeric && (t < 1 && (t = 1, e = i.globals.dataPoints), e - t < 2))) {
                        var a = {
                            min: t,
                            max: e
                        }, s = this.getBeforeZoomRange(a);
                        s && (a = s.xaxis);
                        var r = {
                            xaxis: a
                        }, o = m.clone(i.globals.initialConfig.yaxis);
                        i.config.chart.group || (r.yaxis = o), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, o);
                    }
                } else this.handleZoomReset();
            }
        },
        {
            key: "zoomCallback",
            value: function(t, e) {
                "function" == typeof this.ev.zoomed && this.ev.zoomed(this.ctx, {
                    xaxis: t,
                    yaxis: e
                });
            }
        },
        {
            key: "getBeforeZoomRange",
            value: function(t, e) {
                var i = null;
                return "function" == typeof this.ev.beforeZoom && (i = this.ev.beforeZoom(this, {
                    xaxis: t,
                    yaxis: e
                })), i;
            }
        },
        {
            key: "toggleMenu",
            value: function() {
                var t = this;
                window.setTimeout(function() {
                    t.elMenu.classList.contains("apexcharts-menu-open") ? t.elMenu.classList.remove("apexcharts-menu-open") : t.elMenu.classList.add("apexcharts-menu-open");
                }, 0);
            }
        },
        {
            key: "handleDownload",
            value: function(t) {
                var e = this.w, i = new U(this.ctx);
                switch(t){
                    case "svg":
                        i.exportToSVG(this.ctx);
                        break;
                    case "png":
                        i.exportToPng(this.ctx);
                        break;
                    case "csv":
                        i.exportToCSV({
                            series: e.config.series,
                            columnDelimiter: e.config.chart.toolbar.export.csv.columnDelimiter
                        });
                }
            }
        },
        {
            key: "handleZoomReset",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    var e = t.w;
                    if (e.globals.lastXAxis.min = e.globals.initialConfig.xaxis.min, e.globals.lastXAxis.max = e.globals.initialConfig.xaxis.max, t.updateHelpers.revertDefaultAxisMinMax(), "function" == typeof e.config.chart.events.beforeResetZoom) {
                        var i = e.config.chart.events.beforeResetZoom(t, e);
                        i && t.updateHelpers.revertDefaultAxisMinMax(i);
                    }
                    "function" == typeof e.config.chart.events.zoomed && t.ctx.toolbar.zoomCallback({
                        min: e.config.xaxis.min,
                        max: e.config.xaxis.max
                    }), e.globals.zoomed = !1;
                    var a = t.ctx.series.emptyCollapsedSeries(m.clone(e.globals.initialSeries));
                    t.updateHelpers._updateSeries(a, e.config.chart.animations.dynamicAnimation.enabled);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
            }
        }
    ]), t;
}(), ft = function(t) {
    h(a, ut);
    var e = o(a);
    function a(t) {
        var s;
        return i(this, a), (s = e.call(this, t)).ctx = t, s.w = t.w, s.dragged = !1, s.graphics = new k(s.ctx), s.eventList = [
            "mousedown",
            "mouseleave",
            "mousemove",
            "touchstart",
            "touchmove",
            "mouseup",
            "touchend",
            "wheel"
        ], s.clientX = 0, s.clientY = 0, s.startX = 0, s.endX = 0, s.dragX = 0, s.startY = 0, s.endY = 0, s.dragY = 0, s.moveDirection = "none", s.debounceTimer = null, s.debounceDelay = 100, s.wheelDelay = 400, s;
    }
    return s(a, [
        {
            key: "init",
            value: function(t) {
                var e = this, i = t.xyRatios, a = this.w, s = this;
                this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = a.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), a.globals.dom.elGraphical.add(this.zoomRect), a.globals.dom.elGraphical.add(this.selectionRect), "x" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    minY: 0,
                    maxX: a.globals.gridWidth,
                    maxY: a.globals.gridHeight
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : "y" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    maxX: a.globals.gridWidth
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(t) {
                    e.hoverArea.addEventListener(t, s.svgMouseEvents.bind(s, i), {
                        capture: !1,
                        passive: !0
                    });
                }), a.config.chart.zoom.allowMouseWheelZoom && this.hoverArea.addEventListener("wheel", s.mouseWheelEvent.bind(s), {
                    capture: !1,
                    passive: !1
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
            }
        },
        {
            key: "svgMouseEvents",
            value: function(t, e) {
                var i = this.w, a = this, s = this.ctx.toolbar, r = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type, o = i.config.chart.toolbar.autoSelected;
                if (e.shiftKey ? (this.shiftWasPressed = !0, s.enableZoomPanFromToolbar("pan" === o ? "zoom" : "pan")) : this.shiftWasPressed && (s.enableZoomPanFromToolbar(o), this.shiftWasPressed = !1), e.target) {
                    var n, l = e.target.classList;
                    if (e.target.parentNode && null !== e.target.parentNode && (n = e.target.parentNode.classList), !(l.contains("apexcharts-selection-rect") || l.contains("apexcharts-legend-marker") || l.contains("apexcharts-legend-text") || n && n.contains("apexcharts-toolbar"))) {
                        if (a.clientX = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientX : "touchend" === e.type ? e.changedTouches[0].clientX : e.clientX, a.clientY = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientY : "touchend" === e.type ? e.changedTouches[0].clientY : e.clientY, "mousedown" === e.type && 1 === e.which) {
                            var h = a.gridRect.getBoundingClientRect();
                            a.startX = a.clientX - h.left, a.startY = a.clientY - h.top, a.dragged = !1, a.w.globals.mousedown = !0;
                        }
                        if (("mousemove" === e.type && 1 === e.which || "touchmove" === e.type) && (a.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, a.w.globals.mousedown && a.panDragging({
                            context: a,
                            zoomtype: r,
                            xyRatios: t
                        })) : (a.w.globals.mousedown && i.globals.zoomEnabled || a.w.globals.mousedown && i.globals.selectionEnabled) && (a.selection = a.selectionDrawing({
                            context: a,
                            zoomtype: r
                        }))), "mouseup" === e.type || "touchend" === e.type || "mouseleave" === e.type) {
                            var c, d = null === (c = a.gridRect) || void 0 === c ? void 0 : c.getBoundingClientRect();
                            d && a.w.globals.mousedown && (a.endX = a.clientX - d.left, a.endY = a.clientY - d.top, a.dragX = Math.abs(a.endX - a.startX), a.dragY = Math.abs(a.endY - a.startY), (i.globals.zoomEnabled || i.globals.selectionEnabled) && a.selectionDrawn({
                                context: a,
                                zoomtype: r
                            }), i.globals.panEnabled && i.config.xaxis.convertedCatToNumeric && a.delayedPanScrolled()), i.globals.zoomEnabled && a.hideSelectionRect(this.selectionRect), a.dragged = !1, a.w.globals.mousedown = !1;
                        }
                        this.makeSelectionRectDraggable();
                    }
                }
            }
        },
        {
            key: "mouseWheelEvent",
            value: function(t) {
                var e = this, i = this.w;
                t.preventDefault();
                var a = Date.now();
                a - i.globals.lastWheelExecution > this.wheelDelay && (this.executeMouseWheelZoom(t), i.globals.lastWheelExecution = a), this.debounceTimer && clearTimeout(this.debounceTimer), this.debounceTimer = setTimeout(function() {
                    a - i.globals.lastWheelExecution > e.wheelDelay && (e.executeMouseWheelZoom(t), i.globals.lastWheelExecution = a);
                }, this.debounceDelay);
            }
        },
        {
            key: "executeMouseWheelZoom",
            value: function(t) {
                var e, i = this.w;
                this.minX = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, this.maxX = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                var a = null === (e = this.gridRect) || void 0 === e ? void 0 : e.getBoundingClientRect();
                if (a) {
                    var s, r, o, n = (t.clientX - a.left) / a.width, l = this.minX, h = this.maxX, c = h - l;
                    if (t.deltaY < 0) {
                        var d = l + n * c;
                        r = d - (s = .5 * c) / 2, o = d + s / 2;
                    } else r = l - (s = 1.5 * c) / 2, o = h + s / 2;
                    if (!i.globals.isRangeBar) {
                        r = Math.max(r, i.globals.initialMinX), o = Math.min(o, i.globals.initialMaxX);
                        var g = .01 * (i.globals.initialMaxX - i.globals.initialMinX);
                        if (o - r < g) {
                            var u = (r + o) / 2;
                            r = u - g / 2, o = u + g / 2;
                        }
                    }
                    var f = this._getNewMinXMaxX(r, o);
                    isNaN(f.minX) || isNaN(f.maxX) || this.zoomUpdateOptions(f.minX, f.maxX);
                }
            }
        },
        {
            key: "makeSelectionRectDraggable",
            value: function() {
                var t = this.w;
                if (this.selectionRect) {
                    var e = this.selectionRect.node.getBoundingClientRect();
                    e.width > 0 && e.height > 0 && this.slDraggableRect.selectize({
                        points: "l, r",
                        pointSize: 8,
                        pointType: "rect"
                    }).resize({
                        constraint: {
                            minX: 0,
                            minY: 0,
                            maxX: t.globals.gridWidth,
                            maxY: t.globals.gridHeight
                        }
                    }).on("resizing", this.selectionDragging.bind(this, "resizing"));
                }
            }
        },
        {
            key: "preselectedSelection",
            value: function() {
                var t = this.w, e = this.xyRatios;
                if (!t.globals.zoomEnabled) {
                    if (void 0 !== t.globals.selection && null !== t.globals.selection) this.drawSelectionRect(t.globals.selection);
                    else if (void 0 !== t.config.chart.selection.xaxis.min && void 0 !== t.config.chart.selection.xaxis.max) {
                        var i = (t.config.chart.selection.xaxis.min - t.globals.minX) / e.xRatio, a = t.globals.gridWidth - (t.globals.maxX - t.config.chart.selection.xaxis.max) / e.xRatio - i;
                        t.globals.isRangeBar && (i = (t.config.chart.selection.xaxis.min - t.globals.yAxisScale[0].niceMin) / e.invertedYRatio, a = (t.config.chart.selection.xaxis.max - t.config.chart.selection.xaxis.min) / e.invertedYRatio);
                        var s = {
                            x: i,
                            y: 0,
                            width: a,
                            height: t.globals.gridHeight,
                            translateX: 0,
                            translateY: 0,
                            selectionEnabled: !0
                        };
                        this.drawSelectionRect(s), this.makeSelectionRectDraggable(), "function" == typeof t.config.chart.events.selection && t.config.chart.events.selection(this.ctx, {
                            xaxis: {
                                min: t.config.chart.selection.xaxis.min,
                                max: t.config.chart.selection.xaxis.max
                            },
                            yaxis: {}
                        });
                    }
                }
            }
        },
        {
            key: "drawSelectionRect",
            value: function(t) {
                var e = t.x, i = t.y, a = t.width, s = t.height, r = t.translateX, o = void 0 === r ? 0 : r, n = t.translateY, l = void 0 === n ? 0 : n, h = this.w, c = this.zoomRect, d = this.selectionRect;
                if (this.dragged || null !== h.globals.selection) {
                    var g = {
                        transform: "translate(" + o + ", " + l + ")"
                    };
                    h.globals.zoomEnabled && this.dragged && (a < 0 && (a = 1), c.attr({
                        x: e,
                        y: i,
                        width: a,
                        height: s,
                        fill: h.config.chart.zoom.zoomedArea.fill.color,
                        "fill-opacity": h.config.chart.zoom.zoomedArea.fill.opacity,
                        stroke: h.config.chart.zoom.zoomedArea.stroke.color,
                        "stroke-width": h.config.chart.zoom.zoomedArea.stroke.width,
                        "stroke-opacity": h.config.chart.zoom.zoomedArea.stroke.opacity
                    }), k.setAttrs(c.node, g)), h.globals.selectionEnabled && (d.attr({
                        x: e,
                        y: i,
                        width: a > 0 ? a : 0,
                        height: s > 0 ? s : 0,
                        fill: h.config.chart.selection.fill.color,
                        "fill-opacity": h.config.chart.selection.fill.opacity,
                        stroke: h.config.chart.selection.stroke.color,
                        "stroke-width": h.config.chart.selection.stroke.width,
                        "stroke-dasharray": h.config.chart.selection.stroke.dashArray,
                        "stroke-opacity": h.config.chart.selection.stroke.opacity
                    }), k.setAttrs(d.node, g));
                }
            }
        },
        {
            key: "hideSelectionRect",
            value: function(t) {
                t && t.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
        },
        {
            key: "selectionDrawing",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.gridRect.getBoundingClientRect(), o = s.startX - 1, n = s.startY, l = !1, h = !1, c = s.clientX - r.left - o, d = s.clientY - r.top - n, g = {};
                return Math.abs(c + o) > a.globals.gridWidth ? c = a.globals.gridWidth - o : s.clientX - r.left < 0 && (c = o), o > s.clientX - r.left && (l = !0, c = Math.abs(c)), n > s.clientY - r.top && (h = !0, d = Math.abs(d)), g = "x" === i ? {
                    x: l ? o - c : o,
                    y: 0,
                    width: c,
                    height: a.globals.gridHeight
                } : "y" === i ? {
                    x: 0,
                    y: h ? n - d : n,
                    width: a.globals.gridWidth,
                    height: d
                } : {
                    x: l ? o - c : o,
                    y: h ? n - d : n,
                    width: c,
                    height: d
                }, s.drawSelectionRect(g), s.selectionDragging("resizing"), g;
            }
        },
        {
            key: "selectionDragging",
            value: function(t, e) {
                var i = this, a = this.w, s = this.xyRatios, r = this.selectionRect, o = 0;
                "resizing" === t && (o = 30);
                var n = function(t) {
                    return parseFloat(r.node.getAttribute(t));
                }, l = {
                    x: n("x"),
                    y: n("y"),
                    width: n("width"),
                    height: n("height")
                };
                a.globals.selection = l, "function" == typeof a.config.chart.events.selection && a.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                    var t, e, o, n, l = i.gridRect.getBoundingClientRect(), h = r.node.getBoundingClientRect();
                    a.globals.isRangeBar ? (t = a.globals.yAxisScale[0].niceMin + (h.left - l.left) * s.invertedYRatio, e = a.globals.yAxisScale[0].niceMin + (h.right - l.left) * s.invertedYRatio, o = 0, n = 1) : (t = a.globals.xAxisScale.niceMin + (h.left - l.left) * s.xRatio, e = a.globals.xAxisScale.niceMin + (h.right - l.left) * s.xRatio, o = a.globals.yAxisScale[0].niceMin + (l.bottom - h.bottom) * s.yRatio[0], n = a.globals.yAxisScale[0].niceMax - (h.top - l.top) * s.yRatio[0]);
                    var c = {
                        xaxis: {
                            min: t,
                            max: e
                        },
                        yaxis: {
                            min: o,
                            max: n
                        }
                    };
                    a.config.chart.events.selection(i.ctx, c), a.config.chart.brush.enabled && void 0 !== a.config.chart.events.brushScrolled && a.config.chart.events.brushScrolled(i.ctx, c);
                }, o));
            }
        },
        {
            key: "selectionDrawn",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.xyRatios, o = this.ctx.toolbar;
                if (s.startX > s.endX) {
                    var n = s.startX;
                    s.startX = s.endX, s.endX = n;
                }
                if (s.startY > s.endY) {
                    var l = s.startY;
                    s.startY = s.endY, s.endY = l;
                }
                var h = void 0, c = void 0;
                a.globals.isRangeBar ? (h = a.globals.yAxisScale[0].niceMin + s.startX * r.invertedYRatio, c = a.globals.yAxisScale[0].niceMin + s.endX * r.invertedYRatio) : (h = a.globals.xAxisScale.niceMin + s.startX * r.xRatio, c = a.globals.xAxisScale.niceMin + s.endX * r.xRatio);
                var d = [], g = [];
                if (a.config.yaxis.forEach(function(t, e) {
                    var i = a.globals.seriesYAxisMap[e][0];
                    d.push(a.globals.yAxisScale[e].niceMax - r.yRatio[i] * s.startY), g.push(a.globals.yAxisScale[e].niceMax - r.yRatio[i] * s.endY);
                }), s.dragged && (s.dragX > 10 || s.dragY > 10) && h !== c) {
                    if (a.globals.zoomEnabled) {
                        var u = m.clone(a.globals.initialConfig.yaxis), f = m.clone(a.globals.initialConfig.xaxis);
                        if (a.globals.zoomed = !0, a.config.xaxis.convertedCatToNumeric && (h = Math.floor(h), c = Math.floor(c), h < 1 && (h = 1, c = a.globals.dataPoints), c - h < 2 && (c = h + 1)), "xy" !== i && "x" !== i || (f = {
                            min: h,
                            max: c
                        }), "xy" !== i && "y" !== i || u.forEach(function(t, e) {
                            u[e].min = g[e], u[e].max = d[e];
                        }), o) {
                            var p = o.getBeforeZoomRange(f, u);
                            p && (f = p.xaxis ? p.xaxis : f, u = p.yaxis ? p.yaxis : u);
                        }
                        var x = {
                            xaxis: f
                        };
                        a.config.chart.group || (x.yaxis = u), s.ctx.updateHelpers._updateOptions(x, !1, s.w.config.chart.animations.dynamicAnimation.enabled), "function" == typeof a.config.chart.events.zoomed && o.zoomCallback(f, u);
                    } else if (a.globals.selectionEnabled) {
                        var b, v = null;
                        b = {
                            min: h,
                            max: c
                        }, "xy" !== i && "y" !== i || (v = m.clone(a.config.yaxis)).forEach(function(t, e) {
                            v[e].min = g[e], v[e].max = d[e];
                        }), a.globals.selection = s.selection, "function" == typeof a.config.chart.events.selection && a.config.chart.events.selection(s.ctx, {
                            xaxis: b,
                            yaxis: v
                        });
                    }
                }
            }
        },
        {
            key: "panDragging",
            value: function(t) {
                var e = t.context, i = this.w, a = e;
                if (void 0 !== i.globals.lastClientPosition.x) {
                    var s = i.globals.lastClientPosition.x - a.clientX, r = i.globals.lastClientPosition.y - a.clientY;
                    Math.abs(s) > Math.abs(r) && s > 0 ? this.moveDirection = "left" : Math.abs(s) > Math.abs(r) && s < 0 ? this.moveDirection = "right" : Math.abs(r) > Math.abs(s) && r > 0 ? this.moveDirection = "up" : Math.abs(r) > Math.abs(s) && r < 0 && (this.moveDirection = "down");
                }
                i.globals.lastClientPosition = {
                    x: a.clientX,
                    y: a.clientY
                };
                var o = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, n = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                i.config.xaxis.convertedCatToNumeric || a.panScrolled(o, n);
            }
        },
        {
            key: "delayedPanScrolled",
            value: function() {
                var t = this.w, e = t.globals.minX, i = t.globals.maxX, a = (t.globals.maxX - t.globals.minX) / 2;
                "left" === this.moveDirection ? (e = t.globals.minX + a, i = t.globals.maxX + a) : "right" === this.moveDirection && (e = t.globals.minX - a, i = t.globals.maxX - a), e = Math.floor(e), i = Math.floor(i), this.updateScrolledChart({
                    xaxis: {
                        min: e,
                        max: i
                    }
                }, e, i);
            }
        },
        {
            key: "panScrolled",
            value: function(t, e) {
                var i = this.w, a = this.xyRatios, s = m.clone(i.globals.initialConfig.yaxis), r = a.xRatio, o = i.globals.minX, n = i.globals.maxX;
                i.globals.isRangeBar && (r = a.invertedYRatio, o = i.globals.minY, n = i.globals.maxY), "left" === this.moveDirection ? (t = o + i.globals.gridWidth / 15 * r, e = n + i.globals.gridWidth / 15 * r) : "right" === this.moveDirection && (t = o - i.globals.gridWidth / 15 * r, e = n - i.globals.gridWidth / 15 * r), i.globals.isRangeBar || (t < i.globals.initialMinX || e > i.globals.initialMaxX) && (t = o, e = n);
                var l = {
                    xaxis: {
                        min: t,
                        max: e
                    }
                };
                i.config.chart.group || (l.yaxis = s), this.updateScrolledChart(l, t, e);
            }
        },
        {
            key: "updateScrolledChart",
            value: function(t, e, i) {
                var a = this.w;
                this.ctx.updateHelpers._updateOptions(t, !1, !1), "function" == typeof a.config.chart.events.scrolled && a.config.chart.events.scrolled(this.ctx, {
                    xaxis: {
                        min: e,
                        max: i
                    }
                });
            }
        }
    ]), a;
}(), pt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
    }
    return s(t, [
        {
            key: "getNearestValues",
            value: function(t) {
                var e = t.hoverArea, i = t.elGrid, a = t.clientX, s = t.clientY, r = this.w, o = i.getBoundingClientRect(), n = o.width, l = o.height, h = n / (r.globals.dataPoints - 1), c = l / r.globals.dataPoints, d = this.hasBars();
                !r.globals.comboCharts && !d || r.config.xaxis.convertedCatToNumeric || (h = n / r.globals.dataPoints);
                var g = a - o.left - r.globals.barPadForNumericAxis, u = s - o.top;
                g < 0 || u < 0 || g > n || u > l ? (e.classList.remove("hovering-zoom"), e.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (e.classList.remove("hovering-pan"), e.classList.add("hovering-zoom")) : r.globals.panEnabled && (e.classList.remove("hovering-zoom"), e.classList.add("hovering-pan"));
                var f = Math.round(g / h), p = Math.floor(u / c);
                d && !r.config.xaxis.convertedCatToNumeric && (f = Math.ceil(g / h), f -= 1);
                var x = null, b = null, v = r.globals.seriesXvalues.map(function(t) {
                    return t.filter(function(t) {
                        return m.isNumber(t);
                    });
                }), y = r.globals.seriesYvalues.map(function(t) {
                    return t.filter(function(t) {
                        return m.isNumber(t);
                    });
                });
                if (r.globals.isXNumeric) {
                    var w = this.ttCtx.getElGrid().getBoundingClientRect(), k = g * (w.width / n), A = u * (w.height / l);
                    x = (b = this.closestInMultiArray(k, A, v, y)).index, f = b.j, null !== x && (v = r.globals.seriesXvalues[x], f = (b = this.closestInArray(k, v)).index);
                }
                return r.globals.capturedSeriesIndex = null === x ? -1 : x, (!f || f < 1) && (f = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = p : r.globals.capturedDataPointIndex = f, {
                    capturedSeries: x,
                    j: r.globals.isBarHorizontal ? p : f,
                    hoverX: g,
                    hoverY: u
                };
            }
        },
        {
            key: "closestInMultiArray",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = null, n = -1;
                s.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : o = 0;
                var l = i[r][0], h = Math.abs(t - l);
                if (i.forEach(function(e) {
                    e.forEach(function(e, i) {
                        var a = Math.abs(t - e);
                        a <= h && (h = a, n = i);
                    });
                }), -1 !== n) {
                    var c = a[r][n], d = Math.abs(e - c);
                    o = r, a.forEach(function(t, i) {
                        var a = Math.abs(e - t[n]);
                        a <= d && (d = a, o = i);
                    });
                }
                return {
                    index: o,
                    j: n
                };
            }
        },
        {
            key: "getFirstActiveXArray",
            value: function(t) {
                for(var e = this.w, i = 0, a = t.map(function(t, e) {
                    return t.length > 0 ? e : -1;
                }), s = 0; s < a.length; s++)if (-1 !== a[s] && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)) {
                    i = a[s];
                    break;
                }
                return i;
            }
        },
        {
            key: "closestInArray",
            value: function(t, e) {
                for(var i = e[0], a = null, s = Math.abs(t - i), r = 0; r < e.length; r++){
                    var o = Math.abs(t - e[r]);
                    o < s && (s = o, a = r);
                }
                return {
                    index: a
                };
            }
        },
        {
            key: "isXoverlap",
            value: function(t) {
                var e = [], i = this.w.globals.seriesX.filter(function(t) {
                    return void 0 !== t[0];
                });
                if (i.length > 0) for(var a = 0; a < i.length - 1; a++)void 0 !== i[a][t] && void 0 !== i[a + 1][t] && i[a][t] !== i[a + 1][t] && e.push("unEqual");
                return 0 === e.length;
            }
        },
        {
            key: "isInitialSeriesSameLen",
            value: function() {
                for(var t = !0, e = this.w.globals.initialSeries, i = 0; i < e.length - 1; i++)if (e[i].data.length !== e[i + 1].data.length) {
                    t = !1;
                    break;
                }
                return t;
            }
        },
        {
            key: "getBarsHeight",
            value: function(t) {
                return p(t).reduce(function(t, e) {
                    return t + e.getBBox().height;
                }, 0);
            }
        },
        {
            key: "getElMarkers",
            value: function(t) {
                return "number" == typeof t ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
            }
        },
        {
            key: "getAllMarkers",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                (t = p(t)).sort(function(t, e) {
                    var i = Number(t.getAttribute("data:realIndex")), a = Number(e.getAttribute("data:realIndex"));
                    return a < i ? 1 : a > i ? -1 : 0;
                });
                var e = [];
                return t.forEach(function(t) {
                    e.push(t.querySelector(".apexcharts-marker"));
                }), e;
            }
        },
        {
            key: "hasMarkers",
            value: function(t) {
                return this.getElMarkers(t).length > 0;
            }
        },
        {
            key: "getPathFromPoint",
            value: function(t, e) {
                var i = Number(t.getAttribute("cx")), a = Number(t.getAttribute("cy")), s = t.getAttribute("shape");
                return new k(this.ctx).getMarkerPath(i, a, s, e);
            }
        },
        {
            key: "getElBars",
            value: function() {
                return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
            }
        },
        {
            key: "hasBars",
            value: function() {
                return this.getElBars().length > 0;
            }
        },
        {
            key: "getHoverMarkerSize",
            value: function(t) {
                var e = this.w, i = e.config.markers.hover.size;
                return void 0 === i && (i = e.globals.markers.size[t] + e.config.markers.hover.sizeOffset), i;
            }
        },
        {
            key: "toggleAllTooltipSeriesGroups",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                0 === i.allTooltipSeriesGroups.length && (i.allTooltipSeriesGroups = e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)"enable" === t ? (a[s].classList.add("apexcharts-active"), a[s].style.display = e.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
            }
        }
    ]), t;
}(), xt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new pt(e);
    }
    return s(t, [
        {
            key: "drawSeriesTexts",
            value: function(t) {
                var e = t.shared, i = void 0 === e || e, a = t.ttItems, s = t.i, r = void 0 === s ? 0 : s, o = t.j, n = void 0 === o ? null : o, l = t.y1, h = t.y2, c = t.e, d = this.w;
                void 0 !== d.config.tooltip.custom ? this.handleCustomTooltip({
                    i: r,
                    j: n,
                    y1: l,
                    y2: h,
                    w: d
                }) : this.toggleActiveInactiveSeries(i, r);
                var g = this.getValuesToPrint({
                    i: r,
                    j: n
                });
                this.printLabels({
                    i: r,
                    j: n,
                    values: g,
                    ttItems: a,
                    shared: i,
                    e: c
                });
                var u = this.ttCtx.getElTooltip();
                this.ttCtx.tooltipRect.ttWidth = u.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = u.getBoundingClientRect().height;
            }
        },
        {
            key: "printLabels",
            value: function(t) {
                var e, i = this, a = t.i, s = t.j, r = t.values, o = t.ttItems, n = t.shared, l = t.e, h = this.w, c = [], d = function(t) {
                    return h.globals.seriesGoals[t] && h.globals.seriesGoals[t][s] && Array.isArray(h.globals.seriesGoals[t][s]);
                }, u = r.xVal, f = r.zVal, p = r.xAxisTTVal, x = "", b = h.globals.colors[a];
                null !== s && h.config.plotOptions.bar.distributed && (b = h.globals.colors[s]);
                for(var v = function(t, r) {
                    var v = i.getFormatters(a);
                    x = i.getSeriesName({
                        fn: v.yLbTitleFormatter,
                        index: a,
                        seriesIndex: a,
                        j: s
                    }), "treemap" === h.config.chart.type && (x = v.yLbTitleFormatter(String(h.config.series[a].data[s].x), {
                        series: h.globals.series,
                        seriesIndex: a,
                        dataPointIndex: s,
                        w: h
                    }));
                    var m = h.config.tooltip.inverseOrder ? r : t;
                    if (h.globals.axisCharts) {
                        var y = function(t) {
                            var e, i, a, r;
                            return h.globals.isRangeData ? v.yLbFormatter(null === (e = h.globals.seriesRangeStart) || void 0 === e || null === (i = e[t]) || void 0 === i ? void 0 : i[s], {
                                series: h.globals.seriesRangeStart,
                                seriesIndex: t,
                                dataPointIndex: s,
                                w: h
                            }) + " - " + v.yLbFormatter(null === (a = h.globals.seriesRangeEnd) || void 0 === a || null === (r = a[t]) || void 0 === r ? void 0 : r[s], {
                                series: h.globals.seriesRangeEnd,
                                seriesIndex: t,
                                dataPointIndex: s,
                                w: h
                            }) : v.yLbFormatter(h.globals.series[t][s], {
                                series: h.globals.series,
                                seriesIndex: t,
                                dataPointIndex: s,
                                w: h
                            });
                        };
                        if (n) v = i.getFormatters(m), x = i.getSeriesName({
                            fn: v.yLbTitleFormatter,
                            index: m,
                            seriesIndex: a,
                            j: s
                        }), b = h.globals.colors[m], e = y(m), d(m) && (c = h.globals.seriesGoals[m][s].map(function(t) {
                            return {
                                attrs: t,
                                val: v.yLbFormatter(t.value, {
                                    seriesIndex: m,
                                    dataPointIndex: s,
                                    w: h
                                })
                            };
                        }));
                        else {
                            var w, k = null == l || null === (w = l.target) || void 0 === w ? void 0 : w.getAttribute("fill");
                            k && (-1 !== k.indexOf("url") ? -1 !== k.indexOf("Pattern") && (b = h.globals.dom.baseEl.querySelector(k.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke")) : b = k), e = y(a), d(a) && Array.isArray(h.globals.seriesGoals[a][s]) && (c = h.globals.seriesGoals[a][s].map(function(t) {
                                return {
                                    attrs: t,
                                    val: v.yLbFormatter(t.value, {
                                        seriesIndex: a,
                                        dataPointIndex: s,
                                        w: h
                                    })
                                };
                            }));
                        }
                    }
                    null === s && (e = v.yLbFormatter(h.globals.series[a], g(g({}, h), {}, {
                        seriesIndex: a,
                        dataPointIndex: a
                    }))), i.DOMHandling({
                        i: a,
                        t: m,
                        j: s,
                        ttItems: o,
                        values: {
                            val: e,
                            goalVals: c,
                            xVal: u,
                            xAxisTTVal: p,
                            zVal: f
                        },
                        seriesName: x,
                        shared: n,
                        pColor: b
                    });
                }, m = 0, y = h.globals.series.length - 1; m < h.globals.series.length; m++, y--)v(m, y);
            }
        },
        {
            key: "getFormatters",
            value: function(t) {
                var e, i = this.w, a = i.globals.yLabelFormatters[t];
                return void 0 !== i.globals.ttVal ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[t] && i.globals.ttVal[t].formatter, e = i.globals.ttVal[t] && i.globals.ttVal[t].title && i.globals.ttVal[t].title.formatter) : (a = i.globals.ttVal.formatter, "function" == typeof i.globals.ttVal.title.formatter && (e = i.globals.ttVal.title.formatter)) : e = i.config.tooltip.y.title.formatter, "function" != typeof a && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(t) {
                    return t;
                }), "function" != typeof e && (e = function(t) {
                    return t;
                }), {
                    yLbFormatter: a,
                    yLbTitleFormatter: e
                };
            }
        },
        {
            key: "getSeriesName",
            value: function(t) {
                var e = t.fn, i = t.index, a = t.seriesIndex, s = t.j, r = this.w;
                return e(String(r.globals.seriesNames[i]), {
                    series: r.globals.series,
                    seriesIndex: a,
                    dataPointIndex: s,
                    w: r
                });
            }
        },
        {
            key: "DOMHandling",
            value: function(t) {
                t.i;
                var e = t.t, i = t.j, a = t.ttItems, s = t.values, r = t.seriesName, o = t.shared, n = t.pColor, l = this.w, h = this.ttCtx, c = s.val, d = s.goalVals, g = s.xVal, u = s.xAxisTTVal, f = s.zVal, p = null;
                p = a[e].children, l.config.tooltip.fillSeriesColor && (a[e].style.backgroundColor = n, p[0].style.display = "none"), h.showTooltipTitle && (null === h.tooltipTitle && (h.tooltipTitle = l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), h.tooltipTitle.innerHTML = g), h.isXAxisTooltipEnabled && (h.xaxisTooltipText.innerHTML = "" !== u ? u : g);
                var x = a[e].querySelector(".apexcharts-tooltip-text-y-label");
                x && (x.innerHTML = r || "");
                var b = a[e].querySelector(".apexcharts-tooltip-text-y-value");
                b && (b.innerHTML = void 0 !== c ? c : ""), p[0] && p[0].classList.contains("apexcharts-tooltip-marker") && (l.config.tooltip.marker.fillColors && Array.isArray(l.config.tooltip.marker.fillColors) && (n = l.config.tooltip.marker.fillColors[e]), p[0].style.backgroundColor = n), l.config.tooltip.marker.show || (p[0].style.display = "none");
                var v = a[e].querySelector(".apexcharts-tooltip-text-goals-label"), m = a[e].querySelector(".apexcharts-tooltip-text-goals-value");
                if (d.length && l.globals.seriesGoals[e]) {
                    var y = function() {
                        var t = "<div >", e = "<div>";
                        d.forEach(function(i, a) {
                            t += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name, "</div>"), e += "<div>".concat(i.val, "</div>");
                        }), v.innerHTML = t + "</div>", m.innerHTML = e + "</div>";
                    };
                    o ? l.globals.seriesGoals[e][i] && Array.isArray(l.globals.seriesGoals[e][i]) ? y() : (v.innerHTML = "", m.innerHTML = "") : y();
                } else v.innerHTML = "", m.innerHTML = "";
                null !== f && (a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = l.config.tooltip.z.title, a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = void 0 !== f ? f : "");
                if (o && p[0]) {
                    if (l.config.tooltip.hideEmptySeries) {
                        var w = a[e].querySelector(".apexcharts-tooltip-marker"), k = a[e].querySelector(".apexcharts-tooltip-text");
                        0 == parseFloat(c) ? (w.style.display = "none", k.style.display = "none") : (w.style.display = "block", k.style.display = "block");
                    }
                    null == c || l.globals.ancillaryCollapsedSeriesIndices.indexOf(e) > -1 || l.globals.collapsedSeriesIndices.indexOf(e) > -1 || Array.isArray(h.tConfig.enabledOnSeries) && -1 === h.tConfig.enabledOnSeries.indexOf(e) ? p[0].parentNode.style.display = "none" : p[0].parentNode.style.display = l.config.tooltip.items.display;
                } else Array.isArray(h.tConfig.enabledOnSeries) && -1 === h.tConfig.enabledOnSeries.indexOf(e) && (p[0].parentNode.style.display = "none");
            }
        },
        {
            key: "toggleActiveInactiveSeries",
            value: function(t, e) {
                var i = this.w;
                if (t) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                else {
                    this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                    var a = i.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group-".concat(e));
                    a && (a.classList.add("apexcharts-active"), a.style.display = i.config.tooltip.items.display);
                }
            }
        },
        {
            key: "getValuesToPrint",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", o = "", n = null, l = null, h = {
                    series: a.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }, c = a.globals.ttZFormatter;
                null === i ? l = a.globals.series[e] : a.globals.isXNumeric && "treemap" !== a.config.chart.type ? (r = s[e][i], 0 === s[e].length && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = new _(this.ctx).isFormatXY() ? void 0 !== a.config.series[e].data[i] ? a.config.series[e].data[i].x : "" : void 0 !== a.globals.labels[i] ? a.globals.labels[i] : "";
                var d = r;
                a.globals.isXNumeric && "datetime" === a.config.xaxis.type ? r = new P(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, d, d, {
                    i: void 0,
                    dateFormatter: new L(this.ctx).formatDate,
                    w: this.w
                }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](d, h) : a.globals.xLabelFormatter(d, h);
                return void 0 !== a.config.tooltip.x.formatter && (r = a.globals.ttKeyFormatter(d, h)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[e].length > 0 && (n = c(a.globals.seriesZ[e][i], a)), o = "function" == typeof a.config.xaxis.tooltip.formatter ? a.globals.xaxisTooltipFormatter(d, h) : r, {
                    val: Array.isArray(l) ? l.join(" ") : l,
                    xVal: Array.isArray(r) ? r.join(" ") : r,
                    xAxisTTVal: Array.isArray(o) ? o.join(" ") : o,
                    zVal: n
                };
            }
        },
        {
            key: "handleCustomTooltip",
            value: function(t) {
                var e = t.i, i = t.j, a = t.y1, s = t.y2, r = t.w, o = this.ttCtx.getElTooltip(), n = r.config.tooltip.custom;
                Array.isArray(n) && n[e] && (n = n[e]), o.innerHTML = n({
                    ctx: this.ctx,
                    series: r.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    y1: a,
                    y2: s,
                    w: r
                });
            }
        }
    ]), t;
}(), bt = function() {
    function t(e) {
        i(this, t), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
    }
    return s(t, [
        {
            key: "moveXCrosshairs",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = t - i.xcrosshairsWidth / 2, o = a.globals.labels.slice().length;
                if (null !== e && (r = a.globals.gridWidth / o * e), null === s || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                    var n = r;
                    "tickWidth" !== a.config.xaxis.crosshairs.width && "barWidth" !== a.config.xaxis.crosshairs.width || (n = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(n);
                }
            }
        },
        {
            key: "moveYCrosshairs",
            value: function(t) {
                var e = this.ttCtx;
                null !== e.ycrosshairs && k.setAttrs(e.ycrosshairs, {
                    y1: t,
                    y2: t
                }), null !== e.ycrosshairsHidden && k.setAttrs(e.ycrosshairsHidden, {
                    y1: t,
                    y2: t
                });
            }
        },
        {
            key: "moveXAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                if (null !== i.xaxisTooltip && 0 !== i.xcrosshairsWidth) {
                    i.xaxisTooltip.classList.add("apexcharts-active");
                    var a = i.xaxisOffY + e.config.xaxis.tooltip.offsetY + e.globals.translateY + 1 + e.config.xaxis.offsetY;
                    if (t -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(t)) {
                        t += e.globals.translateX;
                        var s;
                        s = new k(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = t + "px", i.xaxisTooltip.style.top = a + "px";
                    }
                }
            }
        },
        {
            key: "moveYAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                null === i.yaxisTTEls && (i.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = e.globals.translateY + a, r = i.yaxisTTEls[t].getBoundingClientRect().height, o = e.globals.translateYAxisX[t] - 2;
                e.config.yaxis[t].opposite && (o -= 26), s -= r / 2, -1 === e.globals.ignoreYAxisIndexes.indexOf(t) ? (i.yaxisTTEls[t].classList.add("apexcharts-active"), i.yaxisTTEls[t].style.top = s + "px", i.yaxisTTEls[t].style.left = o + e.config.yaxis[t].tooltip.offsetX + "px") : i.yaxisTTEls[t].classList.remove("apexcharts-active");
            }
        },
        {
            key: "moveTooltip",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), o = s.tooltipRect, n = null !== i ? parseFloat(i) : 1, l = parseFloat(t) + n + 5, h = parseFloat(e) + n / 2;
                if (l > a.globals.gridWidth / 2 && (l = l - o.ttWidth - n - 10), l > a.globals.gridWidth - o.ttWidth - 10 && (l = a.globals.gridWidth - o.ttWidth), l < -20 && (l = -20), a.config.tooltip.followCursor) {
                    var c = s.getElGrid().getBoundingClientRect();
                    (l = s.e.clientX - c.left) > a.globals.gridWidth / 2 && (l -= s.tooltipRect.ttWidth), (h = s.e.clientY + a.globals.translateY - c.top) > a.globals.gridHeight / 2 && (h -= s.tooltipRect.ttHeight);
                } else a.globals.isBarHorizontal || o.ttHeight / 2 + h > a.globals.gridHeight && (h = a.globals.gridHeight - o.ttHeight + a.globals.translateY);
                isNaN(l) || (l += a.globals.translateX, r.style.left = l + "px", r.style.top = h + "px");
            }
        },
        {
            key: "moveMarkers",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx;
                if (i.globals.markers.size[t] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === e && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(e, s[r]));
                else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(e, t);
            }
        },
        {
            key: "moveDynamicPointOnHover",
            value: function(t, e) {
                var i, a, s, r, o = this.w, n = this.ttCtx, l = new k(this.ctx), h = o.globals.pointsArray, c = n.tooltipUtil.getHoverMarkerSize(e), d = o.config.series[e].type;
                if (!d || "column" !== d && "candlestick" !== d && "boxPlot" !== d) {
                    s = null === (i = h[e][t]) || void 0 === i ? void 0 : i[0], r = (null === (a = h[e][t]) || void 0 === a ? void 0 : a[1]) || 0;
                    var g = o.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers path"));
                    if (g && r < o.globals.gridHeight && r > 0) {
                        var u = g.getAttribute("shape"), f = l.getMarkerPath(s, r, u, 1.5 * c);
                        g.setAttribute("d", f);
                    }
                    this.moveXCrosshairs(s), n.fixedTooltip || this.moveTooltip(s, r, c);
                }
            }
        },
        {
            key: "moveDynamicPointsOnHover",
            value: function(t) {
                var e, i = this.ttCtx, a = i.w, s = 0, r = 0, o = a.globals.pointsArray, n = new V(this.ctx), l = new k(this.ctx);
                e = n.getActiveConfigSeriesIndex("asc", [
                    "line",
                    "area",
                    "scatter",
                    "bubble"
                ]);
                var h = i.tooltipUtil.getHoverMarkerSize(e);
                o[e] && (s = o[e][t][0], r = o[e][t][1]);
                var c = i.tooltipUtil.getAllMarkers();
                if (null !== c) for(var d = 0; d < a.globals.series.length; d++){
                    var g = o[d];
                    if (a.globals.comboCharts && void 0 === g && c.splice(d, 0, null), g && g.length) {
                        var u = o[d][t][1], f = void 0;
                        c[d].setAttribute("cx", s);
                        var p = c[d].getAttribute("shape");
                        if ("rangeArea" === a.config.chart.type && !a.globals.comboCharts) {
                            var x = t + a.globals.series[d].length;
                            f = o[d][x][1], u -= Math.abs(u - f) / 2;
                        }
                        if (null !== u && !isNaN(u) && u < a.globals.gridHeight + h && u + h > 0) {
                            var b = l.getMarkerPath(s, u, p, h);
                            c[d].setAttribute("d", b);
                        } else c[d].setAttribute("d", "");
                    }
                }
                this.moveXCrosshairs(s), i.fixedTooltip || this.moveTooltip(s, r || a.globals.gridHeight, h);
            }
        },
        {
            key: "moveStickyTooltipOverBars",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx, s = i.globals.columnSeries ? i.globals.columnSeries.length : i.globals.series.length, r = s >= 2 && s % 2 == 0 ? Math.floor(s / 2) : Math.floor(s / 2) + 1;
                i.globals.isBarHorizontal && (r = new V(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
                var o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r, "'] path[j='").concat(t, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "']"));
                o || "number" != typeof e || (o = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "']")));
                var n = o ? parseFloat(o.getAttribute("cx")) : 0, l = o ? parseFloat(o.getAttribute("cy")) : 0, h = o ? parseFloat(o.getAttribute("barWidth")) : 0, c = a.getElGrid().getBoundingClientRect(), d = o && (o.classList.contains("apexcharts-candlestick-area") || o.classList.contains("apexcharts-boxPlot-area"));
                i.globals.isXNumeric ? (o && !d && (n -= s % 2 != 0 ? h / 2 : 0), o && d && i.globals.comboCharts && (n -= h / 2)) : i.globals.isBarHorizontal || (n = a.xAxisTicksPositions[t - 1] + a.dataPointsDividedWidth / 2, isNaN(n) && (n = a.xAxisTicksPositions[t] - a.dataPointsDividedWidth / 2)), i.globals.isBarHorizontal ? l -= a.tooltipRect.ttHeight : i.config.tooltip.followCursor ? l = a.e.clientY - c.top - a.tooltipRect.ttHeight / 2 : l + a.tooltipRect.ttHeight + 15 > i.globals.gridHeight && (l = i.globals.gridHeight), i.globals.isBarHorizontal || this.moveXCrosshairs(n), a.fixedTooltip || this.moveTooltip(n, l || i.globals.gridHeight);
            }
        }
    ]), t;
}(), vt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new bt(e);
    }
    return s(t, [
        {
            key: "drawDynamicPoints",
            value: function() {
                var t = this.w, e = new k(this.ctx), i = new W(this.ctx), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                a = p(a), t.config.chart.stacked && a.sort(function(t, e) {
                    return parseFloat(t.getAttribute("data:realIndex")) - parseFloat(e.getAttribute("data:realIndex"));
                });
                for(var s = 0; s < a.length; s++){
                    var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                    if (null !== r) {
                        var o = void 0, n = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                        "line" !== t.config.chart.type && "area" !== t.config.chart.type || t.globals.comboCharts || t.config.tooltip.intersect || (n += " no-pointer-events");
                        var l = i.getMarkerConfig({
                            cssClass: n,
                            seriesIndex: Number(r.getAttribute("data:realIndex"))
                        });
                        (o = e.drawMarker(0, 0, l)).node.setAttribute("default-marker-size", 0);
                        var h = document.createElementNS(t.globals.SVGNS, "g");
                        h.classList.add("apexcharts-series-markers"), h.appendChild(o.node), r.appendChild(h);
                    }
                }
            }
        },
        {
            key: "enlargeCurrentPoint",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w;
                "bubble" !== s.config.chart.type && this.newPointSize(t, e);
                var r = e.getAttribute("cx"), o = e.getAttribute("cy");
                if (null !== i && null !== a && (r = i, o = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                    if ("radar" === s.config.chart.type) {
                        var n = this.ttCtx.getElGrid().getBoundingClientRect();
                        r = this.ttCtx.e.clientX - n.left;
                    }
                    this.tooltipPosition.moveTooltip(r, o, s.config.markers.hover.size);
                }
            }
        },
        {
            key: "enlargePoints",
            value: function(t) {
                for(var e = this.w, i = this, a = this.ttCtx, s = t, r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), o = e.config.markers.hover.size, n = 0; n < r.length; n++){
                    var l = r[n].getAttribute("rel"), h = r[n].getAttribute("index");
                    if (void 0 === o && (o = e.globals.markers.size[h] + e.config.markers.hover.sizeOffset), s === parseInt(l, 10)) {
                        i.newPointSize(s, r[n]);
                        var c = r[n].getAttribute("cx"), d = r[n].getAttribute("cy");
                        i.tooltipPosition.moveXCrosshairs(c), a.fixedTooltip || i.tooltipPosition.moveTooltip(c, d, o);
                    } else i.oldPointSize(r[n]);
                }
            }
        },
        {
            key: "newPointSize",
            value: function(t, e) {
                var i = this.w, a = i.config.markers.hover.size, s = 0 === t ? e.parentNode.firstChild : e.parentNode.lastChild;
                if ("0" !== s.getAttribute("default-marker-size")) {
                    var r = parseInt(s.getAttribute("index"), 10);
                    void 0 === a && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0);
                    var o = this.ttCtx.tooltipUtil.getPathFromPoint(e, a);
                    e.setAttribute("d", o);
                }
            }
        },
        {
            key: "oldPointSize",
            value: function(t) {
                var e = parseFloat(t.getAttribute("default-marker-size")), i = this.ttCtx.tooltipUtil.getPathFromPoint(t, e);
                t.setAttribute("d", i);
            }
        },
        {
            key: "resetPointsSize",
            value: function() {
                for(var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), e = 0; e < t.length; e++){
                    var i = parseFloat(t[e].getAttribute("default-marker-size"));
                    if (m.isNumber(i) && i >= 0) {
                        var a = this.ttCtx.tooltipUtil.getPathFromPoint(t[e], i);
                        t[e].setAttribute("d", a);
                    } else t[e].setAttribute("d", "M0,0");
                }
            }
        }
    ]), t;
}(), mt = function() {
    function t(e) {
        i(this, t), this.w = e.w;
        var a = this.w;
        this.ttCtx = e, this.isVerticalGroupedRangeBar = !a.globals.isBarHorizontal && "rangeBar" === a.config.chart.type && a.config.plotOptions.bar.rangeBarGroupRows;
    }
    return s(t, [
        {
            key: "getAttr",
            value: function(t, e) {
                return parseFloat(t.target.getAttribute(e));
            }
        },
        {
            key: "handleHeatTreeTooltip",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.x, s = t.y, r = t.type, o = this.ttCtx, n = this.w;
                if (e.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                    var l = this.getAttr(e, "i"), h = this.getAttr(e, "j"), c = this.getAttr(e, "cx"), d = this.getAttr(e, "cy"), g = this.getAttr(e, "width"), u = this.getAttr(e, "height");
                    if (o.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: l,
                        j: h,
                        shared: !1,
                        e: e
                    }), n.globals.capturedSeriesIndex = l, n.globals.capturedDataPointIndex = h, a = c + o.tooltipRect.ttWidth / 2 + g, s = d + o.tooltipRect.ttHeight / 2 - u / 2, o.tooltipPosition.moveXCrosshairs(c + g / 2), a > n.globals.gridWidth / 2 && (a = c - o.tooltipRect.ttWidth / 2 + g), o.w.config.tooltip.followCursor) {
                        var f = n.globals.dom.elWrap.getBoundingClientRect();
                        a = n.globals.clientX - f.left - (a > n.globals.gridWidth / 2 ? o.tooltipRect.ttWidth : 0), s = n.globals.clientY - f.top - (s > n.globals.gridHeight / 2 ? o.tooltipRect.ttHeight : 0);
                    }
                }
                return {
                    x: a,
                    y: s
                };
            }
        },
        {
            key: "handleMarkerTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = t.x, o = t.y, n = this.w, l = this.ttCtx;
                if (a.target.classList.contains("apexcharts-marker")) {
                    var h = parseInt(s.paths.getAttribute("cx"), 10), c = parseInt(s.paths.getAttribute("cy"), 10), d = parseFloat(s.paths.getAttribute("val"));
                    if (i = parseInt(s.paths.getAttribute("rel"), 10), e = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, l.intersect) {
                        var g = m.findAncestor(s.paths, "apexcharts-series");
                        g && (e = parseInt(g.getAttribute("data:realIndex"), 10));
                    }
                    if (l.tooltipLabels.drawSeriesTexts({
                        ttItems: s.ttItems,
                        i: e,
                        j: i,
                        shared: !l.showOnIntersect && n.config.tooltip.shared,
                        e: a
                    }), "mouseup" === a.type && l.markerClick(a, e, i), n.globals.capturedSeriesIndex = e, n.globals.capturedDataPointIndex = i, r = h, o = c + n.globals.translateY - 1.4 * l.tooltipRect.ttHeight, l.w.config.tooltip.followCursor) {
                        var u = l.getElGrid().getBoundingClientRect();
                        o = l.e.clientY + n.globals.translateY - u.top;
                    }
                    d < 0 && (o = c), l.marker.enlargeCurrentPoint(i, s.paths, r, o);
                }
                return {
                    x: r,
                    y: o
                };
            }
        },
        {
            key: "handleBarTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = this.ttCtx, n = o.getElTooltip(), l = 0, h = 0, c = 0, d = this.getBarTooltipXY({
                    e: a,
                    opt: s
                });
                e = d.i;
                var g = d.j;
                r.globals.capturedSeriesIndex = e, r.globals.capturedDataPointIndex = g, r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (h = d.x, c = d.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[e] : r.config.stroke.width, l = h) : r.globals.comboCharts || r.config.tooltip.shared || (l /= 2), isNaN(c) && (c = r.globals.svgHeight - o.tooltipRect.ttHeight);
                var u = parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10);
                if (r.globals.isMultipleYAxis ? r.config.yaxis[u] && r.config.yaxis[u].reversed : r.config.yaxis[0].reversed, h + o.tooltipRect.ttWidth > r.globals.gridWidth ? h -= o.tooltipRect.ttWidth : h < 0 && (h = 0), o.w.config.tooltip.followCursor) {
                    var f = o.getElGrid().getBoundingClientRect();
                    c = o.e.clientY - f.top;
                }
                null === o.tooltip && (o.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? o.tooltipPosition.moveXCrosshairs(l + i / 2) : o.tooltipPosition.moveXCrosshairs(l)), !o.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && o.tooltipUtil.hasBars()) && (c = c + r.globals.translateY - o.tooltipRect.ttHeight / 2, n.style.left = h + r.globals.translateX + "px", n.style.top = c + "px");
            }
        },
        {
            key: "getBarTooltipXY",
            value: function(t) {
                var e = this, i = t.e, a = t.opt, s = this.w, r = null, o = this.ttCtx, n = 0, l = 0, h = 0, c = 0, d = 0, g = i.target.classList;
                if (g.contains("apexcharts-bar-area") || g.contains("apexcharts-candlestick-area") || g.contains("apexcharts-boxPlot-area") || g.contains("apexcharts-rangebar-area")) {
                    var u = i.target, f = u.getBoundingClientRect(), p = a.elGrid.getBoundingClientRect(), x = f.height;
                    d = f.height;
                    var b = f.width, v = parseInt(u.getAttribute("cx"), 10), m = parseInt(u.getAttribute("cy"), 10);
                    c = parseFloat(u.getAttribute("barWidth"));
                    var y = "touchmove" === i.type ? i.touches[0].clientX : i.clientX;
                    r = parseInt(u.getAttribute("j"), 10), n = parseInt(u.parentNode.getAttribute("rel"), 10) - 1;
                    var w = u.getAttribute("data-range-y1"), k = u.getAttribute("data-range-y2");
                    s.globals.comboCharts && (n = parseInt(u.parentNode.getAttribute("data:realIndex"), 10));
                    var A = function(t) {
                        return s.globals.isXNumeric ? v - b / 2 : e.isVerticalGroupedRangeBar ? v + b / 2 : v - o.dataPointsDividedWidth + b / 2;
                    }, S = function() {
                        return m - o.dataPointsDividedHeight + x / 2 - o.tooltipRect.ttHeight / 2;
                    };
                    o.tooltipLabels.drawSeriesTexts({
                        ttItems: a.ttItems,
                        i: n,
                        j: r,
                        y1: w ? parseInt(w, 10) : null,
                        y2: k ? parseInt(k, 10) : null,
                        shared: !o.showOnIntersect && s.config.tooltip.shared,
                        e: i
                    }), s.config.tooltip.followCursor ? s.globals.isBarHorizontal ? (l = y - p.left + 15, h = S()) : (l = A(), h = i.clientY - p.top - o.tooltipRect.ttHeight / 2 - 15) : s.globals.isBarHorizontal ? ((l = v) < o.xyRatios.baseLineInvertedY && (l = v - o.tooltipRect.ttWidth), h = S()) : (l = A(), h = m);
                }
                return {
                    x: l,
                    y: h,
                    barHeight: d,
                    barWidth: c,
                    i: n,
                    j: r
                };
            }
        }
    ]), t;
}(), yt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.ttCtx = e;
    }
    return s(t, [
        {
            key: "drawXaxisTooltip",
            value: function() {
                var t = this.w, e = this.ttCtx, i = "bottom" === t.config.xaxis.position;
                e.xaxisOffY = i ? t.globals.gridHeight + 1 : -t.globals.xAxisHeight - t.config.xaxis.axisTicks.height + 3;
                var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = t.globals.dom.elWrap;
                e.isXAxisTooltipEnabled && null === t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") && (e.xaxisTooltip = document.createElement("div"), e.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + t.config.tooltip.theme), s.appendChild(e.xaxisTooltip), e.xaxisTooltipText = document.createElement("div"), e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), e.xaxisTooltipText.style.fontFamily = t.config.xaxis.tooltip.style.fontFamily || t.config.chart.fontFamily, e.xaxisTooltipText.style.fontSize = t.config.xaxis.tooltip.style.fontSize, e.xaxisTooltip.appendChild(e.xaxisTooltipText));
            }
        },
        {
            key: "drawYaxisTooltip",
            value: function() {
                for(var t = this.w, e = this.ttCtx, i = 0; i < t.config.yaxis.length; i++){
                    var a = t.config.yaxis[i].opposite || t.config.yaxis[i].crosshairs.opposite;
                    e.yaxisOffX = a ? t.globals.gridWidth + 1 : 1;
                    var s = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i, a ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left"), r = t.globals.dom.elWrap;
                    null === t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i)) && (e.yaxisTooltip = document.createElement("div"), e.yaxisTooltip.setAttribute("class", s + " apexcharts-theme-" + t.config.tooltip.theme), r.appendChild(e.yaxisTooltip), 0 === i && (e.yaxisTooltipText = []), e.yaxisTooltipText[i] = document.createElement("div"), e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"), e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]));
                }
            }
        },
        {
            key: "setXCrosshairWidth",
            value: function() {
                var t = this.w, e = this.ttCtx, i = e.getElXCrosshairs();
                if (e.xcrosshairsWidth = parseInt(t.config.xaxis.crosshairs.width, 10), t.globals.comboCharts) {
                    var a = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== a && "barWidth" === t.config.xaxis.crosshairs.width) {
                        var s = parseFloat(a.getAttribute("barWidth"));
                        e.xcrosshairsWidth = s;
                    } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                        var r = t.globals.labels.length;
                        e.xcrosshairsWidth = t.globals.gridWidth / r;
                    }
                } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                    var o = t.globals.labels.length;
                    e.xcrosshairsWidth = t.globals.gridWidth / o;
                } else if ("barWidth" === t.config.xaxis.crosshairs.width) {
                    var n = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== n) {
                        var l = parseFloat(n.getAttribute("barWidth"));
                        e.xcrosshairsWidth = l;
                    } else e.xcrosshairsWidth = 1;
                }
                t.globals.isBarHorizontal && (e.xcrosshairsWidth = 0), null !== i && e.xcrosshairsWidth > 0 && i.setAttribute("width", e.xcrosshairsWidth);
            }
        },
        {
            key: "handleYCrosshair",
            value: function() {
                var t = this.w, e = this.ttCtx;
                e.ycrosshairs = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), e.ycrosshairsHidden = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
            }
        },
        {
            key: "drawYaxisTooltipText",
            value: function(t, e, i) {
                var a = this.ttCtx, s = this.w, r = s.globals, o = r.seriesYAxisMap[t];
                if (a.yaxisTooltips[t] && o.length > 0) {
                    var n = r.yLabelFormatters[t], l = a.getElGrid().getBoundingClientRect(), h = o[0], c = 0;
                    i.yRatio.length > 1 && (c = h);
                    var d = (e - l.top) * i.yRatio[c], g = r.maxYArr[h] - r.minYArr[h], u = r.minYArr[h] + (g - d);
                    s.config.yaxis[t].reversed && (u = r.maxYArr[h] - (g - d)), a.tooltipPosition.moveYCrosshairs(e - l.top), a.yaxisTooltipText[t].innerHTML = n(u), a.tooltipPosition.moveYAxisTooltip(t);
                }
            }
        }
    ]), t;
}(), wt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.tConfig = a.config.tooltip, this.tooltipUtil = new pt(this), this.tooltipLabels = new xt(this), this.tooltipPosition = new bt(this), this.marker = new vt(this), this.intersect = new mt(this), this.axesTooltip = new yt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !a.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
    }
    return s(t, [
        {
            key: "getElTooltip",
            value: function(t) {
                return t || (t = this), t.w.globals.dom.baseEl ? t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
            }
        },
        {
            key: "getElXCrosshairs",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
            }
        },
        {
            key: "getElGrid",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
            }
        },
        {
            key: "drawTooltip",
            value: function(t) {
                var e = this.w;
                this.xyRatios = t, this.isXAxisTooltipEnabled = e.config.xaxis.tooltip.enabled && e.globals.axisCharts, this.yaxisTooltips = e.config.yaxis.map(function(t, i) {
                    return !!(t.show && t.tooltip.enabled && e.globals.axisCharts);
                }), this.allTooltipSeriesGroups = [], e.globals.axisCharts || (this.showTooltipTitle = !1);
                var i = document.createElement("div");
                if (i.classList.add("apexcharts-tooltip"), e.config.tooltip.cssClass && i.classList.add(e.config.tooltip.cssClass), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), e.globals.dom.elWrap.appendChild(i), e.globals.axisCharts) {
                    this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                    var a = new q(this.ctx);
                    this.xAxisTicksPositions = a.getXAxisTicksPositions();
                }
                if (!e.globals.comboCharts && !this.tConfig.intersect && "rangeBar" !== e.config.chart.type || this.tConfig.shared || (this.showOnIntersect = !0), 0 !== e.config.markers.size && 0 !== e.globals.markers.largestSize || this.marker.drawDynamicPoints(this), e.globals.collapsedSeries.length !== e.globals.series.length) {
                    this.dataPointsDividedHeight = e.globals.gridHeight / e.globals.dataPoints, this.dataPointsDividedWidth = e.globals.gridWidth / e.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                    var s = e.globals.series.length;
                    (e.globals.xyCharts || e.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : e.globals.series.length), this.legendLabels = e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                }
            }
        },
        {
            key: "createTTElements",
            value: function(t) {
                for(var e = this, i = this.w, a = [], s = this.getElTooltip(), r = function(r) {
                    var o = document.createElement("div");
                    o.classList.add("apexcharts-tooltip-series-group", "apexcharts-tooltip-series-group-".concat(r)), o.style.order = i.config.tooltip.inverseOrder ? t - r : r + 1;
                    var n = document.createElement("span");
                    n.classList.add("apexcharts-tooltip-marker"), n.style.backgroundColor = i.globals.colors[r], o.appendChild(n);
                    var l = document.createElement("div");
                    l.classList.add("apexcharts-tooltip-text"), l.style.fontFamily = e.tConfig.style.fontFamily || i.config.chart.fontFamily, l.style.fontSize = e.tConfig.style.fontSize, [
                        "y",
                        "goals",
                        "z"
                    ].forEach(function(t) {
                        var e = document.createElement("div");
                        e.classList.add("apexcharts-tooltip-".concat(t, "-group"));
                        var i = document.createElement("span");
                        i.classList.add("apexcharts-tooltip-text-".concat(t, "-label")), e.appendChild(i);
                        var a = document.createElement("span");
                        a.classList.add("apexcharts-tooltip-text-".concat(t, "-value")), e.appendChild(a), l.appendChild(e);
                    }), o.appendChild(l), s.appendChild(o), a.push(o);
                }, o = 0; o < t; o++)r(o);
                return a;
            }
        },
        {
            key: "addSVGEvents",
            value: function() {
                var t = this.w, e = t.config.chart.type, i = this.getElTooltip(), a = !("bar" !== e && "candlestick" !== e && "boxPlot" !== e && "rangeBar" !== e), s = "area" === e || "line" === e || "scatter" === e || "bubble" === e || "radar" === e, r = t.globals.dom.Paper.node, o = this.getElGrid();
                o && (this.seriesBound = o.getBoundingClientRect());
                var n, l = [], h = [], c = {
                    hoverArea: r,
                    elGrid: o,
                    tooltipEl: i,
                    tooltipY: l,
                    tooltipX: h,
                    ttItems: this.ttItems
                };
                if (t.globals.axisCharts && (s ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : "heatmap" !== e && "treemap" !== e || (n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), n && n.length)) for(var d = 0; d < n.length; d++)l.push(n[d].getAttribute("cy")), h.push(n[d].getAttribute("cx"));
                if (t.globals.xyCharts && !this.showOnIntersect || t.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                    r
                ], c);
                else if (a && !t.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(c);
                else if (!t.globals.axisCharts || "heatmap" === e || "treemap" === e) {
                    var g = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    this.addPathsEventListeners(g, c);
                }
                if (this.showOnIntersect) {
                    var u = t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                    u.length > 0 && this.addPathsEventListeners(u, c), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(c);
                }
            }
        },
        {
            key: "drawFixedTooltipRect",
            value: function() {
                var t = this.w, e = this.getElTooltip(), i = e.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, o = this.tConfig.fixed.offsetY, n = this.tConfig.fixed.position.toLowerCase();
                return n.indexOf("right") > -1 && (r = r + t.globals.svgWidth - a + 10), n.indexOf("bottom") > -1 && (o = o + t.globals.svgHeight - s - 10), e.style.left = r + "px", e.style.top = o + "px", {
                    x: r,
                    y: o,
                    ttWidth: a,
                    ttHeight: s
                };
            }
        },
        {
            key: "addDatapointEventsListeners",
            value: function(t) {
                var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                this.addPathsEventListeners(e, t);
            }
        },
        {
            key: "addPathsEventListeners",
            value: function(t, e) {
                for(var i = this, a = function(a) {
                    var s = {
                        paths: t[a],
                        tooltipEl: e.tooltipEl,
                        tooltipY: e.tooltipY,
                        tooltipX: e.tooltipX,
                        elGrid: e.elGrid,
                        hoverArea: e.hoverArea,
                        ttItems: e.ttItems
                    };
                    [
                        "mousemove",
                        "mouseup",
                        "touchmove",
                        "mouseout",
                        "touchend"
                    ].map(function(e) {
                        return t[a].addEventListener(e, i.onSeriesHover.bind(i, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }, s = 0; s < t.length; s++)a(s);
            }
        },
        {
            key: "onSeriesHover",
            value: function(t, e) {
                var i = this, a = Date.now() - this.lastHoverTime;
                a >= 100 ? this.seriesHover(t, e) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                    i.seriesHover(t, e);
                }, 100 - a));
            }
        },
        {
            key: "seriesHover",
            value: function(t, e) {
                var i = this;
                this.lastHoverTime = Date.now();
                var a = [], s = this.w;
                s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || 0 === s.globals.dataPoints) || (a.length ? a.forEach(function(a) {
                    var s = i.getElTooltip(a), r = {
                        paths: t.paths,
                        tooltipEl: s,
                        tooltipY: t.tooltipY,
                        tooltipX: t.tooltipX,
                        elGrid: t.elGrid,
                        hoverArea: t.hoverArea,
                        ttItems: a.w.globals.tooltip.ttItems
                    };
                    a.w.globals.minX === i.w.globals.minX && a.w.globals.maxX === i.w.globals.maxX && a.w.globals.tooltip.seriesHoverByContext({
                        chartCtx: a,
                        ttCtx: a.w.globals.tooltip,
                        opt: r,
                        e: e
                    });
                }) : this.seriesHoverByContext({
                    chartCtx: this.ctx,
                    ttCtx: this.w.globals.tooltip,
                    opt: t,
                    e: e
                }));
            }
        },
        {
            key: "seriesHoverByContext",
            value: function(t) {
                var e = t.chartCtx, i = t.ttCtx, a = t.opt, s = t.e, r = e.w, o = this.getElTooltip(e);
                if (o) {
                    if (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: o.getBoundingClientRect().width,
                        ttHeight: o.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared) {
                        if (this.tConfig.onDatasetHover.highlightDataSeries) new V(e).toggleSeriesOnHover(s, s.target.parentNode);
                    }
                    i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    });
                }
            }
        },
        {
            key: "axisChartsTooltips",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = s.elGrid.getBoundingClientRect(), n = "touchmove" === a.type ? a.touches[0].clientX : a.clientX, l = "touchmove" === a.type ? a.touches[0].clientY : a.clientY;
                if (this.clientY = l, this.clientX = n, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, l < o.top || l > o.top + o.height) this.handleMouseOut(s);
                else {
                    if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                        var h = parseInt(s.paths.getAttribute("index"), 10);
                        if (this.tConfig.enabledOnSeries.indexOf(h) < 0) return void this.handleMouseOut(s);
                    }
                    var c = this.getElTooltip(), d = this.getElXCrosshairs(), g = [];
                    r.config.chart.group && (g = this.ctx.getSyncedCharts());
                    var u = r.globals.xyCharts || "bar" === r.config.chart.type && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                    if ("mousemove" === a.type || "touchmove" === a.type || "mouseup" === a.type) {
                        if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                        null !== d && d.classList.add("apexcharts-active");
                        var f = this.yaxisTooltips.filter(function(t) {
                            return !0 === t;
                        });
                        if (null !== this.ycrosshairs && f.length && this.ycrosshairs.classList.add("apexcharts-active"), u && !this.showOnIntersect || g.length > 1) this.handleStickyTooltip(a, n, l, s);
                        else if ("heatmap" === r.config.chart.type || "treemap" === r.config.chart.type) {
                            var p = this.intersect.handleHeatTreeTooltip({
                                e: a,
                                opt: s,
                                x: e,
                                y: i,
                                type: r.config.chart.type
                            });
                            e = p.x, i = p.y, c.style.left = e + "px", c.style.top = i + "px";
                        } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                            e: a,
                            opt: s
                        }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                            e: a,
                            opt: s,
                            x: e,
                            y: i
                        });
                        if (this.yaxisTooltips.length) for(var x = 0; x < r.config.yaxis.length; x++)this.axesTooltip.drawYaxisTooltipText(x, l, this.xyRatios);
                        r.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"), s.tooltipEl.classList.add("apexcharts-active");
                    } else "mouseout" !== a.type && "touchend" !== a.type || this.handleMouseOut(s);
                }
            }
        },
        {
            key: "nonAxisChartsTooltips",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), o = this.getElTooltip(), n = s.globals.dom.elWrap.getBoundingClientRect();
                if ("mousemove" === e.type || "touchmove" === e.type) {
                    s.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"), o.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: parseInt(r, 10) - 1,
                        shared: !1
                    });
                    var l = s.globals.clientX - n.left - a.ttWidth / 2, h = s.globals.clientY - n.top - a.ttHeight - 10;
                    if (o.style.left = l + "px", o.style.top = h + "px", s.config.legend.tooltipHoverFormatter) {
                        var c = r - 1, d = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"), {
                            seriesIndex: c,
                            dataPointIndex: c,
                            w: s
                        });
                        this.legendLabels[c].innerHTML = d;
                    }
                } else "mouseout" !== e.type && "touchend" !== e.type || (o.classList.remove("apexcharts-active"), s.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                }));
            }
        },
        {
            key: "handleStickyTooltip",
            value: function(t, e, i, a) {
                var s = this.w, r = this.tooltipUtil.getNearestValues({
                    context: this,
                    hoverArea: a.hoverArea,
                    elGrid: a.elGrid,
                    clientX: e,
                    clientY: i
                }), o = r.j, n = r.capturedSeries;
                s.globals.collapsedSeriesIndices.includes(n) && (n = null);
                var l = a.elGrid.getBoundingClientRect();
                if (r.hoverX < 0 || r.hoverX > l.width) this.handleMouseOut(a);
                else if (null !== n) this.handleStickyCapturedSeries(t, n, a, o);
                else if (this.tooltipUtil.isXoverlap(o) || s.globals.isBarHorizontal) {
                    var h = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, h, o, a.ttItems);
                }
            }
        },
        {
            key: "handleStickyCapturedSeries",
            value: function(t, e, i, a) {
                var s = this.w;
                if (!this.tConfig.shared && null === s.globals.series[e][a]) return void this.handleMouseOut(i);
                if (void 0 !== s.globals.series[e][a]) this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(t, this, e, a, i.ttItems) : this.create(t, this, e, a, i.ttItems, !1);
                else if (this.tooltipUtil.isXoverlap(a)) {
                    var r = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, r, a, i.ttItems);
                }
            }
        },
        {
            key: "deactivateHoverFilter",
            value: function() {
                for(var t = this.w, e = new k(this.ctx), i = t.globals.dom.Paper.select(".apexcharts-bar-area"), a = 0; a < i.length; a++)e.pathMouseLeave(i[a]);
            }
        },
        {
            key: "handleMouseOut",
            value: function(t) {
                var e = this.w, i = this.getElXCrosshairs();
                if (e.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"), t.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), "bubble" !== e.config.chart.type && this.marker.resetPointsSize(), null !== i && i.classList.remove("apexcharts-active"), null !== this.ycrosshairs && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                    null === this.yaxisTTEls && (this.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                }
                e.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                });
            }
        },
        {
            key: "markerClick",
            value: function(t, e, i) {
                var a = this.w;
                "function" == typeof a.config.chart.events.markerClick && a.config.chart.events.markerClick(t, this.ctx, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }), this.ctx.events.fireEvent("markerClick", [
                    t,
                    this.ctx,
                    {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: a
                    }
                ]);
            }
        },
        {
            key: "create",
            value: function(t, e, i, a, s) {
                var r, o, n, l, h, c, d, u, f, p, x, b, v, m, y, w, A = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, S = this.w, C = e;
                "mouseup" === t.type && this.markerClick(t, i, a), null === A && (A = this.tConfig.shared);
                var L = this.tooltipUtil.hasMarkers(i), P = this.tooltipUtil.getElBars();
                if (S.config.legend.tooltipHoverFormatter) {
                    var M = S.config.legend.tooltipHoverFormatter, I = Array.from(this.legendLabels);
                    I.forEach(function(t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e);
                    });
                    for(var T = 0; T < I.length; T++){
                        var z = I[T], X = parseInt(z.getAttribute("i"), 10), E = decodeURIComponent(z.getAttribute("data:default-text")), Y = M(E, {
                            seriesIndex: A ? X : i,
                            dataPointIndex: a,
                            w: S
                        });
                        if (A) z.innerHTML = S.globals.collapsedSeriesIndices.indexOf(X) < 0 ? Y : E;
                        else if (z.innerHTML = X === i ? Y : E, i === X) break;
                    }
                }
                var R = g(g({
                    ttItems: s,
                    i: i,
                    j: a
                }, void 0 !== (null === (r = S.globals.seriesRange) || void 0 === r || null === (o = r[i]) || void 0 === o || null === (n = o[a]) || void 0 === n || null === (l = n.y[0]) || void 0 === l ? void 0 : l.y1) && {
                    y1: null === (h = S.globals.seriesRange) || void 0 === h || null === (c = h[i]) || void 0 === c || null === (d = c[a]) || void 0 === d || null === (u = d.y[0]) || void 0 === u ? void 0 : u.y1
                }), void 0 !== (null === (f = S.globals.seriesRange) || void 0 === f || null === (p = f[i]) || void 0 === p || null === (x = p[a]) || void 0 === x || null === (b = x.y[0]) || void 0 === b ? void 0 : b.y2) && {
                    y2: null === (v = S.globals.seriesRange) || void 0 === v || null === (m = v[i]) || void 0 === m || null === (y = m[a]) || void 0 === y || null === (w = y.y[0]) || void 0 === w ? void 0 : w.y2
                });
                if (A) {
                    if (C.tooltipLabels.drawSeriesTexts(g(g({}, R), {}, {
                        shared: !this.showOnIntersect && this.tConfig.shared
                    })), L) S.globals.markers.largestSize > 0 ? C.marker.enlargePoints(a) : C.tooltipPosition.moveDynamicPointsOnHover(a);
                    else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(P), this.barSeriesHeight > 0)) {
                        var F = new k(this.ctx), D = S.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(a, "']"));
                        this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(a, i);
                        for(var H = 0; H < D.length; H++)F.pathMouseEnter(D[H]);
                    }
                } else C.tooltipLabels.drawSeriesTexts(g({
                    shared: !1
                }, R)), this.tooltipUtil.hasBars() && C.tooltipPosition.moveStickyTooltipOverBars(a, i), L && C.tooltipPosition.moveMarkers(i, a);
            }
        }
    ]), t;
}(), kt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
    }
    return s(t, [
        {
            key: "handleBarDataLabels",
            value: function(t) {
                var e, i, a = t.x, s = t.y, r = t.y1, o = t.y2, n = t.i, l = t.j, h = t.realIndex, c = t.columnGroupIndex, d = t.series, u = t.barHeight, f = t.barWidth, p = t.barXPosition, x = t.barYPosition, b = t.visibleSeries, v = t.renderedPath, m = this.w, y = new k(this.barCtx.ctx), w = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[h] : this.barCtx.strokeWidth;
                m.globals.isXNumeric && !m.globals.isBarHorizontal ? (e = a + parseFloat(f * (b + 1)), i = s + parseFloat(u * (b + 1)) - w) : (e = a + parseFloat(f * b), i = s + parseFloat(u * b));
                var A, S = null, C = a, L = s, P = {}, M = m.config.dataLabels, I = this.barCtx.barOptions.dataLabels, T = this.barCtx.barOptions.dataLabels.total;
                void 0 !== x && this.barCtx.isRangeBar && (i = x, L = x), void 0 !== p && this.barCtx.isVerticalGroupedRangeBar && (e = p, C = p);
                var z = M.offsetX, X = M.offsetY, E = {
                    width: 0,
                    height: 0
                };
                if (m.config.dataLabels.enabled) {
                    var Y = m.globals.series[n][l];
                    E = y.getTextRects(m.config.dataLabels.formatter ? m.config.dataLabels.formatter(Y, g(g({}, m), {}, {
                        seriesIndex: n,
                        dataPointIndex: l,
                        w: m
                    })) : m.globals.yLabelFormatters[0](Y), parseFloat(M.style.fontSize));
                }
                var R = {
                    x: a,
                    y: s,
                    i: n,
                    j: l,
                    realIndex: h,
                    columnGroupIndex: c,
                    renderedPath: v,
                    bcx: e,
                    bcy: i,
                    barHeight: u,
                    barWidth: f,
                    textRects: E,
                    strokeWidth: w,
                    dataLabelsX: C,
                    dataLabelsY: L,
                    dataLabelsConfig: M,
                    barDataLabelsConfig: I,
                    barTotalDataLabelsConfig: T,
                    offX: z,
                    offY: X
                };
                return P = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(R) : this.calculateColumnsDataLabelsPosition(R), v.attr({
                    cy: P.bcy,
                    cx: P.bcx,
                    j: l,
                    val: m.globals.series[n][l],
                    barHeight: u,
                    barWidth: f
                }), A = this.drawCalculatedDataLabels({
                    x: P.dataLabelsX,
                    y: P.dataLabelsY,
                    val: this.barCtx.isRangeBar ? [
                        r,
                        o
                    ] : "100%" === m.config.chart.stackType ? d[h][l] : m.globals.series[h][l],
                    i: h,
                    j: l,
                    barWidth: f,
                    barHeight: u,
                    textRects: E,
                    dataLabelsConfig: M
                }), m.config.chart.stacked && T.enabled && (S = this.drawTotalDataLabels({
                    x: P.totalDataLabelsX,
                    y: P.totalDataLabelsY,
                    barWidth: f,
                    barHeight: u,
                    realIndex: h,
                    textAnchor: P.totalDataLabelsAnchor,
                    val: this.getStackedTotalDataLabel({
                        realIndex: h,
                        j: l
                    }),
                    dataLabelsConfig: M,
                    barTotalDataLabelsConfig: T
                })), {
                    dataLabels: A,
                    totalDataLabels: S
                };
            }
        },
        {
            key: "getStackedTotalDataLabel",
            value: function(t) {
                var e = t.realIndex, i = t.j, a = this.w, s = this.barCtx.stackedSeriesTotals[i];
                return this.totalFormatter && (s = this.totalFormatter(s, g(g({}, a), {}, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }))), s;
            }
        },
        {
            key: "calculateColumnsDataLabelsPosition",
            value: function(t) {
                var e = this.w, i = t.i, a = t.j, s = t.realIndex;
                t.columnGroupIndex;
                var r, o, n = t.y, l = t.bcx, h = t.barWidth, c = t.barHeight, d = t.textRects, g = t.dataLabelsX, u = t.dataLabelsY, f = t.dataLabelsConfig, p = t.barDataLabelsConfig, x = t.barTotalDataLabelsConfig, b = t.strokeWidth, v = t.offX, m = t.offY, y = l;
                c = Math.abs(c);
                var w = "vertical" === e.config.plotOptions.bar.dataLabels.orientation, A = this.barCtx.barHelpers.getZeroValueEncounters({
                    i: i,
                    j: a
                }).zeroEncounters;
                l -= b / 2;
                var S = e.globals.gridWidth / e.globals.dataPoints;
                if (this.barCtx.isVerticalGroupedRangeBar ? g += h / 2 : (g = e.globals.isXNumeric ? l - h / 2 + v : l - S + h / 2 + v, A > 0 && e.config.plotOptions.bar.hideZeroBarsWhenGrouped && (g -= h * A)), w) g = g + d.height / 2 - b / 2 - 2;
                var C = e.globals.series[i][a] < 0, L = n;
                switch(this.barCtx.isReversed && (L = n + (C ? c : -c)), p.position){
                    case "center":
                        u = w ? C ? L - c / 2 + m : L + c / 2 - m : C ? L - c / 2 + d.height / 2 + m : L + c / 2 + d.height / 2 - m;
                        break;
                    case "bottom":
                        u = w ? C ? L - c + m : L + c - m : C ? L - c + d.height + b + m : L + c - d.height / 2 + b - m;
                        break;
                    case "top":
                        u = w ? C ? L + m : L - m : C ? L - d.height / 2 - m : L + d.height + m;
                }
                if (this.barCtx.lastActiveBarSerieIndex === s && x.enabled) {
                    var P = new k(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: s,
                        j: a
                    }), f.fontSize);
                    r = C ? L - P.height / 2 - m - x.offsetY + 18 : L + P.height + m + x.offsetY - 18;
                    var M = S;
                    o = y + (e.globals.isXNumeric ? -h * e.globals.barGroups.length / 2 : e.globals.barGroups.length * h / 2 - (e.globals.barGroups.length - 1) * h - M) + x.offsetX;
                }
                return e.config.chart.stacked || (u < 0 ? u = 0 + b : u + d.height / 3 > e.globals.gridHeight && (u = e.globals.gridHeight - b)), {
                    bcx: l,
                    bcy: n,
                    dataLabelsX: g,
                    dataLabelsY: u,
                    totalDataLabelsX: o,
                    totalDataLabelsY: r,
                    totalDataLabelsAnchor: "middle"
                };
            }
        },
        {
            key: "calculateBarsDataLabelsPosition",
            value: function(t) {
                var e = this.w, i = t.x, a = t.i, s = t.j, r = t.realIndex, o = t.bcy, n = t.barHeight, l = t.barWidth, h = t.textRects, c = t.dataLabelsX, d = t.strokeWidth, g = t.dataLabelsConfig, u = t.barDataLabelsConfig, f = t.barTotalDataLabelsConfig, p = t.offX, x = t.offY, b = e.globals.gridHeight / e.globals.dataPoints;
                l = Math.abs(l);
                var v, m, y = o - (this.barCtx.isRangeBar ? 0 : b) + n / 2 + h.height / 2 + x - 3, w = "start", A = e.globals.series[a][s] < 0, S = i;
                switch(this.barCtx.isReversed && (S = i + (A ? -l : l), w = A ? "start" : "end"), u.position){
                    case "center":
                        c = A ? S + l / 2 - p : Math.max(h.width / 2, S - l / 2) + p;
                        break;
                    case "bottom":
                        c = A ? S + l - d - p : S - l + d + p;
                        break;
                    case "top":
                        c = A ? S - d - p : S - d + p;
                }
                if (this.barCtx.lastActiveBarSerieIndex === r && f.enabled) {
                    var C = new k(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: r,
                        j: s
                    }), g.fontSize);
                    A ? (v = S - d - p - f.offsetX, w = "end") : v = S + p + f.offsetX + (this.barCtx.isReversed ? -(l + d) : d), m = y - h.height / 2 + C.height / 2 + f.offsetY + d;
                }
                return e.config.chart.stacked || ("start" === g.textAnchor ? c - h.width < 0 ? c = A ? h.width + d : d : c + h.width > e.globals.gridWidth && (c = A ? e.globals.gridWidth - d : e.globals.gridWidth - h.width - d) : "middle" === g.textAnchor ? c - h.width / 2 < 0 ? c = h.width / 2 + d : c + h.width / 2 > e.globals.gridWidth && (c = e.globals.gridWidth - h.width / 2 - d) : "end" === g.textAnchor && (c < 1 ? c = h.width + d : c + 1 > e.globals.gridWidth && (c = e.globals.gridWidth - h.width - d))), {
                    bcx: i,
                    bcy: o,
                    dataLabelsX: c,
                    dataLabelsY: y,
                    totalDataLabelsX: v,
                    totalDataLabelsY: m,
                    totalDataLabelsAnchor: w
                };
            }
        },
        {
            key: "drawCalculatedDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.val, s = t.i, r = t.j, o = t.textRects, n = t.barHeight, l = t.barWidth, h = t.dataLabelsConfig, c = this.w, d = "rotate(0)";
                "vertical" === c.config.plotOptions.bar.dataLabels.orientation && (d = "rotate(-90, ".concat(e, ", ").concat(i, ")"));
                var u = new G(this.barCtx.ctx), f = new k(this.barCtx.ctx), p = h.formatter, x = null, b = c.globals.collapsedSeriesIndices.indexOf(s) > -1;
                if (h.enabled && !b) {
                    x = f.group({
                        class: "apexcharts-data-labels",
                        transform: d
                    });
                    var v = "";
                    void 0 !== a && (v = p(a, g(g({}, c), {}, {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: c
                    }))), !a && c.config.plotOptions.bar.hideZeroBarsWhenGrouped && (v = "");
                    var m = c.globals.series[s][r] < 0, y = c.config.plotOptions.bar.dataLabels.position;
                    if ("vertical" === c.config.plotOptions.bar.dataLabels.orientation && ("top" === y && (h.textAnchor = m ? "end" : "start"), "center" === y && (h.textAnchor = "middle"), "bottom" === y && (h.textAnchor = m ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels) l < f.getTextRects(v, parseFloat(h.style.fontSize)).width && (v = "");
                    c.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? o.width / 1.6 > Math.abs(l) && (v = "") : o.height / 1.6 > Math.abs(n) && (v = ""));
                    var w = g({}, h);
                    this.barCtx.isHorizontal && a < 0 && ("start" === h.textAnchor ? w.textAnchor = "end" : "end" === h.textAnchor && (w.textAnchor = "start")), u.plotDataLabelsText({
                        x: e,
                        y: i,
                        text: v,
                        i: s,
                        j: r,
                        parent: x,
                        dataLabelsConfig: w,
                        alwaysDrawDataLabel: !0,
                        offsetCorrection: !0
                    });
                }
                return x;
            }
        },
        {
            key: "drawTotalDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.val, s = t.realIndex, r = t.textAnchor, o = t.barTotalDataLabelsConfig;
                this.w;
                var n, l = new k(this.barCtx.ctx);
                return o.enabled && void 0 !== e && void 0 !== i && this.barCtx.lastActiveBarSerieIndex === s && (n = l.drawText({
                    x: e,
                    y: i,
                    foreColor: o.style.color,
                    text: a,
                    textAnchor: r,
                    fontFamily: o.style.fontFamily,
                    fontSize: o.style.fontSize,
                    fontWeight: o.style.fontWeight
                })), n;
            }
        }
    ]), t;
}(), At = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.barCtx = e;
    }
    return s(t, [
        {
            key: "initVariables",
            value: function(t) {
                var e = this.w;
                this.barCtx.series = t, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                for(var i = 0; i < t.length; i++)if (t[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += t[i].length), e.globals.isXNumeric) for(var a = 0; a < t[i].length; a++)e.globals.seriesX[i][a] > e.globals.minX && e.globals.seriesX[i][a] < e.globals.maxX && this.barCtx.visibleItems++;
                else this.barCtx.visibleItems = e.globals.dataPoints;
                this.arrBorderRadius = this.createBorderRadiusArr(e.globals.series), 0 === this.barCtx.seriesLen && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], e.globals.comboCharts || this.checkZeroSeries({
                    series: t
                });
            }
        },
        {
            key: "initialPositions",
            value: function() {
                var t, e, i, a, s, r, o, n, l = this.w, h = l.globals.dataPoints;
                this.barCtx.isRangeBar && (h = l.globals.labels.length);
                var c = this.barCtx.seriesLen;
                if (l.config.plotOptions.bar.rangeBarGroupRows && (c = 1), this.barCtx.isHorizontal) s = (i = l.globals.gridHeight / h) / c, l.globals.isXNumeric && (s = (i = l.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), s = s * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, -1 === String(this.barCtx.barOptions.barHeight).indexOf("%") && (s = parseInt(this.barCtx.barOptions.barHeight, 10)), n = this.barCtx.baseLineInvertedY + l.globals.padHorizontal + (this.barCtx.isReversed ? l.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (n = l.globals.gridWidth / 2), e = (i - s * this.barCtx.seriesLen) / 2;
                else {
                    if (a = l.globals.gridWidth / this.barCtx.visibleItems, l.config.xaxis.convertedCatToNumeric && (a = l.globals.gridWidth / l.globals.dataPoints), r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, l.globals.isXNumeric) {
                        var d = this.barCtx.xRatio;
                        l.globals.minXDiff && .5 !== l.globals.minXDiff && l.globals.minXDiff / d > 0 && (a = l.globals.minXDiff / d), (r = a / c * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1);
                    }
                    -1 === String(this.barCtx.barOptions.columnWidth).indexOf("%") && (r = parseInt(this.barCtx.barOptions.columnWidth, 10)), o = l.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.translationsIndex] - (this.barCtx.isReversed ? l.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.translationsIndex] : 0), t = l.globals.padHorizontal + (a - r * this.barCtx.seriesLen) / 2;
                }
                return l.globals.barHeight = s, l.globals.barWidth = r, {
                    x: t,
                    y: e,
                    yDivision: i,
                    xDivision: a,
                    barHeight: s,
                    barWidth: r,
                    zeroH: o,
                    zeroW: n
                };
            }
        },
        {
            key: "initializeStackedPrevVars",
            value: function(t) {
                t.w.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].prevY = [], t[e].prevX = [], t[e].prevYF = [], t[e].prevXF = [], t[e].prevYVal = [], t[e].prevXVal = [];
                });
            }
        },
        {
            key: "initializeStackedXYVars",
            value: function(t) {
                t.w.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].xArrj = [], t[e].xArrjF = [], t[e].xArrjVal = [], t[e].yArrj = [], t[e].yArrjF = [], t[e].yArrjVal = [];
                });
            }
        },
        {
            key: "getPathFillColor",
            value: function(t, e, i, a) {
                var s, r, o, n, l, h = this.w, c = this.barCtx.ctx.fill, d = null, g = this.barCtx.barOptions.distributed ? i : e;
                this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(a) {
                    t[e][i] >= a.from && t[e][i] <= a.to && (d = a.color);
                });
                return null !== (s = h.config.series[e].data[i]) && void 0 !== s && s.fillColor && (d = h.config.series[e].data[i].fillColor), c.fillPath({
                    seriesNumber: this.barCtx.barOptions.distributed ? g : a,
                    dataPointIndex: i,
                    color: d,
                    value: t[e][i],
                    fillConfig: null === (r = h.config.series[e].data[i]) || void 0 === r ? void 0 : r.fill,
                    fillType: null !== (o = h.config.series[e].data[i]) && void 0 !== o && null !== (n = o.fill) && void 0 !== n && n.type ? null === (l = h.config.series[e].data[i]) || void 0 === l ? void 0 : l.fill.type : Array.isArray(h.config.fill.type) ? h.config.fill.type[a] : h.config.fill.type
                });
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t, e, i) {
                var a = 0, s = this.w;
                return this.barCtx.series[t][e] ? this.barCtx.isNullValue = !1 : this.barCtx.isNullValue = !0, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
            }
        },
        {
            key: "createBorderRadiusArr",
            value: function(t) {
                var e = this.w, i = !this.w.config.chart.stacked || "last" !== e.config.plotOptions.bar.borderRadiusWhenStacked || e.config.plotOptions.bar.borderRadius <= 0, a = t.length, s = t[0].length, o = Array.from({
                    length: a
                }, function() {
                    return Array(s).fill(i ? "top" : "none");
                });
                if (i) return o;
                for(var n = 0; n < s; n++){
                    for(var l = [], h = [], c = 0, d = 0; d < a; d++){
                        var g = t[d][n];
                        g > 0 ? (l.push(d), c++) : g < 0 && (h.push(d), c++);
                    }
                    if (l.length > 0 && 0 === h.length) {
                        if (1 === l.length) o[l[0]][n] = "both";
                        else {
                            var u, f = l[0], p = l[l.length - 1], x = r(l);
                            try {
                                for(x.s(); !(u = x.n()).done;){
                                    var b = u.value;
                                    o[b][n] = b === f ? "bottom" : b === p ? "top" : "none";
                                }
                            } catch (t) {
                                x.e(t);
                            } finally{
                                x.f();
                            }
                        }
                    } else if (h.length > 0 && 0 === l.length) {
                        if (1 === h.length) o[h[0]][n] = "both";
                        else {
                            var v, m = h[0], y = h[h.length - 1], w = r(h);
                            try {
                                for(w.s(); !(v = w.n()).done;){
                                    var k = v.value;
                                    o[k][n] = k === m ? "bottom" : k === y ? "top" : "none";
                                }
                            } catch (t) {
                                w.e(t);
                            } finally{
                                w.f();
                            }
                        }
                    } else if (l.length > 0 && h.length > 0) {
                        var A, S = l[l.length - 1], C = r(l);
                        try {
                            for(C.s(); !(A = C.n()).done;){
                                var L = A.value;
                                o[L][n] = L === S ? "top" : "none";
                            }
                        } catch (t) {
                            C.e(t);
                        } finally{
                            C.f();
                        }
                        var P, M = h[h.length - 1], I = r(h);
                        try {
                            for(I.s(); !(P = I.n()).done;){
                                var T = P.value;
                                o[T][n] = T === M ? "bottom" : "none";
                            }
                        } catch (t) {
                            I.e(t);
                        } finally{
                            I.f();
                        }
                    } else if (1 === c) o[l[0] || h[0]][n] = "both";
                }
                return o;
            }
        },
        {
            key: "barBackground",
            value: function(t) {
                var e = t.j, i = t.i, a = t.x1, s = t.x2, r = t.y1, o = t.y2, n = t.elSeries, l = this.w, h = new k(this.barCtx.ctx), c = new V(this.barCtx.ctx).getActiveConfigSeriesIndex();
                if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && c === i) {
                    e >= this.barCtx.barOptions.colors.backgroundBarColors.length && (e %= this.barCtx.barOptions.colors.backgroundBarColors.length);
                    var d = this.barCtx.barOptions.colors.backgroundBarColors[e], g = h.drawRect(void 0 !== a ? a : 0, void 0 !== r ? r : 0, void 0 !== s ? s : l.globals.gridWidth, void 0 !== o ? o : l.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, d, this.barCtx.barOptions.colors.backgroundBarOpacity);
                    n.add(g), g.node.classList.add("apexcharts-backgroundBar");
                }
            }
        },
        {
            key: "getColumnPaths",
            value: function(t) {
                var e, i = t.barWidth, a = t.barXPosition, s = t.y1, r = t.y2, o = t.strokeWidth, n = t.isReversed, l = t.series, h = t.seriesGroup, c = t.realIndex, d = t.i, g = t.j, u = t.w, f = new k(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[c] : o) || (o = 0);
                var p = i, x = a;
                null !== (e = u.config.series[c].data[g]) && void 0 !== e && e.columnWidthOffset && (x = a - u.config.series[c].data[g].columnWidthOffset / 2, p = i + u.config.series[c].data[g].columnWidthOffset);
                var b = o / 2, v = x + b, m = x + p - b, y = (l[d][g] >= 0 ? 1 : -1) * (n ? -1 : 1);
                s += .001 - b * y, r += .001 + b * y;
                var w = f.move(v, s), A = f.move(v, s), S = f.line(m, s);
                if (u.globals.previousPaths.length > 0 && (A = this.barCtx.getPreviousPath(c, g, !1)), w = w + f.line(v, r) + f.line(m, r) + S + ("around" === u.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][g] ? " Z" : " z"), A = A + f.line(v, s) + S + S + S + S + S + f.line(v, s) + ("around" === u.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][g] ? " Z" : " z"), "none" !== this.arrBorderRadius[c][g] && (w = f.roundPathCorners(w, u.config.plotOptions.bar.borderRadius)), u.config.chart.stacked) {
                    var C = this.barCtx;
                    (C = this.barCtx[h]).yArrj.push(r - b * y), C.yArrjF.push(Math.abs(s - r + o * y)), C.yArrjVal.push(this.barCtx.series[d][g]);
                }
                return {
                    pathTo: w,
                    pathFrom: A
                };
            }
        },
        {
            key: "getBarpaths",
            value: function(t) {
                var e, i = t.barYPosition, a = t.barHeight, s = t.x1, r = t.x2, o = t.strokeWidth, n = t.isReversed, l = t.series, h = t.seriesGroup, c = t.realIndex, d = t.i, g = t.j, u = t.w, f = new k(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[c] : o) || (o = 0);
                var p = i, x = a;
                null !== (e = u.config.series[c].data[g]) && void 0 !== e && e.barHeightOffset && (p = i - u.config.series[c].data[g].barHeightOffset / 2, x = a + u.config.series[c].data[g].barHeightOffset);
                var b = o / 2, v = p + b, m = p + x - b, y = (l[d][g] >= 0 ? 1 : -1) * (n ? -1 : 1);
                s += .001 + b * y, r += .001 - b * y;
                var w = f.move(s, v), A = f.move(s, v);
                u.globals.previousPaths.length > 0 && (A = this.barCtx.getPreviousPath(c, g, !1));
                var S = f.line(s, m);
                if (w = w + f.line(r, v) + f.line(r, m) + S + ("around" === u.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][g] ? " Z" : " z"), A = A + f.line(s, v) + S + S + S + S + S + f.line(s, v) + ("around" === u.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][g] ? " Z" : " z"), "none" !== this.arrBorderRadius[c][g] && (w = f.roundPathCorners(w, u.config.plotOptions.bar.borderRadius)), u.config.chart.stacked) {
                    var C = this.barCtx;
                    (C = this.barCtx[h]).xArrj.push(r + b * y), C.xArrjF.push(Math.abs(s - r - o * y)), C.xArrjVal.push(this.barCtx.series[d][g]);
                }
                return {
                    pathTo: w,
                    pathFrom: A
                };
            }
        },
        {
            key: "checkZeroSeries",
            value: function(t) {
                for(var e = t.series, i = this.w, a = 0; a < e.length; a++){
                    for(var s = 0, r = 0; r < e[i.globals.maxValsInArrayIndex].length; r++)s += e[a][r];
                    0 === s && this.barCtx.zeroSerieses.push(a);
                }
            }
        },
        {
            key: "getXForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e + t / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? t / this.barCtx.invertedYRatio : 0)), i;
            }
        },
        {
            key: "getYForValue",
            value: function(t, e, i) {
                var a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3] ? e : null;
                return null != t && (a = e - t / this.barCtx.yRatio[i] + 2 * (this.barCtx.isReversed ? t / this.barCtx.yRatio[i] : 0)), a;
            }
        },
        {
            key: "getGoalValues",
            value: function(t, e, i, a, s, r) {
                var o = this, l = this.w, h = [], c = function(a, s) {
                    var l;
                    h.push((n(l = {}, t, "x" === t ? o.getXForValue(a, e, !1) : o.getYForValue(a, i, r, !1)), n(l, "attrs", s), l));
                };
                if (l.globals.seriesGoals[a] && l.globals.seriesGoals[a][s] && Array.isArray(l.globals.seriesGoals[a][s]) && l.globals.seriesGoals[a][s].forEach(function(t) {
                    c(t.value, t);
                }), this.barCtx.barOptions.isDumbbell && l.globals.seriesRange.length) {
                    var d = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : l.globals.colors, u = {
                        strokeHeight: "x" === t ? 0 : l.globals.markers.size[a],
                        strokeWidth: "x" === t ? l.globals.markers.size[a] : 0,
                        strokeDashArray: 0,
                        strokeLineCap: "round",
                        strokeColor: Array.isArray(d[a]) ? d[a][0] : d[a]
                    };
                    c(l.globals.seriesRangeStart[a][s], u), c(l.globals.seriesRangeEnd[a][s], g(g({}, u), {}, {
                        strokeColor: Array.isArray(d[a]) ? d[a][1] : d[a]
                    }));
                }
                return h;
            }
        },
        {
            key: "drawGoalLine",
            value: function(t) {
                var e = t.barXPosition, i = t.barYPosition, a = t.goalX, s = t.goalY, r = t.barWidth, o = t.barHeight, n = new k(this.barCtx.ctx), l = n.group({
                    className: "apexcharts-bar-goals-groups"
                });
                l.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({
                    el: l.node
                }), l.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
                var h = null;
                return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(t) {
                    if (t.x >= -1 && t.x <= n.w.globals.gridWidth + 1) {
                        var e = void 0 !== t.attrs.strokeHeight ? t.attrs.strokeHeight : o / 2, a = i + e + o / 2;
                        h = n.drawLine(t.x, a - 2 * e, t.x, a, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeWidth ? t.attrs.strokeWidth : 2, t.attrs.strokeLineCap), l.add(h);
                    }
                }) : Array.isArray(s) && s.forEach(function(t) {
                    if (t.y >= -1 && t.y <= n.w.globals.gridHeight + 1) {
                        var i = void 0 !== t.attrs.strokeWidth ? t.attrs.strokeWidth : r / 2, a = e + i + r / 2;
                        h = n.drawLine(a - 2 * i, t.y, a, t.y, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeHeight ? t.attrs.strokeHeight : 2, t.attrs.strokeLineCap), l.add(h);
                    }
                }), l;
            }
        },
        {
            key: "drawBarShadow",
            value: function(t) {
                var e = t.prevPaths, i = t.currPaths, a = t.color, s = this.w, r = e.x, o = e.x1, n = e.barYPosition, l = i.x, h = i.x1, c = i.barYPosition, d = n + i.barHeight, g = new k(this.barCtx.ctx), u = new m, f = g.move(o, d) + g.line(r, d) + g.line(l, c) + g.line(h, c) + g.line(o, d) + ("around" === s.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[realIndex][j] ? " Z" : " z");
                return g.drawPath({
                    d: f,
                    fill: u.shadeColor(.5, m.rgb2hex(a)),
                    stroke: "none",
                    strokeWidth: 0,
                    fillOpacity: 1,
                    classes: "apexcharts-bar-shadows"
                });
            }
        },
        {
            key: "getZeroValueEncounters",
            value: function(t) {
                var e, i = t.i, a = t.j, s = this.w, r = 0, o = 0;
                return (s.config.plotOptions.bar.horizontal ? s.globals.series.map(function(t, e) {
                    return e;
                }) : (null === (e = s.globals.columnSeries) || void 0 === e ? void 0 : e.i.map(function(t) {
                    return t;
                })) || []).forEach(function(t) {
                    var e = s.globals.seriesPercent[t][a];
                    e && r++, t < i && 0 === e && o++;
                }), {
                    nonZeroColumns: r,
                    zeroEncounters: o
                };
            }
        },
        {
            key: "getGroupIndex",
            value: function(t) {
                var e = this.w, i = e.globals.seriesGroups.findIndex(function(i) {
                    return i.indexOf(e.globals.seriesNames[t]) > -1;
                }), a = this.barCtx.columnGroupIndices, s = a.indexOf(i);
                return s < 0 && (a.push(i), s = a.length - 1), {
                    groupIndex: i,
                    columnGroupIndex: s
                };
            }
        }
    ]), t;
}(), St = function() {
    function t(e, a) {
        i(this, t), this.ctx = e, this.w = e.w;
        var s = this.w;
        this.barOptions = s.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = s.config.stroke.width, this.isNullValue = !1, this.isRangeBar = s.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !s.globals.isBarHorizontal && s.globals.seriesRange.length && s.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = a, null !== this.xyRatios && (this.xRatio = a.xRatio, this.yRatio = a.yRatio, this.invertedXRatio = a.invertedXRatio, this.invertedYRatio = a.invertedYRatio, this.baseLineY = a.baseLineY, this.baseLineInvertedY = a.baseLineInvertedY), this.yaxisIndex = 0, this.translationsIndex = 0, this.seriesLen = 0, this.pathArr = [];
        var r = new V(this.ctx);
        this.lastActiveBarSerieIndex = r.getActiveConfigSeriesIndex("desc", [
            "bar",
            "column"
        ]), this.columnGroupIndices = [];
        var o = r.getBarSeriesIndices(), n = new A(this.ctx);
        this.stackedSeriesTotals = n.getStackedSeriesTotals(this.w.config.series.map(function(t, e) {
            return -1 === o.indexOf(e) ? e : -1;
        }).filter(function(t) {
            return -1 !== t;
        })), this.barHelpers = new At(this);
    }
    return s(t, [
        {
            key: "draw",
            value: function(t, e) {
                var i = this.w, a = new k(this.ctx), s = new A(this.ctx, i);
                t = s.getLogSeries(t), this.series = t, this.yRatio = s.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                var r = a.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                });
                i.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");
                for(var o = 0, n = 0; o < t.length; o++, n++){
                    var l, h, c, d, u = void 0, f = void 0, p = [], x = [], b = i.globals.comboCharts ? e[o] : o, v = this.barHelpers.getGroupIndex(b).columnGroupIndex, y = a.group({
                        class: "apexcharts-series",
                        rel: o + 1,
                        seriesName: m.escapeString(i.globals.seriesNames[b]),
                        "data:realIndex": b
                    });
                    this.ctx.series.addCollapsedClassToSeries(y, b), t[o].length > 0 && (this.visibleI = this.visibleI + 1);
                    var w = 0, S = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = i.globals.seriesYAxisReverseMap[b], this.translationsIndex = b);
                    var C = this.translationsIndex;
                    this.isReversed = i.config.yaxis[this.yaxisIndex] && i.config.yaxis[this.yaxisIndex].reversed;
                    var L = this.barHelpers.initialPositions();
                    f = L.y, w = L.barHeight, h = L.yDivision, d = L.zeroW, u = L.x, S = L.barWidth, l = L.xDivision, c = L.zeroH, this.horizontal || x.push(u + S / 2);
                    var P = a.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": b
                    });
                    i.globals.delayedElements.push({
                        el: P.node
                    }), P.node.classList.add("apexcharts-element-hidden");
                    var M = a.group({
                        class: "apexcharts-bar-goals-markers"
                    }), I = a.group({
                        class: "apexcharts-bar-shadows"
                    });
                    i.globals.delayedElements.push({
                        el: I.node
                    }), I.node.classList.add("apexcharts-element-hidden");
                    for(var T = 0; T < t[o].length; T++){
                        var z = this.barHelpers.getStrokeWidth(o, T, b), X = null, E = {
                            indexes: {
                                i: o,
                                j: T,
                                realIndex: b,
                                translationsIndex: C,
                                bc: n
                            },
                            x: u,
                            y: f,
                            strokeWidth: z,
                            elSeries: y
                        };
                        this.isHorizontal ? (X = this.drawBarPaths(g(g({}, E), {}, {
                            barHeight: w,
                            zeroW: d,
                            yDivision: h
                        })), S = this.series[o][T] / this.invertedYRatio) : (X = this.drawColumnPaths(g(g({}, E), {}, {
                            xDivision: l,
                            barWidth: S,
                            zeroH: c
                        })), w = this.series[o][T] / this.yRatio[C]);
                        var Y = this.barHelpers.getPathFillColor(t, o, T, b);
                        if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && T > 0) {
                            var R = this.barHelpers.drawBarShadow({
                                color: "string" == typeof Y && -1 === (null == Y ? void 0 : Y.indexOf("url")) ? Y : m.hexToRgba(i.globals.colors[o]),
                                prevPaths: this.pathArr[this.pathArr.length - 1],
                                currPaths: X
                            });
                            R && I.add(R);
                        }
                        this.pathArr.push(X);
                        var F = this.barHelpers.drawGoalLine({
                            barXPosition: X.barXPosition,
                            barYPosition: X.barYPosition,
                            goalX: X.goalX,
                            goalY: X.goalY,
                            barHeight: w,
                            barWidth: S
                        });
                        F && M.add(F), f = X.y, u = X.x, T > 0 && x.push(u + S / 2), p.push(f), this.renderSeries({
                            realIndex: b,
                            pathFill: Y,
                            j: T,
                            i: o,
                            columnGroupIndex: v,
                            pathFrom: X.pathFrom,
                            pathTo: X.pathTo,
                            strokeWidth: z,
                            elSeries: y,
                            x: u,
                            y: f,
                            series: t,
                            barHeight: Math.abs(X.barHeight ? X.barHeight : w),
                            barWidth: Math.abs(X.barWidth ? X.barWidth : S),
                            elDataLabelsWrap: P,
                            elGoalsMarkers: M,
                            elBarShadows: I,
                            visibleSeries: this.visibleI,
                            type: "bar"
                        });
                    }
                    i.globals.seriesXvalues[b] = x, i.globals.seriesYvalues[b] = p, r.add(y);
                }
                return r;
            }
        },
        {
            key: "renderSeries",
            value: function(t) {
                var e = t.realIndex, i = t.pathFill, a = t.lineFill, s = t.j, r = t.i, o = t.columnGroupIndex, n = t.pathFrom, l = t.pathTo, h = t.strokeWidth, c = t.elSeries, d = t.x, g = t.y, u = t.y1, f = t.y2, p = t.series, x = t.barHeight, b = t.barWidth, v = t.barXPosition, m = t.barYPosition, y = t.elDataLabelsWrap, A = t.elGoalsMarkers, S = t.elBarShadows, C = t.visibleSeries, L = t.type, P = t.classes, M = this.w, I = new k(this.ctx);
                if (!a) {
                    var T = "function" == typeof M.globals.stroke.colors[e] ? function(t) {
                        var e, i = M.config.stroke.colors;
                        return Array.isArray(i) && i.length > 0 && ((e = i[t]) || (e = ""), "function" == typeof e) ? e({
                            value: M.globals.series[t][s],
                            dataPointIndex: s,
                            w: M
                        }) : e;
                    }(e) : M.globals.stroke.colors[e];
                    a = this.barOptions.distributed ? M.globals.stroke.colors[s] : T;
                }
                M.config.series[r].data[s] && M.config.series[r].data[s].strokeColor && (a = M.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                var z = s / M.config.chart.animations.animateGradually.delay * (M.config.chart.animations.speed / M.globals.dataPoints) / 2.4, X = I.renderPaths({
                    i: r,
                    j: s,
                    realIndex: e,
                    pathFrom: n,
                    pathTo: l,
                    stroke: a,
                    strokeWidth: h,
                    strokeLineCap: M.config.stroke.lineCap,
                    fill: i,
                    animationDelay: z,
                    initialSpeed: M.config.chart.animations.speed,
                    dataChangeSpeed: M.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(L, "-area ").concat(P),
                    chartType: L
                });
                X.attr("clip-path", "url(#gridRectBarMask".concat(M.globals.cuid, ")"));
                var E = M.config.forecastDataPoints;
                E.count > 0 && s >= M.globals.dataPoints - E.count && (X.node.setAttribute("stroke-dasharray", E.dashArray), X.node.setAttribute("stroke-width", E.strokeWidth), X.node.setAttribute("fill-opacity", E.fillOpacity)), void 0 !== u && void 0 !== f && (X.attr("data-range-y1", u), X.attr("data-range-y2", f)), new w(this.ctx).setSelectionFilter(X, e, s), c.add(X);
                var Y = new kt(this).handleBarDataLabels({
                    x: d,
                    y: g,
                    y1: u,
                    y2: f,
                    i: r,
                    j: s,
                    series: p,
                    realIndex: e,
                    columnGroupIndex: o,
                    barHeight: x,
                    barWidth: b,
                    barXPosition: v,
                    barYPosition: m,
                    renderedPath: X,
                    visibleSeries: C
                });
                return null !== Y.dataLabels && y.add(Y.dataLabels), Y.totalDataLabels && y.add(Y.totalDataLabels), c.add(y), A && c.add(A), S && c.add(S), c;
            }
        },
        {
            key: "drawBarPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.yDivision, h = t.elSeries, c = this.w, d = i.i, g = i.j;
                if (c.globals.isXNumeric) e = (n = (c.globals.seriesX[d][g] - c.globals.minX) / this.invertedXRatio - a) + a * this.visibleI;
                else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var u = 0, f = 0;
                    c.globals.seriesPercent.forEach(function(t, e) {
                        t[g] && u++, e < d && 0 === t[g] && f++;
                    }), u > 0 && (a = this.seriesLen * a / u), e = n + a * this.visibleI, e -= a * f;
                } else e = n + a * this.visibleI;
                this.isFunnel && (r -= (this.barHelpers.getXForValue(this.series[d][g], r) - r) / 2), o = this.barHelpers.getXForValue(this.series[d][g], r);
                var p = this.barHelpers.getBarpaths({
                    barYPosition: e,
                    barHeight: a,
                    x1: r,
                    x2: o,
                    strokeWidth: s,
                    isReversed: this.isReversed,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return c.globals.isXNumeric || (n += l), this.barHelpers.barBackground({
                    j: g,
                    i: d,
                    y1: e - a * this.visibleI,
                    y2: a * this.seriesLen,
                    elSeries: h
                }), {
                    pathTo: p.pathTo,
                    pathFrom: p.pathFrom,
                    x1: r,
                    x: o,
                    y: n,
                    goalX: this.barHelpers.getGoalValues("x", r, null, d, g),
                    barYPosition: e,
                    barHeight: a
                };
            }
        },
        {
            key: "drawColumnPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.x, s = t.y, r = t.xDivision, o = t.barWidth, n = t.zeroH, l = t.strokeWidth, h = t.elSeries, c = this.w, d = i.realIndex, g = i.translationsIndex, u = i.i, f = i.j, p = i.bc;
                if (c.globals.isXNumeric) {
                    var x = this.getBarXForNumericXAxis({
                        x: a,
                        j: f,
                        realIndex: d,
                        barWidth: o
                    });
                    a = x.x, e = x.barXPosition;
                } else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var b = this.barHelpers.getZeroValueEncounters({
                        i: u,
                        j: f
                    }), v = b.nonZeroColumns, m = b.zeroEncounters;
                    v > 0 && (o = this.seriesLen * o / v), e = a + o * this.visibleI, e -= o * m;
                } else e = a + o * this.visibleI;
                s = this.barHelpers.getYForValue(this.series[u][f], n, g);
                var y = this.barHelpers.getColumnPaths({
                    barXPosition: e,
                    barWidth: o,
                    y1: n,
                    y2: s,
                    strokeWidth: l,
                    isReversed: this.isReversed,
                    series: this.series,
                    realIndex: d,
                    i: u,
                    j: f,
                    w: c
                });
                return c.globals.isXNumeric || (a += r), this.barHelpers.barBackground({
                    bc: p,
                    j: f,
                    i: u,
                    x1: e - l / 2 - o * this.visibleI,
                    x2: o * this.seriesLen + l / 2,
                    elSeries: h
                }), {
                    pathTo: y.pathTo,
                    pathFrom: y.pathFrom,
                    x: a,
                    y: s,
                    goalY: this.barHelpers.getGoalValues("y", null, n, u, f, g),
                    barXPosition: e,
                    barWidth: o
                };
            }
        },
        {
            key: "getBarXForNumericXAxis",
            value: function(t) {
                var e = t.x, i = t.barWidth, a = t.realIndex, s = t.j, r = this.w, o = a;
                return r.globals.seriesX[a].length || (o = r.globals.maxValsInArrayIndex), r.globals.seriesX[o][s] && (e = (r.globals.seriesX[o][s] - r.globals.minX) / this.xRatio - i * this.seriesLen / 2), {
                    barXPosition: e + i * this.visibleI,
                    x: e
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t, e) {
                for(var i, a = this.w, s = 0; s < a.globals.previousPaths.length; s++){
                    var r = a.globals.previousPaths[s];
                    r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(t, 10) && void 0 !== a.globals.previousPaths[s].paths[e] && (i = a.globals.previousPaths[s].paths[e].d);
                }
                return i;
            }
        }
    ]), t;
}(), Ct = function(t) {
    h(a, St);
    var e = o(a);
    function a() {
        return i(this, a), e.apply(this, arguments);
    }
    return s(a, [
        {
            key: "draw",
            value: function(t, e) {
                var i = this, a = this.w;
                this.graphics = new k(this.ctx), this.bar = new St(this.ctx, this.xyRatios);
                var s = new A(this.ctx, a);
                t = s.getLogSeries(t), this.yRatio = s.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t), "100%" === a.config.chart.stackType && (t = a.globals.comboCharts ? e.map(function(t) {
                    return a.globals.seriesPercent[t];
                }) : a.globals.seriesPercent.slice()), this.series = t, this.barHelpers.initializeStackedPrevVars(this);
                for(var r = this.graphics.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                }), o = 0, n = 0, l = function(s, l) {
                    var h = void 0, c = void 0, d = void 0, u = void 0, f = a.globals.comboCharts ? e[s] : s, p = i.barHelpers.getGroupIndex(f), x = p.groupIndex, b = p.columnGroupIndex;
                    i.groupCtx = i[a.globals.seriesGroups[x]];
                    var v = [], y = [], w = 0;
                    i.yRatio.length > 1 && (i.yaxisIndex = a.globals.seriesYAxisReverseMap[f][0], w = f), i.isReversed = a.config.yaxis[i.yaxisIndex] && a.config.yaxis[i.yaxisIndex].reversed;
                    var k = i.graphics.group({
                        class: "apexcharts-series",
                        seriesName: m.escapeString(a.globals.seriesNames[f]),
                        rel: s + 1,
                        "data:realIndex": f
                    });
                    i.ctx.series.addCollapsedClassToSeries(k, f);
                    var A = i.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": f
                    }), S = i.graphics.group({
                        class: "apexcharts-bar-goals-markers"
                    }), C = 0, L = 0, P = i.initialPositions(o, n, h, c, d, u, w);
                    n = P.y, C = P.barHeight, c = P.yDivision, u = P.zeroW, o = P.x, L = P.barWidth, h = P.xDivision, d = P.zeroH, a.globals.barHeight = C, a.globals.barWidth = L, i.barHelpers.initializeStackedXYVars(i), 1 === i.groupCtx.prevY.length && i.groupCtx.prevY[0].every(function(t) {
                        return isNaN(t);
                    }) && (i.groupCtx.prevY[0] = i.groupCtx.prevY[0].map(function() {
                        return d;
                    }), i.groupCtx.prevYF[0] = i.groupCtx.prevYF[0].map(function() {
                        return 0;
                    }));
                    for(var M = 0; M < a.globals.dataPoints; M++){
                        var I = i.barHelpers.getStrokeWidth(s, M, f), T = {
                            indexes: {
                                i: s,
                                j: M,
                                realIndex: f,
                                translationsIndex: w,
                                bc: l
                            },
                            strokeWidth: I,
                            x: o,
                            y: n,
                            elSeries: k,
                            columnGroupIndex: b,
                            seriesGroup: a.globals.seriesGroups[x]
                        }, z = null;
                        i.isHorizontal ? (z = i.drawStackedBarPaths(g(g({}, T), {}, {
                            zeroW: u,
                            barHeight: C,
                            yDivision: c
                        })), L = i.series[s][M] / i.invertedYRatio) : (z = i.drawStackedColumnPaths(g(g({}, T), {}, {
                            xDivision: h,
                            barWidth: L,
                            zeroH: d
                        })), C = i.series[s][M] / i.yRatio[w]);
                        var X = i.barHelpers.drawGoalLine({
                            barXPosition: z.barXPosition,
                            barYPosition: z.barYPosition,
                            goalX: z.goalX,
                            goalY: z.goalY,
                            barHeight: C,
                            barWidth: L
                        });
                        X && S.add(X), n = z.y, o = z.x, v.push(o), y.push(n);
                        var E = i.barHelpers.getPathFillColor(t, s, M, f), Y = "";
                        a.globals.isBarHorizontal ? "bottom" === i.barHelpers.arrBorderRadius[f][M] && a.globals.series[f][M] > 0 && (Y = "apexcharts-flip-x") : "bottom" === i.barHelpers.arrBorderRadius[f][M] && a.globals.series[f][M] > 0 && (Y = "apexcharts-flip-y"), k = i.renderSeries({
                            realIndex: f,
                            pathFill: E,
                            j: M,
                            i: s,
                            columnGroupIndex: b,
                            pathFrom: z.pathFrom,
                            pathTo: z.pathTo,
                            strokeWidth: I,
                            elSeries: k,
                            x: o,
                            y: n,
                            series: t,
                            barHeight: C,
                            barWidth: L,
                            elDataLabelsWrap: A,
                            elGoalsMarkers: S,
                            type: "bar",
                            visibleSeries: b,
                            classes: Y
                        });
                    }
                    a.globals.seriesXvalues[f] = v, a.globals.seriesYvalues[f] = y, i.groupCtx.prevY.push(i.groupCtx.yArrj), i.groupCtx.prevYF.push(i.groupCtx.yArrjF), i.groupCtx.prevYVal.push(i.groupCtx.yArrjVal), i.groupCtx.prevX.push(i.groupCtx.xArrj), i.groupCtx.prevXF.push(i.groupCtx.xArrjF), i.groupCtx.prevXVal.push(i.groupCtx.xArrjVal), r.add(k);
                }, h = 0, c = 0; h < t.length; h++, c++)l(h, c);
                return r;
            }
        },
        {
            key: "initialPositions",
            value: function(t, e, i, a, s, r, o) {
                var n, l, h = this.w;
                if (this.isHorizontal) {
                    a = h.globals.gridHeight / h.globals.dataPoints;
                    var c = h.config.plotOptions.bar.barHeight;
                    n = -1 === String(c).indexOf("%") ? parseInt(c, 10) : a * parseInt(c, 10) / 100, r = h.globals.padHorizontal + (this.isReversed ? h.globals.gridWidth - this.baseLineInvertedY : this.baseLineInvertedY), e = (a - n) / 2;
                } else {
                    l = i = h.globals.gridWidth / h.globals.dataPoints;
                    var d = h.config.plotOptions.bar.columnWidth;
                    h.globals.isXNumeric && h.globals.dataPoints > 1 ? l = (i = h.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : -1 === String(d).indexOf("%") ? l = parseInt(d, 10) : l *= parseInt(d, 10) / 100, s = this.isReversed ? this.baseLineY[o] : h.globals.gridHeight - this.baseLineY[o], t = h.globals.padHorizontal + (i - l) / 2;
                }
                var g = h.globals.barGroups.length || 1;
                return {
                    x: t,
                    y: e,
                    yDivision: a,
                    xDivision: i,
                    barHeight: n / g,
                    barWidth: l / g,
                    zeroH: s,
                    zeroW: r
                };
            }
        },
        {
            key: "drawStackedBarPaths",
            value: function(t) {
                for(var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.columnGroupIndex, h = t.seriesGroup, c = t.yDivision, d = t.elSeries, g = this.w, u = n + l * a, f = i.i, p = i.j, x = i.realIndex, b = i.translationsIndex, v = 0, m = 0; m < this.groupCtx.prevXF.length; m++)v += this.groupCtx.prevXF[m][p];
                var y;
                if ((y = h.indexOf(g.config.series[x].name)) > 0) {
                    var w = r;
                    this.groupCtx.prevXVal[y - 1][p] < 0 ? w = this.series[f][p] >= 0 ? this.groupCtx.prevX[y - 1][p] + v - 2 * (this.isReversed ? v : 0) : this.groupCtx.prevX[y - 1][p] : this.groupCtx.prevXVal[y - 1][p] >= 0 && (w = this.series[f][p] >= 0 ? this.groupCtx.prevX[y - 1][p] : this.groupCtx.prevX[y - 1][p] - v + 2 * (this.isReversed ? v : 0)), e = w;
                } else e = r;
                o = null === this.series[f][p] ? e : e + this.series[f][p] / this.invertedYRatio - 2 * (this.isReversed ? this.series[f][p] / this.invertedYRatio : 0);
                var k = this.barHelpers.getBarpaths({
                    barYPosition: u,
                    barHeight: a,
                    x1: e,
                    x2: o,
                    strokeWidth: s,
                    isReversed: this.isReversed,
                    series: this.series,
                    realIndex: i.realIndex,
                    seriesGroup: h,
                    i: f,
                    j: p,
                    w: g
                });
                return this.barHelpers.barBackground({
                    j: p,
                    i: f,
                    y1: u,
                    y2: a,
                    elSeries: d
                }), n += c, {
                    pathTo: k.pathTo,
                    pathFrom: k.pathFrom,
                    goalX: this.barHelpers.getGoalValues("x", r, null, f, p, b),
                    barXPosition: e,
                    barYPosition: u,
                    x: o,
                    y: n
                };
            }
        },
        {
            key: "drawStackedColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.y, s = t.xDivision, r = t.barWidth, o = t.zeroH, n = t.columnGroupIndex, l = t.seriesGroup, h = t.elSeries, c = this.w, d = e.i, g = e.j, u = e.bc, f = e.realIndex, p = e.translationsIndex;
                if (c.globals.isXNumeric) {
                    var x = c.globals.seriesX[f][g];
                    x || (x = 0), i = (x - c.globals.minX) / this.xRatio - r / 2 * c.globals.barGroups.length;
                }
                for(var b, v = i + n * r, m = 0, y = 0; y < this.groupCtx.prevYF.length; y++)m += isNaN(this.groupCtx.prevYF[y][g]) ? 0 : this.groupCtx.prevYF[y][g];
                var w = d;
                if (l && (w = l.indexOf(c.globals.seriesNames[f])), w > 0 && !c.globals.isXNumeric || w > 0 && c.globals.isXNumeric && c.globals.seriesX[f - 1][g] === c.globals.seriesX[f][g]) {
                    var k, A, S, C = Math.min(this.yRatio.length + 1, f + 1);
                    if (void 0 !== this.groupCtx.prevY[w - 1] && this.groupCtx.prevY[w - 1].length) for(var L = 1; L < C; L++){
                        var P;
                        if (!isNaN(null === (P = this.groupCtx.prevY[w - L]) || void 0 === P ? void 0 : P[g])) {
                            S = this.groupCtx.prevY[w - L][g];
                            break;
                        }
                    }
                    for(var M = 1; M < C; M++){
                        var I, T;
                        if ((null === (I = this.groupCtx.prevYVal[w - M]) || void 0 === I ? void 0 : I[g]) < 0) {
                            A = this.series[d][g] >= 0 ? S - m + 2 * (this.isReversed ? m : 0) : S;
                            break;
                        }
                        if ((null === (T = this.groupCtx.prevYVal[w - M]) || void 0 === T ? void 0 : T[g]) >= 0) {
                            A = this.series[d][g] >= 0 ? S : S + m - 2 * (this.isReversed ? m : 0);
                            break;
                        }
                    }
                    void 0 === A && (A = c.globals.gridHeight), b = null !== (k = this.groupCtx.prevYF[0]) && void 0 !== k && k.every(function(t) {
                        return 0 === t;
                    }) && this.groupCtx.prevYF.slice(1, w).every(function(t) {
                        return t.every(function(t) {
                            return isNaN(t);
                        });
                    }) ? o : A;
                } else b = o;
                a = this.series[d][g] ? b - this.series[d][g] / this.yRatio[p] + 2 * (this.isReversed ? this.series[d][g] / this.yRatio[p] : 0) : b;
                var z = this.barHelpers.getColumnPaths({
                    barXPosition: v,
                    barWidth: r,
                    y1: b,
                    y2: a,
                    yRatio: this.yRatio[p],
                    strokeWidth: this.strokeWidth,
                    isReversed: this.isReversed,
                    series: this.series,
                    seriesGroup: l,
                    realIndex: e.realIndex,
                    i: d,
                    j: g,
                    w: c
                });
                return this.barHelpers.barBackground({
                    bc: u,
                    j: g,
                    i: d,
                    x1: v,
                    x2: r,
                    elSeries: h
                }), {
                    pathTo: z.pathTo,
                    pathFrom: z.pathFrom,
                    goalY: this.barHelpers.getGoalValues("y", null, o, d, g),
                    barXPosition: v,
                    x: c.globals.isXNumeric ? i : i + s,
                    y: a
                };
            }
        }
    ]), a;
}(), Lt = function(t) {
    h(a, St);
    var e = o(a);
    function a() {
        return i(this, a), e.apply(this, arguments);
    }
    return s(a, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this, s = this.w, r = new k(this.ctx), o = s.globals.comboCharts ? e : s.config.chart.type, n = new N(this.ctx);
                this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = s.config.plotOptions.bar.horizontal;
                var l = new A(this.ctx, s);
                t = l.getLogSeries(t), this.series = t, this.yRatio = l.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                for(var h = r.group({
                    class: "apexcharts-".concat(o, "-series apexcharts-plot-series")
                }), c = function(e) {
                    a.isBoxPlot = "boxPlot" === s.config.chart.type || "boxPlot" === s.config.series[e].type;
                    var o, l, c, d, u = void 0, f = void 0, p = [], x = [], b = s.globals.comboCharts ? i[e] : e, v = a.barHelpers.getGroupIndex(b).columnGroupIndex, y = r.group({
                        class: "apexcharts-series",
                        seriesName: m.escapeString(s.globals.seriesNames[b]),
                        rel: e + 1,
                        "data:realIndex": b
                    });
                    a.ctx.series.addCollapsedClassToSeries(y, b), t[e].length > 0 && (a.visibleI = a.visibleI + 1);
                    var w, k, A = 0;
                    a.yRatio.length > 1 && (a.yaxisIndex = s.globals.seriesYAxisReverseMap[b][0], A = b);
                    var S = a.barHelpers.initialPositions();
                    f = S.y, w = S.barHeight, l = S.yDivision, d = S.zeroW, u = S.x, k = S.barWidth, o = S.xDivision, c = S.zeroH, x.push(u + k / 2);
                    for(var C = r.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": b
                    }), L = function(i) {
                        var r = a.barHelpers.getStrokeWidth(e, i, b), h = null, m = {
                            indexes: {
                                i: e,
                                j: i,
                                realIndex: b,
                                translationsIndex: A
                            },
                            x: u,
                            y: f,
                            strokeWidth: r,
                            elSeries: y
                        };
                        h = a.isHorizontal ? a.drawHorizontalBoxPaths(g(g({}, m), {}, {
                            yDivision: l,
                            barHeight: w,
                            zeroW: d
                        })) : a.drawVerticalBoxPaths(g(g({}, m), {}, {
                            xDivision: o,
                            barWidth: k,
                            zeroH: c
                        })), f = h.y, u = h.x, i > 0 && x.push(u + k / 2), p.push(f), h.pathTo.forEach(function(o, l) {
                            var c = !a.isBoxPlot && a.candlestickOptions.wick.useFillColor ? h.color[l] : s.globals.stroke.colors[e], d = n.fillPath({
                                seriesNumber: b,
                                dataPointIndex: i,
                                color: h.color[l],
                                value: t[e][i]
                            });
                            a.renderSeries({
                                realIndex: b,
                                pathFill: d,
                                lineFill: c,
                                j: i,
                                i: e,
                                pathFrom: h.pathFrom,
                                pathTo: o,
                                strokeWidth: r,
                                elSeries: y,
                                x: u,
                                y: f,
                                series: t,
                                columnGroupIndex: v,
                                barHeight: w,
                                barWidth: k,
                                elDataLabelsWrap: C,
                                visibleSeries: a.visibleI,
                                type: s.config.chart.type
                            });
                        });
                    }, P = 0; P < s.globals.dataPoints; P++)L(P);
                    s.globals.seriesXvalues[b] = x, s.globals.seriesYvalues[b] = p, h.add(y);
                }, d = 0; d < t.length; d++)c(d);
                return h;
            }
        },
        {
            key: "drawVerticalBoxPaths",
            value: function(t) {
                var e = t.indexes, i = t.x;
                t.y;
                var a = t.xDivision, s = t.barWidth, r = t.zeroH, o = t.strokeWidth, n = this.w, l = new k(this.ctx), h = e.i, c = e.j, d = !0, g = n.config.plotOptions.candlestick.colors.upward, u = n.config.plotOptions.candlestick.colors.downward, f = "";
                this.isBoxPlot && (f = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var p = this.yRatio[e.translationsIndex], x = e.realIndex, b = this.getOHLCValue(x, c), v = r, m = r;
                b.o > b.c && (d = !1);
                var y = Math.min(b.o, b.c), w = Math.max(b.o, b.c), A = b.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[x][c] - n.globals.minX) / this.xRatio - s / 2);
                var S = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (y = r, w = r) : (y = r - y / p, w = r - w / p, v = r - b.h / p, m = r - b.l / p, A = r - b.m / p);
                var C = l.move(S, r), L = l.move(S + s / 2, y);
                return n.globals.previousPaths.length > 0 && (L = this.getPreviousPath(x, c, !0)), C = this.isBoxPlot ? [
                    l.move(S, y) + l.line(S + s / 2, y) + l.line(S + s / 2, v) + l.line(S + s / 4, v) + l.line(S + s - s / 4, v) + l.line(S + s / 2, v) + l.line(S + s / 2, y) + l.line(S + s, y) + l.line(S + s, A) + l.line(S, A) + l.line(S, y + o / 2),
                    l.move(S, A) + l.line(S + s, A) + l.line(S + s, w) + l.line(S + s / 2, w) + l.line(S + s / 2, m) + l.line(S + s - s / 4, m) + l.line(S + s / 4, m) + l.line(S + s / 2, m) + l.line(S + s / 2, w) + l.line(S, w) + l.line(S, A) + "z"
                ] : [
                    l.move(S, w) + l.line(S + s / 2, w) + l.line(S + s / 2, v) + l.line(S + s / 2, w) + l.line(S + s, w) + l.line(S + s, y) + l.line(S + s / 2, y) + l.line(S + s / 2, m) + l.line(S + s / 2, y) + l.line(S, y) + l.line(S, w - o / 2)
                ], L += l.move(S, y), n.globals.isXNumeric || (i += a), {
                    pathTo: C,
                    pathFrom: L,
                    x: i,
                    y: w,
                    barXPosition: S,
                    color: this.isBoxPlot ? f : d ? [
                        g
                    ] : [
                        u
                    ]
                };
            }
        },
        {
            key: "drawHorizontalBoxPaths",
            value: function(t) {
                var e = t.indexes;
                t.x;
                var i = t.y, a = t.yDivision, s = t.barHeight, r = t.zeroW, o = t.strokeWidth, n = this.w, l = new k(this.ctx), h = e.i, c = e.j, d = this.boxOptions.colors.lower;
                this.isBoxPlot && (d = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var g = this.invertedYRatio, u = e.realIndex, f = this.getOHLCValue(u, c), p = r, x = r, b = Math.min(f.o, f.c), v = Math.max(f.o, f.c), m = f.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[u][c] - n.globals.minX) / this.invertedXRatio - s / 2);
                var y = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (b = r, v = r) : (b = r + b / g, v = r + v / g, p = r + f.h / g, x = r + f.l / g, m = r + f.m / g);
                var w = l.move(r, y), A = l.move(b, y + s / 2);
                return n.globals.previousPaths.length > 0 && (A = this.getPreviousPath(u, c, !0)), w = [
                    l.move(b, y) + l.line(b, y + s / 2) + l.line(p, y + s / 2) + l.line(p, y + s / 2 - s / 4) + l.line(p, y + s / 2 + s / 4) + l.line(p, y + s / 2) + l.line(b, y + s / 2) + l.line(b, y + s) + l.line(m, y + s) + l.line(m, y) + l.line(b + o / 2, y),
                    l.move(m, y) + l.line(m, y + s) + l.line(v, y + s) + l.line(v, y + s / 2) + l.line(x, y + s / 2) + l.line(x, y + s - s / 4) + l.line(x, y + s / 4) + l.line(x, y + s / 2) + l.line(v, y + s / 2) + l.line(v, y) + l.line(m, y) + "z"
                ], A += l.move(b, y), n.globals.isXNumeric || (i += a), {
                    pathTo: w,
                    pathFrom: A,
                    x: v,
                    y: i,
                    barYPosition: y,
                    color: d
                };
            }
        },
        {
            key: "getOHLCValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    o: this.isBoxPlot ? i.globals.seriesCandleH[t][e] : i.globals.seriesCandleO[t][e],
                    h: this.isBoxPlot ? i.globals.seriesCandleO[t][e] : i.globals.seriesCandleH[t][e],
                    m: i.globals.seriesCandleM[t][e],
                    l: this.isBoxPlot ? i.globals.seriesCandleC[t][e] : i.globals.seriesCandleL[t][e],
                    c: this.isBoxPlot ? i.globals.seriesCandleL[t][e] : i.globals.seriesCandleC[t][e]
                };
            }
        }
    ]), a;
}(), Pt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "checkColorRange",
            value: function() {
                var t = this.w, e = !1, i = t.config.plotOptions[t.config.chart.type];
                return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(t, i) {
                    t.from <= 0 && (e = !0);
                }), e;
            }
        },
        {
            key: "getShadeColor",
            value: function(t, e, i, a) {
                var s = this.w, r = 1, o = s.config.plotOptions[t].shadeIntensity, n = this.determineColor(t, e, i);
                s.globals.hasNegs || a ? r = s.config.plotOptions[t].reverseNegativeShade ? n.percent < 0 ? n.percent / 100 * (1.25 * o) : (1 - n.percent / 100) * (1.25 * o) : n.percent <= 0 ? 1 - (1 + n.percent / 100) * o : (1 - n.percent / 100) * o : (r = 1 - n.percent / 100, "treemap" === t && (r = (1 - n.percent / 100) * (1.25 * o)));
                var l = n.color, h = new m;
                if (s.config.plotOptions[t].enableShades) {
                    if ("dark" === this.w.config.theme.mode) {
                        var c = h.shadeColor(-1 * r, n.color);
                        l = m.hexToRgba(m.isColorHex(c) ? c : m.rgb2hex(c), s.config.fill.opacity);
                    } else {
                        var d = h.shadeColor(r, n.color);
                        l = m.hexToRgba(m.isColorHex(d) ? d : m.rgb2hex(d), s.config.fill.opacity);
                    }
                }
                return {
                    color: l,
                    colorProps: n
                };
            }
        },
        {
            key: "determineColor",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.series[e][i], r = a.config.plotOptions[t], o = r.colorScale.inverse ? i : e;
                r.distributed && "treemap" === a.config.chart.type && (o = i);
                var n = a.globals.colors[o], l = null, h = Math.min.apply(Math, p(a.globals.series[e])), c = Math.max.apply(Math, p(a.globals.series[e]));
                r.distributed || "heatmap" !== t || (h = a.globals.minY, c = a.globals.maxY), void 0 !== r.colorScale.min && (h = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, c = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                var d = Math.abs(c) + Math.abs(h), g = 100 * s / (0 === d ? d - 1e-6 : d);
                r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(t, e) {
                    if (s >= t.from && s <= t.to) {
                        n = t.color, l = t.foreColor ? t.foreColor : null, h = t.from, c = t.to;
                        var i = Math.abs(c) + Math.abs(h);
                        g = 100 * s / (0 === i ? i - 1e-6 : i);
                    }
                });
                return {
                    color: n,
                    foreColor: l,
                    percent: g
                };
            }
        },
        {
            key: "calculateDataLabels",
            value: function(t) {
                var e = t.text, i = t.x, a = t.y, s = t.i, r = t.j, o = t.colorProps, n = t.fontSize, l = this.w.config.dataLabels, h = new k(this.ctx), c = new G(this.ctx), d = null;
                if (l.enabled) {
                    d = h.group({
                        class: "apexcharts-data-labels"
                    });
                    var g = l.offsetX, u = l.offsetY, f = i + g, p = a + parseFloat(l.style.fontSize) / 3 + u;
                    c.plotDataLabelsText({
                        x: f,
                        y: p,
                        text: e,
                        i: s,
                        j: r,
                        color: o.foreColor,
                        parent: d,
                        fontSize: n,
                        dataLabelsConfig: l
                    });
                }
                return d;
            }
        },
        {
            key: "addListeners",
            value: function(t) {
                var e = new k(this.ctx);
                t.node.addEventListener("mouseenter", e.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", e.pathMouseLeave.bind(this, t)), t.node.addEventListener("mousedown", e.pathMouseDown.bind(this, t));
            }
        }
    ]), t;
}(), Mt = function() {
    function t(e, a) {
        i(this, t), this.ctx = e, this.w = e.w, this.xRatio = a.xRatio, this.yRatio = a.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new Pt(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
    }
    return s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = i.group({
                    class: "apexcharts-heatmap"
                });
                a.attr("clip-path", "url(#gridRectMask".concat(e.globals.cuid, ")"));
                var s = e.globals.gridWidth / e.globals.dataPoints, r = e.globals.gridHeight / e.globals.series.length, o = 0, n = !1;
                this.negRange = this.helpers.checkColorRange();
                var l = t.slice();
                e.config.yaxis[0].reversed && (n = !0, l.reverse());
                for(var h = n ? 0 : l.length - 1; n ? h < l.length : h >= 0; n ? h++ : h--){
                    var c = i.group({
                        class: "apexcharts-series apexcharts-heatmap-series",
                        seriesName: m.escapeString(e.globals.seriesNames[h]),
                        rel: h + 1,
                        "data:realIndex": h
                    });
                    if (this.ctx.series.addCollapsedClassToSeries(c, h), e.config.chart.dropShadow.enabled) {
                        var d = e.config.chart.dropShadow;
                        new w(this.ctx).dropShadow(c, d, h);
                    }
                    for(var g = 0, u = e.config.plotOptions.heatmap.shadeIntensity, f = 0; f < l[h].length; f++){
                        var p = this.helpers.getShadeColor(e.config.chart.type, h, f, this.negRange), x = p.color, b = p.colorProps;
                        if ("image" === e.config.fill.type) x = new N(this.ctx).fillPath({
                            seriesNumber: h,
                            dataPointIndex: f,
                            opacity: e.globals.hasNegs ? b.percent < 0 ? 1 - (1 + b.percent / 100) : u + b.percent / 100 : b.percent / 100,
                            patternID: m.randomId(),
                            width: e.config.fill.image.width ? e.config.fill.image.width : s,
                            height: e.config.fill.image.height ? e.config.fill.image.height : r
                        });
                        var v = this.rectRadius, y = i.drawRect(g, o, s, r, v);
                        if (y.attr({
                            cx: g,
                            cy: o
                        }), y.node.classList.add("apexcharts-heatmap-rect"), c.add(y), y.attr({
                            fill: x,
                            i: h,
                            index: h,
                            j: f,
                            val: t[h][f],
                            "stroke-width": this.strokeWidth,
                            stroke: e.config.plotOptions.heatmap.useFillColorAsStroke ? x : e.globals.stroke.colors[0],
                            color: x
                        }), this.helpers.addListeners(y), e.config.chart.animations.enabled && !e.globals.dataChanged) {
                            var A = 1;
                            e.globals.resized || (A = e.config.chart.animations.speed), this.animateHeatMap(y, g, o, s, r, A);
                        }
                        if (e.globals.dataChanged) {
                            var S = 1;
                            if (this.dynamicAnim.enabled && e.globals.shouldAnimate) {
                                S = this.dynamicAnim.speed;
                                var C = e.globals.previousPaths[h] && e.globals.previousPaths[h][f] && e.globals.previousPaths[h][f].color;
                                C || (C = "rgba(255, 255, 255, 0)"), this.animateHeatColor(y, m.isColorHex(C) ? C : m.rgb2hex(C), m.isColorHex(x) ? x : m.rgb2hex(x), S);
                            }
                        }
                        var L = (0, e.config.dataLabels.formatter)(e.globals.series[h][f], {
                            value: e.globals.series[h][f],
                            seriesIndex: h,
                            dataPointIndex: f,
                            w: e
                        }), P = this.helpers.calculateDataLabels({
                            text: L,
                            x: g + s / 2,
                            y: o + r / 2,
                            i: h,
                            j: f,
                            colorProps: b,
                            series: l
                        });
                        null !== P && c.add(P), g += s;
                    }
                    o += r, a.add(c);
                }
                var M = e.globals.yAxisScale[0].result.slice();
                return e.config.yaxis[0].reversed ? M.unshift("") : M.push(""), e.globals.yAxisScale[0].result = M, a;
            }
        },
        {
            key: "animateHeatMap",
            value: function(t, e, i, a, s, r) {
                var o = new y(this.ctx);
                o.animateRect(t, {
                    x: e + a / 2,
                    y: i + s / 2,
                    width: 0,
                    height: 0
                }, {
                    x: e,
                    y: i,
                    width: a,
                    height: s
                }, r, function() {
                    o.animationCompleted(t);
                });
            }
        },
        {
            key: "animateHeatColor",
            value: function(t, e, i, a) {
                t.attr({
                    fill: e
                }).animate(a).attr({
                    fill: i
                });
            }
        }
    ]), t;
}(), It = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "drawYAxisTexts",
            value: function(t, e, i, a) {
                var s = this.w, r = s.config.yaxis[0], o = s.globals.yLabelFormatters[0];
                return new k(this.ctx).drawText({
                    x: t + r.labels.offsetX,
                    y: e + r.labels.offsetY,
                    text: o(a, i),
                    textAnchor: "middle",
                    fontSize: r.labels.style.fontSize,
                    fontFamily: r.labels.style.fontFamily,
                    foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                });
            }
        }
    ]), t;
}(), Tt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
            0
        ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = void 0 !== a.globals.stroke.colors ? a.globals.stroke.colors : a.globals.colors, this.defaultSize = Math.min(a.globals.gridWidth, a.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = a.globals.gridWidth / 2, "radialBar" === a.config.chart.type ? this.fullAngle = 360 : this.fullAngle = Math.abs(a.config.plotOptions.pie.endAngle - a.config.plotOptions.pie.startAngle), this.initialAngle = a.config.plotOptions.pie.startAngle % this.fullAngle, a.globals.radialSize = this.defaultSize / 2.05 - a.config.stroke.width - (a.config.chart.sparkline.enabled ? 0 : a.config.chart.dropShadow.blur), this.donutSize = a.globals.radialSize * parseInt(a.config.plotOptions.pie.donut.size, 10) / 100;
        var s = a.config.plotOptions.pie.customScale, r = a.globals.gridWidth / 2, o = a.globals.gridHeight / 2;
        this.translateX = r - r * s, this.translateY = o - o * s, this.dataLabelsGroup = new k(this.ctx).group({
            class: "apexcharts-datalabels-group",
            transform: "translate(".concat(this.translateX, ", ").concat(this.translateY, ") scale(").concat(s, ")")
        }), this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
    }
    return s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new k(this.ctx), s = a.group({
                    class: "apexcharts-pie"
                });
                if (i.globals.noData) return s;
                for(var r = 0, o = 0; o < t.length; o++)r += m.negToZero(t[o]);
                var n = [], l = a.group();
                0 === r && (r = 1e-5), t.forEach(function(t) {
                    e.maxY = Math.max(e.maxY, t);
                }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), "back" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(s);
                for(var h = 0; h < t.length; h++){
                    var c = this.fullAngle * m.negToZero(t[h]) / r;
                    n.push(c), "polarArea" === this.chartType ? (n[h] = this.fullAngle / t.length, this.sliceSizes.push(i.globals.radialSize * t[h] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                }
                if (i.globals.dataChanged) {
                    for(var d, g = 0, u = 0; u < i.globals.previousPaths.length; u++)g += m.negToZero(i.globals.previousPaths[u]);
                    for(var f = 0; f < i.globals.previousPaths.length; f++)d = this.fullAngle * m.negToZero(i.globals.previousPaths[f]) / g, this.prevSectorAngleArr.push(d);
                }
                if (this.donutSize < 0 && (this.donutSize = 0), "donut" === this.chartType) {
                    var p = a.drawCircle(this.donutSize);
                    p.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                    }), l.add(p);
                }
                var x = this.drawArcs(n, t);
                if (this.sliceLabels.forEach(function(t) {
                    x.add(t);
                }), l.attr({
                    transform: "translate(".concat(this.translateX, ", ").concat(this.translateY, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                }), l.add(x), s.add(l), this.donutDataLabels.show) {
                    var b = this.renderInnerDataLabels(this.dataLabelsGroup, this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show
                    });
                    s.add(b);
                }
                return "front" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(s), s;
            }
        },
        {
            key: "drawArcs",
            value: function(t, e) {
                var i = this.w, a = new w(this.ctx), s = new k(this.ctx), r = new N(this.ctx), o = s.group({
                    class: "apexcharts-slices"
                }), n = this.initialAngle, l = this.initialAngle, h = this.initialAngle, c = this.initialAngle;
                this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                for(var d = 0; d < t.length; d++){
                    var g = s.group({
                        class: "apexcharts-series apexcharts-pie-series",
                        seriesName: m.escapeString(i.globals.seriesNames[d]),
                        rel: d + 1,
                        "data:realIndex": d
                    });
                    o.add(g), l = c, h = (n = h) + t[d], c = l + this.prevSectorAngleArr[d];
                    var u = h < n ? this.fullAngle + h - n : h - n, f = r.fillPath({
                        seriesNumber: d,
                        size: this.sliceSizes[d],
                        value: e[d]
                    }), p = this.getChangedPath(l, c), x = s.drawPath({
                        d: p,
                        stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[d] : this.lineColorArr,
                        strokeWidth: 0,
                        fill: f,
                        fillOpacity: i.config.fill.opacity,
                        classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(d)
                    });
                    if (x.attr({
                        index: 0,
                        j: d
                    }), a.setSelectionFilter(x, 0, d), i.config.chart.dropShadow.enabled) {
                        var b = i.config.chart.dropShadow;
                        a.dropShadow(x, b, d);
                    }
                    this.addListeners(x, this.donutDataLabels), k.setAttrs(x.node, {
                        "data:angle": u,
                        "data:startAngle": n,
                        "data:strokeWidth": this.strokeWidth,
                        "data:value": e[d]
                    });
                    var v = {
                        x: 0,
                        y: 0
                    };
                    "pie" === this.chartType || "polarArea" === this.chartType ? v = m.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle) : "donut" === this.chartType && (v = m.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle)), g.add(x);
                    var y = 0;
                    if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : (0 === (y = u / this.fullAngle * i.config.chart.animations.speed) && (y = 1), this.animDur = y + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(x, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        prevStartAngle: l,
                        prevEndAngle: c,
                        animateStartingPos: !0,
                        i: d,
                        animBeginArr: this.animBeginArr,
                        shouldSetPrevPaths: !0,
                        dur: i.config.chart.animations.dynamicAnimation.speed
                    }) : this.animatePaths(x, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        i: d,
                        totalItems: t.length - 1,
                        animBeginArr: this.animBeginArr,
                        dur: y
                    }), i.config.plotOptions.pie.expandOnClick && "polarArea" !== this.chartType && x.node.addEventListener("mouseup", this.pieClicked.bind(this, d)), void 0 !== i.globals.selectedDataPoints[0] && i.globals.selectedDataPoints[0].indexOf(d) > -1 && this.pieClicked(d), i.config.dataLabels.enabled) {
                        var A = v.x, S = v.y, C = 100 * u / this.fullAngle + "%";
                        if (0 !== u && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < t[d]) {
                            var L = i.config.dataLabels.formatter;
                            void 0 !== L && (C = L(i.globals.seriesPercent[d][0], {
                                seriesIndex: d,
                                w: i
                            }));
                            var P = i.globals.dataLabels.style.colors[d], M = s.group({
                                class: "apexcharts-datalabels"
                            }), I = s.drawText({
                                x: A,
                                y: S,
                                text: C,
                                textAnchor: "middle",
                                fontSize: i.config.dataLabels.style.fontSize,
                                fontFamily: i.config.dataLabels.style.fontFamily,
                                fontWeight: i.config.dataLabels.style.fontWeight,
                                foreColor: P
                            });
                            if (M.add(I), i.config.dataLabels.dropShadow.enabled) {
                                var T = i.config.dataLabels.dropShadow;
                                a.dropShadow(I, T);
                            }
                            I.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && !1 === i.globals.resized && (I.node.classList.add("apexcharts-pie-label-delay"), I.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(M);
                        }
                    }
                }
                return o;
            }
        },
        {
            key: "addListeners",
            value: function(t, e) {
                var i = new k(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, t)), t.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this, t)), this.donutDataLabels.total.showAlways || (t.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, t.node, e)));
            }
        },
        {
            key: "animatePaths",
            value: function(t, e) {
                var i = this.w, a = e.endAngle < e.startAngle ? this.fullAngle + e.endAngle - e.startAngle : e.endAngle - e.startAngle, s = a, r = e.startAngle, o = e.startAngle;
                void 0 !== e.prevStartAngle && void 0 !== e.prevEndAngle && (r = e.prevEndAngle, s = e.prevEndAngle < e.prevStartAngle ? this.fullAngle + e.prevEndAngle - e.prevStartAngle : e.prevEndAngle - e.prevStartAngle), e.i === i.config.series.length - 1 && (a + o > this.fullAngle ? e.endAngle = e.endAngle - (a + o) : a + o < this.fullAngle && (e.endAngle = e.endAngle + (this.fullAngle - (a + o)))), a === this.fullAngle && (a = this.fullAngle - .01), this.animateArc(t, r, o, a, s, e);
            }
        },
        {
            key: "animateArc",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = this.w, h = new y(this.ctx), c = r.size;
                (isNaN(e) || isNaN(s)) && (e = i, s = a, r.dur = 0);
                var d = a, g = i, u = e < i ? this.fullAngle + e - i : e - i;
                l.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (o = n.getPiePath({
                    me: n,
                    startAngle: r.prevStartAngle,
                    angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                    size: c
                }), t.attr({
                    d: o
                })), 0 !== r.dur ? t.animate(r.dur, l.globals.easing, r.animBeginArr[r.i]).afterAll(function() {
                    "pie" !== n.chartType && "donut" !== n.chartType && "polarArea" !== n.chartType || this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({
                        "stroke-width": n.strokeWidth
                    }), r.i === l.config.series.length - 1 && h.animationCompleted(t);
                }).during(function(l) {
                    d = u + (a - u) * l, r.animateStartingPos && (d = s + (a - s) * l, g = e - s + (i - (e - s)) * l), o = n.getPiePath({
                        me: n,
                        startAngle: g,
                        angle: d,
                        size: c
                    }), t.node.setAttribute("data:pathOrig", o), t.attr({
                        d: o
                    });
                }) : (o = n.getPiePath({
                    me: n,
                    startAngle: g,
                    angle: a,
                    size: c
                }), r.isTrack || (l.globals.animationEnded = !0), t.node.setAttribute("data:pathOrig", o), t.attr({
                    d: o,
                    "stroke-width": n.strokeWidth
                }));
            }
        },
        {
            key: "pieClicked",
            value: function(t) {
                var e, i = this.w, a = this, s = a.sliceSizes[t] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(t)).members[0];
                if ("true" !== r.attr("data:pieClicked")) {
                    var o = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                    Array.prototype.forEach.call(o, function(t) {
                        t.setAttribute("data:pieClicked", "false");
                        var e = t.getAttribute("data:pathOrig");
                        e && t.setAttribute("d", e);
                    }), i.globals.capturedDataPointIndex = t, r.attr("data:pieClicked", "true");
                    var n = parseInt(r.attr("data:startAngle"), 10), l = parseInt(r.attr("data:angle"), 10);
                    e = a.getPiePath({
                        me: a,
                        startAngle: n,
                        angle: l,
                        size: s
                    }), 360 !== l && r.plot(e);
                } else {
                    r.attr({
                        "data:pieClicked": "false"
                    }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                    var h = r.attr("data:pathOrig");
                    r.attr({
                        d: h
                    });
                }
            }
        },
        {
            key: "getChangedPath",
            value: function(t, e) {
                var i = "";
                return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                    me: this,
                    startAngle: t,
                    angle: e - t,
                    size: this.size
                })), i;
            }
        },
        {
            key: "getPiePath",
            value: function(t) {
                var e, i = t.me, a = t.startAngle, s = t.angle, r = t.size, o = new k(this.ctx), n = a, l = Math.PI * (n - 90) / 180, h = s + a;
                Math.ceil(h) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (h = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - .01), Math.ceil(h) > this.fullAngle && (h -= this.fullAngle);
                var c = Math.PI * (h - 90) / 180, d = i.centerX + r * Math.cos(l), g = i.centerY + r * Math.sin(l), u = i.centerX + r * Math.cos(c), f = i.centerY + r * Math.sin(c), p = m.polarToCartesian(i.centerX, i.centerY, i.donutSize, h), x = m.polarToCartesian(i.centerX, i.centerY, i.donutSize, n), b = s > 180 ? 1 : 0, v = [
                    "M",
                    d,
                    g,
                    "A",
                    r,
                    r,
                    0,
                    b,
                    1,
                    u,
                    f
                ];
                return e = "donut" === i.chartType ? [].concat(v, [
                    "L",
                    p.x,
                    p.y,
                    "A",
                    i.donutSize,
                    i.donutSize,
                    0,
                    b,
                    0,
                    x.x,
                    x.y,
                    "L",
                    d,
                    g,
                    "z"
                ]).join(" ") : "pie" === i.chartType || "polarArea" === i.chartType ? [].concat(v, [
                    "L",
                    i.centerX,
                    i.centerY,
                    "L",
                    d,
                    g
                ]).join(" ") : [].concat(v).join(" "), o.roundPathCorners(e, 2 * this.strokeWidth);
            }
        },
        {
            key: "drawPolarElements",
            value: function(t) {
                var e = this.w, i = new $(this.ctx), a = new k(this.ctx), s = new It(this.ctx), r = a.group(), o = a.group(), n = i.niceScale(0, Math.ceil(this.maxY), 0), l = n.result.reverse(), h = n.result.length;
                this.maxY = n.niceMax;
                for(var c = e.globals.radialSize, d = c / (h - 1), g = 0; g < h - 1; g++){
                    var u = a.drawCircle(c);
                    if (u.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: "none",
                        "stroke-width": e.config.plotOptions.polarArea.rings.strokeWidth,
                        stroke: e.config.plotOptions.polarArea.rings.strokeColor
                    }), e.config.yaxis[0].show) {
                        var f = s.drawYAxisTexts(this.centerX, this.centerY - c + parseInt(e.config.yaxis[0].labels.style.fontSize, 10) / 2, g, l[g]);
                        o.add(f);
                    }
                    r.add(u), c -= d;
                }
                this.drawSpokes(t), t.add(r), t.add(o);
            }
        },
        {
            key: "renderInnerDataLabels",
            value: function(t, e, i) {
                var a = this.w, s = new k(this.ctx), r = e.total.show;
                t.node.innerHTML = "", t.node.style.opacity = i.opacity;
                var o, n, l = i.centerX, h = this.donutDataLabels.total.label ? i.centerY : i.centerY - i.centerY / 6;
                o = void 0 === e.name.color ? a.globals.colors[0] : e.name.color;
                var c = e.name.fontSize, d = e.name.fontFamily, g = e.name.fontWeight;
                n = void 0 === e.value.color ? a.config.chart.foreColor : e.value.color;
                var u = e.value.formatter, f = "", p = "";
                if (r ? (o = e.total.color, c = e.total.fontSize, d = e.total.fontFamily, g = e.total.fontWeight, p = this.donutDataLabels.total.label ? e.total.label : "", f = e.total.formatter(a)) : 1 === a.globals.series.length && (f = u(a.globals.series[0], a), p = a.globals.seriesNames[0]), p && (p = e.name.formatter(p, e.total.show, a)), e.name.show) {
                    var x = s.drawText({
                        x: l,
                        y: h + parseFloat(e.name.offsetY),
                        text: p,
                        textAnchor: "middle",
                        foreColor: o,
                        fontSize: c,
                        fontWeight: g,
                        fontFamily: d
                    });
                    x.node.classList.add("apexcharts-datalabel-label"), t.add(x);
                }
                if (e.value.show) {
                    var b = e.name.show ? parseFloat(e.value.offsetY) + 16 : e.value.offsetY, v = s.drawText({
                        x: l,
                        y: h + b,
                        text: f,
                        textAnchor: "middle",
                        foreColor: n,
                        fontWeight: e.value.fontWeight,
                        fontSize: e.value.fontSize,
                        fontFamily: e.value.fontFamily
                    });
                    v.node.classList.add("apexcharts-datalabel-value"), t.add(v);
                }
                return t;
            }
        },
        {
            key: "printInnerLabels",
            value: function(t, e, i, a) {
                var s, r = this.w;
                a ? s = void 0 === t.name.color ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : t.name.color : r.globals.series.length > 1 && t.total.show && (s = t.total.color);
                var o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                i = (0, t.value.formatter)(i, r), a || "function" != typeof t.total.formatter || (i = t.total.formatter(r));
                var l = e === t.total.label;
                e = this.donutDataLabels.total.label ? t.name.formatter(e, l, r) : "", null !== o && (o.textContent = e), null !== n && (n.textContent = i), null !== o && (o.style.fill = s);
            }
        },
        {
            key: "printDataLabelsInner",
            value: function(t, e) {
                var i = this.w, a = t.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"), 10) - 1];
                i.globals.series.length > 1 && this.printInnerLabels(e, s, a, t);
                var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                null !== r && (r.style.opacity = 1);
            }
        },
        {
            key: "drawSpokes",
            value: function(t) {
                var e = this, i = this.w, a = new k(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                if (0 !== s.strokeWidth) {
                    for(var r = [], o = 360 / i.globals.series.length, n = 0; n < i.globals.series.length; n++)r.push(m.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + o * n));
                    r.forEach(function(i, r) {
                        var o = a.drawLine(i.x, i.y, e.centerX, e.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[r] : s.connectorColors);
                        t.add(o);
                    });
                }
            }
        },
        {
            key: "revertDataLabelsInner",
            value: function() {
                var t = this.w;
                if (this.donutDataLabels.show) {
                    var e = t.globals.dom.Paper.select(".apexcharts-datalabels-group").members[0], i = this.renderInnerDataLabels(e, this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show
                    });
                    t.globals.dom.Paper.select(".apexcharts-radialbar, .apexcharts-pie").members[0].add(i);
                }
            }
        }
    ]), t;
}(), zt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
        var a = this.w;
        this.graphics = new k(this.ctx), this.lineColorArr = void 0 !== a.globals.stroke.colors ? a.globals.stroke.colors : a.globals.colors, this.defaultSize = a.globals.svgHeight < a.globals.svgWidth ? a.globals.gridHeight : a.globals.gridWidth, this.isLog = a.config.yaxis[0].logarithmic, this.logBase = a.config.yaxis[0].logBase, this.coreUtils = new A(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(this.logBase, a.globals.maxY, 0) : a.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.logBase, this.w.globals.minY, 0) : a.globals.minY, this.polygons = a.config.plotOptions.radar.polygons, this.strokeWidth = a.config.stroke.show ? a.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - a.config.chart.dropShadow.blur, a.config.xaxis.labels.show && (this.size = this.size - a.globals.xAxisLabelsWidth / 1.75), void 0 !== a.config.plotOptions.radar.size && (this.size = a.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
    }
    return s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new N(this.ctx), s = [], r = new G(this.ctx);
                t.length && (this.dataPointsLen = t[i.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                var o = i.globals.gridWidth / 2, n = i.globals.gridHeight / 2, l = o + i.config.plotOptions.radar.offsetX, h = n + i.config.plotOptions.radar.offsetY, c = this.graphics.group({
                    class: "apexcharts-radar-series apexcharts-plot-series",
                    transform: "translate(".concat(l || 0, ", ").concat(h || 0, ")")
                }), d = [], u = null, f = null;
                if (this.yaxisLabels = this.graphics.group({
                    class: "apexcharts-yaxis"
                }), t.forEach(function(t, o) {
                    var n = t.length === i.globals.dataPoints, l = e.graphics.group().attr({
                        class: "apexcharts-series",
                        "data:longestSeries": n,
                        seriesName: m.escapeString(i.globals.seriesNames[o]),
                        rel: o + 1,
                        "data:realIndex": o
                    });
                    e.dataRadiusOfPercent[o] = [], e.dataRadius[o] = [], e.angleArr[o] = [], t.forEach(function(t, i) {
                        var a = Math.abs(e.maxValue - e.minValue);
                        t -= e.minValue, e.isLog && (t = e.coreUtils.getLogVal(e.logBase, t, 0)), e.dataRadiusOfPercent[o][i] = t / a, e.dataRadius[o][i] = e.dataRadiusOfPercent[o][i] * e.size, e.angleArr[o][i] = i * e.disAngle;
                    }), d = e.getDataPointsPos(e.dataRadius[o], e.angleArr[o]);
                    var h = e.createPaths(d, {
                        x: 0,
                        y: 0
                    });
                    u = e.graphics.group({
                        class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                    }), f = e.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": o
                    }), i.globals.delayedElements.push({
                        el: u.node,
                        index: o
                    });
                    var c = {
                        i: o,
                        realIndex: o,
                        animationDelay: o,
                        initialSpeed: i.config.chart.animations.speed,
                        dataChangeSpeed: i.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-radar",
                        shouldClipToGrid: !1,
                        bindEventsOnPaths: !1,
                        stroke: i.globals.stroke.colors[o],
                        strokeLineCap: i.config.stroke.lineCap
                    }, p = null;
                    i.globals.previousPaths.length > 0 && (p = e.getPreviousPath(o));
                    for(var x = 0; x < h.linePathsTo.length; x++){
                        var b = e.graphics.renderPaths(g(g({}, c), {}, {
                            pathFrom: null === p ? h.linePathsFrom[x] : p,
                            pathTo: h.linePathsTo[x],
                            strokeWidth: Array.isArray(e.strokeWidth) ? e.strokeWidth[o] : e.strokeWidth,
                            fill: "none",
                            drawShadow: !1
                        }));
                        l.add(b);
                        var v = a.fillPath({
                            seriesNumber: o
                        }), y = e.graphics.renderPaths(g(g({}, c), {}, {
                            pathFrom: null === p ? h.areaPathsFrom[x] : p,
                            pathTo: h.areaPathsTo[x],
                            strokeWidth: 0,
                            fill: v,
                            drawShadow: !1
                        }));
                        if (i.config.chart.dropShadow.enabled) {
                            var k = new w(e.ctx), A = i.config.chart.dropShadow;
                            k.dropShadow(y, Object.assign({}, A, {
                                noUserSpaceOnUse: !0
                            }), o);
                        }
                        l.add(y);
                    }
                    t.forEach(function(t, a) {
                        var s = new W(e.ctx).getMarkerConfig({
                            cssClass: "apexcharts-marker",
                            seriesIndex: o,
                            dataPointIndex: a
                        }), n = e.graphics.drawMarker(d[a].x, d[a].y, s);
                        n.attr("rel", a), n.attr("j", a), n.attr("index", o), n.node.setAttribute("default-marker-size", s.pSize);
                        var h = e.graphics.group({
                            class: "apexcharts-series-markers"
                        });
                        h && h.add(n), u.add(h), l.add(u);
                        var c = i.config.dataLabels;
                        if (c.enabled) {
                            var p = c.formatter(i.globals.series[o][a], {
                                seriesIndex: o,
                                dataPointIndex: a,
                                w: i
                            });
                            r.plotDataLabelsText({
                                x: d[a].x,
                                y: d[a].y,
                                text: p,
                                textAnchor: "middle",
                                i: o,
                                j: o,
                                parent: f,
                                offsetCorrection: !1,
                                dataLabelsConfig: g({}, c)
                            });
                        }
                        l.add(f);
                    }), s.push(l);
                }), this.drawPolygons({
                    parent: c
                }), i.config.xaxis.labels.show) {
                    var p = this.drawXAxisTexts();
                    c.add(p);
                }
                return s.forEach(function(t) {
                    c.add(t);
                }), c.add(this.yaxisLabels), c;
            }
        },
        {
            key: "drawPolygons",
            value: function(t) {
                for(var e = this, i = this.w, a = t.parent, s = new It(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), o = r.length, n = [], l = this.size / (o - 1), h = 0; h < o; h++)n[h] = l * h;
                n.reverse();
                var c = [], d = [];
                n.forEach(function(t, i) {
                    var a = m.getPolygonPos(t, e.dataPointsLen), s = "";
                    a.forEach(function(t, a) {
                        if (0 === i) {
                            var r = e.graphics.drawLine(t.x, t.y, 0, 0, Array.isArray(e.polygons.connectorColors) ? e.polygons.connectorColors[a] : e.polygons.connectorColors);
                            d.push(r);
                        }
                        0 === a && e.yaxisLabelsTextsPos.push({
                            x: t.x,
                            y: t.y
                        }), s += t.x + "," + t.y + " ";
                    }), c.push(s);
                }), c.forEach(function(t, s) {
                    var r = e.polygons.strokeColors, o = e.polygons.strokeWidth, n = e.graphics.drawPolygon(t, Array.isArray(r) ? r[s] : r, Array.isArray(o) ? o[s] : o, i.globals.radarPolygons.fill.colors[s]);
                    a.add(n);
                }), d.forEach(function(t) {
                    a.add(t);
                }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(t, i) {
                    var a = s.drawYAxisTexts(t.x, t.y, i, r[i]);
                    e.yaxisLabels.add(a);
                });
            }
        },
        {
            key: "drawXAxisTexts",
            value: function() {
                var t = this, e = this.w, i = e.config.xaxis.labels, a = this.graphics.group({
                    class: "apexcharts-xaxis"
                }), s = m.getPolygonPos(this.size, this.dataPointsLen);
                return e.globals.labels.forEach(function(r, o) {
                    var n = e.config.xaxis.labels.formatter, l = new G(t.ctx);
                    if (s[o]) {
                        var h = t.getTextPos(s[o], t.size), c = n(r, {
                            seriesIndex: -1,
                            dataPointIndex: o,
                            w: e
                        });
                        l.plotDataLabelsText({
                            x: h.newX,
                            y: h.newY,
                            text: c,
                            textAnchor: h.textAnchor,
                            i: o,
                            j: o,
                            parent: a,
                            className: "apexcharts-xaxis-label",
                            color: Array.isArray(i.style.colors) && i.style.colors[o] ? i.style.colors[o] : "#a8a8a8",
                            dataLabelsConfig: g({
                                textAnchor: h.textAnchor,
                                dropShadow: {
                                    enabled: !1
                                }
                            }, i),
                            offsetCorrection: !1
                        }).on("click", function(i) {
                            if ("function" == typeof e.config.chart.events.xAxisLabelClick) {
                                var a = Object.assign({}, e, {
                                    labelIndex: o
                                });
                                e.config.chart.events.xAxisLabelClick(i, t.ctx, a);
                            }
                        });
                    }
                }), a;
            }
        },
        {
            key: "createPaths",
            value: function(t, e) {
                var i = this, a = [], s = [], r = [], o = [];
                if (t.length) {
                    s = [
                        this.graphics.move(e.x, e.y)
                    ], o = [
                        this.graphics.move(e.x, e.y)
                    ];
                    var n = this.graphics.move(t[0].x, t[0].y), l = this.graphics.move(t[0].x, t[0].y);
                    t.forEach(function(e, a) {
                        n += i.graphics.line(e.x, e.y), l += i.graphics.line(e.x, e.y), a === t.length - 1 && (n += "Z", l += "Z");
                    }), a.push(n), r.push(l);
                }
                return {
                    linePathsFrom: s,
                    linePathsTo: a,
                    areaPathsFrom: o,
                    areaPathsTo: r
                };
            }
        },
        {
            key: "getTextPos",
            value: function(t, e) {
                var i = "middle", a = t.x, s = t.y;
                return Math.abs(t.x) >= 10 ? t.x > 0 ? (i = "start", a += 10) : t.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(t.y) >= e - 10 && (t.y < 0 ? s -= 10 : t.y > 0 && (s += 10)), {
                    textAnchor: i,
                    newX: a,
                    newY: s
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t) {
                for(var e = this.w, i = null, a = 0; a < e.globals.previousPaths.length; a++){
                    var s = e.globals.previousPaths[a];
                    s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(t, 10) && void 0 !== e.globals.previousPaths[a].paths[0] && (i = e.globals.previousPaths[a].paths[0].d);
                }
                return i;
            }
        },
        {
            key: "getDataPointsPos",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.dataPointsLen;
                t = t || [], e = e || [];
                for(var a = [], s = 0; s < i; s++){
                    var r = {};
                    r.x = t[s] * Math.sin(e[s]), r.y = -t[s] * Math.cos(e[s]), a.push(r);
                }
                return a;
            }
        }
    ]), t;
}(), Xt = function(t) {
    h(r, Tt);
    var a = o(r);
    function r(t) {
        var s;
        i(this, r), (s = a.call(this, t)).ctx = t, s.w = t.w, s.animBeginArr = [
            0
        ], s.animDur = 0;
        var o = s.w;
        return s.startAngle = o.config.plotOptions.radialBar.startAngle, s.endAngle = o.config.plotOptions.radialBar.endAngle, s.totalAngle = Math.abs(o.config.plotOptions.radialBar.endAngle - o.config.plotOptions.radialBar.startAngle), s.trackStartAngle = o.config.plotOptions.radialBar.track.startAngle, s.trackEndAngle = o.config.plotOptions.radialBar.track.endAngle, s.barLabels = s.w.config.plotOptions.radialBar.barLabels, s.donutDataLabels = s.w.config.plotOptions.radialBar.dataLabels, s.radialDataLabels = s.donutDataLabels, s.trackStartAngle || (s.trackStartAngle = s.startAngle), s.trackEndAngle || (s.trackEndAngle = s.endAngle), 360 === s.endAngle && (s.endAngle = 359.99), s.margin = parseInt(o.config.plotOptions.radialBar.track.margin, 10), s.onBarLabelClick = s.onBarLabelClick.bind(e(s)), s;
    }
    return s(r, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = i.group({
                    class: "apexcharts-radialbar"
                });
                if (e.globals.noData) return a;
                var s = i.group(), r = this.defaultSize / 2, o = e.globals.gridWidth / 2, n = this.defaultSize / 2.05;
                e.config.chart.sparkline.enabled || (n = n - e.config.stroke.width - e.config.chart.dropShadow.blur);
                var l = e.globals.fill.colors;
                if (e.config.plotOptions.radialBar.track.show) {
                    var h = this.drawTracks({
                        size: n,
                        centerX: o,
                        centerY: r,
                        colorArr: l,
                        series: t
                    });
                    s.add(h);
                }
                var c = this.drawArcs({
                    size: n,
                    centerX: o,
                    centerY: r,
                    colorArr: l,
                    series: t
                }), d = 360;
                e.config.plotOptions.radialBar.startAngle < 0 && (d = this.totalAngle);
                var g = (360 - d) / 360;
                if (e.globals.radialSize = n - n * g, this.radialDataLabels.value.show) {
                    var u = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                    e.globals.radialSize += u * g;
                }
                return s.add(c.g), "front" === e.config.plotOptions.radialBar.hollow.position && (c.g.add(c.elHollow), c.dataLabels && c.g.add(c.dataLabels)), a.add(s), a;
            }
        },
        {
            key: "drawTracks",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = i.group({
                    class: "apexcharts-tracks"
                }), s = new w(this.ctx), r = new N(this.ctx), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                for(var n = 0; n < t.series.length; n++){
                    var l = i.group({
                        class: "apexcharts-radialbar-track apexcharts-track"
                    });
                    a.add(l), l.attr({
                        rel: n + 1
                    }), t.size = t.size - o - this.margin;
                    var h = e.config.plotOptions.radialBar.track, c = r.fillPath({
                        seriesNumber: 0,
                        size: t.size,
                        fillColors: Array.isArray(h.background) ? h.background[n] : h.background,
                        solid: !0
                    }), d = this.trackStartAngle, g = this.trackEndAngle;
                    Math.abs(g) + Math.abs(d) >= 360 && (g = 360 - Math.abs(this.startAngle) - .1);
                    var u = i.drawPath({
                        d: "",
                        stroke: c,
                        strokeWidth: o * parseInt(h.strokeWidth, 10) / 100,
                        fill: "none",
                        strokeOpacity: h.opacity,
                        classes: "apexcharts-radialbar-area"
                    });
                    if (h.dropShadow.enabled) {
                        var f = h.dropShadow;
                        s.dropShadow(u, f);
                    }
                    l.add(u), u.attr("id", "apexcharts-radialbarTrack-" + n), this.animatePaths(u, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: g,
                        startAngle: d,
                        size: t.size,
                        i: n,
                        totalItems: 2,
                        animBeginArr: 0,
                        dur: 0,
                        isTrack: !0,
                        easing: e.globals.easing
                    });
                }
                return a;
            }
        },
        {
            key: "drawArcs",
            value: function(t) {
                var e = this.w, i = new k(this.ctx), a = new N(this.ctx), s = new w(this.ctx), r = i.group(), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                var n = e.config.plotOptions.radialBar.hollow.background, l = t.size - o * t.series.length - this.margin * t.series.length - o * parseInt(e.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, h = l - e.config.plotOptions.radialBar.hollow.margin;
                void 0 !== e.config.plotOptions.radialBar.hollow.image && (n = this.drawHollowImage(t, r, l, n));
                var c = this.drawHollow({
                    size: h,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    fill: n || "transparent"
                });
                if (e.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                    var d = e.config.plotOptions.radialBar.hollow.dropShadow;
                    s.dropShadow(c, d);
                }
                var g = 1;
                !this.radialDataLabels.total.show && e.globals.series.length > 1 && (g = 0);
                var u = null;
                if (this.radialDataLabels.show) {
                    var f = e.globals.dom.Paper.select(".apexcharts-datalabels-group").members[0];
                    u = this.renderInnerDataLabels(f, this.radialDataLabels, {
                        hollowSize: l,
                        centerX: t.centerX,
                        centerY: t.centerY,
                        opacity: g
                    });
                }
                "back" === e.config.plotOptions.radialBar.hollow.position && (r.add(c), u && r.add(u));
                var p = !1;
                e.config.plotOptions.radialBar.inverseOrder && (p = !0);
                for(var x = p ? t.series.length - 1 : 0; p ? x >= 0 : x < t.series.length; p ? x-- : x++){
                    var b = i.group({
                        class: "apexcharts-series apexcharts-radial-series",
                        seriesName: m.escapeString(e.globals.seriesNames[x])
                    });
                    r.add(b), b.attr({
                        rel: x + 1,
                        "data:realIndex": x
                    }), this.ctx.series.addCollapsedClassToSeries(b, x), t.size = t.size - o - this.margin;
                    var v = a.fillPath({
                        seriesNumber: x,
                        size: t.size,
                        value: t.series[x]
                    }), y = this.startAngle, A = void 0, S = m.negToZero(t.series[x] > 100 ? 100 : t.series[x]) / 100, C = Math.round(this.totalAngle * S) + this.startAngle, L = void 0;
                    e.globals.dataChanged && (A = this.startAngle, L = Math.round(this.totalAngle * m.negToZero(e.globals.previousPaths[x]) / 100) + A), Math.abs(C) + Math.abs(y) > 360 && (C -= .01), Math.abs(L) + Math.abs(A) > 360 && (L -= .01);
                    var P = C - y, M = Array.isArray(e.config.stroke.dashArray) ? e.config.stroke.dashArray[x] : e.config.stroke.dashArray, I = i.drawPath({
                        d: "",
                        stroke: v,
                        strokeWidth: o,
                        fill: "none",
                        fillOpacity: e.config.fill.opacity,
                        classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + x,
                        strokeDashArray: M
                    });
                    if (k.setAttrs(I.node, {
                        "data:angle": P,
                        "data:value": t.series[x]
                    }), e.config.chart.dropShadow.enabled) {
                        var T = e.config.chart.dropShadow;
                        s.dropShadow(I, T, x);
                    }
                    if (s.setSelectionFilter(I, 0, x), this.addListeners(I, this.radialDataLabels), b.add(I), I.attr({
                        index: 0,
                        j: x
                    }), this.barLabels.enabled) {
                        var z = m.polarToCartesian(t.centerX, t.centerY, t.size, y), X = this.barLabels.formatter(e.globals.seriesNames[x], {
                            seriesIndex: x,
                            w: e
                        }), E = [
                            "apexcharts-radialbar-label"
                        ];
                        this.barLabels.onClick || E.push("apexcharts-no-click");
                        var Y = this.barLabels.useSeriesColors ? e.globals.colors[x] : e.config.chart.foreColor;
                        Y || (Y = e.config.chart.foreColor);
                        var R = z.x + this.barLabels.offsetX, F = z.y + this.barLabels.offsetY, D = i.drawText({
                            x: R,
                            y: F,
                            text: X,
                            textAnchor: "end",
                            dominantBaseline: "middle",
                            fontFamily: this.barLabels.fontFamily,
                            fontWeight: this.barLabels.fontWeight,
                            fontSize: this.barLabels.fontSize,
                            foreColor: Y,
                            cssClass: E.join(" ")
                        });
                        D.on("click", this.onBarLabelClick), D.attr({
                            rel: x + 1
                        }), 0 !== y && D.attr({
                            "transform-origin": "".concat(R, " ").concat(F),
                            transform: "rotate(".concat(y, " 0 0)")
                        }), b.add(D);
                    }
                    var H = 0;
                    !this.initialAnim || e.globals.resized || e.globals.dataChanged || (H = e.config.chart.animations.speed), e.globals.dataChanged && (H = e.config.chart.animations.dynamicAnimation.speed), this.animDur = H / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(I, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: C,
                        startAngle: y,
                        prevEndAngle: L,
                        prevStartAngle: A,
                        size: t.size,
                        i: x,
                        totalItems: 2,
                        animBeginArr: this.animBeginArr,
                        dur: H,
                        shouldSetPrevPaths: !0,
                        easing: e.globals.easing
                    });
                }
                return {
                    g: r,
                    elHollow: c,
                    dataLabels: u
                };
            }
        },
        {
            key: "drawHollow",
            value: function(t) {
                var e = new k(this.ctx).drawCircle(2 * t.size);
                return e.attr({
                    class: "apexcharts-radialbar-hollow",
                    cx: t.centerX,
                    cy: t.centerY,
                    r: t.size,
                    fill: t.fill
                }), e;
            }
        },
        {
            key: "drawHollowImage",
            value: function(t, e, i, a) {
                var s = this.w, r = new N(this.ctx), o = m.randomId(), n = s.config.plotOptions.radialBar.hollow.image;
                if (s.config.plotOptions.radialBar.hollow.imageClipped) r.clippedImgArea({
                    width: i,
                    height: i,
                    image: n,
                    patternID: "pattern".concat(s.globals.cuid).concat(o)
                }), a = "url(#pattern".concat(s.globals.cuid).concat(o, ")");
                else {
                    var l = s.config.plotOptions.radialBar.hollow.imageWidth, h = s.config.plotOptions.radialBar.hollow.imageHeight;
                    if (void 0 === l && void 0 === h) {
                        var c = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - e.width / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - e.height / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY);
                        });
                        e.add(c);
                    } else {
                        var d = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - l / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - h / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(l, h);
                        });
                        e.add(d);
                    }
                }
                return a;
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t) {
                var e = this.w;
                return t.size * (100 - parseInt(e.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (t.series.length + 1) - this.margin;
            }
        },
        {
            key: "onBarLabelClick",
            value: function(t) {
                var e = parseInt(t.target.getAttribute("rel"), 10) - 1, i = this.barLabels.onClick, a = this.w;
                i && i(a.globals.seriesNames[e], {
                    w: a,
                    seriesIndex: e
                });
            }
        }
    ]), r;
}(), Et = function(t) {
    h(a, St);
    var e = o(a);
    function a() {
        return i(this, a), e.apply(this, arguments);
    }
    return s(a, [
        {
            key: "draw",
            value: function(t, e) {
                var i = this.w, a = new k(this.ctx);
                this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = t, this.seriesRangeStart = i.globals.seriesRangeStart, this.seriesRangeEnd = i.globals.seriesRangeEnd, this.barHelpers.initVariables(t);
                for(var s = a.group({
                    class: "apexcharts-rangebar-series apexcharts-plot-series"
                }), r = 0; r < t.length; r++){
                    var o, n, l, h, c = void 0, d = void 0, u = i.globals.comboCharts ? e[r] : r, f = this.barHelpers.getGroupIndex(u).columnGroupIndex, p = a.group({
                        class: "apexcharts-series",
                        seriesName: m.escapeString(i.globals.seriesNames[u]),
                        rel: r + 1,
                        "data:realIndex": u
                    });
                    this.ctx.series.addCollapsedClassToSeries(p, u), t[r].length > 0 && (this.visibleI = this.visibleI + 1);
                    var x = 0, b = 0, v = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = i.globals.seriesYAxisReverseMap[u][0], v = u);
                    var y = this.barHelpers.initialPositions();
                    d = y.y, h = y.zeroW, c = y.x, b = y.barWidth, x = y.barHeight, o = y.xDivision, n = y.yDivision, l = y.zeroH;
                    for(var w = a.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": u
                    }), A = a.group({
                        class: "apexcharts-rangebar-goals-markers"
                    }), S = 0; S < i.globals.dataPoints; S++){
                        var C = this.barHelpers.getStrokeWidth(r, S, u), L = this.seriesRangeStart[r][S], P = this.seriesRangeEnd[r][S], M = null, I = null, T = null, z = {
                            x: c,
                            y: d,
                            strokeWidth: C,
                            elSeries: p
                        }, X = this.seriesLen;
                        if (i.config.plotOptions.bar.rangeBarGroupRows && (X = 1), void 0 === i.config.series[r].data[S]) break;
                        if (this.isHorizontal) {
                            T = d + x * this.visibleI;
                            var E = (n - x * X) / 2;
                            if (i.config.series[r].data[S].x) {
                                var Y = this.detectOverlappingBars({
                                    i: r,
                                    j: S,
                                    barYPosition: T,
                                    srty: E,
                                    barHeight: x,
                                    yDivision: n,
                                    initPositions: y
                                });
                                x = Y.barHeight, T = Y.barYPosition;
                            }
                            b = (M = this.drawRangeBarPaths(g({
                                indexes: {
                                    i: r,
                                    j: S,
                                    realIndex: u
                                },
                                barHeight: x,
                                barYPosition: T,
                                zeroW: h,
                                yDivision: n,
                                y1: L,
                                y2: P
                            }, z))).barWidth;
                        } else {
                            i.globals.isXNumeric && (c = (i.globals.seriesX[r][S] - i.globals.minX) / this.xRatio - b / 2), I = c + b * this.visibleI;
                            var R = (o - b * X) / 2;
                            if (i.config.series[r].data[S].x) {
                                var F = this.detectOverlappingBars({
                                    i: r,
                                    j: S,
                                    barXPosition: I,
                                    srtx: R,
                                    barWidth: b,
                                    xDivision: o,
                                    initPositions: y
                                });
                                b = F.barWidth, I = F.barXPosition;
                            }
                            x = (M = this.drawRangeColumnPaths(g({
                                indexes: {
                                    i: r,
                                    j: S,
                                    realIndex: u,
                                    translationsIndex: v
                                },
                                barWidth: b,
                                barXPosition: I,
                                zeroH: l,
                                xDivision: o
                            }, z))).barHeight;
                        }
                        var D = this.barHelpers.drawGoalLine({
                            barXPosition: M.barXPosition,
                            barYPosition: T,
                            goalX: M.goalX,
                            goalY: M.goalY,
                            barHeight: x,
                            barWidth: b
                        });
                        D && A.add(D), d = M.y, c = M.x;
                        var H = this.barHelpers.getPathFillColor(t, r, S, u), O = i.globals.stroke.colors[u];
                        this.renderSeries({
                            realIndex: u,
                            pathFill: H,
                            lineFill: O,
                            j: S,
                            i: r,
                            x: c,
                            y: d,
                            y1: L,
                            y2: P,
                            pathFrom: M.pathFrom,
                            pathTo: M.pathTo,
                            strokeWidth: C,
                            elSeries: p,
                            series: t,
                            barHeight: x,
                            barWidth: b,
                            barXPosition: I,
                            barYPosition: T,
                            columnGroupIndex: f,
                            elDataLabelsWrap: w,
                            elGoalsMarkers: A,
                            visibleSeries: this.visibleI,
                            type: "rangebar"
                        });
                    }
                    s.add(p);
                }
                return s;
            }
        },
        {
            key: "detectOverlappingBars",
            value: function(t) {
                var e = t.i, i = t.j, a = t.barYPosition, s = t.barXPosition, r = t.srty, o = t.srtx, n = t.barHeight, l = t.barWidth, h = t.yDivision, c = t.xDivision, d = t.initPositions, g = this.w, u = [], f = g.config.series[e].data[i].rangeName, p = g.config.series[e].data[i].x, x = Array.isArray(p) ? p.join(" ") : p, b = g.globals.labels.map(function(t) {
                    return Array.isArray(t) ? t.join(" ") : t;
                }).indexOf(x), v = g.globals.seriesRange[e].findIndex(function(t) {
                    return t.x === x && t.overlaps.length > 0;
                });
                return this.isHorizontal ? (a = g.config.plotOptions.bar.rangeBarGroupRows ? r + h * b : r + n * this.visibleI + h * b, v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(f) > -1 && (a = (n = d.barHeight / u.length) * this.visibleI + h * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + n * (this.visibleI + u.indexOf(f)) + h * b)) : (b > -1 && !g.globals.timescaleLabels.length && (s = g.config.plotOptions.bar.rangeBarGroupRows ? o + c * b : o + l * this.visibleI + c * b), v > -1 && !g.config.plotOptions.bar.rangeBarOverlap && (u = g.globals.seriesRange[e][v].overlaps).indexOf(f) > -1 && (s = (l = d.barWidth / u.length) * this.visibleI + c * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + l * (this.visibleI + u.indexOf(f)) + c * b)), {
                    barYPosition: a,
                    barXPosition: s,
                    barHeight: n,
                    barWidth: l
                };
            }
        },
        {
            key: "drawRangeColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.xDivision, s = t.barWidth, r = t.barXPosition, o = t.zeroH, n = this.w, l = e.i, h = e.j, c = e.realIndex, d = e.translationsIndex, g = this.yRatio[d], u = this.getRangeValue(c, h), f = Math.min(u.start, u.end), p = Math.max(u.start, u.end);
                void 0 === this.series[l][h] || null === this.series[l][h] ? f = o : (f = o - f / g, p = o - p / g);
                var x = Math.abs(p - f), b = this.barHelpers.getColumnPaths({
                    barXPosition: r,
                    barWidth: s,
                    y1: f,
                    y2: p,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    realIndex: c,
                    i: c,
                    j: h,
                    w: n
                });
                if (n.globals.isXNumeric) {
                    var v = this.getBarXForNumericXAxis({
                        x: i,
                        j: h,
                        realIndex: c,
                        barWidth: s
                    });
                    i = v.x, r = v.barXPosition;
                } else i += a;
                return {
                    pathTo: b.pathTo,
                    pathFrom: b.pathFrom,
                    barHeight: x,
                    x: i,
                    y: u.start < 0 && u.end < 0 ? f : p,
                    goalY: this.barHelpers.getGoalValues("y", null, o, l, h, d),
                    barXPosition: r
                };
            }
        },
        {
            key: "preventBarOverflow",
            value: function(t) {
                var e = this.w;
                return t < 0 && (t = 0), t > e.globals.gridWidth && (t = e.globals.gridWidth), t;
            }
        },
        {
            key: "drawRangeBarPaths",
            value: function(t) {
                var e = t.indexes, i = t.y, a = t.y1, s = t.y2, r = t.yDivision, o = t.barHeight, n = t.barYPosition, l = t.zeroW, h = this.w, c = e.realIndex, d = e.j, g = this.preventBarOverflow(l + a / this.invertedYRatio), u = this.preventBarOverflow(l + s / this.invertedYRatio), f = this.getRangeValue(c, d), p = Math.abs(u - g), x = this.barHelpers.getBarpaths({
                    barYPosition: n,
                    barHeight: o,
                    x1: g,
                    x2: u,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    i: c,
                    realIndex: c,
                    j: d,
                    w: h
                });
                return h.globals.isXNumeric || (i += r), {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    barWidth: p,
                    x: f.start < 0 && f.end < 0 ? g : u,
                    goalX: this.barHelpers.getGoalValues("x", l, null, c, d),
                    y: i
                };
            }
        },
        {
            key: "getRangeValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    start: i.globals.seriesRangeStart[t][e],
                    end: i.globals.seriesRangeEnd[t][e]
                };
            }
        }
    ]), a;
}(), Yt = function() {
    function t(e) {
        i(this, t), this.w = e.w, this.lineCtx = e;
    }
    return s(t, [
        {
            key: "sameValueSeriesFix",
            value: function(t, e) {
                var i = this.w;
                if (("gradient" === i.config.fill.type || "gradient" === i.config.fill.type[t]) && new A(this.lineCtx.ctx, i).seriesHaveSameValues(t)) {
                    var a = e[t].slice();
                    a[a.length - 1] = a[a.length - 1] + 1e-6, e[t] = a;
                }
                return e;
            }
        },
        {
            key: "calculatePoints",
            value: function(t) {
                var e = t.series, i = t.realIndex, a = t.x, s = t.y, r = t.i, o = t.j, n = t.prevY, l = this.w, h = [], c = [];
                if (0 === o) {
                    var d = this.lineCtx.categoryAxisCorrection + l.config.markers.offsetX;
                    l.globals.isXNumeric && (d = (l.globals.seriesX[i][0] - l.globals.minX) / this.lineCtx.xRatio + l.config.markers.offsetX), h.push(d), c.push(m.isNumber(e[r][0]) ? n + l.config.markers.offsetY : null), h.push(a + l.config.markers.offsetX), c.push(m.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                } else h.push(a + l.config.markers.offsetX), c.push(m.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                return {
                    x: h,
                    y: c
                };
            }
        },
        {
            key: "checkPreviousPaths",
            value: function(t) {
                for(var e = t.pathFromLine, i = t.pathFromArea, a = t.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                    var o = s.globals.previousPaths[r];
                    ("line" === o.type || "area" === o.type) && o.paths.length > 0 && parseInt(o.realIndex, 10) === parseInt(a, 10) && ("line" === o.type ? (this.lineCtx.appendPathFrom = !1, e = s.globals.previousPaths[r].paths[0].d) : "area" === o.type && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (e = s.globals.previousPaths[r].paths[1].d)));
                }
                return {
                    pathFromLine: e,
                    pathFromArea: i
                };
            }
        },
        {
            key: "determineFirstPrevY",
            value: function(t) {
                var e, i, a, s = t.i, r = t.realIndex, o = t.series, n = t.prevY, l = t.lineYPosition, h = t.translationsIndex, c = this.w, d = c.config.chart.stacked && !c.globals.comboCharts || c.config.chart.stacked && c.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || "bar" === (null === (e = this.w.config.series[r]) || void 0 === e ? void 0 : e.type) || "column" === (null === (i = this.w.config.series[r]) || void 0 === i ? void 0 : i.type));
                if (void 0 !== (null === (a = o[s]) || void 0 === a ? void 0 : a[0])) n = (l = d && s > 0 ? this.lineCtx.prevSeriesY[s - 1][0] : this.lineCtx.zeroY) - o[s][0] / this.lineCtx.yRatio[h] + 2 * (this.lineCtx.isReversed ? o[s][0] / this.lineCtx.yRatio[h] : 0);
                else if (d && s > 0 && void 0 === o[s][0]) {
                    for(var g = s - 1; g >= 0; g--)if (null !== o[g][0] && void 0 !== o[g][0]) {
                        n = l = this.lineCtx.prevSeriesY[g][0];
                        break;
                    }
                }
                return {
                    prevY: n,
                    lineYPosition: l
                };
            }
        }
    ]), t;
}(), Rt = function(t) {
    for(var e, i, a, s, r = function(t) {
        for(var e = [], i = t[0], a = t[1], s = e[0] = Ht(i, a), r = 1, o = t.length - 1; r < o; r++)i = a, a = t[r + 1], e[r] = .5 * (s + (s = Ht(i, a)));
        return e[r] = s, e;
    }(t), o = t.length - 1, n = [], l = 0; l < o; l++)a = Ht(t[l], t[l + 1]), Math.abs(a) < 1e-6 ? r[l] = r[l + 1] = 0 : (s = (e = r[l] / a) * e + (i = r[l + 1] / a) * i) > 9 && (s = 3 * a / Math.sqrt(s), r[l] = s * e, r[l + 1] = s * i);
    for(var h = 0; h <= o; h++)s = (t[Math.min(o, h + 1)][0] - t[Math.max(0, h - 1)][0]) / (6 * (1 + r[h] * r[h])), n.push([
        s || 0,
        r[h] * s || 0
    ]);
    return n;
}, Ft = function(t) {
    var e = Rt(t), i = t[1], a = t[0], s = [], r = e[1], o = e[0];
    s.push(a, [
        a[0] + o[0],
        a[1] + o[1],
        i[0] - r[0],
        i[1] - r[1],
        i[0],
        i[1]
    ]);
    for(var n = 2, l = e.length; n < l; n++){
        var h = t[n], c = e[n];
        s.push([
            h[0] - c[0],
            h[1] - c[1],
            h[0],
            h[1]
        ]);
    }
    return s;
}, Dt = function(t, e, i) {
    var a = t.slice(e, i);
    if (e) {
        if (i - e > 1 && a[1].length < 6) {
            var s = a[0].length;
            a[1] = [
                2 * a[0][s - 2] - a[0][s - 4],
                2 * a[0][s - 1] - a[0][s - 3]
            ].concat(a[1]);
        }
        a[0] = a[0].slice(-2);
    }
    return a;
};
function Ht(t, e) {
    return (e[1] - t[1]) / (e[0] - t[0]);
}
var Ot = function() {
    function t(e, a, s) {
        i(this, t), this.ctx = e, this.w = e.w, this.xyRatios = a, this.pointsChart = !("bubble" !== this.w.config.chart.type && "scatter" !== this.w.config.chart.type) || s, this.scatter = new B(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new Yt(this), this.markers = new W(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
    }
    return s(t, [
        {
            key: "draw",
            value: function(t, e, i, a) {
                var s, r = this.w, o = new k(this.ctx), n = r.globals.comboCharts ? e : r.config.chart.type, l = o.group({
                    class: "apexcharts-".concat(n, "-series apexcharts-plot-series")
                }), h = new A(this.ctx, r);
                this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, t = h.getLogSeries(t), this.yRatio = h.getLogYRatios(this.yRatio), this.prevSeriesY = [];
                for(var c = [], d = 0; d < t.length; d++){
                    t = this.lineHelpers.sameValueSeriesFix(d, t);
                    var u = r.globals.comboCharts ? i[d] : d, f = this.yRatio.length > 1 ? u : 0;
                    this._initSerieVariables(t, d, u);
                    var p = [], x = [], b = [], v = r.globals.padHorizontal + this.categoryAxisCorrection;
                    this.ctx.series.addCollapsedClassToSeries(this.elSeries, u), r.globals.isXNumeric && r.globals.seriesX.length > 0 && (v = (r.globals.seriesX[u][0] - r.globals.minX) / this.xRatio), b.push(v);
                    var m, y = v, w = void 0, S = y, C = this.zeroY, L = this.zeroY;
                    C = this.lineHelpers.determineFirstPrevY({
                        i: d,
                        realIndex: u,
                        series: t,
                        prevY: C,
                        lineYPosition: 0,
                        translationsIndex: f
                    }).prevY, "monotoneCubic" === r.config.stroke.curve && null === t[d][0] ? p.push(null) : p.push(C), m = C;
                    "rangeArea" === n && (w = L = this.lineHelpers.determineFirstPrevY({
                        i: d,
                        realIndex: u,
                        series: a,
                        prevY: L,
                        lineYPosition: 0,
                        translationsIndex: f
                    }).prevY, x.push(null !== p[0] ? L : null));
                    var P = this._calculatePathsFrom({
                        type: n,
                        series: t,
                        i: d,
                        realIndex: u,
                        translationsIndex: f,
                        prevX: S,
                        prevY: C,
                        prevY2: L
                    }), M = [
                        p[0]
                    ], I = [
                        x[0]
                    ], T = {
                        type: n,
                        series: t,
                        realIndex: u,
                        translationsIndex: f,
                        i: d,
                        x: v,
                        y: 1,
                        pX: y,
                        pY: m,
                        pathsFrom: P,
                        linePaths: [],
                        areaPaths: [],
                        seriesIndex: i,
                        lineYPosition: 0,
                        xArrj: b,
                        yArrj: p,
                        y2Arrj: x,
                        seriesRangeEnd: a
                    }, z = this._iterateOverDataPoints(g(g({}, T), {}, {
                        iterations: "rangeArea" === n ? t[d].length - 1 : void 0,
                        isRangeStart: !0
                    }));
                    if ("rangeArea" === n) {
                        for(var X = this._calculatePathsFrom({
                            series: a,
                            i: d,
                            realIndex: u,
                            prevX: S,
                            prevY: L
                        }), E = this._iterateOverDataPoints(g(g({}, T), {}, {
                            series: a,
                            xArrj: [
                                v
                            ],
                            yArrj: M,
                            y2Arrj: I,
                            pY: w,
                            areaPaths: z.areaPaths,
                            pathsFrom: X,
                            iterations: a[d].length - 1,
                            isRangeStart: !1
                        })), Y = z.linePaths.length / 2, R = 0; R < Y; R++)z.linePaths[R] = E.linePaths[R + Y] + z.linePaths[R];
                        z.linePaths.splice(Y), z.pathFromLine = E.pathFromLine + z.pathFromLine;
                    } else z.pathFromArea += "z";
                    this._handlePaths({
                        type: n,
                        realIndex: u,
                        i: d,
                        paths: z
                    }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), c.push(this.elSeries);
                }
                if (void 0 !== (null === (s = r.config.series[0]) || void 0 === s ? void 0 : s.zIndex) && c.sort(function(t, e) {
                    return Number(t.node.getAttribute("zIndex")) - Number(e.node.getAttribute("zIndex"));
                }), r.config.chart.stacked) for(var F = c.length - 1; F >= 0; F--)l.add(c[F]);
                else for(var D = 0; D < c.length; D++)l.add(c[D]);
                return l;
            }
        },
        {
            key: "_initSerieVariables",
            value: function(t, e, i) {
                var a = this.w, s = new k(this.ctx);
                this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - ("on" === a.config.xaxis.tickPlacement ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width;
                var r = 0;
                this.yRatio.length > 1 && (this.yaxisIndex = a.globals.seriesYAxisReverseMap[i], r = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[r] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[r] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || "end" === a.config.plotOptions.area.fillTo) && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                    class: "apexcharts-series",
                    zIndex: void 0 !== a.config.series[i].zIndex ? a.config.series[i].zIndex : i,
                    seriesName: m.escapeString(a.globals.seriesNames[i])
                }), this.elPointsMain = s.group({
                    class: "apexcharts-series-markers-wrap",
                    "data:realIndex": i
                }), this.elDataLabelsWrap = s.group({
                    class: "apexcharts-datalabels",
                    "data:realIndex": i
                });
                var o = t[e].length === a.globals.dataPoints;
                this.elSeries.attr({
                    "data:longestSeries": o,
                    rel: e + 1,
                    "data:realIndex": i
                }), this.appendPathFrom = !0;
            }
        },
        {
            key: "_calculatePathsFrom",
            value: function(t) {
                var e, i, a, s, r = t.type, o = t.series, n = t.i, l = t.realIndex, h = t.translationsIndex, c = t.prevX, d = t.prevY, g = t.prevY2, u = this.w, f = new k(this.ctx);
                if (null === o[n][0]) {
                    for(var p = 0; p < o[n].length; p++)if (null !== o[n][p]) {
                        c = this.xDivision * p, d = this.zeroY - o[n][p] / this.yRatio[h], e = f.move(c, d), i = f.move(c, this.areaBottomY);
                        break;
                    }
                } else e = f.move(c, d), "rangeArea" === r && (e = f.move(c, g) + f.line(c, d)), i = f.move(c, this.areaBottomY) + f.line(c, d);
                if (a = f.move(0, this.zeroY) + f.line(0, this.zeroY), s = f.move(0, this.zeroY) + f.line(0, this.zeroY), u.globals.previousPaths.length > 0) {
                    var x = this.lineHelpers.checkPreviousPaths({
                        pathFromLine: a,
                        pathFromArea: s,
                        realIndex: l
                    });
                    a = x.pathFromLine, s = x.pathFromArea;
                }
                return {
                    prevX: c,
                    prevY: d,
                    linePath: e,
                    areaPath: i,
                    pathFromLine: a,
                    pathFromArea: s
                };
            }
        },
        {
            key: "_handlePaths",
            value: function(t) {
                var e = t.type, i = t.realIndex, a = t.i, s = t.paths, r = this.w, o = new k(this.ctx), n = new N(this.ctx);
                this.prevSeriesY.push(s.yArrj), r.globals.seriesXvalues[i] = s.xArrj, r.globals.seriesYvalues[i] = s.yArrj;
                var l = r.config.forecastDataPoints;
                if (l.count > 0 && "rangeArea" !== e) {
                    var h = r.globals.seriesXvalues[i][r.globals.seriesXvalues[i].length - l.count - 1], c = o.drawRect(h, 0, r.globals.gridWidth, r.globals.gridHeight, 0);
                    r.globals.dom.elForecastMask.appendChild(c.node);
                    var d = o.drawRect(0, 0, h, r.globals.gridHeight, 0);
                    r.globals.dom.elNonForecastMask.appendChild(d.node);
                }
                this.pointsChart || r.globals.delayedElements.push({
                    el: this.elPointsMain.node,
                    index: i
                });
                var u = {
                    i: a,
                    realIndex: i,
                    animationDelay: a,
                    initialSpeed: r.config.chart.animations.speed,
                    dataChangeSpeed: r.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(e)
                };
                if ("area" === e) for(var f = n.fillPath({
                    seriesNumber: i
                }), p = 0; p < s.areaPaths.length; p++){
                    var x = o.renderPaths(g(g({}, u), {}, {
                        pathFrom: s.pathFromArea,
                        pathTo: s.areaPaths[p],
                        stroke: "none",
                        strokeWidth: 0,
                        strokeLineCap: null,
                        fill: f
                    }));
                    this.elSeries.add(x);
                }
                if (r.config.stroke.show && !this.pointsChart) {
                    var b = null;
                    if ("line" === e) b = n.fillPath({
                        seriesNumber: i,
                        i: a
                    });
                    else if ("solid" === r.config.stroke.fill.type) b = r.globals.stroke.colors[i];
                    else {
                        var v = r.config.fill;
                        r.config.fill = r.config.stroke.fill, b = n.fillPath({
                            seriesNumber: i,
                            i: a
                        }), r.config.fill = v;
                    }
                    for(var m = 0; m < s.linePaths.length; m++){
                        var y = b;
                        "rangeArea" === e && (y = n.fillPath({
                            seriesNumber: i
                        }));
                        var w = g(g({}, u), {}, {
                            pathFrom: s.pathFromLine,
                            pathTo: s.linePaths[m],
                            stroke: b,
                            strokeWidth: this.strokeWidth,
                            strokeLineCap: r.config.stroke.lineCap,
                            fill: "rangeArea" === e ? y : "none"
                        }), A = o.renderPaths(w);
                        if (this.elSeries.add(A), A.attr("fill-rule", "evenodd"), l.count > 0 && "rangeArea" !== e) {
                            var S = o.renderPaths(w);
                            S.node.setAttribute("stroke-dasharray", l.dashArray), l.strokeWidth && S.node.setAttribute("stroke-width", l.strokeWidth), this.elSeries.add(S), S.attr("clip-path", "url(#forecastMask".concat(r.globals.cuid, ")")), A.attr("clip-path", "url(#nonForecastMask".concat(r.globals.cuid, ")"));
                        }
                    }
                }
            }
        },
        {
            key: "_iterateOverDataPoints",
            value: function(t) {
                var e, i, a = this, s = t.type, r = t.series, o = t.iterations, n = t.realIndex, l = t.translationsIndex, h = t.i, c = t.x, d = t.y, g = t.pX, u = t.pY, f = t.pathsFrom, p = t.linePaths, x = t.areaPaths, b = t.seriesIndex, v = t.lineYPosition, y = t.xArrj, w = t.yArrj, A = t.y2Arrj, S = t.isRangeStart, C = t.seriesRangeEnd, L = this.w, P = new k(this.ctx), M = this.yRatio, I = f.prevY, T = f.linePath, z = f.areaPath, X = f.pathFromLine, E = f.pathFromArea, Y = m.isNumber(L.globals.minYArr[n]) ? L.globals.minYArr[n] : L.globals.minY;
                o || (o = L.globals.dataPoints > 1 ? L.globals.dataPoints - 1 : L.globals.dataPoints);
                var R = function(t, e) {
                    return e - t / M[l] + 2 * (a.isReversed ? t / M[l] : 0);
                }, F = d, D = L.config.chart.stacked && !L.globals.comboCharts || L.config.chart.stacked && L.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || "bar" === (null === (e = this.w.config.series[n]) || void 0 === e ? void 0 : e.type) || "column" === (null === (i = this.w.config.series[n]) || void 0 === i ? void 0 : i.type)), H = L.config.stroke.curve;
                Array.isArray(H) && (H = Array.isArray(b) ? H[b[h]] : H[h]);
                for(var O, N = 0, W = 0; W < o; W++){
                    var B = void 0 === r[h][W + 1] || null === r[h][W + 1];
                    if (L.globals.isXNumeric) {
                        var G = L.globals.seriesX[n][W + 1];
                        void 0 === L.globals.seriesX[n][W + 1] && (G = L.globals.seriesX[n][o - 1]), c = (G - L.globals.minX) / this.xRatio;
                    } else c += this.xDivision;
                    if (D) {
                        if (h > 0 && L.globals.collapsedSeries.length < L.config.series.length - 1) v = this.prevSeriesY[function(t) {
                            for(var e = t; e > 0; e--){
                                if (!(L.globals.collapsedSeriesIndices.indexOf((null == b ? void 0 : b[e]) || e) > -1)) return e;
                                e--;
                            }
                            return 0;
                        }(h - 1)][W + 1];
                        else v = this.zeroY;
                    } else v = this.zeroY;
                    B ? d = R(Y, v) : (d = R(r[h][W + 1], v), "rangeArea" === s && (F = R(C[h][W + 1], v))), y.push(c), !B || "smooth" !== L.config.stroke.curve && "monotoneCubic" !== L.config.stroke.curve ? (w.push(d), A.push(F)) : (w.push(null), A.push(null));
                    var V = this.lineHelpers.calculatePoints({
                        series: r,
                        x: c,
                        y: d,
                        realIndex: n,
                        i: h,
                        j: W,
                        prevY: I
                    }), j1 = this._createPaths({
                        type: s,
                        series: r,
                        i: h,
                        realIndex: n,
                        j: W,
                        x: c,
                        y: d,
                        y2: F,
                        xArrj: y,
                        yArrj: w,
                        y2Arrj: A,
                        pX: g,
                        pY: u,
                        pathState: N,
                        segmentStartX: O,
                        linePath: T,
                        areaPath: z,
                        linePaths: p,
                        areaPaths: x,
                        curve: H,
                        isRangeStart: S
                    });
                    x = j1.areaPaths, p = j1.linePaths, g = j1.pX, u = j1.pY, N = j1.pathState, O = j1.segmentStartX, z = j1.areaPath, T = j1.linePath, !this.appendPathFrom || "monotoneCubic" === H && "rangeArea" === s || (X += P.line(c, this.zeroY), E += P.line(c, this.zeroY)), this.handleNullDataPoints(r, V, h, W, n), this._handleMarkersAndLabels({
                        type: s,
                        pointsPos: V,
                        i: h,
                        j: W,
                        realIndex: n,
                        isRangeStart: S
                    });
                }
                return {
                    yArrj: w,
                    xArrj: y,
                    pathFromArea: E,
                    areaPaths: x,
                    pathFromLine: X,
                    linePaths: p,
                    linePath: T,
                    areaPath: z
                };
            }
        },
        {
            key: "_handleMarkersAndLabels",
            value: function(t) {
                var e = t.type, i = t.pointsPos, a = t.isRangeStart, s = t.i, r = t.j, o = t.realIndex, n = this.w, l = new G(this.ctx);
                if (this.pointsChart) this.scatter.draw(this.elSeries, r, {
                    realIndex: o,
                    pointsPos: i,
                    zRatio: this.zRatio,
                    elParent: this.elPointsMain
                });
                else {
                    n.globals.series[s].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                    var h = this.markers.plotChartMarkers(i, o, r + 1);
                    null !== h && this.elPointsMain.add(h);
                }
                var c = l.drawDataLabel({
                    type: e,
                    isRangeStart: a,
                    pos: i,
                    i: o,
                    j: r + 1
                });
                null !== c && this.elDataLabelsWrap.add(c);
            }
        },
        {
            key: "_createPaths",
            value: function(t) {
                var e = t.type, i = t.series, a = t.i;
                t.realIndex;
                var s, r = t.j, o = t.x, n = t.y, l = t.xArrj, h = t.yArrj, c = t.y2, d = t.y2Arrj, g = t.pX, u = t.pY, f = t.pathState, p = t.segmentStartX, x = t.linePath, b = t.areaPath, v = t.linePaths, m = t.areaPaths, y = t.curve, w = t.isRangeStart, A = new k(this.ctx), S = this.areaBottomY, C = "rangeArea" === e, L = "rangeArea" === e && w;
                switch(y){
                    case "monotoneCubic":
                        var P = w ? h : d;
                        switch(f){
                            case 0:
                                if (null === P[r + 1]) break;
                                f = 1;
                            case 1:
                                if (!(C ? l.length === i[a].length : r === i[a].length - 2)) break;
                            case 2:
                                var M = w ? l : l.slice().reverse(), I = w ? P : P.slice().reverse(), T = (s = I, M.map(function(t, e) {
                                    return [
                                        t,
                                        s[e]
                                    ];
                                }).filter(function(t) {
                                    return null !== t[1];
                                })), z = T.length > 1 ? Ft(T) : T, X = [];
                                C && (L ? m = T : X = m.reverse());
                                var E = 0, Y = 0;
                                if ((function(t, e) {
                                    for(var i = function(t) {
                                        var e = [], i = 0;
                                        return t.forEach(function(t) {
                                            null !== t ? i++ : i > 0 && (e.push(i), i = 0);
                                        }), i > 0 && e.push(i), e;
                                    }(t), a = [], s = 0, r = 0; s < i.length; r += i[s++])a[s] = Dt(e, r, r + i[s]);
                                    return a;
                                })(I, z).forEach(function(t) {
                                    E++;
                                    var e = function(t) {
                                        for(var e = "", i = 0; i < t.length; i++){
                                            var a = t[i], s = a.length;
                                            s > 4 ? (e += "C".concat(a[0], ", ").concat(a[1]), e += ", ".concat(a[2], ", ").concat(a[3]), e += ", ".concat(a[4], ", ").concat(a[5])) : s > 2 && (e += "S".concat(a[0], ", ").concat(a[1]), e += ", ".concat(a[2], ", ").concat(a[3]));
                                        }
                                        return e;
                                    }(t), i = Y, a = (Y += t.length) - 1;
                                    L ? x = A.move(T[i][0], T[i][1]) + e : C ? x = A.move(X[i][0], X[i][1]) + A.line(T[i][0], T[i][1]) + e + A.line(X[a][0], X[a][1]) : (x = A.move(T[i][0], T[i][1]) + e, b = x + A.line(T[a][0], S) + A.line(T[i][0], S) + "z", m.push(b)), v.push(x);
                                }), C && E > 1 && !L) {
                                    var R = v.slice(E).reverse();
                                    v.splice(E), R.forEach(function(t) {
                                        return v.push(t);
                                    });
                                }
                                f = 0;
                        }
                        break;
                    case "smooth":
                        var F = .35 * (o - g);
                        if (null === i[a][r]) f = 0;
                        else switch(f){
                            case 0:
                                if (p = g, x = L ? A.move(g, d[r]) + A.line(g, u) : A.move(g, u), b = A.move(g, u), null === i[a][r + 1]) {
                                    v.push(x), m.push(b);
                                    break;
                                }
                                if (f = 1, r < i[a].length - 2) {
                                    var D = A.curve(g + F, u, o - F, n, o, n);
                                    x += D, b += D;
                                    break;
                                }
                            case 1:
                                if (null === i[a][r + 1]) x += L ? A.line(g, c) : A.move(g, u), b += A.line(g, S) + A.line(p, S) + "z", v.push(x), m.push(b), f = -1;
                                else {
                                    var H = A.curve(g + F, u, o - F, n, o, n);
                                    x += H, b += H, r >= i[a].length - 2 && (L && (x += A.curve(o, n, o, n, o, c) + A.move(o, c)), b += A.curve(o, n, o, n, o, S) + A.line(p, S) + "z", v.push(x), m.push(b), f = -1);
                                }
                        }
                        g = o, u = n;
                        break;
                    default:
                        var O = function(t, e, i) {
                            var a = [];
                            switch(t){
                                case "stepline":
                                    a = A.line(e, null, "H") + A.line(null, i, "V");
                                    break;
                                case "linestep":
                                    a = A.line(null, i, "V") + A.line(e, null, "H");
                                    break;
                                case "straight":
                                    a = A.line(e, i);
                            }
                            return a;
                        };
                        if (null === i[a][r]) f = 0;
                        else switch(f){
                            case 0:
                                if (p = g, x = L ? A.move(g, d[r]) + A.line(g, u) : A.move(g, u), b = A.move(g, u), null === i[a][r + 1]) {
                                    v.push(x), m.push(b);
                                    break;
                                }
                                if (f = 1, r < i[a].length - 2) {
                                    var N = O(y, o, n);
                                    x += N, b += N;
                                    break;
                                }
                            case 1:
                                if (null === i[a][r + 1]) x += L ? A.line(g, c) : A.move(g, u), b += A.line(g, S) + A.line(p, S) + "z", v.push(x), m.push(b), f = -1;
                                else {
                                    var W = O(y, o, n);
                                    x += W, b += W, r >= i[a].length - 2 && (L && (x += A.line(o, c)), b += A.line(o, S) + A.line(p, S) + "z", v.push(x), m.push(b), f = -1);
                                }
                        }
                        g = o, u = n;
                }
                return {
                    linePaths: v,
                    areaPaths: m,
                    pX: g,
                    pY: u,
                    pathState: f,
                    segmentStartX: p,
                    linePath: x,
                    areaPath: b
                };
            }
        },
        {
            key: "handleNullDataPoints",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (null === t[i][a] && r.config.markers.showNullDataPoints || 1 === t[i].length) {
                    var o = this.strokeWidth - r.config.markers.strokeWidth / 2;
                    o > 0 || (o = 0);
                    var n = this.markers.plotChartMarkers(e, s, a + 1, o, !0);
                    null !== n && this.elPointsMain.add(n);
                }
            }
        }
    ]), t;
}();
window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
    function t(e, i, a, s) {
        this.xoffset = e, this.yoffset = i, this.height = s, this.width = a, this.shortestEdge = function() {
            return Math.min(this.height, this.width);
        }, this.getCoordinates = function(t) {
            var e, i = [], a = this.xoffset, s = this.yoffset, o = r(t) / this.height, n = r(t) / this.width;
            if (this.width >= this.height) for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + o,
                s + t[e] / o
            ]), s += t[e] / o;
            else for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + t[e] / n,
                s + n
            ]), a += t[e] / n;
            return i;
        }, this.cutArea = function(e) {
            var i;
            if (this.width >= this.height) {
                var a = e / this.height, s = this.width - a;
                i = new t(this.xoffset + a, this.yoffset, s, this.height);
            } else {
                var r = e / this.width, o = this.height - r;
                i = new t(this.xoffset, this.yoffset + r, this.width, o);
            }
            return i;
        };
    }
    function e(e, a, s, o, n) {
        o = void 0 === o ? 0 : o, n = void 0 === n ? 0 : n;
        var l = i(function(t, e) {
            var i, a = [], s = e / r(t);
            for(i = 0; i < t.length; i++)a[i] = t[i] * s;
            return a;
        }(e, a * s), [], new t(o, n, a, s), []);
        return function(t) {
            var e, i, a = [];
            for(e = 0; e < t.length; e++)for(i = 0; i < t[e].length; i++)a.push(t[e][i]);
            return a;
        }(l);
    }
    function i(t, e, s, o) {
        var n, l, h;
        if (0 !== t.length) return n = s.shortestEdge(), function(t, e, i) {
            var s;
            if (0 === t.length) return !0;
            (s = t.slice()).push(e);
            var r = a(t, i), o = a(s, i);
            return r >= o;
        }(e, l = t[0], n) ? (e.push(l), i(t.slice(1), e, s, o)) : (h = s.cutArea(r(e), o), o.push(s.getCoordinates(e)), i(t, [], h, o)), o;
        o.push(s.getCoordinates(e));
    }
    function a(t, e) {
        var i = Math.min.apply(Math, t), a = Math.max.apply(Math, t), s = r(t);
        return Math.max(Math.pow(e, 2) * a / Math.pow(s, 2), Math.pow(s, 2) / (Math.pow(e, 2) * i));
    }
    function s(t) {
        return t && t.constructor === Array;
    }
    function r(t) {
        var e, i = 0;
        for(e = 0; e < t.length; e++)i += t[e];
        return i;
    }
    function o(t) {
        var e, i = 0;
        if (s(t[0])) for(e = 0; e < t.length; e++)i += o(t[e]);
        else i = r(t);
        return i;
    }
    return function t(i, a, r, n, l) {
        n = void 0 === n ? 0 : n, l = void 0 === l ? 0 : l;
        var h, c, d = [], g = [];
        if (s(i[0])) {
            for(c = 0; c < i.length; c++)d[c] = o(i[c]);
            for(h = e(d, a, r, n, l), c = 0; c < i.length; c++)g.push(t(i[c], h[c][2] - h[c][0], h[c][3] - h[c][1], h[c][0], h[c][1]));
        } else g = e(i, a, r, n, l);
        return g;
    };
}();
var Nt, Wt, Bt = function() {
    function t(e, a) {
        i(this, t), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new Pt(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
    }
    return s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new k(this.ctx), s = new N(this.ctx), r = a.group({
                    class: "apexcharts-treemap"
                });
                if (i.globals.noData) return r;
                var o = [];
                return t.forEach(function(t) {
                    var e = t.map(function(t) {
                        return Math.abs(t);
                    });
                    o.push(e);
                }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(t, i) {
                    t.data.forEach(function(t) {
                        Array.isArray(e.labels[i]) || (e.labels[i] = []), e.labels[i].push(t.x);
                    });
                }), window.TreemapSquared.generate(o, i.globals.gridWidth, i.globals.gridHeight).forEach(function(o, n) {
                    var l = a.group({
                        class: "apexcharts-series apexcharts-treemap-series",
                        seriesName: m.escapeString(i.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    if (i.config.chart.dropShadow.enabled) {
                        var h = i.config.chart.dropShadow;
                        new w(e.ctx).dropShadow(r, h, n);
                    }
                    var c = a.group({
                        class: "apexcharts-data-labels"
                    });
                    o.forEach(function(r, o) {
                        var h = r[0], c = r[1], d = r[2], g = r[3], u = a.drawRect(h, c, d - h, g - c, i.config.plotOptions.treemap.borderRadius, "#fff", 1, e.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? p : i.globals.stroke.colors[n]);
                        u.attr({
                            cx: h,
                            cy: c,
                            index: n,
                            i: n,
                            j: o,
                            width: d - h,
                            height: g - c
                        });
                        var f = e.helpers.getShadeColor(i.config.chart.type, n, o, e.negRange), p = f.color;
                        void 0 !== i.config.series[n].data[o] && i.config.series[n].data[o].fillColor && (p = i.config.series[n].data[o].fillColor);
                        var x = s.fillPath({
                            color: p,
                            seriesNumber: n,
                            dataPointIndex: o
                        });
                        u.node.classList.add("apexcharts-treemap-rect"), u.attr({
                            fill: x
                        }), e.helpers.addListeners(u);
                        var b = {
                            x: h + (d - h) / 2,
                            y: c + (g - c) / 2,
                            width: 0,
                            height: 0
                        }, v = {
                            x: h,
                            y: c,
                            width: d - h,
                            height: g - c
                        };
                        if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                            var m = 1;
                            i.globals.resized || (m = i.config.chart.animations.speed), e.animateTreemap(u, b, v, m);
                        }
                        if (i.globals.dataChanged) {
                            var y = 1;
                            e.dynamicAnim.enabled && i.globals.shouldAnimate && (y = e.dynamicAnim.speed, i.globals.previousPaths[n] && i.globals.previousPaths[n][o] && i.globals.previousPaths[n][o].rect && (b = i.globals.previousPaths[n][o].rect), e.animateTreemap(u, b, v, y));
                        }
                        var w = e.getFontSize(r), k = i.config.dataLabels.formatter(e.labels[n][o], {
                            value: i.globals.series[n][o],
                            seriesIndex: n,
                            dataPointIndex: o,
                            w: i
                        });
                        "truncate" === i.config.plotOptions.treemap.dataLabels.format && (w = parseInt(i.config.dataLabels.style.fontSize, 10), k = e.truncateLabels(k, w, h, c, d, g));
                        var A = null;
                        i.globals.series[n][o] && (A = e.helpers.calculateDataLabels({
                            text: k,
                            x: (h + d) / 2,
                            y: (c + g) / 2 + e.strokeWidth / 2 + w / 3,
                            i: n,
                            j: o,
                            colorProps: f,
                            fontSize: w,
                            series: t
                        })), i.config.dataLabels.enabled && A && e.rotateToFitLabel(A, w, k, h, c, d, g), l.add(u), null !== A && l.add(A);
                    }), l.add(c), r.add(l);
                }), r;
            }
        },
        {
            key: "getFontSize",
            value: function(t) {
                var e = this.w;
                var i, a, s, r, o = function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += e[i].length;
                    return a;
                }(this.labels) / function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += 1;
                    return a;
                }(this.labels);
                return i = t[2] - t[0], a = t[3] - t[1], s = i * a, r = Math.pow(s, .5), Math.min(r / o, parseInt(e.config.dataLabels.style.fontSize, 10));
            }
        },
        {
            key: "rotateToFitLabel",
            value: function(t, e, i, a, s, r, o) {
                var n = new k(this.ctx), l = n.getTextRects(i, e);
                if (l.width + this.w.config.stroke.width + 5 > r - a && l.width <= o - s) {
                    var h = n.rotateAroundCenter(t.node);
                    t.node.setAttribute("transform", "rotate(-90 ".concat(h.x, " ").concat(h.y, ") translate(").concat(l.height / 3, ")"));
                }
            }
        },
        {
            key: "truncateLabels",
            value: function(t, e, i, a, s, r) {
                var o = new k(this.ctx), n = o.getTextRects(t, e).width + this.w.config.stroke.width + 5 > s - i && r - a > s - i ? r - a : s - i, l = o.getTextBasedOnMaxWidth({
                    text: t,
                    maxWidth: n,
                    fontSize: e
                });
                return t.length !== l.length && n / e < 5 ? "" : l;
            }
        },
        {
            key: "animateTreemap",
            value: function(t, e, i, a) {
                var s = new y(this.ctx);
                s.animateRect(t, {
                    x: e.x,
                    y: e.y,
                    width: e.width,
                    height: e.height
                }, {
                    x: i.x,
                    y: i.y,
                    width: i.width,
                    height: i.height
                }, a, function() {
                    s.animationCompleted(t);
                });
            }
        }
    ]), t;
}(), Gt = 86400, Vt = 10 / Gt, jt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
    }
    return s(t, [
        {
            key: "calculateTimeScaleTicks",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.allSeriesCollapsed) return a.globals.labels = [], a.globals.timescaleLabels = [], [];
                var s = new L(this.ctx), r = (e - t) / 864e5;
                this.determineInterval(r), a.globals.disableZoomIn = !1, a.globals.disableZoomOut = !1, r < Vt ? a.globals.disableZoomIn = !0 : r > 5e4 && (a.globals.disableZoomOut = !0);
                var o = s.getTimeUnitsfromTimestamp(t, e, this.utc), n = a.globals.gridWidth / r, l = n / 24, h = l / 60, c = h / 60, d = Math.floor(24 * r), u = Math.floor(1440 * r), f = Math.floor(r * Gt), p = Math.floor(r), x = Math.floor(r / 30), b = Math.floor(r / 365), v = {
                    minMillisecond: o.minMillisecond,
                    minSecond: o.minSecond,
                    minMinute: o.minMinute,
                    minHour: o.minHour,
                    minDate: o.minDate,
                    minMonth: o.minMonth,
                    minYear: o.minYear
                }, m = {
                    firstVal: v,
                    currentMillisecond: v.minMillisecond,
                    currentSecond: v.minSecond,
                    currentMinute: v.minMinute,
                    currentHour: v.minHour,
                    currentMonthDate: v.minDate,
                    currentDate: v.minDate,
                    currentMonth: v.minMonth,
                    currentYear: v.minYear,
                    daysWidthOnXAxis: n,
                    hoursWidthOnXAxis: l,
                    minutesWidthOnXAxis: h,
                    secondsWidthOnXAxis: c,
                    numberOfSeconds: f,
                    numberOfMinutes: u,
                    numberOfHours: d,
                    numberOfDays: p,
                    numberOfMonths: x,
                    numberOfYears: b
                };
                switch(this.tickInterval){
                    case "years":
                        this.generateYearScale(m);
                        break;
                    case "months":
                    case "half_year":
                        this.generateMonthScale(m);
                        break;
                    case "months_days":
                    case "months_fortnight":
                    case "days":
                    case "week_days":
                        this.generateDayScale(m);
                        break;
                    case "hours":
                        this.generateHourScale(m);
                        break;
                    case "minutes_fives":
                    case "minutes":
                        this.generateMinuteScale(m);
                        break;
                    case "seconds_tens":
                    case "seconds_fives":
                    case "seconds":
                        this.generateSecondScale(m);
                }
                var y = this.timeScaleArray.map(function(t) {
                    var e = {
                        position: t.position,
                        unit: t.unit,
                        year: t.year,
                        day: t.day ? t.day : 1,
                        hour: t.hour ? t.hour : 0,
                        month: t.month + 1
                    };
                    return "month" === t.unit ? g(g({}, e), {}, {
                        day: 1,
                        value: t.value + 1
                    }) : "day" === t.unit || "hour" === t.unit ? g(g({}, e), {}, {
                        value: t.value
                    }) : "minute" === t.unit ? g(g({}, e), {}, {
                        value: t.value,
                        minute: t.value
                    }) : "second" === t.unit ? g(g({}, e), {}, {
                        value: t.value,
                        minute: t.minute,
                        second: t.second
                    }) : t;
                });
                return y.filter(function(t) {
                    var e = 1, s = Math.ceil(a.globals.gridWidth / 120), r = t.value;
                    void 0 !== a.config.xaxis.tickAmount && (s = a.config.xaxis.tickAmount), y.length > s && (e = Math.floor(y.length / s));
                    var o = !1, n = !1;
                    switch(i.tickInterval){
                        case "years":
                            "year" === t.unit && (o = !0);
                            break;
                        case "half_year":
                            e = 7, "year" === t.unit && (o = !0);
                            break;
                        case "months":
                            e = 1, "year" === t.unit && (o = !0);
                            break;
                        case "months_fortnight":
                            e = 15, "year" !== t.unit && "month" !== t.unit || (o = !0), 30 === r && (n = !0);
                            break;
                        case "months_days":
                            e = 10, "month" === t.unit && (o = !0), 30 === r && (n = !0);
                            break;
                        case "week_days":
                            e = 8, "month" === t.unit && (o = !0);
                            break;
                        case "days":
                            e = 1, "month" === t.unit && (o = !0);
                            break;
                        case "hours":
                            "day" === t.unit && (o = !0);
                            break;
                        case "minutes_fives":
                        case "seconds_fives":
                            r % 5 != 0 && (n = !0);
                            break;
                        case "seconds_tens":
                            r % 10 != 0 && (n = !0);
                    }
                    if ("hours" === i.tickInterval || "minutes_fives" === i.tickInterval || "seconds_tens" === i.tickInterval || "seconds_fives" === i.tickInterval) {
                        if (!n) return !0;
                    } else if ((r % e == 0 || o) && !n) return !0;
                });
            }
        },
        {
            key: "recalcDimensionsBasedOnFormat",
            value: function(t, e) {
                var i = this.w, a = this.formatDates(t), s = this.removeOverlappingTS(a);
                i.globals.timescaleLabels = s.slice(), new ct(this.ctx).plotCoords();
            }
        },
        {
            key: "determineInterval",
            value: function(t) {
                var e = 24 * t, i = 60 * e;
                switch(!0){
                    case t / 365 > 5:
                        this.tickInterval = "years";
                        break;
                    case t > 800:
                        this.tickInterval = "half_year";
                        break;
                    case t > 180:
                        this.tickInterval = "months";
                        break;
                    case t > 90:
                        this.tickInterval = "months_fortnight";
                        break;
                    case t > 60:
                        this.tickInterval = "months_days";
                        break;
                    case t > 30:
                        this.tickInterval = "week_days";
                        break;
                    case t > 2:
                        this.tickInterval = "days";
                        break;
                    case e > 2.4:
                        this.tickInterval = "hours";
                        break;
                    case i > 15:
                        this.tickInterval = "minutes_fives";
                        break;
                    case i > 5:
                        this.tickInterval = "minutes";
                        break;
                    case i > 1:
                        this.tickInterval = "seconds_tens";
                        break;
                    case 60 * i > 20:
                        this.tickInterval = "seconds_fives";
                        break;
                    default:
                        this.tickInterval = "seconds";
                }
            }
        },
        {
            key: "generateYearScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.daysWidthOnXAxis, r = t.numberOfYears, o = e.minYear, n = 0, l = new L(this.ctx), h = "year";
                if (e.minDate > 1 || e.minMonth > 0) {
                    var c = l.determineRemainingDaysOfYear(e.minYear, e.minMonth, e.minDate);
                    n = (l.determineDaysOfYear(e.minYear) - c + 1) * s, o = e.minYear + 1, this.timeScaleArray.push({
                        position: n,
                        value: o,
                        unit: h,
                        year: o,
                        month: m.monthMod(i + 1)
                    });
                } else 1 === e.minDate && 0 === e.minMonth && this.timeScaleArray.push({
                    position: n,
                    value: o,
                    unit: h,
                    year: a,
                    month: m.monthMod(i + 1)
                });
                for(var d = o, g = n, u = 0; u < r; u++)d++, g = l.determineDaysOfYear(d - 1) * s + g, this.timeScaleArray.push({
                    position: g,
                    value: d,
                    unit: h,
                    year: d,
                    month: 1
                });
            }
        },
        {
            key: "generateMonthScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonthDate, a = t.currentMonth, s = t.currentYear, r = t.daysWidthOnXAxis, o = t.numberOfMonths, n = a, l = 0, h = new L(this.ctx), c = "month", d = 0;
                if (e.minDate > 1) {
                    l = (h.determineDaysOfMonths(a + 1, e.minYear) - i + 1) * r, n = m.monthMod(a + 1);
                    var g = s + d, u = m.monthMod(n), f = n;
                    0 === n && (c = "year", f = g, u = 1, g += d += 1), this.timeScaleArray.push({
                        position: l,
                        value: f,
                        unit: c,
                        year: g,
                        month: u
                    });
                } else this.timeScaleArray.push({
                    position: l,
                    value: n,
                    unit: c,
                    year: s,
                    month: m.monthMod(a)
                });
                for(var p = n + 1, x = l, b = 0, v = 1; b < o; b++, v++){
                    0 === (p = m.monthMod(p)) ? (c = "year", d += 1) : c = "month";
                    var y = this._getYear(s, p, d);
                    x = h.determineDaysOfMonths(p, y) * r + x;
                    var w = 0 === p ? y : p;
                    this.timeScaleArray.push({
                        position: x,
                        value: w,
                        unit: c,
                        year: y,
                        month: 0 === p ? 1 : p
                    }), p++;
                }
            }
        },
        {
            key: "generateDayScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.hoursWidthOnXAxis, r = t.numberOfDays, o = new L(this.ctx), n = "day", l = e.minDate + 1, h = l, c = function(t, e, i) {
                    return t > o.determineDaysOfMonths(e + 1, i) ? (h = 1, n = "month", g = e += 1, e) : e;
                }, d = (24 - e.minHour) * s, g = l, u = c(h, i, a);
                0 === e.minHour && 1 === e.minDate ? (d = 0, g = m.monthMod(e.minMonth), n = "month", h = e.minDate) : 1 !== e.minDate && 0 === e.minHour && 0 === e.minMinute && (d = 0, l = e.minDate, g = l, u = c(h = l, i, a)), this.timeScaleArray.push({
                    position: d,
                    value: g,
                    unit: n,
                    year: this._getYear(a, u, 0),
                    month: m.monthMod(u),
                    day: h
                });
                for(var f = d, p = 0; p < r; p++){
                    n = "day", u = c(h += 1, u, this._getYear(a, u, 0));
                    var x = this._getYear(a, u, 0);
                    f = 24 * s + f;
                    var b = 1 === h ? m.monthMod(u) : h;
                    this.timeScaleArray.push({
                        position: f,
                        value: b,
                        unit: n,
                        year: x,
                        month: m.monthMod(u),
                        day: b
                    });
                }
            }
        },
        {
            key: "generateHourScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentDate, a = t.currentMonth, s = t.currentYear, r = t.minutesWidthOnXAxis, o = t.numberOfHours, n = new L(this.ctx), l = "hour", h = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) && (p = 1, e += 1), {
                        month: e,
                        date: p
                    };
                }, c = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) ? e += 1 : e;
                }, d = 60 - (e.minMinute + e.minSecond / 60), g = d * r, u = e.minHour + 1, f = u;
                60 === d && (g = 0, f = u = e.minHour);
                var p = i;
                f >= 24 && (f = 0, p += 1, l = "day");
                var x = h(p, a).month;
                x = c(p, x), this.timeScaleArray.push({
                    position: g,
                    value: u,
                    unit: l,
                    day: p,
                    hour: f,
                    year: s,
                    month: m.monthMod(x)
                }), f++;
                for(var b = g, v = 0; v < o; v++){
                    if (l = "hour", f >= 24) f = 0, l = "day", x = h(p += 1, x).month, x = c(p, x);
                    var y = this._getYear(s, x, 0);
                    b = 60 * r + b;
                    var w = 0 === f ? p : f;
                    this.timeScaleArray.push({
                        position: b,
                        value: w,
                        unit: l,
                        hour: f,
                        day: p,
                        year: y,
                        month: m.monthMod(x)
                    }), f++;
                }
            }
        },
        {
            key: "generateMinuteScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.minutesWidthOnXAxis, h = t.secondsWidthOnXAxis, c = t.numberOfMinutes, d = a + 1, g = r, u = o, f = n, p = s, x = (60 - i - e / 1e3) * h, b = 0; b < c; b++)d >= 60 && (d = 0, 24 === (p += 1) && (p = 0)), this.timeScaleArray.push({
                    position: x,
                    value: d,
                    unit: "minute",
                    hour: p,
                    minute: d,
                    day: g,
                    year: this._getYear(f, u, 0),
                    month: m.monthMod(u)
                }), x += l, d++;
            }
        },
        {
            key: "generateSecondScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.secondsWidthOnXAxis, h = t.numberOfSeconds, c = i + 1, d = a, g = r, u = o, f = n, p = s, x = (1e3 - e) / 1e3 * l, b = 0; b < h; b++)c >= 60 && (c = 0, ++d >= 60 && (d = 0, 24 === ++p && (p = 0))), this.timeScaleArray.push({
                    position: x,
                    value: c,
                    unit: "second",
                    hour: p,
                    minute: d,
                    second: c,
                    day: g,
                    year: this._getYear(f, u, 0),
                    month: m.monthMod(u)
                }), x += l, c++;
            }
        },
        {
            key: "createRawDateString",
            value: function(t, e) {
                var i = t.year;
                return 0 === t.month && (t.month = 1), i += "-" + ("0" + t.month.toString()).slice(-2), "day" === t.unit ? i += "day" === t.unit ? "-" + ("0" + e).slice(-2) : "-01" : i += "-" + ("0" + (t.day ? t.day : "1")).slice(-2), "hour" === t.unit ? i += "hour" === t.unit ? "T" + ("0" + e).slice(-2) : "T00" : i += "T" + ("0" + (t.hour ? t.hour : "0")).slice(-2), "minute" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":" + (t.minute ? ("0" + t.minute).slice(-2) : "00"), "second" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
            }
        },
        {
            key: "formatDates",
            value: function(t) {
                var e = this, i = this.w;
                return t.map(function(t) {
                    var a = t.value.toString(), s = new L(e.ctx), r = e.createRawDateString(t, a), o = s.getDate(s.parseDate(r));
                    if (e.utc || (o = s.getDate(s.parseDateWithTimezone(r))), void 0 === i.config.xaxis.labels.format) {
                        var n = "dd MMM", l = i.config.xaxis.labels.datetimeFormatter;
                        "year" === t.unit && (n = l.year), "month" === t.unit && (n = l.month), "day" === t.unit && (n = l.day), "hour" === t.unit && (n = l.hour), "minute" === t.unit && (n = l.minute), "second" === t.unit && (n = l.second), a = s.formatDate(o, n);
                    } else a = s.formatDate(o, i.config.xaxis.labels.format);
                    return {
                        dateString: r,
                        position: t.position,
                        value: a,
                        unit: t.unit,
                        year: t.year,
                        month: t.month
                    };
                });
            }
        },
        {
            key: "removeOverlappingTS",
            value: function(t) {
                var e, i = this, a = new k(this.ctx), s = !1;
                t.length > 0 && t[0].value && t.every(function(e) {
                    return e.value.length === t[0].value.length;
                }) && (s = !0, e = a.getTextRects(t[0].value).width);
                var r = 0, o = t.map(function(o, n) {
                    if (n > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                        var l = s ? e : a.getTextRects(t[r].value).width, h = t[r].position;
                        return o.position > h + l + 10 ? (r = n, o) : null;
                    }
                    return o;
                });
                return o = o.filter(function(t) {
                    return null !== t;
                });
            }
        },
        {
            key: "_getYear",
            value: function(t, e, i) {
                return t + Math.floor(e / 12) + i;
            }
        }
    ]), t;
}(), _t = function() {
    function t(e, a) {
        i(this, t), this.ctx = a, this.w = a.w, this.el = e;
    }
    return s(t, [
        {
            key: "setupElements",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = i.chart.type;
                e.axisCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble",
                    "radar",
                    "heatmap",
                    "treemap"
                ].includes(a), e.xyCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble"
                ].includes(a), e.isBarHorizontal = [
                    "bar",
                    "rangeBar",
                    "boxPlot"
                ].includes(a) && i.plotOptions.bar.horizontal, e.chartClass = ".apexcharts".concat(e.chartID), e.dom.baseEl = this.el, e.dom.elWrap = document.createElement("div"), k.setAttrs(e.dom.elWrap, {
                    id: e.chartClass.substring(1),
                    class: "apexcharts-canvas ".concat(e.chartClass.substring(1))
                }), this.el.appendChild(e.dom.elWrap), e.dom.Paper = new window.SVG.Doc(e.dom.elWrap), e.dom.Paper.attr({
                    class: "apexcharts-svg",
                    "xmlns:data": "ApexChartsNS",
                    transform: "translate(".concat(i.chart.offsetX, ", ").concat(i.chart.offsetY, ")")
                }), e.dom.Paper.node.style.background = "dark" !== i.theme.mode || i.chart.background ? "light" !== i.theme.mode || i.chart.background ? i.chart.background : "#fff" : "#424242", this.setSVGDimensions(), e.dom.elLegendForeign = document.createElementNS(e.SVGNS, "foreignObject"), k.setAttrs(e.dom.elLegendForeign, {
                    x: 0,
                    y: 0,
                    width: e.svgWidth,
                    height: e.svgHeight
                }), e.dom.elLegendWrap = document.createElement("div"), e.dom.elLegendWrap.classList.add("apexcharts-legend"), e.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), e.dom.elLegendForeign.appendChild(e.dom.elLegendWrap), e.dom.Paper.node.appendChild(e.dom.elLegendForeign), e.dom.elGraphical = e.dom.Paper.group().attr({
                    class: "apexcharts-inner apexcharts-graphical"
                }), e.dom.elDefs = e.dom.Paper.defs(), e.dom.Paper.add(e.dom.elGraphical), e.dom.elGraphical.add(e.dom.elDefs);
            }
        },
        {
            key: "plotChartType",
            value: function(t, e) {
                var i = this.w, a = this.ctx, s = i.config, r = i.globals, o = {
                    line: {
                        series: [],
                        i: []
                    },
                    area: {
                        series: [],
                        i: []
                    },
                    scatter: {
                        series: [],
                        i: []
                    },
                    bubble: {
                        series: [],
                        i: []
                    },
                    column: {
                        series: [],
                        i: []
                    },
                    candlestick: {
                        series: [],
                        i: []
                    },
                    boxPlot: {
                        series: [],
                        i: []
                    },
                    rangeBar: {
                        series: [],
                        i: []
                    },
                    rangeArea: {
                        series: [],
                        seriesRangeEnd: [],
                        i: []
                    }
                }, n = s.chart.type || "line", l = null, h = 0;
                r.series.forEach(function(e, a) {
                    var s = t[a].type || n;
                    o[s] ? ("rangeArea" === s ? (o[s].series.push(r.seriesRangeStart[a]), o[s].seriesRangeEnd.push(r.seriesRangeEnd[a])) : o[s].series.push(e), o[s].i.push(a), "column" !== s && "bar" !== s || (i.globals.columnSeries = o.column)) : [
                        "heatmap",
                        "treemap",
                        "pie",
                        "donut",
                        "polarArea",
                        "radialBar",
                        "radar"
                    ].includes(s) ? l = s : "bar" === s ? (o.column.series.push(e), o.column.i.push(a)) : console.warn("You have specified an unrecognized series type (".concat(s, ").")), n !== s && "scatter" !== s && h++;
                }), h > 0 && (l && console.warn("Chart or series type ".concat(l, " cannot appear with other chart or series types.")), o.column.series.length > 0 && s.plotOptions.bar.horizontal && (h -= o.column.series.length, o.column = {
                    series: [],
                    i: []
                }, i.globals.columnSeries = {
                    series: [],
                    i: []
                }, console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"))), r.comboCharts || (r.comboCharts = h > 0);
                var c = new Ot(a, e), d = new Lt(a, e);
                a.pie = new Tt(a);
                var g = new Xt(a);
                a.rangeBar = new Et(a, e);
                var u = new zt(a), f = [];
                if (r.comboCharts) {
                    var x, b, v = new A(a);
                    if (o.area.series.length > 0) (x = f).push.apply(x, p(v.drawSeriesByGroup(o.area, r.areaGroups, "area", c)));
                    if (o.column.series.length > 0) {
                        if (s.chart.stacked) {
                            var m = new Ct(a, e);
                            f.push(m.draw(o.column.series, o.column.i));
                        } else a.bar = new St(a, e), f.push(a.bar.draw(o.column.series, o.column.i));
                    }
                    if (o.rangeArea.series.length > 0 && f.push(c.draw(o.rangeArea.series, "rangeArea", o.rangeArea.i, o.rangeArea.seriesRangeEnd)), o.line.series.length > 0) (b = f).push.apply(b, p(v.drawSeriesByGroup(o.line, r.lineGroups, "line", c)));
                    if (o.candlestick.series.length > 0 && f.push(d.draw(o.candlestick.series, "candlestick", o.candlestick.i)), o.boxPlot.series.length > 0 && f.push(d.draw(o.boxPlot.series, "boxPlot", o.boxPlot.i)), o.rangeBar.series.length > 0 && f.push(a.rangeBar.draw(o.rangeBar.series, o.rangeBar.i)), o.scatter.series.length > 0) {
                        var y = new Ot(a, e, !0);
                        f.push(y.draw(o.scatter.series, "scatter", o.scatter.i));
                    }
                    if (o.bubble.series.length > 0) {
                        var w = new Ot(a, e, !0);
                        f.push(w.draw(o.bubble.series, "bubble", o.bubble.i));
                    }
                } else switch(s.chart.type){
                    case "line":
                        f = c.draw(r.series, "line");
                        break;
                    case "area":
                        f = c.draw(r.series, "area");
                        break;
                    case "bar":
                        if (s.chart.stacked) f = new Ct(a, e).draw(r.series);
                        else a.bar = new St(a, e), f = a.bar.draw(r.series);
                        break;
                    case "candlestick":
                        f = new Lt(a, e).draw(r.series, "candlestick");
                        break;
                    case "boxPlot":
                        f = new Lt(a, e).draw(r.series, s.chart.type);
                        break;
                    case "rangeBar":
                        f = a.rangeBar.draw(r.series);
                        break;
                    case "rangeArea":
                        f = c.draw(r.seriesRangeStart, "rangeArea", void 0, r.seriesRangeEnd);
                        break;
                    case "heatmap":
                        f = new Mt(a, e).draw(r.series);
                        break;
                    case "treemap":
                        f = new Bt(a, e).draw(r.series);
                        break;
                    case "pie":
                    case "donut":
                    case "polarArea":
                        f = a.pie.draw(r.series);
                        break;
                    case "radialBar":
                        f = g.draw(r.series);
                        break;
                    case "radar":
                        f = u.draw(r.series);
                        break;
                    default:
                        f = c.draw(r.series);
                }
                return f;
            }
        },
        {
            key: "setSVGDimensions",
            value: function() {
                var t = this.w, e = t.globals, i = t.config;
                i.chart.width = i.chart.width || "100%", i.chart.height = i.chart.height || "auto", e.svgWidth = i.chart.width, e.svgHeight = i.chart.height;
                var a = m.getDimensions(this.el), s = i.chart.width.toString().split(/[0-9]+/g).pop();
                "%" === s ? m.isNumber(a[0]) && (0 === a[0].width && (a = m.getDimensions(this.el.parentNode)), e.svgWidth = a[0] * parseInt(i.chart.width, 10) / 100) : "px" !== s && "" !== s || (e.svgWidth = parseInt(i.chart.width, 10));
                var r = String(i.chart.height).toString().split(/[0-9]+/g).pop();
                if ("auto" !== e.svgHeight && "" !== e.svgHeight) {
                    if ("%" === r) {
                        var o = m.getDimensions(this.el.parentNode);
                        e.svgHeight = o[1] * parseInt(i.chart.height, 10) / 100;
                    } else e.svgHeight = parseInt(i.chart.height, 10);
                } else e.svgHeight = e.axisCharts ? e.svgWidth / 1.61 : e.svgWidth / 1.2;
                if (e.svgWidth = Math.max(e.svgWidth, 0), e.svgHeight = Math.max(e.svgHeight, 0), k.setAttrs(e.dom.Paper.node, {
                    width: e.svgWidth,
                    height: e.svgHeight
                }), "%" !== r) {
                    var n = i.chart.sparkline.enabled ? 0 : e.axisCharts ? i.chart.parentHeightOffset : 0;
                    e.dom.Paper.node.parentNode.parentNode.style.minHeight = "".concat(e.svgHeight + n, "px");
                }
                e.dom.elWrap.style.width = "".concat(e.svgWidth, "px"), e.dom.elWrap.style.height = "".concat(e.svgHeight, "px");
            }
        },
        {
            key: "shiftGraphPosition",
            value: function() {
                var t = this.w.globals, e = t.translateY, i = t.translateX;
                k.setAttrs(t.dom.elGraphical.node, {
                    transform: "translate(".concat(i, ", ").concat(e, ")")
                });
            }
        },
        {
            key: "resizeNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = 0, a = t.config.chart.sparkline.enabled ? 1 : 15;
                a += t.config.grid.padding.bottom, [
                    "top",
                    "bottom"
                ].includes(t.config.legend.position) && t.config.legend.show && !t.config.legend.floating && (i = new gt(this.ctx).legendHelpers.getLegendDimensions().clwh + 7);
                var s = t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * t.globals.radialSize;
                if (s && !t.config.chart.sparkline.enabled && 0 !== t.config.plotOptions.radialBar.startAngle) {
                    var o = m.getBoundingClientRect(s);
                    r = o.bottom;
                    var n = o.bottom - o.top;
                    r = Math.max(2.05 * t.globals.radialSize, n);
                }
                var l = Math.ceil(r + e.translateY + i + a);
                e.dom.elLegendForeign && e.dom.elLegendForeign.setAttribute("height", l), t.config.chart.height && String(t.config.chart.height).includes("%") || (e.dom.elWrap.style.height = "".concat(l, "px"), k.setAttrs(e.dom.Paper.node, {
                    height: l
                }), e.dom.Paper.node.parentNode.parentNode.style.minHeight = "".concat(l, "px"));
            }
        },
        {
            key: "coreCalculations",
            value: function() {
                new J(this.ctx).init();
            }
        },
        {
            key: "resetGlobals",
            value: function() {
                var t = this, e = function() {
                    return t.w.config.series.map(function() {
                        return [];
                    });
                }, i = new H, a = this.w.globals;
                i.initGlobalVars(a), a.seriesXvalues = e(), a.seriesYvalues = e();
            }
        },
        {
            key: "isMultipleY",
            value: function() {
                return !!(Array.isArray(this.w.config.yaxis) && this.w.config.yaxis.length > 1) && (this.w.globals.isMultipleYAxis = !0, !0);
            }
        },
        {
            key: "xySettings",
            value: function() {
                var t = this.w, e = null;
                if (t.globals.axisCharts) {
                    if ("back" === t.config.xaxis.crosshairs.position && new it(this.ctx).drawXCrosshairs(), "back" === t.config.yaxis[0].crosshairs.position && new it(this.ctx).drawYCrosshairs(), "datetime" === t.config.xaxis.type && void 0 === t.config.xaxis.labels.formatter) {
                        this.ctx.timeScale = new jt(this.ctx);
                        var i = [];
                        isFinite(t.globals.minX) && isFinite(t.globals.maxX) && !t.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minX, t.globals.maxX) : t.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minY, t.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                    }
                    e = new A(this.ctx).getCalculatedRatios();
                }
                return e;
            }
        },
        {
            key: "updateSourceChart",
            value: function(t) {
                this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                    chart: {
                        selection: {
                            xaxis: {
                                min: t.w.globals.minX,
                                max: t.w.globals.maxX
                            }
                        }
                    }
                }, !1, !1);
            }
        },
        {
            key: "setupBrushHandler",
            value: function() {
                var t = this, e = this.w;
                if (e.config.chart.brush.enabled && "function" != typeof e.config.chart.events.selection) {
                    var i = Array.isArray(e.config.chart.brush.targets) ? e.config.chart.brush.targets : [
                        e.config.chart.brush.target
                    ];
                    i.forEach(function(e) {
                        var i = ApexCharts.getChartByID(e);
                        i.w.globals.brushSource = t.ctx, "function" != typeof i.w.config.chart.events.zoomed && (i.w.config.chart.events.zoomed = function() {
                            return t.updateSourceChart(i);
                        }), "function" != typeof i.w.config.chart.events.scrolled && (i.w.config.chart.events.scrolled = function() {
                            return t.updateSourceChart(i);
                        });
                    }), e.config.chart.events.selection = function(t, e) {
                        i.forEach(function(t) {
                            ApexCharts.getChartByID(t).ctx.updateHelpers._updateOptions({
                                xaxis: {
                                    min: e.xaxis.min,
                                    max: e.xaxis.max
                                }
                            }, !1, !1, !1, !1);
                        });
                    };
                }
            }
        }
    ]), t;
}(), Ut = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "_updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return new Promise(function(o) {
                    var n = [
                        e.ctx
                    ];
                    s && (n = e.ctx.getSyncedCharts()), e.ctx.w.globals.isExecCalled && (n = [
                        e.ctx
                    ], e.ctx.w.globals.isExecCalled = !1), n.forEach(function(s, l) {
                        var h = s.w;
                        if (h.globals.shouldAnimate = a, i || (h.globals.resized = !0, h.globals.dataChanged = !0, a && s.series.getPreviousPaths()), t && "object" === b(t) && (s.config = new D(t), t = A.extendArrayProps(s.config, t, h), s.w.globals.chartID !== e.ctx.w.globals.chartID && delete t.series, h.config = m.extend(h.config, t), r && (h.globals.lastXAxis = t.xaxis ? m.clone(t.xaxis) : [], h.globals.lastYAxis = t.yaxis ? m.clone(t.yaxis) : [], h.globals.initialConfig = m.extend({}, h.config), h.globals.initialSeries = m.clone(h.config.series), t.series))) {
                            for(var c = 0; c < h.globals.collapsedSeriesIndices.length; c++){
                                var d = h.config.series[h.globals.collapsedSeriesIndices[c]];
                                h.globals.collapsedSeries[c].data = h.globals.axisCharts ? d.data.slice() : d;
                            }
                            for(var g = 0; g < h.globals.ancillaryCollapsedSeriesIndices.length; g++){
                                var u = h.config.series[h.globals.ancillaryCollapsedSeriesIndices[g]];
                                h.globals.ancillaryCollapsedSeries[g].data = h.globals.axisCharts ? u.data.slice() : u;
                            }
                            s.series.emptyCollapsedSeries(h.config.series);
                        }
                        return s.update(t).then(function() {
                            l === n.length - 1 && o(s);
                        });
                    });
                });
            }
        },
        {
            key: "_updateSeries",
            value: function(t, e) {
                var i = this, a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise(function(s) {
                    var r, o = i.w;
                    return o.globals.shouldAnimate = e, o.globals.dataChanged = !0, e && i.ctx.series.getPreviousPaths(), o.globals.axisCharts ? (0 === (r = t.map(function(t, e) {
                        return i._extendSeries(t, e);
                    })).length && (r = [
                        {
                            data: []
                        }
                    ]), o.config.series = r) : o.config.series = t.slice(), a && (o.globals.initialConfig.series = m.clone(o.config.series), o.globals.initialSeries = m.clone(o.config.series)), i.ctx.update().then(function() {
                        s(i.ctx);
                    });
                });
            }
        },
        {
            key: "_extendSeries",
            value: function(t, e) {
                var i = this.w, a = i.config.series[e];
                return g(g({}, i.config.series[e]), {}, {
                    name: t.name ? t.name : null == a ? void 0 : a.name,
                    color: t.color ? t.color : null == a ? void 0 : a.color,
                    type: t.type ? t.type : null == a ? void 0 : a.type,
                    group: t.group ? t.group : null == a ? void 0 : a.group,
                    hidden: void 0 !== t.hidden ? t.hidden : null == a ? void 0 : a.hidden,
                    data: t.data ? t.data : null == a ? void 0 : a.data,
                    zIndex: void 0 !== t.zIndex ? t.zIndex : e
                });
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(t, "']");
                return i.globals.axisCharts ? a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(e, "'], ").concat(s, " circle[j='").concat(e, "'], ").concat(s, " rect[j='").concat(e, "']")).members[0] : void 0 === e && (a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(t, "']")).members[0], "pie" !== i.config.chart.type && "polarArea" !== i.config.chart.type && "donut" !== i.config.chart.type || this.ctx.pie.pieClicked(t)), a ? (new k(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
            }
        },
        {
            key: "forceXAxisUpdate",
            value: function(t) {
                var e = this.w;
                if ([
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== t.xaxis[i] && (e.config.xaxis[i] = t.xaxis[i], e.globals.lastXAxis[i] = t.xaxis[i]);
                }), t.xaxis.categories && t.xaxis.categories.length && (e.config.xaxis.categories = t.xaxis.categories), e.config.xaxis.convertedCatToNumeric) {
                    var i = new F(t);
                    t = i.convertCatToNumericXaxis(t, this.ctx);
                }
                return t;
            }
        },
        {
            key: "forceYAxisUpdate",
            value: function(t) {
                return t.chart && t.chart.stacked && "100%" === t.chart.stackType && (Array.isArray(t.yaxis) ? t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }) : (t.yaxis.min = 0, t.yaxis.max = 100)), t;
            }
        },
        {
            key: "revertDefaultAxisMinMax",
            value: function(t) {
                var e = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                t && t.xaxis && (a = t.xaxis), t && t.yaxis && (s = t.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                var r = function(t) {
                    void 0 !== s[t] && (i.config.yaxis[t].min = s[t].min, i.config.yaxis[t].max = s[t].max);
                };
                i.config.yaxis.map(function(t, a) {
                    i.globals.zoomed || void 0 !== s[a] ? r(a) : void 0 !== e.ctx.opts.yaxis[a] && (t.min = e.ctx.opts.yaxis[a].min, t.max = e.ctx.opts.yaxis[a].max);
                });
            }
        }
    ]), t;
}();
Nt = "undefined" != typeof window ? window : void 0, Wt = function(t, e) {
    var i = (void 0 !== this ? this : t).SVG = function(t) {
        if (i.supported) return t = new i.Doc(t), i.parser.draw || i.prepare(), t;
    };
    if (i.ns = "http://www.w3.org/2000/svg", i.xmlns = "http://www.w3.org/2000/xmlns/", i.xlink = "http://www.w3.org/1999/xlink", i.svgjs = "http://svgjs.dev", i.supported = !0, !i.supported) return !1;
    i.did = 1e3, i.eid = function(t) {
        return "Svgjs" + c(t) + i.did++;
    }, i.create = function(t) {
        var i = e.createElementNS(this.ns, t);
        return i.setAttribute("id", this.eid(t)), i;
    }, i.extend = function() {
        var t, e;
        e = (t = [].slice.call(arguments)).pop();
        for(var a = t.length - 1; a >= 0; a--)if (t[a]) for(var s in e)t[a].prototype[s] = e[s];
        i.Set && i.Set.inherit && i.Set.inherit();
    }, i.invent = function(t) {
        var e = "function" == typeof t.create ? t.create : function() {
            this.constructor.call(this, i.create(t.create));
        };
        return t.inherit && (e.prototype = new t.inherit), t.extend && i.extend(e, t.extend), t.construct && i.extend(t.parent || i.Container, t.construct), e;
    }, i.adopt = function(e) {
        var a;
        return e ? e.instance ? e.instance : ((a = "svg" == e.nodeName ? e.parentNode instanceof t.SVGElement ? new i.Nested : new i.Doc : "linearGradient" == e.nodeName ? new i.Gradient("linear") : "radialGradient" == e.nodeName ? new i.Gradient("radial") : i[c(e.nodeName)] ? new i[c(e.nodeName)] : new i.Element(e)).type = e.nodeName, a.node = e, e.instance = a, a instanceof i.Doc && a.namespace().defs(), a.setData(JSON.parse(e.getAttribute("svgjs:data")) || {}), a) : null;
    }, i.prepare = function() {
        var t = e.getElementsByTagName("body")[0], a = (t ? new i.Doc(t) : i.adopt(e.documentElement).nested()).size(2, 0);
        i.parser = {
            body: t || e.documentElement,
            draw: a.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
            poly: a.polyline().node,
            path: a.path().node,
            native: i.create("svg")
        };
    }, i.parser = {
        native: i.create("svg")
    }, e.addEventListener("DOMContentLoaded", function() {
        i.parser.draw || i.prepare();
    }, !1), i.regex = {
        numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
        hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /rgb\((\d+),(\d+),(\d+)\)/,
        reference: /#([a-z0-9\-_]+)/i,
        transforms: /\)\s*,?\s*/,
        whitespace: /\s/g,
        isHex: /^#[a-f0-9]{3,6}$/i,
        isRgb: /^rgb\(/,
        isCss: /[^:]+:[^;]+;?/,
        isBlank: /^(\s+)?$/,
        isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
        isPercent: /^-?[\d\.]+%$/,
        isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
        delimiter: /[\s,]+/,
        hyphen: /([^e])\-/gi,
        pathLetters: /[MLHVCSQTAZ]/gi,
        isPathLetter: /[MLHVCSQTAZ]/i,
        numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
        dots: /\./g
    }, i.utils = {
        map: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)a.push(e(t[s]));
            return a;
        },
        filter: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)e(t[s]) && a.push(t[s]);
            return a;
        },
        filterSVGElements: function(e) {
            return this.filter(e, function(e) {
                return e instanceof t.SVGElement;
            });
        }
    }, i.defaults = {
        attrs: {
            "fill-opacity": 1,
            "stroke-opacity": 1,
            "stroke-width": 0,
            "stroke-linejoin": "miter",
            "stroke-linecap": "butt",
            fill: "#000000",
            stroke: "#000000",
            opacity: 1,
            x: 0,
            y: 0,
            cx: 0,
            cy: 0,
            width: 0,
            height: 0,
            r: 0,
            rx: 0,
            ry: 0,
            offset: 0,
            "stop-opacity": 1,
            "stop-color": "#000000",
            "font-size": 16,
            "font-family": "Helvetica, Arial, sans-serif",
            "text-anchor": "start"
        }
    }, i.Color = function(t) {
        var e, a;
        this.r = 0, this.g = 0, this.b = 0, t && ("string" == typeof t ? i.regex.isRgb.test(t) ? (e = i.regex.rgb.exec(t.replace(i.regex.whitespace, "")), this.r = parseInt(e[1]), this.g = parseInt(e[2]), this.b = parseInt(e[3])) : i.regex.isHex.test(t) && (e = i.regex.hex.exec(4 == (a = t).length ? [
            "#",
            a.substring(1, 2),
            a.substring(1, 2),
            a.substring(2, 3),
            a.substring(2, 3),
            a.substring(3, 4),
            a.substring(3, 4)
        ].join("") : a), this.r = parseInt(e[1], 16), this.g = parseInt(e[2], 16), this.b = parseInt(e[3], 16)) : "object" === b(t) && (this.r = t.r, this.g = t.g, this.b = t.b));
    }, i.extend(i.Color, {
        toString: function() {
            return this.toHex();
        },
        toHex: function() {
            return "#" + d(this.r) + d(this.g) + d(this.b);
        },
        toRgb: function() {
            return "rgb(" + [
                this.r,
                this.g,
                this.b
            ].join() + ")";
        },
        brightness: function() {
            return this.r / 255 * .3 + this.g / 255 * .59 + this.b / 255 * .11;
        },
        morph: function(t) {
            return this.destination = new i.Color(t), this;
        },
        at: function(t) {
            return this.destination ? (t = t < 0 ? 0 : t > 1 ? 1 : t, new i.Color({
                r: ~~(this.r + (this.destination.r - this.r) * t),
                g: ~~(this.g + (this.destination.g - this.g) * t),
                b: ~~(this.b + (this.destination.b - this.b) * t)
            })) : this;
        }
    }), i.Color.test = function(t) {
        return t += "", i.regex.isHex.test(t) || i.regex.isRgb.test(t);
    }, i.Color.isRgb = function(t) {
        return t && "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b;
    }, i.Color.isColor = function(t) {
        return i.Color.isRgb(t) || i.Color.test(t);
    }, i.Array = function(t, e) {
        0 == (t = (t || []).valueOf()).length && e && (t = e.valueOf()), this.value = this.parse(t);
    }, i.extend(i.Array, {
        toString: function() {
            return this.value.join(" ");
        },
        valueOf: function() {
            return this.value;
        },
        parse: function(t) {
            return t = t.valueOf(), Array.isArray(t) ? t : this.split(t);
        }
    }), i.PointArray = function(t, e) {
        i.Array.call(this, t, e || [
            [
                0,
                0
            ]
        ]);
    }, i.PointArray.prototype = new i.Array, i.PointArray.prototype.constructor = i.PointArray;
    for(var a = {
        M: function(t, e, i) {
            return e.x = i.x = t[0], e.y = i.y = t[1], [
                "M",
                e.x,
                e.y
            ];
        },
        L: function(t, e) {
            return e.x = t[0], e.y = t[1], [
                "L",
                t[0],
                t[1]
            ];
        },
        H: function(t, e) {
            return e.x = t[0], [
                "H",
                t[0]
            ];
        },
        V: function(t, e) {
            return e.y = t[0], [
                "V",
                t[0]
            ];
        },
        C: function(t, e) {
            return e.x = t[4], e.y = t[5], [
                "C",
                t[0],
                t[1],
                t[2],
                t[3],
                t[4],
                t[5]
            ];
        },
        Q: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "Q",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        S: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "S",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        Z: function(t, e, i) {
            return e.x = i.x, e.y = i.y, [
                "Z"
            ];
        }
    }, s = "mlhvqtcsaz".split(""), r = 0, o = s.length; r < o; ++r)a[s[r]] = function(t) {
        return function(e, i, s) {
            if ("H" == t) e[0] = e[0] + i.x;
            else if ("V" == t) e[0] = e[0] + i.y;
            else if ("A" == t) e[5] = e[5] + i.x, e[6] = e[6] + i.y;
            else for(var r = 0, o = e.length; r < o; ++r)e[r] = e[r] + (r % 2 ? i.y : i.x);
            if (a && "function" == typeof a[t]) return a[t](e, i, s);
        };
    }(s[r].toUpperCase());
    i.PathArray = function(t, e) {
        i.Array.call(this, t, e || [
            [
                "M",
                0,
                0
            ]
        ]);
    }, i.PathArray.prototype = new i.Array, i.PathArray.prototype.constructor = i.PathArray, i.extend(i.PathArray, {
        toString: function() {
            return function(t) {
                for(var e = 0, i = t.length, a = ""; e < i; e++)a += t[e][0], null != t[e][1] && (a += t[e][1], null != t[e][2] && (a += " ", a += t[e][2], null != t[e][3] && (a += " ", a += t[e][3], a += " ", a += t[e][4], null != t[e][5] && (a += " ", a += t[e][5], a += " ", a += t[e][6], null != t[e][7] && (a += " ", a += t[e][7])))));
                return a + " ";
            }(this.value);
        },
        move: function(t, e) {
            var i = this.bbox();
            return i.x, i.y, this;
        },
        at: function(t) {
            if (!this.destination) return this;
            for(var e = this.value, a = this.destination.value, s = [], r = new i.PathArray, o = 0, n = e.length; o < n; o++){
                s[o] = [
                    e[o][0]
                ];
                for(var l = 1, h = e[o].length; l < h; l++)s[o][l] = e[o][l] + (a[o][l] - e[o][l]) * t;
                "A" === s[o][0] && (s[o][4] = +(0 != s[o][4]), s[o][5] = +(0 != s[o][5]));
            }
            return r.value = s, r;
        },
        parse: function(t) {
            if (t instanceof i.PathArray) return t.valueOf();
            var e, s = {
                M: 2,
                L: 2,
                H: 1,
                V: 1,
                C: 6,
                S: 4,
                Q: 4,
                T: 2,
                A: 7,
                Z: 0
            };
            t = "string" == typeof t ? t.replace(i.regex.numbersWithDots, l).replace(i.regex.pathLetters, " $& ").replace(i.regex.hyphen, "$1 -").trim().split(i.regex.delimiter) : t.reduce(function(t, e) {
                return [].concat.call(t, e);
            }, []);
            var r = [], o = new i.Point, n = new i.Point, h = 0, c = t.length;
            do i.regex.isPathLetter.test(t[h]) ? (e = t[h], ++h) : "M" == e ? e = "L" : "m" == e && (e = "l"), r.push(a[e].call(null, t.slice(h, h += s[e.toUpperCase()]).map(parseFloat), o, n));
            while (c > h);
            return r;
        },
        bbox: function() {
            return i.parser.draw || i.prepare(), i.parser.path.setAttribute("d", this.toString()), i.parser.path.getBBox();
        }
    }), i.Number = i.invent({
        create: function(t, e) {
            this.value = 0, this.unit = e || "", "number" == typeof t ? this.value = isNaN(t) ? 0 : isFinite(t) ? t : t < 0 ? -340000000000000000000000000000000000000 : 34e37 : "string" == typeof t ? (e = t.match(i.regex.numberAndUnit)) && (this.value = parseFloat(e[1]), "%" == e[5] ? this.value /= 100 : "s" == e[5] && (this.value *= 1e3), this.unit = e[5]) : t instanceof i.Number && (this.value = t.valueOf(), this.unit = t.unit);
        },
        extend: {
            toString: function() {
                return ("%" == this.unit ? ~~(1e8 * this.value) / 1e6 : "s" == this.unit ? this.value / 1e3 : this.value) + this.unit;
            },
            toJSON: function() {
                return this.toString();
            },
            valueOf: function() {
                return this.value;
            },
            plus: function(t) {
                return t = new i.Number(t), new i.Number(this + t, this.unit || t.unit);
            },
            minus: function(t) {
                return t = new i.Number(t), new i.Number(this - t, this.unit || t.unit);
            },
            times: function(t) {
                return t = new i.Number(t), new i.Number(this * t, this.unit || t.unit);
            },
            divide: function(t) {
                return t = new i.Number(t), new i.Number(this / t, this.unit || t.unit);
            },
            to: function(t) {
                var e = new i.Number(this);
                return "string" == typeof t && (e.unit = t), e;
            },
            morph: function(t) {
                return this.destination = new i.Number(t), t.relative && (this.destination.value += this.value), this;
            },
            at: function(t) {
                return this.destination ? new i.Number(this.destination).minus(this).times(t).plus(this) : this;
            }
        }
    }), i.Element = i.invent({
        create: function(t) {
            this._stroke = i.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = t) && (this.type = t.nodeName, this.node.instance = this, this._stroke = t.getAttribute("stroke") || this._stroke);
        },
        extend: {
            x: function(t) {
                return this.attr("x", t);
            },
            y: function(t) {
                return this.attr("y", t);
            },
            cx: function(t) {
                return null == t ? this.x() + this.width() / 2 : this.x(t - this.width() / 2);
            },
            cy: function(t) {
                return null == t ? this.y() + this.height() / 2 : this.y(t - this.height() / 2);
            },
            move: function(t, e) {
                return this.x(t).y(e);
            },
            center: function(t, e) {
                return this.cx(t).cy(e);
            },
            width: function(t) {
                return this.attr("width", t);
            },
            height: function(t) {
                return this.attr("height", t);
            },
            size: function(t, e) {
                var a = g(this, t, e);
                return this.width(new i.Number(a.width)).height(new i.Number(a.height));
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = p(this.node.cloneNode(!0));
                return t ? t.add(e) : this.after(e), e;
            },
            remove: function() {
                return this.parent() && this.parent().removeElement(this), this;
            },
            replace: function(t) {
                return this.after(t).remove(), t;
            },
            addTo: function(t) {
                return t.put(this);
            },
            putIn: function(t) {
                return t.add(this);
            },
            id: function(t) {
                return this.attr("id", t);
            },
            show: function() {
                return this.style("display", "");
            },
            hide: function() {
                return this.style("display", "none");
            },
            visible: function() {
                return "none" != this.style("display");
            },
            toString: function() {
                return this.attr("id");
            },
            classes: function() {
                var t = this.attr("class");
                return null == t ? [] : t.trim().split(i.regex.delimiter);
            },
            hasClass: function(t) {
                return -1 != this.classes().indexOf(t);
            },
            addClass: function(t) {
                if (!this.hasClass(t)) {
                    var e = this.classes();
                    e.push(t), this.attr("class", e.join(" "));
                }
                return this;
            },
            removeClass: function(t) {
                return this.hasClass(t) && this.attr("class", this.classes().filter(function(e) {
                    return e != t;
                }).join(" ")), this;
            },
            toggleClass: function(t) {
                return this.hasClass(t) ? this.removeClass(t) : this.addClass(t);
            },
            reference: function(t) {
                return i.get(this.attr(t));
            },
            parent: function(e) {
                var a = this;
                if (!a.node.parentNode) return null;
                if (a = i.adopt(a.node.parentNode), !e) return a;
                for(; a && a.node instanceof t.SVGElement;){
                    if ("string" == typeof e ? a.matches(e) : a instanceof e) return a;
                    if (!a.node.parentNode || "#document" == a.node.parentNode.nodeName) return null;
                    a = i.adopt(a.node.parentNode);
                }
            },
            doc: function() {
                return this instanceof i.Doc ? this : this.parent(i.Doc);
            },
            parents: function(t) {
                var e = [], i = this;
                do {
                    if (!(i = i.parent(t)) || !i.node) break;
                    e.push(i);
                }while (i.parent);
                return e;
            },
            matches: function(t) {
                return function(t, e) {
                    return (t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector).call(t, e);
                }(this.node, t);
            },
            native: function() {
                return this.node;
            },
            svg: function(t) {
                var a = e.createElementNS("http://www.w3.org/2000/svg", "svg");
                if (!(t && this instanceof i.Parent)) return a.appendChild(t = e.createElementNS("http://www.w3.org/2000/svg", "svg")), this.writeDataToDom(), t.appendChild(this.node.cloneNode(!0)), a.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                a.innerHTML = "<svg>" + t.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                for(var s = 0, r = a.firstChild.childNodes.length; s < r; s++)this.node.appendChild(a.firstChild.firstChild);
                return this;
            },
            writeDataToDom: function() {
                return (this.each || this.lines) && (this.each ? this : this.lines()).each(function() {
                    this.writeDataToDom();
                }), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this;
            },
            setData: function(t) {
                return this.dom = t, this;
            },
            is: function(t) {
                return function(t, e) {
                    return t instanceof e;
                }(this, t);
            }
        }
    }), i.easing = {
        "-": function(t) {
            return t;
        },
        "<>": function(t) {
            return -Math.cos(t * Math.PI) / 2 + .5;
        },
        ">": function(t) {
            return Math.sin(t * Math.PI / 2);
        },
        "<": function(t) {
            return 1 - Math.cos(t * Math.PI / 2);
        }
    }, i.morph = function(t) {
        return function(e, a) {
            return new i.MorphObj(e, a).at(t);
        };
    }, i.Situation = i.invent({
        create: function(t) {
            this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new i.Number(t.duration).valueOf(), this.delay = new i.Number(t.delay).valueOf(), this.start = +new Date + this.delay, this.finish = this.start + this.duration, this.ease = t.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {};
        }
    }), i.FX = i.invent({
        create: function(t) {
            this._target = t, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1;
        },
        extend: {
            animate: function(t, e, a) {
                "object" === b(t) && (e = t.ease, a = t.delay, t = t.duration);
                var s = new i.Situation({
                    duration: t || 1e3,
                    delay: a || 0,
                    ease: i.easing[e || "-"] || e
                });
                return this.queue(s), this;
            },
            target: function(t) {
                return t && t instanceof i.Element ? (this._target = t, this) : this._target;
            },
            timeToAbsPos: function(t) {
                return (t - this.situation.start) / (this.situation.duration / this._speed);
            },
            absPosToTime: function(t) {
                return this.situation.duration / this._speed * t + this.situation.start;
            },
            startAnimFrame: function() {
                this.stopAnimFrame(), this.animationFrame = t.requestAnimationFrame((function() {
                    this.step();
                }).bind(this));
            },
            stopAnimFrame: function() {
                t.cancelAnimationFrame(this.animationFrame);
            },
            start: function() {
                return !this.active && this.situation && (this.active = !0, this.startCurrent()), this;
            },
            startCurrent: function() {
                return this.situation.start = +new Date + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step();
            },
            queue: function(t) {
                return ("function" == typeof t || t instanceof i.Situation) && this.situations.push(t), this.situation || (this.situation = this.situations.shift()), this;
            },
            dequeue: function() {
                return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof i.Situation ? this.start() : this.situation.call(this)), this;
            },
            initAnimations: function() {
                var t, e = this.situation;
                if (e.init) return this;
                for(var a in e.animations){
                    t = this.target()[a](), Array.isArray(t) || (t = [
                        t
                    ]), Array.isArray(e.animations[a]) || (e.animations[a] = [
                        e.animations[a]
                    ]);
                    for(var s = t.length; s--;)e.animations[a][s] instanceof i.Number && (t[s] = new i.Number(t[s])), e.animations[a][s] = t[s].morph(e.animations[a][s]);
                }
                for(var a in e.attrs)e.attrs[a] = new i.MorphObj(this.target().attr(a), e.attrs[a]);
                for(var a in e.styles)e.styles[a] = new i.MorphObj(this.target().style(a), e.styles[a]);
                return e.initialTransformation = this.target().matrixify(), e.init = !0, this;
            },
            clearQueue: function() {
                return this.situations = [], this;
            },
            clearCurrent: function() {
                return this.situation = null, this;
            },
            stop: function(t, e) {
                var i = this.active;
                return this.active = !1, e && this.clearQueue(), t && this.situation && (!i && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent();
            },
            after: function(t) {
                var e = this.last();
                return this.target().on("finished.fx", function i(a) {
                    a.detail.situation == e && (t.call(this, e), this.off("finished.fx", i));
                }), this._callStart();
            },
            during: function(t) {
                var e = this.last(), a = function(a) {
                    a.detail.situation == e && t.call(this, a.detail.pos, i.morph(a.detail.pos), a.detail.eased, e);
                };
                return this.target().off("during.fx", a).on("during.fx", a), this.after(function() {
                    this.off("during.fx", a);
                }), this._callStart();
            },
            afterAll: function(t) {
                var e = function e(i) {
                    t.call(this), this.off("allfinished.fx", e);
                };
                return this.target().off("allfinished.fx", e).on("allfinished.fx", e), this._callStart();
            },
            last: function() {
                return this.situations.length ? this.situations[this.situations.length - 1] : this.situation;
            },
            add: function(t, e, i) {
                return this.last()[i || "animations"][t] = e, this._callStart();
            },
            step: function(t) {
                var e, i, a;
                t || (this.absPos = this.timeToAbsPos(+new Date)), !1 !== this.situation.loops ? (e = Math.max(this.absPos, 0), i = Math.floor(e), !0 === this.situation.loops || i < this.situation.loops ? (this.pos = e - i, a = this.situation.loop, this.situation.loop = i) : (this.absPos = this.situation.loops, this.pos = 1, a = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - a) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                var s = this.situation.ease(this.pos);
                for(var r in this.situation.once)r > this.lastPos && r <= s && (this.situation.once[r].call(this.target(), this.pos, s), delete this.situation.once[r]);
                return this.active && this.target().fire("during", {
                    pos: this.pos,
                    eased: s,
                    fx: this,
                    situation: this.situation
                }), this.situation ? (this.eachAt(), 1 == this.pos && !this.situation.reversed || this.situation.reversed && 0 == this.pos ? (this.stopAnimFrame(), this.target().fire("finished", {
                    fx: this,
                    situation: this.situation
                }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = s, this) : this;
            },
            eachAt: function() {
                var t, e = this, a = this.target(), s = this.situation;
                for(var r in s.animations)t = [].concat(s.animations[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), a[r].apply(a, t);
                for(var r in s.attrs)t = [
                    r
                ].concat(s.attrs[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), a.attr.apply(a, t);
                for(var r in s.styles)t = [
                    r
                ].concat(s.styles[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), a.style.apply(a, t);
                if (s.transforms.length) {
                    t = s.initialTransformation, r = 0;
                    for(var o = s.transforms.length; r < o; r++){
                        var n = s.transforms[r];
                        n instanceof i.Matrix ? t = n.relative ? t.multiply((new i.Matrix).morph(n).at(s.ease(this.pos))) : t.morph(n).at(s.ease(this.pos)) : (n.relative || n.undo(t.extract()), t = t.multiply(n.at(s.ease(this.pos))));
                    }
                    a.matrix(t);
                }
                return this;
            },
            once: function(t, e, i) {
                var a = this.last();
                return i || (t = a.ease(t)), a.once[t] = e, this;
            },
            _callStart: function() {
                return setTimeout((function() {
                    this.start();
                }).bind(this), 0), this;
            }
        },
        parent: i.Element,
        construct: {
            animate: function(t, e, a) {
                return (this.fx || (this.fx = new i.FX(this))).animate(t, e, a);
            },
            delay: function(t) {
                return (this.fx || (this.fx = new i.FX(this))).delay(t);
            },
            stop: function(t, e) {
                return this.fx && this.fx.stop(t, e), this;
            },
            finish: function() {
                return this.fx && this.fx.finish(), this;
            }
        }
    }), i.MorphObj = i.invent({
        create: function(t, e) {
            return i.Color.isColor(e) ? new i.Color(t).morph(e) : i.regex.delimiter.test(t) ? i.regex.pathLetters.test(t) ? new i.PathArray(t).morph(e) : new i.Array(t).morph(e) : i.regex.numberAndUnit.test(e) ? new i.Number(t).morph(e) : (this.value = t, void (this.destination = e));
        },
        extend: {
            at: function(t, e) {
                return e < 1 ? this.value : this.destination;
            },
            valueOf: function() {
                return this.value;
            }
        }
    }), i.extend(i.FX, {
        attr: function(t, e, i) {
            if ("object" === b(t)) for(var a in t)this.attr(a, t[a]);
            else this.add(t, e, "attrs");
            return this;
        },
        plot: function(t, e, i, a) {
            return 4 == arguments.length ? this.plot([
                t,
                e,
                i,
                a
            ]) : this.add("plot", new (this.target()).morphArray(t));
        }
    }), i.Box = i.invent({
        create: function(t, e, a, s) {
            if (!("object" !== b(t) || t instanceof i.Element)) return i.Box.call(this, null != t.left ? t.left : t.x, null != t.top ? t.top : t.y, t.width, t.height);
            var r;
            4 == arguments.length && (this.x = t, this.y = e, this.width = a, this.height = s), null == (r = this).x && (r.x = 0, r.y = 0, r.width = 0, r.height = 0), r.w = r.width, r.h = r.height, r.x2 = r.x + r.width, r.y2 = r.y + r.height, r.cx = r.x + r.width / 2, r.cy = r.y + r.height / 2;
        }
    }), i.BBox = i.invent({
        create: function(t) {
            if (i.Box.apply(this, [].slice.call(arguments)), t instanceof i.Element) {
                var a;
                try {
                    if (!e.documentElement.contains) {
                        for(var s = t.node; s.parentNode;)s = s.parentNode;
                        if (s != e) throw new Error("Element not in the dom");
                    }
                    a = t.node.getBBox();
                } catch (e) {
                    if (t instanceof i.Shape) {
                        i.parser.draw || i.prepare();
                        var r = t.clone(i.parser.draw.instance).show();
                        r && r.node && "function" == typeof r.node.getBBox && (a = r.node.getBBox()), r && "function" == typeof r.remove && r.remove();
                    } else a = {
                        x: t.node.clientLeft,
                        y: t.node.clientTop,
                        width: t.node.clientWidth,
                        height: t.node.clientHeight
                    };
                }
                i.Box.call(this, a);
            }
        },
        inherit: i.Box,
        parent: i.Element,
        construct: {
            bbox: function() {
                return new i.BBox(this);
            }
        }
    }), i.BBox.prototype.constructor = i.BBox, i.Matrix = i.invent({
        create: function(t) {
            var e = f([
                1,
                0,
                0,
                1,
                0,
                0
            ]);
            t = null === t ? e : t instanceof i.Element ? t.matrixify() : "string" == typeof t ? f(t.split(i.regex.delimiter).map(parseFloat)) : 6 == arguments.length ? f([].slice.call(arguments)) : Array.isArray(t) ? f(t) : t && "object" === b(t) ? t : e;
            for(var a = v.length - 1; a >= 0; --a)this[v[a]] = null != t[v[a]] ? t[v[a]] : e[v[a]];
        },
        extend: {
            extract: function() {
                var t = u(this, 0, 1);
                u(this, 1, 0);
                var e = 180 / Math.PI * Math.atan2(t.y, t.x) - 90;
                return {
                    x: this.e,
                    y: this.f,
                    transformedX: (this.e * Math.cos(e * Math.PI / 180) + this.f * Math.sin(e * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                    transformedY: (this.f * Math.cos(e * Math.PI / 180) + this.e * Math.sin(-e * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                    rotation: e,
                    a: this.a,
                    b: this.b,
                    c: this.c,
                    d: this.d,
                    e: this.e,
                    f: this.f,
                    matrix: new i.Matrix(this)
                };
            },
            clone: function() {
                return new i.Matrix(this);
            },
            morph: function(t) {
                return this.destination = new i.Matrix(t), this;
            },
            multiply: function(t) {
                return new i.Matrix(this.native().multiply((function(t) {
                    return t instanceof i.Matrix || (t = new i.Matrix(t)), t;
                })(t).native()));
            },
            inverse: function() {
                return new i.Matrix(this.native().inverse());
            },
            translate: function(t, e) {
                return new i.Matrix(this.native().translate(t || 0, e || 0));
            },
            native: function() {
                for(var t = i.parser.native.createSVGMatrix(), e = v.length - 1; e >= 0; e--)t[v[e]] = this[v[e]];
                return t;
            },
            toString: function() {
                return "matrix(" + x(this.a) + "," + x(this.b) + "," + x(this.c) + "," + x(this.d) + "," + x(this.e) + "," + x(this.f) + ")";
            }
        },
        parent: i.Element,
        construct: {
            ctm: function() {
                return new i.Matrix(this.node.getCTM());
            },
            screenCTM: function() {
                if (this instanceof i.Nested) {
                    var t = this.rect(1, 1), e = t.node.getScreenCTM();
                    return t.remove(), new i.Matrix(e);
                }
                return new i.Matrix(this.node.getScreenCTM());
            }
        }
    }), i.Point = i.invent({
        create: function(t, e) {
            var i;
            i = Array.isArray(t) ? {
                x: t[0],
                y: t[1]
            } : "object" === b(t) ? {
                x: t.x,
                y: t.y
            } : null != t ? {
                x: t,
                y: null != e ? e : t
            } : {
                x: 0,
                y: 0
            }, this.x = i.x, this.y = i.y;
        },
        extend: {
            clone: function() {
                return new i.Point(this);
            },
            morph: function(t, e) {
                return this.destination = new i.Point(t, e), this;
            }
        }
    }), i.extend(i.Element, {
        point: function(t, e) {
            return new i.Point(t, e).transform(this.screenCTM().inverse());
        }
    }), i.extend(i.Element, {
        attr: function(t, e, a) {
            if (null == t) {
                for(t = {}, a = (e = this.node.attributes).length - 1; a >= 0; a--)t[e[a].nodeName] = i.regex.isNumber.test(e[a].nodeValue) ? parseFloat(e[a].nodeValue) : e[a].nodeValue;
                return t;
            }
            if ("object" === b(t)) for(var s in t)this.attr(s, t[s]);
            else if (null === e) this.node.removeAttribute(t);
            else {
                if (null == e) return null == (e = this.node.getAttribute(t)) ? i.defaults.attrs[t] : i.regex.isNumber.test(e) ? parseFloat(e) : e;
                "stroke-width" == t ? this.attr("stroke", parseFloat(e) > 0 ? this._stroke : null) : "stroke" == t && (this._stroke = e), "fill" != t && "stroke" != t || (i.regex.isImage.test(e) && (e = this.doc().defs().image(e, 0, 0)), e instanceof i.Image && (e = this.doc().defs().pattern(0, 0, function() {
                    this.add(e);
                }))), "number" == typeof e ? e = new i.Number(e) : i.Color.isColor(e) ? e = new i.Color(e) : Array.isArray(e) && (e = new i.Array(e)), "leading" == t ? this.leading && this.leading(e) : "string" == typeof a ? this.node.setAttributeNS(a, t, e.toString()) : this.node.setAttribute(t, e.toString()), !this.rebuild || "font-size" != t && "x" != t || this.rebuild(t, e);
            }
            return this;
        }
    }), i.extend(i.Element, {
        transform: function(t, e) {
            var a;
            return "object" !== b(t) ? (a = new i.Matrix(this).extract(), "string" == typeof t ? a[t] : a) : (a = new i.Matrix(this), e = !!e || !!t.relative, null != t.a && (a = e ? a.multiply(new i.Matrix(t)) : new i.Matrix(t)), this.attr("transform", a));
        }
    }), i.extend(i.Element, {
        untransform: function() {
            return this.attr("transform", null);
        },
        matrixify: function() {
            return (this.attr("transform") || "").split(i.regex.transforms).slice(0, -1).map(function(t) {
                var e = t.trim().split("(");
                return [
                    e[0],
                    e[1].split(i.regex.delimiter).map(function(t) {
                        return parseFloat(t);
                    })
                ];
            }).reduce(function(t, e) {
                return "matrix" == e[0] ? t.multiply(f(e[1])) : t[e[0]].apply(t, e[1]);
            }, new i.Matrix);
        },
        toParent: function(t) {
            if (this == t) return this;
            var e = this.screenCTM(), i = t.screenCTM().inverse();
            return this.addTo(t).untransform().transform(i.multiply(e)), this;
        },
        toDoc: function() {
            return this.toParent(this.doc());
        }
    }), i.Transformation = i.invent({
        create: function(t, e) {
            if (arguments.length > 1 && "boolean" != typeof e) return this.constructor.call(this, [].slice.call(arguments));
            if (Array.isArray(t)) for(var i = 0, a = this.arguments.length; i < a; ++i)this[this.arguments[i]] = t[i];
            else if (t && "object" === b(t)) for(i = 0, a = this.arguments.length; i < a; ++i)this[this.arguments[i]] = t[this.arguments[i]];
            this.inversed = !1, !0 === e && (this.inversed = !0);
        }
    }), i.Translate = i.invent({
        parent: i.Matrix,
        inherit: i.Transformation,
        create: function(t, e) {
            this.constructor.apply(this, [].slice.call(arguments));
        },
        extend: {
            arguments: [
                "transformedX",
                "transformedY"
            ],
            method: "translate"
        }
    }), i.extend(i.Element, {
        style: function(t, e) {
            if (0 == arguments.length) return this.node.style.cssText || "";
            if (arguments.length < 2) {
                if ("object" === b(t)) for(var a in t)this.style(a, t[a]);
                else {
                    if (!i.regex.isCss.test(t)) return this.node.style[h(t)];
                    for(t = t.split(/\s*;\s*/).filter(function(t) {
                        return !!t;
                    }).map(function(t) {
                        return t.split(/\s*:\s*/);
                    }); e = t.pop();)this.style(e[0], e[1]);
                }
            } else this.node.style[h(t)] = null === e || i.regex.isBlank.test(e) ? "" : e;
            return this;
        }
    }), i.Parent = i.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: i.Element,
        extend: {
            children: function() {
                return i.utils.map(i.utils.filterSVGElements(this.node.childNodes), function(t) {
                    return i.adopt(t);
                });
            },
            add: function(t, e) {
                return null == e ? this.node.appendChild(t.node) : t.node != this.node.childNodes[e] && this.node.insertBefore(t.node, this.node.childNodes[e]), this;
            },
            put: function(t, e) {
                return this.add(t, e), t;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return [].slice.call(this.node.childNodes).indexOf(t.node);
            },
            get: function(t) {
                return i.adopt(this.node.childNodes[t]);
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.node.childNodes.length - 1);
            },
            each: function(t, e) {
                for(var a = this.children(), s = 0, r = a.length; s < r; s++)a[s] instanceof i.Element && t.apply(a[s], [
                    s,
                    a
                ]), e && a[s] instanceof i.Container && a[s].each(t, e);
                return this;
            },
            removeElement: function(t) {
                return this.node.removeChild(t.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, this;
            },
            defs: function() {
                return this.doc().defs();
            }
        }
    }), i.extend(i.Parent, {
        ungroup: function(t, e) {
            return 0 === e || this instanceof i.Defs || this.node == i.parser.draw || (t = t || (this instanceof i.Doc ? this : this.parent(i.Parent)), e = e || 1 / 0, this.each(function() {
                return this instanceof i.Defs ? this : this instanceof i.Parent ? this.ungroup(t, e - 1) : this.toParent(t);
            }), this.node.firstChild || this.remove()), this;
        },
        flatten: function(t, e) {
            return this.ungroup(t, e);
        }
    }), i.Container = i.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: i.Parent
    }), i.ViewBox = i.invent({
        parent: i.Container,
        construct: {}
    }), [
        "click",
        "dblclick",
        "mousedown",
        "mouseup",
        "mouseover",
        "mouseout",
        "mousemove",
        "touchstart",
        "touchmove",
        "touchleave",
        "touchend",
        "touchcancel"
    ].forEach(function(t) {
        i.Element.prototype[t] = function(e) {
            return i.on(this.node, t, e), this;
        };
    }), i.listeners = [], i.handlerMap = [], i.listenerId = 0, i.on = function(t, e, a, s, r) {
        var o = a.bind(s || t.instance || t), n = (i.handlerMap.indexOf(t) + 1 || i.handlerMap.push(t)) - 1, l = e.split(".")[0], h = e.split(".")[1] || "*";
        i.listeners[n] = i.listeners[n] || {}, i.listeners[n][l] = i.listeners[n][l] || {}, i.listeners[n][l][h] = i.listeners[n][l][h] || {}, a._svgjsListenerId || (a._svgjsListenerId = ++i.listenerId), i.listeners[n][l][h][a._svgjsListenerId] = o, t.addEventListener(l, o, r || {
            passive: !1
        });
    }, i.off = function(t, e, a) {
        var s = i.handlerMap.indexOf(t), r = e && e.split(".")[0], o = e && e.split(".")[1], n = "";
        if (-1 != s) {
            if (a) {
                if ("function" == typeof a && (a = a._svgjsListenerId), !a) return;
                i.listeners[s][r] && i.listeners[s][r][o || "*"] && (t.removeEventListener(r, i.listeners[s][r][o || "*"][a], !1), delete i.listeners[s][r][o || "*"][a]);
            } else if (o && r) {
                if (i.listeners[s][r] && i.listeners[s][r][o]) {
                    for(var l in i.listeners[s][r][o])i.off(t, [
                        r,
                        o
                    ].join("."), l);
                    delete i.listeners[s][r][o];
                }
            } else if (o) for(var h in i.listeners[s])for(var n in i.listeners[s][h])o === n && i.off(t, [
                h,
                o
            ].join("."));
            else if (r) {
                if (i.listeners[s][r]) {
                    for(var n in i.listeners[s][r])i.off(t, [
                        r,
                        n
                    ].join("."));
                    delete i.listeners[s][r];
                }
            } else {
                for(var h in i.listeners[s])i.off(t, h);
                delete i.listeners[s], delete i.handlerMap[s];
            }
        }
    }, i.extend(i.Element, {
        on: function(t, e, a, s) {
            return i.on(this.node, t, e, a, s), this;
        },
        off: function(t, e) {
            return i.off(this.node, t, e), this;
        },
        fire: function(e, a) {
            return e instanceof t.Event ? this.node.dispatchEvent(e) : this.node.dispatchEvent(e = new i.CustomEvent(e, {
                detail: a,
                cancelable: !0
            })), this._event = e, this;
        },
        event: function() {
            return this._event;
        }
    }), i.Defs = i.invent({
        create: "defs",
        inherit: i.Container
    }), i.G = i.invent({
        create: "g",
        inherit: i.Container,
        extend: {
            x: function(t) {
                return null == t ? this.transform("x") : this.transform({
                    x: t - this.x()
                }, !0);
            }
        },
        construct: {
            group: function() {
                return this.put(new i.G);
            }
        }
    }), i.Doc = i.invent({
        create: function(t) {
            t && ("svg" == (t = "string" == typeof t ? e.getElementById(t) : t).nodeName ? this.constructor.call(this, t) : (this.constructor.call(this, i.create("svg")), t.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs());
        },
        inherit: i.Container,
        extend: {
            namespace: function() {
                return this.attr({
                    xmlns: i.ns,
                    version: "1.1"
                }).attr("xmlns:xlink", i.xlink, i.xmlns).attr("xmlns:svgjs", i.svgjs, i.xmlns);
            },
            defs: function() {
                var t;
                return this._defs || ((t = this.node.getElementsByTagName("defs")[0]) ? this._defs = i.adopt(t) : this._defs = new i.Defs, this.node.appendChild(this._defs.node)), this._defs;
            },
            parent: function() {
                return this.node.parentNode && "#document" != this.node.parentNode.nodeName ? this.node.parentNode : null;
            },
            remove: function() {
                return this.parent() && this.parent().removeChild(this.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, i.parser.draw && !i.parser.draw.parentNode && this.node.appendChild(i.parser.draw), this;
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = this.node, i = p(e.cloneNode(!0));
                return t ? (t.node || t).appendChild(i.node) : e.parentNode.insertBefore(i.node, e.nextSibling), i;
            }
        }
    }), i.extend(i.Element, {}), i.Gradient = i.invent({
        create: function(t) {
            this.constructor.call(this, i.create(t + "Gradient")), this.type = t;
        },
        inherit: i.Container,
        extend: {
            at: function(t, e, a) {
                return this.put(new i.Stop).update(t, e, a);
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, a) {
                return "transform" == t && (t = "gradientTransform"), i.Container.prototype.attr.call(this, t, e, a);
            }
        },
        construct: {
            gradient: function(t, e) {
                return this.defs().gradient(t, e);
            }
        }
    }), i.extend(i.Gradient, i.FX, {
        from: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                fx: new i.Number(t),
                fy: new i.Number(e)
            }) : this.attr({
                x1: new i.Number(t),
                y1: new i.Number(e)
            });
        },
        to: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                cx: new i.Number(t),
                cy: new i.Number(e)
            }) : this.attr({
                x2: new i.Number(t),
                y2: new i.Number(e)
            });
        }
    }), i.extend(i.Defs, {
        gradient: function(t, e) {
            return this.put(new i.Gradient(t)).update(e);
        }
    }), i.Stop = i.invent({
        create: "stop",
        inherit: i.Element,
        extend: {
            update: function(t) {
                return ("number" == typeof t || t instanceof i.Number) && (t = {
                    offset: arguments[0],
                    color: arguments[1],
                    opacity: arguments[2]
                }), null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", new i.Number(t.offset)), this;
            }
        }
    }), i.Pattern = i.invent({
        create: "pattern",
        inherit: i.Container,
        extend: {
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, a) {
                return "transform" == t && (t = "patternTransform"), i.Container.prototype.attr.call(this, t, e, a);
            }
        },
        construct: {
            pattern: function(t, e, i) {
                return this.defs().pattern(t, e, i);
            }
        }
    }), i.extend(i.Defs, {
        pattern: function(t, e, a) {
            return this.put(new i.Pattern).update(a).attr({
                x: 0,
                y: 0,
                width: t,
                height: e,
                patternUnits: "userSpaceOnUse"
            });
        }
    }), i.Shape = i.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: i.Element
    }), i.Symbol = i.invent({
        create: "symbol",
        inherit: i.Container,
        construct: {
            symbol: function() {
                return this.put(new i.Symbol);
            }
        }
    }), i.Use = i.invent({
        create: "use",
        inherit: i.Shape,
        extend: {
            element: function(t, e) {
                return this.attr("href", (e || "") + "#" + t, i.xlink);
            }
        },
        construct: {
            use: function(t, e) {
                return this.put(new i.Use).element(t, e);
            }
        }
    }), i.Rect = i.invent({
        create: "rect",
        inherit: i.Shape,
        construct: {
            rect: function(t, e) {
                return this.put(new i.Rect).size(t, e);
            }
        }
    }), i.Circle = i.invent({
        create: "circle",
        inherit: i.Shape,
        construct: {
            circle: function(t) {
                return this.put(new i.Circle).rx(new i.Number(t).divide(2)).move(0, 0);
            }
        }
    }), i.extend(i.Circle, i.FX, {
        rx: function(t) {
            return this.attr("r", t);
        },
        ry: function(t) {
            return this.rx(t);
        }
    }), i.Ellipse = i.invent({
        create: "ellipse",
        inherit: i.Shape,
        construct: {
            ellipse: function(t, e) {
                return this.put(new i.Ellipse).size(t, e).move(0, 0);
            }
        }
    }), i.extend(i.Ellipse, i.Rect, i.FX, {
        rx: function(t) {
            return this.attr("rx", t);
        },
        ry: function(t) {
            return this.attr("ry", t);
        }
    }), i.extend(i.Circle, i.Ellipse, {
        x: function(t) {
            return null == t ? this.cx() - this.rx() : this.cx(t + this.rx());
        },
        y: function(t) {
            return null == t ? this.cy() - this.ry() : this.cy(t + this.ry());
        },
        cx: function(t) {
            return null == t ? this.attr("cx") : this.attr("cx", t);
        },
        cy: function(t) {
            return null == t ? this.attr("cy") : this.attr("cy", t);
        },
        width: function(t) {
            return null == t ? 2 * this.rx() : this.rx(new i.Number(t).divide(2));
        },
        height: function(t) {
            return null == t ? 2 * this.ry() : this.ry(new i.Number(t).divide(2));
        },
        size: function(t, e) {
            var a = g(this, t, e);
            return this.rx(new i.Number(a.width).divide(2)).ry(new i.Number(a.height).divide(2));
        }
    }), i.Line = i.invent({
        create: "line",
        inherit: i.Shape,
        extend: {
            array: function() {
                return new i.PointArray([
                    [
                        this.attr("x1"),
                        this.attr("y1")
                    ],
                    [
                        this.attr("x2"),
                        this.attr("y2")
                    ]
                ]);
            },
            plot: function(t, e, a, s) {
                return null == t ? this.array() : (t = void 0 !== e ? {
                    x1: t,
                    y1: e,
                    x2: a,
                    y2: s
                } : new i.PointArray(t).toLine(), this.attr(t));
            },
            move: function(t, e) {
                return this.attr(this.array().move(t, e).toLine());
            },
            size: function(t, e) {
                var i = g(this, t, e);
                return this.attr(this.array().size(i.width, i.height).toLine());
            }
        },
        construct: {
            line: function(t, e, a, s) {
                return i.Line.prototype.plot.apply(this.put(new i.Line), null != t ? [
                    t,
                    e,
                    a,
                    s
                ] : [
                    0,
                    0,
                    0,
                    0
                ]);
            }
        }
    }), i.Polyline = i.invent({
        create: "polyline",
        inherit: i.Shape,
        construct: {
            polyline: function(t) {
                return this.put(new i.Polyline).plot(t || new i.PointArray);
            }
        }
    }), i.Polygon = i.invent({
        create: "polygon",
        inherit: i.Shape,
        construct: {
            polygon: function(t) {
                return this.put(new i.Polygon).plot(t || new i.PointArray);
            }
        }
    }), i.extend(i.Polyline, i.Polygon, {
        array: function() {
            return this._array || (this._array = new i.PointArray(this.attr("points")));
        },
        plot: function(t) {
            return null == t ? this.array() : this.clear().attr("points", "string" == typeof t ? t : this._array = new i.PointArray(t));
        },
        clear: function() {
            return delete this._array, this;
        },
        move: function(t, e) {
            return this.attr("points", this.array().move(t, e));
        },
        size: function(t, e) {
            var i = g(this, t, e);
            return this.attr("points", this.array().size(i.width, i.height));
        }
    }), i.extend(i.Line, i.Polyline, i.Polygon, {
        morphArray: i.PointArray,
        x: function(t) {
            return null == t ? this.bbox().x : this.move(t, this.bbox().y);
        },
        y: function(t) {
            return null == t ? this.bbox().y : this.move(this.bbox().x, t);
        },
        width: function(t) {
            var e = this.bbox();
            return null == t ? e.width : this.size(t, e.height);
        },
        height: function(t) {
            var e = this.bbox();
            return null == t ? e.height : this.size(e.width, t);
        }
    }), i.Path = i.invent({
        create: "path",
        inherit: i.Shape,
        extend: {
            morphArray: i.PathArray,
            array: function() {
                return this._array || (this._array = new i.PathArray(this.attr("d")));
            },
            plot: function(t) {
                return null == t ? this.array() : this.clear().attr("d", "string" == typeof t ? t : this._array = new i.PathArray(t));
            },
            clear: function() {
                return delete this._array, this;
            }
        },
        construct: {
            path: function(t) {
                return this.put(new i.Path).plot(t || new i.PathArray);
            }
        }
    }), i.Image = i.invent({
        create: "image",
        inherit: i.Shape,
        extend: {
            load: function(e) {
                if (!e) return this;
                var a = this, s = new t.Image;
                return i.on(s, "load", function() {
                    i.off(s);
                    var t = a.parent(i.Pattern);
                    null !== t && (0 == a.width() && 0 == a.height() && a.size(s.width, s.height), t && 0 == t.width() && 0 == t.height() && t.size(a.width(), a.height()), "function" == typeof a._loaded && a._loaded.call(a, {
                        width: s.width,
                        height: s.height,
                        ratio: s.width / s.height,
                        url: e
                    }));
                }), i.on(s, "error", function(t) {
                    i.off(s), "function" == typeof a._error && a._error.call(a, t);
                }), this.attr("href", s.src = this.src = e, i.xlink);
            },
            loaded: function(t) {
                return this._loaded = t, this;
            },
            error: function(t) {
                return this._error = t, this;
            }
        },
        construct: {
            image: function(t, e, a) {
                return this.put(new i.Image).load(t).size(e || 0, a || e || 0);
            }
        }
    }), i.Text = i.invent({
        create: function() {
            this.constructor.call(this, i.create("text")), this.dom.leading = new i.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", i.defaults.attrs["font-family"]);
        },
        inherit: i.Shape,
        extend: {
            x: function(t) {
                return null == t ? this.attr("x") : this.attr("x", t);
            },
            text: function(t) {
                if (void 0 === t) {
                    t = "";
                    for(var e = this.node.childNodes, a = 0, s = e.length; a < s; ++a)0 != a && 3 != e[a].nodeType && 1 == i.adopt(e[a]).dom.newLined && (t += "\n"), t += e[a].textContent;
                    return t;
                }
                if (this.clear().build(!0), "function" == typeof t) t.call(this, this);
                else {
                    a = 0;
                    for(var r = (t = t.split("\n")).length; a < r; a++)this.tspan(t[a]).newLine();
                }
                return this.build(!1).rebuild();
            },
            size: function(t) {
                return this.attr("font-size", t).rebuild();
            },
            leading: function(t) {
                return null == t ? this.dom.leading : (this.dom.leading = new i.Number(t), this.rebuild());
            },
            lines: function() {
                var t = (this.textPath && this.textPath() || this).node, e = i.utils.map(i.utils.filterSVGElements(t.childNodes), function(t) {
                    return i.adopt(t);
                });
                return new i.Set(e);
            },
            rebuild: function(t) {
                if ("boolean" == typeof t && (this._rebuild = t), this._rebuild) {
                    var e = this, a = 0, s = this.dom.leading * new i.Number(this.attr("font-size"));
                    this.lines().each(function() {
                        this.dom.newLined && (e.textPath() || this.attr("x", e.attr("x")), "\n" == this.text() ? a += s : (this.attr("dy", s + a), a = 0));
                    }), this.fire("rebuild");
                }
                return this;
            },
            build: function(t) {
                return this._build = !!t, this;
            },
            setData: function(t) {
                return this.dom = t, this.dom.leading = new i.Number(t.leading || 1.3), this;
            }
        },
        construct: {
            text: function(t) {
                return this.put(new i.Text).text(t);
            },
            plain: function(t) {
                return this.put(new i.Text).plain(t);
            }
        }
    }), i.Tspan = i.invent({
        create: "tspan",
        inherit: i.Shape,
        extend: {
            text: function(t) {
                return null == t ? this.node.textContent + (this.dom.newLined ? "\n" : "") : ("function" == typeof t ? t.call(this, this) : this.plain(t), this);
            },
            dx: function(t) {
                return this.attr("dx", t);
            },
            dy: function(t) {
                return this.attr("dy", t);
            },
            newLine: function() {
                var t = this.parent(i.Text);
                return this.dom.newLined = !0, this.dy(t.dom.leading * t.attr("font-size")).attr("x", t.x());
            }
        }
    }), i.extend(i.Text, i.Tspan, {
        plain: function(t) {
            return !1 === this._build && this.clear(), this.node.appendChild(e.createTextNode(t)), this;
        },
        tspan: function(t) {
            var e = (this.textPath && this.textPath() || this).node, a = new i.Tspan;
            return !1 === this._build && this.clear(), e.appendChild(a.node), a.text(t);
        },
        clear: function() {
            for(var t = (this.textPath && this.textPath() || this).node; t.hasChildNodes();)t.removeChild(t.lastChild);
            return this;
        },
        length: function() {
            return this.node.getComputedTextLength();
        }
    }), i.TextPath = i.invent({
        create: "textPath",
        inherit: i.Parent,
        parent: i.Text,
        construct: {
            morphArray: i.PathArray,
            array: function() {
                var t = this.track();
                return t ? t.array() : null;
            },
            plot: function(t) {
                var e = this.track(), i = null;
                return e && (i = e.plot(t)), null == t ? i : this;
            },
            track: function() {
                var t = this.textPath();
                if (t) return t.reference("href");
            },
            textPath: function() {
                if (this.node.firstChild && "textPath" == this.node.firstChild.nodeName) return i.adopt(this.node.firstChild);
            }
        }
    }), i.Nested = i.invent({
        create: function() {
            this.constructor.call(this, i.create("svg")), this.style("overflow", "visible");
        },
        inherit: i.Container,
        construct: {
            nested: function() {
                return this.put(new i.Nested);
            }
        }
    });
    var n = {
        stroke: [
            "color",
            "width",
            "opacity",
            "linecap",
            "linejoin",
            "miterlimit",
            "dasharray",
            "dashoffset"
        ],
        fill: [
            "color",
            "opacity",
            "rule"
        ],
        prefix: function(t, e) {
            return "color" == e ? t : t + "-" + e;
        }
    };
    function l(t, e, a, s) {
        return a + s.replace(i.regex.dots, " .");
    }
    function h(t) {
        return t.toLowerCase().replace(/-(.)/g, function(t, e) {
            return e.toUpperCase();
        });
    }
    function c(t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
    }
    function d(t) {
        var e = t.toString(16);
        return 1 == e.length ? "0" + e : e;
    }
    function g(t, e, i) {
        if (null == e || null == i) {
            var a = t.bbox();
            null == e ? e = a.width / a.height * i : null == i && (i = a.height / a.width * e);
        }
        return {
            width: e,
            height: i
        };
    }
    function u(t, e, i) {
        return {
            x: e * t.a + i * t.c + 0,
            y: e * t.b + i * t.d + 0
        };
    }
    function f(t) {
        return {
            a: t[0],
            b: t[1],
            c: t[2],
            d: t[3],
            e: t[4],
            f: t[5]
        };
    }
    function p(e) {
        for(var a = e.childNodes.length - 1; a >= 0; a--)e.childNodes[a] instanceof t.SVGElement && p(e.childNodes[a]);
        return i.adopt(e).id(i.eid(e.nodeName));
    }
    function x(t) {
        return Math.abs(t) > 1e-37 ? t : 0;
    }
    [
        "fill",
        "stroke"
    ].forEach(function(t) {
        var e = {};
        e[t] = function(e) {
            if (void 0 === e) return this;
            if ("string" == typeof e || i.Color.isRgb(e) || e && "function" == typeof e.fill) this.attr(t, e);
            else for(var a = n[t].length - 1; a >= 0; a--)null != e[n[t][a]] && this.attr(n.prefix(t, n[t][a]), e[n[t][a]]);
            return this;
        }, i.extend(i.Element, i.FX, e);
    }), i.extend(i.Element, i.FX, {
        translate: function(t, e) {
            return this.transform({
                x: t,
                y: e
            });
        },
        matrix: function(t) {
            return this.attr("transform", new i.Matrix(6 == arguments.length ? [].slice.call(arguments) : t));
        },
        opacity: function(t) {
            return this.attr("opacity", t);
        },
        dx: function(t) {
            return this.x(new i.Number(t).plus(this instanceof i.FX ? 0 : this.x()), !0);
        },
        dy: function(t) {
            return this.y(new i.Number(t).plus(this instanceof i.FX ? 0 : this.y()), !0);
        }
    }), i.extend(i.Path, {
        length: function() {
            return this.node.getTotalLength();
        },
        pointAt: function(t) {
            return this.node.getPointAtLength(t);
        }
    }), i.Set = i.invent({
        create: function(t) {
            Array.isArray(t) ? this.members = t : this.clear();
        },
        extend: {
            add: function() {
                for(var t = [].slice.call(arguments), e = 0, i = t.length; e < i; e++)this.members.push(t[e]);
                return this;
            },
            remove: function(t) {
                var e = this.index(t);
                return e > -1 && this.members.splice(e, 1), this;
            },
            each: function(t) {
                for(var e = 0, i = this.members.length; e < i; e++)t.apply(this.members[e], [
                    e,
                    this.members
                ]);
                return this;
            },
            clear: function() {
                return this.members = [], this;
            },
            length: function() {
                return this.members.length;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return this.members.indexOf(t);
            },
            get: function(t) {
                return this.members[t];
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.members.length - 1);
            },
            valueOf: function() {
                return this.members;
            }
        },
        construct: {
            set: function(t) {
                return new i.Set(t);
            }
        }
    }), i.FX.Set = i.invent({
        create: function(t) {
            this.set = t;
        }
    }), i.Set.inherit = function() {
        var t = [];
        for(var e in i.Shape.prototype)"function" == typeof i.Shape.prototype[e] && "function" != typeof i.Set.prototype[e] && t.push(e);
        for(var e in t.forEach(function(t) {
            i.Set.prototype[t] = function() {
                for(var e = 0, a = this.members.length; e < a; e++)this.members[e] && "function" == typeof this.members[e][t] && this.members[e][t].apply(this.members[e], arguments);
                return "animate" == t ? this.fx || (this.fx = new i.FX.Set(this)) : this;
            };
        }), t = [], i.FX.prototype)"function" == typeof i.FX.prototype[e] && "function" != typeof i.FX.Set.prototype[e] && t.push(e);
        t.forEach(function(t) {
            i.FX.Set.prototype[t] = function() {
                for(var e = 0, i = this.set.members.length; e < i; e++)this.set.members[e].fx[t].apply(this.set.members[e].fx, arguments);
                return this;
            };
        });
    }, i.extend(i.Element, {}), i.extend(i.Element, {
        remember: function(t, e) {
            if ("object" === b(arguments[0])) for(var i in t)this.remember(i, t[i]);
            else {
                if (1 == arguments.length) return this.memory()[t];
                this.memory()[t] = e;
            }
            return this;
        },
        forget: function() {
            if (0 == arguments.length) this._memory = {};
            else for(var t = arguments.length - 1; t >= 0; t--)delete this.memory()[arguments[t]];
            return this;
        },
        memory: function() {
            return this._memory || (this._memory = {});
        }
    }), i.get = function(t) {
        var a = e.getElementById(function(t) {
            var e = (t || "").toString().match(i.regex.reference);
            if (e) return e[1];
        }(t) || t);
        return i.adopt(a);
    }, i.select = function(t, a) {
        return new i.Set(i.utils.map((a || e).querySelectorAll(t), function(t) {
            return i.adopt(t);
        }));
    }, i.extend(i.Parent, {
        select: function(t) {
            return i.select(t, this.node);
        }
    });
    var v = "abcdef".split("");
    if ("function" != typeof t.CustomEvent) {
        var m = function(t, i) {
            i = i || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
            };
            var a = e.createEvent("CustomEvent");
            return a.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), a;
        };
        m.prototype = t.Event.prototype, i.CustomEvent = m;
    } else i.CustomEvent = t.CustomEvent;
    return i;
}, "function" == typeof define && define.amd ? define(function() {
    return Wt(Nt, Nt.document);
}) : "object" === b(exports) && true ? module.exports = Nt.document ? Wt(Nt, Nt.document) : function(t) {
    return Wt(t, t.document);
} : Nt.SVG = Wt(Nt, Nt.document), /*! svg.filter.js - v2.0.2 - 2016-02-24
* https://github.com/wout/svg.filter.js
* Copyright (c) 2016 Wout Fierens; Licensed MIT */ (function() {
    SVG.Filter = SVG.invent({
        create: "filter",
        inherit: SVG.Parent,
        extend: {
            source: "SourceGraphic",
            sourceAlpha: "SourceAlpha",
            background: "BackgroundImage",
            backgroundAlpha: "BackgroundAlpha",
            fill: "FillPaint",
            stroke: "StrokePaint",
            autoSetIn: !0,
            put: function(t, e) {
                return this.add(t, e), !t.attr("in") && this.autoSetIn && t.attr("in", this.source), t.attr("result") || t.attr("result", t), t;
            },
            blend: function(t, e, i) {
                return this.put(new SVG.BlendEffect(t, e, i));
            },
            colorMatrix: function(t, e) {
                return this.put(new SVG.ColorMatrixEffect(t, e));
            },
            convolveMatrix: function(t) {
                return this.put(new SVG.ConvolveMatrixEffect(t));
            },
            componentTransfer: function(t) {
                return this.put(new SVG.ComponentTransferEffect(t));
            },
            composite: function(t, e, i) {
                return this.put(new SVG.CompositeEffect(t, e, i));
            },
            flood: function(t, e) {
                return this.put(new SVG.FloodEffect(t, e));
            },
            offset: function(t, e) {
                return this.put(new SVG.OffsetEffect(t, e));
            },
            image: function(t) {
                return this.put(new SVG.ImageEffect(t));
            },
            merge: function() {
                var t = [
                    void 0
                ];
                for(var e in arguments)t.push(arguments[e]);
                return this.put(new (SVG.MergeEffect.bind.apply(SVG.MergeEffect, t)));
            },
            gaussianBlur: function(t, e) {
                return this.put(new SVG.GaussianBlurEffect(t, e));
            },
            morphology: function(t, e) {
                return this.put(new SVG.MorphologyEffect(t, e));
            },
            diffuseLighting: function(t, e, i) {
                return this.put(new SVG.DiffuseLightingEffect(t, e, i));
            },
            displacementMap: function(t, e, i, a, s) {
                return this.put(new SVG.DisplacementMapEffect(t, e, i, a, s));
            },
            specularLighting: function(t, e, i, a) {
                return this.put(new SVG.SpecularLightingEffect(t, e, i, a));
            },
            tile: function() {
                return this.put(new SVG.TileEffect);
            },
            turbulence: function(t, e, i, a, s) {
                return this.put(new SVG.TurbulenceEffect(t, e, i, a, s));
            },
            toString: function() {
                return "url(#" + this.attr("id") + ")";
            }
        }
    }), SVG.extend(SVG.Defs, {
        filter: function(t) {
            var e = this.put(new SVG.Filter);
            return "function" == typeof t && t.call(e, e), e;
        }
    }), SVG.extend(SVG.Container, {
        filter: function(t) {
            return this.defs().filter(t);
        }
    }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
        filter: function(t) {
            return this.filterer = t instanceof SVG.Element ? t : this.doc().filter(t), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer;
        },
        unfilter: function(t) {
            return this.filterer && !0 === t && this.filterer.remove(), delete this.filterer, this.attr("filter", null);
        }
    }), SVG.Effect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    }), SVG.ParentEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Parent,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    });
    var t = {
        blend: function(t, e) {
            return this.parent() && this.parent().blend(this, t, e);
        },
        colorMatrix: function(t, e) {
            return this.parent() && this.parent().colorMatrix(t, e).in(this);
        },
        convolveMatrix: function(t) {
            return this.parent() && this.parent().convolveMatrix(t).in(this);
        },
        componentTransfer: function(t) {
            return this.parent() && this.parent().componentTransfer(t).in(this);
        },
        composite: function(t, e) {
            return this.parent() && this.parent().composite(this, t, e);
        },
        flood: function(t, e) {
            return this.parent() && this.parent().flood(t, e);
        },
        offset: function(t, e) {
            return this.parent() && this.parent().offset(t, e).in(this);
        },
        image: function(t) {
            return this.parent() && this.parent().image(t);
        },
        merge: function() {
            return this.parent() && this.parent().merge.apply(this.parent(), [
                this
            ].concat(arguments));
        },
        gaussianBlur: function(t, e) {
            return this.parent() && this.parent().gaussianBlur(t, e).in(this);
        },
        morphology: function(t, e) {
            return this.parent() && this.parent().morphology(t, e).in(this);
        },
        diffuseLighting: function(t, e, i) {
            return this.parent() && this.parent().diffuseLighting(t, e, i).in(this);
        },
        displacementMap: function(t, e, i, a) {
            return this.parent() && this.parent().displacementMap(this, t, e, i, a);
        },
        specularLighting: function(t, e, i, a) {
            return this.parent() && this.parent().specularLighting(t, e, i, a).in(this);
        },
        tile: function() {
            return this.parent() && this.parent().tile().in(this);
        },
        turbulence: function(t, e, i, a, s) {
            return this.parent() && this.parent().turbulence(t, e, i, a, s).in(this);
        }
    };
    SVG.extend(SVG.Effect, t), SVG.extend(SVG.ParentEffect, t), SVG.ChildEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                this.attr("in", t);
            }
        }
    });
    var e = {
        blend: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                mode: i || "normal"
            });
        },
        colorMatrix: function(t, e) {
            "matrix" == t && (e = s(e)), this.attr({
                type: t,
                values: void 0 === e ? null : e
            });
        },
        convolveMatrix: function(t) {
            t = s(t), this.attr({
                order: Math.sqrt(t.split(" ").length),
                kernelMatrix: t
            });
        },
        composite: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                operator: i
            });
        },
        flood: function(t, e) {
            this.attr("flood-color", t), null != e && this.attr("flood-opacity", e);
        },
        offset: function(t, e) {
            this.attr({
                dx: t,
                dy: e
            });
        },
        image: function(t) {
            this.attr("href", t, SVG.xlink);
        },
        displacementMap: function(t, e, i, a, s) {
            this.attr({
                in: t,
                in2: e,
                scale: i,
                xChannelSelector: a,
                yChannelSelector: s
            });
        },
        gaussianBlur: function(t, e) {
            null != t || null != e ? this.attr("stdDeviation", function(t) {
                if (!Array.isArray(t)) return t;
                for(var e = 0, i = t.length, a = []; e < i; e++)a.push(t[e]);
                return a.join(" ");
            }(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0");
        },
        morphology: function(t, e) {
            this.attr({
                operator: t,
                radius: e
            });
        },
        tile: function() {},
        turbulence: function(t, e, i, a, s) {
            this.attr({
                numOctaves: e,
                seed: i,
                stitchTiles: a,
                baseFrequency: t,
                type: s
            });
        }
    }, i = {
        merge: function() {
            var t;
            if (arguments[0] instanceof SVG.Set) {
                var e = this;
                arguments[0].each(function(t) {
                    this instanceof SVG.MergeNode ? e.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && e.put(new SVG.MergeNode(this));
                });
            } else {
                t = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                for(var i = 0; i < t.length; i++)t[i] instanceof SVG.MergeNode ? this.put(t[i]) : this.put(new SVG.MergeNode(t[i]));
            }
        },
        componentTransfer: function(t) {
            if (this.rgb = new SVG.Set, [
                "r",
                "g",
                "b",
                "a"
            ].forEach((function(t) {
                this[t] = new SVG["Func" + t.toUpperCase()]("identity"), this.rgb.add(this[t]), this.node.appendChild(this[t].node);
            }).bind(this)), t) for(var e in t.rgb && ([
                "r",
                "g",
                "b"
            ].forEach((function(e) {
                this[e].attr(t.rgb);
            }).bind(this)), delete t.rgb), t)this[e].attr(t[e]);
        },
        diffuseLighting: function(t, e, i) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                kernelUnitLength: i
            });
        },
        specularLighting: function(t, e, i, a) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                specularExponent: i,
                kernelUnitLength: a
            });
        }
    }, a = {
        distantLight: function(t, e) {
            this.attr({
                azimuth: t,
                elevation: e
            });
        },
        pointLight: function(t, e, i) {
            this.attr({
                x: t,
                y: e,
                z: i
            });
        },
        spotLight: function(t, e, i, a, s, r) {
            this.attr({
                x: t,
                y: e,
                z: i,
                pointsAtX: a,
                pointsAtY: s,
                pointsAtZ: r
            });
        },
        mergeNode: function(t) {
            this.attr("in", t);
        }
    };
    function s(t) {
        return Array.isArray(t) && (t = new SVG.Array(t)), t.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
    }
    function r() {
        var t = function() {};
        for(var e in "function" == typeof arguments[arguments.length - 1] && (t = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)for(var i in arguments[e])t(arguments[e][i], i, arguments[e]);
    }
    [
        "r",
        "g",
        "b",
        "a"
    ].forEach(function(t) {
        a["Func" + t.toUpperCase()] = function(t) {
            switch(this.attr("type", t), t){
                case "table":
                    this.attr("tableValues", arguments[1]);
                    break;
                case "linear":
                    this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                    break;
                case "gamma":
                    this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2]);
            }
        };
    }), r(e, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.Effect,
            extend: {}
        });
    }), r(i, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.ParentEffect,
            extend: {}
        });
    }), r(a, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments);
            },
            inherit: SVG.ChildEffect,
            extend: {}
        });
    }), SVG.extend(SVG.MergeEffect, {
        in: function(t) {
            return t instanceof SVG.MergeNode ? this.add(t, 0) : this.add(new SVG.MergeNode(t), 0), this;
        }
    }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
        in2: function(t) {
            return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", t);
        }
    }), SVG.filter = {
        sepiatone: [
            .343,
            .669,
            .119,
            0,
            0,
            .249,
            .626,
            .13,
            0,
            0,
            .172,
            .334,
            .111,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ]
    };
}).call(void 0), function() {
    function t(t, s, r, o, n, l, h) {
        for(var c = t.slice(s, r || h), d = o.slice(n, l || h), g = 0, u = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        }, f = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        };;){
            if (c[g] = e.call(u, c[g]), d[g] = e.call(f, d[g]), c[g][0] != d[g][0] || "M" == c[g][0] || "A" == c[g][0] && (c[g][4] != d[g][4] || c[g][5] != d[g][5]) ? (Array.prototype.splice.apply(c, [
                g,
                1
            ].concat(a.call(u, c[g]))), Array.prototype.splice.apply(d, [
                g,
                1
            ].concat(a.call(f, d[g])))) : (c[g] = i.call(u, c[g]), d[g] = i.call(f, d[g])), ++g == c.length && g == d.length) break;
            g == c.length && c.push([
                "C",
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1]
            ]), g == d.length && d.push([
                "C",
                f.pos[0],
                f.pos[1],
                f.pos[0],
                f.pos[1],
                f.pos[0],
                f.pos[1]
            ]);
        }
        return {
            start: c,
            dest: d
        };
    }
    function e(t) {
        switch(t[0]){
            case "z":
            case "Z":
                t[0] = "L", t[1] = this.start[0], t[2] = this.start[1];
                break;
            case "H":
                t[0] = "L", t[2] = this.pos[1];
                break;
            case "V":
                t[0] = "L", t[2] = t[1], t[1] = this.pos[0];
                break;
            case "T":
                t[0] = "Q", t[3] = t[1], t[4] = t[2], t[1] = this.reflection[1], t[2] = this.reflection[0];
                break;
            case "S":
                t[0] = "C", t[6] = t[4], t[5] = t[3], t[4] = t[2], t[3] = t[1], t[2] = this.reflection[1], t[1] = this.reflection[0];
        }
        return t;
    }
    function i(t) {
        var e = t.length;
        return this.pos = [
            t[e - 2],
            t[e - 1]
        ], -1 != "SCQT".indexOf(t[0]) && (this.reflection = [
            2 * this.pos[0] - t[e - 4],
            2 * this.pos[1] - t[e - 3]
        ]), t;
    }
    function a(t) {
        var e = [
            t
        ];
        switch(t[0]){
            case "M":
                return this.pos = this.start = [
                    t[1],
                    t[2]
                ], e;
            case "L":
                t[5] = t[3] = t[1], t[6] = t[4] = t[2], t[1] = this.pos[0], t[2] = this.pos[1];
                break;
            case "Q":
                t[6] = t[4], t[5] = t[3], t[4] = 1 * t[4] / 3 + 2 * t[2] / 3, t[3] = 1 * t[3] / 3 + 2 * t[1] / 3, t[2] = 1 * this.pos[1] / 3 + 2 * t[2] / 3, t[1] = 1 * this.pos[0] / 3 + 2 * t[1] / 3;
                break;
            case "A":
                e = function(t, e) {
                    var i, a, s, r, o, n, l, h, c, d, g, u, f, p, x, b, v, m, y, w, k, A, S, C, L, P, M = Math.abs(e[1]), I = Math.abs(e[2]), T = e[3] % 360, z = e[4], X = e[5], E = e[6], Y = e[7], R = new SVG.Point(t), F = new SVG.Point(E, Y), D = [];
                    if (0 === M || 0 === I || R.x === F.x && R.y === F.y) return [
                        [
                            "C",
                            R.x,
                            R.y,
                            F.x,
                            F.y,
                            F.x,
                            F.y
                        ]
                    ];
                    i = new SVG.Point((R.x - F.x) / 2, (R.y - F.y) / 2).transform((new SVG.Matrix).rotate(T)), (a = i.x * i.x / (M * M) + i.y * i.y / (I * I)) > 1 && (M *= a = Math.sqrt(a), I *= a);
                    s = (new SVG.Matrix).rotate(T).scale(1 / M, 1 / I).rotate(-T), R = R.transform(s), F = F.transform(s), r = [
                        F.x - R.x,
                        F.y - R.y
                    ], n = r[0] * r[0] + r[1] * r[1], o = Math.sqrt(n), r[0] /= o, r[1] /= o, l = n < 4 ? Math.sqrt(1 - n / 4) : 0, z === X && (l *= -1);
                    h = new SVG.Point((F.x + R.x) / 2 + l * -r[1], (F.y + R.y) / 2 + l * r[0]), c = new SVG.Point(R.x - h.x, R.y - h.y), d = new SVG.Point(F.x - h.x, F.y - h.y), g = Math.acos(c.x / Math.sqrt(c.x * c.x + c.y * c.y)), c.y < 0 && (g *= -1);
                    u = Math.acos(d.x / Math.sqrt(d.x * d.x + d.y * d.y)), d.y < 0 && (u *= -1);
                    X && g > u && (u += 2 * Math.PI);
                    !X && g < u && (u -= 2 * Math.PI);
                    for(p = Math.ceil(2 * Math.abs(g - u) / Math.PI), b = [], v = g, f = (u - g) / p, x = 4 * Math.tan(f / 4) / 3, k = 0; k <= p; k++)y = Math.cos(v), m = Math.sin(v), w = new SVG.Point(h.x + y, h.y + m), b[k] = [
                        new SVG.Point(w.x + x * m, w.y - x * y),
                        w,
                        new SVG.Point(w.x - x * m, w.y + x * y)
                    ], v += f;
                    for(b[0][0] = b[0][1].clone(), b[b.length - 1][2] = b[b.length - 1][1].clone(), s = (new SVG.Matrix).rotate(T).scale(M, I).rotate(-T), k = 0, A = b.length; k < A; k++)b[k][0] = b[k][0].transform(s), b[k][1] = b[k][1].transform(s), b[k][2] = b[k][2].transform(s);
                    for(k = 1, A = b.length; k < A; k++)S = (w = b[k - 1][2]).x, C = w.y, L = (w = b[k][0]).x, P = w.y, E = (w = b[k][1]).x, Y = w.y, D.push([
                        "C",
                        S,
                        C,
                        L,
                        P,
                        E,
                        Y
                    ]);
                    return D;
                }(this.pos, t), t = e[0];
        }
        return t[0] = "C", this.pos = [
            t[5],
            t[6]
        ], this.reflection = [
            2 * t[5] - t[3],
            2 * t[6] - t[4]
        ], e;
    }
    function s(t, e) {
        if (!1 === e) return !1;
        for(var i = e, a = t.length; i < a; ++i)if ("M" == t[i][0]) return i;
        return !1;
    }
    SVG.extend(SVG.PathArray, {
        morph: function(e) {
            for(var i = this.value, a = this.parse(e), r = 0, o = 0, n = !1, l = !1; !1 !== r || !1 !== o;){
                var h;
                n = s(i, !1 !== r && r + 1), l = s(a, !1 !== o && o + 1), !1 === r && (r = 0 == (h = new SVG.PathArray(c.start).bbox()).height || 0 == h.width ? i.push(i[0]) - 1 : i.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1), !1 === o && (o = 0 == (h = new SVG.PathArray(c.dest).bbox()).height || 0 == h.width ? a.push(a[0]) - 1 : a.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1);
                var c = t(i, r, n, a, o, l);
                i = i.slice(0, r).concat(c.start, !1 === n ? [] : i.slice(n)), a = a.slice(0, o).concat(c.dest, !1 === l ? [] : a.slice(l)), r = !1 !== n && r + c.start.length, o = !1 !== l && o + c.dest.length;
            }
            return this.value = i, this.destination = new SVG.PathArray, this.destination.value = a, this;
        }
    });
}(), /*! svg.draggable.js - v2.2.2 - 2019-01-08
* https://github.com/svgdotjs/svg.draggable.js
* Copyright (c) 2019 Wout Fierens; Licensed MIT */ (function() {
    function t(t) {
        t.remember("_draggable", this), this.el = t;
    }
    t.prototype.init = function(t, e) {
        var i = this;
        this.constraint = t, this.value = e, this.el.on("mousedown.drag", function(t) {
            i.start(t);
        }), this.el.on("touchstart.drag", function(t) {
            i.start(t);
        });
    }, t.prototype.transformPoint = function(t, e) {
        var i = (t = t || window.event).changedTouches && t.changedTouches[0] || t;
        return this.p.x = i.clientX - (e || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m);
    }, t.prototype.getBBox = function() {
        var t = this.el.bbox();
        return this.el instanceof SVG.Nested && (t = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (t.x = this.el.x(), t.y = this.el.y()), t;
    }, t.prototype.start = function(t) {
        if ("click" != t.type && "mousedown" != t.type && "mousemove" != t.type || 1 == (t.which || t.buttons)) {
            var e = this;
            if (this.el.fire("beforedrag", {
                event: t,
                handler: this
            }), !this.el.event().defaultPrevented) {
                t.preventDefault(), t.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                var i, a = this.getBBox();
                if (this.el instanceof SVG.Text) switch(i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")){
                    case "middle":
                        i /= 2;
                        break;
                    case "start":
                        i = 0;
                }
                this.startPoints = {
                    point: this.transformPoint(t, i),
                    box: a,
                    transform: this.el.transform()
                }, SVG.on(window, "mousemove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "touchmove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "mouseup.drag", function(t) {
                    e.end(t);
                }), SVG.on(window, "touchend.drag", function(t) {
                    e.end(t);
                }), this.el.fire("dragstart", {
                    event: t,
                    p: this.startPoints.point,
                    m: this.m,
                    handler: this
                });
            }
        }
    }, t.prototype.drag = function(t) {
        var e = this.getBBox(), i = this.transformPoint(t), a = this.startPoints.box.x + i.x - this.startPoints.point.x, s = this.startPoints.box.y + i.y - this.startPoints.point.y, r = this.constraint, o = i.x - this.startPoints.point.x, n = i.y - this.startPoints.point.y;
        if (this.el.fire("dragmove", {
            event: t,
            p: i,
            m: this.m,
            handler: this
        }), this.el.event().defaultPrevented) return i;
        if ("function" == typeof r) {
            var l = r.call(this.el, a, s, this.m);
            "boolean" == typeof l && (l = {
                x: l,
                y: l
            }), !0 === l.x ? this.el.x(a) : !1 !== l.x && this.el.x(l.x), !0 === l.y ? this.el.y(s) : !1 !== l.y && this.el.y(l.y);
        } else "object" == typeof r && (null != r.minX && a < r.minX ? o = (a = r.minX) - this.startPoints.box.x : null != r.maxX && a > r.maxX - e.width && (o = (a = r.maxX - e.width) - this.startPoints.box.x), null != r.minY && s < r.minY ? n = (s = r.minY) - this.startPoints.box.y : null != r.maxY && s > r.maxY - e.height && (n = (s = r.maxY - e.height) - this.startPoints.box.y), null != r.snapToGrid && (a -= a % r.snapToGrid, s -= s % r.snapToGrid, o -= o % r.snapToGrid, n -= n % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
            x: o,
            y: n
        }, !0) : this.el.move(a, s));
        return i;
    }, t.prototype.end = function(t) {
        var e = this.drag(t);
        this.el.fire("dragend", {
            event: t,
            p: e,
            m: this.m,
            handler: this
        }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag");
    }, SVG.extend(SVG.Element, {
        draggable: function(e, i) {
            "function" != typeof e && "object" != typeof e || (i = e, e = !0);
            var a = this.remember("_draggable") || new t(this);
            return (e = void 0 === e || e) ? a.init(i || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this;
        }
    });
}).call(void 0), function() {
    function t(t) {
        this.el = t, t.remember("_selectHandler", this), this.pointSelection = {
            isSelected: !1
        }, this.rectSelection = {
            isSelected: !1
        }, this.pointsList = {
            lt: [
                0,
                0
            ],
            rt: [
                "width",
                0
            ],
            rb: [
                "width",
                "height"
            ],
            lb: [
                0,
                "height"
            ],
            t: [
                "width",
                0
            ],
            r: [
                "width",
                "height"
            ],
            b: [
                "width",
                "height"
            ],
            l: [
                0,
                "height"
            ]
        }, this.pointCoord = function(t, e, i) {
            var a = "string" != typeof t ? t : e[t];
            return i ? a / 2 : a;
        }, this.pointCoords = function(t, e) {
            var i = this.pointsList[t];
            return {
                x: this.pointCoord(i[0], e, "t" === t || "b" === t),
                y: this.pointCoord(i[1], e, "r" === t || "l" === t)
            };
        };
    }
    t.prototype.init = function(t, e) {
        var i = this.el.bbox();
        this.options = {};
        var a = this.el.selectize.defaults.points;
        for(var s in this.el.selectize.defaults)this.options[s] = this.el.selectize.defaults[s], void 0 !== e[s] && (this.options[s] = e[s]);
        var r = [
            "points",
            "pointsExclude"
        ];
        for(var s in r){
            var o = this.options[r[s]];
            "string" == typeof o ? o = o.length > 0 ? o.split(/\s*,\s*/i) : [] : "boolean" == typeof o && "points" === r[s] && (o = o ? a : []), this.options[r[s]] = o;
        }
        this.options.points = [
            a,
            this.options.points
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) > -1;
            });
        }), this.options.points = [
            this.options.points,
            this.options.pointsExclude
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) < 0;
            });
        }), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && -1 !== [
            "line",
            "polyline",
            "polygon"
        ].indexOf(this.el.type) ? this.selectPoints(t) : this.selectRect(t), this.observe(), this.cleanup();
    }, t.prototype.selectPoints = function(t) {
        return this.pointSelection.isSelected = t, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this;
    }, t.prototype.getPointArray = function() {
        var t = this.el.bbox();
        return this.el.array().valueOf().map(function(e) {
            return [
                e[0] - t.x,
                e[1] - t.y
            ];
        });
    }, t.prototype.drawPoints = function() {
        for(var t = this, e = this.getPointArray(), i = 0, a = e.length; i < a; ++i){
            var s = function(e) {
                return function(i) {
                    (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                    var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                    t.el.fire("point", {
                        x: a,
                        y: s,
                        i: e,
                        event: i
                    });
                };
            }(i), r = this.drawPoint(e[i][0], e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", s).on("mousedown", s);
            this.pointSelection.set.add(r);
        }
    }, t.prototype.drawPoint = function(t, e) {
        var i = this.options.pointType;
        switch(i){
            case "circle":
                return this.drawCircle(t, e);
            case "rect":
                return this.drawRect(t, e);
            default:
                if ("function" == typeof i) return i.call(this, t, e);
                throw new Error("Unknown " + i + " point type!");
        }
    }, t.prototype.drawCircle = function(t, e) {
        return this.nested.circle(this.options.pointSize).center(t, e);
    }, t.prototype.drawRect = function(t, e) {
        return this.nested.rect(this.options.pointSize, this.options.pointSize).center(t, e);
    }, t.prototype.updatePointSelection = function() {
        var t = this.getPointArray();
        this.pointSelection.set.each(function(e) {
            this.cx() === t[e][0] && this.cy() === t[e][1] || this.center(t[e][0], t[e][1]);
        });
    }, t.prototype.updateRectSelection = function() {
        var t = this, e = this.el.bbox();
        if (this.rectSelection.set.get(0).attr({
            width: e.width,
            height: e.height
        }), this.options.points.length && this.options.points.map(function(i, a) {
            var s = t.pointCoords(i, e);
            t.rectSelection.set.get(a + 1).center(s.x, s.y);
        }), this.options.rotationPoint) {
            var i = this.rectSelection.set.length();
            this.rectSelection.set.get(i - 1).center(e.width / 2, 20);
        }
    }, t.prototype.selectRect = function(t) {
        var e = this, i = this.el.bbox();
        function a(t) {
            return function(i) {
                (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                e.el.fire(t, {
                    x: a,
                    y: s,
                    event: i
                });
            };
        }
        if (this.rectSelection.isSelected = t, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2) this.options.points.map(function(t, s) {
            var r = e.pointCoords(t, i), o = e.drawPoint(r.x, r.y).attr("class", e.options.classPoints + "_" + t).on("mousedown", a(t)).on("touchstart", a(t));
            e.rectSelection.set.add(o);
        }), this.rectSelection.set.each(function() {
            this.addClass(e.options.classPoints);
        });
        if (this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
            var s = function(t) {
                (t = t || window.event).preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation();
                var i = t.pageX || t.touches[0].pageX, a = t.pageY || t.touches[0].pageY;
                e.el.fire("rot", {
                    x: i,
                    y: a,
                    event: t
                });
            }, r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", s).on("mousedown", s);
            this.rectSelection.set.add(r);
        }
    }, t.prototype.handler = function() {
        var t = this.el.bbox();
        this.nested.matrix(new SVG.Matrix(this.el).translate(t.x, t.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection();
    }, t.prototype.observe = function() {
        var t = this;
        if (MutationObserver) {
            if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver(function() {
                t.handler();
            }), this.observerInst.observe(this.el.node, {
                attributes: !0
            });
            else try {
                this.observerInst.disconnect(), delete this.observerInst;
            } catch (t) {}
        } else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", function() {
            t.handler();
        });
    }, t.prototype.cleanup = function() {
        !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each(function() {
            this.remove();
        }), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each(function() {
            this.remove();
        }), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested);
    }, SVG.extend(SVG.Element, {
        selectize: function(e, i) {
            return "object" == typeof e && (i = e, e = !0), (this.remember("_selectHandler") || new t(this)).init(void 0 === e || e, i || {}), this;
        }
    }), SVG.Element.prototype.selectize.defaults = {
        points: [
            "lt",
            "rt",
            "rb",
            "lb",
            "t",
            "r",
            "b",
            "l"
        ],
        pointsExclude: [],
        classRect: "svg_select_boundingRect",
        classPoints: "svg_select_points",
        pointSize: 7,
        rotationPoint: !0,
        deepSelect: !1,
        pointType: "circle"
    };
}(), function() {
    (function() {
        function t(t) {
            t.remember("_resizeHandler", this), this.el = t, this.parameters = {}, this.lastUpdateCall = null, this.p = t.doc().node.createSVGPoint();
        }
        t.prototype.transformPoint = function(t, e, i) {
            return this.p.x = t - (this.offset.x - window.pageXOffset), this.p.y = e - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m);
        }, t.prototype._extractPosition = function(t) {
            return {
                x: null != t.clientX ? t.clientX : t.touches[0].clientX,
                y: null != t.clientY ? t.clientY : t.touches[0].clientY
            };
        }, t.prototype.init = function(t) {
            var e = this;
            if (this.stop(), "stop" !== t) {
                for(var i in this.options = {}, this.el.resize.defaults)this.options[i] = this.el.resize.defaults[i], void 0 !== t[i] && (this.options[i] = t[i]);
                this.el.on("lt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("lb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("t.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("r.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("b.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("l.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rot.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("point.resize", function(t) {
                    e.resize(t || window.event);
                }), this.update();
            }
        }, t.prototype.stop = function() {
            return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this;
        }, t.prototype.resize = function(t) {
            var e = this;
            this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                x: window.pageXOffset,
                y: window.pageYOffset
            };
            var i = this._extractPosition(t.detail.event);
            if (this.parameters = {
                type: this.el.type,
                p: this.transformPoint(i.x, i.y),
                x: t.detail.x,
                y: t.detail.y,
                box: this.el.bbox(),
                rotation: this.el.transform().rotation
            }, "text" === this.el.type && (this.parameters.fontSize = this.el.attr()["font-size"]), void 0 !== t.detail.i) {
                var a = this.el.array().valueOf();
                this.parameters.i = t.detail.i, this.parameters.pointCoords = [
                    a[t.detail.i][0],
                    a[t.detail.i][1]
                ];
            }
            switch(t.type){
                case "lt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y + i[1]).size(this.parameters.box.width - i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).size(this.parameters.box.width + i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "lb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).size(this.parameters.box.width - i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "t":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).height(this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "r":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + i[0]);
                        }
                    };
                    break;
                case "b":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "l":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).width(this.parameters.box.width - i[0]);
                        }
                    };
                    break;
                case "rot":
                    this.calc = function(t, e) {
                        var i = t + this.parameters.p.x, a = e + this.parameters.p.y, s = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2), r = Math.atan2(a - this.parameters.box.y - this.parameters.box.height / 2, i - this.parameters.box.x - this.parameters.box.width / 2), o = this.parameters.rotation + 180 * (r - s) / Math.PI + this.options.snapToAngle / 2;
                        this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(o - o % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy);
                    };
                    break;
                case "point":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, this.parameters.pointCoords[0], this.parameters.pointCoords[1]), a = this.el.array().valueOf();
                        a[this.parameters.i][0] = this.parameters.pointCoords[0] + i[0], a[this.parameters.i][1] = this.parameters.pointCoords[1] + i[1], this.el.plot(a);
                    };
            }
            this.el.fire("resizestart", {
                dx: this.parameters.x,
                dy: this.parameters.y,
                event: t
            }), SVG.on(window, "touchmove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "touchend.resize", function() {
                e.done();
            }), SVG.on(window, "mousemove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "mouseup.resize", function() {
                e.done();
            });
        }, t.prototype.update = function(t) {
            if (t) {
                var e = this._extractPosition(t), i = this.transformPoint(e.x, e.y), a = i.x - this.parameters.p.x, s = i.y - this.parameters.p.y;
                this.lastUpdateCall = [
                    a,
                    s
                ], this.calc(a, s), this.el.fire("resizing", {
                    dx: a,
                    dy: s,
                    event: t
                });
            } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1]);
        }, t.prototype.done = function() {
            this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone");
        }, t.prototype.snapToGrid = function(t, e, i, a) {
            var s;
            return void 0 !== a ? s = [
                (i + t) % this.options.snapToGrid,
                (a + e) % this.options.snapToGrid
            ] : (i = null == i ? 3 : i, s = [
                (this.parameters.box.x + t + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid,
                (this.parameters.box.y + e + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid
            ]), t < 0 && (s[0] -= this.options.snapToGrid), e < 0 && (s[1] -= this.options.snapToGrid), t -= Math.abs(s[0]) < this.options.snapToGrid / 2 ? s[0] : s[0] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), e -= Math.abs(s[1]) < this.options.snapToGrid / 2 ? s[1] : s[1] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(t, e, i, a);
        }, t.prototype.constraintToBox = function(t, e, i, a) {
            var s, r, o = this.options.constraint || {};
            return void 0 !== a ? (s = i, r = a) : (s = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), void 0 !== o.minX && s + t < o.minX && (t = o.minX - s), void 0 !== o.maxX && s + t > o.maxX && (t = o.maxX - s), void 0 !== o.minY && r + e < o.minY && (e = o.minY - r), void 0 !== o.maxY && r + e > o.maxY && (e = o.maxY - r), [
                t,
                e
            ];
        }, t.prototype.checkAspectRatio = function(t, e) {
            if (!this.options.saveAspectRatio) return t;
            var i = t.slice(), a = this.parameters.box.width / this.parameters.box.height, s = this.parameters.box.width + t[0], r = this.parameters.box.height - t[1], o = s / r;
            return o < a ? (i[1] = s / a - this.parameters.box.height, e && (i[1] = -i[1])) : o > a && (i[0] = this.parameters.box.width - r * a, e && (i[0] = -i[0])), i;
        }, SVG.extend(SVG.Element, {
            resize: function(e) {
                return (this.remember("_resizeHandler") || new t(this)).init(e || {}), this;
            }
        }), SVG.Element.prototype.resize.defaults = {
            snapToAngle: .1,
            snapToGrid: 1,
            constraint: {},
            saveAspectRatio: !1
        };
    }).call(this);
}(), void 0 === window.Apex && (window.Apex = {});
var qt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "initModules",
            value: function() {
                this.ctx.publicMethods = [
                    "updateOptions",
                    "updateSeries",
                    "appendData",
                    "appendSeries",
                    "isSeriesHidden",
                    "highlightSeries",
                    "toggleSeries",
                    "showSeries",
                    "hideSeries",
                    "setLocale",
                    "resetSeries",
                    "zoomX",
                    "toggleDataPointSelection",
                    "dataURI",
                    "exportToCSV",
                    "addXaxisAnnotation",
                    "addYaxisAnnotation",
                    "addPointAnnotation",
                    "clearAnnotations",
                    "removeAnnotation",
                    "paper",
                    "destroy"
                ], this.ctx.eventList = [
                    "click",
                    "mousedown",
                    "mousemove",
                    "mouseleave",
                    "touchstart",
                    "touchmove",
                    "touchleave",
                    "mouseup",
                    "touchend"
                ], this.ctx.animations = new y(this.ctx), this.ctx.axes = new et(this.ctx), this.ctx.core = new _t(this.ctx.el, this.ctx), this.ctx.config = new D({}), this.ctx.data = new _(this.ctx), this.ctx.grid = new Z(this.ctx), this.ctx.graphics = new k(this.ctx), this.ctx.coreUtils = new A(this.ctx), this.ctx.crosshairs = new it(this.ctx), this.ctx.events = new K(this.ctx), this.ctx.exports = new U(this.ctx), this.ctx.fill = new N(this.ctx), this.ctx.localization = new tt(this.ctx), this.ctx.options = new X, this.ctx.responsive = new at(this.ctx), this.ctx.series = new V(this.ctx), this.ctx.theme = new st(this.ctx), this.ctx.formatters = new P(this.ctx), this.ctx.titleSubtitle = new rt(this.ctx), this.ctx.legend = new gt(this.ctx), this.ctx.toolbar = new ut(this.ctx), this.ctx.tooltip = new wt(this.ctx), this.ctx.dimensions = new ct(this.ctx), this.ctx.updateHelpers = new Ut(this.ctx), this.ctx.zoomPanSelection = new ft(this.ctx), this.ctx.w.globals.tooltip = new wt(this.ctx);
            }
        }
    ]), t;
}(), Zt = function() {
    function t(e) {
        i(this, t), this.ctx = e, this.w = e.w;
    }
    return s(t, [
        {
            key: "clear",
            value: function(t) {
                var e = t.isUpdating;
                this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                    isUpdating: e
                });
            }
        },
        {
            key: "killSVG",
            value: function(t) {
                t.each(function() {
                    this.removeClass("*"), this.off(), this.stop();
                }, !0), t.ungroup(), t.clear();
            }
        },
        {
            key: "clearDomElements",
            value: function(t) {
                var e = this, i = t.isUpdating, a = this.w.globals.dom.Paper.node;
                a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                var s = this.w.globals.dom.baseEl;
                s && this.ctx.eventList.forEach(function(t) {
                    s.removeEventListener(t, e.ctx.events.documentEvent);
                });
                var r = this.w.globals.dom;
                if (null !== this.ctx.el) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elLegendWrap = null, r.elLegendForeign = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectBarMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
            }
        }
    ]), t;
}(), $t = new WeakMap;
var Jt = function() {
    function t(e, a) {
        i(this, t), this.opts = a, this.ctx = this, this.w = new O(a).init(), this.el = e, this.w.globals.cuid = m.randomId(), this.w.globals.chartID = this.w.config.chart.id ? m.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new qt(this).initModules(), this.create = m.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
    }
    return s(t, [
        {
            key: "render",
            value: function() {
                var t = this;
                return new Promise(function(e, i) {
                    if (null !== t.el) {
                        void 0 === Apex._chartInstances && (Apex._chartInstances = []), t.w.config.chart.id && Apex._chartInstances.push({
                            id: t.w.globals.chartID,
                            group: t.w.config.chart.group,
                            chart: t
                        }), t.setLocale(t.w.config.chart.defaultLocale);
                        var a = t.w.config.chart.events.beforeMount;
                        "function" == typeof a && a(t, t.w), t.events.fireEvent("beforeMount", [
                            t,
                            t.w
                        ]), window.addEventListener("resize", t.windowResizeHandler), function(t, e) {
                            var i = !1;
                            if (t.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
                                var a = t.getBoundingClientRect();
                                "none" !== t.style.display && 0 !== a.width || (i = !0);
                            }
                            var s = new ResizeObserver(function(a) {
                                i && e.call(t, a), i = !0;
                            });
                            t.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(t.children).forEach(function(t) {
                                return s.observe(t);
                            }) : s.observe(t), $t.set(e, s);
                        }(t.el.parentNode, t.parentResizeHandler);
                        var s = t.el.getRootNode && t.el.getRootNode(), r = m.is("ShadowRoot", s), o = t.el.ownerDocument, n = r ? s.getElementById("apexcharts-css") : o.getElementById("apexcharts-css");
                        if (!n) {
                            var l;
                            (n = document.createElement("style")).id = "apexcharts-css", n.textContent = '@keyframes opaque {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n@keyframes resizeanim {\n\n  0%,\n  to {\n    opacity: 0\n  }\n}\n\n.apexcharts-canvas {\n  position: relative;\n  direction: ltr !important;\n  user-select: none\n}\n\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5)\n}\n\n.apexcharts-inner {\n  position: relative\n}\n\n.apexcharts-text tspan {\n  font-family: inherit\n}\n\nrect.legend-mouseover-inactive,\n.legend-mouseover-inactive rect,\n.legend-mouseover-inactive path,\n.legend-mouseover-inactive circle,\n.legend-mouseover-inactive line,\n.legend-mouseover-inactive text.apexcharts-yaxis-title-text,\n.legend-mouseover-inactive text.apexcharts-yaxis-label {\n  transition: .15s ease all;\n  opacity: .2\n}\n\n.apexcharts-legend-text {\n  padding-left: 15px;\n  margin-left: -15px;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255, 255, 255, .96)\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30, 30, 30, .8)\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit\n}\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #eceff1;\n  border-bottom: 1px solid #ddd\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0, 0, 0, .7);\n  border-bottom: 1px solid #333\n}\n\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  margin-left: 5px;\n  font-weight: 600\n}\n\n.apexcharts-tooltip-text-goals-label:empty,\n.apexcharts-tooltip-text-goals-value:empty,\n.apexcharts-tooltip-text-y-label:empty,\n.apexcharts-tooltip-text-y-value:empty,\n.apexcharts-tooltip-text-z-value:empty,\n.apexcharts-tooltip-title:empty {\n  display: none\n}\n\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px\n}\n\n.apexcharts-tooltip-goals-group,\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n  display: flex\n}\n\n.apexcharts-tooltip-text-goals-label:not(:empty),\n.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0;\n  margin-right: 10px;\n  border-radius: 50%\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,\n.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px\n}\n\n.apexcharts-custom-tooltip,\n.apexcharts-tooltip-box {\n  padding: 4px 8px\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: 700\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 5px\n}\n\n.apexcharts-xaxistooltip,\n.apexcharts-yaxistooltip {\n  opacity: 0;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #eceff1;\n  border: 1px solid #90a4ae\n}\n\n.apexcharts-xaxistooltip {\n  padding: 9px 10px;\n  transition: .15s ease all\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, .7);\n  border: 1px solid rgba(0, 0, 0, .5);\n  color: #fff\n}\n\n.apexcharts-xaxistooltip:after,\n.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-left: -6px\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-left: -7px\n}\n\n.apexcharts-xaxistooltip-bottom:after,\n.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%\n}\n\n.apexcharts-xaxistooltip-top:after,\n.apexcharts-xaxistooltip-top:before {\n  top: 100%\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-yaxistooltip {\n  padding: 4px 10px\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, .7);\n  border: 1px solid rgba(0, 0, 0, .5);\n  color: #fff\n}\n\n.apexcharts-yaxistooltip:after,\n.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-top: -6px\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-top: -7px\n}\n\n.apexcharts-yaxistooltip-left:after,\n.apexcharts-yaxistooltip-left:before {\n  left: 100%\n}\n\n.apexcharts-yaxistooltip-right:after,\n.apexcharts-yaxistooltip-right:before {\n  right: 100%\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none\n}\n\n.apexcharts-xcrosshairs,\n.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: .15s ease all\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,\n.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0\n}\n\n.apexcharts-selection-rect {\n  cursor: move\n}\n\n.svg_select_boundingRect,\n.svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_boundingRect,\n.apexcharts-selection-rect+g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden\n}\n\n.apexcharts-selection-rect+g .svg_select_points_l,\n.apexcharts-selection-rect+g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-menu-icon,\n.apexcharts-pan-icon,\n.apexcharts-reset-icon,\n.apexcharts-selection-icon,\n.apexcharts-toolbar-custom-icon,\n.apexcharts-zoom-icon,\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6e8192;\n  text-align: center\n}\n\n.apexcharts-menu-icon svg,\n.apexcharts-reset-icon svg,\n.apexcharts-zoom-icon svg,\n.apexcharts-zoomin-icon svg,\n.apexcharts-zoomout-icon svg {\n  fill: #6e8192\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(.76)\n}\n\n.apexcharts-theme-dark .apexcharts-menu-icon svg,\n.apexcharts-theme-dark .apexcharts-pan-icon svg,\n.apexcharts-theme-dark .apexcharts-reset-icon svg,\n.apexcharts-theme-dark .apexcharts-selection-icon svg,\n.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomin-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomout-icon svg {\n  fill: #f3f4f5\n}\n\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {\n  fill: #008ffb\n}\n\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg,\n.apexcharts-theme-light .apexcharts-reset-icon:hover svg,\n.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,\n.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {\n  fill: #333\n}\n\n.apexcharts-menu-icon,\n.apexcharts-selection-icon {\n  position: relative\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px\n}\n\n.apexcharts-menu-icon,\n.apexcharts-reset-icon,\n.apexcharts-zoom-icon {\n  transform: scale(.85)\n}\n\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  transform: scale(.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px\n}\n\n.apexcharts-pan-icon {\n  transform: scale(.62);\n  position: relative;\n  left: 1px;\n  top: 0\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6e8192;\n  stroke-width: 2\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008ffb\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0 6px 2px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: .15s ease all;\n  pointer-events: none\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: .15s ease all\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0, 0, 0, .7);\n  color: #fff\n}\n\n@media screen and (min-width:768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n    opacity: 1\n  }\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,\n.apexcharts-datalabel.apexcharts-element-hidden,\n.apexcharts-hide .apexcharts-series-points {\n  opacity: 0;\n}\n\n.apexcharts-hidden-element-shown {\n  opacity: 1;\n  transition: 0.25s ease all;\n}\n\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value,\n.apexcharts-datalabels,\n.apexcharts-pie-label {\n  cursor: default;\n  pointer-events: none\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: .3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease\n}\n\n.apexcharts-radialbar-label {\n  cursor: pointer;\n}\n\n.apexcharts-annotation-rect,\n.apexcharts-area-series .apexcharts-area,\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-gridline,\n.apexcharts-line,\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-point-annotation-label,\n.apexcharts-radar-series path:not(.apexcharts-marker),\n.apexcharts-radar-series polygon,\n.apexcharts-toolbar svg,\n.apexcharts-tooltip .apexcharts-marker,\n.apexcharts-xaxis-annotation-label,\n.apexcharts-yaxis-annotation-label,\n.apexcharts-zoom-rect {\n  pointer-events: none\n}\n\n.apexcharts-tooltip-active .apexcharts-marker {\n  transition: .15s ease all\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden\n}\n\n.contract-trigger:before,\n.resize-triggers,\n.resize-triggers>div {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0\n}\n\n.resize-triggers>div {\n  height: 100%;\n  width: 100%;\n  background: #eee;\n  overflow: auto\n}\n\n.contract-trigger:before {\n  overflow: hidden;\n  width: 200%;\n  height: 200%\n}\n\n.apexcharts-bar-goals-markers {\n  pointer-events: none\n}\n\n.apexcharts-bar-shadows {\n  pointer-events: none\n}\n\n.apexcharts-rangebar-goals-markers {\n  pointer-events: none\n}\n';
                            var h = (null === (l = t.opts.chart) || void 0 === l ? void 0 : l.nonce) || t.w.config.chart.nonce;
                            h && n.setAttribute("nonce", h), r ? s.prepend(n) : o.head.appendChild(n);
                        }
                        var c = t.create(t.w.config.series, {});
                        if (!c) return e(t);
                        t.mount(c).then(function() {
                            "function" == typeof t.w.config.chart.events.mounted && t.w.config.chart.events.mounted(t, t.w), t.events.fireEvent("mounted", [
                                t,
                                t.w
                            ]), e(c);
                        }).catch(function(t) {
                            i(t);
                        });
                    } else i(new Error("Element not found"));
                });
            }
        },
        {
            key: "create",
            value: function(t, e) {
                var i = this, a = this.w;
                new qt(this).initModules();
                var s = this.w.globals;
                (s.noData = !1, s.animationEnded = !1, this.responsive.checkResponsiveConfig(e), a.config.xaxis.convertedCatToNumeric) && new F(a.config).convertCatToNumericXaxis(a.config, this.ctx);
                if (null === this.el) return s.animationEnded = !0, null;
                if (this.core.setupElements(), "treemap" === a.config.chart.type && (a.config.grid.show = !1, a.config.yaxis[0].show = !1), 0 === s.svgWidth) return s.animationEnded = !0, null;
                var r = t;
                t.forEach(function(t, e) {
                    t.hidden && (r = i.legend.legendHelpers.getSeriesAfterCollapsing({
                        realIndex: e
                    }));
                });
                var o = A.checkComboSeries(r, a.config.chart.type);
                s.comboCharts = o.comboCharts, s.comboBarCount = o.comboBarCount;
                var n = r.every(function(t) {
                    return t.data && 0 === t.data.length;
                });
                (0 === r.length || n && s.collapsedSeries.length < 1) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(r), this.theme.init(), new W(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), s.noData && s.collapsedSeries.length !== s.series.length && !a.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), s.axisCharts && (this.core.coreCalculations(), "category" !== a.config.xaxis.type && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = a.globals.minX, this.ctx.toolbar.maxX = a.globals.maxX), this.formatters.heatmapLabelFormatters(), new A(this).getLargestMarkerSize(), this.dimensions.plotCoords();
                var l = this.core.xySettings();
                this.grid.createGridMask();
                var h = this.core.plotChartType(r, l), c = new G(this);
                return c.bringForward(), a.config.dataLabels.background.enabled && c.dataLabelsBackground(), this.core.shiftGraphPosition(), {
                    elGraph: h,
                    xyRatios: l,
                    dimensions: {
                        plot: {
                            left: a.globals.translateX,
                            top: a.globals.translateY,
                            width: a.globals.gridWidth,
                            height: a.globals.gridHeight
                        }
                    }
                };
            }
        },
        {
            key: "mount",
            value: function() {
                var t = this, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = this, a = i.w;
                return new Promise(function(s, r) {
                    if (null === i.el) return r(new Error("Not enough data to display or target element not found"));
                    (null === e || a.globals.allSeriesCollapsed) && i.series.handleNoData(), i.grid = new Z(i);
                    var o, n, l = i.grid.drawGrid();
                    (i.annotations = new E(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), "back" === a.config.grid.position) && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (o = l.elGridBorders) && void 0 !== o && o.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    if (Array.isArray(e.elGraph)) for(var h = 0; h < e.elGraph.length; h++)a.globals.dom.elGraphical.add(e.elGraph[h]);
                    else a.globals.dom.elGraphical.add(e.elGraph);
                    "front" === a.config.grid.position && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (n = l.elGridBorders) && void 0 !== n && n.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    "front" === a.config.xaxis.crosshairs.position && i.crosshairs.drawXCrosshairs(), "front" === a.config.yaxis[0].crosshairs.position && i.crosshairs.drawYCrosshairs(), "treemap" !== a.config.chart.type && i.axes.drawAxis(a.config.chart.type, l);
                    var c = new q(t.ctx, l), d = new Q(t.ctx, l);
                    if (null !== l && (c.xAxisLabelCorrections(l.xAxisTickWidth), d.setYAxisTextAlignments(), a.config.yaxis.map(function(t, e) {
                        -1 === a.globals.ignoreYAxisIndexes.indexOf(e) && d.yAxisTitleRotate(e, t.opposite);
                    })), i.annotations.drawAxesAnnotations(), !a.globals.noData) {
                        if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(e.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                            xyRatios: e.xyRatios
                        });
                        else {
                            var g = a.config.chart.toolbar.tools;
                            [
                                "zoom",
                                "zoomin",
                                "zoomout",
                                "selection",
                                "pan",
                                "reset"
                            ].forEach(function(t) {
                                g[t] = !1;
                            });
                        }
                        a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                    }
                    a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(t) {
                        t.method(t.params, !1, t.context);
                    }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                var t, e;
                window.removeEventListener("resize", this.windowResizeHandler), this.el.parentNode, t = this.parentResizeHandler, (e = $t.get(t)) && (e.disconnect(), $t.delete(t));
                var i = this.w.config.chart.id;
                i && Apex._chartInstances.forEach(function(t, e) {
                    t.id === m.escapeString(i) && Apex._chartInstances.splice(e, 1);
                }), new Zt(this.ctx).clear({
                    isUpdating: !1
                });
            }
        },
        {
            key: "updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], o = this.w;
                return o.globals.selection = void 0, t.series && (this.series.resetSeries(!1, !0, !1), t.series.length && t.series[0].data && (t.series = t.series.map(function(t, i) {
                    return e.updateHelpers._extendSeries(t, i);
                })), this.updateHelpers.revertDefaultAxisMinMax()), t.xaxis && (t = this.updateHelpers.forceXAxisUpdate(t)), t.yaxis && (t = this.updateHelpers.forceYAxisUpdate(t)), o.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), t.theme && (t = this.theme.updateThemeOptions(t)), this.updateHelpers._updateOptions(t, i, a, s, r);
            }
        },
        {
            key: "updateSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(t, e, i);
            }
        },
        {
            key: "appendSeries",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w.config.series.slice();
                return a.push(t), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, e, i);
            }
        },
        {
            key: "appendData",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this;
                i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (null !== t[s] && void 0 !== t[s]) for(var r = 0; r < t[s].data.length; r++)a[s].data.push(t[s].data[r]);
                return i.w.config.series = a, e && (i.w.globals.initialSeries = m.clone(i.w.config.series)), this.update();
            }
        },
        {
            key: "update",
            value: function(t) {
                var e = this;
                return new Promise(function(i, a) {
                    new Zt(e.ctx).clear({
                        isUpdating: !0
                    });
                    var s = e.create(e.w.config.series, t);
                    if (!s) return i(e);
                    e.mount(s).then(function() {
                        "function" == typeof e.w.config.chart.events.updated && e.w.config.chart.events.updated(e, e.w), e.events.fireEvent("updated", [
                            e,
                            e.w
                        ]), e.w.globals.isDirty = !0, i(e);
                    }).catch(function(t) {
                        a(t);
                    });
                });
            }
        },
        {
            key: "getSyncedCharts",
            value: function() {
                var t = this.getGroupedCharts(), e = [
                    this
                ];
                return t.length && (e = [], t.forEach(function(t) {
                    e.push(t);
                })), e;
            }
        },
        {
            key: "getGroupedCharts",
            value: function() {
                var t = this;
                return Apex._chartInstances.filter(function(t) {
                    if (t.group) return !0;
                }).map(function(e) {
                    return t.w.config.chart.group === e.group ? e.chart : t;
                });
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                return this.series.toggleSeries(t);
            }
        },
        {
            key: "highlightSeriesOnLegendHover",
            value: function(t, e) {
                return this.series.toggleSeriesOnHover(t, e);
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                this.series.showSeries(t);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                this.series.hideSeries(t);
            }
        },
        {
            key: "highlightSeries",
            value: function(t) {
                this.series.highlightSeries(t);
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                this.series.isSeriesHidden(t);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.series.resetSeries(t, e);
            }
        },
        {
            key: "addEventListener",
            value: function(t, e) {
                this.events.addEventListener(t, e);
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                this.events.removeEventListener(t, e);
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addXaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addYaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addPointAnnotationExternal(t, e, a);
            }
        },
        {
            key: "clearAnnotations",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, e = this;
                t && (e = t), e.annotations.clearAnnotations(e);
            }
        },
        {
            key: "removeAnnotation",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = this;
                e && (i = e), i.annotations.removeAnnotation(i, t);
            }
        },
        {
            key: "getChartArea",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
            }
        },
        {
            key: "getSeriesTotalXRange",
            value: function(t, e) {
                return this.coreUtils.getSeriesTotalsXRange(t, e);
            }
        },
        {
            key: "getHighestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new J(this.ctx).getMinYMaxY(t).highestY;
            }
        },
        {
            key: "getLowestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new J(this.ctx).getMinYMaxY(t).lowestY;
            }
        },
        {
            key: "getSeriesTotal",
            value: function() {
                return this.w.globals.seriesTotals;
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                return this.updateHelpers.toggleDataPointSelection(t, e);
            }
        },
        {
            key: "zoomX",
            value: function(t, e) {
                this.ctx.toolbar.zoomUpdateOptions(t, e);
            }
        },
        {
            key: "setLocale",
            value: function(t) {
                this.localization.setCurrentLocaleValues(t);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                return new U(this.ctx).dataURI(t);
            }
        },
        {
            key: "exportToCSV",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new U(this.ctx).exportToCSV(t);
            }
        },
        {
            key: "paper",
            value: function() {
                return this.w.globals.dom.Paper;
            }
        },
        {
            key: "_parentResizeCallback",
            value: function() {
                this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
            }
        },
        {
            key: "_windowResize",
            value: function() {
                var t = this;
                clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                    t.w.globals.resized = !0, t.w.globals.dataChanged = !1, t.ctx.update();
                }, 150);
            }
        },
        {
            key: "_windowResizeHandler",
            value: function() {
                var t = this.w.config.chart.redrawOnWindowResize;
                "function" == typeof t && (t = t()), t && this._windowResize();
            }
        }
    ], [
        {
            key: "getChartByID",
            value: function(t) {
                var e = m.escapeString(t);
                if (Apex._chartInstances) {
                    var i = Apex._chartInstances.filter(function(t) {
                        return t.id === e;
                    })[0];
                    return i && i.chart;
                }
            }
        },
        {
            key: "initOnLoad",
            value: function() {
                for(var e = document.querySelectorAll("[data-apexcharts]"), i = 0; i < e.length; i++)new t(e[i], JSON.parse(e[i].getAttribute("data-options"))).render();
            }
        },
        {
            key: "exec",
            value: function(t, e) {
                var i = this.getChartByID(t);
                if (i) {
                    i.w.globals.isExecCalled = !0;
                    var a = null;
                    if (-1 !== i.publicMethods.indexOf(e)) {
                        for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)r[o - 2] = arguments[o];
                        a = i[e].apply(i, r);
                    }
                    return a;
                }
            }
        },
        {
            key: "merge",
            value: function(t, e) {
                return m.extend(t, e);
            }
        }
    ]), t;
}();
module.exports = Jt;

},{}],"bRC5z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StandardsAssessment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _reactRouterDom = require("react-router-dom");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function StandardsAssessment({ context }) {
    const classes = (0, _stylesDefault.default)();
    const { quizAssessmentToReview: assessment, quizTypesMap, link, translate } = context;
    const { studentName, content = {}, started, finished } = assessment;
    const { title, type } = content;
    const typeName = translate(quizTypesMap[type]);
    const closeLink = link({}, context.quizEditFrom || '/:languageId/:role/:page/assigned', {
        query: context.quizEditFromQuery
    });
    function formatDate(date) {
        return (0, _momentDefault.default)(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
        container: true,
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                item: true,
                xs: 8,
                md: 8,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.studentName,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faUser)
                        }),
                        studentName
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                item: true,
                xs: 4,
                md: 4,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                    className: (0, _clsxDefault.default)(classes.button, classes.close),
                    to: closeLink,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: "icon",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: "label",
                            children: translate('close')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                xs: 12,
                md: 12,
                className: classes.grid,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.title,
                        children: [
                            typeName,
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "type",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                xs: 12,
                md: 5,
                className: classes.grid,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.title,
                        children: [
                            translate('standards-asigned'),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.finished,
                        children: formatDate(started)
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                xs: 12,
                md: 5,
                className: classes.grid,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.title,
                        children: [
                            translate('standards-completed'),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.finished,
                        children: formatDate(finished)
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","moment":"1e4qG","react-router-dom":"3uzXR","clsx":"5PNR8","@mui/material/Box":"73kto","@mui/icons-material/Close":"acjz6","@mui/material/Grid":"ggUwv","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"joPR3","./styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dpBrQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Loading);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("@mui/material/Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _stack = require("@mui/material/Stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
function Loading() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _stackDefault.default), {
        spacing: 3,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                animation: "wave",
                width: '30%',
                style: {
                    "marginLeft": "65%"
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                animation: "wave"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "rectangular",
                animation: "wave",
                height: 30
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "text",
                animation: "wave"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeletonDefault.default), {
                variant: "rectangular",
                animation: "wave",
                height: 200
            }, 'h1')
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/Skeleton":"4ZIXq","@mui/material/Stack":"jY4TS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ZIXq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _skeletonDefault.default));
parcelHelpers.export(exports, "skeletonClasses", ()=>(0, _skeletonClassesDefault.default));
var _skeleton = require("./Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _skeletonClasses = require("./skeletonClasses");
parcelHelpers.exportAll(_skeletonClasses, exports);
var _skeletonClassesDefault = parcelHelpers.interopDefault(_skeletonClasses);
'use client';

},{"./Skeleton":"suUEB","./skeletonClasses":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"suUEB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _system = require("@mui/system");
var _composeClasses = require("@mui/utils/composeClasses");
var _composeClassesDefault = parcelHelpers.interopDefault(_composeClasses);
var _styles = require("../styles");
var _styled = require("../styles/styled");
var _styledDefault = parcelHelpers.interopDefault(_styled);
var _defaultPropsProvider = require("../DefaultPropsProvider");
var _skeletonClasses = require("./skeletonClasses");
var _jsxRuntime = require("react/jsx-runtime");
'use client';
const _excluded = [
    "animation",
    "className",
    "component",
    "height",
    "style",
    "variant",
    "width"
];
let _ = (t)=>t, _t, _t2, _t3, _t4;
const useUtilityClasses = (ownerState)=>{
    const { classes, variant, animation, hasChildren, width, height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, _composeClassesDefault.default)(slots, (0, _skeletonClasses.getSkeletonUtilityClass), classes);
};
const pulseKeyframe = (0, _system.keyframes)(_t || (_t = _`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = (0, _system.keyframes)(_t2 || (_t2 = _`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = (0, _styledDefault.default)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})(({ theme, ownerState })=>{
    const radiusUnit = (0, _styles.unstable_getUnit)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, _styles.unstable_toUnitless)(theme.shape.borderRadius);
    return (0, _extendsDefault.default)({
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : (0, _styles.alpha)(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em'
    }, ownerState.variant === 'text' && {
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        transformOrigin: '0 55%',
        transform: 'scale(1, 0.60)',
        borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
        '&:empty:before': {
            content: '"\\00a0"'
        }
    }, ownerState.variant === 'circular' && {
        borderRadius: '50%'
    }, ownerState.variant === 'rounded' && {
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.hasChildren && {
        '& > *': {
            visibility: 'hidden'
        }
    }, ownerState.hasChildren && !ownerState.width && {
        maxWidth: 'fit-content'
    }, ownerState.hasChildren && !ownerState.height && {
        height: 'auto'
    });
}, ({ ownerState })=>ownerState.animation === 'pulse' && (0, _system.css)(_t3 || (_t3 = _`
      animation: ${0} 2s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({ ownerState, theme })=>ownerState.animation === 'wave' && (0, _system.css)(_t4 || (_t4 = _`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 2s linear 0.5s infinite;
        background: linear-gradient(
          90deg,
          transparent,
          ${0},
          transparent
        );
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, (theme.vars || theme).palette.action.hover));
const Skeleton = /*#__PURE__*/ _react.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, _defaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation = 'pulse', className, component = 'span', height, style, variant = 'text', width } = props, other = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
    const ownerState = (0, _extendsDefault.default)({}, props, {
        animation,
        component,
        variant,
        hasChildren: Boolean(other.children)
    });
    const classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonRoot, (0, _extendsDefault.default)({
        as: component,
        ref: ref,
        className: (0, _clsxDefault.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        style: (0, _extendsDefault.default)({
            width,
            height
        }, style)
    }));
});
exports.default = Skeleton;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"jGdYV","@babel/runtime/helpers/esm/extends":"aAOJb","react":"9njXz","clsx":"bK0Bf","prop-types":"bnNSm","@mui/system":"5Hnj5","@mui/utils/composeClasses":"43D21","../styles":"c9RfU","../styles/styled":"bTnxF","../DefaultPropsProvider":"ff3VX","./skeletonClasses":"7pSOS","react/jsx-runtime":"1dlk8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7pSOS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSkeletonUtilityClass", ()=>getSkeletonUtilityClass);
var _generateUtilityClasses = require("@mui/utils/generateUtilityClasses");
var _generateUtilityClassesDefault = parcelHelpers.interopDefault(_generateUtilityClasses);
var _generateUtilityClass = require("@mui/utils/generateUtilityClass");
var _generateUtilityClassDefault = parcelHelpers.interopDefault(_generateUtilityClass);
function getSkeletonUtilityClass(slot) {
    return (0, _generateUtilityClassDefault.default)('MuiSkeleton', slot);
}
const skeletonClasses = (0, _generateUtilityClassesDefault.default)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
exports.default = skeletonClasses;

},{"@mui/utils/generateUtilityClasses":"kn9BC","@mui/utils/generateUtilityClass":"ktE5h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"44wLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Legend);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodash = require("lodash");
var _grid = require("@mui/material/Grid");
var _gridDefault = parcelHelpers.interopDefault(_grid);
var _avatar = require("@mui/material/Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _styles = require("../styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function Legend({ context }) {
    const classes = (0, _stylesDefault.default)();
    const { translate, quizStandardScale = {} } = context;
    const scale = (0, _lodash.orderBy)(Object.values(quizStandardScale[0] || {}), 'index');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
        container: true,
        className: classes.legend,
        children: scale && scale.map(({ index, color, label, maxValue, minValue })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                item: true,
                xs: 4,
                md: 2,
                className: classes.legendBox,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridDefault.default), {
                        item: true,
                        xs: 2,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avatarDefault.default), {
                            className: classes.legendDot,
                            style: {
                                "backgroundColor": color
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {})
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridDefault.default), {
                        item: true,
                        xs: 10,
                        className: classes.legendLabel,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate(`standards-${label}`)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: `${maxValue}% - ${minValue}%`
                            })
                        ]
                    })
                ]
            }, index))
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","lodash":"1qc47","@mui/material/Grid":"ggUwv","@mui/material/Avatar":"4ltr6","@mui/material/Box":"73kto","../styles":"453Xc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68nQ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TakeAssessment);
parcelHelpers.export(exports, "assessmentStyles", ()=>assessmentStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _navigation = require("./Navigation");
var _navigationDefault = parcelHelpers.interopDefault(_navigation);
var _timer = require("./Timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
var _sections = require("./Sections");
var _sectionsDefault = parcelHelpers.interopDefault(_sections);
var _section = require("./Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _question = require("./Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
var _finalizeAssessment = require("./FinalizeAssessment");
var _finalizeAssessmentDefault = parcelHelpers.interopDefault(_finalizeAssessment);
var _fullScreenDialog = require("components/FullScreenDialog");
var _fullScreenDialogDefault = parcelHelpers.interopDefault(_fullScreenDialog);
var _command = require("../../../helpers/command");
const saveAnswers = (0, _command.createPost)('quiz', 'saveTeacherAnswers');
const useStyles = (0, _material.makeStyles)(assessmentStyles);
function TakeAssessment(props) {
    const imported = props.imported;
    if (props.context.attemptId && !imported) throw new Error('Imported assessment requires imported test adapter');
    const classes = useStyles();
    const [finalizeOpen, setFinalize] = (0, _reactDefault.default).useState(false);
    function closeFinalize() {
        setFinalize(false);
    }
    function openFinalize() {
        setFinalize(true);
    }
    const context = {
        ...props.context,
        saveAnswers: imported ? imported.saveAnswers : saveAnswers,
        importedFinalize: imported && imported.finalize
    };
    const { quizAssessmentToTake: assessment, assessment: assessmentId, translate, sectionId, link, quizTypesMap } = context;
    const { content = {} } = assessment;
    const { title, type } = content;
    const assessmentLoaded = !context.quizSearch['assessment-to-take'];
    const sections = imported || assessment.assessmentId == assessmentId ? (0, _lodash.orderBy)(Object.values(content.sections || {}), 'index') : [];
    const redirect = !imported && sections.length > 0 && !sectionId;
    const redirectLink = redirect && link({
        sectionId: sections[0].id
    });
    const typeName = imported ? context.languageId === 'es' ? 'Examen' : 'Exam' : translate(quizTypesMap[type]);
    const isSection = !context.questionId;
    const closeLink = imported ? imported.closeLink : link({
        action: 'preview',
        sectionId: undefined,
        questionId: undefined
    });
    return redirectLink ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
        to: redirectLink
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenDialogDefault.default), {
        open: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.label,
                            children: translate('test-preview-header')
                        }),
                        !imported?.readOnly && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.button, classes.finalize),
                            onClick: openFinalize,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: "label",
                                children: translate('finalize-test')
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _finalizeAssessmentDefault.default), {
                            isOpen: finalizeOpen,
                            context: context,
                            onClose: closeFinalize,
                            imported: imported ? {
                                onFinalize: imported.finalize
                            } : undefined
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                            className: (0, _clsxDefault.default)(classes.button, classes.close),
                            to: closeLink,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "label",
                                    children: translate('close')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.preview,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
                            className: classes.view,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.viewHeader,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                            className: "type",
                                            children: [
                                                typeName,
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                            className: "title",
                                            children: title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: classes.viewContent,
                                    children: [
                                        isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionDefault.default), {
                                            sections,
                                            context,
                                            content
                                        }),
                                        !isSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                                            sections,
                                            context,
                                            content
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.viewNavigation,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navigationDefault.default), {
                                        sections,
                                        context,
                                        content
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.side,
                            children: [
                                assessment.duration > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timerDefault.default), {
                                    context: context
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionsDefault.default), {
                                    sections,
                                    context
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function assessmentStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
        },
        header: {
            padding: 10,
            display: 'flex',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }
        },
        label: {
            flexGrow: 1,
            color: '#4d5361',
            fontSize: '13pt',
            fontWeight: 'bold'
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {}
        },
        close: {
            marginLeft: 20,
            '& .icon': {
                marginTop: -3,
                marginRight: 3,
                fontSize: '8pt'
            }
        },
        preview: {
            display: 'flex',
            padding: 10,
            flexGrow: 1,
            overflowY: 'hidden'
        },
        view: {
            flexGrow: 1,
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        viewHeader: {
            display: 'flex',
            color: '#4d5361',
            fontSize: '13pt',
            padding: 20,
            borderBottom: 'solid 1px #d3d8db',
            "& .type": {
                fontWeight: 'bold'
            },
            "& .title": {
                marginLeft: 3
            }
        },
        viewContent: {
            display: 'flex',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        viewNavigation: {
            borderTop: 'solid 1px #d3d8db',
            padding: 20
        },
        side: {
            marginLeft: 25,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 255,
            maxWidth: 255
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","@mui/icons-material/Close":"acjz6","./Navigation":"eiRHj","./Timer":"aN6rf","./Sections":"ffdBw","./Section":"1FMzs","./Question":"lCGxZ","./FinalizeAssessment":"gIGSP","components/FullScreenDialog":"cr6Y6","../../../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eiRHj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Navigation);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _icons = require("../../../resources/icons");
var _finalizeAssessment = require("./FinalizeAssessment");
var _finalizeAssessmentDefault = parcelHelpers.interopDefault(_finalizeAssessment);
const useStyles = (0, _material.makeStyles)(navigationStyles);
function Navigation({ sections, context }) {
    const { quizAssessmentToTake: assessment, assessment: assessmentId, questionId, sectionId, translate, saveAnswers } = context;
    const classes = useStyles();
    const [finalizeOpen, setFinalize] = (0, _reactDefault.default).useState(false);
    function closeFinalize() {
        setFinalize(false);
    }
    function openFinalize() {
        setFinalize(true);
    }
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const questionIndex = questionId && section ? section.questions.findIndex((q)=>q.id == questionId) : -1;
    const question = questionIndex >= 0 && section.questions[questionIndex];
    const isFirst = !questionId && sectionIndex == 0;
    const isLastSection = sectionIndex == sections.length - 1;
    const isLastQuestion = section && questionIndex == section.questions.length - 1;
    const isLast = isLastSection && isLastQuestion;
    const nextTo = ()=>{
        if (!section) return '#';
        if (questionId) return isLastQuestion ? context.link({
            sectionId: sections[sectionIndex + 1].id,
            questionId: undefined
        }) : context.link({
            sectionId,
            questionId: section.questions[questionIndex + 1].id
        });
        return context.link({
            sectionId,
            questionId: section.questions[0].id
        });
    };
    const previousTo = ()=>{
        if (!section) return '#';
        if (questionId) return questionIndex == 0 ? context.link({
            sectionId,
            questionId: undefined
        }) : context.link({
            sectionId,
            questionId: section.questions[questionIndex - 1].id
        });
        const previousSection = sections[sectionIndex - 1];
        const lastQuestion = previousSection.questions[previousSection.questions.length - 1];
        if (lastQuestion) return context.link({
            sectionId: previousSection.id,
            questionId: lastQuestion.id
        });
        return '#';
    };
    const { answers = {} } = assessment || {};
    const answer = answers[questionId];
    const marked = answer ? answer.pending == true : false;
    async function handleMark(e) {
        const pending = e.target.checked;
        const command = answer ? {
            [questionId]: {
                pending: {
                    $set: pending
                }
            }
        } : {
            $apply: (answers)=>({
                    ...answers,
                    [questionId]: {
                        pending
                    }
                })
        };
        const { quizAssessmentToTake: assessment } = await context.updateState({
            quizAssessmentToTake: {
                answers: command
            }
        });
        if (assessment.answers) context.saveAnswers({
            id: assessmentId,
            answers: assessment.answers
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _finalizeAssessmentDefault.default), {
                isOpen: finalizeOpen,
                context: context,
                onClose: closeFinalize
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.root,
                children: [
                    questionId && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                        size: "small",
                        className: classes.pendingReview,
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                            size: "small",
                            color: "primary",
                            checked: marked,
                            onChange: handleMark
                        }),
                        label: translate('pending-review')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: "filler"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.buttons,
                        children: [
                            !isFirst && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NavigationButton, {
                                name: "previous",
                                to: previousTo(),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.buttonIcon,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowLeftIcon), {
                                            width: "16px",
                                            height: "25px",
                                            fill: "#6278f0"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: (0, _clsxDefault.default)(classes.buttonLabel, "previous"),
                                        children: translate('previous')
                                    })
                                ]
                            }),
                            !isLast && /*#__PURE__*/ (0, _jsxRuntime.jsxs)(NavigationButton, {
                                name: "next",
                                to: nextTo(),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: (0, _clsxDefault.default)(classes.buttonLabel, "next"),
                                        children: translate('next')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                        className: classes.buttonIcon,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ArrowRightIcon), {
                                            width: "16px",
                                            height: "25px",
                                            fill: "#6278f0"
                                        })
                                    })
                                ]
                            }),
                            isLast && /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavigationButton, {
                                onClick: openFinalize,
                                name: "finalize",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: (0, _clsxDefault.default)(classes.buttonLabel, "finalize"),
                                    children: translate('finalize-test')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function NavigationButton(props) {
    const { name, onClick, to } = props;
    const classes = useStyles();
    const Elem = to ? (0, _reactRouterDom.Link) : (0, _boxDefault.default);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Elem, {
        to: to,
        onClick: onClick,
        className: (0, _clsxDefault.default)(classes.button, name),
        children: props.children
    });
}
function navigationStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            display: 'flex',
            "& .filler": {
                flexGrow: 1
            }
        },
        pendingReview: {
            color: '#4c4f58'
        },
        buttons: {
            display: 'flex'
        },
        button: {
            cursor: 'pointer',
            display: 'flex',
            padding: '5px',
            fontSize: '12pt',
            backgroundColor: '#f0f0f0',
            color: '#6278f0',
            borderRadius: 3,
            width: 110,
            textDecoration: 'none',
            "&:last-child": {
                marginLeft: 20
            }
        },
        buttonLabel: {
            flexGrow: 1,
            ...verticalCentering,
            textAlign: 'center'
        },
        buttonIcon: {
            ...verticalCentering
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/FormControlLabel":"kemIW","@mui/material/Checkbox":"4sdMA","../../../resources/icons":"7BMUb","./FinalizeAssessment":"gIGSP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gIGSP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FinalizeAssessment);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _responsiveFullscreenDialog = require("../../responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _utils = require("./utils");
const useStyles = (0, _material.makeStyles)(finalizeAssessmentStyles);
function FinalizeAssessment({ isOpen, onClose, context, imported }) {
    const history = (0, _reactRouterDom.useHistory)();
    const [error, setError] = (0, _reactDefault.default).useState('');
    const [submitting, setSubmitting] = (0, _reactDefault.default).useState(false);
    const classes = useStyles();
    const { translate, quizAssessmentToTake: assessment, assessment: assessmentId, saveAnswers } = context;
    const { content = {} } = assessment;
    const sections = !context.quizSearch['assessment-to-take'] ? (0, _lodash.orderBy)(Object.values(content.sections || {}), 'index') : [];
    const answers = Object.entries(assessment.answers || {}).map(([id, { completed, pending }])=>({
            completed,
            pending,
            globalIndex: (0, _utils.findGlobalIndex)(id, sections)
        }));
    const completed = answers.filter((a)=>!a.pending && a.completed);
    const unanswered = (0, _lodash.orderBy)(answers.filter((a)=>!a.pending && !a.completed), 'globalIndex').map((a)=>a.globalIndex + 1);
    const pending = (0, _lodash.orderBy)(answers.filter((a)=>a.pending), 'globalIndex').map((a)=>a.globalIndex + 1);
    async function handleFinalize() {
        if (imported || context.attemptId) {
            const onFinalize = imported && imported.onFinalize || context.importedFinalize;
            if (typeof onFinalize !== 'function') {
                setError("No se pudo identificar la finalizaci\xf3n de la prueba importada.");
                return;
            }
            if (submitting) return;
            setSubmitting(true);
            setError('');
            try {
                await onFinalize();
                onClose();
            } catch (e) {
                setError("No se pudo finalizar la prueba. Int\xe9ntalo nuevamente.");
            } finally{
                setSubmitting(false);
            }
            return;
        }
        const [savedId] = await saveAnswers({
            id: assessmentId,
            answers: assessment.answers,
            finalize: true
        });
        if (assessment.id == savedId) {
            onClose();
            context.navigate({
                action: 'preview-results',
                sectionId: undefined,
                questionId: undefined
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _responsiveFullscreenDialogDefault.default), {
        open: isOpen,
        close: onClose,
        actionsClassName: classes.actions,
        confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            className: (0, _clsxDefault.default)("button", "create"),
            color: "primary",
            disabled: submitting,
            onClick: handleFinalize,
            children: translate('finalize')
        }),
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
            variant: "contained",
            className: (0, _clsxDefault.default)("button", "cancel"),
            onClick: onClose,
            children: translate('cancel')
        }),
        title: translate('finalize-dialog-title'),
        children: [
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                role: "alert",
                children: error
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.completed,
                children: translate('finalize-dialog-completed-message', {
                    completed: completed.length,
                    total: answers.length
                })
            }),
            pending.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.pending,
                children: translate('finalize-dialog-pending-message', {
                    pending: pending.join(', ')
                })
            }),
            unanswered.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.unanswered,
                children: translate('finalize-dialog-unanswered-message', {
                    unanswered: unanswered.join(', ')
                })
            })
        ]
    });
}
function finalizeAssessmentStyles(theme) {
    return {};
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","../../responsive-fullscreen-dialog":"9pRHY","./utils":"j9Vy3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j9Vy3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findGlobalIndex", ()=>findGlobalIndex);
function findGlobalIndex(id, sections = []) {
    let j = 0;
    for(let i = 0; i < sections.length; i++){
        const section = sections[i];
        const index = section.questions.findIndex((q)=>q.id == id);
        if (index >= 0) return j + index;
        j += section.questions.length;
    }
    return -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aN6rf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Timer);
parcelHelpers.export(exports, "timerStyles", ()=>timerStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("../../../helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _intervalHook = require("../../../helpers/interval-hook");
var _intervalHookDefault = parcelHelpers.interopDefault(_intervalHook);
const useStyles = (0, _material.makeStyles)(timerStyles);
function Timer({ context }) {
    const classes = useStyles();
    const { assessment, translate } = context;
    const [count, setCount] = (0, _reactDefault.default).useState(0);
    (0, _intervalHookDefault.default)(()=>{
        setCount(count - 1);
    }, count > 0 ? 1000 : null);
    const duration = (0, _momentDefault.default).duration(assessment.duration, 'seconds').humanize();
    (0, _reactDefault.default).useEffect(()=>{
        if (assessment.started) {
            const deadline = (0, _momentDefault.default)(assessment.started).add(assessment.duration, 'seconds');
            const remaining = (0, _momentDefault.default).duration(deadline.diff((0, _momentDefault.default)()));
            const countdown = Math.floor(remaining.asSeconds());
            setCount(countdown);
        }
    }, [
        assessment.started
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.countdown,
                children: formatCountDown(count)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.duration,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.durationLabel,
                        children: [
                            translate('assessment-duration'),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        children: duration
                    })
                ]
            })
        ]
    });
}
function formatCountDown(time) {
    const hours = Math.floor(time / 3600).toString().padStart(2, 0);
    const minutes = Math.floor(time % 3600 / 60).toString().padStart(2, 0);
    const seconds = Math.floor(time % 60).toString().padStart(2, 0);
    return `${hours}:${minutes}:${seconds}`;
}
function timerStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: 18,
            padding: 25,
            color: '#505163'
        },
        countdown: {
            display: 'flex',
            justifyContent: 'center',
            fontSize: '18pt',
            fontWeight: 'bold',
            color: '#1e4c97'
        },
        duration: {
            marginTop: 10,
            fontSize: '9pt',
            display: 'flex'
        },
        "durationLabel": {
            marginRight: 3
        }
    };
}

},{"react/jsx-runtime":"1dlk8","../../../helpers/moment":"jwdju","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","../../../helpers/interval-hook":"5BIPQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffdBw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Sections);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _sectionLink = require("./SectionLink");
var _sectionLinkDefault = parcelHelpers.interopDefault(_sectionLink);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Sections({ sections, context }) {
    const classes = useStyles();
    const createSection = (section, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sectionLinkDefault.default), {
            key: section.id,
            index,
            section,
            context,
            sections
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paperDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: context.translate('questions')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.sections,
                children: sections.map(createSection)
            })
        ]
    });
}
function sectionStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'column'
        },
        header: {
            padding: 10,
            color: '#555764',
            fontSize: '12pt'
        },
        sections: {
            display: 'flex',
            flexDirection: 'column',
            overflowY: 'auto'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Paper":"arHf6","./SectionLink":"17IHo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"17IHo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
parcelHelpers.export(exports, "sectionStyles", ()=>sectionStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
var _questionLink = require("./QuestionLink");
var _questionLinkDefault = parcelHelpers.interopDefault(_questionLink);
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ index, section, sections, context }) {
    const classes = useStyles();
    const { translate } = context;
    const { questions = [] } = section;
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${index + 1}` : section.title;
    const chunkSize = 4;
    const questionRows = (0, _lodash.chunk)(questions.map((question, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionLinkDefault.default), {
            index,
            section,
            question,
            context,
            sections
        }, question.id)), chunkSize);
    const addDummies = (row)=>{
        const missing = chunkSize - row.length;
        const newRow = missing == 0 ? row : row.concat((0, _lodash.range)(missing).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionLink.QuestionLinkDummy), {}, row.length + index)));
        return newRow;
    };
    const sectionLink = context.link({
        sectionId: section.id,
        questionId: undefined
    });
    const selected = section.id == context.sectionId && !context.questionId;
    function handleClick(e) {
        selected && e.preventDefault();
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                className: (0, _clsxDefault.default)(classes.title, {
                    selected
                }),
                onClick: handleClick,
                to: sectionLink,
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.questions,
                children: questionRows.map((row, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.questionRow,
                        children: addDummies(row)
                    }, index))
            })
        ]
    });
}
function sectionStyles(theme) {
    return {
        title: {
            display: 'flex',
            padding: 10,
            textDecoration: 'none',
            color: '#5c6fcd',
            fontSize: '11pt',
            borderTop: 'solid 1px #e1e5e8',
            borderBottom: 'solid 1px #e1e5e8',
            borderLeft: 'solid 4px #577ee3',
            backgroundColor: '#fff7f3',
            "&.selected": {
                backgroundColor: '#577ee3',
                color: '#fff',
                cursor: 'default'
            }
        },
        questions: {
            display: 'flex',
            flexDirection: 'column',
            padding: '10px 5px'
        },
        questionRow: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: 10
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","./QuestionLink":"7agcI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7agcI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuestionLink);
parcelHelpers.export(exports, "QuestionLinkDummy", ()=>QuestionLinkDummy);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _fab = require("@mui/material/Fab");
var _fabDefault = parcelHelpers.interopDefault(_fab);
var _utils = require("./utils");
const useStyles = (0, _material.makeStyles)(linkStyles);
function QuestionLink({ section, sections, context, question, index }) {
    const classes = useStyles();
    const { answers = {} } = context.quizAssessmentToTake;
    const answer = answers[question.id] || {};
    const selected = question.id == context.questionId && section.id == context.sectionId;
    const marked = answer.pending == true;
    const answered = answer.completed && !marked;
    const onClick = (e)=>selected && e.preventDefault();
    const className = (0, _clsxDefault.default)(classes.root, {
        selected,
        marked,
        answered
    });
    const href = '#' + context.link({
        sectionId: section.id,
        questionId: question.id
    });
    const globalIndex = (0, _utils.findGlobalIndex)(question.id, sections);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fabDefault.default), {
        size: 'small',
        onClick,
        className,
        href,
        children: globalIndex + 1
    });
}
function QuestionLinkDummy() {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fabDefault.default), {
        size: "small",
        className: (0, _clsxDefault.default)(classes.root, "dummy"),
        children: "0"
    });
}
function linkStyles(theme) {
    return {
        root: {
            backgroundColor: '#f3f4f6',
            color: '#a3aab0',
            boxShadow: 'none',
            marginRight: 10,
            "& .MuiFab-label": {
                paddingTop: 2
            },
            "&:last-child": {
                marginRight: 0
            },
            "&.dummy": {
                visibility: 'hidden'
            },
            "&.marked": {
                backgroundColor: '#ef0e0a',
                color: '#fff'
            },
            "&.answered": {
                backgroundColor: '#52aa5e',
                color: '#fff'
            },
            "&.selected": {
                backgroundColor: '#000',
                color: '#fff',
                cursor: 'default'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Fab":"9QkHI","./utils":"j9Vy3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1FMzs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Section);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(sectionStyles);
function Section({ sections, context }) {
    const { questionId, sectionId, translate } = context;
    const classes = useStyles();
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const title = (0, _utils.isEmpty)(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title;
    const instructions = section && ((0, _utils.isEmpty)(section.instructions) ? false : section.instructions);
    const defaultInstructions = translate('default-section-instructions');
    const hasDefaultInstructions = defaultInstructions != 'default-section-instructions';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.header,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.title,
                    children: title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    (instructions || hasDefaultInstructions) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.label,
                        children: translate('instructions')
                    }),
                    instructions && (context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        className: classes.instructions,
                        html: instructions
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.instructions,
                        dangerouslySetInnerHTML: {
                            __html: instructions
                        }
                    })),
                    !instructions && hasDefaultInstructions && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.instructions,
                        children: defaultInstructions
                    })
                ]
            })
        ]
    }, section.id);
}
function sectionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '13pt',
            padding: '10px 20px',
            borderBottom: 'solid 1px #d0d5d8'
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 30,
            display: 'flex',
            flexDirection: 'column'
        },
        label: {
            fontWeight: 'bold',
            fontSize: '12pt',
            marginBottom: 40
        },
        instructions: {
            fontSize: '11pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lCGxZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../helpers/utils");
var _utils1 = require("./utils");
var _questionHandlers = require("./question-handlers");
var _questionHandlersDefault = parcelHelpers.interopDefault(_questionHandlers);
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question({ sections, context }) {
    const { questionId, sectionId, translate, quizQuestionTypes } = context;
    const assessmentLoaded = !context.quizSearch['assessment-to-take'];
    const classes = useStyles();
    const count = sections.reduce((a, b)=>a + b.questions.length, 0);
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const questionIndex = questionId && section ? section.questions.findIndex((q)=>q.id == questionId) : -1;
    const question = questionIndex >= 0 && section.questions[questionIndex];
    const { html } = question && question.premise || {};
    const premiseHtml = (0, _utils.isEmpty)(html) ? false : html;
    const type = quizQuestionTypes.find((t)=>t.id == question.type) || {};
    const title = translate(type.name);
    const globalIndex = (0, _utils1.findGlobalIndex)(question.id, sections);
    const indexLabel = `${translate('questions').substring(0, 1)}: ${globalIndex + 1}/${count}`;
    const Handler = (0, _questionHandlersDefault.default)[type.name];
    const defaultPremiseLabel = `${type.name}-default-premise`;
    const defaultPremise = translate(defaultPremiseLabel);
    const hasDefaultPremise = defaultPremiseLabel != defaultPremise;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.index,
                        children: indexLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    premiseHtml && (context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        className: classes.premise,
                        html: premiseHtml
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.premise,
                        dangerouslySetInnerHTML: {
                            __html: premiseHtml
                        }
                    })),
                    !premiseHtml && hasDefaultPremise && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.premise,
                        children: defaultPremise
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.question,
                        children: assessmentLoaded && Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                            context,
                            question,
                            section,
                            questionIndex
                        })
                    })
                ]
            })
        ]
    }, question.id);
}
function questionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '13pt',
            padding: '10px 20px',
            borderBottom: 'solid 1px #d0d5d8'
        },
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        index: {
            fontSize: '10pt',
            ...verticalCentering
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 30,
            display: 'flex',
            flexDirection: 'column'
        },
        premise: {
            fontWeight: 'bold',
            fontSize: '12pt',
            marginBottom: 20
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","../../../helpers/utils":"gGc98","./utils":"j9Vy3","./question-handlers":"dUUmX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dUUmX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trueOrFalse = require("./TrueOrFalse");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _fillInTheBlanks = require("./FillInTheBlanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _openQuestion = require("./OpenQuestion");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _multipleChoice = require("./MultipleChoice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _matching = require("./Matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'matching': (0, _matchingDefault.default)
};
exports.default = handlers;

},{"./TrueOrFalse":"ixPNY","./FillInTheBlanks":"jUd7a","./OpenQuestion":"il7Db","./MultipleChoice":"kwwAD","./Matching":"2sEIw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ixPNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
function TrueOrFalse({ context, section, question, questionIndex }) {
    const { translate, quizAssessmentToTake: assessment, assessment: assessmentId } = context;
    const answer = assessment.answers[question.id];
    async function handleChange(e) {
        const value = e.target.value == "true";
        const { quizAssessmentToTake: { answers } } = await context.updateState({
            quizAssessmentToTake: {
                answers: {
                    [question.id]: {
                        value: {
                            $set: value
                        },
                        completed: {
                            $set: true
                        }
                    }
                }
            }
        });
        context.saveAnswers({
            id: assessmentId,
            answers
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)("question", "true-or-false"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: (0, _clsxDefault.default)("answer"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
                className: "content",
                value: answer.value,
                onChange: handleChange,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                        value: true,
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                        label: translate('true')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                        value: false,
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                        label: translate('false')
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jUd7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanks);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(fillInTheBlanksStyles);
function FillInTheBlanks({ context, section, question, questionIndex }) {
    const classes = useStyles();
    const { translate, quizAssessmentToTake: assessment, assessment: assessmentId } = context;
    const answer = assessment.answers[question.id] || {};
    const { phrases = [] } = answer;
    function handlePhraseChange(index, phrase) {
        const completed = phrase.length == 0 ? false : phrases.every(({ phrase, blanked }, i)=>i == index || !blanked || phrase.length > 0);
        context.updateState({
            quizAssessmentToTake: {
                answers: {
                    [question.id]: {
                        phrases: {
                            [index]: {
                                phrase: {
                                    $set: phrase
                                }
                            }
                        },
                        completed: {
                            $set: completed
                        }
                    }
                }
            }
        });
    }
    function handleOnBlur() {
        context.saveAnswers({
            id: assessmentId,
            answers: assessment.answers
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: phrases.map(({ phrase, blanked }, index)=>blanked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                className: (0, _clsxDefault.default)(classes.input, classes.phrase),
                type: "text",
                value: phrase,
                onChange: (e)=>handlePhraseChange(index, e.target.value),
                onBlur: handleOnBlur
            }, index) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.phrase,
                children: phrase
            }, index))
    });
}
function fillInTheBlanksStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            padding: '35px 0',
            fontSize: '12pt'
        },
        phrase: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 10,
            '&:last-child': {
                marginLeft: 0
            }
        },
        input: {
            border: 'none',
            borderBottom: 'solid 1px black'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"il7Db":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
const useStyles = (0, _material.makeStyles)(openQuestionStyles);
function OpenQuestion({ context, section, question, questionIndex }) {
    const classes = useStyles();
    const { translate, quizAssessmentToTake: assessment, assessment: assessmentId } = context;
    const answer = assessment.answers[question.id];
    function handleChange(e) {
        const value = e.target.value;
        const completed = value.length > 0;
        context.updateState({
            quizAssessmentToTake: {
                answers: {
                    [question.id]: {
                        value: {
                            $set: value
                        },
                        completed: {
                            $set: completed
                        }
                    }
                }
            }
        });
    }
    function handleBlur() {
        context.saveAnswers({
            id: assessmentId,
            answers: assessment.answers
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
            className: classes.textarea,
            maxRows: 5,
            minRows: 5,
            value: answer.value,
            onKeyPress: ({ key })=>{
                key == 'Enter' && handleBlur();
            },
            onChange: handleChange,
            onBlur: handleBlur
        })
    });
}
function openQuestionStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column'
        },
        textarea: {
            resize: 'none',
            width: 'auto',
            padding: 8,
            flexGrow: 1,
            borderRadius: '4px',
            border: 'solid 1px #c2c7ca'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kwwAD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
const useStyles = (0, _material.makeStyles)(multipleChoiceStyles);
function MultipleChoice({ context, section, question, questionIndex }) {
    const classes = useStyles();
    const { translate, quizAssessmentToTake: assessment } = context;
    const answer = assessment.answers[question.id] || {};
    const { properties } = question;
    const choices = !properties.shuffle && question.answer.choices || answer.choices || [];
    const { selected = null, selectedOptions = [] } = answer;
    const Choices = question.properties.singleOption ? RadioChoice : CheckboxChoice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
            question: question,
            context: context,
            choices: choices,
            selected: selected,
            selectedOptions: selectedOptions
        })
    });
}
function RadioChoice({ context, question, choices, selected }) {
    const classes = useStyles();
    async function handleChange(e) {
        const value = e.target.value;
        const { assessment: assessmentId } = context;
        const { quizAssessmentToTake: { answers } } = await context.updateState({
            quizAssessmentToTake: {
                answers: {
                    [question.id]: {
                        selected: {
                            $set: value
                        },
                        completed: {
                            $set: true
                        }
                    }
                }
            }
        });
        context.saveAnswers({
            id: assessmentId,
            answers
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: selected,
        onChange: handleChange,
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.option,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.radio,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                        value: choice.id,
                        className: "choice",
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                            color: "primary"
                        }),
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.optionLabel,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: "index",
                                    children: [
                                        answerIndex,
                                        ")"
                                    ]
                                }),
                                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                                    className: "choice-caption",
                                    html: choice.html || ''
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "choice-caption",
                                    dangerouslySetInnerHTML: {
                                        __html: choice.html || ''
                                    }
                                })
                            ]
                        })
                    })
                })
            }, index);
        })
    });
}
function CheckboxChoice({ context, question, choices, selectedOptions }) {
    const classes = useStyles();
    const { assessment: assessmentId } = context;
    async function handleChange(id, checked) {
        const value = checked ? [
            ...selectedOptions,
            id
        ] : selectedOptions.filter((o)=>o != id);
        const completed = value.length > 0;
        const { quizAssessmentToTake: { answers } } = await context.updateState({
            quizAssessmentToTake: {
                answers: {
                    [question.id]: {
                        selectedOptions: {
                            $set: value
                        },
                        completed: {
                            $set: completed
                        }
                    }
                }
            }
        });
        context.saveAnswers({
            id: assessmentId,
            answers
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: choices.map((option, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.option,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.checkbox,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                            color: "primary",
                            checked: selectedOptions.indexOf(option.id) >= 0,
                            onChange: (e)=>handleChange(option.id, e.target.checked)
                        }),
                        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.optionLabel,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: "index",
                                    children: [
                                        answerIndex,
                                        ")"
                                    ]
                                }),
                                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                                    className: "choice-caption",
                                    html: option.html || ''
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "choice-caption",
                                    dangerouslySetInnerHTML: {
                                        __html: option.html || ''
                                    }
                                })
                            ]
                        })
                    })
                })
            }, index);
        })
    });
}
function multipleChoiceStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            paddingLeft: 10,
            fontSize: '12pt'
        },
        option: {
            display: 'flex'
        },
        optionLabel: {
            display: 'flex',
            "& > .index": {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                marginRight: 15
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@mui/material/FormGroup":"1gJha","@mui/material/Checkbox":"4sdMA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2sEIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Matching);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
const useStyles = (0, _material.makeStyles)(matchingStyles);
function Matching({ context, section, question, questionIndex }) {
    const classes = useStyles();
    const { translate, quizAssessmentToTake: assessment, assessment: assessmentId, saveAnswers } = context;
    const answer = assessment.answers[question.id] || {};
    async function handleChange(term, definition) {
        const selected = (0, _immutabilityHelperDefault.default)(answer.selected, {
            [answer.selected.indexOf(definition)]: {
                $set: -1
            },
            [term]: {
                $set: definition
            }
        });
        const completed = selected.find((i)=>i == -1) == undefined;
        const { quizAssessmentToTake: assessment } = await context.updateState({
            quizAssessmentToTake: {
                answers: {
                    [question.id]: {
                        completed: {
                            $set: completed
                        },
                        selected: {
                            $set: selected
                        }
                    }
                }
            }
        });
        context.saveAnswers({
            id: assessmentId,
            answers: assessment.answers
        });
    }
    const terms = answer.terms.map(({ term }, index)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.selectAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectDefinition, {
                        index: index,
                        definitions: answer.definitions,
                        onChange: handleChange,
                        value: answer.selected[index]
                    })
                }),
                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        html: term || ''
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    dangerouslySetInnerHTML: {
                        __html: term || ''
                    }
                })
            ]
        });
    });
    const definitions = answer.definitions.map(({ definition }, index)=>{
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionIndex, {
                        selected: answer.selected.indexOf(index) > -1
                    }),
                    size: "small",
                    children: [
                        answerIndex,
                        ")"
                    ]
                }),
                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        html: definition || ''
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    dangerouslySetInnerHTML: {
                        __html: definition || ''
                    }
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _boxDefault.default),
            className: classes.tableContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                className: classes.table,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: (0, _lodash.zip)(terms, definitions).map(([term, definition], index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            className: classes.pair,
                            children: [
                                term,
                                definition
                            ]
                        }, index);
                    })
                })
            })
        })
    });
}
function SelectDefinition(props) {
    const classes = useStyles();
    function handleChange(e) {
        props.onChange(props.index, e.target.value);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _selectDefault.default), {
        className: classes.termValue,
        value: props.value,
        onChange: handleChange,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                style: {
                    display: 'none'
                },
                value: -1,
                children: " "
            }),
            props.definitions.map((definition, index)=>{
                const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                    value: index,
                    children: answerIndex
                }, index);
            })
        ]
    });
}
function matchingStyles(theme) {
    return {
        root: {
            display: 'flex',
            marginTop: 10,
            flexGrow: 1
        },
        tableContainer: {
            flexShrink: 0,
            maxWidth: 1280,
            display: 'flex',
            fontSize: '12pt'
        },
        cell: {
            borderBottom: 0,
            padding: '16px 8px',
            verticalAlign: 'top'
        },
        correctAnswer: {
            width: 35,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 35
        },
        selectAnswer: {
            width: 45,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 45
        },
        definitionIndex: {
            width: 20,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 20
        },
        termValue: {
            border: 'solid 1px #e0e5e9',
            borderRadius: 3,
            paddingLeft: 8,
            justifyContent: 'center',
            '&:focus': {
                backgroundColor: 'transparent'
            },
            '&:before': {
                borderBottom: '0 !important'
            },
            '&:after': {
                borderBottom: 0
            }
        },
        termHtml: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        },
        definitionValue: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/Select":"aY7hn","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableRow":"4f4VX","@mui/material/Table":"if4Vw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fZ6E7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewResultsAssessment);
parcelHelpers.export(exports, "assessmentStyles", ()=>assessmentStyles);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _close = require("@mui/icons-material/Close");
var _closeDefault = parcelHelpers.interopDefault(_close);
var _utils = require("helpers/utils");
var _fullScreenDialog = require("components/FullScreenDialog");
var _fullScreenDialogDefault = parcelHelpers.interopDefault(_fullScreenDialog);
var _question = require("./Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
const useStyles = (0, _material.makeStyles)(assessmentStyles);
function PreviewResultsAssessment({ context, imported }) {
    const classes = useStyles();
    const { quizAssessmentResults: assessment, assessment: assessmentId, translate, link, quizTypesMap } = context;
    const { content = {}, results = {} } = assessment;
    const { title, type } = content;
    const assessmentLoaded = !context.quizSearch['assessment-results'];
    const typeName = translate(quizTypesMap[type]);
    const sections = assessment.assessmentId == assessmentId ? (0, _lodash.orderBy)(Object.values(content.sections || {}), 'index') : [];
    const questions = sections.reduce((questions, section, sectionIndex)=>{
        return questions.concat(section.questions.map((q)=>({
                ...q,
                sectionId: section.id
            })));
    }, []);
    const { points, total } = Object.values(results).reduce((acc, { points, total })=>({
            total: acc.total + total,
            points: acc.points + points
        }), {
        total: 0,
        points: 0
    });
    const percentageText = `${Math.round(points / total * 100)}%`;
    const pointsText = `${translate('points')}: ${(0, _utils.toDisplayPoints)(points)} ${translate('of')} ${(0, _utils.toDisplayPoints)(total)}`;
    const closeLink = imported ? imported.closeLink : link({
        action: 'preview',
        sectionId: undefined,
        questionId: undefined
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenDialogDefault.default), {
        open: assessmentLoaded,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.root,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.header,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.pointsWrapper,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.label,
                                    children: translate('preview-results-header')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.percentage,
                                    children: percentageText
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.points,
                                    children: pointsText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.rightWrapper,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.buttonWrapper,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                        className: (0, _clsxDefault.default)(classes.button, classes.close),
                                        to: closeLink,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeDefault.default), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                                className: "label",
                                                children: translate('close')
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.filler
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: classes.notice,
                                    children: translate('questions-not-autograded-notice')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.preview,
                    children: questions.map((question, globalIndex)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.question,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionDefault.default), {
                                globalIndex,
                                context,
                                sections,
                                question
                            })
                        }, question.id))
                })
            ]
        })
    });
}
function assessmentStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflowY: 'hidden'
        },
        header: {
            padding: '10px 20px 10px 10px',
            display: 'flex',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start'
            }
        },
        pointsWrapper: {
            flexGrow: 1
        },
        label: {
            color: '#4d5361',
            fontSize: '13pt',
            fontWeight: 'bold'
        },
        percentage: {
            marginTop: 5,
            fontSize: '50pt',
            color: '#df7317'
        },
        points: {
            color: '#4d5361',
            fontSize: '10pt'
        },
        notice: {
            color: '#4d5361',
            fontSize: '10pt'
        },
        filler: {
            flexGrow: 1
        },
        buttonWrapper: {
            display: 'flex',
            justifyContent: 'flex-end'
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px 7px 12px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {}
        },
        close: {
            marginLeft: 20,
            '& .icon': {
                marginTop: -3,
                marginRight: 3,
                fontSize: '8pt'
            }
        },
        preview: {
            display: 'flex',
            flexDirection: 'column',
            padding: 10,
            flexGrow: 1,
            overflowY: 'auto'
        },
        question: {
            marginTop: 20,
            border: 'solid 1px #ccc',
            borderRadius: 2,
            backgroundColor: '#fff',
            '&:first-child': {
                marginTop: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Fade":"8DwqP","@mui/material/Box":"73kto","@mui/icons-material/Close":"acjz6","helpers/utils":"gGc98","components/FullScreenDialog":"cr6Y6","./Question":"3uXbe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3uXbe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Question);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textField = require("@mui/material/TextField");
var _textFieldDefault = parcelHelpers.interopDefault(_textField);
var _utils = require("../../../helpers/utils");
var _questionHandlers = require("./question-handlers");
var _questionHandlersDefault = parcelHelpers.interopDefault(_questionHandlers);
var _command = require("../../../helpers/command");
const useStyles = (0, _material.makeStyles)(questionStyles);
function Question({ question, sections, context, globalIndex }) {
    const { id: questionId, sectionId } = question;
    const { translate, quizQuestionTypes, quizAssessmentResults: assessment } = context;
    const classes = useStyles();
    const assessmentLoaded = !context.quizSearch['assessment-results'];
    const { results = {} } = assessment;
    const result = results[questionId] || {};
    const count = sections.reduce((a, b)=>a + b.questions.length, 0);
    const sectionIndex = sections.findIndex((s)=>s.id == sectionId);
    const section = sectionIndex >= 0 && sections[sectionIndex];
    const questionIndex = questionId && section ? section.questions.findIndex((q)=>q.id == questionId) : -1;
    const { html } = question && question.premise || {};
    const premiseHtml = (0, _utils.isEmpty)(html) ? false : html;
    const type = quizQuestionTypes.find((t)=>t.id == question.type) || {};
    const title = translate(type.name);
    const indexLabel = `${translate('questions').substring(0, 1)}: ${globalIndex + 1}/${count}`;
    const Handler = (0, _questionHandlersDefault.default)[type.name];
    const defaultPremiseLabel = `${type.name}-default-premise`;
    const defaultPremise = translate(defaultPremiseLabel);
    const hasDefaultPremise = defaultPremiseLabel != defaultPremise;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.header,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.title,
                        children: [
                            title,
                            [
                                'fill-in-the-blanks',
                                'open-question'
                            ].indexOf(type.name) >= 0 ? '*' : ''
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.index,
                        children: indexLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    premiseHtml && (context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        className: classes.premise,
                        html: premiseHtml
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: classes.premise,
                        dangerouslySetInnerHTML: {
                            __html: premiseHtml
                        }
                    })),
                    !premiseHtml && hasDefaultPremise && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.premise,
                        children: defaultPremise
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.question,
                        children: assessmentLoaded && Handler && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Handler, {
                            context,
                            question,
                            section,
                            questionIndex
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.pointsSection,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.points,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: "label",
                            children: [
                                translate('points'),
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: "value",
                            children: [
                                (0, _utils.toDisplayPoints)(result.points),
                                " ",
                                translate('of'),
                                " ",
                                result.total
                            ]
                        })
                    ]
                })
            })
        ]
    }, question.id);
}
function questionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            color: '#525b6c'
        },
        header: {
            display: 'flex',
            fontSize: '12pt',
            padding: '10px 20px',
            borderBottom: 'solid 1px #d0d5d8'
        },
        pointsSection: {
            display: 'flex',
            padding: '10px 20px',
            fontSize: '11pt',
            color: '#485160',
            backgroundColor: '#edf3ff',
            borderBottom: 'solid 1px #bedbe9',
            '& .label': {
                marginRight: 3
            },
            '& > div': {
                display: 'flex',
                '& > div': {
                    ...verticalCentering
                },
                '&:first-child': {
                    flexGrow: 1
                }
            }
        },
        button: {
            textDecoration: 'none',
            color: '#fff',
            display: 'flex',
            padding: '7px 15px',
            backgroundColor: '#2ca5ec',
            borderRadius: 3,
            '& >div': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .label': {
                fontSize: '13pt'
            },
            cursor: 'pointer',
            '&:hover': {}
        },
        grant: {
            marginLeft: 20
        },
        points: {},
        question: {
            display: 'flex',
            flexGrow: 1
        },
        title: {
            flexGrow: 1,
            ...verticalCentering
        },
        index: {
            fontSize: '10pt',
            ...verticalCentering
        },
        content: {
            flexGrow: 1,
            overflowY: 'auto',
            padding: 30,
            display: 'flex',
            flexDirection: 'column'
        },
        premise: {
            fontWeight: 'bold',
            fontSize: '12pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextField":"amnzu","../../../helpers/utils":"gGc98","./question-handlers":"eGzxn","../../../helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eGzxn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trueOrFalse = require("./TrueOrFalse");
var _trueOrFalseDefault = parcelHelpers.interopDefault(_trueOrFalse);
var _fillInTheBlanks = require("./FillInTheBlanks");
var _fillInTheBlanksDefault = parcelHelpers.interopDefault(_fillInTheBlanks);
var _openQuestion = require("./OpenQuestion");
var _openQuestionDefault = parcelHelpers.interopDefault(_openQuestion);
var _multipleChoice = require("./MultipleChoice");
var _multipleChoiceDefault = parcelHelpers.interopDefault(_multipleChoice);
var _matching = require("./Matching");
var _matchingDefault = parcelHelpers.interopDefault(_matching);
const handlers = {
    'true-or-false': (0, _trueOrFalseDefault.default),
    'fill-in-the-blanks': (0, _fillInTheBlanksDefault.default),
    'open-question': (0, _openQuestionDefault.default),
    'multiple-choice': (0, _multipleChoiceDefault.default),
    'matching': (0, _matchingDefault.default)
};
exports.default = handlers;

},{"./TrueOrFalse":"61PNl","./FillInTheBlanks":"4lROb","./OpenQuestion":"j8W9s","./MultipleChoice":"8f2uE","./Matching":"iToBZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61PNl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TrueOrFalse);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(trueOrFalseStyles);
function TrueOrFalse({ context, section, question, questionIndex }) {
    const classes = useStyles();
    const { quizAssessmentResults: assessment, translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    const correct = question.answer.value == answer.value;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _radioGroupDefault.default), {
            className: "content",
            value: answer.value,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: true,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: true,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('true')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                    className: classes.option,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                            value: false,
                            answer: answer.value,
                            correctAnswer: question.answer.value
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: classes.radio,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                                value: false,
                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {}),
                                label: translate('false')
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function trueOrFalseStyles(theme) {
    return {
        root: {},
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/Fade":"8DwqP","@mui/material/FormControlLabel":"kemIW","../StatusIcon":"7MvYe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7MvYe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StatusIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
const useStyles = (0, _material.makeStyles)(statusIconStyles);
function StatusIcon({ value, answer, correctAnswer }) {
    const classes = useStyles();
    function getStatus() {
        if (value != correctAnswer && value == answer) return 'incorrect';
        if (value == correctAnswer && value == answer) return 'correct';
        if (value == correctAnswer && value != answer) return 'mark';
        return 'dummy';
    }
    const status = getStatus();
    const icon = {
        incorrect: (0, _freeSolidSvgIcons.faTimesCircle),
        correct: (0, _freeSolidSvgIcons.faCheckCircle),
        mark: (0, _freeSolidSvgIcons.faArrowAltCircleRight),
        dummy: (0, _freeSolidSvgIcons.faTimesCircle)
    }[status];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, status),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
            icon: icon
        })
    });
}
function statusIconStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: "#fff",
            marginRight: 20,
            fontSize: '20px',
            '&.dummy': {
                visibility: 'hidden'
            },
            '&.mark': {
                '& svg': {
                    color: '#18d0da'
                }
            },
            '&.incorrect': {
                '& svg': {
                    color: '#dd2229'
                }
            },
            '&.correct': {
                '& svg': {
                    color: '#39c55a'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/Box":"73kto","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4lROb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FillInTheBlanks);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(fillInTheBlanksStyles);
function FillInTheBlanks({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentResults: assessment, translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.wrapper,
                    children: answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                            className: (0, _clsxDefault.default)(classes.phrase, {
                                blanked
                            }),
                            children: phrase
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.wrapper,
                        children: question.answer.phrases.map(({ phrase, blanked }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: (0, _clsxDefault.default)(classes.phrase, {
                                    blanked
                                }),
                                children: phrase
                            }, index))
                    })
                ]
            })
        ]
    });
}
function fillInTheBlanksStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            padding: '35px 0',
            fontSize: '12pt',
            "& .label": {
                display: "flex",
                marginBottom: 10,
                fontWeight: 'bold',
                '& > div': {
                    ...verticalCentering
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        correctAnswer: {
            marginTop: 30
        },
        wrapper: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        phrase: {
            ...verticalCentering,
            marginRight: 10,
            '&:last-child': {
                marginLeft: 0
            },
            '&.blanked': {
                borderBottom: 'solid 1px black'
            }
        },
        input: {
            border: 'none',
            borderBottom: 'solid 1px black'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j8W9s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>OpenQuestion);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _textareaAutosize = require("@mui/material/TextareaAutosize");
var _textareaAutosizeDefault = parcelHelpers.interopDefault(_textareaAutosize);
var _utils = require("../../../../helpers/utils");
var _checkCircle = require("@mui/icons-material/CheckCircle");
var _checkCircleDefault = parcelHelpers.interopDefault(_checkCircle);
const useStyles = (0, _material.makeStyles)(openQuestionStyles);
function OpenQuestion({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentResults: assessment, translate } = context;
    const expected = (0, _utils.htmlToText)(question.answer.html);
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.studentAnswer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                    className: classes.textarea,
                    maxRows: 5,
                    minRows: 5,
                    value: answer.value,
                    readOnly: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.correctAnswer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: "label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.correct,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkCircleDefault.default), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                children: translate('expected-answer')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textareaAutosizeDefault.default), {
                        className: classes.textarea,
                        maxRows: 5,
                        minRows: 5,
                        value: expected,
                        readOnly: true
                    })
                ]
            })
        ]
    });
}
function openQuestionStyles(theme) {
    const verticalCentering = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    };
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            paddingBottom: 20,
            flexDirection: 'column',
            '& > div': {
                display: 'flex',
                flexDirection: 'column',
                '&:last-child': {
                    marginTop: 20
                },
                '& .label': {
                    display: "flex",
                    marginBottom: 10,
                    fontWeight: 'bold',
                    '& > div': {
                        ...verticalCentering
                    }
                }
            }
        },
        correct: {
            marginRight: 5,
            '& svg': {
                fill: '#27bc58'
            }
        },
        textarea: {
            resize: 'none',
            width: 'auto',
            padding: 8,
            flexGrow: 1,
            borderRadius: '4px',
            border: 'solid 1px #c2c7ca'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TextareaAutosize":"9RmQq","../../../../helpers/utils":"gGc98","@mui/icons-material/CheckCircle":"crtKq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8f2uE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleChoice);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _radio = require("@mui/material/Radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioGroup = require("@mui/material/RadioGroup");
var _radioGroupDefault = parcelHelpers.interopDefault(_radioGroup);
var _formControlLabel = require("@mui/material/FormControlLabel");
var _formControlLabelDefault = parcelHelpers.interopDefault(_formControlLabel);
var _formGroup = require("@mui/material/FormGroup");
var _formGroupDefault = parcelHelpers.interopDefault(_formGroup);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(multipleChoiceStyles);
function MultipleChoice({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentResults: assessment, translate } = context;
    const { properties: { singleOption } } = question;
    const { choices = [] } = question.answer;
    const Choices = singleOption ? RadioChoice : CheckboxChoice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: choices.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Choices, {
            question: question,
            context: context,
            choices: choices,
            answer: assessment.answers[question.id]
        })
    });
}
function RadioChoice({ context, choices, answer }) {
    const classes = useStyles();
    const correctChoice = choices.find((c)=>c.correct) || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "radio"),
        value: answer.selected,
        children: choices.map((choice, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: choice.id,
                        answer: answer.selected,
                        correctAnswer: correctChoice.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.radio,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            value: choice.id,
                            className: "choice",
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioDefault.default), {
                                color: "primary"
                            }),
                            label: context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                                className: "choice-caption",
                                html: choice.html || ''
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: choice.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function CheckboxChoice({ context, question, choices, answer }) {
    const classes = useStyles();
    const { assessment } = context;
    const correct = (0, _lodash.difference)(choices.filter((c)=>c.correct).map((c)=>c.id), answer.selectedOptions).length == 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formGroupDefault.default), {
        className: (0, _clsxDefault.default)("choices", "checkbox"),
        children: choices.map((option, index)=>{
            const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
            const checked = answer.selectedOptions.indexOf(option.id) >= 0;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.option,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: option.id,
                        answer: checked && option.id,
                        correctAnswer: option.correct && option.id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                        className: classes.index,
                        children: [
                            answerIndex,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.checkbox,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formControlLabelDefault.default), {
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                color: "primary",
                                checked: checked
                            }),
                            label: context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                                className: "choice-caption",
                                html: option.html || ''
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "choice-caption",
                                dangerouslySetInnerHTML: {
                                    __html: option.html || ''
                                }
                            })
                        })
                    })
                ]
            }, index);
        })
    });
}
function multipleChoiceStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
            paddingLeft: 10,
            fontSize: '12pt'
        },
        index: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 6
        },
        incorrect: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            visibility: 'hidden',
            color: "#fff",
            marginRight: 10,
            '& svg': {
                fill: '#f30d2a'
            },
            '&.visible': {
                visibility: 'visible'
            }
        },
        correct: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '& svg': {
                fill: '#27bc58'
            },
            marginRight: 10,
            visibility: 'hidden',
            '&.visible': {
                visibility: 'visible'
            }
        },
        option: {
            display: 'flex'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Radio":"bneRF","@mui/material/RadioGroup":"9W1hX","@mui/material/FormControlLabel":"kemIW","@mui/material/FormGroup":"1gJha","@mui/material/Checkbox":"4sdMA","../StatusIcon":"7MvYe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iToBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Matching);
var _jsxRuntime = require("react/jsx-runtime");
var _mathHtml = require("components/imported-assessment/MathHtml");
var _mathHtmlDefault = parcelHelpers.interopDefault(_mathHtml);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _statusIcon = require("../StatusIcon");
var _statusIconDefault = parcelHelpers.interopDefault(_statusIcon);
const useStyles = (0, _material.makeStyles)(matchingStyles);
function Matching({ context, question }) {
    const classes = useStyles();
    const { quizAssessmentResults: assessment, translate } = context;
    const { answers = {} } = assessment;
    const answer = answers[question.id] || {};
    const terms = answer.terms.map((term, index)=>{
        const value = answer.selected[index];
        const correctIndex = answer.definitions.findIndex((d)=>d.index == term.index);
        const indexToLetter = (index)=>String.fromCharCode(Math.min(index, 20) + 97);
        const answerIndex = indexToLetter(correctIndex);
        const correct = correctIndex == value;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.correctAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: (0, _clsxDefault.default)(classes.correct, {
                            correct
                        }),
                        children: answerIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    align: "left",
                    className: (0, _clsxDefault.default)(classes.cell, classes.status),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusIconDefault.default), {
                        value: value,
                        answer: value,
                        correctAnswer: correctIndex
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.selectAnswer),
                    size: "small",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                        className: classes.answer,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                            className: classes.termValue,
                            inputProps: {
                                readOnly: true
                            },
                            value: value,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                value: value,
                                children: value >= 0 ? indexToLetter(value) : ''
                            })
                        })
                    })
                }),
                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        html: term.term || ''
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.termHtml),
                    dangerouslySetInnerHTML: {
                        __html: term.term || ''
                    }
                })
            ]
        });
    });
    const definitions = answer.definitions.map(({ definition }, index)=>{
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionIndex, {
                        selected: answer.selected.indexOf(index) > -1
                    }),
                    size: "small",
                    children: [
                        answerIndex,
                        ")"
                    ]
                }),
                context.importedMath ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mathHtmlDefault.default), {
                        html: definition || ''
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: (0, _clsxDefault.default)(classes.cell, classes.definitionValue),
                    dangerouslySetInnerHTML: {
                        __html: definition || ''
                    }
                })
            ]
        });
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            component: (0, _boxDefault.default),
            className: classes.tableContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableDefault.default), {
                className: classes.table,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
                    children: (0, _lodash.zip)(terms, definitions).map(([term, definition], index)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                            className: classes.pair,
                            children: [
                                term,
                                definition
                            ]
                        }, index);
                    })
                })
            })
        })
    });
}
function matchingStyles(theme) {
    return {
        root: {
            display: 'flex',
            marginTop: 10,
            flexGrow: 1
        },
        tableContainer: {
            flexShrink: 0,
            maxWidth: 1280,
            display: 'flex',
            fontSize: '12pt'
        },
        correct: {
            display: 'flex',
            width: 35,
            height: 35,
            borderRadius: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            color: '#fff',
            backgroundColor: '#0bccd5',
            '&.correct': {
                visibility: 'hidden'
            }
        },
        cell: {
            borderBottom: 0,
            padding: '16px 8px',
            verticalAlign: 'top'
        },
        correctAnswer: {
            width: 35,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 35
        },
        status: {
            width: 30,
            maxWidth: 30,
            flexGrow: 0,
            flexShrink: 0,
            paddingTop: 22
        },
        selectAnswer: {
            width: 45,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 45
        },
        definitionIndex: {
            width: 20,
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 20
        },
        table: {
            maxWidth: 1280
        },
        term: {
            display: 'flex'
        },
        termValue: {
            border: 'solid 1px #e0e5e9',
            borderRadius: 3,
            paddingLeft: 8,
            justifyContent: 'center',
            '&:focus': {
                backgroundColor: 'transparent'
            },
            '&:before': {
                borderBottom: '0 !important'
            },
            '&:after': {
                borderBottom: 0
            }
        },
        termHtml: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        },
        definitionValue: {
            paddingLeft: 20,
            '& > p': {
                margin: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","components/imported-assessment/MathHtml":"cDby1","immutability-helper":"hwjCt","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@mui/material/TableBody":"bPEEy","@mui/material/TableCell":"8Htaw","@mui/material/TableContainer":"2Kmn7","@mui/material/TableRow":"4f4VX","@mui/material/Table":"if4Vw","@mui/material/Select":"aY7hn","../StatusIcon":"7MvYe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kIwf6":[function() {},{}],"jgfW1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ImportedTeacherTest);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _take = require("components/quiz/take");
var _takeDefault = parcelHelpers.interopDefault(_take);
var _paper = require("@mui/material/Paper");
var _paperDefault = parcelHelpers.interopDefault(_paper);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _fullScreenDialog = require("components/FullScreenDialog");
var _fullScreenDialogDefault = parcelHelpers.interopDefault(_fullScreenDialog);
var _section = require("components/quiz/take/Section");
var _sectionDefault = parcelHelpers.interopDefault(_section);
var _preview = require("components/quiz/preview");
var _previewDefault = parcelHelpers.interopDefault(_preview);
var _previewResults = require("components/quiz/preview-results");
var _previewResultsDefault = parcelHelpers.interopDefault(_previewResults);
var _question = require("components/quiz/take/Question");
var _questionDefault = parcelHelpers.interopDefault(_question);
var _command = require("helpers/command");
const getTest = (0, _command.createPost)('quiz', 'getImportedAssessmentTest');
const startTest = (0, _command.createPost)('quiz', 'startImportedAssessmentTest');
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const saveTest = (0, _command.createPost)('quiz', 'saveImportedAssessmentTestAnswers');
function ImportedTeacherTest({ context }) {
    const history = (0, _reactRouterDom.useHistory)();
    const location = (0, _reactRouterDom.useLocation)();
    const [attempt, setAttempt] = (0, _reactDefault.default).useState(null);
    const [answers, setAnswers] = (0, _reactDefault.default).useState({});
    const [position, setPosition] = (0, _reactDefault.default).useState(0);
    const stageParam = new URLSearchParams(location.search).get('stage');
    const stage = [
        'take',
        'results'
    ].includes(stageParam) ? stageParam : 'preview';
    const [error, setError] = (0, _reactDefault.default).useState('');
    const [saving, setSaving] = (0, _reactDefault.default).useState(false);
    const [starting, setStarting] = (0, _reactDefault.default).useState(false);
    const id = context.attemptId;
    (0, _reactDefault.default).useEffect(()=>{
        const n = Number(new URLSearchParams(location.search).get('previewPosition') || 0);
        if (Number.isInteger(n) && n >= 0) setPosition(n);
    }, [
        location.search
    ]);
    (0, _reactDefault.default).useEffect(()=>{
        let active = true;
        setAttempt(null);
        setError('');
        setPosition(0);
        getTest({
            id
        }).then((result)=>{
            if (!active) return;
            const data = Array.isArray(result) ? result[0] : result;
            if (!data || data.id !== id) throw new Error('Attempt not found');
            setAttempt(data);
            setAnswers(Object.values(data.content && data.content.sections || {}).reduce((all, section)=>{
                (section.questions || []).forEach((question)=>{
                    all[question.id] = (data.answers || {})[question.id] || {};
                });
                return all;
            }, {}));
        }).catch(()=>{
            if (active) setError('Unable to load imported assessment preview.');
        });
        return ()=>{
            active = false;
        };
    }, [
        id
    ]);
    const sourceId = new URLSearchParams(location.search).get('sourceId') || attempt && attempt.assessmentId;
    const back = new URLSearchParams(location.search).get('returnTo') || location.state && location.state.back;
    const returnTo = back && back.startsWith('/') && !back.startsWith('//') ? back : `/${context.languageId}/${context.role}/my-courses`;
    const route = (stageName, index = 0, attemptId = id)=>`/${context.languageId}/${context.role}/quiz/imported-test/${attemptId}?stage=${stageName}&previewPosition=${index}&sourceId=${encodeURIComponent(sourceId || '')}&returnTo=${encodeURIComponent(returnTo)}`;
    async function startFreshTest() {
        if (starting) return;
        if (!sourceId || !uuid.test(sourceId)) {
            setError('Imported assessment source unavailable. Reopen from the lesson.');
            return;
        }
        setStarting(true);
        setError('');
        try {
            const response = await startTest({
                id: sourceId
            });
            const newId = Array.isArray(response) ? response[0] : response;
            if (typeof newId !== 'string' || !uuid.test(newId) || newId === id) throw new Error('Unable to create a new attempt');
            history.replace(route('take', 0, newId));
        } catch (e) {
            setError('Unable to start a fresh imported assessment test.');
        } finally{
            setStarting(false);
        }
    }
    const close = ()=>history.push(returnTo);
    const content = attempt && attempt.content || {};
    const sections = (0, _lodash.orderBy)(Object.values(content.sections || {}).map((section)=>({
            ...section,
            questions: (0, _lodash.orderBy)(section.questions || [], 'index')
        })), 'index');
    const pages = sections.flatMap((section)=>[
            {
                section,
                question: null
            },
            ...section.questions.map((question)=>({
                    section,
                    question
                }))
        ]);
    const current = pages[position];
    const readOnly = Boolean(attempt && attempt.finished);
    const previewContext = {
        ...context,
        importedMath: true,
        assessment: id,
        quizAssessment: {
            id,
            title: content.title,
            type: content.type,
            owned: true
        },
        quizSections: sections,
        quizQuestions: Object.fromEntries(sections.map((section)=>[
                section.id,
                section.questions
            ])),
        quizSearch: {
            assessment: false
        },
        sectionId: current && current.section.id,
        questionId: current && current.question && current.question.id,
        link: ({ sectionId, questionId } = {})=>{
            const target = pages.findIndex((page)=>page.section.id === (sectionId || current && current.section.id) && (page.question ? page.question.id : null) === (questionId || null));
            return route('preview', target < 0 ? 0 : target);
        }
    };
    // The legacy question controls expect the same updateState/saveAnswers contract as TakeAssessment.
    const adapter = {
        ...context,
        importedMath: true,
        assessment: id,
        sectionId: current && current.section.id,
        questionId: current && current.question && current.question.id,
        quizAssessmentToTake: {
            ...attempt,
            assessmentId: id,
            content,
            answers
        },
        quizSearch: {
            'assessment-to-take': false
        },
        link: ({ sectionId, questionId } = {})=>{
            const target = pages.findIndex((page)=>page.section.id === (sectionId || current && current.section.id) && (page.question ? page.question.id : null) === (questionId || null));
            return route('take', target < 0 ? 0 : target);
        },
        updateState: async (patch)=>{
            const changes = patch.quizAssessmentToTake && patch.quizAssessmentToTake.answers || {};
            const next = {
                ...answers
            };
            Object.entries(changes).forEach(([questionId, fields])=>{
                const updated = {
                    ...next[questionId] || {}
                };
                Object.entries(fields).forEach(([key, instruction])=>{
                    if (instruction && Object.prototype.hasOwnProperty.call(instruction, '$set')) updated[key] = instruction.$set;
                });
                next[questionId] = updated;
            });
            setAnswers(next);
            return {
                quizAssessmentToTake: {
                    answers: next
                }
            };
        },
        saveAnswers: async ({ answers: next })=>{
            if (readOnly) return;
            setSaving(true);
            try {
                const response = await saveTest({
                    id,
                    answers: next,
                    finalize: false
                });
                if ((Array.isArray(response) ? response[0] : response) !== id) throw new Error('Save rejected');
            } catch (e) {
                setError('Unable to save answers.');
            } finally{
                setSaving(false);
            }
        }
    };
    async function finalize() {
        setSaving(true);
        setError('');
        try {
            const response = await saveTest({
                id,
                answers,
                finalize: true
            });
            if ((Array.isArray(response) ? response[0] : response) !== id) throw new Error('Finalize rejected');
            const result = await getTest({
                id
            });
            const updated = Array.isArray(result) ? result[0] : result;
            if (!updated || !updated.finished) throw new Error('Finalization not confirmed');
            setAttempt(updated);
            history.replace(route('results', 0));
            return updated;
        } catch (e) {
            setError('Unable to finalize assessment.');
            throw e;
        } finally{
            setSaving(false);
        }
    }
    if (attempt && stage === 'results') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewResultsDefault.default), {
        context: {
            ...context,
            importedMath: true,
            assessment: id,
            quizAssessmentResults: {
                ...attempt,
                assessmentId: id
            },
            quizSearch: {
                'assessment-results': false
            }
        },
        imported: {
            closeLink: route('preview', 0)
        }
    });
    if (attempt && stage === 'preview') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _previewDefault.default), {
        context: previewContext,
        imported: {
            onStart: startFreshTest,
            closeLink: returnTo
        }
    });
    if (attempt && stage === 'take') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _takeDefault.default), {
        context: adapter,
        imported: {
            saveAnswers: adapter.saveAnswers,
            finalize,
            readOnly,
            closeLink: route('preview', 0)
        }
    }, id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenDialogDefault.default), {
        open: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            sx: {
                padding: 3
            },
            children: [
                error ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    role: "alert",
                    children: error
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    role: "status",
                    children: "Loading imported assessment\u2026"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                    onClick: close,
                    children: "Close"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","lodash":"1qc47","@mui/material/Box":"73kto","components/quiz/take":"68nQ9","@mui/material/Paper":"arHf6","@mui/material/Button":"c6Y0y","components/FullScreenDialog":"cr6Y6","components/quiz/take/Section":"1FMzs","components/quiz/preview":"isGfC","components/quiz/preview-results":"fZ6E7","components/quiz/take/Question":"lCGxZ","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dW4vs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradingPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _grading = require("../../components/grading");
var _gradingDefault = parcelHelpers.interopDefault(_grading);
var _context = require("../../context");
var _gradingStyl = require("./grading.styl");
function GradingPage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradingDefault.default), {
                context: context
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../components/grading":"h1M49","../../context":"iUP37","./grading.styl":"3bxKy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h1M49":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Grading);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _linearProgress = require("@mui/material/LinearProgress");
var _linearProgressDefault = parcelHelpers.interopDefault(_linearProgress);
var _url = require("../../helpers/url");
const domains = {
    development: 'http://localhost:8896',
    staging: `//${(0, _url.subdomainResource)('staging-grading')}`,
    production: `//${(0, _url.subdomainResource)('grading')}`
};
const domain = domains[0, _url.environment] || domains.development;
function makeGradingUrl(languageId, path) {
    return `${domain}/#/${languageId}/${path}`;
}
const useStyles = (0, _material.makeStyles)(gradingStyles);
function Grading({ context }) {
    const classes = useStyles();
    const { profile, grading, languageId } = context;
    const { periods, summaries } = grading;
    const { project } = profile.institution;
    const loading = !periods.initialized && periods.loading || !summaries.initialized && summaries.loading;
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Loader, {});
    const pendingSchoolYearSetup = !periods.currentYear;
    let src = '';
    if (pendingSchoolYearSetup && project == 'homescholer') src = makeGradingUrl(languageId, 'periods/create-periods');
    else if (pendingSchoolYearSetup) src = makeGradingUrl(languageId, 'pending-setup');
    else src = makeGradingUrl(languageId, `book/${periods.currentYear.id}`);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
            className: classes.iframe,
            src: src
        })
    });
}
function Loader() {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linearProgressDefault.default), {})
    });
}
function gradingStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            margin: 20,
            padding: 0,
            backgroundColor: '#fff',
            color: '#4f576e'
        },
        iframe: {
            flexGrow: 1,
            border: 0
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/LinearProgress":"a9Qej","../../helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3bxKy":[function() {},{}],"73fA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Assessment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _assessment = require("../../components/assessment");
var _assessmentDefault = parcelHelpers.interopDefault(_assessment);
var _assessmentStyl = require("./assessment.styl");
function Assessment() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assessmentDefault.default), {});
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../../components/assessment":"czwep","./assessment.styl":"8wm7r","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czwep":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _context = require("../../context");
var _utils = require("../../helpers/utils");
var _url = require("../../helpers/url");
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _contextLoader = require("../context-loader");
var _contextLoaderDefault = parcelHelpers.interopDefault(_contextLoader);
var _searchPattern = require("../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _pagination = require("../pagination");
var _url1 = require("helpers/url");
var _assessmentStyl = require("./assessment.styl");
const { columns, headers } = (0, _columnsDefault.default);
const Layout = ({ Table, Pagination, Filter })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "assessments-search-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
        ]
    });
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "assessments_search_no_results_label"
        })
    });
}
class Assessments extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        (0, _utils.bind)(this, 'goPage', 'goNext', 'goPrevious');
    }
    goPage(page) {
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                page
            }
        });
    }
    goNext() {
        const page = this.context.query.page ? Number.parseInt(this.context.query.page) : 1;
        this.goPage(page + 1);
    }
    goPrevious() {
        const page = this.context.query.page ? Number.parseInt(this.context.query.page) : 1;
        this.goPage(page - 1);
    }
    render() {
        const context = this.context;
        const { query, assessmentView, assessmentCount, languageId } = context;
        const pageProperties = {
            currentPage: query.page ? Number.parseInt(query.page) : 1,
            pageSize: query.pageSize || 8,
            recordCount: assessmentCount
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextLoaderDefault.default), {
            id: "assessmentView",
            className: "assessments",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                className: "create-assessment",
                                ...(0, _url1.viewerGuard)({
                                    target: "_blank",
                                    href: (0, _url.subdomainLink)('assessment', languageId, 'create')
                                }),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-wrapper"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "create_assessment_label"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                                initialPattern: context.query.pattern
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "assessments-search-results",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                            data: assessmentView,
                            components: {
                                NoResults,
                                PageDropdown: (0, _pagination.PageDropdown),
                                Pagination: (0, _pagination.Pagination),
                                Layout,
                                Filter: (0, _filtersDefault.default)
                            },
                            pageProperties: pageProperties,
                            events: {
                                onNext: this.goNext,
                                onPrevious: this.goPrevious,
                                onGetPage: this.goPage
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "name",
                                        customHeadingComponent: headers.AssessmentHeader,
                                        customComponent: columns.TitleColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "course",
                                        customHeadingComponent: headers.AssessmentHeader,
                                        customComponent: columns.CourseColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "template_type",
                                        customHeadingComponent: headers.AssessmentHeader,
                                        customComponent: columns.TypeColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "randomize",
                                        customHeadingComponent: headers.AssessmentHeader,
                                        customComponent: columns.RandomizeColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "links",
                                        customHeadingComponent: headers.EmptyHeader,
                                        customComponent: columns.AssessmentLinksColumn
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        });
    }
}
exports.default = Assessments;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","griddle-react":"6zdUV","../../context":"iUP37","../../helpers/utils":"gGc98","../../helpers/url":"65SQD","../icon":"82gpi","../context-loader":"ktxlD","../search-pattern":"lUZFT","./columns":"b6OmO","./filters":"d0AWo","../pagination":"82vF6","helpers/url":"65SQD","./assessment.styl":"7GNU7","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b6OmO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _links = require("./links");
var _linksDefault = parcelHelpers.interopDefault(_links);
var _context = require("../../context");
var _post = require("../../context/post");
var _utils = require("../../helpers/utils");
function AssessmentHeader({ title }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: `${title}_assessment_header`
        })
    });
}
function EmptyHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
}
function TitleColumn({ rowData }) {
    const { name, assigned } = rowData;
    const assignedClass = `name${assigned ? ' assigned' : ''}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: assignedClass,
        title: name,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bullet"
            }),
            name
        ]
    });
}
function CourseColumn({ value }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const course = context.myCourses.find((i)=>i.course == value);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "course-name",
                children: course && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: course.courseName
                })
            });
        }
    });
}
function TypeColumn({ value }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const type = context.templateTypes.find((i)=>i.id == value);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "template-type",
                children: type && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: type.name
                })
            });
        }
    });
}
function RandomizeColumn({ value, rowData }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { assessmentViewUpdates } = context;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "checkbox",
                checked: value,
                onChange: ()=>{
                    (0, _post.sendAssessment)(context.profile.Passport.id, {
                        ...(0, _lodash.omit)(rowData, [
                            'griddleKey'
                        ]),
                        randomize: !value
                    }).then(()=>context.setState({
                            assessmentViewUpdates: assessmentViewUpdates + 1
                        }));
                }
            });
        }
    });
}
function AssessmentLinksColumn({ rowData }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _linksDefault.default), {
        ...rowData
    });
}
const map = {
    headers: {
        AssessmentHeader,
        EmptyHeader
    },
    columns: {
        TitleColumn: (0, _utils.enhancedWithRowData)(TitleColumn),
        TypeColumn,
        RandomizeColumn: (0, _utils.enhancedWithRowData)(RandomizeColumn),
        CourseColumn,
        AssessmentLinksColumn: (0, _utils.enhancedWithRowData)(AssessmentLinksColumn)
    }
};
exports.default = map;

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","./links":"AhoUe","../../context":"iUP37","../../context/post":"8rmpk","../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"AhoUe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Links);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _url = require("../../../helpers/url");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../context");
var _post = require("../../../context/post");
var _icon = require("../../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _confirmDialog = require("../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _reactConfirmAlert = require("react-confirm-alert");
var _scheduleAssessment = require("../../schedule-assessment");
var _scheduleAssessmentDefault = parcelHelpers.interopDefault(_scheduleAssessment);
var _url1 = require("helpers/url");
var _reactConfirmAlertCss = require("react-confirm-alert/src/react-confirm-alert.css");
var _linksStyl = require("./links.styl");
function DuplicateDialog(props) {
    const { context, assessment, onClose } = props;
    const { translate, setState, assessmentUpdates } = context;
    const [name, setName] = (0, _react.useState)(assessment.name || "");
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "duplicate-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "title",
                children: translate('duplicate_assessment_label')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    value: name,
                    type: "text",
                    onChange: (e)=>setName(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "buttons",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "duplicate button",
                        onClick: ()=>{
                            (0, _post.cloneAssessment)(assessment, name).then(()=>{
                                setState({
                                    assessmentUpdates: assessmentUpdates + 1
                                }, onClose);
                            });
                        },
                        children: context.translate('duplicate_label')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "cancel button",
                        onClick: onClose,
                        children: translate('cancel_label')
                    })
                ]
            })
        ]
    });
}
function duplicateDialog(props) {
    return (0, _reactConfirmAlert.confirmAlert)({
        customUI: ({ onClose })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(DuplicateDialog, {
                ...props,
                onClose
            })
    });
}
function Links(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { assessments, languageId, link, action } = context;
            const { digest } = assessments.find((a)=>a.id == props.id) || {};
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "links",
                children: [
                    digest && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "link edit",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            ...(0, _url1.viewerGuard)({
                                href: (0, _url.subdomainLink)('assessment', languageId, `create#${digest}`),
                                target: "_blank"
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faEdit)
                            })
                        })
                    }),
                    action == 'schedule' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scheduleAssessmentDefault.default), {
                        selectedGroup: {},
                        activeTab: "groups"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "link schedule",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: link({
                                assessment: props.id
                            }, `${context.match.path}/schedule/:assessment`, {
                                preserveQuery: true
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                name: "schedule"
                            })
                        })
                    }),
                    props.used && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "link delete inactive",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTrashAlt)
                        })
                    }),
                    !props.used && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "link delete",
                        onClick: ()=>(0, _confirmDialogDefault.default)({
                                className: 'delete-assessment',
                                translate: context.translate,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "message",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "question",
                                            children: context.translate('confirm_delete_item')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "title",
                                            children: props.name
                                        })
                                    ]
                                }),
                                onConfirm: ()=>{
                                    (0, _post.deleteAssessment)(props.teacher, props.id).then(()=>{
                                        const assessmentUpdates = context.assessmentUpdates + 1;
                                        context.setState({
                                            assessmentUpdates
                                        });
                                    });
                                }
                            }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTrashAlt)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "link",
                        onClick: ()=>duplicateDialog({
                                context,
                                assessment: props
                            }),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faClone)
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","../../../helpers/url":"65SQD","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","../../../context":"iUP37","../../../context/post":"8rmpk","../../icon":"82gpi","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../confirm-dialog":"hzSdJ","react-confirm-alert":"dyW9k","../../schedule-assessment":"2qOfl","helpers/url":"65SQD","react-confirm-alert/src/react-confirm-alert.css":"63bhO","./links.styl":"2d1RL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2qOfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _tabBar = require("./tab-bar");
var _tabBarDefault = parcelHelpers.interopDefault(_tabBar);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("context");
var _utils = require("helpers/utils");
var _groupsStep = require("./groups-step");
var _groupsStepDefault = parcelHelpers.interopDefault(_groupsStep);
var _dateStep = require("./date-step");
var _dateStepDefault = parcelHelpers.interopDefault(_dateStep);
var _post = require("../../context/post");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _indexStyl = require("./index.styl");
function Buttons({ left, right }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                disabled: !left.enabled,
                className: left.label,
                onClick: left.onClick,
                children: [
                    left.loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {}),
                    !left.loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: `${left.label}_label`
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                disabled: !right.enabled,
                className: right.label,
                onClick: right.onClick,
                children: [
                    right.loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {}),
                    !right.loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: `${right.label}_label`
                    })
                ]
            })
        ]
    });
}
class ScheduleAssessment extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            start: props.start || new Date(),
            finish: props.finish || new Date(),
            maxTime: 3600,
            message: props.message || "",
            activeTab: props.activeTab,
            selectedGroup: props.selectedGroup,
            studentList: props.studentList || [],
            selectedStudents: props.selectedStudents || [],
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const { setState, activeTab, isOpen } = this.state;
        const { assessment: assessmentId, assessmentView } = context;
        const assessment = assessmentView.find(({ id })=>id == assessmentId) || {};
        const markAssessmentAsAssigned = async ()=>{
            const assessmentView = context.assessmentView.map((assessment)=>assessment.id != assessmentId ? assessment : {
                    ...assessment,
                    assigned: true
                });
            context.updateState({
                sending: {
                    scheduleAssessment: {
                        $set: false
                    }
                }
            });
            context.setState({
                assessmentView
            }, close);
        };
        const save = async ()=>{
            if (context.sending.scheduleAssessment) return;
            console.log('Sending schedule');
            await context.updateState({
                sending: {
                    scheduleAssessment: {
                        $set: true
                    }
                }
            });
            return (0, _post.scheduleAssessment)({
                id: assessment.id,
                title: assessment.name,
                course: this.state.selectedGroup.course,
                maxTime: this.state.maxTime,
                start: this.state.start,
                finish: this.state.finish,
                language: context.languageId,
                students: this.state.selectedStudents,
                action: context.action,
                message: this.state.message
            }).then(markAssessmentAsAssigned);
        };
        const previous = ()=>setState({
                activeTab: 'groups'
            });
        const next = ()=>setState({
                activeTab: 'date'
            });
        const close = ()=>setState({
                isOpen: false
            });
        const navigateOut = ()=>context.navigate({}, context.match.path.replace(/\/:action.*$/, ''), {
                preserveQuery: true
            });
        const canSave = this.state.selectedStudents.length > 0 && !(0, _utils.isEmptyOrWhiteSpace)(this.state.message) && !context.sending.scheduleAssessment;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "schedule-assessment-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-assessment",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "assessment_title"
                                    }),
                                    `: ${assessment.name}`
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "close",
                                onClick: ()=>close(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faTimesCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabBarDefault.default), {
                        activeTab,
                        setState
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tab-content",
                        children: [
                            activeTab == 'groups' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'selectedGroup',
                                            'studentList',
                                            'selectedStudents',
                                            'setState'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'cancel',
                                            onClick: close,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'continue',
                                            onClick: next,
                                            enabled: true
                                        }
                                    })
                                ]
                            }),
                            activeTab == 'date' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dateStepDefault.default), {
                                        ...(0, _lodash.pick)(this.state, [
                                            'start',
                                            'finish',
                                            'maxTime',
                                            'setState',
                                            'message'
                                        ])
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                        left: {
                                            label: 'back',
                                            onClick: previous,
                                            enabled: true
                                        },
                                        right: {
                                            label: 'save',
                                            onClick: save,
                                            enabled: canSave
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = ScheduleAssessment;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-modal":"kV9Wz","./tab-bar":"fPUVT","react-text":"lEpdJ","context":"iUP37","helpers/utils":"gGc98","./groups-step":"7oJmn","./date-step":"9klhj","../../context/post":"8rmpk","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/CircularProgress":"bK4ky","./index.styl":"cSruF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fPUVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _tabBarStyl = require("./tab-bar.styl");
function TabBar({ activeTab, setState }) {
    const setActiveTab = (activeTab)=>setState({
            activeTab
        });
    const buttonClassName = (tab)=>`${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`;
    const onClick = (tab)=>()=>activeTab != tab && setActiveTab(tab);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "tab-bar",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('groups'),
                onClick: onClick('groups'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faUsers)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_group_button_label"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: buttonClassName('date'),
                onClick: onClick('date'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: "schedule_lesson_date_button_label"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","./tab-bar.styl":"32HnP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"32HnP":[function() {},{}],"7oJmn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GroupsStep);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectGroup = require("./select-group");
var _selectGroupDefault = parcelHelpers.interopDefault(_selectGroup);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _listboxActions = require("../listbox/listbox-actions");
var _listboxActionsDefault = parcelHelpers.interopDefault(_listboxActions);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _groupsStepStyl = require("./groups-step.styl");
function makeStudentClickHandler({ props, target }) {
    return ({ id, selected })=>props.setState({
            [target]: props[target].map((student)=>student.id != id ? {
                    ...student
                } : {
                    ...student,
                    selected: !selected
                })
        });
}
function GroupsStep(props) {
    const groupClick = (group)=>{
        if (group.id != props.selectedGroup.id) props.setState({
            selectedGroup: group,
            selectedStudents: [],
            studentList: group.students.map((student)=>({
                    ...student,
                    selected: false
                }))
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "groups-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "groups-message",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "schedule_lesson_groups_instructions"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "student-selector",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGroupDefault.default), {
                        selectedGroup: props.selectedGroup,
                        onClick: groupClick
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "select-student",
                        labelId: "students_label",
                        items: (0, _lodash.orderBy)(props.studentList, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'studentList'
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxActionsDefault.default), {
                        onAllLeft: ()=>{
                            const studentList = props.studentList.concat(props.selectedStudents);
                            props.setState({
                                selectedStudents: [],
                                studentList
                            });
                        },
                        onLeft: ()=>{
                            const selectedStudents = props.selectedStudents.filter(({ selected })=>!selected);
                            const studentList = props.studentList.concat(props.selectedStudents.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onRight: ()=>{
                            const studentList = props.studentList.filter(({ selected })=>!selected);
                            const selectedStudents = props.selectedStudents.concat(props.studentList.filter(({ selected })=>selected));
                            props.setState({
                                selectedStudents,
                                studentList
                            });
                        },
                        onAllRight: ()=>{
                            const selectedStudents = props.selectedStudents.concat(props.studentList);
                            props.setState({
                                selectedStudents,
                                studentList: []
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                        className: "selected-students",
                        labelId: "selection_label",
                        items: (0, _lodash.orderBy)(props.selectedStudents, [
                            'name'
                        ]),
                        onClick: makeStudentClickHandler({
                            props,
                            target: 'selectedStudents'
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","./select-group":"YCAZI","../listbox":"b8FP6","../listbox/listbox-actions":"h72SQ","react-text":"lEpdJ","./groups-step.styl":"a4hrY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"YCAZI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _listbox = require("../listbox");
var _listboxDefault = parcelHelpers.interopDefault(_listbox);
var _context = require("../../context");
function SelectGroup(props) {
    const { selectedGroup, onClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const groups = context.groups.map((group)=>{
                return {
                    ...group,
                    selected: selectedGroup && group.id == selectedGroup.id
                };
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listboxDefault.default), {
                className: "select-group",
                labelId: "group_label",
                items: (0, _lodash.orderBy)(groups, [
                    'course'
                ]),
                onClick: onClick
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","../listbox":"b8FP6","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a4hrY":[function() {},{}],"9klhj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateStep);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../context");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _dateStepStyl = require("./date-step.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function DateStep(props) {
    const setMessage = (event)=>props.setState({
            message: event.target.value
        });
    const hours = Math.floor(props.maxTime / 3600);
    const minutes = props.maxTime % 3600 / 60;
    const setHours = (event)=>{
        const value = parseInt(event.target.value);
        const hours = isNaN(value) ? 0 : value;
        const maxTime = Math.max(minutes * 60 + hours * 3600, 60);
        props.setState({
            maxTime
        });
    };
    const setMinutes = (event)=>{
        const value = parseInt(event.target.value);
        const minutes = isNaN(value) ? 0 : value;
        const maxTime = Math.max(minutes * 60 + hours * 3600, 60);
        props.setState({
            maxTime
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "date-step",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "instructions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "schedule_lesson_date_instructions"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "date_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "inputs",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "from",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                                    selected: (0, _momentDefault.default)(props.start).toDate(),
                                                    minDate: new Date(),
                                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                                    showTimeInput: true,
                                                    dateFormat: "MM/dd/yyyy h:mm aa",
                                                    onChange: (start)=>{
                                                        const finish = (0, _momentDefault.default)(props.finish).isAfter(start) ? props.finish : (0, _momentDefault.default)(start).toDate();
                                                        props.setState({
                                                            start,
                                                            finish
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "separator",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        flexDirection: 'column'
                                                    },
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "to",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
                                                    selected: (0, _momentDefault.default)(props.finish).toDate(),
                                                    minDate: (0, _momentDefault.default)(props.start).toDate(),
                                                    maxDate: (0, _momentDefault.default)().add(1, 'year').toDate(),
                                                    showTimeInput: true,
                                                    dateFormat: "MM/dd/yyyy h:mm aa",
                                                    timeIntervals: 60,
                                                    onChange: (finish)=>{
                                                        props.setState({
                                                            finish
                                                        });
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "duration",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "hours",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "hours"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inputs",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    value: hours,
                                                    onChange: setHours
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "separator",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: 'column'
                                            },
                                            children: " "
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "minutes",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "minutes"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inputs",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    value: minutes,
                                                    onChange: setMinutes
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "message",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "label",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "message_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            placeholder: context.translate('schedule_lesson_date_message_placeholder'),
                                            value: props.message,
                                            onChange: setMessage
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../context":"iUP37","react-datepicker/dist/react-datepicker.css":"chsuV","./date-step.styl":"2T9YQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"2T9YQ":[function() {},{}],"cSruF":[function() {},{}],"63bhO":[function() {},{}],"2d1RL":[function() {},{}],"d0AWo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _icon = require("../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _context = require("../../context");
var _filtersStyl = require("./filters.styl");
function Filters(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { assessmentCount } = context;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filters-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "filters",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "label-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "label",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                        name: "lesson-count"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "count",
                                    children: assessmentCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "assessments_label"
                                            }),
                                            ": ",
                                            assessmentCount
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","../icon":"82gpi","../../context":"iUP37","./filters.styl":"5Qxa5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Qxa5":[function() {},{}],"7GNU7":[function() {},{}],"8wm7r":[function() {},{}],"7Ik21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Planning);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../context");
var _planning = require("../../components/planning");
var _planningDefault = parcelHelpers.interopDefault(_planning);
var _planningStyl = require("./planning.styl");
const defaultDates = {
    month: ()=>({
            start: (0, _momentDefault.default)().startOf('month').startOf('week').format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)().endOf('month').endOf('week').format('YYYY-MM-DD')
        }),
    week: ()=>({
            start: (0, _momentDefault.default)().startOf('week').format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)().endOf('week').format('YYYY-MM-DD')
        }),
    day: ()=>({
            start: (0, _momentDefault.default)().format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)().format('YYYY-MM-DD')
        })
};
function getView({ view, section }) {
    if (section == 'templates') return (0, _planningDefault.default)[section];
    else return (0, _planningDefault.default)[view] || (0, _planningDefault.default).week;
}
function Planning() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const View = getView(context);
            const view = context.view || 'week';
            const query = context.query.start ? context.query : (defaultDates[view] || defaultDates.week)();
            const date = getDate(query);
            if ([
                'week',
                'day',
                'month'
            ].indexOf(view) >= 0 && !context.query.start && (context.page == 'planning' || context.page == 'planning-rd')) {
                const link = context.link({
                    view
                }, '/:languageId/:role/:page/:view', {
                    preserveQuery: true,
                    query
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Redirect), {
                    to: link
                });
            } else return /*#__PURE__*/ (0, _jsxRuntime.jsx)(View, {
                date,
                view,
                query
            });
        }
    });
}
function getTime(date) {
    return (0, _momentDefault.default)(date).toDate().getTime();
}
function getDate({ start, end }) {
    const time = (getTime(start) + getTime(end)) / 2;
    return (0, _lodash.partial)((0, _momentDefault.default), time);
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","moment":"1e4qG","react":"9njXz","react-router-dom":"3uzXR","../../context":"iUP37","../../components/planning":"sAJHR","./planning.styl":"4uhq8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"sAJHR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _week = require("./week");
var _weekDefault = parcelHelpers.interopDefault(_week);
var _month = require("./month");
var _monthDefault = parcelHelpers.interopDefault(_month);
var _day = require("./day");
var _dayDefault = parcelHelpers.interopDefault(_day);
var _plan = require("./plan");
var _planDefault = parcelHelpers.interopDefault(_plan);
var _planRd = require("./plan-rd");
var _planRdDefault = parcelHelpers.interopDefault(_planRd);
var _templates = require("./templates");
var _templatesDefault = parcelHelpers.interopDefault(_templates);
var _preview = require("./preview");
var _previewDefault = parcelHelpers.interopDefault(_preview);
var _previewRd = require("./preview-rd");
var _previewRdDefault = parcelHelpers.interopDefault(_previewRd);
const views = {
    week: (0, _weekDefault.default),
    month: (0, _monthDefault.default),
    day: (0, _dayDefault.default),
    plan: (0, _planDefault.default),
    templates: (0, _templatesDefault.default),
    preview: (0, _previewDefault.default),
    'plan-rd': (0, _planRdDefault.default),
    'preview-rd': (0, _previewRdDefault.default)
};
exports.default = views;

},{"./week":"2fB5S","./month":"amBY0","./day":"8OTFd","./plan":"hzm0b","./plan-rd":"dP6U1","./templates":"liD0u","./preview":"2M3SU","./preview-rd":"afEIs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2fB5S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WeekView);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactDnd = require("react-dnd");
var _context = require("../../context");
var _post = require("../../context/post");
var _toolbar = require("./toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _label = require("../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _event = require("./event");
var _eventDefault = parcelHelpers.interopDefault(_event);
var _weekStyl = require("./week.styl");
var _navigation = require("planning/navigation");
const minEventHeight = 110;
const minEventWidth = 130;
const dayTitleHeight = 40;
const eventHeight = 40;
const horizontalMargin = 40;
const viewMoreHeight = 20;
const verticalMargin = 237;
const groupWidth = 200;
const groupStyle = {
    with: groupWidth,
    maxWidth: groupWidth,
    minWidth: groupWidth
};
function Day(props) {
    const { date, daySize, group, goToDay, defaultDate, lastDay } = props;
    const day = (0, _momentDefault.default)(date).format('YYYY-MM-DD');
    const isToday = (0, _momentDefault.default)(date).isSame(new Date(), 'day');
    const canAdd = (0, _momentDefault.default)(date).isSameOrAfter(new Date(), 'day');
    const className = `day ${isToday ? 'current' : ''}`;
    const displayCount = Math.floor((daySize.height - dayTitleHeight - viewMoreHeight) / eventHeight);
    const [collectedProps, drop] = (0, _reactDnd.useDrop)({
        accept: 'event',
        canDrop: ()=>{
            return (0, _momentDefault.default)(date).isSameOrAfter(new Date(), 'day');
        },
        drop: ({ id })=>{
            const event = props.context.plans.find((e)=>e.id == id);
            if (event) {
                const start = (0, _momentDefault.default)(date.toDate());
                const duration = Math.ceil((0, _momentDefault.default).duration((0, _momentDefault.default)(event.finish).diff((0, _momentDefault.default)(event.start))).asDays());
                const finish = (0, _momentDefault.default)(start).add(duration, 'days');
                (0, _post.reschedulePlan)(id, start, finish).then(()=>{
                    const planUpdates = props.context.planUpdates + 1;
                    props.context.setState({
                        planUpdates
                    });
                });
            }
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const events = (context.plansByDay[day] || []).filter((event)=>event.clique == group.id);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: drop,
                className: className,
                style: lastDay ? daySize : {
                    ...daySize,
                    maxWidth: 'none',
                    flexGrow: 1
                },
                onClick: ()=>{
                    goToDay({
                        group: group.id,
                        start: day,
                        end: day
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "events",
                        children: (0, _lodash.take)(events, displayCount).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventDefault.default), {
                                ...props,
                                day,
                                date,
                                defaultDate
                            }, i))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "view-more",
                        children: [
                            events.length > displayCount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "more-button",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "view-more"
                                    }),
                                    " ",
                                    events.length - displayCount,
                                    "..."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    flexGrow: 1
                                }
                            }),
                            canAdd && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "add-plan",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    const suggestedDate = (0, _momentDefault.default)(date).toISOString();
                                    const suggestedGroup = group.id;
                                    (0, _navigation.newPlan)(context, suggestedDate, suggestedGroup);
                                },
                                children: "+"
                            })
                        ]
                    })
                ]
            });
        }
    });
}
function Week(props) {
    const { start, daySize, context, group, goToDay, defaultDate } = props;
    const days = (0, _lodash.range)(7).map((d)=>({
            goToDay,
            group,
            context,
            daySize,
            date: (0, _momentDefault.default)(start).add(d, 'days')
        })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Day, {
            defaultDate: defaultDate,
            ...props,
            lastDay: i == 6
        }, i));
    const subjectId = group.course.substring(0, 2);
    const subject = context.subjects.find((subject)=>subject.id == subjectId);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "week",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "group",
                style: groupStyle,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "color-band",
                        style: {
                            backgroundColor: subject.color
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "subject",
                                children: `${group.subject} - ${group.grade}`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "name",
                                children: group.name
                            })
                        ]
                    })
                ]
            }),
            days
        ]
    });
}
function Header(props) {
    const { date, daySize } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "header day",
        style: {
            width: daySize.width
        },
        children: date.format('ddd DD/MM')
    });
}
function WeekView(props) {
    const { date } = props;
    const start = date().startOf('week');
    const end = date().endOf('week');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { sizes, groups, query } = context;
            const goToDay = (0, _lodash.partial)((0, _toolbar.changeView)(context, props.view, {
                ...query
            }), 'day');
            const dayWidth = Math.round((sizes.width - horizontalMargin - groupWidth - 12) / 7);
            const daySize = {
                width: dayWidth,
                maxWidth: dayWidth,
                minWidth: dayWidth,
                height: Math.max(minEventHeight, Math.round((sizes.height - verticalMargin) / groups.length))
            };
            const weeks = groups.filter((group)=>!query.group || query.group == group.id).map((group)=>({
                    goToDay,
                    context,
                    group,
                    start,
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Week, {
                    defaultDate: date,
                    ...props
                }, i));
            const headers = (0, _lodash.range)(7).map((d)=>({
                    date: (0, _momentDefault.default)(start).add(d, 'days'),
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                    ...props
                }, i));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "planning week view",
                style: {
                    width: sizes.width - horizontalMargin
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "calendar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "headers",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "header groups",
                                        style: groupStyle,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "groups_label"
                                        })
                                    }),
                                    headers
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "weeks",
                                children: weeks
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","@mui/material/Fade":"8DwqP","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","react-dnd":"9NZ1L","../../context":"iUP37","../../context/post":"8rmpk","./toolbar":"jRimY","../label":"59910","./event":"f1aJB","./week.styl":"3bhXl","planning/navigation":"7uOU2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jRimY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeView", ()=>changeView);
parcelHelpers.export(exports, "default", ()=>Toolbar);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _reactRouterDom = require("react-router-dom");
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _printPdf = require("../print-pdf");
var _printPdfDefault = parcelHelpers.interopDefault(_printPdf);
var _duplicate = require("./duplicate");
var _duplicateDefault = parcelHelpers.interopDefault(_duplicate);
var _calendarAltInput = require("../date-picker/calendar-alt-input");
var _calendarAltInputDefault = parcelHelpers.interopDefault(_calendarAltInput);
var _navigation = require("planning/navigation");
var _toolbarStyl = require("./toolbar.styl");
function changeDate({ navigate, match }, view) {
    const pad = view == 'day' ? 'day' : 'week';
    return (date)=>{
        const query = {
            start: (0, _momentDefault.default)(date).startOf(view).startOf(pad).format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).endOf(view).endOf(pad).format('YYYY-MM-DD')
        };
        navigate({}, match.path, {
            preserveQuery: true,
            query
        });
    };
}
function changeView({ setState, navigate, match }, planningNavigatedFrom, planningNavigatedFromQuery) {
    return (view, query)=>{
        if (planningNavigatedFrom) setState({
            planningNavigatedFrom,
            planningNavigatedFromQuery
        });
        navigate({
            view
        }, match.path, {
            preserveQuery: true,
            query
        });
    };
}
function title(date, level, { translate, languageId }) {
    switch(level){
        case 'week':
            const start = (0, _momentDefault.default)(date).startOf(level).format('DD');
            const end = (0, _momentDefault.default)(date).endOf(level).format('DD');
            return `${translate('week_label')} ${start} - ${end}`;
        case 'day':
            const formats = {
                es: "dddd, DD [de] MMMM [de] YYYY",
                en: "dddd, MMMM do YYYY"
            };
            return (0, _momentDefault.default)(date).format(formats[languageId]);
        default:
            return (0, _momentDefault.default)(date).format('MMMM YYYY');
    }
}
function Toolbar(props) {
    const { date } = props;
    const currentMonth = (0, _momentDefault.default)(date()).month();
    const monthQuery = {
        start: (0, _momentDefault.default)(date()).startOf('month').startOf('week').format('YYYY-MM-DD'),
        end: (0, _momentDefault.default)(date()).endOf('month').endOf('week').format('YYYY-MM-DD')
    };
    const level = `${props.view}s`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { groups, action, query, languageId, planId, plans } = context;
            const plan = plans.find((plan)=>plan.id == planId) || {};
            const navigate = changeDate(context, props.view);
            const navigateToView = changeView(context);
            const previousDate = date().subtract(1, level);
            const nextDate = date().add(1, level);
            const previous = ()=>navigate(previousDate);
            const next = ()=>navigate(nextDate);
            const group = context.groups.find((group)=>group.id == context.query.group);
            const planGroup = groups.find((group)=>group.id == plan.clique) || {};
            const backPath = context.link({
                view: context.planningNavigatedFrom
            }, '/:languageId/:role/:page/:view', {
                query: context.planningNavigatedFromQuery
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "toolbar",
                children: [
                    action == 'duplicate' && plan.id && planGroup.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _duplicateDefault.default), {
                        plan: plan,
                        group: planGroup
                    }),
                    action == 'pdf' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _printPdfDefault.default), {
                        start: query.start,
                        end: query.end,
                        group: group
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "navigation",
                        children: [
                            props.view == 'day' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: "back",
                                to: backPath
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "previous",
                                onClick: previous,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faChevronLeft)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                    selected: (0, _momentDefault.default)(date()).toDate(),
                                    dateFormat: "MM/yyyy",
                                    locale: languageId,
                                    popperPlacement: "top-end",
                                    popperModifiers: {
                                        offset: {
                                            enabled: true,
                                            offset: props.view == 'month' ? "158px, 5px" : "180px, 5px"
                                        },
                                        preventOverflow: {
                                            enabled: true,
                                            escapeWithReference: false,
                                            boundariesElement: 'viewport'
                                        }
                                    },
                                    onChange: (date)=>{
                                        navigate((0, _momentDefault.default)(date));
                                    },
                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarAltInputDefault.default), {}),
                                    showMonthYearPicker: props.view == 'month'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next",
                                onClick: next,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        justifyContent: 'center'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faChevronRight)
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: title(date(), props.view, context)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "group",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                            className: "select-group",
                            classNamePrefix: "select-group",
                            formatOptionLabel: ({ name })=>name,
                            isSearchable: false,
                            isClearable: true,
                            escapeClearsValue: true,
                            getOptionValue: ({ id })=>id,
                            placeholder: context.translate("group_label"),
                            value: group,
                            onChange: (option)=>{
                                const group = option ? option.id : undefined;
                                context.navigate({}, context.match.params, {
                                    preserveQuery: true,
                                    query: {
                                        group
                                    }
                                });
                            },
                            options: groups
                        })
                    }),
                    props.view != 'day' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "button today",
                        onClick: ()=>navigate(new Date()),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "today_label"
                        })
                    }),
                    props.view != 'day' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `button week ${props.view == 'week' ? 'active' : ''}`,
                        onClick: ()=>{
                            if (props.view == 'month') {
                                const planningWeek = (0, _momentDefault.default)(context.planningWeek);
                                const query = currentMonth == planningWeek.month() ? {
                                    start: context.planningWeek,
                                    end: planningWeek.endOf('week').format('YYYY-MM-DD')
                                } : {
                                    start: (0, _momentDefault.default)(date()).startOf('month').startOf('week').format('YYYY-MM-DD'),
                                    end: (0, _momentDefault.default)(date()).startOf('month').endOf('week').format('YYYY-MM-DD')
                                };
                                navigateToView('week', query);
                            }
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "week_label"
                        })
                    }),
                    props.view != 'day' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `button month ${props.view == 'month' ? 'active' : ''}`,
                        onClick: ()=>props.view != 'month' && navigateToView('month', monthQuery),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "month_label"
                        })
                    }),
                    props.view == 'day' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "new-plan",
                        onClick: ()=>{
                            (0, _navigation.newPlan)(context, (0, _momentDefault.default)(props.date()).toISOString(), context.query.group);
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "print-pdf",
                        onClick: ()=>{
                            context.navigate({
                                view: context.view || 'month'
                            }, '/:languageId/:role/:page/:view/pdf', {
                                preserveQuery: true
                            });
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faFilePdf)
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","react-router-dom":"3uzXR","react-select":"j36cq","react-text":"lEpdJ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","../print-pdf":"3LIow","./duplicate":"FlCse","../date-picker/calendar-alt-input":"4EymL","planning/navigation":"7uOU2","./toolbar.styl":"k1xen","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3LIow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../context");
var _url = require("helpers/url");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _reactConfirmAlertCss = require("react-confirm-alert/src/react-confirm-alert.css");
var _indexStyl = require("./index.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function Buttons({ left, right }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !left.enabled,
                className: left.label,
                onClick: left.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${left.label}_label`
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !right.enabled,
                className: right.label,
                onClick: right.onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${right.label}_label`
                })
            })
        ]
    });
}
class PrintPDF extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            start: props.start,
            end: props.end,
            group: props.group,
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const format = (date)=>(0, _momentDefault.default)(date).format('YYYY-MM-DD');
        const { setState, isOpen, start, end, group } = this.state;
        const locale = context.languageId == 'en' ? _locale.enUS : _locale.es;
        const query = {
            start: format(start),
            end: format(end),
            group: group ? group.id : undefined
        };
        const href = `//${location.host}/#${context.link({}, '/:languageId/:role/planning-pdf', {
            query
        })}`;
        const navigateOut = ()=>context.navigate({}, context.match.path.replace(/\/:action.*$/, ''), {
                preserveQuery: true
            });
        const close = ()=>setState({
                isOpen: false
            });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "print-pdf-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "print-pdf",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "label",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "print-plan"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "group_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                        className: "select-group",
                                        classNamePrefix: "select-group",
                                        formatOptionLabel: ({ name })=>name,
                                        isSearchable: false,
                                        isClearable: true,
                                        escapeClearsValue: true,
                                        getOptionValue: ({ id })=>id,
                                        placeholder: context.translate("all-groups"),
                                        value: group,
                                        onChange: (group)=>setState({
                                                group
                                            }),
                                        options: context.groups
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "date_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "inputs",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "from",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: locale,
                                                    selected: (0, _momentDefault.default)(start).toDate(),
                                                    onChange: (start)=>{
                                                        const end = (0, _momentDefault.default)(end).isAfter(start) ? end : (0, _momentDefault.default)(start).toDate();
                                                        setState({
                                                            start,
                                                            end
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "separator",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        flexDirection: 'column'
                                                    },
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "to",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: locale,
                                                    selected: (0, _momentDefault.default)(end).toDate(),
                                                    onChange: (end)=>setState({
                                                            end
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "button cancel",
                                onClick: close,
                                children: context.translate('cancel_label')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                className: "button continue",
                                onClick: close,
                                ...(0, _url.viewerGuard)({
                                    href,
                                    target: "_blank"
                                }),
                                children: context.translate('continue_label')
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = PrintPDF;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","moment":"1e4qG","react":"9njXz","react-select":"j36cq","react-modal":"kV9Wz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../context":"iUP37","helpers/url":"65SQD","react-datepicker/dist/react-datepicker.css":"chsuV","react-confirm-alert/src/react-confirm-alert.css":"63bhO","./index.styl":"i9vpU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"63bhO":[function() {},{}],"i9vpU":[function() {},{}],"FlCse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _locale = require("date-fns/locale");
var _context = require("../../../context");
var _post = require("../../../context/post");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
var _reactConfirmAlertCss = require("react-confirm-alert/src/react-confirm-alert.css");
var _indexStyl = require("./index.styl");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
class Duplicate extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const { plan, group } = props;
        const setState = this.setState.bind(this);
        this.state = {
            start: plan.start,
            end: plan.finish,
            title: plan.title,
            group: group,
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const { groups, planId } = context;
        const format = (date)=>(0, _momentDefault.default)(date).format('YYYY/MM/DD');
        const { setState, isOpen, start, end, group, title } = this.state;
        const locale = context.languageId == 'en' ? _locale.enUS : _locale.es;
        const navigateOut = ()=>{
            context.navigate({}, context.match.path.replace(/\/:action.*$/, ''), {
                preserveQuery: true
            });
        };
        const close = ()=>setState({
                isOpen: false
            });
        const duplicate = async ()=>{
            await (0, _post.duplicatePlan)({
                start,
                end,
                title,
                group: group.id,
                id: planId
            });
            context.setState({
                planUpdates: context.planUpdates + 1
            }, close);
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "duplicate-plan-dialog-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "duplicate-plan-dialog",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "label",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "duplicate_plan"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "plan-title",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "title"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "input-title",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            placeholder: context.translate('write_here'),
                                            type: "text",
                                            value: title,
                                            onChange: (e)=>{
                                                const title = e.target.value;
                                                setState({
                                                    title
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "group_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                        className: "select-group",
                                        classNamePrefix: "select-group",
                                        formatOptionLabel: ({ name })=>name,
                                        isSearchable: false,
                                        isClearable: false,
                                        escapeClearsValue: true,
                                        getOptionValue: ({ id })=>id,
                                        placeholder: context.translate("pick_one"),
                                        value: group,
                                        onChange: (group)=>{
                                            setState({
                                                group
                                            });
                                        },
                                        options: groups
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "date_label"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "inputs",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "from",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: locale,
                                                    selected: (0, _momentDefault.default)(start).toDate(),
                                                    minDate: (0, _momentDefault.default)().toDate(),
                                                    onChange: (start)=>{
                                                        const endDate = (0, _momentDefault.default)(end).isAfter(start) ? end : (0, _momentDefault.default)(start).toDate();
                                                        setState({
                                                            start,
                                                            end: endDate
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "separator",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        flexDirection: 'column'
                                                    },
                                                    children: "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "to",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
                                                    customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
                                                    locale: locale,
                                                    selected: (0, _momentDefault.default)(end).toDate(),
                                                    minDate: (0, _momentDefault.default)(start).toDate(),
                                                    onChange: (end)=>setState({
                                                            end
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "buttons",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "cancel",
                                onClick: close,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "cancel_label"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "duplicate",
                                onClick: duplicate,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "duplicate"
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = Duplicate;

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-select":"j36cq","react-modal":"kV9Wz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-text":"lEpdJ","date-fns/locale":"dElgW","../../../context":"iUP37","../../../context/post":"8rmpk","react-datepicker/dist/react-datepicker.css":"chsuV","react-confirm-alert/src/react-confirm-alert.css":"63bhO","./index.styl":"lQOOi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"63bhO":[function() {},{}],"lQOOi":[function() {},{}],"7uOU2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultDates", ()=>defaultDates);
parcelHelpers.export(exports, "newPlan", ()=>newPlan);
parcelHelpers.export(exports, "planLink", ()=>planLink);
var _moment = require("external/moment");
const defaultDates = {
    month: (date)=>({
            start: (0, _moment.moment)(date).startOf('month').startOf('week').format('YYYY-MM-DD'),
            end: (0, _moment.moment)(date).endOf('month').endOf('week').format('YYYY-MM-DD')
        }),
    week: (date)=>({
            start: (0, _moment.moment)(date).startOf('week').format('YYYY-MM-DD'),
            end: (0, _moment.moment)(date).endOf('week').format('YYYY-MM-DD')
        }),
    day: (date)=>({
            start: (0, _moment.moment)(date).format('YYYY-MM-DD'),
            end: (0, _moment.moment)(date).format('YYYY-MM-DD')
        })
};
function newPlan(context, suggestedDate, suggestedGroup) {
    const planType = getPlanType(context);
    context.setState({
        newPlanFrom: 'month',
        newPlanFromQuery: {
            ...context.query
        },
        suggestedDate,
        suggestedGroup
    }, ()=>{
        context.navigate({}, `/:languageId/:role/:page/${planType}`);
    });
}
function planLink(context, planId, defaultDate, prefix) {
    const planType = getPlanType(context, prefix);
    const newPlanFromQuery = {
        ...(defaultDates[context.view] || defaultDates.week)(defaultDate()),
        group: context.query.group
    };
    context.setState({
        newPlanFrom: context.view,
        newPlanFromQuery
    });
    context.navigate({
        planId
    }, `/:languageId/:role/:page/${planType}/:planId`);
}
function getPlanType(context, prefix = 'plan') {
    const suffixIndex = context.page.indexOf('-');
    return suffixIndex < 0 ? prefix : `${prefix}${context.page.substring(suffixIndex)}`;
}

},{"external/moment":"mpofx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1xen":[function() {},{}],"f1aJB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Event);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _reactDnd = require("react-dnd");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../context");
var _post = require("../../context/post");
var _confirmDialog = require("../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _navigation = require("planning/navigation");
var _eventStyl = require("./event.styl");
function EventMenu({ planId, context, title, defaultDate }) {
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
        event.stopPropagation();
    };
    const handleClose = (event)=>{
        setAnchorEl(null);
        event.stopPropagation();
    };
    const handleDuplicate = (event)=>{
        handleClose(event);
        context.navigate({
            view: context.view,
            planId
        }, '/:languageId/:role/:page/:view/duplicate/:planId', {
            preserveQuery: true
        });
    };
    const handlePreview = (event)=>{
        handleClose(event);
        (0, _navigation.planLink)(context, planId, defaultDate, 'preview');
    };
    const handleEdit = (event)=>{
        handleClose(event);
        (0, _navigation.planLink)(context, planId, defaultDate);
    };
    const handleDelete = (event)=>{
        handleClose(event);
        (0, _confirmDialogDefault.default)({
            className: 'delete-plan',
            translate: context.translate,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "message",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "question",
                        children: context.translate('confirm_delete_item')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: title
                    })
                ]
            }),
            onConfirm: ()=>{
                (0, _post.deletePlan)(planId).then(()=>{
                    const planUpdates = context.planUpdates + 1;
                    context.setState({
                        planUpdates
                    });
                });
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "event-menu-button",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                "aria-controls": "event-menu",
                "aria-haspopup": "true",
                onClick: handleClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCaretDown)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                className: "event-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: open,
                onClose: handleClose,
                TransitionComponent: (0, _fadeDefault.default),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handlePreview,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "preview_title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleEdit,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "edit_label"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleDuplicate,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "duplicate"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        onClick: handleDelete,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "delete_label"
                        })
                    })
                ]
            })
        ]
    });
}
function Event(props) {
    const { id: planId, title, subject: subjectId, date, defaultDate } = props;
    const [{ opacity }, dragRef] = (0, _reactDnd.useDrag)({
        item: {
            type: 'event',
            id: props.id
        },
        collect: (monitor)=>({
                opacity: monitor.isDragging() ? 0.5 : 1
            })
    });
    const isFirst = (0, _momentDefault.default)(props.start).format('YYYY-MM-DD') == props.day;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { subjects } = context;
            const subject = subjects.find((subject)=>subject.id == subjectId) || subjects[0];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: dragRef,
                className: "event",
                style: {
                    opacity,
                    color: subject.textColor,
                    backgroundColor: subject.color
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        title: title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "flex spacer"
                    }),
                    isFirst && /*#__PURE__*/ (0, _jsxRuntime.jsx)(EventMenu, {
                        planId,
                        title,
                        context,
                        date,
                        defaultDate
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","@mui/material/Button":"c6Y0y","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@mui/material/Fade":"8DwqP","react-dnd":"9NZ1L","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../context":"iUP37","../../context/post":"8rmpk","../confirm-dialog":"hzSdJ","planning/navigation":"7uOU2","./event.styl":"8P4Yl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8P4Yl":[function() {},{}],"3bhXl":[function() {},{}],"amBY0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MonthView);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactDnd = require("react-dnd");
var _context = require("../../context");
var _post = require("../../context/post");
var _toolbar = require("./toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _label = require("../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _event = require("./event");
var _eventDefault = parcelHelpers.interopDefault(_event);
var _monthStyl = require("./month.styl");
var _navigation = require("planning/navigation");
const minEventHeight = 110;
const minEventWidth = 130;
const dayTitleHeight = 28;
const eventHeight = 28;
const viewMoreHeight = 20;
const horizontalMargin = 40;
const verticalMargin = 300;
function Day(props) {
    const { date, daySize, goToDay, defaultDate } = props;
    const day = (0, _momentDefault.default)(date).format('YYYY-MM-DD');
    const isToday = (0, _momentDefault.default)(date).isSame(new Date(), 'day');
    const canAdd = (0, _momentDefault.default)(date).isSameOrAfter(new Date(), 'day');
    const className = `day ${isToday ? 'current' : ''}`;
    const displayCount = Math.floor((daySize.height - dayTitleHeight - viewMoreHeight) / eventHeight);
    const [collectedProps, drop] = (0, _reactDnd.useDrop)({
        accept: 'event',
        canDrop: ()=>{
            return (0, _momentDefault.default)(date).isSameOrAfter(new Date(), 'day');
        },
        drop: ({ id })=>{
            const event = props.context.plans.find((e)=>e.id == id);
            if (event) {
                const start = (0, _momentDefault.default)(date.toDate());
                const duration = Math.ceil((0, _momentDefault.default).duration((0, _momentDefault.default)(event.finish).diff((0, _momentDefault.default)(event.start))).asDays());
                const finish = (0, _momentDefault.default)(start).add(duration, 'days');
                (0, _post.reschedulePlan)(id, start, finish).then(()=>{
                    const planUpdates = props.context.planUpdates + 1;
                    props.context.setState({
                        planUpdates
                    });
                });
            }
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const events = context.plansByDay[day] || [];
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: drop,
                className: className,
                style: daySize,
                onClick: ()=>{
                    goToDay({
                        start: day,
                        end: day
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: date.format('D')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "events",
                        children: (0, _lodash.take)(events, displayCount).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eventDefault.default), {
                                ...props,
                                day,
                                date,
                                defaultDate
                            }, i))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "view-more",
                        children: [
                            events.length > displayCount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "more-button",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "view-more"
                                    }),
                                    " ",
                                    events.length - displayCount,
                                    "..."
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    flexGrow: 1
                                }
                            }),
                            canAdd && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "add-plan",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    const suggestedDate = (0, _momentDefault.default)(date).toISOString();
                                    const suggestedGroup = context.query.group;
                                    (0, _navigation.newPlan)(context, suggestedDate, suggestedGroup);
                                },
                                children: "+"
                            })
                        ]
                    })
                ]
            });
        }
    });
}
function Week(props) {
    const { start, daySize, context, goToDay, defaultDate } = props;
    const days = (0, _lodash.range)(7).map((d)=>({
            goToDay,
            context,
            daySize,
            date: (0, _momentDefault.default)(start).add(d, 'days')
        })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Day, {
            defaultDate: defaultDate,
            ...props
        }, i));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "week",
        children: days
    });
}
function Header(props) {
    const { date, daySize } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "header week",
        style: {
            width: daySize.width
        },
        children: date.format('ddd')
    });
}
function MonthView(props) {
    const { date } = props;
    const start = date().startOf('month').startOf('week');
    const end = date().endOf('month').endOf('week');
    const weekCount = Math.ceil(end.diff(start, 'days') / 7);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { sizes } = context;
            const goToDay = (0, _lodash.partial)((0, _toolbar.changeView)(context, 'month', {
                ...context.query
            }), 'day');
            const daySize = {
                width: Math.max(minEventWidth, Math.round((sizes.width - horizontalMargin) / 7)),
                height: Math.max(minEventHeight, Math.round((sizes.height - verticalMargin) / weekCount))
            };
            const weeks = (0, _lodash.range)(weekCount).map((w)=>({
                    goToDay,
                    context,
                    start: (0, _momentDefault.default)(start).add(w, 'weeks'),
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Week, {
                    ...props,
                    defaultDate: date
                }, i));
            const headers = (0, _lodash.range)(7).map((d)=>({
                    date: (0, _momentDefault.default)(start).add(d, 'days'),
                    daySize
                })).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
                    ...props
                }, i));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "planning month view",
                style: {
                    width: sizes.width - horizontalMargin
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "calendar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "headers",
                                children: headers
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "weeks",
                                children: weeks
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","@mui/material/Fade":"8DwqP","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","react-dnd":"9NZ1L","../../context":"iUP37","../../context/post":"8rmpk","./toolbar":"jRimY","../label":"59910","./event":"f1aJB","./month.styl":"bzoXG","planning/navigation":"7uOU2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bzoXG":[function() {},{}],"8OTFd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DayView);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _post = require("../../context/post");
var _toolbar = require("./toolbar");
var _toolbarDefault = parcelHelpers.interopDefault(_toolbar);
var _label = require("../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _confirmDialog = require("../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _dayStyl = require("./day.styl");
var _navigation = require("planning/navigation");
function Plan(props) {
    const { id, subject: subjectId = 'C1', group, context } = props;
    const subject = context.subjects.find((subject)=>subject.id == subjectId);
    const start = (0, _momentDefault.default)(props.start).format('YYYY-MM-DD');
    const finish = (0, _momentDefault.default)(props.finish).format('YYYY-MM-DD');
    const title = start == finish ? props.title : `${props.title}:  ${(0, _momentDefault.default)(props.start).format('MM/DD')} ${context.translate('to')} ${(0, _momentDefault.default)(props.finish).format('MM/DD')}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "schedule-plan",
        children: [
            subject && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "color-band-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "color-band",
                    style: {
                        backgroundColor: subject.color
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    title: title,
                    children: title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "actions-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "action preview",
                            onClick: ()=>{
                                (0, _navigation.planLink)(context, id, ()=>start, 'preview');
                            },
                            children: context.translate('preview_title')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "action edit",
                            onClick: ()=>{
                                (0, _navigation.planLink)(context, id, ()=>start);
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "edit_label"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "action duplicate",
                            onClick: ()=>{
                                const { navigate, view } = context;
                                navigate({
                                    view,
                                    planId: id
                                }, '/:languageId/:role/:page/:view/duplicate/:planId', {
                                    preserveQuery: true
                                });
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "duplicate"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "action delete",
                            onClick: ()=>(0, _confirmDialogDefault.default)({
                                    className: 'delete-plan',
                                    translate: context.translate,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "message",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "question",
                                                children: context.translate('confirm_delete_item')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "title",
                                                children: title
                                            })
                                        ]
                                    }),
                                    onConfirm: ()=>{
                                        (0, _post.deletePlan)(id).then(()=>{
                                            const planUpdates = props.context.planUpdates + 1;
                                            props.context.setState({
                                                planUpdates
                                            });
                                        });
                                    }
                                }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "delete_label"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function DayView(props) {
    const { date } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { groups, query, action } = context;
            const plans = context.plans.map((plan)=>{
                return {
                    ...plan,
                    context,
                    date
                };
            }).map((props, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Plan, {
                    ...props
                }, i));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "planning day view",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbarDefault.default), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "calendar",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "schedule-plans",
                            children: plans
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","moment":"1e4qG","@mui/material/Fade":"8DwqP","react":"9njXz","react-text":"lEpdJ","../../context":"iUP37","../../context/post":"8rmpk","./toolbar":"jRimY","../label":"59910","../confirm-dialog":"hzSdJ","./day.styl":"hXAcC","planning/navigation":"7uOU2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXAcC":[function() {},{}],"hzm0b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanView);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../../../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _confirmDialog = require("../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _topbar = require("./topbar");
var _topbarDefault = parcelHelpers.interopDefault(_topbar);
var _utils = require("../../../helpers/utils");
var _generalInfo = require("./general-info");
var _generalInfoDefault = parcelHelpers.interopDefault(_generalInfo);
var _groupDateInfo = require("./group-date-info");
var _groupDateInfoDefault = parcelHelpers.interopDefault(_groupDateInfo);
var _addLesson = require("./add-lesson");
var _addLessonDefault = parcelHelpers.interopDefault(_addLesson);
var _addStandard = require("./add-standard");
var _addStandardDefault = parcelHelpers.interopDefault(_addStandard);
var _addResource = require("./add-resource");
var _addResourceDefault = parcelHelpers.interopDefault(_addResource);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _planStyl = require("./plan.styl");
var _loader = require("../../loader");
function validatePlan(plan) {
    const missing = [
        'title',
        'grade',
        'subject',
        'clique'
    ].filter((field)=>(0, _utils.isEmpty)(plan[field]));
    return {
        canSave: missing.length == 0,
        missing
    };
}
function PlanView(props) {
    const { date } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan, languageId, link, loading } = context;
            const { items = [] } = newPlan;
            const validation = validatePlan(newPlan);
            const moveField = (drag, hover)=>{
                const field = newPlan.items[drag];
                const items = (0, _immutabilityHelperDefault.default)(newPlan.items, {
                    $splice: [
                        [
                            drag,
                            1
                        ],
                        [
                            hover,
                            0,
                            field
                        ]
                    ]
                });
                context.setState({
                    newPlan: {
                        ...newPlan,
                        items
                    }
                });
            };
            const deleteField = (index, title)=>{
                return ()=>{
                    (0, _confirmDialogDefault.default)({
                        className: 'delete-field',
                        translate: context.translate,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "message",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "question",
                                    children: context.translate('confirm_delete_item')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title",
                                    children: title
                                })
                            ]
                        }),
                        onConfirm: ()=>{
                            const items = (0, _immutabilityHelperDefault.default)(newPlan.items, {
                                $splice: [
                                    [
                                        index,
                                        1
                                    ]
                                ]
                            });
                            context.setState({
                                newPlan: {
                                    ...newPlan,
                                    items
                                }
                            });
                        }
                    });
                };
            };
            const fields = items.map((field, index)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldDefault.default), {
                    index: index,
                    id: field.id,
                    className: field.name,
                    moveField: moveField,
                    deleteField: deleteField(index, field.content.name),
                    context: context,
                    ...field.content
                }, field.id);
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "planning new view",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loader.Loader), {
                        isLoading: loading.isLoading
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _topbarDefault.default), {
                                plan: newPlan,
                                validation: validation,
                                updatePlan: (plan, afterUpdate)=>{
                                    context.setState({
                                        newPlan: plan
                                    }, afterUpdate);
                                }
                            }),
                            newPlan.id && // <Fade in={context.planUpdated}>
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                id: "new-plan",
                                className: "content-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            id: "fields",
                                            className: "fields",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoDefault.default), {
                                                    title: newPlan.title,
                                                    unit: newPlan.unit,
                                                    validation: validation
                                                }),
                                                fields
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "side-panel",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDateInfoDefault.default), {
                                                    validation: validation
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStandardDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addLessonDefault.default), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addResourceDefault.default), {})
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","@mui/material/Fade":"8DwqP","moment":"1e4qG","react":"9njXz","../../../context":"iUP37","../../confirm-dialog":"hzSdJ","./topbar":"FV1gb","../../../helpers/utils":"gGc98","./general-info":"98wEE","./group-date-info":"3h3Lt","./add-lesson":"1kPcE","./add-standard":"7o7tj","./add-resource":"8Wxwy","./field":"aGeKm","immutability-helper":"hwjCt","./plan.styl":"aByo9","../../loader":"dF5cj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"FV1gb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TopBar);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _utils = require("../../../helpers/utils");
var _context = require("../../../context");
var _addField = require("./add-field");
var _addFieldDefault = parcelHelpers.interopDefault(_addField);
var _templatesMenu = require("./templates-menu");
var _templatesMenuDefault = parcelHelpers.interopDefault(_templatesMenu);
var _confirmDialog = require("../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _planning = require("../../../helpers/planning");
var _post = require("../../../context/post");
var _topbarStyl = require("./topbar.styl");
var _lodash = require("lodash");
const buttonStyles = (0, _material.makeStyles)({
    root: {
        color: '#4e576e',
        width: '145px',
        textTransform: 'none',
        background: '#fff',
        '&:first-child': {
            'margin-left': '9px'
        },
        '&:hover': {
            background: '#eaf5ff'
        }
    }
});
const defaultDates = {
    month: (date)=>({
            start: (0, _momentDefault.default)(date).startOf('month').startOf('week').format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).endOf('month').endOf('week').format('YYYY-MM-DD')
        }),
    week: (date)=>({
            start: (0, _momentDefault.default)(date).startOf('week').format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).endOf('week').format('YYYY-MM-DD')
        }),
    day: (date)=>({
            start: (0, _momentDefault.default)(date).format('YYYY-MM-DD'),
            end: (0, _momentDefault.default)(date).format('YYYY-MM-DD')
        })
};
function TopBar(props) {
    const buttonClasses = buttonStyles();
    const { plan, validation, fieldsMenu } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { planTemplates, translate, navigate, link } = context;
            const templates = planTemplates.map((template)=>template.label == 'default' ? {
                    ...template,
                    label: translate('default_template_label')
                } : template).map((template)=>({
                    ...template,
                    label: template.label.replace('rd-', '')
                }));
            const template = templates.find(({ value })=>value === context.query.template);
            const applyTemplate = (option)=>{
                const { value: template, label } = option;
                if (context.query.template !== template) (0, _confirmDialogDefault.default)({
                    className: 'apply-template',
                    translate: translate,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "message",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "question",
                                children: translate('confirm_apply_template')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "title",
                                children: label
                            })
                        ]
                    }),
                    onConfirm: ()=>{
                        const query = {
                            template
                        };
                        navigate({}, context.match.path, {
                            preserveQuery: true,
                            query
                        });
                    }
                });
            };
            const addItem = (item)=>()=>{
                    const { content } = item;
                    const id = (0, _utils.uuid)();
                    const sections = content.sections.map((0, _planning.createPlanSection));
                    const items = (0, _immutabilityHelperDefault.default)(plan.items, {
                        $push: [
                            {
                                ...item,
                                id,
                                content: {
                                    ...content,
                                    sections
                                }
                            }
                        ]
                    });
                    props.updatePlan({
                        ...plan,
                        items
                    }, ()=>{
                        const wrapper = document.getElementById('new-plan');
                        const field = document.getElementById(id);
                        wrapper.scrollTo({
                            top: field.offsetTop,
                            behavior: 'smooth'
                        });
                    });
                };
            const currentItems = (plan.items || []).reduce((acc, { name })=>{
                acc[name] = true;
                return acc;
            }, {});
            const templateItems = context.templateItems.filter((item)=>item.name == 'annotations' || !currentItems[item.name]).map((field)=>({
                    ...field,
                    addItem: addItem(field)
                }));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "topbar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addFieldDefault.default), {
                        fields: fieldsMenu ?? templateItems,
                        rd: props?.rd
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _templatesMenuDefault.default), {
                        plan,
                        context,
                        rd: props?.rd
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "apply-template",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                            className: "templates",
                            classNamePrefix: "select-",
                            isSearchable: false,
                            value: template,
                            onChange: applyTemplate,
                            options: templates
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            display: 'flex',
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "cancel",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "contained",
                            className: buttonClasses.root,
                            onClick: ()=>{
                                context.navigate({
                                    view: context.newPlanFrom
                                }, '/:languageId/:role/:page/:view', {
                                    query: context.newPlanFromQuery
                                });
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "cancel_label"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "save",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                            variant: "contained",
                            className: buttonClasses.root,
                            disabled: !validation.canSave,
                            onClick: async ()=>{
                                const planToSave = (0, _lodash.cloneDeep)(plan);
                                planToSave.content = planToSave.content || {};
                                planToSave.content.source = context.page;
                                await (0, _post.savePlan)(planToSave, template ? template.id : undefined);
                                const query = {
                                    ...context.newPlanFromQuery,
                                    ...defaultDates[context.newPlanFrom](plan.start)
                                };
                                context.navigate({
                                    view: context.newPlanFrom
                                }, '/:languageId/:role/:page/:view', {
                                    query
                                });
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "save-plan-label"
                            })
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-select":"j36cq","react-text":"lEpdJ","immutability-helper":"hwjCt","external/material":"6yEDE","@mui/material/Button":"c6Y0y","../../../helpers/utils":"gGc98","../../../context":"iUP37","./add-field":"cNAgS","./templates-menu":"i4qG0","../../confirm-dialog":"hzSdJ","../../../helpers/planning":"5kcmd","../../../context/post":"8rmpk","./topbar.styl":"ePK89","lodash":"1qc47","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cNAgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddFieldMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _react1 = require("external/react");
var _context = require("teacher/context");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _dateFns = require("date-fns");
const useStyles = (0, _material.makeStyles)({
    add: {
        color: '#fff',
        background: '#2993ff',
        textTransform: 'none',
        '&:hover': {
            background: '#4e576e'
        }
    },
    item: {
        root: {
            minWidth: '200px',
            color: '#4e576e',
            padding: '10px',
            '&:hover': {
                color: '#fff',
                background: '#2993ff'
            }
        }
    }
});
//Discards time info
function getDateString(str = 'T') {
    switch(typeof str){
        case 'string':
            return str.split('T')[0];
        case 'object':
            return (0, _dateFns.format)(str, 'yyyy-MM-dd');
        default:
            return '';
    }
}
function AddFieldMenu(props) {
    const classes = useStyles();
    const context = (0, _react1.useContext)((0, _context.TeacherContext));
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const { newPlan: { start, finish, content } } = context;
    // We disregard the time so that the days are calculated correctly and allow planning for one day
    const differenceInDays = (0, _react.useMemo)(()=>{
        const startDate = (0, _dayjsDefault.default)(getDateString(start));
        const finishDate = (0, _dayjsDefault.default)(getDateString(finish));
        const dayDiff = finishDate.diff(startDate, 'days');
        return isNaN(dayDiff) ? 0 : dayDiff + 1;
    }, [
        start,
        finish
    ]);
    const thereIsAvaliableDays = (content?.dailyPlanning?.length ?? 0) < differenceInDays;
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    const fields = props.fields.map((field, key)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
            disableGutters: true,
            className: classes.item,
            onClick: ()=>{
                field.addItem();
                handleClose();
            },
            children: field.content.name
        }, key);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "add-field-menu",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                "aria-controls": "customized-menu",
                "aria-haspopup": "true",
                variant: "contained",
                disabled: !thereIsAvaliableDays,
                className: classes.add,
                onClick: (e)=>props?.rd ? props.fields.find((_, index)=>index === 0).addItem() : handleClick(e),
                children: props?.rd ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    style: {
                        margin: 0
                    },
                    children: "+ Planificaci\xf3n diaria"
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "add_field_label"
                })
            }),
            props?.rd ? null : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
                elevation: 0,
                getContentAnchorEl: null,
                className: classes.menu,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                id: "add-field-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: fields
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","external/react":"k16GP","teacher/context":"5LKDx","dayjs":"9FMDe","date-fns":"btU8f","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i4qG0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TemplatesMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _reactConfirmAlert = require("react-confirm-alert");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _post = require("../../../context/post");
var _utils = require("../../../helpers/utils");
var _keyboardArrowDown = require("@mui/icons-material/KeyboardArrowDown");
var _keyboardArrowDownDefault = parcelHelpers.interopDefault(_keyboardArrowDown);
const useStyles = (0, _material.makeStyles)({
    add: {
        color: '#4e576e',
        background: '#fff',
        textTransform: 'none',
        '&:hover': {
            background: '#eaf5ff'
        }
    },
    item: {
        minWidth: '200px',
        color: '#4e576e',
        padding: '10px',
        '&:hover': {
            color: '#fff',
            background: '#2993ff'
        }
    }
});
function SaveTemplateDialog(props) {
    const { context, plan, onClose, rd } = props;
    const { translate, setState, assessmentUpdates } = context;
    const [name, setName] = (0, _react.useState)(plan.title || "");
    const canSave = !(0, _utils.isEmpty)(name);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "save-template-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "title",
                children: translate('save_template_label')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    value: name,
                    type: "text",
                    onChange: (e)=>setName(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "buttons",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "save button",
                        disabled: !canSave,
                        onClick: ()=>{
                            if (rd) {
                                (0, _post.saveRDTemplate)(name, plan).then(()=>setState({
                                        templateUpdates: context.templateUpdates + 1
                                    }, onClose));
                                return;
                            }
                            (0, _post.saveTemplate)(name, plan).then(()=>setState({
                                    templateUpdates: context.templateUpdates + 1
                                }, onClose));
                        },
                        children: context.translate('save_label')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "cancel button",
                        onClick: onClose,
                        children: translate('cancel_label')
                    })
                ]
            })
        ]
    });
}
function saveTemplateDialog(props) {
    return (0, _reactConfirmAlert.confirmAlert)({
        customUI: ({ onClose })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SaveTemplateDialog, {
                ...props,
                onClose
            })
    });
}
function TemplatesMenu(props) {
    const { context, plan, rd } = props;
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "templates-menu",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonDefault.default), {
                "aria-controls": "customized-menu",
                "aria-haspopup": "true",
                variant: "contained",
                className: classes.add,
                onClick: handleClick,
                endIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _keyboardArrowDownDefault.default), {}),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "templates_label"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _menuDefault.default), {
                elevation: 0,
                getContentAnchorEl: null,
                className: classes.menu,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                id: "add-field-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        disableGutters: true,
                        className: classes.item,
                        onClick: ()=>{
                            saveTemplateDialog({
                                context,
                                plan,
                                rd
                            });
                            handleClose();
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "save_as_template"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        disableGutters: true,
                        className: classes.item,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            className: "manage-templates",
                            to: context.link({}, `${context.match.path}/templates`, {
                                preserveQuery: true
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "manage_templates"
                            })
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","external/material":"6yEDE","react-confirm-alert":"dyW9k","@mui/material/Button":"c6Y0y","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","../../../context/post":"8rmpk","../../../helpers/utils":"gGc98","@mui/icons-material/KeyboardArrowDown":"2TA6B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ePK89":[function() {},{}],"98wEE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GeneralInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../../context");
var _generalInfoStyl = require("./general-info.styl");
function GeneralInfo(props) {
    const { validation, title, unit } = props;
    const [titleValue, setTitleValue] = (0, _react.useState)(title);
    const [unitValue, setUnitValue] = (0, _react.useState)(unit);
    const addRequiredReminder = (field)=>{
        return validation.missing.indexOf(field) >= 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "required",
            children: "*"
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan, groups, myGrades, mySubjects, gradePrecedence, translate } = context;
            const setNewPlan = (props)=>context.setState({
                    newPlan: {
                        ...newPlan,
                        ...props
                    }
                });
            const group = groups.find((group)=>group.id == newPlan.clique);
            const grade = myGrades.find((grade)=>newPlan.grade == grade.id);
            const subjects = mySubjects.filter((subject)=>grade && subject.grades[grade.id]);
            const subject = subjects.find((subject)=>newPlan.subject == subject.id);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "general-info",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "sorter"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "name",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "general_info_label"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "title",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "label",
                                            children: [
                                                addRequiredReminder('title'),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "title_label"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "value",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                placeholder: translate('write_here'),
                                                type: "text",
                                                value: titleValue,
                                                onChange: ({ target })=>{
                                                    const title = target.value;
                                                    setTitleValue(title);
                                                    setTimeout(()=>{
                                                        if (title != titleValue) setNewPlan({
                                                            title
                                                        });
                                                    }, 2000);
                                                }
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "row selects",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                children: [
                                                    addRequiredReminder('clique'),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                        id: "group_label"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "value",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                                    className: "group",
                                                    classNamePrefix: "select",
                                                    formatOptionLabel: ({ name })=>name,
                                                    isSearchable: false,
                                                    isClearable: false,
                                                    escapeClearsValue: true,
                                                    getOptionValue: ({ id })=>id,
                                                    placeholder: context.translate("pick_one"),
                                                    value: group,
                                                    onChange: (option)=>{
                                                        setNewPlan({
                                                            clique: option.id,
                                                            subject: option.course.substring(0, 2),
                                                            grade: option.course.substring(4)
                                                        });
                                                    },
                                                    options: groups
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "grade",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "label",
                                                children: [
                                                    addRequiredReminder('grade'),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                        id: "grade_label"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "value",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                                    className: "grade",
                                                    placeholder: translate('pick_one'),
                                                    classNamePrefix: "select",
                                                    formatOptionLabel: (grade)=>grade.name,
                                                    getOptionValue: (grade)=>grade.id,
                                                    isSearchable: false,
                                                    value: grade,
                                                    onChange: (option)=>setNewPlan({
                                                            grade: option.id,
                                                            subject: undefined
                                                        }),
                                                    options: myGrades
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "subject",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "label",
                                                children: [
                                                    addRequiredReminder('subject'),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                        id: "subject_label"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "value",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                                                    className: "suject",
                                                    placeholder: translate('pick_one'),
                                                    classNamePrefix: "select",
                                                    formatOptionLabel: (subject)=>subject.name,
                                                    getOptionValue: (subject)=>subject.id,
                                                    isSearchable: false,
                                                    value: subject ? subject : null,
                                                    onChange: (option)=>setNewPlan({
                                                            subject: option.id
                                                        }),
                                                    options: subjects
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "unit",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "label",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "unit_label"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "value",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: translate('write_here'),
                                                    value: unitValue,
                                                    onChange: ({ target })=>{
                                                        const unit = target.value;
                                                        setUnitValue(unit);
                                                        setTimeout(()=>{
                                                            if (unit != unitValue) setNewPlan({
                                                                unit
                                                            });
                                                        }, 2000);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-select":"j36cq","react-text":"lEpdJ","../../../context":"iUP37","./general-info.styl":"cPwr4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cPwr4":[function() {},{}],"3h3Lt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GroupDateInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../../context");
var _datePicker = require("../../date-picker");
var _datePickerDefault = parcelHelpers.interopDefault(_datePicker);
var _timePicker = require("../../time-picker");
var _timePickerDefault = parcelHelpers.interopDefault(_timePicker);
var _groupDateInfoStyl = require("./group-date-info.styl");
function GroupDateInfo(props) {
    const { validation } = props;
    const addRequiredReminder = (field)=>{
        return validation.missing.indexOf(field) >= 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: "required",
            children: "*"
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan, languageId, translate } = context;
            const setNewPlan = (props)=>context.setState({
                    newPlan: {
                        ...newPlan,
                        ...props
                    }
                });
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "group-date-info",
                children: newPlan.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "date",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "date_label"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "from",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                            date: (0, _momentDefault.default)(newPlan.start).toDate(),
                                            languageId: languageId,
                                            minDate: (0, _momentDefault.default)().toDate(),
                                            setDate: (start)=>{
                                                const finish = (0, _momentDefault.default)(newPlan.finish).isAfter(start) ? newPlan.finish : (0, _momentDefault.default)(start).toDate();
                                                setNewPlan({
                                                    start,
                                                    finish
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "separator",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexDirection: 'column'
                                            },
                                            children: "-"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "to",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                            date: (0, _momentDefault.default)(newPlan.finish).toDate(),
                                            languageId: languageId,
                                            minDate: (0, _momentDefault.default)(newPlan.start).toDate(),
                                            setDate: (finish)=>{
                                                setNewPlan({
                                                    finish
                                                });
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","lodash":"1qc47","react":"9njXz","react-select":"j36cq","react-text":"lEpdJ","../../../context":"iUP37","../../date-picker":"61fBY","../../time-picker":"k3XqG","./group-date-info.styl":"aXwhr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"61fBY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Picker", ()=>Picker);
parcelHelpers.export(exports, "DatePicker", ()=>(0, _reactDatepickerDefault.default));
parcelHelpers.export(exports, "default", ()=>Picker);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _locale = require("date-fns/locale");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: this.props.value
        });
    }
}
(0, _reactDatepicker.registerLocale)("en", _locale.enUS);
(0, _reactDatepicker.registerLocale)("es", _locale.es);
function Picker(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
        customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
        selected: props.date,
        onChange: props.setDate,
        minDate: props.minDate,
        maxDate: props.maxDate,
        locale: props.languageId == 'en' ? _locale.enUS : _locale.es,
        popperPlacement: "auto-left",
        popperModifiers: {
            preventOverflow: {
                enabled: true,
                escapeWithReference: false,
                // force popper to stay in viewport (even when input is scrolled out of view)
                boundariesElement: 'viewport'
            }
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","date-fns/locale":"dElgW","react-datepicker/dist/react-datepicker.css":"chsuV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"k3XqG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Picker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTimePicker = require("react-time-picker");
var _reactTimePickerDefault = parcelHelpers.interopDefault(_reactTimePicker);
function Picker(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTimePickerDefault.default), {
        value: props.time,
        onChange: props.setTime,
        clearIcon: null,
        disableClock: true
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-time-picker":"fWSri","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fWSri":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
require("f8cb4891fa2a1dfe");
var _TimePicker = _interopRequireDefault(require("afc638b39a60b260"));
require("f562c5abdc133fc8");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
var _default = _TimePicker["default"];
exports["default"] = _default;

},{"f8cb4891fa2a1dfe":"kOLOA","afc638b39a60b260":"8hL9e","f562c5abdc133fc8":"13MKG"}],"kOLOA":[function() {},{}],"8hL9e":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("5843368b25ad812f"));
var _propTypes = _interopRequireDefault(require("f506e45e0a174a7e"));
var _reactLifecyclesCompat = require("89f70fc441433daf");
var _makeEventProps = _interopRequireDefault(require("8276334576e33899"));
var _mergeClassNames = _interopRequireDefault(require("bcbb89b6b7a6aaa3"));
var _reactFit = _interopRequireDefault(require("e6b9f60452c791d5"));
var _entry = _interopRequireDefault(require("1d8575b0f7aaacca"));
var _TimeInput = _interopRequireDefault(require("2fefa6d78848fbb9"));
var _propTypes2 = require("5a9c513e04d178bd");
var _utils = require("1205657bb629b061");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var allViews = [
    'hour',
    'minute',
    'second'
];
var baseClassName = 'react-time-picker';
var outsideActionEvents = [
    'mousedown',
    'focusin',
    'touchstart'
];
var TimePicker = /*#__PURE__*/ function(_PureComponent) {
    _inherits(TimePicker, _PureComponent);
    function TimePicker() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, TimePicker);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TimePicker)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "state", {});
        _defineProperty(_assertThisInitialized(_this), "onOutsideAction", function(event) {
            if (_this.wrapper && !_this.wrapper.contains(event.target)) _this.closeClock();
        });
        _defineProperty(_assertThisInitialized(_this), "onChange", function(value) {
            var closeClock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            _this.setState({
                isOpen: !closeClock
            });
            var onChange = _this.props.onChange;
            if (onChange) onChange(value);
        });
        _defineProperty(_assertThisInitialized(_this), "onFocus", function(event) {
            var _this$props = _this.props, disabled = _this$props.disabled, onFocus = _this$props.onFocus;
            if (onFocus) onFocus(event);
             // Internet Explorer still fires onFocus on disabled elements
            if (disabled) return;
            _this.openClock();
        });
        _defineProperty(_assertThisInitialized(_this), "openClock", function() {
            _this.setState({
                isOpen: true
            });
        });
        _defineProperty(_assertThisInitialized(_this), "closeClock", function() {
            _this.setState(function(prevState) {
                if (!prevState.isOpen) return null;
                return {
                    isOpen: false
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "toggleClock", function() {
            _this.setState(function(prevState) {
                return {
                    isOpen: !prevState.isOpen
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "stopPropagation", function(event) {
            return event.stopPropagation();
        });
        _defineProperty(_assertThisInitialized(_this), "clear", function() {
            return _this.onChange(null);
        });
        return _this;
    }
    _createClass(TimePicker, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.handleOutsideActionListeners();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var isOpen = this.state.isOpen;
                var _this$props2 = this.props, onClockClose = _this$props2.onClockClose, onClockOpen = _this$props2.onClockOpen;
                if (isOpen !== prevState.isOpen) {
                    this.handleOutsideActionListeners();
                    (0, _utils.callIfDefined)(isOpen ? onClockOpen : onClockClose);
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.handleOutsideActionListeners(false);
            }
        },
        {
            key: "handleOutsideActionListeners",
            value: function handleOutsideActionListeners(shouldListen) {
                var _this2 = this;
                var isOpen = this.state.isOpen;
                var shouldListenWithFallback = typeof shouldListen !== 'undefined' ? shouldListen : isOpen;
                var fnName = shouldListenWithFallback ? 'addEventListener' : 'removeEventListener';
                outsideActionEvents.forEach(function(eventName) {
                    return document[fnName](eventName, _this2.onOutsideAction);
                });
            }
        },
        {
            key: "renderInputs",
            value: function renderInputs() {
                var _this$props3 = this.props, amPmAriaLabel = _this$props3.amPmAriaLabel, autoFocus = _this$props3.autoFocus, clearAriaLabel = _this$props3.clearAriaLabel, clearIcon = _this$props3.clearIcon, clockAriaLabel = _this$props3.clockAriaLabel, clockIcon = _this$props3.clockIcon, disableClock = _this$props3.disableClock, disabled = _this$props3.disabled, format = _this$props3.format, hourAriaLabel = _this$props3.hourAriaLabel, hourPlaceholder = _this$props3.hourPlaceholder, isOpen = _this$props3.isOpen, locale = _this$props3.locale, maxDetail = _this$props3.maxDetail, maxTime = _this$props3.maxTime, minTime = _this$props3.minTime, minuteAriaLabel = _this$props3.minuteAriaLabel, minutePlaceholder = _this$props3.minutePlaceholder, name = _this$props3.name, nativeInputAriaLabel = _this$props3.nativeInputAriaLabel, required = _this$props3.required, secondAriaLabel = _this$props3.secondAriaLabel, secondPlaceholder = _this$props3.secondPlaceholder, value = _this$props3.value;
                var _concat = [].concat(value), _concat2 = _slicedToArray(_concat, 1), valueFrom = _concat2[0];
                var ariaLabelProps = {
                    amPmAriaLabel: amPmAriaLabel,
                    hourAriaLabel: hourAriaLabel,
                    minuteAriaLabel: minuteAriaLabel,
                    nativeInputAriaLabel: nativeInputAriaLabel,
                    secondAriaLabel: secondAriaLabel
                };
                var placeholderProps = {
                    hourPlaceholder: hourPlaceholder,
                    minutePlaceholder: minutePlaceholder,
                    secondPlaceholder: secondPlaceholder
                };
                return _react["default"].createElement("div", {
                    className: "".concat(baseClassName, "__wrapper")
                }, _react["default"].createElement(_TimeInput["default"], _extends({}, ariaLabelProps, placeholderProps, {
                    autoFocus: autoFocus,
                    className: "".concat(baseClassName, "__inputGroup"),
                    disabled: disabled,
                    format: format,
                    isClockOpen: isOpen,
                    locale: locale,
                    maxDetail: maxDetail,
                    maxTime: maxTime,
                    minTime: minTime,
                    name: name,
                    onChange: this.onChange,
                    placeholder: this.placeholder,
                    required: required,
                    value: valueFrom
                })), clearIcon !== null && _react["default"].createElement("button", {
                    "aria-label": clearAriaLabel,
                    className: "".concat(baseClassName, "__clear-button ").concat(baseClassName, "__button"),
                    disabled: disabled,
                    onClick: this.clear,
                    onFocus: this.stopPropagation,
                    type: "button"
                }, clearIcon), clockIcon !== null && !disableClock && _react["default"].createElement("button", {
                    "aria-label": clockAriaLabel,
                    className: "".concat(baseClassName, "__clock-button ").concat(baseClassName, "__button"),
                    disabled: disabled,
                    onBlur: this.resetValue,
                    onClick: this.toggleClock,
                    onFocus: this.stopPropagation,
                    type: "button"
                }, clockIcon));
            }
        },
        {
            key: "renderClock",
            value: function renderClock() {
                var disableClock = this.props.disableClock;
                var isOpen = this.state.isOpen;
                if (isOpen === null || disableClock) return null;
                var _this$props4 = this.props, clockClassName = _this$props4.clockClassName, timePickerClassName = _this$props4.className, maxDetail = _this$props4.maxDetail, onChange = _this$props4.onChange, value = _this$props4.value, clockProps = _objectWithoutProperties(_this$props4, [
                    "clockClassName",
                    "className",
                    "maxDetail",
                    "onChange",
                    "value"
                ]);
                var className = "".concat(baseClassName, "__clock");
                var _concat3 = [].concat(value), _concat4 = _slicedToArray(_concat3, 1), valueFrom = _concat4[0];
                var maxDetailIndex = allViews.indexOf(maxDetail);
                return _react["default"].createElement(_reactFit["default"], null, _react["default"].createElement("div", {
                    className: (0, _mergeClassNames["default"])(className, "".concat(className, "--").concat(isOpen ? 'open' : 'closed'))
                }, _react["default"].createElement(_entry["default"], _extends({
                    className: clockClassName,
                    renderMinuteHand: maxDetailIndex > 0,
                    renderSecondHand: maxDetailIndex > 1,
                    value: valueFrom
                }, clockProps))));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props5 = this.props, className = _this$props5.className, disabled = _this$props5.disabled;
                var isOpen = this.state.isOpen;
                return _react["default"].createElement("div", _extends({
                    className: (0, _mergeClassNames["default"])(baseClassName, "".concat(baseClassName, "--").concat(isOpen ? 'open' : 'closed'), "".concat(baseClassName, "--").concat(disabled ? 'disabled' : 'enabled'), className)
                }, this.eventProps, {
                    onFocus: this.onFocus,
                    ref: function ref(_ref) {
                        if (!_ref) return;
                        _this3.wrapper = _ref;
                    }
                }), this.renderInputs(), this.renderClock());
            }
        },
        {
            key: "eventProps",
            get: function get() {
                return (0, _makeEventProps["default"])(this.props);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.isOpen !== prevState.isOpenProps) return {
                    isOpen: nextProps.isOpen,
                    isOpenProps: nextProps.isOpen
                };
                return null;
            }
        }
    ]);
    return TimePicker;
}(_react.PureComponent);
exports["default"] = TimePicker;
var iconProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 19,
    height: 19,
    viewBox: '0 0 19 19',
    stroke: 'black',
    strokeWidth: 2
};
var ClockIcon = _react["default"].createElement("svg", _extends({}, iconProps, {
    className: "".concat(baseClassName, "__clock-button__icon ").concat(baseClassName, "__button__icon"),
    fill: "none"
}), _react["default"].createElement("circle", {
    cx: "9.5",
    cy: "9.5",
    r: "7.5"
}), _react["default"].createElement("path", {
    d: "M9.5 4.5 v5 h4"
}));
var ClearIcon = _react["default"].createElement("svg", _extends({}, iconProps, {
    className: "".concat(baseClassName, "__clear-button__icon ").concat(baseClassName, "__button__icon")
}), _react["default"].createElement("line", {
    x1: "4",
    x2: "15",
    y1: "4",
    y2: "15"
}), _react["default"].createElement("line", {
    x1: "15",
    x2: "4",
    y1: "4",
    y2: "15"
}));
TimePicker.defaultProps = {
    clearIcon: ClearIcon,
    clockIcon: ClockIcon,
    isOpen: null,
    maxDetail: 'minute'
};
var isValue = _propTypes["default"].oneOfType([
    _propTypes2.isTime,
    _propTypes["default"].instanceOf(Date)
]);
TimePicker.propTypes = {
    amPmAriaLabel: _propTypes["default"].string,
    autoFocus: _propTypes["default"].bool,
    className: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].arrayOf(_propTypes["default"].string)
    ]),
    clearAriaLabel: _propTypes["default"].string,
    clearIcon: _propTypes["default"].node,
    clockAriaLabel: _propTypes["default"].string,
    clockClassName: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].arrayOf(_propTypes["default"].string)
    ]),
    clockIcon: _propTypes["default"].node,
    disableClock: _propTypes["default"].bool,
    disabled: _propTypes["default"].bool,
    format: _propTypes["default"].string,
    hourAriaLabel: _propTypes["default"].string,
    hourPlaceholder: _propTypes["default"].string,
    isOpen: _propTypes["default"].bool,
    locale: _propTypes["default"].string,
    maxDetail: _propTypes["default"].oneOf(allViews),
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    minuteAriaLabel: _propTypes["default"].string,
    minutePlaceholder: _propTypes["default"].string,
    name: _propTypes["default"].string,
    nativeInputAriaLabel: _propTypes["default"].string,
    onChange: _propTypes["default"].func,
    onClockClose: _propTypes["default"].func,
    onClockOpen: _propTypes["default"].func,
    onFocus: _propTypes["default"].func,
    required: _propTypes["default"].bool,
    secondAriaLabel: _propTypes["default"].string,
    secondPlaceholder: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([
        isValue,
        _propTypes["default"].arrayOf(isValue)
    ])
};
(0, _reactLifecyclesCompat.polyfill)(TimePicker);

},{"5843368b25ad812f":"9njXz","f506e45e0a174a7e":"bnNSm","89f70fc441433daf":"9jQEY","8276334576e33899":"fzZDb","bcbb89b6b7a6aaa3":"6X3Jr","e6b9f60452c791d5":"iGryh","1d8575b0f7aaacca":"f7MyJ","2fefa6d78848fbb9":"3e7y1","5a9c513e04d178bd":"9Mzoe","1205657bb629b061":"gB09q"}],"fzZDb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clipboardEvents", ()=>clipboardEvents);
parcelHelpers.export(exports, "compositionEvents", ()=>compositionEvents);
parcelHelpers.export(exports, "focusEvents", ()=>focusEvents);
parcelHelpers.export(exports, "formEvents", ()=>formEvents);
parcelHelpers.export(exports, "imageEvents", ()=>imageEvents);
parcelHelpers.export(exports, "keyboardEvents", ()=>keyboardEvents);
parcelHelpers.export(exports, "mediaEvents", ()=>mediaEvents);
parcelHelpers.export(exports, "mouseEvents", ()=>mouseEvents);
parcelHelpers.export(exports, "dragEvents", ()=>dragEvents);
parcelHelpers.export(exports, "selectionEvents", ()=>selectionEvents);
parcelHelpers.export(exports, "touchEvents", ()=>touchEvents);
parcelHelpers.export(exports, "pointerEvents", ()=>pointerEvents);
parcelHelpers.export(exports, "uiEvents", ()=>uiEvents);
parcelHelpers.export(exports, "wheelEvents", ()=>wheelEvents);
parcelHelpers.export(exports, "animationEvents", ()=>animationEvents);
parcelHelpers.export(exports, "transitionEvents", ()=>transitionEvents);
parcelHelpers.export(exports, "otherEvents", ()=>otherEvents);
parcelHelpers.export(exports, "changeEvents", ()=>changeEvents);
parcelHelpers.export(exports, "allEvents", ()=>allEvents);
parcelHelpers.export(exports, "default", ()=>makeEventProps);
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var clipboardEvents = [
    'onCopy',
    'onCut',
    'onPaste'
];
var compositionEvents = [
    'onCompositionEnd',
    'onCompositionStart',
    'onCompositionUpdate'
];
var focusEvents = [
    'onFocus',
    'onBlur'
];
var formEvents = [
    'onInput',
    'onInvalid',
    'onReset',
    'onSubmit'
];
var imageEvents = [
    'onLoad',
    'onError'
];
var keyboardEvents = [
    'onKeyDown',
    'onKeyPress',
    'onKeyUp'
];
var mediaEvents = [
    'onAbort',
    'onCanPlay',
    'onCanPlayThrough',
    'onDurationChange',
    'onEmptied',
    'onEncrypted',
    'onEnded',
    'onError',
    'onLoadedData',
    'onLoadedMetadata',
    'onLoadStart',
    'onPause',
    'onPlay',
    'onPlaying',
    'onProgress',
    'onRateChange',
    'onSeeked',
    'onSeeking',
    'onStalled',
    'onSuspend',
    'onTimeUpdate',
    'onVolumeChange',
    'onWaiting'
];
var mouseEvents = [
    'onClick',
    'onContextMenu',
    'onDoubleClick',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseOut',
    'onMouseOver',
    'onMouseUp'
];
var dragEvents = [
    'onDrag',
    'onDragEnd',
    'onDragEnter',
    'onDragExit',
    'onDragLeave',
    'onDragOver',
    'onDragStart',
    'onDrop'
];
var selectionEvents = [
    'onSelect'
];
var touchEvents = [
    'onTouchCancel',
    'onTouchEnd',
    'onTouchMove',
    'onTouchStart'
];
var pointerEvents = [
    'onPointerDown',
    'onPointerMove',
    'onPointerUp',
    'onPointerCancel',
    'onGotPointerCapture',
    'onLostPointerCapture',
    'onPointerEnter',
    'onPointerLeave',
    'onPointerOver',
    'onPointerOut'
];
var uiEvents = [
    'onScroll'
];
var wheelEvents = [
    'onWheel'
];
var animationEvents = [
    'onAnimationStart',
    'onAnimationEnd',
    'onAnimationIteration'
];
var transitionEvents = [
    'onTransitionEnd'
];
var otherEvents = [
    'onToggle'
];
var changeEvents = [
    'onChange'
];
var allEvents = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], clipboardEvents, true), compositionEvents, true), focusEvents, true), formEvents, true), imageEvents, true), keyboardEvents, true), mediaEvents, true), mouseEvents, true), dragEvents, true), selectionEvents, true), touchEvents, true), pointerEvents, true), uiEvents, true), wheelEvents, true), animationEvents, true), transitionEvents, true), changeEvents, true), otherEvents, true);
function makeEventProps(props, getArgs) {
    var eventProps = {};
    allEvents.forEach(function(eventName) {
        var eventHandler = props[eventName];
        if (!eventHandler) return;
        if (getArgs) eventProps[eventName] = function(event) {
            return eventHandler(event, getArgs(eventName));
        };
        else eventProps[eventName] = eventHandler;
    });
    return eventProps;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iGryh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Fit", ()=>(0, _fitJsDefault.default));
var _fitJs = require("./Fit.js");
var _fitJsDefault = parcelHelpers.interopDefault(_fitJs);
exports.default = (0, _fitJsDefault.default);

},{"./Fit.js":"Oz7Nf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Oz7Nf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _detectElementOverflow = require("detect-element-overflow");
var _detectElementOverflowDefault = parcelHelpers.interopDefault(_detectElementOverflow);
var _tinyWarning = require("tiny-warning");
var _tinyWarningDefault = parcelHelpers.interopDefault(_tinyWarning);
'use client';
var __extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var __assign = undefined && undefined.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var isBrowser = typeof document !== 'undefined';
var isDisplayContentsSupported = isBrowser && 'CSS' in window && 'supports' in window.CSS && CSS.supports('display', 'contents');
var isMutationObserverSupported = isBrowser && 'MutationObserver' in window;
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function findScrollContainer(element) {
    var parent = element.parentElement;
    while(parent){
        var overflow = window.getComputedStyle(parent).overflow;
        if (overflow.split(' ').every(function(o) {
            return o === 'auto' || o === 'scroll';
        })) return parent;
        parent = parent.parentElement;
    }
    return document.documentElement;
}
function alignAxis(_a) {
    var axis = _a.axis, container = _a.container, element = _a.element, invertAxis = _a.invertAxis, scrollContainer = _a.scrollContainer, secondary = _a.secondary, spacing = _a.spacing;
    var style = window.getComputedStyle(element);
    var parent = container.parentElement;
    if (!parent) return;
    var scrollContainerCollisions = (0, _detectElementOverflowDefault.default)(parent, scrollContainer);
    var documentCollisions = (0, _detectElementOverflowDefault.default)(parent, document.documentElement);
    var isX = axis === 'x';
    var startProperty = isX ? 'left' : 'top';
    var endProperty = isX ? 'right' : 'bottom';
    var sizeProperty = isX ? 'width' : 'height';
    var overflowStartProperty = "overflow".concat(capitalize(startProperty));
    var overflowEndProperty = "overflow".concat(capitalize(endProperty));
    var scrollProperty = "scroll".concat(capitalize(startProperty));
    var uppercasedSizeProperty = capitalize(sizeProperty);
    var offsetSizeProperty = "offset".concat(uppercasedSizeProperty);
    var clientSizeProperty = "client".concat(uppercasedSizeProperty);
    var minSizeProperty = "min-".concat(sizeProperty);
    var scrollbarWidth = scrollContainer[offsetSizeProperty] - scrollContainer[clientSizeProperty];
    var startSpacing = typeof spacing === 'object' ? spacing[startProperty] : spacing;
    var availableStartSpace = -Math.max(scrollContainerCollisions[overflowStartProperty], documentCollisions[overflowStartProperty] + document.documentElement[scrollProperty]) - startSpacing;
    var endSpacing = typeof spacing === 'object' ? spacing[endProperty] : spacing;
    var availableEndSpace = -Math.max(scrollContainerCollisions[overflowEndProperty], documentCollisions[overflowEndProperty] - document.documentElement[scrollProperty]) - endSpacing - scrollbarWidth;
    if (secondary) {
        availableStartSpace += parent[clientSizeProperty];
        availableEndSpace += parent[clientSizeProperty];
    }
    var offsetSize = element[offsetSizeProperty];
    function displayStart() {
        element.style[startProperty] = 'auto';
        element.style[endProperty] = secondary ? '0' : '100%';
    }
    function displayEnd() {
        element.style[startProperty] = secondary ? '0' : '100%';
        element.style[endProperty] = 'auto';
    }
    function displayIfFits(availableSpace, display) {
        var fits = offsetSize <= availableSpace;
        if (fits) display();
        return fits;
    }
    function displayStartIfFits() {
        return displayIfFits(availableStartSpace, displayStart);
    }
    function displayEndIfFits() {
        return displayIfFits(availableEndSpace, displayEnd);
    }
    function displayWhereverShrinkedFits() {
        var moreSpaceStart = availableStartSpace > availableEndSpace;
        var rawMinSize = style.getPropertyValue(minSizeProperty);
        var minSize = rawMinSize ? parseInt(rawMinSize, 10) : null;
        function shrinkToSize(size) {
            (0, _tinyWarningDefault.default)(!minSize || size >= minSize, "<Fit />'s child will not fit anywhere with its current ".concat(minSizeProperty, " of ").concat(minSize, "px."));
            var newSize = Math.max(size, minSize || 0);
            (0, _tinyWarningDefault.default)(false, "<Fit />'s child needed to have its ".concat(sizeProperty, " decreased to ").concat(newSize, "px."));
            element.style[sizeProperty] = "".concat(newSize, "px");
        }
        if (moreSpaceStart) {
            shrinkToSize(availableStartSpace);
            displayStart();
        } else {
            shrinkToSize(availableEndSpace);
            displayEnd();
        }
    }
    var fits;
    if (invertAxis) fits = displayStartIfFits() || displayEndIfFits();
    else fits = displayEndIfFits() || displayStartIfFits();
    if (!fits) displayWhereverShrinkedFits();
}
function alignMainAxis(args) {
    alignAxis(args);
}
function alignSecondaryAxis(args) {
    alignAxis(__assign(__assign({}, args), {
        axis: args.axis === 'x' ? 'y' : 'x',
        secondary: true
    }));
}
function alignBothAxis(args) {
    var invertAxis = args.invertAxis, invertSecondaryAxis = args.invertSecondaryAxis, commonArgs = __rest(args, [
        "invertAxis",
        "invertSecondaryAxis"
    ]);
    alignMainAxis(__assign(__assign({}, commonArgs), {
        invertAxis: invertAxis
    }));
    alignSecondaryAxis(__assign(__assign({}, commonArgs), {
        invertAxis: invertSecondaryAxis
    }));
}
var Fit = /** @class */ function(_super) {
    __extends(Fit, _super);
    function Fit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fit = function() {
            var _a = _this, scrollContainer = _a.scrollContainer, container = _a.container, element = _a.element;
            if (!scrollContainer || !container || !element) return;
            var elementWidth = element.clientWidth;
            var elementHeight = element.clientHeight;
            // No need to recalculate - already did that for current dimensions
            if (_this.elementWidth === elementWidth && _this.elementHeight === elementHeight) return;
            // Save the dimensions so that we know we don't need to repeat the function if unchanged
            _this.elementWidth = elementWidth;
            _this.elementHeight = elementHeight;
            var parent = container.parentElement;
            // Container was unmounted
            if (!parent) return;
            /**
             * We need to ensure that <Fit />'s child has a absolute position. Otherwise,
             * we wouldn't be able to place the child in the correct position.
             */ var style = window.getComputedStyle(element);
            var position = style.position;
            if (position !== 'absolute') element.style.position = 'absolute';
            /**
             * We need to ensure that <Fit />'s parent has a relative or absolute position. Otherwise,
             * we wouldn't be able to place the child in the correct position.
             */ var parentStyle = window.getComputedStyle(parent);
            var parentPosition = parentStyle.position;
            if (parentPosition !== 'relative' && parentPosition !== 'absolute') parent.style.position = 'relative';
            var _b = _this.props, invertAxis = _b.invertAxis, invertSecondaryAxis = _b.invertSecondaryAxis, _c = _b.mainAxis, mainAxis = _c === void 0 ? 'y' : _c, _d = _b.spacing, spacing = _d === void 0 ? 8 : _d;
            alignBothAxis({
                axis: mainAxis,
                container: container,
                element: element,
                invertAxis: invertAxis,
                invertSecondaryAxis: invertSecondaryAxis,
                scrollContainer: scrollContainer,
                spacing: spacing
            });
        };
        return _this;
    }
    Fit.prototype.componentDidMount = function() {
        var _this = this;
        if (!isDisplayContentsSupported) {
            // eslint-disable-next-line react/no-find-dom-node
            var element = (0, _reactDom.findDOMNode)(this);
            if (!element || !(element instanceof HTMLElement)) return;
            this.container = element;
            this.element = element;
            this.scrollContainer = findScrollContainer(element);
        }
        this.fit();
        var onMutation = function() {
            _this.fit();
        };
        if (isMutationObserverSupported && this.element) {
            var mutationObserver = new MutationObserver(onMutation);
            mutationObserver.observe(this.element, {
                attributes: true,
                attributeFilter: [
                    'class',
                    'style'
                ]
            });
        }
    };
    Fit.prototype.render = function() {
        var _this = this;
        var children = this.props.children;
        var child = (0, _reactDefault.default).Children.only(children);
        if (isDisplayContentsSupported) return (0, _reactDefault.default).createElement("span", {
            ref: function(container) {
                _this.container = container;
                var element = container && container.firstElementChild;
                if (!element || !(element instanceof HTMLElement)) return;
                _this.element = element;
                _this.scrollContainer = findScrollContainer(element);
            },
            style: {
                display: 'contents'
            }
        }, child);
        return child;
    };
    Fit.propTypes = {
        children: (0, _propTypesDefault.default).node.isRequired,
        invertAxis: (0, _propTypesDefault.default).bool,
        invertSecondaryAxis: (0, _propTypesDefault.default).bool,
        mainAxis: (0, _propTypesDefault.default).oneOf([
            'x',
            'y'
        ]),
        spacing: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).shape({
                bottom: (0, _propTypesDefault.default).number.isRequired,
                left: (0, _propTypesDefault.default).number.isRequired,
                right: (0, _propTypesDefault.default).number.isRequired,
                top: (0, _propTypesDefault.default).number.isRequired
            })
        ])
    };
    return Fit;
}((0, _react.Component));
exports.default = Fit;

},{"react":"9njXz","react-dom":"2ApDx","prop-types":"bnNSm","detect-element-overflow":"c0TGa","tiny-warning":"5e17w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c0TGa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>detectElementOverflow);
function getRect(element) {
    return element.getBoundingClientRect();
}
function detectElementOverflow(element, container) {
    return {
        get collidedTop () {
            return getRect(element).top < getRect(container).top;
        },
        get collidedBottom () {
            return getRect(element).bottom > getRect(container).bottom;
        },
        get collidedLeft () {
            return getRect(element).left < getRect(container).left;
        },
        get collidedRight () {
            return getRect(element).right > getRect(container).right;
        },
        get overflowTop () {
            return getRect(container).top - getRect(element).top;
        },
        get overflowBottom () {
            return getRect(element).bottom - getRect(container).bottom;
        },
        get overflowLeft () {
            return getRect(container).left - getRect(element).left;
        },
        get overflowRight () {
            return getRect(element).right - getRect(container).right;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7MyJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Clock", {
    enumerable: true,
    get: function get() {
        return _Clock["default"];
    }
});
exports["default"] = void 0;
var _Clock = _interopRequireDefault(require("d55aa0e51d3dc472"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var _default = _Clock["default"];
exports["default"] = _default;

},{"d55aa0e51d3dc472":"dlpby"}],"dlpby":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Clock;
var _react = _interopRequireDefault(require("86d38fec13dbca09"));
var _propTypes = _interopRequireDefault(require("3fcae8d2e71a84c9"));
var _mergeClassNames = _interopRequireDefault(require("1ddfbc725a0e67ac"));
var _Hand = _interopRequireDefault(require("ad42ed63fc4490f0"));
var _Mark = _interopRequireDefault(require("5b3ec6b237d2ffd0"));
var _dates = require("8ea2d9fa36fd1ddf");
var _propTypes2 = require("fc1cc92922601cb");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function Clock(_ref) {
    var className = _ref.className, hourHandLength = _ref.hourHandLength, hourHandOppositeLength = _ref.hourHandOppositeLength, hourHandWidth = _ref.hourHandWidth, hourMarksLength = _ref.hourMarksLength, hourMarksWidth = _ref.hourMarksWidth, minuteHandLength = _ref.minuteHandLength, minuteHandOppositeLength = _ref.minuteHandOppositeLength, minuteHandWidth = _ref.minuteHandWidth, minuteMarksLength = _ref.minuteMarksLength, minuteMarksWidth = _ref.minuteMarksWidth, renderHourMarks = _ref.renderHourMarks, renderMinuteHand = _ref.renderMinuteHand, renderMinuteMarks = _ref.renderMinuteMarks, renderNumbers = _ref.renderNumbers, renderSecondHand = _ref.renderSecondHand, secondHandLength = _ref.secondHandLength, secondHandOppositeLength = _ref.secondHandOppositeLength, secondHandWidth = _ref.secondHandWidth, size = _ref.size, value = _ref.value;
    function renderMinuteMarksFn() {
        if (!renderMinuteMarks) return null;
        var minuteMarks = [];
        for(var i = 1; i <= 60; i += 1){
            var isHourMark = renderHourMarks && !(i % 5);
            if (!isHourMark) minuteMarks.push(_react["default"].createElement(_Mark["default"], {
                key: "minute_".concat(i),
                angle: i * 6,
                length: minuteMarksLength,
                name: "minute",
                width: minuteMarksWidth
            }));
        }
        return minuteMarks;
    }
    function renderHourMarksFn() {
        if (!renderHourMarks) return null;
        var hourMarks = [];
        for(var i = 1; i <= 12; i += 1)hourMarks.push(_react["default"].createElement(_Mark["default"], {
            key: "hour_".concat(i),
            angle: i * 30,
            length: hourMarksLength,
            name: "hour",
            number: renderNumbers ? i : null,
            width: hourMarksWidth
        }));
        return hourMarks;
    }
    function renderFace() {
        return _react["default"].createElement("div", {
            className: "react-clock__face"
        }, renderMinuteMarksFn(), renderHourMarksFn());
    }
    function renderHourHandFn() {
        var angle = value ? (0, _dates.getHours)(value) * 30 + (0, _dates.getMinutes)(value) / 2 + (0, _dates.getSeconds)(value) / 600 : 0;
        return _react["default"].createElement(_Hand["default"], {
            angle: angle,
            length: hourHandLength,
            name: "hour",
            oppositeLength: hourHandOppositeLength,
            width: hourHandWidth
        });
    }
    function renderMinuteHandFn() {
        if (!renderMinuteHand) return null;
        var angle = value ? (0, _dates.getHours)(value) * 360 + (0, _dates.getMinutes)(value) * 6 + (0, _dates.getSeconds)(value) / 10 : 0;
        return _react["default"].createElement(_Hand["default"], {
            angle: angle,
            length: minuteHandLength,
            name: "minute",
            oppositeLength: minuteHandOppositeLength,
            width: minuteHandWidth
        });
    }
    function renderSecondHandFn() {
        if (!renderSecondHand) return null;
        var angle = value ? (0, _dates.getMinutes)(value) * 360 + (0, _dates.getSeconds)(value) * 6 : 0;
        return _react["default"].createElement(_Hand["default"], {
            angle: angle,
            length: secondHandLength,
            name: "second",
            oppositeLength: secondHandOppositeLength,
            width: secondHandWidth
        });
    }
    return _react["default"].createElement("time", {
        className: (0, _mergeClassNames["default"])('react-clock', className),
        dateTime: value instanceof Date ? value.toISOString() : value,
        style: {
            width: "".concat(size, "px"),
            height: "".concat(size, "px")
        }
    }, renderFace(), renderHourHandFn(), renderMinuteHandFn(), renderSecondHandFn());
}
Clock.defaultProps = {
    hourHandLength: 50,
    hourHandWidth: 4,
    hourMarksLength: 10,
    hourMarksWidth: 3,
    minuteHandLength: 70,
    minuteHandWidth: 2,
    minuteMarksLength: 6,
    minuteMarksWidth: 1,
    renderHourMarks: true,
    renderMinuteHand: true,
    renderMinuteMarks: true,
    renderSecondHand: true,
    secondHandLength: 90,
    secondHandWidth: 1,
    size: 150
};
Clock.propTypes = {
    className: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].arrayOf(_propTypes["default"].string)
    ]),
    hourHandLength: _propTypes2.isHandLength,
    hourHandOppositeLength: _propTypes2.isOppositeHandLength,
    hourHandWidth: _propTypes2.isHandWidth,
    hourMarksLength: _propTypes2.isMarkLength,
    hourMarksWidth: _propTypes2.isMarkWidth,
    minuteHandLength: _propTypes2.isHandLength,
    minuteHandOppositeLength: _propTypes2.isOppositeHandLength,
    minuteHandWidth: _propTypes2.isHandWidth,
    minuteMarksLength: _propTypes2.isMarkLength,
    minuteMarksWidth: _propTypes2.isMarkWidth,
    renderHourMarks: _propTypes["default"].bool,
    renderMinuteHand: _propTypes["default"].bool,
    renderMinuteMarks: _propTypes["default"].bool,
    renderNumbers: _propTypes["default"].bool,
    renderSecondHand: _propTypes["default"].bool,
    secondHandLength: _propTypes2.isHandLength,
    secondHandOppositeLength: _propTypes2.isOppositeHandLength,
    secondHandWidth: _propTypes2.isHandWidth,
    size: _propTypes["default"].number,
    value: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].instanceOf(Date)
    ])
};

},{"86d38fec13dbca09":"9njXz","3fcae8d2e71a84c9":"bnNSm","1ddfbc725a0e67ac":"6X3Jr","ad42ed63fc4490f0":"02IKC","5b3ec6b237d2ffd0":"adFB1","8ea2d9fa36fd1ddf":"a82yt","fc1cc92922601cb":"ayvC4"}],"02IKC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Hand;
var _react = _interopRequireDefault(require("e9de1ed7833691ad"));
var _propTypes = _interopRequireDefault(require("4c0396a3d659ad72"));
var _propTypes2 = require("141d820fc3b86df");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function Hand(_ref) {
    var angle = _ref.angle, name = _ref.name, length = _ref.length, oppositeLength = _ref.oppositeLength, width = _ref.width;
    return _react["default"].createElement("div", {
        className: "react-clock__hand react-clock__".concat(name, "-hand"),
        style: {
            transform: "rotate(".concat(angle, "deg)")
        }
    }, _react["default"].createElement("div", {
        className: "react-clock__hand__body react-clock__".concat(name, "-hand__body"),
        style: {
            width: "".concat(width, "px"),
            top: "".concat(50 - length / 2, "%"),
            bottom: "".concat(50 - oppositeLength / 2, "%")
        }
    }));
}
Hand.defaultProps = {
    angle: 0,
    length: 100,
    oppositeLength: 10,
    width: 1
};
Hand.propTypes = {
    angle: _propTypes["default"].number,
    length: _propTypes2.isHandLength,
    name: _propTypes["default"].string.isRequired,
    oppositeLength: _propTypes2.isHandLength,
    width: _propTypes["default"].number
};

},{"e9de1ed7833691ad":"9njXz","4c0396a3d659ad72":"bnNSm","141d820fc3b86df":"ayvC4"}],"ayvC4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMarkWidth = exports.isMarkLength = exports.isHandWidth = exports.isOppositeHandLength = exports.isHandLength = void 0;
var _utils = require("3f2730585c740c08");
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var isNumberBetween = function isNumberBetween(min, max) {
    return function(props, propName, componentName) {
        var value = props[propName];
        if ((0, _utils.isDefined)(value)) {
            if (typeof value !== 'number') return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(value), "` supplied to `").concat(componentName, "`, expected `number`."));
            if (value < min || value > max) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(value), "` supplied to `").concat(componentName, "`, length must be between ").concat(min, " and ").concat(max, "."));
        } // Everything is fine
        return null;
    };
};
var isHandLength = isNumberBetween(0, 100);
exports.isHandLength = isHandLength;
var isOppositeHandLength = isNumberBetween(-100, 100);
exports.isOppositeHandLength = isOppositeHandLength;
var isHandWidth = function isHandWidth(props, propName, componentName) {
    var width = props[propName];
    if ((0, _utils.isDefined)(width)) {
        if (typeof width !== 'number') return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(width), "` supplied to `").concat(componentName, "`, expected `number`."));
        if (width < 0) return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(width), "` supplied to `").concat(componentName, "`, width must be greater or equal to 0."));
    } // Everything is fine
    return null;
};
exports.isHandWidth = isHandWidth;
var isMarkLength = isHandLength;
exports.isMarkLength = isMarkLength;
var isMarkWidth = isHandWidth;
exports.isMarkWidth = isMarkWidth;

},{"3f2730585c740c08":"7u97D"}],"7u97D":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isDefined = void 0;
/* eslint-disable import/prefer-default-export */ /**
 * Checks whether a variable is defined.
 *
 * @param {*} variable Variable to check
 */ var isDefined = function isDefined(variable) {
    return typeof variable !== 'undefined';
};
exports.isDefined = isDefined;

},{}],"adFB1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Mark;
var _react = _interopRequireDefault(require("4c310b096ca1391d"));
var _propTypes = _interopRequireDefault(require("d3f9bcd04a4cd532"));
var _propTypes2 = require("67a5a6f34cb07561");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function Mark(_ref) {
    var angle = _ref.angle, length = _ref.length, name = _ref.name, width = _ref.width, number = _ref.number;
    return _react["default"].createElement("div", {
        className: "react-clock__mark react-clock__".concat(name, "-mark"),
        style: {
            transform: "rotate(".concat(angle, "deg)")
        }
    }, _react["default"].createElement("div", {
        className: "react-clock__mark__body react-clock__".concat(name, "-mark__body"),
        style: {
            width: "".concat(width, "px"),
            top: 0,
            bottom: "".concat(100 - length / 2, "%")
        }
    }), number && _react["default"].createElement("div", {
        className: "react-clock__mark__number",
        style: {
            transform: "rotate(-".concat(angle, "deg)"),
            top: "".concat(length / 2, "%")
        }
    }, number));
}
Mark.defaultProps = {
    angle: 0,
    length: 10,
    width: 1
};
Mark.propTypes = {
    angle: _propTypes["default"].number,
    length: _propTypes2.isMarkLength,
    name: _propTypes["default"].string.isRequired,
    number: _propTypes["default"].number,
    width: _propTypes2.isMarkWidth
};

},{"4c310b096ca1391d":"9njXz","d3f9bcd04a4cd532":"bnNSm","67a5a6f34cb07561":"ayvC4"}],"a82yt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHours = getHours;
exports.getMinutes = getMinutes;
exports.getSeconds = getSeconds;
var hourOptionalSecondsRegExp = /^(([0-1])?[0-9]|2[0-3]):[0-5][0-9](:([0-5][0-9]))?$/;
var hourRegExp = /^(([0-1])?[0-9]|2[0-3]):[0-5][0-9]:([0-5][0-9])$/;
function getHours(date) {
    if (date instanceof Date) return date.getHours();
    if (typeof date === 'string' && hourOptionalSecondsRegExp.test(date)) {
        var hourString = date.split(':')[0];
        return parseInt(hourString, 10);
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
function getMinutes(date) {
    if (date instanceof Date) return date.getMinutes();
    if (typeof date === 'string' && hourOptionalSecondsRegExp.test(date)) {
        var minuteString = date.split(':')[1];
        return parseInt(minuteString, 10);
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
function getSeconds(date) {
    if (date instanceof Date) return date.getSeconds();
    if (typeof date === 'string') {
        if (hourRegExp.test(date)) {
            var secondString = date.split(':')[2];
            return parseInt(secondString, 10);
        }
        if (hourOptionalSecondsRegExp.test(date)) return 0;
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}

},{}],"3e7y1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("3450c778800dea2"));
var _propTypes = _interopRequireDefault(require("345ac6127004de58"));
var _reactLifecyclesCompat = require("d34ee9607a712b7");
var _dateUtils = require("3fba7a4c2d4f121f");
var _Divider = _interopRequireDefault(require("cbdb8187feecdc45"));
var _Hour12Input = _interopRequireDefault(require("7ffe3870108c2fff"));
var _Hour24Input = _interopRequireDefault(require("6234bf0d3128b770"));
var _MinuteInput = _interopRequireDefault(require("417e86ac601a75ae"));
var _SecondInput = _interopRequireDefault(require("e5c2b360a4cefaa8"));
var _NativeInput = _interopRequireDefault(require("9abc9f2a46d22f0b"));
var _AmPm = _interopRequireDefault(require("73646736082e09e9"));
var _dateFormatter = require("7f0d165fb8ef856c");
var _dates = require("bb0dcb90bf065de7");
var _propTypes2 = require("69502508856483ff");
var _utils = require("97908f6da0a0faf5");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var allViews = [
    'hour',
    'minute',
    'second'
];
function hoursAreDifferent(date1, date2) {
    return date1 && !date2 || !date1 && date2 || date1 && date2 && date1 !== date2 // TODO: Compare 11:22:00 and 11:22 properly
    ;
}
function isValidInput(element) {
    return element.tagName === 'INPUT' && element.type === 'number';
}
function findInput(element, property) {
    var nextElement = element;
    do nextElement = nextElement[property];
    while (nextElement && !isValidInput(nextElement));
    return nextElement;
}
function focus(element) {
    if (element) element.focus();
}
function _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances) {
    var usedFunctions = [];
    var pattern = new RegExp(Object.keys(elementFunctions).map(function(el) {
        return "".concat(el, "+");
    }).join('|'), 'g');
    var matches = placeholder.match(pattern);
    return placeholder.split(pattern).reduce(function(arr, element, index) {
        var divider = element && // eslint-disable-next-line react/no-array-index-key
        _react["default"].createElement(_Divider["default"], {
            key: "separator_".concat(index)
        }, element);
        var res = [].concat(_toConsumableArray(arr), [
            divider
        ]);
        var currentMatch = matches && matches[index];
        if (currentMatch) {
            var renderFunction = elementFunctions[currentMatch] || elementFunctions[Object.keys(elementFunctions).find(function(elementFunction) {
                return currentMatch.match(elementFunction);
            })];
            if (!allowMultipleInstances && usedFunctions.includes(renderFunction)) res.push(currentMatch);
            else {
                res.push(renderFunction(currentMatch, index));
                usedFunctions.push(renderFunction);
            }
        }
        return res;
    }, []);
}
var TimeInput = /*#__PURE__*/ function(_PureComponent) {
    _inherits(TimeInput, _PureComponent);
    function TimeInput() {
        var _getPrototypeOf2;
        var _this;
        _classCallCheck(this, TimeInput);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TimeInput)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        _defineProperty(_assertThisInitialized(_this), "state", {
            amPm: null,
            hour: null,
            minute: null,
            second: null
        });
        _defineProperty(_assertThisInitialized(_this), "onClick", function(event) {
            if (event.target === event.currentTarget) {
                // Wrapper was directly clicked
                var firstInput = event.target.children[1];
                focus(firstInput);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onKeyDown", function(event) {
            switch(event.key){
                case 'ArrowLeft':
                case 'ArrowRight':
                case _this.divider:
                    event.preventDefault();
                    var input = event.target;
                    var property = event.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling';
                    var nextInput = findInput(input, property);
                    focus(nextInput);
                    break;
                default:
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onKeyUp", function(event) {
            var key = event.key, input = event.target;
            var isNumberKey = !isNaN(parseInt(key, 10));
            if (!isNumberKey) return;
            var value = input.value;
            var max = input.getAttribute('max');
            /**
       * Given 1, the smallest possible number the user could type by adding another digit is 10.
       * 10 would be a valid value given max = 12, so we won't jump to the next input.
       * However, given 2, smallers possible number would be 20, and thus keeping the focus in
       * this field doesn't make sense.
       */ if (value * 10 > max || value.length >= max.length) {
                var property = 'nextElementSibling';
                var nextInput = findInput(input, property);
                focus(nextInput);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onChange", function(event) {
            var _event$target = event.target, name = _event$target.name, value = _event$target.value;
            switch(name){
                case 'hour12':
                    _this.setState(function(prevState) {
                        return {
                            hour: value ? (0, _dates.convert12to24)(parseInt(value, 10), prevState.amPm) : null
                        };
                    }, _this.onChangeExternal);
                    break;
                case 'hour24':
                    _this.setState({
                        hour: value ? parseInt(value, 10) : null
                    }, _this.onChangeExternal);
                    break;
                default:
                    _this.setState(_defineProperty({}, name, value ? parseInt(value, 10) : null), _this.onChangeExternal);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "onChangeNative", function(event) {
            var onChange = _this.props.onChange;
            var value = event.target.value;
            if (!onChange) return;
            var processedValue = function() {
                if (!value) return null;
                return value;
            }();
            onChange(processedValue, false);
        });
        _defineProperty(_assertThisInitialized(_this), "onChangeAmPm", function(event) {
            var value = event.target.value;
            _this.setState({
                amPm: value
            }, _this.onChangeExternal);
        });
        _defineProperty(_assertThisInitialized(_this), "onChangeExternal", function() {
            var onChange = _this.props.onChange;
            if (!onChange) return;
            var formElements = [
                _this.hour12Input,
                _this.hour24Input,
                _this.minuteInput,
                _this.secondInput,
                _this.amPmInput
            ].filter(Boolean);
            var formElementsWithoutSelect = formElements.slice(0, -1);
            var values = {};
            formElements.forEach(function(formElement) {
                values[formElement.name] = formElement.value;
            });
            if (formElementsWithoutSelect.every(function(formElement) {
                return !formElement.value;
            })) onChange(null, false);
            else if (formElements.every(function(formElement) {
                return formElement.value && formElement.checkValidity();
            })) {
                var hour = parseInt(values.hour24 || (0, _dates.convert12to24)(values.hour12, values.amPm) || 0, 10);
                var minute = parseInt(values.minute || 0, 10);
                var second = parseInt(values.second || 0, 10);
                var padStart = function padStart(num) {
                    return "0".concat(num).slice(-2);
                };
                var proposedValue = "".concat(padStart(hour), ":").concat(padStart(minute), ":").concat(padStart(second));
                var processedValue = _this.getProcessedValue(proposedValue);
                onChange(processedValue, false);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "renderHour", function(currentMatch, index) {
            if (/h/.test(currentMatch)) return _this.renderHour12(currentMatch, index);
            return _this.renderHour24(currentMatch, index);
        });
        _defineProperty(_assertThisInitialized(_this), "renderHour12", function(currentMatch, index) {
            var _this$props = _this.props, autoFocus = _this$props.autoFocus, hourAriaLabel = _this$props.hourAriaLabel, hourPlaceholder = _this$props.hourPlaceholder;
            var _this$state = _this.state, amPm = _this$state.amPm, hour = _this$state.hour;
            if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
            var showLeadingZeros = currentMatch && currentMatch.length === 2;
            return _react["default"].createElement(_Hour12Input["default"], _extends({
                key: "hour12"
            }, _this.commonInputProps, {
                amPm: amPm,
                ariaLabel: hourAriaLabel,
                autoFocus: index === 0 && autoFocus,
                placeholder: hourPlaceholder,
                showLeadingZeros: showLeadingZeros,
                value: hour
            }));
        });
        _defineProperty(_assertThisInitialized(_this), "renderHour24", function(currentMatch, index) {
            var _this$props2 = _this.props, autoFocus = _this$props2.autoFocus, hourAriaLabel = _this$props2.hourAriaLabel, hourPlaceholder = _this$props2.hourPlaceholder;
            var hour = _this.state.hour;
            if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
            var showLeadingZeros = currentMatch && currentMatch.length === 2;
            return _react["default"].createElement(_Hour24Input["default"], _extends({
                key: "hour24"
            }, _this.commonInputProps, {
                ariaLabel: hourAriaLabel,
                autoFocus: index === 0 && autoFocus,
                placeholder: hourPlaceholder,
                showLeadingZeros: showLeadingZeros,
                value: hour
            }));
        });
        _defineProperty(_assertThisInitialized(_this), "renderMinute", function(currentMatch, index) {
            var _this$props3 = _this.props, autoFocus = _this$props3.autoFocus, minuteAriaLabel = _this$props3.minuteAriaLabel, minutePlaceholder = _this$props3.minutePlaceholder;
            var _this$state2 = _this.state, hour = _this$state2.hour, minute = _this$state2.minute;
            if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
            var showLeadingZeros = currentMatch && currentMatch.length === 2;
            return _react["default"].createElement(_MinuteInput["default"], _extends({
                key: "minute"
            }, _this.commonInputProps, {
                ariaLabel: minuteAriaLabel,
                autoFocus: index === 0 && autoFocus,
                hour: hour,
                placeholder: minutePlaceholder,
                showLeadingZeros: showLeadingZeros,
                value: minute
            }));
        });
        _defineProperty(_assertThisInitialized(_this), "renderSecond", function(currentMatch, index) {
            var _this$props4 = _this.props, autoFocus = _this$props4.autoFocus, secondAriaLabel = _this$props4.secondAriaLabel, secondPlaceholder = _this$props4.secondPlaceholder;
            var _this$state3 = _this.state, hour = _this$state3.hour, minute = _this$state3.minute, second = _this$state3.second;
            if (currentMatch && currentMatch.length > 2) throw new Error("Unsupported token: ".concat(currentMatch));
            var showLeadingZeros = currentMatch ? currentMatch.length === 2 : true;
            return _react["default"].createElement(_SecondInput["default"], _extends({
                key: "second"
            }, _this.commonInputProps, {
                ariaLabel: secondAriaLabel,
                autoFocus: index === 0 && autoFocus,
                hour: hour,
                minute: minute,
                placeholder: secondPlaceholder,
                showLeadingZeros: showLeadingZeros,
                value: second
            }));
        });
        _defineProperty(_assertThisInitialized(_this), "renderAmPm", function(currentMatch, index) {
            var _this$props5 = _this.props, amPmAriaLabel = _this$props5.amPmAriaLabel, autoFocus = _this$props5.autoFocus, locale = _this$props5.locale;
            var amPm = _this.state.amPm;
            return _react["default"].createElement(_AmPm["default"], _extends({
                key: "ampm"
            }, _this.commonInputProps, {
                ariaLabel: amPmAriaLabel,
                autoFocus: index === 0 && autoFocus,
                locale: locale,
                onChange: _this.onChangeAmPm,
                value: amPm
            }));
        });
        return _this;
    }
    _createClass(TimeInput, [
        {
            key: "getProcessedValue",
            /**
     * Gets current value in a desired format.
     */ value: function getProcessedValue(value) {
                var nativeValueParser = this.nativeValueParser;
                return nativeValueParser(value);
            }
        },
        {
            key: "renderCustomInputs",
            value: function renderCustomInputs() {
                var placeholder = this.placeholder;
                var format = this.props.format;
                var elementFunctions = {
                    h: this.renderHour,
                    H: this.renderHour,
                    m: this.renderMinute,
                    s: this.renderSecond,
                    a: this.renderAmPm
                };
                var allowMultipleInstances = typeof format !== 'undefined';
                return _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances);
            }
        },
        {
            key: "renderNativeInput",
            value: function renderNativeInput() {
                var _this$props6 = this.props, disabled = _this$props6.disabled, maxTime = _this$props6.maxTime, minTime = _this$props6.minTime, name = _this$props6.name, nativeInputAriaLabel = _this$props6.nativeInputAriaLabel, required = _this$props6.required, value = _this$props6.value;
                return _react["default"].createElement(_NativeInput["default"], {
                    key: "time",
                    ariaLabel: nativeInputAriaLabel,
                    disabled: disabled,
                    maxTime: maxTime,
                    minTime: minTime,
                    name: name,
                    onChange: this.onChangeNative,
                    required: required,
                    value: value,
                    valueType: this.valueType
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var className = this.props.className;
                /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/no-static-element-interactions */ return _react["default"].createElement("div", {
                    className: className,
                    onClick: this.onClick
                }, this.renderNativeInput(), this.renderCustomInputs());
            }
        },
        {
            key: "formatTime",
            get: function get() {
                var maxDetail = this.props.maxDetail;
                var options = {
                    hour: 'numeric'
                };
                var level = allViews.indexOf(maxDetail);
                if (level >= 1) options.minute = 'numeric';
                if (level >= 2) options.second = 'numeric';
                return (0, _dateFormatter.getFormatter)(options);
            } // eslint-disable-next-line class-methods-use-this
        },
        {
            key: "formatNumber",
            get: function get() {
                var options = {
                    useGrouping: false
                };
                return (0, _dateFormatter.getFormatter)(options);
            }
        },
        {
            key: "valueType",
            get: function get() {
                var maxDetail = this.props.maxDetail;
                return maxDetail;
            }
        },
        {
            key: "nativeValueParser",
            get: function get() {
                switch(this.valueType){
                    case 'hour':
                    case 'minute':
                        return _dateUtils.getHoursMinutes;
                    case 'second':
                        return _dateUtils.getHoursMinutesSeconds;
                    default:
                        throw new Error('Invalid valueType.');
                }
            }
        },
        {
            key: "divider",
            get: function get() {
                return this.placeholder.match(/[^0-9a-z]/i)[0];
            }
        },
        {
            key: "placeholder",
            get: function get() {
                var _this$props7 = this.props, format = _this$props7.format, locale = _this$props7.locale;
                if (format) return format;
                var hour24 = 21;
                var hour12 = 9;
                var minute = 13;
                var second = 14;
                var date = new Date(2017, 0, 1, hour24, minute, second);
                return this.formatTime(locale, date).replace(this.formatNumber(locale, hour12), 'h').replace(this.formatNumber(locale, hour24), 'H').replace(this.formatNumber(locale, minute), 'mm').replace(this.formatNumber(locale, second), 'ss').replace(new RegExp((0, _utils.getAmPmLabels)(locale).join('|')), 'a');
            }
        },
        {
            key: "commonInputProps",
            get: function get() {
                var _this2 = this;
                var _this$props8 = this.props, className = _this$props8.className, disabled = _this$props8.disabled, isClockOpen = _this$props8.isClockOpen, maxTime = _this$props8.maxTime, minTime = _this$props8.minTime, required = _this$props8.required;
                return {
                    className: className,
                    disabled: disabled,
                    itemRef: function itemRef(ref, name) {
                        // Save a reference to each input field
                        _this2["".concat(name, "Input")] = ref;
                    },
                    maxTime: maxTime,
                    minTime: minTime,
                    onChange: this.onChange,
                    onKeyDown: this.onKeyDown,
                    onKeyUp: this.onKeyUp,
                    placeholder: '--',
                    // This is only for showing validity when editing
                    required: required || isClockOpen
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var nextState = {};
                /**
       * If isClockOpen flag has changed, we have to update it.
       * It's saved in state purely for use in getDerivedStateFromProps.
       */ if (nextProps.isClockOpen !== prevState.isClockOpen) nextState.isClockOpen = nextProps.isClockOpen;
                /**
       * If the next value is different from the current one  (with an exception of situation in
       * which values provided are limited by minDate and maxDate so that the dates are the same),
       * get a new one.
       */ var nextValue = nextProps.value;
                if (nextState.isClockOpen // Flag was toggled
                 || hoursAreDifferent(nextValue, prevState.value)) {
                    if (nextValue) {
                        var _convert24to = (0, _dates.convert24to12)((0, _dateUtils.getHours)(nextValue));
                        var _convert24to2 = _slicedToArray(_convert24to, 2);
                        nextState.amPm = _convert24to2[1];
                        nextState.hour = (0, _dateUtils.getHours)(nextValue);
                        nextState.minute = (0, _dateUtils.getMinutes)(nextValue);
                        nextState.second = (0, _dateUtils.getSeconds)(nextValue);
                    } else {
                        nextState.amPm = null;
                        nextState.hour = null;
                        nextState.minute = null;
                        nextState.second = null;
                    }
                    nextState.value = nextValue;
                }
                return nextState;
            }
        }
    ]);
    return TimeInput;
}(_react.PureComponent);
exports["default"] = TimeInput;
TimeInput.defaultProps = {
    maxDetail: 'minute',
    name: 'time'
};
TimeInput.propTypes = {
    amPmAriaLabel: _propTypes["default"].string,
    autoFocus: _propTypes["default"].bool,
    className: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool,
    format: _propTypes["default"].string,
    hourAriaLabel: _propTypes["default"].string,
    hourPlaceholder: _propTypes["default"].string,
    isClockOpen: _propTypes["default"].bool,
    locale: _propTypes["default"].string,
    maxDetail: _propTypes["default"].oneOf(allViews),
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    minuteAriaLabel: _propTypes["default"].string,
    minutePlaceholder: _propTypes["default"].string,
    name: _propTypes["default"].string,
    nativeInputAriaLabel: _propTypes["default"].string,
    onChange: _propTypes["default"].func,
    required: _propTypes["default"].bool,
    secondAriaLabel: _propTypes["default"].string,
    secondPlaceholder: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([
        _propTypes2.isTime,
        _propTypes["default"].instanceOf(Date)
    ])
};
(0, _reactLifecyclesCompat.polyfill)(TimeInput);

},{"3450c778800dea2":"9njXz","345ac6127004de58":"bnNSm","d34ee9607a712b7":"9jQEY","3fba7a4c2d4f121f":"jNz3i","cbdb8187feecdc45":"c5U5W","7ffe3870108c2fff":"4HKLs","6234bf0d3128b770":"gzkD2","417e86ac601a75ae":"1gYty","e5c2b360a4cefaa8":"jYa8v","9abc9f2a46d22f0b":"3rVrd","73646736082e09e9":"4vwIs","7f0d165fb8ef856c":"4TbAe","bb0dcb90bf065de7":"7BeeI","69502508856483ff":"9Mzoe","97908f6da0a0faf5":"gB09q"}],"jNz3i":[function(require,module,exports,__globalThis) {
/**
 * Utils
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Simple getters - getting a property of a given point in time
 */ /**
 * Gets year from a given date.
 *
 * @param {DateLike} date Date to get year from
 * @returns {number} Year
 */ parcelHelpers.export(exports, "getYear", ()=>getYear);
/**
 * Gets month from a given date.
 *
 * @param {Date} date Date to get month from
 * @returns {number} Month
 */ parcelHelpers.export(exports, "getMonth", ()=>getMonth);
/**
 * Gets human-readable month from a given date.
 *
 * @param {Date} date Date to get human-readable month from
 * @returns {number} Human-readable month
 */ parcelHelpers.export(exports, "getMonthHuman", ()=>getMonthHuman);
/**
 * Gets day of the month from a given date.
 *
 * @param {Date} date Date to get day of the month from
 * @returns {number} Day of the month
 */ parcelHelpers.export(exports, "getDate", ()=>getDate);
/**
 * Gets hours from a given date.
 *
 * @param {Date | string} date Date to get hours from
 * @returns {number} Hours
 */ parcelHelpers.export(exports, "getHours", ()=>getHours);
/**
 * Gets minutes from a given date.
 *
 * @param {Date | string} date Date to get minutes from
 * @returns {number} Minutes
 */ parcelHelpers.export(exports, "getMinutes", ()=>getMinutes);
/**
 * Gets seconds from a given date.
 *
 * @param {Date | string} date Date to get seconds from
 * @returns {number} Seconds
 */ parcelHelpers.export(exports, "getSeconds", ()=>getSeconds);
/**
 * Gets milliseconds from a given date.
 *
 * @param {Date | string} date Date to get milliseconds from
 * @returns {number} Milliseconds
 */ parcelHelpers.export(exports, "getMilliseconds", ()=>getMilliseconds);
/**
 * Century
 */ /**
 * Gets century start date from a given date.
 *
 * @param {DateLike} date Date to get century start from
 * @returns {Date} Century start date
 */ parcelHelpers.export(exports, "getCenturyStart", ()=>getCenturyStart);
parcelHelpers.export(exports, "getPreviousCenturyStart", ()=>getPreviousCenturyStart);
parcelHelpers.export(exports, "getNextCenturyStart", ()=>getNextCenturyStart);
parcelHelpers.export(exports, "getCenturyEnd", ()=>getCenturyEnd);
parcelHelpers.export(exports, "getPreviousCenturyEnd", ()=>getPreviousCenturyEnd);
parcelHelpers.export(exports, "getNextCenturyEnd", ()=>getNextCenturyEnd);
parcelHelpers.export(exports, "getCenturyRange", ()=>getCenturyRange);
/**
 * Decade
 */ /**
 * Gets decade start date from a given date.
 *
 * @param {DateLike} date Date to get decade start from
 * @returns {Date} Decade start date
 */ parcelHelpers.export(exports, "getDecadeStart", ()=>getDecadeStart);
parcelHelpers.export(exports, "getPreviousDecadeStart", ()=>getPreviousDecadeStart);
parcelHelpers.export(exports, "getNextDecadeStart", ()=>getNextDecadeStart);
parcelHelpers.export(exports, "getDecadeEnd", ()=>getDecadeEnd);
parcelHelpers.export(exports, "getPreviousDecadeEnd", ()=>getPreviousDecadeEnd);
parcelHelpers.export(exports, "getNextDecadeEnd", ()=>getNextDecadeEnd);
parcelHelpers.export(exports, "getDecadeRange", ()=>getDecadeRange);
/**
 * Year
 */ /**
 * Gets year start date from a given date.
 *
 * @param {DateLike} date Date to get year start from
 * @returns {Date} Year start date
 */ parcelHelpers.export(exports, "getYearStart", ()=>getYearStart);
parcelHelpers.export(exports, "getPreviousYearStart", ()=>getPreviousYearStart);
parcelHelpers.export(exports, "getNextYearStart", ()=>getNextYearStart);
parcelHelpers.export(exports, "getYearEnd", ()=>getYearEnd);
parcelHelpers.export(exports, "getPreviousYearEnd", ()=>getPreviousYearEnd);
parcelHelpers.export(exports, "getNextYearEnd", ()=>getNextYearEnd);
parcelHelpers.export(exports, "getYearRange", ()=>getYearRange);
/**
 * Gets month start date from a given date.
 *
 * @param {DateLike} date Date to get month start from
 * @returns {Date} Month start date
 */ parcelHelpers.export(exports, "getMonthStart", ()=>getMonthStart);
parcelHelpers.export(exports, "getPreviousMonthStart", ()=>getPreviousMonthStart);
parcelHelpers.export(exports, "getNextMonthStart", ()=>getNextMonthStart);
parcelHelpers.export(exports, "getMonthEnd", ()=>getMonthEnd);
parcelHelpers.export(exports, "getPreviousMonthEnd", ()=>getPreviousMonthEnd);
parcelHelpers.export(exports, "getNextMonthEnd", ()=>getNextMonthEnd);
parcelHelpers.export(exports, "getMonthRange", ()=>getMonthRange);
/**
 * Gets day start date from a given date.
 *
 * @param {DateLike} date Date to get day start from
 * @returns {Date} Day start date
 */ parcelHelpers.export(exports, "getDayStart", ()=>getDayStart);
parcelHelpers.export(exports, "getPreviousDayStart", ()=>getPreviousDayStart);
parcelHelpers.export(exports, "getNextDayStart", ()=>getNextDayStart);
parcelHelpers.export(exports, "getDayEnd", ()=>getDayEnd);
parcelHelpers.export(exports, "getPreviousDayEnd", ()=>getPreviousDayEnd);
parcelHelpers.export(exports, "getNextDayEnd", ()=>getNextDayEnd);
parcelHelpers.export(exports, "getDayRange", ()=>getDayRange);
/**
 * Other
 */ /**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date
 * @returns {number} Number of days in a month
 */ parcelHelpers.export(exports, "getDaysInMonth", ()=>getDaysInMonth);
/**
 * Returns local hours and minutes (hh:mm).
 *
 * @param {Date | string} date Date to get hours and minutes from
 * @returns {string} Local hours and minutes
 */ parcelHelpers.export(exports, "getHoursMinutes", ()=>getHoursMinutes);
/**
 * Returns local hours, minutes and seconds (hh:mm:ss).
 *
 * @param {Date | string} date Date to get hours, minutes and seconds from
 * @returns {string} Local hours, minutes and seconds
 */ parcelHelpers.export(exports, "getHoursMinutesSeconds", ()=>getHoursMinutesSeconds);
/**
 * Returns local month in ISO-like format (YYYY-MM).
 *
 * @param {Date} date Date to get month in ISO-like format from
 * @returns {string} Local month in ISO-like format
 */ parcelHelpers.export(exports, "getISOLocalMonth", ()=>getISOLocalMonth);
/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 *
 * @param {Date} date Date to get date in ISO-like format from
 * @returns {string} Local date in ISO-like format
 */ parcelHelpers.export(exports, "getISOLocalDate", ()=>getISOLocalDate);
/**
 * Returns local date & time in ISO-like format (YYYY-MM-DDThh:mm:ss).
 *
 * @param {Date} date Date to get date & time in ISO-like format from
 * @returns {string} Local date & time in ISO-like format
 */ parcelHelpers.export(exports, "getISOLocalDateTime", ()=>getISOLocalDateTime);
function makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var previousPeriod = getPeriod(date) + offset;
        return getEdgeOfPeriod(previousPeriod);
    };
}
function makeGetEnd(getBeginOfNextPeriod) {
    return function makeGetEndInternal(date) {
        return new Date(getBeginOfNextPeriod(date).getTime() - 1);
    };
}
function makeGetRange(getStart, getEnd) {
    return function makeGetRangeInternal(date) {
        return [
            getStart(date),
            getEnd(date)
        ];
    };
}
function getYear(date) {
    if (date instanceof Date) return date.getFullYear();
    if (typeof date === 'number') return date;
    var year = parseInt(date, 10);
    if (typeof date === 'string' && !isNaN(year)) return year;
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getMonth(date) {
    if (date instanceof Date) return date.getMonth();
    throw new Error("Failed to get month from date: ".concat(date, "."));
}
function getMonthHuman(date) {
    if (date instanceof Date) return date.getMonth() + 1;
    throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
function getDate(date) {
    if (date instanceof Date) return date.getDate();
    throw new Error("Failed to get year from date: ".concat(date, "."));
}
function getHours(date) {
    if (date instanceof Date) return date.getHours();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var hoursString = datePieces[0];
            if (hoursString) {
                var hours = parseInt(hoursString, 10);
                if (!isNaN(hours)) return hours;
            }
        }
    }
    throw new Error("Failed to get hours from date: ".concat(date, "."));
}
function getMinutes(date) {
    if (date instanceof Date) return date.getMinutes();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var minutesString = datePieces[1] || '0';
            var minutes = parseInt(minutesString, 10);
            if (!isNaN(minutes)) return minutes;
        }
    }
    throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
function getSeconds(date) {
    if (date instanceof Date) return date.getSeconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var seconds = parseInt(secondsWithMillisecondsString, 10);
            if (!isNaN(seconds)) return seconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function getMilliseconds(date) {
    if (date instanceof Date) return date.getMilliseconds();
    if (typeof date === 'string') {
        var datePieces = date.split(':');
        if (datePieces.length >= 2) {
            var secondsWithMillisecondsString = datePieces[2] || '0';
            var millisecondsString = secondsWithMillisecondsString.split('.')[1] || '0';
            var milliseconds = parseInt(millisecondsString, 10);
            if (!isNaN(milliseconds)) return milliseconds;
        }
    }
    throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
function getCenturyStart(date) {
    var year = getYear(date);
    var centuryStartYear = year + (-year + 1) % 100;
    var centuryStartDate = new Date();
    centuryStartDate.setFullYear(centuryStartYear, 0, 1);
    centuryStartDate.setHours(0, 0, 0, 0);
    return centuryStartDate;
}
var getPreviousCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, -100);
var getNextCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, 100);
var getCenturyEnd = makeGetEnd(getNextCenturyStart);
var getPreviousCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, -100);
var getNextCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, 100);
var getCenturyRange = makeGetRange(getCenturyStart, getCenturyEnd);
function getDecadeStart(date) {
    var year = getYear(date);
    var decadeStartYear = year + (-year + 1) % 10;
    var decadeStartDate = new Date();
    decadeStartDate.setFullYear(decadeStartYear, 0, 1);
    decadeStartDate.setHours(0, 0, 0, 0);
    return decadeStartDate;
}
var getPreviousDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, -10);
var getNextDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, 10);
var getDecadeEnd = makeGetEnd(getNextDecadeStart);
var getPreviousDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, -10);
var getNextDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, 10);
var getDecadeRange = makeGetRange(getDecadeStart, getDecadeEnd);
function getYearStart(date) {
    var year = getYear(date);
    var yearStartDate = new Date();
    yearStartDate.setFullYear(year, 0, 1);
    yearStartDate.setHours(0, 0, 0, 0);
    return yearStartDate;
}
var getPreviousYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, -1);
var getNextYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, 1);
var getYearEnd = makeGetEnd(getNextYearStart);
var getPreviousYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, -1);
var getNextYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, 1);
var getYearRange = makeGetRange(getYearStart, getYearEnd);
/**
 * Month
 */ function makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborMonthInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = getYear(date);
        var month = getMonth(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, 1);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function getMonthStart(date) {
    var year = getYear(date);
    var month = getMonth(date);
    var monthStartDate = new Date();
    monthStartDate.setFullYear(year, month, 1);
    monthStartDate.setHours(0, 0, 0, 0);
    return monthStartDate;
}
var getPreviousMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, -1);
var getNextMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, 1);
var getMonthEnd = makeGetEnd(getNextMonthStart);
var getPreviousMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, -1);
var getNextMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, 1);
var getMonthRange = makeGetRange(getMonthStart, getMonthEnd);
/**
 * Day
 */ function makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
    return function makeGetEdgeOfNeighborDayInternal(date, offset) {
        if (offset === void 0) offset = defaultOffset;
        var year = getYear(date);
        var month = getMonth(date);
        var day = getDate(date) + offset;
        var previousPeriod = new Date();
        previousPeriod.setFullYear(year, month, day);
        previousPeriod.setHours(0, 0, 0, 0);
        return getEdgeOfPeriod(previousPeriod);
    };
}
function getDayStart(date) {
    var year = getYear(date);
    var month = getMonth(date);
    var day = getDate(date);
    var dayStartDate = new Date();
    dayStartDate.setFullYear(year, month, day);
    dayStartDate.setHours(0, 0, 0, 0);
    return dayStartDate;
}
var getPreviousDayStart = makeGetEdgeOfNeighborDay(getDayStart, -1);
var getNextDayStart = makeGetEdgeOfNeighborDay(getDayStart, 1);
var getDayEnd = makeGetEnd(getNextDayStart);
var getPreviousDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, -1);
var getNextDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, 1);
var getDayRange = makeGetRange(getDayStart, getDayEnd);
function getDaysInMonth(date) {
    return getDate(getMonthEnd(date));
}
function padStart(num, val) {
    if (val === void 0) val = 2;
    var numStr = "".concat(num);
    if (numStr.length >= val) return num;
    return "0000".concat(numStr).slice(-val);
}
function getHoursMinutes(date) {
    var hours = padStart(getHours(date));
    var minutes = padStart(getMinutes(date));
    return "".concat(hours, ":").concat(minutes);
}
function getHoursMinutesSeconds(date) {
    var hours = padStart(getHours(date));
    var minutes = padStart(getMinutes(date));
    var seconds = padStart(getSeconds(date));
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
function getISOLocalMonth(date) {
    var year = padStart(getYear(date), 4);
    var month = padStart(getMonthHuman(date));
    return "".concat(year, "-").concat(month);
}
function getISOLocalDate(date) {
    var year = padStart(getYear(date), 4);
    var month = padStart(getMonthHuman(date));
    var day = padStart(getDate(date));
    return "".concat(year, "-").concat(month, "-").concat(day);
}
function getISOLocalDateTime(date) {
    return "".concat(getISOLocalDate(date), "T").concat(getHoursMinutesSeconds(date));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c5U5W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Divider;
var _react = _interopRequireDefault(require("88ff4e8478903df5"));
var _propTypes = _interopRequireDefault(require("ea7ab78c4160555d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function Divider(_ref) {
    var children = _ref.children;
    return _react["default"].createElement("span", {
        className: "react-time-picker__inputGroup__divider"
    }, children);
}
Divider.propTypes = {
    children: _propTypes["default"].node
};

},{"88ff4e8478903df5":"9njXz","ea7ab78c4160555d":"bnNSm"}],"4HKLs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Hour12Input;
var _react = _interopRequireDefault(require("f35cdece177d45de"));
var _propTypes = _interopRequireDefault(require("2f7f7de4538eaec5"));
var _dateUtils = require("596091632ce6f89");
var _Input = _interopRequireDefault(require("c4aeecd66b2c2793"));
var _dates = require("fe3cb1593d12b0e1");
var _propTypes2 = require("1e1d18b758c933e7");
var _utils = require("32e712e250918082");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Hour12Input(_ref) {
    var amPm = _ref.amPm, hour = _ref.hour, maxTime = _ref.maxTime, minTime = _ref.minTime, value = _ref.value, otherProps = _objectWithoutProperties(_ref, [
        "amPm",
        "hour",
        "maxTime",
        "minTime",
        "value"
    ]);
    var maxHour = (0, _utils.min)(12, maxTime && function() {
        var _convert24to = (0, _dates.convert24to12)((0, _dateUtils.getHours)(maxTime)), _convert24to2 = _slicedToArray(_convert24to, 2), maxHourResult = _convert24to2[0], maxAmPm = _convert24to2[1];
        if (maxAmPm !== amPm) // pm is always after am, so we should ignore validation
        return null;
        return maxHourResult;
    }());
    var minHour = (0, _utils.max)(1, minTime && function() {
        var _convert24to3 = (0, _dates.convert24to12)((0, _dateUtils.getHours)(minTime)), _convert24to4 = _slicedToArray(_convert24to3, 2), minHourResult = _convert24to4[0], minAmPm = _convert24to4[1];
        if (minAmPm !== amPm // If minHour is 12 am/pm, user should be able to enter 12, 1, ..., 11.
         || minHourResult === 12) return null;
        return minHourResult;
    }());
    var value12 = value !== null ? (0, _dates.convert24to12)(value)[0] : null;
    return _react["default"].createElement(_Input["default"], _extends({
        max: maxHour,
        min: minHour,
        name: "hour12",
        nameForClass: "hour",
        value: value12
    }, otherProps));
}
Hour12Input.propTypes = {
    amPm: _propTypes["default"].string,
    ariaLabel: _propTypes["default"].string,
    className: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool,
    hour: _propTypes["default"].number,
    itemRef: _propTypes["default"].func,
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    onChange: _propTypes["default"].func,
    onKeyDown: _propTypes["default"].func,
    onKeyUp: _propTypes["default"].func,
    placeholder: _propTypes["default"].string,
    required: _propTypes["default"].bool,
    showLeadingZeros: _propTypes["default"].bool,
    value: _propTypes["default"].number
};

},{"f35cdece177d45de":"9njXz","2f7f7de4538eaec5":"bnNSm","596091632ce6f89":"jNz3i","c4aeecd66b2c2793":"4lKNX","fe3cb1593d12b0e1":"7BeeI","1e1d18b758c933e7":"9Mzoe","32e712e250918082":"gB09q"}],"4lKNX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Input;
var _react = _interopRequireDefault(require("c6405d57f110ebf7"));
var _propTypes = _interopRequireDefault(require("98a287373e88c9a1"));
var _mergeClassNames = _interopRequireDefault(require("4863a95e491e9036"));
var _updateInputWidth = _interopRequireWildcard(require("33d486a96d793162"));
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj["default"] = obj;
        return newObj;
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/* eslint-disable jsx-a11y/no-autofocus */ function onFocus(event) {
    var target = event.target;
    requestAnimationFrame(function() {
        return target.select();
    });
}
function updateInputWidthOnFontLoad(element) {
    if (!document.fonts) return;
    var font = (0, _updateInputWidth.getFontShorthand)(element);
    if (!font) return;
    var isFontLoaded = document.fonts.check(font);
    if (isFontLoaded) return;
    function onLoadingDone() {
        (0, _updateInputWidth["default"])(element);
    }
    document.fonts.addEventListener('loadingdone', onLoadingDone);
}
function getSelectionString() {
    if (typeof window === 'undefined') return null;
    return window.getSelection().toString();
}
function makeOnKeyPress(maxLength) {
    return function onKeyPress(event) {
        var value = event.target.value;
        var selection = getSelectionString();
        if (selection || value.length < maxLength) return;
        event.preventDefault();
    };
}
function Input(_ref) {
    var ariaLabel = _ref.ariaLabel, autoFocus = _ref.autoFocus, className = _ref.className, disabled = _ref.disabled, itemRef = _ref.itemRef, max = _ref.max, min = _ref.min, name = _ref.name, nameForClass = _ref.nameForClass, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, _onKeyUp = _ref.onKeyUp, _ref$placeholder = _ref.placeholder, placeholder = _ref$placeholder === void 0 ? '--' : _ref$placeholder, required = _ref.required, showLeadingZeros = _ref.showLeadingZeros, step = _ref.step, value = _ref.value;
    var hasLeadingZero = showLeadingZeros && value !== null && value < 10;
    var maxLength = max.toString().length;
    return [
        hasLeadingZero && _react["default"].createElement("span", {
            key: "leadingZero",
            className: "".concat(className, "__leadingZero")
        }, "0"),
        _react["default"].createElement("input", {
            key: "input",
            "aria-label": ariaLabel,
            autoComplete: "off",
            autoFocus: autoFocus,
            className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
            disabled: disabled,
            max: max,
            min: min,
            name: name,
            onChange: onChange,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onKeyPress: makeOnKeyPress(maxLength),
            onKeyUp: function onKeyUp(event) {
                (0, _updateInputWidth["default"])(event.target);
                if (_onKeyUp) _onKeyUp(event);
            },
            placeholder: placeholder,
            ref: function ref(_ref2) {
                if (_ref2) {
                    (0, _updateInputWidth["default"])(_ref2);
                    updateInputWidthOnFontLoad(_ref2);
                }
                if (itemRef) itemRef(_ref2, name);
            },
            required: required,
            step: step,
            type: "number",
            value: value !== null ? value : ''
        })
    ];
}
Input.propTypes = {
    ariaLabel: _propTypes["default"].string,
    className: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool,
    itemRef: _propTypes["default"].func,
    max: _propTypes["default"].number,
    min: _propTypes["default"].number,
    onChange: _propTypes["default"].func,
    onKeyDown: _propTypes["default"].func,
    required: _propTypes["default"].bool,
    showLeadingZeros: _propTypes["default"].bool,
    step: _propTypes["default"].number,
    value: _propTypes["default"].number
};

},{"c6405d57f110ebf7":"9njXz","98a287373e88c9a1":"bnNSm","4863a95e491e9036":"6X3Jr","33d486a96d793162":"6NDSV"}],"6NDSV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Gets font CSS shorthand property given element.
 *
 * @param {HTMLElement} element Element to get font CSS shorthand property from
 */ parcelHelpers.export(exports, "getFontShorthand", ()=>getFontShorthand);
/**
 * Measures text width given text and font CSS shorthand.
 *
 * @param {string} text Text to measure
 * @param {string} font Font to use when measuring the text
 */ parcelHelpers.export(exports, "measureText", ()=>measureText);
/**
 * Updates input element width to fit its content given input element
 * @param {HTMLInputElement} element
 */ parcelHelpers.export(exports, "updateInputWidth", ()=>updateInputWidth);
var allowedVariants = [
    'normal',
    'small-caps'
];
function getFontShorthand(element) {
    if (!element) return '';
    var style = window.getComputedStyle(element);
    if (style.font) return style.font;
    var isFontDefined = style.fontFamily !== '';
    if (!isFontDefined) return '';
    var fontVariant = allowedVariants.includes(style.fontVariant) ? style.fontVariant : 'normal';
    return "".concat(style.fontStyle, " ").concat(fontVariant, " ").concat(style.fontWeight, " ").concat(style.fontSize, " / ").concat(style.lineHeight, " ").concat(style.fontFamily);
}
var cachedCanvas;
function measureText(text, font) {
    var canvas = cachedCanvas || (cachedCanvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    // Context type not supported
    if (!context) return null;
    context.font = font;
    var width = context.measureText(text).width;
    return Math.ceil(width);
}
function updateInputWidth(element) {
    if (typeof document === 'undefined' || !element) return null;
    var font = getFontShorthand(element);
    var text = element.value || element.placeholder;
    var width = measureText(text, font);
    if (width === null) return null;
    element.style.width = "".concat(width, "px");
    return width;
}
exports.default = updateInputWidth;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7BeeI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.convert12to24 = convert12to24;
exports.convert24to12 = convert24to12;
function convert12to24(hour12, amPm) {
    var hour24 = parseInt(hour12, 10);
    if (amPm === 'am' && hour24 === 12) hour24 = 0;
    else if (amPm === 'pm' && hour24 < 12) hour24 += 12;
    return hour24;
}
function convert24to12(hour24) {
    var hour12 = hour24 % 12 || 12;
    return [
        hour12,
        hour24 < 12 ? 'am' : 'pm'
    ];
}

},{}],"9Mzoe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValueType = exports.isTime = void 0;
var _propTypes = _interopRequireDefault(require("37cc54d77a3f08bb"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var allViews = [
    'hour',
    'minute',
    'second'
];
var allValueTypes = [].concat(allViews);
var hourOptionalSecondsRegExp = /^(([0-1])?[0-9]|2[0-3]):[0-5][0-9](:([0-5][0-9]))?$/;
var isTime = function isTime(props, propName, componentName) {
    var time = props[propName];
    if (time) {
        if (!hourOptionalSecondsRegExp.test(time)) return new Error("Invalid prop `".concat(propName, "` of type `").concat(typeof minDate === "undefined" ? "undefined" : _typeof(minDate), "` supplied to `").concat(componentName, "`, expected time in HH:mm(:ss) format."));
    } // Everything is fine
    return null;
};
exports.isTime = isTime;
var isValueType = _propTypes["default"].oneOf(allValueTypes);
exports.isValueType = isValueType;

},{"37cc54d77a3f08bb":"bnNSm"}],"gB09q":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.callIfDefined = exports.getAmPmLabels = exports.max = exports.min = void 0;
var _dateFormatter = require("a869ed1422b97fe3");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
var isValidNumber = function isValidNumber(a) {
    return typeof a === 'number' && !isNaN(a);
};
var min = function min() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return Math.min.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
};
exports.min = min;
var max = function max() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    return Math.max.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
};
exports.max = max;
var nines = [
    '9',
    "\u0669"
];
var ninesRegExp = new RegExp("[".concat(nines.join(''), "]"));
var amPmFormatter = (0, _dateFormatter.getFormatter)({
    hour: 'numeric'
});
var getAmPmLabels = function getAmPmLabels(locale) {
    var amString = amPmFormatter(locale, new Date(2017, 0, 1, 9));
    var pmString = amPmFormatter(locale, new Date(2017, 0, 1, 21));
    var _amString$split = amString.split(ninesRegExp), _amString$split2 = _slicedToArray(_amString$split, 2), am1 = _amString$split2[0], am2 = _amString$split2[1];
    var _pmString$split = pmString.split(ninesRegExp), _pmString$split2 = _slicedToArray(_pmString$split, 2), pm1 = _pmString$split2[0], pm2 = _pmString$split2[1];
    if (pm2 !== undefined) {
        // If pm2 is undefined, nine was not found in pmString - this locale is not using 12-hour time
        if (am1 !== pm1) return [
            am1,
            pm1
        ].map(function(el) {
            return el.trim();
        });
        if (am2 !== pm2) return [
            am2,
            pm2
        ].map(function(el) {
            return el.trim();
        });
    } // Fallback
    return [
        'AM',
        'PM'
    ];
};
/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */ exports.getAmPmLabels = getAmPmLabels;
var callIfDefined = function callIfDefined(fn) {
    if (fn && typeof fn === 'function') {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        fn.apply(void 0, args);
    }
};
exports.callIfDefined = callIfDefined;

},{"a869ed1422b97fe3":"4TbAe"}],"4TbAe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getFormatter = getFormatter;
var _getUserLocale = _interopRequireDefault(require("e1c0933827c148b1"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/* eslint-disable import/prefer-default-export */ function getFormatter(options) {
    return function(locale, date) {
        return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
    };
}

},{"e1c0933827c148b1":"l1lv0"}],"gzkD2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = Hour24Input;
var _react = _interopRequireDefault(require("26cc5f81b53718e3"));
var _propTypes = _interopRequireDefault(require("a91ab123cf549749"));
var _dateUtils = require("cf82e309083b0935");
var _Input = _interopRequireDefault(require("3bccf4430643181e"));
var _propTypes2 = require("a19bb9303c6ac340");
var _utils = require("d487f41dbed7be03");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Hour24Input(_ref) {
    var hour = _ref.hour, maxTime = _ref.maxTime, minTime = _ref.minTime, otherProps = _objectWithoutProperties(_ref, [
        "hour",
        "maxTime",
        "minTime"
    ]);
    var maxHour = (0, _utils.min)(23, maxTime && (0, _dateUtils.getHours)(maxTime));
    var minHour = (0, _utils.max)(0, minTime && (0, _dateUtils.getHours)(minTime));
    return _react["default"].createElement(_Input["default"], _extends({
        max: maxHour,
        min: minHour,
        name: "hour24",
        nameForClass: "hour"
    }, otherProps));
}
Hour24Input.propTypes = {
    ariaLabel: _propTypes["default"].string,
    className: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool,
    hour: _propTypes["default"].number,
    itemRef: _propTypes["default"].func,
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    onChange: _propTypes["default"].func,
    onKeyDown: _propTypes["default"].func,
    onKeyUp: _propTypes["default"].func,
    placeholder: _propTypes["default"].string,
    required: _propTypes["default"].bool,
    showLeadingZeros: _propTypes["default"].bool,
    value: _propTypes["default"].number
};

},{"26cc5f81b53718e3":"9njXz","a91ab123cf549749":"bnNSm","cf82e309083b0935":"jNz3i","3bccf4430643181e":"4lKNX","a19bb9303c6ac340":"9Mzoe","d487f41dbed7be03":"gB09q"}],"1gYty":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = MinuteInput;
var _react = _interopRequireDefault(require("5386003a68c02af6"));
var _propTypes = _interopRequireDefault(require("35df49d247f4188c"));
var _dateUtils = require("2d90668e3a103bdf");
var _Input = _interopRequireDefault(require("e5c20f1f8d07e3db"));
var _propTypes2 = require("d2986c48d6421414");
var _utils = require("744650b8580b9b3c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function MinuteInput(_ref) {
    var hour = _ref.hour, maxTime = _ref.maxTime, minTime = _ref.minTime, _ref$showLeadingZeros = _ref.showLeadingZeros, showLeadingZeros = _ref$showLeadingZeros === void 0 ? true : _ref$showLeadingZeros, otherProps = _objectWithoutProperties(_ref, [
        "hour",
        "maxTime",
        "minTime",
        "showLeadingZeros"
    ]);
    function isSameHour(date) {
        return date && hour === (0, _dateUtils.getHours)(date);
    }
    var maxMinute = (0, _utils.min)(59, isSameHour(maxTime) && (0, _dateUtils.getMinutes)(maxTime));
    var minMinute = (0, _utils.max)(0, isSameHour(minTime) && (0, _dateUtils.getMinutes)(minTime));
    return _react["default"].createElement(_Input["default"], _extends({
        max: maxMinute,
        min: minMinute,
        name: "minute",
        showLeadingZeros: showLeadingZeros
    }, otherProps));
}
MinuteInput.propTypes = {
    ariaLabel: _propTypes["default"].string,
    className: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool,
    hour: _propTypes["default"].number,
    itemRef: _propTypes["default"].func,
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    onChange: _propTypes["default"].func,
    onKeyDown: _propTypes["default"].func,
    onKeyUp: _propTypes["default"].func,
    placeholder: _propTypes["default"].string,
    required: _propTypes["default"].bool,
    showLeadingZeros: _propTypes["default"].bool,
    value: _propTypes["default"].number
};

},{"5386003a68c02af6":"9njXz","35df49d247f4188c":"bnNSm","2d90668e3a103bdf":"jNz3i","e5c20f1f8d07e3db":"4lKNX","d2986c48d6421414":"9Mzoe","744650b8580b9b3c":"gB09q"}],"jYa8v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = SecondInput;
var _react = _interopRequireDefault(require("ed7d58ec36e8242c"));
var _propTypes = _interopRequireDefault(require("6439820c795a2cdc"));
var _dateUtils = require("dc7b8eab061a4a79");
var _Input = _interopRequireDefault(require("11a193dead60a069"));
var _propTypes2 = require("d5a04603ded101d3");
var _utils = require("bf492c0edce0ebe8");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SecondInput(_ref) {
    var hour = _ref.hour, maxTime = _ref.maxTime, minTime = _ref.minTime, minute = _ref.minute, _ref$showLeadingZeros = _ref.showLeadingZeros, showLeadingZeros = _ref$showLeadingZeros === void 0 ? true : _ref$showLeadingZeros, otherProps = _objectWithoutProperties(_ref, [
        "hour",
        "maxTime",
        "minTime",
        "minute",
        "showLeadingZeros"
    ]);
    function isSameMinute(date) {
        return date && hour === (0, _dateUtils.getHours)(date) && minute === (0, _dateUtils.getMinutes)(date);
    }
    var maxSecond = (0, _utils.min)(59, isSameMinute(maxTime) && (0, _dateUtils.getSeconds)(maxTime));
    var minSecond = (0, _utils.max)(0, isSameMinute(minTime) && (0, _dateUtils.getSeconds)(minTime));
    return _react["default"].createElement(_Input["default"], _extends({
        max: maxSecond,
        min: minSecond,
        name: "second",
        showLeadingZeros: showLeadingZeros
    }, otherProps));
}
SecondInput.propTypes = {
    ariaLabel: _propTypes["default"].string,
    className: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool,
    hour: _propTypes["default"].number,
    itemRef: _propTypes["default"].func,
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    minute: _propTypes["default"].number,
    onChange: _propTypes["default"].func,
    onKeyDown: _propTypes["default"].func,
    onKeyUp: _propTypes["default"].func,
    placeholder: _propTypes["default"].string,
    required: _propTypes["default"].bool,
    showLeadingZeros: _propTypes["default"].bool,
    value: _propTypes["default"].number
};

},{"ed7d58ec36e8242c":"9njXz","6439820c795a2cdc":"bnNSm","dc7b8eab061a4a79":"jNz3i","11a193dead60a069":"4lKNX","d5a04603ded101d3":"9Mzoe","bf492c0edce0ebe8":"gB09q"}],"3rVrd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = NativeInput;
var _react = _interopRequireDefault(require("53c4f5bd66e53ce9"));
var _propTypes = _interopRequireDefault(require("8ac6898a6bcf1f64"));
var _dateUtils = require("b4d6720644094d84");
var _propTypes2 = require("68dbf7fbaaa021ba");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function NativeInput(_ref) {
    var ariaLabel = _ref.ariaLabel, disabled = _ref.disabled, maxTime = _ref.maxTime, minTime = _ref.minTime, name = _ref.name, onChange = _ref.onChange, required = _ref.required, value = _ref.value, valueType = _ref.valueType;
    var nativeValueParser = function() {
        switch(valueType){
            case 'hour':
                return function(receivedValue) {
                    return "".concat((0, _dateUtils.getHours)(receivedValue), ":00");
                };
            case 'minute':
                return _dateUtils.getHoursMinutes;
            case 'second':
                return _dateUtils.getHoursMinutesSeconds;
            default:
                throw new Error('Invalid valueType.');
        }
    }();
    var step = function() {
        switch(valueType){
            case 'hour':
                return 3600;
            case 'minute':
                return 60;
            case 'second':
                return 1;
            default:
                throw new Error('Invalid valueType.');
        }
    }();
    function stopPropagation(event) {
        event.stopPropagation();
    }
    return _react["default"].createElement("input", {
        "aria-label": ariaLabel,
        disabled: disabled,
        max: maxTime ? nativeValueParser(maxTime) : null,
        min: minTime ? nativeValueParser(minTime) : null,
        name: name,
        onChange: onChange,
        onFocus: stopPropagation,
        required: required,
        step: step,
        style: {
            visibility: 'hidden',
            position: 'absolute',
            top: '-9999px',
            left: '-9999px'
        },
        type: "time",
        value: value ? nativeValueParser(value) : ''
    });
}
NativeInput.propTypes = {
    ariaLabel: _propTypes["default"].string,
    disabled: _propTypes["default"].bool,
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    name: _propTypes["default"].string,
    onChange: _propTypes["default"].func,
    required: _propTypes["default"].bool,
    value: _propTypes["default"].oneOfType([
        _propTypes["default"].string,
        _propTypes["default"].instanceOf(Date)
    ]),
    valueType: _propTypes2.isValueType
};

},{"53c4f5bd66e53ce9":"9njXz","8ac6898a6bcf1f64":"bnNSm","b4d6720644094d84":"jNz3i","68dbf7fbaaa021ba":"9Mzoe"}],"4vwIs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = AmPm;
var _react = _interopRequireDefault(require("3f726ab6da3f3008"));
var _propTypes = _interopRequireDefault(require("ac27dde19d40de85"));
var _mergeClassNames = _interopRequireDefault(require("b789600e3107bc90"));
var _dateUtils = require("67543f01ccbf8f1f");
var _dates = require("14b734664c07e030");
var _propTypes2 = require("699414564c8a0e7d");
var _utils = require("681df0786feff364");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function AmPm(_ref) {
    var ariaLabel = _ref.ariaLabel, className = _ref.className, disabled = _ref.disabled, itemRef = _ref.itemRef, locale = _ref.locale, maxTime = _ref.maxTime, minTime = _ref.minTime, onChange = _ref.onChange, required = _ref.required, value = _ref.value;
    var amDisabled = minTime && (0, _dates.convert24to12)((0, _dateUtils.getHours)(minTime))[1] === 'pm';
    var pmDisabled = maxTime && (0, _dates.convert24to12)((0, _dateUtils.getHours)(maxTime))[1] === 'am';
    var name = 'amPm';
    var _getAmPmLabels = (0, _utils.getAmPmLabels)(locale), _getAmPmLabels2 = _slicedToArray(_getAmPmLabels, 2), amLabel = _getAmPmLabels2[0], pmLabel = _getAmPmLabels2[1];
    return _react["default"].createElement("select", {
        "aria-label": ariaLabel,
        className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(name)),
        disabled: disabled,
        name: name,
        onChange: onChange,
        ref: function ref(_ref2) {
            if (itemRef) itemRef(_ref2, name);
        },
        required: required,
        value: value !== null ? value : ''
    }, !value && _react["default"].createElement("option", {
        value: ""
    }, "--"), _react["default"].createElement("option", {
        disabled: amDisabled,
        value: "am"
    }, amLabel), _react["default"].createElement("option", {
        disabled: pmDisabled,
        value: "pm"
    }, pmLabel));
}
AmPm.propTypes = {
    ariaLabel: _propTypes["default"].string,
    className: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool,
    itemRef: _propTypes["default"].func,
    locale: _propTypes["default"].string,
    maxTime: _propTypes2.isTime,
    minTime: _propTypes2.isTime,
    onChange: _propTypes["default"].func,
    required: _propTypes["default"].bool,
    value: _propTypes["default"].oneOf([
        'am',
        'pm'
    ])
};

},{"3f726ab6da3f3008":"9njXz","ac27dde19d40de85":"bnNSm","b789600e3107bc90":"6X3Jr","67543f01ccbf8f1f":"jNz3i","14b734664c07e030":"7BeeI","699414564c8a0e7d":"9Mzoe","681df0786feff364":"gB09q"}],"13MKG":[function() {},{}],"aXwhr":[function() {},{}],"1kPcE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddLesson);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _reactRouterDom = require("react-router-dom");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../../context");
var _confirmDialog = require("../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _addLessons = require("../../add-lessons");
var _addLessonsDefault = parcelHelpers.interopDefault(_addLessons);
var _utils = require("../../../helpers/utils");
var _addLessonStyl = require("./add-lesson.styl");
function Lesson(props) {
    const { id, name, deleteLesson } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "lesson",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content",
                children: [
                    !(0, _utils.isUUID)(id) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "id",
                        children: id
                    }),
                    (0, _utils.isUUID)(id) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "id",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "my-lesson"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "name",
                        title: name,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                            text: name,
                            maxLine: 3,
                            ellipsis: "...",
                            trimRight: true,
                            basedOn: "letters"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "delete",
                    onClick: deleteLesson,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTrashAlt)
                    })
                })
            })
        ]
    });
}
function AddLesson() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan, languageId, link } = context;
            const { content = {} } = newPlan;
            const { lessons = [] } = content;
            const deleteLesson = (index, title)=>{
                return ()=>{
                    (0, _confirmDialogDefault.default)({
                        className: 'delete-field',
                        translate: context.translate,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "message",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "question",
                                    children: context.translate('confirm_delete_item')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title",
                                    children: title
                                })
                            ]
                        }),
                        onConfirm: ()=>{
                            const lessons = (0, _immutabilityHelperDefault.default)(newPlan.content.lessons, {
                                $splice: [
                                    [
                                        index,
                                        1
                                    ]
                                ]
                            });
                            context.setState({
                                newPlan: {
                                    ...newPlan,
                                    content: {
                                        ...content,
                                        lessons
                                    }
                                }
                            });
                        }
                    });
                };
            };
            const items = lessons.map((lesson, index)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Lesson, {
                    index: index,
                    className: "lesson",
                    deleteLesson: deleteLesson(index, lesson.name),
                    context: context,
                    ...lesson
                }, index);
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "lessons",
                children: [
                    context.section == 'add-lessons' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addLessonsDefault.default), {
                        activeTab: "catalogue"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "head",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "lessons_label"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: "add-lesson",
                                to: context.link({
                                    section: 'add-lessons',
                                    activeTab: 'catalogue'
                                }, context.match.path, {
                                    preserveQuery: true
                                }),
                                children: "+"
                            })
                        ]
                    }),
                    items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "content",
                        children: items
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","react-text":"lEpdJ","react-lines-ellipsis":"ikp0X","react-router-dom":"3uzXR","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../context":"iUP37","../../confirm-dialog":"hzSdJ","../../add-lessons":"l306l","../../../helpers/utils":"gGc98","./add-lesson.styl":"hyhdn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l306l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _tabBar = require("./tab-bar");
var _tabBarDefault = parcelHelpers.interopDefault(_tabBar);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _catalogueStep = require("./catalogue-step");
var _catalogueStepDefault = parcelHelpers.interopDefault(_catalogueStep);
var _myLessonsStep = require("./my-lessons-step");
var _myLessonsStepDefault = parcelHelpers.interopDefault(_myLessonsStep);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _indexStyl = require("./index.styl");
function Buttons({ label, onClick, enabled }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "buttons",
        style: {
            display: "flex"
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                disabled: !enabled,
                className: label,
                onClick: onClick,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: label
                })
            })
        ]
    });
}
class AddLesson extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            isOpen: true,
            setState
        };
    }
    render() {
        const context = this.context;
        const template = context.query.template;
        const { newPlan, activeTab = 'catalogue', navigate } = context;
        const { setState, isOpen } = this.state;
        const close = ()=>setState({
                isOpen: false
            });
        const navigateOut = ()=>{
            context.navigate({}, context.match.path.replace(/\/:section.*$/, ''), {
                query: {
                    template
                }
            });
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "add-lesson-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "add-lesson",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "add-lessons"
                                    }),
                                    newPlan.title != "" && `: ${newPlan.title}`
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "close",
                                onClick: ()=>close(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faTimesCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabBarDefault.default), {
                        activeTab,
                        navigate,
                        template
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tab-content",
                        children: [
                            activeTab == 'catalogue' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _catalogueStepDefault.default), {
                                ...(0, _lodash.pick)(this.state, [
                                    'setState'
                                ])
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                label: 'accept',
                                onClick: close,
                                enabled: true
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = AddLesson;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-modal":"kV9Wz","./tab-bar":"gx26E","react-text":"lEpdJ","../../context":"iUP37","./catalogue-step":"gYSd1","./my-lessons-step":"j7t75","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./index.styl":"gAKwF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gx26E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TabBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _indexStyl = require("./index.styl");
function TabBar({ activeTab, navigate, template }) {
    const setActiveTab = (activeTab)=>navigate({
            activeTab
        }, undefined, {
            query: {
                template
            }
        });
    const buttonClassName = (tab)=>`${tab}-button ${activeTab == tab ? 'active' : 'selectable'}`;
    const onClick = (tab)=>()=>activeTab != tab && setActiveTab(tab);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "tab-bar",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: buttonClassName('catalogue'),
            onClick: onClick('catalogue'),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                id: "catalogue"
            })
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","./index.styl":"jGqE3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jGqE3":[function() {},{}],"gYSd1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _context = require("../../../context");
var _utils = require("../../../helpers/utils");
var _contextLoader = require("../../context-loader");
var _contextLoaderDefault = parcelHelpers.interopDefault(_contextLoader);
var _searchPattern = require("../../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _pagination = require("../../pagination");
var _indexStyl = require("./index.styl");
const { columns, headers } = (0, _columnsDefault.default);
const Layout = ({ Table, Pagination, Filter })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "catalogue-search-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
        ]
    });
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "catalog_search_no_results_label"
        })
    });
}
class Lessons extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        (0, _utils.bind)(this, 'goPage', 'goNext', 'goPrevious', 'sort');
    }
    goPage(page) {
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                page
            }
        });
    }
    goNext() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage + 1);
    }
    goPrevious() {
        this.goPage(this.context.catalogueSearchResults[0].currentPage - 1);
    }
    sort({ id, sortAscending }) {
        const orderBy = `${sortAscending ? '' : '-'}${id}`;
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                orderBy
            }
        });
    }
    render() {
        const context = this.context;
        const [pageProperties, ...lessons] = context.catalogueSearchResults;
        const { recordCount } = pageProperties || {};
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextLoaderDefault.default), {
            id: "catalogueSearch",
            className: "catalogue-search",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                            initialPattern: context.query.pattern
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "catalogue-search-results",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                            data: lessons,
                            components: {
                                NoResults,
                                PageDropdown: (0, _pagination.PageDropdown),
                                Pagination: (0, _pagination.Pagination),
                                Layout,
                                Filter: (0, _filtersDefault.default)
                            },
                            pageProperties: pageProperties,
                            events: {
                                onNext: this.goNext,
                                onPrevious: this.goPrevious,
                                onGetPage: this.goPage,
                                onSort: this.sort
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "lesson",
                                        customHeadingComponent: headers.CatalogueSearchHeader,
                                        customComponent: columns.LessonColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "courseName",
                                        customHeadingComponent: headers.CatalogueSearchHeader,
                                        customComponent: columns.LabelColumn(200)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "lessonName",
                                        customHeadingComponent: headers.CatalogueSearchHeader,
                                        customComponent: columns.LabelColumn(200)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "links",
                                        customHeadingComponent: headers.EmptyHeader,
                                        customComponent: columns.LessonLinksColumn
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        });
    }
}
exports.default = Lessons;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","griddle-react":"6zdUV","../../../context":"iUP37","../../../helpers/utils":"gGc98","../../context-loader":"ktxlD","../../search-pattern":"lUZFT","./columns":"lv0x2","./filters":"bpGw2","../../pagination":"82vF6","./index.styl":"4O9if","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lv0x2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _label = require("../../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _lessonLinks = require("./lesson-links");
var _lessonLinksDefault = parcelHelpers.interopDefault(_lessonLinks);
var _context = require("../../../context");
var _utils = require("../../../helpers/utils");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
function CatalogueSearchHeader({ sortColumns, title }) {
    const active = sortColumns && sortColumns.id == title;
    const direction = active ? sortColumns.sortAscending ? 'ascending' : 'descending' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "sorted-column-wrapper",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: direction
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${title}_catalog_search_header`
                })
            })
        ]
    });
}
function EmptyHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
}
function LabelColumn(maxLength) {
    return ({ value, sortColumns })=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _labelDefault.default), {
            value,
            maxLength
        });
    };
}
function LessonColumn({ rowData }) {
    const { lesson, lessonName } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan } = context;
            const { content = {} } = newPlan;
            const { lessons: planLessons = [] } = content;
            const index = (0, _lodash.findIndex)(planLessons, ({ id })=>lesson == id);
            const assigned = index >= 0;
            const assignedClass = `lesson-code${assigned ? ' assigned' : ''}`;
            const title = context.translate(assigned ? 'remove-lesson-from-plan' : 'add-lesson-to-plan');
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: assignedClass,
                title: title,
                onClick: ()=>{
                    const lessons = (0, _immutabilityHelperDefault.default)(planLessons, assigned ? {
                        $splice: [
                            [
                                index,
                                1
                            ]
                        ]
                    } : {
                        $push: [
                            {
                                id: lesson,
                                name: lessonName
                            }
                        ]
                    });
                    context.setState({
                        newPlan: {
                            ...newPlan,
                            content: {
                                ...content,
                                lessons
                            }
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bullet"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "code",
                        children: lesson
                    })
                ]
            });
        }
    });
}
function LessonLinksColumn({ rowData }) {
    const map = {
        lesson: 'id',
        lessonName: 'name'
    };
    const props = (0, _lodash.mapKeys)(rowData, (_, key)=>map[key] || key);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonLinksDefault.default), {
        ...props
    });
}
const map = {
    headers: {
        CatalogueSearchHeader: (0, _utils.enhancedWithSortColumns)(CatalogueSearchHeader),
        EmptyHeader
    },
    columns: {
        LessonColumn: (0, _utils.enhancedWithRowData)(LessonColumn),
        LessonLinksColumn: (0, _utils.enhancedWithRowData)(LessonLinksColumn),
        LabelColumn
    }
};
exports.default = map;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","../../label":"59910","./lesson-links":"4VOnl","../../../context":"iUP37","../../../helpers/utils":"gGc98","immutability-helper":"hwjCt","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4VOnl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>LessonLinks);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _url = require("../../../helpers/url");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../context");
var _icon = require("../../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function LessonLink(props) {
    const { key, show, to } = props;
    const linkProps = (0, _lodash.omit)(props, [
        'key',
        'show'
    ]);
    const LinkElem = to ? (0, _reactRouterDom.Link) : ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            ...linkProps,
            ...(0, _url.viewerGuard)(linkProps),
            children: children
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _clsxDefault.default)(key, 'link'),
        children: [
            show && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkElem, {
                ...linkProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            }),
            !show && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "disabled link",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            })
        ]
    }, key);
}
function LessonLinks(props) {
    const { id, hasEpl, hasSummary, hasKey } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translations, languageId, profile } = context;
            const { limited } = profile.institution;
            const tooltipTitle = (name)=>`${translations[`${name}_tooltip_title`][languageId]}: ${id}`;
            const links = [
                {
                    key: 'preview',
                    title: tooltipTitle('preview'),
                    show: hasEpl,
                    href: (0, _url.subdomainLink)('preview', '#', languageId, 'lesson', id),
                    target: "_blank"
                },
                {
                    key: 'summary',
                    title: tooltipTitle('summary'),
                    show: hasSummary,
                    href: (0, _url.pdfPreviewLink)('download', 'summary', languageId, id),
                    target: "_blank"
                },
                {
                    key: 'key',
                    title: tooltipTitle('key'),
                    show: hasKey && !limited,
                    href: (0, _url.pdfPreviewLink)('download', 'key', languageId, id),
                    target: "_blank"
                }
            ];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "links",
                children: links.map(LessonLink)
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","../../../helpers/url":"65SQD","react":"9njXz","react-router-dom":"3uzXR","../../../context":"iUP37","../../icon":"82gpi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bpGw2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _context = require("../../../context");
var _filtersStyl = require("./filters.styl");
function SelectFilter(props) {
    const className = `select-${props.name}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const id = context.query[props.valueProperty];
            const value = context[props.name].find((prop)=>prop.id == id);
            const placeholder = context.translate(`${props.name}_filters_no_options_message`);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "dropdown",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        className: className,
                        classNamePrefix: "select",
                        formatOptionLabel: ({ name })=>name,
                        isSearchable: false,
                        isClearable: true,
                        escapeClearsValue: true,
                        getOptionValue: ({ id })=>id,
                        placeholder: placeholder,
                        value: value,
                        onChange: (option)=>{
                            const { id } = option || {};
                            const query = {
                                [props.valueProperty]: id,
                                page: undefined
                            };
                            context.navigate({}, context.match.path, {
                                preserveQuery: true,
                                query
                            });
                        },
                        options: context[props.name]
                    })
                })
            });
        }
    });
}
function Filters() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "filters-wrapper",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "filters",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                    name: "subjects",
                    valueProperty: "subject"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                    name: "grades",
                    valueProperty: "grade"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                    name: "languages",
                    valueProperty: "languageId"
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-select":"j36cq","../../../context":"iUP37","./filters.styl":"kGAsh","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGAsh":[function() {},{}],"4O9if":[function() {},{}],"j7t75":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _griddleReact = require("griddle-react");
var _griddleReactDefault = parcelHelpers.interopDefault(_griddleReact);
var _context = require("../../../context");
var _utils = require("../../../helpers/utils");
var _contextLoader = require("../../context-loader");
var _contextLoaderDefault = parcelHelpers.interopDefault(_contextLoader);
var _searchPattern = require("../../search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _upload = require("./upload");
var _uploadDefault = parcelHelpers.interopDefault(_upload);
var _columns = require("./columns");
var _columnsDefault = parcelHelpers.interopDefault(_columns);
var _filters = require("./filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _pagination = require("../../pagination");
var _indexStyl = require("./index.styl");
const { columns, headers } = (0, _columnsDefault.default);
const Layout = ({ Table, Pagination, Filter })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "my-lessons-search-table",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Filter, {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Pagination, {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Table, {})
        ]
    });
function NoResults(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: props.className,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
            id: "my-lessons_search_no_results_label"
        })
    });
}
class MyLessons extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        (0, _utils.bind)(this, 'goPage', 'goNext', 'goPrevious', 'sort');
    }
    goPage(page) {
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                page
            }
        });
    }
    goNext() {
        this.goPage(this.context.myLessons[0].currentPage + 1);
    }
    goPrevious() {
        this.goPage(this.context.myLessons[0].currentPage - 1);
    }
    sort({ id, sortAscending }) {
        const orderBy = `${sortAscending ? '' : '-'}${id}`;
        this.context.navigate({}, this.context.match.params, {
            preserveQuery: true,
            query: {
                orderBy
            }
        });
    }
    render() {
        const context = this.context;
        const [pageProperties, ...lessons] = context.myLessons;
        const { recordCount } = pageProperties || {};
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contextLoaderDefault.default), {
            id: "myLessons",
            className: "my-lessons",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                                initialPattern: context.query.pattern
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "my-lessons-search-results",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReactDefault.default), {
                            data: lessons,
                            components: {
                                NoResults,
                                PageDropdown: (0, _pagination.PageDropdown),
                                Pagination: (0, _pagination.Pagination),
                                Layout,
                                Filter: (0, _filtersDefault.default)
                            },
                            pageProperties: pageProperties,
                            events: {
                                onNext: this.goNext,
                                onPrevious: this.goPrevious,
                                onGetPage: this.goPage,
                                onSort: this.sort
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _griddleReact.RowDefinition), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "name",
                                        customHeadingComponent: headers.MyLessonsHeader,
                                        customComponent: columns.UploadColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "subjectName",
                                        customHeadingComponent: headers.MyLessonsHeader
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "gradeName",
                                        customHeadingComponent: headers.MyLessonsHeader
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "byteLength",
                                        customHeadingComponent: headers.MyLessonsHeader,
                                        customComponent: columns.ByteLengthColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "modified",
                                        customHeadingComponent: headers.MyLessonsHeader,
                                        customComponent: columns.DateColumn
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _griddleReact.ColumnDefinition), {
                                        id: "links",
                                        customHeadingComponent: headers.EmptyHeader,
                                        customComponent: columns.LessonLinksColumn
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        });
    }
}
exports.default = MyLessons;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","griddle-react":"6zdUV","../../../context":"iUP37","../../../helpers/utils":"gGc98","../../context-loader":"ktxlD","../../search-pattern":"lUZFT","./upload":"kVppX","./columns":"bifEc","./filters":"440qY","../../pagination":"82vF6","./index.styl":"4oVIl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kVppX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UploadLesson);
var _jsxRuntime = require("react/jsx-runtime");
var _jquery = require("jquery");
var _jqueryDefault = parcelHelpers.interopDefault(_jquery);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _icon = require("../../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _moxie = require("../../../helpers/moxie");
var _moxieDefault = parcelHelpers.interopDefault(_moxie);
var _context = require("../../../context");
var _post = require("../../../context/post");
var _uploadStyl = require("./upload.styl");
function createSelect({ action, label, options, onChange }) {
    const $container = (0, _jqueryDefault.default)('<div>', {
        class: `select_${action}`
    });
    (0, _jqueryDefault.default)('<label>', {
        text: label
    }).appendTo($container);
    const $select = (0, _jqueryDefault.default)('<select>').appendTo($container);
    (0, _jqueryDefault.default)('<option>', {
        text: '',
        value: '',
        selected: 'selected'
    }).appendTo($select);
    options.forEach((item)=>{
        (0, _jqueryDefault.default)('<option>', {
            text: item.name,
            value: item.id
        }).appendTo($select);
    });
    $select.on('change', (e)=>{
        (0, _jqueryDefault.default)("option[value='']", e.target).remove();
        onChange({
            [action]: (0, _jqueryDefault.default)(e.target).val()
        });
    });
    return $select;
}
function enableUpload(enable) {
    const $button = (0, _jqueryDefault.default)('.moxman-primary > button');
    if (enable) $button.removeAttr('disabled').parent().removeClass('disabled');
    else $button.attr('disabled', 'disabled').parent().addClass('disabled');
}
function createSelectGrade(container, label, options, context) {
    (0, _jqueryDefault.default)('.select_grade', container).remove();
    enableUpload(false);
    const $grades = createSelect({
        action: 'grade',
        label,
        options,
        onChange: ({ grade })=>{
            enableUpload(true);
            context.grade = grade;
        }
    });
    container.append($grades.parent());
}
function createSelectSubject(container, label, options, context) {
    const $subjects = createSelect({
        action: 'subject',
        label,
        options,
        onChange: ({ subject })=>{
            context.subject = subject;
            const grades = Object.values(context.subjects[subject].grades);
            createSelectGrade(container, context.translate('grade_label'), grades, context);
        }
    });
    container.append($subjects.parent());
}
async function showUpload({ locale, subjects, translate, profile, setState, uploadUpdates }) {
    const context = {
        subjects,
        translate
    };
    const $uploadInfo = (0, _jqueryDefault.default)('<div>', {
        "class": 'uploadInfo'
    });
    createSelectSubject($uploadInfo, translate('subject_label'), Object.values(subjects), context);
    createSelectGrade($uploadInfo, translate('grade_label'), [], context);
    await (0, _moxieDefault.default);
    (0, _jqueryDefault.default)('body').on('DOMSubtreeModified', '.moxman-window', ()=>{
        (0, _jqueryDefault.default)('body').off('DOMSubtreeModified', '.moxman-window');
        (0, _jqueryDefault.default)('.moxman-window .moxman-upload-drop-zone').parent().prepend($uploadInfo);
        enableUpload(false);
    });
    window.moxman.upload({
        path: '/lesson',
        onupload: (e)=>{
            Promise.all(e.files.map((file)=>({
                    name: file.name,
                    subject: context.subject,
                    grade: context.grade,
                    file: `${profile.domain}/${profile.Passport.userName}/lesson/${file.name}`
                })).map((0, _post.saveUpload))).then(()=>{
                setState({
                    uploadUpdates: uploadUpdates + 1
                });
                (0, _jqueryDefault.default)('.moxman-last > button').trigger('click');
            });
        }
    });
}
function UploadLesson(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { languageId, settings, translate, profile, uploadUpdates, setState } = context;
            const locale = settings.moxman[languageId];
            const subjects = context.groups.reduce((acc, group)=>{
                const subjectId = group.course.substring(0, 2);
                const gradeId = group.course.substring(4, 7);
                acc[subjectId] = acc[subjectId] || {
                    id: subjectId,
                    name: group.subject,
                    grades: {}
                };
                acc[subjectId].grades[gradeId] = acc[subjectId].grades[gradeId] || {
                    id: gradeId,
                    name: group.grade
                };
                return acc;
            }, {});
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "upload-lesson",
                onClick: ()=>showUpload({
                        locale,
                        subjects,
                        translate,
                        profile,
                        uploadUpdates,
                        setState
                    }),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                            name: "lesson-upload"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "label-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "upload_lesson_label"
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","jquery":"2Z9Ua","react":"9njXz","react-text":"lEpdJ","../../icon":"82gpi","../../../helpers/moxie":"eWIsw","../../../context":"iUP37","../../../context/post":"8rmpk","./upload.styl":"hao8G","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hao8G":[function() {},{}],"bifEc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../../context");
var _uploadLinks = require("./upload-links");
var _uploadLinksDefault = parcelHelpers.interopDefault(_uploadLinks);
var _prettyBytes = require("pretty-bytes");
var _prettyBytesDefault = parcelHelpers.interopDefault(_prettyBytes);
var _utils = require("../../../helpers/utils");
function UploadColumn({ rowData }) {
    const { id: uploadId, name } = rowData;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan } = context;
            const { content = {} } = newPlan;
            const { lessons: planLessons = [] } = content;
            const index = (0, _lodash.findIndex)(planLessons, ({ id })=>uploadId == id);
            const assigned = index >= 0;
            const assignedClass = `lesson-name${assigned ? ' assigned' : ''}`;
            const title = context.translate(assigned ? 'remove-lesson-from-plan' : 'add-lesson-to-plan');
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: assignedClass,
                title: title,
                onClick: ()=>{
                    const lessons = (0, _immutabilityHelperDefault.default)(planLessons, assigned ? {
                        $splice: [
                            [
                                index,
                                1
                            ]
                        ]
                    } : {
                        $push: [
                            {
                                id: uploadId,
                                name
                            }
                        ]
                    });
                    context.setState({
                        newPlan: {
                            ...newPlan,
                            content: {
                                ...content,
                                lessons
                            }
                        }
                    });
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "bullet"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "code",
                        children: name
                    })
                ]
            });
        }
    });
}
function MyLessonsHeader({ sortColumns, title }) {
    const active = sortColumns && sortColumns.id == title;
    const direction = active ? sortColumns.sortAscending ? 'ascending' : 'descending' : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        className: "sorted-column-wrapper",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: direction
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: `${title}_my_lessons_header`
                })
            })
        ]
    });
}
function EmptyHeader() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {});
}
function ByteLengthColumn({ value }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "size",
        children: (0, _prettyBytesDefault.default)(value || 0)
    });
}
function DateColumn({ value }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "modified",
        children: (0, _momentDefault.default)(value).format('L, LT')
    });
}
function LessonLinksColumn({ rowData }) {
    const map = {
        lesson: 'id',
        lessonName: 'name'
    };
    const props = (0, _lodash.mapKeys)(rowData, (_, key)=>map[key] || key);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadLinksDefault.default), {
        ...props
    });
}
const map = {
    headers: {
        MyLessonsHeader: (0, _utils.enhancedWithSortColumns)(MyLessonsHeader),
        EmptyHeader
    },
    columns: {
        UploadColumn: (0, _utils.enhancedWithRowData)(UploadColumn),
        LessonLinksColumn: (0, _utils.enhancedWithRowData)(LessonLinksColumn),
        ByteLengthColumn,
        DateColumn
    }
};
exports.default = map;

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","immutability-helper":"hwjCt","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","../../../context":"iUP37","./upload-links":"bHLlw","pretty-bytes":"1L0Q0","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bHLlw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UploadLinks);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _url = require("../../../helpers/url");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../context");
var _icon = require("../../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
function LessonLink(props) {
    const { key, enabled, to, title, href } = props;
    const linkProps = (0, _lodash.omit)(props, [
        'key',
        'enabled'
    ]);
    const LinkElem = to ? (0, _reactRouterDom.Link) : ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            ...linkProps,
            children: children
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: key,
        children: [
            enabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkElem, {
                ...linkProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            }),
            !enabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "disabled",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                    name: key
                })
            })
        ]
    }, key);
}
function UploadLinks(props) {
    const { name, id, assigned } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { link, match, translations, languageId, profile } = context;
            const { limited } = profile.institution;
            const tooltipTitle = (name)=>`${translations[`${name}_tooltip_title`][languageId]}: ${props.name}`;
            const links = [
                {
                    key: 'download',
                    title: tooltipTitle('download'),
                    enabled: !limited,
                    href: (0, _url.subdomainLink)('download', profile.domain, profile.Passport.userName, 'lesson', name),
                    target: "blank"
                }
            ];
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "links",
                children: links.map(LessonLink)
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","../../../helpers/url":"65SQD","react":"9njXz","react-router-dom":"3uzXR","../../../context":"iUP37","../../icon":"82gpi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"440qY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Filters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _icon = require("../../icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _context = require("../../../context");
var _filtersStyl = require("./filters.styl");
function SelectFilter(props) {
    const className = `select-${props.name}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const id = context.query[props.valueProperty];
            const value = context[props.name].find((prop)=>prop.id == id);
            const placeholder = context.translate(`${props.name}_filters_no_options_message`);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "dropdown",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                        className: className,
                        classNamePrefix: "select",
                        formatOptionLabel: ({ name })=>name,
                        isSearchable: false,
                        isClearable: true,
                        escapeClearsValue: true,
                        getOptionValue: ({ id })=>id,
                        placeholder: placeholder,
                        value: value,
                        onChange: (option)=>{
                            const { id } = option || {};
                            const query = {
                                [props.valueProperty]: id,
                                page: undefined
                            };
                            context.navigate({}, context.match.path, {
                                preserveQuery: true,
                                query
                            });
                        },
                        options: context[props.name]
                    })
                })
            });
        }
    });
}
function Filters(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const [pageProperties] = context.myLessons;
            const { recordCount } = pageProperties || {};
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filters-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "filters",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "label-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconDefault.default), {
                                            name: "lesson-count"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "count",
                                        children: recordCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "uploaded_lessons_label"
                                                }),
                                                ": ",
                                                recordCount
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                flexGrow: 1
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectFilter, {
                            name: "grades",
                            valueProperty: "grade"
                        })
                    ]
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-select":"j36cq","../../icon":"82gpi","../../../context":"iUP37","./filters.styl":"c8pVP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8pVP":[function() {},{}],"4oVIl":[function() {},{}],"gAKwF":[function() {},{}],"hyhdn":[function() {},{}],"7o7tj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddStandard);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _reactRouterDom = require("react-router-dom");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../../context");
var _label = require("../../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _confirmDialog = require("../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _addStandards = require("../../add-standards");
var _addStandardsDefault = parcelHelpers.interopDefault(_addStandards);
var _utils = require("../../../helpers/utils");
var _planningSummaryCjs = require("components/standards-selector/domain/planning-summary.cjs");
var _addStandardStyl = require("./add-standard.styl");
function Standard(props) {
    const { code, description, deleteStandard } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "standard",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content",
                children: [
                    code != undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "code",
                        children: code
                    }),
                    code == undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "code",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "expectation"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "description",
                        title: description,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                            text: description,
                            maxLine: 3,
                            ellipsis: "...",
                            trimRight: true,
                            basedOn: "letters"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "delete",
                    onClick: deleteStandard,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTrashAlt)
                    })
                })
            })
        ]
    });
}
function AddStandard() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan, languageId, link } = context;
            const { content = {} } = newPlan;
            const { standards = [] } = content;
            const deleteStandard = (index, title)=>{
                return ()=>{
                    (0, _confirmDialogDefault.default)({
                        className: 'delete-field',
                        translate: context.translate,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "message",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "question",
                                    children: context.translate('confirm_delete_item')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title",
                                    children: title
                                })
                            ]
                        }),
                        onConfirm: ()=>{
                            const standards = (0, _immutabilityHelperDefault.default)(newPlan.content.standards, {
                                $splice: [
                                    [
                                        index,
                                        1
                                    ]
                                ]
                            });
                            context.setState({
                                newPlan: {
                                    ...newPlan,
                                    content: {
                                        ...content,
                                        standards
                                    }
                                }
                            });
                        }
                    });
                };
            };
            const editionGroups = (0, _planningSummaryCjs.groupPlanningStandards)(standards);
            const items = editionGroups.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "edition-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "edition-heading",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "standards"
                                }),
                                " \xb7 ",
                                group.year
                            ]
                        }),
                        group.items.map(({ item: standard, index })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Standard, {
                                index: index,
                                className: "standard",
                                deleteStandard: deleteStandard(index, standard.code ? standard.code.toUpperCase() : standard.description),
                                context: context,
                                ...standard
                            }, `${group.id}:${standard.id}:${index}`))
                    ]
                }, group.id));
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "standards",
                children: [
                    context.section == 'add-standards' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addStandardsDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "head",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "standards"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: "add-standard",
                                to: context.link({
                                    section: 'add-standards'
                                }, context.match.path, {
                                    preserveQuery: true,
                                    query: {
                                        subject: newPlan.subject,
                                        grade: newPlan.grade
                                    }
                                }),
                                children: "+"
                            })
                        ]
                    }),
                    items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "content",
                        children: items
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","react-text":"lEpdJ","react-lines-ellipsis":"ikp0X","react-router-dom":"3uzXR","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../context":"iUP37","../../label":"59910","../../confirm-dialog":"hzSdJ","../../add-standards":"6m0LW","../../../helpers/utils":"gGc98","components/standards-selector/domain/planning-summary.cjs":"aaPXn","./add-standard.styl":"3dax9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6m0LW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddStandard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _standardsSelector = require("components/standards-selector/components/StandardsSelector");
var _standardsSelectorDefault = parcelHelpers.interopDefault(_standardsSelector);
var _planningSummaryCjs = require("components/standards-selector/domain/planning-summary.cjs");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _indexStyl = require("./index.styl");
function AddStandard() {
    const context = (0, _react.useContext)((0, _context.Context));
    const { newPlan, languageId, query, setState } = context;
    const [isOpen, setIsOpen] = (0, _react.useState)(true);
    const [filters, setFilters] = (0, _react.useState)(query || {});
    const selected = (newPlan.content || {}).standards || [];
    const load = (0, _react.useCallback)((entity, parameters)=>(0, _commandDefault.default)('de', entity)({
            language: languageId,
            ...parameters
        }), [
        languageId
    ]);
    function navigateOut() {
        context.navigate({}, context.match.path.replace(/\/:section.*$/, ''), {
            query: {
                template: query.template
            }
        });
    }
    function changeSelection(standards) {
        setState({
            newPlan: (0, _planningSummaryCjs.updatePlanStandards)(newPlan, standards)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
        isOpen: isOpen,
        onAfterClose: navigateOut,
        onRequestClose: ()=>setIsOpen(false),
        contentLabel: "",
        className: "add-standard-wrapper",
        appElement: document.querySelector('#root'),
        closeTimeoutMS: 800,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "add-standard",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "title",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "label",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "standards"
                                }),
                                newPlan.title != '' && `: ${newPlan.title}`
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "close",
                            onClick: ()=>setIsOpen(false),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faTimesCircle)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "selector-content",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsSelectorDefault.default), {
                                language: languageId,
                                load: load,
                                mode: "planning",
                                filters: filters,
                                onFiltersChange: setFilters,
                                selected: selected,
                                onSelectionChange: changeSelection
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "buttons",
                            style: {
                                display: 'flex'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        flexGrow: 1
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "accept",
                                    onClick: ()=>setIsOpen(false),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "accept"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","react-modal":"kV9Wz","react-text":"lEpdJ","../../context":"iUP37","helpers/command":"f3cbG","components/standards-selector/components/StandardsSelector":"c5fch","components/standards-selector/domain/planning-summary.cjs":"aaPXn","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./index.styl":"hVwN2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aaPXn":[function(require,module,exports,__globalThis) {
const { groupByEdition } = require("5b80cfaf03510286");
function groupPlanningStandards(items = []) {
    return groupByEdition(items.map((item, index)=>({
            item,
            index,
            standard_set: item.standard_set
        }))).map((group)=>({
            ...group,
            items: group.items.map(({ item, index })=>({
                    item,
                    index
                }))
        }));
}
function updatePlanStandards(plan, standards) {
    return {
        ...plan,
        content: {
            ...plan.content || {},
            standards
        }
    };
}
module.exports = {
    groupPlanningStandards,
    updatePlanStandards
};

},{"5b80cfaf03510286":"Ul5PW"}],"hVwN2":[function() {},{}],"3dax9":[function() {},{}],"8Wxwy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddResource);
var _jsxRuntime = require("react/jsx-runtime");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactLinesEllipsis = require("react-lines-ellipsis");
var _reactLinesEllipsisDefault = parcelHelpers.interopDefault(_reactLinesEllipsis);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../../../context");
var _label = require("../../../label");
var _labelDefault = parcelHelpers.interopDefault(_label);
var _confirmDialog = require("../../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _addLinkResource = require("../../../add-link-resource");
var _addLinkResourceDefault = parcelHelpers.interopDefault(_addLinkResource);
var _menu = require("./menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _indexStyl = require("./index.styl");
function ResourceLink(props) {
    const { title, href, deleteResource } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "resource link",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "id",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "link",
                        href: href,
                        targe: "_blank",
                        title: href,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactLinesEllipsisDefault.default), {
                            text: href,
                            maxLine: 1,
                            ellipsis: "...",
                            trimRight: true,
                            basedOn: "letters"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "delete",
                    onClick: deleteResource,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                        icon: (0, _freeSolidSvgIcons.faTrashAlt)
                    })
                })
            })
        ]
    });
}
const resourceMap = {
    link: ResourceLink
};
function AddResource() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { newPlan, languageId, link } = context;
            const { content = {} } = newPlan;
            const { resources = [] } = content;
            const deleteResource = (index, title)=>{
                return ()=>{
                    (0, _confirmDialogDefault.default)({
                        className: 'delete-resource',
                        translate: context.translate,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "message",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "question",
                                    children: context.translate('confirm_delete_item')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title",
                                    children: title
                                })
                            ]
                        }),
                        onConfirm: ()=>{
                            const resources = (0, _immutabilityHelperDefault.default)(newPlan.content.resources, {
                                $splice: [
                                    [
                                        index,
                                        1
                                    ]
                                ]
                            });
                            context.setState({
                                newPlan: {
                                    ...newPlan,
                                    content: {
                                        ...content,
                                        resources
                                    }
                                }
                            });
                        }
                    });
                };
            };
            const items = resources.filter(({ type })=>resourceMap[type]).map((resource, index)=>{
                const Resource = resourceMap[resource.type];
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Resource, {
                    index: index,
                    className: "resource",
                    deleteResource: deleteResource(index, resource.title),
                    context: context,
                    ...resource
                }, index);
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "resources",
                children: [
                    context.section == 'add-link-resource' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addLinkResourceDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "head",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "digital-resources"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {})
                        ]
                    }),
                    items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "content",
                        children: items
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","immutability-helper":"hwjCt","react":"9njXz","react-text":"lEpdJ","react-lines-ellipsis":"ikp0X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../../context":"iUP37","../../../label":"59910","../../../confirm-dialog":"hzSdJ","../../../add-link-resource":"f8li1","./menu":"6V8pp","./index.styl":"8lziG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f8li1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactModal = require("react-modal");
var _reactModalDefault = parcelHelpers.interopDefault(_reactModal);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _indexStyl = require("./index.styl");
function Buttons({ buttonProps }) {
    const buttons = buttonProps.map((props, index)=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            className: props.label,
            onClick: props.onClick,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                id: props.label
            })
        }, index);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "buttons",
        style: {
            display: "flex"
        },
        children: buttons
    });
}
class AddResourceLink extends (0, _reactDefault.default).Component {
    static contextType = (0, _context.Context);
    constructor(props){
        super(props);
        const setState = this.setState.bind(this);
        this.state = {
            isOpen: true,
            title: '',
            href: '',
            setState
        };
    }
    render() {
        const context = this.context;
        const template = context.query.template;
        const { newPlan, navigate } = context;
        const { content = {} } = newPlan;
        const { resources: planResources = [] } = content;
        const { setState, isOpen } = this.state;
        const close = ()=>setState({
                isOpen: false
            });
        const navigateOut = ()=>{
            context.navigate({}, context.match.path.replace(/\/:section.*$/, ''), {
                query: {
                    template
                }
            });
        };
        const create = ()=>{
            const href = /^http[s]*:\/\//.test(this.state.href) ? this.state.href : `http://${this.state.href}`;
            const resources = (0, _immutabilityHelperDefault.default)(planResources, {
                $push: [
                    {
                        type: 'link',
                        title: this.state.title,
                        href
                    }
                ]
            });
            context.setState({
                newPlan: {
                    ...newPlan,
                    content: {
                        ...content,
                        resources
                    }
                }
            }, close);
        };
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactModalDefault.default), {
            isOpen: isOpen,
            onAfterClose: navigateOut,
            onRequestClose: close,
            contentLabel: "",
            className: "add-link-resource-wrapper",
            appElement: document.querySelector('#root'),
            closeTimeoutMS: 800,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "add-link-resource",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "resource"
                                    }),
                                    ": ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: "link"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "close",
                                onClick: ()=>close(),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faTimesCircle)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "name",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "title"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                value: this.state.title,
                                                onChange: (e)=>setState({
                                                        title: e.target.value
                                                    })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "link",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                    id: "link"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                value: this.state.href,
                                                onChange: (e)=>setState({
                                                        href: e.target.value
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Buttons, {
                                buttonProps: [
                                    {
                                        label: 'cancel',
                                        onClick: close,
                                        enabled: true
                                    },
                                    {
                                        label: 'create',
                                        onClick: create,
                                        enabled: true
                                    }
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
exports.default = AddResourceLink;

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","immutability-helper":"hwjCt","react":"9njXz","react-modal":"kV9Wz","react-text":"lEpdJ","../../context":"iUP37","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./index.styl":"dmyWU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dmyWU":[function() {},{}],"6V8pp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TemplatesMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _menu = require("@mui/material/Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../../../context");
var _menuStyl = require("./menu.styl");
const menuButtonStyles = (0, _material.makeStyles)({
    root: {
        color: '#6679ad',
        background: '#f0f7ff',
        textTransform: 'none',
        border: 'solid 1px #a3b6d9',
        boxShadow: 'none',
        '&:hover': {
            background: '#eaf5ff'
        }
    }
});
const menuStyles = (0, _material.makeStyles)({
    root: {
        background: '#eaf5ff',
        padding: '0 8px'
    }
});
const itemStyles = (0, _material.makeStyles)({
    root: {
        minWidth: '244px',
        maxWidth: '244px',
        display: 'flex',
        color: '#4e576e'
    }
});
function TemplatesMenu(props) {
    const menuButtonClasses = menuButtonStyles();
    const menuClasses = menuStyles();
    const itemClasses = itemStyles();
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "resources-menu",
                style: {
                    width: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
                        "aria-controls": "customized-menu",
                        "aria-haspopup": "true",
                        variant: "contained",
                        classes: menuButtonClasses,
                        onClick: handleClick,
                        sx: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "plus-icon",
                                children: "+"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "label",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "add-resources"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "arrow",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                    icon: (0, _freeSolidSvgIcons.faCaretDown)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuDefault.default), {
                        elevation: 0,
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left'
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left'
                        },
                        id: "add-resource-menu",
                        anchorEl: anchorEl,
                        MenuListProps: {
                            disablePadding: true,
                            classes: menuClasses
                        },
                        keepMounted: true,
                        open: Boolean(anchorEl),
                        onClose: handleClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            disableGutters: true,
                            classes: itemClasses,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: "add-link-button",
                                to: context.link({
                                    section: 'add-link-resource'
                                }, context.match.path, {
                                    preserveQuery: true
                                }),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "link"
                                })
                            })
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Menu":"fW0kE","@mui/material/MenuItem":"a18vm","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../../context":"iUP37","./menu.styl":"G5CMj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"G5CMj":[function() {},{}],"8lziG":[function() {},{}],"aGeKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Field);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDnd = require("react-dnd");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _inputBase = require("@mui/material/InputBase");
var _inputBaseDefault = parcelHelpers.interopDefault(_inputBase);
var _fieldContent = require("./field-content");
var _fieldContentDefault = parcelHelpers.interopDefault(_fieldContent);
var _fieldStyl = require("./field.styl");
function setName(context, field, name) {
    const data = context.newPlan;
    if (data.items) {
        const items = data.items.map((item)=>item.id === field ? {
                ...item,
                content: {
                    ...item.content,
                    name
                }
            } : item);
        const newPlan = {
            ...data,
            items
        };
        context.setState({
            newPlan
        });
    }
}
function Field(props) {
    const { id, name, index, moveField, className, deleteField, context } = props;
    const ref = (0, _react.useRef)(null);
    const [, drop] = (0, _reactDnd.useDrop)({
        accept: 'FIELD',
        hover (item, monitor) {
            if (!ref.current) return;
            const dragIndex = item.index;
            const hoverIndex = index;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) return;
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
            // Time to actually perform the action
            moveField(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex;
        }
    });
    const [{ isDragging }, drag] = (0, _reactDnd.useDrag)({
        item: {
            type: 'FIELD',
            id,
            index
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            })
    });
    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    const sections = props.sections.map((props, contentId)=>({
            props,
            Element: (0, _fieldContentDefault.default)[props.type],
            contentId
        })).filter((section)=>section.Element).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            ...props,
            id: id,
            contentId: contentId,
            context: context
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        id: id,
        style: {
            opacity
        },
        className: `${className} field`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: ref,
                className: "title",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "sorter",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "dots"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "name",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputBaseDefault.default), {
                            id: `${id}-name`,
                            value: name,
                            readOnly: props.className != 'annotations',
                            onChange: (e)=>setName(context, id, e.target.value),
                            margin: "dense"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "delete",
                        onClick: deleteField,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                            icon: (0, _freeSolidSvgIcons.faTimesCircle)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "content",
                children: sections
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-dnd":"9NZ1L","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","@mui/material/InputBase":"c1XNn","./field-content":"di8Cw","./field.styl":"2rR7A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"di8Cw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
const types = {
    checkbox: Checkbox,
    textarea: Textarea,
    panel: Panel,
    dropdown: Dropdown,
    radiopanel: RadioPanel
};
function getValue(context, field, contentId, panelId, contentIndex) {
    const data = context.newPlan;
    if (!data.items) return;
    const item = data.items.find((i)=>i.id === field);
    if (!item) return;
    const insidePanel = panelId !== undefined;
    const insideList = contentIndex !== undefined;
    const { content } = item;
    const section = content.sections[insidePanel ? panelId : contentId];
    if (!section) return;
    if (insidePanel) {
        const child = section.children[contentId];
        if (!child) return;
        return insideList ? child.value[contentIndex] : child.value;
    } else return insideList ? section.value[contentIndex] : section.value;
}
function setValue(context, field, contentId, value, panelId, contentIndex) {
    const data = context.newPlan;
    const insidePanel = panelId !== undefined;
    const insideList = contentIndex !== undefined;
    if (data.items) {
        const items = data.items.map((item)=>{
            if (item.id != field) return item;
            const { content } = item;
            const sections = content.sections.map((section, index)=>{
                if (insidePanel) {
                    if (index !== panelId) return section;
                    else {
                        const children = section.children.map((child, index)=>{
                            if (index !== contentId) return child;
                            if (!insideList) return {
                                ...child,
                                value
                            };
                            return {
                                ...child,
                                value: child.value.map((v, index)=>index === contentIndex ? value : v)
                            };
                        });
                        return {
                            ...section,
                            children
                        };
                    }
                } else {
                    if (index !== contentId) return section;
                    else {
                        if (!insideList) return {
                            ...section,
                            value
                        };
                        else return {
                            ...section,
                            value: section.value.map((v, index)=>index === contentIndex ? value : v)
                        };
                    }
                }
            });
            return {
                ...item,
                content: {
                    ...content,
                    sections
                }
            };
        });
        const newPlan = {
            ...data,
            items
        };
        context.setState({
            newPlan
        });
    }
}
function Dropdown(props) {
    const { name, count, grouped, value, optionsMap, mapIndex, context } = props;
    const [optionsSelector] = getValue(props.context, props.id, mapIndex, props.panelId) || [];
    function updateDropdownProperties(propertyUpdates) {
        const insidePanel = props.panelId !== undefined;
        const itemIndex = props.context.newPlan.items.findIndex((i)=>i.id === props.id);
        if (itemIndex >= 0) {
            const updateCommand = insidePanel ? {
                newPlan: {
                    items: {
                        [itemIndex]: {
                            content: {
                                sections: {
                                    [props.panelId]: {
                                        children: {
                                            [props.contentId]: propertyUpdates
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } : {
                newPlan: {
                    items: {
                        [itemIndex]: {
                            content: {
                                sections: {
                                    [props.contentId]: propertyUpdates
                                }
                            }
                        }
                    }
                }
            };
            context.updateState(updateCommand);
        }
    }
    (0, _reactDefault.default).useEffect(()=>{
        if (optionsMap) {
            const options = optionsMap[optionsSelector] || [];
            const value = props.optionsSelector === optionsSelector && props.value || "";
            updateDropdownProperties({
                value: {
                    $set: [
                        value
                    ]
                },
                options: {
                    $set: options
                },
                optionsSelector: {
                    $set: optionsSelector
                }
            });
        }
    }, [
        optionsSelector
    ]);
    const selects = value.map((val, index)=>{
        const label = value.length < 2 ? name : `${name} ${index + 1}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "select",
            children: [
                !grouped && name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: label
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactSelectDefault.default), {
                    isClearable: true,
                    isSearchable: true,
                    placeholder: context.translate('pick_one'),
                    value: {
                        label: val,
                        value: val
                    },
                    onChange: (option)=>{
                        const { value } = option || {};
                        if (optionsMap) updateDropdownProperties({
                            optionsSelector: {
                                $set: optionsSelector
                            }
                        });
                        setValue(props.context, props.id, props.contentId, value, props.panelId, index);
                    },
                    options: props.options.map((a)=>({
                            label: a,
                            value: a
                        }))
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            grouped && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            selects
        ]
    });
}
function Checkbox(props) {
    const { context } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "checkbox",
                    checked: props.value,
                    onChange: (event)=>{
                        setValue(context, props.id, props.contentId, event.target.checked, props.panelId);
                    }
                }),
                props.name
            ]
        })
    });
}
function Textarea({ context, name, maxlength, value, id, panelId, contentId }) {
    const [text, setText] = (0, _react.useState)('');
    const handleChange = ({ target })=>{
        setText(target.value);
        setTimeout(()=>{
            if (target.value !== value) {
                console.log(target.value);
                setValue(context, id, contentId, target.value, panelId);
            }
        }, 2000);
    };
    (0, _react.useEffect)(()=>{
        if (text != value) setText(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                placeholder: context.translate('write_here'),
                value: text,
                rows: 4,
                onChange: handleChange
            })
        ]
    });
}
function Panel(panelProps) {
    const { id, name, context } = panelProps;
    const children = panelProps.children.map((props, contentId)=>({
            props,
            Element: types[props.type],
            contentId
        })).filter((section)=>section.Element).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            id: id,
            panelId: panelProps.contentId,
            contentId: contentId,
            context: context,
            ...props
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "children",
                children: children
            })
        ]
    });
}
function RadioPanel(panelProps) {
    const { id, name, context } = panelProps;
    const children = panelProps.children.map((props, contentId)=>{
        const radioId = `${id}-radio-${contentId}`;
        const checked = panelProps.value === props.name;
        const children = checked && props.value.map((props, index)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)("radio-panel-option", {
                    checked
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            checked: props.value || false,
                            onChange: (event)=>{
                                setValue(context, id, contentId, (0, _immutabilityHelperDefault.default)(props, {
                                    value: {
                                        $set: event.target.checked
                                    }
                                }), panelProps.contentId, index);
                            }
                        }),
                        props.name
                    ]
                })
            }, index);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _clsxDefault.default)("radio-panel-item", {
                checked
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: radioId,
                    type: "radio",
                    name: id,
                    checked: checked,
                    value: props.name,
                    onChange: (event)=>{
                        setValue(context, panelProps.id, panelProps.contentId, event.target.value, panelProps.panelId);
                    }
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: radioId,
                    children: props.name
                }),
                children && children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "children",
                    children: children
                })
            ]
        }, contentId);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "children",
                children: children
            })
        ]
    });
}
exports.default = types;

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","immutability-helper":"hwjCt","react":"9njXz","react-select":"j36cq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2rR7A":[function() {},{}],"aByo9":[function() {},{}],"dF5cj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Loader", ()=>Loader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _circularProgress = require("@mui/material/CircularProgress");
var _circularProgressDefault = parcelHelpers.interopDefault(_circularProgress);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _loaderStyl = require("./loader.styl");
const Loader = ({ isLoading = false })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
            className: "box",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circularProgressDefault.default), {
                className: "progress"
            })
        })
    });
};

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@mui/material/CircularProgress":"bK4ky","@mui/material/Box":"73kto","./loader.styl":"a1gPv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a1gPv":[function() {},{}],"dP6U1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanRD);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _planningTopbar = require("planning/PlanningTopbar");
var _planningTopbarDefault = parcelHelpers.interopDefault(_planningTopbar);
var _addDailyPlanning = require("./DailyPlanning/AddDailyPlanning");
var _addDailyPlanningDefault = parcelHelpers.interopDefault(_addDailyPlanning);
var _planificationAcordion = require("./components/PlanificationAcordion");
var _planificationAcordionDefault = parcelHelpers.interopDefault(_planificationAcordion);
var _unitPlan = require("./UnitPlan");
var _unitPlanDefault = parcelHelpers.interopDefault(_unitPlan);
var _generaInfo = require("./GeneraInfo");
var _generaInfoDefault = parcelHelpers.interopDefault(_generaInfo);
var _sideBar = require("./SideBar");
var _sideBarDefault = parcelHelpers.interopDefault(_sideBar);
var _dailyPlanning = require("./DailyPlanning");
var _dailyPlanningDefault = parcelHelpers.interopDefault(_dailyPlanning);
var _context = require("teacher/context");
const StyledPlanRD = (0, _material.styled)('div')(planRDStyles);
const PlanRD = ()=>{
    const { translate } = (0, _react.useContext)((0, _context.TeacherContext));
    const [lastItemRef, scrollToLastItem] = (0, _react.useScrollToRefChange)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.LocalizationProvider), {
        dateAdapter: (0, _material.AdapterDayjs),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledPlanRD, {
            className: "plan-rd",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planningTopbarDefault.default), {
                    className: "topbar",
                    rd: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDailyPlanningDefault.default), {
                        scrollToLastItem: scrollToLastItem
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "main",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _planificationAcordionDefault.default), {
                                    className: "unit-planning",
                                    title: translate('planning-rd-unit-planning'),
                                    deleteButton: false,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generaInfoDefault.default), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitPlanDefault.default), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dailyPlanningDefault.default), {
                                    lastItemRef: lastItemRef
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sideBarDefault.default), {
                            className: "sidebar"
                        })
                    ]
                })
            ]
        })
    });
};
function planRDStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        '& > .topbar': {
            flexShrink: 0
        },
        '& > .main': {
            padding: '10px 20px',
            flexGrow: 1,
            overflow: 'hidden',
            display: 'flex',
            gap: 15,
            '& > .content': {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                overflowY: 'auto',
                paddingRight: 10
            },
            '& > .sidebar': {
                minWidth: 310,
                maxWidth: 310,
                overflowY: 'auto',
                scrollbarWidth: 'thin'
            },
            '& .unit-planning': {
                marginBottom: 20
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","planning/PlanningTopbar":"lUSYh","./DailyPlanning/AddDailyPlanning":"hYnWZ","./components/PlanificationAcordion":"93LwZ","./UnitPlan":"5eYiH","./GeneraInfo":"2eDM2","./SideBar":"3NHtO","./DailyPlanning":"4gNnE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lUSYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanningTopbar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _selectTemplate = require("./Templates/SelectTemplate");
var _selectTemplateDefault = parcelHelpers.interopDefault(_selectTemplate);
var _templatesMenu = require("./Templates/TemplatesMenu");
var _templatesMenuDefault = parcelHelpers.interopDefault(_templatesMenu);
var _savePlan = require("./Buttons/SavePlan");
var _savePlanDefault = parcelHelpers.interopDefault(_savePlan);
var _cancelPlan = require("./Buttons/CancelPlan");
var _cancelPlanDefault = parcelHelpers.interopDefault(_cancelPlan);
const StyledPlanningTopbar = (0, _material.styled)('div')(planningTopbarStyles);
const PlanningTopbar = (props)=>{
    const { rd, children, className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledPlanningTopbar, {
        className: className,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _templatesMenuDefault.default), {
                rd: rd
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectTemplateDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "filler"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelPlanDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _savePlanDefault.default), {})
        ]
    });
};
function planningTopbarStyles() {
    return {
        minHeight: "40px",
        marginTop: "10px",
        gap: 20,
        display: "flex",
        "& > .filler": {
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./Templates/SelectTemplate":"kum8x","./Templates/TemplatesMenu":"91P6N","./Buttons/SavePlan":"7OewJ","./Buttons/CancelPlan":"7Fkfc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kum8x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectTemplate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _confirmDialog = require("components/confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
const StyledSelectTemplate = (0, _material.styled)('div')(selectTemplateStyles);
const SelectTemplate = (props)=>{
    const { planTemplates, translate, navigate, query, match } = (0, _react.useContext)((0, _context.TeacherContext));
    const templates = (0, _react.useMemo)(()=>planTemplates.map((template)=>template.label == 'default' ? {
                ...template,
                label: translate('default_template_label').replace('rd-', '')
            } : template), [
        planTemplates
    ]);
    const template = (0, _react.useMemo)(()=>templates.find((template)=>template.value === query.template), [
        templates,
        query.template
    ]);
    function applyTemplate(option) {
        const { value: template, label } = option;
        if (query.template !== template) (0, _confirmDialogDefault.default)({
            className: 'apply-template',
            translate: translate,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "message",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "question",
                        children: translate('confirm_apply_template')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: label
                    })
                ]
            }),
            onConfirm: ()=>{
                const query = {
                    template
                };
                navigate({}, match.path, {
                    preserveQuery: true,
                    query
                });
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSelectTemplate, {
        className: "apply-template",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Select), {
            className: "templates",
            classNamePrefix: "select-",
            isSearchable: false,
            value: template,
            onChange: applyTemplate,
            options: templates
        })
    });
};
function selectTemplateStyles() {
    return {
        cursor: "pointer",
        minWidth: "250px",
        ".apply-template.confirm-dialog": {
            border: "solid 1px #bcc0c9",
            color: "#515a71",
            borderRadius: "6px",
            padding: "20px",
            backgroundColor: "#edf1f5",
            "& .question": {
                fontSize: "15pt"
            },
            "& .title": {
                fontSize: "12pt",
                marginTop: "10px",
                marginLeft: "12px"
            },
            "& .buttons": {
                display: "flex",
                justifyContent: "flex-end",
                paddingTop: "20px",
                "& .button": {
                    cursor: "pointer",
                    width: "50px",
                    textAlign: "center",
                    borderRadius: "5px",
                    padding: "4px 0",
                    "&:hover": {
                        transform: "scale(1.04)"
                    },
                    "&.yes": {
                        marginRight: "15px",
                        border: "solid 1px #2ca5ec",
                        backgroundColor: "#2ca5ec",
                        color: "#fff"
                    },
                    "&.no": {
                        border: "solid 1px #c2c5c6",
                        color: "#ef4747"
                    }
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","components/confirm-dialog":"hzSdJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"91P6N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TemplatesMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _saveTemplateDialog = require("./SaveTemplateDialog");
const StyledTemplatesMenu = (0, _material.styled)('div')(templatesMenuStyles);
const TemplatesMenu = (props)=>{
    const { rd = false } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { link, match, translate } = context;
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    function handleClick(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleClose() {
        setAnchorEl(null);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledTemplatesMenu, {
        className: "templates-menu",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                "aria-controls": "customized-menu",
                "aria-haspopup": "true",
                variant: "contained",
                className: "add",
                onClick: handleClick,
                endIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.KeyboardArrowDownIcon), {}),
                children: translate("templates_label")
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Menu), {
                elevation: 0,
                className: "menu",
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left'
                },
                id: "add-field-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: Boolean(anchorEl),
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                        disableGutters: true,
                        className: "item",
                        onClick: ()=>{
                            (0, _saveTemplateDialog.saveTemplateDialog)({
                                rd,
                                context
                            });
                            handleClose();
                        },
                        children: translate("save_as_template")
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                        disableGutters: true,
                        className: (0, _material.clsx)("item", "manage-templates"),
                        component: (0, _react.Link),
                        to: link({}, `${match.path}/templates`, {
                            preserveQuery: true
                        }),
                        children: translate("manage_templates")
                    })
                ]
            })
        ]
    });
};
function templatesMenuStyles() {
    return {
        "& .add": {
            color: '#4e576e',
            background: '#fff',
            textTransform: 'none',
            '&:hover': {
                background: '#eaf5ff'
            }
        },
        "& .item": {
            minWidth: '200px',
            color: '#4e576e',
            padding: '10px',
            '&:hover': {
                color: '#fff',
                background: '#2993ff'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","./SaveTemplateDialog":"axub6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axub6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveTemplateDialog", ()=>saveTemplateDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _post = require("context/post");
var _utils = require("helpers/utils");
const StyledSaveTemplateDialog = (0, _material.styled)('div')(saveTemplateDialogStyles);
const SaveTemplateDialog = (props)=>{
    const { onClose, rd, context } = props;
    const { translate, updateState, newPlan } = context;
    const [name, setName] = (0, _react.useState)(newPlan.title || "");
    const canSave = (0, _react.useMemo)(()=>!(0, _utils.isEmpty)(name), [
        name
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledSaveTemplateDialog, {
        className: "save-template-dialog",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "title",
                children: translate('save_template_label')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    value: name,
                    type: "text",
                    onChange: (e)=>setName(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "buttons",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "save button",
                        disabled: !canSave,
                        onClick: async ()=>{
                            const save = rd ? (0, _post.saveRDTemplate) : (0, _post.saveTemplate);
                            await save(name, newPlan);
                            await updateState({
                                templateUpdates: {
                                    $apply: (i)=>i + 1
                                }
                            });
                            onClose();
                        },
                        children: translate('save_label')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "cancel button",
                        onClick: onClose,
                        children: translate('cancel_label')
                    })
                ]
            })
        ]
    });
};
function saveTemplateDialog(props) {
    return (0, _react.confirmAlert)({
        customUI: ({ onClose })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SaveTemplateDialog, {
                ...props,
                onClose
            })
    });
}
function saveTemplateDialogStyles() {
    return {
        border: "solid 1px #bcc0c9",
        color: "#515a71",
        borderRadius: "6px",
        padding: "20px 50px",
        backgroundColor: "#edf1f5",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        "& > div": {
            display: "flex"
        },
        "& .title": {
            fontWeight: "bold",
            fontSize: "13pt"
        },
        "& .input": {
            marginTop: "10px",
            "& input": {
                flexGrow: 1
            }
        },
        "& .buttons": {
            marginTop: "25px",
            justifyContent: "center",
            "& .button": {
                cursor: "pointer",
                fontSize: "12pt",
                width: "70px",
                textAlign: "center",
                borderRadius: "5px",
                padding: "4px 0",
                "&:hover": {
                    transform: "scale(1.04)"
                },
                "&.save:disabled,&.save[disabled]": {
                    cursor: "default",
                    opacity: "0.5",
                    border: "1px solid #999999",
                    backgroundColor: "#cccccc",
                    color: "#666666",
                    "&:hover": {
                        transform: "none"
                    }
                },
                "&.save": {
                    marginRight: "15px",
                    border: "solid 1px #2ca5ec",
                    backgroundColor: "#2ca5ec",
                    color: "#fff"
                },
                "&.cancel": {
                    border: "solid 1px #c2c5c6",
                    color: "#ef4747"
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","context/post":"8rmpk","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7OewJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SavePlan);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("external/lodash");
var _moment = require("external/moment");
var _react = require("external/react");
var _context = require("teacher/context");
var _post = require("context/post");
var _styledTopbarButton = require("./StyledTopbarButton");
var _styledTopbarButtonDefault = parcelHelpers.interopDefault(_styledTopbarButton);
const SavePlan = (props)=>{
    const { canSave = true, templateId } = props;
    const { translate, navigate, page, newPlan, newPlanFrom, newPlanFromQuery } = (0, _react.useContext)((0, _context.TeacherContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledTopbarButtonDefault.default), {
        variant: "contained",
        disabled: canSave ? undefined : true,
        onClick: async ()=>{
            const planToSave = (0, _lodash.cloneDeep)(newPlan);
            planToSave.content = planToSave.content || {};
            planToSave.content.source = page;
            await (0, _post.savePlan)(planToSave, templateId);
            const query = {
                ...newPlanFromQuery,
                ...(0, _moment.defaultRanges)[newPlanFrom](planToSave.start)
            };
            navigate({
                view: newPlanFrom
            }, '/:languageId/:role/:page/:view', {
                query
            });
        },
        children: translate("save-plan-label")
    });
};

},{"react/jsx-runtime":"1dlk8","external/lodash":"5bCAQ","external/moment":"mpofx","external/react":"k16GP","teacher/context":"5LKDx","context/post":"8rmpk","./StyledTopbarButton":"gR99g","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gR99g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StyledButton);
var _material = require("external/material");
const StyledButton = (0, _material.styled)((0, _material.Button))(buttonStyles);
function buttonStyles() {
    return {
        color: '#4e576e',
        width: '145px',
        textTransform: 'none',
        background: '#fff',
        '&:first-child': {
            'margin-left': '9px'
        },
        '&:hover': {
            background: '#eaf5ff'
        }
    };
}

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Fkfc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CancelPlan);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _context = require("teacher/context");
var _styledTopbarButton = require("./StyledTopbarButton");
var _styledTopbarButtonDefault = parcelHelpers.interopDefault(_styledTopbarButton);
const CancelPlan = (props)=>{
    const { translate, navigate, newPlanFrom, newPlanFromQuery } = (0, _react.useContext)((0, _context.TeacherContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _styledTopbarButtonDefault.default), {
        variant: "contained",
        onClick: ()=>{
            navigate({
                view: newPlanFrom
            }, '/:languageId/:role/:page/:view', {
                query: newPlanFromQuery
            });
        },
        ...props,
        children: translate("cancel_label")
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","teacher/context":"5LKDx","./StyledTopbarButton":"gR99g","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYnWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddDailyPlanning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _dayjs = require("external/dayjs");
var _dateFns = require("external/date-fns");
var _context = require("teacher/context");
const StyledAddDailyPlanning = (0, _material.styled)((0, _material.Button))(addDailyPlannningStyles);
const AddDailyPlanning = (props)=>{
    const { scrollToLastItem } = props;
    const { newPlan: { start, finish, content }, translate, updateState } = (0, _react.useContext)((0, _context.TeacherContext));
    // We disregard the time so that the days are calculated correctly and allow planning for one day
    const differenceInDays = (0, _react.useMemo)(()=>{
        const startDate = (0, _dayjs.dayjs)(getDateString(start));
        const finishDate = (0, _dayjs.dayjs)(getDateString(finish));
        const dayDiff = finishDate.diff(startDate, 'days');
        return isNaN(dayDiff) ? 0 : dayDiff + 1;
    }, [
        start,
        finish
    ]);
    const thereIsAvaliableDays = (0, _react.useMemo)(()=>(content?.dailyPlanning?.length ?? 0) < differenceInDays, [
        content,
        differenceInDays
    ]);
    function addDailyPlannning() {
        updateState({
            newPlan: (0, _react.autoCommand)({
                $autoArray: {
                    $push: [
                        {}
                    ]
                }
            }, 'content', 'dailyPlanning')
        });
        scrollToLastItem && setTimeout(scrollToLastItem, 0);
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledAddDailyPlanning, {
        variant: "contained",
        disabled: !thereIsAvaliableDays,
        className: "planning-rd-add-daily-planning",
        onClick: addDailyPlannning,
        children: [
            "+ ",
            translate(`plannind-rd-daily-planning-title`, {
                n: ''
            })
        ]
    });
};
//Discards time info
function getDateString(str = 'T') {
    switch(typeof str){
        case 'string':
            return str.split('T')[0];
        case 'object':
            return (0, _dateFns.format)(str, 'yyyy-MM-dd');
        default:
            return '';
    }
}
function addDailyPlannningStyles() {
    return {
        color: '#fff',
        background: '#2993ff',
        textTransform: 'none',
        '&:hover': {
            background: '#4e576e'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/dayjs":"kdp5L","external/date-fns":"kwxNe","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kdp5L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dayjs", ()=>(0, _dayjsDefault.default));
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _utc = require("dayjs/plugin/utc");
var _utcDefault = parcelHelpers.interopDefault(_utc);
var _timezone = require("dayjs/plugin/timezone");
var _timezoneDefault = parcelHelpers.interopDefault(_timezone);
(0, _dayjsDefault.default).extend((0, _utcDefault.default));
(0, _dayjsDefault.default).extend((0, _timezoneDefault.default));

},{"dayjs":"9FMDe","dayjs/plugin/utc":"hAxTa","dayjs/plugin/timezone":"8ZoC9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hAxTa":[function(require,module,exports,__globalThis) {
!function(t, i) {
    module.exports = i();
}(this, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

},{}],"8ZoC9":[function(require,module,exports,__globalThis) {
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});

},{}],"93LwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanificationAccordion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const StyledPlannificationAccordion = (0, _material.styled)((0, _material.Accordion))(plannificationAccordionStyles);
const PlanificationAccordion = ({ className, children, title, deleteButton, handleDelete })=>{
    const [expanded, setExpanded] = (0, _react.useState)(true);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledPlannificationAccordion, {
        className: className,
        expanded: expanded,
        onChange: ()=>setExpanded((prev)=>!prev),
        sx: {},
        disableGutters: true,
        elevation: 0,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AccordionSummary), {
                className: "accordion-summary",
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ArrowForwardIosSharpIcon), {
                    className: "icon"
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "title",
                    children: [
                        deleteButton && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "delete",
                            children: [
                                " ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.IconButton), {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleDelete();
                                    },
                                    children: [
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CancelIcon), {
                                            fontSize: 'small'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                            component: "span",
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AccordionDetails), {
                className: "accordion-details",
                children: children
            })
        ]
    });
};
function plannificationAccordionStyles() {
    return {
        backgroundColor: '#fff',
        '&::before': {
            display: 'none'
        },
        "& .accordion-summary": {
            flexDirection: 'row-reverse',
            padding: 0,
            gap: '16px',
            backgroundColor: 'rgba(0,0,0, 0.02)',
            color: 'rgba(0,0,30,1)',
            '& .MuiSvgIcon-root': {
                fontSize: 20,
                transition: 'transform 200ms linear 0s'
            },
            [`& .${(0, _material.accordionSummaryClasses).expandIconWrapper}.${(0, _material.accordionSummaryClasses).expanded}`]: {
                transform: 'none',
                'svg': {
                    transform: 'rotate(90deg)'
                }
            },
            [`& .${(0, _material.accordionSummaryClasses).expandIconWrapper}`]: {
                backgroundColor: 'rgba(165, 211, 243, 0.5)',
                minHeight: '48px',
                width: '48px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex'
            },
            "& .title": {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'space-between',
                width: '100%',
                "& .delete": {
                    position: 'absolute',
                    right: 0,
                    padding: '8px 5px',
                    cursor: 'pointer'
                },
                "& span": {
                    fontWeight: 'bold'
                }
            }
        },
        "& .accordion-details": {
            padding: 24
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5eYiH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>UnitPlan);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _inputField = require("components/common/InputField");
var _itemAccordion = require("components/planning/plan-rd/components/ItemAccordion");
var _material = require("external/material");
var _skills = require("./Skills");
var _context = require("teacher/context");
const skills = [
    'communicative',
    'ethical',
    'logicalThinking',
    'problemSolving',
    'scientific',
    'environmental',
    'personalDevelopment'
];
const StyledUnitPlan = (0, _material.styled)('div')(unitPlanStyles);
const UnitPlan = ()=>{
    const { newPlan, translate, updateState } = (0, _react.useContext)((0, _context.TeacherContext));
    const unitPlan = (0, _react.useMemo)(()=>newPlan.content ? newPlan.content.unitPlan : undefined, [
        newPlan.content
    ]);
    function handleValueChange(key, value) {
        updateState({
            newPlan: (0, _react.autoSet)(value, 'content', 'unitPlan', key)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledUnitPlan, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                children: translate('planning-rd-unit-planning')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputField.InputField), {
                label: translate(`planning-rd-skill-cycle`),
                value: unitPlan?.cycleSkill ?? '',
                onChange: (value)=>handleValueChange('cycleSkill', value)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inputField.InputField), {
                label: translate(`planning-rd-skill-grade`),
                value: unitPlan?.gradeSkill ?? '',
                onChange: (value)=>handleValueChange('gradeSkill', value)
            }),
            skills.map((skill)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemAccordion.ItemAccordion), {
                    title: translate(`planning-rd-${skill}-label`),
                    menuButton: false,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skills.Skills), {
                        skill: skill
                    })
                }, skill))
        ]
    });
};
function unitPlanStyles() {
    return {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        gap: '32px',
        marginTop: '32px',
        '& > h5': {
            fontWeight: 'bold',
            fontSize: '1.2rem',
            margin: 0
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","components/common/InputField":"2kAeC","components/planning/plan-rd/components/ItemAccordion":"14r8t","external/material":"6yEDE","./Skills":"dONuJ","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2kAeC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputField", ()=>InputField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _styles = require("./styles");
const InputField = ({ onChange, label, required, value, readonly })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            height: '80px',
            gap: '8px',
            flexDirection: 'column',
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    required && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            color: 'red'
                        },
                        children: "*"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        style: {
                            height: '60px'
                        },
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flex: 1,
                    display: 'flex'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    value: value,
                    readOnly: readonly,
                    type: "text",
                    onChange: (e)=>onChange(e.target.value),
                    style: {
                        ...(0, _styles.InputStyles),
                        backgroundColor: readonly ? 'rgba(0,0,0, 0.06)' : undefined,
                        border: readonly ? '1px solid rgba(0,0,0, 0.5)' : undefined
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","./styles":"02ekp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"02ekp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputStyles", ()=>InputStyles);
const InputStyles = {
    flexGrow: 1,
    height: '40px',
    fontSize: '12pt',
    paddingLeft: '8px'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"14r8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ItemAccordion", ()=>ItemAccordion);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
var _dotMenu = require("./DotMenu");
var _dotMenuDefault = parcelHelpers.interopDefault(_dotMenu);
const ItemAccordion = ({ children, title, menuButton, handleDelete, menuOptions, canDoActions, shouldShowMenu })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Accordion), {
        sx: {
            '&::before': {
                display: 'none'
            }
        },
        disableGutters: true,
        elevation: 0,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AccordionSummary), {
                sx: {
                    backgroundColor: 'rgba(165, 211, 243, 0.5)',
                    flexDirection: 'row-reverse'
                },
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ArrowForwardIosSharpIcon), {
                    sx: {
                        fontSize: 16,
                        transform: 'rotate(270deg)'
                    }
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px'
                    },
                    children: [
                        menuButton && shouldShowMenu && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                position: 'absolute',
                                right: 0,
                                padding: '8px 5px',
                                cursor: 'pointer',
                                marginRight: '4px'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dotMenuDefault.default), {
                                actions: {
                                    delete: handleDelete,
                                    edit: ()=>''
                                },
                                canDoActions: canDoActions,
                                options: menuOptions ?? []
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                            component: "span",
                            sx: {
                                fontWeight: 'bold',
                                color: 'rgba(0,0,30,1)',
                                marginLeft: '10px'
                            },
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AccordionDetails), {
                sx: {
                    padding: 0
                },
                children: children
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","./DotMenu":"dZZyv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dZZyv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const DotMenu = ({ actions, options, canDoActions })=>{
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (option)=>{
        setAnchorEl(null);
        const action = actions?.[option];
        if (option && action && canDoActions?.[option]) action(option);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                "aria-label": "opciones",
                style: {
                    padding: 0
                },
                onClick: (e)=>{
                    e.stopPropagation();
                    handleClick(e);
                },
                "aria-controls": open ? 'dot-menu' : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? 'true' : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MoreVertIcon), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Menu), {
                id: "dot-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: ()=>handleClose(),
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                children: options?.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                        disabled: canDoActions ? !canDoActions[option] : true,
                        onClick: (e)=>{
                            e.stopPropagation();
                            handleClose(option);
                        },
                        children: option
                    }, option))
            })
        ]
    });
};
exports.default = DotMenu;

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dONuJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Skills", ()=>Skills);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
var _skillField = require("./SkillField");
const StyledSkills = (0, _material.styled)('div')(skillsStyles);
const Skills = (props)=>{
    const { skill } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledSkills, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skillField.SkillField), {
                skill: skill,
                field: "conceptual"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skillField.SkillField), {
                skill: skill,
                field: "procedural"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skillField.SkillField), {
                skill: skill,
                field: "attitudinal"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skillField.SkillField), {
                skill: skill,
                field: "achievementIndicators"
            })
        ]
    });
};
function skillsStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'rgba(165, 211, 243, 0.1)',
        alignItems: 'center',
        padding: '16px',
        boxSizing: 'border-box',
        gap: '30px',
        marginBottom: '30px'
    };
}

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","./SkillField":"g0GfI","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g0GfI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkillField", ()=>SkillField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _textAreaField = require("components/common/TextAreaField");
var _context = require("teacher/context");
const SkillField = (props)=>{
    const { skill, field, className } = props;
    const { newPlan, translate, updateState } = (0, _react.useContext)((0, _context.TeacherContext));
    const unitPlan = (0, _react.useMemo)(()=>newPlan.content ? newPlan.content.unitPlan : undefined, [
        newPlan.content
    ]);
    const value = (0, _react.useMemo)(()=>unitPlan && unitPlan[skill] && unitPlan[skill][field] || '', [
        unitPlan
    ]);
    function handleValueChange(value) {
        updateState({
            newPlan: (0, _react.autoSet)(value, 'content', 'unitPlan', skill, field)
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAreaField.TextAreaField), {
        className: className,
        label: translate(`planning-rd-skill-${field}-label`),
        onChange: handleValueChange,
        value: value
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","components/common/TextAreaField":"5JQZD","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5JQZD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAreaField", ()=>TextAreaField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _stylesCss = require("./styles.css");
const TextAreaField = ({ className, onChange, label, labelStyles, textAreaStyles, required, value })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: className,
        style: {
            display: 'flex',
            justifyContent: 'center',
            minHeight: '80px',
            gap: '8px',
            width: '100%',
            flexDirection: 'column'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    required && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            color: 'red'
                        },
                        children: "*"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        style: {
                            height: '60px',
                            ...labelStyles
                        },
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    display: 'flex',
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                    placeholder: "Escriba aqu\xed...",
                    className: "textarea",
                    value: value,
                    rows: 5,
                    style: {
                        width: '100%',
                        resize: 'none',
                        padding: '20px',
                        minHeight: '40px',
                        ...textAreaStyles
                    },
                    onChange: (e)=>onChange(e.target.value)
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","./styles.css":"148DL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"148DL":[function() {},{}],"2eDM2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GeneralInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _context = require("teacher/context");
var _textAreaField = require("components/common/TextAreaField");
var _material = require("external/material");
var _generalInfoField = require("./GeneralInfoField");
var _generalInfoFieldDefault = parcelHelpers.interopDefault(_generalInfoField);
const StyledGeneralInfo = (0, _material.styled)('div')(generalInfoStyles);
const GeneralInfo = (props)=>{
    const { className } = props;
    const { profile, newPlan, myGrades, mySubjects } = (0, _react.useContext)((0, _context.TeacherContext));
    const grade = myGrades.find((grade)=>newPlan.grade == grade.id);
    const subject = mySubjects.find((subject)=>newPlan.subject == subject.id);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledGeneralInfo, {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "field-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "field-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                                id: "titulo",
                                required: true
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                                id: "docente",
                                readonlyValue: `${profile?.individual.last_name}, ${profile?.individual.first_name}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "field-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                                id: "asignatura",
                                readonlyValue: subject?.name ?? ''
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                                id: "grado",
                                readonlyValue: grade?.name ?? ''
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                                id: "section"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                                id: "estimatedTime"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "field-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                        id: "learningUnit"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                        id: "thematicAxis"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalInfoFieldDefault.default), {
                        id: "learningSituation",
                        Component: (0, _textAreaField.TextAreaField)
                    })
                ]
            })
        ]
    });
};
function generalInfoStyles() {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '30px',
        alignItems: 'center',
        '& > .field-group': {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: '30px'
        },
        '& .field-row': {
            display: 'flex',
            gap: '30px',
            width: '100%',
            flex: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","teacher/context":"5LKDx","components/common/TextAreaField":"5JQZD","external/material":"6yEDE","./GeneralInfoField":"jlux6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jlux6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GeneralInfoField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _context = require("teacher/context");
var _inputField = require("components/common/InputField");
const GeneralInfoField = (props)=>{
    const { id, Component = (0, _inputField.InputField), required, readonlyValue } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { newPlan, updateState, translate } = context;
    const updateContent = (value)=>{
        !readonlyValue && updateState({
            newPlan: {
                content: {
                    [id]: {
                        $set: value
                    }
                }
            }
        });
    };
    const value = (0, _react.useMemo)(()=>readonlyValue ? readonlyValue : newPlan.content ? newPlan.content[id] || '' : '', [
        id,
        newPlan.content,
        readonlyValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
        label: translate(`planning-rd-general-info-field-label-${id}`),
        onChange: updateContent,
        required: required,
        readonly: readonlyValue ? true : undefined,
        value: value
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","teacher/context":"5LKDx","components/common/InputField":"2kAeC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NHtO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Sidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _unitDuration = require("./UnitDuration");
var _unitDurationDefault = parcelHelpers.interopDefault(_unitDuration);
var _lessons = require("./Lessons");
var _lessonsDefault = parcelHelpers.interopDefault(_lessons);
var _resources = require("./Resources");
var _resourcesDefault = parcelHelpers.interopDefault(_resources);
var _selectGroup = require("./SelectGroup");
var _selectGroupDefault = parcelHelpers.interopDefault(_selectGroup);
const StyledSideBar = (0, _material.styled)('div')(sideBarStyles);
const Sidebar = (props)=>{
    const { className } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledSideBar, {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGroupDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unitDurationDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonsDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourcesDefault.default), {})
        ]
    });
};
function sideBarStyles() {
    return {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        gap: '26px',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: '20px',
        marginLeft: '20px',
        backgroundColor: '#fff',
        "& .date-picker": {
            width: '100%'
        },
        '& .side-bar-section': {
            paddingBottom: '20px',
            borderBottom: 'solid 1px #d8d8d8'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./UnitDuration":"78dZF","./Lessons":"62C0d","./Resources":"lo2rD","./SelectGroup":"bVT5Z","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"78dZF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDatePicker", ()=>StyledDatePicker);
parcelHelpers.export(exports, "default", ()=>UnitDuration);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _dateFns = require("external/date-fns");
var _dateFns1 = require("date-fns");
var _context = require("teacher/context");
Object.entries((0, _dateFns.locales)).forEach(([languages, locale])=>(0, _react.registerDatePickerLocale)(languages, locale));
const StyledDatePicker = (0, _material.styled)('div')(unitDurationStyles);
const UnitDuration = (props)=>{
    const { className } = props;
    const { newPlan: plan, updateState, translate, languageId } = (0, _react.useContext)((0, _context.TeacherContext));
    const updatePlan = (commands)=>updateState({
            newPlan: commands
        });
    const startDate = (0, _react.useMemo)(()=>(0, _dateFns.parseDate)(plan.start), [
        plan.start
    ]);
    const endDate = (0, _react.useMemo)(()=>(0, _dateFns.parseDate)(plan.finish), [
        plan.finish
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDatePicker, {
        className: (0, _material.clsx)("date-picker", className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "label",
                children: translate('planning-rd-unit-duration')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "components",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.DatePicker), {
                        customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.CustomDateInput), {}),
                        selected: startDate,
                        onChange: (date)=>{
                            const isoDate = (0, _dateFns1.formatISO)(date);
                            const updateDate = (0, _dateFns.isAfter)(endDate, date) ? {
                                start: {
                                    $set: isoDate
                                }
                            } : {
                                start: {
                                    $set: isoDate
                                },
                                finish: {
                                    $set: isoDate
                                }
                            };
                            updatePlan(updateDate);
                        },
                        minDate: new Date(),
                        maxDate: null,
                        locale: languageId,
                        popperPlacement: "auto-start"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "separator",
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.DatePicker), {
                        customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.CustomDateInput), {}),
                        selected: endDate,
                        onChange: (date)=>updatePlan({
                                finish: {
                                    $set: (0, _dateFns1.formatISO)(date)
                                }
                            }),
                        minDate: startDate,
                        maxDate: null,
                        locale: languageId,
                        popperPlacement: "auto-start"
                    })
                ]
            })
        ]
    });
};
function unitDurationStyles() {
    return {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        "& .label": {
            fontSize: '16px',
            color: '#4a4a4a',
            alignSelf: 'flex-start'
        },
        "& .components": {
            display: 'flex',
            gap: '1rem',
            justifyContent: 'flex-start',
            width: '100%',
            "& .separator": {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transform: 'scaleX(1.5)'
            },
            "& .date-input": {
                cursor: 'pointer',
                width: '110px',
                padding: '6px 0',
                textAlign: 'center',
                border: 'solid 1px #b8c1c7'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/date-fns":"kwxNe","date-fns":"btU8f","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"62C0d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Lessons);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _addLessons = require("components/add-lessons");
var _addLessonsDefault = parcelHelpers.interopDefault(_addLessons);
var _lesson = require("./Lesson");
var _lessonDefault = parcelHelpers.interopDefault(_lesson);
var _confirmDialog = require("components/confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
const StyledLessons = (0, _material.styled)('div')(lessonsStyles);
const Lessons = ()=>{
    const { newPlan, updateState, section, translate, navigate, match } = (0, _react.useContext)((0, _context.TeacherContext));
    const lessonItems = (0, _react.useMemo)(()=>newPlan.content?.lessons || [], [
        newPlan.content
    ]);
    const updatePlan = (commands)=>updateState({
            newPlan: commands
        });
    function deleteLesson(index, lesson) {
        (0, _confirmDialogDefault.default)({
            className: 'delete-field',
            translate: translate,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "message",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "question",
                        children: translate('confirm_delete_item')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: lesson.name
                    })
                ]
            }),
            onConfirm: ()=>{
                updatePlan({
                    content: {
                        lessons: {
                            $splice: [
                                [
                                    index,
                                    1
                                ]
                            ]
                        }
                    }
                });
            }
        });
    }
    function addLessonClick() {
        navigate({
            section: 'add-lessons',
            activeTab: 'catalogue'
        }, match.path, {
            preserveQuery: true
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledLessons, {
        className: "planrd-lessons",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                children: translate('lessons')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                onClick: addLessonClick,
                className: "add-lessons",
                children: "+"
            }),
            section == 'add-lessons' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addLessonsDefault.default), {
                activeTab: "catalogue"
            }) : null,
            lessonItems.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "planrd-content",
                children: lessonItems.map((lesson, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lessonDefault.default), {
                        onDeleteClick: ()=>deleteLesson(index, lesson),
                        id: lesson.id,
                        name: lesson.name
                    }, index))
            })
        ]
    });
};
function lessonsStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center',
        borderBottom: '1px solid #d8d8d8',
        '& .label': {
            alignSelf: 'flex-start',
            color: '#868c9c'
        },
        '& .add-lessons': {
            backgroundColor: '#f0f7ff',
            border: '1px solid #a5b9de',
            color: '#a5b9de',
            width: '100%'
        },
        '& .planrd-content': {
            width: '100%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","components/add-lessons":"l306l","./Lesson":"hRVN1","components/confirm-dialog":"hzSdJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRVN1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Lesson);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _utils = require("helpers/utils");
const StyledLesson = (0, _material.styled)('div')(lessonStyles);
const Lesson = (props)=>{
    const { id, name, onDeleteClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledLesson, {
        className: "planrd-lesson",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content",
                children: [
                    !(0, _utils.isUUID)(id) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "id",
                        children: id
                    }),
                    (0, _utils.isUUID)(id) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "id",
                        children: "Mi lecci\xf3n"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "name",
                        title: name,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "delete",
                    onClick: onDeleteClick,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FAIcon), {
                        icon: "trash"
                    })
                })
            })
        ]
    });
};
function lessonStyles() {
    return {
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        marginTop: 15,
        borderBottom: 'solid 1px #e2ecf2',
        '&:last-child': {
            borderBottom: 'none'
        },
        '& .content': {
            cursor: 'default',
            flexGrow: 1,
            color: '#4e576e',
            overflowX: 'hidden',
            overflowY: 'auto',
            padding: 0,
            minHeight: '40px',
            maxHeight: '150px',
            '& > .id': {
                fontWeight: 'bold'
            },
            '& > .name': {
                color: '#838999',
                fontSize: '10.5pt',
                wordWrap: 'breakWord'
            }
        },
        '& .actions': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '10px',
            '& .delete': {
                cursor: 'pointer',
                color: '#dd3636',
                backgroundColor: '#ededed',
                borderRadius: '50%',
                padding: '8px 9px',
                '&:hover': {
                    transform: 'scale(1.10)'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lo2rD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Resources);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _resource = require("./Resource");
var _resourceDefault = parcelHelpers.interopDefault(_resource);
var _confirmDialog = require("components/confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _addLinkResource = require("components/add-link-resource");
var _addLinkResourceDefault = parcelHelpers.interopDefault(_addLinkResource);
const StyledResources = (0, _material.styled)('div')(resourcesStyles);
const Resources = ()=>{
    const { newPlan, updateState, section, translate, navigate, match } = (0, _react.useContext)((0, _context.TeacherContext));
    const resourceItems = (0, _react.useMemo)(()=>newPlan.content?.resources || [], [
        newPlan.content
    ]);
    const updatePlan = (commands)=>updateState({
            newPlan: commands
        });
    function deleteResource(index, resource) {
        (0, _confirmDialogDefault.default)({
            className: 'delete-field',
            translate: translate,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "message",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "question",
                        children: translate('confirm_delete_item')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "title",
                        children: resource.title
                    })
                ]
            }),
            onConfirm: ()=>{
                updatePlan({
                    content: {
                        resources: {
                            $splice: [
                                [
                                    index,
                                    1
                                ]
                            ]
                        }
                    }
                });
            }
        });
    }
    function addResourceClick() {
        navigate({
            section: 'add-link-resource'
        }, match.path, {
            preserveQuery: true
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledResources, {
        className: "planrd-resources",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                children: translate('resources')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                onClick: addResourceClick,
                className: "add-resource",
                children: "+"
            }),
            section == 'add-link-resource' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addLinkResourceDefault.default), {}) : null,
            resourceItems.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "planrd-content",
                children: resourceItems.map((resource, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourceDefault.default), {
                        onDeleteClick: ()=>deleteResource(index, resource),
                        title: resource.title,
                        href: resource.href
                    }, index))
            })
        ]
    });
};
function resourcesStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        alignItems: 'center',
        borderBottom: '1px solid #d8d8d8',
        '& .label': {
            alignSelf: 'flex-start',
            color: '#868c9c'
        },
        '& .add-resource': {
            backgroundColor: '#f0f7ff',
            border: '1px solid #a5b9de',
            color: '#a5b9de',
            width: '100%'
        },
        '& .planrd-content': {
            width: '100%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","./Resource":"hMnms","components/confirm-dialog":"hzSdJ","components/add-link-resource":"f8li1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMnms":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Resource);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const StyledResource = (0, _material.styled)('div')(resourceStyles);
const Resource = (props)=>{
    const { title, href, onDeleteClick } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledResource, {
        className: "planrd-resource link",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "id",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        className: "link",
                        href: href,
                        target: "_blank",
                        title: href,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "link",
                            children: href
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "actions",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "delete",
                    onClick: onDeleteClick,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FAIcon), {
                        icon: "trash"
                    })
                })
            })
        ]
    });
};
function resourceStyles() {
    return {
        display: 'flex',
        justifyContent: 'flex-start',
        width: '100%',
        marginTop: 15,
        borderBottom: 'solid 1px #e2ecf2',
        '&:last-child': {
            borderBottom: 'none'
        },
        '& .content': {
            cursor: 'default',
            flexGrow: 1,
            color: '#4e576e',
            overflowX: 'hidden',
            overflowY: 'auto',
            padding: 0,
            minHeight: '40px',
            maxHeight: '150px',
            "& .id": {
                fontWeight: 'bold'
            },
            "& .link": {
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        },
        '& .actions': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            paddingLeft: '10px',
            '& .delete': {
                cursor: 'pointer',
                color: '#dd3636',
                backgroundColor: '#ededed',
                borderRadius: '50%',
                padding: '8px 9px',
                '&:hover': {
                    transform: 'scale(1.10)'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bVT5Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _selectField = require("components/common/SelectField");
const StyledSelectGroup = (0, _material.styled)((0, _selectField.SelectField))(selectGroupStyles);
const SelectGroup = (props)=>{
    const { className } = props;
    const { newPlan, updateState, groups, translate } = (0, _react.useContext)((0, _context.TeacherContext));
    const updatePlan = (commands)=>updateState({
            newPlan: commands
        });
    const groupList = (0, _react.useMemo)(()=>(groups || []).map((group)=>({
                ...group,
                label: group.name,
                value: group.id
            })), [
        groups
    ]);
    const group = (0, _react.useMemo)(()=>groupList.find((group)=>group.value === newPlan.clique), [
        groupList,
        newPlan.clique
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSelectGroup, {
        className: className,
        label: translate('group-label'),
        onChange: (option)=>{
            updatePlan({
                clique: {
                    $set: option.value
                },
                subject: {
                    $set: option.course.substring(0, 2)
                },
                grade: {
                    $set: option.course.substring(4)
                }
            });
        },
        options: groupList,
        value: group
    });
};
function selectGroupStyles() {
    return {};
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","components/common/SelectField":"kz9TJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kz9TJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectField", ()=>SelectField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _context = require("teacher/context");
const SelectField = ({ options, onChange, label, selectStyles, value, className, isMulti })=>{
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: className,
        style: {
            display: 'flex',
            justifyContent: 'center',
            gap: '8px',
            flexDirection: 'column',
            width: '100%'
        },
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    style: {
                        height: '60px'
                    },
                    children: label
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Select), {
                    styles: selectStyles,
                    classNamePrefix: "select",
                    formatOptionLabel: ({ label })=>label,
                    isMulti: isMulti,
                    isSearchable: false,
                    isClearable: false,
                    escapeClearsValue: true,
                    getOptionValue: ({ value })=>value,
                    placeholder: context.translate("pick_one"),
                    value: value,
                    onChange: onChange,
                    options: options
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4gNnE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DailyPlans);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _dailyPlanning = require("./DailyPlanning");
const StyledDailyPlanning = (0, _material.styled)('div')(dailyPlanningStyles);
const DailyPlans = (props)=>{
    const { lastItemRef } = props;
    const { translate, newPlan } = (0, _react.useContext)((0, _context.TeacherContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDailyPlanning, {
        children: newPlan.content?.dailyPlanning?.map((_, index, arr)=>{
            const isLast = index === arr.length - 1;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dailyPlanning.DailyPlanning), {
                refu: isLast ? lastItemRef : null,
                id: index,
                title: translate(`plannind-rd-daily-planning-title`, {
                    n: index + 1
                })
            }, index);
        })
    });
};
function dailyPlanningStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        boxSizing: 'border-box',
        padding: 0
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","./DailyPlanning":"2scEF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2scEF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DailyPlanning", ()=>DailyPlanning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _planificationAcordion = require("components/planning/plan-rd/components/PlanificationAcordion");
var _planificationAcordionDefault = parcelHelpers.interopDefault(_planificationAcordion);
var _context = require("teacher/context");
var _dailyTimeInfo = require("./DailyTimeInfo");
var _dailyTimeInfoDefault = parcelHelpers.interopDefault(_dailyTimeInfo);
var _dailyIntent = require("./DailyIntent");
var _dailyIntentDefault = parcelHelpers.interopDefault(_dailyIntent);
var _dayMoments = require("./DayMoments");
const StyledDailyPlanning = (0, _material.styled)((0, _planificationAcordionDefault.default))(dailyPlanninStyles);
const DailyPlanning = (props)=>{
    const { title, id, refu } = props;
    const { updateState, newPlan } = (0, _react.useContext)((0, _context.TeacherContext));
    function deleteDailyPlan() {
        updateState({
            newPlan: {
                content: {
                    dailyPlanning: {
                        $splice: [
                            [
                                id,
                                1
                            ]
                        ]
                    }
                }
            }
        });
    }
    const dailyPlan = (0, _react.useMemo)(()=>newPlan.content?.dailyPlanning[id], [
        newPlan,
        id
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDailyPlanning, {
        title: title,
        deleteButton: true,
        handleDelete: deleteDailyPlan,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: refu,
            className: "daily-planning",
            children: dailyPlan && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "time-info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "filler"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dailyTimeInfoDefault.default), {
                                id: id,
                                dailyPlan: dailyPlan
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dailyIntentDefault.default), {
                        id: id
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dayMoments.DayMoments), {
                        id: id
                    })
                ]
            })
        })
    });
};
function dailyPlanninStyles() {
    return {
        '& .daily-planning': {
            display: 'flex',
            width: '100%',
            padding: '16px',
            boxSizing: 'border-box',
            flexDirection: 'column',
            gap: '16px',
            '& .filler': {
                flexGrow: 1
            },
            '& .time-info': {
                display: 'flex',
                justifyContent: 'flex-start',
                width: '100%',
                height: '60px',
                alignItems: 'center',
                gap: '20px'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/planning/plan-rd/components/PlanificationAcordion":"93LwZ","teacher/context":"5LKDx","./DailyTimeInfo":"9tScG","./DailyIntent":"9RQaz","./DayMoments":"7U4GF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9tScG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DailyTimeInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _dateFns = require("external/date-fns");
var _timeRangePicker = require("components/planning/plan-rd/components/TimeRangePicker");
var _context = require("teacher/context");
const StyledDailyTimeInfo = (0, _material.styled)('div')(dailyTimeInfoStyles);
const DailyTimeInfo = (props)=>{
    const { id } = props;
    const { updateState, newPlan, translate, languageId } = (0, _react.useContext)((0, _context.TeacherContext));
    const { maxDate, minDate, dailyPlan, unavailableDates } = (0, _react.useMemo)(()=>{
        const maxDate = (0, _dateFns.parseDate)(newPlan.finish ?? '');
        const minDate = (0, _dateFns.parseDate)(newPlan.start ?? '');
        const dailyPlans = newPlan.content.dailyPlanning || [];
        const dailyPlan = id >= 0 && id < dailyPlans.length ? dailyPlans[id] : {
            notFound: true
        };
        const unavailableDates = dailyPlans.map((d)=>(0, _dateFns.parseDate)(d.date)) ?? [];
        return {
            maxDate,
            minDate,
            dailyPlan,
            unavailableDates
        };
    }, [
        newPlan.start,
        newPlan.finish,
        newPlan.content.dailyPlanning,
        id
    ]);
    const date = (0, _react.useMemo)(()=>dailyPlan.date ? (0, _dateFns.parseDate)(dailyPlan.date) : undefined, [
        dailyPlan.date
    ]);
    function updateDailyPlan(commands) {
        updateState({
            newPlan: {
                content: {
                    dailyPlanning: {
                        [id]: commands
                    }
                }
            }
        });
    }
    function updateDailyPlanDate(date) {
        updateDailyPlan({
            date: {
                $set: (0, _dateFns.formatDate)(date, 'yyyy-MM-dd', languageId)
            }
        });
    }
    function updateDailyPlanTime(timeProperty, value) {
        updateDailyPlan({
            [`${timeProperty}Time`]: {
                $set: value.toISOString()
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDailyTimeInfo, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _material.clsx)('info', 'date'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "label",
                        children: translate('planning-rd-assigned-day')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.DatePicker), {
                        customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.CustomDateInput), {}),
                        selected: date,
                        onChange: updateDailyPlanDate,
                        minDate: minDate,
                        maxDate: maxDate,
                        locale: languageId,
                        popperPlacement: "auto-start",
                        excludeDates: unavailableDates
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _material.clsx)('info', 'time'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeRangePicker.TimeRangePicker), {
                    label: translate('planning-rd-hour'),
                    minTime: {
                        value: (0, _dateFns.parseISO)(dailyPlan.startTime),
                        onChange: (time)=>time && updateDailyPlanTime('start', time)
                    },
                    maxTime: {
                        value: (0, _dateFns.parseISO)(dailyPlan.finishTime),
                        onChange: (time)=>time && updateDailyPlanTime('finish', time)
                    }
                })
            })
        ]
    });
};
function dailyTimeInfoStyles() {
    const dateInput = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        cursor: 'pointer',
        width: '110px',
        padding: 0,
        textAlign: 'center',
        border: 'solid 1px #b8c1c7',
        height: '28px'
    };
    return {
        display: 'flex',
        gap: 20,
        "& .label": {
            color: 'rgba(0, 0, 0, 0.87)'
        },
        '& > .info': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '&.date': {
                flexShrink: 0,
                width: 200,
                gap: 8,
                height: '100%',
                boxSizing: 'border-box',
                "& .date-input": dateInput
            },
            '&.time': {
                flexShrink: 0,
                "& .timerange-picker .picker": dateInput
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/date-fns":"kwxNe","components/planning/plan-rd/components/TimeRangePicker":"anXGD","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"anXGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeRangePicker", ()=>TimeRangePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
var _mobileTimePicker = require("./MobileTimePicker");
var _mobileTimePickerDefault = parcelHelpers.interopDefault(_mobileTimePicker);
const StyledTimeRangePicker = (0, _material.styled)('div')(timeRangePickerStyles);
const TimeRangePicker = (props)=>{
    const { label, className, minTime, maxTime } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledTimeRangePicker, {
        className: (0, _material.clsx)('timerange-picker', className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "picker",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileTimePickerDefault.default), {
                            ...minTime
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "separator",
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "picker",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileTimePickerDefault.default), {
                            ...maxTime
                        })
                    })
                ]
            })
        ]
    });
};
function timeRangePickerStyles() {
    return {
        display: 'flex',
        flexDirection: 'column',
        '& .label': {
            fontSize: '16px',
            color: '#4a4a4a',
            alignSelf: 'flex-start'
        },
        '& .separator': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'scaleX(1.5)'
        },
        '& .picker': {
            display: 'flex'
        },
        '& .container': {
            display: 'flex',
            gap: '1rem',
            justifyContent: 'space-between',
            width: '100%',
            marginTop: 5
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","./MobileTimePicker":"jT3p0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jT3p0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MobileTimePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
var _dayjs = require("external/dayjs");
const StyledMobileTimePicker = (0, _material.styled)((0, _material.MobileTimePicker))(mobileTimePickerStyles);
const MobileTimePicker = (props)=>{
    const { value, minTime, maxTime, onChange, onAccept } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledMobileTimePicker, {
        value: (0, _dayjs.dayjs)(value),
        minTime: minTime ? (0, _dayjs.dayjs)(minTime) : undefined,
        maxTime: maxTime ? (0, _dayjs.dayjs)(maxTime) : undefined,
        onChange: onChange,
        onAccept: onAccept
    });
};
function mobileTimePickerStyles() {
    return {
        width: '131px',
        height: '32px',
        border: 'none',
        backgroundColor: 'transparent',
        '& .MuiPickersInputBase-sectionsContainer': {
            padding: 8
        },
        '& .MuiOutlinedInput-root': {
            border: 'none',
            outline: 'none',
            padding: 0
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            outline: 'none'
        },
        '& .MuiIconButton-root': {
            padding: '0 8px 0 0'
        },
        padding: 0,
        '& .MuiInputBase-input': {
            height: '32px',
            padding: 0,
            textAlign: 'center',
            fontSize: '16px',
            color: '#000'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","external/dayjs":"kdp5L","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9RQaz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DailyIntent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _textAreaField = require("components/common/TextAreaField");
var _context = require("teacher/context");
const StyledDailyIntent = (0, _material.styled)('div')(dailyIntentStyles);
const DailyIntent = (props)=>{
    const { id } = props;
    const { translate, updateState, newPlan } = (0, _react.useContext)((0, _context.TeacherContext));
    const dailyPlan = (0, _react.useMemo)(()=>{
        const dailyPlans = newPlan.content.dailyPlanning;
        const dailyPlan = id >= 0 && id < dailyPlans.length ? dailyPlans[id] : {
            intent: ''
        };
        return dailyPlan;
    }, [
        newPlan.content.dailyPlanning,
        id
    ]);
    function updateDailyIntent(intent) {
        updateState({
            newPlan: {
                content: {
                    dailyPlanning: {
                        [id]: {
                            intent: {
                                $set: intent
                            }
                        }
                    }
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDailyIntent, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "label",
                children: translate('planning-rd-daily-intent')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAreaField.TextAreaField), {
                    label: '',
                    value: dailyPlan.intent,
                    textAreaStyles: {
                        height: '60px'
                    },
                    onChange: updateDailyIntent
                })
            })
        ]
    });
};
function dailyIntentStyles() {
    return {
        marginTop: 10,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        '& > .label': {},
        '& > .input': {}
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/common/TextAreaField":"5JQZD","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7U4GF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayMoments", ()=>DayMoments);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _crossAccordion = require("components/common/CrossAccordion");
var _crossAccordionDefault = parcelHelpers.interopDefault(_crossAccordion);
var _context = require("teacher/context");
var _dayMoment = require("./DayMoment");
var _dayMomentDefault = parcelHelpers.interopDefault(_dayMoment);
const StyledDayMoments = (0, _material.styled)('div')(dayMomentsStyles);
const DayMoments = (props)=>{
    const { id } = props;
    const { translate } = (0, _react.useContext)((0, _context.TeacherContext));
    const moments = (0, _react.useMemo)(()=>(0, _dayMoment.MOMENT).map((moment)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossAccordionDefault.default), {
                title: translate(`planning-rd-${moment}`),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dayMomentDefault.default), {
                    id: id,
                    moment: moment
                })
            }, moment)), [
        id,
        translate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDayMoments, {
        className: "day-moments",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _material.clsx)('header', 'label'),
                children: translate('day-moments')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "moments",
                children: moments
            })
        ]
    });
};
function dayMomentsStyles() {
    const vflexGap = (gap, overrides = {})=>({
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: `${gap}px`,
            marginBottom: `${30}px`,
            justifyContent: 'center',
            ...overrides
        });
    return {
        padding: 0,
        '& .label': {
            margin: 0,
            marginTop: 15,
            marginBottom: 10,
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            fontSize: '1rem',
            lineHeight: '1.5',
            letterSpacing: '0.00938em',
            fontweight: '700'
        },
        '&.day-moments': {
            ...vflexGap(10),
            '& > .moments': vflexGap(20)
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/common/CrossAccordion":"5HimG","teacher/context":"5LKDx","./DayMoment":"bjmf6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5HimG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CrossAccordion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _crossIconToggleButton = require("components/common/CrossIconToggleButton");
var _crossIconToggleButtonDefault = parcelHelpers.interopDefault(_crossIconToggleButton);
const StyledCrossAccordion = (0, _material.styled)((0, _material.Accordion))(crossAccordionStyles);
const CrossAccordion = (props)=>{
    const { title, children, expandedByDefault = false } = props;
    const [expanded, setExpanded] = (0, _react.useState)(expandedByDefault);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCrossAccordion, {
        expanded: expanded,
        onChange: ()=>setExpanded((prev)=>!prev),
        sx: {},
        disableGutters: true,
        elevation: 0,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AccordionSummary), {
                expandIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossIconToggleButtonDefault.default), {
                    boxSize: 44,
                    expanded: expanded,
                    onChange: setExpanded
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Typography), {
                    component: "span",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AccordionDetails), {
                children: children
            })
        ]
    });
};
function crossAccordionStyles() {
    return {
        '&::before': {
            display: 'none'
        },
        '& .MuiAccordionSummary-root': {
            backgroundColor: 'rgba(165, 211, 243, 0.5)',
            '& span': {
                fontWeight: 'bold',
                color: 'rgba(0,0,30,1)'
            }
        },
        '& .MuiAccordionDetails-root': {
            padding: 0
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/common/CrossIconToggleButton":"k8OrC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k8OrC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CrossIconToggleButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const StyledCrossIconToggleButton = (0, _material.styleAndCapture)('div', 'size')(crossIconToggleButtonStyles);
const CrossIconToggleButton = (props)=>{
    const { boxSize = 32, expanded = false, onChange, className, strokeWidth = 2 } = props;
    const [value, setExpanded] = (0, _react.useState)(expanded);
    (0, _react.useEffect)(()=>{
        if (expanded !== value) setExpanded(expanded);
    }, [
        expanded
    ]);
    function handleClick() {
        const newValue = !value;
        setExpanded(newValue);
        onChange && setTimeout(()=>onChange(newValue), 0);
    }
    const [viewBox, low, high, size] = (0, _react.useMemo)(()=>{
        const size = Math.floor(boxSize / 2);
        const viewBox = `0 0 ${boxSize} ${boxSize}`;
        const low = Math.floor(size / 2);
        const high = low + size;
        return [
            viewBox,
            low,
            high,
            size
        ];
    }, [
        boxSize
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCrossIconToggleButton, {
        className: (0, _material.clsx)('cross-icon-toggle-button', className),
        onClick: handleClick,
        size: size,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: viewBox,
            fill: "none",
            stroke: "currentColor",
            strokeWidth: strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                    x1: low,
                    y1: size,
                    x2: high,
                    y2: size
                }),
                !value && /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                    x1: size,
                    y1: low,
                    x2: size,
                    y2: high
                })
            ]
        })
    });
};
function crossIconToggleButtonStyles(props) {
    const { size } = props;
    return {
        cursor: 'pointer',
        '& > svg': {
            width: size,
            height: size
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bjmf6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MOMENT", ()=>MOMENT);
parcelHelpers.export(exports, "PHASE", ()=>PHASE);
parcelHelpers.export(exports, "default", ()=>DayMoment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _textAreaField = require("components/common/TextAreaField");
var _context = require("teacher/context");
var _strategyDropdown = require("./StrategyDropdown");
var _strategyDropdownDefault = parcelHelpers.interopDefault(_strategyDropdown);
const MOMENT = [
    'start',
    'development',
    'end'
];
const PHASE = [
    'activities',
    'evidence',
    'organization',
    'resources',
    'metacognition',
    'instruments'
];
const StyledDayMoment = (0, _material.styled)('div')(dayMomentStyles);
const DayMoment = (props)=>{
    const { id, moment, className } = props;
    const { translate, updateState, newPlan } = (0, _react.useContext)((0, _context.TeacherContext));
    const dailyPlan = (0, _react.useMemo)(()=>{
        const dailyPlans = newPlan.content.dailyPlanning;
        const dailyPlan = dailyPlans[id];
        return dailyPlan;
    }, [
        newPlan.content.dailyPlanning,
        id
    ]);
    const dailyMoment = (0, _react.useMemo)(()=>dailyPlan[moment] || false, [
        dailyPlan,
        moment
    ]);
    function editPhase(phase, value) {
        updateState({
            newPlan: {
                content: {
                    dailyPlanning: {
                        [id]: (0, _react.autoSet)(value, moment, phase)
                    }
                }
            }
        });
    }
    const phases = (0, _react.useMemo)(()=>PHASE.map((phase)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAreaField.TextAreaField), {
                label: translate(`planning-rd-phase-${phase}`).toUpperCase(),
                value: dailyMoment[phase],
                labelStyles: {
                    fontWeight: 'bold'
                },
                textAreaStyles: {
                    height: '190px'
                },
                onChange: (value)=>editPhase(phase, value)
            }, phase)), [
        id,
        moment,
        translate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDayMoment, {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _strategyDropdownDefault.default), {
                id: id,
                moment: moment
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAreaField.TextAreaField), {
                className: "description-text",
                label: '',
                value: dailyMoment.description,
                textAreaStyles: {
                    height: '70px'
                },
                onChange: (value)=>editPhase('description', value)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "phases-grid",
                children: phases
            })
        ]
    });
};
function dayMomentStyles() {
    return {
        display: 'flex',
        padding: 24,
        flexDirection: 'column',
        backgroundColor: 'rgba(165, 211, 243, 0.2)',
        '& > .description-text': {
            marginBottom: 25
        },
        '& .phases-grid': {
            width: '100%',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gridTemplateRows: '1fr 1fr',
            rowGap: '40px',
            columnGap: '40px',
            height: '100%',
            boxSizing: 'border-box'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","components/common/TextAreaField":"5JQZD","teacher/context":"5LKDx","./StrategyDropdown":"hluFO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hluFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StrategyDropdown", ()=>StrategyDropdown);
parcelHelpers.export(exports, "default", ()=>StrategyDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _lodash = require("external/lodash");
var _selectField = require("components/common/SelectField");
var _context = require("teacher/context");
const StyledStrategyDropdown = (0, _material.styled)('div')(strategyDropdownStyles);
const dailyStrategiesPrefix = 'planning-rd-daily-strategy-';
const StrategyDropdown = (props)=>{
    const { id, moment } = props;
    const { newPlan, translate, updateState, translations } = (0, _react.useContext)((0, _context.TeacherContext));
    const dailyPlan = (0, _react.useMemo)(()=>{
        const dailyPlans = newPlan.content.dailyPlanning;
        const dailyPlan = dailyPlans[id];
        return dailyPlan;
    }, [
        newPlan.content.dailyPlanning,
        id
    ]);
    const dailyMoment = (0, _react.useMemo)(()=>dailyPlan[moment] || false, [
        dailyPlan,
        moment
    ]);
    function addStrategy(strategy) {
        updateState({
            newPlan: {
                content: {
                    dailyPlanning: {
                        [id]: (0, _react.autoCommand)({
                            $autoArray: {
                                $push: [
                                    strategy
                                ]
                            }
                        }, moment, 'strategies')
                    }
                }
            }
        });
    }
    function removeStrategy(strategy) {
        const strategyIndex = dailyMoment.strategies.findIndex((s)=>s.value == strategy.value);
        if (strategyIndex < 0) return;
        updateState({
            newPlan: {
                content: {
                    dailyPlanning: {
                        [id]: {
                            [moment]: {
                                strategies: {
                                    $splice: [
                                        [
                                            strategyIndex,
                                            1
                                        ]
                                    ]
                                }
                            }
                        }
                    }
                }
            }
        });
    }
    const strategies = (0, _react.useMemo)(()=>{
        return (0, _lodash.orderBy)(Object.keys(translations).filter((key)=>key.startsWith(dailyStrategiesPrefix)).map((s)=>{
            const value = parseInt(s.substring(dailyStrategiesPrefix.length));
            const label = translate(s);
            return {
                value,
                label
            };
        }), [
            'value'
        ]);
    }, [
        translations
    ]);
    function handleStrategyChange(_, meta) {
        switch(meta.action){
            case 'select-option':
                return addStrategy(meta.option);
            case 'remove-value':
                return removeStrategy(meta.removedValue);
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledStrategyDropdown, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectField.SelectField), {
            label: translate('strategy'),
            value: dailyMoment.strategies,
            isMulti: true,
            options: strategies,
            onChange: handleStrategyChange
        })
    });
};
function strategyDropdownStyles() {
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        marginBottom: '30px',
        justifyContent: 'center'
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/lodash":"5bCAQ","components/common/SelectField":"kz9TJ","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"liD0u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Templates);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _confirmDialog = require("../../confirm-dialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _post = require("../../../context/post");
var _reactRouterDom = require("react-router-dom");
var _context = require("../../../context");
var _templatesStyl = require("./templates.styl");
function Templates() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translate, planTemplates } = context;
            const deleteDialog = (id, title)=>{
                return ()=>(0, _confirmDialogDefault.default)({
                        className: 'delete-template',
                        translate: translate,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "message",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "question",
                                    children: translate('confirm_delete_item')
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title",
                                    children: title
                                })
                            ]
                        }),
                        onConfirm: async ()=>{
                            await (0, _post.deletePlanTemplate)(id);
                            context.setState({
                                templateUpdates: context.templateUpdates + 1
                            });
                        }
                    });
            };
            const templates = planTemplates.filter(({ label })=>[
                    'default'
                ].indexOf(label) < 0).map((template)=>{
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "template",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "name",
                            children: template.label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                display: "flex",
                                flexGrow: 1
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "delete-template",
                            onClick: deleteDialog(template.value, template.label),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                id: "delete_label"
                            })
                        })
                    ]
                }, template.value);
            });
            const backPath = context.link({
                section: undefined
            }, context.match.path, {
                preserveQuery: true
            });
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "templates",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "head",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                className: "back",
                                to: backPath
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "templates_label"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "title",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                    id: "title_label"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "templates-wrapper",
                                children: templates
                            })
                        ]
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","../../confirm-dialog":"hzSdJ","../../../context/post":"8rmpk","react-router-dom":"3uzXR","../../../context":"iUP37","./templates.styl":"11y5D","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"11y5D":[function() {},{}],"2M3SU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Preview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _iconButton = require("@mui/material/IconButton");
var _iconButtonDefault = parcelHelpers.interopDefault(_iconButton);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("../../../context");
var _plan = require("./plan");
var _planDefault = parcelHelpers.interopDefault(_plan);
var _planningFilenameCjs = require("components/standards-selector/domain/planning-filename.cjs");
var _plan1 = require("../pdf/plan");
var _planDefault1 = parcelHelpers.interopDefault(_plan1);
var _renderer = require("@react-pdf/renderer");
var _indexStyl = require("./index.styl");
function Preview() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translate } = context;
            const { project } = context.profile.institution;
            const plan = (0, _plan1.parseContext)(context, context.newPlan);
            const filename = (0, _planningFilenameCjs.planningFilename)([
                context.translate('planning'),
                plan.author.name,
                plan.author.lastName,
                plan.title
            ]);
            const headerTitle = `${translate(`${project}_project_title`)} - ${translate("planning_title")}`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "planning-preview",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "preview-topbar",
                        children: [
                            plan.id && plan.subject && plan.grade && plan.group && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _planDefault1.default), {
                                className: "print-pdf",
                                fileName: filename,
                                headerTitle: headerTitle,
                                plan: plan,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: translate('save-pdf')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faFilePdf)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    flexGrow: 1
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _iconButtonDefault.default), {
                                style: {
                                    padding: 0
                                },
                                onClick: ()=>{
                                    context.navigate({
                                        view: context.newPlanFrom
                                    }, '/:languageId/:role/:page/:view', {
                                        query: context.newPlanFromQuery
                                    });
                                },
                                size: "large",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {})
                            })
                        ]
                    }),
                    false,
                    //  <Fade in={plan.id != undefined}>
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "preview",
                        children: plan.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planDefault.default), {
                            ...plan
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","@mui/material/Fade":"8DwqP","@mui/icons-material/Cancel":"lMa52","@mui/material/IconButton":"bXjnZ","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","../../../context":"iUP37","./plan":"7b2Xn","components/standards-selector/domain/planning-filename.cjs":"9iiNb","../pdf/plan":"h2quG","@react-pdf/renderer":"3NU82","./index.styl":"cjMlE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7b2Xn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Plan);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../../context");
var _standards = require("./standards");
var _standardsDefault = parcelHelpers.interopDefault(_standards);
var _items = require("./items");
var _itemsDefault = parcelHelpers.interopDefault(_items);
var _url = require("helpers/url");
function Plan(props) {
    const format = (date)=>(0, _momentDefault.default)(date).format('MM/DD/YYYY');
    const { content, items } = props;
    const { lessons, standards, resources } = content;
    const start = format(props.start);
    const end = format(props.finish);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translate, profile, subjects, grades } = context;
            const { institution, individual } = profile;
            const subject = subjects.find((subject)=>subject.id == props.subject);
            const grade = grades.find((grade)=>grade.id == props.grade);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "plan",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "plan-school info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "school",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "school"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: institution.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "teacher",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "teacher"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: `${individual.last_name}, ${individual.first_name}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "details title",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "details-title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "plan-date info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "assigned-date"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    start == end && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: `${start}`
                                    }),
                                    start != end && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: `${start} - ${end}`
                                    })
                                ]
                            }),
                            grade && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grade",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "grade"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: grade.name
                                    })
                                ]
                            }),
                            subject && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "subject",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "subject"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: subject.name
                                    })
                                ]
                            })
                        ]
                    }),
                    props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-title info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "content-title"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: props.title
                                })
                            ]
                        })
                    }),
                    props.unit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-unit info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "unit"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: props.unit
                                })
                            ]
                        })
                    }),
                    lessons && lessons.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-lessons info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "lessons_label"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: lessons.map((lesson)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "lesson",
                                            children: `${lesson.id}: ${lesson.name}`
                                        }, lesson.id))
                                })
                            ]
                        })
                    }),
                    resources && resources.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-resources info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        context.translate("digital-resources"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: resources.map((resource, id)=>{
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "resource",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                ...(0, _url.viewerGuard)({
                                                    href: resource.href,
                                                    target: " _blank"
                                                }),
                                                children: [
                                                    resource.title,
                                                    ": ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: resource.href
                                                    })
                                                ]
                                            })
                                        }, id);
                                    })
                                })
                            ]
                        })
                    }),
                    standards && standards.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsDefault.default), {
                        standards: standards
                    }),
                    items && items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemsDefault.default), {
                        items: items
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","../../../context":"iUP37","./standards":"lRZc5","./items":"jsXPk","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lRZc5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Standards);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../../context");
var _planningPdfCjs = require("components/standards-selector/domain/planning-pdf.cjs");
function Indicator({ code, description }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "indicator",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "indicator-code",
                children: code
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "indicator-name",
                children: description
            })
        ]
    });
}
function Expectation({ name, description, indicators }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "expectation",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "expectation-title",
                children: name || description
            }),
            indicators.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "indicators",
                children: indicators.map((indicator)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Indicator, {
                        ...indicator
                    }, indicator.id))
            })
        ]
    });
}
function Standard({ name, expectations }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "standard",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                className: "standard-title",
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "expectations",
                children: expectations.map((expectation)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Expectation, {
                        ...expectation
                    }, expectation.id))
            })
        ]
    });
}
function Standards({ standards }) {
    const context = (0, _react.useContext)((0, _context.Context));
    const groups = (0, _planningPdfCjs.groupPlanningPdfStandards)(standards, context.teacherExpectations, context.teacherStandards);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.React).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "standards title",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                    id: "planning-pdf-standards-title"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "standards",
                children: groups.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "edition-group",
                        style: {
                            marginBottom: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "edition-heading",
                                style: {
                                    fontWeight: 'bold',
                                    color: '#294e73',
                                    background: '#eaf2fa',
                                    padding: '10px 12px',
                                    marginBottom: 12
                                },
                                children: [
                                    context.translate('standards'),
                                    " \xb7 ",
                                    group.year
                                ]
                            }),
                            group.standards.map((standard)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Standard, {
                                    ...standard
                                }, `${group.id}:${standard.id}`))
                        ]
                    }, group.id))
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","react-text":"lEpdJ","../../../context":"iUP37","components/standards-selector/domain/planning-pdf.cjs":"j2Aoc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jsXPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Items);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _context = require("../../../context");
function Items(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                children: props.items.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldDefault.default), {
                        className: field.name,
                        name: field.content.name,
                        context: context,
                        sections: field.content.sections
                    }, field.id))
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./field":"lLuvS","../../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lLuvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Field);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fieldContent = require("./field-content");
var _fieldContentDefault = parcelHelpers.interopDefault(_fieldContent);
var _utils = require("../../../helpers/utils");
function Field(props) {
    const { id, name, className, context } = props;
    const sections = props.sections.map((props, contentId)=>({
            props,
            Element: (0, _fieldContentDefault.default)[props.type],
            contentId
        })).filter(({ Element, props })=>Element && !(0, _utils.isFieldEmpty)(props)).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            ...props,
            id: id,
            contentId: contentId,
            context: context
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: sections.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `${className} field-title title`,
                    children: name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "field-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        id: id,
                        className: `${className} field`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "content",
                            children: sections
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./field-content":"84Pr0","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"84Pr0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _utils = require("../../../helpers/utils");
const types = {
    checkbox: Checkbox,
    textarea: Textarea,
    panel: Panel,
    dropdown: Dropdown,
    radiopanel: RadioPanel
};
function Dropdown(props) {
    const { name, count, grouped, value, options, context } = props;
    const selects = value.filter((val)=>val != '').map((val, index)=>{
        const label = value.length < 2 ? name : `${name} ${index + 1}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "select",
            children: [
                !grouped && name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: label
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: val || " "
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            grouped && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            selects
        ]
    });
}
function Checkbox(props) {
    const { context } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "checkbox",
                    checked: props.value,
                    readOnly: true
                }),
                props.name
            ]
        })
    });
}
function Textarea(props) {
    const { context, name, maxlength, value, id, panelId, contentId } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "textarea",
                children: value
            })
        ]
    });
}
function Panel(panelProps) {
    const { id, name, context } = panelProps;
    const children = panelProps.children.map((props, contentId)=>({
            props,
            Element: types[props.type],
            contentId
        })).filter(({ Element, props })=>Element && !(0, _utils.isFieldEmpty)(props)).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            id: id,
            panelId: panelProps.contentId,
            contentId: contentId,
            context: context,
            ...props
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "children",
                    children: children
                })
            ]
        })
    });
}
function RadioPanel(panelProps) {
    const { id, name, context } = panelProps;
    const children = panelProps.children.filter((props)=>props.name === panelProps.value).map((props, contentId)=>{
        const radioId = `${id}-radio-${contentId}`;
        const checked = panelProps.value === props.name;
        const children = checked && props.value.filter((props)=>props.value).map((props, index)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)("radio-panel-option", {
                    checked
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            checked: props.value || false,
                            readOnly: true
                        }),
                        props.name
                    ]
                })
            }, index);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _clsxDefault.default)("radio-panel-item", {
                checked
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    id: radioId,
                    type: "radio",
                    name: id,
                    checked: checked,
                    readOnly: true,
                    value: props.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    htmlFor: radioId,
                    children: props.name
                }),
                children && children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "children",
                    children: children
                })
            ]
        }, contentId);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "children",
                children: children
            })
        ]
    });
}
exports.default = types;

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-select":"j36cq","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9iiNb":[function(require,module,exports,__globalThis) {
function safePart(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9_-]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 100);
}
function planningFilename(parts) {
    const name = parts.map(safePart).filter(Boolean).join('_');
    return `${name || 'Planificacion'}.pdf`;
}
module.exports = {
    planningFilename
};

},{}],"h2quG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DownloadLink);
parcelHelpers.export(exports, "parseContext", ()=>parseContext);
parcelHelpers.export(exports, "PDFDocument", ()=>PDFDocument);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _common = require("./common");
var _planInfo = require("./plan-info");
var _planInfoDefault = parcelHelpers.interopDefault(_planInfo);
var _standards = require("./standards");
var _standardsDefault = parcelHelpers.interopDefault(_standards);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _planningPdfCjs = require("components/standards-selector/domain/planning-pdf.cjs");
function DownloadLink({ plan, fileName, className, children, headerTitle }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.PDFDownloadLink), {
        className: className,
        fileName: fileName,
        document: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PDFDocument, {
            ...plan,
            headerTitle
        }),
        children: children
    });
}
function parseContext(context, newPlan) {
    const format = (date)=>(0, _momentDefault.default)(date).format('MM/DD/YYYY');
    const { translate, profile, subjects, grades, groups } = context;
    const { individual, institution } = profile;
    const { content = {}, title = '' } = newPlan;
    const planStart = format(newPlan.start);
    const planEnd = format(newPlan.finish);
    const subject = subjects.find((subject)=>subject.id == newPlan.subject);
    const grade = grades.find((grade)=>grade.id == newPlan.grade);
    const group = groups.find((group)=>group.id == newPlan.clique);
    /* Edition-aware hierarchy replaces the legacy ID-only reducer below. */ const groupedStandards = (0, _planningPdfCjs.groupPlanningPdfStandards)(content.standards || [], context.teacherExpectations, context.teacherStandards);
    return {
        ...newPlan,
        translate,
        planStart,
        planEnd,
        institution,
        author: {
            name: individual.first_name,
            lastName: individual.last_name
        },
        subject,
        grade,
        group,
        groupedStandards,
        lessons: content.lessons || [],
        resources: content.resources || [],
        items: newPlan.items || []
    };
}
function PDFDocument(plan) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Document), {
        style: (0, _stylesDefault.default).document,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Page), {
            size: "A4",
            style: (0, _stylesDefault.default).page,
            wrap: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Header), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        style: (0, _stylesDefault.default).headerTitle,
                        children: plan.headerTitle
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                    style: (0, _stylesDefault.default).content,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planInfoDefault.default), {
                            ...plan
                        }),
                        plan.groupedStandards.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsDefault.default), {
                            ...plan
                        }),
                        plan.items.length > 0 && plan.items.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldDefault.default), {
                                className: field.name,
                                name: field.content.name,
                                context: plan,
                                sections: field.content.sections
                            }, field.id))
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                    style: [
                        (0, _stylesDefault.default).author,
                        (0, _stylesDefault.default).footer
                    ],
                    fixed: true,
                    children: [
                        plan.author.name,
                        " ",
                        plan.author.lastName
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                    style: [
                        (0, _stylesDefault.default).paging,
                        (0, _stylesDefault.default).footer
                    ],
                    fixed: true,
                    render: (props)=>{
                        const { pageNumber, totalPages } = props;
                        return totalPages ? `${pageNumber} / ${totalPages}` : `${pageNumber}`;
                    }
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","@react-pdf/renderer":"3NU82","./common":"2jweM","./plan-info":"dICJ5","./standards":"pHJIV","./field":"6EUvL","./styles":"34LkF","components/standards-selector/domain/planning-pdf.cjs":"j2Aoc","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3NU82":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Document", ()=>Document$2);
parcelHelpers.export(exports, "BlobProvider", ()=>BlobProvider);
parcelHelpers.export(exports, "PDFViewer", ()=>PDFViewer);
parcelHelpers.export(exports, "PDFDownloadLink", ()=>PDFDownloadLink);
parcelHelpers.export(exports, "pdf", ()=>pdf);
parcelHelpers.export(exports, "View", ()=>View$1);
parcelHelpers.export(exports, "Text", ()=>Text$1);
parcelHelpers.export(exports, "Link", ()=>Link$1);
parcelHelpers.export(exports, "Page", ()=>Page$1);
parcelHelpers.export(exports, "Font", ()=>Font$1);
parcelHelpers.export(exports, "Note", ()=>Note$1);
parcelHelpers.export(exports, "Image", ()=>Image$1);
parcelHelpers.export(exports, "Canvas", ()=>Canvas$1);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "StyleSheet", ()=>StyleSheet);
parcelHelpers.export(exports, "PDFRenderer", ()=>PDFRenderer);
parcelHelpers.export(exports, "createInstance", ()=>createInstance);
var _inheritsLoose = require("@babel/runtime/helpers/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _regenerator = require("@babel/runtime/regenerator");
var _regeneratorDefault = parcelHelpers.interopDefault(_regenerator);
var _asyncToGenerator = require("@babel/runtime/helpers/asyncToGenerator");
var _asyncToGeneratorDefault = parcelHelpers.interopDefault(_asyncToGenerator);
var _blobStream = require("blob-stream");
var _blobStreamDefault = parcelHelpers.interopDefault(_blobStream);
var _reactReconciler = require("react-reconciler");
var _reactReconcilerDefault = parcelHelpers.interopDefault(_reactReconciler);
var _scheduler = require("scheduler");
var _createClass = require("@babel/runtime/helpers/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _pdfkit = require("@react-pdf/pdfkit");
var _pdfkitDefault = parcelHelpers.interopDefault(_pdfkit);
var _yoga = require("@react-pdf/yoga");
var _yogaDefault = parcelHelpers.interopDefault(_yoga);
var _ramda = require("ramda");
var _mediaEngine = require("media-engine");
var _mediaEngineDefault = parcelHelpers.interopDefault(_mediaEngine);
var _assertThisInitialized = require("@babel/runtime/helpers/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _pdf = require("@react-pdf/textkit/renderers/pdf");
var _pdfDefault = parcelHelpers.interopDefault(_pdf);
var _attributedString = require("@react-pdf/textkit/attributedString");
var _attributedStringDefault = parcelHelpers.interopDefault(_attributedString);
var _isUrl = require("is-url");
var _fontkit = require("@react-pdf/fontkit");
var _fontkitDefault = parcelHelpers.interopDefault(_fontkit);
var _crossFetch = require("cross-fetch");
var _crossFetchDefault = parcelHelpers.interopDefault(_crossFetch);
var _layout = require("@react-pdf/textkit/layout");
var _layoutDefault = parcelHelpers.interopDefault(_layout);
var _linebreaker = require("@react-pdf/textkit/engines/linebreaker");
var _linebreakerDefault = parcelHelpers.interopDefault(_linebreaker);
var _justification = require("@react-pdf/textkit/engines/justification");
var _justificationDefault = parcelHelpers.interopDefault(_justification);
var _textDecoration = require("@react-pdf/textkit/engines/textDecoration");
var _textDecorationDefault = parcelHelpers.interopDefault(_textDecoration);
var _scriptItemizer = require("@react-pdf/textkit/engines/scriptItemizer");
var _scriptItemizerDefault = parcelHelpers.interopDefault(_scriptItemizer);
var _wordHyphenation = require("@react-pdf/textkit/engines/wordHyphenation");
var _wordHyphenationDefault = parcelHelpers.interopDefault(_wordHyphenation);
var _emojiRegex = require("emoji-regex");
var _emojiRegexDefault = parcelHelpers.interopDefault(_emojiRegex);
var _pngJs = require("@react-pdf/png-js");
var _pngJsDefault = parcelHelpers.interopDefault(_pngJs);
var Buffer = require("be3b31386940112a").Buffer;
function printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        throw new Error(message);
    } catch (x) {}
}
var __DEV__ = false;
var warning = __DEV__ ? function(condition, format) {
    if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
    if (!condition) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
        printWarning.apply(void 0, [
            format
        ].concat(args));
    }
} : function() {};
var Root = /*#__PURE__*/ function() {
    function Root() {
        this.isDirty = false;
        this.document = null;
        this.instance = null;
    }
    var _proto = Root.prototype;
    _proto.appendChild = function appendChild(child) {
        this.document = child;
    };
    _proto.removeChild = function removeChild() {
        this.document.cleanup();
        this.document = null;
    };
    _proto.markDirty = function markDirty() {
        this.isDirty = true;
    };
    _proto.cleanup = function cleanup() {
        this.document.cleanup();
    };
    _proto.finish = function finish() {
        this.document.finish();
    };
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        this.instance = new (0, _pdfkitDefault.default)({
                            autoFirstPage: false
                        });
                        _context.next = 3;
                        return this.document.render();
                    case 3:
                        this.cleanup();
                        this.isDirty = false;
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Root, [
        {
            key: "name",
            get: function get() {
                return 'Root';
            }
        }
    ]);
    return Root;
}();
var upperFirst = function upperFirst(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
};
var isPercent = function isPercent(value) {
    return /((-)?\d+\.?\d*)%/g.exec(value);
};
var matchPercent = function matchPercent(value) {
    var match = isPercent(value);
    if (match) {
        var _value = parseFloat(match[1], 10);
        var percent = _value / 100;
        return {
            value: _value,
            percent: percent,
            absValue: Math.abs(_value),
            absPercent: Math.abs(percent)
        };
    }
    return null;
};
var YOGA_CONFIG = (0, _yogaDefault.default).Config.create();
YOGA_CONFIG.setPointScaleFactor(0);
var Node = /*#__PURE__*/ function() {
    function Node() {
        this.parent = null;
        this.children = [];
        this.computed = false;
        this.layout = (0, _yogaDefault.default).Node.createWithConfig(YOGA_CONFIG);
    }
    var _proto = Node.prototype;
    _proto.appendChild = function appendChild(child) {
        if (child) {
            child.parent = this;
            this.children.push(child);
            this.layout.insertChild(child.layout, this.layout.getChildCount());
        }
    };
    _proto.appendChildBefore = function appendChildBefore(child, beforeChild) {
        var index = this.children.indexOf(beforeChild);
        if (index !== -1 && child) {
            child.parent = this;
            this.children.splice(index, 0, child);
            this.layout.insertChild(child.layout, index);
        }
    };
    _proto.removeChild = function removeChild(child) {
        var index = this.children.indexOf(child);
        if (index !== -1) {
            child.parent = null;
            this.children.splice(index, 1);
            this.layout.removeChild(child.layout);
        }
        child.cleanup();
    };
    _proto.removeAllChilds = function removeAllChilds() {
        var children = [].concat(this.children);
        for(var i = 0; i < children.length; i++)children[i].remove();
    };
    _proto.remove = function remove() {
        this.parent.removeChild(this);
    };
    _proto.setDimension = function setDimension(attr, value) {
        var fixedMethod = "set" + upperFirst(attr);
        var percentMethod = fixedMethod + "Percent";
        var percent = matchPercent(value);
        if (percent) this.layout[percentMethod](percent.value);
        else this.layout[fixedMethod](value);
    };
    _proto.setPosition = function setPosition(edge, value) {
        var percent = matchPercent(value);
        if (percent) this.layout.setPositionPercent(edge, percent.value);
        else this.layout.setPosition(edge, value);
    };
    _proto.setPadding = function setPadding(edge, value) {
        var percent = matchPercent(value);
        if (percent) this.layout.setPaddingPercent(edge, percent.value);
        else this.layout.setPadding(edge, value);
    };
    _proto.setMargin = function setMargin(edge, value) {
        var percent = matchPercent(value);
        if (percent) this.layout.setMarginPercent(edge, percent.value);
        else this.layout.setMargin(edge, value);
    };
    _proto.setBorder = function setBorder(edge, value) {
        if (matchPercent(value)) throw new Error('Node: You cannot set percentage border widths');
        this.layout.setBorder(edge, value);
    };
    _proto.getAbsoluteLayout = function getAbsoluteLayout() {
        var parent = this.parent;
        var parentLayout = parent && parent.getAbsoluteLayout ? parent.getAbsoluteLayout() : {
            left: 0,
            top: 0
        };
        return {
            left: this.left + parentLayout.left,
            top: this.top + parentLayout.top,
            height: this.height,
            width: this.width
        };
    };
    _proto.copyStyle = function copyStyle(node) {
        this.layout.copyStyle(node.layout);
    };
    _proto.calculateLayout = function calculateLayout() {
        this.layout.calculateLayout();
        this.computed = true;
    };
    _proto.isEmpty = function isEmpty() {
        return this.children.length === 0;
    };
    _proto.markDirty = function markDirty() {
        return this.layout.markDirty();
    };
    _proto.onAppendDynamically = function onAppendDynamically() {};
    _proto.cleanup = function cleanup() {
        this.children.forEach(function(c) {
            return c.cleanup();
        });
        this.layout.unsetMeasureFunc();
        (0, _yogaDefault.default).Node.destroy(this.layout);
    };
    (0, _createClassDefault.default)(Node, [
        {
            key: "position",
            get: function get() {
                return this.layout.getPositionType() === (0, _yogaDefault.default).POSITION_TYPE_ABSOLUTE ? 'absolute' : 'relative';
            },
            set: function set(value) {
                this.layout.setPositionType(value === 'absolute' ? (0, _yogaDefault.default).POSITION_TYPE_ABSOLUTE : (0, _yogaDefault.default).POSITION_TYPE_RELATIVE);
            }
        },
        {
            key: "top",
            get: function get() {
                return this.layout.getComputedTop() || 0;
            },
            set: function set(value) {
                this.setPosition((0, _yogaDefault.default).EDGE_TOP, value);
            }
        },
        {
            key: "left",
            get: function get() {
                return this.layout.getComputedLeft() || 0;
            },
            set: function set(value) {
                this.setPosition((0, _yogaDefault.default).EDGE_LEFT, value);
            }
        },
        {
            key: "right",
            get: function get() {
                return this.layout.getComputedRight() || 0;
            },
            set: function set(value) {
                this.setPosition((0, _yogaDefault.default).EDGE_RIGHT, value);
            }
        },
        {
            key: "bottom",
            get: function get() {
                return this.layout.getComputedBottom() || 0;
            },
            set: function set(value) {
                this.setPosition((0, _yogaDefault.default).EDGE_BOTTOM, value);
            }
        },
        {
            key: "width",
            get: function get() {
                return this.layout.getComputedWidth();
            },
            set: function set(value) {
                this.setDimension('width', value);
            }
        },
        {
            key: "minWidth",
            get: function get() {
                return this.layout.getMinWidth().value;
            },
            set: function set(value) {
                this.setDimension('minWidth', value);
            }
        },
        {
            key: "maxWidth",
            get: function get() {
                return this.layout.getMaxWidth().value;
            },
            set: function set(value) {
                this.setDimension('maxWidth', value);
            }
        },
        {
            key: "height",
            get: function get() {
                return this.layout.getComputedHeight();
            },
            set: function set(value) {
                this.setDimension('height', value);
            }
        },
        {
            key: "minHeight",
            get: function get() {
                return this.layout.getMinHeight().value;
            },
            set: function set(value) {
                this.setDimension('minHeight', value);
            }
        },
        {
            key: "maxHeight",
            get: function get() {
                return this.layout.getMaxHeight().value;
            },
            set: function set(value) {
                this.setDimension('maxHeight', value);
            }
        },
        {
            key: "paddingTop",
            get: function get() {
                return this.layout.getComputedPadding((0, _yogaDefault.default).EDGE_TOP) || 0;
            },
            set: function set(value) {
                this.setPadding((0, _yogaDefault.default).EDGE_TOP, value);
            }
        },
        {
            key: "paddingRight",
            get: function get() {
                return this.layout.getComputedPadding((0, _yogaDefault.default).EDGE_RIGHT) || 0;
            },
            set: function set(value) {
                this.setPadding((0, _yogaDefault.default).EDGE_RIGHT, value);
            }
        },
        {
            key: "paddingBottom",
            get: function get() {
                return this.layout.getComputedPadding((0, _yogaDefault.default).EDGE_BOTTOM) || 0;
            },
            set: function set(value) {
                this.setPadding((0, _yogaDefault.default).EDGE_BOTTOM, value);
            }
        },
        {
            key: "paddingLeft",
            get: function get() {
                return this.layout.getComputedPadding((0, _yogaDefault.default).EDGE_LEFT) || 0;
            },
            set: function set(value) {
                this.setPadding((0, _yogaDefault.default).EDGE_LEFT, value);
            }
        },
        {
            key: "marginTop",
            get: function get() {
                return this.layout.getComputedMargin((0, _yogaDefault.default).EDGE_TOP) || 0;
            },
            set: function set(value) {
                this.setMargin((0, _yogaDefault.default).EDGE_TOP, value);
            }
        },
        {
            key: "marginRight",
            get: function get() {
                return this.layout.getComputedMargin((0, _yogaDefault.default).EDGE_RIGHT) || 0;
            },
            set: function set(value) {
                this.setMargin((0, _yogaDefault.default).EDGE_RIGHT, value);
            }
        },
        {
            key: "marginBottom",
            get: function get() {
                return this.layout.getComputedMargin((0, _yogaDefault.default).EDGE_BOTTOM) || 0;
            },
            set: function set(value) {
                this.setMargin((0, _yogaDefault.default).EDGE_BOTTOM, value);
            }
        },
        {
            key: "marginLeft",
            get: function get() {
                return this.layout.getComputedMargin((0, _yogaDefault.default).EDGE_LEFT) || 0;
            },
            set: function set(value) {
                this.setMargin((0, _yogaDefault.default).EDGE_LEFT, value);
            }
        },
        {
            key: "borderTopWidth",
            get: function get() {
                return this.layout.getComputedBorder((0, _yogaDefault.default).EDGE_TOP) || 0;
            },
            set: function set(value) {
                this.setBorder((0, _yogaDefault.default).EDGE_TOP, value);
            }
        },
        {
            key: "borderRightWidth",
            get: function get() {
                return this.layout.getComputedBorder((0, _yogaDefault.default).EDGE_RIGHT) || 0;
            },
            set: function set(value) {
                this.setBorder((0, _yogaDefault.default).EDGE_RIGHT, value);
            }
        },
        {
            key: "borderBottomWidth",
            get: function get() {
                return this.layout.getComputedBorder((0, _yogaDefault.default).EDGE_BOTTOM) || 0;
            },
            set: function set(value) {
                this.setBorder((0, _yogaDefault.default).EDGE_BOTTOM, value);
            }
        },
        {
            key: "borderLeftWidth",
            get: function get() {
                return this.layout.getComputedBorder((0, _yogaDefault.default).EDGE_LEFT) || 0;
            },
            set: function set(value) {
                this.setBorder((0, _yogaDefault.default).EDGE_LEFT, value);
            }
        },
        {
            key: "padding",
            get: function get() {
                return {
                    top: this.paddingTop,
                    right: this.paddingRight,
                    bottom: this.paddingBottom,
                    left: this.paddingLeft
                };
            },
            set: function set(value) {
                this.paddingTop = value;
                this.paddingRight = value;
                this.paddingBottom = value;
                this.paddingLeft = value;
            }
        },
        {
            key: "margin",
            get: function get() {
                return {
                    top: this.marginTop,
                    right: this.marginRight,
                    bottom: this.marginBottom,
                    left: this.marginLeft
                };
            },
            set: function set(value) {
                this.marginTop = value;
                this.marginRight = value;
                this.marginBottom = value;
                this.marginLeft = value;
            }
        }
    ]);
    return Node;
}();
var yogaValue = function yogaValue(prop, value) {
    var isAlignType = function isAlignType(prop) {
        return prop === 'alignItems' || prop === 'alignContent' || prop === 'alignSelf';
    };
    switch(value){
        case 'auto':
            if (prop === 'alignSelf') return (0, _yogaDefault.default).ALIGN_AUTO;
            break;
        case 'flex':
            return (0, _yogaDefault.default).DISPLAY_FLEX;
        case 'none':
            return (0, _yogaDefault.default).DISPLAY_NONE;
        case 'row':
            return (0, _yogaDefault.default).FLEX_DIRECTION_ROW;
        case 'row-reverse':
            return (0, _yogaDefault.default).FLEX_DIRECTION_ROW_REVERSE;
        case 'column':
            return (0, _yogaDefault.default).FLEX_DIRECTION_COLUMN;
        case 'column-reverse':
            return (0, _yogaDefault.default).FLEX_DIRECTION_COLUMN_REVERSE;
        case 'stretch':
            return (0, _yogaDefault.default).ALIGN_STRETCH;
        case 'baseline':
            return (0, _yogaDefault.default).ALIGN_BASELINE;
        case 'space-around':
            if (prop === 'justifyContent') return (0, _yogaDefault.default).JUSTIFY_SPACE_AROUND;
            else if (isAlignType(prop)) return (0, _yogaDefault.default).ALIGN_SPACE_AROUND;
            break;
        case 'space-between':
            if (prop === 'justifyContent') return (0, _yogaDefault.default).JUSTIFY_SPACE_BETWEEN;
            else if (isAlignType(prop)) return (0, _yogaDefault.default).ALIGN_SPACE_BETWEEN;
            break;
        case 'around':
            return (0, _yogaDefault.default).JUSTIFY_SPACE_AROUND;
        case 'between':
            return (0, _yogaDefault.default).JUSTIFY_SPACE_BETWEEN;
        case 'wrap':
            return (0, _yogaDefault.default).WRAP_WRAP;
        case 'wrap-reverse':
            return (0, _yogaDefault.default).WRAP_WRAP_REVERSE;
        case 'nowrap':
            return (0, _yogaDefault.default).WRAP_NO_WRAP;
        case 'flex-start':
            if (prop === 'justifyContent') return (0, _yogaDefault.default).JUSTIFY_FLEX_START;
            else if (isAlignType(prop)) return (0, _yogaDefault.default).ALIGN_FLEX_START;
            break;
        case 'flex-end':
            if (prop === 'justifyContent') return (0, _yogaDefault.default).JUSTIFY_FLEX_END;
            else if (isAlignType(prop)) return (0, _yogaDefault.default).ALIGN_FLEX_END;
            break;
        case 'center':
            if (prop === 'justifyContent') return (0, _yogaDefault.default).JUSTIFY_CENTER;
            else if (isAlignType(prop)) return (0, _yogaDefault.default).ALIGN_CENTER;
            break;
        default:
            return value;
    }
}; // These are not supported yet
var DPI = 72; // 72pt per inch.
var parseValue = function parseValue(value) {
    var match = /^(-?\d*\.?\d+)(in|mm|cm|pt|vh|vw)?$/g.exec(value);
    if (match) return {
        value: parseFloat(match[1], 10),
        unit: match[2] || 'pt'
    };
    return {
        value: value,
        unit: undefined
    };
};
var parseScalar = function parseScalar(value, container) {
    var scalar = parseValue(value);
    switch(scalar.unit){
        case 'in':
            return scalar.value * DPI;
        case 'mm':
            return scalar.value * (1 / 25.4) * DPI;
        case 'cm':
            return scalar.value * (1 / 2.54) * DPI;
        case 'vh':
            if (container.isAutoHeight) throw new Error('vh unit not supported in auto-height pages. Please specify page height if you want to use vh.');
            return scalar.value * (container.height / 100);
        case 'vw':
            return scalar.value * (container.width / 100);
        default:
            return scalar.value;
    }
};
var isBorderStyle = function isBorderStyle(key, value) {
    return key.match(/^border/) && typeof value === 'string';
};
var matchBorderShorthand = function matchBorderShorthand(value) {
    return value.match(/(\d+(px|in|mm|cm|pt|vw|vh)?)\s(\S+)\s(\S+)/);
}; // Transforms shorthand border values
var processBorders = function processBorders(key, value) {
    var match = matchBorderShorthand(value);
    if (match) {
        if (key.match(/.Color/)) return match[4];
        else if (key.match(/.Style/)) return match[3];
        else if (key.match(/.Width/)) return match[1];
        else throw new Error("StyleSheet: Invalid '" + value + "' for '" + key + "'");
    }
    return value;
};
var isBoxModelStyle = function isBoxModelStyle(key, value) {
    return key.match(/^(margin)|(padding)/) && typeof value === 'string';
};
var matchBoxModel = function matchBoxModel(value) {
    return value.match(/\d+(px|in|mm|cm|pt|%|vw|vh)?/g);
}; // Transforms shorthand margin and padding values
var processBoxModel = function processBoxModel(key, value) {
    var match = matchBoxModel(value);
    if (match) {
        if (key.match(/.Top/)) return match[0];
        else if (key.match(/.Right/)) return match[1] || match[0];
        else if (key.match(/.Bottom/)) return match[2] || match[0];
        else if (key.match(/.Left/)) return match[3] || match[1] || match[0];
        else throw new Error("StyleSheet: Invalid '" + value + "' for '" + key + "'");
    }
    return value;
};
// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#Common_weight_name_mapping
var FONT_WEIGHTS = {
    thin: 100,
    hairline: 100,
    ultralight: 200,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    demibold: 600,
    bold: 700,
    ultrabold: 800,
    extrabold: 800,
    heavy: 900,
    black: 900
};
var isFontWeightStyle = function isFontWeightStyle(key) {
    return key.match(/^fontWeight/);
};
var processFontWeight = function processFontWeight(value) {
    if (!value) return FONT_WEIGHTS.normal;
    if (typeof value === 'number') return value;
    return FONT_WEIGHTS[value.toLowerCase()];
};
var isObjectPositionStyle = function isObjectPositionStyle(key, value) {
    return key.match(/^objectPosition/) && typeof value === 'string';
};
var matchObjectPosition = function matchObjectPosition(value) {
    return value.match(/\d+(px|in|mm|cm|pt|%|vw|vh)?/g);
}; // Transforms shorthand objectPosition values
var processObjectPosition = function processObjectPosition(key, value) {
    var match = matchObjectPosition(value);
    if (match) {
        if (key.match(/.X/)) return match[0];
        else if (key.match(/.Y/)) return match[1];
        else throw new Error("StyleSheet: Invalid '" + value + "' for '" + key + "'");
    }
    return value;
};
var isTransformOriginStyle = function isTransformOriginStyle(key, value) {
    return key.match(/^transformOrigin/) && typeof value === 'string';
};
var matchTransformOrigin = function matchTransformOrigin(value) {
    return value.match(/(-?\d+(px|in|mm|cm|pt|%|vw|vh)?)|top|right|bottom|left|center/g);
};
var transformOffsetKeywords = function transformOffsetKeywords(value) {
    switch(value){
        case 'top':
        case 'left':
            return '0%';
        case 'right':
        case 'bottom':
            return '100%';
        case 'center':
            return '50%';
        default:
            return value;
    }
}; // Transforms shorthand transformOrigin values
var processTransformOrigin = function processTransformOrigin(key, value) {
    var match = matchTransformOrigin(value);
    if (match) {
        var result;
        if (key.match(/.X/)) result = match[0];
        else if (key.match(/.Y/)) result = match[1] || match[0];
        else throw new Error("StyleSheet: Invalid '" + value + "' for '" + key + "'");
        return transformOffsetKeywords(result);
    }
    return value;
};
var hasOwnProperty = Object.prototype.hasOwnProperty;
var styleShorthands = {
    margin: {
        marginTop: true,
        marginRight: true,
        marginBottom: true,
        marginLeft: true
    },
    marginHorizontal: {
        marginLeft: true,
        marginRight: true
    },
    marginVertical: {
        marginTop: true,
        marginBottom: true
    },
    padding: {
        paddingTop: true,
        paddingRight: true,
        paddingBottom: true,
        paddingLeft: true
    },
    paddingHorizontal: {
        paddingLeft: true,
        paddingRight: true
    },
    paddingVertical: {
        paddingTop: true,
        paddingBottom: true
    },
    border: {
        borderTopColor: true,
        borderTopStyle: true,
        borderTopWidth: true,
        borderRightColor: true,
        borderRightStyle: true,
        borderRightWidth: true,
        borderBottomColor: true,
        borderBottomStyle: true,
        borderBottomWidth: true,
        borderLeftColor: true,
        borderLeftStyle: true,
        borderLeftWidth: true
    },
    borderTop: {
        borderTopColor: true,
        borderTopStyle: true,
        borderTopWidth: true
    },
    borderRight: {
        borderRightColor: true,
        borderRightStyle: true,
        borderRightWidth: true
    },
    borderBottom: {
        borderBottomColor: true,
        borderBottomStyle: true,
        borderBottomWidth: true
    },
    borderLeft: {
        borderLeftColor: true,
        borderLeftStyle: true,
        borderLeftWidth: true
    },
    borderColor: {
        borderTopColor: true,
        borderRightColor: true,
        borderBottomColor: true,
        borderLeftColor: true
    },
    borderRadius: {
        borderTopLeftRadius: true,
        borderTopRightRadius: true,
        borderBottomRightRadius: true,
        borderBottomLeftRadius: true
    },
    borderStyle: {
        borderTopStyle: true,
        borderRightStyle: true,
        borderBottomStyle: true,
        borderLeftStyle: true
    },
    borderWidth: {
        borderTopWidth: true,
        borderRightWidth: true,
        borderBottomWidth: true,
        borderLeftWidth: true
    },
    objectPosition: {
        objectPositionX: true,
        objectPositionY: true
    },
    transformOrigin: {
        transformOriginX: true,
        transformOriginY: true
    }
}; // Expand the shorthand properties to isolate every declaration from the others.
var expandStyles = function expandStyles(style) {
    if (!style) return style;
    var propsArray = Object.keys(style);
    var resolvedStyle = {};
    for(var i = 0; i < propsArray.length; i++){
        var key = propsArray[i];
        var value = style[key];
        switch(key){
            case 'display':
            case 'flex':
            case 'flexDirection':
            case 'flexWrap':
            case 'flexFlow':
            case 'flexGrow':
            case 'flexShrink':
            case 'flexBasis':
            case 'justifyContent':
            case 'alignSelf':
            case 'alignItems':
            case 'alignContent':
            case 'order':
                resolvedStyle[key] = yogaValue(key, value);
                break;
            case 'textAlignVertical':
                resolvedStyle.verticalAlign = value === 'center' ? 'middle' : value;
                break;
            case 'margin':
            case 'marginHorizontal':
            case 'marginVertical':
            case 'padding':
            case 'paddingHorizontal':
            case 'paddingVertical':
            case 'border':
            case 'borderTop':
            case 'borderRight':
            case 'borderBottom':
            case 'borderLeft':
            case 'borderColor':
            case 'borderRadius':
            case 'borderStyle':
            case 'borderWidth':
            case 'objectPosition':
            case 'transformOrigin':
                var expandedProps = styleShorthands[key];
                for(var propName in expandedProps)if (hasOwnProperty.call(expandedProps, propName)) resolvedStyle[propName] = value;
                break;
            default:
                resolvedStyle[key] = value;
                break;
        }
    }
    return resolvedStyle;
};
var transformStyles = function transformStyles(style, container) {
    var expandedStyles = expandStyles(style);
    var propsArray = Object.keys(expandedStyles);
    var resolvedStyle = {};
    for(var i = 0; i < propsArray.length; i++){
        var key = propsArray[i];
        var value = expandedStyles[key];
        var resolved = void 0;
        if (isBorderStyle(key, value)) resolved = processBorders(key, value);
        else if (isBoxModelStyle(key, value)) resolved = processBoxModel(key, value);
        else if (isObjectPositionStyle(key, value)) resolved = processObjectPosition(key, value);
        else if (isTransformOriginStyle(key, value)) resolved = processTransformOrigin(key, value);
        else if (isFontWeightStyle(key, value)) resolved = processFontWeight(value);
        else resolved = value;
        resolvedStyle[key] = parseScalar(resolved, container);
    }
    return resolvedStyle;
};
var create = function create(styles) {
    return styles;
};
var flatten = function flatten(input) {
    if (!Array.isArray(input)) input = [
        input
    ];
    var result = input.reduce(function(acc, style) {
        if (style) {
            var s = Array.isArray(style) ? flatten(style) : style;
            Object.keys(s).forEach(function(key) {
                if (s[key] !== null && s[key] !== undefined) acc[key] = s[key];
            });
        }
        return acc;
    }, {});
    return result;
};
var resolveMediaQueries = function resolveMediaQueries(input, container) {
    var result = Object.keys(input).reduce(function(acc, key) {
        var _extends2;
        if (/@media/.test(key)) {
            var _matchMedia;
            return (0, _extendsDefault.default)({}, acc, (0, _mediaEngineDefault.default)((_matchMedia = {}, _matchMedia[key] = input[key], _matchMedia), container));
        }
        return (0, _extendsDefault.default)({}, acc, (_extends2 = {}, _extends2[key] = input[key], _extends2));
    }, {});
    return result;
};
var resolve = function resolve(styles, container) {
    if (!styles) return null;
    styles = flatten(styles);
    styles = resolveMediaQueries(styles, container);
    styles = transformStyles(styles, container);
    return styles;
};
var absoluteFillObject = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
var StyleSheet = {
    hairlineWidth: 1,
    create: create,
    resolve: resolve,
    flatten: flatten,
    absoluteFillObject: absoluteFillObject
};
var Debug = {
    debug: function debug() {
        var layout = this.getAbsoluteLayout();
        var padding = this.padding;
        var margin = this.margin;
        this.root.instance.save();
        this.debugContent(layout, margin, padding);
        this.debugPadding(layout, margin, padding);
        this.debugMargin(layout, margin);
        this.debugText(layout, margin);
        this.debugOrigin();
        this.root.instance.restore();
    },
    debugOrigin: function debugOrigin() {
        if (this.style.transform) {
            var origin = this.origin;
            this.root.instance.circle(origin[0], origin[1], 3).fill('red').circle(origin[0], origin[1], 5).stroke('red');
        }
    },
    debugText: function debugText(layout, margin) {
        var roundedWidth = Math.round(this.width + margin.left + margin.right);
        var roundedHeight = Math.round(this.height + margin.top + margin.bottom);
        this.root.instance.fontSize(4).opacity(1).fillColor('black').text(roundedWidth + " x " + roundedHeight, layout.left - margin.left, Math.max(layout.top - margin.top - 4, 1));
    },
    debugContent: function debugContent(layout, margin, padding) {
        this.root.instance.fillColor('#a1c6e7').opacity(0.5).rect(layout.left + padding.left, layout.top + padding.top, layout.width - padding.left - padding.right, layout.height - padding.top - padding.bottom).fill();
    },
    debugPadding: function debugPadding(layout, margin, padding) {
        this.root.instance.fillColor('#c4deb9').opacity(0.5); // Padding top
        this.root.instance.rect(layout.left + padding.left, layout.top, layout.width - padding.right - padding.left, padding.top).fill(); // Padding left
        this.root.instance.rect(layout.left, layout.top, padding.left, layout.height).fill(); // Padding right
        this.root.instance.rect(layout.left + layout.width - padding.right, layout.top, padding.right, layout.height).fill(); // Padding bottom
        this.root.instance.rect(layout.left + padding.left, layout.top + layout.height - padding.bottom, layout.width - padding.right - padding.left, padding.bottom).fill();
    },
    debugMargin: function debugMargin(layout, margin) {
        this.root.instance.fillColor('#f8cca1').opacity(0.5); // Margin top
        this.root.instance.rect(layout.left, layout.top - margin.top, layout.width, margin.top).fill(); // Margin left
        this.root.instance.rect(layout.left - margin.left, layout.top - margin.top, margin.left, layout.height + margin.top + margin.bottom).fill(); // Margin right
        this.root.instance.rect(layout.left + layout.width, layout.top - margin.top, margin.right, layout.height + margin.top + margin.bottom).fill(); // Margin bottom
        this.root.instance.rect(layout.left, layout.top + layout.height, layout.width, margin.bottom).fill();
    }
};
// Ref: https://www.w3.org/TR/css-backgrounds-3/#borders
// This constant is used to approximate a symmetrical arc using a cubic Bezier curve.
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
function drawBorders() {
    var instance = this.root.instance;
    var layout = this.getAbsoluteLayout();
    var borderTopWidth = this.borderTopWidth, borderLeftWidth = this.borderLeftWidth, borderRightWidth = this.borderRightWidth, borderBottomWidth = this.borderBottomWidth;
    var _this$style = this.style, opacity = _this$style.opacity, _this$style$borderTop = _this$style.borderTopLeftRadius, borderTopLeftRadius = _this$style$borderTop === void 0 ? 0 : _this$style$borderTop, _this$style$borderTop2 = _this$style.borderTopRightRadius, borderTopRightRadius = _this$style$borderTop2 === void 0 ? 0 : _this$style$borderTop2, _this$style$borderBot = _this$style.borderBottomLeftRadius, borderBottomLeftRadius = _this$style$borderBot === void 0 ? 0 : _this$style$borderBot, _this$style$borderBot2 = _this$style.borderBottomRightRadius, borderBottomRightRadius = _this$style$borderBot2 === void 0 ? 0 : _this$style$borderBot2, _this$style$borderTop3 = _this$style.borderTopColor, borderTopColor = _this$style$borderTop3 === void 0 ? 'black' : _this$style$borderTop3, _this$style$borderTop4 = _this$style.borderTopStyle, borderTopStyle = _this$style$borderTop4 === void 0 ? 'solid' : _this$style$borderTop4, _this$style$borderLef = _this$style.borderLeftColor, borderLeftColor = _this$style$borderLef === void 0 ? 'black' : _this$style$borderLef, _this$style$borderLef2 = _this$style.borderLeftStyle, borderLeftStyle = _this$style$borderLef2 === void 0 ? 'solid' : _this$style$borderLef2, _this$style$borderRig = _this$style.borderRightColor, borderRightColor = _this$style$borderRig === void 0 ? 'black' : _this$style$borderRig, _this$style$borderRig2 = _this$style.borderRightStyle, borderRightStyle = _this$style$borderRig2 === void 0 ? 'solid' : _this$style$borderRig2, _this$style$borderBot3 = _this$style.borderBottomColor, borderBottomColor = _this$style$borderBot3 === void 0 ? 'black' : _this$style$borderBot3, _this$style$borderBot4 = _this$style.borderBottomStyle, borderBottomStyle = _this$style$borderBot4 === void 0 ? 'solid' : _this$style$borderBot4;
    var style = {
        borderTopColor: borderTopColor,
        borderTopWidth: borderTopWidth,
        borderTopStyle: borderTopStyle,
        borderLeftColor: borderLeftColor,
        borderLeftWidth: borderLeftWidth,
        borderLeftStyle: borderLeftStyle,
        borderRightColor: borderRightColor,
        borderRightWidth: borderRightWidth,
        borderRightStyle: borderRightStyle,
        borderBottomColor: borderBottomColor,
        borderBottomWidth: borderBottomWidth,
        borderBottomStyle: borderBottomStyle,
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius,
        borderBottomLeftRadius: borderBottomLeftRadius,
        borderBottomRightRadius: borderBottomRightRadius
    };
    var width = layout.width, height = layout.height;
    var rtr = Math.min(borderTopRightRadius, 0.5 * width, 0.5 * height);
    var rtl = Math.min(borderTopLeftRadius, 0.5 * width, 0.5 * height);
    var rbr = Math.min(borderBottomRightRadius, 0.5 * width, 0.5 * height);
    var rbl = Math.min(borderBottomLeftRadius, 0.5 * width, 0.5 * height);
    instance.save();
    instance.strokeOpacity(opacity);
    if (borderTopWidth) {
        instance.save();
        clipBorderTop(instance, layout, style, rtr, rtl);
        fillBorderTop(instance, layout, style, rtr, rtl);
        instance.restore();
    }
    if (borderRightWidth) {
        instance.save();
        clipBorderRight(instance, layout, style, rtr, rbr);
        fillBorderRight(instance, layout, style, rtr, rbr);
        instance.restore();
    }
    if (borderBottomWidth) {
        instance.save();
        clipBorderBottom(instance, layout, style, rbl, rbr);
        fillBorderBottom(instance, layout, style, rbl, rbr);
        instance.restore();
    }
    if (borderLeftWidth) {
        instance.save();
        clipBorderLeft(instance, layout, style, rbl, rtl);
        fillBorderLeft(instance, layout, style, rbl, rtl);
        instance.restore();
    }
    instance.restore();
}
var clipBorderTop = function clipBorderTop(ctx, layout, style, rtr, rtl) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth; // Clip outer top border edge
    ctx.moveTo(left + rtl, top);
    ctx.lineTo(left + width - rtr, top); // Ellipse coefficients outer top right cap
    var c0 = rtr * (1.0 - KAPPA); // Clip outer top right cap
    ctx.bezierCurveTo(left + width - c0, top, left + width, top + c0, left + width, top + rtr); // Move down in case the margin exceedes the radius
    var topRightYCoord = top + Math.max(borderTopWidth, rtr);
    ctx.lineTo(left + width, topRightYCoord); // Clip inner top right cap
    ctx.lineTo(left + width - borderRightWidth, topRightYCoord); // Ellipse coefficients inner top right cap
    var innerTopRightRadiusX = Math.max(rtr - borderRightWidth, 0);
    var innerTopRightRadiusY = Math.max(rtr - borderTopWidth, 0);
    var c1 = innerTopRightRadiusX * (1.0 - KAPPA);
    var c2 = innerTopRightRadiusY * (1.0 - KAPPA); // Clip inner top right cap
    ctx.bezierCurveTo(left + width - borderRightWidth, top + borderTopWidth + c2, left + width - borderRightWidth - c1, top + borderTopWidth, left + width - borderRightWidth - innerTopRightRadiusX, top + borderTopWidth); // Clip inner top border edge
    ctx.lineTo(left + Math.max(rtl, borderLeftWidth), top + borderTopWidth); // Ellipse coefficients inner top left cap
    var innerTopLeftRadiusX = Math.max(rtl - borderLeftWidth, 0);
    var innerTopLeftRadiusY = Math.max(rtl - borderTopWidth, 0);
    var c3 = innerTopLeftRadiusX * (1.0 - KAPPA);
    var c4 = innerTopLeftRadiusY * (1.0 - KAPPA);
    var topLeftYCoord = top + Math.max(borderTopWidth, rtl); // Clip inner top left cap
    ctx.bezierCurveTo(left + borderLeftWidth + c3, top + borderTopWidth, left + borderLeftWidth, top + borderTopWidth + c4, left + borderLeftWidth, topLeftYCoord);
    ctx.lineTo(left, topLeftYCoord); // Move down in case the margin exceedes the radius
    ctx.lineTo(left, top + rtl); // Ellipse coefficients outer top left cap
    var c5 = rtl * (1.0 - KAPPA); // Clip outer top left cap
    ctx.bezierCurveTo(left, top + c5, left + c5, top, left + rtl, top);
    ctx.closePath();
    ctx.clip(); // Clip border top cap joins
    if (borderRightWidth) {
        var trSlope = -borderTopWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, trSlope * (-width / 2) + top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left, top);
        ctx.lineTo(left, top + height);
        ctx.closePath();
        ctx.clip();
    }
    if (borderLeftWidth) {
        var _trSlope = -borderTopWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, _trSlope * (-width / 2) + top);
        ctx.lineTo(left, top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left + width, top + height);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderTop = function fillBorderTop(ctx, layout, style, rtr, rtl) {
    var top = layout.top, left = layout.left, width = layout.width;
    var borderTopColor = style.borderTopColor, borderTopWidth = style.borderTopWidth, borderTopStyle = style.borderTopStyle, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    var c0 = rtl * (1.0 - KAPPA);
    var c1 = rtr * (1.0 - KAPPA);
    ctx.moveTo(left, top + Math.max(rtl, borderTopWidth));
    ctx.bezierCurveTo(left, top + c0, left + c0, top, left + rtl, top);
    ctx.lineTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - c1, top, left + width, top + c1, left + width, top + rtr);
    ctx.strokeColor(borderTopColor);
    ctx.lineWidth(Math.max(borderRightWidth, borderTopWidth, borderLeftWidth) * 2);
    if (borderTopStyle === 'dashed') ctx.dash(borderTopWidth * 2, {
        space: borderTopWidth * 1.2
    });
    else if (borderTopStyle === 'dotted') ctx.dash(borderTopWidth, {
        space: borderTopWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderRight = function clipBorderRight(ctx, layout, style, rtr, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderRightWidth = style.borderRightWidth, borderBottomWidth = style.borderBottomWidth; // Clip outer right border edge
    ctx.moveTo(left + width, top + rtr);
    ctx.lineTo(left + width, top + height - rbr); // Ellipse coefficients outer bottom right cap
    var c0 = rbr * (1.0 - KAPPA); // Clip outer top right cap
    ctx.bezierCurveTo(left + width, top + height - c0, left + width - c0, top + height, left + width - rbr, top + height); // Move left in case the margin exceedes the radius
    var topBottomXCoord = left + width - Math.max(borderRightWidth, rbr);
    ctx.lineTo(topBottomXCoord, top + height); // Clip inner bottom right cap
    ctx.lineTo(topBottomXCoord, top + height - borderBottomWidth); // Ellipse coefficients inner bottom right cap
    var innerBottomRightRadiusX = Math.max(rbr - borderRightWidth, 0);
    var innerBottomRightRadiusY = Math.max(rbr - borderBottomWidth, 0);
    var c1 = innerBottomRightRadiusX * (1.0 - KAPPA);
    var c2 = innerBottomRightRadiusY * (1.0 - KAPPA); // Clip inner top right cap
    ctx.bezierCurveTo(left + width - borderRightWidth - c1, top + height - borderBottomWidth, left + width - borderRightWidth, top + height - borderBottomWidth - c2, left + width - borderRightWidth, top + height - Math.max(rbr, borderBottomWidth)); // Clip inner right border edge
    ctx.lineTo(left + width - borderRightWidth, top + Math.max(rtr, borderTopWidth)); // Ellipse coefficients inner top right cap
    var innerTopRightRadiusX = Math.max(rtr - borderRightWidth, 0);
    var innerTopRightRadiusY = Math.max(rtr - borderTopWidth, 0);
    var c3 = innerTopRightRadiusX * (1.0 - KAPPA);
    var c4 = innerTopRightRadiusY * (1.0 - KAPPA);
    var topRightXCoord = left + width - Math.max(rtr, borderRightWidth); // Clip inner top left cap
    ctx.bezierCurveTo(left + width - borderRightWidth, top + borderTopWidth + c4, left + width - borderRightWidth - c3, top + borderTopWidth, topRightXCoord, top + borderTopWidth);
    ctx.lineTo(topRightXCoord, top); // Move right in case the margin exceedes the radius
    ctx.lineTo(left + width - rtr, top); // Ellipse coefficients outer top right cap
    var c5 = rtr * (1.0 - KAPPA); // Clip outer top right cap
    ctx.bezierCurveTo(left + width - c5, top, left + width, top + c5, left + width, top + rtr);
    ctx.closePath();
    ctx.clip(); // Clip border right cap joins
    if (borderTopWidth) {
        var trSlope = -borderTopWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, trSlope * (-width / 2) + top);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left, top + height);
        ctx.closePath();
        ctx.clip();
    }
    if (borderBottomWidth) {
        var brSlope = borderBottomWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, brSlope * (-width / 2) + top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left + width, top);
        ctx.lineTo(left, top);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderRight = function fillBorderRight(ctx, layout, style, rtr, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderRightColor = style.borderRightColor, borderRightStyle = style.borderRightStyle, borderRightWidth = style.borderRightWidth, borderTopWidth = style.borderTopWidth, borderBottomWidth = style.borderBottomWidth;
    var c0 = rbr * (1.0 - KAPPA);
    var c1 = rtr * (1.0 - KAPPA);
    ctx.moveTo(left + width - rtr, top);
    ctx.bezierCurveTo(left + width - c1, top, left + width, top + c1, left + width, top + rtr);
    ctx.lineTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - c0, left + width - c0, top + height, left + width - rbr, top + height);
    ctx.strokeColor(borderRightColor);
    ctx.lineWidth(Math.max(borderRightWidth, borderTopWidth, borderBottomWidth) * 2);
    if (borderRightStyle === 'dashed') ctx.dash(borderRightWidth * 2, {
        space: borderRightWidth * 1.2
    });
    else if (borderRightStyle === 'dotted') ctx.dash(borderRightWidth, {
        space: borderRightWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderBottom = function clipBorderBottom(ctx, layout, style, rbl, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderBottomWidth = style.borderBottomWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth; // Clip outer top border edge
    ctx.moveTo(left + width - rbr, top + height);
    ctx.lineTo(left + rbl, top + height); // Ellipse coefficients outer top right cap
    var c0 = rbl * (1.0 - KAPPA); // Clip outer top right cap
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl); // Move up in case the margin exceedes the radius
    var bottomLeftYCoord = top + height - Math.max(borderBottomWidth, rbl);
    ctx.lineTo(left, bottomLeftYCoord); // Clip inner bottom left cap
    ctx.lineTo(left + borderLeftWidth, bottomLeftYCoord); // Ellipse coefficients inner top right cap
    var innerBottomLeftRadiusX = Math.max(rbl - borderLeftWidth, 0);
    var innerBottomLeftRadiusY = Math.max(rbl - borderBottomWidth, 0);
    var c1 = innerBottomLeftRadiusX * (1.0 - KAPPA);
    var c2 = innerBottomLeftRadiusY * (1.0 - KAPPA); // Clip inner bottom left cap
    ctx.bezierCurveTo(left + borderLeftWidth, top + height - borderBottomWidth - c2, left + borderLeftWidth + c1, top + height - borderBottomWidth, left + borderLeftWidth + innerBottomLeftRadiusX, top + height - borderBottomWidth); // Clip inner bottom border edge
    ctx.lineTo(left + width - Math.max(rbr, borderRightWidth), top + height - borderBottomWidth); // Ellipse coefficients inner top left cap
    var innerBottomRightRadiusX = Math.max(rbr - borderRightWidth, 0);
    var innerBottomRightRadiusY = Math.max(rbr - borderBottomWidth, 0);
    var c3 = innerBottomRightRadiusX * (1.0 - KAPPA);
    var c4 = innerBottomRightRadiusY * (1.0 - KAPPA);
    var bottomRightYCoord = top + height - Math.max(borderBottomWidth, rbr); // Clip inner top left cap
    ctx.bezierCurveTo(left + width - borderRightWidth - c3, top + height - borderBottomWidth, left + width - borderRightWidth, top + height - borderBottomWidth - c4, left + width - borderRightWidth, bottomRightYCoord);
    ctx.lineTo(left + width, bottomRightYCoord); // Move down in case the margin exceedes the radius
    ctx.lineTo(left + width, top + height - rbr); // Ellipse coefficients outer top left cap
    var c5 = rbr * (1.0 - KAPPA); // Clip outer top left cap
    ctx.bezierCurveTo(left + width, top + height - c5, left + width - c5, top + height, left + width - rbr, top + height);
    ctx.closePath();
    ctx.clip(); // Clip border bottom cap joins
    if (borderRightWidth) {
        var brSlope = borderBottomWidth / borderRightWidth;
        ctx.moveTo(left + width / 2, brSlope * (-width / 2) + top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left, top);
        ctx.closePath();
        ctx.clip();
    }
    if (borderLeftWidth) {
        var trSlope = -borderBottomWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, trSlope * (width / 2) + top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left + width, top + height);
        ctx.lineTo(left + width, top);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderBottom = function fillBorderBottom(ctx, layout, style, rbl, rbr) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderBottomColor = style.borderBottomColor, borderBottomStyle = style.borderBottomStyle, borderBottomWidth = style.borderBottomWidth, borderRightWidth = style.borderRightWidth, borderLeftWidth = style.borderLeftWidth;
    var c0 = rbl * (1.0 - KAPPA);
    var c1 = rbr * (1.0 - KAPPA);
    ctx.moveTo(left + width, top + height - rbr);
    ctx.bezierCurveTo(left + width, top + height - c1, left + width - c1, top + height, left + width - rbr, top + height);
    ctx.lineTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    ctx.strokeColor(borderBottomColor);
    ctx.lineWidth(Math.max(borderBottomWidth, borderRightWidth, borderLeftWidth) * 2);
    if (borderBottomStyle === 'dashed') ctx.dash(borderBottomWidth * 2, {
        space: borderBottomWidth * 1.2
    });
    else if (borderBottomStyle === 'dotted') ctx.dash(borderBottomWidth, {
        space: borderBottomWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var clipBorderLeft = function clipBorderLeft(ctx, layout, style, rbl, rtl) {
    var top = layout.top, left = layout.left, width = layout.width, height = layout.height;
    var borderTopWidth = style.borderTopWidth, borderLeftWidth = style.borderLeftWidth, borderBottomWidth = style.borderBottomWidth; // Clip outer left border edge
    ctx.moveTo(left, top + height - rbl);
    ctx.lineTo(left, top + rtl); // Ellipse coefficients outer top left cap
    var c0 = rtl * (1.0 - KAPPA); // Clip outer top left cap
    ctx.bezierCurveTo(left, top + c0, left + c0, top, left + rtl, top); // Move right in case the margin exceedes the radius
    var topLeftCoordX = left + Math.max(borderLeftWidth, rtl);
    ctx.lineTo(topLeftCoordX, top); // Clip inner top left cap
    ctx.lineTo(topLeftCoordX, top + borderTopWidth); // Ellipse coefficients inner top left cap
    var innerTopLeftRadiusX = Math.max(rtl - borderLeftWidth, 0);
    var innerTopLeftRadiusY = Math.max(rtl - borderTopWidth, 0);
    var c1 = innerTopLeftRadiusX * (1.0 - KAPPA);
    var c2 = innerTopLeftRadiusY * (1.0 - KAPPA); // Clip inner top right cap
    ctx.bezierCurveTo(left + borderLeftWidth + c1, top + borderTopWidth, left + borderLeftWidth, top + borderTopWidth + c2, left + borderLeftWidth, top + Math.max(rtl, borderTopWidth)); // Clip inner left border edge
    ctx.lineTo(left + borderLeftWidth, top + height - Math.max(rbl, borderBottomWidth)); // Ellipse coefficients inner bottom left cap
    var innerBottomLeftRadiusX = Math.max(rbl - borderLeftWidth, 0);
    var innerBottomLeftRadiusY = Math.max(rbl - borderBottomWidth, 0);
    var c3 = innerBottomLeftRadiusX * (1.0 - KAPPA);
    var c4 = innerBottomLeftRadiusY * (1.0 - KAPPA);
    var bottomLeftXCoord = left + Math.max(rbl, borderLeftWidth); // Clip inner top left cap
    ctx.bezierCurveTo(left + borderLeftWidth, top + height - borderBottomWidth - c4, left + borderLeftWidth + c3, top + height - borderBottomWidth, bottomLeftXCoord, top + height - borderBottomWidth);
    ctx.lineTo(bottomLeftXCoord, top + height); // Move left in case the margin exceedes the radius
    ctx.lineTo(left + rbl, top + height); // Ellipse coefficients outer top right cap
    var c5 = rbl * (1.0 - KAPPA); // Clip outer top right cap
    ctx.bezierCurveTo(left + c5, top + height, left, top + height - c5, left, top + height - rbl);
    ctx.closePath();
    ctx.clip(); // Clip border right cap joins
    if (borderBottomWidth) {
        var trSlope = -borderBottomWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, trSlope * (width / 2) + top + height);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left, top);
        ctx.lineTo(left + width, top);
        ctx.closePath();
        ctx.clip();
    }
    if (borderBottomWidth) {
        var _trSlope2 = -borderTopWidth / borderLeftWidth;
        ctx.moveTo(left + width / 2, _trSlope2 * (-width / 2) + top);
        ctx.lineTo(left, top);
        ctx.lineTo(left, top + height);
        ctx.lineTo(left + width, top + height);
        ctx.closePath();
        ctx.clip();
    }
};
var fillBorderLeft = function fillBorderLeft(ctx, layout, style, rbl, rtl) {
    var top = layout.top, left = layout.left, height = layout.height;
    var borderLeftColor = style.borderLeftColor, borderLeftStyle = style.borderLeftStyle, borderLeftWidth = style.borderLeftWidth, borderTopWidth = style.borderTopWidth, borderBottomWidth = style.borderBottomWidth;
    var c0 = rbl * (1.0 - KAPPA);
    var c1 = rtl * (1.0 - KAPPA);
    ctx.moveTo(left + rbl, top + height);
    ctx.bezierCurveTo(left + c0, top + height, left, top + height - c0, left, top + height - rbl);
    ctx.lineTo(left, top + rtl);
    ctx.bezierCurveTo(left, top + c1, left + c1, top, left + rtl, top);
    ctx.strokeColor(borderLeftColor);
    ctx.lineWidth(Math.max(borderLeftWidth, borderTopWidth, borderBottomWidth) * 2);
    if (borderLeftStyle === 'dashed') ctx.dash(borderLeftWidth * 2, {
        space: borderLeftWidth * 1.2
    });
    else if (borderLeftStyle === 'dotted') ctx.dash(borderLeftWidth, {
        space: borderLeftWidth * 1.2
    });
    ctx.stroke();
    ctx.undash();
};
var Borders = {
    drawBorders: drawBorders
};
// This constant is used to approximate a symmetrical arc using a cubic
// Bezier curve.
var KAPPA$1 = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var Clipping = {
    clip: function clip() {
        var _this$getAbsoluteLayo = this.getAbsoluteLayout(), top = _this$getAbsoluteLayo.top, left = _this$getAbsoluteLayo.left, width = _this$getAbsoluteLayo.width, height = _this$getAbsoluteLayo.height;
        var _this$style = this.style, _this$style$borderTop = _this$style.borderTopLeftRadius, borderTopLeftRadius = _this$style$borderTop === void 0 ? 0 : _this$style$borderTop, _this$style$borderTop2 = _this$style.borderTopRightRadius, borderTopRightRadius = _this$style$borderTop2 === void 0 ? 0 : _this$style$borderTop2, _this$style$borderBot = _this$style.borderBottomRightRadius, borderBottomRightRadius = _this$style$borderBot === void 0 ? 0 : _this$style$borderBot, _this$style$borderBot2 = _this$style.borderBottomLeftRadius, borderBottomLeftRadius = _this$style$borderBot2 === void 0 ? 0 : _this$style$borderBot2; // Border top
        var rtr = Math.min(borderTopRightRadius, 0.5 * width, 0.5 * height);
        var ctr = rtr * (1.0 - KAPPA$1);
        this.root.instance.moveTo(left + rtr, top);
        this.root.instance.lineTo(left + width - rtr, top);
        this.root.instance.bezierCurveTo(left + width - ctr, top, left + width, top + ctr, left + width, top + rtr); // Border right
        var rbr = Math.min(borderBottomRightRadius, 0.5 * width, 0.5 * height);
        var cbr = rbr * (1.0 - KAPPA$1);
        this.root.instance.lineTo(left + width, top + height - rbr);
        this.root.instance.bezierCurveTo(left + width, top + height - cbr, left + width - cbr, top + height, left + width - rbr, top + height); // Border bottom
        var rbl = Math.min(borderBottomLeftRadius, 0.5 * width, 0.5 * height);
        var cbl = rbl * (1.0 - KAPPA$1);
        this.root.instance.lineTo(left + rbl, top + height);
        this.root.instance.bezierCurveTo(left + cbl, top + height, left, top + height - cbl, left, top + height - rbl); // Border left
        var rtl = Math.min(borderTopLeftRadius, 0.5 * width, 0.5 * height);
        var ctl = rtl * (1.0 - KAPPA$1);
        this.root.instance.lineTo(left, top + rtl);
        this.root.instance.bezierCurveTo(left, top + ctl, left + ctl, top, left + rtl, top);
        this.root.instance.closePath();
        this.root.instance.clip();
    }
};
var getRotation = function getRotation(transform) {
    var match = /rotate\((-?\d+.?\d+)(.+)\)/g.exec(transform);
    if (match && match[1] && match[2]) {
        var value = match[1];
        return match[2] === 'rad' ? value * 180 / Math.PI : value;
    }
    return 0;
};
var getTranslateX = function getTranslateX(transform) {
    var matchX = /translateX\((-?\d+\.?d*)\)/g.exec(transform);
    var matchGeneric = /translate\((-?\d+\.?d*).*,\s*(-?\d+\.?d*).*\)/g.exec(transform);
    if (matchX && matchX[1]) return matchX[1];
    if (matchGeneric && matchGeneric[1]) return matchGeneric[1];
    return 0;
};
var getTranslateY = function getTranslateY(transform) {
    var matchY = /translateY\((-?\d+\.?\d*)\)/g.exec(transform);
    var matchGeneric = /translate\((-?\d+\.?\d*).*,\s*(-?\d+\.?\d*).*\)/g.exec(transform);
    if (matchY && matchY[1]) return matchY[1];
    if (matchGeneric && matchGeneric[2]) return matchGeneric[2];
    return 0;
};
var getScaleX = function getScaleX(transform) {
    var matchX = /scaleX\((-?\d+\.?\d*)\)/g.exec(transform);
    var matchGeneric = /scale\((-?\d+\.?\d*).*,\s*(-?\d+\.?\d*).*\)/g.exec(transform);
    if (matchX && matchX[1]) return matchX[1];
    if (matchGeneric && matchGeneric[1]) return matchGeneric[1];
    return 1;
};
var getScaleY = function getScaleY(transform) {
    var matchY = /scaleY\((-?\d+\.?\d*)\)/g.exec(transform);
    var matchGeneric = /scale\((-?\d+\.?\d*).*,\s*(-?\d+\.?\d*).*\)/g.exec(transform);
    if (matchY && matchY[1]) return matchY[1];
    if (matchGeneric && matchGeneric[2]) return matchGeneric[2];
    return 1;
};
var getMatrix = function getMatrix(transform) {
    var match = /matrix\(([^,]+),([^,]+),([^,]+),([^,]+),([^,]+),([^,]+)\)/g.exec(transform);
    if (match) return match.slice(1, 7);
    return null;
};
var applySingleTransformation = function applySingleTransformation(element, transform, origin) {
    if (/rotate/g.test(transform)) element.root.instance.rotate(getRotation(transform), {
        origin: origin
    });
    else if (/scaleX/g.test(transform)) element.root.instance.scale(getScaleX(transform), 1, {
        origin: origin
    });
    else if (/scaleY/g.test(transform)) element.root.instance.scale(1, getScaleY(transform), {
        origin: origin
    });
    else if (/scale/g.test(transform)) element.root.instance.scale(getScaleX(transform), getScaleY(transform), {
        origin: origin
    });
    else if (/translateX/g.test(transform)) element.root.instance.translate(getTranslateX(transform), 1, {
        origin: origin
    });
    else if (/translateY/g.test(transform)) element.root.instance.translate(1, getTranslateY(transform), {
        origin: origin
    });
    else if (/translate/g.test(transform)) element.root.instance.translate(getTranslateX(transform), getTranslateY(transform), {
        origin: origin
    });
    else if (/matrix/g.test(transform)) {
        var _element$root$instanc;
        (_element$root$instanc = element.root.instance).transform.apply(_element$root$instanc, getMatrix(transform));
    }
};
var Transformations = {
    applyTransformations: function applyTransformations() {
        var match;
        var re = /[a-zA-Z]+\([^)]+\)/g;
        var origin = this.origin;
        var transform = this.style && this.style.transform || '';
        while((match = re.exec(transform)) != null)applySingleTransformation(this, match[0], origin);
    }
};
var merge = function merge(a, b) {
    return (0, _ramda.isNil)(b) ? a : b;
};
var deepMerge = function deepMerge(objs) {
    return objs.reduce(function(acc, obj) {
        return (0, _ramda.mergeDeepWith)(merge, acc, obj);
    }, {});
};
var isFunction = (0, _ramda.compose)((0, _ramda.equals)('Function'), (0, _ramda.type));
var inheritedProperties = [
    'color',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'letterSpacing',
    'opacity',
    'textDecoration',
    'lineHeight',
    'textAlign',
    'textTransform',
    'visibility',
    'wordSpacing'
];
var Base = /*#__PURE__*/ function(_Node) {
    (0, _inheritsLooseDefault.default)(Base, _Node);
    function Base(root, props) {
        var _this;
        _this = _Node.call(this) || this;
        _this.root = root;
        _this.style = {};
        _this.props = deepMerge([
            _this.constructor.defaultProps,
            Base.defaultProps,
            props
        ]);
        warning(!_this.props.styles, '"styles" prop passed instead of "style" prop');
        return _this;
    }
    var _proto = Base.prototype;
    _proto.appendChild = function appendChild(child) {
        _Node.prototype.appendChild.call(this, child);
        this.root.markDirty();
    };
    _proto.appendChildBefore = function appendChildBefore(child, beforeChild) {
        _Node.prototype.appendChildBefore.call(this, child, beforeChild);
        this.root.markDirty();
    };
    _proto.removeChild = function removeChild(child) {
        _Node.prototype.removeChild.call(this, child);
        this.root.markDirty();
    };
    _proto.update = function update(newProps) {
        this.props = deepMerge([
            this.constructor.defaultProps,
            Base.defaultProps,
            newProps
        ]);
        this.root.markDirty();
    };
    _proto.applyProps = function applyProps() {
        var _this2 = this;
        this.style = this.resolveStyles();
        (0, _ramda.toPairsIn)(this.style).map(function(_ref) {
            var attribute = _ref[0], value = _ref[1];
            _this2.applyStyle(attribute, value);
        });
        this.children.forEach(function(child) {
            if (child.applyProps) child.applyProps();
        });
    };
    _proto.resolveStyles = function resolveStyles() {
        var _this$page = this.page, size = _this$page.size, orientation = _this$page.orientation, isAutoHeight = _this$page.isAutoHeight;
        var container = {
            orientation: orientation,
            isAutoHeight: isAutoHeight,
            width: size.width,
            height: size.height
        };
        var ownStyles = StyleSheet.resolve(this.props.style, container);
        var inheritedStyles = this.parent ? (0, _ramda.pick)(inheritedProperties, this.parent.style) : {};
        return (0, _extendsDefault.default)({}, inheritedStyles, ownStyles);
    };
    _proto.applyStyle = function applyStyle(attribute, value) {
        if (value === undefined) return;
        var setter = "set" + upperFirst(attribute);
        switch(attribute){
            case 'marginTop':
            case 'marginRight':
            case 'marginBottom':
            case 'marginLeft':
            case 'paddingTop':
            case 'paddingRight':
            case 'paddingBottom':
            case 'paddingLeft':
            case 'borderTopWidth':
            case 'borderRightWidth':
            case 'borderBottomWidth':
            case 'borderLeftWidth':
            case 'position':
            case 'top':
            case 'right':
            case 'bottom':
            case 'left':
            case 'width':
            case 'height':
            case 'minHeight':
            case 'maxHeight':
            case 'minWidth':
            case 'maxWidth':
                this[attribute] = value;
                break;
            default:
                if (isFunction(this.layout[setter])) this.layout[setter](value);
        }
    };
    _proto.getLayoutData = function getLayoutData() {
        var layout = this.getAbsoluteLayout();
        return {
            type: this.name,
            top: layout.top,
            left: layout.left,
            width: layout.width,
            style: this.style,
            height: layout.height,
            children: this.children.map(function(c) {
                return c.getLayoutData();
            })
        };
    };
    _proto.drawBackgroundColor = function drawBackgroundColor() {
        var _this$style = this.style, backgroundColor = _this$style.backgroundColor, _this$style$opacity = _this$style.opacity, opacity = _this$style$opacity === void 0 ? 1 : _this$style$opacity;
        var _this$getAbsoluteLayo = this.getAbsoluteLayout(), left = _this$getAbsoluteLayo.left, top = _this$getAbsoluteLayo.top, width = _this$getAbsoluteLayo.width, height = _this$getAbsoluteLayo.height;
        if (backgroundColor) {
            this.root.instance.save();
            this.clip();
            this.root.instance.fillOpacity(opacity).fillColor(backgroundColor).rect(left, top, width, height).fill().restore();
        }
    };
    _proto.clone = function clone() {
        var clone = new this.constructor(this.root, this.props);
        clone.copyStyle(this);
        clone.style = this.style;
        return clone;
    };
    _proto.onNodeSplit = function onNodeSplit(height, clone) {
        this.calculateLayout();
        clone.marginTop = 0;
        clone.paddingTop = 0; // If a height was given to the element, we need to substract the remaining wrapping height
        // If not, we just let Yoga calculate the appropiate height when layout get's calculated.
        if (clone.style.height) clone.height = this.height - height;
        this.height = height;
        this.marginBottom = 0;
        this.paddingBottom = 0;
    };
    _proto.renderChildren = /*#__PURE__*/ function() {
        var _renderChildren = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            var i;
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        i = 0;
                    case 1:
                        if (!(i < this.children.length)) {
                            _context.next = 7;
                            break;
                        }
                        _context.next = 4;
                        return this.children[i].render();
                    case 4:
                        i++;
                        _context.next = 1;
                        break;
                    case 7:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function renderChildren() {
            return _renderChildren.apply(this, arguments);
        }
        return renderChildren;
    }();
    (0, _createClassDefault.default)(Base, [
        {
            key: "page",
            get: function get() {
                return this.parent.page;
            }
        },
        {
            key: "wrap",
            get: function get() {
                return this.props.wrap;
            }
        },
        {
            key: "break",
            get: function get() {
                return this.props.break;
            },
            set: function set(value) {
                this.props.break = value;
            }
        },
        {
            key: "fixed",
            get: function get() {
                return this.props.fixed;
            }
        },
        {
            key: "minPresenceAhead",
            get: function get() {
                return this.props.minPresenceAhead;
            }
        },
        {
            key: "absolute",
            get: function get() {
                return this.props.style.position === 'absolute';
            }
        },
        {
            key: "origin",
            get: function get() {
                var _this$style2 = this.style, transformOriginX = _this$style2.transformOriginX, transformOriginY = _this$style2.transformOriginY;
                var _this$getAbsoluteLayo2 = this.getAbsoluteLayout(), left = _this$getAbsoluteLayo2.left, top = _this$getAbsoluteLayo2.top, width = _this$getAbsoluteLayo2.width, height = _this$getAbsoluteLayo2.height;
                var percentX = matchPercent(transformOriginX);
                var percentY = matchPercent(transformOriginY);
                var offsetX = percentX ? width * percentX.percent : transformOriginX;
                var offsetY = percentY ? height * percentY.percent : transformOriginY;
                return [
                    left + offsetX,
                    top + offsetY
                ];
            }
        }
    ]);
    return Base;
}(Node);
Base.defaultProps = {
    style: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        transformOriginX: '50%',
        transformOriginY: '50%'
    },
    minPresenceAhead: 0
};
Object.assign(Base.prototype, Debug);
Object.assign(Base.prototype, Borders);
Object.assign(Base.prototype, Clipping);
Object.assign(Base.prototype, Transformations);
var RULER_WIDTH = 13;
var RULER_COLOR = 'white';
var RULER_FONT_SIZE = 5;
var DEFAULT_RULER_STEPS = 50;
var LINE_WIDTH = 0.5;
var LINE_COLOR = 'gray';
var GRID_COLOR = '#ababab';
var range = function range(max, steps) {
    return Array.from({
        length: Math.ceil(max / steps)
    }, function(_, i) {
        return i * steps;
    });
};
var matchPercentage = function matchPercentage(value) {
    var match = matchPercent(value);
    return match ? 100 / match.value : null;
};
var Ruler = {
    getRulerWidth: function getRulerWidth() {
        return RULER_WIDTH;
    },
    hasHorizontalRuler: function hasHorizontalRuler() {
        return this.props.ruler || this.props.horizontalRuler;
    },
    hasVerticalRuler: function hasVerticalRuler() {
        return this.props.ruler || this.props.verticalRuler;
    },
    getHorizontalSteps: function getHorizontalSteps() {
        var value = this.props.horizontalRulerSteps || this.props.rulerSteps || DEFAULT_RULER_STEPS;
        if (typeof value === 'string') {
            var percentage = matchPercentage(value);
            if (percentage) {
                var width = this.width - (this.hasVerticalRuler() ? RULER_WIDTH : 0);
                return width / percentage;
            }
            throw new Error('Page: Invalid horizontal steps value');
        }
        return value;
    },
    getVerticalSteps: function getVerticalSteps() {
        var value = this.props.verticalRulerSteps || this.props.rulerSteps || DEFAULT_RULER_STEPS;
        if (typeof value === 'string') {
            var percentage = matchPercentage(value);
            if (percentage) {
                var height = this.height - (this.hasHorizontalRuler() ? RULER_WIDTH : 0);
                return height / percentage;
            }
            throw new Error('Page: Invalid horizontal steps value');
        }
        return value;
    },
    renderRuler: function renderRuler() {
        var hasHorizontalRuler = this.hasHorizontalRuler();
        var hasVerticalRuler = this.hasVerticalRuler();
        if (hasHorizontalRuler || hasVerticalRuler) {
            this.root.instance.save().lineWidth(LINE_WIDTH).fontSize(RULER_FONT_SIZE).opacity(1);
            if (hasHorizontalRuler) this.drawHorizontalRuler();
            if (hasVerticalRuler) this.drawVerticalRuler();
            if (hasHorizontalRuler && hasVerticalRuler) this.root.instance.rect(0, 0, RULER_WIDTH - LINE_WIDTH, RULER_WIDTH - LINE_WIDTH).fill(RULER_COLOR);
            this.root.instance.restore();
        }
    },
    drawHorizontalRuler: function drawHorizontalRuler() {
        var _this = this;
        var offset = this.hasVerticalRuler() ? RULER_WIDTH : 0;
        this.root.instance.rect(offset, 0, this.width, RULER_WIDTH).fill(RULER_COLOR).moveTo(this.hasVerticalRuler() ? RULER_WIDTH : 0, RULER_WIDTH).lineTo(this.width, RULER_WIDTH).stroke(LINE_COLOR);
        var hRange = range(this.width, this.getHorizontalSteps());
        hRange.map(function(step) {
            _this.root.instance.moveTo(offset + step, 0).lineTo(offset + step, RULER_WIDTH).stroke(LINE_COLOR).fillColor('black').text("" + Math.round(step), offset + step + 1, 1);
        });
        hRange.map(function(step) {
            if (step !== 0) _this.root.instance.moveTo(offset + step, RULER_WIDTH).lineTo(offset + step, _this.height).stroke(GRID_COLOR);
        });
    },
    drawVerticalRuler: function drawVerticalRuler() {
        var _this2 = this;
        var offset = this.hasHorizontalRuler() ? RULER_WIDTH : 0;
        this.root.instance.rect(0, offset, RULER_WIDTH, this.height).fill(RULER_COLOR).moveTo(RULER_WIDTH, this.hasHorizontalRuler() ? RULER_WIDTH : 0).lineTo(RULER_WIDTH, this.height).stroke(LINE_COLOR);
        var vRange = range(this.height, this.getVerticalSteps());
        vRange.map(function(step) {
            _this2.root.instance.moveTo(0, offset + step).lineTo(RULER_WIDTH, offset + step).stroke(LINE_COLOR).fillColor('black').text("" + Math.round(step), 1, offset + step + 1);
        });
        vRange.map(function(step) {
            if (step !== 0) _this2.root.instance.moveTo(RULER_WIDTH, offset + step).lineTo(_this2.width, offset + step).stroke(GRID_COLOR);
        });
    }
};
var TextInstance = /*#__PURE__*/ function() {
    function TextInstance(root, value) {
        this.root = root;
        this.value = value;
        this.parent = null;
        this.props = {};
    }
    var _proto = TextInstance.prototype;
    _proto.getLayoutData = function getLayoutData() {
        return this.value;
    };
    _proto.remove = function remove() {
        this.parent.removeChild(this);
    };
    _proto.clone = function clone() {
        return new this.constructor(this.root, this.value);
    };
    _proto.cleanup = function cleanup() {};
    _proto.update = function update(value) {
        this.value = value;
        this.parent.computed = false;
        this.parent.container = null;
        this.root.markDirty();
    };
    (0, _createClassDefault.default)(TextInstance, [
        {
            key: "name",
            get: function get() {
                return 'TextInstance';
            }
        }
    ]);
    return TextInstance;
}();
var PAGE_SIZES = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ],
    ID1: [
        153,
        243
    ]
}; // Return page size in an object { width, height } given the passed size and orientation
// Accepts page type string, number, array or object as parameter
var getPageSize = function getPageSize(size, orientation) {
    if (orientation === void 0) orientation = 'portrait';
    var result;
    if (typeof size === 'string') result = PAGE_SIZES[size.toUpperCase()];
    else if (Array.isArray(size)) result = size;
    else if (typeof size === 'number') result = [
        size
    ];
    else if (typeof size === 'object' && size.width) result = [
        size.width,
        size.height
    ];
    else throw new Error("Invalid Page size: " + size);
    return orientation === 'portrait' ? {
        width: result[0],
        height: result[1]
    } : {
        width: result[1],
        height: result[0]
    };
};
var PROTOCOL_REGEXP = /^([a-z]+\:(\/\/)?)/i;
var DEST_REGEXP = /^#.+/;
var getURL = function getURL(value) {
    if (!value) return '';
    if (isSrcId(value)) return value; // don't modify it if it is an id
    if (typeof value === 'string' && !value.match(PROTOCOL_REGEXP)) return "http://" + value;
    return value;
};
var isSrcId = function isSrcId(src) {
    return src.match(DEST_REGEXP);
};
var setLink = function setLink(node) {
    if (!node.src) return;
    var _node$getAbsoluteLayo = node.getAbsoluteLayout(), top = _node$getAbsoluteLayo.top, left = _node$getAbsoluteLayo.left, width = _node$getAbsoluteLayo.width, height = _node$getAbsoluteLayo.height;
    var instanceMethod = isSrcId(node.src) ? 'goTo' : 'link';
    var nodeSrc = isSrcId(node.src) ? node.src.slice(1) : node.src;
    node.root.instance[instanceMethod](left, top, width, height, nodeSrc);
};
var setDestination = function setDestination(node) {
    if (!node.props.id) return;
    var _node$getAbsoluteLayo2 = node.getAbsoluteLayout(), top = _node$getAbsoluteLayo2.top;
    node.root.instance.addNamedDestination(node.props.id, 'XYZ', null, top, null);
};
var Page = /*#__PURE__*/ function(_Base) {
    (0, _inheritsLooseDefault.default)(Page, _Base);
    function Page(root, props) {
        var _this;
        _this = _Base.call(this, root, props) || this;
        _this._size = null;
        return _this;
    }
    var _proto = Page.prototype;
    _proto.resetMargins = function resetMargins() {
        if (!!this.marginTop || !!this.marginBottom || !!this.marginLeft || !!this.marginRight) {
            warning(false, 'Margin values are not allowed on Page element. Use padding instead.');
            this.marginTop = 0;
            this.marginBottom = 0;
            this.marginLeft = 0;
            this.marginRight = 0;
        }
    };
    _proto.applyProps = function applyProps() {
        _Base.prototype.applyProps.call(this);
        this.top = 0;
        this.left = 0;
        this.width = this.size.width;
        this.resetMargins(); // Add some padding if ruler present, so we can see the whole page inside it
        var rulerWidth = this.getRulerWidth();
        if (this.hasHorizontalRuler()) this.paddingTop = this.paddingTop + rulerWidth;
        if (this.hasVerticalRuler()) this.paddingLeft = this.paddingLeft + rulerWidth;
    };
    _proto.setPadding = function setPadding(edge, value) {
        var dimension = edge === (0, _yogaDefault.default).EDGE_TOP || edge === (0, _yogaDefault.default).EDGE_BOTTOM ? this.size.height : this.size.width;
        var match = matchPercent(value);
        if (match) this.layout.setPadding(edge, dimension * match.percent);
        else this.layout.setPadding(edge, value);
    };
    _proto.addDynamicChild = /*#__PURE__*/ function() {
        var _addDynamicChild = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee(parent, elements) {
            var children, i, child, type, props, instance, _instance;
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (elements) {
                            _context.next = 2;
                            break;
                        }
                        return _context.abrupt("return");
                    case 2:
                        children = Array.isArray(elements) ? elements : [
                            elements
                        ];
                        i = 0;
                    case 4:
                        if (!(i < children.length)) {
                            _context.next = 29;
                            break;
                        }
                        child = children[i];
                        if (child) {
                            _context.next = 8;
                            break;
                        }
                        return _context.abrupt("continue", 26);
                    case 8:
                        type = child.type, props = child.props;
                        if (!(typeof child === 'string')) {
                            _context.next = 14;
                            break;
                        }
                        instance = new TextInstance(this.root, child);
                        parent.appendChild(instance);
                        _context.next = 26;
                        break;
                    case 14:
                        if (!(type !== (0, _react.Fragment))) {
                            _context.next = 24;
                            break;
                        }
                        _instance = createInstance(child, this.root);
                        _context.next = 18;
                        return _instance.onAppendDynamically();
                    case 18:
                        parent.appendChild(_instance);
                        _instance.applyProps();
                        _context.next = 22;
                        return this.addDynamicChild(_instance, props.children);
                    case 22:
                        _context.next = 26;
                        break;
                    case 24:
                        _context.next = 26;
                        return this.addDynamicChild(parent, props.children);
                    case 26:
                        i++;
                        _context.next = 4;
                        break;
                    case 29:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function addDynamicChild(_x, _x2) {
            return _addDynamicChild.apply(this, arguments);
        }
        return addDynamicChild;
    }();
    _proto.renderDynamicNodes = /*#__PURE__*/ function() {
        var _renderDynamicNodes = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee2(props, cb) {
            var listToExplore, node, condition, elements;
            return (0, _regeneratorDefault.default).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        listToExplore = this.children.slice(0);
                    case 1:
                        if (!(listToExplore.length > 0)) {
                            _context2.next = 14;
                            break;
                        }
                        node = listToExplore.shift();
                        condition = cb ? cb(node) : true;
                        if (!(condition && node.props.render)) {
                            _context2.next = 11;
                            break;
                        }
                        node.removeAllChilds();
                        elements = node.props.render(props);
                        _context2.next = 9;
                        return this.addDynamicChild(node, elements);
                    case 9:
                        if (!node.fixed) node.props.render = null;
                        return _context2.abrupt("continue", 1);
                    case 11:
                        if (node.children) listToExplore.push.apply(listToExplore, node.children);
                        _context2.next = 1;
                        break;
                    case 14:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function renderDynamicNodes(_x3, _x4) {
            return _renderDynamicNodes.apply(this, arguments);
        }
        return renderDynamicNodes;
    }();
    _proto.nodeWillWrap = /*#__PURE__*/ function() {
        var _nodeWillWrap = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee3(props) {
            return (0, _regeneratorDefault.default).wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return this.renderDynamicNodes(props);
                    case 2:
                        this.calculateLayout();
                    case 3:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function nodeWillWrap(_x5) {
            return _nodeWillWrap.apply(this, arguments);
        }
        return nodeWillWrap;
    }();
    _proto.onNodeSplit = function onNodeSplit(height, clone) {
        clone.marginTop = 0;
        this.marginBottom = 0;
        this.calculateLayout();
    };
    _proto.clone = function clone() {
        var clone = _Base.prototype.clone.call(this);
        clone._size = this.size;
        return clone;
    };
    _proto.update = function update(newProps) {
        _Base.prototype.update.call(this, newProps);
        this._size = null;
    };
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee4() {
            var instance, height;
            return (0, _regeneratorDefault.default).wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        instance = this.root.instance;
                        if (!this.isAutoHeight) this.height = this.size.height;
                        this.calculateLayout();
                        height = this.isAutoHeight ? this.height : this.size.height;
                        instance.addPage({
                            size: [
                                this.size.width,
                                height
                            ],
                            margin: 0
                        });
                        setDestination(this);
                        if (this.style.backgroundColor) instance.fillColor(this.style.backgroundColor).rect(0, 0, this.size.width, height).fill();
                        _context4.next = 9;
                        return this.renderChildren();
                    case 9:
                        if (this.props.debug) this.debug();
                        this.renderRuler();
                    case 11:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Page, [
        {
            key: "name",
            get: function get() {
                return 'Page';
            }
        },
        {
            key: "document",
            get: function get() {
                return this.parent;
            }
        },
        {
            key: "page",
            get: function get() {
                return this;
            }
        },
        {
            key: "orientation",
            get: function get() {
                return this.props.orientation;
            }
        },
        {
            key: "size",
            get: function get() {
                if (this._size) return this._size;
                this._size = getPageSize(this.props.size, this.orientation); // Adjust size for ruler
                if (this.hasHorizontalRuler()) this._size.width += this.getRulerWidth();
                if (this.hasVerticalRuler()) this._size.height += this.getRulerWidth();
                return this._size;
            }
        },
        {
            key: "isAutoHeight",
            get: function get() {
                return typeof this.size.height === 'undefined';
            }
        }
    ]);
    return Page;
}(Base);
Page.defaultProps = {
    size: 'A4',
    wrap: true,
    orientation: 'portrait'
};
Object.assign(Page.prototype, Ruler);
var View = /*#__PURE__*/ function(_Base) {
    (0, _inheritsLooseDefault.default)(View, _Base);
    function View() {
        return _Base.apply(this, arguments) || this;
    }
    var _proto = View.prototype;
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        this.root.instance.save();
                        this.applyTransformations();
                        this.drawBackgroundColor();
                        if (this.style.overflow === 'hidden') this.clip();
                        _context.next = 6;
                        return this.renderChildren();
                    case 6:
                        this.drawBorders();
                        setDestination(this);
                        if (this.props.debug) this.debug();
                        this.root.instance.restore();
                    case 10:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(View, [
        {
            key: "name",
            get: function get() {
                return 'View';
            }
        }
    ]);
    return View;
}(Base);
View.defaultProps = {
    wrap: true
};
var fetchFont = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee(src, options) {
        var response, buffer;
        return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, _crossFetchDefault.default)(src, options);
                case 2:
                    response = _context.sent;
                    _context.next = 5;
                    return response.buffer ? response.buffer() : response.arrayBuffer();
                case 5:
                    buffer = _context.sent;
                    return _context.abrupt("return", buffer.constructor.name === 'Buffer' ? buffer : Buffer.from(buffer));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchFont(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var isDataUrl = function isDataUrl(dataUrl) {
    var header = dataUrl.split(',')[0];
    return header.substring(0, 5) === 'data:' && header.split(';')[1] === 'base64';
};
var FontSource = /*#__PURE__*/ function() {
    function FontSource(src, fontFamily, fontStyle, fontWeight, options) {
        this.src = src;
        this.fontFamily = fontFamily;
        this.fontStyle = fontStyle || 'normal';
        this.fontWeight = processFontWeight(fontWeight) || 400;
        this.data = null;
        this.loading = false;
        this.options = options;
    }
    var _proto = FontSource.prototype;
    _proto.load = /*#__PURE__*/ function() {
        var _load = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee2() {
            var _this = this;
            var postscriptName, _this$options, headers, body, _this$options$method, method, data;
            return (0, _regeneratorDefault.default).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        this.loading = true;
                        postscriptName = this.options.postscriptName;
                        if (!isDataUrl(this.src)) {
                            _context2.next = 6;
                            break;
                        }
                        this.data = (0, _fontkitDefault.default).create(Buffer.from(this.src.split(',')[1], 'base64'), postscriptName);
                        _context2.next = 17;
                        break;
                    case 6:
                        _this$options = this.options, headers = _this$options.headers, body = _this$options.body, _this$options$method = _this$options.method, method = _this$options$method === void 0 ? 'GET' : _this$options$method;
                        _context2.next = 10;
                        return fetchFont(this.src, {
                            method: method,
                            body: body,
                            headers: headers
                        });
                    case 10:
                        data = _context2.sent;
                        this.data = (0, _fontkitDefault.default).create(data, postscriptName);
                        _context2.next = 17;
                        break;
                    case 14:
                        _context2.next = 16;
                        return new Promise(function(resolve, reject) {
                            return (0, _fontkitDefault.default).open(_this.src, postscriptName, function(err, data) {
                                return err ? reject(err) : resolve(data);
                            });
                        });
                    case 16:
                        this.data = _context2.sent;
                    case 17:
                        this.loading = false;
                    case 18:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function load() {
            return _load.apply(this, arguments);
        }
        return load;
    }();
    return FontSource;
}();
var Font = /*#__PURE__*/ function() {
    Font.create = function create(family) {
        return new Font(family);
    };
    function Font(family) {
        this.family = family;
        this.sources = [];
    }
    var _proto2 = Font.prototype;
    _proto2.register = function register(_ref2) {
        var src = _ref2.src, fontWeight = _ref2.fontWeight, fontStyle = _ref2.fontStyle, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref2, [
            "src",
            "fontWeight",
            "fontStyle"
        ]);
        this.sources.push(new FontSource(src, this.fontFamily, fontStyle, fontWeight, options));
    };
    _proto2.resolve = function resolve(descriptor) {
        var _descriptor$fontWeigh = descriptor.fontWeight, fontWeight = _descriptor$fontWeigh === void 0 ? 400 : _descriptor$fontWeigh, _descriptor$fontStyle = descriptor.fontStyle, fontStyle = _descriptor$fontStyle === void 0 ? 'normal' : _descriptor$fontStyle;
        var styleSources = this.sources.filter(function(s) {
            return s.fontStyle === fontStyle;
        }); // Weight resolution. https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#Fallback_weights
        var exactFit = styleSources.find(function(s) {
            return s.fontWeight === fontWeight;
        });
        if (exactFit) return exactFit;
        var res;
        if (fontWeight >= 400 && fontWeight <= 500) {
            var leftOffset = styleSources.filter(function(s) {
                return s.fontWeight <= fontWeight;
            });
            var rightOffset = styleSources.filter(function(s) {
                return s.fontWeight > 500;
            });
            var fit = styleSources.filter(function(s) {
                return s.fontWeight >= fontWeight && s.fontWeight < 500;
            });
            res = fit[0] || leftOffset[leftOffset.length - 1] || rightOffset[0];
        }
        var lt = styleSources.filter(function(s) {
            return s.fontWeight < fontWeight;
        });
        var gt = styleSources.filter(function(s) {
            return s.fontWeight > fontWeight;
        });
        if (fontWeight < 400) res = lt[lt.length - 1] || gt[0];
        if (fontWeight > 500) res = gt[0] || lt[lt.length - 1];
        if (!res) throw new Error("Could not resolve font for " + this.fontFamily + ", fontWeight " + fontWeight);
        return res;
    };
    return Font;
}();
var emojiSource;
var registerEmojiSource = function registerEmojiSource(_ref) {
    var url = _ref.url, _ref$format = _ref.format, format = _ref$format === void 0 ? 'png' : _ref$format;
    emojiSource = {
        url: url,
        format: format
    };
};
var getEmojiSource = function getEmojiSource() {
    return emojiSource;
};
var emoji = {
    registerEmojiSource: registerEmojiSource,
    getEmojiSource: getEmojiSource
};
var standardFonts = [
    'Courier',
    'Courier-Bold',
    'Courier-Oblique',
    'Helvetica',
    'Helvetica-Bold',
    'Helvetica-Oblique',
    'Times-Roman',
    'Times-Bold',
    'Times-Italic'
];
var hyphenationCallback;
var registerHyphenationCallback = function registerHyphenationCallback(callback) {
    hyphenationCallback = callback;
};
var getHyphenationCallback = function getHyphenationCallback() {
    return hyphenationCallback;
};
var hyphenation = {
    registerHyphenationCallback: registerHyphenationCallback,
    getHyphenationCallback: getHyphenationCallback
};
var fonts = {};
var register = function register(src, data) {
    if (typeof src === 'object') data = src;
    else {
        warning(false, 'Font.register will not longer accept the font source as first argument. Please move it into the data object. For more info refer to https://react-pdf.org/fonts');
        data.src = src;
    }
    var _data = data, family = _data.family;
    if (!fonts[family]) fonts[family] = Font.create(family);
     // Bulk loading
    if (data.fonts) for(var i = 0; i < data.fonts.length; i++)fonts[family].register((0, _extendsDefault.default)({
        family: family
    }, data.fonts[i]));
    else fonts[family].register(data);
};
var getRegisteredFonts = function getRegisteredFonts() {
    return fonts;
};
var getRegisteredFontFamilies = function getRegisteredFontFamilies() {
    return Object.keys(fonts);
};
var getFont = function getFont(descriptor) {
    var fontFamily = descriptor.fontFamily;
    var isStandard = standardFonts.includes(fontFamily);
    if (isStandard) return null;
    if (!fonts[fontFamily]) throw new Error("Font family not registered: " + fontFamily + ". Please register it calling Font.register() method.");
    return fonts[fontFamily].resolve(descriptor);
};
var load = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee(descriptor, doc) {
        var fontFamily, isStandard, font;
        return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    fontFamily = descriptor.fontFamily;
                    isStandard = standardFonts.includes(fontFamily);
                    if (!isStandard) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    font = getFont(descriptor); // We cache the font to avoid fetching it many times
                    if (!(!font.data && !font.loading)) {
                        _context.next = 8;
                        break;
                    }
                    _context.next = 8;
                    return font.load();
                case 8:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function load(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var reset = function reset() {
    for(var _font in fonts)if (fonts.hasOwnProperty(_font)) fonts[_font].data = null;
};
var clear = function clear() {
    fonts = {};
};
var Font$1 = (0, _extendsDefault.default)({
    register: register,
    getRegisteredFonts: getRegisteredFonts,
    getRegisteredFontFamilies: getRegisteredFontFamilies,
    getFont: getFont,
    load: load,
    clear: clear,
    reset: reset
}, emoji, hyphenation);
var StandardFont = /*#__PURE__*/ function() {
    function StandardFont(src) {
        this.name = src;
        this.src = (0, _pdfkit.PDFFont).open(null, src);
    }
    var _proto = StandardFont.prototype;
    _proto.layout = function layout(str) {
        var _this = this;
        var _this$src$encode = this.src.encode(str), encoded = _this$src$encode[0], positions = _this$src$encode[1];
        return {
            positions: positions,
            stringIndices: positions.map(function(_, i) {
                return i;
            }),
            glyphs: encoded.map(function(g, i) {
                var glyph = _this.getGlyph(parseInt(g, 16));
                glyph.advanceWidth = positions[i].advanceWidth;
                return glyph;
            })
        };
    };
    _proto.glyphForCodePoint = function glyphForCodePoint(codePoint) {
        var glyph = this.getGlyph(codePoint);
        glyph.advanceWidth = 400;
        return glyph;
    };
    _proto.getGlyph = function getGlyph(id) {
        return {
            id: id,
            _font: this.src,
            codePoints: [
                id
            ],
            isLigature: false,
            name: this.src.font.characterToGlyph(id)
        };
    };
    _proto.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
        return this.src.font.characterToGlyph(codePoint) !== '.notdef';
    } // Based on empirical observation
    ;
    (0, _createClassDefault.default)(StandardFont, [
        {
            key: "ascent",
            get: function get() {
                return 900;
            } // Based on empirical observation
        },
        {
            key: "descent",
            get: function get() {
                switch(this.name){
                    case 'Times-Roman':
                    case 'Times-Bold':
                    case 'Times-Italic':
                        return -220;
                    case 'Courier':
                    case 'Courier-Bold':
                    case 'Courier-Oblique':
                        return -230;
                    default:
                        return -200;
                }
            }
        },
        {
            key: "lineGap",
            get: function get() {
                return 0;
            }
        },
        {
            key: "unitsPerEm",
            get: function get() {
                return 1000;
            }
        }
    ]);
    return StandardFont;
}();
var fontCache = {};
var IGNORED_CODE_POINTS = [
    173
];
var getFontSize = (0, _ramda.pathOr)(12, [
    'attributes',
    'fontSize'
]);
var getFallbackFont = function getFallbackFont() {
    return getOrCreateFont('Helvetica');
};
var getOrCreateFont = function getOrCreateFont(name) {
    if (fontCache[name]) return fontCache[name];
    var font = new StandardFont(name);
    fontCache[name] = font;
    return font;
};
var shouldFallbackToFont = function shouldFallbackToFont(codePoint, font) {
    return !IGNORED_CODE_POINTS.includes(codePoint) && !font.hasGlyphForCodePoint(codePoint) && getFallbackFont().hasGlyphForCodePoint(codePoint);
};
var fontSubstitution = function fontSubstitution() {
    return function(_ref) {
        var string = _ref.string, runs = _ref.runs;
        var lastFont = null;
        var lastFontSize = null;
        var lastIndex = 0;
        var index = 0;
        var res = [];
        for(var _iterator = runs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref2;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref2 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref2 = _i.value;
            }
            var run = _ref2;
            var defaultFont = typeof run.attributes.font === 'string' ? getOrCreateFont(run.attributes.font) : run.attributes.font;
            if (string.length === 0) {
                res.push({
                    start: 0,
                    end: 0,
                    attributes: {
                        font: defaultFont
                    }
                });
                break;
            }
            for(var _iterator2 = string.slice(run.start, run.end), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                var _ref3;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref3 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref3 = _i2.value;
                }
                var char = _ref3;
                var codePoint = char.codePointAt();
                var shouldFallback = shouldFallbackToFont(codePoint, defaultFont); // If the default font does not have a glyph and the fallback font does, we use it
                var font = shouldFallback ? getFallbackFont() : defaultFont;
                var _fontSize = getFontSize(run); // If anything that would impact res has changed, update it
                if (font !== lastFont || _fontSize !== lastFontSize || font.unitsPerEm !== lastFont.unitsPerEm) {
                    if (lastFont) res.push({
                        start: lastIndex,
                        end: index,
                        attributes: {
                            font: lastFont,
                            scale: lastFontSize / lastFont.unitsPerEm
                        }
                    });
                    lastFont = font;
                    lastFontSize = _fontSize;
                    lastIndex = index;
                }
                index += char.length;
            }
        }
        if (lastIndex < string.length) {
            var fontSize = getFontSize((0, _ramda.last)(runs));
            res.push({
                start: lastIndex,
                end: string.length,
                attributes: {
                    font: lastFont,
                    scale: fontSize / lastFont.unitsPerEm
                }
            });
        }
        return {
            string: string,
            runs: res
        };
    };
};
var engines = {
    linebreaker: (0, _linebreakerDefault.default),
    justification: (0, _justificationDefault.default),
    textDecoration: (0, _textDecorationDefault.default),
    scriptItemizer: (0, _scriptItemizerDefault.default),
    wordHyphenation: (0, _wordHyphenationDefault.default),
    fontSubstitution: fontSubstitution
};
var engine = (0, _layoutDefault.default)(engines);
var fs = {};
(0, _pngJsDefault.default).isValid = function(data) {
    try {
        return new (0, _pngJsDefault.default)(data), true;
    } catch (e) {
        return false;
    }
};
// Extracted from https://github.com/devongovett/pdfkit/blob/master/lib/image/jpeg.coffee
var MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var JPEG = function JPEG(data) {
    this.data = null;
    this.width = null;
    this.height = null;
    this.data = data;
    if (data.readUInt16BE(0) !== 0xffd8) throw new Error('SOI not found in JPEG');
    var marker;
    var pos = 2;
    while(pos < data.length){
        marker = data.readUInt16BE(pos);
        pos += 2;
        if (MARKERS.includes(marker)) break;
        pos += data.readUInt16BE(pos);
    }
    if (!MARKERS.includes(marker)) throw new Error('Invalid JPEG.');
    pos += 3;
    this.height = data.readUInt16BE(pos);
    pos += 2;
    this.width = data.readUInt16BE(pos);
};
JPEG.isValid = function(data) {
    if (!data || !Buffer.isBuffer(data) || data.readUInt16BE(0) !== 0xffd8) return false;
    var marker;
    var pos = 2;
    while(pos < data.length){
        marker = data.readUInt16BE(pos);
        pos += 2;
        if (MARKERS.includes(marker)) break;
        pos += data.readUInt16BE(pos);
    }
    if (!MARKERS.includes(marker)) return false;
    return true;
};
var createCache = function createCache(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$limit = _ref.limit, limit = _ref$limit === void 0 ? 100 : _ref$limit;
    var cache = {};
    var keys = [];
    return {
        get: function get(key) {
            return cache[key];
        },
        set: function set(key, value) {
            keys.push(key);
            if (keys.length > limit) delete cache[keys.shift()];
            cache[key] = value;
        },
        reset: function reset() {
            cache = {};
            keys = [];
        },
        length: function length() {
            return keys.length;
        }
    };
};
var IMAGE_CACHE = createCache({
    limit: 30
});
var getAbsoluteLocalPath = function getAbsoluteLocalPath(src) {
    var _url$parse, protocol, auth, host, port, hostname, pathname, absolutePath;
    throw new Error('Cannot check local paths in client-side environment');
};
var isDangerousLocalPath = function isDangerousLocalPath(filename, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$safePath = _ref.safePath, safePath = _ref$safePath === void 0 ? './public' : _ref$safePath;
    var absoluteSafePath, absoluteFilePath;
    throw new Error('Cannot check dangerous local path in client-side environemnt');
};
var fetchLocalFile = function fetchLocalFile(src, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, safePath = _ref2.safePath, _ref2$allowDangerousP = _ref2.allowDangerousPaths, allowDangerousPaths = _ref2$allowDangerousP === void 0 ? false : _ref2$allowDangerousP;
    return new Promise(function(resolve, reject) {
        try {
            var absolutePath;
            return reject(new Error('Cannot fetch local file in this environemnt'));
        } catch (err) {
            reject(err);
        }
    });
};
var fetchRemoteFile = /*#__PURE__*/ function() {
    var _ref3 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee(uri, options) {
        var response, buffer;
        return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return (0, _crossFetchDefault.default)(uri, options);
                case 2:
                    response = _context.sent;
                    _context.next = 5;
                    return response.buffer ? response.buffer() : response.arrayBuffer();
                case 5:
                    buffer = _context.sent;
                    return _context.abrupt("return", buffer.constructor.name === 'Buffer' ? buffer : Buffer.from(buffer));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function fetchRemoteFile(_x, _x2) {
        return _ref3.apply(this, arguments);
    };
}();
var isValidFormat = function isValidFormat(format) {
    var lower = format.toLowerCase();
    return lower === 'jpg' || lower === 'jpeg' || lower === 'png';
};
var guessFormat = function guessFormat(buffer) {
    var format;
    if (JPEG.isValid(buffer)) format = 'jpg';
    else if ((0, _pngJsDefault.default).isValid(buffer)) format = 'png';
    return format;
};
var isCompatibleBase64 = function isCompatibleBase64(_ref4) {
    var uri = _ref4.uri;
    return /^data:image\/[a-zA-Z]*;base64,[^"]*/g.test(uri);
};
function getImage(body, extension) {
    switch(extension.toLowerCase()){
        case 'jpg':
        case 'jpeg':
            return new JPEG(body);
        case 'png':
            return new (0, _pngJsDefault.default)(body);
        default:
            return null;
    }
}
var resolveBase64Image = function resolveBase64Image(_ref5) {
    var uri = _ref5.uri;
    var match = /^data:image\/([a-zA-Z]*);base64,([^"]*)/g.exec(uri);
    var format = match[1];
    var data = match[2];
    if (!isValidFormat(format)) throw new Error("Base64 image invalid format: " + format);
    return new Promise(function(resolve) {
        return resolve(getImage(Buffer.from(data, 'base64'), format));
    });
};
var resolveImageFromData = function resolveImageFromData(src) {
    if (src.data && src.format) return new Promise(function(resolve) {
        return resolve(getImage(src.data, src.format));
    });
    throw new Error("Invalid data given for local file: " + JSON.stringify(src));
};
var resolveBufferImage = function resolveBufferImage(buffer) {
    var format = guessFormat(buffer);
    if (format) return new Promise(function(resolve) {
        return resolve(getImage(buffer, format));
    });
};
var getImageFormat = function getImageFormat(body) {
    var isPng = body[0] === 137 && body[1] === 80 && body[2] === 78 && body[3] === 71 && body[4] === 13 && body[5] === 10 && body[6] === 26 && body[7] === 10;
    var isJpg = body[0] === 255 && body[1] === 216 && body[2] === 255;
    var extension = '';
    if (isPng) extension = 'png';
    else if (isJpg) extension = 'jpg';
    else throw new Error('Not valid image extension');
    return extension;
};
var resolveImageFromUrl = /*#__PURE__*/ function() {
    var _ref6 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee2(src, options) {
        var uri, body, headers, _src$method, method, data, extension;
        return (0, _regeneratorDefault.default).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    uri = src.uri, body = src.body, headers = src.headers, _src$method = src.method, method = _src$method === void 0 ? 'GET' : _src$method;
                    _context2.next = 7;
                    break;
                case 4:
                    _context2.t0 = _context2.sent;
                    _context2.next = 10;
                    break;
                case 7:
                    _context2.next = 9;
                    return fetchRemoteFile(uri, {
                        body: body,
                        headers: headers,
                        method: method
                    });
                case 9:
                    _context2.t0 = _context2.sent;
                case 10:
                    data = _context2.t0;
                    extension = getImageFormat(data);
                    return _context2.abrupt("return", getImage(data, extension));
                case 13:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function resolveImageFromUrl(_x3, _x4) {
        return _ref6.apply(this, arguments);
    };
}();
var resolveImage = function resolveImage(src, _temp3) {
    var _ref7 = _temp3 === void 0 ? {} : _temp3, _ref7$cache = _ref7.cache, cache = _ref7$cache === void 0 ? true : _ref7$cache, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref7, [
        "cache"
    ]);
    var cacheKey = src.data ? src.data.toString() : src.uri;
    if (cache && IMAGE_CACHE.get(cacheKey)) return IMAGE_CACHE.get(cacheKey);
    var image;
    if (isCompatibleBase64(src)) image = resolveBase64Image(src);
    else if (Buffer.isBuffer(src)) image = resolveBufferImage(src);
    else if (typeof src === 'object' && src.data) image = resolveImageFromData(src);
    else image = resolveImageFromUrl(src, options);
    if (!image) throw new Error('Cannot resolve image');
    if (cache) IMAGE_CACHE.set(cacheKey, image);
    return image;
};
var emojis = {};
var regex = (0, _emojiRegexDefault.default)();
var reflect = function reflect(promise) {
    return function() {
        return promise.apply(void 0, arguments).then(function(v) {
            return v;
        }, function(e) {
            return e;
        });
    };
}; // Returns a function to be able to mock resolveImage.
var makeFetchEmojiImage = function makeFetchEmojiImage() {
    return reflect(resolveImage);
};
/**
 * When an emoji as no color, it might still have 2 parts,
 * the canonical emoji and an empty string.
 * ex.
 *   (no color) Array.from('❤️') => ["❤", "️"]
 *   (w/ color) Array.from('👍🏿') => ["👍", "🏿"]
 *
 * The empty string needs to be removed otherwise the generated
 * url will be incorect.
 */ var _removeNoColor = function _removeNoColor(x) {
    return x !== "\uFE0F";
};
var getCodePoints = function getCodePoints(string) {
    return Array.from(string).filter(_removeNoColor).map(function(char) {
        return char.codePointAt(0).toString(16);
    }).join('-');
};
var buildEmojiUrl = function buildEmojiUrl(emoji) {
    var _Font$getEmojiSource = Font$1.getEmojiSource(), url = _Font$getEmojiSource.url, format = _Font$getEmojiSource.format;
    return "" + url + getCodePoints(emoji) + "." + format;
};
var fetchEmojis = function fetchEmojis(string) {
    var emojiSource = Font$1.getEmojiSource();
    if (!emojiSource || !emojiSource.url) return [];
    var promises = [];
    var match;
    var _loop = function _loop() {
        var emoji = match[0];
        if (!emojis[emoji] || emojis[emoji].loading) {
            var emojiUrl = buildEmojiUrl(emoji);
            emojis[emoji] = {
                loading: true
            };
            var fetchEmojiImage = makeFetchEmojiImage();
            promises.push(fetchEmojiImage({
                uri: emojiUrl
            }).then(function(image) {
                emojis[emoji].loading = false;
                emojis[emoji].data = image.data;
            }));
        }
    };
    while(match = regex.exec(string))_loop();
    return promises;
};
var embedEmojis = function embedEmojis(fragments) {
    var result = [];
    for(var i = 0; i < fragments.length; i++){
        var fragment = fragments[i];
        var match = void 0;
        var lastIndex = 0;
        while(match = regex.exec(fragment.string)){
            var index = match.index;
            var emoji = match[0];
            var emojiSize = fragment.attributes.fontSize;
            var chunk = fragment.string.slice(lastIndex, index + match[0].length); // If emoji image was found, we create a new fragment with the
            // correct attachment and object substitution character;
            if (emojis[emoji] && emojis[emoji].data) result.push({
                string: chunk.replace(match, String.fromCharCode(0xfffc)),
                attributes: (0, _extendsDefault.default)({}, fragment.attributes, {
                    attachment: {
                        width: emojiSize,
                        height: emojiSize,
                        yOffset: Math.floor(emojiSize * 0.1),
                        image: emojis[emoji].data
                    }
                })
            });
            else // If no emoji data, we just replace the emoji with a nodef char
            result.push({
                string: chunk.replace(match, String.fromCharCode(0)),
                attributes: fragment.attributes
            });
            lastIndex = index + emoji.length;
        }
        if (lastIndex < fragment.string.length) result.push({
            string: fragment.string.slice(lastIndex),
            attributes: fragment.attributes
        });
    }
    return result;
};
var IGNORABLE_CODEPOINTS = [
    8232,
    8233
];
var buildSubsetForFont = function buildSubsetForFont(font) {
    return IGNORABLE_CODEPOINTS.reduce(function(acc, codePoint) {
        if (font.hasGlyphForCodePoint && font.hasGlyphForCodePoint(codePoint)) return acc;
        return [].concat(acc, [
            String.fromCharCode(codePoint)
        ]);
    }, []);
};
var ignoreChars = function ignoreChars(fragments) {
    return fragments.map(function(fragment) {
        var charSubset = buildSubsetForFont(fragment.attributes.font);
        var subsetRegex = new RegExp(charSubset.join('|'));
        return {
            string: fragment.string.replace(subsetRegex, ''),
            attributes: fragment.attributes
        };
    });
};
var PREPROCESSORS = [
    ignoreChars,
    embedEmojis
];
var capitalize = function capitalize(value) {
    return value.replace(/(^|\s)\S/g, function(l) {
        return l.toUpperCase();
    });
};
var isImage = (0, _ramda.propEq)('name', 'Image');
var isTextInstance = (0, _ramda.compose)((0, _ramda.complement)((0, _ramda.isNil)), (0, _ramda.prop)('value'));
var transformText = function transformText(text, transformation) {
    switch(transformation){
        case 'uppercase':
            return text.toUpperCase();
        case 'lowercase':
            return text.toLowerCase();
        case 'capitalize':
            return capitalize(text);
        default:
            return text;
    }
};
var getFragments = function getFragments(instance, parentLink) {
    if (!instance) return [
        {
            string: ''
        }
    ];
    var fragments = [];
    var _instance$style = instance.style, _instance$style$color = _instance$style.color, color = _instance$style$color === void 0 ? 'black' : _instance$style$color, backgroundColor = _instance$style.backgroundColor, _instance$style$fontF = _instance$style.fontFamily, fontFamily = _instance$style$fontF === void 0 ? 'Helvetica' : _instance$style$fontF, fontWeight = _instance$style.fontWeight, fontStyle = _instance$style.fontStyle, _instance$style$fontS = _instance$style.fontSize, fontSize = _instance$style$fontS === void 0 ? 18 : _instance$style$fontS, _instance$style$textA = _instance$style.textAlign, textAlign = _instance$style$textA === void 0 ? 'left' : _instance$style$textA, lineHeight = _instance$style.lineHeight, textDecoration = _instance$style.textDecoration, textDecorationColor = _instance$style.textDecorationColor, textDecorationStyle = _instance$style.textDecorationStyle, textTransform = _instance$style.textTransform, letterSpacing = _instance$style.letterSpacing, textIndent = _instance$style.textIndent, opacity = _instance$style.opacity;
    var obj = Font$1.getFont({
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle
    });
    var font = obj ? obj.data : fontFamily;
    var attributes = {
        font: font,
        color: color,
        opacity: opacity,
        fontSize: fontSize,
        backgroundColor: backgroundColor,
        align: textAlign,
        indent: textIndent,
        link: parentLink || instance.src,
        characterSpacing: letterSpacing,
        underlineStyle: textDecorationStyle,
        underline: textDecoration === 'underline',
        underlineColor: textDecorationColor || color,
        strike: textDecoration === 'line-through',
        strikeStyle: textDecorationStyle,
        strikeColor: textDecorationColor || color,
        lineHeight: lineHeight ? lineHeight * fontSize : null
    };
    instance.children.forEach(function(child) {
        if (isImage(child)) fragments.push({
            string: String.fromCharCode(0xfffc),
            attributes: (0, _extendsDefault.default)({}, attributes, {
                attachment: {
                    width: child.style.width || fontSize,
                    height: child.style.height || fontSize,
                    image: child.image.data
                }
            })
        });
        else if (isTextInstance(child)) fragments.push({
            string: transformText(child.value, textTransform),
            attributes: attributes
        });
        else if (child) {
            var _fragments;
            (_fragments = fragments).push.apply(_fragments, getFragments(child, attributes.link));
        }
    });
    for(var _i = 0; _i < PREPROCESSORS.length; _i++){
        var preprocessor = PREPROCESSORS[_i];
        fragments = preprocessor(fragments);
    }
    return fragments;
};
var getAttributedString = function getAttributedString(instance) {
    return (0, _attributedStringDefault.default).fromFragments(getFragments(instance));
};
var Text = /*#__PURE__*/ function(_Base) {
    (0, _inheritsLooseDefault.default)(Text, _Base);
    function Text(root, props) {
        var _this;
        _this = _Base.call(this, root, props) || this;
        _this.start = 0;
        _this.end = 0;
        _this.blocks = null;
        _this.computed = false;
        _this.attributedString = null;
        _this.layoutOptions = {
            hyphenationPenalty: props.hyphenationPenalty,
            hyphenationCallback: props.hyphenationCallback || Font$1.getHyphenationCallback(),
            shrinkWhitespaceFactor: {
                before: -0.5,
                after: -0.5
            }
        };
        _this.layout.setMeasureFunc(_this.measureText.bind((0, _assertThisInitializedDefault.default)(_this)));
        return _this;
    }
    var _proto = Text.prototype;
    _proto.appendChild = function appendChild(child) {
        if (child) {
            child.parent = this;
            this.children.push(child);
            this.computed = false;
            this.attributedString = null;
            this.markDirty();
        }
    };
    _proto.removeChild = function removeChild(child) {
        var index = this.children.indexOf(child);
        if (index !== -1) {
            child.parent = null;
            this.children.splice(index, 1);
            this.computed = false;
            this.attributedString = null;
            this.markDirty();
            child.cleanup();
        }
    };
    _proto.lineIndexAtHeight = function lineIndexAtHeight(height) {
        var counter = 0;
        for(var i = 0; i < this.lines.length; i++){
            var line = this.lines[i];
            if (counter + line.box.height > height) return i;
            counter += line.box.height;
        }
        return this.lines.length;
    };
    _proto.heightAtLineIndex = function heightAtLineIndex(index) {
        var counter = 0;
        for(var i = 0; i < index; i++){
            var line = this.lines[i];
            counter += line.box.height;
        }
        return counter;
    };
    _proto.layoutText = function layoutText(width, height) {
        this.attributedString = getAttributedString(this); // Text layout is expensive. That's why we ensure to only do it once
        // (except dynamic nodes. Those change content and needs to relayout every time)
        if (!this.blocks || this.props.render) {
            // Do the actual text layout.
            /// If height null or NaN, we take some liberty on layout height
            var container = {
                x: 0,
                y: 0,
                width: width,
                height: height || Infinity,
                maxLines: this.style.maxLines,
                truncateMode: this.style.textOverflow
            };
            this.blocks = engine(this.attributedString, container, this.layoutOptions);
        } // Get the total amount of rendered lines
        var linesCount = this.blocks.reduce(function(acc, b) {
            return acc + b.length;
        }, 0);
        this.end = linesCount + 1;
        this.computed = true;
    };
    _proto.measureText = function measureText(width, widthMode, height, heightMode) {
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY) {
            this.layoutText(width, height);
            return {
                height: this.linesHeight
            };
        }
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            this.layoutText(width, height);
            return {
                height: this.linesHeight,
                width: Math.min(width, this.linesWidth)
            };
        }
        return {};
    };
    _proto.resolveStyles = function resolveStyles() {
        var styles = _Base.prototype.resolveStyles.call(this); // Inherit relative positioning for inline childs
        if (this.parent && this.parent.name === 'Text' && this.parent.style.position === 'relative') {
            styles.top = styles.top || this.parent.style.top;
            styles.bottom = styles.bottom || this.parent.style.bottom;
            styles.position = styles.position || 'relative';
        } // Apply default link styles
        if (this.src) {
            styles.color = styles.color || 'blue';
            styles.textDecoration = styles.textDecoration || 'underline';
        }
        return styles;
    };
    _proto.wrapHeight = function wrapHeight(height) {
        var _this$props = this.props, orphans = _this$props.orphans, widows = _this$props.widows;
        var linesQuantity = this.lines.length;
        var sliceHeight = height - this.paddingTop;
        var slicedLine = this.lineIndexAtHeight(sliceHeight);
        if (linesQuantity < orphans) return height;
        else if (slicedLine < orphans || linesQuantity < orphans + widows) return 0;
        else if (linesQuantity === orphans + widows) return this.heightAtLineIndex(orphans);
        else if (linesQuantity - slicedLine < widows) return height - this.heightAtLineIndex(widows - 1);
        return height;
    };
    _proto.onNodeSplit = function onNodeSplit(height, clone) {
        var wrapHeight = this.wrapHeight(height);
        var slicedLineIndex = this.lineIndexAtHeight(wrapHeight);
        clone.marginTop = 0;
        clone.paddingTop = 0;
        clone.start = slicedLineIndex + this.start;
        clone.attributedString = this.attributedString;
        this.height = wrapHeight;
        this.marginBottom = 0;
        this.paddingBottom = 0;
        this.end = slicedLineIndex;
    };
    _proto.clone = function clone() {
        var text = _Base.prototype.clone.call(this);
        text.layoutEngine = this.layoutEngine; // Save calculated layout for non-dynamic clone elements
        if (this.blocks && !this.props.render) text.blocks = [].concat(this.blocks);
        return text;
    };
    _proto.renderText = function renderText() {
        var _this$getAbsoluteLayo = this.getAbsoluteLayout(), top = _this$getAbsoluteLayo.top, left = _this$getAbsoluteLayo.left;
        var initialY = this.lines[0] ? this.lines[0].box.y : 0; // We translate lines based on Yoga container
        this.root.instance.save();
        this.root.instance.translate(left + this.padding.left, top + this.padding.top - initialY); // Perform actual text rendering on document
        (0, _pdfDefault.default).render(this.root.instance, [
            this.lines
        ]);
        setLink(this);
        setDestination(this);
        this.root.instance.restore();
    };
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        this.root.instance.save();
                        this.applyTransformations();
                        this.drawBackgroundColor();
                        this.drawBorders(); // Calculate text layout if needed
                        // This can happen if measureText was not called by Yoga
                        if (!this.computed) this.layoutText(this.width - this.padding.left - this.padding.right, this.height - this.padding.top - this.padding.bottom);
                        this.renderText();
                        if (this.props.debug) this.debug();
                        this.root.instance.restore();
                    case 8:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Text, [
        {
            key: "name",
            get: function get() {
                return 'Text';
            }
        },
        {
            key: "src",
            get: function get() {
                return getURL(this.props.src || this.props.href);
            }
        },
        {
            key: "lines",
            get: function get() {
                if (!this.blocks) return [];
                return this.blocks.reduce(function(acc, block) {
                    return [].concat(acc, block);
                }, []).splice(this.start, this.end);
            }
        },
        {
            key: "linesHeight",
            get: function get() {
                if (!this.blocks) return -1;
                return this.lines.reduce(function(acc, line) {
                    return acc + line.box.height;
                }, 0);
            }
        },
        {
            key: "linesWidth",
            get: function get() {
                if (!this.blocks) return -1;
                return Math.max.apply(Math, this.lines.map(function(line) {
                    return (0, _attributedStringDefault.default).advanceWidth(line);
                }));
            }
        }
    ]);
    return Text;
}(Base);
Text.defaultProps = {
    wrap: true,
    widows: 2,
    orphans: 2
};
var Link = /*#__PURE__*/ function(_Base) {
    (0, _inheritsLooseDefault.default)(Link, _Base);
    function Link() {
        return _Base.apply(this, arguments) || this;
    }
    var _proto = Link.prototype;
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        setLink(this);
                        _context.next = 3;
                        return this.renderChildren();
                    case 3:
                        if (this.props.debug) this.debug();
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Link, [
        {
            key: "name",
            get: function get() {
                return 'Link';
            }
        },
        {
            key: "src",
            get: function get() {
                return getURL(this.props.src || this.props.href);
            }
        }
    ]);
    return Link;
}(Base);
var Note = /*#__PURE__*/ function(_Base) {
    (0, _inheritsLooseDefault.default)(Note, _Base);
    function Note() {
        return _Base.apply(this, arguments) || this;
    }
    var _proto = Note.prototype;
    _proto.appendChild = function appendChild(child) {
        if (child.name !== 'TextInstance') throw new Error('Note only accepts string children');
        if (child) {
            child.parent = this;
            this.children.push(child);
        }
    };
    _proto.removeChild = function removeChild(child) {
        var index = this.children.indexOf(child);
        if (index !== -1) {
            child.parent = null;
            this.children.splice(index, 1);
        }
        child.cleanup();
    };
    _proto.applyProps = function applyProps() {
        _Base.prototype.applyProps.call(this);
        this.height = 0;
        this.width = 0;
    };
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            var _this$getAbsoluteLayo, top, left, value;
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _this$getAbsoluteLayo = this.getAbsoluteLayout(), top = _this$getAbsoluteLayo.top, left = _this$getAbsoluteLayo.left;
                        value = this.children[0] ? this.children[0].value : '';
                        this.root.instance.note(left, top, 0, 0, value);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Note, [
        {
            key: "name",
            get: function get() {
                return 'Note';
            }
        }
    ]);
    return Note;
}(Base);
Note.defaultProps = {};
var isNumeric = function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};
var applyContainObjectFit = function applyContainObjectFit(cw, ch, iw, ih, px, py) {
    var cr = cw / ch;
    var ir = iw / ih;
    var pxp = matchPercent(px);
    var pyp = matchPercent(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    if (cr > ir) {
        var height = ch;
        var width = height * ir;
        var yOffset = isNumeric(py) ? py : 0;
        var xOffset = isNumeric(px) ? px : (cw - width) * pxv;
        return {
            width: width,
            height: height,
            xOffset: xOffset,
            yOffset: yOffset
        };
    } else {
        var _width = cw;
        var _height = _width / ir;
        var _xOffset = isNumeric(px) ? px : 0;
        var _yOffset = isNumeric(py) ? py : (ch - _height) * pyv;
        return {
            width: _width,
            height: _height,
            yOffset: _yOffset,
            xOffset: _xOffset
        };
    }
};
var applyNoneObjectFit = function applyNoneObjectFit(cw, ch, iw, ih, px, py) {
    var width = iw;
    var height = ih;
    var pxp = matchPercent(px);
    var pyp = matchPercent(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    var xOffset = isNumeric(px) ? px : (cw - width) * pxv;
    var yOffset = isNumeric(py) ? py : (ch - height) * pyv;
    return {
        width: width,
        height: height,
        xOffset: xOffset,
        yOffset: yOffset
    };
};
var applyCoverObjectFit = function applyCoverObjectFit(cw, ch, iw, ih, px, py) {
    var ir = iw / ih;
    var cr = cw / ch;
    var pxp = matchPercent(px);
    var pyp = matchPercent(py);
    var pxv = pxp ? pxp.percent : 0.5;
    var pyv = pyp ? pyp.percent : 0.5;
    if (cr > ir) {
        var width = cw;
        var height = width / ir;
        var xOffset = isNumeric(px) ? px : 0;
        var yOffset = isNumeric(py) ? py : (ch - height) * pyv;
        return {
            width: width,
            height: height,
            yOffset: yOffset,
            xOffset: xOffset
        };
    } else {
        var _height2 = ch;
        var _width2 = _height2 * ir;
        var _xOffset2 = isNumeric(px) ? px : (cw - _width2) * pxv;
        var _yOffset2 = isNumeric(py) ? py : 0;
        return {
            width: _width2,
            height: _height2,
            xOffset: _xOffset2,
            yOffset: _yOffset2
        };
    }
};
var applyScaleDownObjectFit = function applyScaleDownObjectFit(cw, ch, iw, ih, px, py) {
    var containDimension = applyContainObjectFit(cw, ch, iw, ih, px, py);
    var noneDimension = applyNoneObjectFit(cw, ch, iw, ih, px, py);
    return containDimension.width < noneDimension.width ? containDimension : noneDimension;
};
var applyFillObjectFit = function applyFillObjectFit(cw, ch, px, py) {
    return {
        width: cw,
        height: ch,
        xOffset: matchPercent(px) ? 0 : px || 0,
        yOffset: matchPercent(py) ? 0 : py || 0
    };
};
var resolveObjectFit = function resolveObjectFit(type, cw, ch, iw, ih, px, py) {
    if (type === void 0) type = 'fill';
    switch(type){
        case 'contain':
            return applyContainObjectFit(cw, ch, iw, ih, px, py);
        case 'cover':
            return applyCoverObjectFit(cw, ch, iw, ih, px, py);
        case 'none':
            return applyNoneObjectFit(cw, ch, iw, ih, px, py);
        case 'scale-down':
            return applyScaleDownObjectFit(cw, ch, iw, ih, px, py);
        default:
            return applyFillObjectFit(cw, ch, px, py);
    }
};
var SAFETY_HEIGHT = 10;
var Image = /*#__PURE__*/ function(_Base) {
    (0, _inheritsLooseDefault.default)(Image, _Base);
    function Image(root, props) {
        var _this;
        _this = _Base.call(this, root, props) || this;
        _this.image = null;
        _this.layout.setMeasureFunc(_this.measureImage.bind((0, _assertThisInitializedDefault.default)(_this)));
        return _this;
    }
    var _proto = Image.prototype;
    _proto.shouldGrow = function shouldGrow() {
        return !!this.style.flexGrow;
    };
    _proto.measureImage = function measureImage(width, widthMode, height, heightMode) {
        var imageMargin = this.margin;
        var pagePadding = this.page.padding;
        var pageArea = this.page.isAutoHeight ? Infinity : this.page.size.height - pagePadding.top - pagePadding.bottom - imageMargin.top - imageMargin.bottom - SAFETY_HEIGHT; // Skip measure if image data not present yet
        if (!this.image) return {
            width: 0,
            height: 0
        };
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && heightMode === (0, _yogaDefault.default).MEASURE_MODE_UNDEFINED) {
            var scaledHeight = width / this.ratio;
            return {
                height: Math.min(pageArea, scaledHeight)
            };
        }
        if (heightMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST || widthMode === (0, _yogaDefault.default).MEASURE_MODE_UNDEFINED)) return {
            width: Math.min(height * this.ratio, width)
        };
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_EXACTLY && heightMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            var _scaledHeight = width / this.ratio;
            return {
                height: Math.min(height, pageArea, _scaledHeight)
            };
        }
        if (widthMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST && heightMode === (0, _yogaDefault.default).MEASURE_MODE_AT_MOST) {
            if (this.ratio > 1) return {
                width: width,
                height: Math.min(width / this.ratio, height)
            };
            else return {
                width: Math.min(height * this.ratio, width),
                height: height
            };
        }
        return {
            height: height,
            width: width
        };
    };
    _proto.fetch = /*#__PURE__*/ function() {
        var _fetch = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            var _this$props, cache, safePath, allowDangerousPaths, src;
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _this$props = this.props, cache = _this$props.cache, safePath = _this$props.safePath, allowDangerousPaths = _this$props.allowDangerousPaths;
                        if (this.src) {
                            _context.next = 4;
                            break;
                        }
                        warning(false, 'Image should receive either a "src" or "source" prop');
                        return _context.abrupt("return");
                    case 4:
                        _context.prev = 4;
                        if (!(typeof this.src === 'function')) {
                            _context.next = 11;
                            break;
                        }
                        _context.next = 8;
                        return this.src();
                    case 8:
                        _context.t0 = _context.sent;
                        _context.next = 12;
                        break;
                    case 11:
                        _context.t0 = this.src;
                    case 12:
                        src = _context.t0;
                        _context.next = 15;
                        return resolveImage(src, {
                            cache: cache,
                            safePath: safePath,
                            allowDangerousPaths: allowDangerousPaths
                        });
                    case 15:
                        this.image = _context.sent;
                        _context.next = 22;
                        break;
                    case 18:
                        _context.prev = 18;
                        _context.t1 = _context["catch"](4);
                        this.image = {
                            width: 0,
                            height: 0
                        };
                        console.warn(_context.t1.message);
                    case 22:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this, [
                [
                    4,
                    18
                ]
            ]);
        }));
        function fetch() {
            return _fetch.apply(this, arguments);
        }
        return fetch;
    }();
    _proto.clone = function clone() {
        var clone = _Base.prototype.clone.call(this);
        clone.image = this.image;
        return clone;
    };
    _proto.onAppendDynamically = /*#__PURE__*/ function() {
        var _onAppendDynamically = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee2() {
            return (0, _regeneratorDefault.default).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return this.fetch();
                    case 2:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function onAppendDynamically() {
            return _onAppendDynamically.apply(this, arguments);
        }
        return onAppendDynamically;
    }();
    _proto.renderImage = function renderImage() {
        var padding = this.padding;
        var _this$getAbsoluteLayo = this.getAbsoluteLayout(), left = _this$getAbsoluteLayo.left, top = _this$getAbsoluteLayo.top;
        var _this$style = this.style, opacity = _this$style.opacity, objectPositionX = _this$style.objectPositionX, objectPositionY = _this$style.objectPositionY;
        this.root.instance.save(); // Clip path to keep image inside border radius
        this.clip();
        if (this.image && this.image.data) {
            var _resolveObjectFit = resolveObjectFit(this.style.objectFit, this.width - padding.left - padding.right, this.height - padding.top - padding.bottom, this.image.width, this.image.height, objectPositionX, objectPositionY), width = _resolveObjectFit.width, height = _resolveObjectFit.height, xOffset = _resolveObjectFit.xOffset, yOffset = _resolveObjectFit.yOffset;
            if (width !== 0 && height !== 0) this.root.instance.fillOpacity(opacity).image(this.image.data, left + padding.left + xOffset, top + padding.top + yOffset, {
                width: width,
                height: height
            });
            else warning(false, "Image with src '" + this.props.src + "' skipped due to invalid dimensions");
        } else warning(false, "Image skipped because src prop is " + this.props.src);
        this.root.instance.restore();
    };
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee3() {
            return (0, _regeneratorDefault.default).wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        setDestination(this);
                        this.root.instance.save();
                        this.applyTransformations();
                        this.drawBackgroundColor();
                        this.renderImage();
                        this.drawBorders();
                        if (this.props.debug) this.debug();
                        this.root.instance.restore();
                    case 8:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Image, [
        {
            key: "name",
            get: function get() {
                return 'Image';
            }
        },
        {
            key: "ratio",
            get: function get() {
                return this.image.data ? this.image.width / this.image.height : 1;
            }
        },
        {
            key: "src",
            get: function get() {
                var src = this.props.src || this.props.source;
                return typeof src === 'string' ? {
                    uri: src
                } : src;
            }
        }
    ]);
    return Image;
}(Base);
Image.defaultProps = {
    wrap: false,
    cache: true,
    style: {}
};
// Default presence ahead function. Used when node does not provides one.
var defaultPresenceAhead = function defaultPresenceAhead(element) {
    return function(height) {
        return Math.min(element.height, height);
    };
}; // Calculates the presence ahead or an array of nodes, given the available height.
var getPresenceAhead = function getPresenceAhead(elements, height) {
    var result = 0;
    for(var i = 0; i < elements.length; i++){
        var element = elements[i];
        var isElementInside = height > element.top;
        var presenceAhead = element.presenceAhead || defaultPresenceAhead(element);
        if (element && isElementInside) result += presenceAhead(height - element.top);
    }
    return result;
}; // Clone element recursively including children
var cloneRecursively = function cloneRecursively(node) {
    var clone = node.clone();
    if (node.children && node.children.length > 0) node.children.forEach(function(child) {
        return clone.appendChild(cloneRecursively(child));
    });
    return clone;
}; // Wrap nodes tree in fixed height page, and returns exceedings separately.
var wrap = /*#__PURE__*/ function() {
    var _ref = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee2(elements, height, pageNumber) {
        var nextPageElements, elementsToBeRemoved, i, element, futureElements, isElementOutside, elementShouldSplit, elementFitsFullPageHeight, elementShouldBreak, presenceAhead, clone, newFutureElements, nonFixedElements, _ret;
        return (0, _regeneratorDefault.default).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    nextPageElements = [];
                    elementsToBeRemoved = [];
                    i = 0;
                case 3:
                    if (!(i < elements.length)) {
                        _context2.next = 38;
                        break;
                    }
                    element = elements[i];
                    if (!element.nodeWillWrap) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return element.nodeWillWrap({
                        pageNumber: pageNumber
                    });
                case 8:
                    futureElements = elements.slice(i + 1);
                    isElementOutside = height <= element.top;
                    elementShouldSplit = height < element.top + element.height;
                    elementFitsFullPageHeight = element.height <= height;
                    elementShouldBreak = element.break || !element.wrap && elementShouldSplit && elementFitsFullPageHeight; // If element is fixed, we add it both to the current page
                    // and to all future pages to come.
                    if (!element.fixed) {
                        _context2.next = 16;
                        break;
                    }
                    nextPageElements.push(cloneRecursively(element));
                    return _context2.abrupt("continue", 35);
                case 16:
                    if (!isElementOutside) {
                        _context2.next = 20;
                        break;
                    }
                    nextPageElements.push(cloneRecursively(element));
                    elementsToBeRemoved.push(element);
                    return _context2.abrupt("continue", 35);
                case 20:
                    // Checks if element has more than the minimun presence ahead on that page.
                    // If not, we break the page in this element.
                    if (element.minPresenceAhead) {
                        presenceAhead = getPresenceAhead(futureElements, height);
                        if (presenceAhead < element.minPresenceAhead) elementShouldBreak = true;
                    } // Element can break based on many conditions: if has the break flag,
                    // if has the wrap flag as false and should be splitted or didn't have enough
                    // presence ahead. Either way, the element get's relocated on the next page,
                    // as well as all other next elements.
                    if (!elementShouldBreak) {
                        _context2.next = 30;
                        break;
                    }
                    clone = cloneRecursively(element);
                    newFutureElements = futureElements.map(function(element) {
                        return cloneRecursively(element);
                    });
                    nonFixedElements = futureElements.filter(function(element) {
                        return !element.fixed;
                    });
                    clone.top = 0;
                    clone.break = false;
                    nextPageElements.push.apply(nextPageElements, [
                        clone
                    ].concat(newFutureElements));
                    elementsToBeRemoved.push.apply(elementsToBeRemoved, [
                        element
                    ].concat(nonFixedElements));
                    return _context2.abrupt("break", 38);
                case 30:
                    if (!elementShouldSplit) {
                        _context2.next = 35;
                        break;
                    }
                    return _context2.delegateYield(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
                        var clone, remainingHeight, wrappedChildren;
                        return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    clone = element.clone();
                                    remainingHeight = height - element.top;
                                    if (!(element.children && element.children.length > 0)) {
                                        _context.next = 7;
                                        break;
                                    }
                                    _context.next = 5;
                                    return wrap(element.children, remainingHeight);
                                case 5:
                                    wrappedChildren = _context.sent;
                                    wrappedChildren.forEach(function(child) {
                                        return clone.appendChild(child);
                                    });
                                case 7:
                                    element.onNodeSplit(remainingHeight, clone);
                                    nextPageElements.push(clone);
                                    return _context.abrupt("return", "continue");
                                case 10:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    })(), "t0", 32);
                case 32:
                    _ret = _context2.t0;
                    if (!(_ret === "continue")) {
                        _context2.next = 35;
                        break;
                    }
                    return _context2.abrupt("continue", 35);
                case 35:
                    i++;
                    _context2.next = 3;
                    break;
                case 38:
                    // Remove elements that didn't fit inside page
                    // We do this here to not interfer with upper elements iteration
                    elementsToBeRemoved.forEach(function(element) {
                        return element.remove();
                    });
                    return _context2.abrupt("return", nextPageElements);
                case 40:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function wrap(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}(); // Wrap nodes tree in equal sized subpages
var wrapPages = /*#__PURE__*/ function() {
    var _ref2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee3(nodes, height, pageIndex) {
        var wrapResult, nextPage, hasOnlyFixedChilds, nextPages;
        return (0, _regeneratorDefault.default).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.next = 2;
                    return wrap(nodes, height, pageIndex++);
                case 2:
                    wrapResult = _context3.sent;
                    nextPage = wrapResult[0];
                    if (!(!nextPage || nextPage.isEmpty())) {
                        _context3.next = 6;
                        break;
                    }
                    return _context3.abrupt("return", nodes);
                case 6:
                    hasOnlyFixedChilds = nextPage.children.length > 0 && nextPage.children.every(function(c) {
                        return c.fixed;
                    });
                    if (!hasOnlyFixedChilds) {
                        _context3.next = 9;
                        break;
                    }
                    return _context3.abrupt("return", nodes);
                case 9:
                    _context3.next = 11;
                    return wrapPages([
                        nextPage
                    ], height, pageIndex);
                case 11:
                    nextPages = _context3.sent;
                    return _context3.abrupt("return", [].concat(nodes, nextPages));
                case 13:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return function wrapPages(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
    };
}();
var wrapPage = /*#__PURE__*/ function() {
    var _ref3 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee4(page, height, pageIndex) {
        var pages;
        return (0, _regeneratorDefault.default).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    if (pageIndex === void 0) pageIndex = 0;
                    if (page) {
                        _context4.next = 3;
                        break;
                    }
                    return _context4.abrupt("return", []);
                case 3:
                    _context4.next = 5;
                    return wrapPages([
                        cloneRecursively(page)
                    ], height, pageIndex);
                case 5:
                    pages = _context4.sent;
                    return _context4.abrupt("return", pages);
                case 7:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return function wrapPage(_x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
    };
}();
var Document = /*#__PURE__*/ function() {
    function Document(root, props) {
        this.root = root;
        this.style = {};
        this.props = props;
        this.children = [];
        this.subpages = [];
    }
    var _proto = Document.prototype;
    _proto.appendChild = function appendChild(child) {
        child.parent = this;
        this.children.push(child);
    };
    _proto.removeChild = function removeChild(child) {
        var index = this.children.indexOf(child);
        if (index !== -1) {
            child.parent = null;
            this.children.splice(index, 1);
        }
        child.cleanup();
    };
    _proto.addMetaData = function addMetaData() {
        var _this$props = this.props, title = _this$props.title, author = _this$props.author, subject = _this$props.subject, keywords = _this$props.keywords, creator = _this$props.creator, producer = _this$props.producer; // The object keys need to start with a capital letter by the PDF spec
        if (title) this.root.instance.info.Title = title;
        if (author) this.root.instance.info.Author = author;
        if (subject) this.root.instance.info.Subject = subject;
        if (keywords) this.root.instance.info.Keywords = keywords;
        this.root.instance.info.Creator = creator || 'react-pdf';
        this.root.instance.info.Producer = producer || 'react-pdf';
    };
    _proto.loadFonts = /*#__PURE__*/ function() {
        var _loadFonts = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            var promises, listToExplore, node;
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        promises = [];
                        listToExplore = this.children.slice(0);
                        while(listToExplore.length > 0){
                            node = listToExplore.shift();
                            if (node.style && node.style.fontFamily) promises.push(Font$1.load(node.style, this.root.instance));
                            if (node.children) node.children.forEach(function(childNode) {
                                listToExplore.push(childNode);
                            });
                        }
                        _context.next = 5;
                        return Promise.all(promises);
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function loadFonts() {
            return _loadFonts.apply(this, arguments);
        }
        return loadFonts;
    }();
    _proto.loadEmojis = /*#__PURE__*/ function() {
        var _loadEmojis = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee2() {
            var promises, listToExplore, node;
            return (0, _regeneratorDefault.default).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        promises = [];
                        listToExplore = this.children.slice(0);
                        while(listToExplore.length > 0){
                            node = listToExplore.shift();
                            if (typeof node === 'string') promises.push.apply(promises, fetchEmojis(node));
                            else if (typeof node.value === 'string') promises.push.apply(promises, fetchEmojis(node.value));
                            else if (node.children) node.children.forEach(function(childNode) {
                                listToExplore.push(childNode);
                            });
                        }
                        _context2.next = 5;
                        return Promise.all(promises);
                    case 5:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function loadEmojis() {
            return _loadEmojis.apply(this, arguments);
        }
        return loadEmojis;
    }();
    _proto.loadImages = /*#__PURE__*/ function() {
        var _loadImages = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee3() {
            var promises, listToExplore, node;
            return (0, _regeneratorDefault.default).wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        promises = [];
                        listToExplore = this.children.slice(0);
                        while(listToExplore.length > 0){
                            node = listToExplore.shift();
                            if (node.name === 'Image') promises.push(node.fetch());
                            if (node.children) node.children.forEach(function(childNode) {
                                listToExplore.push(childNode);
                            });
                        }
                        _context3.next = 5;
                        return Promise.all(promises);
                    case 5:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function loadImages() {
            return _loadImages.apply(this, arguments);
        }
        return loadImages;
    }();
    _proto.loadAssets = /*#__PURE__*/ function() {
        var _loadAssets = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee4() {
            return (0, _regeneratorDefault.default).wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return Promise.all([
                            this.loadFonts(),
                            this.loadImages(),
                            this.loadEmojis()
                        ]);
                    case 2:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4, this);
        }));
        function loadAssets() {
            return _loadAssets.apply(this, arguments);
        }
        return loadAssets;
    }();
    _proto.applyProps = function applyProps() {
        this.children.forEach(function(child) {
            return child.applyProps();
        });
    };
    _proto.update = function update(newProps) {
        this.props = newProps;
    };
    _proto.cleanup = function cleanup() {
        this.subpages.forEach(function(p) {
            return p.cleanup();
        });
    };
    _proto.finish = function finish() {
        this.children.forEach(function(c) {
            return c.cleanup();
        });
    };
    _proto.getLayoutData = function getLayoutData() {
        return {
            type: this.name,
            children: this.subpages.map(function(c) {
                return c.getLayoutData();
            })
        };
    };
    _proto.wrapPages = /*#__PURE__*/ function() {
        var _wrapPages2 = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee6() {
            var pageCount, pages, _iterator, _isArray, _i, _ref, page;
            return (0, _regeneratorDefault.default).wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        pageCount = 1;
                        pages = [];
                        _iterator = this.children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();
                    case 3:
                        if (!_isArray) {
                            _context6.next = 9;
                            break;
                        }
                        if (!(_i >= _iterator.length)) {
                            _context6.next = 6;
                            break;
                        }
                        return _context6.abrupt("break", 21);
                    case 6:
                        _ref = _iterator[_i++];
                        _context6.next = 13;
                        break;
                    case 9:
                        _i = _iterator.next();
                        if (!_i.done) {
                            _context6.next = 12;
                            break;
                        }
                        return _context6.abrupt("break", 21);
                    case 12:
                        _ref = _i.value;
                    case 13:
                        page = _ref;
                        if (!page.wrap) {
                            _context6.next = 18;
                            break;
                        }
                        return _context6.delegateYield(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee5() {
                            var wrapArea, subpages;
                            return (0, _regeneratorDefault.default).wrap(function _callee5$(_context5) {
                                while(true)switch(_context5.prev = _context5.next){
                                    case 0:
                                        wrapArea = page.isAutoHeight ? Infinity : page.size.height - (page.style.paddingBottom || 0);
                                        _context5.next = 3;
                                        return wrapPage(page, wrapArea, pageCount);
                                    case 3:
                                        subpages = _context5.sent;
                                        pageCount += subpages.length;
                                        subpages.forEach(function(sub, index) {
                                            return pages.push({
                                                page: sub,
                                                number: index + 1,
                                                count: subpages.length
                                            });
                                        });
                                    case 6:
                                    case "end":
                                        return _context5.stop();
                                }
                            }, _callee5);
                        })(), "t0", 16);
                    case 16:
                        _context6.next = 19;
                        break;
                    case 18:
                        pages.push({
                            page: page,
                            number: 1,
                            count: 1
                        });
                    case 19:
                        _context6.next = 3;
                        break;
                    case 21:
                        return _context6.abrupt("return", pages);
                    case 22:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6, this);
        }));
        function wrapPages() {
            return _wrapPages2.apply(this, arguments);
        }
        return wrapPages;
    }();
    _proto.renderPages = /*#__PURE__*/ function() {
        var _renderPages = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee7() {
            var subpages, normalized, j;
            return (0, _regeneratorDefault.default).wrap(function _callee7$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        _context7.next = 2;
                        return this.wrapPages();
                    case 2:
                        subpages = _context7.sent;
                        normalized = subpages.map(function(p) {
                            return p.page;
                        });
                        this.subpages = normalized;
                        j = 0;
                    case 6:
                        if (!(j < this.subpages.length)) {
                            _context7.next = 13;
                            break;
                        }
                        // Update dynamic text nodes with total pages info
                        this.subpages[j].renderDynamicNodes({
                            pageNumber: j + 1,
                            totalPages: subpages.length,
                            subPageNumber: subpages[j].number,
                            subPageTotalPages: subpages[j].count
                        }, function(node) {
                            return node.name === 'Text';
                        });
                        _context7.next = 10;
                        return this.subpages[j].render();
                    case 10:
                        j++;
                        _context7.next = 6;
                        break;
                    case 13:
                        return _context7.abrupt("return", this.subpages);
                    case 14:
                    case "end":
                        return _context7.stop();
                }
            }, _callee7, this);
        }));
        function renderPages() {
            return _renderPages.apply(this, arguments);
        }
        return renderPages;
    }();
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee8() {
            return (0, _regeneratorDefault.default).wrap(function _callee8$(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        _context8.prev = 0;
                        this.addMetaData();
                        this.applyProps();
                        _context8.next = 5;
                        return this.loadAssets();
                    case 5:
                        _context8.next = 7;
                        return this.renderPages();
                    case 7:
                        this.root.instance.end();
                        Font$1.reset();
                        _context8.next = 14;
                        break;
                    case 11:
                        _context8.prev = 11;
                        _context8.t0 = _context8["catch"](0);
                        throw _context8.t0;
                    case 14:
                    case "end":
                        return _context8.stop();
                }
            }, _callee8, this, [
                [
                    0,
                    11
                ]
            ]);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Document, [
        {
            key: "name",
            get: function get() {
                return 'Document';
            }
        }
    ]);
    return Document;
}();
Document.defaultProps = {
    author: null,
    keywords: null,
    subject: null,
    title: null
};
var availableMethods = [
    'dash',
    'clip',
    'save',
    'path',
    'fill',
    'font',
    'text',
    'rect',
    'scale',
    'moveTo',
    'lineTo',
    'stroke',
    'rotate',
    'circle',
    'lineCap',
    'opacity',
    'ellipse',
    'polygon',
    'restore',
    'lineJoin',
    'fontSize',
    'fillColor',
    'lineWidth',
    'translate',
    'miterLimit',
    'strokeColor',
    'fillOpacity',
    'roundedRect',
    'strokeOpacity',
    'fillAndStroke',
    'bezierCurveTo',
    'quadraticCurveTo'
];
var painter = function painter(instance) {
    var p = availableMethods.reduce(function(acc, prop) {
        var _extends2;
        return (0, _extendsDefault.default)({}, acc, (_extends2 = {}, _extends2[prop] = function() {
            instance[prop].apply(instance, arguments);
            return p;
        }, _extends2));
    }, {});
    p.linearGradient = function() {
        return instance.linearGradient.apply(instance, arguments);
    };
    p.radialGradient = function() {
        return instance.linearGradient.apply(instance, arguments);
    };
    return p;
};
var Canvas = /*#__PURE__*/ function(_Base) {
    (0, _inheritsLooseDefault.default)(Canvas, _Base);
    function Canvas() {
        return _Base.apply(this, arguments) || this;
    }
    var _proto = Canvas.prototype;
    _proto.render = /*#__PURE__*/ function() {
        var _render = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            var _this$getAbsoluteLayo, left, top, width, height, availableWidth, availableHeight;
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _this$getAbsoluteLayo = this.getAbsoluteLayout(), left = _this$getAbsoluteLayo.left, top = _this$getAbsoluteLayo.top, width = _this$getAbsoluteLayo.width, height = _this$getAbsoluteLayo.height;
                        availableWidth = width - this.paddingLeft - this.paddingRight;
                        availableHeight = height - this.paddingTop - this.paddingBottom;
                        warning(availableWidth && availableHeight, 'Canvas element has null width or height. Please provide valid values via the `style` prop in order to correctly render it.');
                        this.root.instance.save();
                        this.applyTransformations();
                        this.drawBackgroundColor();
                        this.drawBorders();
                        this.clip();
                        this.root.instance.translate(left + this.paddingLeft, top + this.paddingTop);
                        if (this.props.paint) this.props.paint(painter(this.root.instance), availableWidth, availableHeight);
                        this.root.instance.restore();
                        if (this.props.debug) this.debug();
                    case 13:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function render() {
            return _render.apply(this, arguments);
        }
        return render;
    }();
    (0, _createClassDefault.default)(Canvas, [
        {
            key: "name",
            get: function get() {
                return 'Canvas';
            }
        }
    ]);
    return Canvas;
}(Base);
Canvas.defaultProps = {
    style: {},
    wrap: false
};
var constructors = {
    ROOT: Root,
    PAGE: Page,
    TEXT: Text,
    LINK: Link,
    VIEW: View,
    NOTE: Note,
    IMAGE: Image,
    CANVAS: Canvas,
    DOCUMENT: Document,
    TEXT_INSTANCE: TextInstance
};
function createInstance(element, root) {
    var type = element.type, _element$props = element.props, props = _element$props === void 0 ? {} : _element$props;
    if (constructors[type]) return new constructors[type](root, props);
    throw new Error("Invalid element of type " + type + " passed to PDF renderer");
}
var propsEqual = function propsEqual(a, b) {
    var oldPropsKeys = Object.keys(a);
    var newPropsKeys = Object.keys(b);
    if (oldPropsKeys.length !== newPropsKeys.length) return false;
    for(var i = 0; i < oldPropsKeys.length; i++){
        var propName = oldPropsKeys[i];
        if (propName === 'render') {
            if (!a[propName] !== !b[propName]) return false;
            continue;
        }
        if (propName !== 'children' && a[propName] !== b[propName]) {
            if (typeof a[propName] === 'object' && typeof b[propName] === 'object' && propsEqual(a[propName], b[propName])) continue;
            return false;
        }
        if (propName === 'children' && (typeof a[propName] === 'string' || typeof b[propName] === 'string')) return a[propName] === b[propName];
    }
    return true;
};
var emptyObject = {}; // If the Link has a string child or render prop, substitute the instance by a Text,
// that will ultimately render the inline Link via the textkit PDF renderer.
var shouldReplaceLink = function shouldReplaceLink(type, props) {
    return type === 'LINK' && (typeof props.children === 'string' || typeof props.children === 'number' || Array.isArray(props.children) || props.render);
};
var PDFRenderer = (0, _reactReconcilerDefault.default)({
    schedulePassiveEffects: (0, _scheduler.unstable_scheduleCallback),
    cancelPassiveEffects: (0, _scheduler.unstable_cancelCallback),
    supportsMutation: true,
    appendInitialChild: function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    },
    createInstance: function createInstance$1(type, props, internalInstanceHandle) {
        var instanceType = shouldReplaceLink(type, props) ? 'TEXT' : type;
        return createInstance({
            type: instanceType,
            props: props
        }, internalInstanceHandle);
    },
    createTextInstance: function createTextInstance(text, rootContainerInstance) {
        return createInstance({
            type: 'TEXT_INSTANCE',
            props: text
        }, rootContainerInstance);
    },
    finalizeInitialChildren: function finalizeInitialChildren(element, type, props) {
        return false;
    },
    getPublicInstance: function getPublicInstance(instance) {
        return instance;
    },
    prepareForCommit: function prepareForCommit() {},
    prepareUpdate: function prepareUpdate(element, type, oldProps, newProps) {
        return !propsEqual(oldProps, newProps);
    },
    resetAfterCommit: function resetAfterCommit() {},
    resetTextContent: function resetTextContent(element) {},
    getRootHostContext: function getRootHostContext() {
        return emptyObject;
    },
    getChildHostContext: function getChildHostContext() {
        return emptyObject;
    },
    shouldSetTextContent: function shouldSetTextContent(type, props) {
        return false;
    },
    now: Date.now,
    useSyncScheduling: true,
    appendChild: function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    },
    appendChildToContainer: function appendChildToContainer(parentInstance, child) {
        parentInstance.appendChild(child);
    },
    insertBefore: function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.appendChildBefore(child, beforeChild);
    },
    removeChild: function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    },
    removeChildFromContainer: function removeChildFromContainer(parentInstance, child) {
        parentInstance.removeChild(child);
    },
    commitTextUpdate: function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.update(newText);
    },
    commitUpdate: function commitUpdate(instance, updatePayload, type, oldProps, newProps) {
        instance.update(newProps);
    }
});
var version = "1.6.17";
var View$1 = 'VIEW';
var Text$1 = 'TEXT';
var Link$1 = 'LINK';
var Page$1 = 'PAGE';
var Note$1 = 'NOTE';
var Image$1 = 'IMAGE';
var Document$1 = 'DOCUMENT';
var Canvas$1 = 'CANVAS';
var pdf = function pdf(input) {
    var container = createInstance({
        type: 'ROOT'
    });
    var mountNode = PDFRenderer.createContainer(container);
    if (input) updateContainer(input);
    function callOnRender(params) {
        if (params === void 0) params = {};
        if (container.document.props.onRender) {
            var layoutData = container.document.getLayoutData();
            container.document.props.onRender((0, _extendsDefault.default)({}, params, {
                layoutData: layoutData
            }));
        }
    }
    function isDirty() {
        return container.isDirty;
    }
    function updateContainer(doc) {
        PDFRenderer.updateContainer(doc, mountNode, null);
    }
    function toBlob() {
        return _toBlob.apply(this, arguments);
    }
    function _toBlob() {
        _toBlob = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee() {
            var stream;
            return (0, _regeneratorDefault.default).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return container.render();
                    case 2:
                        stream = container.instance.pipe((0, _blobStreamDefault.default)());
                        return _context.abrupt("return", new Promise(function(resolve, reject) {
                            stream.on('finish', function() {
                                try {
                                    var blob = stream.toBlob('application/pdf');
                                    callOnRender({
                                        blob: blob
                                    });
                                    resolve(blob);
                                } catch (error) {
                                    reject(error);
                                }
                            });
                            stream.on('error', reject);
                        }));
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return _toBlob.apply(this, arguments);
    }
    function toBuffer() {
        return _toBuffer.apply(this, arguments);
    }
    function _toBuffer() {
        _toBuffer = (0, _asyncToGeneratorDefault.default)(/*#__PURE__*/ (0, _regeneratorDefault.default).mark(function _callee2() {
            return (0, _regeneratorDefault.default).wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return container.render();
                    case 2:
                        callOnRender();
                        return _context2.abrupt("return", container.instance);
                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return _toBuffer.apply(this, arguments);
    }
    function toString() {
        var result = '';
        container.render();
        return new Promise(function(resolve, reject) {
            try {
                container.instance.on('data', function(buffer) {
                    result += buffer;
                });
                container.instance.on('end', function() {
                    callOnRender({
                        string: result
                    });
                    resolve(result);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    return {
        isDirty: isDirty,
        container: container,
        updateContainer: updateContainer,
        toBuffer: toBuffer,
        toBlob: toBlob,
        toString: toString
    };
};
var flatStyles = function flatStyles(stylesArray) {
    return stylesArray.reduce(function(acc, style) {
        return (0, _extendsDefault.default)({}, acc, style);
    }, {});
};
var Document$2 = function Document(_ref) {
    var children = _ref.children, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "children"
    ]);
    return (0, _reactDefault.default).createElement(Document$1, props, children);
};
var InternalBlobProvider = /*#__PURE__*/ function(_React$PureComponent) {
    (0, _inheritsLooseDefault.default)(InternalBlobProvider, _React$PureComponent);
    function InternalBlobProvider(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this; // Create new root container for this render
        _this.state = {
            blob: null,
            url: null,
            loading: true,
            error: null
        };
        _this.instance = pdf();
        return _this;
    }
    var _proto = InternalBlobProvider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.renderDocument();
        this.onDocumentUpdate();
    };
    _proto.componentDidUpdate = function componentDidUpdate() {
        this.renderDocument();
        if (this.instance.isDirty() && !this.state.error) this.onDocumentUpdate();
    };
    _proto.renderDocument = function renderDocument() {
        this.instance.updateContainer(this.props.document);
    };
    _proto.onDocumentUpdate = function onDocumentUpdate() {
        var _this2 = this;
        var oldBlobUrl = this.state.url;
        this.instance.toBlob().then(function(blob) {
            _this2.setState({
                blob: blob,
                url: URL.createObjectURL(blob),
                loading: false
            }, function() {
                return URL.revokeObjectURL(oldBlobUrl);
            });
        }).catch(function(error) {
            _this2.setState({
                error: error
            });
            console.error(error);
            throw error;
        });
    };
    _proto.render = function render() {
        return this.props.children(this.state);
    };
    return InternalBlobProvider;
}((0, _reactDefault.default).PureComponent);
var BlobProvider = function BlobProvider(_ref2) {
    var doc = _ref2.document, children = _ref2.children;
    if (!doc) {
        warning(false, 'You should pass a valid document to BlobProvider');
        return null;
    }
    return (0, _reactDefault.default).createElement(InternalBlobProvider, {
        document: doc
    }, children);
};
var PDFViewer = function PDFViewer(_ref3) {
    var className = _ref3.className, style = _ref3.style, children = _ref3.children, innerRef = _ref3.innerRef, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref3, [
        "className",
        "style",
        "children",
        "innerRef"
    ]);
    return (0, _reactDefault.default).createElement(InternalBlobProvider, {
        document: children
    }, function(_ref4) {
        var url = _ref4.url;
        return (0, _reactDefault.default).createElement("iframe", (0, _extendsDefault.default)({
            className: className,
            ref: innerRef,
            src: url,
            style: Array.isArray(style) ? flatStyles(style) : style
        }, props));
    });
};
var PDFDownloadLink = function PDFDownloadLink(_ref5) {
    var doc = _ref5.document, className = _ref5.className, style = _ref5.style, children = _ref5.children, _ref5$fileName = _ref5.fileName, fileName = _ref5$fileName === void 0 ? 'document.pdf' : _ref5$fileName;
    if (!doc) {
        warning(false, 'You should pass a valid document to PDFDownloadLink');
        return null;
    }
    var downloadOnIE = function downloadOnIE(blob) {
        return function() {
            if (window.navigator.msSaveBlob) window.navigator.msSaveBlob(blob, fileName);
        };
    };
    return (0, _reactDefault.default).createElement(InternalBlobProvider, {
        document: doc
    }, function(params) {
        return (0, _reactDefault.default).createElement("a", {
            className: className,
            download: fileName,
            href: params.url,
            onClick: downloadOnIE(params.blob),
            style: Array.isArray(style) ? flatStyles(style) : style
        }, typeof children === 'function' ? children(params) : children);
    });
};
var dom = {
    pdf: pdf,
    View: View$1,
    Text: Text$1,
    Link: Link$1,
    Page: Page$1,
    Font: Font$1,
    Note: Note$1,
    Image: Image$1,
    Canvas: Canvas$1,
    version: version,
    Document: Document$2,
    PDFViewer: PDFViewer,
    StyleSheet: StyleSheet,
    PDFRenderer: PDFRenderer,
    BlobProvider: BlobProvider,
    createInstance: createInstance,
    PDFDownloadLink: PDFDownloadLink
};
exports.default = dom;

},{"be3b31386940112a":"dB11O","@babel/runtime/helpers/inheritsLoose":"kUsrV","@babel/runtime/helpers/objectWithoutPropertiesLoose":"imPRm","@babel/runtime/helpers/extends":"ktcBy","react":"9njXz","@babel/runtime/regenerator":"h9Mdb","@babel/runtime/helpers/asyncToGenerator":"lbsK1","blob-stream":"a4Q1T","react-reconciler":"5A2ws","scheduler":"eTyLO","@babel/runtime/helpers/createClass":"g9J5L","@react-pdf/pdfkit":"7rt0D","@react-pdf/yoga":"7v1e1","ramda":"lzfqX","media-engine":"5bTln","@babel/runtime/helpers/assertThisInitialized":"f0luE","@react-pdf/textkit/renderers/pdf":"iNXZf","@react-pdf/textkit/attributedString":"2G4cs","is-url":"law2T","@react-pdf/fontkit":"kddcQ","cross-fetch":"elqs3","@react-pdf/textkit/layout":"crpPy","@react-pdf/textkit/engines/linebreaker":"7m3Wj","@react-pdf/textkit/engines/justification":"9I486","@react-pdf/textkit/engines/textDecoration":"4GBoE","@react-pdf/textkit/engines/scriptItemizer":"a5Law","@react-pdf/textkit/engines/wordHyphenation":"iB4R0","emoji-regex":"bUaMF","@react-pdf/png-js":"5hlIT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dB11O":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"ettWx","aceacb6a4531a9d2":"6DXND"}],"ettWx":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6DXND":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"h9Mdb":[function(require,module,exports,__globalThis) {
// TODO(Babel 8): Remove this file.
var runtime = require("1716bf03fd9b86cf")();
module.exports = runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
    else Function("r", "regeneratorRuntime = r")(runtime);
}

},{"1716bf03fd9b86cf":"lUFku"}],"lUFku":[function(require,module,exports,__globalThis) {
var _typeof = require("921e792370458e88")["default"];
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"921e792370458e88":"979to"}],"lbsK1":[function(require,module,exports,__globalThis) {
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"a4Q1T":[function(require,module,exports,__globalThis) {
var global = arguments[3];
var WritableStream = require("4c9b64386e68d7c4").Writable;
var util = require("9d519b1f154854b2");
var Blob = require("242ed4d03374c524");
var URL = global.URL || global.webkitURL || global.mozURL;
function BlobStream() {
    if (!(this instanceof BlobStream)) return new BlobStream;
    WritableStream.call(this);
    this._chunks = [];
    this._blob = null;
    this.length = 0;
}
util.inherits(BlobStream, WritableStream);
BlobStream.prototype._write = function(chunk, encoding, callback) {
    // convert chunks to Uint8Arrays (e.g. Buffer when array fallback is being used)
    if (!(chunk instanceof Uint8Array)) chunk = new Uint8Array(chunk);
    this.length += chunk.length;
    this._chunks.push(chunk);
    callback();
};
BlobStream.prototype.toBlob = function(type) {
    type = type || 'application/octet-stream';
    // cache the blob if needed
    if (!this._blob) {
        this._blob = new Blob(this._chunks, {
            type: type
        });
        this._chunks = []; // free memory
    }
    // if the cached blob's type doesn't match the requested type, make a new blob
    if (this._blob.type !== type) this._blob = new Blob([
        this._blob
    ], {
        type: type
    });
    return this._blob;
};
BlobStream.prototype.toBlobURL = function(type) {
    return URL.createObjectURL(this.toBlob(type));
};
module.exports = BlobStream;

},{"4c9b64386e68d7c4":"6U5YO","9d519b1f154854b2":"6Hf8s","242ed4d03374c524":"9D9ZX"}],"6U5YO":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = Stream;
var EE = require("96b62835346f84f0").EventEmitter;
var inherits = require("4a6ee9586f51c38d");
inherits(Stream, EE);
Stream.Readable = require("e6206e1f4d20abc7");
Stream.Writable = require("a3f1405f37e1dfb1");
Stream.Duplex = require("6691a72c5fc222fd");
Stream.Transform = require("43a905ce7ec6ac9e");
Stream.PassThrough = require("dd715550d7783885");
Stream.finished = require("d90a3520974ec96e");
Stream.pipeline = require("eb2779cfd287c5c9");
// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function Stream() {
    EE.call(this);
}
Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if (EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

},{"96b62835346f84f0":"bfUsG","4a6ee9586f51c38d":"3qcfW","e6206e1f4d20abc7":"eHWro","a3f1405f37e1dfb1":"1xWW1","6691a72c5fc222fd":"fFbFB","43a905ce7ec6ac9e":"1j2qH","dd715550d7783885":"5boi6","d90a3520974ec96e":"1yhKf","eb2779cfd287c5c9":"1xedn"}],"bfUsG":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"eHWro":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var global = arguments[3];
var process = require("896ff8d56553f7a");
'use strict';
module.exports = Readable;
/*<replacement>*/ var Duplex;
/*</replacement>*/ Readable.ReadableState = ReadableState;
/*<replacement>*/ var EE = require("16782d660ac22e0c").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("9a34f23fa53f83f7");
/*</replacement>*/ var Buffer = require("fb95ecaa88342eae").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*<replacement>*/ var debugUtil = require("a4a723b7297c7152");
var debug;
if (debugUtil && debugUtil.debuglog) debug = debugUtil.debuglog('stream');
else debug = function debug() {};
/*</replacement>*/ var BufferList = require("7a14cc1689b8c63e");
var destroyImpl = require("efa8155386cc4283");
var _require = require("994c984d08c7bbf2"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("8de60461b822641b").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
require("19affa8ce41f090d")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
function ReadableState(options, stream, isDuplex) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
        this.decoder = new StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}
function Readable(options) {
    Duplex = Duplex || require("f1c95f846e94e4eb");
    if (!(this instanceof Readable)) return new Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    this._readableState = new ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
    return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = chunkInvalid(state, chunk);
        if (er) errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) chunk = _uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else addChunk(stream, state, chunk, true);
            } else if (state.ended) errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);
                    else maybeReadMore(stream, state);
                } else addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) emitReadable(stream);
    }
    maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
    var er;
    if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
    if (!StringDecoder) StringDecoder = require("6392acd10886f115").StringDecoder;
    var decoder = new StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
    if (n >= MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
    debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) endReadable(this);
        else emitReadable(this);
        return null;
    }
    n = howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        debug('reading or ended', doRead);
    } else if (doRead) {
        debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function onEofChunk(stream, state) {
    debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
    var state = stream._readableState;
    debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        process.nextTick(emitReadable_, stream);
    }
}
function emitReadable_(stream) {
    var state = stream._readableState;
    debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        process.nextTick(maybeReadMore_, stream, state);
    }
}
function maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
    errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) process.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        debug('ondata');
        var ret = dest.write(chunk);
        debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        debug('pipe resume');
        src.resume();
    }
    return dest;
};
function pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
            state.flowing = true;
            flow(src);
        }
    };
}
Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
    var res = Stream.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            debug('on readable', state.length, state.reading);
            if (state.length) emitReadable(this);
            else if (!state.reading) process.nextTick(nReadingNextTick, this);
        }
    }
    return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function(ev, fn) {
    var res = Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
Readable.prototype.removeAllListeners = function(ev) {
    var res = Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
    return res;
};
function updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function nReadingNextTick(self1) {
    debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        resume(this, state);
    }
    state.paused = false;
    return this;
};
function resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        process.nextTick(resume_, stream, state);
    }
}
function resume_(stream, state) {
    debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function() {
    debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function flow(stream) {
    var state = stream._readableState;
    debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < kProxyEvents.length; n++)stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
if (typeof Symbol === 'function') Readable.prototype[Symbol.asyncIterator] = function() {
    if (createReadableStreamAsyncIterator === undefined) createReadableStreamAsyncIterator = require("830c56f840811f05");
    return createReadableStreamAsyncIterator(this);
};
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function endReadable(stream) {
    var state = stream._readableState;
    debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        process.nextTick(endReadableNT, state, stream);
    }
}
function endReadableNT(state, stream) {
    debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}
if (typeof Symbol === 'function') Readable.from = function(iterable, opts) {
    if (from === undefined) from = require("7451b8c4bf72370");
    return from(Readable, iterable, opts);
};
function indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

},{"896ff8d56553f7a":"5jT8D","16782d660ac22e0c":"bfUsG","9a34f23fa53f83f7":"65hM3","fb95ecaa88342eae":"dB11O","a4a723b7297c7152":"aBjM4","7a14cc1689b8c63e":"aiiDA","efa8155386cc4283":"edvQZ","994c984d08c7bbf2":"dFcGl","8de60461b822641b":"5xISA","19affa8ce41f090d":"3qcfW","f1c95f846e94e4eb":"fFbFB","6392acd10886f115":"8Iwjg","830c56f840811f05":"dPVA3","7451b8c4bf72370":"jyywz"}],"65hM3":[function(require,module,exports,__globalThis) {
module.exports = require("ed88fc9aa73f911").EventEmitter;

},{"ed88fc9aa73f911":"bfUsG"}],"aBjM4":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"aiiDA":[function(require,module,exports,__globalThis) {
'use strict';
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var _require = require("59f5d0111b7fa075"), Buffer = _require.Buffer;
var _require2 = require("eef6a677577349b8"), inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
    Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        _classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    _createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return Buffer.alloc(0);
                var ret = Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: custom,
            value: function value(_, options) {
                return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

},{"59f5d0111b7fa075":"dB11O","eef6a677577349b8":"aBjM4"}],"edvQZ":[function(require,module,exports,__globalThis) {
var process = require("4284522496af5dfb");
'use strict';
// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) process.nextTick(emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                process.nextTick(emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) process.nextTick(emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                process.nextTick(emitErrorAndCloseNT, _this, err);
            } else process.nextTick(emitCloseNT, _this);
        } else if (cb) {
            process.nextTick(emitCloseNT, _this);
            cb(err);
        } else process.nextTick(emitCloseNT, _this);
    });
    return this;
}
function emitErrorAndCloseNT(self, err) {
    emitErrorNT(self, err);
    emitCloseNT(self);
}
function emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function emitErrorNT(self, err) {
    self.emit('error', err);
}
function errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: destroy,
    undestroy: undestroy,
    errorOrDestroy: errorOrDestroy
};

},{"4284522496af5dfb":"5jT8D"}],"dFcGl":[function(require,module,exports,__globalThis) {
'use strict';
var ERR_INVALID_OPT_VALUE = require("4e508d569e2117ef").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: getHighWaterMark
};

},{"4e508d569e2117ef":"5xISA"}],"5xISA":[function(require,module,exports,__globalThis) {
'use strict';
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var codes = {};
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if (endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    else {
        var type = includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;

},{}],"fFbFB":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
var process = require("2ab1115635c50a9f");
'use strict';
/*<replacement>*/ var objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = Duplex;
var Readable = require("68a7582259cd5865");
var Writable = require("93d042f8bb80078e");
require("aa7b11ba5bf4defc")(Duplex, Readable);
// Allow the keys array to be GC'ed.
var keys = objectKeys(Writable.prototype);
for(var v = 0; v < keys.length; v++){
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}
function Duplex(options) {
    if (!(this instanceof Duplex)) return new Duplex(options);
    Readable.call(this, options);
    Writable.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', onend);
        }
    }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    process.nextTick(onEndNT, this);
}
function onEndNT(self) {
    self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

},{"2ab1115635c50a9f":"5jT8D","68a7582259cd5865":"eHWro","93d042f8bb80078e":"1xWW1","aa7b11ba5bf4defc":"3qcfW"}],"1xWW1":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
var global = arguments[3];
var process = require("f05a2a5a09d4d8b0");
'use strict';
module.exports = Writable;
/* <replacement> */ function WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var Duplex;
/*</replacement>*/ Writable.WritableState = WritableState;
/*<replacement>*/ var internalUtil = {
    deprecate: require("dc51171b07b54af1")
};
/*</replacement>*/ /*<replacement>*/ var Stream = require("44a3cc22ec64fcd3");
/*</replacement>*/ var Buffer = require("de8f7fb7ccda8086").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function _uint8ArrayToBuffer(chunk) {
    return Buffer.from(chunk);
}
function _isUint8Array(obj) {
    return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = require("acf48fb5d9dc6204");
var _require = require("9d146cd974da0f53"), getHighWaterMark = _require.getHighWaterMark;
var _require$codes = require("3c574b8881abcf86").codes, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED, ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
require("10dad555ffe77dde")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty(WritableState.prototype, 'buffer', {
            get: internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty(Writable, Symbol.hasInstance, {
        value: function value(object) {
            if (realHasInstance.call(this, object)) return true;
            if (this !== Writable) return false;
            return object && object._writableState instanceof WritableState;
        }
    });
} else realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};
function Writable(options) {
    Duplex = Duplex || require("c5e7171d6f58d3c0");
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof Duplex;
    if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
    this._writableState = new WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    Stream.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
    errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
    var er = new ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        errorOrDestroy(stream, er);
        process.nextTick(cb, er);
        return false;
    }
    return true;
}
Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && _isUint8Array(chunk);
    if (isBuf && !Buffer.isBuffer(chunk)) chunk = _uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = nop;
    if (state.ending) writeAfterEnd(this, cb);
    else if (isBuf || validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
Writable.prototype.cork = function() {
    this._writableState.corked++;
};
Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
    }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        process.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        process.nextTick(finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        finishMaybe(stream, state);
    }
}
function onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
    onwriteStateUpdate(state);
    if (er) onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(stream, state);
        if (sync) process.nextTick(afterWrite, stream, state, finished, cb);
        else afterWrite(stream, state, finished, cb);
    }
}
function afterWrite(stream, state, finished, cb) {
    if (!finished) onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) endWritable(this, state, cb);
    return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        finishMaybe(stream, state);
    });
}
function prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            process.nextTick(callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function finishMaybe(stream, state) {
    var need = needFinish(state);
    if (need) {
        prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function endWritable(stream, state, cb) {
    state.ending = true;
    finishMaybe(stream, state);
    if (cb) {
        if (state.finished) process.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

},{"f05a2a5a09d4d8b0":"5jT8D","dc51171b07b54af1":"egsVV","44a3cc22ec64fcd3":"65hM3","de8f7fb7ccda8086":"dB11O","acf48fb5d9dc6204":"edvQZ","9d146cd974da0f53":"dFcGl","3c574b8881abcf86":"5xISA","10dad555ffe77dde":"3qcfW","c5e7171d6f58d3c0":"fFbFB"}],"egsVV":[function(require,module,exports,__globalThis) {
/**
 * Module exports.
 */ var global = arguments[3];
module.exports = deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function deprecate(fn, msg) {
    if (config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if (config('throwDeprecation')) throw new Error(msg);
            else if (config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

},{}],"8Iwjg":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
/*<replacement>*/ var Buffer = require("2a29807c689a070a").Buffer;
/*</replacement>*/ var isEncoding = Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function _normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
    var nenc = _normalizeEncoding(enc);
    if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
    this.encoding = normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = utf16Text;
            this.end = utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = base64Text;
            this.end = base64End;
            nb = 3;
            break;
        default:
            this.write = simpleWrite;
            this.end = simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = Buffer.allocUnsafe(nb);
}
StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
StringDecoder.prototype.end = utf8End;
// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
    var total = utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

},{"2a29807c689a070a":"0F6vL"}],"0F6vL":[function(require,module,exports,__globalThis) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ var buffer = require("7e0d6ecd698c3ca6");
var Buffer = buffer.Buffer;
// alternative to using Object.keys for old browsers
function copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) module.exports = buffer;
else {
    // Copy properties from require('buffer')
    copyProps(buffer, exports);
    exports.Buffer = SafeBuffer;
}
function SafeBuffer(arg, encodingOrOffset, length) {
    return Buffer(arg, encodingOrOffset, length);
}
SafeBuffer.prototype = Object.create(Buffer.prototype);
// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer);
SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return Buffer(arg, encodingOrOffset, length);
};
SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return Buffer(size);
};
SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return buffer.SlowBuffer(size);
};

},{"7e0d6ecd698c3ca6":"dB11O"}],"dPVA3":[function(require,module,exports,__globalThis) {
var process = require("96b869862a96261a");
'use strict';
var _Object$setPrototypeO;
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var finished = require("745a3cd8f6469ed5");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function readAndResolve(iter) {
    var resolve = iter[kLastResolve];
    if (resolve !== null) {
        var data = iter[kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[kLastPromise] = null;
            iter[kLastResolve] = null;
            iter[kLastReject] = null;
            resolve(createIterResult(data, false));
        }
    }
}
function onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[kEnded]) {
                resolve(createIterResult(undefined, true));
                return;
            }
            iter[kHandlePromise](resolve, reject);
        }, reject);
    };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
    get stream () {
        return this[kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[kError];
        if (error !== null) return Promise.reject(error);
        if (this[kEnded]) return Promise.resolve(createIterResult(undefined, true));
        if (this[kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            process.nextTick(function() {
                if (_this[kError]) reject(_this[kError]);
                else resolve(createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise(wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[kStream].read();
            if (data !== null) return Promise.resolve(createIterResult(data, false));
            promise = new Promise(this[kHandlePromise]);
        }
        this[kLastPromise] = promise;
        return promise;
    }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve(createIterResult(undefined, true));
        });
    });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
        value: stream,
        writable: true
    }), _defineProperty(_Object$create, kLastResolve, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kLastReject, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kError, {
        value: null,
        writable: true
    }), _defineProperty(_Object$create, kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), _defineProperty(_Object$create, kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[kStream].read();
            if (data) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                resolve(createIterResult(data, false));
            } else {
                iterator[kLastResolve] = resolve;
                iterator[kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[kLastPromise] = null;
    finished(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[kLastPromise] = null;
                iterator[kLastResolve] = null;
                iterator[kLastReject] = null;
                reject(err);
            }
            iterator[kError] = err;
            return;
        }
        var resolve = iterator[kLastResolve];
        if (resolve !== null) {
            iterator[kLastPromise] = null;
            iterator[kLastResolve] = null;
            iterator[kLastReject] = null;
            resolve(createIterResult(undefined, true));
        }
        iterator[kEnded] = true;
    });
    stream.on('readable', onReadable.bind(null, iterator));
    return iterator;
};
module.exports = createReadableStreamAsyncIterator;

},{"96b869862a96261a":"5jT8D","745a3cd8f6469ed5":"1yhKf"}],"1yhKf":[function(require,module,exports,__globalThis) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var ERR_STREAM_PREMATURE_CLOSE = require("d35458f585bdd360").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function noop() {}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
    if (typeof opts === 'function') return eos(stream, null, opts);
    if (!opts) opts = {};
    callback = once(callback || noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if (isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = eos;

},{"d35458f585bdd360":"5xISA"}],"jyywz":[function(require,module,exports,__globalThis) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

},{}],"1j2qH":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = Transform;
var _require$codes = require("baab47252aa06434").codes, ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK, ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = require("db11ebf938e536ed");
require("82049677fa603d40")(Transform, Duplex);
function afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function Transform(options) {
    if (!(this instanceof Transform)) return new Transform(options);
    Duplex.call(this, options);
    this._transformState = {
        afterTransform: afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', prefinish);
}
function prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        done(_this, er, data);
    });
    else done(this, null, null);
}
Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return Duplex.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
Transform.prototype._destroy = function(err, cb) {
    Duplex.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

},{"baab47252aa06434":"5xISA","db11ebf938e536ed":"fFbFB","82049677fa603d40":"3qcfW"}],"5boi6":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = PassThrough;
var Transform = require("7ab21291895ec3d2");
require("f24ec1883eef5e9b")(PassThrough, Transform);
function PassThrough(options) {
    if (!(this instanceof PassThrough)) return new PassThrough(options);
    Transform.call(this, options);
}
PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

},{"7ab21291895ec3d2":"1j2qH","f24ec1883eef5e9b":"3qcfW"}],"1xedn":[function(require,module,exports,__globalThis) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var eos;
function once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}
var _require$codes = require("6ba21bd580ac7d57").codes, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS, ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
    callback = once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if (eos === undefined) eos = require("dd7fd89dd81b8674");
    eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if (isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new ERR_STREAM_DESTROYED('pipe'));
    };
}
function call(fn) {
    fn();
}
function pipe(from, to) {
    return from.pipe(to);
}
function popCallback(streams) {
    if (!streams.length) return noop;
    if (typeof streams[streams.length - 1] !== 'function') return noop;
    return streams.pop();
}
function pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach(call);
            if (reading) return;
            destroys.forEach(call);
            callback(error);
        });
    });
    return streams.reduce(pipe);
}
module.exports = pipeline;

},{"6ba21bd580ac7d57":"5xISA","dd7fd89dd81b8674":"1yhKf"}],"9D9ZX":[function(require,module,exports,__globalThis) {
/**
 * Create a blob builder even when vendor prefixes exist
 */ var global = arguments[3];
var BlobBuilder = global.BlobBuilder || global.WebKitBlobBuilder || global.MSBlobBuilder || global.MozBlobBuilder;
/**
 * Check if Blob constructor is supported
 */ var blobSupported = function() {
    try {
        var a = new Blob([
            'hi'
        ]);
        return a.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */ var blobSupportsArrayBufferView = blobSupported && function() {
    try {
        var b = new Blob([
            new Uint8Array([
                1,
                2
            ])
        ]);
        return b.size === 2;
    } catch (e) {
        return false;
    }
}();
/**
 * Check if BlobBuilder is supported
 */ var blobBuilderSupported = BlobBuilder && BlobBuilder.prototype.append && BlobBuilder.prototype.getBlob;
/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */ function mapArrayBufferViews(ary) {
    for(var i = 0; i < ary.length; i++){
        var chunk = ary[i];
        if (chunk.buffer instanceof ArrayBuffer) {
            var buf = chunk.buffer;
            // if this is a subarray, make a copy so we only
            // include the subarray region from the underlying buffer
            if (chunk.byteLength !== buf.byteLength) {
                var copy = new Uint8Array(chunk.byteLength);
                copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
                buf = copy.buffer;
            }
            ary[i] = buf;
        }
    }
}
function BlobBuilderConstructor(ary, options) {
    options = options || {};
    var bb = new BlobBuilder();
    mapArrayBufferViews(ary);
    for(var i = 0; i < ary.length; i++)bb.append(ary[i]);
    return options.type ? bb.getBlob(options.type) : bb.getBlob();
}
function BlobConstructor(ary, options) {
    mapArrayBufferViews(ary);
    return new Blob(ary, options || {});
}
module.exports = function() {
    if (blobSupported) return blobSupportsArrayBufferView ? global.Blob : BlobConstructor;
    else if (blobBuilderSupported) return BlobBuilderConstructor;
    else return undefined;
}();

},{}],"5A2ws":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("9a109349246465dc");

},{"9a109349246465dc":"1zTqy"}],"1zTqy":[function(require,module,exports,__globalThis) {
/** @license React v0.24.0
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ module.exports = function $$$reconciler($$$hostConfig) {
    'use strict';
    var aa = require("20cd3217b407ef91"), ba = require("dd158a5ff2156cef"), m = require("d0adbee359419cfb");
    function n(a) {
        for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
        return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var q = ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    q.hasOwnProperty("ReactCurrentDispatcher") || (q.ReactCurrentDispatcher = {
        current: null
    });
    q.hasOwnProperty("ReactCurrentBatchConfig") || (q.ReactCurrentBatchConfig = {
        suspense: null
    });
    var u = "function" === typeof Symbol && Symbol.for, ca = u ? Symbol.for("react.element") : 60103, da = u ? Symbol.for("react.portal") : 60106, ea = u ? Symbol.for("react.fragment") : 60107, fa = u ? Symbol.for("react.strict_mode") : 60108, ha = u ? Symbol.for("react.profiler") : 60114, ia = u ? Symbol.for("react.provider") : 60109, ja = u ? Symbol.for("react.context") : 60110, ka = u ? Symbol.for("react.concurrent_mode") : 60111, la = u ? Symbol.for("react.forward_ref") : 60112, ma = u ? Symbol.for("react.suspense") : 60113, na = u ? Symbol.for("react.suspense_list") : 60120, oa = u ? Symbol.for("react.memo") : 60115, pa = u ? Symbol.for("react.lazy") : 60116;
    u && Symbol.for("react.fundamental");
    u && Symbol.for("react.responder");
    u && Symbol.for("react.scope");
    var qa = "function" === typeof Symbol && Symbol.iterator;
    function ra(a) {
        if (null === a || "object" !== typeof a) return null;
        a = qa && a[qa] || a["@@iterator"];
        return "function" === typeof a ? a : null;
    }
    function sa(a) {
        if (-1 === a._status) {
            a._status = 0;
            var b = a._ctor;
            b = b();
            a._result = b;
            b.then(function(b) {
                0 === a._status && (b = b.default, a._status = 1, a._result = b);
            }, function(b) {
                0 === a._status && (a._status = 2, a._result = b);
            });
        }
    }
    function ta(a) {
        if (null == a) return null;
        if ("function" === typeof a) return a.displayName || a.name || null;
        if ("string" === typeof a) return a;
        switch(a){
            case ea:
                return "Fragment";
            case da:
                return "Portal";
            case ha:
                return "Profiler";
            case fa:
                return "StrictMode";
            case ma:
                return "Suspense";
            case na:
                return "SuspenseList";
        }
        if ("object" === typeof a) switch(a.$$typeof){
            case ja:
                return "Context.Consumer";
            case ia:
                return "Context.Provider";
            case la:
                var b = a.render;
                b = b.displayName || b.name || "";
                return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
            case oa:
                return ta(a.type);
            case pa:
                if (a = 1 === a._status ? a._result : null) return ta(a);
        }
        return null;
    }
    function ua(a) {
        var b = a, c = a;
        if (a.alternate) for(; b.return;)b = b.return;
        else {
            a = b;
            do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
            while (a);
        }
        return 3 === b.tag ? c : null;
    }
    function va(a) {
        if (ua(a) !== a) throw Error(n(188));
    }
    function wa(a) {
        var b = a.alternate;
        if (!b) {
            b = ua(a);
            if (null === b) throw Error(n(188));
            return b !== a ? null : a;
        }
        for(var c = a, d = b;;){
            var e = c.return;
            if (null === e) break;
            var f = e.alternate;
            if (null === f) {
                d = e.return;
                if (null !== d) {
                    c = d;
                    continue;
                }
                break;
            }
            if (e.child === f.child) {
                for(f = e.child; f;){
                    if (f === c) return va(e), a;
                    if (f === d) return va(e), b;
                    f = f.sibling;
                }
                throw Error(n(188));
            }
            if (c.return !== d.return) c = e, d = f;
            else {
                for(var g = !1, l = e.child; l;){
                    if (l === c) {
                        g = !0;
                        c = e;
                        d = f;
                        break;
                    }
                    if (l === d) {
                        g = !0;
                        d = e;
                        c = f;
                        break;
                    }
                    l = l.sibling;
                }
                if (!g) {
                    for(l = f.child; l;){
                        if (l === c) {
                            g = !0;
                            c = f;
                            d = e;
                            break;
                        }
                        if (l === d) {
                            g = !0;
                            d = f;
                            c = e;
                            break;
                        }
                        l = l.sibling;
                    }
                    if (!g) throw Error(n(189));
                }
            }
            if (c.alternate !== d) throw Error(n(190));
        }
        if (3 !== c.tag) throw Error(n(188));
        return c.stateNode.current === c ? a : b;
    }
    function xa(a) {
        a = wa(a);
        if (!a) return null;
        for(var b = a;;){
            if (5 === b.tag || 6 === b.tag) return b;
            if (b.child) b.child.return = b, b = b.child;
            else {
                if (b === a) break;
                for(; !b.sibling;){
                    if (!b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return null;
    }
    function ya(a) {
        a = wa(a);
        if (!a) return null;
        for(var b = a;;){
            if (5 === b.tag || 6 === b.tag) return b;
            if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;
            else {
                if (b === a) break;
                for(; !b.sibling;){
                    if (!b.return || b.return === a) return null;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
        return null;
    }
    var za = $$$hostConfig.getPublicInstance, Aa = $$$hostConfig.getRootHostContext, Ba = $$$hostConfig.getChildHostContext, Ca = $$$hostConfig.prepareForCommit, Da = $$$hostConfig.resetAfterCommit, Ea = $$$hostConfig.createInstance, Fa = $$$hostConfig.appendInitialChild, Ga = $$$hostConfig.finalizeInitialChildren, Ia = $$$hostConfig.prepareUpdate, Ja = $$$hostConfig.shouldSetTextContent, Ka = $$$hostConfig.shouldDeprioritizeSubtree, La = $$$hostConfig.createTextInstance, Ma = $$$hostConfig.setTimeout, Na = $$$hostConfig.clearTimeout, Oa = $$$hostConfig.noTimeout, Pa = $$$hostConfig.isPrimaryRenderer, Qa = $$$hostConfig.supportsMutation, Ra = $$$hostConfig.supportsPersistence, Sa = $$$hostConfig.supportsHydration, Ta = $$$hostConfig.appendChild, Ua = $$$hostConfig.appendChildToContainer, Va = $$$hostConfig.commitTextUpdate, Wa = $$$hostConfig.commitMount, Xa = $$$hostConfig.commitUpdate, Ya = $$$hostConfig.insertBefore, Za = $$$hostConfig.insertInContainerBefore, $a = $$$hostConfig.removeChild, ab = $$$hostConfig.removeChildFromContainer, bb = $$$hostConfig.resetTextContent, cb = $$$hostConfig.hideInstance, db = $$$hostConfig.hideTextInstance, eb = $$$hostConfig.unhideInstance, fb = $$$hostConfig.unhideTextInstance, gb = $$$hostConfig.cloneInstance, hb = $$$hostConfig.createContainerChildSet, ib = $$$hostConfig.appendChildToContainerChildSet, kb = $$$hostConfig.finalizeContainerChildren, lb = $$$hostConfig.replaceContainerChildren, mb = $$$hostConfig.cloneHiddenInstance, nb = $$$hostConfig.cloneHiddenTextInstance, ob = $$$hostConfig.canHydrateInstance, pb = $$$hostConfig.canHydrateTextInstance, qb = $$$hostConfig.isSuspenseInstancePending, rb = $$$hostConfig.isSuspenseInstanceFallback, sb = $$$hostConfig.getNextHydratableSibling, tb = $$$hostConfig.getFirstHydratableChild, ub = $$$hostConfig.hydrateInstance, vb = $$$hostConfig.hydrateTextInstance, wb = $$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance, xb = $$$hostConfig.commitHydratedContainer, yb = $$$hostConfig.commitHydratedSuspenseInstance, zb = /^(.*)[\\\/]/;
    function Ab(a) {
        var b = "";
        do {
            a: switch(a.tag){
                case 3:
                case 4:
                case 6:
                case 7:
                case 10:
                case 9:
                    var c = "";
                    break a;
                default:
                    var d = a._debugOwner, e = a._debugSource, f = ta(a.type);
                    c = null;
                    d && (c = ta(d.type));
                    d = f;
                    f = "";
                    e ? f = " (at " + e.fileName.replace(zb, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                    c = "\n    in " + (d || "Unknown") + f;
            }
            b += c;
            a = a.return;
        }while (a);
        return b;
    }
    new Set;
    var Bb = [], Cb = -1;
    function y(a) {
        0 > Cb || (a.current = Bb[Cb], Bb[Cb] = null, Cb--);
    }
    function z(a, b) {
        Cb++;
        Bb[Cb] = a.current;
        a.current = b;
    }
    var Db = {}, A = {
        current: Db
    }, B = {
        current: !1
    }, Eb = Db;
    function Fb(a, b) {
        var c = a.type.contextTypes;
        if (!c) return Db;
        var d = a.stateNode;
        if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
        var e = {}, f;
        for(f in c)e[f] = b[f];
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
        return e;
    }
    function C(a) {
        a = a.childContextTypes;
        return null !== a && void 0 !== a;
    }
    function Gb(a) {
        y(B, a);
        y(A, a);
    }
    function Hb(a) {
        y(B, a);
        y(A, a);
    }
    function Ib(a, b, c) {
        if (A.current !== Db) throw Error(n(168));
        z(A, b, a);
        z(B, c, a);
    }
    function Jb(a, b, c) {
        var d = a.stateNode;
        a = b.childContextTypes;
        if ("function" !== typeof d.getChildContext) return c;
        d = d.getChildContext();
        for(var e in d)if (!(e in a)) throw Error(n(108, ta(b) || "Unknown", e));
        return aa({}, c, {}, d);
    }
    function Kb(a) {
        var b = a.stateNode;
        b = b && b.__reactInternalMemoizedMergedChildContext || Db;
        Eb = A.current;
        z(A, b, a);
        z(B, B.current, a);
        return !0;
    }
    function Lb(a, b, c) {
        var d = a.stateNode;
        if (!d) throw Error(n(169));
        c ? (b = Jb(a, b, Eb), d.__reactInternalMemoizedMergedChildContext = b, y(B, a), y(A, a), z(A, b, a)) : y(B, a);
        z(B, c, a);
    }
    var Mb = m.unstable_runWithPriority, Nb = m.unstable_scheduleCallback, Ob = m.unstable_cancelCallback, Pb = m.unstable_shouldYield, Qb = m.unstable_requestPaint, Rb = m.unstable_now, Ub = m.unstable_getCurrentPriorityLevel, Vb = m.unstable_ImmediatePriority, Wb = m.unstable_UserBlockingPriority, Xb = m.unstable_NormalPriority, Yb = m.unstable_LowPriority, Zb = m.unstable_IdlePriority, $b = {}, ac = void 0 !== Qb ? Qb : function() {}, bc = null, cc = null, dc = !1, ec = Rb(), E = 1E4 > ec ? Rb : function() {
        return Rb() - ec;
    };
    function fc() {
        switch(Ub()){
            case Vb:
                return 99;
            case Wb:
                return 98;
            case Xb:
                return 97;
            case Yb:
                return 96;
            case Zb:
                return 95;
            default:
                throw Error(n(332));
        }
    }
    function gc(a) {
        switch(a){
            case 99:
                return Vb;
            case 98:
                return Wb;
            case 97:
                return Xb;
            case 96:
                return Yb;
            case 95:
                return Zb;
            default:
                throw Error(n(332));
        }
    }
    function hc(a, b) {
        a = gc(a);
        return Mb(a, b);
    }
    function ic(a, b, c) {
        a = gc(a);
        return Nb(a, b, c);
    }
    function jc(a) {
        null === bc ? (bc = [
            a
        ], cc = Nb(Vb, kc)) : bc.push(a);
        return $b;
    }
    function F() {
        if (null !== cc) {
            var a = cc;
            cc = null;
            Ob(a);
        }
        kc();
    }
    function kc() {
        if (!dc && null !== bc) {
            dc = !0;
            var a = 0;
            try {
                var b = bc;
                hc(99, function() {
                    for(; a < b.length; a++){
                        var c = b[a];
                        do c = c(!0);
                        while (null !== c);
                    }
                });
                bc = null;
            } catch (c) {
                throw null !== bc && (bc = bc.slice(a + 1)), Nb(Vb, F), c;
            } finally{
                dc = !1;
            }
        }
    }
    var lc = 3;
    function mc(a, b, c) {
        c /= 10;
        return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
    }
    function nc(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var oc = "function" === typeof Object.is ? Object.is : nc, pc = Object.prototype.hasOwnProperty;
    function qc(a, b) {
        if (oc(a, b)) return !0;
        if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
        var c = Object.keys(a), d = Object.keys(b);
        if (c.length !== d.length) return !1;
        for(d = 0; d < c.length; d++)if (!pc.call(b, c[d]) || !oc(a[c[d]], b[c[d]])) return !1;
        return !0;
    }
    function rc(a, b) {
        if (a && a.defaultProps) {
            b = aa({}, b);
            a = a.defaultProps;
            for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        }
        return b;
    }
    var sc = {
        current: null
    }, tc = null, uc = null, vc = null;
    function wc() {
        vc = uc = tc = null;
    }
    function xc(a, b) {
        var c = a.type._context;
        Pa ? (z(sc, c._currentValue, a), c._currentValue = b) : (z(sc, c._currentValue2, a), c._currentValue2 = b);
    }
    function yc(a) {
        var b = sc.current;
        y(sc, a);
        a = a.type._context;
        Pa ? a._currentValue = b : a._currentValue2 = b;
    }
    function zc(a, b) {
        for(; null !== a;){
            var c = a.alternate;
            if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
            else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
            else break;
            a = a.return;
        }
    }
    function Ac(a, b) {
        tc = a;
        vc = uc = null;
        a = a.dependencies;
        null !== a && null !== a.firstContext && (a.expirationTime >= b && (Bc = !0), a.firstContext = null);
    }
    function Cc(a, b) {
        if (vc !== a && !1 !== b && 0 !== b) {
            if ("number" !== typeof b || 1073741823 === b) vc = a, b = 1073741823;
            b = {
                context: a,
                observedBits: b,
                next: null
            };
            if (null === uc) {
                if (null === tc) throw Error(n(308));
                uc = b;
                tc.dependencies = {
                    expirationTime: 0,
                    firstContext: b,
                    responders: null
                };
            } else uc = uc.next = b;
        }
        return Pa ? a._currentValue : a._currentValue2;
    }
    var Dc = !1;
    function Ec(a) {
        return {
            baseState: a,
            firstUpdate: null,
            lastUpdate: null,
            firstCapturedUpdate: null,
            lastCapturedUpdate: null,
            firstEffect: null,
            lastEffect: null,
            firstCapturedEffect: null,
            lastCapturedEffect: null
        };
    }
    function Fc(a) {
        return {
            baseState: a.baseState,
            firstUpdate: a.firstUpdate,
            lastUpdate: a.lastUpdate,
            firstCapturedUpdate: null,
            lastCapturedUpdate: null,
            firstEffect: null,
            lastEffect: null,
            firstCapturedEffect: null,
            lastCapturedEffect: null
        };
    }
    function Gc(a, b) {
        return {
            expirationTime: a,
            suspenseConfig: b,
            tag: 0,
            payload: null,
            callback: null,
            next: null,
            nextEffect: null
        };
    }
    function Hc(a, b) {
        null === a.lastUpdate ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
    }
    function Ic(a, b) {
        var c = a.alternate;
        if (null === c) {
            var d = a.updateQueue;
            var e = null;
            null === d && (d = a.updateQueue = Ec(a.memoizedState));
        } else d = a.updateQueue, e = c.updateQueue, null === d ? null === e ? (d = a.updateQueue = Ec(a.memoizedState), e = c.updateQueue = Ec(c.memoizedState)) : d = a.updateQueue = Fc(e) : null === e && (e = c.updateQueue = Fc(d));
        null === e || d === e ? Hc(d, b) : null === d.lastUpdate || null === e.lastUpdate ? (Hc(d, b), Hc(e, b)) : (Hc(d, b), e.lastUpdate = b);
    }
    function Jc(a, b) {
        var c = a.updateQueue;
        c = null === c ? a.updateQueue = Ec(a.memoizedState) : Kc(a, c);
        null === c.lastCapturedUpdate ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
    }
    function Kc(a, b) {
        var c = a.alternate;
        null !== c && b === c.updateQueue && (b = a.updateQueue = Fc(b));
        return b;
    }
    function Lc(a, b, c, d, e, f) {
        switch(c.tag){
            case 1:
                return a = c.payload, "function" === typeof a ? a.call(f, d, e) : a;
            case 3:
                a.effectTag = a.effectTag & -4097 | 64;
            case 0:
                a = c.payload;
                e = "function" === typeof a ? a.call(f, d, e) : a;
                if (null === e || void 0 === e) break;
                return aa({}, d, e);
            case 2:
                Dc = !0;
        }
        return d;
    }
    function Nc(a, b, c, d, e) {
        Dc = !1;
        b = Kc(a, b);
        for(var f = b.baseState, g = null, l = 0, h = b.firstUpdate, k = f; null !== h;){
            var p = h.expirationTime;
            p < e ? (null === g && (g = h, f = k), l < p && (l = p)) : (Oc(p, h.suspenseConfig), k = Lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastEffect ? b.firstEffect = b.lastEffect = h : (b.lastEffect.nextEffect = h, b.lastEffect = h)));
            h = h.next;
        }
        p = null;
        for(h = b.firstCapturedUpdate; null !== h;){
            var D = h.expirationTime;
            D < e ? (null === p && (p = h, null === g && (f = k)), l < D && (l = D)) : (k = Lc(a, b, h, k, c, d), null !== h.callback && (a.effectTag |= 32, h.nextEffect = null, null === b.lastCapturedEffect ? b.firstCapturedEffect = b.lastCapturedEffect = h : (b.lastCapturedEffect.nextEffect = h, b.lastCapturedEffect = h)));
            h = h.next;
        }
        null === g && (b.lastUpdate = null);
        null === p ? b.lastCapturedUpdate = null : a.effectTag |= 32;
        null === g && null === p && (f = k);
        b.baseState = f;
        b.firstUpdate = g;
        b.firstCapturedUpdate = p;
        Pc(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
    function Qc(a, b, c) {
        null !== b.firstCapturedUpdate && (null !== b.lastUpdate && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
        Rc(b.firstEffect, c);
        b.firstEffect = b.lastEffect = null;
        Rc(b.firstCapturedEffect, c);
        b.firstCapturedEffect = b.lastCapturedEffect = null;
    }
    function Rc(a, b) {
        for(; null !== a;){
            var c = a.callback;
            if (null !== c) {
                a.callback = null;
                var d = b;
                if ("function" !== typeof c) throw Error(n(191, c));
                c.call(d);
            }
            a = a.nextEffect;
        }
    }
    var Sc = q.ReactCurrentBatchConfig, Tc = (new ba.Component).refs;
    function Uc(a, b, c, d) {
        b = a.memoizedState;
        c = c(d, b);
        c = null === c || void 0 === c ? b : aa({}, b, c);
        a.memoizedState = c;
        d = a.updateQueue;
        null !== d && 0 === a.expirationTime && (d.baseState = c);
    }
    var Xc = {
        isMounted: function(a) {
            return (a = a._reactInternalFiber) ? ua(a) === a : !1;
        },
        enqueueSetState: function(a, b, c) {
            a = a._reactInternalFiber;
            var d = G(), e = Sc.suspense;
            d = Vc(d, a, e);
            e = Gc(d, e);
            e.payload = b;
            void 0 !== c && null !== c && (e.callback = c);
            Ic(a, e);
            Wc(a, d);
        },
        enqueueReplaceState: function(a, b, c) {
            a = a._reactInternalFiber;
            var d = G(), e = Sc.suspense;
            d = Vc(d, a, e);
            e = Gc(d, e);
            e.tag = 1;
            e.payload = b;
            void 0 !== c && null !== c && (e.callback = c);
            Ic(a, e);
            Wc(a, d);
        },
        enqueueForceUpdate: function(a, b) {
            a = a._reactInternalFiber;
            var c = G(), d = Sc.suspense;
            c = Vc(c, a, d);
            d = Gc(c, d);
            d.tag = 2;
            void 0 !== b && null !== b && (d.callback = b);
            Ic(a, d);
            Wc(a, c);
        }
    };
    function Yc(a, b, c, d, e, f, g) {
        a = a.stateNode;
        return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !qc(c, d) || !qc(e, f) : !0;
    }
    function Zc(a, b, c) {
        var d = !1, e = Db;
        var f = b.contextType;
        "object" === typeof f && null !== f ? f = Cc(f) : (e = C(b) ? Eb : A.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Fb(a, e) : Db);
        b = new b(c, f);
        a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
        b.updater = Xc;
        a.stateNode = b;
        b._reactInternalFiber = a;
        d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
        return b;
    }
    function $c(a, b, c, d) {
        a = b.state;
        "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
        "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
        b.state !== a && Xc.enqueueReplaceState(b, b.state, null);
    }
    function ad(a, b, c, d) {
        var e = a.stateNode;
        e.props = c;
        e.state = a.memoizedState;
        e.refs = Tc;
        var f = b.contextType;
        "object" === typeof f && null !== f ? e.context = Cc(f) : (f = C(b) ? Eb : A.current, e.context = Fb(a, f));
        f = a.updateQueue;
        null !== f && (Nc(a, f, c, e, d), e.state = a.memoizedState);
        f = b.getDerivedStateFromProps;
        "function" === typeof f && (Uc(a, b, f, c), e.state = a.memoizedState);
        "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Xc.enqueueReplaceState(e, e.state, null), f = a.updateQueue, null !== f && (Nc(a, f, c, e, d), e.state = a.memoizedState));
        "function" === typeof e.componentDidMount && (a.effectTag |= 4);
    }
    var bd = Array.isArray;
    function cd(a, b, c) {
        a = c.ref;
        if (null !== a && "function" !== typeof a && "object" !== typeof a) {
            if (c._owner) {
                c = c._owner;
                if (c) {
                    if (1 !== c.tag) throw Error(n(309));
                    var d = c.stateNode;
                }
                if (!d) throw Error(n(147, a));
                var e = "" + a;
                if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
                b = function(b) {
                    var a = d.refs;
                    a === Tc && (a = d.refs = {});
                    null === b ? delete a[e] : a[e] = b;
                };
                b._stringRef = e;
                return b;
            }
            if ("string" !== typeof a) throw Error(n(284));
            if (!c._owner) throw Error(n(290, a));
        }
        return a;
    }
    function dd(a, b) {
        if ("textarea" !== a.type) throw Error(n(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
    }
    function ed(a) {
        function b(b, c) {
            if (a) {
                var d = b.lastEffect;
                null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
                c.nextEffect = null;
                c.effectTag = 8;
            }
        }
        function c(c, d) {
            if (!a) return null;
            for(; null !== d;)b(c, d), d = d.sibling;
            return null;
        }
        function d(b, a) {
            for(b = new Map; null !== a;)null !== a.key ? b.set(a.key, a) : b.set(a.index, a), a = a.sibling;
            return b;
        }
        function e(b, a, c) {
            b = fd(b, a, c);
            b.index = 0;
            b.sibling = null;
            return b;
        }
        function f(b, c, d) {
            b.index = d;
            if (!a) return c;
            d = b.alternate;
            if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
            b.effectTag = 2;
            return c;
        }
        function g(b) {
            a && null === b.alternate && (b.effectTag = 2);
            return b;
        }
        function l(b, a, c, d) {
            if (null === a || 6 !== a.tag) return a = gd(c, b.mode, d), a.return = b, a;
            a = e(a, c, d);
            a.return = b;
            return a;
        }
        function h(b, a, c, d) {
            if (null !== a && a.elementType === c.type) return d = e(a, c.props, d), d.ref = cd(b, a, c), d.return = b, d;
            d = hd(c.type, c.key, c.props, null, b.mode, d);
            d.ref = cd(b, a, c);
            d.return = b;
            return d;
        }
        function k(b, a, c, d) {
            if (null === a || 4 !== a.tag || a.stateNode.containerInfo !== c.containerInfo || a.stateNode.implementation !== c.implementation) return a = id(c, b.mode, d), a.return = b, a;
            a = e(a, c.children || [], d);
            a.return = b;
            return a;
        }
        function p(b, a, c, d, f) {
            if (null === a || 7 !== a.tag) return a = jd(c, b.mode, d, f), a.return = b, a;
            a = e(a, c, d);
            a.return = b;
            return a;
        }
        function D(b, a, c) {
            if ("string" === typeof a || "number" === typeof a) return a = gd("" + a, b.mode, c), a.return = b, a;
            if ("object" === typeof a && null !== a) {
                switch(a.$$typeof){
                    case ca:
                        return c = hd(a.type, a.key, a.props, null, b.mode, c), c.ref = cd(b, null, a), c.return = b, c;
                    case da:
                        return a = id(a, b.mode, c), a.return = b, a;
                }
                if (bd(a) || ra(a)) return a = jd(a, b.mode, c, null), a.return = b, a;
                dd(b, a);
            }
            return null;
        }
        function x(b, a, c, d) {
            var e = null !== a ? a.key : null;
            if ("string" === typeof c || "number" === typeof c) return null !== e ? null : l(b, a, "" + c, d);
            if ("object" === typeof c && null !== c) {
                switch(c.$$typeof){
                    case ca:
                        return c.key === e ? c.type === ea ? p(b, a, c.props.children, d, e) : h(b, a, c, d) : null;
                    case da:
                        return c.key === e ? k(b, a, c, d) : null;
                }
                if (bd(c) || ra(c)) return null !== e ? null : p(b, a, c, d, null);
                dd(b, c);
            }
            return null;
        }
        function K(b, a, c, d, e) {
            if ("string" === typeof d || "number" === typeof d) return b = b.get(c) || null, l(a, b, "" + d, e);
            if ("object" === typeof d && null !== d) {
                switch(d.$$typeof){
                    case ca:
                        return b = b.get(null === d.key ? c : d.key) || null, d.type === ea ? p(a, b, d.props.children, e, d.key) : h(a, b, d, e);
                    case da:
                        return b = b.get(null === d.key ? c : d.key) || null, k(a, b, d, e);
                }
                if (bd(d) || ra(d)) return b = b.get(c) || null, p(a, b, d, e, null);
                dd(a, d);
            }
            return null;
        }
        function Ha(e, g, h, l) {
            for(var k = null, w = null, t = g, r = g = 0, p = null; null !== t && r < h.length; r++){
                t.index > r ? (p = t, t = null) : p = t.sibling;
                var v = x(e, t, h[r], l);
                if (null === v) {
                    null === t && (t = p);
                    break;
                }
                a && t && null === v.alternate && b(e, t);
                g = f(v, g, r);
                null === w ? k = v : w.sibling = v;
                w = v;
                t = p;
            }
            if (r === h.length) return c(e, t), k;
            if (null === t) {
                for(; r < h.length; r++)t = D(e, h[r], l), null !== t && (g = f(t, g, r), null === w ? k = t : w.sibling = t, w = t);
                return k;
            }
            for(t = d(e, t); r < h.length; r++)p = K(t, e, r, h[r], l), null !== p && (a && null !== p.alternate && t.delete(null === p.key ? r : p.key), g = f(p, g, r), null === w ? k = p : w.sibling = p, w = p);
            a && t.forEach(function(a) {
                return b(e, a);
            });
            return k;
        }
        function O(e, g, h, l) {
            var k = ra(h);
            if ("function" !== typeof k) throw Error(n(150));
            h = k.call(h);
            if (null == h) throw Error(n(151));
            for(var t = k = null, r = g, w = g = 0, p = null, v = h.next(); null !== r && !v.done; w++, v = h.next()){
                r.index > w ? (p = r, r = null) : p = r.sibling;
                var N = x(e, r, v.value, l);
                if (null === N) {
                    null === r && (r = p);
                    break;
                }
                a && r && null === N.alternate && b(e, r);
                g = f(N, g, w);
                null === t ? k = N : t.sibling = N;
                t = N;
                r = p;
            }
            if (v.done) return c(e, r), k;
            if (null === r) {
                for(; !v.done; w++, v = h.next())v = D(e, v.value, l), null !== v && (g = f(v, g, w), null === t ? k = v : t.sibling = v, t = v);
                return k;
            }
            for(r = d(e, r); !v.done; w++, v = h.next())v = K(r, e, w, v.value, l), null !== v && (a && null !== v.alternate && r.delete(null === v.key ? w : v.key), g = f(v, g, w), null === t ? k = v : t.sibling = v, t = v);
            a && r.forEach(function(a) {
                return b(e, a);
            });
            return k;
        }
        return function(a, d, f, h) {
            var k = "object" === typeof f && null !== f && f.type === ea && null === f.key;
            k && (f = f.props.children);
            var l = "object" === typeof f && null !== f;
            if (l) switch(f.$$typeof){
                case ca:
                    a: {
                        l = f.key;
                        for(k = d; null !== k;){
                            if (k.key === l) {
                                if (7 === k.tag ? f.type === ea : k.elementType === f.type) {
                                    c(a, k.sibling);
                                    d = e(k, f.type === ea ? f.props.children : f.props, h);
                                    d.ref = cd(a, k, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, k);
                                    break;
                                }
                            } else b(a, k);
                            k = k.sibling;
                        }
                        f.type === ea ? (d = jd(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = hd(f.type, f.key, f.props, null, a.mode, h), h.ref = cd(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case da:
                    a: {
                        for(k = f.key; null !== d;){
                            if (d.key === k) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || [], h);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = id(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
            }
            if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, h), d.return = a, a = d) : (c(a, d), d = gd(f, a.mode, h), d.return = a, a = d), g(a);
            if (bd(f)) return Ha(a, d, f, h);
            if (ra(f)) return O(a, d, f, h);
            l && dd(a, f);
            if ("undefined" === typeof f && !k) switch(a.tag){
                case 1:
                case 0:
                    throw a = a.type, Error(n(152, a.displayName || a.name || "Component"));
            }
            return c(a, d);
        };
    }
    var kd = ed(!0), ld = ed(!1), md = {}, H = {
        current: md
    }, nd = {
        current: md
    }, od = {
        current: md
    };
    function pd(a) {
        if (a === md) throw Error(n(174));
        return a;
    }
    function qd(a, b) {
        z(od, b, a);
        z(nd, a, a);
        z(H, md, a);
        b = Aa(b);
        y(H, a);
        z(H, b, a);
    }
    function rd(a) {
        y(H, a);
        y(nd, a);
        y(od, a);
    }
    function sd(a) {
        var b = pd(od.current), c = pd(H.current);
        b = Ba(c, a.type, b);
        c !== b && (z(nd, a, a), z(H, b, a));
    }
    function td(a) {
        nd.current === a && (y(H, a), y(nd, a));
    }
    var I = {
        current: 0
    };
    function ud(a) {
        for(var b = a; null !== b;){
            if (13 === b.tag) {
                var c = b.memoizedState;
                if (null !== c && (c = c.dehydrated, null === c || qb(c) || rb(c))) return b;
            } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
                if (0 !== (b.effectTag & 64)) return b;
            } else if (null !== b.child) {
                b.child.return = b;
                b = b.child;
                continue;
            }
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
        return null;
    }
    function vd(a, b) {
        return {
            responder: a,
            props: b
        };
    }
    var wd = q.ReactCurrentDispatcher, J = q.ReactCurrentBatchConfig, xd = 0, yd = null, L = null, zd = null, Ad = null, M = null, Bd = null, Cd = 0, Dd = null, Ed = 0, Fd = !1, Gd = null, Hd = 0;
    function P() {
        throw Error(n(321));
    }
    function Id(a, b) {
        if (null === b) return !1;
        for(var c = 0; c < b.length && c < a.length; c++)if (!oc(a[c], b[c])) return !1;
        return !0;
    }
    function Jd(a, b, c, d, e, f) {
        xd = f;
        yd = b;
        zd = null !== a ? a.memoizedState : null;
        wd.current = null === zd ? Kd : Ld;
        b = c(d, e);
        if (Fd) {
            do Fd = !1, Hd += 1, zd = null !== a ? a.memoizedState : null, Bd = Ad, Dd = M = L = null, wd.current = Ld, b = c(d, e);
            while (Fd);
            Gd = null;
            Hd = 0;
        }
        wd.current = Md;
        a = yd;
        a.memoizedState = Ad;
        a.expirationTime = Cd;
        a.updateQueue = Dd;
        a.effectTag |= Ed;
        a = null !== L && null !== L.next;
        xd = 0;
        Bd = M = Ad = zd = L = yd = null;
        Cd = 0;
        Dd = null;
        Ed = 0;
        if (a) throw Error(n(300));
        return b;
    }
    function Nd() {
        wd.current = Md;
        xd = 0;
        Bd = M = Ad = zd = L = yd = null;
        Cd = 0;
        Dd = null;
        Ed = 0;
        Fd = !1;
        Gd = null;
        Hd = 0;
    }
    function Od() {
        var a = {
            memoizedState: null,
            baseState: null,
            queue: null,
            baseUpdate: null,
            next: null
        };
        null === M ? Ad = M = a : M = M.next = a;
        return M;
    }
    function Pd() {
        if (null !== Bd) M = Bd, Bd = M.next, L = zd, zd = null !== L ? L.next : null;
        else {
            if (null === zd) throw Error(n(310));
            L = zd;
            var a = {
                memoizedState: L.memoizedState,
                baseState: L.baseState,
                queue: L.queue,
                baseUpdate: L.baseUpdate,
                next: null
            };
            M = null === M ? Ad = a : M.next = a;
            zd = L.next;
        }
        return M;
    }
    function Qd(a, b) {
        return "function" === typeof b ? b(a) : b;
    }
    function Rd(a) {
        var b = Pd(), c = b.queue;
        if (null === c) throw Error(n(311));
        c.lastRenderedReducer = a;
        if (0 < Hd) {
            var d = c.dispatch;
            if (null !== Gd) {
                var e = Gd.get(c);
                if (void 0 !== e) {
                    Gd.delete(c);
                    var f = b.memoizedState;
                    do f = a(f, e.action), e = e.next;
                    while (null !== e);
                    oc(f, b.memoizedState) || (Bc = !0);
                    b.memoizedState = f;
                    b.baseUpdate === c.last && (b.baseState = f);
                    c.lastRenderedState = f;
                    return [
                        f,
                        d
                    ];
                }
            }
            return [
                b.memoizedState,
                d
            ];
        }
        d = c.last;
        var g = b.baseUpdate;
        f = b.baseState;
        null !== g ? (null !== d && (d.next = null), d = g.next) : d = null !== d ? d.next : null;
        if (null !== d) {
            var l = e = null, h = d, k = !1;
            do {
                var p = h.expirationTime;
                p < xd ? (k || (k = !0, l = g, e = f), p > Cd && (Cd = p, Pc(Cd))) : (Oc(p, h.suspenseConfig), f = h.eagerReducer === a ? h.eagerState : a(f, h.action));
                g = h;
                h = h.next;
            }while (null !== h && h !== d);
            k || (l = g, e = f);
            oc(f, b.memoizedState) || (Bc = !0);
            b.memoizedState = f;
            b.baseUpdate = l;
            b.baseState = e;
            c.lastRenderedState = f;
        }
        return [
            b.memoizedState,
            c.dispatch
        ];
    }
    function Sd(a) {
        var b = Od();
        "function" === typeof a && (a = a());
        b.memoizedState = b.baseState = a;
        a = b.queue = {
            last: null,
            dispatch: null,
            lastRenderedReducer: Qd,
            lastRenderedState: a
        };
        a = a.dispatch = Td.bind(null, yd, a);
        return [
            b.memoizedState,
            a
        ];
    }
    function Ud(a) {
        return Rd(Qd, a);
    }
    function Vd(a, b, c, d) {
        a = {
            tag: a,
            create: b,
            destroy: c,
            deps: d,
            next: null
        };
        null === Dd ? (Dd = {
            lastEffect: null
        }, Dd.lastEffect = a.next = a) : (b = Dd.lastEffect, null === b ? Dd.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, Dd.lastEffect = a));
        return a;
    }
    function Wd(a, b, c, d) {
        var e = Od();
        Ed |= a;
        e.memoizedState = Vd(b, c, void 0, void 0 === d ? null : d);
    }
    function Xd(a, b, c, d) {
        var e = Pd();
        d = void 0 === d ? null : d;
        var f = void 0;
        if (null !== L) {
            var g = L.memoizedState;
            f = g.destroy;
            if (null !== d && Id(d, g.deps)) {
                Vd(0, c, f, d);
                return;
            }
        }
        Ed |= a;
        e.memoizedState = Vd(b, c, f, d);
    }
    function Yd(a, b) {
        return Wd(516, 192, a, b);
    }
    function Zd(a, b) {
        return Xd(516, 192, a, b);
    }
    function $d(a, b) {
        if ("function" === typeof b) return a = a(), b(a), function() {
            b(null);
        };
        if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
            b.current = null;
        };
    }
    function ae() {}
    function be(a, b) {
        Od().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    }
    function ce(a, b) {
        var c = Pd();
        b = void 0 === b ? null : b;
        var d = c.memoizedState;
        if (null !== d && null !== b && Id(b, d[1])) return d[0];
        c.memoizedState = [
            a,
            b
        ];
        return a;
    }
    function Td(a, b, c) {
        if (!(25 > Hd)) throw Error(n(301));
        var d = a.alternate;
        if (a === yd || null !== d && d === yd) {
            if (Fd = !0, a = {
                expirationTime: xd,
                suspenseConfig: null,
                action: c,
                eagerReducer: null,
                eagerState: null,
                next: null
            }, null === Gd && (Gd = new Map), c = Gd.get(b), void 0 === c) Gd.set(b, a);
            else {
                for(b = c; null !== b.next;)b = b.next;
                b.next = a;
            }
        } else {
            var e = G(), f = Sc.suspense;
            e = Vc(e, a, f);
            f = {
                expirationTime: e,
                suspenseConfig: f,
                action: c,
                eagerReducer: null,
                eagerState: null,
                next: null
            };
            var g = b.last;
            if (null === g) f.next = f;
            else {
                var l = g.next;
                null !== l && (f.next = l);
                g.next = f;
            }
            b.last = f;
            if (0 === a.expirationTime && (null === d || 0 === d.expirationTime) && (d = b.lastRenderedReducer, null !== d)) try {
                var h = b.lastRenderedState, k = d(h, c);
                f.eagerReducer = d;
                f.eagerState = k;
                if (oc(k, h)) return;
            } catch (p) {} finally{}
            Wc(a, e);
        }
    }
    var Md = {
        readContext: Cc,
        useCallback: P,
        useContext: P,
        useEffect: P,
        useImperativeHandle: P,
        useLayoutEffect: P,
        useMemo: P,
        useReducer: P,
        useRef: P,
        useState: P,
        useDebugValue: P,
        useResponder: P,
        useDeferredValue: P,
        useTransition: P
    }, Kd = {
        readContext: Cc,
        useCallback: be,
        useContext: Cc,
        useEffect: Yd,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return Wd(4, 36, $d.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return Wd(4, 36, a, b);
        },
        useMemo: function(a, b) {
            var c = Od();
            b = void 0 === b ? null : b;
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: function(a, b, c) {
            var d = Od();
            b = void 0 !== c ? c(b) : b;
            d.memoizedState = d.baseState = b;
            a = d.queue = {
                last: null,
                dispatch: null,
                lastRenderedReducer: a,
                lastRenderedState: b
            };
            a = a.dispatch = Td.bind(null, yd, a);
            return [
                d.memoizedState,
                a
            ];
        },
        useRef: function(a) {
            var b = Od();
            a = {
                current: a
            };
            return b.memoizedState = a;
        },
        useState: Sd,
        useDebugValue: ae,
        useResponder: vd,
        useDeferredValue: function(a, b) {
            var c = Sd(a), d = c[0], e = c[1];
            Yd(function() {
                m.unstable_next(function() {
                    var c = J.suspense;
                    J.suspense = void 0 === b ? null : b;
                    try {
                        e(a);
                    } finally{
                        J.suspense = c;
                    }
                });
            }, [
                a,
                b
            ]);
            return d;
        },
        useTransition: function(a) {
            var b = Sd(!1), c = b[0], d = b[1];
            return [
                be(function(b) {
                    d(!0);
                    m.unstable_next(function() {
                        var c = J.suspense;
                        J.suspense = void 0 === a ? null : a;
                        try {
                            d(!1), b();
                        } finally{
                            J.suspense = c;
                        }
                    });
                }, [
                    a,
                    c
                ]),
                c
            ];
        }
    }, Ld = {
        readContext: Cc,
        useCallback: ce,
        useContext: Cc,
        useEffect: Zd,
        useImperativeHandle: function(a, b, c) {
            c = null !== c && void 0 !== c ? c.concat([
                a
            ]) : null;
            return Xd(4, 36, $d.bind(null, b, a), c);
        },
        useLayoutEffect: function(a, b) {
            return Xd(4, 36, a, b);
        },
        useMemo: function(a, b) {
            var c = Pd();
            b = void 0 === b ? null : b;
            var d = c.memoizedState;
            if (null !== d && null !== b && Id(b, d[1])) return d[0];
            a = a();
            c.memoizedState = [
                a,
                b
            ];
            return a;
        },
        useReducer: Rd,
        useRef: function() {
            return Pd().memoizedState;
        },
        useState: Ud,
        useDebugValue: ae,
        useResponder: vd,
        useDeferredValue: function(a, b) {
            var c = Ud(a), d = c[0], e = c[1];
            Zd(function() {
                m.unstable_next(function() {
                    var c = J.suspense;
                    J.suspense = void 0 === b ? null : b;
                    try {
                        e(a);
                    } finally{
                        J.suspense = c;
                    }
                });
            }, [
                a,
                b
            ]);
            return d;
        },
        useTransition: function(a) {
            var b = Ud(!1), c = b[0], d = b[1];
            return [
                ce(function(b) {
                    d(!0);
                    m.unstable_next(function() {
                        var c = J.suspense;
                        J.suspense = void 0 === a ? null : a;
                        try {
                            d(!1), b();
                        } finally{
                            J.suspense = c;
                        }
                    });
                }, [
                    a,
                    c
                ]),
                c
            ];
        }
    }, de = null, ee = null, fe = !1;
    function ge(a, b) {
        var c = he(5, null, null, 0);
        c.elementType = "DELETED";
        c.type = "DELETED";
        c.stateNode = b;
        c.return = a;
        c.effectTag = 8;
        null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
    }
    function ie(a, b) {
        switch(a.tag){
            case 5:
                return b = ob(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
            case 6:
                return b = pb(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;
            case 13:
                return !1;
            default:
                return !1;
        }
    }
    function je(a) {
        if (fe) {
            var b = ee;
            if (b) {
                var c = b;
                if (!ie(a, b)) {
                    b = sb(c);
                    if (!b || !ie(a, b)) {
                        a.effectTag = a.effectTag & -1025 | 2;
                        fe = !1;
                        de = a;
                        return;
                    }
                    ge(de, c);
                }
                de = a;
                ee = tb(b);
            } else a.effectTag = a.effectTag & -1025 | 2, fe = !1, de = a;
        }
    }
    function ke(a) {
        for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
        de = a;
    }
    function ne(a) {
        if (!Sa || a !== de) return !1;
        if (!fe) return ke(a), fe = !0, !1;
        var b = a.type;
        if (5 !== a.tag || "head" !== b && "body" !== b && !Ja(b, a.memoizedProps)) for(b = ee; b;)ge(a, b), b = sb(b);
        ke(a);
        if (13 === a.tag) {
            if (!Sa) throw Error(n(316));
            a = a.memoizedState;
            a = null !== a ? a.dehydrated : null;
            if (!a) throw Error(n(317));
            ee = wb(a);
        } else ee = de ? sb(a.stateNode) : null;
        return !0;
    }
    function oe() {
        Sa && (ee = de = null, fe = !1);
    }
    var pe = q.ReactCurrentOwner, Bc = !1;
    function Q(a, b, c, d) {
        b.child = null === a ? ld(b, null, c, d) : kd(b, a.child, c, d);
    }
    function qe(a, b, c, d, e) {
        c = c.render;
        var f = b.ref;
        Ac(b, e);
        d = Jd(a, b, c, d, f, e);
        if (null !== a && !Bc) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), re(a, b, e);
        b.effectTag |= 1;
        Q(a, b, d, e);
        return b.child;
    }
    function se(a, b, c, d, e, f) {
        if (null === a) {
            var g = c.type;
            if ("function" === typeof g && !te(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ue(a, b, g, d, e, f);
            a = hd(c.type, null, d, null, b.mode, f);
            a.ref = b.ref;
            a.return = b;
            return b.child = a;
        }
        g = a.child;
        if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : qc, c(e, d) && a.ref === b.ref)) return re(a, b, f);
        b.effectTag |= 1;
        a = fd(g, d, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    function ue(a, b, c, d, e, f) {
        return null !== a && qc(a.memoizedProps, d) && a.ref === b.ref && (Bc = !1, e < f) ? re(a, b, f) : ve(a, b, c, d, f);
    }
    function we(a, b) {
        var c = b.ref;
        if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
    }
    function ve(a, b, c, d, e) {
        var f = C(c) ? Eb : A.current;
        f = Fb(b, f);
        Ac(b, e);
        c = Jd(a, b, c, d, f, e);
        if (null !== a && !Bc) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), re(a, b, e);
        b.effectTag |= 1;
        Q(a, b, c, e);
        return b.child;
    }
    function xe(a, b, c, d, e) {
        if (C(c)) {
            var f = !0;
            Kb(b);
        } else f = !1;
        Ac(b, e);
        if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Zc(b, c, d, e), ad(b, c, d, e), d = !0;
        else if (null === a) {
            var g = b.stateNode, l = b.memoizedProps;
            g.props = l;
            var h = g.context, k = c.contextType;
            "object" === typeof k && null !== k ? k = Cc(k) : (k = C(c) ? Eb : A.current, k = Fb(b, k));
            var p = c.getDerivedStateFromProps, D = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate;
            D || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (l !== d || h !== k) && $c(b, g, d, k);
            Dc = !1;
            var x = b.memoizedState;
            h = g.state = x;
            var K = b.updateQueue;
            null !== K && (Nc(b, K, d, g, e), h = b.memoizedState);
            l !== d || x !== h || B.current || Dc ? ("function" === typeof p && (Uc(b, c, p, d), h = b.memoizedState), (l = Dc || Yc(b, c, l, d, x, h, k)) ? (D || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = h), g.props = d, g.state = h, g.context = k, d = l) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
        } else g = b.stateNode, l = b.memoizedProps, g.props = b.type === b.elementType ? l : rc(b.type, l), h = g.context, k = c.contextType, "object" === typeof k && null !== k ? k = Cc(k) : (k = C(c) ? Eb : A.current, k = Fb(b, k)), p = c.getDerivedStateFromProps, (D = "function" === typeof p || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (l !== d || h !== k) && $c(b, g, d, k), Dc = !1, h = b.memoizedState, x = g.state = h, K = b.updateQueue, null !== K && (Nc(b, K, d, g, e), x = b.memoizedState), l !== d || h !== x || B.current || Dc ? ("function" === typeof p && (Uc(b, c, p, d), x = b.memoizedState), (p = Dc || Yc(b, c, l, d, h, x, k)) ? (D || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = p) : ("function" !== typeof g.componentDidUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || l === a.memoizedProps && h === a.memoizedState || (b.effectTag |= 256), d = !1);
        return ye(a, b, c, d, f, e);
    }
    function ye(a, b, c, d, e, f) {
        we(a, b);
        var g = 0 !== (b.effectTag & 64);
        if (!d && !g) return e && Lb(b, c, !1), re(a, b, f);
        d = b.stateNode;
        pe.current = b;
        var l = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
        b.effectTag |= 1;
        null !== a && g ? (b.child = kd(b, a.child, null, f), b.child = kd(b, null, l, f)) : Q(a, b, l, f);
        b.memoizedState = d.state;
        e && Lb(b, c, !0);
        return b.child;
    }
    function ze(a) {
        var b = a.stateNode;
        b.pendingContext ? Ib(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ib(a, b.context, !1);
        qd(a, b.containerInfo);
    }
    var Ae = {
        dehydrated: null,
        retryTime: 0
    };
    function Be(a, b, c) {
        var d = b.mode, e = b.pendingProps, f = I.current, g = !1, l;
        (l = 0 !== (b.effectTag & 64)) || (l = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
        l ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
        z(I, f & 1, b);
        if (null === a) {
            void 0 !== e.fallback && je(b);
            if (g) {
                g = e.fallback;
                e = jd(null, d, 0, null);
                e.return = b;
                if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
                c = jd(g, d, c, null);
                c.return = b;
                e.sibling = c;
                b.memoizedState = Ae;
                b.child = e;
                return c;
            }
            d = e.children;
            b.memoizedState = null;
            return b.child = ld(b, null, d, c);
        }
        if (null !== a.memoizedState) {
            a = a.child;
            d = a.sibling;
            if (g) {
                e = e.fallback;
                c = fd(a, a.pendingProps, 0);
                c.return = b;
                if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
                d = fd(d, e, d.expirationTime);
                d.return = b;
                c.sibling = d;
                c.childExpirationTime = 0;
                b.memoizedState = Ae;
                b.child = c;
                return d;
            }
            c = kd(b, a.child, e.children, c);
            b.memoizedState = null;
            return b.child = c;
        }
        a = a.child;
        if (g) {
            g = e.fallback;
            e = jd(null, d, 0, null);
            e.return = b;
            e.child = a;
            null !== a && (a.return = e);
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = jd(g, d, c, null);
            c.return = b;
            e.sibling = c;
            c.effectTag |= 2;
            e.childExpirationTime = 0;
            b.memoizedState = Ae;
            b.child = e;
            return c;
        }
        b.memoizedState = null;
        return b.child = kd(b, a, e.children, c);
    }
    function Ce(a, b) {
        a.expirationTime < b && (a.expirationTime = b);
        var c = a.alternate;
        null !== c && c.expirationTime < b && (c.expirationTime = b);
        zc(a.return, b);
    }
    function De(a, b, c, d, e, f) {
        var g = a.memoizedState;
        null === g ? a.memoizedState = {
            isBackwards: b,
            rendering: null,
            last: d,
            tail: c,
            tailExpiration: 0,
            tailMode: e,
            lastEffect: f
        } : (g.isBackwards = b, g.rendering = null, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
    }
    function Ee(a, b, c) {
        var d = b.pendingProps, e = d.revealOrder, f = d.tail;
        Q(a, b, d.children, c);
        d = I.current;
        if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
        else {
            if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
                if (13 === a.tag) null !== a.memoizedState && Ce(a, c);
                else if (19 === a.tag) Ce(a, c);
                else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === b) break a;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === b) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            d &= 1;
        }
        z(I, d, b);
        if (0 === (b.mode & 2)) b.memoizedState = null;
        else switch(e){
            case "forwards":
                c = b.child;
                for(e = null; null !== c;)a = c.alternate, null !== a && null === ud(a) && (e = c), c = c.sibling;
                c = e;
                null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
                De(b, !1, e, c, f, b.lastEffect);
                break;
            case "backwards":
                c = null;
                e = b.child;
                for(b.child = null; null !== e;){
                    a = e.alternate;
                    if (null !== a && null === ud(a)) {
                        b.child = e;
                        break;
                    }
                    a = e.sibling;
                    e.sibling = c;
                    c = e;
                    e = a;
                }
                De(b, !0, c, null, f, b.lastEffect);
                break;
            case "together":
                De(b, !1, null, null, void 0, b.lastEffect);
                break;
            default:
                b.memoizedState = null;
        }
        return b.child;
    }
    function re(a, b, c) {
        null !== a && (b.dependencies = a.dependencies);
        var d = b.expirationTime;
        0 !== d && Pc(d);
        if (b.childExpirationTime < c) return null;
        if (null !== a && b.child !== a.child) throw Error(n(153));
        if (null !== b.child) {
            a = b.child;
            c = fd(a, a.pendingProps, a.expirationTime);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = fd(a, a.pendingProps, a.expirationTime), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    function Fe(a) {
        a.effectTag |= 4;
    }
    var Ge, He, Ie, Je;
    if (Qa) Ge = function(a, b) {
        for(var c = b.child; null !== c;){
            if (5 === c.tag || 6 === c.tag) Fa(a, c.stateNode);
            else if (4 !== c.tag && null !== c.child) {
                c.child.return = c;
                c = c.child;
                continue;
            }
            if (c === b) break;
            for(; null === c.sibling;){
                if (null === c.return || c.return === b) return;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }, He = function() {}, Ie = function(a, b, c, d, e) {
        a = a.memoizedProps;
        if (a !== d) {
            var f = b.stateNode, g = pd(H.current);
            c = Ia(f, c, a, d, e, g);
            (b.updateQueue = c) && Fe(b);
        }
    }, Je = function(a, b, c, d) {
        c !== d && Fe(b);
    };
    else if (Ra) {
        Ge = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = mb(f, e.type, e.memoizedProps, e));
                    Fa(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = nb(f, e.memoizedProps, e)), Fa(a, f);
                else if (4 !== e.tag) {
                    if (13 === e.tag && 0 !== (e.effectTag & 4) && (f = null !== e.memoizedState)) {
                        var g = e.child;
                        if (null !== g && (null !== g.child && (g.child.return = g, Ge(a, g, !0, f)), f = g.sibling, null !== f)) {
                            f.return = e;
                            e = f;
                            continue;
                        }
                    }
                    if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        var Ke = function(a, b, c, d) {
            for(var e = b.child; null !== e;){
                if (5 === e.tag) {
                    var f = e.stateNode;
                    c && d && (f = mb(f, e.type, e.memoizedProps, e));
                    ib(a, f);
                } else if (6 === e.tag) f = e.stateNode, c && d && (f = nb(f, e.memoizedProps, e)), ib(a, f);
                else if (4 !== e.tag) {
                    if (13 === e.tag && 0 !== (e.effectTag & 4) && (f = null !== e.memoizedState)) {
                        var g = e.child;
                        if (null !== g && (null !== g.child && (g.child.return = g, Ke(a, g, !0, f)), f = g.sibling, null !== f)) {
                            f.return = e;
                            e = f;
                            continue;
                        }
                    }
                    if (null !== e.child) {
                        e.child.return = e;
                        e = e.child;
                        continue;
                    }
                }
                if (e === b) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === b) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        };
        He = function(a) {
            var b = a.stateNode;
            if (null !== a.firstEffect) {
                var c = b.containerInfo, d = hb(c);
                Ke(d, a, !1, !1);
                b.pendingChildren = d;
                Fe(a);
                kb(c, d);
            }
        };
        Ie = function(a, b, c, d, e) {
            var f = a.stateNode, g = a.memoizedProps;
            if ((a = null === b.firstEffect) && g === d) b.stateNode = f;
            else {
                var l = b.stateNode, h = pd(H.current), k = null;
                g !== d && (k = Ia(l, c, g, d, e, h));
                a && null === k ? b.stateNode = f : (f = gb(f, k, c, g, d, b, a, l), Ga(f, c, d, e, h) && Fe(b), b.stateNode = f, a ? Fe(b) : Ge(f, b, !1, !1));
            }
        };
        Je = function(a, b, c, d) {
            c !== d && (a = pd(od.current), c = pd(H.current), b.stateNode = La(d, a, c, b), Fe(b));
        };
    } else He = function() {}, Ie = function() {}, Je = function() {};
    function Le(a, b) {
        switch(a.tailMode){
            case "hidden":
                b = a.tail;
                for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
                null === c ? a.tail = null : c.sibling = null;
                break;
            case "collapsed":
                c = a.tail;
                for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
                null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
        }
    }
    function Me(a) {
        switch(a.tag){
            case 1:
                C(a.type) && Gb(a);
                var b = a.effectTag;
                return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
            case 3:
                rd(a);
                Hb(a);
                b = a.effectTag;
                if (0 !== (b & 64)) throw Error(n(285));
                a.effectTag = b & -4097 | 64;
                return a;
            case 5:
                return td(a), null;
            case 13:
                return y(I, a), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
            case 19:
                return y(I, a), null;
            case 4:
                return rd(a), null;
            case 10:
                return yc(a), null;
            default:
                return null;
        }
    }
    function Ne(a, b) {
        return {
            value: a,
            source: b,
            stack: Ab(b)
        };
    }
    var Oe = "function" === typeof WeakSet ? WeakSet : Set;
    function Pe(a, b) {
        var c = b.source, d = b.stack;
        null === d && null !== c && (d = Ab(c));
        null !== c && ta(c.type);
        b = b.value;
        null !== a && 1 === a.tag && ta(a.type);
        try {
            console.error(b);
        } catch (e) {
            setTimeout(function() {
                throw e;
            });
        }
    }
    function Qe(a, b) {
        try {
            b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
        } catch (c) {
            Re(a, c);
        }
    }
    function Se(a) {
        var b = a.ref;
        if (null !== b) {
            if ("function" === typeof b) try {
                b(null);
            } catch (c) {
                Re(a, c);
            }
            else b.current = null;
        }
    }
    function Te(a, b) {
        switch(b.tag){
            case 0:
            case 11:
            case 15:
                Ue(2, 0, b);
                break;
            case 1:
                if (b.effectTag & 256 && null !== a) {
                    var c = a.memoizedProps, d = a.memoizedState;
                    a = b.stateNode;
                    b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : rc(b.type, c), d);
                    a.__reactInternalSnapshotBeforeUpdate = b;
                }
                break;
            case 3:
            case 5:
            case 6:
            case 4:
            case 17:
                break;
            default:
                throw Error(n(163));
        }
    }
    function Ue(a, b, c) {
        c = c.updateQueue;
        c = null !== c ? c.lastEffect : null;
        if (null !== c) {
            var d = c = c.next;
            do {
                if (0 !== (d.tag & a)) {
                    var e = d.destroy;
                    d.destroy = void 0;
                    void 0 !== e && e();
                }
                0 !== (d.tag & b) && (e = d.create, d.destroy = e());
                d = d.next;
            }while (d !== c);
        }
    }
    function Ve(a, b, c) {
        "function" === typeof We && We(b);
        switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                a = b.updateQueue;
                if (null !== a && (a = a.lastEffect, null !== a)) {
                    var d = a.next;
                    hc(97 < c ? 97 : c, function() {
                        var a = d;
                        do {
                            var c = a.destroy;
                            if (void 0 !== c) {
                                var g = b;
                                try {
                                    c();
                                } catch (l) {
                                    Re(g, l);
                                }
                            }
                            a = a.next;
                        }while (a !== d);
                    });
                }
                break;
            case 1:
                Se(b);
                c = b.stateNode;
                "function" === typeof c.componentWillUnmount && Qe(b, c);
                break;
            case 5:
                Se(b);
                break;
            case 4:
                Qa ? Xe(a, b, c) : Ra && Ye(b);
        }
    }
    function Ze(a, b, c) {
        for(var d = b;;)if (Ve(a, d, c), null === d.child || Qa && 4 === d.tag) {
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
            }
            d.sibling.return = d.return;
            d = d.sibling;
        } else d.child.return = d, d = d.child;
    }
    function $e(a) {
        var b = a.alternate;
        a.return = null;
        a.child = null;
        a.memoizedState = null;
        a.updateQueue = null;
        a.dependencies = null;
        a.alternate = null;
        a.firstEffect = null;
        a.lastEffect = null;
        a.pendingProps = null;
        a.memoizedProps = null;
        null !== b && $e(b);
    }
    function Ye(a) {
        if (Ra) {
            a = a.stateNode.containerInfo;
            var b = hb(a);
            lb(a, b);
        }
    }
    function af(a) {
        return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }
    function bf(a) {
        if (Qa) {
            a: {
                for(var b = a.return; null !== b;){
                    if (af(b)) {
                        var c = b;
                        break a;
                    }
                    b = b.return;
                }
                throw Error(n(160));
            }
            b = c.stateNode;
            switch(c.tag){
                case 5:
                    var d = !1;
                    break;
                case 3:
                    b = b.containerInfo;
                    d = !0;
                    break;
                case 4:
                    b = b.containerInfo;
                    d = !0;
                    break;
                default:
                    throw Error(n(161));
            }
            c.effectTag & 16 && (bb(b), c.effectTag &= -17);
            a: b: for(c = a;;){
                for(; null === c.sibling;){
                    if (null === c.return || af(c.return)) {
                        c = null;
                        break a;
                    }
                    c = c.return;
                }
                c.sibling.return = c.return;
                for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
                    if (c.effectTag & 2) continue b;
                    if (null === c.child || 4 === c.tag) continue b;
                    else c.child.return = c, c = c.child;
                }
                if (!(c.effectTag & 2)) {
                    c = c.stateNode;
                    break a;
                }
            }
            for(var e = a;;){
                var f = 5 === e.tag || 6 === e.tag;
                if (f) f = f ? e.stateNode : e.stateNode.instance, c ? d ? Za(b, f, c) : Ya(b, f, c) : d ? Ua(b, f) : Ta(b, f);
                else if (4 !== e.tag && null !== e.child) {
                    e.child.return = e;
                    e = e.child;
                    continue;
                }
                if (e === a) break;
                for(; null === e.sibling;){
                    if (null === e.return || e.return === a) return;
                    e = e.return;
                }
                e.sibling.return = e.return;
                e = e.sibling;
            }
        }
    }
    function Xe(a, b, c) {
        for(var d = b, e = !1, f, g;;){
            if (!e) {
                e = d.return;
                a: for(;;){
                    if (null === e) throw Error(n(160));
                    f = e.stateNode;
                    switch(e.tag){
                        case 5:
                            g = !1;
                            break a;
                        case 3:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                        case 4:
                            f = f.containerInfo;
                            g = !0;
                            break a;
                    }
                    e = e.return;
                }
                e = !0;
            }
            if (5 === d.tag || 6 === d.tag) Ze(a, d, c), g ? ab(f, d.stateNode) : $a(f, d.stateNode);
            else if (4 === d.tag) {
                if (null !== d.child) {
                    f = d.stateNode.containerInfo;
                    g = !0;
                    d.child.return = d;
                    d = d.child;
                    continue;
                }
            } else if (Ve(a, d, c), null !== d.child) {
                d.child.return = d;
                d = d.child;
                continue;
            }
            if (d === b) break;
            for(; null === d.sibling;){
                if (null === d.return || d.return === b) return;
                d = d.return;
                4 === d.tag && (e = !1);
            }
            d.sibling.return = d.return;
            d = d.sibling;
        }
    }
    function cf(a, b) {
        if (Qa) switch(b.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                Ue(4, 8, b);
                break;
            case 1:
                break;
            case 5:
                var c = b.stateNode;
                if (null != c) {
                    var d = b.memoizedProps;
                    a = null !== a ? a.memoizedProps : d;
                    var e = b.type, f = b.updateQueue;
                    b.updateQueue = null;
                    null !== f && Xa(c, f, e, a, d, b);
                }
                break;
            case 6:
                if (null === b.stateNode) throw Error(n(162));
                c = b.memoizedProps;
                Va(b.stateNode, null !== a ? a.memoizedProps : c, c);
                break;
            case 3:
                Sa && (b = b.stateNode, b.hydrate && (b.hydrate = !1, xb(b.containerInfo)));
                break;
            case 12:
                break;
            case 13:
                df(b);
                ef(b);
                break;
            case 19:
                ef(b);
                break;
            case 17:
                break;
            case 20:
                break;
            case 21:
                break;
            default:
                throw Error(n(163));
        }
        else {
            switch(b.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    Ue(4, 8, b);
                    return;
                case 12:
                    return;
                case 13:
                    df(b);
                    ef(b);
                    return;
                case 19:
                    ef(b);
                    return;
                case 3:
                    Sa && (c = b.stateNode, c.hydrate && (c.hydrate = !1, xb(c.containerInfo)));
            }
            a: if (Ra) switch(b.tag){
                case 1:
                case 5:
                case 6:
                case 20:
                    break a;
                case 3:
                case 4:
                    b = b.stateNode;
                    lb(b.containerInfo, b.pendingChildren);
                    break a;
                default:
                    throw Error(n(163));
            }
        }
    }
    function df(a) {
        var b = a;
        if (null === a.memoizedState) var c = !1;
        else c = !0, b = a.child, ff = E();
        if (Qa && null !== b) {
            a: if (a = b, Qa) for(b = a;;){
                if (5 === b.tag) {
                    var d = b.stateNode;
                    c ? cb(d) : eb(b.stateNode, b.memoizedProps);
                } else if (6 === b.tag) d = b.stateNode, c ? db(d) : fb(d, b.memoizedProps);
                else if (13 === b.tag && null !== b.memoizedState && null === b.memoizedState.dehydrated) {
                    d = b.child.sibling;
                    d.return = b;
                    b = d;
                    continue;
                } else if (null !== b.child) {
                    b.child.return = b;
                    b = b.child;
                    continue;
                }
                if (b === a) break a;
                for(; null === b.sibling;){
                    if (null === b.return || b.return === a) break a;
                    b = b.return;
                }
                b.sibling.return = b.return;
                b = b.sibling;
            }
        }
    }
    function ef(a) {
        var b = a.updateQueue;
        if (null !== b) {
            a.updateQueue = null;
            var c = a.stateNode;
            null === c && (c = a.stateNode = new Oe);
            b.forEach(function(b) {
                var d = gf.bind(null, a, b);
                c.has(b) || (c.add(b), b.then(d, d));
            });
        }
    }
    var hf = "function" === typeof WeakMap ? WeakMap : Map;
    function jf(a, b, c) {
        c = Gc(c, null);
        c.tag = 3;
        c.payload = {
            element: null
        };
        var d = b.value;
        c.callback = function() {
            kf || (kf = !0, lf = d);
            Pe(a, b);
        };
        return c;
    }
    function mf(a, b, c) {
        c = Gc(c, null);
        c.tag = 3;
        var d = a.type.getDerivedStateFromError;
        if ("function" === typeof d) {
            var e = b.value;
            c.payload = function() {
                Pe(a, b);
                return d(e);
            };
        }
        var f = a.stateNode;
        null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
            "function" !== typeof d && (null === nf ? nf = new Set([
                this
            ]) : nf.add(this), Pe(a, b));
            var c = b.stack;
            this.componentDidCatch(b.value, {
                componentStack: null !== c ? c : ""
            });
        });
        return c;
    }
    var of = Math.ceil, pf = q.ReactCurrentDispatcher, qf = q.ReactCurrentOwner, R = 0, rf = 8, S = 16, sf = 32, tf = 0, uf = 1, vf = 2, wf = 3, xf = 4, yf = 5, T = R, U = null, V = null, W = 0, X = tf, zf = null, Af = 1073741823, Bf = 1073741823, Cf = null, Df = 0, Ef = !1, ff = 0, Ff = 500, Y = null, kf = !1, lf = null, nf = null, Gf = !1, Hf = null, If = 90, Jf = null, Kf = 0, Lf = null, Mf = 0;
    function G() {
        return (T & (S | sf)) !== R ? 1073741821 - (E() / 10 | 0) : 0 !== Mf ? Mf : Mf = 1073741821 - (E() / 10 | 0);
    }
    function Vc(a, b, c) {
        b = b.mode;
        if (0 === (b & 2)) return 1073741823;
        var d = fc();
        if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
        if ((T & S) !== R) return W;
        if (null !== c) a = mc(a, c.timeoutMs | 0 || 5E3, 250);
        else switch(d){
            case 99:
                a = 1073741823;
                break;
            case 98:
                a = mc(a, 150, 100);
                break;
            case 97:
            case 96:
                a = mc(a, 5E3, 250);
                break;
            case 95:
                a = 2;
                break;
            default:
                throw Error(n(326));
        }
        null !== U && a === W && --a;
        return a;
    }
    function Wc(a, b) {
        if (50 < Kf) throw Kf = 0, Lf = null, Error(n(185));
        a = Nf(a, b);
        if (null !== a) {
            var c = fc();
            1073741823 === b ? (T & rf) !== R && (T & (S | sf)) === R ? Of(a) : (Z(a), T === R && F()) : Z(a);
            (T & 4) === R || 98 !== c && 99 !== c || (null === Jf ? Jf = new Map([
                [
                    a,
                    b
                ]
            ]) : (c = Jf.get(a), (void 0 === c || c > b) && Jf.set(a, b)));
        }
    }
    function Nf(a, b) {
        a.expirationTime < b && (a.expirationTime = b);
        var c = a.alternate;
        null !== c && c.expirationTime < b && (c.expirationTime = b);
        var d = a.return, e = null;
        if (null === d && 3 === a.tag) e = a.stateNode;
        else for(; null !== d;){
            c = d.alternate;
            d.childExpirationTime < b && (d.childExpirationTime = b);
            null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
            if (null === d.return && 3 === d.tag) {
                e = d.stateNode;
                break;
            }
            d = d.return;
        }
        null !== e && (U === e && (Pc(b), X === xf && Pf(e, W)), Qf(e, b));
        return e;
    }
    function Rf(a) {
        var b = a.lastExpiredTime;
        if (0 !== b) return b;
        b = a.firstPendingTime;
        if (!Sf(a, b)) return b;
        b = a.lastPingedTime;
        a = a.nextKnownPendingLevel;
        return b > a ? b : a;
    }
    function Z(a) {
        if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = jc(Of.bind(null, a));
        else {
            var b = Rf(a), c = a.callbackNode;
            if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
            else {
                var d = G();
                1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
                if (null !== c) {
                    var e = a.callbackPriority;
                    if (a.callbackExpirationTime === b && e >= d) return;
                    c !== $b && Ob(c);
                }
                a.callbackExpirationTime = b;
                a.callbackPriority = d;
                b = 1073741823 === b ? jc(Of.bind(null, a)) : ic(d, Tf.bind(null, a), {
                    timeout: 10 * (1073741821 - b) - E()
                });
                a.callbackNode = b;
            }
        }
    }
    function Tf(a, b) {
        Mf = 0;
        if (b) return b = G(), Uf(a, b), Z(a), null;
        var c = Rf(a);
        if (0 !== c) {
            b = a.callbackNode;
            if ((T & (S | sf)) !== R) throw Error(n(327));
            Vf();
            a === U && c === W || Wf(a, c);
            if (null !== V) {
                var d = T;
                T |= S;
                var e = Xf(a);
                for(;;)try {
                    Yf();
                    break;
                } catch (l) {
                    Zf(a, l);
                }
                wc();
                T = d;
                pf.current = e;
                if (X === uf) throw b = zf, Wf(a, c), Pf(a, c), Z(a), b;
                if (null === V) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = X, U = null, d){
                    case tf:
                    case uf:
                        throw Error(n(345));
                    case vf:
                        Uf(a, 2 < c ? 2 : c);
                        break;
                    case wf:
                        Pf(a, c);
                        d = a.lastSuspendedTime;
                        c === d && (a.nextKnownPendingLevel = $f(e));
                        if (1073741823 === Af && (e = ff + Ff - E(), 10 < e)) {
                            if (Ef) {
                                var f = a.lastPingedTime;
                                if (0 === f || f >= c) {
                                    a.lastPingedTime = c;
                                    Wf(a, c);
                                    break;
                                }
                            }
                            f = Rf(a);
                            if (0 !== f && f !== c) break;
                            if (0 !== d && d !== c) {
                                a.lastPingedTime = d;
                                break;
                            }
                            a.timeoutHandle = Ma(ag.bind(null, a), e);
                            break;
                        }
                        ag(a);
                        break;
                    case xf:
                        Pf(a, c);
                        d = a.lastSuspendedTime;
                        c === d && (a.nextKnownPendingLevel = $f(e));
                        if (Ef && (e = a.lastPingedTime, 0 === e || e >= c)) {
                            a.lastPingedTime = c;
                            Wf(a, c);
                            break;
                        }
                        e = Rf(a);
                        if (0 !== e && e !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        1073741823 !== Bf ? d = 10 * (1073741821 - Bf) - E() : 1073741823 === Af ? d = 0 : (d = 10 * (1073741821 - Af) - 5E3, e = E(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * of(d / 1960)) - d, c < d && (d = c));
                        if (10 < d) {
                            a.timeoutHandle = Ma(ag.bind(null, a), d);
                            break;
                        }
                        ag(a);
                        break;
                    case yf:
                        if (1073741823 !== Af && null !== Cf) {
                            f = Af;
                            var g = Cf;
                            d = g.busyMinDurationMs | 0;
                            0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = E() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                            if (10 < d) {
                                Pf(a, c);
                                a.timeoutHandle = Ma(ag.bind(null, a), d);
                                break;
                            }
                        }
                        ag(a);
                        break;
                    default:
                        throw Error(n(329));
                }
                Z(a);
                if (a.callbackNode === b) return Tf.bind(null, a);
            }
        }
        return null;
    }
    function Of(a) {
        var b = a.lastExpiredTime;
        b = 0 !== b ? b : 1073741823;
        if (a.finishedExpirationTime === b) ag(a);
        else {
            if ((T & (S | sf)) !== R) throw Error(n(327));
            Vf();
            a === U && b === W || Wf(a, b);
            if (null !== V) {
                var c = T;
                T |= S;
                var d = Xf(a);
                for(;;)try {
                    bg();
                    break;
                } catch (e) {
                    Zf(a, e);
                }
                wc();
                T = c;
                pf.current = d;
                if (X === uf) throw c = zf, Wf(a, b), Pf(a, b), Z(a), c;
                if (null !== V) throw Error(n(261));
                a.finishedWork = a.current.alternate;
                a.finishedExpirationTime = b;
                U = null;
                ag(a);
                Z(a);
            }
        }
        return null;
    }
    function cg(a, b) {
        Uf(a, b);
        Z(a);
        (T & (S | sf)) === R && F();
    }
    function dg() {
        if (null !== Jf) {
            var a = Jf;
            Jf = null;
            a.forEach(function(a, c) {
                Uf(c, a);
                Z(c);
            });
            F();
        }
    }
    function eg(a, b) {
        if ((T & (S | sf)) !== R) throw Error(n(187));
        var c = T;
        T |= 1;
        try {
            return hc(99, a.bind(null, b));
        } finally{
            T = c, F();
        }
    }
    function Wf(a, b) {
        a.finishedWork = null;
        a.finishedExpirationTime = 0;
        var c = a.timeoutHandle;
        c !== Oa && (a.timeoutHandle = Oa, Na(c));
        if (null !== V) for(c = V.return; null !== c;){
            var d = c;
            switch(d.tag){
                case 1:
                    var e = d.type.childContextTypes;
                    null !== e && void 0 !== e && Gb(d);
                    break;
                case 3:
                    rd(d);
                    Hb(d);
                    break;
                case 5:
                    td(d);
                    break;
                case 4:
                    rd(d);
                    break;
                case 13:
                    y(I, d);
                    break;
                case 19:
                    y(I, d);
                    break;
                case 10:
                    yc(d);
            }
            c = c.return;
        }
        U = a;
        V = fd(a.current, null, b);
        W = b;
        X = tf;
        zf = null;
        Bf = Af = 1073741823;
        Cf = null;
        Df = 0;
        Ef = !1;
    }
    function Zf(a, b) {
        do {
            try {
                wc();
                Nd();
                if (null === V || null === V.return) return X = uf, zf = b, null;
                a: {
                    var c = a, d = V.return, e = V, f = b;
                    b = W;
                    e.effectTag |= 2048;
                    e.firstEffect = e.lastEffect = null;
                    if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                        var g = f, l = 0 !== (I.current & 1), h = d;
                        do {
                            var k;
                            if (k = 13 === h.tag) {
                                var p = h.memoizedState;
                                if (null !== p) k = null !== p.dehydrated ? !0 : !1;
                                else {
                                    var D = h.memoizedProps;
                                    k = void 0 === D.fallback ? !1 : !0 !== D.unstable_avoidThisFallback ? !0 : l ? !1 : !0;
                                }
                            }
                            if (k) {
                                var x = h.updateQueue;
                                if (null === x) {
                                    var K = new Set;
                                    K.add(g);
                                    h.updateQueue = K;
                                } else x.add(g);
                                if (0 === (h.mode & 2)) {
                                    h.effectTag |= 64;
                                    e.effectTag &= -2981;
                                    if (1 === e.tag) {
                                        if (null === e.alternate) e.tag = 17;
                                        else {
                                            var Ha = Gc(1073741823, null);
                                            Ha.tag = 2;
                                            Ic(e, Ha);
                                        }
                                    }
                                    e.expirationTime = 1073741823;
                                    break a;
                                }
                                f = void 0;
                                e = b;
                                var O = c.pingCache;
                                null === O ? (O = c.pingCache = new hf, f = new Set, O.set(g, f)) : (f = O.get(g), void 0 === f && (f = new Set, O.set(g, f)));
                                if (!f.has(e)) {
                                    f.add(e);
                                    var w = fg.bind(null, c, g, e);
                                    g.then(w, w);
                                }
                                h.effectTag |= 4096;
                                h.expirationTime = b;
                                break a;
                            }
                            h = h.return;
                        }while (null !== h);
                        f = Error((ta(e.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Ab(e));
                    }
                    X !== yf && (X = vf);
                    f = Ne(f, e);
                    h = d;
                    do {
                        switch(h.tag){
                            case 3:
                                g = f;
                                h.effectTag |= 4096;
                                h.expirationTime = b;
                                var r = jf(h, g, b);
                                Jc(h, r);
                                break a;
                            case 1:
                                g = f;
                                var t = h.type, N = h.stateNode;
                                if (0 === (h.effectTag & 64) && ("function" === typeof t.getDerivedStateFromError || null !== N && "function" === typeof N.componentDidCatch && (null === nf || !nf.has(N)))) {
                                    h.effectTag |= 4096;
                                    h.expirationTime = b;
                                    var Mc = mf(h, g, b);
                                    Jc(h, Mc);
                                    break a;
                                }
                        }
                        h = h.return;
                    }while (null !== h);
                }
                V = gg(V);
            } catch (Sb) {
                b = Sb;
                continue;
            }
            break;
        }while (1);
    }
    function Xf() {
        var a = pf.current;
        pf.current = Md;
        return null === a ? Md : a;
    }
    function Oc(a, b) {
        a < Af && 2 < a && (Af = a);
        null !== b && a < Bf && 2 < a && (Bf = a, Cf = b);
    }
    function Pc(a) {
        a > Df && (Df = a);
    }
    function bg() {
        for(; null !== V;)V = hg(V);
    }
    function Yf() {
        for(; null !== V && !Pb();)V = hg(V);
    }
    function hg(a) {
        var b = ig(a.alternate, a, W);
        a.memoizedProps = a.pendingProps;
        null === b && (b = gg(a));
        qf.current = null;
        return b;
    }
    function gg(a) {
        V = a;
        do {
            var b = V.alternate;
            a = V.return;
            if (0 === (V.effectTag & 2048)) {
                a: {
                    var c = b;
                    b = V;
                    var d = W, e = b.pendingProps;
                    switch(b.tag){
                        case 2:
                            break;
                        case 16:
                            break;
                        case 15:
                        case 0:
                            break;
                        case 1:
                            C(b.type) && Gb(b);
                            break;
                        case 3:
                            rd(b);
                            Hb(b);
                            e = b.stateNode;
                            e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null);
                            (null === c || null === c.child) && ne(b) && Fe(b);
                            He(b);
                            break;
                        case 5:
                            td(b);
                            var f = pd(od.current);
                            d = b.type;
                            if (null !== c && null != b.stateNode) Ie(c, b, d, e, f), c.ref !== b.ref && (b.effectTag |= 128);
                            else if (e) {
                                c = pd(H.current);
                                if (ne(b)) {
                                    e = b;
                                    if (!Sa) throw Error(n(175));
                                    c = ub(e.stateNode, e.type, e.memoizedProps, f, c, e);
                                    e.updateQueue = c;
                                    c = null !== c ? !0 : !1;
                                    c && Fe(b);
                                } else {
                                    var g = Ea(d, e, f, c, b);
                                    Ge(g, b, !1, !1);
                                    b.stateNode = g;
                                    Ga(g, d, e, f, c) && Fe(b);
                                }
                                null !== b.ref && (b.effectTag |= 128);
                            } else if (null === b.stateNode) throw Error(n(166));
                            break;
                        case 6:
                            if (c && null != b.stateNode) Je(c, b, c.memoizedProps, e);
                            else {
                                if ("string" !== typeof e && null === b.stateNode) throw Error(n(166));
                                c = pd(od.current);
                                f = pd(H.current);
                                if (ne(b)) {
                                    c = b;
                                    if (!Sa) throw Error(n(176));
                                    (c = vb(c.stateNode, c.memoizedProps, c)) && Fe(b);
                                } else b.stateNode = La(e, c, f, b);
                            }
                            break;
                        case 11:
                            break;
                        case 13:
                            y(I, b);
                            e = b.memoizedState;
                            if (0 !== (b.effectTag & 64)) {
                                b.expirationTime = d;
                                break a;
                            }
                            e = null !== e;
                            f = !1;
                            null === c ? void 0 !== b.memoizedProps.fallback && ne(b) : (d = c.memoizedState, f = null !== d, e || null === d || (d = c.child.sibling, null !== d && (g = b.firstEffect, null !== g ? (b.firstEffect = d, d.nextEffect = g) : (b.firstEffect = b.lastEffect = d, d.nextEffect = null), d.effectTag = 8)));
                            if (e && !f && 0 !== (b.mode & 2)) {
                                if (null === c && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (I.current & 1)) X === tf && (X = wf);
                                else {
                                    if (X === tf || X === wf) X = xf;
                                    0 !== Df && null !== U && (Pf(U, W), Qf(U, Df));
                                }
                            }
                            Ra && e && (b.effectTag |= 4);
                            Qa && (e || f) && (b.effectTag |= 4);
                            break;
                        case 7:
                            break;
                        case 8:
                            break;
                        case 12:
                            break;
                        case 4:
                            rd(b);
                            He(b);
                            break;
                        case 10:
                            yc(b);
                            break;
                        case 9:
                            break;
                        case 14:
                            break;
                        case 17:
                            C(b.type) && Gb(b);
                            break;
                        case 19:
                            y(I, b);
                            e = b.memoizedState;
                            if (null === e) break;
                            f = 0 !== (b.effectTag & 64);
                            g = e.rendering;
                            if (null === g) {
                                if (f) Le(e, !1);
                                else {
                                    if (X !== tf || null !== c && 0 !== (c.effectTag & 64)) for(c = b.child; null !== c;){
                                        g = ud(c);
                                        if (null !== g) {
                                            b.effectTag |= 64;
                                            Le(e, !1);
                                            c = g.updateQueue;
                                            null !== c && (b.updateQueue = c, b.effectTag |= 4);
                                            null === e.lastEffect && (b.firstEffect = null);
                                            b.lastEffect = e.lastEffect;
                                            c = d;
                                            for(e = b.child; null !== e;)f = e, d = c, f.effectTag &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childExpirationTime = 0, f.expirationTime = d, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null) : (f.childExpirationTime = g.childExpirationTime, f.expirationTime = g.expirationTime, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, d = g.dependencies, f.dependencies = null === d ? null : {
                                                expirationTime: d.expirationTime,
                                                firstContext: d.firstContext,
                                                responders: d.responders
                                            }), e = e.sibling;
                                            z(I, I.current & 1 | 2, b);
                                            b = b.child;
                                            break a;
                                        }
                                        c = c.sibling;
                                    }
                                }
                            } else {
                                if (!f) {
                                    if (c = ud(g), null !== c) {
                                        if (b.effectTag |= 64, f = !0, c = c.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), Le(e, !0), null === e.tail && "hidden" === e.tailMode && !g.alternate) {
                                            b = b.lastEffect = e.lastEffect;
                                            null !== b && (b.nextEffect = null);
                                            break;
                                        }
                                    } else E() > e.tailExpiration && 1 < d && (b.effectTag |= 64, f = !0, Le(e, !1), b.expirationTime = b.childExpirationTime = d - 1);
                                }
                                e.isBackwards ? (g.sibling = b.child, b.child = g) : (c = e.last, null !== c ? c.sibling = g : b.child = g, e.last = g);
                            }
                            if (null !== e.tail) {
                                0 === e.tailExpiration && (e.tailExpiration = E() + 500);
                                c = e.tail;
                                e.rendering = c;
                                e.tail = c.sibling;
                                e.lastEffect = b.lastEffect;
                                c.sibling = null;
                                e = I.current;
                                e = f ? e & 1 | 2 : e & 1;
                                z(I, e, b);
                                b = c;
                                break a;
                            }
                            break;
                        case 20:
                            break;
                        case 21:
                            break;
                        default:
                            throw Error(n(156, b.tag));
                    }
                    b = null;
                }
                c = V;
                if (1 === W || 1 !== c.childExpirationTime) {
                    e = 0;
                    for(f = c.child; null !== f;)d = f.expirationTime, g = f.childExpirationTime, d > e && (e = d), g > e && (e = g), f = f.sibling;
                    c.childExpirationTime = e;
                }
                if (null !== b) return b;
                null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = V.firstEffect), null !== V.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = V.firstEffect), a.lastEffect = V.lastEffect), 1 < V.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = V : a.firstEffect = V, a.lastEffect = V));
            } else {
                b = Me(V, W);
                if (null !== b) return b.effectTag &= 2047, b;
                null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
            }
            b = V.sibling;
            if (null !== b) return b;
            V = a;
        }while (null !== V);
        X === tf && (X = yf);
        return null;
    }
    function $f(a) {
        var b = a.expirationTime;
        a = a.childExpirationTime;
        return b > a ? b : a;
    }
    function ag(a) {
        var b = fc();
        hc(99, jg.bind(null, a, b));
        return null;
    }
    function jg(a, b) {
        do Vf();
        while (null !== Hf);
        if ((T & (S | sf)) !== R) throw Error(n(327));
        var c = a.finishedWork, d = a.finishedExpirationTime;
        if (null === c) return null;
        a.finishedWork = null;
        a.finishedExpirationTime = 0;
        if (c === a.current) throw Error(n(177));
        a.callbackNode = null;
        a.callbackExpirationTime = 0;
        a.callbackPriority = 90;
        a.nextKnownPendingLevel = 0;
        var e = $f(c);
        a.firstPendingTime = e;
        d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
        d <= a.lastPingedTime && (a.lastPingedTime = 0);
        d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
        a === U && (V = U = null, W = 0);
        1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
        if (null !== e) {
            var f = T;
            T |= sf;
            qf.current = null;
            Ca(a.containerInfo);
            Y = e;
            do try {
                kg();
            } catch (jb) {
                if (null === Y) throw Error(n(330));
                Re(Y, jb);
                Y = Y.nextEffect;
            }
            while (null !== Y);
            Y = e;
            do try {
                for(var g = a, l = b; null !== Y;){
                    var h = Y.effectTag;
                    h & 16 && Qa && bb(Y.stateNode);
                    if (h & 128) {
                        var k = Y.alternate;
                        if (null !== k) {
                            var p = k.ref;
                            null !== p && ("function" === typeof p ? p(null) : p.current = null);
                        }
                    }
                    switch(h & 1038){
                        case 2:
                            bf(Y);
                            Y.effectTag &= -3;
                            break;
                        case 6:
                            bf(Y);
                            Y.effectTag &= -3;
                            cf(Y.alternate, Y);
                            break;
                        case 1024:
                            Y.effectTag &= -1025;
                            break;
                        case 1028:
                            Y.effectTag &= -1025;
                            cf(Y.alternate, Y);
                            break;
                        case 4:
                            cf(Y.alternate, Y);
                            break;
                        case 8:
                            var D = g, x = Y, K = l;
                            Qa ? Xe(D, x, K) : Ze(D, x, K);
                            $e(x);
                    }
                    Y = Y.nextEffect;
                }
            } catch (jb) {
                if (null === Y) throw Error(n(330));
                Re(Y, jb);
                Y = Y.nextEffect;
            }
            while (null !== Y);
            Da(a.containerInfo);
            a.current = c;
            Y = e;
            do try {
                for(h = d; null !== Y;){
                    var Ha = Y.effectTag;
                    if (Ha & 36) {
                        var O = Y.alternate;
                        k = Y;
                        p = h;
                        switch(k.tag){
                            case 0:
                            case 11:
                            case 15:
                                Ue(16, 32, k);
                                break;
                            case 1:
                                var w = k.stateNode;
                                if (k.effectTag & 4) {
                                    if (null === O) w.componentDidMount();
                                    else {
                                        var r = k.elementType === k.type ? O.memoizedProps : rc(k.type, O.memoizedProps);
                                        w.componentDidUpdate(r, O.memoizedState, w.__reactInternalSnapshotBeforeUpdate);
                                    }
                                }
                                var t = k.updateQueue;
                                null !== t && Qc(k, t, w, p);
                                break;
                            case 3:
                                var N = k.updateQueue;
                                if (null !== N) {
                                    g = null;
                                    if (null !== k.child) switch(k.child.tag){
                                        case 5:
                                            g = za(k.child.stateNode);
                                            break;
                                        case 1:
                                            g = k.child.stateNode;
                                    }
                                    Qc(k, N, g, p);
                                }
                                break;
                            case 5:
                                var Mc = k.stateNode;
                                null === O && k.effectTag & 4 && Wa(Mc, k.type, k.memoizedProps, k);
                                break;
                            case 6:
                                break;
                            case 4:
                                break;
                            case 12:
                                break;
                            case 13:
                                if (Sa && null === k.memoizedState) {
                                    var Sb = k.alternate;
                                    if (null !== Sb) {
                                        var le = Sb.memoizedState;
                                        if (null !== le) {
                                            var me = le.dehydrated;
                                            null !== me && yb(me);
                                        }
                                    }
                                }
                                break;
                            case 19:
                            case 17:
                            case 20:
                            case 21:
                                break;
                            default:
                                throw Error(n(163));
                        }
                    }
                    if (Ha & 128) {
                        k = void 0;
                        var Tb = Y.ref;
                        if (null !== Tb) {
                            var v = Y.stateNode;
                            switch(Y.tag){
                                case 5:
                                    k = za(v);
                                    break;
                                default:
                                    k = v;
                            }
                            "function" === typeof Tb ? Tb(k) : Tb.current = k;
                        }
                    }
                    Y = Y.nextEffect;
                }
            } catch (jb) {
                if (null === Y) throw Error(n(330));
                Re(Y, jb);
                Y = Y.nextEffect;
            }
            while (null !== Y);
            Y = null;
            ac();
            T = f;
        } else a.current = c;
        if (Gf) Gf = !1, Hf = a, If = b;
        else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
        b = a.firstPendingTime;
        0 === b && (nf = null);
        1073741823 === b ? a === Lf ? Kf++ : (Kf = 0, Lf = a) : Kf = 0;
        "function" === typeof lg && lg(c.stateNode, d);
        Z(a);
        if (kf) throw kf = !1, a = lf, lf = null, a;
        if ((T & rf) !== R) return null;
        F();
        return null;
    }
    function kg() {
        for(; null !== Y;){
            var a = Y.effectTag;
            0 !== (a & 256) && Te(Y.alternate, Y);
            0 === (a & 512) || Gf || (Gf = !0, ic(97, function() {
                Vf();
                return null;
            }));
            Y = Y.nextEffect;
        }
    }
    function Vf() {
        if (90 !== If) {
            var a = 97 < If ? 97 : If;
            If = 90;
            return hc(a, mg);
        }
    }
    function mg() {
        if (null === Hf) return !1;
        var a = Hf;
        Hf = null;
        if ((T & (S | sf)) !== R) throw Error(n(331));
        var b = T;
        T |= sf;
        for(a = a.current.firstEffect; null !== a;){
            try {
                var c = a;
                if (0 !== (c.effectTag & 512)) switch(c.tag){
                    case 0:
                    case 11:
                    case 15:
                        Ue(128, 0, c), Ue(0, 64, c);
                }
            } catch (d) {
                if (null === a) throw Error(n(330));
                Re(a, d);
            }
            c = a.nextEffect;
            a.nextEffect = null;
            a = c;
        }
        T = b;
        F();
        return !0;
    }
    function ng(a, b, c) {
        b = Ne(c, b);
        b = jf(a, b, 1073741823);
        Ic(a, b);
        a = Nf(a, 1073741823);
        null !== a && Z(a);
    }
    function Re(a, b) {
        if (3 === a.tag) ng(a, a, b);
        else for(var c = a.return; null !== c;){
            if (3 === c.tag) {
                ng(c, a, b);
                break;
            } else if (1 === c.tag) {
                var d = c.stateNode;
                if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === nf || !nf.has(d))) {
                    a = Ne(b, a);
                    a = mf(c, a, 1073741823);
                    Ic(c, a);
                    c = Nf(c, 1073741823);
                    null !== c && Z(c);
                    break;
                }
            }
            c = c.return;
        }
    }
    function fg(a, b, c) {
        var d = a.pingCache;
        null !== d && d.delete(b);
        U === a && W === c ? X === xf || X === wf && 1073741823 === Af && E() - ff < Ff ? Wf(a, W) : Ef = !0 : Sf(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, a.finishedExpirationTime === c && (a.finishedExpirationTime = 0, a.finishedWork = null), Z(a)));
    }
    function gf(a, b) {
        var c = a.stateNode;
        null !== c && c.delete(b);
        b = 0;
        0 === b && (b = G(), b = Vc(b, a, null));
        a = Nf(a, b);
        null !== a && Z(a);
    }
    var ig;
    ig = function(a, b, c) {
        var d = b.expirationTime;
        if (null !== a) {
            var e = b.pendingProps;
            if (a.memoizedProps !== e || B.current) Bc = !0;
            else {
                if (d < c) {
                    Bc = !1;
                    switch(b.tag){
                        case 3:
                            ze(b);
                            oe();
                            break;
                        case 5:
                            sd(b);
                            if (b.mode & 4 && 1 !== c && Ka(b.type, e)) return b.expirationTime = b.childExpirationTime = 1, null;
                            break;
                        case 1:
                            C(b.type) && Kb(b);
                            break;
                        case 4:
                            qd(b, b.stateNode.containerInfo);
                            break;
                        case 10:
                            xc(b, b.memoizedProps.value);
                            break;
                        case 13:
                            if (null !== b.memoizedState) {
                                d = b.child.childExpirationTime;
                                if (0 !== d && d >= c) return Be(a, b, c);
                                z(I, I.current & 1, b);
                                b = re(a, b, c);
                                return null !== b ? b.sibling : null;
                            }
                            z(I, I.current & 1, b);
                            break;
                        case 19:
                            d = b.childExpirationTime >= c;
                            if (0 !== (a.effectTag & 64)) {
                                if (d) return Ee(a, b, c);
                                b.effectTag |= 64;
                            }
                            e = b.memoizedState;
                            null !== e && (e.rendering = null, e.tail = null);
                            z(I, I.current, b);
                            if (!d) return null;
                    }
                    return re(a, b, c);
                }
                Bc = !1;
            }
        } else Bc = !1;
        b.expirationTime = 0;
        switch(b.tag){
            case 2:
                d = b.type;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                e = Fb(b, A.current);
                Ac(b, c);
                e = Jd(null, b, d, a, e, c);
                b.effectTag |= 1;
                if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                    b.tag = 1;
                    Nd();
                    if (C(d)) {
                        var f = !0;
                        Kb(b);
                    } else f = !1;
                    b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                    var g = d.getDerivedStateFromProps;
                    "function" === typeof g && Uc(b, d, g, a);
                    e.updater = Xc;
                    b.stateNode = e;
                    e._reactInternalFiber = b;
                    ad(b, d, a, c);
                    b = ye(null, b, d, !0, f, c);
                } else b.tag = 0, Q(null, b, e, c), b = b.child;
                return b;
            case 16:
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                sa(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = og(e);
                a = rc(e, a);
                switch(f){
                    case 0:
                        b = ve(null, b, e, a, c);
                        break;
                    case 1:
                        b = xe(null, b, e, a, c);
                        break;
                    case 11:
                        b = qe(null, b, e, a, c);
                        break;
                    case 14:
                        b = se(null, b, e, rc(e.type, a), d, c);
                        break;
                    default:
                        throw Error(n(306, e, ""));
                }
                return b;
            case 0:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), ve(a, b, d, e, c);
            case 1:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), xe(a, b, d, e, c);
            case 3:
                ze(b);
                d = b.updateQueue;
                if (null === d) throw Error(n(282));
                e = b.memoizedState;
                e = null !== e ? e.element : null;
                Nc(b, d, b.pendingProps, null, c);
                d = b.memoizedState.element;
                if (d === e) oe(), b = re(a, b, c);
                else {
                    if (e = b.stateNode.hydrate) Sa ? (ee = tb(b.stateNode.containerInfo), de = b, e = fe = !0) : e = !1;
                    if (e) for(c = ld(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                    else Q(a, b, d, c), oe();
                    b = b.child;
                }
                return b;
            case 5:
                return sd(b), null === a && je(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ja(d, e) ? g = null : null !== f && Ja(d, f) && (b.effectTag |= 16), we(a, b), b.mode & 4 && 1 !== c && Ka(d, e) ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (Q(a, b, g, c), b = b.child), b;
            case 6:
                return null === a && je(b), null;
            case 13:
                return Be(a, b, c);
            case 4:
                return qd(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = kd(b, null, d, c) : Q(a, b, d, c), b.child;
            case 11:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), qe(a, b, d, e, c);
            case 7:
                return Q(a, b, b.pendingProps, c), b.child;
            case 8:
                return Q(a, b, b.pendingProps.children, c), b.child;
            case 12:
                return Q(a, b, b.pendingProps.children, c), b.child;
            case 10:
                a: {
                    d = b.type._context;
                    e = b.pendingProps;
                    g = b.memoizedProps;
                    f = e.value;
                    xc(b, f);
                    if (null !== g) {
                        var l = g.value;
                        f = oc(l, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(l, f) : 1073741823) | 0;
                        if (0 === f) {
                            if (g.children === e.children && !B.current) {
                                b = re(a, b, c);
                                break a;
                            }
                        } else for(l = b.child, null !== l && (l.return = b); null !== l;){
                            var h = l.dependencies;
                            if (null !== h) {
                                g = l.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d && 0 !== (k.observedBits & f)) {
                                        1 === l.tag && (k = Gc(c, null), k.tag = 2, Ic(l, k));
                                        l.expirationTime < c && (l.expirationTime = c);
                                        k = l.alternate;
                                        null !== k && k.expirationTime < c && (k.expirationTime = c);
                                        zc(l.return, c);
                                        h.expirationTime < c && (h.expirationTime = c);
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else g = 10 === l.tag ? l.type === b.type ? null : l.child : l.child;
                            if (null !== g) g.return = l;
                            else for(g = l; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                l = g.sibling;
                                if (null !== l) {
                                    l.return = g.return;
                                    g = l;
                                    break;
                                }
                                g = g.return;
                            }
                            l = g;
                        }
                    }
                    Q(a, b, e.children, c);
                    b = b.child;
                }
                return b;
            case 9:
                return e = b.type, f = b.pendingProps, d = f.children, Ac(b, c), e = Cc(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, Q(a, b, d, c), b.child;
            case 14:
                return e = b.type, f = rc(e, b.pendingProps), f = rc(e.type, f), se(a, b, e, f, d, c);
            case 15:
                return ue(a, b, b.type, b.pendingProps, d, c);
            case 17:
                return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : rc(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, C(d) ? (a = !0, Kb(b)) : a = !1, Ac(b, c), Zc(b, d, e, c), ad(b, d, e, c), ye(null, b, d, !0, a, c);
            case 19:
                return Ee(a, b, c);
        }
        throw Error(n(156, b.tag));
    };
    var lg = null, We = null;
    function pg(a) {
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
        var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (b.isDisabled || !b.supportsFiber) return !0;
        try {
            var c = b.inject(a);
            lg = function(a) {
                try {
                    b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
                } catch (e) {}
            };
            We = function(a) {
                try {
                    b.onCommitFiberUnmount(c, a);
                } catch (e) {}
            };
        } catch (d) {}
        return !0;
    }
    function qg(a, b, c, d) {
        this.tag = a;
        this.key = c;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = b;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = d;
        this.effectTag = 0;
        this.lastEffect = this.firstEffect = this.nextEffect = null;
        this.childExpirationTime = this.expirationTime = 0;
        this.alternate = null;
    }
    function he(a, b, c, d) {
        return new qg(a, b, c, d);
    }
    function te(a) {
        a = a.prototype;
        return !(!a || !a.isReactComponent);
    }
    function og(a) {
        if ("function" === typeof a) return te(a) ? 1 : 0;
        if (void 0 !== a && null !== a) {
            a = a.$$typeof;
            if (a === la) return 11;
            if (a === oa) return 14;
        }
        return 2;
    }
    function fd(a, b) {
        var c = a.alternate;
        null === c ? (c = he(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
        c.childExpirationTime = a.childExpirationTime;
        c.expirationTime = a.expirationTime;
        c.child = a.child;
        c.memoizedProps = a.memoizedProps;
        c.memoizedState = a.memoizedState;
        c.updateQueue = a.updateQueue;
        b = a.dependencies;
        c.dependencies = null === b ? null : {
            expirationTime: b.expirationTime,
            firstContext: b.firstContext,
            responders: b.responders
        };
        c.sibling = a.sibling;
        c.index = a.index;
        c.ref = a.ref;
        return c;
    }
    function hd(a, b, c, d, e, f) {
        var g = 2;
        d = a;
        if ("function" === typeof a) te(a) && (g = 1);
        else if ("string" === typeof a) g = 5;
        else a: switch(a){
            case ea:
                return jd(c.children, e, f, b);
            case ka:
                g = 8;
                e |= 7;
                break;
            case fa:
                g = 8;
                e |= 1;
                break;
            case ha:
                return a = he(12, c, b, e | 8), a.elementType = ha, a.type = ha, a.expirationTime = f, a;
            case ma:
                return a = he(13, c, b, e), a.type = ma, a.elementType = ma, a.expirationTime = f, a;
            case na:
                return a = he(19, c, b, e), a.elementType = na, a.expirationTime = f, a;
            default:
                if ("object" === typeof a && null !== a) switch(a.$$typeof){
                    case ia:
                        g = 10;
                        break a;
                    case ja:
                        g = 9;
                        break a;
                    case la:
                        g = 11;
                        break a;
                    case oa:
                        g = 14;
                        break a;
                    case pa:
                        g = 16;
                        d = null;
                        break a;
                }
                throw Error(n(130, null == a ? a : typeof a, ""));
        }
        b = he(g, c, b, e);
        b.elementType = a;
        b.type = d;
        b.expirationTime = f;
        return b;
    }
    function jd(a, b, c, d) {
        a = he(7, a, d, b);
        a.expirationTime = c;
        return a;
    }
    function gd(a, b, c) {
        a = he(6, a, null, b);
        a.expirationTime = c;
        return a;
    }
    function id(a, b, c) {
        b = he(4, null !== a.children ? a.children : [], a.key, b);
        b.expirationTime = c;
        b.stateNode = {
            containerInfo: a.containerInfo,
            pendingChildren: null,
            implementation: a.implementation
        };
        return b;
    }
    function rg(a, b, c) {
        this.tag = b;
        this.current = null;
        this.containerInfo = a;
        this.pingCache = this.pendingChildren = null;
        this.finishedExpirationTime = 0;
        this.finishedWork = null;
        this.timeoutHandle = Oa;
        this.pendingContext = this.context = null;
        this.hydrate = c;
        this.callbackNode = null;
        this.callbackPriority = 90;
        this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    }
    function Sf(a, b) {
        var c = a.firstSuspendedTime;
        a = a.lastSuspendedTime;
        return 0 !== c && c >= b && a <= b;
    }
    function Pf(a, b) {
        var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
        c < b && (a.firstSuspendedTime = b);
        if (d > b || 0 === c) a.lastSuspendedTime = b;
        b <= a.lastPingedTime && (a.lastPingedTime = 0);
        b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    }
    function Qf(a, b) {
        b > a.firstPendingTime && (a.firstPendingTime = b);
        var c = a.firstSuspendedTime;
        0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
    }
    function Uf(a, b) {
        var c = a.lastExpiredTime;
        if (0 === c || c > b) a.lastExpiredTime = b;
    }
    function sg(a) {
        var b = a._reactInternalFiber;
        if (void 0 === b) {
            if ("function" === typeof a.render) throw Error(n(188));
            throw Error(n(268, Object.keys(a)));
        }
        a = xa(b);
        return null === a ? null : a.stateNode;
    }
    function tg(a, b) {
        a = a.memoizedState;
        null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
    }
    function ug(a, b) {
        tg(a, b);
        (a = a.alternate) && tg(a, b);
    }
    var vg = {
        createContainer: function(a, b, c) {
            a = new rg(a, b, c);
            b = he(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
            a.current = b;
            return b.stateNode = a;
        },
        updateContainer: function(a, b, c, d) {
            var e = b.current, f = G(), g = Sc.suspense;
            f = Vc(f, e, g);
            a: if (c) {
                c = c._reactInternalFiber;
                b: {
                    if (ua(c) !== c || 1 !== c.tag) throw Error(n(170));
                    var l = c;
                    do {
                        switch(l.tag){
                            case 3:
                                l = l.stateNode.context;
                                break b;
                            case 1:
                                if (C(l.type)) {
                                    l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                    break b;
                                }
                        }
                        l = l.return;
                    }while (null !== l);
                    throw Error(n(171));
                }
                if (1 === c.tag) {
                    var h = c.type;
                    if (C(h)) {
                        c = Jb(c, h, l);
                        break a;
                    }
                }
                c = l;
            } else c = Db;
            null === b.context ? b.context = c : b.pendingContext = c;
            b = Gc(f, g);
            b.payload = {
                element: a
            };
            d = void 0 === d ? null : d;
            null !== d && (b.callback = d);
            Ic(e, b);
            Wc(e, f);
            return f;
        },
        batchedEventUpdates: function(a, b) {
            var c = T;
            T |= 2;
            try {
                return a(b);
            } finally{
                T = c, T === R && F();
            }
        },
        batchedUpdates: function(a, b) {
            var c = T;
            T |= 1;
            try {
                return a(b);
            } finally{
                T = c, T === R && F();
            }
        },
        unbatchedUpdates: function(a, b) {
            var c = T;
            T &= -2;
            T |= rf;
            try {
                return a(b);
            } finally{
                T = c, T === R && F();
            }
        },
        deferredUpdates: function(a) {
            return hc(97, a);
        },
        syncUpdates: function(a, b, c, d) {
            return hc(99, a.bind(null, b, c, d));
        },
        discreteUpdates: function(a, b, c, d) {
            var e = T;
            T |= 4;
            try {
                return hc(98, a.bind(null, b, c, d));
            } finally{
                T = e, T === R && F();
            }
        },
        flushDiscreteUpdates: function() {
            (T & (1 | S | sf)) === R && (dg(), Vf());
        },
        flushControlled: function(a) {
            var b = T;
            T |= 1;
            try {
                hc(99, a);
            } finally{
                T = b, T === R && F();
            }
        },
        flushSync: eg,
        flushPassiveEffects: Vf,
        IsThisRendererActing: {
            current: !1
        },
        getPublicRootInstance: function(a) {
            a = a.current;
            if (!a.child) return null;
            switch(a.child.tag){
                case 5:
                    return za(a.child.stateNode);
                default:
                    return a.child.stateNode;
            }
        },
        attemptSynchronousHydration: function(a) {
            switch(a.tag){
                case 3:
                    var b = a.stateNode;
                    b.hydrate && cg(b, b.firstPendingTime);
                    break;
                case 13:
                    eg(function() {
                        return Wc(a, 1073741823);
                    }), b = mc(G(), 150, 100), ug(a, b);
            }
        },
        attemptUserBlockingHydration: function(a) {
            if (13 === a.tag) {
                var b = mc(G(), 150, 100);
                Wc(a, b);
                ug(a, b);
            }
        },
        attemptContinuousHydration: function(a) {
            if (13 === a.tag) {
                G();
                var b = lc++;
                Wc(a, b);
                ug(a, b);
            }
        },
        attemptHydrationAtCurrentPriority: function(a) {
            if (13 === a.tag) {
                var b = G();
                b = Vc(b, a, null);
                Wc(a, b);
                ug(a, b);
            }
        },
        findHostInstance: sg,
        findHostInstanceWithWarning: function(a) {
            return sg(a);
        },
        findHostInstanceWithNoPortals: function(a) {
            a = ya(a);
            return null === a ? null : 20 === a.tag ? a.stateNode.instance : a.stateNode;
        },
        shouldSuspend: function() {
            return !1;
        },
        injectIntoDevTools: function(a) {
            var b = a.findFiberByHostInstance;
            return pg(aa({}, a, {
                overrideHookState: null,
                overrideProps: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: q.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(a) {
                    a = xa(a);
                    return null === a ? null : a.stateNode;
                },
                findFiberByHostInstance: function(a) {
                    return b ? b(a) : null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            }));
        }
    };
    module.exports = vg.default || vg;
    var $$$renderer = module.exports;
    module.exports = $$$reconciler;
    return $$$renderer;
};

},{"20cd3217b407ef91":"dudAz","dd158a5ff2156cef":"9njXz","d0adbee359419cfb":"eTyLO"}],"dudAz":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"eTyLO":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"i8Rha"}],"i8Rha":[function(require,module,exports,__globalThis) {
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var f, g, h, k, l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var p = null, q = null, t = function() {
        if (null !== p) try {
            var a = exports.unstable_now();
            p(!0, a);
            p = null;
        } catch (b) {
            throw setTimeout(t, 0), b;
        }
    }, u = Date.now();
    exports.unstable_now = function() {
        return Date.now() - u;
    };
    f = function(a) {
        null !== p ? setTimeout(f, 0, a) : (p = a, setTimeout(t, 0));
    };
    g = function(a, b) {
        q = setTimeout(a, b);
    };
    h = function() {
        clearTimeout(q);
    };
    k = function() {
        return !1;
    };
    l = exports.unstable_forceFrameRate = function() {};
} else {
    var w = window.performance, x = window.Date, y = window.setTimeout, z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof w && "function" === typeof w.now) exports.unstable_now = function() {
        return w.now();
    };
    else {
        var B = x.now();
        exports.unstable_now = function() {
            return x.now() - B;
        };
    }
    var C = !1, D = null, E = -1, F = 5, G = 0;
    k = function() {
        return exports.unstable_now() >= G;
    };
    l = function() {};
    exports.unstable_forceFrameRate = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var H = new MessageChannel, I = H.port2;
    H.port1.onmessage = function() {
        if (null !== D) {
            var a = exports.unstable_now();
            G = a + F;
            try {
                D(!0, a) ? I.postMessage(null) : (C = !1, D = null);
            } catch (b) {
                throw I.postMessage(null), b;
            }
        } else C = !1;
    };
    f = function(a) {
        D = a;
        C || (C = !0, I.postMessage(null));
    };
    g = function(a, b) {
        E = y(function() {
            a(exports.unstable_now());
        }, b);
    };
    h = function() {
        z(E);
        E = -1;
    };
}
function J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = Math.floor((c - 1) / 2), e = a[d];
        if (void 0 !== e && 0 < K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > K(n, c)) void 0 !== r && 0 > K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var N = [], O = [], P = 1, Q = null, R = 3, S = !1, T = !1, U = !1;
function V(a) {
    for(var b = L(O); null !== b;){
        if (null === b.callback) M(O);
        else if (b.startTime <= a) M(O), b.sortIndex = b.expirationTime, J(N, b);
        else break;
        b = L(O);
    }
}
function W(a) {
    U = !1;
    V(a);
    if (!T) {
        if (null !== L(N)) T = !0, f(X);
        else {
            var b = L(O);
            null !== b && g(W, b.startTime - a);
        }
    }
}
function X(a, b) {
    T = !1;
    U && (U = !1, h());
    S = !0;
    var c = R;
    try {
        V(b);
        for(Q = L(N); null !== Q && (!(Q.expirationTime > b) || a && !k());){
            var d = Q.callback;
            if (null !== d) {
                Q.callback = null;
                R = Q.priorityLevel;
                var e = d(Q.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? Q.callback = e : Q === L(N) && M(N);
                V(b);
            } else M(N);
            Q = L(N);
        }
        if (null !== Q) var m = !0;
        else {
            var n = L(O);
            null !== n && g(W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        Q = null, R = c, S = !1;
    }
}
function Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var Z = l;
exports.unstable_ImmediatePriority = 1;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_NormalPriority = 3;
exports.unstable_IdlePriority = 5;
exports.unstable_LowPriority = 4;
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = R;
    R = a;
    try {
        return b();
    } finally{
        R = c;
    }
};
exports.unstable_next = function(a) {
    switch(R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = R;
    }
    var c = R;
    R = b;
    try {
        return a();
    } finally{
        R = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : Y(a);
    } else c = Y(a), e = d;
    c = e + c;
    a = {
        id: P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, J(O, a), null === L(N) && a === L(O) && (U ? h() : U = !0, g(W, e - d))) : (a.sortIndex = c, J(N, a), T || S || (T = !0, f(X)));
    return a;
};
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_wrapCallback = function(a) {
    var b = R;
    return function() {
        var c = R;
        R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            R = c;
        }
    };
};
exports.unstable_getCurrentPriorityLevel = function() {
    return R;
};
exports.unstable_shouldYield = function() {
    var a = exports.unstable_now();
    V(a);
    var b = L(N);
    return b !== Q && null !== Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < Q.expirationTime || k();
};
exports.unstable_requestPaint = Z;
exports.unstable_continueExecution = function() {
    T || S || (T = !0, f(X));
};
exports.unstable_pauseExecution = function() {};
exports.unstable_getFirstCallbackNode = function() {
    return L(N);
};
exports.unstable_Profiling = null;

},{}],"7rt0D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PDFFont", ()=>PDFFont);
parcelHelpers.export(exports, "StandardFont", ()=>StandardFont);
parcelHelpers.export(exports, "EmbeddedFont", ()=>EmbeddedFont);
var _stream = require("stream");
var _streamDefault = parcelHelpers.interopDefault(_stream);
var _zlib = require("zlib");
var _zlibDefault = parcelHelpers.interopDefault(_zlib);
var _fontkit = require("@react-pdf/fontkit");
var _fontkitDefault = parcelHelpers.interopDefault(_fontkit);
var _lzString = require("lz-string");
var _lzStringDefault = parcelHelpers.interopDefault(_lzString);
var _pngJs = require("@react-pdf/png-js");
var _pngJsDefault = parcelHelpers.interopDefault(_pngJs);
var Buffer = require("c73c3162b1d2bb60").Buffer;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var toConsumableArray = function(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
};
var PDFReference = function(_stream$Writable) {
    inherits(PDFReference, _stream$Writable);
    function PDFReference(document, id, data) {
        classCallCheck(this, PDFReference);
        var _this = possibleConstructorReturn(this, (PDFReference.__proto__ || Object.getPrototypeOf(PDFReference)).call(this, {
            decodeStrings: false
        }));
        _this.finalize = _this.finalize.bind(_this);
        _this.document = document;
        _this.id = id;
        if (data == null) data = {};
        _this.data = data;
        _this.gen = 0;
        _this.deflate = null;
        _this.compress = _this.document.compress && !_this.data.Filter;
        _this.uncompressedLength = 0;
        _this.chunks = [];
        return _this;
    }
    createClass(PDFReference, [
        {
            key: 'initDeflate',
            value: function initDeflate() {
                var _this2 = this;
                this.data.Filter = 'FlateDecode';
                this.deflate = (0, _zlibDefault.default).createDeflate();
                this.deflate.on('data', function(chunk) {
                    _this2.chunks.push(chunk);
                    return _this2.data.Length += chunk.length;
                });
                return this.deflate.on('end', this.finalize);
            }
        },
        {
            key: '_write',
            value: function _write(chunk, encoding, callback) {
                if (!Buffer.isBuffer(chunk)) chunk = new Buffer(chunk + '\n', 'binary');
                this.uncompressedLength += chunk.length;
                if (this.data.Length == null) this.data.Length = 0;
                if (this.compress) {
                    if (!this.deflate) this.initDeflate();
                    this.deflate.write(chunk);
                } else {
                    this.chunks.push(chunk);
                    this.data.Length += chunk.length;
                }
                return callback();
            }
        },
        {
            key: 'end',
            value: function end(chunk) {
                get(PDFReference.prototype.__proto__ || Object.getPrototypeOf(PDFReference.prototype), 'end', this).apply(this, arguments);
                if (this.deflate) return this.deflate.end();
                else return this.finalize();
            }
        },
        {
            key: 'finalize',
            value: function finalize() {
                this.offset = this.document._offset;
                this.document._write(this.id + ' ' + this.gen + ' obj');
                this.document._write(PDFObject.convert(this.data));
                if (this.chunks.length) {
                    this.document._write('stream');
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(this.chunks)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var chunk = _step.value;
                            this.document._write(chunk);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    this.chunks.length = 0; // free up memory
                    this.document._write('\nendstream');
                }
                this.document._write('endobj');
                return this.document._refEnd(this);
            }
        },
        {
            key: 'toString',
            value: function toString() {
                return this.id + ' ' + this.gen + ' R';
            }
        }
    ]);
    return PDFReference;
}((0, _streamDefault.default).Writable);
/*
PDFNameTree - represents a name tree object
*/ var PDFNameTree = function() {
    function PDFNameTree() {
        classCallCheck(this, PDFNameTree);
        this._items = {};
    }
    createClass(PDFNameTree, [
        {
            key: 'add',
            value: function add(key, val) {
                return this._items[key] = val;
            }
        },
        {
            key: 'get',
            value: function get$$1(key) {
                return this._items[key];
            }
        },
        {
            key: 'toString',
            value: function toString() {
                // Needs to be sorted by key
                var sortedKeys = Object.keys(this._items).sort(function(a, b) {
                    return a.localeCompare(b);
                });
                var out = [
                    '<<'
                ];
                if (sortedKeys.length > 1) {
                    var first = sortedKeys[0], last = sortedKeys[sortedKeys.length - 1];
                    out.push('  /Limits ' + PDFObject.convert([
                        new String(first),
                        new String(last)
                    ]));
                }
                out.push('  /Names [');
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = sortedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        out.push('    ' + PDFObject.convert(new String(key)) + ' ' + PDFObject.convert(this._items[key]));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
                out.push(']');
                out.push('>>');
                return out.join('\n');
            }
        }
    ]);
    return PDFNameTree;
}();
var escapableRe = /[\n\r\t\b\f\(\)\\]/g;
var escapable = {
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t',
    '\b': '\\b',
    '\f': '\\f',
    '\\': '\\\\',
    '(': '\\(',
    ')': '\\)'
};
var pad = function pad(str, length) {
    return (Array(length + 1).join('0') + str).slice(-length);
};
// Convert little endian UTF-16 to big endian
var swapBytes = function swapBytes(buff) {
    var l = buff.length;
    if (l & 0x01) throw new Error('Buffer length must be even');
    else for(var i = 0, end = l - 1; i < end; i += 2){
        var a = buff[i];
        buff[i] = buff[i + 1];
        buff[i + 1] = a;
    }
    return buff;
};
var PDFObject = function() {
    function PDFObject() {
        classCallCheck(this, PDFObject);
    }
    createClass(PDFObject, null, [
        {
            key: 'convert',
            value: function convert(object) {
                // String literals are converted to the PDF name type
                if (typeof object === 'string') return '/' + object;
                else if (object instanceof String) {
                    var string = object;
                    // Detect if this is a unicode string
                    var isUnicode = false;
                    for(var i = 0, end = string.length; i < end; i++)if (string.charCodeAt(i) > 0x7f) {
                        isUnicode = true;
                        break;
                    }
                    // If so, encode it as big endian UTF-16
                    if (isUnicode) string = swapBytes(new Buffer('\uFEFF' + string, 'utf16le')).toString('binary');
                    // Escape characters as required by the spec
                    string = string.replace(escapableRe, function(c) {
                        return escapable[c];
                    });
                    return '(' + string + ')';
                // Buffers are converted to PDF hex strings
                } else if (Buffer.isBuffer(object)) return '<' + object.toString('hex') + '>';
                else if (object instanceof PDFReference || object instanceof PDFNameTree) return object.toString();
                else if (object instanceof Date) return '(D:' + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + 'Z)';
                else if (Array.isArray(object)) {
                    var items = Array.from(object).map(function(e) {
                        return PDFObject.convert(e);
                    }).join(' ');
                    return '[' + items + ']';
                } else if (({}).toString.call(object) === '[object Object]') {
                    var out = [
                        '<<'
                    ];
                    for(var key in object){
                        var val = object[key];
                        out.push('/' + key + ' ' + PDFObject.convert(val));
                    }
                    out.push('>>');
                    return out.join('\n');
                } else if (typeof object === 'number') return PDFObject.number(object);
                else return '' + object;
            }
        },
        {
            key: 'number',
            value: function number(n) {
                if (n > -1000000000000000000000 && n < 1e21) return Math.round(n * 1e6) / 1e6;
                throw new Error('unsupported number: ' + n);
            }
        }
    ]);
    return PDFObject;
}();
var SIZES = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    EXECUTIVE: [
        521.86,
        756.0
    ],
    FOLIO: [
        612.0,
        936.0
    ],
    LEGAL: [
        612.0,
        1008.0
    ],
    LETTER: [
        612.0,
        792.0
    ],
    TABLOID: [
        792.0,
        1224.0
    ]
};
var PDFPage = function() {
    function PDFPage(document, options) {
        var _this = this;
        classCallCheck(this, PDFPage);
        this.document = document;
        if (options == null) options = {};
        this.size = options.size || 'letter';
        this.layout = options.layout || 'portrait';
        // calculate page dimensions
        var dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
        this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
        this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
        this.content = this.document.ref();
        // Initialize the Font, XObject, and ExtGState dictionaries
        this.resources = this.document.ref({
            ProcSet: [
                'PDF',
                'Text',
                'ImageB',
                'ImageC',
                'ImageI'
            ]
        });
        // Lazily create these dictionaries
        Object.defineProperties(this, {
            fonts: {
                get: function get$$1() {
                    return _this.resources.data.Font != null ? _this.resources.data.Font : _this.resources.data.Font = {};
                }
            },
            xobjects: {
                get: function get$$1() {
                    return _this.resources.data.XObject != null ? _this.resources.data.XObject : _this.resources.data.XObject = {};
                }
            },
            ext_gstates: {
                get: function get$$1() {
                    return _this.resources.data.ExtGState != null ? _this.resources.data.ExtGState : _this.resources.data.ExtGState = {};
                }
            },
            patterns: {
                get: function get$$1() {
                    return _this.resources.data.Pattern != null ? _this.resources.data.Pattern : _this.resources.data.Pattern = {};
                }
            },
            annotations: {
                get: function get$$1() {
                    return _this.dictionary.data.Annots != null ? _this.dictionary.data.Annots : _this.dictionary.data.Annots = [];
                }
            }
        });
        // The page dictionary
        this.dictionary = this.document.ref({
            Type: 'Page',
            Parent: this.document._root.data.Pages,
            MediaBox: [
                0,
                0,
                this.width,
                this.height
            ],
            Contents: this.content,
            Resources: this.resources
        });
    }
    createClass(PDFPage, [
        {
            key: 'maxY',
            value: function maxY() {
                return this.height;
            }
        },
        {
            key: 'write',
            value: function write(chunk) {
                return this.content.write(chunk);
            }
        },
        {
            key: 'end',
            value: function end() {
                this.dictionary.end();
                this.resources.end();
                return this.content.end();
            }
        }
    ]);
    return PDFPage;
}();
var number = PDFObject.number;
var PDFGradient$1 = function() {
    function PDFGradient(doc) {
        classCallCheck(this, PDFGradient);
        this.doc = doc;
        this.stops = [];
        this.embedded = false;
        this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    createClass(PDFGradient, [
        {
            key: 'stop',
            value: function stop(pos, color, opacity) {
                if (opacity == null) opacity = 1;
                color = this.doc._normalizeColor(color);
                if (this.stops.length === 0) {
                    if (color.length === 3) this._colorSpace = 'DeviceRGB';
                    else if (color.length === 4) this._colorSpace = 'DeviceCMYK';
                    else if (color.length === 1) this._colorSpace = 'DeviceGray';
                    else throw new Error('Unknown color space');
                } else if (this._colorSpace === 'DeviceRGB' && color.length !== 3 || this._colorSpace === 'DeviceCMYK' && color.length !== 4 || this._colorSpace === 'DeviceGray' && color.length !== 1) throw new Error('All gradient stops must use the same color space');
                opacity = Math.max(0, Math.min(1, opacity));
                this.stops.push([
                    pos,
                    color,
                    opacity
                ]);
                return this;
            }
        },
        {
            key: 'setTransform',
            value: function setTransform(m11, m12, m21, m22, dx, dy) {
                this.transform = [
                    m11,
                    m12,
                    m21,
                    m22,
                    dx,
                    dy
                ];
                return this;
            }
        },
        {
            key: 'embed',
            value: function embed(m) {
                var fn = void 0;
                var stopsLength = this.stops.length;
                if (stopsLength === 0) return;
                this.embedded = true;
                this.matrix = m;
                // if the last stop comes before 100%, add a copy at 100%
                var last = this.stops[stopsLength - 1];
                if (last[0] < 1) this.stops.push([
                    1,
                    last[1],
                    last[2]
                ]);
                var bounds = [];
                var encode = [];
                var stops = [];
                for(var i = 0; i < stopsLength - 1; i++){
                    encode.push(0, 1);
                    if (i + 2 !== stopsLength) bounds.push(this.stops[i + 1][0]);
                    fn = this.doc.ref({
                        FunctionType: 2,
                        Domain: [
                            0,
                            1
                        ],
                        C0: this.stops[i + 0][1],
                        C1: this.stops[i + 1][1],
                        N: 1
                    });
                    stops.push(fn);
                    fn.end();
                }
                // if there are only two stops, we don't need a stitching function
                if (stopsLength === 1) fn = stops[0];
                else {
                    fn = this.doc.ref({
                        FunctionType: 3,
                        Domain: [
                            0,
                            1
                        ],
                        Functions: stops,
                        Bounds: bounds,
                        Encode: encode
                    });
                    fn.end();
                }
                this.id = 'Sh' + ++this.doc._gradCount;
                var shader = this.shader(fn);
                shader.end();
                var pattern = this.doc.ref({
                    Type: 'Pattern',
                    PatternType: 2,
                    Shading: shader,
                    Matrix: this.matrix.map(number)
                });
                pattern.end();
                if (this.stops.some(function(stop) {
                    return stop[2] < 1;
                })) {
                    var grad = this.opacityGradient();
                    grad._colorSpace = 'DeviceGray';
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = this.stops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var stop = _step.value;
                            grad.stop(stop[0], [
                                stop[2]
                            ]);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    grad = grad.embed(this.matrix);
                    var pageBBox = [
                        0,
                        0,
                        this.doc.page.width,
                        this.doc.page.height
                    ];
                    var form = this.doc.ref({
                        Type: 'XObject',
                        Subtype: 'Form',
                        FormType: 1,
                        BBox: pageBBox,
                        Group: {
                            Type: 'Group',
                            S: 'Transparency',
                            CS: 'DeviceGray'
                        },
                        Resources: {
                            ProcSet: [
                                'PDF',
                                'Text',
                                'ImageB',
                                'ImageC',
                                'ImageI'
                            ],
                            Pattern: {
                                Sh1: grad
                            }
                        }
                    });
                    form.write('/Pattern cs /Sh1 scn');
                    form.end(pageBBox.join(' ') + ' re f');
                    var gstate = this.doc.ref({
                        Type: 'ExtGState',
                        SMask: {
                            Type: 'Mask',
                            S: 'Luminosity',
                            G: form
                        }
                    });
                    gstate.end();
                    var opacityPattern = this.doc.ref({
                        Type: 'Pattern',
                        PatternType: 1,
                        PaintType: 1,
                        TilingType: 2,
                        BBox: pageBBox,
                        XStep: pageBBox[2],
                        YStep: pageBBox[3],
                        Resources: {
                            ProcSet: [
                                'PDF',
                                'Text',
                                'ImageB',
                                'ImageC',
                                'ImageI'
                            ],
                            Pattern: {
                                Sh1: pattern
                            },
                            ExtGState: {
                                Gs1: gstate
                            }
                        }
                    });
                    opacityPattern.write('/Gs1 gs /Pattern cs /Sh1 scn');
                    opacityPattern.end(pageBBox.join(' ') + ' re f');
                    this.doc.page.patterns[this.id] = opacityPattern;
                } else this.doc.page.patterns[this.id] = pattern;
                return pattern;
            }
        },
        {
            key: 'apply',
            value: function apply(op) {
                // apply gradient transform to existing document ctm
                var _doc$_ctm = slicedToArray(this.doc._ctm, 6), m0 = _doc$_ctm[0], m1 = _doc$_ctm[1], m2 = _doc$_ctm[2], m3 = _doc$_ctm[3], m4 = _doc$_ctm[4], m5 = _doc$_ctm[5];
                var _transform = slicedToArray(this.transform, 6), m11 = _transform[0], m12 = _transform[1], m21 = _transform[2], m22 = _transform[3], dx = _transform[4], dy = _transform[5];
                var m = [
                    m0 * m11 + m2 * m12,
                    m1 * m11 + m3 * m12,
                    m0 * m21 + m2 * m22,
                    m1 * m21 + m3 * m22,
                    m0 * dx + m2 * dy + m4,
                    m1 * dx + m3 * dy + m5
                ];
                if (!this.embedded || m.join(' ') !== this.matrix.join(' ')) this.embed(m);
                return this.doc.addContent('/' + this.id + ' ' + op);
            }
        }
    ]);
    return PDFGradient;
}();
var PDFLinearGradient$1 = function(_PDFGradient) {
    inherits(PDFLinearGradient, _PDFGradient);
    function PDFLinearGradient(doc, x1, y1, x2, y2) {
        classCallCheck(this, PDFLinearGradient);
        var _this = possibleConstructorReturn(this, (PDFLinearGradient.__proto__ || Object.getPrototypeOf(PDFLinearGradient)).call(this, doc));
        _this.x1 = x1;
        _this.y1 = y1;
        _this.x2 = x2;
        _this.y2 = y2;
        return _this;
    }
    createClass(PDFLinearGradient, [
        {
            key: 'shader',
            value: function shader(fn) {
                return this.doc.ref({
                    ShadingType: 2,
                    ColorSpace: this._colorSpace,
                    Coords: [
                        this.x1,
                        this.y1,
                        this.x2,
                        this.y2
                    ],
                    Function: fn,
                    Extend: [
                        true,
                        true
                    ]
                });
            }
        },
        {
            key: 'opacityGradient',
            value: function opacityGradient() {
                return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
            }
        }
    ]);
    return PDFLinearGradient;
}(PDFGradient$1);
var PDFRadialGradient$1 = function(_PDFGradient2) {
    inherits(PDFRadialGradient, _PDFGradient2);
    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
        classCallCheck(this, PDFRadialGradient);
        var _this2 = possibleConstructorReturn(this, (PDFRadialGradient.__proto__ || Object.getPrototypeOf(PDFRadialGradient)).call(this, doc));
        _this2.doc = doc;
        _this2.x1 = x1;
        _this2.y1 = y1;
        _this2.r1 = r1;
        _this2.x2 = x2;
        _this2.y2 = y2;
        _this2.r2 = r2;
        return _this2;
    }
    createClass(PDFRadialGradient, [
        {
            key: 'shader',
            value: function shader(fn) {
                return this.doc.ref({
                    ShadingType: 3,
                    ColorSpace: this._colorSpace,
                    Coords: [
                        this.x1,
                        this.y1,
                        this.r1,
                        this.x2,
                        this.y2,
                        this.r2
                    ],
                    Function: fn,
                    Extend: [
                        true,
                        true
                    ]
                });
            }
        },
        {
            key: 'opacityGradient',
            value: function opacityGradient() {
                return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
            }
        }
    ]);
    return PDFRadialGradient;
}(PDFGradient$1);
var Gradient = {
    PDFGradient: PDFGradient$1,
    PDFLinearGradient: PDFLinearGradient$1,
    PDFRadialGradient: PDFRadialGradient$1
};
var PDFGradient = Gradient.PDFGradient;
var PDFLinearGradient = Gradient.PDFLinearGradient;
var PDFRadialGradient = Gradient.PDFRadialGradient;
var Color = {
    initColor: function initColor() {
        // The opacity dictionaries
        this._opacityRegistry = {};
        this._opacityCount = 0;
        return this._gradCount = 0;
    },
    _normalizeColor: function _normalizeColor(color) {
        if (color instanceof PDFGradient) return color;
        var part = void 0;
        if (typeof color === 'string') {
            if (color.charAt(0) === '#') {
                if (color.length === 4) color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, '#$1$1$2$2$3$3');
                var hex = parseInt(color.slice(1), 16);
                color = [
                    hex >> 16,
                    hex >> 8 & 0xff,
                    hex & 0xff
                ];
            } else if (namedColors[color]) color = namedColors[color];
        }
        if (Array.isArray(color)) {
            // RGB
            if (color.length === 3) color = function() {
                var result = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(color)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        part = _step.value;
                        result.push(part / 255);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
                return result;
            }();
            else if (color.length === 4) color = function() {
                var result1 = [];
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = Array.from(color)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        part = _step2.value;
                        result1.push(part / 100);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                    } finally{
                        if (_didIteratorError2) throw _iteratorError2;
                    }
                }
                return result1;
            }();
            return color;
        }
        return null;
    },
    _setColor: function _setColor(color, stroke) {
        color = this._normalizeColor(color);
        if (!color) return false;
        var op = stroke ? 'SCN' : 'scn';
        if (color instanceof PDFGradient) {
            this._setColorSpace('Pattern', stroke);
            color.apply(op);
        } else {
            var space = color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
            this._setColorSpace(space, stroke);
            color = color.join(' ');
            this.addContent(color + ' ' + op);
        }
        return true;
    },
    _setColorSpace: function _setColorSpace(space, stroke) {
        var op = stroke ? 'CS' : 'cs';
        return this.addContent('/' + space + ' ' + op);
    },
    fillColor: function fillColor(color, opacity) {
        var set$$1 = this._setColor(color, false);
        if (set$$1) this.fillOpacity(opacity);
        // save this for text wrapper, which needs to reset
        // the fill color on new pages
        this._fillColor = [
            color,
            opacity
        ];
        return this;
    },
    strokeColor: function strokeColor(color, opacity) {
        var set$$1 = this._setColor(color, true);
        if (set$$1) this.strokeOpacity(opacity);
        return this;
    },
    opacity: function opacity(_opacity) {
        this._doOpacity(_opacity, _opacity);
        return this;
    },
    fillOpacity: function fillOpacity(opacity) {
        this._doOpacity(opacity, null);
        return this;
    },
    strokeOpacity: function strokeOpacity(opacity) {
        this._doOpacity(null, opacity);
        return this;
    },
    _doOpacity: function _doOpacity(fillOpacity, strokeOpacity) {
        var dictionary = void 0, name = void 0;
        if (fillOpacity == null && strokeOpacity == null) return;
        if (fillOpacity != null) fillOpacity = Math.max(0, Math.min(1, fillOpacity));
        if (strokeOpacity != null) strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
        var key = fillOpacity + '_' + strokeOpacity;
        if (this._opacityRegistry[key]) {
            var _Array$from = Array.from(this._opacityRegistry[key]);
            var _Array$from2 = slicedToArray(_Array$from, 2);
            dictionary = _Array$from2[0];
            name = _Array$from2[1];
        } else {
            dictionary = {
                Type: 'ExtGState'
            };
            if (fillOpacity != null) dictionary.ca = fillOpacity;
            if (strokeOpacity != null) dictionary.CA = strokeOpacity;
            dictionary = this.ref(dictionary);
            dictionary.end();
            var id = ++this._opacityCount;
            name = 'Gs' + id;
            this._opacityRegistry[key] = [
                dictionary,
                name
            ];
        }
        this.page.ext_gstates[name] = dictionary;
        return this.addContent('/' + name + ' gs');
    },
    linearGradient: function linearGradient(x1, y1, x2, y2) {
        return new PDFLinearGradient(this, x1, y1, x2, y2);
    },
    radialGradient: function radialGradient(x1, y1, r1, x2, y2, r2) {
        return new PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
    }
};
var namedColors = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    grey: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};
var SVGPath = function() {
    var parameters = undefined;
    var parse = undefined;
    var cx = undefined;
    var _apply = undefined;
    var runners = undefined;
    var solveArc = undefined;
    var arcToSegments = undefined;
    var segmentToBezier = undefined;
    SVGPath = function() {
        function SVGPath() {
            classCallCheck(this, SVGPath);
        }
        createClass(SVGPath, null, [
            {
                key: 'initClass',
                value: function initClass() {
                    var cy = void 0, px = void 0, py = void 0, sx = void 0, sy = void 0;
                    parameters = {
                        A: 7,
                        a: 7,
                        C: 6,
                        c: 6,
                        H: 1,
                        h: 1,
                        L: 2,
                        l: 2,
                        M: 2,
                        m: 2,
                        Q: 4,
                        q: 4,
                        S: 4,
                        s: 4,
                        T: 2,
                        t: 2,
                        V: 1,
                        v: 1,
                        Z: 0,
                        z: 0
                    };
                    parse = function parse(path) {
                        var cmd = void 0;
                        var ret = [];
                        var args = [];
                        var curArg = '';
                        var foundDecimal = false;
                        var params = 0;
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;
                        try {
                            for(var _iterator = Array.from(path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var c = _step.value;
                                if (parameters[c] != null) {
                                    params = parameters[c];
                                    if (cmd) {
                                        // save existing command
                                        if (curArg.length > 0) args[args.length] = +curArg;
                                        ret[ret.length] = {
                                            cmd: cmd,
                                            args: args
                                        };
                                        args = [];
                                        curArg = '';
                                        foundDecimal = false;
                                    }
                                    cmd = c;
                                } else if ([
                                    ' ',
                                    ','
                                ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
                                    if (curArg.length === 0) continue;
                                    if (args.length === params) {
                                        // handle reused commands
                                        ret[ret.length] = {
                                            cmd: cmd,
                                            args: args
                                        };
                                        args = [
                                            +curArg
                                        ];
                                        // handle assumed commands
                                        if (cmd === 'M') cmd = 'L';
                                        if (cmd === 'm') cmd = 'l';
                                    } else args[args.length] = +curArg;
                                    foundDecimal = c === '.';
                                    // fix for negative numbers or repeated decimals with no delimeter between commands
                                    curArg = [
                                        '-',
                                        '.'
                                    ].includes(c) ? c : '';
                                } else {
                                    curArg += c;
                                    if (c === '.') foundDecimal = true;
                                }
                            }
                        // add the last command
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                            } finally{
                                if (_didIteratorError) throw _iteratorError;
                            }
                        }
                        if (curArg.length > 0) {
                            if (args.length === params) {
                                // handle reused commands
                                ret[ret.length] = {
                                    cmd: cmd,
                                    args: args
                                };
                                args = [
                                    +curArg
                                ];
                                // handle assumed commands
                                if (cmd === 'M') cmd = 'L';
                                if (cmd === 'm') cmd = 'l';
                            } else args[args.length] = +curArg;
                        }
                        ret[ret.length] = {
                            cmd: cmd,
                            args: args
                        };
                        return ret;
                    };
                    cx = cy = px = py = sx = sy = 0;
                    _apply = function _apply(commands, doc) {
                        // current point, control point, and subpath starting point
                        cx = cy = px = py = sx = sy = 0;
                        // run the commands
                        for(var i = 0; i < commands.length; i++){
                            var c = commands[i];
                            if (typeof runners[c.cmd] === 'function') runners[c.cmd](doc, c.args);
                        }
                        return cx = cy = px = py = 0;
                    };
                    runners = {
                        M: function M(doc, a) {
                            cx = a[0];
                            cy = a[1];
                            px = py = null;
                            sx = cx;
                            sy = cy;
                            return doc.moveTo(cx, cy);
                        },
                        m: function m(doc, a) {
                            cx += a[0];
                            cy += a[1];
                            px = py = null;
                            sx = cx;
                            sy = cy;
                            return doc.moveTo(cx, cy);
                        },
                        C: function C(doc, a) {
                            cx = a[4];
                            cy = a[5];
                            px = a[2];
                            py = a[3];
                            return doc.bezierCurveTo.apply(doc, toConsumableArray(Array.from(a || [])));
                        },
                        c: function c(doc, a) {
                            doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
                            px = cx + a[2];
                            py = cy + a[3];
                            cx += a[4];
                            return cy += a[5];
                        },
                        S: function S(doc, a) {
                            if (px === null) {
                                px = cx;
                                py = cy;
                            }
                            doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
                            px = a[0];
                            py = a[1];
                            cx = a[2];
                            return cy = a[3];
                        },
                        s: function s(doc, a) {
                            if (px === null) {
                                px = cx;
                                py = cy;
                            }
                            doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
                            px = cx + a[0];
                            py = cy + a[1];
                            cx += a[2];
                            return cy += a[3];
                        },
                        Q: function Q(doc, a) {
                            px = a[0];
                            py = a[1];
                            cx = a[2];
                            cy = a[3];
                            return doc.quadraticCurveTo(a[0], a[1], cx, cy);
                        },
                        q: function q(doc, a) {
                            doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
                            px = cx + a[0];
                            py = cy + a[1];
                            cx += a[2];
                            return cy += a[3];
                        },
                        T: function T(doc, a) {
                            if (px === null) {
                                px = cx;
                                py = cy;
                            } else {
                                px = cx - (px - cx);
                                py = cy - (py - cy);
                            }
                            doc.quadraticCurveTo(px, py, a[0], a[1]);
                            px = cx - (px - cx);
                            py = cy - (py - cy);
                            cx = a[0];
                            return cy = a[1];
                        },
                        t: function t(doc, a) {
                            if (px === null) {
                                px = cx;
                                py = cy;
                            } else {
                                px = cx - (px - cx);
                                py = cy - (py - cy);
                            }
                            doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
                            cx += a[0];
                            return cy += a[1];
                        },
                        A: function A(doc, a) {
                            solveArc(doc, cx, cy, a);
                            cx = a[5];
                            return cy = a[6];
                        },
                        a: function a(doc, _a) {
                            _a[5] += cx;
                            _a[6] += cy;
                            solveArc(doc, cx, cy, _a);
                            cx = _a[5];
                            return cy = _a[6];
                        },
                        L: function L(doc, a) {
                            cx = a[0];
                            cy = a[1];
                            px = py = null;
                            return doc.lineTo(cx, cy);
                        },
                        l: function l(doc, a) {
                            cx += a[0];
                            cy += a[1];
                            px = py = null;
                            return doc.lineTo(cx, cy);
                        },
                        H: function H(doc, a) {
                            cx = a[0];
                            px = py = null;
                            return doc.lineTo(cx, cy);
                        },
                        h: function h(doc, a) {
                            cx += a[0];
                            px = py = null;
                            return doc.lineTo(cx, cy);
                        },
                        V: function V(doc, a) {
                            cy = a[0];
                            px = py = null;
                            return doc.lineTo(cx, cy);
                        },
                        v: function v(doc, a) {
                            cy += a[0];
                            px = py = null;
                            return doc.lineTo(cx, cy);
                        },
                        Z: function Z(doc) {
                            doc.closePath();
                            cx = sx;
                            return cy = sy;
                        },
                        z: function z(doc) {
                            doc.closePath();
                            cx = sx;
                            return cy = sy;
                        }
                    };
                    solveArc = function solveArc(doc, x, y, coords) {
                        var _Array$from = Array.from(coords), _Array$from2 = slicedToArray(_Array$from, 7), rx = _Array$from2[0], ry = _Array$from2[1], rot = _Array$from2[2], large = _Array$from2[3], sweep = _Array$from2[4], ex = _Array$from2[5], ey = _Array$from2[6];
                        var segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
                        return function() {
                            var result = [];
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = Array.from(segs)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var seg = _step2.value;
                                    var bez = segmentToBezier.apply(undefined, toConsumableArray(Array.from(seg || [])));
                                    result.push(doc.bezierCurveTo.apply(doc, toConsumableArray(Array.from(bez || []))));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                                } finally{
                                    if (_didIteratorError2) throw _iteratorError2;
                                }
                            }
                            return result;
                        }();
                    };
                    // from Inkscape svgtopdf, thanks!
                    arcToSegments = function arcToSegments(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
                        var th = rotateX * (Math.PI / 180);
                        var sin_th = Math.sin(th);
                        var cos_th = Math.cos(th);
                        rx = Math.abs(rx);
                        ry = Math.abs(ry);
                        px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
                        py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
                        var pl = px * px / (rx * rx) + py * py / (ry * ry);
                        if (pl > 1) {
                            pl = Math.sqrt(pl);
                            rx *= pl;
                            ry *= pl;
                        }
                        var a00 = cos_th / rx;
                        var a01 = sin_th / rx;
                        var a10 = -sin_th / ry;
                        var a11 = cos_th / ry;
                        var x0 = a00 * ox + a01 * oy;
                        var y0 = a10 * ox + a11 * oy;
                        var x1 = a00 * x + a01 * y;
                        var y1 = a10 * x + a11 * y;
                        var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
                        var sfactor_sq = 1 / d - 0.25;
                        if (sfactor_sq < 0) sfactor_sq = 0;
                        var sfactor = Math.sqrt(sfactor_sq);
                        if (sweep === large) sfactor = -sfactor;
                        var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
                        var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
                        var th0 = Math.atan2(y0 - yc, x0 - xc);
                        var th1 = Math.atan2(y1 - yc, x1 - xc);
                        var th_arc = th1 - th0;
                        if (th_arc < 0 && sweep === 1) th_arc += 2 * Math.PI;
                        else if (th_arc > 0 && sweep === 0) th_arc -= 2 * Math.PI;
                        var segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
                        var result = [];
                        for(var i = 0, end = segments, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--){
                            var th2 = th0 + i * th_arc / segments;
                            var th3 = th0 + (i + 1) * th_arc / segments;
                            result[i] = [
                                xc,
                                yc,
                                th2,
                                th3,
                                rx,
                                ry,
                                sin_th,
                                cos_th
                            ];
                        }
                        return result;
                    };
                    segmentToBezier = function segmentToBezier(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
                        var a00 = cos_th * rx;
                        var a01 = -sin_th * ry;
                        var a10 = sin_th * rx;
                        var a11 = cos_th * ry;
                        var th_half = 0.5 * (th1 - th0);
                        var t = 8 / 3 * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
                        var x1 = cx + Math.cos(th0) - t * Math.sin(th0);
                        var y1 = cy + Math.sin(th0) + t * Math.cos(th0);
                        var x3 = cx + Math.cos(th1);
                        var y3 = cy + Math.sin(th1);
                        var x2 = x3 + t * Math.sin(th1);
                        var y2 = y3 - t * Math.cos(th1);
                        return [
                            a00 * x1 + a01 * y1,
                            a10 * x1 + a11 * y1,
                            a00 * x2 + a01 * y2,
                            a10 * x2 + a11 * y2,
                            a00 * x3 + a01 * y3,
                            a10 * x3 + a11 * y3
                        ];
                    };
                }
            },
            {
                key: 'apply',
                value: function apply(doc, path) {
                    var commands = parse(path);
                    return _apply(commands, doc);
                }
            }
        ]);
        return SVGPath;
    }();
    SVGPath.initClass();
    return SVGPath;
}();
var SVGPath$1 = SVGPath;
// This constant is used to approximate a symmetrical arc using a cubic
// Bezier curve.
var KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var Vector = {
    initVector: function initVector() {
        this._ctm = [
            1,
            0,
            0,
            1,
            0,
            0
        ]; // current transformation matrix
        return this._ctmStack = [];
    },
    save: function save() {
        this._ctmStack.push(this._ctm.slice());
        // TODO: save/restore colorspace and styles so not setting it unnessesarily all the time?
        return this.addContent('q');
    },
    restore: function restore() {
        this._ctm = this._ctmStack.pop() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        return this.addContent('Q');
    },
    closePath: function closePath() {
        return this.addContent('h');
    },
    lineWidth: function lineWidth(w) {
        return this.addContent(PDFObject.number(w) + ' w');
    },
    _CAP_STYLES: {
        BUTT: 0,
        ROUND: 1,
        SQUARE: 2
    },
    lineCap: function lineCap(c) {
        if (typeof c === 'string') c = this._CAP_STYLES[c.toUpperCase()];
        return this.addContent(c + ' J');
    },
    _JOIN_STYLES: {
        MITER: 0,
        ROUND: 1,
        BEVEL: 2
    },
    lineJoin: function lineJoin(j) {
        if (typeof j === 'string') j = this._JOIN_STYLES[j.toUpperCase()];
        return this.addContent(j + ' j');
    },
    miterLimit: function miterLimit(m) {
        return this.addContent(PDFObject.number(m) + ' M');
    },
    dash: function dash(length, options) {
        var phase = void 0;
        if (options == null) options = {};
        if (length == null) return this;
        if (Array.isArray(length)) {
            length = Array.from(length).map(function(v) {
                return PDFObject.number(v);
            }).join(' ');
            phase = options.phase || 0;
            return this.addContent('[' + length + '] ' + PDFObject.number(phase) + ' d');
        } else {
            var space = options.space != null ? options.space : length;
            phase = options.phase || 0;
            return this.addContent('[' + PDFObject.number(length) + ' ' + PDFObject.number(space) + '] ' + PDFObject.number(phase) + ' d');
        }
    },
    undash: function undash() {
        return this.addContent('[] 0 d');
    },
    moveTo: function moveTo(x, y) {
        return this.addContent(PDFObject.number(x) + ' ' + PDFObject.number(y) + ' m');
    },
    lineTo: function lineTo(x, y) {
        return this.addContent(PDFObject.number(x) + ' ' + PDFObject.number(y) + ' l');
    },
    bezierCurveTo: function bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        return this.addContent(PDFObject.number(cp1x) + ' ' + PDFObject.number(cp1y) + ' ' + PDFObject.number(cp2x) + ' ' + PDFObject.number(cp2y) + ' ' + PDFObject.number(x) + ' ' + PDFObject.number(y) + ' c');
    },
    quadraticCurveTo: function quadraticCurveTo(cpx, cpy, x, y) {
        return this.addContent(PDFObject.number(cpx) + ' ' + PDFObject.number(cpy) + ' ' + PDFObject.number(x) + ' ' + PDFObject.number(y) + ' v');
    },
    rect: function rect(x, y, w, h) {
        return this.addContent(PDFObject.number(x) + ' ' + PDFObject.number(y) + ' ' + PDFObject.number(w) + ' ' + PDFObject.number(h) + ' re');
    },
    roundedRect: function roundedRect(x, y, w, h, r) {
        if (r == null) r = 0;
        r = Math.min(r, 0.5 * w, 0.5 * h);
        // amount to inset control points from corners (see `ellipse`)
        var c = r * (1.0 - KAPPA);
        this.moveTo(x + r, y);
        this.lineTo(x + w - r, y);
        this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
        this.lineTo(x + w, y + h - r);
        this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
        this.lineTo(x + r, y + h);
        this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
        this.lineTo(x, y + r);
        this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
        return this.closePath();
    },
    ellipse: function ellipse(x, y, r1, r2) {
        // based on http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas/2173084#2173084
        if (r2 == null) r2 = r1;
        x -= r1;
        y -= r2;
        var ox = r1 * KAPPA;
        var oy = r2 * KAPPA;
        var xe = x + r1 * 2;
        var ye = y + r2 * 2;
        var xm = x + r1;
        var ym = y + r2;
        this.moveTo(x, ym);
        this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
        this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
        this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
        this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
        return this.closePath();
    },
    circle: function circle(x, y, radius) {
        return this.ellipse(x, y, radius);
    },
    arc: function arc(x, y, radius, startAngle, endAngle, anticlockwise) {
        if (anticlockwise == null) anticlockwise = false;
        var TWO_PI = 2.0 * Math.PI;
        var HALF_PI = 0.5 * Math.PI;
        var deltaAng = endAngle - startAngle;
        if (Math.abs(deltaAng) > TWO_PI) // draw only full circle if more than that is specified
        deltaAng = TWO_PI;
        else if (deltaAng !== 0 && anticlockwise !== deltaAng < 0) {
            // necessary to flip direction of rendering
            var dir = anticlockwise ? -1 : 1;
            deltaAng = dir * TWO_PI + deltaAng;
        }
        var numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
        var segAng = deltaAng / numSegs;
        var handleLen = segAng / HALF_PI * KAPPA * radius;
        var curAng = startAngle;
        // component distances between anchor point and control point
        var deltaCx = -Math.sin(curAng) * handleLen;
        var deltaCy = Math.cos(curAng) * handleLen;
        // anchor point
        var ax = x + Math.cos(curAng) * radius;
        var ay = y + Math.sin(curAng) * radius;
        // calculate and render segments
        this.moveTo(ax, ay);
        for(var segIdx = 0, end = numSegs, asc = 0 <= end; asc ? segIdx < end : segIdx > end; asc ? segIdx++ : segIdx--){
            // starting control point
            var cp1x = ax + deltaCx;
            var cp1y = ay + deltaCy;
            // step angle
            curAng += segAng;
            // next anchor point
            ax = x + Math.cos(curAng) * radius;
            ay = y + Math.sin(curAng) * radius;
            // next control point delta
            deltaCx = -Math.sin(curAng) * handleLen;
            deltaCy = Math.cos(curAng) * handleLen;
            // ending control point
            var cp2x = ax - deltaCx;
            var cp2y = ay - deltaCy;
            // render segment
            this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
        }
        return this;
    },
    polygon: function polygon() {
        for(var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
        this.moveTo.apply(this, toConsumableArray(Array.from(points.shift() || [])));
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = Array.from(points)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var point = _step.value;
                this.lineTo.apply(this, toConsumableArray(Array.from(point || [])));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return this.closePath();
    },
    path: function path(_path) {
        SVGPath$1.apply(this, _path);
        return this;
    },
    _windingRule: function _windingRule(rule) {
        if (/even-?odd/.test(rule)) return '*';
        return '';
    },
    fill: function fill(color, rule) {
        if (/(even-?odd)|(non-?zero)/.test(color)) {
            rule = color;
            color = null;
        }
        if (color) this.fillColor(color);
        return this.addContent('f' + this._windingRule(rule));
    },
    stroke: function stroke(color) {
        if (color) this.strokeColor(color);
        return this.addContent('S');
    },
    fillAndStroke: function fillAndStroke(fillColor, strokeColor, rule) {
        if (strokeColor == null) strokeColor = fillColor;
        var isFillRule = /(even-?odd)|(non-?zero)/;
        if (isFillRule.test(fillColor)) {
            rule = fillColor;
            fillColor = null;
        }
        if (isFillRule.test(strokeColor)) {
            rule = strokeColor;
            strokeColor = fillColor;
        }
        if (fillColor) {
            this.fillColor(fillColor);
            this.strokeColor(strokeColor);
        }
        return this.addContent('B' + this._windingRule(rule));
    },
    clip: function clip(rule) {
        return this.addContent('W' + this._windingRule(rule) + ' n');
    },
    transform: function transform(m11, m12, m21, m22, dx, dy) {
        // keep track of the current transformation matrix
        var m = this._ctm;
        var _Array$from = Array.from(m), _Array$from2 = slicedToArray(_Array$from, 6), m0 = _Array$from2[0], m1 = _Array$from2[1], m2 = _Array$from2[2], m3 = _Array$from2[3], m4 = _Array$from2[4], m5 = _Array$from2[5];
        m[0] = m0 * m11 + m2 * m12;
        m[1] = m1 * m11 + m3 * m12;
        m[2] = m0 * m21 + m2 * m22;
        m[3] = m1 * m21 + m3 * m22;
        m[4] = m0 * dx + m2 * dy + m4;
        m[5] = m1 * dx + m3 * dy + m5;
        var values = [
            m11,
            m12,
            m21,
            m22,
            dx,
            dy
        ].map(function(v) {
            return PDFObject.number(v);
        }).join(' ');
        return this.addContent(values + ' cm');
    },
    translate: function translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    },
    rotate: function rotate(angle, options) {
        var y = void 0;
        if (options == null) options = {};
        var rad = angle * Math.PI / 180;
        var cos = Math.cos(rad);
        var sin = Math.sin(rad);
        var x = y = 0;
        if (options.origin != null) {
            var _Array$from3 = Array.from(options.origin);
            var _Array$from4 = slicedToArray(_Array$from3, 2);
            x = _Array$from4[0];
            y = _Array$from4[1];
            var x1 = x * cos - y * sin;
            var y1 = x * sin + y * cos;
            x -= x1;
            y -= y1;
        }
        return this.transform(cos, sin, -sin, cos, x, y);
    },
    scale: function scale(xFactor, yFactor, options) {
        var y = void 0;
        if (yFactor == null) yFactor = xFactor;
        if (options == null) options = {};
        if ((typeof yFactor === 'undefined' ? 'undefined' : _typeof(yFactor)) === 'object') {
            options = yFactor;
            yFactor = xFactor;
        }
        var x = y = 0;
        if (options.origin != null) {
            var _Array$from5 = Array.from(options.origin);
            var _Array$from6 = slicedToArray(_Array$from5, 2);
            x = _Array$from6[0];
            y = _Array$from6[1];
            x -= xFactor * x;
            y -= yFactor * y;
        }
        return this.transform(xFactor, 0, 0, yFactor, x, y);
    }
};
var fs = {};
var range = function range(left, right, inclusive) {
    var range = [];
    var ascending = left < right;
    var end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
};
var WIN_ANSI_MAP = {
    402: 131,
    8211: 150,
    8212: 151,
    8216: 145,
    8217: 146,
    8218: 130,
    8220: 147,
    8221: 148,
    8222: 132,
    8224: 134,
    8225: 135,
    8226: 149,
    8230: 133,
    8364: 128,
    8240: 137,
    8249: 139,
    8250: 155,
    710: 136,
    8482: 153,
    338: 140,
    339: 156,
    732: 152,
    352: 138,
    353: 154,
    376: 159,
    381: 142,
    382: 158
};
var characters = '.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis'.split(/\s+/);
var AFMFont = function() {
    createClass(AFMFont, null, [
        {
            key: 'open',
            value: function open(filename) {
                throw new Error('AFMFont.open not available on browser build');
            }
        }
    ]);
    function AFMFont(contents) {
        var _this = this;
        classCallCheck(this, AFMFont);
        this.contents = contents;
        this.attributes = {};
        this.glyphWidths = {};
        this.boundingBoxes = {};
        this.kernPairs = {};
        this.parse();
        this.charWidths = range(0, 255, true).map(function(i) {
            return _this.glyphWidths[characters[i]];
        });
        this.bbox = Array.from(this.attributes['FontBBox'].split(/\s+/)).map(function(e) {
            return +e;
        });
        this.ascender = +(this.attributes['Ascender'] || 0);
        this.descender = +(this.attributes['Descender'] || 0);
        this.xHeight = +(this.attributes['XHeight'] || 0);
        this.capHeight = +(this.attributes['CapHeight'] || 0);
        this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
    }
    createClass(AFMFont, [
        {
            key: 'parse',
            value: function parse() {
                var section = '';
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(this.contents.split('\n'))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var line = _step.value;
                        var match;
                        var a;
                        if (match = line.match(/^Start(\w+)/)) {
                            section = match[1];
                            continue;
                        } else if (match = line.match(/^End(\w+)/)) {
                            section = '';
                            continue;
                        }
                        switch(section){
                            case 'FontMetrics':
                                match = line.match(/(^\w+)\s+(.*)/);
                                var key = match[1];
                                var value = match[2];
                                if (a = this.attributes[key]) {
                                    if (!Array.isArray(a)) a = this.attributes[key] = [
                                        a
                                    ];
                                    a.push(value);
                                } else this.attributes[key] = value;
                                break;
                            case 'CharMetrics':
                                if (!/^CH?\s/.test(line)) continue;
                                var name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
                                this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
                                break;
                            case 'KernPairs':
                                match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
                                if (match) this.kernPairs[match[1] + '\0' + match[2]] = parseInt(match[3]);
                                break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
            }
        },
        {
            key: 'encodeText',
            value: function encodeText(text) {
                var res = [];
                for(var i = 0, end = text.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--){
                    var char = text.charCodeAt(i);
                    char = WIN_ANSI_MAP[char] || char;
                    res.push(char.toString(16));
                }
                return res;
            }
        },
        {
            key: 'glyphsForString',
            value: function glyphsForString(string) {
                var glyphs = [];
                for(var i = 0, end = string.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--){
                    var charCode = string.charCodeAt(i);
                    glyphs.push(this.characterToGlyph(charCode));
                }
                return glyphs;
            }
        },
        {
            key: 'characterToGlyph',
            value: function characterToGlyph(character) {
                return characters[WIN_ANSI_MAP[character] || character] || '.notdef';
            }
        },
        {
            key: 'widthOfGlyph',
            value: function widthOfGlyph(glyph) {
                return this.glyphWidths[glyph] || 0;
            }
        },
        {
            key: 'getKernPair',
            value: function getKernPair(left, right) {
                return this.kernPairs[left + '\0' + right] || 0;
            }
        },
        {
            key: 'advancesForGlyphs',
            value: function advancesForGlyphs(glyphs) {
                var advances = [];
                for(var index = 0; index < glyphs.length; index++){
                    var left = glyphs[index];
                    var right = glyphs[index + 1];
                    advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
                }
                return advances;
            }
        }
    ]);
    return AFMFont;
}();
var Courier = "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=";
var CourierBold = "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";
var CourierOblique = "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=";
var Helvetica = "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";
var HelveticaBold = "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=";
var HelveticaOblique = "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";
var TimesRoman = "MoFwhgTiBiD2B2ICyBTEECWBjAzgAgBYA6ARgCgBhWAW2pUTyoAcBPTAcwAsQ8AKLAJR4SATgAcAVgA0w8QHYZosSMUiRABlUiAzFrl4AggBNYAIxR5gLHCBTV8ASXhZYEJq7C2jRPIYA2fngAShhcIPhBKDgoEABuKN6UNHQMFBAonhgIeAAinigAXHgAKpwArnhIYCy+JMIATAUEIgUk+qIickm09DwAqvAYAI5lKA45hNrqAGxi3Sk8AGpIZThg7BYE2hoieBLN2gRkcIgAcmB0JRh0OAC0QTRg8MdlAeeXxddRwY/P0BcYPwsd4WT43MgAdRQoW4P2oTzIDnAfmwBng7D8FnUiJw0AwAA8EgAFDAgLCcPAAMzAfmilE4kDAWFsEGAaDwAFF8bZ4EYEg94X8ECAAEIi2D4vC3EizKX1EhiYTqZV4ZSKsgDPkQFHwFBE2A4UlZeBSkjKjW8mI6lClbAAa11OHwEmxixihuyyvqRGV2NOsBA2AszDYMJ4/CESmksjEChjKlkGi0ukT+mMZgsVhsdkczlc7gg+W8vgMAWCYYiURi8W8YO+GHwYDw6DAfPhEDteFglLwABkMPAAywmChbgAJFBlgwAcTwTyMAHpXHhSfgcGVTIajBhIBgokQyBy89v0cByXYLOnzKB55AjEeXCf2JQwEwJ2G8NNpvUyAANd9hIQLpkAYOBYPQWqfmI2hkDkUTgZaEBym0ZCgEYY4Qng9RzGhiyYWIRw3lAFAMhAqDoNg+DaCQEiUHg2j1HgADceAQr+WEusxeCnHgOBMEyFgsSKeDqCJYmiUxdHaNoXFsfR0lcTxKD4lgfgXFxwkkFMUq7PU2iKtMcjTMxUkELJ7EEOoiosTxIwBgkpiBEJeByPoWx1NJdSGcZkkUPREjmXsKo2Xg8BlNQ5gQIa7Ams5AWic0xlfoxvn0T5rHsS6EncXgJgBJAGmEGZtyxkB+hyPU+ipdoVUZaqCkhSOEAITwznTHU0oya5jHeSZfn6YFrnWTlFxNWsvKFQQjGdS5nG9dVuwsXJ0kySFdksh+zlyLsWwyfKBlGX1hDZctDU5fx6TwJilKtXgwkEIq0qufR6hmfNdEEHUS3sStil4Bd9AcLCzn1LsT36NhAXvX5U2BVlf1gNmmA4J2bW6dMAVbD1h2pVscPTGZjV+KshXaaJEiHEFPkfYTdX1JxIUuLQTZxcZ0qfbIAVmilH0Bd98mrTlnDDpw9Ck7sohmZDHFVR96VyfT2U8U1WRGIVciidKdQKtrwUfbVCtyMNPE4GpOAUs5txgyQUuldDhDDXJ8MhQAXjEsCFfUxU24Qh3280cPBTlCCCXdwgkHUonbG9ON0QzdXOzlIAAO4e85ZO+1Dsd+RIX0J0HPEgJw6Sh/dMns5MXnZ3sKX50rVKwGUSHOSQjEJRVn7VxTgf15SGDxKT00+1sBliNZce007Be8QSpPe2ZBCyrMhNx3zdd/dE8SxWH9Sa4qBAB8lR0SPLmXT9CgGs6aC8EFn1M5wbZ/14Muqk5r9SMbfuz2xIjvsZVxs8AuD8NkZyYgOoR1kJ/CQi046LTpkbDedhsCwBAdvYSYhNY2zqPKHaMCjrTBOplAmf1MROk9o9RUFNjK5xXn5dq+NaZKRGDSN+DRyaU30vfT8tcnYkJCuwdI+Rm470oXsbQNCfapWmILOSB8mF4BGFEQMoCw6yhKoQH29t+F1REPKBGt1NIymvqqdQ39q4Y0Gh/P6BhCo0TEhrJKcg6GflPq42qPFhIt30OTHQrieb0Mfu4v6fkQaPS0QpbRf8XLWJChMFuxlRKzCht+Ah8C5LtTzjxDkdi257E6P4o6Gs4Ynz+tAXJYl9hJVSalOQec5IVVrjxWc6ch5mQ1uY7hHd+aNL+mOOxuxRIax6jUuichZE/TOjxBwdjFRR3sUfWpk8frKD+gAKTsVgsyNUkmjL8nINeDTYk5QANJzwcXpQptS3GZL+r2CpviDJ7JckEse8CeJIAeaqGRVyxnRN6SFHiLch51A1voRZYz0nsQBTlAA8uciuswDrcMwSU9KPEiR2MSXsWGEK/LgKsU0vAABFBFbRFQayrii3h7EvweOCHYnxn58F4vqmiv6wBJptMICIKlR0CKBVuSFYojLKl+NZZIQlf0+h2Pni5dQKSAnfKlSFRYWLTReQKRKoJIgD5/UwnFDVeAdAjKVWPFVOV2It1EkM16vz8VQpiUSgAmp7PJGsZKso0IKyBIUABahVBn5PBc83lgVfohVMIWLAdo0DXUMaqcJpTQbf1DTSrCiDI1MjtKbRGFsw5WxMdhcF1c/H8wjTlKN2a0BAwTZTaUybb72uNcswg0x3lzjAhgbAGBmrhU9lLApB9qlKpEIcp+f0yiITAq4UuYlpT0yCprA5R0RBuIrbZMo9l412PsbtDiMduEFP5vIhGpN9DSgSrDReEk6LiB7n9UwpNTQJSXtBVdjrT2M09gFS9mjP6EKOmaIhS6/pqxBhes0PKvLvtSmaepFk9UhTnYuv9U0F6Abg+odNG6qSextfRd9sxBb3IwFSMjLF7mBEpE5OiZoJmgYERQ5C+9ik3qA3a/miceL5uEkGh64LYN0YVYFABf0KNh2MaJemnqhN+TNG4sTIUABWhVbjFNuPtWQb05NKiCdxvAqMw5MpdFDXTZpolKZyk5STQb6aCdWsJx1Q0/rUHVUMld7G4NQa49PdBwhsUPUxphujvr14hTTjva27dX23vk63B9jVCq/vlG5NjIX4sMYM0MAdyE3Lmq86F1tuGRHCXivJYLcXw7jsIx2/AcUIFRwem2qrEdFOZqTnY8uUHKq7AkNtIDbREs5QqM5aLvs8GtYVMNnisQBkmIIM9W+U3nPHJ4snT2EC3q6qAq13eM28CSm8WJRbk2gP6N8/XGoLdipacW5jBmdHjlyKQzlF2nsmWfX3o9+TlyT2osjdGycKAbqbKwQS7Qc0AdPdbbveupgCptQvVprSXUxBKtbjVh68Oge1q6+DjyqLZh7bcfsLJnasDdsDH4Pkk1RIKhki6RiDFHPyYYeWqZeBlKqQuCYZO/mCmaem7vYLss2fpoMy1ZL3WBoHyoQNuDPzLsbxZDqdgFSNHNCSdXGUraZT0spNGlR/npTqJ9p5Tu3CZQ1YMywMWltu7kwS6ymUpPp40dcAOdWppVla8t0BwyB3ojMmNOrLZ+96hOKt7KZXjMm6XSwNdgt1jf41x6thgPjqFT13WlEAcGI53NfcsISJOviknte5u+yRhHI7ucnjfdn1D1AbqQd9gZRASYmoAGOvYdYYKVvsZT6Vvul1Vw+3wEhp0QBBBwmn5ClpbD5bwx8fHfaT578Hj+vioF9seMXB5x7KQp91JpHGuMHWfCBXVx0px+bPCQYpU/RxGW/6fPryPNhVpPqDqPDRWLfokDMjB1gNhSt8lr4dpcUy9HUgCQCYga9789gk0ZID5sYrcAc6Z45lYYhVYWoYgEgw9ExhAIcfM6N0dApb5BZlZGRBFXxeM5Qh59hdtm0Gdw0sC8BTBXhMQE1LJZBjJqJX10DitOdc8p8MQEdoh1ZrYOYUcM84NJUK8FFc8ECJDC9f1sFNFjJuYgMxA3Ev0cplDHIt8w5tJG8f9/d5C3964J8Z9u8KJL4+9tkUDU8l95DolgN65JwUQmBDR6tJNIEtZE1FRgMdCs9fQ/omoi5G5xpwNjNTRdg1B2kZggMw1FC/olEbBjQ+d/NtIhcd9DpF4rcy0x9OdaCB4W4+t1AIYoDx55MdsOcqC5wsAyhbBA1Gcqj6IhtDJajOZw1OdKc+1qAaNlJd0gp9AGJsYXFRB11OdqdacW5xFmdqJPwBo4Nj0SjGj4QsAIBVEjEcVxjrFCEvo6N70GjH10hyid4aEOipgQ0pi1A+jGiTBwAsApcW5ptf4cFjFZhji/I4dHiwM9x0hfDZkkCPIFkCVUpd4cNOdMB0RCpA9c5GJI9jI6lfisJ1AV9+iEhO8WYw4JBpp5QApI8z8oSRMziQpyh0RIBwo1IWi1N2jxjnpuijpd4ZjGjYB2AQ4jNhJUlTdiS8Yqtd4glcMsBIBdjw4xj6JDjD8yT3DwjkNqBgDzYv8MTdYVR/8oTF1+Y3kbEclnICNdDPVnkP4glKp0UuwIAjBKRkEX5C96IdtKptduE9J00hUcpexc0VTgUxUnklU9IGMYUeJYUvT6D60idzVxkXE9JW1dSQpYV9STDNZjIx4Ukei9IasBC/pXAjB4QwJXgBw51+Cdsphm8oSOZ+Y6UEY50Bo/0ZEAMhSm1+YrMeJniyFDR3MOIUCMssJmtmyOseJaQzZ6DRAxJ6Zv5dMvYYDp4DRhzPZrYEtFtyZc5WT44jkiVYAaysEklvVCs/iVzY8cpQDBQEC/DNJpodo31L9pQASQoHBtx8CQSW45lOiApoI+Y6Iby0jkMmQWiUN1CEovZO4eivy6p9CeIwAo0UBLiH9IMr0RkXFQKp564ygqT2AaTqA6SE1xsXQq4QKEMioFEUAxSdj/NUMoN0NO5EKCKgy8BnUHzgSGw3UHFMT6oPy/IkLiEFFtxYgMB5ikyX1xEzJc5uFOKnU/pnVfzWiQZ3VWLlAqsxLaKDABjmihjMQjtJNytHFE1RKCLwK5wpKay4KipsZ8KLUeI+gVLwphiNLNI5UNY3zdCjoxLbdDLZUWNM5gLnKCL9I6smZ4QmQ3j8SOotNDh94eyxL9LiLe1VKbKf1BLKLDJqLzK8A+g4T1cbsTEHLVRTjPyaK1tUqGK88zzhB7KRN3zvKKDK85xOTuTz1TRLFF5LyFL8qiU+g3LMqK5sr5LKrDyeIt0uTdQeTjVTQJBMZSplteq6p3TskiqnzJM8kYF9AKrUpFKCqchtjYBPBOzklm0xLNScp/KwBArehkswYUcBVbgftTRBpMNDrYBWBjCH9wl2kZTdKfVycOQtjSKvklrVQtIpqXsFFXjxSyKAL/0qLAbEMFFdx4T05jLUCXJfU8qUrTgjqTqGAfTpR70wU9qCKWy8A1JmjpLbMxzvUerVq9Lqr1hCwYL6IEaaiobPwwseJih0bXjTrjs8j8ljSlUxKqyQoKAOrRETEZEZIKaUbvyRo5ijKErcVVjJbpqWbORniMaE0EtfFlrIcmbfKN4SKJTthBLIdtdkry1VkQowIcT8pksQr7EwqWsmaCadxia50pMsJvUWTKaKDW8QoQE3Z0RXaZIEp8EKpTbprA8Qogh9b/Mhskl8Ex53qekCrpx2agqH9CTpsOkLDFbkLJ0rK1KRixsEqBskqmb9KmQYrrL1L6q0MoCw71ybFvqJT7FbUUyAavaKScpmpQbksxJpIs567oa/oObtxraQYUs91FyIqCKZq8A/VVaObMaw4g0/qVqc7Mpb8cpShXAY7sV9hTUmbaLYUm6ci5UkV/rryZ6I6coghhbNImUMZdgJaOKCKxqLTgA77CBuVmg6hn6bquNzUQojBo6PtBLf5v4x1D6Cq+gT73Kuryr2717GMRt0rA1i7dg0Sdbp4i4S51wVZlwW5iTUlQY+UO66oj6yiayz7zU/61qiUDBKG7EtLkjaHWqbEoK6aW75UUzq4XKdEeJqBXhAwmAgRSZFQqFKoeUxd/7wsRtP7xtTsvKyGMlla2ae7jtfFxanLlGLIcZzpIBAwaRtxKQewubZcQ7SCX6DsWA5qmLOq7sV1vxL7UbP6EtAjcbWHRMByVx864rLY3bQYB6mbZ6ORfHq6fTNadKy7qbbGSqao5aeo/skGorYn4q0MgKnHongbP7yKEoAbPakGDN4BXHAtJUCmrG+q8BwomQfqi60MS7zCdHxLAUQGsbIEPHtGkHcMHBXGXzqJlrvUmmT4FERHVhqABwSZ04CMKZhLkimn/jAdYBY14AEcwDA92YZJUd5VpHFK7qeJ0h2AGwWQCD04XrxL7Y6G/ppwOGazuUs7YxE6Ni/p7yAw1bQT5k3ztamnCF651xmZjcmGwHJVtLvnlaORGGIng0cqWrbyu7P7yt+6lHCmZzYGQYFHikjjgnla/V5GxUBmYXKzsXWnl68WomhmA4BEhFjmWFEDI8n9jTHmG6QoOQi4dqynnl+br6eIKBwJR61JmMhcoZS9GX/5vG/BU7ObSbub7MoJnHy06WQoyR1HJNut5kKVYlknqqUBaqhq0nrcv6MMCXyHoGdWUBhqfZ+T5VFUoH6HXHmGUzBmkGlLUnCGWKUyvnNWiKIWd5wbErM1PW/oXYcnPtptymZHDZAEshBqzX1VLXI8zM5XjWiVYVP760tEaHHWKnZGeItqXb5zi7tczKpaILUWTCGb090SxLdaLb4XGt6Jmsw39rvG+KgTiq1M7NzVMmmmj6wnC6TDqHxHOms2mWco+hvW7KsryrM3w3aUEs4lJxwAESxJCFR4i3s3mxOAd7e6hc0skldMq3sHU48GcCCHJMM1pM11s7h3oUCrYUXX+3RaaGPXr3kGBHRsTC2YtMkTmD5nm3x2pQXyZMkWX2DNYA0KMKsL820Mw1G2Z6wXTXzWh5LE/rWUXLp5gGdjtqIMwGVQX9u32CcGUAUAWEoB3RAWurQ3eHX7N6eIzwrb+X68M7MYYOqPw1qrxXlXNIg1DhwVIHu2CqTkJWl6H9vYcbLlUO4PydexXHFr71PH+ZxB64Ww2xIBhrtJ6ZjIx0Q0+aqaiKF606OIEqMmkmX3un/3psPnoWdbOcHBS29io5rFwFE2VGpPiXzzfSr2Z3Zp64Q4GQ/BTGTCtsXJF5POXKKXrMohogaXPY97xOvwmbQPe3bL3aC3Iahm/MZbOygsVi12R2LLwOIBaSwB6TOqfZurp3+awWZPSX5OwKtW7PDP0m3pGnkXrCbmBWHHdlB7vPszdQSOWQa6yvKORW9gaPLA3Ov6Fsw0E6EuxuzxkhjrF6eCM794WORuj6CuiuSuH3EUM2jW5F0OUBBEiPktxjvVDhPVWPKnOTaaUN0XC3gmuXGAJvsJRaFIZv0uUL/30XzFcuLJu4QpCxtwxTaWpRANb5GIjI/vmmcoNrOOAtl3JUPuunYShOE0J6d9ta9yvPaLThMu2nQUOjJB9uJ0It8eotUuZFoeBab60fRVsaDIWUOXJO7k6esav370JOUqDByfNJ7XVRrrLmQoDAEPyP9XxkDpuulLUHXXW6croej7ef63H3xHBfdPA39PJXhJJG8mDITOvOQmJuNaoXkfTObPRfnyGqApqJrXPu/o7Q2e4jubTNZWEv+G8Bxmwo4npN9sZmsIh2vPumkvRiHPGJTevOimjfSmgnf3AEyQFu3mW5y4tNes9gFdCn3eQFDmQfBw616crIhLCMRvQP73tf7ueFnPSeRtS+Rr6nv59ewuO1c/iOyhWEsbliKZ9B9gdnX7p52BHftfHpOvgvYEQPz5WW0Xi6YMRv9KXYXuQ3JeEu/MB+EfubsvseD2fPHQyh8GwD+tz3ezkVHbm2GvsVKovIWux/64OQm5IthICMCNJIjwjASJIByJMBcBUJwAoATkYh4A8hwAX/Axr/wgDwAiQYAXtPgGFIwQTkRIdiLYg4qWQyAsA+AYwDcq3AkBKAwwM9x7oYDsQWAhAby1xJShMBcA7AbODwHICyBtia5hcQsCUCCBeAFOgnyW4kD8B1AvAPCiuq0RGBKbPNtwKoGoDYUwfAQbwNSaiCOBsKRhhIKEGbdMKxXHgDIOwHH0am2QJQbYhDJzl1BnAzLtoNJTaCRUWscgIwLUY/UjBgg7AWzRYFS5zBjAmVNoPar8CxqFg2xJZUroF1JQDg8Qc4LsHSCfBHAvoHIMg4ODYGDg0Xg4NQbaC1UnUHgRwMwhWx2BqA11JeliFJD0BZoVIdgPoqtsQSKQlwYoi3QbRAItgjgXNnUxHBGBG2K2D+EYE1Bqh+QlgOgL0QNDxBzQggW5UQGJDDAHQ9AaQPgEdCQGDA6gQMPo5Nghh/QvNhQL6HdDJh7XcYTML/JMC6e8wgwG5S4H+CJhiwvgYsPUFrCRBGwhYa0TvY5CmKuwvNlINu5SgDhqw84UEIUFXDMhNwrYaEOuFrDQyDwlwWsN0GvC82+gn4YsMMERxjBwwvNqYLUFAjPhoI5YRCPaF5t7B/w1oo4J2EIiLAbgwYnFTOGLC+g3gx4W5THaXDMRiIu4fSUJGoiXhuIuEeEJRGpVIh1I6IVpApGLD4hGgSEYsOSEZDWRrRSSvwI5Gwi2R4g3kSCMWG548cJQzYa0TKHOJORFgKoW0KFGtE6hco8URYEaH8ClRhwlUa0JqHUD2unQlwbqN6FdCDAuowYdMONF0DnuowtgfqItFTCjR7XWgdBXoFmiHRywl0RaPWGPD2u2w1ouoO9H7CvRHonETaKdGcC/BgY0MbCmJGKDrh3o8kSGIHiaDP8foj0d8IjEDw/h6Y0EBqmBHwD2uYIk0GKMMD5joREcBMaiI+EED2uSI30bGItFojYq1dFMaGOxEnD8AzYgePiLAADwOxqI6MZWJ1H1j4xVY+sVSKzE0j88A4vMRaPpGQ5yxrEHSPaItHsiFU847kTsMFHTjQx2Qx8qcM3HFiLRIoj8EWPNGhjJRFQwcaGNlHaitxA8RUTeIPGhjVROw9UaeLvFaiXBwfPUQQK/GGjPx7guKjy1wFmivxRA62isOD52j/x6I6uo6J7EgSAJsEt0UaOD6ejoJjYkYj6PoHXDUJAY9CVXUwnBifxiEzCeGPwkeDOB/Y9QahOHHUDUJ7w6iSRMlCwo0x5EuKpmLYnV1ARZY4iTBJGIFicxnE/iaWNzGGBg+8Ix4eJPQE4SmJqVPCbxIwmShWxu49sTJL4lKSyJCkgiUpKolqTFJqVWifAPEljihJSk2kZJNkmziLJ6khcQkNMl0UX01k/SeuN9H7jlKskncYxXbFuTg+R44oTCLomyTzx9k68fZPvFhSmhD49yTZJsZtidIUU1Jt+OoGJS/xBAxKaaKNHpSrRKw1JlBLSlxS4JzozKQVOQkuDUmaE/KSpM4HSTHh5U+SclLinHCqp6g8qZpIalVSoxU6dCoV3kEkjrh5UwyYYHKkMT+pjU1iZVK8kkopxQ0uKdxNEnGBZpgwgKfANSZWDmYbzE8akwkllS4pNY7CbVN2n1SVpu0oie1Mmldiexo0qqYEK6kQd7hLU3aYNIWnXSTJE0ttmlUnEPSqpVknaVVOZHFSqpK4g6YDPSGri3pIJTyW2zyHgymKfk2EJtLinBSYZ+AUKcjLwDhS0Zz430a+NSaxTmpr4xhklPgGEzUp1AwmRlJcHkzspZoxhnlLJmXDCp1oggbTNKnMzLhFU+md2IsBYTppDDdmUdMMCMMmpk09QULLanEz2Zukx4ULKelCyRp0s9meNM5kZjeZjDOaZTMuECSTxaskSRrK5mpVVZlwvaYbP1kNjtJJszsadIlmmzxZgso2VLL1mdjZZRs16crNRHmTHZFgH6WzP1n/TPZDk6GW7LoqgyFZ+syGbkLcmMM4Zig5aXbP1lIyg5qMoORjOTmRT/ZeMkWa+NgZEzDA2c0mfAOzkUyCBhc6mUaNgZ0yC5qgk0IzJWHlzWZ1A2BhzMrmbUTQPM9QY3IFkGBG5Vs3OVXLDEEjrhjch2cXL7kqCW5vMxufLJcGNylZzcn6hxJHnjz1Zi8n6lrNjldy+5a0gKqwJPGwNtpK87IMbPbl9yzZFE4+ePOUkizB5J822RvIvnDyG5J8p6XvNdlzzD5Hsg+SaG9mPzx5fsz+QHLcmwMXJ9AwBX3PDl7iwZP8n6tHMEn/yE5b8k0EnIQXoz4p08vuVjPoFZz0FH4ggaLxzki9o2nYIWvwLNF4Ki51AshaXJcGi8K5hgGhXMNIWEKlh1g06isNF5Ny6FTCtudcPYWdz2FPcghXVQuH6z1B7Ch+fAPYVPT2FU83BVwtnmcK6qC8ihUwuXnKK6qa8niWot1ZbzFuNg9eaL33laKY2R8nhUwtPkYjTFdVS+VDMsW6sLp+06hWYvEUKK7FUisxa/JcXGKP5RizsN/IkVMK/5PigBZAv8V1VgFjkxxWEoFEhLPFnYGBSeNF7wLYleAKoQSUiW6s6haS2RXVQwVXCopovDOTYqimoN8FJS/OYYBKXkL4BlSqhQQNQa0KDA9ShhUaPqX1zqlk4jhY0o6U1SXBqDYQbJPUF9KBFfS2+X0ucVdL4SY8swdcL6UyLqBfS+RRMvVxKL2l8JVRasvVwaL5pqDHRRtPXmoNDFGy1Kj0rqWTjzFTYmZWcuGVnLRlZy8ZQcqekHKPFSyicfCUGWTi/FFSycYEqOVAzelk48JYHN+XRLHhqDeJfssnFJKXlSCr5fCRTlHLcl9Q05XCpwXUDMu+C9FeUp56AhacQEswWaPRVgT+WKwzLg0tJXNKXBpKtpYYEy6dLaVJytFTiu5mdzaVAi2lbfNpXjLaVT02lXMvgG0rFlmXFZTSqZUlBYFjKmnKCCWmaL+Voq3ZTvPXmZdDlIqyVccqcGPClVLK0VdYtyHXClVHK7VVyu1U8rtVzypVd4tlWqrPl2K1VT8pVW04/lBAzLoCrcnOqQVlK0VeCplX2qLAUKzLjCptW054VPq9GWnKdWirCluQ9UcJFsS3A5xWAmNegPjVkCY1cw5NexBjUiD01YcZ6SLOzUxrpB+a3uePLjWZCY14QotS8tLUWCY1ugotfYLNA1q1VG4rocJHOUjFL0TanVRAq7XSDG1Ca1KlRP7UpqDJfcztQOr6DhDh1Ga15ernHVkCJgsa6YYuvKWLqKVWAxdSIOXUzTmp26vmSIr3WhC914QvdZEL3W6Dt10Q7dfEKmAWCJgyQg4feoZXsR71PcuHj9SXVdD312QJ4b6OXUgM3xRUu9QBq3VfqAN4g/9T3X3XwSwNUGo9bBo/UnqENP6s9chpNCBqgNG6kBlerQ22Tb1WGnug+syHfqTQgKx9SA3AWqTiNm1bap+uA2YceAv6zDQupo2Mb11LGhjWJIGX/rONuaqGTxq2qMbpBAm2jfBvo2Cbkl8wjarxtQ3ibaNF6sDZxpw1yaeAN6xTRJqI0qbg56qrTZRumnlJY1UorAQZvQFGayBBmuYWZvYgGaRBVmvAAZvEF2aDN0gpzcWrMGubBFurcoRYIM2RCPNug1zWMJog+aDKPIzIeUkgoWiG0IWiujZOi3Ga5wAo8LXOD7XJaLgY64LQlrABTq0tkQzLeZrnC6D8t1moBAtwA5dDykHseLQVtzYbjktsAEQcVvs1dgktIWm7iIqa2Vah19W0IZ1q7AMS+tAYUVdVpK34M1YJULoRsljWEILBU29ATNqwFTa5hC2sgVNpEErb2IU28QRtrwBTbpBO2qbaEIO2SbjtVa07boJ21nIuB+GsgVdqTVdCrtWah7ZwPEE3b2IV2wtc9s6nUkepwQt7XgCu2hD/tV2hicDp0HDawd9A+mBYLOQZB+B0OrAbDsGEI7btXOEQSjve1c5xBGOgHVjteY7ycdsO6QYTq5yhCSd2rJhZpkyFnIqt2amnUmup1dgs1jO2AK9pZ2FqWdVEunV2CB0s7QdLOutYzoqAjbcdrfMLTDqqaNahdrWxHVU1S0S7UKt037fdKa1nJqmJa1XVUxy0K68tjOuoSTsRUG7sd1Ountdoe2m77tMO03U9qt0sKGAwsqGcDtN2fbbd601gd9u6lbdFBTuu3TwCmVqCfdbuqXEmJVJxrzdvu8HaqrD2u7t5UuKHSboj1w6dhhOunsRVwEp7E96OhPUHtOo4lmpGenPQwASD46bBBe2PbnuJ3Z7y9ResnVXt0W57whZe+vQwFp1163mtW30XTrp4NaBlXeiPazrinVrEd3ejnTHub08AwOSur3VKD72F6J9vOsfe3v52L7WBQ2qPbPur08BhdquunmLrq0r6pcZQKXQftOplAZdt23ffLuH0R7FdP26fSLsE437etbe1gQNTqoP7d9uuk/QwH10v6pchuv/adUjWnCcd9yQweqLAODCIDJQZYdAfpHmgsB9yeIXZvuQriuhqB0GegborRKsD8S6A5ksyH3JEVBwogz3Ok6gjUFiBtylrIgPUHYDD48g4sPgPoG3KyBi8exEYNciX0LBvNi6oQNkDODFgPTZeh4PCjChOBYobQbzYEGLBgh0NTpqoPSGyDIDPAwwZAYyHED6h59X2HUPKGI94BtQ/oagOGG59MBiPUioEN09mDshunmwZsMR60D9h0w3wfQN09hDwGJw5voKH2RRREBunhocsMR7iDhB/w2QfeEGHZD4R4w5EbnLyqbBEB94dYcQPvC7DyRuco4bSOf4XDMRrIzgZyMqlVD+RikAEY4PvDgjRR9GT3J4ixrs11RhnRYOqNprMh1R5nQ0Z3V5rmjccnsbUbc0B7OjnmmNkPrIHVHIhPRjDTPuaNuUajkxvNkxomMNGpjTRhY7MdaNYDzgsxtncscWHQb6BtRqYwvrWNTGK1Mx7Y6MZOOtFxjQx9iGjSg3zG1jAG+o/cag1LGnjH61Y8MfA2D7ajAG0fa8Z/UHGPjUG44w0YA1nGQTUGwXSCYj3TGoTphuY1ce4h09ANdxj49CfePXGkTmx+49Cd+Oom4TAJjE9CeBPYm4TYJkk14cuO1HMuMJtY9ScePDHqTLxhk6Kuin6SETePFk1ieZOqqdjKJ649SYJPcRqTxJ7k7TirVUmWTkJrAfChpNkCZT9J9iDKaZOKmuNcW7NTKa5MqneTCJmU4KZlMimtTZJuUyGp1Nir5h8KLWdMItPUr4U0Q4CNKbw2ZD4U7Ec0wHPtPGmyNXQ+FMIfdOKmpjfJ6qbMYVOBntjypkMxcfRPhnLwmpqM10d2NOn9jY69U0ccp3JnZjRpv07MalNynqDTMnM1COAlem6D5hq025TtNFm82N6hM3mxdOlneDVwis2yOkmNmuR3gr08H1lOKmOzwZ/pTZORM6mOzkZ3s/pL425D1THZ3E12dkl3yzB456cwac4EdmMzi56c9manM2TDBVp4PpafbOyS4jrCrc5ZIbMWDhz5sqsyeeD61ndzNkh9deecnNmLzHktsyedSadmXtcU+E+qdfNhmHdIJVk+bJ1OvmYzv5pitqa/Mfm9Tr5hcyBfwDimnTr5tc++aqmbmvTq0qpUhcmn7mGA5p1JuWZfNxTzz0p1JlefwuAzjzRFuKZ6dIuTSfTXpxhm+eEUDxPzTp+iz+fotDn6LwF+i5Of7n6yZzfRk8/Regv0XlzjFy8IhbEtmmrTOsws4Jc1k2nGGeF6U4w0ItynGGJF5S5cNvNyWw5D5zS2HOfPSn+xDF4yz2eMs/njLQ54y8BeMs8WPdd0+kvxcLHqnjL0F4y6JeMsSX+xKFk895fQv2Xld9JLC4oKtP9ilLcp/sapcVP9iNLEVqfb1J4DaWjL8VyDlReSt36Er2Bwfb6c4GwMGLeVns3lZ/N5WhzeV4C3lbst5W9TeV6C3ldEt5WJLsDHy9Kaav+XWrJZr07A3CuKnYGUV3K33Nis9WwF5FuU0Ar0ujWwFhluU+8IYszWezM1n8zNaHMzXgLM1uyzNb1MzXoLM10SzNYkvhG8zipqI7JelNRGOrJ5xIyNaOtzk+rIeikINc4HvCkr019I+Neuu5HsrXp6kwGZYksmezjJqLeqepNDnqTwF6k3ZYFNJmnTwp1M9DZZOiXqTElzLs1blPI3/LaN869Kcy7dXI9tOW65lweu/XVVz1xU86reu42hDU19iJiljXqiabYasgTTbmF03VTbJlm6OdOHs3pB7N0IezfCHs3Ih7N3QSzaC2ZDMUi3ffVgPFtzCmt4t4/VLcS2D7ZbKWgkcrfS0a6xbNVSnWra/0K3MgUe5W0dXFXU3/oJ7cbbHNJQNquhlt0GRYMtuNbrbhVJW47fsUvo7bg6lKyrpdu9aXbU6l23lq6FBBOBh1hlG3OmFB3TzZ88Oxhf42B3eLMGiwRHaonR3/dhYlOwxJTsKbE7ZpnbUHa1m52zDph24AXfsHR2j5Zd0Ddne7Xtiy7wmuOzdIyvBCy7YmrAUHcnWU6y7sm1u3gGiGYJs78Qg4UHeSEYxs7gKke93eEPj2yBt9c4SHZntbDyl89o4ZXdbtrCINgdtYXXcTtrDk7G984S3entvCtB4dr4cNpPsUHi7e9gEYMNzvFmi7t9uEXPbxGL28RK9w+3CPXvb24RW91e3CN3tf2sRB99iEvdRFIaAHiIru+/aYPlbwHFgAe5kJAcByp7wDtymPYQeoPttCDkBlwPDvYPF72Dt+8A+wef3W72Dn+9Pewf/3SHPdVO3PewcZ3A72DrO9Q9Xlg9GHPdfO+w9XnLDc7IDUu1w8Pn4Oe67azwbg+EckOKHwj8h0Q+EdUPJHP1GBmOrEcKOwHLD9+Z9OUfZBe7Ajk0PA8TsUaweWDwjfNqMc/VJ7WDiPTg8YeWP8Hljwh8EFN0SOiHlj6Rw48sdyPnHph2h/MKjqWOGH+jyx8w4of6G2HAT0w5w7CdeHgroT0hxHv4eRPx9zav9dY9MMiO6HcTpx249SeuPfHqTjx1k68OKOS1uDuJ6o+CepPIHnjrw9o4SdvM9HsT5w4Y9qesC0HzTqXOY4sEipabMAsgV06aE9P2IXT5mwM7FX/mz5OgTp+0ahkTOsBXT7myM66e82FnkmmZ709hVzrVngzk05s7FVcCFQkztufs9mcrm4tRztZzBZ9wHO+1cwY5wFfv1nOtn3jh57s4G03PznRWt51s7GF93jnEt30T87WeRbQxE2yZ7FrZMAuvnmTkVDTQPVdDoXQDsVdlsp0QvEXkQlF9C6CdbPgEagnKyKiNvebjn9AjWJM6T2+jiXhLwYeS7WfRU4tVLrZ3nrzVwu8dLxGwXS7FVHcCRbLkVHYCTNMuKd7+rl3gGFhMBRYhY9USKjIwImJXwZiVwuZFRVb0XXYdAYq571xaVX4glV9IJVdUSVXoQlVwxJVe6DFXY2qUHZpFRIQpXeAaNDsOzXmvBhtrq18sIdfRBxm2LwsQcJFTC7b4kzvfX+syGeut1/rqphBqDdlBhNob5O6G6PWhuT1obs9UG6qGKu6hSb5V0y+APtj0XAGnSAs4eNqic3zxqLTs4EljOMRRbz4/jPzcfr5nnTgDUs5rdAnKdZbqDYLcrc/rhbrb1uZc9md4OeRnzmAzQ8a19uBJFz6UEO7Ieq2x3NDodZO5+pPOZ32QO61296dMPhtzzgSd87hcgM/n9AzNz3SBc9jd3P1MFwBcPfZBWwg+6Yeu9cfruEX678Iae5NCw051D7wrWfc3c903XV1/tz9XxdmuQGRL99z9VJcAf63QHyl4B+yA0u2T/2gSQy8d0QeTQxell6wq5f/uXNCH0nby9A+QfwhqHnusK9FeUHl3PdSV7a5AbO0bX/r8j3K5AYKuMPHend/R5EEvuB9zUlj1q/o86v6Per+jwa/o9GuMPJrgl8R5+oWuyPPda153qo8Sf7X0n0T067k/ZAXXKCNBNNIElevFPJoX186M0+S7uNuns/Re4M/hvsPWnyN6Z6qbRuLPb+rzd6+7c90m4Gj3T4m4w/JvXPqbiz+m5gfdvoT2bmt9Cf6f+e4TwzoLxSZEFlvoTrQnNziYJERf8TY6uLxSf5vRfSTn0xL4k8uPpe3mezsdzY97ehfEnkdjEWu8cdK3cvXj65wV+y/Tuqv7u3reV68OLvR3tX4PR85a+nUN37XhgNu+8/LuI9+7xj1154DHuz5mb/r1C7p4wuE7Pn0w+rfxWbv+v97hb7N7RfLevD+t2nPMOiefurqa3xJ7+/YOF2vDIHmb8d9M17e3mae9zRd9YFQeALMH1Pa9pu9x7Ne2F1D4npd2nfEnPLkte99MP8uvNf3rwwR7FgWHBndPUj1R4j0UepPQ3lcDR/729fwf/ejz19/b3Mfnvp1VjyLLG+mH2tB7zHy3q49w/HgJa3H14dnLJjyfiTtfZt+p9vMhPf7iPWJ6h+mHJP8ZuH93VnOs+vDzUcw2R4j3KedvHr3fSQJ5+JPtPYvuH0fv0/S+Q30vkz2j9f3melfh+qz6r9P2xvpf8buHy57h9uf9fqPvr6Ya88gusBMqOjeb41Eh2Lf7G9iBb/scW/MnFv1xxb4RcW+yn9v9Zzb5NPTDjZlvsgf7/KX++7fSTy8I76mPO+pjrvxM8U66H+/PfYf73/MP9+Yu5J05m392ZIXx+OzoftJyW6bF++OzzvicwSKL/Tn3fHZxP/n8qfp++zaf6u9gJT+vng/35qLX79fOO+gLF7+P6+dd+vn3fUFju734/O1/G/lxv3/RZt/0Xg/rF9v/H/YvcaF/lwjmzXeX98XXf9F930JeH8WDXbVayfyv4b/GWbfpl7P3v/Mvz+L/ntxy47+ss9/r/jd+4dqb9/GX3frl3f+b/csaP4/nlt93v7ysbfAq3P9zfIqyv9QAvuQL8O1P3zKsH/CAPHkX/ePyqslHJAMgDq/Oqx/8AAyAIb9ReAP3t9cA4P1wC8/XAMd9cA531wDXfXAPd9cA6v1wCx/XAIb9UGPANnVrfFPyYC8/JgMd8mA53yYDXfJgPd8mA6vyYCx/JgLT81UWNQZELBcQPSFs1cQJltZA1mwAtJArAXECBRBQO1NlAsgXEDetdQKnV1AvLXUCitBQIoEmtNVBrlTA5hSLsLAqxykDYzeYTVQivQvy6EHAzJwcDXHBwPycHAhFwcD/HFQIpsQ7NVCC1vVQIPSFggucBlswgkbwxE6kWwPPdmpGIL8CpvIl1ElAg0IQSCtArW3f1Y5QILy1IggLRSDStVT2E92INVHxdW4EQFsCQFMIOA9jbHuzR1cBdIJKC0dAZUaC6guD1yFWgtVCQ89laoJc0Cgn73c1+gqdTCCQfQsQ8M/AyVx201UGH3oEpgnxgGVd4WwJbZ89ZwJXBidVYOuAx1RYImDwhOYKq1yg2wIY9TQUGEODGtE4L8DsfKGWUBDgrVwqCLgodXOCMg0nzMFrgi4IG1HgpoNp8d3O4IyChPA4L8ChfVBDUE7NNVGF0DkWwMl91MTIVBDbNaEODdB9cEL8Cw3TlzhDb9T3UysoQiELSDUQ3D1RC/NTIUwgJA7YLIFCQ9IWJD2IQkJltyQhcSgDPBVuC6FCQgUWpDCQvtWZDejMYLZCBjTsAXQGQ5P3pCLBQkKK02QvZ15DDnUUIdsBQmOwjlRQvtVFCh1UUJ9tJQpr2nUFxIm028VQzCE68sBTUKN8KQ8IKi0UXTUIx9JQuIJx9eQpIKR8FxObzUFDQzIK81bQp90tDNQgT0lCdvGqFdCytMHwXFBvbUK5xdQ70MGFbQu71G9eQ9oNOFphTCG6Cd5IMNcdIwhF0jClvSUNGCmnX0MlcIwlcHKVMIKNnf10wuj0lCjgs3xJCmdAZVtDLg3IVLCOPfMOJ9fQ54JtDeQyn1D1Swl0N9ChPdUUwhAQooPdDfQ4XRytMISEN7C9POLQHDDPZqWHC/BXkLRCHLGMQnCXhCcKpEJw2kV5C6hcZElDEVFcN9DTfdcLIFXUIkK6EdwskL3DHxHsX5CsBHcLODDw1f2OCLw1kIvDetakJ3Cp1e8L5Cnwy4xPDtw4O2j1TwuwP+1XURwI7UfwqUNOEAIyS0/D3wu5wxDgIoHUPCmvYCLrVDwoLX4N2IV1B68RDCwWQiZbRCIckogpsXGD3w00KhkdtZCP214Io7Xgi/beCIDt4Ii7UPCdvdUVdQygj4IckQFTCNdQag1CK/CrvcERYjmg0524iww9sUIjmXPZT4jiItCMw8S1QSIB9BjXCKQihXEWFB9Y5V1ElcDhJSO0MlIjxVdR9glUM0jQgw8NVc2TCOD0jHNPSPQ8xIyfSf8SRQyLMi0gvSIG1tIrsAC1Dwv4MYjXUDsLUE6IqplqDXUSEMUjBwgyO9VvIxzVElvIvoLEjJwwKxjkAoyzzHVWg7yOGDgoqplyDgo/0x5C0IqYwPC0o2YypC9wqY3PDMo7YyZCco2YxvD8oi4zvCio7Y0fCKoi4zy17wqYyFDqo7mRn1Go78Jai/wzwR/C17L4zajPvbcJ3sb/b3TaioI0qO5lQdNqLgiRoucG4NJolCJkjtNRYQG9po08LcpsIjtTmjwlfCNyFCIlaNEjlovNmtDCxbaP2jyImaMoiZo6iMmjaIh8XCUGIn4KQi3KZiJai2I9aIeilpFiNeiBlF6LzZ+ImJz6jvo17xjl3o76N2i/oxYQGC1BI6LBiTovaMWFkwosXCVlIzIQRi1ItymzCvNFSLcotIlqILCrImGNaJ9IpQO0jMY4yMmj8fE71Bj8YodSJi82WsMLE2XcJQbCKQLWGxjHIyaOci7o+aNaI3IsV2ui3KbfQCi+Y0IOSi82GX1OcBYkWKCjJo5EJEVYovmKpjhYxYXV1BgqWPiipYpKLQjXzK8I1iPzDKNPC2/YFzfCkIzv0+j7w7v2alDYrKyqkNA02IgsMtG2Ktiqo7WKtjaovcIQtV3e2MmkzdJ2M9jLdPWMakbdP2I6knvb2LbYQIn8PKkudV2MalhowOM9ixokOJBI1Q3YyjiqpBCJTjJpWaJYjUmRaPYjtw7OIdt04ttk2jThQiOziQYo2LikDo36IrjU46GLzjK4s6Njii4orSzi4pK6ITimKW6I7j8AR6O7i/QnkVbiqpTiLGDB4yaWDDivUeLbYfoy+z7iowvRUniQSDlxEVS4uKXBjDowuMXi64muMmk4YxSNSZEYvuJmDppPTTRjBjFSNSYsYvuJxjtIi+Ma0b4uKTLDThemIvjTIpuJBJzI9EOCFcY+uKqlaY01w3imKRmI1QAE/AC+D/4vuPZi+47mKI9t4ttn5jgo1Jh8iAoxBLviEEuKRHCRZWKMQTQot+KYpwo+52QT0EtILQSqpGz2kjCE0hPVisBJsDKFqQpsCqEmtHr1oSuhHrwYTMhRaOYSLBRaLYSuE4Pk4TqE4Ph4TqE1Jn4SyBYuJRlRqLhMYZRE9iAtChEsRNgYZEucFgZ5E2RMSU5QFhNF5VEucFQYlEx0O0SNvX1Q0SuE/1UkSsBJ9CE9phJ9GF1qQ6xPQFbEvyIAsHEjBKhlnE9YIsFrEqiWcSydLoWsTG9XxMSjPpBxLKEmtLABQURdMJMRVQkyoyVtMhMUmkMzEsgXiTFhKJLiS3KU31CT1DRJPYgQaH6lSSLBXJOyAMkuJKJUmwOoUySrRfJKwER6YgWKSCksrUMJN8Y8TZcjbeJTZcLAOdSa0OkmW0yEOk6EV6S8AWhIGSqhHHQsA6QgZPKSJk9IQmTz9diBqDOk3pLcp2AHpIsF5k/pNWS3KIZI2S82EZMWS82cZO2SUk7JP7iUk6ZMOSFRWZPqCfqBZNWSQGZZKi0uku5PWSsBYeMGS5QXpJAZdk25J7oDkl5KySRdV5KqSyBQFMuTx46uhuS/k2SXuSDYj5KhTnk4FL4T3k25NkkvkyFJslfkhFNklJk5FJikzktFP0k6kl5NSYIU4FOJSVkolLil++cwy6SREpFIpSqpVFNJS4pDFLmTcZY5J+igU1lLilCU0lJL1TqElNZS+UhgGhTjw3pIBi8AKlKsCxUoVJ4AtkolJlSUlOlN5TkPBgBZShI1gWxT5UlVJ4BOU9VP/1QUxhgFSucQ1PJTgUw1PhS5k6RKVTLUy4UZSbU/WTVSl4u8XZTGGXVKdTNRWJNWTYGI1LXiJU01LmTvUi1PEifqOVOBSVE61ODTsgR1NgZNUsNPQU8UuNPHkeUuZNF4fU1NP9SucVNKDSpIzsFDSU0phTtTM0phUdSCldlIKUE0/NJyVLknsAQiLBGtNtssBGtIwi60pok+iuhGtOiUW0i0PnV2IGtMVDG0u0Okj20nRM+kVQmtJbiW0tski5lI4dJ7AqdFtMldqQnsCPjNMYdJgUDhdXDGFMhTdOkkLBTdLmFt01tKHC90xW1HCT07tMPSq4q6nPSqRc9NpFz074T3T2uLdKfSLRFCO3Tn0g9NfTQxVaM8EP0t9O8Fv0geAvSgMiwCvT/0n9NvSsBEVLAz706DOfTH06DMm8rhPdMm9d0pDP68v0jDNm99hVDPG9srPDNm8/BQjPW8XhEjMSckXd/W3TJvODLIFJU9b0QyyBYoxQysBYo3QymMmJLPSsBMjDzSMwvNl4ye0GyQEzaU+dO4yrU0TLIFNg8eQEz1EiTPYhOwZiIsEFMhtLIEFMt6KUyeIgyK6EFMztKwEdMhVJ7TDMY1NVttMyNJHiNMnNLds9MrsCszVMpVwHiNMgmLPkVQzsEfjvJUzLJjbM+TK7B5QxzP7S7MoBMMzXMidOszY07zN1TOwZNMMxU9LzOizE9FTPkzU9dTL0yksttKUzHvZ23SzE9cVKCzU9WUKyz/vfzMSzE9P2wKyKfWLId4UfBzJSz+9CUJqy8fXTNUyR9EzLKyafXzPqyKfIrLiy8fAbW0zu9ELKaygjY5MqyTfCtO6yvDKLMCAGEroSJpFhabIsFxWCPXmysBIck/xlssgRNAyhaYRNAws0KHkNJbDbM4yRZJrWKZ+MkO1OyjkkXQuyFRMbOuyPU82MyFnAHui2yuhJ7LyTjkt7KKTbs3Q09SsBPMFMMXsiwX+yJsj7P8NvsoI0uTEAUVUBy/szLl2yoc1VV1SEcoNUuSPYEJMyEPYQtI9hykroWxyEsmzIyTcczZOOSjgrHPSTYso4KiSicpQ0yysBJzLip0ciwXpzq6LHOD4ccpnLZz8c5nJGJCcpnJEymtNzMVS5MlrW5SKc3GS5zcZRrPYhPMxnLpzGGLHNdSKc11K5zXUqXJ8yBot5JF0P4qcKFycdbXIijwklUP1zp9KnKZz+xXnLpzFEknPDThcv+PZzLc+NOqyyBO3LVygE2XOdz3hLHLKMKcsoy5yyjV3My53c6XNMTbcuHIpy4crnLhy1cpgENyuhGPNNysBePOjyzbbwy8AjCZpLjyU8tpK6FGkndFjUUXXPNnxWAgvPEMECPPLmES86vFrwi82kMtDC80HEvDCw9iHryhNAkUry08mfAbyePCwRbzJNdvIchO8xjVW8e80vOryG85sLIFc8PPLrzxDPPP9Cp8mvIryc82fJrzjQrAQXyG8jV2Xzt0GvMrD18lfK7yx1fvLzzEw/fJ3yG84fLPzbAPPInzm8g/J4AN8xQTs0YFcbRysX81jS/cYFQIEMyv8/HK/zoRbfKKFYQVbND0VQmBTaTDvGBQtc388Qzxx2fT/NgKPwLnxxdACiQ1hA+fIuxgKfDD8Co0R87AsAg1gBQ0nzECggsGEDhGBUto+WLdMyEKC5YXIKSC2ED4gBIU10gKGCngBjk+3GBXj4rAzgrYLNcnKyQh8XaYSQhOkvtxEKZbMQolToRSQrhjqQpCCE8DheAqEKuheAtEKLBVQokL1CpZOkKtCvNlkKVCtygULMhZApNBlC9QruSl3diBMK/Uh5LEKnk6lLsL8PeSMLE5CkBiMLzCiPTMKsBDAq8M1C7wrp4YMywsdcI9ejMSdmvfwoj19CjwtMN3CrASYLwIJvwOF4iy8G0Nkio8IcU4i/iASLa8pQTSLG8pIqyLLwW2TyLBpPIo8U8ii1V4hCik0wKLmCwET7c0iteQaLqi6J3CKyBNIpxs0itTQsE0i5IRZFMi5gsBV+i9ouqLhDYYvYg5sMYRx1Ji+xMyFJiuYWmKj0tk0WLxEiNMmLK9CwUmLa9TYsHTuQlYsiEVi3QUWL8XZBzeSQFOYpOTXJC4teSRdObDBS1o64suS7inLKa07iq/TIE7i5/R2LLM24pszV0nYoLDqQubG5zPBIEpFyVggEvcSsBYEq8SuhYEp8SAShiTBKwE/4uhLTbTAFZ0UwsgQ2xa0rARxL8cnEubS8SpYqUCuhHErVycS/LOJKr0lUJxLSs6koDsLBHEoGz2IDbBOLMhDbH2CyS+zJbUmS4sN4i+SwXMMzOSqkuxL1ciyMBjBSrrM5LeswUpZLFUoT1OLJQc4osFlSsbOVKlpTIQ1LPorUqx1fssgWVKXi3UvdTjk5Uq+KsBZUu10sBGoHZKLBGoEVLMhXJVtLrSwwpTzi7R0tSZnSsgS88HSw8F5AQBMAQgEooP0qMAAygATAAQyk4GQAa0SiDIAgAA==";
var TimesBold = "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=";
var TimesItalic = "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";
var STANDARD_FONTS = {
    Courier: (0, _lzStringDefault.default).decompressFromBase64(Courier),
    'Courier-Bold': (0, _lzStringDefault.default).decompressFromBase64(CourierBold),
    'Courier-Oblique': (0, _lzStringDefault.default).decompressFromBase64(CourierOblique),
    Helvetica: (0, _lzStringDefault.default).decompressFromBase64(Helvetica),
    'Helvetica-Bold': (0, _lzStringDefault.default).decompressFromBase64(HelveticaBold),
    'Helvetica-Oblique': (0, _lzStringDefault.default).decompressFromBase64(HelveticaOblique),
    'Times-Roman': (0, _lzStringDefault.default).decompressFromBase64(TimesRoman),
    'Times-Bold': (0, _lzStringDefault.default).decompressFromBase64(TimesBold),
    'Times-Italic': (0, _lzStringDefault.default).decompressFromBase64(TimesItalic)
};
var createStandardFont = function createStandardFont(PDFFont) {
    return function(_PDFFont) {
        inherits(StandardFont, _PDFFont);
        function StandardFont(document, name, id) {
            classCallCheck(this, StandardFont);
            var _this = possibleConstructorReturn(this, (StandardFont.__proto__ || Object.getPrototypeOf(StandardFont)).call(this));
            _this.document = document;
            _this.name = name;
            _this.id = id;
            _this.font = new AFMFont(STANDARD_FONTS[_this.name]);
            _this.ascender = _this.font.ascender;
            _this.descender = _this.font.descender;
            _this.bbox = _this.font.bbox;
            _this.lineGap = _this.font.lineGap;
            return _this;
        }
        createClass(StandardFont, [
            {
                key: 'embed',
                value: function embed() {
                    this.dictionary.data = {
                        Type: 'Font',
                        BaseFont: this.name,
                        Subtype: 'Type1',
                        Encoding: 'WinAnsiEncoding'
                    };
                    return this.dictionary.end();
                }
            },
            {
                key: 'encode',
                value: function encode(text) {
                    var encoded = this.font.encodeText(text);
                    var glyphs = this.font.glyphsForString('' + text);
                    var advances = this.font.advancesForGlyphs(glyphs);
                    var positions = [];
                    for(var i = 0; i < glyphs.length; i++){
                        var glyph = glyphs[i];
                        positions.push({
                            xAdvance: advances[i],
                            yAdvance: 0,
                            xOffset: 0,
                            yOffset: 0,
                            advanceWidth: this.font.widthOfGlyph(glyph)
                        });
                    }
                    return [
                        encoded,
                        positions
                    ];
                }
            },
            {
                key: 'encodeGlyphs',
                value: function encodeGlyphs(glyphs) {
                    var res = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(glyphs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var glyph = _step.value;
                            res.push(('00' + glyph.id.toString(16)).slice(-2));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    return res;
                }
            },
            {
                key: 'widthOfString',
                value: function widthOfString(string, size) {
                    var glyphs = this.font.glyphsForString('' + string);
                    var advances = this.font.advancesForGlyphs(glyphs);
                    var width = 0;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = Array.from(advances)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var advance = _step2.value;
                            width += advance;
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                        } finally{
                            if (_didIteratorError2) throw _iteratorError2;
                        }
                    }
                    var scale = size / 1000;
                    return width * scale;
                }
            }
        ], [
            {
                key: 'isStandardFont',
                value: function isStandardFont(name) {
                    return name in STANDARD_FONTS;
                }
            }
        ]);
        return StandardFont;
    }(PDFFont);
};
var toHex = function toHex() {
    for(var _len = arguments.length, codePoints = Array(_len), _key = 0; _key < _len; _key++)codePoints[_key] = arguments[_key];
    var codes = Array.from(codePoints).map(function(code) {
        return ('0000' + code.toString(16)).slice(-4);
    });
    return codes.join('');
};
var createEmbeddedFont = function createEmbeddedFont(PDFFont) {
    return function(_PDFFont) {
        inherits(EmbeddedFont, _PDFFont);
        function EmbeddedFont(document, font, id) {
            classCallCheck(this, EmbeddedFont);
            var _this = possibleConstructorReturn(this, (EmbeddedFont.__proto__ || Object.getPrototypeOf(EmbeddedFont)).call(this));
            _this.document = document;
            _this.font = font;
            _this.id = id;
            _this.subset = _this.font.createSubset();
            _this.unicode = [
                [
                    0
                ]
            ];
            _this.widths = [
                _this.font.getGlyph(0).advanceWidth
            ];
            _this.name = _this.font.postscriptName;
            _this.scale = 1000 / _this.font.unitsPerEm;
            _this.ascender = _this.font.ascent * _this.scale;
            _this.descender = _this.font.descent * _this.scale;
            _this.xHeight = _this.font.xHeight * _this.scale;
            _this.capHeight = _this.font.capHeight * _this.scale;
            _this.lineGap = _this.font.lineGap * _this.scale;
            _this.bbox = _this.font.bbox;
            _this.layoutCache = Object.create(null);
            return _this;
        }
        createClass(EmbeddedFont, [
            {
                key: 'layoutRun',
                value: function layoutRun(text, features) {
                    var run = this.font.layout(text, features);
                    // Normalize position values
                    for(var i = 0; i < run.positions.length; i++){
                        var position = run.positions[i];
                        for(var key in position)position[key] *= this.scale;
                        position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
                    }
                    return run;
                }
            },
            {
                key: 'layoutCached',
                value: function layoutCached(text) {
                    var cached = void 0;
                    if (cached = this.layoutCache[text]) return cached;
                    var run = this.layoutRun(text);
                    this.layoutCache[text] = run;
                    return run;
                }
            },
            {
                key: 'layout',
                value: function layout(text, features, onlyWidth) {
                    // Skip the cache if any user defined features are applied
                    if (onlyWidth == null) onlyWidth = false;
                    if (features) return this.layoutRun(text, features);
                    var glyphs = onlyWidth ? null : [];
                    var positions = onlyWidth ? null : [];
                    var advanceWidth = 0;
                    // Split the string by words to increase cache efficiency.
                    // For this purpose, spaces and tabs are a good enough delimeter.
                    var last = 0;
                    var index = 0;
                    while(index <= text.length){
                        var needle;
                        if (index === text.length && last < index || (needle = text.charAt(index), [
                            ' ',
                            '\t'
                        ].includes(needle))) {
                            var run = this.layoutCached(text.slice(last, ++index));
                            if (!onlyWidth) {
                                glyphs.push.apply(glyphs, toConsumableArray(Array.from(run.glyphs || [])));
                                positions.push.apply(positions, toConsumableArray(Array.from(run.positions || [])));
                            }
                            advanceWidth += run.advanceWidth;
                            last = index;
                        } else index++;
                    }
                    return {
                        glyphs: glyphs,
                        positions: positions,
                        advanceWidth: advanceWidth
                    };
                }
            },
            {
                key: 'encode',
                value: function encode(text, features) {
                    var _layout = this.layout(text, features), glyphs = _layout.glyphs, positions = _layout.positions;
                    var res = [];
                    for(var i = 0; i < glyphs.length; i++){
                        var glyph = glyphs[i];
                        var gid = this.subset.includeGlyph(glyph.id);
                        res.push(('0000' + gid.toString(16)).slice(-4));
                        if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                        if (this.unicode[gid] == null) this.unicode[gid] = this.font._cmapProcessor.codePointsForGlyph(glyph.id);
                    }
                    return [
                        res,
                        positions
                    ];
                }
            },
            {
                key: 'encodeGlyphs',
                value: function encodeGlyphs(glyphs) {
                    var res = [];
                    for(var i = 0; i < glyphs.length; i++){
                        var glyph = glyphs[i];
                        var gid = this.subset.includeGlyph(glyph.id);
                        res.push(('0000' + gid.toString(16)).slice(-4));
                        if (this.widths[gid] == null) this.widths[gid] = glyph.advanceWidth * this.scale;
                        if (this.unicode[gid] == null) this.unicode[gid] = this.font._cmapProcessor.codePointsForGlyph(glyph.id);
                    }
                    return res;
                }
            },
            {
                key: 'widthOfString',
                value: function widthOfString(string, size, features) {
                    var width = this.layout(string, features, true).advanceWidth;
                    var scale = size / 1000;
                    return width * scale;
                }
            },
            {
                key: 'embed',
                value: function embed() {
                    var isCFF = this.subset.cff != null;
                    var fontFile = this.document.ref();
                    if (isCFF) fontFile.data.Subtype = 'CIDFontType0C';
                    this.subset.encodeStream().pipe(fontFile);
                    var familyClass = ((this.font['OS/2'] != null ? this.font['OS/2'].sFamilyClass : undefined) || 0) >> 8;
                    var flags = 0;
                    if (this.font.post.isFixedPitch) flags |= 1;
                    if (1 <= familyClass && familyClass <= 7) flags |= 2;
                    flags |= 4; // assume the font uses non-latin characters
                    if (familyClass === 10) flags |= 8;
                    if (this.font.head.macStyle.italic) flags |= 64;
                    // generate a random tag (6 uppercase letters. 65 is the char code for 'A')
                    var tag = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5
                    ].map(function(i) {
                        return String.fromCharCode(Math.random() * 26 + 65);
                    }).join('');
                    var name = tag + '+' + this.font.postscriptName;
                    var bbox = this.font.bbox;
                    var descriptor = this.document.ref({
                        Type: 'FontDescriptor',
                        FontName: name,
                        Flags: flags,
                        FontBBox: [
                            bbox.minX * this.scale,
                            bbox.minY * this.scale,
                            bbox.maxX * this.scale,
                            bbox.maxY * this.scale
                        ],
                        ItalicAngle: this.font.italicAngle,
                        Ascent: this.ascender,
                        Descent: this.descender,
                        CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
                        XHeight: (this.font.xHeight || 0) * this.scale,
                        StemV: 0
                    }); // not sure how to calculate this
                    if (isCFF) descriptor.data.FontFile3 = fontFile;
                    else descriptor.data.FontFile2 = fontFile;
                    descriptor.end();
                    var descendantFont = this.document.ref({
                        Type: 'Font',
                        Subtype: isCFF ? 'CIDFontType0' : 'CIDFontType2',
                        BaseFont: name,
                        CIDSystemInfo: {
                            Registry: new String('Adobe'),
                            Ordering: new String('Identity'),
                            Supplement: 0
                        },
                        FontDescriptor: descriptor,
                        W: [
                            0,
                            this.widths
                        ]
                    });
                    descendantFont.end();
                    this.dictionary.data = {
                        Type: 'Font',
                        Subtype: 'Type0',
                        BaseFont: name,
                        Encoding: 'Identity-H',
                        DescendantFonts: [
                            descendantFont
                        ],
                        ToUnicode: this.toUnicodeCmap()
                    };
                    return this.dictionary.end();
                }
            },
            {
                key: 'toUnicodeCmap',
                value: function toUnicodeCmap() {
                    var cmap = this.document.ref();
                    var entries = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(this.unicode)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _codePoints = _step.value;
                            var encoded = [];
                            var _iteratorNormalCompletion2 = true;
                            var _didIteratorError2 = false;
                            var _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = Array.from(_codePoints)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var value = _step2.value;
                                    if (value > 0xffff) {
                                        value -= 0x10000;
                                        encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
                                        value = 0xdc00 | value & 0x3ff;
                                    }
                                    encoded.push(toHex(value));
                                    entries.push('<' + encoded.join(' ') + '>');
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                                } finally{
                                    if (_didIteratorError2) throw _iteratorError2;
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    cmap.end('  /CIDInit /ProcSet findresource begin\n  12 dict begin\n  begincmap\n  /CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n  >> def\n  /CMapName /Adobe-Identity-UCS def\n  /CMapType 2 def\n  1 begincodespacerange\n  <0000><ffff>\n  endcodespacerange\n  1 beginbfrange\n  <0000> <' + toHex(entries.length - 1) + '> [' + entries.join(' ') + ']\n  endbfrange\n  endcmap\n  CMapName currentdict /CMap defineresource pop\n  end\n  end  ');
                    return cmap;
                }
            }
        ]);
        return EmbeddedFont;
    }(PDFFont);
};
var PDFFont = function() {
    function PDFFont() {
        classCallCheck(this, PDFFont);
    }
    createClass(PDFFont, [
        {
            key: 'encode',
            value: function encode(text) {
                throw new Error('Must be implemented by subclasses');
            }
        },
        {
            key: 'widthOfString',
            value: function widthOfString(text) {
                throw new Error('Must be implemented by subclasses');
            }
        },
        {
            key: 'ref',
            value: function ref() {
                return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
            }
        },
        {
            key: 'finalize',
            value: function finalize() {
                if (this.embedded || this.dictionary == null) return;
                this.embed();
                return this.embedded = true;
            }
        },
        {
            key: 'embed',
            value: function embed() {
                throw new Error('Must be implemented by subclasses');
            }
        },
        {
            key: 'lineHeight',
            value: function lineHeight(size, includeGap) {
                if (includeGap == null) includeGap = false;
                var gap = includeGap ? this.lineGap : 0;
                return (this.ascender + gap - this.descender) / 1000 * size;
            }
        }
    ], [
        {
            key: 'open',
            value: function open(document, src, family, id) {
                var font = void 0;
                if (typeof src === 'string') {
                    if (StandardFont.isStandardFont(src)) return new StandardFont(document, src, id);
                    font = (0, _fontkitDefault.default).openSync(src, family);
                } else if (Buffer.isBuffer(src)) font = (0, _fontkitDefault.default).create(src, family);
                else if (src instanceof Uint8Array) font = (0, _fontkitDefault.default).create(new Buffer(src), family);
                else if (src instanceof ArrayBuffer) font = (0, _fontkitDefault.default).create(new Buffer(new Uint8Array(src)), family);
                else if ((typeof src === 'undefined' ? 'undefined' : _typeof(src)) === 'object') font = src;
                if (font == null) throw new Error('Not a supported font format or standard PDF font.');
                return new EmbeddedFont(document, font, id);
            }
        }
    ]);
    return PDFFont;
}();
var StandardFont = createStandardFont(PDFFont);
var EmbeddedFont = createEmbeddedFont(PDFFont);
var Fonts = {
    initFonts: function initFonts() {
        // Lookup table for embedded fonts
        this._fontFamilies = {};
        this._fontCount = 0;
        // Font state
        this._fontSize = 12;
        this._font = null;
        this._registeredFonts = {};
        // Set the default font
        return this.font('Helvetica');
    },
    font: function font(src, family, size) {
        var cacheKey = void 0, font = void 0;
        if (typeof family === 'number') {
            size = family;
            family = null;
        }
        // check registered fonts if src is a string
        if (typeof src === 'string' && this._registeredFonts[src]) {
            cacheKey = src;
            var _registeredFonts$src = this._registeredFonts[src];
            src = _registeredFonts$src.src;
            family = _registeredFonts$src.family;
        } else {
            cacheKey = family || src;
            if (typeof cacheKey !== 'string') cacheKey = null;
        }
        if (size != null) this.fontSize(size);
        // fast path: check if the font is already in the PDF
        if (font = this._fontFamilies[cacheKey]) {
            this._font = font;
            return this;
        }
        // load the font
        var id = 'F' + ++this._fontCount;
        this._font = PDFFont.open(this, src, family, id);
        // check for existing font familes with the same name already in the PDF
        // useful if the font was passed as a buffer
        if (font = this._fontFamilies[this._font.name]) {
            this._font = font;
            return this;
        }
        // save the font for reuse later
        if (cacheKey) this._fontFamilies[cacheKey] = this._font;
        if (this._font.name) this._fontFamilies[this._font.name] = this._font;
        return this;
    },
    fontSize: function fontSize(_fontSize) {
        this._fontSize = _fontSize;
        return this;
    },
    currentLineHeight: function currentLineHeight(includeGap) {
        if (includeGap == null) includeGap = false;
        return this._font.lineHeight(this._fontSize, includeGap);
    },
    registerFont: function registerFont(name, src, family) {
        this._registeredFonts[name] = {
            src: src,
            family: family
        };
        return this;
    }
};
var Text = {
    initText: function initText() {
        // Current coordinates
        this.x = 0;
        this.y = 0;
        return this._lineGap = 0;
    },
    text: function text(_text, x, y, options) {
        options = this._initOptions(x, y, options);
        // if the wordSpacing option is specified, remove multiple consecutive spaces
        if (options.wordSpacing) _text = _text.replace(/\s{2,}/g, ' ');
        // render paragraphs as single lines
        var lines = _text.split('\n');
        for(var i = 0; i < lines.length; i++)this._line(lines[i], options);
        return this;
    },
    _initOptions: function _initOptions() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var y = arguments[1];
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object') {
            options = x;
            x = null;
        }
        // Update the current position
        if (x) this.x = x;
        if (y) this.y = y;
        options.columns = options.columns || 0;
        options.columnGap = options.columnGap || 18; // 1/4 inch
        return options;
    },
    _line: function _line(text) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this._fragment(text, this.x, this.y, options);
    },
    _fragment: function _fragment(text, x, y, options) {
        text = ('' + text).replace(/\n/g, '');
        if (text.length === 0) return;
        // add current font to page if necessary
        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
        // Glyph encoding and positioning
        var _font$encode = this._font.encode(text, options.features), _font$encode2 = slicedToArray(_font$encode, 2), encoded = _font$encode2[0], positions = _font$encode2[1];
        // Pass down spacings to _glyphs method
        options.wordSpacing = options.wordSpacing || 0;
        options.characterSpacing = options.characterSpacing || 0;
        // Adjust y to match coordinate flipping
        y = this.page.height - y - this._font.ascender / 1000 * this._fontSize;
        this._glyphs(encoded, positions, x, y, options);
    },
    _addGlyphs: function _addGlyphs(glyphs, positions, x, y, options) {
        // add current font to page if necessary
        if (options == null) options = {};
        if (this.page.fonts[this._font.id] == null) this.page.fonts[this._font.id] = this._font.ref();
        // Adjust y to match coordinate flipping
        y = this.page.height - y;
        var scale = 1000 / this._fontSize;
        var unitsPerEm = this._font.font.unitsPerEm || 1000;
        var advanceWidthScale = 1000 / unitsPerEm;
        // Glyph encoding and positioning
        var encodedGlyphs = this._font.encodeGlyphs(glyphs);
        var encodedPositions = positions.map(function(pos, i) {
            return {
                xAdvance: pos.xAdvance * scale,
                yAdvance: pos.yAdvance * scale,
                xOffset: pos.xOffset,
                yOffset: pos.yOffset,
                advanceWidth: glyphs[i].advanceWidth * advanceWidthScale
            };
        });
        return this._glyphs(encodedGlyphs, encodedPositions, x, y, options);
    },
    _glyphs: function _glyphs(encoded, positions, x, y, options) {
        var _this = this;
        // flip coordinate system
        var i = void 0;
        this.save();
        this.transform(1, 0, 0, -1, 0, this.page.height);
        // begin the text object
        this.addContent('BT');
        // text position
        this.addContent('1 0 0 1 ' + PDFObject.number(x) + ' ' + PDFObject.number(y) + ' Tm');
        // font and font size
        this.addContent('/' + this._font.id + ' ' + PDFObject.number(this._fontSize) + ' Tf');
        // rendering mode
        var mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
        if (mode) this.addContent(mode + ' Tr');
        // Character spacing
        if (options.characterSpacing) this.addContent(PDFObject.number(options.characterSpacing) + ' Tc');
        var scale = this._fontSize / 1000;
        var commands = [];
        var last = 0;
        var hadOffset = false;
        // Adds a segment of text to the TJ command buffer
        var addSegment = function addSegment(cur) {
            if (last < cur) {
                var hex = encoded.slice(last, cur).join('');
                var advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
                commands.push('<' + hex + '> ' + PDFObject.number(-advance));
            }
            return last = cur;
        };
        // Flushes the current TJ commands to the output stream
        var flush = function flush(i) {
            addSegment(i);
            if (commands.length > 0) {
                _this.addContent('[' + commands.join(' ') + '] TJ');
                return commands.length = 0;
            }
        };
        for(i = 0; i < positions.length; i++){
            // If we have an x or y offset, we have to break out of the current TJ command
            // so we can move the text position.
            var pos = positions[i];
            if (pos.xOffset || pos.yOffset) {
                // Flush the current buffer
                flush(i);
                // Move the text position and flush just the current character
                this.addContent('1 0 0 1 ' + PDFObject.number(x + pos.xOffset * scale) + ' ' + PDFObject.number(y + pos.yOffset * scale) + ' Tm');
                flush(i + 1);
                hadOffset = true;
            } else {
                // If the last character had an offset, reset the text position
                if (hadOffset) {
                    this.addContent('1 0 0 1 ' + PDFObject.number(x) + ' ' + PDFObject.number(y) + ' Tm');
                    hadOffset = false;
                }
                // Group segments that don't have any advance adjustments
                if (pos.xAdvance - pos.advanceWidth !== 0) addSegment(i + 1);
            }
            x += pos.xAdvance * scale;
        }
        // Flush any remaining commands
        flush(i);
        // end the text object
        this.addContent('ET');
        // restore flipped coordinate system
        return this.restore();
    }
};
var Data = function() {
    function Data() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        classCallCheck(this, Data);
        this.pos = 0;
        this.data = data;
        this.length = this.data.length;
    }
    createClass(Data, [
        {
            key: 'readByte',
            value: function readByte() {
                return this.data[this.pos++];
            }
        },
        {
            key: 'writeByte',
            value: function writeByte(byte) {
                return this.data[this.pos++] = byte;
            }
        },
        {
            key: 'byteAt',
            value: function byteAt(index) {
                return this.data[index];
            }
        },
        {
            key: 'readBool',
            value: function readBool() {
                return !!this.readByte();
            }
        },
        {
            key: 'writeBool',
            value: function writeBool(val) {
                return this.writeByte(val ? 1 : 0);
            }
        },
        {
            key: 'readUInt32',
            value: function readUInt32() {
                var b1 = this.readByte() * 0x1000000;
                var b2 = this.readByte() << 16;
                var b3 = this.readByte() << 8;
                var b4 = this.readByte();
                return b1 + b2 + b3 + b4;
            }
        },
        {
            key: 'writeUInt32',
            value: function writeUInt32(val) {
                this.writeByte(val >>> 24 & 0xff);
                this.writeByte(val >> 16 & 0xff);
                this.writeByte(val >> 8 & 0xff);
                return this.writeByte(val & 0xff);
            }
        },
        {
            key: 'readInt32',
            value: function readInt32() {
                var int = this.readUInt32();
                if (int >= 0x80000000) return int - 0x100000000;
                return int;
            }
        },
        {
            key: 'writeInt32',
            value: function writeInt32(val) {
                if (val < 0) val += 0x100000000;
                return this.writeUInt32(val);
            }
        },
        {
            key: 'readUInt16',
            value: function readUInt16() {
                var b1 = this.readByte() << 8;
                var b2 = this.readByte();
                return b1 | b2;
            }
        },
        {
            key: 'writeUInt16',
            value: function writeUInt16(val) {
                this.writeByte(val >> 8 & 0xff);
                return this.writeByte(val & 0xff);
            }
        },
        {
            key: 'readInt16',
            value: function readInt16() {
                var int = this.readUInt16();
                if (int >= 0x8000) return int - 0x10000;
                return int;
            }
        },
        {
            key: 'writeInt16',
            value: function writeInt16(val) {
                if (val < 0) val += 0x10000;
                return this.writeUInt16(val);
            }
        },
        {
            key: 'readString',
            value: function readString(length) {
                var ret = [];
                for(var i = 0, end = length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--)ret[i] = String.fromCharCode(this.readByte());
                return ret.join('');
            }
        },
        {
            key: 'writeString',
            value: function writeString(val) {
                var _this = this;
                return range(0, val.length, false).map(function(i) {
                    return _this.writeByte(val.charCodeAt(i));
                });
            }
        },
        {
            key: 'stringAt',
            value: function stringAt(pos, length) {
                this.pos = pos;
                return this.readString(length);
            }
        },
        {
            key: 'readShort',
            value: function readShort() {
                return this.readInt16();
            }
        },
        {
            key: 'writeShort',
            value: function writeShort(val) {
                return this.writeInt16(val);
            }
        },
        {
            key: 'readLongLong',
            value: function readLongLong() {
                var b1 = this.readByte();
                var b2 = this.readByte();
                var b3 = this.readByte();
                var b4 = this.readByte();
                var b5 = this.readByte();
                var b6 = this.readByte();
                var b7 = this.readByte();
                var b8 = this.readByte();
                if (b1 & 0x80) // sign -> avoid overflow
                return ((b1 ^ 0xff) * 0x100000000000000 + (b2 ^ 0xff) * 0x1000000000000 + (b3 ^ 0xff) * 0x10000000000 + (b4 ^ 0xff) * 0x100000000 + (b5 ^ 0xff) * 0x1000000 + (b6 ^ 0xff) * 0x10000 + (b7 ^ 0xff) * 0x100 + (b8 ^ 0xff) + 1) * -1;
                return b1 * 0x100000000000000 + b2 * 0x1000000000000 + b3 * 0x10000000000 + b4 * 0x100000000 + b5 * 0x1000000 + b6 * 0x10000 + b7 * 0x100 + b8;
            }
        },
        {
            key: 'writeLongLong',
            value: function writeLongLong(val) {
                var high = Math.floor(val / 0x100000000);
                var low = val & 0xffffffff;
                this.writeByte(high >> 24 & 0xff);
                this.writeByte(high >> 16 & 0xff);
                this.writeByte(high >> 8 & 0xff);
                this.writeByte(high & 0xff);
                this.writeByte(low >> 24 & 0xff);
                this.writeByte(low >> 16 & 0xff);
                this.writeByte(low >> 8 & 0xff);
                return this.writeByte(low & 0xff);
            }
        },
        {
            key: 'readInt',
            value: function readInt() {
                return this.readInt32();
            }
        },
        {
            key: 'writeInt',
            value: function writeInt(val) {
                return this.writeInt32(val);
            }
        },
        {
            key: 'slice',
            value: function slice(start, end) {
                return this.data.slice(start, end);
            }
        },
        {
            key: 'read',
            value: function read(bytes) {
                var buf = [];
                for(var i = 0, end = bytes, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--)buf.push(this.readByte());
                return buf;
            }
        },
        {
            key: 'write',
            value: function write(bytes) {
                var _this2 = this;
                return Array.from(bytes).map(function(byte) {
                    return _this2.writeByte(byte);
                });
            }
        }
    ]);
    return Data;
}();
var MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var JPEG = function() {
    function JPEG(data, label) {
        classCallCheck(this, JPEG);
        var marker = void 0;
        this.data = data;
        this.label = label;
        if (this.data.readUInt16BE(0) !== 0xffd8) throw 'SOI not found in JPEG';
        var pos = 2;
        while(pos < this.data.length){
            marker = this.data.readUInt16BE(pos);
            pos += 2;
            if (Array.from(MARKERS).includes(marker)) break;
            pos += this.data.readUInt16BE(pos);
        }
        if (!Array.from(MARKERS).includes(marker)) throw 'Invalid JPEG.';
        pos += 2;
        this.bits = this.data[pos++];
        this.height = this.data.readUInt16BE(pos);
        pos += 2;
        this.width = this.data.readUInt16BE(pos);
        pos += 2;
        var channels = this.data[pos++];
        this.colorSpace = function() {
            switch(channels){
                case 1:
                    return 'DeviceGray';
                case 3:
                    return 'DeviceRGB';
                case 4:
                    return 'DeviceCMYK';
            }
        }();
        this.obj = null;
    }
    createClass(JPEG, [
        {
            key: 'embed',
            value: function embed(document) {
                if (this.obj) return;
                this.obj = document.ref({
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bits,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode'
                });
                // add extra decode params for CMYK images. By swapping the
                // min and max values from the default, we invert the colors. See
                // section 4.8.4 of the spec.
                if (this.colorSpace === 'DeviceCMYK') this.obj.data['Decode'] = [
                    1.0,
                    0.0,
                    1.0,
                    0.0,
                    1.0,
                    0.0,
                    1.0,
                    0.0
                ];
                this.obj.end(this.data);
                // free memory
                return this.data = null;
            }
        }
    ]);
    return JPEG;
}();
var PNGImage = function() {
    function PNGImage(data, label) {
        classCallCheck(this, PNGImage);
        this.label = label;
        this.image = new (0, _pngJsDefault.default)(data);
        this.width = this.image.width;
        this.height = this.image.height;
        this.imgData = this.image.imgData;
        this.obj = null;
    }
    createClass(PNGImage, [
        {
            key: 'embed',
            value: function embed(document) {
                this.document = document;
                if (this.obj) return;
                this.obj = this.document.ref({
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bits,
                    Width: this.width,
                    Height: this.height,
                    Filter: 'FlateDecode'
                });
                if (!this.image.hasAlphaChannel) {
                    var params = this.document.ref({
                        Predictor: 15,
                        Colors: this.image.colors,
                        BitsPerComponent: this.image.bits,
                        Columns: this.width
                    });
                    this.obj.data['DecodeParms'] = params;
                    params.end();
                }
                if (this.image.palette.length === 0) this.obj.data['ColorSpace'] = this.image.colorSpace;
                else {
                    // embed the color palette in the PDF as an object stream
                    var palette = this.document.ref();
                    palette.end(new Buffer(this.image.palette));
                    // build the color space array for the image
                    this.obj.data['ColorSpace'] = [
                        'Indexed',
                        'DeviceRGB',
                        this.image.palette.length / 3 - 1,
                        palette
                    ];
                }
                // For PNG color types 0, 2 and 3, the transparency data is stored in
                // a dedicated PNG chunk.
                if (this.image.transparency.grayscale) {
                    // Use Color Key Masking (spec section 4.8.5)
                    // An array with N elements, where N is two times the number of color components.
                    var val = this.image.transparency.greyscale;
                    return this.obj.data['Mask'] = [
                        val,
                        val
                    ];
                } else if (this.image.transparency.rgb) {
                    // Use Color Key Masking (spec section 4.8.5)
                    // An array with N elements, where N is two times the number of color components.
                    var rgb = this.image.transparency.rgb;
                    var mask = [];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(rgb)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var x = _step.value;
                            mask.push(x, x);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                        } finally{
                            if (_didIteratorError) throw _iteratorError;
                        }
                    }
                    return this.obj.data['Mask'] = mask;
                } else if (this.image.transparency.indexed) // Create a transparency SMask for the image based on the data
                // in the PLTE and tRNS sections. See below for details on SMasks.
                return this.loadIndexedAlphaChannel();
                else if (this.image.hasAlphaChannel) // For PNG color types 4 and 6, the transparency data is stored as a alpha
                // channel mixed in with the main image data. Separate this data out into an
                // SMask object and store it separately in the PDF.
                return this.splitAlphaChannel();
                else return this.finalize();
            }
        },
        {
            key: 'finalize',
            value: function finalize() {
                if (this.alphaChannel) {
                    var sMask = this.document.ref({
                        Type: 'XObject',
                        Subtype: 'Image',
                        Height: this.height,
                        Width: this.width,
                        BitsPerComponent: 8,
                        Filter: 'FlateDecode',
                        ColorSpace: 'DeviceGray',
                        Decode: [
                            0,
                            1
                        ]
                    });
                    sMask.end(this.alphaChannel);
                    this.obj.data['SMask'] = sMask;
                }
                // add the actual image data
                this.obj.end(this.imgData);
                // free memory
                this.image = null;
                return this.imgData = null;
            }
        },
        {
            key: 'splitAlphaChannel',
            value: function splitAlphaChannel() {
                var _this = this;
                return this.image.decodePixels(function(pixels) {
                    var a = void 0, p = void 0;
                    var colorByteSize = _this.image.colors * _this.image.bits / 8;
                    var pixelCount = _this.width * _this.height;
                    var imgData = new Buffer(pixelCount * colorByteSize);
                    var alphaChannel = new Buffer(pixelCount);
                    var i = p = a = 0;
                    var len = pixels.length;
                    while(i < len){
                        imgData[p++] = pixels[i++];
                        imgData[p++] = pixels[i++];
                        imgData[p++] = pixels[i++];
                        alphaChannel[a++] = pixels[i++];
                    }
                    var done = 0;
                    (0, _zlibDefault.default).deflate(imgData, function(err, imgData1) {
                        _this.imgData = imgData1;
                        if (err) throw err;
                        if (++done === 2) return _this.finalize();
                    });
                    return (0, _zlibDefault.default).deflate(alphaChannel, function(err, alphaChannel1) {
                        _this.alphaChannel = alphaChannel1;
                        if (err) throw err;
                        if (++done === 2) return _this.finalize();
                    });
                });
            }
        },
        {
            key: 'loadIndexedAlphaChannel',
            value: function loadIndexedAlphaChannel(fn) {
                var _this2 = this;
                var transparency = this.image.transparency.indexed;
                return this.image.decodePixels(function(pixels) {
                    var alphaChannel = new Buffer(_this2.width * _this2.height);
                    var i = 0;
                    for(var j = 0, end = pixels.length; j < end; j++)alphaChannel[i++] = transparency[pixels[j]];
                    return (0, _zlibDefault.default).deflate(alphaChannel, function(err, alphaChannel1) {
                        _this2.alphaChannel = alphaChannel1;
                        if (err) throw err;
                        return _this2.finalize();
                    });
                });
            }
        }
    ]);
    return PNGImage;
}();
var PDFImage = function() {
    function PDFImage() {
        classCallCheck(this, PDFImage);
    }
    createClass(PDFImage, null, [
        {
            key: 'open',
            value: function open(src, label) {
                var data = void 0;
                if (Buffer.isBuffer(src)) data = src;
                else if (src instanceof ArrayBuffer) data = new Buffer(new Uint8Array(src));
                else {
                    var match = /^data:.+;base64,(.*)$/.exec(src);
                    if (match) data = new Buffer(match[1], 'base64');
                }
                if (data[0] === 0xff && data[1] === 0xd8) return new JPEG(data, label);
                else if (data[0] === 0x89 && data.toString('ascii', 1, 4) === 'PNG') return new PNGImage(data, label);
                else throw new Error('Unknown image format.');
            }
        }
    ]);
    return PDFImage;
}();
var Images = {
    initImages: function initImages() {
        this._imageRegistry = {};
        return this._imageCount = 0;
    },
    image: function image(src, x, y, options) {
        var bh = void 0, bp = void 0, bw = void 0, image = void 0, ip = void 0, left = void 0, left1 = void 0;
        if (options == null) options = {};
        if ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object') {
            options = x;
            x = null;
        }
        x = (left = x != null ? x : options.x) != null ? left : this.x;
        y = (left1 = y != null ? y : options.y) != null ? left1 : this.y;
        if (typeof src === 'string') image = this._imageRegistry[src];
        if (!image) {
            if (src.width && src.height) image = src;
            else image = this.openImage(src);
        }
        if (!image.obj) image.embed(this);
        if (this.page.xobjects[image.label] == null) this.page.xobjects[image.label] = image.obj;
        var w = options.width || image.width;
        var h = options.height || image.height;
        if (options.width && !options.height) {
            var wp = w / image.width;
            w = image.width * wp;
            h = image.height * wp;
        } else if (options.height && !options.width) {
            var hp = h / image.height;
            w = image.width * hp;
            h = image.height * hp;
        } else if (options.scale) {
            w = image.width * options.scale;
            h = image.height * options.scale;
        } else if (options.fit) {
            var _Array$from = Array.from(options.fit);
            var _Array$from2 = slicedToArray(_Array$from, 2);
            bw = _Array$from2[0];
            bh = _Array$from2[1];
            bp = bw / bh;
            ip = image.width / image.height;
            if (ip > bp) {
                w = bw;
                h = bw / ip;
            } else {
                h = bh;
                w = bh * ip;
            }
        } else if (options.cover) {
            var _Array$from3 = Array.from(options.cover);
            var _Array$from4 = slicedToArray(_Array$from3, 2);
            bw = _Array$from4[0];
            bh = _Array$from4[1];
            bp = bw / bh;
            ip = image.width / image.height;
            if (ip > bp) {
                h = bh;
                w = bh * ip;
            } else {
                w = bw;
                h = bw / ip;
            }
        }
        if (options.fit || options.cover) {
            if (options.align === 'center') x = x + bw / 2 - w / 2;
            else if (options.align === 'right') x = x + bw - w;
            if (options.valign === 'center') y = y + bh / 2 - h / 2;
            else if (options.valign === 'bottom') y = y + bh - h;
        }
        // create link annotations if the link option is given
        if (options.link != null) this.link(x, y, w, h, options.link);
        if (options.goTo != null) this.goTo(x, y, w, h, options.goTo);
        if (options.destination != null) this.addNamedDestination(options.destination, 'XYZ', x, y, null);
        // Set the current y position to below the image if it is in the document flow
        if (this.y === y) this.y += h;
        this.save();
        this.transform(w, 0, 0, -h, x, y + h);
        this.addContent('/' + image.label + ' Do');
        this.restore();
        return this;
    },
    openImage: function openImage(src) {
        var image = void 0;
        if (typeof src === 'string') image = this._imageRegistry[src];
        if (!image) {
            image = PDFImage.open(src, 'I' + ++this._imageCount);
            if (typeof src === 'string') this._imageRegistry[src] = image;
        }
        return image;
    }
};
var Annotations = {
    annotate: function annotate(x, y, w, h, options) {
        options.Type = 'Annot';
        options.Rect = this._convertRect(x, y, w, h);
        options.Border = [
            0,
            0,
            0
        ];
        if (options.Subtype !== 'Link') {
            if (options.C == null) options.C = this._normalizeColor(options.color || [
                0,
                0,
                0
            ]);
        } // convert colors
        delete options.color;
        if (typeof options.Dest === 'string') options.Dest = new String(options.Dest);
        // Capitalize keys
        for(var key in options){
            var val = options[key];
            options[key[0].toUpperCase() + key.slice(1)] = val;
        }
        var ref = this.ref(options);
        this.page.annotations.push(ref);
        ref.end();
        return this;
    },
    note: function note(x, y, w, h, contents, options) {
        if (options == null) options = {};
        options.Subtype = 'Text';
        options.Contents = new String(contents);
        options.Name = 'Comment';
        if (options.color == null) options.color = [
            243,
            223,
            92
        ];
        return this.annotate(x, y, w, h, options);
    },
    goTo: function goTo(x, y, w, h, name, options) {
        if (options == null) options = {};
        options.Subtype = 'Link';
        options.A = this.ref({
            S: 'GoTo',
            D: new String(name)
        });
        options.A.end();
        return this.annotate(x, y, w, h, options);
    },
    link: function link(x, y, w, h, url, options) {
        if (options == null) options = {};
        options.Subtype = 'Link';
        if (typeof url === 'number') {
            // Link to a page in the document (the page must already exist)
            var pages = this._root.data.Pages.data;
            if (url >= 0 && url < pages.Kids.length) {
                options.A = this.ref({
                    S: 'GoTo',
                    D: [
                        pages.Kids[url],
                        'XYZ',
                        null,
                        null,
                        null
                    ]
                });
                options.A.end();
            } else throw new Error('The document has no page ' + url);
        } else {
            // Link to an external url
            options.A = this.ref({
                S: 'URI',
                URI: new String(url)
            });
            options.A.end();
        }
        return this.annotate(x, y, w, h, options);
    },
    _markup: function _markup(x, y, w, h, options) {
        if (options == null) options = {};
        var _Array$from = Array.from(this._convertRect(x, y, w, h)), _Array$from2 = slicedToArray(_Array$from, 4), x1 = _Array$from2[0], y1 = _Array$from2[1], x2 = _Array$from2[2], y2 = _Array$from2[3];
        options.QuadPoints = [
            x1,
            y2,
            x2,
            y2,
            x1,
            y1,
            x2,
            y1
        ];
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    highlight: function highlight(x, y, w, h, options) {
        if (options == null) options = {};
        options.Subtype = 'Highlight';
        if (options.color == null) options.color = [
            241,
            238,
            148
        ];
        return this._markup(x, y, w, h, options);
    },
    underline: function underline(x, y, w, h, options) {
        if (options == null) options = {};
        options.Subtype = 'Underline';
        return this._markup(x, y, w, h, options);
    },
    strike: function strike(x, y, w, h, options) {
        if (options == null) options = {};
        options.Subtype = 'StrikeOut';
        return this._markup(x, y, w, h, options);
    },
    lineAnnotation: function lineAnnotation(x1, y1, x2, y2, options) {
        if (options == null) options = {};
        options.Subtype = 'Line';
        options.Contents = new String();
        options.L = [
            x1,
            this.page.height - y1,
            x2,
            this.page.height - y2
        ];
        return this.annotate(x1, y1, x2, y2, options);
    },
    rectAnnotation: function rectAnnotation(x, y, w, h, options) {
        if (options == null) options = {};
        options.Subtype = 'Square';
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    ellipseAnnotation: function ellipseAnnotation(x, y, w, h, options) {
        if (options == null) options = {};
        options.Subtype = 'Circle';
        options.Contents = new String();
        return this.annotate(x, y, w, h, options);
    },
    textAnnotation: function textAnnotation(x, y, w, h, text, options) {
        if (options == null) options = {};
        options.Subtype = 'FreeText';
        options.Contents = new String(text);
        options.DA = new String();
        return this.annotate(x, y, w, h, options);
    },
    _convertRect: function _convertRect(x1, y1, w, h) {
        // flip y1 and y2
        var y2 = y1;
        y1 += h;
        // make x2
        var x2 = x1 + w;
        // apply current transformation matrix to points
        var _Array$from3 = Array.from(this._ctm), _Array$from4 = slicedToArray(_Array$from3, 6), m0 = _Array$from4[0], m1 = _Array$from4[1], m2 = _Array$from4[2], m3 = _Array$from4[3], m4 = _Array$from4[4], m5 = _Array$from4[5];
        x1 = m0 * x1 + m2 * y1 + m4;
        y1 = m1 * x1 + m3 * y1 + m5;
        x2 = m0 * x2 + m2 * y2 + m4;
        y2 = m1 * x2 + m3 * y2 + m5;
        return [
            x1,
            y1,
            x2,
            y2
        ];
    }
};
var PDFDocument$1 = function(_stream$Readable) {
    inherits(PDFDocument, _stream$Readable);
    function PDFDocument() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        classCallCheck(this, PDFDocument);
        var _this = possibleConstructorReturn(this, (PDFDocument.__proto__ || Object.getPrototypeOf(PDFDocument)).call(this));
        _this.options = options;
        _this.version = 1.3;
        _this.compress = true;
        _this._pageBuffer = [];
        _this._pageBufferStart = 0;
        // The PDF object store
        _this._offsets = [];
        _this._waiting = 0;
        _this._ended = false;
        _this._offset = 0;
        var Names = _this.ref({
            Dests: new PDFNameTree()
        });
        _this._root = _this.ref({
            Type: 'Catalog',
            Pages: _this.ref({
                Type: 'Pages',
                Count: 0,
                Kids: []
            }),
            Names: Names
        });
        // The current page
        _this.page = null;
        // Initialize mixins
        _this.initColor();
        _this.initVector();
        _this.initFonts();
        _this.initText();
        _this.initImages();
        // Initialize the metadata
        _this.info = {
            Producer: 'PDFKit',
            Creator: 'PDFKit',
            CreationDate: new Date()
        };
        if (_this.options.info) for(var key in _this.options.info){
            var val = _this.options.info[key];
            _this.info[key] = val;
        }
        // Write the header PDF version
        _this._write('%PDF-' + _this.version);
        // 4 binary chars, as recommended by the spec
        _this._write('%\xFF\xFF\xFF\xFF');
        // Add the first page
        if (_this.options.autoFirstPage !== false) _this.addPage();
        return _this;
    }
    createClass(PDFDocument, [
        {
            key: 'addPage',
            value: function addPage(options) {
                // end the current page if needed
                if (options == null) options = this.options;
                if (!this.options.bufferPages) this.flushPages();
                // create a page object
                this.page = new PDFPage(this, options);
                this._pageBuffer.push(this.page);
                // add the page to the object store
                var pages = this._root.data.Pages.data;
                pages.Kids.push(this.page.dictionary);
                pages.Count++;
                // flip PDF coordinate system so that the origin is in
                // the top left rather than the bottom left
                this._ctm = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                this.transform(1, 0, 0, -1, 0, this.page.height);
                return this;
            }
        },
        {
            key: 'flushPages',
            value: function flushPages() {
                // this local variable exists so we're future-proof against
                // reentrant calls to flushPages.
                var pages = this._pageBuffer;
                this._pageBuffer = [];
                this._pageBufferStart += pages.length;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(pages)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var page = _step.value;
                        page.end();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
            }
        },
        {
            key: 'addNamedDestination',
            value: function addNamedDestination(name) {
                for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (args.length === 0) args = [
                    'XYZ',
                    null,
                    null,
                    null
                ];
                if (args[0] === 'XYZ' && args[2] !== null) args[2] = this.page.height - args[2];
                args.unshift(this.page.dictionary);
                this._root.data.Names.data.Dests.add(name, args);
            }
        },
        {
            key: 'ref',
            value: function ref(data) {
                var ref = new PDFReference(this, this._offsets.length + 1, data);
                this._offsets.push(null); // placeholder for this object's offset once it is finalized
                this._waiting++;
                return ref;
            }
        },
        {
            key: '_read',
            value: function _read() {
            // do nothing, but this method is required by node
            }
        },
        {
            key: '_write',
            value: function _write(data) {
                if (!Buffer.isBuffer(data)) data = new Buffer(data + '\n', 'binary');
                this.push(data);
                return this._offset += data.length;
            }
        },
        {
            key: 'addContent',
            value: function addContent(data) {
                this.page.write(data);
                return this;
            }
        },
        {
            key: '_refEnd',
            value: function _refEnd(ref) {
                this._offsets[ref.id - 1] = ref.offset;
                if (--this._waiting === 0 && this._ended) {
                    this._finalize();
                    return this._ended = false;
                }
            }
        },
        {
            key: 'end',
            value: function end() {
                this.flushPages();
                this._info = this.ref();
                for(var key in this.info){
                    var val = this.info[key];
                    if (typeof val === 'string') val = new String(val);
                    this._info.data[key] = val;
                }
                this._info.end();
                for(var name in this._fontFamilies){
                    var font = this._fontFamilies[name];
                    font.finalize();
                }
                this._root.end();
                this._root.data.Pages.end();
                this._root.data.Names.end();
                if (this._waiting === 0) return this._finalize();
                else return this._ended = true;
            }
        },
        {
            key: '_finalize',
            value: function _finalize(fn) {
                // generate xref
                var xRefOffset = this._offset;
                this._write('xref');
                this._write('0 ' + (this._offsets.length + 1));
                this._write('0000000000 65535 f ');
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = Array.from(this._offsets)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var offset = _step2.value;
                        offset = ('0000000000' + offset).slice(-10);
                        this._write(offset + ' 00000 n ');
                    }
                // trailer
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                    } finally{
                        if (_didIteratorError2) throw _iteratorError2;
                    }
                }
                this._write('trailer');
                this._write(PDFObject.convert({
                    Size: this._offsets.length + 1,
                    Root: this._root,
                    Info: this._info
                }));
                this._write('startxref');
                this._write('' + xRefOffset);
                this._write('%%EOF');
                // end the stream
                return this.push(null);
            }
        },
        {
            key: 'toString',
            value: function toString() {
                return '[object PDFDocument]';
            }
        }
    ]);
    return PDFDocument;
}((0, _streamDefault.default).Readable);
var mixin = function mixin(methods) {
    return function() {
        var result = [];
        for(var name in methods){
            var method = methods[name];
            result.push(PDFDocument$1.prototype[name] = method);
        }
        return result;
    }();
};
// Load mixins
mixin(Color);
mixin(Vector);
mixin(Fonts);
mixin(Text);
mixin(Images);
mixin(Annotations);
exports.default = PDFDocument$1;

},{"c73c3162b1d2bb60":"dB11O","stream":"6U5YO","zlib":"ltIO1","@react-pdf/fontkit":"kddcQ","lz-string":"h2bTB","@react-pdf/png-js":"5hlIT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ltIO1":[function(require,module,exports,__globalThis) {
var process = require("85b5e5b1fe9ac2d6");
'use strict';
var Buffer = require("b45d57ded3095448").Buffer;
var Transform = require("302f6ba8c9b288cd").Transform;
var binding = require("18c3507b0ec1fd53");
var util = require("eb7830382781fd77");
var assert = require("6d05aa73f6370f9e").ok;
var kMaxLength = require("b45d57ded3095448").kMaxLength;
var kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + kMaxLength.toString(16) + ' bytes';
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16384;
binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;
binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var bkeys = Object.keys(binding);
for(var bk = 0; bk < bkeys.length; bk++){
    var bkey = bkeys[bk];
    if (bkey.match(/^Z/)) Object.defineProperty(exports, bkey, {
        enumerable: true,
        value: binding[bkey],
        writable: false
    });
}
// translation table for return codes.
var codes = {
    Z_OK: binding.Z_OK,
    Z_STREAM_END: binding.Z_STREAM_END,
    Z_NEED_DICT: binding.Z_NEED_DICT,
    Z_ERRNO: binding.Z_ERRNO,
    Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
    Z_DATA_ERROR: binding.Z_DATA_ERROR,
    Z_MEM_ERROR: binding.Z_MEM_ERROR,
    Z_BUF_ERROR: binding.Z_BUF_ERROR,
    Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};
var ckeys = Object.keys(codes);
for(var ck = 0; ck < ckeys.length; ck++){
    var ckey = ckeys[ck];
    codes[codes[ckey]] = ckey;
}
Object.defineProperty(exports, 'codes', {
    enumerable: true,
    value: Object.freeze(codes),
    writable: false
});
exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;
exports.createDeflate = function(o) {
    return new Deflate(o);
};
exports.createInflate = function(o) {
    return new Inflate(o);
};
exports.createDeflateRaw = function(o) {
    return new DeflateRaw(o);
};
exports.createInflateRaw = function(o) {
    return new InflateRaw(o);
};
exports.createGzip = function(o) {
    return new Gzip(o);
};
exports.createGunzip = function(o) {
    return new Gunzip(o);
};
exports.createUnzip = function(o) {
    return new Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Deflate(opts), buffer, callback);
};
exports.deflateSync = function(buffer, opts) {
    return zlibBufferSync(new Deflate(opts), buffer);
};
exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Gzip(opts), buffer, callback);
};
exports.gzipSync = function(buffer, opts) {
    return zlibBufferSync(new Gzip(opts), buffer);
};
exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};
exports.deflateRawSync = function(buffer, opts) {
    return zlibBufferSync(new DeflateRaw(opts), buffer);
};
exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Unzip(opts), buffer, callback);
};
exports.unzipSync = function(buffer, opts) {
    return zlibBufferSync(new Unzip(opts), buffer);
};
exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Inflate(opts), buffer, callback);
};
exports.inflateSync = function(buffer, opts) {
    return zlibBufferSync(new Inflate(opts), buffer);
};
exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new Gunzip(opts), buffer, callback);
};
exports.gunzipSync = function(buffer, opts) {
    return zlibBufferSync(new Gunzip(opts), buffer);
};
exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return zlibBuffer(new InflateRaw(opts), buffer, callback);
};
exports.inflateRawSync = function(buffer, opts) {
    return zlibBufferSync(new InflateRaw(opts), buffer);
};
function zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on('error', onError);
    engine.on('end', onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once('readable', flow);
    }
    function onError(err) {
        engine.removeListener('end', onEnd);
        engine.removeListener('readable', flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= kMaxLength) err = new RangeError(kRangeErrorMessage);
        else buf = Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function zlibBufferSync(engine, buffer) {
    if (typeof buffer === 'string') buffer = Buffer.from(buffer);
    if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function Deflate(opts) {
    if (!(this instanceof Deflate)) return new Deflate(opts);
    Zlib.call(this, opts, binding.DEFLATE);
}
function Inflate(opts) {
    if (!(this instanceof Inflate)) return new Inflate(opts);
    Zlib.call(this, opts, binding.INFLATE);
}
// gzip - bigger header, same deflate compression
function Gzip(opts) {
    if (!(this instanceof Gzip)) return new Gzip(opts);
    Zlib.call(this, opts, binding.GZIP);
}
function Gunzip(opts) {
    if (!(this instanceof Gunzip)) return new Gunzip(opts);
    Zlib.call(this, opts, binding.GUNZIP);
}
// raw - no header
function DeflateRaw(opts) {
    if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
    Zlib.call(this, opts, binding.DEFLATERAW);
}
function InflateRaw(opts) {
    if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
    Zlib.call(this, opts, binding.INFLATERAW);
}
// auto-detect header.
function Unzip(opts) {
    if (!(this instanceof Unzip)) return new Unzip(opts);
    Zlib.call(this, opts, binding.UNZIP);
}
function isValidFlushFlag(flag) {
    return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;
    Transform.call(this, opts);
    if (opts.flush && !isValidFlushFlag(opts.flush)) throw new Error('Invalid flush flag: ' + opts.flush);
    if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) throw new Error('Invalid flush flag: ' + opts.finishFlush);
    this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) throw new Error('Invalid compression level: ' + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) throw new Error('Invalid strategy: ' + opts.strategy);
    }
    if (opts.dictionary) {
        if (!Buffer.isBuffer(opts.dictionary)) throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
    this._handle = new binding.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        _close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = exports.codes[errno];
        self.emit('error', error);
    };
    var level = exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === 'number') level = opts.level;
    var strategy = exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === 'number') strategy = opts.strategy;
    this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once('end', this.close);
    Object.defineProperty(this, '_closed', {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
util.inherits(Zlib, Transform);
Zlib.prototype.params = function(level, strategy, callback) {
    if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) throw new RangeError('Invalid compression level: ' + level);
    if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) throw new TypeError('Invalid strategy: ' + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush(binding.Z_SYNC_FLUSH, function() {
            assert(self._handle, 'zlib binding closed');
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else process.nextTick(callback);
};
Zlib.prototype.reset = function() {
    assert(this._handle, 'zlib binding closed');
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function(callback) {
    this._transform(Buffer.alloc(0), '', callback);
};
Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === 'function' || kind === undefined && !callback) {
        callback = kind;
        kind = binding.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) process.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once('end', callback);
    } else if (ws.needDrain) {
        if (callback) this.once('drain', function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write(Buffer.alloc(0), '', callback);
    }
};
Zlib.prototype.close = function(callback) {
    _close(this, callback);
    process.nextTick(emitCloseNT, this);
};
function _close(engine, callback) {
    if (callback) process.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function emitCloseNT(self) {
    self.emit('close');
}
Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
    if (!this._handle) return cb(new Error('zlib binding closed'));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === 'function';
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on('error', function(er) {
            error = er;
        });
        assert(this._handle, 'zlib binding closed');
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= kMaxLength) {
            _close(this);
            throw new RangeError(kRangeErrorMessage);
        }
        var buf = Buffer.concat(buffers, nread);
        _close(this);
        return buf;
    }
    assert(this._handle, 'zlib binding closed');
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        assert(have >= 0, 'have should not go down');
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);

},{"85b5e5b1fe9ac2d6":"5jT8D","b45d57ded3095448":"dB11O","302f6ba8c9b288cd":"6U5YO","18c3507b0ec1fd53":"6UY1m","eb7830382781fd77":"6Hf8s","6d05aa73f6370f9e":"gK6e8"}],"6UY1m":[function(require,module,exports,__globalThis) {
var Buffer = require("c0875ec23d3f711b").Buffer;
var process = require("275b523c6d34b701");
'use strict';
/* eslint camelcase: "off" */ var assert = require("77b161f030b665c6");
var Zstream = require("fd1f09d11ac7dfac");
var zlib_deflate = require("df246bd555afd20e");
var zlib_inflate = require("38e8b32c21318329");
var constants = require("5b80d7a6197bcc1e");
for(var key in constants)exports[key] = constants[key];
// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;
var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function Zlib(mode) {
    if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) throw new TypeError('Bad argument');
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    assert(this.init_done, 'close before init');
    assert(this.mode <= exports.UNZIP);
    if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) zlib_deflate.deflateEnd(this.strm);
    else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) zlib_inflate.inflateEnd(this.strm);
    this.mode = exports.NONE;
    this.dictionary = null;
};
Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    assert.equal(arguments.length, 8);
    assert(this.init_done, 'write before init');
    assert(this.mode !== exports.NONE, 'already finalized');
    assert.equal(false, this.write_in_progress, 'write already in progress');
    assert.equal(false, this.pending_close, 'close is pending');
    this.write_in_progress = true;
    assert.equal(false, flush === undefined, 'must provide flush value');
    this.write_in_progress = true;
    if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) throw new Error('Invalid flush value');
    if (input == null) {
        input = Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    process.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflate(this.strm, this.flush);
            break;
        case exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = exports.INFLATE;
                    break;
                default:
                    throw new Error('invalid number of gzip magic number bytes read');
            }
        // fallthrough
        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
            this.err = zlib_inflate.inflate(this.strm, this.flush);
            if (this.err === exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === exports.Z_OK) // And try to decode again
                this.err = zlib_inflate.inflate(this.strm, this.flush);
                else if (this.err === exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = zlib_inflate.inflate(this.strm, this.flush);
            }
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
};
Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case exports.Z_OK:
        case exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
                this._error('unexpected end of file');
                return false;
            }
            break;
        case exports.Z_STREAM_END:
            break;
        case exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error('Missing dictionary');
            else this._error('Bad dictionary');
            return false;
        default:
            // something else.
            this._error('Zlib error');
            return false;
    }
    return true;
};
Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
    assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
    assert(level >= -1 && level <= 9, 'invalid compression level');
    assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
    assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
Zlib.prototype.params = function() {
    throw new Error('deflateParams Not supported');
};
Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = exports.Z_NO_FLUSH;
    this.err = exports.Z_OK;
    if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) this.windowBits += 16;
    if (this.mode === exports.UNZIP) this.windowBits += 32;
    if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new Zstream();
    switch(this.mode){
        case exports.DEFLATE:
        case exports.GZIP:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case exports.INFLATE:
        case exports.GUNZIP:
        case exports.INFLATERAW:
        case exports.UNZIP:
            this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
    if (this.err !== exports.Z_OK) this._error('Init error');
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = exports.Z_OK;
    switch(this.mode){
        case exports.DEFLATE:
        case exports.DEFLATERAW:
            this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== exports.Z_OK) this._error('Failed to set dictionary');
};
Zlib.prototype._reset = function() {
    this.err = exports.Z_OK;
    switch(this.mode){
        case exports.DEFLATE:
        case exports.DEFLATERAW:
        case exports.GZIP:
            this.err = zlib_deflate.deflateReset(this.strm);
            break;
        case exports.INFLATE:
        case exports.INFLATERAW:
        case exports.GUNZIP:
            this.err = zlib_inflate.inflateReset(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== exports.Z_OK) this._error('Failed to reset stream');
};
exports.Zlib = Zlib;

},{"c0875ec23d3f711b":"dB11O","275b523c6d34b701":"5jT8D","77b161f030b665c6":"gK6e8","fd1f09d11ac7dfac":"8m1U1","df246bd555afd20e":"cW4cK","38e8b32c21318329":"8KYHj","5b80d7a6197bcc1e":"kl5PS"}],"gK6e8":[function(require,module,exports,__globalThis) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
var process = require("17530e9a8e9dd8de");
'use strict';
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var _require = require("67930e3bebc18ea9"), _require$codes = _require.codes, ERR_AMBIGUOUS_ARGUMENT = _require$codes.ERR_AMBIGUOUS_ARGUMENT, ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE = _require$codes.ERR_INVALID_ARG_VALUE, ERR_INVALID_RETURN_VALUE = _require$codes.ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS;
var AssertionError = require("11bdd262fb706a54");
var _require2 = require("d61a3396666721b6"), inspect = _require2.inspect;
var _require$types = require("d61a3396666721b6").types, isPromise = _require$types.isPromise, isRegExp = _require$types.isRegExp;
var objectAssign = require("fe81af847d362e93")();
var objectIs = require("4ad4507c8e372c71")();
var RegExpPrototypeTest = require("11f208d8f2e10b17")('RegExp.prototype.test');
var errorCache = new Map();
var isDeepEqual;
var isDeepStrictEqual;
var parseExpressionAt;
var findNodeAround;
var decoder;
function lazyLoadComparison() {
    var comparison = require("131e25d2408617a4");
    isDeepEqual = comparison.isDeepEqual;
    isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var escapeFn = function escapeFn(str) {
    return meta[str.charCodeAt(0)];
};
var warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var assert = module.exports = ok;
var NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new AssertionError(obj);
}
function fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if (warned === false) {
            warned = true;
            var warn = process.emitWarning ? process.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new AssertionError(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
assert.fail = fail;
// The AssertionError is defined in internal/error.
assert.AssertionError = AssertionError;
function innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new AssertionError({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    innerOk.apply(void 0, [
        ok,
        args.length
    ].concat(args));
}
assert.ok = ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (!isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    if (isDeepEqual === undefined) lazyLoadComparison();
    if (isDeepStrictEqual(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: notDeepStrictEqual
    });
}
assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    if (!objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new ERR_MISSING_ARGS('actual', 'expected');
    if (objectIs(actual, expected)) innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var Comparison = /*#__PURE__*/ _createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    _classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && isRegExp(obj[key]) && RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new Comparison(actual, keys);
            var b = new Comparison(expected, keys, actual);
            var err = new AssertionError({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if (isRegExp(expected)) return RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if (_typeof(actual) !== 'object' || actual === null) {
            var err = new AssertionError({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if (isDeepEqual === undefined) lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && isRegExp(expected[key]) && RegExpPrototypeTest(expected[key], actual[key])) return;
            compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function getActual(fn) {
    if (typeof fn !== 'function') throw new ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return NO_EXCEPTION_SENTINEL;
}
function checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return isPromise(obj) || obj !== null && _typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!checkIsPromise(resultPromise)) throw new ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if (checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if (_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && _typeof(error) !== 'object' && typeof error !== 'function') throw new ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !expectedException(actual, error, message, stackStartFn)) throw actual;
}
function expectsNoError(stackStartFn, actual, error, message) {
    if (actual === NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    expectsError.apply(void 0, [
        throws,
        getActual(promiseFn)
    ].concat(args));
};
assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return waitForActual(promiseFn).then(function(result) {
        return expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    expectsNoError.apply(void 0, [
        doesNotThrow,
        getActual(fn)
    ].concat(args));
};
assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return waitForActual(fn).then(function(result) {
        return expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if (_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += inspect(err);
        var newErr = new AssertionError({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function internalMatch(string, regexp, message, fn, fnName) {
    if (!isRegExp(regexp)) throw new ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat(_typeof(string), " (").concat(inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat(inspect(regexp), ". Input:\n\n").concat(inspect(string), "\n"));
        var err = new AssertionError({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
assert.match = function match(string, regexp, message) {
    internalMatch(string, regexp, message, match, 'match');
};
assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    innerOk.apply(void 0, [
        strict,
        args.length
    ].concat(args));
}
assert.strict = objectAssign(strict, assert, {
    equal: assert.strictEqual,
    deepEqual: assert.deepStrictEqual,
    notEqual: assert.notStrictEqual,
    notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

},{"17530e9a8e9dd8de":"5jT8D","67930e3bebc18ea9":"8jLut","11bdd262fb706a54":"aZ73r","d61a3396666721b6":"6Hf8s","fe81af847d362e93":"es1pE","4ad4507c8e372c71":"gpUkX","11f208d8f2e10b17":"6cPux","131e25d2408617a4":"iss0t"}],"8jLut":[function(require,module,exports,__globalThis) {
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ 'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
var codes = {};
// Lazy loaded
var assert;
var util;
function createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        _inherits(NodeError, _Base);
        var _super = _createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            _classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return _createClass(NodeError);
    }(Base);
    codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if (assert === undefined) assert = require("f73a3052b95b9ed");
    assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if (endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    else {
        var type = includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat(_typeof(actual));
    return msg;
}, TypeError);
createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if (util === undefined) util = require("1fd472100fa8826f");
    var inspected = util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat(_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);
createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (assert === undefined) assert = require("f73a3052b95b9ed");
    assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
module.exports.codes = codes;

},{"f73a3052b95b9ed":"gK6e8","1fd472100fa8826f":"6Hf8s"}],"aZ73r":[function(require,module,exports,__globalThis) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c
var process = require("228da2c254a5e871");
'use strict';
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _require = require("9984e91d63ed614c"), inspect = _require.inspect;
var _require2 = require("1670766d7c5cef96"), ERR_INVALID_ARG_TYPE = _require2.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var blue = '';
var green = '';
var red = '';
var white = '';
var kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var kMaxShortLength = 10;
function copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && _typeof(actual) === 'object' && _typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= kMaxShortLength) {
            if ((_typeof(actual) !== 'object' || actual === null) && (_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat(kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat(repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat(blue, "...").concat(white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat(kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat(blue, "...").concat(white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = kReadableOperator[operator] + "\n".concat(green, "+ actual").concat(white, " ").concat(red, "- expected").concat(white);
    var skippedMsg = " ".concat(blue, "...").concat(white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat(red, "-").concat(white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat(blue, "...").concat(white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat(green, "+").concat(white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat(blue, "...").concat(white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat(green, "+").concat(white, " ").concat(actualLine);
                other += "\n".concat(red, "-").concat(white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat(blue, "...").concat(white).concat(other, "\n") + "".concat(blue, "...").concat(white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    _inherits(AssertionError, _Error);
    var _super = _createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        _classCallCheck(this, AssertionError);
        if (_typeof(options) !== 'object' || options === null) throw new ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if (process.stderr && process.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1) {
                    blue = "\x1B[34m";
                    green = "\x1B[32m";
                    white = "\x1B[39m";
                    red = "\x1B[31m";
                } else {
                    blue = '';
                    green = '';
                    white = '';
                    red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if (_typeof(actual) === 'object' && actual !== null && _typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = copyError(actual);
                expected = copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = kReadableOperator[operator];
                var res = inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && _typeof(actual) === 'object' && actual !== null) base = kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat(blue, "...").concat(white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = inspectValue(actual);
                var other = '';
                var knownOperators = kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat(kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat(inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty(_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace(_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return _possibleConstructorReturn(_this);
    }
    _createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return inspect(this, _objectSpread(_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ _wrapNativeSuper(Error), inspect.custom);
module.exports = AssertionError;

},{"228da2c254a5e871":"5jT8D","9984e91d63ed614c":"6Hf8s","1670766d7c5cef96":"8jLut"}],"es1pE":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("b7e83063a8ec29e5");
var lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return implementation;
    if (lacksProperEnumerationOrder()) return implementation;
    if (assignHasPendingExceptions()) return implementation;
    return Object.assign;
};

},{"b7e83063a8ec29e5":"47eDt"}],"47eDt":[function(require,module,exports,__globalThis) {
'use strict';
// modified from https://github.com/es-shims/es6-shim
var objectKeys = require("334c0bea01e613e6");
var hasSymbols = require("1964e25feb5e87a1")();
var callBound = require("20da938b12dae35d");
var $Object = require("5b3fc42904ffd60f");
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $Object(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $Object(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = objectKeys(from);
        var getSymbols = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($propIsEnumerable(from, key)) $push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

},{"334c0bea01e613e6":"7AE8b","1964e25feb5e87a1":"77zbC","20da938b12dae35d":"dhWMF","5b3fc42904ffd60f":"jtFM1"}],"6cPux":[function(require,module,exports,__globalThis) {
'use strict';
var GetIntrinsic = require("8b08ecb81cf4de17");
var callBind = require("266fc50410cfc4a");
var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) return callBind(intrinsic);
    return intrinsic;
};

},{"8b08ecb81cf4de17":"dRNto","266fc50410cfc4a":"hMR6y"}],"iss0t":[function(require,module,exports,__globalThis) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var regexFlagsSupported = /a/g.flags !== undefined;
var arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};
var objectIs = Object.is ? Object.is : require("3addb16fbdd05c1c");
var objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};
var numberIsNaN = Number.isNaN ? Number.isNaN : require("a27e57a3fd2e2e23");
function uncurryThis(f) {
    return f.call.bind(f);
}
var hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
var propertyIsEnumerable = uncurryThis(Object.prototype.propertyIsEnumerable);
var objectToString = uncurryThis(Object.prototype.toString);
var _require$types = require("4940125679601087").types, isAnyArrayBuffer = _require$types.isAnyArrayBuffer, isArrayBufferView = _require$types.isArrayBufferView, isDate = _require$types.isDate, isMap = _require$types.isMap, isRegExp = _require$types.isRegExp, isSet = _require$types.isSet, isNativeError = _require$types.isNativeError, isBoxedPrimitive = _require$types.isBoxedPrimitive, isNumberObject = _require$types.isNumberObject, isStringObject = _require$types.isStringObject, isBooleanObject = _require$types.isBooleanObject, isBigIntObject = _require$types.isBigIntObject, isSymbolObject = _require$types.isSymbolObject, isFloat32Array = _require$types.isFloat32Array, isFloat64Array = _require$types.isFloat64Array;
function isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function getOwnNonIndexProperties(value) {
    return Object.keys(value).filter(isNonIndex).concat(objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var ONLY_ENUMERABLE = undefined;
var kStrict = true;
var kLoose = false;
var kNoIterator = 0;
var kIsArray = 1;
var kIsSet = 2;
var kIsMap = 3;
// Check if they have the same source and flags
function areSimilarRegExps(a, b) {
    return regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function isEqualBoxedPrimitive(val1, val2) {
    if (isNumberObject(val1)) return isNumberObject(val2) && objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if (isStringObject(val1)) return isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if (isBooleanObject(val1)) return isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if (isBigIntObject(val1)) return isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if (_typeof(val1) !== 'object') return typeof val1 === 'number' && numberIsNaN(val1) && numberIsNaN(val2);
        if (_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || _typeof(val1) !== 'object') {
            if (val2 === null || _typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || _typeof(val2) !== 'object') return false;
    }
    var val1Tag = objectToString(val1);
    var val2Tag = objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
        var keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!isMap(val1) && isMap(val2) || !isSet(val1) && isSet(val2)) return false;
    }
    if (isDate(val1)) {
        if (!isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if (isRegExp(val1)) {
        if (!isRegExp(val2) || !areSimilarRegExps(val1, val2)) return false;
    } else if (isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if (isArrayBufferView(val1)) {
        if (!strict && (isFloat32Array(val1) || isFloat64Array(val1))) {
            if (!areSimilarFloatArrays(val1, val2)) return false;
        } else if (!areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = getOwnNonIndexProperties(val1, ONLY_ENUMERABLE);
        var _keys2 = getOwnNonIndexProperties(val2, ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return keyCheck(val1, val2, strict, memos, kNoIterator, _keys);
    } else if (isSet(val1)) {
        if (!isSet(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsSet);
    } else if (isMap(val1)) {
        if (!isMap(val2) || val1.size !== val2.size) return false;
        return keyCheck(val1, val2, strict, memos, kIsMap);
    } else if (isAnyArrayBuffer(val1)) {
        if (!areEqualArrayBuffers(val1, val2)) return false;
    } else if (isBoxedPrimitive(val1) && !isEqualBoxedPrimitive(val1, val2)) return false;
    return keyCheck(val1, val2, strict, memos, kNoIterator);
}
function getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return propertyIsEnumerable(val, k);
    });
}
function keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if (propertyIsEnumerable(val1, key)) {
                    if (!propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if (propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === kNoIterator || iterationType === kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if (innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function findLooseMatchingPrimitives(prim) {
    switch(_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if (numberIsNaN(prim)) return false;
    }
    return true;
}
function setMightHaveLoosePrim(a, b, prim) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && innerDeepEqual(item, curB, false, memo);
}
function setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if (_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if (_typeof(_val) === 'object' && _val !== null) {
                if (!setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if (innerDeepEqual(key1, key2, strict, memo) && innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = _slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if (_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = _slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if (_typeof(_key) === 'object' && _key !== null) {
                if (!mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !innerDeepEqual(a.get(_key), item, false, memo)) && !mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === kIsSet) {
        if (!setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsMap) {
        if (!mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === kIsArray) for(; i < a.length; i++){
        if (hasOwnProperty(a, i)) {
            if (!hasOwnProperty(b, i) || !innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if (hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!hasOwnProperty(b, key) || !innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function isDeepEqual(val1, val2) {
    return innerDeepEqual(val1, val2, kLoose);
}
function isDeepStrictEqual(val1, val2) {
    return innerDeepEqual(val1, val2, kStrict);
}
module.exports = {
    isDeepEqual: isDeepEqual,
    isDeepStrictEqual: isDeepStrictEqual
};

},{"3addb16fbdd05c1c":"41SFz","a27e57a3fd2e2e23":"aUZeV","4940125679601087":"6Hf8s"}],"aUZeV":[function(require,module,exports,__globalThis) {
'use strict';
var callBind = require("8bc778ead6edc2b");
var define = require("1e9a111647ec40d6");
var implementation = require("db9e8266e38a0a1c");
var getPolyfill = require("37ae20d268339d21");
var shim = require("9fe13ad91d3d9c68");
var polyfill = callBind(getPolyfill(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ define(polyfill, {
    getPolyfill: getPolyfill,
    implementation: implementation,
    shim: shim
});
module.exports = polyfill;

},{"8bc778ead6edc2b":"hMR6y","1e9a111647ec40d6":"iXqnd","db9e8266e38a0a1c":"i6wpL","37ae20d268339d21":"lRRkh","9fe13ad91d3d9c68":"4Rgwg"}],"i6wpL":[function(require,module,exports,__globalThis) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

},{}],"lRRkh":[function(require,module,exports,__globalThis) {
'use strict';
var implementation = require("e25466f067cfd8fc");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return implementation;
};

},{"e25466f067cfd8fc":"i6wpL"}],"4Rgwg":[function(require,module,exports,__globalThis) {
'use strict';
var define = require("6e613ddb8bace1c6");
var getPolyfill = require("f2ce5ac0488eb372");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = getPolyfill();
    define(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

},{"6e613ddb8bace1c6":"iXqnd","f2ce5ac0488eb372":"lRRkh"}],"8m1U1":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = ZStream;

},{}],"cW4cK":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("6ecd050ab5cf9e92");
var trees = require("b17b4660c9a756a1");
var adler32 = require("8a0173ce93724f81");
var crc32 = require("9fe740ea87b93669");
var msg = require("86729d90d4373c72");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var Z_NO_FLUSH = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;
var Z_FILTERED = 1;
var Z_HUFFMAN_ONLY = 2;
var Z_RLE = 3;
var Z_FIXED = 4;
var Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/* The deflate compression method */ var Z_DEFLATED = 8;
/*============================================================================*/ var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_MEM_LEVEL = 8;
var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
var PRESET_DICT = 0x20;
var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;
var BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var BS_BLOCK_DONE = 2; /* block flush performed */ 
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function err(strm, errorCode) {
    strm.msg = msg[errorCode];
    return errorCode;
}
function rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function flush_block_only(s, last) {
    trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    flush_pending(s.strm);
}
function put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    utils.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
                if (s.strm.avail_out === 0) return BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) return BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
                if (flush === Z_NO_FLUSH) return BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        /***/ return BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
    /***/ }
    return BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var configuration_table;
configuration_table = [
    /*      good lazy nice chain */ new Config(0, 0, 0, 0, deflate_stored),
    /* 0 store only */ new Config(4, 4, 8, 4, deflate_fast),
    /* 1 max speed, no lazy matches */ new Config(4, 5, 16, 8, deflate_fast),
    /* 2 */ new Config(4, 6, 32, 32, deflate_fast),
    /* 3 */ new Config(4, 4, 16, 16, deflate_slow),
    /* 4 lazy matches */ new Config(8, 16, 32, 32, deflate_slow),
    /* 5 */ new Config(8, 16, 128, 128, deflate_slow),
    /* 6 */ new Config(8, 32, 128, 256, deflate_slow),
    /* 7 */ new Config(32, 128, 258, 1024, deflate_slow),
    /* 8 */ new Config(32, 258, 258, 4096, deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = configuration_table[s.level].max_lazy;
    s.good_match = configuration_table[s.level].good_length;
    s.nice_match = configuration_table[s.level].nice_length;
    s.max_chain_length = configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
    this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
    this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
    zero(this.dyn_ltree);
    zero(this.dyn_dtree);
    zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new utils.Buf16(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */ 
    zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
    zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return err(strm, Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? INIT_STATE : BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = Z_NO_FLUSH;
    trees._tr_init(s);
    return Z_OK;
}
function deflateReset(strm) {
    var ret = deflateResetKeep(strm);
    if (ret === Z_OK) lm_init(strm.state);
    return ret;
}
function deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return Z_OK;
}
function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return Z_STREAM_ERROR;
    var wrap = 1;
    if (level === Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) return err(strm, Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
    s.window = new utils.Buf8(s.w_size * 2);
    s.head = new utils.Buf16(s.hash_size);
    s.prev = new utils.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new utils.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return deflateReset(strm);
}
function deflateInit(strm, level) {
    return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}
function deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, 0);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, OS_CODE);
                s.status = BUSY_STATE;
            } else {
                put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                put_byte(s, s.gzhead.time & 0xff);
                put_byte(s, s.gzhead.time >> 8 & 0xff);
                put_byte(s, s.gzhead.time >> 16 & 0xff);
                put_byte(s, s.gzhead.time >> 24 & 0xff);
                put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    put_byte(s, s.gzhead.extra.length & 0xff);
                    put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = EXTRA_STATE;
            }
        } else {
            var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= PRESET_DICT;
            header += 31 - header % 31;
            s.status = BUSY_STATE;
            putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = NAME_STATE;
            }
        } else s.status = NAME_STATE;
    }
    if (s.status === NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = COMMENT_STATE;
            }
        } else s.status = COMMENT_STATE;
    }
    if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                    flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = HCRC_STATE;
        } else s.status = HCRC_STATE;
    }
    if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                put_byte(s, strm.adler & 0xff);
                put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = BUSY_STATE;
            }
        } else s.status = BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) return err(strm, Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
        var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) trees._tr_align(s);
            else if (flush !== Z_BLOCK) {
                trees._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== Z_FINISH) return Z_OK;
    if (s.wrap <= 0) return Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, strm.adler >> 8 & 0xff);
        put_byte(s, strm.adler >> 16 & 0xff);
        put_byte(s, strm.adler >> 24 & 0xff);
        put_byte(s, strm.total_in & 0xff);
        put_byte(s, strm.total_in >> 8 & 0xff);
        put_byte(s, strm.total_in >> 16 & 0xff);
        put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
    }
    flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}
function deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) return err(strm, Z_STREAM_ERROR);
    strm.state = null;
    return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new utils.Buf8(s.w_size);
        utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    fill_window(s);
    while(s.lookahead >= MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - (MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return Z_OK;
}
exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

},{"6ecd050ab5cf9e92":"f0mDw","b17b4660c9a756a1":"fYqOF","8a0173ce93724f81":"a1YEz","9fe740ea87b93669":"cVtyI","86729d90d4373c72":"I61Sv"}],"f0mDw":[function(require,module,exports,__globalThis) {
'use strict';
var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function _has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if (_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function(on) {
    if (on) {
        exports.Buf8 = Uint8Array;
        exports.Buf16 = Uint16Array;
        exports.Buf32 = Int32Array;
        exports.assign(exports, fnTyped);
    } else {
        exports.Buf8 = Array;
        exports.Buf16 = Array;
        exports.Buf32 = Array;
        exports.assign(exports, fnUntyped);
    }
};
exports.setTyped(TYPED_OK);

},{}],"fYqOF":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ var utils = require("f7e73d4e313a2bb7");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var Z_BINARY = 0;
var Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN = 2;
/*============================================================================*/ function zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES = 2;
/* The three kinds of block type */ var MIN_MATCH = 3;
var MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var LITERALS = 256;
/* number of literal bytes 0..255 */ var L_CODES = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var D_CODES = 30;
/* number of distance codes */ var BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var HEAP_SIZE = 2 * L_CODES + 1;
/* maximum heap size */ var MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var END_BLOCK = 256;
/* end of block literal code */ var REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var static_dtree = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var _dist_code = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var base_length = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var base_dist = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var static_l_desc;
var static_d_desc;
var static_bl_desc;
function TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function d_code(dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function send_bits(s, value, length) {
    if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function send_code(s, c, tree) {
    send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function bi_flush(s) {
    if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array(MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < LENGTH_CODES - 1; code++){
        base_length[code] = length;
        for(n = 0; n < 1 << extra_lbits[code]; n++)_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ _length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        base_dist[code] = dist;
        for(n = 0; n < 1 << extra_dbits[code]; n++)_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < D_CODES; code++){
        base_dist[code] = dist << 7;
        for(n = 0; n < 1 << extra_dbits[code] - 7; n++)_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ gen_codes(static_ltree, L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < D_CODES; n++){
        static_dtree[n * 2 + 1] = 5;
        static_dtree[n * 2] = bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
    static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
    static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function bi_windup(s) {
    if (s.bi_valid > 8) put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    bi_windup(s); /* align on byte boundary */ 
    if (header) {
        put_short(s, len);
        put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if (smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = _length_code[lc];
            send_code(s, code + LITERALS + 1, ltree); /* send the length code */ 
            extra = extra_lbits[code];
            if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            send_code(s, code, dtree); /* send the distance code */ 
            extra = extra_dbits[code];
            if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    send_code(s, END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
        } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    send_bits(s, dcodes - 1, 5);
    send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
    for(n = 32; n < LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return Z_BINARY;
}
var static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function _tr_init(s) {
    if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
    }
    s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
    s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
    s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function _tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function _tr_align(s) {
    send_bits(s, STATIC_TREES << 1, 3);
    send_code(s, END_BLOCK, static_ltree);
    bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function _tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
        /* Construct the literal and distance trees */ build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ _tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
    } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ init_block(s);
    if (last) bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function _tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
exports._tr_init = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"f7e73d4e313a2bb7":"f0mDw"}],"a1YEz":[function(require,module,exports,__globalThis) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = adler32;

},{}],"cVtyI":[function(require,module,exports,__globalThis) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();
function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = crc32;

},{}],"I61Sv":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

},{}],"8KYHj":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("3693fcbb98dc8df0");
var adler32 = require("6ebe24dff7c86ec6");
var crc32 = require("733ae5de3dad536a");
var inflate_fast = require("d6c5d4935fa23026");
var inflate_table = require("f4fe87fcccdc3597");
var CODES = 0;
var LENS = 1;
var DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH = 4;
var Z_BLOCK = 5;
var Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var Z_OK = 0;
var Z_STREAM_END = 1;
var Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR = -2;
var Z_DATA_ERROR = -3;
var Z_MEM_ERROR = -4;
var Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var HEAD = 1; /* i: waiting for magic header */ 
var FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var TIME = 3; /* i: waiting for modification time (gzip) */ 
var OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var NAME = 7; /* i: waiting for end of file name (gzip) */ 
var COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var HCRC = 9; /* i: waiting for header crc (gzip) */ 
var DICTID = 10; /* i: waiting for dictionary check value */ 
var DICT = 11; /* waiting for inflateSetDictionary() call */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var STORED = 14; /* i: waiting for stored size (length and complement) */ 
var COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var LENLENS = 18; /* i: waiting for code length code lengths */ 
var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var LEN = 21; /* i: waiting for length/lit/eob code */ 
var LENEXT = 22; /* i: waiting for length extra bits */ 
var DIST = 23; /* i: waiting for distance code */ 
var DISTEXT = 24; /* i: waiting for distance extra bits */ 
var MATCH = 25; /* o: waiting for output space to copy string */ 
var LIT = 26; /* o: waiting for output space to write literal */ 
var CHECK = 27; /* i: waiting for 32-bit check value */ 
var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var DONE = 29; /* finished check, done -- remain here until reset */ 
var BAD = 30; /* got a data error -- remain here until reset */ 
var MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var MAX_WBITS = 15;
/* 32K LZ77 window */ var DEF_WBITS = MAX_WBITS;
function zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new utils.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new utils.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
    state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return Z_OK;
}
function inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return inflateResetKeep(strm);
}
function inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return inflateReset(strm);
}
function inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = inflateReset2(strm, windowBits);
    if (ret !== Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function inflateInit(strm) {
    return inflateInit2(strm, DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var virgin = true;
var lenfix, distfix; // We have no pointers in JS, so keep tables separate
function fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if (virgin) {
        var sym;
        lenfix = new utils.Buf32(512);
        distfix = new utils.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ virgin = false;
    }
    state.lencode = lenfix;
    state.lenbits = 9;
    state.distcode = distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new utils.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        utils.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === TYPE) state.mode = TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case HEAD:
            if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = BAD;
                break;
            }
            if ((hold & 0x0f) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? DICTID : TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = TIME;
        /* falls through */ case TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = OS;
        /* falls through */ case OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = EXLEN;
        /* falls through */ case EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = crc32(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = EXTRA;
        /* falls through */ case EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        utils.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = NAME;
        /* falls through */ case NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = COMMENT;
        /* falls through */ case COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = crc32(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = HCRC;
        /* falls through */ case HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = TYPE;
            break;
        case DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = DICT;
        /* falls through */ case DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = TYPE;
        /* falls through */ case TYPE:
            if (flush === Z_BLOCK || flush === Z_TREES) break inf_leave;
        /* falls through */ case TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = STORED;
                    break;
                case 1:
                    /* fixed block */ fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = LEN_; /* decode codes */ 
                    if (flush === Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = COPY_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case COPY_:
            state.mode = COPY;
        /* falls through */ case COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = TYPE;
            break;
        case TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = LENLENS;
        /* falls through */ case LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = CODELENS;
        /* falls through */ case CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = LEN_;
            if (flush === Z_TREES) break inf_leave;
        /* falls through */ case LEN_:
            state.mode = LEN;
        /* falls through */ case LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = LENEXT;
        /* falls through */ case LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = DIST;
        /* falls through */ case DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = DISTEXT;
        /* falls through */ case DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = MATCH;
        /* falls through */ case MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = LEN;
            break;
        case LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = LEN;
            break;
        case CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = LENGTH;
        /* falls through */ case LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = DONE;
        /* falls through */ case DONE:
            ret = Z_STREAM_END;
            break inf_leave;
        case BAD:
            ret = Z_DATA_ERROR;
            break inf_leave;
        case MEM:
            return Z_MEM_ERROR;
        case SYNC:
        /* falls through */ default:
            return Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) ret = Z_BUF_ERROR;
    return ret;
}
function inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return Z_OK;
}
function inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return Z_OK;
}
function inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== DICT) return Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = MEM;
        return Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return Z_OK;
}
exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

},{"3693fcbb98dc8df0":"f0mDw","6ebe24dff7c86ec6":"a1YEz","733ae5de3dad536a":"cVtyI","d6c5d4935fa23026":"cxSkw","f4fe87fcccdc3597":"aA8jE"}],"cxSkw":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var BAD = 30; /* got a data error -- remain here until reset */ 
var TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

},{}],"aA8jE":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var utils = require("11b3fa99ba8f3902");
var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var CODES = 0;
var LENS = 1;
var DISTS = 2;
var lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === LENS) {
        base = lbase;
        base_index -= 257;
        extra = lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = dbase;
        extra = dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

},{"11b3fa99ba8f3902":"f0mDw"}],"kl5PS":[function(require,module,exports,__globalThis) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

},{}],"kddcQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _restructure = require("restructure");
var _restructureDefault = parcelHelpers.interopDefault(_restructure);
var _utils = require("restructure/src/utils");
var _deepEqual = require("deep-equal");
var _deepEqualDefault = parcelHelpers.interopDefault(_deepEqual);
var _unicodeProperties = require("@react-pdf/unicode-properties");
var _unicodePropertiesDefault = parcelHelpers.interopDefault(_unicodeProperties);
var _unicodeTrie = require("unicode-trie");
var _unicodeTrieDefault = parcelHelpers.interopDefault(_unicodeTrie);
var _dfa = require("dfa");
var _dfaDefault = parcelHelpers.interopDefault(_dfa);
var _clone = require("clone");
var _cloneDefault = parcelHelpers.interopDefault(_clone);
var _tinyInflate = require("tiny-inflate");
var _tinyInflateDefault = parcelHelpers.interopDefault(_tinyInflate);
var Buffer = require("750871484726ec28").Buffer;
var process = require("ac20bad08ee389f");
var fs = {};
var fontkit$1 = {};
fontkit$1.logErrors = false;
var formats = [];
fontkit$1.registerFormat = function(format) {
    formats.push(format);
};
fontkit$1.openSync = function(filename, postscriptName) {
    var buffer;
    throw new Error('fontkit.openSync unavailable for browser build');
};
fontkit$1.open = function(filename, postscriptName, callback) {
    throw new Error('fontkit.open unavailable for browser build');
};
fontkit$1.create = function(buffer, postscriptName) {
    for(var i = 0; i < formats.length; i++){
        var format = formats[i];
        if (format.probe(buffer)) {
            var font = new format(new (0, _restructureDefault.default).DecodeStream(buffer));
            if (postscriptName) return font.getFont(postscriptName);
            return font;
        }
    }
    throw new Error('Unknown font format');
};
/**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */ function cache(target, key, descriptor) {
    if (descriptor.get) {
        var get = descriptor.get;
        descriptor.get = function() {
            var value = get.call(this);
            Object.defineProperty(this, key, {
                value: value
            });
            return value;
        };
    } else if (typeof descriptor.value === 'function') {
        var fn = descriptor.value;
        return {
            get: function get() {
                var cache = new Map();
                function memoized() {
                    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var key = args.length > 0 ? args[0] : 'value';
                    if (cache.has(key)) return cache.get(key);
                    var result = fn.apply(this, args);
                    cache.set(key, result);
                    return result;
                }
                Object.defineProperty(this, key, {
                    value: memoized
                });
                return memoized;
            }
        };
    }
}
var SubHeader = new (0, _restructureDefault.default).Struct({
    firstCode: (0, _restructureDefault.default).uint16,
    entryCount: (0, _restructureDefault.default).uint16,
    idDelta: (0, _restructureDefault.default).int16,
    idRangeOffset: (0, _restructureDefault.default).uint16
});
var CmapGroup = new (0, _restructureDefault.default).Struct({
    startCharCode: (0, _restructureDefault.default).uint32,
    endCharCode: (0, _restructureDefault.default).uint32,
    glyphID: (0, _restructureDefault.default).uint32
});
var UnicodeValueRange = new (0, _restructureDefault.default).Struct({
    startUnicodeValue: (0, _restructureDefault.default).uint24,
    additionalCount: (0, _restructureDefault.default).uint8
});
var UVSMapping = new (0, _restructureDefault.default).Struct({
    unicodeValue: (0, _restructureDefault.default).uint24,
    glyphID: (0, _restructureDefault.default).uint16
});
var DefaultUVS = new (0, _restructureDefault.default).Array(UnicodeValueRange, (0, _restructureDefault.default).uint32);
var NonDefaultUVS = new (0, _restructureDefault.default).Array(UVSMapping, (0, _restructureDefault.default).uint32);
var VarSelectorRecord = new (0, _restructureDefault.default).Struct({
    varSelector: (0, _restructureDefault.default).uint24,
    defaultUVS: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, DefaultUVS, {
        type: 'parent'
    }),
    nonDefaultUVS: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, NonDefaultUVS, {
        type: 'parent'
    })
});
var CmapSubtable = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    0: {
        length: (0, _restructureDefault.default).uint16,
        language: (0, _restructureDefault.default).uint16,
        codeMap: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint8, 256)
    },
    2: {
        length: (0, _restructureDefault.default).uint16,
        language: (0, _restructureDefault.default).uint16,
        subHeaderKeys: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 256),
        subHeaderCount: function subHeaderCount(t) {
            return Math.max.apply(Math, t.subHeaderKeys);
        },
        subHeaders: new (0, _restructureDefault.default).LazyArray(SubHeader, 'subHeaderCount'),
        glyphIndexArray: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, 'subHeaderCount')
    },
    4: {
        length: (0, _restructureDefault.default).uint16,
        language: (0, _restructureDefault.default).uint16,
        segCountX2: (0, _restructureDefault.default).uint16,
        segCount: function segCount(t) {
            return t.segCountX2 >> 1;
        },
        searchRange: (0, _restructureDefault.default).uint16,
        entrySelector: (0, _restructureDefault.default).uint16,
        rangeShift: (0, _restructureDefault.default).uint16,
        endCode: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, 'segCount'),
        reservedPad: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
        startCode: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, 'segCount'),
        idDelta: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).int16, 'segCount'),
        idRangeOffset: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, 'segCount'),
        glyphIndexArray: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, function(t) {
            return (t.length - t._currentOffset) / 2;
        })
    },
    6: {
        length: (0, _restructureDefault.default).uint16,
        language: (0, _restructureDefault.default).uint16,
        firstCode: (0, _restructureDefault.default).uint16,
        entryCount: (0, _restructureDefault.default).uint16,
        glyphIndices: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, 'entryCount')
    },
    8: {
        reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
        length: (0, _restructureDefault.default).uint32,
        language: (0, _restructureDefault.default).uint16,
        is32: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint8, 8192),
        nGroups: (0, _restructureDefault.default).uint32,
        groups: new (0, _restructureDefault.default).LazyArray(CmapGroup, 'nGroups')
    },
    10: {
        reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
        length: (0, _restructureDefault.default).uint32,
        language: (0, _restructureDefault.default).uint32,
        firstCode: (0, _restructureDefault.default).uint32,
        entryCount: (0, _restructureDefault.default).uint32,
        glyphIndices: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, 'numChars')
    },
    12: {
        reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
        length: (0, _restructureDefault.default).uint32,
        language: (0, _restructureDefault.default).uint32,
        nGroups: (0, _restructureDefault.default).uint32,
        groups: new (0, _restructureDefault.default).LazyArray(CmapGroup, 'nGroups')
    },
    13: {
        reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
        length: (0, _restructureDefault.default).uint32,
        language: (0, _restructureDefault.default).uint32,
        nGroups: (0, _restructureDefault.default).uint32,
        groups: new (0, _restructureDefault.default).LazyArray(CmapGroup, 'nGroups')
    },
    14: {
        length: (0, _restructureDefault.default).uint32,
        numRecords: (0, _restructureDefault.default).uint32,
        varSelectors: new (0, _restructureDefault.default).LazyArray(VarSelectorRecord, 'numRecords')
    }
});
var CmapEntry = new (0, _restructureDefault.default).Struct({
    platformID: (0, _restructureDefault.default).uint16,
    encodingID: (0, _restructureDefault.default).uint16,
    table: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, CmapSubtable, {
        type: 'parent',
        lazy: true
    })
});
// character to glyph mapping
var cmap = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    numSubtables: (0, _restructureDefault.default).uint16,
    tables: new (0, _restructureDefault.default).Array(CmapEntry, 'numSubtables')
});
// font header
var head = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).int32,
    revision: (0, _restructureDefault.default).int32,
    checkSumAdjustment: (0, _restructureDefault.default).uint32,
    magicNumber: (0, _restructureDefault.default).uint32,
    flags: (0, _restructureDefault.default).uint16,
    unitsPerEm: (0, _restructureDefault.default).uint16,
    created: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int32, 2),
    modified: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int32, 2),
    xMin: (0, _restructureDefault.default).int16,
    yMin: (0, _restructureDefault.default).int16,
    xMax: (0, _restructureDefault.default).int16,
    yMax: (0, _restructureDefault.default).int16,
    macStyle: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint16, [
        'bold',
        'italic',
        'underline',
        'outline',
        'shadow',
        'condensed',
        'extended'
    ]),
    lowestRecPPEM: (0, _restructureDefault.default).uint16,
    fontDirectionHint: (0, _restructureDefault.default).int16,
    indexToLocFormat: (0, _restructureDefault.default).int16,
    glyphDataFormat: (0, _restructureDefault.default).int16 // 0 for current format
});
// horizontal header
var hhea = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).int32,
    ascent: (0, _restructureDefault.default).int16,
    descent: (0, _restructureDefault.default).int16,
    lineGap: (0, _restructureDefault.default).int16,
    advanceWidthMax: (0, _restructureDefault.default).uint16,
    minLeftSideBearing: (0, _restructureDefault.default).int16,
    minRightSideBearing: (0, _restructureDefault.default).int16,
    xMaxExtent: (0, _restructureDefault.default).int16,
    caretSlopeRise: (0, _restructureDefault.default).int16,
    caretSlopeRun: (0, _restructureDefault.default).int16,
    caretOffset: (0, _restructureDefault.default).int16,
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).int16, 4),
    metricDataFormat: (0, _restructureDefault.default).int16,
    numberOfMetrics: (0, _restructureDefault.default).uint16 // Number of advance widths in 'hmtx' table
});
var HmtxEntry = new (0, _restructureDefault.default).Struct({
    advance: (0, _restructureDefault.default).uint16,
    bearing: (0, _restructureDefault.default).int16
});
var hmtx = new (0, _restructureDefault.default).Struct({
    metrics: new (0, _restructureDefault.default).LazyArray(HmtxEntry, function(t) {
        return t.parent.hhea.numberOfMetrics;
    }),
    bearings: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).int16, function(t) {
        return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
    })
});
// maxiumum profile
var maxp = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).int32,
    numGlyphs: (0, _restructureDefault.default).uint16,
    maxPoints: (0, _restructureDefault.default).uint16,
    maxContours: (0, _restructureDefault.default).uint16,
    maxComponentPoints: (0, _restructureDefault.default).uint16,
    maxComponentContours: (0, _restructureDefault.default).uint16,
    maxZones: (0, _restructureDefault.default).uint16,
    maxTwilightPoints: (0, _restructureDefault.default).uint16,
    maxStorage: (0, _restructureDefault.default).uint16,
    maxFunctionDefs: (0, _restructureDefault.default).uint16,
    maxInstructionDefs: (0, _restructureDefault.default).uint16,
    maxStackElements: (0, _restructureDefault.default).uint16,
    maxSizeOfInstructions: (0, _restructureDefault.default).uint16,
    maxComponentElements: (0, _restructureDefault.default).uint16,
    maxComponentDepth: (0, _restructureDefault.default).uint16 // Maximum levels of recursion; 1 for simple components
});
/**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */ function getEncoding(platformID, encodingID) {
    var languageID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) return MAC_LANGUAGE_ENCODINGS[languageID];
    return ENCODINGS[platformID][encodingID];
}
// Map of platform ids to encoding ids.
var ENCODINGS = [
    // unicode
    [
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be'
    ],
    // macintosh
    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
    // 0	Roman                 17	Malayalam
    // 1	Japanese	            18	Sinhalese
    // 2	Traditional Chinese	  19	Burmese
    // 3	Korean	              20	Khmer
    // 4	Arabic	              21	Thai
    // 5	Hebrew	              22	Laotian
    // 6	Greek	                23	Georgian
    // 7	Russian	              24	Armenian
    // 8	RSymbol	              25	Simplified Chinese
    // 9	Devanagari	          26	Tibetan
    // 10	Gurmukhi	            27	Mongolian
    // 11	Gujarati	            28	Geez
    // 12	Oriya	                29	Slavic
    // 13	Bengali	              30	Vietnamese
    // 14	Tamil	                31	Sindhi
    // 15	Telugu	              32	(Uninterpreted)
    // 16	Kannada
    [
        'macroman',
        'shift-jis',
        'big5',
        'euc-kr',
        'iso-8859-6',
        'iso-8859-8',
        'macgreek',
        'maccyrillic',
        'symbol',
        'Devanagari',
        'Gurmukhi',
        'Gujarati',
        'Oriya',
        'Bengali',
        'Tamil',
        'Telugu',
        'Kannada',
        'Malayalam',
        'Sinhalese',
        'Burmese',
        'Khmer',
        'macthai',
        'Laotian',
        'Georgian',
        'Armenian',
        'gb-2312-80',
        'Tibetan',
        'Mongolian',
        'Geez',
        'maccenteuro',
        'Vietnamese',
        'Sindhi'
    ],
    // ISO (deprecated)
    [
        'ascii'
    ],
    // windows
    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
    [
        'symbol',
        'utf16be',
        'shift-jis',
        'gb18030',
        'big5',
        'wansung',
        'johab',
        null,
        null,
        null,
        'utf16be'
    ]
];
// Overrides for Mac scripts by language id.
// See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var MAC_LANGUAGE_ENCODINGS = {
    15: 'maciceland',
    17: 'macturkish',
    18: 'maccroatian',
    24: 'maccenteuro',
    25: 'maccenteuro',
    26: 'maccenteuro',
    27: 'maccenteuro',
    28: 'maccenteuro',
    30: 'maciceland',
    37: 'macromania',
    38: 'maccenteuro',
    39: 'maccenteuro',
    40: 'maccenteuro',
    143: 'macinuit',
    146: 'macgaelic' // Unsupported by iconv-lite
};
// Map of platform ids to BCP-47 language codes.
var LANGUAGES = [
    // unicode
    [],
    {
        0: 'en',
        30: 'fo',
        60: 'ks',
        90: 'rw',
        1: 'fr',
        31: 'fa',
        61: 'ku',
        91: 'rn',
        2: 'de',
        32: 'ru',
        62: 'sd',
        92: 'ny',
        3: 'it',
        33: 'zh',
        63: 'bo',
        93: 'mg',
        4: 'nl',
        34: 'nl-BE',
        64: 'ne',
        94: 'eo',
        5: 'sv',
        35: 'ga',
        65: 'sa',
        128: 'cy',
        6: 'es',
        36: 'sq',
        66: 'mr',
        129: 'eu',
        7: 'da',
        37: 'ro',
        67: 'bn',
        130: 'ca',
        8: 'pt',
        38: 'cz',
        68: 'as',
        131: 'la',
        9: 'no',
        39: 'sk',
        69: 'gu',
        132: 'qu',
        10: 'he',
        40: 'si',
        70: 'pa',
        133: 'gn',
        11: 'ja',
        41: 'yi',
        71: 'or',
        134: 'ay',
        12: 'ar',
        42: 'sr',
        72: 'ml',
        135: 'tt',
        13: 'fi',
        43: 'mk',
        73: 'kn',
        136: 'ug',
        14: 'el',
        44: 'bg',
        74: 'ta',
        137: 'dz',
        15: 'is',
        45: 'uk',
        75: 'te',
        138: 'jv',
        16: 'mt',
        46: 'be',
        76: 'si',
        139: 'su',
        17: 'tr',
        47: 'uz',
        77: 'my',
        140: 'gl',
        18: 'hr',
        48: 'kk',
        78: 'km',
        141: 'af',
        19: 'zh-Hant',
        49: 'az-Cyrl',
        79: 'lo',
        142: 'br',
        20: 'ur',
        50: 'az-Arab',
        80: 'vi',
        143: 'iu',
        21: 'hi',
        51: 'hy',
        81: 'id',
        144: 'gd',
        22: 'th',
        52: 'ka',
        82: 'tl',
        145: 'gv',
        23: 'ko',
        53: 'mo',
        83: 'ms',
        146: 'ga',
        24: 'lt',
        54: 'ky',
        84: 'ms-Arab',
        147: 'to',
        25: 'pl',
        55: 'tg',
        85: 'am',
        148: 'el-polyton',
        26: 'hu',
        56: 'tk',
        86: 'ti',
        149: 'kl',
        27: 'es',
        57: 'mn-CN',
        87: 'om',
        150: 'az',
        28: 'lv',
        58: 'mn',
        88: 'so',
        151: 'nn',
        29: 'se',
        59: 'ps',
        89: 'sw'
    },
    // ISO (deprecated)
    [],
    {
        0x0436: 'af',
        0x4009: 'en-IN',
        0x0487: 'rw',
        0x0432: 'tn',
        0x041C: 'sq',
        0x1809: 'en-IE',
        0x0441: 'sw',
        0x045B: 'si',
        0x0484: 'gsw',
        0x2009: 'en-JM',
        0x0457: 'kok',
        0x041B: 'sk',
        0x045E: 'am',
        0x4409: 'en-MY',
        0x0412: 'ko',
        0x0424: 'sl',
        0x1401: 'ar-DZ',
        0x1409: 'en-NZ',
        0x0440: 'ky',
        0x2C0A: 'es-AR',
        0x3C01: 'ar-BH',
        0x3409: 'en-PH',
        0x0454: 'lo',
        0x400A: 'es-BO',
        0x0C01: 'ar',
        0x4809: 'en-SG',
        0x0426: 'lv',
        0x340A: 'es-CL',
        0x0801: 'ar-IQ',
        0x1C09: 'en-ZA',
        0x0427: 'lt',
        0x240A: 'es-CO',
        0x2C01: 'ar-JO',
        0x2C09: 'en-TT',
        0x082E: 'dsb',
        0x140A: 'es-CR',
        0x3401: 'ar-KW',
        0x0809: 'en-GB',
        0x046E: 'lb',
        0x1C0A: 'es-DO',
        0x3001: 'ar-LB',
        0x0409: 'en',
        0x042F: 'mk',
        0x300A: 'es-EC',
        0x1001: 'ar-LY',
        0x3009: 'en-ZW',
        0x083E: 'ms-BN',
        0x440A: 'es-SV',
        0x1801: 'ary',
        0x0425: 'et',
        0x043E: 'ms',
        0x100A: 'es-GT',
        0x2001: 'ar-OM',
        0x0438: 'fo',
        0x044C: 'ml',
        0x480A: 'es-HN',
        0x4001: 'ar-QA',
        0x0464: 'fil',
        0x043A: 'mt',
        0x080A: 'es-MX',
        0x0401: 'ar-SA',
        0x040B: 'fi',
        0x0481: 'mi',
        0x4C0A: 'es-NI',
        0x2801: 'ar-SY',
        0x080C: 'fr-BE',
        0x047A: 'arn',
        0x180A: 'es-PA',
        0x1C01: 'aeb',
        0x0C0C: 'fr-CA',
        0x044E: 'mr',
        0x3C0A: 'es-PY',
        0x3801: 'ar-AE',
        0x040C: 'fr',
        0x047C: 'moh',
        0x280A: 'es-PE',
        0x2401: 'ar-YE',
        0x140C: 'fr-LU',
        0x0450: 'mn',
        0x500A: 'es-PR',
        0x042B: 'hy',
        0x180C: 'fr-MC',
        0x0850: 'mn-CN',
        0x0C0A: 'es',
        0x044D: 'as',
        0x100C: 'fr-CH',
        0x0461: 'ne',
        0x040A: 'es',
        0x082C: 'az-Cyrl',
        0x0462: 'fy',
        0x0414: 'nb',
        0x540A: 'es-US',
        0x042C: 'az',
        0x0456: 'gl',
        0x0814: 'nn',
        0x380A: 'es-UY',
        0x046D: 'ba',
        0x0437: 'ka',
        0x0482: 'oc',
        0x200A: 'es-VE',
        0x042D: 'eu',
        0x0C07: 'de-AT',
        0x0448: 'or',
        0x081D: 'sv-FI',
        0x0423: 'be',
        0x0407: 'de',
        0x0463: 'ps',
        0x041D: 'sv',
        0x0845: 'bn',
        0x1407: 'de-LI',
        0x0415: 'pl',
        0x045A: 'syr',
        0x0445: 'bn-IN',
        0x1007: 'de-LU',
        0x0416: 'pt',
        0x0428: 'tg',
        0x201A: 'bs-Cyrl',
        0x0807: 'de-CH',
        0x0816: 'pt-PT',
        0x085F: 'tzm',
        0x141A: 'bs',
        0x0408: 'el',
        0x0446: 'pa',
        0x0449: 'ta',
        0x047E: 'br',
        0x046F: 'kl',
        0x046B: 'qu-BO',
        0x0444: 'tt',
        0x0402: 'bg',
        0x0447: 'gu',
        0x086B: 'qu-EC',
        0x044A: 'te',
        0x0403: 'ca',
        0x0468: 'ha',
        0x0C6B: 'qu',
        0x041E: 'th',
        0x0C04: 'zh-HK',
        0x040D: 'he',
        0x0418: 'ro',
        0x0451: 'bo',
        0x1404: 'zh-MO',
        0x0439: 'hi',
        0x0417: 'rm',
        0x041F: 'tr',
        0x0804: 'zh',
        0x040E: 'hu',
        0x0419: 'ru',
        0x0442: 'tk',
        0x1004: 'zh-SG',
        0x040F: 'is',
        0x243B: 'smn',
        0x0480: 'ug',
        0x0404: 'zh-TW',
        0x0470: 'ig',
        0x103B: 'smj-NO',
        0x0422: 'uk',
        0x0483: 'co',
        0x0421: 'id',
        0x143B: 'smj',
        0x042E: 'hsb',
        0x041A: 'hr',
        0x045D: 'iu',
        0x0C3B: 'se-FI',
        0x0420: 'ur',
        0x101A: 'hr-BA',
        0x085D: 'iu-Latn',
        0x043B: 'se',
        0x0843: 'uz-Cyrl',
        0x0405: 'cs',
        0x083C: 'ga',
        0x083B: 'se-SE',
        0x0443: 'uz',
        0x0406: 'da',
        0x0434: 'xh',
        0x203B: 'sms',
        0x042A: 'vi',
        0x048C: 'prs',
        0x0435: 'zu',
        0x183B: 'sma-NO',
        0x0452: 'cy',
        0x0465: 'dv',
        0x0410: 'it',
        0x1C3B: 'sms',
        0x0488: 'wo',
        0x0813: 'nl-BE',
        0x0810: 'it-CH',
        0x044F: 'sa',
        0x0485: 'sah',
        0x0413: 'nl',
        0x0411: 'ja',
        0x1C1A: 'sr-Cyrl-BA',
        0x0478: 'ii',
        0x0C09: 'en-AU',
        0x044B: 'kn',
        0x0C1A: 'sr',
        0x046A: 'yo',
        0x2809: 'en-BZ',
        0x043F: 'kk',
        0x181A: 'sr-Latn-BA',
        0x1009: 'en-CA',
        0x0453: 'km',
        0x081A: 'sr-Latn',
        0x2409: 'en-029',
        0x0486: 'quc',
        0x046C: 'nso'
    }
];
var NameRecord = new (0, _restructureDefault.default).Struct({
    platformID: (0, _restructureDefault.default).uint16,
    encodingID: (0, _restructureDefault.default).uint16,
    languageID: (0, _restructureDefault.default).uint16,
    nameID: (0, _restructureDefault.default).uint16,
    length: (0, _restructureDefault.default).uint16,
    string: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new (0, _restructureDefault.default).String('length', function(t) {
        return getEncoding(t.platformID, t.encodingID, t.languageID);
    }), {
        type: 'parent',
        relativeTo: 'parent.stringOffset',
        allowNull: false
    })
});
var LangTagRecord = new (0, _restructureDefault.default).Struct({
    length: (0, _restructureDefault.default).uint16,
    tag: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new (0, _restructureDefault.default).String('length', 'utf16be'), {
        type: 'parent',
        relativeTo: 'stringOffset'
    })
});
var NameTable = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    0: {
        count: (0, _restructureDefault.default).uint16,
        stringOffset: (0, _restructureDefault.default).uint16,
        records: new (0, _restructureDefault.default).Array(NameRecord, 'count')
    },
    1: {
        count: (0, _restructureDefault.default).uint16,
        stringOffset: (0, _restructureDefault.default).uint16,
        records: new (0, _restructureDefault.default).Array(NameRecord, 'count'),
        langTagCount: (0, _restructureDefault.default).uint16,
        langTags: new (0, _restructureDefault.default).Array(LangTagRecord, 'langTagCount')
    }
});
var NAMES = [
    'copyright',
    'fontFamily',
    'fontSubfamily',
    'uniqueSubfamily',
    'fullName',
    'version',
    'postscriptName',
    'trademark',
    'manufacturer',
    'designer',
    'description',
    'vendorURL',
    'designerURL',
    'license',
    'licenseURL',
    null,
    'preferredFamily',
    'preferredSubfamily',
    'compatibleFull',
    'sampleText',
    'postscriptCIDFontName',
    'wwsFamilyName',
    'wwsSubfamilyName'
];
NameTable.process = function(stream) {
    var records = {};
    for(var _iterator = this.records, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var record = _ref;
        // find out what language this is for
        var language = LANGUAGES[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
        if (language == null) language = record.platformID + '-' + record.languageID;
        // if the nameID is >= 256, it is a font feature record (AAT)
        var key = record.nameID >= 256 ? 'fontFeatures' : NAMES[record.nameID] || record.nameID;
        if (records[key] == null) records[key] = {};
        var obj = records[key];
        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
        if (typeof record.string === 'string' || typeof obj[language] !== 'string') obj[language] = record.string;
    }
    this.records = records;
};
NameTable.preEncode = function() {
    if (Array.isArray(this.records)) return;
    this.version = 0;
    var records = [];
    for(var key in this.records){
        var val = this.records[key];
        if (key === 'fontFeatures') continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 0x409,
            nameID: NAMES.indexOf(key),
            length: Buffer.byteLength(val.en, 'utf16le'),
            string: val.en
        });
        if (key === 'postscriptName') records.push({
            platformID: 1,
            encodingID: 0,
            languageID: 0,
            nameID: NAMES.indexOf(key),
            length: val.en.length,
            string: val.en
        });
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = NameTable.size(this, null, false);
};
var OS2 = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    header: {
        xAvgCharWidth: (0, _restructureDefault.default).int16,
        usWeightClass: (0, _restructureDefault.default).uint16,
        usWidthClass: (0, _restructureDefault.default).uint16,
        fsType: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint16, [
            null,
            'noEmbedding',
            'viewOnly',
            'editable',
            null,
            null,
            null,
            null,
            'noSubsetting',
            'bitmapOnly'
        ]),
        ySubscriptXSize: (0, _restructureDefault.default).int16,
        ySubscriptYSize: (0, _restructureDefault.default).int16,
        ySubscriptXOffset: (0, _restructureDefault.default).int16,
        ySubscriptYOffset: (0, _restructureDefault.default).int16,
        ySuperscriptXSize: (0, _restructureDefault.default).int16,
        ySuperscriptYSize: (0, _restructureDefault.default).int16,
        ySuperscriptXOffset: (0, _restructureDefault.default).int16,
        ySuperscriptYOffset: (0, _restructureDefault.default).int16,
        yStrikeoutSize: (0, _restructureDefault.default).int16,
        yStrikeoutPosition: (0, _restructureDefault.default).int16,
        sFamilyClass: (0, _restructureDefault.default).int16,
        panose: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, 10),
        ulCharRange: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, 4),
        vendorID: new (0, _restructureDefault.default).String(4),
        fsSelection: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint16, [
            'italic',
            'underscore',
            'negative',
            'outlined',
            'strikeout',
            'bold',
            'regular',
            'useTypoMetrics',
            'wws',
            'oblique'
        ]),
        usFirstCharIndex: (0, _restructureDefault.default).uint16,
        usLastCharIndex: (0, _restructureDefault.default).uint16 // The maximum Unicode index in this font
    },
    // The Apple version of this table ends here, but the Microsoft one continues on...
    0: {},
    1: {
        typoAscender: (0, _restructureDefault.default).int16,
        typoDescender: (0, _restructureDefault.default).int16,
        typoLineGap: (0, _restructureDefault.default).int16,
        winAscent: (0, _restructureDefault.default).uint16,
        winDescent: (0, _restructureDefault.default).uint16,
        codePageRange: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, 2)
    },
    2: {
        // these should be common with version 1 somehow
        typoAscender: (0, _restructureDefault.default).int16,
        typoDescender: (0, _restructureDefault.default).int16,
        typoLineGap: (0, _restructureDefault.default).int16,
        winAscent: (0, _restructureDefault.default).uint16,
        winDescent: (0, _restructureDefault.default).uint16,
        codePageRange: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, 2),
        xHeight: (0, _restructureDefault.default).int16,
        capHeight: (0, _restructureDefault.default).int16,
        defaultChar: (0, _restructureDefault.default).uint16,
        breakChar: (0, _restructureDefault.default).uint16,
        maxContent: (0, _restructureDefault.default).uint16
    },
    5: {
        typoAscender: (0, _restructureDefault.default).int16,
        typoDescender: (0, _restructureDefault.default).int16,
        typoLineGap: (0, _restructureDefault.default).int16,
        winAscent: (0, _restructureDefault.default).uint16,
        winDescent: (0, _restructureDefault.default).uint16,
        codePageRange: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, 2),
        xHeight: (0, _restructureDefault.default).int16,
        capHeight: (0, _restructureDefault.default).int16,
        defaultChar: (0, _restructureDefault.default).uint16,
        breakChar: (0, _restructureDefault.default).uint16,
        maxContent: (0, _restructureDefault.default).uint16,
        usLowerOpticalPointSize: (0, _restructureDefault.default).uint16,
        usUpperOpticalPointSize: (0, _restructureDefault.default).uint16
    }
});
var versions = OS2.versions;
versions[3] = versions[4] = versions[2];
// PostScript information
var post = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).fixed32, {
    header: {
        italicAngle: (0, _restructureDefault.default).fixed32,
        underlinePosition: (0, _restructureDefault.default).int16,
        underlineThickness: (0, _restructureDefault.default).int16,
        isFixedPitch: (0, _restructureDefault.default).uint32,
        minMemType42: (0, _restructureDefault.default).uint32,
        maxMemType42: (0, _restructureDefault.default).uint32,
        minMemType1: (0, _restructureDefault.default).uint32,
        maxMemType1: (0, _restructureDefault.default).uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
    },
    1: {},
    2: {
        numberOfGlyphs: (0, _restructureDefault.default).uint16,
        glyphNameIndex: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'numberOfGlyphs'),
        names: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).String((0, _restructureDefault.default).uint8))
    },
    2.5: {
        numberOfGlyphs: (0, _restructureDefault.default).uint16,
        offsets: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, 'numberOfGlyphs')
    },
    3: {},
    4: {
        map: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, function(t) {
            return t.parent.maxp.numGlyphs;
        })
    }
});
// An array of predefined values accessible by instructions
var cvt = new (0, _restructureDefault.default).Struct({
    controlValues: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int16)
});
// A list of instructions that are executed once when a font is first used.
// These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
var fpgm = new (0, _restructureDefault.default).Struct({
    instructions: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8)
});
var loca = new (0, _restructureDefault.default).VersionedStruct('head.indexToLocFormat', {
    0: {
        offsets: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16)
    },
    1: {
        offsets: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32)
    }
});
loca.process = function() {
    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
};
loca.preEncode = function() {
    if (this.version != null) return;
    // assume this.offsets is a sorted array
    this.version = this.offsets[this.offsets.length - 1] > 0xffff ? 1 : 0;
    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
};
// Set of instructions executed whenever the point size or font transformation change
var prep = new (0, _restructureDefault.default).Struct({
    controlValueProgram: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8)
});
// only used for encoding
var glyf = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Buffer());
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var CFFIndex = function() {
    function CFFIndex(type) {
        classCallCheck(this, CFFIndex);
        this.type = type;
    }
    CFFIndex.prototype.getCFFVersion = function getCFFVersion(ctx) {
        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
        return ctx ? ctx.version : -1;
    };
    CFFIndex.prototype.decode = function decode(stream, parent) {
        var version = this.getCFFVersion(parent);
        var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
        if (count === 0) return [];
        var offSize = stream.readUInt8();
        var offsetType = void 0;
        if (offSize === 1) offsetType = (0, _restructureDefault.default).uint8;
        else if (offSize === 2) offsetType = (0, _restructureDefault.default).uint16;
        else if (offSize === 3) offsetType = (0, _restructureDefault.default).uint24;
        else if (offSize === 4) offsetType = (0, _restructureDefault.default).uint32;
        else throw new Error("Bad offset size in CFFIndex: " + offSize + " " + stream.pos);
        var ret = [];
        var startPos = stream.pos + (count + 1) * offSize - 1;
        var start = offsetType.decode(stream);
        for(var i = 0; i < count; i++){
            var end = offsetType.decode(stream);
            if (this.type != null) {
                var pos = stream.pos;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
            } else ret.push({
                offset: startPos + start,
                length: end - start
            });
            start = end;
        }
        stream.pos = startPos + start;
        return ret;
    };
    CFFIndex.prototype.size = function size(arr, parent) {
        var size = 2;
        if (arr.length === 0) return size;
        var type = this.type || new (0, _restructureDefault.default).Buffer();
        // find maximum offset to detminine offset type
        var offset = 1;
        for(var i = 0; i < arr.length; i++){
            var item = arr[i];
            offset += type.size(item, parent);
        }
        var offsetType = void 0;
        if (offset <= 0xff) offsetType = (0, _restructureDefault.default).uint8;
        else if (offset <= 0xffff) offsetType = (0, _restructureDefault.default).uint16;
        else if (offset <= 0xffffff) offsetType = (0, _restructureDefault.default).uint24;
        else if (offset <= 0xffffffff) offsetType = (0, _restructureDefault.default).uint32;
        else throw new Error("Bad offset in CFFIndex");
        size += 1 + offsetType.size() * (arr.length + 1);
        size += offset - 1;
        return size;
    };
    CFFIndex.prototype.encode = function encode(stream, arr, parent) {
        stream.writeUInt16BE(arr.length);
        if (arr.length === 0) return;
        var type = this.type || new (0, _restructureDefault.default).Buffer();
        // find maximum offset to detminine offset type
        var sizes = [];
        var offset = 1;
        for(var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var item = _ref;
            var s = type.size(item, parent);
            sizes.push(s);
            offset += s;
        }
        var offsetType = void 0;
        if (offset <= 0xff) offsetType = (0, _restructureDefault.default).uint8;
        else if (offset <= 0xffff) offsetType = (0, _restructureDefault.default).uint16;
        else if (offset <= 0xffffff) offsetType = (0, _restructureDefault.default).uint24;
        else if (offset <= 0xffffffff) offsetType = (0, _restructureDefault.default).uint32;
        else throw new Error("Bad offset in CFFIndex");
        // write offset size
        stream.writeUInt8(offsetType.size());
        // write elements
        offset = 1;
        offsetType.encode(stream, offset);
        for(var _iterator2 = sizes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var size = _ref2;
            offset += size;
            offsetType.encode(stream, offset);
        }
        for(var _iterator3 = arr, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
            var _ref3;
            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }
            var _item = _ref3;
            type.encode(stream, _item, parent);
        }
        return;
    };
    return CFFIndex;
}();
var FLOAT_EOF = 0xf;
var FLOAT_LOOKUP = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    'E',
    'E-',
    null,
    '-'
];
var FLOAT_ENCODE_LOOKUP = {
    '.': 10,
    'E': 11,
    'E-': 12,
    '-': 14
};
var CFFOperand = function() {
    function CFFOperand() {
        classCallCheck(this, CFFOperand);
    }
    CFFOperand.decode = function decode(stream, value) {
        if (32 <= value && value <= 246) return value - 139;
        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
        if (value === 28) return stream.readInt16BE();
        if (value === 29) return stream.readInt32BE();
        if (value === 30) {
            var str = '';
            while(true){
                var b = stream.readUInt8();
                var n1 = b >> 4;
                if (n1 === FLOAT_EOF) break;
                str += FLOAT_LOOKUP[n1];
                var n2 = b & 15;
                if (n2 === FLOAT_EOF) break;
                str += FLOAT_LOOKUP[n2];
            }
            return parseFloat(str);
        }
        return null;
    };
    CFFOperand.size = function size(value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, set to 32768
        if (value.forceLarge) value = 32768;
        if ((value | 0) !== value) {
            // floating point
            var str = '' + value;
            return 1 + Math.ceil((str.length + 1) / 2);
        } else if (-107 <= value && value <= 107) return 1;
        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
        else if (-32768 <= value && value <= 32767) return 3;
        else return 5;
    };
    CFFOperand.encode = function encode(stream, value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, save the old value and set to 32768
        var val = Number(value);
        if (value.forceLarge) {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        } else if ((val | 0) !== val) {
            // floating point
            stream.writeUInt8(30);
            var str = '' + val;
            for(var i = 0; i < str.length; i += 2){
                var c1 = str[i];
                var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;
                if (i === str.length - 1) var n2 = FLOAT_EOF;
                else {
                    var c2 = str[i + 1];
                    var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }
                stream.writeUInt8(n1 << 4 | n2 & 15);
            }
            if (n2 !== FLOAT_EOF) return stream.writeUInt8(FLOAT_EOF << 4);
        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
        else if (108 <= val && val <= 1131) {
            val -= 108;
            stream.writeUInt8((val >> 8) + 247);
            return stream.writeUInt8(val & 0xff);
        } else if (-1131 <= val && val <= -108) {
            val = -val - 108;
            stream.writeUInt8((val >> 8) + 251);
            return stream.writeUInt8(val & 0xff);
        } else if (-32768 <= val && val <= 32767) {
            stream.writeUInt8(28);
            return stream.writeInt16BE(val);
        } else {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        }
    };
    return CFFOperand;
}();
var CFFDict = function() {
    function CFFDict() {
        var ops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        classCallCheck(this, CFFDict);
        this.ops = ops;
        this.fields = {};
        for(var _iterator = ops, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var field = _ref;
            var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
            this.fields[key] = field;
        }
    }
    CFFDict.prototype.decodeOperands = function decodeOperands(type, stream, ret, operands) {
        var _this = this;
        if (Array.isArray(type)) return operands.map(function(op, i) {
            return _this.decodeOperands(type[i], stream, ret, [
                op
            ]);
        });
        else if (type.decode != null) return type.decode(stream, ret, operands);
        else switch(type){
            case 'number':
            case 'offset':
            case 'sid':
                return operands[0];
            case 'boolean':
                return !!operands[0];
            default:
                return operands;
        }
    };
    CFFDict.prototype.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
        var _this2 = this;
        if (Array.isArray(type)) return operands.map(function(op, i) {
            return _this2.encodeOperands(type[i], stream, ctx, op)[0];
        });
        else if (type.encode != null) return type.encode(stream, operands, ctx);
        else if (typeof operands === 'number') return [
            operands
        ];
        else if (typeof operands === 'boolean') return [
            +operands
        ];
        else if (Array.isArray(operands)) return operands;
        else return [
            operands
        ];
    };
    CFFDict.prototype.decode = function decode(stream, parent) {
        var end = stream.pos + parent.length;
        var ret = {};
        var operands = [];
        // define hidden properties
        Object.defineProperties(ret, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            }
        });
        // fill in defaults
        for(var key in this.fields){
            var field = this.fields[key];
            ret[field[1]] = field[3];
        }
        while(stream.pos < end){
            var b = stream.readUInt8();
            if (b < 28) {
                if (b === 12) b = b << 8 | stream.readUInt8();
                var _field = this.fields[b];
                if (!_field) throw new Error('Unknown operator ' + b);
                var val = this.decodeOperands(_field[2], stream, ret, operands);
                if (val != null) {
                    if (val instanceof (0, _utils.PropertyDescriptor)) Object.defineProperty(ret, _field[1], val);
                    else ret[_field[1]] = val;
                }
                operands = [];
            } else operands.push(CFFOperand.decode(stream, b));
        }
        return ret;
    };
    CFFDict.prototype.size = function size(dict, parent) {
        var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var ctx = {
            parent: parent,
            val: dict,
            pointerSize: 0,
            startOffset: parent.startOffset || 0
        };
        var len = 0;
        for(var k in this.fields){
            var field = this.fields[k];
            var val = dict[field[1]];
            if (val == null || (0, _deepEqualDefault.default)(val, field[3])) continue;
            var operands = this.encodeOperands(field[2], null, ctx, val);
            for(var _iterator2 = operands, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref2 = _i2.value;
                }
                var op = _ref2;
                len += CFFOperand.size(op);
            }
            var key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            len += key.length;
        }
        if (includePointers) len += ctx.pointerSize;
        return len;
    };
    CFFDict.prototype.encode = function encode(stream, dict, parent) {
        var ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: dict,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
        for(var _iterator3 = this.ops, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
            var _ref3;
            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }
            var field = _ref3;
            var val = dict[field[1]];
            if (val == null || (0, _deepEqualDefault.default)(val, field[3])) continue;
            var operands = this.encodeOperands(field[2], stream, ctx, val);
            for(var _iterator4 = operands, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;){
                var _ref4;
                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref4 = _i4.value;
                }
                var op = _ref4;
                CFFOperand.encode(stream, op);
            }
            var key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            for(var _iterator5 = key, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;){
                var _ref5;
                if (_isArray5) {
                    if (_i5 >= _iterator5.length) break;
                    _ref5 = _iterator5[_i5++];
                } else {
                    _i5 = _iterator5.next();
                    if (_i5.done) break;
                    _ref5 = _i5.value;
                }
                var _op = _ref5;
                stream.writeUInt8(_op);
            }
        }
        var i = 0;
        while(i < ctx.pointers.length){
            var ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
        return;
    };
    return CFFDict;
}();
var CFFPointer = function(_r$Pointer) {
    inherits(CFFPointer, _r$Pointer);
    function CFFPointer(type) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        classCallCheck(this, CFFPointer);
        if (options.type == null) options.type = 'global';
        return possibleConstructorReturn(this, _r$Pointer.call(this, null, type, options));
    }
    CFFPointer.prototype.decode = function decode(stream, parent, operands) {
        this.offsetType = {
            decode: function decode() {
                return operands[0];
            }
        };
        return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
    };
    CFFPointer.prototype.encode = function encode(stream, value, ctx) {
        if (!stream) {
            // compute the size (so ctx.pointerSize is correct)
            this.offsetType = {
                size: function size() {
                    return 0;
                }
            };
            this.size(value, ctx);
            return [
                new Ptr(0)
            ];
        }
        var ptr = null;
        this.offsetType = {
            encode: function encode(stream, val) {
                return ptr = val;
            }
        };
        _r$Pointer.prototype.encode.call(this, stream, value, ctx);
        return [
            new Ptr(ptr)
        ];
    };
    return CFFPointer;
}((0, _restructureDefault.default).Pointer);
var Ptr = function() {
    function Ptr(val) {
        classCallCheck(this, Ptr);
        this.val = val;
        this.forceLarge = true;
    }
    Ptr.prototype.valueOf = function valueOf() {
        return this.val;
    };
    return Ptr;
}();
var CFFBlendOp = function() {
    function CFFBlendOp() {
        classCallCheck(this, CFFBlendOp);
    }
    CFFBlendOp.decode = function decode(stream, parent, operands) {
        var numBlends = operands.pop();
        // TODO: actually blend. For now just consume the deltas
        // since we don't use any of the values anyway.
        while(operands.length > numBlends)operands.pop();
    };
    return CFFBlendOp;
}();
var CFFPrivateDict = new CFFDict([
    // key       name                    type                                          default
    [
        6,
        'BlueValues',
        'delta',
        null
    ],
    [
        7,
        'OtherBlues',
        'delta',
        null
    ],
    [
        8,
        'FamilyBlues',
        'delta',
        null
    ],
    [
        9,
        'FamilyOtherBlues',
        'delta',
        null
    ],
    [
        [
            12,
            9
        ],
        'BlueScale',
        'number',
        0.039625
    ],
    [
        [
            12,
            10
        ],
        'BlueShift',
        'number',
        7
    ],
    [
        [
            12,
            11
        ],
        'BlueFuzz',
        'number',
        1
    ],
    [
        10,
        'StdHW',
        'number',
        null
    ],
    [
        11,
        'StdVW',
        'number',
        null
    ],
    [
        [
            12,
            12
        ],
        'StemSnapH',
        'delta',
        null
    ],
    [
        [
            12,
            13
        ],
        'StemSnapV',
        'delta',
        null
    ],
    [
        [
            12,
            14
        ],
        'ForceBold',
        'boolean',
        false
    ],
    [
        [
            12,
            17
        ],
        'LanguageGroup',
        'number',
        0
    ],
    [
        [
            12,
            18
        ],
        'ExpansionFactor',
        'number',
        0.06
    ],
    [
        [
            12,
            19
        ],
        'initialRandomSeed',
        'number',
        0
    ],
    [
        20,
        'defaultWidthX',
        'number',
        0
    ],
    [
        21,
        'nominalWidthX',
        'number',
        0
    ],
    [
        22,
        'vsindex',
        'number',
        0
    ],
    [
        23,
        'blend',
        CFFBlendOp,
        null
    ],
    [
        19,
        'Subrs',
        new CFFPointer(new CFFIndex(), {
            type: 'local'
        }),
        null
    ]
]);
// Automatically generated from Appendix A of the CFF specification; do
// not edit. Length should be 391.
var standardStrings = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall",
    "001.000",
    "001.001",
    "001.002",
    "001.003",
    "Black",
    "Bold",
    "Book",
    "Light",
    "Medium",
    "Regular",
    "Roman",
    "Semibold"
];
var StandardEncoding = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    '',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    '',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    '',
    'questiondown',
    '',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    '',
    'ring',
    'cedilla',
    '',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'AE',
    '',
    'ordfeminine',
    '',
    '',
    '',
    '',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    '',
    '',
    '',
    '',
    '',
    'ae',
    '',
    '',
    '',
    'dotlessi',
    '',
    '',
    'lslash',
    'oslash',
    'oe',
    'germandbls'
];
var ExpertEncoding = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    '',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    '',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    '',
    '',
    'isuperior',
    '',
    '',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    '',
    '',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    '',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    '',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    '',
    '',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    '',
    'Dotaccentsmall',
    '',
    '',
    'Macronsmall',
    '',
    '',
    'figuredash',
    'hypheninferior',
    '',
    '',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    '',
    '',
    '',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    '',
    '',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
var ISOAdobeCharset = [
    '.notdef',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    'questiondown',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    'AE',
    'ordfeminine',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    'ae',
    'dotlessi',
    'lslash',
    'oslash',
    'oe',
    'germandbls',
    'onesuperior',
    'logicalnot',
    'mu',
    'trademark',
    'Eth',
    'onehalf',
    'plusminus',
    'Thorn',
    'onequarter',
    'divide',
    'brokenbar',
    'degree',
    'thorn',
    'threequarters',
    'twosuperior',
    'registered',
    'minus',
    'eth',
    'multiply',
    'threesuperior',
    'copyright',
    'Aacute',
    'Acircumflex',
    'Adieresis',
    'Agrave',
    'Aring',
    'Atilde',
    'Ccedilla',
    'Eacute',
    'Ecircumflex',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Ntilde',
    'Oacute',
    'Ocircumflex',
    'Odieresis',
    'Ograve',
    'Otilde',
    'Scaron',
    'Uacute',
    'Ucircumflex',
    'Udieresis',
    'Ugrave',
    'Yacute',
    'Ydieresis',
    'Zcaron',
    'aacute',
    'acircumflex',
    'adieresis',
    'agrave',
    'aring',
    'atilde',
    'ccedilla',
    'eacute',
    'ecircumflex',
    'edieresis',
    'egrave',
    'iacute',
    'icircumflex',
    'idieresis',
    'igrave',
    'ntilde',
    'oacute',
    'ocircumflex',
    'odieresis',
    'ograve',
    'otilde',
    'scaron',
    'uacute',
    'ucircumflex',
    'udieresis',
    'ugrave',
    'yacute',
    'ydieresis',
    'zcaron'
];
var ExpertCharset = [
    '.notdef',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    'Dotaccentsmall',
    'Macronsmall',
    'figuredash',
    'hypheninferior',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
var ExpertSubsetCharset = [
    '.notdef',
    'space',
    'dollaroldstyle',
    'dollarsuperior',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'hyphensuperior',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'centoldstyle',
    'figuredash',
    'hypheninferior',
    'onequarter',
    'onehalf',
    'threequarters',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior'
];
//########################
// Scripts and Languages #
//########################
var LangSysTable = new (0, _restructureDefault.default).Struct({
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
    reqFeatureIndex: (0, _restructureDefault.default).uint16,
    featureCount: (0, _restructureDefault.default).uint16,
    featureIndexes: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'featureCount')
});
var LangSysRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    langSys: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, LangSysTable, {
        type: 'parent'
    })
});
var Script = new (0, _restructureDefault.default).Struct({
    defaultLangSys: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, LangSysTable),
    count: (0, _restructureDefault.default).uint16,
    langSysRecords: new (0, _restructureDefault.default).Array(LangSysRecord, 'count')
});
var ScriptRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    script: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Script, {
        type: 'parent'
    })
});
var ScriptList = new (0, _restructureDefault.default).Array(ScriptRecord, (0, _restructureDefault.default).uint16);
//#######################
// Features and Lookups #
//#######################
var Feature = new (0, _restructureDefault.default).Struct({
    featureParams: (0, _restructureDefault.default).uint16,
    lookupCount: (0, _restructureDefault.default).uint16,
    lookupListIndexes: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'lookupCount')
});
var FeatureRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    feature: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Feature, {
        type: 'parent'
    })
});
var FeatureList = new (0, _restructureDefault.default).Array(FeatureRecord, (0, _restructureDefault.default).uint16);
var LookupFlags = new (0, _restructureDefault.default).Struct({
    markAttachmentType: (0, _restructureDefault.default).uint8,
    flags: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint8, [
        'rightToLeft',
        'ignoreBaseGlyphs',
        'ignoreLigatures',
        'ignoreMarks',
        'useMarkFilteringSet'
    ])
});
function LookupList(SubTable) {
    var Lookup = new (0, _restructureDefault.default).Struct({
        lookupType: (0, _restructureDefault.default).uint16,
        flags: LookupFlags,
        subTableCount: (0, _restructureDefault.default).uint16,
        subTables: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, SubTable), 'subTableCount'),
        markFilteringSet: new (0, _restructureDefault.default).Optional((0, _restructureDefault.default).uint16, function(t) {
            return t.flags.flags.useMarkFilteringSet;
        })
    });
    return new (0, _restructureDefault.default).LazyArray(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Lookup), (0, _restructureDefault.default).uint16);
}
//#################
// Coverage Table #
//#################
var RangeRecord = new (0, _restructureDefault.default).Struct({
    start: (0, _restructureDefault.default).uint16,
    end: (0, _restructureDefault.default).uint16,
    startCoverageIndex: (0, _restructureDefault.default).uint16
});
var Coverage = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: {
        glyphCount: (0, _restructureDefault.default).uint16,
        glyphs: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'glyphCount')
    },
    2: {
        rangeCount: (0, _restructureDefault.default).uint16,
        rangeRecords: new (0, _restructureDefault.default).Array(RangeRecord, 'rangeCount')
    }
});
//#########################
// Class Definition Table #
//#########################
var ClassRangeRecord = new (0, _restructureDefault.default).Struct({
    start: (0, _restructureDefault.default).uint16,
    end: (0, _restructureDefault.default).uint16,
    class: (0, _restructureDefault.default).uint16
});
var ClassDef = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: {
        startGlyph: (0, _restructureDefault.default).uint16,
        glyphCount: (0, _restructureDefault.default).uint16,
        classValueArray: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'glyphCount')
    },
    2: {
        classRangeCount: (0, _restructureDefault.default).uint16,
        classRangeRecord: new (0, _restructureDefault.default).Array(ClassRangeRecord, 'classRangeCount')
    }
});
//###############
// Device Table #
//###############
var Device = new (0, _restructureDefault.default).Struct({
    a: (0, _restructureDefault.default).uint16,
    b: (0, _restructureDefault.default).uint16,
    deltaFormat: (0, _restructureDefault.default).uint16
});
//#############################################
// Contextual Substitution/Positioning Tables #
//#############################################
var LookupRecord = new (0, _restructureDefault.default).Struct({
    sequenceIndex: (0, _restructureDefault.default).uint16,
    lookupListIndex: (0, _restructureDefault.default).uint16
});
var Rule = new (0, _restructureDefault.default).Struct({
    glyphCount: (0, _restructureDefault.default).uint16,
    lookupCount: (0, _restructureDefault.default).uint16,
    input: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, function(t) {
        return t.glyphCount - 1;
    }),
    lookupRecords: new (0, _restructureDefault.default).Array(LookupRecord, 'lookupCount')
});
var RuleSet = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Rule), (0, _restructureDefault.default).uint16);
var ClassRule = new (0, _restructureDefault.default).Struct({
    glyphCount: (0, _restructureDefault.default).uint16,
    lookupCount: (0, _restructureDefault.default).uint16,
    classes: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, function(t) {
        return t.glyphCount - 1;
    }),
    lookupRecords: new (0, _restructureDefault.default).Array(LookupRecord, 'lookupCount')
});
var ClassSet = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassRule), (0, _restructureDefault.default).uint16);
var Context = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: {
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        ruleSetCount: (0, _restructureDefault.default).uint16,
        ruleSets: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, RuleSet), 'ruleSetCount')
    },
    2: {
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        classDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef),
        classSetCnt: (0, _restructureDefault.default).uint16,
        classSet: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassSet), 'classSetCnt')
    },
    3: {
        glyphCount: (0, _restructureDefault.default).uint16,
        lookupCount: (0, _restructureDefault.default).uint16,
        coverages: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage), 'glyphCount'),
        lookupRecords: new (0, _restructureDefault.default).Array(LookupRecord, 'lookupCount')
    }
});
//######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################
var ChainRule = new (0, _restructureDefault.default).Struct({
    backtrackGlyphCount: (0, _restructureDefault.default).uint16,
    backtrack: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'backtrackGlyphCount'),
    inputGlyphCount: (0, _restructureDefault.default).uint16,
    input: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, function(t) {
        return t.inputGlyphCount - 1;
    }),
    lookaheadGlyphCount: (0, _restructureDefault.default).uint16,
    lookahead: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'lookaheadGlyphCount'),
    lookupCount: (0, _restructureDefault.default).uint16,
    lookupRecords: new (0, _restructureDefault.default).Array(LookupRecord, 'lookupCount')
});
var ChainRuleSet = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ChainRule), (0, _restructureDefault.default).uint16);
var ChainingContext = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: {
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        chainCount: (0, _restructureDefault.default).uint16,
        chainRuleSets: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ChainRuleSet), 'chainCount')
    },
    2: {
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        backtrackClassDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef),
        inputClassDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef),
        lookaheadClassDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef),
        chainCount: (0, _restructureDefault.default).uint16,
        chainClassSet: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ChainRuleSet), 'chainCount')
    },
    3: {
        backtrackGlyphCount: (0, _restructureDefault.default).uint16,
        backtrackCoverage: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage), 'backtrackGlyphCount'),
        inputGlyphCount: (0, _restructureDefault.default).uint16,
        inputCoverage: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage), 'inputGlyphCount'),
        lookaheadGlyphCount: (0, _restructureDefault.default).uint16,
        lookaheadCoverage: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage), 'lookaheadGlyphCount'),
        lookupCount: (0, _restructureDefault.default).uint16,
        lookupRecords: new (0, _restructureDefault.default).Array(LookupRecord, 'lookupCount')
    }
});
var _;
/*******************
 * Variation Store *
 *******************/ var F2DOT14 = new (0, _restructureDefault.default).Fixed(16, 'BE', 14);
var RegionAxisCoordinates = new (0, _restructureDefault.default).Struct({
    startCoord: F2DOT14,
    peakCoord: F2DOT14,
    endCoord: F2DOT14
});
var VariationRegionList = new (0, _restructureDefault.default).Struct({
    axisCount: (0, _restructureDefault.default).uint16,
    regionCount: (0, _restructureDefault.default).uint16,
    variationRegions: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Array(RegionAxisCoordinates, 'axisCount'), 'regionCount')
});
var DeltaSet = new (0, _restructureDefault.default).Struct({
    shortDeltas: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int16, function(t) {
        return t.parent.shortDeltaCount;
    }),
    regionDeltas: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int8, function(t) {
        return t.parent.regionIndexCount - t.parent.shortDeltaCount;
    }),
    deltas: function deltas(t) {
        return t.shortDeltas.concat(t.regionDeltas);
    }
});
var ItemVariationData = new (0, _restructureDefault.default).Struct({
    itemCount: (0, _restructureDefault.default).uint16,
    shortDeltaCount: (0, _restructureDefault.default).uint16,
    regionIndexCount: (0, _restructureDefault.default).uint16,
    regionIndexes: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'regionIndexCount'),
    deltaSets: new (0, _restructureDefault.default).Array(DeltaSet, 'itemCount')
});
var ItemVariationStore = new (0, _restructureDefault.default).Struct({
    format: (0, _restructureDefault.default).uint16,
    variationRegionList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, VariationRegionList),
    variationDataCount: (0, _restructureDefault.default).uint16,
    itemVariationData: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, ItemVariationData), 'variationDataCount')
});
/**********************
 * Feature Variations *
 **********************/ var ConditionTable = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: (_ = {
        axisIndex: (0, _restructureDefault.default).uint16
    }, _['axisIndex'] = (0, _restructureDefault.default).uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _)
});
var ConditionSet = new (0, _restructureDefault.default).Struct({
    conditionCount: (0, _restructureDefault.default).uint16,
    conditionTable: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, ConditionTable), 'conditionCount')
});
var FeatureTableSubstitutionRecord = new (0, _restructureDefault.default).Struct({
    featureIndex: (0, _restructureDefault.default).uint16,
    alternateFeatureTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, Feature, {
        type: 'parent'
    })
});
var FeatureTableSubstitution = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).fixed32,
    substitutionCount: (0, _restructureDefault.default).uint16,
    substitutions: new (0, _restructureDefault.default).Array(FeatureTableSubstitutionRecord, 'substitutionCount')
});
var FeatureVariationRecord = new (0, _restructureDefault.default).Struct({
    conditionSet: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, ConditionSet, {
        type: 'parent'
    }),
    featureTableSubstitution: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, FeatureTableSubstitution, {
        type: 'parent'
    })
});
var FeatureVariations = new (0, _restructureDefault.default).Struct({
    majorVersion: (0, _restructureDefault.default).uint16,
    minorVersion: (0, _restructureDefault.default).uint16,
    featureVariationRecordCount: (0, _restructureDefault.default).uint32,
    featureVariationRecords: new (0, _restructureDefault.default).Array(FeatureVariationRecord, 'featureVariationRecordCount')
});
// Checks if an operand is an index of a predefined value,
// otherwise delegates to the provided type.
var PredefinedOp = function() {
    function PredefinedOp(predefinedOps, type) {
        classCallCheck(this, PredefinedOp);
        this.predefinedOps = predefinedOps;
        this.type = type;
    }
    PredefinedOp.prototype.decode = function decode(stream, parent, operands) {
        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
        return this.type.decode(stream, parent, operands);
    };
    PredefinedOp.prototype.size = function size(value, ctx) {
        return this.type.size(value, ctx);
    };
    PredefinedOp.prototype.encode = function encode(stream, value, ctx) {
        var index = this.predefinedOps.indexOf(value);
        if (index !== -1) return index;
        return this.type.encode(stream, value, ctx);
    };
    return PredefinedOp;
}();
var CFFEncodingVersion = function(_r$Number) {
    inherits(CFFEncodingVersion, _r$Number);
    function CFFEncodingVersion() {
        classCallCheck(this, CFFEncodingVersion);
        return possibleConstructorReturn(this, _r$Number.call(this, 'UInt8'));
    }
    CFFEncodingVersion.prototype.decode = function decode(stream) {
        return (0, _restructureDefault.default).uint8.decode(stream) & 0x7f;
    };
    return CFFEncodingVersion;
}((0, _restructureDefault.default).Number);
var Range1 = new (0, _restructureDefault.default).Struct({
    first: (0, _restructureDefault.default).uint16,
    nLeft: (0, _restructureDefault.default).uint8
});
var Range2 = new (0, _restructureDefault.default).Struct({
    first: (0, _restructureDefault.default).uint16,
    nLeft: (0, _restructureDefault.default).uint16
});
var CFFCustomEncoding = new (0, _restructureDefault.default).VersionedStruct(new CFFEncodingVersion(), {
    0: {
        nCodes: (0, _restructureDefault.default).uint8,
        codes: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, 'nCodes')
    },
    1: {
        nRanges: (0, _restructureDefault.default).uint8,
        ranges: new (0, _restructureDefault.default).Array(Range1, 'nRanges')
    }
});
var CFFEncoding = new PredefinedOp([
    StandardEncoding,
    ExpertEncoding
], new CFFPointer(CFFCustomEncoding, {
    lazy: true
}));
// Decodes an array of ranges until the total
// length is equal to the provided length.
var RangeArray = function(_r$Array) {
    inherits(RangeArray, _r$Array);
    function RangeArray() {
        classCallCheck(this, RangeArray);
        return possibleConstructorReturn(this, _r$Array.apply(this, arguments));
    }
    RangeArray.prototype.decode = function decode(stream, parent) {
        var length = (0, _utils.resolveLength)(this.length, stream, parent);
        var count = 0;
        var res = [];
        while(count < length){
            var range = this.type.decode(stream, parent);
            range.offset = count;
            count += range.nLeft + 1;
            res.push(range);
        }
        return res;
    };
    return RangeArray;
}((0, _restructureDefault.default).Array);
var CFFCustomCharset = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint8, {
    0: {
        glyphs: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    },
    1: {
        ranges: new RangeArray(Range1, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    },
    2: {
        ranges: new RangeArray(Range2, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    }
});
var CFFCharset = new PredefinedOp([
    ISOAdobeCharset,
    ExpertCharset,
    ExpertSubsetCharset
], new CFFPointer(CFFCustomCharset, {
    lazy: true
}));
var FDRange3 = new (0, _restructureDefault.default).Struct({
    first: (0, _restructureDefault.default).uint16,
    fd: (0, _restructureDefault.default).uint8
});
var FDRange4 = new (0, _restructureDefault.default).Struct({
    first: (0, _restructureDefault.default).uint32,
    fd: (0, _restructureDefault.default).uint16
});
var FDSelect = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint8, {
    0: {
        fds: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, function(t) {
            return t.parent.CharStrings.length;
        })
    },
    3: {
        nRanges: (0, _restructureDefault.default).uint16,
        ranges: new (0, _restructureDefault.default).Array(FDRange3, 'nRanges'),
        sentinel: (0, _restructureDefault.default).uint16
    },
    4: {
        nRanges: (0, _restructureDefault.default).uint32,
        ranges: new (0, _restructureDefault.default).Array(FDRange4, 'nRanges'),
        sentinel: (0, _restructureDefault.default).uint32
    }
});
var ptr = new CFFPointer(CFFPrivateDict);
var CFFPrivateOp = function() {
    function CFFPrivateOp() {
        classCallCheck(this, CFFPrivateOp);
    }
    CFFPrivateOp.prototype.decode = function decode(stream, parent, operands) {
        parent.length = operands[0];
        return ptr.decode(stream, parent, [
            operands[1]
        ]);
    };
    CFFPrivateOp.prototype.size = function size(dict, ctx) {
        return [
            CFFPrivateDict.size(dict, ctx, false),
            ptr.size(dict, ctx)[0]
        ];
    };
    CFFPrivateOp.prototype.encode = function encode(stream, dict, ctx) {
        return [
            CFFPrivateDict.size(dict, ctx, false),
            ptr.encode(stream, dict, ctx)[0]
        ];
    };
    return CFFPrivateOp;
}();
var FontDict = new CFFDict([
    // key       name                   type(s)                                 default
    [
        18,
        'Private',
        new CFFPrivateOp(),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
var CFFTopDict = new CFFDict([
    // key       name                   type(s)                                 default
    [
        [
            12,
            30
        ],
        'ROS',
        [
            'sid',
            'sid',
            'number'
        ],
        null
    ],
    [
        0,
        'version',
        'sid',
        null
    ],
    [
        1,
        'Notice',
        'sid',
        null
    ],
    [
        [
            12,
            0
        ],
        'Copyright',
        'sid',
        null
    ],
    [
        2,
        'FullName',
        'sid',
        null
    ],
    [
        3,
        'FamilyName',
        'sid',
        null
    ],
    [
        4,
        'Weight',
        'sid',
        null
    ],
    [
        [
            12,
            1
        ],
        'isFixedPitch',
        'boolean',
        false
    ],
    [
        [
            12,
            2
        ],
        'ItalicAngle',
        'number',
        0
    ],
    [
        [
            12,
            3
        ],
        'UnderlinePosition',
        'number',
        -100
    ],
    [
        [
            12,
            4
        ],
        'UnderlineThickness',
        'number',
        50
    ],
    [
        [
            12,
            5
        ],
        'PaintType',
        'number',
        0
    ],
    [
        [
            12,
            6
        ],
        'CharstringType',
        'number',
        2
    ],
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        13,
        'UniqueID',
        'number',
        null
    ],
    [
        5,
        'FontBBox',
        'array',
        [
            0,
            0,
            0,
            0
        ]
    ],
    [
        [
            12,
            8
        ],
        'StrokeWidth',
        'number',
        0
    ],
    [
        14,
        'XUID',
        'array',
        null
    ],
    [
        15,
        'charset',
        CFFCharset,
        ISOAdobeCharset
    ],
    [
        16,
        'Encoding',
        CFFEncoding,
        StandardEncoding
    ],
    [
        17,
        'CharStrings',
        new CFFPointer(new CFFIndex()),
        null
    ],
    [
        18,
        'Private',
        new CFFPrivateOp(),
        null
    ],
    [
        [
            12,
            20
        ],
        'SyntheticBase',
        'number',
        null
    ],
    [
        [
            12,
            21
        ],
        'PostScript',
        'sid',
        null
    ],
    [
        [
            12,
            22
        ],
        'BaseFontName',
        'sid',
        null
    ],
    [
        [
            12,
            23
        ],
        'BaseFontBlend',
        'delta',
        null
    ],
    // CID font specific
    [
        [
            12,
            31
        ],
        'CIDFontVersion',
        'number',
        0
    ],
    [
        [
            12,
            32
        ],
        'CIDFontRevision',
        'number',
        0
    ],
    [
        [
            12,
            33
        ],
        'CIDFontType',
        'number',
        0
    ],
    [
        [
            12,
            34
        ],
        'CIDCount',
        'number',
        8720
    ],
    [
        [
            12,
            35
        ],
        'UIDBase',
        'number',
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new CFFPointer(FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new CFFPointer(new CFFIndex(FontDict)),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
var VariationStore = new (0, _restructureDefault.default).Struct({
    length: (0, _restructureDefault.default).uint16,
    itemVariationStore: ItemVariationStore
});
var CFF2TopDict = new CFFDict([
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        17,
        'CharStrings',
        new CFFPointer(new CFFIndex()),
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new CFFPointer(FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new CFFPointer(new CFFIndex(FontDict)),
        null
    ],
    [
        24,
        'vstore',
        new CFFPointer(VariationStore),
        null
    ],
    [
        25,
        'maxstack',
        'number',
        193
    ]
]);
var CFFTop = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).fixed16, {
    1: {
        hdrSize: (0, _restructureDefault.default).uint8,
        offSize: (0, _restructureDefault.default).uint8,
        nameIndex: new CFFIndex(new (0, _restructureDefault.default).String('length')),
        topDictIndex: new CFFIndex(CFFTopDict),
        stringIndex: new CFFIndex(new (0, _restructureDefault.default).String('length')),
        globalSubrIndex: new CFFIndex()
    },
    2: {
        hdrSize: (0, _restructureDefault.default).uint8,
        length: (0, _restructureDefault.default).uint16,
        topDict: CFF2TopDict,
        globalSubrIndex: new CFFIndex()
    }
});
var CFFFont = function() {
    function CFFFont(stream) {
        classCallCheck(this, CFFFont);
        this.stream = stream;
        this.decode();
    }
    CFFFont.decode = function decode(stream) {
        return new CFFFont(stream);
    };
    CFFFont.prototype.decode = function decode() {
        var start = this.stream.pos;
        var top = CFFTop.decode(this.stream);
        for(var key in top){
            var val = top[key];
            this[key] = val;
        }
        if (this.version < 2) {
            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
            this.topDict = this.topDictIndex[0];
        }
        this.isCIDFont = this.topDict.ROS != null;
        return this;
    };
    CFFFont.prototype.string = function string(sid) {
        if (this.version >= 2) return null;
        if (sid < standardStrings.length) return standardStrings[sid];
        return this.stringIndex[sid - standardStrings.length];
    };
    CFFFont.prototype.getCharString = function getCharString(glyph) {
        this.stream.pos = this.topDict.CharStrings[glyph].offset;
        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
    };
    CFFFont.prototype.getGlyphName = function getGlyphName(gid) {
        // CFF2 glyph names are in the post table.
        if (this.version >= 2) return null;
        // CID-keyed fonts don't have glyph names
        if (this.isCIDFont) return null;
        var charset = this.topDict.charset;
        if (Array.isArray(charset)) return charset[gid];
        if (gid === 0) return '.notdef';
        gid -= 1;
        switch(charset.version){
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for(var i = 0; i < charset.ranges.length; i++){
                    var range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                }
                break;
        }
        return null;
    };
    CFFFont.prototype.fdForGlyph = function fdForGlyph(gid) {
        if (!this.topDict.FDSelect) return null;
        switch(this.topDict.FDSelect.version){
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                var ranges = this.topDict.FDSelect.ranges;
                var low = 0;
                var high = ranges.length - 1;
                while(low <= high){
                    var mid = low + high >> 1;
                    if (gid < ranges[mid].first) high = mid - 1;
                    else if (mid < high && gid > ranges[mid + 1].first) low = mid + 1;
                    else return ranges[mid].fd;
                }
            default:
                throw new Error('Unknown FDSelect version: ' + this.topDict.FDSelect.version);
        }
    };
    CFFFont.prototype.privateDictForGlyph = function privateDictForGlyph(gid) {
        if (this.topDict.FDSelect) {
            var fd = this.fdForGlyph(gid);
            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
            return null;
        }
        if (this.version < 2) return this.topDict.Private;
        return this.topDict.FDArray[0].Private;
    };
    createClass(CFFFont, [
        {
            key: 'postscriptName',
            get: function get$$1() {
                if (this.version < 2) return this.nameIndex[0];
                return null;
            }
        },
        {
            key: 'fullName',
            get: function get$$1() {
                return this.string(this.topDict.FullName);
            }
        },
        {
            key: 'familyName',
            get: function get$$1() {
                return this.string(this.topDict.FamilyName);
            }
        }
    ]);
    return CFFFont;
}();
var VerticalOrigin = new (0, _restructureDefault.default).Struct({
    glyphIndex: (0, _restructureDefault.default).uint16,
    vertOriginY: (0, _restructureDefault.default).int16
});
var VORG = new (0, _restructureDefault.default).Struct({
    majorVersion: (0, _restructureDefault.default).uint16,
    minorVersion: (0, _restructureDefault.default).uint16,
    defaultVertOriginY: (0, _restructureDefault.default).int16,
    numVertOriginYMetrics: (0, _restructureDefault.default).uint16,
    metrics: new (0, _restructureDefault.default).Array(VerticalOrigin, 'numVertOriginYMetrics')
});
var BigMetrics = new (0, _restructureDefault.default).Struct({
    height: (0, _restructureDefault.default).uint8,
    width: (0, _restructureDefault.default).uint8,
    horiBearingX: (0, _restructureDefault.default).int8,
    horiBearingY: (0, _restructureDefault.default).int8,
    horiAdvance: (0, _restructureDefault.default).uint8,
    vertBearingX: (0, _restructureDefault.default).int8,
    vertBearingY: (0, _restructureDefault.default).int8,
    vertAdvance: (0, _restructureDefault.default).uint8
});
var SmallMetrics = new (0, _restructureDefault.default).Struct({
    height: (0, _restructureDefault.default).uint8,
    width: (0, _restructureDefault.default).uint8,
    bearingX: (0, _restructureDefault.default).int8,
    bearingY: (0, _restructureDefault.default).int8,
    advance: (0, _restructureDefault.default).uint8
});
var EBDTComponent = new (0, _restructureDefault.default).Struct({
    glyph: (0, _restructureDefault.default).uint16,
    xOffset: (0, _restructureDefault.default).int8,
    yOffset: (0, _restructureDefault.default).int8
});
var ByteAligned = function ByteAligned() {
    classCallCheck(this, ByteAligned);
};
var BitAligned = function BitAligned() {
    classCallCheck(this, BitAligned);
};
var glyph = new (0, _restructureDefault.default).VersionedStruct('version', {
    1: {
        metrics: SmallMetrics,
        data: ByteAligned
    },
    2: {
        metrics: SmallMetrics,
        data: BitAligned
    },
    // format 3 is deprecated
    // format 4 is not supported by Microsoft
    5: {
        data: BitAligned
    },
    6: {
        metrics: BigMetrics,
        data: ByteAligned
    },
    7: {
        metrics: BigMetrics,
        data: BitAligned
    },
    8: {
        metrics: SmallMetrics,
        pad: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8),
        numComponents: (0, _restructureDefault.default).uint16,
        components: new (0, _restructureDefault.default).Array(EBDTComponent, 'numComponents')
    },
    9: {
        metrics: BigMetrics,
        pad: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8),
        numComponents: (0, _restructureDefault.default).uint16,
        components: new (0, _restructureDefault.default).Array(EBDTComponent, 'numComponents')
    },
    17: {
        metrics: SmallMetrics,
        dataLen: (0, _restructureDefault.default).uint32,
        data: new (0, _restructureDefault.default).Buffer('dataLen')
    },
    18: {
        metrics: BigMetrics,
        dataLen: (0, _restructureDefault.default).uint32,
        data: new (0, _restructureDefault.default).Buffer('dataLen')
    },
    19: {
        dataLen: (0, _restructureDefault.default).uint32,
        data: new (0, _restructureDefault.default).Buffer('dataLen')
    }
});
var SBitLineMetrics = new (0, _restructureDefault.default).Struct({
    ascender: (0, _restructureDefault.default).int8,
    descender: (0, _restructureDefault.default).int8,
    widthMax: (0, _restructureDefault.default).uint8,
    caretSlopeNumerator: (0, _restructureDefault.default).int8,
    caretSlopeDenominator: (0, _restructureDefault.default).int8,
    caretOffset: (0, _restructureDefault.default).int8,
    minOriginSB: (0, _restructureDefault.default).int8,
    minAdvanceSB: (0, _restructureDefault.default).int8,
    maxBeforeBL: (0, _restructureDefault.default).int8,
    minAfterBL: (0, _restructureDefault.default).int8,
    pad: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).int8, 2)
});
var CodeOffsetPair = new (0, _restructureDefault.default).Struct({
    glyphCode: (0, _restructureDefault.default).uint16,
    offset: (0, _restructureDefault.default).uint16
});
var IndexSubtable = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    header: {
        imageFormat: (0, _restructureDefault.default).uint16,
        imageDataOffset: (0, _restructureDefault.default).uint32
    },
    1: {
        offsetArray: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, function(t) {
            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
        })
    },
    2: {
        imageSize: (0, _restructureDefault.default).uint32,
        bigMetrics: BigMetrics
    },
    3: {
        offsetArray: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, function(t) {
            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
        })
    },
    4: {
        numGlyphs: (0, _restructureDefault.default).uint32,
        glyphArray: new (0, _restructureDefault.default).Array(CodeOffsetPair, function(t) {
            return t.numGlyphs + 1;
        })
    },
    5: {
        imageSize: (0, _restructureDefault.default).uint32,
        bigMetrics: BigMetrics,
        numGlyphs: (0, _restructureDefault.default).uint32,
        glyphCodeArray: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'numGlyphs')
    }
});
var IndexSubtableArray = new (0, _restructureDefault.default).Struct({
    firstGlyphIndex: (0, _restructureDefault.default).uint16,
    lastGlyphIndex: (0, _restructureDefault.default).uint16,
    subtable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, IndexSubtable)
});
var BitmapSizeTable = new (0, _restructureDefault.default).Struct({
    indexSubTableArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array(IndexSubtableArray, 1), {
        type: 'parent'
    }),
    indexTablesSize: (0, _restructureDefault.default).uint32,
    numberOfIndexSubTables: (0, _restructureDefault.default).uint32,
    colorRef: (0, _restructureDefault.default).uint32,
    hori: SBitLineMetrics,
    vert: SBitLineMetrics,
    startGlyphIndex: (0, _restructureDefault.default).uint16,
    endGlyphIndex: (0, _restructureDefault.default).uint16,
    ppemX: (0, _restructureDefault.default).uint8,
    ppemY: (0, _restructureDefault.default).uint8,
    bitDepth: (0, _restructureDefault.default).uint8,
    flags: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint8, [
        'horizontal',
        'vertical'
    ])
});
var EBLC = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint32,
    numSizes: (0, _restructureDefault.default).uint32,
    sizes: new (0, _restructureDefault.default).Array(BitmapSizeTable, 'numSizes')
});
var ImageTable = new (0, _restructureDefault.default).Struct({
    ppem: (0, _restructureDefault.default).uint16,
    resolution: (0, _restructureDefault.default).uint16,
    imageOffsets: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, 'void'), function(t) {
        return t.parent.parent.maxp.numGlyphs + 1;
    })
});
// This is the Apple sbix table, used by the "Apple Color Emoji" font.
// It includes several image tables with images for each bitmap glyph
// of several different sizes.
var sbix = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    flags: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint16, [
        'renderOutlines'
    ]),
    numImgTables: (0, _restructureDefault.default).uint32,
    imageTables: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, ImageTable), 'numImgTables')
});
var LayerRecord = new (0, _restructureDefault.default).Struct({
    gid: (0, _restructureDefault.default).uint16,
    paletteIndex: (0, _restructureDefault.default).uint16 // Index value to use in the appropriate palette. This value must
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.
var BaseGlyphRecord = new (0, _restructureDefault.default).Struct({
    gid: (0, _restructureDefault.default).uint16,
    // and is not rendered for color.
    firstLayerIndex: (0, _restructureDefault.default).uint16,
    // There will be numLayers consecutive entries for this base glyph.
    numLayers: (0, _restructureDefault.default).uint16
});
var COLR = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    numBaseGlyphRecords: (0, _restructureDefault.default).uint16,
    baseGlyphRecord: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array(BaseGlyphRecord, 'numBaseGlyphRecords')),
    layerRecords: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array(LayerRecord, 'numLayerRecords'), {
        lazy: true
    }),
    numLayerRecords: (0, _restructureDefault.default).uint16
});
var ColorRecord = new (0, _restructureDefault.default).Struct({
    blue: (0, _restructureDefault.default).uint8,
    green: (0, _restructureDefault.default).uint8,
    red: (0, _restructureDefault.default).uint8,
    alpha: (0, _restructureDefault.default).uint8
});
var CPAL = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    header: {
        numPaletteEntries: (0, _restructureDefault.default).uint16,
        numPalettes: (0, _restructureDefault.default).uint16,
        numColorRecords: (0, _restructureDefault.default).uint16,
        colorRecords: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array(ColorRecord, 'numColorRecords')),
        colorRecordIndices: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'numPalettes')
    },
    0: {},
    1: {
        offsetPaletteTypeArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, 'numPalettes')),
        offsetPaletteLabelArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'numPalettes')),
        offsetPaletteEntryLabelArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'numPaletteEntries'))
    }
});
var BaseCoord = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: {
        coordinate: (0, _restructureDefault.default).int16 // X or Y value, in design units
    },
    2: {
        coordinate: (0, _restructureDefault.default).int16,
        referenceGlyph: (0, _restructureDefault.default).uint16,
        baseCoordPoint: (0, _restructureDefault.default).uint16 // Index of contour point on the referenceGlyph
    },
    3: {
        coordinate: (0, _restructureDefault.default).int16,
        deviceTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device) // Device table for X or Y value
    }
});
var BaseValues = new (0, _restructureDefault.default).Struct({
    defaultIndex: (0, _restructureDefault.default).uint16,
    baseCoordCount: (0, _restructureDefault.default).uint16,
    baseCoords: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseCoord), 'baseCoordCount')
});
var FeatMinMaxRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    minCoord: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseCoord, {
        type: 'parent'
    }),
    maxCoord: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseCoord, {
        type: 'parent'
    }) // May be NULL
});
var MinMax = new (0, _restructureDefault.default).Struct({
    minCoord: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseCoord),
    maxCoord: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseCoord),
    featMinMaxCount: (0, _restructureDefault.default).uint16,
    featMinMaxRecords: new (0, _restructureDefault.default).Array(FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
});
var BaseLangSysRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    minMax: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, MinMax, {
        type: 'parent'
    })
});
var BaseScript = new (0, _restructureDefault.default).Struct({
    baseValues: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseValues),
    defaultMinMax: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, MinMax),
    baseLangSysCount: (0, _restructureDefault.default).uint16,
    baseLangSysRecords: new (0, _restructureDefault.default).Array(BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
});
var BaseScriptRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    script: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseScript, {
        type: 'parent'
    })
});
var BaseScriptList = new (0, _restructureDefault.default).Array(BaseScriptRecord, (0, _restructureDefault.default).uint16);
// Array of 4-byte baseline identification tags-must be in alphabetical order
var BaseTagList = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).String(4), (0, _restructureDefault.default).uint16);
var Axis = new (0, _restructureDefault.default).Struct({
    baseTagList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseTagList),
    baseScriptList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseScriptList)
});
var BASE = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint32, {
    header: {
        horizAxis: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Axis),
        vertAxis: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Axis) // May be NULL
    },
    0x00010000: {},
    0x00010001: {
        itemVariationStore: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, ItemVariationStore)
    }
});
var AttachPoint = new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, (0, _restructureDefault.default).uint16);
var AttachList = new (0, _restructureDefault.default).Struct({
    coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
    glyphCount: (0, _restructureDefault.default).uint16,
    attachPoints: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, AttachPoint), 'glyphCount')
});
var CaretValue = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: {
        coordinate: (0, _restructureDefault.default).int16
    },
    2: {
        caretValuePoint: (0, _restructureDefault.default).uint16
    },
    3: {
        coordinate: (0, _restructureDefault.default).int16,
        deviceTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device)
    }
});
var LigGlyph = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, CaretValue), (0, _restructureDefault.default).uint16);
var LigCaretList = new (0, _restructureDefault.default).Struct({
    coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
    ligGlyphCount: (0, _restructureDefault.default).uint16,
    ligGlyphs: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, LigGlyph), 'ligGlyphCount')
});
var MarkGlyphSetsDef = new (0, _restructureDefault.default).Struct({
    markSetTableFormat: (0, _restructureDefault.default).uint16,
    markSetCount: (0, _restructureDefault.default).uint16,
    coverage: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, Coverage), 'markSetCount')
});
var GDEF = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint32, {
    header: {
        glyphClassDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef),
        attachList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, AttachList),
        ligCaretList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, LigCaretList),
        markAttachClassDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef)
    },
    0x00010000: {},
    0x00010002: {
        markGlyphSetsDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, MarkGlyphSetsDef)
    },
    0x00010003: {
        markGlyphSetsDef: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, MarkGlyphSetsDef),
        itemVariationStore: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, ItemVariationStore)
    }
});
var ValueFormat = new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint16, [
    'xPlacement',
    'yPlacement',
    'xAdvance',
    'yAdvance',
    'xPlaDevice',
    'yPlaDevice',
    'xAdvDevice',
    'yAdvDevice'
]);
var types = {
    xPlacement: (0, _restructureDefault.default).int16,
    yPlacement: (0, _restructureDefault.default).int16,
    xAdvance: (0, _restructureDefault.default).int16,
    yAdvance: (0, _restructureDefault.default).int16,
    xPlaDevice: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    yPlaDevice: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    xAdvDevice: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    yAdvDevice: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device, {
        type: 'global',
        relativeTo: 'rel'
    })
};
var ValueRecord = function() {
    function ValueRecord() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valueFormat';
        classCallCheck(this, ValueRecord);
        this.key = key;
    }
    ValueRecord.prototype.buildStruct = function buildStruct(parent) {
        var struct = parent;
        while(!struct[this.key] && struct.parent)struct = struct.parent;
        if (!struct[this.key]) return;
        var fields = {};
        fields.rel = function() {
            return struct._startOffset;
        };
        var format = struct[this.key];
        for(var key in format)if (format[key]) fields[key] = types[key];
        return new (0, _restructureDefault.default).Struct(fields);
    };
    ValueRecord.prototype.size = function size(val, ctx) {
        return this.buildStruct(ctx).size(val, ctx);
    };
    ValueRecord.prototype.decode = function decode(stream, parent) {
        var res = this.buildStruct(parent).decode(stream, parent);
        delete res.rel;
        return res;
    };
    return ValueRecord;
}();
var PairValueRecord = new (0, _restructureDefault.default).Struct({
    secondGlyph: (0, _restructureDefault.default).uint16,
    value1: new ValueRecord('valueFormat1'),
    value2: new ValueRecord('valueFormat2')
});
var PairSet = new (0, _restructureDefault.default).Array(PairValueRecord, (0, _restructureDefault.default).uint16);
var Class2Record = new (0, _restructureDefault.default).Struct({
    value1: new ValueRecord('valueFormat1'),
    value2: new ValueRecord('valueFormat2')
});
var Anchor = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    1: {
        xCoordinate: (0, _restructureDefault.default).int16,
        yCoordinate: (0, _restructureDefault.default).int16
    },
    2: {
        xCoordinate: (0, _restructureDefault.default).int16,
        yCoordinate: (0, _restructureDefault.default).int16,
        anchorPoint: (0, _restructureDefault.default).uint16
    },
    3: {
        xCoordinate: (0, _restructureDefault.default).int16,
        yCoordinate: (0, _restructureDefault.default).int16,
        xDeviceTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device),
        yDeviceTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Device)
    }
});
var EntryExitRecord = new (0, _restructureDefault.default).Struct({
    entryAnchor: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Anchor, {
        type: 'parent'
    }),
    exitAnchor: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Anchor, {
        type: 'parent'
    })
});
var MarkRecord = new (0, _restructureDefault.default).Struct({
    class: (0, _restructureDefault.default).uint16,
    markAnchor: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Anchor, {
        type: 'parent'
    })
});
var MarkArray = new (0, _restructureDefault.default).Array(MarkRecord, (0, _restructureDefault.default).uint16);
var BaseRecord = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Anchor), function(t) {
    return t.parent.classCount;
});
var BaseArray = new (0, _restructureDefault.default).Array(BaseRecord, (0, _restructureDefault.default).uint16);
var ComponentRecord = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Anchor), function(t) {
    return t.parent.parent.classCount;
});
var LigatureAttach = new (0, _restructureDefault.default).Array(ComponentRecord, (0, _restructureDefault.default).uint16);
var LigatureArray = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, LigatureAttach), (0, _restructureDefault.default).uint16);
var GPOSLookup = new (0, _restructureDefault.default).VersionedStruct('lookupType', {
    1: new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
        1: {
            coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
            valueFormat: ValueFormat,
            value: new ValueRecord()
        },
        2: {
            coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
            valueFormat: ValueFormat,
            valueCount: (0, _restructureDefault.default).uint16,
            values: new (0, _restructureDefault.default).LazyArray(new ValueRecord(), 'valueCount')
        }
    }),
    2: new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
        1: {
            coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
            valueFormat1: ValueFormat,
            valueFormat2: ValueFormat,
            pairSetCount: (0, _restructureDefault.default).uint16,
            pairSets: new (0, _restructureDefault.default).LazyArray(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, PairSet), 'pairSetCount')
        },
        2: {
            coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
            valueFormat1: ValueFormat,
            valueFormat2: ValueFormat,
            classDef1: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef),
            classDef2: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassDef),
            class1Count: (0, _restructureDefault.default).uint16,
            class2Count: (0, _restructureDefault.default).uint16,
            classRecords: new (0, _restructureDefault.default).LazyArray(new (0, _restructureDefault.default).LazyArray(Class2Record, 'class2Count'), 'class1Count')
        }
    }),
    3: {
        format: (0, _restructureDefault.default).uint16,
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        entryExitCount: (0, _restructureDefault.default).uint16,
        entryExitRecords: new (0, _restructureDefault.default).Array(EntryExitRecord, 'entryExitCount')
    },
    4: {
        format: (0, _restructureDefault.default).uint16,
        markCoverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        baseCoverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        classCount: (0, _restructureDefault.default).uint16,
        markArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, MarkArray),
        baseArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseArray)
    },
    5: {
        format: (0, _restructureDefault.default).uint16,
        markCoverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        ligatureCoverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        classCount: (0, _restructureDefault.default).uint16,
        markArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, MarkArray),
        ligatureArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, LigatureArray)
    },
    6: {
        format: (0, _restructureDefault.default).uint16,
        mark1Coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        mark2Coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        classCount: (0, _restructureDefault.default).uint16,
        mark1Array: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, MarkArray),
        mark2Array: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, BaseArray)
    },
    7: Context,
    8: ChainingContext,
    9: {
        posFormat: (0, _restructureDefault.default).uint16,
        lookupType: (0, _restructureDefault.default).uint16,
        extension: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, undefined)
    }
});
// Fix circular reference
GPOSLookup.versions[9].extension.type = GPOSLookup;
var GPOS = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint32, {
    header: {
        scriptList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ScriptList),
        featureList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, FeatureList),
        lookupList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new LookupList(GPOSLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, FeatureVariations)
    }
});
var Sequence = new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, (0, _restructureDefault.default).uint16);
var AlternateSet = Sequence;
var Ligature = new (0, _restructureDefault.default).Struct({
    glyph: (0, _restructureDefault.default).uint16,
    compCount: (0, _restructureDefault.default).uint16,
    components: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, function(t) {
        return t.compCount - 1;
    })
});
var LigatureSet = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Ligature), (0, _restructureDefault.default).uint16);
var GSUBLookup = new (0, _restructureDefault.default).VersionedStruct('lookupType', {
    1: new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
        1: {
            coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
            deltaGlyphID: (0, _restructureDefault.default).int16
        },
        2: {
            coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
            glyphCount: (0, _restructureDefault.default).uint16,
            substitute: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).uint16, 'glyphCount')
        }
    }),
    2: {
        substFormat: (0, _restructureDefault.default).uint16,
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        count: (0, _restructureDefault.default).uint16,
        sequences: new (0, _restructureDefault.default).LazyArray(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Sequence), 'count')
    },
    3: {
        substFormat: (0, _restructureDefault.default).uint16,
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        count: (0, _restructureDefault.default).uint16,
        alternateSet: new (0, _restructureDefault.default).LazyArray(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, AlternateSet), 'count')
    },
    4: {
        substFormat: (0, _restructureDefault.default).uint16,
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        count: (0, _restructureDefault.default).uint16,
        ligatureSets: new (0, _restructureDefault.default).LazyArray(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, LigatureSet), 'count')
    },
    5: Context,
    6: ChainingContext,
    7: {
        substFormat: (0, _restructureDefault.default).uint16,
        lookupType: (0, _restructureDefault.default).uint16,
        extension: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, undefined)
    },
    8: {
        substFormat: (0, _restructureDefault.default).uint16,
        coverage: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage),
        backtrackCoverage: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage), 'backtrackGlyphCount'),
        lookaheadGlyphCount: (0, _restructureDefault.default).uint16,
        lookaheadCoverage: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Coverage), 'lookaheadGlyphCount'),
        glyphCount: (0, _restructureDefault.default).uint16,
        substitutes: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'glyphCount')
    }
});
// Fix circular reference
GSUBLookup.versions[7].extension.type = GSUBLookup;
var GSUB = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint32, {
    header: {
        scriptList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ScriptList),
        featureList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, FeatureList),
        lookupList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new LookupList(GSUBLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, FeatureVariations)
    }
});
var JstfGSUBModList = new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, (0, _restructureDefault.default).uint16);
var JstfPriority = new (0, _restructureDefault.default).Struct({
    shrinkageEnableGSUB: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    shrinkageDisableGSUB: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    shrinkageEnableGPOS: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    shrinkageDisableGPOS: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    shrinkageJstfMax: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new LookupList(GPOSLookup)),
    extensionEnableGSUB: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    extensionDisableGSUB: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    extensionEnableGPOS: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    extensionDisableGPOS: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfGSUBModList),
    extensionJstfMax: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new LookupList(GPOSLookup))
});
var JstfLangSys = new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfPriority), (0, _restructureDefault.default).uint16);
var JstfLangSysRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    jstfLangSys: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfLangSys)
});
var JstfScript = new (0, _restructureDefault.default).Struct({
    extenderGlyphs: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, (0, _restructureDefault.default).uint16)),
    defaultLangSys: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfLangSys),
    langSysCount: (0, _restructureDefault.default).uint16,
    langSysRecords: new (0, _restructureDefault.default).Array(JstfLangSysRecord, 'langSysCount')
});
var JstfScriptRecord = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    script: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JstfScript, {
        type: 'parent'
    })
});
var JSTF = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint32,
    scriptCount: (0, _restructureDefault.default).uint16,
    scriptList: new (0, _restructureDefault.default).Array(JstfScriptRecord, 'scriptCount')
});
// TODO: add this to restructure
var VariableSizeNumber = function() {
    function VariableSizeNumber(size) {
        classCallCheck(this, VariableSizeNumber);
        this._size = size;
    }
    VariableSizeNumber.prototype.decode = function decode(stream, parent) {
        switch(this.size(0, parent)){
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
        }
    };
    VariableSizeNumber.prototype.size = function size(val, parent) {
        return (0, _utils.resolveLength)(this._size, null, parent);
    };
    return VariableSizeNumber;
}();
var MapDataEntry = new (0, _restructureDefault.default).Struct({
    entry: new VariableSizeNumber(function(t) {
        return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
    }),
    outerIndex: function outerIndex(t) {
        return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
    },
    innerIndex: function innerIndex(t) {
        return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
    }
});
var DeltaSetIndexMap = new (0, _restructureDefault.default).Struct({
    entryFormat: (0, _restructureDefault.default).uint16,
    mapCount: (0, _restructureDefault.default).uint16,
    mapData: new (0, _restructureDefault.default).Array(MapDataEntry, 'mapCount')
});
var HVAR = new (0, _restructureDefault.default).Struct({
    majorVersion: (0, _restructureDefault.default).uint16,
    minorVersion: (0, _restructureDefault.default).uint16,
    itemVariationStore: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, ItemVariationStore),
    advanceWidthMapping: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, DeltaSetIndexMap),
    LSBMapping: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, DeltaSetIndexMap),
    RSBMapping: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, DeltaSetIndexMap)
});
var Signature = new (0, _restructureDefault.default).Struct({
    format: (0, _restructureDefault.default).uint32,
    length: (0, _restructureDefault.default).uint32,
    offset: (0, _restructureDefault.default).uint32
});
var SignatureBlock = new (0, _restructureDefault.default).Struct({
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16, 2),
    cbSignature: (0, _restructureDefault.default).uint32,
    signature: new (0, _restructureDefault.default).Buffer('cbSignature')
});
var DSIG = new (0, _restructureDefault.default).Struct({
    ulVersion: (0, _restructureDefault.default).uint32,
    usNumSigs: (0, _restructureDefault.default).uint16,
    usFlag: (0, _restructureDefault.default).uint16,
    signatures: new (0, _restructureDefault.default).Array(Signature, 'usNumSigs'),
    signatureBlocks: new (0, _restructureDefault.default).Array(SignatureBlock, 'usNumSigs')
});
var GaspRange = new (0, _restructureDefault.default).Struct({
    rangeMaxPPEM: (0, _restructureDefault.default).uint16,
    rangeGaspBehavior: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint16, [
        'grayscale',
        'gridfit',
        'symmetricSmoothing',
        'symmetricGridfit' // only in version 1, for ClearType
    ])
});
var gasp = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    numRanges: (0, _restructureDefault.default).uint16,
    gaspRanges: new (0, _restructureDefault.default).Array(GaspRange, 'numRanges') // Sorted by ppem
});
var DeviceRecord = new (0, _restructureDefault.default).Struct({
    pixelSize: (0, _restructureDefault.default).uint8,
    maximumWidth: (0, _restructureDefault.default).uint8,
    widths: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, function(t) {
        return t.parent.parent.maxp.numGlyphs;
    })
});
// The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
var hdmx = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    numRecords: (0, _restructureDefault.default).int16,
    sizeDeviceRecord: (0, _restructureDefault.default).int32,
    records: new (0, _restructureDefault.default).Array(DeviceRecord, 'numRecords')
});
var KernPair = new (0, _restructureDefault.default).Struct({
    left: (0, _restructureDefault.default).uint16,
    right: (0, _restructureDefault.default).uint16,
    value: (0, _restructureDefault.default).int16
});
var ClassTable = new (0, _restructureDefault.default).Struct({
    firstGlyph: (0, _restructureDefault.default).uint16,
    nGlyphs: (0, _restructureDefault.default).uint16,
    offsets: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'nGlyphs'),
    max: function max(t) {
        return t.offsets.length && Math.max.apply(Math, t.offsets);
    }
});
var Kern2Array = new (0, _restructureDefault.default).Struct({
    off: function off(t) {
        return t._startOffset - t.parent.parent._startOffset;
    },
    len: function len(t) {
        return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
    },
    values: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).int16, 'len')
});
var KernSubtable = new (0, _restructureDefault.default).VersionedStruct('format', {
    0: {
        nPairs: (0, _restructureDefault.default).uint16,
        searchRange: (0, _restructureDefault.default).uint16,
        entrySelector: (0, _restructureDefault.default).uint16,
        rangeShift: (0, _restructureDefault.default).uint16,
        pairs: new (0, _restructureDefault.default).Array(KernPair, 'nPairs')
    },
    2: {
        rowWidth: (0, _restructureDefault.default).uint16,
        leftTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassTable, {
            type: 'parent'
        }),
        rightTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassTable, {
            type: 'parent'
        }),
        array: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, Kern2Array, {
            type: 'parent'
        })
    },
    3: {
        glyphCount: (0, _restructureDefault.default).uint16,
        kernValueCount: (0, _restructureDefault.default).uint8,
        leftClassCount: (0, _restructureDefault.default).uint8,
        rightClassCount: (0, _restructureDefault.default).uint8,
        flags: (0, _restructureDefault.default).uint8,
        kernValue: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int16, 'kernValueCount'),
        leftClass: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, 'glyphCount'),
        rightClass: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, 'glyphCount'),
        kernIndex: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, function(t) {
            return t.leftClassCount * t.rightClassCount;
        })
    }
});
var KernTable = new (0, _restructureDefault.default).VersionedStruct('version', {
    0: {
        subVersion: (0, _restructureDefault.default).uint16,
        length: (0, _restructureDefault.default).uint16,
        format: (0, _restructureDefault.default).uint8,
        coverage: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint8, [
            'horizontal',
            'minimum',
            'crossStream',
            'override' // If set to 1 the value in this table replaces the accumulated value
        ]),
        subtable: KernSubtable,
        padding: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8, function(t) {
            return t.length - t._currentOffset;
        })
    },
    1: {
        length: (0, _restructureDefault.default).uint32,
        coverage: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint8, [
            null,
            null,
            null,
            null,
            null,
            'variation',
            'crossStream',
            'vertical' // Set if table has vertical kerning values
        ]),
        format: (0, _restructureDefault.default).uint8,
        tupleIndex: (0, _restructureDefault.default).uint16,
        subtable: KernSubtable,
        padding: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8, function(t) {
            return t.length - t._currentOffset;
        })
    }
});
var kern = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
    0: {
        nTables: (0, _restructureDefault.default).uint16,
        tables: new (0, _restructureDefault.default).Array(KernTable, 'nTables')
    },
    1: {
        reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
        nTables: (0, _restructureDefault.default).uint32,
        tables: new (0, _restructureDefault.default).Array(KernTable, 'nTables')
    }
});
// Linear Threshold table
// Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
var LTSH = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    numGlyphs: (0, _restructureDefault.default).uint16,
    yPels: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, 'numGlyphs')
});
// PCL 5 Table
// NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
var PCLT = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    fontNumber: (0, _restructureDefault.default).uint32,
    pitch: (0, _restructureDefault.default).uint16,
    xHeight: (0, _restructureDefault.default).uint16,
    style: (0, _restructureDefault.default).uint16,
    typeFamily: (0, _restructureDefault.default).uint16,
    capHeight: (0, _restructureDefault.default).uint16,
    symbolSet: (0, _restructureDefault.default).uint16,
    typeface: new (0, _restructureDefault.default).String(16),
    characterComplement: new (0, _restructureDefault.default).String(8),
    fileName: new (0, _restructureDefault.default).String(6),
    strokeWeight: new (0, _restructureDefault.default).String(1),
    widthType: new (0, _restructureDefault.default).String(1),
    serifStyle: (0, _restructureDefault.default).uint8,
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8)
});
// VDMX tables contain ascender/descender overrides for certain (usually small)
// sizes. This is needed in order to match font metrics on Windows.
var Ratio = new (0, _restructureDefault.default).Struct({
    bCharSet: (0, _restructureDefault.default).uint8,
    xRatio: (0, _restructureDefault.default).uint8,
    yStartRatio: (0, _restructureDefault.default).uint8,
    yEndRatio: (0, _restructureDefault.default).uint8 // Ending y-Ratio value
});
var vTable = new (0, _restructureDefault.default).Struct({
    yPelHeight: (0, _restructureDefault.default).uint16,
    yMax: (0, _restructureDefault.default).int16,
    yMin: (0, _restructureDefault.default).int16 // Minimum value (in pels) for this yPelHeight
});
var VdmxGroup = new (0, _restructureDefault.default).Struct({
    recs: (0, _restructureDefault.default).uint16,
    startsz: (0, _restructureDefault.default).uint8,
    endsz: (0, _restructureDefault.default).uint8,
    entries: new (0, _restructureDefault.default).Array(vTable, 'recs') // The VDMX records
});
var VDMX = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    numRecs: (0, _restructureDefault.default).uint16,
    numRatios: (0, _restructureDefault.default).uint16,
    ratioRanges: new (0, _restructureDefault.default).Array(Ratio, 'numRatios'),
    offsets: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'numRatios'),
    groups: new (0, _restructureDefault.default).Array(VdmxGroup, 'numRecs') // The actual VDMX groupings
});
// Vertical Header Table
var vhea = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    ascent: (0, _restructureDefault.default).int16,
    descent: (0, _restructureDefault.default).int16,
    lineGap: (0, _restructureDefault.default).int16,
    advanceHeightMax: (0, _restructureDefault.default).int16,
    minTopSideBearing: (0, _restructureDefault.default).int16,
    minBottomSideBearing: (0, _restructureDefault.default).int16,
    yMaxExtent: (0, _restructureDefault.default).int16,
    caretSlopeRise: (0, _restructureDefault.default).int16,
    caretSlopeRun: (0, _restructureDefault.default).int16,
    caretOffset: (0, _restructureDefault.default).int16,
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).int16, 4),
    metricDataFormat: (0, _restructureDefault.default).int16,
    numberOfMetrics: (0, _restructureDefault.default).uint16 // Number of advance heights in the Vertical Metrics table
});
var VmtxEntry = new (0, _restructureDefault.default).Struct({
    advance: (0, _restructureDefault.default).uint16,
    bearing: (0, _restructureDefault.default).int16 // The top sidebearing of the glyph
});
// Vertical Metrics Table
var vmtx = new (0, _restructureDefault.default).Struct({
    metrics: new (0, _restructureDefault.default).LazyArray(VmtxEntry, function(t) {
        return t.parent.vhea.numberOfMetrics;
    }),
    bearings: new (0, _restructureDefault.default).LazyArray((0, _restructureDefault.default).int16, function(t) {
        return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
    })
});
var shortFrac = new (0, _restructureDefault.default).Fixed(16, 'BE', 14);
var Correspondence = new (0, _restructureDefault.default).Struct({
    fromCoord: shortFrac,
    toCoord: shortFrac
});
var Segment = new (0, _restructureDefault.default).Struct({
    pairCount: (0, _restructureDefault.default).uint16,
    correspondence: new (0, _restructureDefault.default).Array(Correspondence, 'pairCount')
});
var avar = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).fixed32,
    axisCount: (0, _restructureDefault.default).uint32,
    segment: new (0, _restructureDefault.default).Array(Segment, 'axisCount')
});
var UnboundedArrayAccessor = function() {
    function UnboundedArrayAccessor(type, stream, parent) {
        classCallCheck(this, UnboundedArrayAccessor);
        this.type = type;
        this.stream = stream;
        this.parent = parent;
        this.base = this.stream.pos;
        this._items = [];
    }
    UnboundedArrayAccessor.prototype.getItem = function getItem(index) {
        if (this._items[index] == null) {
            var pos = this.stream.pos;
            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
            this._items[index] = this.type.decode(this.stream, this.parent);
            this.stream.pos = pos;
        }
        return this._items[index];
    };
    UnboundedArrayAccessor.prototype.inspect = function inspect() {
        return '[UnboundedArray ' + this.type.constructor.name + ']';
    };
    return UnboundedArrayAccessor;
}();
var UnboundedArray = function(_r$Array) {
    inherits(UnboundedArray, _r$Array);
    function UnboundedArray(type) {
        classCallCheck(this, UnboundedArray);
        return possibleConstructorReturn(this, _r$Array.call(this, type, 0));
    }
    UnboundedArray.prototype.decode = function decode(stream, parent) {
        return new UnboundedArrayAccessor(this.type, stream, parent);
    };
    return UnboundedArray;
}((0, _restructureDefault.default).Array);
var LookupTable = function LookupTable() {
    var ValueType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _restructureDefault.default).uint16;
    // Helper class that makes internal structures invisible to pointers
    var Shadow = function() {
        function Shadow(type) {
            classCallCheck(this, Shadow);
            this.type = type;
        }
        Shadow.prototype.decode = function decode(stream, ctx) {
            ctx = ctx.parent.parent;
            return this.type.decode(stream, ctx);
        };
        Shadow.prototype.size = function size(val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.size(val, ctx);
        };
        Shadow.prototype.encode = function encode(stream, val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.encode(stream, val, ctx);
        };
        return Shadow;
    }();
    ValueType = new Shadow(ValueType);
    var BinarySearchHeader = new (0, _restructureDefault.default).Struct({
        unitSize: (0, _restructureDefault.default).uint16,
        nUnits: (0, _restructureDefault.default).uint16,
        searchRange: (0, _restructureDefault.default).uint16,
        entrySelector: (0, _restructureDefault.default).uint16,
        rangeShift: (0, _restructureDefault.default).uint16
    });
    var LookupSegmentSingle = new (0, _restructureDefault.default).Struct({
        lastGlyph: (0, _restructureDefault.default).uint16,
        firstGlyph: (0, _restructureDefault.default).uint16,
        value: ValueType
    });
    var LookupSegmentArray = new (0, _restructureDefault.default).Struct({
        lastGlyph: (0, _restructureDefault.default).uint16,
        firstGlyph: (0, _restructureDefault.default).uint16,
        values: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new (0, _restructureDefault.default).Array(ValueType, function(t) {
            return t.lastGlyph - t.firstGlyph + 1;
        }), {
            type: 'parent'
        })
    });
    var LookupSingle = new (0, _restructureDefault.default).Struct({
        glyph: (0, _restructureDefault.default).uint16,
        value: ValueType
    });
    return new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint16, {
        0: {
            values: new UnboundedArray(ValueType) // length == number of glyphs maybe?
        },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new (0, _restructureDefault.default).Array(LookupSegmentSingle, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new (0, _restructureDefault.default).Array(LookupSegmentArray, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new (0, _restructureDefault.default).Array(LookupSingle, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        8: {
            firstGlyph: (0, _restructureDefault.default).uint16,
            count: (0, _restructureDefault.default).uint16,
            values: new (0, _restructureDefault.default).Array(ValueType, 'count')
        }
    });
};
function StateTable() {
    var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _restructureDefault.default).uint16;
    var entry = Object.assign({
        newState: (0, _restructureDefault.default).uint16,
        flags: (0, _restructureDefault.default).uint16
    }, entryData);
    var Entry = new (0, _restructureDefault.default).Struct(entry);
    var StateArray = new UnboundedArray(new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, function(t) {
        return t.nClasses;
    }));
    var StateHeader = new (0, _restructureDefault.default).Struct({
        nClasses: (0, _restructureDefault.default).uint32,
        classTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new LookupTable(lookupType)),
        stateArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, StateArray),
        entryTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new UnboundedArray(Entry))
    });
    return StateHeader;
}
// This is the old version of the StateTable structure
function StateTable1() {
    var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _restructureDefault.default).uint16;
    var ClassLookupTable = new (0, _restructureDefault.default).Struct({
        version: function version() {
            return 8;
        },
        // simulate LookupTable
        firstGlyph: (0, _restructureDefault.default).uint16,
        values: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, (0, _restructureDefault.default).uint16)
    });
    var entry = Object.assign({
        newStateOffset: (0, _restructureDefault.default).uint16,
        // convert offset to stateArray index
        newState: function newState(t) {
            return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
        },
        flags: (0, _restructureDefault.default).uint16
    }, entryData);
    var Entry = new (0, _restructureDefault.default).Struct(entry);
    var StateArray = new UnboundedArray(new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, function(t) {
        return t.nClasses;
    }));
    var StateHeader1 = new (0, _restructureDefault.default).Struct({
        nClasses: (0, _restructureDefault.default).uint16,
        classTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassLookupTable),
        stateArray: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, StateArray),
        entryTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new UnboundedArray(Entry))
    });
    return StateHeader1;
}
var BslnSubtable = new (0, _restructureDefault.default).VersionedStruct('format', {
    0: {
        deltas: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int16, 32)
    },
    1: {
        deltas: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).int16, 32),
        mappingData: new LookupTable((0, _restructureDefault.default).uint16)
    },
    2: {
        standardGlyph: (0, _restructureDefault.default).uint16,
        controlPoints: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 32)
    },
    3: {
        standardGlyph: (0, _restructureDefault.default).uint16,
        controlPoints: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 32),
        mappingData: new LookupTable((0, _restructureDefault.default).uint16)
    }
});
var bsln = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).fixed32,
    format: (0, _restructureDefault.default).uint16,
    defaultBaseline: (0, _restructureDefault.default).uint16,
    subtable: BslnSubtable
});
var Setting = new (0, _restructureDefault.default).Struct({
    setting: (0, _restructureDefault.default).uint16,
    nameIndex: (0, _restructureDefault.default).int16,
    name: function name(t) {
        return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
    }
});
var FeatureName = new (0, _restructureDefault.default).Struct({
    feature: (0, _restructureDefault.default).uint16,
    nSettings: (0, _restructureDefault.default).uint16,
    settingTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array(Setting, 'nSettings'), {
        type: 'parent'
    }),
    featureFlags: new (0, _restructureDefault.default).Bitfield((0, _restructureDefault.default).uint8, [
        null,
        null,
        null,
        null,
        null,
        null,
        'hasDefault',
        'exclusive'
    ]),
    defaultSetting: (0, _restructureDefault.default).uint8,
    nameIndex: (0, _restructureDefault.default).int16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameIndex];
    }
});
var feat = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).fixed32,
    featureNameCount: (0, _restructureDefault.default).uint16,
    reserved1: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
    reserved2: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint32),
    featureNames: new (0, _restructureDefault.default).Array(FeatureName, 'featureNameCount')
});
var Axis$1 = new (0, _restructureDefault.default).Struct({
    axisTag: new (0, _restructureDefault.default).String(4),
    minValue: (0, _restructureDefault.default).fixed32,
    defaultValue: (0, _restructureDefault.default).fixed32,
    maxValue: (0, _restructureDefault.default).fixed32,
    flags: (0, _restructureDefault.default).uint16,
    nameID: (0, _restructureDefault.default).uint16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameID];
    }
});
var Instance = new (0, _restructureDefault.default).Struct({
    nameID: (0, _restructureDefault.default).uint16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameID];
    },
    flags: (0, _restructureDefault.default).uint16,
    coord: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).fixed32, function(t) {
        return t.parent.axisCount;
    }),
    postscriptNameID: new (0, _restructureDefault.default).Optional((0, _restructureDefault.default).uint16, function(t) {
        return t.parent.instanceSize - t._currentOffset > 0;
    })
});
var fvar = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).fixed32,
    offsetToData: (0, _restructureDefault.default).uint16,
    countSizePairs: (0, _restructureDefault.default).uint16,
    axisCount: (0, _restructureDefault.default).uint16,
    axisSize: (0, _restructureDefault.default).uint16,
    instanceCount: (0, _restructureDefault.default).uint16,
    instanceSize: (0, _restructureDefault.default).uint16,
    axis: new (0, _restructureDefault.default).Array(Axis$1, 'axisCount'),
    instance: new (0, _restructureDefault.default).Array(Instance, 'instanceCount')
});
var shortFrac$1 = new (0, _restructureDefault.default).Fixed(16, 'BE', 14);
var Offset = function() {
    function Offset() {
        classCallCheck(this, Offset);
    }
    Offset.decode = function decode(stream, parent) {
        // In short format, offsets are multiplied by 2.
        // This doesn't seem to be documented by Apple, but it
        // is implemented this way in Freetype.
        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
    };
    return Offset;
}();
var gvar = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
    axisCount: (0, _restructureDefault.default).uint16,
    globalCoordCount: (0, _restructureDefault.default).uint16,
    globalCoords: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Array(shortFrac$1, 'axisCount'), 'globalCoordCount')),
    glyphCount: (0, _restructureDefault.default).uint16,
    flags: (0, _restructureDefault.default).uint16,
    offsetToData: (0, _restructureDefault.default).uint32,
    offsets: new (0, _restructureDefault.default).Array(new (0, _restructureDefault.default).Pointer(Offset, 'void', {
        relativeTo: 'offsetToData',
        allowNull: false
    }), function(t) {
        return t.glyphCount + 1;
    })
});
var ClassTable$1 = new (0, _restructureDefault.default).Struct({
    length: (0, _restructureDefault.default).uint16,
    coverage: (0, _restructureDefault.default).uint16,
    subFeatureFlags: (0, _restructureDefault.default).uint32,
    stateTable: new StateTable1()
});
var WidthDeltaRecord = new (0, _restructureDefault.default).Struct({
    justClass: (0, _restructureDefault.default).uint32,
    beforeGrowLimit: (0, _restructureDefault.default).fixed32,
    beforeShrinkLimit: (0, _restructureDefault.default).fixed32,
    afterGrowLimit: (0, _restructureDefault.default).fixed32,
    afterShrinkLimit: (0, _restructureDefault.default).fixed32,
    growFlags: (0, _restructureDefault.default).uint16,
    shrinkFlags: (0, _restructureDefault.default).uint16
});
var WidthDeltaCluster = new (0, _restructureDefault.default).Array(WidthDeltaRecord, (0, _restructureDefault.default).uint32);
var ActionData = new (0, _restructureDefault.default).VersionedStruct('actionType', {
    0: {
        lowerLimit: (0, _restructureDefault.default).fixed32,
        upperLimit: (0, _restructureDefault.default).fixed32,
        order: (0, _restructureDefault.default).uint16,
        glyphs: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, (0, _restructureDefault.default).uint16)
    },
    1: {
        addGlyph: (0, _restructureDefault.default).uint16
    },
    2: {
        substThreshold: (0, _restructureDefault.default).fixed32,
        addGlyph: (0, _restructureDefault.default).uint16,
        substGlyph: (0, _restructureDefault.default).uint16
    },
    3: {},
    4: {
        variationAxis: (0, _restructureDefault.default).uint32,
        minimumLimit: (0, _restructureDefault.default).fixed32,
        noStretchValue: (0, _restructureDefault.default).fixed32,
        maximumLimit: (0, _restructureDefault.default).fixed32
    },
    5: {
        flags: (0, _restructureDefault.default).uint16,
        glyph: (0, _restructureDefault.default).uint16
    }
});
var Action = new (0, _restructureDefault.default).Struct({
    actionClass: (0, _restructureDefault.default).uint16,
    actionType: (0, _restructureDefault.default).uint16,
    actionLength: (0, _restructureDefault.default).uint32,
    actionData: ActionData,
    padding: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8, function(t) {
        return t.actionLength - t._currentOffset;
    })
});
var PostcompensationAction = new (0, _restructureDefault.default).Array(Action, (0, _restructureDefault.default).uint32);
var PostCompensationTable = new (0, _restructureDefault.default).Struct({
    lookupTable: new LookupTable(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, PostcompensationAction))
});
var JustificationTable = new (0, _restructureDefault.default).Struct({
    classTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, ClassTable$1, {
        type: 'parent'
    }),
    wdcOffset: (0, _restructureDefault.default).uint16,
    postCompensationTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, PostCompensationTable, {
        type: 'parent'
    }),
    widthDeltaClusters: new LookupTable(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, WidthDeltaCluster, {
        type: 'parent',
        relativeTo: 'wdcOffset'
    }))
});
var just = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint32,
    format: (0, _restructureDefault.default).uint16,
    horizontal: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JustificationTable),
    vertical: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, JustificationTable)
});
var LigatureData = {
    action: (0, _restructureDefault.default).uint16
};
var ContextualData = {
    markIndex: (0, _restructureDefault.default).uint16,
    currentIndex: (0, _restructureDefault.default).uint16
};
var InsertionData = {
    currentInsertIndex: (0, _restructureDefault.default).uint16,
    markedInsertIndex: (0, _restructureDefault.default).uint16
};
var SubstitutionTable = new (0, _restructureDefault.default).Struct({
    items: new UnboundedArray(new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new LookupTable()))
});
var SubtableData = new (0, _restructureDefault.default).VersionedStruct('type', {
    0: {
        stateTable: new StateTable()
    },
    1: {
        stateTable: new StateTable(ContextualData),
        substitutionTable: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, SubstitutionTable)
    },
    2: {
        stateTable: new StateTable(LigatureData),
        ligatureActions: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new UnboundedArray((0, _restructureDefault.default).uint32)),
        components: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new UnboundedArray((0, _restructureDefault.default).uint16)),
        ligatureList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new UnboundedArray((0, _restructureDefault.default).uint16))
    },
    4: {
        lookupTable: new LookupTable()
    },
    5: {
        stateTable: new StateTable(InsertionData),
        insertionActions: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, new UnboundedArray((0, _restructureDefault.default).uint16))
    }
});
var Subtable = new (0, _restructureDefault.default).Struct({
    length: (0, _restructureDefault.default).uint32,
    coverage: (0, _restructureDefault.default).uint24,
    type: (0, _restructureDefault.default).uint8,
    subFeatureFlags: (0, _restructureDefault.default).uint32,
    table: SubtableData,
    padding: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8, function(t) {
        return t.length - t._currentOffset;
    })
});
var FeatureEntry = new (0, _restructureDefault.default).Struct({
    featureType: (0, _restructureDefault.default).uint16,
    featureSetting: (0, _restructureDefault.default).uint16,
    enableFlags: (0, _restructureDefault.default).uint32,
    disableFlags: (0, _restructureDefault.default).uint32
});
var MorxChain = new (0, _restructureDefault.default).Struct({
    defaultFlags: (0, _restructureDefault.default).uint32,
    chainLength: (0, _restructureDefault.default).uint32,
    nFeatureEntries: (0, _restructureDefault.default).uint32,
    nSubtables: (0, _restructureDefault.default).uint32,
    features: new (0, _restructureDefault.default).Array(FeatureEntry, 'nFeatureEntries'),
    subtables: new (0, _restructureDefault.default).Array(Subtable, 'nSubtables')
});
var morx = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).uint16,
    unused: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
    nChains: (0, _restructureDefault.default).uint32,
    chains: new (0, _restructureDefault.default).Array(MorxChain, 'nChains')
});
var OpticalBounds = new (0, _restructureDefault.default).Struct({
    left: (0, _restructureDefault.default).int16,
    top: (0, _restructureDefault.default).int16,
    right: (0, _restructureDefault.default).int16,
    bottom: (0, _restructureDefault.default).int16
});
var opbd = new (0, _restructureDefault.default).Struct({
    version: (0, _restructureDefault.default).fixed32,
    format: (0, _restructureDefault.default).uint16,
    lookupTable: new LookupTable(OpticalBounds)
});
var tables = {};
// Required Tables
tables.cmap = cmap;
tables.head = head;
tables.hhea = hhea;
tables.hmtx = hmtx;
tables.maxp = maxp;
tables.name = NameTable;
tables['OS/2'] = OS2;
tables.post = post;
// TrueType Outlines
tables.fpgm = fpgm;
tables.loca = loca;
tables.prep = prep;
tables['cvt '] = cvt;
tables.glyf = glyf;
// PostScript Outlines
tables['CFF '] = CFFFont;
tables['CFF2'] = CFFFont;
tables.VORG = VORG;
// Bitmap Glyphs
tables.EBLC = EBLC;
tables.CBLC = tables.EBLC;
tables.sbix = sbix;
tables.COLR = COLR;
tables.CPAL = CPAL;
// Advanced OpenType Tables
tables.BASE = BASE;
tables.GDEF = GDEF;
tables.GPOS = GPOS;
tables.GSUB = GSUB;
tables.JSTF = JSTF;
// OpenType variations tables
tables.HVAR = HVAR;
// Other OpenType Tables
tables.DSIG = DSIG;
tables.gasp = gasp;
tables.hdmx = hdmx;
tables.kern = kern;
tables.LTSH = LTSH;
tables.PCLT = PCLT;
tables.VDMX = VDMX;
tables.vhea = vhea;
tables.vmtx = vmtx;
// Apple Advanced Typography Tables
tables.avar = avar;
tables.bsln = bsln;
tables.feat = feat;
tables.fvar = fvar;
tables.gvar = gvar;
tables.just = just;
tables.morx = morx;
tables.opbd = opbd;
var TableEntry = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    checkSum: (0, _restructureDefault.default).uint32,
    offset: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, 'void', {
        type: 'global'
    }),
    length: (0, _restructureDefault.default).uint32
});
var Directory = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    numTables: (0, _restructureDefault.default).uint16,
    searchRange: (0, _restructureDefault.default).uint16,
    entrySelector: (0, _restructureDefault.default).uint16,
    rangeShift: (0, _restructureDefault.default).uint16,
    tables: new (0, _restructureDefault.default).Array(TableEntry, 'numTables')
});
Directory.process = function() {
    var tables$$1 = {};
    for(var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var table = _ref;
        tables$$1[table.tag] = table;
    }
    this.tables = tables$$1;
};
Directory.preEncode = function(stream) {
    var tables$$1 = [];
    for(var tag in this.tables){
        var table = this.tables[tag];
        if (table) tables$$1.push({
            tag: tag,
            checkSum: 0,
            offset: new (0, _restructureDefault.default).VoidPointer(tables[tag], table),
            length: tables[tag].size(table)
        });
    }
    this.tag = 'true';
    this.numTables = tables$$1.length;
    this.tables = tables$$1;
    this.searchRange = Math.floor(Math.log(this.numTables) / Math.LN2) * 16;
    this.entrySelector = Math.floor(this.searchRange / Math.LN2);
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
function binarySearch(arr, cmp) {
    var min = 0;
    var max = arr.length - 1;
    while(min <= max){
        var mid = min + max >> 1;
        var res = cmp(arr[mid]);
        if (res < 0) max = mid - 1;
        else if (res > 0) min = mid + 1;
        else return mid;
    }
    return -1;
}
function range(index, end) {
    var range = [];
    while(index < end)range.push(index++);
    return range;
}
var _class$1;
function _applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
// iconv-lite is an optional dependency.
try {
    var iconv = require("bb09cce7b0d33d05");
} catch (err) {}
var CmapProcessor = (_class$1 = function() {
    function CmapProcessor(cmapTable) {
        classCallCheck(this, CmapProcessor);
        // Attempt to find a Unicode cmap first
        this.encoding = null;
        this.cmap = this.findSubtable(cmapTable, [
            // 32-bit subtables
            [
                3,
                10
            ],
            [
                0,
                6
            ],
            [
                0,
                4
            ],
            // 16-bit subtables
            [
                3,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                2
            ],
            [
                0,
                1
            ],
            [
                0,
                0
            ]
        ]);
        // If not unicode cmap was found, and iconv-lite is installed,
        // take the first table with a supported encoding.
        if (!this.cmap && iconv) for(var _iterator = cmapTable.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var cmap = _ref;
            var encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
            if (iconv.encodingExists(encoding)) {
                this.cmap = cmap.table;
                this.encoding = encoding;
            }
        }
        if (!this.cmap) throw new Error("Could not find a supported cmap table");
        this.uvs = this.findSubtable(cmapTable, [
            [
                0,
                5
            ]
        ]);
        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
    }
    CmapProcessor.prototype.findSubtable = function findSubtable(cmapTable, pairs) {
        for(var _iterator2 = pairs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var _ref3 = _ref2, platformID = _ref3[0], encodingID = _ref3[1];
            for(var _iterator3 = cmapTable.tables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
                var _ref4;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref4 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref4 = _i3.value;
                }
                var cmap = _ref4;
                if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
            }
        }
        return null;
    };
    CmapProcessor.prototype.lookup = function lookup(codepoint, variationSelector) {
        // If there is no Unicode cmap in this font, we need to re-encode
        // the codepoint in the encoding that the cmap supports.
        if (this.encoding) {
            var buf = iconv.encode(String.fromCodePoint(codepoint), this.encoding);
            codepoint = 0;
            for(var i = 0; i < buf.length; i++)codepoint = codepoint << 8 | buf[i];
        // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
        } else if (variationSelector) {
            var gid = this.getVariationSelector(codepoint, variationSelector);
            if (gid) return gid;
        }
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4:
                var min = 0;
                var max = cmap.segCount - 1;
                while(min <= max){
                    var mid = min + max >> 1;
                    if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                    else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                    else {
                        var rangeOffset = cmap.idRangeOffset.get(mid);
                        var _gid = void 0;
                        if (rangeOffset === 0) _gid = codepoint + cmap.idDelta.get(mid);
                        else {
                            var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                            _gid = cmap.glyphIndexArray.get(index) || 0;
                            if (_gid !== 0) _gid += cmap.idDelta.get(mid);
                        }
                        return _gid & 0xffff;
                    }
                }
                return 0;
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13:
                var _min = 0;
                var _max = cmap.nGroups - 1;
                while(_min <= _max){
                    var _mid = _min + _max >> 1;
                    var group = cmap.groups.get(_mid);
                    if (codepoint < group.startCharCode) _max = _mid - 1;
                    else if (codepoint > group.endCharCode) _min = _mid + 1;
                    else {
                        if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                        else return group.glyphID;
                    }
                }
                return 0;
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error('Unknown cmap format ' + cmap.version);
        }
    };
    CmapProcessor.prototype.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
        if (!this.uvs) return 0;
        var selectors = this.uvs.varSelectors.toArray();
        var i = binarySearch(selectors, function(x) {
            return variationSelector - x.varSelector;
        });
        var sel = selectors[i];
        if (i !== -1 && sel.defaultUVS) i = binarySearch(sel.defaultUVS, function(x) {
            return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0;
        });
        if (i !== -1 && sel.nonDefaultUVS) {
            i = binarySearch(sel.nonDefaultUVS, function(x) {
                return codepoint - x.unicodeValue;
            });
            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
        }
        return 0;
    };
    CmapProcessor.prototype.getCharacterSet = function getCharacterSet() {
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return range(0, cmap.codeMap.length);
            case 4:
                var res = [];
                var endCodes = cmap.endCode.toArray();
                for(var i = 0; i < endCodes.length; i++){
                    var tail = endCodes[i] + 1;
                    var start = cmap.startCode.get(i);
                    res.push.apply(res, range(start, tail));
                }
                return res;
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13:
                var _res = [];
                for(var _iterator4 = cmap.groups.toArray(), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;){
                    var _ref5;
                    if (_isArray4) {
                        if (_i4 >= _iterator4.length) break;
                        _ref5 = _iterator4[_i4++];
                    } else {
                        _i4 = _iterator4.next();
                        if (_i4.done) break;
                        _ref5 = _i4.value;
                    }
                    var group = _ref5;
                    _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
                }
                return _res;
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error('Unknown cmap format ' + cmap.version);
        }
    };
    CmapProcessor.prototype.codePointsForGlyph = function codePointsForGlyph(gid) {
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                var res = [];
                for(var i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                return res;
            case 4:
                var _res2 = [];
                for(var _i5 = 0; _i5 < cmap.segCount; _i5++){
                    var end = cmap.endCode.get(_i5);
                    var start = cmap.startCode.get(_i5);
                    var rangeOffset = cmap.idRangeOffset.get(_i5);
                    var delta = cmap.idDelta.get(_i5);
                    for(var c = start; c <= end; c++){
                        var g = 0;
                        if (rangeOffset === 0) g = c + delta;
                        else {
                            var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i5);
                            g = cmap.glyphIndexArray.get(index) || 0;
                            if (g !== 0) g += delta;
                        }
                        if (g === gid) _res2.push(c);
                    }
                }
                return _res2;
            case 12:
                var _res3 = [];
                for(var _iterator5 = cmap.groups.toArray(), _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;){
                    var _ref6;
                    if (_isArray5) {
                        if (_i6 >= _iterator5.length) break;
                        _ref6 = _iterator5[_i6++];
                    } else {
                        _i6 = _iterator5.next();
                        if (_i6.done) break;
                        _ref6 = _i6.value;
                    }
                    var group = _ref6;
                    if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) _res3.push(group.startCharCode + (gid - group.glyphID));
                }
                return _res3;
            case 13:
                var _res4 = [];
                for(var _iterator6 = cmap.groups.toArray(), _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;){
                    var _ref7;
                    if (_isArray6) {
                        if (_i7 >= _iterator6.length) break;
                        _ref7 = _iterator6[_i7++];
                    } else {
                        _i7 = _iterator6.next();
                        if (_i7.done) break;
                        _ref7 = _i7.value;
                    }
                    var _group = _ref7;
                    if (gid === _group.glyphID) _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
                }
                return _res4;
            default:
                throw new Error('Unknown cmap format ' + cmap.version);
        }
    };
    return CmapProcessor;
}(), _applyDecoratedDescriptor$1(_class$1.prototype, 'getCharacterSet', [
    cache
], Object.getOwnPropertyDescriptor(_class$1.prototype, 'getCharacterSet'), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, 'codePointsForGlyph', [
    cache
], Object.getOwnPropertyDescriptor(_class$1.prototype, 'codePointsForGlyph'), _class$1.prototype), _class$1);
var KernProcessor = function() {
    function KernProcessor(font) {
        classCallCheck(this, KernProcessor);
        this.kern = font.kern;
    }
    KernProcessor.prototype.process = function process(glyphs, positions1) {
        for(var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
            var left = glyphs[glyphIndex].id;
            var right = glyphs[glyphIndex + 1].id;
            positions1[glyphIndex].xAdvance += this.getKerning(left, right);
        }
    };
    KernProcessor.prototype.getKerning = function getKerning(left, right) {
        var res = 0;
        for(var _iterator = this.kern.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var table = _ref;
            if (table.coverage.crossStream) continue;
            switch(table.version){
                case 0:
                    if (!table.coverage.horizontal) continue;
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) continue;
                    break;
                default:
                    throw new Error('Unsupported kerning table version ' + table.version);
            }
            var val = 0;
            var s = table.subtable;
            switch(table.format){
                case 0:
                    var pairIdx = binarySearch(s.pairs, function(pair) {
                        return left - pair.left || right - pair.right;
                    });
                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                    break;
                case 2:
                    var leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    else leftOffset = s.array.off;
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    var index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error('Unsupported kerning sub-table format ' + table.format);
            }
            // Microsoft supports the override flag, which resets the result
            // Otherwise, the sum of the results from all subtables is returned
            if (table.coverage.override) res = val;
            else res += val;
        }
        return res;
    };
    return KernProcessor;
}();
/**
 * This class is used when GPOS does not define 'mark' or 'mkmk' features
 * for positioning marks relative to base glyphs. It uses the unicode
 * combining class property to position marks.
 *
 * Based on code from Harfbuzz, thanks!
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
 */ var UnicodeLayoutEngine = function() {
    function UnicodeLayoutEngine(font) {
        classCallCheck(this, UnicodeLayoutEngine);
        this.font = font;
    }
    UnicodeLayoutEngine.prototype.positionGlyphs = function positionGlyphs(glyphs, positions1) {
        // find each base + mark cluster, and position the marks relative to the base
        var clusterStart = 0;
        var clusterEnd = 0;
        for(var index = 0; index < glyphs.length; index++){
            var glyph = glyphs[index];
            if (glyph.isMark) // TODO: handle ligatures
            clusterEnd = index;
            else {
                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions1, clusterStart, clusterEnd);
                clusterStart = clusterEnd = index;
            }
        }
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions1, clusterStart, clusterEnd);
        return positions1;
    };
    UnicodeLayoutEngine.prototype.positionCluster = function positionCluster(glyphs, positions1, clusterStart, clusterEnd) {
        var base = glyphs[clusterStart];
        var baseBox = base.cbox.copy();
        // adjust bounding box for ligature glyphs
        if (base.codePoints.length > 1) // LTR. TODO: RTL support.
        baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
        var xOffset = -positions1[clusterStart].xAdvance;
        var yOffset = 0;
        var yGap = this.font.unitsPerEm / 16;
        // position each of the mark glyphs relative to the base glyph
        for(var index = clusterStart + 1; index <= clusterEnd; index++){
            var mark = glyphs[index];
            var markBox = mark.cbox;
            var position = positions1[index];
            var combiningClass = this.getCombiningClass(mark.codePoints[0]);
            if (combiningClass !== 'Not_Reordered') {
                position.xOffset = position.yOffset = 0;
                // x positioning
                switch(combiningClass){
                    case 'Double_Above':
                    case 'Double_Below':
                        // LTR. TODO: RTL support.
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case 'Attached_Below_Left':
                    case 'Below_Left':
                    case 'Above_Left':
                        // left align
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case 'Attached_Above_Right':
                    case 'Below_Right':
                    case 'Above_Right':
                        // right align
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        // Attached_Below, Attached_Above, Below, Above, other
                        // center align
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                }
                // y positioning
                switch(combiningClass){
                    case 'Double_Below':
                    case 'Below_Left':
                    case 'Below':
                    case 'Below_Right':
                    case 'Attached_Below_Left':
                    case 'Attached_Below':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') baseBox.minY += yGap;
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case 'Double_Above':
                    case 'Above_Left':
                    case 'Above':
                    case 'Above_Right':
                    case 'Attached_Above':
                    case 'Attached_Above_Right':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') baseBox.maxY += yGap;
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                }
                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
            } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
            }
        }
        return;
    };
    UnicodeLayoutEngine.prototype.getCombiningClass = function getCombiningClass(codePoint) {
        var combiningClass = (0, _unicodePropertiesDefault.default).getCombiningClass(codePoint);
        // Thai / Lao need some per-character work
        if ((codePoint & -256) === 0x0e00) {
            if (combiningClass === 'Not_Reordered') switch(codePoint){
                case 0x0e31:
                case 0x0e34:
                case 0x0e35:
                case 0x0e36:
                case 0x0e37:
                case 0x0e47:
                case 0x0e4c:
                case 0x0e3d:
                case 0x0e4e:
                    return 'Above_Right';
                case 0x0eb1:
                case 0x0eb4:
                case 0x0eb5:
                case 0x0eb6:
                case 0x0eb7:
                case 0x0ebb:
                case 0x0ecc:
                case 0x0ecd:
                    return 'Above';
                case 0x0ebc:
                    return 'Below';
            }
            else if (codePoint === 0x0e3a) // virama
            return 'Below_Right';
        }
        switch(combiningClass){
            // Hebrew
            case 'CCC10':
            case 'CCC11':
            case 'CCC12':
            case 'CCC13':
            case 'CCC14':
            case 'CCC15':
            case 'CCC16':
            case 'CCC17':
            case 'CCC18':
            case 'CCC20':
            case 'CCC22':
                // meteg
                return 'Below';
            case 'CCC23':
                // rafe
                return 'Attached_Above';
            case 'CCC24':
                // shin dot
                return 'Above_Right';
            case 'CCC25':
            case 'CCC19':
                // holam
                return 'Above_Left';
            case 'CCC26':
                // point varika
                return 'Above';
            case 'CCC21':
                break;
            // Arabic and Syriac
            case 'CCC27':
            case 'CCC28':
            case 'CCC30':
            case 'CCC31':
            case 'CCC33':
            case 'CCC34':
            case 'CCC35':
            case 'CCC36':
                // superscript alaph
                return 'Above';
            case 'CCC29':
            case 'CCC32':
                // kasra
                return 'Below';
            // Thai
            case 'CCC103':
                // sara u / sara uu
                return 'Below_Right';
            case 'CCC107':
                // mai
                return 'Above_Right';
            // Lao
            case 'CCC118':
                // sign u / sign uu
                return 'Below';
            case 'CCC122':
                // mai
                return 'Above';
            // Tibetan
            case 'CCC129':
            case 'CCC132':
                // sign u
                return 'Below';
            case 'CCC130':
                // sign i
                return 'Above';
        }
        return combiningClass;
    };
    return UnicodeLayoutEngine;
}();
/**
 * Represents a glyph bounding box
 */ var BBox = function() {
    function BBox() {
        var minX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
        var minY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
        var maxX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -Infinity;
        var maxY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -Infinity;
        classCallCheck(this, BBox);
        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * The width of the bounding box
   * @type {number}
   */ BBox.prototype.addPoint = function addPoint(x, y) {
        if (Math.abs(x) !== Infinity) {
            if (x < this.minX) this.minX = x;
            if (x > this.maxX) this.maxX = x;
        }
        if (Math.abs(y) !== Infinity) {
            if (y < this.minY) this.minY = y;
            if (y > this.maxY) this.maxY = y;
        }
    };
    BBox.prototype.copy = function copy() {
        return new BBox(this.minX, this.minY, this.maxX, this.maxY);
    };
    createClass(BBox, [
        {
            key: "width",
            get: function get$$1() {
                return this.maxX - this.minX;
            }
        },
        {
            key: "height",
            get: function get$$1() {
                return this.maxY - this.minY;
            }
        }
    ]);
    return BBox;
}();
// This maps the Unicode Script property to an OpenType script tag
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
var UNICODE_SCRIPTS = {
    Caucasian_Albanian: 'aghb',
    Arabic: 'arab',
    Imperial_Aramaic: 'armi',
    Armenian: 'armn',
    Avestan: 'avst',
    Balinese: 'bali',
    Bamum: 'bamu',
    Bassa_Vah: 'bass',
    Batak: 'batk',
    Bengali: [
        'bng2',
        'beng'
    ],
    Bopomofo: 'bopo',
    Brahmi: 'brah',
    Braille: 'brai',
    Buginese: 'bugi',
    Buhid: 'buhd',
    Chakma: 'cakm',
    Canadian_Aboriginal: 'cans',
    Carian: 'cari',
    Cham: 'cham',
    Cherokee: 'cher',
    Coptic: 'copt',
    Cypriot: 'cprt',
    Cyrillic: 'cyrl',
    Devanagari: [
        'dev2',
        'deva'
    ],
    Deseret: 'dsrt',
    Duployan: 'dupl',
    Egyptian_Hieroglyphs: 'egyp',
    Elbasan: 'elba',
    Ethiopic: 'ethi',
    Georgian: 'geor',
    Glagolitic: 'glag',
    Gothic: 'goth',
    Grantha: 'gran',
    Greek: 'grek',
    Gujarati: [
        'gjr2',
        'gujr'
    ],
    Gurmukhi: [
        'gur2',
        'guru'
    ],
    Hangul: 'hang',
    Han: 'hani',
    Hanunoo: 'hano',
    Hebrew: 'hebr',
    Hiragana: 'hira',
    Pahawh_Hmong: 'hmng',
    Katakana_Or_Hiragana: 'hrkt',
    Old_Italic: 'ital',
    Javanese: 'java',
    Kayah_Li: 'kali',
    Katakana: 'kana',
    Kharoshthi: 'khar',
    Khmer: 'khmr',
    Khojki: 'khoj',
    Kannada: [
        'knd2',
        'knda'
    ],
    Kaithi: 'kthi',
    Tai_Tham: 'lana',
    Lao: 'lao ',
    Latin: 'latn',
    Lepcha: 'lepc',
    Limbu: 'limb',
    Linear_A: 'lina',
    Linear_B: 'linb',
    Lisu: 'lisu',
    Lycian: 'lyci',
    Lydian: 'lydi',
    Mahajani: 'mahj',
    Mandaic: 'mand',
    Manichaean: 'mani',
    Mende_Kikakui: 'mend',
    Meroitic_Cursive: 'merc',
    Meroitic_Hieroglyphs: 'mero',
    Malayalam: [
        'mlm2',
        'mlym'
    ],
    Modi: 'modi',
    Mongolian: 'mong',
    Mro: 'mroo',
    Meetei_Mayek: 'mtei',
    Myanmar: [
        'mym2',
        'mymr'
    ],
    Old_North_Arabian: 'narb',
    Nabataean: 'nbat',
    Nko: 'nko ',
    Ogham: 'ogam',
    Ol_Chiki: 'olck',
    Old_Turkic: 'orkh',
    Oriya: [
        'ory2',
        'orya'
    ],
    Osmanya: 'osma',
    Palmyrene: 'palm',
    Pau_Cin_Hau: 'pauc',
    Old_Permic: 'perm',
    Phags_Pa: 'phag',
    Inscriptional_Pahlavi: 'phli',
    Psalter_Pahlavi: 'phlp',
    Phoenician: 'phnx',
    Miao: 'plrd',
    Inscriptional_Parthian: 'prti',
    Rejang: 'rjng',
    Runic: 'runr',
    Samaritan: 'samr',
    Old_South_Arabian: 'sarb',
    Saurashtra: 'saur',
    Shavian: 'shaw',
    Sharada: 'shrd',
    Siddham: 'sidd',
    Khudawadi: 'sind',
    Sinhala: 'sinh',
    Sora_Sompeng: 'sora',
    Sundanese: 'sund',
    Syloti_Nagri: 'sylo',
    Syriac: 'syrc',
    Tagbanwa: 'tagb',
    Takri: 'takr',
    Tai_Le: 'tale',
    New_Tai_Lue: 'talu',
    Tamil: [
        'tml2',
        'taml'
    ],
    Tai_Viet: 'tavt',
    Telugu: [
        'tel2',
        'telu'
    ],
    Tifinagh: 'tfng',
    Tagalog: 'tglg',
    Thaana: 'thaa',
    Thai: 'thai',
    Tibetan: 'tibt',
    Tirhuta: 'tirh',
    Ugaritic: 'ugar',
    Vai: 'vai ',
    Warang_Citi: 'wara',
    Old_Persian: 'xpeo',
    Cuneiform: 'xsux',
    Yi: 'yi  ',
    Inherited: 'zinh',
    Common: 'zyyy',
    Unknown: 'zzzz'
};
var OPENTYPE_SCRIPTS = {};
for(var script in UNICODE_SCRIPTS){
    var tag = UNICODE_SCRIPTS[script];
    if (Array.isArray(tag)) for(var _iterator = tag, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var t = _ref;
        OPENTYPE_SCRIPTS[t] = script;
    }
    else OPENTYPE_SCRIPTS[tag] = script;
}
function fromOpenType(tag) {
    return OPENTYPE_SCRIPTS[tag];
}
function forString(string) {
    var len = string.length;
    var idx = 0;
    while(idx < len){
        var code = string.charCodeAt(idx++);
        // Check if this is a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
            var next = string.charCodeAt(idx);
            // Check if this is a low surrogate
            if (0xdc00 <= next && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
            }
        }
        var _script = (0, _unicodePropertiesDefault.default).getScript(code);
        if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') return UNICODE_SCRIPTS[_script];
    }
    return UNICODE_SCRIPTS.Unknown;
}
// The scripts in this map are written from right to left
var RTL = {
    arab: true,
    hebr: true,
    syrc: true,
    thaa: true,
    cprt: true,
    khar: true,
    phnx: true,
    'nko ': true,
    lydi: true,
    avst: true,
    armi: true,
    phli: true,
    prti: true,
    sarb: true,
    orkh: true,
    samr: true,
    mand: true,
    merc: true,
    mero: true,
    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
    mani: true,
    mend: true,
    nbat: true,
    narb: true,
    palm: true,
    phlp: true // Psalter Pahlavi
};
function direction(script) {
    if (RTL[script]) return 'rtl';
    return 'ltr';
}
/**
 * Represents a run of Glyph and GlyphPosition objects.
 * Returned by the font layout method.
 */ var GlyphRun = function() {
    function GlyphRun(glyphs, features, script, language, direction$$1) {
        classCallCheck(this, GlyphRun);
        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
        /**
     * An array of indices to indices in the input string for each glyph
     * @type {number[]}
     */ this.stringIndices = null;
        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction$$1 || direction(script);
        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {};
        // Convert features to an object
        if (Array.isArray(features)) for(var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var tag = _ref;
            this.features[tag] = true;
        }
        else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') this.features = features;
    }
    /**
   * The total advance width of the run.
   * @type {number}
   */ createClass(GlyphRun, [
        {
            key: 'advanceWidth',
            get: function get$$1() {
                var width = 0;
                for(var _iterator2 = this.positions, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var position = _ref2;
                    width += position.xAdvance;
                }
                return width;
            }
        },
        {
            key: 'advanceHeight',
            get: function get$$1() {
                var height = 0;
                for(var _iterator3 = this.positions, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
                    var _ref3;
                    if (_isArray3) {
                        if (_i3 >= _iterator3.length) break;
                        _ref3 = _iterator3[_i3++];
                    } else {
                        _i3 = _iterator3.next();
                        if (_i3.done) break;
                        _ref3 = _i3.value;
                    }
                    var position = _ref3;
                    height += position.yAdvance;
                }
                return height;
            }
        },
        {
            key: 'bbox',
            get: function get$$1() {
                var bbox = new BBox();
                var x = 0;
                var y = 0;
                for(var index = 0; index < this.glyphs.length; index++){
                    var glyph = this.glyphs[index];
                    var p = this.positions[index];
                    var b = glyph.bbox;
                    bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
                    bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
                    x += p.xAdvance;
                    y += p.yAdvance;
                }
                return bbox;
            }
        }
    ]);
    return GlyphRun;
}();
/**
 * Represents positioning information for a glyph in a GlyphRun.
 */ var GlyphPosition = function GlyphPosition() {
    var xAdvance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var yAdvance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var xOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var yOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    classCallCheck(this, GlyphPosition);
    /**
   * The amount to move the virtual pen in the X direction after rendering this glyph.
   * @type {number}
   */ this.xAdvance = xAdvance;
    /**
   * The amount to move the virtual pen in the Y direction after rendering this glyph.
   * @type {number}
   */ this.yAdvance = yAdvance;
    /**
   * The offset from the pen position in the X direction at which to render this glyph.
   * @type {number}
   */ this.xOffset = xOffset;
    /**
   * The offset from the pen position in the Y direction at which to render this glyph.
   * @type {number}
   */ this.yOffset = yOffset;
};
// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
var features = {
    allTypographicFeatures: {
        code: 0,
        exclusive: false,
        allTypeFeatures: 0
    },
    ligatures: {
        code: 1,
        exclusive: false,
        requiredLigatures: 0,
        commonLigatures: 2,
        rareLigatures: 4,
        // logos: 6
        rebusPictures: 8,
        diphthongLigatures: 10,
        squaredLigatures: 12,
        abbrevSquaredLigatures: 14,
        symbolLigatures: 16,
        contextualLigatures: 18,
        historicalLigatures: 20
    },
    cursiveConnection: {
        code: 2,
        exclusive: true,
        unconnected: 0,
        partiallyConnected: 1,
        cursive: 2
    },
    letterCase: {
        code: 3,
        exclusive: true
    },
    // upperAndLowerCase: 0          # deprecated
    // allCaps: 1                    # deprecated
    // allLowerCase: 2               # deprecated
    // smallCaps: 3                  # deprecated
    // initialCaps: 4                # deprecated
    // initialCapsAndSmallCaps: 5    # deprecated
    verticalSubstitution: {
        code: 4,
        exclusive: false,
        substituteVerticalForms: 0
    },
    linguisticRearrangement: {
        code: 5,
        exclusive: false,
        linguisticRearrangement: 0
    },
    numberSpacing: {
        code: 6,
        exclusive: true,
        monospacedNumbers: 0,
        proportionalNumbers: 1,
        thirdWidthNumbers: 2,
        quarterWidthNumbers: 3
    },
    smartSwash: {
        code: 8,
        exclusive: false,
        wordInitialSwashes: 0,
        wordFinalSwashes: 2,
        // lineInitialSwashes: 4
        // lineFinalSwashes: 6
        nonFinalSwashes: 8
    },
    diacritics: {
        code: 9,
        exclusive: true,
        showDiacritics: 0,
        hideDiacritics: 1,
        decomposeDiacritics: 2
    },
    verticalPosition: {
        code: 10,
        exclusive: true,
        normalPosition: 0,
        superiors: 1,
        inferiors: 2,
        ordinals: 3,
        scientificInferiors: 4
    },
    fractions: {
        code: 11,
        exclusive: true,
        noFractions: 0,
        verticalFractions: 1,
        diagonalFractions: 2
    },
    overlappingCharacters: {
        code: 13,
        exclusive: false,
        preventOverlap: 0
    },
    typographicExtras: {
        code: 14,
        exclusive: false,
        // hyphensToEmDash: 0
        // hyphenToEnDash: 2
        slashedZero: 4
    },
    // formInterrobang: 6
    // smartQuotes: 8
    // periodsToEllipsis: 10
    mathematicalExtras: {
        code: 15,
        exclusive: false,
        // hyphenToMinus: 0
        // asteristoMultiply: 2
        // slashToDivide: 4
        // inequalityLigatures: 6
        // exponents: 8
        mathematicalGreek: 10
    },
    ornamentSets: {
        code: 16,
        exclusive: true,
        noOrnaments: 0,
        dingbats: 1,
        piCharacters: 2,
        fleurons: 3,
        decorativeBorders: 4,
        internationalSymbols: 5,
        mathSymbols: 6
    },
    characterAlternatives: {
        code: 17,
        exclusive: true,
        noAlternates: 0
    },
    // user defined options
    designComplexity: {
        code: 18,
        exclusive: true,
        designLevel1: 0,
        designLevel2: 1,
        designLevel3: 2,
        designLevel4: 3,
        designLevel5: 4
    },
    styleOptions: {
        code: 19,
        exclusive: true,
        noStyleOptions: 0,
        displayText: 1,
        engravedText: 2,
        illuminatedCaps: 3,
        titlingCaps: 4,
        tallCaps: 5
    },
    characterShape: {
        code: 20,
        exclusive: true,
        traditionalCharacters: 0,
        simplifiedCharacters: 1,
        JIS1978Characters: 2,
        JIS1983Characters: 3,
        JIS1990Characters: 4,
        traditionalAltOne: 5,
        traditionalAltTwo: 6,
        traditionalAltThree: 7,
        traditionalAltFour: 8,
        traditionalAltFive: 9,
        expertCharacters: 10,
        JIS2004Characters: 11,
        hojoCharacters: 12,
        NLCCharacters: 13,
        traditionalNamesCharacters: 14
    },
    numberCase: {
        code: 21,
        exclusive: true,
        lowerCaseNumbers: 0,
        upperCaseNumbers: 1
    },
    textSpacing: {
        code: 22,
        exclusive: true,
        proportionalText: 0,
        monospacedText: 1,
        halfWidthText: 2,
        thirdWidthText: 3,
        quarterWidthText: 4,
        altProportionalText: 5,
        altHalfWidthText: 6
    },
    transliteration: {
        code: 23,
        exclusive: true,
        noTransliteration: 0
    },
    // hanjaToHangul: 1
    // hiraganaToKatakana: 2
    // katakanaToHiragana: 3
    // kanaToRomanization: 4
    // romanizationToHiragana: 5
    // romanizationToKatakana: 6
    // hanjaToHangulAltOne: 7
    // hanjaToHangulAltTwo: 8
    // hanjaToHangulAltThree: 9
    annotation: {
        code: 24,
        exclusive: true,
        noAnnotation: 0,
        boxAnnotation: 1,
        roundedBoxAnnotation: 2,
        circleAnnotation: 3,
        invertedCircleAnnotation: 4,
        parenthesisAnnotation: 5,
        periodAnnotation: 6,
        romanNumeralAnnotation: 7,
        diamondAnnotation: 8,
        invertedBoxAnnotation: 9,
        invertedRoundedBoxAnnotation: 10
    },
    kanaSpacing: {
        code: 25,
        exclusive: true,
        fullWidthKana: 0,
        proportionalKana: 1
    },
    ideographicSpacing: {
        code: 26,
        exclusive: true,
        fullWidthIdeographs: 0,
        proportionalIdeographs: 1,
        halfWidthIdeographs: 2
    },
    unicodeDecomposition: {
        code: 27,
        exclusive: false,
        canonicalComposition: 0,
        compatibilityComposition: 2,
        transcodingComposition: 4
    },
    rubyKana: {
        code: 28,
        exclusive: false,
        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
        // rubyKana: 1     # deprecated - use rubyKanaOn instead
        rubyKana: 2
    },
    CJKSymbolAlternatives: {
        code: 29,
        exclusive: true,
        noCJKSymbolAlternatives: 0,
        CJKSymbolAltOne: 1,
        CJKSymbolAltTwo: 2,
        CJKSymbolAltThree: 3,
        CJKSymbolAltFour: 4,
        CJKSymbolAltFive: 5
    },
    ideographicAlternatives: {
        code: 30,
        exclusive: true,
        noIdeographicAlternatives: 0,
        ideographicAltOne: 1,
        ideographicAltTwo: 2,
        ideographicAltThree: 3,
        ideographicAltFour: 4,
        ideographicAltFive: 5
    },
    CJKVerticalRomanPlacement: {
        code: 31,
        exclusive: true,
        CJKVerticalRomanCentered: 0,
        CJKVerticalRomanHBaseline: 1
    },
    italicCJKRoman: {
        code: 32,
        exclusive: false,
        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
        CJKItalicRoman: 2
    },
    caseSensitiveLayout: {
        code: 33,
        exclusive: false,
        caseSensitiveLayout: 0,
        caseSensitiveSpacing: 2
    },
    alternateKana: {
        code: 34,
        exclusive: false,
        alternateHorizKana: 0,
        alternateVertKana: 2
    },
    stylisticAlternatives: {
        code: 35,
        exclusive: false,
        noStylisticAlternates: 0,
        stylisticAltOne: 2,
        stylisticAltTwo: 4,
        stylisticAltThree: 6,
        stylisticAltFour: 8,
        stylisticAltFive: 10,
        stylisticAltSix: 12,
        stylisticAltSeven: 14,
        stylisticAltEight: 16,
        stylisticAltNine: 18,
        stylisticAltTen: 20,
        stylisticAltEleven: 22,
        stylisticAltTwelve: 24,
        stylisticAltThirteen: 26,
        stylisticAltFourteen: 28,
        stylisticAltFifteen: 30,
        stylisticAltSixteen: 32,
        stylisticAltSeventeen: 34,
        stylisticAltEighteen: 36,
        stylisticAltNineteen: 38,
        stylisticAltTwenty: 40
    },
    contextualAlternates: {
        code: 36,
        exclusive: false,
        contextualAlternates: 0,
        swashAlternates: 2,
        contextualSwashAlternates: 4
    },
    lowerCase: {
        code: 37,
        exclusive: true,
        defaultLowerCase: 0,
        lowerCaseSmallCaps: 1,
        lowerCasePetiteCaps: 2
    },
    upperCase: {
        code: 38,
        exclusive: true,
        defaultUpperCase: 0,
        upperCaseSmallCaps: 1,
        upperCasePetiteCaps: 2
    },
    languageTag: {
        code: 39,
        exclusive: true
    },
    CJKRomanSpacing: {
        code: 103,
        exclusive: true,
        halfWidthCJKRoman: 0,
        proportionalCJKRoman: 1,
        defaultCJKRoman: 2,
        fullWidthCJKRoman: 3
    }
};
var feature = function feature(name, selector) {
    return [
        features[name].code,
        features[name][selector]
    ];
};
var OTMapping = {
    rlig: feature('ligatures', 'requiredLigatures'),
    clig: feature('ligatures', 'contextualLigatures'),
    dlig: feature('ligatures', 'rareLigatures'),
    hlig: feature('ligatures', 'historicalLigatures'),
    liga: feature('ligatures', 'commonLigatures'),
    hist: feature('ligatures', 'historicalLigatures'),
    smcp: feature('lowerCase', 'lowerCaseSmallCaps'),
    pcap: feature('lowerCase', 'lowerCasePetiteCaps'),
    frac: feature('fractions', 'diagonalFractions'),
    dnom: feature('fractions', 'diagonalFractions'),
    numr: feature('fractions', 'diagonalFractions'),
    afrc: feature('fractions', 'verticalFractions'),
    // aalt
    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
    // unic, vatu, vhal, vjmo, vpal, vrt2
    // dist -> trak table?
    // kern, vkrn -> kern table
    // lfbd + opbd + rtbd -> opbd table?
    // mark, mkmk -> acnt table?
    // locl -> languageTag + ltag table
    case: feature('caseSensitiveLayout', 'caseSensitiveLayout'),
    ccmp: feature('unicodeDecomposition', 'canonicalComposition'),
    cpct: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    valt: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    swsh: feature('contextualAlternates', 'swashAlternates'),
    cswh: feature('contextualAlternates', 'contextualSwashAlternates'),
    curs: feature('cursiveConnection', 'cursive'),
    c2pc: feature('upperCase', 'upperCasePetiteCaps'),
    c2sc: feature('upperCase', 'upperCaseSmallCaps'),
    init: feature('smartSwash', 'wordInitialSwashes'),
    fin2: feature('smartSwash', 'wordFinalSwashes'),
    medi: feature('smartSwash', 'nonFinalSwashes'),
    med2: feature('smartSwash', 'nonFinalSwashes'),
    fin3: feature('smartSwash', 'wordFinalSwashes'),
    fina: feature('smartSwash', 'wordFinalSwashes'),
    pkna: feature('kanaSpacing', 'proportionalKana'),
    half: feature('textSpacing', 'halfWidthText'),
    halt: feature('textSpacing', 'altHalfWidthText'),
    hkna: feature('alternateKana', 'alternateHorizKana'),
    vkna: feature('alternateKana', 'alternateVertKana'),
    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
    ital: feature('italicCJKRoman', 'CJKItalicRoman'),
    lnum: feature('numberCase', 'upperCaseNumbers'),
    onum: feature('numberCase', 'lowerCaseNumbers'),
    mgrk: feature('mathematicalExtras', 'mathematicalGreek'),
    // nalt: not enough info. what type of annotation?
    // ornm: ditto, which ornament style?
    calt: feature('contextualAlternates', 'contextualAlternates'),
    vrt2: feature('verticalSubstitution', 'substituteVerticalForms'),
    vert: feature('verticalSubstitution', 'substituteVerticalForms'),
    tnum: feature('numberSpacing', 'monospacedNumbers'),
    pnum: feature('numberSpacing', 'proportionalNumbers'),
    sups: feature('verticalPosition', 'superiors'),
    subs: feature('verticalPosition', 'inferiors'),
    ordn: feature('verticalPosition', 'ordinals'),
    pwid: feature('textSpacing', 'proportionalText'),
    hwid: feature('textSpacing', 'halfWidthText'),
    qwid: feature('textSpacing', 'quarterWidthText'),
    twid: feature('textSpacing', 'thirdWidthText'),
    fwid: feature('textSpacing', 'proportionalText'),
    palt: feature('textSpacing', 'altProportionalText'),
    trad: feature('characterShape', 'traditionalCharacters'),
    smpl: feature('characterShape', 'simplifiedCharacters'),
    jp78: feature('characterShape', 'JIS1978Characters'),
    jp83: feature('characterShape', 'JIS1983Characters'),
    jp90: feature('characterShape', 'JIS1990Characters'),
    jp04: feature('characterShape', 'JIS2004Characters'),
    expt: feature('characterShape', 'expertCharacters'),
    hojo: feature('characterShape', 'hojoCharacters'),
    nlck: feature('characterShape', 'NLCCharacters'),
    tnam: feature('characterShape', 'traditionalNamesCharacters'),
    ruby: feature('rubyKana', 'rubyKana'),
    titl: feature('styleOptions', 'titlingCaps'),
    zero: feature('typographicExtras', 'slashedZero'),
    ss01: feature('stylisticAlternatives', 'stylisticAltOne'),
    ss02: feature('stylisticAlternatives', 'stylisticAltTwo'),
    ss03: feature('stylisticAlternatives', 'stylisticAltThree'),
    ss04: feature('stylisticAlternatives', 'stylisticAltFour'),
    ss05: feature('stylisticAlternatives', 'stylisticAltFive'),
    ss06: feature('stylisticAlternatives', 'stylisticAltSix'),
    ss07: feature('stylisticAlternatives', 'stylisticAltSeven'),
    ss08: feature('stylisticAlternatives', 'stylisticAltEight'),
    ss09: feature('stylisticAlternatives', 'stylisticAltNine'),
    ss10: feature('stylisticAlternatives', 'stylisticAltTen'),
    ss11: feature('stylisticAlternatives', 'stylisticAltEleven'),
    ss12: feature('stylisticAlternatives', 'stylisticAltTwelve'),
    ss13: feature('stylisticAlternatives', 'stylisticAltThirteen'),
    ss14: feature('stylisticAlternatives', 'stylisticAltFourteen'),
    ss15: feature('stylisticAlternatives', 'stylisticAltFifteen'),
    ss16: feature('stylisticAlternatives', 'stylisticAltSixteen'),
    ss17: feature('stylisticAlternatives', 'stylisticAltSeventeen'),
    ss18: feature('stylisticAlternatives', 'stylisticAltEighteen'),
    ss19: feature('stylisticAlternatives', 'stylisticAltNineteen'),
    ss20: feature('stylisticAlternatives', 'stylisticAltTwenty')
};
// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
// Add cv01-cv99 features
for(var i = 1; i <= 99; i++)OTMapping['cv' + ('00' + i).slice(-2)] = [
    features.characterAlternatives.code,
    i
];
// create inverse mapping
var AATMapping = {};
for(var ot in OTMapping){
    var aat = OTMapping[ot];
    if (AATMapping[aat[0]] == null) AATMapping[aat[0]] = {};
    AATMapping[aat[0]][aat[1]] = ot;
}
// Maps an array of OpenType features to AAT features
// in the form of {featureType:{featureSetting:true}}
function mapOTToAAT(features) {
    var res = {};
    for(var k in features){
        var r$$1 = void 0;
        if (r$$1 = OTMapping[k]) {
            if (res[r$$1[0]] == null) res[r$$1[0]] = {};
            res[r$$1[0]][r$$1[1]] = features[k];
        }
    }
    return res;
}
// Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function mapFeatureStrings(f) {
    var type = f[0], setting = f[1];
    if (isNaN(type)) var typeCode = features[type] && features[type].code;
    else var typeCode = type;
    if (isNaN(setting)) var settingCode = features[type] && features[type][setting];
    else var settingCode = setting;
    return [
        typeCode,
        settingCode
    ];
}
// Maps AAT features to an array of OpenType features
// Supports both arrays in the form of [[featureType, featureSetting]]
// and objects in the form of {featureType:{featureSetting:true}}
// featureTypes and featureSettings can be either strings or number codes
function mapAATToOT(features) {
    var res = {};
    if (Array.isArray(features)) for(var k = 0; k < features.length; k++){
        var r$$1 = void 0;
        var f = mapFeatureStrings(features[k]);
        if (r$$1 = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) res[r$$1] = true;
    }
    else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') for(var type in features){
        var _feature = features[type];
        for(var setting in _feature){
            var _r = void 0;
            var _f = mapFeatureStrings([
                type,
                setting
            ]);
            if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) res[_r] = true;
        }
    }
    return Object.keys(res);
}
var _class$3;
function _applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
var AATLookupTable = (_class$3 = function() {
    function AATLookupTable(table) {
        classCallCheck(this, AATLookupTable);
        this.table = table;
    }
    AATLookupTable.prototype.lookup = function lookup(glyph) {
        switch(this.table.version){
            case 0:
                // simple array format
                return this.table.values.getItem(glyph);
            case 2:
            case 4:
                var min = 0;
                var max = this.table.binarySearchHeader.nUnits - 1;
                while(min <= max){
                    var mid = min + max >> 1;
                    var seg = this.table.segments[mid];
                    // special end of search value
                    if (seg.firstGlyph === 0xffff) return null;
                    if (glyph < seg.firstGlyph) max = mid - 1;
                    else if (glyph > seg.lastGlyph) min = mid + 1;
                    else {
                        if (this.table.version === 2) return seg.value;
                        else return seg.values[glyph - seg.firstGlyph];
                    }
                }
                return null;
            case 6:
                // lookup single
                var _min = 0;
                var _max = this.table.binarySearchHeader.nUnits - 1;
                while(_min <= _max){
                    var mid = _min + _max >> 1;
                    var seg = this.table.segments[mid];
                    // special end of search value
                    if (seg.glyph === 0xffff) return null;
                    if (glyph < seg.glyph) _max = mid - 1;
                    else if (glyph > seg.glyph) _min = mid + 1;
                    else return seg.value;
                }
                return null;
            case 8:
                // lookup trimmed
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error('Unknown lookup table format: ' + this.table.version);
        }
    };
    AATLookupTable.prototype.glyphsForValue = function glyphsForValue(classValue) {
        var res = [];
        switch(this.table.version){
            case 2:
            case 4:
                for(var _iterator = this.table.segments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var segment = _ref;
                    if (this.table.version === 2 && segment.value === classValue) res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
                    else {
                        for(var index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                    }
                }
                break;
            case 6:
                // lookup single
                for(var _iterator2 = this.table.segments, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var _segment = _ref2;
                    if (_segment.value === classValue) res.push(_segment.glyph);
                }
                break;
            case 8:
                // lookup trimmed
                for(var i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                break;
            default:
                throw new Error('Unknown lookup table format: ' + this.table.version);
        }
        return res;
    };
    return AATLookupTable;
}(), _applyDecoratedDescriptor$3(_class$3.prototype, 'glyphsForValue', [
    cache
], Object.getOwnPropertyDescriptor(_class$3.prototype, 'glyphsForValue'), _class$3.prototype), _class$3);
var START_OF_TEXT_STATE = 0;
var END_OF_TEXT_CLASS = 0;
var OUT_OF_BOUNDS_CLASS = 1;
var DELETED_GLYPH_CLASS = 2;
var DONT_ADVANCE = 0x4000;
var AATStateMachine = function() {
    function AATStateMachine(stateTable) {
        classCallCheck(this, AATStateMachine);
        this.stateTable = stateTable;
        this.lookupTable = new AATLookupTable(stateTable.classTable);
    }
    AATStateMachine.prototype.process = function process(glyphs, reverse, processEntry) {
        var currentState = START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
        var index = reverse ? glyphs.length - 1 : 0;
        var dir = reverse ? -1 : 1;
        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
            var glyph = null;
            var classCode = OUT_OF_BOUNDS_CLASS;
            var shouldAdvance = true;
            if (index === glyphs.length || index === -1) classCode = END_OF_TEXT_CLASS;
            else {
                glyph = glyphs[index];
                if (glyph.id === 0xffff) // deleted glyph
                classCode = DELETED_GLYPH_CLASS;
                else {
                    classCode = this.lookupTable.lookup(glyph.id);
                    if (classCode == null) classCode = OUT_OF_BOUNDS_CLASS;
                }
            }
            var row = this.stateTable.stateArray.getItem(currentState);
            var entryIndex = row[classCode];
            var entry = this.stateTable.entryTable.getItem(entryIndex);
            if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & DONT_ADVANCE);
            }
            currentState = entry.newState;
            if (shouldAdvance) index += dir;
        }
        return glyphs;
    };
    /**
   * Performs a depth-first traversal of the glyph strings
   * represented by the state machine.
   */ AATStateMachine.prototype.traverse = function traverse(opts) {
        var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Set();
        if (visited.has(state)) return;
        visited.add(state);
        var _stateTable = this.stateTable, nClasses = _stateTable.nClasses, stateArray = _stateTable.stateArray, entryTable = _stateTable.entryTable;
        var row = stateArray.getItem(state);
        // Skip predefined classes
        for(var classCode = 4; classCode < nClasses; classCode++){
            var entryIndex = row[classCode];
            var entry = entryTable.getItem(entryIndex);
            // Try all glyphs in the class
            for(var _iterator = this.lookupTable.glyphsForValue(classCode), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }
                var glyph = _ref;
                if (opts.enter) opts.enter(glyph, entry);
                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                if (opts.exit) opts.exit(glyph, entry);
            }
        }
    };
    return AATStateMachine;
}();
var _class$2;
function _applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
// indic replacement flags
var MARK_FIRST = 0x8000;
var MARK_LAST = 0x2000;
var VERB = 0x000f;
// contextual substitution and glyph insertion flag
var SET_MARK = 0x8000;
// ligature entry flags
var SET_COMPONENT = 0x8000;
var PERFORM_ACTION = 0x2000;
// ligature action masks
var LAST_MASK = 0x80000000;
var STORE_MASK = 0x40000000;
var OFFSET_MASK = 0x3fffffff;
var REVERSE_DIRECTION = 0x400000;
var CURRENT_INSERT_BEFORE = 0x0800;
var MARKED_INSERT_BEFORE = 0x0400;
var CURRENT_INSERT_COUNT = 0x03e0;
var MARKED_INSERT_COUNT = 0x001f;
var AATMorxProcessor = (_class$2 = function() {
    function AATMorxProcessor(font) {
        classCallCheck(this, AATMorxProcessor);
        this.processIndicRearragement = this.processIndicRearragement.bind(this);
        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
        this.processLigature = this.processLigature.bind(this);
        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
        this.font = font;
        this.morx = font.morx;
        this.inputCache = null;
    }
    // Processes an array of glyphs and applies the specified features
    // Features should be in the form of {featureType:{featureSetting:true}}
    AATMorxProcessor.prototype.process = function process(glyphs) {
        var features = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        for(var _iterator = this.morx.chains, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var chain = _ref;
            var flags = chain.defaultFlags;
            // enable/disable the requested features
            for(var _iterator2 = chain.features, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref2 = _i2.value;
                }
                var feature = _ref2;
                var f = void 0;
                if ((f = features[feature.featureType]) && f[feature.featureSetting]) {
                    flags &= feature.disableFlags;
                    flags |= feature.enableFlags;
                }
            }
            for(var _iterator3 = chain.subtables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
                var _ref3;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }
                var subtable = _ref3;
                if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
            }
        }
        // remove deleted glyphs
        var index = glyphs.length - 1;
        while(index >= 0){
            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
            index--;
        }
        return glyphs;
    };
    AATMorxProcessor.prototype.processSubtable = function processSubtable(subtable, glyphs) {
        this.subtable = subtable;
        this.glyphs = glyphs;
        if (this.subtable.type === 4) {
            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
            return;
        }
        this.ligatureStack = [];
        this.markedGlyph = null;
        this.firstGlyph = null;
        this.lastGlyph = null;
        this.markedIndex = null;
        var stateMachine = this.getStateMachine(subtable);
        var process = this.getProcessor();
        var reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
        return stateMachine.process(this.glyphs, reverse, process);
    };
    AATMorxProcessor.prototype.getStateMachine = function getStateMachine(subtable) {
        return new AATStateMachine(subtable.table.stateTable);
    };
    AATMorxProcessor.prototype.getProcessor = function getProcessor() {
        switch(this.subtable.type){
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error('Invalid morx subtable type: ' + this.subtable.type);
        }
    };
    AATMorxProcessor.prototype.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
        if (entry.flags & MARK_FIRST) this.firstGlyph = index;
        if (entry.flags & MARK_LAST) this.lastGlyph = index;
        reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
    };
    AATMorxProcessor.prototype.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
        var subsitutions = this.subtable.table.substitutionTable.items;
        if (entry.markIndex !== 0xffff) {
            var lookup = subsitutions.getItem(entry.markIndex);
            var lookupTable = new AATLookupTable(lookup);
            glyph = this.glyphs[this.markedGlyph];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.currentIndex !== 0xffff) {
            var _lookup = subsitutions.getItem(entry.currentIndex);
            var _lookupTable = new AATLookupTable(_lookup);
            glyph = this.glyphs[index];
            var gid = _lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.flags & SET_MARK) this.markedGlyph = index;
    };
    AATMorxProcessor.prototype.processLigature = function processLigature(glyph, entry, index) {
        if (entry.flags & SET_COMPONENT) this.ligatureStack.push(index);
        if (entry.flags & PERFORM_ACTION) {
            var _ligatureStack;
            var actions = this.subtable.table.ligatureActions;
            var components = this.subtable.table.components;
            var ligatureList = this.subtable.table.ligatureList;
            var actionIndex = entry.action;
            var last = false;
            var ligatureIndex = 0;
            var codePoints = [];
            var ligatureGlyphs = [];
            while(!last){
                var _codePoints;
                var componentGlyph = this.ligatureStack.pop();
                (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);
                var action = actions.getItem(actionIndex++);
                last = !!(action & LAST_MASK);
                var store = !!(action & STORE_MASK);
                var offset = (action & OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                offset += this.glyphs[componentGlyph].id;
                var component = components.getItem(offset);
                ligatureIndex += component;
                if (last || store) {
                    var ligatureEntry = ligatureList.getItem(ligatureIndex);
                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                    ligatureGlyphs.push(componentGlyph);
                    ligatureIndex = 0;
                    codePoints = [];
                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
            }
            // Put ligature glyph indexes back on the stack
            (_ligatureStack = this.ligatureStack).push.apply(_ligatureStack, ligatureGlyphs);
        }
    };
    AATMorxProcessor.prototype.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
        var lookupTable = new AATLookupTable(subtable.table.lookupTable);
        for(index = 0; index < glyphs.length; index++){
            var glyph = glyphs[index];
            if (glyph.id !== 0xffff) {
                var gid = lookupTable.lookup(glyph.id);
                if (gid) // 0 means do nothing
                glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
            }
        }
    };
    AATMorxProcessor.prototype._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
        var _glyphs;
        var stringIndex = this.glyphs[glyphIndex].stringIndex;
        var insertions = [];
        while(count--){
            var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
            insertions.push(this.font.getGlyph(gid));
        }
        if (!isBefore) glyphIndex++;
        (_glyphs = this.glyphs).splice.apply(_glyphs, [
            glyphIndex,
            0
        ].concat(insertions));
    };
    AATMorxProcessor.prototype.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
        if (entry.flags & SET_MARK) this.markedIndex = index;
        if (entry.markedInsertIndex !== 0xffff) {
            var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
            var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
        }
        if (entry.currentInsertIndex !== 0xffff) {
            var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
            var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
            this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
        }
    };
    AATMorxProcessor.prototype.getSupportedFeatures = function getSupportedFeatures() {
        var features = [];
        for(var _iterator4 = this.morx.chains, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;){
            var _ref4;
            if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                _ref4 = _iterator4[_i4++];
            } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                _ref4 = _i4.value;
            }
            var chain = _ref4;
            for(var _iterator5 = chain.features, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;){
                var _ref5;
                if (_isArray5) {
                    if (_i5 >= _iterator5.length) break;
                    _ref5 = _iterator5[_i5++];
                } else {
                    _i5 = _iterator5.next();
                    if (_i5.done) break;
                    _ref5 = _i5.value;
                }
                var feature = _ref5;
                features.push([
                    feature.featureType,
                    feature.featureSetting
                ]);
            }
        }
        return features;
    };
    AATMorxProcessor.prototype.generateInputs = function generateInputs(gid) {
        if (!this.inputCache) this.generateInputCache();
        return this.inputCache[gid] || [];
    };
    AATMorxProcessor.prototype.generateInputCache = function generateInputCache() {
        this.inputCache = {};
        for(var _iterator6 = this.morx.chains, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;){
            var _ref6;
            if (_isArray6) {
                if (_i6 >= _iterator6.length) break;
                _ref6 = _iterator6[_i6++];
            } else {
                _i6 = _iterator6.next();
                if (_i6.done) break;
                _ref6 = _i6.value;
            }
            var chain = _ref6;
            var flags = chain.defaultFlags;
            for(var _iterator7 = chain.subtables, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;){
                var _ref7;
                if (_isArray7) {
                    if (_i7 >= _iterator7.length) break;
                    _ref7 = _iterator7[_i7++];
                } else {
                    _i7 = _iterator7.next();
                    if (_i7.done) break;
                    _ref7 = _i7.value;
                }
                var subtable = _ref7;
                if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
            }
        }
    };
    AATMorxProcessor.prototype.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
        var _this = this;
        // Currently, only supporting ligature subtables.
        if (subtable.type !== 2) return;
        var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
        if (reverse) throw new Error('Reverse subtable, not supported.');
        this.subtable = subtable;
        this.ligatureStack = [];
        var stateMachine = this.getStateMachine(subtable);
        var process = this.getProcessor();
        var input = [];
        var stack = [];
        this.glyphs = [];
        stateMachine.traverse({
            enter: function enter(glyph, entry) {
                var glyphs = _this.glyphs;
                stack.push({
                    glyphs: glyphs.slice(),
                    ligatureStack: _this.ligatureStack.slice()
                });
                // Add glyph to input and glyphs to process.
                var g = _this.font.getGlyph(glyph);
                input.push(g);
                glyphs.push(input[input.length - 1]);
                // Process ligature substitution
                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);
                // Add input to result if only one matching (non-deleted) glyph remains.
                var count = 0;
                var found = 0;
                for(var i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                }
                if (count === 1) {
                    var result = input.map(function(g) {
                        return g.id;
                    });
                    var _cache = _this.inputCache[found];
                    if (_cache) _cache.push(result);
                    else _this.inputCache[found] = [
                        result
                    ];
                }
            },
            exit: function exit() {
                var _stack$pop = stack.pop();
                _this.glyphs = _stack$pop.glyphs;
                _this.ligatureStack = _stack$pop.ligatureStack;
                input.pop();
            }
        });
    };
    return AATMorxProcessor;
}(), _applyDecoratedDescriptor$2(_class$2.prototype, 'getStateMachine', [
    cache
], Object.getOwnPropertyDescriptor(_class$2.prototype, 'getStateMachine'), _class$2.prototype), _class$2);
function swap(glyphs, rangeA, rangeB) {
    var reverseA = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var reverseB = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) end.reverse();
    var start = glyphs.splice.apply(glyphs, [
        rangeA[0],
        rangeA[1]
    ].concat(end));
    if (reverseA) start.reverse();
    glyphs.splice.apply(glyphs, [
        rangeB[0] - (rangeA[1] - 1),
        0
    ].concat(start));
    return glyphs;
}
function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    switch(verb){
        case 0:
            // no change
            return glyphs;
        case 1:
            // Ax => xA
            return swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                0
            ]);
        case 2:
            // xD => Dx
            return swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                1
            ]);
        case 3:
            // AxD => DxA
            return swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                1
            ]);
        case 4:
            // ABx => xAB
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ]);
        case 5:
            // ABx => xBA
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ], true, false);
        case 6:
            // xCD => CDx
            return swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ]);
        case 7:
            // xCD => DCx
            return swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ], false, true);
        case 8:
            // AxCD => CDxA
            return swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ]);
        case 9:
            // AxCD => DCxA
            return swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ], false, true);
        case 10:
            // ABxD => DxAB
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ]);
        case 11:
            // ABxD => DxBA
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ], true, false);
        case 12:
            // ABxCD => CDxAB
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ]);
        case 13:
            // ABxCD => CDxBA
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, false);
        case 14:
            // ABxCD => DCxAB
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], false, true);
        case 15:
            // ABxCD => DCxBA
            return swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, true);
        default:
            throw new Error('Unknown verb: ' + verb);
    }
}
var AATLayoutEngine = function() {
    function AATLayoutEngine(font) {
        classCallCheck(this, AATLayoutEngine);
        this.font = font;
        this.morxProcessor = new AATMorxProcessor(font);
        this.fallbackPosition = false;
    }
    AATLayoutEngine.prototype.substitute = function substitute(glyphRun) {
        // AAT expects the glyphs to be in visual order prior to morx processing,
        // so reverse the glyphs if the script is right-to-left.
        if (glyphRun.direction === 'rtl') glyphRun.glyphs.reverse();
        this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
    };
    AATLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
        return mapAATToOT(this.morxProcessor.getSupportedFeatures());
    };
    AATLayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
        var glyphStrings = this.morxProcessor.generateInputs(gid);
        var result = new Set();
        for(var _iterator = glyphStrings, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var glyphs = _ref;
            this._addStrings(glyphs, 0, result, '');
        }
        return result;
    };
    AATLayoutEngine.prototype._addStrings = function _addStrings(glyphs, index, strings, string) {
        var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
        for(var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var codePoint = _ref2;
            var s = string + String.fromCodePoint(codePoint);
            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
            else strings.add(s);
        }
    };
    return AATLayoutEngine;
}();
/**
 * ShapingPlans are used by the OpenType shapers to store which
 * features should by applied, and in what order to apply them.
 * The features are applied in groups called stages. A feature
 * can be applied globally to all glyphs, or locally to only
 * specific glyphs.
 *
 * @private
 */ var ShapingPlan = function() {
    function ShapingPlan(font, script, direction$$1) {
        classCallCheck(this, ShapingPlan);
        this.font = font;
        this.script = script;
        this.direction = direction$$1;
        this.stages = [];
        this.globalFeatures = {};
        this.allFeatures = {};
    }
    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ ShapingPlan.prototype._addFeatures = function _addFeatures(features, global) {
        var stageIndex = this.stages.length - 1;
        var stage = this.stages[stageIndex];
        for(var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var feature = _ref;
            if (this.allFeatures[feature] == null) {
                stage.push(feature);
                this.allFeatures[feature] = stageIndex;
                if (global) this.globalFeatures[feature] = true;
            }
        }
    };
    /**
   * Add features to the last stage
   */ ShapingPlan.prototype.add = function add(arg) {
        var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (this.stages.length === 0) this.stages.push([]);
        if (typeof arg === 'string') arg = [
            arg
        ];
        if (Array.isArray(arg)) this._addFeatures(arg, global);
        else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
            this._addFeatures(arg.global || [], true);
            this._addFeatures(arg.local || [], false);
        } else throw new Error("Unsupported argument to ShapingPlan#add");
    };
    /**
   * Add a new stage
   */ ShapingPlan.prototype.addStage = function addStage(arg, global) {
        if (typeof arg === 'function') this.stages.push(arg, []);
        else {
            this.stages.push([]);
            this.add(arg, global);
        }
    };
    ShapingPlan.prototype.setFeatureOverrides = function setFeatureOverrides(features) {
        if (Array.isArray(features)) this.add(features);
        else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') for(var tag in features){
            if (features[tag]) this.add(tag);
            else if (this.allFeatures[tag] != null) {
                var stage = this.stages[this.allFeatures[tag]];
                stage.splice(stage.indexOf(tag), 1);
                delete this.allFeatures[tag];
                delete this.globalFeatures[tag];
            }
        }
    };
    /**
   * Assigns the global features to the given glyphs
   */ ShapingPlan.prototype.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
        for(var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var glyph = _ref2;
            for(var feature in this.globalFeatures)glyph.features[feature] = true;
        }
    };
    /**
   * Executes the planned stages using the given OTProcessor
   */ ShapingPlan.prototype.process = function process(processor, glyphs, positions1) {
        for(var _iterator3 = this.stages, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
            var _ref3;
            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }
            var stage = _ref3;
            if (typeof stage === 'function') {
                if (!positions1) stage(this.font, glyphs, this);
            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions1);
        }
    };
    return ShapingPlan;
}();
var _class$4;
var _temp;
var VARIATION_FEATURES = [
    'rvrn'
];
var COMMON_FEATURES = [
    'ccmp',
    'locl',
    'rlig',
    'mark',
    'mkmk'
];
var FRACTIONAL_FEATURES = [
    'frac',
    'numr',
    'dnom'
];
var HORIZONTAL_FEATURES = [
    'calt',
    'clig',
    'liga',
    'rclt',
    'curs',
    'kern'
];
var DIRECTIONAL_FEATURES = {
    ltr: [
        'ltra',
        'ltrm'
    ],
    rtl: [
        'rtla',
        'rtlm'
    ]
};
var DefaultShaper = (_temp = _class$4 = function() {
    function DefaultShaper() {
        classCallCheck(this, DefaultShaper);
    }
    DefaultShaper.plan = function plan(_plan, glyphs, features) {
        // Plan the features we want to apply
        this.planPreprocessing(_plan);
        this.planFeatures(_plan);
        this.planPostprocessing(_plan, features);
        // Assign the global features to all the glyphs
        _plan.assignGlobalFeatures(glyphs);
        // Assign local features to glyphs
        this.assignFeatures(_plan, glyphs);
    };
    DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
        plan.add({
            global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
            local: FRACTIONAL_FEATURES
        });
    };
    DefaultShaper.planFeatures = function planFeatures(plan) {
    // Do nothing by default. Let subclasses override this.
    };
    DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
        plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
        plan.setFeatureOverrides(userFeatures);
    };
    DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        // Enable contextual fractions
        for(var i = 0; i < glyphs.length; i++){
            var glyph = glyphs[i];
            if (glyph.codePoints[0] === 0x2044) {
                // fraction slash
                var start = i;
                var end = i + 1;
                // Apply numerator
                while(start > 0 && (0, _unicodePropertiesDefault.default).isDigit(glyphs[start - 1].codePoints[0])){
                    glyphs[start - 1].features.numr = true;
                    glyphs[start - 1].features.frac = true;
                    start--;
                }
                // Apply denominator
                while(end < glyphs.length && (0, _unicodePropertiesDefault.default).isDigit(glyphs[end].codePoints[0])){
                    glyphs[end].features.dnom = true;
                    glyphs[end].features.frac = true;
                    end++;
                }
                // Apply fraction slash
                glyph.features.frac = true;
                i = end - 1;
            }
        }
    };
    return DefaultShaper;
}(), _class$4.zeroMarkWidths = 'AFTER_GPOS', _temp);
var type = "Buffer";
var data = [
    0,
    1,
    16,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    49,
    160,
    1,
    149,
    1,
    106,
    254,
    237,
    216,
    43,
    79,
    3,
    65,
    20,
    5,
    224,
    217,
    7,
    77,
    41,
    138,
    127,
    64,
    37,
    146,
    4,
    131,
    37,
    4,
    143,
    68,
    33,
    193,
    224,
    192,
    129,
    3,
    137,
    196,
    32,
    81,
    4,
    73,
    80,
    72,
    28,
    18,
    137,
    194,
    224,
    144,
    224,
    48,
    156,
    210,
    153,
    228,
    102,
    152,
    217,
    206,
    238,
    206,
    62,
    40,
    231,
    38,
    95,
    102,
    186,
    219,
    121,
    246,
    238,
    35,
    29,
    167,
    74,
    173,
    194,
    26,
    108,
    192,
    88,
    127,
    254,
    43,
    229,
    14,
    236,
    194,
    30,
    236,
    195,
    33,
    28,
    195,
    41,
    156,
    195,
    5,
    92,
    194,
    21,
    92,
    139,
    118,
    183,
    112,
    167,
    63,
    79,
    60,
    136,
    250,
    163,
    168,
    211,
    124,
    123,
    130,
    35,
    237,
    25,
    94,
    224,
    181,
    7,
    243,
    106,
    203,
    155,
    168,
    191,
    247,
    96,
    62,
    68,
    68,
    68,
    68,
    68,
    68,
    68,
    68,
    77,
    153,
    252,
    255,
    243,
    209,
    131,
    121,
    16,
    17,
    17,
    17,
    17,
    205,
    179,
    124,
    113,
    234,
    108,
    216,
    140,
    45,
    244,
    125,
    2,
    247,
    240,
    9,
    235,
    35,
    165,
    14,
    70,
    211,
    115,
    55,
    40,
    183,
    149,
    82,
    155,
    195,
    230,
    214,
    247,
    5,
    89,
    246,
    251,
    248,
    18,
    142,
    45,
    59,
    142,
    119,
    101,
    37,
    77,
    126,
    48,
    24,
    255,
    57,
    18,
    15,
    121,
    222,
    85,
    143,
    21,
    185,
    238,
    55,
    179,
    228,
    142,
    210,
    230,
    106,
    83,
    150,
    108,
    215,
    167,
    144,
    115,
    146,
    107,
    180,
    247,
    42,
    100,
    125,
    49,
    84,
    217,
    219,
    54,
    100,
    86,
    61,
    100,
    29,
    174,
    188,
    50,
    231,
    149,
    40,
    125,
    17,
    227,
    58,
    144,
    227,
    133,
    132,
    92,
    179,
    60,
    86,
    55,
    22,
    28,
    253,
    15,
    180,
    162,
    223,
    63,
    52,
    39,
    50,
    209,
    167,
    221,
    110,
    16,
    97,
    254,
    170,
    196,
    92,
    92,
    121,
    82,
    55,
    247,
    138,
    246,
    198,
    117,
    126,
    214,
    184,
    161,
    209,
    245,
    117,
    87,
    55,
    247,
    124,
    237,
    103,
    221,
    235,
    203,
    228,
    158,
    252,
    174,
    235,
    217,
    230,
    155,
    87,
    217,
    28,
    50,
    247,
    100,
    223,
    111,
    92,
    37,
    18,
    171,
    173,
    221,
    79,
    172,
    103,
    113,
    215,
    57,
    226,
    123,
    255,
    48,
    235,
    111,
    43,
    143,
    235,
    230,
    115,
    209,
    250,
    154,
    232,
    219,
    247,
    190,
    22,
    59,
    98,
    237,
    113,
    90,
    113,
    158,
    190,
    107,
    47,
    177,
    74,
    83,
    79,
    244,
    88,
    33,
    239,
    48,
    105,
    65,
    255,
    174,
    241,
    204,
    88,
    161,
    115,
    45,
    243,
    124,
    47,
    234,
    211,
    126,
    158,
    184,
    230,
    103,
    215,
    237,
    251,
    101,
    157,
    240,
    237,
    99,
    19,
    121,
    247,
    13
];
var trieData = {
    type: type,
    data: data
};
var trie = new (0, _unicodeTrieDefault.default)(new Uint8Array(trieData.data));
var FEATURES = [
    'isol',
    'fina',
    'fin2',
    'fin3',
    'medi',
    'med2',
    'init'
];
var ShapingClasses = {
    Non_Joining: 0,
    Left_Joining: 1,
    Right_Joining: 2,
    Dual_Joining: 3,
    Join_Causing: 3,
    ALAPH: 4,
    'DALATH RISH': 5,
    Transparent: 6
};
var ISOL = 'isol';
var FINA = 'fina';
var FIN2 = 'fin2';
var FIN3 = 'fin3';
var MEDI = 'medi';
var MED2 = 'med2';
var INIT = 'init';
var NONE = null;
// Each entry is [prevAction, curAction, nextState]
var STATE_TABLE = [
    //   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
    // State 0: prev was U,  not willing to join.
    [
        [
            NONE,
            NONE,
            0
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            NONE,
            ISOL,
            1
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            NONE,
            ISOL,
            1
        ],
        [
            NONE,
            ISOL,
            6
        ]
    ],
    // State 1: prev was R or ISOL/ALAPH,  not willing to join.
    [
        [
            NONE,
            NONE,
            0
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            NONE,
            ISOL,
            1
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            NONE,
            FIN2,
            5
        ],
        [
            NONE,
            ISOL,
            6
        ]
    ],
    // State 2: prev was D/L in ISOL form,  willing to join.
    [
        [
            NONE,
            NONE,
            0
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            INIT,
            FINA,
            1
        ],
        [
            INIT,
            FINA,
            3
        ],
        [
            INIT,
            FINA,
            4
        ],
        [
            INIT,
            FINA,
            6
        ]
    ],
    // State 3: prev was D in FINA form,  willing to join.
    [
        [
            NONE,
            NONE,
            0
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            MEDI,
            FINA,
            1
        ],
        [
            MEDI,
            FINA,
            3
        ],
        [
            MEDI,
            FINA,
            4
        ],
        [
            MEDI,
            FINA,
            6
        ]
    ],
    // State 4: prev was FINA ALAPH,  not willing to join.
    [
        [
            NONE,
            NONE,
            0
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            MED2,
            ISOL,
            1
        ],
        [
            MED2,
            ISOL,
            2
        ],
        [
            MED2,
            FIN2,
            5
        ],
        [
            MED2,
            ISOL,
            6
        ]
    ],
    // State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
    [
        [
            NONE,
            NONE,
            0
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            ISOL,
            ISOL,
            1
        ],
        [
            ISOL,
            ISOL,
            2
        ],
        [
            ISOL,
            FIN2,
            5
        ],
        [
            ISOL,
            ISOL,
            6
        ]
    ],
    // State 6: prev was DALATH/RISH,  not willing to join.
    [
        [
            NONE,
            NONE,
            0
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            NONE,
            ISOL,
            1
        ],
        [
            NONE,
            ISOL,
            2
        ],
        [
            NONE,
            FIN3,
            5
        ],
        [
            NONE,
            ISOL,
            6
        ]
    ]
];
/**
 * This is a shaper for Arabic, and other cursive scripts.
 * It uses data from ArabicShaping.txt in the Unicode database,
 * compiled to a UnicodeTrie by generate-data.coffee.
 *
 * The shaping state machine was ported from Harfbuzz.
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
 */ var ArabicShaper = function(_DefaultShaper) {
    inherits(ArabicShaper, _DefaultShaper);
    function ArabicShaper() {
        classCallCheck(this, ArabicShaper);
        return possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
    }
    ArabicShaper.planFeatures = function planFeatures(plan) {
        plan.add([
            'ccmp',
            'locl'
        ]);
        for(var i = 0; i < FEATURES.length; i++){
            var feature = FEATURES[i];
            plan.addStage(feature, false);
        }
        plan.addStage('mset');
    };
    ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        _DefaultShaper.assignFeatures.call(this, plan, glyphs);
        var prev = -1;
        var state = 0;
        var actions = [];
        // Apply the state machine to map glyphs to features
        for(var i = 0; i < glyphs.length; i++){
            var curAction = void 0, prevAction = void 0;
            var glyph = glyphs[i];
            var type$$1 = getShapingClass(glyph.codePoints[0]);
            if (type$$1 === ShapingClasses.Transparent) {
                actions[i] = NONE;
                continue;
            }
            var _STATE_TABLE$state$ty = STATE_TABLE[state][type$$1];
            prevAction = _STATE_TABLE$state$ty[0];
            curAction = _STATE_TABLE$state$ty[1];
            state = _STATE_TABLE$state$ty[2];
            if (prevAction !== NONE && prev !== -1) actions[prev] = prevAction;
            actions[i] = curAction;
            prev = i;
        }
        // Apply the chosen features to their respective glyphs
        for(var index = 0; index < glyphs.length; index++){
            var feature = void 0;
            var glyph = glyphs[index];
            if (feature = actions[index]) glyph.features[feature] = true;
        }
    };
    return ArabicShaper;
}(DefaultShaper);
function getShapingClass(codePoint) {
    var res = trie.get(codePoint);
    if (res) return res - 1;
    var category = (0, _unicodePropertiesDefault.default).getCategory(codePoint);
    if (category === 'Mn' || category === 'Me' || category === 'Cf') return ShapingClasses.Transparent;
    return ShapingClasses.Non_Joining;
}
var GlyphIterator = function() {
    function GlyphIterator(glyphs, options) {
        classCallCheck(this, GlyphIterator);
        this.glyphs = glyphs;
        this.reset(options);
    }
    GlyphIterator.prototype.reset = function reset() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        this.options = options;
        this.flags = options.flags || {};
        this.markAttachmentType = options.markAttachmentType || 0;
        this.index = index;
    };
    GlyphIterator.prototype.shouldIgnore = function shouldIgnore(glyph) {
        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
    };
    GlyphIterator.prototype.move = function move(dir) {
        this.index += dir;
        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
        if (0 > this.index || this.index >= this.glyphs.length) return null;
        return this.glyphs[this.index];
    };
    GlyphIterator.prototype.next = function next() {
        return this.move(1);
    };
    GlyphIterator.prototype.prev = function prev() {
        return this.move(-1);
    };
    GlyphIterator.prototype.peek = function peek() {
        var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var idx = this.index;
        var res = this.increment(count);
        this.index = idx;
        return res;
    };
    GlyphIterator.prototype.peekIndex = function peekIndex() {
        var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var idx = this.index;
        this.increment(count);
        var res = this.index;
        this.index = idx;
        return res;
    };
    GlyphIterator.prototype.increment = function increment() {
        var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var dir = count < 0 ? -1 : 1;
        count = Math.abs(count);
        while(count--)this.move(dir);
        return this.glyphs[this.index];
    };
    createClass(GlyphIterator, [
        {
            key: "cur",
            get: function get$$1() {
                return this.glyphs[this.index] || null;
            }
        }
    ]);
    return GlyphIterator;
}();
var DEFAULT_SCRIPTS = [
    'DFLT',
    'dflt',
    'latn'
];
var OTProcessor = function() {
    function OTProcessor(font, table) {
        classCallCheck(this, OTProcessor);
        this.font = font;
        this.table = table;
        this.script = null;
        this.scriptTag = null;
        this.language = null;
        this.languageTag = null;
        this.features = {};
        this.lookups = {};
        // Setup variation substitutions
        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;
        // initialize to default script + language
        this.selectScript();
        // current context (set by applyFeatures)
        this.glyphs = [];
        this.positions = []; // only used by GPOS
        this.ligatureID = 1;
        this.currentFeature = null;
    }
    OTProcessor.prototype.findScript = function findScript(script) {
        if (this.table.scriptList == null) return null;
        if (!Array.isArray(script)) script = [
            script
        ];
        for(var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var s = _ref;
            for(var _iterator2 = this.table.scriptList, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                var _ref2;
                if (_isArray2) {
                    if (_i2 >= _iterator2.length) break;
                    _ref2 = _iterator2[_i2++];
                } else {
                    _i2 = _iterator2.next();
                    if (_i2.done) break;
                    _ref2 = _i2.value;
                }
                var entry = _ref2;
                if (entry.tag === s) return entry;
            }
        }
        return null;
    };
    OTProcessor.prototype.selectScript = function selectScript(script, language, direction$$1) {
        var changed = false;
        var entry = void 0;
        if (!this.script || script !== this.scriptTag) {
            entry = this.findScript(script);
            if (!entry) entry = this.findScript(DEFAULT_SCRIPTS);
            if (!entry) return this.scriptTag;
            this.scriptTag = entry.tag;
            this.script = entry.script;
            this.language = null;
            this.languageTag = null;
            changed = true;
        }
        if (!direction$$1 || direction$$1 !== this.direction) this.direction = direction$$1 || direction(script);
        if (language && language.length < 4) language += ' '.repeat(4 - language.length);
        if (!language || language !== this.languageTag) {
            this.language = null;
            for(var _iterator3 = this.script.langSysRecords, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
                var _ref3;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }
                var lang = _ref3;
                if (lang.tag === language) {
                    this.language = lang.langSys;
                    this.languageTag = lang.tag;
                    break;
                }
            }
            if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
            }
            changed = true;
        }
        // Build a feature lookup table
        if (changed) {
            this.features = {};
            if (this.language) for(var _iterator4 = this.language.featureIndexes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;){
                var _ref4;
                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref4 = _i4.value;
                }
                var featureIndex = _ref4;
                var record = this.table.featureList[featureIndex];
                var substituteFeature = this.substituteFeatureForVariations(featureIndex);
                this.features[record.tag] = substituteFeature || record.feature;
            }
        }
        return this.scriptTag;
    };
    OTProcessor.prototype.lookupsForFeatures = function lookupsForFeatures() {
        var userFeatures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var exclude = arguments[1];
        var lookups = [];
        for(var _iterator5 = userFeatures, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;){
            var _ref5;
            if (_isArray5) {
                if (_i5 >= _iterator5.length) break;
                _ref5 = _iterator5[_i5++];
            } else {
                _i5 = _iterator5.next();
                if (_i5.done) break;
                _ref5 = _i5.value;
            }
            var tag = _ref5;
            var feature = this.features[tag];
            if (!feature) continue;
            for(var _iterator6 = feature.lookupListIndexes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;){
                var _ref6;
                if (_isArray6) {
                    if (_i6 >= _iterator6.length) break;
                    _ref6 = _iterator6[_i6++];
                } else {
                    _i6 = _iterator6.next();
                    if (_i6.done) break;
                    _ref6 = _i6.value;
                }
                var lookupIndex = _ref6;
                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                lookups.push({
                    feature: tag,
                    index: lookupIndex,
                    lookup: this.table.lookupList.get(lookupIndex)
                });
            }
        }
        lookups.sort(function(a, b) {
            return a.index - b.index;
        });
        return lookups;
    };
    OTProcessor.prototype.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
        if (this.variationsIndex === -1) return null;
        var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
        var substitutions = record.featureTableSubstitution.substitutions;
        for(var _iterator7 = substitutions, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;){
            var _ref7;
            if (_isArray7) {
                if (_i7 >= _iterator7.length) break;
                _ref7 = _iterator7[_i7++];
            } else {
                _i7 = _iterator7.next();
                if (_i7.done) break;
                _ref7 = _i7.value;
            }
            var substitution = _ref7;
            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
        }
        return null;
    };
    OTProcessor.prototype.findVariationsIndex = function findVariationsIndex(coords) {
        var variations = this.table.featureVariations;
        if (!variations) return -1;
        var records = variations.featureVariationRecords;
        for(var i = 0; i < records.length; i++){
            var conditions = records[i].conditionSet.conditionTable;
            if (this.variationConditionsMatch(conditions, coords)) return i;
        }
        return -1;
    };
    OTProcessor.prototype.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
        return conditions.every(function(condition) {
            var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
        });
    };
    OTProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
        var lookups = this.lookupsForFeatures(userFeatures);
        this.applyLookups(lookups, glyphs, advances);
    };
    OTProcessor.prototype.applyLookups = function applyLookups(lookups, glyphs, positions1) {
        this.glyphs = glyphs;
        this.positions = positions1;
        this.glyphIterator = new GlyphIterator(glyphs);
        for(var _iterator8 = lookups, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;){
            var _ref8;
            if (_isArray8) {
                if (_i8 >= _iterator8.length) break;
                _ref8 = _iterator8[_i8++];
            } else {
                _i8 = _iterator8.next();
                if (_i8.done) break;
                _ref8 = _i8.value;
            }
            var _ref9 = _ref8, feature = _ref9.feature, lookup = _ref9.lookup;
            this.currentFeature = feature;
            this.glyphIterator.reset(lookup.flags);
            while(this.glyphIterator.index < glyphs.length){
                if (!(feature in this.glyphIterator.cur.features)) {
                    this.glyphIterator.next();
                    continue;
                }
                for(var _iterator9 = lookup.subTables, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;){
                    var _ref10;
                    if (_isArray9) {
                        if (_i9 >= _iterator9.length) break;
                        _ref10 = _iterator9[_i9++];
                    } else {
                        _i9 = _iterator9.next();
                        if (_i9.done) break;
                        _ref10 = _i9.value;
                    }
                    var table = _ref10;
                    var res = this.applyLookup(lookup.lookupType, table);
                    if (res) break;
                }
                this.glyphIterator.next();
            }
        }
    };
    OTProcessor.prototype.applyLookup = function applyLookup(lookup, table) {
        throw new Error("applyLookup must be implemented by subclasses");
    };
    OTProcessor.prototype.applyLookupList = function applyLookupList(lookupRecords) {
        var options = this.glyphIterator.options;
        var glyphIndex = this.glyphIterator.index;
        for(var _iterator10 = lookupRecords, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;){
            var _ref11;
            if (_isArray10) {
                if (_i10 >= _iterator10.length) break;
                _ref11 = _iterator10[_i10++];
            } else {
                _i10 = _iterator10.next();
                if (_i10.done) break;
                _ref11 = _i10.value;
            }
            var lookupRecord = _ref11;
            // Reset flags and find glyph index for this lookup record
            this.glyphIterator.reset(options, glyphIndex);
            this.glyphIterator.increment(lookupRecord.sequenceIndex);
            // Get the lookup and setup flags for subtables
            var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);
            // Apply lookup subtables until one matches
            for(var _iterator11 = lookup.subTables, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;){
                var _ref12;
                if (_isArray11) {
                    if (_i11 >= _iterator11.length) break;
                    _ref12 = _iterator11[_i11++];
                } else {
                    _i11 = _iterator11.next();
                    if (_i11.done) break;
                    _ref12 = _i11.value;
                }
                var table = _ref12;
                if (this.applyLookup(lookup.lookupType, table)) break;
            }
        }
        this.glyphIterator.reset(options, glyphIndex);
        return true;
    };
    OTProcessor.prototype.coverageIndex = function coverageIndex(coverage, glyph) {
        if (glyph == null) glyph = this.glyphIterator.cur.id;
        switch(coverage.version){
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for(var _iterator12 = coverage.rangeRecords, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;){
                    var _ref13;
                    if (_isArray12) {
                        if (_i12 >= _iterator12.length) break;
                        _ref13 = _iterator12[_i12++];
                    } else {
                        _i12 = _iterator12.next();
                        if (_i12.done) break;
                        _ref13 = _i12.value;
                    }
                    var range = _ref13;
                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                }
                break;
        }
        return -1;
    };
    OTProcessor.prototype.match = function match(sequenceIndex, sequence, fn, matched) {
        var pos = this.glyphIterator.index;
        var glyph = this.glyphIterator.increment(sequenceIndex);
        var idx = 0;
        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
            if (matched) matched.push(this.glyphIterator.index);
            idx++;
            glyph = this.glyphIterator.next();
        }
        this.glyphIterator.index = pos;
        if (idx < sequence.length) return false;
        return matched || true;
    };
    OTProcessor.prototype.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, function(component, glyph) {
            return component === glyph.id;
        });
    };
    OTProcessor.prototype.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
        var _this = this;
        return this.match(sequenceIndex, sequence, function(component, glyph) {
            // If the current feature doesn't apply to this glyph,
            if (!(_this.currentFeature in glyph.features)) return false;
            return component === glyph.id;
        }, []);
    };
    OTProcessor.prototype.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
        var _this2 = this;
        return this.match(sequenceIndex, sequence, function(coverage, glyph) {
            return _this2.coverageIndex(coverage, glyph.id) >= 0;
        });
    };
    OTProcessor.prototype.getClassID = function getClassID(glyph, classDef) {
        switch(classDef.version){
            case 1:
                // Class array
                var i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                break;
            case 2:
                for(var _iterator13 = classDef.classRangeRecord, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _iterator13[Symbol.iterator]();;){
                    var _ref14;
                    if (_isArray13) {
                        if (_i13 >= _iterator13.length) break;
                        _ref14 = _iterator13[_i13++];
                    } else {
                        _i13 = _iterator13.next();
                        if (_i13.done) break;
                        _ref14 = _i13.value;
                    }
                    var range = _ref14;
                    if (range.start <= glyph && glyph <= range.end) return range.class;
                }
                break;
        }
        return 0;
    };
    OTProcessor.prototype.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
        var _this3 = this;
        return this.match(sequenceIndex, sequence, function(classID, glyph) {
            return classID === _this3.getClassID(glyph.id, classDef);
        });
    };
    OTProcessor.prototype.applyContext = function applyContext(table) {
        switch(table.version){
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var set$$1 = table.ruleSets[index];
                for(var _iterator14 = set$$1, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _iterator14[Symbol.iterator]();;){
                    var _ref15;
                    if (_isArray14) {
                        if (_i14 >= _iterator14.length) break;
                        _ref15 = _iterator14[_i14++];
                    } else {
                        _i14 = _iterator14.next();
                        if (_i14.done) break;
                        _ref15 = _i14.value;
                    }
                    var rule = _ref15;
                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) return false;
                set$$1 = table.classSet[index];
                for(var _iterator15 = set$$1, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _iterator15[Symbol.iterator]();;){
                    var _ref16;
                    if (_isArray15) {
                        if (_i15 >= _iterator15.length) break;
                        _ref16 = _iterator15[_i15++];
                    } else {
                        _i15 = _iterator15.next();
                        if (_i15.done) break;
                        _ref16 = _i15.value;
                    }
                    var _rule = _ref16;
                    if (this.classSequenceMatches(1, _rule.classes, table.classDef)) return this.applyLookupList(_rule.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    };
    OTProcessor.prototype.applyChainingContext = function applyChainingContext(table) {
        switch(table.version){
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var set$$1 = table.chainRuleSets[index];
                for(var _iterator16 = set$$1, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _iterator16[Symbol.iterator]();;){
                    var _ref17;
                    if (_isArray16) {
                        if (_i16 >= _iterator16.length) break;
                        _ref17 = _iterator16[_i16++];
                    } else {
                        _i16 = _iterator16.next();
                        if (_i16.done) break;
                        _ref17 = _i16.value;
                    }
                    var rule = _ref17;
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                var rules = table.chainClassSet[index];
                if (!rules) return false;
                for(var _iterator17 = rules, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _iterator17[Symbol.iterator]();;){
                    var _ref18;
                    if (_isArray17) {
                        if (_i17 >= _iterator17.length) break;
                        _ref18 = _iterator17[_i17++];
                    } else {
                        _i17 = _iterator17.next();
                        if (_i17.done) break;
                        _ref18 = _i17.value;
                    }
                    var _rule2 = _ref18;
                    if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) return this.applyLookupList(_rule2.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    };
    return OTProcessor;
}();
var GlyphInfo = function() {
    function GlyphInfo(font, id) {
        var codePoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var features = arguments[3];
        var stringIndex = arguments[4];
        classCallCheck(this, GlyphInfo);
        this._font = font;
        this.codePoints = codePoints;
        this.stringIndex = stringIndex;
        this.id = id;
        this.features = {};
        if (Array.isArray(features)) for(var i = 0; i < features.length; i++){
            var feature = features[i];
            this.features[feature] = true;
        }
        else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') Object.assign(this.features, features);
        this.ligatureID = null;
        this.ligatureComponent = null;
        this.isLigated = false;
        this.cursiveAttachment = null;
        this.markAttachment = null;
        this.shaperInfo = null;
        this.substituted = false;
        this.isMultiplied = false;
    }
    GlyphInfo.prototype.copy = function copy() {
        return new GlyphInfo(this._font, this.id, this.codePoints, this.features, this.stringIndex);
    };
    createClass(GlyphInfo, [
        {
            key: 'id',
            get: function get$$1() {
                return this._id;
            },
            set: function set$$1(id) {
                this._id = id;
                this.substituted = true;
                var GDEF = this._font.GDEF;
                if (GDEF && GDEF.glyphClassDef) {
                    // TODO: clean this up
                    var classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
                    this.isBase = classID === 1;
                    this.isLigature = classID === 2;
                    this.isMark = classID === 3;
                    this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
                } else {
                    this.isMark = this.codePoints.length > 0 && this.codePoints.every((0, _unicodePropertiesDefault.default).isMark);
                    this.isBase = !this.isMark;
                    this.isLigature = this.codePoints.length > 1;
                    this.markAttachmentType = 0;
                }
            }
        },
        {
            key: 'advanceWidth',
            get: function get$$1() {
                return this._font.getGlyph(this.id, this.codePoints).advanceWidth;
            }
        }
    ]);
    return GlyphInfo;
}();
var _class$5;
var _temp$1;
/**
 * This is a shaper for the Hangul script, used by the Korean language.
 * It does the following:
 *   - decompose if unsupported by the font:
 *     <LV>   -> <L,V>
 *     <LVT>  -> <L,V,T>
 *     <LV,T> -> <L,V,T>
 *
 *   - compose if supported by the font:
 *     <L,V>   -> <LV>
 *     <L,V,T> -> <LVT>
 *     <LV,T>  -> <LVT>
 *
 *   - reorder tone marks (S is any valid syllable):
 *     <S, M> -> <M, S>
 *
 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
 *
 * This logic is based on the following documents:
 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
 */ var HangulShaper = (_temp$1 = _class$5 = function(_DefaultShaper) {
    inherits(HangulShaper, _DefaultShaper);
    function HangulShaper() {
        classCallCheck(this, HangulShaper);
        return possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
    }
    HangulShaper.planFeatures = function planFeatures(plan) {
        plan.add([
            'ljmo',
            'vjmo',
            'tjmo'
        ], false);
    };
    HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var state = 0;
        var i = 0;
        while(i < glyphs.length){
            var action = void 0;
            var glyph = glyphs[i];
            var code = glyph.codePoints[0];
            var type = getType(code);
            var _STATE_TABLE$state$ty = STATE_TABLE$1[state][type];
            action = _STATE_TABLE$state$ty[0];
            state = _STATE_TABLE$state$ty[1];
            switch(action){
                case DECOMPOSE:
                    // Decompose the composed syllable if it is not supported by the font.
                    if (!plan.font.hasGlyphForCodePoint(code)) i = decompose(glyphs, i, plan.font);
                    break;
                case COMPOSE:
                    // Found a decomposed syllable. Try to compose if supported by the font.
                    i = compose(glyphs, i, plan.font);
                    break;
                case TONE_MARK:
                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                    reorderToneMark(glyphs, i, plan.font);
                    break;
                case INVALID:
                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                    i = insertDottedCircle(glyphs, i, plan.font);
                    break;
            }
            i++;
        }
    };
    return HangulShaper;
}(DefaultShaper), _class$5.zeroMarkWidths = 'NONE', _temp$1);
var HANGUL_BASE = 0xac00;
var HANGUL_END = 0xd7a4;
var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
var L_BASE = 0x1100; // lead
var V_BASE = 0x1161; // vowel
var T_BASE = 0x11a7; // trail
var L_COUNT = 19;
var V_COUNT = 21;
var T_COUNT = 28;
var L_END = L_BASE + L_COUNT - 1;
var V_END = V_BASE + V_COUNT - 1;
var T_END = T_BASE + T_COUNT - 1;
var DOTTED_CIRCLE = 0x25cc;
var isL = function isL(code) {
    return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
};
var isV = function isV(code) {
    return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
};
var isT = function isT(code) {
    return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
};
var isTone = function isTone(code) {
    return 0x302e <= code && code <= 0x302f;
};
var isLVT = function isLVT(code) {
    return HANGUL_BASE <= code && code <= HANGUL_END;
};
var isLV = function isLV(code) {
    return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
};
var isCombiningL = function isCombiningL(code) {
    return L_BASE <= code && code <= L_END;
};
var isCombiningV = function isCombiningV(code) {
    return V_BASE <= code && code <= V_END;
};
var isCombiningT = function isCombiningT(code) {
    return T_BASE + 1 && 1 <= code && code <= T_END;
};
// Character categories
var X = 0; // Other character
var L = 1; // Leading consonant
var V = 2; // Medial vowel
var T = 3; // Trailing consonant
var LV = 4; // Composed <LV> syllable
var LVT = 5; // Composed <LVT> syllable
var M = 6; // Tone mark
// This function classifies a character using the above categories.
function getType(code) {
    if (isL(code)) return L;
    if (isV(code)) return V;
    if (isT(code)) return T;
    if (isLV(code)) return LV;
    if (isLVT(code)) return LVT;
    if (isTone(code)) return M;
    return X;
}
// State machine actions
var NO_ACTION = 0;
var DECOMPOSE = 1;
var COMPOSE = 2;
var TONE_MARK = 4;
var INVALID = 5;
// Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
var STATE_TABLE$1 = [
    //       X                 L                 V                T                  LV                LVT               M
    // State 0: start state
    [
        [
            NO_ACTION,
            0
        ],
        [
            NO_ACTION,
            1
        ],
        [
            NO_ACTION,
            0
        ],
        [
            NO_ACTION,
            0
        ],
        [
            DECOMPOSE,
            2
        ],
        [
            DECOMPOSE,
            3
        ],
        [
            INVALID,
            0
        ]
    ],
    // State 1: <L>
    [
        [
            NO_ACTION,
            0
        ],
        [
            NO_ACTION,
            1
        ],
        [
            COMPOSE,
            2
        ],
        [
            NO_ACTION,
            0
        ],
        [
            DECOMPOSE,
            2
        ],
        [
            DECOMPOSE,
            3
        ],
        [
            INVALID,
            0
        ]
    ],
    // State 2: <L,V> or <LV>
    [
        [
            NO_ACTION,
            0
        ],
        [
            NO_ACTION,
            1
        ],
        [
            NO_ACTION,
            0
        ],
        [
            COMPOSE,
            3
        ],
        [
            DECOMPOSE,
            2
        ],
        [
            DECOMPOSE,
            3
        ],
        [
            TONE_MARK,
            0
        ]
    ],
    // State 3: <L,V,T> or <LVT>
    [
        [
            NO_ACTION,
            0
        ],
        [
            NO_ACTION,
            1
        ],
        [
            NO_ACTION,
            0
        ],
        [
            NO_ACTION,
            0
        ],
        [
            DECOMPOSE,
            2
        ],
        [
            DECOMPOSE,
            3
        ],
        [
            TONE_MARK,
            0
        ]
    ]
];
function getGlyph(font, code, features) {
    return new GlyphInfo(font, font.glyphForCodePoint(code).id, [
        code
    ], features);
}
function decompose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyph.codePoints[0];
    var s = code - HANGUL_BASE;
    var t = T_BASE + s % T_COUNT;
    s = s / T_COUNT | 0;
    var l = L_BASE + s / V_COUNT | 0;
    var v = V_BASE + s % V_COUNT;
    // Don't decompose if all of the components are not available
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) return i;
    // Replace the current glyph with decomposed L, V, and T glyphs,
    // and apply the proper OpenType features to each component.
    var ljmo = getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    var vjmo = getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    var insert = [
        ljmo,
        vjmo
    ];
    if (t > T_BASE) {
        var tjmo = getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice.apply(glyphs, [
        i,
        1
    ].concat(insert));
    return i + insert.length - 1;
}
function compose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    var type = getType(code);
    var prev = glyphs[i - 1].codePoints[0];
    var prevType = getType(prev);
    // Figure out what type of syllable we're dealing with
    var lv = void 0, ljmo = void 0, vjmo = void 0, tjmo = void 0;
    if (prevType === LV && type === T) {
        // <LV,T>
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === V) {
            // <L,V>
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            // <L,V,T>
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        var l = ljmo.codePoints[0];
        var v = vjmo.codePoints[0];
        // Make sure L and V are combining characters
        if (isCombiningL(l) && isCombiningV(v)) lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
    }
    var t = tjmo && tjmo.codePoints[0] || T_BASE;
    if (lv != null && (t === T_BASE || isCombiningT(t))) {
        var s = lv + (t - T_BASE);
        // Replace with a composed glyph if supported by the font,
        // otherwise apply the proper OpenType features to each component.
        if (font.hasGlyphForCodePoint(s)) {
            var del = prevType === V ? 3 : 2;
            glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    }
    // Didn't compose (either a non-combining component or unsupported by font).
    if (ljmo) ljmo.features.ljmo = true;
    if (vjmo) vjmo.features.vjmo = true;
    if (tjmo) tjmo.features.tjmo = true;
    if (prevType === LV) {
        // Sequence was originally <L,V>, which got combined earlier.
        // Either the T was non-combining, or the LVT glyph wasn't supported.
        // Decompose the glyph again and apply OT features.
        decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function getLength(code) {
    switch(getType(code)){
        case LV:
        case LVT:
            return 1;
        case V:
            return 2;
        case T:
            return 3;
    }
}
function reorderToneMark(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    // Move tone mark to the beginning of the previous syllable, unless it is zero width
    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
    var prev = glyphs[i - 1].codePoints[0];
    var len = getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function insertDottedCircle(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
        var dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features);
        // If the tone mark is zero width, insert the dotted circle before, otherwise after
        var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
var stateTable = [
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        10,
        11,
        11,
        12,
        13,
        14,
        15,
        16,
        17
    ],
    [
        0,
        0,
        0,
        18,
        19,
        20,
        21,
        22,
        23,
        0,
        24,
        0,
        0,
        25,
        26,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        28,
        29,
        30,
        31,
        32,
        33,
        0,
        34,
        0,
        0,
        35,
        36,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        38,
        5,
        7,
        7,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        13,
        0,
        0,
        16,
        0
    ],
    [
        0,
        39,
        0,
        0,
        0,
        40,
        41,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        39,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        43,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        12,
        43,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        43,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        0,
        43,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        45,
        46,
        47,
        48,
        49,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        50,
        0,
        0,
        51,
        0,
        10,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        52,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        53,
        54,
        55,
        56,
        57,
        58,
        0,
        59,
        0,
        0,
        60,
        61,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        4,
        5,
        7,
        7,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        13,
        0,
        0,
        16,
        0
    ],
    [
        0,
        63,
        64,
        0,
        0,
        40,
        41,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        63,
        0,
        0
    ],
    [
        0,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        0,
        10,
        11,
        11,
        12,
        13,
        0,
        2,
        16,
        0
    ],
    [
        0,
        0,
        0,
        18,
        65,
        20,
        21,
        22,
        23,
        0,
        24,
        0,
        0,
        25,
        26,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        66,
        67,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        68,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        69,
        0,
        70,
        70,
        0,
        71,
        0,
        72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        73,
        19,
        74,
        74,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        26,
        0,
        0,
        27,
        0
    ],
    [
        0,
        75,
        0,
        0,
        0,
        76,
        77,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        75,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        79,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        25,
        79,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        18,
        19,
        20,
        74,
        22,
        23,
        0,
        24,
        0,
        0,
        25,
        26,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        81,
        82,
        83,
        84,
        85,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        86,
        0,
        0,
        87,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        88,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        18,
        19,
        74,
        74,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        26,
        0,
        0,
        27,
        0
    ],
    [
        0,
        89,
        90,
        0,
        0,
        76,
        77,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        89,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        91,
        92,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        93,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        94,
        29,
        95,
        31,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        36,
        0,
        0,
        37,
        0
    ],
    [
        0,
        96,
        0,
        0,
        0,
        97,
        98,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        96,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        100,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        35,
        100,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        100,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        0,
        100,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        102,
        103,
        104,
        105,
        106,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        107,
        0,
        0,
        108,
        0,
        34,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        109,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        28,
        29,
        95,
        31,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        36,
        0,
        0,
        37,
        0
    ],
    [
        0,
        110,
        111,
        0,
        0,
        97,
        98,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        110,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        112,
        113,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        114,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        5,
        7,
        7,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        13,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        115,
        116,
        117,
        118,
        8,
        9,
        0,
        10,
        0,
        0,
        119,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        39,
        0,
        122,
        0,
        123,
        123,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        39,
        0,
        0
    ],
    [
        0,
        124,
        64,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        124,
        0,
        0
    ],
    [
        0,
        39,
        0,
        0,
        0,
        121,
        125,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        39,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        126,
        126,
        8,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        46,
        47,
        48,
        49,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        47,
        47,
        49,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        127,
        127,
        49,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        128,
        127,
        127,
        49,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        129,
        130,
        131,
        132,
        133,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        10,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        50,
        0,
        0,
        0,
        0,
        10,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        134,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        135,
        54,
        56,
        56,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        61,
        0,
        0,
        62,
        0
    ],
    [
        0,
        136,
        0,
        0,
        0,
        137,
        138,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        136,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        140,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        60,
        140,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        140,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        0,
        140,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        142,
        143,
        144,
        145,
        146,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        147,
        0,
        0,
        148,
        0,
        59,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        149,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        53,
        54,
        56,
        56,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        61,
        0,
        0,
        62,
        0
    ],
    [
        0,
        150,
        151,
        0,
        0,
        137,
        138,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        150,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        152,
        153,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        154,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        155,
        116,
        156,
        157,
        8,
        9,
        0,
        10,
        0,
        0,
        158,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        75,
        3,
        4,
        5,
        159,
        160,
        8,
        161,
        0,
        162,
        0,
        11,
        12,
        163,
        0,
        75,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        40,
        164,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        165,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        0,
        165,
        0,
        0,
        0,
        0
    ],
    [
        0,
        124,
        64,
        0,
        0,
        40,
        164,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        124,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        70,
        70,
        0,
        71,
        0,
        72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        71,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        166,
        0,
        0,
        167,
        0,
        72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        168,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        19,
        74,
        74,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        26,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        79,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        0,
        79,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        169,
        170,
        171,
        172,
        22,
        23,
        0,
        24,
        0,
        0,
        173,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        75,
        0,
        176,
        0,
        177,
        177,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        75,
        0,
        0
    ],
    [
        0,
        178,
        90,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        178,
        0,
        0
    ],
    [
        0,
        75,
        0,
        0,
        0,
        175,
        179,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        75,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        180,
        180,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        82,
        83,
        84,
        85,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        83,
        83,
        85,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        181,
        181,
        85,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        182,
        181,
        181,
        85,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        183,
        184,
        185,
        186,
        187,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        86,
        0,
        0,
        0,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        188,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        189,
        170,
        190,
        191,
        22,
        23,
        0,
        24,
        0,
        0,
        192,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        76,
        193,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        194,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        0,
        194,
        0,
        0,
        0,
        0
    ],
    [
        0,
        178,
        90,
        0,
        0,
        76,
        193,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        178,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        29,
        95,
        31,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        36,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        100,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        0,
        100,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        195,
        196,
        197,
        198,
        32,
        33,
        0,
        34,
        0,
        0,
        199,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        96,
        0,
        202,
        0,
        203,
        203,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        96,
        0,
        0
    ],
    [
        0,
        204,
        111,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        204,
        0,
        0
    ],
    [
        0,
        96,
        0,
        0,
        0,
        201,
        205,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        96,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        206,
        206,
        32,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        103,
        104,
        105,
        106,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        104,
        104,
        106,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        207,
        207,
        106,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        208,
        207,
        207,
        106,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        209,
        210,
        211,
        212,
        213,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        107,
        0,
        0,
        0,
        0,
        34,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        214,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        215,
        196,
        216,
        217,
        32,
        33,
        0,
        34,
        0,
        0,
        218,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        97,
        219,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        220,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        0,
        220,
        0,
        0,
        0,
        0
    ],
    [
        0,
        204,
        111,
        0,
        0,
        97,
        219,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        204,
        0,
        0
    ],
    [
        0,
        0,
        0,
        221,
        116,
        222,
        222,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        223,
        0,
        0,
        0,
        40,
        224,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        223,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        225,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        119,
        225,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        115,
        116,
        117,
        222,
        8,
        9,
        0,
        10,
        0,
        0,
        119,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        115,
        116,
        222,
        222,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        226,
        64,
        0,
        0,
        40,
        224,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        226,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        39,
        0,
        0,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        39,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        227,
        0,
        228,
        229,
        0,
        9,
        0,
        10,
        0,
        0,
        230,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        39,
        0,
        122,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        39,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        8,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        231,
        231,
        49,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        232,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        130,
        131,
        132,
        133,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        131,
        131,
        133,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        233,
        233,
        133,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        234,
        233,
        233,
        133,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        235,
        236,
        237,
        238,
        239,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        54,
        56,
        56,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        61,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        240,
        241,
        242,
        243,
        57,
        58,
        0,
        59,
        0,
        0,
        244,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        136,
        0,
        247,
        0,
        248,
        248,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        136,
        0,
        0
    ],
    [
        0,
        249,
        151,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        249,
        0,
        0
    ],
    [
        0,
        136,
        0,
        0,
        0,
        246,
        250,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        136,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        251,
        251,
        57,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        143,
        144,
        145,
        146,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        144,
        144,
        146,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        252,
        252,
        146,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        253,
        252,
        252,
        146,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        254,
        255,
        256,
        257,
        258,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        59,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        147,
        0,
        0,
        0,
        0,
        59,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        259,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        260,
        241,
        261,
        262,
        57,
        58,
        0,
        59,
        0,
        0,
        263,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        137,
        264,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        265,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        0,
        265,
        0,
        0,
        0,
        0
    ],
    [
        0,
        249,
        151,
        0,
        0,
        137,
        264,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        249,
        0,
        0
    ],
    [
        0,
        0,
        0,
        221,
        116,
        222,
        222,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        225,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        158,
        225,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        155,
        116,
        156,
        222,
        8,
        9,
        0,
        10,
        0,
        0,
        158,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        155,
        116,
        222,
        222,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        43,
        266,
        266,
        8,
        161,
        0,
        24,
        0,
        0,
        12,
        267,
        0,
        0,
        0,
        0
    ],
    [
        0,
        75,
        0,
        176,
        43,
        268,
        268,
        269,
        161,
        0,
        24,
        0,
        0,
        0,
        267,
        0,
        75,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        270,
        0,
        0,
        271,
        0,
        162,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        272,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        273,
        274,
        0,
        0,
        40,
        41,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        273,
        0,
        0
    ],
    [
        0,
        0,
        0,
        40,
        0,
        123,
        123,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        121,
        275,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        166,
        0,
        0,
        0,
        0,
        72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        276,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        277,
        170,
        278,
        278,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        279,
        0,
        0,
        0,
        76,
        280,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        279,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        281,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        173,
        281,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        169,
        170,
        171,
        278,
        22,
        23,
        0,
        24,
        0,
        0,
        173,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        169,
        170,
        278,
        278,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        282,
        90,
        0,
        0,
        76,
        280,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        282,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        75,
        0,
        0,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        75,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        283,
        0,
        284,
        285,
        0,
        23,
        0,
        24,
        0,
        0,
        286,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        75,
        0,
        176,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        75,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        287,
        287,
        85,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        288,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        184,
        185,
        186,
        187,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        185,
        185,
        187,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        289,
        289,
        187,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        290,
        289,
        289,
        187,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        291,
        292,
        293,
        294,
        295,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        277,
        170,
        278,
        278,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        281,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        192,
        281,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        189,
        170,
        190,
        278,
        22,
        23,
        0,
        24,
        0,
        0,
        192,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        189,
        170,
        278,
        278,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        76,
        0,
        177,
        177,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        175,
        296,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        297,
        196,
        298,
        298,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        299,
        0,
        0,
        0,
        97,
        300,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        299,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        301,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        199,
        301,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        195,
        196,
        197,
        298,
        32,
        33,
        0,
        34,
        0,
        0,
        199,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        195,
        196,
        298,
        298,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        302,
        111,
        0,
        0,
        97,
        300,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        302,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        96,
        0,
        0,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        96,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        303,
        0,
        304,
        305,
        0,
        33,
        0,
        34,
        0,
        0,
        306,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        96,
        0,
        202,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        96,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        32,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        307,
        307,
        106,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        308,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        210,
        211,
        212,
        213,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        211,
        211,
        213,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        309,
        309,
        213,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        310,
        309,
        309,
        213,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        311,
        312,
        313,
        314,
        315,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        297,
        196,
        298,
        298,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        301,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        218,
        301,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        215,
        196,
        216,
        298,
        32,
        33,
        0,
        34,
        0,
        0,
        218,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        215,
        196,
        298,
        298,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        97,
        0,
        203,
        203,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        201,
        316,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        116,
        222,
        222,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        225,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        0,
        225,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        317,
        318,
        319,
        320,
        8,
        9,
        0,
        10,
        0,
        0,
        321,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        223,
        0,
        323,
        0,
        123,
        123,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        223,
        0,
        0
    ],
    [
        0,
        223,
        0,
        0,
        0,
        121,
        324,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        223,
        0,
        0
    ],
    [
        0,
        0,
        0,
        325,
        318,
        326,
        327,
        8,
        9,
        0,
        10,
        0,
        0,
        328,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        64,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        9,
        0,
        0,
        0,
        0,
        230,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        227,
        0,
        228,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        230,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        227,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        49,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        46,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        329,
        329,
        133,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        330,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        236,
        237,
        238,
        239,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        237,
        237,
        239,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        331,
        331,
        239,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        332,
        331,
        331,
        239,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        333,
        40,
        121,
        334,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        335,
        241,
        336,
        336,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        337,
        0,
        0,
        0,
        137,
        338,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        337,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        339,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        244,
        339,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        240,
        241,
        242,
        336,
        57,
        58,
        0,
        59,
        0,
        0,
        244,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        240,
        241,
        336,
        336,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        340,
        151,
        0,
        0,
        137,
        338,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        340,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        136,
        0,
        0,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        136,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        341,
        0,
        342,
        343,
        0,
        58,
        0,
        59,
        0,
        0,
        344,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        136,
        0,
        247,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        136,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        57,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        345,
        345,
        146,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        346,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        255,
        256,
        257,
        258,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        256,
        256,
        258,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        347,
        347,
        258,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        348,
        347,
        347,
        258,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        349,
        350,
        351,
        352,
        353,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        335,
        241,
        336,
        336,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        339,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        263,
        339,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        260,
        241,
        261,
        336,
        57,
        58,
        0,
        59,
        0,
        0,
        263,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        260,
        241,
        336,
        336,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        137,
        0,
        248,
        248,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        246,
        354,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        126,
        126,
        8,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        355,
        90,
        0,
        0,
        121,
        125,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        355,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        356,
        356,
        269,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        357,
        358,
        359,
        360,
        361,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        162,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        270,
        0,
        0,
        0,
        0,
        162,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        363,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        364,
        116,
        365,
        366,
        8,
        161,
        0,
        162,
        0,
        0,
        367,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        368,
        368,
        0,
        161,
        0,
        162,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        40,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        170,
        278,
        278,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        174,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        281,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        0,
        281,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        369,
        370,
        371,
        372,
        22,
        23,
        0,
        24,
        0,
        0,
        373,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        279,
        0,
        375,
        0,
        177,
        177,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        279,
        0,
        0
    ],
    [
        0,
        279,
        0,
        0,
        0,
        175,
        376,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        279,
        0,
        0
    ],
    [
        0,
        0,
        0,
        377,
        370,
        378,
        379,
        22,
        23,
        0,
        24,
        0,
        0,
        380,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        90,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        286,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        283,
        0,
        284,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        286,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        283,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        85,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        82,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        381,
        381,
        187,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        382,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        292,
        293,
        294,
        295,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        293,
        293,
        295,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        383,
        383,
        295,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        384,
        383,
        383,
        295,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        385,
        76,
        175,
        386,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        76,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        196,
        298,
        298,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        200,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        301,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        0,
        301,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        387,
        388,
        389,
        390,
        32,
        33,
        0,
        34,
        0,
        0,
        391,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        299,
        0,
        393,
        0,
        203,
        203,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        299,
        0,
        0
    ],
    [
        0,
        299,
        0,
        0,
        0,
        201,
        394,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        299,
        0,
        0
    ],
    [
        0,
        0,
        0,
        395,
        388,
        396,
        397,
        32,
        33,
        0,
        34,
        0,
        0,
        398,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        111,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        306,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        303,
        0,
        304,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        306,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        303,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        106,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        103,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        399,
        399,
        213,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        400,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        312,
        313,
        314,
        315,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        313,
        313,
        315,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        401,
        401,
        315,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        402,
        401,
        401,
        315,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        403,
        97,
        201,
        404,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        97,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        405,
        318,
        406,
        406,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        407,
        0,
        0,
        0,
        40,
        408,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        407,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        409,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        321,
        409,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        317,
        318,
        319,
        406,
        8,
        9,
        0,
        10,
        0,
        0,
        321,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        317,
        318,
        406,
        406,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        410,
        64,
        0,
        0,
        40,
        408,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        410,
        0,
        0
    ],
    [
        0,
        223,
        0,
        0,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        223,
        0,
        0
    ],
    [
        0,
        223,
        0,
        323,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        223,
        0,
        0
    ],
    [
        0,
        0,
        0,
        405,
        318,
        406,
        406,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        409,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        328,
        409,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        325,
        318,
        326,
        406,
        8,
        9,
        0,
        10,
        0,
        0,
        328,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        325,
        318,
        406,
        406,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        133,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        130,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        411,
        411,
        239,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        412,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        40,
        121,
        334,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        413,
        0,
        0,
        0,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        241,
        336,
        336,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        245,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        339,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        0,
        339,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        414,
        415,
        416,
        417,
        57,
        58,
        0,
        59,
        0,
        0,
        418,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        337,
        0,
        420,
        0,
        248,
        248,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        337,
        0,
        0
    ],
    [
        0,
        337,
        0,
        0,
        0,
        246,
        421,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        337,
        0,
        0
    ],
    [
        0,
        0,
        0,
        422,
        415,
        423,
        424,
        57,
        58,
        0,
        59,
        0,
        0,
        425,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        151,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        58,
        0,
        0,
        0,
        0,
        344,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        341,
        0,
        342,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        344,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        341,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        146,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        143,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        426,
        426,
        258,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        427,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        350,
        351,
        352,
        353,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        351,
        351,
        353,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        428,
        428,
        353,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        429,
        428,
        428,
        353,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        430,
        137,
        246,
        431,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        137,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        432,
        116,
        433,
        434,
        8,
        161,
        0,
        162,
        0,
        0,
        435,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        180,
        180,
        269,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        358,
        359,
        360,
        361,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        359,
        359,
        361,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        436,
        436,
        361,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        437,
        436,
        436,
        361,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        438,
        439,
        440,
        441,
        442,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        443,
        274,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        443,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        444,
        116,
        445,
        445,
        8,
        161,
        0,
        162,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        225,
        44,
        44,
        8,
        161,
        0,
        0,
        0,
        0,
        367,
        225,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        364,
        116,
        365,
        445,
        8,
        161,
        0,
        162,
        0,
        0,
        367,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        364,
        116,
        445,
        445,
        8,
        161,
        0,
        162,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        446,
        370,
        447,
        447,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        448,
        0,
        0,
        0,
        76,
        449,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        448,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        450,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        373,
        450,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        369,
        370,
        371,
        447,
        22,
        23,
        0,
        24,
        0,
        0,
        373,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        369,
        370,
        447,
        447,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        451,
        90,
        0,
        0,
        76,
        449,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        451,
        0,
        0
    ],
    [
        0,
        279,
        0,
        0,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        279,
        0,
        0
    ],
    [
        0,
        279,
        0,
        375,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        279,
        0,
        0
    ],
    [
        0,
        0,
        0,
        446,
        370,
        447,
        447,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        450,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        380,
        450,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        377,
        370,
        378,
        447,
        22,
        23,
        0,
        24,
        0,
        0,
        380,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        377,
        370,
        447,
        447,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        187,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        184,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        452,
        452,
        295,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        453,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        76,
        175,
        386,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        454,
        0,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        455,
        388,
        456,
        456,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        457,
        0,
        0,
        0,
        97,
        458,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        457,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        459,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        391,
        459,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        387,
        388,
        389,
        456,
        32,
        33,
        0,
        34,
        0,
        0,
        391,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        387,
        388,
        456,
        456,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        460,
        111,
        0,
        0,
        97,
        458,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        460,
        0,
        0
    ],
    [
        0,
        299,
        0,
        0,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        299,
        0,
        0
    ],
    [
        0,
        299,
        0,
        393,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        299,
        0,
        0
    ],
    [
        0,
        0,
        0,
        455,
        388,
        456,
        456,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        459,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        398,
        459,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        395,
        388,
        396,
        456,
        32,
        33,
        0,
        34,
        0,
        0,
        398,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        395,
        388,
        456,
        456,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        213,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        210,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        461,
        461,
        315,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        462,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        97,
        201,
        404,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        463,
        0,
        0,
        0,
        33,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        318,
        406,
        406,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        322,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        409,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        0,
        409,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        464,
        465,
        466,
        467,
        8,
        9,
        0,
        10,
        0,
        0,
        468,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        407,
        0,
        470,
        0,
        123,
        123,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        407,
        0,
        0
    ],
    [
        0,
        407,
        0,
        0,
        0,
        121,
        471,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        407,
        0,
        0
    ],
    [
        0,
        0,
        0,
        472,
        465,
        473,
        474,
        8,
        9,
        0,
        10,
        0,
        0,
        475,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        239,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        236,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        476,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        477,
        415,
        478,
        478,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        479,
        0,
        0,
        0,
        137,
        480,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        479,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        481,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        418,
        481,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        414,
        415,
        416,
        478,
        57,
        58,
        0,
        59,
        0,
        0,
        418,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        414,
        415,
        478,
        478,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        482,
        151,
        0,
        0,
        137,
        480,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        482,
        0,
        0
    ],
    [
        0,
        337,
        0,
        0,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        337,
        0,
        0
    ],
    [
        0,
        337,
        0,
        420,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        337,
        0,
        0
    ],
    [
        0,
        0,
        0,
        477,
        415,
        478,
        478,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        481,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        425,
        481,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        422,
        415,
        423,
        478,
        57,
        58,
        0,
        59,
        0,
        0,
        425,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        422,
        415,
        478,
        478,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        258,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        483,
        483,
        353,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        484,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        137,
        246,
        431,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        485,
        0,
        0,
        0,
        58,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        444,
        116,
        445,
        445,
        8,
        161,
        0,
        162,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        225,
        44,
        44,
        8,
        161,
        0,
        0,
        0,
        0,
        435,
        225,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        432,
        116,
        433,
        445,
        8,
        161,
        0,
        162,
        0,
        0,
        435,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        432,
        116,
        445,
        445,
        8,
        161,
        0,
        162,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        486,
        486,
        361,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        487,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        439,
        440,
        441,
        442,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        440,
        440,
        442,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        488,
        488,
        442,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        489,
        488,
        488,
        442,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        490,
        491,
        492,
        493,
        494,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        495,
        0,
        496,
        497,
        0,
        161,
        0,
        162,
        0,
        0,
        498,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        116,
        445,
        445,
        8,
        161,
        0,
        162,
        0,
        0,
        0,
        120,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        225,
        44,
        44,
        8,
        161,
        0,
        0,
        0,
        0,
        0,
        225,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        370,
        447,
        447,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        374,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        450,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        0,
        450,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        499,
        500,
        501,
        502,
        22,
        23,
        0,
        24,
        0,
        0,
        503,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        448,
        0,
        505,
        0,
        177,
        177,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        448,
        0,
        0
    ],
    [
        0,
        448,
        0,
        0,
        0,
        175,
        506,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        448,
        0,
        0
    ],
    [
        0,
        0,
        0,
        507,
        500,
        508,
        509,
        22,
        23,
        0,
        24,
        0,
        0,
        510,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        295,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        292,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        511,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        388,
        456,
        456,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        392,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        459,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        0,
        459,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        512,
        513,
        514,
        515,
        32,
        33,
        0,
        34,
        0,
        0,
        516,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        457,
        0,
        518,
        0,
        203,
        203,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        457,
        0,
        0
    ],
    [
        0,
        457,
        0,
        0,
        0,
        201,
        519,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        457,
        0,
        0
    ],
    [
        0,
        0,
        0,
        520,
        513,
        521,
        522,
        32,
        33,
        0,
        34,
        0,
        0,
        523,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        315,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        312,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        524,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        525,
        465,
        526,
        526,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        527,
        0,
        0,
        0,
        40,
        528,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        527,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        529,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        468,
        529,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        464,
        465,
        466,
        526,
        8,
        9,
        0,
        10,
        0,
        0,
        468,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        464,
        465,
        526,
        526,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        530,
        64,
        0,
        0,
        40,
        528,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        530,
        0,
        0
    ],
    [
        0,
        407,
        0,
        0,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        407,
        0,
        0
    ],
    [
        0,
        407,
        0,
        470,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        407,
        0,
        0
    ],
    [
        0,
        0,
        0,
        525,
        465,
        526,
        526,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        529,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        475,
        529,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        472,
        465,
        473,
        526,
        8,
        9,
        0,
        10,
        0,
        0,
        475,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        472,
        465,
        526,
        526,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        40,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        415,
        478,
        478,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        419,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        481,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        0,
        481,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        531,
        532,
        533,
        534,
        57,
        58,
        0,
        59,
        0,
        0,
        535,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        479,
        0,
        537,
        0,
        248,
        248,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        479,
        0,
        0
    ],
    [
        0,
        479,
        0,
        0,
        0,
        246,
        538,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        479,
        0,
        0
    ],
    [
        0,
        0,
        0,
        539,
        532,
        540,
        541,
        57,
        58,
        0,
        59,
        0,
        0,
        542,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        353,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        350,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        543,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        361,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        358,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        544,
        544,
        442,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        545,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        491,
        492,
        493,
        494,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        492,
        492,
        494,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        546,
        546,
        494,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        547,
        546,
        546,
        494,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        548,
        549,
        368,
        550,
        0,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        274,
        0,
        368,
        368,
        0,
        161,
        0,
        162,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        161,
        0,
        0,
        0,
        0,
        498,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        495,
        0,
        496,
        368,
        0,
        161,
        0,
        162,
        0,
        0,
        498,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        495,
        0,
        368,
        368,
        0,
        161,
        0,
        162,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        551,
        500,
        552,
        552,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        553,
        0,
        0,
        0,
        76,
        554,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        553,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        555,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        503,
        555,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        499,
        500,
        501,
        552,
        22,
        23,
        0,
        24,
        0,
        0,
        503,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        499,
        500,
        552,
        552,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        556,
        90,
        0,
        0,
        76,
        554,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        556,
        0,
        0
    ],
    [
        0,
        448,
        0,
        0,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        448,
        0,
        0
    ],
    [
        0,
        448,
        0,
        505,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        448,
        0,
        0
    ],
    [
        0,
        0,
        0,
        551,
        500,
        552,
        552,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        555,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        510,
        555,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        507,
        500,
        508,
        552,
        22,
        23,
        0,
        24,
        0,
        0,
        510,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        507,
        500,
        552,
        552,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        76,
        0,
        0
    ],
    [
        0,
        0,
        0,
        557,
        513,
        558,
        558,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        559,
        0,
        0,
        0,
        97,
        560,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        559,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        561,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        516,
        561,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        512,
        513,
        514,
        558,
        32,
        33,
        0,
        34,
        0,
        0,
        516,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        512,
        513,
        558,
        558,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        562,
        111,
        0,
        0,
        97,
        560,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        562,
        0,
        0
    ],
    [
        0,
        457,
        0,
        0,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        457,
        0,
        0
    ],
    [
        0,
        457,
        0,
        518,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        457,
        0,
        0
    ],
    [
        0,
        0,
        0,
        557,
        513,
        558,
        558,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        561,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        523,
        561,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        520,
        513,
        521,
        558,
        32,
        33,
        0,
        34,
        0,
        0,
        523,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        520,
        513,
        558,
        558,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        97,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        465,
        526,
        526,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        469,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        529,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        0,
        529,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        563,
        66,
        564,
        565,
        8,
        9,
        0,
        10,
        0,
        0,
        566,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        527,
        0,
        567,
        0,
        123,
        123,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        527,
        0,
        0
    ],
    [
        0,
        527,
        0,
        0,
        0,
        121,
        568,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        527,
        0,
        0
    ],
    [
        0,
        0,
        0,
        569,
        66,
        570,
        571,
        8,
        9,
        0,
        10,
        0,
        0,
        572,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        573,
        532,
        574,
        574,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        575,
        0,
        0,
        0,
        137,
        576,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        575,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        577,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        535,
        577,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        531,
        532,
        533,
        574,
        57,
        58,
        0,
        59,
        0,
        0,
        535,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        531,
        532,
        574,
        574,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        578,
        151,
        0,
        0,
        137,
        576,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        578,
        0,
        0
    ],
    [
        0,
        479,
        0,
        0,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        479,
        0,
        0
    ],
    [
        0,
        479,
        0,
        537,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        479,
        0,
        0
    ],
    [
        0,
        0,
        0,
        573,
        532,
        574,
        574,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        577,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        542,
        577,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        539,
        532,
        540,
        574,
        57,
        58,
        0,
        59,
        0,
        0,
        542,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        539,
        532,
        574,
        574,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        137,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        442,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        439,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        579,
        579,
        494,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        580,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        549,
        368,
        550,
        0,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        368,
        368,
        0,
        161,
        0,
        162,
        0,
        0,
        0,
        362,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        581,
        0,
        0,
        0,
        161,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        500,
        552,
        552,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        504,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        555,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        0,
        555,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        582,
        91,
        583,
        584,
        22,
        23,
        0,
        24,
        0,
        0,
        585,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        553,
        0,
        586,
        0,
        177,
        177,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        553,
        0,
        0
    ],
    [
        0,
        553,
        0,
        0,
        0,
        175,
        587,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        553,
        0,
        0
    ],
    [
        0,
        0,
        0,
        588,
        91,
        589,
        590,
        22,
        23,
        0,
        24,
        0,
        0,
        591,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        513,
        558,
        558,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        517,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        561,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        0,
        561,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        592,
        112,
        593,
        594,
        32,
        33,
        0,
        34,
        0,
        0,
        595,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        559,
        0,
        596,
        0,
        203,
        203,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        559,
        0,
        0
    ],
    [
        0,
        559,
        0,
        0,
        0,
        201,
        597,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        559,
        0,
        0
    ],
    [
        0,
        0,
        0,
        598,
        112,
        599,
        600,
        32,
        33,
        0,
        34,
        0,
        0,
        601,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        602,
        66,
        67,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        165,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        566,
        165,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        563,
        66,
        564,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        566,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        563,
        66,
        67,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        527,
        0,
        0,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        527,
        0,
        0
    ],
    [
        0,
        527,
        0,
        567,
        0,
        121,
        121,
        0,
        9,
        0,
        10,
        0,
        0,
        0,
        42,
        0,
        527,
        0,
        0
    ],
    [
        0,
        0,
        0,
        602,
        66,
        67,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        165,
        44,
        44,
        8,
        9,
        0,
        0,
        0,
        0,
        572,
        165,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        569,
        66,
        570,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        572,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        569,
        66,
        67,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        0,
        532,
        574,
        574,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        536,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        577,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        0,
        577,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        603,
        152,
        604,
        605,
        57,
        58,
        0,
        59,
        0,
        0,
        606,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        575,
        0,
        607,
        0,
        248,
        248,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        575,
        0,
        0
    ],
    [
        0,
        575,
        0,
        0,
        0,
        246,
        608,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        575,
        0,
        0
    ],
    [
        0,
        0,
        0,
        609,
        152,
        610,
        611,
        57,
        58,
        0,
        59,
        0,
        0,
        612,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        494,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        491,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        613,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        614,
        91,
        92,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        194,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        585,
        194,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        582,
        91,
        583,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        585,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        582,
        91,
        92,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        553,
        0,
        0,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        553,
        0,
        0
    ],
    [
        0,
        553,
        0,
        586,
        0,
        175,
        175,
        0,
        23,
        0,
        24,
        0,
        0,
        0,
        78,
        0,
        553,
        0,
        0
    ],
    [
        0,
        0,
        0,
        614,
        91,
        92,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        194,
        80,
        80,
        22,
        23,
        0,
        0,
        0,
        0,
        591,
        194,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        588,
        91,
        589,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        591,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        588,
        91,
        92,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        615,
        112,
        113,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        220,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        595,
        220,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        592,
        112,
        593,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        595,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        592,
        112,
        113,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        559,
        0,
        0,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        559,
        0,
        0
    ],
    [
        0,
        559,
        0,
        596,
        0,
        201,
        201,
        0,
        33,
        0,
        34,
        0,
        0,
        0,
        99,
        0,
        559,
        0,
        0
    ],
    [
        0,
        0,
        0,
        615,
        112,
        113,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        220,
        101,
        101,
        32,
        33,
        0,
        0,
        0,
        0,
        601,
        220,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        598,
        112,
        599,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        601,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        598,
        112,
        113,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        66,
        67,
        67,
        8,
        9,
        0,
        10,
        0,
        0,
        0,
        68,
        0,
        0,
        16,
        0
    ],
    [
        0,
        0,
        0,
        616,
        152,
        153,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        265,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        606,
        265,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        603,
        152,
        604,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        606,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        603,
        152,
        153,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        575,
        0,
        0,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        575,
        0,
        0
    ],
    [
        0,
        575,
        0,
        607,
        0,
        246,
        246,
        0,
        58,
        0,
        59,
        0,
        0,
        0,
        139,
        0,
        575,
        0,
        0
    ],
    [
        0,
        0,
        0,
        616,
        152,
        153,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        265,
        141,
        141,
        57,
        58,
        0,
        0,
        0,
        0,
        612,
        265,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        609,
        152,
        610,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        612,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        609,
        152,
        153,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        154,
        0,
        0,
        62,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        549,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        91,
        92,
        92,
        22,
        23,
        0,
        24,
        0,
        0,
        0,
        93,
        0,
        0,
        27,
        0
    ],
    [
        0,
        0,
        0,
        0,
        112,
        113,
        113,
        32,
        33,
        0,
        34,
        0,
        0,
        0,
        114,
        0,
        0,
        37,
        0
    ],
    [
        0,
        0,
        0,
        0,
        152,
        153,
        153,
        57,
        58,
        0,
        59,
        0,
        0,
        0,
        154,
        0,
        0,
        62,
        0
    ]
];
var accepting = [
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    true,
    false,
    true,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    false,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    false,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    false,
    false,
    false,
    false,
    true,
    true,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    false,
    false,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    false,
    true,
    true,
    true
];
var tags = [
    [],
    [
        "broken_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [
        "broken_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [],
    [
        "symbol_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [
        "broken_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [],
    [],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [],
    [],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [],
    [],
    [
        "broken_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [],
    [],
    [],
    [
        "consonant_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [],
    [],
    [],
    [
        "vowel_syllable"
    ],
    [],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [],
    [],
    [
        "standalone_cluster"
    ],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [],
    [],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [],
    [],
    [],
    [],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [],
    [],
    [],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [
        "consonant_syllable",
        "broken_cluster"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [],
    [],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [],
    [
        "vowel_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "broken_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "standalone_cluster"
    ],
    [
        "standalone_cluster"
    ],
    [],
    [
        "consonant_syllable"
    ],
    [
        "vowel_syllable"
    ],
    [
        "standalone_cluster"
    ]
];
var indicMachine = {
    stateTable: stateTable,
    accepting: accepting,
    tags: tags
};
var categories = [
    "O",
    "IND",
    "S",
    "GB",
    "B",
    "FM",
    "CGJ",
    "VMAbv",
    "VMPst",
    "VAbv",
    "VPst",
    "CMBlw",
    "VPre",
    "VBlw",
    "H",
    "VMBlw",
    "CMAbv",
    "MBlw",
    "CS",
    "R",
    "SUB",
    "MPst",
    "MPre",
    "FAbv",
    "FPst",
    "FBlw",
    "SMAbv",
    "SMBlw",
    "VMPre",
    "ZWNJ",
    "ZWJ",
    "WJ",
    "VS",
    "N",
    "HN",
    "MAbv"
];
var decompositions$1 = {
    "2507": [
        2503,
        2494
    ],
    "2508": [
        2503,
        2519
    ],
    "2888": [
        2887,
        2902
    ],
    "2891": [
        2887,
        2878
    ],
    "2892": [
        2887,
        2903
    ],
    "3018": [
        3014,
        3006
    ],
    "3019": [
        3015,
        3006
    ],
    "3020": [
        3014,
        3031
    ],
    "3144": [
        3142,
        3158
    ],
    "3264": [
        3263,
        3285
    ],
    "3271": [
        3270,
        3285
    ],
    "3272": [
        3270,
        3286
    ],
    "3274": [
        3270,
        3266
    ],
    "3275": [
        3270,
        3266,
        3285
    ],
    "3402": [
        3398,
        3390
    ],
    "3403": [
        3399,
        3390
    ],
    "3404": [
        3398,
        3415
    ],
    "3546": [
        3545,
        3530
    ],
    "3548": [
        3545,
        3535
    ],
    "3549": [
        3545,
        3535,
        3530
    ],
    "3550": [
        3545,
        3551
    ],
    "3635": [
        3661,
        3634
    ],
    "3763": [
        3789,
        3762
    ],
    "3955": [
        3953,
        3954
    ],
    "3957": [
        3953,
        3956
    ],
    "3958": [
        4018,
        3968
    ],
    "3959": [
        4018,
        3953,
        3968
    ],
    "3960": [
        4019,
        3968
    ],
    "3961": [
        4019,
        3953,
        3968
    ],
    "3969": [
        3953,
        3968
    ],
    "6971": [
        6970,
        6965
    ],
    "6973": [
        6972,
        6965
    ],
    "6976": [
        6974,
        6965
    ],
    "6977": [
        6975,
        6965
    ],
    "6979": [
        6978,
        6965
    ],
    "69934": [
        69937,
        69927
    ],
    "69935": [
        69938,
        69927
    ],
    "70475": [
        70471,
        70462
    ],
    "70476": [
        70471,
        70487
    ],
    "70843": [
        70841,
        70842
    ],
    "70844": [
        70841,
        70832
    ],
    "70846": [
        70841,
        70845
    ],
    "71098": [
        71096,
        71087
    ],
    "71099": [
        71097,
        71087
    ]
};
var stateTable$1 = [
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        2,
        2,
        3,
        4,
        4,
        5,
        0,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        0,
        17,
        18,
        11,
        19,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        2,
        0,
        24,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        26,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        27,
        28,
        0,
        0,
        0,
        0,
        27,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        0,
        0,
        41,
        35,
        42,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        39,
        0,
        0,
        47
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        0,
        0,
        0,
        0,
        0,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        0,
        7,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        0,
        0,
        12,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        0,
        9,
        0,
        0,
        0,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        0,
        16,
        0,
        0,
        18,
        11,
        19,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        0,
        11,
        12,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        0,
        9,
        0,
        0,
        12,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        18,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        0,
        7,
        0,
        0,
        0,
        0,
        0,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        0,
        0,
        18,
        11,
        19,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        0,
        11,
        12,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        11,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        4,
        4,
        5,
        0,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        0,
        0,
        18,
        11,
        19,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        48,
        11,
        12,
        13,
        14,
        48,
        16,
        0,
        0,
        18,
        11,
        19,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        49,
        0,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        0,
        11,
        12,
        0,
        14,
        0,
        16,
        0,
        0,
        0,
        11,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        21,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        21,
        22,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        0,
        0,
        0,
        0,
        0,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        50,
        0,
        51,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        0,
        11,
        12,
        0,
        14,
        0,
        16,
        0,
        0,
        0,
        11,
        0,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        27,
        28,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        28,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        0,
        0,
        0,
        0,
        0,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        0,
        31,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        0,
        0,
        36,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        0,
        33,
        0,
        0,
        0,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        0,
        40,
        0,
        0,
        41,
        35,
        42,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        47
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        0,
        35,
        36,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        0,
        33,
        0,
        0,
        36,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        41,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        0,
        31,
        0,
        0,
        0,
        0,
        0,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        0,
        0,
        41,
        35,
        42,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        47
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        0,
        35,
        36,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        35,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        52,
        35,
        36,
        37,
        38,
        52,
        40,
        0,
        0,
        41,
        35,
        42,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        53,
        0,
        0,
        47
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        0,
        35,
        36,
        0,
        38,
        0,
        40,
        0,
        0,
        0,
        35,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        47
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        44,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        44,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        0,
        0,
        0,
        0,
        0,
        0,
        38,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        0,
        35,
        36,
        0,
        38,
        0,
        40,
        0,
        0,
        0,
        35,
        0,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        48,
        11,
        12,
        13,
        14,
        0,
        16,
        0,
        0,
        18,
        11,
        19,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        5,
        0,
        6,
        7,
        8,
        9,
        48,
        11,
        12,
        13,
        14,
        48,
        16,
        0,
        0,
        18,
        11,
        19,
        20,
        21,
        22,
        0,
        0,
        23,
        0,
        0,
        0,
        0,
        0,
        0,
        25
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        51,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        54,
        0,
        0
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        52,
        35,
        36,
        37,
        38,
        0,
        40,
        0,
        0,
        41,
        35,
        42,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        47
    ],
    [
        0,
        0,
        0,
        0,
        0,
        29,
        0,
        30,
        31,
        32,
        33,
        52,
        35,
        36,
        37,
        38,
        52,
        40,
        0,
        0,
        41,
        35,
        42,
        43,
        44,
        45,
        0,
        0,
        46,
        0,
        0,
        0,
        0,
        0,
        0,
        47
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        50,
        0,
        51,
        0
    ]
];
var accepting$1 = [
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    false,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true,
    true
];
var tags$1 = [
    [],
    [
        "broken_cluster"
    ],
    [
        "independent_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "numeral_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "independent_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "symbol_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "virama_terminated_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "broken_cluster"
    ],
    [
        "numeral_cluster"
    ],
    [
        "number_joiner_terminated_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "standard_cluster"
    ],
    [
        "numeral_cluster"
    ]
];
var useData = {
    categories: categories,
    decompositions: decompositions$1,
    stateTable: stateTable$1,
    accepting: accepting$1,
    tags: tags$1
};
// Cateories used in the OpenType spec:
// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
var CATEGORIES = {
    X: 1,
    C: 2,
    V: 4,
    N: 8,
    H: 16,
    ZWNJ: 32,
    ZWJ: 64,
    M: 128,
    SM: 256,
    VD: 512,
    A: 1024,
    Placeholder: 2048,
    Dotted_Circle: 4096,
    RS: 8192,
    Coeng: 16384,
    Repha: 32768,
    Ra: 65536,
    CM: 131072,
    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
};
// Visual positions in a syllable from left to right.
var POSITIONS = {
    Start: 1,
    Ra_To_Become_Reph: 2,
    Pre_M: 4,
    Pre_C: 8,
    Base_C: 16,
    After_Main: 32,
    Above_C: 64,
    Before_Sub: 128,
    Below_C: 256,
    After_Sub: 512,
    Before_Post: 1024,
    Post_C: 2048,
    After_Post: 4096,
    Final_C: 8192,
    SMVD: 16384,
    End: 32768
};
var CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;
var INDIC_CONFIGS = {
    Default: {
        hasOldSpec: false,
        virama: 0,
        basePos: 'Last',
        rephPos: POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Devanagari: {
        hasOldSpec: true,
        virama: 0x094D,
        basePos: 'Last',
        rephPos: POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Bengali: {
        hasOldSpec: true,
        virama: 0x09CD,
        basePos: 'Last',
        rephPos: POSITIONS.After_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gurmukhi: {
        hasOldSpec: true,
        virama: 0x0A4D,
        basePos: 'Last',
        rephPos: POSITIONS.Before_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gujarati: {
        hasOldSpec: true,
        virama: 0x0ACD,
        basePos: 'Last',
        rephPos: POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Oriya: {
        hasOldSpec: true,
        virama: 0x0B4D,
        basePos: 'Last',
        rephPos: POSITIONS.After_Main,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Tamil: {
        hasOldSpec: true,
        virama: 0x0BCD,
        basePos: 'Last',
        rephPos: POSITIONS.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Telugu: {
        hasOldSpec: true,
        virama: 0x0C4D,
        basePos: 'Last',
        rephPos: POSITIONS.After_Post,
        rephMode: 'Explicit',
        blwfMode: 'Post_Only'
    },
    Kannada: {
        hasOldSpec: true,
        virama: 0x0CCD,
        basePos: 'Last',
        rephPos: POSITIONS.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Post_Only'
    },
    Malayalam: {
        hasOldSpec: true,
        virama: 0x0D4D,
        basePos: 'Last',
        rephPos: POSITIONS.After_Main,
        rephMode: 'Log_Repha',
        blwfMode: 'Pre_And_Post'
    },
    // Handled by UniversalShaper
    // Sinhala: {
    //   hasOldSpec: false,
    //   virama: 0x0DCA,
    //   basePos: 'Last_Sinhala',
    //   rephPos: POSITIONS.After_Main,
    //   rephMode: 'Explicit',
    //   blwfMode: 'Pre_And_Post'
    // },
    Khmer: {
        hasOldSpec: false,
        virama: 0x17D2,
        basePos: 'First',
        rephPos: POSITIONS.Ra_To_Become_Reph,
        rephMode: 'Vis_Repha',
        blwfMode: 'Pre_And_Post'
    }
};
// Additional decompositions that aren't in Unicode
var INDIC_DECOMPOSITIONS = {
    // Khmer
    0x17BE: [
        0x17C1,
        0x17BE
    ],
    0x17BF: [
        0x17C1,
        0x17BF
    ],
    0x17C0: [
        0x17C1,
        0x17C0
    ],
    0x17C4: [
        0x17C1,
        0x17C4
    ],
    0x17C5: [
        0x17C1,
        0x17C5
    ]
};
var type$1 = "Buffer";
var data$1 = [
    0,
    17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    194,
    160,
    1,
    177,
    13,
    78,
    242,
    237,
    157,
    127,
    172,
    29,
    69,
    21,
    199,
    247,
    245,
    222,
    119,
    127,
    188,
    119,
    251,
    110,
    95,
    133,
    68,
    98,
    251,
    71,
    67,
    137,
    49,
    197,
    152,
    166,
    16,
    107,
    138,
    105,
    21,
    9,
    34,
    81,
    219,
    24,
    132,
    104,
    177,
    6,
    67,
    176,
    36,
    4,
    106,
    48,
    109,
    132,
    82,
    130,
    63,
    10,
    216,
    31,
    198,
    146,
    148,
    88,
    19,
    172,
    37,
    65,
    44,
    137,
    40,
    38,
    160,
    173,
    41,
    70,
    146,
    106,
    172,
    169,
    70,
    76,
    99,
    180,
    182,
    9,
    105,
    32,
    169,
    5,
    98,
    65,
    41,
    45,
    224,
    119,
    238,
    206,
    188,
    123,
    238,
    220,
    153,
    217,
    249,
    181,
    187,
    239,
    209,
    61,
    201,
    39,
    187,
    59,
    59,
    59,
    115,
    230,
    156,
    51,
    179,
    179,
    179,
    123,
    223,
    59,
    94,
    75,
    146,
    151,
    192,
    171,
    224,
    13,
    48,
    167,
    158,
    36,
    239,
    5,
    243,
    193,
    37,
    224,
    21,
    164,
    253,
    175,
    22,
    190,
    189,
    24,
    101,
    45,
    2,
    75,
    192,
    50,
    135,
    114,
    175,
    64,
    222,
    79,
    128,
    107,
    192,
    42,
    112,
    61,
    88,
    3,
    110,
    6,
    183,
    129,
    175,
    131,
    141,
    134,
    242,
    150,
    226,
    220,
    10,
    240,
    77,
    240,
    93,
    176,
    25,
    108,
    7,
    59,
    193,
    35,
    224,
    56,
    242,
    60,
    134,
    237,
    207,
    64,
    194,
    121,
    154,
    111,
    15,
    128,
    131,
    224,
    79,
    224,
    111,
    224,
    40,
    56,
    1,
    78,
    130,
    211,
    224,
    44,
    168,
    141,
    38,
    73,
    27,
    76,
    130,
    139,
    192,
    2,
    240,
    126,
    240,
    33,
    240,
    97,
    176,
    28,
    92,
    5,
    62,
    13,
    174,
    3,
    55,
    130,
    155,
    193,
    109,
    224,
    78,
    112,
    55,
    184,
    15,
    60,
    8,
    190,
    15,
    126,
    0,
    126,
    4,
    126,
    2,
    158,
    228,
    199,
    207,
    128,
    103,
    193,
    239,
    193,
    159,
    193,
    17,
    112,
    12,
    188,
    8,
    94,
    1,
    175,
    129,
    115,
    163,
    169,
    206,
    245,
    70,
    146,
    116,
    192,
    5,
    141,
    244,
    120,
    30,
    182,
    11,
    193,
    165,
    96,
    49,
    88,
    10,
    150,
    131,
    171,
    249,
    249,
    207,
    98,
    123,
    61,
    88,
    3,
    110,
    1,
    183,
    55,
    82,
    155,
    172,
    231,
    91,
    91,
    54,
    242,
    252,
    223,
    198,
    246,
    46,
    176,
    149,
    31,
    63,
    192,
    183,
    155,
    80,
    215,
    14,
    150,
    94,
    239,
    95,
    179,
    203,
    177,
    14,
    27,
    118,
    144,
    50,
    247,
    96,
    127,
    47,
    120,
    10,
    236,
    3,
    191,
    3,
    127,
    4,
    127,
    5,
    255,
    0,
    47,
    128,
    147,
    36,
    255,
    155,
    124,
    123,
    154,
    167,
    109,
    99,
    62,
    198,
    126,
    173,
    153,
    36,
    227,
    224,
    61,
    205,
    212,
    94,
    239,
    195,
    246,
    226,
    102,
    154,
    103,
    17,
    79,
    91,
    130,
    237,
    50,
    112,
    101,
    51,
    141,
    39,
    17,
    75,
    215,
    226,
    120,
    37,
    184,
    1,
    172,
    1,
    183,
    128,
    219,
    249,
    53,
    235,
    249,
    118,
    19,
    182,
    155,
    121,
    121,
    226,
    186,
    173,
    56,
    222,
    209,
    52,
    183,
    117,
    87,
    198,
    121,
    106,
    227,
    31,
    35,
    239,
    22,
    110,
    251,
    245,
    216,
    254,
    20,
    199,
    191,
    0,
    191,
    38,
    101,
    252,
    22,
    251,
    127,
    0,
    247,
    224,
    124,
    7,
    252,
    69,
    81,
    254,
    223,
    45,
    234,
    180,
    101,
    173,
    136,
    5,
    148,
    121,
    204,
    177,
    220,
    151,
    34,
    234,
    81,
    20,
    255,
    134,
    206,
    255,
    1,
    111,
    128,
    164,
    149,
    36,
    163,
    173,
    52,
    125,
    111,
    61,
    181,
    185,
    156,
    127,
    54,
    63,
    47,
    250,
    226,
    5,
    56,
    158,
    7,
    22,
    114,
    104,
    222,
    69,
    173,
    52,
    110,
    150,
    144,
    244,
    179,
    6,
    93,
    88,
    108,
    47,
    35,
    121,
    87,
    241,
    250,
    175,
    145,
    244,
    248,
    56,
    242,
    92,
    77,
    242,
    49,
    93,
    133,
    223,
    62,
    211,
    82,
    235,
    45,
    48,
    157,
    171,
    168,
    168,
    240,
    99,
    91,
    213,
    175,
    42,
    42,
    42,
    42,
    42,
    42,
    42,
    42,
    42,
    28,
    217,
    198,
    215,
    25,
    202,
    214,
    67,
    102,
    39,
    127,
    214,
    189,
    174,
    101,
    127,
    205,
    91,
    154,
    244,
    55,
    53,
    233,
    95,
    224,
    207,
    202,
    95,
    198,
    246,
    171,
    224,
    14,
    176,
    1,
    220,
    11,
    238,
    7,
    91,
    193,
    67,
    224,
    135,
    224,
    81,
    240,
    4,
    120,
    170,
    149,
    174,
    45,
    237,
    195,
    246,
    0,
    56,
    8,
    14,
    131,
    35,
    224,
    40,
    56,
    1,
    78,
    181,
    210,
    245,
    156,
    215,
    177,
    125,
    139,
    61,
    223,
    183,
    241,
    12,
    15,
    46,
    108,
    167,
    245,
    206,
    107,
    247,
    117,
    88,
    136,
    253,
    75,
    219,
    246,
    109,
    172,
    168,
    168,
    168,
    168,
    8,
    135,
    173,
    91,
    94,
    134,
    177,
    247,
    76,
    173,
    191,
    222,
    94,
    22,
    101,
    219,
    162,
    162,
    162,
    34,
    14,
    175,
    145,
    119,
    82,
    91,
    121,
    255,
    94,
    134,
    113,
    230,
    74,
    112,
    173,
    52,
    215,
    251,
    156,
    227,
    220,
    175,
    195,
    199,
    138,
    83,
    188,
    142,
    183,
    193,
    23,
    219,
    253,
    247,
    169,
    95,
    193,
    254,
    173,
    82,
    153,
    119,
    180,
    251,
    239,
    117,
    40,
    236,
    189,
    204,
    6,
    156,
    187,
    119,
    26,
    204,
    63,
    147,
    57,
    41,
    43,
    192,
    157,
    96,
    127,
    55,
    155,
    45,
    200,
    119,
    72,
    147,
    247,
    85,
    164,
    47,
    156,
    76,
    146,
    213,
    224,
    33,
    240,
    252,
    228,
    224,
    249,
    227,
    56,
    223,
    153,
    139,
    185,
    56,
    88,
    13,
    238,
    29,
    75,
    146,
    103,
    65,
    50,
    14,
    95,
    129,
    187,
    192,
    10,
    28,
    239,
    227,
    219,
    163,
    124,
    75,
    153,
    223,
    25,
    78,
    147,
    185,
    17,
    121,
    54,
    146,
    124,
    191,
    193,
    254,
    57,
    126,
    124,
    197,
    236,
    36,
    185,
    27,
    236,
    7,
    15,
    143,
    196,
    229,
    28,
    47,
    243,
    178,
    9,
    216,
    115,
    34,
    221,
    223,
    52,
    161,
    214,
    241,
    128,
    38,
    189,
    162,
    162,
    162,
    162,
    34,
    127,
    222,
    41,
    121,
    12,
    142,
    125,
    255,
    113,
    97,
    121,
    183,
    252,
    250,
    203,
    126,
    254,
    43,
    155,
    171,
    192,
    253,
    152,
    7,
    126,
    175,
    61,
    252,
    60,
    202,
    190,
    243,
    121,
    24,
    233,
    187,
    200,
    60,
    113,
    55,
    246,
    31,
    111,
    167,
    243,
    209,
    45,
    138,
    242,
    196,
    247,
    119,
    236,
    219,
    177,
    51,
    252,
    26,
    246,
    188,
    205,
    190,
    169,
    99,
    229,
    253,
    156,
    151,
    245,
    43,
    69,
    125,
    12,
    86,
    230,
    254,
    246,
    224,
    243,
    241,
    205,
    124,
    251,
    92,
    123,
    184,
    62,
    155,
    57,
    38,
    251,
    102,
    138,
    173,
    119,
    179,
    57,
    179,
    124,
    253,
    33,
    148,
    121,
    24,
    28,
    105,
    247,
    231,
    198,
    199,
    120,
    61,
    47,
    98,
    251,
    50,
    248,
    175,
    164,
    207,
    219,
    237,
    254,
    60,
    188,
    129,
    62,
    52,
    27,
    92,
    56,
    70,
    230,
    180,
    60,
    223,
    124,
    158,
    118,
    134,
    127,
    247,
    181,
    27,
    233,
    151,
    32,
    237,
    131,
    99,
    195,
    250,
    95,
    62,
    214,
    63,
    62,
    202,
    203,
    254,
    232,
    152,
    157,
    15,
    5,
    247,
    248,
    248,
    31,
    117,
    124,
    10,
    172,
    2,
    159,
    7,
    95,
    2,
    55,
    129,
    29,
    56,
    183,
    22,
    219,
    117,
    96,
    195,
    88,
    58,
    79,
    254,
    14,
    216,
    198,
    206,
    129,
    93,
    96,
    15,
    216,
    11,
    158,
    36,
    122,
    62,
    51,
    150,
    206,
    167,
    15,
    130,
    195,
    224,
    8,
    56,
    10,
    78,
    128,
    83,
    22,
    237,
    121,
    29,
    121,
    206,
    128,
    145,
    113,
    245,
    249,
    7,
    224,
    203,
    54,
    206,
    77,
    142,
    247,
    143,
    47,
    194,
    254,
    2,
    126,
    252,
    32,
    142,
    63,
    128,
    253,
    197,
    252,
    248,
    35,
    216,
    126,
    76,
    83,
    22,
    181,
    255,
    82,
    69,
    108,
    217,
    194,
    174,
    223,
    211,
    40,
    191,
    47,
    219,
    232,
    89,
    36,
    91,
    13,
    245,
    127,
    114,
    92,
    127,
    221,
    59,
    138,
    126,
    58,
    19,
    219,
    175,
    226,
    95,
    205,
    119,
    81,
    28,
    120,
    182,
    37,
    70,
    221,
    172,
    191,
    177,
    241,
    110,
    37,
    233,
    219,
    236,
    158,
    116,
    3,
    137,
    171,
    213,
    216,
    191,
    9,
    156,
    203,
    41,
    158,
    178,
    218,
    183,
    174,
    158,
    234,
    120,
    171,
    52,
    254,
    124,
    205,
    48,
    30,
    157,
    15,
    80,
    63,
    126,
    3,
    182,
    216,
    52,
    158,
    95,
    159,
    119,
    141,
    63,
    241,
    109,
    229,
    183,
    52,
    249,
    46,
    39,
    247,
    249,
    117,
    26,
    63,
    138,
    243,
    108,
    222,
    177,
    221,
    112,
    126,
    61,
    223,
    103,
    191,
    97,
    217,
    140,
    178,
    86,
    242,
    227,
    237,
    216,
    223,
    9,
    30,
    49,
    140,
    145,
    50,
    187,
    45,
    126,
    75,
    241,
    114,
    14,
    223,
    204,
    63,
    10,
    29,
    159,
    152,
    65,
    241,
    172,
    107,
    199,
    47,
    103,
    72,
    27,
    88,
    140,
    236,
    135,
    174,
    207,
    129,
    67,
    224,
    121,
    240,
    79,
    174,
    251,
    11,
    22,
    109,
    96,
    109,
    165,
    191,
    225,
    96,
    191,
    17,
    184,
    15,
    233,
    39,
    199,
    211,
    216,
    103,
    223,
    95,
    236,
    37,
    249,
    214,
    146,
    107,
    79,
    35,
    207,
    217,
    241,
    52,
    109,
    164,
    227,
    222,
    183,
    92,
    17,
    191,
    101,
    88,
    105,
    81,
    46,
    123,
    222,
    104,
    119,
    6,
    211,
    232,
    239,
    31,
    196,
    111,
    186,
    68,
    219,
    39,
    121,
    94,
    246,
    108,
    177,
    143,
    204,
    253,
    22,
    75,
    115,
    212,
    139,
    120,
    59,
    31,
    15,
    152,
    31,
    78,
    39,
    98,
    247,
    255,
    233,
    194,
    188,
    214,
    187,
    187,
    125,
    148,
    167,
    13,
    237,
    220,
    114,
    158,
    216,
    64,
    135,
    203,
    220,
    42,
    180,
    46,
    213,
    250,
    199,
    76,
    98,
    129,
    52,
    94,
    186,
    216,
    167,
    232,
    57,
    117,
    53,
    22,
    198,
    133,
    197,
    238,
    177,
    218,
    72,
    194,
    150,
    64,
    103,
    26,
    245,
    241,
    193,
    125,
    27,
    202,
    214,
    121,
    186,
    114,
    190,
    75,
    217,
    246,
    143,
    22,
    155,
    77,
    206,
    76,
    208,
    117,
    26,
    35,
    36,
    235,
    124,
    86,
    190,
    46,
    57,
    159,
    149,
    207,
    87,
    207,
    178,
    109,
    53,
    211,
    218,
    225,
    226,
    179,
    233,
    96,
    15,
    149,
    190,
    101,
    235,
    23,
    203,
    7,
    58,
    41,
    91,
    23,
    31,
    157,
    203,
    210,
    127,
    186,
    199,
    68,
    153,
    54,
    41,
    35,
    118,
    108,
    164,
    108,
    189,
    203,
    182,
    81,
    153,
    177,
    84,
    134,
    253,
    169,
    222,
    121,
    213,
    239,
    43,
    101,
    196,
    196,
    68,
    107,
    144,
    250,
    172,
    8,
    140,
    68,
    100,
    142,
    93,
    190,
    118,
    51,
    165,
    133,
    103,
    233,
    137,
    185,
    233,
    254,
    172,
    102,
    63,
    221,
    133,
    86,
    189,
    127,
    109,
    207,
    70,
    99,
    28,
    110,
    35,
    154,
    55,
    83,
    55,
    110,
    147,
    54,
    41,
    143,
    225,
    250,
    156,
    236,
    107,
    107,
    217,
    199,
    137,
    169,
    44,
    142,
    16,
    221,
    177,
    171,
    15,
    123,
    215,
    26,
    252,
    43,
    206,
    83,
    81,
    149,
    193,
    68,
    248,
    183,
    195,
    253,
    219,
    81,
    248,
    79,
    200,
    44,
    158,
    71,
    72,
    135,
    231,
    103,
    254,
    149,
    235,
    83,
    73,
    167,
    57,
    156,
    54,
    212,
    38,
    201,
    191,
    83,
    249,
    44,
    253,
    43,
    226,
    59,
    100,
    108,
    177,
    245,
    239,
    80,
    91,
    10,
    246,
    175,
    156,
    87,
    222,
    103,
    194,
    252,
    43,
    108,
    47,
    252,
    43,
    144,
    69,
    78,
    167,
    254,
    165,
    146,
    53,
    38,
    235,
    218,
    99,
    188,
    198,
    210,
    191,
    83,
    227,
    42,
    233,
    143,
    245,
    201,
    12,
    133,
    36,
    113,
    237,
    191,
    194,
    167,
    218,
    227,
    130,
    252,
    107,
    219,
    127,
    101,
    68,
    63,
    18,
    125,
    74,
    248,
    88,
    229,
    223,
    144,
    251,
    45,
    181,
    137,
    28,
    75,
    174,
    227,
    179,
    177,
    142,
    140,
    88,
    106,
    206,
    144,
    241,
    217,
    213,
    191,
    163,
    22,
    227,
    243,
    168,
    69,
    255,
    85,
    201,
    168,
    102,
    76,
    136,
    61,
    62,
    119,
    147,
    126,
    191,
    13,
    153,
    235,
    49,
    223,
    138,
    252,
    54,
    227,
    179,
    169,
    47,
    235,
    238,
    149,
    98,
    95,
    78,
    83,
    229,
    147,
    211,
    180,
    233,
    150,
    243,
    47,
    89,
    104,
    95,
    86,
    141,
    223,
    226,
    222,
    60,
    75,
    234,
    219,
    140,
    134,
    101,
    255,
    86,
    249,
    95,
    39,
    121,
    188,
    151,
    80,
    137,
    60,
    159,
    238,
    213,
    29,
    50,
    86,
    231,
    208,
    159,
    93,
    253,
    201,
    250,
    115,
    179,
    57,
    12,
    237,
    83,
    52,
    93,
    62,
    110,
    100,
    244,
    103,
    122,
    157,
    41,
    166,
    168,
    93,
    232,
    53,
    46,
    254,
    205,
    18,
    27,
    159,
    207,
    36,
    255,
    234,
    242,
    10,
    17,
    227,
    181,
    141,
    127,
    233,
    177,
    216,
    183,
    241,
    175,
    60,
    246,
    170,
    100,
    74,
    215,
    8,
    254,
    237,
    118,
    83,
    124,
    196,
    213,
    23,
    190,
    253,
    139,
    250,
    64,
    220,
    47,
    117,
    48,
    201,
    26,
    47,
    109,
    218,
    155,
    53,
    94,
    210,
    152,
    12,
    157,
    15,
    153,
    198,
    74,
    113,
    79,
    53,
    218,
    196,
    113,
    190,
    107,
    59,
    39,
    142,
    230,
    103,
    151,
    62,
    73,
    98,
    67,
    228,
    179,
    209,
    131,
    138,
    170,
    143,
    233,
    214,
    47,
    196,
    57,
    177,
    21,
    107,
    25,
    170,
    245,
    16,
    109,
    44,
    56,
    142,
    167,
    116,
    125,
    195,
    85,
    98,
    251,
    194,
    151,
    174,
    193,
    166,
    58,
    59,
    83,
    97,
    215,
    211,
    126,
    58,
    171,
    57,
    184,
    142,
    196,
    182,
    141,
    218,
    32,
    44,
    77,
    172,
    41,
    249,
    172,
    11,
    153,
    236,
    41,
    246,
    109,
    210,
    109,
    125,
    147,
    229,
    47,
    249,
    60,
    45,
    223,
    164,
    139,
    171,
    253,
    19,
    158,
    151,
    61,
    75,
    211,
    231,
    105,
    149,
    253,
    133,
    111,
    152,
    200,
    246,
    103,
    63,
    19,
    18,
    227,
    76,
    79,
    23,
    199,
    184,
    87,
    197,
    80,
    158,
    180,
    56,
    186,
    243,
    214,
    235,
    78,
    14,
    113,
    70,
    227,
    183,
    203,
    109,
    40,
    215,
    203,
    76,
    82,
    203,
    136,
    13,
    235,
    113,
    50,
    194,
    88,
    76,
    197,
    103,
    13,
    152,
    174,
    245,
    178,
    251,
    51,
    139,
    147,
    134,
    78,
    247,
    73,
    123,
    122,
    237,
    119,
    200,
    159,
    7,
    162,
    63,
    152,
    160,
    107,
    213,
    170,
    123,
    185,
    79,
    236,
    170,
    164,
    236,
    49,
    191,
    135,
    229,
    252,
    65,
    23,
    43,
    170,
    251,
    42,
    139,
    157,
    222,
    220,
    154,
    61,
    247,
    79,
    12,
    142,
    85,
    83,
    176,
    186,
    61,
    231,
    85,
    116,
    109,
    66,
    213,
    6,
    89,
    31,
    99,
    204,
    142,
    164,
    121,
    198,
    107,
    41,
    34,
    143,
    184,
    86,
    164,
    83,
    104,
    89,
    153,
    117,
    217,
    48,
    57,
    108,
    75,
    85,
    189,
    140,
    22,
    175,
    191,
    167,
    135,
    165,
    253,
    196,
    181,
    242,
    123,
    152,
    172,
    24,
    87,
    73,
    87,
    218,
    15,
    69,
    85,
    142,
    77,
    249,
    73,
    224,
    245,
    161,
    245,
    231,
    221,
    62,
    159,
    114,
    139,
    128,
    74,
    222,
    117,
    248,
    158,
    207,
    171,
    189,
    178,
    248,
    172,
    99,
    244,
    174,
    147,
    210,
    108,
    158,
    73,
    98,
    213,
    175,
    130,
    214,
    111,
    211,
    238,
    188,
    234,
    119,
    149,
    24,
    246,
    103,
    226,
    93,
    127,
    81,
    247,
    104,
    155,
    117,
    149,
    8,
    107,
    4,
    194,
    247,
    166,
    245,
    24,
    25,
    250,
    172,
    49,
    181,
    38,
    195,
    239,
    253,
    189,
    253,
    217,
    41,
    34,
    93,
    85,
    6,
    155,
    35,
    116,
    44,
    238,
    75,
    98,
    46,
    58,
    101,
    255,
    192,
    117,
    207,
    208,
    49,
    160,
    168,
    241,
    59,
    70,
    253,
    177,
    245,
    103,
    244,
    236,
    91,
    84,
    31,
    80,
    244,
    99,
    155,
    103,
    25,
    121,
    238,
    79,
    69,
    164,
    247,
    222,
    81,
    27,
    158,
    25,
    76,
    107,
    30,
    42,
    123,
    90,
    63,
    99,
    198,
    180,
    137,
    199,
    90,
    160,
    235,
    253,
    110,
    200,
    126,
    30,
    62,
    163,
    162,
    123,
    158,
    160,
    107,
    71,
    186,
    103,
    12,
    149,
    127,
    101,
    196,
    188,
    87,
    171,
    191,
    195,
    243,
    135,
    210,
    207,
    57,
    198,
    183,
    170,
    237,
    81,
    234,
    215,
    197,
    133,
    56,
    239,
    242,
    28,
    61,
    225,
    183,
    190,
    160,
    91,
    39,
    84,
    173,
    17,
    54,
    106,
    131,
    215,
    210,
    216,
    9,
    29,
    255,
    67,
    175,
    167,
    239,
    194,
    196,
    61,
    207,
    251,
    254,
    155,
    67,
    12,
    201,
    182,
    203,
    242,
    135,
    156,
    62,
    94,
    55,
    151,
    31,
    210,
    159,
    92,
    97,
    247,
    253,
    86,
    210,
    95,
    139,
    82,
    225,
    122,
    31,
    180,
    246,
    91,
    158,
    247,
    50,
    197,
    125,
    70,
    229,
    11,
    214,
    215,
    6,
    214,
    78,
    70,
    236,
    237,
    205,
    230,
    77,
    202,
    58,
    53,
    99,
    131,
    109,
    220,
    100,
    221,
    31,
    101,
    25,
    154,
    63,
    104,
    108,
    97,
    138,
    73,
    211,
    152,
    68,
    215,
    45,
    91,
    53,
    115,
    221,
    46,
    247,
    233,
    129,
    24,
    39,
    250,
    134,
    206,
    159,
    178,
    100,
    234,
    219,
    219,
    49,
    62,
    255,
    29,
    243,
    96,
    174,
    132,
    42,
    77,
    140,
    99,
    99,
    131,
    125,
    91,
    148,
    97,
    235,
    207,
    88,
    184,
    214,
    23,
    122,
    158,
    230,
    51,
    109,
    77,
    215,
    132,
    180,
    51,
    143,
    178,
    109,
    235,
    179,
    173,
    195,
    75,
    151,
    81,
    208,
    232,
    31,
    199,
    184,
    23,
    248,
    232,
    49,
    213,
    110,
    139,
    103,
    76,
    37,
    205,
    196,
    249,
    55,
    173,
    190,
    190,
    163,
    18,
    211,
    231,
    62,
    18,
    90,
    87,
    12,
    253,
    99,
    180,
    195,
    86,
    92,
    117,
    170,
    119,
    226,
    182,
    81,
    27,
    183,
    57,
    83,
    84,
    61,
    42,
    95,
    250,
    92,
    155,
    87,
    172,
    196,
    142,
    185,
    60,
    237,
    230,
    83,
    135,
    141,
    174,
    190,
    82,
    100,
    204,
    248,
    232,
    80,
    196,
    249,
    162,
    37,
    111,
    155,
    103,
    181,
    189,
    104,
    253,
    99,
    148,
    17,
    59,
    22,
    243,
    142,
    233,
    188,
    218,
    90,
    100,
    125,
    182,
    229,
    229,
    41,
    54,
    122,
    210,
    247,
    32,
    242,
    247,
    4,
    242,
    179,
    42,
    253,
    93,
    83,
    158,
    235,
    127,
    170,
    119,
    115,
    58,
    123,
    133,
    250,
    62,
    215,
    117,
    14,
    151,
    53,
    73,
    213,
    121,
    221,
    154,
    133,
    106,
    13,
    97,
    164,
    255,
    155,
    19,
    151,
    248,
    138,
    246,
    59,
    224,
    28,
    215,
    138,
    92,
    214,
    89,
    109,
    126,
    75,
    68,
    227,
    38,
    120,
    61,
    212,
    103,
    125,
    194,
    102,
    205,
    130,
    147,
    21,
    207,
    165,
    188,
    119,
    177,
    137,
    103,
    5,
    173,
    90,
    159,
    41,
    251,
    231,
    60,
    126,
    152,
    214,
    209,
    92,
    223,
    127,
    119,
    73,
    127,
    49,
    174,
    161,
    234,
    236,
    18,
    217,
    230,
    166,
    53,
    75,
    186,
    150,
    56,
    240,
    126,
    168,
    238,
    127,
    63,
    11,
    233,
    47,
    38,
    127,
    139,
    113,
    222,
    170,
    221,
    1,
    241,
    222,
    235,
    47,
    101,
    172,
    119,
    91,
    198,
    169,
    188,
    254,
    171,
    122,
    255,
    148,
    37,
    33,
    223,
    136,
    38,
    30,
    254,
    29,
    154,
    79,
    4,
    218,
    70,
    46,
    67,
    59,
    111,
    25,
    73,
    223,
    115,
    54,
    20,
    223,
    39,
    198,
    246,
    141,
    238,
    221,
    172,
    234,
    61,
    30,
    211,
    77,
    108,
    243,
    22,
    211,
    124,
    206,
    166,
    173,
    170,
    54,
    169,
    202,
    20,
    223,
    180,
    134,
    232,
    101,
    51,
    39,
    182,
    61,
    239,
    83,
    119,
    55,
    194,
    121,
    215,
    241,
    50,
    84,
    95,
    27,
    188,
    99,
    157,
    198,
    137,
    237,
    248,
    151,
    49,
    134,
    100,
    221,
    127,
    153,
    190,
    226,
    155,
    92,
    33,
    161,
    243,
    47,
    23,
    31,
    196,
    242,
    109,
    168,
    207,
    77,
    250,
    184,
    182,
    49,
    182,
    254,
    166,
    244,
    68,
    147,
    183,
    72,
    29,
    125,
    109,
    173,
    146,
    50,
    234,
    13,
    109,
    111,
    17,
    254,
    14,
    185,
    222,
    166,
    189,
    177,
    219,
    17,
    98,
    203,
    44,
    187,
    230,
    113,
    62,
    203,
    62,
    182,
    118,
    178,
    21,
    223,
    120,
    202,
    58,
    31,
    18,
    47,
    161,
    101,
    219,
    232,
    239,
    122,
    189,
    141,
    221,
    242,
    138,
    197,
    24,
    109,
    241,
    41,
    67,
    213,
    230,
    50,
    165,
    8,
    155,
    103,
    197,
    102,
    30,
    49,
    145,
    151,
    132,
    212,
    19,
    67,
    47,
    155,
    254,
    101,
    202,
    151,
    135,
    255,
    116,
    109,
    44,
    35,
    126,
    92,
    252,
    83,
    68,
    28,
    21,
    97,
    243,
    60,
    234,
    114,
    209,
    169,
    140,
    250,
    203,
    106,
    127,
    86,
    157,
    236,
    185,
    109,
    84,
    250,
    150,
    152,
    109,
    233,
    223,
    225,
    162,
    34,
    242,
    201,
    127,
    199,
    110,
    96,
    13,
    205,
    112,
    28,
    27,
    89,
    26,
    100,
    13,
    121,
    168,
    237,
    19,
    254,
    207,
    145,
    58,
    251,
    197,
    236,
    195,
    62,
    117,
    217,
    214,
    235,
    91,
    102,
    140,
    54,
    186,
    74,
    104,
    27,
    125,
    203,
    142,
    85,
    71,
    104,
    253,
    121,
    248,
    64,
    64,
    191,
    207,
    23,
    127,
    23,
    105,
    218,
    189,
    211,
    179,
    88,
    11,
    151,
    105,
    100,
    188,
    183,
    144,
    197,
    250,
    61,
    65,
    224,
    120,
    97,
    146,
    222,
    119,
    232,
    62,
    127,
    107,
    57,
    178,
    125,
    179,
    254,
    46,
    50,
    123,
    103,
    74,
    223,
    201,
    229,
    53,
    254,
    217,
    148,
    97,
    180,
    87,
    1,
    241,
    152,
    21,
    155,
    38,
    91,
    138,
    223,
    6,
    9,
    223,
    251,
    252,
    46,
    196,
    57,
    198,
    10,
    236,
    183,
    114,
    140,
    216,
    72,
    148,
    191,
    53,
    158,
    163,
    127,
    93,
    255,
    102,
    56,
    123,
    127,
    106,
    122,
    47,
    63,
    133,
    244,
    183,
    39,
    166,
    252,
    229,
    25,
    23,
    212,
    230,
    177,
    198,
    54,
    159,
    49,
    46,
    150,
    175,
    122,
    101,
    229,
    112,
    191,
    96,
    113,
    198,
    124,
    36,
    222,
    207,
    103,
    141,
    63,
    38,
    253,
    133,
    142,
    42,
    93,
    125,
    245,
    247,
    185,
    222,
    212,
    215,
    202,
    238,
    67,
    46,
    136,
    223,
    41,
    101,
    222,
    143,
    164,
    119,
    68,
    3,
    237,
    13,
    253,
    94,
    199,
    243,
    239,
    181,
    210,
    124,
    67,
    182,
    143,
    236,
    123,
    122,
    94,
    151,
    87,
    72,
    151,
    252,
    255,
    3,
    29,
    66,
    228,
    191,
    143,
    79,
    199,
    180,
    169,
    242,
    244,
    166,
    211,
    250,
    132,
    246,
    43,
    97,
    19,
    185,
    110,
    211,
    183,
    79,
    84,
    178,
    206,
    103,
    9,
    213,
    161,
    140,
    251,
    140,
    77,
    124,
    235,
    206,
    211,
    184,
    20,
    115,
    50,
    249,
    94,
    147,
    37,
    161,
    253,
    35,
    175,
    182,
    11,
    145,
    207,
    171,
    218,
    28,
    243,
    25,
    74,
    70,
    246,
    185,
    172,
    95,
    12,
    255,
    187,
    66,
    219,
    175,
    250,
    6,
    195,
    69,
    138,
    244,
    63,
    253,
    237,
    105,
    86,
    204,
    143,
    215,
    213,
    107,
    54,
    177,
    245,
    15,
    149,
    162,
    238,
    133,
    3,
    117,
    90,
    124,
    67,
    145,
    213,
    175,
    92,
    237,
    151,
    53,
    207,
    180,
    125,
    134,
    115,
    125,
    62,
    148,
    197,
    247,
    121,
    209,
    247,
    121,
    201,
    183,
    126,
    157,
    62,
    62,
    207,
    200,
    62,
    245,
    135,
    232,
    234,
    98,
    87,
    185,
    158,
    16,
    201,
    91,
    207,
    34,
    36,
    166,
    45,
    99,
    180,
    53,
    52,
    62,
    105,
    186,
    156,
    199,
    116,
    141,
    79,
    27,
    92,
    174,
    205,
    210,
    53,
    164,
    111,
    248,
    232,
    31,
    35,
    94,
    109,
    245,
    160,
    182,
    178,
    105,
    115,
    72,
    123,
    66,
    36,
    15,
    219,
    134,
    138,
    169,
    204,
    24,
    62,
    116,
    209,
    33,
    73,
    134,
    235,
    119,
    209,
    67,
    149,
    87,
    46,
    199,
    164,
    131,
    46,
    77,
    181,
    85,
    213,
    105,
    210,
    223,
    166,
    60,
    213,
    245,
    46,
    177,
    98,
    123,
    141,
    174,
    45,
    121,
    245,
    153,
    172,
    152,
    176,
    169,
    39,
    207,
    250,
    93,
    36,
    70,
    57,
    161,
    250,
    231,
    209,
    254,
    24,
    182,
    45,
    194,
    23,
    121,
    215,
    27,
    234,
    223,
    80,
    125,
    66,
    109,
    20,
    106,
    243,
    60,
    226,
    168,
    104,
    41,
    163,
    78,
    157,
    252,
    31
];
var trieData$1 = {
    type: type$1,
    data: data$1
};
var _class$6;
var _temp$2;
var decompositions = useData.decompositions;
var trie$1 = new (0, _unicodeTrieDefault.default)(new Uint8Array(trieData$1.data));
var stateMachine = new (0, _dfaDefault.default)(indicMachine);
/**
 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
 */ var IndicShaper = (_temp$2 = _class$6 = function(_DefaultShaper) {
    inherits(IndicShaper, _DefaultShaper);
    function IndicShaper() {
        classCallCheck(this, IndicShaper);
        return possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
    }
    IndicShaper.planFeatures = function planFeatures(plan) {
        plan.addStage(setupSyllables);
        plan.addStage([
            'locl',
            'ccmp'
        ]);
        plan.addStage(initialReordering);
        plan.addStage('nukt');
        plan.addStage('akhn');
        plan.addStage('rphf', false);
        plan.addStage('rkrf');
        plan.addStage('pref', false);
        plan.addStage('blwf', false);
        plan.addStage('abvf', false);
        plan.addStage('half', false);
        plan.addStage('pstf', false);
        plan.addStage('vatu');
        plan.addStage('cjct');
        plan.addStage('cfar', false);
        plan.addStage(finalReordering);
        plan.addStage({
            local: [
                'init'
            ],
            global: [
                'pres',
                'abvs',
                'blws',
                'psts',
                'haln',
                'dist',
                'abvm',
                'blwm',
                'calt',
                'clig'
            ]
        });
        // Setup the indic config for the selected script
        plan.unicodeScript = fromOpenType(plan.script);
        plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2';
    // TODO: turn off kern (Khmer) and liga features.
    };
    IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var _loop = function _loop(i) {
            var codepoint = glyphs[i].codePoints[0];
            var d = INDIC_DECOMPOSITIONS[codepoint] || decompositions[codepoint];
            if (d) {
                var decomposed = d.map(function(c) {
                    var g = plan.font.glyphForCodePoint(c);
                    return new GlyphInfo(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [
                    i,
                    1
                ].concat(decomposed));
            }
        };
        // Decompose split matras
        // TODO: do this in a more general unicode normalizer
        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
    };
    return IndicShaper;
}(DefaultShaper), _class$6.zeroMarkWidths = 'NONE', _temp$2);
function indicCategory(glyph) {
    return trie$1.get(glyph.codePoints[0]) >> 8;
}
function indicPosition(glyph) {
    return 1 << (trie$1.get(glyph.codePoints[0]) & 0xff);
}
var IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
    classCallCheck(this, IndicInfo);
    this.category = category;
    this.position = position;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function setupSyllables(font, glyphs) {
    var syllable = 0;
    var last = 0;
    for(var _iterator = stateMachine.match(glyphs.map(indicCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var _ref2 = _ref, start = _ref2[0], end = _ref2[1], tags$$1 = _ref2[2];
        if (start > last) {
            ++syllable;
            for(var _i2 = last; _i2 < start; _i2++)glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
        }
        ++syllable;
        // Create shaper info
        for(var _i3 = start; _i3 <= end; _i3++)glyphs[_i3].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i3]), indicPosition(glyphs[_i3]), tags$$1[0], syllable);
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for(var i = last; i < glyphs.length; i++)glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
    }
}
function isConsonant(glyph) {
    return glyph.shaperInfo.category & CONSONANT_FLAGS;
}
function isJoiner(glyph) {
    return glyph.shaperInfo.category & JOINER_FLAGS;
}
function isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
}
function wouldSubstitute(glyphs, feature) {
    for(var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i4 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
        var _glyph$features;
        var _ref3;
        if (_isArray2) {
            if (_i4 >= _iterator2.length) break;
            _ref3 = _iterator2[_i4++];
        } else {
            _i4 = _iterator2.next();
            if (_i4.done) break;
            _ref3 = _i4.value;
        }
        var glyph = _ref3;
        glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
    }
    var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([
        feature
    ], glyphs);
    return glyphs.length === 1;
}
function consonantPosition(font, consonant, virama) {
    var glyphs = [
        virama,
        consonant,
        virama
    ];
    if (wouldSubstitute(glyphs.slice(0, 2), 'blwf') || wouldSubstitute(glyphs.slice(1, 3), 'blwf')) return POSITIONS.Below_C;
    else if (wouldSubstitute(glyphs.slice(0, 2), 'pstf') || wouldSubstitute(glyphs.slice(1, 3), 'pstf')) return POSITIONS.Post_C;
    else if (wouldSubstitute(glyphs.slice(0, 2), 'pref') || wouldSubstitute(glyphs.slice(1, 3), 'pref')) return POSITIONS.Post_C;
    return POSITIONS.Base_C;
}
function initialReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
    var virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        var info = new GlyphInfo(font, virama, [
            indicConfig.virama
        ]);
        for(var i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
    }
    for(var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)){
        var _glyphs$start$shaperI = glyphs[start].shaperInfo, category = _glyphs$start$shaperI.category, syllableType = _glyphs$start$shaperI.syllableType;
        if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') continue;
        if (syllableType === 'broken_cluster' && dottedCircle) {
            var g = new GlyphInfo(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);
            // Insert after possible Repha.
            var _i5 = start;
            while(_i5 < end && glyphs[_i5].shaperInfo.category === CATEGORIES.Repha)_i5++;
            glyphs.splice(_i5++, 0, g);
            end++;
        }
        // 1. Find base consonant:
        //
        // The shaping engine finds the base consonant of the syllable, using the
        // following algorithm: starting from the end of the syllable, move backwards
        // until a consonant is found that does not have a below-base or post-base
        // form (post-base forms have to follow below-base forms), or that is not a
        // pre-base reordering Ra, or arrive at the first consonant. The consonant
        // stopped at will be the base.
        var base = end;
        var limit = start;
        var hasReph = false;
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
            // See if it matches the 'rphf' feature.
            var _g = [
                glyphs[start].copy(),
                glyphs[start + 1].copy(),
                glyphs[start + 2].copy()
            ];
            if (wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && wouldSubstitute(_g, 'rphf')) {
                limit += 2;
                while(limit < end && isJoiner(glyphs[limit]))limit++;
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
            limit++;
            while(limit < end && isJoiner(glyphs[limit]))limit++;
            base = start;
            hasReph = true;
        }
        switch(indicConfig.basePos){
            case 'Last':
                // starting from the end of the syllable, move backwards
                var _i6 = end;
                var seenBelow = false;
                do {
                    var _info = glyphs[--_i6].shaperInfo;
                    // until a consonant is found
                    if (isConsonant(glyphs[_i6])) {
                        // that does not have a below-base or post-base form
                        // (post-base forms have to follow below-base forms),
                        if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
                            base = _i6;
                            break;
                        }
                        // or that is not a pre-base reordering Ra,
                        //
                        // IMPLEMENTATION NOTES:
                        //
                        // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                        // by the logic above already.
                        //
                        // or arrive at the first consonant. The consonant stopped at will
                        // be the base.
                        if (_info.position === POSITIONS.Below_C) seenBelow = true;
                        base = _i6;
                    } else if (start < _i6 && _info.category === CATEGORIES.ZWJ && glyphs[_i6 - 1].shaperInfo.category === CATEGORIES.H) break;
                }while (_i6 > limit);
                break;
            case 'First':
                // The first consonant is always the base.
                base = start;
                // Mark all subsequent consonants as below.
                for(var _i7 = base + 1; _i7 < end; _i7++)if (isConsonant(glyphs[_i7])) glyphs[_i7].shaperInfo.position = POSITIONS.Below_C;
        }
        // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        //
        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
        if (hasReph && base === start && limit - base <= 2) hasReph = false;
        // 2. Decompose and reorder Matras:
        //
        // Each matra and any syllable modifier sign in the cluster are moved to the
        // appropriate position relative to the consonant(s) in the cluster. The
        // shaping engine decomposes two- or three-part matras into their constituent
        // parts before any repositioning. Matra characters are classified by which
        // consonant in a conjunct they have affinity for and are reordered to the
        // following positions:
        //
        //   o Before first half form in the syllable
        //   o After subjoined consonants
        //   o After post-form consonant
        //   o After main consonant (for above marks)
        //
        // IMPLEMENTATION NOTES:
        //
        // The normalize() routine has already decomposed matras for us, so we don't
        // need to worry about that.
        // 3.  Reorder marks to canonical order:
        //
        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
        // if necessary, so that the nukta is first.
        //
        // IMPLEMENTATION NOTES:
        //
        // We don't need to do this: the normalize() routine already did this for us.
        // Reorder characters
        for(var _i8 = start; _i8 < base; _i8++){
            var _info2 = glyphs[_i8].shaperInfo;
            _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
        }
        if (base < end) glyphs[base].shaperInfo.position = POSITIONS.Base_C;
        // Mark final consonants.  A final consonant is one appearing after a matra,
        // like in Khmer.
        for(var _i9 = base + 1; _i9 < end; _i9++)if (glyphs[_i9].shaperInfo.category === CATEGORIES.M) {
            for(var j = _i9 + 1; j < end; j++)if (isConsonant(glyphs[j])) {
                glyphs[j].shaperInfo.position = POSITIONS.Final_C;
                break;
            }
            break;
        }
        // Handle beginning Ra
        if (hasReph) glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
        // For old-style Indic script tags, move the first post-base Halant after
        // last consonant.
        //
        // Reports suggest that in some scripts Uniscribe does this only if there
        // is *not* a Halant after last consonant already (eg. Kannada), while it
        // does it unconditionally in other scripts (eg. Malayalam).  We don't
        // currently know about other scripts, so we single out Malayalam for now.
        //
        // Kannada test case:
        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
        // With some versions of Lohit Kannada.
        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
        //
        // Malayalam test case:
        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
        if (plan.isOldSpec) {
            var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
            for(var _i10 = base + 1; _i10 < end; _i10++)if (glyphs[_i10].shaperInfo.category === CATEGORIES.H) {
                var _j = void 0;
                for(_j = end - 1; _j > _i10; _j--){
                    if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) break;
                }
                if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i10) {
                    // Move Halant to after last consonant.
                    var t = glyphs[_i10];
                    glyphs.splice.apply(glyphs, [
                        _i10,
                        0
                    ].concat(glyphs.splice(_i10 + 1, _j - _i10)));
                    glyphs[_j] = t;
                }
                break;
            }
        }
        // Attach misc marks to previous char to move with them.
        var lastPos = POSITIONS.Start;
        for(var _i11 = start; _i11 < end; _i11++){
            var _info3 = glyphs[_i11].shaperInfo;
            if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
                _info3.position = lastPos;
                if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
                    // Uniscribe doesn't move the Halant with Left Matra.
                    // TEST: U+092B,U+093F,U+094DE
                    // We follow.  This is important for the Sinhala
                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                    // We don't want to move the virama with the left matra.
                    // TEST: U+0D9A,U+0DDA
                    for(var _j2 = _i11; _j2 > start; _j2--)if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
                        _info3.position = glyphs[_j2 - 1].shaperInfo.position;
                        break;
                    }
                }
            } else if (_info3.position !== POSITIONS.SMVD) lastPos = _info3.position;
        }
        // For post-base consonants let them own anything before them
        // since the last consonant or matra.
        var last = base;
        for(var _i12 = base + 1; _i12 < end; _i12++){
            if (isConsonant(glyphs[_i12])) {
                for(var _j3 = last + 1; _j3 < _i12; _j3++)if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) glyphs[_j3].shaperInfo.position = glyphs[_i12].shaperInfo.position;
                last = _i12;
            } else if (glyphs[_i12].shaperInfo.category === CATEGORIES.M) last = _i12;
        }
        var arr = glyphs.slice(start, end);
        arr.sort(function(a, b) {
            return a.shaperInfo.position - b.shaperInfo.position;
        });
        glyphs.splice.apply(glyphs, [
            start,
            arr.length
        ].concat(arr));
        // Find base again
        for(var _i13 = start; _i13 < end; _i13++)if (glyphs[_i13].shaperInfo.position === POSITIONS.Base_C) {
            base = _i13;
            break;
        }
        // Setup features now
        // Reph
        for(var _i14 = start; _i14 < end && glyphs[_i14].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i14++)glyphs[_i14].features.rphf = true;
        // Pre-base
        var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
        for(var _i15 = start; _i15 < base; _i15++){
            glyphs[_i15].features.half = true;
            if (blwf) glyphs[_i15].features.blwf = true;
        }
        // Post-base
        for(var _i16 = base + 1; _i16 < end; _i16++){
            glyphs[_i16].features.abvf = true;
            glyphs[_i16].features.pstf = true;
            glyphs[_i16].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
            // Old-spec eye-lash Ra needs special handling.  From the
            // spec:
            //
            // "The feature 'below-base form' is applied to consonants
            // having below-base forms and following the base consonant.
            // The exception is vattu, which may appear below half forms
            // as well as below the base glyph. The feature 'below-base
            // form' will be applied to all such occurrences of Ra as well."
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
            // with Sanskrit 2003 font.
            //
            // However, note that Ra,Halant,ZWJ is the correct way to
            // request eyelash form of Ra, so we wouldbn't inhibit it
            // in that sequence.
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
            for(var _i17 = start; _i17 + 1 < base; _i17++)if (glyphs[_i17].shaperInfo.category === CATEGORIES.Ra && glyphs[_i17 + 1].shaperInfo.category === CATEGORIES.H && (_i17 + 1 === base || glyphs[_i17 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
                glyphs[_i17].features.blwf = true;
                glyphs[_i17 + 1].features.blwf = true;
            }
        }
        var prefLen = 2;
        if (features.pref && base + prefLen < end) // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
        for(var _i18 = base + 1; _i18 + prefLen - 1 < end; _i18++){
            var _g2 = [
                glyphs[_i18].copy(),
                glyphs[_i18 + 1].copy()
            ];
            if (wouldSubstitute(_g2, 'pref')) {
                for(var _j4 = 0; _j4 < prefLen; _j4++)glyphs[_i18++].features.pref = true;
                // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                // Read the feature spec.
                // This allows distinguishing the following cases with MS Khmer fonts:
                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                if (features.cfar) for(; _i18 < end; _i18++)glyphs[_i18].features.cfar = true;
                break;
            }
        }
        // Apply ZWJ/ZWNJ effects
        for(var _i19 = start + 1; _i19 < end; _i19++)if (isJoiner(glyphs[_i19])) {
            var nonJoiner = glyphs[_i19].shaperInfo.category === CATEGORIES.ZWNJ;
            var _j5 = _i19;
            do {
                _j5--;
                // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                // being there, since we don't skip them for the CJCT
                // feature (ie. F_MANUAL_ZWJ)
                // A ZWNJ disables HALF.
                if (nonJoiner) delete glyphs[_j5].features.half;
            }while (_j5 > start && !isConsonant(glyphs[_j5]));
        }
    }
}
function finalReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    for(var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)){
        // 4. Final reordering:
        //
        // After the localized forms and basic shaping forms GSUB features have been
        // applied (see below), the shaping engine performs some final glyph
        // reordering before applying all the remaining font features to the entire
        // cluster.
        var tryPref = !!features.pref;
        // Find base again
        var base = start;
        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
            if (tryPref && base + 1 < end) {
                for(var i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;
                        while(base < end && isHalantOrCoeng(glyphs[base]))base++;
                        glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
                        tryPref = false;
                    }
                    break;
                }
            }
            // For Malayalam, skip over unformed below- (but NOT post-) forms.
            if (plan.unicodeScript === 'Malayalam') for(var _i20 = base + 1; _i20 < end; _i20++){
                while(_i20 < end && isJoiner(glyphs[_i20]))_i20++;
                if (_i20 === end || !isHalantOrCoeng(glyphs[_i20])) break;
                _i20++; // Skip halant.
                while(_i20 < end && isJoiner(glyphs[_i20]))_i20++;
                if (_i20 < end && isConsonant(glyphs[_i20]) && glyphs[_i20].shaperInfo.position === POSITIONS.Below_C) {
                    base = _i20;
                    glyphs[base].shaperInfo.position = POSITIONS.Base_C;
                }
            }
            if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) base--;
            break;
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) base--;
        if (base < end) while(start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS))base--;
        // o Reorder matras:
        //
        // If a pre-base matra character had been reordered before applying basic
        // features, the glyph can be moved closer to the main consonant based on
        // whether half-forms had been formed. Actual position for the matra is
        // defined as “after last standalone halant glyph, after initial matra
        // position and before the main consonant”. If ZWJ or ZWNJ follow this
        // halant, position is moved after it.
        //
        if (start + 1 < end && start < base) {
            // Otherwise there can't be any pre-base matra characters.
            // If we lost track of base, alas, position before last thingy.
            var newPos = base === end ? base - 2 : base - 1;
            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                while(newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS)))newPos--;
                // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!
                if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) // If ZWJ or ZWNJ follow this halant, position is moved after it.
                {
                    if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) newPos++;
                } else newPos = start; // No move.
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
                // Now go see if there's actually any matras...
                for(var _i21 = newPos; _i21 > start; _i21--)if (glyphs[_i21 - 1].shaperInfo.position === POSITIONS.Pre_M) {
                    var oldPos = _i21 - 1;
                    if (oldPos < base && base <= newPos) // Shouldn't actually happen.
                    base--;
                    var tmp = glyphs[oldPos];
                    glyphs.splice.apply(glyphs, [
                        oldPos,
                        0
                    ].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
                    glyphs[newPos] = tmp;
                    newPos--;
                }
            }
        }
        // o Reorder reph:
        //
        // Reph’s original position is always at the beginning of the syllable,
        // (i.e. it is not reordered at the character reordering stage). However,
        // it will be reordered according to the basic-forms shaping results.
        // Possible positions for reph, depending on the script, are; after main,
        // before post-base consonant forms, and after post-base consonant forms.
        // Two cases:
        //
        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
        //   we should only move it if the sequence ligated to the repha form.
        //
        // - If repha is encoded separately and in the logical position, we should only
        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
        //   to make it work without the reordering.
        if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            var newRephPos = void 0;
            var rephPos = indicConfig.rephPos;
            var found = false;
            // 1. If reph should be positioned after post-base consonant forms,
            //    proceed to step 5.
            if (rephPos !== POSITIONS.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;
                while(newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
                // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.
                if (!found && rephPos === POSITIONS.After_Main) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main)newRephPos++;
                    found = newRephPos < end;
                }
                // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).
                if (!found && rephPos === POSITIONS.After_Sub) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD)))newRephPos++;
                    found = newRephPos < end;
                }
            }
            //  5. If no consonant is found in steps 3 or 4, move reph to a position
            //     immediately before the first post-base matra, syllable modifier
            //     sign or vedic sign that has a reordering class after the intended
            //     reph position. For example, if the reordering position for reph
            //     is post-main, it will skip above-base matras that also have a
            //     post-main position.
            if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;
                while(newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
            }
            // 6. Otherwise, reorder reph to the end of the syllable.
            if (!found) {
                newRephPos = end - 1;
                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD)newRephPos--;
                // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                if (isHalantOrCoeng(glyphs[newRephPos])) {
                    for(var _i22 = base + 1; _i22 < newRephPos; _i22++)if (glyphs[_i22].shaperInfo.category === CATEGORIES.M) newRephPos--;
                }
            }
            var reph = glyphs[start];
            glyphs.splice.apply(glyphs, [
                start,
                0
            ].concat(glyphs.splice(start + 1, newRephPos - start)));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) base--;
        }
        // o Reorder pre-base reordering consonants:
        //
        // If a pre-base reordering consonant is found, reorder it according to
        // the following rules:
        if (tryPref && base + 1 < end) {
            for(var _i23 = base + 1; _i23 < end; _i23++)if (glyphs[_i23].features.pref) {
                // 1. Only reorder a glyph produced by substitution during application
                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                //    the feature generally but block it in certain contexts.)
                // Note: We just check that something got substituted.  We don't check that
                // the <pref> feature actually did it...
                //
                // Reorder pref only if it ligated.
                if (glyphs[_i23].isLigated && !glyphs[_i23].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    var _newPos = base;
                    // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.
                    if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                        while(_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS)))_newPos--;
                        // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                        // split matra, it should be reordered to *before* the left part of such matra.
                        if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
                            var _oldPos2 = _i23;
                            for(var j = base + 1; j < _oldPos2; j++)if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
                                _newPos--;
                                break;
                            }
                        }
                    }
                    if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
                    {
                        if (_newPos < end && isJoiner(glyphs[_newPos])) _newPos++;
                    }
                    var _oldPos = _i23;
                    var _tmp = glyphs[_oldPos];
                    glyphs.splice.apply(glyphs, [
                        _newPos + 1,
                        0
                    ].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
                    glyphs[_newPos] = _tmp;
                    if (_newPos <= base && base < _oldPos) base++;
                }
                break;
            }
        }
        // Apply 'init' to the Left Matra if it's a word start.
        if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test((0, _unicodePropertiesDefault.default).getCategory(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
    }
}
function nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
var type$2 = "Buffer";
var data$2 = [
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    169,
    208,
    1,
    81,
    12,
    174,
    243,
    237,
    156,
    127,
    168,
    29,
    71,
    21,
    199,
    231,
    221,
    247,
    222,
    253,
    245,
    110,
    94,
    242,
    108,
    126,
    244,
    217,
    24,
    155,
    182,
    20,
    35,
    98,
    173,
    138,
    105,
    21,
    12,
    109,
    197,
    90,
    5,
    83,
    21,
    141,
    69,
    169,
    173,
    149,
    38,
    42,
    216,
    7,
    66,
    26,
    80,
    82,
    193,
    104,
    161,
    137,
    86,
    37,
    226,
    175,
    170,
    49,
    40,
    36,
    129,
    162,
    45,
    20,
    76,
    171,
    96,
    219,
    32,
    54,
    234,
    31,
    166,
    138,
    86,
    13,
    180,
    193,
    254,
    209,
    98,
    181,
    85,
    12,
    175,
    180,
    20,
    191,
    227,
    206,
    225,
    158,
    119,
    50,
    51,
    59,
    179,
    187,
    179,
    123,
    159,
    185,
    7,
    62,
    204,
    238,
    236,
    236,
    204,
    153,
    51,
    115,
    118,
    103,
    102,
    127,
    60,
    223,
    82,
    106,
    98,
    82,
    169,
    30,
    152,
    3,
    27,
    193,
    38,
    112,
    41,
    184,
    220,
    196,
    205,
    87,
    16,
    190,
    21,
    188,
    29,
    188,
    27,
    124,
    192,
    147,
    238,
    122,
    112,
    179,
    37,
    126,
    7,
    88,
    0,
    59,
    193,
    110,
    240,
    69,
    240,
    101,
    176,
    31,
    220,
    101,
    248,
    33,
    75,
    127,
    8,
    252,
    4,
    252,
    20,
    252,
    194,
    146,
    223,
    207,
    192,
    49,
    240,
    60,
    234,
    255,
    107,
    163,
    219,
    156,
    65,
    199,
    81,
    248,
    40,
    194,
    63,
    128,
    147,
    224,
    73,
    240,
    12,
    248,
    55,
    120,
    1,
    76,
    78,
    41,
    53,
    3,
    230,
    192,
    60,
    216,
    8,
    54,
    129,
    75,
    192,
    102,
    176,
    101,
    42,
    75,
    127,
    53,
    194,
    173,
    96,
    27,
    248,
    8,
    216,
    14,
    110,
    1,
    59,
    193,
    110,
    176,
    7,
    236,
    3,
    251,
    193,
    93,
    224,
    32,
    56,
    2,
    238,
    53,
    251,
    247,
    131,
    135,
    192,
    113,
    112,
    2,
    60,
    6,
    158,
    0,
    79,
    129,
    231,
    192,
    105,
    240,
    210,
    84,
    166,
    115,
    123,
    90,
    169,
    89,
    176,
    118,
    58,
    219,
    223,
    128,
    240,
    98,
    240,
    90,
    240,
    6,
    240,
    22,
    112,
    37,
    120,
    167,
    57,
    254,
    94,
    132,
    31,
    4,
    55,
    128,
    29,
    96,
    97,
    58,
    171,
    183,
    102,
    23,
    219,
    174,
    130,
    207,
    33,
    191,
    61,
    21,
    231,
    201,
    217,
    43,
    242,
    254,
    42,
    246,
    191,
    5,
    126,
    0,
    14,
    131,
    123,
    166,
    179,
    250,
    30,
    5,
    15,
    130,
    71,
    192,
    239,
    114,
    244,
    121,
    12,
    199,
    159,
    0,
    79,
    129,
    127,
    152,
    243,
    79,
    131,
    23,
    193,
    84,
    91,
    169,
    65,
    59,
    139,
    91,
    141,
    112,
    61,
    184,
    8,
    188,
    166,
    61,
    236,
    75,
    111,
    196,
    246,
    102,
    176,
    5,
    92,
    13,
    182,
    130,
    109,
    230,
    156,
    235,
    77,
    120,
    51,
    194,
    79,
    129,
    237,
    172,
    15,
    238,
    196,
    254,
    238,
    118,
    58,
    91,
    17,
    95,
    64,
    25,
    95,
    2,
    95,
    7,
    223,
    5,
    63,
    2,
    119,
    179,
    114,
    239,
    195,
    246,
    207,
    193,
    49,
    19,
    119,
    28,
    225,
    9,
    240,
    71,
    112,
    50,
    64,
    191,
    39,
    145,
    230,
    153,
    118,
    102,
    171,
    103,
    193,
    34,
    56,
    4,
    84,
    71,
    169,
    110,
    39,
    139,
    95,
    129,
    112,
    208,
    201,
    210,
    175,
    52,
    113,
    154,
    181,
    108,
    155,
    179,
    1,
    241,
    23,
    131,
    87,
    139,
    227,
    175,
    119,
    164,
    39,
    46,
    235,
    100,
    101,
    79,
    49,
    189,
    125,
    233,
    121,
    186,
    162,
    232,
    60,
    222,
    132,
    114,
    183,
    128,
    171,
    192,
    53,
    96,
    43,
    216,
    6,
    62,
    220,
    241,
    159,
    123,
    147,
    56,
    62,
    152,
    60,
    51,
    205,
    39,
    145,
    230,
    211,
    224,
    51,
    157,
    172,
    223,
    124,
    158,
    217,
    224,
    164,
    167,
    94,
    119,
    32,
    221,
    87,
    192,
    55,
    193,
    1,
    135,
    30,
    54,
    255,
    63,
    212,
    25,
    214,
    235,
    199,
    157,
    172,
    175,
    220,
    135,
    240,
    1,
    83,
    174,
    222,
    126,
    216,
    108,
    223,
    157,
    99,
    219,
    42,
    236,
    59,
    102,
    204,
    217,
    200,
    216,
    127,
    198,
    140,
    25,
    51,
    102,
    204,
    152,
    49,
    99,
    198,
    196,
    50,
    103,
    153,
    79,
    54,
    205,
    225,
    246,
    112,
    77,
    96,
    123,
    128,
    126,
    191,
    98,
    115,
    215,
    223,
    136,
    121,
    236,
    39,
    60,
    231,
    83,
    221,
    127,
    143,
    115,
    254,
    218,
    201,
    214,
    97,
    254,
    134,
    240,
    239,
    224,
    159,
    224,
    52,
    120,
    201,
    196,
    183,
    187,
    208,
    167,
    155,
    165,
    95,
    131,
    112,
    30,
    108,
    4,
    155,
    186,
    217,
    241,
    75,
    17,
    94,
    14,
    174,
    48,
    251,
    215,
    32,
    124,
    15,
    184,
    174,
    235,
    46,
    95,
    167,
    187,
    209,
    115,
    124,
    204,
    152,
    49,
    99,
    198,
    164,
    101,
    110,
    178,
    89,
    154,
    174,
    255,
    152,
    49,
    99,
    210,
    144,
    218,
    191,
    119,
    96,
    252,
    184,
    208,
    205,
    158,
    11,
    221,
    138,
    240,
    54,
    203,
    120,
    242,
    246,
    110,
    246,
    108,
    95,
    111,
    223,
    41,
    142,
    127,
    99,
    4,
    198,
    159,
    31,
    27,
    100,
    236,
    1,
    199,
    192,
    219,
    2,
    88,
    4,
    151,
    173,
    88,
    26,
    183,
    139,
    237,
    31,
    192,
    246,
    159,
    192,
    185,
    179,
    74,
    93,
    11,
    22,
    102,
    77,
    60,
    194,
    199,
    103,
    135,
    233,
    158,
    197,
    246,
    1,
    216,
    224,
    113,
    112,
    126,
    79,
    169,
    15,
    129,
    239,
    128,
    27,
    176,
    255,
    189,
    118,
    22,
    254,
    210,
    236,
    115,
    218,
    253,
    51,
    227,
    36,
    87,
    34,
    205,
    71,
    89,
    186,
    131,
    216,
    62,
    101,
    246,
    47,
    152,
    193,
    49,
    112,
    112,
    166,
    249,
    251,
    79,
    211,
    228,
    249,
    203,
    247,
    181,
    237,
    76,
    63,
    61,
    130,
    240,
    30,
    112,
    180,
    155,
    205,
    19,
    31,
    236,
    198,
    223,
    79,
    247,
    154,
    52,
    131,
    156,
    244,
    182,
    252,
    30,
    41,
    80,
    158,
    43,
    95,
    121,
    254,
    111,
    145,
    247,
    163,
    221,
    165,
    233,
    72,
    223,
    189,
    158,
    242,
    254,
    130,
    115,
    78,
    129,
    167,
    187,
    195,
    186,
    233,
    116,
    207,
    97,
    255,
    63,
    38,
    191,
    23,
    88,
    190,
    147,
    61,
    119,
    253,
    108,
    249,
    199,
    182,
    101,
    108,
    251,
    207,
    64,
    159,
    21,
    96,
    13,
    88,
    15,
    46,
    2,
    175,
    2,
    15,
    152,
    252,
    94,
    135,
    237,
    205,
    96,
    11,
    184,
    202,
    28,
    127,
    23,
    120,
    159,
    241,
    215,
    155,
    192,
    142,
    222,
    48,
    191,
    5,
    108,
    239,
    2,
    159,
    5,
    123,
    192,
    62,
    240,
    53,
    240,
    109,
    112,
    176,
    151,
    175,
    143,
    126,
    159,
    230,
    8,
    210,
    221,
    235,
    72,
    171,
    231,
    237,
    247,
    227,
    216,
    67,
    189,
    225,
    254,
    113,
    108,
    159,
    96,
    251,
    127,
    238,
    101,
    239,
    150,
    232,
    253,
    83,
    216,
    126,
    218,
    83,
    110,
    81,
    91,
    219,
    242,
    104,
    218,
    151,
    99,
    124,
    189,
    46,
    92,
    229,
    255,
    171,
    23,
    231,
    167,
    203,
    217,
    86,
    77,
    151,
    191,
    216,
    91,
    154,
    239,
    139,
    198,
    246,
    45,
    220,
    15,
    251,
    253,
    102,
    108,
    62,
    138,
    109,
    62,
    74,
    253,
    109,
    208,
    175,
    215,
    38,
    190,
    119,
    132,
    238,
    48,
    239,
    19,
    173,
    238,
    103,
    225,
    121,
    8,
    47,
    4,
    155,
    204,
    254,
    37,
    253,
    97,
    218,
    205,
    125,
    127,
    254,
    189,
    142,
    255,
    62,
    220,
    20,
    121,
    239,
    73,
    133,
    188,
    71,
    245,
    102,
    211,
    102,
    87,
    32,
    124,
    71,
    205,
    237,
    87,
    117,
    255,
    91,
    110,
    126,
    233,
    211,
    61,
    164,
    14,
    186,
    13,
    175,
    101,
    253,
    88,
    191,
    187,
    247,
    126,
    236,
    95,
    215,
    207,
    250,
    255,
    97,
    246,
    126,
    163,
    78,
    183,
    200,
    222,
    49,
    189,
    17,
    251,
    31,
    55,
    113,
    183,
    228,
    244,
    127,
    27,
    139,
    145,
    125,
    141,
    222,
    49,
    60,
    29,
    144,
    86,
    191,
    11,
    120,
    107,
    127,
    105,
    28,
    127,
    47,
    241,
    97,
    51,
    166,
    166,
    186,
    223,
    102,
    194,
    219,
    17,
    238,
    235,
    12,
    245,
    191,
    83,
    212,
    107,
    191,
    217,
    63,
    106,
    25,
    147,
    47,
    71,
    22,
    91,
    19,
    255,
    99,
    20,
    100,
    130,
    209,
    18,
    251,
    60,
    13,
    133,
    147,
    236,
    248,
    84,
    32,
    50,
    63,
    229,
    136,
    75,
    45,
    163,
    97,
    241,
    177,
    144,
    80,
    95,
    106,
    89,
    160,
    182,
    106,
    89,
    206,
    107,
    137,
    112,
    218,
    64,
    18,
    210,
    183,
    82,
    247,
    133,
    201,
    196,
    249,
    87,
    45,
    237,
    166,
    21,
    40,
    33,
    33,
    109,
    121,
    54,
    249,
    190,
    205,
    103,
    206,
    38,
    153,
    112,
    48,
    10,
    34,
    245,
    224,
    215,
    188,
    229,
    46,
    182,
    49,
    131,
    220,
    94,
    46,
    82,
    180,
    207,
    216,
    198,
    82,
    69,
    218,
    87,
    218,
    111,
    57,
    217,
    176,
    46,
    191,
    11,
    205,
    59,
    198,
    246,
    85,
    251,
    33,
    111,
    123,
    215,
    117,
    41,
    143,
    255,
    119,
    113,
    205,
    59,
    202,
    74,
    81,
    123,
    147,
    14,
    29,
    6,
    166,
    158,
    193,
    243,
    157,
    170,
    233,
    1,
    76,
    129,
    213,
    140,
    217,
    215,
    219,
    3,
    19,
    174,
    16,
    244,
    4,
    125,
    193,
    44,
    59,
    151,
    234,
    184,
    146,
    217,
    172,
    199,
    242,
    10,
    213,
    143,
    210,
    23,
    153,
    23,
    170,
    18,
    118,
    33,
    253,
    187,
    134,
    144,
    188,
    148,
    72,
    39,
    247,
    139,
    232,
    16,
    114,
    156,
    139,
    75,
    167,
    144,
    246,
    37,
    25,
    24,
    228,
    190,
    110,
    223,
    16,
    31,
    234,
    91,
    226,
    92,
    117,
    146,
    101,
    199,
    218,
    40,
    239,
    254,
    231,
    59,
    206,
    253,
    207,
    87,
    182,
    175,
    46,
    69,
    116,
    142,
    109,
    223,
    188,
    109,
    45,
    51,
    38,
    180,
    181,
    175,
    20,
    242,
    95,
    185,
    63,
    107,
    73,
    235,
    147,
    144,
    254,
    152,
    119,
    142,
    11,
    221,
    46,
    171,
    84,
    54,
    215,
    165,
    249,
    238,
    92,
    164,
    126,
    161,
    237,
    235,
    107,
    147,
    24,
    157,
    171,
    106,
    223,
    162,
    254,
    75,
    109,
    202,
    175,
    209,
    74,
    45,
    189,
    62,
    87,
    37,
    101,
    253,
    151,
    198,
    174,
    121,
    101,
    228,
    149,
    223,
    132,
    253,
    233,
    222,
    87,
    228,
    250,
    153,
    39,
    210,
    55,
    101,
    125,
    165,
    158,
    69,
    237,
    223,
    18,
    245,
    43,
    42,
    218,
    191,
    242,
    238,
    181,
    182,
    122,
    184,
    108,
    110,
    75,
    171,
    44,
    233,
    93,
    233,
    92,
    229,
    216,
    226,
    67,
    251,
    16,
    23,
    242,
    37,
    62,
    254,
    225,
    50,
    80,
    75,
    219,
    159,
    239,
    135,
    250,
    159,
    237,
    254,
    233,
    146,
    34,
    245,
    176,
    173,
    137,
    230,
    173,
    21,
    240,
    177,
    80,
    204,
    120,
    40,
    198,
    31,
    203,
    250,
    115,
    172,
    29,
    244,
    190,
    111,
    60,
    171,
    212,
    153,
    215,
    82,
    190,
    159,
    215,
    158,
    52,
    222,
    181,
    217,
    65,
    74,
    89,
    127,
    46,
    35,
    212,
    230,
    69,
    198,
    187,
    77,
    181,
    175,
    43,
    45,
    137,
    188,
    94,
    167,
    104,
    95,
    155,
    255,
    75,
    145,
    186,
    150,
    105,
    223,
    151,
    25,
    138,
    72,
    89,
    191,
    41,
    226,
    99,
    100,
    127,
    9,
    183,
    65,
    222,
    245,
    242,
    156,
    128,
    186,
    133,
    180,
    65,
    29,
    254,
    37,
    215,
    26,
    108,
    235,
    14,
    49,
    254,
    85,
    68,
    183,
    20,
    109,
    25,
    147,
    46,
    68,
    15,
    46,
    54,
    31,
    227,
    125,
    133,
    124,
    145,
    218,
    108,
    5,
    75,
    51,
    112,
    224,
    235,
    15,
    177,
    54,
    37,
    61,
    138,
    172,
    29,
    213,
    233,
    115,
    33,
    109,
    211,
    99,
    113,
    114,
    45,
    199,
    54,
    142,
    37,
    105,
    41,
    127,
    222,
    250,
    252,
    142,
    96,
    149,
    9,
    245,
    177,
    178,
    207,
    243,
    165,
    61,
    21,
    11,
    243,
    226,
    93,
    18,
    219,
    207,
    229,
    113,
    101,
    9,
    109,
    186,
    196,
    218,
    95,
    153,
    253,
    57,
    71,
    190,
    46,
    63,
    146,
    246,
    87,
    44,
    204,
    171,
    155,
    45,
    79,
    91,
    188,
    124,
    134,
    94,
    148,
    22,
    11,
    229,
    152,
    211,
    53,
    38,
    173,
    218,
    39,
    116,
    158,
    211,
    34,
    92,
    165,
    220,
    18,
    234,
    99,
    169,
    253,
    152,
    11,
    95,
    147,
    117,
    173,
    209,
    74,
    104,
    140,
    199,
    247,
    59,
    106,
    184,
    198,
    234,
    171,
    239,
    234,
    8,
    84,
    100,
    250,
    20,
    104,
    201,
    155,
    235,
    76,
    123,
    142,
    241,
    243,
    93,
    253,
    216,
    230,
    19,
    54,
    73,
    221,
    55,
    98,
    176,
    221,
    91,
    53,
    3,
    101,
    239,
    47,
    122,
    13,
    95,
    247,
    153,
    89,
    19,
    183,
    6,
    172,
    85,
    217,
    53,
    106,
    46,
    178,
    108,
    105,
    67,
    122,
    79,
    39,
    79,
    87,
    215,
    115,
    131,
    57,
    181,
    84,
    143,
    190,
    26,
    142,
    177,
    100,
    30,
    93,
    11,
    60,
    47,
    89,
    247,
    34,
    182,
    157,
    83,
    195,
    177,
    9,
    229,
    99,
    43,
    183,
    107,
    236,
    58,
    101,
    209,
    195,
    7,
    157,
    75,
    237,
    215,
    196,
    243,
    125,
    91,
    31,
    111,
    250,
    89,
    99,
    158,
    159,
    87,
    97,
    167,
    84,
    245,
    72,
    97,
    163,
    162,
    247,
    23,
    25,
    39,
    199,
    38,
    41,
    203,
    183,
    193,
    203,
    143,
    177,
    81,
    213,
    229,
    199,
    74,
    21,
    246,
    87,
    53,
    151,
    159,
    167,
    155,
    22,
    126,
    223,
    176,
    205,
    29,
    92,
    115,
    50,
    130,
    198,
    31,
    125,
    53,
    28,
    123,
    232,
    123,
    240,
    58,
    149,
    141,
    191,
    166,
    25,
    180,
    6,
    163,
    183,
    165,
    143,
    200,
    251,
    48,
    181,
    85,
    108,
    253,
    83,
    137,
    239,
    26,
    88,
    199,
    117,
    81,
    223,
    87,
    171,
    238,
    3,
    49,
    54,
    229,
    125,
    67,
    142,
    55,
    8,
    57,
    86,
    227,
    114,
    174,
    97,
    37,
    219,
    150,
    204,
    155,
    124,
    166,
    45,
    231,
    203,
    107,
    125,
    236,
    251,
    3,
    85,
    251,
    77,
    217,
    190,
    87,
    180,
    220,
    162,
    231,
    75,
    248,
    186,
    85,
    25,
    253,
    164,
    132,
    222,
    183,
    83,
    147,
    178,
    15,
    144,
    31,
    208,
    218,
    20,
    191,
    78,
    165,
    236,
    151,
    52,
    70,
    215,
    190,
    178,
    142,
    49,
    47,
    208,
    50,
    203,
    116,
    115,
    249,
    43,
    159,
    99,
    146,
    95,
    219,
    174,
    241,
    114,
    110,
    201,
    225,
    215,
    119,
    146,
    233,
    136,
    58,
    185,
    164,
    236,
    249,
    121,
    227,
    214,
    212,
    99,
    90,
    110,
    35,
    221,
    70,
    117,
    191,
    19,
    166,
    239,
    189,
    182,
    57,
    161,
    92,
    87,
    112,
    181,
    245,
    108,
    78,
    254,
    82,
    66,
    245,
    202,
    91,
    71,
    10,
    225,
    229,
    224,
    60,
    19,
    186,
    136,
    157,
    59,
    52,
    213,
    78,
    28,
    126,
    255,
    180,
    93,
    99,
    200,
    151,
    103,
    89,
    186,
    212,
    253,
    70,
    174,
    221,
    83,
    72,
    215,
    158,
    144,
    103,
    102,
    90,
    100,
    91,
    187,
    234,
    46,
    175,
    65,
    124,
    189,
    96,
    157,
    135,
    245,
    6,
    125,
    237,
    161,
    119,
    167,
    92,
    101,
    199,
    92,
    159,
    185,
    132,
    92,
    119,
    66,
    165,
    236,
    220,
    154,
    95,
    95,
    116,
    250,
    149,
    14,
    40,
    141,
    45,
    190,
    235,
    57,
    143,
    191,
    231,
    73,
    98,
    139,
    163,
    113,
    68,
    71,
    196,
    119,
    44,
    113,
    49,
    242,
    10,
    176,
    129,
    237,
    79,
    58,
    8,
    181,
    151,
    92,
    159,
    138,
    181,
    119,
    204,
    122,
    72,
    72,
    124,
    108,
    222,
    242,
    222,
    21,
    115,
    158,
    150,
    87,
    6,
    212,
    49,
    70,
    108,
    99,
    244,
    208,
    243,
    228,
    120,
    161,
    14,
    105,
    114,
    44,
    170,
    28,
    219,
    174,
    227,
    161,
    245,
    9,
    57,
    47,
    79,
    39,
    91,
    104,
    43,
    39,
    70,
    175,
    178,
    245,
    168,
    114,
    253,
    51,
    70,
    31,
    223,
    24,
    33,
    180,
    77,
    93,
    249,
    132,
    30,
    47,
    210,
    183,
    108,
    229,
    87,
    93,
    142,
    111,
    236,
    20,
    34,
    177,
    249,
    165,
    210,
    183,
    108,
    154,
    148,
    246,
    108,
    162,
    92,
    87,
    91,
    142,
    130,
    14,
    117,
    233,
    209,
    132,
    52,
    173,
    219,
    40,
    244,
    229,
    24,
    61,
    38,
    19,
    235,
    236,
    179,
    187,
    28,
    115,
    150,
    181,
    95,
    21,
    246,
    175,
    67,
    242,
    202,
    170,
    195,
    254,
    117,
    181,
    115,
    19,
    253,
    42,
    69,
    191,
    41,
    42,
    41,
    250,
    87,
    213,
    58,
    22,
    121,
    246,
    226,
    154,
    135,
    185,
    242,
    204,
    91,
    47,
    116,
    157,
    95,
    180,
    14,
    69,
    230,
    114,
    182,
    244,
    82,
    175,
    186,
    165,
    78,
    255,
    169,
    203,
    63,
    235,
    180,
    135,
    77,
    228,
    218,
    104,
    25,
    61,
    138,
    156,
    151,
    66,
    242,
    234,
    91,
    85,
    59,
    184,
    242,
    169,
    187,
    31,
    196,
    74,
    83,
    253,
    186,
    108,
    157,
    71,
    193,
    247,
    82,
    60,
    199,
    161,
    124,
    99,
    211,
    242,
    117,
    98,
    190,
    110,
    108,
    123,
    15,
    173,
    99,
    137,
    171,
    18,
    190,
    134,
    78,
    107,
    248,
    69,
    109,
    31,
    122,
    94,
    213,
    117,
    136,
    93,
    175,
    181,
    189,
    15,
    88,
    39,
    250,
    25,
    173,
    237,
    91,
    25,
    23,
    161,
    223,
    18,
    150,
    121,
    126,
    193,
    197,
    246,
    44,
    183,
    8,
    121,
    122,
    186,
    198,
    38,
    46,
    125,
    109,
    239,
    56,
    243,
    103,
    18,
    177,
    245,
    15,
    65,
    62,
    23,
    149,
    207,
    74,
    249,
    115,
    38,
    106,
    215,
    24,
    209,
    250,
    54,
    249,
    44,
    88,
    66,
    207,
    248,
    92,
    239,
    12,
    211,
    115,
    96,
    253,
    60,
    110,
    141,
    129,
    254,
    21,
    17,
    11,
    73,
    209,
    254,
    234,
    107,
    111,
    122,
    239,
    34,
    181,
    189,
    66,
    203,
    176,
    189,
    95,
    193,
    159,
    177,
    83,
    156,
    124,
    223,
    58,
    68,
    120,
    57,
    235,
    2,
    116,
    161,
    190,
    106,
    59,
    63,
    196,
    254,
    178,
    29,
    171,
    182,
    33,
    23,
    126,
    63,
    209,
    199,
    232,
    121,
    98,
    149,
    126,
    210,
    99,
    33,
    181,
    131,
    108,
    55,
    215,
    121,
    116,
    127,
    166,
    176,
    78,
    41,
    98,
    127,
    221,
    215,
    120,
    223,
    235,
    43,
    251,
    125,
    147,
    190,
    1,
    8,
    17,
    158,
    191,
    237,
    155,
    121,
    254,
    94,
    224,
    132,
    201,
    187,
    238,
    239,
    158,
    203,
    136,
    28,
    207,
    156,
    95,
    146,
    208,
    57,
    188,
    79,
    66,
    230,
    252,
    182,
    99,
    121,
    105,
    93,
    229,
    248,
    210,
    209,
    220,
    44,
    197,
    248,
    218,
    166,
    71,
    75,
    249,
    109,
    102,
    91,
    151,
    137,
    41,
    67,
    198,
    41,
    101,
    183,
    117,
    93,
    34,
    251,
    159,
    109,
    205,
    35,
    239,
    156,
    50,
    229,
    165,
    154,
    59,
    21,
    145,
    81,
    153,
    159,
    151,
    153,
    195,
    74,
    29,
    203,
    206,
    133,
    155,
    92,
    147,
    160,
    242,
    235,
    166,
    42,
    73,
    221,
    167,
    83,
    231,
    31,
    98,
    15,
    125,
    239,
    148,
    223,
    124,
    251,
    190,
    53,
    161,
    116,
    244,
    46,
    88,
    200,
    120,
    173,
    170,
    177,
    88,
    200,
    125,
    95,
    207,
    81,
    102,
    212,
    153,
    239,
    242,
    105,
    201,
    123,
    55,
    53,
    100,
    28,
    17,
    51,
    119,
    9,
    145,
    212,
    254,
    89,
    149,
    158,
    203,
    89,
    7,
    95,
    153,
    124,
    206,
    64,
    255,
    85,
    73,
    217,
    95,
    109,
    243,
    4,
    215,
    55,
    84,
    190,
    127,
    110,
    230,
    205,
    171,
    165,
    108,
    44,
    73,
    29,
    227,
    240,
    11,
    84,
    243,
    255,
    66,
    181,
    253,
    87,
    79,
    190,
    211,
    172,
    109,
    175,
    175,
    47,
    182,
    113,
    51,
    95,
    227,
    106,
    66,
    127,
    87,
    223,
    242,
    125,
    219,
    77,
    199,
    232,
    187,
    110,
    21,
    81,
    70,
    89,
    127,
    174,
    178,
    190,
    178,
    77,
    234,
    46,
    223,
    247,
    79,
    70,
    159,
    31,
    235,
    115,
    207,
    81,
    195,
    127,
    28,
    217,
    252,
    121,
    70,
    13,
    219,
    138,
    215,
    47,
    198,
    47,
    109,
    115,
    188,
    170,
    109,
    64,
    101,
    133,
    74,
    149,
    101,
    22,
    109,
    51,
    249,
    156,
    67,
    254,
    247,
    64,
    183,
    209,
    42,
    67,
    222,
    245,
    54,
    68,
    71,
    91,
    186,
    178,
    182,
    136,
    57,
    223,
    231,
    31,
    85,
    247,
    133,
    24,
    180,
    173,
    125,
    215,
    95,
    98,
    70,
    185,
    199,
    167,
    101,
    251,
    40,
    191,
    255,
    140,
    250,
    255,
    158,
    125,
    105,
    73,
    248,
    255,
    239,
    228,
    218,
    155,
    252,
    6,
    167,
    204,
    255,
    74,
    149,
    10,
    123,
    190,
    33,
    253,
    142,
    36,
    244,
    89,
    81,
    204,
    179,
    36,
    95,
    249,
    69,
    9,
    185,
    198,
    211,
    61,
    150,
    127,
    139,
    68,
    223,
    188,
    83,
    223,
    162,
    49,
    4,
    181,
    85,
    232,
    61,
    171,
    108,
    255,
    78,
    85,
    119,
    18,
    219,
    119,
    254,
    178,
    206,
    33,
    115,
    168,
    162,
    72,
    157,
    203,
    254,
    87,
    220,
    102,
    3,
    249,
    47,
    26,
    215,
    61,
    158,
    210,
    241,
    250,
    247,
    148,
    253,
    190,
    17,
    42,
    117,
    182,
    63,
    255,
    71,
    84,
    222,
    53,
    153,
    218,
    182,
    42,
    253,
    203,
    194,
    69,
    63,
    43,
    211,
    207,
    205,
    46,
    84,
    249,
    255,
    60,
    146,
    117,
    43,
    171,
    191,
    92,
    155,
    46,
    43,
    169,
    230,
    208,
    41,
    231,
    227,
    77,
    205,
    243,
    201,
    230,
    190,
    181,
    193,
    170,
    218,
    165,
    168,
    200,
    181,
    244,
    208,
    53,
    226,
    186,
    215,
    79,
    235,
    88,
    67,
    15,
    201,
    191,
    174,
    58,
    143,
    226,
    122,
    180,
    77,
    108,
    101,
    52,
    213,
    159,
    171,
    170,
    119,
    136,
    61,
    99,
    108,
    79,
    219,
    117,
    172,
    63,
    142,
    98,
    191,
    43,
    155,
    71,
    138,
    190,
    159,
    194,
    135,
    83,
    248,
    97,
    234,
    114,
    203,
    232,
    86,
    84,
    63,
    223,
    249,
    85,
    151,
    95,
    149,
    254,
    77,
    151,
    95,
    101,
    159,
    138,
    45,
    191,
    73,
    249,
    47
];
var trieData$2 = {
    type: type$2,
    data: data$2
};
var _class$7;
var _temp$3;
var categories$1 = useData.categories;
var decompositions$2 = useData.decompositions;
var trie$2 = new (0, _unicodeTrieDefault.default)(new Uint8Array(trieData$2.data));
var stateMachine$1 = new (0, _dfaDefault.default)(useData);
/**
 * This shaper is an implementation of the Universal Shaping Engine, which
 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
 */ var UniversalShaper = (_temp$3 = _class$7 = function(_DefaultShaper) {
    inherits(UniversalShaper, _DefaultShaper);
    function UniversalShaper() {
        classCallCheck(this, UniversalShaper);
        return possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
    }
    UniversalShaper.planFeatures = function planFeatures(plan) {
        plan.addStage(setupSyllables$1);
        // Default glyph pre-processing group
        plan.addStage([
            'locl',
            'ccmp',
            'nukt',
            'akhn'
        ]);
        // Reordering group
        plan.addStage(clearSubstitutionFlags);
        plan.addStage([
            'rphf'
        ], false);
        plan.addStage(recordRphf);
        plan.addStage(clearSubstitutionFlags);
        plan.addStage([
            'pref'
        ]);
        plan.addStage(recordPref);
        // Orthographic unit shaping group
        plan.addStage([
            'rkrf',
            'abvf',
            'blwf',
            'half',
            'pstf',
            'vatu',
            'cjct'
        ]);
        plan.addStage(reorder);
        // Topographical features
        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
        // Standard topographic presentation and positional feature application
        plan.addStage([
            'abvs',
            'blws',
            'pres',
            'psts',
            'dist',
            'abvm',
            'blwm'
        ]);
    };
    UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var _loop = function _loop(i) {
            var codepoint = glyphs[i].codePoints[0];
            if (decompositions$2[codepoint]) {
                var decomposed = decompositions$2[codepoint].map(function(c) {
                    var g = plan.font.glyphForCodePoint(c);
                    return new GlyphInfo(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [
                    i,
                    1
                ].concat(decomposed));
            }
        };
        // Decompose split vowels
        // TODO: do this in a more general unicode normalizer
        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
    };
    return UniversalShaper;
}(DefaultShaper), _class$7.zeroMarkWidths = 'BEFORE_GPOS', _temp$3);
function useCategory(glyph) {
    return trie$2.get(glyph.codePoints[0]);
}
var USEInfo = function USEInfo(category, syllableType, syllable) {
    classCallCheck(this, USEInfo);
    this.category = category;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function setupSyllables$1(font, glyphs) {
    var syllable = 0;
    for(var _iterator = stateMachine$1.match(glyphs.map(useCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var _ref2 = _ref, start = _ref2[0], end = _ref2[1], tags = _ref2[2];
        ++syllable;
        // Create shaper info
        for(var i = start; i <= end; i++)glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
        // Assign rphf feature
        var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
        for(var _i2 = start; _i2 < start + limit; _i2++)glyphs[_i2].features.rphf = true;
    }
}
function clearSubstitutionFlags(font, glyphs) {
    for(var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
        var _ref3;
        if (_isArray2) {
            if (_i3 >= _iterator2.length) break;
            _ref3 = _iterator2[_i3++];
        } else {
            _i3 = _iterator2.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
        }
        var glyph = _ref3;
        glyph.substituted = false;
    }
}
function recordRphf(font, glyphs) {
    for(var _iterator3 = glyphs, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
        var _ref4;
        if (_isArray3) {
            if (_i4 >= _iterator3.length) break;
            _ref4 = _iterator3[_i4++];
        } else {
            _i4 = _iterator3.next();
            if (_i4.done) break;
            _ref4 = _i4.value;
        }
        var glyph = _ref4;
        if (glyph.substituted && glyph.features.rphf) // Mark a substituted repha.
        glyph.shaperInfo.category = 'R';
    }
}
function recordPref(font, glyphs) {
    for(var _iterator4 = glyphs, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;){
        var _ref5;
        if (_isArray4) {
            if (_i5 >= _iterator4.length) break;
            _ref5 = _iterator4[_i5++];
        } else {
            _i5 = _iterator4.next();
            if (_i5.done) break;
            _ref5 = _i5.value;
        }
        var glyph = _ref5;
        if (glyph.substituted) // Mark a substituted pref as VPre, as they behave the same way.
        glyph.shaperInfo.category = 'VPre';
    }
}
function reorder(font, glyphs) {
    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
    for(var start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)){
        var i = void 0, j = void 0;
        var info = glyphs[start].shaperInfo;
        var type = info.syllableType;
        // Only a few syllable types need reordering.
        if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') continue;
        // Insert a dotted circle glyph in broken clusters.
        if (type === 'broken_cluster' && dottedCircle) {
            var g = new GlyphInfo(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = info;
            // Insert after possible Repha.
            for(i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++);
            glyphs.splice(++i, 0, g);
            end++;
        }
        // Move things forward.
        if (info.category === 'R' && end - start > 1) // Got a repha. Reorder it to after first base, before first halant.
        for(i = start + 1; i < end; i++){
            info = glyphs[i].shaperInfo;
            if (isBase(info) || isHalant(glyphs[i])) {
                // If we hit a halant, move before it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                if (isHalant(glyphs[i])) i--;
                glyphs.splice.apply(glyphs, [
                    start,
                    0
                ].concat(glyphs.splice(start + 1, i - start), [
                    glyphs[i]
                ]));
                break;
            }
        }
        // Move things back.
        for(i = start, j = end; i < end; i++){
            info = glyphs[i].shaperInfo;
            if (isBase(info) || isHalant(glyphs[i])) // If we hit a halant, move after it; otherwise it's a base: move to it's
            // place, and shift things in between backward.
            j = isHalant(glyphs[i]) ? i + 1 : i;
            else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) glyphs.splice.apply(glyphs, [
                j,
                1,
                glyphs[i]
            ].concat(glyphs.splice(j, i - j)));
        }
    }
}
function nextSyllable$1(glyphs, start) {
    if (start >= glyphs.length) return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
function isHalant(glyph) {
    return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
}
function isBase(info) {
    return info.category === 'B' || info.category === 'GB';
}
var SHAPERS = {
    arab: ArabicShaper,
    mong: ArabicShaper,
    syrc: ArabicShaper,
    'nko ': ArabicShaper,
    phag: ArabicShaper,
    mand: ArabicShaper,
    mani: ArabicShaper,
    phlp: ArabicShaper,
    hang: HangulShaper,
    bng2: IndicShaper,
    beng: IndicShaper,
    dev2: IndicShaper,
    deva: IndicShaper,
    gjr2: IndicShaper,
    gujr: IndicShaper,
    guru: IndicShaper,
    gur2: IndicShaper,
    knda: IndicShaper,
    knd2: IndicShaper,
    mlm2: IndicShaper,
    mlym: IndicShaper,
    ory2: IndicShaper,
    orya: IndicShaper,
    taml: IndicShaper,
    tml2: IndicShaper,
    telu: IndicShaper,
    tel2: IndicShaper,
    khmr: IndicShaper,
    bali: UniversalShaper,
    batk: UniversalShaper,
    brah: UniversalShaper,
    bugi: UniversalShaper,
    buhd: UniversalShaper,
    cakm: UniversalShaper,
    cham: UniversalShaper,
    dupl: UniversalShaper,
    egyp: UniversalShaper,
    gran: UniversalShaper,
    hano: UniversalShaper,
    java: UniversalShaper,
    kthi: UniversalShaper,
    kali: UniversalShaper,
    khar: UniversalShaper,
    khoj: UniversalShaper,
    sind: UniversalShaper,
    lepc: UniversalShaper,
    limb: UniversalShaper,
    mahj: UniversalShaper,
    // mand: UniversalShaper, // Mandaic
    // mani: UniversalShaper, // Manichaean
    mtei: UniversalShaper,
    modi: UniversalShaper,
    // mong: UniversalShaper, // Mongolian
    // 'nko ': UniversalShaper, // N’Ko
    hmng: UniversalShaper,
    // phag: UniversalShaper, // Phags-pa
    // phlp: UniversalShaper, // Psalter Pahlavi
    rjng: UniversalShaper,
    saur: UniversalShaper,
    shrd: UniversalShaper,
    sidd: UniversalShaper,
    sinh: UniversalShaper,
    sund: UniversalShaper,
    sylo: UniversalShaper,
    tglg: UniversalShaper,
    tagb: UniversalShaper,
    tale: UniversalShaper,
    lana: UniversalShaper,
    tavt: UniversalShaper,
    takr: UniversalShaper,
    tibt: UniversalShaper,
    tfng: UniversalShaper,
    tirh: UniversalShaper,
    latn: DefaultShaper,
    DFLT: DefaultShaper // Default
};
function choose(script) {
    if (!Array.isArray(script)) script = [
        script
    ];
    for(var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var s = _ref;
        var shaper = SHAPERS[s];
        if (shaper) return shaper;
    }
    return DefaultShaper;
}
var GSUBProcessor = function(_OTProcessor) {
    inherits(GSUBProcessor, _OTProcessor);
    function GSUBProcessor() {
        classCallCheck(this, GSUBProcessor);
        return possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
    }
    GSUBProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
        var _this2 = this;
        switch(lookupType){
            case 1:
                // Single Substitution
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var glyph = this.glyphIterator.cur;
                switch(table.version){
                    case 1:
                        glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                        break;
                    case 2:
                        glyph.id = table.substitute.get(index);
                        break;
                }
                return true;
            case 2:
                // Multiple Substitution
                var _index = this.coverageIndex(table.coverage);
                if (_index !== -1) {
                    var _glyphs;
                    var sequence = table.sequences.get(_index);
                    this.glyphIterator.cur.id = sequence[0];
                    this.glyphIterator.cur.ligatureComponent = 0;
                    var features = this.glyphIterator.cur.features;
                    var curGlyph = this.glyphIterator.cur;
                    var replacement = sequence.slice(1).map(function(gid, i) {
                        var glyph = new GlyphInfo(_this2.font, gid, undefined, features);
                        glyph.shaperInfo = curGlyph.shaperInfo;
                        glyph.isLigated = curGlyph.isLigated;
                        glyph.ligatureComponent = i + 1;
                        glyph.substituted = true;
                        glyph.isMultiplied = true;
                        return glyph;
                    });
                    (_glyphs = this.glyphs).splice.apply(_glyphs, [
                        this.glyphIterator.index + 1,
                        0
                    ].concat(replacement));
                    return true;
                }
                return false;
            case 3:
                // Alternate Substitution
                var _index2 = this.coverageIndex(table.coverage);
                if (_index2 !== -1) {
                    var USER_INDEX = 0; // TODO
                    this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
                    return true;
                }
                return false;
            case 4:
                // Ligature Substitution
                var _index3 = this.coverageIndex(table.coverage);
                if (_index3 === -1) return false;
                for(var _iterator = table.ligatureSets.get(_index3), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var ligature = _ref;
                    var matched = this.sequenceMatchIndices(1, ligature.components);
                    if (!matched) continue;
                    var _curGlyph = this.glyphIterator.cur;
                    // Concatenate all of the characters the new ligature will represent
                    var characters = _curGlyph.codePoints.slice();
                    for(var _iterator2 = matched, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                        var _ref2;
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) break;
                            _ref2 = _i2.value;
                        }
                        var _index4 = _ref2;
                        characters.push.apply(characters, this.glyphs[_index4].codePoints);
                    }
                    // Create the replacement ligature glyph
                    var ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features, _curGlyph.stringIndex);
                    ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                    ligatureGlyph.isLigated = true;
                    ligatureGlyph.substituted = true;
                    // From Harfbuzz:
                    // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                    //   the ligature to keep its old ligature id.  This will allow it to attach to
                    //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                    //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                    //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                    //   later, we don't want them to lose their ligature id/component, otherwise
                    //   GPOS will fail to correctly position the mark ligature on top of the
                    //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                    //
                    // - If a ligature is formed of components that some of which are also ligatures
                    //   themselves, and those ligature components had marks attached to *their*
                    //   components, we have to attach the marks to the new ligature component
                    //   positions!  Now *that*'s tricky!  And these marks may be following the
                    //   last component of the whole sequence, so we should loop forward looking
                    //   for them and update them.
                    //
                    //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                    //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                    //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                    //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                    //   the new ligature with a component value of 2.
                    //
                    //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                    var isMarkLigature = _curGlyph.isMark;
                    for(var i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                    ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                    var lastLigID = _curGlyph.ligatureID;
                    var lastNumComps = _curGlyph.codePoints.length;
                    var curComps = lastNumComps;
                    var idx = this.glyphIterator.index + 1;
                    // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                    // This allows GPOS to attach marks to the correct ligature components.
                    for(var _iterator3 = matched, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
                        var _ref3;
                        if (_isArray3) {
                            if (_i3 >= _iterator3.length) break;
                            _ref3 = _iterator3[_i3++];
                        } else {
                            _i3 = _iterator3.next();
                            if (_i3.done) break;
                            _ref3 = _i3.value;
                        }
                        var matchIndex = _ref3;
                        // Don't assign new ligature components for mark ligatures (see above)
                        if (isMarkLigature) idx = matchIndex;
                        else while(idx < matchIndex){
                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                            this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                            this.glyphs[idx].ligatureComponent = ligatureComponent;
                            idx++;
                        }
                        lastLigID = this.glyphs[idx].ligatureID;
                        lastNumComps = this.glyphs[idx].codePoints.length;
                        curComps += lastNumComps;
                        idx++; // skip base glyph
                    }
                    // Adjust ligature components for any marks following
                    if (lastLigID && !isMarkLigature) for(var _i4 = idx; _i4 < this.glyphs.length; _i4++){
                        if (this.glyphs[_i4].ligatureID === lastLigID) {
                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i4].ligatureComponent || 1, lastNumComps);
                            this.glyphs[_i4].ligatureComponent = ligatureComponent;
                        } else break;
                    }
                    // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                    for(var _i5 = matched.length - 1; _i5 >= 0; _i5--)this.glyphs.splice(matched[_i5], 1);
                    this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                    return true;
                }
                return false;
            case 5:
                // Contextual Substitution
                return this.applyContext(table);
            case 6:
                // Chaining Contextual Substitution
                return this.applyChainingContext(table);
            case 7:
                // Extension Substitution
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error('GSUB lookupType ' + lookupType + ' is not supported');
        }
    };
    return GSUBProcessor;
}(OTProcessor);
var GPOSProcessor = function(_OTProcessor) {
    inherits(GPOSProcessor, _OTProcessor);
    function GPOSProcessor() {
        classCallCheck(this, GPOSProcessor);
        return possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
    }
    GPOSProcessor.prototype.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
        var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
        if (value.xPlacement != null) position.xOffset += value.xPlacement;
        if (value.yPlacement != null) position.yOffset += value.yPlacement;
        // Adjustments for font variations
        var variationProcessor = this.font._variationProcessor;
        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
        }
    // TODO: device tables
    };
    GPOSProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                // Single positioning value
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                switch(table.version){
                    case 1:
                        this.applyPositionValue(0, table.value);
                        break;
                    case 2:
                        this.applyPositionValue(0, table.values.get(index));
                        break;
                }
                return true;
            case 2:
                // Pair Adjustment Positioning
                var nextGlyph = this.glyphIterator.peek();
                if (!nextGlyph) return false;
                var _index = this.coverageIndex(table.coverage);
                if (_index === -1) return false;
                switch(table.version){
                    case 1:
                        // Adjustments for glyph pairs
                        var set$$1 = table.pairSets.get(_index);
                        for(var _iterator = set$$1, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                            var _ref;
                            if (_isArray) {
                                if (_i >= _iterator.length) break;
                                _ref = _iterator[_i++];
                            } else {
                                _i = _iterator.next();
                                if (_i.done) break;
                                _ref = _i.value;
                            }
                            var _pair = _ref;
                            if (_pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, _pair.value1);
                                this.applyPositionValue(1, _pair.value2);
                                return true;
                            }
                        }
                        return false;
                    case 2:
                        // Class pair adjustment
                        var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                        var class2 = this.getClassID(nextGlyph.id, table.classDef2);
                        if (class1 === -1 || class2 === -1) return false;
                        var pair = table.classRecords.get(class1).get(class2);
                        this.applyPositionValue(0, pair.value1);
                        this.applyPositionValue(1, pair.value2);
                        return true;
                }
            case 3:
                // Cursive Attachment Positioning
                var nextIndex = this.glyphIterator.peekIndex();
                var _nextGlyph = this.glyphs[nextIndex];
                if (!_nextGlyph) return false;
                var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                if (!curRecord || !curRecord.exitAnchor) return false;
                var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
                if (!nextRecord || !nextRecord.entryAnchor) return false;
                var entry = this.getAnchor(nextRecord.entryAnchor);
                var exit = this.getAnchor(curRecord.exitAnchor);
                var cur = this.positions[this.glyphIterator.index];
                var next = this.positions[nextIndex];
                switch(this.direction){
                    case 'ltr':
                        cur.xAdvance = exit.x + cur.xOffset;
                        var d = entry.x + next.xOffset;
                        next.xAdvance -= d;
                        next.xOffset -= d;
                        break;
                    case 'rtl':
                        d = exit.x + cur.xOffset;
                        cur.xAdvance -= d;
                        cur.xOffset -= d;
                        next.xAdvance = entry.x + next.xOffset;
                        break;
                }
                if (this.glyphIterator.flags.rightToLeft) {
                    this.glyphIterator.cur.cursiveAttachment = nextIndex;
                    cur.yOffset = entry.y - exit.y;
                } else {
                    _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                    cur.yOffset = exit.y - entry.y;
                }
                return true;
            case 4:
                // Mark to base positioning
                var markIndex = this.coverageIndex(table.markCoverage);
                if (markIndex === -1) return false;
                // search backward for a base glyph
                var baseGlyphIndex = this.glyphIterator.index;
                while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                if (baseGlyphIndex < 0) return false;
                var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                if (baseIndex === -1) return false;
                var markRecord = table.markArray[markIndex];
                var baseAnchor = table.baseArray[baseIndex][markRecord.class];
                this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                return true;
            case 5:
                // Mark to ligature positioning
                var _markIndex = this.coverageIndex(table.markCoverage);
                if (_markIndex === -1) return false;
                // search backward for a base glyph
                var _baseGlyphIndex = this.glyphIterator.index;
                while(--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark);
                if (_baseGlyphIndex < 0) return false;
                var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
                if (ligIndex === -1) return false;
                var ligAttach = table.ligatureArray[ligIndex];
                var markGlyph = this.glyphIterator.cur;
                var ligGlyph = this.glyphs[_baseGlyphIndex];
                var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                var _markRecord = table.markArray[_markIndex];
                var _baseAnchor = ligAttach[compIndex][_markRecord.class];
                this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
                return true;
            case 6:
                // Mark to mark positioning
                var mark1Index = this.coverageIndex(table.mark1Coverage);
                if (mark1Index === -1) return false;
                // get the previous mark to attach to
                var prevIndex = this.glyphIterator.peekIndex(-1);
                var prev = this.glyphs[prevIndex];
                if (!prev || !prev.isMark) return false;
                var _cur = this.glyphIterator.cur;
                // The following logic was borrowed from Harfbuzz
                var good = false;
                if (_cur.ligatureID === prev.ligatureID) {
                    if (!_cur.ligatureID) // Marks belonging to the same base
                    good = true;
                    else if (_cur.ligatureComponent === prev.ligatureComponent) // Marks belonging to the same ligature component
                    good = true;
                } else // If ligature ids don't match, it may be the case that one of the marks
                // itself is a ligature, in which case match.
                if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                if (!good) return false;
                var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                if (mark2Index === -1) return false;
                var _markRecord2 = table.mark1Array[mark1Index];
                var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
                this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                return true;
            case 7:
                // Contextual positioning
                return this.applyContext(table);
            case 8:
                // Chaining contextual positioning
                return this.applyChainingContext(table);
            case 9:
                // Extension positioning
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error('Unsupported GPOS table: ' + lookupType);
        }
    };
    GPOSProcessor.prototype.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
        var baseCoords = this.getAnchor(baseAnchor);
        var markCoords = this.getAnchor(markRecord.markAnchor);
        var basePos = this.positions[baseGlyphIndex];
        var markPos = this.positions[this.glyphIterator.index];
        markPos.xOffset = baseCoords.x - markCoords.x;
        markPos.yOffset = baseCoords.y - markCoords.y;
        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
    };
    GPOSProcessor.prototype.getAnchor = function getAnchor(anchor) {
        // TODO: contour point, device tables
        var x = anchor.xCoordinate;
        var y = anchor.yCoordinate;
        // Adjustments for font variations
        var variationProcessor = this.font._variationProcessor;
        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
        }
        return {
            x: x,
            y: y
        };
    };
    GPOSProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
        _OTProcessor.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);
        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
        this.fixMarkAttachment();
    };
    GPOSProcessor.prototype.fixCursiveAttachment = function fixCursiveAttachment(i) {
        var glyph = this.glyphs[i];
        if (glyph.cursiveAttachment != null) {
            var j = glyph.cursiveAttachment;
            glyph.cursiveAttachment = null;
            this.fixCursiveAttachment(j);
            this.positions[i].yOffset += this.positions[j].yOffset;
        }
    };
    GPOSProcessor.prototype.fixMarkAttachment = function fixMarkAttachment() {
        for(var i = 0; i < this.glyphs.length; i++){
            var glyph = this.glyphs[i];
            if (glyph.markAttachment != null) {
                var j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;
                if (this.direction === 'ltr') for(var k = j; k < i; k++){
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                }
                else for(var _k = j + 1; _k < i + 1; _k++){
                    this.positions[i].xOffset += this.positions[_k].xAdvance;
                    this.positions[i].yOffset += this.positions[_k].yAdvance;
                }
            }
        }
    };
    return GPOSProcessor;
}(OTProcessor);
var OTLayoutEngine = function() {
    function OTLayoutEngine(font) {
        classCallCheck(this, OTLayoutEngine);
        this.font = font;
        this.plan = null;
        this.GSUBProcessor = null;
        this.GPOSProcessor = null;
        this.fallbackPosition = true;
        if (font.GSUB) this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
        if (font.GPOS) this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
    }
    OTLayoutEngine.prototype.setup = function setup(glyphRun) {
        // Select a script based on what is available in GSUB/GPOS.
        var script = null;
        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        // Choose a shaper based on the script, and setup a shaping plan.
        // This determines which features to apply to which glyphs.
        this.shaper = choose(script);
        this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
        this.shaper.plan(this.plan, glyphRun.glyphs, glyphRun.features);
        // Assign chosen features to output glyph run
        for(var key in this.plan.allFeatures)glyphRun.features[key] = true;
    };
    OTLayoutEngine.prototype.substitute = function substitute(glyphRun) {
        if (this.GSUBProcessor) this.plan.process(this.GSUBProcessor, glyphRun.glyphs);
    };
    OTLayoutEngine.prototype.position = function position(glyphRun) {
        if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') this.zeroMarkAdvances(glyphRun);
        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, glyphRun.glyphs, glyphRun.positions);
        if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') this.zeroMarkAdvances(glyphRun);
        // Reverse the glyphs and positions if the script is right-to-left
        if (glyphRun.direction === 'rtl') {
            glyphRun.glyphs.reverse();
            glyphRun.positions.reverse();
        }
        return this.GPOSProcessor && this.GPOSProcessor.features;
    };
    OTLayoutEngine.prototype.zeroMarkAdvances = function zeroMarkAdvances(glyphRun) {
        for(var i = 0; i < glyphRun.glyphs; i++)if (glyphRun.glyphs[i].isMark) {
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    };
    OTLayoutEngine.prototype.cleanup = function cleanup() {
        this.glyphInfos = null;
        this.plan = null;
        this.shaper = null;
    };
    OTLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
        var features = [];
        if (this.GSUBProcessor) {
            this.GSUBProcessor.selectScript(script, language);
            features.push.apply(features, Object.keys(this.GSUBProcessor.features));
        }
        if (this.GPOSProcessor) {
            this.GPOSProcessor.selectScript(script, language);
            features.push.apply(features, Object.keys(this.GPOSProcessor.features));
        }
        return features;
    };
    return OTLayoutEngine;
}();
var LayoutEngine = function() {
    function LayoutEngine(font) {
        classCallCheck(this, LayoutEngine);
        this.font = font;
        this.unicodeLayoutEngine = null;
        this.kernProcessor = null;
        // Choose an advanced layout engine. We try the AAT morx table first since more
        // scripts are currently supported because the shaping logic is built into the font.
        if (this.font.morx) this.engine = new AATLayoutEngine(this.font);
        else if (this.font.GSUB || this.font.GPOS) this.engine = new OTLayoutEngine(this.font);
    }
    LayoutEngine.prototype.layout = function layout(string, features, script, language, direction$$1) {
        var _this = this;
        // Make the features parameter optional
        if (typeof features === 'string') {
            direction$$1 = language;
            language = script;
            script = features;
            features = [];
        }
        // Attempt to detect the script from the string if not provided.
        if (script == null) script = forString(string);
        var glyphs = this.glyphsForString(string);
        var glyphRun = new GlyphRun(glyphs, features, script, language, direction$$1);
        // Return early if there are no glyphs
        if (glyphs.length === 0) {
            glyphRun.positions = [];
            return glyphRun;
        }
        // Setup the advanced layout engine
        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
        // Substitute and position the glyphs
        this.substitute(glyphRun);
        this.position(glyphRun);
        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);
        // Let the layout engine clean up any state it might have
        if (this.engine && this.engine.cleanup) this.engine.cleanup();
        // Map glyph infos back to normal Glyph objects
        glyphRun.stringIndices = glyphRun.glyphs.map(function(glyphInfo) {
            return glyphInfo.stringIndex;
        });
        glyphRun.glyphs = glyphRun.glyphs.map(function(glyphInfo) {
            return _this.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
        });
        return glyphRun;
    };
    LayoutEngine.prototype.glyphsForString = function glyphsForString(string) {
        var glyphs = [];
        var len = string.length;
        var idx = 0;
        var last = -1;
        var state = -1;
        while(idx <= len){
            var code = 0;
            var nextState = 0;
            var stringIndex = idx - 1;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    var next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                }
                // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) // Variation selector following normal codepoint.
            glyphs.push(new GlyphInfo(this.font, this.font._cmapProcessor.lookup(last, code), [
                last,
                code
            ], null, stringIndex));
            else if (state === 0 && nextState === 0) // Normal codepoint following normal codepoint.
            glyphs.push(new GlyphInfo(this.font, this.font._cmapProcessor.lookup(last), [
                last
            ], null, stringIndex));
            last = code;
            state = nextState;
        }
        return glyphs;
    };
    LayoutEngine.prototype.substitute = function substitute(glyphRun) {
        // Call the advanced layout engine to make substitutions
        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
    };
    LayoutEngine.prototype.position = function position(glyphRun) {
        // Get initial glyph positions
        glyphRun.positions = glyphRun.glyphs.map(function(glyph) {
            return new GlyphPosition(glyph.advanceWidth);
        });
        var positioned = null;
        // Call the advanced layout engine. Returns the features applied.
        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
        // if there is no GPOS table, use unicode properties to position marks.
        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
        }
        // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
            if (!this.kernProcessor) this.kernProcessor = new KernProcessor(this.font);
            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
            glyphRun.features.kern = true;
        }
    };
    LayoutEngine.prototype.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions1) {
        var space = this.font.glyphForCodePoint(0x20);
        for(var i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
            glyphs[i] = space;
            positions1[i].xAdvance = 0;
            positions1[i].yAdvance = 0;
        }
    };
    LayoutEngine.prototype.isDefaultIgnorable = function isDefaultIgnorable(ch) {
        // From DerivedCoreProperties.txt in the Unicode database,
        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
        // Harfbuzz and Uniscribe do.
        var plane = ch >> 16;
        if (plane === 0) // BMP
        switch(ch >> 8){
            case 0x00:
                return ch === 0x00ad;
            case 0x03:
                return ch === 0x034f;
            case 0x06:
                return ch === 0x061c;
            case 0x17:
                return 0x17b4 <= ch && ch <= 0x17b5;
            case 0x18:
                return 0x180b <= ch && ch <= 0x180e;
            case 0x20:
                return 0x200b <= ch && ch <= 0x200f || 0x202a <= ch && ch <= 0x202e || 0x2060 <= ch && ch <= 0x206f;
            case 0xfe:
                return 0xfe00 <= ch && ch <= 0xfe0f || ch === 0xfeff;
            case 0xff:
                return 0xfff0 <= ch && ch <= 0xfff8;
            default:
                return false;
        }
        else // Other planes
        switch(plane){
            case 0x01:
                return 0x1bca0 <= ch && ch <= 0x1bca3 || 0x1d173 <= ch && ch <= 0x1d17a;
            case 0x0e:
                return 0xe0000 <= ch && ch <= 0xe0fff;
            default:
                return false;
        }
    };
    LayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
        var features = [];
        if (this.engine) features.push.apply(features, this.engine.getAvailableFeatures(script, language));
        if (this.font.kern && features.indexOf('kern') === -1) features.push('kern');
        return features;
    };
    LayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
        var result = new Set();
        var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
        for(var _iterator = codePoints, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var codePoint = _ref;
            result.add(String.fromCodePoint(codePoint));
        }
        if (this.engine && this.engine.stringsForGlyph) for(var _iterator2 = this.engine.stringsForGlyph(gid), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var string = _ref2;
            result.add(string);
        }
        return Array.from(result);
    };
    return LayoutEngine;
}();
var SVG_COMMANDS = {
    moveTo: 'M',
    lineTo: 'L',
    quadraticCurveTo: 'Q',
    bezierCurveTo: 'C',
    closePath: 'Z'
};
/**
 * Path objects are returned by glyphs and represent the actual
 * vector outlines for each glyph in the font. Paths can be converted
 * to SVG path data strings, or to functions that can be applied to
 * render the path to a graphics context.
 */ var Path = function() {
    function Path() {
        classCallCheck(this, Path);
        this.commands = [];
        this._bbox = null;
        this._cbox = null;
    }
    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ Path.prototype.toFunction = function toFunction() {
        var cmds = this.commands.map(function(c) {
            return '  ctx.' + c.command + '(' + c.args.join(', ') + ');';
        });
        return new Function('ctx', cmds.join('\n'));
    };
    /**
   * Converts the path to an SVG path data string
   * @return {string}
   */ Path.prototype.toSVG = function toSVG() {
        var cmds = this.commands.map(function(c) {
            var args = c.args.map(function(arg) {
                return Math.round(arg * 100) / 100;
            });
            return '' + SVG_COMMANDS[c.command] + args.join(' ');
        });
        return cmds.join('');
    };
    /**
   * Gets the "control box" of a path.
   * This is like the bounding box, but it includes all points including
   * control points of bezier segments and is much faster to compute than
   * the real bounding box.
   * @type {BBox}
   */ /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ Path.prototype.mapPoints = function mapPoints(fn) {
        var path = new Path();
        for(var _iterator = this.commands, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var c = _ref;
            var args = [];
            for(var _i2 = 0; _i2 < c.args.length; _i2 += 2){
                var _fn = fn(c.args[_i2], c.args[_i2 + 1]), x = _fn[0], y = _fn[1];
                args.push(x, y);
            }
            path[c.command].apply(path, args);
        }
        return path;
    };
    /**
   * Transforms the path by the given matrix.
   */ Path.prototype.transform = function transform(m0, m1, m2, m3, m4, m5) {
        return this.mapPoints(function(x, y) {
            x = m0 * x + m2 * y + m4;
            y = m1 * x + m3 * y + m5;
            return [
                x,
                y
            ];
        });
    };
    /**
   * Translates the path by the given offset.
   */ Path.prototype.translate = function translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    };
    /**
   * Rotates the path by the given angle (in radians).
   */ Path.prototype.rotate = function rotate(angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        return this.transform(cos, sin, -sin, cos, 0, 0);
    };
    /**
   * Scales the path.
   */ Path.prototype.scale = function scale(scaleX) {
        var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
    };
    createClass(Path, [
        {
            key: 'cbox',
            get: function get$$1() {
                if (!this._cbox) {
                    var cbox = new BBox();
                    for(var _iterator2 = this.commands, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                        var _ref2;
                        if (_isArray2) {
                            if (_i3 >= _iterator2.length) break;
                            _ref2 = _iterator2[_i3++];
                        } else {
                            _i3 = _iterator2.next();
                            if (_i3.done) break;
                            _ref2 = _i3.value;
                        }
                        var command = _ref2;
                        for(var _i4 = 0; _i4 < command.args.length; _i4 += 2)cbox.addPoint(command.args[_i4], command.args[_i4 + 1]);
                    }
                    this._cbox = Object.freeze(cbox);
                }
                return this._cbox;
            }
        },
        {
            key: 'bbox',
            get: function get$$1() {
                if (this._bbox) return this._bbox;
                var bbox = new BBox();
                var cx = 0, cy = 0;
                var f = function f(t) {
                    return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
                };
                for(var _iterator3 = this.commands, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
                    var _ref3;
                    if (_isArray3) {
                        if (_i5 >= _iterator3.length) break;
                        _ref3 = _iterator3[_i5++];
                    } else {
                        _i5 = _iterator3.next();
                        if (_i5.done) break;
                        _ref3 = _i5.value;
                    }
                    var c = _ref3;
                    switch(c.command){
                        case 'moveTo':
                        case 'lineTo':
                            var _c$args = c.args, x = _c$args[0], y = _c$args[1];
                            bbox.addPoint(x, y);
                            cx = x;
                            cy = y;
                            break;
                        case 'quadraticCurveTo':
                        case 'bezierCurveTo':
                            if (c.command === 'quadraticCurveTo') {
                                // http://fontforge.org/bezier.html
                                var _c$args2 = c.args, qp1x = _c$args2[0], qp1y = _c$args2[1], p3x = _c$args2[2], p3y = _c$args2[3];
                                var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                                var cp1y = cy + 2 / 3 * (qp1y - cy);
                                var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                                var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                            } else var _c$args3 = c.args, cp1x = _c$args3[0], cp1y = _c$args3[1], cp2x = _c$args3[2], cp2y = _c$args3[3], p3x = _c$args3[4], p3y = _c$args3[5];
                            // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                            bbox.addPoint(p3x, p3y);
                            var p0 = [
                                cx,
                                cy
                            ];
                            var p1 = [
                                cp1x,
                                cp1y
                            ];
                            var p2 = [
                                cp2x,
                                cp2y
                            ];
                            var p3 = [
                                p3x,
                                p3y
                            ];
                            for(var i = 0; i <= 1; i++){
                                var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                                var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                                c = 3 * p1[i] - 3 * p0[i];
                                if (a === 0) {
                                    if (b === 0) continue;
                                    var t = -c / b;
                                    if (0 < t && t < 1) {
                                        if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                                    }
                                    continue;
                                }
                                var b2ac = Math.pow(b, 2) - 4 * c * a;
                                if (b2ac < 0) continue;
                                var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t1 && t1 < 1) {
                                    if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                                }
                                var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t2 && t2 < 1) {
                                    if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                                }
                            }
                            cx = p3x;
                            cy = p3y;
                            break;
                    }
                }
                return this._bbox = Object.freeze(bbox);
            }
        }
    ]);
    return Path;
}();
var _arr = [
    'moveTo',
    'lineTo',
    'quadraticCurveTo',
    'bezierCurveTo',
    'closePath'
];
var _loop = function _loop() {
    var command = _arr[_i6];
    Path.prototype[command] = function() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        this._bbox = this._cbox = null;
        this.commands.push({
            command: command,
            args: args
        });
        return this;
    };
};
for(var _i6 = 0; _i6 < _arr.length; _i6++)_loop();
var StandardNames = [
    '.notdef',
    '.null',
    'nonmarkingreturn',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quotesingle',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'grave',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'Adieresis',
    'Aring',
    'Ccedilla',
    'Eacute',
    'Ntilde',
    'Odieresis',
    'Udieresis',
    'aacute',
    'agrave',
    'acircumflex',
    'adieresis',
    'atilde',
    'aring',
    'ccedilla',
    'eacute',
    'egrave',
    'ecircumflex',
    'edieresis',
    'iacute',
    'igrave',
    'icircumflex',
    'idieresis',
    'ntilde',
    'oacute',
    'ograve',
    'ocircumflex',
    'odieresis',
    'otilde',
    'uacute',
    'ugrave',
    'ucircumflex',
    'udieresis',
    'dagger',
    'degree',
    'cent',
    'sterling',
    'section',
    'bullet',
    'paragraph',
    'germandbls',
    'registered',
    'copyright',
    'trademark',
    'acute',
    'dieresis',
    'notequal',
    'AE',
    'Oslash',
    'infinity',
    'plusminus',
    'lessequal',
    'greaterequal',
    'yen',
    'mu',
    'partialdiff',
    'summation',
    'product',
    'pi',
    'integral',
    'ordfeminine',
    'ordmasculine',
    'Omega',
    'ae',
    'oslash',
    'questiondown',
    'exclamdown',
    'logicalnot',
    'radical',
    'florin',
    'approxequal',
    'Delta',
    'guillemotleft',
    'guillemotright',
    'ellipsis',
    'nonbreakingspace',
    'Agrave',
    'Atilde',
    'Otilde',
    'OE',
    'oe',
    'endash',
    'emdash',
    'quotedblleft',
    'quotedblright',
    'quoteleft',
    'quoteright',
    'divide',
    'lozenge',
    'ydieresis',
    'Ydieresis',
    'fraction',
    'currency',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'daggerdbl',
    'periodcentered',
    'quotesinglbase',
    'quotedblbase',
    'perthousand',
    'Acircumflex',
    'Ecircumflex',
    'Aacute',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Oacute',
    'Ocircumflex',
    'apple',
    'Ograve',
    'Uacute',
    'Ucircumflex',
    'Ugrave',
    'dotlessi',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'Lslash',
    'lslash',
    'Scaron',
    'scaron',
    'Zcaron',
    'zcaron',
    'brokenbar',
    'Eth',
    'eth',
    'Yacute',
    'yacute',
    'Thorn',
    'thorn',
    'minus',
    'multiply',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'onehalf',
    'onequarter',
    'threequarters',
    'franc',
    'Gbreve',
    'gbreve',
    'Idotaccent',
    'Scedilla',
    'scedilla',
    'Cacute',
    'cacute',
    'Ccaron',
    'ccaron',
    'dcroat'
];
var _class$8;
function _applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
 *
 * You do not create glyph objects directly. They are created by various methods on the font object.
 * There are several subclasses of the base Glyph class internally that may be returned depending
 * on the font format, but they all inherit from this class.
 */ var Glyph = (_class$8 = function() {
    function Glyph(id, codePoints, font) {
        classCallCheck(this, Glyph);
        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
        this._font = font;
        // TODO: get this info from GDEF if available
        this.isMark = this.codePoints.length > 0 && this.codePoints.every((0, _unicodePropertiesDefault.default).isMark);
        this.isLigature = this.codePoints.length > 1;
    }
    Glyph.prototype._getPath = function _getPath() {
        return new Path();
    };
    Glyph.prototype._getCBox = function _getCBox() {
        return this.path.cbox;
    };
    Glyph.prototype._getBBox = function _getBBox() {
        return this.path.bbox;
    };
    Glyph.prototype._getTableMetrics = function _getTableMetrics(table) {
        if (this.id < table.metrics.length) return table.metrics.get(this.id);
        var metric = table.metrics.get(table.metrics.length - 1);
        var res = {
            advance: metric ? metric.advance : 0,
            bearing: table.bearings.get(this.id - table.metrics.length) || 0
        };
        return res;
    };
    Glyph.prototype._getMetrics = function _getMetrics(cbox) {
        if (this._metrics) return this._metrics;
        var _getTableMetrics2 = this._getTableMetrics(this._font.hmtx), advanceWidth = _getTableMetrics2.advance, leftBearing = _getTableMetrics2.bearing;
        // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
        if (this._font.vmtx) var _getTableMetrics3 = this._getTableMetrics(this._font.vmtx), advanceHeight = _getTableMetrics3.advance, topBearing = _getTableMetrics3.bearing;
        else {
            var os2 = void 0;
            if (typeof cbox === 'undefined' || cbox === null) cbox = this.cbox;
            if ((os2 = this._font['OS/2']) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
            } else {
                var hhea = this._font.hhea;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
            }
        }
        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
        return this._metrics = {
            advanceWidth: advanceWidth,
            advanceHeight: advanceHeight,
            leftBearing: leftBearing,
            topBearing: topBearing
        };
    };
    /**
   * The glyph’s control box.
   * This is often the same as the bounding box, but is faster to compute.
   * Because of the way bezier curves are defined, some of the control points
   * can be outside of the bounding box. Where `bbox` takes this into account,
   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
   * for a more detailed description.
   *
   * @type {BBox}
   */ /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ Glyph.prototype.getScaledPath = function getScaledPath(size) {
        var scale = 1 / this._font.unitsPerEm * size;
        return this.path.scale(scale);
    };
    /**
   * The glyph's advance width.
   * @type {number}
   */ Glyph.prototype._getName = function _getName() {
        var post = this._font.post;
        if (!post) return null;
        switch(post.version){
            case 1:
                return StandardNames[this.id];
            case 2:
                var id = post.glyphNameIndex[this.id];
                if (id < StandardNames.length) return StandardNames[id];
                return post.names[id - StandardNames.length];
            case 2.5:
                return StandardNames[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
        }
    };
    /**
   * The glyph's name
   * @type {string}
   */ /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ Glyph.prototype.render = function render(ctx, size) {
        ctx.save();
        var scale = 1 / this._font.head.unitsPerEm * size;
        ctx.scale(scale, scale);
        var fn = this.path.toFunction();
        fn(ctx);
        ctx.fill();
        ctx.restore();
    };
    createClass(Glyph, [
        {
            key: 'cbox',
            get: function get$$1() {
                return this._getCBox();
            }
        },
        {
            key: 'bbox',
            get: function get$$1() {
                return this._getBBox();
            }
        },
        {
            key: 'path',
            get: function get$$1() {
                // Cache the path so we only decode it once
                // Decoding is actually performed by subclasses
                return this._getPath();
            }
        },
        {
            key: 'advanceWidth',
            get: function get$$1() {
                return this._getMetrics().advanceWidth;
            }
        },
        {
            key: 'advanceHeight',
            get: function get$$1() {
                return this._getMetrics().advanceHeight;
            }
        },
        {
            key: 'ligatureCaretPositions',
            get: function get$$1() {}
        },
        {
            key: 'name',
            get: function get$$1() {
                return this._getName();
            }
        }
    ]);
    return Glyph;
}(), _applyDecoratedDescriptor$4(_class$8.prototype, 'cbox', [
    cache
], Object.getOwnPropertyDescriptor(_class$8.prototype, 'cbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'bbox', [
    cache
], Object.getOwnPropertyDescriptor(_class$8.prototype, 'bbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'path', [
    cache
], Object.getOwnPropertyDescriptor(_class$8.prototype, 'path'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceWidth', [
    cache
], Object.getOwnPropertyDescriptor(_class$8.prototype, 'advanceWidth'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceHeight', [
    cache
], Object.getOwnPropertyDescriptor(_class$8.prototype, 'advanceHeight'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'name', [
    cache
], Object.getOwnPropertyDescriptor(_class$8.prototype, 'name'), _class$8.prototype), _class$8);
// The header for both simple and composite glyphs
var GlyfHeader = new (0, _restructureDefault.default).Struct({
    numberOfContours: (0, _restructureDefault.default).int16,
    xMin: (0, _restructureDefault.default).int16,
    yMin: (0, _restructureDefault.default).int16,
    xMax: (0, _restructureDefault.default).int16,
    yMax: (0, _restructureDefault.default).int16
});
// Flags for simple glyphs
var ON_CURVE = 1;
var X_SHORT_VECTOR = 2;
var Y_SHORT_VECTOR = 4;
var REPEAT = 8;
var SAME_X = 16;
var SAME_Y = 32;
// Flags for composite glyphs
var ARG_1_AND_2_ARE_WORDS = 1;
var WE_HAVE_A_SCALE = 8;
var MORE_COMPONENTS = 32;
var WE_HAVE_AN_X_AND_Y_SCALE = 64;
var WE_HAVE_A_TWO_BY_TWO = 128;
var WE_HAVE_INSTRUCTIONS = 256;
// Represents a point in a simple glyph
var Point = function() {
    function Point(onCurve, endContour) {
        var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        classCallCheck(this, Point);
        this.onCurve = onCurve;
        this.endContour = endContour;
        this.x = x;
        this.y = y;
    }
    Point.prototype.copy = function copy() {
        return new Point(this.onCurve, this.endContour, this.x, this.y);
    };
    return Point;
}();
// Represents a component in a composite glyph
var Component = function Component(glyphID, dx, dy) {
    classCallCheck(this, Component);
    this.glyphID = glyphID;
    this.dx = dx;
    this.dy = dy;
    this.pos = 0;
    this.scaleX = this.scaleY = 1;
    this.scale01 = this.scale10 = 0;
};
/**
 * Represents a TrueType glyph.
 */ var TTFGlyph = function(_Glyph) {
    inherits(TTFGlyph, _Glyph);
    function TTFGlyph() {
        classCallCheck(this, TTFGlyph);
        return possibleConstructorReturn(this, _Glyph.apply(this, arguments));
    }
    // Parses just the glyph header and returns the bounding box
    TTFGlyph.prototype._getCBox = function _getCBox(internal) {
        // We need to decode the glyph if variation processing is requested,
        // so it's easier just to recompute the path's cbox after decoding.
        if (this._font._variationProcessor && !internal) return this.path.cbox;
        var stream = this._font._getTableStream('glyf');
        stream.pos += this._font.loca.offsets[this.id];
        var glyph = GlyfHeader.decode(stream);
        var cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
        return Object.freeze(cbox);
    };
    // Parses a single glyph coordinate
    TTFGlyph.prototype._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
        if (short) {
            var val = stream.readUInt8();
            if (!same) val = -val;
            val += prev;
        } else if (same) var val = prev;
        else var val = prev + stream.readInt16BE();
        return val;
    };
    // Decodes the glyph data into points for simple glyphs,
    // or components for composite glyphs
    TTFGlyph.prototype._decode = function _decode() {
        var glyfPos = this._font.loca.offsets[this.id];
        var nextPos = this._font.loca.offsets[this.id + 1];
        // Nothing to do if there is no data for this glyph
        if (glyfPos === nextPos) return null;
        var stream = this._font._getTableStream('glyf');
        stream.pos += glyfPos;
        var startPos = stream.pos;
        var glyph = GlyfHeader.decode(stream);
        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
        return glyph;
    };
    TTFGlyph.prototype._decodeSimple = function _decodeSimple(glyph, stream) {
        // this is a simple glyph
        glyph.points = [];
        var endPtsOfContours = new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, glyph.numberOfContours).decode(stream);
        glyph.instructions = new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, (0, _restructureDefault.default).uint16).decode(stream);
        var flags = [];
        var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
        while(flags.length < numCoords){
            var flag = stream.readUInt8();
            flags.push(flag);
            // check for repeat flag
            if (flag & REPEAT) {
                var count = stream.readUInt8();
                for(var j = 0; j < count; j++)flags.push(flag);
            }
        }
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            var point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
            glyph.points.push(point);
        }
        var px = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
        }
        var py = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
        }
        if (this._font._variationProcessor) {
            var points = glyph.points.slice();
            points.push.apply(points, this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.slice(-4);
        }
        return;
    };
    TTFGlyph.prototype._decodeComposite = function _decodeComposite(glyph, stream) {
        var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        // this is a composite glyph
        glyph.components = [];
        var haveInstructions = false;
        var flags = MORE_COMPONENTS;
        while(flags & MORE_COMPONENTS){
            flags = stream.readUInt16BE();
            var gPos = stream.pos - offset;
            var glyphID = stream.readUInt16BE();
            if (!haveInstructions) haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
            if (flags & ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
            } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
            }
            var component = new Component(glyphID, dx, dy);
            component.pos = gPos;
            if (flags & WE_HAVE_A_SCALE) // fixed number with 14 bits of fraction
            component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            }
            glyph.components.push(component);
        }
        if (this._font._variationProcessor) {
            var points = [];
            for(var j = 0; j < glyph.components.length; j++){
                var component = glyph.components[j];
                points.push(new Point(true, true, component.dx, component.dy));
            }
            points.push.apply(points, this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.splice(-4, 4);
            for(var i = 0; i < points.length; i++){
                var point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
            }
        }
        return haveInstructions;
    };
    TTFGlyph.prototype._getPhantomPoints = function _getPhantomPoints(glyph) {
        var cbox = this._getCBox(true);
        if (this._metrics == null) this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
        var _metrics = this._metrics, advanceWidth = _metrics.advanceWidth, advanceHeight = _metrics.advanceHeight, leftBearing = _metrics.leftBearing, topBearing = _metrics.topBearing;
        return [
            new Point(false, true, glyph.xMin - leftBearing, 0),
            new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
            new Point(false, true, 0, glyph.yMax + topBearing),
            new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)
        ];
    };
    // Decodes font data, resolves composite glyphs, and returns an array of contours
    TTFGlyph.prototype._getContours = function _getContours() {
        var glyph = this._decode();
        if (!glyph) return [];
        var points = [];
        if (glyph.numberOfContours < 0) // resolve composite glyphs
        for(var _iterator = glyph.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var component = _ref;
            var _contours = this._font.getGlyph(component.glyphID)._getContours();
            for(var i = 0; i < _contours.length; i++){
                var contour = _contours[i];
                for(var j = 0; j < contour.length; j++){
                    var _point = contour[j];
                    var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
                    var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
                    points.push(new Point(_point.onCurve, _point.endContour, x, y));
                }
            }
        }
        else points = glyph.points || [];
        // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
        }
        var contours = [];
        var cur = [];
        for(var k = 0; k < points.length; k++){
            var point = points[k];
            cur.push(point);
            if (point.endContour) {
                contours.push(cur);
                cur = [];
            }
        }
        return contours;
    };
    TTFGlyph.prototype._getMetrics = function _getMetrics() {
        if (this._metrics) return this._metrics;
        var cbox = this._getCBox(true);
        _Glyph.prototype._getMetrics.call(this, cbox);
        if (this._font._variationProcessor && !this._font.HVAR) // No HVAR table, decode the glyph. This triggers recomputation of metrics.
        this.path;
        return this._metrics;
    };
    // Converts contours to a Path object that can be rendered
    TTFGlyph.prototype._getPath = function _getPath() {
        var contours = this._getContours();
        var path = new Path();
        for(var i = 0; i < contours.length; i++){
            var contour = contours[i];
            var firstPt = contour[0];
            var lastPt = contour[contour.length - 1];
            var start = 0;
            if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
            } else {
                if (lastPt.onCurve) // Start at the last point if the first point is off curve and the last point is on curve
                firstPt = lastPt;
                else // Start at the middle if both the first and last points are off curve
                firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                var curvePt = firstPt;
            }
            path.moveTo(firstPt.x, firstPt.y);
            for(var j = start; j < contour.length; j++){
                var pt = contour[j];
                var prevPt = j === 0 ? firstPt : contour[j - 1];
                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                else if (!prevPt.onCurve && !pt.onCurve) {
                    var midX = (prevPt.x + pt.x) / 2;
                    var midY = (prevPt.y + pt.y) / 2;
                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                    var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                    var curvePt = null;
                } else throw new Error("Unknown TTF path state");
            }
            // Connect the first and last points
            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            path.closePath();
        }
        return path;
    };
    return TTFGlyph;
}(Glyph);
/**
 * Represents an OpenType PostScript glyph, in the Compact Font Format.
 */ var CFFGlyph = function(_Glyph) {
    inherits(CFFGlyph, _Glyph);
    function CFFGlyph() {
        classCallCheck(this, CFFGlyph);
        return possibleConstructorReturn(this, _Glyph.apply(this, arguments));
    }
    CFFGlyph.prototype._getName = function _getName() {
        if (this._font.CFF2) return _Glyph.prototype._getName.call(this);
        return this._font['CFF '].getGlyphName(this.id);
    };
    CFFGlyph.prototype.bias = function bias(s) {
        if (s.length < 1240) return 107;
        else if (s.length < 33900) return 1131;
        else return 32768;
    };
    CFFGlyph.prototype._getPath = function _getPath() {
        var stream = this._font.stream;
        var pos = stream.pos;
        var cff = this._font.CFF2 || this._font['CFF '];
        var str = cff.topDict.CharStrings[this.id];
        var end = str.offset + str.length;
        stream.pos = str.offset;
        var path = new Path();
        var stack = [];
        var trans = [];
        var width = null;
        var nStems = 0;
        var x = 0, y = 0;
        var usedGsubrs = void 0;
        var usedSubrs = void 0;
        var open = false;
        this._usedGsubrs = usedGsubrs = {};
        this._usedSubrs = usedSubrs = {};
        var gsubrs = cff.globalSubrIndex || [];
        var gsubrsBias = this.bias(gsubrs);
        var privateDict = cff.privateDictForGlyph(this.id);
        var subrs = privateDict.Subrs || [];
        var subrsBias = this.bias(subrs);
        var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
        var vsindex = privateDict.vsindex;
        var variationProcessor = this._font._variationProcessor;
        function checkWidth() {
            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
        }
        function parseStems() {
            if (stack.length % 2 !== 0) checkWidth();
            nStems += stack.length >> 1;
            return stack.length = 0;
        }
        function moveTo(x, y) {
            if (open) path.closePath();
            path.moveTo(x, y);
            open = true;
        }
        var parse = function parse() {
            while(stream.pos < end){
                var op = stream.readUInt8();
                if (op < 32) switch(op){
                    case 1:
                    case 3:
                    case 18:
                    case 23:
                        // vstemhm
                        parseStems();
                        break;
                    case 4:
                        // vmoveto
                        if (stack.length > 1) checkWidth();
                        y += stack.shift();
                        moveTo(x, y);
                        break;
                    case 5:
                        // rlineto
                        while(stack.length >= 2){
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                        }
                        break;
                    case 6:
                    case 7:
                        // vlineto
                        var phase = op === 6;
                        while(stack.length >= 1){
                            if (phase) x += stack.shift();
                            else y += stack.shift();
                            path.lineTo(x, y);
                            phase = !phase;
                        }
                        break;
                    case 8:
                        // rrcurveto
                        while(stack.length > 0){
                            var c1x = x + stack.shift();
                            var c1y = y + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 10:
                        // callsubr
                        var index = stack.pop() + subrsBias;
                        var subr = subrs[index];
                        if (subr) {
                            usedSubrs[index] = true;
                            var p = stream.pos;
                            var e = end;
                            stream.pos = subr.offset;
                            end = subr.offset + subr.length;
                            parse();
                            stream.pos = p;
                            end = e;
                        }
                        break;
                    case 11:
                        // return
                        if (cff.version >= 2) break;
                        return;
                    case 14:
                        // endchar
                        if (cff.version >= 2) break;
                        if (stack.length > 0) checkWidth();
                        if (open) {
                            path.closePath();
                            open = false;
                        }
                        break;
                    case 15:
                        // vsindex
                        if (cff.version < 2) throw new Error('vsindex operator not supported in CFF v1');
                        vsindex = stack.pop();
                        break;
                    case 16:
                        // blend
                        if (cff.version < 2) throw new Error('blend operator not supported in CFF v1');
                        if (!variationProcessor) throw new Error('blend operator in non-variation font');
                        var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                        var numBlends = stack.pop();
                        var numOperands = numBlends * blendVector.length;
                        var delta = stack.length - numOperands;
                        var base = delta - numBlends;
                        for(var i = 0; i < numBlends; i++){
                            var sum = stack[base + i];
                            for(var j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                            stack[base + i] = sum;
                        }
                        while(numOperands--)stack.pop();
                        break;
                    case 19:
                    case 20:
                        // cntrmask
                        parseStems();
                        stream.pos += nStems + 7 >> 3;
                        break;
                    case 21:
                        // rmoveto
                        if (stack.length > 2) checkWidth();
                        x += stack.shift();
                        y += stack.shift();
                        moveTo(x, y);
                        break;
                    case 22:
                        // hmoveto
                        if (stack.length > 1) checkWidth();
                        x += stack.shift();
                        moveTo(x, y);
                        break;
                    case 24:
                        // rcurveline
                        while(stack.length >= 8){
                            var c1x = x + stack.shift();
                            var c1y = y + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        x += stack.shift();
                        y += stack.shift();
                        path.lineTo(x, y);
                        break;
                    case 25:
                        // rlinecurve
                        while(stack.length >= 8){
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                        }
                        var c1x = x + stack.shift();
                        var c1y = y + stack.shift();
                        var c2x = c1x + stack.shift();
                        var c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        break;
                    case 26:
                        // vvcurveto
                        if (stack.length % 2) x += stack.shift();
                        while(stack.length >= 4){
                            c1x = x;
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x;
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 27:
                        // hhcurveto
                        if (stack.length % 2) y += stack.shift();
                        while(stack.length >= 4){
                            c1x = x + stack.shift();
                            c1y = y;
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y;
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 28:
                        // shortint
                        stack.push(stream.readInt16BE());
                        break;
                    case 29:
                        // callgsubr
                        index = stack.pop() + gsubrsBias;
                        subr = gsubrs[index];
                        if (subr) {
                            usedGsubrs[index] = true;
                            var p = stream.pos;
                            var e = end;
                            stream.pos = subr.offset;
                            end = subr.offset + subr.length;
                            parse();
                            stream.pos = p;
                            end = e;
                        }
                        break;
                    case 30:
                    case 31:
                        // hvcurveto
                        phase = op === 31;
                        while(stack.length >= 4){
                            if (phase) {
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                y = c2y + stack.shift();
                                x = c2x + (stack.length === 1 ? stack.shift() : 0);
                            } else {
                                c1x = x;
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + (stack.length === 1 ? stack.shift() : 0);
                            }
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            phase = !phase;
                        }
                        break;
                    case 12:
                        op = stream.readUInt8();
                        switch(op){
                            case 3:
                                // and
                                var a = stack.pop();
                                var b = stack.pop();
                                stack.push(a && b ? 1 : 0);
                                break;
                            case 4:
                                // or
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a || b ? 1 : 0);
                                break;
                            case 5:
                                // not
                                a = stack.pop();
                                stack.push(a ? 0 : 1);
                                break;
                            case 9:
                                // abs
                                a = stack.pop();
                                stack.push(Math.abs(a));
                                break;
                            case 10:
                                // add
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a + b);
                                break;
                            case 11:
                                // sub
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a - b);
                                break;
                            case 12:
                                // div
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a / b);
                                break;
                            case 14:
                                // neg
                                a = stack.pop();
                                stack.push(-a);
                                break;
                            case 15:
                                // eq
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a === b ? 1 : 0);
                                break;
                            case 18:
                                // drop
                                stack.pop();
                                break;
                            case 20:
                                // put
                                var val = stack.pop();
                                var idx = stack.pop();
                                trans[idx] = val;
                                break;
                            case 21:
                                // get
                                idx = stack.pop();
                                stack.push(trans[idx] || 0);
                                break;
                            case 22:
                                // ifelse
                                var s1 = stack.pop();
                                var s2 = stack.pop();
                                var v1 = stack.pop();
                                var v2 = stack.pop();
                                stack.push(v1 <= v2 ? s1 : s2);
                                break;
                            case 23:
                                // random
                                stack.push(Math.random());
                                break;
                            case 24:
                                // mul
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a * b);
                                break;
                            case 26:
                                // sqrt
                                a = stack.pop();
                                stack.push(Math.sqrt(a));
                                break;
                            case 27:
                                // dup
                                a = stack.pop();
                                stack.push(a, a);
                                break;
                            case 28:
                                // exch
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(b, a);
                                break;
                            case 29:
                                // index
                                idx = stack.pop();
                                if (idx < 0) idx = 0;
                                else if (idx > stack.length - 1) idx = stack.length - 1;
                                stack.push(stack[idx]);
                                break;
                            case 30:
                                // roll
                                var n = stack.pop();
                                var _j = stack.pop();
                                if (_j >= 0) while(_j > 0){
                                    var t = stack[n - 1];
                                    for(var _i = n - 2; _i >= 0; _i--)stack[_i + 1] = stack[_i];
                                    stack[0] = t;
                                    _j--;
                                }
                                else while(_j < 0){
                                    var t = stack[0];
                                    for(var _i2 = 0; _i2 <= n; _i2++)stack[_i2] = stack[_i2 + 1];
                                    stack[n - 1] = t;
                                    _j++;
                                }
                                break;
                            case 34:
                                // hflex
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                var c3x = c2x + stack.shift();
                                var c3y = c2y;
                                var c4x = c3x + stack.shift();
                                var c4y = c3y;
                                var c5x = c4x + stack.shift();
                                var c5y = c4y;
                                var c6x = c5x + stack.shift();
                                var c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 35:
                                // flex
                                var pts = [];
                                for(var _i3 = 0; _i3 <= 5; _i3++){
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                stack.shift(); // fd
                                break;
                            case 36:
                                // hflex1
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                c3x = c2x + stack.shift();
                                c3y = c2y;
                                c4x = c3x + stack.shift();
                                c4y = c3y;
                                c5x = c4x + stack.shift();
                                c5y = c4y + stack.shift();
                                c6x = c5x + stack.shift();
                                c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 37:
                                // flex1
                                var startx = x;
                                var starty = y;
                                pts = [];
                                for(var _i4 = 0; _i4 <= 4; _i4++){
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                    // horizontal
                                    x += stack.shift();
                                    y = starty;
                                } else {
                                    x = startx;
                                    y += stack.shift();
                                }
                                pts.push(x, y);
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                break;
                            default:
                                throw new Error('Unknown op: 12 ' + op);
                        }
                        break;
                    default:
                        throw new Error('Unknown op: ' + op);
                }
                else if (op < 247) stack.push(op - 139);
                else if (op < 251) {
                    var b1 = stream.readUInt8();
                    stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                    var b1 = stream.readUInt8();
                    stack.push(-(op - 251) * 256 - b1 - 108);
                } else stack.push(stream.readInt32BE() / 65536);
            }
        };
        parse();
        if (open) path.closePath();
        return path;
    };
    return CFFGlyph;
}(Glyph);
var SBIXImage = new (0, _restructureDefault.default).Struct({
    originX: (0, _restructureDefault.default).uint16,
    originY: (0, _restructureDefault.default).uint16,
    type: new (0, _restructureDefault.default).String(4),
    data: new (0, _restructureDefault.default).Buffer(function(t) {
        return t.parent.buflen - t._currentOffset;
    })
});
/**
 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
 */ var SBIXGlyph = function(_TTFGlyph) {
    inherits(SBIXGlyph, _TTFGlyph);
    function SBIXGlyph() {
        classCallCheck(this, SBIXGlyph);
        return possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
    }
    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ SBIXGlyph.prototype.getImageForSize = function getImageForSize(size) {
        for(var i = 0; i < this._font.sbix.imageTables.length; i++){
            var table = this._font.sbix.imageTables[i];
            if (table.ppem >= size) break;
        }
        var offsets = table.imageOffsets;
        var start = offsets[this.id];
        var end = offsets[this.id + 1];
        if (start === end) return null;
        this._font.stream.pos = start;
        return SBIXImage.decode(this._font.stream, {
            buflen: end - start
        });
    };
    SBIXGlyph.prototype.render = function render(ctx, size) {
        var img = this.getImageForSize(size);
        if (img != null) {
            var scale = size / this._font.unitsPerEm;
            ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale
            });
        }
        if (this._font.sbix.flags.renderOutlines) _TTFGlyph.prototype.render.call(this, ctx, size);
    };
    return SBIXGlyph;
}(TTFGlyph);
var COLRLayer = function COLRLayer(glyph, color) {
    classCallCheck(this, COLRLayer);
    this.glyph = glyph;
    this.color = color;
};
/**
 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
 * Each glyph in this format contain a list of colored layers, each
 * of which  is another vector glyph.
 */ var COLRGlyph = function(_Glyph) {
    inherits(COLRGlyph, _Glyph);
    function COLRGlyph() {
        classCallCheck(this, COLRGlyph);
        return possibleConstructorReturn(this, _Glyph.apply(this, arguments));
    }
    COLRGlyph.prototype._getBBox = function _getBBox() {
        var bbox = new BBox();
        for(var i = 0; i < this.layers.length; i++){
            var layer = this.layers[i];
            var b = layer.glyph.bbox;
            bbox.addPoint(b.minX, b.minY);
            bbox.addPoint(b.maxX, b.maxY);
        }
        return bbox;
    };
    /**
   * Returns an array of objects containing the glyph and color for
   * each layer in the composite color glyph.
   * @type {object[]}
   */ COLRGlyph.prototype.render = function render(ctx, size) {
        for(var _iterator = this.layers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var _ref2 = _ref, glyph = _ref2.glyph, color = _ref2.color;
            ctx.fillColor([
                color.red,
                color.green,
                color.blue
            ], color.alpha / 255 * 100);
            glyph.render(ctx, size);
        }
        return;
    };
    createClass(COLRGlyph, [
        {
            key: 'layers',
            get: function get$$1() {
                var cpal = this._font.CPAL;
                var colr = this._font.COLR;
                var low = 0;
                var high = colr.baseGlyphRecord.length - 1;
                while(low <= high){
                    var mid = low + high >> 1;
                    var rec = colr.baseGlyphRecord[mid];
                    if (this.id < rec.gid) high = mid - 1;
                    else if (this.id > rec.gid) low = mid + 1;
                    else {
                        var baseLayer = rec;
                        break;
                    }
                }
                // if base glyph not found in COLR table,
                // default to normal glyph from glyf or CFF
                if (baseLayer == null) {
                    var g = this._font._getBaseGlyph(this.id);
                    var color = {
                        red: 0,
                        green: 0,
                        blue: 0,
                        alpha: 255
                    };
                    return [
                        new COLRLayer(g, color)
                    ];
                }
                // otherwise, return an array of all the layers
                var layers = [];
                for(var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
                    var rec = colr.layerRecords[i];
                    var color = cpal.colorRecords[rec.paletteIndex];
                    var g = this._font._getBaseGlyph(rec.gid);
                    layers.push(new COLRLayer(g, color));
                }
                return layers;
            }
        }
    ]);
    return COLRGlyph;
}(Glyph);
var TUPLES_SHARE_POINT_NUMBERS = 0x8000;
var TUPLE_COUNT_MASK = 0x0fff;
var EMBEDDED_TUPLE_COORD = 0x8000;
var INTERMEDIATE_TUPLE = 0x4000;
var PRIVATE_POINT_NUMBERS = 0x2000;
var TUPLE_INDEX_MASK = 0x0fff;
var POINTS_ARE_WORDS = 0x80;
var POINT_RUN_COUNT_MASK = 0x7f;
var DELTAS_ARE_ZERO = 0x80;
var DELTAS_ARE_WORDS = 0x40;
var DELTA_RUN_COUNT_MASK = 0x3f;
/**
 * This class is transforms TrueType glyphs according to the data from
 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
 * These tables allow infinite adjustments to glyph weight, width, slant,
 * and optical size without the designer needing to specify every exact style.
 *
 * Apple's documentation for these tables is not great, so thanks to the
 * Freetype project for figuring much of this out.
 *
 * @private
 */ var GlyphVariationProcessor = function() {
    function GlyphVariationProcessor(font, coords) {
        classCallCheck(this, GlyphVariationProcessor);
        this.font = font;
        this.normalizedCoords = this.normalizeCoords(coords);
        this.blendVectors = new Map();
    }
    GlyphVariationProcessor.prototype.normalizeCoords = function normalizeCoords(coords) {
        // the default mapping is linear along each axis, in two segments:
        // from the minValue to defaultValue, and from defaultValue to maxValue.
        var normalized = [];
        for(var i = 0; i < this.font.fvar.axis.length; i++){
            var axis = this.font.fvar.axis[i];
            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
        }
        // if there is an avar table, the normalized value is calculated
        // by interpolating between the two nearest mapped values.
        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
            var segment = this.font.avar.segment[i];
            for(var j = 0; j < segment.correspondence.length; j++){
                var pair = segment.correspondence[j];
                if (j >= 1 && normalized[i] < pair.fromCoord) {
                    var prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                }
            }
        }
        return normalized;
    };
    GlyphVariationProcessor.prototype.transformPoints = function transformPoints(gid, glyphPoints) {
        if (!this.font.fvar || !this.font.gvar) return;
        var gvar = this.font.gvar;
        if (gid >= gvar.glyphCount) return;
        var offset = gvar.offsets[gid];
        if (offset === gvar.offsets[gid + 1]) return;
        // Read the gvar data for this glyph
        var stream = this.font.stream;
        stream.pos = offset;
        if (stream.pos >= stream.length) return;
        var tupleCount = stream.readUInt16BE();
        var offsetToData = offset + stream.readUInt16BE();
        if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
            var here = stream.pos;
            stream.pos = offsetToData;
            var sharedPoints = this.decodePoints();
            offsetToData = stream.pos;
            stream.pos = here;
        }
        var origPoints = glyphPoints.map(function(pt) {
            return pt.copy();
        });
        tupleCount &= TUPLE_COUNT_MASK;
        for(var i = 0; i < tupleCount; i++){
            var tupleDataSize = stream.readUInt16BE();
            var tupleIndex = stream.readUInt16BE();
            if (tupleIndex & EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];
                for(var a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
            } else {
                if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error('Invalid gvar table');
                var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
            }
            if (tupleIndex & INTERMEDIATE_TUPLE) {
                var startCoords = [];
                for(var _a = 0; _a < gvar.axisCount; _a++)startCoords.push(stream.readInt16BE() / 16384);
                var endCoords = [];
                for(var _a2 = 0; _a2 < gvar.axisCount; _a2++)endCoords.push(stream.readInt16BE() / 16384);
            }
            // Get the factor at which to apply this tuple
            var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
            if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
            }
            var here = stream.pos;
            stream.pos = offsetToData;
            if (tupleIndex & PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
            else var points = sharedPoints;
            // points.length = 0 means there are deltas for all points
            var nPoints = points.length === 0 ? glyphPoints.length : points.length;
            var xDeltas = this.decodeDeltas(nPoints);
            var yDeltas = this.decodeDeltas(nPoints);
            if (points.length === 0) // all points
            for(var _i = 0; _i < glyphPoints.length; _i++){
                var point = glyphPoints[_i];
                point.x += Math.round(xDeltas[_i] * factor);
                point.y += Math.round(yDeltas[_i] * factor);
            }
            else {
                var outPoints = origPoints.map(function(pt) {
                    return pt.copy();
                });
                var hasDelta = glyphPoints.map(function() {
                    return false;
                });
                for(var _i2 = 0; _i2 < points.length; _i2++){
                    var idx = points[_i2];
                    if (idx < glyphPoints.length) {
                        var _point = outPoints[idx];
                        hasDelta[idx] = true;
                        _point.x += Math.round(xDeltas[_i2] * factor);
                        _point.y += Math.round(yDeltas[_i2] * factor);
                    }
                }
                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                for(var _i3 = 0; _i3 < glyphPoints.length; _i3++){
                    var deltaX = outPoints[_i3].x - origPoints[_i3].x;
                    var deltaY = outPoints[_i3].y - origPoints[_i3].y;
                    glyphPoints[_i3].x += deltaX;
                    glyphPoints[_i3].y += deltaY;
                }
            }
            offsetToData += tupleDataSize;
            stream.pos = here;
        }
    };
    GlyphVariationProcessor.prototype.decodePoints = function decodePoints() {
        var stream = this.font.stream;
        var count = stream.readUInt8();
        if (count & POINTS_ARE_WORDS) count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
        var points = new Uint16Array(count);
        var i = 0;
        var point = 0;
        while(i < count){
            var run = stream.readUInt8();
            var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
            var fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
            for(var j = 0; j < runCount && i < count; j++){
                point += fn.call(stream);
                points[i++] = point;
            }
        }
        return points;
    };
    GlyphVariationProcessor.prototype.decodeDeltas = function decodeDeltas(count) {
        var stream = this.font.stream;
        var i = 0;
        var deltas = new Int16Array(count);
        while(i < count){
            var run = stream.readUInt8();
            var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;
            if (run & DELTAS_ARE_ZERO) i += runCount;
            else {
                var fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                for(var j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
            }
        }
        return deltas;
    };
    GlyphVariationProcessor.prototype.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
        var normalized = this.normalizedCoords;
        var gvar = this.font.gvar;
        var factor = 1;
        for(var i = 0; i < gvar.axisCount; i++){
            if (tupleCoords[i] === 0) continue;
            if (normalized[i] === 0) return 0;
            if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
            } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
            }
        }
        return factor;
    };
    // Interpolates points without delta values.
    // Needed for the Ø and Q glyphs in Skia.
    // Algorithm from Freetype.
    GlyphVariationProcessor.prototype.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
        if (points.length === 0) return;
        var point = 0;
        while(point < points.length){
            var firstPoint = point;
            // find the end point of the contour
            var endPoint = point;
            var pt = points[endPoint];
            while(!pt.endContour)pt = points[++endPoint];
            // find the first point that has a delta
            while(point <= endPoint && !hasDelta[point])point++;
            if (point > endPoint) continue;
            var firstDelta = point;
            var curDelta = point;
            point++;
            while(point <= endPoint){
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                    curDelta = point;
                }
                point++;
            }
            // shift contour if we only have a single delta
            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
            else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
            }
            point = endPoint + 1;
        }
    };
    GlyphVariationProcessor.prototype.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
        if (p1 > p2) return;
        var iterable = [
            'x',
            'y'
        ];
        for(var i = 0; i < iterable.length; i++){
            var k = iterable[i];
            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                var p = ref1;
                ref1 = ref2;
                ref2 = p;
            }
            var in1 = inPoints[ref1][k];
            var in2 = inPoints[ref2][k];
            var out1 = outPoints[ref1][k];
            var out2 = outPoints[ref2][k];
            // If the reference points have the same coordinate but different
            // delta, inferred delta is zero.  Otherwise interpolate.
            if (in1 !== in2 || out1 === out2) {
                var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                for(var _p = p1; _p <= p2; _p++){
                    var out = inPoints[_p][k];
                    if (out <= in1) out += out1 - in1;
                    else if (out >= in2) out += out2 - in2;
                    else out = out1 + (out - in1) * scale;
                    outPoints[_p][k] = out;
                }
            }
        }
    };
    GlyphVariationProcessor.prototype.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
        var deltaX = outPoints[ref].x - inPoints[ref].x;
        var deltaY = outPoints[ref].y - inPoints[ref].y;
        if (deltaX === 0 && deltaY === 0) return;
        for(var p = p1; p <= p2; p++)if (p !== ref) {
            outPoints[p].x += deltaX;
            outPoints[p].y += deltaY;
        }
    };
    GlyphVariationProcessor.prototype.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
        var outerIndex = void 0, innerIndex = void 0;
        if (table.advanceWidthMapping) {
            var idx = gid;
            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
            var entryFormat = table.advanceWidthMapping.entryFormat;
            var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
            outerIndex = _table$advanceWidthMa.outerIndex;
            innerIndex = _table$advanceWidthMa.innerIndex;
        } else {
            outerIndex = 0;
            innerIndex = gid;
        }
        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
    };
    // See pseudo code from `Font Variations Overview'
    // in the OpenType specification.
    GlyphVariationProcessor.prototype.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
        if (outerIndex >= itemStore.itemVariationData.length) return 0;
        var varData = itemStore.itemVariationData[outerIndex];
        if (innerIndex >= varData.deltaSets.length) return 0;
        var deltaSet = varData.deltaSets[innerIndex];
        var blendVector = this.getBlendVector(itemStore, outerIndex);
        var netAdjustment = 0;
        for(var master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
        return netAdjustment;
    };
    GlyphVariationProcessor.prototype.getBlendVector = function getBlendVector(itemStore, outerIndex) {
        var varData = itemStore.itemVariationData[outerIndex];
        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
        var normalizedCoords = this.normalizedCoords;
        var blendVector = [];
        // outer loop steps through master designs to be blended
        for(var master = 0; master < varData.regionIndexCount; master++){
            var scalar = 1;
            var regionIndex = varData.regionIndexes[master];
            var axes = itemStore.variationRegionList.variationRegions[regionIndex];
            // inner loop steps through axes in this region
            for(var j = 0; j < axes.length; j++){
                var axis = axes[j];
                var axisScalar = void 0;
                // compute the scalar contribution of this axis
                // ignore invalid ranges
                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1;
                else if (axis.peakCoord === 0) axisScalar = 1;
                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0;
                else {
                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                }
                // take product of all the axis scalars
                scalar *= axisScalar;
            }
            blendVector[master] = scalar;
        }
        this.blendVectors.set(varData, blendVector);
        return blendVector;
    };
    return GlyphVariationProcessor;
}();
var Subset = function() {
    function Subset(font) {
        classCallCheck(this, Subset);
        this.font = font;
        this.glyphs = [];
        this.mapping = {};
        // always include the missing glyph
        this.includeGlyph(0);
    }
    Subset.prototype.includeGlyph = function includeGlyph(glyph) {
        if ((typeof glyph === 'undefined' ? 'undefined' : _typeof(glyph)) === 'object') glyph = glyph.id;
        if (this.mapping[glyph] == null) {
            this.glyphs.push(glyph);
            this.mapping[glyph] = this.glyphs.length - 1;
        }
        return this.mapping[glyph];
    };
    Subset.prototype.encodeStream = function encodeStream() {
        var _this = this;
        var s = new (0, _restructureDefault.default).EncodeStream();
        process.nextTick(function() {
            _this.encode(s);
            return s.end();
        });
        return s;
    };
    return Subset;
}();
// Flags for simple glyphs
var ON_CURVE$1 = 1;
var X_SHORT_VECTOR$1 = 2;
var Y_SHORT_VECTOR$1 = 4;
var REPEAT$1 = 8;
var SAME_X$1 = 16;
var SAME_Y$1 = 32;
var Point$1 = function() {
    function Point() {
        classCallCheck(this, Point);
    }
    Point.size = function size(val) {
        return val >= 0 && val <= 255 ? 1 : 2;
    };
    Point.encode = function encode(stream, value) {
        if (value >= 0 && value <= 255) stream.writeUInt8(value);
        else stream.writeInt16BE(value);
    };
    return Point;
}();
var Glyf = new (0, _restructureDefault.default).Struct({
    numberOfContours: (0, _restructureDefault.default).int16,
    xMin: (0, _restructureDefault.default).int16,
    yMin: (0, _restructureDefault.default).int16,
    xMax: (0, _restructureDefault.default).int16,
    yMax: (0, _restructureDefault.default).int16,
    endPtsOfContours: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint16, 'numberOfContours'),
    instructions: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, (0, _restructureDefault.default).uint16),
    flags: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint8, 0),
    xPoints: new (0, _restructureDefault.default).Array(Point$1, 0),
    yPoints: new (0, _restructureDefault.default).Array(Point$1, 0)
});
/**
 * Encodes TrueType glyph outlines
 */ var TTFGlyphEncoder = function() {
    function TTFGlyphEncoder() {
        classCallCheck(this, TTFGlyphEncoder);
    }
    TTFGlyphEncoder.prototype.encodeSimple = function encodeSimple(path) {
        var instructions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var endPtsOfContours = [];
        var xPoints = [];
        var yPoints = [];
        var flags = [];
        var same = 0;
        var lastX = 0, lastY = 0, lastFlag = 0;
        var pointCount = 0;
        for(var i = 0; i < path.commands.length; i++){
            var c = path.commands[i];
            for(var j = 0; j < c.args.length; j += 2){
                var x = c.args[j];
                var y = c.args[j + 1];
                var flag = 0;
                // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.
                if (c.command === 'quadraticCurveTo' && j === 2) {
                    var next = path.commands[i + 1];
                    if (next && next.command === 'quadraticCurveTo') {
                        var midX = (lastX + next.args[0]) / 2;
                        var midY = (lastY + next.args[1]) / 2;
                        if (x === midX && y === midY) continue;
                    }
                }
                // All points except control points are on curve.
                if (!(c.command === 'quadraticCurveTo' && j === 0)) flag |= ON_CURVE$1;
                flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
                flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);
                if (flag === lastFlag && same < 255) {
                    flags[flags.length - 1] |= REPEAT$1;
                    same++;
                } else {
                    if (same > 0) {
                        flags.push(same);
                        same = 0;
                    }
                    flags.push(flag);
                    lastFlag = flag;
                }
                lastX = x;
                lastY = y;
                pointCount++;
            }
            if (c.command === 'closePath') endPtsOfContours.push(pointCount - 1);
        }
        // Close the path if the last command didn't already
        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') endPtsOfContours.push(pointCount - 1);
        var bbox = path.bbox;
        var glyf = {
            numberOfContours: endPtsOfContours.length,
            xMin: bbox.minX,
            yMin: bbox.minY,
            xMax: bbox.maxX,
            yMax: bbox.maxY,
            endPtsOfContours: endPtsOfContours,
            instructions: instructions,
            flags: flags,
            xPoints: xPoints,
            yPoints: yPoints
        };
        var size = Glyf.size(glyf);
        var tail = 4 - size % 4;
        var stream = new (0, _restructureDefault.default).EncodeStream(size + tail);
        Glyf.encode(stream, glyf);
        // Align to 4-byte length
        if (tail !== 0) stream.fill(0, tail);
        return stream.buffer;
    };
    TTFGlyphEncoder.prototype._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
        var diff = value - last;
        if (value === last) flag |= sameFlag;
        else {
            if (-255 <= diff && diff <= 255) {
                flag |= shortFlag;
                if (diff < 0) diff = -diff;
                else flag |= sameFlag;
            }
            points.push(diff);
        }
        return flag;
    };
    return TTFGlyphEncoder;
}();
var TTFSubset = function(_Subset) {
    inherits(TTFSubset, _Subset);
    function TTFSubset(font) {
        classCallCheck(this, TTFSubset);
        var _this = possibleConstructorReturn(this, _Subset.call(this, font));
        _this.glyphEncoder = new TTFGlyphEncoder();
        return _this;
    }
    TTFSubset.prototype._addGlyph = function _addGlyph(gid) {
        var glyph = this.font.getGlyph(gid);
        var glyf = glyph._decode();
        // get the offset to the glyph from the loca table
        var curOffset = this.font.loca.offsets[gid];
        var nextOffset = this.font.loca.offsets[gid + 1];
        var stream = this.font._getTableStream('glyf');
        stream.pos += curOffset;
        var buffer = stream.readBuffer(nextOffset - curOffset);
        // if it is a compound glyph, include its components
        if (glyf && glyf.numberOfContours < 0) {
            buffer = Buffer.from(buffer);
            for(var _iterator = glyf.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                var _ref;
                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }
                var component = _ref;
                gid = this.includeGlyph(component.glyphID);
                buffer.writeUInt16BE(gid, component.pos);
            }
        } else if (glyf && this.font._variationProcessor) // If this is a TrueType variation glyph, re-encode the path
        buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
        this.glyf.push(buffer);
        this.loca.offsets.push(this.offset);
        this.hmtx.metrics.push({
            advance: glyph.advanceWidth,
            bearing: glyph._getMetrics().leftBearing
        });
        this.offset += buffer.length;
        return this.glyf.length - 1;
    };
    TTFSubset.prototype.encode = function encode(stream) {
        // tables required by PDF spec:
        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
        //
        // additional tables required for standalone fonts:
        //   name, cmap, OS/2, post
        this.glyf = [];
        this.offset = 0;
        this.loca = {
            offsets: []
        };
        this.hmtx = {
            metrics: [],
            bearings: []
        };
        // include all the glyphs
        // not using a for loop because we need to support adding more
        // glyphs to the array as we go, and CoffeeScript caches the length.
        var i = 0;
        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
        var maxp = (0, _cloneDefault.default)(this.font.maxp);
        maxp.numGlyphs = this.glyf.length;
        this.loca.offsets.push(this.offset);
        tables.loca.preEncode.call(this.loca);
        var head = (0, _cloneDefault.default)(this.font.head);
        head.indexToLocFormat = this.loca.version;
        var hhea = (0, _cloneDefault.default)(this.font.hhea);
        hhea.numberOfMetrics = this.hmtx.metrics.length;
        // map = []
        // for index in [0...256]
        //     if index < @numGlyphs
        //         map[index] = index
        //     else
        //         map[index] = 0
        //
        // cmapTable =
        //     version: 0
        //     length: 262
        //     language: 0
        //     codeMap: map
        //
        // cmap =
        //     version: 0
        //     numSubtables: 1
        //     tables: [
        //         platformID: 1
        //         encodingID: 0
        //         table: cmapTable
        //     ]
        // TODO: subset prep, cvt, fpgm?
        Directory.encode(stream, {
            tables: {
                head: head,
                hhea: hhea,
                loca: this.loca,
                maxp: maxp,
                'cvt ': this.font['cvt '],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm
            }
        });
    };
    return TTFSubset;
}(Subset);
var CFFSubset = function(_Subset) {
    inherits(CFFSubset, _Subset);
    function CFFSubset(font) {
        classCallCheck(this, CFFSubset);
        var _this = possibleConstructorReturn(this, _Subset.call(this, font));
        _this.cff = _this.font['CFF '];
        if (!_this.cff) throw new Error('Not a CFF Font');
        return _this;
    }
    CFFSubset.prototype.subsetCharstrings = function subsetCharstrings() {
        this.charstrings = [];
        var gsubrs = {};
        for(var _iterator = this.glyphs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var gid = _ref;
            this.charstrings.push(this.cff.getCharString(gid));
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedGsubrs)gsubrs[subr] = true;
        }
        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
    };
    CFFSubset.prototype.subsetSubrs = function subsetSubrs(subrs, used) {
        var res = [];
        for(var i = 0; i < subrs.length; i++){
            var subr = subrs[i];
            if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
            } else res.push(Buffer.from([
                11
            ])); // return
        }
        return res;
    };
    CFFSubset.prototype.subsetFontdict = function subsetFontdict(topDict) {
        topDict.FDArray = [];
        topDict.FDSelect = {
            version: 0,
            fds: []
        };
        var used_fds = {};
        var used_subrs = [];
        for(var _iterator2 = this.glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var gid = _ref2;
            var fd = this.cff.fdForGlyph(gid);
            if (fd == null) continue;
            if (!used_fds[fd]) {
                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                used_subrs.push({});
            }
            used_fds[fd] = true;
            topDict.FDSelect.fds.push(topDict.FDArray.length - 1);
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedSubrs)used_subrs[used_subrs.length - 1][subr] = true;
        }
        for(var i = 0; i < topDict.FDArray.length; i++){
            var dict = topDict.FDArray[i];
            delete dict.FontName;
            if (dict.Private && dict.Private.Subrs) {
                dict.Private = Object.assign({}, dict.Private);
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
            }
        }
        return;
    };
    CFFSubset.prototype.createCIDFontdict = function createCIDFontdict(topDict) {
        var used_subrs = {};
        for(var _iterator3 = this.glyphs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
            var _ref3;
            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }
            var gid = _ref3;
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedSubrs)used_subrs[subr] = true;
        }
        var privateDict = Object.assign({}, this.cff.topDict.Private);
        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
        topDict.FDArray = [
            {
                Private: privateDict
            }
        ];
        return topDict.FDSelect = {
            version: 3,
            nRanges: 1,
            ranges: [
                {
                    first: 0,
                    fd: 0
                }
            ],
            sentinel: this.charstrings.length
        };
    };
    CFFSubset.prototype.addString = function addString(string) {
        if (!string) return null;
        if (!this.strings) this.strings = [];
        this.strings.push(string);
        return standardStrings.length + this.strings.length - 1;
    };
    CFFSubset.prototype.encode = function encode(stream) {
        this.subsetCharstrings();
        var charset = {
            version: this.charstrings.length > 255 ? 2 : 1,
            ranges: [
                {
                    first: 1,
                    nLeft: this.charstrings.length - 2
                }
            ]
        };
        var topDict = Object.assign({}, this.cff.topDict);
        topDict.Private = null;
        topDict.charset = charset;
        topDict.Encoding = null;
        topDict.CharStrings = this.charstrings;
        var _arr = [
            'version',
            'Notice',
            'Copyright',
            'FullName',
            'FamilyName',
            'Weight',
            'PostScript',
            'BaseFontName',
            'FontName'
        ];
        for(var _i4 = 0; _i4 < _arr.length; _i4++){
            var key = _arr[_i4];
            topDict[key] = this.addString(this.cff.string(topDict[key]));
        }
        topDict.ROS = [
            this.addString('Adobe'),
            this.addString('Identity'),
            0
        ];
        topDict.CIDCount = this.charstrings.length;
        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
        else this.createCIDFontdict(topDict);
        var top = {
            version: 1,
            hdrSize: this.cff.hdrSize,
            offSize: this.cff.length,
            header: this.cff.header,
            nameIndex: [
                this.cff.postscriptName
            ],
            topDictIndex: [
                topDict
            ],
            stringIndex: this.strings,
            globalSubrIndex: this.gsubrs
        };
        CFFTop.encode(stream, top);
    };
    return CFFSubset;
}(Subset);
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object["keys"](descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object["defineProperty"](target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * This is the base class for all SFNT-based font formats in fontkit.
 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
 */ var TTFFont = (_class = function() {
    TTFFont.probe = function probe(buffer) {
        var format = buffer.toString('ascii', 0, 4);
        return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
    };
    function TTFFont(stream) {
        var variationCoords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        classCallCheck(this, TTFFont);
        this.stream = stream;
        this.variationCoords = variationCoords;
        this._directoryPos = this.stream.pos;
        this._tables = {};
        this._glyphs = {};
        this._decodeDirectory();
        // define properties for each table to lazily parse
        for(var tag in this.directory.tables){
            var table = this.directory.tables[tag];
            if (tables[tag] && table.length > 0) Object.defineProperty(this, tag, {
                get: this._getTable.bind(this, table)
            });
        }
    }
    TTFFont.prototype._getTable = function _getTable(table) {
        if (!(table.tag in this._tables)) try {
            this._tables[table.tag] = this._decodeTable(table);
        } catch (e) {
            if (fontkit$1.logErrors) {
                console.error('Error decoding table ' + table.tag);
                console.error(e.stack);
            }
        }
        return this._tables[table.tag];
    };
    TTFFont.prototype._getTableStream = function _getTableStream(tag) {
        var table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            return this.stream;
        }
        return null;
    };
    TTFFont.prototype._decodeDirectory = function _decodeDirectory() {
        return this.directory = Directory.decode(this.stream, {
            _startOffset: 0
        });
    };
    TTFFont.prototype._decodeTable = function _decodeTable(table) {
        var pos = this.stream.pos;
        var stream = this._getTableStream(table.tag);
        var result = tables[table.tag].decode(stream, this, table.length);
        this.stream.pos = pos;
        return result;
    };
    /**
   * The unique PostScript name for this font
   * @type {string}
   */ /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ TTFFont.prototype.getName = function getName(key) {
        var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
        var record = this.name.records[key];
        if (record) return record[lang];
        return null;
    };
    /**
   * The font's full name, e.g. "Helvetica Bold"
   * @type {string}
   */ /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ TTFFont.prototype.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
        return !!this._cmapProcessor.lookup(codePoint);
    };
    /**
   * Maps a single unicode code point to a Glyph object.
   * Does not perform any advanced substitutions (there is no context to do so).
   *
   * @param {number} codePoint
   * @return {Glyph}
   */ TTFFont.prototype.glyphForCodePoint = function glyphForCodePoint(codePoint) {
        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
            codePoint
        ]);
    };
    /**
   * Returns an array of Glyph objects for the given string.
   * This is only a one-to-one mapping from characters to glyphs.
   * For most uses, you should use font.layout (described below), which
   * provides a much more advanced mapping supporting AAT and OpenType shaping.
   *
   * @param {string} string
   * @return {Glyph[]}
   */ TTFFont.prototype.glyphsForString = function glyphsForString(string) {
        var glyphs = [];
        var len = string.length;
        var idx = 0;
        var last = -1;
        var state = -1;
        while(idx <= len){
            var code = 0;
            var nextState = 0;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    var next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                }
                // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) // Variation selector following normal codepoint.
            glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                last,
                code
            ]));
            else if (state === 0 && nextState === 0) // Normal codepoint following normal codepoint.
            glyphs.push(this.glyphForCodePoint(last));
            last = code;
            state = nextState;
        }
        return glyphs;
    };
    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ TTFFont.prototype.layout = function layout(string, userFeatures, script, language, direction) {
        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
    };
    /**
   * Returns an array of strings that map to the given glyph id.
   * @param {number} gid - glyph id
   */ TTFFont.prototype.stringsForGlyph = function stringsForGlyph(gid) {
        return this._layoutEngine.stringsForGlyph(gid);
    };
    /**
   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
   * (or mapped AAT tags) supported by the font.
   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
   *
   * @type {string[]}
   */ TTFFont.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
        return this._layoutEngine.getAvailableFeatures(script, language);
    };
    TTFFont.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
        var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf) this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
            else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
        }
        return this._glyphs[glyph] || null;
    };
    /**
   * Returns a glyph object for the given glyph id.
   * You can pass the array of code points this glyph represents for
   * your use later, and it will be stored in the glyph object.
   *
   * @param {number} glyph
   * @param {number[]} characters
   * @return {Glyph}
   */ TTFFont.prototype.getGlyph = function getGlyph(glyph) {
        var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.sbix) this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
            else this._getBaseGlyph(glyph, characters);
        }
        return this._glyphs[glyph] || null;
    };
    /**
   * Returns a Subset for this font.
   * @return {Subset}
   */ TTFFont.prototype.createSubset = function createSubset() {
        if (this.directory.tables['CFF ']) return new CFFSubset(this);
        return new TTFSubset(this);
    };
    /**
   * Returns an object describing the available variation axes
   * that this font supports. Keys are setting tags, and values
   * contain the axis name, range, and default value.
   *
   * @type {object}
   */ /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ TTFFont.prototype.getVariation = function getVariation(settings) {
        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
        if (typeof settings === 'string') settings = this.namedVariations[settings];
        if ((typeof settings === 'undefined' ? 'undefined' : _typeof(settings)) !== 'object') throw new Error('Variation settings must be either a variation name or settings object.');
        // normalize the coordinates
        var coords = this.fvar.axis.map(function(axis, i) {
            var axisTag = axis.axisTag.trim();
            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
            else return axis.defaultValue;
        });
        var stream = new (0, _restructureDefault.default).DecodeStream(this.stream.buffer);
        stream.pos = this._directoryPos;
        var font = new TTFFont(stream, coords);
        font._tables = this._tables;
        return font;
    };
    // Standardized format plugin API
    TTFFont.prototype.getFont = function getFont(name) {
        return this.getVariation(name);
    };
    createClass(TTFFont, [
        {
            key: 'postscriptName',
            get: function get$$1() {
                var name = this.name.records.postscriptName;
                if (name) {
                    var lang = Object.keys(name)[0];
                    return name[lang];
                }
                return null;
            }
        },
        {
            key: 'fullName',
            get: function get$$1() {
                return this.getName('fullName');
            }
        },
        {
            key: 'familyName',
            get: function get$$1() {
                return this.getName('fontFamily');
            }
        },
        {
            key: 'subfamilyName',
            get: function get$$1() {
                return this.getName('fontSubfamily');
            }
        },
        {
            key: 'copyright',
            get: function get$$1() {
                return this.getName('copyright');
            }
        },
        {
            key: 'version',
            get: function get$$1() {
                return this.getName('version');
            }
        },
        {
            key: 'ascent',
            get: function get$$1() {
                return this.hhea.ascent;
            }
        },
        {
            key: 'descent',
            get: function get$$1() {
                return this.hhea.descent;
            }
        },
        {
            key: 'lineGap',
            get: function get$$1() {
                return this.hhea.lineGap;
            }
        },
        {
            key: 'underlinePosition',
            get: function get$$1() {
                return this.post.underlinePosition;
            }
        },
        {
            key: 'underlineThickness',
            get: function get$$1() {
                return this.post.underlineThickness;
            }
        },
        {
            key: 'italicAngle',
            get: function get$$1() {
                return this.post.italicAngle;
            }
        },
        {
            key: 'capHeight',
            get: function get$$1() {
                var os2 = this['OS/2'];
                return os2 ? os2.capHeight : this.ascent;
            }
        },
        {
            key: 'xHeight',
            get: function get$$1() {
                var os2 = this['OS/2'];
                return os2 ? os2.xHeight : 0;
            }
        },
        {
            key: 'numGlyphs',
            get: function get$$1() {
                return this.maxp.numGlyphs;
            }
        },
        {
            key: 'unitsPerEm',
            get: function get$$1() {
                return this.head.unitsPerEm;
            }
        },
        {
            key: 'bbox',
            get: function get$$1() {
                return Object.freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
            }
        },
        {
            key: '_cmapProcessor',
            get: function get$$1() {
                return new CmapProcessor(this.cmap);
            }
        },
        {
            key: 'characterSet',
            get: function get$$1() {
                return this._cmapProcessor.getCharacterSet();
            }
        },
        {
            key: '_layoutEngine',
            get: function get$$1() {
                return new LayoutEngine(this);
            }
        },
        {
            key: 'availableFeatures',
            get: function get$$1() {
                return this._layoutEngine.getAvailableFeatures();
            }
        },
        {
            key: 'variationAxes',
            get: function get$$1() {
                var res = {};
                if (!this.fvar) return res;
                for(var _iterator = this.fvar.axis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
                    var _ref;
                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }
                    var axis = _ref;
                    res[axis.axisTag.trim()] = {
                        name: axis.name.en,
                        min: axis.minValue,
                        default: axis.defaultValue,
                        max: axis.maxValue
                    };
                }
                return res;
            }
        },
        {
            key: 'namedVariations',
            get: function get$$1() {
                var res = {};
                if (!this.fvar) return res;
                for(var _iterator2 = this.fvar.instance, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var instance = _ref2;
                    var settings = {};
                    for(var i = 0; i < this.fvar.axis.length; i++){
                        var axis = this.fvar.axis[i];
                        settings[axis.axisTag.trim()] = instance.coord[i];
                    }
                    res[instance.name.en] = settings;
                }
                return res;
            }
        },
        {
            key: '_variationProcessor',
            get: function get$$1() {
                if (!this.fvar) return null;
                var variationCoords = this.variationCoords;
                // Ignore if no variation coords and not CFF2
                if (!variationCoords && !this.CFF2) return null;
                if (!variationCoords) variationCoords = this.fvar.axis.map(function(axis) {
                    return axis.defaultValue;
                });
                return new GlyphVariationProcessor(this, variationCoords);
            }
        }
    ]);
    return TTFFont;
}(), _applyDecoratedDescriptor(_class.prototype, 'bbox', [
    cache
], Object.getOwnPropertyDescriptor(_class.prototype, 'bbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_cmapProcessor', [
    cache
], Object.getOwnPropertyDescriptor(_class.prototype, '_cmapProcessor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'characterSet', [
    cache
], Object.getOwnPropertyDescriptor(_class.prototype, 'characterSet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_layoutEngine', [
    cache
], Object.getOwnPropertyDescriptor(_class.prototype, '_layoutEngine'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'variationAxes', [
    cache
], Object.getOwnPropertyDescriptor(_class.prototype, 'variationAxes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'namedVariations', [
    cache
], Object.getOwnPropertyDescriptor(_class.prototype, 'namedVariations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_variationProcessor', [
    cache
], Object.getOwnPropertyDescriptor(_class.prototype, '_variationProcessor'), _class.prototype), _class);
var WOFFDirectoryEntry = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    offset: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, 'void', {
        type: 'global'
    }),
    compLength: (0, _restructureDefault.default).uint32,
    length: (0, _restructureDefault.default).uint32,
    origChecksum: (0, _restructureDefault.default).uint32
});
var WOFFDirectory = new (0, _restructureDefault.default).Struct({
    tag: new (0, _restructureDefault.default).String(4),
    flavor: (0, _restructureDefault.default).uint32,
    length: (0, _restructureDefault.default).uint32,
    numTables: (0, _restructureDefault.default).uint16,
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint16),
    totalSfntSize: (0, _restructureDefault.default).uint32,
    majorVersion: (0, _restructureDefault.default).uint16,
    minorVersion: (0, _restructureDefault.default).uint16,
    metaOffset: (0, _restructureDefault.default).uint32,
    metaLength: (0, _restructureDefault.default).uint32,
    metaOrigLength: (0, _restructureDefault.default).uint32,
    privOffset: (0, _restructureDefault.default).uint32,
    privLength: (0, _restructureDefault.default).uint32,
    tables: new (0, _restructureDefault.default).Array(WOFFDirectoryEntry, 'numTables')
});
WOFFDirectory.process = function() {
    var tables$$1 = {};
    for(var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var table = _ref;
        tables$$1[table.tag] = table;
    }
    this.tables = tables$$1;
};
var WOFFFont = function(_TTFFont) {
    inherits(WOFFFont, _TTFFont);
    function WOFFFont() {
        classCallCheck(this, WOFFFont);
        return possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
    }
    WOFFFont.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'wOFF';
    };
    WOFFFont.prototype._decodeDirectory = function _decodeDirectory() {
        this.directory = WOFFDirectory.decode(this.stream, {
            _startOffset: 0
        });
    };
    WOFFFont.prototype._getTableStream = function _getTableStream(tag) {
        var table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header
                var outBuffer = Buffer.alloc(table.length);
                var buf = (0, _tinyInflateDefault.default)(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new (0, _restructureDefault.default).DecodeStream(buf);
            } else return this.stream;
        }
        return null;
    };
    return WOFFFont;
}(TTFFont);
var TTCHeader = new (0, _restructureDefault.default).VersionedStruct((0, _restructureDefault.default).uint32, {
    0x00010000: {
        numFonts: (0, _restructureDefault.default).uint32,
        offsets: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, 'numFonts')
    },
    0x00020000: {
        numFonts: (0, _restructureDefault.default).uint32,
        offsets: new (0, _restructureDefault.default).Array((0, _restructureDefault.default).uint32, 'numFonts'),
        dsigTag: (0, _restructureDefault.default).uint32,
        dsigLength: (0, _restructureDefault.default).uint32,
        dsigOffset: (0, _restructureDefault.default).uint32
    }
});
var TrueTypeCollection = function() {
    TrueTypeCollection.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'ttcf';
    };
    function TrueTypeCollection(stream) {
        classCallCheck(this, TrueTypeCollection);
        this.stream = stream;
        if (stream.readString(4) !== 'ttcf') throw new Error('Not a TrueType collection');
        this.header = TTCHeader.decode(stream);
    }
    TrueTypeCollection.prototype.getFont = function getFont(name) {
        for(var _iterator = this.header.offsets, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var offset = _ref;
            var stream = new (0, _restructureDefault.default).DecodeStream(this.stream.buffer);
            stream.pos = offset;
            var font = new TTFFont(stream);
            if (font.postscriptName === name) return font;
        }
        return null;
    };
    createClass(TrueTypeCollection, [
        {
            key: 'fonts',
            get: function get$$1() {
                var fonts = [];
                for(var _iterator2 = this.header.offsets, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
                    var _ref2;
                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }
                    var offset = _ref2;
                    var stream = new (0, _restructureDefault.default).DecodeStream(this.stream.buffer);
                    stream.pos = offset;
                    fonts.push(new TTFFont(stream));
                }
                return fonts;
            }
        }
    ]);
    return TrueTypeCollection;
}();
var DFontName = new (0, _restructureDefault.default).String((0, _restructureDefault.default).uint8);
var DFontData = new (0, _restructureDefault.default).Struct({
    len: (0, _restructureDefault.default).uint32,
    buf: new (0, _restructureDefault.default).Buffer('len')
});
var Ref = new (0, _restructureDefault.default).Struct({
    id: (0, _restructureDefault.default).uint16,
    nameOffset: (0, _restructureDefault.default).int16,
    attr: (0, _restructureDefault.default).uint8,
    dataOffset: (0, _restructureDefault.default).uint24,
    handle: (0, _restructureDefault.default).uint32
});
var Type = new (0, _restructureDefault.default).Struct({
    name: new (0, _restructureDefault.default).String(4),
    maxTypeIndex: (0, _restructureDefault.default).uint16,
    refList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, new (0, _restructureDefault.default).Array(Ref, function(t) {
        return t.maxTypeIndex + 1;
    }), {
        type: 'parent'
    })
});
var TypeList = new (0, _restructureDefault.default).Struct({
    length: (0, _restructureDefault.default).uint16,
    types: new (0, _restructureDefault.default).Array(Type, function(t) {
        return t.length + 1;
    })
});
var DFontMap = new (0, _restructureDefault.default).Struct({
    reserved: new (0, _restructureDefault.default).Reserved((0, _restructureDefault.default).uint8, 24),
    typeList: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, TypeList),
    nameListOffset: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint16, 'void')
});
var DFontHeader = new (0, _restructureDefault.default).Struct({
    dataOffset: (0, _restructureDefault.default).uint32,
    map: new (0, _restructureDefault.default).Pointer((0, _restructureDefault.default).uint32, DFontMap),
    dataLength: (0, _restructureDefault.default).uint32,
    mapLength: (0, _restructureDefault.default).uint32
});
var DFont = function() {
    DFont.probe = function probe(buffer) {
        var stream = new (0, _restructureDefault.default).DecodeStream(buffer);
        try {
            var header = DFontHeader.decode(stream);
        } catch (e) {
            return false;
        }
        for(var _iterator = header.map.typeList.types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var type = _ref;
            if (type.name === 'sfnt') return true;
        }
        return false;
    };
    function DFont(stream) {
        classCallCheck(this, DFont);
        this.stream = stream;
        this.header = DFontHeader.decode(this.stream);
        for(var _iterator2 = this.header.map.typeList.types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var type = _ref2;
            for(var _iterator3 = type.refList, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
                var _ref3;
                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }
                var ref = _ref3;
                if (ref.nameOffset >= 0) {
                    this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                    ref.name = DFontName.decode(this.stream);
                } else ref.name = null;
            }
            if (type.name === 'sfnt') this.sfnt = type;
        }
    }
    DFont.prototype.getFont = function getFont(name) {
        if (!this.sfnt) return null;
        for(var _iterator4 = this.sfnt.refList, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;){
            var _ref4;
            if (_isArray4) {
                if (_i4 >= _iterator4.length) break;
                _ref4 = _iterator4[_i4++];
            } else {
                _i4 = _iterator4.next();
                if (_i4.done) break;
                _ref4 = _i4.value;
            }
            var ref = _ref4;
            var pos = this.header.dataOffset + ref.dataOffset + 4;
            var stream = new (0, _restructureDefault.default).DecodeStream(this.stream.buffer.slice(pos));
            var font = new TTFFont(stream);
            if (font.postscriptName === name) return font;
        }
        return null;
    };
    createClass(DFont, [
        {
            key: 'fonts',
            get: function get$$1() {
                var fonts = [];
                for(var _iterator5 = this.sfnt.refList, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;){
                    var _ref5;
                    if (_isArray5) {
                        if (_i5 >= _iterator5.length) break;
                        _ref5 = _iterator5[_i5++];
                    } else {
                        _i5 = _iterator5.next();
                        if (_i5.done) break;
                        _ref5 = _i5.value;
                    }
                    var ref = _ref5;
                    var pos = this.header.dataOffset + ref.dataOffset + 4;
                    var stream = new (0, _restructureDefault.default).DecodeStream(this.stream.buffer.slice(pos));
                    fonts.push(new TTFFont(stream));
                }
                return fonts;
            }
        }
    ]);
    return DFont;
}();
// Register font formats
fontkit$1.registerFormat(TTFFont);
fontkit$1.registerFormat(WOFFFont);
fontkit$1.registerFormat(TrueTypeCollection);
fontkit$1.registerFormat(DFont);
exports.default = fontkit$1;

},{"750871484726ec28":"dB11O","ac20bad08ee389f":"5jT8D","restructure":"38JwL","restructure/src/utils":"4jpsW","deep-equal":"bX1wQ","@react-pdf/unicode-properties":"itgDl","unicode-trie":"fU8wQ","dfa":"7aYIw","clone":"9z6ZU","tiny-inflate":"2G0sR","bb09cce7b0d33d05":"lNAWE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"38JwL":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var key, val, _ref, _ref1;
    exports.EncodeStream = require("d957396eb6850862");
    exports.DecodeStream = require("6ea13bd945f16fe");
    exports.Array = require("abe8f5c2d98f7ae1");
    exports.LazyArray = require("2a7eb9ce4d106d2");
    exports.Bitfield = require("b255ab916520e8c4");
    exports.Boolean = require("8ef28ffa508df722");
    exports.Buffer = require("ca7822e4b174dd68");
    exports.Enum = require("3b229b0fe3402588");
    exports.Optional = require("8dcba950b77b7d0f");
    exports.Reserved = require("1cad421acbfbb10f");
    exports.String = require("e41685b7e92a03b9");
    exports.Struct = require("4c209fd4ed0ff9d4");
    exports.VersionedStruct = require("1b8effef40852dc8");
    _ref = require("158421267851e2a5");
    for(key in _ref){
        val = _ref[key];
        exports[key] = val;
    }
    _ref1 = require("3a72199e73f58541");
    for(key in _ref1){
        val = _ref1[key];
        exports[key] = val;
    }
}).call(this);

},{"d957396eb6850862":"lbdXc","6ea13bd945f16fe":"hQenQ","abe8f5c2d98f7ae1":"eyY9t","2a7eb9ce4d106d2":"eu4TE","b255ab916520e8c4":"3eBjz","8ef28ffa508df722":"99TnW","ca7822e4b174dd68":"jeGFD","3b229b0fe3402588":"7LRHI","8dcba950b77b7d0f":"aPp9g","1cad421acbfbb10f":"dXdPo","e41685b7e92a03b9":"5IfYV","4c209fd4ed0ff9d4":"3BHoc","1b8effef40852dc8":"5MQvJ","158421267851e2a5":"5m1Sl","3a72199e73f58541":"7Tss7"}],"lbdXc":[function(require,module,exports,__globalThis) {
var Buffer = require("d3f89f3833723c5").Buffer;
// Generated by CoffeeScript 1.7.1
(function() {
    var DecodeStream, EncodeStream, iconv, stream, __hasProp = {}.hasOwnProperty, __extends = function(child, parent) {
        for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    };
    stream = require("1752fd3524b8540f");
    DecodeStream = require("460d602db0197c0");
    try {
        iconv = require("d0fa22fa39dff621");
    } catch (_error) {}
    EncodeStream = function(_super) {
        var key;
        __extends(EncodeStream, _super);
        function EncodeStream(bufferSize) {
            if (bufferSize == null) bufferSize = 65536;
            EncodeStream.__super__.constructor.apply(this, arguments);
            this.buffer = new Buffer(bufferSize);
            this.bufferOffset = 0;
            this.pos = 0;
        }
        for(key in Buffer.prototype)if (key.slice(0, 5) === 'write') (function(key) {
            var bytes;
            bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, '')];
            return EncodeStream.prototype[key] = function(value) {
                this.ensure(bytes);
                this.buffer[key](value, this.bufferOffset);
                this.bufferOffset += bytes;
                return this.pos += bytes;
            };
        })(key);
        EncodeStream.prototype._read = function() {};
        EncodeStream.prototype.ensure = function(bytes) {
            if (this.bufferOffset + bytes > this.buffer.length) return this.flush();
        };
        EncodeStream.prototype.flush = function() {
            if (this.bufferOffset > 0) {
                this.push(new Buffer(this.buffer.slice(0, this.bufferOffset)));
                return this.bufferOffset = 0;
            }
        };
        EncodeStream.prototype.writeBuffer = function(buffer) {
            this.flush();
            this.push(buffer);
            return this.pos += buffer.length;
        };
        EncodeStream.prototype.writeString = function(string, encoding) {
            var buf, byte, i, _i, _ref;
            if (encoding == null) encoding = 'ascii';
            switch(encoding){
                case 'utf16le':
                case 'ucs2':
                case 'utf8':
                case 'ascii':
                    return this.writeBuffer(new Buffer(string, encoding));
                case 'utf16be':
                    buf = new Buffer(string, 'utf16le');
                    for(i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2){
                        byte = buf[i];
                        buf[i] = buf[i + 1];
                        buf[i + 1] = byte;
                    }
                    return this.writeBuffer(buf);
                default:
                    if (iconv) return this.writeBuffer(iconv.encode(string, encoding));
                    else throw new Error('Install iconv-lite to enable additional string encodings.');
            }
        };
        EncodeStream.prototype.writeUInt24BE = function(val) {
            this.ensure(3);
            this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
            this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
            this.buffer[this.bufferOffset++] = val & 0xff;
            return this.pos += 3;
        };
        EncodeStream.prototype.writeUInt24LE = function(val) {
            this.ensure(3);
            this.buffer[this.bufferOffset++] = val & 0xff;
            this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
            this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
            return this.pos += 3;
        };
        EncodeStream.prototype.writeInt24BE = function(val) {
            if (val >= 0) return this.writeUInt24BE(val);
            else return this.writeUInt24BE(val + 0xffffff + 1);
        };
        EncodeStream.prototype.writeInt24LE = function(val) {
            if (val >= 0) return this.writeUInt24LE(val);
            else return this.writeUInt24LE(val + 0xffffff + 1);
        };
        EncodeStream.prototype.fill = function(val, length) {
            var buf;
            if (length < this.buffer.length) {
                this.ensure(length);
                this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
                this.bufferOffset += length;
                return this.pos += length;
            } else {
                buf = new Buffer(length);
                buf.fill(val);
                return this.writeBuffer(buf);
            }
        };
        EncodeStream.prototype.end = function() {
            this.flush();
            return this.push(null);
        };
        return EncodeStream;
    }(stream.Readable);
    module.exports = EncodeStream;
}).call(this);

},{"d3f89f3833723c5":"dB11O","1752fd3524b8540f":"6U5YO","460d602db0197c0":"hQenQ","d0fa22fa39dff621":"lNAWE"}],"hQenQ":[function(require,module,exports,__globalThis) {
var Buffer = require("33348e0be406efe4").Buffer;
// Generated by CoffeeScript 1.7.1
(function() {
    var DecodeStream, iconv;
    try {
        iconv = require("413c9bb6e909f736");
    } catch (_error) {}
    DecodeStream = function() {
        var key;
        function DecodeStream(buffer) {
            this.buffer = buffer;
            this.pos = 0;
            this.length = this.buffer.length;
        }
        DecodeStream.TYPES = {
            UInt8: 1,
            UInt16: 2,
            UInt24: 3,
            UInt32: 4,
            Int8: 1,
            Int16: 2,
            Int24: 3,
            Int32: 4,
            Float: 4,
            Double: 8
        };
        for(key in Buffer.prototype)if (key.slice(0, 4) === 'read') (function(key) {
            var bytes;
            bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
            return DecodeStream.prototype[key] = function() {
                var ret;
                ret = this.buffer[key](this.pos);
                this.pos += bytes;
                return ret;
            };
        })(key);
        DecodeStream.prototype.readString = function(length, encoding) {
            var buf, byte, i, _i, _ref;
            if (encoding == null) encoding = 'ascii';
            switch(encoding){
                case 'utf16le':
                case 'ucs2':
                case 'utf8':
                case 'ascii':
                    return this.buffer.toString(encoding, this.pos, this.pos += length);
                case 'utf16be':
                    buf = new Buffer(this.readBuffer(length));
                    for(i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2){
                        byte = buf[i];
                        buf[i] = buf[i + 1];
                        buf[i + 1] = byte;
                    }
                    return buf.toString('utf16le');
                default:
                    buf = this.readBuffer(length);
                    if (iconv) try {
                        return iconv.decode(buf, encoding);
                    } catch (_error) {}
                    return buf;
            }
        };
        DecodeStream.prototype.readBuffer = function(length) {
            return this.buffer.slice(this.pos, this.pos += length);
        };
        DecodeStream.prototype.readUInt24BE = function() {
            return (this.readUInt16BE() << 8) + this.readUInt8();
        };
        DecodeStream.prototype.readUInt24LE = function() {
            return this.readUInt16LE() + (this.readUInt8() << 16);
        };
        DecodeStream.prototype.readInt24BE = function() {
            return (this.readInt16BE() << 8) + this.readUInt8();
        };
        DecodeStream.prototype.readInt24LE = function() {
            return this.readUInt16LE() + (this.readInt8() << 16);
        };
        return DecodeStream;
    }();
    module.exports = DecodeStream;
}).call(this);

},{"33348e0be406efe4":"dB11O","413c9bb6e909f736":"lNAWE"}],"lNAWE":[function(require,module,exports,__globalThis) {
var process = require("4dc0af2679c6768c");
"use strict";
// Some environments don't have global Buffer (e.g. React Native).
// Solution would be installing npm modules "buffer" and "stream" explicitly.
var Buffer = require("d59043c74995af48").Buffer;
var bomHandling = require("dc2ac0bf59105a0e"), iconv = module.exports;
// All codecs and aliases are kept here, keyed by encoding name/alias.
// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
iconv.encodings = null;
// Characters emitted in case of error.
iconv.defaultCharUnicode = "\uFFFD";
iconv.defaultCharSingleByte = '?';
// Public API.
iconv.encode = function encode(str, encoding, options) {
    str = "" + (str || ""); // Ensure string.
    var encoder = iconv.getEncoder(encoding, options);
    var res = encoder.write(str);
    var trail = encoder.end();
    return trail && trail.length > 0 ? Buffer.concat([
        res,
        trail
    ]) : res;
};
iconv.decode = function decode(buf, encoding, options) {
    if (typeof buf === 'string') {
        if (!iconv.skipDecodeWarning) {
            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
            iconv.skipDecodeWarning = true;
        }
        buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
    }
    var decoder = iconv.getDecoder(encoding, options);
    var res = decoder.write(buf);
    var trail = decoder.end();
    return trail ? res + trail : res;
};
iconv.encodingExists = function encodingExists(enc) {
    try {
        iconv.getCodec(enc);
        return true;
    } catch (e) {
        return false;
    }
};
// Legacy aliases to convert functions
iconv.toEncoding = iconv.encode;
iconv.fromEncoding = iconv.decode;
// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
iconv._codecDataCache = {};
iconv.getCodec = function getCodec(encoding) {
    if (!iconv.encodings) iconv.encodings = require("be03e21360668db1"); // Lazy load all encoding definitions.
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    var enc = iconv._canonicalizeEncoding(encoding);
    // Traverse iconv.encodings to find actual codec.
    var codecOptions = {};
    while(true){
        var codec = iconv._codecDataCache[enc];
        if (codec) return codec;
        var codecDef = iconv.encodings[enc];
        switch(typeof codecDef){
            case "string":
                enc = codecDef;
                break;
            case "object":
                for(var key in codecDef)codecOptions[key] = codecDef[key];
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                enc = codecDef.type;
                break;
            case "function":
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                codec = new codecDef(codecOptions, iconv);
                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                return codec;
            default:
                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
        }
    }
};
iconv._canonicalizeEncoding = function(encoding) {
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    return ('' + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
};
iconv.getEncoder = function getEncoder(encoding, options) {
    var codec = iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
    if (codec.bomAware && options && options.addBOM) encoder = new bomHandling.PrependBOM(encoder, options);
    return encoder;
};
iconv.getDecoder = function getDecoder(encoding, options) {
    var codec = iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
    if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new bomHandling.StripBOM(decoder, options);
    return decoder;
};
// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
var nodeVer = typeof process !== 'undefined' && process.versions && process.versions.node;
if (nodeVer) {
    // Load streaming support in Node v0.10+
    var nodeVerArr = nodeVer.split(".").map(Number);
    if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) require("907a3f89ffdb20ae")(iconv);
    // Load Node primitive extensions.
    require("6d1acbc3401da2d6")(iconv);
}

},{"4dc0af2679c6768c":"5jT8D","d59043c74995af48":"254Bi","dc2ac0bf59105a0e":"8qQTb","be03e21360668db1":"3KlqR","907a3f89ffdb20ae":"aBjM4","6d1acbc3401da2d6":"aBjM4"}],"254Bi":[function(require,module,exports,__globalThis) {
/* eslint-disable node/no-deprecated-api */ var process = require("e7af3484edf6bee9");
'use strict';
var buffer = require("9b1fd4bf3515d7a6");
var Buffer = buffer.Buffer;
var safer = {};
var key;
for(key in buffer){
    if (!buffer.hasOwnProperty(key)) continue;
    if (key === 'SlowBuffer' || key === 'Buffer') continue;
    safer[key] = buffer[key];
}
var Safer = safer.Buffer = {};
for(key in Buffer){
    if (!Buffer.hasOwnProperty(key)) continue;
    if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue;
    Safer[key] = Buffer[key];
}
safer.Buffer.prototype = Buffer.prototype;
if (!Safer.from || Safer.from === Uint8Array.from) Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
    return Buffer(value, encodingOrOffset, length);
};
if (!Safer.alloc) Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === 'string') buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!safer.kStringMaxLength) try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!safer.constants) {
    safer.constants = {
        MAX_LENGTH: safer.kMaxLength
    };
    if (safer.kStringMaxLength) safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength;
}
module.exports = safer;

},{"e7af3484edf6bee9":"5jT8D","9b1fd4bf3515d7a6":"dB11O"}],"8qQTb":[function(require,module,exports,__globalThis) {
"use strict";
var BOMChar = '\uFEFF';
exports.PrependBOM = PrependBOMWrapper;
function PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}
PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = BOMChar + str;
        this.addBOM = false;
    }
    return this.encoder.write(str);
};
PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
};
//------------------------------------------------------------------------------
exports.StripBOM = StripBOMWrapper;
function StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}
StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res) return res;
    if (res[0] === BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === 'function') this.options.stripBOM();
    }
    this.pass = true;
    return res;
};
StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
};

},{}],"3KlqR":[function(require,module,exports,__globalThis) {
"use strict";
// Update this array if you add/rename/remove files in this directory.
// We support Browserify by skipping automatic module discovery and requiring modules directly.
var modules = [
    require("bdaa557df13ed604"),
    require("fd3dc965fc8aca3f"),
    require("eef39a6572ec0e16"),
    require("db74ee6b9422868a"),
    require("8a20a6a175d74380"),
    require("e647804c36d26de7"),
    require("1447d5a4b8fe2b16"),
    require("87cdd8efe5f0a905")
];
// Put all encoding/alias/codec definitions to single object and export it. 
for(var i = 0; i < modules.length; i++){
    var module = modules[i];
    for(var enc in module)if (Object.prototype.hasOwnProperty.call(module, enc)) exports[enc] = module[enc];
}

},{"bdaa557df13ed604":"2bg8v","fd3dc965fc8aca3f":"hfFyY","eef39a6572ec0e16":"khcb2","db74ee6b9422868a":"1uKAP","8a20a6a175d74380":"gjdU9","e647804c36d26de7":"9YNWH","1447d5a4b8fe2b16":"dhW5E","87cdd8efe5f0a905":"2twwc"}],"2bg8v":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("b2563c082b744514").Buffer;
// Export Node.js internal encodings.
module.exports = {
    // Encodings
    utf8: {
        type: "_internal",
        bomAware: true
    },
    cesu8: {
        type: "_internal",
        bomAware: true
    },
    unicode11utf8: "utf8",
    ucs2: {
        type: "_internal",
        bomAware: true
    },
    utf16le: "ucs2",
    binary: {
        type: "_internal"
    },
    base64: {
        type: "_internal"
    },
    hex: {
        type: "_internal"
    },
    // Codec.
    _internal: InternalCodec
};
//------------------------------------------------------------------------------
function InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;
    if (this.enc === "base64") this.encoder = InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = InternalEncoderCesu8;
        // Add decoder for versions of Node not supporting CESU-8
        if (Buffer.from('eda0bdedb2a9', 'hex').toString() !== "\uD83D\uDCA9") {
            this.decoder = InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}
InternalCodec.prototype.encoder = InternalEncoder;
InternalCodec.prototype.decoder = InternalDecoder;
//------------------------------------------------------------------------------
// We use node.js internal decoder. Its signature is the same as ours.
var StringDecoder = require("912b463ef1262b9c").StringDecoder;
if (!StringDecoder.prototype.end) StringDecoder.prototype.end = function() {};
function InternalDecoder(options, codec) {
    StringDecoder.call(this, codec.enc);
}
InternalDecoder.prototype = StringDecoder.prototype;
//------------------------------------------------------------------------------
// Encoder is mostly trivial
function InternalEncoder(options, codec) {
    this.enc = codec.enc;
}
InternalEncoder.prototype.write = function(str) {
    return Buffer.from(str, this.enc);
};
InternalEncoder.prototype.end = function() {};
//------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.
function InternalEncoderBase64(options, codec) {
    this.prevStr = '';
}
InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - str.length % 4;
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);
    return Buffer.from(str, "base64");
};
InternalEncoderBase64.prototype.end = function() {
    return Buffer.from(this.prevStr, "base64");
};
//------------------------------------------------------------------------------
// CESU-8 encoder is also special.
function InternalEncoderCesu8(options, codec) {}
InternalEncoderCesu8.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length * 3), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var charCode = str.charCodeAt(i);
        // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80) buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        } else {
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
};
InternalEncoderCesu8.prototype.end = function() {};
//------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+
function InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}
InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = '';
    for(var i = 0; i < buf.length; i++){
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) {
            if (contBytes > 0) {
                res += this.defaultCharUnicode;
                contBytes = 0;
            }
            if (curByte < 0x80) res += String.fromCharCode(curByte);
            else if (curByte < 0xE0) {
                acc = curByte & 0x1F;
                contBytes = 1;
                accBytes = 1;
            } else if (curByte < 0xF0) {
                acc = curByte & 0x0F;
                contBytes = 2;
                accBytes = 1;
            } else res += this.defaultCharUnicode;
        } else if (contBytes > 0) {
            acc = acc << 6 | curByte & 0x3f;
            contBytes--;
            accBytes++;
            if (contBytes === 0) {
                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                else // Actually add character.
                res += String.fromCharCode(acc);
            }
        } else res += this.defaultCharUnicode;
    }
    this.acc = acc;
    this.contBytes = contBytes;
    this.accBytes = accBytes;
    return res;
};
InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0) res += this.defaultCharUnicode;
    return res;
};

},{"b2563c082b744514":"254Bi","912b463ef1262b9c":"8Iwjg"}],"hfFyY":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("8456d24d7088f48").Buffer;
// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
// == UTF16-BE codec. ==========================================================
exports.utf16be = Utf16BECodec;
function Utf16BECodec() {}
Utf16BECodec.prototype.encoder = Utf16BEEncoder;
Utf16BECodec.prototype.decoder = Utf16BEDecoder;
Utf16BECodec.prototype.bomAware = true;
// -- Encoding
function Utf16BEEncoder() {}
Utf16BEEncoder.prototype.write = function(str) {
    var buf = Buffer.from(str, 'ucs2');
    for(var i = 0; i < buf.length; i += 2){
        var tmp = buf[i];
        buf[i] = buf[i + 1];
        buf[i + 1] = tmp;
    }
    return buf;
};
Utf16BEEncoder.prototype.end = function() {};
// -- Decoding
function Utf16BEDecoder() {
    this.overflowByte = -1;
}
Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0) return '';
    var buf2 = Buffer.alloc(buf.length + 1), i = 0, j = 0;
    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1;
        j = 2;
    }
    for(; i < buf.length - 1; i += 2, j += 2){
        buf2[j] = buf[i + 1];
        buf2[j + 1] = buf[i];
    }
    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
    return buf2.slice(0, j).toString('ucs2');
};
Utf16BEDecoder.prototype.end = function() {};
// == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
exports.utf16 = Utf16Codec;
function Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
Utf16Codec.prototype.encoder = Utf16Encoder;
Utf16Codec.prototype.decoder = Utf16Decoder;
// -- Encoding (pass-through)
function Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder('utf-16le', options);
}
Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBytes = [];
    this.initialBytesLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBytes.push(buf);
        this.initialBytesLen += buf.length;
        if (this.initialBytesLen < 16) return '';
        // We have enough bytes -> detect endianness.
        var buf = Buffer.concat(this.initialBytes), encoding = detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        this.initialBytes.length = this.initialBytesLen = 0;
    }
    return this.decoder.write(buf);
};
Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var buf = Buffer.concat(this.initialBytes), encoding = detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var res = this.decoder.write(buf), trail = this.decoder.end();
        return trail ? res + trail : res;
    }
    return this.decoder.end();
};
function detectEncoding(buf, defaultEncoding) {
    var enc = defaultEncoding || 'utf-16le';
    if (buf.length >= 2) {
        // Check BOM.
        if (buf[0] == 0xFE && buf[1] == 0xFF) enc = 'utf-16be';
        else if (buf[0] == 0xFF && buf[1] == 0xFE) enc = 'utf-16le';
        else {
            // No BOM found. Try to deduce encoding from initial content.
            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
            // So, we count ASCII as if it was LE or BE, and decide from that.
            var asciiCharsLE = 0, asciiCharsBE = 0, _len = Math.min(buf.length - buf.length % 2, 64); // Len is always even.
            for(var i = 0; i < _len; i += 2){
                if (buf[i] === 0 && buf[i + 1] !== 0) asciiCharsBE++;
                if (buf[i] !== 0 && buf[i + 1] === 0) asciiCharsLE++;
            }
            if (asciiCharsBE > asciiCharsLE) enc = 'utf-16be';
            else if (asciiCharsBE < asciiCharsLE) enc = 'utf-16le';
        }
    }
    return enc;
}

},{"8456d24d7088f48":"254Bi"}],"khcb2":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("3ed47161966685ce").Buffer;
// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
exports.utf7 = Utf7Codec;
exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
function Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
Utf7Codec.prototype.encoder = Utf7Encoder;
Utf7Codec.prototype.decoder = Utf7Decoder;
Utf7Codec.prototype.bomAware = true;
// -- Encoding
var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
function Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}
Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return Buffer.from(str.replace(nonDirectChars, (function(chunk) {
        return "+" + (chunk === '+' ? '' : this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) + "-";
    }).bind(this)));
};
Utf7Encoder.prototype.end = function() {};
// -- Decoding
function Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var base64Regex = /[A-Za-z0-9\/+]/;
var base64Chars = [];
for(var i = 0; i < 256; i++)base64Chars[i] = base64Regex.test(String.fromCharCode(i));
var plusChar = '+'.charCodeAt(0), minusChar = '-'.charCodeAt(0), andChar = '&'.charCodeAt(0);
Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '+'
        {
            if (buf[i] == plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!base64Chars[buf[i]]) {
            if (i == lastI && buf[i] == minusChar) res += "+";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString();
                res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString();
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};
// UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.
exports.utf7imap = Utf7IMAPCodec;
function Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
}
Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
Utf7IMAPCodec.prototype.bomAware = true;
// -- Encoding
function Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = Buffer.alloc(6);
    this.base64AccumIdx = 0;
}
Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = Buffer.alloc(str.length * 5 + 10), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) {
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                    base64AccumIdx = 0;
                }
                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }
            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character
                if (uChar === andChar) buf[bufIdx++] = minusChar;
            }
        } else {
            if (!inBase64) {
                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }
    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;
    return buf.slice(0, bufIdx);
};
Utf7IMAPEncoder.prototype.end = function() {
    var buf = Buffer.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
            this.base64AccumIdx = 0;
        }
        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }
    return buf.slice(0, bufIdx);
};
// -- Decoding
function Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var base64IMAPChars = base64Chars.slice();
base64IMAPChars[','.charCodeAt(0)] = true;
Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '&'
        {
            if (buf[i] == andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!base64IMAPChars[buf[i]]) {
            if (i == lastI && buf[i] == minusChar) res += "&";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
                res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode(Buffer.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode(Buffer.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};

},{"3ed47161966685ce":"254Bi"}],"1uKAP":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("83e04ce10fc2395e").Buffer;
// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 
exports._sbcs = SBCSCodec;
function SBCSCodec(codecOptions, iconv) {
    if (!codecOptions) throw new Error("SBCS codec is called without the data.");
    // Prepare char buffer for decoding.
    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }
    this.decodeBuf = Buffer.from(codecOptions.chars, 'ucs2');
    // Encoding buffer.
    var encodeBuf = Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
    this.encodeBuf = encodeBuf;
}
SBCSCodec.prototype.encoder = SBCSEncoder;
SBCSCodec.prototype.decoder = SBCSDecoder;
function SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}
SBCSEncoder.prototype.write = function(str) {
    var buf = Buffer.alloc(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
    return buf;
};
SBCSEncoder.prototype.end = function() {};
function SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}
SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = Buffer.alloc(buf.length * 2);
    var idx1 = 0, idx2 = 0;
    for(var i = 0; i < buf.length; i++){
        idx1 = buf[i] * 2;
        idx2 = i * 2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
    }
    return newBuf.toString('ucs2');
};
SBCSDecoder.prototype.end = function() {};

},{"83e04ce10fc2395e":"254Bi"}],"gjdU9":[function(require,module,exports,__globalThis) {
"use strict";
// Manually added data to be used by sbcs codec in addition to generated one.
module.exports = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
    },
    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
    },
    "mik": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",
    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",
    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek": "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",
    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",
    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",
    "cp819": "iso88591",
    "ibm819": "iso88591",
    "cyrillic": "iso88595",
    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",
    "greek": "iso88597",
    "greek8": "iso88597",
    "ecma118": "iso88597",
    "elot928": "iso88597",
    "hebrew": "iso88598",
    "hebrew8": "iso88598",
    "turkish": "iso88599",
    "turkish8": "iso88599",
    "thai": "iso885911",
    "thai8": "iso885911",
    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",
    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",
    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",
    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",
    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",
    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",
    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",
    "strk10482002": "rk1048",
    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",
    "gb198880": "iso646cn",
    "cn": "iso646cn",
    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",
    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",
    "mac": "macintosh",
    "csmacintosh": "macintosh"
};

},{}],"9YNWH":[function(require,module,exports,__globalThis) {
"use strict";
// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
module.exports = {
    "437": "cp437",
    "737": "cp737",
    "775": "cp775",
    "850": "cp850",
    "852": "cp852",
    "855": "cp855",
    "856": "cp856",
    "857": "cp857",
    "858": "cp858",
    "860": "cp860",
    "861": "cp861",
    "862": "cp862",
    "863": "cp863",
    "864": "cp864",
    "865": "cp865",
    "866": "cp866",
    "869": "cp869",
    "874": "windows874",
    "922": "cp922",
    "1046": "cp1046",
    "1124": "cp1124",
    "1125": "cp1125",
    "1129": "cp1129",
    "1133": "cp1133",
    "1161": "cp1161",
    "1162": "cp1162",
    "1163": "cp1163",
    "1250": "windows1250",
    "1251": "windows1251",
    "1252": "windows1252",
    "1253": "windows1253",
    "1254": "windows1254",
    "1255": "windows1255",
    "1256": "windows1256",
    "1257": "windows1257",
    "1258": "windows1258",
    "28591": "iso88591",
    "28592": "iso88592",
    "28593": "iso88593",
    "28594": "iso88594",
    "28595": "iso88595",
    "28596": "iso88596",
    "28597": "iso88597",
    "28598": "iso88598",
    "28599": "iso88599",
    "28600": "iso885910",
    "28601": "iso885911",
    "28603": "iso885913",
    "28604": "iso885914",
    "28605": "iso885915",
    "28606": "iso885916",
    "windows874": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "win874": "windows874",
    "cp874": "windows874",
    "windows1250": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "win1250": "windows1250",
    "cp1250": "windows1250",
    "windows1251": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "win1251": "windows1251",
    "cp1251": "windows1251",
    "windows1252": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "win1252": "windows1252",
    "cp1252": "windows1252",
    "windows1253": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "win1253": "windows1253",
    "cp1253": "windows1253",
    "windows1254": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "win1254": "windows1254",
    "cp1254": "windows1254",
    "windows1255": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "win1255": "windows1255",
    "cp1255": "windows1255",
    "windows1256": {
        "type": "_sbcs",
        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
    },
    "win1256": "windows1256",
    "cp1256": "windows1256",
    "windows1257": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
    },
    "win1257": "windows1257",
    "cp1257": "windows1257",
    "windows1258": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "win1258": "windows1258",
    "cp1258": "windows1258",
    "iso88591": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28591": "iso88591",
    "iso88592": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "cp28592": "iso88592",
    "iso88593": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
    },
    "cp28593": "iso88593",
    "iso88594": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
    },
    "cp28594": "iso88594",
    "iso88595": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "cp28595": "iso88595",
    "iso88596": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28596": "iso88596",
    "iso88597": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "cp28597": "iso88597",
    "iso88598": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "cp28598": "iso88598",
    "iso88599": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "cp28599": "iso88599",
    "iso885910": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
    },
    "cp28600": "iso885910",
    "iso885911": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28601": "iso885911",
    "iso885913": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
    },
    "cp28603": "iso885913",
    "iso885914": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
    },
    "cp28604": "iso885914",
    "iso885915": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28605": "iso885915",
    "iso885916": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
    },
    "cp28606": "iso885916",
    "cp437": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm437": "cp437",
    "csibm437": "cp437",
    "cp737": {
        "type": "_sbcs",
        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm737": "cp737",
    "csibm737": "cp737",
    "cp775": {
        "type": "_sbcs",
        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm775": "cp775",
    "csibm775": "cp775",
    "cp850": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm850": "cp850",
    "csibm850": "cp850",
    "cp852": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
    },
    "ibm852": "cp852",
    "csibm852": "cp852",
    "cp855": {
        "type": "_sbcs",
        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
    },
    "ibm855": "cp855",
    "csibm855": "cp855",
    "cp856": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm856": "cp856",
    "csibm856": "cp856",
    "cp857": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm857": "cp857",
    "csibm857": "cp857",
    "cp858": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm858": "cp858",
    "csibm858": "cp858",
    "cp860": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm860": "cp860",
    "csibm860": "cp860",
    "cp861": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm861": "cp861",
    "csibm861": "cp861",
    "cp862": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm862": "cp862",
    "csibm862": "cp862",
    "cp863": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm863": "cp863",
    "csibm863": "cp863",
    "cp864": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xb0\xb7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xb1\xbd\xbc\u2248\xab\xbb\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xa0\xad\uFE82\xa3\xa4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xa2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xa6\xac\xf7\xd7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
    },
    "ibm864": "cp864",
    "csibm864": "cp864",
    "cp865": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm865": "cp865",
    "csibm865": "cp865",
    "cp866": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm866": "cp866",
    "csibm866": "cp866",
    "cp869": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
    },
    "ibm869": "cp869",
    "csibm869": "cp869",
    "cp922": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
    },
    "ibm922": "cp922",
    "csibm922": "cp922",
    "cp1046": {
        "type": "_sbcs",
        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
    },
    "ibm1046": "cp1046",
    "csibm1046": "cp1046",
    "cp1124": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "ibm1124": "cp1124",
    "csibm1124": "cp1124",
    "cp1125": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm1125": "cp1125",
    "csibm1125": "cp1125",
    "cp1129": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1129": "cp1129",
    "csibm1129": "cp1129",
    "cp1133": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
    },
    "ibm1133": "cp1133",
    "csibm1133": "cp1133",
    "cp1161": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
    },
    "ibm1161": "cp1161",
    "csibm1161": "cp1161",
    "cp1162": {
        "type": "_sbcs",
        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "ibm1162": "cp1162",
    "csibm1162": "cp1162",
    "cp1163": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1163": "cp1163",
    "csibm1163": "cp1163",
    "maccroatian": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
    },
    "maccyrillic": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "macgreek": {
        "type": "_sbcs",
        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
    },
    "maciceland": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macroman": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macromania": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macthai": {
        "type": "_sbcs",
        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "macturkish": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macukraine": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "koi8r": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8u": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8ru": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8t": {
        "type": "_sbcs",
        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "armscii8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
    },
    "rk1048": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "tcvn": {
        "type": "_sbcs",
        "chars": "\0\xda\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b	\n\v\f\r\x0e\x0f\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xdd\u1EF4\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc0\u1EA2\xc3\xc1\u1EA0\u1EB6\u1EAC\xc8\u1EBA\u1EBC\xc9\u1EB8\u1EC6\xcc\u1EC8\u0128\xcd\u1ECA\xd2\u1ECE\xd5\xd3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xd9\u1EE6\u0168\xa0\u0102\xc2\xca\xd4\u01A0\u01AF\u0110\u0103\xe2\xea\xf4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xe0\u1EA3\xe3\xe1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xe8\u1EC2\u1EBB\u1EBD\xe9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xec\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xed\u1ECB\xf2\u1ED4\u1ECF\xf5\xf3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xf9\u1ED6\u1EE7\u0169\xfa\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xfd\u1EF5\u1ED0"
    },
    "georgianacademy": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "georgianps": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "pt154": {
        "type": "_sbcs",
        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "viscii": {
        "type": "_sbcs",
        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1a\x1b\x1c\x1d\u1EF4\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xd5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xc0\xc1\xc2\xc3\u1EA2\u0102\u1EB3\u1EB5\xc8\xc9\xca\u1EBA\xcc\xcd\u0128\u1EF3\u0110\u1EE9\xd2\xd3\xd4\u1EA1\u1EF7\u1EEB\u1EED\xd9\xda\u1EF9\u1EF5\xdd\u1EE1\u01B0\xe0\xe1\xe2\xe3\u1EA3\u0103\u1EEF\u1EAB\xe8\xe9\xea\u1EBB\xec\xed\u0129\u1EC9\u0111\u1EF1\xf2\xf3\xf4\xf5\u1ECF\u1ECD\u1EE5\xf9\xfa\u0169\u1EE7\xfd\u1EE3\u1EEE"
    },
    "iso646cn": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#\xa5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "iso646jp": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xa5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "hproman8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
    },
    "macintosh": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "ascii": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "tis620": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    }
};

},{}],"dhW5E":[function(require,module,exports,__globalThis) {
"use strict";
var Buffer = require("28f0481976da1ca4").Buffer;
// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.
exports._dbcs = DBCSCodec;
var UNASSIGNED = -1, GB18030_CODE = -2, SEQ_START = -10, NODE_START = -1000, UNASSIGNED_NODE = new Array(0x100), DEF_CHAR = -1;
for(var i = 0; i < 0x100; i++)UNASSIGNED_NODE[i] = UNASSIGNED;
// Class DBCSCodec reads and initializes mapping tables.
function DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data.");
    // Load tables.
    var mappingTable = codecOptions.table();
    // Decode tables: MBCS -> Unicode.
    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.
    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = [];
    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
    this.defaultCharUnicode = iconv.defaultCharUnicode;
    // Encode tables: Unicode -> DBCS.
    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = [];
    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = [];
    // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
        var val = codecOptions.encodeSkipVals[i];
        if (typeof val === 'number') skipEncodeChars[val] = true;
        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
    }
    // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars);
    // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }
    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
    // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === 'function') {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
        // Add GB18030 decode tables.
        var thirdByteNodeIdx = this.decodeTables.length;
        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = UNASSIGNED_NODE.slice(0);
        var fourthByteNodeIdx = this.decodeTables.length;
        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = UNASSIGNED_NODE.slice(0);
        for(var i = 0x81; i <= 0xFE; i++){
            var secondByteNodeIdx = NODE_START - this.decodeTables[0][i];
            var secondByteNode = this.decodeTables[secondByteNodeIdx];
            for(var j = 0x30; j <= 0x39; j++)secondByteNode[j] = NODE_START - thirdByteNodeIdx;
        }
        for(var i = 0x81; i <= 0xFE; i++)thirdByteNode[i] = NODE_START - fourthByteNodeIdx;
        for(var i = 0x30; i <= 0x39; i++)fourthByteNode[i] = GB18030_CODE;
    }
}
DBCSCodec.prototype.encoder = DBCSEncoder;
DBCSCodec.prototype.decoder = DBCSDecoder;
// Decoder helpers
DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for(; addr > 0; addr >>= 8)bytes.push(addr & 0xFF);
    if (bytes.length == 0) bytes.push(0);
    var node = this.decodeTables[0];
    for(var i = bytes.length - 1; i > 0; i--){
        var val = node[bytes[i]];
        if (val == UNASSIGNED) {
            node[bytes[i]] = NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
        } else if (val <= NODE_START) node = this.decodeTables[NODE_START - val];
        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
};
DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16);
    // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF;
    // Write all other elements of the chunk to the table.
    for(var k = 1; k < chunk.length; k++){
        var part = chunk[k];
        if (typeof part === "string") for(var l = 0; l < part.length;){
            var code = part.charCodeAt(l++);
            if (0xD800 <= code && code < 0xDC00) {
                var codeTrail = part.charCodeAt(l++);
                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
            } else if (0x0FF0 < code && code <= 0x0FFF) {
                var len = 0xFFF - code + 2;
                var seq = [];
                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
                writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
                this.decodeTableSeq.push(seq);
            } else writeTable[curAddr++] = code; // Basic char
        }
        else if (typeof part === "number") {
            var charCode = writeTable[curAddr - 1] + 1;
            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
};
// Encoder helpers
DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined) this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
};
DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= SEQ_START) this.encodeTableSeq[SEQ_START - bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == UNASSIGNED) bucket[low] = dbcsCode;
};
DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    var node;
    if (bucket[low] <= SEQ_START) // There's already a sequence with  - use it.
    node = this.encodeTableSeq[SEQ_START - bucket[low]];
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    }
    // Traverse the character tree, allocating new nodes as needed.
    for(var j = 1; j < seq.length - 1; j++){
        var oldVal = node[uCode];
        if (typeof oldVal === 'object') node = oldVal;
        else {
            node = node[uCode] = {};
            if (oldVal !== undefined) node[DEF_CHAR] = oldVal;
        }
    }
    // Set the leaf to given dbcsCode.
    uCode = seq[seq.length - 1];
    node[uCode] = dbcsCode;
};
DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    for(var i = 0; i < 0x100; i++){
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode]) continue;
        if (uCode >= 0) this._setEncodeChar(uCode, mbCode);
        else if (uCode <= NODE_START) this._fillEncodeTable(NODE_START - uCode, mbCode << 8, skipEncodeChars);
        else if (uCode <= SEQ_START) this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
    }
};
// == Encoder ==================================================================
function DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined;
    // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}
DBCSEncoder.prototype.write = function(str) {
    var newBuf = Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
    while(true){
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        } else {
            var uCode = nextChar;
            nextChar = -1;
        }
        // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) {
            if (uCode < 0xDC00) {
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode;
                    // Double lead surrogate found.
                    uCode = UNASSIGNED;
                }
            } else if (leadSurrogate !== -1) {
                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                leadSurrogate = -1;
            } else // Incomplete surrogate pair - only trail surrogate found.
            uCode = UNASSIGNED;
        } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode;
            uCode = UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        }
        // 2. Convert uCode character.
        var dbcsCode = UNASSIGNED;
        if (seqObj !== undefined && uCode != UNASSIGNED) {
            var resCode = seqObj[uCode];
            if (typeof resCode === 'object') {
                seqObj = resCode;
                continue;
            } else if (typeof resCode == 'number') dbcsCode = resCode;
            else if (resCode == undefined) {
                // Try default character for this sequence
                resCode = seqObj[DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.
                }
            }
            seqObj = undefined;
        } else if (uCode >= 0) {
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
            if (dbcsCode <= SEQ_START) {
                seqObj = this.encodeTableSeq[SEQ_START - dbcsCode];
                continue;
            }
            if (dbcsCode == UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                    dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                    dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                    dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        }
        // 3. Write dbcsCode character.
        if (dbcsCode === UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8; // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        } else {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = dbcsCode >> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }
    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
};
DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
    var newBuf = Buffer.alloc(10), j = 0;
    if (this.seqObj) {
        var dbcsCode = this.seqObj[DEF_CHAR];
        if (dbcsCode !== undefined) {
            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
            else {
                newBuf[j++] = dbcsCode >> 8; // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        } else ;
        this.seqObj = undefined;
    }
    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    return newBuf.slice(0, j);
};
// Export for testing
DBCSEncoder.prototype.findIdx = findIdx;
// == Decoder ==================================================================
function DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBuf = Buffer.alloc(0);
    // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}
DBCSDecoder.prototype.write = function(buf) {
    var newBuf = Buffer.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length, seqStart = -this.prevBuf.length, uCode;
    if (prevBufOffset > 0) prevBuf = Buffer.concat([
        prevBuf,
        buf.slice(0, 10)
    ]);
    for(var i = 0, j = 0; i < buf.length; i++){
        var curByte = i >= 0 ? buf[i] : prevBuf[i + prevBufOffset];
        // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];
        if (uCode >= 0) ;
        else if (uCode === UNASSIGNED) {
            // TODO: Callback with seq.
            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
            uCode = this.defaultCharUnicode.charCodeAt(0);
        } else if (uCode === GB18030_CODE) {
            var curSeq = seqStart >= 0 ? buf.slice(seqStart, i + 1) : prevBuf.slice(seqStart + prevBufOffset, i + 1 + prevBufOffset);
            var ptr = (curSeq[0] - 0x81) * 12600 + (curSeq[1] - 0x30) * 1260 + (curSeq[2] - 0x81) * 10 + (curSeq[3] - 0x30);
            var idx = findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        } else if (uCode <= NODE_START) {
            nodeIdx = NODE_START - uCode;
            continue;
        } else if (uCode <= SEQ_START) {
            var seq = this.decodeTableSeq[SEQ_START - uCode];
            for(var k = 0; k < seq.length - 1; k++){
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length - 1];
        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
        // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode > 0xFFFF) {
            uCode -= 0x10000;
            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;
            uCode = 0xDC00 + uCode % 0x400;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8;
        // Reset trie node.
        nodeIdx = 0;
        seqStart = i + 1;
    }
    this.nodeIdx = nodeIdx;
    this.prevBuf = seqStart >= 0 ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
    return newBuf.slice(0, j).toString('ucs2');
};
DBCSDecoder.prototype.end = function() {
    var ret = '';
    // Try to parse all remaining chars.
    while(this.prevBuf.length > 0){
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var buf = this.prevBuf.slice(1);
        // Parse remaining as usual.
        this.prevBuf = Buffer.alloc(0);
        this.nodeIdx = 0;
        if (buf.length > 0) ret += this.write(buf);
    }
    this.nodeIdx = 0;
    return ret;
};
// Binary search for GB18030. Returns largest i such that table[i] <= val.
function findIdx(table, val) {
    if (table[0] > val) return -1;
    var l = 0, r = table.length;
    while(l < r - 1){
        var mid = l + Math.floor((r - l + 1) / 2);
        if (table[mid] <= val) l = mid;
        else r = mid;
    }
    return l;
}

},{"28f0481976da1ca4":"254Bi"}],"2twwc":[function(require,module,exports,__globalThis) {
"use strict";
// Description of supported double byte encodings and aliases.
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.
module.exports = {
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
    'shiftjis': {
        type: '_dbcs',
        table: function() {
            return require("7fd6e990ab3bef41");
        },
        encodeAdd: {
            '\u00a5': 0x5C,
            '\u203E': 0x7E
        },
        encodeSkipVals: [
            {
                from: 0xED40,
                to: 0xF940
            }
        ]
    },
    'csshiftjis': 'shiftjis',
    'mskanji': 'shiftjis',
    'sjis': 'shiftjis',
    'windows31j': 'shiftjis',
    'ms31j': 'shiftjis',
    'xsjis': 'shiftjis',
    'windows932': 'shiftjis',
    'ms932': 'shiftjis',
    '932': 'shiftjis',
    'cp932': 'shiftjis',
    'eucjp': {
        type: '_dbcs',
        table: function() {
            return require("4ecedfe19d7d5f08");
        },
        encodeAdd: {
            '\u00a5': 0x5C,
            '\u203E': 0x7E
        }
    },
    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    'gb2312': 'cp936',
    'gb231280': 'cp936',
    'gb23121980': 'cp936',
    'csgb2312': 'cp936',
    'csiso58gb231280': 'cp936',
    'euccn': 'cp936',
    // Microsoft's CP936 is a subset and approximation of GBK.
    'windows936': 'cp936',
    'ms936': 'cp936',
    '936': 'cp936',
    'cp936': {
        type: '_dbcs',
        table: function() {
            return require("7a67b65f65727c4");
        }
    },
    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    'gbk': {
        type: '_dbcs',
        table: function() {
            return require("7a67b65f65727c4").concat(require("a573389a26b6ed04"));
        }
    },
    'xgbk': 'gbk',
    'isoir58': 'gbk',
    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    'gb18030': {
        type: '_dbcs',
        table: function() {
            return require("7a67b65f65727c4").concat(require("a573389a26b6ed04"));
        },
        gb18030: function() {
            return require("8df748b1500da7b0");
        },
        encodeSkipVals: [
            0x80
        ],
        encodeAdd: {
            "\u20AC": 0xA2E3
        }
    },
    'chinese': 'gb18030',
    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    'windows949': 'cp949',
    'ms949': 'cp949',
    '949': 'cp949',
    'cp949': {
        type: '_dbcs',
        table: function() {
            return require("97f577bf8532eb93");
        }
    },
    'cseuckr': 'cp949',
    'csksc56011987': 'cp949',
    'euckr': 'cp949',
    'isoir149': 'cp949',
    'korean': 'cp949',
    'ksc56011987': 'cp949',
    'ksc56011989': 'cp949',
    'ksc5601': 'cp949',
    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
    'windows950': 'cp950',
    'ms950': 'cp950',
    '950': 'cp950',
    'cp950': {
        type: '_dbcs',
        table: function() {
            return require("e119a7f28ac84bb1");
        }
    },
    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    'big5': 'big5hkscs',
    'big5hkscs': {
        type: '_dbcs',
        table: function() {
            return require("e119a7f28ac84bb1").concat(require("cf01c21de68946c"));
        },
        encodeSkipVals: [
            0xa2cc
        ]
    },
    'cnbig5': 'big5hkscs',
    'csbig5': 'big5hkscs',
    'xxbig5': 'big5hkscs'
};

},{"7fd6e990ab3bef41":"ljQao","4ecedfe19d7d5f08":"8ufcs","7a67b65f65727c4":"lHy4o","a573389a26b6ed04":"lCpwI","8df748b1500da7b0":"4Q69p","97f577bf8532eb93":"dmGGU","e119a7f28ac84bb1":"b0SFM","cf01c21de68946c":"9TDg5"}],"ljQao":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",128],["a1","\uFF61",62],["8140","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7"],["8180","\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["81b8","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["81c8","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["81da","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["81f0","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["81fc","\u25EF"],["824f","\uFF10",9],["8260","\uFF21",25],["8281","\uFF41",25],["829f","\u3041",82],["8340","\u30A1",62],["8380","\u30E0",22],["839f","\u0391",16,"\u03A3",6],["83bf","\u03B1",16,"\u03C3",6],["8440","\u0410",5,"\u0401\u0416",25],["8470","\u0430",5,"\u0451\u0436",7],["8480","\u043E",17],["849f","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["8740","\u2460",19,"\u2160",9],["875f","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["877e","\u337B"],["8780","\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["889f","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["8940","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"],["8980","\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["8a40","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"],["8a80","\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["8b40","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"],["8b80","\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["8c40","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"],["8c80","\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["8d40","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"],["8d80","\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["8e40","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"],["8e80","\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["8f40","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"],["8f80","\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["9040","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"],["9080","\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["9140","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"],["9180","\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["9240","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"],["9280","\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["9340","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"],["9380","\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["9440","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"],["9480","\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["9540","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"],["9580","\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["9640","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"],["9680","\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["9740","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"],["9780","\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["9840","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["989f","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["9940","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"],["9980","\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["9a40","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"],["9a80","\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["9b40","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"],["9b80","\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["9c40","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"],["9c80","\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["9d40","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"],["9d80","\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["9e40","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"],["9e80","\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["9f40","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"],["9f80","\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["e040","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"],["e080","\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e140","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"],["e180","\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e240","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"],["e280","\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e340","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"],["e380","\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e440","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"],["e480","\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e540","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"],["e580","\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["e640","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"],["e680","\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["e740","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"],["e780","\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["e840","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"],["e880","\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["e940","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"],["e980","\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["ea40","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"],["ea80","\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"],["ed40","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"],["ed80","\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["ee40","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"],["ee80","\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["eeef","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["f040","\uE000",62],["f080","\uE03F",124],["f140","\uE0BC",62],["f180","\uE0FB",124],["f240","\uE178",62],["f280","\uE1B7",124],["f340","\uE234",62],["f380","\uE273",124],["f440","\uE2F0",62],["f480","\uE32F",124],["f540","\uE3AC",62],["f580","\uE3EB",124],["f640","\uE468",62],["f680","\uE4A7",124],["f740","\uE524",62],["f780","\uE563",124],["f840","\uE5E0",62],["f880","\uE61F",124],["f940","\uE69C"],["fa40","\u2170",9,"\u2160",9,"\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"],["fa80","\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"],["fb40","\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"],["fb80","\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"],["fc40","\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"]]');

},{}],"8ufcs":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127],["8ea1","\uFF61",62],["a1a1","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"],["a2a1","\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["a2ba","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["a2ca","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["a2dc","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["a2f2","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["a2fe","\u25EF"],["a3b0","\uFF10",9],["a3c1","\uFF21",25],["a3e1","\uFF41",25],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a8a1","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["ada1","\u2460",19,"\u2160",9],["adc0","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["addf","\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["b0a1","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["b1a1","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"],["b2a1","\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["b3a1","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"],["b4a1","\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["b5a1","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"],["b6a1","\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["b7a1","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"],["b8a1","\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["b9a1","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"],["baa1","\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["bba1","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"],["bca1","\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["bda1","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"],["bea1","\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["bfa1","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"],["c0a1","\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["c1a1","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"],["c2a1","\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["c3a1","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"],["c4a1","\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["c5a1","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"],["c6a1","\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["c7a1","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"],["c8a1","\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["c9a1","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"],["caa1","\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["cba1","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"],["cca1","\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["cda1","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"],["cea1","\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["cfa1","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["d0a1","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["d1a1","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"],["d2a1","\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["d3a1","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"],["d4a1","\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["d5a1","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"],["d6a1","\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["d7a1","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"],["d8a1","\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["d9a1","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"],["daa1","\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["dba1","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"],["dca1","\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["dda1","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"],["dea1","\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["dfa1","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"],["e0a1","\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e1a1","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"],["e2a1","\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e3a1","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"],["e4a1","\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e5a1","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"],["e6a1","\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e7a1","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"],["e8a1","\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e9a1","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"],["eaa1","\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["eba1","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"],["eca1","\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["eda1","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"],["eea1","\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["efa1","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"],["f0a1","\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["f1a1","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"],["f2a1","\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["f3a1","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"],["f4a1","\u582F\u69C7\u9059\u7464\u51DC\u7199"],["f9a1","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"],["faa1","\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["fba1","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"],["fca1","\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["fcf1","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["8fa2af","\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"],["8fa2c2","\xa1\xa6\xbf"],["8fa2eb","\xba\xaa\xa9\xae\u2122\xa4\u2116"],["8fa6e1","\u0386\u0388\u0389\u038A\u03AA"],["8fa6e7","\u038C"],["8fa6e9","\u038E\u03AB"],["8fa6ec","\u038F"],["8fa6f1","\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"],["8fa7c2","\u0402",10,"\u040E\u040F"],["8fa7f2","\u0452",10,"\u045E\u045F"],["8fa9a1","\xc6\u0110"],["8fa9a4","\u0126"],["8fa9a6","\u0132"],["8fa9a8","\u0141\u013F"],["8fa9ab","\u014A\xd8\u0152"],["8fa9af","\u0166\xde"],["8fa9c1","\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"],["8faaa1","\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"],["8faaba","\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"],["8faba1","\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"],["8fabbd","\u0121\u0125\xed\xec\xef\xee\u01D0"],["8fabc5","\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"],["8fb0a1","\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"],["8fb1a1","\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"],["8fb2a1","\u5092\u5093\u5094\u5096\u509B\u509C\u509E",4,"\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"],["8fb3a1","\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"],["8fb4a1","\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"],["8fb5a1","\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"],["8fb6a1","\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",5,"\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",4,"\u56F1\u56EB\u56ED"],["8fb7a1","\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",4,"\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"],["8fb8a1","\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"],["8fb9a1","\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"],["8fbaa1","\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",4,"\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"],["8fbba1","\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"],["8fbca1","\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",4,"\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"],["8fbda1","\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",4,"\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"],["8fbea1","\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",4,"\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"],["8fbfa1","\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"],["8fc0a1","\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"],["8fc1a1","\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"],["8fc2a1","\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"],["8fc3a1","\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",4,"\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"],["8fc4a1","\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"],["8fc5a1","\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"],["8fc6a1","\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"],["8fc7a1","\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"],["8fc8a1","\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"],["8fc9a1","\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",4,"\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",4,"\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"],["8fcaa1","\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"],["8fcba1","\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"],["8fcca1","\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",9,"\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"],["8fcda1","\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",5,"\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"],["8fcea1","\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",6,"\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"],["8fcfa1","\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"],["8fd0a1","\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"],["8fd1a1","\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"],["8fd2a1","\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",5],["8fd3a1","\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"],["8fd4a1","\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",4,"\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"],["8fd5a1","\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"],["8fd6a1","\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"],["8fd7a1","\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"],["8fd8a1","\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"],["8fd9a1","\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",4,"\u8556\u8559\u855C",6,"\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"],["8fdaa1","\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",4,"\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"],["8fdba1","\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",6,"\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"],["8fdca1","\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",4,"\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"],["8fdda1","\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",4,"\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"],["8fdea1","\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",4,"\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"],["8fdfa1","\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"],["8fe0a1","\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"],["8fe1a1","\u8F43\u8F47\u8F4F\u8F51",4,"\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"],["8fe2a1","\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"],["8fe3a1","\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",5,"\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",4,"\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"],["8fe4a1","\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",4,"\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"],["8fe5a1","\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",4,"\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"],["8fe6a1","\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"],["8fe7a1","\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"],["8fe8a1","\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",4,"\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"],["8fe9a1","\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",4],["8feaa1","\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",4,"\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"],["8feba1","\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",4,"\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"],["8feca1","\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"],["8feda1","\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",4,"\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",4,"\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"]]');

},{}],"lHy4o":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127,"\u20AC"],["8140","\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",5,"\u4E72\u4E74",9,"\u4E7F",6,"\u4E87\u4E8A"],["8180","\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",6,"\u4F0B\u4F0C\u4F12",4,"\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",4,"\u4F44\u4F45\u4F47",5,"\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"],["8240","\u4FA4\u4FAB\u4FAD\u4FB0",4,"\u4FB6",8,"\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",4,"\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",11],["8280","\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",10,"\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",4,"\u5056\u5057\u5058\u5059\u505B\u505D",7,"\u5066",5,"\u506D",8,"\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",20,"\u50A4\u50A6\u50AA\u50AB\u50AD",4,"\u50B3",6,"\u50BC"],["8340","\u50BD",17,"\u50D0",5,"\u50D7\u50D8\u50D9\u50DB",10,"\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",4,"\u50FC",9,"\u5108"],["8380","\u5109\u510A\u510C",5,"\u5113",13,"\u5122",28,"\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",4,"\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",4,"\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",5],["8440","\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",5,"\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",5,"\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"],["8480","\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",9,"\u527E\u5280\u5283",4,"\u5289",6,"\u5291\u5292\u5294",6,"\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",9,"\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",5,"\u52E0\u52E1\u52E2\u52E3\u52E5",10,"\u52F1",7,"\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"],["8540","\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",9,"\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"],["8580","\u5390",4,"\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",6,"\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",4,"\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",4,"\u5463\u5465\u5467\u5469",7,"\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"],["8640","\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",4,"\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",5,"\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",4,"\u5512\u5513\u5515",5,"\u551C\u551D\u551E\u551F\u5521\u5525\u5526"],["8680","\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",4,"\u5551\u5552\u5553\u5554\u5557",4,"\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",5,"\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",6,"\u55A8",8,"\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",4,"\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",4,"\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",4,"\u55FF\u5602\u5603\u5604\u5605"],["8740","\u5606\u5607\u560A\u560B\u560D\u5610",7,"\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",11,"\u564F",4,"\u5655\u5656\u565A\u565B\u565D",4],["8780","\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",7,"\u5687",6,"\u5690\u5691\u5692\u5694",14,"\u56A4",10,"\u56B0",6,"\u56B8\u56B9\u56BA\u56BB\u56BD",12,"\u56CB",8,"\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",5,"\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",6],["8840","\u5712",9,"\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",4,"\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",4,"\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"],["8880","\u5781\u5787\u5788\u5789\u578A\u578D",4,"\u5794",6,"\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",8,"\u57C4",6,"\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",7,"\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",4,"\u582B",4,"\u5831\u5832\u5833\u5834\u5836",7],["8940","\u583E",5,"\u5845",6,"\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",4,"\u585F",5,"\u5866",4,"\u586D",16,"\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"],["8980","\u588D",4,"\u5894",4,"\u589B\u589C\u589D\u58A0",7,"\u58AA",17,"\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",10,"\u58D2\u58D3\u58D4\u58D6",13,"\u58E5",5,"\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",7,"\u5903\u5905\u5906\u5908",4,"\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"],["8a40","\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",4,"\u5961\u5963\u5964\u5966",12,"\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"],["8a80","\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",5,"\u59BA\u59BC\u59BD\u59BF",6,"\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",4,"\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",11,"\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",6,"\u5A33\u5A35\u5A37",4,"\u5A3D\u5A3E\u5A3F\u5A41",4,"\u5A47\u5A48\u5A4B",9,"\u5A56\u5A57\u5A58\u5A59\u5A5B",5],["8b40","\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",8,"\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",17,"\u5A93",6,"\u5A9C",13,"\u5AAB\u5AAC"],["8b80","\u5AAD",4,"\u5AB4\u5AB6\u5AB7\u5AB9",4,"\u5ABF\u5AC0\u5AC3",5,"\u5ACA\u5ACB\u5ACD",4,"\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",4,"\u5AF2",22,"\u5B0A",11,"\u5B18",25,"\u5B33\u5B35\u5B36\u5B38",7,"\u5B41",6],["8c40","\u5B48",7,"\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"],["8c80","\u5BD1\u5BD4",8,"\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",4,"\u5BEF\u5BF1",6,"\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",6,"\u5C70\u5C72",6,"\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",4,"\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",4,"\u5CA4",4],["8d40","\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",5,"\u5CCC",5,"\u5CD3",5,"\u5CDA",6,"\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",9,"\u5CFC",4],["8d80","\u5D01\u5D04\u5D05\u5D08",5,"\u5D0F",4,"\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",4,"\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",4,"\u5D35",7,"\u5D3F",7,"\u5D48\u5D49\u5D4D",10,"\u5D59\u5D5A\u5D5C\u5D5E",10,"\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",12,"\u5D83",21,"\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"],["8e40","\u5DA1",21,"\u5DB8",12,"\u5DC6",6,"\u5DCE",12,"\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"],["8e80","\u5DF0\u5DF5\u5DF6\u5DF8",4,"\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",7,"\u5E28",4,"\u5E2F\u5E30\u5E32",4,"\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",5,"\u5E4D",6,"\u5E56",4,"\u5E5C\u5E5D\u5E5F\u5E60\u5E63",14,"\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",4,"\u5EAE",4,"\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",6],["8f40","\u5EC6\u5EC7\u5EC8\u5ECB",5,"\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",11,"\u5EE9\u5EEB",8,"\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"],["8f80","\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",6,"\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",14,"\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",5,"\u5FA9\u5FAB\u5FAC\u5FAF",5,"\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",4,"\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"],["9040","\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",4,"\u6036",4,"\u603D\u603E\u6040\u6044",6,"\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"],["9080","\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",7,"\u60C7\u60C8\u60C9\u60CC",4,"\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",4,"\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",4,"\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",4,"\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",18,"\u6140",6],["9140","\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",6,"\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",6,"\u6171\u6172\u6173\u6174\u6176\u6178",18,"\u618C\u618D\u618F",4,"\u6195"],["9180","\u6196",6,"\u619E",8,"\u61AA\u61AB\u61AD",9,"\u61B8",5,"\u61BF\u61C0\u61C1\u61C3",4,"\u61C9\u61CC",4,"\u61D3\u61D5",16,"\u61E7",13,"\u61F6",8,"\u6200",5,"\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",4,"\u6242\u6244\u6245\u6246\u624A"],["9240","\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",6,"\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",5,"\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"],["9280","\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",5,"\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",7,"\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",6,"\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"],["9340","\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",6,"\u63DF\u63E2\u63E4",4,"\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",4,"\u640D\u640E\u6411\u6412\u6415",5,"\u641D\u641F\u6422\u6423\u6424"],["9380","\u6425\u6427\u6428\u6429\u642B\u642E",5,"\u6435",4,"\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",6,"\u6453\u6455\u6456\u6457\u6459",4,"\u645F",7,"\u6468\u646A\u646B\u646C\u646E",9,"\u647B",6,"\u6483\u6486\u6488",8,"\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",4,"\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",6,"\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"],["9440","\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",24,"\u6501",7,"\u650A",7,"\u6513",4,"\u6519",8],["9480","\u6522\u6523\u6524\u6526",4,"\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",4,"\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",14,"\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",7,"\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",7,"\u65E1\u65E3\u65E4\u65EA\u65EB"],["9540","\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",4,"\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",4,"\u663D\u663F\u6640\u6642\u6644",6,"\u664D\u664E\u6650\u6651\u6658"],["9580","\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",4,"\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",4,"\u669E",8,"\u66A9",4,"\u66AF",4,"\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",25,"\u66DA\u66DE",7,"\u66E7\u66E8\u66EA",5,"\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"],["9640","\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",5,"\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",4,"\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"],["9680","\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",7,"\u67C2\u67C5",9,"\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",7,"\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",4,"\u681E\u681F\u6820\u6822",6,"\u682B",6,"\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",5],["9740","\u685C\u685D\u685E\u685F\u686A\u686C",7,"\u6875\u6878",8,"\u6882\u6884\u6887",7,"\u6890\u6891\u6892\u6894\u6895\u6896\u6898",9,"\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"],["9780","\u68B9",6,"\u68C1\u68C3",5,"\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",4,"\u68E1\u68E2\u68E4",9,"\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",4,"\u690C\u690F\u6911\u6913",11,"\u6921\u6922\u6923\u6925",7,"\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",16,"\u6955\u6956\u6958\u6959\u695B\u695C\u695F"],["9840","\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",4,"\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",5,"\u6996\u6997\u6999\u699A\u699D",9,"\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"],["9880","\u69BE\u69BF\u69C0\u69C2",7,"\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",5,"\u69DC\u69DD\u69DE\u69E1",11,"\u69EE\u69EF\u69F0\u69F1\u69F3",9,"\u69FE\u6A00",9,"\u6A0B",11,"\u6A19",5,"\u6A20\u6A22",5,"\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",6,"\u6A3F",4,"\u6A45\u6A46\u6A48",7,"\u6A51",6,"\u6A5A"],["9940","\u6A5C",4,"\u6A62\u6A63\u6A64\u6A66",10,"\u6A72",6,"\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",8,"\u6A8F\u6A92",4,"\u6A98",7,"\u6AA1",5],["9980","\u6AA7\u6AA8\u6AAA\u6AAD",114,"\u6B25\u6B26\u6B28",6],["9a40","\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",11,"\u6B5A",7,"\u6B68\u6B69\u6B6B",13,"\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"],["9a80","\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",4,"\u6BA2",7,"\u6BAB",7,"\u6BB6\u6BB8",6,"\u6BC0\u6BC3\u6BC4\u6BC6",4,"\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",4,"\u6BE2",7,"\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",6,"\u6C08",4,"\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",4,"\u6C51\u6C52\u6C53\u6C56\u6C58"],["9b40","\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",4,"\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"],["9b80","\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",5,"\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",4,"\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",4,"\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",5,"\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"],["9c40","\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",7,"\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"],["9c80","\u6E36\u6E37\u6E39\u6E3B",7,"\u6E45",7,"\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",10,"\u6E6C\u6E6D\u6E6F",14,"\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",4,"\u6E91",6,"\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",5],["9d40","\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",7,"\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",4,"\u6F10\u6F11\u6F12\u6F16",9,"\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",6,"\u6F3F\u6F40\u6F41\u6F42"],["9d80","\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",9,"\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",5,"\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",6,"\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",12,"\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",4,"\u6FA8",10,"\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",5,"\u6FC1\u6FC3",5,"\u6FCA",6,"\u6FD3",10,"\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"],["9e40","\u6FE6",7,"\u6FF0",32,"\u7012",7,"\u701C",6,"\u7024",6],["9e80","\u702B",9,"\u7036\u7037\u7038\u703A",17,"\u704D\u704E\u7050",13,"\u705F",11,"\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",12,"\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",12,"\u70DA"],["9f40","\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",6,"\u70F8\u70FA\u70FB\u70FC\u70FE",10,"\u710B",4,"\u7111\u7112\u7114\u7117\u711B",10,"\u7127",7,"\u7132\u7133\u7134"],["9f80","\u7135\u7137",13,"\u7146\u7147\u7148\u7149\u714B\u714D\u714F",12,"\u715D\u715F",4,"\u7165\u7169",4,"\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",5,"\u7185",4,"\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",4,"\u71A1",6,"\u71A9\u71AA\u71AB\u71AD",5,"\u71B4\u71B6\u71B7\u71B8\u71BA",8,"\u71C4",9,"\u71CF",4],["a040","\u71D6",9,"\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",5,"\u71EF",9,"\u71FA",11,"\u7207",19],["a080","\u721B\u721C\u721E",9,"\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",6,"\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",4,"\u728C\u728E\u7290\u7291\u7293",11,"\u72A0",11,"\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",6,"\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"],["a1a1","\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",7,"\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"],["a2a1","\u2170",9],["a2b1","\u2488",19,"\u2474",19,"\u2460",9],["a2e5","\u3220",9],["a2f1","\u2160",11],["a3a1","\uFF01\uFF02\uFF03\uFFE5\uFF05",88,"\uFFE3"],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a6e0","\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"],["a6ee","\uFE3B\uFE3C\uFE37\uFE38\uFE31"],["a6f4","\uFE33\uFE34"],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a840","\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",35,"\u2581",6],["a880","\u2588",7,"\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"],["a8a1","\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"],["a8bd","\u0144\u0148"],["a8c0","\u0261"],["a8c5","\u3105",36],["a940","\u3021",8,"\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"],["a959","\u2121\u3231"],["a95c","\u2010"],["a960","\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",9,"\uFE54\uFE55\uFE56\uFE57\uFE59",8],["a980","\uFE62",4,"\uFE68\uFE69\uFE6A\uFE6B"],["a996","\u3007"],["a9a4","\u2500",75],["aa40","\u72DC\u72DD\u72DF\u72E2",5,"\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",5,"\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",8],["aa80","\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",7,"\u7361",10,"\u736E\u7370\u7371"],["ab40","\u7372",11,"\u737F",4,"\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",5,"\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",4],["ab80","\u73CB\u73CC\u73CE\u73D2",6,"\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",4],["ac40","\u73F8",10,"\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",8,"\u741C",5,"\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",4,"\u743D\u743E\u743F\u7440\u7442",11],["ac80","\u744E",6,"\u7456\u7458\u745D\u7460",12,"\u746E\u746F\u7471",4,"\u7478\u7479\u747A"],["ad40","\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",10,"\u749D\u749F",7,"\u74AA",15,"\u74BB",12],["ad80","\u74C8",9,"\u74D3",8,"\u74DD\u74DF\u74E1\u74E5\u74E7",6,"\u74F0\u74F1\u74F2"],["ae40","\u74F3\u74F5\u74F8",6,"\u7500\u7501\u7502\u7503\u7505",7,"\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",4,"\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"],["ae80","\u755D",7,"\u7567\u7568\u7569\u756B",6,"\u7573\u7575\u7576\u7577\u757A",4,"\u7580\u7581\u7582\u7584\u7585\u7587"],["af40","\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",4,"\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"],["af80","\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"],["b040","\u7645",6,"\u764E",5,"\u7655\u7657",4,"\u765D\u765F\u7660\u7661\u7662\u7664",6,"\u766C\u766D\u766E\u7670",7,"\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"],["b080","\u769C",7,"\u76A5",8,"\u76AF\u76B0\u76B3\u76B5",9,"\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"],["b140","\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",4,"\u76E6",7,"\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",10,"\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"],["b180","\u772C\u772E\u7730",4,"\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",7,"\u7752",7,"\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"],["b240","\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",11,"\u777A\u777B\u777C\u7781\u7782\u7783\u7786",5,"\u778F\u7790\u7793",11,"\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",4],["b280","\u77BC\u77BE\u77C0",12,"\u77CE",8,"\u77D8\u77D9\u77DA\u77DD",4,"\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"],["b340","\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",5,"\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"],["b380","\u785B\u785C\u785E",11,"\u786F",7,"\u7878\u7879\u787A\u787B\u787D",6,"\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"],["b440","\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",7,"\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",9],["b480","\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",4,"\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",5,"\u7902\u7903\u7904\u7906",6,"\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"],["b540","\u790D",5,"\u7914",9,"\u791F",4,"\u7925",14,"\u7935",4,"\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",8,"\u7954\u7955\u7958\u7959\u7961\u7963"],["b580","\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",6,"\u7979\u797B",4,"\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"],["b640","\u7993",6,"\u799B",11,"\u79A8",10,"\u79B4",4,"\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",5,"\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"],["b680","\u79EC\u79EE\u79F1",6,"\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",4,"\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"],["b740","\u7A1D\u7A1F\u7A21\u7A22\u7A24",14,"\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",5,"\u7A47",9,"\u7A52",4,"\u7A58",16],["b780","\u7A69",6,"\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"],["b840","\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",4,"\u7AB4",10,"\u7AC0",10,"\u7ACC",9,"\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",5,"\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"],["b880","\u7AF4",4,"\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"],["b940","\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",5,"\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",10,"\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",6,"\u7B8E\u7B8F"],["b980","\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",7,"\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"],["ba40","\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",4,"\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",4,"\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",7,"\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",5,"\u7C17\u7C18\u7C19"],["ba80","\u7C1A",4,"\u7C20",5,"\u7C28\u7C29\u7C2B",12,"\u7C39",5,"\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"],["bb40","\u7C43",9,"\u7C4E",36,"\u7C75",5,"\u7C7E",9],["bb80","\u7C88\u7C8A",6,"\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",4,"\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"],["bc40","\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",6,"\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",6,"\u7CE9",5,"\u7CF0",7,"\u7CF9\u7CFA\u7CFC",13,"\u7D0B",5],["bc80","\u7D11",14,"\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",6,"\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"],["bd40","\u7D37",54,"\u7D6F",7],["bd80","\u7D78",32,"\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"],["be40","\u7D99",12,"\u7DA7",6,"\u7DAF",42],["be80","\u7DDA",32,"\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"],["bf40","\u7DFB",62],["bf80","\u7E3A\u7E3C",4,"\u7E42",4,"\u7E48",21,"\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"],["c040","\u7E5E",35,"\u7E83",23,"\u7E9C\u7E9D\u7E9E"],["c080","\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",6,"\u7F43\u7F46",9,"\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"],["c140","\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",4,"\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",7,"\u7F8B\u7F8D\u7F8F",4,"\u7F95",4,"\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",6,"\u7FB1"],["c180","\u7FB3",4,"\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",4,"\u7FD6\u7FD7\u7FD9",5,"\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"],["c240","\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",6,"\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",5,"\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"],["c280","\u8059\u805B",13,"\u806B",5,"\u8072",11,"\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"],["c340","\u807E\u8081\u8082\u8085\u8088\u808A\u808D",5,"\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",4,"\u80CF",6,"\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"],["c380","\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",12,"\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",4,"\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"],["c440","\u8140",5,"\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",4,"\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",4,"\u8189\u818B\u818C\u818D\u818E\u8190\u8192",5,"\u8199\u819A\u819E",4,"\u81A4\u81A5"],["c480","\u81A7\u81A9\u81AB",7,"\u81B4",5,"\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",6,"\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"],["c540","\u81D4",14,"\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",4,"\u81F5",5,"\u81FD\u81FF\u8203\u8207",4,"\u820E\u820F\u8211\u8213\u8215",5,"\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"],["c580","\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",7,"\u8259\u825B\u825C\u825D\u825E\u8260",7,"\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"],["c640","\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"],["c680","\u82FA\u82FC",4,"\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",9,"\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"],["c740","\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",4,"\u8353\u8355",4,"\u835D\u8362\u8370",6,"\u8379\u837A\u837E",6,"\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",6,"\u83AC\u83AD\u83AE"],["c780","\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"],["c840","\u83EE\u83EF\u83F3",4,"\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",5,"\u8419\u841A\u841B\u841E",5,"\u8429",7,"\u8432",5,"\u8439\u843A\u843B\u843E",7,"\u8447\u8448\u8449"],["c880","\u844A",6,"\u8452",4,"\u8458\u845D\u845E\u845F\u8460\u8462\u8464",4,"\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"],["c940","\u847D",4,"\u8483\u8484\u8485\u8486\u848A\u848D\u848F",7,"\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",12,"\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"],["c980","\u84D8",4,"\u84DE\u84E1\u84E2\u84E4\u84E7",4,"\u84ED\u84EE\u84EF\u84F1",10,"\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"],["ca40","\u8503",8,"\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",8,"\u852D",9,"\u853E",4,"\u8544\u8545\u8546\u8547\u854B",10],["ca80","\u8557\u8558\u855A\u855B\u855C\u855D\u855F",4,"\u8565\u8566\u8567\u8569",8,"\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"],["cb40","\u8582\u8583\u8586\u8588",6,"\u8590",10,"\u859D",6,"\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",5,"\u85B8\u85BA",6,"\u85C2",6,"\u85CA",4,"\u85D1\u85D2"],["cb80","\u85D4\u85D6",5,"\u85DD",6,"\u85E5\u85E6\u85E7\u85E8\u85EA",14,"\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"],["cc40","\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",4,"\u8606",10,"\u8612\u8613\u8614\u8615\u8617",15,"\u8628\u862A",13,"\u8639\u863A\u863B\u863D\u863E\u863F\u8640"],["cc80","\u8641",11,"\u8652\u8653\u8655",4,"\u865B\u865C\u865D\u865F\u8660\u8661\u8663",7,"\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"],["cd40","\u866D\u866F\u8670\u8672",6,"\u8683",6,"\u868E",4,"\u8694\u8696",5,"\u869E",4,"\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",4,"\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"],["cd80","\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"],["ce40","\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",6,"\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",5,"\u8761\u8762\u8766",7,"\u876F\u8771\u8772\u8773\u8775"],["ce80","\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",4,"\u8794\u8795\u8796\u8798",6,"\u87A0",4,"\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"],["cf40","\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",4,"\u87C7\u87C8\u87C9\u87CC",4,"\u87D4",6,"\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",9],["cf80","\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",5,"\u880B",7,"\u8814\u8817\u8818\u8819\u881A\u881C",4,"\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"],["d040","\u8824",13,"\u8833",5,"\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",5,"\u884E",5,"\u8855\u8856\u8858\u885A",6,"\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"],["d080","\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",4,"\u889D",4,"\u88A3\u88A5",5,"\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"],["d140","\u88AC\u88AE\u88AF\u88B0\u88B2",4,"\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",4,"\u88E0\u88E1\u88E6\u88E7\u88E9",6,"\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",5],["d180","\u8909\u890B",4,"\u8911\u8914",4,"\u891C",4,"\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"],["d240","\u8938",8,"\u8942\u8943\u8945",24,"\u8960",5,"\u8967",19,"\u897C"],["d280","\u897D\u897E\u8980\u8982\u8984\u8985\u8987",26,"\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"],["d340","\u89A2",30,"\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",6],["d380","\u89FB",4,"\u8A01",5,"\u8A08",21,"\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"],["d440","\u8A1E",31,"\u8A3F",8,"\u8A49",21],["d480","\u8A5F",25,"\u8A7A",6,"\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"],["d540","\u8A81",7,"\u8A8B",7,"\u8A94",46],["d580","\u8AC3",32,"\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"],["d640","\u8AE4",34,"\u8B08",27],["d680","\u8B24\u8B25\u8B27",30,"\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"],["d740","\u8B46",31,"\u8B67",4,"\u8B6D",25],["d780","\u8B87",24,"\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"],["d840","\u8C38",8,"\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",7,"\u8C56\u8C57\u8C58\u8C59\u8C5B",5,"\u8C63",6,"\u8C6C",6,"\u8C74\u8C75\u8C76\u8C77\u8C7B",6,"\u8C83\u8C84\u8C86\u8C87"],["d880","\u8C88\u8C8B\u8C8D",6,"\u8C95\u8C96\u8C97\u8C99",20,"\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"],["d940","\u8CAE",62],["d980","\u8CED",32,"\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"],["da40","\u8D0E",14,"\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",8,"\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",4,"\u8D92\u8D93\u8D95",9,"\u8DA0\u8DA1"],["da80","\u8DA2\u8DA4",12,"\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"],["db40","\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",6,"\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",7,"\u8E20\u8E21\u8E24",4,"\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"],["db80","\u8E3F\u8E43\u8E45\u8E46\u8E4C",4,"\u8E53",5,"\u8E5A",11,"\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"],["dc40","\u8E73\u8E75\u8E77",4,"\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",6,"\u8E91\u8E92\u8E93\u8E95",6,"\u8E9D\u8E9F",11,"\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",6,"\u8EBB",7],["dc80","\u8EC3",10,"\u8ECF",21,"\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"],["dd40","\u8EE5",62],["dd80","\u8F24",32,"\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"],["de40","\u8F45",32,"\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"],["de80","\u8FC9",4,"\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"],["df40","\u9019\u901C\u9023\u9024\u9025\u9027",5,"\u9030",4,"\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",4,"\u904E\u9054\u9055\u9056\u9059\u905A\u905C",5,"\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",4,"\u9076",6,"\u907E\u9081"],["df80","\u9084\u9085\u9086\u9087\u9089\u908A\u908C",4,"\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"],["e040","\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",19,"\u911A\u911B\u911C"],["e080","\u911D\u911F\u9120\u9121\u9124",10,"\u9130\u9132",6,"\u913A",8,"\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"],["e140","\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",4,"\u9186\u9188\u918A\u918E\u918F\u9193",6,"\u919C",5,"\u91A4",5,"\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"],["e180","\u91BC",10,"\u91C8\u91CB\u91D0\u91D2",9,"\u91DD",8,"\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"],["e240","\u91E6",62],["e280","\u9225",32,"\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",5,"\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"],["e340","\u9246",45,"\u9275",16],["e380","\u9286",7,"\u928F",24,"\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"],["e440","\u92A8",5,"\u92AF",24,"\u92C9",31],["e480","\u92E9",32,"\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"],["e540","\u930A",51,"\u933F",10],["e580","\u934A",31,"\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"],["e640","\u936C",34,"\u9390",27],["e680","\u93AC",29,"\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"],["e740","\u93CE",7,"\u93D7",54],["e780","\u940E",32,"\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",6,"\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",4,"\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"],["e840","\u942F",14,"\u943F",43,"\u946C\u946D\u946E\u946F"],["e880","\u9470",20,"\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"],["e940","\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",7,"\u9580",42],["e980","\u95AB",32,"\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"],["ea40","\u95CC",27,"\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",6,"\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"],["ea80","\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",4,"\u9673\u9678",12,"\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"],["eb40","\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",9,"\u96A8",7,"\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",9,"\u96E1",6,"\u96EB"],["eb80","\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",4,"\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"],["ec40","\u9721",8,"\u972B\u972C\u972E\u972F\u9731\u9733",4,"\u973A\u973B\u973C\u973D\u973F",18,"\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",7],["ec80","\u9772\u9775\u9777",4,"\u977D",7,"\u9786",4,"\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",4,"\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"],["ed40","\u979E\u979F\u97A1\u97A2\u97A4",6,"\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",46],["ed80","\u97E4\u97E5\u97E8\u97EE",4,"\u97F4\u97F7",23,"\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"],["ee40","\u980F",62],["ee80","\u984E",32,"\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",4,"\u94BC\u94BD\u94BF\u94C4\u94C8",6,"\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"],["ef40","\u986F",5,"\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",37,"\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",4],["ef80","\u98E5\u98E6\u98E9",30,"\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",4,"\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",8,"\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"],["f040","\u9908",4,"\u990E\u990F\u9911",28,"\u992F",26],["f080","\u994A",9,"\u9956",12,"\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",4,"\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",6,"\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"],["f140","\u998C\u998E\u999A",10,"\u99A6\u99A7\u99A9",47],["f180","\u99D9",32,"\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"],["f240","\u99FA",62],["f280","\u9A39",32,"\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"],["f340","\u9A5A",17,"\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",6,"\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",4,"\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"],["f380","\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",8,"\u9AFA\u9AFC",6,"\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"],["f440","\u9B07\u9B09",5,"\u9B10\u9B11\u9B12\u9B14",10,"\u9B20\u9B21\u9B22\u9B24",10,"\u9B30\u9B31\u9B33",7,"\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",5],["f480","\u9B5B",32,"\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"],["f540","\u9B7C",62],["f580","\u9BBB",32,"\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"],["f640","\u9BDC",62],["f680","\u9C1B",32,"\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",5,"\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",5,"\u9CA5",4,"\u9CAB\u9CAD\u9CAE\u9CB0",7,"\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"],["f740","\u9C3C",62],["f780","\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",4,"\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",4,"\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"],["f840","\u9CE3",62],["f880","\u9D22",32],["f940","\u9D43",62],["f980","\u9D82",32],["fa40","\u9DA3",62],["fa80","\u9DE2",32],["fb40","\u9E03",27,"\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",9,"\u9E80"],["fb80","\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",5,"\u9E94",8,"\u9E9E\u9EA0",5,"\u9EA7\u9EA8\u9EA9\u9EAA"],["fc40","\u9EAB",8,"\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",4,"\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",8,"\u9EFA\u9EFD\u9EFF",6],["fc80","\u9F06",4,"\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",5,"\u9F21\u9F23",8,"\u9F2D\u9F2E\u9F30\u9F31"],["fd40","\u9F32",4,"\u9F38\u9F3A\u9F3C\u9F3F",4,"\u9F45",10,"\u9F52",38],["fd80","\u9F79",5,"\u9F81\u9F82\u9F8D",11,"\u9F9C\u9F9D\u9F9E\u9FA1",4,"\uF92C\uF979\uF995\uF9E7\uF9F1"],["fe40","\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"]]');

},{}],"lCpwI":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["a140","\uE4C6",62],["a180","\uE505",32],["a240","\uE526",62],["a280","\uE565",32],["a2ab","\uE766",5],["a2e3","\u20AC\uE76D"],["a2ef","\uE76E\uE76F"],["a2fd","\uE770\uE771"],["a340","\uE586",62],["a380","\uE5C5",31,"\u3000"],["a440","\uE5E6",62],["a480","\uE625",32],["a4f4","\uE772",10],["a540","\uE646",62],["a580","\uE685",32],["a5f7","\uE77D",7],["a640","\uE6A6",62],["a680","\uE6E5",32],["a6b9","\uE785",7],["a6d9","\uE78D",6],["a6ec","\uE794\uE795"],["a6f3","\uE796"],["a6f6","\uE797",8],["a740","\uE706",62],["a780","\uE745",32],["a7c2","\uE7A0",14],["a7f2","\uE7AF",12],["a896","\uE7BC",10],["a8bc","\uE7C7"],["a8bf","\u01F9"],["a8c1","\uE7C9\uE7CA\uE7CB\uE7CC"],["a8ea","\uE7CD",20],["a958","\uE7E2"],["a95b","\uE7E3"],["a95d","\uE7E4\uE7E5\uE7E6"],["a989","\u303E\u2FF0",11],["a997","\uE7F4",12],["a9f0","\uE801",14],["aaa1","\uE000",93],["aba1","\uE05E",93],["aca1","\uE0BC",93],["ada1","\uE11A",93],["aea1","\uE178",93],["afa1","\uE1D6",93],["d7fa","\uE810",4],["f8a1","\uE234",93],["f9a1","\uE292",93],["faa1","\uE2F0",93],["fba1","\uE34E",93],["fca1","\uE3AC",93],["fda1","\uE40A",93],["fe50","\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"],["fe80","\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",6,"\u4DAE\uE864\uE468",93]]');

},{}],"4Q69p":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"uChars\":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],\"gbChars\":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}");

},{}],"dmGGU":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127],["8141","\uAC02\uAC03\uAC05\uAC06\uAC0B",4,"\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",6,"\uAC2E\uAC32\uAC33\uAC34"],["8161","\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",9,"\uAC4C\uAC4E",5,"\uAC55"],["8181","\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",18,"\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",4,"\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",6,"\uAC9E\uACA2",5,"\uACAB\uACAD\uACAE\uACB1",6,"\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",7,"\uACD6\uACD8",7,"\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",4,"\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",4,"\uAD0E\uAD10\uAD12\uAD13"],["8241","\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",7,"\uAD2A\uAD2B\uAD2E",5],["8261","\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",6,"\uAD46\uAD48\uAD4A",5,"\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"],["8281","\uAD59",7,"\uAD62\uAD64",7,"\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",4,"\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",10,"\uAD9E",5,"\uADA5",17,"\uADB8",7,"\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",6,"\uADD2\uADD4",7,"\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",18],["8341","\uADFA\uADFB\uADFD\uADFE\uAE02",5,"\uAE0A\uAE0C\uAE0E",5,"\uAE15",7],["8361","\uAE1D",18,"\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"],["8381","\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",4,"\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",6,"\uAE7A\uAE7E",5,"\uAE86",5,"\uAE8D",46,"\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",6,"\uAECE\uAED2",5,"\uAEDA\uAEDB\uAEDD",8],["8441","\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",5,"\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",8],["8461","\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",18],["8481","\uAF24",7,"\uAF2E\uAF2F\uAF31\uAF33\uAF35",6,"\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",5,"\uAF51",10,"\uAF5E",5,"\uAF66",18,"\uAF7A",5,"\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",6,"\uAF92\uAF93\uAF94\uAF96",5,"\uAF9D",26,"\uAFBA\uAFBB\uAFBD\uAFBE"],["8541","\uAFBF\uAFC1",5,"\uAFCA\uAFCC\uAFCF",4,"\uAFD5",6,"\uAFDD",4],["8561","\uAFE2",5,"\uAFEA",5,"\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",6,"\uB002\uB003"],["8581","\uB005",6,"\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",6,"\uB01E",9,"\uB029",26,"\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",29,"\uB07E\uB07F\uB081\uB082\uB083\uB085",6,"\uB08E\uB090\uB092",5,"\uB09B\uB09D\uB09E\uB0A3\uB0A4"],["8641","\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",6,"\uB0C6\uB0CA",5,"\uB0D2"],["8661","\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",6,"\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",10],["8681","\uB0F1",22,"\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",4,"\uB126\uB127\uB129\uB12A\uB12B\uB12D",6,"\uB136\uB13A",5,"\uB142\uB143\uB145\uB146\uB147\uB149",6,"\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",22,"\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",4,"\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"],["8741","\uB19E",9,"\uB1A9",15],["8761","\uB1B9",18,"\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"],["8781","\uB1D6",5,"\uB1DE\uB1E0",7,"\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",7,"\uB1FA\uB1FC\uB1FE",5,"\uB206\uB207\uB209\uB20A\uB20D",6,"\uB216\uB218\uB21A",5,"\uB221",18,"\uB235",6,"\uB23D",26,"\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",6,"\uB26A",4],["8841","\uB26F",4,"\uB276",5,"\uB27D",6,"\uB286\uB287\uB288\uB28A",4],["8861","\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",4,"\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"],["8881","\uB2B8",15,"\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",4,"\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",6,"\uB312\uB316",5,"\uB31D",54,"\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"],["8941","\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",6,"\uB382\uB386",5,"\uB38D"],["8961","\uB38E\uB38F\uB391\uB392\uB393\uB395",10,"\uB3A2",5,"\uB3A9\uB3AA\uB3AB\uB3AD"],["8981","\uB3AE",21,"\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",18,"\uB3FD",18,"\uB411",6,"\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",6,"\uB42A\uB42C",7,"\uB435",15],["8a41","\uB445",10,"\uB452\uB453\uB455\uB456\uB457\uB459",6,"\uB462\uB464\uB466"],["8a61","\uB467",4,"\uB46D",18,"\uB481\uB482"],["8a81","\uB483",4,"\uB489",19,"\uB49E",5,"\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",7,"\uB4B6\uB4B8\uB4BA",5,"\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",6,"\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",5,"\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",4,"\uB4EE\uB4F0\uB4F2",5,"\uB4F9",26,"\uB516\uB517\uB519\uB51A\uB51D"],["8b41","\uB51E",5,"\uB526\uB52B",4,"\uB532\uB533\uB535\uB536\uB537\uB539",6,"\uB542\uB546"],["8b61","\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",6,"\uB55E\uB562",8],["8b81","\uB56B",52,"\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",4,"\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",6,"\uB5CE\uB5D2",5,"\uB5D9",18,"\uB5ED",18],["8c41","\uB600",15,"\uB612\uB613\uB615\uB616\uB617\uB619",4],["8c61","\uB61E",6,"\uB626",5,"\uB62D",6,"\uB635",5],["8c81","\uB63B",12,"\uB649",26,"\uB665\uB666\uB667\uB669",50,"\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",5,"\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",16],["8d41","\uB6C3",16,"\uB6D5",8],["8d61","\uB6DE",17,"\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"],["8d81","\uB6FB",4,"\uB702\uB703\uB704\uB706",33,"\uB72A\uB72B\uB72D\uB72E\uB731",6,"\uB73A\uB73C",7,"\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",6,"\uB756",9,"\uB761\uB762\uB763\uB765\uB766\uB767\uB769",6,"\uB772\uB774\uB776",5,"\uB77E\uB77F\uB781\uB782\uB783\uB785",6,"\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"],["8e41","\uB79F\uB7A1",6,"\uB7AA\uB7AE",5,"\uB7B6\uB7B7\uB7B9",8],["8e61","\uB7C2",4,"\uB7C8\uB7CA",19],["8e81","\uB7DE",13,"\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",6,"\uB7FE\uB802",4,"\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",6,"\uB81A\uB81C\uB81E",5,"\uB826\uB827\uB829\uB82A\uB82B\uB82D",6,"\uB836\uB83A",5,"\uB841\uB842\uB843\uB845",11,"\uB852\uB854",7,"\uB85E\uB85F\uB861\uB862\uB863\uB865",6,"\uB86E\uB870\uB872",5,"\uB879\uB87A\uB87B\uB87D",7],["8f41","\uB885",7,"\uB88E",17],["8f61","\uB8A0",7,"\uB8A9",6,"\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",4],["8f81","\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",5,"\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",7,"\uB8DE\uB8E0\uB8E2",5,"\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",6,"\uB8FA\uB8FC\uB8FE",5,"\uB905",18,"\uB919",6,"\uB921",26,"\uB93E\uB93F\uB941\uB942\uB943\uB945",6,"\uB94D\uB94E\uB950\uB952",5],["9041","\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",6,"\uB96A\uB96C\uB96E",5,"\uB976\uB977\uB979\uB97A\uB97B\uB97D"],["9061","\uB97E",5,"\uB986\uB988\uB98B\uB98C\uB98F",15],["9081","\uB99F",12,"\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",6,"\uB9BE\uB9C0\uB9C2",5,"\uB9CA\uB9CB\uB9CD\uB9D3",4,"\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",6,"\uB9F6\uB9FB",4,"\uBA02",5,"\uBA09",11,"\uBA16",33,"\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"],["9141","\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",6,"\uBA66\uBA6A",5],["9161","\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",9,"\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",5],["9181","\uBA93",20,"\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",4,"\uBABA\uBABC\uBABE",5,"\uBAC5\uBAC6\uBAC7\uBAC9",14,"\uBADA",33,"\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",7,"\uBB0E\uBB10\uBB12",5,"\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",6],["9241","\uBB28\uBB2A\uBB2C",7,"\uBB37\uBB39\uBB3A\uBB3F",4,"\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"],["9261","\uBB53\uBB55\uBB56\uBB57\uBB59",7,"\uBB62\uBB64",7,"\uBB6D",4],["9281","\uBB72",21,"\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",18,"\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",6,"\uBBB5\uBBB6\uBBB8",7,"\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",6,"\uBBD1\uBBD2\uBBD4",35,"\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"],["9341","\uBC03",4,"\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"],["9361","\uBC36\uBC37\uBC39",6,"\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",8],["9381","\uBC5A\uBC5B\uBC5C\uBC5E",37,"\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",4,"\uBC96\uBC98\uBC9B",4,"\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",6,"\uBCB2\uBCB6",5,"\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",7,"\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",22,"\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"],["9441","\uBCFE",5,"\uBD06\uBD08\uBD0A",5,"\uBD11\uBD12\uBD13\uBD15",8],["9461","\uBD1E",5,"\uBD25",6,"\uBD2D",12],["9481","\uBD3A",5,"\uBD41",6,"\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",6,"\uBD5A",9,"\uBD65\uBD66\uBD67\uBD69",22,"\uBD82\uBD83\uBD85\uBD86\uBD8B",4,"\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",6,"\uBDA5",10,"\uBDB1",6,"\uBDB9",24],["9541","\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",11,"\uBDEA",5,"\uBDF1"],["9561","\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",6,"\uBE01\uBE02\uBE04\uBE06",5,"\uBE0E\uBE0F\uBE11\uBE12\uBE13"],["9581","\uBE15",6,"\uBE1E\uBE20",35,"\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",4,"\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",4,"\uBE72\uBE76",4,"\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",6,"\uBE8E\uBE92",5,"\uBE9A",13,"\uBEA9",14],["9641","\uBEB8",23,"\uBED2\uBED3"],["9661","\uBED5\uBED6\uBED9",6,"\uBEE1\uBEE2\uBEE6",5,"\uBEED",8],["9681","\uBEF6",10,"\uBF02",5,"\uBF0A",13,"\uBF1A\uBF1E",33,"\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",6,"\uBF52\uBF53\uBF54\uBF56",44],["9741","\uBF83",16,"\uBF95",8],["9761","\uBF9E",17,"\uBFB1",7],["9781","\uBFB9",11,"\uBFC6",5,"\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",6,"\uBFDD\uBFDE\uBFE0\uBFE2",89,"\uC03D\uC03E\uC03F"],["9841","\uC040",16,"\uC052",5,"\uC059\uC05A\uC05B"],["9861","\uC05D\uC05E\uC05F\uC061",6,"\uC06A",15],["9881","\uC07A",21,"\uC092\uC093\uC095\uC096\uC097\uC099",6,"\uC0A2\uC0A4\uC0A6",5,"\uC0AE\uC0B1\uC0B2\uC0B7",4,"\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",6,"\uC0DA\uC0DE",5,"\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",6,"\uC0F6\uC0F8\uC0FA",5,"\uC101\uC102\uC103\uC105\uC106\uC107\uC109",6,"\uC111\uC112\uC113\uC114\uC116",5,"\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"],["9941","\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",6,"\uC14A\uC14E",5,"\uC156\uC157"],["9961","\uC159\uC15A\uC15B\uC15D",6,"\uC166\uC16A",5,"\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"],["9981","\uC17C",8,"\uC186",5,"\uC18F\uC191\uC192\uC193\uC195\uC197",4,"\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",11,"\uC1BE",5,"\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",6,"\uC1D5\uC1D6\uC1D9",6,"\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",6,"\uC1F2\uC1F4",7,"\uC1FE\uC1FF\uC201\uC202\uC203\uC205",6,"\uC20E\uC210\uC212",5,"\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"],["9a41","\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",16],["9a61","\uC246\uC247\uC249",6,"\uC252\uC253\uC255\uC256\uC257\uC259",6,"\uC261\uC262\uC263\uC264\uC266"],["9a81","\uC267",4,"\uC26E\uC26F\uC271\uC272\uC273\uC275",6,"\uC27E\uC280\uC282",5,"\uC28A",5,"\uC291",6,"\uC299\uC29A\uC29C\uC29E",5,"\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",5,"\uC2B6\uC2B8\uC2BA",33,"\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",5,"\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",6,"\uC30A\uC30B\uC30E\uC30F"],["9b41","\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",6,"\uC326\uC327\uC32A",8],["9b61","\uC333",17,"\uC346",7],["9b81","\uC34E",25,"\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",4,"\uC37A\uC37B\uC37E",5,"\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",50,"\uC3C1",22,"\uC3DA"],["9c41","\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",4,"\uC3EA\uC3EB\uC3EC\uC3EE",5,"\uC3F6\uC3F7\uC3F9",5],["9c61","\uC3FF",8,"\uC409",6,"\uC411",9],["9c81","\uC41B",8,"\uC425",6,"\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",6,"\uC43E",9,"\uC449",26,"\uC466\uC467\uC469\uC46A\uC46B\uC46D",6,"\uC476\uC477\uC478\uC47A",5,"\uC481",18,"\uC495",6,"\uC49D",12],["9d41","\uC4AA",13,"\uC4B9\uC4BA\uC4BB\uC4BD",8],["9d61","\uC4C6",25],["9d81","\uC4E0",8,"\uC4EA",5,"\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",9,"\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",6,"\uC51D",10,"\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",6,"\uC53A\uC53C\uC53E",5,"\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",6,"\uC572\uC576",5,"\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"],["9e41","\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",7,"\uC5AA",9,"\uC5B6"],["9e61","\uC5B7\uC5BA\uC5BF",4,"\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",6,"\uC5E2\uC5E4\uC5E6\uC5E7"],["9e81","\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",6,"\uC61A\uC61D",6,"\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",6,"\uC652\uC656",5,"\uC65E\uC65F\uC661",10,"\uC66D\uC66E\uC670\uC672",5,"\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",6,"\uC68A\uC68C\uC68E",5,"\uC696\uC697\uC699\uC69A\uC69B\uC69D",6,"\uC6A6"],["9f41","\uC6A8\uC6AA",5,"\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",4,"\uC6C2\uC6C4\uC6C6",5,"\uC6CE"],["9f61","\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",6,"\uC6DE\uC6DF\uC6E2",5,"\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"],["9f81","\uC6F3",4,"\uC6FA\uC6FB\uC6FC\uC6FE",5,"\uC706\uC707\uC709\uC70A\uC70B\uC70D",6,"\uC716\uC718\uC71A",5,"\uC722\uC723\uC725\uC726\uC727\uC729",6,"\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",4,"\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",6,"\uC769\uC76A\uC76C",7,"\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",4,"\uC7A2\uC7A7",4,"\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"],["a041","\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",5,"\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",6,"\uC7D9\uC7DA\uC7DB\uC7DC"],["a061","\uC7DE",5,"\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",13],["a081","\uC7FB",4,"\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",4,"\uC812\uC814\uC817",4,"\uC81E\uC81F\uC821\uC822\uC823\uC825",6,"\uC82E\uC830\uC832",5,"\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",6,"\uC84A\uC84B\uC84E",5,"\uC855",26,"\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",4,"\uC882\uC884\uC888\uC889\uC88A\uC88E",5,"\uC895",7,"\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"],["a141","\uC8A5\uC8A6\uC8A7\uC8A9",18,"\uC8BE\uC8BF\uC8C0\uC8C1"],["a161","\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",6,"\uC8D6\uC8D8\uC8DA",5,"\uC8E2\uC8E3\uC8E5"],["a181","\uC8E6",14,"\uC8F6",5,"\uC8FE\uC8FF\uC901\uC902\uC903\uC907",4,"\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",9,"\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"],["a241","\uC910\uC912",5,"\uC919",18],["a261","\uC92D",6,"\uC935",18],["a281","\uC948",7,"\uC952\uC953\uC955\uC956\uC957\uC959",6,"\uC962\uC964",7,"\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"],["a341","\uC971\uC972\uC973\uC975",6,"\uC97D",10,"\uC98A\uC98B\uC98D\uC98E\uC98F"],["a361","\uC991",6,"\uC99A\uC99C\uC99E",16],["a381","\uC9AF",16,"\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",4,"\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",58,"\uFFE6\uFF3D",32,"\uFFE3"],["a441","\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",5,"\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"],["a461","\uCA05\uCA06\uCA07\uCA0A\uCA0E",5,"\uCA15\uCA16\uCA17\uCA19",12],["a481","\uCA26\uCA27\uCA28\uCA2A",28,"\u3131",93],["a541","\uCA47",4,"\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",6,"\uCA5E\uCA62",5,"\uCA69\uCA6A"],["a561","\uCA6B",17,"\uCA7E",5,"\uCA85\uCA86"],["a581","\uCA87",16,"\uCA99",14,"\u2170",9],["a5b0","\u2160",9],["a5c1","\u0391",16,"\u03A3",6],["a5e1","\u03B1",16,"\u03C3",6],["a641","\uCAA8",19,"\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"],["a661","\uCAC6",5,"\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",5,"\uCAE1",6],["a681","\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",6,"\uCAF5",18,"\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",7],["a741","\uCB0B",4,"\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",6,"\uCB22",7],["a761","\uCB2A",22,"\uCB42\uCB43\uCB44"],["a781","\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",6,"\uCB5A\uCB5B\uCB5C\uCB5E",5,"\uCB65",7,"\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",9,"\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",9,"\u3380",4,"\u33BA",5,"\u3390",4,"\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"],["a841","\uCB6D",10,"\uCB7A",14],["a861","\uCB89",18,"\uCB9D",6],["a881","\uCBA4",19,"\uCBB9",11,"\xc6\xd0\xaa\u0126"],["a8a6","\u0132"],["a8a8","\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"],["a8b1","\u3260",27,"\u24D0",25,"\u2460",14,"\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"],["a941","\uCBC5",14,"\uCBD5",10],["a961","\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",18],["a981","\uCBFD",14,"\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",6,"\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",27,"\u249C",25,"\u2474",14,"\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"],["aa41","\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",6,"\uCC3A\uCC3F",4,"\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"],["aa61","\uCC4F",4,"\uCC56\uCC5A",5,"\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",6,"\uCC71\uCC72"],["aa81","\uCC73\uCC74\uCC76",29,"\u3041",82],["ab41","\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",6,"\uCCAA\uCCAE",5,"\uCCB6\uCCB7\uCCB9"],["ab61","\uCCBA\uCCBB\uCCBD",6,"\uCCC6\uCCC8\uCCCA",5,"\uCCD1\uCCD2\uCCD3\uCCD5",5],["ab81","\uCCDB",8,"\uCCE5",6,"\uCCED\uCCEE\uCCEF\uCCF1",12,"\u30A1",85],["ac41","\uCCFE\uCCFF\uCD00\uCD02",5,"\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",6,"\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"],["ac61","\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",11,"\uCD3A",4],["ac81","\uCD3F",28,"\uCD5D\uCD5E\uCD5F\u0410",5,"\u0401\u0416",25],["acd1","\u0430",5,"\u0451\u0436",25],["ad41","\uCD61\uCD62\uCD63\uCD65",6,"\uCD6E\uCD70\uCD72",5,"\uCD79",7],["ad61","\uCD81",6,"\uCD89",10,"\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"],["ad81","\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",5,"\uCDB1",18,"\uCDC5"],["ae41","\uCDC6",5,"\uCDCD\uCDCE\uCDCF\uCDD1",16],["ae61","\uCDE2",5,"\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",6,"\uCDFA\uCDFC\uCDFE",4],["ae81","\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",6,"\uCE15\uCE16\uCE17\uCE18\uCE1A",5,"\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"],["af41","\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",19],["af61","\uCE4A",13,"\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",5,"\uCE6A\uCE6C"],["af81","\uCE6E",5,"\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",6,"\uCE86\uCE88\uCE8A",5,"\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"],["b041","\uCE9A",5,"\uCEA2\uCEA6",5,"\uCEAE",12],["b061","\uCEBB",5,"\uCEC2",19],["b081","\uCED6",13,"\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",6,"\uCEF6\uCEFA",5,"\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",7,"\uAC19",4,"\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"],["b141","\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",6,"\uCF12\uCF14\uCF16",5,"\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"],["b161","\uCF25",6,"\uCF2E\uCF32",5,"\uCF39",11],["b181","\uCF45",14,"\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",6,"\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"],["b241","\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",6,"\uCF81\uCF82\uCF83\uCF84\uCF86",5,"\uCF8D"],["b261","\uCF8E",18,"\uCFA2",5,"\uCFA9"],["b281","\uCFAA",5,"\uCFB1",18,"\uCFC5",6,"\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"],["b341","\uCFCC",19,"\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"],["b361","\uCFEA",5,"\uCFF2\uCFF4\uCFF6",5,"\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",5],["b381","\uD00B",5,"\uD012",5,"\uD019",19,"\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",4,"\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"],["b441","\uD02E",5,"\uD036\uD037\uD039\uD03A\uD03B\uD03D",6,"\uD046\uD048\uD04A",5],["b461","\uD051\uD052\uD053\uD055\uD056\uD057\uD059",6,"\uD061",10,"\uD06E\uD06F"],["b481","\uD071\uD072\uD073\uD075",6,"\uD07E\uD07F\uD080\uD082",18,"\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",4,"\uB2F3\uB2F4\uB2F5\uB2F7",4,"\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"],["b541","\uD095",14,"\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",5],["b561","\uD0B3\uD0B6\uD0B8\uD0BA",5,"\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",5,"\uD0D2\uD0D6",4],["b581","\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",6,"\uD0EE\uD0F2",5,"\uD0F9",11,"\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"],["b641","\uD105",7,"\uD10E",17],["b661","\uD120",15,"\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"],["b681","\uD13F\uD142\uD146",5,"\uD14E\uD14F\uD151\uD152\uD153\uD155",6,"\uD15E\uD160\uD162",5,"\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"],["b741","\uD16E",13,"\uD17D",6,"\uD185\uD186\uD187\uD189\uD18A"],["b761","\uD18B",20,"\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"],["b781","\uD1A9",6,"\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",14,"\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"],["b841","\uD1D0",7,"\uD1D9",17],["b861","\uD1EB",8,"\uD1F5\uD1F6\uD1F7\uD1F9",13],["b881","\uD208\uD20A",5,"\uD211",24,"\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",4,"\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"],["b941","\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",6,"\uD23E\uD240\uD242",5,"\uD249\uD24A\uD24B\uD24C"],["b961","\uD24D",14,"\uD25D",6,"\uD265\uD266\uD267\uD268"],["b981","\uD269",22,"\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",4,"\uBC1B",4,"\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"],["ba41","\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",5,"\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",6,"\uD2AD"],["ba61","\uD2AE\uD2AF\uD2B0\uD2B2",5,"\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",4,"\uD2CA\uD2CC",5],["ba81","\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",6,"\uD2E6",9,"\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"],["bb41","\uD2FB",4,"\uD302\uD304\uD306",5,"\uD30F\uD311\uD312\uD313\uD315\uD317",4,"\uD31E\uD322\uD323"],["bb61","\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",6,"\uD33A\uD33E",5,"\uD346\uD347\uD348\uD349"],["bb81","\uD34A",31,"\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"],["bc41","\uD36A",17,"\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"],["bc61","\uD388\uD389\uD38A\uD38B\uD38E\uD392",5,"\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",6,"\uD3AA\uD3AC\uD3AE"],["bc81","\uD3AF",4,"\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",6,"\uD3C6\uD3C7\uD3CA",5,"\uD3D1",5,"\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",4,"\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"],["bd41","\uD3D7\uD3D9",7,"\uD3E2\uD3E4",7,"\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"],["bd61","\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",5,"\uD409",13],["bd81","\uD417",5,"\uD41E",25,"\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"],["be41","\uD438",7,"\uD441\uD442\uD443\uD445",14],["be61","\uD454",7,"\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",7,"\uD46E\uD470\uD471\uD472"],["be81","\uD473",4,"\uD47A\uD47B\uD47D\uD47E\uD481\uD483",4,"\uD48A\uD48C\uD48E",5,"\uD495",8,"\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",6,"\uC5CC\uC5CE"],["bf41","\uD49E",10,"\uD4AA",14],["bf61","\uD4B9",18,"\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"],["bf81","\uD4D6",5,"\uD4DD\uD4DE\uD4E0",7,"\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",6,"\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",5,"\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"],["c041","\uD4FE",5,"\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",6,"\uD516\uD518",5],["c061","\uD51E",25],["c081","\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",6,"\uD54E\uD550\uD552",5,"\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",7,"\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"],["c141","\uD564\uD566\uD567\uD56A\uD56C\uD56E",5,"\uD576\uD577\uD579\uD57A\uD57B\uD57D",6,"\uD586\uD58A\uD58B"],["c161","\uD58C\uD58D\uD58E\uD58F\uD591",19,"\uD5A6\uD5A7"],["c181","\uD5A8",31,"\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"],["c241","\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",4,"\uD5DA\uD5DC\uD5DE",5,"\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"],["c261","\uD5EF",4,"\uD5F6\uD5F8\uD5FA",5,"\uD602\uD603\uD605\uD606\uD607\uD609",6,"\uD612"],["c281","\uD616",5,"\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",7,"\uD62E",9,"\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"],["c341","\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",4],["c361","\uD662",4,"\uD668\uD66A",5,"\uD672\uD673\uD675",11],["c381","\uD681\uD682\uD684\uD686",5,"\uD68E\uD68F\uD691\uD692\uD693\uD695",7,"\uD69E\uD6A0\uD6A2",5,"\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"],["c441","\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",7,"\uD6BA\uD6BC",7,"\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"],["c461","\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",5,"\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",4],["c481","\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",5,"\uD6FE\uD6FF\uD701\uD702\uD703\uD705",11,"\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"],["c541","\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",6,"\uD72A\uD72C\uD72E",5,"\uD736\uD737\uD739"],["c561","\uD73A\uD73B\uD73D",6,"\uD745\uD746\uD748\uD74A",5,"\uD752\uD753\uD755\uD75A",4],["c581","\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",6,"\uD77E\uD77F\uD780\uD782",5,"\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"],["c641","\uD78D\uD78E\uD78F\uD791",6,"\uD79A\uD79C\uD79E",5],["c6a1","\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"],["c7a1","\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"],["c8a1","\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"],["caa1","\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"],["cba1","\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"],["cca1","\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"],["cda1","\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"],["cea1","\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"],["cfa1","\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"],["d0a1","\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"],["d1a1","\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",5,"\u90A3\uF914",4,"\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"],["d2a1","\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",4,"\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",5,"\u99D1\uF939",10,"\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",7,"\u5AE9\u8A25\u677B\u7D10\uF952",5,"\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"],["d3a1","\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"],["d4a1","\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"],["d5a1","\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"],["d6a1","\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"],["d7a1","\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"],["d8a1","\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"],["d9a1","\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"],["daa1","\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"],["dba1","\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"],["dca1","\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"],["dda1","\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"],["dea1","\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"],["dfa1","\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"],["e0a1","\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"],["e1a1","\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"],["e2a1","\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"],["e3a1","\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"],["e4a1","\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"],["e5a1","\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"],["e6a1","\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"],["e7a1","\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"],["e8a1","\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"],["e9a1","\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"],["eaa1","\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"],["eba1","\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"],["eca1","\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"],["eda1","\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"],["eea1","\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"],["efa1","\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"],["f0a1","\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"],["f1a1","\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"],["f2a1","\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"],["f3a1","\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"],["f4a1","\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"],["f5a1","\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"],["f6a1","\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"],["f7a1","\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"],["f8a1","\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"],["f9a1","\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"],["faa1","\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"],["fba1","\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"],["fca1","\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"],["fda1","\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"]]');

},{}],"b0SFM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["0","\\u0000",127],["a140","\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"],["a1a1","\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",4,"\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"],["a240","\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",7,"\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"],["a2a1","\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",9,"\u2160",9,"\u3021",8,"\u5341\u5344\u5345\uFF21",25,"\uFF41",21],["a340","\uFF57\uFF58\uFF59\uFF5A\u0391",16,"\u03A3",6,"\u03B1",16,"\u03C3",6,"\u3105",10],["a3a1","\u3110",25,"\u02D9\u02C9\u02CA\u02C7\u02CB"],["a3e1","\u20AC"],["a440","\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"],["a4a1","\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"],["a540","\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"],["a5a1","\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"],["a640","\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"],["a6a1","\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"],["a740","\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"],["a7a1","\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"],["a840","\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"],["a8a1","\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"],["a940","\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"],["a9a1","\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"],["aa40","\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"],["aaa1","\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"],["ab40","\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"],["aba1","\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"],["ac40","\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"],["aca1","\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"],["ad40","\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"],["ada1","\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"],["ae40","\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"],["aea1","\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"],["af40","\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"],["afa1","\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"],["b040","\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"],["b0a1","\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"],["b140","\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"],["b1a1","\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"],["b240","\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"],["b2a1","\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"],["b340","\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"],["b3a1","\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"],["b440","\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"],["b4a1","\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"],["b540","\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"],["b5a1","\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"],["b640","\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"],["b6a1","\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"],["b740","\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"],["b7a1","\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"],["b840","\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"],["b8a1","\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"],["b940","\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"],["b9a1","\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"],["ba40","\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"],["baa1","\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"],["bb40","\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"],["bba1","\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"],["bc40","\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"],["bca1","\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"],["bd40","\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"],["bda1","\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"],["be40","\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"],["bea1","\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"],["bf40","\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"],["bfa1","\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"],["c040","\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"],["c0a1","\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"],["c140","\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"],["c1a1","\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"],["c240","\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"],["c2a1","\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"],["c340","\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"],["c3a1","\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"],["c440","\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"],["c4a1","\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"],["c540","\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"],["c5a1","\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"],["c640","\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"],["c940","\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"],["c9a1","\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"],["ca40","\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"],["caa1","\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"],["cb40","\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"],["cba1","\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"],["cc40","\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"],["cca1","\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"],["cd40","\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"],["cda1","\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"],["ce40","\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"],["cea1","\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"],["cf40","\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"],["cfa1","\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"],["d040","\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"],["d0a1","\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"],["d140","\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"],["d1a1","\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"],["d240","\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"],["d2a1","\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"],["d340","\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"],["d3a1","\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"],["d440","\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"],["d4a1","\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"],["d540","\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"],["d5a1","\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"],["d640","\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"],["d6a1","\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"],["d740","\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"],["d7a1","\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"],["d840","\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"],["d8a1","\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"],["d940","\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"],["d9a1","\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"],["da40","\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"],["daa1","\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"],["db40","\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"],["dba1","\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"],["dc40","\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"],["dca1","\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"],["dd40","\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"],["dda1","\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"],["de40","\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"],["dea1","\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"],["df40","\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"],["dfa1","\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"],["e040","\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"],["e0a1","\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"],["e140","\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"],["e1a1","\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"],["e240","\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"],["e2a1","\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"],["e340","\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"],["e3a1","\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"],["e440","\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"],["e4a1","\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"],["e540","\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"],["e5a1","\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"],["e640","\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"],["e6a1","\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"],["e740","\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"],["e7a1","\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"],["e840","\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"],["e8a1","\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"],["e940","\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"],["e9a1","\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"],["ea40","\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"],["eaa1","\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"],["eb40","\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"],["eba1","\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"],["ec40","\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"],["eca1","\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"],["ed40","\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"],["eda1","\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"],["ee40","\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"],["eea1","\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"],["ef40","\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"],["efa1","\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"],["f040","\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"],["f0a1","\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"],["f140","\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"],["f1a1","\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"],["f240","\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"],["f2a1","\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"],["f340","\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"],["f3a1","\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"],["f440","\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"],["f4a1","\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"],["f540","\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"],["f5a1","\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"],["f640","\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"],["f6a1","\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"],["f740","\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"],["f7a1","\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"],["f840","\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"],["f8a1","\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"],["f940","\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"],["f9a1","\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"]]');

},{}],"9TDg5":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('[["8740","\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"],["8767","\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"],["87a1","\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"],["8840","\u31C0",4,"\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"],["88a1","\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"],["8940","\uD868\uDFA9\uD844\uDD45"],["8943","\u650A"],["8946","\u4E3D\u6EDD\u9D4E\u91DF"],["894c","\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"],["89a1","\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"],["89ab","\u918C\u78B8\u915E\u80BC"],["89b0","\u8D0B\u80F6\uD842\uDDE7"],["89b5","\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"],["89c1","\u6E9A\u823E\u7519"],["89c5","\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"],["8a40","\uD85F\uDD84\u5525"],["8a43","\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"],["8a64","\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"],["8a76","\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"],["8aa1","\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"],["8aac","\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"],["8ab2","\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"],["8abb","\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"],["8ac9","\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"],["8ace","\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"],["8adf","\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"],["8af6","\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"],["8b40","\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"],["8b55","\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"],["8ba1","\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"],["8bde","\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"],["8c40","\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"],["8ca1","\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"],["8ca7","\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"],["8cc9","\u9868\u676B\u4276\u573D"],["8cce","\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"],["8ce6","\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"],["8d40","\uD842\uDF9F"],["8d42","\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"],["8da1","\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"],["8e40","\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"],["8ea1","\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"],["8f40","\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"],["8fa1","\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"],["9040","\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"],["90a1","\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"],["9140","\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"],["91a1","\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"],["9240","\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"],["92a1","\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"],["9340","\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"],["93a1","\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"],["9440","\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"],["94a1","\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"],["9540","\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"],["95a1","\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"],["9640","\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"],["96a1","\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"],["9740","\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"],["97a1","\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"],["9840","\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"],["98a1","\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"],["9940","\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"],["99a1","\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"],["9a40","\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"],["9aa1","\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"],["9b40","\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"],["9b62","\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"],["9ba1","\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"],["9c40","\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"],["9ca1","\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"],["9d40","\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"],["9da1","\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"],["9e40","\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"],["9ea1","\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"],["9ead","\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"],["9ec5","\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"],["9ef5","\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"],["9f40","\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"],["9f4f","\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"],["9fa1","\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"],["9fae","\u9159\u9681\u915C"],["9fb2","\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"],["9fc1","\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"],["9fc9","\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"],["9fdb","\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"],["9fe7","\u6BFA\u8818\u7F78"],["9feb","\u5620\uD869\uDE4A\u8E77\u9F53"],["9ff0","\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"],["a040","\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"],["a055","\uD846\uDC3B\uD85B\uDE05"],["a058","\u8A7E\uD849\uDD1B"],["a05b","\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"],["a063","\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"],["a073","\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"],["a0a1","\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"],["a0a6","\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"],["a0ae","\u77FE"],["a0b0","\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"],["a0d4","\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"],["a0e2","\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"],["a3c0","\u2400",31,"\u2421"],["c6a1","\u2460",9,"\u2474",9,"\u2170",9,"\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",23],["c740","\u3059",58,"\u30A1\u30A2\u30A3\u30A4"],["c7a1","\u30A5",81,"\u0410",5,"\u0401\u0416",4],["c840","\u041B",26,"\u0451\u0436",25,"\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"],["c8a1","\u9FB0\u5188\u9FB1\uD85D\uDE07"],["c8cd","\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"],["c8f5","\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"],["f9fe","\uFFED"],["fa40","\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"],["faa1","\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"],["fb40","\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"],["fba1","\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"],["fc40","\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"],["fca1","\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"],["fd40","\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"],["fda1","\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"],["fe40","\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"],["fea1","\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"]]');

},{}],"eyY9t":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var ArrayT, NumberT, utils;
    NumberT = require("63fd43242c81db23").Number;
    utils = require("1e0e480ba13d0d71");
    ArrayT = function() {
        function ArrayT(type, length, lengthType) {
            this.type = type;
            this.length = length;
            this.lengthType = lengthType != null ? lengthType : 'count';
        }
        ArrayT.prototype.decode = function(stream, parent) {
            var ctx, i, length, pos, res, target, _i;
            pos = stream.pos;
            res = [];
            ctx = parent;
            if (this.length != null) length = utils.resolveLength(this.length, stream, parent);
            if (this.length instanceof NumberT) {
                Object.defineProperties(res, {
                    parent: {
                        value: parent
                    },
                    _startOffset: {
                        value: pos
                    },
                    _currentOffset: {
                        value: 0,
                        writable: true
                    },
                    _length: {
                        value: length
                    }
                });
                ctx = res;
            }
            if (length == null || this.lengthType === 'bytes') {
                target = length != null ? stream.pos + length : (parent != null ? parent._length : void 0) ? parent._startOffset + parent._length : stream.length;
                while(stream.pos < target)res.push(this.type.decode(stream, ctx));
            } else for(i = _i = 0; _i < length; i = _i += 1)res.push(this.type.decode(stream, ctx));
            return res;
        };
        ArrayT.prototype.size = function(array, ctx) {
            var item, size, _i, _len;
            if (!array) return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
            size = 0;
            if (this.length instanceof NumberT) {
                size += this.length.size();
                ctx = {
                    parent: ctx
                };
            }
            for(_i = 0, _len = array.length; _i < _len; _i++){
                item = array[_i];
                size += this.type.size(item, ctx);
            }
            return size;
        };
        ArrayT.prototype.encode = function(stream, array, parent) {
            var ctx, i, item, ptr, _i, _len;
            ctx = parent;
            if (this.length instanceof NumberT) {
                ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent
                };
                ctx.pointerOffset = stream.pos + this.size(array, ctx);
                this.length.encode(stream, array.length);
            }
            for(_i = 0, _len = array.length; _i < _len; _i++){
                item = array[_i];
                this.type.encode(stream, item, ctx);
            }
            if (this.length instanceof NumberT) {
                i = 0;
                while(i < ctx.pointers.length){
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val);
                }
            }
        };
        return ArrayT;
    }();
    module.exports = ArrayT;
}).call(this);

},{"63fd43242c81db23":"5m1Sl","1e0e480ba13d0d71":"4jpsW"}],"5m1Sl":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var DecodeStream, Fixed, NumberT, __hasProp = {}.hasOwnProperty, __extends = function(child, parent) {
        for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    };
    DecodeStream = require("b4467568ff03b9c6");
    NumberT = function() {
        function NumberT(type, endian) {
            this.type = type;
            this.endian = endian != null ? endian : 'BE';
            this.fn = this.type;
            if (this.type[this.type.length - 1] !== '8') this.fn += this.endian;
        }
        NumberT.prototype.size = function() {
            return DecodeStream.TYPES[this.type];
        };
        NumberT.prototype.decode = function(stream) {
            return stream['read' + this.fn]();
        };
        NumberT.prototype.encode = function(stream, val) {
            return stream['write' + this.fn](val);
        };
        return NumberT;
    }();
    exports.Number = NumberT;
    exports.uint8 = new NumberT('UInt8');
    exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');
    exports.uint16le = new NumberT('UInt16', 'LE');
    exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');
    exports.uint24le = new NumberT('UInt24', 'LE');
    exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');
    exports.uint32le = new NumberT('UInt32', 'LE');
    exports.int8 = new NumberT('Int8');
    exports.int16be = exports.int16 = new NumberT('Int16', 'BE');
    exports.int16le = new NumberT('Int16', 'LE');
    exports.int24be = exports.int24 = new NumberT('Int24', 'BE');
    exports.int24le = new NumberT('Int24', 'LE');
    exports.int32be = exports.int32 = new NumberT('Int32', 'BE');
    exports.int32le = new NumberT('Int32', 'LE');
    exports.floatbe = exports.float = new NumberT('Float', 'BE');
    exports.floatle = new NumberT('Float', 'LE');
    exports.doublebe = exports.double = new NumberT('Double', 'BE');
    exports.doublele = new NumberT('Double', 'LE');
    Fixed = function(_super) {
        __extends(Fixed, _super);
        function Fixed(size, endian, fracBits) {
            if (fracBits == null) fracBits = size >> 1;
            Fixed.__super__.constructor.call(this, "Int" + size, endian);
            this._point = 1 << fracBits;
        }
        Fixed.prototype.decode = function(stream) {
            return Fixed.__super__.decode.call(this, stream) / this._point;
        };
        Fixed.prototype.encode = function(stream, val) {
            return Fixed.__super__.encode.call(this, stream, val * this._point | 0);
        };
        return Fixed;
    }(NumberT);
    exports.Fixed = Fixed;
    exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');
    exports.fixed16le = new Fixed(16, 'LE');
    exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');
    exports.fixed32le = new Fixed(32, 'LE');
}).call(this);

},{"b4467568ff03b9c6":"hQenQ"}],"4jpsW":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var NumberT, PropertyDescriptor;
    NumberT = require("a22ec85ed556001f").Number;
    exports.resolveLength = function(length, stream, parent) {
        var res;
        if (typeof length === 'number') res = length;
        else if (typeof length === 'function') res = length.call(parent, parent);
        else if (parent && typeof length === 'string') res = parent[length];
        else if (stream && length instanceof NumberT) res = length.decode(stream);
        if (isNaN(res)) throw new Error('Not a fixed size');
        return res;
    };
    PropertyDescriptor = function() {
        function PropertyDescriptor(opts) {
            var key, val;
            if (opts == null) opts = {};
            this.enumerable = true;
            this.configurable = true;
            for(key in opts){
                val = opts[key];
                this[key] = val;
            }
        }
        return PropertyDescriptor;
    }();
    exports.PropertyDescriptor = PropertyDescriptor;
}).call(this);

},{"a22ec85ed556001f":"5m1Sl"}],"eu4TE":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var ArrayT, LazyArray, LazyArrayT, NumberT, inspect, utils, __hasProp = {}.hasOwnProperty, __extends = function(child, parent) {
        for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    };
    ArrayT = require("a067c1aff17cc65a");
    NumberT = require("d165121ddba421f4").Number;
    utils = require("4182e151c9c51548");
    inspect = require("b3acf1a38f38d6a").inspect;
    LazyArrayT = function(_super) {
        __extends(LazyArrayT, _super);
        function LazyArrayT() {
            return LazyArrayT.__super__.constructor.apply(this, arguments);
        }
        LazyArrayT.prototype.decode = function(stream, parent) {
            var length, pos, res;
            pos = stream.pos;
            length = utils.resolveLength(this.length, stream, parent);
            if (this.length instanceof NumberT) parent = {
                parent: parent,
                _startOffset: pos,
                _currentOffset: 0,
                _length: length
            };
            res = new LazyArray(this.type, length, stream, parent);
            stream.pos += length * this.type.size(null, parent);
            return res;
        };
        LazyArrayT.prototype.size = function(val, ctx) {
            if (val instanceof LazyArray) val = val.toArray();
            return LazyArrayT.__super__.size.call(this, val, ctx);
        };
        LazyArrayT.prototype.encode = function(stream, val, ctx) {
            if (val instanceof LazyArray) val = val.toArray();
            return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
        };
        return LazyArrayT;
    }(ArrayT);
    LazyArray = function() {
        function LazyArray(type, length, stream, ctx) {
            this.type = type;
            this.length = length;
            this.stream = stream;
            this.ctx = ctx;
            this.base = this.stream.pos;
            this.items = [];
        }
        LazyArray.prototype.get = function(index) {
            var pos;
            if (index < 0 || index >= this.length) return void 0;
            if (this.items[index] == null) {
                pos = this.stream.pos;
                this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
                this.items[index] = this.type.decode(this.stream, this.ctx);
                this.stream.pos = pos;
            }
            return this.items[index];
        };
        LazyArray.prototype.toArray = function() {
            var i, _i, _ref, _results;
            _results = [];
            for(i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1)_results.push(this.get(i));
            return _results;
        };
        LazyArray.prototype.inspect = function() {
            return inspect(this.toArray());
        };
        return LazyArray;
    }();
    module.exports = LazyArrayT;
}).call(this);

},{"a067c1aff17cc65a":"eyY9t","d165121ddba421f4":"5m1Sl","4182e151c9c51548":"4jpsW","b3acf1a38f38d6a":"6Hf8s"}],"3eBjz":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var Bitfield;
    Bitfield = function() {
        function Bitfield(type, flags) {
            this.type = type;
            this.flags = flags != null ? flags : [];
        }
        Bitfield.prototype.decode = function(stream) {
            var flag, i, res, val, _i, _len, _ref;
            val = this.type.decode(stream);
            res = {};
            _ref = this.flags;
            for(i = _i = 0, _len = _ref.length; _i < _len; i = ++_i){
                flag = _ref[i];
                if (flag != null) res[flag] = !!(val & 1 << i);
            }
            return res;
        };
        Bitfield.prototype.size = function() {
            return this.type.size();
        };
        Bitfield.prototype.encode = function(stream, keys) {
            var flag, i, val, _i, _len, _ref;
            val = 0;
            _ref = this.flags;
            for(i = _i = 0, _len = _ref.length; _i < _len; i = ++_i){
                flag = _ref[i];
                if (flag != null) {
                    if (keys[flag]) val |= 1 << i;
                }
            }
            return this.type.encode(stream, val);
        };
        return Bitfield;
    }();
    module.exports = Bitfield;
}).call(this);

},{}],"99TnW":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var BooleanT;
    BooleanT = function() {
        function BooleanT(type) {
            this.type = type;
        }
        BooleanT.prototype.decode = function(stream, parent) {
            return !!this.type.decode(stream, parent);
        };
        BooleanT.prototype.size = function(val, parent) {
            return this.type.size(val, parent);
        };
        BooleanT.prototype.encode = function(stream, val, parent) {
            return this.type.encode(stream, +val, parent);
        };
        return BooleanT;
    }();
    module.exports = BooleanT;
}).call(this);

},{}],"jeGFD":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var BufferT, NumberT, utils;
    utils = require("67d4fd9b71f7f86d");
    NumberT = require("3e2780fab105a8e1").Number;
    BufferT = function() {
        function BufferT(length) {
            this.length = length;
        }
        BufferT.prototype.decode = function(stream, parent) {
            var length;
            length = utils.resolveLength(this.length, stream, parent);
            return stream.readBuffer(length);
        };
        BufferT.prototype.size = function(val, parent) {
            if (!val) return utils.resolveLength(this.length, null, parent);
            return val.length;
        };
        BufferT.prototype.encode = function(stream, buf, parent) {
            if (this.length instanceof NumberT) this.length.encode(stream, buf.length);
            return stream.writeBuffer(buf);
        };
        return BufferT;
    }();
    module.exports = BufferT;
}).call(this);

},{"67d4fd9b71f7f86d":"4jpsW","3e2780fab105a8e1":"5m1Sl"}],"7LRHI":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var Enum;
    Enum = function() {
        function Enum(type, options) {
            this.type = type;
            this.options = options != null ? options : [];
        }
        Enum.prototype.decode = function(stream) {
            var index;
            index = this.type.decode(stream);
            return this.options[index] || index;
        };
        Enum.prototype.size = function() {
            return this.type.size();
        };
        Enum.prototype.encode = function(stream, val) {
            var index;
            index = this.options.indexOf(val);
            if (index === -1) throw new Error("Unknown option in enum: " + val);
            return this.type.encode(stream, index);
        };
        return Enum;
    }();
    module.exports = Enum;
}).call(this);

},{}],"aPp9g":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var Optional;
    Optional = function() {
        function Optional(type, condition) {
            this.type = type;
            this.condition = condition != null ? condition : true;
        }
        Optional.prototype.decode = function(stream, parent) {
            var condition;
            condition = this.condition;
            if (typeof condition === 'function') condition = condition.call(parent, parent);
            if (condition) return this.type.decode(stream, parent);
        };
        Optional.prototype.size = function(val, parent) {
            var condition;
            condition = this.condition;
            if (typeof condition === 'function') condition = condition.call(parent, parent);
            if (condition) return this.type.size(val, parent);
            else return 0;
        };
        Optional.prototype.encode = function(stream, val, parent) {
            var condition;
            condition = this.condition;
            if (typeof condition === 'function') condition = condition.call(parent, parent);
            if (condition) return this.type.encode(stream, val, parent);
        };
        return Optional;
    }();
    module.exports = Optional;
}).call(this);

},{}],"dXdPo":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var Reserved, utils;
    utils = require("2656bb0888d30719");
    Reserved = function() {
        function Reserved(type, count) {
            this.type = type;
            this.count = count != null ? count : 1;
        }
        Reserved.prototype.decode = function(stream, parent) {
            stream.pos += this.size(null, parent);
            return void 0;
        };
        Reserved.prototype.size = function(data, parent) {
            var count;
            count = utils.resolveLength(this.count, null, parent);
            return this.type.size() * count;
        };
        Reserved.prototype.encode = function(stream, val, parent) {
            return stream.fill(0, this.size(val, parent));
        };
        return Reserved;
    }();
    module.exports = Reserved;
}).call(this);

},{"2656bb0888d30719":"4jpsW"}],"5IfYV":[function(require,module,exports,__globalThis) {
var Buffer = require("47346a4f410ec3da").Buffer;
// Generated by CoffeeScript 1.7.1
(function() {
    var NumberT, StringT, utils;
    NumberT = require("f997656c3259efb9").Number;
    utils = require("a771dc335886056");
    StringT = function() {
        function StringT(length, encoding) {
            this.length = length;
            this.encoding = encoding != null ? encoding : 'ascii';
        }
        StringT.prototype.decode = function(stream, parent) {
            var buffer, encoding, length, pos, string;
            length = (function() {
                if (this.length != null) return utils.resolveLength(this.length, stream, parent);
                else {
                    buffer = stream.buffer, length = stream.length, pos = stream.pos;
                    while(pos < length && buffer[pos] !== 0x00)++pos;
                    return pos - stream.pos;
                }
            }).call(this);
            encoding = this.encoding;
            if (typeof encoding === 'function') encoding = encoding.call(parent, parent) || 'ascii';
            string = stream.readString(length, encoding);
            if (this.length == null && stream.pos < stream.length) stream.pos++;
            return string;
        };
        StringT.prototype.size = function(val, parent) {
            var encoding, size;
            if (!val) return utils.resolveLength(this.length, null, parent);
            encoding = this.encoding;
            if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
            if (encoding === 'utf16be') encoding = 'utf16le';
            size = Buffer.byteLength(val, encoding);
            if (this.length instanceof NumberT) size += this.length.size();
            if (this.length == null) size++;
            return size;
        };
        StringT.prototype.encode = function(stream, val, parent) {
            var encoding;
            encoding = this.encoding;
            if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
            if (this.length instanceof NumberT) this.length.encode(stream, Buffer.byteLength(val, encoding));
            stream.writeString(val, encoding);
            if (this.length == null) return stream.writeUInt8(0x00);
        };
        return StringT;
    }();
    module.exports = StringT;
}).call(this);

},{"47346a4f410ec3da":"dB11O","f997656c3259efb9":"5m1Sl","a771dc335886056":"4jpsW"}],"3BHoc":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var Struct, utils;
    utils = require("d5b78a9314c52757");
    Struct = function() {
        function Struct(fields) {
            this.fields = fields != null ? fields : {};
        }
        Struct.prototype.decode = function(stream, parent, length) {
            var res, _ref;
            if (length == null) length = 0;
            res = this._setup(stream, parent, length);
            this._parseFields(stream, res, this.fields);
            if ((_ref = this.process) != null) _ref.call(res, stream);
            return res;
        };
        Struct.prototype._setup = function(stream, parent, length) {
            var res;
            res = {};
            Object.defineProperties(res, {
                parent: {
                    value: parent
                },
                _startOffset: {
                    value: stream.pos
                },
                _currentOffset: {
                    value: 0,
                    writable: true
                },
                _length: {
                    value: length
                }
            });
            return res;
        };
        Struct.prototype._parseFields = function(stream, res, fields) {
            var key, type, val;
            for(key in fields){
                type = fields[key];
                if (typeof type === 'function') val = type.call(res, res);
                else val = type.decode(stream, res);
                if (val !== void 0) {
                    if (val instanceof utils.PropertyDescriptor) Object.defineProperty(res, key, val);
                    else res[key] = val;
                }
                res._currentOffset = stream.pos - res._startOffset;
            }
        };
        Struct.prototype.size = function(val, parent, includePointers) {
            var ctx, key, size, type, _ref;
            if (val == null) val = {};
            if (includePointers == null) includePointers = true;
            ctx = {
                parent: parent,
                val: val,
                pointerSize: 0
            };
            size = 0;
            _ref = this.fields;
            for(key in _ref){
                type = _ref[key];
                if (type.size != null) size += type.size(val[key], ctx);
            }
            if (includePointers) size += ctx.pointerSize;
            return size;
        };
        Struct.prototype.encode = function(stream, val, parent) {
            var ctx, i, key, ptr, type, _ref, _ref1;
            if ((_ref = this.preEncode) != null) _ref.call(val, stream);
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent: parent,
                val: val,
                pointerSize: 0
            };
            ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
            _ref1 = this.fields;
            for(key in _ref1){
                type = _ref1[key];
                if (type.encode != null) type.encode(stream, val[key], ctx);
            }
            i = 0;
            while(i < ctx.pointers.length){
                ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        };
        return Struct;
    }();
    module.exports = Struct;
}).call(this);

},{"d5b78a9314c52757":"4jpsW"}],"5MQvJ":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var Struct, VersionedStruct, __hasProp = {}.hasOwnProperty, __extends = function(child, parent) {
        for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
    };
    Struct = require("c2258464ae2b0e13");
    VersionedStruct = function(_super) {
        __extends(VersionedStruct, _super);
        function VersionedStruct(type, versions) {
            this.type = type;
            this.versions = versions != null ? versions : {};
            if (typeof this.type === 'string') {
                this.versionGetter = new Function('parent', "return parent." + this.type);
                this.versionSetter = new Function('parent', 'version', "return parent." + this.type + " = version");
            }
        }
        VersionedStruct.prototype.decode = function(stream, parent, length) {
            var fields, res, _ref;
            if (length == null) length = 0;
            res = this._setup(stream, parent, length);
            if (typeof this.type === 'string') res.version = this.versionGetter(parent);
            else res.version = this.type.decode(stream);
            if (this.versions.header) this._parseFields(stream, res, this.versions.header);
            fields = this.versions[res.version];
            if (fields == null) throw new Error("Unknown version " + res.version);
            if (fields instanceof VersionedStruct) return fields.decode(stream, parent);
            this._parseFields(stream, res, fields);
            if ((_ref = this.process) != null) _ref.call(res, stream);
            return res;
        };
        VersionedStruct.prototype.size = function(val, parent, includePointers) {
            var ctx, fields, key, size, type, _ref;
            if (includePointers == null) includePointers = true;
            if (!val) throw new Error('Not a fixed size');
            ctx = {
                parent: parent,
                val: val,
                pointerSize: 0
            };
            size = 0;
            if (typeof this.type !== 'string') size += this.type.size(val.version, ctx);
            if (this.versions.header) {
                _ref = this.versions.header;
                for(key in _ref){
                    type = _ref[key];
                    if (type.size != null) size += type.size(val[key], ctx);
                }
            }
            fields = this.versions[val.version];
            if (fields == null) throw new Error("Unknown version " + val.version);
            for(key in fields){
                type = fields[key];
                if (type.size != null) size += type.size(val[key], ctx);
            }
            if (includePointers) size += ctx.pointerSize;
            return size;
        };
        VersionedStruct.prototype.encode = function(stream, val, parent) {
            var ctx, fields, i, key, ptr, type, _ref, _ref1;
            if ((_ref = this.preEncode) != null) _ref.call(val, stream);
            ctx = {
                pointers: [],
                startOffset: stream.pos,
                parent: parent,
                val: val,
                pointerSize: 0
            };
            ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
            if (typeof this.type !== 'string') this.type.encode(stream, val.version);
            if (this.versions.header) {
                _ref1 = this.versions.header;
                for(key in _ref1){
                    type = _ref1[key];
                    if (type.encode != null) type.encode(stream, val[key], ctx);
                }
            }
            fields = this.versions[val.version];
            for(key in fields){
                type = fields[key];
                if (type.encode != null) type.encode(stream, val[key], ctx);
            }
            i = 0;
            while(i < ctx.pointers.length){
                ptr = ctx.pointers[i++];
                ptr.type.encode(stream, ptr.val, ptr.parent);
            }
        };
        return VersionedStruct;
    }(Struct);
    module.exports = VersionedStruct;
}).call(this);

},{"c2258464ae2b0e13":"3BHoc"}],"7Tss7":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
(function() {
    var Pointer, VoidPointer, utils;
    utils = require("543244339f86f371");
    Pointer = function() {
        function Pointer(offsetType, type, options) {
            var _base, _base1, _base2, _base3;
            this.offsetType = offsetType;
            this.type = type;
            this.options = options != null ? options : {};
            if (this.type === 'void') this.type = null;
            if ((_base = this.options).type == null) _base.type = 'local';
            if ((_base1 = this.options).allowNull == null) _base1.allowNull = true;
            if ((_base2 = this.options).nullValue == null) _base2.nullValue = 0;
            if ((_base3 = this.options).lazy == null) _base3.lazy = false;
            if (this.options.relativeTo) this.relativeToGetter = new Function('ctx', "return ctx." + this.options.relativeTo);
        }
        Pointer.prototype.decode = function(stream, ctx) {
            var c, decodeValue, offset, ptr, relative, val;
            offset = this.offsetType.decode(stream, ctx);
            if (offset === this.options.nullValue && this.options.allowNull) return null;
            relative = (function() {
                switch(this.options.type){
                    case 'local':
                        return ctx._startOffset;
                    case 'immediate':
                        return stream.pos - this.offsetType.size();
                    case 'parent':
                        return ctx.parent._startOffset;
                    default:
                        c = ctx;
                        while(c.parent)c = c.parent;
                        return c._startOffset || 0;
                }
            }).call(this);
            if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
            ptr = offset + relative;
            if (this.type != null) {
                val = null;
                decodeValue = function(_this) {
                    return function() {
                        var pos;
                        if (val != null) return val;
                        pos = stream.pos;
                        stream.pos = ptr;
                        val = _this.type.decode(stream, ctx);
                        stream.pos = pos;
                        return val;
                    };
                }(this);
                if (this.options.lazy) return new utils.PropertyDescriptor({
                    get: decodeValue
                });
                return decodeValue();
            } else return ptr;
        };
        Pointer.prototype.size = function(val, ctx) {
            var parent, type;
            parent = ctx;
            switch(this.options.type){
                case 'local':
                case 'immediate':
                    break;
                case 'parent':
                    ctx = ctx.parent;
                    break;
                default:
                    while(ctx.parent)ctx = ctx.parent;
            }
            type = this.type;
            if (type == null) {
                if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                type = val.type;
                val = val.value;
            }
            if (val && ctx) ctx.pointerSize += type.size(val, parent);
            return this.offsetType.size();
        };
        Pointer.prototype.encode = function(stream, val, ctx) {
            var parent, relative, type;
            parent = ctx;
            if (val == null) {
                this.offsetType.encode(stream, this.options.nullValue);
                return;
            }
            switch(this.options.type){
                case 'local':
                    relative = ctx.startOffset;
                    break;
                case 'immediate':
                    relative = stream.pos + this.offsetType.size(val, parent);
                    break;
                case 'parent':
                    ctx = ctx.parent;
                    relative = ctx.startOffset;
                    break;
                default:
                    relative = 0;
                    while(ctx.parent)ctx = ctx.parent;
            }
            if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
            this.offsetType.encode(stream, ctx.pointerOffset - relative);
            type = this.type;
            if (type == null) {
                if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                type = val.type;
                val = val.value;
            }
            ctx.pointers.push({
                type: type,
                val: val,
                parent: parent
            });
            return ctx.pointerOffset += type.size(val, parent);
        };
        return Pointer;
    }();
    VoidPointer = function() {
        function VoidPointer(type, value) {
            this.type = type;
            this.value = value;
        }
        return VoidPointer;
    }();
    exports.Pointer = Pointer;
    exports.VoidPointer = VoidPointer;
}).call(this);

},{"543244339f86f371":"4jpsW"}],"itgDl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCategory", ()=>getCategory);
parcelHelpers.export(exports, "getCombiningClass", ()=>getCombiningClass);
parcelHelpers.export(exports, "getScript", ()=>getScript);
parcelHelpers.export(exports, "getEastAsianWidth", ()=>getEastAsianWidth);
parcelHelpers.export(exports, "getNumericValue", ()=>getNumericValue);
parcelHelpers.export(exports, "isAlphabetic", ()=>isAlphabetic);
parcelHelpers.export(exports, "isDigit", ()=>isDigit);
parcelHelpers.export(exports, "isPunctuation", ()=>isPunctuation);
parcelHelpers.export(exports, "isLowerCase", ()=>isLowerCase);
parcelHelpers.export(exports, "isUpperCase", ()=>isUpperCase);
parcelHelpers.export(exports, "isTitleCase", ()=>isTitleCase);
parcelHelpers.export(exports, "isWhiteSpace", ()=>isWhiteSpace);
parcelHelpers.export(exports, "isBaseForm", ()=>isBaseForm);
parcelHelpers.export(exports, "isMark", ()=>isMark);
var UnicodeTrie = require("7d073bd0a2616813");
var data = require("fa521c5375cb66d");
var trieBuffer = require("5b1dbbc00810021");
// Trie is serialized as a Buffer in node, but here
// we may be running in a browser so we make an Uint8Array
var trieData = new Uint8Array(trieBuffer.data);
var trie = new UnicodeTrie(trieData);
var log2 = Math.log2 || function(n) {
    return Math.log(n) / Math.LN2;
};
var bits = function bits(n) {
    return log2(n) + 1 | 0;
};
// compute the number of bits stored for each field
var CATEGORY_BITS = bits(data.categories.length - 1);
var COMBINING_BITS = bits(data.combiningClasses.length - 1);
var SCRIPT_BITS = bits(data.scripts.length - 1);
var EAW_BITS = bits(data.eaw.length - 1);
var NUMBER_BITS = 10;
// compute shift and mask values for each field
var CATEGORY_SHIFT = COMBINING_BITS + SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
var COMBINING_SHIFT = SCRIPT_BITS + EAW_BITS + NUMBER_BITS;
var SCRIPT_SHIFT = EAW_BITS + NUMBER_BITS;
var EAW_SHIFT = NUMBER_BITS;
var CATEGORY_MASK = (1 << CATEGORY_BITS) - 1;
var COMBINING_MASK = (1 << COMBINING_BITS) - 1;
var SCRIPT_MASK = (1 << SCRIPT_BITS) - 1;
var EAW_MASK = (1 << EAW_BITS) - 1;
var NUMBER_MASK = (1 << NUMBER_BITS) - 1;
var getCategory = function getCategory(codePoint) {
    var val = trie.get(codePoint);
    return data.categories[val >> CATEGORY_SHIFT & CATEGORY_MASK];
};
var getCombiningClass = function getCombiningClass(codePoint) {
    var val = trie.get(codePoint);
    return data.combiningClasses[val >> COMBINING_SHIFT & COMBINING_MASK];
};
var getScript = function getScript(codePoint) {
    var val = trie.get(codePoint);
    return data.scripts[val >> SCRIPT_SHIFT & SCRIPT_MASK];
};
var getEastAsianWidth = function getEastAsianWidth(codePoint) {
    var val = trie.get(codePoint);
    return data.eaw[val >> EAW_SHIFT & EAW_MASK];
};
var getNumericValue = function getNumericValue(codePoint) {
    var val = trie.get(codePoint);
    var num = val & NUMBER_MASK;
    if (num === 0) return null;
    else if (num <= 50) return num - 1;
    else if (num < 0x1e0) {
        var numerator = (num >> 4) - 12;
        var denominator = (num & 0xf) + 1;
        return numerator / denominator;
    } else if (num < 0x300) {
        val = (num >> 5) - 14;
        var exp = (num & 0x1f) + 2;
        while(exp > 0){
            val *= 10;
            exp--;
        }
        return val;
    } else {
        val = (num >> 2) - 0xbf;
        var _exp = (num & 3) + 1;
        while(_exp > 0){
            val *= 60;
            _exp--;
        }
        return val;
    }
};
var isAlphabetic = function isAlphabetic(codePoint) {
    var category = getCategory(codePoint);
    return category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Nl';
};
var isDigit = function isDigit(codePoint) {
    return getCategory(codePoint) === 'Nd';
};
var isPunctuation = function isPunctuation(codePoint) {
    var category = getCategory(codePoint);
    return category === 'Pc' || category === 'Pd' || category === 'Pe' || category === 'Pf' || category === 'Pi' || category === 'Po' || category === 'Ps';
};
var isLowerCase = function isLowerCase(codePoint) {
    return getCategory(codePoint) === 'Ll';
};
var isUpperCase = function isUpperCase(codePoint) {
    return getCategory(codePoint) === 'Lu';
};
var isTitleCase = function isTitleCase(codePoint) {
    return getCategory(codePoint) === 'Lt';
};
var isWhiteSpace = function isWhiteSpace(codePoint) {
    var category = getCategory(codePoint);
    return category === 'Zs' || category === 'Zl' || category === 'Zp';
};
var isBaseForm = function isBaseForm(codePoint) {
    var category = getCategory(codePoint);
    return category === 'Nd' || category === 'No' || category === 'Nl' || category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Me' || category === 'Mc';
};
var isMark = function isMark(codePoint) {
    var category = getCategory(codePoint);
    return category === 'Mn' || category === 'Me' || category === 'Mc';
};
var index = {
    getCategory: getCategory,
    getCombiningClass: getCombiningClass,
    getScript: getScript,
    getEastAsianWidth: getEastAsianWidth,
    getNumericValue: getNumericValue,
    isAlphabetic: isAlphabetic,
    isDigit: isDigit,
    isPunctuation: isPunctuation,
    isLowerCase: isLowerCase,
    isUpperCase: isUpperCase,
    isTitleCase: isTitleCase,
    isWhiteSpace: isWhiteSpace,
    isBaseForm: isBaseForm,
    isMark: isMark
};
exports.default = index;

},{"7d073bd0a2616813":"fU8wQ","fa521c5375cb66d":"kDyHk","5b1dbbc00810021":"jrG09","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fU8wQ":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.7.1
var UnicodeTrie, inflate;
inflate = require("8ae222e01e363bff");
UnicodeTrie = function() {
    var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;
    SHIFT_1 = 11;
    SHIFT_2 = 5;
    SHIFT_1_2 = SHIFT_1 - SHIFT_2;
    OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
    INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
    INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
    INDEX_SHIFT = 2;
    DATA_BLOCK_LENGTH = 1 << SHIFT_2;
    DATA_MASK = DATA_BLOCK_LENGTH - 1;
    LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
    LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
    INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
    UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
    UTF8_2B_INDEX_2_LENGTH = 32;
    INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
    DATA_GRANULARITY = 1 << INDEX_SHIFT;
    function UnicodeTrie(data) {
        var isBuffer, uncompressedLength, view;
        isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
        if (isBuffer || data instanceof Uint8Array) {
            if (isBuffer) {
                this.highStart = data.readUInt32BE(0);
                this.errorValue = data.readUInt32BE(4);
                uncompressedLength = data.readUInt32BE(8);
                data = data.slice(12);
            } else {
                view = new DataView(data.buffer);
                this.highStart = view.getUint32(0);
                this.errorValue = view.getUint32(4);
                uncompressedLength = view.getUint32(8);
                data = data.subarray(12);
            }
            data = inflate(data, new Uint8Array(uncompressedLength));
            data = inflate(data, new Uint8Array(uncompressedLength));
            this.data = new Uint32Array(data.buffer);
        } else this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
    }
    UnicodeTrie.prototype.get = function(codePoint) {
        var index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
            index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
            index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - DATA_GRANULARITY];
    };
    return UnicodeTrie;
}();
module.exports = UnicodeTrie;

},{"8ae222e01e363bff":"2G0sR"}],"2G0sR":[function(require,module,exports,__globalThis) {
var TINF_OK = 0;
var TINF_DATA_ERROR = -3;
function Tree() {
    this.table = new Uint16Array(16); /* table of code length counts */ 
    this.trans = new Uint16Array(288); /* code -> symbol translation table */ 
}
function Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new Tree(); /* dynamic length/symbol tree */ 
    this.dtree = new Tree(); /* dynamic distance tree */ 
}
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var sltree = new Tree();
var sdtree = new Tree();
/* extra bits and base tables for length codes */ var length_bits = new Uint8Array(30);
var length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var dist_bits = new Uint8Array(30);
var dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var code_tree = new Tree();
var lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var offs = new Uint16Array(16);
function tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = tinf_read_bits(d, 3, 0);
        lengths[clcidx[i]] = clen;
    }
    /* build code length tree */ tinf_build_tree(code_tree, lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = tinf_decode_symbol(d, code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = lengths[num - 1];
                for(length = tinf_read_bits(d, 2, 3); length; --length)lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = tinf_read_bits(d, 3, 3); length; --length)lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = tinf_read_bits(d, 7, 11); length; --length)lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ tinf_build_tree(lt, lengths, 0, hlit);
    tinf_build_tree(dt, lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = tinf_read_bits(d, length_bits[sym], length_base[sym]);
            dist = tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return TINF_OK;
}
/* inflate stream from source to dest */ function tinf_uncompress(source, dest) {
    var d = new Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = tinf_getbit(d);
        /* read block type (2 bits) */ btype = tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = tinf_inflate_block_data(d, sltree, sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ tinf_decode_trees(d, d.ltree, d.dtree);
                res = tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = TINF_DATA_ERROR;
        }
        if (res !== TINF_OK) throw new Error('Data error');
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ tinf_build_fixed_trees(sltree, sdtree);
/* build extra bits and base tables */ tinf_build_bits_base(length_bits, length_base, 4, 3);
tinf_build_bits_base(dist_bits, dist_base, 2, 1);
/* fix a special case */ length_bits[28] = 0;
length_base[28] = 258;
module.exports = tinf_uncompress;

},{}],"kDyHk":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"categories\":[\"Cc\",\"Zs\",\"Po\",\"Sc\",\"Ps\",\"Pe\",\"Sm\",\"Pd\",\"Nd\",\"Lu\",\"Sk\",\"Pc\",\"Ll\",\"So\",\"Lo\",\"Pi\",\"Cf\",\"No\",\"Pf\",\"Lt\",\"Lm\",\"Mn\",\"Me\",\"Mc\",\"Nl\",\"Zl\",\"Zp\",\"Cs\",\"Co\"],\"combiningClasses\":[\"Not_Reordered\",\"Above\",\"Above_Right\",\"Below\",\"Attached_Above_Right\",\"Attached_Below\",\"Overlay\",\"Iota_Subscript\",\"Double_Below\",\"Double_Above\",\"Below_Right\",\"Above_Left\",\"CCC10\",\"CCC11\",\"CCC12\",\"CCC13\",\"CCC14\",\"CCC15\",\"CCC16\",\"CCC17\",\"CCC18\",\"CCC19\",\"CCC20\",\"CCC21\",\"CCC22\",\"CCC23\",\"CCC24\",\"CCC25\",\"CCC30\",\"CCC31\",\"CCC32\",\"CCC27\",\"CCC28\",\"CCC29\",\"CCC33\",\"CCC34\",\"CCC35\",\"CCC36\",\"Nukta\",\"Virama\",\"CCC84\",\"CCC91\",\"CCC103\",\"CCC107\",\"CCC118\",\"CCC122\",\"CCC129\",\"CCC130\",\"CCC132\",\"Attached_Above\",\"Below_Left\",\"Left\",\"Kana_Voicing\",\"CCC26\",\"Right\"],\"scripts\":[\"Common\",\"Latin\",\"Bopomofo\",\"Inherited\",\"Greek\",\"Coptic\",\"Cyrillic\",\"Armenian\",\"Hebrew\",\"Arabic\",\"Syriac\",\"Thaana\",\"Nko\",\"Samaritan\",\"Mandaic\",\"Devanagari\",\"Bengali\",\"Gurmukhi\",\"Gujarati\",\"Oriya\",\"Tamil\",\"Telugu\",\"Kannada\",\"Malayalam\",\"Sinhala\",\"Thai\",\"Lao\",\"Tibetan\",\"Myanmar\",\"Georgian\",\"Hangul\",\"Ethiopic\",\"Cherokee\",\"Canadian_Aboriginal\",\"Ogham\",\"Runic\",\"Tagalog\",\"Hanunoo\",\"Buhid\",\"Tagbanwa\",\"Khmer\",\"Mongolian\",\"Limbu\",\"Tai_Le\",\"New_Tai_Lue\",\"Buginese\",\"Tai_Tham\",\"Balinese\",\"Sundanese\",\"Batak\",\"Lepcha\",\"Ol_Chiki\",\"Braille\",\"Glagolitic\",\"Tifinagh\",\"Han\",\"Hiragana\",\"Katakana\",\"Yi\",\"Lisu\",\"Vai\",\"Bamum\",\"Syloti_Nagri\",\"Phags_Pa\",\"Saurashtra\",\"Kayah_Li\",\"Rejang\",\"Javanese\",\"Cham\",\"Tai_Viet\",\"Meetei_Mayek\",\"null\",\"Linear_B\",\"Lycian\",\"Carian\",\"Old_Italic\",\"Gothic\",\"Old_Permic\",\"Ugaritic\",\"Old_Persian\",\"Deseret\",\"Shavian\",\"Osmanya\",\"Elbasan\",\"Caucasian_Albanian\",\"Linear_A\",\"Cypriot\",\"Imperial_Aramaic\",\"Palmyrene\",\"Nabataean\",\"Hatran\",\"Phoenician\",\"Lydian\",\"Meroitic_Hieroglyphs\",\"Meroitic_Cursive\",\"Kharoshthi\",\"Old_South_Arabian\",\"Old_North_Arabian\",\"Manichaean\",\"Avestan\",\"Inscriptional_Parthian\",\"Inscriptional_Pahlavi\",\"Psalter_Pahlavi\",\"Old_Turkic\",\"Old_Hungarian\",\"Brahmi\",\"Kaithi\",\"Sora_Sompeng\",\"Chakma\",\"Mahajani\",\"Sharada\",\"Khojki\",\"Multani\",\"Khudawadi\",\"Grantha\",\"Tirhuta\",\"Siddham\",\"Modi\",\"Takri\",\"Ahom\",\"Warang_Citi\",\"Pau_Cin_Hau\",\"Cuneiform\",\"Egyptian_Hieroglyphs\",\"Anatolian_Hieroglyphs\",\"Mro\",\"Bassa_Vah\",\"Pahawh_Hmong\",\"Miao\",\"Duployan\",\"SignWriting\",\"Mende_Kikakui\"],\"eaw\":[\"N\",\"Na\",\"A\",\"W\",\"H\",\"F\"]}");

},{}],"jrG09":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"type\":\"Buffer\",\"data\":[0,17,0,0,0,0,0,0,0,1,80,112,93,120,119,32,155,251,251,246,233,113,74,135,113,104,81,177,142,170,90,13,85,123,159,82,171,54,181,106,132,170,218,35,212,14,122,170,181,73,171,106,212,136,77,91,132,90,49,83,51,173,21,123,5,65,106,70,132,134,132,32,121,251,253,125,223,95,123,222,247,191,231,121,254,120,62,247,231,30,215,117,221,23,97,241,114,195,13,55,151,229,253,237,208,96,116,148,156,44,119,160,240,229,9,134,98,238,151,97,251,203,96,8,225,32,1,218,198,68,86,186,248,164,71,226,137,87,216,99,213,127,122,167,251,56,65,134,232,191,31,229,6,179,0,166,11,193,218,108,8,3,83,68,143,22,235,77,99,174,50,166,212,213,231,221,74,128,189,96,63,236,185,63,98,19,164,254,172,231,253,186,131,252,208,185,77,251,208,90,112,246,161,63,8,169,140,60,254,208,73,161,88,89,133,6,99,35,219,84,197,117,194,249,52,187,52,239,26,75,222,103,79,22,115,185,56,56,155,118,199,186,246,50,247,223,61,254,43,148,61,216,30,172,142,91,176,11,181,47,190,131,58,183,16,167,26,112,1,212,231,2,225,197,31,9,21,244,214,135,177,230,164,20,15,173,134,241,197,131,250,191,134,177,143,124,158,11,3,46,61,35,237,89,59,36,24,238,97,194,184,107,62,51,129,89,52,146,240,123,60,16,174,143,8,254,208,85,67,4,183,94,97,169,49,150,19,195,118,69,243,31,209,253,91,5,218,55,63,138,229,214,158,23,93,125,144,151,86,191,39,177,211,155,187,207,117,202,24,130,179,56,149,90,138,101,91,161,236,131,192,252,26,177,188,251,89,71,146,167,192,121,4,19,219,178,16,68,16,186,106,160,150,12,19,206,183,204,224,185,229,204,94,150,167,188,46,178,234,230,195,125,226,182,202,185,211,13,199,241,35,254,200,74,62,149,76,192,66,163,142,180,33,191,195,250,163,79,217,248,50,32,35,125,27,47,165,147,142,156,248,186,217,235,98,144,9,200,212,224,211,63,53,57,11,186,208,251,11,9,55,172,116,196,157,235,107,19,56,50,107,83,8,98,56,190,188,100,210,126,136,67,202,224,94,219,163,19,245,15,115,75,39,9,148,85,225,35,37,141,68,205,30,99,165,103,152,0,38,214,21,67,4,27,182,151,50,185,212,114,112,1,3,93,17,63,101,70,189,26,148,28,80,51,249,252,85,137,197,125,117,7,2,95,242,158,139,102,24,233,57,62,10,61,50,118,72,26,4,159,95,202,82,132,107,206,57,233,205,235,205,210,149,52,94,158,41,61,139,61,226,211,128,34,123,102,246,128,255,247,82,27,175,196,3,128,171,97,121,47,38,2,110,142,244,123,7,176,142,244,29,135,169,74,245,19,151,23,187,79,234,216,144,80,205,207,168,61,236,158,231,130,216,56,253,247,152,52,122,34,178,155,191,219,113,156,108,19,32,157,182,220,22,118,205,116,217,115,172,159,174,29,248,166,248,241,75,229,188,218,175,67,170,57,71,58,74,12,238,201,13,51,28,176,216,32,134,246,54,231,208,78,253,72,222,125,129,44,136,104,7,28,91,238,192,73,236,139,15,144,167,93,174,233,59,60,34,206,66,25,16,198,227,90,188,160,174,14,165,20,127,87,199,35,161,232,36,122,114,111,74,248,210,183,196,228,110,46,79,204,214,61,159,158,45,165,203,240,238,143,251,42,237,236,254,221,151,66,86,102,220,35,160,231,252,93,79,174,159,178,46,189,164,184,72,107,164,104,114,96,98,158,243,6,92,241,227,98,77,82,49,129,97,106,93,180,111,84,243,144,192,58,220,20,91,5,159,217,90,151,158,56,22,94,5,53,205,77,202,43,42,190,79,97,63,171,226,75,7,66,48,6,74,92,246,120,134,218,155,76,57,94,90,65,39,64,133,20,189,223,245,92,84,10,159,134,72,127,123,176,154,181,90,101,23,180,11,191,177,244,143,34,14,120,36,223,206,66,252,44,130,224,179,89,102,152,141,215,236,21,221,51,56,229,161,241,53,47,135,44,36,74,175,104,168,61,139,31,237,194,29,93,252,81,218,195,232,13,35,137,164,32,50,101,230,191,7,135,1,191,35,218,56,43,134,14,151,252,161,131,134,235,171,135,223,127,68,18,150,78,204,1,1,201,161,28,200,139,27,42,223,209,89,100,186,238,2,8,153,223,144,12,158,203,59,14,242,90,84,157,139,134,55,8,126,139,205,232,208,205,128,39,31,185,246,194,62,87,128,133,89,151,21,244,114,99,122,104,142,71,151,118,81,177,71,2,2,93,208,189,33,135,83,168,230,253,177,7,207,227,24,85,168,52,240,14,46,66,237,197,193,19,157,112,134,154,174,172,87,75,221,26,53,93,132,48,70,119,233,87,113,146,96,201,232,231,107,56,206,178,36,244,234,185,171,166,102,25,142,8,46,182,66,235,101,249,63,51,140,147,190,3,32,191,185,145,233,89,9,72,233,71,115,6,178,103,158,38,196,194,161,248,210,64,152,251,137,114,29,93,197,137,9,114,1,166,39,44,243,16,157,168,0,234,154,239,116,31,89,168,25,110,129,214,17,94,119,254,79,102,251,77,115,160,45,116,7,200,0,201,114,52,102,8,78,95,37,7,237,158,179,168,234,185,89,199,101,191,30,153,134,50,248,79,127,114,254,103,82,57,243,54,62,69,251,139,16,180,60,42,11,147,36,205,123,228,143,196,106,122,96,73,173,138,236,130,159,239,254,103,216,245,189,40,31,125,176,80,225,163,52,195,24,189,141,88,245,36,209,253,42,195,179,141,3,185,93,69,171,171,117,98,187,58,169,216,178,27,78,253,228,71,112,72,14,225,199,236,157,95,45,56,212,92,206,15,147,174,225,112,211,52,58,149,129,112,192,186,163,249,62,251,34,180,189,136,102,99,7,156,175,67,52,247,217,33,220,222,125,203,56,209,200,91,143,194,23,45,39,143,197,105,6,240,193,168,166,36,158,91,203,231,149,206,87,224,110,181,255,14,239,49,57,229,61,149,160,169,71,147,16,78,145,200,62,50,113,101,49,76,147,92,148,230,221,215,1,25,13,3,100,28,223,178,86,31,88,50,161,242,43,221,248,142,188,127,42,15,49,220,137,129,29,185,168,9,145,97,55,105,238,176,104,203,246,204,217,23,192,92,38,100,156,73,233,174,129,246,36,44,99,66,193,116,58,153,223,251,251,29,50,40,145,63,172,222,180,163,57,197,19,24,227,26,116,42,149,247,156,244,45,125,184,4,60,247,44,168,46,90,67,49,133,174,143,21,252,60,53,126,77,99,136,172,7,230,175,209,99,48,94,80,89,145,247,247,85,88,20,89,250,136,64,143,209,21,43,150,249,18,38,40,10,20,190,62,215,48,175,231,222,143,206,118,75,115,97,190,10,56,215,235,35,126,230,25,202,183,124,100,40,160,191,33,73,123,233,64,26,1,251,34,171,45,35,92,222,83,117,255,102,94,124,243,170,150,195,243,152,212,31,80,160,145,208,161,20,99,8,31,193,223,203,135,46,203,31,85,86,6,253,64,57,244,234,147,211,139,126,159,65,203,92,16,64,76,170,244,242,160,54,85,133,53,249,72,168,106,69,6,218,152,173,107,234,11,166,64,209,111,148,79,47,227,134,164,2,156,86,255,200,75,225,6,102,135,187,75,189,80,165,131,234,70,85,77,65,125,100,147,118,112,151,26,157,14,220,135,3,179,99,66,193,231,246,95,90,228,114,215,71,241,44,37,82,34,14,214,66,163,28,27,151,97,196,3,23,115,154,171,208,54,240,147,84,204,142,24,69,194,147,110,218,23,86,221,130,189,177,154,219,119,210,55,125,228,31,58,132,103,173,163,55,11,77,147,143,255,218,197,170,3,178,218,184,163,235,54,68,79,176,151,151,194,99,212,207,227,146,39,20,175,59,84,140,180,98,247,237,108,224,141,105,39,17,2,253,230,235,39,108,28,238,52,186,221,30,25,138,252,13,26,15,166,67,148,77,232,197,130,72,132,246,67,115,243,140,91,42,100,67,91,14,204,224,245,37,191,53,209,241,251,202,137,87,199,191,252,149,204,247,224,155,249,179,201,165,79,189,70,145,69,159,238,176,175,59,36,61,210,104,11,248,135,29,105,54,118,179,123,39,198,238,0,201,71,41,130,165,23,126,71,171,16,185,230,156,174,98,56,133,29,215,142,196,124,164,197,173,86,37,83,131,45,223,2,36,250,235,44,83,3,7,197,173,222,87,8,13,120,23,215,152,107,190,175,200,61,132,171,119,147,93,212,124,51,129,129,247,172,29,128,225,165,122,226,40,132,26,41,139,249,161,205,87,23,131,164,44,7,114,199,192,87,223,236,51,202,140,244,220,64,77,2,225,237,110,244,100,152,248,99,85,115,170,93,160,56,209,42,230,107,9,196,191,128,22,117,235,120,168,168,57,154,70,58,216,142,25,85,26,56,141,117,133,171,1,11,83,130,34,251,202,210,236,149,225,42,78,110,221,105,170,59,71,11,3,155,31,164,112,239,85,54,143,103,12,15,23,155,243,55,180,26,194,158,110,36,158,40,197,78,127,59,230,139,220,87,129,183,79,223,128,196,248,65,209,230,204,246,49,74,83,23,41,51,23,74,95,124,26,44,76,178,53,181,212,41,144,120,61,65,192,180,57,188,103,77,18,14,17,244,143,81,117,43,154,201,10,133,153,63,184,63,60,38,169,29,52,58,225,37,181,213,26,247,167,194,162,41,230,101,189,209,232,145,234,117,242,7,215,50,113,129,173,192,252,79,174,32,229,191,111,29,248,234,129,240,0,40,175,124,13,131,228,52,58,25,128,106,108,246,143,123,247,186,38,120,11,121,190,40,11,28,247,78,73,122,168,189,216,195,189,204,222,58,173,90,99,187,183,103,60,22,212,185,0,179,140,250,227,249,60,24,63,163,33,0,151,169,121,145,196,219,155,122,238,17,81,6,168,74,13,16,244,230,165,36,132,253,73,233,53,225,189,111,159,196,84,127,71,4,172,227,73,10,43,156,248,195,21,212,98,149,16,9,193,165,48,85,243,82,16,241,208,195,81,151,72,142,170,209,149,215,21,61,65,177,188,178,160,228,84,158,131,58,159,172,126,123,118,174,225,23,234,198,58,115,235,203,70,152,240,207,29,121,14,75,169,246,145,186,246,76,67,132,142,222,19,240,5,188,254,169,200,214,108,162,250,108,242,89,183,80,149,48,88,54,27,173,160,254,36,53,148,131,200,142,177,6,81,155,156,20,197,110,124,120,115,101,54,102,236,170,80,6,71,163,6,117,81,95,188,238,150,248,165,228,254,22,103,63,27,163,170,44,120,135,162,100,217,153,210,211,250,71,180,70,11,227,3,251,171,190,86,174,101,88,236,75,224,199,96,191,245,36,219,181,150,223,228,155,120,61,74,134,58,155,230,163,10,70,17,138,64,194,190,45,84,189,137,112,79,220,220,228,250,75,185,59,95,174,51,113,134,95,253,139,159,33,249,154,165,175,60,89,62,79,234,145,47,100,196,128,116,26,162,28,90,237,250,198,35,187,234,105,199,142,128,158,114,61,242,2,202,84,160,4,17,50,43,37,187,116,119,179,104,168,241,225,52,102,22,233,213,15,118,86,31,168,138,103,111,243,37,190,30,207,195,96,28,182,195,251,250,193,150,189,237,145,103,168,152,78,22,189,220,135,195,23,212,10,114,159,107,23,247,31,198,254,106,116,139,18,232,44,152,53,98,94,248,145,128,162,17,231,85,17,150,153,243,30,163,187,182,183,185,120,169,68,195,32,67,138,216,12,175,63,216,57,194,67,182,169,14,103,107,91,53,202,117,22,223,114,179,4,32,119,160,94,129,240,181,63,201,12,222,45,227,80,219,240,183,63,108,131,239,181,211,55,111,60,6,62,112,189,78,213,108,144,32,219,115,108,40,45,246,3,237,64,111,201,31,23,35,107,71,20,186,172,21,7,142,14,72,40,132,169,241,211,176,60,173,75,158,143,95,233,176,74,124,23,123,166,210,110,189,10,0,60,117,204,40,77,139,126,3,124,35,144,110,21,99,189,55,15,149,168,172,121,43,205,4,151,89,236,144,24,127,152,94,238,216,204,226,57,242,157,54,54,69,163,45,60,119,152,241,53,246,113,109,56,204,55,75,95,187,97,161,47,28,123,43,208,236,181,222,57,139,51,157,197,119,233,85,154,9,174,74,207,43,192,124,95,62,102,187,57,104,37,70,27,3,235,64,193,83,32,116,193,174,149,180,190,153,163,59,200,9,211,223,25,13,73,61,200,236,205,131,205,180,159,76,175,108,122,129,148,145,203,242,78,176,87,98,96,200,107,45,0,207,227,215,177,73,106,151,94,165,165,46,196,211,195,242,138,140,194,45,13,119,108,24,148,7,95,86,115,151,3,145,16,248,167,197,150,0,200,112,67,102,233,28,42,106,169,184,253,41,100,173,137,233,98,135,12,153,42,178,183,233,115,106,40,148,202,252,233,203,93,29,129,243,102,241,51,166,2,51,110,179,50,94,7,31,101,164,141,135,44,75,218,97,78,234,148,179,202,231,219,42,39,223,249,175,160,102,140,188,13,72,94,243,7,253,152,220,250,118,184,114,13,8,41,143,55,165,0,42,170,137,47,250,199,116,254,149,36,206,14,26,59,208,78,51,165,162,46,142,9,108,52,33,152,165,29,7,136,154,233,69,28,204,166,118,180,171,171,27,217,121,99,114,214,173,71,62,10,54,31,220,166,110,96,56,222,45,250,82,78,173,177,209,198,42,52,63,223,65,223,23,204,137,0,20,175,120,233,235,187,92,202,149,95,74,158,53,118,124,141,96,194,23,158,37,197,235,8,135,92,102,89,199,56,59,112,201,86,111,15,218,221,52,202,23,35,176,204,235,250,155,88,201,72,27,26,110,193,92,165,177,45,216,11,136,2,222,175,177,247,113,25,177,53,248,81,80,147,23,47,52,24,194,203,7,42,125,165,203,104,247,173,240,58,244,119,8,202,165,201,178,34,95,133,48,57,145,230,75,149,133,134,231,70,99,134,218,128,235,75,79,212,162,243,220,186,39,19,199,151,254,114,171,30,93,223,159,55,242,158,91,23,9,130,5,125,180,17,93,62,26,56,108,31,84,66,205,203,217,162,202,134,247,127,93,247,243,116,127,97,145,54,146,191,31,195,238,186,59,154,41,232,158,115,59,184,191,72,145,230,21,122,90,94,158,106,87,158,69,92,32,6,168,173,145,219,103,190,210,179,231,81,51,248,220,87,155,1,106,191,10,103,107,191,177,127,13,175,52,190,162,124,205,52,148,15,221,198,95,51,88,40,111,110,1,124,83,231,200,207,162,156,242,193,184,133,32,182,214,157,162,205,202,214,230,80,63,13,224,121,167,174,235,52,81,150,114,153,242,202,12,241,70,247,87,24,110,183,116,224,10,234,218,137,45,253,31,183,102,51,243,130,70,191,53,209,6,138,77,115,89,234,105,125,76,4,31,2,247,21,145,105,158,159,73,253,173,163,170,11,152,177,5,191,53,194,45,201,122,159,114,201,154,223,221,81,122,4,210,18,133,172,155,149,231,199,164,127,100,3,12,69,12,251,217,193,247,201,84,143,236,125,99,38,194,61,222,235,55,82,108,82,196,113,160,255,141,220,109,75,45,148,92,198,35,145,190,250,167,132,197,45,135,5,185,57,234,230,125,143,20,193,95,149,235,121,248,129,102,201,215,44,106,165,121,25,153,20,186,130,67,176,196,31,102,159,58,193,2,33,141,2,89,181,55,250,128,69,219,134,108,119,221,226,214,152,231,185,217,36,230,123,244,183,112,157,58,189,172,108,130,13,178,227,246,29,4,203,243,53,145,184,108,219,147,26,215,0,79,108,108,139,192,202,32,52,86,153,113,134,244,53,122,41,252,219,28,158,2,67,81,177,145,95,35,182,206,138,250,169,198,208,204,209,167,1,134,61,220,54,195,106,35,236,218,160,51,175,31,232,241,139,38,127,115,75,22,232,78,155,202,193,62,253,214,120,99,68,97,33,172,113,109,218,230,154,113,89,204,144,64,20,104,129,63,232,197,161,183,242,60,252,26,224,253,219,247,133,76,146,33,140,202,29,93,237,162,58,230,73,189,44,246,243,81,50,222,168,42,217,243,7,203,153,235,153,187,214,254,163,212,30,178,230,238,49,203,248,46,2,250,102,76,148,114,222,81,237,9,147,126,136,197,225,207,195,62,207,71,124,136,102,182,135,150,111,171,214,242,218,172,48,46,188,148,127,250,69,243,18,198,245,235,30,233,195,139,85,158,113,201,137,34,85,129,225,252,11,101,7,33,15,42,140,204,175,117,86,7,62,212,9,214,186,111,251,41,159,21,176,53,161,101,158,148,57,252,176,181,227,252,229,11,230,104,213,201,47,208,129,14,167,137,3,253,61,244,248,183,209,194,93,15,57,99,93,250,180,202,249,120,133,96,189,18,207,4,128,202,100,234,128,29,122,193,31,112,61,222,72,254,137,113,145,136,111,155,231,121,15,149,38,6,181,86,137,166,228,244,56,215,152,49,62,156,231,56,113,238,241,128,193,175,33,104,183,206,165,6,111,207,188,7,85,68,231,255,251,33,146,158,215,220,139,120,58,173,236,231,155,117,7,211,22,174,110,108,48,188,137,236,61,250,213,176,34,196,253,9,147,224,36,185,155,75,238,102,23,166,70,202,152,212,48,18,101,40,82,30,159,66,6,143,141,195,16,45,55,61,83,59,38,130,126,180,246,105,132,218,205,203,38,230,86,179,245,189,236,12,154,181,102,212,87,7,154,20,73,193,126,249,122,141,88,91,94,68,31,252,31,30,41,244,24,114,189,90,181,156,197,125,115,82,76,176,2,156,138,18,190,225,197,39,250,51,208,231,118,253,180,107,246,56,4,62,35,91,62,27,51,27,48,162,168,180,193,235,192,80,190,116,140,93,86,155,105,20,231,70,114,189,179,216,49,97,243,45,64,17,214,206,240,179,131,202,137,167,19,167,118,69,81,158,178,99,235,14,191,160,187,33,106,151,41,174,10,29,150,172,1,40,8,183,30,45,69,178,101,209,105,232,183,121,240,5,175,73,98,173,83,8,240,129,232,6,209,90,7,54,2,150,43,59,200,188,252,154,182,153,223,73,80,133,218,196,227,94,254,106,162,224,100,13,137,149,128,154,96,132,83,234,172,97,66,136,143,16,230,106,216,238,144,181,235,120,122,191,16,84,239,62,189,43,223,246,237,247,212,214,139,34,131,103,161,153,39,196,91,20,172,26,131,240,127,217,203,29,91,230,185,191,102,181,202,245,78,203,112,252,233,183,127,14,71,207,191,180,104,242,176,44,135,135,53,254,46,199,160,191,214,233,19,227,95,228,51,132,190,233,114,58,253,116,250,72,60,108,30,161,61,8,160,255,135,44,138,242,128,170,243,91,105,138,69,230,191,102,235,55,157,146,211,199,114,106,87,89,238,191,122,246,151,230,46,30,46,220,24,146,128,138,214,107,45,110,24,138,16,184,138,171,151,142,60,136,24,145,235,96,41,201,79,207,171,208,119,37,41,97,195,111,190,99,148,231,246,21,134,203,128,229,185,87,6,238,193,66,35,63,71,148,200,28,55,6,215,20,17,90,3,218,178,2,135,53,159,217,15,53,232,254,221,193,190,223,78,123,203,208,81,183,5,59,41,52,162,6,93,145,183,87,110,198,127,241,19,121,22,169,46,25,54,133,95,131,86,208,61,121,144,83,113,54,106,180,99,166,97,233,202,157,195,115,186,32,172,134,212,6,228,80,165,237,222,146,148,193,36,245,236,112,97,166,140,142,56,153,98,11,61,141,56,92,76,211,158,221,207,189,155,90,56,243,225,122,101,255,134,92,206,3,94,82,148,159,85,11,199,12,0,125,154,84,71,88,144,14,17,31,15,145,38,8,168,141,18,208,38,132,143,21,250,96,244,91,196,116,166,159,31,232,175,47,110,89,125,179,153,124,91,119,51,117,118,124,208,208,109,25,233,62,225,14,83,45,250,100,95,250,190,93,177,238,151,202,251,234,134,15,89,229,156,208,37,133,89,50,40,119,153,141,230,199,144,197,48,117,3,126,60,105,84,120,202,38,165,122,19,221,67,174,189,86,41,230,251,81,104,32,94,17,178,169,225,110,79,65,143,108,124,111,50,44,8,252,152,47,107,44,5,87,158,7,119,192,4,111,62,248,227,140,180,49,236,107,117,31,79,240,126,132,45,62,44,123,223,223,217,1,36,65,236,192,230,91,22,142,212,170,208,193,236,186,104,100,221,164,13,114,38,230,171,130,212,134,55,167,241,54,90,121,215,141,251,251,169,220,123,90,96,115,126,122,14,153,226,192,203,182,130,57,98,156,25,49,135,188,33,232,237,49,143,95,44,163,1,87,113,137,130,55,136,238,71,101,237,22,49,34,233,212,198,230,210,6,203,159,90,192,187,66,146,192,179,106,183,163,161,227,25,218,36,238,155,26,150,175,244,244,140,227,208,240,236,48,56,114,86,227,190,207,226,196,218,189,150,228,189,219,91,23,167,16,180,234,195,122,166,51,85,6,170,21,245,96,186,105,181,150,239,17,198,216,172,19,211,34,207,124,114,100,85,87,29,199,23,63,51,203,40,168,167,244,225,234,71,169,240,15,134,118,205,173,126,91,78,158,35,164,174,143,234,148,32,84,27,27,178,169,99,253,106,72,212,233,250,122,150,64,249,89,173,55,174,89,179,202,188,73,48,100,56,206,177,205,5,197,9,45,196,55,151,102,83,76,172,213,6,80,140,72,212,92,1,15,181,96,127,43,242,83,119,213,156,210,73,193,193,62,108,146,239,230,24,101,86,27,235,125,229,127,96,100,26,145,245,78,168,160,143,111,221,188,23,60,155,2,180,253,92,215,62,232,157,47,132,9,234,152,73,252,135,166,226,55,233,253,202,140,41,27,70,226,227,57,116,40,41,40,41,217,246,31,5,127,89,139,207,201,58,9,163,194,73,149,107,121,110,241,249,254,179,184,63,155,70,150,161,49,75,208,216,104,18,89,226,74,198,174,143,183,28,92,153,17,228,222,236,186,19,194,188,131,217,87,231,102,59,57,98,47,243,201,32,51,242,163,75,5,176,186,141,228,137,9,83,131,58,172,96,124,82,143,70,197,22,177,165,244,128,226,246,202,124,1,139,119,48,124,33,173,248,89,5,161,174,107,23,148,179,128,207,88,162,52,180,162,74,0,150,64,251,196,183,24,21,10,26,60,27,150,14,151,198,237,96,8,14,252,100,176,203,85,215,75,94,146,71,96,207,64,104,143,245,53,10,142,80,74,5,147,21,245,97,46,219,204,0,221,169,52,30,192,220,219,247,46,105,122,201,169,2,59,72,197,85,138,250,187,145,89,187,165,234,2,44,241,207,156,96,222,1,103,108,155,66,171,173,205,254,178,152,189,23,57,65,110,38,200,72,124,128,85,17,129,222,220,173,104,120,239,156,34,187,38,19,45,222,145,95,221,63,32,221,80,207,114,53,106,240,104,154,222,181,125,143,182,132,149,102,38,29,255,81,242,165,185,179,94,74,106,4,187,191,217,167,147,165,182,17,242,138,32,133,25,161,78,71,27,236,35,245,158,122,35,217,3,249,172,233,24,245,241,228,98,216,215,120,65,48,84,253,226,155,29,73,15,190,137,90,141,146,75,178,247,69,56,220,109,151,253,194,227,72,112,61,65,80,44,226,221,145,121,211,226,153,157,101,128,207,33,251,3,191,182,6,223,73,195,113,211,159,232,183,137,67,180,67,146,3,91,66,158,33,18,25,6,162,184,99,186,156,155,102,2,92,82,220,9,95,125,78,174,53,209,178,21,122,219,91,73,13,187,162,238,129,83,239,31,191,28,244,110,190,246,36,195,177,220,65,187,18,64,210,140,13,3,228,224,23,156,49,171,180,188,48,1,212,227,241,111,183,63,160,139,211,107,80,223,82,44,76,127,168,71,45,16,12,92,221,85,8,21,45,225,146,103,142,76,91,202,250,208,27,183,172,102,250,95,81,89,53,172,171,20,115,125,28,107,57,21,83,142,104,44,156,12,117,86,172,233,102,65,124,116,38,71,254,238,122,36,114,107,53,107,255,247,188,132,152,151,111,2,238,52,141,136,31,114,236,43,228,61,183,220,215,58,107,135,6,69,233,53,232,86,200,64,185,87,250,108,187,89,215,169,28,171,89,171,204,121,137,160,174,193,218,148,250,189,192,157,2,222,46,176,170,48,183,32,137,154,20,202,124,23,79,18,118,18,54,137,173,93,81,19,8,210,133,203,148,135,48,185,194,252,221,188,94,92,4,224,4,225,113,241,197,69,186,57,97,242,102,25,204,83,78,197,153,146,162,191,200,108,115,154,39,216,67,50,54,26,25,57,5,129,106,181,88,89,48,211,151,226,156,50,35,177,93,39,130,114,126,217,189,74,128,170,173,171,250,10,129,132,159,36,240,247,239,247,113,125,198,87,54,10,114,151,107,189,83,0,66,217,110,103,88,85,54,82,104,110,9,85,117,52,14,29,185,31,29,245,210,27,27,51,50,197,142,134,163,46,157,105,38,7,164,249,67,186,242,96,135,36,102,239,206,16,66,94,153,184,47,174,206,234,164,211,62,231,181,247,69,227,187,216,154,89,165,110,118,157,247,130,253,19,63,214,152,229,187,124,178,244,130,161,8,250,99,243,253,147,22,135,248,104,156,85,195,69,102,47,195,202,254,82,206,97,156,144,38,221,18,184,205,145,244,240,95,107,216,114,148,90,179,188,94,15,73,213,55,57,221,75,145,75,200,252,209,169,254,79,73,47,38,50,29,216,254,238,76,66,157,26,73,21,153,110,55,154,27,243,212,29,181,24,128,50,197,68,167,242,13,164,40,166,161,3,178,98,251,103,35,31,254,128,228,2,43,153,184,76,87,7,99,189,136,143,241,242,51,182,168,202,161,81,125,143,60,236,175,159,13,175,81,27,230,223,215,21,156,29,16,21,61,94,28,47,189,188,128,133,141,130,64,108,242,211,192,104,99,54,96,87,148,166,209,38,81,116,200,182,21,150,155,83,249,239,213,68,126,235,104,250,192,85,226,178,70,220,185,211,145,216,164,82,137,40,69,93,226,137,58,192,107,40,243,93,135,173,141,231,60,41,243,221,210,225,183,214,237,77,144,183,138,54,156,206,152,20,167,112,178,2,142,233,63,118,245,186,168,115,23,237,127,161,52,190,131,205,172,61,70,212,249,193,113,236,1,63,153,194,249,28,52,152,146,118,252,174,124,101,20,84,195,181,22,28,55,67,185,108,164,223,64,242,95,168,10,106,221,170,115,124,90,128,73,84,128,194,126,198,254,178,9,125,246,17,219,161,151,61,90,62,82,153,82,79,184,139,26,53,23,76,154,194,121,137,90,179,47,145,76,153,190,193,213,231,96,153,128,9,180,32,135,176,143,228,70,130,232,176,239,34,35,45,124,168,150,112,164,169,121,239,50,255,182,82,11,227,217,225,46,205,126,72,41,99,237,130,155,136,53,200,105,43,176,115,38,228,217,248,151,29,192,128,88,247,230,58,135,35,49,148,29,151,223,83,75,72,81,189,39,56,113,61,130,8,178,206,88,55,219,65,26,110,60,62,91,202,165,156,188,250,7,230,185,213,69,13,135,206,161,67,86,126,23,218,33,238,29,246,111,240,193,23,207,167,59,181,10,80,7,253,216,198,160,126,118,25,142,187,219,141,205,30,120,225,205,48,182,16,129,148,239,15,27,181,134,143,98,254,1,83,254,31,255,135,43,35,144,227,151,14,120,223,225,150,152,19,210,244,111,255,7,54,76,90,184,145,125,38,157,76,203,106,243,182,151,163,189,117,246,229,126,187,230,32,127,245,12,174,208,157,201,47,138,135,27,8,44,23,168,75,5,94,144,144,29,128,40,103,207,160,139,149,58,169,202,214,91,229,91,69,95,52,244,102,138,30,93,16,244,226,192,19,47,234,124,177,41,225,41,53,113,240,29,36,176,96,200,133,120,249,15,84,220,67,98,167,89,198,172,214,44,242,174,102,92,181,65,89,39,67,27,152,211,239,179,163,173,182,30,93,53,120,149,99,96,212,76,155,193,87,93,16,159,97,240,167,127,143,201,78,151,211,14,74,72,93,80,239,16,153,44,170,113,30,142,210,153,141,231,5,55,23,192,228,162,107,36,227,63,35,207,212,44,44,231,227,95,223,227,106,163,136,251,178,68,6,140,105,200,250,250,194,115,150,230,188,215,171,137,242,164,142,239,105,187,242,248,237,240,175,15,77,7,186,62,16,27,130,97,115,229,70,254,200,27,253,235,55,160,122,210,131,144,237,214,146,48,128,218,165,7,197,247,205,136,9,86,138,171,239,84,102,181,99,34,223,176,190,161,70,126,19,32,157,92,30,50,91,85,201,147,83,206,152,131,98,110,255,211,152,247,13,103,17,67,79,209,212,53,0,130,208,143,124,77,59,59,79,138,33,244,163,231,90,169,33,113,13,77,210,88,86,137,137,177,65,196,75,198,99,87,112,68,61,212,222,195,82,129,245,9,86,167,172,39,36,47,79,8,97,34,51,247,181,217,210,214,30,221,12,45,170,223,5,251,56,106,187,136,60,153,183,125,123,105,202,246,173,235,117,173,98,7,177,31,176,210,234,112,187,115,202,130,222,95,250,3,41,138,232,151,99,58,239,49,3,92,19,45,205,42,205,111,154,152,107,85,143,82,0,127,5,122,140,110,52,36,4,181,151,60,132,131,227,21,162,16,175,73,103,3,169,73,11,241,65,144,239,33,238,70,7,163,226,123,14,54,149,21,175,250,231,35,138,162,153,249,171,112,98,87,221,44,131,83,36,90,75,63,37,158,96,140,23,176,126,171,180,144,43,148,230,92,4,108,177,247,108,167,188,213,162,216,193,225,119,173,79,189,136,215,186,186,95,30,249,242,186,234,49,105,195,224,110,253,50,18,129,145,126,36,113,217,232,42,194,227,211,205,191,199,196,84,25,13,82,163,201,163,108,42,250,117,176,105,62,124,153,175,132,132,252,128,233,115,251,202,177,152,216,118,165,70,212,16,187,70,128,135,229,89,64,46,238,175,239,111,124,42,126,110,10,211,149,65,204,246,196,165,7,216,127,22,17,151,20,23,22,85,11,248,191,115,146,13,197,180,181,89,88,26,198,186,84,220,56,122,49,181,87,34,107,185,79,192,250,104,148,249,192,141,68,211,46,60,152,157,188,162,187,80,189,129,115,25,40,77,48,237,83,70,92,179,193,221,132,152,163,81,161,60,148,43,71,238,62,197,167,137,97,226,78,177,65,251,33,14,229,208,150,30,149,167,10,242,109,41,95,245,49,35,206,223,28,111,14,32,27,196,183,41,217,110,237,20,189,106,127,8,53,123,87,30,53,155,69,233,245,250,212,51,255,99,162,167,167,149,155,54,157,163,212,123,113,118,241,222,55,19,252,179,223,155,60,180,200,121,79,52,25,185,221,156,83,108,113,221,183,59,189,140,167,64,246,73,216,136,51,179,219,248,169,149,86,6,207,56,143,113,25,36,28,123,252,250,22,122,239,244,179,109,232,29,235,167,33,0,28,48,226,210,21,57,106,46,35,89,134,83,125,74,76,149,117,26,48,243,100,251,199,96,117,205,59,77,3,248,171,180,61,205,66,30,56,104,125,186,75,255,33,212,26,207,14,160,172,211,69,13,239,21,47,69,23,13,171,12,94,143,123,156,171,252,215,143,96,88,101,152,158,178,14,51,199,104,78,187,236,128,121,189,179,29,115,4,24,82,65,185,2,75,66,239,135,190,171,184,103,206,40,215,171,81,134,166,85,123,241,250,153,28,237,229,250,123,239,174,119,225,19,255,128,139,114,28,254,119,85,108,250,3,205,153,72,157,182,228,56,228,159,77,253,24,192,176,219,13,80,249,38,217,43,146,81,84,20,199,56,31,161,193,58,49,205,14,97,208,115,97,174,146,195,104,89,246,78,93,147,235,9,15,124,139,216,252,218,178,84,102,55,29,156,25,156,239,230,104,23,249,223,74,53,13,127,170,169,175,194,223,194,15,128,187,172,16,231,66,93,88,248,191,207,188,22,27,206,244,172,55,202,117,155,191,53,241,36,71,97,176,193,174,124,248,142,239,143,79,106,159,47,46,92,166,242,13,14,77,77,106,201,51,2,13,38,238,150,226,113,167,239,52,166,139,205,222,52,25,199,50,166,202,48,15,138,222,144,75,19,254,233,90,221,37,41,167,53,202,230,170,31,112,194,203,147,51,245,84,148,252,84,162,248,189,170,24,126,217,90,147,146,243,247,88,88,250,149,239,228,5,177,244,59,95,162,180,207,62,89,42,231,250,32,227,109,240,78,200,108,247,171,170,227,188,56,217,213,55,226,176,21,37,62,182,174,36,252,203,77,108,244,246,7,141,193,218,254,189,69,63,188,110,245,3,98,190,62,136,98,10,193,73,44,60,107,171,141,99,61,198,39,60,165,61,189,134,22,99,94,178,54,28,207,208,247,228,43,97,197,251,151,115,59,6,247,56,76,229,190,37,90,75,85,250,189,210,63,236,128,147,56,142,247,87,52,156,107,68,60,91,79,84,40,151,52,67,206,34,7,239,121,166,109,236,43,23,160,54,194,4,96,184,112,200,255,255,210,242,105,227,116,176,193,223,139,103,168,225,3,220,201,241,151,241,229,237,86,222,248,162,188,97,49,183,100,46,237,36,250,24,21,122,223,115,9,58,24,232,24,217,138,81,227,139,58,187,63,241,166,186,250,217,105,97,225,88,104,251,195,244,242,248,204,171,109,111,221,115,73,32,220,44,121,30,8,0,255,173,239,225,32,248,47,22,221,160,86,142,161,14,60,12,222,41,116,236,55,169,13,212,13,3,166,109,123,0,222,138,26,35,50,24,212,204,95,64,39,160,129,236,51,135,180,236,67,217,230,228,116,125,162,251,13,64,30,244,23,145,197,161,143,103,203,145,91,93,29,60,248,241,228,106,95,110,181,242,38,164,192,81,206,185,68,5,252,47,171,212,227,164,10,93,91,212,211,126,179,107,201,221,114,156,227,157,212,86,90,3,45,242,249,189,248,67,237,159,138,208,217,55,170,38,154,185,193,50,227,193,85,183,104,145,39,15,243,56,126,48,65,226,191,146,255,168,96,134,137,212,174,145,189,113,216,165,6,103,91,15,143,186,141,198,199,134,59,9,14,145,168,206,209,207,40,94,27,45,162,121,191,71,23,25,209,228,246,46,188,255,14,81,253,223,8,159,169,193,15,110,60,159,15,150,116,37,196,87,139,102,25,22,104,67,210,66,59,219,165,235,231,109,202,162,171,58,31,251,145,192,35,93,3,111,54,30,189,61,102,76,91,61,202,239,32,48,129,255,192,114,212,237,214,62,8,65,225,55,48,109,32,98,7,215,234,169,4,57,145,67,171,64,212,245,50,32,202,36,217,252,5,128,96,148,108,240,194,0,162,81,237,79,31,146,149,74,138,142,25,32,9,254,106,59,41,156,20,32,142,197,183,95,230,210,34,121,215,159,156,124,123,132,213,183,111,219,205,216,127,168,4,212,87,180,226,156,121,145,135,131,127,132,233,167,171,160,133,82,19,156,158,222,192,243,243,245,9,31,157,19,64,105,86,37,71,22,129,171,208,8,232,220,104,145,109,42,232,219,126,83,121,207,168,55,246,169,199,189,39,16,184,217,103,87,178,146,118,34,78,6,168,43,223,105,62,212,108,211,249,188,220,34,226,55,157,51,112,199,250,237,45,51,158,55,230,7,154,187,50,151,26,51,239,122,43,182,249,28,19,164,159,14,206,30,240,171,170,34,209,37,50,244,39,51,62,88,98,189,79,63,89,177,39,141,182,170,76,30,211,54,78,60,109,94,199,117,189,11,78,13,31,177,184,54,133,189,201,38,243,226,237,197,177,254,199,124,56,243,155,163,244,134,42,24,6,114,245,61,72,103,222,6,242,221,154,111,203,124,163,68,233,145,244,221,99,63,18,207,90,235,201,240,152,183,122,113,141,233,164,50,171,176,135,70,52,46,171,7,177,78,74,14,80,79,117,205,179,190,54,67,253,146,41,218,96,29,125,166,6,219,80,30,9,215,217,210,131,166,190,50,203,184,67,17,88,187,138,160,136,5,17,205,215,151,74,242,38,144,156,218,244,73,238,0,162,121,1,57,240,126,206,12,104,223,203,228,181,121,42,112,40,175,164,10,218,232,184,35,107,20,192,219,102,19,97,219,195,88,109,155,154,127,193,160,218,214,244,151,160,124,216,184,37,110,148,112,82,175,191,70,171,242,13,247,49,239,199,41,10,186,99,252,240,203,111,215,185,244,248,99,178,201,11,219,122,202,10,46,248,20,47,223,248,147,42,187,19,21,166,67,217,17,90,201,11,139,71,115,183,195,42,239,201,249,156,85,18,160,17,167,126,81,44,152,254,207,135,87,62,88,204,136,252,18,138,17,202,125,143,115,59,104,115,31,74,156,135,221,26,8,135,130,104,243,70,65,63,102,156,138,127,119,238,235,206,216,200,87,183,203,137,213,161,242,30,116,151,126,205,176,236,33,240,29,66,160,204,251,206,142,117,149,45,249,0,1,73,100,251,109,151,5,28,111,19,221,60,85,115,151,166,215,242,164,39,77,180,243,246,8,113,58,241,35,253,238,186,160,205,181,192,154,151,99,85,86,192,166,99,166,179,161,208,133,184,51,218,91,23,22,222,85,234,210,29,232,30,253,220,255,1]}");

},{}],"7aYIw":[function(require,module,exports,__globalThis) {
'use strict';
var INITIAL_STATE = 1;
var FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ class StateMachine {
    constructor(dfa){
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
    }
    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ match(str) {
        var self = this;
        return {
            *[Symbol.iterator] () {
                var state = INITIAL_STATE;
                var startRun = null;
                var lastAccepting = null;
                var lastState = null;
                for(var p = 0; p < str.length; p++){
                    var c = str[p];
                    lastState = state;
                    state = self.stateTable[state][c];
                    if (state === FAIL_STATE) {
                        // yield the last match if any
                        if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                            startRun,
                            lastAccepting,
                            self.tags[lastState]
                        ];
                         // reset the state as if we started over from the initial state
                        state = self.stateTable[INITIAL_STATE][c];
                        startRun = null;
                    } // start a run if not in the failure state
                    if (state !== FAIL_STATE && startRun == null) startRun = p;
                     // if accepting, mark the potential match end
                    if (self.accepting[state]) lastAccepting = p;
                     // reset the state to the initial state if we get into the failure state
                    if (state === FAIL_STATE) state = INITIAL_STATE;
                } // yield the last match if any
                if (startRun != null && lastAccepting != null && lastAccepting >= startRun) yield [
                    startRun,
                    lastAccepting,
                    self.tags[state]
                ];
            }
        };
    }
    /**
   * For each match over the input sequence, action functions matching
   * the tag definitions in the input pattern are called with the startIndex,
   * endIndex, and sub-match sequence.
   */ apply(str, actions) {
        for (var [start, end, tags] of this.match(str)){
            for (var tag of tags)if (typeof actions[tag] === 'function') actions[tag](start, end, str.slice(start, end + 1));
        }
    }
}
module.exports = StateMachine;

},{}],"9z6ZU":[function(require,module,exports,__globalThis) {
var Buffer = require("60a852b18ef9adce").Buffer;
var clone = function() {
    'use strict';
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/ function clone(parent, circular, depth, prototype) {
        var filter;
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            filter = circular.filter;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth == 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && Buffer.isBuffer(parent)) {
                if (Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (0, module.exports) module.exports = clone;

},{"60a852b18ef9adce":"dB11O"}],"h2bTB":[function(require,module,exports,__globalThis) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

},{}],"5hlIT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _zlib = require("zlib");
var _zlibDefault = parcelHelpers.interopDefault(_zlib);
var Buffer = require("825656d9998d777b").Buffer;
var range = function range(left, right, inclusive) {
    var range = [];
    var ascending = left < right;
    var end = !inclusive ? right : ascending ? right + 1 : right - 1;
    for(var i = left; ascending ? i < end : i > end; ascending ? i++ : i--)range.push(i);
    return range;
};
var classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var toConsumableArray = function(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
};
var PNG = function() {
    createClass(PNG, null, [
        {
            key: 'decode',
            value: function decode(path, fn) {
                throw new Error('PNG.decode not available in browser build');
            }
        },
        {
            key: 'load',
            value: function load(path) {
                throw new Error('PNG.load not available in browser build');
            }
        }
    ]);
    function PNG(data) {
        var _this = this;
        classCallCheck(this, PNG);
        var i = void 0;
        this.data = data;
        this.pos = 8; // Skip the default header
        this.palette = [];
        this.imgData = [];
        this.transparency = {};
        this.text = {};
        while(true){
            var end;
            var chunkSize = this.readUInt32();
            var section = (function() {
                var result = [];
                for(i = 0; i < 4; i++)result.push(String.fromCharCode(_this.data[_this.pos++]));
                return result;
            })().join('');
            switch(section){
                case 'IHDR':
                    // we can grab  interesting values from here (like width, height, etc)
                    this.width = this.readUInt32();
                    this.height = this.readUInt32();
                    this.bits = this.data[this.pos++];
                    this.colorType = this.data[this.pos++];
                    this.compressionMethod = this.data[this.pos++];
                    this.filterMethod = this.data[this.pos++];
                    this.interlaceMethod = this.data[this.pos++];
                    break;
                case 'PLTE':
                    this.palette = this.read(chunkSize);
                    break;
                case 'IDAT':
                    for(i = 0, end = chunkSize; i < end; i++)this.imgData.push(this.data[this.pos++]);
                    break;
                case 'tRNS':
                    // This chunk can only occur once and it must occur after the
                    // PLTE chunk and before the IDAT chunk.
                    this.transparency = {};
                    switch(this.colorType){
                        case 3:
                            // Indexed color, RGB. Each byte in this chunk is an alpha for
                            // the palette index in the PLTE ("palette") chunk up until the
                            // last non-opaque entry. Set up an array, stretching over all
                            // palette entries which will be 0 (opaque) or 1 (transparent).
                            this.transparency.indexed = this.read(chunkSize);
                            var short = 255 - this.transparency.indexed.length;
                            if (short > 0) {
                                var asc, end1;
                                for(i = 0, end1 = short, asc = 0 <= end1; asc ? i < end1 : i > end1; asc ? i++ : i--)this.transparency.indexed.push(255);
                            }
                            break;
                        case 0:
                            // Greyscale. Corresponding to entries in the PLTE chunk.
                            // Grey is two bytes, range 0 .. (2 ^ bit-depth) - 1
                            this.transparency.grayscale = this.read(chunkSize)[0];
                            break;
                        case 2:
                            // True color with proper alpha channel.
                            this.transparency.rgb = this.read(chunkSize);
                            break;
                    }
                    break;
                case 'tEXt':
                    var text = this.read(chunkSize);
                    var index = text.indexOf(0);
                    var key = String.fromCharCode.apply(String, toConsumableArray(Array.from(text.slice(0, index) || [])));
                    this.text[key] = String.fromCharCode.apply(String, toConsumableArray(Array.from(text.slice(index + 1) || [])));
                    break;
                case 'IEND':
                    // we've got everything we need!
                    this.colors = function() {
                        switch(_this.colorType){
                            case 0:
                            case 3:
                            case 4:
                                return 1;
                            case 2:
                            case 6:
                                return 3;
                        }
                    }();
                    this.hasAlphaChannel = [
                        4,
                        6
                    ].includes(this.colorType);
                    var colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
                    this.pixelBitlength = this.bits * colors;
                    this.colorSpace = function() {
                        switch(_this.colors){
                            case 1:
                                return 'DeviceGray';
                            case 3:
                                return 'DeviceRGB';
                        }
                    }();
                    this.imgData = new Buffer(this.imgData);
                    return;
                default:
                    // unknown (or unimportant) section, skip it
                    this.pos += chunkSize;
            }
            this.pos += 4; // Skip the CRC
            if (this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    }
    createClass(PNG, [
        {
            key: 'read',
            value: function read(bytes) {
                var _this2 = this;
                return range(0, bytes, false).map(function(i) {
                    return _this2.data[_this2.pos++];
                });
            }
        },
        {
            key: 'readUInt32',
            value: function readUInt32() {
                var b1 = this.data[this.pos++] << 24;
                var b2 = this.data[this.pos++] << 16;
                var b3 = this.data[this.pos++] << 8;
                var b4 = this.data[this.pos++];
                return b1 | b2 | b3 | b4;
            }
        },
        {
            key: 'readUInt16',
            value: function readUInt16() {
                var b1 = this.data[this.pos++] << 8;
                var b2 = this.data[this.pos++];
                return b1 | b2;
            }
        },
        {
            key: 'decodePixels',
            value: function decodePixels(fn) {
                var _this3 = this;
                return (0, _zlibDefault.default).inflate(this.imgData, function(err, data) {
                    if (err) throw err;
                    var pixelBytes = _this3.pixelBitlength / 8;
                    var scanlineLength = pixelBytes * _this3.width;
                    var pixels = new Buffer(scanlineLength * _this3.height);
                    var length = data.length;
                    var row = 0;
                    var pos = 0;
                    var c = 0;
                    while(pos < length){
                        var byte, col, i, left, upper;
                        var end;
                        var end1;
                        var end2;
                        var end3;
                        var end4;
                        switch(data[pos++]){
                            case 0:
                                // None
                                for(i = 0, end = scanlineLength; i < end; i++)pixels[c++] = data[pos++];
                                break;
                            case 1:
                                // Sub
                                for(i = 0, end1 = scanlineLength; i < end1; i++){
                                    byte = data[pos++];
                                    left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
                                    pixels[c++] = (byte + left) % 256;
                                }
                                break;
                            case 2:
                                // Up
                                for(i = 0, end2 = scanlineLength; i < end2; i++){
                                    byte = data[pos++];
                                    col = (i - i % pixelBytes) / pixelBytes;
                                    upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                    pixels[c++] = (upper + byte) % 256;
                                }
                                break;
                            case 3:
                                // Average
                                for(i = 0, end3 = scanlineLength; i < end3; i++){
                                    byte = data[pos++];
                                    col = (i - i % pixelBytes) / pixelBytes;
                                    left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
                                    upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                    pixels[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
                                }
                                break;
                            case 4:
                                // Paeth
                                for(i = 0, end4 = scanlineLength; i < end4; i++){
                                    var paeth, upperLeft;
                                    byte = data[pos++];
                                    col = (i - i % pixelBytes) / pixelBytes;
                                    left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
                                    if (row === 0) upper = upperLeft = 0;
                                    else {
                                        upper = pixels[(row - 1) * scanlineLength + col * pixelBytes + i % pixelBytes];
                                        upperLeft = col && pixels[(row - 1) * scanlineLength + (col - 1) * pixelBytes + i % pixelBytes];
                                    }
                                    var p = left + upper - upperLeft;
                                    var pa = Math.abs(p - left);
                                    var pb = Math.abs(p - upper);
                                    var pc = Math.abs(p - upperLeft);
                                    if (pa <= pb && pa <= pc) paeth = left;
                                    else if (pb <= pc) paeth = upper;
                                    else paeth = upperLeft;
                                    pixels[c++] = (byte + paeth) % 256;
                                }
                                break;
                            default:
                                throw new Error('Invalid filter algorithm: ' + data[pos - 1]);
                        }
                        row++;
                    }
                    return fn(pixels);
                });
            }
        },
        {
            key: 'decodePalette',
            value: function decodePalette() {
                var palette = this.palette;
                var transparency = this.transparency.indexed || [];
                var ret = new Buffer(transparency.length + palette.length);
                var pos = 0;
                var length = palette.length;
                var c = 0;
                for(var _i = 0, end = palette.length; _i < end; _i += 3){
                    var left;
                    ret[pos++] = palette[_i];
                    ret[pos++] = palette[_i + 1];
                    ret[pos++] = palette[_i + 2];
                    ret[pos++] = (left = transparency[c++]) != null ? left : 255;
                }
                return ret;
            }
        },
        {
            key: 'copyToImageData',
            value: function copyToImageData(imageData, pixels) {
                var j = void 0, k = void 0;
                var colors = this.colors;
                var palette = null;
                var alpha = this.hasAlphaChannel;
                if (this.palette.length) {
                    palette = this._decodedPalette != null ? this._decodedPalette : this._decodedPalette = this.decodePalette();
                    colors = 4;
                    alpha = true;
                }
                var data = (imageData != null ? imageData.data : undefined) || imageData;
                var length = data.length;
                var input = palette || pixels;
                var i = j = 0;
                if (colors === 1) while(i < length){
                    k = palette ? pixels[i / 4] * 4 : j;
                    var v = input[k++];
                    data[i++] = v;
                    data[i++] = v;
                    data[i++] = v;
                    data[i++] = alpha ? input[k++] : 255;
                    j = k;
                }
                else while(i < length){
                    k = palette ? pixels[i / 4] * 4 : j;
                    data[i++] = input[k++];
                    data[i++] = input[k++];
                    data[i++] = input[k++];
                    data[i++] = alpha ? input[k++] : 255;
                    j = k;
                }
            }
        },
        {
            key: 'decode',
            value: function decode(fn) {
                var _this4 = this;
                var ret = new Buffer(this.width * this.height * 4);
                return this.decodePixels(function(pixels) {
                    _this4.copyToImageData(ret, pixels);
                    return fn(ret);
                });
            }
        }
    ]);
    return PNG;
}();
exports.default = PNG;

},{"825656d9998d777b":"dB11O","zlib":"ltIO1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7v1e1":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @format
 */ var Yoga = require("3d32796c984ef253");
var nbind = require("99f47a42eb0422b7");
var ran = false;
var ret = null;
nbind({}, function(err, result) {
    if (ran) return;
    ran = true;
    if (err) throw err;
    ret = result;
});
if (!ran) throw new Error("Failed to load the yoga module - it needed to be loaded synchronously, but didn't");
// $FlowFixMe ret will not be null here
module.exports = Yoga(ret.bind, ret.lib);

},{"3d32796c984ef253":"3pmpt","99f47a42eb0422b7":"ase56"}],"3pmpt":[function(require,module,exports,__globalThis) {
'use strict';
var _extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @format
 */ var CONSTANTS = require("d005afae6344a4ab");
var Layout = function() {
    function Layout(left, right, top, bottom, width, height) {
        _classCallCheck(this, Layout);
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.width = width;
        this.height = height;
    }
    _createClass(Layout, [
        {
            key: 'fromJS',
            value: function fromJS(expose) {
                expose(this.left, this.right, this.top, this.bottom, this.width, this.height);
            }
        },
        {
            key: 'toString',
            value: function toString() {
                return '<Layout#' + this.left + ':' + this.right + ';' + this.top + ':' + this.bottom + ';' + this.width + ':' + this.height + '>';
            }
        }
    ]);
    return Layout;
}();
var Size = function() {
    _createClass(Size, null, [
        {
            key: 'fromJS',
            value: function fromJS(_ref) {
                var width = _ref.width, height = _ref.height;
                return new Size(width, height);
            }
        }
    ]);
    function Size(width, height) {
        _classCallCheck(this, Size);
        this.width = width;
        this.height = height;
    }
    _createClass(Size, [
        {
            key: 'fromJS',
            value: function fromJS(expose) {
                expose(this.width, this.height);
            }
        },
        {
            key: 'toString',
            value: function toString() {
                return '<Size#' + this.width + 'x' + this.height + '>';
            }
        }
    ]);
    return Size;
}();
var Value = function() {
    function Value(unit, value) {
        _classCallCheck(this, Value);
        this.unit = unit;
        this.value = value;
    }
    _createClass(Value, [
        {
            key: 'fromJS',
            value: function fromJS(expose) {
                expose(this.unit, this.value);
            }
        },
        {
            key: 'toString',
            value: function toString() {
                switch(this.unit){
                    case CONSTANTS.UNIT_POINT:
                        return String(this.value);
                    case CONSTANTS.UNIT_PERCENT:
                        return this.value + '%';
                    case CONSTANTS.UNIT_AUTO:
                        return 'auto';
                    default:
                        return this.value + '?';
                }
            }
        },
        {
            key: 'valueOf',
            value: function valueOf() {
                return this.value;
            }
        }
    ]);
    return Value;
}();
module.exports = function(bind, lib) {
    function patch(prototype, name, fn) {
        var original = prototype[name];
        prototype[name] = function() {
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return fn.call.apply(fn, [
                this,
                original
            ].concat(args));
        };
    }
    var _arr = [
        'setPosition',
        'setMargin',
        'setFlexBasis',
        'setWidth',
        'setHeight',
        'setMinWidth',
        'setMinHeight',
        'setMaxWidth',
        'setMaxHeight',
        'setPadding'
    ];
    var _loop = function _loop() {
        var _methods;
        var fnName = _arr[_i];
        var methods = (_methods = {}, _defineProperty(_methods, CONSTANTS.UNIT_POINT, lib.Node.prototype[fnName]), _defineProperty(_methods, CONSTANTS.UNIT_PERCENT, lib.Node.prototype[fnName + 'Percent']), _defineProperty(_methods, CONSTANTS.UNIT_AUTO, lib.Node.prototype[fnName + 'Auto']), _methods);
        patch(lib.Node.prototype, fnName, function(original) {
            for(var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            // We patch all these functions to add support for the following calls:
            // .setWidth(100) / .setWidth("100%") / .setWidth(.getWidth()) / .setWidth("auto")
            var value = args.pop();
            var unit = void 0, asNumber = void 0;
            if (value === 'auto') {
                unit = CONSTANTS.UNIT_AUTO;
                asNumber = undefined;
            } else if (value instanceof Value) {
                unit = value.unit;
                asNumber = value.valueOf();
            } else {
                unit = typeof value === 'string' && value.endsWith('%') ? CONSTANTS.UNIT_PERCENT : CONSTANTS.UNIT_POINT;
                asNumber = parseFloat(value);
                if (!Number.isNaN(value) && Number.isNaN(asNumber)) throw new Error('Invalid value ' + value + ' for ' + fnName);
            }
            if (!methods[unit]) throw new Error('Failed to execute "' + fnName + '": Unsupported unit \'' + value + '\'');
            if (asNumber !== undefined) {
                var _methods$unit;
                return (_methods$unit = methods[unit]).call.apply(_methods$unit, [
                    this
                ].concat(args, [
                    asNumber
                ]));
            } else {
                var _methods$unit2;
                return (_methods$unit2 = methods[unit]).call.apply(_methods$unit2, [
                    this
                ].concat(args));
            }
        });
    };
    for(var _i = 0; _i < _arr.length; _i++)_loop();
    patch(lib.Config.prototype, 'free', function() {
        // Since we handle the memory allocation ourselves (via lib.Config.create),
        // we also need to handle the deallocation
        lib.Config.destroy(this);
    });
    patch(lib.Node, 'create', function(_, config) {
        // We decide the constructor we want to call depending on the parameters
        return config ? lib.Node.createWithConfig(config) : lib.Node.createDefault();
    });
    patch(lib.Node.prototype, 'free', function() {
        // Since we handle the memory allocation ourselves (via lib.Node.create),
        // we also need to handle the deallocation
        lib.Node.destroy(this);
    });
    patch(lib.Node.prototype, 'freeRecursive', function() {
        for(var t = 0, T = this.getChildCount(); t < T; ++t)this.getChild(0).freeRecursive();
        this.free();
    });
    patch(lib.Node.prototype, 'setMeasureFunc', function(original, measureFunc) {
        // This patch is just a convenience patch, since it helps write more
        // idiomatic source code (such as .setMeasureFunc(null))
        // We also automatically convert the return value of the measureFunc
        // to a Size object, so that we can return anything that has .width and
        // .height properties
        if (measureFunc) return original.call(this, function() {
            return Size.fromJS(measureFunc.apply(undefined, arguments));
        });
        else return this.unsetMeasureFunc();
    });
    patch(lib.Node.prototype, 'calculateLayout', function(original) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NaN;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NaN;
        var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : CONSTANTS.DIRECTION_LTR;
        // Just a small patch to add support for the function default parameters
        return original.call(this, width, height, direction);
    });
    return _extends({
        Config: lib.Config,
        Node: lib.Node,
        Layout: bind('Layout', Layout),
        Size: bind('Size', Size),
        Value: bind('Value', Value),
        getInstanceCount: function getInstanceCount() {
            return lib.getInstanceCount.apply(lib, arguments);
        }
    }, CONSTANTS);
};

},{"d005afae6344a4ab":"9GfYE"}],"9GfYE":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 * @format
 */ var CONSTANTS = {
    ALIGN_COUNT: 8,
    ALIGN_AUTO: 0,
    ALIGN_FLEX_START: 1,
    ALIGN_CENTER: 2,
    ALIGN_FLEX_END: 3,
    ALIGN_STRETCH: 4,
    ALIGN_BASELINE: 5,
    ALIGN_SPACE_BETWEEN: 6,
    ALIGN_SPACE_AROUND: 7,
    DIMENSION_COUNT: 2,
    DIMENSION_WIDTH: 0,
    DIMENSION_HEIGHT: 1,
    DIRECTION_COUNT: 3,
    DIRECTION_INHERIT: 0,
    DIRECTION_LTR: 1,
    DIRECTION_RTL: 2,
    DISPLAY_COUNT: 2,
    DISPLAY_FLEX: 0,
    DISPLAY_NONE: 1,
    EDGE_COUNT: 9,
    EDGE_LEFT: 0,
    EDGE_TOP: 1,
    EDGE_RIGHT: 2,
    EDGE_BOTTOM: 3,
    EDGE_START: 4,
    EDGE_END: 5,
    EDGE_HORIZONTAL: 6,
    EDGE_VERTICAL: 7,
    EDGE_ALL: 8,
    EXPERIMENTAL_FEATURE_COUNT: 1,
    EXPERIMENTAL_FEATURE_WEB_FLEX_BASIS: 0,
    FLEX_DIRECTION_COUNT: 4,
    FLEX_DIRECTION_COLUMN: 0,
    FLEX_DIRECTION_COLUMN_REVERSE: 1,
    FLEX_DIRECTION_ROW: 2,
    FLEX_DIRECTION_ROW_REVERSE: 3,
    JUSTIFY_COUNT: 6,
    JUSTIFY_FLEX_START: 0,
    JUSTIFY_CENTER: 1,
    JUSTIFY_FLEX_END: 2,
    JUSTIFY_SPACE_BETWEEN: 3,
    JUSTIFY_SPACE_AROUND: 4,
    JUSTIFY_SPACE_EVENLY: 5,
    LOG_LEVEL_COUNT: 6,
    LOG_LEVEL_ERROR: 0,
    LOG_LEVEL_WARN: 1,
    LOG_LEVEL_INFO: 2,
    LOG_LEVEL_DEBUG: 3,
    LOG_LEVEL_VERBOSE: 4,
    LOG_LEVEL_FATAL: 5,
    MEASURE_MODE_COUNT: 3,
    MEASURE_MODE_UNDEFINED: 0,
    MEASURE_MODE_EXACTLY: 1,
    MEASURE_MODE_AT_MOST: 2,
    NODE_TYPE_COUNT: 2,
    NODE_TYPE_DEFAULT: 0,
    NODE_TYPE_TEXT: 1,
    OVERFLOW_COUNT: 3,
    OVERFLOW_VISIBLE: 0,
    OVERFLOW_HIDDEN: 1,
    OVERFLOW_SCROLL: 2,
    POSITION_TYPE_COUNT: 2,
    POSITION_TYPE_RELATIVE: 0,
    POSITION_TYPE_ABSOLUTE: 1,
    PRINT_OPTIONS_COUNT: 3,
    PRINT_OPTIONS_LAYOUT: 1,
    PRINT_OPTIONS_STYLE: 2,
    PRINT_OPTIONS_CHILDREN: 4,
    UNIT_COUNT: 4,
    UNIT_UNDEFINED: 0,
    UNIT_POINT: 1,
    UNIT_PERCENT: 2,
    UNIT_AUTO: 3,
    WRAP_COUNT: 3,
    WRAP_NO_WRAP: 0,
    WRAP_WRAP: 1,
    WRAP_WRAP_REVERSE: 2
};
module.exports = CONSTANTS;

},{}],"ase56":[function(require,module,exports,__globalThis) {
var process = require("e9ad461861cad07b");
var Buffer = require("b87b47a1e546bea").Buffer;
(function(root, wrapper) {
    if (typeof define == "function" && define.amd) define([], function() {
        return wrapper;
    });
    else if (0, module.exports) module.exports = wrapper;
    else (root.nbind = root.nbind || {}).init = wrapper;
})(this, function(Module, cb) {
    if (typeof Module == "function") {
        cb = Module;
        Module = {};
    }
    Module.onRuntimeInitialized = function(init, cb) {
        return function() {
            if (init) init.apply(this, arguments);
            try {
                Module.ccall("nbind_init");
            } catch (err) {
                cb(err);
                return;
            }
            cb(null, {
                bind: Module._nbind_value,
                reflect: Module.NBind.reflect,
                queryType: Module.NBind.queryType,
                toggleLightGC: Module.toggleLightGC,
                lib: Module
            });
        };
    }(Module.onRuntimeInitialized, cb);
    var Module;
    if (!Module) Module = (typeof Module !== "undefined" ? Module : null) || {};
    var moduleOverrides = {};
    for(var key in Module)if (Module.hasOwnProperty(key)) moduleOverrides[key] = Module[key];
    var ENVIRONMENT_IS_WEB = false;
    var ENVIRONMENT_IS_WORKER = false;
    var ENVIRONMENT_IS_NODE = false;
    var ENVIRONMENT_IS_SHELL = false;
    if (Module["ENVIRONMENT"]) {
        if (Module["ENVIRONMENT"] === "WEB") ENVIRONMENT_IS_WEB = true;
        else if (Module["ENVIRONMENT"] === "WORKER") ENVIRONMENT_IS_WORKER = true;
        else if (Module["ENVIRONMENT"] === "NODE") ENVIRONMENT_IS_NODE = true;
        else if (Module["ENVIRONMENT"] === "SHELL") ENVIRONMENT_IS_SHELL = true;
        else throw new Error("The provided Module['ENVIRONMENT'] value is not valid. It must be one of: WEB|WORKER|NODE|SHELL.");
    } else {
        ENVIRONMENT_IS_WEB = typeof window === "object";
        ENVIRONMENT_IS_WORKER = typeof importScripts === "function";
        ENVIRONMENT_IS_NODE = typeof process === "object" && true && !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_WORKER;
        ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;
    }
    if (ENVIRONMENT_IS_NODE) {
        if (!Module["print"]) Module["print"] = console.log;
        if (!Module["printErr"]) Module["printErr"] = console.warn;
        var nodeFS;
        var nodePath;
        Module["read"] = function shell_read(filename, binary) {
            if (!nodeFS) nodeFS = ({})("");
            if (!nodePath) nodePath = ({})("");
            filename = nodePath["normalize"](filename);
            var ret = nodeFS["readFileSync"](filename);
            return binary ? ret : ret.toString();
        };
        Module["readBinary"] = function readBinary(filename) {
            var ret = Module["read"](filename, true);
            if (!ret.buffer) ret = new Uint8Array(ret);
            assert(ret.buffer);
            return ret;
        };
        Module["load"] = function load(f) {
            globalEval(read(f));
        };
        if (!Module["thisProgram"]) {
            if (process["argv"].length > 1) Module["thisProgram"] = process["argv"][1].replace(/\\/g, "/");
            else Module["thisProgram"] = "unknown-program";
        }
        Module["arguments"] = process["argv"].slice(2);
        module["exports"] = Module;
        process["on"]("uncaughtException", function(ex) {
            if (!(ex instanceof ExitStatus)) throw ex;
        });
        Module["inspect"] = function() {
            return "[Emscripten Module object]";
        };
    } else if (ENVIRONMENT_IS_SHELL) {
        if (!Module["print"]) Module["print"] = print;
        if (typeof printErr != "undefined") Module["printErr"] = printErr;
        if (typeof read != "undefined") Module["read"] = read;
        else Module["read"] = function shell_read() {
            throw "no read() available";
        };
        Module["readBinary"] = function readBinary(f) {
            if (typeof readbuffer === "function") return new Uint8Array(readbuffer(f));
            var data = read(f, "binary");
            assert(typeof data === "object");
            return data;
        };
        if (typeof scriptArgs != "undefined") Module["arguments"] = scriptArgs;
        else if (typeof arguments != "undefined") Module["arguments"] = arguments;
        if (typeof quit === "function") Module["quit"] = function(status, toThrow) {
            quit(status);
        };
    } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
        Module["read"] = function shell_read(url) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false);
            xhr.send(null);
            return xhr.responseText;
        };
        if (ENVIRONMENT_IS_WORKER) Module["readBinary"] = function readBinary(url) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, false);
            xhr.responseType = "arraybuffer";
            xhr.send(null);
            return new Uint8Array(xhr.response);
        };
        Module["readAsync"] = function readAsync(url, onload, onerror) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "arraybuffer";
            xhr.onload = function xhr_onload() {
                if (xhr.status == 200 || xhr.status == 0 && xhr.response) onload(xhr.response);
                else onerror();
            };
            xhr.onerror = onerror;
            xhr.send(null);
        };
        if (typeof arguments != "undefined") Module["arguments"] = arguments;
        if (typeof console !== "undefined") {
            if (!Module["print"]) Module["print"] = function shell_print(x) {
                console.log(x);
            };
            if (!Module["printErr"]) Module["printErr"] = function shell_printErr(x) {
                console.warn(x);
            };
        } else {
            var TRY_USE_DUMP = false;
            if (!Module["print"]) Module["print"] = TRY_USE_DUMP && typeof dump !== "undefined" ? function(x) {
                dump(x);
            } : function(x) {};
        }
        if (ENVIRONMENT_IS_WORKER) Module["load"] = importScripts;
        if (typeof Module["setWindowTitle"] === "undefined") Module["setWindowTitle"] = function(title) {
            document.title = title;
        };
    } else throw "Unknown runtime environment. Where are we?";
    function globalEval(x) {
        eval.call(null, x);
    }
    if (!Module["load"] && Module["read"]) Module["load"] = function load(f) {
        globalEval(Module["read"](f));
    };
    if (!Module["print"]) Module["print"] = function() {};
    if (!Module["printErr"]) Module["printErr"] = Module["print"];
    if (!Module["arguments"]) Module["arguments"] = [];
    if (!Module["thisProgram"]) Module["thisProgram"] = "./this.program";
    if (!Module["quit"]) Module["quit"] = function(status, toThrow) {
        throw toThrow;
    };
    Module.print = Module["print"];
    Module.printErr = Module["printErr"];
    Module["preRun"] = [];
    Module["postRun"] = [];
    for(var key in moduleOverrides)if (moduleOverrides.hasOwnProperty(key)) Module[key] = moduleOverrides[key];
    moduleOverrides = undefined;
    var Runtime = {
        setTempRet0: function(value) {
            tempRet0 = value;
            return value;
        },
        getTempRet0: function() {
            return tempRet0;
        },
        stackSave: function() {
            return STACKTOP;
        },
        stackRestore: function(stackTop) {
            STACKTOP = stackTop;
        },
        getNativeTypeSize: function(type) {
            switch(type){
                case "i1":
                case "i8":
                    return 1;
                case "i16":
                    return 2;
                case "i32":
                    return 4;
                case "i64":
                    return 8;
                case "float":
                    return 4;
                case "double":
                    return 8;
                default:
                    if (type[type.length - 1] === "*") return Runtime.QUANTUM_SIZE;
                    else if (type[0] === "i") {
                        var bits = parseInt(type.substr(1));
                        assert(bits % 8 === 0);
                        return bits / 8;
                    } else return 0;
            }
        },
        getNativeFieldSize: function(type) {
            return Math.max(Runtime.getNativeTypeSize(type), Runtime.QUANTUM_SIZE);
        },
        STACK_ALIGN: 16,
        prepVararg: function(ptr, type) {
            if (type === "double" || type === "i64") {
                if (ptr & 7) {
                    assert((ptr & 7) === 4);
                    ptr += 4;
                }
            } else assert((ptr & 3) === 0);
            return ptr;
        },
        getAlignSize: function(type, size, vararg) {
            if (!vararg && (type == "i64" || type == "double")) return 8;
            if (!type) return Math.min(size, 8);
            return Math.min(size || (type ? Runtime.getNativeFieldSize(type) : 0), Runtime.QUANTUM_SIZE);
        },
        dynCall: function(sig, ptr, args) {
            if (args && args.length) return Module["dynCall_" + sig].apply(null, [
                ptr
            ].concat(args));
            else return Module["dynCall_" + sig].call(null, ptr);
        },
        functionPointers: [],
        addFunction: function(func) {
            for(var i = 0; i < Runtime.functionPointers.length; i++)if (!Runtime.functionPointers[i]) {
                Runtime.functionPointers[i] = func;
                return 2 * (1 + i);
            }
            throw "Finished up all reserved function pointers. Use a higher value for RESERVED_FUNCTION_POINTERS.";
        },
        removeFunction: function(index) {
            Runtime.functionPointers[(index - 2) / 2] = null;
        },
        warnOnce: function(text) {
            if (!Runtime.warnOnce.shown) Runtime.warnOnce.shown = {};
            if (!Runtime.warnOnce.shown[text]) {
                Runtime.warnOnce.shown[text] = 1;
                Module.printErr(text);
            }
        },
        funcWrappers: {},
        getFuncWrapper: function(func, sig) {
            if (!func) return;
            assert(sig);
            if (!Runtime.funcWrappers[sig]) Runtime.funcWrappers[sig] = {};
            var sigCache = Runtime.funcWrappers[sig];
            if (!sigCache[func]) {
                if (sig.length === 1) sigCache[func] = function dynCall_wrapper() {
                    return Runtime.dynCall(sig, func);
                };
                else if (sig.length === 2) sigCache[func] = function dynCall_wrapper(arg) {
                    return Runtime.dynCall(sig, func, [
                        arg
                    ]);
                };
                else sigCache[func] = function dynCall_wrapper() {
                    return Runtime.dynCall(sig, func, Array.prototype.slice.call(arguments));
                };
            }
            return sigCache[func];
        },
        getCompilerSetting: function(name) {
            throw "You must build with -s RETAIN_COMPILER_SETTINGS=1 for Runtime.getCompilerSetting or emscripten_get_compiler_setting to work";
        },
        stackAlloc: function(size) {
            var ret = STACKTOP;
            STACKTOP = STACKTOP + size | 0;
            STACKTOP = STACKTOP + 15 & -16;
            return ret;
        },
        staticAlloc: function(size) {
            var ret = STATICTOP;
            STATICTOP = STATICTOP + size | 0;
            STATICTOP = STATICTOP + 15 & -16;
            return ret;
        },
        dynamicAlloc: function(size) {
            var ret = HEAP32[DYNAMICTOP_PTR >> 2];
            var end = (ret + size + 15 | 0) & -16;
            HEAP32[DYNAMICTOP_PTR >> 2] = end;
            if (end >= TOTAL_MEMORY) {
                var success = enlargeMemory();
                if (!success) {
                    HEAP32[DYNAMICTOP_PTR >> 2] = ret;
                    return 0;
                }
            }
            return ret;
        },
        alignMemory: function(size, quantum) {
            var ret = size = Math.ceil(size / (quantum ? quantum : 16)) * (quantum ? quantum : 16);
            return ret;
        },
        makeBigInt: function(low, high, unsigned) {
            var ret = unsigned ? +(low >>> 0) + +(high >>> 0) * 4294967296 : +(low >>> 0) + +(high | 0) * 4294967296;
            return ret;
        },
        GLOBAL_BASE: 8,
        QUANTUM_SIZE: 4,
        __dummy__: 0
    };
    Module["Runtime"] = Runtime;
    var ABORT = 0;
    var EXITSTATUS = 0;
    function assert(condition, text) {
        if (!condition) abort("Assertion failed: " + text);
    }
    function getCFunc(ident) {
        var func = Module["_" + ident];
        if (!func) try {
            func = eval("_" + ident);
        } catch (e) {}
        assert(func, "Cannot call unknown function " + ident + " (perhaps LLVM optimizations or closure removed it?)");
        return func;
    }
    var cwrap, ccall;
    (function() {
        var JSfuncs = {
            "stackSave": function() {
                Runtime.stackSave();
            },
            "stackRestore": function() {
                Runtime.stackRestore();
            },
            "arrayToC": function(arr) {
                var ret = Runtime.stackAlloc(arr.length);
                writeArrayToMemory(arr, ret);
                return ret;
            },
            "stringToC": function(str) {
                var ret = 0;
                if (str !== null && str !== undefined && str !== 0) {
                    var len = (str.length << 2) + 1;
                    ret = Runtime.stackAlloc(len);
                    stringToUTF8(str, ret, len);
                }
                return ret;
            }
        };
        var toC = {
            "string": JSfuncs["stringToC"],
            "array": JSfuncs["arrayToC"]
        };
        ccall = function ccallFunc(ident, returnType, argTypes, args, opts) {
            var func = getCFunc(ident);
            var cArgs = [];
            var stack = 0;
            if (args) for(var i = 0; i < args.length; i++){
                var converter = toC[argTypes[i]];
                if (converter) {
                    if (stack === 0) stack = Runtime.stackSave();
                    cArgs[i] = converter(args[i]);
                } else cArgs[i] = args[i];
            }
            var ret = func.apply(null, cArgs);
            if (returnType === "string") ret = Pointer_stringify(ret);
            if (stack !== 0) {
                if (opts && opts.async) {
                    EmterpreterAsync.asyncFinalizers.push(function() {
                        Runtime.stackRestore(stack);
                    });
                    return;
                }
                Runtime.stackRestore(stack);
            }
            return ret;
        };
        var sourceRegex = /^function\s*[a-zA-Z$_0-9]*\s*\(([^)]*)\)\s*{\s*([^*]*?)[\s;]*(?:return\s*(.*?)[;\s]*)?}$/;
        function parseJSFunc(jsfunc) {
            var parsed = jsfunc.toString().match(sourceRegex).slice(1);
            return {
                arguments: parsed[0],
                body: parsed[1],
                returnValue: parsed[2]
            };
        }
        var JSsource = null;
        function ensureJSsource() {
            if (!JSsource) {
                JSsource = {};
                for(var fun in JSfuncs)if (JSfuncs.hasOwnProperty(fun)) JSsource[fun] = parseJSFunc(JSfuncs[fun]);
            }
        }
        cwrap = function cwrap(ident, returnType, argTypes) {
            argTypes = argTypes || [];
            var cfunc = getCFunc(ident);
            var numericArgs = argTypes.every(function(type) {
                return type === "number";
            });
            var numericRet = returnType !== "string";
            if (numericRet && numericArgs) return cfunc;
            var argNames = argTypes.map(function(x, i) {
                return "$" + i;
            });
            var funcstr = "(function(" + argNames.join(",") + ") {";
            var nargs = argTypes.length;
            if (!numericArgs) {
                ensureJSsource();
                funcstr += "var stack = " + JSsource["stackSave"].body + ";";
                for(var i = 0; i < nargs; i++){
                    var arg = argNames[i], type = argTypes[i];
                    if (type === "number") continue;
                    var convertCode = JSsource[type + "ToC"];
                    funcstr += "var " + convertCode.arguments + " = " + arg + ";";
                    funcstr += convertCode.body + ";";
                    funcstr += arg + "=(" + convertCode.returnValue + ");";
                }
            }
            var cfuncname = parseJSFunc(function() {
                return cfunc;
            }).returnValue;
            funcstr += "var ret = " + cfuncname + "(" + argNames.join(",") + ");";
            if (!numericRet) {
                var strgfy = parseJSFunc(function() {
                    return Pointer_stringify;
                }).returnValue;
                funcstr += "ret = " + strgfy + "(ret);";
            }
            if (!numericArgs) {
                ensureJSsource();
                funcstr += JSsource["stackRestore"].body.replace("()", "(stack)") + ";";
            }
            funcstr += "return ret})";
            return eval(funcstr);
        };
    })();
    Module["ccall"] = ccall;
    Module["cwrap"] = cwrap;
    function setValue(ptr, value, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                HEAP8[ptr >> 0] = value;
                break;
            case "i8":
                HEAP8[ptr >> 0] = value;
                break;
            case "i16":
                HEAP16[ptr >> 1] = value;
                break;
            case "i32":
                HEAP32[ptr >> 2] = value;
                break;
            case "i64":
                tempI64 = [
                    value >>> 0,
                    (tempDouble = value, +Math_abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math_min(+Math_floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math_ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)
                ], HEAP32[ptr >> 2] = tempI64[0], HEAP32[ptr + 4 >> 2] = tempI64[1];
                break;
            case "float":
                HEAPF32[ptr >> 2] = value;
                break;
            case "double":
                HEAPF64[ptr >> 3] = value;
                break;
            default:
                abort("invalid type for setValue: " + type);
        }
    }
    Module["setValue"] = setValue;
    function getValue(ptr, type, noSafe) {
        type = type || "i8";
        if (type.charAt(type.length - 1) === "*") type = "i32";
        switch(type){
            case "i1":
                return HEAP8[ptr >> 0];
            case "i8":
                return HEAP8[ptr >> 0];
            case "i16":
                return HEAP16[ptr >> 1];
            case "i32":
                return HEAP32[ptr >> 2];
            case "i64":
                return HEAP32[ptr >> 2];
            case "float":
                return HEAPF32[ptr >> 2];
            case "double":
                return HEAPF64[ptr >> 3];
            default:
                abort("invalid type for setValue: " + type);
        }
        return null;
    }
    Module["getValue"] = getValue;
    var ALLOC_NORMAL = 0;
    var ALLOC_STACK = 1;
    var ALLOC_STATIC = 2;
    var ALLOC_DYNAMIC = 3;
    var ALLOC_NONE = 4;
    Module["ALLOC_NORMAL"] = ALLOC_NORMAL;
    Module["ALLOC_STACK"] = ALLOC_STACK;
    Module["ALLOC_STATIC"] = ALLOC_STATIC;
    Module["ALLOC_DYNAMIC"] = ALLOC_DYNAMIC;
    Module["ALLOC_NONE"] = ALLOC_NONE;
    function allocate(slab, types, allocator, ptr) {
        var zeroinit, size;
        if (typeof slab === "number") {
            zeroinit = true;
            size = slab;
        } else {
            zeroinit = false;
            size = slab.length;
        }
        var singleType = typeof types === "string" ? types : null;
        var ret;
        if (allocator == ALLOC_NONE) ret = ptr;
        else ret = [
            typeof _malloc === "function" ? _malloc : Runtime.staticAlloc,
            Runtime.stackAlloc,
            Runtime.staticAlloc,
            Runtime.dynamicAlloc
        ][allocator === undefined ? ALLOC_STATIC : allocator](Math.max(size, singleType ? 1 : types.length));
        if (zeroinit) {
            var ptr = ret, stop;
            assert((ret & 3) == 0);
            stop = ret + (size & -4);
            for(; ptr < stop; ptr += 4)HEAP32[ptr >> 2] = 0;
            stop = ret + size;
            while(ptr < stop)HEAP8[ptr++ >> 0] = 0;
            return ret;
        }
        if (singleType === "i8") {
            if (slab.subarray || slab.slice) HEAPU8.set(slab, ret);
            else HEAPU8.set(new Uint8Array(slab), ret);
            return ret;
        }
        var i = 0, type, typeSize, previousType;
        while(i < size){
            var curr = slab[i];
            if (typeof curr === "function") curr = Runtime.getFunctionIndex(curr);
            type = singleType || types[i];
            if (type === 0) {
                i++;
                continue;
            }
            if (type == "i64") type = "i32";
            setValue(ret + i, curr, type);
            if (previousType !== type) {
                typeSize = Runtime.getNativeTypeSize(type);
                previousType = type;
            }
            i += typeSize;
        }
        return ret;
    }
    Module["allocate"] = allocate;
    function getMemory(size) {
        if (!staticSealed) return Runtime.staticAlloc(size);
        if (!runtimeInitialized) return Runtime.dynamicAlloc(size);
        return _malloc(size);
    }
    Module["getMemory"] = getMemory;
    function Pointer_stringify(ptr, length) {
        if (length === 0 || !ptr) return "";
        var hasUtf = 0;
        var t;
        var i = 0;
        while(true){
            t = HEAPU8[ptr + i >> 0];
            hasUtf |= t;
            if (t == 0 && !length) break;
            i++;
            if (length && i == length) break;
        }
        if (!length) length = i;
        var ret = "";
        if (hasUtf < 128) {
            var MAX_CHUNK = 1024;
            var curr;
            while(length > 0){
                curr = String.fromCharCode.apply(String, HEAPU8.subarray(ptr, ptr + Math.min(length, MAX_CHUNK)));
                ret = ret ? ret + curr : curr;
                ptr += MAX_CHUNK;
                length -= MAX_CHUNK;
            }
            return ret;
        }
        return Module["UTF8ToString"](ptr);
    }
    Module["Pointer_stringify"] = Pointer_stringify;
    function AsciiToString(ptr) {
        var str = "";
        while(true){
            var ch = HEAP8[ptr++ >> 0];
            if (!ch) return str;
            str += String.fromCharCode(ch);
        }
    }
    Module["AsciiToString"] = AsciiToString;
    function stringToAscii(str, outPtr) {
        return writeAsciiToMemory(str, outPtr, false);
    }
    Module["stringToAscii"] = stringToAscii;
    var UTF8Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf8") : undefined;
    function UTF8ArrayToString(u8Array, idx) {
        var endPtr = idx;
        while(u8Array[endPtr])++endPtr;
        if (endPtr - idx > 16 && u8Array.subarray && UTF8Decoder) return UTF8Decoder.decode(u8Array.subarray(idx, endPtr));
        else {
            var u0, u1, u2, u3, u4, u5;
            var str = "";
            while(true){
                u0 = u8Array[idx++];
                if (!u0) return str;
                if (!(u0 & 128)) {
                    str += String.fromCharCode(u0);
                    continue;
                }
                u1 = u8Array[idx++] & 63;
                if ((u0 & 224) == 192) {
                    str += String.fromCharCode((u0 & 31) << 6 | u1);
                    continue;
                }
                u2 = u8Array[idx++] & 63;
                if ((u0 & 240) == 224) u0 = (u0 & 15) << 12 | u1 << 6 | u2;
                else {
                    u3 = u8Array[idx++] & 63;
                    if ((u0 & 248) == 240) u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | u3;
                    else {
                        u4 = u8Array[idx++] & 63;
                        if ((u0 & 252) == 248) u0 = (u0 & 3) << 24 | u1 << 18 | u2 << 12 | u3 << 6 | u4;
                        else {
                            u5 = u8Array[idx++] & 63;
                            u0 = (u0 & 1) << 30 | u1 << 24 | u2 << 18 | u3 << 12 | u4 << 6 | u5;
                        }
                    }
                }
                if (u0 < 65536) str += String.fromCharCode(u0);
                else {
                    var ch = u0 - 65536;
                    str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
                }
            }
        }
    }
    Module["UTF8ArrayToString"] = UTF8ArrayToString;
    function UTF8ToString(ptr) {
        return UTF8ArrayToString(HEAPU8, ptr);
    }
    Module["UTF8ToString"] = UTF8ToString;
    function stringToUTF8Array(str, outU8Array, outIdx, maxBytesToWrite) {
        if (!(maxBytesToWrite > 0)) return 0;
        var startIdx = outIdx;
        var endIdx = outIdx + maxBytesToWrite - 1;
        for(var i = 0; i < str.length; ++i){
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) u = 65536 + ((u & 1023) << 10) | str.charCodeAt(++i) & 1023;
            if (u <= 127) {
                if (outIdx >= endIdx) break;
                outU8Array[outIdx++] = u;
            } else if (u <= 2047) {
                if (outIdx + 1 >= endIdx) break;
                outU8Array[outIdx++] = 192 | u >> 6;
                outU8Array[outIdx++] = 128 | u & 63;
            } else if (u <= 65535) {
                if (outIdx + 2 >= endIdx) break;
                outU8Array[outIdx++] = 224 | u >> 12;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            } else if (u <= 2097151) {
                if (outIdx + 3 >= endIdx) break;
                outU8Array[outIdx++] = 240 | u >> 18;
                outU8Array[outIdx++] = 128 | u >> 12 & 63;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            } else if (u <= 67108863) {
                if (outIdx + 4 >= endIdx) break;
                outU8Array[outIdx++] = 248 | u >> 24;
                outU8Array[outIdx++] = 128 | u >> 18 & 63;
                outU8Array[outIdx++] = 128 | u >> 12 & 63;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            } else {
                if (outIdx + 5 >= endIdx) break;
                outU8Array[outIdx++] = 252 | u >> 30;
                outU8Array[outIdx++] = 128 | u >> 24 & 63;
                outU8Array[outIdx++] = 128 | u >> 18 & 63;
                outU8Array[outIdx++] = 128 | u >> 12 & 63;
                outU8Array[outIdx++] = 128 | u >> 6 & 63;
                outU8Array[outIdx++] = 128 | u & 63;
            }
        }
        outU8Array[outIdx] = 0;
        return outIdx - startIdx;
    }
    Module["stringToUTF8Array"] = stringToUTF8Array;
    function stringToUTF8(str, outPtr, maxBytesToWrite) {
        return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
    }
    Module["stringToUTF8"] = stringToUTF8;
    function lengthBytesUTF8(str) {
        var len = 0;
        for(var i = 0; i < str.length; ++i){
            var u = str.charCodeAt(i);
            if (u >= 55296 && u <= 57343) u = 65536 + ((u & 1023) << 10) | str.charCodeAt(++i) & 1023;
            if (u <= 127) ++len;
            else if (u <= 2047) len += 2;
            else if (u <= 65535) len += 3;
            else if (u <= 2097151) len += 4;
            else if (u <= 67108863) len += 5;
            else len += 6;
        }
        return len;
    }
    Module["lengthBytesUTF8"] = lengthBytesUTF8;
    var UTF16Decoder = typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le") : undefined;
    function demangle(func) {
        var __cxa_demangle_func = Module["___cxa_demangle"] || Module["__cxa_demangle"];
        if (__cxa_demangle_func) {
            try {
                var s = func.substr(1);
                var len = lengthBytesUTF8(s) + 1;
                var buf = _malloc(len);
                stringToUTF8(s, buf, len);
                var status = _malloc(4);
                var ret = __cxa_demangle_func(buf, 0, 0, status);
                if (getValue(status, "i32") === 0 && ret) return Pointer_stringify(ret);
            } catch (e) {} finally{
                if (buf) _free(buf);
                if (status) _free(status);
                if (ret) _free(ret);
            }
            return func;
        }
        Runtime.warnOnce("warning: build with  -s DEMANGLE_SUPPORT=1  to link in libcxxabi demangling");
        return func;
    }
    function demangleAll(text) {
        var regex = /__Z[\w\d_]+/g;
        return text.replace(regex, function(x) {
            var y = demangle(x);
            return x === y ? x : x + " [" + y + "]";
        });
    }
    function jsStackTrace() {
        var err = new Error();
        if (!err.stack) {
            try {
                throw new Error(0);
            } catch (e) {
                err = e;
            }
            if (!err.stack) return "(no stack trace available)";
        }
        return err.stack.toString();
    }
    function stackTrace() {
        var js = jsStackTrace();
        if (Module["extraStackTrace"]) js += "\n" + Module["extraStackTrace"]();
        return demangleAll(js);
    }
    Module["stackTrace"] = stackTrace;
    var HEAP, buffer, HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;
    function updateGlobalBufferViews() {
        Module["HEAP8"] = HEAP8 = new Int8Array(buffer);
        Module["HEAP16"] = HEAP16 = new Int16Array(buffer);
        Module["HEAP32"] = HEAP32 = new Int32Array(buffer);
        Module["HEAPU8"] = HEAPU8 = new Uint8Array(buffer);
        Module["HEAPU16"] = HEAPU16 = new Uint16Array(buffer);
        Module["HEAPU32"] = HEAPU32 = new Uint32Array(buffer);
        Module["HEAPF32"] = HEAPF32 = new Float32Array(buffer);
        Module["HEAPF64"] = HEAPF64 = new Float64Array(buffer);
    }
    var STATIC_BASE, STATICTOP, staticSealed;
    var STACK_BASE, STACKTOP, STACK_MAX;
    var DYNAMIC_BASE, DYNAMICTOP_PTR;
    STATIC_BASE = STATICTOP = STACK_BASE = STACKTOP = STACK_MAX = DYNAMIC_BASE = DYNAMICTOP_PTR = 0;
    staticSealed = false;
    function abortOnCannotGrowMemory() {
        abort("Cannot enlarge memory arrays. Either (1) compile with  -s TOTAL_MEMORY=X  with X higher than the current value " + TOTAL_MEMORY + ", (2) compile with  -s ALLOW_MEMORY_GROWTH=1  which allows increasing the size at runtime but prevents some optimizations, (3) set Module.TOTAL_MEMORY to a higher value before the program runs, or (4) if you want malloc to return NULL (0) instead of this abort, compile with  -s ABORTING_MALLOC=0 ");
    }
    function enlargeMemory() {
        abortOnCannotGrowMemory();
    }
    var TOTAL_STACK = Module["TOTAL_STACK"] || 5242880;
    var TOTAL_MEMORY = Module["TOTAL_MEMORY"] || 268435456;
    if (TOTAL_MEMORY < TOTAL_STACK) Module.printErr("TOTAL_MEMORY should be larger than TOTAL_STACK, was " + TOTAL_MEMORY + "! (TOTAL_STACK=" + TOTAL_STACK + ")");
    if (Module["buffer"]) buffer = Module["buffer"];
    else buffer = new ArrayBuffer(TOTAL_MEMORY);
    updateGlobalBufferViews();
    function getTotalMemory() {
        return TOTAL_MEMORY;
    }
    HEAP32[0] = 1668509029;
    HEAP16[1] = 25459;
    if (HEAPU8[2] !== 115 || HEAPU8[3] !== 99) throw "Runtime error: expected the system to be little-endian!";
    Module["HEAP"] = HEAP;
    Module["buffer"] = buffer;
    Module["HEAP8"] = HEAP8;
    Module["HEAP16"] = HEAP16;
    Module["HEAP32"] = HEAP32;
    Module["HEAPU8"] = HEAPU8;
    Module["HEAPU16"] = HEAPU16;
    Module["HEAPU32"] = HEAPU32;
    Module["HEAPF32"] = HEAPF32;
    Module["HEAPF64"] = HEAPF64;
    function callRuntimeCallbacks(callbacks) {
        while(callbacks.length > 0){
            var callback = callbacks.shift();
            if (typeof callback == "function") {
                callback();
                continue;
            }
            var func = callback.func;
            if (typeof func === "number") {
                if (callback.arg === undefined) Module["dynCall_v"](func);
                else Module["dynCall_vi"](func, callback.arg);
            } else func(callback.arg === undefined ? null : callback.arg);
        }
    }
    var __ATPRERUN__ = [];
    var __ATINIT__ = [];
    var __ATMAIN__ = [];
    var __ATEXIT__ = [];
    var __ATPOSTRUN__ = [];
    var runtimeInitialized = false;
    var runtimeExited = false;
    function preRun() {
        if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [
                Module["preRun"]
            ];
            while(Module["preRun"].length)addOnPreRun(Module["preRun"].shift());
        }
        callRuntimeCallbacks(__ATPRERUN__);
    }
    function ensureInitRuntime() {
        if (runtimeInitialized) return;
        runtimeInitialized = true;
        callRuntimeCallbacks(__ATINIT__);
    }
    function preMain() {
        callRuntimeCallbacks(__ATMAIN__);
    }
    function exitRuntime() {
        callRuntimeCallbacks(__ATEXIT__);
        runtimeExited = true;
    }
    function postRun() {
        if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [
                Module["postRun"]
            ];
            while(Module["postRun"].length)addOnPostRun(Module["postRun"].shift());
        }
        callRuntimeCallbacks(__ATPOSTRUN__);
    }
    function addOnPreRun(cb) {
        __ATPRERUN__.unshift(cb);
    }
    Module["addOnPreRun"] = addOnPreRun;
    function addOnInit(cb) {
        __ATINIT__.unshift(cb);
    }
    Module["addOnInit"] = addOnInit;
    function addOnPreMain(cb) {
        __ATMAIN__.unshift(cb);
    }
    Module["addOnPreMain"] = addOnPreMain;
    function addOnExit(cb) {
        __ATEXIT__.unshift(cb);
    }
    Module["addOnExit"] = addOnExit;
    function addOnPostRun(cb) {
        __ATPOSTRUN__.unshift(cb);
    }
    Module["addOnPostRun"] = addOnPostRun;
    function intArrayFromString(stringy, dontAddNull, length) {
        var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
        var u8array = new Array(len);
        var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
        if (dontAddNull) u8array.length = numBytesWritten;
        return u8array;
    }
    Module["intArrayFromString"] = intArrayFromString;
    function intArrayToString(array) {
        var ret = [];
        for(var i = 0; i < array.length; i++){
            var chr = array[i];
            if (chr > 255) chr &= 255;
            ret.push(String.fromCharCode(chr));
        }
        return ret.join("");
    }
    Module["intArrayToString"] = intArrayToString;
    function writeStringToMemory(string, buffer, dontAddNull) {
        Runtime.warnOnce("writeStringToMemory is deprecated and should not be called! Use stringToUTF8() instead!");
        var lastChar, end;
        if (dontAddNull) {
            end = buffer + lengthBytesUTF8(string);
            lastChar = HEAP8[end];
        }
        stringToUTF8(string, buffer, Infinity);
        if (dontAddNull) HEAP8[end] = lastChar;
    }
    Module["writeStringToMemory"] = writeStringToMemory;
    function writeArrayToMemory(array, buffer) {
        HEAP8.set(array, buffer);
    }
    Module["writeArrayToMemory"] = writeArrayToMemory;
    function writeAsciiToMemory(str, buffer, dontAddNull) {
        for(var i = 0; i < str.length; ++i)HEAP8[buffer++ >> 0] = str.charCodeAt(i);
        if (!dontAddNull) HEAP8[buffer >> 0] = 0;
    }
    Module["writeAsciiToMemory"] = writeAsciiToMemory;
    if (!Math["imul"] || Math["imul"](4294967295, 5) !== -5) Math["imul"] = function imul(a, b) {
        var ah = a >>> 16;
        var al = a & 65535;
        var bh = b >>> 16;
        var bl = b & 65535;
        return al * bl + (ah * bl + al * bh << 16) | 0;
    };
    Math.imul = Math["imul"];
    if (!Math["fround"]) {
        var froundBuffer = new Float32Array(1);
        Math["fround"] = function(x) {
            froundBuffer[0] = x;
            return froundBuffer[0];
        };
    }
    Math.fround = Math["fround"];
    if (!Math["clz32"]) Math["clz32"] = function(x) {
        x = x >>> 0;
        for(var i = 0; i < 32; i++){
            if (x & 1 << 31 - i) return i;
        }
        return 32;
    };
    Math.clz32 = Math["clz32"];
    if (!Math["trunc"]) Math["trunc"] = function(x) {
        return x < 0 ? Math.ceil(x) : Math.floor(x);
    };
    Math.trunc = Math["trunc"];
    var Math_abs = Math.abs;
    var Math_cos = Math.cos;
    var Math_sin = Math.sin;
    var Math_tan = Math.tan;
    var Math_acos = Math.acos;
    var Math_asin = Math.asin;
    var Math_atan = Math.atan;
    var Math_atan2 = Math.atan2;
    var Math_exp = Math.exp;
    var Math_log = Math.log;
    var Math_sqrt = Math.sqrt;
    var Math_ceil = Math.ceil;
    var Math_floor = Math.floor;
    var Math_pow = Math.pow;
    var Math_imul = Math.imul;
    var Math_fround = Math.fround;
    var Math_round = Math.round;
    var Math_min = Math.min;
    var Math_clz32 = Math.clz32;
    var Math_trunc = Math.trunc;
    var runDependencies = 0;
    var runDependencyWatcher = null;
    var dependenciesFulfilled = null;
    function getUniqueRunDependency(id) {
        return id;
    }
    function addRunDependency(id) {
        runDependencies++;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
    }
    Module["addRunDependency"] = addRunDependency;
    function removeRunDependency(id) {
        runDependencies--;
        if (Module["monitorRunDependencies"]) Module["monitorRunDependencies"](runDependencies);
        if (runDependencies == 0) {
            if (runDependencyWatcher !== null) {
                clearInterval(runDependencyWatcher);
                runDependencyWatcher = null;
            }
            if (dependenciesFulfilled) {
                var callback = dependenciesFulfilled;
                dependenciesFulfilled = null;
                callback();
            }
        }
    }
    Module["removeRunDependency"] = removeRunDependency;
    Module["preloadedImages"] = {};
    Module["preloadedAudios"] = {};
    var ASM_CONSTS = [
        function($0, $1, $2, $3, $4, $5, $6, $7) {
            return _nbind.callbackSignatureList[$0].apply(this, arguments);
        }
    ];
    function _emscripten_asm_const_iiiiiiii(code, a0, a1, a2, a3, a4, a5, a6) {
        return ASM_CONSTS[code](a0, a1, a2, a3, a4, a5, a6);
    }
    function _emscripten_asm_const_iiiii(code, a0, a1, a2, a3) {
        return ASM_CONSTS[code](a0, a1, a2, a3);
    }
    function _emscripten_asm_const_iiidddddd(code, a0, a1, a2, a3, a4, a5, a6, a7) {
        return ASM_CONSTS[code](a0, a1, a2, a3, a4, a5, a6, a7);
    }
    function _emscripten_asm_const_iiididi(code, a0, a1, a2, a3, a4, a5) {
        return ASM_CONSTS[code](a0, a1, a2, a3, a4, a5);
    }
    function _emscripten_asm_const_iiii(code, a0, a1, a2) {
        return ASM_CONSTS[code](a0, a1, a2);
    }
    function _emscripten_asm_const_iiiid(code, a0, a1, a2, a3) {
        return ASM_CONSTS[code](a0, a1, a2, a3);
    }
    function _emscripten_asm_const_iiiiii(code, a0, a1, a2, a3, a4) {
        return ASM_CONSTS[code](a0, a1, a2, a3, a4);
    }
    STATIC_BASE = Runtime.GLOBAL_BASE;
    STATICTOP = STATIC_BASE + 12800;
    __ATINIT__.push({
        func: function() {
            __GLOBAL__sub_I_Yoga_cpp();
        }
    }, {
        func: function() {
            __GLOBAL__sub_I_nbind_cc();
        }
    }, {
        func: function() {
            __GLOBAL__sub_I_common_cc();
        }
    }, {
        func: function() {
            __GLOBAL__sub_I_Binding_cc();
        }
    });
    allocate([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        192,
        127,
        0,
        0,
        192,
        127,
        0,
        0,
        192,
        127,
        3,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        3,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        3,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        255,
        255,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        255,
        255,
        255,
        255,
        255,
        255,
        255,
        0,
        0,
        128,
        191,
        0,
        0,
        128,
        191,
        0,
        0,
        192,
        127,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        128,
        63,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        190,
        12,
        0,
        0,
        200,
        12,
        0,
        0,
        208,
        12,
        0,
        0,
        216,
        12,
        0,
        0,
        230,
        12,
        0,
        0,
        242,
        12,
        0,
        0,
        1,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        192,
        127,
        3,
        0,
        0,
        0,
        180,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        4,
        0,
        0,
        0,
        183,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        184,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        186,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        148,
        4,
        0,
        0,
        3,
        0,
        0,
        0,
        187,
        45,
        0,
        0,
        164,
        4,
        0,
        0,
        188,
        45,
        0,
        0,
        2,
        0,
        0,
        0,
        189,
        45,
        0,
        0,
        164,
        4,
        0,
        0,
        188,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        164,
        4,
        0,
        0,
        185,
        45,
        0,
        0,
        164,
        4,
        0,
        0,
        188,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        5,
        0,
        0,
        0,
        6,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        7,
        0,
        0,
        0,
        183,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        190,
        45,
        0,
        0,
        190,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        48,
        5,
        0,
        0,
        3,
        0,
        0,
        0,
        56,
        5,
        0,
        0,
        1,
        0,
        0,
        0,
        189,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        164,
        4,
        0,
        0,
        76,
        5,
        0,
        0,
        2,
        0,
        0,
        0,
        191,
        45,
        0,
        0,
        186,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        192,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        186,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        76,
        5,
        0,
        0,
        76,
        5,
        0,
        0,
        136,
        5,
        0,
        0,
        182,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        2,
        0,
        0,
        0,
        190,
        45,
        0,
        0,
        136,
        5,
        0,
        0,
        56,
        19,
        0,
        0,
        156,
        5,
        0,
        0,
        2,
        0,
        0,
        0,
        184,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        8,
        0,
        0,
        0,
        9,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        10,
        0,
        0,
        0,
        204,
        5,
        0,
        0,
        181,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        2,
        0,
        0,
        0,
        180,
        45,
        0,
        0,
        204,
        5,
        0,
        0,
        2,
        0,
        0,
        0,
        195,
        45,
        0,
        0,
        236,
        5,
        0,
        0,
        97,
        19,
        0,
        0,
        198,
        45,
        0,
        0,
        211,
        45,
        0,
        0,
        212,
        45,
        0,
        0,
        213,
        45,
        0,
        0,
        214,
        45,
        0,
        0,
        215,
        45,
        0,
        0,
        188,
        45,
        0,
        0,
        182,
        45,
        0,
        0,
        216,
        45,
        0,
        0,
        217,
        45,
        0,
        0,
        218,
        45,
        0,
        0,
        219,
        45,
        0,
        0,
        192,
        45,
        0,
        0,
        181,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        185,
        45,
        0,
        0,
        110,
        19,
        0,
        0,
        186,
        45,
        0,
        0,
        115,
        19,
        0,
        0,
        221,
        45,
        0,
        0,
        120,
        19,
        0,
        0,
        148,
        4,
        0,
        0,
        132,
        19,
        0,
        0,
        96,
        6,
        0,
        0,
        145,
        19,
        0,
        0,
        222,
        45,
        0,
        0,
        164,
        19,
        0,
        0,
        223,
        45,
        0,
        0,
        173,
        19,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        104,
        6,
        0,
        0,
        1,
        0,
        0,
        0,
        187,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        11,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        13,
        0,
        0,
        0,
        185,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        164,
        6,
        0,
        0,
        188,
        45,
        0,
        0,
        172,
        6,
        0,
        0,
        180,
        6,
        0,
        0,
        2,
        0,
        0,
        0,
        188,
        6,
        0,
        0,
        7,
        0,
        0,
        0,
        224,
        45,
        0,
        0,
        7,
        0,
        0,
        0,
        164,
        6,
        0,
        0,
        1,
        0,
        0,
        0,
        213,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        172,
        6,
        0,
        0,
        185,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        164,
        6,
        0,
        0,
        185,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        211,
        45,
        0,
        0,
        211,
        45,
        0,
        0,
        222,
        45,
        0,
        0,
        211,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        222,
        45,
        0,
        0,
        211,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        172,
        6,
        0,
        0,
        222,
        45,
        0,
        0,
        211,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        188,
        45,
        0,
        0,
        222,
        45,
        0,
        0,
        211,
        45,
        0,
        0,
        40,
        7,
        0,
        0,
        188,
        45,
        0,
        0,
        2,
        0,
        0,
        0,
        224,
        45,
        0,
        0,
        185,
        45,
        0,
        0,
        188,
        45,
        0,
        0,
        188,
        45,
        0,
        0,
        188,
        45,
        0,
        0,
        188,
        45,
        0,
        0,
        222,
        45,
        0,
        0,
        224,
        45,
        0,
        0,
        148,
        4,
        0,
        0,
        185,
        45,
        0,
        0,
        148,
        4,
        0,
        0,
        148,
        4,
        0,
        0,
        148,
        4,
        0,
        0,
        148,
        4,
        0,
        0,
        148,
        4,
        0,
        0,
        185,
        45,
        0,
        0,
        164,
        6,
        0,
        0,
        148,
        4,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        14,
        0,
        0,
        0,
        15,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        16,
        0,
        0,
        0,
        148,
        7,
        0,
        0,
        2,
        0,
        0,
        0,
        225,
        45,
        0,
        0,
        183,
        45,
        0,
        0,
        188,
        45,
        0,
        0,
        168,
        7,
        0,
        0,
        5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        234,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        255,
        255,
        255,
        255,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        148,
        45,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        28,
        9,
        0,
        0,
        5,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        242,
        45,
        0,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        10,
        255,
        255,
        255,
        255,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        67,
        111,
        117,
        108,
        100,
        32,
        110,
        111,
        116,
        32,
        97,
        108,
        108,
        111,
        99,
        97,
        116,
        101,
        32,
        109,
        101,
        109,
        111,
        114,
        121,
        32,
        102,
        111,
        114,
        32,
        110,
        111,
        100,
        101,
        0,
        67,
        97,
        110,
        110,
        111,
        116,
        32,
        114,
        101,
        115,
        101,
        116,
        32,
        97,
        32,
        110,
        111,
        100,
        101,
        32,
        119,
        104,
        105,
        99,
        104,
        32,
        115,
        116,
        105,
        108,
        108,
        32,
        104,
        97,
        115,
        32,
        99,
        104,
        105,
        108,
        100,
        114,
        101,
        110,
        32,
        97,
        116,
        116,
        97,
        99,
        104,
        101,
        100,
        0,
        67,
        97,
        110,
        110,
        111,
        116,
        32,
        114,
        101,
        115,
        101,
        116,
        32,
        97,
        32,
        110,
        111,
        100,
        101,
        32,
        115,
        116,
        105,
        108,
        108,
        32,
        97,
        116,
        116,
        97,
        99,
        104,
        101,
        100,
        32,
        116,
        111,
        32,
        97,
        32,
        112,
        97,
        114,
        101,
        110,
        116,
        0,
        67,
        111,
        117,
        108,
        100,
        32,
        110,
        111,
        116,
        32,
        97,
        108,
        108,
        111,
        99,
        97,
        116,
        101,
        32,
        109,
        101,
        109,
        111,
        114,
        121,
        32,
        102,
        111,
        114,
        32,
        99,
        111,
        110,
        102,
        105,
        103,
        0,
        67,
        97,
        110,
        110,
        111,
        116,
        32,
        115,
        101,
        116,
        32,
        109,
        101,
        97,
        115,
        117,
        114,
        101,
        32,
        102,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        58,
        32,
        78,
        111,
        100,
        101,
        115,
        32,
        119,
        105,
        116,
        104,
        32,
        109,
        101,
        97,
        115,
        117,
        114,
        101,
        32,
        102,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        115,
        32,
        99,
        97,
        110,
        110,
        111,
        116,
        32,
        104,
        97,
        118,
        101,
        32,
        99,
        104,
        105,
        108,
        100,
        114,
        101,
        110,
        46,
        0,
        67,
        104,
        105,
        108,
        100,
        32,
        97,
        108,
        114,
        101,
        97,
        100,
        121,
        32,
        104,
        97,
        115,
        32,
        97,
        32,
        112,
        97,
        114,
        101,
        110,
        116,
        44,
        32,
        105,
        116,
        32,
        109,
        117,
        115,
        116,
        32,
        98,
        101,
        32,
        114,
        101,
        109,
        111,
        118,
        101,
        100,
        32,
        102,
        105,
        114,
        115,
        116,
        46,
        0,
        67,
        97,
        110,
        110,
        111,
        116,
        32,
        97,
        100,
        100,
        32,
        99,
        104,
        105,
        108,
        100,
        58,
        32,
        78,
        111,
        100,
        101,
        115,
        32,
        119,
        105,
        116,
        104,
        32,
        109,
        101,
        97,
        115,
        117,
        114,
        101,
        32,
        102,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        115,
        32,
        99,
        97,
        110,
        110,
        111,
        116,
        32,
        104,
        97,
        118,
        101,
        32,
        99,
        104,
        105,
        108,
        100,
        114,
        101,
        110,
        46,
        0,
        79,
        110,
        108,
        121,
        32,
        108,
        101,
        97,
        102,
        32,
        110,
        111,
        100,
        101,
        115,
        32,
        119,
        105,
        116,
        104,
        32,
        99,
        117,
        115,
        116,
        111,
        109,
        32,
        109,
        101,
        97,
        115,
        117,
        114,
        101,
        32,
        102,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        115,
        115,
        104,
        111,
        117,
        108,
        100,
        32,
        109,
        97,
        110,
        117,
        97,
        108,
        108,
        121,
        32,
        109,
        97,
        114,
        107,
        32,
        116,
        104,
        101,
        109,
        115,
        101,
        108,
        118,
        101,
        115,
        32,
        97,
        115,
        32,
        100,
        105,
        114,
        116,
        121,
        0,
        67,
        97,
        110,
        110,
        111,
        116,
        32,
        103,
        101,
        116,
        32,
        108,
        97,
        121,
        111,
        117,
        116,
        32,
        112,
        114,
        111,
        112,
        101,
        114,
        116,
        105,
        101,
        115,
        32,
        111,
        102,
        32,
        109,
        117,
        108,
        116,
        105,
        45,
        101,
        100,
        103,
        101,
        32,
        115,
        104,
        111,
        114,
        116,
        104,
        97,
        110,
        100,
        115,
        0,
        37,
        115,
        37,
        100,
        46,
        123,
        91,
        115,
        107,
        105,
        112,
        112,
        101,
        100,
        93,
        32,
        0,
        119,
        109,
        58,
        32,
        37,
        115,
        44,
        32,
        104,
        109,
        58,
        32,
        37,
        115,
        44,
        32,
        97,
        119,
        58,
        32,
        37,
        102,
        32,
        97,
        104,
        58,
        32,
        37,
        102,
        32,
        61,
        62,
        32,
        100,
        58,
        32,
        40,
        37,
        102,
        44,
        32,
        37,
        102,
        41,
        32,
        37,
        115,
        10,
        0,
        37,
        115,
        37,
        100,
        46,
        123,
        37,
        115,
        0,
        42,
        0,
        119,
        109,
        58,
        32,
        37,
        115,
        44,
        32,
        104,
        109,
        58,
        32,
        37,
        115,
        44,
        32,
        97,
        119,
        58,
        32,
        37,
        102,
        32,
        97,
        104,
        58,
        32,
        37,
        102,
        32,
        37,
        115,
        10,
        0,
        37,
        115,
        37,
        100,
        46,
        125,
        37,
        115,
        0,
        119,
        109,
        58,
        32,
        37,
        115,
        44,
        32,
        104,
        109,
        58,
        32,
        37,
        115,
        44,
        32,
        100,
        58,
        32,
        40,
        37,
        102,
        44,
        32,
        37,
        102,
        41,
        32,
        37,
        115,
        10,
        0,
        79,
        117,
        116,
        32,
        111,
        102,
        32,
        99,
        97,
        99,
        104,
        101,
        32,
        101,
        110,
        116,
        114,
        105,
        101,
        115,
        33,
        10,
        0,
        83,
        99,
        97,
        108,
        101,
        32,
        102,
        97,
        99,
        116,
        111,
        114,
        32,
        115,
        104,
        111,
        117,
        108,
        100,
        32,
        110,
        111,
        116,
        32,
        98,
        101,
        32,
        108,
        101,
        115,
        115,
        32,
        116,
        104,
        97,
        110,
        32,
        122,
        101,
        114,
        111,
        0,
        105,
        110,
        105,
        116,
        105,
        97,
        108,
        0,
        37,
        115,
        10,
        0,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        32,
        0,
        85,
        78,
        68,
        69,
        70,
        73,
        78,
        69,
        68,
        0,
        69,
        88,
        65,
        67,
        84,
        76,
        89,
        0,
        65,
        84,
        95,
        77,
        79,
        83,
        84,
        0,
        76,
        65,
        89,
        95,
        85,
        78,
        68,
        69,
        70,
        73,
        78,
        69,
        68,
        0,
        76,
        65,
        89,
        95,
        69,
        88,
        65,
        67,
        84,
        76,
        89,
        0,
        76,
        65,
        89,
        95,
        65,
        84,
        95,
        77,
        79,
        83,
        84,
        0,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        87,
        105,
        100,
        116,
        104,
        32,
        105,
        115,
        32,
        105,
        110,
        100,
        101,
        102,
        105,
        110,
        105,
        116,
        101,
        32,
        115,
        111,
        32,
        119,
        105,
        100,
        116,
        104,
        77,
        101,
        97,
        115,
        117,
        114,
        101,
        77,
        111,
        100,
        101,
        32,
        109,
        117,
        115,
        116,
        32,
        98,
        101,
        32,
        89,
        71,
        77,
        101,
        97,
        115,
        117,
        114,
        101,
        77,
        111,
        100,
        101,
        85,
        110,
        100,
        101,
        102,
        105,
        110,
        101,
        100,
        0,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        72,
        101,
        105,
        103,
        104,
        116,
        32,
        105,
        115,
        32,
        105,
        110,
        100,
        101,
        102,
        105,
        110,
        105,
        116,
        101,
        32,
        115,
        111,
        32,
        104,
        101,
        105,
        103,
        104,
        116,
        77,
        101,
        97,
        115,
        117,
        114,
        101,
        77,
        111,
        100,
        101,
        32,
        109,
        117,
        115,
        116,
        32,
        98,
        101,
        32,
        89,
        71,
        77,
        101,
        97,
        115,
        117,
        114,
        101,
        77,
        111,
        100,
        101,
        85,
        110,
        100,
        101,
        102,
        105,
        110,
        101,
        100,
        0,
        102,
        108,
        101,
        120,
        0,
        115,
        116,
        114,
        101,
        116,
        99,
        104,
        0,
        109,
        117,
        108,
        116,
        105,
        108,
        105,
        110,
        101,
        45,
        115,
        116,
        114,
        101,
        116,
        99,
        104,
        0,
        69,
        120,
        112,
        101,
        99,
        116,
        101,
        100,
        32,
        110,
        111,
        100,
        101,
        32,
        116,
        111,
        32,
        104,
        97,
        118,
        101,
        32,
        99,
        117,
        115,
        116,
        111,
        109,
        32,
        109,
        101,
        97,
        115,
        117,
        114,
        101,
        32,
        102,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        0,
        109,
        101,
        97,
        115,
        117,
        114,
        101,
        0,
        69,
        120,
        112,
        101,
        99,
        116,
        32,
        99,
        117,
        115,
        116,
        111,
        109,
        32,
        98,
        97,
        115,
        101,
        108,
        105,
        110,
        101,
        32,
        102,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        32,
        116,
        111,
        32,
        110,
        111,
        116,
        32,
        114,
        101,
        116,
        117,
        114,
        110,
        32,
        78,
        97,
        78,
        0,
        97,
        98,
        115,
        45,
        109,
        101,
        97,
        115,
        117,
        114,
        101,
        0,
        97,
        98,
        115,
        45,
        108,
        97,
        121,
        111,
        117,
        116,
        0,
        78,
        111,
        100,
        101,
        0,
        99,
        114,
        101,
        97,
        116,
        101,
        68,
        101,
        102,
        97,
        117,
        108,
        116,
        0,
        99,
        114,
        101,
        97,
        116,
        101,
        87,
        105,
        116,
        104,
        67,
        111,
        110,
        102,
        105,
        103,
        0,
        100,
        101,
        115,
        116,
        114,
        111,
        121,
        0,
        114,
        101,
        115,
        101,
        116,
        0,
        99,
        111,
        112,
        121,
        83,
        116,
        121,
        108,
        101,
        0,
        115,
        101,
        116,
        80,
        111,
        115,
        105,
        116,
        105,
        111,
        110,
        84,
        121,
        112,
        101,
        0,
        115,
        101,
        116,
        80,
        111,
        115,
        105,
        116,
        105,
        111,
        110,
        0,
        115,
        101,
        116,
        80,
        111,
        115,
        105,
        116,
        105,
        111,
        110,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        65,
        108,
        105,
        103,
        110,
        67,
        111,
        110,
        116,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        65,
        108,
        105,
        103,
        110,
        73,
        116,
        101,
        109,
        115,
        0,
        115,
        101,
        116,
        65,
        108,
        105,
        103,
        110,
        83,
        101,
        108,
        102,
        0,
        115,
        101,
        116,
        70,
        108,
        101,
        120,
        68,
        105,
        114,
        101,
        99,
        116,
        105,
        111,
        110,
        0,
        115,
        101,
        116,
        70,
        108,
        101,
        120,
        87,
        114,
        97,
        112,
        0,
        115,
        101,
        116,
        74,
        117,
        115,
        116,
        105,
        102,
        121,
        67,
        111,
        110,
        116,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        77,
        97,
        114,
        103,
        105,
        110,
        0,
        115,
        101,
        116,
        77,
        97,
        114,
        103,
        105,
        110,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        77,
        97,
        114,
        103,
        105,
        110,
        65,
        117,
        116,
        111,
        0,
        115,
        101,
        116,
        79,
        118,
        101,
        114,
        102,
        108,
        111,
        119,
        0,
        115,
        101,
        116,
        68,
        105,
        115,
        112,
        108,
        97,
        121,
        0,
        115,
        101,
        116,
        70,
        108,
        101,
        120,
        0,
        115,
        101,
        116,
        70,
        108,
        101,
        120,
        66,
        97,
        115,
        105,
        115,
        0,
        115,
        101,
        116,
        70,
        108,
        101,
        120,
        66,
        97,
        115,
        105,
        115,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        70,
        108,
        101,
        120,
        71,
        114,
        111,
        119,
        0,
        115,
        101,
        116,
        70,
        108,
        101,
        120,
        83,
        104,
        114,
        105,
        110,
        107,
        0,
        115,
        101,
        116,
        87,
        105,
        100,
        116,
        104,
        0,
        115,
        101,
        116,
        87,
        105,
        100,
        116,
        104,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        87,
        105,
        100,
        116,
        104,
        65,
        117,
        116,
        111,
        0,
        115,
        101,
        116,
        72,
        101,
        105,
        103,
        104,
        116,
        0,
        115,
        101,
        116,
        72,
        101,
        105,
        103,
        104,
        116,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        72,
        101,
        105,
        103,
        104,
        116,
        65,
        117,
        116,
        111,
        0,
        115,
        101,
        116,
        77,
        105,
        110,
        87,
        105,
        100,
        116,
        104,
        0,
        115,
        101,
        116,
        77,
        105,
        110,
        87,
        105,
        100,
        116,
        104,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        77,
        105,
        110,
        72,
        101,
        105,
        103,
        104,
        116,
        0,
        115,
        101,
        116,
        77,
        105,
        110,
        72,
        101,
        105,
        103,
        104,
        116,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        77,
        97,
        120,
        87,
        105,
        100,
        116,
        104,
        0,
        115,
        101,
        116,
        77,
        97,
        120,
        87,
        105,
        100,
        116,
        104,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        77,
        97,
        120,
        72,
        101,
        105,
        103,
        104,
        116,
        0,
        115,
        101,
        116,
        77,
        97,
        120,
        72,
        101,
        105,
        103,
        104,
        116,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        115,
        101,
        116,
        65,
        115,
        112,
        101,
        99,
        116,
        82,
        97,
        116,
        105,
        111,
        0,
        115,
        101,
        116,
        66,
        111,
        114,
        100,
        101,
        114,
        0,
        115,
        101,
        116,
        80,
        97,
        100,
        100,
        105,
        110,
        103,
        0,
        115,
        101,
        116,
        80,
        97,
        100,
        100,
        105,
        110,
        103,
        80,
        101,
        114,
        99,
        101,
        110,
        116,
        0,
        103,
        101,
        116,
        80,
        111,
        115,
        105,
        116,
        105,
        111,
        110,
        84,
        121,
        112,
        101,
        0,
        103,
        101,
        116,
        80,
        111,
        115,
        105,
        116,
        105,
        111,
        110,
        0,
        103,
        101,
        116,
        65,
        108,
        105,
        103,
        110,
        67,
        111,
        110,
        116,
        101,
        110,
        116,
        0,
        103,
        101,
        116,
        65,
        108,
        105,
        103,
        110,
        73,
        116,
        101,
        109,
        115,
        0,
        103,
        101,
        116,
        65,
        108,
        105,
        103,
        110,
        83,
        101,
        108,
        102,
        0,
        103,
        101,
        116,
        70,
        108,
        101,
        120,
        68,
        105,
        114,
        101,
        99,
        116,
        105,
        111,
        110,
        0,
        103,
        101,
        116,
        70,
        108,
        101,
        120,
        87,
        114,
        97,
        112,
        0,
        103,
        101,
        116,
        74,
        117,
        115,
        116,
        105,
        102,
        121,
        67,
        111,
        110,
        116,
        101,
        110,
        116,
        0,
        103,
        101,
        116,
        77,
        97,
        114,
        103,
        105,
        110,
        0,
        103,
        101,
        116,
        70,
        108,
        101,
        120,
        66,
        97,
        115,
        105,
        115,
        0,
        103,
        101,
        116,
        70,
        108,
        101,
        120,
        71,
        114,
        111,
        119,
        0,
        103,
        101,
        116,
        70,
        108,
        101,
        120,
        83,
        104,
        114,
        105,
        110,
        107,
        0,
        103,
        101,
        116,
        87,
        105,
        100,
        116,
        104,
        0,
        103,
        101,
        116,
        72,
        101,
        105,
        103,
        104,
        116,
        0,
        103,
        101,
        116,
        77,
        105,
        110,
        87,
        105,
        100,
        116,
        104,
        0,
        103,
        101,
        116,
        77,
        105,
        110,
        72,
        101,
        105,
        103,
        104,
        116,
        0,
        103,
        101,
        116,
        77,
        97,
        120,
        87,
        105,
        100,
        116,
        104,
        0,
        103,
        101,
        116,
        77,
        97,
        120,
        72,
        101,
        105,
        103,
        104,
        116,
        0,
        103,
        101,
        116,
        65,
        115,
        112,
        101,
        99,
        116,
        82,
        97,
        116,
        105,
        111,
        0,
        103,
        101,
        116,
        66,
        111,
        114,
        100,
        101,
        114,
        0,
        103,
        101,
        116,
        79,
        118,
        101,
        114,
        102,
        108,
        111,
        119,
        0,
        103,
        101,
        116,
        68,
        105,
        115,
        112,
        108,
        97,
        121,
        0,
        103,
        101,
        116,
        80,
        97,
        100,
        100,
        105,
        110,
        103,
        0,
        105,
        110,
        115,
        101,
        114,
        116,
        67,
        104,
        105,
        108,
        100,
        0,
        114,
        101,
        109,
        111,
        118,
        101,
        67,
        104,
        105,
        108,
        100,
        0,
        103,
        101,
        116,
        67,
        104,
        105,
        108,
        100,
        67,
        111,
        117,
        110,
        116,
        0,
        103,
        101,
        116,
        80,
        97,
        114,
        101,
        110,
        116,
        0,
        103,
        101,
        116,
        67,
        104,
        105,
        108,
        100,
        0,
        115,
        101,
        116,
        77,
        101,
        97,
        115,
        117,
        114,
        101,
        70,
        117,
        110,
        99,
        0,
        117,
        110,
        115,
        101,
        116,
        77,
        101,
        97,
        115,
        117,
        114,
        101,
        70,
        117,
        110,
        99,
        0,
        109,
        97,
        114,
        107,
        68,
        105,
        114,
        116,
        121,
        0,
        105,
        115,
        68,
        105,
        114,
        116,
        121,
        0,
        99,
        97,
        108,
        99,
        117,
        108,
        97,
        116,
        101,
        76,
        97,
        121,
        111,
        117,
        116,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        76,
        101,
        102,
        116,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        82,
        105,
        103,
        104,
        116,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        84,
        111,
        112,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        66,
        111,
        116,
        116,
        111,
        109,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        87,
        105,
        100,
        116,
        104,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        72,
        101,
        105,
        103,
        104,
        116,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        76,
        97,
        121,
        111,
        117,
        116,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        77,
        97,
        114,
        103,
        105,
        110,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        66,
        111,
        114,
        100,
        101,
        114,
        0,
        103,
        101,
        116,
        67,
        111,
        109,
        112,
        117,
        116,
        101,
        100,
        80,
        97,
        100,
        100,
        105,
        110,
        103,
        0,
        67,
        111,
        110,
        102,
        105,
        103,
        0,
        99,
        114,
        101,
        97,
        116,
        101,
        0,
        115,
        101,
        116,
        69,
        120,
        112,
        101,
        114,
        105,
        109,
        101,
        110,
        116,
        97,
        108,
        70,
        101,
        97,
        116,
        117,
        114,
        101,
        69,
        110,
        97,
        98,
        108,
        101,
        100,
        0,
        115,
        101,
        116,
        80,
        111,
        105,
        110,
        116,
        83,
        99,
        97,
        108,
        101,
        70,
        97,
        99,
        116,
        111,
        114,
        0,
        105,
        115,
        69,
        120,
        112,
        101,
        114,
        105,
        109,
        101,
        110,
        116,
        97,
        108,
        70,
        101,
        97,
        116,
        117,
        114,
        101,
        69,
        110,
        97,
        98,
        108,
        101,
        100,
        0,
        86,
        97,
        108,
        117,
        101,
        0,
        76,
        97,
        121,
        111,
        117,
        116,
        0,
        83,
        105,
        122,
        101,
        0,
        103,
        101,
        116,
        73,
        110,
        115,
        116,
        97,
        110,
        99,
        101,
        67,
        111,
        117,
        110,
        116,
        0,
        73,
        110,
        116,
        54,
        52,
        0,
        1,
        1,
        1,
        2,
        2,
        4,
        4,
        4,
        4,
        8,
        8,
        4,
        8,
        118,
        111,
        105,
        100,
        0,
        98,
        111,
        111,
        108,
        0,
        115,
        116,
        100,
        58,
        58,
        115,
        116,
        114,
        105,
        110,
        103,
        0,
        99,
        98,
        70,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        32,
        38,
        0,
        99,
        111,
        110,
        115,
        116,
        32,
        99,
        98,
        70,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        32,
        38,
        0,
        69,
        120,
        116,
        101,
        114,
        110,
        97,
        108,
        0,
        66,
        117,
        102,
        102,
        101,
        114,
        0,
        78,
        66,
        105,
        110,
        100,
        73,
        68,
        0,
        78,
        66,
        105,
        110,
        100,
        0,
        98,
        105,
        110,
        100,
        95,
        118,
        97,
        108,
        117,
        101,
        0,
        114,
        101,
        102,
        108,
        101,
        99,
        116,
        0,
        113,
        117,
        101,
        114,
        121,
        84,
        121,
        112,
        101,
        0,
        108,
        97,
        108,
        108,
        111,
        99,
        0,
        108,
        114,
        101,
        115,
        101,
        116,
        0,
        123,
        114,
        101,
        116,
        117,
        114,
        110,
        40,
        95,
        110,
        98,
        105,
        110,
        100,
        46,
        99,
        97,
        108,
        108,
        98,
        97,
        99,
        107,
        83,
        105,
        103,
        110,
        97,
        116,
        117,
        114,
        101,
        76,
        105,
        115,
        116,
        91,
        36,
        48,
        93,
        46,
        97,
        112,
        112,
        108,
        121,
        40,
        116,
        104,
        105,
        115,
        44,
        97,
        114,
        103,
        117,
        109,
        101,
        110,
        116,
        115,
        41,
        41,
        59,
        125,
        0,
        95,
        110,
        98,
        105,
        110,
        100,
        95,
        110,
        101,
        119,
        0,
        17,
        0,
        10,
        0,
        17,
        17,
        17,
        0,
        0,
        0,
        0,
        5,
        0,
        0,
        0,
        0,
        0,
        0,
        9,
        0,
        0,
        0,
        0,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        17,
        0,
        15,
        10,
        17,
        17,
        17,
        3,
        10,
        7,
        0,
        1,
        19,
        9,
        11,
        11,
        0,
        0,
        9,
        6,
        11,
        0,
        0,
        11,
        0,
        6,
        17,
        0,
        0,
        0,
        17,
        17,
        17,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        17,
        0,
        10,
        10,
        17,
        17,
        17,
        0,
        10,
        0,
        0,
        2,
        0,
        9,
        11,
        0,
        0,
        0,
        9,
        0,
        11,
        0,
        0,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        9,
        12,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        13,
        0,
        0,
        0,
        4,
        13,
        0,
        0,
        0,
        0,
        9,
        14,
        0,
        0,
        0,
        0,
        0,
        14,
        0,
        0,
        14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        16,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        15,
        0,
        0,
        0,
        0,
        15,
        0,
        0,
        0,
        0,
        9,
        16,
        0,
        0,
        0,
        0,
        0,
        16,
        0,
        0,
        16,
        0,
        0,
        18,
        0,
        0,
        0,
        18,
        18,
        18,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        18,
        0,
        0,
        0,
        18,
        18,
        18,
        0,
        0,
        0,
        0,
        0,
        0,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        10,
        0,
        0,
        0,
        0,
        10,
        0,
        0,
        0,
        0,
        9,
        11,
        0,
        0,
        0,
        0,
        0,
        11,
        0,
        0,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        0,
        0,
        9,
        12,
        0,
        0,
        0,
        0,
        0,
        12,
        0,
        0,
        12,
        0,
        0,
        45,
        43,
        32,
        32,
        32,
        48,
        88,
        48,
        120,
        0,
        40,
        110,
        117,
        108,
        108,
        41,
        0,
        45,
        48,
        88,
        43,
        48,
        88,
        32,
        48,
        88,
        45,
        48,
        120,
        43,
        48,
        120,
        32,
        48,
        120,
        0,
        105,
        110,
        102,
        0,
        73,
        78,
        70,
        0,
        110,
        97,
        110,
        0,
        78,
        65,
        78,
        0,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        65,
        66,
        67,
        68,
        69,
        70,
        46,
        0,
        84,
        33,
        34,
        25,
        13,
        1,
        2,
        3,
        17,
        75,
        28,
        12,
        16,
        4,
        11,
        29,
        18,
        30,
        39,
        104,
        110,
        111,
        112,
        113,
        98,
        32,
        5,
        6,
        15,
        19,
        20,
        21,
        26,
        8,
        22,
        7,
        40,
        36,
        23,
        24,
        9,
        10,
        14,
        27,
        31,
        37,
        35,
        131,
        130,
        125,
        38,
        42,
        43,
        60,
        61,
        62,
        63,
        67,
        71,
        74,
        77,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        95,
        96,
        97,
        99,
        100,
        101,
        102,
        103,
        105,
        106,
        107,
        108,
        114,
        115,
        116,
        121,
        122,
        123,
        124,
        0,
        73,
        108,
        108,
        101,
        103,
        97,
        108,
        32,
        98,
        121,
        116,
        101,
        32,
        115,
        101,
        113,
        117,
        101,
        110,
        99,
        101,
        0,
        68,
        111,
        109,
        97,
        105,
        110,
        32,
        101,
        114,
        114,
        111,
        114,
        0,
        82,
        101,
        115,
        117,
        108,
        116,
        32,
        110,
        111,
        116,
        32,
        114,
        101,
        112,
        114,
        101,
        115,
        101,
        110,
        116,
        97,
        98,
        108,
        101,
        0,
        78,
        111,
        116,
        32,
        97,
        32,
        116,
        116,
        121,
        0,
        80,
        101,
        114,
        109,
        105,
        115,
        115,
        105,
        111,
        110,
        32,
        100,
        101,
        110,
        105,
        101,
        100,
        0,
        79,
        112,
        101,
        114,
        97,
        116,
        105,
        111,
        110,
        32,
        110,
        111,
        116,
        32,
        112,
        101,
        114,
        109,
        105,
        116,
        116,
        101,
        100,
        0,
        78,
        111,
        32,
        115,
        117,
        99,
        104,
        32,
        102,
        105,
        108,
        101,
        32,
        111,
        114,
        32,
        100,
        105,
        114,
        101,
        99,
        116,
        111,
        114,
        121,
        0,
        78,
        111,
        32,
        115,
        117,
        99,
        104,
        32,
        112,
        114,
        111,
        99,
        101,
        115,
        115,
        0,
        70,
        105,
        108,
        101,
        32,
        101,
        120,
        105,
        115,
        116,
        115,
        0,
        86,
        97,
        108,
        117,
        101,
        32,
        116,
        111,
        111,
        32,
        108,
        97,
        114,
        103,
        101,
        32,
        102,
        111,
        114,
        32,
        100,
        97,
        116,
        97,
        32,
        116,
        121,
        112,
        101,
        0,
        78,
        111,
        32,
        115,
        112,
        97,
        99,
        101,
        32,
        108,
        101,
        102,
        116,
        32,
        111,
        110,
        32,
        100,
        101,
        118,
        105,
        99,
        101,
        0,
        79,
        117,
        116,
        32,
        111,
        102,
        32,
        109,
        101,
        109,
        111,
        114,
        121,
        0,
        82,
        101,
        115,
        111,
        117,
        114,
        99,
        101,
        32,
        98,
        117,
        115,
        121,
        0,
        73,
        110,
        116,
        101,
        114,
        114,
        117,
        112,
        116,
        101,
        100,
        32,
        115,
        121,
        115,
        116,
        101,
        109,
        32,
        99,
        97,
        108,
        108,
        0,
        82,
        101,
        115,
        111,
        117,
        114,
        99,
        101,
        32,
        116,
        101,
        109,
        112,
        111,
        114,
        97,
        114,
        105,
        108,
        121,
        32,
        117,
        110,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        0,
        73,
        110,
        118,
        97,
        108,
        105,
        100,
        32,
        115,
        101,
        101,
        107,
        0,
        67,
        114,
        111,
        115,
        115,
        45,
        100,
        101,
        118,
        105,
        99,
        101,
        32,
        108,
        105,
        110,
        107,
        0,
        82,
        101,
        97,
        100,
        45,
        111,
        110,
        108,
        121,
        32,
        102,
        105,
        108,
        101,
        32,
        115,
        121,
        115,
        116,
        101,
        109,
        0,
        68,
        105,
        114,
        101,
        99,
        116,
        111,
        114,
        121,
        32,
        110,
        111,
        116,
        32,
        101,
        109,
        112,
        116,
        121,
        0,
        67,
        111,
        110,
        110,
        101,
        99,
        116,
        105,
        111,
        110,
        32,
        114,
        101,
        115,
        101,
        116,
        32,
        98,
        121,
        32,
        112,
        101,
        101,
        114,
        0,
        79,
        112,
        101,
        114,
        97,
        116,
        105,
        111,
        110,
        32,
        116,
        105,
        109,
        101,
        100,
        32,
        111,
        117,
        116,
        0,
        67,
        111,
        110,
        110,
        101,
        99,
        116,
        105,
        111,
        110,
        32,
        114,
        101,
        102,
        117,
        115,
        101,
        100,
        0,
        72,
        111,
        115,
        116,
        32,
        105,
        115,
        32,
        100,
        111,
        119,
        110,
        0,
        72,
        111,
        115,
        116,
        32,
        105,
        115,
        32,
        117,
        110,
        114,
        101,
        97,
        99,
        104,
        97,
        98,
        108,
        101,
        0,
        65,
        100,
        100,
        114,
        101,
        115,
        115,
        32,
        105,
        110,
        32,
        117,
        115,
        101,
        0,
        66,
        114,
        111,
        107,
        101,
        110,
        32,
        112,
        105,
        112,
        101,
        0,
        73,
        47,
        79,
        32,
        101,
        114,
        114,
        111,
        114,
        0,
        78,
        111,
        32,
        115,
        117,
        99,
        104,
        32,
        100,
        101,
        118,
        105,
        99,
        101,
        32,
        111,
        114,
        32,
        97,
        100,
        100,
        114,
        101,
        115,
        115,
        0,
        66,
        108,
        111,
        99,
        107,
        32,
        100,
        101,
        118,
        105,
        99,
        101,
        32,
        114,
        101,
        113,
        117,
        105,
        114,
        101,
        100,
        0,
        78,
        111,
        32,
        115,
        117,
        99,
        104,
        32,
        100,
        101,
        118,
        105,
        99,
        101,
        0,
        78,
        111,
        116,
        32,
        97,
        32,
        100,
        105,
        114,
        101,
        99,
        116,
        111,
        114,
        121,
        0,
        73,
        115,
        32,
        97,
        32,
        100,
        105,
        114,
        101,
        99,
        116,
        111,
        114,
        121,
        0,
        84,
        101,
        120,
        116,
        32,
        102,
        105,
        108,
        101,
        32,
        98,
        117,
        115,
        121,
        0,
        69,
        120,
        101,
        99,
        32,
        102,
        111,
        114,
        109,
        97,
        116,
        32,
        101,
        114,
        114,
        111,
        114,
        0,
        73,
        110,
        118,
        97,
        108,
        105,
        100,
        32,
        97,
        114,
        103,
        117,
        109,
        101,
        110,
        116,
        0,
        65,
        114,
        103,
        117,
        109,
        101,
        110,
        116,
        32,
        108,
        105,
        115,
        116,
        32,
        116,
        111,
        111,
        32,
        108,
        111,
        110,
        103,
        0,
        83,
        121,
        109,
        98,
        111,
        108,
        105,
        99,
        32,
        108,
        105,
        110,
        107,
        32,
        108,
        111,
        111,
        112,
        0,
        70,
        105,
        108,
        101,
        110,
        97,
        109,
        101,
        32,
        116,
        111,
        111,
        32,
        108,
        111,
        110,
        103,
        0,
        84,
        111,
        111,
        32,
        109,
        97,
        110,
        121,
        32,
        111,
        112,
        101,
        110,
        32,
        102,
        105,
        108,
        101,
        115,
        32,
        105,
        110,
        32,
        115,
        121,
        115,
        116,
        101,
        109,
        0,
        78,
        111,
        32,
        102,
        105,
        108,
        101,
        32,
        100,
        101,
        115,
        99,
        114,
        105,
        112,
        116,
        111,
        114,
        115,
        32,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        0,
        66,
        97,
        100,
        32,
        102,
        105,
        108,
        101,
        32,
        100,
        101,
        115,
        99,
        114,
        105,
        112,
        116,
        111,
        114,
        0,
        78,
        111,
        32,
        99,
        104,
        105,
        108,
        100,
        32,
        112,
        114,
        111,
        99,
        101,
        115,
        115,
        0,
        66,
        97,
        100,
        32,
        97,
        100,
        100,
        114,
        101,
        115,
        115,
        0,
        70,
        105,
        108,
        101,
        32,
        116,
        111,
        111,
        32,
        108,
        97,
        114,
        103,
        101,
        0,
        84,
        111,
        111,
        32,
        109,
        97,
        110,
        121,
        32,
        108,
        105,
        110,
        107,
        115,
        0,
        78,
        111,
        32,
        108,
        111,
        99,
        107,
        115,
        32,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        0,
        82,
        101,
        115,
        111,
        117,
        114,
        99,
        101,
        32,
        100,
        101,
        97,
        100,
        108,
        111,
        99,
        107,
        32,
        119,
        111,
        117,
        108,
        100,
        32,
        111,
        99,
        99,
        117,
        114,
        0,
        83,
        116,
        97,
        116,
        101,
        32,
        110,
        111,
        116,
        32,
        114,
        101,
        99,
        111,
        118,
        101,
        114,
        97,
        98,
        108,
        101,
        0,
        80,
        114,
        101,
        118,
        105,
        111,
        117,
        115,
        32,
        111,
        119,
        110,
        101,
        114,
        32,
        100,
        105,
        101,
        100,
        0,
        79,
        112,
        101,
        114,
        97,
        116,
        105,
        111,
        110,
        32,
        99,
        97,
        110,
        99,
        101,
        108,
        101,
        100,
        0,
        70,
        117,
        110,
        99,
        116,
        105,
        111,
        110,
        32,
        110,
        111,
        116,
        32,
        105,
        109,
        112,
        108,
        101,
        109,
        101,
        110,
        116,
        101,
        100,
        0,
        78,
        111,
        32,
        109,
        101,
        115,
        115,
        97,
        103,
        101,
        32,
        111,
        102,
        32,
        100,
        101,
        115,
        105,
        114,
        101,
        100,
        32,
        116,
        121,
        112,
        101,
        0,
        73,
        100,
        101,
        110,
        116,
        105,
        102,
        105,
        101,
        114,
        32,
        114,
        101,
        109,
        111,
        118,
        101,
        100,
        0,
        68,
        101,
        118,
        105,
        99,
        101,
        32,
        110,
        111,
        116,
        32,
        97,
        32,
        115,
        116,
        114,
        101,
        97,
        109,
        0,
        78,
        111,
        32,
        100,
        97,
        116,
        97,
        32,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        0,
        68,
        101,
        118,
        105,
        99,
        101,
        32,
        116,
        105,
        109,
        101,
        111,
        117,
        116,
        0,
        79,
        117,
        116,
        32,
        111,
        102,
        32,
        115,
        116,
        114,
        101,
        97,
        109,
        115,
        32,
        114,
        101,
        115,
        111,
        117,
        114,
        99,
        101,
        115,
        0,
        76,
        105,
        110,
        107,
        32,
        104,
        97,
        115,
        32,
        98,
        101,
        101,
        110,
        32,
        115,
        101,
        118,
        101,
        114,
        101,
        100,
        0,
        80,
        114,
        111,
        116,
        111,
        99,
        111,
        108,
        32,
        101,
        114,
        114,
        111,
        114,
        0,
        66,
        97,
        100,
        32,
        109,
        101,
        115,
        115,
        97,
        103,
        101,
        0,
        70,
        105,
        108,
        101,
        32,
        100,
        101,
        115,
        99,
        114,
        105,
        112,
        116,
        111,
        114,
        32,
        105,
        110,
        32,
        98,
        97,
        100,
        32,
        115,
        116,
        97,
        116,
        101,
        0,
        78,
        111,
        116,
        32,
        97,
        32,
        115,
        111,
        99,
        107,
        101,
        116,
        0,
        68,
        101,
        115,
        116,
        105,
        110,
        97,
        116,
        105,
        111,
        110,
        32,
        97,
        100,
        100,
        114,
        101,
        115,
        115,
        32,
        114,
        101,
        113,
        117,
        105,
        114,
        101,
        100,
        0,
        77,
        101,
        115,
        115,
        97,
        103,
        101,
        32,
        116,
        111,
        111,
        32,
        108,
        97,
        114,
        103,
        101,
        0,
        80,
        114,
        111,
        116,
        111,
        99,
        111,
        108,
        32,
        119,
        114,
        111,
        110,
        103,
        32,
        116,
        121,
        112,
        101,
        32,
        102,
        111,
        114,
        32,
        115,
        111,
        99,
        107,
        101,
        116,
        0,
        80,
        114,
        111,
        116,
        111,
        99,
        111,
        108,
        32,
        110,
        111,
        116,
        32,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        0,
        80,
        114,
        111,
        116,
        111,
        99,
        111,
        108,
        32,
        110,
        111,
        116,
        32,
        115,
        117,
        112,
        112,
        111,
        114,
        116,
        101,
        100,
        0,
        83,
        111,
        99,
        107,
        101,
        116,
        32,
        116,
        121,
        112,
        101,
        32,
        110,
        111,
        116,
        32,
        115,
        117,
        112,
        112,
        111,
        114,
        116,
        101,
        100,
        0,
        78,
        111,
        116,
        32,
        115,
        117,
        112,
        112,
        111,
        114,
        116,
        101,
        100,
        0,
        80,
        114,
        111,
        116,
        111,
        99,
        111,
        108,
        32,
        102,
        97,
        109,
        105,
        108,
        121,
        32,
        110,
        111,
        116,
        32,
        115,
        117,
        112,
        112,
        111,
        114,
        116,
        101,
        100,
        0,
        65,
        100,
        100,
        114,
        101,
        115,
        115,
        32,
        102,
        97,
        109,
        105,
        108,
        121,
        32,
        110,
        111,
        116,
        32,
        115,
        117,
        112,
        112,
        111,
        114,
        116,
        101,
        100,
        32,
        98,
        121,
        32,
        112,
        114,
        111,
        116,
        111,
        99,
        111,
        108,
        0,
        65,
        100,
        100,
        114,
        101,
        115,
        115,
        32,
        110,
        111,
        116,
        32,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        0,
        78,
        101,
        116,
        119,
        111,
        114,
        107,
        32,
        105,
        115,
        32,
        100,
        111,
        119,
        110,
        0,
        78,
        101,
        116,
        119,
        111,
        114,
        107,
        32,
        117,
        110,
        114,
        101,
        97,
        99,
        104,
        97,
        98,
        108,
        101,
        0,
        67,
        111,
        110,
        110,
        101,
        99,
        116,
        105,
        111,
        110,
        32,
        114,
        101,
        115,
        101,
        116,
        32,
        98,
        121,
        32,
        110,
        101,
        116,
        119,
        111,
        114,
        107,
        0,
        67,
        111,
        110,
        110,
        101,
        99,
        116,
        105,
        111,
        110,
        32,
        97,
        98,
        111,
        114,
        116,
        101,
        100,
        0,
        78,
        111,
        32,
        98,
        117,
        102,
        102,
        101,
        114,
        32,
        115,
        112,
        97,
        99,
        101,
        32,
        97,
        118,
        97,
        105,
        108,
        97,
        98,
        108,
        101,
        0,
        83,
        111,
        99,
        107,
        101,
        116,
        32,
        105,
        115,
        32,
        99,
        111,
        110,
        110,
        101,
        99,
        116,
        101,
        100,
        0,
        83,
        111,
        99,
        107,
        101,
        116,
        32,
        110,
        111,
        116,
        32,
        99,
        111,
        110,
        110,
        101,
        99,
        116,
        101,
        100,
        0,
        67,
        97,
        110,
        110,
        111,
        116,
        32,
        115,
        101,
        110,
        100,
        32,
        97,
        102,
        116,
        101,
        114,
        32,
        115,
        111,
        99,
        107,
        101,
        116,
        32,
        115,
        104,
        117,
        116,
        100,
        111,
        119,
        110,
        0,
        79,
        112,
        101,
        114,
        97,
        116,
        105,
        111,
        110,
        32,
        97,
        108,
        114,
        101,
        97,
        100,
        121,
        32,
        105,
        110,
        32,
        112,
        114,
        111,
        103,
        114,
        101,
        115,
        115,
        0,
        79,
        112,
        101,
        114,
        97,
        116,
        105,
        111,
        110,
        32,
        105,
        110,
        32,
        112,
        114,
        111,
        103,
        114,
        101,
        115,
        115,
        0,
        83,
        116,
        97,
        108,
        101,
        32,
        102,
        105,
        108,
        101,
        32,
        104,
        97,
        110,
        100,
        108,
        101,
        0,
        82,
        101,
        109,
        111,
        116,
        101,
        32,
        73,
        47,
        79,
        32,
        101,
        114,
        114,
        111,
        114,
        0,
        81,
        117,
        111,
        116,
        97,
        32,
        101,
        120,
        99,
        101,
        101,
        100,
        101,
        100,
        0,
        78,
        111,
        32,
        109,
        101,
        100,
        105,
        117,
        109,
        32,
        102,
        111,
        117,
        110,
        100,
        0,
        87,
        114,
        111,
        110,
        103,
        32,
        109,
        101,
        100,
        105,
        117,
        109,
        32,
        116,
        121,
        112,
        101,
        0,
        78,
        111,
        32,
        101,
        114,
        114,
        111,
        114,
        32,
        105,
        110,
        102,
        111,
        114,
        109,
        97,
        116,
        105,
        111,
        110,
        0,
        0
    ], "i8", ALLOC_NONE, Runtime.GLOBAL_BASE);
    var tempDoublePtr = STATICTOP;
    STATICTOP += 16;
    function _atexit(func, arg) {
        __ATEXIT__.unshift({
            func: func,
            arg: arg
        });
    }
    function ___cxa_atexit() {
        return _atexit.apply(null, arguments);
    }
    function _abort() {
        Module["abort"]();
    }
    function __ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj() {
        Module["printErr"]("missing function: _ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj");
        abort(-1);
    }
    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }
    function _defineHidden(value) {
        return function(target, key) {
            Object.defineProperty(target, key, {
                configurable: false,
                enumerable: false,
                value: value,
                writable: true
            });
        };
    }
    var _nbind = {};
    function __nbind_free_external(num) {
        _nbind.externalList[num].dereference(num);
    }
    function __nbind_reference_external(num) {
        _nbind.externalList[num].reference();
    }
    function _llvm_stackrestore(p) {
        var self1 = _llvm_stacksave;
        var ret = self1.LLVM_SAVEDSTACKS[p];
        self1.LLVM_SAVEDSTACKS.splice(p, 1);
        Runtime.stackRestore(ret);
    }
    function __nbind_register_pool(pageSize, usedPtr, rootPtr, pagePtr) {
        _nbind.Pool.pageSize = pageSize;
        _nbind.Pool.usedPtr = usedPtr / 4;
        _nbind.Pool.rootPtr = rootPtr;
        _nbind.Pool.pagePtr = pagePtr / 4;
        HEAP32[usedPtr / 4] = 16909060;
        if (HEAP8[usedPtr] == 1) _nbind.bigEndian = true;
        HEAP32[usedPtr / 4] = 0;
        _nbind.makeTypeKindTbl = (_a = {}, _a[1024] = _nbind.PrimitiveType, _a[64] = _nbind.Int64Type, _a[2048] = _nbind.BindClass, _a[3072] = _nbind.BindClassPtr, _a[4096] = _nbind.SharedClassPtr, _a[5120] = _nbind.ArrayType, _a[6144] = _nbind.ArrayType, _a[7168] = _nbind.CStringType, _a[9216] = _nbind.CallbackType, _a[10240] = _nbind.BindType, _a);
        _nbind.makeTypeNameTbl = {
            "Buffer": _nbind.BufferType,
            "External": _nbind.ExternalType,
            "Int64": _nbind.Int64Type,
            "_nbind_new": _nbind.CreateValueType,
            "bool": _nbind.BooleanType,
            "cbFunction &": _nbind.CallbackType,
            "const cbFunction &": _nbind.CallbackType,
            "const std::string &": _nbind.StringType,
            "std::string": _nbind.StringType
        };
        Module["toggleLightGC"] = _nbind.toggleLightGC;
        _nbind.callUpcast = Module["dynCall_ii"];
        var globalScope = _nbind.makeType(_nbind.constructType, {
            flags: 2048,
            id: 0,
            name: ""
        });
        globalScope.proto = Module;
        _nbind.BindClass.list.push(globalScope);
        var _a;
    }
    function _emscripten_set_main_loop_timing(mode, value) {
        Browser.mainLoop.timingMode = mode;
        Browser.mainLoop.timingValue = value;
        if (!Browser.mainLoop.func) return 1;
        if (mode == 0) {
            Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_setTimeout() {
                var timeUntilNextTick = Math.max(0, Browser.mainLoop.tickStartTime + value - _emscripten_get_now()) | 0;
                setTimeout(Browser.mainLoop.runner, timeUntilNextTick);
            };
            Browser.mainLoop.method = "timeout";
        } else if (mode == 1) {
            Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_rAF() {
                Browser.requestAnimationFrame(Browser.mainLoop.runner);
            };
            Browser.mainLoop.method = "rAF";
        } else if (mode == 2) {
            if (!window["setImmediate"]) {
                var setImmediates = [];
                var emscriptenMainLoopMessageId = "setimmediate";
                function Browser_setImmediate_messageHandler(event) {
                    if (event.source === window && event.data === emscriptenMainLoopMessageId) {
                        event.stopPropagation();
                        setImmediates.shift()();
                    }
                }
                window.addEventListener("message", Browser_setImmediate_messageHandler, true);
                window["setImmediate"] = function Browser_emulated_setImmediate(func) {
                    setImmediates.push(func);
                    if (ENVIRONMENT_IS_WORKER) {
                        if (Module["setImmediates"] === undefined) Module["setImmediates"] = [];
                        Module["setImmediates"].push(func);
                        window.postMessage({
                            target: emscriptenMainLoopMessageId
                        });
                    } else window.postMessage(emscriptenMainLoopMessageId, "*");
                };
            }
            Browser.mainLoop.scheduler = function Browser_mainLoop_scheduler_setImmediate() {
                window["setImmediate"](Browser.mainLoop.runner);
            };
            Browser.mainLoop.method = "immediate";
        }
        return 0;
    }
    function _emscripten_get_now() {
        abort();
    }
    function _emscripten_set_main_loop(func, fps, simulateInfiniteLoop, arg, noSetTiming) {
        Module["noExitRuntime"] = true;
        assert(!Browser.mainLoop.func, "emscripten_set_main_loop: there can only be one main loop function at once: call emscripten_cancel_main_loop to cancel the previous one before setting a new one with different parameters.");
        Browser.mainLoop.func = func;
        Browser.mainLoop.arg = arg;
        var browserIterationFunc;
        if (typeof arg !== "undefined") browserIterationFunc = function() {
            Module["dynCall_vi"](func, arg);
        };
        else browserIterationFunc = function() {
            Module["dynCall_v"](func);
        };
        var thisMainLoopId = Browser.mainLoop.currentlyRunningMainloop;
        Browser.mainLoop.runner = function Browser_mainLoop_runner() {
            if (ABORT) return;
            if (Browser.mainLoop.queue.length > 0) {
                var start = Date.now();
                var blocker = Browser.mainLoop.queue.shift();
                blocker.func(blocker.arg);
                if (Browser.mainLoop.remainingBlockers) {
                    var remaining = Browser.mainLoop.remainingBlockers;
                    var next = remaining % 1 == 0 ? remaining - 1 : Math.floor(remaining);
                    if (blocker.counted) Browser.mainLoop.remainingBlockers = next;
                    else {
                        next = next + .5;
                        Browser.mainLoop.remainingBlockers = (8 * remaining + next) / 9;
                    }
                }
                console.log('main loop blocker "' + blocker.name + '" took ' + (Date.now() - start) + " ms");
                Browser.mainLoop.updateStatus();
                if (thisMainLoopId < Browser.mainLoop.currentlyRunningMainloop) return;
                setTimeout(Browser.mainLoop.runner, 0);
                return;
            }
            if (thisMainLoopId < Browser.mainLoop.currentlyRunningMainloop) return;
            Browser.mainLoop.currentFrameNumber = Browser.mainLoop.currentFrameNumber + 1 | 0;
            if (Browser.mainLoop.timingMode == 1 && Browser.mainLoop.timingValue > 1 && Browser.mainLoop.currentFrameNumber % Browser.mainLoop.timingValue != 0) {
                Browser.mainLoop.scheduler();
                return;
            } else if (Browser.mainLoop.timingMode == 0) Browser.mainLoop.tickStartTime = _emscripten_get_now();
            if (Browser.mainLoop.method === "timeout" && Module.ctx) {
                Module.printErr("Looks like you are rendering without using requestAnimationFrame for the main loop. You should use 0 for the frame rate in emscripten_set_main_loop in order to use requestAnimationFrame, as that can greatly improve your frame rates!");
                Browser.mainLoop.method = "";
            }
            Browser.mainLoop.runIter(browserIterationFunc);
            if (thisMainLoopId < Browser.mainLoop.currentlyRunningMainloop) return;
            if (typeof SDL === "object" && SDL.audio && SDL.audio.queueNewAudioData) SDL.audio.queueNewAudioData();
            Browser.mainLoop.scheduler();
        };
        if (!noSetTiming) {
            if (fps && fps > 0) _emscripten_set_main_loop_timing(0, 1e3 / fps);
            else _emscripten_set_main_loop_timing(1, 1);
            Browser.mainLoop.scheduler();
        }
        if (simulateInfiniteLoop) throw "SimulateInfiniteLoop";
    }
    var Browser = {
        mainLoop: {
            scheduler: null,
            method: "",
            currentlyRunningMainloop: 0,
            func: null,
            arg: 0,
            timingMode: 0,
            timingValue: 0,
            currentFrameNumber: 0,
            queue: [],
            pause: function() {
                Browser.mainLoop.scheduler = null;
                Browser.mainLoop.currentlyRunningMainloop++;
            },
            resume: function() {
                Browser.mainLoop.currentlyRunningMainloop++;
                var timingMode = Browser.mainLoop.timingMode;
                var timingValue = Browser.mainLoop.timingValue;
                var func = Browser.mainLoop.func;
                Browser.mainLoop.func = null;
                _emscripten_set_main_loop(func, 0, false, Browser.mainLoop.arg, true);
                _emscripten_set_main_loop_timing(timingMode, timingValue);
                Browser.mainLoop.scheduler();
            },
            updateStatus: function() {
                if (Module["setStatus"]) {
                    var message = Module["statusMessage"] || "Please wait...";
                    var remaining = Browser.mainLoop.remainingBlockers;
                    var expected = Browser.mainLoop.expectedBlockers;
                    if (remaining) {
                        if (remaining < expected) Module["setStatus"](message + " (" + (expected - remaining) + "/" + expected + ")");
                        else Module["setStatus"](message);
                    } else Module["setStatus"]("");
                }
            },
            runIter: function(func) {
                if (ABORT) return;
                if (Module["preMainLoop"]) {
                    var preRet = Module["preMainLoop"]();
                    if (preRet === false) return;
                }
                try {
                    func();
                } catch (e) {
                    if (e instanceof ExitStatus) return;
                    else {
                        if (e && typeof e === "object" && e.stack) Module.printErr("exception thrown: " + [
                            e,
                            e.stack
                        ]);
                        throw e;
                    }
                }
                if (Module["postMainLoop"]) Module["postMainLoop"]();
            }
        },
        isFullscreen: false,
        pointerLock: false,
        moduleContextCreatedCallbacks: [],
        workers: [],
        init: function() {
            if (!Module["preloadPlugins"]) Module["preloadPlugins"] = [];
            if (Browser.initted) return;
            Browser.initted = true;
            try {
                new Blob();
                Browser.hasBlobConstructor = true;
            } catch (e) {
                Browser.hasBlobConstructor = false;
                console.log("warning: no blob constructor, cannot create blobs with mimetypes");
            }
            Browser.BlobBuilder = typeof MozBlobBuilder != "undefined" ? MozBlobBuilder : typeof WebKitBlobBuilder != "undefined" ? WebKitBlobBuilder : !Browser.hasBlobConstructor ? console.log("warning: no BlobBuilder") : null;
            Browser.URLObject = typeof window != "undefined" ? window.URL ? window.URL : window.webkitURL : undefined;
            if (!Module.noImageDecoding && typeof Browser.URLObject === "undefined") {
                console.log("warning: Browser does not support creating object URLs. Built-in browser image decoding will not be available.");
                Module.noImageDecoding = true;
            }
            var imagePlugin = {};
            imagePlugin["canHandle"] = function imagePlugin_canHandle(name) {
                return !Module.noImageDecoding && /\.(jpg|jpeg|png|bmp)$/i.test(name);
            };
            imagePlugin["handle"] = function imagePlugin_handle(byteArray, name, onload, onerror) {
                var b = null;
                if (Browser.hasBlobConstructor) try {
                    b = new Blob([
                        byteArray
                    ], {
                        type: Browser.getMimetype(name)
                    });
                    if (b.size !== byteArray.length) b = new Blob([
                        new Uint8Array(byteArray).buffer
                    ], {
                        type: Browser.getMimetype(name)
                    });
                } catch (e) {
                    Runtime.warnOnce("Blob constructor present but fails: " + e + "; falling back to blob builder");
                }
                if (!b) {
                    var bb = new Browser.BlobBuilder();
                    bb.append(new Uint8Array(byteArray).buffer);
                    b = bb.getBlob();
                }
                var url = Browser.URLObject.createObjectURL(b);
                var img = new Image();
                img.onload = function img_onload() {
                    assert(img.complete, "Image " + name + " could not be decoded");
                    var canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    var ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    Module["preloadedImages"][name] = canvas;
                    Browser.URLObject.revokeObjectURL(url);
                    if (onload) onload(byteArray);
                };
                img.onerror = function img_onerror(event) {
                    console.log("Image " + url + " could not be decoded");
                    if (onerror) onerror();
                };
                img.src = url;
            };
            Module["preloadPlugins"].push(imagePlugin);
            var audioPlugin = {};
            audioPlugin["canHandle"] = function audioPlugin_canHandle(name) {
                return !Module.noAudioDecoding && name.substr(-4) in {
                    ".ogg": 1,
                    ".wav": 1,
                    ".mp3": 1
                };
            };
            audioPlugin["handle"] = function audioPlugin_handle(byteArray, name, onload, onerror) {
                var done = false;
                function finish(audio) {
                    if (done) return;
                    done = true;
                    Module["preloadedAudios"][name] = audio;
                    if (onload) onload(byteArray);
                }
                function fail() {
                    if (done) return;
                    done = true;
                    Module["preloadedAudios"][name] = new Audio();
                    if (onerror) onerror();
                }
                if (Browser.hasBlobConstructor) {
                    try {
                        var b = new Blob([
                            byteArray
                        ], {
                            type: Browser.getMimetype(name)
                        });
                    } catch (e) {
                        return fail();
                    }
                    var url = Browser.URLObject.createObjectURL(b);
                    var audio = new Audio();
                    audio.addEventListener("canplaythrough", function() {
                        finish(audio);
                    }, false);
                    audio.onerror = function audio_onerror(event) {
                        if (done) return;
                        console.log("warning: browser could not fully decode audio " + name + ", trying slower base64 approach");
                        function encode64(data) {
                            var BASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                            var PAD = "=";
                            var ret = "";
                            var leftchar = 0;
                            var leftbits = 0;
                            for(var i = 0; i < data.length; i++){
                                leftchar = leftchar << 8 | data[i];
                                leftbits += 8;
                                while(leftbits >= 6){
                                    var curr = leftchar >> leftbits - 6 & 63;
                                    leftbits -= 6;
                                    ret += BASE[curr];
                                }
                            }
                            if (leftbits == 2) {
                                ret += BASE[(leftchar & 3) << 4];
                                ret += PAD + PAD;
                            } else if (leftbits == 4) {
                                ret += BASE[(leftchar & 15) << 2];
                                ret += PAD;
                            }
                            return ret;
                        }
                        audio.src = "data:audio/x-" + name.substr(-3) + ";base64," + encode64(byteArray);
                        finish(audio);
                    };
                    audio.src = url;
                    Browser.safeSetTimeout(function() {
                        finish(audio);
                    }, 1e4);
                } else return fail();
            };
            Module["preloadPlugins"].push(audioPlugin);
            function pointerLockChange() {
                Browser.pointerLock = document["pointerLockElement"] === Module["canvas"] || document["mozPointerLockElement"] === Module["canvas"] || document["webkitPointerLockElement"] === Module["canvas"] || document["msPointerLockElement"] === Module["canvas"];
            }
            var canvas = Module["canvas"];
            if (canvas) {
                canvas.requestPointerLock = canvas["requestPointerLock"] || canvas["mozRequestPointerLock"] || canvas["webkitRequestPointerLock"] || canvas["msRequestPointerLock"] || function() {};
                canvas.exitPointerLock = document["exitPointerLock"] || document["mozExitPointerLock"] || document["webkitExitPointerLock"] || document["msExitPointerLock"] || function() {};
                canvas.exitPointerLock = canvas.exitPointerLock.bind(document);
                document.addEventListener("pointerlockchange", pointerLockChange, false);
                document.addEventListener("mozpointerlockchange", pointerLockChange, false);
                document.addEventListener("webkitpointerlockchange", pointerLockChange, false);
                document.addEventListener("mspointerlockchange", pointerLockChange, false);
                if (Module["elementPointerLock"]) canvas.addEventListener("click", function(ev) {
                    if (!Browser.pointerLock && Module["canvas"].requestPointerLock) {
                        Module["canvas"].requestPointerLock();
                        ev.preventDefault();
                    }
                }, false);
            }
        },
        createContext: function(canvas, useWebGL, setInModule, webGLContextAttributes) {
            if (useWebGL && Module.ctx && canvas == Module.canvas) return Module.ctx;
            var ctx;
            var contextHandle;
            if (useWebGL) {
                var contextAttributes = {
                    antialias: false,
                    alpha: false
                };
                if (webGLContextAttributes) for(var attribute in webGLContextAttributes)contextAttributes[attribute] = webGLContextAttributes[attribute];
                contextHandle = GL.createContext(canvas, contextAttributes);
                if (contextHandle) ctx = GL.getContext(contextHandle).GLctx;
            } else ctx = canvas.getContext("2d");
            if (!ctx) return null;
            if (setInModule) {
                if (!useWebGL) assert(typeof GLctx === "undefined", "cannot set in module if GLctx is used, but we are a non-GL context that would replace it");
                Module.ctx = ctx;
                if (useWebGL) GL.makeContextCurrent(contextHandle);
                Module.useWebGL = useWebGL;
                Browser.moduleContextCreatedCallbacks.forEach(function(callback) {
                    callback();
                });
                Browser.init();
            }
            return ctx;
        },
        destroyContext: function(canvas, useWebGL, setInModule) {},
        fullscreenHandlersInstalled: false,
        lockPointer: undefined,
        resizeCanvas: undefined,
        requestFullscreen: function(lockPointer, resizeCanvas, vrDevice) {
            Browser.lockPointer = lockPointer;
            Browser.resizeCanvas = resizeCanvas;
            Browser.vrDevice = vrDevice;
            if (typeof Browser.lockPointer === "undefined") Browser.lockPointer = true;
            if (typeof Browser.resizeCanvas === "undefined") Browser.resizeCanvas = false;
            if (typeof Browser.vrDevice === "undefined") Browser.vrDevice = null;
            var canvas = Module["canvas"];
            function fullscreenChange() {
                Browser.isFullscreen = false;
                var canvasContainer = canvas.parentNode;
                if ((document["fullscreenElement"] || document["mozFullScreenElement"] || document["msFullscreenElement"] || document["webkitFullscreenElement"] || document["webkitCurrentFullScreenElement"]) === canvasContainer) {
                    canvas.exitFullscreen = document["exitFullscreen"] || document["cancelFullScreen"] || document["mozCancelFullScreen"] || document["msExitFullscreen"] || document["webkitCancelFullScreen"] || function() {};
                    canvas.exitFullscreen = canvas.exitFullscreen.bind(document);
                    if (Browser.lockPointer) canvas.requestPointerLock();
                    Browser.isFullscreen = true;
                    if (Browser.resizeCanvas) Browser.setFullscreenCanvasSize();
                } else {
                    canvasContainer.parentNode.insertBefore(canvas, canvasContainer);
                    canvasContainer.parentNode.removeChild(canvasContainer);
                    if (Browser.resizeCanvas) Browser.setWindowedCanvasSize();
                }
                if (Module["onFullScreen"]) Module["onFullScreen"](Browser.isFullscreen);
                if (Module["onFullscreen"]) Module["onFullscreen"](Browser.isFullscreen);
                Browser.updateCanvasDimensions(canvas);
            }
            if (!Browser.fullscreenHandlersInstalled) {
                Browser.fullscreenHandlersInstalled = true;
                document.addEventListener("fullscreenchange", fullscreenChange, false);
                document.addEventListener("mozfullscreenchange", fullscreenChange, false);
                document.addEventListener("webkitfullscreenchange", fullscreenChange, false);
                document.addEventListener("MSFullscreenChange", fullscreenChange, false);
            }
            var canvasContainer = document.createElement("div");
            canvas.parentNode.insertBefore(canvasContainer, canvas);
            canvasContainer.appendChild(canvas);
            canvasContainer.requestFullscreen = canvasContainer["requestFullscreen"] || canvasContainer["mozRequestFullScreen"] || canvasContainer["msRequestFullscreen"] || (canvasContainer["webkitRequestFullscreen"] ? function() {
                canvasContainer["webkitRequestFullscreen"](Element["ALLOW_KEYBOARD_INPUT"]);
            } : null) || (canvasContainer["webkitRequestFullScreen"] ? function() {
                canvasContainer["webkitRequestFullScreen"](Element["ALLOW_KEYBOARD_INPUT"]);
            } : null);
            if (vrDevice) canvasContainer.requestFullscreen({
                vrDisplay: vrDevice
            });
            else canvasContainer.requestFullscreen();
        },
        requestFullScreen: function(lockPointer, resizeCanvas, vrDevice) {
            Module.printErr("Browser.requestFullScreen() is deprecated. Please call Browser.requestFullscreen instead.");
            Browser.requestFullScreen = function(lockPointer, resizeCanvas, vrDevice) {
                return Browser.requestFullscreen(lockPointer, resizeCanvas, vrDevice);
            };
            return Browser.requestFullscreen(lockPointer, resizeCanvas, vrDevice);
        },
        nextRAF: 0,
        fakeRequestAnimationFrame: function(func) {
            var now = Date.now();
            if (Browser.nextRAF === 0) Browser.nextRAF = now + 1e3 / 60;
            else while(now + 2 >= Browser.nextRAF)Browser.nextRAF += 1e3 / 60;
            var delay = Math.max(Browser.nextRAF - now, 0);
            setTimeout(func, delay);
        },
        requestAnimationFrame: function requestAnimationFrame(func) {
            if (typeof window === "undefined") Browser.fakeRequestAnimationFrame(func);
            else {
                if (!window.requestAnimationFrame) window.requestAnimationFrame = window["requestAnimationFrame"] || window["mozRequestAnimationFrame"] || window["webkitRequestAnimationFrame"] || window["msRequestAnimationFrame"] || window["oRequestAnimationFrame"] || Browser.fakeRequestAnimationFrame;
                window.requestAnimationFrame(func);
            }
        },
        safeCallback: function(func) {
            return function() {
                if (!ABORT) return func.apply(null, arguments);
            };
        },
        allowAsyncCallbacks: true,
        queuedAsyncCallbacks: [],
        pauseAsyncCallbacks: function() {
            Browser.allowAsyncCallbacks = false;
        },
        resumeAsyncCallbacks: function() {
            Browser.allowAsyncCallbacks = true;
            if (Browser.queuedAsyncCallbacks.length > 0) {
                var callbacks = Browser.queuedAsyncCallbacks;
                Browser.queuedAsyncCallbacks = [];
                callbacks.forEach(function(func) {
                    func();
                });
            }
        },
        safeRequestAnimationFrame: function(func) {
            return Browser.requestAnimationFrame(function() {
                if (ABORT) return;
                if (Browser.allowAsyncCallbacks) func();
                else Browser.queuedAsyncCallbacks.push(func);
            });
        },
        safeSetTimeout: function(func, timeout) {
            Module["noExitRuntime"] = true;
            return setTimeout(function() {
                if (ABORT) return;
                if (Browser.allowAsyncCallbacks) func();
                else Browser.queuedAsyncCallbacks.push(func);
            }, timeout);
        },
        safeSetInterval: function(func, timeout) {
            Module["noExitRuntime"] = true;
            return setInterval(function() {
                if (ABORT) return;
                if (Browser.allowAsyncCallbacks) func();
            }, timeout);
        },
        getMimetype: function(name) {
            return ({
                "jpg": "image/jpeg",
                "jpeg": "image/jpeg",
                "png": "image/png",
                "bmp": "image/bmp",
                "ogg": "audio/ogg",
                "wav": "audio/wav",
                "mp3": "audio/mpeg"
            })[name.substr(name.lastIndexOf(".") + 1)];
        },
        getUserMedia: function(func) {
            if (!window.getUserMedia) window.getUserMedia = navigator["getUserMedia"] || navigator["mozGetUserMedia"];
            window.getUserMedia(func);
        },
        getMovementX: function(event) {
            return event["movementX"] || event["mozMovementX"] || event["webkitMovementX"] || 0;
        },
        getMovementY: function(event) {
            return event["movementY"] || event["mozMovementY"] || event["webkitMovementY"] || 0;
        },
        getMouseWheelDelta: function(event) {
            var delta = 0;
            switch(event.type){
                case "DOMMouseScroll":
                    delta = event.detail;
                    break;
                case "mousewheel":
                    delta = event.wheelDelta;
                    break;
                case "wheel":
                    delta = event["deltaY"];
                    break;
                default:
                    throw "unrecognized mouse wheel event: " + event.type;
            }
            return delta;
        },
        mouseX: 0,
        mouseY: 0,
        mouseMovementX: 0,
        mouseMovementY: 0,
        touches: {},
        lastTouches: {},
        calculateMouseEvent: function(event) {
            if (Browser.pointerLock) {
                if (event.type != "mousemove" && "mozMovementX" in event) Browser.mouseMovementX = Browser.mouseMovementY = 0;
                else {
                    Browser.mouseMovementX = Browser.getMovementX(event);
                    Browser.mouseMovementY = Browser.getMovementY(event);
                }
                if (typeof SDL != "undefined") {
                    Browser.mouseX = SDL.mouseX + Browser.mouseMovementX;
                    Browser.mouseY = SDL.mouseY + Browser.mouseMovementY;
                } else {
                    Browser.mouseX += Browser.mouseMovementX;
                    Browser.mouseY += Browser.mouseMovementY;
                }
            } else {
                var rect = Module["canvas"].getBoundingClientRect();
                var cw = Module["canvas"].width;
                var ch = Module["canvas"].height;
                var scrollX = typeof window.scrollX !== "undefined" ? window.scrollX : window.pageXOffset;
                var scrollY = typeof window.scrollY !== "undefined" ? window.scrollY : window.pageYOffset;
                if (event.type === "touchstart" || event.type === "touchend" || event.type === "touchmove") {
                    var touch = event.touch;
                    if (touch === undefined) return;
                    var adjustedX = touch.pageX - (scrollX + rect.left);
                    var adjustedY = touch.pageY - (scrollY + rect.top);
                    adjustedX = adjustedX * (cw / rect.width);
                    adjustedY = adjustedY * (ch / rect.height);
                    var coords = {
                        x: adjustedX,
                        y: adjustedY
                    };
                    if (event.type === "touchstart") {
                        Browser.lastTouches[touch.identifier] = coords;
                        Browser.touches[touch.identifier] = coords;
                    } else if (event.type === "touchend" || event.type === "touchmove") {
                        var last = Browser.touches[touch.identifier];
                        if (!last) last = coords;
                        Browser.lastTouches[touch.identifier] = last;
                        Browser.touches[touch.identifier] = coords;
                    }
                    return;
                }
                var x = event.pageX - (scrollX + rect.left);
                var y = event.pageY - (scrollY + rect.top);
                x = x * (cw / rect.width);
                y = y * (ch / rect.height);
                Browser.mouseMovementX = x - Browser.mouseX;
                Browser.mouseMovementY = y - Browser.mouseY;
                Browser.mouseX = x;
                Browser.mouseY = y;
            }
        },
        asyncLoad: function(url, onload, onerror, noRunDep) {
            var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
            Module["readAsync"](url, function(arrayBuffer) {
                assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
                onload(new Uint8Array(arrayBuffer));
                if (dep) removeRunDependency(dep);
            }, function(event) {
                if (onerror) onerror();
                else throw 'Loading data file "' + url + '" failed.';
            });
            if (dep) addRunDependency(dep);
        },
        resizeListeners: [],
        updateResizeListeners: function() {
            var canvas = Module["canvas"];
            Browser.resizeListeners.forEach(function(listener) {
                listener(canvas.width, canvas.height);
            });
        },
        setCanvasSize: function(width, height, noUpdates) {
            var canvas = Module["canvas"];
            Browser.updateCanvasDimensions(canvas, width, height);
            if (!noUpdates) Browser.updateResizeListeners();
        },
        windowedWidth: 0,
        windowedHeight: 0,
        setFullscreenCanvasSize: function() {
            if (typeof SDL != "undefined") {
                var flags = HEAPU32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2];
                flags = flags | 8388608;
                HEAP32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2] = flags;
            }
            Browser.updateResizeListeners();
        },
        setWindowedCanvasSize: function() {
            if (typeof SDL != "undefined") {
                var flags = HEAPU32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2];
                flags = flags & -8388609;
                HEAP32[SDL.screen + Runtime.QUANTUM_SIZE * 0 >> 2] = flags;
            }
            Browser.updateResizeListeners();
        },
        updateCanvasDimensions: function(canvas, wNative, hNative) {
            if (wNative && hNative) {
                canvas.widthNative = wNative;
                canvas.heightNative = hNative;
            } else {
                wNative = canvas.widthNative;
                hNative = canvas.heightNative;
            }
            var w = wNative;
            var h = hNative;
            if (Module["forcedAspectRatio"] && Module["forcedAspectRatio"] > 0) {
                if (w / h < Module["forcedAspectRatio"]) w = Math.round(h * Module["forcedAspectRatio"]);
                else h = Math.round(w / Module["forcedAspectRatio"]);
            }
            if ((document["fullscreenElement"] || document["mozFullScreenElement"] || document["msFullscreenElement"] || document["webkitFullscreenElement"] || document["webkitCurrentFullScreenElement"]) === canvas.parentNode && typeof screen != "undefined") {
                var factor = Math.min(screen.width / w, screen.height / h);
                w = Math.round(w * factor);
                h = Math.round(h * factor);
            }
            if (Browser.resizeCanvas) {
                if (canvas.width != w) canvas.width = w;
                if (canvas.height != h) canvas.height = h;
                if (typeof canvas.style != "undefined") {
                    canvas.style.removeProperty("width");
                    canvas.style.removeProperty("height");
                }
            } else {
                if (canvas.width != wNative) canvas.width = wNative;
                if (canvas.height != hNative) canvas.height = hNative;
                if (typeof canvas.style != "undefined") {
                    if (w != wNative || h != hNative) {
                        canvas.style.setProperty("width", w + "px", "important");
                        canvas.style.setProperty("height", h + "px", "important");
                    } else {
                        canvas.style.removeProperty("width");
                        canvas.style.removeProperty("height");
                    }
                }
            }
        },
        wgetRequests: {},
        nextWgetRequestHandle: 0,
        getNextWgetRequestHandle: function() {
            var handle = Browser.nextWgetRequestHandle;
            Browser.nextWgetRequestHandle++;
            return handle;
        }
    };
    var SYSCALLS = {
        varargs: 0,
        get: function(varargs) {
            SYSCALLS.varargs += 4;
            var ret = HEAP32[SYSCALLS.varargs - 4 >> 2];
            return ret;
        },
        getStr: function() {
            var ret = Pointer_stringify(SYSCALLS.get());
            return ret;
        },
        get64: function() {
            var low = SYSCALLS.get(), high = SYSCALLS.get();
            if (low >= 0) assert(high === 0);
            else assert(high === -1);
            return low;
        },
        getZero: function() {
            assert(SYSCALLS.get() === 0);
        }
    };
    function ___syscall6(which, varargs) {
        SYSCALLS.varargs = varargs;
        try {
            var stream = SYSCALLS.getStreamFromFD();
            FS.close(stream);
            return 0;
        } catch (e) {
            if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);
            return -e.errno;
        }
    }
    function ___syscall54(which, varargs) {
        SYSCALLS.varargs = varargs;
        try {
            return 0;
        } catch (e) {
            if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);
            return -e.errno;
        }
    }
    function _typeModule(self1) {
        var structureList = [
            [
                0,
                1,
                "X"
            ],
            [
                1,
                1,
                "const X"
            ],
            [
                128,
                1,
                "X *"
            ],
            [
                256,
                1,
                "X &"
            ],
            [
                384,
                1,
                "X &&"
            ],
            [
                512,
                1,
                "std::shared_ptr<X>"
            ],
            [
                640,
                1,
                "std::unique_ptr<X>"
            ],
            [
                5120,
                1,
                "std::vector<X>"
            ],
            [
                6144,
                2,
                "std::array<X, Y>"
            ],
            [
                9216,
                -1,
                "std::function<X (Y)>"
            ]
        ];
        function applyStructure(outerName, outerFlags, innerName, innerFlags, param, flip) {
            if (outerFlags == 1) {
                var ref = innerFlags & 896;
                if (ref == 128 || ref == 256 || ref == 384) outerName = "X const";
            }
            var name;
            if (flip) name = innerName.replace("X", outerName).replace("Y", param);
            else name = outerName.replace("X", innerName).replace("Y", param);
            return name.replace(/([*&]) (?=[*&])/g, "$1");
        }
        function reportProblem(problem, id, kind, structureType, place) {
            throw new Error(problem + " type " + kind.replace("X", id + "?") + (structureType ? " with flag " + structureType : "") + " in " + place);
        }
        function getComplexType(id, constructType, getType, queryType, place, kind, prevStructure, depth) {
            if (kind === void 0) kind = "X";
            if (depth === void 0) depth = 1;
            var result = getType(id);
            if (result) return result;
            var query = queryType(id);
            var structureType = query.placeholderFlag;
            var structure = structureList[structureType];
            if (prevStructure && structure) kind = applyStructure(prevStructure[2], prevStructure[0], kind, structure[0], "?", true);
            var problem;
            if (structureType == 0) problem = "Unbound";
            if (structureType >= 10) problem = "Corrupt";
            if (depth > 20) problem = "Deeply nested";
            if (problem) reportProblem(problem, id, kind, structureType, place || "?");
            var subId = query.paramList[0];
            var subType = getComplexType(subId, constructType, getType, queryType, place, kind, structure, depth + 1);
            var srcSpec;
            var spec = {
                flags: structure[0],
                id: id,
                name: "",
                paramList: [
                    subType
                ]
            };
            var argList = [];
            var structureParam = "?";
            switch(query.placeholderFlag){
                case 1:
                    srcSpec = subType.spec;
                    break;
                case 2:
                    if ((subType.flags & 15360) == 1024 && subType.spec.ptrSize == 1) {
                        spec.flags = 7168;
                        break;
                    }
                case 3:
                case 6:
                case 5:
                    srcSpec = subType.spec;
                    subType.flags;
                    break;
                case 8:
                    structureParam = "" + query.paramList[1];
                    spec.paramList.push(query.paramList[1]);
                    break;
                case 9:
                    for(var _i = 0, _a = query.paramList[1]; _i < _a.length; _i++){
                        var paramId = _a[_i];
                        var paramType = getComplexType(paramId, constructType, getType, queryType, place, kind, structure, depth + 1);
                        argList.push(paramType.name);
                        spec.paramList.push(paramType);
                    }
                    structureParam = argList.join(", ");
                    break;
                default:
                    break;
            }
            spec.name = applyStructure(structure[2], structure[0], subType.name, subType.flags, structureParam);
            if (srcSpec) {
                for(var _b = 0, _c = Object.keys(srcSpec); _b < _c.length; _b++){
                    var key = _c[_b];
                    spec[key] = spec[key] || srcSpec[key];
                }
                spec.flags |= srcSpec.flags;
            }
            return makeType(constructType, spec);
        }
        function makeType(constructType, spec) {
            var flags = spec.flags;
            var refKind = flags & 896;
            var kind = flags & 15360;
            if (!spec.name && kind == 1024) {
                if (spec.ptrSize == 1) spec.name = (flags & 16 ? "" : (flags & 8 ? "un" : "") + "signed ") + "char";
                else spec.name = (flags & 8 ? "u" : "") + (flags & 32 ? "float" : "int") + (spec.ptrSize * 8 + "_t");
            }
            if (spec.ptrSize == 8 && !(flags & 32)) kind = 64;
            if (kind == 2048) {
                if (refKind == 512 || refKind == 640) kind = 4096;
                else if (refKind) kind = 3072;
            }
            return constructType(kind, spec);
        }
        var Type = function() {
            function Type(spec) {
                this.id = spec.id;
                this.name = spec.name;
                this.flags = spec.flags;
                this.spec = spec;
            }
            Type.prototype.toString = function() {
                return this.name;
            };
            return Type;
        }();
        var output = {
            Type: Type,
            getComplexType: getComplexType,
            makeType: makeType,
            structureList: structureList
        };
        self1.output = output;
        return self1.output || output;
    }
    function __nbind_register_type(id, namePtr) {
        var name = _nbind.readAsciiString(namePtr);
        var spec = {
            flags: 10240,
            id: id,
            name: name
        };
        _nbind.makeType(_nbind.constructType, spec);
    }
    function __nbind_register_callback_signature(typeListPtr, typeCount) {
        var typeList = _nbind.readTypeIdList(typeListPtr, typeCount);
        var num = _nbind.callbackSignatureList.length;
        _nbind.callbackSignatureList[num] = _nbind.makeJSCaller(typeList);
        return num;
    }
    function __extends(Class, Parent) {
        for(var key in Parent)if (Parent.hasOwnProperty(key)) Class[key] = Parent[key];
        function Base() {
            this.constructor = Class;
        }
        Base.prototype = Parent.prototype;
        Class.prototype = new Base();
    }
    function __nbind_register_class(idListPtr, policyListPtr, superListPtr, upcastListPtr, superCount, destructorPtr, namePtr) {
        var name = _nbind.readAsciiString(namePtr);
        var policyTbl = _nbind.readPolicyList(policyListPtr);
        var idList = HEAPU32.subarray(idListPtr / 4, idListPtr / 4 + 2);
        var spec = {
            flags: 2048 | (policyTbl["Value"] ? 2 : 0),
            id: idList[0],
            name: name
        };
        var bindClass = _nbind.makeType(_nbind.constructType, spec);
        bindClass.ptrType = _nbind.getComplexType(idList[1], _nbind.constructType, _nbind.getType, _nbind.queryType);
        bindClass.destroy = _nbind.makeMethodCaller(bindClass.ptrType, {
            boundID: spec.id,
            flags: 0,
            name: "destroy",
            num: 0,
            ptr: destructorPtr,
            title: bindClass.name + ".free",
            typeList: [
                "void",
                "uint32_t",
                "uint32_t"
            ]
        });
        if (superCount) {
            bindClass.superIdList = Array.prototype.slice.call(HEAPU32.subarray(superListPtr / 4, superListPtr / 4 + superCount));
            bindClass.upcastList = Array.prototype.slice.call(HEAPU32.subarray(upcastListPtr / 4, upcastListPtr / 4 + superCount));
        }
        Module[bindClass.name] = bindClass.makeBound(policyTbl);
        _nbind.BindClass.list.push(bindClass);
    }
    function _removeAccessorPrefix(name) {
        var prefixMatcher = /^[Gg]et_?([A-Z]?([A-Z]?))/;
        return name.replace(prefixMatcher, function(match, initial, second) {
            return second ? initial : initial.toLowerCase();
        });
    }
    function __nbind_register_function(boundID, policyListPtr, typeListPtr, typeCount, ptr, direct, signatureType, namePtr, num, flags) {
        var bindClass = _nbind.getType(boundID);
        var policyTbl = _nbind.readPolicyList(policyListPtr);
        var typeList = _nbind.readTypeIdList(typeListPtr, typeCount);
        var specList;
        if (signatureType == 5) specList = [
            {
                direct: ptr,
                name: "__nbindConstructor",
                ptr: 0,
                title: bindClass.name + " constructor",
                typeList: [
                    "uint32_t"
                ].concat(typeList.slice(1))
            },
            {
                direct: direct,
                name: "__nbindValueConstructor",
                ptr: 0,
                title: bindClass.name + " value constructor",
                typeList: [
                    "void",
                    "uint32_t"
                ].concat(typeList.slice(1))
            }
        ];
        else {
            var name_1 = _nbind.readAsciiString(namePtr);
            var title = (bindClass.name && bindClass.name + ".") + name_1;
            if (signatureType == 3 || signatureType == 4) name_1 = _removeAccessorPrefix(name_1);
            specList = [
                {
                    boundID: boundID,
                    direct: direct,
                    name: name_1,
                    ptr: ptr,
                    title: title,
                    typeList: typeList
                }
            ];
        }
        for(var _i = 0, specList_1 = specList; _i < specList_1.length; _i++){
            var spec = specList_1[_i];
            spec.signatureType = signatureType;
            spec.policyTbl = policyTbl;
            spec.num = num;
            spec.flags = flags;
            bindClass.addMethod(spec);
        }
    }
    function _nbind_value(name, proto) {
        if (!_nbind.typeNameTbl[name]) _nbind.throwError("Unknown value type " + name);
        Module["NBind"].bind_value(name, proto);
        _defineHidden(_nbind.typeNameTbl[name].proto.prototype.__nbindValueConstructor)(proto.prototype, "__nbindValueConstructor");
    }
    Module["_nbind_value"] = _nbind_value;
    function __nbind_get_value_object(num, ptr) {
        var obj = _nbind.popValue(num);
        if (!obj.fromJS) throw new Error("Object " + obj + " has no fromJS function");
        obj.fromJS(function() {
            obj.__nbindValueConstructor.apply(this, Array.prototype.concat.apply([
                ptr
            ], arguments));
        });
    }
    function _emscripten_memcpy_big(dest, src, num) {
        HEAPU8.set(HEAPU8.subarray(src, src + num), dest);
        return dest;
    }
    function __nbind_register_primitive(id, size, flags) {
        var spec = {
            flags: 1024 | flags,
            id: id,
            ptrSize: size
        };
        _nbind.makeType(_nbind.constructType, spec);
    }
    var cttz_i8 = allocate([
        8,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        5,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        6,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        5,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        7,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        5,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        6,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        5,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        4,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0
    ], "i8", ALLOC_STATIC);
    function ___setErrNo(value) {
        if (Module["___errno_location"]) HEAP32[Module["___errno_location"]() >> 2] = value;
        return value;
    }
    function _llvm_stacksave() {
        var self1 = _llvm_stacksave;
        if (!self1.LLVM_SAVEDSTACKS) self1.LLVM_SAVEDSTACKS = [];
        self1.LLVM_SAVEDSTACKS.push(Runtime.stackSave());
        return self1.LLVM_SAVEDSTACKS.length - 1;
    }
    function ___syscall140(which, varargs) {
        SYSCALLS.varargs = varargs;
        try {
            var stream = SYSCALLS.getStreamFromFD(), offset_high = SYSCALLS.get(), offset_low = SYSCALLS.get(), result = SYSCALLS.get(), whence = SYSCALLS.get();
            var offset = offset_low;
            FS.llseek(stream, offset, whence);
            HEAP32[result >> 2] = stream.position;
            if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
            return 0;
        } catch (e) {
            if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);
            return -e.errno;
        }
    }
    function ___syscall146(which, varargs) {
        SYSCALLS.varargs = varargs;
        try {
            var stream = SYSCALLS.get(), iov = SYSCALLS.get(), iovcnt = SYSCALLS.get();
            var ret = 0;
            if (!___syscall146.buffer) {
                ___syscall146.buffers = [
                    null,
                    [],
                    []
                ];
                ___syscall146.printChar = function(stream, curr) {
                    var buffer = ___syscall146.buffers[stream];
                    assert(buffer);
                    if (curr === 0 || curr === 10) {
                        (stream === 1 ? Module["print"] : Module["printErr"])(UTF8ArrayToString(buffer, 0));
                        buffer.length = 0;
                    } else buffer.push(curr);
                };
            }
            for(var i = 0; i < iovcnt; i++){
                var ptr = HEAP32[iov + i * 8 >> 2];
                var len = HEAP32[iov + (i * 8 + 4) >> 2];
                for(var j = 0; j < len; j++)___syscall146.printChar(stream, HEAPU8[ptr + j]);
                ret += len;
            }
            return ret;
        } catch (e) {
            if (typeof FS === "undefined" || !(e instanceof FS.ErrnoError)) abort(e);
            return -e.errno;
        }
    }
    function __nbind_finish() {
        for(var _i = 0, _a = _nbind.BindClass.list; _i < _a.length; _i++){
            var bindClass = _a[_i];
            bindClass.finish();
        }
    }
    var ___dso_handle = STATICTOP;
    STATICTOP += 16;
    (function(_nbind) {
        var typeIdTbl = {};
        _nbind.typeNameTbl = {};
        var Pool = function() {
            function Pool() {}
            Pool.lalloc = function(size) {
                size = size + 7 & -8;
                var used = HEAPU32[Pool.usedPtr];
                if (size > Pool.pageSize / 2 || size > Pool.pageSize - used) {
                    var NBind = _nbind.typeNameTbl["NBind"].proto;
                    return NBind.lalloc(size);
                } else {
                    HEAPU32[Pool.usedPtr] = used + size;
                    return Pool.rootPtr + used;
                }
            };
            Pool.lreset = function(used, page) {
                var topPage = HEAPU32[Pool.pagePtr];
                if (topPage) {
                    var NBind = _nbind.typeNameTbl["NBind"].proto;
                    NBind.lreset(used, page);
                } else HEAPU32[Pool.usedPtr] = used;
            };
            return Pool;
        }();
        _nbind.Pool = Pool;
        function constructType(kind, spec) {
            var construct = kind == 10240 ? _nbind.makeTypeNameTbl[spec.name] || _nbind.BindType : _nbind.makeTypeKindTbl[kind];
            var bindType = new construct(spec);
            typeIdTbl[spec.id] = bindType;
            _nbind.typeNameTbl[spec.name] = bindType;
            return bindType;
        }
        _nbind.constructType = constructType;
        function getType(id) {
            return typeIdTbl[id];
        }
        _nbind.getType = getType;
        function queryType(id) {
            var placeholderFlag = HEAPU8[id];
            var paramCount = _nbind.structureList[placeholderFlag][1];
            id /= 4;
            if (paramCount < 0) {
                ++id;
                paramCount = HEAPU32[id] + 1;
            }
            var paramList = Array.prototype.slice.call(HEAPU32.subarray(id + 1, id + 1 + paramCount));
            if (placeholderFlag == 9) paramList = [
                paramList[0],
                paramList.slice(1)
            ];
            return {
                paramList: paramList,
                placeholderFlag: placeholderFlag
            };
        }
        _nbind.queryType = queryType;
        function getTypes(idList, place) {
            return idList.map(function(id) {
                return typeof id == "number" ? _nbind.getComplexType(id, constructType, getType, queryType, place) : _nbind.typeNameTbl[id];
            });
        }
        _nbind.getTypes = getTypes;
        function readTypeIdList(typeListPtr, typeCount) {
            return Array.prototype.slice.call(HEAPU32, typeListPtr / 4, typeListPtr / 4 + typeCount);
        }
        _nbind.readTypeIdList = readTypeIdList;
        function readAsciiString(ptr) {
            var endPtr = ptr;
            while(HEAPU8[endPtr++]);
            return String.fromCharCode.apply("", HEAPU8.subarray(ptr, endPtr - 1));
        }
        _nbind.readAsciiString = readAsciiString;
        function readPolicyList(policyListPtr) {
            var policyTbl = {};
            if (policyListPtr) while(true){
                var namePtr = HEAPU32[policyListPtr / 4];
                if (!namePtr) break;
                policyTbl[readAsciiString(namePtr)] = true;
                policyListPtr += 4;
            }
            return policyTbl;
        }
        _nbind.readPolicyList = readPolicyList;
        function getDynCall(typeList, name) {
            var mangleMap = {
                float32_t: "d",
                float64_t: "d",
                int64_t: "d",
                uint64_t: "d",
                "void": "v"
            };
            var signature = typeList.map(function(type) {
                return mangleMap[type.name] || "i";
            }).join("");
            var dynCall = Module["dynCall_" + signature];
            if (!dynCall) throw new Error("dynCall_" + signature + " not found for " + name + "(" + typeList.map(function(type) {
                return type.name;
            }).join(", ") + ")");
            return dynCall;
        }
        _nbind.getDynCall = getDynCall;
        function addMethod(obj, name, func, arity) {
            var overload = obj[name];
            if (obj.hasOwnProperty(name) && overload) {
                if (overload.arity || overload.arity === 0) {
                    overload = _nbind.makeOverloader(overload, overload.arity);
                    obj[name] = overload;
                }
                overload.addMethod(func, arity);
            } else {
                func.arity = arity;
                obj[name] = func;
            }
        }
        _nbind.addMethod = addMethod;
        function throwError(message) {
            throw new Error(message);
        }
        _nbind.throwError = throwError;
        _nbind.bigEndian = false;
        var _a = _typeModule(_typeModule);
        _nbind.Type = _a.Type, _nbind.makeType = _a.makeType, _nbind.getComplexType = _a.getComplexType, _nbind.structureList = _a.structureList;
        var BindType = function(_super) {
            __extends(BindType, _super);
            function BindType() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.heap = HEAPU32;
                _this.ptrSize = 4;
                return _this;
            }
            BindType.prototype.needsWireRead = function(policyTbl) {
                return !!this.wireRead || !!this.makeWireRead;
            };
            BindType.prototype.needsWireWrite = function(policyTbl) {
                return !!this.wireWrite || !!this.makeWireWrite;
            };
            return BindType;
        }(_nbind.Type);
        _nbind.BindType = BindType;
        var PrimitiveType = function(_super) {
            __extends(PrimitiveType, _super);
            function PrimitiveType(spec) {
                var _this = _super.call(this, spec) || this;
                var heapTbl = spec.flags & 32 ? {
                    32: HEAPF32,
                    64: HEAPF64
                } : spec.flags & 8 ? {
                    8: HEAPU8,
                    16: HEAPU16,
                    32: HEAPU32
                } : {
                    8: HEAP8,
                    16: HEAP16,
                    32: HEAP32
                };
                _this.heap = heapTbl[spec.ptrSize * 8];
                _this.ptrSize = spec.ptrSize;
                return _this;
            }
            PrimitiveType.prototype.needsWireWrite = function(policyTbl) {
                return !!policyTbl && !!policyTbl["Strict"];
            };
            PrimitiveType.prototype.makeWireWrite = function(expr, policyTbl) {
                return policyTbl && policyTbl["Strict"] && function(arg) {
                    if (typeof arg == "number") return arg;
                    throw new Error("Type mismatch");
                };
            };
            return PrimitiveType;
        }(BindType);
        _nbind.PrimitiveType = PrimitiveType;
        function pushCString(str, policyTbl) {
            if (str === null || str === undefined) {
                if (policyTbl && policyTbl["Nullable"]) return 0;
                else throw new Error("Type mismatch");
            }
            if (policyTbl && policyTbl["Strict"]) {
                if (typeof str != "string") throw new Error("Type mismatch");
            } else str = str.toString();
            var length = Module.lengthBytesUTF8(str) + 1;
            var result = _nbind.Pool.lalloc(length);
            Module.stringToUTF8Array(str, HEAPU8, result, length);
            return result;
        }
        _nbind.pushCString = pushCString;
        function popCString(ptr) {
            if (ptr === 0) return null;
            return Module.Pointer_stringify(ptr);
        }
        _nbind.popCString = popCString;
        var CStringType = function(_super) {
            __extends(CStringType, _super);
            function CStringType() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.wireRead = popCString;
                _this.wireWrite = pushCString;
                _this.readResources = [
                    _nbind.resources.pool
                ];
                _this.writeResources = [
                    _nbind.resources.pool
                ];
                return _this;
            }
            CStringType.prototype.makeWireWrite = function(expr, policyTbl) {
                return function(arg) {
                    return pushCString(arg, policyTbl);
                };
            };
            return CStringType;
        }(BindType);
        _nbind.CStringType = CStringType;
        var BooleanType = function(_super) {
            __extends(BooleanType, _super);
            function BooleanType() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.wireRead = function(arg) {
                    return !!arg;
                };
                return _this;
            }
            BooleanType.prototype.needsWireWrite = function(policyTbl) {
                return !!policyTbl && !!policyTbl["Strict"];
            };
            BooleanType.prototype.makeWireRead = function(expr) {
                return "!!(" + expr + ")";
            };
            BooleanType.prototype.makeWireWrite = function(expr, policyTbl) {
                return policyTbl && policyTbl["Strict"] && function(arg) {
                    if (typeof arg == "boolean") return arg;
                    throw new Error("Type mismatch");
                } || expr;
            };
            return BooleanType;
        }(BindType);
        _nbind.BooleanType = BooleanType;
        var Wrapper = function() {
            function Wrapper() {}
            Wrapper.prototype.persist = function() {
                this.__nbindState |= 1;
            };
            return Wrapper;
        }();
        _nbind.Wrapper = Wrapper;
        function makeBound(policyTbl, bindClass) {
            var Bound = function(_super) {
                __extends(Bound, _super);
                function Bound(marker, flags, ptr, shared) {
                    var _this = _super.call(this) || this;
                    if (!(_this instanceof Bound)) return new (Function.prototype.bind.apply(Bound, Array.prototype.concat.apply([
                        null
                    ], arguments)))();
                    var nbindFlags = flags;
                    var nbindPtr = ptr;
                    var nbindShared = shared;
                    if (marker !== _nbind.ptrMarker) {
                        var wirePtr = _this.__nbindConstructor.apply(_this, arguments);
                        nbindFlags = 4608;
                        nbindShared = HEAPU32[wirePtr / 4];
                        nbindPtr = HEAPU32[wirePtr / 4 + 1];
                    }
                    var spec = {
                        configurable: true,
                        enumerable: false,
                        value: null,
                        writable: false
                    };
                    var propTbl = {
                        "__nbindFlags": nbindFlags,
                        "__nbindPtr": nbindPtr
                    };
                    if (nbindShared) {
                        propTbl["__nbindShared"] = nbindShared;
                        _nbind.mark(_this);
                    }
                    for(var _i = 0, _a = Object.keys(propTbl); _i < _a.length; _i++){
                        var key = _a[_i];
                        spec.value = propTbl[key];
                        Object.defineProperty(_this, key, spec);
                    }
                    _defineHidden(0)(_this, "__nbindState");
                    return _this;
                }
                Bound.prototype.free = function() {
                    bindClass.destroy.call(this, this.__nbindShared, this.__nbindFlags);
                    this.__nbindState |= 2;
                    disableMember(this, "__nbindShared");
                    disableMember(this, "__nbindPtr");
                };
                return Bound;
            }(Wrapper);
            __decorate([
                _defineHidden()
            ], Bound.prototype, "__nbindConstructor", void 0);
            __decorate([
                _defineHidden()
            ], Bound.prototype, "__nbindValueConstructor", void 0);
            __decorate([
                _defineHidden(policyTbl)
            ], Bound.prototype, "__nbindPolicies", void 0);
            return Bound;
        }
        _nbind.makeBound = makeBound;
        function disableMember(obj, name) {
            function die() {
                throw new Error("Accessing deleted object");
            }
            Object.defineProperty(obj, name, {
                configurable: false,
                enumerable: false,
                get: die,
                set: die
            });
        }
        _nbind.ptrMarker = {};
        var BindClass = function(_super) {
            __extends(BindClass, _super);
            function BindClass(spec) {
                var _this = _super.call(this, spec) || this;
                _this.wireRead = function(arg) {
                    return _nbind.popValue(arg, _this.ptrType);
                };
                _this.wireWrite = function(arg) {
                    return pushPointer(arg, _this.ptrType, true);
                };
                _this.pendingSuperCount = 0;
                _this.ready = false;
                _this.methodTbl = {};
                if (spec.paramList) {
                    _this.classType = spec.paramList[0].classType;
                    _this.proto = _this.classType.proto;
                } else _this.classType = _this;
                return _this;
            }
            BindClass.prototype.makeBound = function(policyTbl) {
                var Bound = _nbind.makeBound(policyTbl, this);
                this.proto = Bound;
                this.ptrType.proto = Bound;
                return Bound;
            };
            BindClass.prototype.addMethod = function(spec) {
                var overloadList = this.methodTbl[spec.name] || [];
                overloadList.push(spec);
                this.methodTbl[spec.name] = overloadList;
            };
            BindClass.prototype.registerMethods = function(src, staticOnly) {
                var setter;
                for(var _i = 0, _a = Object.keys(src.methodTbl); _i < _a.length; _i++){
                    var name_1 = _a[_i];
                    var overloadList = src.methodTbl[name_1];
                    for(var _b = 0, overloadList_1 = overloadList; _b < overloadList_1.length; _b++){
                        var spec = overloadList_1[_b];
                        var target = void 0;
                        var caller = void 0;
                        target = this.proto.prototype;
                        if (staticOnly && spec.signatureType != 1) continue;
                        switch(spec.signatureType){
                            case 1:
                                target = this.proto;
                            case 5:
                                caller = _nbind.makeCaller(spec);
                                _nbind.addMethod(target, spec.name, caller, spec.typeList.length - 1);
                                break;
                            case 4:
                                setter = _nbind.makeMethodCaller(src.ptrType, spec);
                                break;
                            case 3:
                                Object.defineProperty(target, spec.name, {
                                    configurable: true,
                                    enumerable: false,
                                    get: _nbind.makeMethodCaller(src.ptrType, spec),
                                    set: setter
                                });
                                break;
                            case 2:
                                caller = _nbind.makeMethodCaller(src.ptrType, spec);
                                _nbind.addMethod(target, spec.name, caller, spec.typeList.length - 1);
                                break;
                            default:
                                break;
                        }
                    }
                }
            };
            BindClass.prototype.registerSuperMethods = function(src, firstSuper, visitTbl) {
                if (visitTbl[src.name]) return;
                visitTbl[src.name] = true;
                var superNum = 0;
                var nextFirst;
                for(var _i = 0, _a = src.superIdList || []; _i < _a.length; _i++){
                    var superId = _a[_i];
                    var superClass = _nbind.getType(superId);
                    if (superNum++ < firstSuper || firstSuper < 0) nextFirst = -1;
                    else nextFirst = 0;
                    this.registerSuperMethods(superClass, nextFirst, visitTbl);
                }
                this.registerMethods(src, firstSuper < 0);
            };
            BindClass.prototype.finish = function() {
                if (this.ready) return this;
                this.ready = true;
                this.superList = (this.superIdList || []).map(function(superId) {
                    return _nbind.getType(superId).finish();
                });
                var Bound = this.proto;
                if (this.superList.length) {
                    var Proto = function() {
                        this.constructor = Bound;
                    };
                    Proto.prototype = this.superList[0].proto.prototype;
                    Bound.prototype = new Proto();
                }
                if (Bound != Module) Bound.prototype.__nbindType = this;
                this.registerSuperMethods(this, 1, {});
                return this;
            };
            BindClass.prototype.upcastStep = function(dst, ptr) {
                if (dst == this) return ptr;
                for(var i = 0; i < this.superList.length; ++i){
                    var superPtr = this.superList[i].upcastStep(dst, _nbind.callUpcast(this.upcastList[i], ptr));
                    if (superPtr) return superPtr;
                }
                return 0;
            };
            return BindClass;
        }(_nbind.BindType);
        BindClass.list = [];
        _nbind.BindClass = BindClass;
        function popPointer(ptr, type) {
            return ptr ? new type.proto(_nbind.ptrMarker, type.flags, ptr) : null;
        }
        _nbind.popPointer = popPointer;
        function pushPointer(obj, type, tryValue) {
            if (!(obj instanceof _nbind.Wrapper)) {
                if (tryValue) return _nbind.pushValue(obj);
                else throw new Error("Type mismatch");
            }
            var ptr = obj.__nbindPtr;
            var objType = obj.__nbindType.classType;
            var classType = type.classType;
            if (obj instanceof type.proto) while(objType != classType){
                ptr = _nbind.callUpcast(objType.upcastList[0], ptr);
                objType = objType.superList[0];
            }
            else {
                ptr = objType.upcastStep(classType, ptr);
                if (!ptr) throw new Error("Type mismatch");
            }
            return ptr;
        }
        _nbind.pushPointer = pushPointer;
        function pushMutablePointer(obj, type) {
            var ptr = pushPointer(obj, type);
            if (obj.__nbindFlags & 1) throw new Error("Passing a const value as a non-const argument");
            return ptr;
        }
        var BindClassPtr = function(_super) {
            __extends(BindClassPtr, _super);
            function BindClassPtr(spec) {
                var _this = _super.call(this, spec) || this;
                _this.classType = spec.paramList[0].classType;
                _this.proto = _this.classType.proto;
                var isConst = spec.flags & 1;
                var isValue = (_this.flags & 896) == 256 && spec.flags & 2;
                var push = isConst ? pushPointer : pushMutablePointer;
                var pop = isValue ? _nbind.popValue : popPointer;
                _this.makeWireWrite = function(expr, policyTbl) {
                    return policyTbl["Nullable"] ? function(arg) {
                        return arg ? push(arg, _this) : 0;
                    } : function(arg) {
                        return push(arg, _this);
                    };
                };
                _this.wireRead = function(arg) {
                    return pop(arg, _this);
                };
                _this.wireWrite = function(arg) {
                    return push(arg, _this);
                };
                return _this;
            }
            return BindClassPtr;
        }(_nbind.BindType);
        _nbind.BindClassPtr = BindClassPtr;
        function popShared(ptr, type) {
            var shared = HEAPU32[ptr / 4];
            var unsafe = HEAPU32[ptr / 4 + 1];
            return unsafe ? new type.proto(_nbind.ptrMarker, type.flags, unsafe, shared) : null;
        }
        _nbind.popShared = popShared;
        function pushShared(obj, type) {
            if (!(obj instanceof type.proto)) throw new Error("Type mismatch");
            return obj.__nbindShared;
        }
        function pushMutableShared(obj, type) {
            if (!(obj instanceof type.proto)) throw new Error("Type mismatch");
            if (obj.__nbindFlags & 1) throw new Error("Passing a const value as a non-const argument");
            return obj.__nbindShared;
        }
        var SharedClassPtr = function(_super) {
            __extends(SharedClassPtr, _super);
            function SharedClassPtr(spec) {
                var _this = _super.call(this, spec) || this;
                _this.readResources = [
                    _nbind.resources.pool
                ];
                _this.classType = spec.paramList[0].classType;
                _this.proto = _this.classType.proto;
                var isConst = spec.flags & 1;
                var push = isConst ? pushShared : pushMutableShared;
                _this.wireRead = function(arg) {
                    return popShared(arg, _this);
                };
                _this.wireWrite = function(arg) {
                    return push(arg, _this);
                };
                return _this;
            }
            return SharedClassPtr;
        }(_nbind.BindType);
        _nbind.SharedClassPtr = SharedClassPtr;
        _nbind.externalList = [
            0
        ];
        var firstFreeExternal = 0;
        var External = function() {
            function External(data) {
                this.refCount = 1;
                this.data = data;
            }
            External.prototype.register = function() {
                var num = firstFreeExternal;
                if (num) firstFreeExternal = _nbind.externalList[num];
                else num = _nbind.externalList.length;
                _nbind.externalList[num] = this;
                return num;
            };
            External.prototype.reference = function() {
                ++this.refCount;
            };
            External.prototype.dereference = function(num) {
                if (--this.refCount == 0) {
                    if (this.free) this.free();
                    _nbind.externalList[num] = firstFreeExternal;
                    firstFreeExternal = num;
                }
            };
            return External;
        }();
        _nbind.External = External;
        function popExternal(num) {
            var obj = _nbind.externalList[num];
            obj.dereference(num);
            return obj.data;
        }
        function pushExternal(obj) {
            var external = new External(obj);
            external.reference();
            return external.register();
        }
        var ExternalType = function(_super) {
            __extends(ExternalType, _super);
            function ExternalType() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.wireRead = popExternal;
                _this.wireWrite = pushExternal;
                return _this;
            }
            return ExternalType;
        }(_nbind.BindType);
        _nbind.ExternalType = ExternalType;
        _nbind.callbackSignatureList = [];
        var CallbackType = function(_super) {
            __extends(CallbackType, _super);
            function CallbackType() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.wireWrite = function(func) {
                    if (typeof func != "function") _nbind.throwError("Type mismatch");
                    return new _nbind.External(func).register();
                };
                return _this;
            }
            return CallbackType;
        }(_nbind.BindType);
        _nbind.CallbackType = CallbackType;
        _nbind.valueList = [
            0
        ];
        var firstFreeValue = 0;
        function pushValue(value) {
            var num = firstFreeValue;
            if (num) firstFreeValue = _nbind.valueList[num];
            else num = _nbind.valueList.length;
            _nbind.valueList[num] = value;
            return num * 2 + 1;
        }
        _nbind.pushValue = pushValue;
        function popValue(num, type) {
            if (!num) _nbind.throwError("Value type JavaScript class is missing or not registered");
            if (num & 1) {
                num >>= 1;
                var obj = _nbind.valueList[num];
                _nbind.valueList[num] = firstFreeValue;
                firstFreeValue = num;
                return obj;
            } else if (type) return _nbind.popShared(num, type);
            else throw new Error("Invalid value slot " + num);
        }
        _nbind.popValue = popValue;
        var valueBase = 0x10000000000000000;
        function push64(num) {
            if (typeof num == "number") return num;
            return pushValue(num) * 4096 + valueBase;
        }
        function pop64(num) {
            if (num < valueBase) return num;
            return popValue((num - valueBase) / 4096);
        }
        var CreateValueType = function(_super) {
            __extends(CreateValueType, _super);
            function CreateValueType() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            CreateValueType.prototype.makeWireWrite = function(expr) {
                return "(_nbind.pushValue(new " + expr + "))";
            };
            return CreateValueType;
        }(_nbind.BindType);
        _nbind.CreateValueType = CreateValueType;
        var Int64Type = function(_super) {
            __extends(Int64Type, _super);
            function Int64Type() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.wireWrite = push64;
                _this.wireRead = pop64;
                return _this;
            }
            return Int64Type;
        }(_nbind.BindType);
        _nbind.Int64Type = Int64Type;
        function pushArray(arr, type) {
            if (!arr) return 0;
            var length = arr.length;
            if ((type.size || type.size === 0) && length < type.size) throw new Error("Type mismatch");
            var ptrSize = type.memberType.ptrSize;
            var result = _nbind.Pool.lalloc(4 + length * ptrSize);
            HEAPU32[result / 4] = length;
            var heap = type.memberType.heap;
            var ptr = (result + 4) / ptrSize;
            var wireWrite = type.memberType.wireWrite;
            var num = 0;
            if (wireWrite) while(num < length)heap[ptr++] = wireWrite(arr[num++]);
            else while(num < length)heap[ptr++] = arr[num++];
            return result;
        }
        _nbind.pushArray = pushArray;
        function popArray(ptr, type) {
            if (ptr === 0) return null;
            var length = HEAPU32[ptr / 4];
            var arr = new Array(length);
            var heap = type.memberType.heap;
            ptr = (ptr + 4) / type.memberType.ptrSize;
            var wireRead = type.memberType.wireRead;
            var num = 0;
            if (wireRead) while(num < length)arr[num++] = wireRead(heap[ptr++]);
            else while(num < length)arr[num++] = heap[ptr++];
            return arr;
        }
        _nbind.popArray = popArray;
        var ArrayType = function(_super) {
            __extends(ArrayType, _super);
            function ArrayType(spec) {
                var _this = _super.call(this, spec) || this;
                _this.wireRead = function(arg) {
                    return popArray(arg, _this);
                };
                _this.wireWrite = function(arg) {
                    return pushArray(arg, _this);
                };
                _this.readResources = [
                    _nbind.resources.pool
                ];
                _this.writeResources = [
                    _nbind.resources.pool
                ];
                _this.memberType = spec.paramList[0];
                if (spec.paramList[1]) _this.size = spec.paramList[1];
                return _this;
            }
            return ArrayType;
        }(_nbind.BindType);
        _nbind.ArrayType = ArrayType;
        function pushString(str, policyTbl) {
            if (str === null || str === undefined) {
                if (policyTbl && policyTbl["Nullable"]) str = "";
                else throw new Error("Type mismatch");
            }
            if (policyTbl && policyTbl["Strict"]) {
                if (typeof str != "string") throw new Error("Type mismatch");
            } else str = str.toString();
            var length = Module.lengthBytesUTF8(str);
            var result = _nbind.Pool.lalloc(4 + length + 1);
            HEAPU32[result / 4] = length;
            Module.stringToUTF8Array(str, HEAPU8, result + 4, length + 1);
            return result;
        }
        _nbind.pushString = pushString;
        function popString(ptr) {
            if (ptr === 0) return null;
            var length = HEAPU32[ptr / 4];
            return Module.Pointer_stringify(ptr + 4, length);
        }
        _nbind.popString = popString;
        var StringType = function(_super) {
            __extends(StringType, _super);
            function StringType() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.wireRead = popString;
                _this.wireWrite = pushString;
                _this.readResources = [
                    _nbind.resources.pool
                ];
                _this.writeResources = [
                    _nbind.resources.pool
                ];
                return _this;
            }
            StringType.prototype.makeWireWrite = function(expr, policyTbl) {
                return function(arg) {
                    return pushString(arg, policyTbl);
                };
            };
            return StringType;
        }(_nbind.BindType);
        _nbind.StringType = StringType;
        function makeArgList(argCount) {
            return Array.apply(null, Array(argCount)).map(function(dummy, num) {
                return "a" + (num + 1);
            });
        }
        function anyNeedsWireWrite(typeList, policyTbl) {
            return typeList.reduce(function(result, type) {
                return result || type.needsWireWrite(policyTbl);
            }, false);
        }
        function anyNeedsWireRead(typeList, policyTbl) {
            return typeList.reduce(function(result, type) {
                return result || !!type.needsWireRead(policyTbl);
            }, false);
        }
        function makeWireRead(convertParamList, policyTbl, type, expr) {
            var paramNum = convertParamList.length;
            if (type.makeWireRead) return type.makeWireRead(expr, convertParamList, paramNum);
            else if (type.wireRead) {
                convertParamList[paramNum] = type.wireRead;
                return "(convertParamList[" + paramNum + "](" + expr + "))";
            } else return expr;
        }
        function makeWireWrite(convertParamList, policyTbl, type, expr) {
            var wireWrite;
            var paramNum = convertParamList.length;
            if (type.makeWireWrite) wireWrite = type.makeWireWrite(expr, policyTbl, convertParamList, paramNum);
            else wireWrite = type.wireWrite;
            if (wireWrite) {
                if (typeof wireWrite == "string") return wireWrite;
                else {
                    convertParamList[paramNum] = wireWrite;
                    return "(convertParamList[" + paramNum + "](" + expr + "))";
                }
            } else return expr;
        }
        function buildCallerFunction(dynCall, ptrType, ptr, num, policyTbl, needsWireWrite, prefix, returnType, argTypeList, mask, err) {
            var argList = makeArgList(argTypeList.length);
            var convertParamList = [];
            var callExpression = makeWireRead(convertParamList, policyTbl, returnType, "dynCall(" + [
                prefix
            ].concat(argList.map(function(name, index) {
                return makeWireWrite(convertParamList, policyTbl, argTypeList[index], name);
            })).join(",") + ")");
            var resourceSet = _nbind.listResources([
                returnType
            ], argTypeList);
            var sourceCode = "function(" + argList.join(",") + "){" + (mask ? "this.__nbindFlags&mask&&err();" : "") + resourceSet.makeOpen() + "var r=" + callExpression + ";" + resourceSet.makeClose() + "return r;" + "}";
            return eval("(" + sourceCode + ")");
        }
        function buildJSCallerFunction(returnType, argTypeList) {
            var argList = makeArgList(argTypeList.length);
            var convertParamList = [];
            var callExpression = makeWireWrite(convertParamList, null, returnType, "_nbind.externalList[num].data(" + argList.map(function(name, index) {
                return makeWireRead(convertParamList, null, argTypeList[index], name);
            }).join(",") + ")");
            var resourceSet = _nbind.listResources(argTypeList, [
                returnType
            ]);
            resourceSet.remove(_nbind.resources.pool);
            var sourceCode = "function(" + [
                "dummy",
                "num"
            ].concat(argList).join(",") + "){" + resourceSet.makeOpen() + "var r=" + callExpression + ";" + resourceSet.makeClose() + "return r;" + "}";
            return eval("(" + sourceCode + ")");
        }
        _nbind.buildJSCallerFunction = buildJSCallerFunction;
        function makeJSCaller(idList) {
            var argCount = idList.length - 1;
            var typeList = _nbind.getTypes(idList, "callback");
            var returnType = typeList[0];
            var argTypeList = typeList.slice(1);
            var needsWireRead = anyNeedsWireRead(argTypeList, null);
            var needsWireWrite = returnType.needsWireWrite(null);
            if (!needsWireWrite && !needsWireRead) switch(argCount){
                case 0:
                    return function(dummy, num) {
                        return _nbind.externalList[num].data();
                    };
                case 1:
                    return function(dummy, num, a1) {
                        return _nbind.externalList[num].data(a1);
                    };
                case 2:
                    return function(dummy, num, a1, a2) {
                        return _nbind.externalList[num].data(a1, a2);
                    };
                case 3:
                    return function(dummy, num, a1, a2, a3) {
                        return _nbind.externalList[num].data(a1, a2, a3);
                    };
                default:
                    break;
            }
            return buildJSCallerFunction(returnType, argTypeList);
        }
        _nbind.makeJSCaller = makeJSCaller;
        function makeMethodCaller(ptrType, spec) {
            var argCount = spec.typeList.length - 1;
            var typeIdList = spec.typeList.slice(0);
            typeIdList.splice(1, 0, "uint32_t", spec.boundID);
            var typeList = _nbind.getTypes(typeIdList, spec.title);
            var returnType = typeList[0];
            var argTypeList = typeList.slice(3);
            var needsWireRead = returnType.needsWireRead(spec.policyTbl);
            var needsWireWrite = anyNeedsWireWrite(argTypeList, spec.policyTbl);
            var ptr = spec.ptr;
            var num = spec.num;
            var dynCall = _nbind.getDynCall(typeList, spec.title);
            var mask = ~spec.flags & 1;
            function err() {
                throw new Error("Calling a non-const method on a const object");
            }
            if (!needsWireRead && !needsWireWrite) switch(argCount){
                case 0:
                    return function() {
                        return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType));
                    };
                case 1:
                    return function(a1) {
                        return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType), a1);
                    };
                case 2:
                    return function(a1, a2) {
                        return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType), a1, a2);
                    };
                case 3:
                    return function(a1, a2, a3) {
                        return this.__nbindFlags & mask ? err() : dynCall(ptr, num, _nbind.pushPointer(this, ptrType), a1, a2, a3);
                    };
                default:
                    break;
            }
            return buildCallerFunction(dynCall, ptrType, ptr, num, spec.policyTbl, needsWireWrite, "ptr,num,pushPointer(this,ptrType)", returnType, argTypeList, mask, err);
        }
        _nbind.makeMethodCaller = makeMethodCaller;
        function makeCaller(spec) {
            var argCount = spec.typeList.length - 1;
            var typeList = _nbind.getTypes(spec.typeList, spec.title);
            var returnType = typeList[0];
            var argTypeList = typeList.slice(1);
            var needsWireRead = returnType.needsWireRead(spec.policyTbl);
            var needsWireWrite = anyNeedsWireWrite(argTypeList, spec.policyTbl);
            var direct = spec.direct;
            var ptr = spec.ptr;
            if (spec.direct && !needsWireRead && !needsWireWrite) {
                var dynCall_1 = _nbind.getDynCall(typeList, spec.title);
                switch(argCount){
                    case 0:
                        return function() {
                            return dynCall_1(direct);
                        };
                    case 1:
                        return function(a1) {
                            return dynCall_1(direct, a1);
                        };
                    case 2:
                        return function(a1, a2) {
                            return dynCall_1(direct, a1, a2);
                        };
                    case 3:
                        return function(a1, a2, a3) {
                            return dynCall_1(direct, a1, a2, a3);
                        };
                    default:
                        break;
                }
                ptr = 0;
            }
            var prefix;
            if (ptr) {
                var typeIdList = spec.typeList.slice(0);
                typeIdList.splice(1, 0, "uint32_t");
                typeList = _nbind.getTypes(typeIdList, spec.title);
                prefix = "ptr,num";
            } else {
                ptr = direct;
                prefix = "ptr";
            }
            var dynCall = _nbind.getDynCall(typeList, spec.title);
            return buildCallerFunction(dynCall, null, ptr, spec.num, spec.policyTbl, needsWireWrite, prefix, returnType, argTypeList);
        }
        _nbind.makeCaller = makeCaller;
        function makeOverloader(func, arity) {
            var callerList = [];
            function call() {
                return callerList[arguments.length].apply(this, arguments);
            }
            call.addMethod = function(_func, _arity) {
                callerList[_arity] = _func;
            };
            call.addMethod(func, arity);
            return call;
        }
        _nbind.makeOverloader = makeOverloader;
        var Resource = function() {
            function Resource(open, close) {
                var _this = this;
                this.makeOpen = function() {
                    return Object.keys(_this.openTbl).join("");
                };
                this.makeClose = function() {
                    return Object.keys(_this.closeTbl).join("");
                };
                this.openTbl = {};
                this.closeTbl = {};
                if (open) this.openTbl[open] = true;
                if (close) this.closeTbl[close] = true;
            }
            Resource.prototype.add = function(other) {
                for(var _i = 0, _a = Object.keys(other.openTbl); _i < _a.length; _i++){
                    var key = _a[_i];
                    this.openTbl[key] = true;
                }
                for(var _b = 0, _c = Object.keys(other.closeTbl); _b < _c.length; _b++){
                    var key = _c[_b];
                    this.closeTbl[key] = true;
                }
            };
            Resource.prototype.remove = function(other) {
                for(var _i = 0, _a = Object.keys(other.openTbl); _i < _a.length; _i++){
                    var key = _a[_i];
                    delete this.openTbl[key];
                }
                for(var _b = 0, _c = Object.keys(other.closeTbl); _b < _c.length; _b++){
                    var key = _c[_b];
                    delete this.closeTbl[key];
                }
            };
            return Resource;
        }();
        _nbind.Resource = Resource;
        function listResources(readList, writeList) {
            var result = new Resource();
            for(var _i = 0, readList_1 = readList; _i < readList_1.length; _i++){
                var bindType = readList_1[_i];
                for(var _a = 0, _b = bindType.readResources || []; _a < _b.length; _a++){
                    var resource = _b[_a];
                    result.add(resource);
                }
            }
            for(var _c = 0, writeList_1 = writeList; _c < writeList_1.length; _c++){
                var bindType = writeList_1[_c];
                for(var _d = 0, _e = bindType.writeResources || []; _d < _e.length; _d++){
                    var resource = _e[_d];
                    result.add(resource);
                }
            }
            return result;
        }
        _nbind.listResources = listResources;
        _nbind.resources = {
            pool: new Resource("var used=HEAPU32[_nbind.Pool.usedPtr],page=HEAPU32[_nbind.Pool.pagePtr];", "_nbind.Pool.lreset(used,page);")
        };
        var ExternalBuffer = function(_super) {
            __extends(ExternalBuffer, _super);
            function ExternalBuffer(buf, ptr) {
                var _this = _super.call(this, buf) || this;
                _this.ptr = ptr;
                return _this;
            }
            ExternalBuffer.prototype.free = function() {
                _free(this.ptr);
            };
            return ExternalBuffer;
        }(_nbind.External);
        function getBuffer(buf) {
            if (buf instanceof ArrayBuffer) return new Uint8Array(buf);
            else if (buf instanceof DataView) return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
            else return buf;
        }
        function pushBuffer(buf, policyTbl) {
            if (buf === null || buf === undefined) {
                if (policyTbl && policyTbl["Nullable"]) buf = [];
            }
            if (typeof buf != "object") throw new Error("Type mismatch");
            var b = buf;
            var length = b.byteLength || b.length;
            if (!length && length !== 0 && b.byteLength !== 0) throw new Error("Type mismatch");
            var result = _nbind.Pool.lalloc(8);
            var data = _malloc(length);
            var ptr = result / 4;
            HEAPU32[ptr++] = length;
            HEAPU32[ptr++] = data;
            HEAPU32[ptr++] = new ExternalBuffer(buf, data).register();
            HEAPU8.set(getBuffer(buf), data);
            return result;
        }
        var BufferType = function(_super) {
            __extends(BufferType, _super);
            function BufferType() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.wireWrite = pushBuffer;
                _this.readResources = [
                    _nbind.resources.pool
                ];
                _this.writeResources = [
                    _nbind.resources.pool
                ];
                return _this;
            }
            BufferType.prototype.makeWireWrite = function(expr, policyTbl) {
                return function(arg) {
                    return pushBuffer(arg, policyTbl);
                };
            };
            return BufferType;
        }(_nbind.BindType);
        _nbind.BufferType = BufferType;
        function commitBuffer(num, data, length) {
            var buf = _nbind.externalList[num].data;
            var NodeBuffer = Buffer;
            if (typeof Buffer != "function") NodeBuffer = function() {};
            if (buf instanceof Array) ;
            else {
                var src = HEAPU8.subarray(data, data + length);
                if (buf instanceof NodeBuffer) {
                    var srcBuf = void 0;
                    if (typeof Buffer.from == "function" && Buffer.from.length >= 3) srcBuf = Buffer.from(src);
                    else srcBuf = Buffer.from(src);
                    srcBuf.copy(buf);
                } else getBuffer(buf).set(src);
            }
        }
        _nbind.commitBuffer = commitBuffer;
        var dirtyList = [];
        var gcTimer = 0;
        function sweep() {
            for(var _i = 0, dirtyList_1 = dirtyList; _i < dirtyList_1.length; _i++){
                var obj = dirtyList_1[_i];
                if (!(obj.__nbindState & 3)) obj.free();
            }
            dirtyList = [];
            gcTimer = 0;
        }
        _nbind.mark = function(obj) {};
        function toggleLightGC(enable) {
            if (enable) _nbind.mark = function(obj) {
                dirtyList.push(obj);
                if (!gcTimer) gcTimer = setTimeout(sweep, 0);
            };
            else _nbind.mark = function(obj) {};
        }
        _nbind.toggleLightGC = toggleLightGC;
    })(_nbind);
    Module["requestFullScreen"] = function Module_requestFullScreen(lockPointer, resizeCanvas, vrDevice) {
        Module.printErr("Module.requestFullScreen is deprecated. Please call Module.requestFullscreen instead.");
        Module["requestFullScreen"] = Module["requestFullscreen"];
        Browser.requestFullScreen(lockPointer, resizeCanvas, vrDevice);
    };
    Module["requestFullscreen"] = function Module_requestFullscreen(lockPointer, resizeCanvas, vrDevice) {
        Browser.requestFullscreen(lockPointer, resizeCanvas, vrDevice);
    };
    Module["requestAnimationFrame"] = function Module_requestAnimationFrame(func) {
        Browser.requestAnimationFrame(func);
    };
    Module["setCanvasSize"] = function Module_setCanvasSize(width, height, noUpdates) {
        Browser.setCanvasSize(width, height, noUpdates);
    };
    Module["pauseMainLoop"] = function Module_pauseMainLoop() {
        Browser.mainLoop.pause();
    };
    Module["resumeMainLoop"] = function Module_resumeMainLoop() {
        Browser.mainLoop.resume();
    };
    Module["getUserMedia"] = function Module_getUserMedia() {
        Browser.getUserMedia();
    };
    Module["createContext"] = function Module_createContext(canvas, useWebGL, setInModule, webGLContextAttributes) {
        return Browser.createContext(canvas, useWebGL, setInModule, webGLContextAttributes);
    };
    if (ENVIRONMENT_IS_NODE) _emscripten_get_now = function _emscripten_get_now_actual() {
        var t = process["hrtime"]();
        return t[0] * 1e3 + t[1] / 1e6;
    };
    else if (typeof dateNow !== "undefined") _emscripten_get_now = dateNow;
    else if (typeof self === "object" && self["performance"] && typeof self["performance"]["now"] === "function") _emscripten_get_now = function() {
        return self["performance"]["now"]();
    };
    else if (typeof performance === "object" && typeof performance["now"] === "function") _emscripten_get_now = function() {
        return performance["now"]();
    };
    else _emscripten_get_now = Date.now;
    __ATEXIT__.push(function() {
        var fflush = Module["_fflush"];
        if (fflush) fflush(0);
        var printChar = ___syscall146.printChar;
        if (!printChar) return;
        var buffers = ___syscall146.buffers;
        if (buffers[1].length) printChar(1, 10);
        if (buffers[2].length) printChar(2, 10);
    });
    DYNAMICTOP_PTR = allocate(1, "i32", ALLOC_STATIC);
    STACK_BASE = STACKTOP = Runtime.alignMemory(STATICTOP);
    STACK_MAX = STACK_BASE + TOTAL_STACK;
    DYNAMIC_BASE = Runtime.alignMemory(STACK_MAX);
    HEAP32[DYNAMICTOP_PTR >> 2] = DYNAMIC_BASE;
    staticSealed = true;
    function invoke_viiiii(index, a1, a2, a3, a4, a5) {
        try {
            Module["dynCall_viiiii"](index, a1, a2, a3, a4, a5);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_vif(index, a1, a2) {
        try {
            Module["dynCall_vif"](index, a1, a2);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_vid(index, a1, a2) {
        try {
            Module["dynCall_vid"](index, a1, a2);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_fiff(index, a1, a2, a3) {
        try {
            return Module["dynCall_fiff"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_vi(index, a1) {
        try {
            Module["dynCall_vi"](index, a1);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_vii(index, a1, a2) {
        try {
            Module["dynCall_vii"](index, a1, a2);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_ii(index, a1) {
        try {
            return Module["dynCall_ii"](index, a1);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viddi(index, a1, a2, a3, a4) {
        try {
            Module["dynCall_viddi"](index, a1, a2, a3, a4);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_vidd(index, a1, a2, a3) {
        try {
            Module["dynCall_vidd"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_iiii(index, a1, a2, a3) {
        try {
            return Module["dynCall_iiii"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_diii(index, a1, a2, a3) {
        try {
            return Module["dynCall_diii"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_di(index, a1) {
        try {
            return Module["dynCall_di"](index, a1);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_iid(index, a1, a2) {
        try {
            return Module["dynCall_iid"](index, a1, a2);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_iii(index, a1, a2) {
        try {
            return Module["dynCall_iii"](index, a1, a2);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viiddi(index, a1, a2, a3, a4, a5) {
        try {
            Module["dynCall_viiddi"](index, a1, a2, a3, a4, a5);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viiiiii(index, a1, a2, a3, a4, a5, a6) {
        try {
            Module["dynCall_viiiiii"](index, a1, a2, a3, a4, a5, a6);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_dii(index, a1, a2) {
        try {
            return Module["dynCall_dii"](index, a1, a2);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_i(index) {
        try {
            return Module["dynCall_i"](index);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_iiiiii(index, a1, a2, a3, a4, a5) {
        try {
            return Module["dynCall_iiiiii"](index, a1, a2, a3, a4, a5);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viiid(index, a1, a2, a3, a4) {
        try {
            Module["dynCall_viiid"](index, a1, a2, a3, a4);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viififi(index, a1, a2, a3, a4, a5, a6) {
        try {
            Module["dynCall_viififi"](index, a1, a2, a3, a4, a5, a6);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viii(index, a1, a2, a3) {
        try {
            Module["dynCall_viii"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_v(index) {
        try {
            Module["dynCall_v"](index);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viid(index, a1, a2, a3) {
        try {
            Module["dynCall_viid"](index, a1, a2, a3);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_idd(index, a1, a2) {
        try {
            return Module["dynCall_idd"](index, a1, a2);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    function invoke_viiii(index, a1, a2, a3, a4) {
        try {
            Module["dynCall_viiii"](index, a1, a2, a3, a4);
        } catch (e) {
            if (typeof e !== "number" && e !== "longjmp") throw e;
            Module["setThrew"](1, 0);
        }
    }
    Module.asmGlobalArg = {
        "Math": Math,
        "Int8Array": Int8Array,
        "Int16Array": Int16Array,
        "Int32Array": Int32Array,
        "Uint8Array": Uint8Array,
        "Uint16Array": Uint16Array,
        "Uint32Array": Uint32Array,
        "Float32Array": Float32Array,
        "Float64Array": Float64Array,
        "NaN": NaN,
        "Infinity": Infinity
    };
    Module.asmLibraryArg = {
        "abort": abort,
        "assert": assert,
        "enlargeMemory": enlargeMemory,
        "getTotalMemory": getTotalMemory,
        "abortOnCannotGrowMemory": abortOnCannotGrowMemory,
        "invoke_viiiii": invoke_viiiii,
        "invoke_vif": invoke_vif,
        "invoke_vid": invoke_vid,
        "invoke_fiff": invoke_fiff,
        "invoke_vi": invoke_vi,
        "invoke_vii": invoke_vii,
        "invoke_ii": invoke_ii,
        "invoke_viddi": invoke_viddi,
        "invoke_vidd": invoke_vidd,
        "invoke_iiii": invoke_iiii,
        "invoke_diii": invoke_diii,
        "invoke_di": invoke_di,
        "invoke_iid": invoke_iid,
        "invoke_iii": invoke_iii,
        "invoke_viiddi": invoke_viiddi,
        "invoke_viiiiii": invoke_viiiiii,
        "invoke_dii": invoke_dii,
        "invoke_i": invoke_i,
        "invoke_iiiiii": invoke_iiiiii,
        "invoke_viiid": invoke_viiid,
        "invoke_viififi": invoke_viififi,
        "invoke_viii": invoke_viii,
        "invoke_v": invoke_v,
        "invoke_viid": invoke_viid,
        "invoke_idd": invoke_idd,
        "invoke_viiii": invoke_viiii,
        "_emscripten_asm_const_iiiii": _emscripten_asm_const_iiiii,
        "_emscripten_asm_const_iiidddddd": _emscripten_asm_const_iiidddddd,
        "_emscripten_asm_const_iiiid": _emscripten_asm_const_iiiid,
        "__nbind_reference_external": __nbind_reference_external,
        "_emscripten_asm_const_iiiiiiii": _emscripten_asm_const_iiiiiiii,
        "_removeAccessorPrefix": _removeAccessorPrefix,
        "_typeModule": _typeModule,
        "__nbind_register_pool": __nbind_register_pool,
        "__decorate": __decorate,
        "_llvm_stackrestore": _llvm_stackrestore,
        "___cxa_atexit": ___cxa_atexit,
        "__extends": __extends,
        "__nbind_get_value_object": __nbind_get_value_object,
        "__ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj": __ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj,
        "_emscripten_set_main_loop_timing": _emscripten_set_main_loop_timing,
        "__nbind_register_primitive": __nbind_register_primitive,
        "__nbind_register_type": __nbind_register_type,
        "_emscripten_memcpy_big": _emscripten_memcpy_big,
        "__nbind_register_function": __nbind_register_function,
        "___setErrNo": ___setErrNo,
        "__nbind_register_class": __nbind_register_class,
        "__nbind_finish": __nbind_finish,
        "_abort": _abort,
        "_nbind_value": _nbind_value,
        "_llvm_stacksave": _llvm_stacksave,
        "___syscall54": ___syscall54,
        "_defineHidden": _defineHidden,
        "_emscripten_set_main_loop": _emscripten_set_main_loop,
        "_emscripten_get_now": _emscripten_get_now,
        "__nbind_register_callback_signature": __nbind_register_callback_signature,
        "_emscripten_asm_const_iiiiii": _emscripten_asm_const_iiiiii,
        "__nbind_free_external": __nbind_free_external,
        "_emscripten_asm_const_iiii": _emscripten_asm_const_iiii,
        "_emscripten_asm_const_iiididi": _emscripten_asm_const_iiididi,
        "___syscall6": ___syscall6,
        "_atexit": _atexit,
        "___syscall140": ___syscall140,
        "___syscall146": ___syscall146,
        "DYNAMICTOP_PTR": DYNAMICTOP_PTR,
        "tempDoublePtr": tempDoublePtr,
        "ABORT": ABORT,
        "STACKTOP": STACKTOP,
        "STACK_MAX": STACK_MAX,
        "cttz_i8": cttz_i8,
        "___dso_handle": ___dso_handle
    }; // EMSCRIPTEN_START_ASM
    var asm = function(global, env, buffer) {
        "use asm";
        var a = new global.Int8Array(buffer);
        var b = new global.Int16Array(buffer);
        var c = new global.Int32Array(buffer);
        var d = new global.Uint8Array(buffer);
        var e = new global.Uint16Array(buffer);
        var f = new global.Uint32Array(buffer);
        var g = new global.Float32Array(buffer);
        var h = new global.Float64Array(buffer);
        var i = env.DYNAMICTOP_PTR | 0;
        var j = env.tempDoublePtr | 0;
        var k = env.ABORT | 0;
        var l = env.STACKTOP | 0;
        var m = env.STACK_MAX | 0;
        var n = env.cttz_i8 | 0;
        var o = env.___dso_handle | 0;
        var p = 0;
        var q = 0;
        var r = 0;
        var s = 0;
        var t = global.NaN, u = global.Infinity;
        var v = 0, w = 0, x = 0, y = 0, z = 0.0;
        var A = 0;
        var B = global.Math.floor;
        var C = global.Math.abs;
        var D = global.Math.sqrt;
        var E = global.Math.pow;
        var F = global.Math.cos;
        var G = global.Math.sin;
        var H = global.Math.tan;
        var I = global.Math.acos;
        var J = global.Math.asin;
        var K = global.Math.atan;
        var L = global.Math.atan2;
        var M = global.Math.exp;
        var N = global.Math.log;
        var O = global.Math.ceil;
        var P = global.Math.imul;
        var Q = global.Math.min;
        var R = global.Math.max;
        var S = global.Math.clz32;
        var T = global.Math.fround;
        var U = env.abort;
        var V = env.assert;
        var W = env.enlargeMemory;
        var X = env.getTotalMemory;
        var Y = env.abortOnCannotGrowMemory;
        var Z = env.invoke_viiiii;
        var _ = env.invoke_vif;
        var $ = env.invoke_vid;
        var aa = env.invoke_fiff;
        var ba = env.invoke_vi;
        var ca = env.invoke_vii;
        var da = env.invoke_ii;
        var ea = env.invoke_viddi;
        var fa = env.invoke_vidd;
        var ga = env.invoke_iiii;
        var ha = env.invoke_diii;
        var ia = env.invoke_di;
        var ja = env.invoke_iid;
        var ka = env.invoke_iii;
        var la = env.invoke_viiddi;
        var ma = env.invoke_viiiiii;
        var na = env.invoke_dii;
        var oa = env.invoke_i;
        var pa = env.invoke_iiiiii;
        var qa = env.invoke_viiid;
        var ra = env.invoke_viififi;
        var sa = env.invoke_viii;
        var ta = env.invoke_v;
        var ua = env.invoke_viid;
        var va = env.invoke_idd;
        var wa = env.invoke_viiii;
        var xa = env._emscripten_asm_const_iiiii;
        var ya = env._emscripten_asm_const_iiidddddd;
        var za = env._emscripten_asm_const_iiiid;
        var Aa = env.__nbind_reference_external;
        var Ba = env._emscripten_asm_const_iiiiiiii;
        var Ca = env._removeAccessorPrefix;
        var Da = env._typeModule;
        var Ea = env.__nbind_register_pool;
        var Fa = env.__decorate;
        var Ga = env._llvm_stackrestore;
        var Ha = env.___cxa_atexit;
        var Ia = env.__extends;
        var Ja = env.__nbind_get_value_object;
        var Ka = env.__ZN8facebook4yoga14YGNodeToStringEPNSt3__212basic_stringIcNS1_11char_traitsIcEENS1_9allocatorIcEEEEP6YGNode14YGPrintOptionsj;
        var La = env._emscripten_set_main_loop_timing;
        var Ma = env.__nbind_register_primitive;
        var Na = env.__nbind_register_type;
        var Oa = env._emscripten_memcpy_big;
        var Pa = env.__nbind_register_function;
        var Qa = env.___setErrNo;
        var Ra = env.__nbind_register_class;
        var Sa = env.__nbind_finish;
        var Ta = env._abort;
        var Ua = env._nbind_value;
        var Va = env._llvm_stacksave;
        var Wa = env.___syscall54;
        var Xa = env._defineHidden;
        var Ya = env._emscripten_set_main_loop;
        var Za = env._emscripten_get_now;
        var _a = env.__nbind_register_callback_signature;
        var $a = env._emscripten_asm_const_iiiiii;
        var ab = env.__nbind_free_external;
        var bb = env._emscripten_asm_const_iiii;
        var cb = env._emscripten_asm_const_iiididi;
        var db = env.___syscall6;
        var eb = env._atexit;
        var fb = env.___syscall140;
        var gb = env.___syscall146;
        var hb = T(0);
        const ib = T(0);
        // EMSCRIPTEN_START_FUNCS
        function Jb(a) {
            a = a | 0;
            var b = 0;
            b = l;
            l = l + a | 0;
            l = l + 15 & -16;
            return b | 0;
        }
        function Kb() {
            return l | 0;
        }
        function Lb(a) {
            a = a | 0;
            l = a;
        }
        function Mb(a, b) {
            a = a | 0;
            b = b | 0;
            l = a;
            m = b;
        }
        function Nb(a, b) {
            a = a | 0;
            b = b | 0;
            if (!p) {
                p = a;
                q = b;
            }
        }
        function Ob(a) {
            a = a | 0;
            A = a;
        }
        function Pb() {
            return A | 0;
        }
        function Qb() {
            var b = 0, d = 0;
            BC(8104, 8, 400);
            BC(8504, 408, 540);
            b = 9044;
            d = b + 44 | 0;
            do {
                c[b >> 2] = 0;
                b = b + 4 | 0;
            }while ((b | 0) < (d | 0));
            a[9088] = 0;
            a[9089] = 1;
            c[2273] = 0;
            c[2274] = 948;
            c[2275] = 948;
            Ha(17, 8104, o | 0);
            return;
        }
        function Rb(a) {
            a = a | 0;
            oc(a + 948 | 0);
            return;
        }
        function Sb(a) {
            a = T(a);
            return ((af(a) | 0) & 2147483647) >>> 0 > 2139095040 | 0;
        }
        function Tb(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            a: do if (!(c[a + (b << 3) + 4 >> 2] | 0)) {
                if ((b | 2) == 3 ? c[a + 60 >> 2] | 0 : 0) {
                    a = a + 56 | 0;
                    break;
                }
                switch(b | 0){
                    case 0:
                    case 2:
                    case 4:
                    case 5:
                        if (c[a + 52 >> 2] | 0) {
                            a = a + 48 | 0;
                            break a;
                        }
                        break;
                    default:
                }
                if (!(c[a + 68 >> 2] | 0)) {
                    a = (b | 1) == 5 ? 948 : d;
                    break;
                } else {
                    a = a + 64 | 0;
                    break;
                }
            } else a = a + (b << 3) | 0;
            while (0);
            return a | 0;
        }
        function Ub(b) {
            b = b | 0;
            var d = 0;
            d = oB(1e3) | 0;
            Vb(b, (d | 0) != 0, 2456);
            c[2276] = (c[2276] | 0) + 1;
            BC(d | 0, 8104, 1e3);
            if (a[b + 2 >> 0] | 0) {
                c[d + 4 >> 2] = 2;
                c[d + 12 >> 2] = 4;
            }
            c[d + 976 >> 2] = b;
            return d | 0;
        }
        function Vb(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0;
            f = l;
            l = l + 16 | 0;
            e = f;
            if (!b) {
                c[e >> 2] = d;
                fe(a, 5, 3197, e);
            }
            l = f;
            return;
        }
        function Wb() {
            return Ub(956) | 0;
        }
        function Xb(a) {
            a = a | 0;
            var b = 0;
            b = qC(1e3) | 0;
            Yb(b, a);
            Vb(c[a + 976 >> 2] | 0, 1, 2456);
            c[2276] = (c[2276] | 0) + 1;
            c[b + 944 >> 2] = 0;
            return b | 0;
        }
        function Yb(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            BC(a | 0, b | 0, 948);
            ie(a + 948 | 0, b + 948 | 0);
            d = a + 960 | 0;
            a = b + 960 | 0;
            b = d + 40 | 0;
            do {
                c[d >> 2] = c[a >> 2];
                d = d + 4 | 0;
                a = a + 4 | 0;
            }while ((d | 0) < (b | 0));
            return;
        }
        function Zb(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0;
            b = a + 944 | 0;
            d = c[b >> 2] | 0;
            if (d | 0) {
                _b(d + 948 | 0, a);
                c[b >> 2] = 0;
            }
            d = $b(a) | 0;
            if (d | 0) {
                b = 0;
                do {
                    c[(ac(a, b) | 0) + 944 >> 2] = 0;
                    b = b + 1 | 0;
                }while ((b | 0) != (d | 0));
            }
            d = a + 948 | 0;
            e = c[d >> 2] | 0;
            f = a + 952 | 0;
            b = c[f >> 2] | 0;
            if ((b | 0) != (e | 0)) c[f >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);
            bc(d);
            pB(a);
            c[2276] = (c[2276] | 0) + -1;
            return;
        }
        function _b(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            e = c[a >> 2] | 0;
            i = a + 4 | 0;
            d = c[i >> 2] | 0;
            g = d;
            a: do if ((e | 0) == (d | 0)) {
                f = e;
                h = 4;
            } else {
                a = e;
                while(true){
                    if ((c[a >> 2] | 0) == (b | 0)) {
                        f = a;
                        h = 4;
                        break a;
                    }
                    a = a + 4 | 0;
                    if ((a | 0) == (d | 0)) {
                        a = 0;
                        break;
                    }
                }
            }
            while (0);
            if ((h | 0) == 4) {
                if ((f | 0) != (d | 0)) {
                    e = f + 4 | 0;
                    a = g - e | 0;
                    b = a >> 2;
                    if (b) {
                        GC(f | 0, e | 0, a | 0);
                        d = c[i >> 2] | 0;
                    }
                    a = f + (b << 2) | 0;
                    if ((d | 0) == (a | 0)) a = 1;
                    else {
                        c[i >> 2] = d + (~((d + -4 - a | 0) >>> 2) << 2);
                        a = 1;
                    }
                } else a = 0;
            }
            return a | 0;
        }
        function $b(a) {
            a = a | 0;
            return (c[a + 952 >> 2] | 0) - (c[a + 948 >> 2] | 0) >> 2 | 0;
        }
        function ac(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[a + 948 >> 2] | 0;
            if ((c[a + 952 >> 2] | 0) - d >> 2 >>> 0 > b >>> 0) a = c[d + (b << 2) >> 2] | 0;
            else a = 0;
            return a | 0;
        }
        function bc(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0;
            e = l;
            l = l + 32 | 0;
            b = e;
            f = c[a >> 2] | 0;
            d = (c[a + 4 >> 2] | 0) - f | 0;
            if (((c[a + 8 >> 2] | 0) - f | 0) >>> 0 > d >>> 0) {
                f = d >> 2;
                bf(b, f, f, a + 8 | 0);
                cf(a, b);
                df(b);
            }
            l = e;
            return;
        }
        function cc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            k = $b(a) | 0;
            do if (k | 0) {
                if ((c[(ac(a, 0) | 0) + 944 >> 2] | 0) == (a | 0)) {
                    if (!(_b(a + 948 | 0, b) | 0)) break;
                    BC(b + 400 | 0, 8504, 540);
                    c[b + 944 >> 2] = 0;
                    nc(a);
                    break;
                }
                h = c[(c[a + 976 >> 2] | 0) + 12 >> 2] | 0;
                i = a + 948 | 0;
                j = (h | 0) == 0;
                d = 0;
                g = 0;
                do {
                    e = c[(c[i >> 2] | 0) + (g << 2) >> 2] | 0;
                    if ((e | 0) == (b | 0)) nc(a);
                    else {
                        f = Xb(e) | 0;
                        c[(c[i >> 2] | 0) + (d << 2) >> 2] = f;
                        c[f + 944 >> 2] = a;
                        if (!j) Ib[h & 15](e, f, a, d);
                        d = d + 1 | 0;
                    }
                    g = g + 1 | 0;
                }while ((g | 0) != (k | 0));
                if (d >>> 0 < k >>> 0) {
                    j = a + 948 | 0;
                    i = a + 952 | 0;
                    h = d;
                    d = c[i >> 2] | 0;
                    do {
                        g = (c[j >> 2] | 0) + (h << 2) | 0;
                        e = g + 4 | 0;
                        f = d - e | 0;
                        b = f >> 2;
                        if (!b) f = d;
                        else {
                            GC(g | 0, e | 0, f | 0);
                            d = c[i >> 2] | 0;
                            f = d;
                        }
                        e = g + (b << 2) | 0;
                        if ((f | 0) != (e | 0)) {
                            d = f + (~((f + -4 - e | 0) >>> 2) << 2) | 0;
                            c[i >> 2] = d;
                        }
                        h = h + 1 | 0;
                    }while ((h | 0) != (k | 0));
                }
            }
            while (0);
            return;
        }
        function dc(b) {
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            ec(b, ($b(b) | 0) == 0, 2491);
            ec(b, (c[b + 944 >> 2] | 0) == 0, 2545);
            d = b + 948 | 0;
            e = c[d >> 2] | 0;
            f = b + 952 | 0;
            g = c[f >> 2] | 0;
            if ((g | 0) != (e | 0)) c[f >> 2] = g + (~((g + -4 - e | 0) >>> 2) << 2);
            bc(d);
            d = b + 976 | 0;
            e = c[d >> 2] | 0;
            BC(b | 0, 8104, 1e3);
            if (a[e + 2 >> 0] | 0) {
                c[b + 4 >> 2] = 2;
                c[b + 12 >> 2] = 4;
            }
            c[d >> 2] = e;
            return;
        }
        function ec(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0;
            f = l;
            l = l + 16 | 0;
            e = f;
            if (!b) {
                c[e >> 2] = d;
                Vd(a, 5, 3197, e);
            }
            l = f;
            return;
        }
        function fc() {
            return c[2276] | 0;
        }
        function gc() {
            var a = 0;
            a = oB(20) | 0;
            hc((a | 0) != 0, 2592);
            c[2277] = (c[2277] | 0) + 1;
            c[a >> 2] = c[239];
            c[a + 4 >> 2] = c[240];
            c[a + 8 >> 2] = c[241];
            c[a + 12 >> 2] = c[242];
            c[a + 16 >> 2] = c[243];
            return a | 0;
        }
        function hc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = l;
            l = l + 16 | 0;
            d = e;
            if (!a) {
                c[d >> 2] = b;
                Vd(0, 5, 3197, d);
            }
            l = e;
            return;
        }
        function ic(a) {
            a = a | 0;
            pB(a);
            c[2277] = (c[2277] | 0) + -1;
            return;
        }
        function jc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if (!b) {
                d = 0;
                b = 0;
            } else {
                ec(a, ($b(a) | 0) == 0, 2629);
                d = 1;
            }
            c[a + 964 >> 2] = b;
            c[a + 988 >> 2] = d;
            return;
        }
        function kc(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            g = e + 8 | 0;
            f = e + 4 | 0;
            h = e;
            c[f >> 2] = b;
            ec(a, (c[b + 944 >> 2] | 0) == 0, 2709);
            ec(a, (c[a + 964 >> 2] | 0) == 0, 2763);
            lc(a);
            b = a + 948 | 0;
            c[h >> 2] = (c[b >> 2] | 0) + (d << 2);
            c[g >> 2] = c[h >> 2];
            mc(b, g, f);
            c[(c[f >> 2] | 0) + 944 >> 2] = a;
            nc(a);
            l = e;
            return;
        }
        function lc(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            d = $b(a) | 0;
            if (d | 0 ? (c[(ac(a, 0) | 0) + 944 >> 2] | 0) != (a | 0) : 0) {
                e = c[(c[a + 976 >> 2] | 0) + 12 >> 2] | 0;
                f = a + 948 | 0;
                g = (e | 0) == 0;
                b = 0;
                do {
                    h = c[(c[f >> 2] | 0) + (b << 2) >> 2] | 0;
                    i = Xb(h) | 0;
                    c[(c[f >> 2] | 0) + (b << 2) >> 2] = i;
                    c[i + 944 >> 2] = a;
                    if (!g) Ib[e & 15](h, i, a, b);
                    b = b + 1 | 0;
                }while ((b | 0) != (d | 0));
            }
            return;
        }
        function mc(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
            s = l;
            l = l + 64 | 0;
            n = s + 52 | 0;
            i = s + 48 | 0;
            o = s + 28 | 0;
            p = s + 24 | 0;
            q = s + 20 | 0;
            r = s;
            e = c[a >> 2] | 0;
            g = e;
            b = e + ((c[b >> 2] | 0) - g >> 2 << 2) | 0;
            e = a + 4 | 0;
            f = c[e >> 2] | 0;
            h = a + 8 | 0;
            do if (f >>> 0 < (c[h >> 2] | 0) >>> 0) {
                if ((b | 0) == (f | 0)) {
                    c[b >> 2] = c[d >> 2];
                    c[e >> 2] = (c[e >> 2] | 0) + 4;
                    break;
                }
                ef(a, b, f, b + 4 | 0);
                if (b >>> 0 <= d >>> 0) d = (c[e >> 2] | 0) >>> 0 > d >>> 0 ? d + 4 | 0 : d;
                c[b >> 2] = c[d >> 2];
            } else {
                e = (f - g >> 2) + 1 | 0;
                f = le(a) | 0;
                if (f >>> 0 < e >>> 0) jC(a);
                m = c[a >> 2] | 0;
                k = (c[h >> 2] | 0) - m | 0;
                g = k >> 1;
                bf(r, k >> 2 >>> 0 < f >>> 1 >>> 0 ? g >>> 0 < e >>> 0 ? e : g : f, b - m >> 2, a + 8 | 0);
                m = r + 8 | 0;
                e = c[m >> 2] | 0;
                g = r + 12 | 0;
                k = c[g >> 2] | 0;
                h = k;
                j = e;
                do if ((e | 0) == (k | 0)) {
                    k = r + 4 | 0;
                    e = c[k >> 2] | 0;
                    t = c[r >> 2] | 0;
                    f = t;
                    if (e >>> 0 <= t >>> 0) {
                        e = h - f >> 1;
                        e = (e | 0) == 0 ? 1 : e;
                        bf(o, e, e >>> 2, c[r + 16 >> 2] | 0);
                        c[p >> 2] = c[k >> 2];
                        c[q >> 2] = c[m >> 2];
                        c[i >> 2] = c[p >> 2];
                        c[n >> 2] = c[q >> 2];
                        gf(o, i, n);
                        e = c[r >> 2] | 0;
                        c[r >> 2] = c[o >> 2];
                        c[o >> 2] = e;
                        e = o + 4 | 0;
                        t = c[k >> 2] | 0;
                        c[k >> 2] = c[e >> 2];
                        c[e >> 2] = t;
                        e = o + 8 | 0;
                        t = c[m >> 2] | 0;
                        c[m >> 2] = c[e >> 2];
                        c[e >> 2] = t;
                        e = o + 12 | 0;
                        t = c[g >> 2] | 0;
                        c[g >> 2] = c[e >> 2];
                        c[e >> 2] = t;
                        df(o);
                        e = c[m >> 2] | 0;
                        break;
                    }
                    g = e;
                    h = ((g - f >> 2) + 1 | 0) / -2 | 0;
                    i = e + (h << 2) | 0;
                    f = j - g | 0;
                    g = f >> 2;
                    if (g) {
                        GC(i | 0, e | 0, f | 0);
                        e = c[k >> 2] | 0;
                    }
                    t = i + (g << 2) | 0;
                    c[m >> 2] = t;
                    c[k >> 2] = e + (h << 2);
                    e = t;
                }
                while (0);
                c[e >> 2] = c[d >> 2];
                c[m >> 2] = (c[m >> 2] | 0) + 4;
                b = ff(a, r, b) | 0;
                df(r);
            }
            while (0);
            l = s;
            return b | 0;
        }
        function nc(b) {
            b = b | 0;
            var d = 0;
            do {
                d = b + 984 | 0;
                if (a[d >> 0] | 0) break;
                a[d >> 0] = 1;
                g[b + 504 >> 2] = T(t);
                b = c[b + 944 >> 2] | 0;
            }while ((b | 0) != 0);
            return;
        }
        function oc(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);
                sC(d);
            }
            return;
        }
        function pc(a) {
            a = a | 0;
            return c[a + 944 >> 2] | 0;
        }
        function qc(a) {
            a = a | 0;
            ec(a, (c[a + 964 >> 2] | 0) != 0, 2832);
            nc(a);
            return;
        }
        function rc(b) {
            b = b | 0;
            return (a[b + 984 >> 0] | 0) != 0 | 0;
        }
        function sc(a, b) {
            a = a | 0;
            b = b | 0;
            if (BB(a, b, 400) | 0) {
                BC(a | 0, b | 0, 400);
                nc(a);
            }
            return;
        }
        function tc(a) {
            a = a | 0;
            var b = ib;
            b = T(g[a + 44 >> 2]);
            a = Sb(b) | 0;
            return T(a ? T(0.0) : b);
        }
        function uc(b) {
            b = b | 0;
            var d = ib;
            d = T(g[b + 48 >> 2]);
            if (Sb(d) | 0) d = a[(c[b + 976 >> 2] | 0) + 2 >> 0] | 0 ? T(1.0) : T(0.0);
            return T(d);
        }
        function vc(a, b) {
            a = a | 0;
            b = b | 0;
            c[a + 980 >> 2] = b;
            return;
        }
        function wc(a) {
            a = a | 0;
            return c[a + 980 >> 2] | 0;
        }
        function xc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 4 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function yc(a) {
            a = a | 0;
            return c[a + 4 >> 2] | 0;
        }
        function zc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 8 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Ac(a) {
            a = a | 0;
            return c[a + 8 >> 2] | 0;
        }
        function Bc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 12 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Cc(a) {
            a = a | 0;
            return c[a + 12 >> 2] | 0;
        }
        function Dc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 16 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Ec(a) {
            a = a | 0;
            return c[a + 16 >> 2] | 0;
        }
        function Fc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 20 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Gc(a) {
            a = a | 0;
            return c[a + 20 >> 2] | 0;
        }
        function Hc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 24 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Ic(a) {
            a = a | 0;
            return c[a + 24 >> 2] | 0;
        }
        function Jc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 28 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Kc(a) {
            a = a | 0;
            return c[a + 28 >> 2] | 0;
        }
        function Lc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 32 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Mc(a) {
            a = a | 0;
            return c[a + 32 >> 2] | 0;
        }
        function Nc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 36 | 0;
            if ((c[d >> 2] | 0) != (b | 0)) {
                c[d >> 2] = b;
                nc(a);
            }
            return;
        }
        function Oc(a) {
            a = a | 0;
            return c[a + 36 >> 2] | 0;
        }
        function Pc(a, b) {
            a = a | 0;
            b = T(b);
            var c = 0;
            c = a + 40 | 0;
            if (T(g[c >> 2]) != b) {
                g[c >> 2] = b;
                nc(a);
            }
            return;
        }
        function Qc(a, b) {
            a = a | 0;
            b = T(b);
            var c = 0;
            c = a + 44 | 0;
            if (T(g[c >> 2]) != b) {
                g[c >> 2] = b;
                nc(a);
            }
            return;
        }
        function Rc(a, b) {
            a = a | 0;
            b = T(b);
            var c = 0;
            c = a + 48 | 0;
            if (T(g[c >> 2]) != b) {
                g[c >> 2] = b;
                nc(a);
            }
            return;
        }
        function Sc(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = (h ^ 1) & 1;
            e = a + 52 | 0;
            f = a + 56 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function Tc(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0;
            e = a + 52 | 0;
            d = a + 56 | 0;
            if (!(!(T(g[e >> 2]) != b) ? (c[d >> 2] | 0) == 2 : 0)) {
                g[e >> 2] = b;
                e = Sb(b) | 0;
                c[d >> 2] = e ? 3 : 2;
                nc(a);
            }
            return;
        }
        function Uc(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = b + 52 | 0;
            d = c[e + 4 >> 2] | 0;
            b = a;
            c[b >> 2] = c[e >> 2];
            c[b + 4 >> 2] = d;
            return;
        }
        function Vc(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0, h = 0;
            h = Sb(d) | 0;
            e = (h ^ 1) & 1;
            f = a + 132 + (b << 3) | 0;
            b = a + 132 + (b << 3) + 4 | 0;
            if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
                g[f >> 2] = d;
                c[b >> 2] = e;
                nc(a);
            }
            return;
        }
        function Wc(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0, h = 0;
            h = Sb(d) | 0;
            e = h ? 0 : 2;
            f = a + 132 + (b << 3) | 0;
            b = a + 132 + (b << 3) + 4 | 0;
            if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
                g[f >> 2] = d;
                c[b >> 2] = e;
                nc(a);
            }
            return;
        }
        function Xc(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = b + 132 + (d << 3) | 0;
            b = c[e + 4 >> 2] | 0;
            d = a;
            c[d >> 2] = c[e >> 2];
            c[d + 4 >> 2] = b;
            return;
        }
        function Yc(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0, h = 0;
            h = Sb(d) | 0;
            e = (h ^ 1) & 1;
            f = a + 60 + (b << 3) | 0;
            b = a + 60 + (b << 3) + 4 | 0;
            if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
                g[f >> 2] = d;
                c[b >> 2] = e;
                nc(a);
            }
            return;
        }
        function Zc(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0, h = 0;
            h = Sb(d) | 0;
            e = h ? 0 : 2;
            f = a + 60 + (b << 3) | 0;
            b = a + 60 + (b << 3) + 4 | 0;
            if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
                g[f >> 2] = d;
                c[b >> 2] = e;
                nc(a);
            }
            return;
        }
        function _c(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = b + 60 + (d << 3) | 0;
            b = c[e + 4 >> 2] | 0;
            d = a;
            c[d >> 2] = c[e >> 2];
            c[d + 4 >> 2] = b;
            return;
        }
        function $c(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = a + 60 + (b << 3) + 4 | 0;
            if ((c[d >> 2] | 0) != 3) {
                g[a + 60 + (b << 3) >> 2] = T(t);
                c[d >> 2] = 3;
                nc(a);
            }
            return;
        }
        function ad(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0, h = 0;
            h = Sb(d) | 0;
            e = (h ^ 1) & 1;
            f = a + 204 + (b << 3) | 0;
            b = a + 204 + (b << 3) + 4 | 0;
            if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
                g[f >> 2] = d;
                c[b >> 2] = e;
                nc(a);
            }
            return;
        }
        function bd(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0, h = 0;
            h = Sb(d) | 0;
            e = h ? 0 : 2;
            f = a + 204 + (b << 3) | 0;
            b = a + 204 + (b << 3) + 4 | 0;
            if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
                g[f >> 2] = d;
                c[b >> 2] = e;
                nc(a);
            }
            return;
        }
        function cd(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = b + 204 + (d << 3) | 0;
            b = c[e + 4 >> 2] | 0;
            d = a;
            c[d >> 2] = c[e >> 2];
            c[d + 4 >> 2] = b;
            return;
        }
        function dd(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0, h = 0;
            h = Sb(d) | 0;
            e = (h ^ 1) & 1;
            f = a + 276 + (b << 3) | 0;
            b = a + 276 + (b << 3) + 4 | 0;
            if (!(h | T(g[f >> 2]) == d ? (c[b >> 2] | 0) == (e | 0) : 0)) {
                g[f >> 2] = d;
                c[b >> 2] = e;
                nc(a);
            }
            return;
        }
        function ed(a, b) {
            a = a | 0;
            b = b | 0;
            return T(g[a + 276 + (b << 3) >> 2]);
        }
        function fd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = (h ^ 1) & 1;
            e = a + 348 | 0;
            f = a + 352 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function gd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0;
            e = a + 348 | 0;
            d = a + 352 | 0;
            if (!(!(T(g[e >> 2]) != b) ? (c[d >> 2] | 0) == 2 : 0)) {
                g[e >> 2] = b;
                e = Sb(b) | 0;
                c[d >> 2] = e ? 3 : 2;
                nc(a);
            }
            return;
        }
        function hd(a) {
            a = a | 0;
            var b = 0;
            b = a + 352 | 0;
            if ((c[b >> 2] | 0) != 3) {
                g[a + 348 >> 2] = T(t);
                c[b >> 2] = 3;
                nc(a);
            }
            return;
        }
        function id(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = b + 348 | 0;
            d = c[e + 4 >> 2] | 0;
            b = a;
            c[b >> 2] = c[e >> 2];
            c[b + 4 >> 2] = d;
            return;
        }
        function jd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = (h ^ 1) & 1;
            e = a + 356 | 0;
            f = a + 360 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function kd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0;
            e = a + 356 | 0;
            d = a + 360 | 0;
            if (!(!(T(g[e >> 2]) != b) ? (c[d >> 2] | 0) == 2 : 0)) {
                g[e >> 2] = b;
                e = Sb(b) | 0;
                c[d >> 2] = e ? 3 : 2;
                nc(a);
            }
            return;
        }
        function ld(a) {
            a = a | 0;
            var b = 0;
            b = a + 360 | 0;
            if ((c[b >> 2] | 0) != 3) {
                g[a + 356 >> 2] = T(t);
                c[b >> 2] = 3;
                nc(a);
            }
            return;
        }
        function md(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = b + 356 | 0;
            d = c[e + 4 >> 2] | 0;
            b = a;
            c[b >> 2] = c[e >> 2];
            c[b + 4 >> 2] = d;
            return;
        }
        function nd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = (h ^ 1) & 1;
            e = a + 364 | 0;
            f = a + 368 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function od(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = h ? 0 : 2;
            e = a + 364 | 0;
            f = a + 368 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function pd(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = b + 364 | 0;
            d = c[e + 4 >> 2] | 0;
            b = a;
            c[b >> 2] = c[e >> 2];
            c[b + 4 >> 2] = d;
            return;
        }
        function qd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = (h ^ 1) & 1;
            e = a + 372 | 0;
            f = a + 376 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function rd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = h ? 0 : 2;
            e = a + 372 | 0;
            f = a + 376 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function sd(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = b + 372 | 0;
            d = c[e + 4 >> 2] | 0;
            b = a;
            c[b >> 2] = c[e >> 2];
            c[b + 4 >> 2] = d;
            return;
        }
        function td(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = (h ^ 1) & 1;
            e = a + 380 | 0;
            f = a + 384 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function ud(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = h ? 0 : 2;
            e = a + 380 | 0;
            f = a + 384 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function vd(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = b + 380 | 0;
            d = c[e + 4 >> 2] | 0;
            b = a;
            c[b >> 2] = c[e >> 2];
            c[b + 4 >> 2] = d;
            return;
        }
        function wd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = (h ^ 1) & 1;
            e = a + 388 | 0;
            f = a + 392 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function xd(a, b) {
            a = a | 0;
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0;
            h = Sb(b) | 0;
            d = h ? 0 : 2;
            e = a + 388 | 0;
            f = a + 392 | 0;
            if (!(h | T(g[e >> 2]) == b ? (c[f >> 2] | 0) == (d | 0) : 0)) {
                g[e >> 2] = b;
                c[f >> 2] = d;
                nc(a);
            }
            return;
        }
        function yd(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = b + 388 | 0;
            d = c[e + 4 >> 2] | 0;
            b = a;
            c[b >> 2] = c[e >> 2];
            c[b + 4 >> 2] = d;
            return;
        }
        function zd(a, b) {
            a = a | 0;
            b = T(b);
            var c = 0;
            c = a + 396 | 0;
            if (T(g[c >> 2]) != b) {
                g[c >> 2] = b;
                nc(a);
            }
            return;
        }
        function Ad(a) {
            a = a | 0;
            return T(g[a + 396 >> 2]);
        }
        function Bd(a) {
            a = a | 0;
            return T(g[a + 400 >> 2]);
        }
        function Cd(a) {
            a = a | 0;
            return T(g[a + 404 >> 2]);
        }
        function Dd(a) {
            a = a | 0;
            return T(g[a + 408 >> 2]);
        }
        function Ed(a) {
            a = a | 0;
            return T(g[a + 412 >> 2]);
        }
        function Fd(a) {
            a = a | 0;
            return T(g[a + 416 >> 2]);
        }
        function Gd(a) {
            a = a | 0;
            return T(g[a + 420 >> 2]);
        }
        function Hd(a, b) {
            a = a | 0;
            b = b | 0;
            ec(a, (b | 0) < 6, 2918);
            switch(b | 0){
                case 0:
                    b = (c[a + 496 >> 2] | 0) == 2 ? 5 : 4;
                    break;
                case 2:
                    b = (c[a + 496 >> 2] | 0) == 2 ? 4 : 5;
                    break;
                default:
            }
            return T(g[a + 424 + (b << 2) >> 2]);
        }
        function Id(a, b) {
            a = a | 0;
            b = b | 0;
            ec(a, (b | 0) < 6, 2918);
            switch(b | 0){
                case 0:
                    b = (c[a + 496 >> 2] | 0) == 2 ? 5 : 4;
                    break;
                case 2:
                    b = (c[a + 496 >> 2] | 0) == 2 ? 4 : 5;
                    break;
                default:
            }
            return T(g[a + 448 + (b << 2) >> 2]);
        }
        function Jd(a, b) {
            a = a | 0;
            b = b | 0;
            ec(a, (b | 0) < 6, 2918);
            switch(b | 0){
                case 0:
                    b = (c[a + 496 >> 2] | 0) == 2 ? 5 : 4;
                    break;
                case 2:
                    b = (c[a + 496 >> 2] | 0) == 2 ? 4 : 5;
                    break;
                default:
            }
            return T(g[a + 472 + (b << 2) >> 2]);
        }
        function Kd(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = ib;
            d = c[a + 4 >> 2] | 0;
            if ((d | 0) == (c[b + 4 >> 2] | 0)) {
                if (!d) a = 1;
                else {
                    e = T(g[a >> 2]);
                    a = T(C(T(e - T(g[b >> 2])))) < T(.0000999999974);
                }
            } else a = 0;
            return a | 0;
        }
        function Ld(a, b) {
            a = T(a);
            b = T(b);
            var c = 0;
            if (Sb(a) | 0) c = Sb(b) | 0;
            else c = T(C(T(a - b))) < T(.0000999999974);
            return c | 0;
        }
        function Md(a, b) {
            a = a | 0;
            b = b | 0;
            Nd(a, b);
            return;
        }
        function Nd(b, d) {
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 4 | 0;
            c[f >> 2] = 0;
            c[f + 4 >> 2] = 0;
            c[f + 8 >> 2] = 0;
            Ka(f | 0, b | 0, d | 0, 0);
            Vd(b, 3, (a[f + 11 >> 0] | 0) < 0 ? c[f >> 2] | 0 : f, e);
            tC(f);
            l = e;
            return;
        }
        function Od(a, b, c, d) {
            a = T(a);
            b = T(b);
            c = c | 0;
            d = d | 0;
            var e = ib;
            a = T(a * b);
            e = T(gC(a, T(1.0)));
            do if (!(Ld(e, T(0.0)) | 0)) {
                a = T(a - e);
                if (Ld(e, T(1.0)) | 0) {
                    a = T(a + T(1.0));
                    break;
                }
                if (c) {
                    a = T(a + T(1.0));
                    break;
                }
                if (!d) {
                    if (e > T(.5)) e = T(1.0);
                    else {
                        d = Ld(e, T(.5)) | 0;
                        e = d ? T(1.0) : T(0.0);
                    }
                    a = T(a + e);
                }
            } else a = T(a - e);
            while (0);
            return T(a / b);
        }
        function Pd(a, b, c, d, e, f, h, i, j, k, l, m, n) {
            a = a | 0;
            b = T(b);
            c = c | 0;
            d = T(d);
            e = e | 0;
            f = T(f);
            h = h | 0;
            i = T(i);
            j = T(j);
            k = T(k);
            l = T(l);
            m = T(m);
            n = n | 0;
            var o = 0, p = ib, q = ib, r = ib, s = ib, t = ib, u = ib;
            if (j < T(0.0) | k < T(0.0)) n = 0;
            else {
                if ((n | 0) != 0 ? (p = T(g[n + 4 >> 2]), p != T(0.0)) : 0) {
                    r = T(Od(b, p, 0, 0));
                    s = T(Od(d, p, 0, 0));
                    q = T(Od(f, p, 0, 0));
                    p = T(Od(i, p, 0, 0));
                } else {
                    q = f;
                    r = b;
                    p = i;
                    s = d;
                }
                if ((e | 0) == (a | 0)) o = Ld(q, r) | 0;
                else o = 0;
                if ((h | 0) == (c | 0)) n = Ld(p, s) | 0;
                else n = 0;
                if ((!o ? (t = T(b - l), !(Qd(a, t, j) | 0)) : 0) ? !(Rd(a, t, e, j) | 0) : 0) o = Sd(a, t, e, f, j) | 0;
                else o = 1;
                if ((!n ? (u = T(d - m), !(Qd(c, u, k) | 0)) : 0) ? !(Rd(c, u, h, k) | 0) : 0) n = Sd(c, u, h, i, k) | 0;
                else n = 1;
                n = o & n;
            }
            return n | 0;
        }
        function Qd(a, b, c) {
            a = a | 0;
            b = T(b);
            c = T(c);
            if ((a | 0) == 1) a = Ld(b, c) | 0;
            else a = 0;
            return a | 0;
        }
        function Rd(a, b, c, d) {
            a = a | 0;
            b = T(b);
            c = c | 0;
            d = T(d);
            if ((a | 0) == 2 & (c | 0) == 0) {
                if (!(b >= d)) a = Ld(b, d) | 0;
                else a = 1;
            } else a = 0;
            return a | 0;
        }
        function Sd(a, b, c, d, e) {
            a = a | 0;
            b = T(b);
            c = c | 0;
            d = T(d);
            e = T(e);
            if ((a | 0) == 2 & (c | 0) == 2 & d > b) {
                if (!(e <= b)) a = Ld(b, e) | 0;
                else a = 1;
            } else a = 0;
            return a | 0;
        }
        function Td(b, d, e, f, i, j, k, m, n, o, p) {
            b = b | 0;
            d = T(d);
            e = T(e);
            f = f | 0;
            i = i | 0;
            j = j | 0;
            k = T(k);
            m = T(m);
            n = n | 0;
            o = o | 0;
            p = p | 0;
            var q = 0, r = 0, s = 0, t = 0, u = ib, v = ib, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = ib, I = ib, J = ib, K = 0.0, L = 0.0;
            G = l;
            l = l + 160 | 0;
            D = G + 152 | 0;
            C = G + 120 | 0;
            B = G + 104 | 0;
            y = G + 72 | 0;
            t = G + 56 | 0;
            A = G + 8 | 0;
            x = G;
            z = (c[2279] | 0) + 1 | 0;
            c[2279] = z;
            E = b + 984 | 0;
            if ((a[E >> 0] | 0) != 0 ? (c[b + 512 >> 2] | 0) != (c[2278] | 0) : 0) w = 4;
            else if ((c[b + 516 >> 2] | 0) == (f | 0)) F = 0;
            else w = 4;
            if ((w | 0) == 4) {
                c[b + 520 >> 2] = 0;
                c[b + 924 >> 2] = -1;
                c[b + 928 >> 2] = -1;
                g[b + 932 >> 2] = T(-1);
                g[b + 936 >> 2] = T(-1);
                F = 1;
            }
            a: do if (!(c[b + 964 >> 2] | 0)) {
                if (n) {
                    q = b + 916 | 0;
                    if (!(Ld(T(g[q >> 2]), d) | 0)) {
                        w = 21;
                        break;
                    }
                    if (!(Ld(T(g[b + 920 >> 2]), e) | 0)) {
                        w = 21;
                        break;
                    }
                    if ((c[b + 924 >> 2] | 0) != (i | 0)) {
                        w = 21;
                        break;
                    }
                    q = (c[b + 928 >> 2] | 0) == (j | 0) ? q : 0;
                    w = 22;
                    break;
                }
                s = c[b + 520 >> 2] | 0;
                if (!s) w = 21;
                else {
                    r = 0;
                    while(true){
                        q = b + 524 + (r * 24 | 0) | 0;
                        if (((Ld(T(g[q >> 2]), d) | 0 ? Ld(T(g[b + 524 + (r * 24 | 0) + 4 >> 2]), e) | 0 : 0) ? (c[b + 524 + (r * 24 | 0) + 8 >> 2] | 0) == (i | 0) : 0) ? (c[b + 524 + (r * 24 | 0) + 12 >> 2] | 0) == (j | 0) : 0) {
                            w = 22;
                            break a;
                        }
                        r = r + 1 | 0;
                        if (r >>> 0 >= s >>> 0) {
                            w = 21;
                            break;
                        }
                    }
                }
            } else {
                u = T(Ud(b, 2, k));
                v = T(Ud(b, 0, k));
                q = b + 916 | 0;
                J = T(g[q >> 2]);
                I = T(g[b + 920 >> 2]);
                H = T(g[b + 932 >> 2]);
                if (!(Pd(i, d, j, e, c[b + 924 >> 2] | 0, J, c[b + 928 >> 2] | 0, I, H, T(g[b + 936 >> 2]), u, v, p) | 0)) {
                    s = c[b + 520 >> 2] | 0;
                    if (!s) w = 21;
                    else {
                        r = 0;
                        while(true){
                            q = b + 524 + (r * 24 | 0) | 0;
                            H = T(g[q >> 2]);
                            I = T(g[b + 524 + (r * 24 | 0) + 4 >> 2]);
                            J = T(g[b + 524 + (r * 24 | 0) + 16 >> 2]);
                            if (Pd(i, d, j, e, c[b + 524 + (r * 24 | 0) + 8 >> 2] | 0, H, c[b + 524 + (r * 24 | 0) + 12 >> 2] | 0, I, J, T(g[b + 524 + (r * 24 | 0) + 20 >> 2]), u, v, p) | 0) {
                                w = 22;
                                break a;
                            }
                            r = r + 1 | 0;
                            if (r >>> 0 >= s >>> 0) {
                                w = 21;
                                break;
                            }
                        }
                    }
                } else w = 22;
            }
            while (0);
            do if ((w | 0) == 21) {
                if (!(a[11697] | 0)) {
                    q = 0;
                    w = 31;
                } else {
                    q = 0;
                    w = 28;
                }
            } else if ((w | 0) == 22) {
                r = (a[11697] | 0) != 0;
                if (!((q | 0) != 0 & (F ^ 1))) {
                    if (r) {
                        w = 28;
                        break;
                    } else {
                        w = 31;
                        break;
                    }
                }
                t = q + 16 | 0;
                c[b + 908 >> 2] = c[t >> 2];
                s = q + 20 | 0;
                c[b + 912 >> 2] = c[s >> 2];
                if (!((a[11698] | 0) == 0 | r ^ 1)) {
                    c[x >> 2] = Wd(z) | 0;
                    c[x + 4 >> 2] = z;
                    Vd(b, 4, 2972, x);
                    r = c[b + 972 >> 2] | 0;
                    if (r | 0) nb[r & 127](b);
                    i = Xd(i, n) | 0;
                    j = Xd(j, n) | 0;
                    L = +T(g[t >> 2]);
                    K = +T(g[s >> 2]);
                    c[A >> 2] = i;
                    c[A + 4 >> 2] = j;
                    h[A + 8 >> 3] = +d;
                    h[A + 16 >> 3] = +e;
                    h[A + 24 >> 3] = L;
                    h[A + 32 >> 3] = K;
                    c[A + 40 >> 2] = o;
                    Vd(b, 4, 2989, A);
                }
            }
            while (0);
            if ((w | 0) == 28) {
                r = Wd(z) | 0;
                c[t >> 2] = r;
                c[t + 4 >> 2] = z;
                c[t + 8 >> 2] = F ? 3047 : 11699;
                Vd(b, 4, 3038, t);
                r = c[b + 972 >> 2] | 0;
                if (r | 0) nb[r & 127](b);
                A = Xd(i, n) | 0;
                w = Xd(j, n) | 0;
                c[y >> 2] = A;
                c[y + 4 >> 2] = w;
                h[y + 8 >> 3] = +d;
                h[y + 16 >> 3] = +e;
                c[y + 24 >> 2] = o;
                Vd(b, 4, 3049, y);
                w = 31;
            }
            if ((w | 0) == 31) {
                Yd(b, d, e, f, i, j, k, m, n, p);
                if (a[11697] | 0) {
                    r = c[2279] | 0;
                    A = Wd(r) | 0;
                    c[B >> 2] = A;
                    c[B + 4 >> 2] = r;
                    c[B + 8 >> 2] = F ? 3047 : 11699;
                    Vd(b, 4, 3083, B);
                    r = c[b + 972 >> 2] | 0;
                    if (r | 0) nb[r & 127](b);
                    A = Xd(i, n) | 0;
                    B = Xd(j, n) | 0;
                    K = +T(g[b + 908 >> 2]);
                    L = +T(g[b + 912 >> 2]);
                    c[C >> 2] = A;
                    c[C + 4 >> 2] = B;
                    h[C + 8 >> 3] = K;
                    h[C + 16 >> 3] = L;
                    c[C + 24 >> 2] = o;
                    Vd(b, 4, 3092, C);
                }
                c[b + 516 >> 2] = f;
                if (!q) {
                    r = b + 520 | 0;
                    q = c[r >> 2] | 0;
                    if ((q | 0) == 16) {
                        if (a[11697] | 0) Vd(b, 4, 3124, D);
                        c[r >> 2] = 0;
                        q = 0;
                    }
                    if (n) q = b + 916 | 0;
                    else {
                        c[r >> 2] = q + 1;
                        q = b + 524 + (q * 24 | 0) | 0;
                    }
                    g[q >> 2] = d;
                    g[q + 4 >> 2] = e;
                    c[q + 8 >> 2] = i;
                    c[q + 12 >> 2] = j;
                    c[q + 16 >> 2] = c[b + 908 >> 2];
                    c[q + 20 >> 2] = c[b + 912 >> 2];
                    q = 0;
                }
            }
            if (n) {
                c[b + 416 >> 2] = c[b + 908 >> 2];
                c[b + 420 >> 2] = c[b + 912 >> 2];
                a[b + 985 >> 0] = 1;
                a[E >> 0] = 0;
            }
            c[2279] = (c[2279] | 0) + -1;
            c[b + 512 >> 2] = c[2278];
            l = G;
            return F | (q | 0) == 0 | 0;
        }
        function Ud(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            var d = ib;
            d = T(me(a, b, c));
            return T(d + T(ne(a, b, c)));
        }
        function Vd(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            c[f >> 2] = e;
            if (!a) e = 0;
            else e = c[a + 976 >> 2] | 0;
            ge(e, a, b, d, f);
            l = g;
            return;
        }
        function Wd(a) {
            a = a | 0;
            return (a >>> 0 > 60 ? 3201 : 3201 + (60 - a) | 0) | 0;
        }
        function Xd(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            f = l;
            l = l + 32 | 0;
            d = f + 12 | 0;
            e = f;
            c[d >> 2] = c[254];
            c[d + 4 >> 2] = c[255];
            c[d + 8 >> 2] = c[256];
            c[e >> 2] = c[257];
            c[e + 4 >> 2] = c[258];
            c[e + 8 >> 2] = c[259];
            if ((a | 0) > 2) a = 11699;
            else a = c[(b ? e : d) + (a << 2) >> 2] | 0;
            l = f;
            return a | 0;
        }
        function Yd(b, e, f, h, i, k, m, n, o, p) {
            b = b | 0;
            e = T(e);
            f = T(f);
            h = h | 0;
            i = i | 0;
            k = k | 0;
            m = T(m);
            n = T(n);
            o = o | 0;
            p = p | 0;
            var q = 0, r = 0, s = 0, t = 0, u = ib, v = ib, w = ib, x = ib, y = ib, z = ib, A = ib, B = 0, C = 0, D = 0, E = ib, F = ib, G = 0, H = ib, I = 0, J = 0, K = 0, L = 0, M = 0, N = 0, O = 0, P = 0, Q = 0, R = 0, S = 0, U = 0, V = 0, W = 0, X = 0, Y = 0, Z = 0, _ = 0, $ = ib, aa = ib, ba = ib, ca = ib, da = ib, ea = 0, fa = 0, ga = 0, ha = 0, ia = 0, ja = ib, ka = ib, la = ib, ma = ib, na = ib, oa = ib, pa = 0, qa = ib, ra = ib, sa = ib, ta = ib, ua = ib, va = ib, wa = 0, xa = 0, ya = ib, za = ib, Aa = 0, Ba = 0, Ca = 0, Da = 0, Ea = ib, Fa = 0, Ga = 0, Ha = 0, Ia = 0, Ja = 0, Ka = 0, La = 0, Ma = ib, Na = 0, Oa = 0;
            La = l;
            l = l + 16 | 0;
            ea = La + 12 | 0;
            fa = La + 8 | 0;
            ga = La + 4 | 0;
            ha = La;
            ec(b, (i | 0) == 0 | (Sb(e) | 0) ^ 1, 3326);
            ec(b, (k | 0) == 0 | (Sb(f) | 0) ^ 1, 3406);
            Ga = qe(b, h) | 0;
            c[b + 496 >> 2] = Ga;
            Ja = re(2, Ga) | 0;
            Ka = re(0, Ga) | 0;
            g[b + 440 >> 2] = T(me(b, Ja, m));
            g[b + 444 >> 2] = T(ne(b, Ja, m));
            g[b + 428 >> 2] = T(me(b, Ka, m));
            g[b + 436 >> 2] = T(ne(b, Ka, m));
            g[b + 464 >> 2] = T(se(b, Ja));
            g[b + 468 >> 2] = T(te(b, Ja));
            g[b + 452 >> 2] = T(se(b, Ka));
            g[b + 460 >> 2] = T(te(b, Ka));
            g[b + 488 >> 2] = T(ue(b, Ja, m));
            g[b + 492 >> 2] = T(ve(b, Ja, m));
            g[b + 476 >> 2] = T(ue(b, Ka, m));
            g[b + 484 >> 2] = T(ve(b, Ka, m));
            do if (!(c[b + 964 >> 2] | 0)) {
                Ha = b + 948 | 0;
                Ia = (c[b + 952 >> 2] | 0) - (c[Ha >> 2] | 0) >> 2;
                if (!Ia) {
                    xe(b, e, f, i, k, m, n);
                    break;
                }
                if (!o ? ye(b, e, f, i, k, m, n) | 0 : 0) break;
                lc(b);
                Y = b + 508 | 0;
                a[Y >> 0] = 0;
                Ja = re(c[b + 4 >> 2] | 0, Ga) | 0;
                Ka = ze(Ja, Ga) | 0;
                Fa = oe(Ja) | 0;
                Z = c[b + 8 >> 2] | 0;
                Ba = b + 28 | 0;
                _ = (c[Ba >> 2] | 0) != 0;
                ua = Fa ? m : n;
                ya = Fa ? n : m;
                $ = T(Ae(b, Ja, m));
                aa = T(Be(b, Ja, m));
                u = T(Ae(b, Ka, m));
                va = T(Ce(b, Ja, m));
                za = T(Ce(b, Ka, m));
                D = Fa ? i : k;
                Aa = Fa ? k : i;
                Ea = Fa ? va : za;
                y = Fa ? za : va;
                ta = T(Ud(b, 2, m));
                x = T(Ud(b, 0, m));
                v = T(T(be(b + 364 | 0, m)) - Ea);
                w = T(T(be(b + 380 | 0, m)) - Ea);
                z = T(T(be(b + 372 | 0, n)) - y);
                A = T(T(be(b + 388 | 0, n)) - y);
                ba = Fa ? v : z;
                ca = Fa ? w : A;
                ta = T(e - ta);
                e = T(ta - Ea);
                if (Sb(e) | 0) Ea = e;
                else Ea = T(cC(T(eC(e, w)), v));
                ra = T(f - x);
                e = T(ra - y);
                if (Sb(e) | 0) sa = e;
                else sa = T(cC(T(eC(e, A)), z));
                v = Fa ? Ea : sa;
                qa = Fa ? sa : Ea;
                a: do if ((D | 0) == 1) {
                    h = 0;
                    r = 0;
                    while(true){
                        q = ac(b, r) | 0;
                        if (!h) {
                            if (T(Ee(q)) > T(0.0) ? T(Fe(q)) > T(0.0) : 0) h = q;
                            else h = 0;
                        } else if (De(q) | 0) {
                            t = 0;
                            break a;
                        }
                        r = r + 1 | 0;
                        if (r >>> 0 >= Ia >>> 0) {
                            t = h;
                            break;
                        }
                    }
                } else t = 0;
                while (0);
                B = t + 500 | 0;
                C = t + 504 | 0;
                h = 0;
                q = 0;
                e = T(0.0);
                s = 0;
                do {
                    r = c[(c[Ha >> 2] | 0) + (s << 2) >> 2] | 0;
                    if ((c[r + 36 >> 2] | 0) == 1) {
                        Ge(r);
                        a[r + 985 >> 0] = 1;
                        a[r + 984 >> 0] = 0;
                    } else {
                        $d(r);
                        if (o) ce(r, qe(r, Ga) | 0, v, qa, Ea);
                        do if ((c[r + 24 >> 2] | 0) != 1) {
                            if ((r | 0) == (t | 0)) {
                                c[B >> 2] = c[2278];
                                g[C >> 2] = T(0.0);
                                break;
                            } else {
                                He(b, r, Ea, i, sa, Ea, sa, k, Ga, p);
                                break;
                            }
                        } else {
                            if (q | 0) c[q + 960 >> 2] = r;
                            c[r + 960 >> 2] = 0;
                            q = r;
                            h = (h | 0) == 0 ? r : h;
                        }
                        while (0);
                        oa = T(g[r + 504 >> 2]);
                        e = T(e + T(oa + T(Ud(r, Ja, Ea))));
                    }
                    s = s + 1 | 0;
                }while ((s | 0) != (Ia | 0));
                K = e > v;
                pa = _ & ((D | 0) == 2 & K) ? 1 : D;
                I = (Aa | 0) == 1;
                M = I & (o ^ 1);
                N = (pa | 0) == 1;
                O = (pa | 0) == 2;
                P = 976 + (Ja << 2) | 0;
                Q = (Aa | 2) == 2;
                W = I & (_ ^ 1);
                R = 1040 + (Ka << 2) | 0;
                S = 1040 + (Ja << 2) | 0;
                U = 976 + (Ka << 2) | 0;
                V = (Aa | 0) != 1;
                K = _ & ((D | 0) != 0 & K);
                J = b + 976 | 0;
                I = I ^ 1;
                e = v;
                G = 0;
                L = 0;
                oa = T(0.0);
                da = T(0.0);
                while(true){
                    b: do if (G >>> 0 < Ia >>> 0) {
                        C = c[Ha >> 2] | 0;
                        s = 0;
                        A = T(0.0);
                        z = T(0.0);
                        w = T(0.0);
                        v = T(0.0);
                        r = 0;
                        q = 0;
                        t = G;
                        while(true){
                            B = c[C + (t << 2) >> 2] | 0;
                            if ((c[B + 36 >> 2] | 0) != 1 ? (c[B + 940 >> 2] = L, (c[B + 24 >> 2] | 0) != 1) : 0) {
                                x = T(Ud(B, Ja, Ea));
                                X = c[P >> 2] | 0;
                                f = T(be(B + 380 + (X << 3) | 0, ua));
                                y = T(g[B + 504 >> 2]);
                                f = T(eC(f, y));
                                f = T(cC(T(be(B + 364 + (X << 3) | 0, ua)), f));
                                if (_ & (s | 0) != 0 & T(x + T(z + f)) > e) {
                                    k = s;
                                    x = A;
                                    D = t;
                                    break b;
                                }
                                x = T(x + f);
                                f = T(z + x);
                                x = T(A + x);
                                if (De(B) | 0) {
                                    w = T(w + T(Ee(B)));
                                    v = T(v - T(y * T(Fe(B))));
                                }
                                if (q | 0) c[q + 960 >> 2] = B;
                                c[B + 960 >> 2] = 0;
                                s = s + 1 | 0;
                                q = B;
                                r = (r | 0) == 0 ? B : r;
                            } else {
                                x = A;
                                f = z;
                            }
                            t = t + 1 | 0;
                            if (t >>> 0 < Ia >>> 0) {
                                A = x;
                                z = f;
                            } else {
                                k = s;
                                D = t;
                                break;
                            }
                        }
                    } else {
                        k = 0;
                        x = T(0.0);
                        w = T(0.0);
                        v = T(0.0);
                        r = 0;
                        D = G;
                    }
                    while (0);
                    X = w > T(0.0) & w < T(1.0);
                    E = X ? T(1.0) : w;
                    X = v > T(0.0) & v < T(1.0);
                    A = X ? T(1.0) : v;
                    do if (!N) {
                        if (!(x < ba & ((Sb(ba) | 0) ^ 1))) {
                            if (!(x > ca & ((Sb(ca) | 0) ^ 1))) {
                                if (!(a[(c[J >> 2] | 0) + 3 >> 0] | 0)) {
                                    if (!(E == T(0.0)) ? !(T(Ee(b)) == T(0.0)) : 0) {
                                        X = 53;
                                        break;
                                    }
                                    e = x;
                                    X = 53;
                                } else X = 51;
                            } else {
                                e = ca;
                                X = 51;
                            }
                        } else {
                            e = ba;
                            X = 51;
                        }
                    } else X = 51;
                    while (0);
                    if ((X | 0) == 51) {
                        X = 0;
                        if (Sb(e) | 0) X = 53;
                        else {
                            F = T(e - x);
                            H = e;
                        }
                    }
                    if ((X | 0) == 53) {
                        X = 0;
                        if (x < T(0.0)) {
                            F = T(-x);
                            H = e;
                        } else {
                            F = T(0.0);
                            H = e;
                        }
                    }
                    if (!M ? (ia = (r | 0) == 0, !ia) : 0) {
                        s = c[P >> 2] | 0;
                        t = F < T(0.0);
                        y = T(F / A);
                        B = F > T(0.0);
                        z = T(F / E);
                        w = T(0.0);
                        x = T(0.0);
                        e = T(0.0);
                        q = r;
                        do {
                            f = T(be(q + 380 + (s << 3) | 0, ua));
                            v = T(be(q + 364 + (s << 3) | 0, ua));
                            v = T(eC(f, T(cC(v, T(g[q + 504 >> 2])))));
                            if (t) {
                                f = T(v * T(Fe(q)));
                                if (f != T(-0) ? (Ma = T(v - T(y * f)), ja = T(Ie(q, Ja, Ma, H, Ea)), Ma != ja) : 0) {
                                    w = T(w - T(ja - v));
                                    e = T(e + f);
                                }
                            } else if ((B ? (ka = T(Ee(q)), ka != T(0.0)) : 0) ? (Ma = T(v + T(z * ka)), la = T(Ie(q, Ja, Ma, H, Ea)), Ma != la) : 0) {
                                w = T(w - T(la - v));
                                x = T(x - ka);
                            }
                            q = c[q + 960 >> 2] | 0;
                        }while ((q | 0) != 0);
                        e = T(A + e);
                        v = T(F + w);
                        if (!ia) {
                            y = T(E + x);
                            t = c[P >> 2] | 0;
                            B = v < T(0.0);
                            C = e == T(0.0);
                            z = T(v / e);
                            s = v > T(0.0);
                            y = T(v / y);
                            e = T(0.0);
                            do {
                                Ma = T(be(r + 380 + (t << 3) | 0, ua));
                                w = T(be(r + 364 + (t << 3) | 0, ua));
                                w = T(eC(Ma, T(cC(w, T(g[r + 504 >> 2])))));
                                if (B) {
                                    Ma = T(w * T(Fe(r)));
                                    v = T(-Ma);
                                    if (Ma != T(-0)) {
                                        Ma = T(z * v);
                                        v = T(Ie(r, Ja, T(w + (C ? v : Ma)), H, Ea));
                                    } else v = w;
                                } else if (s ? (ma = T(Ee(r)), ma != T(0.0)) : 0) v = T(Ie(r, Ja, T(w + T(y * ma)), H, Ea));
                                else v = w;
                                e = T(e - T(v - w));
                                x = T(Ud(r, Ja, Ea));
                                f = T(Ud(r, Ka, Ea));
                                v = T(v + x);
                                g[fa >> 2] = v;
                                c[ha >> 2] = 1;
                                w = T(g[r + 396 >> 2]);
                                c: do if (Sb(w) | 0) {
                                    q = Sb(qa) | 0;
                                    do if (!q) {
                                        if (K | (ae(r, Ka, qa) | 0 | I)) break;
                                        if ((Je(b, r) | 0) != 4) break;
                                        if ((c[(Ke(r, Ka) | 0) + 4 >> 2] | 0) == 3) break;
                                        if ((c[(Le(r, Ka) | 0) + 4 >> 2] | 0) == 3) break;
                                        g[ea >> 2] = qa;
                                        c[ga >> 2] = 1;
                                        break c;
                                    }
                                    while (0);
                                    if (ae(r, Ka, qa) | 0) {
                                        q = c[r + 992 + (c[U >> 2] << 2) >> 2] | 0;
                                        Ma = T(f + T(be(q, qa)));
                                        g[ea >> 2] = Ma;
                                        q = V & (c[q + 4 >> 2] | 0) == 2;
                                        c[ga >> 2] = ((Sb(Ma) | 0 | q) ^ 1) & 1;
                                        break;
                                    } else {
                                        g[ea >> 2] = qa;
                                        c[ga >> 2] = q ? 0 : 2;
                                        break;
                                    }
                                } else {
                                    Ma = T(v - x);
                                    E = T(Ma / w);
                                    Ma = T(w * Ma);
                                    c[ga >> 2] = 1;
                                    g[ea >> 2] = T(f + (Fa ? E : Ma));
                                }
                                while (0);
                                Me(r, Ja, H, Ea, ha, fa);
                                Me(r, Ka, qa, Ea, ga, ea);
                                do if (!(ae(r, Ka, qa) | 0) ? (Je(b, r) | 0) == 4 : 0) {
                                    if ((c[(Ke(r, Ka) | 0) + 4 >> 2] | 0) == 3) {
                                        q = 0;
                                        break;
                                    }
                                    q = (c[(Le(r, Ka) | 0) + 4 >> 2] | 0) != 3;
                                } else q = 0;
                                while (0);
                                Ma = T(g[fa >> 2]);
                                E = T(g[ea >> 2]);
                                Na = c[ha >> 2] | 0;
                                Oa = c[ga >> 2] | 0;
                                Td(r, Fa ? Ma : E, Fa ? E : Ma, Ga, Fa ? Na : Oa, Fa ? Oa : Na, Ea, sa, o & (q ^ 1), 3488, p);
                                a[Y >> 0] = a[Y >> 0] | a[r + 508 >> 0];
                                r = c[r + 960 >> 2] | 0;
                            }while ((r | 0) != 0);
                        } else e = T(0.0);
                    } else e = T(0.0);
                    e = T(F + e);
                    Oa = e < T(0.0) & 1;
                    a[Y >> 0] = Oa | d[Y >> 0];
                    if (O & e > T(0.0)) {
                        q = c[P >> 2] | 0;
                        if ((c[b + 364 + (q << 3) + 4 >> 2] | 0) != 0 ? (na = T(be(b + 364 + (q << 3) | 0, ua)), na >= T(0.0)) : 0) v = T(cC(T(0.0), T(na - T(H - e))));
                        else v = T(0.0);
                    } else v = e;
                    B = G >>> 0 < D >>> 0;
                    if (B) {
                        t = c[Ha >> 2] | 0;
                        s = G;
                        q = 0;
                        do {
                            r = c[t + (s << 2) >> 2] | 0;
                            if (!(c[r + 24 >> 2] | 0)) {
                                q = ((c[(Ke(r, Ja) | 0) + 4 >> 2] | 0) == 3 & 1) + q | 0;
                                q = q + ((c[(Le(r, Ja) | 0) + 4 >> 2] | 0) == 3 & 1) | 0;
                            }
                            s = s + 1 | 0;
                        }while ((s | 0) != (D | 0));
                        if (q) {
                            x = T(0.0);
                            f = T(0.0);
                        } else X = 101;
                    } else X = 101;
                    d: if ((X | 0) == 101) {
                        X = 0;
                        switch(Z | 0){
                            case 1:
                                q = 0;
                                x = T(v * T(.5));
                                f = T(0.0);
                                break d;
                            case 2:
                                q = 0;
                                x = v;
                                f = T(0.0);
                                break d;
                            case 3:
                                if (k >>> 0 <= 1) {
                                    q = 0;
                                    x = T(0.0);
                                    f = T(0.0);
                                    break d;
                                }
                                f = T((k + -1 | 0) >>> 0);
                                q = 0;
                                x = T(0.0);
                                f = T(T(cC(v, T(0.0))) / f);
                                break d;
                            case 5:
                                f = T(v / T((k + 1 | 0) >>> 0));
                                q = 0;
                                x = f;
                                break d;
                            case 4:
                                f = T(v / T(k >>> 0));
                                q = 0;
                                x = T(f * T(.5));
                                break d;
                            default:
                                q = 0;
                                x = T(0.0);
                                f = T(0.0);
                                break d;
                        }
                    }
                    e = T($ + x);
                    if (B) {
                        w = T(v / T(q | 0));
                        s = c[Ha >> 2] | 0;
                        r = G;
                        v = T(0.0);
                        do {
                            q = c[s + (r << 2) >> 2] | 0;
                            e: do if ((c[q + 36 >> 2] | 0) != 1) {
                                switch(c[q + 24 >> 2] | 0){
                                    case 1:
                                        if (Ne(q, Ja) | 0) {
                                            if (!o) break e;
                                            Ma = T(Oe(q, Ja, H));
                                            Ma = T(Ma + T(se(b, Ja)));
                                            Ma = T(Ma + T(me(q, Ja, Ea)));
                                            g[q + 400 + (c[S >> 2] << 2) >> 2] = Ma;
                                            break e;
                                        }
                                        break;
                                    case 0:
                                        Oa = (c[(Ke(q, Ja) | 0) + 4 >> 2] | 0) == 3;
                                        Ma = T(w + e);
                                        e = Oa ? Ma : e;
                                        if (o) {
                                            Oa = q + 400 + (c[S >> 2] << 2) | 0;
                                            g[Oa >> 2] = T(e + T(g[Oa >> 2]));
                                        }
                                        Oa = (c[(Le(q, Ja) | 0) + 4 >> 2] | 0) == 3;
                                        Ma = T(w + e);
                                        e = Oa ? Ma : e;
                                        if (M) {
                                            Ma = T(f + T(Ud(q, Ja, Ea)));
                                            v = qa;
                                            e = T(e + T(Ma + T(g[q + 504 >> 2])));
                                            break e;
                                        } else {
                                            e = T(e + T(f + T(Pe(q, Ja, Ea))));
                                            v = T(cC(v, T(Pe(q, Ka, Ea))));
                                            break e;
                                        }
                                    default:
                                }
                                if (o) {
                                    Ma = T(x + T(se(b, Ja)));
                                    Oa = q + 400 + (c[S >> 2] << 2) | 0;
                                    g[Oa >> 2] = T(Ma + T(g[Oa >> 2]));
                                }
                            }
                            while (0);
                            r = r + 1 | 0;
                        }while ((r | 0) != (D | 0));
                    } else v = T(0.0);
                    f = T(aa + e);
                    if (Q) x = T(T(Ie(b, Ka, T(za + v), ya, m)) - za);
                    else x = qa;
                    w = T(T(Ie(b, Ka, T(za + (W ? qa : v)), ya, m)) - za);
                    if (B & o) {
                        r = G;
                        do {
                            s = c[(c[Ha >> 2] | 0) + (r << 2) >> 2] | 0;
                            do if ((c[s + 36 >> 2] | 0) != 1) {
                                if ((c[s + 24 >> 2] | 0) == 1) {
                                    if (Ne(s, Ka) | 0) {
                                        Ma = T(Oe(s, Ka, qa));
                                        Ma = T(Ma + T(se(b, Ka)));
                                        Ma = T(Ma + T(me(s, Ka, Ea)));
                                        q = c[R >> 2] | 0;
                                        g[s + 400 + (q << 2) >> 2] = Ma;
                                        if (!(Sb(Ma) | 0)) break;
                                    } else q = c[R >> 2] | 0;
                                    Ma = T(se(b, Ka));
                                    g[s + 400 + (q << 2) >> 2] = T(Ma + T(me(s, Ka, Ea)));
                                    break;
                                }
                                q = Je(b, s) | 0;
                                do if ((q | 0) == 4) {
                                    if ((c[(Ke(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
                                        X = 139;
                                        break;
                                    }
                                    if ((c[(Le(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
                                        X = 139;
                                        break;
                                    }
                                    if (ae(s, Ka, qa) | 0) {
                                        e = u;
                                        break;
                                    }
                                    Na = c[s + 908 + (c[P >> 2] << 2) >> 2] | 0;
                                    c[ea >> 2] = Na;
                                    e = T(g[s + 396 >> 2]);
                                    Oa = Sb(e) | 0;
                                    v = (c[j >> 2] = Na, T(g[j >> 2]));
                                    if (Oa) e = w;
                                    else {
                                        F = T(Ud(s, Ka, Ea));
                                        Ma = T(v / e);
                                        e = T(e * v);
                                        e = T(F + (Fa ? Ma : e));
                                    }
                                    g[fa >> 2] = e;
                                    g[ea >> 2] = T(T(Ud(s, Ja, Ea)) + v);
                                    c[ga >> 2] = 1;
                                    c[ha >> 2] = 1;
                                    Me(s, Ja, H, Ea, ga, ea);
                                    Me(s, Ka, qa, Ea, ha, fa);
                                    e = T(g[ea >> 2]);
                                    F = T(g[fa >> 2]);
                                    Ma = Fa ? e : F;
                                    e = Fa ? F : e;
                                    Oa = ((Sb(Ma) | 0) ^ 1) & 1;
                                    Td(s, Ma, e, Ga, Oa, ((Sb(e) | 0) ^ 1) & 1, Ea, sa, 1, 3493, p);
                                    e = u;
                                } else X = 139;
                                while (0);
                                f: do if ((X | 0) == 139) {
                                    X = 0;
                                    e = T(x - T(Pe(s, Ka, Ea)));
                                    do if ((c[(Ke(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
                                        if ((c[(Le(s, Ka) | 0) + 4 >> 2] | 0) != 3) break;
                                        e = T(u + T(cC(T(0.0), T(e * T(.5)))));
                                        break f;
                                    }
                                    while (0);
                                    if ((c[(Le(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
                                        e = u;
                                        break;
                                    }
                                    if ((c[(Ke(s, Ka) | 0) + 4 >> 2] | 0) == 3) {
                                        e = T(u + T(cC(T(0.0), e)));
                                        break;
                                    }
                                    switch(q | 0){
                                        case 1:
                                            e = u;
                                            break f;
                                        case 2:
                                            e = T(u + T(e * T(.5)));
                                            break f;
                                        default:
                                            e = T(u + e);
                                            break f;
                                    }
                                }
                                while (0);
                                Ma = T(oa + e);
                                Oa = s + 400 + (c[R >> 2] << 2) | 0;
                                g[Oa >> 2] = T(Ma + T(g[Oa >> 2]));
                            }
                            while (0);
                            r = r + 1 | 0;
                        }while ((r | 0) != (D | 0));
                    }
                    oa = T(oa + w);
                    da = T(cC(da, f));
                    k = L + 1 | 0;
                    if (D >>> 0 >= Ia >>> 0) break;
                    else {
                        e = H;
                        G = D;
                        L = k;
                    }
                }
                do if (o) {
                    q = k >>> 0 > 1;
                    if (!q ? !(Qe(b) | 0) : 0) break;
                    if (!(Sb(qa) | 0)) {
                        e = T(qa - oa);
                        g: do switch(c[b + 12 >> 2] | 0){
                            case 3:
                                u = T(u + e);
                                z = T(0.0);
                                break;
                            case 2:
                                u = T(u + T(e * T(.5)));
                                z = T(0.0);
                                break;
                            case 4:
                                if (qa > oa) z = T(e / T(k >>> 0));
                                else z = T(0.0);
                                break;
                            case 7:
                                if (qa > oa) {
                                    u = T(u + T(e / T(k << 1 >>> 0)));
                                    z = T(e / T(k >>> 0));
                                    z = q ? z : T(0.0);
                                    break g;
                                } else {
                                    u = T(u + T(e * T(.5)));
                                    z = T(0.0);
                                    break g;
                                }
                            case 6:
                                z = T(e / T(L >>> 0));
                                z = qa > oa & q ? z : T(0.0);
                                break;
                            default:
                                z = T(0.0);
                        }
                        while (0);
                        if (k | 0) {
                            B = 1040 + (Ka << 2) | 0;
                            C = 976 + (Ka << 2) | 0;
                            t = 0;
                            r = 0;
                            while(true){
                                h: do if (r >>> 0 < Ia >>> 0) {
                                    v = T(0.0);
                                    w = T(0.0);
                                    e = T(0.0);
                                    s = r;
                                    while(true){
                                        q = c[(c[Ha >> 2] | 0) + (s << 2) >> 2] | 0;
                                        do if ((c[q + 36 >> 2] | 0) != 1 ? (c[q + 24 >> 2] | 0) == 0 : 0) {
                                            if ((c[q + 940 >> 2] | 0) != (t | 0)) break h;
                                            if (Re(q, Ka) | 0) {
                                                Ma = T(g[q + 908 + (c[C >> 2] << 2) >> 2]);
                                                e = T(cC(e, T(Ma + T(Ud(q, Ka, Ea)))));
                                            }
                                            if ((Je(b, q) | 0) != 5) break;
                                            na = T(Se(q));
                                            na = T(na + T(me(q, 0, Ea)));
                                            Ma = T(g[q + 912 >> 2]);
                                            Ma = T(T(Ma + T(Ud(q, 0, Ea))) - na);
                                            na = T(cC(w, na));
                                            Ma = T(cC(v, Ma));
                                            v = Ma;
                                            w = na;
                                            e = T(cC(e, T(na + Ma)));
                                        }
                                        while (0);
                                        q = s + 1 | 0;
                                        if (q >>> 0 < Ia >>> 0) s = q;
                                        else {
                                            s = q;
                                            break;
                                        }
                                    }
                                } else {
                                    w = T(0.0);
                                    e = T(0.0);
                                    s = r;
                                }
                                while (0);
                                y = T(z + e);
                                f = u;
                                u = T(u + y);
                                if (r >>> 0 < s >>> 0) {
                                    x = T(f + w);
                                    q = r;
                                    do {
                                        r = c[(c[Ha >> 2] | 0) + (q << 2) >> 2] | 0;
                                        i: if ((c[r + 36 >> 2] | 0) != 1 ? (c[r + 24 >> 2] | 0) == 0 : 0) switch(Je(b, r) | 0){
                                            case 1:
                                                Ma = T(f + T(me(r, Ka, Ea)));
                                                g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;
                                                break i;
                                            case 3:
                                                Ma = T(T(u - T(ne(r, Ka, Ea))) - T(g[r + 908 + (c[C >> 2] << 2) >> 2]));
                                                g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;
                                                break i;
                                            case 2:
                                                Ma = T(f + T(T(y - T(g[r + 908 + (c[C >> 2] << 2) >> 2])) * T(.5)));
                                                g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;
                                                break i;
                                            case 4:
                                                Ma = T(f + T(me(r, Ka, Ea)));
                                                g[r + 400 + (c[B >> 2] << 2) >> 2] = Ma;
                                                if (ae(r, Ka, qa) | 0) break i;
                                                if (Fa) {
                                                    v = T(g[r + 908 >> 2]);
                                                    e = T(v + T(Ud(r, Ja, Ea)));
                                                    w = y;
                                                } else {
                                                    w = T(g[r + 912 >> 2]);
                                                    w = T(w + T(Ud(r, Ka, Ea)));
                                                    e = y;
                                                    v = T(g[r + 908 >> 2]);
                                                }
                                                if (Ld(e, v) | 0 ? Ld(w, T(g[r + 912 >> 2])) | 0 : 0) break i;
                                                Td(r, e, w, Ga, 1, 1, Ea, sa, 1, 3501, p);
                                                break i;
                                            case 5:
                                                g[r + 404 >> 2] = T(T(x - T(Se(r))) + T(Oe(r, 0, qa)));
                                                break i;
                                            default:
                                                break i;
                                        }
                                        q = q + 1 | 0;
                                    }while ((q | 0) != (s | 0));
                                }
                                t = t + 1 | 0;
                                if ((t | 0) == (k | 0)) break;
                                else r = s;
                            }
                        }
                    }
                }
                while (0);
                g[b + 908 >> 2] = T(Ie(b, 2, ta, m, m));
                g[b + 912 >> 2] = T(Ie(b, 0, ra, n, m));
                if ((pa | 0) != 0 ? (wa = c[b + 32 >> 2] | 0, xa = (pa | 0) == 2, !(xa & (wa | 0) != 2)) : 0) {
                    if (xa & (wa | 0) == 2) {
                        e = T(va + H);
                        e = T(cC(T(eC(e, T(Te(b, Ja, da, ua)))), va));
                        X = 198;
                    }
                } else {
                    e = T(Ie(b, Ja, da, ua, m));
                    X = 198;
                }
                if ((X | 0) == 198) g[b + 908 + (c[976 + (Ja << 2) >> 2] << 2) >> 2] = e;
                if ((Aa | 0) != 0 ? (Ca = c[b + 32 >> 2] | 0, Da = (Aa | 0) == 2, !(Da & (Ca | 0) != 2)) : 0) {
                    if (Da & (Ca | 0) == 2) {
                        e = T(za + qa);
                        e = T(cC(T(eC(e, T(Te(b, Ka, T(za + oa), ya)))), za));
                        X = 204;
                    }
                } else {
                    e = T(Ie(b, Ka, T(za + oa), ya, m));
                    X = 204;
                }
                if ((X | 0) == 204) g[b + 908 + (c[976 + (Ka << 2) >> 2] << 2) >> 2] = e;
                if (o) {
                    if ((c[Ba >> 2] | 0) == 2) {
                        r = 976 + (Ka << 2) | 0;
                        s = 1040 + (Ka << 2) | 0;
                        q = 0;
                        do {
                            t = ac(b, q) | 0;
                            if (!(c[t + 24 >> 2] | 0)) {
                                Na = c[r >> 2] | 0;
                                Ma = T(g[b + 908 + (Na << 2) >> 2]);
                                Oa = t + 400 + (c[s >> 2] << 2) | 0;
                                Ma = T(Ma - T(g[Oa >> 2]));
                                g[Oa >> 2] = T(Ma - T(g[t + 908 + (Na << 2) >> 2]));
                            }
                            q = q + 1 | 0;
                        }while ((q | 0) != (Ia | 0));
                    }
                    if (h | 0) {
                        q = Fa ? pa : i;
                        do {
                            Ue(b, h, Ea, q, sa, Ga, p);
                            h = c[h + 960 >> 2] | 0;
                        }while ((h | 0) != 0);
                    }
                    q = (Ja | 2) == 3;
                    r = (Ka | 2) == 3;
                    if (q | r) {
                        h = 0;
                        do {
                            s = c[(c[Ha >> 2] | 0) + (h << 2) >> 2] | 0;
                            if ((c[s + 36 >> 2] | 0) != 1) {
                                if (q) Ve(b, s, Ja);
                                if (r) Ve(b, s, Ka);
                            }
                            h = h + 1 | 0;
                        }while ((h | 0) != (Ia | 0));
                    }
                }
            } else we(b, e, f, i, k, m, n);
            while (0);
            l = La;
            return;
        }
        function Zd(a, b) {
            a = a | 0;
            b = T(b);
            var c = 0;
            Vb(a, b >= T(0.0), 3147);
            c = b == T(0.0);
            g[a + 4 >> 2] = c ? T(0.0) : b;
            return;
        }
        function _d(b, d, e, f) {
            b = b | 0;
            d = T(d);
            e = T(e);
            f = f | 0;
            var h = ib, i = ib, j = 0, k = 0, l = 0;
            c[2278] = (c[2278] | 0) + 1;
            $d(b);
            if (!(ae(b, 2, d) | 0)) {
                h = T(be(b + 380 | 0, d));
                if (!(h >= T(0.0))) {
                    l = ((Sb(d) | 0) ^ 1) & 1;
                    h = d;
                } else l = 2;
            } else {
                h = T(be(c[b + 992 >> 2] | 0, d));
                l = 1;
                h = T(h + T(Ud(b, 2, d)));
            }
            if (!(ae(b, 0, e) | 0)) {
                i = T(be(b + 388 | 0, e));
                if (!(i >= T(0.0))) {
                    k = ((Sb(e) | 0) ^ 1) & 1;
                    i = e;
                } else k = 2;
            } else {
                i = T(be(c[b + 996 >> 2] | 0, e));
                k = 1;
                i = T(i + T(Ud(b, 0, d)));
            }
            j = b + 976 | 0;
            if (Td(b, h, i, f, l, k, d, e, 1, 3189, c[j >> 2] | 0) | 0 ? (ce(b, c[b + 496 >> 2] | 0, d, e, d), de(b, T(g[(c[j >> 2] | 0) + 4 >> 2]), T(0.0), T(0.0)), a[11696] | 0) : 0) Md(b, 7);
            return;
        }
        function $d(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            h = i + 24 | 0;
            g = i + 16 | 0;
            e = i + 8 | 0;
            f = i;
            d = 0;
            do {
                b = a + 380 + (d << 3) | 0;
                if (!((c[a + 380 + (d << 3) + 4 >> 2] | 0) != 0 ? (j = b, k = c[j + 4 >> 2] | 0, m = e, c[m >> 2] = c[j >> 2], c[m + 4 >> 2] = k, m = a + 364 + (d << 3) | 0, k = c[m + 4 >> 2] | 0, j = f, c[j >> 2] = c[m >> 2], c[j + 4 >> 2] = k, c[g >> 2] = c[e >> 2], c[g + 4 >> 2] = c[e + 4 >> 2], c[h >> 2] = c[f >> 2], c[h + 4 >> 2] = c[f + 4 >> 2], Kd(g, h) | 0) : 0)) b = a + 348 + (d << 3) | 0;
                c[a + 992 + (d << 2) >> 2] = b;
                d = d + 1 | 0;
            }while ((d | 0) != 2);
            l = i;
            return;
        }
        function ae(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0;
            a = c[a + 992 + (c[976 + (b << 2) >> 2] << 2) >> 2] | 0;
            switch(c[a + 4 >> 2] | 0){
                case 0:
                case 3:
                    a = 0;
                    break;
                case 1:
                    if (T(g[a >> 2]) < T(0.0)) a = 0;
                    else e = 5;
                    break;
                case 2:
                    if (T(g[a >> 2]) < T(0.0)) a = 0;
                    else a = (Sb(d) | 0) ^ 1;
                    break;
                default:
                    e = 5;
            }
            if ((e | 0) == 5) a = 1;
            return a | 0;
        }
        function be(a, b) {
            a = a | 0;
            b = T(b);
            switch(c[a + 4 >> 2] | 0){
                case 2:
                    b = T(T(T(g[a >> 2]) * b) / T(100.0));
                    break;
                case 1:
                    b = T(g[a >> 2]);
                    break;
                default:
                    b = T(t);
            }
            return T(b);
        }
        function ce(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            e = T(e);
            f = T(f);
            var h = 0, i = ib;
            b = c[a + 944 >> 2] | 0 ? b : 1;
            h = re(c[a + 4 >> 2] | 0, b) | 0;
            b = ze(h, b) | 0;
            d = T($e(a, h, d));
            e = T($e(a, b, e));
            i = T(d + T(me(a, h, f)));
            g[a + 400 + (c[1040 + (h << 2) >> 2] << 2) >> 2] = i;
            d = T(d + T(ne(a, h, f)));
            g[a + 400 + (c[1e3 + (h << 2) >> 2] << 2) >> 2] = d;
            d = T(e + T(me(a, b, f)));
            g[a + 400 + (c[1040 + (b << 2) >> 2] << 2) >> 2] = d;
            f = T(e + T(ne(a, b, f)));
            g[a + 400 + (c[1e3 + (b << 2) >> 2] << 2) >> 2] = f;
            return;
        }
        function de(a, b, d, e) {
            a = a | 0;
            b = T(b);
            d = T(d);
            e = T(e);
            var f = 0, h = 0, i = ib, j = ib, k = 0, l = 0, m = ib, n = 0, o = ib, p = ib, q = ib, r = ib;
            if (!(b == T(0.0))) {
                f = a + 400 | 0;
                r = T(g[f >> 2]);
                h = a + 404 | 0;
                q = T(g[h >> 2]);
                n = a + 416 | 0;
                p = T(g[n >> 2]);
                l = a + 420 | 0;
                i = T(g[l >> 2]);
                o = T(r + d);
                m = T(q + e);
                e = T(o + p);
                j = T(m + i);
                k = (c[a + 988 >> 2] | 0) == 1;
                g[f >> 2] = T(Od(r, b, 0, k));
                g[h >> 2] = T(Od(q, b, 0, k));
                d = T(gC(T(p * b), T(1.0)));
                if (Ld(d, T(0.0)) | 0) h = 0;
                else h = (Ld(d, T(1.0)) | 0) ^ 1;
                d = T(gC(T(i * b), T(1.0)));
                if (Ld(d, T(0.0)) | 0) f = 0;
                else f = (Ld(d, T(1.0)) | 0) ^ 1;
                r = T(Od(e, b, k & h, k & (h ^ 1)));
                g[n >> 2] = T(r - T(Od(o, b, 0, k)));
                r = T(Od(j, b, k & f, k & (f ^ 1)));
                g[l >> 2] = T(r - T(Od(m, b, 0, k)));
                h = (c[a + 952 >> 2] | 0) - (c[a + 948 >> 2] | 0) >> 2;
                if (h | 0) {
                    f = 0;
                    do {
                        de(ac(a, f) | 0, b, o, m);
                        f = f + 1 | 0;
                    }while ((f | 0) != (h | 0));
                }
            }
            return;
        }
        function ee(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            switch(d | 0){
                case 5:
                case 0:
                    a = CB(c[489] | 0, e, f) | 0;
                    break;
                default:
                    a = iC(e, f) | 0;
            }
            return a | 0;
        }
        function fe(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            f = l;
            l = l + 16 | 0;
            g = f;
            c[g >> 2] = e;
            ge(a, 0, b, d, g);
            l = f;
            return;
        }
        function ge(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            a = a | 0 ? a : 956;
            Bb[c[a + 8 >> 2] & 1](a, b, d, e, f);
            if ((d | 0) == 5) Ta();
            else return;
        }
        function he(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            a[b + c >> 0] = d & 1;
            return;
        }
        function ie(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            c[a >> 2] = 0;
            c[a + 4 >> 2] = 0;
            c[a + 8 >> 2] = 0;
            d = b + 4 | 0;
            e = (c[d >> 2] | 0) - (c[b >> 2] | 0) >> 2;
            if (e | 0) {
                je(a, e);
                ke(a, c[b >> 2] | 0, c[d >> 2] | 0, e);
            }
            return;
        }
        function je(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if ((le(a) | 0) >>> 0 < b >>> 0) jC(a);
            if (b >>> 0 > 1073741823) Ta();
            else {
                d = qC(b << 2) | 0;
                c[a + 4 >> 2] = d;
                c[a >> 2] = d;
                c[a + 8 >> 2] = d + (b << 2);
                return;
            }
        }
        function ke(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            e = a + 4 | 0;
            a = d - b | 0;
            if ((a | 0) > 0) {
                BC(c[e >> 2] | 0, b | 0, a | 0);
                c[e >> 2] = (c[e >> 2] | 0) + (a >>> 2 << 2);
            }
            return;
        }
        function le(a) {
            a = a | 0;
            return 1073741823;
        }
        function me(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            if (oe(b) | 0 ? (c[a + 96 >> 2] | 0) != 0 : 0) a = a + 92 | 0;
            else a = Tb(a + 60 | 0, c[1040 + (b << 2) >> 2] | 0, 992) | 0;
            return T(pe(a, d));
        }
        function ne(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            if (oe(b) | 0 ? (c[a + 104 >> 2] | 0) != 0 : 0) a = a + 100 | 0;
            else a = Tb(a + 60 | 0, c[1e3 + (b << 2) >> 2] | 0, 992) | 0;
            return T(pe(a, d));
        }
        function oe(a) {
            a = a | 0;
            return (a | 1) == 3 | 0;
        }
        function pe(a, b) {
            a = a | 0;
            b = T(b);
            if ((c[a + 4 >> 2] | 0) == 3) b = T(0.0);
            else b = T(be(a, b));
            return T(b);
        }
        function qe(a, b) {
            a = a | 0;
            b = b | 0;
            a = c[a >> 2] | 0;
            return ((a | 0) == 0 ? (b | 0) > 1 ? b : 1 : a) | 0;
        }
        function re(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            a: do if ((b | 0) == 2) {
                switch(a | 0){
                    case 2:
                        a = 3;
                        break a;
                    case 3:
                        break;
                    default:
                        c = 4;
                        break a;
                }
                a = 2;
            } else c = 4;
            while (0);
            return a | 0;
        }
        function se(a, b) {
            a = a | 0;
            b = b | 0;
            var d = ib;
            if (!((oe(b) | 0 ? (c[a + 312 >> 2] | 0) != 0 : 0) ? (d = T(g[a + 308 >> 2]), d >= T(0.0)) : 0)) d = T(cC(T(g[(Tb(a + 276 | 0, c[1040 + (b << 2) >> 2] | 0, 992) | 0) >> 2]), T(0.0)));
            return T(d);
        }
        function te(a, b) {
            a = a | 0;
            b = b | 0;
            var d = ib;
            if (!((oe(b) | 0 ? (c[a + 320 >> 2] | 0) != 0 : 0) ? (d = T(g[a + 316 >> 2]), d >= T(0.0)) : 0)) d = T(cC(T(g[(Tb(a + 276 | 0, c[1e3 + (b << 2) >> 2] | 0, 992) | 0) >> 2]), T(0.0)));
            return T(d);
        }
        function ue(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = ib;
            if (!((oe(b) | 0 ? (c[a + 240 >> 2] | 0) != 0 : 0) ? (e = T(be(a + 236 | 0, d)), e >= T(0.0)) : 0)) e = T(cC(T(be(Tb(a + 204 | 0, c[1040 + (b << 2) >> 2] | 0, 992) | 0, d)), T(0.0)));
            return T(e);
        }
        function ve(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = ib;
            if (!((oe(b) | 0 ? (c[a + 248 >> 2] | 0) != 0 : 0) ? (e = T(be(a + 244 | 0, d)), e >= T(0.0)) : 0)) e = T(cC(T(be(Tb(a + 204 | 0, c[1e3 + (b << 2) >> 2] | 0, 992) | 0, d)), T(0.0)));
            return T(e);
        }
        function we(a, b, d, e, f, h, i) {
            a = a | 0;
            b = T(b);
            d = T(d);
            e = e | 0;
            f = f | 0;
            h = T(h);
            i = T(i);
            var j = ib, k = ib, m = ib, n = ib, o = ib, p = ib, q = 0, r = 0, s = 0;
            s = l;
            l = l + 16 | 0;
            q = s;
            r = a + 964 | 0;
            ec(a, (c[r >> 2] | 0) != 0, 3519);
            j = T(Ce(a, 2, b));
            k = T(Ce(a, 0, b));
            m = T(Ud(a, 2, b));
            n = T(Ud(a, 0, b));
            if (Sb(b) | 0) o = b;
            else o = T(cC(T(0.0), T(T(b - m) - j)));
            if (Sb(d) | 0) p = d;
            else p = T(cC(T(0.0), T(T(d - n) - k)));
            if ((e | 0) == 1 & (f | 0) == 1) {
                g[a + 908 >> 2] = T(Ie(a, 2, T(b - m), h, h));
                b = T(Ie(a, 0, T(d - n), i, h));
            } else {
                Db[c[r >> 2] & 1](q, a, o, e, p, f);
                o = T(j + T(g[q >> 2]));
                p = T(b - m);
                g[a + 908 >> 2] = T(Ie(a, 2, (e | 2) == 2 ? o : p, h, h));
                p = T(k + T(g[q + 4 >> 2]));
                b = T(d - n);
                b = T(Ie(a, 0, (f | 2) == 2 ? p : b, i, h));
            }
            g[a + 912 >> 2] = b;
            l = s;
            return;
        }
        function xe(a, b, c, d, e, f, h) {
            a = a | 0;
            b = T(b);
            c = T(c);
            d = d | 0;
            e = e | 0;
            f = T(f);
            h = T(h);
            var i = ib, j = ib, k = ib, l = ib;
            k = T(Ce(a, 2, f));
            i = T(Ce(a, 0, f));
            l = T(Ud(a, 2, f));
            j = T(Ud(a, 0, f));
            b = T(b - l);
            g[a + 908 >> 2] = T(Ie(a, 2, (d | 2) == 2 ? k : b, f, f));
            c = T(c - j);
            g[a + 912 >> 2] = T(Ie(a, 0, (e | 2) == 2 ? i : c, h, f));
            return;
        }
        function ye(a, b, c, d, e, f, h) {
            a = a | 0;
            b = T(b);
            c = T(c);
            d = d | 0;
            e = e | 0;
            f = T(f);
            h = T(h);
            var i = 0, j = ib, k = ib;
            i = (d | 0) == 2;
            if ((!(b <= T(0.0) & i) ? !(c <= T(0.0) & (e | 0) == 2) : 0) ? !((d | 0) == 1 & (e | 0) == 1) : 0) a = 0;
            else {
                j = T(Ud(a, 0, f));
                k = T(Ud(a, 2, f));
                i = b < T(0.0) & i | (Sb(b) | 0);
                b = T(b - k);
                g[a + 908 >> 2] = T(Ie(a, 2, i ? T(0.0) : b, f, f));
                b = T(c - j);
                i = c < T(0.0) & (e | 0) == 2 | (Sb(c) | 0);
                g[a + 912 >> 2] = T(Ie(a, 0, i ? T(0.0) : b, h, f));
                a = 1;
            }
            return a | 0;
        }
        function ze(a, b) {
            a = a | 0;
            b = b | 0;
            if (We(a) | 0) a = re(2, b) | 0;
            else a = 0;
            return a | 0;
        }
        function Ae(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            c = T(ue(a, b, c));
            return T(c + T(se(a, b)));
        }
        function Be(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            c = T(ve(a, b, c));
            return T(c + T(te(a, b)));
        }
        function Ce(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            var d = ib;
            d = T(Ae(a, b, c));
            return T(d + T(Be(a, b, c)));
        }
        function De(a) {
            a = a | 0;
            if (!(c[a + 24 >> 2] | 0)) {
                if (T(Ee(a)) != T(0.0)) a = 1;
                else a = T(Fe(a)) != T(0.0);
            } else a = 0;
            return a | 0;
        }
        function Ee(a) {
            a = a | 0;
            var b = ib;
            if (c[a + 944 >> 2] | 0) {
                b = T(g[a + 44 >> 2]);
                if (Sb(b) | 0) {
                    b = T(g[a + 40 >> 2]);
                    a = b > T(0.0) & ((Sb(b) | 0) ^ 1);
                    return T(a ? b : T(0.0));
                }
            } else b = T(0.0);
            return T(b);
        }
        function Fe(b) {
            b = b | 0;
            var d = ib, e = 0, f = ib;
            do if (c[b + 944 >> 2] | 0) {
                d = T(g[b + 48 >> 2]);
                if (Sb(d) | 0) {
                    e = a[(c[b + 976 >> 2] | 0) + 2 >> 0] | 0;
                    if (e << 24 >> 24 == 0 ? (f = T(g[b + 40 >> 2]), f < T(0.0) & ((Sb(f) | 0) ^ 1)) : 0) {
                        d = T(-f);
                        break;
                    }
                    d = e << 24 >> 24 ? T(1.0) : T(0.0);
                }
            } else d = T(0.0);
            while (0);
            return T(d);
        }
        function Ge(b) {
            b = b | 0;
            var d = 0, e = 0;
            yC(b + 400 | 0, 0, 540);
            a[b + 985 >> 0] = 1;
            lc(b);
            e = $b(b) | 0;
            if (e | 0) {
                d = b + 948 | 0;
                b = 0;
                do {
                    Ge(c[(c[d >> 2] | 0) + (b << 2) >> 2] | 0);
                    b = b + 1 | 0;
                }while ((b | 0) != (e | 0));
            }
            return;
        }
        function He(a, b, d, e, f, h, i, j, k, m) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            e = e | 0;
            f = T(f);
            h = T(h);
            i = T(i);
            j = j | 0;
            k = k | 0;
            m = m | 0;
            var n = 0, o = ib, p = 0, q = 0, r = ib, s = ib, u = 0, v = ib, w = 0, x = ib, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0;
            G = l;
            l = l + 16 | 0;
            A = G + 12 | 0;
            B = G + 8 | 0;
            C = G + 4 | 0;
            D = G;
            F = re(c[a + 4 >> 2] | 0, k) | 0;
            y = oe(F) | 0;
            o = T(be(Xe(b) | 0, y ? h : i));
            z = ae(b, 2, h) | 0;
            E = ae(b, 0, i) | 0;
            do if (!(Sb(o) | 0) ? !(Sb(y ? d : f) | 0) : 0) {
                n = b + 504 | 0;
                if (!(Sb(T(g[n >> 2])) | 0)) {
                    if (!(Ye(c[b + 976 >> 2] | 0, 0) | 0)) break;
                    if ((c[b + 500 >> 2] | 0) == (c[2278] | 0)) break;
                }
                g[n >> 2] = T(cC(o, T(Ce(b, F, h))));
            } else p = 7;
            while (0);
            do if ((p | 0) == 7) {
                w = y ^ 1;
                if (!(w | z ^ 1)) {
                    i = T(be(c[b + 992 >> 2] | 0, h));
                    g[b + 504 >> 2] = T(cC(i, T(Ce(b, 2, h))));
                    break;
                }
                if (!(y | E ^ 1)) {
                    i = T(be(c[b + 996 >> 2] | 0, i));
                    g[b + 504 >> 2] = T(cC(i, T(Ce(b, 0, h))));
                    break;
                }
                g[A >> 2] = T(t);
                g[B >> 2] = T(t);
                c[C >> 2] = 0;
                c[D >> 2] = 0;
                v = T(Ud(b, 2, h));
                x = T(Ud(b, 0, h));
                if (z) {
                    r = T(v + T(be(c[b + 992 >> 2] | 0, h)));
                    g[A >> 2] = r;
                    c[C >> 2] = 1;
                    q = 1;
                } else {
                    q = 0;
                    r = T(t);
                }
                if (E) {
                    o = T(x + T(be(c[b + 996 >> 2] | 0, i)));
                    g[B >> 2] = o;
                    c[D >> 2] = 1;
                    n = 1;
                } else {
                    n = 0;
                    o = T(t);
                }
                p = c[a + 32 >> 2] | 0;
                if (!(y & (p | 0) == 2)) {
                    if (Sb(r) | 0 ? !(Sb(d) | 0) : 0) {
                        g[A >> 2] = d;
                        c[C >> 2] = 2;
                        q = 2;
                        r = d;
                    }
                } else p = 2;
                if ((!((p | 0) == 2 & w) ? Sb(o) | 0 : 0) ? !(Sb(f) | 0) : 0) {
                    g[B >> 2] = f;
                    c[D >> 2] = 2;
                    n = 2;
                    o = f;
                }
                s = T(g[b + 396 >> 2]);
                u = Sb(s) | 0;
                do if (!u) {
                    if ((q | 0) == 1 & w) {
                        g[B >> 2] = T(T(r - v) / s);
                        c[D >> 2] = 1;
                        n = 1;
                        p = 1;
                        break;
                    }
                    if (y & (n | 0) == 1) {
                        g[A >> 2] = T(s * T(o - x));
                        c[C >> 2] = 1;
                        n = 1;
                        p = 1;
                    } else p = q;
                } else p = q;
                while (0);
                H = Sb(d) | 0;
                q = (Je(a, b) | 0) != 4;
                if (!(y | z | ((e | 0) != 1 | H) | (q | (p | 0) == 1)) ? (g[A >> 2] = d, c[C >> 2] = 1, !u) : 0) {
                    g[B >> 2] = T(T(d - v) / s);
                    c[D >> 2] = 1;
                    n = 1;
                }
                if (!(E | w | ((j | 0) != 1 | (Sb(f) | 0)) | (q | (n | 0) == 1)) ? (g[B >> 2] = f, c[D >> 2] = 1, !u) : 0) {
                    g[A >> 2] = T(s * T(f - x));
                    c[C >> 2] = 1;
                }
                Me(b, 2, h, h, C, A);
                Me(b, 0, i, h, D, B);
                d = T(g[A >> 2]);
                f = T(g[B >> 2]);
                Td(b, d, f, k, c[C >> 2] | 0, c[D >> 2] | 0, h, i, 0, 3565, m);
                i = T(g[b + 908 + (c[976 + (F << 2) >> 2] << 2) >> 2]);
                g[b + 504 >> 2] = T(cC(i, T(Ce(b, F, h))));
            }
            while (0);
            c[b + 500 >> 2] = c[2278];
            l = G;
            return;
        }
        function Ie(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            d = T(d);
            e = T(e);
            d = T(Te(a, b, c, d));
            return T(cC(d, T(Ce(a, b, e))));
        }
        function Je(a, b) {
            a = a | 0;
            b = b | 0;
            b = b + 20 | 0;
            b = c[((c[b >> 2] | 0) == 0 ? a + 16 | 0 : b) >> 2] | 0;
            if ((b | 0) == 5 ? We(c[a + 4 >> 2] | 0) | 0 : 0) b = 1;
            return b | 0;
        }
        function Ke(a, b) {
            a = a | 0;
            b = b | 0;
            if (oe(b) | 0 ? (c[a + 96 >> 2] | 0) != 0 : 0) b = 4;
            else b = c[1040 + (b << 2) >> 2] | 0;
            return a + 60 + (b << 3) | 0;
        }
        function Le(a, b) {
            a = a | 0;
            b = b | 0;
            if (oe(b) | 0 ? (c[a + 104 >> 2] | 0) != 0 : 0) b = 5;
            else b = c[1e3 + (b << 2) >> 2] | 0;
            return a + 60 + (b << 3) | 0;
        }
        function Me(a, b, d, e, f, h) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            e = T(e);
            f = f | 0;
            h = h | 0;
            d = T(be(a + 380 + (c[976 + (b << 2) >> 2] << 3) | 0, d));
            d = T(d + T(Ud(a, b, e)));
            switch(c[f >> 2] | 0){
                case 2:
                case 1:
                    f = Sb(d) | 0;
                    e = T(g[h >> 2]);
                    g[h >> 2] = f | e < d ? e : d;
                    break;
                case 0:
                    if (!(Sb(d) | 0)) {
                        c[f >> 2] = 2;
                        g[h >> 2] = d;
                    }
                    break;
                default:
            }
            return;
        }
        function Ne(a, b) {
            a = a | 0;
            b = b | 0;
            a = a + 132 | 0;
            if (oe(b) | 0 ? (c[(Tb(a, 4, 948) | 0) + 4 >> 2] | 0) != 0 : 0) a = 1;
            else a = (c[(Tb(a, c[1040 + (b << 2) >> 2] | 0, 948) | 0) + 4 >> 2] | 0) != 0;
            return a | 0;
        }
        function Oe(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0;
            a = a + 132 | 0;
            if (oe(b) | 0 ? (e = Tb(a, 4, 948) | 0, (c[e + 4 >> 2] | 0) != 0) : 0) f = 4;
            else {
                e = Tb(a, c[1040 + (b << 2) >> 2] | 0, 948) | 0;
                if (!(c[e + 4 >> 2] | 0)) d = T(0.0);
                else f = 4;
            }
            if ((f | 0) == 4) d = T(be(e, d));
            return T(d);
        }
        function Pe(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = ib;
            e = T(g[a + 908 + (c[976 + (b << 2) >> 2] << 2) >> 2]);
            e = T(e + T(me(a, b, d)));
            return T(e + T(ne(a, b, d)));
        }
        function Qe(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            a: do if (!(We(c[a + 4 >> 2] | 0) | 0)) {
                if ((c[a + 16 >> 2] | 0) != 5) {
                    d = $b(a) | 0;
                    if (!d) b = 0;
                    else {
                        b = 0;
                        while(true){
                            e = ac(a, b) | 0;
                            if ((c[e + 24 >> 2] | 0) == 0 ? (c[e + 20 >> 2] | 0) == 5 : 0) {
                                b = 1;
                                break a;
                            }
                            b = b + 1 | 0;
                            if (b >>> 0 >= d >>> 0) {
                                b = 0;
                                break;
                            }
                        }
                    }
                } else b = 1;
            } else b = 0;
            while (0);
            return b | 0;
        }
        function Re(a, b) {
            a = a | 0;
            b = b | 0;
            var d = ib;
            d = T(g[a + 908 + (c[976 + (b << 2) >> 2] << 2) >> 2]);
            return d >= T(0.0) & ((Sb(d) | 0) ^ 1) | 0;
        }
        function Se(a) {
            a = a | 0;
            var b = ib, d = 0, e = 0, f = 0, h = 0, i = 0, j = 0, k = ib;
            d = c[a + 968 >> 2] | 0;
            if (!d) {
                h = $b(a) | 0;
                do if (h | 0) {
                    d = 0;
                    f = 0;
                    while(true){
                        e = ac(a, f) | 0;
                        if (c[e + 940 >> 2] | 0) {
                            i = 8;
                            break;
                        }
                        if ((c[e + 24 >> 2] | 0) != 1) {
                            j = (Je(a, e) | 0) == 5;
                            if (j) {
                                d = e;
                                break;
                            } else d = (d | 0) == 0 ? e : d;
                        }
                        f = f + 1 | 0;
                        if (f >>> 0 >= h >>> 0) {
                            i = 8;
                            break;
                        }
                    }
                    if ((i | 0) == 8) {
                        if (!d) break;
                    }
                    b = T(Se(d));
                    return T(b + T(g[d + 404 >> 2]));
                }
                while (0);
                b = T(g[a + 912 >> 2]);
            } else {
                k = T(g[a + 908 >> 2]);
                b = T(g[a + 912 >> 2]);
                b = T(mb[d & 0](a, k, b));
                ec(a, (Sb(b) | 0) ^ 1, 3573);
            }
            return T(b);
        }
        function Te(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            d = T(d);
            var e = ib, f = 0;
            if (!(We(b) | 0)) {
                if (oe(b) | 0) {
                    b = 0;
                    f = 3;
                } else {
                    d = T(t);
                    e = T(t);
                }
            } else {
                b = 1;
                f = 3;
            }
            if ((f | 0) == 3) {
                e = T(be(a + 364 + (b << 3) | 0, d));
                d = T(be(a + 380 + (b << 3) | 0, d));
            }
            f = d < c & (d >= T(0.0) & ((Sb(d) | 0) ^ 1));
            c = f ? d : c;
            f = e >= T(0.0) & ((Sb(e) | 0) ^ 1) & c < e;
            return T(f ? e : c);
        }
        function Ue(a, b, d, e, f, h, i) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            e = e | 0;
            f = T(f);
            h = h | 0;
            i = i | 0;
            var j = ib, k = ib, l = 0, m = 0, n = ib, o = ib, p = ib, q = 0, r = 0, s = 0, u = 0, v = ib, w = 0;
            s = re(c[a + 4 >> 2] | 0, h) | 0;
            q = ze(s, h) | 0;
            r = oe(s) | 0;
            n = T(Ud(b, 2, d));
            o = T(Ud(b, 0, d));
            if (!(ae(b, 2, d) | 0)) {
                if (Ne(b, 2) | 0 ? Ze(b, 2) | 0 : 0) {
                    j = T(g[a + 908 >> 2]);
                    k = T(se(a, 2));
                    k = T(j - T(k + T(te(a, 2))));
                    j = T(Oe(b, 2, d));
                    j = T(Ie(b, 2, T(k - T(j + T(_e(b, 2, d)))), d, d));
                } else j = T(t);
            } else j = T(n + T(be(c[b + 992 >> 2] | 0, d)));
            if (!(ae(b, 0, f) | 0)) {
                if (Ne(b, 0) | 0 ? Ze(b, 0) | 0 : 0) {
                    k = T(g[a + 912 >> 2]);
                    v = T(se(a, 0));
                    v = T(k - T(v + T(te(a, 0))));
                    k = T(Oe(b, 0, f));
                    k = T(Ie(b, 0, T(v - T(k + T(_e(b, 0, f)))), f, d));
                } else k = T(t);
            } else k = T(o + T(be(c[b + 996 >> 2] | 0, f)));
            l = Sb(j) | 0;
            m = Sb(k) | 0;
            do if (l ^ m ? (p = T(g[b + 396 >> 2]), !(Sb(p) | 0)) : 0) {
                if (l) {
                    j = T(n + T(T(k - o) * p));
                    break;
                } else {
                    v = T(o + T(T(j - n) / p));
                    k = m ? v : k;
                    break;
                }
            }
            while (0);
            m = Sb(j) | 0;
            l = Sb(k) | 0;
            if (m | l) {
                w = (m ^ 1) & 1;
                e = d > T(0.0) & ((e | 0) != 0 & m);
                j = r ? j : e ? d : j;
                Td(b, j, k, h, r ? w : e ? 2 : w, m & (l ^ 1) & 1, j, k, 0, 3623, i);
                j = T(g[b + 908 >> 2]);
                j = T(j + T(Ud(b, 2, d)));
                k = T(g[b + 912 >> 2]);
                k = T(k + T(Ud(b, 0, d)));
            }
            Td(b, j, k, h, 1, 1, j, k, 1, 3635, i);
            if (Ze(b, s) | 0 ? !(Ne(b, s) | 0) : 0) {
                w = c[976 + (s << 2) >> 2] | 0;
                v = T(g[a + 908 + (w << 2) >> 2]);
                v = T(v - T(g[b + 908 + (w << 2) >> 2]));
                v = T(v - T(te(a, s)));
                v = T(v - T(ne(b, s, d)));
                v = T(v - T(_e(b, s, r ? d : f)));
                g[b + 400 + (c[1040 + (s << 2) >> 2] << 2) >> 2] = v;
            } else u = 21;
            do if ((u | 0) == 21) {
                if (!(Ne(b, s) | 0) ? (c[a + 8 >> 2] | 0) == 1 : 0) {
                    w = c[976 + (s << 2) >> 2] | 0;
                    v = T(g[a + 908 + (w << 2) >> 2]);
                    v = T(T(v - T(g[b + 908 + (w << 2) >> 2])) * T(.5));
                    g[b + 400 + (c[1040 + (s << 2) >> 2] << 2) >> 2] = v;
                    break;
                }
                if (!(Ne(b, s) | 0) ? (c[a + 8 >> 2] | 0) == 2 : 0) {
                    w = c[976 + (s << 2) >> 2] | 0;
                    v = T(g[a + 908 + (w << 2) >> 2]);
                    v = T(v - T(g[b + 908 + (w << 2) >> 2]));
                    g[b + 400 + (c[1040 + (s << 2) >> 2] << 2) >> 2] = v;
                }
            }
            while (0);
            if (Ze(b, q) | 0 ? !(Ne(b, q) | 0) : 0) {
                w = c[976 + (q << 2) >> 2] | 0;
                v = T(g[a + 908 + (w << 2) >> 2]);
                v = T(v - T(g[b + 908 + (w << 2) >> 2]));
                v = T(v - T(te(a, q)));
                v = T(v - T(ne(b, q, d)));
                v = T(v - T(_e(b, q, r ? f : d)));
                g[b + 400 + (c[1040 + (q << 2) >> 2] << 2) >> 2] = v;
            } else u = 30;
            do if ((u | 0) == 30 ? !(Ne(b, q) | 0) : 0) {
                if ((Je(a, b) | 0) == 2) {
                    w = c[976 + (q << 2) >> 2] | 0;
                    v = T(g[a + 908 + (w << 2) >> 2]);
                    v = T(T(v - T(g[b + 908 + (w << 2) >> 2])) * T(.5));
                    g[b + 400 + (c[1040 + (q << 2) >> 2] << 2) >> 2] = v;
                    break;
                }
                w = (Je(a, b) | 0) == 3;
                if (w ^ (c[a + 28 >> 2] | 0) == 2) {
                    w = c[976 + (q << 2) >> 2] | 0;
                    v = T(g[a + 908 + (w << 2) >> 2]);
                    v = T(v - T(g[b + 908 + (w << 2) >> 2]));
                    g[b + 400 + (c[1040 + (q << 2) >> 2] << 2) >> 2] = v;
                }
            }
            while (0);
            return;
        }
        function Ve(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = ib, f = 0;
            f = c[976 + (d << 2) >> 2] | 0;
            e = T(g[b + 908 + (f << 2) >> 2]);
            e = T(T(g[a + 908 + (f << 2) >> 2]) - e);
            e = T(e - T(g[b + 400 + (c[1040 + (d << 2) >> 2] << 2) >> 2]));
            g[b + 400 + (c[1e3 + (d << 2) >> 2] << 2) >> 2] = e;
            return;
        }
        function We(a) {
            a = a | 0;
            return (a | 1) == 1 | 0;
        }
        function Xe(b) {
            b = b | 0;
            var d = ib;
            switch(c[b + 56 >> 2] | 0){
                case 0:
                case 3:
                    d = T(g[b + 40 >> 2]);
                    if (d > T(0.0) & ((Sb(d) | 0) ^ 1)) b = a[(c[b + 976 >> 2] | 0) + 2 >> 0] | 0 ? 1056 : 992;
                    else b = 1056;
                    break;
                default:
                    b = b + 52 | 0;
            }
            return b | 0;
        }
        function Ye(b, c) {
            b = b | 0;
            c = c | 0;
            return (a[b + c >> 0] | 0) != 0 | 0;
        }
        function Ze(a, b) {
            a = a | 0;
            b = b | 0;
            a = a + 132 | 0;
            if (oe(b) | 0 ? (c[(Tb(a, 5, 948) | 0) + 4 >> 2] | 0) != 0 : 0) a = 1;
            else a = (c[(Tb(a, c[1e3 + (b << 2) >> 2] | 0, 948) | 0) + 4 >> 2] | 0) != 0;
            return a | 0;
        }
        function _e(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = T(d);
            var e = 0, f = 0;
            a = a + 132 | 0;
            if (oe(b) | 0 ? (e = Tb(a, 5, 948) | 0, (c[e + 4 >> 2] | 0) != 0) : 0) f = 4;
            else {
                e = Tb(a, c[1e3 + (b << 2) >> 2] | 0, 948) | 0;
                if (!(c[e + 4 >> 2] | 0)) d = T(0.0);
                else f = 4;
            }
            if ((f | 0) == 4) d = T(be(e, d));
            return T(d);
        }
        function $e(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            if (Ne(a, b) | 0) c = T(Oe(a, b, c));
            else c = T(-T(_e(a, b, c)));
            return T(c);
        }
        function af(a) {
            a = T(a);
            return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
        }
        function bf(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 1073741823) Ta();
                else {
                    f = qC(b << 2) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 2) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 2);
            return;
        }
        function cf(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 2) << 2) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function df(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -4 - b | 0) >>> 2) << 2);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function ef(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = a + 4 | 0;
            i = c[h >> 2] | 0;
            f = i - e | 0;
            g = f >> 2;
            a = b + (g << 2) | 0;
            if (a >>> 0 < d >>> 0) {
                e = i;
                do {
                    c[e >> 2] = c[a >> 2];
                    a = a + 4 | 0;
                    e = (c[h >> 2] | 0) + 4 | 0;
                    c[h >> 2] = e;
                }while (a >>> 0 < d >>> 0);
            }
            if (g | 0) GC(i + (0 - g << 2) | 0, b | 0, f | 0);
            return;
        }
        function ff(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = b + 4 | 0;
            j = c[i >> 2] | 0;
            f = c[a >> 2] | 0;
            h = d;
            g = h - f | 0;
            e = j + (0 - (g >> 2) << 2) | 0;
            c[i >> 2] = e;
            if ((g | 0) > 0) BC(e | 0, f | 0, g | 0);
            f = a + 4 | 0;
            g = b + 8 | 0;
            e = (c[f >> 2] | 0) - h | 0;
            if ((e | 0) > 0) {
                BC(c[g >> 2] | 0, d | 0, e | 0);
                c[g >> 2] = (c[g >> 2] | 0) + (e >>> 2 << 2);
            }
            h = c[a >> 2] | 0;
            c[a >> 2] = c[i >> 2];
            c[i >> 2] = h;
            h = c[f >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[g >> 2] = h;
            h = a + 8 | 0;
            d = b + 12 | 0;
            a = c[h >> 2] | 0;
            c[h >> 2] = c[d >> 2];
            c[d >> 2] = a;
            c[b >> 2] = c[i >> 2];
            return j | 0;
        }
        function gf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            h = c[b >> 2] | 0;
            g = c[d >> 2] | 0;
            if ((h | 0) != (g | 0)) {
                f = a + 8 | 0;
                d = ((g + -4 - h | 0) >>> 2) + 1 | 0;
                a = h;
                e = c[f >> 2] | 0;
                do {
                    c[e >> 2] = c[a >> 2];
                    e = (c[f >> 2] | 0) + 4 | 0;
                    c[f >> 2] = e;
                    a = a + 4 | 0;
                }while ((a | 0) != (g | 0));
                c[b >> 2] = h + (d << 2);
            }
            return;
        }
        function hf() {
            Qb();
            return;
        }
        function jf() {
            var a = 0;
            a = qC(4) | 0;
            kf(a);
            return a | 0;
        }
        function kf(a) {
            a = a | 0;
            c[a >> 2] = gc() | 0;
            return;
        }
        function lf(a) {
            a = a | 0;
            if (a | 0) {
                mf(a);
                sC(a);
            }
            return;
        }
        function mf(a) {
            a = a | 0;
            ic(c[a >> 2] | 0);
            return;
        }
        function nf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            he(c[a >> 2] | 0, b, d);
            return;
        }
        function of(a, b) {
            a = a | 0;
            b = T(b);
            Zd(c[a >> 2] | 0, b);
            return;
        }
        function pf(a, b) {
            a = a | 0;
            b = b | 0;
            return Ye(c[a >> 2] | 0, b) | 0;
        }
        function qf() {
            var a = 0;
            a = qC(8) | 0;
            rf(a, 0);
            return a | 0;
        }
        function rf(a, b) {
            a = a | 0;
            b = b | 0;
            if (!b) b = Wb() | 0;
            else b = Ub(c[b >> 2] | 0) | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = 0;
            vc(b, a);
            return;
        }
        function sf(a) {
            a = a | 0;
            var b = 0;
            b = qC(8) | 0;
            rf(b, a);
            return b | 0;
        }
        function tf(a) {
            a = a | 0;
            if (a | 0) {
                uf(a);
                sC(a);
            }
            return;
        }
        function uf(a) {
            a = a | 0;
            var b = 0;
            Zb(c[a >> 2] | 0);
            b = a + 4 | 0;
            a = c[b >> 2] | 0;
            c[b >> 2] = 0;
            if (a | 0) {
                vf(a);
                sC(a);
            }
            return;
        }
        function vf(a) {
            a = a | 0;
            wf(a);
            return;
        }
        function wf(a) {
            a = a | 0;
            a = c[a >> 2] | 0;
            if (a | 0) ab(a | 0);
            return;
        }
        function xf(a) {
            a = a | 0;
            return wc(a) | 0;
        }
        function yf(a) {
            a = a | 0;
            var b = 0, d = 0;
            d = a + 4 | 0;
            b = c[d >> 2] | 0;
            c[d >> 2] = 0;
            if (b | 0) {
                vf(b);
                sC(b);
            }
            dc(c[a >> 2] | 0);
            return;
        }
        function zf(a, b) {
            a = a | 0;
            b = b | 0;
            sc(c[a >> 2] | 0, c[b >> 2] | 0);
            return;
        }
        function Af(a, b) {
            a = a | 0;
            b = b | 0;
            Hc(c[a >> 2] | 0, b);
            return;
        }
        function Bf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            Vc(c[a >> 2] | 0, b, T(d));
            return;
        }
        function Cf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            Wc(c[a >> 2] | 0, b, T(d));
            return;
        }
        function Df(a, b) {
            a = a | 0;
            b = b | 0;
            Bc(c[a >> 2] | 0, b);
            return;
        }
        function Ef(a, b) {
            a = a | 0;
            b = b | 0;
            Dc(c[a >> 2] | 0, b);
            return;
        }
        function Ff(a, b) {
            a = a | 0;
            b = b | 0;
            Fc(c[a >> 2] | 0, b);
            return;
        }
        function Gf(a, b) {
            a = a | 0;
            b = b | 0;
            xc(c[a >> 2] | 0, b);
            return;
        }
        function Hf(a, b) {
            a = a | 0;
            b = b | 0;
            Jc(c[a >> 2] | 0, b);
            return;
        }
        function If(a, b) {
            a = a | 0;
            b = b | 0;
            zc(c[a >> 2] | 0, b);
            return;
        }
        function Jf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            Yc(c[a >> 2] | 0, b, T(d));
            return;
        }
        function Kf(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            Zc(c[a >> 2] | 0, b, T(d));
            return;
        }
        function Lf(a, b) {
            a = a | 0;
            b = b | 0;
            $c(c[a >> 2] | 0, b);
            return;
        }
        function Mf(a, b) {
            a = a | 0;
            b = b | 0;
            Lc(c[a >> 2] | 0, b);
            return;
        }
        function Nf(a, b) {
            a = a | 0;
            b = b | 0;
            Nc(c[a >> 2] | 0, b);
            return;
        }
        function Of(a, b) {
            a = a | 0;
            b = +b;
            Pc(c[a >> 2] | 0, T(b));
            return;
        }
        function Pf(a, b) {
            a = a | 0;
            b = +b;
            Sc(c[a >> 2] | 0, T(b));
            return;
        }
        function Qf(a, b) {
            a = a | 0;
            b = +b;
            Tc(c[a >> 2] | 0, T(b));
            return;
        }
        function Rf(a, b) {
            a = a | 0;
            b = +b;
            Qc(c[a >> 2] | 0, T(b));
            return;
        }
        function Sf(a, b) {
            a = a | 0;
            b = +b;
            Rc(c[a >> 2] | 0, T(b));
            return;
        }
        function Tf(a, b) {
            a = a | 0;
            b = +b;
            fd(c[a >> 2] | 0, T(b));
            return;
        }
        function Uf(a, b) {
            a = a | 0;
            b = +b;
            gd(c[a >> 2] | 0, T(b));
            return;
        }
        function Vf(a) {
            a = a | 0;
            hd(c[a >> 2] | 0);
            return;
        }
        function Wf(a, b) {
            a = a | 0;
            b = +b;
            jd(c[a >> 2] | 0, T(b));
            return;
        }
        function Xf(a, b) {
            a = a | 0;
            b = +b;
            kd(c[a >> 2] | 0, T(b));
            return;
        }
        function Yf(a) {
            a = a | 0;
            ld(c[a >> 2] | 0);
            return;
        }
        function Zf(a, b) {
            a = a | 0;
            b = +b;
            nd(c[a >> 2] | 0, T(b));
            return;
        }
        function _f(a, b) {
            a = a | 0;
            b = +b;
            od(c[a >> 2] | 0, T(b));
            return;
        }
        function $f(a, b) {
            a = a | 0;
            b = +b;
            qd(c[a >> 2] | 0, T(b));
            return;
        }
        function ag(a, b) {
            a = a | 0;
            b = +b;
            rd(c[a >> 2] | 0, T(b));
            return;
        }
        function bg(a, b) {
            a = a | 0;
            b = +b;
            td(c[a >> 2] | 0, T(b));
            return;
        }
        function cg(a, b) {
            a = a | 0;
            b = +b;
            ud(c[a >> 2] | 0, T(b));
            return;
        }
        function dg(a, b) {
            a = a | 0;
            b = +b;
            wd(c[a >> 2] | 0, T(b));
            return;
        }
        function eg(a, b) {
            a = a | 0;
            b = +b;
            xd(c[a >> 2] | 0, T(b));
            return;
        }
        function fg(a, b) {
            a = a | 0;
            b = +b;
            zd(c[a >> 2] | 0, T(b));
            return;
        }
        function gg(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            dd(c[a >> 2] | 0, b, T(d));
            return;
        }
        function hg(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            ad(c[a >> 2] | 0, b, T(d));
            return;
        }
        function ig(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            bd(c[a >> 2] | 0, b, T(d));
            return;
        }
        function jg(a) {
            a = a | 0;
            return Ic(c[a >> 2] | 0) | 0;
        }
        function kg(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = l;
            l = l + 16 | 0;
            f = e;
            Xc(f, c[b >> 2] | 0, d);
            lg(a, f);
            l = e;
            return;
        }
        function lg(a, b) {
            a = a | 0;
            b = b | 0;
            mg(a, c[b + 4 >> 2] | 0, +T(g[b >> 2]));
            return;
        }
        function mg(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            c[a >> 2] = b;
            h[a + 8 >> 3] = d;
            return;
        }
        function ng(a) {
            a = a | 0;
            return Cc(c[a >> 2] | 0) | 0;
        }
        function og(a) {
            a = a | 0;
            return Ec(c[a >> 2] | 0) | 0;
        }
        function pg(a) {
            a = a | 0;
            return Gc(c[a >> 2] | 0) | 0;
        }
        function qg(a) {
            a = a | 0;
            return yc(c[a >> 2] | 0) | 0;
        }
        function rg(a) {
            a = a | 0;
            return Kc(c[a >> 2] | 0) | 0;
        }
        function sg(a) {
            a = a | 0;
            return Ac(c[a >> 2] | 0) | 0;
        }
        function tg(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = l;
            l = l + 16 | 0;
            f = e;
            _c(f, c[b >> 2] | 0, d);
            lg(a, f);
            l = e;
            return;
        }
        function ug(a) {
            a = a | 0;
            return Mc(c[a >> 2] | 0) | 0;
        }
        function vg(a) {
            a = a | 0;
            return Oc(c[a >> 2] | 0) | 0;
        }
        function wg(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            Uc(e, c[b >> 2] | 0);
            lg(a, e);
            l = d;
            return;
        }
        function xg(a) {
            a = a | 0;
            return + +T(tc(c[a >> 2] | 0));
        }
        function yg(a) {
            a = a | 0;
            return + +T(uc(c[a >> 2] | 0));
        }
        function zg(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            id(e, c[b >> 2] | 0);
            lg(a, e);
            l = d;
            return;
        }
        function Ag(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            md(e, c[b >> 2] | 0);
            lg(a, e);
            l = d;
            return;
        }
        function Bg(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            pd(e, c[b >> 2] | 0);
            lg(a, e);
            l = d;
            return;
        }
        function Cg(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            sd(e, c[b >> 2] | 0);
            lg(a, e);
            l = d;
            return;
        }
        function Dg(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            vd(e, c[b >> 2] | 0);
            lg(a, e);
            l = d;
            return;
        }
        function Eg(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            yd(e, c[b >> 2] | 0);
            lg(a, e);
            l = d;
            return;
        }
        function Fg(a) {
            a = a | 0;
            return + +T(Ad(c[a >> 2] | 0));
        }
        function Gg(a, b) {
            a = a | 0;
            b = b | 0;
            return + +T(ed(c[a >> 2] | 0, b));
        }
        function Hg(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = l;
            l = l + 16 | 0;
            f = e;
            cd(f, c[b >> 2] | 0, d);
            lg(a, f);
            l = e;
            return;
        }
        function Ig(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            kc(c[a >> 2] | 0, c[b >> 2] | 0, d);
            return;
        }
        function Jg(a, b) {
            a = a | 0;
            b = b | 0;
            cc(c[a >> 2] | 0, c[b >> 2] | 0);
            return;
        }
        function Kg(a) {
            a = a | 0;
            return $b(c[a >> 2] | 0) | 0;
        }
        function Lg(a) {
            a = a | 0;
            a = pc(c[a >> 2] | 0) | 0;
            if (!a) a = 0;
            else a = xf(a) | 0;
            return a | 0;
        }
        function Mg(a, b) {
            a = a | 0;
            b = b | 0;
            a = ac(c[a >> 2] | 0, b) | 0;
            if (!a) a = 0;
            else a = xf(a) | 0;
            return a | 0;
        }
        function Ng(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            e = qC(4) | 0;
            Og(e, b);
            d = a + 4 | 0;
            b = c[d >> 2] | 0;
            c[d >> 2] = e;
            if (b | 0) {
                vf(b);
                sC(b);
            }
            jc(c[a >> 2] | 0, 1);
            return;
        }
        function Og(a, b) {
            a = a | 0;
            b = b | 0;
            gh(a, b);
            return;
        }
        function Pg(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            d = d | 0;
            e = T(e);
            f = f | 0;
            var i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            j = i;
            Qg(j, wc(b) | 0, +c, d, +e, f);
            g[a >> 2] = T(+h[j >> 3]);
            g[a + 4 >> 2] = T(+h[j + 8 >> 3]);
            l = i;
            return;
        }
        function Qg(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = +d;
            e = e | 0;
            f = +f;
            g = g | 0;
            var i = 0, j = 0, k = 0, m = 0, n = 0;
            i = l;
            l = l + 32 | 0;
            n = i + 8 | 0;
            m = i + 20 | 0;
            k = i;
            j = i + 16 | 0;
            h[n >> 3] = d;
            c[m >> 2] = e;
            h[k >> 3] = f;
            c[j >> 2] = g;
            Rg(a, c[b + 4 >> 2] | 0, n, m, k, j);
            l = i;
            return;
        }
        function Rg(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            j = i;
            UA(j);
            b = Sg(b) | 0;
            Tg(a, b, +h[d >> 3], c[e >> 2] | 0, +h[f >> 3], c[g >> 2] | 0);
            WA(j);
            l = i;
            return;
        }
        function Sg(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function Tg(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = +c;
            d = d | 0;
            e = +e;
            f = f | 0;
            var g = 0;
            g = Vg(Ug() | 0) | 0;
            c = +Wg(c);
            d = Xg(d) | 0;
            e = +Wg(e);
            Yg(a, cb(0, g | 0, b | 0, +c, d | 0, +e, Xg(f) | 0) | 0);
            return;
        }
        function Ug() {
            var b = 0;
            if (!(a[7608] | 0)) {
                dh(9120);
                b = 7608;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 9120;
        }
        function Vg(a) {
            a = a | 0;
            return c[a + 8 >> 2] | 0;
        }
        function Wg(a) {
            a = +a;
            return + +ch(a);
        }
        function Xg(a) {
            a = a | 0;
            return bh(a) | 0;
        }
        function Yg(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            f = l;
            l = l + 32 | 0;
            d = f;
            e = b;
            if (!(e & 1)) {
                c[a >> 2] = c[b >> 2];
                c[a + 4 >> 2] = c[b + 4 >> 2];
                c[a + 8 >> 2] = c[b + 8 >> 2];
                c[a + 12 >> 2] = c[b + 12 >> 2];
            } else {
                Zg(d, 0);
                Ja(e | 0, d | 0);
                _g(a, d);
                $g(d);
            }
            l = f;
            return;
        }
        function Zg(b, d) {
            b = b | 0;
            d = d | 0;
            ah(b, d);
            c[b + 8 >> 2] = 0;
            a[b + 24 >> 0] = 0;
            return;
        }
        function _g(a, b) {
            a = a | 0;
            b = b | 0;
            b = b + 8 | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = c[b + 4 >> 2];
            c[a + 8 >> 2] = c[b + 8 >> 2];
            c[a + 12 >> 2] = c[b + 12 >> 2];
            return;
        }
        function $g(b) {
            b = b | 0;
            a[b + 24 >> 0] = 0;
            return;
        }
        function ah(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = b;
            return;
        }
        function bh(a) {
            a = a | 0;
            return a | 0;
        }
        function ch(a) {
            a = +a;
            return +a;
        }
        function dh(a) {
            a = a | 0;
            fh(a, eh() | 0, 4);
            return;
        }
        function eh() {
            return 1064;
        }
        function fh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            c[a + 8 >> 2] = _a(b | 0, d + 1 | 0) | 0;
            return;
        }
        function gh(a, b) {
            a = a | 0;
            b = b | 0;
            b = c[b >> 2] | 0;
            c[a >> 2] = b;
            Aa(b | 0);
            return;
        }
        function hh(a) {
            a = a | 0;
            var b = 0, d = 0;
            d = a + 4 | 0;
            b = c[d >> 2] | 0;
            c[d >> 2] = 0;
            if (b | 0) {
                vf(b);
                sC(b);
            }
            jc(c[a >> 2] | 0, 0);
            return;
        }
        function ih(a) {
            a = a | 0;
            qc(c[a >> 2] | 0);
            return;
        }
        function jh(a) {
            a = a | 0;
            return rc(c[a >> 2] | 0) | 0;
        }
        function kh(a, b, d, e) {
            a = a | 0;
            b = +b;
            d = +d;
            e = e | 0;
            _d(c[a >> 2] | 0, T(b), T(d), e);
            return;
        }
        function lh(a) {
            a = a | 0;
            return + +T(Bd(c[a >> 2] | 0));
        }
        function mh(a) {
            a = a | 0;
            return + +T(Dd(c[a >> 2] | 0));
        }
        function nh(a) {
            a = a | 0;
            return + +T(Cd(c[a >> 2] | 0));
        }
        function oh(a) {
            a = a | 0;
            return + +T(Ed(c[a >> 2] | 0));
        }
        function ph(a) {
            a = a | 0;
            return + +T(Fd(c[a >> 2] | 0));
        }
        function qh(a) {
            a = a | 0;
            return + +T(Gd(c[a >> 2] | 0));
        }
        function rh(a, b) {
            a = a | 0;
            b = b | 0;
            h[a >> 3] = +T(Bd(c[b >> 2] | 0));
            h[a + 8 >> 3] = +T(Dd(c[b >> 2] | 0));
            h[a + 16 >> 3] = +T(Cd(c[b >> 2] | 0));
            h[a + 24 >> 3] = +T(Ed(c[b >> 2] | 0));
            h[a + 32 >> 3] = +T(Fd(c[b >> 2] | 0));
            h[a + 40 >> 3] = +T(Gd(c[b >> 2] | 0));
            return;
        }
        function sh(a, b) {
            a = a | 0;
            b = b | 0;
            return + +T(Hd(c[a >> 2] | 0, b));
        }
        function th(a, b) {
            a = a | 0;
            b = b | 0;
            return + +T(Id(c[a >> 2] | 0, b));
        }
        function uh(a, b) {
            a = a | 0;
            b = b | 0;
            return + +T(Jd(c[a >> 2] | 0, b));
        }
        function vh() {
            return fc() | 0;
        }
        function wh() {
            xh();
            yh();
            zh();
            Ah();
            Bh();
            Ch();
            return;
        }
        function xh() {
            kv(11713, 4938, 1);
            return;
        }
        function yh() {
            yu(10448);
            return;
        }
        function zh() {
            eu(10408);
            return;
        }
        function Ah() {
            vt(10324);
            return;
        }
        function Bh() {
            or(10096);
            return;
        }
        function Ch() {
            Dh(9132);
            return;
        }
        function Dh(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, A = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0, I = 0, J = 0, K = 0, L = 0, M = 0, N = 0, O = 0, P = 0, Q = 0, R = 0, S = 0, T = 0, U = 0, V = 0, W = 0, X = 0, Y = 0, Z = 0, _ = 0, $ = 0, aa = 0, ba = 0, ca = 0, da = 0, ea = 0, fa = 0, ga = 0, ha = 0, ia = 0, ja = 0, ka = 0, la = 0, ma = 0, na = 0, oa = 0, pa = 0, qa = 0, ra = 0, sa = 0, ta = 0, ua = 0, va = 0, wa = 0, xa = 0, ya = 0, za = 0, Aa = 0, Ba = 0, Ca = 0, Da = 0, Ea = 0, Fa = 0, Ga = 0;
            b = l;
            l = l + 672 | 0;
            d = b + 656 | 0;
            Ga = b + 648 | 0;
            Fa = b + 640 | 0;
            Ea = b + 632 | 0;
            Da = b + 624 | 0;
            Ca = b + 616 | 0;
            Ba = b + 608 | 0;
            Aa = b + 600 | 0;
            za = b + 592 | 0;
            ya = b + 584 | 0;
            xa = b + 576 | 0;
            wa = b + 568 | 0;
            va = b + 560 | 0;
            ua = b + 552 | 0;
            ta = b + 544 | 0;
            sa = b + 536 | 0;
            ra = b + 528 | 0;
            qa = b + 520 | 0;
            pa = b + 512 | 0;
            oa = b + 504 | 0;
            na = b + 496 | 0;
            ma = b + 488 | 0;
            la = b + 480 | 0;
            ka = b + 472 | 0;
            ja = b + 464 | 0;
            ia = b + 456 | 0;
            ha = b + 448 | 0;
            ga = b + 440 | 0;
            fa = b + 432 | 0;
            ea = b + 424 | 0;
            da = b + 416 | 0;
            ca = b + 408 | 0;
            ba = b + 400 | 0;
            aa = b + 392 | 0;
            $ = b + 384 | 0;
            _ = b + 376 | 0;
            Z = b + 368 | 0;
            Y = b + 360 | 0;
            X = b + 352 | 0;
            W = b + 344 | 0;
            V = b + 336 | 0;
            U = b + 328 | 0;
            T = b + 320 | 0;
            S = b + 312 | 0;
            R = b + 304 | 0;
            Q = b + 296 | 0;
            P = b + 288 | 0;
            O = b + 280 | 0;
            N = b + 272 | 0;
            M = b + 264 | 0;
            L = b + 256 | 0;
            K = b + 248 | 0;
            J = b + 240 | 0;
            I = b + 232 | 0;
            H = b + 224 | 0;
            G = b + 216 | 0;
            F = b + 208 | 0;
            E = b + 200 | 0;
            D = b + 192 | 0;
            C = b + 184 | 0;
            B = b + 176 | 0;
            A = b + 168 | 0;
            z = b + 160 | 0;
            y = b + 152 | 0;
            x = b + 144 | 0;
            w = b + 136 | 0;
            v = b + 128 | 0;
            u = b + 120 | 0;
            t = b + 112 | 0;
            s = b + 104 | 0;
            r = b + 96 | 0;
            q = b + 88 | 0;
            p = b + 80 | 0;
            o = b + 72 | 0;
            n = b + 64 | 0;
            m = b + 56 | 0;
            k = b + 48 | 0;
            j = b + 40 | 0;
            i = b + 32 | 0;
            h = b + 24 | 0;
            g = b + 16 | 0;
            f = b + 8 | 0;
            e = b;
            Eh(a, 3646);
            Fh(a, 3651, 2);
            Gh(a, 3665, 2);
            Hh(a, 3682, 18);
            c[Ga >> 2] = 19;
            c[Ga + 4 >> 2] = 0;
            c[d >> 2] = c[Ga >> 2];
            c[d + 4 >> 2] = c[Ga + 4 >> 2];
            Ih(a, 3690, d);
            c[Fa >> 2] = 1;
            c[Fa + 4 >> 2] = 0;
            c[d >> 2] = c[Fa >> 2];
            c[d + 4 >> 2] = c[Fa + 4 >> 2];
            Jh(a, 3696, d);
            c[Ea >> 2] = 2;
            c[Ea + 4 >> 2] = 0;
            c[d >> 2] = c[Ea >> 2];
            c[d + 4 >> 2] = c[Ea + 4 >> 2];
            Kh(a, 3706, d);
            c[Da >> 2] = 1;
            c[Da + 4 >> 2] = 0;
            c[d >> 2] = c[Da >> 2];
            c[d + 4 >> 2] = c[Da + 4 >> 2];
            Lh(a, 3722, d);
            c[Ca >> 2] = 2;
            c[Ca + 4 >> 2] = 0;
            c[d >> 2] = c[Ca >> 2];
            c[d + 4 >> 2] = c[Ca + 4 >> 2];
            Lh(a, 3734, d);
            c[Ba >> 2] = 3;
            c[Ba + 4 >> 2] = 0;
            c[d >> 2] = c[Ba >> 2];
            c[d + 4 >> 2] = c[Ba + 4 >> 2];
            Kh(a, 3753, d);
            c[Aa >> 2] = 4;
            c[Aa + 4 >> 2] = 0;
            c[d >> 2] = c[Aa >> 2];
            c[d + 4 >> 2] = c[Aa + 4 >> 2];
            Kh(a, 3769, d);
            c[za >> 2] = 5;
            c[za + 4 >> 2] = 0;
            c[d >> 2] = c[za >> 2];
            c[d + 4 >> 2] = c[za + 4 >> 2];
            Kh(a, 3783, d);
            c[ya >> 2] = 6;
            c[ya + 4 >> 2] = 0;
            c[d >> 2] = c[ya >> 2];
            c[d + 4 >> 2] = c[ya + 4 >> 2];
            Kh(a, 3796, d);
            c[xa >> 2] = 7;
            c[xa + 4 >> 2] = 0;
            c[d >> 2] = c[xa >> 2];
            c[d + 4 >> 2] = c[xa + 4 >> 2];
            Kh(a, 3813, d);
            c[wa >> 2] = 8;
            c[wa + 4 >> 2] = 0;
            c[d >> 2] = c[wa >> 2];
            c[d + 4 >> 2] = c[wa + 4 >> 2];
            Kh(a, 3825, d);
            c[va >> 2] = 3;
            c[va + 4 >> 2] = 0;
            c[d >> 2] = c[va >> 2];
            c[d + 4 >> 2] = c[va + 4 >> 2];
            Lh(a, 3843, d);
            c[ua >> 2] = 4;
            c[ua + 4 >> 2] = 0;
            c[d >> 2] = c[ua >> 2];
            c[d + 4 >> 2] = c[ua + 4 >> 2];
            Lh(a, 3853, d);
            c[ta >> 2] = 9;
            c[ta + 4 >> 2] = 0;
            c[d >> 2] = c[ta >> 2];
            c[d + 4 >> 2] = c[ta + 4 >> 2];
            Kh(a, 3870, d);
            c[sa >> 2] = 10;
            c[sa + 4 >> 2] = 0;
            c[d >> 2] = c[sa >> 2];
            c[d + 4 >> 2] = c[sa + 4 >> 2];
            Kh(a, 3884, d);
            c[ra >> 2] = 11;
            c[ra + 4 >> 2] = 0;
            c[d >> 2] = c[ra >> 2];
            c[d + 4 >> 2] = c[ra + 4 >> 2];
            Kh(a, 3896, d);
            c[qa >> 2] = 1;
            c[qa + 4 >> 2] = 0;
            c[d >> 2] = c[qa >> 2];
            c[d + 4 >> 2] = c[qa + 4 >> 2];
            Mh(a, 3907, d);
            c[pa >> 2] = 2;
            c[pa + 4 >> 2] = 0;
            c[d >> 2] = c[pa >> 2];
            c[d + 4 >> 2] = c[pa + 4 >> 2];
            Mh(a, 3915, d);
            c[oa >> 2] = 3;
            c[oa + 4 >> 2] = 0;
            c[d >> 2] = c[oa >> 2];
            c[d + 4 >> 2] = c[oa + 4 >> 2];
            Mh(a, 3928, d);
            c[na >> 2] = 4;
            c[na + 4 >> 2] = 0;
            c[d >> 2] = c[na >> 2];
            c[d + 4 >> 2] = c[na + 4 >> 2];
            Mh(a, 3948, d);
            c[ma >> 2] = 5;
            c[ma + 4 >> 2] = 0;
            c[d >> 2] = c[ma >> 2];
            c[d + 4 >> 2] = c[ma + 4 >> 2];
            Mh(a, 3960, d);
            c[la >> 2] = 6;
            c[la + 4 >> 2] = 0;
            c[d >> 2] = c[la >> 2];
            c[d + 4 >> 2] = c[la + 4 >> 2];
            Mh(a, 3974, d);
            c[ka >> 2] = 7;
            c[ka + 4 >> 2] = 0;
            c[d >> 2] = c[ka >> 2];
            c[d + 4 >> 2] = c[ka + 4 >> 2];
            Mh(a, 3983, d);
            c[ja >> 2] = 20;
            c[ja + 4 >> 2] = 0;
            c[d >> 2] = c[ja >> 2];
            c[d + 4 >> 2] = c[ja + 4 >> 2];
            Ih(a, 3999, d);
            c[ia >> 2] = 8;
            c[ia + 4 >> 2] = 0;
            c[d >> 2] = c[ia >> 2];
            c[d + 4 >> 2] = c[ia + 4 >> 2];
            Mh(a, 4012, d);
            c[ha >> 2] = 9;
            c[ha + 4 >> 2] = 0;
            c[d >> 2] = c[ha >> 2];
            c[d + 4 >> 2] = c[ha + 4 >> 2];
            Mh(a, 4022, d);
            c[ga >> 2] = 21;
            c[ga + 4 >> 2] = 0;
            c[d >> 2] = c[ga >> 2];
            c[d + 4 >> 2] = c[ga + 4 >> 2];
            Ih(a, 4039, d);
            c[fa >> 2] = 10;
            c[fa + 4 >> 2] = 0;
            c[d >> 2] = c[fa >> 2];
            c[d + 4 >> 2] = c[fa + 4 >> 2];
            Mh(a, 4053, d);
            c[ea >> 2] = 11;
            c[ea + 4 >> 2] = 0;
            c[d >> 2] = c[ea >> 2];
            c[d + 4 >> 2] = c[ea + 4 >> 2];
            Mh(a, 4065, d);
            c[da >> 2] = 12;
            c[da + 4 >> 2] = 0;
            c[d >> 2] = c[da >> 2];
            c[d + 4 >> 2] = c[da + 4 >> 2];
            Mh(a, 4084, d);
            c[ca >> 2] = 13;
            c[ca + 4 >> 2] = 0;
            c[d >> 2] = c[ca >> 2];
            c[d + 4 >> 2] = c[ca + 4 >> 2];
            Mh(a, 4097, d);
            c[ba >> 2] = 14;
            c[ba + 4 >> 2] = 0;
            c[d >> 2] = c[ba >> 2];
            c[d + 4 >> 2] = c[ba + 4 >> 2];
            Mh(a, 4117, d);
            c[aa >> 2] = 15;
            c[aa + 4 >> 2] = 0;
            c[d >> 2] = c[aa >> 2];
            c[d + 4 >> 2] = c[aa + 4 >> 2];
            Mh(a, 4129, d);
            c[$ >> 2] = 16;
            c[$ + 4 >> 2] = 0;
            c[d >> 2] = c[$ >> 2];
            c[d + 4 >> 2] = c[$ + 4 >> 2];
            Mh(a, 4148, d);
            c[_ >> 2] = 17;
            c[_ + 4 >> 2] = 0;
            c[d >> 2] = c[_ >> 2];
            c[d + 4 >> 2] = c[_ + 4 >> 2];
            Mh(a, 4161, d);
            c[Z >> 2] = 18;
            c[Z + 4 >> 2] = 0;
            c[d >> 2] = c[Z >> 2];
            c[d + 4 >> 2] = c[Z + 4 >> 2];
            Mh(a, 4181, d);
            c[Y >> 2] = 5;
            c[Y + 4 >> 2] = 0;
            c[d >> 2] = c[Y >> 2];
            c[d + 4 >> 2] = c[Y + 4 >> 2];
            Lh(a, 4196, d);
            c[X >> 2] = 6;
            c[X + 4 >> 2] = 0;
            c[d >> 2] = c[X >> 2];
            c[d + 4 >> 2] = c[X + 4 >> 2];
            Lh(a, 4206, d);
            c[W >> 2] = 7;
            c[W + 4 >> 2] = 0;
            c[d >> 2] = c[W >> 2];
            c[d + 4 >> 2] = c[W + 4 >> 2];
            Lh(a, 4217, d);
            c[V >> 2] = 3;
            c[V + 4 >> 2] = 0;
            c[d >> 2] = c[V >> 2];
            c[d + 4 >> 2] = c[V + 4 >> 2];
            Nh(a, 4235, d);
            c[U >> 2] = 1;
            c[U + 4 >> 2] = 0;
            c[d >> 2] = c[U >> 2];
            c[d + 4 >> 2] = c[U + 4 >> 2];
            Oh(a, 4251, d);
            c[T >> 2] = 4;
            c[T + 4 >> 2] = 0;
            c[d >> 2] = c[T >> 2];
            c[d + 4 >> 2] = c[T + 4 >> 2];
            Nh(a, 4263, d);
            c[S >> 2] = 5;
            c[S + 4 >> 2] = 0;
            c[d >> 2] = c[S >> 2];
            c[d + 4 >> 2] = c[S + 4 >> 2];
            Nh(a, 4279, d);
            c[R >> 2] = 6;
            c[R + 4 >> 2] = 0;
            c[d >> 2] = c[R >> 2];
            c[d + 4 >> 2] = c[R + 4 >> 2];
            Nh(a, 4293, d);
            c[Q >> 2] = 7;
            c[Q + 4 >> 2] = 0;
            c[d >> 2] = c[Q >> 2];
            c[d + 4 >> 2] = c[Q + 4 >> 2];
            Nh(a, 4306, d);
            c[P >> 2] = 8;
            c[P + 4 >> 2] = 0;
            c[d >> 2] = c[P >> 2];
            c[d + 4 >> 2] = c[P + 4 >> 2];
            Nh(a, 4323, d);
            c[O >> 2] = 9;
            c[O + 4 >> 2] = 0;
            c[d >> 2] = c[O >> 2];
            c[d + 4 >> 2] = c[O + 4 >> 2];
            Nh(a, 4335, d);
            c[N >> 2] = 2;
            c[N + 4 >> 2] = 0;
            c[d >> 2] = c[N >> 2];
            c[d + 4 >> 2] = c[N + 4 >> 2];
            Oh(a, 4353, d);
            c[M >> 2] = 12;
            c[M + 4 >> 2] = 0;
            c[d >> 2] = c[M >> 2];
            c[d + 4 >> 2] = c[M + 4 >> 2];
            Ph(a, 4363, d);
            c[L >> 2] = 1;
            c[L + 4 >> 2] = 0;
            c[d >> 2] = c[L >> 2];
            c[d + 4 >> 2] = c[L + 4 >> 2];
            Qh(a, 4376, d);
            c[K >> 2] = 2;
            c[K + 4 >> 2] = 0;
            c[d >> 2] = c[K >> 2];
            c[d + 4 >> 2] = c[K + 4 >> 2];
            Qh(a, 4388, d);
            c[J >> 2] = 13;
            c[J + 4 >> 2] = 0;
            c[d >> 2] = c[J >> 2];
            c[d + 4 >> 2] = c[J + 4 >> 2];
            Ph(a, 4402, d);
            c[I >> 2] = 14;
            c[I + 4 >> 2] = 0;
            c[d >> 2] = c[I >> 2];
            c[d + 4 >> 2] = c[I + 4 >> 2];
            Ph(a, 4411, d);
            c[H >> 2] = 15;
            c[H + 4 >> 2] = 0;
            c[d >> 2] = c[H >> 2];
            c[d + 4 >> 2] = c[H + 4 >> 2];
            Ph(a, 4421, d);
            c[G >> 2] = 16;
            c[G + 4 >> 2] = 0;
            c[d >> 2] = c[G >> 2];
            c[d + 4 >> 2] = c[G + 4 >> 2];
            Ph(a, 4433, d);
            c[F >> 2] = 17;
            c[F + 4 >> 2] = 0;
            c[d >> 2] = c[F >> 2];
            c[d + 4 >> 2] = c[F + 4 >> 2];
            Ph(a, 4446, d);
            c[E >> 2] = 18;
            c[E + 4 >> 2] = 0;
            c[d >> 2] = c[E >> 2];
            c[d + 4 >> 2] = c[E + 4 >> 2];
            Ph(a, 4458, d);
            c[D >> 2] = 3;
            c[D + 4 >> 2] = 0;
            c[d >> 2] = c[D >> 2];
            c[d + 4 >> 2] = c[D + 4 >> 2];
            Qh(a, 4471, d);
            c[C >> 2] = 1;
            c[C + 4 >> 2] = 0;
            c[d >> 2] = c[C >> 2];
            c[d + 4 >> 2] = c[C + 4 >> 2];
            Rh(a, 4486, d);
            c[B >> 2] = 10;
            c[B + 4 >> 2] = 0;
            c[d >> 2] = c[B >> 2];
            c[d + 4 >> 2] = c[B + 4 >> 2];
            Nh(a, 4496, d);
            c[A >> 2] = 11;
            c[A + 4 >> 2] = 0;
            c[d >> 2] = c[A >> 2];
            c[d + 4 >> 2] = c[A + 4 >> 2];
            Nh(a, 4508, d);
            c[z >> 2] = 3;
            c[z + 4 >> 2] = 0;
            c[d >> 2] = c[z >> 2];
            c[d + 4 >> 2] = c[z + 4 >> 2];
            Oh(a, 4519, d);
            c[y >> 2] = 4;
            c[y + 4 >> 2] = 0;
            c[d >> 2] = c[y >> 2];
            c[d + 4 >> 2] = c[y + 4 >> 2];
            Sh(a, 4530, d);
            c[x >> 2] = 19;
            c[x + 4 >> 2] = 0;
            c[d >> 2] = c[x >> 2];
            c[d + 4 >> 2] = c[x + 4 >> 2];
            Th(a, 4542, d);
            c[w >> 2] = 12;
            c[w + 4 >> 2] = 0;
            c[d >> 2] = c[w >> 2];
            c[d + 4 >> 2] = c[w + 4 >> 2];
            Uh(a, 4554, d);
            c[v >> 2] = 13;
            c[v + 4 >> 2] = 0;
            c[d >> 2] = c[v >> 2];
            c[d + 4 >> 2] = c[v + 4 >> 2];
            Vh(a, 4568, d);
            c[u >> 2] = 2;
            c[u + 4 >> 2] = 0;
            c[d >> 2] = c[u >> 2];
            c[d + 4 >> 2] = c[u + 4 >> 2];
            Wh(a, 4578, d);
            c[t >> 2] = 20;
            c[t + 4 >> 2] = 0;
            c[d >> 2] = c[t >> 2];
            c[d + 4 >> 2] = c[t + 4 >> 2];
            Xh(a, 4587, d);
            c[s >> 2] = 22;
            c[s + 4 >> 2] = 0;
            c[d >> 2] = c[s >> 2];
            c[d + 4 >> 2] = c[s + 4 >> 2];
            Ih(a, 4602, d);
            c[r >> 2] = 23;
            c[r + 4 >> 2] = 0;
            c[d >> 2] = c[r >> 2];
            c[d + 4 >> 2] = c[r + 4 >> 2];
            Ih(a, 4619, d);
            c[q >> 2] = 14;
            c[q + 4 >> 2] = 0;
            c[d >> 2] = c[q >> 2];
            c[d + 4 >> 2] = c[q + 4 >> 2];
            Yh(a, 4629, d);
            c[p >> 2] = 1;
            c[p + 4 >> 2] = 0;
            c[d >> 2] = c[p >> 2];
            c[d + 4 >> 2] = c[p + 4 >> 2];
            Zh(a, 4637, d);
            c[o >> 2] = 4;
            c[o + 4 >> 2] = 0;
            c[d >> 2] = c[o >> 2];
            c[d + 4 >> 2] = c[o + 4 >> 2];
            Qh(a, 4653, d);
            c[n >> 2] = 5;
            c[n + 4 >> 2] = 0;
            c[d >> 2] = c[n >> 2];
            c[d + 4 >> 2] = c[n + 4 >> 2];
            Qh(a, 4669, d);
            c[m >> 2] = 6;
            c[m + 4 >> 2] = 0;
            c[d >> 2] = c[m >> 2];
            c[d + 4 >> 2] = c[m + 4 >> 2];
            Qh(a, 4686, d);
            c[k >> 2] = 7;
            c[k + 4 >> 2] = 0;
            c[d >> 2] = c[k >> 2];
            c[d + 4 >> 2] = c[k + 4 >> 2];
            Qh(a, 4701, d);
            c[j >> 2] = 8;
            c[j + 4 >> 2] = 0;
            c[d >> 2] = c[j >> 2];
            c[d + 4 >> 2] = c[j + 4 >> 2];
            Qh(a, 4719, d);
            c[i >> 2] = 9;
            c[i + 4 >> 2] = 0;
            c[d >> 2] = c[i >> 2];
            c[d + 4 >> 2] = c[i + 4 >> 2];
            Qh(a, 4736, d);
            c[h >> 2] = 21;
            c[h + 4 >> 2] = 0;
            c[d >> 2] = c[h >> 2];
            c[d + 4 >> 2] = c[h + 4 >> 2];
            _h(a, 4754, d);
            c[g >> 2] = 2;
            c[g + 4 >> 2] = 0;
            c[d >> 2] = c[g >> 2];
            c[d + 4 >> 2] = c[g + 4 >> 2];
            Rh(a, 4772, d);
            c[f >> 2] = 3;
            c[f + 4 >> 2] = 0;
            c[d >> 2] = c[f >> 2];
            c[d + 4 >> 2] = c[f + 4 >> 2];
            Rh(a, 4790, d);
            c[e >> 2] = 4;
            c[e + 4 >> 2] = 0;
            c[d >> 2] = c[e >> 2];
            c[d + 4 >> 2] = c[e + 4 >> 2];
            Rh(a, 4808, d);
            l = b;
            return;
        }
        function Eh(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = dr() | 0;
            c[a >> 2] = d;
            er(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function Fh(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Oq(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function Gh(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            tq(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function Hh(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            cq(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function Ih(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Lp(a, b, f);
            l = e;
            return a | 0;
        }
        function Jh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            pp(a, b, f);
            l = e;
            return a | 0;
        }
        function Kh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Yo(a, b, f);
            l = e;
            return a | 0;
        }
        function Lh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Fo(a, b, f);
            l = e;
            return a | 0;
        }
        function Mh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            mo(a, b, f);
            l = e;
            return a | 0;
        }
        function Nh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Un(a, b, f);
            l = e;
            return a | 0;
        }
        function Oh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Bn(a, b, f);
            l = e;
            return a | 0;
        }
        function Ph(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Um(a, b, f);
            l = e;
            return a | 0;
        }
        function Qh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Bm(a, b, f);
            l = e;
            return a | 0;
        }
        function Rh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            im(a, b, f);
            l = e;
            return a | 0;
        }
        function Sh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Rl(a, b, f);
            l = e;
            return a | 0;
        }
        function Th(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            vl(a, b, f);
            l = e;
            return a | 0;
        }
        function Uh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            bl(a, b, f);
            l = e;
            return a | 0;
        }
        function Vh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Kk(a, b, f);
            l = e;
            return a | 0;
        }
        function Wh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            nk(a, b, f);
            l = e;
            return a | 0;
        }
        function Xh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Rj(a, b, f);
            l = e;
            return a | 0;
        }
        function Yh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            xj(a, b, f);
            l = e;
            return a | 0;
        }
        function Zh(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            _i(a, b, f);
            l = e;
            return a | 0;
        }
        function _h(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            $h(a, b, f);
            l = e;
            return a | 0;
        }
        function $h(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            bi(a, d, f, 1);
            l = e;
            return;
        }
        function ai(a) {
            a = a | 0;
            return a | 0;
        }
        function bi(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = ci() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = di(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, ei(g, e) | 0, e);
            l = f;
            return;
        }
        function ci() {
            var b = 0, d = 0;
            if (!(a[7616] | 0)) {
                qi(9136);
                Ha(24, 9136, o | 0);
                d = 7616;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9136) | 0)) {
                b = 9136;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                qi(9136);
            }
            return 9136;
        }
        function di(a) {
            a = a | 0;
            return 0;
        }
        function ei(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = ci() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                ki(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                li(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function fi(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0;
            h = l;
            l = l + 32 | 0;
            o = h + 24 | 0;
            n = h + 20 | 0;
            j = h + 16 | 0;
            m = h + 12 | 0;
            k = h + 8 | 0;
            i = h + 4 | 0;
            p = h;
            c[n >> 2] = b;
            c[j >> 2] = d;
            c[m >> 2] = e;
            c[k >> 2] = f;
            c[i >> 2] = g;
            g = a + 28 | 0;
            c[p >> 2] = c[g >> 2];
            c[o >> 2] = c[p >> 2];
            gi(a + 24 | 0, o, n, m, k, j, i);
            c[g >> 2] = c[c[g >> 2] >> 2];
            l = h;
            return;
        }
        function gi(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            a = hi(b) | 0;
            b = qC(24) | 0;
            ii(b + 4 | 0, c[d >> 2] | 0, c[e >> 2] | 0, c[f >> 2] | 0, c[g >> 2] | 0, c[h >> 2] | 0);
            c[b >> 2] = c[a >> 2];
            c[a >> 2] = b;
            return b | 0;
        }
        function hi(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function ii(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            c[a + 8 >> 2] = e;
            c[a + 12 >> 2] = f;
            c[a + 16 >> 2] = g;
            return;
        }
        function ji(a, b) {
            a = a | 0;
            b = b | 0;
            return b | a | 0;
        }
        function ki(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function li(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = mi(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                ni(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                ki(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                oi(a, i);
                pi(i);
                l = k;
                return;
            }
        }
        function mi(a) {
            a = a | 0;
            return 357913941;
        }
        function ni(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function oi(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function pi(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function qi(a) {
            a = a | 0;
            ui(a);
            return;
        }
        function ri(a) {
            a = a | 0;
            ti(a + 24 | 0);
            return;
        }
        function si(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function ti(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function ui(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 3, b, wi() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function vi() {
            return 9228;
        }
        function wi() {
            return 1140;
        }
        function xi(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            d = l;
            l = l + 16 | 0;
            e = d + 8 | 0;
            f = d;
            g = zi(a) | 0;
            a = c[g + 4 >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = a;
            c[e >> 2] = c[f >> 2];
            c[e + 4 >> 2] = c[f + 4 >> 2];
            b = Ai(b, e) | 0;
            l = d;
            return b | 0;
        }
        function yi(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            c[a + 8 >> 2] = e;
            c[a + 12 >> 2] = f;
            c[a + 16 >> 2] = g;
            return;
        }
        function zi(a) {
            a = a | 0;
            return (c[(ci() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Ai(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            f = l;
            l = l + 48 | 0;
            e = f;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            ob[d & 31](e, a);
            e = Bi(e) | 0;
            l = f;
            return e | 0;
        }
        function Bi(a) {
            a = a | 0;
            var b = 0, c = 0, d = 0, e = 0;
            e = l;
            l = l + 32 | 0;
            b = e + 12 | 0;
            c = e;
            d = Di(Ci() | 0) | 0;
            if (!d) a = Ii(a) | 0;
            else {
                Ei(b, d);
                Fi(c, b);
                Gi(a, c);
                a = Hi(b) | 0;
            }
            l = e;
            return a | 0;
        }
        function Ci() {
            var b = 0;
            if (!(a[7632] | 0)) {
                Ti(9184);
                Ha(25, 9184, o | 0);
                b = 7632;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 9184;
        }
        function Di(a) {
            a = a | 0;
            return c[a + 36 >> 2] | 0;
        }
        function Ei(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = a;
            c[a + 8 >> 2] = 0;
            return;
        }
        function Fi(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = c[b + 4 >> 2];
            c[a + 8 >> 2] = 0;
            return;
        }
        function Gi(a, b) {
            a = a | 0;
            b = b | 0;
            Ni(b, a, a + 8 | 0, a + 16 | 0, a + 24 | 0, a + 32 | 0, a + 40 | 0);
            return;
        }
        function Hi(a) {
            a = a | 0;
            return c[(c[a + 4 >> 2] | 0) + 8 >> 2] | 0;
        }
        function Ii(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            j = l;
            l = l + 16 | 0;
            d = j + 4 | 0;
            e = j;
            f = jy(8) | 0;
            g = f;
            h = qC(48) | 0;
            i = h;
            b = i + 48 | 0;
            do {
                c[i >> 2] = c[a >> 2];
                i = i + 4 | 0;
                a = a + 4 | 0;
            }while ((i | 0) < (b | 0));
            b = g + 4 | 0;
            c[b >> 2] = h;
            i = qC(8) | 0;
            h = c[b >> 2] | 0;
            c[e >> 2] = 0;
            c[d >> 2] = c[e >> 2];
            Ji(i, h, d);
            c[f >> 2] = i;
            l = j;
            return g | 0;
        }
        function Ji(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            d = qC(16) | 0;
            c[d + 4 >> 2] = 0;
            c[d + 8 >> 2] = 0;
            c[d >> 2] = 1092;
            c[d + 12 >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Ki(a) {
            a = a | 0;
            kC(a);
            sC(a);
            return;
        }
        function Li(a) {
            a = a | 0;
            a = c[a + 12 >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Mi(a) {
            a = a | 0;
            sC(a);
            return;
        }
        function Ni(a, b, d, e, f, g, h) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            g = Oi(c[a >> 2] | 0, b, d, e, f, g, h) | 0;
            h = a + 4 | 0;
            c[(c[h >> 2] | 0) + 8 >> 2] = g;
            return c[(c[h >> 2] | 0) + 8 >> 2] | 0;
        }
        function Oi(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            j = i;
            UA(j);
            a = Sg(a) | 0;
            g = Pi(a, +h[b >> 3], +h[c >> 3], +h[d >> 3], +h[e >> 3], +h[f >> 3], +h[g >> 3]) | 0;
            WA(j);
            l = i;
            return g | 0;
        }
        function Pi(a, b, c, d, e, f, g) {
            a = a | 0;
            b = +b;
            c = +c;
            d = +d;
            e = +e;
            f = +f;
            g = +g;
            var h = 0;
            h = Vg(Qi() | 0) | 0;
            b = +Wg(b);
            c = +Wg(c);
            d = +Wg(d);
            e = +Wg(e);
            f = +Wg(f);
            return ya(0, h | 0, a | 0, +b, +c, +d, +e, +f, + +Wg(g)) | 0;
        }
        function Qi() {
            var b = 0;
            if (!(a[7624] | 0)) {
                Ri(9172);
                b = 7624;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 9172;
        }
        function Ri(a) {
            a = a | 0;
            fh(a, Si() | 0, 6);
            return;
        }
        function Si() {
            return 1112;
        }
        function Ti(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function Ui(a) {
            a = a | 0;
            Vi(a + 24 | 0);
            Wi(a + 16 | 0);
            return;
        }
        function Vi(a) {
            a = a | 0;
            Yi(a);
            return;
        }
        function Wi(a) {
            a = a | 0;
            Xi(a);
            return;
        }
        function Xi(a) {
            a = a | 0;
            var b = 0, d = 0;
            b = c[a >> 2] | 0;
            if (b | 0) do {
                d = b;
                b = c[b >> 2] | 0;
                sC(d);
            }while ((b | 0) != 0);
            c[a >> 2] = 0;
            return;
        }
        function Yi(a) {
            a = a | 0;
            var b = 0, d = 0;
            b = c[a >> 2] | 0;
            if (b | 0) do {
                d = b;
                b = c[b >> 2] | 0;
                sC(d);
            }while ((b | 0) != 0);
            c[a >> 2] = 0;
            return;
        }
        function Zi(b) {
            b = b | 0;
            var d = 0;
            c[b + 16 >> 2] = 0;
            c[b + 20 >> 2] = 0;
            d = b + 24 | 0;
            c[d >> 2] = 0;
            c[b + 28 >> 2] = d;
            c[b + 36 >> 2] = 0;
            a[b + 40 >> 0] = 0;
            a[b + 41 >> 0] = 0;
            return;
        }
        function _i(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            $i(a, d, f, 0);
            l = e;
            return;
        }
        function $i(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = aj() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = bj(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, cj(g, e) | 0, e);
            l = f;
            return;
        }
        function aj() {
            var b = 0, d = 0;
            if (!(a[7640] | 0)) {
                jj(9232);
                Ha(26, 9232, o | 0);
                d = 7640;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9232) | 0)) {
                b = 9232;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                jj(9232);
            }
            return 9232;
        }
        function bj(a) {
            a = a | 0;
            return 0;
        }
        function cj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = aj() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                dj(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                ej(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function dj(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function ej(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = fj(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                gj(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                dj(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                hj(a, i);
                ij(i);
                l = k;
                return;
            }
        }
        function fj(a) {
            a = a | 0;
            return 357913941;
        }
        function gj(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function hj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function ij(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function jj(a) {
            a = a | 0;
            mj(a);
            return;
        }
        function kj(a) {
            a = a | 0;
            lj(a + 24 | 0);
            return;
        }
        function lj(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function mj(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 1, b, nj() | 0, 3);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function nj() {
            return 1144;
        }
        function oj(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = +d;
            e = +e;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0;
            g = l;
            l = l + 16 | 0;
            h = g + 8 | 0;
            i = g;
            j = pj(a) | 0;
            a = c[j + 4 >> 2] | 0;
            c[i >> 2] = c[j >> 2];
            c[i + 4 >> 2] = a;
            c[h >> 2] = c[i >> 2];
            c[h + 4 >> 2] = c[i + 4 >> 2];
            qj(b, h, d, e, f);
            l = g;
            return;
        }
        function pj(a) {
            a = a | 0;
            return (c[(aj() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function qj(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = +d;
            e = +e;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0;
            k = l;
            l = l + 16 | 0;
            h = k + 2 | 0;
            i = k + 1 | 0;
            j = k;
            g = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) g = c[(c[a >> 2] | 0) + g >> 2] | 0;
            rj(h, d);
            d = +sj(h, d);
            rj(i, e);
            e = +sj(i, e);
            tj(j, f);
            j = uj(j, f) | 0;
            qb[g & 1](a, d, e, j);
            l = k;
            return;
        }
        function rj(a, b) {
            a = a | 0;
            b = +b;
            return;
        }
        function sj(a, b) {
            a = a | 0;
            b = +b;
            return + +wj(b);
        }
        function tj(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function uj(a, b) {
            a = a | 0;
            b = b | 0;
            return vj(b) | 0;
        }
        function vj(a) {
            a = a | 0;
            return a | 0;
        }
        function wj(a) {
            a = +a;
            return +a;
        }
        function xj(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            yj(a, d, f, 1);
            l = e;
            return;
        }
        function yj(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = zj() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Aj(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Bj(g, e) | 0, e);
            l = f;
            return;
        }
        function zj() {
            var b = 0, d = 0;
            if (!(a[7648] | 0)) {
                Ij(9268);
                Ha(27, 9268, o | 0);
                d = 7648;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9268) | 0)) {
                b = 9268;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Ij(9268);
            }
            return 9268;
        }
        function Aj(a) {
            a = a | 0;
            return 0;
        }
        function Bj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = zj() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Cj(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Dj(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Cj(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Dj(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Ej(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Fj(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Cj(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Gj(a, i);
                Hj(i);
                l = k;
                return;
            }
        }
        function Ej(a) {
            a = a | 0;
            return 357913941;
        }
        function Fj(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Gj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Hj(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Ij(a) {
            a = a | 0;
            Lj(a);
            return;
        }
        function Jj(a) {
            a = a | 0;
            Kj(a + 24 | 0);
            return;
        }
        function Kj(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Lj(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 4, b, Mj() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Mj() {
            return 1160;
        }
        function Nj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            d = l;
            l = l + 16 | 0;
            e = d + 8 | 0;
            f = d;
            g = Oj(a) | 0;
            a = c[g + 4 >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = a;
            c[e >> 2] = c[f >> 2];
            c[e + 4 >> 2] = c[f + 4 >> 2];
            b = Pj(b, e) | 0;
            l = d;
            return b | 0;
        }
        function Oj(a) {
            a = a | 0;
            return (c[(zj() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Pj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            return Qj(pb[d & 31](a) | 0) | 0;
        }
        function Qj(a) {
            a = a | 0;
            return a & 1 | 0;
        }
        function Rj(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Sj(a, d, f, 0);
            l = e;
            return;
        }
        function Sj(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Tj() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Uj(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Vj(g, e) | 0, e);
            l = f;
            return;
        }
        function Tj() {
            var b = 0, d = 0;
            if (!(a[7656] | 0)) {
                ak(9304);
                Ha(28, 9304, o | 0);
                d = 7656;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9304) | 0)) {
                b = 9304;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                ak(9304);
            }
            return 9304;
        }
        function Uj(a) {
            a = a | 0;
            return 0;
        }
        function Vj(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Tj() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Wj(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Xj(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Wj(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Xj(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Yj(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Zj(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Wj(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                _j(a, i);
                $j(i);
                l = k;
                return;
            }
        }
        function Yj(a) {
            a = a | 0;
            return 357913941;
        }
        function Zj(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function _j(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function $j(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function ak(a) {
            a = a | 0;
            dk(a);
            return;
        }
        function bk(a) {
            a = a | 0;
            ck(a + 24 | 0);
            return;
        }
        function ck(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function dk(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 5, b, ek() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function ek() {
            return 1164;
        }
        function fk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = gk(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            hk(b, f, d);
            l = e;
            return;
        }
        function gk(a) {
            a = a | 0;
            return (c[(Tj() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function hk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            ik(f, d);
            d = jk(f, d) | 0;
            ob[e & 31](a, d);
            kk(f);
            l = g;
            return;
        }
        function ik(a, b) {
            a = a | 0;
            b = b | 0;
            lk(a, b);
            return;
        }
        function jk(a, b) {
            a = a | 0;
            b = b | 0;
            return a | 0;
        }
        function kk(a) {
            a = a | 0;
            vf(a);
            return;
        }
        function lk(a, b) {
            a = a | 0;
            b = b | 0;
            mk(a, b);
            return;
        }
        function mk(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = b;
            return;
        }
        function nk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            ok(a, d, f, 0);
            l = e;
            return;
        }
        function ok(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = pk() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = qk(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, rk(g, e) | 0, e);
            l = f;
            return;
        }
        function pk() {
            var b = 0, d = 0;
            if (!(a[7664] | 0)) {
                yk(9340);
                Ha(29, 9340, o | 0);
                d = 7664;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9340) | 0)) {
                b = 9340;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                yk(9340);
            }
            return 9340;
        }
        function qk(a) {
            a = a | 0;
            return 0;
        }
        function rk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = pk() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                sk(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                tk(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function sk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function tk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = uk(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                vk(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                sk(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                wk(a, i);
                xk(i);
                l = k;
                return;
            }
        }
        function uk(a) {
            a = a | 0;
            return 357913941;
        }
        function vk(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function wk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function xk(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function yk(a) {
            a = a | 0;
            Bk(a);
            return;
        }
        function zk(a) {
            a = a | 0;
            Ak(a + 24 | 0);
            return;
        }
        function Ak(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Bk(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 4, b, Ck() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Ck() {
            return 1180;
        }
        function Dk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = Ek(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            d = Fk(b, f, d) | 0;
            l = e;
            return d | 0;
        }
        function Ek(a) {
            a = a | 0;
            return (c[(pk() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Fk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            Gk(f, d);
            f = Hk(f, d) | 0;
            f = Ik(wb[e & 15](a, f) | 0) | 0;
            l = g;
            return f | 0;
        }
        function Gk(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function Hk(a, b) {
            a = a | 0;
            b = b | 0;
            return Jk(b) | 0;
        }
        function Ik(a) {
            a = a | 0;
            return a | 0;
        }
        function Jk(a) {
            a = a | 0;
            return a | 0;
        }
        function Kk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Lk(a, d, f, 0);
            l = e;
            return;
        }
        function Lk(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Mk() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Nk(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Ok(g, e) | 0, e);
            l = f;
            return;
        }
        function Mk() {
            var b = 0, d = 0;
            if (!(a[7672] | 0)) {
                Vk(9376);
                Ha(30, 9376, o | 0);
                d = 7672;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9376) | 0)) {
                b = 9376;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Vk(9376);
            }
            return 9376;
        }
        function Nk(a) {
            a = a | 0;
            return 0;
        }
        function Ok(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Mk() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Pk(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Qk(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Pk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Qk(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Rk(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Sk(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Pk(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Tk(a, i);
                Uk(i);
                l = k;
                return;
            }
        }
        function Rk(a) {
            a = a | 0;
            return 357913941;
        }
        function Sk(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Tk(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Uk(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Vk(a) {
            a = a | 0;
            Yk(a);
            return;
        }
        function Wk(a) {
            a = a | 0;
            Xk(a + 24 | 0);
            return;
        }
        function Xk(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Yk(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 5, b, Zk() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Zk() {
            return 1196;
        }
        function _k(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            d = l;
            l = l + 16 | 0;
            e = d + 8 | 0;
            f = d;
            g = $k(a) | 0;
            a = c[g + 4 >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = a;
            c[e >> 2] = c[f >> 2];
            c[e + 4 >> 2] = c[f + 4 >> 2];
            b = al(b, e) | 0;
            l = d;
            return b | 0;
        }
        function $k(a) {
            a = a | 0;
            return (c[(Mk() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function al(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            return Ik(pb[d & 31](a) | 0) | 0;
        }
        function bl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            cl(a, d, f, 1);
            l = e;
            return;
        }
        function cl(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = dl() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = el(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, fl(g, e) | 0, e);
            l = f;
            return;
        }
        function dl() {
            var b = 0, d = 0;
            if (!(a[7680] | 0)) {
                ml(9412);
                Ha(31, 9412, o | 0);
                d = 7680;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9412) | 0)) {
                b = 9412;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                ml(9412);
            }
            return 9412;
        }
        function el(a) {
            a = a | 0;
            return 0;
        }
        function fl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = dl() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                gl(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                hl(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function gl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function hl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = il(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                jl(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                gl(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                kl(a, i);
                ll(i);
                l = k;
                return;
            }
        }
        function il(a) {
            a = a | 0;
            return 357913941;
        }
        function jl(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function kl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function ll(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function ml(a) {
            a = a | 0;
            pl(a);
            return;
        }
        function nl(a) {
            a = a | 0;
            ol(a + 24 | 0);
            return;
        }
        function ol(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function pl(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 6, b, ql() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function ql() {
            return 1200;
        }
        function rl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            d = l;
            l = l + 16 | 0;
            e = d + 8 | 0;
            f = d;
            g = sl(a) | 0;
            a = c[g + 4 >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = a;
            c[e >> 2] = c[f >> 2];
            c[e + 4 >> 2] = c[f + 4 >> 2];
            b = tl(b, e) | 0;
            l = d;
            return b | 0;
        }
        function sl(a) {
            a = a | 0;
            return (c[(dl() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function tl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            return ul(pb[d & 31](a) | 0) | 0;
        }
        function ul(a) {
            a = a | 0;
            return a | 0;
        }
        function vl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            wl(a, d, f, 0);
            l = e;
            return;
        }
        function wl(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = xl() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = yl(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, zl(g, e) | 0, e);
            l = f;
            return;
        }
        function xl() {
            var b = 0, d = 0;
            if (!(a[7688] | 0)) {
                Gl(9448);
                Ha(32, 9448, o | 0);
                d = 7688;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9448) | 0)) {
                b = 9448;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Gl(9448);
            }
            return 9448;
        }
        function yl(a) {
            a = a | 0;
            return 0;
        }
        function zl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = xl() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Al(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Bl(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Al(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Bl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Cl(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Dl(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Al(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                El(a, i);
                Fl(i);
                l = k;
                return;
            }
        }
        function Cl(a) {
            a = a | 0;
            return 357913941;
        }
        function Dl(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function El(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Fl(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Gl(a) {
            a = a | 0;
            Jl(a);
            return;
        }
        function Hl(a) {
            a = a | 0;
            Il(a + 24 | 0);
            return;
        }
        function Il(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Jl(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 6, b, Kl() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Kl() {
            return 1204;
        }
        function Ll(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = Ml(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Nl(b, f, d);
            l = e;
            return;
        }
        function Ml(a) {
            a = a | 0;
            return (c[(xl() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Nl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            Ol(f, d);
            f = Pl(f, d) | 0;
            ob[e & 31](a, f);
            l = g;
            return;
        }
        function Ol(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function Pl(a, b) {
            a = a | 0;
            b = b | 0;
            return Ql(b) | 0;
        }
        function Ql(a) {
            a = a | 0;
            return a | 0;
        }
        function Rl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Sl(a, d, f, 0);
            l = e;
            return;
        }
        function Sl(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Tl() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Ul(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Vl(g, e) | 0, e);
            l = f;
            return;
        }
        function Tl() {
            var b = 0, d = 0;
            if (!(a[7696] | 0)) {
                am(9484);
                Ha(33, 9484, o | 0);
                d = 7696;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9484) | 0)) {
                b = 9484;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                am(9484);
            }
            return 9484;
        }
        function Ul(a) {
            a = a | 0;
            return 0;
        }
        function Vl(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Tl() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Wl(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Xl(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Wl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Xl(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Yl(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Zl(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Wl(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                _l(a, i);
                $l(i);
                l = k;
                return;
            }
        }
        function Yl(a) {
            a = a | 0;
            return 357913941;
        }
        function Zl(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function _l(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function $l(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function am(a) {
            a = a | 0;
            dm(a);
            return;
        }
        function bm(a) {
            a = a | 0;
            cm(a + 24 | 0);
            return;
        }
        function cm(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function dm(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 1, b, em() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function em() {
            return 1212;
        }
        function fm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            f = l;
            l = l + 16 | 0;
            g = f + 8 | 0;
            h = f;
            i = gm(a) | 0;
            a = c[i + 4 >> 2] | 0;
            c[h >> 2] = c[i >> 2];
            c[h + 4 >> 2] = a;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = c[h + 4 >> 2];
            hm(b, g, d, e);
            l = f;
            return;
        }
        function gm(a) {
            a = a | 0;
            return (c[(Tl() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function hm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            i = l;
            l = l + 16 | 0;
            g = i + 1 | 0;
            h = i;
            f = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) f = c[(c[a >> 2] | 0) + f >> 2] | 0;
            Ol(g, d);
            g = Pl(g, d) | 0;
            Gk(h, e);
            h = Hk(h, e) | 0;
            Eb[f & 15](a, g, h);
            l = i;
            return;
        }
        function im(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            jm(a, d, f, 1);
            l = e;
            return;
        }
        function jm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = km() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = lm(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, mm(g, e) | 0, e);
            l = f;
            return;
        }
        function km() {
            var b = 0, d = 0;
            if (!(a[7704] | 0)) {
                tm(9520);
                Ha(34, 9520, o | 0);
                d = 7704;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9520) | 0)) {
                b = 9520;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                tm(9520);
            }
            return 9520;
        }
        function lm(a) {
            a = a | 0;
            return 0;
        }
        function mm(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = km() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                nm(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                om(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function nm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function om(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = pm(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                qm(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                nm(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                rm(a, i);
                sm(i);
                l = k;
                return;
            }
        }
        function pm(a) {
            a = a | 0;
            return 357913941;
        }
        function qm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function rm(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function sm(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function tm(a) {
            a = a | 0;
            wm(a);
            return;
        }
        function um(a) {
            a = a | 0;
            vm(a + 24 | 0);
            return;
        }
        function vm(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function wm(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 1, b, xm() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function xm() {
            return 1224;
        }
        function ym(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0.0, f = 0, g = 0, h = 0, i = 0;
            f = l;
            l = l + 16 | 0;
            g = f + 8 | 0;
            h = f;
            i = zm(a) | 0;
            a = c[i + 4 >> 2] | 0;
            c[h >> 2] = c[i >> 2];
            c[h + 4 >> 2] = a;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = c[h + 4 >> 2];
            e = +Am(b, g, d);
            l = f;
            return +e;
        }
        function zm(a) {
            a = a | 0;
            return (c[(km() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Am(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0.0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            tj(f, d);
            f = uj(f, d) | 0;
            h = +ch(+zb[e & 7](a, f));
            l = g;
            return +h;
        }
        function Bm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Cm(a, d, f, 1);
            l = e;
            return;
        }
        function Cm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Dm() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Em(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Fm(g, e) | 0, e);
            l = f;
            return;
        }
        function Dm() {
            var b = 0, d = 0;
            if (!(a[7712] | 0)) {
                Mm(9556);
                Ha(35, 9556, o | 0);
                d = 7712;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9556) | 0)) {
                b = 9556;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Mm(9556);
            }
            return 9556;
        }
        function Em(a) {
            a = a | 0;
            return 0;
        }
        function Fm(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Dm() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Gm(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Hm(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Gm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Hm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Im(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Jm(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Gm(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Km(a, i);
                Lm(i);
                l = k;
                return;
            }
        }
        function Im(a) {
            a = a | 0;
            return 357913941;
        }
        function Jm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Km(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Lm(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Mm(a) {
            a = a | 0;
            Pm(a);
            return;
        }
        function Nm(a) {
            a = a | 0;
            Om(a + 24 | 0);
            return;
        }
        function Om(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Pm(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 5, b, Qm() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Qm() {
            return 1232;
        }
        function Rm(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0.0, e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = Sm(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            d = +Tm(b, f);
            l = e;
            return +d;
        }
        function Sm(a) {
            a = a | 0;
            return (c[(Dm() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Tm(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            return + +ch(+ub[d & 15](a));
        }
        function Um(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Vm(a, d, f, 1);
            l = e;
            return;
        }
        function Vm(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Wm() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Xm(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Ym(g, e) | 0, e);
            l = f;
            return;
        }
        function Wm() {
            var b = 0, d = 0;
            if (!(a[7720] | 0)) {
                dn(9592);
                Ha(36, 9592, o | 0);
                d = 7720;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9592) | 0)) {
                b = 9592;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                dn(9592);
            }
            return 9592;
        }
        function Xm(a) {
            a = a | 0;
            return 0;
        }
        function Ym(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Wm() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Zm(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                _m(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Zm(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function _m(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = $m(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                an(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Zm(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                bn(a, i);
                cn(i);
                l = k;
                return;
            }
        }
        function $m(a) {
            a = a | 0;
            return 357913941;
        }
        function an(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function bn(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function cn(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function dn(a) {
            a = a | 0;
            gn(a);
            return;
        }
        function en(a) {
            a = a | 0;
            fn(a + 24 | 0);
            return;
        }
        function fn(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function gn(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 7, b, hn() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function hn() {
            return 1276;
        }
        function jn(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            d = l;
            l = l + 16 | 0;
            e = d + 8 | 0;
            f = d;
            g = kn(a) | 0;
            a = c[g + 4 >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = a;
            c[e >> 2] = c[f >> 2];
            c[e + 4 >> 2] = c[f + 4 >> 2];
            b = ln(b, e) | 0;
            l = d;
            return b | 0;
        }
        function kn(a) {
            a = a | 0;
            return (c[(Wm() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function ln(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            f = l;
            l = l + 16 | 0;
            e = f;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            ob[d & 31](e, a);
            e = mn(e) | 0;
            l = f;
            return e | 0;
        }
        function mn(a) {
            a = a | 0;
            var b = 0, c = 0, d = 0, e = 0;
            e = l;
            l = l + 32 | 0;
            b = e + 12 | 0;
            c = e;
            d = Di(nn() | 0) | 0;
            if (!d) a = pn(a) | 0;
            else {
                Ei(b, d);
                Fi(c, b);
                on(a, c);
                a = Hi(b) | 0;
            }
            l = e;
            return a | 0;
        }
        function nn() {
            var b = 0;
            if (!(a[7736] | 0)) {
                An(9640);
                Ha(25, 9640, o | 0);
                b = 7736;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 9640;
        }
        function on(a, b) {
            a = a | 0;
            b = b | 0;
            un(b, a, a + 8 | 0);
            return;
        }
        function pn(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            d = l;
            l = l + 16 | 0;
            f = d + 4 | 0;
            h = d;
            e = jy(8) | 0;
            b = e;
            i = qC(16) | 0;
            c[i >> 2] = c[a >> 2];
            c[i + 4 >> 2] = c[a + 4 >> 2];
            c[i + 8 >> 2] = c[a + 8 >> 2];
            c[i + 12 >> 2] = c[a + 12 >> 2];
            g = b + 4 | 0;
            c[g >> 2] = i;
            a = qC(8) | 0;
            g = c[g >> 2] | 0;
            c[h >> 2] = 0;
            c[f >> 2] = c[h >> 2];
            qn(a, g, f);
            c[e >> 2] = a;
            l = d;
            return b | 0;
        }
        function qn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            d = qC(16) | 0;
            c[d + 4 >> 2] = 0;
            c[d + 8 >> 2] = 0;
            c[d >> 2] = 1244;
            c[d + 12 >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function rn(a) {
            a = a | 0;
            kC(a);
            sC(a);
            return;
        }
        function sn(a) {
            a = a | 0;
            a = c[a + 12 >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function tn(a) {
            a = a | 0;
            sC(a);
            return;
        }
        function un(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            b = vn(c[a >> 2] | 0, b, d) | 0;
            d = a + 4 | 0;
            c[(c[d >> 2] | 0) + 8 >> 2] = b;
            return c[(c[d >> 2] | 0) + 8 >> 2] | 0;
        }
        function vn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = l;
            l = l + 16 | 0;
            f = e;
            UA(f);
            a = Sg(a) | 0;
            d = wn(a, c[b >> 2] | 0, +h[d >> 3]) | 0;
            WA(f);
            l = e;
            return d | 0;
        }
        function wn(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = +c;
            var d = 0;
            d = Vg(xn() | 0) | 0;
            b = Xg(b) | 0;
            return za(0, d | 0, a | 0, b | 0, + +Wg(c)) | 0;
        }
        function xn() {
            var b = 0;
            if (!(a[7728] | 0)) {
                yn(9628);
                b = 7728;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 9628;
        }
        function yn(a) {
            a = a | 0;
            fh(a, zn() | 0, 2);
            return;
        }
        function zn() {
            return 1264;
        }
        function An(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function Bn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Cn(a, d, f, 1);
            l = e;
            return;
        }
        function Cn(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Dn() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = En(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Fn(g, e) | 0, e);
            l = f;
            return;
        }
        function Dn() {
            var b = 0, d = 0;
            if (!(a[7744] | 0)) {
                Mn(9684);
                Ha(37, 9684, o | 0);
                d = 7744;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9684) | 0)) {
                b = 9684;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Mn(9684);
            }
            return 9684;
        }
        function En(a) {
            a = a | 0;
            return 0;
        }
        function Fn(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Dn() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Gn(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Hn(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Gn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Hn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = In(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Jn(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Gn(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Kn(a, i);
                Ln(i);
                l = k;
                return;
            }
        }
        function In(a) {
            a = a | 0;
            return 357913941;
        }
        function Jn(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Kn(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Ln(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Mn(a) {
            a = a | 0;
            Pn(a);
            return;
        }
        function Nn(a) {
            a = a | 0;
            On(a + 24 | 0);
            return;
        }
        function On(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Pn(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 5, b, Qn() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Qn() {
            return 1280;
        }
        function Rn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = Sn(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            d = Tn(b, f, d) | 0;
            l = e;
            return d | 0;
        }
        function Sn(a) {
            a = a | 0;
            return (c[(Dn() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Tn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            h = l;
            l = l + 32 | 0;
            f = h;
            g = h + 16 | 0;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            tj(g, d);
            g = uj(g, d) | 0;
            Eb[e & 15](f, a, g);
            g = mn(f) | 0;
            l = h;
            return g | 0;
        }
        function Un(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Vn(a, d, f, 1);
            l = e;
            return;
        }
        function Vn(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Wn() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Xn(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Yn(g, e) | 0, e);
            l = f;
            return;
        }
        function Wn() {
            var b = 0, d = 0;
            if (!(a[7752] | 0)) {
                eo(9720);
                Ha(38, 9720, o | 0);
                d = 7752;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9720) | 0)) {
                b = 9720;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                eo(9720);
            }
            return 9720;
        }
        function Xn(a) {
            a = a | 0;
            return 0;
        }
        function Yn(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Wn() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Zn(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                _n(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Zn(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function _n(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = $n(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                ao(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Zn(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                bo(a, i);
                co(i);
                l = k;
                return;
            }
        }
        function $n(a) {
            a = a | 0;
            return 357913941;
        }
        function ao(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function bo(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function co(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function eo(a) {
            a = a | 0;
            ho(a);
            return;
        }
        function fo(a) {
            a = a | 0;
            go(a + 24 | 0);
            return;
        }
        function go(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function ho(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 8, b, io() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function io() {
            return 1288;
        }
        function jo(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            d = l;
            l = l + 16 | 0;
            e = d + 8 | 0;
            f = d;
            g = ko(a) | 0;
            a = c[g + 4 >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = a;
            c[e >> 2] = c[f >> 2];
            c[e + 4 >> 2] = c[f + 4 >> 2];
            b = lo(b, e) | 0;
            l = d;
            return b | 0;
        }
        function ko(a) {
            a = a | 0;
            return (c[(Wn() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function lo(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            return bh(pb[d & 31](a) | 0) | 0;
        }
        function mo(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            no(a, d, f, 0);
            l = e;
            return;
        }
        function no(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = oo() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = po(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, qo(g, e) | 0, e);
            l = f;
            return;
        }
        function oo() {
            var b = 0, d = 0;
            if (!(a[7760] | 0)) {
                xo(9756);
                Ha(39, 9756, o | 0);
                d = 7760;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9756) | 0)) {
                b = 9756;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                xo(9756);
            }
            return 9756;
        }
        function po(a) {
            a = a | 0;
            return 0;
        }
        function qo(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = oo() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                ro(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                so(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function ro(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function so(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = to(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                uo(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                ro(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                vo(a, i);
                wo(i);
                l = k;
                return;
            }
        }
        function to(a) {
            a = a | 0;
            return 357913941;
        }
        function uo(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function vo(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function wo(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function xo(a) {
            a = a | 0;
            Ao(a);
            return;
        }
        function yo(a) {
            a = a | 0;
            zo(a + 24 | 0);
            return;
        }
        function zo(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Ao(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 8, b, Bo() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Bo() {
            return 1292;
        }
        function Co(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = Do(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Eo(b, f, d);
            l = e;
            return;
        }
        function Do(a) {
            a = a | 0;
            return (c[(oo() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Eo(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            var e = 0, f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            rj(f, d);
            d = +sj(f, d);
            lb[e & 31](a, d);
            l = g;
            return;
        }
        function Fo(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Go(a, d, f, 0);
            l = e;
            return;
        }
        function Go(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Ho() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Io(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Jo(g, e) | 0, e);
            l = f;
            return;
        }
        function Ho() {
            var b = 0, d = 0;
            if (!(a[7768] | 0)) {
                Qo(9792);
                Ha(40, 9792, o | 0);
                d = 7768;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9792) | 0)) {
                b = 9792;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Qo(9792);
            }
            return 9792;
        }
        function Io(a) {
            a = a | 0;
            return 0;
        }
        function Jo(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Ho() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Ko(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Lo(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Ko(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Lo(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Mo(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                No(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Ko(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Oo(a, i);
                Po(i);
                l = k;
                return;
            }
        }
        function Mo(a) {
            a = a | 0;
            return 357913941;
        }
        function No(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Oo(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Po(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Qo(a) {
            a = a | 0;
            To(a);
            return;
        }
        function Ro(a) {
            a = a | 0;
            So(a + 24 | 0);
            return;
        }
        function So(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function To(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 1, b, Uo() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Uo() {
            return 1300;
        }
        function Vo(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = +e;
            var f = 0, g = 0, h = 0, i = 0;
            f = l;
            l = l + 16 | 0;
            g = f + 8 | 0;
            h = f;
            i = Wo(a) | 0;
            a = c[i + 4 >> 2] | 0;
            c[h >> 2] = c[i >> 2];
            c[h + 4 >> 2] = a;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = c[h + 4 >> 2];
            Xo(b, g, d, e);
            l = f;
            return;
        }
        function Wo(a) {
            a = a | 0;
            return (c[(Ho() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Xo(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = +e;
            var f = 0, g = 0, h = 0, i = 0;
            i = l;
            l = l + 16 | 0;
            g = i + 1 | 0;
            h = i;
            f = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) f = c[(c[a >> 2] | 0) + f >> 2] | 0;
            tj(g, d);
            g = uj(g, d) | 0;
            rj(h, e);
            e = +sj(h, e);
            Gb[f & 15](a, g, e);
            l = i;
            return;
        }
        function Yo(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Zo(a, d, f, 0);
            l = e;
            return;
        }
        function Zo(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = _o() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = $o(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, ap(g, e) | 0, e);
            l = f;
            return;
        }
        function _o() {
            var b = 0, d = 0;
            if (!(a[7776] | 0)) {
                hp(9828);
                Ha(41, 9828, o | 0);
                d = 7776;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9828) | 0)) {
                b = 9828;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                hp(9828);
            }
            return 9828;
        }
        function $o(a) {
            a = a | 0;
            return 0;
        }
        function ap(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = _o() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                bp(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                cp(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function bp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function cp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = dp(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                ep(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                bp(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                fp(a, i);
                gp(i);
                l = k;
                return;
            }
        }
        function dp(a) {
            a = a | 0;
            return 357913941;
        }
        function ep(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function fp(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function gp(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function hp(a) {
            a = a | 0;
            kp(a);
            return;
        }
        function ip(a) {
            a = a | 0;
            jp(a + 24 | 0);
            return;
        }
        function jp(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function kp(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 7, b, lp() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function lp() {
            return 1312;
        }
        function mp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = np(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            op(b, f, d);
            l = e;
            return;
        }
        function np(a) {
            a = a | 0;
            return (c[(_o() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function op(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            tj(f, d);
            f = uj(f, d) | 0;
            ob[e & 31](a, f);
            l = g;
            return;
        }
        function pp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            qp(a, d, f, 0);
            l = e;
            return;
        }
        function qp(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = rp() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = sp(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, tp(g, e) | 0, e);
            l = f;
            return;
        }
        function rp() {
            var b = 0, d = 0;
            if (!(a[7784] | 0)) {
                Ap(9864);
                Ha(42, 9864, o | 0);
                d = 7784;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9864) | 0)) {
                b = 9864;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Ap(9864);
            }
            return 9864;
        }
        function sp(a) {
            a = a | 0;
            return 0;
        }
        function tp(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = rp() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                up(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                vp(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function up(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function vp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = wp(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                xp(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                up(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                yp(a, i);
                zp(i);
                l = k;
                return;
            }
        }
        function wp(a) {
            a = a | 0;
            return 357913941;
        }
        function xp(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function yp(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function zp(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Ap(a) {
            a = a | 0;
            Dp(a);
            return;
        }
        function Bp(a) {
            a = a | 0;
            Cp(a + 24 | 0);
            return;
        }
        function Cp(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Dp(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 8, b, Ep() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Ep() {
            return 1320;
        }
        function Fp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = Gp(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Hp(b, f, d);
            l = e;
            return;
        }
        function Gp(a) {
            a = a | 0;
            return (c[(rp() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Hp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            Ip(f, d);
            f = Jp(f, d) | 0;
            ob[e & 31](a, f);
            l = g;
            return;
        }
        function Ip(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function Jp(a, b) {
            a = a | 0;
            b = b | 0;
            return Kp(b) | 0;
        }
        function Kp(a) {
            a = a | 0;
            return a | 0;
        }
        function Lp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Mp(a, d, f, 0);
            l = e;
            return;
        }
        function Mp(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Np() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Op(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Pp(g, e) | 0, e);
            l = f;
            return;
        }
        function Np() {
            var b = 0, d = 0;
            if (!(a[7792] | 0)) {
                Wp(9900);
                Ha(43, 9900, o | 0);
                d = 7792;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9900) | 0)) {
                b = 9900;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Wp(9900);
            }
            return 9900;
        }
        function Op(a) {
            a = a | 0;
            return 0;
        }
        function Pp(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Np() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Qp(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Rp(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Qp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Rp(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Sp(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Tp(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Qp(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Up(a, i);
                Vp(i);
                l = k;
                return;
            }
        }
        function Sp(a) {
            a = a | 0;
            return 357913941;
        }
        function Tp(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Up(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Vp(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Wp(a) {
            a = a | 0;
            Zp(a);
            return;
        }
        function Xp(a) {
            a = a | 0;
            Yp(a + 24 | 0);
            return;
        }
        function Yp(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Zp(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 22, b, _p() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function _p() {
            return 1344;
        }
        function $p(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0;
            d = l;
            l = l + 16 | 0;
            e = d + 8 | 0;
            f = d;
            g = aq(a) | 0;
            a = c[g + 4 >> 2] | 0;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = a;
            c[e >> 2] = c[f >> 2];
            c[e + 4 >> 2] = c[f + 4 >> 2];
            bq(b, e);
            l = d;
            return;
        }
        function aq(a) {
            a = a | 0;
            return (c[(Np() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function bq(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) d = c[(c[a >> 2] | 0) + d >> 2] | 0;
            nb[d & 127](a);
            return;
        }
        function cq(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = dq() | 0;
            a = eq(d) | 0;
            fi(g, b, f, a, fq(d, e) | 0, e);
            return;
        }
        function dq() {
            var b = 0, d = 0;
            if (!(a[7800] | 0)) {
                mq(9936);
                Ha(44, 9936, o | 0);
                d = 7800;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9936) | 0)) {
                b = 9936;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                mq(9936);
            }
            return 9936;
        }
        function eq(a) {
            a = a | 0;
            return a | 0;
        }
        function fq(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = dq() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                gq(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                hq(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function gq(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function hq(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = iq(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                jq(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                gq(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                kq(a, f);
                lq(f);
                l = i;
                return;
            }
        }
        function iq(a) {
            a = a | 0;
            return 536870911;
        }
        function jq(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function kq(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function lq(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function mq(a) {
            a = a | 0;
            pq(a);
            return;
        }
        function nq(a) {
            a = a | 0;
            oq(a + 24 | 0);
            return;
        }
        function oq(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function pq(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 23, b, Kl() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function qq(a, b) {
            a = a | 0;
            b = b | 0;
            sq(c[(rq(a) | 0) >> 2] | 0, b);
            return;
        }
        function rq(a) {
            a = a | 0;
            return (c[(dq() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function sq(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0;
            c = l;
            l = l + 16 | 0;
            d = c;
            Ol(d, b);
            b = Pl(d, b) | 0;
            nb[a & 127](b);
            l = c;
            return;
        }
        function tq(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = uq() | 0;
            a = vq(d) | 0;
            fi(g, b, f, a, wq(d, e) | 0, e);
            return;
        }
        function uq() {
            var b = 0, d = 0;
            if (!(a[7808] | 0)) {
                Dq(9972);
                Ha(45, 9972, o | 0);
                d = 7808;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(9972) | 0)) {
                b = 9972;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Dq(9972);
            }
            return 9972;
        }
        function vq(a) {
            a = a | 0;
            return a | 0;
        }
        function wq(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = uq() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                xq(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                yq(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function xq(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function yq(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = zq(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                Aq(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                xq(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                Bq(a, f);
                Cq(f);
                l = i;
                return;
            }
        }
        function zq(a) {
            a = a | 0;
            return 536870911;
        }
        function Aq(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function Bq(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Cq(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Dq(a) {
            a = a | 0;
            Gq(a);
            return;
        }
        function Eq(a) {
            a = a | 0;
            Fq(a + 24 | 0);
            return;
        }
        function Fq(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function Gq(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 9, b, Hq() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Hq() {
            return 1348;
        }
        function Iq(a, b) {
            a = a | 0;
            b = b | 0;
            return Kq(c[(Jq(a) | 0) >> 2] | 0, b) | 0;
        }
        function Jq(a) {
            a = a | 0;
            return (c[(uq() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function Kq(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0;
            c = l;
            l = l + 16 | 0;
            d = c;
            Lq(d, b);
            b = Mq(d, b) | 0;
            b = Ik(pb[a & 31](b) | 0) | 0;
            l = c;
            return b | 0;
        }
        function Lq(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function Mq(a, b) {
            a = a | 0;
            b = b | 0;
            return Nq(b) | 0;
        }
        function Nq(a) {
            a = a | 0;
            return a | 0;
        }
        function Oq(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = Pq() | 0;
            a = Qq(d) | 0;
            fi(g, b, f, a, Rq(d, e) | 0, e);
            return;
        }
        function Pq() {
            var b = 0, d = 0;
            if (!(a[7816] | 0)) {
                Yq(10008);
                Ha(46, 10008, o | 0);
                d = 7816;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10008) | 0)) {
                b = 10008;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Yq(10008);
            }
            return 10008;
        }
        function Qq(a) {
            a = a | 0;
            return a | 0;
        }
        function Rq(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = Pq() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                Sq(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                Tq(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function Sq(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Tq(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = Uq(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                Vq(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                Sq(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                Wq(a, f);
                Xq(f);
                l = i;
                return;
            }
        }
        function Uq(a) {
            a = a | 0;
            return 536870911;
        }
        function Vq(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function Wq(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Xq(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Yq(a) {
            a = a | 0;
            $q(a);
            return;
        }
        function Zq(a) {
            a = a | 0;
            _q(a + 24 | 0);
            return;
        }
        function _q(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function $q(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 15, b, Zk() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function ar(a) {
            a = a | 0;
            return cr(c[(br(a) | 0) >> 2] | 0) | 0;
        }
        function br(a) {
            a = a | 0;
            return (c[(Pq() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function cr(a) {
            a = a | 0;
            return Ik(Ab[a & 7]() | 0) | 0;
        }
        function dr() {
            var b = 0;
            if (!(a[7832] | 0)) {
                nr(10052);
                Ha(25, 10052, o | 0);
                b = 7832;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10052;
        }
        function er(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = fr() | 0;
            c[a + 4 >> 2] = gr() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = hr() | 0;
            c[a + 32 >> 2] = 2;
            return;
        }
        function fr() {
            return 11709;
        }
        function gr() {
            return 1188;
        }
        function hr() {
            return lr() | 0;
        }
        function ir(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    kr(c);
                    sC(c);
                }
            } else if (b | 0) {
                uf(b);
                sC(b);
            }
            return;
        }
        function jr(a, b) {
            a = a | 0;
            b = b | 0;
            return b & a | 0;
        }
        function kr(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function lr() {
            var b = 0;
            if (!(a[7824] | 0)) {
                c[2511] = mr() | 0;
                c[2512] = 0;
                b = 7824;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10044;
        }
        function mr() {
            return 0;
        }
        function nr(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function or(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0;
            b = l;
            l = l + 32 | 0;
            d = b + 24 | 0;
            g = b + 16 | 0;
            f = b + 8 | 0;
            e = b;
            pr(a, 4827);
            qr(a, 4834, 3);
            rr(a, 3682, 47);
            c[g >> 2] = 9;
            c[g + 4 >> 2] = 0;
            c[d >> 2] = c[g >> 2];
            c[d + 4 >> 2] = c[g + 4 >> 2];
            sr(a, 4841, d);
            c[f >> 2] = 1;
            c[f + 4 >> 2] = 0;
            c[d >> 2] = c[f >> 2];
            c[d + 4 >> 2] = c[f + 4 >> 2];
            tr(a, 4871, d);
            c[e >> 2] = 10;
            c[e + 4 >> 2] = 0;
            c[d >> 2] = c[e >> 2];
            c[d + 4 >> 2] = c[e + 4 >> 2];
            ur(a, 4891, d);
            l = b;
            return;
        }
        function pr(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = nt() | 0;
            c[a >> 2] = d;
            ot(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function qr(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Ws(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function rr(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Es(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function sr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            is(a, b, f);
            l = e;
            return a | 0;
        }
        function tr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Or(a, b, f);
            l = e;
            return a | 0;
        }
        function ur(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = c[d + 4 >> 2] | 0;
            c[g >> 2] = c[d >> 2];
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            vr(a, b, f);
            l = e;
            return a | 0;
        }
        function vr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            wr(a, d, f, 1);
            l = e;
            return;
        }
        function wr(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = xr() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = yr(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, zr(g, e) | 0, e);
            l = f;
            return;
        }
        function xr() {
            var b = 0, d = 0;
            if (!(a[7840] | 0)) {
                Gr(10100);
                Ha(48, 10100, o | 0);
                d = 7840;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10100) | 0)) {
                b = 10100;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Gr(10100);
            }
            return 10100;
        }
        function yr(a) {
            a = a | 0;
            return 0;
        }
        function zr(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = xr() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Ar(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Br(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Ar(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Br(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Cr(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Dr(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Ar(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Er(a, i);
                Fr(i);
                l = k;
                return;
            }
        }
        function Cr(a) {
            a = a | 0;
            return 357913941;
        }
        function Dr(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Er(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Fr(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Gr(a) {
            a = a | 0;
            Jr(a);
            return;
        }
        function Hr(a) {
            a = a | 0;
            Ir(a + 24 | 0);
            return;
        }
        function Ir(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function Jr(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 6, b, Kr() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Kr() {
            return 1364;
        }
        function Lr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = Mr(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            d = Nr(b, f, d) | 0;
            l = e;
            return d | 0;
        }
        function Mr(a) {
            a = a | 0;
            return (c[(xr() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function Nr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            tj(f, d);
            f = uj(f, d) | 0;
            f = Qj(wb[e & 15](a, f) | 0) | 0;
            l = g;
            return f | 0;
        }
        function Or(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            Pr(a, d, f, 0);
            l = e;
            return;
        }
        function Pr(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = Qr() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = Rr(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, Sr(g, e) | 0, e);
            l = f;
            return;
        }
        function Qr() {
            var b = 0, d = 0;
            if (!(a[7848] | 0)) {
                Zr(10136);
                Ha(49, 10136, o | 0);
                d = 7848;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10136) | 0)) {
                b = 10136;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Zr(10136);
            }
            return 10136;
        }
        function Rr(a) {
            a = a | 0;
            return 0;
        }
        function Sr(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = Qr() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                Tr(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                Ur(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function Tr(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function Ur(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = Vr(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                Wr(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                Tr(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                Xr(a, i);
                Yr(i);
                l = k;
                return;
            }
        }
        function Vr(a) {
            a = a | 0;
            return 357913941;
        }
        function Wr(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function Xr(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Yr(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Zr(a) {
            a = a | 0;
            as(a);
            return;
        }
        function _r(a) {
            a = a | 0;
            $r(a + 24 | 0);
            return;
        }
        function $r(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function as(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 9, b, bs() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function bs() {
            return 1372;
        }
        function cs(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            h = ds(a) | 0;
            a = c[h + 4 >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = a;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            es(b, f, d);
            l = e;
            return;
        }
        function ds(a) {
            a = a | 0;
            return (c[(Qr() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function es(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            var e = 0, f = 0, g = 0, h = ib;
            g = l;
            l = l + 16 | 0;
            f = g;
            e = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) e = c[(c[a >> 2] | 0) + e >> 2] | 0;
            fs(f, d);
            h = T(gs(f, d));
            kb[e & 1](a, h);
            l = g;
            return;
        }
        function fs(a, b) {
            a = a | 0;
            b = +b;
            return;
        }
        function gs(a, b) {
            a = a | 0;
            b = +b;
            return T(hs(b));
        }
        function hs(a) {
            a = +a;
            return T(a);
        }
        function is(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 16 | 0;
            f = e + 8 | 0;
            g = e;
            i = c[d >> 2] | 0;
            h = c[d + 4 >> 2] | 0;
            d = ai(b) | 0;
            c[g >> 2] = i;
            c[g + 4 >> 2] = h;
            c[f >> 2] = c[g >> 2];
            c[f + 4 >> 2] = c[g + 4 >> 2];
            js(a, d, f, 0);
            l = e;
            return;
        }
        function js(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            f = l;
            l = l + 32 | 0;
            g = f + 16 | 0;
            m = f + 8 | 0;
            i = f;
            k = c[d >> 2] | 0;
            j = c[d + 4 >> 2] | 0;
            h = c[a >> 2] | 0;
            a = ks() | 0;
            c[m >> 2] = k;
            c[m + 4 >> 2] = j;
            c[g >> 2] = c[m >> 2];
            c[g + 4 >> 2] = c[m + 4 >> 2];
            d = ls(g) | 0;
            c[i >> 2] = k;
            c[i + 4 >> 2] = j;
            c[g >> 2] = c[i >> 2];
            c[g + 4 >> 2] = c[i + 4 >> 2];
            fi(h, b, a, d, ms(g, e) | 0, e);
            l = f;
            return;
        }
        function ks() {
            var b = 0, d = 0;
            if (!(a[7856] | 0)) {
                ts(10172);
                Ha(50, 10172, o | 0);
                d = 7856;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10172) | 0)) {
                b = 10172;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                ts(10172);
            }
            return 10172;
        }
        function ls(a) {
            a = a | 0;
            return 0;
        }
        function ms(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            m = l;
            l = l + 32 | 0;
            f = m + 24 | 0;
            h = m + 16 | 0;
            i = m;
            j = m + 8 | 0;
            g = c[a >> 2] | 0;
            e = c[a + 4 >> 2] | 0;
            c[i >> 2] = g;
            c[i + 4 >> 2] = e;
            n = ks() | 0;
            k = n + 24 | 0;
            a = ji(b, 4) | 0;
            c[j >> 2] = a;
            b = n + 28 | 0;
            d = c[b >> 2] | 0;
            if (d >>> 0 < (c[n + 32 >> 2] | 0) >>> 0) {
                c[h >> 2] = g;
                c[h + 4 >> 2] = e;
                c[f >> 2] = c[h >> 2];
                c[f + 4 >> 2] = c[h + 4 >> 2];
                ns(d, f, a);
                a = (c[b >> 2] | 0) + 12 | 0;
                c[b >> 2] = a;
            } else {
                os(k, i, j);
                a = c[b >> 2] | 0;
            }
            l = m;
            return ((a - (c[k >> 2] | 0) | 0) / 12 | 0) + -1 | 0;
        }
        function ns(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0;
            e = c[b + 4 >> 2] | 0;
            c[a >> 2] = c[b >> 2];
            c[a + 4 >> 2] = e;
            c[a + 8 >> 2] = d;
            return;
        }
        function os(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0;
            k = l;
            l = l + 48 | 0;
            e = k + 32 | 0;
            h = k + 24 | 0;
            i = k;
            j = a + 4 | 0;
            f = (((c[j >> 2] | 0) - (c[a >> 2] | 0) | 0) / 12 | 0) + 1 | 0;
            g = ps(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                m = c[a >> 2] | 0;
                o = ((c[a + 8 >> 2] | 0) - m | 0) / 12 | 0;
                n = o << 1;
                qs(i, o >>> 0 < g >>> 1 >>> 0 ? n >>> 0 < f >>> 0 ? f : n : g, ((c[j >> 2] | 0) - m | 0) / 12 | 0, a + 8 | 0);
                j = i + 8 | 0;
                g = c[j >> 2] | 0;
                f = c[b + 4 >> 2] | 0;
                d = c[d >> 2] | 0;
                c[h >> 2] = c[b >> 2];
                c[h + 4 >> 2] = f;
                c[e >> 2] = c[h >> 2];
                c[e + 4 >> 2] = c[h + 4 >> 2];
                ns(g, e, d);
                c[j >> 2] = (c[j >> 2] | 0) + 12;
                rs(a, i);
                ss(i);
                l = k;
                return;
            }
        }
        function ps(a) {
            a = a | 0;
            return 357913941;
        }
        function qs(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 357913941) Ta();
                else {
                    f = qC(b * 12 | 0) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d * 12 | 0) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b * 12 | 0);
            return;
        }
        function rs(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (((f | 0) / -12 | 0) * 12 | 0) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function ss(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~(((e + -12 - b | 0) >>> 0) / 12 | 0) * 12 | 0);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function ts(a) {
            a = a | 0;
            ws(a);
            return;
        }
        function us(a) {
            a = a | 0;
            vs(a + 24 | 0);
            return;
        }
        function vs(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~(((b + -12 - e | 0) >>> 0) / 12 | 0) * 12 | 0);
                sC(d);
            }
            return;
        }
        function ws(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 2, 3, b, xs() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function xs() {
            return 1380;
        }
        function ys(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            f = l;
            l = l + 16 | 0;
            g = f + 8 | 0;
            h = f;
            i = zs(a) | 0;
            a = c[i + 4 >> 2] | 0;
            c[h >> 2] = c[i >> 2];
            c[h + 4 >> 2] = a;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = c[h + 4 >> 2];
            As(b, g, d, e);
            l = f;
            return;
        }
        function zs(a) {
            a = a | 0;
            return (c[(ks() | 0) + 24 >> 2] | 0) + (a * 12 | 0) | 0;
        }
        function As(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            i = l;
            l = l + 16 | 0;
            g = i + 1 | 0;
            h = i;
            f = c[b >> 2] | 0;
            b = c[b + 4 >> 2] | 0;
            a = a + (b >> 1) | 0;
            if (b & 1) f = c[(c[a >> 2] | 0) + f >> 2] | 0;
            tj(g, d);
            g = uj(g, d) | 0;
            Bs(h, e);
            h = Cs(h, e) | 0;
            Eb[f & 15](a, g, h);
            l = i;
            return;
        }
        function Bs(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function Cs(a, b) {
            a = a | 0;
            b = b | 0;
            return Ds(b) | 0;
        }
        function Ds(a) {
            a = a | 0;
            return (a | 0) != 0 | 0;
        }
        function Es(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = Fs() | 0;
            a = Gs(d) | 0;
            fi(g, b, f, a, Hs(d, e) | 0, e);
            return;
        }
        function Fs() {
            var b = 0, d = 0;
            if (!(a[7864] | 0)) {
                Os(10208);
                Ha(51, 10208, o | 0);
                d = 7864;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10208) | 0)) {
                b = 10208;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Os(10208);
            }
            return 10208;
        }
        function Gs(a) {
            a = a | 0;
            return a | 0;
        }
        function Hs(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = Fs() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                Is(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                Js(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function Is(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Js(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = Ks(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                Ls(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                Is(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                Ms(a, f);
                Ns(f);
                l = i;
                return;
            }
        }
        function Ks(a) {
            a = a | 0;
            return 536870911;
        }
        function Ls(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function Ms(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Ns(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Os(a) {
            a = a | 0;
            Rs(a);
            return;
        }
        function Ps(a) {
            a = a | 0;
            Qs(a + 24 | 0);
            return;
        }
        function Qs(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function Rs(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 24, b, Ss() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Ss() {
            return 1392;
        }
        function Ts(a, b) {
            a = a | 0;
            b = b | 0;
            Vs(c[(Us(a) | 0) >> 2] | 0, b);
            return;
        }
        function Us(a) {
            a = a | 0;
            return (c[(Fs() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function Vs(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0;
            c = l;
            l = l + 16 | 0;
            d = c;
            Lq(d, b);
            b = Mq(d, b) | 0;
            nb[a & 127](b);
            l = c;
            return;
        }
        function Ws(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = Xs() | 0;
            a = Ys(d) | 0;
            fi(g, b, f, a, Zs(d, e) | 0, e);
            return;
        }
        function Xs() {
            var b = 0, d = 0;
            if (!(a[7872] | 0)) {
                et(10244);
                Ha(52, 10244, o | 0);
                d = 7872;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10244) | 0)) {
                b = 10244;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                et(10244);
            }
            return 10244;
        }
        function Ys(a) {
            a = a | 0;
            return a | 0;
        }
        function Zs(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = Xs() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                _s(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                $s(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function _s(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function $s(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = at(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                bt(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                _s(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                ct(a, f);
                dt(f);
                l = i;
                return;
            }
        }
        function at(a) {
            a = a | 0;
            return 536870911;
        }
        function bt(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function ct(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function dt(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function et(a) {
            a = a | 0;
            ht(a);
            return;
        }
        function ft(a) {
            a = a | 0;
            gt(a + 24 | 0);
            return;
        }
        function gt(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function ht(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 16, b, it() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function it() {
            return 1400;
        }
        function jt(a) {
            a = a | 0;
            return lt(c[(kt(a) | 0) >> 2] | 0) | 0;
        }
        function kt(a) {
            a = a | 0;
            return (c[(Xs() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function lt(a) {
            a = a | 0;
            return mt(Ab[a & 7]() | 0) | 0;
        }
        function mt(a) {
            a = a | 0;
            return a | 0;
        }
        function nt() {
            var b = 0;
            if (!(a[7880] | 0)) {
                ut(10280);
                Ha(25, 10280, o | 0);
                b = 7880;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10280;
        }
        function ot(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = pt() | 0;
            c[a + 4 >> 2] = qt() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = rt() | 0;
            c[a + 32 >> 2] = 4;
            return;
        }
        function pt() {
            return 11711;
        }
        function qt() {
            return 1356;
        }
        function rt() {
            return lr() | 0;
        }
        function st(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    tt(c);
                    sC(c);
                }
            } else if (b | 0) {
                mf(b);
                sC(b);
            }
            return;
        }
        function tt(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function ut(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function vt(a) {
            a = a | 0;
            wt(a, 4920);
            xt(a);
            yt(a);
            return;
        }
        function wt(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = nn() | 0;
            c[a >> 2] = d;
            Yt(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function xt(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            At(b, Mt() | 0);
            return a | 0;
        }
        function yt(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            At(b, zt() | 0);
            return a | 0;
        }
        function zt() {
            var b = 0;
            if (!(a[7888] | 0)) {
                Bt(10328);
                Ha(53, 10328, o | 0);
                b = 7888;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            if (!(si(10328) | 0)) Bt(10328);
            return 10328;
        }
        function At(a, b) {
            a = a | 0;
            b = b | 0;
            fi(a, 0, b, 0, 0, 0);
            return;
        }
        function Bt(a) {
            a = a | 0;
            Et(a);
            Gt(a, 10);
            return;
        }
        function Ct(a) {
            a = a | 0;
            Dt(a + 24 | 0);
            return;
        }
        function Dt(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function Et(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 5, 1, b, Jt() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Ft(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = +c;
            Ht(a, b, c);
            return;
        }
        function Gt(a, b) {
            a = a | 0;
            b = b | 0;
            c[a + 20 >> 2] = b;
            return;
        }
        function Ht(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = +d;
            var e = 0, f = 0, g = 0, i = 0, j = 0;
            e = l;
            l = l + 16 | 0;
            g = e + 8 | 0;
            j = e + 13 | 0;
            f = e;
            i = e + 12 | 0;
            tj(j, b);
            c[g >> 2] = uj(j, b) | 0;
            rj(i, d);
            h[f >> 3] = +sj(i, d);
            It(a, g, f);
            l = e;
            return;
        }
        function It(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            mg(b + 8 | 0, c[d >> 2] | 0, +h[e >> 3]);
            a[b + 24 >> 0] = 1;
            return;
        }
        function Jt() {
            return 1404;
        }
        function Kt(a, b) {
            a = a | 0;
            b = +b;
            return Lt(a, b) | 0;
        }
        function Lt(a, b) {
            a = a | 0;
            b = +b;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            e = l;
            l = l + 16 | 0;
            g = e + 4 | 0;
            h = e + 8 | 0;
            i = e;
            f = jy(8) | 0;
            d = f;
            j = qC(16) | 0;
            tj(g, a);
            a = uj(g, a) | 0;
            rj(h, b);
            mg(j, a, +sj(h, b));
            h = d + 4 | 0;
            c[h >> 2] = j;
            a = qC(8) | 0;
            h = c[h >> 2] | 0;
            c[i >> 2] = 0;
            c[g >> 2] = c[i >> 2];
            qn(a, h, g);
            c[f >> 2] = a;
            l = e;
            return d | 0;
        }
        function Mt() {
            var b = 0;
            if (!(a[7896] | 0)) {
                Nt(10364);
                Ha(54, 10364, o | 0);
                b = 7896;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            if (!(si(10364) | 0)) Nt(10364);
            return 10364;
        }
        function Nt(a) {
            a = a | 0;
            Qt(a);
            Gt(a, 55);
            return;
        }
        function Ot(a) {
            a = a | 0;
            Pt(a + 24 | 0);
            return;
        }
        function Pt(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function Qt(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 5, 4, b, Vt() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Rt(a) {
            a = a | 0;
            St(a);
            return;
        }
        function St(a) {
            a = a | 0;
            Tt(a);
            return;
        }
        function Tt(b) {
            b = b | 0;
            Ut(b + 8 | 0);
            a[b + 24 >> 0] = 1;
            return;
        }
        function Ut(a) {
            a = a | 0;
            c[a >> 2] = 0;
            h[a + 8 >> 3] = 0.0;
            return;
        }
        function Vt() {
            return 1424;
        }
        function Wt() {
            return Xt() | 0;
        }
        function Xt() {
            var a = 0, b = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            b = l;
            l = l + 16 | 0;
            f = b + 4 | 0;
            h = b;
            d = jy(8) | 0;
            a = d;
            e = qC(16) | 0;
            Ut(e);
            g = a + 4 | 0;
            c[g >> 2] = e;
            e = qC(8) | 0;
            g = c[g >> 2] | 0;
            c[h >> 2] = 0;
            c[f >> 2] = c[h >> 2];
            qn(e, g, f);
            c[d >> 2] = e;
            l = b;
            return a | 0;
        }
        function Yt(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = Zt() | 0;
            c[a + 4 >> 2] = _t() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = $t() | 0;
            c[a + 32 >> 2] = 5;
            return;
        }
        function Zt() {
            return 11710;
        }
        function _t() {
            return 1416;
        }
        function $t() {
            return cu() | 0;
        }
        function au(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    bu(c);
                    sC(c);
                }
            } else if (b | 0) sC(b);
            return;
        }
        function bu(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function cu() {
            var b = 0;
            if (!(a[7904] | 0)) {
                c[2600] = du() | 0;
                c[2601] = 0;
                b = 7904;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10400;
        }
        function du() {
            return c[357] | 0;
        }
        function eu(a) {
            a = a | 0;
            fu(a, 4926);
            gu(a);
            return;
        }
        function fu(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = Ci() | 0;
            c[a >> 2] = d;
            su(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function gu(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            At(b, hu() | 0);
            return a | 0;
        }
        function hu() {
            var b = 0;
            if (!(a[7912] | 0)) {
                iu(10412);
                Ha(56, 10412, o | 0);
                b = 7912;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            if (!(si(10412) | 0)) iu(10412);
            return 10412;
        }
        function iu(a) {
            a = a | 0;
            lu(a);
            Gt(a, 57);
            return;
        }
        function ju(a) {
            a = a | 0;
            ku(a + 24 | 0);
            return;
        }
        function ku(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function lu(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 5, 5, b, pu() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function mu(a) {
            a = a | 0;
            nu(a);
            return;
        }
        function nu(a) {
            a = a | 0;
            ou(a);
            return;
        }
        function ou(b) {
            b = b | 0;
            var d = 0, e = 0;
            d = b + 8 | 0;
            e = d + 48 | 0;
            do {
                c[d >> 2] = 0;
                d = d + 4 | 0;
            }while ((d | 0) < (e | 0));
            a[b + 56 >> 0] = 1;
            return;
        }
        function pu() {
            return 1432;
        }
        function qu() {
            return ru() | 0;
        }
        function ru() {
            var a = 0, b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            h = l;
            l = l + 16 | 0;
            a = h + 4 | 0;
            b = h;
            d = jy(8) | 0;
            e = d;
            f = qC(48) | 0;
            g = f;
            i = g + 48 | 0;
            do {
                c[g >> 2] = 0;
                g = g + 4 | 0;
            }while ((g | 0) < (i | 0));
            g = e + 4 | 0;
            c[g >> 2] = f;
            i = qC(8) | 0;
            g = c[g >> 2] | 0;
            c[b >> 2] = 0;
            c[a >> 2] = c[b >> 2];
            Ji(i, g, a);
            c[d >> 2] = i;
            l = h;
            return e | 0;
        }
        function su(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = tu() | 0;
            c[a + 4 >> 2] = uu() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = vu() | 0;
            c[a + 32 >> 2] = 6;
            return;
        }
        function tu() {
            return 11704;
        }
        function uu() {
            return 1436;
        }
        function vu() {
            return cu() | 0;
        }
        function wu(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    xu(c);
                    sC(c);
                }
            } else if (b | 0) sC(b);
            return;
        }
        function xu(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function yu(a) {
            a = a | 0;
            zu(a, 4933);
            Au(a);
            Bu(a);
            return;
        }
        function zu(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = cv() | 0;
            c[a >> 2] = d;
            dv(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function Au(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            At(b, Su() | 0);
            return a | 0;
        }
        function Bu(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            At(b, Cu() | 0);
            return a | 0;
        }
        function Cu() {
            var b = 0;
            if (!(a[7920] | 0)) {
                Du(10452);
                Ha(58, 10452, o | 0);
                b = 7920;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            if (!(si(10452) | 0)) Du(10452);
            return 10452;
        }
        function Du(a) {
            a = a | 0;
            Gu(a);
            Gt(a, 1);
            return;
        }
        function Eu(a) {
            a = a | 0;
            Fu(a + 24 | 0);
            return;
        }
        function Fu(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function Gu(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 5, 1, b, Lu() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Hu(a, b, c) {
            a = a | 0;
            b = +b;
            c = +c;
            Iu(a, b, c);
            return;
        }
        function Iu(a, b, c) {
            a = a | 0;
            b = +b;
            c = +c;
            var d = 0, e = 0, f = 0, g = 0, i = 0;
            d = l;
            l = l + 32 | 0;
            f = d + 8 | 0;
            i = d + 17 | 0;
            e = d;
            g = d + 16 | 0;
            rj(i, b);
            h[f >> 3] = +sj(i, b);
            rj(g, c);
            h[e >> 3] = +sj(g, c);
            Ju(a, f, e);
            l = d;
            return;
        }
        function Ju(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            Ku(b + 8 | 0, +h[c >> 3], +h[d >> 3]);
            a[b + 24 >> 0] = 1;
            return;
        }
        function Ku(a, b, c) {
            a = a | 0;
            b = +b;
            c = +c;
            h[a >> 3] = b;
            h[a + 8 >> 3] = c;
            return;
        }
        function Lu() {
            return 1472;
        }
        function Mu(a, b) {
            a = +a;
            b = +b;
            return Nu(a, b) | 0;
        }
        function Nu(a, b) {
            a = +a;
            b = +b;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            e = l;
            l = l + 16 | 0;
            h = e + 4 | 0;
            i = e + 8 | 0;
            j = e;
            f = jy(8) | 0;
            d = f;
            g = qC(16) | 0;
            rj(h, a);
            a = +sj(h, a);
            rj(i, b);
            Ku(g, a, +sj(i, b));
            i = d + 4 | 0;
            c[i >> 2] = g;
            g = qC(8) | 0;
            i = c[i >> 2] | 0;
            c[j >> 2] = 0;
            c[h >> 2] = c[j >> 2];
            Ou(g, i, h);
            c[f >> 2] = g;
            l = e;
            return d | 0;
        }
        function Ou(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            d = qC(16) | 0;
            c[d + 4 >> 2] = 0;
            c[d + 8 >> 2] = 0;
            c[d >> 2] = 1452;
            c[d + 12 >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Pu(a) {
            a = a | 0;
            kC(a);
            sC(a);
            return;
        }
        function Qu(a) {
            a = a | 0;
            a = c[a + 12 >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Ru(a) {
            a = a | 0;
            sC(a);
            return;
        }
        function Su() {
            var b = 0;
            if (!(a[7928] | 0)) {
                Tu(10488);
                Ha(59, 10488, o | 0);
                b = 7928;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            if (!(si(10488) | 0)) Tu(10488);
            return 10488;
        }
        function Tu(a) {
            a = a | 0;
            Wu(a);
            Gt(a, 60);
            return;
        }
        function Uu(a) {
            a = a | 0;
            Vu(a + 24 | 0);
            return;
        }
        function Vu(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function Wu(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 5, 6, b, $u() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Xu(a) {
            a = a | 0;
            Yu(a);
            return;
        }
        function Yu(a) {
            a = a | 0;
            Zu(a);
            return;
        }
        function Zu(b) {
            b = b | 0;
            _u(b + 8 | 0);
            a[b + 24 >> 0] = 1;
            return;
        }
        function _u(a) {
            a = a | 0;
            c[a >> 2] = 0;
            c[a + 4 >> 2] = 0;
            c[a + 8 >> 2] = 0;
            c[a + 12 >> 2] = 0;
            return;
        }
        function $u() {
            return 1492;
        }
        function av() {
            return bv() | 0;
        }
        function bv() {
            var a = 0, b = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            b = l;
            l = l + 16 | 0;
            f = b + 4 | 0;
            h = b;
            d = jy(8) | 0;
            a = d;
            e = qC(16) | 0;
            _u(e);
            g = a + 4 | 0;
            c[g >> 2] = e;
            e = qC(8) | 0;
            g = c[g >> 2] | 0;
            c[h >> 2] = 0;
            c[f >> 2] = c[h >> 2];
            Ou(e, g, f);
            c[d >> 2] = e;
            l = b;
            return a | 0;
        }
        function cv() {
            var b = 0;
            if (!(a[7936] | 0)) {
                jv(10524);
                Ha(25, 10524, o | 0);
                b = 7936;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10524;
        }
        function dv(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = ev() | 0;
            c[a + 4 >> 2] = fv() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = gv() | 0;
            c[a + 32 >> 2] = 7;
            return;
        }
        function ev() {
            return 11700;
        }
        function fv() {
            return 1484;
        }
        function gv() {
            return cu() | 0;
        }
        function hv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    iv(c);
                    sC(c);
                }
            } else if (b | 0) sC(b);
            return;
        }
        function iv(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function jv(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function kv(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            a = ai(b) | 0;
            b = lv(c) | 0;
            c = mv(c, 0) | 0;
            Zv(a, b, c, nv() | 0, 0);
            return;
        }
        function lv(a) {
            a = a | 0;
            return a | 0;
        }
        function mv(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = nv() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                vv(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                wv(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function nv() {
            var b = 0, d = 0;
            if (!(a[7944] | 0)) {
                ov(10568);
                Ha(61, 10568, o | 0);
                d = 7944;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10568) | 0)) {
                b = 10568;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                ov(10568);
            }
            return 10568;
        }
        function ov(a) {
            a = a | 0;
            rv(a);
            return;
        }
        function pv(a) {
            a = a | 0;
            qv(a + 24 | 0);
            return;
        }
        function qv(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function rv(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 17, b, ql() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function sv(a) {
            a = a | 0;
            return uv(c[(tv(a) | 0) >> 2] | 0) | 0;
        }
        function tv(a) {
            a = a | 0;
            return (c[(nv() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function uv(a) {
            a = a | 0;
            return ul(Ab[a & 7]() | 0) | 0;
        }
        function vv(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function wv(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = xv(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                yv(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                vv(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                zv(a, f);
                Av(f);
                l = i;
                return;
            }
        }
        function xv(a) {
            a = a | 0;
            return 536870911;
        }
        function yv(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function zv(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Av(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Bv() {
            Cv();
            return;
        }
        function Cv() {
            Dv(10604);
            return;
        }
        function Dv(a) {
            a = a | 0;
            Ev(a, 4955);
            return;
        }
        function Ev(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = Fv() | 0;
            c[a >> 2] = d;
            Gv(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function Fv() {
            var b = 0;
            if (!(a[7952] | 0)) {
                Rv(10612);
                Ha(25, 10612, o | 0);
                b = 7952;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10612;
        }
        function Gv(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = Mv() | 0;
            c[a + 4 >> 2] = Nv() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = Ov() | 0;
            c[a + 32 >> 2] = 8;
            return;
        }
        function Hv(a) {
            a = a | 0;
            var b = 0, d = 0;
            b = l;
            l = l + 16 | 0;
            d = b;
            Iv();
            c[d >> 2] = a;
            Jv(10608, d);
            l = b;
            return;
        }
        function Iv() {
            if (!(a[11714] | 0)) {
                c[2652] = 0;
                Ha(62, 10608, o | 0);
                a[11714] = 1;
            }
            return 10608;
        }
        function Jv(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = qC(8) | 0;
            c[d + 4 >> 2] = c[b >> 2];
            c[d >> 2] = c[a >> 2];
            c[a >> 2] = d;
            return;
        }
        function Kv(a) {
            a = a | 0;
            Lv(a);
            return;
        }
        function Lv(a) {
            a = a | 0;
            var b = 0, d = 0;
            b = c[a >> 2] | 0;
            if (b | 0) do {
                d = b;
                b = c[b >> 2] | 0;
                sC(d);
            }while ((b | 0) != 0);
            c[a >> 2] = 0;
            return;
        }
        function Mv() {
            return 11715;
        }
        function Nv() {
            return 1496;
        }
        function Ov() {
            return lr() | 0;
        }
        function Pv(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    Qv(c);
                    sC(c);
                }
            } else if (b | 0) sC(b);
            return;
        }
        function Qv(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function Rv(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function Sv(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            Iv();
            d = c[2652] | 0;
            a: do if (d | 0) {
                while(true){
                    e = c[d + 4 >> 2] | 0;
                    if (e | 0 ? (AB(Tv(e) | 0, a) | 0) == 0 : 0) break;
                    d = c[d >> 2] | 0;
                    if (!d) break a;
                }
                Uv(e, b);
            }
            while (0);
            return;
        }
        function Tv(a) {
            a = a | 0;
            return c[a + 12 >> 2] | 0;
        }
        function Uv(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            a = a + 36 | 0;
            d = c[a >> 2] | 0;
            if (d | 0) {
                vf(d);
                sC(d);
            }
            d = qC(4) | 0;
            Og(d, b);
            c[a >> 2] = d;
            return;
        }
        function Vv() {
            if (!(a[11716] | 0)) {
                c[2664] = 0;
                Ha(63, 10656, o | 0);
                a[11716] = 1;
            }
            return 10656;
        }
        function Wv() {
            var b = 0;
            if (!(a[11717] | 0)) {
                Xv();
                c[2665] = 1504;
                a[11717] = 1;
                b = 1504;
            } else b = c[2665] | 0;
            return b | 0;
        }
        function Xv() {
            if (!(a[11740] | 0)) {
                a[11718] = ji(ji(8, 0) | 0, 0) | 0;
                a[11719] = ji(ji(0, 0) | 0, 0) | 0;
                a[11720] = ji(ji(0, 16) | 0, 0) | 0;
                a[11721] = ji(ji(8, 0) | 0, 0) | 0;
                a[11722] = ji(ji(0, 0) | 0, 0) | 0;
                a[11723] = ji(ji(8, 0) | 0, 0) | 0;
                a[11724] = ji(ji(0, 0) | 0, 0) | 0;
                a[11725] = ji(ji(8, 0) | 0, 0) | 0;
                a[11726] = ji(ji(0, 0) | 0, 0) | 0;
                a[11727] = ji(ji(8, 0) | 0, 0) | 0;
                a[11728] = ji(ji(0, 0) | 0, 0) | 0;
                a[11729] = ji(ji(0, 0) | 0, 32) | 0;
                a[11730] = ji(ji(0, 0) | 0, 32) | 0;
                a[11740] = 1;
            }
            return;
        }
        function Yv() {
            return 1572;
        }
        function Zv(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            g = l;
            l = l + 32 | 0;
            m = g + 16 | 0;
            k = g + 12 | 0;
            j = g + 8 | 0;
            i = g + 4 | 0;
            h = g;
            c[m >> 2] = a;
            c[k >> 2] = b;
            c[j >> 2] = d;
            c[i >> 2] = e;
            c[h >> 2] = f;
            Vv();
            _v(10656, m, k, j, i, h);
            l = g;
            return;
        }
        function _v(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0;
            h = qC(24) | 0;
            ii(h + 4 | 0, c[b >> 2] | 0, c[d >> 2] | 0, c[e >> 2] | 0, c[f >> 2] | 0, c[g >> 2] | 0);
            c[h >> 2] = c[a >> 2];
            c[a >> 2] = h;
            return;
        }
        function $v(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0;
            u = l;
            l = l + 32 | 0;
            q = u + 20 | 0;
            r = u + 8 | 0;
            s = u + 4 | 0;
            t = u;
            b = c[b >> 2] | 0;
            if (b | 0) {
                p = q + 4 | 0;
                j = q + 8 | 0;
                k = r + 4 | 0;
                m = r + 8 | 0;
                n = r + 8 | 0;
                o = q + 8 | 0;
                do {
                    h = b + 4 | 0;
                    i = aw(h) | 0;
                    if (i | 0) {
                        f = bw(i) | 0;
                        c[q >> 2] = 0;
                        c[p >> 2] = 0;
                        c[j >> 2] = 0;
                        e = (cw(i) | 0) + 1 | 0;
                        dw(q, e);
                        if (e | 0) while(true){
                            e = e + -1 | 0;
                            OA(r, c[f >> 2] | 0);
                            g = c[p >> 2] | 0;
                            if (g >>> 0 < (c[o >> 2] | 0) >>> 0) {
                                c[g >> 2] = c[r >> 2];
                                c[p >> 2] = (c[p >> 2] | 0) + 4;
                            } else ew(q, r);
                            if (!e) break;
                            else f = f + 4 | 0;
                        }
                        e = fw(i) | 0;
                        c[r >> 2] = 0;
                        c[k >> 2] = 0;
                        c[m >> 2] = 0;
                        a: if (c[e >> 2] | 0) {
                            f = 0;
                            g = 0;
                            while(true){
                                if ((f | 0) == (g | 0)) gw(r, e);
                                else {
                                    c[f >> 2] = c[e >> 2];
                                    c[k >> 2] = (c[k >> 2] | 0) + 4;
                                }
                                e = e + 4 | 0;
                                if (!(c[e >> 2] | 0)) break a;
                                f = c[k >> 2] | 0;
                                g = c[n >> 2] | 0;
                            }
                        }
                        c[s >> 2] = hw(h) | 0;
                        c[t >> 2] = si(i) | 0;
                        iw(d, a, s, t, q, r);
                        jw(r);
                        kw(q);
                    }
                    b = c[b >> 2] | 0;
                }while ((b | 0) != 0);
            }
            l = u;
            return;
        }
        function aw(a) {
            a = a | 0;
            return c[a + 12 >> 2] | 0;
        }
        function bw(a) {
            a = a | 0;
            return c[a + 12 >> 2] | 0;
        }
        function cw(a) {
            a = a | 0;
            return c[a + 16 >> 2] | 0;
        }
        function dw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            f = l;
            l = l + 32 | 0;
            d = f;
            e = c[a >> 2] | 0;
            if ((c[a + 8 >> 2] | 0) - e >> 2 >>> 0 < b >>> 0) {
                Rw(d, b, (c[a + 4 >> 2] | 0) - e >> 2, a + 8 | 0);
                Sw(a, d);
                Tw(d);
            }
            l = f;
            return;
        }
        function ew(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            h = l;
            l = l + 32 | 0;
            d = h;
            e = a + 4 | 0;
            f = ((c[e >> 2] | 0) - (c[a >> 2] | 0) >> 2) + 1 | 0;
            g = Nw(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                i = c[a >> 2] | 0;
                k = (c[a + 8 >> 2] | 0) - i | 0;
                j = k >> 1;
                Rw(d, k >> 2 >>> 0 < g >>> 1 >>> 0 ? j >>> 0 < f >>> 0 ? f : j : g, (c[e >> 2] | 0) - i >> 2, a + 8 | 0);
                g = d + 8 | 0;
                c[c[g >> 2] >> 2] = c[b >> 2];
                c[g >> 2] = (c[g >> 2] | 0) + 4;
                Sw(a, d);
                Tw(d);
                l = h;
                return;
            }
        }
        function fw(a) {
            a = a | 0;
            return c[a + 8 >> 2] | 0;
        }
        function gw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0;
            h = l;
            l = l + 32 | 0;
            d = h;
            e = a + 4 | 0;
            f = ((c[e >> 2] | 0) - (c[a >> 2] | 0) >> 2) + 1 | 0;
            g = Kw(a) | 0;
            if (g >>> 0 < f >>> 0) jC(a);
            else {
                i = c[a >> 2] | 0;
                k = (c[a + 8 >> 2] | 0) - i | 0;
                j = k >> 1;
                Ow(d, k >> 2 >>> 0 < g >>> 1 >>> 0 ? j >>> 0 < f >>> 0 ? f : j : g, (c[e >> 2] | 0) - i >> 2, a + 8 | 0);
                g = d + 8 | 0;
                c[c[g >> 2] >> 2] = c[b >> 2];
                c[g >> 2] = (c[g >> 2] | 0) + 4;
                Pw(a, d);
                Qw(d);
                l = h;
                return;
            }
        }
        function hw(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function iw(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            lw(a, b, c, d, e, f);
            return;
        }
        function jw(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);
                sC(d);
            }
            return;
        }
        function kw(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -4 - e | 0) >>> 2) << 2);
                sC(d);
            }
            return;
        }
        function lw(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            h = l;
            l = l + 48 | 0;
            m = h + 40 | 0;
            i = h + 32 | 0;
            n = h + 24 | 0;
            j = h + 12 | 0;
            k = h;
            UA(i);
            a = Sg(a) | 0;
            c[n >> 2] = c[b >> 2];
            d = c[d >> 2] | 0;
            e = c[e >> 2] | 0;
            mw(j, f);
            nw(k, g);
            c[m >> 2] = c[n >> 2];
            ow(a, m, d, e, j, k);
            jw(k);
            kw(j);
            WA(i);
            l = h;
            return;
        }
        function mw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            c[a >> 2] = 0;
            c[a + 4 >> 2] = 0;
            c[a + 8 >> 2] = 0;
            d = b + 4 | 0;
            e = (c[d >> 2] | 0) - (c[b >> 2] | 0) >> 2;
            if (e | 0) {
                Lw(a, e);
                Mw(a, c[b >> 2] | 0, c[d >> 2] | 0, e);
            }
            return;
        }
        function nw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            c[a >> 2] = 0;
            c[a + 4 >> 2] = 0;
            c[a + 8 >> 2] = 0;
            d = b + 4 | 0;
            e = (c[d >> 2] | 0) - (c[b >> 2] | 0) >> 2;
            if (e | 0) {
                Iw(a, e);
                Jw(a, c[b >> 2] | 0, c[d >> 2] | 0, e);
            }
            return;
        }
        function ow(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, m = 0, n = 0;
            h = l;
            l = l + 32 | 0;
            m = h + 28 | 0;
            n = h + 24 | 0;
            i = h + 12 | 0;
            j = h;
            k = Vg(pw() | 0) | 0;
            c[n >> 2] = c[b >> 2];
            c[m >> 2] = c[n >> 2];
            b = qw(m) | 0;
            d = rw(d) | 0;
            e = sw(e) | 0;
            c[i >> 2] = c[f >> 2];
            m = f + 4 | 0;
            c[i + 4 >> 2] = c[m >> 2];
            n = f + 8 | 0;
            c[i + 8 >> 2] = c[n >> 2];
            c[n >> 2] = 0;
            c[m >> 2] = 0;
            c[f >> 2] = 0;
            f = tw(i) | 0;
            c[j >> 2] = c[g >> 2];
            m = g + 4 | 0;
            c[j + 4 >> 2] = c[m >> 2];
            n = g + 8 | 0;
            c[j + 8 >> 2] = c[n >> 2];
            c[n >> 2] = 0;
            c[m >> 2] = 0;
            c[g >> 2] = 0;
            Ba(0, k | 0, a | 0, b | 0, d | 0, e | 0, f | 0, uw(j) | 0);
            jw(j);
            kw(i);
            l = h;
            return;
        }
        function pw() {
            var b = 0;
            if (!(a[7968] | 0)) {
                Gw(10708);
                b = 7968;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10708;
        }
        function qw(a) {
            a = a | 0;
            return yw(a) | 0;
        }
        function rw(a) {
            a = a | 0;
            return ww(a) | 0;
        }
        function sw(a) {
            a = a | 0;
            return ul(a) | 0;
        }
        function tw(a) {
            a = a | 0;
            return xw(a) | 0;
        }
        function uw(a) {
            a = a | 0;
            return vw(a) | 0;
        }
        function vw(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            e = (c[a + 4 >> 2] | 0) - (c[a >> 2] | 0) | 0;
            d = e >> 2;
            e = jy(e + 4 | 0) | 0;
            c[e >> 2] = d;
            if (d | 0) {
                b = 0;
                do {
                    c[e + 4 + (b << 2) >> 2] = ww(c[(c[a >> 2] | 0) + (b << 2) >> 2] | 0) | 0;
                    b = b + 1 | 0;
                }while ((b | 0) != (d | 0));
            }
            return e | 0;
        }
        function ww(a) {
            a = a | 0;
            return a | 0;
        }
        function xw(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            e = (c[a + 4 >> 2] | 0) - (c[a >> 2] | 0) | 0;
            d = e >> 2;
            e = jy(e + 4 | 0) | 0;
            c[e >> 2] = d;
            if (d | 0) {
                b = 0;
                do {
                    c[e + 4 + (b << 2) >> 2] = yw((c[a >> 2] | 0) + (b << 2) | 0) | 0;
                    b = b + 1 | 0;
                }while ((b | 0) != (d | 0));
            }
            return e | 0;
        }
        function yw(a) {
            a = a | 0;
            var b = 0, c = 0, d = 0, e = 0;
            e = l;
            l = l + 32 | 0;
            b = e + 12 | 0;
            c = e;
            d = Di(zw() | 0) | 0;
            if (!d) a = Aw(a) | 0;
            else {
                Ei(b, d);
                Fi(c, b);
                RA(a, c);
                a = Hi(b) | 0;
            }
            l = e;
            return a | 0;
        }
        function zw() {
            var b = 0;
            if (!(a[7960] | 0)) {
                Fw(10664);
                Ha(25, 10664, o | 0);
                b = 7960;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10664;
        }
        function Aw(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            d = l;
            l = l + 16 | 0;
            f = d + 4 | 0;
            h = d;
            e = jy(8) | 0;
            b = e;
            i = qC(4) | 0;
            c[i >> 2] = c[a >> 2];
            g = b + 4 | 0;
            c[g >> 2] = i;
            a = qC(8) | 0;
            g = c[g >> 2] | 0;
            c[h >> 2] = 0;
            c[f >> 2] = c[h >> 2];
            Bw(a, g, f);
            c[e >> 2] = a;
            l = d;
            return b | 0;
        }
        function Bw(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            d = qC(16) | 0;
            c[d + 4 >> 2] = 0;
            c[d + 8 >> 2] = 0;
            c[d >> 2] = 1656;
            c[d + 12 >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Cw(a) {
            a = a | 0;
            kC(a);
            sC(a);
            return;
        }
        function Dw(a) {
            a = a | 0;
            a = c[a + 12 >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Ew(a) {
            a = a | 0;
            sC(a);
            return;
        }
        function Fw(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function Gw(a) {
            a = a | 0;
            fh(a, Hw() | 0, 5);
            return;
        }
        function Hw() {
            return 1676;
        }
        function Iw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if ((Kw(a) | 0) >>> 0 < b >>> 0) jC(a);
            if (b >>> 0 > 1073741823) Ta();
            else {
                d = qC(b << 2) | 0;
                c[a + 4 >> 2] = d;
                c[a >> 2] = d;
                c[a + 8 >> 2] = d + (b << 2);
                return;
            }
        }
        function Jw(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            e = a + 4 | 0;
            a = d - b | 0;
            if ((a | 0) > 0) {
                BC(c[e >> 2] | 0, b | 0, a | 0);
                c[e >> 2] = (c[e >> 2] | 0) + (a >>> 2 << 2);
            }
            return;
        }
        function Kw(a) {
            a = a | 0;
            return 1073741823;
        }
        function Lw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            if ((Nw(a) | 0) >>> 0 < b >>> 0) jC(a);
            if (b >>> 0 > 1073741823) Ta();
            else {
                d = qC(b << 2) | 0;
                c[a + 4 >> 2] = d;
                c[a >> 2] = d;
                c[a + 8 >> 2] = d + (b << 2);
                return;
            }
        }
        function Mw(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            e = a + 4 | 0;
            a = d - b | 0;
            if ((a | 0) > 0) {
                BC(c[e >> 2] | 0, b | 0, a | 0);
                c[e >> 2] = (c[e >> 2] | 0) + (a >>> 2 << 2);
            }
            return;
        }
        function Nw(a) {
            a = a | 0;
            return 1073741823;
        }
        function Ow(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 1073741823) Ta();
                else {
                    f = qC(b << 2) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 2) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 2);
            return;
        }
        function Pw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 2) << 2) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Qw(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -4 - b | 0) >>> 2) << 2);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Rw(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 1073741823) Ta();
                else {
                    f = qC(b << 2) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 2) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 2);
            return;
        }
        function Sw(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 2) << 2) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Tw(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -4 - b | 0) >>> 2) << 2);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Uw(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0;
            r = l;
            l = l + 32 | 0;
            m = r + 20 | 0;
            n = r + 12 | 0;
            k = r + 16 | 0;
            o = r + 4 | 0;
            p = r;
            q = r + 8 | 0;
            i = Wv() | 0;
            g = c[i >> 2] | 0;
            h = c[g >> 2] | 0;
            if (h | 0) {
                j = c[i + 8 >> 2] | 0;
                i = c[i + 4 >> 2] | 0;
                while(true){
                    OA(m, h);
                    Vw(a, m, i, j);
                    g = g + 4 | 0;
                    h = c[g >> 2] | 0;
                    if (!h) break;
                    else {
                        j = j + 1 | 0;
                        i = i + 1 | 0;
                    }
                }
            }
            g = Yv() | 0;
            h = c[g >> 2] | 0;
            if (h | 0) do {
                OA(m, h);
                c[n >> 2] = c[g + 4 >> 2];
                Ww(b, m, n);
                g = g + 8 | 0;
                h = c[g >> 2] | 0;
            }while ((h | 0) != 0);
            g = c[(Iv() | 0) >> 2] | 0;
            if (g | 0) do {
                b = c[g + 4 >> 2] | 0;
                OA(m, c[(Xw(b) | 0) >> 2] | 0);
                c[n >> 2] = Tv(b) | 0;
                Yw(d, m, n);
                g = c[g >> 2] | 0;
            }while ((g | 0) != 0);
            OA(k, 0);
            g = Vv() | 0;
            c[m >> 2] = c[k >> 2];
            $v(m, g, f);
            g = c[(Iv() | 0) >> 2] | 0;
            if (g | 0) {
                a = m + 4 | 0;
                b = m + 8 | 0;
                d = m + 8 | 0;
                do {
                    j = c[g + 4 >> 2] | 0;
                    OA(n, c[(Xw(j) | 0) >> 2] | 0);
                    _w(o, Zw(j) | 0);
                    h = c[o >> 2] | 0;
                    if (h | 0) {
                        c[m >> 2] = 0;
                        c[a >> 2] = 0;
                        c[b >> 2] = 0;
                        do {
                            OA(p, c[(Xw(c[h + 4 >> 2] | 0) | 0) >> 2] | 0);
                            i = c[a >> 2] | 0;
                            if (i >>> 0 < (c[d >> 2] | 0) >>> 0) {
                                c[i >> 2] = c[p >> 2];
                                c[a >> 2] = (c[a >> 2] | 0) + 4;
                            } else ew(m, p);
                            h = c[h >> 2] | 0;
                        }while ((h | 0) != 0);
                        $w(e, n, m);
                        kw(m);
                    }
                    c[q >> 2] = c[n >> 2];
                    k = ax(j) | 0;
                    c[m >> 2] = c[q >> 2];
                    $v(m, k, f);
                    Wi(o);
                    g = c[g >> 2] | 0;
                }while ((g | 0) != 0);
            }
            l = r;
            return;
        }
        function Vw(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            ox(a, b, c, d);
            return;
        }
        function Ww(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            nx(a, b, c);
            return;
        }
        function Xw(a) {
            a = a | 0;
            return a | 0;
        }
        function Yw(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            ix(a, b, c);
            return;
        }
        function Zw(a) {
            a = a | 0;
            return a + 16 | 0;
        }
        function _w(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            g = l;
            l = l + 16 | 0;
            f = g + 8 | 0;
            d = g;
            c[a >> 2] = 0;
            e = c[b >> 2] | 0;
            c[f >> 2] = e;
            c[d >> 2] = a;
            d = gx(d) | 0;
            if (e | 0) {
                e = qC(12) | 0;
                h = (hx(f) | 0) + 4 | 0;
                a = c[h + 4 >> 2] | 0;
                b = e + 4 | 0;
                c[b >> 2] = c[h >> 2];
                c[b + 4 >> 2] = a;
                b = c[c[f >> 2] >> 2] | 0;
                c[f >> 2] = b;
                if (!b) a = e;
                else {
                    b = e;
                    while(true){
                        a = qC(12) | 0;
                        j = (hx(f) | 0) + 4 | 0;
                        i = c[j + 4 >> 2] | 0;
                        h = a + 4 | 0;
                        c[h >> 2] = c[j >> 2];
                        c[h + 4 >> 2] = i;
                        c[b >> 2] = a;
                        h = c[c[f >> 2] >> 2] | 0;
                        c[f >> 2] = h;
                        if (!h) break;
                        else b = a;
                    }
                }
                c[a >> 2] = c[d >> 2];
                c[d >> 2] = e;
            }
            l = g;
            return;
        }
        function $w(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            bx(a, b, c);
            return;
        }
        function ax(a) {
            a = a | 0;
            return a + 24 | 0;
        }
        function bx(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 32 | 0;
            h = e + 24 | 0;
            f = e + 16 | 0;
            i = e + 12 | 0;
            g = e;
            UA(f);
            a = Sg(a) | 0;
            c[i >> 2] = c[b >> 2];
            mw(g, d);
            c[h >> 2] = c[i >> 2];
            cx(a, h, g);
            kw(g);
            WA(f);
            l = e;
            return;
        }
        function cx(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0;
            e = l;
            l = l + 32 | 0;
            h = e + 16 | 0;
            i = e + 12 | 0;
            f = e;
            g = Vg(dx() | 0) | 0;
            c[i >> 2] = c[b >> 2];
            c[h >> 2] = c[i >> 2];
            b = qw(h) | 0;
            c[f >> 2] = c[d >> 2];
            h = d + 4 | 0;
            c[f + 4 >> 2] = c[h >> 2];
            i = d + 8 | 0;
            c[f + 8 >> 2] = c[i >> 2];
            c[i >> 2] = 0;
            c[h >> 2] = 0;
            c[d >> 2] = 0;
            xa(0, g | 0, a | 0, b | 0, tw(f) | 0);
            kw(f);
            l = e;
            return;
        }
        function dx() {
            var b = 0;
            if (!(a[7976] | 0)) {
                ex(10720);
                b = 7976;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10720;
        }
        function ex(a) {
            a = a | 0;
            fh(a, fx() | 0, 2);
            return;
        }
        function fx() {
            return 1732;
        }
        function gx(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function hx(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function ix(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 32 | 0;
            g = e + 16 | 0;
            f = e + 8 | 0;
            h = e;
            UA(f);
            a = Sg(a) | 0;
            c[h >> 2] = c[b >> 2];
            d = c[d >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            jx(a, g, d);
            WA(f);
            l = e;
            return;
        }
        function jx(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 16 | 0;
            g = e + 4 | 0;
            h = e;
            f = Vg(kx() | 0) | 0;
            c[h >> 2] = c[b >> 2];
            c[g >> 2] = c[h >> 2];
            b = qw(g) | 0;
            xa(0, f | 0, a | 0, b | 0, rw(d) | 0);
            l = e;
            return;
        }
        function kx() {
            var b = 0;
            if (!(a[7984] | 0)) {
                lx(10732);
                b = 7984;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10732;
        }
        function lx(a) {
            a = a | 0;
            fh(a, mx() | 0, 2);
            return;
        }
        function mx() {
            return 1744;
        }
        function nx(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0;
            e = l;
            l = l + 32 | 0;
            g = e + 16 | 0;
            f = e + 8 | 0;
            h = e;
            UA(f);
            a = Sg(a) | 0;
            c[h >> 2] = c[b >> 2];
            d = c[d >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            jx(a, g, d);
            WA(f);
            l = e;
            return;
        }
        function ox(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0;
            g = l;
            l = l + 32 | 0;
            i = g + 16 | 0;
            h = g + 8 | 0;
            j = g;
            UA(h);
            b = Sg(b) | 0;
            c[j >> 2] = c[d >> 2];
            e = a[e >> 0] | 0;
            f = a[f >> 0] | 0;
            c[i >> 2] = c[j >> 2];
            px(b, i, e, f);
            WA(h);
            l = g;
            return;
        }
        function px(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            f = l;
            l = l + 16 | 0;
            h = f + 4 | 0;
            i = f;
            g = Vg(qx() | 0) | 0;
            c[i >> 2] = c[b >> 2];
            c[h >> 2] = c[i >> 2];
            b = qw(h) | 0;
            d = rx(d) | 0;
            $a(0, g | 0, a | 0, b | 0, d | 0, rx(e) | 0);
            l = f;
            return;
        }
        function qx() {
            var b = 0;
            if (!(a[7992] | 0)) {
                tx(10744);
                b = 7992;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10744;
        }
        function rx(a) {
            a = a | 0;
            return sx(a) | 0;
        }
        function sx(a) {
            a = a | 0;
            return a & 255 | 0;
        }
        function tx(a) {
            a = a | 0;
            fh(a, ux() | 0, 3);
            return;
        }
        function ux() {
            return 1756;
        }
        function vx(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0;
            p = l;
            l = l + 32 | 0;
            j = p + 8 | 0;
            k = p + 4 | 0;
            m = p + 20 | 0;
            n = p;
            mk(b, 0);
            f = QA(d) | 0;
            c[j >> 2] = 0;
            o = j + 4 | 0;
            c[o >> 2] = 0;
            c[j + 8 >> 2] = 0;
            switch(f << 24 >> 24){
                case 0:
                    a[m >> 0] = 0;
                    wx(k, e, m);
                    xx(b, k);
                    wf(k);
                    break;
                case 8:
                    o = PA(d) | 0;
                    a[m >> 0] = 8;
                    OA(n, c[o + 4 >> 2] | 0);
                    yx(k, e, m, n, o + 8 | 0);
                    xx(b, k);
                    wf(k);
                    break;
                case 9:
                    h = PA(d) | 0;
                    d = c[h + 4 >> 2] | 0;
                    if (d | 0) {
                        i = j + 8 | 0;
                        g = h + 12 | 0;
                        while(true){
                            d = d + -1 | 0;
                            OA(k, c[g >> 2] | 0);
                            f = c[o >> 2] | 0;
                            if (f >>> 0 < (c[i >> 2] | 0) >>> 0) {
                                c[f >> 2] = c[k >> 2];
                                c[o >> 2] = (c[o >> 2] | 0) + 4;
                            } else ew(j, k);
                            if (!d) break;
                            else g = g + 4 | 0;
                        }
                    }
                    a[m >> 0] = 9;
                    OA(n, c[h + 8 >> 2] | 0);
                    zx(k, e, m, n, j);
                    xx(b, k);
                    wf(k);
                    break;
                default:
                    o = PA(d) | 0;
                    a[m >> 0] = f;
                    OA(n, c[o + 4 >> 2] | 0);
                    Ax(k, e, m, n);
                    xx(b, k);
                    wf(k);
            }
            kw(j);
            l = p;
            return;
        }
        function wx(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            e = l;
            l = l + 16 | 0;
            f = e;
            UA(f);
            c = Sg(c) | 0;
            Ox(b, c, a[d >> 0] | 0);
            WA(f);
            l = e;
            return;
        }
        function xx(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = c[a >> 2] | 0;
            if (d | 0) ab(d | 0);
            c[a >> 2] = c[b >> 2];
            c[b >> 2] = 0;
            return a | 0;
        }
        function yx(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0;
            h = l;
            l = l + 32 | 0;
            j = h + 16 | 0;
            i = h + 8 | 0;
            k = h;
            UA(i);
            d = Sg(d) | 0;
            e = a[e >> 0] | 0;
            c[k >> 2] = c[f >> 2];
            g = c[g >> 2] | 0;
            c[j >> 2] = c[k >> 2];
            Kx(b, d, e, j, g);
            WA(i);
            l = h;
            return;
        }
        function zx(b, d, e, f, g) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            var h = 0, i = 0, j = 0, k = 0, m = 0;
            h = l;
            l = l + 32 | 0;
            k = h + 24 | 0;
            i = h + 16 | 0;
            m = h + 12 | 0;
            j = h;
            UA(i);
            d = Sg(d) | 0;
            e = a[e >> 0] | 0;
            c[m >> 2] = c[f >> 2];
            mw(j, g);
            c[k >> 2] = c[m >> 2];
            Gx(b, d, e, k, j);
            kw(j);
            WA(i);
            l = h;
            return;
        }
        function Ax(b, d, e, f) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0;
            g = l;
            l = l + 32 | 0;
            i = g + 16 | 0;
            h = g + 8 | 0;
            j = g;
            UA(h);
            d = Sg(d) | 0;
            e = a[e >> 0] | 0;
            c[j >> 2] = c[f >> 2];
            c[i >> 2] = c[j >> 2];
            Bx(b, d, e, i);
            WA(h);
            l = g;
            return;
        }
        function Bx(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            f = l;
            l = l + 16 | 0;
            g = f + 4 | 0;
            i = f;
            h = Vg(Cx() | 0) | 0;
            d = rx(d) | 0;
            c[i >> 2] = c[e >> 2];
            c[g >> 2] = c[i >> 2];
            Dx(a, xa(0, h | 0, b | 0, d | 0, qw(g) | 0) | 0);
            l = f;
            return;
        }
        function Cx() {
            var b = 0;
            if (!(a[8e3] | 0)) {
                Ex(10756);
                b = 8e3;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10756;
        }
        function Dx(a, b) {
            a = a | 0;
            b = b | 0;
            mk(a, b);
            return;
        }
        function Ex(a) {
            a = a | 0;
            fh(a, Fx() | 0, 2);
            return;
        }
        function Fx() {
            return 1772;
        }
        function Gx(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0;
            g = l;
            l = l + 32 | 0;
            j = g + 16 | 0;
            k = g + 12 | 0;
            h = g;
            i = Vg(Hx() | 0) | 0;
            d = rx(d) | 0;
            c[k >> 2] = c[e >> 2];
            c[j >> 2] = c[k >> 2];
            e = qw(j) | 0;
            c[h >> 2] = c[f >> 2];
            j = f + 4 | 0;
            c[h + 4 >> 2] = c[j >> 2];
            k = f + 8 | 0;
            c[h + 8 >> 2] = c[k >> 2];
            c[k >> 2] = 0;
            c[j >> 2] = 0;
            c[f >> 2] = 0;
            Dx(a, $a(0, i | 0, b | 0, d | 0, e | 0, tw(h) | 0) | 0);
            kw(h);
            l = g;
            return;
        }
        function Hx() {
            var b = 0;
            if (!(a[8008] | 0)) {
                Ix(10768);
                b = 8008;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10768;
        }
        function Ix(a) {
            a = a | 0;
            fh(a, Jx() | 0, 3);
            return;
        }
        function Jx() {
            return 1784;
        }
        function Kx(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0;
            g = l;
            l = l + 16 | 0;
            i = g + 4 | 0;
            j = g;
            h = Vg(Lx() | 0) | 0;
            d = rx(d) | 0;
            c[j >> 2] = c[e >> 2];
            c[i >> 2] = c[j >> 2];
            e = qw(i) | 0;
            Dx(a, $a(0, h | 0, b | 0, d | 0, e | 0, sw(f) | 0) | 0);
            l = g;
            return;
        }
        function Lx() {
            var b = 0;
            if (!(a[8016] | 0)) {
                Mx(10780);
                b = 8016;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10780;
        }
        function Mx(a) {
            a = a | 0;
            fh(a, Nx() | 0, 3);
            return;
        }
        function Nx() {
            return 1800;
        }
        function Ox(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0;
            d = Vg(Px() | 0) | 0;
            Dx(a, bb(0, d | 0, b | 0, rx(c) | 0) | 0);
            return;
        }
        function Px() {
            var b = 0;
            if (!(a[8024] | 0)) {
                Qx(10792);
                b = 8024;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 10792;
        }
        function Qx(a) {
            a = a | 0;
            fh(a, Rx() | 0, 1);
            return;
        }
        function Rx() {
            return 1816;
        }
        function Sx() {
            Tx();
            Ux();
            Vx();
            return;
        }
        function Tx() {
            c[2702] = rC(65536) | 0;
            return;
        }
        function Ux() {
            qy(10856);
            return;
        }
        function Vx() {
            Wx(10816);
            return;
        }
        function Wx(a) {
            a = a | 0;
            Xx(a, 5044);
            Yx(a);
            return;
        }
        function Xx(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = zw() | 0;
            c[a >> 2] = d;
            ky(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function Yx(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            At(b, Zx() | 0);
            return a | 0;
        }
        function Zx() {
            var b = 0;
            if (!(a[8032] | 0)) {
                _x(10820);
                Ha(64, 10820, o | 0);
                b = 8032;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            if (!(si(10820) | 0)) _x(10820);
            return 10820;
        }
        function _x(a) {
            a = a | 0;
            by(a);
            Gt(a, 25);
            return;
        }
        function $x(a) {
            a = a | 0;
            ay(a + 24 | 0);
            return;
        }
        function ay(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function by(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 5, 18, b, gy() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function cy(a, b) {
            a = a | 0;
            b = b | 0;
            dy(a, b);
            return;
        }
        function dy(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            f = d + 4 | 0;
            Gk(f, b);
            c[e >> 2] = Hk(f, b) | 0;
            ey(a, e);
            l = d;
            return;
        }
        function ey(b, d) {
            b = b | 0;
            d = d | 0;
            fy(b + 4 | 0, c[d >> 2] | 0);
            a[b + 8 >> 0] = 1;
            return;
        }
        function fy(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = b;
            return;
        }
        function gy() {
            return 1824;
        }
        function hy(a) {
            a = a | 0;
            return iy(a) | 0;
        }
        function iy(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0;
            d = l;
            l = l + 16 | 0;
            f = d + 4 | 0;
            h = d;
            e = jy(8) | 0;
            b = e;
            i = qC(4) | 0;
            Gk(f, a);
            fy(i, Hk(f, a) | 0);
            g = b + 4 | 0;
            c[g >> 2] = i;
            a = qC(8) | 0;
            g = c[g >> 2] | 0;
            c[h >> 2] = 0;
            c[f >> 2] = c[h >> 2];
            Bw(a, g, f);
            c[e >> 2] = a;
            l = d;
            return b | 0;
        }
        function jy(a) {
            a = a | 0;
            var b = 0, d = 0;
            a = a + 7 & -8;
            if (a >>> 0 <= 32768 ? (b = c[2701] | 0, a >>> 0 <= (65536 - b | 0) >>> 0) : 0) {
                d = (c[2702] | 0) + b | 0;
                c[2701] = b + a;
                a = d;
            } else {
                a = rC(a + 8 | 0) | 0;
                c[a >> 2] = c[2703];
                c[2703] = a;
                a = a + 8 | 0;
            }
            return a | 0;
        }
        function ky(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = ly() | 0;
            c[a + 4 >> 2] = my() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = ny() | 0;
            c[a + 32 >> 2] = 9;
            return;
        }
        function ly() {
            return 11744;
        }
        function my() {
            return 1832;
        }
        function ny() {
            return cu() | 0;
        }
        function oy(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    py(c);
                    sC(c);
                }
            } else if (b | 0) sC(b);
            return;
        }
        function py(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function qy(a) {
            a = a | 0;
            ry(a, 5052);
            sy(a);
            ty(a, 5058, 26);
            uy(a, 5069, 1);
            vy(a, 5077, 10);
            wy(a, 5087, 19);
            yy(a, 5094, 27);
            return;
        }
        function ry(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = GA() | 0;
            c[a >> 2] = d;
            HA(d, b);
            Hv(c[a >> 2] | 0);
            return;
        }
        function sy(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            At(b, rA() | 0);
            return a | 0;
        }
        function ty(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Yz(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function uy(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Gz(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function vy(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            hz(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function wy(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Ry(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function xy(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            a: while(true){
                d = c[2703] | 0;
                while(true){
                    if ((d | 0) == (b | 0)) break a;
                    e = c[d >> 2] | 0;
                    c[2703] = e;
                    if (!d) d = e;
                    else break;
                }
                sC(d);
            }
            c[2701] = a;
            return;
        }
        function yy(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            zy(a, ai(b) | 0, c, 0);
            return a | 0;
        }
        function zy(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = Ay() | 0;
            a = By(d) | 0;
            fi(g, b, f, a, Cy(d, e) | 0, e);
            return;
        }
        function Ay() {
            var b = 0, d = 0;
            if (!(a[8040] | 0)) {
                Jy(10860);
                Ha(65, 10860, o | 0);
                d = 8040;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10860) | 0)) {
                b = 10860;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Jy(10860);
            }
            return 10860;
        }
        function By(a) {
            a = a | 0;
            return a | 0;
        }
        function Cy(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = Ay() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                Dy(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                Ey(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function Dy(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Ey(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = Fy(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                Gy(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                Dy(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                Hy(a, f);
                Iy(f);
                l = i;
                return;
            }
        }
        function Fy(a) {
            a = a | 0;
            return 536870911;
        }
        function Gy(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function Hy(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Iy(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Jy(a) {
            a = a | 0;
            My(a);
            return;
        }
        function Ky(a) {
            a = a | 0;
            Ly(a + 24 | 0);
            return;
        }
        function Ly(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function My(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 11, b, Ny() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Ny() {
            return 1840;
        }
        function Oy(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            Qy(c[(Py(a) | 0) >> 2] | 0, b, d);
            return;
        }
        function Py(a) {
            a = a | 0;
            return (c[(Ay() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function Qy(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0;
            d = l;
            l = l + 16 | 0;
            f = d + 1 | 0;
            e = d;
            Gk(f, b);
            b = Hk(f, b) | 0;
            Gk(e, c);
            c = Hk(e, c) | 0;
            ob[a & 31](b, c);
            l = d;
            return;
        }
        function Ry(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = Sy() | 0;
            a = Ty(d) | 0;
            fi(g, b, f, a, Uy(d, e) | 0, e);
            return;
        }
        function Sy() {
            var b = 0, d = 0;
            if (!(a[8048] | 0)) {
                $y(10896);
                Ha(66, 10896, o | 0);
                d = 8048;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10896) | 0)) {
                b = 10896;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                $y(10896);
            }
            return 10896;
        }
        function Ty(a) {
            a = a | 0;
            return a | 0;
        }
        function Uy(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = Sy() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                Vy(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                Wy(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function Vy(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Wy(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = Xy(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                Yy(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                Vy(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                Zy(a, f);
                _y(f);
                l = i;
                return;
            }
        }
        function Xy(a) {
            a = a | 0;
            return 536870911;
        }
        function Yy(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function Zy(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function _y(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function $y(a) {
            a = a | 0;
            cz(a);
            return;
        }
        function az(a) {
            a = a | 0;
            bz(a + 24 | 0);
            return;
        }
        function bz(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function cz(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 11, b, dz() | 0, 1);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function dz() {
            return 1852;
        }
        function ez(a, b) {
            a = a | 0;
            b = b | 0;
            return gz(c[(fz(a) | 0) >> 2] | 0, b) | 0;
        }
        function fz(a) {
            a = a | 0;
            return (c[(Sy() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function gz(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0, d = 0;
            c = l;
            l = l + 16 | 0;
            d = c;
            Gk(d, b);
            b = Hk(d, b) | 0;
            b = ul(pb[a & 31](b) | 0) | 0;
            l = c;
            return b | 0;
        }
        function hz(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = iz() | 0;
            a = jz(d) | 0;
            fi(g, b, f, a, kz(d, e) | 0, e);
            return;
        }
        function iz() {
            var b = 0, d = 0;
            if (!(a[8056] | 0)) {
                rz(10932);
                Ha(67, 10932, o | 0);
                d = 8056;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10932) | 0)) {
                b = 10932;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                rz(10932);
            }
            return 10932;
        }
        function jz(a) {
            a = a | 0;
            return a | 0;
        }
        function kz(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = iz() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                lz(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                mz(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function lz(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function mz(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = nz(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                oz(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                lz(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                pz(a, f);
                qz(f);
                l = i;
                return;
            }
        }
        function nz(a) {
            a = a | 0;
            return 536870911;
        }
        function oz(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function pz(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function qz(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function rz(a) {
            a = a | 0;
            uz(a);
            return;
        }
        function sz(a) {
            a = a | 0;
            tz(a + 24 | 0);
            return;
        }
        function tz(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function uz(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 7, b, vz() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function vz() {
            return 1860;
        }
        function wz(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            return yz(c[(xz(a) | 0) >> 2] | 0, b, d) | 0;
        }
        function xz(a) {
            a = a | 0;
            return (c[(iz() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function yz(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            e = l;
            l = l + 32 | 0;
            h = e + 12 | 0;
            g = e + 8 | 0;
            i = e;
            j = e + 16 | 0;
            f = e + 4 | 0;
            zz(j, b);
            Az(i, j, b);
            ik(f, d);
            d = jk(f, d) | 0;
            c[h >> 2] = c[i >> 2];
            Eb[a & 15](g, h, d);
            d = Bz(g) | 0;
            wf(g);
            kk(f);
            l = e;
            return d | 0;
        }
        function zz(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function Az(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            Cz(a, c);
            return;
        }
        function Bz(a) {
            a = a | 0;
            return Sg(a) | 0;
        }
        function Cz(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            f = l;
            l = l + 16 | 0;
            d = f;
            e = b;
            if (!(e & 1)) c[a >> 2] = c[b >> 2];
            else {
                Dz(d, 0);
                Ja(e | 0, d | 0);
                Ez(a, d);
                Fz(d);
            }
            l = f;
            return;
        }
        function Dz(b, d) {
            b = b | 0;
            d = d | 0;
            ah(b, d);
            c[b + 4 >> 2] = 0;
            a[b + 8 >> 0] = 0;
            return;
        }
        function Ez(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = c[b + 4 >> 2];
            return;
        }
        function Fz(b) {
            b = b | 0;
            a[b + 8 >> 0] = 0;
            return;
        }
        function Gz(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = Hz() | 0;
            a = Iz(d) | 0;
            fi(g, b, f, a, Jz(d, e) | 0, e);
            return;
        }
        function Hz() {
            var b = 0, d = 0;
            if (!(a[8064] | 0)) {
                Qz(10968);
                Ha(68, 10968, o | 0);
                d = 8064;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(10968) | 0)) {
                b = 10968;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                Qz(10968);
            }
            return 10968;
        }
        function Iz(a) {
            a = a | 0;
            return a | 0;
        }
        function Jz(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = Hz() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                Kz(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                Lz(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function Kz(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function Lz(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = Mz(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                Nz(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                Kz(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                Oz(a, f);
                Pz(f);
                l = i;
                return;
            }
        }
        function Mz(a) {
            a = a | 0;
            return 536870911;
        }
        function Nz(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function Oz(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function Pz(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function Qz(a) {
            a = a | 0;
            Tz(a);
            return;
        }
        function Rz(a) {
            a = a | 0;
            Sz(a + 24 | 0);
            return;
        }
        function Sz(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function Tz(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 1, b, Uz() | 0, 5);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function Uz() {
            return 1872;
        }
        function Vz(a, b, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            Xz(c[(Wz(a) | 0) >> 2] | 0, b, d, e, f, g);
            return;
        }
        function Wz(a) {
            a = a | 0;
            return (c[(Hz() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function Xz(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            g = l;
            l = l + 32 | 0;
            h = g + 16 | 0;
            i = g + 12 | 0;
            j = g + 8 | 0;
            k = g + 4 | 0;
            m = g;
            ik(h, b);
            b = jk(h, b) | 0;
            ik(i, c);
            c = jk(i, c) | 0;
            ik(j, d);
            d = jk(j, d) | 0;
            ik(k, e);
            e = jk(k, e) | 0;
            ik(m, f);
            f = jk(m, f) | 0;
            jb[a & 1](b, c, d, e, f);
            kk(m);
            kk(k);
            kk(j);
            kk(i);
            kk(h);
            l = g;
            return;
        }
        function Yz(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = c[a >> 2] | 0;
            f = Zz() | 0;
            a = _z(d) | 0;
            fi(g, b, f, a, $z(d, e) | 0, e);
            return;
        }
        function Zz() {
            var b = 0, d = 0;
            if (!(a[8072] | 0)) {
                gA(11004);
                Ha(69, 11004, o | 0);
                d = 8072;
                c[d >> 2] = 1;
                c[d + 4 >> 2] = 0;
            }
            if (!(si(11004) | 0)) {
                b = 11004;
                d = b + 36 | 0;
                do {
                    c[b >> 2] = 0;
                    b = b + 4 | 0;
                }while ((b | 0) < (d | 0));
                gA(11004);
            }
            return 11004;
        }
        function _z(a) {
            a = a | 0;
            return a | 0;
        }
        function $z(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            i = l;
            l = l + 16 | 0;
            f = i;
            g = i + 4 | 0;
            c[f >> 2] = a;
            j = Zz() | 0;
            h = j + 24 | 0;
            b = ji(b, 4) | 0;
            c[g >> 2] = b;
            d = j + 28 | 0;
            e = c[d >> 2] | 0;
            if (e >>> 0 < (c[j + 32 >> 2] | 0) >>> 0) {
                aA(e, a, b);
                b = (c[d >> 2] | 0) + 8 | 0;
                c[d >> 2] = b;
            } else {
                bA(h, f, g);
                b = c[d >> 2] | 0;
            }
            l = i;
            return (b - (c[h >> 2] | 0) >> 3) + -1 | 0;
        }
        function aA(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function bA(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0;
            i = l;
            l = l + 32 | 0;
            f = i;
            g = a + 4 | 0;
            h = ((c[g >> 2] | 0) - (c[a >> 2] | 0) >> 3) + 1 | 0;
            e = cA(a) | 0;
            if (e >>> 0 < h >>> 0) jC(a);
            else {
                j = c[a >> 2] | 0;
                m = (c[a + 8 >> 2] | 0) - j | 0;
                k = m >> 2;
                dA(f, m >> 3 >>> 0 < e >>> 1 >>> 0 ? k >>> 0 < h >>> 0 ? h : k : e, (c[g >> 2] | 0) - j >> 3, a + 8 | 0);
                h = f + 8 | 0;
                aA(c[h >> 2] | 0, c[b >> 2] | 0, c[d >> 2] | 0);
                c[h >> 2] = (c[h >> 2] | 0) + 8;
                eA(a, f);
                fA(f);
                l = i;
                return;
            }
        }
        function cA(a) {
            a = a | 0;
            return 536870911;
        }
        function dA(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0;
            c[a + 12 >> 2] = 0;
            c[a + 16 >> 2] = e;
            do if (b) {
                if (b >>> 0 > 536870911) Ta();
                else {
                    f = qC(b << 3) | 0;
                    break;
                }
            } else f = 0;
            while (0);
            c[a >> 2] = f;
            e = f + (d << 3) | 0;
            c[a + 8 >> 2] = e;
            c[a + 4 >> 2] = e;
            c[a + 12 >> 2] = f + (b << 3);
            return;
        }
        function eA(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0, f = 0, g = 0, h = 0;
            e = c[a >> 2] | 0;
            h = a + 4 | 0;
            g = b + 4 | 0;
            f = (c[h >> 2] | 0) - e | 0;
            d = (c[g >> 2] | 0) + (0 - (f >> 3) << 3) | 0;
            c[g >> 2] = d;
            if ((f | 0) > 0) {
                BC(d | 0, e | 0, f | 0);
                e = g;
                d = c[g >> 2] | 0;
            } else e = g;
            g = c[a >> 2] | 0;
            c[a >> 2] = d;
            c[e >> 2] = g;
            g = b + 8 | 0;
            f = c[h >> 2] | 0;
            c[h >> 2] = c[g >> 2];
            c[g >> 2] = f;
            g = a + 8 | 0;
            h = b + 12 | 0;
            a = c[g >> 2] | 0;
            c[g >> 2] = c[h >> 2];
            c[h >> 2] = a;
            c[b >> 2] = c[e >> 2];
            return;
        }
        function fA(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            b = c[a + 4 >> 2] | 0;
            d = a + 8 | 0;
            e = c[d >> 2] | 0;
            if ((e | 0) != (b | 0)) c[d >> 2] = e + (~((e + -8 - b | 0) >>> 3) << 3);
            a = c[a >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function gA(a) {
            a = a | 0;
            jA(a);
            return;
        }
        function hA(a) {
            a = a | 0;
            iA(a + 24 | 0);
            return;
        }
        function iA(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function jA(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 1, 12, b, kA() | 0, 2);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function kA() {
            return 1896;
        }
        function lA(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            nA(c[(mA(a) | 0) >> 2] | 0, b, d);
            return;
        }
        function mA(a) {
            a = a | 0;
            return (c[(Zz() | 0) + 24 >> 2] | 0) + (a << 3) | 0;
        }
        function nA(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0, f = 0;
            d = l;
            l = l + 16 | 0;
            f = d + 4 | 0;
            e = d;
            oA(f, b);
            b = pA(f, b) | 0;
            ik(e, c);
            c = jk(e, c) | 0;
            ob[a & 31](b, c);
            kk(e);
            l = d;
            return;
        }
        function oA(a, b) {
            a = a | 0;
            b = b | 0;
            return;
        }
        function pA(a, b) {
            a = a | 0;
            b = b | 0;
            return qA(b) | 0;
        }
        function qA(a) {
            a = a | 0;
            return a | 0;
        }
        function rA() {
            var b = 0;
            if (!(a[8080] | 0)) {
                sA(11040);
                Ha(70, 11040, o | 0);
                b = 8080;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            if (!(si(11040) | 0)) sA(11040);
            return 11040;
        }
        function sA(a) {
            a = a | 0;
            vA(a);
            Gt(a, 71);
            return;
        }
        function tA(a) {
            a = a | 0;
            uA(a + 24 | 0);
            return;
        }
        function uA(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0;
            d = c[a >> 2] | 0;
            e = d;
            if (d | 0) {
                a = a + 4 | 0;
                b = c[a >> 2] | 0;
                if ((b | 0) != (d | 0)) c[a >> 2] = b + (~((b + -8 - e | 0) >>> 3) << 3);
                sC(d);
            }
            return;
        }
        function vA(a) {
            a = a | 0;
            var b = 0;
            b = vi() | 0;
            yi(a, 5, 7, b, zA() | 0, 0);
            c[a + 24 >> 2] = 0;
            c[a + 28 >> 2] = 0;
            c[a + 32 >> 2] = 0;
            return;
        }
        function wA(a) {
            a = a | 0;
            xA(a);
            return;
        }
        function xA(a) {
            a = a | 0;
            yA(a);
            return;
        }
        function yA(b) {
            b = b | 0;
            a[b + 8 >> 0] = 1;
            return;
        }
        function zA() {
            return 1936;
        }
        function AA() {
            return BA() | 0;
        }
        function BA() {
            var a = 0, b = 0, d = 0, e = 0, f = 0, g = 0, h = 0;
            b = l;
            l = l + 16 | 0;
            f = b + 4 | 0;
            h = b;
            d = jy(8) | 0;
            a = d;
            g = a + 4 | 0;
            c[g >> 2] = qC(1) | 0;
            e = qC(8) | 0;
            g = c[g >> 2] | 0;
            c[h >> 2] = 0;
            c[f >> 2] = c[h >> 2];
            CA(e, g, f);
            c[d >> 2] = e;
            l = b;
            return a | 0;
        }
        function CA(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            c[a >> 2] = b;
            d = qC(16) | 0;
            c[d + 4 >> 2] = 0;
            c[d + 8 >> 2] = 0;
            c[d >> 2] = 1916;
            c[d + 12 >> 2] = b;
            c[a + 4 >> 2] = d;
            return;
        }
        function DA(a) {
            a = a | 0;
            kC(a);
            sC(a);
            return;
        }
        function EA(a) {
            a = a | 0;
            a = c[a + 12 >> 2] | 0;
            if (a | 0) sC(a);
            return;
        }
        function FA(a) {
            a = a | 0;
            sC(a);
            return;
        }
        function GA() {
            var b = 0;
            if (!(a[8088] | 0)) {
                NA(11076);
                Ha(25, 11076, o | 0);
                b = 8088;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 11076;
        }
        function HA(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = IA() | 0;
            c[a + 4 >> 2] = JA() | 0;
            c[a + 12 >> 2] = b;
            c[a + 8 >> 2] = KA() | 0;
            c[a + 32 >> 2] = 10;
            return;
        }
        function IA() {
            return 11745;
        }
        function JA() {
            return 1940;
        }
        function KA() {
            return lr() | 0;
        }
        function LA(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if ((jr(d, 896) | 0) == 512) {
                if (c | 0) {
                    MA(c);
                    sC(c);
                }
            } else if (b | 0) sC(b);
            return;
        }
        function MA(a) {
            a = a | 0;
            a = c[a + 4 >> 2] | 0;
            if (a | 0) oC(a);
            return;
        }
        function NA(a) {
            a = a | 0;
            Zi(a);
            return;
        }
        function OA(a, b) {
            a = a | 0;
            b = b | 0;
            c[a >> 2] = b;
            return;
        }
        function PA(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function QA(b) {
            b = b | 0;
            return a[c[b >> 2] >> 0] | 0;
        }
        function RA(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            c[e >> 2] = c[a >> 2];
            SA(b, e);
            l = d;
            return;
        }
        function SA(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0;
            d = TA(c[a >> 2] | 0, b) | 0;
            b = a + 4 | 0;
            c[(c[b >> 2] | 0) + 8 >> 2] = d;
            return c[(c[b >> 2] | 0) + 8 >> 2] | 0;
        }
        function TA(a, b) {
            a = a | 0;
            b = b | 0;
            var d = 0, e = 0;
            d = l;
            l = l + 16 | 0;
            e = d;
            UA(e);
            a = Sg(a) | 0;
            b = VA(a, c[b >> 2] | 0) | 0;
            WA(e);
            l = d;
            return b | 0;
        }
        function UA(a) {
            a = a | 0;
            c[a >> 2] = c[2701];
            c[a + 4 >> 2] = c[2703];
            return;
        }
        function VA(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            c = Vg(XA() | 0) | 0;
            return bb(0, c | 0, a | 0, sw(b) | 0) | 0;
        }
        function WA(a) {
            a = a | 0;
            xy(c[a >> 2] | 0, c[a + 4 >> 2] | 0);
            return;
        }
        function XA() {
            var b = 0;
            if (!(a[8096] | 0)) {
                YA(11120);
                b = 8096;
                c[b >> 2] = 1;
                c[b + 4 >> 2] = 0;
            }
            return 11120;
        }
        function YA(a) {
            a = a | 0;
            fh(a, ZA() | 0, 1);
            return;
        }
        function ZA() {
            return 1948;
        }
        function _A() {
            $A();
            return;
        }
        function $A() {
            var b = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0;
            s = l;
            l = l + 16 | 0;
            o = s + 4 | 0;
            p = s;
            Ea(65536, 10804, c[2702] | 0, 10812);
            f = Wv() | 0;
            e = c[f >> 2] | 0;
            b = c[e >> 2] | 0;
            if (b | 0) {
                g = c[f + 8 >> 2] | 0;
                f = c[f + 4 >> 2] | 0;
                while(true){
                    Ma(b | 0, d[f >> 0] | 0, a[g >> 0] | 0);
                    e = e + 4 | 0;
                    b = c[e >> 2] | 0;
                    if (!b) break;
                    else {
                        g = g + 1 | 0;
                        f = f + 1 | 0;
                    }
                }
            }
            b = Yv() | 0;
            e = c[b >> 2] | 0;
            if (e | 0) do {
                Na(e | 0, c[b + 4 >> 2] | 0);
                b = b + 8 | 0;
                e = c[b >> 2] | 0;
            }while ((e | 0) != 0);
            Na(aB() | 0, 5167);
            n = Iv() | 0;
            b = c[n >> 2] | 0;
            a: do if (b | 0) {
                do {
                    bB(c[b + 4 >> 2] | 0);
                    b = c[b >> 2] | 0;
                }while ((b | 0) != 0);
                b = c[n >> 2] | 0;
                if (b | 0) {
                    m = n;
                    do {
                        while(true){
                            h = b;
                            b = c[b >> 2] | 0;
                            h = c[h + 4 >> 2] | 0;
                            if (!(cB(h) | 0)) break;
                            c[p >> 2] = m;
                            c[o >> 2] = c[p >> 2];
                            dB(n, o);
                            if (!b) break a;
                        }
                        eB(h);
                        m = c[m >> 2] | 0;
                        e = fB(h) | 0;
                        i = Va() | 0;
                        j = l;
                        l = l + ((1 * (e << 2) | 0) + 15 & -16) | 0;
                        k = l;
                        l = l + ((1 * (e << 2) | 0) + 15 & -16) | 0;
                        e = c[(Zw(h) | 0) >> 2] | 0;
                        if (e | 0) {
                            f = j;
                            g = k;
                            while(true){
                                c[f >> 2] = c[(Xw(c[e + 4 >> 2] | 0) | 0) >> 2];
                                c[g >> 2] = c[e + 8 >> 2];
                                e = c[e >> 2] | 0;
                                if (!e) break;
                                else {
                                    f = f + 4 | 0;
                                    g = g + 4 | 0;
                                }
                            }
                        }
                        t = Xw(h) | 0;
                        e = gB(h) | 0;
                        f = fB(h) | 0;
                        g = hB(h) | 0;
                        Ra(t | 0, e | 0, j | 0, k | 0, f | 0, g | 0, Tv(h) | 0);
                        Ga(i | 0);
                    }while ((b | 0) != 0);
                }
            }
            while (0);
            b = c[(Vv() | 0) >> 2] | 0;
            if (b | 0) do {
                t = b + 4 | 0;
                n = aw(t) | 0;
                h = fw(n) | 0;
                i = bw(n) | 0;
                j = (cw(n) | 0) + 1 | 0;
                k = iB(n) | 0;
                m = jB(t) | 0;
                n = si(n) | 0;
                o = hw(t) | 0;
                p = kB(t) | 0;
                Pa(0, h | 0, i | 0, j | 0, k | 0, m | 0, n | 0, o | 0, p | 0, lB(t) | 0);
                b = c[b >> 2] | 0;
            }while ((b | 0) != 0);
            b = c[(Iv() | 0) >> 2] | 0;
            b: if (b | 0) {
                c: while(true){
                    e = c[b + 4 >> 2] | 0;
                    if (e | 0 ? (q = c[(Xw(e) | 0) >> 2] | 0, r = c[(ax(e) | 0) >> 2] | 0, r | 0) : 0) {
                        f = r;
                        do {
                            e = f + 4 | 0;
                            g = aw(e) | 0;
                            d: if (g | 0) switch(si(g) | 0){
                                case 0:
                                    break c;
                                case 4:
                                case 3:
                                case 2:
                                    k = fw(g) | 0;
                                    m = bw(g) | 0;
                                    n = (cw(g) | 0) + 1 | 0;
                                    o = iB(g) | 0;
                                    p = si(g) | 0;
                                    t = hw(e) | 0;
                                    Pa(q | 0, k | 0, m | 0, n | 0, o | 0, 0, p | 0, t | 0, kB(e) | 0, lB(e) | 0);
                                    break d;
                                case 1:
                                    j = fw(g) | 0;
                                    k = bw(g) | 0;
                                    m = (cw(g) | 0) + 1 | 0;
                                    n = iB(g) | 0;
                                    o = jB(e) | 0;
                                    p = si(g) | 0;
                                    t = hw(e) | 0;
                                    Pa(q | 0, j | 0, k | 0, m | 0, n | 0, o | 0, p | 0, t | 0, kB(e) | 0, lB(e) | 0);
                                    break d;
                                case 5:
                                    n = fw(g) | 0;
                                    o = bw(g) | 0;
                                    p = (cw(g) | 0) + 1 | 0;
                                    t = iB(g) | 0;
                                    Pa(q | 0, n | 0, o | 0, p | 0, t | 0, mB(g) | 0, si(g) | 0, 0, 0, 0);
                                    break d;
                                default:
                                    break d;
                            }
                            f = c[f >> 2] | 0;
                        }while ((f | 0) != 0);
                    }
                    b = c[b >> 2] | 0;
                    if (!b) break b;
                }
                Ta();
            }
            Sa();
            l = s;
            return;
        }
        function aB() {
            return 11703;
        }
        function bB(b) {
            b = b | 0;
            a[b + 40 >> 0] = 0;
            return;
        }
        function cB(b) {
            b = b | 0;
            return (a[b + 40 >> 0] | 0) != 0 | 0;
        }
        function dB(a, b) {
            a = a | 0;
            b = b | 0;
            b = nB(b) | 0;
            a = c[b >> 2] | 0;
            c[b >> 2] = c[a >> 2];
            sC(a);
            return c[b >> 2] | 0;
        }
        function eB(b) {
            b = b | 0;
            a[b + 40 >> 0] = 1;
            return;
        }
        function fB(a) {
            a = a | 0;
            return c[a + 20 >> 2] | 0;
        }
        function gB(a) {
            a = a | 0;
            return c[a + 8 >> 2] | 0;
        }
        function hB(a) {
            a = a | 0;
            return c[a + 32 >> 2] | 0;
        }
        function iB(a) {
            a = a | 0;
            return c[a + 4 >> 2] | 0;
        }
        function jB(a) {
            a = a | 0;
            return c[a + 4 >> 2] | 0;
        }
        function kB(a) {
            a = a | 0;
            return c[a + 8 >> 2] | 0;
        }
        function lB(a) {
            a = a | 0;
            return c[a + 16 >> 2] | 0;
        }
        function mB(a) {
            a = a | 0;
            return c[a + 20 >> 2] | 0;
        }
        function nB(a) {
            a = a | 0;
            return c[a >> 2] | 0;
        }
        function oB(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0;
            x = l;
            l = l + 16 | 0;
            o = x;
            do if (a >>> 0 < 245) {
                k = a >>> 0 < 11 ? 16 : a + 11 & -8;
                a = k >>> 3;
                n = c[2783] | 0;
                d = n >>> a;
                if (d & 3 | 0) {
                    b = (d & 1 ^ 1) + a | 0;
                    a = 11172 + (b << 1 << 2) | 0;
                    d = a + 8 | 0;
                    e = c[d >> 2] | 0;
                    f = e + 8 | 0;
                    g = c[f >> 2] | 0;
                    if ((a | 0) == (g | 0)) c[2783] = n & ~(1 << b);
                    else {
                        c[g + 12 >> 2] = a;
                        c[d >> 2] = g;
                    }
                    w = b << 3;
                    c[e + 4 >> 2] = w | 3;
                    w = e + w + 4 | 0;
                    c[w >> 2] = c[w >> 2] | 1;
                    w = f;
                    l = x;
                    return w | 0;
                }
                m = c[2785] | 0;
                if (k >>> 0 > m >>> 0) {
                    if (d | 0) {
                        b = 2 << a;
                        b = d << a & (b | 0 - b);
                        b = (b & 0 - b) + -1 | 0;
                        h = b >>> 12 & 16;
                        b = b >>> h;
                        d = b >>> 5 & 8;
                        b = b >>> d;
                        f = b >>> 2 & 4;
                        b = b >>> f;
                        a = b >>> 1 & 2;
                        b = b >>> a;
                        e = b >>> 1 & 1;
                        e = (d | h | f | a | e) + (b >>> e) | 0;
                        b = 11172 + (e << 1 << 2) | 0;
                        a = b + 8 | 0;
                        f = c[a >> 2] | 0;
                        h = f + 8 | 0;
                        d = c[h >> 2] | 0;
                        if ((b | 0) == (d | 0)) {
                            a = n & ~(1 << e);
                            c[2783] = a;
                        } else {
                            c[d + 12 >> 2] = b;
                            c[a >> 2] = d;
                            a = n;
                        }
                        g = (e << 3) - k | 0;
                        c[f + 4 >> 2] = k | 3;
                        e = f + k | 0;
                        c[e + 4 >> 2] = g | 1;
                        c[e + g >> 2] = g;
                        if (m | 0) {
                            f = c[2788] | 0;
                            b = m >>> 3;
                            d = 11172 + (b << 1 << 2) | 0;
                            b = 1 << b;
                            if (!(a & b)) {
                                c[2783] = a | b;
                                b = d;
                                a = d + 8 | 0;
                            } else {
                                a = d + 8 | 0;
                                b = c[a >> 2] | 0;
                            }
                            c[a >> 2] = f;
                            c[b + 12 >> 2] = f;
                            c[f + 8 >> 2] = b;
                            c[f + 12 >> 2] = d;
                        }
                        c[2785] = g;
                        c[2788] = e;
                        w = h;
                        l = x;
                        return w | 0;
                    }
                    i = c[2784] | 0;
                    if (i) {
                        d = (i & 0 - i) + -1 | 0;
                        h = d >>> 12 & 16;
                        d = d >>> h;
                        g = d >>> 5 & 8;
                        d = d >>> g;
                        j = d >>> 2 & 4;
                        d = d >>> j;
                        e = d >>> 1 & 2;
                        d = d >>> e;
                        a = d >>> 1 & 1;
                        a = c[11436 + ((g | h | j | e | a) + (d >>> a) << 2) >> 2] | 0;
                        d = (c[a + 4 >> 2] & -8) - k | 0;
                        e = c[a + 16 + (((c[a + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;
                        if (!e) {
                            j = a;
                            g = d;
                        } else {
                            do {
                                h = (c[e + 4 >> 2] & -8) - k | 0;
                                j = h >>> 0 < d >>> 0;
                                d = j ? h : d;
                                a = j ? e : a;
                                e = c[e + 16 + (((c[e + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;
                            }while ((e | 0) != 0);
                            j = a;
                            g = d;
                        }
                        h = j + k | 0;
                        if (j >>> 0 < h >>> 0) {
                            f = c[j + 24 >> 2] | 0;
                            b = c[j + 12 >> 2] | 0;
                            do if ((b | 0) == (j | 0)) {
                                a = j + 20 | 0;
                                b = c[a >> 2] | 0;
                                if (!b) {
                                    a = j + 16 | 0;
                                    b = c[a >> 2] | 0;
                                    if (!b) {
                                        d = 0;
                                        break;
                                    }
                                }
                                while(true){
                                    d = b + 20 | 0;
                                    e = c[d >> 2] | 0;
                                    if (e | 0) {
                                        b = e;
                                        a = d;
                                        continue;
                                    }
                                    d = b + 16 | 0;
                                    e = c[d >> 2] | 0;
                                    if (!e) break;
                                    else {
                                        b = e;
                                        a = d;
                                    }
                                }
                                c[a >> 2] = 0;
                                d = b;
                            } else {
                                d = c[j + 8 >> 2] | 0;
                                c[d + 12 >> 2] = b;
                                c[b + 8 >> 2] = d;
                                d = b;
                            }
                            while (0);
                            do if (f | 0) {
                                b = c[j + 28 >> 2] | 0;
                                a = 11436 + (b << 2) | 0;
                                if ((j | 0) == (c[a >> 2] | 0)) {
                                    c[a >> 2] = d;
                                    if (!d) {
                                        c[2784] = i & ~(1 << b);
                                        break;
                                    }
                                } else {
                                    c[f + 16 + (((c[f + 16 >> 2] | 0) != (j | 0) & 1) << 2) >> 2] = d;
                                    if (!d) break;
                                }
                                c[d + 24 >> 2] = f;
                                b = c[j + 16 >> 2] | 0;
                                if (b | 0) {
                                    c[d + 16 >> 2] = b;
                                    c[b + 24 >> 2] = d;
                                }
                                b = c[j + 20 >> 2] | 0;
                                if (b | 0) {
                                    c[d + 20 >> 2] = b;
                                    c[b + 24 >> 2] = d;
                                }
                            }
                            while (0);
                            if (g >>> 0 < 16) {
                                w = g + k | 0;
                                c[j + 4 >> 2] = w | 3;
                                w = j + w + 4 | 0;
                                c[w >> 2] = c[w >> 2] | 1;
                            } else {
                                c[j + 4 >> 2] = k | 3;
                                c[h + 4 >> 2] = g | 1;
                                c[h + g >> 2] = g;
                                if (m | 0) {
                                    e = c[2788] | 0;
                                    b = m >>> 3;
                                    d = 11172 + (b << 1 << 2) | 0;
                                    b = 1 << b;
                                    if (!(n & b)) {
                                        c[2783] = n | b;
                                        b = d;
                                        a = d + 8 | 0;
                                    } else {
                                        a = d + 8 | 0;
                                        b = c[a >> 2] | 0;
                                    }
                                    c[a >> 2] = e;
                                    c[b + 12 >> 2] = e;
                                    c[e + 8 >> 2] = b;
                                    c[e + 12 >> 2] = d;
                                }
                                c[2785] = g;
                                c[2788] = h;
                            }
                            w = j + 8 | 0;
                            l = x;
                            return w | 0;
                        } else n = k;
                    } else n = k;
                } else n = k;
            } else if (a >>> 0 <= 4294967231) {
                a = a + 11 | 0;
                k = a & -8;
                j = c[2784] | 0;
                if (j) {
                    e = 0 - k | 0;
                    a = a >>> 8;
                    if (a) {
                        if (k >>> 0 > 16777215) i = 31;
                        else {
                            n = (a + 1048320 | 0) >>> 16 & 8;
                            v = a << n;
                            m = (v + 520192 | 0) >>> 16 & 4;
                            v = v << m;
                            i = (v + 245760 | 0) >>> 16 & 2;
                            i = 14 - (m | n | i) + (v << i >>> 15) | 0;
                            i = k >>> (i + 7 | 0) & 1 | i << 1;
                        }
                    } else i = 0;
                    d = c[11436 + (i << 2) >> 2] | 0;
                    a: do if (!d) {
                        d = 0;
                        a = 0;
                        v = 57;
                    } else {
                        a = 0;
                        h = k << ((i | 0) == 31 ? 0 : 25 - (i >>> 1) | 0);
                        g = 0;
                        while(true){
                            f = (c[d + 4 >> 2] & -8) - k | 0;
                            if (f >>> 0 < e >>> 0) {
                                if (!f) {
                                    a = d;
                                    e = 0;
                                    f = d;
                                    v = 61;
                                    break a;
                                } else {
                                    a = d;
                                    e = f;
                                }
                            }
                            f = c[d + 20 >> 2] | 0;
                            d = c[d + 16 + (h >>> 31 << 2) >> 2] | 0;
                            g = (f | 0) == 0 | (f | 0) == (d | 0) ? g : f;
                            f = (d | 0) == 0;
                            if (f) {
                                d = g;
                                v = 57;
                                break;
                            } else h = h << ((f ^ 1) & 1);
                        }
                    }
                    while (0);
                    if ((v | 0) == 57) {
                        if ((d | 0) == 0 & (a | 0) == 0) {
                            a = 2 << i;
                            a = j & (a | 0 - a);
                            if (!a) {
                                n = k;
                                break;
                            }
                            n = (a & 0 - a) + -1 | 0;
                            h = n >>> 12 & 16;
                            n = n >>> h;
                            g = n >>> 5 & 8;
                            n = n >>> g;
                            i = n >>> 2 & 4;
                            n = n >>> i;
                            m = n >>> 1 & 2;
                            n = n >>> m;
                            d = n >>> 1 & 1;
                            a = 0;
                            d = c[11436 + ((g | h | i | m | d) + (n >>> d) << 2) >> 2] | 0;
                        }
                        if (!d) {
                            i = a;
                            h = e;
                        } else {
                            f = d;
                            v = 61;
                        }
                    }
                    if ((v | 0) == 61) while(true){
                        v = 0;
                        d = (c[f + 4 >> 2] & -8) - k | 0;
                        n = d >>> 0 < e >>> 0;
                        d = n ? d : e;
                        a = n ? f : a;
                        f = c[f + 16 + (((c[f + 16 >> 2] | 0) == 0 & 1) << 2) >> 2] | 0;
                        if (!f) {
                            i = a;
                            h = d;
                            break;
                        } else {
                            e = d;
                            v = 61;
                        }
                    }
                    if ((i | 0) != 0 ? h >>> 0 < ((c[2785] | 0) - k | 0) >>> 0 : 0) {
                        g = i + k | 0;
                        if (i >>> 0 >= g >>> 0) {
                            w = 0;
                            l = x;
                            return w | 0;
                        }
                        f = c[i + 24 >> 2] | 0;
                        b = c[i + 12 >> 2] | 0;
                        do if ((b | 0) == (i | 0)) {
                            a = i + 20 | 0;
                            b = c[a >> 2] | 0;
                            if (!b) {
                                a = i + 16 | 0;
                                b = c[a >> 2] | 0;
                                if (!b) {
                                    b = 0;
                                    break;
                                }
                            }
                            while(true){
                                d = b + 20 | 0;
                                e = c[d >> 2] | 0;
                                if (e | 0) {
                                    b = e;
                                    a = d;
                                    continue;
                                }
                                d = b + 16 | 0;
                                e = c[d >> 2] | 0;
                                if (!e) break;
                                else {
                                    b = e;
                                    a = d;
                                }
                            }
                            c[a >> 2] = 0;
                        } else {
                            w = c[i + 8 >> 2] | 0;
                            c[w + 12 >> 2] = b;
                            c[b + 8 >> 2] = w;
                        }
                        while (0);
                        do if (f) {
                            a = c[i + 28 >> 2] | 0;
                            d = 11436 + (a << 2) | 0;
                            if ((i | 0) == (c[d >> 2] | 0)) {
                                c[d >> 2] = b;
                                if (!b) {
                                    e = j & ~(1 << a);
                                    c[2784] = e;
                                    break;
                                }
                            } else {
                                c[f + 16 + (((c[f + 16 >> 2] | 0) != (i | 0) & 1) << 2) >> 2] = b;
                                if (!b) {
                                    e = j;
                                    break;
                                }
                            }
                            c[b + 24 >> 2] = f;
                            a = c[i + 16 >> 2] | 0;
                            if (a | 0) {
                                c[b + 16 >> 2] = a;
                                c[a + 24 >> 2] = b;
                            }
                            a = c[i + 20 >> 2] | 0;
                            if (a) {
                                c[b + 20 >> 2] = a;
                                c[a + 24 >> 2] = b;
                                e = j;
                            } else e = j;
                        } else e = j;
                        while (0);
                        do if (h >>> 0 >= 16) {
                            c[i + 4 >> 2] = k | 3;
                            c[g + 4 >> 2] = h | 1;
                            c[g + h >> 2] = h;
                            b = h >>> 3;
                            if (h >>> 0 < 256) {
                                d = 11172 + (b << 1 << 2) | 0;
                                a = c[2783] | 0;
                                b = 1 << b;
                                if (!(a & b)) {
                                    c[2783] = a | b;
                                    b = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    b = c[a >> 2] | 0;
                                }
                                c[a >> 2] = g;
                                c[b + 12 >> 2] = g;
                                c[g + 8 >> 2] = b;
                                c[g + 12 >> 2] = d;
                                break;
                            }
                            b = h >>> 8;
                            if (b) {
                                if (h >>> 0 > 16777215) b = 31;
                                else {
                                    v = (b + 1048320 | 0) >>> 16 & 8;
                                    w = b << v;
                                    u = (w + 520192 | 0) >>> 16 & 4;
                                    w = w << u;
                                    b = (w + 245760 | 0) >>> 16 & 2;
                                    b = 14 - (u | v | b) + (w << b >>> 15) | 0;
                                    b = h >>> (b + 7 | 0) & 1 | b << 1;
                                }
                            } else b = 0;
                            d = 11436 + (b << 2) | 0;
                            c[g + 28 >> 2] = b;
                            a = g + 16 | 0;
                            c[a + 4 >> 2] = 0;
                            c[a >> 2] = 0;
                            a = 1 << b;
                            if (!(e & a)) {
                                c[2784] = e | a;
                                c[d >> 2] = g;
                                c[g + 24 >> 2] = d;
                                c[g + 12 >> 2] = g;
                                c[g + 8 >> 2] = g;
                                break;
                            }
                            a = h << ((b | 0) == 31 ? 0 : 25 - (b >>> 1) | 0);
                            d = c[d >> 2] | 0;
                            while(true){
                                if ((c[d + 4 >> 2] & -8 | 0) == (h | 0)) {
                                    v = 97;
                                    break;
                                }
                                e = d + 16 + (a >>> 31 << 2) | 0;
                                b = c[e >> 2] | 0;
                                if (!b) {
                                    v = 96;
                                    break;
                                } else {
                                    a = a << 1;
                                    d = b;
                                }
                            }
                            if ((v | 0) == 96) {
                                c[e >> 2] = g;
                                c[g + 24 >> 2] = d;
                                c[g + 12 >> 2] = g;
                                c[g + 8 >> 2] = g;
                                break;
                            } else if ((v | 0) == 97) {
                                v = d + 8 | 0;
                                w = c[v >> 2] | 0;
                                c[w + 12 >> 2] = g;
                                c[v >> 2] = g;
                                c[g + 8 >> 2] = w;
                                c[g + 12 >> 2] = d;
                                c[g + 24 >> 2] = 0;
                                break;
                            }
                        } else {
                            w = h + k | 0;
                            c[i + 4 >> 2] = w | 3;
                            w = i + w + 4 | 0;
                            c[w >> 2] = c[w >> 2] | 1;
                        }
                        while (0);
                        w = i + 8 | 0;
                        l = x;
                        return w | 0;
                    } else n = k;
                } else n = k;
            } else n = -1;
            while (0);
            d = c[2785] | 0;
            if (d >>> 0 >= n >>> 0) {
                b = d - n | 0;
                a = c[2788] | 0;
                if (b >>> 0 > 15) {
                    w = a + n | 0;
                    c[2788] = w;
                    c[2785] = b;
                    c[w + 4 >> 2] = b | 1;
                    c[w + b >> 2] = b;
                    c[a + 4 >> 2] = n | 3;
                } else {
                    c[2785] = 0;
                    c[2788] = 0;
                    c[a + 4 >> 2] = d | 3;
                    w = a + d + 4 | 0;
                    c[w >> 2] = c[w >> 2] | 1;
                }
                w = a + 8 | 0;
                l = x;
                return w | 0;
            }
            h = c[2786] | 0;
            if (h >>> 0 > n >>> 0) {
                u = h - n | 0;
                c[2786] = u;
                w = c[2789] | 0;
                v = w + n | 0;
                c[2789] = v;
                c[v + 4 >> 2] = u | 1;
                c[w + 4 >> 2] = n | 3;
                w = w + 8 | 0;
                l = x;
                return w | 0;
            }
            if (!(c[2901] | 0)) {
                c[2903] = 4096;
                c[2902] = 4096;
                c[2904] = -1;
                c[2905] = -1;
                c[2906] = 0;
                c[2894] = 0;
                a = o & -16 ^ 1431655768;
                c[o >> 2] = a;
                c[2901] = a;
                a = 4096;
            } else a = c[2903] | 0;
            i = n + 48 | 0;
            j = n + 47 | 0;
            g = a + j | 0;
            f = 0 - a | 0;
            k = g & f;
            if (k >>> 0 <= n >>> 0) {
                w = 0;
                l = x;
                return w | 0;
            }
            a = c[2893] | 0;
            if (a | 0 ? (m = c[2891] | 0, o = m + k | 0, o >>> 0 <= m >>> 0 | o >>> 0 > a >>> 0) : 0) {
                w = 0;
                l = x;
                return w | 0;
            }
            b: do if (!(c[2894] & 4)) {
                d = c[2789] | 0;
                c: do if (d) {
                    e = 11580;
                    while(true){
                        a = c[e >> 2] | 0;
                        if (a >>> 0 <= d >>> 0 ? (r = e + 4 | 0, (a + (c[r >> 2] | 0) | 0) >>> 0 > d >>> 0) : 0) break;
                        a = c[e + 8 >> 2] | 0;
                        if (!a) {
                            v = 118;
                            break c;
                        } else e = a;
                    }
                    b = g - h & f;
                    if (b >>> 0 < 2147483647) {
                        a = FC(b | 0) | 0;
                        if ((a | 0) == ((c[e >> 2] | 0) + (c[r >> 2] | 0) | 0)) {
                            if ((a | 0) != -1) {
                                h = b;
                                g = a;
                                v = 135;
                                break b;
                            }
                        } else {
                            e = a;
                            v = 126;
                        }
                    } else b = 0;
                } else v = 118;
                while (0);
                do if ((v | 0) == 118) {
                    d = FC(0) | 0;
                    if ((d | 0) != -1 ? (b = d, p = c[2902] | 0, q = p + -1 | 0, b = ((q & b | 0) == 0 ? 0 : (q + b & 0 - p) - b | 0) + k | 0, p = c[2891] | 0, q = b + p | 0, b >>> 0 > n >>> 0 & b >>> 0 < 2147483647) : 0) {
                        r = c[2893] | 0;
                        if (r | 0 ? q >>> 0 <= p >>> 0 | q >>> 0 > r >>> 0 : 0) {
                            b = 0;
                            break;
                        }
                        a = FC(b | 0) | 0;
                        if ((a | 0) == (d | 0)) {
                            h = b;
                            g = d;
                            v = 135;
                            break b;
                        } else {
                            e = a;
                            v = 126;
                        }
                    } else b = 0;
                }
                while (0);
                do if ((v | 0) == 126) {
                    d = 0 - b | 0;
                    if (!(i >>> 0 > b >>> 0 & (b >>> 0 < 2147483647 & (e | 0) != -1))) {
                        if ((e | 0) == -1) {
                            b = 0;
                            break;
                        } else {
                            h = b;
                            g = e;
                            v = 135;
                            break b;
                        }
                    }
                    a = c[2903] | 0;
                    a = j - b + a & 0 - a;
                    if (a >>> 0 >= 2147483647) {
                        h = b;
                        g = e;
                        v = 135;
                        break b;
                    }
                    if ((FC(a | 0) | 0) == -1) {
                        FC(d | 0);
                        b = 0;
                        break;
                    } else {
                        h = a + b | 0;
                        g = e;
                        v = 135;
                        break b;
                    }
                }
                while (0);
                c[2894] = c[2894] | 4;
                v = 133;
            } else {
                b = 0;
                v = 133;
            }
            while (0);
            if (((v | 0) == 133 ? k >>> 0 < 2147483647 : 0) ? (u = FC(k | 0) | 0, r = FC(0) | 0, s = r - u | 0, t = s >>> 0 > (n + 40 | 0) >>> 0, !((u | 0) == -1 | t ^ 1 | u >>> 0 < r >>> 0 & ((u | 0) != -1 & (r | 0) != -1) ^ 1)) : 0) {
                h = t ? s : b;
                g = u;
                v = 135;
            }
            if ((v | 0) == 135) {
                b = (c[2891] | 0) + h | 0;
                c[2891] = b;
                if (b >>> 0 > (c[2892] | 0) >>> 0) c[2892] = b;
                j = c[2789] | 0;
                do if (j) {
                    b = 11580;
                    while(true){
                        a = c[b >> 2] | 0;
                        d = b + 4 | 0;
                        e = c[d >> 2] | 0;
                        if ((g | 0) == (a + e | 0)) {
                            v = 145;
                            break;
                        }
                        f = c[b + 8 >> 2] | 0;
                        if (!f) break;
                        else b = f;
                    }
                    if (((v | 0) == 145 ? (c[b + 12 >> 2] & 8 | 0) == 0 : 0) ? j >>> 0 < g >>> 0 & j >>> 0 >= a >>> 0 : 0) {
                        c[d >> 2] = e + h;
                        w = j + 8 | 0;
                        w = (w & 7 | 0) == 0 ? 0 : 0 - w & 7;
                        v = j + w | 0;
                        w = (c[2786] | 0) + (h - w) | 0;
                        c[2789] = v;
                        c[2786] = w;
                        c[v + 4 >> 2] = w | 1;
                        c[v + w + 4 >> 2] = 40;
                        c[2790] = c[2905];
                        break;
                    }
                    if (g >>> 0 < (c[2787] | 0) >>> 0) c[2787] = g;
                    d = g + h | 0;
                    b = 11580;
                    while(true){
                        if ((c[b >> 2] | 0) == (d | 0)) {
                            v = 153;
                            break;
                        }
                        a = c[b + 8 >> 2] | 0;
                        if (!a) break;
                        else b = a;
                    }
                    if ((v | 0) == 153 ? (c[b + 12 >> 2] & 8 | 0) == 0 : 0) {
                        c[b >> 2] = g;
                        m = b + 4 | 0;
                        c[m >> 2] = (c[m >> 2] | 0) + h;
                        m = g + 8 | 0;
                        m = g + ((m & 7 | 0) == 0 ? 0 : 0 - m & 7) | 0;
                        b = d + 8 | 0;
                        b = d + ((b & 7 | 0) == 0 ? 0 : 0 - b & 7) | 0;
                        k = m + n | 0;
                        i = b - m - n | 0;
                        c[m + 4 >> 2] = n | 3;
                        do if ((b | 0) != (j | 0)) {
                            if ((b | 0) == (c[2788] | 0)) {
                                w = (c[2785] | 0) + i | 0;
                                c[2785] = w;
                                c[2788] = k;
                                c[k + 4 >> 2] = w | 1;
                                c[k + w >> 2] = w;
                                break;
                            }
                            a = c[b + 4 >> 2] | 0;
                            if ((a & 3 | 0) == 1) {
                                h = a & -8;
                                e = a >>> 3;
                                d: do if (a >>> 0 < 256) {
                                    a = c[b + 8 >> 2] | 0;
                                    d = c[b + 12 >> 2] | 0;
                                    if ((d | 0) == (a | 0)) {
                                        c[2783] = c[2783] & ~(1 << e);
                                        break;
                                    } else {
                                        c[a + 12 >> 2] = d;
                                        c[d + 8 >> 2] = a;
                                        break;
                                    }
                                } else {
                                    g = c[b + 24 >> 2] | 0;
                                    a = c[b + 12 >> 2] | 0;
                                    do if ((a | 0) == (b | 0)) {
                                        e = b + 16 | 0;
                                        d = e + 4 | 0;
                                        a = c[d >> 2] | 0;
                                        if (!a) {
                                            a = c[e >> 2] | 0;
                                            if (!a) {
                                                a = 0;
                                                break;
                                            } else d = e;
                                        }
                                        while(true){
                                            e = a + 20 | 0;
                                            f = c[e >> 2] | 0;
                                            if (f | 0) {
                                                a = f;
                                                d = e;
                                                continue;
                                            }
                                            e = a + 16 | 0;
                                            f = c[e >> 2] | 0;
                                            if (!f) break;
                                            else {
                                                a = f;
                                                d = e;
                                            }
                                        }
                                        c[d >> 2] = 0;
                                    } else {
                                        w = c[b + 8 >> 2] | 0;
                                        c[w + 12 >> 2] = a;
                                        c[a + 8 >> 2] = w;
                                    }
                                    while (0);
                                    if (!g) break;
                                    d = c[b + 28 >> 2] | 0;
                                    e = 11436 + (d << 2) | 0;
                                    do if ((b | 0) != (c[e >> 2] | 0)) {
                                        c[g + 16 + (((c[g + 16 >> 2] | 0) != (b | 0) & 1) << 2) >> 2] = a;
                                        if (!a) break d;
                                    } else {
                                        c[e >> 2] = a;
                                        if (a | 0) break;
                                        c[2784] = c[2784] & ~(1 << d);
                                        break d;
                                    }
                                    while (0);
                                    c[a + 24 >> 2] = g;
                                    d = b + 16 | 0;
                                    e = c[d >> 2] | 0;
                                    if (e | 0) {
                                        c[a + 16 >> 2] = e;
                                        c[e + 24 >> 2] = a;
                                    }
                                    d = c[d + 4 >> 2] | 0;
                                    if (!d) break;
                                    c[a + 20 >> 2] = d;
                                    c[d + 24 >> 2] = a;
                                }
                                while (0);
                                b = b + h | 0;
                                f = h + i | 0;
                            } else f = i;
                            b = b + 4 | 0;
                            c[b >> 2] = c[b >> 2] & -2;
                            c[k + 4 >> 2] = f | 1;
                            c[k + f >> 2] = f;
                            b = f >>> 3;
                            if (f >>> 0 < 256) {
                                d = 11172 + (b << 1 << 2) | 0;
                                a = c[2783] | 0;
                                b = 1 << b;
                                if (!(a & b)) {
                                    c[2783] = a | b;
                                    b = d;
                                    a = d + 8 | 0;
                                } else {
                                    a = d + 8 | 0;
                                    b = c[a >> 2] | 0;
                                }
                                c[a >> 2] = k;
                                c[b + 12 >> 2] = k;
                                c[k + 8 >> 2] = b;
                                c[k + 12 >> 2] = d;
                                break;
                            }
                            b = f >>> 8;
                            do if (!b) b = 0;
                            else {
                                if (f >>> 0 > 16777215) {
                                    b = 31;
                                    break;
                                }
                                v = (b + 1048320 | 0) >>> 16 & 8;
                                w = b << v;
                                u = (w + 520192 | 0) >>> 16 & 4;
                                w = w << u;
                                b = (w + 245760 | 0) >>> 16 & 2;
                                b = 14 - (u | v | b) + (w << b >>> 15) | 0;
                                b = f >>> (b + 7 | 0) & 1 | b << 1;
                            }
                            while (0);
                            e = 11436 + (b << 2) | 0;
                            c[k + 28 >> 2] = b;
                            a = k + 16 | 0;
                            c[a + 4 >> 2] = 0;
                            c[a >> 2] = 0;
                            a = c[2784] | 0;
                            d = 1 << b;
                            if (!(a & d)) {
                                c[2784] = a | d;
                                c[e >> 2] = k;
                                c[k + 24 >> 2] = e;
                                c[k + 12 >> 2] = k;
                                c[k + 8 >> 2] = k;
                                break;
                            }
                            a = f << ((b | 0) == 31 ? 0 : 25 - (b >>> 1) | 0);
                            d = c[e >> 2] | 0;
                            while(true){
                                if ((c[d + 4 >> 2] & -8 | 0) == (f | 0)) {
                                    v = 194;
                                    break;
                                }
                                e = d + 16 + (a >>> 31 << 2) | 0;
                                b = c[e >> 2] | 0;
                                if (!b) {
                                    v = 193;
                                    break;
                                } else {
                                    a = a << 1;
                                    d = b;
                                }
                            }
                            if ((v | 0) == 193) {
                                c[e >> 2] = k;
                                c[k + 24 >> 2] = d;
                                c[k + 12 >> 2] = k;
                                c[k + 8 >> 2] = k;
                                break;
                            } else if ((v | 0) == 194) {
                                v = d + 8 | 0;
                                w = c[v >> 2] | 0;
                                c[w + 12 >> 2] = k;
                                c[v >> 2] = k;
                                c[k + 8 >> 2] = w;
                                c[k + 12 >> 2] = d;
                                c[k + 24 >> 2] = 0;
                                break;
                            }
                        } else {
                            w = (c[2786] | 0) + i | 0;
                            c[2786] = w;
                            c[2789] = k;
                            c[k + 4 >> 2] = w | 1;
                        }
                        while (0);
                        w = m + 8 | 0;
                        l = x;
                        return w | 0;
                    }
                    b = 11580;
                    while(true){
                        a = c[b >> 2] | 0;
                        if (a >>> 0 <= j >>> 0 ? (w = a + (c[b + 4 >> 2] | 0) | 0, w >>> 0 > j >>> 0) : 0) break;
                        b = c[b + 8 >> 2] | 0;
                    }
                    f = w + -47 | 0;
                    a = f + 8 | 0;
                    a = f + ((a & 7 | 0) == 0 ? 0 : 0 - a & 7) | 0;
                    f = j + 16 | 0;
                    a = a >>> 0 < f >>> 0 ? j : a;
                    b = a + 8 | 0;
                    d = g + 8 | 0;
                    d = (d & 7 | 0) == 0 ? 0 : 0 - d & 7;
                    v = g + d | 0;
                    d = h + -40 - d | 0;
                    c[2789] = v;
                    c[2786] = d;
                    c[v + 4 >> 2] = d | 1;
                    c[v + d + 4 >> 2] = 40;
                    c[2790] = c[2905];
                    d = a + 4 | 0;
                    c[d >> 2] = 27;
                    c[b >> 2] = c[2895];
                    c[b + 4 >> 2] = c[2896];
                    c[b + 8 >> 2] = c[2897];
                    c[b + 12 >> 2] = c[2898];
                    c[2895] = g;
                    c[2896] = h;
                    c[2898] = 0;
                    c[2897] = b;
                    b = a + 24 | 0;
                    do {
                        v = b;
                        b = b + 4 | 0;
                        c[b >> 2] = 7;
                    }while ((v + 8 | 0) >>> 0 < w >>> 0);
                    if ((a | 0) != (j | 0)) {
                        g = a - j | 0;
                        c[d >> 2] = c[d >> 2] & -2;
                        c[j + 4 >> 2] = g | 1;
                        c[a >> 2] = g;
                        b = g >>> 3;
                        if (g >>> 0 < 256) {
                            d = 11172 + (b << 1 << 2) | 0;
                            a = c[2783] | 0;
                            b = 1 << b;
                            if (!(a & b)) {
                                c[2783] = a | b;
                                b = d;
                                a = d + 8 | 0;
                            } else {
                                a = d + 8 | 0;
                                b = c[a >> 2] | 0;
                            }
                            c[a >> 2] = j;
                            c[b + 12 >> 2] = j;
                            c[j + 8 >> 2] = b;
                            c[j + 12 >> 2] = d;
                            break;
                        }
                        b = g >>> 8;
                        if (b) {
                            if (g >>> 0 > 16777215) d = 31;
                            else {
                                v = (b + 1048320 | 0) >>> 16 & 8;
                                w = b << v;
                                u = (w + 520192 | 0) >>> 16 & 4;
                                w = w << u;
                                d = (w + 245760 | 0) >>> 16 & 2;
                                d = 14 - (u | v | d) + (w << d >>> 15) | 0;
                                d = g >>> (d + 7 | 0) & 1 | d << 1;
                            }
                        } else d = 0;
                        e = 11436 + (d << 2) | 0;
                        c[j + 28 >> 2] = d;
                        c[j + 20 >> 2] = 0;
                        c[f >> 2] = 0;
                        b = c[2784] | 0;
                        a = 1 << d;
                        if (!(b & a)) {
                            c[2784] = b | a;
                            c[e >> 2] = j;
                            c[j + 24 >> 2] = e;
                            c[j + 12 >> 2] = j;
                            c[j + 8 >> 2] = j;
                            break;
                        }
                        a = g << ((d | 0) == 31 ? 0 : 25 - (d >>> 1) | 0);
                        d = c[e >> 2] | 0;
                        while(true){
                            if ((c[d + 4 >> 2] & -8 | 0) == (g | 0)) {
                                v = 216;
                                break;
                            }
                            e = d + 16 + (a >>> 31 << 2) | 0;
                            b = c[e >> 2] | 0;
                            if (!b) {
                                v = 215;
                                break;
                            } else {
                                a = a << 1;
                                d = b;
                            }
                        }
                        if ((v | 0) == 215) {
                            c[e >> 2] = j;
                            c[j + 24 >> 2] = d;
                            c[j + 12 >> 2] = j;
                            c[j + 8 >> 2] = j;
                            break;
                        } else if ((v | 0) == 216) {
                            v = d + 8 | 0;
                            w = c[v >> 2] | 0;
                            c[w + 12 >> 2] = j;
                            c[v >> 2] = j;
                            c[j + 8 >> 2] = w;
                            c[j + 12 >> 2] = d;
                            c[j + 24 >> 2] = 0;
                            break;
                        }
                    }
                } else {
                    w = c[2787] | 0;
                    if ((w | 0) == 0 | g >>> 0 < w >>> 0) c[2787] = g;
                    c[2895] = g;
                    c[2896] = h;
                    c[2898] = 0;
                    c[2792] = c[2901];
                    c[2791] = -1;
                    b = 0;
                    do {
                        w = 11172 + (b << 1 << 2) | 0;
                        c[w + 12 >> 2] = w;
                        c[w + 8 >> 2] = w;
                        b = b + 1 | 0;
                    }while ((b | 0) != 32);
                    w = g + 8 | 0;
                    w = (w & 7 | 0) == 0 ? 0 : 0 - w & 7;
                    v = g + w | 0;
                    w = h + -40 - w | 0;
                    c[2789] = v;
                    c[2786] = w;
                    c[v + 4 >> 2] = w | 1;
                    c[v + w + 4 >> 2] = 40;
                    c[2790] = c[2905];
                }
                while (0);
                b = c[2786] | 0;
                if (b >>> 0 > n >>> 0) {
                    u = b - n | 0;
                    c[2786] = u;
                    w = c[2789] | 0;
                    v = w + n | 0;
                    c[2789] = v;
                    c[v + 4 >> 2] = u | 1;
                    c[w + 4 >> 2] = n | 3;
                    w = w + 8 | 0;
                    l = x;
                    return w | 0;
                }
            }
            c[(vB() | 0) >> 2] = 12;
            w = 0;
            l = x;
            return w | 0;
        }
        function pB(a) {
            a = a | 0;
            var b = 0, d = 0, e = 0, f = 0, g = 0, h = 0, i = 0, j = 0;
            if (!a) return;
            d = a + -8 | 0;
            f = c[2787] | 0;
            a = c[a + -4 >> 2] | 0;
            b = a & -8;
            j = d + b | 0;
            do if (!(a & 1)) {
                e = c[d >> 2] | 0;
                if (!(a & 3)) return;
                h = d + (0 - e) | 0;
                g = e + b | 0;
                if (h >>> 0 < f >>> 0) return;
                if ((h | 0) == (c[2788] | 0)) {
                    a = j + 4 | 0;
                    b = c[a >> 2] | 0;
                    if ((b & 3 | 0) != 3) {
                        i = h;
                        b = g;
                        break;
                    }
                    c[2785] = g;
                    c[a >> 2] = b & -2;
                    c[h + 4 >> 2] = g | 1;
                    c[h + g >> 2] = g;
                    return;
                }
                d = e >>> 3;
                if (e >>> 0 < 256) {
                    a = c[h + 8 >> 2] | 0;
                    b = c[h + 12 >> 2] | 0;
                    if ((b | 0) == (a | 0)) {
                        c[2783] = c[2783] & ~(1 << d);
                        i = h;
                        b = g;
                        break;
                    } else {
                        c[a + 12 >> 2] = b;
                        c[b + 8 >> 2] = a;
                        i = h;
                        b = g;
                        break;
                    }
                }
                f = c[h + 24 >> 2] | 0;
                a = c[h + 12 >> 2] | 0;
                do if ((a | 0) == (h | 0)) {
                    d = h + 16 | 0;
                    b = d + 4 | 0;
                    a = c[b >> 2] | 0;
                    if (!a) {
                        a = c[d >> 2] | 0;
                        if (!a) {
                            a = 0;
                            break;
                        } else b = d;
                    }
                    while(true){
                        d = a + 20 | 0;
                        e = c[d >> 2] | 0;
                        if (e | 0) {
                            a = e;
                            b = d;
                            continue;
                        }
                        d = a + 16 | 0;
                        e = c[d >> 2] | 0;
                        if (!e) break;
                        else {
                            a = e;
                            b = d;
                        }
                    }
                    c[b >> 2] = 0;
                } else {
                    i = c[h + 8 >> 2] | 0;
                    c[i + 12 >> 2] = a;
                    c[a + 8 >> 2] = i;
                }
                while (0);
                if (f) {
                    b = c[h + 28 >> 2] | 0;
                    d = 11436 + (b << 2) | 0;
                    if ((h | 0) == (c[d >> 2] | 0)) {
                        c[d >> 2] = a;
                        if (!a) {
                            c[2784] = c[2784] & ~(1 << b);
                            i = h;
                            b = g;
                            break;
                        }
                    } else {
                        c[f + 16 + (((c[f + 16 >> 2] | 0) != (h | 0) & 1) << 2) >> 2] = a;
                        if (!a) {
                            i = h;
                            b = g;
                            break;
                        }
                    }
                    c[a + 24 >> 2] = f;
                    b = h + 16 | 0;
                    d = c[b >> 2] | 0;
                    if (d | 0) {
                        c[a + 16 >> 2] = d;
                        c[d + 24 >> 2] = a;
                    }
                    b = c[b + 4 >> 2] | 0;
                    if (b) {
                        c[a + 20 >> 2] = b;
                        c[b + 24 >> 2] = a;
                        i = h;
                        b = g;
                    } else {
                        i = h;
                        b = g;
                    }
                } else {
                    i = h;
                    b = g;
                }
            } else {
                i = d;
                h = d;
            }
            while (0);
            if (h >>> 0 >= j >>> 0) return;
            a = j + 4 | 0;
            e = c[a >> 2] | 0;
            if (!(e & 1)) return;
            if (!(e & 2)) {
                a = c[2788] | 0;
                if ((j | 0) == (c[2789] | 0)) {
                    j = (c[2786] | 0) + b | 0;
                    c[2786] = j;
                    c[2789] = i;
                    c[i + 4 >> 2] = j | 1;
                    if ((i | 0) != (a | 0)) return;
                    c[2788] = 0;
                    c[2785] = 0;
                    return;
                }
                if ((j | 0) == (a | 0)) {
                    j = (c[2785] | 0) + b | 0;
                    c[2785] = j;
                    c[2788] = h;
                    c[i + 4 >> 2] = j | 1;
                    c[h + j >> 2] = j;
                    return;
                }
                f = (e & -8) + b | 0;
                d = e >>> 3;
                do if (e >>> 0 < 256) {
                    b = c[j + 8 >> 2] | 0;
                    a = c[j + 12 >> 2] | 0;
                    if ((a | 0) == (b | 0)) {
                        c[2783] = c[2783] & ~(1 << d);
                        break;
                    } else {
                        c[b + 12 >> 2] = a;
                        c[a + 8 >> 2] = b;
                        break;
                    }
                } else {
                    g = c[j + 24 >> 2] | 0;
                    a = c[j + 12 >> 2] | 0;
                    do if ((a | 0) == (j | 0)) {
                        d = j + 16 | 0;
                        b = d + 4 | 0;
                        a = c[b >> 2] | 0;
                        if (!a) {
                            a = c[d >> 2] | 0;
                            if (!a) {
                                d = 0;
                                break;
                            } else b = d;
                        }
                        while(true){
                            d = a + 20 | 0;
                            e = c[d >> 2] | 0;
                            if (e | 0) {
                                a = e;
                                b = d;
                                continue;
                            }
                            d = a + 16 | 0;
                            e = c[d >> 2] | 0;
                            if (!e) break;
                            else {
                                a = e;
                                b = d;
                            }
                        }
                        c[b >> 2] = 0;
                        d = a;
                    } else {
                        d = c[j + 8 >> 2] | 0;
                        c[d + 12 >> 2] = a;
                        c[a + 8 >> 2] = d;
                        d = a;
                    }
                    while (0);
                    if (g | 0) {
                        a = c[j + 28 >> 2] | 0;
                        b = 11436 + (a << 2) | 0;
                        if ((j | 0) == (c[b >> 2] | 0)) {
                            c[b >> 2] = d;
                            if (!d) {
                                c[2784] = c[2784] & ~(1 << a);
                                break;
                            }
                        } else {
                            c[g + 16 + (((c[g + 16 >> 2] | 0) != (j | 0) & 1) << 2) >> 2] = d;
                            if (!d) break;
                        }
                        c[d + 24 >> 2] = g;
                        a = j + 16 | 0;
                        b = c[a >> 2] | 0;
                        if (b | 0) {
                            c[d + 16 >> 2] = b;
                            c[b + 24 >> 2] = d;
                        }
                        a = c[a + 4 >> 2] | 0;
                        if (a | 0) {
                            c[d + 20 >> 2] = a;
                            c[a + 24 >> 2] = d;
                        }
                    }
                }
                while (0);
                c[i + 4 >> 2] = f | 1;
                c[h + f >> 2] = f;
                if ((i | 0) == (c[2788] | 0)) {
                    c[2785] = f;
                    return;
                }
            } else {
                c[a >> 2] = e & -2;
                c[i + 4 >> 2] = b | 1;
                c[h + b >> 2] = b;
                f = b;
            }
            a = f >>> 3;
            if (f >>> 0 < 256) {
                d = 11172 + (a << 1 << 2) | 0;
                b = c[2783] | 0;
                a = 1 << a;
                if (!(b & a)) {
                    c[2783] = b | a;
                    a = d;
                    b = d + 8 | 0;
                } else {
                    b = d + 8 | 0;
                    a = c[b >> 2] | 0;
                }
                c[b >> 2] = i;
                c[a + 12 >> 2] = i;
                c[i + 8 >> 2] = a;
                c[i + 12 >> 2] = d;
                return;
            }
            a = f >>> 8;
            if (a) {
                if (f >>> 0 > 16777215) a = 31;
                else {
                    h = (a + 1048320 | 0) >>> 16 & 8;
                    j = a << h;
                    g = (j + 520192 | 0) >>> 16 & 4;
                    j = j << g;
                    a = (j + 245760 | 0) >>> 16 & 2;
                    a = 14 - (g | h | a) + (j << a >>> 15) | 0;
                    a = f >>> (a + 7 | 0) & 1 | a << 1;
                }
            } else a = 0;
            e = 11436 + (a << 2) | 0;
            c[i + 28 >> 2] = a;
            c[i + 20 >> 2] = 0;
            c[i + 16 >> 2] = 0;
            b = c[2784] | 0;
            d = 1 << a;
            do if (b & d) {
                b = f << ((a | 0) == 31 ? 0 : 25 - (a >>> 1) | 0);
                d = c[e >> 2] | 0;
                while(true){
                    if ((c[d + 4 >> 2] & -8 | 0) == (f | 0)) {
                        a = 73;
                        break;
                    }
                    e = d + 16 + (b >>> 31 << 2) | 0;
                    a = c[e >> 2] | 0;
                    if (!a) {
                        a = 72;
                        break;
                    } else {
                        b = b << 1;
                        d = a;
                    }
                }
                if ((a | 0) == 72) {
                    c[e >> 2] = i;
                    c[i + 24 >> 2] = d;
                    c[i + 12 >> 2] = i;
                    c[i + 8 >> 2] = i;
                    break;
                } else if ((a | 0) == 73) {
                    h = d + 8 | 0;
                    j = c[h >> 2] | 0;
                    c[j + 12 >> 2] = i;
                    c[h >> 2] = i;
                    c[i + 8 >> 2] = j;
                    c[i + 12 >> 2] = d;
                    c[i + 24 >> 2] = 0;
                    break;
                }
            } else {
                c[2784] = b | d;
                c[e >> 2] = i;
                c[i + 24 >> 2] = e;
                c[i + 12 >> 2] = i;
                c[i + 8 >> 2] = i;
            }
            while (0);
            j = (c[2791] | 0) + -1 | 0;
            c[2791] = j;
            if (!j) a = 11588;
            else return;
            while(true){
                a = c[a >> 2] | 0;
                if (!a) break;
                else a = a + 8 | 0;
            }
            c[2791] = -1;
            return;
        }
        function qB() {
            return 11628;
        }
        function rB(a) {
            a = a | 0;
            var b = 0, d = 0;
            b = l;
            l = l + 16 | 0;
            d = b;
            c[d >> 2] = yB(c[a + 60 >> 2] | 0) | 0;
            a = uB(db(6, d | 0) | 0) | 0;
            l = b;
            return a | 0;
        }
        function sB(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0;
            n = l;
            l = l + 48 | 0;
            k = n + 16 | 0;
            g = n;
            f = n + 32 | 0;
            i = a + 28 | 0;
            e = c[i >> 2] | 0;
            c[f >> 2] = e;
            j = a + 20 | 0;
            e = (c[j >> 2] | 0) - e | 0;
            c[f + 4 >> 2] = e;
            c[f + 8 >> 2] = b;
            c[f + 12 >> 2] = d;
            e = e + d | 0;
            h = a + 60 | 0;
            c[g >> 2] = c[h >> 2];
            c[g + 4 >> 2] = f;
            c[g + 8 >> 2] = 2;
            g = uB(gb(146, g | 0) | 0) | 0;
            a: do if ((e | 0) != (g | 0)) {
                b = 2;
                while(true){
                    if ((g | 0) < 0) break;
                    e = e - g | 0;
                    p = c[f + 4 >> 2] | 0;
                    o = g >>> 0 > p >>> 0;
                    f = o ? f + 8 | 0 : f;
                    b = (o << 31 >> 31) + b | 0;
                    p = g - (o ? p : 0) | 0;
                    c[f >> 2] = (c[f >> 2] | 0) + p;
                    o = f + 4 | 0;
                    c[o >> 2] = (c[o >> 2] | 0) - p;
                    c[k >> 2] = c[h >> 2];
                    c[k + 4 >> 2] = f;
                    c[k + 8 >> 2] = b;
                    g = uB(gb(146, k | 0) | 0) | 0;
                    if ((e | 0) == (g | 0)) {
                        m = 3;
                        break a;
                    }
                }
                c[a + 16 >> 2] = 0;
                c[i >> 2] = 0;
                c[j >> 2] = 0;
                c[a >> 2] = c[a >> 2] | 32;
                if ((b | 0) == 2) d = 0;
                else d = d - (c[f + 4 >> 2] | 0) | 0;
            } else m = 3;
            while (0);
            if ((m | 0) == 3) {
                p = c[a + 44 >> 2] | 0;
                c[a + 16 >> 2] = p + (c[a + 48 >> 2] | 0);
                c[i >> 2] = p;
                c[j >> 2] = p;
            }
            l = n;
            return d | 0;
        }
        function tB(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0;
            f = l;
            l = l + 32 | 0;
            g = f;
            e = f + 20 | 0;
            c[g >> 2] = c[a + 60 >> 2];
            c[g + 4 >> 2] = 0;
            c[g + 8 >> 2] = b;
            c[g + 12 >> 2] = e;
            c[g + 16 >> 2] = d;
            if ((uB(fb(140, g | 0) | 0) | 0) < 0) {
                c[e >> 2] = -1;
                a = -1;
            } else a = c[e >> 2] | 0;
            l = f;
            return a | 0;
        }
        function uB(a) {
            a = a | 0;
            if (a >>> 0 > 4294963200) {
                c[(vB() | 0) >> 2] = 0 - a;
                a = -1;
            }
            return a | 0;
        }
        function vB() {
            return (wB() | 0) + 64 | 0;
        }
        function wB() {
            return xB() | 0;
        }
        function xB() {
            return 2084;
        }
        function yB(a) {
            a = a | 0;
            return a | 0;
        }
        function zB(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = l;
            l = l + 32 | 0;
            f = g;
            c[b + 36 >> 2] = 1;
            if ((c[b >> 2] & 64 | 0) == 0 ? (c[f >> 2] = c[b + 60 >> 2], c[f + 4 >> 2] = 21523, c[f + 8 >> 2] = g + 16, Wa(54, f | 0) | 0) : 0) a[b + 75 >> 0] = -1;
            f = sB(b, d, e) | 0;
            l = g;
            return f | 0;
        }
        function AB(b, c) {
            b = b | 0;
            c = c | 0;
            var d = 0, e = 0;
            d = a[b >> 0] | 0;
            e = a[c >> 0] | 0;
            if (d << 24 >> 24 == 0 ? 1 : d << 24 >> 24 != e << 24 >> 24) b = e;
            else {
                do {
                    b = b + 1 | 0;
                    c = c + 1 | 0;
                    d = a[b >> 0] | 0;
                    e = a[c >> 0] | 0;
                }while (!(d << 24 >> 24 == 0 ? 1 : d << 24 >> 24 != e << 24 >> 24));
                b = e;
            }
            return (d & 255) - (b & 255) | 0;
        }
        function BB(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0, f = 0;
            a: do if (!d) b = 0;
            else {
                while(true){
                    e = a[b >> 0] | 0;
                    f = a[c >> 0] | 0;
                    if (e << 24 >> 24 != f << 24 >> 24) break;
                    d = d + -1 | 0;
                    if (!d) {
                        b = 0;
                        break a;
                    } else {
                        b = b + 1 | 0;
                        c = c + 1 | 0;
                    }
                }
                b = (e & 255) - (f & 255) | 0;
            }
            while (0);
            return b | 0;
        }
        function CB(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0;
            s = l;
            l = l + 224 | 0;
            n = s + 120 | 0;
            o = s + 80 | 0;
            q = s;
            r = s + 136 | 0;
            f = o;
            g = f + 40 | 0;
            do {
                c[f >> 2] = 0;
                f = f + 4 | 0;
            }while ((f | 0) < (g | 0));
            c[n >> 2] = c[e >> 2];
            if ((DB(0, d, n, q, o) | 0) < 0) e = -1;
            else {
                if ((c[b + 76 >> 2] | 0) > -1) p = EB(b) | 0;
                else p = 0;
                e = c[b >> 2] | 0;
                m = e & 32;
                if ((a[b + 74 >> 0] | 0) < 1) c[b >> 2] = e & -33;
                f = b + 48 | 0;
                if (!(c[f >> 2] | 0)) {
                    g = b + 44 | 0;
                    h = c[g >> 2] | 0;
                    c[g >> 2] = r;
                    i = b + 28 | 0;
                    c[i >> 2] = r;
                    j = b + 20 | 0;
                    c[j >> 2] = r;
                    c[f >> 2] = 80;
                    k = b + 16 | 0;
                    c[k >> 2] = r + 80;
                    e = DB(b, d, n, q, o) | 0;
                    if (h) {
                        sb[c[b + 36 >> 2] & 7](b, 0, 0);
                        e = (c[j >> 2] | 0) == 0 ? -1 : e;
                        c[g >> 2] = h;
                        c[f >> 2] = 0;
                        c[k >> 2] = 0;
                        c[i >> 2] = 0;
                        c[j >> 2] = 0;
                    }
                } else e = DB(b, d, n, q, o) | 0;
                f = c[b >> 2] | 0;
                c[b >> 2] = f | m;
                if (p | 0) FB(b);
                e = (f & 32 | 0) == 0 ? e : -1;
            }
            l = s;
            return e | 0;
        }
        function DB(d, e, f, g, i) {
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            i = i | 0;
            var j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0;
            H = l;
            l = l + 64 | 0;
            D = H + 16 | 0;
            E = H;
            B = H + 24 | 0;
            F = H + 8 | 0;
            G = H + 20 | 0;
            c[D >> 2] = e;
            x = (d | 0) != 0;
            y = B + 40 | 0;
            z = y;
            B = B + 39 | 0;
            C = F + 4 | 0;
            k = 0;
            j = 0;
            p = 0;
            a: while(true){
                do if ((j | 0) > -1) {
                    if ((k | 0) > (2147483647 - j | 0)) {
                        c[(vB() | 0) >> 2] = 75;
                        j = -1;
                        break;
                    } else {
                        j = k + j | 0;
                        break;
                    }
                }
                while (0);
                k = a[e >> 0] | 0;
                if (!(k << 24 >> 24)) {
                    w = 87;
                    break;
                } else m = e;
                b: while(true){
                    switch(k << 24 >> 24){
                        case 37:
                            k = m;
                            w = 9;
                            break b;
                        case 0:
                            k = m;
                            break b;
                        default:
                    }
                    v = m + 1 | 0;
                    c[D >> 2] = v;
                    k = a[v >> 0] | 0;
                    m = v;
                }
                c: do if ((w | 0) == 9) while(true){
                    w = 0;
                    if ((a[m + 1 >> 0] | 0) != 37) break c;
                    k = k + 1 | 0;
                    m = m + 2 | 0;
                    c[D >> 2] = m;
                    if ((a[m >> 0] | 0) == 37) w = 9;
                    else break;
                }
                while (0);
                k = k - e | 0;
                if (x) GB(d, e, k);
                if (k | 0) {
                    e = m;
                    continue;
                }
                n = m + 1 | 0;
                k = (a[n >> 0] | 0) + -48 | 0;
                if (k >>> 0 < 10) {
                    v = (a[m + 2 >> 0] | 0) == 36;
                    u = v ? k : -1;
                    p = v ? 1 : p;
                    n = v ? m + 3 | 0 : n;
                } else u = -1;
                c[D >> 2] = n;
                k = a[n >> 0] | 0;
                m = (k << 24 >> 24) + -32 | 0;
                d: do if (m >>> 0 < 32) {
                    o = 0;
                    q = k;
                    while(true){
                        k = 1 << m;
                        if (!(k & 75913)) {
                            k = q;
                            break d;
                        }
                        o = k | o;
                        n = n + 1 | 0;
                        c[D >> 2] = n;
                        k = a[n >> 0] | 0;
                        m = (k << 24 >> 24) + -32 | 0;
                        if (m >>> 0 >= 32) break;
                        else q = k;
                    }
                } else o = 0;
                while (0);
                if (k << 24 >> 24 == 42) {
                    m = n + 1 | 0;
                    k = (a[m >> 0] | 0) + -48 | 0;
                    if (k >>> 0 < 10 ? (a[n + 2 >> 0] | 0) == 36 : 0) {
                        c[i + (k << 2) >> 2] = 10;
                        k = c[g + ((a[m >> 0] | 0) + -48 << 3) >> 2] | 0;
                        p = 1;
                        n = n + 3 | 0;
                    } else {
                        if (p | 0) {
                            j = -1;
                            break;
                        }
                        if (x) {
                            p = (c[f >> 2] | 0) + 3 & -4;
                            k = c[p >> 2] | 0;
                            c[f >> 2] = p + 4;
                            p = 0;
                            n = m;
                        } else {
                            k = 0;
                            p = 0;
                            n = m;
                        }
                    }
                    c[D >> 2] = n;
                    v = (k | 0) < 0;
                    k = v ? 0 - k | 0 : k;
                    o = v ? o | 8192 : o;
                } else {
                    k = HB(D) | 0;
                    if ((k | 0) < 0) {
                        j = -1;
                        break;
                    }
                    n = c[D >> 2] | 0;
                }
                do if ((a[n >> 0] | 0) == 46) {
                    if ((a[n + 1 >> 0] | 0) != 42) {
                        c[D >> 2] = n + 1;
                        m = HB(D) | 0;
                        n = c[D >> 2] | 0;
                        break;
                    }
                    q = n + 2 | 0;
                    m = (a[q >> 0] | 0) + -48 | 0;
                    if (m >>> 0 < 10 ? (a[n + 3 >> 0] | 0) == 36 : 0) {
                        c[i + (m << 2) >> 2] = 10;
                        m = c[g + ((a[q >> 0] | 0) + -48 << 3) >> 2] | 0;
                        n = n + 4 | 0;
                        c[D >> 2] = n;
                        break;
                    }
                    if (p | 0) {
                        j = -1;
                        break a;
                    }
                    if (x) {
                        v = (c[f >> 2] | 0) + 3 & -4;
                        m = c[v >> 2] | 0;
                        c[f >> 2] = v + 4;
                    } else m = 0;
                    c[D >> 2] = q;
                    n = q;
                } else m = -1;
                while (0);
                t = 0;
                while(true){
                    if (((a[n >> 0] | 0) + -65 | 0) >>> 0 > 57) {
                        j = -1;
                        break a;
                    }
                    v = n + 1 | 0;
                    c[D >> 2] = v;
                    q = a[(a[n >> 0] | 0) + -65 + (5178 + (t * 58 | 0)) >> 0] | 0;
                    r = q & 255;
                    if ((r + -1 | 0) >>> 0 < 8) {
                        t = r;
                        n = v;
                    } else break;
                }
                if (!(q << 24 >> 24)) {
                    j = -1;
                    break;
                }
                s = (u | 0) > -1;
                do if (q << 24 >> 24 == 19) {
                    if (s) {
                        j = -1;
                        break a;
                    } else w = 49;
                } else {
                    if (s) {
                        c[i + (u << 2) >> 2] = r;
                        s = g + (u << 3) | 0;
                        u = c[s + 4 >> 2] | 0;
                        w = E;
                        c[w >> 2] = c[s >> 2];
                        c[w + 4 >> 2] = u;
                        w = 49;
                        break;
                    }
                    if (!x) {
                        j = 0;
                        break a;
                    }
                    IB(E, r, f);
                }
                while (0);
                if ((w | 0) == 49 ? (w = 0, !x) : 0) {
                    k = 0;
                    e = v;
                    continue;
                }
                n = a[n >> 0] | 0;
                n = (t | 0) != 0 & (n & 15 | 0) == 3 ? n & -33 : n;
                s = o & -65537;
                u = (o & 8192 | 0) == 0 ? o : s;
                e: do switch(n | 0){
                    case 110:
                        switch((t & 255) << 24 >> 24){
                            case 0:
                                c[c[E >> 2] >> 2] = j;
                                k = 0;
                                e = v;
                                continue a;
                            case 1:
                                c[c[E >> 2] >> 2] = j;
                                k = 0;
                                e = v;
                                continue a;
                            case 2:
                                k = c[E >> 2] | 0;
                                c[k >> 2] = j;
                                c[k + 4 >> 2] = ((j | 0) < 0) << 31 >> 31;
                                k = 0;
                                e = v;
                                continue a;
                            case 3:
                                b[c[E >> 2] >> 1] = j;
                                k = 0;
                                e = v;
                                continue a;
                            case 4:
                                a[c[E >> 2] >> 0] = j;
                                k = 0;
                                e = v;
                                continue a;
                            case 6:
                                c[c[E >> 2] >> 2] = j;
                                k = 0;
                                e = v;
                                continue a;
                            case 7:
                                k = c[E >> 2] | 0;
                                c[k >> 2] = j;
                                c[k + 4 >> 2] = ((j | 0) < 0) << 31 >> 31;
                                k = 0;
                                e = v;
                                continue a;
                            default:
                                k = 0;
                                e = v;
                                continue a;
                        }
                    case 112:
                        n = 120;
                        m = m >>> 0 > 8 ? m : 8;
                        e = u | 8;
                        w = 61;
                        break;
                    case 88:
                    case 120:
                        e = u;
                        w = 61;
                        break;
                    case 111:
                        n = E;
                        e = c[n >> 2] | 0;
                        n = c[n + 4 >> 2] | 0;
                        r = KB(e, n, y) | 0;
                        s = z - r | 0;
                        o = 0;
                        q = 5642;
                        m = (u & 8 | 0) == 0 | (m | 0) > (s | 0) ? m : s + 1 | 0;
                        s = u;
                        w = 67;
                        break;
                    case 105:
                    case 100:
                        n = E;
                        e = c[n >> 2] | 0;
                        n = c[n + 4 >> 2] | 0;
                        if ((n | 0) < 0) {
                            e = wC(0, 0, e | 0, n | 0) | 0;
                            n = A;
                            o = E;
                            c[o >> 2] = e;
                            c[o + 4 >> 2] = n;
                            o = 1;
                            q = 5642;
                            w = 66;
                            break e;
                        } else {
                            o = (u & 2049 | 0) != 0 & 1;
                            q = (u & 2048 | 0) == 0 ? (u & 1 | 0) == 0 ? 5642 : 5644 : 5643;
                            w = 66;
                            break e;
                        }
                    case 117:
                        n = E;
                        o = 0;
                        q = 5642;
                        e = c[n >> 2] | 0;
                        n = c[n + 4 >> 2] | 0;
                        w = 66;
                        break;
                    case 99:
                        a[B >> 0] = c[E >> 2];
                        e = B;
                        o = 0;
                        q = 5642;
                        r = y;
                        n = 1;
                        m = s;
                        break;
                    case 109:
                        n = MB(c[(vB() | 0) >> 2] | 0) | 0;
                        w = 71;
                        break;
                    case 115:
                        n = c[E >> 2] | 0;
                        n = n | 0 ? n : 5652;
                        w = 71;
                        break;
                    case 67:
                        c[F >> 2] = c[E >> 2];
                        c[C >> 2] = 0;
                        c[E >> 2] = F;
                        r = -1;
                        n = F;
                        w = 75;
                        break;
                    case 83:
                        e = c[E >> 2] | 0;
                        if (!m) {
                            OB(d, 32, k, 0, u);
                            e = 0;
                            w = 84;
                        } else {
                            r = m;
                            n = e;
                            w = 75;
                        }
                        break;
                    case 65:
                    case 71:
                    case 70:
                    case 69:
                    case 97:
                    case 103:
                    case 102:
                    case 101:
                        k = QB(d, +h[E >> 3], k, m, u, n) | 0;
                        e = v;
                        continue a;
                    default:
                        o = 0;
                        q = 5642;
                        r = y;
                        n = m;
                        m = u;
                }
                while (0);
                f: do if ((w | 0) == 61) {
                    u = E;
                    t = c[u >> 2] | 0;
                    u = c[u + 4 >> 2] | 0;
                    r = JB(t, u, y, n & 32) | 0;
                    q = (e & 8 | 0) == 0 | (t | 0) == 0 & (u | 0) == 0;
                    o = q ? 0 : 2;
                    q = q ? 5642 : 5642 + (n >> 4) | 0;
                    s = e;
                    e = t;
                    n = u;
                    w = 67;
                } else if ((w | 0) == 66) {
                    r = LB(e, n, y) | 0;
                    s = u;
                    w = 67;
                } else if ((w | 0) == 71) {
                    w = 0;
                    u = NB(n, 0, m) | 0;
                    t = (u | 0) == 0;
                    e = n;
                    o = 0;
                    q = 5642;
                    r = t ? n + m | 0 : u;
                    n = t ? m : u - n | 0;
                    m = s;
                } else if ((w | 0) == 75) {
                    w = 0;
                    q = n;
                    e = 0;
                    m = 0;
                    while(true){
                        o = c[q >> 2] | 0;
                        if (!o) break;
                        m = PB(G, o) | 0;
                        if ((m | 0) < 0 | m >>> 0 > (r - e | 0) >>> 0) break;
                        e = m + e | 0;
                        if (r >>> 0 > e >>> 0) q = q + 4 | 0;
                        else break;
                    }
                    if ((m | 0) < 0) {
                        j = -1;
                        break a;
                    }
                    OB(d, 32, k, e, u);
                    if (!e) {
                        e = 0;
                        w = 84;
                    } else {
                        o = 0;
                        while(true){
                            m = c[n >> 2] | 0;
                            if (!m) {
                                w = 84;
                                break f;
                            }
                            m = PB(G, m) | 0;
                            o = m + o | 0;
                            if ((o | 0) > (e | 0)) {
                                w = 84;
                                break f;
                            }
                            GB(d, G, m);
                            if (o >>> 0 >= e >>> 0) {
                                w = 84;
                                break;
                            } else n = n + 4 | 0;
                        }
                    }
                }
                while (0);
                if ((w | 0) == 67) {
                    w = 0;
                    n = (e | 0) != 0 | (n | 0) != 0;
                    u = (m | 0) != 0 | n;
                    n = ((n ^ 1) & 1) + (z - r) | 0;
                    e = u ? r : y;
                    r = y;
                    n = u ? (m | 0) > (n | 0) ? m : n : m;
                    m = (m | 0) > -1 ? s & -65537 : s;
                } else if ((w | 0) == 84) {
                    w = 0;
                    OB(d, 32, k, e, u ^ 8192);
                    k = (k | 0) > (e | 0) ? k : e;
                    e = v;
                    continue;
                }
                t = r - e | 0;
                s = (n | 0) < (t | 0) ? t : n;
                u = s + o | 0;
                k = (k | 0) < (u | 0) ? u : k;
                OB(d, 32, k, u, m);
                GB(d, q, o);
                OB(d, 48, k, u, m ^ 65536);
                OB(d, 48, s, t, 0);
                GB(d, e, t);
                OB(d, 32, k, u, m ^ 8192);
                e = v;
            }
            g: do if ((w | 0) == 87) {
                if (!d) {
                    if (!p) j = 0;
                    else {
                        j = 1;
                        while(true){
                            e = c[i + (j << 2) >> 2] | 0;
                            if (!e) break;
                            IB(g + (j << 3) | 0, e, f);
                            j = j + 1 | 0;
                            if ((j | 0) >= 10) {
                                j = 1;
                                break g;
                            }
                        }
                        while(true){
                            if (c[i + (j << 2) >> 2] | 0) {
                                j = -1;
                                break g;
                            }
                            j = j + 1 | 0;
                            if ((j | 0) >= 10) {
                                j = 1;
                                break;
                            }
                        }
                    }
                }
            }
            while (0);
            l = H;
            return j | 0;
        }
        function EB(a) {
            a = a | 0;
            return 0;
        }
        function FB(a) {
            a = a | 0;
            return;
        }
        function GB(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            if (!(c[a >> 2] & 32)) aC(b, d, a);
            return;
        }
        function HB(b) {
            b = b | 0;
            var d = 0, e = 0, f = 0;
            e = c[b >> 2] | 0;
            f = (a[e >> 0] | 0) + -48 | 0;
            if (f >>> 0 < 10) {
                d = 0;
                do {
                    d = f + (d * 10 | 0) | 0;
                    e = e + 1 | 0;
                    c[b >> 2] = e;
                    f = (a[e >> 0] | 0) + -48 | 0;
                }while (f >>> 0 < 10);
            } else d = 0;
            return d | 0;
        }
        function IB(a, b, d) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            var e = 0, f = 0, g = 0.0;
            a: if (b >>> 0 <= 20) switch(b | 0){
                case 9:
                    e = (c[d >> 2] | 0) + 3 & -4;
                    b = c[e >> 2] | 0;
                    c[d >> 2] = e + 4;
                    c[a >> 2] = b;
                    break a;
                case 10:
                    e = (c[d >> 2] | 0) + 3 & -4;
                    b = c[e >> 2] | 0;
                    c[d >> 2] = e + 4;
                    e = a;
                    c[e >> 2] = b;
                    c[e + 4 >> 2] = ((b | 0) < 0) << 31 >> 31;
                    break a;
                case 11:
                    e = (c[d >> 2] | 0) + 3 & -4;
                    b = c[e >> 2] | 0;
                    c[d >> 2] = e + 4;
                    e = a;
                    c[e >> 2] = b;
                    c[e + 4 >> 2] = 0;
                    break a;
                case 12:
                    e = (c[d >> 2] | 0) + 7 & -8;
                    b = e;
                    f = c[b >> 2] | 0;
                    b = c[b + 4 >> 2] | 0;
                    c[d >> 2] = e + 8;
                    e = a;
                    c[e >> 2] = f;
                    c[e + 4 >> 2] = b;
                    break a;
                case 13:
                    f = (c[d >> 2] | 0) + 3 & -4;
                    e = c[f >> 2] | 0;
                    c[d >> 2] = f + 4;
                    e = (e & 65535) << 16 >> 16;
                    f = a;
                    c[f >> 2] = e;
                    c[f + 4 >> 2] = ((e | 0) < 0) << 31 >> 31;
                    break a;
                case 14:
                    f = (c[d >> 2] | 0) + 3 & -4;
                    e = c[f >> 2] | 0;
                    c[d >> 2] = f + 4;
                    f = a;
                    c[f >> 2] = e & 65535;
                    c[f + 4 >> 2] = 0;
                    break a;
                case 15:
                    f = (c[d >> 2] | 0) + 3 & -4;
                    e = c[f >> 2] | 0;
                    c[d >> 2] = f + 4;
                    e = (e & 255) << 24 >> 24;
                    f = a;
                    c[f >> 2] = e;
                    c[f + 4 >> 2] = ((e | 0) < 0) << 31 >> 31;
                    break a;
                case 16:
                    f = (c[d >> 2] | 0) + 3 & -4;
                    e = c[f >> 2] | 0;
                    c[d >> 2] = f + 4;
                    f = a;
                    c[f >> 2] = e & 255;
                    c[f + 4 >> 2] = 0;
                    break a;
                case 17:
                    f = (c[d >> 2] | 0) + 7 & -8;
                    g = +h[f >> 3];
                    c[d >> 2] = f + 8;
                    h[a >> 3] = g;
                    break a;
                case 18:
                    f = (c[d >> 2] | 0) + 7 & -8;
                    g = +h[f >> 3];
                    c[d >> 2] = f + 8;
                    h[a >> 3] = g;
                    break a;
                default:
                    break a;
            }
            return;
        }
        function JB(b, c, e, f) {
            b = b | 0;
            c = c | 0;
            e = e | 0;
            f = f | 0;
            if (!((b | 0) == 0 & (c | 0) == 0)) do {
                e = e + -1 | 0;
                a[e >> 0] = d[5694 + (b & 15) >> 0] | 0 | f;
                b = AC(b | 0, c | 0, 4) | 0;
                c = A;
            }while (!((b | 0) == 0 & (c | 0) == 0));
            return e | 0;
        }
        function KB(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            if (!((b | 0) == 0 & (c | 0) == 0)) do {
                d = d + -1 | 0;
                a[d >> 0] = b & 7 | 48;
                b = AC(b | 0, c | 0, 3) | 0;
                c = A;
            }while (!((b | 0) == 0 & (c | 0) == 0));
            return d | 0;
        }
        function LB(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            if (c >>> 0 > 0 | (c | 0) == 0 & b >>> 0 > 4294967295) {
                while(true){
                    e = HC(b | 0, c | 0, 10, 0) | 0;
                    d = d + -1 | 0;
                    a[d >> 0] = e & 255 | 48;
                    e = b;
                    b = EC(b | 0, c | 0, 10, 0) | 0;
                    if (!(c >>> 0 > 9 | (c | 0) == 9 & e >>> 0 > 4294967295)) break;
                    else c = A;
                }
                c = b;
            } else c = b;
            if (c) while(true){
                d = d + -1 | 0;
                a[d >> 0] = (c >>> 0) % 10 | 48;
                if (c >>> 0 < 10) break;
                else c = (c >>> 0) / 10 | 0;
            }
            return d | 0;
        }
        function MB(a) {
            a = a | 0;
            return XB(a, c[(WB() | 0) + 188 >> 2] | 0) | 0;
        }
        function NB(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = d & 255;
            f = (e | 0) != 0;
            a: do if (f & (b & 3 | 0) != 0) {
                g = d & 255;
                while(true){
                    if ((a[b >> 0] | 0) == g << 24 >> 24) {
                        i = 6;
                        break a;
                    }
                    b = b + 1 | 0;
                    e = e + -1 | 0;
                    f = (e | 0) != 0;
                    if (!(f & (b & 3 | 0) != 0)) {
                        i = 5;
                        break;
                    }
                }
            } else i = 5;
            while (0);
            if ((i | 0) == 5) {
                if (f) i = 6;
                else e = 0;
            }
            b: do if ((i | 0) == 6) {
                g = d & 255;
                if ((a[b >> 0] | 0) != g << 24 >> 24) {
                    f = P(h, 16843009) | 0;
                    c: do if (e >>> 0 > 3) while(true){
                        h = c[b >> 2] ^ f;
                        if ((h & -2139062144 ^ -2139062144) & h + -16843009 | 0) break;
                        b = b + 4 | 0;
                        e = e + -4 | 0;
                        if (e >>> 0 <= 3) {
                            i = 11;
                            break c;
                        }
                    }
                    else i = 11;
                    while (0);
                    if ((i | 0) == 11) {
                        if (!e) {
                            e = 0;
                            break;
                        }
                    }
                    while(true){
                        if ((a[b >> 0] | 0) == g << 24 >> 24) break b;
                        b = b + 1 | 0;
                        e = e + -1 | 0;
                        if (!e) {
                            e = 0;
                            break;
                        }
                    }
                }
            }
            while (0);
            return (e | 0 ? b : 0) | 0;
        }
        function OB(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = l;
            l = l + 256 | 0;
            f = g;
            if ((c | 0) > (d | 0) & (e & 73728 | 0) == 0) {
                e = c - d | 0;
                yC(f | 0, b | 0, (e >>> 0 < 256 ? e : 256) | 0);
                if (e >>> 0 > 255) {
                    b = c - d | 0;
                    do {
                        GB(a, f, 256);
                        e = e + -256 | 0;
                    }while (e >>> 0 > 255);
                    e = b & 255;
                }
                GB(a, f, e);
            }
            l = g;
            return;
        }
        function PB(a, b) {
            a = a | 0;
            b = b | 0;
            if (!a) a = 0;
            else a = UB(a, b, 0) | 0;
            return a | 0;
        }
        function QB(b, e, f, g, h, i) {
            b = b | 0;
            e = +e;
            f = f | 0;
            g = g | 0;
            h = h | 0;
            i = i | 0;
            var j = 0, k = 0, m = 0, n = 0, o = 0, p = 0, q = 0, r = 0.0, s = 0, t = 0, u = 0, v = 0, w = 0, x = 0, y = 0, z = 0, B = 0, C = 0, D = 0, E = 0, F = 0, G = 0, H = 0;
            H = l;
            l = l + 560 | 0;
            m = H + 8 | 0;
            u = H;
            G = H + 524 | 0;
            F = G;
            n = H + 512 | 0;
            c[u >> 2] = 0;
            E = n + 12 | 0;
            RB(e);
            if ((A | 0) < 0) {
                e = -e;
                C = 1;
                B = 5659;
            } else {
                C = (h & 2049 | 0) != 0 & 1;
                B = (h & 2048 | 0) == 0 ? (h & 1 | 0) == 0 ? 5660 : 5665 : 5662;
            }
            RB(e);
            D = A & 2146435072;
            do if (D >>> 0 < 2146435072 | (D | 0) == 2146435072 & false) {
                r = +SB(e, u) * 2.0;
                j = r != 0.0;
                if (j) c[u >> 2] = (c[u >> 2] | 0) + -1;
                w = i | 32;
                if ((w | 0) == 97) {
                    s = i & 32;
                    q = (s | 0) == 0 ? B : B + 9 | 0;
                    p = C | 2;
                    j = 12 - g | 0;
                    do if (!(g >>> 0 > 11 | (j | 0) == 0)) {
                        e = 8.0;
                        do {
                            j = j + -1 | 0;
                            e = e * 16.0;
                        }while ((j | 0) != 0);
                        if ((a[q >> 0] | 0) == 45) {
                            e = -(e + (-r - e));
                            break;
                        } else {
                            e = r + e - e;
                            break;
                        }
                    } else e = r;
                    while (0);
                    k = c[u >> 2] | 0;
                    j = (k | 0) < 0 ? 0 - k | 0 : k;
                    j = LB(j, ((j | 0) < 0) << 31 >> 31, E) | 0;
                    if ((j | 0) == (E | 0)) {
                        j = n + 11 | 0;
                        a[j >> 0] = 48;
                    }
                    a[j + -1 >> 0] = (k >> 31 & 2) + 43;
                    o = j + -2 | 0;
                    a[o >> 0] = i + 15;
                    n = (g | 0) < 1;
                    m = (h & 8 | 0) == 0;
                    j = G;
                    do {
                        D = ~~e;
                        k = j + 1 | 0;
                        a[j >> 0] = d[5694 + D >> 0] | s;
                        e = (e - +(D | 0)) * 16.0;
                        if ((k - F | 0) == 1 ? !(m & (n & e == 0.0)) : 0) {
                            a[k >> 0] = 46;
                            j = j + 2 | 0;
                        } else j = k;
                    }while (e != 0.0);
                    D = j - F | 0;
                    F = E - o | 0;
                    E = (g | 0) != 0 & (D + -2 | 0) < (g | 0) ? g + 2 | 0 : D;
                    j = F + p + E | 0;
                    OB(b, 32, f, j, h);
                    GB(b, q, p);
                    OB(b, 48, f, j, h ^ 65536);
                    GB(b, G, D);
                    OB(b, 48, E - D | 0, 0, 0);
                    GB(b, o, F);
                    OB(b, 32, f, j, h ^ 8192);
                    break;
                }
                k = (g | 0) < 0 ? 6 : g;
                if (j) {
                    j = (c[u >> 2] | 0) + -28 | 0;
                    c[u >> 2] = j;
                    e = r * 268435456.0;
                } else {
                    e = r;
                    j = c[u >> 2] | 0;
                }
                D = (j | 0) < 0 ? m : m + 288 | 0;
                m = D;
                do {
                    y = ~~e >>> 0;
                    c[m >> 2] = y;
                    m = m + 4 | 0;
                    e = (e - +(y >>> 0)) * 1.0e9;
                }while (e != 0.0);
                if ((j | 0) > 0) {
                    n = D;
                    p = m;
                    while(true){
                        o = (j | 0) < 29 ? j : 29;
                        j = p + -4 | 0;
                        if (j >>> 0 >= n >>> 0) {
                            m = 0;
                            do {
                                x = zC(c[j >> 2] | 0, 0, o | 0) | 0;
                                x = xC(x | 0, A | 0, m | 0, 0) | 0;
                                y = A;
                                v = HC(x | 0, y | 0, 1e9, 0) | 0;
                                c[j >> 2] = v;
                                m = EC(x | 0, y | 0, 1e9, 0) | 0;
                                j = j + -4 | 0;
                            }while (j >>> 0 >= n >>> 0);
                            if (m) {
                                n = n + -4 | 0;
                                c[n >> 2] = m;
                            }
                        }
                        m = p;
                        while(true){
                            if (m >>> 0 <= n >>> 0) break;
                            j = m + -4 | 0;
                            if (!(c[j >> 2] | 0)) m = j;
                            else break;
                        }
                        j = (c[u >> 2] | 0) - o | 0;
                        c[u >> 2] = j;
                        if ((j | 0) > 0) p = m;
                        else break;
                    }
                } else n = D;
                if ((j | 0) < 0) {
                    g = ((k + 25 | 0) / 9 | 0) + 1 | 0;
                    t = (w | 0) == 102;
                    do {
                        s = 0 - j | 0;
                        s = (s | 0) < 9 ? s : 9;
                        if (n >>> 0 < m >>> 0) {
                            o = (1 << s) + -1 | 0;
                            p = 1e9 >>> s;
                            q = 0;
                            j = n;
                            do {
                                y = c[j >> 2] | 0;
                                c[j >> 2] = (y >>> s) + q;
                                q = P(y & o, p) | 0;
                                j = j + 4 | 0;
                            }while (j >>> 0 < m >>> 0);
                            j = (c[n >> 2] | 0) == 0 ? n + 4 | 0 : n;
                            if (!q) {
                                n = j;
                                j = m;
                            } else {
                                c[m >> 2] = q;
                                n = j;
                                j = m + 4 | 0;
                            }
                        } else {
                            n = (c[n >> 2] | 0) == 0 ? n + 4 | 0 : n;
                            j = m;
                        }
                        m = t ? D : n;
                        m = (j - m >> 2 | 0) > (g | 0) ? m + (g << 2) | 0 : j;
                        j = (c[u >> 2] | 0) + s | 0;
                        c[u >> 2] = j;
                    }while ((j | 0) < 0);
                    j = n;
                    g = m;
                } else {
                    j = n;
                    g = m;
                }
                y = D;
                if (j >>> 0 < g >>> 0) {
                    m = (y - j >> 2) * 9 | 0;
                    o = c[j >> 2] | 0;
                    if (o >>> 0 >= 10) {
                        n = 10;
                        do {
                            n = n * 10 | 0;
                            m = m + 1 | 0;
                        }while (o >>> 0 >= n >>> 0);
                    }
                } else m = 0;
                t = (w | 0) == 103;
                v = (k | 0) != 0;
                n = k - ((w | 0) != 102 ? m : 0) + ((v & t) << 31 >> 31) | 0;
                if ((n | 0) < (((g - y >> 2) * 9 | 0) + -9 | 0)) {
                    n = n + 9216 | 0;
                    s = D + 4 + (((n | 0) / 9 | 0) + -1024 << 2) | 0;
                    n = ((n | 0) % 9 | 0) + 1 | 0;
                    if ((n | 0) < 9) {
                        o = 10;
                        do {
                            o = o * 10 | 0;
                            n = n + 1 | 0;
                        }while ((n | 0) != 9);
                    } else o = 10;
                    p = c[s >> 2] | 0;
                    q = (p >>> 0) % (o >>> 0) | 0;
                    n = (s + 4 | 0) == (g | 0);
                    if (!(n & (q | 0) == 0)) {
                        r = (((p >>> 0) / (o >>> 0) | 0) & 1 | 0) == 0 ? 9007199254740992.0 : 9007199254740994.0;
                        x = (o | 0) / 2 | 0;
                        e = q >>> 0 < x >>> 0 ? .5 : n & (q | 0) == (x | 0) ? 1.0 : 1.5;
                        if (C) {
                            x = (a[B >> 0] | 0) == 45;
                            e = x ? -e : e;
                            r = x ? -r : r;
                        }
                        n = p - q | 0;
                        c[s >> 2] = n;
                        if (r + e != r) {
                            x = n + o | 0;
                            c[s >> 2] = x;
                            if (x >>> 0 > 999999999) {
                                m = s;
                                while(true){
                                    n = m + -4 | 0;
                                    c[m >> 2] = 0;
                                    if (n >>> 0 < j >>> 0) {
                                        j = j + -4 | 0;
                                        c[j >> 2] = 0;
                                    }
                                    x = (c[n >> 2] | 0) + 1 | 0;
                                    c[n >> 2] = x;
                                    if (x >>> 0 > 999999999) m = n;
                                    else break;
                                }
                            } else n = s;
                            m = (y - j >> 2) * 9 | 0;
                            p = c[j >> 2] | 0;
                            if (p >>> 0 >= 10) {
                                o = 10;
                                do {
                                    o = o * 10 | 0;
                                    m = m + 1 | 0;
                                }while (p >>> 0 >= o >>> 0);
                            }
                        } else n = s;
                    } else n = s;
                    n = n + 4 | 0;
                    n = g >>> 0 > n >>> 0 ? n : g;
                    x = j;
                } else {
                    n = g;
                    x = j;
                }
                w = n;
                while(true){
                    if (w >>> 0 <= x >>> 0) {
                        u = 0;
                        break;
                    }
                    j = w + -4 | 0;
                    if (!(c[j >> 2] | 0)) w = j;
                    else {
                        u = 1;
                        break;
                    }
                }
                g = 0 - m | 0;
                do if (t) {
                    j = ((v ^ 1) & 1) + k | 0;
                    if ((j | 0) > (m | 0) & (m | 0) > -5) {
                        o = i + -1 | 0;
                        k = j + -1 - m | 0;
                    } else {
                        o = i + -2 | 0;
                        k = j + -1 | 0;
                    }
                    j = h & 8;
                    if (!j) {
                        if (u ? (z = c[w + -4 >> 2] | 0, (z | 0) != 0) : 0) {
                            if (!((z >>> 0) % 10 | 0)) {
                                n = 0;
                                j = 10;
                                do {
                                    j = j * 10 | 0;
                                    n = n + 1 | 0;
                                }while (!((z >>> 0) % (j >>> 0) | 0));
                            } else n = 0;
                        } else n = 9;
                        j = ((w - y >> 2) * 9 | 0) + -9 | 0;
                        if ((o | 32) == 102) {
                            s = j - n | 0;
                            s = (s | 0) > 0 ? s : 0;
                            k = (k | 0) < (s | 0) ? k : s;
                            s = 0;
                            break;
                        } else {
                            s = j + m - n | 0;
                            s = (s | 0) > 0 ? s : 0;
                            k = (k | 0) < (s | 0) ? k : s;
                            s = 0;
                            break;
                        }
                    } else s = j;
                } else {
                    o = i;
                    s = h & 8;
                }
                while (0);
                t = k | s;
                p = (t | 0) != 0 & 1;
                q = (o | 32) == 102;
                if (q) {
                    v = 0;
                    j = (m | 0) > 0 ? m : 0;
                } else {
                    j = (m | 0) < 0 ? g : m;
                    j = LB(j, ((j | 0) < 0) << 31 >> 31, E) | 0;
                    n = E;
                    if ((n - j | 0) < 2) do {
                        j = j + -1 | 0;
                        a[j >> 0] = 48;
                    }while ((n - j | 0) < 2);
                    a[j + -1 >> 0] = (m >> 31 & 2) + 43;
                    j = j + -2 | 0;
                    a[j >> 0] = o;
                    v = j;
                    j = n - j | 0;
                }
                j = C + 1 + k + p + j | 0;
                OB(b, 32, f, j, h);
                GB(b, B, C);
                OB(b, 48, f, j, h ^ 65536);
                if (q) {
                    o = x >>> 0 > D >>> 0 ? D : x;
                    s = G + 9 | 0;
                    p = s;
                    q = G + 8 | 0;
                    n = o;
                    do {
                        m = LB(c[n >> 2] | 0, 0, s) | 0;
                        if ((n | 0) == (o | 0)) {
                            if ((m | 0) == (s | 0)) {
                                a[q >> 0] = 48;
                                m = q;
                            }
                        } else if (m >>> 0 > G >>> 0) {
                            yC(G | 0, 48, m - F | 0);
                            do m = m + -1 | 0;
                            while (m >>> 0 > G >>> 0);
                        }
                        GB(b, m, p - m | 0);
                        n = n + 4 | 0;
                    }while (n >>> 0 <= D >>> 0);
                    if (t | 0) GB(b, 5710, 1);
                    if (n >>> 0 < w >>> 0 & (k | 0) > 0) while(true){
                        m = LB(c[n >> 2] | 0, 0, s) | 0;
                        if (m >>> 0 > G >>> 0) {
                            yC(G | 0, 48, m - F | 0);
                            do m = m + -1 | 0;
                            while (m >>> 0 > G >>> 0);
                        }
                        GB(b, m, (k | 0) < 9 ? k : 9);
                        n = n + 4 | 0;
                        m = k + -9 | 0;
                        if (!(n >>> 0 < w >>> 0 & (k | 0) > 9)) {
                            k = m;
                            break;
                        } else k = m;
                    }
                    OB(b, 48, k + 9 | 0, 9, 0);
                } else {
                    t = u ? w : x + 4 | 0;
                    if ((k | 0) > -1) {
                        u = G + 9 | 0;
                        s = (s | 0) == 0;
                        g = u;
                        p = 0 - F | 0;
                        q = G + 8 | 0;
                        o = x;
                        do {
                            m = LB(c[o >> 2] | 0, 0, u) | 0;
                            if ((m | 0) == (u | 0)) {
                                a[q >> 0] = 48;
                                m = q;
                            }
                            do if ((o | 0) == (x | 0)) {
                                n = m + 1 | 0;
                                GB(b, m, 1);
                                if (s & (k | 0) < 1) {
                                    m = n;
                                    break;
                                }
                                GB(b, 5710, 1);
                                m = n;
                            } else {
                                if (m >>> 0 <= G >>> 0) break;
                                yC(G | 0, 48, m + p | 0);
                                do m = m + -1 | 0;
                                while (m >>> 0 > G >>> 0);
                            }
                            while (0);
                            F = g - m | 0;
                            GB(b, m, (k | 0) > (F | 0) ? F : k);
                            k = k - F | 0;
                            o = o + 4 | 0;
                        }while (o >>> 0 < t >>> 0 & (k | 0) > -1);
                    }
                    OB(b, 48, k + 18 | 0, 18, 0);
                    GB(b, v, E - v | 0);
                }
                OB(b, 32, f, j, h ^ 8192);
            } else {
                G = (i & 32 | 0) != 0;
                j = C + 3 | 0;
                OB(b, 32, f, j, h & -65537);
                GB(b, B, C);
                GB(b, e != e | false ? G ? 5686 : 5690 : G ? 5678 : 5682, 3);
                OB(b, 32, f, j, h ^ 8192);
            }
            while (0);
            l = H;
            return ((j | 0) < (f | 0) ? f : j) | 0;
        }
        function RB(a) {
            a = +a;
            var b = 0;
            h[j >> 3] = a;
            b = c[j >> 2] | 0;
            A = c[j + 4 >> 2] | 0;
            return b | 0;
        }
        function SB(a, b) {
            a = +a;
            b = b | 0;
            return + +TB(a, b);
        }
        function TB(a, b) {
            a = +a;
            b = b | 0;
            var d = 0, e = 0, f = 0;
            h[j >> 3] = a;
            d = c[j >> 2] | 0;
            e = c[j + 4 >> 2] | 0;
            f = AC(d | 0, e | 0, 52) | 0;
            switch(f & 2047){
                case 0:
                    if (a != 0.0) {
                        a = +TB(a * 18446744073709551616.0, b);
                        d = (c[b >> 2] | 0) + -64 | 0;
                    } else d = 0;
                    c[b >> 2] = d;
                    break;
                case 2047:
                    break;
                default:
                    c[b >> 2] = (f & 2047) + -1022;
                    c[j >> 2] = d;
                    c[j + 4 >> 2] = e & -2146435073 | 1071644672;
                    a = +h[j >> 3];
            }
            return +a;
        }
        function UB(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            do if (b) {
                if (d >>> 0 < 128) {
                    a[b >> 0] = d;
                    b = 1;
                    break;
                }
                if (!(c[c[(VB() | 0) + 188 >> 2] >> 2] | 0)) {
                    if ((d & -128 | 0) == 57216) {
                        a[b >> 0] = d;
                        b = 1;
                        break;
                    } else {
                        c[(vB() | 0) >> 2] = 84;
                        b = -1;
                        break;
                    }
                }
                if (d >>> 0 < 2048) {
                    a[b >> 0] = d >>> 6 | 192;
                    a[b + 1 >> 0] = d & 63 | 128;
                    b = 2;
                    break;
                }
                if (d >>> 0 < 55296 | (d & -8192 | 0) == 57344) {
                    a[b >> 0] = d >>> 12 | 224;
                    a[b + 1 >> 0] = d >>> 6 & 63 | 128;
                    a[b + 2 >> 0] = d & 63 | 128;
                    b = 3;
                    break;
                }
                if ((d + -65536 | 0) >>> 0 < 1048576) {
                    a[b >> 0] = d >>> 18 | 240;
                    a[b + 1 >> 0] = d >>> 12 & 63 | 128;
                    a[b + 2 >> 0] = d >>> 6 & 63 | 128;
                    a[b + 3 >> 0] = d & 63 | 128;
                    b = 4;
                    break;
                } else {
                    c[(vB() | 0) >> 2] = 84;
                    b = -1;
                    break;
                }
            } else b = 1;
            while (0);
            return b | 0;
        }
        function VB() {
            return xB() | 0;
        }
        function WB() {
            return xB() | 0;
        }
        function XB(b, e) {
            b = b | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = 0;
            while(true){
                if ((d[5712 + g >> 0] | 0) == (b | 0)) {
                    b = 2;
                    break;
                }
                f = g + 1 | 0;
                if ((f | 0) == 87) {
                    f = 5800;
                    g = 87;
                    b = 5;
                    break;
                } else g = f;
            }
            if ((b | 0) == 2) {
                if (!g) f = 5800;
                else {
                    f = 5800;
                    b = 5;
                }
            }
            if ((b | 0) == 5) while(true){
                do {
                    b = f;
                    f = f + 1 | 0;
                }while ((a[b >> 0] | 0) != 0);
                g = g + -1 | 0;
                if (!g) break;
                else b = 5;
            }
            return YB(f, c[e + 20 >> 2] | 0) | 0;
        }
        function YB(a, b) {
            a = a | 0;
            b = b | 0;
            return ZB(a, b) | 0;
        }
        function ZB(a, b) {
            a = a | 0;
            b = b | 0;
            if (!b) b = 0;
            else b = _B(c[b >> 2] | 0, c[b + 4 >> 2] | 0, a) | 0;
            return (b | 0 ? b : a) | 0;
        }
        function _B(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0;
            o = (c[b >> 2] | 0) + 1794895138 | 0;
            h = $B(c[b + 8 >> 2] | 0, o) | 0;
            f = $B(c[b + 12 >> 2] | 0, o) | 0;
            g = $B(c[b + 16 >> 2] | 0, o) | 0;
            a: do if ((h >>> 0 < d >>> 2 >>> 0 ? (n = d - (h << 2) | 0, f >>> 0 < n >>> 0 & g >>> 0 < n >>> 0) : 0) ? ((g | f) & 3 | 0) == 0 : 0) {
                n = f >>> 2;
                m = g >>> 2;
                l = 0;
                while(true){
                    j = h >>> 1;
                    k = l + j | 0;
                    i = k << 1;
                    g = i + n | 0;
                    f = $B(c[b + (g << 2) >> 2] | 0, o) | 0;
                    g = $B(c[b + (g + 1 << 2) >> 2] | 0, o) | 0;
                    if (!(g >>> 0 < d >>> 0 & f >>> 0 < (d - g | 0) >>> 0)) {
                        f = 0;
                        break a;
                    }
                    if (a[b + (g + f) >> 0] | 0) {
                        f = 0;
                        break a;
                    }
                    f = AB(e, b + g | 0) | 0;
                    if (!f) break;
                    f = (f | 0) < 0;
                    if ((h | 0) == 1) {
                        f = 0;
                        break a;
                    } else {
                        l = f ? l : k;
                        h = f ? j : h - j | 0;
                    }
                }
                f = i + m | 0;
                g = $B(c[b + (f << 2) >> 2] | 0, o) | 0;
                f = $B(c[b + (f + 1 << 2) >> 2] | 0, o) | 0;
                if (f >>> 0 < d >>> 0 & g >>> 0 < (d - f | 0) >>> 0) f = (a[b + (f + g) >> 0] | 0) == 0 ? b + f | 0 : 0;
                else f = 0;
            } else f = 0;
            while (0);
            return f | 0;
        }
        function $B(a, b) {
            a = a | 0;
            b = b | 0;
            var c = 0;
            c = IC(a | 0) | 0;
            return ((b | 0) == 0 ? a : c) | 0;
        }
        function aC(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0, j = 0;
            f = e + 16 | 0;
            g = c[f >> 2] | 0;
            if (!g) {
                if (!(bC(e) | 0)) {
                    g = c[f >> 2] | 0;
                    h = 5;
                } else f = 0;
            } else h = 5;
            a: do if ((h | 0) == 5) {
                j = e + 20 | 0;
                i = c[j >> 2] | 0;
                f = i;
                if ((g - i | 0) >>> 0 < d >>> 0) {
                    f = sb[c[e + 36 >> 2] & 7](e, b, d) | 0;
                    break;
                }
                b: do if ((a[e + 75 >> 0] | 0) > -1) {
                    i = d;
                    while(true){
                        if (!i) {
                            h = 0;
                            g = b;
                            break b;
                        }
                        g = i + -1 | 0;
                        if ((a[b + g >> 0] | 0) == 10) break;
                        else i = g;
                    }
                    f = sb[c[e + 36 >> 2] & 7](e, b, i) | 0;
                    if (f >>> 0 < i >>> 0) break a;
                    h = i;
                    g = b + i | 0;
                    d = d - i | 0;
                    f = c[j >> 2] | 0;
                } else {
                    h = 0;
                    g = b;
                }
                while (0);
                BC(f | 0, g | 0, d | 0);
                c[j >> 2] = (c[j >> 2] | 0) + d;
                f = h + d | 0;
            }
            while (0);
            return f | 0;
        }
        function bC(b) {
            b = b | 0;
            var d = 0, e = 0;
            d = b + 74 | 0;
            e = a[d >> 0] | 0;
            a[d >> 0] = e + 255 | e;
            d = c[b >> 2] | 0;
            if (!(d & 8)) {
                c[b + 8 >> 2] = 0;
                c[b + 4 >> 2] = 0;
                e = c[b + 44 >> 2] | 0;
                c[b + 28 >> 2] = e;
                c[b + 20 >> 2] = e;
                c[b + 16 >> 2] = e + (c[b + 48 >> 2] | 0);
                b = 0;
            } else {
                c[b >> 2] = d | 32;
                b = -1;
            }
            return b | 0;
        }
        function cC(a, b) {
            a = T(a);
            b = T(b);
            var c = 0, d = 0;
            c = dC(a) | 0;
            do if ((c & 2147483647) >>> 0 <= 2139095040) {
                d = dC(b) | 0;
                if ((d & 2147483647) >>> 0 <= 2139095040) {
                    if ((d ^ c | 0) < 0) {
                        a = (c | 0) < 0 ? b : a;
                        break;
                    } else {
                        a = a < b ? b : a;
                        break;
                    }
                }
            } else a = b;
            while (0);
            return T(a);
        }
        function dC(a) {
            a = T(a);
            return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
        }
        function eC(a, b) {
            a = T(a);
            b = T(b);
            var c = 0, d = 0;
            c = fC(a) | 0;
            do if ((c & 2147483647) >>> 0 <= 2139095040) {
                d = fC(b) | 0;
                if ((d & 2147483647) >>> 0 <= 2139095040) {
                    if ((d ^ c | 0) < 0) {
                        a = (c | 0) < 0 ? a : b;
                        break;
                    } else {
                        a = a < b ? a : b;
                        break;
                    }
                }
            } else a = b;
            while (0);
            return T(a);
        }
        function fC(a) {
            a = T(a);
            return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
        }
        function gC(a, b) {
            a = T(a);
            b = T(b);
            var d = 0, e = 0, f = 0, h = 0, i = 0, k = 0, l = 0, m = 0;
            h = (g[j >> 2] = a, c[j >> 2] | 0);
            k = (g[j >> 2] = b, c[j >> 2] | 0);
            d = h >>> 23 & 255;
            i = k >>> 23 & 255;
            l = h & -2147483648;
            f = k << 1;
            a: do if ((f | 0) != 0 ? !((d | 0) == 255 | ((hC(b) | 0) & 2147483647) >>> 0 > 2139095040) : 0) {
                e = h << 1;
                if (e >>> 0 <= f >>> 0) {
                    b = T(a * T(0.0));
                    return T((e | 0) == (f | 0) ? b : a);
                }
                if (!d) {
                    d = h << 9;
                    if ((d | 0) > -1) {
                        e = d;
                        d = 0;
                        do {
                            d = d + -1 | 0;
                            e = e << 1;
                        }while ((e | 0) > -1);
                    } else d = 0;
                    e = h << 1 - d;
                } else e = h & 8388607 | 8388608;
                if (!i) {
                    h = k << 9;
                    if ((h | 0) > -1) {
                        f = 0;
                        do {
                            f = f + -1 | 0;
                            h = h << 1;
                        }while ((h | 0) > -1);
                    } else f = 0;
                    i = f;
                    k = k << 1 - f;
                } else k = k & 8388607 | 8388608;
                f = e - k | 0;
                h = (f | 0) > -1;
                b: do if ((d | 0) > (i | 0)) {
                    while(true){
                        if (h) {
                            if (!f) break;
                            else e = f;
                        }
                        e = e << 1;
                        d = d + -1 | 0;
                        f = e - k | 0;
                        h = (f | 0) > -1;
                        if ((d | 0) <= (i | 0)) break b;
                    }
                    b = T(a * T(0.0));
                    break a;
                }
                while (0);
                if (h) {
                    if (!f) {
                        b = T(a * T(0.0));
                        break;
                    } else e = f;
                }
                if (e >>> 0 < 8388608) do {
                    e = e << 1;
                    d = d + -1 | 0;
                }while (e >>> 0 < 8388608);
                if ((d | 0) > 0) d = e + -8388608 | d << 23;
                else d = e >>> (1 - d | 0);
                b = (c[j >> 2] = d | l, T(g[j >> 2]));
            } else m = 3;
            while (0);
            if ((m | 0) == 3) {
                b = T(a * b);
                b = T(b / b);
            }
            return T(b);
        }
        function hC(a) {
            a = T(a);
            return (g[j >> 2] = a, c[j >> 2] | 0) | 0;
        }
        function iC(a, b) {
            a = a | 0;
            b = b | 0;
            return CB(c[582] | 0, a, b) | 0;
        }
        function jC(a) {
            a = a | 0;
            Ta();
        }
        function kC(a) {
            a = a | 0;
            return;
        }
        function lC(a, b) {
            a = a | 0;
            b = b | 0;
            return 0;
        }
        function mC(a) {
            a = a | 0;
            if ((nC(a + 4 | 0) | 0) == -1) {
                nb[c[(c[a >> 2] | 0) + 8 >> 2] & 127](a);
                a = 1;
            } else a = 0;
            return a | 0;
        }
        function nC(a) {
            a = a | 0;
            var b = 0;
            b = c[a >> 2] | 0;
            c[a >> 2] = b + -1;
            return b + -1 | 0;
        }
        function oC(a) {
            a = a | 0;
            if (mC(a) | 0) pC(a);
            return;
        }
        function pC(a) {
            a = a | 0;
            var b = 0;
            b = a + 8 | 0;
            if (!((c[b >> 2] | 0) != 0 ? (nC(b) | 0) != -1 : 0)) nb[c[(c[a >> 2] | 0) + 16 >> 2] & 127](a);
            return;
        }
        function qC(a) {
            a = a | 0;
            var b = 0;
            b = (a | 0) == 0 ? 1 : a;
            while(true){
                a = oB(b) | 0;
                if (a | 0) break;
                a = uC() | 0;
                if (!a) {
                    a = 0;
                    break;
                }
                Fb[a & 0]();
            }
            return a | 0;
        }
        function rC(a) {
            a = a | 0;
            return qC(a) | 0;
        }
        function sC(a) {
            a = a | 0;
            pB(a);
            return;
        }
        function tC(b) {
            b = b | 0;
            if ((a[b + 11 >> 0] | 0) < 0) sC(c[b >> 2] | 0);
            return;
        }
        function uC() {
            var a = 0;
            a = c[2923] | 0;
            c[2923] = a + 0;
            return a | 0;
        }
        function vC() {}
        function wC(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            d = b - d - (c >>> 0 > a >>> 0 | 0) >>> 0;
            return (A = d, a - c >>> 0 | 0) | 0;
        }
        function xC(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            c = a + c >>> 0;
            return (A = b + d + (c >>> 0 < a >>> 0 | 0) >>> 0, c | 0) | 0;
        }
        function yC(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0, i = 0;
            h = b + e | 0;
            d = d & 255;
            if ((e | 0) >= 67) {
                while(b & 3){
                    a[b >> 0] = d;
                    b = b + 1 | 0;
                }
                f = h & -4 | 0;
                g = f - 64 | 0;
                i = d | d << 8 | d << 16 | d << 24;
                while((b | 0) <= (g | 0)){
                    c[b >> 2] = i;
                    c[b + 4 >> 2] = i;
                    c[b + 8 >> 2] = i;
                    c[b + 12 >> 2] = i;
                    c[b + 16 >> 2] = i;
                    c[b + 20 >> 2] = i;
                    c[b + 24 >> 2] = i;
                    c[b + 28 >> 2] = i;
                    c[b + 32 >> 2] = i;
                    c[b + 36 >> 2] = i;
                    c[b + 40 >> 2] = i;
                    c[b + 44 >> 2] = i;
                    c[b + 48 >> 2] = i;
                    c[b + 52 >> 2] = i;
                    c[b + 56 >> 2] = i;
                    c[b + 60 >> 2] = i;
                    b = b + 64 | 0;
                }
                while((b | 0) < (f | 0)){
                    c[b >> 2] = i;
                    b = b + 4 | 0;
                }
            }
            while((b | 0) < (h | 0)){
                a[b >> 0] = d;
                b = b + 1 | 0;
            }
            return h - e | 0;
        }
        function zC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                A = b << c | (a & (1 << c) - 1 << 32 - c) >>> 32 - c;
                return a << c;
            }
            A = a << c - 32;
            return 0;
        }
        function AC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            if ((c | 0) < 32) {
                A = b >>> c;
                return a >>> c | (b & (1 << c) - 1) << 32 - c;
            }
            A = 0;
            return b >>> c - 32 | 0;
        }
        function BC(b, d, e) {
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0, h = 0;
            if ((e | 0) >= 8192) return Oa(b | 0, d | 0, e | 0) | 0;
            h = b | 0;
            g = b + e | 0;
            if ((b & 3) == (d & 3)) {
                while(b & 3){
                    if (!e) return h | 0;
                    a[b >> 0] = a[d >> 0] | 0;
                    b = b + 1 | 0;
                    d = d + 1 | 0;
                    e = e - 1 | 0;
                }
                e = g & -4 | 0;
                f = e - 64 | 0;
                while((b | 0) <= (f | 0)){
                    c[b >> 2] = c[d >> 2];
                    c[b + 4 >> 2] = c[d + 4 >> 2];
                    c[b + 8 >> 2] = c[d + 8 >> 2];
                    c[b + 12 >> 2] = c[d + 12 >> 2];
                    c[b + 16 >> 2] = c[d + 16 >> 2];
                    c[b + 20 >> 2] = c[d + 20 >> 2];
                    c[b + 24 >> 2] = c[d + 24 >> 2];
                    c[b + 28 >> 2] = c[d + 28 >> 2];
                    c[b + 32 >> 2] = c[d + 32 >> 2];
                    c[b + 36 >> 2] = c[d + 36 >> 2];
                    c[b + 40 >> 2] = c[d + 40 >> 2];
                    c[b + 44 >> 2] = c[d + 44 >> 2];
                    c[b + 48 >> 2] = c[d + 48 >> 2];
                    c[b + 52 >> 2] = c[d + 52 >> 2];
                    c[b + 56 >> 2] = c[d + 56 >> 2];
                    c[b + 60 >> 2] = c[d + 60 >> 2];
                    b = b + 64 | 0;
                    d = d + 64 | 0;
                }
                while((b | 0) < (e | 0)){
                    c[b >> 2] = c[d >> 2];
                    b = b + 4 | 0;
                    d = d + 4 | 0;
                }
            } else {
                e = g - 4 | 0;
                while((b | 0) < (e | 0)){
                    a[b >> 0] = a[d >> 0] | 0;
                    a[b + 1 >> 0] = a[d + 1 >> 0] | 0;
                    a[b + 2 >> 0] = a[d + 2 >> 0] | 0;
                    a[b + 3 >> 0] = a[d + 3 >> 0] | 0;
                    b = b + 4 | 0;
                    d = d + 4 | 0;
                }
            }
            while((b | 0) < (g | 0)){
                a[b >> 0] = a[d >> 0] | 0;
                b = b + 1 | 0;
                d = d + 1 | 0;
            }
            return h | 0;
        }
        function CC(b) {
            b = b | 0;
            var c = 0;
            c = a[n + (b & 255) >> 0] | 0;
            if ((c | 0) < 8) return c | 0;
            c = a[n + (b >> 8 & 255) >> 0] | 0;
            if ((c | 0) < 8) return c + 8 | 0;
            c = a[n + (b >> 16 & 255) >> 0] | 0;
            if ((c | 0) < 8) return c + 16 | 0;
            return (a[n + (b >>> 24) >> 0] | 0) + 24 | 0;
        }
        function DC(a, b, d, e, f) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            var g = 0, h = 0, i = 0, j = 0, k = 0, l = 0, m = 0, n = 0, o = 0, p = 0;
            l = a;
            j = b;
            k = j;
            h = d;
            n = e;
            i = n;
            if (!k) {
                g = (f | 0) != 0;
                if (!i) {
                    if (g) {
                        c[f >> 2] = (l >>> 0) % (h >>> 0);
                        c[f + 4 >> 2] = 0;
                    }
                    n = 0;
                    f = (l >>> 0) / (h >>> 0) >>> 0;
                    return (A = n, f) | 0;
                } else {
                    if (!g) {
                        n = 0;
                        f = 0;
                        return (A = n, f) | 0;
                    }
                    c[f >> 2] = a | 0;
                    c[f + 4 >> 2] = b & 0;
                    n = 0;
                    f = 0;
                    return (A = n, f) | 0;
                }
            }
            g = (i | 0) == 0;
            do if (h) {
                if (!g) {
                    g = (S(i | 0) | 0) - (S(k | 0) | 0) | 0;
                    if (g >>> 0 <= 31) {
                        m = g + 1 | 0;
                        i = 31 - g | 0;
                        b = g - 31 >> 31;
                        h = m;
                        a = l >>> (m >>> 0) & b | k << i;
                        b = k >>> (m >>> 0) & b;
                        g = 0;
                        i = l << i;
                        break;
                    }
                    if (!f) {
                        n = 0;
                        f = 0;
                        return (A = n, f) | 0;
                    }
                    c[f >> 2] = a | 0;
                    c[f + 4 >> 2] = j | b & 0;
                    n = 0;
                    f = 0;
                    return (A = n, f) | 0;
                }
                g = h - 1 | 0;
                if (g & h | 0) {
                    i = (S(h | 0) | 0) + 33 - (S(k | 0) | 0) | 0;
                    p = 64 - i | 0;
                    m = 32 - i | 0;
                    j = m >> 31;
                    o = i - 32 | 0;
                    b = o >> 31;
                    h = i;
                    a = m - 1 >> 31 & k >>> (o >>> 0) | (k << m | l >>> (i >>> 0)) & b;
                    b = b & k >>> (i >>> 0);
                    g = l << p & j;
                    i = (k << p | l >>> (o >>> 0)) & j | l << m & i - 33 >> 31;
                    break;
                }
                if (f | 0) {
                    c[f >> 2] = g & l;
                    c[f + 4 >> 2] = 0;
                }
                if ((h | 0) == 1) {
                    o = j | b & 0;
                    p = a | 0;
                    return (A = o, p) | 0;
                } else {
                    p = CC(h | 0) | 0;
                    o = k >>> (p >>> 0) | 0;
                    p = k << 32 - p | l >>> (p >>> 0) | 0;
                    return (A = o, p) | 0;
                }
            } else {
                if (g) {
                    if (f | 0) {
                        c[f >> 2] = (k >>> 0) % (h >>> 0);
                        c[f + 4 >> 2] = 0;
                    }
                    o = 0;
                    p = (k >>> 0) / (h >>> 0) >>> 0;
                    return (A = o, p) | 0;
                }
                if (!l) {
                    if (f | 0) {
                        c[f >> 2] = 0;
                        c[f + 4 >> 2] = (k >>> 0) % (i >>> 0);
                    }
                    o = 0;
                    p = (k >>> 0) / (i >>> 0) >>> 0;
                    return (A = o, p) | 0;
                }
                g = i - 1 | 0;
                if (!(g & i)) {
                    if (f | 0) {
                        c[f >> 2] = a | 0;
                        c[f + 4 >> 2] = g & k | b & 0;
                    }
                    o = 0;
                    p = k >>> ((CC(i | 0) | 0) >>> 0);
                    return (A = o, p) | 0;
                }
                g = (S(i | 0) | 0) - (S(k | 0) | 0) | 0;
                if (g >>> 0 <= 30) {
                    b = g + 1 | 0;
                    i = 31 - g | 0;
                    h = b;
                    a = k << i | l >>> (b >>> 0);
                    b = k >>> (b >>> 0);
                    g = 0;
                    i = l << i;
                    break;
                }
                if (!f) {
                    o = 0;
                    p = 0;
                    return (A = o, p) | 0;
                }
                c[f >> 2] = a | 0;
                c[f + 4 >> 2] = j | b & 0;
                o = 0;
                p = 0;
                return (A = o, p) | 0;
            }
            while (0);
            if (!h) {
                k = i;
                j = 0;
                i = 0;
            } else {
                m = d | 0;
                l = n | e & 0;
                k = xC(m | 0, l | 0, -1, -1) | 0;
                d = A;
                j = i;
                i = 0;
                do {
                    e = j;
                    j = g >>> 31 | j << 1;
                    g = i | g << 1;
                    e = a << 1 | e >>> 31 | 0;
                    n = a >>> 31 | b << 1 | 0;
                    wC(k | 0, d | 0, e | 0, n | 0);
                    p = A;
                    o = p >> 31 | ((p | 0) < 0 ? -1 : 0) << 1;
                    i = o & 1;
                    a = wC(e | 0, n | 0, o & m | 0, (((p | 0) < 0 ? -1 : 0) >> 31 | ((p | 0) < 0 ? -1 : 0) << 1) & l | 0) | 0;
                    b = A;
                    h = h - 1 | 0;
                }while ((h | 0) != 0);
                k = j;
                j = 0;
            }
            h = 0;
            if (f | 0) {
                c[f >> 2] = a;
                c[f + 4 >> 2] = b;
            }
            o = (g | 0) >>> 31 | (k | h) << 1 | (h << 1 | g >>> 31) & 0 | j;
            p = (g << 1 | 0) & -2 | i;
            return (A = o, p) | 0;
        }
        function EC(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            return DC(a, b, c, d, 0) | 0;
        }
        function FC(a) {
            a = a | 0;
            var b = 0, d = 0;
            d = a + 15 & -16 | 0;
            b = c[i >> 2] | 0;
            a = b + d | 0;
            if ((d | 0) > 0 & (a | 0) < (b | 0) | (a | 0) < 0) {
                Y();
                Qa(12);
                return -1;
            }
            c[i >> 2] = a;
            if ((a | 0) > (X() | 0) ? (W() | 0) == 0 : 0) {
                c[i >> 2] = b;
                Qa(12);
                return -1;
            }
            return b | 0;
        }
        function GC(b, c, d) {
            b = b | 0;
            c = c | 0;
            d = d | 0;
            var e = 0;
            if ((c | 0) < (b | 0) & (b | 0) < (c + d | 0)) {
                e = b;
                c = c + d | 0;
                b = b + d | 0;
                while((d | 0) > 0){
                    b = b - 1 | 0;
                    c = c - 1 | 0;
                    d = d - 1 | 0;
                    a[b >> 0] = a[c >> 0] | 0;
                }
                b = e;
            } else BC(b, c, d);
            return b | 0;
        }
        function HC(a, b, d, e) {
            a = a | 0;
            b = b | 0;
            d = d | 0;
            e = e | 0;
            var f = 0, g = 0;
            g = l;
            l = l + 16 | 0;
            f = g | 0;
            DC(a, b, d, e, f);
            l = g;
            return (A = c[f + 4 >> 2] | 0, c[f >> 2] | 0) | 0;
        }
        function IC(a) {
            a = a | 0;
            return (a & 255) << 24 | (a >> 8 & 255) << 16 | (a >> 16 & 255) << 8 | a >>> 24 | 0;
        }
        function JC(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            jb[a & 1](b | 0, c | 0, d | 0, e | 0, f | 0);
        }
        function KC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            kb[a & 1](b | 0, T(c));
        }
        function LC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = +c;
            lb[a & 31](b | 0, +c);
        }
        function MC(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            d = T(d);
            return T(mb[a & 0](b | 0, T(c), T(d)));
        }
        function NC(a, b) {
            a = a | 0;
            b = b | 0;
            nb[a & 127](b | 0);
        }
        function OC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            ob[a & 31](b | 0, c | 0);
        }
        function PC(a, b) {
            a = a | 0;
            b = b | 0;
            return pb[a & 31](b | 0) | 0;
        }
        function QC(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = +c;
            d = +d;
            e = e | 0;
            qb[a & 1](b | 0, +c, +d, e | 0);
        }
        function RC(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = +c;
            d = +d;
            rb[a & 1](b | 0, +c, +d);
        }
        function SC(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            return sb[a & 7](b | 0, c | 0, d | 0) | 0;
        }
        function TC(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            return +tb[a & 1](b | 0, c | 0, d | 0);
        }
        function UC(a, b) {
            a = a | 0;
            b = b | 0;
            return +ub[a & 15](b | 0);
        }
        function VC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = +c;
            return vb[a & 1](b | 0, +c) | 0;
        }
        function WC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return wb[a & 15](b | 0, c | 0) | 0;
        }
        function XC(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = +d;
            e = +e;
            f = f | 0;
            xb[a & 1](b | 0, c | 0, +d, +e, f | 0);
        }
        function YC(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            g = g | 0;
            yb[a & 1](b | 0, c | 0, d | 0, e | 0, f | 0, g | 0);
        }
        function ZC(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            return +zb[a & 7](b | 0, c | 0);
        }
        function _C(a) {
            a = a | 0;
            return Ab[a & 7]() | 0;
        }
        function $C(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            return Bb[a & 1](b | 0, c | 0, d | 0, e | 0, f | 0) | 0;
        }
        function aD(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = +e;
            Cb[a & 1](b | 0, c | 0, d | 0, +e);
        }
        function bD(a, b, c, d, e, f, g) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = T(d);
            e = e | 0;
            f = T(f);
            g = g | 0;
            Db[a & 1](b | 0, c | 0, T(d), e | 0, T(f), g | 0);
        }
        function cD(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            Eb[a & 15](b | 0, c | 0, d | 0);
        }
        function dD(a) {
            a = a | 0;
            Fb[a & 0]();
        }
        function eD(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = +d;
            Gb[a & 15](b | 0, c | 0, +d);
        }
        function fD(a, b, c) {
            a = a | 0;
            b = +b;
            c = +c;
            return Hb[a & 1](+b, +c) | 0;
        }
        function gD(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            Ib[a & 15](b | 0, c | 0, d | 0, e | 0);
        }
        function hD(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            U(0);
        }
        function iD(a, b) {
            a = a | 0;
            b = T(b);
            U(1);
        }
        function jD(a, b) {
            a = a | 0;
            b = +b;
            U(2);
        }
        function kD(a, b, c) {
            a = a | 0;
            b = T(b);
            c = T(c);
            U(3);
            return ib;
        }
        function lD(a) {
            a = a | 0;
            U(4);
        }
        function mD(a, b) {
            a = a | 0;
            b = b | 0;
            U(5);
        }
        function nD(a) {
            a = a | 0;
            U(6);
            return 0;
        }
        function oD(a, b, c, d) {
            a = a | 0;
            b = +b;
            c = +c;
            d = d | 0;
            U(7);
        }
        function pD(a, b, c) {
            a = a | 0;
            b = +b;
            c = +c;
            U(8);
        }
        function qD(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            U(9);
            return 0;
        }
        function rD(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            U(10);
            return 0.0;
        }
        function sD(a) {
            a = a | 0;
            U(11);
            return 0.0;
        }
        function tD(a, b) {
            a = a | 0;
            b = +b;
            U(12);
            return 0;
        }
        function uD(a, b) {
            a = a | 0;
            b = b | 0;
            U(13);
            return 0;
        }
        function vD(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = +c;
            d = +d;
            e = e | 0;
            U(14);
        }
        function wD(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            f = f | 0;
            U(15);
        }
        function xD(a, b) {
            a = a | 0;
            b = b | 0;
            U(16);
            return 0.0;
        }
        function yD() {
            U(17);
            return 0;
        }
        function zD(a, b, c, d, e) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            e = e | 0;
            U(18);
            return 0;
        }
        function AD(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = +d;
            U(19);
        }
        function BD(a, b, c, d, e, f) {
            a = a | 0;
            b = b | 0;
            c = T(c);
            d = d | 0;
            e = T(e);
            f = f | 0;
            U(20);
        }
        function CD(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            U(21);
        }
        function DD() {
            U(22);
        }
        function ED(a, b, c) {
            a = a | 0;
            b = b | 0;
            c = +c;
            U(23);
        }
        function FD(a, b) {
            a = +a;
            b = +b;
            U(24);
            return 0;
        }
        function GD(a, b, c, d) {
            a = a | 0;
            b = b | 0;
            c = c | 0;
            d = d | 0;
            U(25);
        }
        // EMSCRIPTEN_END_FUNCS
        var jb = [
            hD,
            Uw
        ];
        var kb = [
            iD,
            of
        ];
        var lb = [
            jD,
            Of,
            Pf,
            Qf,
            Rf,
            Sf,
            Tf,
            Uf,
            Wf,
            Xf,
            Zf,
            _f,
            $f,
            ag,
            bg,
            cg,
            dg,
            eg,
            fg,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD,
            jD
        ];
        var mb = [
            kD
        ];
        var nb = [
            lD,
            kC,
            Ki,
            Li,
            Mi,
            rn,
            sn,
            tn,
            Pu,
            Qu,
            Ru,
            Cw,
            Dw,
            Ew,
            DA,
            EA,
            FA,
            Rb,
            tf,
            yf,
            Vf,
            Yf,
            hh,
            ih,
            ri,
            Ui,
            kj,
            Jj,
            bk,
            zk,
            Wk,
            nl,
            Hl,
            bm,
            um,
            Nm,
            en,
            Nn,
            fo,
            yo,
            Ro,
            ip,
            Bp,
            Xp,
            nq,
            Eq,
            Zq,
            lf,
            Hr,
            _r,
            us,
            Ps,
            ft,
            Ct,
            Ot,
            Rt,
            ju,
            mu,
            Eu,
            Uu,
            Xu,
            pv,
            Kv,
            Vi,
            $x,
            Ky,
            az,
            sz,
            Rz,
            hA,
            tA,
            wA,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD,
            lD
        ];
        var ob = [
            mD,
            zf,
            Af,
            Df,
            Ef,
            Ff,
            Gf,
            Hf,
            If,
            Lf,
            Mf,
            Nf,
            wg,
            zg,
            Ag,
            Bg,
            Cg,
            Dg,
            Eg,
            Jg,
            Ng,
            rh,
            $p,
            qq,
            Ts,
            cy,
            Sv,
            xy,
            mD,
            mD,
            mD,
            mD
        ];
        var pb = [
            nD,
            rB,
            sf,
            jg,
            ng,
            og,
            pg,
            qg,
            rg,
            sg,
            ug,
            vg,
            Kg,
            Lg,
            jh,
            ar,
            jt,
            sv,
            hy,
            jy,
            nD,
            nD,
            nD,
            nD,
            nD,
            nD,
            nD,
            nD,
            nD,
            nD,
            nD,
            nD
        ];
        var qb = [
            oD,
            kh
        ];
        var rb = [
            pD,
            Hu
        ];
        var sb = [
            qD,
            sB,
            tB,
            zB,
            Dk,
            Rn,
            Lr,
            wz
        ];
        var tb = [
            rD,
            ym
        ];
        var ub = [
            sD,
            xg,
            yg,
            Fg,
            lh,
            mh,
            nh,
            oh,
            ph,
            qh,
            sD,
            sD,
            sD,
            sD,
            sD,
            sD
        ];
        var vb = [
            tD,
            Kt
        ];
        var wb = [
            uD,
            lC,
            Mg,
            xi,
            Nj,
            _k,
            rl,
            jn,
            jo,
            Iq,
            pf,
            ez,
            uD,
            uD,
            uD,
            uD
        ];
        var xb = [
            vD,
            oj
        ];
        var yb = [
            wD,
            Vz
        ];
        var zb = [
            xD,
            Gg,
            sh,
            th,
            uh,
            Rm,
            xD,
            xD
        ];
        var Ab = [
            yD,
            vh,
            qf,
            jf,
            Wt,
            qu,
            av,
            AA
        ];
        var Bb = [
            zD,
            ee
        ];
        var Cb = [
            AD,
            Vo
        ];
        var Db = [
            BD,
            Pg
        ];
        var Eb = [
            CD,
            kg,
            tg,
            Hg,
            Ig,
            fk,
            Ll,
            mp,
            Fp,
            nf,
            vx,
            Oy,
            lA,
            CD,
            CD,
            CD
        ];
        var Fb = [
            DD
        ];
        var Gb = [
            ED,
            Bf,
            Cf,
            Jf,
            Kf,
            gg,
            hg,
            ig,
            Co,
            cs,
            Ft,
            ED,
            ED,
            ED,
            ED,
            ED
        ];
        var Hb = [
            FD,
            Mu
        ];
        var Ib = [
            GD,
            fm,
            ir,
            ys,
            st,
            au,
            wu,
            hv,
            Pv,
            oy,
            LA,
            GD,
            GD,
            GD,
            GD,
            GD
        ];
        return {
            _llvm_bswap_i32: IC,
            dynCall_idd: fD,
            dynCall_i: _C,
            _i64Subtract: wC,
            ___udivdi3: EC,
            dynCall_vif: KC,
            setThrew: Nb,
            dynCall_viii: cD,
            _bitshift64Lshr: AC,
            _bitshift64Shl: zC,
            dynCall_vi: NC,
            dynCall_viiddi: XC,
            dynCall_diii: TC,
            dynCall_iii: WC,
            _memset: yC,
            _sbrk: FC,
            _memcpy: BC,
            __GLOBAL__sub_I_Yoga_cpp: hf,
            dynCall_vii: OC,
            ___uremdi3: HC,
            dynCall_vid: LC,
            stackAlloc: Jb,
            _nbind_init: _A,
            getTempRet0: Pb,
            dynCall_di: UC,
            dynCall_iid: VC,
            setTempRet0: Ob,
            _i64Add: xC,
            dynCall_fiff: MC,
            dynCall_iiii: SC,
            _emscripten_get_global_libc: qB,
            dynCall_viid: eD,
            dynCall_viiid: aD,
            dynCall_viififi: bD,
            dynCall_ii: PC,
            __GLOBAL__sub_I_Binding_cc: Sx,
            dynCall_viiii: gD,
            dynCall_iiiiii: $C,
            stackSave: Kb,
            dynCall_viiiii: JC,
            __GLOBAL__sub_I_nbind_cc: wh,
            dynCall_vidd: RC,
            _free: pB,
            runPostSets: vC,
            dynCall_viiiiii: YC,
            establishStackSpace: Mb,
            _memmove: GC,
            stackRestore: Lb,
            _malloc: oB,
            __GLOBAL__sub_I_common_cc: Bv,
            dynCall_viddi: QC,
            dynCall_dii: ZC,
            dynCall_v: dD
        };
    }(// EMSCRIPTEN_END_ASM
    Module.asmGlobalArg, Module.asmLibraryArg, buffer);
    var _llvm_bswap_i32 = Module["_llvm_bswap_i32"] = asm["_llvm_bswap_i32"];
    var getTempRet0 = Module["getTempRet0"] = asm["getTempRet0"];
    var ___udivdi3 = Module["___udivdi3"] = asm["___udivdi3"];
    var setThrew = Module["setThrew"] = asm["setThrew"];
    var _bitshift64Lshr = Module["_bitshift64Lshr"] = asm["_bitshift64Lshr"];
    var _bitshift64Shl = Module["_bitshift64Shl"] = asm["_bitshift64Shl"];
    var _memset = Module["_memset"] = asm["_memset"];
    var _sbrk = Module["_sbrk"] = asm["_sbrk"];
    var _memcpy = Module["_memcpy"] = asm["_memcpy"];
    var stackAlloc = Module["stackAlloc"] = asm["stackAlloc"];
    var ___uremdi3 = Module["___uremdi3"] = asm["___uremdi3"];
    var _nbind_init = Module["_nbind_init"] = asm["_nbind_init"];
    var _i64Subtract = Module["_i64Subtract"] = asm["_i64Subtract"];
    var setTempRet0 = Module["setTempRet0"] = asm["setTempRet0"];
    var _i64Add = Module["_i64Add"] = asm["_i64Add"];
    var _emscripten_get_global_libc = Module["_emscripten_get_global_libc"] = asm["_emscripten_get_global_libc"];
    var __GLOBAL__sub_I_Yoga_cpp = Module["__GLOBAL__sub_I_Yoga_cpp"] = asm["__GLOBAL__sub_I_Yoga_cpp"];
    var __GLOBAL__sub_I_Binding_cc = Module["__GLOBAL__sub_I_Binding_cc"] = asm["__GLOBAL__sub_I_Binding_cc"];
    var stackSave = Module["stackSave"] = asm["stackSave"];
    var __GLOBAL__sub_I_nbind_cc = Module["__GLOBAL__sub_I_nbind_cc"] = asm["__GLOBAL__sub_I_nbind_cc"];
    var _free = Module["_free"] = asm["_free"];
    var runPostSets = Module["runPostSets"] = asm["runPostSets"];
    var establishStackSpace = Module["establishStackSpace"] = asm["establishStackSpace"];
    var _memmove = Module["_memmove"] = asm["_memmove"];
    var stackRestore = Module["stackRestore"] = asm["stackRestore"];
    var _malloc = Module["_malloc"] = asm["_malloc"];
    var __GLOBAL__sub_I_common_cc = Module["__GLOBAL__sub_I_common_cc"] = asm["__GLOBAL__sub_I_common_cc"];
    var dynCall_viiiii = Module["dynCall_viiiii"] = asm["dynCall_viiiii"];
    var dynCall_vif = Module["dynCall_vif"] = asm["dynCall_vif"];
    var dynCall_vid = Module["dynCall_vid"] = asm["dynCall_vid"];
    var dynCall_fiff = Module["dynCall_fiff"] = asm["dynCall_fiff"];
    var dynCall_vi = Module["dynCall_vi"] = asm["dynCall_vi"];
    var dynCall_vii = Module["dynCall_vii"] = asm["dynCall_vii"];
    var dynCall_ii = Module["dynCall_ii"] = asm["dynCall_ii"];
    var dynCall_viddi = Module["dynCall_viddi"] = asm["dynCall_viddi"];
    var dynCall_vidd = Module["dynCall_vidd"] = asm["dynCall_vidd"];
    var dynCall_iiii = Module["dynCall_iiii"] = asm["dynCall_iiii"];
    var dynCall_diii = Module["dynCall_diii"] = asm["dynCall_diii"];
    var dynCall_di = Module["dynCall_di"] = asm["dynCall_di"];
    var dynCall_iid = Module["dynCall_iid"] = asm["dynCall_iid"];
    var dynCall_iii = Module["dynCall_iii"] = asm["dynCall_iii"];
    var dynCall_viiddi = Module["dynCall_viiddi"] = asm["dynCall_viiddi"];
    var dynCall_viiiiii = Module["dynCall_viiiiii"] = asm["dynCall_viiiiii"];
    var dynCall_dii = Module["dynCall_dii"] = asm["dynCall_dii"];
    var dynCall_i = Module["dynCall_i"] = asm["dynCall_i"];
    var dynCall_iiiiii = Module["dynCall_iiiiii"] = asm["dynCall_iiiiii"];
    var dynCall_viiid = Module["dynCall_viiid"] = asm["dynCall_viiid"];
    var dynCall_viififi = Module["dynCall_viififi"] = asm["dynCall_viififi"];
    var dynCall_viii = Module["dynCall_viii"] = asm["dynCall_viii"];
    var dynCall_v = Module["dynCall_v"] = asm["dynCall_v"];
    var dynCall_viid = Module["dynCall_viid"] = asm["dynCall_viid"];
    var dynCall_idd = Module["dynCall_idd"] = asm["dynCall_idd"];
    var dynCall_viiii = Module["dynCall_viiii"] = asm["dynCall_viiii"];
    Runtime.stackAlloc = Module["stackAlloc"];
    Runtime.stackSave = Module["stackSave"];
    Runtime.stackRestore = Module["stackRestore"];
    Runtime.establishStackSpace = Module["establishStackSpace"];
    Runtime.setTempRet0 = Module["setTempRet0"];
    Runtime.getTempRet0 = Module["getTempRet0"];
    Module["asm"] = asm;
    function ExitStatus(status) {
        this.name = "ExitStatus";
        this.message = "Program terminated with exit(" + status + ")";
        this.status = status;
    }
    ExitStatus.prototype = new Error();
    ExitStatus.prototype.constructor = ExitStatus;
    var initialStackTop;
    var preloadStartTime = null;
    var calledMain = false;
    dependenciesFulfilled = function runCaller() {
        if (!Module["calledRun"]) run();
        if (!Module["calledRun"]) dependenciesFulfilled = runCaller;
    };
    Module["callMain"] = Module.callMain = function callMain(args) {
        args = args || [];
        ensureInitRuntime();
        var argc = args.length + 1;
        function pad() {
            for(var i = 0; i < 3; i++)argv.push(0);
        }
        var argv = [
            allocate(intArrayFromString(Module["thisProgram"]), "i8", ALLOC_NORMAL)
        ];
        pad();
        for(var i = 0; i < argc - 1; i = i + 1){
            argv.push(allocate(intArrayFromString(args[i]), "i8", ALLOC_NORMAL));
            pad();
        }
        argv.push(0);
        argv = allocate(argv, "i32", ALLOC_NORMAL);
        try {
            var ret = Module["_main"](argc, argv, 0);
            exit(ret, true);
        } catch (e) {
            if (e instanceof ExitStatus) return;
            else if (e == "SimulateInfiniteLoop") {
                Module["noExitRuntime"] = true;
                return;
            } else {
                var toLog = e;
                if (e && typeof e === "object" && e.stack) toLog = [
                    e,
                    e.stack
                ];
                Module.printErr("exception thrown: " + toLog);
                Module["quit"](1, e);
            }
        } finally{
            calledMain = true;
        }
    };
    function run(args) {
        args = args || Module["arguments"];
        if (preloadStartTime === null) preloadStartTime = Date.now();
        if (runDependencies > 0) return;
        preRun();
        if (runDependencies > 0) return;
        if (Module["calledRun"]) return;
        function doRun() {
            if (Module["calledRun"]) return;
            Module["calledRun"] = true;
            if (ABORT) return;
            ensureInitRuntime();
            preMain();
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            if (Module["_main"] && shouldRunNow) Module["callMain"](args);
            postRun();
        }
        if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function() {
                setTimeout(function() {
                    Module["setStatus"]("");
                }, 1);
                doRun();
            }, 1);
        } else doRun();
    }
    Module["run"] = Module.run = run;
    function exit(status, implicit) {
        if (implicit && Module["noExitRuntime"]) return;
        if (Module["noExitRuntime"]) ;
        else {
            ABORT = true;
            EXITSTATUS = status;
            STACKTOP = initialStackTop;
            exitRuntime();
            if (Module["onExit"]) Module["onExit"](status);
        }
        if (ENVIRONMENT_IS_NODE) process["exit"](status);
        Module["quit"](status, new ExitStatus(status));
    }
    Module["exit"] = Module.exit = exit;
    var abortDecorators = [];
    function abort(what) {
        if (Module["onAbort"]) Module["onAbort"](what);
        if (what !== undefined) {
            Module.print(what);
            Module.printErr(what);
            what = JSON.stringify(what);
        } else what = "";
        ABORT = true;
        EXITSTATUS = 1;
        var extra = "\nIf this abort() is unexpected, build with -s ASSERTIONS=1 which can give more information.";
        var output = "abort(" + what + ") at " + stackTrace() + extra;
        if (abortDecorators) abortDecorators.forEach(function(decorator) {
            output = decorator(output, what);
        });
        throw output;
    }
    Module["abort"] = Module.abort = abort;
    if (Module["preInit"]) {
        if (typeof Module["preInit"] == "function") Module["preInit"] = [
            Module["preInit"]
        ];
        while(Module["preInit"].length > 0)Module["preInit"].pop()();
    }
    var shouldRunNow = true;
    if (Module["noInitialRun"]) shouldRunNow = false;
    run();
});

},{"e9ad461861cad07b":"5jT8D","b87b47a1e546bea":"dB11O"}],"lzfqX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "F", ()=>(0, _fJsDefault.default));
parcelHelpers.export(exports, "T", ()=>(0, _tJsDefault.default));
parcelHelpers.export(exports, "__", ()=>(0, _jsDefault.default));
parcelHelpers.export(exports, "add", ()=>(0, _addJsDefault.default));
parcelHelpers.export(exports, "addIndex", ()=>(0, _addIndexJsDefault.default));
parcelHelpers.export(exports, "adjust", ()=>(0, _adjustJsDefault.default));
parcelHelpers.export(exports, "all", ()=>(0, _allJsDefault.default));
parcelHelpers.export(exports, "allPass", ()=>(0, _allPassJsDefault.default));
parcelHelpers.export(exports, "always", ()=>(0, _alwaysJsDefault.default));
parcelHelpers.export(exports, "and", ()=>(0, _andJsDefault.default));
parcelHelpers.export(exports, "any", ()=>(0, _anyJsDefault.default));
parcelHelpers.export(exports, "anyPass", ()=>(0, _anyPassJsDefault.default));
parcelHelpers.export(exports, "ap", ()=>(0, _apJsDefault.default));
parcelHelpers.export(exports, "aperture", ()=>(0, _apertureJsDefault.default));
parcelHelpers.export(exports, "append", ()=>(0, _appendJsDefault.default));
parcelHelpers.export(exports, "apply", ()=>(0, _applyJsDefault.default));
parcelHelpers.export(exports, "applySpec", ()=>(0, _applySpecJsDefault.default));
parcelHelpers.export(exports, "applyTo", ()=>(0, _applyToJsDefault.default));
parcelHelpers.export(exports, "ascend", ()=>(0, _ascendJsDefault.default));
parcelHelpers.export(exports, "assoc", ()=>(0, _assocJsDefault.default));
parcelHelpers.export(exports, "assocPath", ()=>(0, _assocPathJsDefault.default));
parcelHelpers.export(exports, "binary", ()=>(0, _binaryJsDefault.default));
parcelHelpers.export(exports, "bind", ()=>(0, _bindJsDefault.default));
parcelHelpers.export(exports, "both", ()=>(0, _bothJsDefault.default));
parcelHelpers.export(exports, "call", ()=>(0, _callJsDefault.default));
parcelHelpers.export(exports, "chain", ()=>(0, _chainJsDefault.default));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampJsDefault.default));
parcelHelpers.export(exports, "clone", ()=>(0, _cloneJsDefault.default));
parcelHelpers.export(exports, "comparator", ()=>(0, _comparatorJsDefault.default));
parcelHelpers.export(exports, "complement", ()=>(0, _complementJsDefault.default));
parcelHelpers.export(exports, "compose", ()=>(0, _composeJsDefault.default));
parcelHelpers.export(exports, "composeK", ()=>(0, _composeKJsDefault.default));
parcelHelpers.export(exports, "composeP", ()=>(0, _composePJsDefault.default));
parcelHelpers.export(exports, "composeWith", ()=>(0, _composeWithJsDefault.default));
parcelHelpers.export(exports, "concat", ()=>(0, _concatJsDefault.default));
parcelHelpers.export(exports, "cond", ()=>(0, _condJsDefault.default));
parcelHelpers.export(exports, "construct", ()=>(0, _constructJsDefault.default));
parcelHelpers.export(exports, "constructN", ()=>(0, _constructNJsDefault.default));
parcelHelpers.export(exports, "contains", ()=>(0, _containsJsDefault.default));
parcelHelpers.export(exports, "converge", ()=>(0, _convergeJsDefault.default));
parcelHelpers.export(exports, "countBy", ()=>(0, _countByJsDefault.default));
parcelHelpers.export(exports, "curry", ()=>(0, _curryJsDefault.default));
parcelHelpers.export(exports, "curryN", ()=>(0, _curryNJsDefault.default));
parcelHelpers.export(exports, "dec", ()=>(0, _decJsDefault.default));
parcelHelpers.export(exports, "defaultTo", ()=>(0, _defaultToJsDefault.default));
parcelHelpers.export(exports, "descend", ()=>(0, _descendJsDefault.default));
parcelHelpers.export(exports, "difference", ()=>(0, _differenceJsDefault.default));
parcelHelpers.export(exports, "differenceWith", ()=>(0, _differenceWithJsDefault.default));
parcelHelpers.export(exports, "dissoc", ()=>(0, _dissocJsDefault.default));
parcelHelpers.export(exports, "dissocPath", ()=>(0, _dissocPathJsDefault.default));
parcelHelpers.export(exports, "divide", ()=>(0, _divideJsDefault.default));
parcelHelpers.export(exports, "drop", ()=>(0, _dropJsDefault.default));
parcelHelpers.export(exports, "dropLast", ()=>(0, _dropLastJsDefault.default));
parcelHelpers.export(exports, "dropLastWhile", ()=>(0, _dropLastWhileJsDefault.default));
parcelHelpers.export(exports, "dropRepeats", ()=>(0, _dropRepeatsJsDefault.default));
parcelHelpers.export(exports, "dropRepeatsWith", ()=>(0, _dropRepeatsWithJsDefault.default));
parcelHelpers.export(exports, "dropWhile", ()=>(0, _dropWhileJsDefault.default));
parcelHelpers.export(exports, "either", ()=>(0, _eitherJsDefault.default));
parcelHelpers.export(exports, "empty", ()=>(0, _emptyJsDefault.default));
parcelHelpers.export(exports, "endsWith", ()=>(0, _endsWithJsDefault.default));
parcelHelpers.export(exports, "eqBy", ()=>(0, _eqByJsDefault.default));
parcelHelpers.export(exports, "eqProps", ()=>(0, _eqPropsJsDefault.default));
parcelHelpers.export(exports, "equals", ()=>(0, _equalsJsDefault.default));
parcelHelpers.export(exports, "evolve", ()=>(0, _evolveJsDefault.default));
parcelHelpers.export(exports, "filter", ()=>(0, _filterJsDefault.default));
parcelHelpers.export(exports, "find", ()=>(0, _findJsDefault.default));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndexJsDefault.default));
parcelHelpers.export(exports, "findLast", ()=>(0, _findLastJsDefault.default));
parcelHelpers.export(exports, "findLastIndex", ()=>(0, _findLastIndexJsDefault.default));
parcelHelpers.export(exports, "flatten", ()=>(0, _flattenJsDefault.default));
parcelHelpers.export(exports, "flip", ()=>(0, _flipJsDefault.default));
parcelHelpers.export(exports, "forEach", ()=>(0, _forEachJsDefault.default));
parcelHelpers.export(exports, "forEachObjIndexed", ()=>(0, _forEachObjIndexedJsDefault.default));
parcelHelpers.export(exports, "fromPairs", ()=>(0, _fromPairsJsDefault.default));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupByJsDefault.default));
parcelHelpers.export(exports, "groupWith", ()=>(0, _groupWithJsDefault.default));
parcelHelpers.export(exports, "gt", ()=>(0, _gtJsDefault.default));
parcelHelpers.export(exports, "gte", ()=>(0, _gteJsDefault.default));
parcelHelpers.export(exports, "has", ()=>(0, _hasJsDefault.default));
parcelHelpers.export(exports, "hasIn", ()=>(0, _hasInJsDefault.default));
parcelHelpers.export(exports, "hasPath", ()=>(0, _hasPathJsDefault.default));
parcelHelpers.export(exports, "head", ()=>(0, _headJsDefault.default));
parcelHelpers.export(exports, "identical", ()=>(0, _identicalJsDefault.default));
parcelHelpers.export(exports, "identity", ()=>(0, _identityJsDefault.default));
parcelHelpers.export(exports, "ifElse", ()=>(0, _ifElseJsDefault.default));
parcelHelpers.export(exports, "inc", ()=>(0, _incJsDefault.default));
parcelHelpers.export(exports, "includes", ()=>(0, _includesJsDefault.default));
parcelHelpers.export(exports, "indexBy", ()=>(0, _indexByJsDefault.default));
parcelHelpers.export(exports, "indexOf", ()=>(0, _indexOfJsDefault.default));
parcelHelpers.export(exports, "init", ()=>(0, _initJsDefault.default));
parcelHelpers.export(exports, "innerJoin", ()=>(0, _innerJoinJsDefault.default));
parcelHelpers.export(exports, "insert", ()=>(0, _insertJsDefault.default));
parcelHelpers.export(exports, "insertAll", ()=>(0, _insertAllJsDefault.default));
parcelHelpers.export(exports, "intersection", ()=>(0, _intersectionJsDefault.default));
parcelHelpers.export(exports, "intersperse", ()=>(0, _intersperseJsDefault.default));
parcelHelpers.export(exports, "into", ()=>(0, _intoJsDefault.default));
parcelHelpers.export(exports, "invert", ()=>(0, _invertJsDefault.default));
parcelHelpers.export(exports, "invertObj", ()=>(0, _invertObjJsDefault.default));
parcelHelpers.export(exports, "invoker", ()=>(0, _invokerJsDefault.default));
parcelHelpers.export(exports, "is", ()=>(0, _isJsDefault.default));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmptyJsDefault.default));
parcelHelpers.export(exports, "isNil", ()=>(0, _isNilJsDefault.default));
parcelHelpers.export(exports, "join", ()=>(0, _joinJsDefault.default));
parcelHelpers.export(exports, "juxt", ()=>(0, _juxtJsDefault.default));
parcelHelpers.export(exports, "keys", ()=>(0, _keysJsDefault.default));
parcelHelpers.export(exports, "keysIn", ()=>(0, _keysInJsDefault.default));
parcelHelpers.export(exports, "last", ()=>(0, _lastJsDefault.default));
parcelHelpers.export(exports, "lastIndexOf", ()=>(0, _lastIndexOfJsDefault.default));
parcelHelpers.export(exports, "length", ()=>(0, _lengthJsDefault.default));
parcelHelpers.export(exports, "lens", ()=>(0, _lensJsDefault.default));
parcelHelpers.export(exports, "lensIndex", ()=>(0, _lensIndexJsDefault.default));
parcelHelpers.export(exports, "lensPath", ()=>(0, _lensPathJsDefault.default));
parcelHelpers.export(exports, "lensProp", ()=>(0, _lensPropJsDefault.default));
parcelHelpers.export(exports, "lift", ()=>(0, _liftJsDefault.default));
parcelHelpers.export(exports, "liftN", ()=>(0, _liftNJsDefault.default));
parcelHelpers.export(exports, "lt", ()=>(0, _ltJsDefault.default));
parcelHelpers.export(exports, "lte", ()=>(0, _lteJsDefault.default));
parcelHelpers.export(exports, "map", ()=>(0, _mapJsDefault.default));
parcelHelpers.export(exports, "mapAccum", ()=>(0, _mapAccumJsDefault.default));
parcelHelpers.export(exports, "mapAccumRight", ()=>(0, _mapAccumRightJsDefault.default));
parcelHelpers.export(exports, "mapObjIndexed", ()=>(0, _mapObjIndexedJsDefault.default));
parcelHelpers.export(exports, "match", ()=>(0, _matchJsDefault.default));
parcelHelpers.export(exports, "mathMod", ()=>(0, _mathModJsDefault.default));
parcelHelpers.export(exports, "max", ()=>(0, _maxJsDefault.default));
parcelHelpers.export(exports, "maxBy", ()=>(0, _maxByJsDefault.default));
parcelHelpers.export(exports, "mean", ()=>(0, _meanJsDefault.default));
parcelHelpers.export(exports, "median", ()=>(0, _medianJsDefault.default));
parcelHelpers.export(exports, "memoizeWith", ()=>(0, _memoizeWithJsDefault.default));
parcelHelpers.export(exports, "merge", ()=>(0, _mergeJsDefault.default));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAllJsDefault.default));
parcelHelpers.export(exports, "mergeDeepLeft", ()=>(0, _mergeDeepLeftJsDefault.default));
parcelHelpers.export(exports, "mergeDeepRight", ()=>(0, _mergeDeepRightJsDefault.default));
parcelHelpers.export(exports, "mergeDeepWith", ()=>(0, _mergeDeepWithJsDefault.default));
parcelHelpers.export(exports, "mergeDeepWithKey", ()=>(0, _mergeDeepWithKeyJsDefault.default));
parcelHelpers.export(exports, "mergeLeft", ()=>(0, _mergeLeftJsDefault.default));
parcelHelpers.export(exports, "mergeRight", ()=>(0, _mergeRightJsDefault.default));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _mergeWithJsDefault.default));
parcelHelpers.export(exports, "mergeWithKey", ()=>(0, _mergeWithKeyJsDefault.default));
parcelHelpers.export(exports, "min", ()=>(0, _minJsDefault.default));
parcelHelpers.export(exports, "minBy", ()=>(0, _minByJsDefault.default));
parcelHelpers.export(exports, "modulo", ()=>(0, _moduloJsDefault.default));
parcelHelpers.export(exports, "move", ()=>(0, _moveJsDefault.default));
parcelHelpers.export(exports, "multiply", ()=>(0, _multiplyJsDefault.default));
parcelHelpers.export(exports, "nAry", ()=>(0, _nAryJsDefault.default));
parcelHelpers.export(exports, "negate", ()=>(0, _negateJsDefault.default));
parcelHelpers.export(exports, "none", ()=>(0, _noneJsDefault.default));
parcelHelpers.export(exports, "not", ()=>(0, _notJsDefault.default));
parcelHelpers.export(exports, "nth", ()=>(0, _nthJsDefault.default));
parcelHelpers.export(exports, "nthArg", ()=>(0, _nthArgJsDefault.default));
parcelHelpers.export(exports, "o", ()=>(0, _oJsDefault.default));
parcelHelpers.export(exports, "objOf", ()=>(0, _objOfJsDefault.default));
parcelHelpers.export(exports, "of", ()=>(0, _ofJsDefault.default));
parcelHelpers.export(exports, "omit", ()=>(0, _omitJsDefault.default));
parcelHelpers.export(exports, "once", ()=>(0, _onceJsDefault.default));
parcelHelpers.export(exports, "or", ()=>(0, _orJsDefault.default));
parcelHelpers.export(exports, "otherwise", ()=>(0, _otherwiseJsDefault.default));
parcelHelpers.export(exports, "over", ()=>(0, _overJsDefault.default));
parcelHelpers.export(exports, "pair", ()=>(0, _pairJsDefault.default));
parcelHelpers.export(exports, "partial", ()=>(0, _partialJsDefault.default));
parcelHelpers.export(exports, "partialRight", ()=>(0, _partialRightJsDefault.default));
parcelHelpers.export(exports, "partition", ()=>(0, _partitionJsDefault.default));
parcelHelpers.export(exports, "path", ()=>(0, _pathJsDefault.default));
parcelHelpers.export(exports, "pathEq", ()=>(0, _pathEqJsDefault.default));
parcelHelpers.export(exports, "pathOr", ()=>(0, _pathOrJsDefault.default));
parcelHelpers.export(exports, "pathSatisfies", ()=>(0, _pathSatisfiesJsDefault.default));
parcelHelpers.export(exports, "pick", ()=>(0, _pickJsDefault.default));
parcelHelpers.export(exports, "pickAll", ()=>(0, _pickAllJsDefault.default));
parcelHelpers.export(exports, "pickBy", ()=>(0, _pickByJsDefault.default));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipeJsDefault.default));
parcelHelpers.export(exports, "pipeK", ()=>(0, _pipeKJsDefault.default));
parcelHelpers.export(exports, "pipeP", ()=>(0, _pipePJsDefault.default));
parcelHelpers.export(exports, "pipeWith", ()=>(0, _pipeWithJsDefault.default));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluckJsDefault.default));
parcelHelpers.export(exports, "prepend", ()=>(0, _prependJsDefault.default));
parcelHelpers.export(exports, "product", ()=>(0, _productJsDefault.default));
parcelHelpers.export(exports, "project", ()=>(0, _projectJsDefault.default));
parcelHelpers.export(exports, "prop", ()=>(0, _propJsDefault.default));
parcelHelpers.export(exports, "propEq", ()=>(0, _propEqJsDefault.default));
parcelHelpers.export(exports, "propIs", ()=>(0, _propIsJsDefault.default));
parcelHelpers.export(exports, "propOr", ()=>(0, _propOrJsDefault.default));
parcelHelpers.export(exports, "propSatisfies", ()=>(0, _propSatisfiesJsDefault.default));
parcelHelpers.export(exports, "props", ()=>(0, _propsJsDefault.default));
parcelHelpers.export(exports, "range", ()=>(0, _rangeJsDefault.default));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduceJsDefault.default));
parcelHelpers.export(exports, "reduceBy", ()=>(0, _reduceByJsDefault.default));
parcelHelpers.export(exports, "reduceRight", ()=>(0, _reduceRightJsDefault.default));
parcelHelpers.export(exports, "reduceWhile", ()=>(0, _reduceWhileJsDefault.default));
parcelHelpers.export(exports, "reduced", ()=>(0, _reducedJsDefault.default));
parcelHelpers.export(exports, "reject", ()=>(0, _rejectJsDefault.default));
parcelHelpers.export(exports, "remove", ()=>(0, _removeJsDefault.default));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeatJsDefault.default));
parcelHelpers.export(exports, "replace", ()=>(0, _replaceJsDefault.default));
parcelHelpers.export(exports, "reverse", ()=>(0, _reverseJsDefault.default));
parcelHelpers.export(exports, "scan", ()=>(0, _scanJsDefault.default));
parcelHelpers.export(exports, "sequence", ()=>(0, _sequenceJsDefault.default));
parcelHelpers.export(exports, "set", ()=>(0, _setJsDefault.default));
parcelHelpers.export(exports, "slice", ()=>(0, _sliceJsDefault.default));
parcelHelpers.export(exports, "sort", ()=>(0, _sortJsDefault.default));
parcelHelpers.export(exports, "sortBy", ()=>(0, _sortByJsDefault.default));
parcelHelpers.export(exports, "sortWith", ()=>(0, _sortWithJsDefault.default));
parcelHelpers.export(exports, "split", ()=>(0, _splitJsDefault.default));
parcelHelpers.export(exports, "splitAt", ()=>(0, _splitAtJsDefault.default));
parcelHelpers.export(exports, "splitEvery", ()=>(0, _splitEveryJsDefault.default));
parcelHelpers.export(exports, "splitWhen", ()=>(0, _splitWhenJsDefault.default));
parcelHelpers.export(exports, "startsWith", ()=>(0, _startsWithJsDefault.default));
parcelHelpers.export(exports, "subtract", ()=>(0, _subtractJsDefault.default));
parcelHelpers.export(exports, "sum", ()=>(0, _sumJsDefault.default));
parcelHelpers.export(exports, "symmetricDifference", ()=>(0, _symmetricDifferenceJsDefault.default));
parcelHelpers.export(exports, "symmetricDifferenceWith", ()=>(0, _symmetricDifferenceWithJsDefault.default));
parcelHelpers.export(exports, "tail", ()=>(0, _tailJsDefault.default));
parcelHelpers.export(exports, "take", ()=>(0, _takeJsDefault.default));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLastJsDefault.default));
parcelHelpers.export(exports, "takeLastWhile", ()=>(0, _takeLastWhileJsDefault.default));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhileJsDefault.default));
parcelHelpers.export(exports, "tap", ()=>(0, _tapJsDefault.default));
parcelHelpers.export(exports, "test", ()=>(0, _testJsDefault.default));
parcelHelpers.export(exports, "then", ()=>(0, _thenJsDefault.default));
parcelHelpers.export(exports, "times", ()=>(0, _timesJsDefault.default));
parcelHelpers.export(exports, "toLower", ()=>(0, _toLowerJsDefault.default));
parcelHelpers.export(exports, "toPairs", ()=>(0, _toPairsJsDefault.default));
parcelHelpers.export(exports, "toPairsIn", ()=>(0, _toPairsInJsDefault.default));
parcelHelpers.export(exports, "toString", ()=>(0, _toStringJsDefault.default));
parcelHelpers.export(exports, "toUpper", ()=>(0, _toUpperJsDefault.default));
parcelHelpers.export(exports, "transduce", ()=>(0, _transduceJsDefault.default));
parcelHelpers.export(exports, "transpose", ()=>(0, _transposeJsDefault.default));
parcelHelpers.export(exports, "traverse", ()=>(0, _traverseJsDefault.default));
parcelHelpers.export(exports, "trim", ()=>(0, _trimJsDefault.default));
parcelHelpers.export(exports, "tryCatch", ()=>(0, _tryCatchJsDefault.default));
parcelHelpers.export(exports, "type", ()=>(0, _typeJsDefault.default));
parcelHelpers.export(exports, "unapply", ()=>(0, _unapplyJsDefault.default));
parcelHelpers.export(exports, "unary", ()=>(0, _unaryJsDefault.default));
parcelHelpers.export(exports, "uncurryN", ()=>(0, _uncurryNJsDefault.default));
parcelHelpers.export(exports, "unfold", ()=>(0, _unfoldJsDefault.default));
parcelHelpers.export(exports, "union", ()=>(0, _unionJsDefault.default));
parcelHelpers.export(exports, "unionWith", ()=>(0, _unionWithJsDefault.default));
parcelHelpers.export(exports, "uniq", ()=>(0, _uniqJsDefault.default));
parcelHelpers.export(exports, "uniqBy", ()=>(0, _uniqByJsDefault.default));
parcelHelpers.export(exports, "uniqWith", ()=>(0, _uniqWithJsDefault.default));
parcelHelpers.export(exports, "unless", ()=>(0, _unlessJsDefault.default));
parcelHelpers.export(exports, "unnest", ()=>(0, _unnestJsDefault.default));
parcelHelpers.export(exports, "until", ()=>(0, _untilJsDefault.default));
parcelHelpers.export(exports, "update", ()=>(0, _updateJsDefault.default));
parcelHelpers.export(exports, "useWith", ()=>(0, _useWithJsDefault.default));
parcelHelpers.export(exports, "values", ()=>(0, _valuesJsDefault.default));
parcelHelpers.export(exports, "valuesIn", ()=>(0, _valuesInJsDefault.default));
parcelHelpers.export(exports, "view", ()=>(0, _viewJsDefault.default));
parcelHelpers.export(exports, "when", ()=>(0, _whenJsDefault.default));
parcelHelpers.export(exports, "where", ()=>(0, _whereJsDefault.default));
parcelHelpers.export(exports, "whereEq", ()=>(0, _whereEqJsDefault.default));
parcelHelpers.export(exports, "without", ()=>(0, _withoutJsDefault.default));
parcelHelpers.export(exports, "xprod", ()=>(0, _xprodJsDefault.default));
parcelHelpers.export(exports, "zip", ()=>(0, _zipJsDefault.default));
parcelHelpers.export(exports, "zipObj", ()=>(0, _zipObjJsDefault.default));
parcelHelpers.export(exports, "zipWith", ()=>(0, _zipWithJsDefault.default));
parcelHelpers.export(exports, "thunkify", ()=>(0, _thunkifyJsDefault.default));
var _fJs = require("./F.js");
var _fJsDefault = parcelHelpers.interopDefault(_fJs);
var _tJs = require("./T.js");
var _tJsDefault = parcelHelpers.interopDefault(_tJs);
var _js = require("./__.js");
var _jsDefault = parcelHelpers.interopDefault(_js);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _addIndexJs = require("./addIndex.js");
var _addIndexJsDefault = parcelHelpers.interopDefault(_addIndexJs);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
var _allJs = require("./all.js");
var _allJsDefault = parcelHelpers.interopDefault(_allJs);
var _allPassJs = require("./allPass.js");
var _allPassJsDefault = parcelHelpers.interopDefault(_allPassJs);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _andJs = require("./and.js");
var _andJsDefault = parcelHelpers.interopDefault(_andJs);
var _anyJs = require("./any.js");
var _anyJsDefault = parcelHelpers.interopDefault(_anyJs);
var _anyPassJs = require("./anyPass.js");
var _anyPassJsDefault = parcelHelpers.interopDefault(_anyPassJs);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _apertureJs = require("./aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _appendJs = require("./append.js");
var _appendJsDefault = parcelHelpers.interopDefault(_appendJs);
var _applyJs = require("./apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
var _applySpecJs = require("./applySpec.js");
var _applySpecJsDefault = parcelHelpers.interopDefault(_applySpecJs);
var _applyToJs = require("./applyTo.js");
var _applyToJsDefault = parcelHelpers.interopDefault(_applyToJs);
var _ascendJs = require("./ascend.js");
var _ascendJsDefault = parcelHelpers.interopDefault(_ascendJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _assocPathJs = require("./assocPath.js");
var _assocPathJsDefault = parcelHelpers.interopDefault(_assocPathJs);
var _binaryJs = require("./binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _bindJs = require("./bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _bothJs = require("./both.js");
var _bothJsDefault = parcelHelpers.interopDefault(_bothJs);
var _callJs = require("./call.js");
var _callJsDefault = parcelHelpers.interopDefault(_callJs);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
var _clampJs = require("./clamp.js");
var _clampJsDefault = parcelHelpers.interopDefault(_clampJs);
var _cloneJs = require("./clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _comparatorJs = require("./comparator.js");
var _comparatorJsDefault = parcelHelpers.interopDefault(_comparatorJs);
var _complementJs = require("./complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _composeKJs = require("./composeK.js");
var _composeKJsDefault = parcelHelpers.interopDefault(_composeKJs);
var _composePJs = require("./composeP.js");
var _composePJsDefault = parcelHelpers.interopDefault(_composePJs);
var _composeWithJs = require("./composeWith.js");
var _composeWithJsDefault = parcelHelpers.interopDefault(_composeWithJs);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _condJs = require("./cond.js");
var _condJsDefault = parcelHelpers.interopDefault(_condJs);
var _constructJs = require("./construct.js");
var _constructJsDefault = parcelHelpers.interopDefault(_constructJs);
var _constructNJs = require("./constructN.js");
var _constructNJsDefault = parcelHelpers.interopDefault(_constructNJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _convergeJs = require("./converge.js");
var _convergeJsDefault = parcelHelpers.interopDefault(_convergeJs);
var _countByJs = require("./countBy.js");
var _countByJsDefault = parcelHelpers.interopDefault(_countByJs);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _decJs = require("./dec.js");
var _decJsDefault = parcelHelpers.interopDefault(_decJs);
var _defaultToJs = require("./defaultTo.js");
var _defaultToJsDefault = parcelHelpers.interopDefault(_defaultToJs);
var _descendJs = require("./descend.js");
var _descendJsDefault = parcelHelpers.interopDefault(_descendJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
var _differenceWithJs = require("./differenceWith.js");
var _differenceWithJsDefault = parcelHelpers.interopDefault(_differenceWithJs);
var _dissocJs = require("./dissoc.js");
var _dissocJsDefault = parcelHelpers.interopDefault(_dissocJs);
var _dissocPathJs = require("./dissocPath.js");
var _dissocPathJsDefault = parcelHelpers.interopDefault(_dissocPathJs);
var _divideJs = require("./divide.js");
var _divideJsDefault = parcelHelpers.interopDefault(_divideJs);
var _dropJs = require("./drop.js");
var _dropJsDefault = parcelHelpers.interopDefault(_dropJs);
var _dropLastJs = require("./dropLast.js");
var _dropLastJsDefault = parcelHelpers.interopDefault(_dropLastJs);
var _dropLastWhileJs = require("./dropLastWhile.js");
var _dropLastWhileJsDefault = parcelHelpers.interopDefault(_dropLastWhileJs);
var _dropRepeatsJs = require("./dropRepeats.js");
var _dropRepeatsJsDefault = parcelHelpers.interopDefault(_dropRepeatsJs);
var _dropRepeatsWithJs = require("./dropRepeatsWith.js");
var _dropRepeatsWithJsDefault = parcelHelpers.interopDefault(_dropRepeatsWithJs);
var _dropWhileJs = require("./dropWhile.js");
var _dropWhileJsDefault = parcelHelpers.interopDefault(_dropWhileJs);
var _eitherJs = require("./either.js");
var _eitherJsDefault = parcelHelpers.interopDefault(_eitherJs);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _endsWithJs = require("./endsWith.js");
var _endsWithJsDefault = parcelHelpers.interopDefault(_endsWithJs);
var _eqByJs = require("./eqBy.js");
var _eqByJsDefault = parcelHelpers.interopDefault(_eqByJs);
var _eqPropsJs = require("./eqProps.js");
var _eqPropsJsDefault = parcelHelpers.interopDefault(_eqPropsJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _evolveJs = require("./evolve.js");
var _evolveJsDefault = parcelHelpers.interopDefault(_evolveJs);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _findJs = require("./find.js");
var _findJsDefault = parcelHelpers.interopDefault(_findJs);
var _findIndexJs = require("./findIndex.js");
var _findIndexJsDefault = parcelHelpers.interopDefault(_findIndexJs);
var _findLastJs = require("./findLast.js");
var _findLastJsDefault = parcelHelpers.interopDefault(_findLastJs);
var _findLastIndexJs = require("./findLastIndex.js");
var _findLastIndexJsDefault = parcelHelpers.interopDefault(_findLastIndexJs);
var _flattenJs = require("./flatten.js");
var _flattenJsDefault = parcelHelpers.interopDefault(_flattenJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _forEachJs = require("./forEach.js");
var _forEachJsDefault = parcelHelpers.interopDefault(_forEachJs);
var _forEachObjIndexedJs = require("./forEachObjIndexed.js");
var _forEachObjIndexedJsDefault = parcelHelpers.interopDefault(_forEachObjIndexedJs);
var _fromPairsJs = require("./fromPairs.js");
var _fromPairsJsDefault = parcelHelpers.interopDefault(_fromPairsJs);
var _groupByJs = require("./groupBy.js");
var _groupByJsDefault = parcelHelpers.interopDefault(_groupByJs);
var _groupWithJs = require("./groupWith.js");
var _groupWithJsDefault = parcelHelpers.interopDefault(_groupWithJs);
var _gtJs = require("./gt.js");
var _gtJsDefault = parcelHelpers.interopDefault(_gtJs);
var _gteJs = require("./gte.js");
var _gteJsDefault = parcelHelpers.interopDefault(_gteJs);
var _hasJs = require("./has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _hasInJs = require("./hasIn.js");
var _hasInJsDefault = parcelHelpers.interopDefault(_hasInJs);
var _hasPathJs = require("./hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
var _headJs = require("./head.js");
var _headJsDefault = parcelHelpers.interopDefault(_headJs);
var _identicalJs = require("./identical.js");
var _identicalJsDefault = parcelHelpers.interopDefault(_identicalJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _ifElseJs = require("./ifElse.js");
var _ifElseJsDefault = parcelHelpers.interopDefault(_ifElseJs);
var _incJs = require("./inc.js");
var _incJsDefault = parcelHelpers.interopDefault(_incJs);
var _includesJs = require("./includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _indexByJs = require("./indexBy.js");
var _indexByJsDefault = parcelHelpers.interopDefault(_indexByJs);
var _indexOfJs = require("./indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
var _initJs = require("./init.js");
var _initJsDefault = parcelHelpers.interopDefault(_initJs);
var _innerJoinJs = require("./innerJoin.js");
var _innerJoinJsDefault = parcelHelpers.interopDefault(_innerJoinJs);
var _insertJs = require("./insert.js");
var _insertJsDefault = parcelHelpers.interopDefault(_insertJs);
var _insertAllJs = require("./insertAll.js");
var _insertAllJsDefault = parcelHelpers.interopDefault(_insertAllJs);
var _intersectionJs = require("./intersection.js");
var _intersectionJsDefault = parcelHelpers.interopDefault(_intersectionJs);
var _intersperseJs = require("./intersperse.js");
var _intersperseJsDefault = parcelHelpers.interopDefault(_intersperseJs);
var _intoJs = require("./into.js");
var _intoJsDefault = parcelHelpers.interopDefault(_intoJs);
var _invertJs = require("./invert.js");
var _invertJsDefault = parcelHelpers.interopDefault(_invertJs);
var _invertObjJs = require("./invertObj.js");
var _invertObjJsDefault = parcelHelpers.interopDefault(_invertObjJs);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
var _isJs = require("./is.js");
var _isJsDefault = parcelHelpers.interopDefault(_isJs);
var _isEmptyJs = require("./isEmpty.js");
var _isEmptyJsDefault = parcelHelpers.interopDefault(_isEmptyJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
var _joinJs = require("./join.js");
var _joinJsDefault = parcelHelpers.interopDefault(_joinJs);
var _juxtJs = require("./juxt.js");
var _juxtJsDefault = parcelHelpers.interopDefault(_juxtJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _keysInJs = require("./keysIn.js");
var _keysInJsDefault = parcelHelpers.interopDefault(_keysInJs);
var _lastJs = require("./last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
var _lastIndexOfJs = require("./lastIndexOf.js");
var _lastIndexOfJsDefault = parcelHelpers.interopDefault(_lastIndexOfJs);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _lensIndexJs = require("./lensIndex.js");
var _lensIndexJsDefault = parcelHelpers.interopDefault(_lensIndexJs);
var _lensPathJs = require("./lensPath.js");
var _lensPathJsDefault = parcelHelpers.interopDefault(_lensPathJs);
var _lensPropJs = require("./lensProp.js");
var _lensPropJsDefault = parcelHelpers.interopDefault(_lensPropJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _liftNJs = require("./liftN.js");
var _liftNJsDefault = parcelHelpers.interopDefault(_liftNJs);
var _ltJs = require("./lt.js");
var _ltJsDefault = parcelHelpers.interopDefault(_ltJs);
var _lteJs = require("./lte.js");
var _lteJsDefault = parcelHelpers.interopDefault(_lteJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _mapAccumJs = require("./mapAccum.js");
var _mapAccumJsDefault = parcelHelpers.interopDefault(_mapAccumJs);
var _mapAccumRightJs = require("./mapAccumRight.js");
var _mapAccumRightJsDefault = parcelHelpers.interopDefault(_mapAccumRightJs);
var _mapObjIndexedJs = require("./mapObjIndexed.js");
var _mapObjIndexedJsDefault = parcelHelpers.interopDefault(_mapObjIndexedJs);
var _matchJs = require("./match.js");
var _matchJsDefault = parcelHelpers.interopDefault(_matchJs);
var _mathModJs = require("./mathMod.js");
var _mathModJsDefault = parcelHelpers.interopDefault(_mathModJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _maxByJs = require("./maxBy.js");
var _maxByJsDefault = parcelHelpers.interopDefault(_maxByJs);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
var _medianJs = require("./median.js");
var _medianJsDefault = parcelHelpers.interopDefault(_medianJs);
var _memoizeWithJs = require("./memoizeWith.js");
var _memoizeWithJsDefault = parcelHelpers.interopDefault(_memoizeWithJs);
var _mergeJs = require("./merge.js");
var _mergeJsDefault = parcelHelpers.interopDefault(_mergeJs);
var _mergeAllJs = require("./mergeAll.js");
var _mergeAllJsDefault = parcelHelpers.interopDefault(_mergeAllJs);
var _mergeDeepLeftJs = require("./mergeDeepLeft.js");
var _mergeDeepLeftJsDefault = parcelHelpers.interopDefault(_mergeDeepLeftJs);
var _mergeDeepRightJs = require("./mergeDeepRight.js");
var _mergeDeepRightJsDefault = parcelHelpers.interopDefault(_mergeDeepRightJs);
var _mergeDeepWithJs = require("./mergeDeepWith.js");
var _mergeDeepWithJsDefault = parcelHelpers.interopDefault(_mergeDeepWithJs);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
var _mergeLeftJs = require("./mergeLeft.js");
var _mergeLeftJsDefault = parcelHelpers.interopDefault(_mergeLeftJs);
var _mergeRightJs = require("./mergeRight.js");
var _mergeRightJsDefault = parcelHelpers.interopDefault(_mergeRightJs);
var _mergeWithJs = require("./mergeWith.js");
var _mergeWithJsDefault = parcelHelpers.interopDefault(_mergeWithJs);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
var _minJs = require("./min.js");
var _minJsDefault = parcelHelpers.interopDefault(_minJs);
var _minByJs = require("./minBy.js");
var _minByJsDefault = parcelHelpers.interopDefault(_minByJs);
var _moduloJs = require("./modulo.js");
var _moduloJsDefault = parcelHelpers.interopDefault(_moduloJs);
var _moveJs = require("./move.js");
var _moveJsDefault = parcelHelpers.interopDefault(_moveJs);
var _multiplyJs = require("./multiply.js");
var _multiplyJsDefault = parcelHelpers.interopDefault(_multiplyJs);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
var _negateJs = require("./negate.js");
var _negateJsDefault = parcelHelpers.interopDefault(_negateJs);
var _noneJs = require("./none.js");
var _noneJsDefault = parcelHelpers.interopDefault(_noneJs);
var _notJs = require("./not.js");
var _notJsDefault = parcelHelpers.interopDefault(_notJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
var _nthArgJs = require("./nthArg.js");
var _nthArgJsDefault = parcelHelpers.interopDefault(_nthArgJs);
var _oJs = require("./o.js");
var _oJsDefault = parcelHelpers.interopDefault(_oJs);
var _objOfJs = require("./objOf.js");
var _objOfJsDefault = parcelHelpers.interopDefault(_objOfJs);
var _ofJs = require("./of.js");
var _ofJsDefault = parcelHelpers.interopDefault(_ofJs);
var _omitJs = require("./omit.js");
var _omitJsDefault = parcelHelpers.interopDefault(_omitJs);
var _onceJs = require("./once.js");
var _onceJsDefault = parcelHelpers.interopDefault(_onceJs);
var _orJs = require("./or.js");
var _orJsDefault = parcelHelpers.interopDefault(_orJs);
var _otherwiseJs = require("./otherwise.js");
var _otherwiseJsDefault = parcelHelpers.interopDefault(_otherwiseJs);
var _overJs = require("./over.js");
var _overJsDefault = parcelHelpers.interopDefault(_overJs);
var _pairJs = require("./pair.js");
var _pairJsDefault = parcelHelpers.interopDefault(_pairJs);
var _partialJs = require("./partial.js");
var _partialJsDefault = parcelHelpers.interopDefault(_partialJs);
var _partialRightJs = require("./partialRight.js");
var _partialRightJsDefault = parcelHelpers.interopDefault(_partialRightJs);
var _partitionJs = require("./partition.js");
var _partitionJsDefault = parcelHelpers.interopDefault(_partitionJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
var _pathEqJs = require("./pathEq.js");
var _pathEqJsDefault = parcelHelpers.interopDefault(_pathEqJs);
var _pathOrJs = require("./pathOr.js");
var _pathOrJsDefault = parcelHelpers.interopDefault(_pathOrJs);
var _pathSatisfiesJs = require("./pathSatisfies.js");
var _pathSatisfiesJsDefault = parcelHelpers.interopDefault(_pathSatisfiesJs);
var _pickJs = require("./pick.js");
var _pickJsDefault = parcelHelpers.interopDefault(_pickJs);
var _pickAllJs = require("./pickAll.js");
var _pickAllJsDefault = parcelHelpers.interopDefault(_pickAllJs);
var _pickByJs = require("./pickBy.js");
var _pickByJsDefault = parcelHelpers.interopDefault(_pickByJs);
var _pipeJs = require("./pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _pipeKJs = require("./pipeK.js");
var _pipeKJsDefault = parcelHelpers.interopDefault(_pipeKJs);
var _pipePJs = require("./pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _pipeWithJs = require("./pipeWith.js");
var _pipeWithJsDefault = parcelHelpers.interopDefault(_pipeWithJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _prependJs = require("./prepend.js");
var _prependJsDefault = parcelHelpers.interopDefault(_prependJs);
var _productJs = require("./product.js");
var _productJsDefault = parcelHelpers.interopDefault(_productJs);
var _projectJs = require("./project.js");
var _projectJsDefault = parcelHelpers.interopDefault(_projectJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
var _propEqJs = require("./propEq.js");
var _propEqJsDefault = parcelHelpers.interopDefault(_propEqJs);
var _propIsJs = require("./propIs.js");
var _propIsJsDefault = parcelHelpers.interopDefault(_propIsJs);
var _propOrJs = require("./propOr.js");
var _propOrJsDefault = parcelHelpers.interopDefault(_propOrJs);
var _propSatisfiesJs = require("./propSatisfies.js");
var _propSatisfiesJsDefault = parcelHelpers.interopDefault(_propSatisfiesJs);
var _propsJs = require("./props.js");
var _propsJsDefault = parcelHelpers.interopDefault(_propsJs);
var _rangeJs = require("./range.js");
var _rangeJsDefault = parcelHelpers.interopDefault(_rangeJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
var _reduceRightJs = require("./reduceRight.js");
var _reduceRightJsDefault = parcelHelpers.interopDefault(_reduceRightJs);
var _reduceWhileJs = require("./reduceWhile.js");
var _reduceWhileJsDefault = parcelHelpers.interopDefault(_reduceWhileJs);
var _reducedJs = require("./reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _repeatJs = require("./repeat.js");
var _repeatJsDefault = parcelHelpers.interopDefault(_repeatJs);
var _replaceJs = require("./replace.js");
var _replaceJsDefault = parcelHelpers.interopDefault(_replaceJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
var _scanJs = require("./scan.js");
var _scanJsDefault = parcelHelpers.interopDefault(_scanJs);
var _sequenceJs = require("./sequence.js");
var _sequenceJsDefault = parcelHelpers.interopDefault(_sequenceJs);
var _setJs = require("./set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
var _sortJs = require("./sort.js");
var _sortJsDefault = parcelHelpers.interopDefault(_sortJs);
var _sortByJs = require("./sortBy.js");
var _sortByJsDefault = parcelHelpers.interopDefault(_sortByJs);
var _sortWithJs = require("./sortWith.js");
var _sortWithJsDefault = parcelHelpers.interopDefault(_sortWithJs);
var _splitJs = require("./split.js");
var _splitJsDefault = parcelHelpers.interopDefault(_splitJs);
var _splitAtJs = require("./splitAt.js");
var _splitAtJsDefault = parcelHelpers.interopDefault(_splitAtJs);
var _splitEveryJs = require("./splitEvery.js");
var _splitEveryJsDefault = parcelHelpers.interopDefault(_splitEveryJs);
var _splitWhenJs = require("./splitWhen.js");
var _splitWhenJsDefault = parcelHelpers.interopDefault(_splitWhenJs);
var _startsWithJs = require("./startsWith.js");
var _startsWithJsDefault = parcelHelpers.interopDefault(_startsWithJs);
var _subtractJs = require("./subtract.js");
var _subtractJsDefault = parcelHelpers.interopDefault(_subtractJs);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
var _symmetricDifferenceJs = require("./symmetricDifference.js");
var _symmetricDifferenceJsDefault = parcelHelpers.interopDefault(_symmetricDifferenceJs);
var _symmetricDifferenceWithJs = require("./symmetricDifferenceWith.js");
var _symmetricDifferenceWithJsDefault = parcelHelpers.interopDefault(_symmetricDifferenceWithJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
var _takeJs = require("./take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
var _takeLastJs = require("./takeLast.js");
var _takeLastJsDefault = parcelHelpers.interopDefault(_takeLastJs);
var _takeLastWhileJs = require("./takeLastWhile.js");
var _takeLastWhileJsDefault = parcelHelpers.interopDefault(_takeLastWhileJs);
var _takeWhileJs = require("./takeWhile.js");
var _takeWhileJsDefault = parcelHelpers.interopDefault(_takeWhileJs);
var _tapJs = require("./tap.js");
var _tapJsDefault = parcelHelpers.interopDefault(_tapJs);
var _testJs = require("./test.js");
var _testJsDefault = parcelHelpers.interopDefault(_testJs);
var _thenJs = require("./then.js");
var _thenJsDefault = parcelHelpers.interopDefault(_thenJs);
var _timesJs = require("./times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
var _toLowerJs = require("./toLower.js");
var _toLowerJsDefault = parcelHelpers.interopDefault(_toLowerJs);
var _toPairsJs = require("./toPairs.js");
var _toPairsJsDefault = parcelHelpers.interopDefault(_toPairsJs);
var _toPairsInJs = require("./toPairsIn.js");
var _toPairsInJsDefault = parcelHelpers.interopDefault(_toPairsInJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
var _toUpperJs = require("./toUpper.js");
var _toUpperJsDefault = parcelHelpers.interopDefault(_toUpperJs);
var _transduceJs = require("./transduce.js");
var _transduceJsDefault = parcelHelpers.interopDefault(_transduceJs);
var _transposeJs = require("./transpose.js");
var _transposeJsDefault = parcelHelpers.interopDefault(_transposeJs);
var _traverseJs = require("./traverse.js");
var _traverseJsDefault = parcelHelpers.interopDefault(_traverseJs);
var _trimJs = require("./trim.js");
var _trimJsDefault = parcelHelpers.interopDefault(_trimJs);
var _tryCatchJs = require("./tryCatch.js");
var _tryCatchJsDefault = parcelHelpers.interopDefault(_tryCatchJs);
var _typeJs = require("./type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
var _unapplyJs = require("./unapply.js");
var _unapplyJsDefault = parcelHelpers.interopDefault(_unapplyJs);
var _unaryJs = require("./unary.js");
var _unaryJsDefault = parcelHelpers.interopDefault(_unaryJs);
var _uncurryNJs = require("./uncurryN.js");
var _uncurryNJsDefault = parcelHelpers.interopDefault(_uncurryNJs);
var _unfoldJs = require("./unfold.js");
var _unfoldJsDefault = parcelHelpers.interopDefault(_unfoldJs);
var _unionJs = require("./union.js");
var _unionJsDefault = parcelHelpers.interopDefault(_unionJs);
var _unionWithJs = require("./unionWith.js");
var _unionWithJsDefault = parcelHelpers.interopDefault(_unionWithJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
var _uniqByJs = require("./uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
var _uniqWithJs = require("./uniqWith.js");
var _uniqWithJsDefault = parcelHelpers.interopDefault(_uniqWithJs);
var _unlessJs = require("./unless.js");
var _unlessJsDefault = parcelHelpers.interopDefault(_unlessJs);
var _unnestJs = require("./unnest.js");
var _unnestJsDefault = parcelHelpers.interopDefault(_unnestJs);
var _untilJs = require("./until.js");
var _untilJsDefault = parcelHelpers.interopDefault(_untilJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
var _useWithJs = require("./useWith.js");
var _useWithJsDefault = parcelHelpers.interopDefault(_useWithJs);
var _valuesJs = require("./values.js");
var _valuesJsDefault = parcelHelpers.interopDefault(_valuesJs);
var _valuesInJs = require("./valuesIn.js");
var _valuesInJsDefault = parcelHelpers.interopDefault(_valuesInJs);
var _viewJs = require("./view.js");
var _viewJsDefault = parcelHelpers.interopDefault(_viewJs);
var _whenJs = require("./when.js");
var _whenJsDefault = parcelHelpers.interopDefault(_whenJs);
var _whereJs = require("./where.js");
var _whereJsDefault = parcelHelpers.interopDefault(_whereJs);
var _whereEqJs = require("./whereEq.js");
var _whereEqJsDefault = parcelHelpers.interopDefault(_whereEqJs);
var _withoutJs = require("./without.js");
var _withoutJsDefault = parcelHelpers.interopDefault(_withoutJs);
var _xprodJs = require("./xprod.js");
var _xprodJsDefault = parcelHelpers.interopDefault(_xprodJs);
var _zipJs = require("./zip.js");
var _zipJsDefault = parcelHelpers.interopDefault(_zipJs);
var _zipObjJs = require("./zipObj.js");
var _zipObjJsDefault = parcelHelpers.interopDefault(_zipObjJs);
var _zipWithJs = require("./zipWith.js");
var _zipWithJsDefault = parcelHelpers.interopDefault(_zipWithJs);
var _thunkifyJs = require("./thunkify.js");
var _thunkifyJsDefault = parcelHelpers.interopDefault(_thunkifyJs);

},{"./F.js":"5wCfY","./T.js":"42vCR","./__.js":"e202o","./add.js":"49LDq","./addIndex.js":"2y1uA","./adjust.js":"1Jj5f","./all.js":"a9Bza","./allPass.js":"LLe97","./always.js":"17a55","./and.js":"fNSfi","./any.js":"ilKPm","./anyPass.js":"hsvdT","./ap.js":"1hv9E","./aperture.js":"i8e9k","./append.js":"egZoZ","./apply.js":"bIQUf","./applySpec.js":"f1rqC","./applyTo.js":"fy2C8","./ascend.js":"fPFlQ","./assoc.js":"kx0W3","./assocPath.js":"9hyo3","./binary.js":"21HV3","./bind.js":"9FzMy","./both.js":"7UAF2","./call.js":"l68m2","./chain.js":"349mj","./clamp.js":"gCZfw","./clone.js":"k1kLp","./comparator.js":"5HJqp","./complement.js":"705Gg","./compose.js":"985qM","./composeK.js":"fmXwQ","./composeP.js":"eE6e1","./composeWith.js":"7corr","./concat.js":"8EMJt","./cond.js":"6yEqP","./construct.js":"csTEP","./constructN.js":"eVfMO","./contains.js":"cvc7D","./converge.js":"a3HDL","./countBy.js":"5tATF","./curry.js":"2FUaQ","./curryN.js":"jig5V","./dec.js":"9lcQr","./defaultTo.js":"j7d9y","./descend.js":"gQxWl","./difference.js":"kOL0M","./differenceWith.js":"6hyWS","./dissoc.js":"lw69U","./dissocPath.js":"fdBQw","./divide.js":"9ibnW","./drop.js":"eUV7h","./dropLast.js":"8KKVA","./dropLastWhile.js":"wBgXr","./dropRepeats.js":"g1WbI","./dropRepeatsWith.js":"lVOzi","./dropWhile.js":"csTRb","./either.js":"ix25g","./empty.js":"aCQa1","./endsWith.js":"8Qgy5","./eqBy.js":"agONC","./eqProps.js":"9w98j","./equals.js":"90ObX","./evolve.js":"hYvGg","./filter.js":"kidP8","./find.js":"9GNIr","./findIndex.js":"gVNw8","./findLast.js":"6BZFD","./findLastIndex.js":"wjHm9","./flatten.js":"5SDRJ","./flip.js":"h3gua","./forEach.js":"g4StJ","./forEachObjIndexed.js":"k20NG","./fromPairs.js":"054qa","./groupBy.js":"bZkDs","./groupWith.js":"5eMQM","./gt.js":"51JGj","./gte.js":"1yl8b","./has.js":"LJXag","./hasIn.js":"ksKGi","./hasPath.js":"8kj6Q","./head.js":"fHb0C","./identical.js":"kswLQ","./identity.js":"4xoG2","./ifElse.js":"hMMPK","./inc.js":"3BAcg","./includes.js":"1cgtb","./indexBy.js":"cVHNJ","./indexOf.js":"8ql7T","./init.js":"c8PSn","./innerJoin.js":"5J9Wi","./insert.js":"lluCV","./insertAll.js":"cSbT4","./intersection.js":"d5sHO","./intersperse.js":"cirXr","./into.js":"Mj4ju","./invert.js":"6GEy9","./invertObj.js":"6e4w5","./invoker.js":"grw4w","./is.js":"gXlvv","./isEmpty.js":"hHFkC","./isNil.js":"iyj1k","./join.js":"1vMr3","./juxt.js":"ezcwh","./keys.js":"7WEzg","./keysIn.js":"8UipG","./last.js":"ioMJD","./lastIndexOf.js":"4eL6e","./length.js":"e5Vtn","./lens.js":"lH0bS","./lensIndex.js":"g96qs","./lensPath.js":"67TaH","./lensProp.js":"hYEVt","./lift.js":"4spBG","./liftN.js":"5Owrg","./lt.js":"79IqU","./lte.js":"21lPg","./map.js":"6E1l9","./mapAccum.js":"dX8Hb","./mapAccumRight.js":"7OqYT","./mapObjIndexed.js":"eBjyt","./match.js":"6fhHQ","./mathMod.js":"9KvOh","./max.js":"7Sw8f","./maxBy.js":"eoyZO","./mean.js":"1LUYn","./median.js":"aewWO","./memoizeWith.js":"3P7V2","./merge.js":"a1HMy","./mergeAll.js":"krREj","./mergeDeepLeft.js":"cqixg","./mergeDeepRight.js":"8GsaD","./mergeDeepWith.js":"h3QRA","./mergeDeepWithKey.js":"b8F2l","./mergeLeft.js":"iNxOF","./mergeRight.js":"84OnG","./mergeWith.js":"742mQ","./mergeWithKey.js":"gJMdQ","./min.js":"39La5","./minBy.js":"1gZ6y","./modulo.js":"1fGzv","./move.js":"dF01F","./multiply.js":"i0Qo1","./nAry.js":"gUdSm","./negate.js":"kxxsb","./none.js":"6Na1O","./not.js":"7kCTe","./nth.js":"7AaSQ","./nthArg.js":"7zaHU","./o.js":"oAU7U","./objOf.js":"6o9sS","./of.js":"6WcyW","./omit.js":"gZqX4","./once.js":"iskcq","./or.js":"84jgE","./otherwise.js":"fO0Ys","./over.js":"8vrvT","./pair.js":"3v1DQ","./partial.js":"7G4P4","./partialRight.js":"4c0xc","./partition.js":"h7rnv","./path.js":"199kS","./pathEq.js":"90Y4R","./pathOr.js":"56c6t","./pathSatisfies.js":"6QmpS","./pick.js":"iSGes","./pickAll.js":"7mkXe","./pickBy.js":"hESLr","./pipe.js":"1xQ3K","./pipeK.js":"1P96O","./pipeP.js":"3xYh3","./pipeWith.js":"gRDu4","./pluck.js":"bKszn","./prepend.js":"ihMcA","./product.js":"1L85T","./project.js":"2ZFdf","./prop.js":"h0KMs","./propEq.js":"jAegf","./propIs.js":"kEENR","./propOr.js":"leANP","./propSatisfies.js":"2ypg8","./props.js":"hac3l","./range.js":"jXooF","./reduce.js":"14LEy","./reduceBy.js":"4hpJN","./reduceRight.js":"9glW9","./reduceWhile.js":"bn3o3","./reduced.js":"7FPaA","./reject.js":"4OIPW","./remove.js":"dtUhF","./repeat.js":"f9SOy","./replace.js":"fp7vG","./reverse.js":"kusbf","./scan.js":"jrecT","./sequence.js":"jWtQg","./set.js":"ijlMu","./slice.js":"gWLR6","./sort.js":"9KSna","./sortBy.js":"gRNAH","./sortWith.js":"1ikiG","./split.js":"6n8Ra","./splitAt.js":"4c5vZ","./splitEvery.js":"ivyZa","./splitWhen.js":"2dlNd","./startsWith.js":"6aD0D","./subtract.js":"1ovIw","./sum.js":"cJJ21","./symmetricDifference.js":"cXE07","./symmetricDifferenceWith.js":"3awOX","./tail.js":"3aeWe","./take.js":"9GQUp","./takeLast.js":"i6F2s","./takeLastWhile.js":"bCuVs","./takeWhile.js":"9nV7k","./tap.js":"3fTPk","./test.js":"kkzEr","./then.js":"f2Bvd","./times.js":"6xPZL","./toLower.js":"j1otG","./toPairs.js":"euRrp","./toPairsIn.js":"34EwM","./toString.js":"fffBR","./toUpper.js":"kYwqm","./transduce.js":"awR23","./transpose.js":"lbOML","./traverse.js":"cj1N4","./trim.js":"7Hqiy","./tryCatch.js":"di6xw","./type.js":"8E76F","./unapply.js":"6FNXX","./unary.js":"gurCN","./uncurryN.js":"3E6l5","./unfold.js":"jKJwF","./union.js":"5Nn1P","./unionWith.js":"lpZjX","./uniq.js":"b2tzD","./uniqBy.js":"1eIBw","./uniqWith.js":"8oNoi","./unless.js":"1fx2U","./unnest.js":"k7QPj","./until.js":"7QjvZ","./update.js":"lbNxi","./useWith.js":"gxbrq","./values.js":"X4WCA","./valuesIn.js":"6Mk8r","./view.js":"7RNFQ","./when.js":"fAxtz","./where.js":"7EL9d","./whereEq.js":"paKr6","./without.js":"cu2sz","./xprod.js":"fZ4el","./zip.js":"1hFPR","./zipObj.js":"6XcZ5","./zipWith.js":"ay9NA","./thunkify.js":"98Rha","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5wCfY":[function(require,module,exports,__globalThis) {
/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.T
 * @example
 *
 *      R.F(); //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var F = function() {
    return false;
};
exports.default = F;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"42vCR":[function(require,module,exports,__globalThis) {
/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var T = function() {
    return true;
};
exports.default = T;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e202o":[function(require,module,exports,__globalThis) {
/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    '@@functional/placeholder': true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"49LDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Adds two values.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a
 * @param {Number} b
 * @return {Number}
 * @see R.subtract
 * @example
 *
 *      R.add(2, 3);       //=>  5
 *      R.add(7)(10);      //=> 17
 */ var add = /*#__PURE__*/ (0, _curry2JsDefault.default)(function add(a, b) {
    return Number(a) + Number(b);
});
exports.default = add;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fKiHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curry2);
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, _isPlaceholderJsDefault.default)(a) ? f2 : (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? f2 : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry1JsDefault.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

},{"./_curry1.js":"973zL","./_isPlaceholder.js":"8q1QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"973zL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curry1);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, _isPlaceholderJsDefault.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

},{"./_isPlaceholder.js":"8q1QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8q1QN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isPlaceholder);
function _isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2y1uA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Creates a new list iteration function from an existing one by adding two new
 * parameters to its callback function: the current index, and the entire list.
 *
 * This would turn, for instance, [`R.map`](#map) function into one that
 * more closely resembles `Array.prototype.map`. Note that this will only work
 * for functions in which the iteration callback function is the first
 * parameter, and where the list is the last parameter. (This latter might be
 * unimportant if the list parameter is not used.)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Function
 * @category List
 * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
 * @param {Function} fn A list iteration function that does not pass index or list to its callback
 * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
 * @example
 *
 *      const mapIndexed = R.addIndex(R.map);
 *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
 *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
 */ var addIndex = /*#__PURE__*/ (0, _curry1JsDefault.default)(function addIndex(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function() {
        var idx = 0;
        var origFn = arguments[0];
        var list = arguments[arguments.length - 1];
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = function() {
            var result = origFn.apply(this, (0, _concatJsDefault.default)(arguments, [
                idx,
                list
            ]));
            idx += 1;
            return result;
        };
        return fn.apply(this, args);
    });
});
exports.default = addIndex;

},{"./internal/_concat.js":"hXJys","./internal/_curry1.js":"973zL","./curryN.js":"jig5V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hXJys":[function(require,module,exports,__globalThis) {
/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_concat);
function _concat(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;
    while(idx < len1){
        result[result.length] = set1[idx];
        idx += 1;
    }
    idx = 0;
    while(idx < len2){
        result[result.length] = set2[idx];
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jig5V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var curryN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function curryN(length, fn) {
    if (length === 1) return (0, _curry1JsDefault.default)(fn);
    return (0, _arityJsDefault.default)(length, (0, _curryNJsDefault.default)(length, [], fn));
});
exports.default = curryN;

},{"./internal/_arity.js":"cUJua","./internal/_curry1.js":"973zL","./internal/_curry2.js":"fKiHC","./internal/_curryN.js":"8fWG3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cUJua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arity);
function _arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8fWG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curryN);
var _arityJs = require("./_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!(0, _isPlaceholderJsDefault.default)(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!(0, _isPlaceholderJsDefault.default)(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : (0, _arityJsDefault.default)(left, _curryN(length, combined, fn));
    };
}

},{"./_arity.js":"cUJua","./_isPlaceholder.js":"8q1QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1Jj5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Applies a function to the value at the given index of an array, returning a
 * new copy of the array with the element at the given index replaced with the
 * result of the function application.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> (a -> a) -> [a] -> [a]
 * @param {Number} idx The index.
 * @param {Function} fn The function to apply.
 * @param {Array|Arguments} list An array-like object whose value
 *        at the supplied index will be replaced.
 * @return {Array} A copy of the supplied array-like object with
 *         the element at index `idx` replaced with the value
 *         returned by applying `fn` to the existing element.
 * @see R.update
 * @example
 *
 *      R.adjust(1, R.toUpper, ['a', 'b', 'c', 'd']);      //=> ['a', 'B', 'c', 'd']
 *      R.adjust(-1, R.toUpper, ['a', 'b', 'c', 'd']);     //=> ['a', 'b', 'c', 'D']
 * @symb R.adjust(-1, f, [a, b]) = [a, f(b)]
 * @symb R.adjust(0, f, [a, b]) = [f(a), b]
 */ var adjust = /*#__PURE__*/ (0, _curry3JsDefault.default)(function adjust(idx, fn, list) {
    if (idx >= list.length || idx < -list.length) return list;
    var start = idx < 0 ? list.length : 0;
    var _idx = start + idx;
    var _list = (0, _concatJsDefault.default)(list);
    _list[_idx] = fn(list[_idx]);
    return _list;
});
exports.default = adjust;

},{"./internal/_concat.js":"hXJys","./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eXJSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_curry3);
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isPlaceholderJs = require("./_isPlaceholder.js");
var _isPlaceholderJsDefault = parcelHelpers.interopDefault(_isPlaceholderJs);
function _curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, _isPlaceholderJsDefault.default)(a) ? f3 : (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? f3 : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry2JsDefault.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, _curry1JsDefault.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) && (0, _isPlaceholderJsDefault.default)(c) ? f3 : (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry2JsDefault.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, _isPlaceholderJsDefault.default)(a) && (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry2JsDefault.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(b) && (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry2JsDefault.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, _isPlaceholderJsDefault.default)(a) ? (0, _curry1JsDefault.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, _isPlaceholderJsDefault.default)(b) ? (0, _curry1JsDefault.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, _isPlaceholderJsDefault.default)(c) ? (0, _curry1JsDefault.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

},{"./_curry1.js":"973zL","./_curry2.js":"fKiHC","./_isPlaceholder.js":"8q1QN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a9Bza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xallJs = require("./internal/_xall.js");
var _xallJsDefault = parcelHelpers.interopDefault(_xallJs);
/**
 * Returns `true` if all elements of the list match the predicate, `false` if
 * there are any that don't.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by every element, `false`
 *         otherwise.
 * @see R.any, R.none, R.transduce
 * @example
 *
 *      const equals3 = R.equals(3);
 *      R.all(equals3)([3, 3, 3, 3]); //=> true
 *      R.all(equals3)([3, 3, 1, 3]); //=> false
 */ var all = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'all'
], (0, _xallJsDefault.default), function all(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (!fn(list[idx])) return false;
        idx += 1;
    }
    return true;
}));
exports.default = all;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xall.js":"fU2is","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1aoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_dispatchable);
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isTransformerJs = require("./_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
function _dispatchable(methodNames, xf, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var args = Array.prototype.slice.call(arguments, 0);
        var obj = args.pop();
        if (!(0, _isArrayJsDefault.default)(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, args);
                idx += 1;
            }
            if ((0, _isTransformerJsDefault.default)(obj)) {
                var transducer = xf.apply(null, args);
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}

},{"./_isArray.js":"lc1D3","./_isTransformer.js":"7PEtz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lc1D3":[function(require,module,exports,__globalThis) {
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7PEtz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isTransformer);
function _isTransformer(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fU2is":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAll = /*#__PURE__*/ function() {
    function XAll(f, xf) {
        this.xf = xf;
        this.f = f;
        this.all = true;
    }
    XAll.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XAll.prototype['@@transducer/result'] = function(result) {
        if (this.all) result = this.xf['@@transducer/step'](result, true);
        return this.xf['@@transducer/result'](result);
    };
    XAll.prototype['@@transducer/step'] = function(result, input) {
        if (!this.f(input)) {
            this.all = false;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, false));
        }
        return result;
    };
    return XAll;
}();
var _xall = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xall(f, xf) {
    return new XAll(f, xf);
});
exports.default = _xall;

},{"./_curry2.js":"fKiHC","./_reduced.js":"jCwWa","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jCwWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_reduced);
function _reduced(x) {
    return x && x['@@transducer/reduced'] ? x : {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJ0GC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    init: function() {
        return this.xf['@@transducer/init']();
    },
    result: function(result) {
        return this.xf['@@transducer/result'](result);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LLe97":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if every one of the provided predicates is satisfied
 * by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.anyPass
 * @example
 *
 *      const isQueen = R.propEq('rank', 'Q');
 *      const isSpade = R.propEq('suit', '♠︎');
 *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
 *
 *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
 *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
 */ var allPass = /*#__PURE__*/ (0, _curry1JsDefault.default)(function allPass(preds) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (!preds[idx].apply(this, arguments)) return false;
            idx += 1;
        }
        return true;
    });
});
exports.default = allPass;

},{"./internal/_curry1.js":"973zL","./curryN.js":"jig5V","./max.js":"7Sw8f","./pluck.js":"bKszn","./reduce.js":"14LEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Sw8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */ var max = /*#__PURE__*/ (0, _curry2JsDefault.default)(function max(a, b) {
    return b > a ? b : a;
});
exports.default = max;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bKszn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
/**
 * Returns a new list by plucking the same named property off all objects in
 * the list supplied.
 *
 * `pluck` will work on
 * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
 * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => k -> f {k: v} -> f v
 * @param {Number|String} key The key name to pluck off of each object.
 * @param {Array} f The array or functor to consider.
 * @return {Array} The list of values for the given key.
 * @see R.props
 * @example
 *
 *      var getAges = R.pluck('age');
 *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
 *
 *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
 *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
 * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
 * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
 */ var pluck = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pluck(p, list) {
    return (0, _mapJsDefault.default)((0, _propJsDefault.default)(p), list);
});
exports.default = pluck;

},{"./internal/_curry2.js":"fKiHC","./map.js":"6E1l9","./prop.js":"h0KMs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6E1l9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xmapJs = require("./internal/_xmap.js");
var _xmapJsDefault = parcelHelpers.interopDefault(_xmapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var map = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'fantasy-land/map',
    'map'
], (0, _xmapJsDefault.default), function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case '[object Function]':
            return (0, _curryNJsDefault.default)(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return (0, _reduceJsDefault.default)(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, (0, _keysJsDefault.default)(functor));
        default:
            return (0, _mapJsDefault.default)(fn, functor);
    }
}));
exports.default = map;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_map.js":"9apIE","./internal/_reduce.js":"kZKBe","./internal/_xmap.js":"a8Onq","./curryN.js":"jig5V","./keys.js":"7WEzg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9apIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_map);
function _map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kZKBe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_reduce);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _xwrapJs = require("./_xwrap.js");
var _xwrapJsDefault = parcelHelpers.interopDefault(_xwrapJs);
var _bindJs = require("../bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
function _iterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName]((0, _bindJsDefault.default)(xf['@@transducer/step'], xf), acc));
}
var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function _reduce(fn, acc, list) {
    if (typeof fn === 'function') fn = (0, _xwrapJsDefault.default)(fn);
    if ((0, _isArrayLikeJsDefault.default)(list)) return _arrayReduce(fn, acc, list);
    if (typeof list['fantasy-land/reduce'] === 'function') return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    if (list[symIterator] != null) return _iterableReduce(fn, acc, list[symIterator]());
    if (typeof list.next === 'function') return _iterableReduce(fn, acc, list);
    if (typeof list.reduce === 'function') return _methodReduce(fn, acc, list, 'reduce');
    throw new TypeError('reduce: list must be array or iterable');
}

},{"./_isArrayLike.js":"9cF1E","./_xwrap.js":"8YPBf","../bind.js":"9FzMy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9cF1E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isStringJs = require("./_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 */ var _isArrayLike = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isArrayLike(x) {
    if ((0, _isArrayJsDefault.default)(x)) return true;
    if (!x) return false;
    if (typeof x !== 'object') return false;
    if ((0, _isStringJsDefault.default)(x)) return false;
    if (x.nodeType === 1) return !!x.length;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
exports.default = _isArrayLike;

},{"./_curry1.js":"973zL","./_isArray.js":"lc1D3","./_isString.js":"dtqat","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dtqat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isString);
function _isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YPBf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_xwrap);
var XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function() {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function(acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function _xwrap(fn) {
    return new XWrap(fn);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9FzMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var bind = /*#__PURE__*/ (0, _curry2JsDefault.default)(function bind(fn, thisObj) {
    return (0, _arityJsDefault.default)(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
exports.default = bind;

},{"./internal/_arity.js":"cUJua","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8Onq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XMap.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XMap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var _xmap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xmap(f, xf) {
    return new XMap(f, xf);
});
exports.default = _xmap;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7WEzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isArgumentsJs = require("./internal/_isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
// cover IE < 9 keys issues
var hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable('toString');
var nonEnumerableProps = [
    'constructor',
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/ function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? /*#__PURE__*/ (0, _curry1JsDefault.default)(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ (0, _curry1JsDefault.default)(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = hasArgsEnumBug && (0, _isArgumentsJsDefault.default)(obj);
    for(prop in obj)if ((0, _hasJsDefault.default)(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
    if (hasEnumBug) {
        nIdx = nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = nonEnumerableProps[nIdx];
            if ((0, _hasJsDefault.default)(prop, obj) && !contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
exports.default = keys;

},{"./internal/_curry1.js":"973zL","./internal/_has.js":"lzxBF","./internal/_isArguments.js":"dPYSe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lzxBF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_has);
function _has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dPYSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var toString = Object.prototype.toString;
var _isArguments = /*#__PURE__*/ function() {
    return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return (0, _hasJsDefault.default)('callee', x);
    };
}();
exports.default = _isArguments;

},{"./_has.js":"lzxBF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0KMs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var prop = /*#__PURE__*/ (0, _curry2JsDefault.default)(function prop(p, obj) {
    return (0, _pathJsDefault.default)([
        p
    ], obj);
});
exports.default = prop;

},{"./internal/_curry2.js":"fKiHC","./path.js":"199kS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"199kS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */ var path = /*#__PURE__*/ (0, _curry2JsDefault.default)(function path(paths, obj) {
    var val = obj;
    var idx = 0;
    while(idx < paths.length){
        if (val == null) return;
        val = val[paths[idx]];
        idx += 1;
    }
    return val;
});
exports.default = path;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"14LEy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var reduce = /*#__PURE__*/ (0, _curry3JsDefault.default)((0, _reduceJsDefault.default));
exports.default = reduce;

},{"./internal/_curry3.js":"eXJSk","./internal/_reduce.js":"kZKBe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"17a55":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */ var always = /*#__PURE__*/ (0, _curry1JsDefault.default)(function always(val) {
    return function() {
        return val;
    };
});
exports.default = always;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fNSfi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if it is falsy, otherwise the second argument.
 * @see R.both
 * @example
 *
 *      R.and(true, true); //=> true
 *      R.and(true, false); //=> false
 *      R.and(false, true); //=> false
 *      R.and(false, false); //=> false
 */ var and = /*#__PURE__*/ (0, _curry2JsDefault.default)(function and(a, b) {
    return a && b;
});
exports.default = and;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ilKPm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xanyJs = require("./internal/_xany.js");
var _xanyJsDefault = parcelHelpers.interopDefault(_xanyJs);
/**
 * Returns `true` if at least one of the elements of the list match the predicate,
 * `false` otherwise.
 *
 * Dispatches to the `any` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
 *         otherwise.
 * @see R.all, R.none, R.transduce
 * @example
 *
 *      const lessThan0 = R.flip(R.lt)(0);
 *      const lessThan2 = R.flip(R.lt)(2);
 *      R.any(lessThan0)([1, 2]); //=> false
 *      R.any(lessThan2)([1, 2]); //=> true
 */ var any = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'any'
], (0, _xanyJsDefault.default), function any(fn, list) {
    var idx = 0;
    while(idx < list.length){
        if (fn(list[idx])) return true;
        idx += 1;
    }
    return false;
}));
exports.default = any;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xany.js":"bK02s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bK02s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAny = /*#__PURE__*/ function() {
    function XAny(f, xf) {
        this.xf = xf;
        this.f = f;
        this.any = false;
    }
    XAny.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XAny.prototype['@@transducer/result'] = function(result) {
        if (!this.any) result = this.xf['@@transducer/step'](result, false);
        return this.xf['@@transducer/result'](result);
    };
    XAny.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.any = true;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, true));
        }
        return result;
    };
    return XAny;
}();
var _xany = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xany(f, xf) {
    return new XAny(f, xf);
});
exports.default = _xany;

},{"./_curry2.js":"fKiHC","./_reduced.js":"jCwWa","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hsvdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Takes a list of predicates and returns a predicate that returns true for a
 * given list of arguments if at least one of the provided predicates is
 * satisfied by those arguments.
 *
 * The function returned is a curried function whose arity matches that of the
 * highest-arity predicate.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Logic
 * @sig [(*... -> Boolean)] -> (*... -> Boolean)
 * @param {Array} predicates An array of predicates to check
 * @return {Function} The combined predicate
 * @see R.allPass
 * @example
 *
 *      const isClub = R.propEq('suit', '♣');
 *      const isSpade = R.propEq('suit', '♠');
 *      const isBlackCard = R.anyPass([isClub, isSpade]);
 *
 *      isBlackCard({rank: '10', suit: '♣'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
 *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
 */ var anyPass = /*#__PURE__*/ (0, _curry1JsDefault.default)(function anyPass(preds) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', preds)), function() {
        var idx = 0;
        var len = preds.length;
        while(idx < len){
            if (preds[idx].apply(this, arguments)) return true;
            idx += 1;
        }
        return false;
    });
});
exports.default = anyPass;

},{"./internal/_curry1.js":"973zL","./curryN.js":"jig5V","./max.js":"7Sw8f","./pluck.js":"bKszn","./reduce.js":"14LEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1hv9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the second argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */ var ap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function ap(applyF, applyX) {
    return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function(x) {
        return applyF(x)(applyX(x));
    } : (0, _reduceJsDefault.default)(function(acc, f) {
        return (0, _concatJsDefault.default)(acc, (0, _mapJsDefault.default)(f, applyX));
    }, [], applyF);
});
exports.default = ap;

},{"./internal/_concat.js":"hXJys","./internal/_curry2.js":"fKiHC","./internal/_reduce.js":"kZKBe","./map.js":"6E1l9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i8e9k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _apertureJs = require("./internal/_aperture.js");
var _apertureJsDefault = parcelHelpers.interopDefault(_apertureJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xapertureJs = require("./internal/_xaperture.js");
var _xapertureJsDefault = parcelHelpers.interopDefault(_xapertureJs);
/**
 * Returns a new list, composed of n-tuples of consecutive elements. If `n` is
 * greater than the length of the list, an empty list is returned.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @param {Number} n The size of the tuples to create
 * @param {Array} list The list to split into `n`-length tuples
 * @return {Array} The resulting list of `n`-length tuples
 * @see R.transduce
 * @example
 *
 *      R.aperture(2, [1, 2, 3, 4, 5]); //=> [[1, 2], [2, 3], [3, 4], [4, 5]]
 *      R.aperture(3, [1, 2, 3, 4, 5]); //=> [[1, 2, 3], [2, 3, 4], [3, 4, 5]]
 *      R.aperture(7, [1, 2, 3, 4, 5]); //=> []
 */ var aperture = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xapertureJsDefault.default), (0, _apertureJsDefault.default)));
exports.default = aperture;

},{"./internal/_aperture.js":"96Fv5","./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xaperture.js":"6rxWL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"96Fv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_aperture);
function _aperture(n, list) {
    var idx = 0;
    var limit = list.length - (n - 1);
    var acc = new Array(limit >= 0 ? limit : 0);
    while(idx < limit){
        acc[idx] = Array.prototype.slice.call(list, idx, idx + n);
        idx += 1;
    }
    return acc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6rxWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XAperture = /*#__PURE__*/ function() {
    function XAperture(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XAperture.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XAperture.prototype['@@transducer/result'] = function(result) {
        this.acc = null;
        return this.xf['@@transducer/result'](result);
    };
    XAperture.prototype['@@transducer/step'] = function(result, input) {
        this.store(input);
        return this.full ? this.xf['@@transducer/step'](result, this.getCopy()) : result;
    };
    XAperture.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    XAperture.prototype.getCopy = function() {
        return (0, _concatJsDefault.default)(Array.prototype.slice.call(this.acc, this.pos), Array.prototype.slice.call(this.acc, 0, this.pos));
    };
    return XAperture;
}();
var _xaperture = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xaperture(n, xf) {
    return new XAperture(n, xf);
});
exports.default = _xaperture;

},{"./_concat.js":"hXJys","./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"egZoZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing the contents of the given list, followed by
 * the given element.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The element to add to the end of the new list.
 * @param {Array} list The list of elements to add a new item to.
 *        list.
 * @return {Array} A new list containing the elements of the old list followed by `el`.
 * @see R.prepend
 * @example
 *
 *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
 *      R.append('tests', []); //=> ['tests']
 *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
 */ var append = /*#__PURE__*/ (0, _curry2JsDefault.default)(function append(el, list) {
    return (0, _concatJsDefault.default)(list, [
        el
    ]);
});
exports.default = append;

},{"./internal/_concat.js":"hXJys","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bIQUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Applies function `fn` to the argument list `args`. This is useful for
 * creating a fixed-arity function from a variadic function. `fn` should be a
 * bound function if context is significant.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> a) -> [*] -> a
 * @param {Function} fn The function which will be called with `args`
 * @param {Array} args The arguments to call `fn` with
 * @return {*} result The result, equivalent to `fn(...args)`
 * @see R.call, R.unapply
 * @example
 *
 *      const nums = [1, 2, 3, -99, 42, 6, 7];
 *      R.apply(Math.max, nums); //=> 42
 * @symb R.apply(f, [a, b, c]) = f(a, b, c)
 */ var apply = /*#__PURE__*/ (0, _curry2JsDefault.default)(function apply(fn, args) {
    return fn.apply(this, args);
});
exports.default = apply;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1rqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _applyJs = require("./apply.js");
var _applyJsDefault = parcelHelpers.interopDefault(_applyJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _valuesJs = require("./values.js");
var _valuesJsDefault = parcelHelpers.interopDefault(_valuesJs);
// Use custom mapValues function to avoid issues with specs that include a "map" key and R.map
// delegating calls to .map
function mapValues(fn, obj) {
    return (0, _keysJsDefault.default)(obj).reduce(function(acc, key) {
        acc[key] = fn(obj[key]);
        return acc;
    }, {});
}
/**
 * Given a spec object recursively mapping properties to functions, creates a
 * function producing an object of the same structure, by mapping each property
 * to the result of calling its associated function with the supplied arguments.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig {k: ((a, b, ..., m) -> v)} -> ((a, b, ..., m) -> {k: v})
 * @param {Object} spec an object recursively mapping properties to functions for
 *        producing the values for these properties.
 * @return {Function} A function that returns an object of the same structure
 * as `spec', with each property set to the value returned by calling its
 * associated function with the supplied arguments.
 * @see R.converge, R.juxt
 * @example
 *
 *      const getMetrics = R.applySpec({
 *        sum: R.add,
 *        nested: { mul: R.multiply }
 *      });
 *      getMetrics(2, 4); // => { sum: 6, nested: { mul: 8 } }
 * @symb R.applySpec({ x: f, y: { z: g } })(a, b) = { x: f(a, b), y: { z: g(a, b) } }
 */ var applySpec = /*#__PURE__*/ (0, _curry1JsDefault.default)(function applySpec(spec) {
    spec = mapValues(function(v) {
        return typeof v == 'function' ? v : applySpec(v);
    }, spec);
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', (0, _valuesJsDefault.default)(spec))), function() {
        var args = arguments;
        return mapValues(function(f) {
            return (0, _applyJsDefault.default)(f, args);
        }, spec);
    });
});
exports.default = applySpec;

},{"./internal/_curry1.js":"973zL","./apply.js":"bIQUf","./curryN.js":"jig5V","./max.js":"7Sw8f","./pluck.js":"bKszn","./reduce.js":"14LEy","./keys.js":"7WEzg","./values.js":"X4WCA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"X4WCA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */ var values = /*#__PURE__*/ (0, _curry1JsDefault.default)(function values(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var vals = [];
    var idx = 0;
    while(idx < len){
        vals[idx] = obj[props[idx]];
        idx += 1;
    }
    return vals;
});
exports.default = values;

},{"./internal/_curry1.js":"973zL","./keys.js":"7WEzg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fy2C8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a value and applies a function to it.
 *
 * This function is also known as the `thrush` combinator.
 *
 * @func
 * @memberOf R
 * @since v0.25.0
 * @category Function
 * @sig a -> (a -> b) -> b
 * @param {*} x The value
 * @param {Function} f The function to apply
 * @return {*} The result of applying `f` to `x`
 * @example
 *
 *      const t42 = R.applyTo(42);
 *      t42(R.identity); //=> 42
 *      t42(R.add(1)); //=> 43
 */ var applyTo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function applyTo(x, f) {
    return f(x);
});
exports.default = applyTo;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fPFlQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes an ascending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) < fn(b), `1` if fn(b) < fn(a), otherwise `0`
 * @see R.descend
 * @example
 *
 *      const byAge = R.ascend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByYoungestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var ascend = /*#__PURE__*/ (0, _curry3JsDefault.default)(function ascend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
});
exports.default = ascend;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kx0W3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes a shallow clone of an object, setting or overriding the specified
 * property with the given value. Note that this copies and flattens prototype
 * properties onto the new object as well. All non-primitive properties are
 * copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig String -> a -> {k: v} -> {k: v}
 * @param {String} prop The property name to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except for the changed property.
 * @see R.dissoc, R.pick
 * @example
 *
 *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
 */ var assoc = /*#__PURE__*/ (0, _curry3JsDefault.default)(function assoc(prop, val, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    result[prop] = val;
    return result;
});
exports.default = assoc;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9hyo3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _isNilJs = require("./isNil.js");
var _isNilJsDefault = parcelHelpers.interopDefault(_isNilJs);
/**
 * Makes a shallow clone of an object, setting or overriding the nodes required
 * to create the given path, and placing the specific value at the tail end of
 * that path. Note that this copies and flattens prototype properties onto the
 * new object as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> {a}
 * @param {Array} path the path to set
 * @param {*} val The new value
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original except along the specified path.
 * @see R.dissocPath
 * @example
 *
 *      R.assocPath(['a', 'b', 'c'], 42, {a: {b: {c: 0}}}); //=> {a: {b: {c: 42}}}
 *
 *      // Any missing or non-object keys in path will be overridden
 *      R.assocPath(['a', 'b', 'c'], 42, {a: 5}); //=> {a: {b: {c: 42}}}
 */ var assocPath = /*#__PURE__*/ (0, _curry3JsDefault.default)(function assocPath(path, val, obj) {
    if (path.length === 0) return val;
    var idx = path[0];
    if (path.length > 1) {
        var nextObj = !(0, _isNilJsDefault.default)(obj) && (0, _hasJsDefault.default)(idx, obj) ? obj[idx] : (0, _isIntegerJsDefault.default)(path[1]) ? [] : {};
        val = assocPath(Array.prototype.slice.call(path, 1), val, nextObj);
    }
    if ((0, _isIntegerJsDefault.default)(idx) && (0, _isArrayJsDefault.default)(obj)) {
        var arr = [].concat(obj);
        arr[idx] = val;
        return arr;
    } else return (0, _assocJsDefault.default)(idx, val, obj);
});
exports.default = assocPath;

},{"./internal/_curry3.js":"eXJSk","./internal/_has.js":"lzxBF","./internal/_isArray.js":"lc1D3","./internal/_isInteger.js":"69VMa","./assoc.js":"kx0W3","./isNil.js":"iyj1k","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"69VMa":[function(require,module,exports,__globalThis) {
/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iyj1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */ var isNil = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isNil(x) {
    return x == null;
});
exports.default = isNil;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21HV3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 2 parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> c) -> (a, b -> c)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 2.
 * @see R.nAry, R.unary
 * @example
 *
 *      const takesThreeArgs = function(a, b, c) {
 *        return [a, b, c];
 *      };
 *      takesThreeArgs.length; //=> 3
 *      takesThreeArgs(1, 2, 3); //=> [1, 2, 3]
 *
 *      const takesTwoArgs = R.binary(takesThreeArgs);
 *      takesTwoArgs.length; //=> 2
 *      // Only 2 arguments are passed to the wrapped function
 *      takesTwoArgs(1, 2, 3); //=> [1, 2, undefined]
 * @symb R.binary(f)(a, b, c) = f(a, b)
 */ var binary = /*#__PURE__*/ (0, _curry1JsDefault.default)(function binary(fn) {
    return (0, _nAryJsDefault.default)(2, fn);
});
exports.default = binary;

},{"./internal/_curry1.js":"973zL","./nAry.js":"gUdSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gUdSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly `n` parameters. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} n The desired arity of the new function.
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity `n`.
 * @see R.binary, R.unary
 * @example
 *
 *      const takesTwoArgs = (a, b) => [a, b];
 *
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.nAry(1, takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only `n` arguments are passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.nAry(0, f)(a, b) = f()
 * @symb R.nAry(1, f)(a, b) = f(a)
 * @symb R.nAry(2, f)(a, b) = f(a, b)
 */ var nAry = /*#__PURE__*/ (0, _curry2JsDefault.default)(function nAry(n, fn) {
    switch(n){
        case 0:
            return function() {
                return fn.call(this);
            };
        case 1:
            return function(a0) {
                return fn.call(this, a0);
            };
        case 2:
            return function(a0, a1) {
                return fn.call(this, a0, a1);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.call(this, a0, a1, a2);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.call(this, a0, a1, a2, a3);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.call(this, a0, a1, a2, a3, a4);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.call(this, a0, a1, a2, a3, a4, a5);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
            };
        default:
            throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
    }
});
exports.default = nAry;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7UAF2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _andJs = require("./and.js");
var _andJsDefault = parcelHelpers.interopDefault(_andJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
/**
 * A function which calls the two provided functions and returns the `&&`
 * of the results.
 * It returns the result of the first function if it is false-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * false-y value.
 *
 * In addition to functions, `R.both` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f A predicate
 * @param {Function} g Another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `&&`s their outputs together.
 * @see R.and
 * @example
 *
 *      const gt10 = R.gt(R.__, 10)
 *      const lt20 = R.lt(R.__, 20)
 *      const f = R.both(gt10, lt20);
 *      f(15); //=> true
 *      f(30); //=> false
 *
 *      R.both(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(false)
 *      R.both([false, false, 'a'], [11]); //=> [false, false, 11]
 */ var both = /*#__PURE__*/ (0, _curry2JsDefault.default)(function both(f, g) {
    return (0, _isFunctionJsDefault.default)(f) ? function _both() {
        return f.apply(this, arguments) && g.apply(this, arguments);
    } : (0, _liftJsDefault.default)((0, _andJsDefault.default))(f, g);
});
exports.default = both;

},{"./internal/_curry2.js":"fKiHC","./internal/_isFunction.js":"3UxAP","./and.js":"fNSfi","./lift.js":"4spBG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3UxAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isFunction);
function _isFunction(x) {
    return Object.prototype.toString.call(x) === '[object Function]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4spBG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _liftNJs = require("./liftN.js");
var _liftNJsDefault = parcelHelpers.interopDefault(_liftNJs);
/**
 * "lifts" a function of arity > 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([1,2], [3], [4, 5], [6], [7, 8]); //=> [21, 22, 22, 23, 22, 23, 23, 24]
 */ var lift = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lift(fn) {
    return (0, _liftNJsDefault.default)(fn.length, fn);
});
exports.default = lift;

},{"./internal/_curry1.js":"973zL","./liftN.js":"5Owrg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Owrg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */ var liftN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function liftN(arity, fn) {
    var lifted = (0, _curryNJsDefault.default)(arity, fn);
    return (0, _curryNJsDefault.default)(arity, function() {
        return (0, _reduceJsDefault.default)((0, _apJsDefault.default), (0, _mapJsDefault.default)(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
    });
});
exports.default = liftN;

},{"./internal/_curry2.js":"fKiHC","./internal/_reduce.js":"kZKBe","./ap.js":"1hv9E","./curryN.js":"jig5V","./map.js":"6E1l9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l68m2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
/**
 * Returns the result of calling its first argument with the remaining
 * arguments. This is occasionally useful as a converging function for
 * [`R.converge`](#converge): the first branch can produce a function while the
 * remaining branches produce values to be passed to that function as its
 * arguments.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig (*... -> a),*... -> a
 * @param {Function} fn The function to apply to the remaining arguments.
 * @param {...*} args Any number of positional arguments.
 * @return {*}
 * @see R.apply
 * @example
 *
 *      R.call(R.add, 1, 2); //=> 3
 *
 *      const indentN = R.pipe(R.repeat(' '),
 *                           R.join(''),
 *                           R.replace(/^(?!$)/gm));
 *
 *      const format = R.converge(R.call, [
 *                                  R.pipe(R.prop('indent'), indentN),
 *                                  R.prop('value')
 *                              ]);
 *
 *      format({indent: 2, value: 'foo\nbar\nbaz\n'}); //=> '  foo\n  bar\n  baz\n'
 * @symb R.call(f, a, b) = f(a, b)
 */ var call = /*#__PURE__*/ (0, _curryJsDefault.default)(function call(fn) {
    return fn.apply(this, Array.prototype.slice.call(arguments, 1));
});
exports.default = call;

},{"./curry.js":"2FUaQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2FUaQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var curry = /*#__PURE__*/ (0, _curry1JsDefault.default)(function curry(fn) {
    return (0, _curryNJsDefault.default)(fn.length, fn);
});
exports.default = curry;

},{"./internal/_curry1.js":"973zL","./curryN.js":"jig5V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"349mj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _makeFlatJs = require("./internal/_makeFlat.js");
var _makeFlatJsDefault = parcelHelpers.interopDefault(_makeFlatJs);
var _xchainJs = require("./internal/_xchain.js");
var _xchainJsDefault = parcelHelpers.interopDefault(_xchainJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * `chain` maps a function over a list and concatenates the results. `chain`
 * is also known as `flatMap` in some libraries.
 *
 * Dispatches to the `chain` method of the second argument, if present,
 * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
 *
 * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain m => (a -> m b) -> m a -> m b
 * @param {Function} fn The function to map with
 * @param {Array} list The list to map over
 * @return {Array} The result of flat-mapping `list` with `fn`
 * @example
 *
 *      const duplicate = n => [n, n];
 *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
 *
 *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
 */ var chain = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'fantasy-land/chain',
    'chain'
], (0, _xchainJsDefault.default), function chain(fn, monad) {
    if (typeof monad === 'function') return function(x) {
        return fn(monad(x))(x);
    };
    return (0, _makeFlatJsDefault.default)(false)((0, _mapJsDefault.default)(fn, monad));
}));
exports.default = chain;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_makeFlat.js":"8qgp3","./internal/_xchain.js":"8Xvef","./map.js":"6E1l9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8qgp3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_makeFlat);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
function _makeFlat(recursive) {
    return function flatt(list) {
        var value, jlen, j;
        var result = [];
        var idx = 0;
        var ilen = list.length;
        while(idx < ilen){
            if ((0, _isArrayLikeJsDefault.default)(list[idx])) {
                value = recursive ? flatt(list[idx]) : list[idx];
                j = 0;
                jlen = value.length;
                while(j < jlen){
                    result[result.length] = value[j];
                    j += 1;
                }
            } else result[result.length] = list[idx];
            idx += 1;
        }
        return result;
    };
}

},{"./_isArrayLike.js":"9cF1E","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Xvef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _flatCatJs = require("./_flatCat.js");
var _flatCatJsDefault = parcelHelpers.interopDefault(_flatCatJs);
var _mapJs = require("../map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _xchain = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xchain(f, xf) {
    return (0, _mapJsDefault.default)(f, (0, _flatCatJsDefault.default)(xf));
});
exports.default = _xchain;

},{"./_curry2.js":"fKiHC","./_flatCat.js":"iOH7y","../map.js":"6E1l9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOH7y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _forceReducedJs = require("./_forceReduced.js");
var _forceReducedJsDefault = parcelHelpers.interopDefault(_forceReducedJs);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _reduceJs = require("./_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var preservingReduced = function(xf) {
    return {
        '@@transducer/init': (0, _xfBaseJsDefault.default).init,
        '@@transducer/result': function(result) {
            return xf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            var ret = xf['@@transducer/step'](result, input);
            return ret['@@transducer/reduced'] ? (0, _forceReducedJsDefault.default)(ret) : ret;
        }
    };
};
var _flatCat = function _xcat(xf) {
    var rxf = preservingReduced(xf);
    return {
        '@@transducer/init': (0, _xfBaseJsDefault.default).init,
        '@@transducer/result': function(result) {
            return rxf['@@transducer/result'](result);
        },
        '@@transducer/step': function(result, input) {
            return !(0, _isArrayLikeJsDefault.default)(input) ? (0, _reduceJsDefault.default)(rxf, result, [
                input
            ]) : (0, _reduceJsDefault.default)(rxf, result, input);
        }
    };
};
exports.default = _flatCat;

},{"./_forceReduced.js":"9gt8R","./_isArrayLike.js":"9cF1E","./_reduce.js":"kZKBe","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gt8R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_forceReduced);
function _forceReduced(x) {
    return {
        '@@transducer/value': x,
        '@@transducer/reduced': true
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gCZfw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Restricts a number to be within a range.
 *
 * Also works for other ordered types such as Strings and Dates.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Relation
 * @sig Ord a => a -> a -> a -> a
 * @param {Number} minimum The lower limit of the clamp (inclusive)
 * @param {Number} maximum The upper limit of the clamp (inclusive)
 * @param {Number} value Value to be clamped
 * @return {Number} Returns `minimum` when `val < minimum`, `maximum` when `val > maximum`, returns `val` otherwise
 * @example
 *
 *      R.clamp(1, 10, -5) // => 1
 *      R.clamp(1, 10, 15) // => 10
 *      R.clamp(1, 10, 4)  // => 4
 */ var clamp = /*#__PURE__*/ (0, _curry3JsDefault.default)(function clamp(min, max, value) {
    if (min > max) throw new Error('min must not be greater than max in clamp(min, max, value)');
    return value < min ? min : value > max ? max : value;
});
exports.default = clamp;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k1kLp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a deep copy of the value which may contain (nested) `Array`s and
 * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
 * assigned by reference rather than copied
 *
 * Dispatches to a `clone` method if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {*} -> {*}
 * @param {*} value The object or array to clone
 * @return {*} A deeply cloned copy of `val`
 * @example
 *
 *      const objects = [{}, {}, {}];
 *      const objectsClone = R.clone(objects);
 *      objects === objectsClone; //=> false
 *      objects[0] === objectsClone[0]; //=> false
 */ var clone = /*#__PURE__*/ (0, _curry1JsDefault.default)(function clone(value) {
    return value != null && typeof value.clone === 'function' ? value.clone() : (0, _cloneJsDefault.default)(value, [], [], true);
});
exports.default = clone;

},{"./internal/_clone.js":"dGsJA","./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dGsJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_clone);
var _cloneRegExpJs = require("./_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _typeJs = require("../type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
function _clone(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
        var len = refFrom.length;
        var idx = 0;
        while(idx < len){
            if (value === refFrom[idx]) return refTo[idx];
            idx += 1;
        }
        refFrom[idx + 1] = value;
        refTo[idx + 1] = copiedValue;
        for(var key in value)copiedValue[key] = deep ? _clone(value[key], refFrom, refTo, true) : value[key];
        return copiedValue;
    };
    switch((0, _typeJsDefault.default)(value)){
        case 'Object':
            return copy({});
        case 'Array':
            return copy([]);
        case 'Date':
            return new Date(value.valueOf());
        case 'RegExp':
            return (0, _cloneRegExpJsDefault.default)(value);
        default:
            return value;
    }
}

},{"./_cloneRegExp.js":"b2nDL","../type.js":"8E76F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2nDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_cloneRegExp);
function _cloneRegExp(pattern) {
    return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8E76F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var type = /*#__PURE__*/ (0, _curry1JsDefault.default)(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
exports.default = type;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5HJqp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Makes a comparator function out of a function that reports whether the first
 * element is less than the second.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b) -> Boolean) -> ((a, b) -> Number)
 * @param {Function} pred A predicate function of arity two which will return `true` if the first argument
 * is less than the second, `false` otherwise
 * @return {Function} A Function :: a -> b -> Int that returns `-1` if a < b, `1` if b < a, otherwise `0`
 * @example
 *
 *      const byAge = R.comparator((a, b) => a.age < b.age);
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByIncreasingAge = R.sort(byAge, people);
 *        //=> [{ name: 'Mikhail', age: 62 },{ name: 'Emma', age: 70 }, { name: 'Peter', age: 78 }]
 */ var comparator = /*#__PURE__*/ (0, _curry1JsDefault.default)(function comparator(pred) {
    return function(a, b) {
        return pred(a, b) ? -1 : pred(b, a) ? 1 : 0;
    };
});
exports.default = comparator;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"705Gg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _notJs = require("./not.js");
var _notJsDefault = parcelHelpers.interopDefault(_notJs);
/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      isNil(7); //=> false
 *      isNotNil(7); //=> true
 */ var complement = /*#__PURE__*/ (0, _liftJsDefault.default)((0, _notJsDefault.default));
exports.default = complement;

},{"./lift.js":"4spBG","./not.js":"7kCTe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7kCTe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */ var not = /*#__PURE__*/ (0, _curry1JsDefault.default)(function not(a) {
    return !a;
});
exports.default = not;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"985qM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>compose);
var _pipeJs = require("./pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function compose() {
    if (arguments.length === 0) throw new Error('compose requires at least one argument');
    return (0, _pipeJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./pipe.js":"1xQ3K","./reverse.js":"kusbf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1xQ3K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pipe);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _pipeJs = require("./internal/_pipe.js");
var _pipeJsDefault = parcelHelpers.interopDefault(_pipeJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
function pipe() {
    if (arguments.length === 0) throw new Error('pipe requires at least one argument');
    return (0, _arityJsDefault.default)(arguments[0].length, (0, _reduceJsDefault.default)((0, _pipeJsDefault.default), arguments[0], (0, _tailJsDefault.default)(arguments)));
}

},{"./internal/_arity.js":"cUJua","./internal/_pipe.js":"3OojM","./reduce.js":"14LEy","./tail.js":"3aeWe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3OojM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_pipe);
function _pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3aeWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var tail = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('tail', /*#__PURE__*/ (0, _sliceJsDefault.default)(1, Infinity)));
exports.default = tail;

},{"./internal/_checkForMethod.js":"5zr8J","./internal/_curry1.js":"973zL","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5zr8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_checkForMethod);
var _isArrayJs = require("./_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
function _checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, _isArrayJsDefault.default)(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}

},{"./_isArray.js":"lc1D3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWLR6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var slice = /*#__PURE__*/ (0, _curry3JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
exports.default = slice;

},{"./internal/_checkForMethod.js":"5zr8J","./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kusbf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns a new list or string with the elements or characters in reverse
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {Array|String} list
 * @return {Array|String}
 * @example
 *
 *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
 *      R.reverse([1, 2]);     //=> [2, 1]
 *      R.reverse([1]);        //=> [1]
 *      R.reverse([]);         //=> []
 *
 *      R.reverse('abc');      //=> 'cba'
 *      R.reverse('ab');       //=> 'ba'
 *      R.reverse('a');        //=> 'a'
 *      R.reverse('');         //=> ''
 */ var reverse = /*#__PURE__*/ (0, _curry1JsDefault.default)(function reverse(list) {
    return (0, _isStringJsDefault.default)(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
});
exports.default = reverse;

},{"./internal/_curry1.js":"973zL","./internal/_isString.js":"dtqat","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fmXwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeK);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
function composeK() {
    if (arguments.length === 0) throw new Error('composeK requires at least one argument');
    var init = Array.prototype.slice.call(arguments);
    var last = init.pop();
    return (0, _composeJsDefault.default)((0, _composeJsDefault.default).apply(this, (0, _mapJsDefault.default)((0, _chainJsDefault.default), init)), last);
}

},{"./chain.js":"349mj","./compose.js":"985qM","./map.js":"6E1l9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eE6e1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>composeP);
var _pipePJs = require("./pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function composeP() {
    if (arguments.length === 0) throw new Error('composeP requires at least one argument');
    return (0, _pipePJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./pipeP.js":"3xYh3","./reverse.js":"kusbf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3xYh3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pipeP);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _pipePJs = require("./internal/_pipeP.js");
var _pipePJsDefault = parcelHelpers.interopDefault(_pipePJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
function pipeP() {
    if (arguments.length === 0) throw new Error('pipeP requires at least one argument');
    return (0, _arityJsDefault.default)(arguments[0].length, (0, _reduceJsDefault.default)((0, _pipePJsDefault.default), arguments[0], (0, _tailJsDefault.default)(arguments)));
}

},{"./internal/_arity.js":"cUJua","./internal/_pipeP.js":"d6roX","./reduce.js":"14LEy","./tail.js":"3aeWe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d6roX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_pipeP);
function _pipeP(f, g) {
    return function() {
        var ctx = this;
        return f.apply(ctx, arguments).then(function(x) {
            return g.call(ctx, x);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7corr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _pipeWithJs = require("./pipeWith.js");
var _pipeWithJsDefault = parcelHelpers.interopDefault(_pipeWithJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
/**
 * Performs right-to-left function composition using transforming function. The rightmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of compose is not automatically curried.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((* -> *), [(y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} ...functions The functions to compose
 * @return {Function}
 * @see R.compose, R.pipeWith
 * @example
 *
 *      const composeWhileNotNil = R.composeWith((f, res) => R.isNil(res) ? res : f(res));
 *
 *      composeWhileNotNil([R.inc, R.prop('age')])({age: 1}) //=> 2
 *      composeWhileNotNil([R.inc, R.prop('age')])({}) //=> undefined
 *
 * @symb R.composeWith(f)([g, h, i])(...args) = f(g, f(h, f(i, ...args)))
 */ var composeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function composeWith(xf, list) {
    return (0, _pipeWithJsDefault.default).apply(this, [
        xf,
        (0, _reverseJsDefault.default)(list)
    ]);
});
exports.default = composeWith;

},{"./internal/_curry2.js":"fKiHC","./pipeWith.js":"gRDu4","./reverse.js":"kusbf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gRDu4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _headJs = require("./head.js");
var _headJsDefault = parcelHelpers.interopDefault(_headJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _tailJs = require("./tail.js");
var _tailJsDefault = parcelHelpers.interopDefault(_tailJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * Performs left-to-right function composition using transforming function. The leftmost function may have
 * any arity; the remaining functions must be unary.
 *
 * **Note:** The result of pipeWith is not automatically curried.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((* -> *), [((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)]) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.composeWith, R.pipe
 * @example
 *
 *      const pipeWhileNotNil = R.pipeWith((f, res) => R.isNil(res) ? res : f(res));
 *      const f = pipeWhileNotNil([Math.pow, R.negate, R.inc])
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipeWith(f)([g, h, i])(...args) = f(i, f(h, f(g, ...args)))
 */ var pipeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pipeWith(xf, list) {
    if (list.length <= 0) return 0, _identityJsDefault.default;
    var headList = (0, _headJsDefault.default)(list);
    var tailList = (0, _tailJsDefault.default)(list);
    return (0, _arityJsDefault.default)(headList.length, function() {
        return (0, _reduceJsDefault.default)(function(result, f) {
            return xf.call(this, f, result);
        }, headList.apply(this, arguments), tailList);
    });
});
exports.default = pipeWith;

},{"./internal/_arity.js":"cUJua","./internal/_curry2.js":"fKiHC","./head.js":"fHb0C","./internal/_reduce.js":"kZKBe","./tail.js":"3aeWe","./identity.js":"4xoG2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fHb0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns the first element of the given list or string. In some libraries
 * this function is named `first`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {Array|String} list
 * @return {*}
 * @see R.tail, R.init, R.last
 * @example
 *
 *      R.head(['fi', 'fo', 'fum']); //=> 'fi'
 *      R.head([]); //=> undefined
 *
 *      R.head('abc'); //=> 'a'
 *      R.head(''); //=> ''
 */ var head = /*#__PURE__*/ (0, _nthJsDefault.default)(0);
exports.default = head;

},{"./nth.js":"7AaSQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7AaSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */ var nth = /*#__PURE__*/ (0, _curry2JsDefault.default)(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return (0, _isStringJsDefault.default)(list) ? list.charAt(idx) : list[idx];
});
exports.default = nth;

},{"./internal/_curry2.js":"fKiHC","./internal/_isString.js":"dtqat","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4xoG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _identityJs = require("./internal/_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
/**
 * A function that does nothing but return the parameter supplied to it. Good
 * as a default or placeholder function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> a
 * @param {*} x The value to return.
 * @return {*} The input value, `x`.
 * @example
 *
 *      R.identity(1); //=> 1
 *
 *      const obj = {};
 *      R.identity(obj) === obj; //=> true
 * @symb R.identity(a) = a
 */ var identity = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _identityJsDefault.default));
exports.default = identity;

},{"./internal/_curry1.js":"973zL","./internal/_identity.js":"guYHv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"guYHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_identity);
function _identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8EMJt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Returns the result of concatenating the given lists or strings.
 *
 * Note: `R.concat` expects both arguments to be of the same type,
 * unlike the native `Array.prototype.concat` method. It will throw
 * an error if you `concat` an Array with a non-Array value.
 *
 * Dispatches to the `concat` method of the first argument, if present.
 * Can also concatenate two members of a [fantasy-land
 * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @sig String -> String -> String
 * @param {Array|String} firstList The first list
 * @param {Array|String} secondList The second list
 * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
 * `secondList`.
 *
 * @example
 *
 *      R.concat('ABC', 'DEF'); // 'ABCDEF'
 *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 *      R.concat([], []); //=> []
 */ var concat = /*#__PURE__*/ (0, _curry2JsDefault.default)(function concat(a, b) {
    if ((0, _isArrayJsDefault.default)(a)) {
        if ((0, _isArrayJsDefault.default)(b)) return a.concat(b);
        throw new TypeError((0, _toStringJsDefault.default)(b) + ' is not an array');
    }
    if ((0, _isStringJsDefault.default)(a)) {
        if ((0, _isStringJsDefault.default)(b)) return a + b;
        throw new TypeError((0, _toStringJsDefault.default)(b) + ' is not a string');
    }
    if (a != null && (0, _isFunctionJsDefault.default)(a['fantasy-land/concat'])) return a['fantasy-land/concat'](b);
    if (a != null && (0, _isFunctionJsDefault.default)(a.concat)) return a.concat(b);
    throw new TypeError((0, _toStringJsDefault.default)(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
});
exports.default = concat;

},{"./internal/_curry2.js":"fKiHC","./internal/_isArray.js":"lc1D3","./internal/_isFunction.js":"3UxAP","./internal/_isString.js":"dtqat","./toString.js":"fffBR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fffBR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _toStringJs = require("./internal/_toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */ var toString = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toString(val) {
    return (0, _toStringJsDefault.default)(val, []);
});
exports.default = toString;

},{"./internal/_curry1.js":"973zL","./internal/_toString.js":"4cnPl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4cnPl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toString);
var _includesJs = require("./_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _mapJs = require("./_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _quoteJs = require("./_quote.js");
var _quoteJsDefault = parcelHelpers.interopDefault(_quoteJs);
var _toISOStringJs = require("./_toISOString.js");
var _toISOStringJsDefault = parcelHelpers.interopDefault(_toISOStringJs);
var _keysJs = require("../keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _rejectJs = require("../reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
function _toString(x, seen) {
    var recur = function recur(y) {
        var xs = seen.concat([
            x
        ]);
        return (0, _includesJsDefault.default)(y, xs) ? '<Circular>' : _toString(y, xs);
    };
    //  mapPairs :: (Object, [String]) -> [String]
    var mapPairs = function(obj, keys) {
        return (0, _mapJsDefault.default)(function(k) {
            return (0, _quoteJsDefault.default)(k) + ': ' + recur(obj[k]);
        }, keys.slice().sort());
    };
    switch(Object.prototype.toString.call(x)){
        case '[object Arguments]':
            return '(function() { return arguments; }(' + (0, _mapJsDefault.default)(recur, x).join(', ') + '))';
        case '[object Array]':
            return '[' + (0, _mapJsDefault.default)(recur, x).concat(mapPairs(x, (0, _rejectJsDefault.default)(function(k) {
                return /^\d+$/.test(k);
            }, (0, _keysJsDefault.default)(x)))).join(', ') + ']';
        case '[object Boolean]':
            return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();
        case '[object Date]':
            return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : (0, _quoteJsDefault.default)((0, _toISOStringJsDefault.default)(x))) + ')';
        case '[object Null]':
            return 'null';
        case '[object Number]':
            return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);
        case '[object String]':
            return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : (0, _quoteJsDefault.default)(x);
        case '[object Undefined]':
            return 'undefined';
        default:
            if (typeof x.toString === 'function') {
                var repr = x.toString();
                if (repr !== '[object Object]') return repr;
            }
            return '{' + mapPairs(x, (0, _keysJsDefault.default)(x)).join(', ') + '}';
    }
}

},{"./_includes.js":"hfNgu","./_map.js":"9apIE","./_quote.js":"ivWCt","./_toISOString.js":"ckGta","../keys.js":"7WEzg","../reject.js":"4OIPW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hfNgu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_includes);
var _indexOfJs = require("./_indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
function _includes(a, list) {
    return (0, _indexOfJsDefault.default)(list, a, 0) >= 0;
}

},{"./_indexOf.js":"7KvCu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7KvCu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_indexOf);
var _equalsJs = require("../equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
function _indexOf(list, a, idx) {
    var inf, item;
    // Array.prototype.indexOf doesn't exist below IE9
    if (typeof list.indexOf === 'function') switch(typeof a){
        case 'number':
            if (a === 0) {
                // manually crawl the list to distinguish between +0 and -0
                inf = 1 / a;
                while(idx < list.length){
                    item = list[idx];
                    if (item === 0 && 1 / item === inf) return idx;
                    idx += 1;
                }
                return -1;
            } else if (a !== a) {
                // NaN
                while(idx < list.length){
                    item = list[idx];
                    if (typeof item === 'number' && item !== item) return idx;
                    idx += 1;
                }
                return -1;
            }
            // non-zero numbers can utilise Set
            return list.indexOf(a, idx);
        // all these types can utilise Set
        case 'string':
        case 'boolean':
        case 'function':
        case 'undefined':
            return list.indexOf(a, idx);
        case 'object':
            if (a === null) // null can utilise Set
            return list.indexOf(a, idx);
    }
    // anything else not covered above, defer to R.equals
    while(idx < list.length){
        if ((0, _equalsJsDefault.default)(list[idx], a)) return idx;
        idx += 1;
    }
    return -1;
}

},{"../equals.js":"90ObX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"90ObX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./internal/_equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */ var equals = /*#__PURE__*/ (0, _curry2JsDefault.default)(function equals(a, b) {
    return (0, _equalsJsDefault.default)(a, b, [], []);
});
exports.default = equals;

},{"./internal/_curry2.js":"fKiHC","./internal/_equals.js":"igIkY","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"igIkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_equals);
var _arrayFromIteratorJs = require("./_arrayFromIterator.js");
var _arrayFromIteratorJsDefault = parcelHelpers.interopDefault(_arrayFromIteratorJs);
var _includesWithJs = require("./_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _functionNameJs = require("./_functionName.js");
var _functionNameJsDefault = parcelHelpers.interopDefault(_functionNameJs);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _objectIsJs = require("./_objectIs.js");
var _objectIsJsDefault = parcelHelpers.interopDefault(_objectIsJs);
var _keysJs = require("../keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
var _typeJs = require("../type.js");
var _typeJsDefault = parcelHelpers.interopDefault(_typeJs);
/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparision of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */ function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = (0, _arrayFromIteratorJsDefault.default)(aIterator);
    var b = (0, _arrayFromIteratorJsDefault.default)(bIterator);
    function eq(_a, _b) {
        return _equals(_a, _b, stackA.slice(), stackB.slice());
    }
    // if *a* array contains any element that is not included in *b*
    return !(0, _includesWithJsDefault.default)(function(b, aItem) {
        return !(0, _includesWithJsDefault.default)(eq, aItem, b);
    }, b, a);
}
function _equals(a, b, stackA, stackB) {
    if ((0, _objectIsJsDefault.default)(a, b)) return true;
    var typeA = (0, _typeJsDefault.default)(a);
    if (typeA !== (0, _typeJsDefault.default)(b)) return false;
    if (a == null || b == null) return false;
    if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
    if (typeof a.equals === 'function' || typeof b.equals === 'function') return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
    switch(typeA){
        case 'Arguments':
        case 'Array':
        case 'Object':
            if (typeof a.constructor === 'function' && (0, _functionNameJsDefault.default)(a.constructor) === 'Promise') return a === b;
            break;
        case 'Boolean':
        case 'Number':
        case 'String':
            if (!(typeof a === typeof b && (0, _objectIsJsDefault.default)(a.valueOf(), b.valueOf()))) return false;
            break;
        case 'Date':
            if (!(0, _objectIsJsDefault.default)(a.valueOf(), b.valueOf())) return false;
            break;
        case 'Error':
            return a.name === b.name && a.message === b.message;
        case 'RegExp':
            if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) return false;
            break;
    }
    var idx = stackA.length - 1;
    while(idx >= 0){
        if (stackA[idx] === a) return stackB[idx] === b;
        idx -= 1;
    }
    switch(typeA){
        case 'Map':
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Set':
            if (a.size !== b.size) return false;
            return _uniqContentEquals(a.values(), b.values(), stackA.concat([
                a
            ]), stackB.concat([
                b
            ]));
        case 'Arguments':
        case 'Array':
        case 'Object':
        case 'Boolean':
        case 'Number':
        case 'String':
        case 'Date':
        case 'Error':
        case 'RegExp':
        case 'Int8Array':
        case 'Uint8Array':
        case 'Uint8ClampedArray':
        case 'Int16Array':
        case 'Uint16Array':
        case 'Int32Array':
        case 'Uint32Array':
        case 'Float32Array':
        case 'Float64Array':
        case 'ArrayBuffer':
            break;
        default:
            // Values of other types are only equal if identical.
            return false;
    }
    var keysA = (0, _keysJsDefault.default)(a);
    if (keysA.length !== (0, _keysJsDefault.default)(b).length) return false;
    var extendedStackA = stackA.concat([
        a
    ]);
    var extendedStackB = stackB.concat([
        b
    ]);
    idx = keysA.length - 1;
    while(idx >= 0){
        var key = keysA[idx];
        if (!((0, _hasJsDefault.default)(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) return false;
        idx -= 1;
    }
    return true;
}

},{"./_arrayFromIterator.js":"font3","./_includesWith.js":"hGCJ4","./_functionName.js":"bPQlg","./_has.js":"lzxBF","./_objectIs.js":"iUeOr","../keys.js":"7WEzg","../type.js":"8E76F","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"font3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayFromIterator);
function _arrayFromIterator(iter) {
    var list = [];
    var next;
    while(!(next = iter.next()).done)list.push(next.value);
    return list;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hGCJ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_includesWith);
function _includesWith(pred, x, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (pred(x, list[idx])) return true;
        idx += 1;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPQlg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_functionName);
function _functionName(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? '' : match[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iUeOr":[function(require,module,exports,__globalThis) {
// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function _objectIs(a, b) {
    // SameValue algorithm
    if (a === b) // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
    else // Step 6.a: NaN == NaN
    return a !== a && b !== b;
}
exports.default = typeof Object.is === 'function' ? Object.is : _objectIs;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivWCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_quote);
function _quote(s) {
    var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
    return '"' + escaped.replace(/"/g, '\\"') + '"';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ckGta":[function(require,module,exports,__globalThis) {
/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var pad = function pad(n) {
    return (n < 10 ? '0' : '') + n;
};
var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
    return d.toISOString();
} : function _toISOString(d) {
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};
exports.default = _toISOString;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4OIPW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _complementJs = require("./internal/_complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 === 1;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var reject = /*#__PURE__*/ (0, _curry2JsDefault.default)(function reject(pred, filterable) {
    return (0, _filterJsDefault.default)((0, _complementJsDefault.default)(pred), filterable);
});
exports.default = reject;

},{"./internal/_complement.js":"lDJPC","./internal/_curry2.js":"fKiHC","./filter.js":"kidP8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lDJPC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_complement);
function _complement(f) {
    return function() {
        return !f.apply(this, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kidP8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfilterJs = require("./internal/_xfilter.js");
var _xfilterJsDefault = parcelHelpers.interopDefault(_xfilterJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */ var filter = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'filter'
], (0, _xfilterJsDefault.default), function(pred, filterable) {
    return (0, _isObjectJsDefault.default)(filterable) ? (0, _reduceJsDefault.default)(function(acc, key) {
        if (pred(filterable[key])) acc[key] = filterable[key];
        return acc;
    }, {}, (0, _keysJsDefault.default)(filterable)) : // else
    (0, _filterJsDefault.default)(pred, filterable);
}));
exports.default = filter;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_filter.js":"cCJ2i","./internal/_isObject.js":"1GAHA","./internal/_reduce.js":"kZKBe","./internal/_xfilter.js":"gKYRX","./keys.js":"7WEzg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cCJ2i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_filter);
function _filter(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    while(idx < len){
        if (fn(list[idx])) result[result.length] = list[idx];
        idx += 1;
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1GAHA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isObject);
function _isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gKYRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFilter = /*#__PURE__*/ function() {
    function XFilter(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFilter.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFilter.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XFilter.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
    };
    return XFilter;
}();
var _xfilter = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfilter(f, xf) {
    return new XFilter(f, xf);
});
exports.default = _xfilter;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6yEqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */ var cond = /*#__PURE__*/ (0, _curry1JsDefault.default)(function cond(pairs) {
    var arity = (0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _mapJsDefault.default)(function(pair) {
        return pair[0].length;
    }, pairs));
    return (0, _arityJsDefault.default)(arity, function() {
        var idx = 0;
        while(idx < pairs.length){
            if (pairs[idx][0].apply(this, arguments)) return pairs[idx][1].apply(this, arguments);
            idx += 1;
        }
    });
});
exports.default = cond;

},{"./internal/_arity.js":"cUJua","./internal/_curry1.js":"973zL","./map.js":"6E1l9","./max.js":"7Sw8f","./reduce.js":"14LEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"csTEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _constructNJs = require("./constructN.js");
var _constructNJsDefault = parcelHelpers.interopDefault(_constructNJs);
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> {*}) -> (* -> {*})
 * @param {Function} fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @see R.invoker
 * @example
 *
 *      // Constructor function
 *      function Animal(kind) {
 *        this.kind = kind;
 *      };
 *      Animal.prototype.sighting = function() {
 *        return "It's a " + this.kind + "!";
 *      }
 *
 *      const AnimalConstructor = R.construct(Animal)
 *
 *      // Notice we no longer need the 'new' keyword:
 *      AnimalConstructor('Pig'); //=> {"kind": "Pig", "sighting": function (){...}};
 *
 *      const animalTypes = ["Lion", "Tiger", "Bear"];
 *      const animalSighting = R.invoker(0, 'sighting');
 *      const sightNewAnimal = R.compose(animalSighting, AnimalConstructor);
 *      R.map(sightNewAnimal, animalTypes); //=> ["It's a Lion!", "It's a Tiger!", "It's a Bear!"]
 */ var construct = /*#__PURE__*/ (0, _curry1JsDefault.default)(function construct(Fn) {
    return (0, _constructNJsDefault.default)(Fn.length, Fn);
});
exports.default = construct;

},{"./internal/_curry1.js":"973zL","./constructN.js":"eVfMO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eVfMO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryJs = require("./curry.js");
var _curryJsDefault = parcelHelpers.interopDefault(_curryJs);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a constructor function inside a curried function that can be called
 * with the same arguments and returns the same type. The arity of the function
 * returned is specified to allow using variadic constructor functions.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Function
 * @sig Number -> (* -> {*}) -> (* -> {*})
 * @param {Number} n The arity of the constructor function.
 * @param {Function} Fn The constructor function to wrap.
 * @return {Function} A wrapped, curried constructor function.
 * @example
 *
 *      // Variadic Constructor function
 *      function Salad() {
 *        this.ingredients = arguments;
 *      }
 *
 *      Salad.prototype.recipe = function() {
 *        const instructions = R.map(ingredient => 'Add a dollop of ' + ingredient, this.ingredients);
 *        return R.join('\n', instructions);
 *      };
 *
 *      const ThreeLayerSalad = R.constructN(3, Salad);
 *
 *      // Notice we no longer need the 'new' keyword, and the constructor is curried for 3 arguments.
 *      const salad = ThreeLayerSalad('Mayonnaise')('Potato Chips')('Ketchup');
 *
 *      console.log(salad.recipe());
 *      // Add a dollop of Mayonnaise
 *      // Add a dollop of Potato Chips
 *      // Add a dollop of Ketchup
 */ var constructN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function constructN(n, Fn) {
    if (n > 10) throw new Error('Constructor with greater than ten arguments');
    if (n === 0) return function() {
        return new Fn();
    };
    return (0, _curryJsDefault.default)((0, _nAryJsDefault.default)(n, function($0, $1, $2, $3, $4, $5, $6, $7, $8, $9) {
        switch(arguments.length){
            case 1:
                return new Fn($0);
            case 2:
                return new Fn($0, $1);
            case 3:
                return new Fn($0, $1, $2);
            case 4:
                return new Fn($0, $1, $2, $3);
            case 5:
                return new Fn($0, $1, $2, $3, $4);
            case 6:
                return new Fn($0, $1, $2, $3, $4, $5);
            case 7:
                return new Fn($0, $1, $2, $3, $4, $5, $6);
            case 8:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7);
            case 9:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8);
            case 10:
                return new Fn($0, $1, $2, $3, $4, $5, $6, $7, $8, $9);
        }
    }));
});
exports.default = constructN;

},{"./internal/_curry2.js":"fKiHC","./curry.js":"2FUaQ","./nAry.js":"gUdSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cvc7D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.includes
 * @deprecated since v0.26.0
 * @example
 *
 *      R.contains(3, [1, 2, 3]); //=> true
 *      R.contains(4, [1, 2, 3]); //=> false
 *      R.contains({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.contains([42], [[42]]); //=> true
 *      R.contains('ba', 'banana'); //=>true
 */ var contains = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _includesJsDefault.default));
exports.default = contains;

},{"./internal/_includes.js":"hfNgu","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a3HDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _maxJs = require("./max.js");
var _maxJsDefault = parcelHelpers.interopDefault(_maxJs);
var _pluckJs = require("./pluck.js");
var _pluckJsDefault = parcelHelpers.interopDefault(_pluckJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Accepts a converging function and a list of branching functions and returns
 * a new function. The arity of the new function is the same as the arity of
 * the longest branching function. When invoked, this new function is applied
 * to some arguments, and each branching function is applied to those same
 * arguments. The results of each branching function are passed as arguments
 * to the converging function to produce the return value.
 *
 * @func
 * @memberOf R
 * @since v0.4.2
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} after A function. `after` will be invoked with the return values of
 *        `fn1` and `fn2` as its arguments.
 * @param {Array} functions A list of functions.
 * @return {Function} A new function.
 * @see R.useWith
 * @example
 *
 *      const average = R.converge(R.divide, [R.sum, R.length])
 *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
 *
 *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
 *      strangeConcat("Yodel") //=> "YODELyodel"
 *
 * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
 */ var converge = /*#__PURE__*/ (0, _curry2JsDefault.default)(function converge(after, fns) {
    return (0, _curryNJsDefault.default)((0, _reduceJsDefault.default)((0, _maxJsDefault.default), 0, (0, _pluckJsDefault.default)('length', fns)), function() {
        var args = arguments;
        var context = this;
        return after.apply(context, (0, _mapJsDefault.default)(function(fn) {
            return fn.apply(context, args);
        }, fns));
    });
});
exports.default = converge;

},{"./internal/_curry2.js":"fKiHC","./internal/_map.js":"9apIE","./curryN.js":"jig5V","./max.js":"7Sw8f","./pluck.js":"bKszn","./reduce.js":"14LEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tATF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Counts the elements of a list according to how many match each value of a
 * key generated by the supplied function. Returns an object mapping the keys
 * produced by `fn` to the number of occurrences in the list. Note that all
 * keys are coerced to strings because of how JavaScript objects work.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig (a -> String) -> [a] -> {*}
 * @param {Function} fn The function used to map values to keys.
 * @param {Array} list The list to count elements from.
 * @return {Object} An object mapping keys to number of occurrences in the list.
 * @example
 *
 *      const numbers = [1.0, 1.1, 1.2, 2.0, 3.0, 2.2];
 *      R.countBy(Math.floor)(numbers);    //=> {'1': 3, '2': 2, '3': 1}
 *
 *      const letters = ['a', 'b', 'A', 'a', 'B', 'c'];
 *      R.countBy(R.toLower)(letters);   //=> {'a': 3, 'b': 2, 'c': 1}
 */ var countBy = /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, elem) {
    return acc + 1;
}, 0);
exports.default = countBy;

},{"./reduceBy.js":"4hpJN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4hpJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xreduceByJs = require("./internal/_xreduceBy.js");
var _xreduceByJsDefault = parcelHelpers.interopDefault(_xreduceByJs);
/**
 * Groups the elements of the list according to the result of calling
 * the String-returning function `keyFn` on each element and reduces the elements
 * of each group to a single value via the reducer function `valueFn`.
 *
 * This function is basically a more general [`groupBy`](#groupBy) function.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category List
 * @sig ((a, b) -> a) -> a -> (b -> String) -> [b] -> {String: a}
 * @param {Function} valueFn The function that reduces the elements of each group to a single
 *        value. Receives two values, accumulator for a particular group and the current element.
 * @param {*} acc The (initial) accumulator value for each group.
 * @param {Function} keyFn The function that maps the list's element into a key.
 * @param {Array} list The array to group.
 * @return {Object} An object with the output of `keyFn` for keys, mapped to the output of
 *         `valueFn` for elements which produced that key when passed to `keyFn`.
 * @see R.groupBy, R.reduce
 * @example
 *
 *      const groupNames = (acc, {name}) => acc.concat(name)
 *      const toGrade = ({score}) =>
 *        score < 65 ? 'F' :
 *        score < 70 ? 'D' :
 *        score < 80 ? 'C' :
 *        score < 90 ? 'B' : 'A'
 *
 *      var students = [
 *        {name: 'Abby', score: 83},
 *        {name: 'Bart', score: 62},
 *        {name: 'Curt', score: 88},
 *        {name: 'Dora', score: 92},
 *      ]
 *
 *      reduceBy(groupNames, [], toGrade, students)
 *      //=> {"A": ["Dora"], "B": ["Abby", "Curt"], "F": ["Bart"]}
 */ var reduceBy = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], /*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xreduceByJsDefault.default), function reduceBy(valueFn, valueAcc, keyFn, list) {
    return (0, _reduceJsDefault.default)(function(acc, elt) {
        var key = keyFn(elt);
        acc[key] = valueFn((0, _hasJsDefault.default)(key, acc) ? acc[key] : valueAcc, elt);
        return acc;
    }, {}, list);
}));
exports.default = reduceBy;

},{"./internal/_curryN.js":"8fWG3","./internal/_dispatchable.js":"f1aoQ","./internal/_has.js":"lzxBF","./internal/_reduce.js":"kZKBe","./internal/_xreduceBy.js":"9B9Qz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9B9Qz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XReduceBy = /*#__PURE__*/ function() {
    function XReduceBy(valueFn, valueAcc, keyFn, xf) {
        this.valueFn = valueFn;
        this.valueAcc = valueAcc;
        this.keyFn = keyFn;
        this.xf = xf;
        this.inputs = {};
    }
    XReduceBy.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XReduceBy.prototype['@@transducer/result'] = function(result) {
        var key;
        for(key in this.inputs)if ((0, _hasJsDefault.default)(key, this.inputs)) {
            result = this.xf['@@transducer/step'](result, this.inputs[key]);
            if (result['@@transducer/reduced']) {
                result = result['@@transducer/value'];
                break;
            }
        }
        this.inputs = null;
        return this.xf['@@transducer/result'](result);
    };
    XReduceBy.prototype['@@transducer/step'] = function(result, input) {
        var key = this.keyFn(input);
        this.inputs[key] = this.inputs[key] || [
            key,
            this.valueAcc
        ];
        this.inputs[key][1] = this.valueFn(this.inputs[key][1], input);
        return result;
    };
    return XReduceBy;
}();
var _xreduceBy = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], function _xreduceBy(valueFn, valueAcc, keyFn, xf) {
    return new XReduceBy(valueFn, valueAcc, keyFn, xf);
});
exports.default = _xreduceBy;

},{"./_curryN.js":"8fWG3","./_has.js":"lzxBF","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9lcQr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
/**
 * Decrements its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n - 1
 * @see R.inc
 * @example
 *
 *      R.dec(42); //=> 41
 */ var dec = /*#__PURE__*/ (0, _addJsDefault.default)(-1);
exports.default = dec;

},{"./add.js":"49LDq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j7d9y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the second argument if it is not `null`, `undefined` or `NaN`;
 * otherwise the first argument is returned.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {a} default The default value.
 * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
 * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
 * @example
 *
 *      const defaultTo42 = R.defaultTo(42);
 *
 *      defaultTo42(null);  //=> 42
 *      defaultTo42(undefined);  //=> 42
 *      defaultTo42(false);  //=> false
 *      defaultTo42('Ramda');  //=> 'Ramda'
 *      // parseInt('string') results in NaN
 *      defaultTo42(parseInt('string')); //=> 42
 */ var defaultTo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
});
exports.default = defaultTo;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gQxWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Makes a descending comparator function out of a function that returns a value
 * that can be compared with `<` and `>`.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Function
 * @sig Ord b => (a -> b) -> a -> a -> Number
 * @param {Function} fn A function of arity one that returns a value that can be compared
 * @param {*} a The first item to be compared.
 * @param {*} b The second item to be compared.
 * @return {Number} `-1` if fn(a) > fn(b), `1` if fn(b) > fn(a), otherwise `0`
 * @see R.ascend
 * @example
 *
 *      const byAge = R.descend(R.prop('age'));
 *      const people = [
 *        { name: 'Emma', age: 70 },
 *        { name: 'Peter', age: 78 },
 *        { name: 'Mikhail', age: 62 },
 *      ];
 *      const peopleByOldestFirst = R.sort(byAge, people);
 *        //=> [{ name: 'Peter', age: 78 }, { name: 'Emma', age: 70 }, { name: 'Mikhail', age: 62 }]
 */ var descend = /*#__PURE__*/ (0, _curry3JsDefault.default)(function descend(fn, a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa > bb ? -1 : aa < bb ? 1 : 0;
});
exports.default = descend;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kOL0M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _setJs = require("./internal/_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Objects and Arrays are compared in terms of
 * value equality, not reference equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.differenceWith, R.symmetricDifference, R.symmetricDifferenceWith, R.without
 * @example
 *
 *      R.difference([1,2,3,4], [7,6,5,4,3]); //=> [1,2]
 *      R.difference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5]
 *      R.difference([{a: 1}, {b: 2}], [{a: 1}, {c: 3}]) //=> [{b: 2}]
 */ var difference = /*#__PURE__*/ (0, _curry2JsDefault.default)(function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new (0, _setJsDefault.default)();
    for(var i = 0; i < secondLen; i += 1)toFilterOut.add(second[i]);
    while(idx < firstLen){
        if (toFilterOut.add(first[idx])) out[out.length] = first[idx];
        idx += 1;
    }
    return out;
});
exports.default = difference;

},{"./internal/_curry2.js":"fKiHC","./internal/_Set.js":"bPI3B","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPI3B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _Set = /*#__PURE__*/ function() {
    function _Set() {
        /* globals Set */ this._nativeSet = typeof Set === 'function' ? new Set() : null;
        this._items = {};
    }
    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function(item) {
        return !hasOrAdd(item, true, this);
    };
    //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //
    _Set.prototype.has = function(item) {
        return hasOrAdd(item, false, this);
    };
    //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //
    return _Set;
}();
function hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;
    switch(type){
        case 'string':
        case 'number':
            // distinguish between +0 and -0
            if (item === 0 && 1 / item === -Infinity) {
                if (set._items['-0']) return true;
                else {
                    if (shouldAdd) set._items['-0'] = true;
                    return false;
                }
            }
            // these types can all utilise the native Set
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) {
                        set._items[type] = {};
                        set._items[type][item] = true;
                    }
                    return false;
                } else if (item in set._items[type]) return true;
                else {
                    if (shouldAdd) set._items[type][item] = true;
                    return false;
                }
            }
        case 'boolean':
            // set._items['boolean'] holds a two element array
            // representing [ falseExists, trueExists ]
            if (type in set._items) {
                var bIdx = item ? 1 : 0;
                if (set._items[type][bIdx]) return true;
                else {
                    if (shouldAdd) set._items[type][bIdx] = true;
                    return false;
                }
            } else {
                if (shouldAdd) set._items[type] = item ? [
                    false,
                    true
                ] : [
                    true,
                    false
                ];
                return false;
            }
        case 'function':
            // compare functions for reference equality
            if (set._nativeSet !== null) {
                if (shouldAdd) {
                    prevSize = set._nativeSet.size;
                    set._nativeSet.add(item);
                    newSize = set._nativeSet.size;
                    return newSize === prevSize;
                } else return set._nativeSet.has(item);
            } else {
                if (!(type in set._items)) {
                    if (shouldAdd) set._items[type] = [
                        item
                    ];
                    return false;
                }
                if (!(0, _includesJsDefault.default)(item, set._items[type])) {
                    if (shouldAdd) set._items[type].push(item);
                    return false;
                }
                return true;
            }
        case 'undefined':
            if (set._items[type]) return true;
            else {
                if (shouldAdd) set._items[type] = true;
                return false;
            }
        case 'object':
            if (item === null) {
                if (!set._items['null']) {
                    if (shouldAdd) set._items['null'] = true;
                    return false;
                }
                return true;
            }
        /* falls through */ default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) set._items[type] = [
                    item
                ];
                return false;
            }
            // scan through all previously applied items
            if (!(0, _includesJsDefault.default)(item, set._items[type])) {
                if (shouldAdd) set._items[type].push(item);
                return false;
            }
            return true;
    }
}
// A simple Set type that honours R.equals semantics
exports.default = _Set;

},{"./_includes.js":"hfNgu","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6hyWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Finds the set (i.e. no duplicates) of all elements in the first list not
 * contained in the second list. Duplication is determined according to the
 * value returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` that are not in `list2`.
 * @see R.difference, R.symmetricDifference, R.symmetricDifferenceWith
 * @example
 *
 *      const cmp = (x, y) => x.a === y.a;
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}];
 *      const l2 = [{a: 3}, {a: 4}];
 *      R.differenceWith(cmp, l1, l2); //=> [{a: 1}, {a: 2}]
 */ var differenceWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function differenceWith(pred, first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    while(idx < firstLen){
        if (!(0, _includesWithJsDefault.default)(pred, first[idx], second) && !(0, _includesWithJsDefault.default)(pred, first[idx], out)) out.push(first[idx]);
        idx += 1;
    }
    return out;
});
exports.default = differenceWith;

},{"./internal/_includesWith.js":"hGCJ4","./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lw69U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new object that does not contain a `prop` property.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Object
 * @sig String -> {k: v} -> {k: v}
 * @param {String} prop The name of the property to dissociate
 * @param {Object} obj The object to clone
 * @return {Object} A new object equivalent to the original but without the specified property
 * @see R.assoc, R.omit
 * @example
 *
 *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
 */ var dissoc = /*#__PURE__*/ (0, _curry2JsDefault.default)(function dissoc(prop, obj) {
    var result = {};
    for(var p in obj)result[p] = obj[p];
    delete result[prop];
    return result;
});
exports.default = dissoc;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fdBQw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _dissocJs = require("./dissoc.js");
var _dissocJsDefault = parcelHelpers.interopDefault(_dissocJs);
var _removeJs = require("./remove.js");
var _removeJsDefault = parcelHelpers.interopDefault(_removeJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
/**
 * Makes a shallow clone of an object, omitting the property at the given path.
 * Note that this copies and flattens prototype properties onto the new object
 * as well. All non-primitive properties are copied by reference.
 *
 * @func
 * @memberOf R
 * @since v0.11.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {k: v} -> {k: v}
 * @param {Array} path The path to the value to omit
 * @param {Object} obj The object to clone
 * @return {Object} A new object without the property at path
 * @see R.assocPath
 * @example
 *
 *      R.dissocPath(['a', 'b', 'c'], {a: {b: {c: 42}}}); //=> {a: {b: {}}}
 */ var dissocPath = /*#__PURE__*/ (0, _curry2JsDefault.default)(function dissocPath(path, obj) {
    switch(path.length){
        case 0:
            return obj;
        case 1:
            return (0, _isIntegerJsDefault.default)(path[0]) && (0, _isArrayJsDefault.default)(obj) ? (0, _removeJsDefault.default)(path[0], 1, obj) : (0, _dissocJsDefault.default)(path[0], obj);
        default:
            var head = path[0];
            var tail = Array.prototype.slice.call(path, 1);
            if (obj[head] == null) return obj;
            else if ((0, _isIntegerJsDefault.default)(head) && (0, _isArrayJsDefault.default)(obj)) return (0, _updateJsDefault.default)(head, dissocPath(tail, obj[head]), obj);
            else return (0, _assocJsDefault.default)(head, dissocPath(tail, obj[head]), obj);
    }
});
exports.default = dissocPath;

},{"./internal/_curry2.js":"fKiHC","./internal/_isInteger.js":"69VMa","./internal/_isArray.js":"lc1D3","./assoc.js":"kx0W3","./dissoc.js":"lw69U","./remove.js":"dtUhF","./update.js":"lbNxi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dtUhF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Removes the sub-list of `list` starting at index `start` and containing
 * `count` elements. _Note that this is not destructive_: it returns a copy of
 * the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} start The position to start removing elements
 * @param {Number} count The number of elements to remove
 * @param {Array} list The list to remove from
 * @return {Array} A new Array with `count` elements from `start` removed.
 * @see R.without
 * @example
 *
 *      R.remove(2, 3, [1,2,3,4,5,6,7,8]); //=> [1,2,6,7,8]
 */ var remove = /*#__PURE__*/ (0, _curry3JsDefault.default)(function remove(start, count, list) {
    var result = Array.prototype.slice.call(list, 0);
    result.splice(start, count);
    return result;
});
exports.default = remove;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lbNxi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _adjustJs = require("./adjust.js");
var _adjustJsDefault = parcelHelpers.interopDefault(_adjustJs);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
/**
 * Returns a new copy of the array with the element at the provided index
 * replaced with the given value.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} idx The index to update.
 * @param {*} x The value to exist at the given index of the returned array.
 * @param {Array|Arguments} list The source array-like object to be updated.
 * @return {Array} A copy of `list` with the value at index `idx` replaced with `x`.
 * @see R.adjust
 * @example
 *
 *      R.update(1, '_', ['a', 'b', 'c']);      //=> ['a', '_', 'c']
 *      R.update(-1, '_', ['a', 'b', 'c']);     //=> ['a', 'b', '_']
 * @symb R.update(-1, a, [b, c]) = [b, a]
 * @symb R.update(0, a, [b, c]) = [a, c]
 * @symb R.update(1, a, [b, c]) = [b, a]
 */ var update = /*#__PURE__*/ (0, _curry3JsDefault.default)(function update(idx, x, list) {
    return (0, _adjustJsDefault.default)(idx, (0, _alwaysJsDefault.default)(x), list);
});
exports.default = update;

},{"./internal/_curry3.js":"eXJSk","./adjust.js":"1Jj5f","./always.js":"17a55","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9ibnW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Divides two numbers. Equivalent to `a / b`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a / b`.
 * @see R.multiply
 * @example
 *
 *      R.divide(71, 100); //=> 0.71
 *
 *      const half = R.divide(R.__, 2);
 *      half(42); //=> 21
 *
 *      const reciprocal = R.divide(1);
 *      reciprocal(4);   //=> 0.25
 */ var divide = /*#__PURE__*/ (0, _curry2JsDefault.default)(function divide(a, b) {
    return a / b;
});
exports.default = divide;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eUV7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropJs = require("./internal/_xdrop.js");
var _xdropJsDefault = parcelHelpers.interopDefault(_xdropJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `drop` method).
 *
 * Dispatches to the `drop` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*} A copy of list without the first `n` elements
 * @see R.take, R.transduce, R.dropLast, R.dropWhile
 * @example
 *
 *      R.drop(1, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.drop(2, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.drop(3, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(4, ['foo', 'bar', 'baz']); //=> []
 *      R.drop(3, 'ramda');               //=> 'da'
 */ var drop = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'drop'
], (0, _xdropJsDefault.default), function drop(n, xs) {
    return (0, _sliceJsDefault.default)(Math.max(0, n), Infinity, xs);
}));
exports.default = drop;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xdrop.js":"byJkb","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"byJkb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDrop = /*#__PURE__*/ function() {
    function XDrop(n, xf) {
        this.xf = xf;
        this.n = n;
    }
    XDrop.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDrop.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XDrop.prototype['@@transducer/step'] = function(result, input) {
        if (this.n > 0) {
            this.n -= 1;
            return result;
        }
        return this.xf['@@transducer/step'](result, input);
    };
    return XDrop;
}();
var _xdrop = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdrop(n, xf) {
    return new XDrop(n, xf);
});
exports.default = _xdrop;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8KKVA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _dropLastJs = require("./internal/_dropLast.js");
var _dropLastJsDefault = parcelHelpers.interopDefault(_dropLastJs);
var _xdropLastJs = require("./internal/_xdropLast.js");
var _xdropLastJsDefault = parcelHelpers.interopDefault(_xdropLastJs);
/**
 * Returns a list containing all but the last `n` elements of the given `list`.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements of `list` to skip.
 * @param {Array} list The list of elements to consider.
 * @return {Array} A copy of the list with only the first `list.length - n` elements
 * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
 * @example
 *
 *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
 *      R.dropLast(3, 'ramda');               //=> 'ra'
 */ var dropLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropLastJsDefault.default), (0, _dropLastJsDefault.default)));
exports.default = dropLast;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_dropLast.js":"1AuPP","./internal/_xdropLast.js":"9KcS6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1AuPP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dropLast);
var _takeJs = require("../take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
function dropLast(n, xs) {
    return (0, _takeJsDefault.default)(n < xs.length ? xs.length - n : 0, xs);
}

},{"../take.js":"9GQUp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9GQUp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtakeJs = require("./internal/_xtake.js");
var _xtakeJsDefault = parcelHelpers.interopDefault(_xtakeJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns the first `n` elements of the given list, string, or
 * transducer/transformer (or object with a `take` method).
 *
 * Dispatches to the `take` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n
 * @param {*} list
 * @return {*}
 * @see R.drop
 * @example
 *
 *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
 *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
 *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.take(3, 'ramda');               //=> 'ram'
 *
 *      const personnel = [
 *        'Dave Brubeck',
 *        'Paul Desmond',
 *        'Eugene Wright',
 *        'Joe Morello',
 *        'Gerry Mulligan',
 *        'Bob Bates',
 *        'Joe Dodge',
 *        'Ron Crotty'
 *      ];
 *
 *      const takeFive = R.take(5);
 *      takeFive(personnel);
 *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
 * @symb R.take(-1, [a, b]) = [a, b]
 * @symb R.take(0, [a, b]) = []
 * @symb R.take(1, [a, b]) = [a]
 * @symb R.take(2, [a, b]) = [a, b]
 */ var take = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'take'
], (0, _xtakeJsDefault.default), function take(n, xs) {
    return (0, _sliceJsDefault.default)(0, n < 0 ? Infinity : n, xs);
}));
exports.default = take;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xtake.js":"jpUtD","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jpUtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTake = /*#__PURE__*/ function() {
    function XTake(n, xf) {
        this.xf = xf;
        this.n = n;
        this.i = 0;
    }
    XTake.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XTake.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XTake.prototype['@@transducer/step'] = function(result, input) {
        this.i += 1;
        var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
        return this.n >= 0 && this.i >= this.n ? (0, _reducedJsDefault.default)(ret) : ret;
    };
    return XTake;
}();
var _xtake = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtake(n, xf) {
    return new XTake(n, xf);
});
exports.default = _xtake;

},{"./_curry2.js":"fKiHC","./_reduced.js":"jCwWa","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9KcS6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropLast = /*#__PURE__*/ function() {
    function XDropLast(n, xf) {
        this.xf = xf;
        this.pos = 0;
        this.full = false;
        this.acc = new Array(n);
    }
    XDropLast.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropLast.prototype['@@transducer/result'] = function(result) {
        this.acc = null;
        return this.xf['@@transducer/result'](result);
    };
    XDropLast.prototype['@@transducer/step'] = function(result, input) {
        if (this.full) result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
        this.store(input);
        return result;
    };
    XDropLast.prototype.store = function(input) {
        this.acc[this.pos] = input;
        this.pos += 1;
        if (this.pos === this.acc.length) {
            this.pos = 0;
            this.full = true;
        }
    };
    return XDropLast;
}();
var _xdropLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropLast(n, xf) {
    return new XDropLast(n, xf);
});
exports.default = _xdropLast;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"wBgXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _dropLastWhileJs = require("./internal/_dropLastWhile.js");
var _dropLastWhileJsDefault = parcelHelpers.interopDefault(_dropLastWhileJs);
var _xdropLastWhileJs = require("./internal/_xdropLastWhile.js");
var _xdropLastWhileJsDefault = parcelHelpers.interopDefault(_xdropLastWhileJs);
/**
 * Returns a new list excluding all the tailing elements of a given list which
 * satisfy the supplied predicate function. It passes each value from the right
 * to the supplied predicate function, skipping elements until the predicate
 * function returns a `falsy` value. The predicate function is applied to one argument:
 * *(value)*.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} predicate The function to be called on each element
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array without any trailing elements that return `falsy` values from the `predicate`.
 * @see R.takeLastWhile, R.addIndex, R.drop, R.dropWhile
 * @example
 *
 *      const lteThree = x => x <= 3;
 *
 *      R.dropLastWhile(lteThree, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3, 4]
 *
 *      R.dropLastWhile(x => x !== 'd' , 'Ramda'); //=> 'Ramd'
 */ var dropLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropLastWhileJsDefault.default), (0, _dropLastWhileJsDefault.default)));
exports.default = dropLastWhile;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_dropLastWhile.js":"kEHvz","./internal/_xdropLastWhile.js":"7VBMi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kEHvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dropLastWhile);
var _sliceJs = require("../slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
function dropLastWhile(pred, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && pred(xs[idx]))idx -= 1;
    return (0, _sliceJsDefault.default)(0, idx + 1, xs);
}

},{"../slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7VBMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropLastWhile = /*#__PURE__*/ function() {
    function XDropLastWhile(fn, xf) {
        this.f = fn;
        this.retained = [];
        this.xf = xf;
    }
    XDropLastWhile.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropLastWhile.prototype['@@transducer/result'] = function(result) {
        this.retained = null;
        return this.xf['@@transducer/result'](result);
    };
    XDropLastWhile.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.retain(result, input) : this.flush(result, input);
    };
    XDropLastWhile.prototype.flush = function(result, input) {
        result = (0, _reduceJsDefault.default)(this.xf['@@transducer/step'], result, this.retained);
        this.retained = [];
        return this.xf['@@transducer/step'](result, input);
    };
    XDropLastWhile.prototype.retain = function(result, input) {
        this.retained.push(input);
        return result;
    };
    return XDropLastWhile;
}();
var _xdropLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropLastWhile(fn, xf) {
    return new XDropLastWhile(fn, xf);
});
exports.default = _xdropLastWhile;

},{"./_curry2.js":"fKiHC","./_reduce.js":"kZKBe","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g1WbI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropRepeatsWithJs = require("./internal/_xdropRepeatsWith.js");
var _xdropRepeatsWithJsDefault = parcelHelpers.interopDefault(_xdropRepeatsWithJs);
var _dropRepeatsWithJs = require("./dropRepeatsWith.js");
var _dropRepeatsWithJsDefault = parcelHelpers.interopDefault(_dropRepeatsWithJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns a new list without any consecutively repeating elements.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *     R.dropRepeats([1, 1, 1, 2, 3, 4, 4, 2, 2]); //=> [1, 2, 3, 4, 2]
 */ var dropRepeats = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], /*#__PURE__*/ (0, _xdropRepeatsWithJsDefault.default)((0, _equalsJsDefault.default)), /*#__PURE__*/ (0, _dropRepeatsWithJsDefault.default)((0, _equalsJsDefault.default))));
exports.default = dropRepeats;

},{"./internal/_curry1.js":"973zL","./internal/_dispatchable.js":"f1aoQ","./internal/_xdropRepeatsWith.js":"3jlRR","./dropRepeatsWith.js":"lVOzi","./equals.js":"90ObX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jlRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropRepeatsWith = /*#__PURE__*/ function() {
    function XDropRepeatsWith(pred, xf) {
        this.xf = xf;
        this.pred = pred;
        this.lastValue = undefined;
        this.seenFirstValue = false;
    }
    XDropRepeatsWith.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropRepeatsWith.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XDropRepeatsWith.prototype['@@transducer/step'] = function(result, input) {
        var sameAsLast = false;
        if (!this.seenFirstValue) this.seenFirstValue = true;
        else if (this.pred(this.lastValue, input)) sameAsLast = true;
        this.lastValue = input;
        return sameAsLast ? result : this.xf['@@transducer/step'](result, input);
    };
    return XDropRepeatsWith;
}();
var _xdropRepeatsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropRepeatsWith(pred, xf) {
    return new XDropRepeatsWith(pred, xf);
});
exports.default = _xdropRepeatsWith;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lVOzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropRepeatsWithJs = require("./internal/_xdropRepeatsWith.js");
var _xdropRepeatsWithJsDefault = parcelHelpers.interopDefault(_xdropRepeatsWithJs);
var _lastJs = require("./last.js");
var _lastJsDefault = parcelHelpers.interopDefault(_lastJs);
/**
 * Returns a new list without any consecutively repeating elements. Equality is
 * determined by applying the supplied predicate to each pair of consecutive elements. The
 * first element in a series of equal elements will be preserved.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} `list` without repeating elements.
 * @see R.transduce
 * @example
 *
 *      const l = [1, -1, 1, 3, 4, -4, -4, -5, 5, 3, 3];
 *      R.dropRepeatsWith(R.eqBy(Math.abs), l); //=> [1, 3, 4, -5, 3]
 */ var dropRepeatsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xdropRepeatsWithJsDefault.default), function dropRepeatsWith(pred, list) {
    var result = [];
    var idx = 1;
    var len = list.length;
    if (len !== 0) {
        result[0] = list[0];
        while(idx < len){
            if (!pred((0, _lastJsDefault.default)(result), list[idx])) result[result.length] = list[idx];
            idx += 1;
        }
    }
    return result;
}));
exports.default = dropRepeatsWith;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xdropRepeatsWith.js":"3jlRR","./last.js":"ioMJD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ioMJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig [a] -> a | Undefined
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.init, R.head, R.tail
 * @example
 *
 *      R.last(['fi', 'fo', 'fum']); //=> 'fum'
 *      R.last([]); //=> undefined
 *
 *      R.last('abc'); //=> 'c'
 *      R.last(''); //=> ''
 */ var last = /*#__PURE__*/ (0, _nthJsDefault.default)(-1);
exports.default = last;

},{"./nth.js":"7AaSQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"csTRb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xdropWhileJs = require("./internal/_xdropWhile.js");
var _xdropWhileJsDefault = parcelHelpers.interopDefault(_xdropWhileJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list excluding the leading elements of a given list which
 * satisfy the supplied predicate function. It passes each value to the supplied
 * predicate function, skipping elements while the predicate function returns
 * `true`. The predicate function is applied to one argument: *(value)*.
 *
 * Dispatches to the `dropWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.takeWhile, R.transduce, R.addIndex
 * @example
 *
 *      const lteTwo = x => x <= 2;
 *
 *      R.dropWhile(lteTwo, [1, 2, 3, 4, 3, 2, 1]); //=> [3, 4, 3, 2, 1]
 *
 *      R.dropWhile(x => x !== 'd' , 'Ramda'); //=> 'da'
 */ var dropWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'dropWhile'
], (0, _xdropWhileJsDefault.default), function dropWhile(pred, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && pred(xs[idx]))idx += 1;
    return (0, _sliceJsDefault.default)(idx, Infinity, xs);
}));
exports.default = dropWhile;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xdropWhile.js":"lA0Fj","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lA0Fj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XDropWhile = /*#__PURE__*/ function() {
    function XDropWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XDropWhile.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XDropWhile.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XDropWhile.prototype['@@transducer/step'] = function(result, input) {
        if (this.f) {
            if (this.f(input)) return result;
            this.f = null;
        }
        return this.xf['@@transducer/step'](result, input);
    };
    return XDropWhile;
}();
var _xdropWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xdropWhile(f, xf) {
    return new XDropWhile(f, xf);
});
exports.default = _xdropWhile;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ix25g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _liftJs = require("./lift.js");
var _liftJsDefault = parcelHelpers.interopDefault(_liftJs);
var _orJs = require("./or.js");
var _orJsDefault = parcelHelpers.interopDefault(_orJs);
/**
 * A function wrapping calls to the two functions in an `||` operation,
 * returning the result of the first function if it is truth-y and the result
 * of the second function otherwise. Note that this is short-circuited,
 * meaning that the second function will not be invoked if the first returns a
 * truth-y value.
 *
 * In addition to functions, `R.either` also accepts any fantasy-land compatible
 * applicative functor.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> Boolean) -> (*... -> Boolean)
 * @param {Function} f a predicate
 * @param {Function} g another predicate
 * @return {Function} a function that applies its arguments to `f` and `g` and `||`s their outputs together.
 * @see R.or
 * @example
 *
 *      const gt10 = x => x > 10;
 *      const even = x => x % 2 === 0;
 *      const f = R.either(gt10, even);
 *      f(101); //=> true
 *      f(8); //=> true
 *
 *      R.either(Maybe.Just(false), Maybe.Just(55)); // => Maybe.Just(55)
 *      R.either([false, false, 'a'], [11]) // => [11, 11, "a"]
 */ var either = /*#__PURE__*/ (0, _curry2JsDefault.default)(function either(f, g) {
    return (0, _isFunctionJsDefault.default)(f) ? function _either() {
        return f.apply(this, arguments) || g.apply(this, arguments);
    } : (0, _liftJsDefault.default)((0, _orJsDefault.default))(f, g);
});
exports.default = either;

},{"./internal/_curry2.js":"fKiHC","./internal/_isFunction.js":"3UxAP","./lift.js":"4spBG","./or.js":"84jgE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"84jgE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if one or both of its arguments are `true`. Returns `false`
 * if both arguments are `false`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> b -> a | b
 * @param {Any} a
 * @param {Any} b
 * @return {Any} the first argument if truthy, otherwise the second argument.
 * @see R.either
 * @example
 *
 *      R.or(true, true); //=> true
 *      R.or(true, false); //=> true
 *      R.or(false, true); //=> true
 *      R.or(false, false); //=> false
 */ var or = /*#__PURE__*/ (0, _curry2JsDefault.default)(function or(a, b) {
    return a || b;
});
exports.default = or;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aCQa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isArgumentsJs = require("./internal/_isArguments.js");
var _isArgumentsJsDefault = parcelHelpers.interopDefault(_isArgumentsJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _isStringJs = require("./internal/_isString.js");
var _isStringJsDefault = parcelHelpers.interopDefault(_isStringJs);
/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));      //=> Nothing()
 *      R.empty([1, 2, 3]);     //=> []
 *      R.empty('unicorns');    //=> ''
 *      R.empty({x: 1, y: 2});  //=> {}
 */ var empty = /*#__PURE__*/ (0, _curry1JsDefault.default)(function empty(x) {
    return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : (0, _isArrayJsDefault.default)(x) ? [] : (0, _isStringJsDefault.default)(x) ? '' : (0, _isObjectJsDefault.default)(x) ? {} : (0, _isArgumentsJsDefault.default)(x) ? function() {
        return arguments;
    }() : void 0 // else
    ;
});
exports.default = empty;

},{"./internal/_curry1.js":"973zL","./internal/_isArguments.js":"dPYSe","./internal/_isArray.js":"lc1D3","./internal/_isObject.js":"1GAHA","./internal/_isString.js":"dtqat","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8Qgy5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _takeLastJs = require("./takeLast.js");
var _takeLastJsDefault = parcelHelpers.interopDefault(_takeLastJs);
/**
 * Checks if a list ends with the provided sublist.
 *
 * Similarly, checks if a string ends with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} suffix
 * @param {*} list
 * @return {Boolean}
 * @see R.startsWith
 * @example
 *
 *      R.endsWith('c', 'abc')                //=> true
 *      R.endsWith('b', 'abc')                //=> false
 *      R.endsWith(['c'], ['a', 'b', 'c'])    //=> true
 *      R.endsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var endsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(suffix, list) {
    return (0, _equalsJsDefault.default)((0, _takeLastJsDefault.default)(suffix.length, list), suffix);
});
exports.default = endsWith;

},{"./internal/_curry2.js":"fKiHC","./equals.js":"90ObX","./takeLast.js":"i6F2s","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i6F2s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dropJs = require("./drop.js");
var _dropJsDefault = parcelHelpers.interopDefault(_dropJs);
/**
 * Returns a new list containing the last `n` elements of the given list.
 * If `n > list.length`, returns a list of `list.length` elements.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [a]
 * @sig Number -> String -> String
 * @param {Number} n The number of elements to return.
 * @param {Array} xs The collection to consider.
 * @return {Array}
 * @see R.dropLast
 * @example
 *
 *      R.takeLast(1, ['foo', 'bar', 'baz']); //=> ['baz']
 *      R.takeLast(2, ['foo', 'bar', 'baz']); //=> ['bar', 'baz']
 *      R.takeLast(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
 *      R.takeLast(3, 'ramda');               //=> 'mda'
 */ var takeLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function takeLast(n, xs) {
    return (0, _dropJsDefault.default)(n >= 0 ? xs.length - n : 0, xs);
});
exports.default = takeLast;

},{"./internal/_curry2.js":"fKiHC","./drop.js":"eUV7h","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agONC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Takes a function and two values in its domain and returns `true` if the
 * values map to the same value in the codomain; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Relation
 * @sig (a -> b) -> a -> a -> Boolean
 * @param {Function} f
 * @param {*} x
 * @param {*} y
 * @return {Boolean}
 * @example
 *
 *      R.eqBy(Math.abs, 5, -5); //=> true
 */ var eqBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function eqBy(f, x, y) {
    return (0, _equalsJsDefault.default)(f(x), f(y));
});
exports.default = eqBy;

},{"./internal/_curry3.js":"eXJSk","./equals.js":"90ObX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9w98j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Reports whether two objects have the same value, in [`R.equals`](#equals)
 * terms, for the specified property. Useful as a curried predicate.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig k -> {k: v} -> {k: v} -> Boolean
 * @param {String} prop The name of the property to compare
 * @param {Object} obj1
 * @param {Object} obj2
 * @return {Boolean}
 *
 * @example
 *
 *      const o1 = { a: 1, b: 2, c: 3, d: 4 };
 *      const o2 = { a: 10, b: 20, c: 3, d: 40 };
 *      R.eqProps('a', o1, o2); //=> false
 *      R.eqProps('c', o1, o2); //=> true
 */ var eqProps = /*#__PURE__*/ (0, _curry3JsDefault.default)(function eqProps(prop, obj1, obj2) {
    return (0, _equalsJsDefault.default)(obj1[prop], obj2[prop]);
});
exports.default = eqProps;

},{"./internal/_curry3.js":"eXJSk","./equals.js":"90ObX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYvGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var evolve = /*#__PURE__*/ (0, _curry2JsDefault.default)(function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
exports.default = evolve;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9GNIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindJs = require("./internal/_xfind.js");
var _xfindJsDefault = parcelHelpers.interopDefault(_xfindJs);
/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */ var find = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'find'
], (0, _xfindJsDefault.default), function find(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return list[idx];
        idx += 1;
    }
}));
exports.default = find;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xfind.js":"f3O4p","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f3O4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFind = /*#__PURE__*/ function() {
    function XFind(f, xf) {
        this.xf = xf;
        this.f = f;
        this.found = false;
    }
    XFind.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFind.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, void 0);
        return this.xf['@@transducer/result'](result);
    };
    XFind.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) {
            this.found = true;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, input));
        }
        return result;
    };
    return XFind;
}();
var _xfind = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfind(f, xf) {
    return new XFind(f, xf);
});
exports.default = _xfind;

},{"./_curry2.js":"fKiHC","./_reduced.js":"jCwWa","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gVNw8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindIndexJs = require("./internal/_xfindIndex.js");
var _xfindIndexJsDefault = parcelHelpers.interopDefault(_xfindIndexJs);
/**
 * Returns the index of the first element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.findIndex(R.propEq('a', 2))(xs); //=> 1
 *      R.findIndex(R.propEq('a', 4))(xs); //=> -1
 */ var findIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindIndexJsDefault.default), function findIndex(fn, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        if (fn(list[idx])) return idx;
        idx += 1;
    }
    return -1;
}));
exports.default = findIndex;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xfindIndex.js":"h0xOO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h0xOO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindIndex = /*#__PURE__*/ function() {
    function XFindIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.found = false;
    }
    XFindIndex.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFindIndex.prototype['@@transducer/result'] = function(result) {
        if (!this.found) result = this.xf['@@transducer/step'](result, -1);
        return this.xf['@@transducer/result'](result);
    };
    XFindIndex.prototype['@@transducer/step'] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) {
            this.found = true;
            result = (0, _reducedJsDefault.default)(this.xf['@@transducer/step'](result, this.idx));
        }
        return result;
    };
    return XFindIndex;
}();
var _xfindIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindIndex(f, xf) {
    return new XFindIndex(f, xf);
});
exports.default = _xfindIndex;

},{"./_curry2.js":"fKiHC","./_reduced.js":"jCwWa","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6BZFD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindLastJs = require("./internal/_xfindLast.js");
var _xfindLastJsDefault = parcelHelpers.interopDefault(_xfindLastJs);
/**
 * Returns the last element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLast(R.propEq('a', 1))(xs); //=> {a: 1, b: 1}
 *      R.findLast(R.propEq('a', 4))(xs); //=> undefined
 */ var findLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindLastJsDefault.default), function findLast(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return list[idx];
        idx -= 1;
    }
}));
exports.default = findLast;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xfindLast.js":"1KiFa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1KiFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindLast = /*#__PURE__*/ function() {
    function XFindLast(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XFindLast.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFindLast.prototype['@@transducer/result'] = function(result) {
        return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.last));
    };
    XFindLast.prototype['@@transducer/step'] = function(result, input) {
        if (this.f(input)) this.last = input;
        return result;
    };
    return XFindLast;
}();
var _xfindLast = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindLast(f, xf) {
    return new XFindLast(f, xf);
});
exports.default = _xfindLast;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"wjHm9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xfindLastIndexJs = require("./internal/_xfindLastIndex.js");
var _xfindLastIndexJsDefault = parcelHelpers.interopDefault(_xfindLastIndexJs);
/**
 * Returns the index of the last element of the list which matches the
 * predicate, or `-1` if no element matches.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> Boolean) -> [a] -> Number
 * @param {Function} fn The predicate function used to determine if the element is the
 * desired one.
 * @param {Array} list The array to consider.
 * @return {Number} The index of the element found, or `-1`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1, b: 0}, {a:1, b: 1}];
 *      R.findLastIndex(R.propEq('a', 1))(xs); //=> 1
 *      R.findLastIndex(R.propEq('a', 4))(xs); //=> -1
 */ var findLastIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xfindLastIndexJsDefault.default), function findLastIndex(fn, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        if (fn(list[idx])) return idx;
        idx -= 1;
    }
    return -1;
}));
exports.default = findLastIndex;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xfindLastIndex.js":"gw4uU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gw4uU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XFindLastIndex = /*#__PURE__*/ function() {
    function XFindLastIndex(f, xf) {
        this.xf = xf;
        this.f = f;
        this.idx = -1;
        this.lastIdx = -1;
    }
    XFindLastIndex.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XFindLastIndex.prototype['@@transducer/result'] = function(result) {
        return this.xf['@@transducer/result'](this.xf['@@transducer/step'](result, this.lastIdx));
    };
    XFindLastIndex.prototype['@@transducer/step'] = function(result, input) {
        this.idx += 1;
        if (this.f(input)) this.lastIdx = this.idx;
        return result;
    };
    return XFindLastIndex;
}();
var _xfindLastIndex = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xfindLastIndex(f, xf) {
    return new XFindLastIndex(f, xf);
});
exports.default = _xfindLastIndex;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5SDRJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _makeFlatJs = require("./internal/_makeFlat.js");
var _makeFlatJsDefault = parcelHelpers.interopDefault(_makeFlatJs);
/**
 * Returns a new list by pulling every item out of it (and all its sub-arrays)
 * and putting them in a new array, depth-first.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b]
 * @param {Array} list The array to consider.
 * @return {Array} The flattened list.
 * @see R.unnest
 * @example
 *
 *      R.flatten([1, 2, [3, 4], 5, [6, [7, 8, [9, [10, 11], 12]]]]);
 *      //=> [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
 */ var flatten = /*#__PURE__*/ (0, _curry1JsDefault.default)(/*#__PURE__*/ (0, _makeFlatJsDefault.default)(true));
exports.default = flatten;

},{"./internal/_curry1.js":"973zL","./internal/_makeFlat.js":"8qgp3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h3gua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a new function much like the supplied one, except that the first two
 * arguments' order is reversed.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((a, b, c, ...) -> z) -> (b -> a -> c -> ... -> z)
 * @param {Function} fn The function to invoke with its first two parameters reversed.
 * @return {*} The result of invoking `fn` with its first two parameters' order reversed.
 * @example
 *
 *      const mergeThree = (a, b, c) => [].concat(a, b, c);
 *
 *      mergeThree(1, 2, 3); //=> [1, 2, 3]
 *
 *      R.flip(mergeThree)(1, 2, 3); //=> [2, 1, 3]
 * @symb R.flip(f)(a, b, c) = f(b, a, c)
 */ var flip = /*#__PURE__*/ (0, _curry1JsDefault.default)(function flip(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function(a, b) {
        var args = Array.prototype.slice.call(arguments, 0);
        args[0] = b;
        args[1] = a;
        return fn.apply(this, args);
    });
});
exports.default = flip;

},{"./internal/_curry1.js":"973zL","./curryN.js":"jig5V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4StJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Iterate over an input `list`, calling a provided function `fn` for each
 * element in the list.
 *
 * `fn` receives one argument: *(value)*.
 *
 * Note: `R.forEach` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.forEach` method. For more
 * details on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach#Description
 *
 * Also note that, unlike `Array.prototype.forEach`, Ramda's `forEach` returns
 * the original array. In some libraries this function is named `each`.
 *
 * Dispatches to the `forEach` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig (a -> *) -> [a] -> [a]
 * @param {Function} fn The function to invoke. Receives one argument, `value`.
 * @param {Array} list The list to iterate over.
 * @return {Array} The original list.
 * @see R.addIndex
 * @example
 *
 *      const printXPlusFive = x => console.log(x + 5);
 *      R.forEach(printXPlusFive, [1, 2, 3]); //=> [1, 2, 3]
 *      // logs 6
 *      // logs 7
 *      // logs 8
 * @symb R.forEach(f, [a, b, c]) = [a, b, c]
 */ var forEach = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('forEach', function forEach(fn, list) {
    var len = list.length;
    var idx = 0;
    while(idx < len){
        fn(list[idx]);
        idx += 1;
    }
    return list;
}));
exports.default = forEach;

},{"./internal/_checkForMethod.js":"5zr8J","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k20NG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Iterate over an input `object`, calling a provided function `fn` for each
 * key and value in the object.
 *
 * `fn` receives three argument: *(value, key, obj)*.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Object
 * @sig ((a, String, StrMap a) -> Any) -> StrMap a -> StrMap a
 * @param {Function} fn The function to invoke. Receives three argument, `value`, `key`, `obj`.
 * @param {Object} obj The object to iterate over.
 * @return {Object} The original object.
 * @example
 *
 *      const printKeyConcatValue = (value, key) => console.log(key + ':' + value);
 *      R.forEachObjIndexed(printKeyConcatValue, {x: 1, y: 2}); //=> {x: 1, y: 2}
 *      // logs x:1
 *      // logs y:2
 * @symb R.forEachObjIndexed(f, {x: a, y: b}) = {x: a, y: b}
 */ var forEachObjIndexed = /*#__PURE__*/ (0, _curry2JsDefault.default)(function forEachObjIndexed(fn, obj) {
    var keyList = (0, _keysJsDefault.default)(obj);
    var idx = 0;
    while(idx < keyList.length){
        var key = keyList[idx];
        fn(obj[key], key, obj);
        idx += 1;
    }
    return obj;
});
exports.default = forEachObjIndexed;

},{"./internal/_curry2.js":"fKiHC","./keys.js":"7WEzg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"054qa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a new object from a list key-value pairs. If a key appears in
 * multiple pairs, the rightmost pair is included in the object.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [[k,v]] -> {k: v}
 * @param {Array} pairs An array of two-element arrays that will be the keys and values of the output object.
 * @return {Object} The object made by pairing up `keys` and `values`.
 * @see R.toPairs, R.pair
 * @example
 *
 *      R.fromPairs([['a', 1], ['b', 2], ['c', 3]]); //=> {a: 1, b: 2, c: 3}
 */ var fromPairs = /*#__PURE__*/ (0, _curry1JsDefault.default)(function fromPairs(pairs) {
    var result = {};
    var idx = 0;
    while(idx < pairs.length){
        result[pairs[idx][0]] = pairs[idx][1];
        idx += 1;
    }
    return result;
});
exports.default = fromPairs;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bZkDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Splits a list into sub-lists stored in an object, based on the result of
 * calling a String-returning function on each element, and grouping the
 * results according to values returned.
 *
 * Dispatches to the `groupBy` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> String) -> [a] -> {String: [a]}
 * @param {Function} fn Function :: a -> String
 * @param {Array} list The array to group
 * @return {Object} An object with the output of `fn` for keys, mapped to arrays of elements
 *         that produced that key when passed to `fn`.
 * @see R.reduceBy, R.transduce
 * @example
 *
 *      const byGrade = R.groupBy(function(student) {
 *        const score = student.score;
 *        return score < 65 ? 'F' :
 *               score < 70 ? 'D' :
 *               score < 80 ? 'C' :
 *               score < 90 ? 'B' : 'A';
 *      });
 *      const students = [{name: 'Abby', score: 84},
 *                      {name: 'Eddy', score: 58},
 *                      // ...
 *                      {name: 'Jack', score: 69}];
 *      byGrade(students);
 *      // {
 *      //   'A': [{name: 'Dianne', score: 99}],
 *      //   'B': [{name: 'Abby', score: 84}]
 *      //   // ...,
 *      //   'F': [{name: 'Eddy', score: 58}]
 *      // }
 */ var groupBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('groupBy', /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, item) {
    if (acc == null) acc = [];
    acc.push(item);
    return acc;
}, null)));
exports.default = groupBy;

},{"./internal/_checkForMethod.js":"5zr8J","./internal/_curry2.js":"fKiHC","./reduceBy.js":"4hpJN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5eMQM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a list and returns a list of lists where each sublist's elements are
 * all satisfied pairwise comparison according to the provided function.
 * Only adjacent elements are passed to the comparison function.
 *
 * @func
 * @memberOf R
 * @since v0.21.0
 * @category List
 * @sig ((a, a) → Boolean) → [a] → [[a]]
 * @param {Function} fn Function for determining whether two given (adjacent)
 *        elements should be in the same group
 * @param {Array} list The array to group. Also accepts a string, which will be
 *        treated as a list of characters.
 * @return {List} A list that contains sublists of elements,
 *         whose concatenations are equal to the original list.
 * @example
 *
 * R.groupWith(R.equals, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a + 1 === b, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0, 1], [1, 2, 3], [5], [8], [13], [21]]
 *
 * R.groupWith((a, b) => a % 2 === b % 2, [0, 1, 1, 2, 3, 5, 8, 13, 21])
 * //=> [[0], [1, 1], [2], [3, 5], [8], [13, 21]]
 *
 * R.groupWith(R.eqBy(isVowel), 'aestiou')
 * //=> ['ae', 'st', 'iou']
 */ var groupWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(fn, list) {
    var res = [];
    var idx = 0;
    var len = list.length;
    while(idx < len){
        var nextidx = idx + 1;
        while(nextidx < len && fn(list[nextidx - 1], list[nextidx]))nextidx += 1;
        res.push(list.slice(idx, nextidx));
        idx = nextidx;
    }
    return res;
});
exports.default = groupWith;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"51JGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is greater than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.lt
 * @example
 *
 *      R.gt(2, 1); //=> true
 *      R.gt(2, 2); //=> false
 *      R.gt(2, 3); //=> false
 *      R.gt('a', 'z'); //=> false
 *      R.gt('z', 'a'); //=> true
 */ var gt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function gt(a, b) {
    return a > b;
});
exports.default = gt;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1yl8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is greater than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.lte
 * @example
 *
 *      R.gte(2, 1); //=> true
 *      R.gte(2, 2); //=> true
 *      R.gte(2, 3); //=> false
 *      R.gte('a', 'z'); //=> false
 *      R.gte('z', 'a'); //=> true
 */ var gte = /*#__PURE__*/ (0, _curry2JsDefault.default)(function gte(a, b) {
    return a >= b;
});
exports.default = gte;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"LJXag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasPathJs = require("./hasPath.js");
var _hasPathJsDefault = parcelHelpers.interopDefault(_hasPathJs);
/**
 * Returns whether or not an object has an own property with the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      const hasName = R.has('name');
 *      hasName({name: 'alice'});   //=> true
 *      hasName({name: 'bob'});     //=> true
 *      hasName({});                //=> false
 *
 *      const point = {x: 0, y: 0};
 *      const pointHas = R.has(R.__, point);
 *      pointHas('x');  //=> true
 *      pointHas('y');  //=> true
 *      pointHas('z');  //=> false
 */ var has = /*#__PURE__*/ (0, _curry2JsDefault.default)(function has(prop, obj) {
    return (0, _hasPathJsDefault.default)([
        prop
    ], obj);
});
exports.default = has;

},{"./internal/_curry2.js":"fKiHC","./hasPath.js":"8kj6Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8kj6Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Returns whether or not a path exists in an object. Only the object's
 * own properties are checked.
 *
 * @func
 * @memberOf R
 * @since v0.26.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> Boolean
 * @param {Array} path The path to use.
 * @param {Object} obj The object to check the path in.
 * @return {Boolean} Whether the path exists.
 * @see R.has
 * @example
 *
 *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
 *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
 *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
 *      R.hasPath(['a', 'b'], {});                  // => false
 */ var hasPath = /*#__PURE__*/ (0, _curry2JsDefault.default)(function hasPath(_path, obj) {
    if (_path.length === 0) return false;
    var val = obj;
    var idx = 0;
    while(idx < _path.length){
        if ((0, _hasJsDefault.default)(_path[idx], val)) {
            val = val[_path[idx]];
            idx += 1;
        } else return false;
    }
    return true;
});
exports.default = hasPath;

},{"./internal/_curry2.js":"fKiHC","./internal/_has.js":"lzxBF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ksKGi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns whether or not an object or its prototype chain has a property with
 * the specified name
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Object
 * @sig s -> {s: x} -> Boolean
 * @param {String} prop The name of the property to check for.
 * @param {Object} obj The object to query.
 * @return {Boolean} Whether the property exists.
 * @example
 *
 *      function Rectangle(width, height) {
 *        this.width = width;
 *        this.height = height;
 *      }
 *      Rectangle.prototype.area = function() {
 *        return this.width * this.height;
 *      };
 *
 *      const square = new Rectangle(2, 2);
 *      R.hasIn('width', square);  //=> true
 *      R.hasIn('area', square);  //=> true
 */ var hasIn = /*#__PURE__*/ (0, _curry2JsDefault.default)(function hasIn(prop, obj) {
    return prop in obj;
});
exports.default = hasIn;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kswLQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectIsJs = require("./internal/_objectIs.js");
var _objectIsJsDefault = parcelHelpers.interopDefault(_objectIsJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns true if its arguments are identical, false otherwise. Values are
 * identical if they reference the same memory. `NaN` is identical to `NaN`;
 * `0` and `-0` are not identical.
 *
 * Note this is merely a curried version of ES6 `Object.is`.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      const o = {};
 *      R.identical(o, o); //=> true
 *      R.identical(1, 1); //=> true
 *      R.identical(1, '1'); //=> false
 *      R.identical([], []); //=> false
 *      R.identical(0, -0); //=> false
 *      R.identical(NaN, NaN); //=> true
 */ var identical = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _objectIsJsDefault.default));
exports.default = identical;

},{"./internal/_objectIs.js":"iUeOr","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hMMPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Creates a function that will process either the `onTrue` or the `onFalse`
 * function depending upon the result of the `condition` predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Logic
 * @sig (*... -> Boolean) -> (*... -> *) -> (*... -> *) -> (*... -> *)
 * @param {Function} condition A predicate function
 * @param {Function} onTrue A function to invoke when the `condition` evaluates to a truthy value.
 * @param {Function} onFalse A function to invoke when the `condition` evaluates to a falsy value.
 * @return {Function} A new function that will process either the `onTrue` or the `onFalse`
 *                    function depending upon the result of the `condition` predicate.
 * @see R.unless, R.when, R.cond
 * @example
 *
 *      const incCount = R.ifElse(
 *        R.has('count'),
 *        R.over(R.lensProp('count'), R.inc),
 *        R.assoc('count', 1)
 *      );
 *      incCount({});           //=> { count: 1 }
 *      incCount({ count: 1 }); //=> { count: 2 }
 */ var ifElse = /*#__PURE__*/ (0, _curry3JsDefault.default)(function ifElse(condition, onTrue, onFalse) {
    return (0, _curryNJsDefault.default)(Math.max(condition.length, onTrue.length, onFalse.length), function _ifElse() {
        return condition.apply(this, arguments) ? onTrue.apply(this, arguments) : onFalse.apply(this, arguments);
    });
});
exports.default = ifElse;

},{"./internal/_curry3.js":"eXJSk","./curryN.js":"jig5V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3BAcg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
/**
 * Increments its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number} n + 1
 * @see R.dec
 * @example
 *
 *      R.inc(42); //=> 43
 */ var inc = /*#__PURE__*/ (0, _addJsDefault.default)(1);
exports.default = inc;

},{"./add.js":"49LDq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1cgtb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the specified value is equal, in [`R.equals`](#equals)
 * terms, to at least one element of the given list; `false` otherwise.
 * Works also with strings.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Boolean
 * @param {Object} a The item to compare against.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if an equivalent item is in the list, `false` otherwise.
 * @see R.any
 * @example
 *
 *      R.includes(3, [1, 2, 3]); //=> true
 *      R.includes(4, [1, 2, 3]); //=> false
 *      R.includes({ name: 'Fred' }, [{ name: 'Fred' }]); //=> true
 *      R.includes([42], [[42]]); //=> true
 *      R.includes('ba', 'banana'); //=>true
 */ var includes = /*#__PURE__*/ (0, _curry2JsDefault.default)((0, _includesJsDefault.default));
exports.default = includes;

},{"./internal/_includes.js":"hfNgu","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cVHNJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceByJs = require("./reduceBy.js");
var _reduceByJsDefault = parcelHelpers.interopDefault(_reduceByJs);
/**
 * Given a function that generates a key, turns a list of objects into an
 * object indexing the objects by the given key. Note that if multiple
 * objects generate the same value for the indexing key only the last value
 * will be included in the generated object.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> String) -> [{k: v}] -> {k: {k: v}}
 * @param {Function} fn Function :: a -> String
 * @param {Array} array The array of objects to index
 * @return {Object} An object indexing each array element by the given property.
 * @example
 *
 *      const list = [{id: 'xyz', title: 'A'}, {id: 'abc', title: 'B'}];
 *      R.indexBy(R.prop('id'), list);
 *      //=> {abc: {id: 'abc', title: 'B'}, xyz: {id: 'xyz', title: 'A'}}
 */ var indexBy = /*#__PURE__*/ (0, _reduceByJsDefault.default)(function(acc, elem) {
    return elem;
}, null);
exports.default = indexBy;

},{"./reduceBy.js":"4hpJN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8ql7T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _indexOfJs = require("./internal/_indexOf.js");
var _indexOfJsDefault = parcelHelpers.interopDefault(_indexOfJs);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
/**
 * Returns the position of the first occurrence of an item in an array, or -1
 * if the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.lastIndexOf
 * @example
 *
 *      R.indexOf(3, [1,2,3,4]); //=> 2
 *      R.indexOf(10, [1,2,3,4]); //=> -1
 */ var indexOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function indexOf(target, xs) {
    return typeof xs.indexOf === 'function' && !(0, _isArrayJsDefault.default)(xs) ? xs.indexOf(target) : (0, _indexOfJsDefault.default)(xs, target, 0);
});
exports.default = indexOf;

},{"./internal/_curry2.js":"fKiHC","./internal/_indexOf.js":"7KvCu","./internal/_isArray.js":"lc1D3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c8PSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns all but the last element of the given list or string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.last, R.head, R.tail
 * @example
 *
 *      R.init([1, 2, 3]);  //=> [1, 2]
 *      R.init([1, 2]);     //=> [1]
 *      R.init([1]);        //=> []
 *      R.init([]);         //=> []
 *
 *      R.init('abc');  //=> 'ab'
 *      R.init('ab');   //=> 'a'
 *      R.init('a');    //=> ''
 *      R.init('');     //=> ''
 */ var init = /*#__PURE__*/ (0, _sliceJsDefault.default)(0, -1);
exports.default = init;

},{"./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5J9Wi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
/**
 * Takes a predicate `pred`, a list `xs`, and a list `ys`, and returns a list
 * `xs'` comprising each of the elements of `xs` which is equal to one or more
 * elements of `ys` according to `pred`.
 *
 * `pred` must be a binary function expecting an element from each list.
 *
 * `xs`, `ys`, and `xs'` are treated as sets, semantically, so ordering should
 * not be significant, but since `xs'` is ordered the implementation guarantees
 * that its values are in the same order as they appear in `xs`. Duplicates are
 * not removed, so `xs'` may contain duplicates if `xs` contains duplicates.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Relation
 * @sig ((a, b) -> Boolean) -> [a] -> [b] -> [a]
 * @param {Function} pred
 * @param {Array} xs
 * @param {Array} ys
 * @return {Array}
 * @see R.intersection
 * @example
 *
 *      R.innerJoin(
 *        (record, id) => record.id === id,
 *        [{id: 824, name: 'Richie Furay'},
 *         {id: 956, name: 'Dewey Martin'},
 *         {id: 313, name: 'Bruce Palmer'},
 *         {id: 456, name: 'Stephen Stills'},
 *         {id: 177, name: 'Neil Young'}],
 *        [177, 456, 999]
 *      );
 *      //=> [{id: 456, name: 'Stephen Stills'}, {id: 177, name: 'Neil Young'}]
 */ var innerJoin = /*#__PURE__*/ (0, _curry3JsDefault.default)(function innerJoin(pred, xs, ys) {
    return (0, _filterJsDefault.default)(function(x) {
        return (0, _includesWithJsDefault.default)(pred, x, ys);
    }, xs);
});
exports.default = innerJoin;

},{"./internal/_includesWith.js":"hGCJ4","./internal/_curry3.js":"eXJSk","./internal/_filter.js":"cCJ2i","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lluCV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Inserts the supplied element into the list, at the specified `index`. _Note that

 * this is not destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.2.2
 * @category List
 * @sig Number -> a -> [a] -> [a]
 * @param {Number} index The position to insert the element
 * @param {*} elt The element to insert into the Array
 * @param {Array} list The list to insert into
 * @return {Array} A new Array with `elt` inserted at `index`.
 * @example
 *
 *      R.insert(2, 'x', [1,2,3,4]); //=> [1,2,'x',3,4]
 */ var insert = /*#__PURE__*/ (0, _curry3JsDefault.default)(function insert(idx, elt, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    var result = Array.prototype.slice.call(list, 0);
    result.splice(idx, 0, elt);
    return result;
});
exports.default = insert;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cSbT4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Inserts the sub-list into the list, at the specified `index`. _Note that this is not
 * destructive_: it returns a copy of the list with the changes.
 * <small>No lists have been harmed in the application of this function.</small>
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category List
 * @sig Number -> [a] -> [a] -> [a]
 * @param {Number} index The position to insert the sub-list
 * @param {Array} elts The sub-list to insert into the Array
 * @param {Array} list The list to insert the sub-list into
 * @return {Array} A new Array with `elts` inserted starting at `index`.
 * @example
 *
 *      R.insertAll(2, ['x','y','z'], [1,2,3,4]); //=> [1,2,'x','y','z',3,4]
 */ var insertAll = /*#__PURE__*/ (0, _curry3JsDefault.default)(function insertAll(idx, elts, list) {
    idx = idx < list.length && idx >= 0 ? idx : list.length;
    return [].concat(Array.prototype.slice.call(list, 0, idx), elts, Array.prototype.slice.call(list, idx));
});
exports.default = insertAll;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d5sHO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _filterJs = require("./internal/_filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of those
 * elements common to both lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The list of elements found in both `list1` and `list2`.
 * @see R.innerJoin
 * @example
 *
 *      R.intersection([1,2,3,4], [7,6,5,4,3]); //=> [4, 3]
 */ var intersection = /*#__PURE__*/ (0, _curry2JsDefault.default)(function intersection(list1, list2) {
    var lookupList, filteredList;
    if (list1.length > list2.length) {
        lookupList = list1;
        filteredList = list2;
    } else {
        lookupList = list2;
        filteredList = list1;
    }
    return (0, _uniqJsDefault.default)((0, _filterJsDefault.default)((0, _flipJsDefault.default)((0, _includesJsDefault.default))(lookupList), filteredList));
});
exports.default = intersection;

},{"./internal/_includes.js":"hfNgu","./internal/_curry2.js":"fKiHC","./internal/_filter.js":"cCJ2i","./flip.js":"h3gua","./uniq.js":"b2tzD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b2tzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _uniqByJs = require("./uniqBy.js");
var _uniqByJsDefault = parcelHelpers.interopDefault(_uniqByJs);
/**
 * Returns a new list containing only one copy of each element in the original
 * list. [`R.equals`](#equals) is used to determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniq([1, 1, 2, 1]); //=> [1, 2]
 *      R.uniq([1, '1']);     //=> [1, '1']
 *      R.uniq([[42], [42]]); //=> [[42]]
 */ var uniq = /*#__PURE__*/ (0, _uniqByJsDefault.default)((0, _identityJsDefault.default));
exports.default = uniq;

},{"./identity.js":"4xoG2","./uniqBy.js":"1eIBw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1eIBw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _setJs = require("./internal/_Set.js");
var _setJsDefault = parcelHelpers.interopDefault(_setJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied function to
 * each list element. Prefers the first item if the supplied function produces
 * the same value on two items. [`R.equals`](#equals) is used for comparison.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> b) -> [a] -> [a]
 * @param {Function} fn A function used to produce a value to use during comparisons.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
 */ var uniqBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uniqBy(fn, list) {
    var set = new (0, _setJsDefault.default)();
    var result = [];
    var idx = 0;
    var appliedItem, item;
    while(idx < list.length){
        item = list[idx];
        appliedItem = fn(item);
        if (set.add(appliedItem)) result.push(item);
        idx += 1;
    }
    return result;
});
exports.default = uniqBy;

},{"./internal/_Set.js":"bPI3B","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cirXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkForMethodJs = require("./internal/_checkForMethod.js");
var _checkForMethodJsDefault = parcelHelpers.interopDefault(_checkForMethodJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var intersperse = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _checkForMethodJsDefault.default)('intersperse', function intersperse(separator, list) {
    var out = [];
    var idx = 0;
    var length = list.length;
    while(idx < length){
        if (idx === length - 1) out.push(list[idx]);
        else out.push(list[idx], separator);
        idx += 1;
    }
    return out;
}));
exports.default = intersperse;

},{"./internal/_checkForMethod.js":"5zr8J","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"Mj4ju":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneJs = require("./internal/_clone.js");
var _cloneJsDefault = parcelHelpers.interopDefault(_cloneJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isTransformerJs = require("./internal/_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _stepCatJs = require("./internal/_stepCat.js");
var _stepCatJsDefault = parcelHelpers.interopDefault(_stepCatJs);
/**
 * Transforms the items of the list with the transducer and appends the
 * transformed items to the accumulator using an appropriate iterator function
 * based on the accumulator type.
 *
 * The accumulator can be an array, string, object or a transformer. Iterated
 * items will be appended to arrays and concatenated to strings. Objects will
 * be merged directly or 2-item arrays will be merged as key, value pairs.
 *
 * The accumulator can also be a transformer object that provides a 2-arity
 * reducing iterator function, step, 0-arity initial value function, init, and
 * 1-arity result extraction function result. The step function is used as the
 * iterator function in reduce. The result function is used to convert the
 * final accumulator into the return type and in most cases is R.identity. The
 * init function is used to provide the initial accumulator.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the
 * transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig a -> (b -> b) -> [c] -> a
 * @param {*} acc The initial accumulator value.
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.transduce
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *
 *      R.into([], transducer, numbers); //=> [2, 3]
 *
 *      const intoArray = R.into([]);
 *      intoArray(transducer, numbers); //=> [2, 3]
 */ var into = /*#__PURE__*/ (0, _curry3JsDefault.default)(function into(acc, xf, list) {
    return (0, _isTransformerJsDefault.default)(acc) ? (0, _reduceJsDefault.default)(xf(acc), acc['@@transducer/init'](), list) : (0, _reduceJsDefault.default)(xf((0, _stepCatJsDefault.default)(acc)), (0, _cloneJsDefault.default)(acc, [], [], false), list);
});
exports.default = into;

},{"./internal/_clone.js":"dGsJA","./internal/_curry3.js":"eXJSk","./internal/_isTransformer.js":"7PEtz","./internal/_reduce.js":"kZKBe","./internal/_stepCat.js":"js8a2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"js8a2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_stepCat);
var _objectAssignJs = require("./_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _identityJs = require("./_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _isArrayLikeJs = require("./_isArrayLike.js");
var _isArrayLikeJsDefault = parcelHelpers.interopDefault(_isArrayLikeJs);
var _isTransformerJs = require("./_isTransformer.js");
var _isTransformerJsDefault = parcelHelpers.interopDefault(_isTransformerJs);
var _objOfJs = require("../objOf.js");
var _objOfJsDefault = parcelHelpers.interopDefault(_objOfJs);
var _stepCatArray = {
    '@@transducer/init': Array,
    '@@transducer/step': function(xs, x) {
        xs.push(x);
        return xs;
    },
    '@@transducer/result': (0, _identityJsDefault.default)
};
var _stepCatString = {
    '@@transducer/init': String,
    '@@transducer/step': function(a, b) {
        return a + b;
    },
    '@@transducer/result': (0, _identityJsDefault.default)
};
var _stepCatObject = {
    '@@transducer/init': Object,
    '@@transducer/step': function(result, input) {
        return (0, _objectAssignJsDefault.default)(result, (0, _isArrayLikeJsDefault.default)(input) ? (0, _objOfJsDefault.default)(input[0], input[1]) : input);
    },
    '@@transducer/result': (0, _identityJsDefault.default)
};
function _stepCat(obj) {
    if ((0, _isTransformerJsDefault.default)(obj)) return obj;
    if ((0, _isArrayLikeJsDefault.default)(obj)) return _stepCatArray;
    if (typeof obj === 'string') return _stepCatString;
    if (typeof obj === 'object') return _stepCatObject;
    throw new Error('Cannot create transformer for ' + obj);
}

},{"./_objectAssign.js":"aeMZL","./_identity.js":"guYHv","./_isArrayLike.js":"9cF1E","./_isTransformer.js":"7PEtz","../objOf.js":"6o9sS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aeMZL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hasJs = require("./_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
// Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
function _objectAssign(target) {
    if (target == null) throw new TypeError('Cannot convert undefined or null to object');
    var output = Object(target);
    var idx = 1;
    var length = arguments.length;
    while(idx < length){
        var source = arguments[idx];
        if (source != null) {
            for(var nextKey in source)if ((0, _hasJsDefault.default)(nextKey, source)) output[nextKey] = source[nextKey];
        }
        idx += 1;
    }
    return output;
}
exports.default = typeof Object.assign === 'function' ? Object.assign : _objectAssign;

},{"./_has.js":"lzxBF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6o9sS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates an object containing a single key:value pair.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @sig String -> a -> {String:a}
 * @param {String} key
 * @param {*} val
 * @return {Object}
 * @see R.pair
 * @example
 *
 *      const matchPhrases = R.compose(
 *        R.objOf('must'),
 *        R.map(R.objOf('match_phrase'))
 *      );
 *      matchPhrases(['foo', 'bar', 'baz']); //=> {must: [{match_phrase: 'foo'}, {match_phrase: 'bar'}, {match_phrase: 'baz'}]}
 */ var objOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function objOf(key, val) {
    var obj = {};
    obj[key] = val;
    return obj;
});
exports.default = objOf;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6GEy9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Same as [`R.invertObj`](#invertObj), however this accounts for objects with
 * duplicate values by putting the values into an array.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: [ s, ... ]}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object with keys in an array.
 * @see R.invertObj
 * @example
 *
 *      const raceResultsByFirstName = {
 *        first: 'alice',
 *        second: 'jake',
 *        third: 'alice',
 *      };
 *      R.invert(raceResultsByFirstName);
 *      //=> { 'alice': ['first', 'third'], 'jake':['second'] }
 */ var invert = /*#__PURE__*/ (0, _curry1JsDefault.default)(function invert(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        var val = obj[key];
        var list = (0, _hasJsDefault.default)(val, out) ? out[val] : out[val] = [];
        list[list.length] = key;
        idx += 1;
    }
    return out;
});
exports.default = invert;

},{"./internal/_curry1.js":"973zL","./internal/_has.js":"lzxBF","./keys.js":"7WEzg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6e4w5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * Returns a new object with the keys of the given object as values, and the
 * values of the given object, which are coerced to strings, as keys. Note
 * that the last key found is preferred when handling the same value.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {s: x} -> {x: s}
 * @param {Object} obj The object or array to invert
 * @return {Object} out A new object
 * @see R.invert
 * @example
 *
 *      const raceResults = {
 *        first: 'alice',
 *        second: 'jake'
 *      };
 *      R.invertObj(raceResults);
 *      //=> { 'alice': 'first', 'jake':'second' }
 *
 *      // Alternatively:
 *      const raceResults = ['alice', 'jake'];
 *      R.invertObj(raceResults);
 *      //=> { 'alice': '0', 'jake':'1' }
 */ var invertObj = /*#__PURE__*/ (0, _curry1JsDefault.default)(function invertObj(obj) {
    var props = (0, _keysJsDefault.default)(obj);
    var len = props.length;
    var idx = 0;
    var out = {};
    while(idx < len){
        var key = props[idx];
        out[obj[key]] = key;
        idx += 1;
    }
    return out;
});
exports.default = invertObj;

},{"./internal/_curry1.js":"973zL","./keys.js":"7WEzg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grw4w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isFunctionJs = require("./internal/_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Turns a named method with a specified arity into a function that can be
 * called directly supplied with arguments and a target object.
 *
 * The returned function is curried and accepts `arity + 1` parameters where
 * the final parameter is the target object.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig Number -> String -> (a -> b -> ... -> n -> Object -> *)
 * @param {Number} arity Number of arguments the returned function should take
 *        before the target object.
 * @param {String} method Name of the method to call.
 * @return {Function} A new curried function.
 * @see R.construct
 * @example
 *
 *      const sliceFrom = R.invoker(1, 'slice');
 *      sliceFrom(6, 'abcdefghijklm'); //=> 'ghijklm'
 *      const sliceFrom6 = R.invoker(2, 'slice')(6);
 *      sliceFrom6(8, 'abcdefghijklm'); //=> 'gh'
 * @symb R.invoker(0, 'method')(o) = o['method']()
 * @symb R.invoker(1, 'method')(a, o) = o['method'](a)
 * @symb R.invoker(2, 'method')(a, b, o) = o['method'](a, b)
 */ var invoker = /*#__PURE__*/ (0, _curry2JsDefault.default)(function invoker(arity, method) {
    return (0, _curryNJsDefault.default)(arity + 1, function() {
        var target = arguments[arity];
        if (target != null && (0, _isFunctionJsDefault.default)(target[method])) return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
        throw new TypeError((0, _toStringJsDefault.default)(target) + ' does not have a method named "' + method + '"');
    });
});
exports.default = invoker;

},{"./internal/_curry2.js":"fKiHC","./internal/_isFunction.js":"3UxAP","./curryN.js":"jig5V","./toString.js":"fffBR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXlvv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var is = /*#__PURE__*/ (0, _curry2JsDefault.default)(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
});
exports.default = is;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHFkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _emptyJs = require("./empty.js");
var _emptyJsDefault = parcelHelpers.interopDefault(_emptyJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);   //=> false
 *      R.isEmpty([]);          //=> true
 *      R.isEmpty('');          //=> true
 *      R.isEmpty(null);        //=> false
 *      R.isEmpty({});          //=> true
 *      R.isEmpty({length: 0}); //=> false
 */ var isEmpty = /*#__PURE__*/ (0, _curry1JsDefault.default)(function isEmpty(x) {
    return x != null && (0, _equalsJsDefault.default)(x, (0, _emptyJsDefault.default)(x));
});
exports.default = isEmpty;

},{"./internal/_curry1.js":"973zL","./empty.js":"aCQa1","./equals.js":"90ObX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1vMr3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * Returns a string made by inserting the `separator` between each element and
 * concatenating all the elements into a single string.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig String -> [a] -> String
 * @param {Number|String} separator The string used to separate the elements.
 * @param {Array} xs The elements to join into a string.
 * @return {String} str The string made by concatenating `xs` with `separator`.
 * @see R.split
 * @example
 *
 *      const spacer = R.join(' ');
 *      spacer(['a', 2, 3.4]);   //=> 'a 2 3.4'
 *      R.join('|', [1, 2, 3]);    //=> '1|2|3'
 */ var join = /*#__PURE__*/ (0, _invokerJsDefault.default)(1, 'join');
exports.default = join;

},{"./invoker.js":"grw4w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ezcwh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _convergeJs = require("./converge.js");
var _convergeJsDefault = parcelHelpers.interopDefault(_convergeJs);
/**
 * juxt applies a list of functions to a list of values.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Function
 * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
 * @param {Array} fns An array of functions
 * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
 * @see R.applySpec
 * @example
 *
 *      const getRange = R.juxt([Math.min, Math.max]);
 *      getRange(3, 4, 9, -3); //=> [-3, 9]
 * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
 */ var juxt = /*#__PURE__*/ (0, _curry1JsDefault.default)(function juxt(fns) {
    return (0, _convergeJsDefault.default)(function() {
        return Array.prototype.slice.call(arguments, 0);
    }, fns);
});
exports.default = juxt;

},{"./internal/_curry1.js":"973zL","./converge.js":"a3HDL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8UipG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a list containing the names of all the properties of the supplied
 * object, including prototype properties.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own and prototype properties.
 * @see R.keys, R.valuesIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.keysIn(f); //=> ['x', 'y']
 */ var keysIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function keysIn(obj) {
    var prop;
    var ks = [];
    for(prop in obj)ks[ks.length] = prop;
    return ks;
});
exports.default = keysIn;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4eL6e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isArrayJs = require("./internal/_isArray.js");
var _isArrayJsDefault = parcelHelpers.interopDefault(_isArrayJs);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns the position of the last occurrence of an item in an array, or -1 if
 * the item is not included in the array. [`R.equals`](#equals) is used to
 * determine equality.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> Number
 * @param {*} target The item to find.
 * @param {Array} xs The array to search in.
 * @return {Number} the index of the target, or -1 if the target is not found.
 * @see R.indexOf
 * @example
 *
 *      R.lastIndexOf(3, [-1,3,3,0,1,2,3,4]); //=> 6
 *      R.lastIndexOf(10, [1,2,3,4]); //=> -1
 */ var lastIndexOf = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lastIndexOf(target, xs) {
    if (typeof xs.lastIndexOf === 'function' && !(0, _isArrayJsDefault.default)(xs)) return xs.lastIndexOf(target);
    else {
        var idx = xs.length - 1;
        while(idx >= 0){
            if ((0, _equalsJsDefault.default)(xs[idx], target)) return idx;
            idx -= 1;
        }
        return -1;
    }
});
exports.default = lastIndexOf;

},{"./internal/_curry2.js":"fKiHC","./internal/_isArray.js":"lc1D3","./equals.js":"90ObX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"e5Vtn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _isNumberJs = require("./internal/_isNumber.js");
var _isNumberJsDefault = parcelHelpers.interopDefault(_isNumberJs);
/**
 * Returns the number of elements in the array by returning `list.length`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [a] -> Number
 * @param {Array} list The array to inspect.
 * @return {Number} The length of the array.
 * @example
 *
 *      R.length([]); //=> 0
 *      R.length([1, 2, 3]); //=> 3
 */ var length = /*#__PURE__*/ (0, _curry1JsDefault.default)(function length(list) {
    return list != null && (0, _isNumberJsDefault.default)(list.length) ? list.length : NaN;
});
exports.default = length;

},{"./internal/_curry1.js":"973zL","./internal/_isNumber.js":"dWS7r","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dWS7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNumber);
function _isNumber(x) {
    return Object.prototype.toString.call(x) === '[object Number]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lH0bS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
/**
 * Returns a lens for the given getter and setter functions. The getter "gets"
 * the value of the focus; the setter "sets" the value of the focus. The setter
 * should not mutate the data structure.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig (s -> a) -> ((a, s) -> s) -> Lens s a
 * @param {Function} getter
 * @param {Function} setter
 * @return {Lens}
 * @see R.view, R.set, R.over, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lens(R.prop('x'), R.assoc('x'));
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var lens = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lens(getter, setter) {
    return function(toFunctorFn) {
        return function(target) {
            return (0, _mapJsDefault.default)(function(focus) {
                return setter(focus, target);
            }, toFunctorFn(getter(target)));
        };
    };
});
exports.default = lens;

},{"./internal/_curry2.js":"fKiHC","./map.js":"6E1l9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g96qs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
var _updateJs = require("./update.js");
var _updateJsDefault = parcelHelpers.interopDefault(_updateJs);
/**
 * Returns a lens whose focus is the specified index.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Number -> Lens s a
 * @param {Number} n
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.view(headLens, ['a', 'b', 'c']);            //=> 'a'
 *      R.set(headLens, 'x', ['a', 'b', 'c']);        //=> ['x', 'b', 'c']
 *      R.over(headLens, R.toUpper, ['a', 'b', 'c']); //=> ['A', 'b', 'c']
 */ var lensIndex = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensIndex(n) {
    return (0, _lensJsDefault.default)((0, _nthJsDefault.default)(n), (0, _updateJsDefault.default)(n));
});
exports.default = lensIndex;

},{"./internal/_curry1.js":"973zL","./lens.js":"lH0bS","./nth.js":"7AaSQ","./update.js":"lbNxi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"67TaH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _assocPathJs = require("./assocPath.js");
var _assocPathJsDefault = parcelHelpers.interopDefault(_assocPathJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns a lens whose focus is the specified path.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @typedefn Idx = String | Int
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig [Idx] -> Lens s a
 * @param {Array} path The path to use.
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xHeadYLens = R.lensPath(['x', 0, 'y']);
 *
 *      R.view(xHeadYLens, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> 2
 *      R.set(xHeadYLens, 1, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: 1, z: 3}, {y: 4, z: 5}]}
 *      R.over(xHeadYLens, R.negate, {x: [{y: 2, z: 3}, {y: 4, z: 5}]});
 *      //=> {x: [{y: -2, z: 3}, {y: 4, z: 5}]}
 */ var lensPath = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensPath(p) {
    return (0, _lensJsDefault.default)((0, _pathJsDefault.default)(p), (0, _assocPathJsDefault.default)(p));
});
exports.default = lensPath;

},{"./internal/_curry1.js":"973zL","./assocPath.js":"9hyo3","./lens.js":"lH0bS","./path.js":"199kS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYEVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _assocJs = require("./assoc.js");
var _assocJsDefault = parcelHelpers.interopDefault(_assocJs);
var _lensJs = require("./lens.js");
var _lensJsDefault = parcelHelpers.interopDefault(_lensJs);
var _propJs = require("./prop.js");
var _propJsDefault = parcelHelpers.interopDefault(_propJs);
/**
 * Returns a lens whose focus is the specified property.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig String -> Lens s a
 * @param {String} k
 * @return {Lens}
 * @see R.view, R.set, R.over
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});            //=> 1
 *      R.set(xLens, 4, {x: 1, y: 2});          //=> {x: 4, y: 2}
 *      R.over(xLens, R.negate, {x: 1, y: 2});  //=> {x: -1, y: 2}
 */ var lensProp = /*#__PURE__*/ (0, _curry1JsDefault.default)(function lensProp(k) {
    return (0, _lensJsDefault.default)((0, _propJsDefault.default)(k), (0, _assocJsDefault.default)(k));
});
exports.default = lensProp;

},{"./internal/_curry1.js":"973zL","./assoc.js":"kx0W3","./lens.js":"lH0bS","./prop.js":"h0KMs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"79IqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is less than the second; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @see R.gt
 * @example
 *
 *      R.lt(2, 1); //=> false
 *      R.lt(2, 2); //=> false
 *      R.lt(2, 3); //=> true
 *      R.lt('a', 'z'); //=> true
 *      R.lt('z', 'a'); //=> false
 */ var lt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lt(a, b) {
    return a < b;
});
exports.default = lt;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21lPg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns `true` if the first argument is less than or equal to the second;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> Boolean
 * @param {Number} a
 * @param {Number} b
 * @return {Boolean}
 * @see R.gte
 * @example
 *
 *      R.lte(2, 1); //=> false
 *      R.lte(2, 2); //=> true
 *      R.lte(2, 3); //=> true
 *      R.lte('a', 'z'); //=> true
 *      R.lte('z', 'a'); //=> false
 */ var lte = /*#__PURE__*/ (0, _curry2JsDefault.default)(function lte(a, b) {
    return a <= b;
});
exports.default = lte;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dX8Hb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * The `mapAccum` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from left to right, and returning a final value of this
 * accumulator together with the new list.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.scan, R.addIndex, R.mapAccumRight
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [a + b, a + b];
 *
 *      R.mapAccum(appender, 0, digits); //=> ['01234', ['01', '012', '0123', '01234']]
 * @symb R.mapAccum(f, a, [b, c, d]) = [
 *   f(f(f(a, b)[0], c)[0], d)[0],
 *   [
 *     f(a, b)[1],
 *     f(f(a, b)[0], c)[1],
 *     f(f(f(a, b)[0], c)[0], d)[1]
 *   ]
 * ]
 */ var mapAccum = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mapAccum(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx < len){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx += 1;
    }
    return [
        tuple[0],
        result
    ];
});
exports.default = mapAccum;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7OqYT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * The `mapAccumRight` function behaves like a combination of map and reduce; it
 * applies a function to each element of a list, passing an accumulating
 * parameter from right to left, and returning a final value of this
 * accumulator together with the new list.
 *
 * Similar to [`mapAccum`](#mapAccum), except moves through the input list from
 * the right to the left.
 *
 * The iterator function receives two arguments, *acc* and *value*, and should
 * return a tuple *[acc, value]*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((acc, x) -> (acc, y)) -> acc -> [x] -> (acc, [y])
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.addIndex, R.mapAccum
 * @example
 *
 *      const digits = ['1', '2', '3', '4'];
 *      const appender = (a, b) => [b + a, b + a];
 *
 *      R.mapAccumRight(appender, 5, digits); //=> ['12345', ['12345', '2345', '345', '45']]
 * @symb R.mapAccumRight(f, a, [b, c, d]) = [
 *   f(f(f(a, d)[0], c)[0], b)[0],
 *   [
 *     f(a, d)[1],
 *     f(f(a, d)[0], c)[1],
 *     f(f(f(a, d)[0], c)[0], b)[1]
 *   ]
 * ]
 */ var mapAccumRight = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mapAccumRight(fn, acc, list) {
    var idx = list.length - 1;
    var result = [];
    var tuple = [
        acc
    ];
    while(idx >= 0){
        tuple = fn(tuple[0], list[idx]);
        result[idx] = tuple[1];
        idx -= 1;
    }
    return [
        tuple[0],
        result
    ];
});
exports.default = mapAccumRight;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eBjyt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _keysJs = require("./keys.js");
var _keysJsDefault = parcelHelpers.interopDefault(_keysJs);
/**
 * An Object-specific version of [`map`](#map). The function is applied to three
 * arguments: *(value, key, obj)*. If only the value is significant, use
 * [`map`](#map) instead.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig ((*, String, Object) -> *) -> Object -> Object
 * @param {Function} fn
 * @param {Object} obj
 * @return {Object}
 * @see R.map
 * @example
 *
 *      const xyz = { x: 1, y: 2, z: 3 };
 *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
 *
 *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
 */ var mapObjIndexed = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mapObjIndexed(fn, obj) {
    return (0, _reduceJsDefault.default)(function(acc, key) {
        acc[key] = fn(obj[key], key, obj);
        return acc;
    }, {}, (0, _keysJsDefault.default)(obj));
});
exports.default = mapObjIndexed;

},{"./internal/_curry2.js":"fKiHC","./internal/_reduce.js":"kZKBe","./keys.js":"7WEzg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6fhHQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Tests a regular expression against a String. Note that this function will
 * return an empty array when there are no matches. This differs from
 * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
 * which returns `null` when there are no matches.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig RegExp -> String -> [String | Undefined]
 * @param {RegExp} rx A regular expression.
 * @param {String} str The string to match against
 * @return {Array} The list of matches or empty array.
 * @see R.test
 * @example
 *
 *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
 *      R.match(/a/, 'b'); //=> []
 *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
 */ var match = /*#__PURE__*/ (0, _curry2JsDefault.default)(function match(rx, str) {
    return str.match(rx) || [];
});
exports.default = match;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9KvOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isIntegerJs = require("./internal/_isInteger.js");
var _isIntegerJsDefault = parcelHelpers.interopDefault(_isIntegerJs);
/**
 * `mathMod` behaves like the modulo operator should mathematically, unlike the
 * `%` operator (and by extension, [`R.modulo`](#modulo)). So while
 * `-17 % 5` is `-2`, `mathMod(-17, 5)` is `3`. `mathMod` requires Integer
 * arguments, and returns NaN when the modulus is zero or negative.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} m The dividend.
 * @param {Number} p the modulus.
 * @return {Number} The result of `b mod a`.
 * @see R.modulo
 * @example
 *
 *      R.mathMod(-17, 5);  //=> 3
 *      R.mathMod(17, 5);   //=> 2
 *      R.mathMod(17, -5);  //=> NaN
 *      R.mathMod(17, 0);   //=> NaN
 *      R.mathMod(17.2, 5); //=> NaN
 *      R.mathMod(17, 5.3); //=> NaN
 *
 *      const clock = R.mathMod(R.__, 12);
 *      clock(15); //=> 3
 *      clock(24); //=> 0
 *
 *      const seventeenMod = R.mathMod(17);
 *      seventeenMod(3);  //=> 2
 *      seventeenMod(4);  //=> 1
 *      seventeenMod(10); //=> 7
 */ var mathMod = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mathMod(m, p) {
    if (!(0, _isIntegerJsDefault.default)(m)) return NaN;
    if (!(0, _isIntegerJsDefault.default)(p) || p < 1) return NaN;
    return (m % p + p) % p;
});
exports.default = mathMod;

},{"./internal/_curry2.js":"fKiHC","./internal/_isInteger.js":"69VMa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eoyZO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a function and two values, and returns whichever value produces the
 * larger result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.max, R.minBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.maxBy(square, -3, 2); //=> -3
 *
 *      R.reduce(R.maxBy(square), 0, [3, -5, 4, 1, -2]); //=> -5
 *      R.reduce(R.maxBy(square), 0, []); //=> 0
 */ var maxBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function maxBy(f, a, b) {
    return f(b) > f(a) ? b : a;
});
exports.default = maxBy;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1LUYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _sumJs = require("./sum.js");
var _sumJsDefault = parcelHelpers.interopDefault(_sumJs);
/**
 * Returns the mean of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.median
 * @example
 *
 *      R.mean([2, 7, 9]); //=> 6
 *      R.mean([]); //=> NaN
 */ var mean = /*#__PURE__*/ (0, _curry1JsDefault.default)(function mean(list) {
    return (0, _sumJsDefault.default)(list) / list.length;
});
exports.default = mean;

},{"./internal/_curry1.js":"973zL","./sum.js":"cJJ21","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cJJ21":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _addJs = require("./add.js");
var _addJsDefault = parcelHelpers.interopDefault(_addJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Adds together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The sum of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.sum([2,4,6,8,100,1]); //=> 121
 */ var sum = /*#__PURE__*/ (0, _reduceJsDefault.default)((0, _addJsDefault.default), 0);
exports.default = sum;

},{"./add.js":"49LDq","./reduce.js":"14LEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aewWO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _meanJs = require("./mean.js");
var _meanJsDefault = parcelHelpers.interopDefault(_meanJs);
/**
 * Returns the median of the given list of numbers.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list
 * @return {Number}
 * @see R.mean
 * @example
 *
 *      R.median([2, 9, 7]); //=> 7
 *      R.median([7, 2, 10, 9]); //=> 8
 *      R.median([]); //=> NaN
 */ var median = /*#__PURE__*/ (0, _curry1JsDefault.default)(function median(list) {
    var len = list.length;
    if (len === 0) return NaN;
    var width = 2 - len % 2;
    var idx = (len - width) / 2;
    return (0, _meanJsDefault.default)(Array.prototype.slice.call(list, 0).sort(function(a, b) {
        return a < b ? -1 : a > b ? 1 : 0;
    }).slice(idx, idx + width));
});
exports.default = median;

},{"./internal/_curry1.js":"973zL","./mean.js":"1LUYn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3P7V2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Creates a new function that, when invoked, caches the result of calling `fn`
 * for a given argument set and returns the result. Subsequent calls to the
 * memoized `fn` with the same argument set will not result in an additional
 * call to `fn`; instead, the cached result for that set of arguments will be
 * returned.
 *
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (*... -> String) -> (*... -> a) -> (*... -> a)
 * @param {Function} fn The function to generate the cache key.
 * @param {Function} fn The function to memoize.
 * @return {Function} Memoized version of `fn`.
 * @example
 *
 *      let count = 0;
 *      const factorial = R.memoizeWith(R.identity, n => {
 *        count += 1;
 *        return R.product(R.range(1, n + 1));
 *      });
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      factorial(5); //=> 120
 *      count; //=> 1
 */ var memoizeWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function memoizeWith(mFn, fn) {
    var cache = {};
    return (0, _arityJsDefault.default)(fn.length, function() {
        var key = mFn.apply(this, arguments);
        if (!(0, _hasJsDefault.default)(key, cache)) cache[key] = fn.apply(this, arguments);
        return cache[key];
    });
});
exports.default = memoizeWith;

},{"./internal/_arity.js":"cUJua","./internal/_curry2.js":"fKiHC","./internal/_has.js":"lzxBF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a1HMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @deprecated
 * @example
 *
 *      R.merge({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.merge({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.merge(a, b) = {...a, ...b}
 */ var merge = /*#__PURE__*/ (0, _curry2JsDefault.default)(function merge(l, r) {
    return (0, _objectAssignJsDefault.default)({}, l, r);
});
exports.default = merge;

},{"./internal/_objectAssign.js":"aeMZL","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"krREj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Merges a list of objects together into one object.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig [{k: v}] -> {k: v}
 * @param {Array} list An array of objects
 * @return {Object} A merged object.
 * @see R.reduce
 * @example
 *
 *      R.mergeAll([{foo:1},{bar:2},{baz:3}]); //=> {foo:1,bar:2,baz:3}
 *      R.mergeAll([{foo:1},{foo:2},{bar:2}]); //=> {foo:2,bar:2}
 * @symb R.mergeAll([{ x: 1 }, { y: 2 }, { z: 3 }]) = { x: 1, y: 2, z: 3 }
 */ var mergeAll = /*#__PURE__*/ (0, _curry1JsDefault.default)(function mergeAll(list) {
    return (0, _objectAssignJsDefault.default).apply(null, [
        {}
    ].concat(list));
});
exports.default = mergeAll;

},{"./internal/_objectAssign.js":"aeMZL","./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cqixg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var mergeDeepLeft = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeDeepLeft(lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
exports.default = mergeDeepLeft;

},{"./internal/_curry2.js":"fKiHC","./mergeDeepWithKey.js":"b8F2l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b8F2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isObjectJs = require("./internal/_isObject.js");
var _isObjectJsDefault = parcelHelpers.interopDefault(_isObjectJs);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var mergeDeepWithKey = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeDeepWithKey(fn, lObj, rObj) {
    return (0, _mergeWithKeyJsDefault.default)(function(k, lVal, rVal) {
        if ((0, _isObjectJsDefault.default)(lVal) && (0, _isObjectJsDefault.default)(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
exports.default = mergeDeepWithKey;

},{"./internal/_curry3.js":"eXJSk","./internal/_isObject.js":"1GAHA","./mergeWithKey.js":"gJMdQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJMdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.merge, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var mergeWithKey = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    for(k in l)if ((0, _hasJsDefault.default)(k, l)) result[k] = (0, _hasJsDefault.default)(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ((0, _hasJsDefault.default)(k, r) && !(0, _hasJsDefault.default)(k, result)) result[k] = r[k];
    return result;
});
exports.default = mergeWithKey;

},{"./internal/_curry3.js":"eXJSk","./internal/_has.js":"lzxBF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8GsaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.merge, R.mergeDeepLeft, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepRight({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                       { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 40, contact: { email: 'baa@example.com' }}
 */ var mergeDeepRight = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeDeepRight(lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return rVal;
    }, lObj, rObj);
});
exports.default = mergeDeepRight;

},{"./internal/_curry2.js":"fKiHC","./mergeDeepWithKey.js":"b8F2l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h3QRA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mergeDeepWithKeyJs = require("./mergeDeepWithKey.js");
var _mergeDeepWithKeyJsDefault = parcelHelpers.interopDefault(_mergeDeepWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to associated values using the
 *   resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepWith(R.concat,
 *                      { a: true, c: { values: [10, 20] }},
 *                      { b: true, c: { values: [15, 35] }});
 *      //=> { a: true, b: true, c: { values: [10, 20, 15, 35] }}
 */ var mergeDeepWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeDeepWith(fn, lObj, rObj) {
    return (0, _mergeDeepWithKeyJsDefault.default)(function(k, lVal, rVal) {
        return fn(lVal, rVal);
    }, lObj, rObj);
});
exports.default = mergeDeepWith;

},{"./internal/_curry3.js":"eXJSk","./mergeDeepWithKey.js":"b8F2l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iNxOF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeRight, R.mergeDeepLeft, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeLeft({ 'age': 40 }, { 'name': 'fred', 'age': 10 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const resetToDefault = R.mergeLeft({x: 0});
 *      resetToDefault({x: 5, y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeLeft(a, b) = {...b, ...a}
 */ var mergeLeft = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeLeft(l, r) {
    return (0, _objectAssignJsDefault.default)({}, r, l);
});
exports.default = mergeLeft;

},{"./internal/_objectAssign.js":"aeMZL","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"84OnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectAssignJs = require("./internal/_objectAssign.js");
var _objectAssignJsDefault = parcelHelpers.interopDefault(_objectAssignJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Create a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects,
 * the value from the second object will be used.
 *
 * @func
 * @memberOf R
 * @category Object
 * @sig {k: v} -> {k: v} -> {k: v}
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
 * @example
 *
 *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
 *      //=> { 'name': 'fred', 'age': 40 }
 *
 *      const withDefaults = R.mergeRight({x: 0, y: 0});
 *      withDefaults({y: 2}); //=> {x: 0, y: 2}
 * @symb R.mergeRight(a, b) = {...a, ...b}
 */ var mergeRight = /*#__PURE__*/ (0, _curry2JsDefault.default)(function mergeRight(l, r) {
    return (0, _objectAssignJsDefault.default)({}, l, r);
});
exports.default = mergeRight;

},{"./internal/_objectAssign.js":"aeMZL","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"742mQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mergeWithKeyJs = require("./mergeWithKey.js");
var _mergeWithKeyJsDefault = parcelHelpers.interopDefault(_mergeWithKeyJs);
/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the values
 * associated with the key in each object, with the result being used as the
 * value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWith, R.merge, R.mergeWithKey
 * @example
 *
 *      R.mergeWith(R.concat,
 *                  { a: true, values: [10, 20] },
 *                  { b: true, values: [15, 35] });
 *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
 */ var mergeWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function mergeWith(fn, l, r) {
    return (0, _mergeWithKeyJsDefault.default)(function(_, _l, _r) {
        return fn(_l, _r);
    }, l, r);
});
exports.default = mergeWith;

},{"./internal/_curry3.js":"eXJSk","./mergeWithKey.js":"gJMdQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"39La5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns the smaller of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.minBy, R.max
 * @example
 *
 *      R.min(789, 123); //=> 123
 *      R.min('a', 'b'); //=> 'a'
 */ var min = /*#__PURE__*/ (0, _curry2JsDefault.default)(function min(a, b) {
    return b < a ? b : a;
});
exports.default = min;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1gZ6y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a function and two values, and returns whichever value produces the
 * smaller result when passed to the provided function.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Relation
 * @sig Ord b => (a -> b) -> a -> a -> a
 * @param {Function} f
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.min, R.maxBy
 * @example
 *
 *      //  square :: Number -> Number
 *      const square = n => n * n;
 *
 *      R.minBy(square, -3, 2); //=> 2
 *
 *      R.reduce(R.minBy(square), Infinity, [3, -5, 4, 1, -2]); //=> 1
 *      R.reduce(R.minBy(square), Infinity, []); //=> Infinity
 */ var minBy = /*#__PURE__*/ (0, _curry3JsDefault.default)(function minBy(f, a, b) {
    return f(b) < f(a) ? b : a;
});
exports.default = minBy;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fGzv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Divides the first parameter by the second and returns the remainder. Note
 * that this function preserves the JavaScript-style behavior for modulo. For
 * mathematical modulo see [`mathMod`](#mathMod).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The value to the divide.
 * @param {Number} b The pseudo-modulus
 * @return {Number} The result of `b % a`.
 * @see R.mathMod
 * @example
 *
 *      R.modulo(17, 3); //=> 2
 *      // JS behavior:
 *      R.modulo(-17, 3); //=> -2
 *      R.modulo(17, -3); //=> 2
 *
 *      const isOdd = R.modulo(R.__, 2);
 *      isOdd(42); //=> 0
 *      isOdd(21); //=> 1
 */ var modulo = /*#__PURE__*/ (0, _curry2JsDefault.default)(function modulo(a, b) {
    return a % b;
});
exports.default = modulo;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dF01F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var move = /*#__PURE__*/ (0, _curry3JsDefault.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
exports.default = move;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0Qo1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Multiplies two numbers. Equivalent to `a * b` but curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a * b`.
 * @see R.divide
 * @example
 *
 *      const double = R.multiply(2);
 *      const triple = R.multiply(3);
 *      double(3);       //=>  6
 *      triple(4);       //=> 12
 *      R.multiply(2, 5);  //=> 10
 */ var multiply = /*#__PURE__*/ (0, _curry2JsDefault.default)(function multiply(a, b) {
    return a * b;
});
exports.default = multiply;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kxxsb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Negates its argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Math
 * @sig Number -> Number
 * @param {Number} n
 * @return {Number}
 * @example
 *
 *      R.negate(42); //=> -42
 */ var negate = /*#__PURE__*/ (0, _curry1JsDefault.default)(function negate(n) {
    return -n;
});
exports.default = negate;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Na1O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _complementJs = require("./internal/_complement.js");
var _complementJsDefault = parcelHelpers.interopDefault(_complementJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _allJs = require("./all.js");
var _allJsDefault = parcelHelpers.interopDefault(_allJs);
/**
 * Returns `true` if no elements of the list match the predicate, `false`
 * otherwise.
 *
 * Dispatches to the `all` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> Boolean
 * @param {Function} fn The predicate function.
 * @param {Array} list The array to consider.
 * @return {Boolean} `true` if the predicate is not satisfied by every element, `false` otherwise.
 * @see R.all, R.any
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *      const isOdd = n => n % 2 === 1;
 *
 *      R.none(isEven, [1, 3, 5, 7, 9, 11]); //=> true
 *      R.none(isOdd, [1, 3, 5, 7, 8, 11]); //=> false
 */ var none = /*#__PURE__*/ (0, _curry2JsDefault.default)(function none(fn, input) {
    return (0, _allJsDefault.default)((0, _complementJsDefault.default)(fn), input);
});
exports.default = none;

},{"./internal/_complement.js":"lDJPC","./internal/_curry2.js":"fKiHC","./all.js":"a9Bza","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7zaHU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _nthJs = require("./nth.js");
var _nthJsDefault = parcelHelpers.interopDefault(_nthJs);
/**
 * Returns a function which returns its nth argument.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig Number -> *... -> *
 * @param {Number} n
 * @return {Function}
 * @example
 *
 *      R.nthArg(1)('a', 'b', 'c'); //=> 'b'
 *      R.nthArg(-1)('a', 'b', 'c'); //=> 'c'
 * @symb R.nthArg(-1)(a, b, c) = c
 * @symb R.nthArg(0)(a, b, c) = a
 * @symb R.nthArg(1)(a, b, c) = b
 */ var nthArg = /*#__PURE__*/ (0, _curry1JsDefault.default)(function nthArg(n) {
    var arity = n < 0 ? 1 : n + 1;
    return (0, _curryNJsDefault.default)(arity, function() {
        return (0, _nthJsDefault.default)(n, arguments);
    });
});
exports.default = nthArg;

},{"./internal/_curry1.js":"973zL","./curryN.js":"jig5V","./nth.js":"7AaSQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"oAU7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * `o` is a curried composition function that returns a unary function.
 * Like [`compose`](#compose), `o` performs right-to-left function composition.
 * Unlike [`compose`](#compose), the rightmost function passed to `o` will be
 * invoked with only one argument. Also, unlike [`compose`](#compose), `o` is
 * limited to accepting only 2 unary functions. The name o was chosen because
 * of its similarity to the mathematical composition operator ∘.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Function
 * @sig (b -> c) -> (a -> b) -> a -> c
 * @param {Function} f
 * @param {Function} g
 * @return {Function}
 * @see R.compose, R.pipe
 * @example
 *
 *      const classyGreeting = name => "The name's " + name.last + ", " + name.first + " " + name.last
 *      const yellGreeting = R.o(R.toUpper, classyGreeting);
 *      yellGreeting({first: 'James', last: 'Bond'}); //=> "THE NAME'S BOND, JAMES BOND"
 *
 *      R.o(R.multiply(10), R.add(10))(-4) //=> 60
 *
 * @symb R.o(f, g, x) = f(g(x))
 */ var o = /*#__PURE__*/ (0, _curry3JsDefault.default)(function o(f, g, x) {
    return f(g(x));
});
exports.default = o;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6WcyW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _ofJs = require("./internal/_of.js");
var _ofJsDefault = parcelHelpers.interopDefault(_ofJs);
/**
 * Returns a singleton array containing the value provided.
 *
 * Note this `of` is different from the ES6 `of`; See
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/of
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> [a]
 * @param {*} x any value
 * @return {Array} An array wrapping `x`.
 * @example
 *
 *      R.of(null); //=> [null]
 *      R.of([42]); //=> [[42]]
 */ var of = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _ofJsDefault.default));
exports.default = of;

},{"./internal/_curry1.js":"973zL","./internal/_of.js":"8RE2t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8RE2t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_of);
function _of(x) {
    return [
        x
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gZqX4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object omitting the keys specified.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [String] -> {String: *} -> {String: *}
 * @param {Array} names an array of String property names to omit from the new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with properties from `names` not on it.
 * @see R.pick
 * @example
 *
 *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
 */ var omit = /*#__PURE__*/ (0, _curry2JsDefault.default)(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        index[names[idx]] = 1;
        idx += 1;
    }
    for(var prop in obj)if (!index.hasOwnProperty(prop)) result[prop] = obj[prop];
    return result;
});
exports.default = omit;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iskcq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Accepts a function `fn` and returns a function that guards invocation of
 * `fn` such that `fn` can only ever be called once, no matter how many times
 * the returned function is invoked. The first value calculated is returned in
 * subsequent invocations.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a... -> b) -> (a... -> b)
 * @param {Function} fn The function to wrap in a call-only-once wrapper.
 * @return {Function} The wrapped function.
 * @example
 *
 *      const addOneOnce = R.once(x => x + 1);
 *      addOneOnce(10); //=> 11
 *      addOneOnce(addOneOnce(50)); //=> 11
 */ var once = /*#__PURE__*/ (0, _curry1JsDefault.default)(function once(fn) {
    var called = false;
    var result;
    return (0, _arityJsDefault.default)(fn.length, function() {
        if (called) return result;
        called = true;
        result = fn.apply(this, arguments);
        return result;
    });
});
exports.default = once;

},{"./internal/_arity.js":"cUJua","./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fO0Ys":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _assertPromiseJs = require("./internal/_assertPromise.js");
var _assertPromiseJsDefault = parcelHelpers.interopDefault(_assertPromiseJs);
/**
 * Returns the result of applying the onFailure function to the value inside
 * a failed promise. This is useful for handling rejected promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig (e -> b) -> (Promise e a) -> (Promise e b)
 * @sig (e -> (Promise f b)) -> (Promise e a) -> (Promise f b)
 * @param {Function} onFailure The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(null, onFailure)`
 * @see R.then
 * @example
 *
 *      var failedFetch = (id) => Promise.reject('bad ID');
 *      var useDefault = () => ({ firstName: 'Bob', lastName: 'Loblaw' })
 *
 *      //recoverFromFailure :: String -> Promise ({firstName, lastName})
 *      var recoverFromFailure = R.pipe(
 *        failedFetch,
 *        R.otherwise(useDefault),
 *        R.then(R.pick(['firstName', 'lastName'])),
 *      );
 *      recoverFromFailure(12345).then(console.log)
 */ var otherwise = /*#__PURE__*/ (0, _curry2JsDefault.default)(function otherwise(f, p) {
    (0, _assertPromiseJsDefault.default)('otherwise', p);
    return p.then(null, f);
});
exports.default = otherwise;

},{"./internal/_curry2.js":"fKiHC","./internal/_assertPromise.js":"aX6ak","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aX6ak":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertPromise);
var _isFunctionJs = require("./_isFunction.js");
var _isFunctionJsDefault = parcelHelpers.interopDefault(_isFunctionJs);
var _toStringJs = require("./_toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
function _assertPromise(name, p) {
    if (p == null || !(0, _isFunctionJsDefault.default)(p.then)) throw new TypeError('`' + name + '` expected a Promise, received ' + (0, _toStringJsDefault.default)(p, []));
}

},{"./_isFunction.js":"3UxAP","./_toString.js":"4cnPl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8vrvT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
// `Identity` is a functor that holds a single value, where `map` simply
// transforms the held value with the provided function.
var Identity = function(x) {
    return {
        value: x,
        map: function(f) {
            return Identity(f(x));
        }
    };
};
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the result of applying the given function to
 * the focused value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> (a -> a) -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const headLens = R.lensIndex(0);
 *
 *      R.over(headLens, R.toUpper, ['foo', 'bar', 'baz']); //=> ['FOO', 'bar', 'baz']
 */ var over = /*#__PURE__*/ (0, _curry3JsDefault.default)(function over(lens, f, x) {
    // The value returned by the getter function is first transformed with `f`,
    // then set as the value of an `Identity`. This is then mapped over with the
    // setter function of the lens.
    return lens(function(y) {
        return Identity(f(y));
    })(x).value;
});
exports.default = over;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3v1DQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes two arguments, `fst` and `snd`, and returns `[fst, snd]`.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category List
 * @sig a -> b -> (a,b)
 * @param {*} fst
 * @param {*} snd
 * @return {Array}
 * @see R.objOf, R.of
 * @example
 *
 *      R.pair('foo', 'bar'); //=> ['foo', 'bar']
 */ var pair = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pair(fst, snd) {
    return [
        fst,
        snd
    ];
});
exports.default = pair;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7G4P4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _createPartialApplicatorJs = require("./internal/_createPartialApplicator.js");
var _createPartialApplicatorJsDefault = parcelHelpers.interopDefault(_createPartialApplicatorJs);
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided initially followed by the arguments provided to `g`.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [a, b, c, ...] -> ((d, e, f, ..., n) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partialRight, R.curry
 * @example
 *
 *      const multiply2 = (a, b) => a * b;
 *      const double = R.partial(multiply2, [2]);
 *      double(2); //=> 4
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const sayHello = R.partial(greet, ['Hello']);
 *      const sayHelloToMs = R.partial(sayHello, ['Ms.']);
 *      sayHelloToMs('Jane', 'Jones'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partial(f, [a, b])(c, d) = f(a, b, c, d)
 */ var partial = /*#__PURE__*/ (0, _createPartialApplicatorJsDefault.default)((0, _concatJsDefault.default));
exports.default = partial;

},{"./internal/_concat.js":"hXJys","./internal/_createPartialApplicator.js":"6CTOX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6CTOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createPartialApplicator);
var _arityJs = require("./_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
function _createPartialApplicator(concat) {
    return (0, _curry2JsDefault.default)(function(fn, args) {
        return (0, _arityJsDefault.default)(Math.max(0, fn.length - args.length), function() {
            return fn.apply(this, concat(args, arguments));
        });
    });
}

},{"./_arity.js":"cUJua","./_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4c0xc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _createPartialApplicatorJs = require("./internal/_createPartialApplicator.js");
var _createPartialApplicatorJsDefault = parcelHelpers.interopDefault(_createPartialApplicatorJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
/**
 * Takes a function `f` and a list of arguments, and returns a function `g`.
 * When applied, `g` returns the result of applying `f` to the arguments
 * provided to `g` followed by the arguments provided initially.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category Function
 * @sig ((a, b, c, ..., n) -> x) -> [d, e, f, ..., n] -> ((a, b, c, ...) -> x)
 * @param {Function} f
 * @param {Array} args
 * @return {Function}
 * @see R.partial
 * @example
 *
 *      const greet = (salutation, title, firstName, lastName) =>
 *        salutation + ', ' + title + ' ' + firstName + ' ' + lastName + '!';
 *
 *      const greetMsJaneJones = R.partialRight(greet, ['Ms.', 'Jane', 'Jones']);
 *
 *      greetMsJaneJones('Hello'); //=> 'Hello, Ms. Jane Jones!'
 * @symb R.partialRight(f, [a, b])(c, d) = f(c, d, a, b)
 */ var partialRight = /*#__PURE__*/ (0, _createPartialApplicatorJsDefault.default)(/*#__PURE__*/ (0, _flipJsDefault.default)((0, _concatJsDefault.default)));
exports.default = partialRight;

},{"./internal/_concat.js":"hXJys","./internal/_createPartialApplicator.js":"6CTOX","./flip.js":"h3gua","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h7rnv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _filterJs = require("./filter.js");
var _filterJsDefault = parcelHelpers.interopDefault(_filterJs);
var _juxtJs = require("./juxt.js");
var _juxtJsDefault = parcelHelpers.interopDefault(_juxtJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
/**
 * Takes a predicate and a list or other `Filterable` object and returns the
 * pair of filterable objects of the same type of elements which do and do not
 * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
 * @param {Function} pred A predicate to determine which side the element belongs to.
 * @param {Array} filterable the list (or other filterable) to partition.
 * @return {Array} An array, containing first the subset of elements that satisfy the
 *         predicate, and second the subset of elements that do not satisfy.
 * @see R.filter, R.reject
 * @example
 *
 *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
 *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
 *
 *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
 *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
 */ var partition = /*#__PURE__*/ (0, _juxtJsDefault.default)([
    (0, _filterJsDefault.default),
    (0, _rejectJsDefault.default)
]);
exports.default = partition;

},{"./filter.js":"kidP8","./juxt.js":"ezcwh","./reject.js":"4OIPW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"90Y4R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Determines whether a nested path on an object has a specific value, in
 * [`R.equals`](#equals) terms. Most likely used to filter a list.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Relation
 * @typedefn Idx = String | Int
 * @sig [Idx] -> a -> {a} -> Boolean
 * @param {Array} path The path of the nested property to use
 * @param {*} val The value to compare the nested property with
 * @param {Object} obj The object to check the nested property in
 * @return {Boolean} `true` if the value equals the nested object property,
 *         `false` otherwise.
 * @example
 *
 *      const user1 = { address: { zipCode: 90210 } };
 *      const user2 = { address: { zipCode: 55555 } };
 *      const user3 = { name: 'Bob' };
 *      const users = [ user1, user2, user3 ];
 *      const isFamous = R.pathEq(['address', 'zipCode'], 90210);
 *      R.filter(isFamous, users); //=> [ user1 ]
 */ var pathEq = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathEq(_path, val, obj) {
    return (0, _equalsJsDefault.default)((0, _pathJsDefault.default)(_path, obj), val);
});
exports.default = pathEq;

},{"./internal/_curry3.js":"eXJSk","./equals.js":"90ObX","./path.js":"199kS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"56c6t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _defaultToJs = require("./defaultTo.js");
var _defaultToJsDefault = parcelHelpers.interopDefault(_defaultToJs);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * If the given, non-null object has a value at the given path, returns the
 * value at that path. Otherwise returns the provided default value.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig a -> [Idx] -> {a} -> a
 * @param {*} d The default value.
 * @param {Array} p The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path` of the supplied object or the default value.
 * @example
 *
 *      R.pathOr('N/A', ['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.pathOr('N/A', ['a', 'b'], {c: {b: 2}}); //=> "N/A"
 */ var pathOr = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathOr(d, p, obj) {
    return (0, _defaultToJsDefault.default)(d, (0, _pathJsDefault.default)(p, obj));
});
exports.default = pathOr;

},{"./internal/_curry3.js":"eXJSk","./defaultTo.js":"j7d9y","./path.js":"199kS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6QmpS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _pathJs = require("./path.js");
var _pathJsDefault = parcelHelpers.interopDefault(_pathJs);
/**
 * Returns `true` if the specified object property at given path satisfies the
 * given predicate; `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Logic
 * @typedefn Idx = String | Int
 * @sig (a -> Boolean) -> [Idx] -> {a} -> Boolean
 * @param {Function} pred
 * @param {Array} propPath
 * @param {*} obj
 * @return {Boolean}
 * @see R.propSatisfies, R.path
 * @example
 *
 *      R.pathSatisfies(y => y > 0, ['x', 'y'], {x: {y: 2}}); //=> true
 */ var pathSatisfies = /*#__PURE__*/ (0, _curry3JsDefault.default)(function pathSatisfies(pred, propPath, obj) {
    return propPath.length > 0 && pred((0, _pathJsDefault.default)(propPath, obj));
});
exports.default = pathSatisfies;

},{"./internal/_curry3.js":"eXJSk","./path.js":"199kS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iSGes":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object containing only the keys specified. If
 * the key does not exist, the property is ignored.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.omit, R.props
 * @example
 *
 *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
 */ var pick = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pick(names, obj) {
    var result = {};
    var idx = 0;
    while(idx < names.length){
        if (names[idx] in obj) result[names[idx]] = obj[names[idx]];
        idx += 1;
    }
    return result;
});
exports.default = pick;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7mkXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Similar to `pick` except that this one includes a `key: undefined` pair for
 * properties that don't exist.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> {k: v}
 * @param {Array} names an array of String property names to copy onto a new object
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties from `names` on it.
 * @see R.pick
 * @example
 *
 *      R.pickAll(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
 *      R.pickAll(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, e: undefined, f: undefined}
 */ var pickAll = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pickAll(names, obj) {
    var result = {};
    var idx = 0;
    var len = names.length;
    while(idx < len){
        var name = names[idx];
        result[name] = obj[name];
        idx += 1;
    }
    return result;
});
exports.default = pickAll;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hESLr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a partial copy of an object containing only the keys that satisfy
 * the supplied predicate.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Object
 * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
 * @param {Function} pred A predicate to determine whether or not a key
 *        should be included on the output object.
 * @param {Object} obj The object to copy from
 * @return {Object} A new object with only properties that satisfy `pred`
 *         on it.
 * @see R.pick, R.filter
 * @example
 *
 *      const isUpperCase = (val, key) => key.toUpperCase() === key;
 *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
 */ var pickBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function pickBy(test, obj) {
    var result = {};
    for(var prop in obj)if (test(obj[prop], prop, obj)) result[prop] = obj[prop];
    return result;
});
exports.default = pickBy;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1P96O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pipeK);
var _composeKJs = require("./composeK.js");
var _composeKJsDefault = parcelHelpers.interopDefault(_composeKJs);
var _reverseJs = require("./reverse.js");
var _reverseJsDefault = parcelHelpers.interopDefault(_reverseJs);
function pipeK() {
    if (arguments.length === 0) throw new Error('pipeK requires at least one argument');
    return (0, _composeKJsDefault.default).apply(this, (0, _reverseJsDefault.default)(arguments));
}

},{"./composeK.js":"fmXwQ","./reverse.js":"kusbf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ihMcA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list with the given element at the front, followed by the
 * contents of the list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} el The item to add to the head of the output list.
 * @param {Array} list The array to add to the tail of the output list.
 * @return {Array} A new array.
 * @see R.append
 * @example
 *
 *      R.prepend('fee', ['fi', 'fo', 'fum']); //=> ['fee', 'fi', 'fo', 'fum']
 */ var prepend = /*#__PURE__*/ (0, _curry2JsDefault.default)(function prepend(el, list) {
    return (0, _concatJsDefault.default)([
        el
    ], list);
});
exports.default = prepend;

},{"./internal/_concat.js":"hXJys","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1L85T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _multiplyJs = require("./multiply.js");
var _multiplyJsDefault = parcelHelpers.interopDefault(_multiplyJs);
var _reduceJs = require("./reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
/**
 * Multiplies together all the elements of a list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig [Number] -> Number
 * @param {Array} list An array of numbers
 * @return {Number} The product of all the numbers in the list.
 * @see R.reduce
 * @example
 *
 *      R.product([2,4,6,8,100,1]); //=> 38400
 */ var product = /*#__PURE__*/ (0, _reduceJsDefault.default)((0, _multiplyJsDefault.default), 1);
exports.default = product;

},{"./multiply.js":"i0Qo1","./reduce.js":"14LEy","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ZFdf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _mapJs = require("./internal/_map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _identityJs = require("./identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _pickAllJs = require("./pickAll.js");
var _pickAllJsDefault = parcelHelpers.interopDefault(_pickAllJs);
var _useWithJs = require("./useWith.js");
var _useWithJsDefault = parcelHelpers.interopDefault(_useWithJs);
/**
 * Reasonable analog to SQL `select` statement.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @category Relation
 * @sig [k] -> [{k: v}] -> [{k: v}]
 * @param {Array} props The property names to project
 * @param {Array} objs The objects to query
 * @return {Array} An array of objects with just the `props` properties.
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond', grade: 2};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown', grade: 7};
 *      const kids = [abby, fred];
 *      R.project(['name', 'grade'], kids); //=> [{name: 'Abby', grade: 2}, {name: 'Fred', grade: 7}]
 */ var project = /*#__PURE__*/ (0, _useWithJsDefault.default)((0, _mapJsDefault.default), [
    (0, _pickAllJsDefault.default),
    (0, _identityJsDefault.default)
]); // passing `identity` gives correct arity
exports.default = project;

},{"./internal/_map.js":"9apIE","./identity.js":"4xoG2","./pickAll.js":"7mkXe","./useWith.js":"gxbrq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gxbrq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Accepts a function `fn` and a list of transformer functions and returns a
 * new curried function. When the new function is invoked, it calls the
 * function `fn` with parameters consisting of the result of calling each
 * supplied handler on successive arguments to the new function.
 *
 * If more arguments are passed to the returned function than transformer
 * functions, those arguments are passed directly to `fn` as additional
 * parameters. If you expect additional arguments that don't need to be
 * transformed, although you can ignore them, it's best to pass an identity
 * function so that the new function reports the correct arity.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig ((x1, x2, ...) -> z) -> [(a -> x1), (b -> x2), ...] -> (a -> b -> ... -> z)
 * @param {Function} fn The function to wrap.
 * @param {Array} transformers A list of transformer functions
 * @return {Function} The wrapped function.
 * @see R.converge
 * @example
 *
 *      R.useWith(Math.pow, [R.identity, R.identity])(3, 4); //=> 81
 *      R.useWith(Math.pow, [R.identity, R.identity])(3)(4); //=> 81
 *      R.useWith(Math.pow, [R.dec, R.inc])(3, 4); //=> 32
 *      R.useWith(Math.pow, [R.dec, R.inc])(3)(4); //=> 32
 * @symb R.useWith(f, [g, h])(a, b) = f(g(a), h(b))
 */ var useWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function useWith(fn, transformers) {
    return (0, _curryNJsDefault.default)(transformers.length, function() {
        var args = [];
        var idx = 0;
        while(idx < transformers.length){
            args.push(transformers[idx].call(this, arguments[idx]));
            idx += 1;
        }
        return fn.apply(this, args.concat(Array.prototype.slice.call(arguments, transformers.length)));
    });
});
exports.default = useWith;

},{"./internal/_curry2.js":"fKiHC","./curryN.js":"jig5V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jAegf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */ var propEq = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propEq(name, val, obj) {
    return (0, _equalsJsDefault.default)(val, obj[name]);
});
exports.default = propEq;

},{"./internal/_curry3.js":"eXJSk","./equals.js":"90ObX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kEENR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _isJs = require("./is.js");
var _isJsDefault = parcelHelpers.interopDefault(_isJs);
/**
 * Returns `true` if the specified object property is of the given type;
 * `false` otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Type
 * @sig Type -> String -> Object -> Boolean
 * @param {Function} type
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.is, R.propSatisfies
 * @example
 *
 *      R.propIs(Number, 'x', {x: 1, y: 2});  //=> true
 *      R.propIs(Number, 'x', {x: 'foo'});    //=> false
 *      R.propIs(Number, 'x', {});            //=> false
 */ var propIs = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propIs(type, name, obj) {
    return (0, _isJsDefault.default)(type, obj[name]);
});
exports.default = propIs;

},{"./internal/_curry3.js":"eXJSk","./is.js":"gXlvv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"leANP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _pathOrJs = require("./pathOr.js");
var _pathOrJsDefault = parcelHelpers.interopDefault(_pathOrJs);
/**
 * If the given, non-null object has an own property with the specified name,
 * returns the value of that property. Otherwise returns the provided default
 * value.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Object
 * @sig a -> String -> Object -> a
 * @param {*} val The default value.
 * @param {String} p The name of the property to return.
 * @param {Object} obj The object to query.
 * @return {*} The value of given property of the supplied object or the default value.
 * @example
 *
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const favorite = R.prop('favoriteLibrary');
 *      const favoriteWithDefault = R.propOr('Ramda', 'favoriteLibrary');
 *
 *      favorite(alice);  //=> undefined
 *      favoriteWithDefault(alice);  //=> 'Ramda'
 */ var propOr = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propOr(val, p, obj) {
    return (0, _pathOrJsDefault.default)(val, [
        p
    ], obj);
});
exports.default = propOr;

},{"./internal/_curry3.js":"eXJSk","./pathOr.js":"56c6t","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2ypg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns `true` if the specified object property satisfies the given
 * predicate; `false` otherwise. You can test multiple properties with
 * [`R.where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Logic
 * @sig (a -> Boolean) -> String -> {String: a} -> Boolean
 * @param {Function} pred
 * @param {String} name
 * @param {*} obj
 * @return {Boolean}
 * @see R.where, R.propEq, R.propIs
 * @example
 *
 *      R.propSatisfies(x => x > 0, 'x', {x: 1, y: 2}); //=> true
 */ var propSatisfies = /*#__PURE__*/ (0, _curry3JsDefault.default)(function propSatisfies(pred, name, obj) {
    return pred(obj[name]);
});
exports.default = propSatisfies;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hac3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Acts as multiple `prop`: array of keys in, array of values out. Preserves
 * order.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig [k] -> {k: v} -> [v]
 * @param {Array} ps The property names to fetch
 * @param {Object} obj The object to query
 * @return {Array} The corresponding values or partially applied function.
 * @example
 *
 *      R.props(['x', 'y'], {x: 1, y: 2}); //=> [1, 2]
 *      R.props(['c', 'a', 'b'], {b: 2, a: 1}); //=> [undefined, 1, 2]
 *
 *      const fullName = R.compose(R.join(' '), R.props(['first', 'last']));
 *      fullName({last: 'Bullet-Tooth', age: 33, first: 'Tony'}); //=> 'Tony Bullet-Tooth'
 */ var props = /*#__PURE__*/ (0, _curry2JsDefault.default)(function props(ps, obj) {
    var len = ps.length;
    var out = [];
    var idx = 0;
    while(idx < len){
        out[idx] = obj[ps[idx]];
        idx += 1;
    }
    return out;
});
exports.default = props;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jXooF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isNumberJs = require("./internal/_isNumber.js");
var _isNumberJsDefault = parcelHelpers.interopDefault(_isNumberJs);
/**
 * Returns a list of numbers from `from` (inclusive) to `to` (exclusive).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> Number -> [Number]
 * @param {Number} from The first number in the list.
 * @param {Number} to One more than the last number in the list.
 * @return {Array} The list of numbers in the set `[a, b)`.
 * @example
 *
 *      R.range(1, 5);    //=> [1, 2, 3, 4]
 *      R.range(50, 53);  //=> [50, 51, 52]
 */ var range = /*#__PURE__*/ (0, _curry2JsDefault.default)(function range(from, to) {
    if (!((0, _isNumberJsDefault.default)(from) && (0, _isNumberJsDefault.default)(to))) throw new TypeError('Both arguments to range must be numbers');
    var result = [];
    var n = from;
    while(n < to){
        result.push(n);
        n += 1;
    }
    return result;
});
exports.default = range;

},{"./internal/_curry2.js":"fKiHC","./internal/_isNumber.js":"dWS7r","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9glW9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * Similar to [`reduce`](#reduce), except moves through the input list from the
 * right to the left.
 *
 * The iterator function receives two values: *(value, acc)*, while the arguments'
 * order of `reduce`'s iterator function is *(acc, value)*.
 *
 * Note: `R.reduceRight` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduceRight` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduceRight#Description
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> b) -> b -> [a] -> b
 * @param {Function} fn The iterator function. Receives two values, the current element from the array
 *        and the accumulator.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.addIndex
 * @example
 *
 *      R.reduceRight(R.subtract, 0, [1, 2, 3, 4]) // => (1 - (2 - (3 - (4 - 0)))) = -2
 *      //    -               -2
 *      //   / \              / \
 *      //  1   -            1   3
 *      //     / \              / \
 *      //    2   -     ==>    2  -1
 *      //       / \              / \
 *      //      3   -            3   4
 *      //         / \              / \
 *      //        4   0            4   0
 *
 * @symb R.reduceRight(f, a, [b, c, d]) = f(b, f(c, f(d, a)))
 */ var reduceRight = /*#__PURE__*/ (0, _curry3JsDefault.default)(function reduceRight(fn, acc, list) {
    var idx = list.length - 1;
    while(idx >= 0){
        acc = fn(list[idx], acc);
        idx -= 1;
    }
    return acc;
});
exports.default = reduceRight;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bn3o3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./internal/_curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _reducedJs = require("./internal/_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
/**
 * Like [`reduce`](#reduce), `reduceWhile` returns a single item by iterating
 * through the list, successively calling the iterator function. `reduceWhile`
 * also takes a predicate that is evaluated before each step. If the predicate
 * returns `false`, it "short-circuits" the iteration and returns the current
 * value of the accumulator.
 *
 * @func
 * @memberOf R
 * @since v0.22.0
 * @category List
 * @sig ((a, b) -> Boolean) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} pred The predicate. It is passed the accumulator and the
 *        current element.
 * @param {Function} fn The iterator function. Receives two values, the
 *        accumulator and the current element.
 * @param {*} a The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced
 * @example
 *
 *      const isOdd = (acc, x) => x % 2 === 1;
 *      const xs = [1, 3, 5, 60, 777, 800];
 *      R.reduceWhile(isOdd, R.add, 0, xs); //=> 9
 *
 *      const ys = [2, 4, 6]
 *      R.reduceWhile(isOdd, R.add, 111, ys); //=> 111
 */ var reduceWhile = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, [], function _reduceWhile(pred, fn, a, list) {
    return (0, _reduceJsDefault.default)(function(acc, x) {
        return pred(acc, x) ? fn(acc, x) : (0, _reducedJsDefault.default)(acc);
    }, a, list);
});
exports.default = reduceWhile;

},{"./internal/_curryN.js":"8fWG3","./internal/_reduce.js":"kZKBe","./internal/_reduced.js":"jCwWa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7FPaA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _reducedJs = require("./internal/_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
/**
 * Returns a value wrapped to indicate that it is the final value of the reduce
 * and transduce functions. The returned value should be considered a black
 * box: the internal structure is not guaranteed to be stable.
 *
 * Note: this optimization is only available to the below functions:
 * - [`reduce`](#reduce)
 * - [`reduceWhile`](#reduceWhile)
 * - [`transduce`](#transduce)
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category List
 * @sig a -> *
 * @param {*} x The final value of the reduce.
 * @return {*} The wrapped value.
 * @see R.reduce, R.reduceWhile, R.transduce
 * @example
 *
 *     R.reduce(
 *       (acc, item) => item > 3 ? R.reduced(acc) : acc.concat(item),
 *       [],
 *       [1, 2, 3, 4, 5]) // [1, 2, 3]
 */ var reduced = /*#__PURE__*/ (0, _curry1JsDefault.default)((0, _reducedJsDefault.default));
exports.default = reduced;

},{"./internal/_curry1.js":"973zL","./internal/_reduced.js":"jCwWa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f9SOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _timesJs = require("./times.js");
var _timesJsDefault = parcelHelpers.interopDefault(_timesJs);
/**
 * Returns a fixed list of size `n` containing a specified identical value.
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category List
 * @sig a -> n -> [a]
 * @param {*} value The value to repeat.
 * @param {Number} n The desired size of the output list.
 * @return {Array} A new array containing `n` `value`s.
 * @see R.times
 * @example
 *
 *      R.repeat('hi', 5); //=> ['hi', 'hi', 'hi', 'hi', 'hi']
 *
 *      const obj = {};
 *      const repeatedObjs = R.repeat(obj, 5); //=> [{}, {}, {}, {}, {}]
 *      repeatedObjs[0] === repeatedObjs[1]; //=> true
 * @symb R.repeat(a, 0) = []
 * @symb R.repeat(a, 1) = [a]
 * @symb R.repeat(a, 2) = [a, a]
 */ var repeat = /*#__PURE__*/ (0, _curry2JsDefault.default)(function repeat(value, n) {
    return (0, _timesJsDefault.default)((0, _alwaysJsDefault.default)(value), n);
});
exports.default = repeat;

},{"./internal/_curry2.js":"fKiHC","./always.js":"17a55","./times.js":"6xPZL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6xPZL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Calls an input function `n` times, returning an array containing the results
 * of those function calls.
 *
 * `fn` is passed one argument: The current value of `n`, which begins at `0`
 * and is gradually incremented to `n - 1`.
 *
 * @func
 * @memberOf R
 * @since v0.2.3
 * @category List
 * @sig (Number -> a) -> Number -> [a]
 * @param {Function} fn The function to invoke. Passed one argument, the current value of `n`.
 * @param {Number} n A value between `0` and `n - 1`. Increments after each function call.
 * @return {Array} An array containing the return values of all calls to `fn`.
 * @see R.repeat
 * @example
 *
 *      R.times(R.identity, 5); //=> [0, 1, 2, 3, 4]
 * @symb R.times(f, 0) = []
 * @symb R.times(f, 1) = [f(0)]
 * @symb R.times(f, 2) = [f(0), f(1)]
 */ var times = /*#__PURE__*/ (0, _curry2JsDefault.default)(function times(fn, n) {
    var len = Number(n);
    var idx = 0;
    var list;
    if (len < 0 || isNaN(len)) throw new RangeError('n must be a non-negative number');
    list = new Array(len);
    while(idx < len){
        list[idx] = fn(idx);
        idx += 1;
    }
    return list;
});
exports.default = times;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fp7vG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Replace a substring or regex match in a string with a replacement.
 *
 * The first two parameters correspond to the parameters of the
 * `String.prototype.replace()` function, so the second parameter can also be a
 * function.
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category String
 * @sig RegExp|String -> String -> String -> String
 * @param {RegExp|String} pattern A regular expression or a substring to match.
 * @param {String} replacement The string to replace the matches with.
 * @param {String} str The String to do the search and replacement in.
 * @return {String} The result.
 * @example
 *
 *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
 *
 *      // Use the "g" (global) flag to replace all occurrences:
 *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
 */ var replace = /*#__PURE__*/ (0, _curry3JsDefault.default)(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
});
exports.default = replace;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jrecT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Scan is similar to [`reduce`](#reduce), but returns a list of successively
 * reduced values from the left
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> [a]
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {Array} A list of all intermediately reduced values.
 * @see R.reduce, R.mapAccum
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const factorials = R.scan(R.multiply, 1, numbers); //=> [1, 1, 2, 6, 24]
 * @symb R.scan(f, a, [b, c]) = [a, f(a, b), f(f(a, b), c)]
 */ var scan = /*#__PURE__*/ (0, _curry3JsDefault.default)(function scan(fn, acc, list) {
    var idx = 0;
    var len = list.length;
    var result = [
        acc
    ];
    while(idx < len){
        acc = fn(acc, list[idx]);
        result[idx + 1] = acc;
        idx += 1;
    }
    return result;
});
exports.default = scan;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jWtQg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _apJs = require("./ap.js");
var _apJsDefault = parcelHelpers.interopDefault(_apJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _prependJs = require("./prepend.js");
var _prependJsDefault = parcelHelpers.interopDefault(_prependJs);
var _reduceRightJs = require("./reduceRight.js");
var _reduceRightJsDefault = parcelHelpers.interopDefault(_reduceRightJs);
/**
 * Transforms a [Traversable](https://github.com/fantasyland/fantasy-land#traversable)
 * of [Applicative](https://github.com/fantasyland/fantasy-land#applicative) into an
 * Applicative of Traversable.
 *
 * Dispatches to the `sequence` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> t (f a) -> f (t a)
 * @param {Function} of
 * @param {*} traversable
 * @return {*}
 * @see R.traverse
 * @example
 *
 *      R.sequence(Maybe.of, [Just(1), Just(2), Just(3)]);   //=> Just([1, 2, 3])
 *      R.sequence(Maybe.of, [Just(1), Just(2), Nothing()]); //=> Nothing()
 *
 *      R.sequence(R.of, Just([1, 2, 3])); //=> [Just(1), Just(2), Just(3)]
 *      R.sequence(R.of, Nothing());       //=> [Nothing()]
 */ var sequence = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sequence(of, traversable) {
    return typeof traversable.sequence === 'function' ? traversable.sequence(of) : (0, _reduceRightJsDefault.default)(function(x, acc) {
        return (0, _apJsDefault.default)((0, _mapJsDefault.default)((0, _prependJsDefault.default), x), acc);
    }, of([]), traversable);
});
exports.default = sequence;

},{"./internal/_curry2.js":"fKiHC","./ap.js":"1hv9E","./map.js":"6E1l9","./prepend.js":"ihMcA","./reduceRight.js":"9glW9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ijlMu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _alwaysJs = require("./always.js");
var _alwaysJsDefault = parcelHelpers.interopDefault(_alwaysJs);
var _overJs = require("./over.js");
var _overJsDefault = parcelHelpers.interopDefault(_overJs);
/**
 * Returns the result of "setting" the portion of the given data structure
 * focused by the given lens to the given value.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> a -> s -> s
 * @param {Lens} lens
 * @param {*} v
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.set(xLens, 4, {x: 1, y: 2});  //=> {x: 4, y: 2}
 *      R.set(xLens, 8, {x: 1, y: 2});  //=> {x: 8, y: 2}
 */ var set = /*#__PURE__*/ (0, _curry3JsDefault.default)(function set(lens, v, x) {
    return (0, _overJsDefault.default)(lens, (0, _alwaysJsDefault.default)(v), x);
});
exports.default = set;

},{"./internal/_curry3.js":"eXJSk","./always.js":"17a55","./over.js":"8vrvT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9KSna":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a copy of the list, sorted according to the comparator function,
 * which should accept two values at a time and return a negative number if the
 * first value is smaller, a positive number if it's larger, and zero if they
 * are equal. Please note that this is a **copy** of the list. It does not
 * modify the original.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, a) -> Number) -> [a] -> [a]
 * @param {Function} comparator A sorting function :: a -> b -> Int
 * @param {Array} list The list to sort
 * @return {Array} a new array with its elements sorted by the comparator function.
 * @example
 *
 *      const diff = function(a, b) { return a - b; };
 *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
 */ var sort = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
});
exports.default = sort;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gRNAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Sorts the list according to the supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord b => (a -> b) -> [a] -> [a]
 * @param {Function} fn
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted by the keys generated by `fn`.
 * @example
 *
 *      const sortByFirstItem = R.sortBy(R.prop(0));
 *      const pairs = [[-1, 1], [-2, 2], [-3, 3]];
 *      sortByFirstItem(pairs); //=> [[-3, 3], [-2, 2], [-1, 1]]
 *
 *      const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('name')));
 *      const alice = {
 *        name: 'ALICE',
 *        age: 101
 *      };
 *      const bob = {
 *        name: 'Bob',
 *        age: -10
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 314.159
 *      };
 *      const people = [clara, bob, alice];
 *      sortByNameCaseInsensitive(people); //=> [alice, bob, clara]
 */ var sortBy = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sortBy(fn, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var aa = fn(a);
        var bb = fn(b);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
    });
});
exports.default = sortBy;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ikiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Sorts a list according to a list of comparators.
 *
 * @func
 * @memberOf R
 * @since v0.23.0
 * @category Relation
 * @sig [(a, a) -> Number] -> [a] -> [a]
 * @param {Array} functions A list of comparator functions.
 * @param {Array} list The list to sort.
 * @return {Array} A new list sorted according to the comarator functions.
 * @example
 *
 *      const alice = {
 *        name: 'alice',
 *        age: 40
 *      };
 *      const bob = {
 *        name: 'bob',
 *        age: 30
 *      };
 *      const clara = {
 *        name: 'clara',
 *        age: 40
 *      };
 *      const people = [clara, bob, alice];
 *      const ageNameSort = R.sortWith([
 *        R.descend(R.prop('age')),
 *        R.ascend(R.prop('name'))
 *      ]);
 *      ageNameSort(people); //=> [alice, clara, bob]
 */ var sortWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function sortWith(fns, list) {
    return Array.prototype.slice.call(list, 0).sort(function(a, b) {
        var result = 0;
        var i = 0;
        while(result === 0 && i < fns.length){
            result = fns[i](a, b);
            i += 1;
        }
        return result;
    });
});
exports.default = sortWith;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6n8Ra":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * Splits a string into an array of strings based on the given
 * separator.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category String
 * @sig (String | RegExp) -> String -> [String]
 * @param {String|RegExp} sep The pattern.
 * @param {String} str The string to separate into an array.
 * @return {Array} The array of strings from `str` separated by `str`.
 * @see R.join
 * @example
 *
 *      const pathComponents = R.split('/');
 *      R.tail(pathComponents('/usr/local/bin/node')); //=> ['usr', 'local', 'bin', 'node']
 *
 *      R.split('.', 'a.b.c.xyz.d'); //=> ['a', 'b', 'c', 'xyz', 'd']
 */ var split = /*#__PURE__*/ (0, _invokerJsDefault.default)(1, 'split');
exports.default = split;

},{"./invoker.js":"grw4w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4c5vZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _lengthJs = require("./length.js");
var _lengthJsDefault = parcelHelpers.interopDefault(_lengthJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Splits a given list or string at a given index.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig Number -> [a] -> [[a], [a]]
 * @sig Number -> String -> [String, String]
 * @param {Number} index The index where the array/string is split.
 * @param {Array|String} array The array/string to be split.
 * @return {Array}
 * @example
 *
 *      R.splitAt(1, [1, 2, 3]);          //=> [[1], [2, 3]]
 *      R.splitAt(5, 'hello world');      //=> ['hello', ' world']
 *      R.splitAt(-1, 'foobar');          //=> ['fooba', 'r']
 */ var splitAt = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitAt(index, array) {
    return [
        (0, _sliceJsDefault.default)(0, index, array),
        (0, _sliceJsDefault.default)(index, (0, _lengthJsDefault.default)(array), array)
    ];
});
exports.default = splitAt;

},{"./internal/_curry2.js":"fKiHC","./length.js":"e5Vtn","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivyZa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Splits a collection into slices of the specified length.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig Number -> [a] -> [[a]]
 * @sig Number -> String -> [String]
 * @param {Number} n
 * @param {Array} list
 * @return {Array}
 * @example
 *
 *      R.splitEvery(3, [1, 2, 3, 4, 5, 6, 7]); //=> [[1, 2, 3], [4, 5, 6], [7]]
 *      R.splitEvery(3, 'foobarbaz'); //=> ['foo', 'bar', 'baz']
 */ var splitEvery = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitEvery(n, list) {
    if (n <= 0) throw new Error('First argument to splitEvery must be a positive integer');
    var result = [];
    var idx = 0;
    while(idx < list.length)result.push((0, _sliceJsDefault.default)(idx, idx += n, list));
    return result;
});
exports.default = splitEvery;

},{"./internal/_curry2.js":"fKiHC","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2dlNd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Takes a list and a predicate and returns a pair of lists with the following properties:
 *
 *  - the result of concatenating the two output lists is equivalent to the input list;
 *  - none of the elements of the first output list satisfies the predicate; and
 *  - if the second output list is non-empty, its first element satisfies the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [[a], [a]]
 * @param {Function} pred The predicate that determines where the array is split.
 * @param {Array} list The array to be split.
 * @return {Array}
 * @example
 *
 *      R.splitWhen(R.equals(2), [1, 2, 3, 1, 2, 3]);   //=> [[1], [2, 3, 1, 2, 3]]
 */ var splitWhen = /*#__PURE__*/ (0, _curry2JsDefault.default)(function splitWhen(pred, list) {
    var idx = 0;
    var len = list.length;
    var prefix = [];
    while(idx < len && !pred(list[idx])){
        prefix.push(list[idx]);
        idx += 1;
    }
    return [
        prefix,
        Array.prototype.slice.call(list, idx)
    ];
});
exports.default = splitWhen;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6aD0D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _takeJs = require("./take.js");
var _takeJsDefault = parcelHelpers.interopDefault(_takeJs);
/**
 * Checks if a list starts with the provided sublist.
 *
 * Similarly, checks if a string starts with the provided substring.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category List
 * @sig [a] -> [a] -> Boolean
 * @sig String -> String -> Boolean
 * @param {*} prefix
 * @param {*} list
 * @return {Boolean}
 * @see R.endsWith
 * @example
 *
 *      R.startsWith('a', 'abc')                //=> true
 *      R.startsWith('b', 'abc')                //=> false
 *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
 *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
 */ var startsWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(prefix, list) {
    return (0, _equalsJsDefault.default)((0, _takeJsDefault.default)(prefix.length, list), prefix);
});
exports.default = startsWith;

},{"./internal/_curry2.js":"fKiHC","./equals.js":"90ObX","./take.js":"9GQUp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ovIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Subtracts its second argument from its first argument.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Math
 * @sig Number -> Number -> Number
 * @param {Number} a The first value.
 * @param {Number} b The second value.
 * @return {Number} The result of `a - b`.
 * @see R.add
 * @example
 *
 *      R.subtract(10, 8); //=> 2
 *
 *      const minus5 = R.subtract(R.__, 5);
 *      minus5(17); //=> 12
 *
 *      const complementaryAngle = R.subtract(90);
 *      complementaryAngle(30); //=> 60
 *      complementaryAngle(72); //=> 18
 */ var subtract = /*#__PURE__*/ (0, _curry2JsDefault.default)(function subtract(a, b) {
    return Number(a) - Number(b);
});
exports.default = subtract;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cXE07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _differenceJs = require("./difference.js");
var _differenceJsDefault = parcelHelpers.interopDefault(_differenceJs);
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifferenceWith, R.difference, R.differenceWith
 * @example
 *
 *      R.symmetricDifference([1,2,3,4], [7,6,5,4,3]); //=> [1,2,7,6,5]
 *      R.symmetricDifference([7,6,5,4,3], [1,2,3,4]); //=> [7,6,5,1,2]
 */ var symmetricDifference = /*#__PURE__*/ (0, _curry2JsDefault.default)(function symmetricDifference(list1, list2) {
    return (0, _concatJsDefault.default)((0, _differenceJsDefault.default)(list1, list2), (0, _differenceJsDefault.default)(list2, list1));
});
exports.default = symmetricDifference;

},{"./internal/_curry2.js":"fKiHC","./concat.js":"8EMJt","./difference.js":"kOL0M","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3awOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _concatJs = require("./concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _differenceWithJs = require("./differenceWith.js");
var _differenceWithJsDefault = parcelHelpers.interopDefault(_differenceWithJs);
/**
 * Finds the set (i.e. no duplicates) of all elements contained in the first or
 * second list, but not both. Duplication is determined according to the value
 * returned by applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [a] -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The elements in `list1` or `list2`, but not both.
 * @see R.symmetricDifference, R.difference, R.differenceWith
 * @example
 *
 *      const eqA = R.eqBy(R.prop('a'));
 *      const l1 = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];
 *      const l2 = [{a: 3}, {a: 4}, {a: 5}, {a: 6}];
 *      R.symmetricDifferenceWith(eqA, l1, l2); //=> [{a: 1}, {a: 2}, {a: 5}, {a: 6}]
 */ var symmetricDifferenceWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function symmetricDifferenceWith(pred, list1, list2) {
    return (0, _concatJsDefault.default)((0, _differenceWithJsDefault.default)(pred, list1, list2), (0, _differenceWithJsDefault.default)(pred, list2, list1));
});
exports.default = symmetricDifferenceWith;

},{"./internal/_curry3.js":"eXJSk","./concat.js":"8EMJt","./differenceWith.js":"6hyWS","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bCuVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list containing the last `n` elements of a given list, passing
 * each value to the supplied predicate function, and terminating when the
 * predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropLastWhile, R.addIndex
 * @example
 *
 *      const isNotOne = x => x !== 1;
 *
 *      R.takeLastWhile(isNotOne, [1, 2, 3, 4]); //=> [2, 3, 4]
 *
 *      R.takeLastWhile(x => x !== 'R' , 'Ramda'); //=> 'amda'
 */ var takeLastWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function takeLastWhile(fn, xs) {
    var idx = xs.length - 1;
    while(idx >= 0 && fn(xs[idx]))idx -= 1;
    return (0, _sliceJsDefault.default)(idx + 1, Infinity, xs);
});
exports.default = takeLastWhile;

},{"./internal/_curry2.js":"fKiHC","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9nV7k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtakeWhileJs = require("./internal/_xtakeWhile.js");
var _xtakeWhileJsDefault = parcelHelpers.interopDefault(_xtakeWhileJs);
var _sliceJs = require("./slice.js");
var _sliceJsDefault = parcelHelpers.interopDefault(_sliceJs);
/**
 * Returns a new list containing the first `n` elements of a given list,
 * passing each value to the supplied predicate function, and terminating when
 * the predicate function returns `false`. Excludes the element that caused the
 * predicate function to fail. The predicate function is passed one argument:
 * *(value)*.
 *
 * Dispatches to the `takeWhile` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> [a]
 * @sig (a -> Boolean) -> String -> String
 * @param {Function} fn The function called per iteration.
 * @param {Array} xs The collection to iterate over.
 * @return {Array} A new array.
 * @see R.dropWhile, R.transduce, R.addIndex
 * @example
 *
 *      const isNotFour = x => x !== 4;
 *
 *      R.takeWhile(isNotFour, [1, 2, 3, 4, 3, 2, 1]); //=> [1, 2, 3]
 *
 *      R.takeWhile(x => x !== 'd' , 'Ramda'); //=> 'Ram'
 */ var takeWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([
    'takeWhile'
], (0, _xtakeWhileJsDefault.default), function takeWhile(fn, xs) {
    var idx = 0;
    var len = xs.length;
    while(idx < len && fn(xs[idx]))idx += 1;
    return (0, _sliceJsDefault.default)(0, idx, xs);
}));
exports.default = takeWhile;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xtakeWhile.js":"4bGi8","./slice.js":"gWLR6","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4bGi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _reducedJs = require("./_reduced.js");
var _reducedJsDefault = parcelHelpers.interopDefault(_reducedJs);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTakeWhile = /*#__PURE__*/ function() {
    function XTakeWhile(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTakeWhile.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XTakeWhile.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XTakeWhile.prototype['@@transducer/step'] = function(result, input) {
        return this.f(input) ? this.xf['@@transducer/step'](result, input) : (0, _reducedJsDefault.default)(result);
    };
    return XTakeWhile;
}();
var _xtakeWhile = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtakeWhile(f, xf) {
    return new XTakeWhile(f, xf);
});
exports.default = _xtakeWhile;

},{"./_curry2.js":"fKiHC","./_reduced.js":"jCwWa","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3fTPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _dispatchableJs = require("./internal/_dispatchable.js");
var _dispatchableJsDefault = parcelHelpers.interopDefault(_dispatchableJs);
var _xtapJs = require("./internal/_xtap.js");
var _xtapJsDefault = parcelHelpers.interopDefault(_xtapJs);
/**
 * Runs the given function with the supplied object, then returns the object.
 *
 * Acts as a transducer if a transformer is given as second parameter.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (a -> *) -> a -> a
 * @param {Function} fn The function to call with `x`. The return value of `fn` will be thrown away.
 * @param {*} x
 * @return {*} `x`.
 * @example
 *
 *      const sayX = x => console.log('x is ' + x);
 *      R.tap(sayX, 100); //=> 100
 *      // logs 'x is 100'
 * @symb R.tap(f, a) = a
 */ var tap = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _dispatchableJsDefault.default)([], (0, _xtapJsDefault.default), function tap(fn, x) {
    fn(x);
    return x;
}));
exports.default = tap;

},{"./internal/_curry2.js":"fKiHC","./internal/_dispatchable.js":"f1aoQ","./internal/_xtap.js":"kMKNU","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kMKNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _xfBaseJs = require("./_xfBase.js");
var _xfBaseJsDefault = parcelHelpers.interopDefault(_xfBaseJs);
var XTap = /*#__PURE__*/ function() {
    function XTap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XTap.prototype['@@transducer/init'] = (0, _xfBaseJsDefault.default).init;
    XTap.prototype['@@transducer/result'] = (0, _xfBaseJsDefault.default).result;
    XTap.prototype['@@transducer/step'] = function(result, input) {
        this.f(input);
        return this.xf['@@transducer/step'](result, input);
    };
    return XTap;
}();
var _xtap = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _xtap(f, xf) {
    return new XTap(f, xf);
});
exports.default = _xtap;

},{"./_curry2.js":"fKiHC","./_xfBase.js":"iJ0GC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kkzEr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cloneRegExpJs = require("./internal/_cloneRegExp.js");
var _cloneRegExpJsDefault = parcelHelpers.interopDefault(_cloneRegExpJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _isRegExpJs = require("./internal/_isRegExp.js");
var _isRegExpJsDefault = parcelHelpers.interopDefault(_isRegExpJs);
var _toStringJs = require("./toString.js");
var _toStringJsDefault = parcelHelpers.interopDefault(_toStringJs);
/**
 * Determines whether a given string matches a given regular expression.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category String
 * @sig RegExp -> String -> Boolean
 * @param {RegExp} pattern
 * @param {String} str
 * @return {Boolean}
 * @see R.match
 * @example
 *
 *      R.test(/^x/, 'xyz'); //=> true
 *      R.test(/^y/, 'xyz'); //=> false
 */ var test = /*#__PURE__*/ (0, _curry2JsDefault.default)(function test(pattern, str) {
    if (!(0, _isRegExpJsDefault.default)(pattern)) throw new TypeError("\u2018test\u2019 requires a value of type RegExp as its first argument; received " + (0, _toStringJsDefault.default)(pattern));
    return (0, _cloneRegExpJsDefault.default)(pattern).test(str);
});
exports.default = test;

},{"./internal/_cloneRegExp.js":"b2nDL","./internal/_curry2.js":"fKiHC","./internal/_isRegExp.js":"3iPF9","./toString.js":"fffBR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3iPF9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isRegExp);
function _isRegExp(x) {
    return Object.prototype.toString.call(x) === '[object RegExp]';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f2Bvd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _assertPromiseJs = require("./internal/_assertPromise.js");
var _assertPromiseJsDefault = parcelHelpers.interopDefault(_assertPromiseJs);
/**
 * Returns the result of applying the onSuccess function to the value inside
 * a successfully resolved promise. This is useful for working with promises
 * inside function compositions.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig (a -> b) -> (Promise e a) -> (Promise e b)
 * @sig (a -> (Promise e b)) -> (Promise e a) -> (Promise e b)
 * @param {Function} onSuccess The function to apply. Can return a value or a promise of a value.
 * @param {Promise} p
 * @return {Promise} The result of calling `p.then(onSuccess)`
 * @see R.otherwise
 * @example
 *
 *      var makeQuery = (email) => ({ query: { email }});
 *
 *      //getMemberName :: String -> Promise ({firstName, lastName})
 *      var getMemberName = R.pipe(
 *        makeQuery,
 *        fetchMember,
 *        R.then(R.pick(['firstName', 'lastName']))
 *      );
 */ var then = /*#__PURE__*/ (0, _curry2JsDefault.default)(function then(f, p) {
    (0, _assertPromiseJsDefault.default)('then', p);
    return p.then(f);
});
exports.default = then;

},{"./internal/_curry2.js":"fKiHC","./internal/_assertPromise.js":"aX6ak","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j1otG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * The lower case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to lower case.
 * @return {String} The lower case version of `str`.
 * @see R.toUpper
 * @example
 *
 *      R.toLower('XYZ'); //=> 'xyz'
 */ var toLower = /*#__PURE__*/ (0, _invokerJsDefault.default)(0, 'toLowerCase');
exports.default = toLower;

},{"./invoker.js":"grw4w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"euRrp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @see R.fromPairs
 * @example
 *
 *      R.toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */ var toPairs = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toPairs(obj) {
    var pairs = [];
    for(var prop in obj)if ((0, _hasJsDefault.default)(prop, obj)) pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
exports.default = toPairs;

},{"./internal/_curry1.js":"973zL","./internal/_has.js":"lzxBF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34EwM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Converts an object into an array of key, value arrays. The object's own
 * properties and prototype properties are used. Note that the order of the
 * output array is not guaranteed to be consistent across different JS
 * platforms.
 *
 * @func
 * @memberOf R
 * @since v0.4.0
 * @category Object
 * @sig {String: *} -> [[String,*]]
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own
 *         and prototype properties.
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.toPairsIn(f); //=> [['x','X'], ['y','Y']]
 */ var toPairsIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function toPairsIn(obj) {
    var pairs = [];
    for(var prop in obj)pairs[pairs.length] = [
        prop,
        obj[prop]
    ];
    return pairs;
});
exports.default = toPairsIn;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kYwqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _invokerJs = require("./invoker.js");
var _invokerJsDefault = parcelHelpers.interopDefault(_invokerJs);
/**
 * The upper case version of a string.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to upper case.
 * @return {String} The upper case version of `str`.
 * @see R.toLower
 * @example
 *
 *      R.toUpper('abc'); //=> 'ABC'
 */ var toUpper = /*#__PURE__*/ (0, _invokerJsDefault.default)(0, 'toUpperCase');
exports.default = toUpper;

},{"./invoker.js":"grw4w","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"awR23":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reduceJs = require("./internal/_reduce.js");
var _reduceJsDefault = parcelHelpers.interopDefault(_reduceJs);
var _xwrapJs = require("./internal/_xwrap.js");
var _xwrapJsDefault = parcelHelpers.interopDefault(_xwrapJs);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Initializes a transducer using supplied iterator function. Returns a single
 * item by iterating through the list, successively calling the transformed
 * iterator function and passing it an accumulator value and the current value
 * from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It will be
 * wrapped as a transformer to initialize the transducer. A transformer can be
 * passed directly in place of an iterator function. In both cases, iteration
 * may be stopped early with the [`R.reduced`](#reduced) function.
 *
 * A transducer is a function that accepts a transformer and returns a
 * transformer and can be composed directly.
 *
 * A transformer is an an object that provides a 2-arity reducing iterator
 * function, step, 0-arity initial value function, init, and 1-arity result
 * extraction function, result. The step function is used as the iterator
 * function in reduce. The result function is used to convert the final
 * accumulator into the return type and in most cases is
 * [`R.identity`](#identity). The init function can be used to provide an
 * initial accumulator, but is ignored by transduce.
 *
 * The iteration is performed with [`R.reduce`](#reduce) after initializing the transducer.
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category List
 * @sig (c -> c) -> ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} xf The transducer function. Receives a transformer and returns a transformer.
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array. Wrapped as transformer, if necessary, and used to
 *        initialize the transducer
 * @param {*} acc The initial accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduce, R.reduced, R.into
 * @example
 *
 *      const numbers = [1, 2, 3, 4];
 *      const transducer = R.compose(R.map(R.add(1)), R.take(2));
 *      R.transduce(transducer, R.flip(R.append), [], numbers); //=> [2, 3]
 *
 *      const isOdd = (x) => x % 2 === 1;
 *      const firstOddTransducer = R.compose(R.filter(isOdd), R.take(1));
 *      R.transduce(firstOddTransducer, R.flip(R.append), [], R.range(0, 100)); //=> [1]
 */ var transduce = /*#__PURE__*/ (0, _curryNJsDefault.default)(4, function transduce(xf, fn, acc, list) {
    return (0, _reduceJsDefault.default)(xf(typeof fn === 'function' ? (0, _xwrapJsDefault.default)(fn) : fn), acc, list);
});
exports.default = transduce;

},{"./internal/_reduce.js":"kZKBe","./internal/_xwrap.js":"8YPBf","./curryN.js":"jig5V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lbOML":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Transposes the rows and columns of a 2D list.
 * When passed a list of `n` lists of length `x`,
 * returns a list of `x` lists of length `n`.
 *
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [[a]] -> [[a]]
 * @param {Array} list A 2D list
 * @return {Array} A 2D list
 * @example
 *
 *      R.transpose([[1, 'a'], [2, 'b'], [3, 'c']]) //=> [[1, 2, 3], ['a', 'b', 'c']]
 *      R.transpose([[1, 2, 3], ['a', 'b', 'c']]) //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 *
 *      // If some of the rows are shorter than the following rows, their elements are skipped:
 *      R.transpose([[10, 11], [20], [], [30, 31, 32]]) //=> [[10, 20, 30], [11, 31], [32]]
 * @symb R.transpose([[a], [b], [c]]) = [a, b, c]
 * @symb R.transpose([[a, b], [c, d]]) = [[a, c], [b, d]]
 * @symb R.transpose([[a, b], [c]]) = [[a, c], [b]]
 */ var transpose = /*#__PURE__*/ (0, _curry1JsDefault.default)(function transpose(outerlist) {
    var i = 0;
    var result = [];
    while(i < outerlist.length){
        var innerlist = outerlist[i];
        var j = 0;
        while(j < innerlist.length){
            if (typeof result[j] === 'undefined') result[j] = [];
            result[j].push(innerlist[j]);
            j += 1;
        }
        i += 1;
    }
    return result;
});
exports.default = transpose;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cj1N4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _sequenceJs = require("./sequence.js");
var _sequenceJsDefault = parcelHelpers.interopDefault(_sequenceJs);
/**
 * Maps an [Applicative](https://github.com/fantasyland/fantasy-land#applicative)-returning
 * function over a [Traversable](https://github.com/fantasyland/fantasy-land#traversable),
 * then uses [`sequence`](#sequence) to transform the resulting Traversable of Applicative
 * into an Applicative of Traversable.
 *
 * Dispatches to the `traverse` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig (Applicative f, Traversable t) => (a -> f a) -> (a -> f b) -> t a -> f (t b)
 * @param {Function} of
 * @param {Function} f
 * @param {*} traversable
 * @return {*}
 * @see R.sequence
 * @example
 *
 *      // Returns `Maybe.Nothing` if the given divisor is `0`
 *      const safeDiv = n => d => d === 0 ? Maybe.Nothing() : Maybe.Just(n / d)
 *
 *      R.traverse(Maybe.of, safeDiv(10), [2, 4, 5]); //=> Maybe.Just([5, 2.5, 2])
 *      R.traverse(Maybe.of, safeDiv(10), [2, 0, 5]); //=> Maybe.Nothing
 */ var traverse = /*#__PURE__*/ (0, _curry3JsDefault.default)(function traverse(of, f, traversable) {
    return typeof traversable['fantasy-land/traverse'] === 'function' ? traversable['fantasy-land/traverse'](f, of) : (0, _sequenceJsDefault.default)(of, (0, _mapJsDefault.default)(f, traversable));
});
exports.default = traverse;

},{"./internal/_curry3.js":"eXJSk","./map.js":"6E1l9","./sequence.js":"jWtQg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7Hqiy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var ws = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var zeroWidth = '\u200b';
var hasProtoTrim = typeof String.prototype.trim === 'function';
/**
 * Removes (strips) whitespace from both ends of the string.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category String
 * @sig String -> String
 * @param {String} str The string to trim.
 * @return {String} Trimmed version of `str`.
 * @example
 *
 *      R.trim('   xyz  '); //=> 'xyz'
 *      R.map(R.trim, R.split(',', 'x, y, z')); //=> ['x', 'y', 'z']
 */ var trim = !hasProtoTrim || /*#__PURE__*/ ws.trim() || !/*#__PURE__*/ zeroWidth.trim() ? /*#__PURE__*/ (0, _curry1JsDefault.default)(function trim(str) {
    var beginRx = new RegExp('^[' + ws + '][' + ws + ']*');
    var endRx = new RegExp('[' + ws + '][' + ws + ']*$');
    return str.replace(beginRx, '').replace(endRx, '');
}) : /*#__PURE__*/ (0, _curry1JsDefault.default)(function trim(str) {
    return str.trim();
});
exports.default = trim;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"di6xw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _arityJs = require("./internal/_arity.js");
var _arityJsDefault = parcelHelpers.interopDefault(_arityJs);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * `tryCatch` takes two functions, a `tryer` and a `catcher`. The returned
 * function evaluates the `tryer`; if it does not throw, it simply returns the
 * result. If the `tryer` *does* throw, the returned function evaluates the
 * `catcher` function and returns its result. Note that for effective
 * composition with this function, both the `tryer` and `catcher` functions
 * must return the same type of results.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Function
 * @sig (...x -> a) -> ((e, ...x) -> a) -> (...x -> a)
 * @param {Function} tryer The function that may throw.
 * @param {Function} catcher The function that will be evaluated if `tryer` throws.
 * @return {Function} A new function that will catch exceptions and send then to the catcher.
 * @example
 *
 *      R.tryCatch(R.prop('x'), R.F)({x: true}); //=> true
 *      R.tryCatch(() => { throw 'foo'}, R.always('catched'))('bar') // => 'catched'
 *      R.tryCatch(R.times(R.identity), R.always([]))('s') // => []
 `` */ var tryCatch = /*#__PURE__*/ (0, _curry2JsDefault.default)(function _tryCatch(tryer, catcher) {
    return (0, _arityJsDefault.default)(tryer.length, function() {
        try {
            return tryer.apply(this, arguments);
        } catch (e) {
            return catcher.apply(this, (0, _concatJsDefault.default)([
                e
            ], arguments));
        }
    });
});
exports.default = tryCatch;

},{"./internal/_arity.js":"cUJua","./internal/_concat.js":"hXJys","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6FNXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Takes a function `fn`, which takes a single array argument, and returns a
 * function which:
 *
 *   - takes any number of positional arguments;
 *   - passes these arguments to `fn` as an array; and
 *   - returns the result.
 *
 * In other words, `R.unapply` derives a variadic function from a function which
 * takes an array. `R.unapply` is the inverse of [`R.apply`](#apply).
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Function
 * @sig ([*...] -> a) -> (*... -> a)
 * @param {Function} fn
 * @return {Function}
 * @see R.apply
 * @example
 *
 *      R.unapply(JSON.stringify)(1, 2, 3); //=> '[1,2,3]'
 * @symb R.unapply(f)(a, b) = f([a, b])
 */ var unapply = /*#__PURE__*/ (0, _curry1JsDefault.default)(function unapply(fn) {
    return function() {
        return fn(Array.prototype.slice.call(arguments, 0));
    };
});
exports.default = unapply;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gurCN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
var _nAryJs = require("./nAry.js");
var _nAryJsDefault = parcelHelpers.interopDefault(_nAryJs);
/**
 * Wraps a function of any arity (including nullary) in a function that accepts
 * exactly 1 parameter. Any extraneous parameters will not be passed to the
 * supplied function.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Function
 * @sig (* -> b) -> (a -> b)
 * @param {Function} fn The function to wrap.
 * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
 *         arity 1.
 * @see R.binary, R.nAry
 * @example
 *
 *      const takesTwoArgs = function(a, b) {
 *        return [a, b];
 *      };
 *      takesTwoArgs.length; //=> 2
 *      takesTwoArgs(1, 2); //=> [1, 2]
 *
 *      const takesOneArg = R.unary(takesTwoArgs);
 *      takesOneArg.length; //=> 1
 *      // Only 1 argument is passed to the wrapped function
 *      takesOneArg(1, 2); //=> [1, undefined]
 * @symb R.unary(f)(a, b, c) = f(a)
 */ var unary = /*#__PURE__*/ (0, _curry1JsDefault.default)(function unary(fn) {
    return (0, _nAryJsDefault.default)(1, fn);
});
exports.default = unary;

},{"./internal/_curry1.js":"973zL","./nAry.js":"gUdSm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3E6l5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
/**
 * Returns a function of arity `n` from a (manually) curried function.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Function
 * @sig Number -> (a -> b) -> (a -> c)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to uncurry.
 * @return {Function} A new function.
 * @see R.curry
 * @example
 *
 *      const addFour = a => b => c => d => a + b + c + d;
 *
 *      const uncurriedAddFour = R.uncurryN(4, addFour);
 *      uncurriedAddFour(1, 2, 3, 4); //=> 10
 */ var uncurryN = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uncurryN(depth, fn) {
    return (0, _curryNJsDefault.default)(depth, function() {
        var currentDepth = 1;
        var value = fn;
        var idx = 0;
        var endIdx;
        while(currentDepth <= depth && typeof value === 'function'){
            endIdx = currentDepth === depth ? arguments.length : idx + value.length;
            value = value.apply(this, Array.prototype.slice.call(arguments, idx, endIdx));
            currentDepth += 1;
            idx = endIdx;
        }
        return value;
    });
});
exports.default = uncurryN;

},{"./internal/_curry2.js":"fKiHC","./curryN.js":"jig5V","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jKJwF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Builds a list from a seed value. Accepts an iterator function, which returns
 * either false to stop iteration or an array of length 2 containing the value
 * to add to the resulting list and the seed to be used in the next call to the
 * iterator function.
 *
 * The iterator function receives one argument: *(seed)*.
 *
 * @func
 * @memberOf R
 * @since v0.10.0
 * @category List
 * @sig (a -> [b]) -> * -> [b]
 * @param {Function} fn The iterator function. receives one argument, `seed`, and returns
 *        either false to quit iteration or an array of length two to proceed. The element
 *        at index 0 of this array will be added to the resulting array, and the element
 *        at index 1 will be passed to the next call to `fn`.
 * @param {*} seed The seed value.
 * @return {Array} The final list.
 * @example
 *
 *      const f = n => n > 50 ? false : [-n, n + 10];
 *      R.unfold(f, 10); //=> [-10, -20, -30, -40, -50]
 * @symb R.unfold(f, x) = [f(x)[0], f(f(x)[1])[0], f(f(f(x)[1])[1])[0], ...]
 */ var unfold = /*#__PURE__*/ (0, _curry2JsDefault.default)(function unfold(fn, seed) {
    var pair = fn(seed);
    var result = [];
    while(pair && pair.length){
        result[result.length] = pair[0];
        pair = fn(pair[1]);
    }
    return result;
});
exports.default = unfold;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Nn1P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _composeJs = require("./compose.js");
var _composeJsDefault = parcelHelpers.interopDefault(_composeJs);
var _uniqJs = require("./uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig [*] -> [*] -> [*]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @example
 *
 *      R.union([1, 2, 3], [2, 3, 4]); //=> [1, 2, 3, 4]
 */ var union = /*#__PURE__*/ (0, _curry2JsDefault.default)(/*#__PURE__*/ (0, _composeJsDefault.default)((0, _uniqJsDefault.default), (0, _concatJsDefault.default)));
exports.default = union;

},{"./internal/_concat.js":"hXJys","./internal/_curry2.js":"fKiHC","./compose.js":"985qM","./uniq.js":"b2tzD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lpZjX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _concatJs = require("./internal/_concat.js");
var _concatJsDefault = parcelHelpers.interopDefault(_concatJs);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
var _uniqWithJs = require("./uniqWith.js");
var _uniqWithJsDefault = parcelHelpers.interopDefault(_uniqWithJs);
/**
 * Combines two lists into a set (i.e. no duplicates) composed of the elements
 * of each list. Duplication is determined according to the value returned by
 * applying the supplied predicate to two list elements.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig ((a, a) -> Boolean) -> [*] -> [*] -> [*]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list1 The first list.
 * @param {Array} list2 The second list.
 * @return {Array} The first and second lists concatenated, with
 *         duplicates removed.
 * @see R.union
 * @example
 *
 *      const l1 = [{a: 1}, {a: 2}];
 *      const l2 = [{a: 1}, {a: 4}];
 *      R.unionWith(R.eqBy(R.prop('a')), l1, l2); //=> [{a: 1}, {a: 2}, {a: 4}]
 */ var unionWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function unionWith(pred, list1, list2) {
    return (0, _uniqWithJsDefault.default)(pred, (0, _concatJsDefault.default)(list1, list2));
});
exports.default = unionWith;

},{"./internal/_concat.js":"hXJys","./internal/_curry3.js":"eXJSk","./uniqWith.js":"8oNoi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8oNoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesWithJs = require("./internal/_includesWith.js");
var _includesWithJsDefault = parcelHelpers.interopDefault(_includesWithJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Returns a new list containing only one copy of each element in the original
 * list, based upon the value returned by applying the supplied predicate to
 * two list elements. Prefers the first item if two items compare equal based
 * on the predicate.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category List
 * @sig ((a, a) -> Boolean) -> [a] -> [a]
 * @param {Function} pred A predicate used to test whether two items are equal.
 * @param {Array} list The array to consider.
 * @return {Array} The list of unique items.
 * @example
 *
 *      const strEq = R.eqBy(String);
 *      R.uniqWith(strEq)([1, '1', 2, 1]); //=> [1, 2]
 *      R.uniqWith(strEq)([{}, {}]);       //=> [{}]
 *      R.uniqWith(strEq)([1, '1', 1]);    //=> [1]
 *      R.uniqWith(strEq)(['1', 1, 1]);    //=> ['1']
 */ var uniqWith = /*#__PURE__*/ (0, _curry2JsDefault.default)(function uniqWith(pred, list) {
    var idx = 0;
    var len = list.length;
    var result = [];
    var item;
    while(idx < len){
        item = list[idx];
        if (!(0, _includesWithJsDefault.default)(pred, item, result)) result[result.length] = item;
        idx += 1;
    }
    return result;
});
exports.default = uniqWith;

},{"./internal/_includesWith.js":"hGCJ4","./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1fx2U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is not satisfied, the function will return the result of
 * calling the `whenFalseFn` function with the same argument. If the predicate
 * is satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred        A predicate function
 * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
 *                               to a falsy value.
 * @param {*}        x           An object to test with the `pred` function and
 *                               pass to `whenFalseFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
 * @see R.ifElse, R.when, R.cond
 * @example
 *
 *      let safeInc = R.unless(R.isNil, R.inc);
 *      safeInc(null); //=> null
 *      safeInc(1); //=> 2
 */ var unless = /*#__PURE__*/ (0, _curry3JsDefault.default)(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
});
exports.default = unless;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k7QPj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _identityJs = require("./internal/_identity.js");
var _identityJsDefault = parcelHelpers.interopDefault(_identityJs);
var _chainJs = require("./chain.js");
var _chainJsDefault = parcelHelpers.interopDefault(_chainJs);
/**
 * Shorthand for `R.chain(R.identity)`, which removes one level of nesting from
 * any [Chain](https://github.com/fantasyland/fantasy-land#chain).
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig Chain c => c (c a) -> c a
 * @param {*} list
 * @return {*}
 * @see R.flatten, R.chain
 * @example
 *
 *      R.unnest([1, [2], [[3]]]); //=> [1, 2, [3]]
 *      R.unnest([[1, 2], [3, 4], [5, 6]]); //=> [1, 2, 3, 4, 5, 6]
 */ var unnest = /*#__PURE__*/ (0, _chainJsDefault.default)((0, _identityJsDefault.default));
exports.default = unnest;

},{"./internal/_identity.js":"guYHv","./chain.js":"349mj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7QjvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Takes a predicate, a transformation function, and an initial value,
 * and returns a value of the same type as the initial value.
 * It does so by applying the transformation until the predicate is satisfied,
 * at which point it returns the satisfactory value.
 *
 * @func
 * @memberOf R
 * @since v0.20.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred A predicate function
 * @param {Function} fn The iterator function
 * @param {*} init Initial value
 * @return {*} Final value that satisfies predicate
 * @example
 *
 *      R.until(R.gt(R.__, 100), R.multiply(2))(1) // => 128
 */ var until = /*#__PURE__*/ (0, _curry3JsDefault.default)(function until(pred, fn, init) {
    var val = init;
    while(!pred(val))val = fn(val);
    return val;
});
exports.default = until;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6Mk8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Returns a list of all the properties, including prototype properties, of the
 * supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own and prototype properties.
 * @see R.values, R.keysIn
 * @example
 *
 *      const F = function() { this.x = 'X'; };
 *      F.prototype.y = 'Y';
 *      const f = new F();
 *      R.valuesIn(f); //=> ['X', 'Y']
 */ var valuesIn = /*#__PURE__*/ (0, _curry1JsDefault.default)(function valuesIn(obj) {
    var prop;
    var vs = [];
    for(prop in obj)vs[vs.length] = obj[prop];
    return vs;
});
exports.default = valuesIn;

},{"./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7RNFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
// `Const` is a functor that effectively ignores the function given to `map`.
var Const = function(x) {
    return {
        value: x,
        'fantasy-land/map': function() {
            return this;
        }
    };
};
/**
 * Returns a "view" of the given data structure, determined by the given lens.
 * The lens's focus determines which portion of the data structure is visible.
 *
 * @func
 * @memberOf R
 * @since v0.16.0
 * @category Object
 * @typedefn Lens s a = Functor f => (a -> f a) -> s -> f s
 * @sig Lens s a -> s -> a
 * @param {Lens} lens
 * @param {*} x
 * @return {*}
 * @see R.prop, R.lensIndex, R.lensProp
 * @example
 *
 *      const xLens = R.lensProp('x');
 *
 *      R.view(xLens, {x: 1, y: 2});  //=> 1
 *      R.view(xLens, {x: 4, y: 2});  //=> 4
 */ var view = /*#__PURE__*/ (0, _curry2JsDefault.default)(function view(lens, x) {
    // Using `Const` effectively ignores the setter function of the `lens`,
    // leaving the value returned by the getter function unmodified.
    return lens(Const)(x).value;
});
exports.default = view;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fAxtz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Tests the final argument by passing it to the given predicate function. If
 * the predicate is satisfied, the function will return the result of calling
 * the `whenTrueFn` function with the same argument. If the predicate is not
 * satisfied, the argument is returned as is.
 *
 * @func
 * @memberOf R
 * @since v0.18.0
 * @category Logic
 * @sig (a -> Boolean) -> (a -> a) -> a -> a
 * @param {Function} pred       A predicate function
 * @param {Function} whenTrueFn A function to invoke when the `condition`
 *                              evaluates to a truthy value.
 * @param {*}        x          An object to test with the `pred` function and
 *                              pass to `whenTrueFn` if necessary.
 * @return {*} Either `x` or the result of applying `x` to `whenTrueFn`.
 * @see R.ifElse, R.unless, R.cond
 * @example
 *
 *      // truncate :: String -> String
 *      const truncate = R.when(
 *        R.propSatisfies(R.gt(R.__, 10), 'length'),
 *        R.pipe(R.take(10), R.append('…'), R.join(''))
 *      );
 *      truncate('12345');         //=> '12345'
 *      truncate('0123456789ABC'); //=> '0123456789…'
 */ var when = /*#__PURE__*/ (0, _curry3JsDefault.default)(function when(pred, whenTrueFn, x) {
    return pred(x) ? whenTrueFn(x) : x;
});
exports.default = when;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7EL9d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _hasJs = require("./internal/_has.js");
var _hasJsDefault = parcelHelpers.interopDefault(_hasJs);
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec. Each of the spec's own properties must be a predicate function.
 * Each predicate is applied to the value of the corresponding property of the
 * test object. `where` returns true if all the predicates return true, false
 * otherwise.
 *
 * `where` is well suited to declaratively expressing constraints for other
 * functions such as [`filter`](#filter) and [`find`](#find).
 *
 * @func
 * @memberOf R
 * @since v0.1.1
 * @category Object
 * @sig {String: (* -> Boolean)} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propSatisfies, R.whereEq
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.where({
 *        a: R.equals('foo'),
 *        b: R.complement(R.equals('bar')),
 *        x: R.gt(R.__, 10),
 *        y: R.lt(R.__, 20)
 *      });
 *
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 19}); //=> true
 *      pred({a: 'xxx', b: 'xxx', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'bar', x: 11, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 10, y: 19}); //=> false
 *      pred({a: 'foo', b: 'xxx', x: 11, y: 20}); //=> false
 */ var where = /*#__PURE__*/ (0, _curry2JsDefault.default)(function where(spec, testObj) {
    for(var prop in spec){
        if ((0, _hasJsDefault.default)(prop, spec) && !spec[prop](testObj[prop])) return false;
    }
    return true;
});
exports.default = where;

},{"./internal/_curry2.js":"fKiHC","./internal/_has.js":"lzxBF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"paKr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _equalsJs = require("./equals.js");
var _equalsJsDefault = parcelHelpers.interopDefault(_equalsJs);
var _mapJs = require("./map.js");
var _mapJsDefault = parcelHelpers.interopDefault(_mapJs);
var _whereJs = require("./where.js");
var _whereJsDefault = parcelHelpers.interopDefault(_whereJs);
/**
 * Takes a spec object and a test object; returns true if the test satisfies
 * the spec, false otherwise. An object satisfies the spec if, for each of the
 * spec's own properties, accessing that property of the object gives the same
 * value (in [`R.equals`](#equals) terms) as accessing that property of the
 * spec.
 *
 * `whereEq` is a specialization of [`where`](#where).
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category Object
 * @sig {String: *} -> {String: *} -> Boolean
 * @param {Object} spec
 * @param {Object} testObj
 * @return {Boolean}
 * @see R.propEq, R.where
 * @example
 *
 *      // pred :: Object -> Boolean
 *      const pred = R.whereEq({a: 1, b: 2});
 *
 *      pred({a: 1});              //=> false
 *      pred({a: 1, b: 2});        //=> true
 *      pred({a: 1, b: 2, c: 3});  //=> true
 *      pred({a: 1, b: 1});        //=> false
 */ var whereEq = /*#__PURE__*/ (0, _curry2JsDefault.default)(function whereEq(spec, testObj) {
    return (0, _whereJsDefault.default)((0, _mapJsDefault.default)((0, _equalsJsDefault.default), spec), testObj);
});
exports.default = whereEq;

},{"./internal/_curry2.js":"fKiHC","./equals.js":"90ObX","./map.js":"6E1l9","./where.js":"7EL9d","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cu2sz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _includesJs = require("./internal/_includes.js");
var _includesJsDefault = parcelHelpers.interopDefault(_includesJs);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _rejectJs = require("./reject.js");
var _rejectJsDefault = parcelHelpers.interopDefault(_rejectJs);
/**
 * Returns a new list without values in the first argument.
 * [`R.equals`](#equals) is used to determine equality.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category List
 * @sig [a] -> [a] -> [a]
 * @param {Array} list1 The values to be removed from `list2`.
 * @param {Array} list2 The array to remove values from.
 * @return {Array} The new array without values in `list1`.
 * @see R.transduce, R.difference, R.remove
 * @example
 *
 *      R.without([1, 2], [1, 2, 1, 3, 4]); //=> [3, 4]
 */ var without = /*#__PURE__*/ (0, _curry2JsDefault.default)(function(xs, list) {
    return (0, _rejectJsDefault.default)((0, _flipJsDefault.default)((0, _includesJsDefault.default))(xs), list);
});
exports.default = without;

},{"./internal/_includes.js":"hfNgu","./internal/_curry2.js":"fKiHC","./flip.js":"h3gua","./reject.js":"4OIPW","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fZ4el":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list out of the two supplied by creating each possible pair
 * from the lists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} as The first list.
 * @param {Array} bs The second list.
 * @return {Array} The list made by combining each possible pair from
 *         `as` and `bs` into pairs (`[a, b]`).
 * @example
 *
 *      R.xprod([1, 2], ['a', 'b']); //=> [[1, 'a'], [1, 'b'], [2, 'a'], [2, 'b']]
 * @symb R.xprod([a, b], [c, d]) = [[a, c], [a, d], [b, c], [b, d]]
 */ var xprod = /*#__PURE__*/ (0, _curry2JsDefault.default)(function xprod(a, b) {
    // = xprodWith(prepend); (takes about 3 times as long...)
    var idx = 0;
    var ilen = a.length;
    var j;
    var jlen = b.length;
    var result = [];
    while(idx < ilen){
        j = 0;
        while(j < jlen){
            result[result.length] = [
                a[idx],
                b[j]
            ];
            j += 1;
        }
        idx += 1;
    }
    return result;
});
exports.default = xprod;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1hFPR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new list out of the two supplied by pairing up equally-positioned
 * items from both lists. The returned list is truncated to the length of the
 * shorter of the two input lists.
 * Note: `zip` is equivalent to `zipWith(function(a, b) { return [a, b] })`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [b] -> [[a,b]]
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by pairing up same-indexed elements of `list1` and `list2`.
 * @example
 *
 *      R.zip([1, 2, 3], ['a', 'b', 'c']); //=> [[1, 'a'], [2, 'b'], [3, 'c']]
 * @symb R.zip([a, b, c], [d, e, f]) = [[a, d], [b, e], [c, f]]
 */ var zip = /*#__PURE__*/ (0, _curry2JsDefault.default)(function zip(a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = [
            a[idx],
            b[idx]
        ];
        idx += 1;
    }
    return rv;
});
exports.default = zip;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6XcZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry2Js = require("./internal/_curry2.js");
var _curry2JsDefault = parcelHelpers.interopDefault(_curry2Js);
/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */ var zipObj = /*#__PURE__*/ (0, _curry2JsDefault.default)(function zipObj(keys, values) {
    var idx = 0;
    var len = Math.min(keys.length, values.length);
    var out = {};
    while(idx < len){
        out[keys[idx]] = values[idx];
        idx += 1;
    }
    return out;
});
exports.default = zipObj;

},{"./internal/_curry2.js":"fKiHC","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ay9NA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curry3Js = require("./internal/_curry3.js");
var _curry3JsDefault = parcelHelpers.interopDefault(_curry3Js);
/**
 * Creates a new list out of the two supplied by applying the function to each
 * equally-positioned pair in the lists. The returned list is truncated to the
 * length of the shorter of the two input lists.
 *
 * @function
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> c) -> [a] -> [b] -> [c]
 * @param {Function} fn The function used to combine the two elements into one value.
 * @param {Array} list1 The first array to consider.
 * @param {Array} list2 The second array to consider.
 * @return {Array} The list made by combining same-indexed elements of `list1` and `list2`
 *         using `fn`.
 * @example
 *
 *      const f = (x, y) => {
 *        // ...
 *      };
 *      R.zipWith(f, [1, 2, 3], ['a', 'b', 'c']);
 *      //=> [f(1, 'a'), f(2, 'b'), f(3, 'c')]
 * @symb R.zipWith(fn, [a, b, c], [d, e, f]) = [fn(a, d), fn(b, e), fn(c, f)]
 */ var zipWith = /*#__PURE__*/ (0, _curry3JsDefault.default)(function zipWith(fn, a, b) {
    var rv = [];
    var idx = 0;
    var len = Math.min(a.length, b.length);
    while(idx < len){
        rv[idx] = fn(a[idx], b[idx]);
        idx += 1;
    }
    return rv;
});
exports.default = zipWith;

},{"./internal/_curry3.js":"eXJSk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"98Rha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _curryNJs = require("./curryN.js");
var _curryNJsDefault = parcelHelpers.interopDefault(_curryNJs);
var _curry1Js = require("./internal/_curry1.js");
var _curry1JsDefault = parcelHelpers.interopDefault(_curry1Js);
/**
 * Creates a thunk out of a function. A thunk delays a calculation until
 * its result is needed, providing lazy evaluation of arguments.
 *
 * @func
 * @memberOf R
 * @category Function
 * @sig ((a, b, ..., j) -> k) -> (a, b, ..., j) -> (() -> k)
 * @param {Function} fn A function to wrap in a thunk
 * @return {Function} Expects arguments for `fn` and returns a new function
 *  that, when called, applies those arguments to `fn`.
 * @see R.partial, R.partialRight
 * @example
 *
 *      R.thunkify(R.identity)(42)(); //=> 42
 *      R.thunkify((a, b) => a + b)(25, 17)(); //=> 42
 */ var thunkify = /*#__PURE__*/ (0, _curry1JsDefault.default)(function thunkify(fn) {
    return (0, _curryNJsDefault.default)(fn.length, function createThunk() {
        var fnArgs = arguments;
        return function invokeThunk() {
            return fn.apply(this, fnArgs);
        };
    });
});
exports.default = thunkify;

},{"./curryN.js":"jig5V","./internal/_curry1.js":"973zL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bTln":[function(require,module,exports,__globalThis) {
var Parser = require("87bc0e8707db2e9a");
module.exports = function(queries, options) {
    var result = {};
    Object.keys(queries).forEach(function(query) {
        if (Parser.parse(query).match(options)) Object.assign(result, queries[query]);
    });
    return result;
};

},{"87bc0e8707db2e9a":"cGZ9e"}],"cGZ9e":[function(require,module,exports,__globalThis) {
var Query = require("65352f2699c24bdf");
var Operator = require("7f5fc0bd01bcfeb3");
var NUMBERS = /[0-9]/;
var LETTERS = /[a-z|\-]/i;
var WHITESPACE = /\s/;
var COLON = /:/;
var COMMA = /,/;
var AND = /and$/;
var AT = /@/;
function tokenizer(input) {
    var current = 0;
    var tokens = [];
    while(current < input.length){
        var char = input[current];
        if (AT.test(char)) {
            char = input[++current];
            while(LETTERS.test(char) && char !== undefined)char = input[++current];
        }
        if (WHITESPACE.test(char) || char === ')' || char === '(') {
            current++;
            continue;
        }
        if (COLON.test(char) || COMMA.test(char)) {
            current++;
            tokens.push({
                type: 'operator',
                value: char
            });
            continue;
        }
        if (NUMBERS.test(char)) {
            var value = '';
            while(NUMBERS.test(char)){
                value += char;
                char = input[++current];
            }
            tokens.push({
                type: 'number',
                value: value
            });
            continue;
        }
        if (LETTERS.test(char)) {
            var value = '';
            while(LETTERS.test(char) && char !== undefined){
                value += char;
                char = input[++current];
            }
            if (AND.test(value)) tokens.push({
                type: 'operator',
                value: value
            });
            else tokens.push({
                type: 'literal',
                value: value
            });
            continue;
        }
        throw new TypeError('Tokenizer: I dont know what this character is: ' + char);
    }
    return tokens;
}
function parser(tokens) {
    var output = [];
    var stack = [];
    while(tokens.length > 0){
        var token = tokens.shift();
        if (token.type === 'number' || token.type === 'literal') {
            output.push(token);
            continue;
        }
        if (token.type === 'operator') {
            if (COLON.test(token.value)) {
                token = {
                    type: 'query',
                    key: output.pop(),
                    value: tokens.shift()
                };
                output.push(token);
                continue;
            }
            while(stack.length > 0)output.unshift(stack.pop());
            stack.push(token);
        }
    }
    while(stack.length > 0)output.unshift(stack.pop());
    function walk() {
        var head = output.shift();
        if (head.type === 'number') return parseInt(head.value);
        if (head.type === 'literal') return head.value;
        if (head.type === 'operator') {
            var l = walk();
            var r = walk();
            return Operator(head.value, l, r);
        }
        if (head.type === 'query') {
            var l = head.key.value;
            var r = head.value.value;
            return Query(l, r);
        }
    }
    return walk();
}
module.exports = {
    parse: function(query) {
        var tokens = tokenizer(query);
        var ast = parser(tokens);
        return ast;
    }
};

},{"65352f2699c24bdf":"9Pmk5","7f5fc0bd01bcfeb3":"gqU88"}],"9Pmk5":[function(require,module,exports,__globalThis) {
function MaxHeight(value) {
    this.value = value;
    this.match = function(options) {
        return this.value >= options.height;
    };
}
function MinHeight(value) {
    this.value = value;
    this.match = function(options) {
        return this.value < options.height;
    };
}
function MaxWidth(value) {
    this.value = value;
    this.match = function(options) {
        return this.value >= options.width;
    };
}
function MinWidth(value) {
    this.value = value;
    this.match = function(options) {
        return this.value < options.width;
    };
}
function Orientation(value) {
    this.value = value;
    this.match = function(options) {
        return this.value === options.orientation;
    };
}
module.exports = function Query(type, value) {
    switch(type){
        case 'max-height':
            return new MaxHeight(value);
        case 'min-height':
            return new MinHeight(value);
        case 'max-width':
            return new MaxWidth(value);
        case 'min-width':
            return new MinWidth(value);
        case 'orientation':
            return new Orientation(value);
        default:
            throw new Error(value);
    }
};

},{}],"gqU88":[function(require,module,exports,__globalThis) {
function And(left, right) {
    this.left = left;
    this.right = right;
    this.match = function(options) {
        return left.match(options) && right.match(options);
    };
}
function Or(left, right) {
    this.left = left;
    this.right = right;
    this.match = function(options) {
        return left.match(options) || right.match(options);
    };
}
module.exports = function Operator(type, left, right) {
    switch(type){
        case 'and':
            return new And(left, right);
        case ',':
            return new Or(left, right);
        default:
            throw new Error(value);
    }
};

},{}],"iNXZf":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ac3b28f5c0fc998a");
exports.__esModule = true;
exports["default"] = void 0;
var _height = _interopRequireDefault(require("407601bac84520bf"));
var _descent = _interopRequireDefault(require("71c65255c79275ca"));
var _advanceWidth = _interopRequireDefault(require("aa8b57a8f93ce63f"));
var _ascent = _interopRequireDefault(require("a566267d8f0aa7c6"));
var DEST_REGEXP = /^#.+/;
var isSrcId = function isSrcId(src) {
    return src.match(DEST_REGEXP);
};
var renderAttachments = function renderAttachments(ctx, run) {
    ctx.save();
    var font = run.attributes.font;
    var space = font.glyphForCodePoint(0x20);
    var objectReplacement = font.glyphForCodePoint(0xfffc);
    var attachmentAdvance = 0;
    for(var i = 0; i < run.glyphs.length; i++){
        var position = run.positions[i];
        var glyph = run.glyphs[i];
        attachmentAdvance += position.xAdvance || 0;
        if (glyph.id === objectReplacement.id && run.attributes.attachment) {
            ctx.translate(attachmentAdvance, position.yOffset || 0);
            renderAttachment(ctx, run.attributes.attachment);
            run.glyphs[i] = space;
            attachmentAdvance = 0;
        }
    }
    ctx.restore();
};
var renderAttachment = function renderAttachment(ctx, attachment) {
    var _attachment$xOffset = attachment.xOffset, xOffset = _attachment$xOffset === void 0 ? 0 : _attachment$xOffset, _attachment$yOffset = attachment.yOffset, yOffset = _attachment$yOffset === void 0 ? 0 : _attachment$yOffset, width = attachment.width, height = attachment.height, image = attachment.image;
    ctx.translate(-width + xOffset, -height + yOffset);
    ctx.image(image, 0, 0, {
        fit: [
            width,
            height
        ],
        align: 'center',
        valign: 'bottom'
    });
};
var renderRun = function renderRun(ctx, run, options) {
    var _run$attributes = run.attributes, font = _run$attributes.font, fontSize = _run$attributes.fontSize, color = _run$attributes.color, link = _run$attributes.link, opacity = _run$attributes.opacity;
    var height = (0, _height["default"])(run);
    var descent = (0, _descent["default"])(run);
    var runAdvanceWidth = (0, _advanceWidth["default"])(run);
    if (options.outlineRuns) ctx.rect(0, -height, runAdvanceWidth, height).stroke();
    ctx.fillColor(color);
    ctx.fillOpacity(opacity);
    if (link) {
        if (isSrcId(link)) ctx.goTo(0, -height - descent, runAdvanceWidth, height, link.slice(1));
        else ctx.link(0, -height - descent, runAdvanceWidth, height, link);
    }
    renderAttachments(ctx, run);
    if (font.sbix || font.COLR && font.CPAL) {
        ctx.save();
        ctx.translate(0, -run.ascent);
        for(var i = 0; i < run.glyphs.length; i++){
            var position = run.positions[i];
            var glyph = run.glyphs[i];
            ctx.save();
            ctx.translate(position.xOffset, position.yOffset);
            glyph.render(ctx, fontSize);
            ctx.restore();
            ctx.translate(position.xAdvance, position.yAdvance);
        }
        ctx.restore();
    } else {
        ctx.font(typeof font.name === 'string' ? font.name : font, fontSize);
        try {
            ctx._addGlyphs(run.glyphs, run.positions, 0, 0);
        } catch (error) {
            console.log(error);
        }
    }
    ctx.translate(runAdvanceWidth, 0);
};
var renderBackground = function renderBackground(ctx, rect, backgroundColor) {
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    ctx.fill(backgroundColor);
};
var renderDecorationLine = function renderDecorationLine(ctx, line) {
    ctx.save();
    ctx.lineWidth(line.rect.height);
    ctx.strokeOpacity(line.opacity);
    if (/dashed/.test(line.style)) ctx.dash(3 * line.rect.height);
    else if (/dotted/.test(line.style)) ctx.dash(line.rect.height);
    if (/wavy/.test(line.style)) {
        var dist = Math.max(2, line.rect.height);
        var step = 1.1 * dist;
        var stepCount = Math.floor(line.rect.width / (2 * step)); // Adjust step to fill entire width
        var remainingWidth = line.rect.width - stepCount * 2 * step;
        var adjustment = remainingWidth / stepCount / 2;
        step += adjustment;
        var cp1y = line.rect.y + dist;
        var cp2y = line.rect.y - dist;
        var x = line.rect.x;
        ctx.moveTo(line.rect.x, line.rect.y);
        for(var i = 0; i < stepCount; i++){
            ctx.bezierCurveTo(x + step, cp1y, x + step, cp2y, x + 2 * step, line.rect.y);
            x += 2 * step;
        }
    } else {
        ctx.moveTo(line.rect.x, line.rect.y);
        ctx.lineTo(line.rect.x + line.rect.width, line.rect.y);
        if (/double/.test(line.style)) {
            ctx.moveTo(line.rect.x, line.rect.y + line.rect.height * 2);
            ctx.lineTo(line.rect.x + line.rect.width, line.rect.y + line.rect.height * 2);
        }
    }
    ctx.stroke(line.color);
    ctx.restore();
};
var renderLine = function renderLine(ctx, line, options) {
    var lineAscent = (0, _ascent["default"])(line);
    if (options.outlineLines) ctx.rect(line.box.x, line.box.y, line.box.width, line.box.height).stroke();
    ctx.save();
    ctx.translate(line.box.x, line.box.y + lineAscent);
    for(var _iterator = line.runs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var run = _ref;
        if (run.attributes.backgroundColor) {
            var backgroundRect = {
                x: 0,
                y: -lineAscent,
                height: line.box.height,
                width: (0, _advanceWidth["default"])(run) - line.overflowRight
            };
            renderBackground(ctx, backgroundRect, run.attributes.backgroundColor);
        }
        renderRun(ctx, run, options);
    }
    ctx.restore();
    ctx.save();
    ctx.translate(line.box.x, line.box.y);
    for(var _iterator2 = line.decorationLines, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
        var _ref2;
        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }
        var decorationLine = _ref2;
        renderDecorationLine(ctx, decorationLine);
    }
    ctx.restore();
};
var renderBlock = function renderBlock(ctx, block, options) {
    for(var _iterator3 = block, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;){
        var _ref3;
        if (_isArray3) {
            if (_i3 >= _iterator3.length) break;
            _ref3 = _iterator3[_i3++];
        } else {
            _i3 = _iterator3.next();
            if (_i3.done) break;
            _ref3 = _i3.value;
        }
        var line = _ref3;
        renderLine(ctx, line, options);
    }
};
var render = function render(ctx, blocks, options) {
    if (options === void 0) options = {};
    for(var _iterator4 = blocks, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;){
        var _ref4;
        if (_isArray4) {
            if (_i4 >= _iterator4.length) break;
            _ref4 = _iterator4[_i4++];
        } else {
            _i4 = _iterator4.next();
            if (_i4.done) break;
            _ref4 = _i4.value;
        }
        var block = _ref4;
        renderBlock(ctx, block, options);
    }
};
var _default = {
    render: render
};
exports["default"] = _default;

},{"ac3b28f5c0fc998a":"kZ6eK","407601bac84520bf":"1UdtL","71c65255c79275ca":"1erMr","aa8b57a8f93ce63f":"1J9lT","a566267d8f0aa7c6":"1ijen"}],"1UdtL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2a0b0a5671ac6d94");
var _interopRequireWildcard = require("e16f5337b206c027");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("eecfa2401d3dcdf3"));
var _ascent = _interopRequireDefault(require("4b299b269b60422"));
var _descent = _interopRequireDefault(require("613037ee671123f2"));
var _lineGap = _interopRequireDefault(require("e3dc7422ca353145"));
/**
 * Get run height
 *
 * @param  {Object}  run
 * @return {number} height
 */ var height = R.either(R.path([
    'attributes',
    'lineHeight'
]), R.compose(R.sum, R.juxt([
    _ascent["default"],
    R.o(R.negate, _descent["default"]),
    _lineGap["default"]
])));
var _default = height;
exports["default"] = _default;

},{"2a0b0a5671ac6d94":"kZ6eK","e16f5337b206c027":"fiRIh","eecfa2401d3dcdf3":"lzfqX","4b299b269b60422":"1j5S7","613037ee671123f2":"1erMr","e3dc7422ca353145":"c9h9b"}],"fiRIh":[function(require,module,exports,__globalThis) {
var _typeof = require("41c629e90a135a51")["default"];
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"41c629e90a135a51":"979to"}],"1j5S7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("628f67827d3dec49");
var _interopRequireWildcard = require("dea1540d1a8c0665");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("329416aaeba286a5"));
var _scale = _interopRequireDefault(require("b5a7616556a8910e"));
var getFontAscent = R.ifElse(R.has('attributes'), R.pathOr(0, [
    'attributes',
    'font',
    'ascent'
]), R.always(0));
/**
 * Get run ascent
 *
 * @param  {Object}  run
 * @return {boolean} ascent
 */ var ascent = R.converge(R.max, [
    R.pathOr(0, [
        'attributes',
        'attachment',
        'height'
    ]),
    R.converge(R.multiply, [
        _scale["default"],
        getFontAscent
    ])
]);
var _default = ascent;
exports["default"] = _default;

},{"628f67827d3dec49":"kZ6eK","dea1540d1a8c0665":"fiRIh","329416aaeba286a5":"lzfqX","b5a7616556a8910e":"eOG6x"}],"eOG6x":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("cb3dc6f8f6ef7049");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("33eceae69440ea5"));
var unitsPerEm = [
    'font',
    'unitsPerEm'
];
/**
 * Calculate run scale
 *
 * @param  {Object}  run
 * @return {number} scale
 */ var calculateScale = R.compose(R.ifElse(R.compose(R.not, R.isNil, R.path(unitsPerEm)), R.converge(R.divide, [
    R.propOr(12, 'fontSize'),
    R.path(unitsPerEm)
]), R.always(0)), R.propOr({}, 'attributes'));
/**
 * Get run scale
 *
 * @param  {Object}  run
 * @return {number} scale
 */ var scale = R.either(R.path([
    'attributes',
    'scale'
]), calculateScale);
var _default = scale;
exports["default"] = _default;

},{"cb3dc6f8f6ef7049":"fiRIh","33eceae69440ea5":"lzfqX"}],"1erMr":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("4f8450110d3779f");
var _interopRequireWildcard = require("889565671262b56e");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("12ddd145f3162f4"));
var _scale = _interopRequireDefault(require("8d288d322432dab7"));
var getFontDescent = R.ifElse(R.has('attributes'), R.pathOr(0, [
    'attributes',
    'font',
    'descent'
]), R.always(0));
/**
 * Get run descent
 *
 * @param  {Object}  run
 * @return {number} descent
 */ var descent = R.converge(R.multiply, [
    _scale["default"],
    getFontDescent
]);
var _default = descent;
exports["default"] = _default;

},{"4f8450110d3779f":"kZ6eK","889565671262b56e":"fiRIh","12ddd145f3162f4":"lzfqX","8d288d322432dab7":"eOG6x"}],"c9h9b":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("88839cdabe376dab");
var _interopRequireWildcard = require("5df585d2eccc5e0d");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("37323fc357bdb470"));
var _scale = _interopRequireDefault(require("4f5dd87642f5a2d1"));
/**
 * Get run lineGap
 *
 * @param  {Object}  run
 * @return {number} lineGap
 */ var lineGap = R.converge(R.multiply, [
    _scale["default"],
    R.pathOr(0, [
        'attributes',
        'font',
        'lineGap'
    ])
]);
var _default = lineGap;
exports["default"] = _default;

},{"88839cdabe376dab":"kZ6eK","5df585d2eccc5e0d":"fiRIh","37323fc357bdb470":"lzfqX","4f5dd87642f5a2d1":"eOG6x"}],"1J9lT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("510d4033cf00427b");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("fec0ce0568c96a8e"));
/**
 * Return run advance width
 *
 * @param  {Object}  run
 * @return {number} advance width
 */ var advanceWidth = R.compose(R.reduce(R.useWith(R.add, [
    R.identity,
    R.propOr(0, 'xAdvance')
]), 0), R.propOr([], 'positions'));
var _default = advanceWidth;
exports["default"] = _default;

},{"510d4033cf00427b":"fiRIh","fec0ce0568c96a8e":"lzfqX"}],"1ijen":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6650e3f6a96c790d");
var _interopRequireWildcard = require("6b03c8d450991f97");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("81205c673958cc15"));
var _reduce = _interopRequireDefault(require("e5407c48879c691"));
var _ascent = _interopRequireDefault(require("f555c9a9887b8ad8"));
/**
 * Returns attributed string ascent
 *
 * @param {Object} attributed string
 * @return {number} ascent
 */ var ascent = (0, _reduce["default"])(R.max, _ascent["default"]);
var _default = ascent;
exports["default"] = _default;

},{"6650e3f6a96c790d":"kZ6eK","6b03c8d450991f97":"fiRIh","81205c673958cc15":"lzfqX","e5407c48879c691":"aagkU","f555c9a9887b8ad8":"1j5S7"}],"aagkU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("bb27a52f7e2ae20f");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("7833a1eb7149b09a"));
/**
 * Sum run function results
 *
 * @param {function} accum fn
 * @param {function} function run (run) -> Number
 * @param {number} initial value
 * @return {number} sum
 */ var sumRuns = function sumRuns(accum, fn, init) {
    if (init === void 0) init = 0;
    return R.compose(R.reduce(R.useWith(accum, [
        R.identity,
        fn
    ]), init), R.prop('runs'));
};
var _default = sumRuns;
exports["default"] = _default;

},{"bb27a52f7e2ae20f":"fiRIh","7833a1eb7149b09a":"lzfqX"}],"2G4cs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a1106d4df64d57e4");
exports.__esModule = true;
exports["default"] = void 0;
var _advanceWidth = _interopRequireDefault(require("46d96142506953f1"));
var _advanceWidthBetween = _interopRequireDefault(require("73e892d58701672e"));
var _append = _interopRequireDefault(require("25759d74d4dc0e39"));
var _ascent = _interopRequireDefault(require("7a88f00ec2747932"));
var _copy = _interopRequireDefault(require("b25989b61d8296a5"));
var _descent = _interopRequireDefault(require("873a20dc6e5ec128"));
var _dropLast = _interopRequireDefault(require("89a1bbeb75fd89a2"));
var _empty = _interopRequireDefault(require("59290f8fd3568f3a"));
var _end = _interopRequireDefault(require("84c5b2ba0018906e"));
var _fromFragments = _interopRequireDefault(require("52309622766fa0bf"));
var _glyphWidthAt = _interopRequireDefault(require("167ff8b07726b35"));
var _height = _interopRequireDefault(require("6a30bf1a1541a4fa"));
var _indexAtOffset = _interopRequireDefault(require("9bf7a4b4a58debf9"));
var _insertGlyph = _interopRequireDefault(require("1a63c0782971100e"));
var _leadingOffset = _interopRequireDefault(require("57e18459337db2cf"));
var _length = _interopRequireDefault(require("d110038d42828449"));
var _prepend = _interopRequireDefault(require("23baf0a05c45d1c"));
var _reduce = _interopRequireDefault(require("c377345fa755df11"));
var _runAt = _interopRequireDefault(require("c5559d5ca3c96446"));
var _runIndexAt = _interopRequireDefault(require("6cc603af24279393"));
var _slice = _interopRequireDefault(require("7a73124c8e9290b7"));
var _sliceAtOffset = _interopRequireDefault(require("67f8fd5b29972fd6"));
var _start = _interopRequireDefault(require("c6e852d38e0f9922"));
var _trailingOffset = _interopRequireDefault(require("916c90f5e4c45dac"));
var _trim = _interopRequireDefault(require("b7b08ce5770a4267"));
var _default = {
    advanceWidth: _advanceWidth["default"],
    advanceWidthBetween: _advanceWidthBetween["default"],
    append: _append["default"],
    ascent: _ascent["default"],
    copy: _copy["default"],
    descent: _descent["default"],
    dropLast: _dropLast["default"],
    empty: _empty["default"],
    end: _end["default"],
    fromFragments: _fromFragments["default"],
    glyphWidthAt: _glyphWidthAt["default"],
    height: _height["default"],
    indexAtOffset: _indexAtOffset["default"],
    insertGlyph: _insertGlyph["default"],
    leadingOffset: _leadingOffset["default"],
    length: _length["default"],
    prepend: _prepend["default"],
    reduce: _reduce["default"],
    runAt: _runAt["default"],
    runIndexAt: _runIndexAt["default"],
    slice: _slice["default"],
    sliceAtOffset: _sliceAtOffset["default"],
    start: _start["default"],
    trailingOffset: _trailingOffset["default"],
    trim: _trim["default"]
};
exports["default"] = _default;

},{"a1106d4df64d57e4":"kZ6eK","46d96142506953f1":"bqw7C","73e892d58701672e":"iaHWm","25759d74d4dc0e39":"677Va","7a88f00ec2747932":"1ijen","b25989b61d8296a5":"3ccTH","873a20dc6e5ec128":"hLtXU","89a1bbeb75fd89a2":"MTB7g","59290f8fd3568f3a":"bJOOn","84c5b2ba0018906e":"3Iz3s","52309622766fa0bf":"dpl7E","167ff8b07726b35":"ip7iq","6a30bf1a1541a4fa":"lkmD6","9bf7a4b4a58debf9":"bwgzK","1a63c0782971100e":"37qVT","57e18459337db2cf":"lB4Yp","d110038d42828449":"fi9n8","23baf0a05c45d1c":"2doIT","c377345fa755df11":"aagkU","c5559d5ca3c96446":"8lNSx","6cc603af24279393":"8oz6U","7a73124c8e9290b7":"eSCNP","67f8fd5b29972fd6":"3PBI3","c6e852d38e0f9922":"hFLv7","916c90f5e4c45dac":"fo2bo","b7b08ce5770a4267":"dyq8z"}],"bqw7C":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("13d6b40ecf279802");
var _interopRequireWildcard = require("9097ee4e689b19d3");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("7a284d1fbcd4eafc"));
var _reduce = _interopRequireDefault(require("2a456cbec94a7ddb"));
var _advanceWidth = _interopRequireDefault(require("58a0bfa357f860f2"));
/**
 * Returns attributed string advancewidth
 *
 * @param {Object} attributed string
 * @return {number} advance width
 */ var advanceWidth = (0, _reduce["default"])(R.add, _advanceWidth["default"]);
var _default = advanceWidth;
exports["default"] = _default;

},{"13d6b40ecf279802":"kZ6eK","9097ee4e689b19d3":"fiRIh","7a284d1fbcd4eafc":"lzfqX","2a456cbec94a7ddb":"aagkU","58a0bfa357f860f2":"1J9lT"}],"iaHWm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5c70f4734619cae9");
var _interopRequireWildcard = require("8252f7f137376ded");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("79d7c38940da0284"));
var _filter = _interopRequireDefault(require("a0a4fd4922ebfae8"));
var _advanceWidthBetween = _interopRequireDefault(require("fe2015c274b1a411"));
/**
 * Advance width between start and end
 * Does not consider ligature splitting for the moment.
 * Check performance impact on supporting this
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Object}  attributedString
 * @return {number} advance width
 */ var advanceWidthBetween = function advanceWidthBetween(start, end, string) {
    return R.compose(R.sum, R.map((0, _advanceWidthBetween["default"])(start, end)), (0, _filter["default"])(start, end), R.propOr([], 'runs'))(string);
};
var _default = R.curryN(3, advanceWidthBetween);
exports["default"] = _default;

},{"5c70f4734619cae9":"kZ6eK","8252f7f137376ded":"fiRIh","79d7c38940da0284":"lzfqX","a0a4fd4922ebfae8":"lYk4C","fe2015c274b1a411":"7bKhl"}],"lYk4C":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c1a7687bd54a09e");
var _interopRequireWildcard = require("f99d0eacc96a3ec1");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("e8dcdeb625ba96fe"));
var _runIndexAt = _interopRequireDefault(require("5c014549344bd"));
/**
 * Filter runs contained between start and end
 *
 * @param  {number}  start
 * @param  {number}  end
 * @param  {Array}  runs
 * @return {boolean} filtered runs
 */ var filter = function filter(start, end, runs) {
    var startIndex = (0, _runIndexAt["default"])(start, runs);
    var endIndex = R.max((0, _runIndexAt["default"])(end - 1, runs), startIndex);
    return R.slice(startIndex, endIndex + 1, runs);
};
var _default = R.curryN(3, filter);
exports["default"] = _default;

},{"c1a7687bd54a09e":"kZ6eK","f99d0eacc96a3ec1":"fiRIh","e8dcdeb625ba96fe":"lzfqX","5c014549344bd":"lCX8c"}],"lCX8c":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8cc1374abfa7177b");
var _interopRequireWildcard = require("aeebc69ac8d0a1ed");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("a1849dcd239ca6b4"));
var _isBetween = _interopRequireDefault(require("acfc195f7d2d2b17"));
/**
 * Get run index that contains passed index
 *
 * @param  {number}  char index
 * @param  {Array}  runs array
 * @return {Array} run index
 */ var runIndexAt = function runIndexAt(n, runs) {
    return R.findIndex((0, _isBetween["default"])(R.prop('start'), R.prop('end'), n))(runs);
};
var _default = R.curryN(2, runIndexAt);
exports["default"] = _default;

},{"8cc1374abfa7177b":"kZ6eK","aeebc69ac8d0a1ed":"fiRIh","a1849dcd239ca6b4":"lzfqX","acfc195f7d2d2b17":"gmclt"}],"gmclt":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f5a19db905f8d026");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("443ac8f89516ad84"));
/**
 * Checks if number is between two values (upper non-inclusive)
 *
 * @param  {Function}  lower value
 * @param  {Function}  higher value
 * @param  {number}  predicate value
 * @return {Function} is between invoker
 */ var isBetween = function isBetween(a, b, c) {
    return R.both(R.o(R.gte(c), a), R.o(R.lt(c), b));
};
var _default = R.curryN(3, isBetween);
exports["default"] = _default;

},{"f5a19db905f8d026":"fiRIh","443ac8f89516ad84":"lzfqX"}],"7bKhl":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("650d8a31f11d2b9");
var _interopRequireWildcard = require("70884ac0979a4707");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("aae729e07202b17f"));
var _glyphIndexAt = _interopRequireDefault(require("2bd65e9cf9352d7b"));
/**
 * Advance width between two string indices
 *
 * @param  {number}  start glyph index
 * @param  {number}  end glyph index
 * @param  {Object}  run
 * @return {Object} advanced width run
 */ var advanceWidthBetween = function advanceWidthBetween(start, end, run) {
    var runStart = R.propOr(0, 'start', run);
    var glyphStartIndex = Math.max(0, (0, _glyphIndexAt["default"])(start - runStart, run));
    var glyphEndIndex = Math.max(0, (0, _glyphIndexAt["default"])(end - runStart, run));
    return R.compose(R.reduce(R.useWith(R.add, [
        R.identity,
        R.propOr(0, 'xAdvance')
    ]), 0), R.slice(glyphStartIndex, glyphEndIndex), R.propOr([], 'positions'))(run);
};
var _default = R.curryN(3, advanceWidthBetween);
exports["default"] = _default;

},{"650d8a31f11d2b9":"kZ6eK","70884ac0979a4707":"fiRIh","aae729e07202b17f":"lzfqX","2bd65e9cf9352d7b":"1rIKi"}],"1rIKi":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("268152427a58deb9");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("7ff8ea43e7be9894"));
/**
 * Return glyph index at string index, if glyph indices present.
 * Otherwise return string index
 *
 * @param  {number}  string index
 * @param  {Object}  run
 * @return {number}  glyph index
 */ var glyphIndexAt = function glyphIndexAt(index, run) {
    return R.pathOr(index, [
        'glyphIndices',
        index
    ])(run);
};
var _default = R.curryN(2, glyphIndexAt);
exports["default"] = _default;

},{"268152427a58deb9":"fiRIh","7ff8ea43e7be9894":"lzfqX"}],"677Va":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("214121c3a1ab5dc0");
var _interopRequireWildcard = require("12bcf494fee9ff92");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("ff0a0631a8edf2d6"));
var _empty = _interopRequireDefault(require("80d74730c41d2a11"));
var _append = _interopRequireDefault(require("f15812d532b73125"));
var _stringFromCodePoints = _interopRequireDefault(require("9870a253cd4864d0"));
/**
 * Append glyph into last run of attributed string
 *
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var append = function append(glyph, string) {
    var codePoints = R.propOr([], 'codePoints')(glyph);
    return R.evolve({
        string: R.concat(R.__, (0, _stringFromCodePoints["default"])(codePoints)),
        runs: R.converge(R.concat, [
            R.init,
            R.compose(R.unapply(R.identity), (0, _append["default"])(glyph), R.either(R.last, _empty["default"]))
        ])
    })(string);
};
var _default = R.curryN(2, append);
exports["default"] = _default;

},{"214121c3a1ab5dc0":"kZ6eK","12bcf494fee9ff92":"fiRIh","ff0a0631a8edf2d6":"lzfqX","80d74730c41d2a11":"ah8au","f15812d532b73125":"9bLgy","9870a253cd4864d0":"ev4bJ"}],"ah8au":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("84a7cf8c316e176a");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("fc0712ce1db1f29b"));
/**
 * Returns empty run
 *
 * @return {Object} empty run
 */ var empty = R.always({
    start: 0,
    end: 0,
    glyphIndices: [],
    glyphs: [],
    positions: [],
    attributes: {}
});
var _default = empty;
exports["default"] = _default;

},{"84a7cf8c316e176a":"fiRIh","fc0712ce1db1f29b":"lzfqX"}],"9bLgy":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9190f792ac2ffd32");
var _interopRequireWildcard = require("c1fb3e97fdeb2825");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("79269bb3dade0f9"));
var _copy = _interopRequireDefault(require("6e0fb939a8b27b96"));
var _scale = _interopRequireDefault(require("9d8510da2af6c507"));
var _getFont = _interopRequireDefault(require("118e3f87420f8e4a"));
var _isNumber = _interopRequireDefault(require("35af350c4e86beb5"));
var _append = _interopRequireDefault(require("e8142a020c2d91b"));
var _fromCodePoint = _interopRequireDefault(require("70980b6827b38506"));
/**
 * Append glyph to run
 *
 * @param  {Object}  glyph
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var appendGlyph = function appendGlyph(glyph, run) {
    var runScale = (0, _scale["default"])(run);
    var glyphLength = R.length(glyph.codePoints);
    return R.evolve({
        end: R.add(glyphLength),
        glyphs: R.append(glyph),
        glyphIndices: (0, _append["default"])(glyphLength),
        positions: R.append({
            xAdvance: glyph.advanceWidth * runScale
        })
    })(run);
};
/**
 * Append glyph or code point to run
 *
 * @param  {Object | number}  glyph | codePoint
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var append = function append(value, run) {
    if (!value) return (0, _copy["default"])(run);
    var font = (0, _getFont["default"])(run);
    var glyph = (0, _isNumber["default"])(value) ? (0, _fromCodePoint["default"])(value, font) : value;
    return appendGlyph(glyph, run);
};
var _default = R.curryN(2, append);
exports["default"] = _default;

},{"9190f792ac2ffd32":"kZ6eK","c1fb3e97fdeb2825":"fiRIh","79269bb3dade0f9":"lzfqX","6e0fb939a8b27b96":"diPRw","9d8510da2af6c507":"eOG6x","118e3f87420f8e4a":"jqjVQ","35af350c4e86beb5":"ilX8l","e8142a020c2d91b":"ciHkv","70980b6827b38506":"3ghfj"}],"diPRw":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("b5c9dfde5496d6b6");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("6509e3e4ff9fa46a"));
/**
 * Deep clone run
 *
 * @param  {Object}  run
 * @return {Object} cloned run
 */ var copy = R.evolve({
    glyphs: R.map(R.identity),
    positions: R.clone,
    glyphIndices: R.clone,
    attributes: R.evolve({
        font: R.identity
    })
});
var _default = copy;
exports["default"] = _default;

},{"b5c9dfde5496d6b6":"fiRIh","6509e3e4ff9fa46a":"lzfqX"}],"jqjVQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("8717eefc4a3f4895");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("a83bef49ea87eacf"));
/**
 * Get run font
 *
 * @param  {Object}  run
 * @return {Object} font
 */ var getFont = R.pathOr(null, [
    'attributes',
    'font'
]);
var _default = getFont;
exports["default"] = _default;

},{"8717eefc4a3f4895":"fiRIh","a83bef49ea87eacf":"lzfqX"}],"ilX8l":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("bf2799d75a7674be");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("5c8b53c4b98e14d3"));
var isNumber = R.is(Number);
var _default = isNumber;
exports["default"] = _default;

},{"bf2799d75a7674be":"fiRIh","5c8b53c4b98e14d3":"lzfqX"}],"ciHkv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5bd11fcc389932db");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("e1abee0fef1d4deb"));
/**
 * Append glyph indices with given length
 *
 * Ex. appendIndices(3, [0, 1, 2, 2]) => [0, 1, 2, 2, 3, 3, 3]
 *
 * @param  {number}  length
 * @param  {Array}  glyph indices
 * @return {Array}  extended glyph indices
 */ var appendIndices = function appendIndices(length, indices) {
    return R.converge(R.concat, [
        R.identity,
        R.converge(R.repeat, [
            R.either(R.o(R.inc, R.last), R.always(0) // Or zero if inserting at beggining
            ),
            R.always(length)
        ])
    ])(indices);
};
var _default = R.curryN(2, appendIndices);
exports["default"] = _default;

},{"5bd11fcc389932db":"fiRIh","e1abee0fef1d4deb":"lzfqX"}],"3ghfj":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports["default"] = void 0;
/**
 * Get glyph for a given code point
 *
 * @param  {number}  codePoint
 * @param  {Object}  font
 * @return {Object}  glyph
 * */ var fromCodePoint = function fromCodePoint(value, font) {
    return font && value ? font.glyphForCodePoint(value) : null;
};
var _default = fromCodePoint;
exports["default"] = _default;

},{}],"ev4bJ":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports["default"] = void 0;
/**
 * Get string from array of code points
 *
 * @param {Array} code points
 * @return {String} string
 */ var stringFromCodePoints = function stringFromCodePoints(codePoints) {
    return String.fromCodePoint.apply(String, codePoints);
};
var _default = stringFromCodePoints;
exports["default"] = _default;

},{}],"3ccTH":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e71470d04a840a8b");
var _interopRequireWildcard = require("5fe1f5ea6e93b1f8");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("6d003cc085cb211c"));
var _copy = _interopRequireDefault(require("54da25caa848d2e0"));
/**
 * Deep clone attributed string
 *
 * @param  {Object}  attributed string
 * @return {Object} cloned attributed string
 */ var copy = R.evolve({
    string: R.identity,
    syllables: R.identity,
    runs: R.map(_copy["default"])
});
var _default = copy;
exports["default"] = _default;

},{"e71470d04a840a8b":"kZ6eK","5fe1f5ea6e93b1f8":"fiRIh","6d003cc085cb211c":"lzfqX","54da25caa848d2e0":"diPRw"}],"hLtXU":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1cce5c012acb375b");
var _interopRequireWildcard = require("bdd169a798e9b87b");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("e2e1a64312ed91e7"));
var _reduce = _interopRequireDefault(require("965935ee1cd83b99"));
var _descent = _interopRequireDefault(require("8f9b185d0ac10225"));
/**
 * Returns attributed string descent
 *
 * @param {Object} attributed string
 * @return {number} descent
 */ var descent = (0, _reduce["default"])(R.min, _descent["default"]);
var _default = descent;
exports["default"] = _default;

},{"1cce5c012acb375b":"kZ6eK","bdd169a798e9b87b":"fiRIh","e2e1a64312ed91e7":"lzfqX","965935ee1cd83b99":"aagkU","8f9b185d0ac10225":"1erMr"}],"MTB7g":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("30c19de88e71ae6b");
var _interopRequireWildcard = require("ee217c357f2dad1d");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("8f317c1e0c877014"));
var _dropLast = _interopRequireDefault(require("fbde8de72fc9da4e"));
/**
 * Drop last glyph
 *
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var dropLast = function dropLast(string) {
    return R.evolve({
        string: R.dropLast(1),
        runs: R.adjust(-1, _dropLast["default"])
    })(string);
};
var _default = dropLast;
exports["default"] = _default;

},{"30c19de88e71ae6b":"kZ6eK","ee217c357f2dad1d":"fiRIh","8f317c1e0c877014":"lzfqX","fbde8de72fc9da4e":"2yuRP"}],"2yuRP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("15557e0e23eea74e");
exports.__esModule = true;
exports["default"] = void 0;
var _slice = _interopRequireDefault(require("414672d93a3a83c0"));
/**
 * Drop last char of run
 *
 * @param  {Object}  run
 * @return {boolean} run without last char
 */ var dropLast = function dropLast(run) {
    return (0, _slice["default"])(0, run.end - run.start - 1, run);
};
var _default = dropLast;
exports["default"] = _default;

},{"15557e0e23eea74e":"kZ6eK","414672d93a3a83c0":"02clA"}],"02clA":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("273c26f5121482fb");
var _interopRequireWildcard = require("5b970b2b9661146e");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("9577305ce41cefa4"));
var _scale = _interopRequireDefault(require("3b21e783177d5ba"));
var _offset = _interopRequireDefault(require("96cd99eb04dc7037"));
var _getFont = _interopRequireDefault(require("8527d8b8675c0fa0"));
var _slice = _interopRequireDefault(require("f3947e4a1159cf05"));
var _glyphIndexAt = _interopRequireDefault(require("7556d769d6bb0c11"));
var _normalize = _interopRequireDefault(require("79cf741e3efc8956"));
/**
 * Slice run between glyph indices range
 *
 * @param  {number}  start glyph index
 * @param  {number}  end glyph index
 * @param  {Object}  run
 * @return {Object} sliced run
 */ var slice = function slice(start, end, run) {
    var runScale = (0, _scale["default"])(run);
    var font = (0, _getFont["default"])(run); // Get glyph start and end indices
    var glyphStartIndex = (0, _glyphIndexAt["default"])(start, run);
    var glyphEndIndex = (0, _glyphIndexAt["default"])(end, run); // Get start and end glyph
    var startGlyph = R.path([
        'glyphs',
        glyphStartIndex
    ], run);
    var endGlyph = R.path([
        'glyphs',
        glyphEndIndex
    ], run); // Get start ligature chunks (if any)
    var startOffset = (0, _offset["default"])(start, run);
    var startGlyphs = startOffset > 0 ? (0, _slice["default"])(startOffset, Infinity, font, startGlyph) : []; // Get end ligature chunks (if any)
    var endOffset = (0, _offset["default"])(end, run);
    var endGlyphs = (0, _slice["default"])(0, endOffset, font, endGlyph);
    var sliceOffset = Math.min(1, startOffset);
    return R.evolve({
        start: R.add(start),
        end: R.compose(R.apply(R.min), R.juxt([
            R.identity,
            R.o(R.add(end), R.always(run.start)) // end + string.start
        ])),
        glyphs: function glyphs(_glyphs) {
            return R.flatten([
                startGlyphs,
                _glyphs.slice(glyphStartIndex + sliceOffset, glyphEndIndex),
                endGlyphs
            ]);
        },
        positions: function positions(_positions) {
            return R.flatten([
                startGlyphs.map(function(g) {
                    return {
                        xAdvance: g.advanceWidth * runScale
                    };
                }),
                _positions.slice(glyphStartIndex + sliceOffset, glyphEndIndex),
                endGlyphs.map(function(g) {
                    return {
                        xAdvance: g.advanceWidth * runScale
                    };
                })
            ]);
        },
        glyphIndices: R.o(_normalize["default"], R.slice(start, end)),
        attributes: R.identity
    })(run);
};
var _default = R.curryN(3, slice);
exports["default"] = _default;

},{"273c26f5121482fb":"kZ6eK","5b970b2b9661146e":"fiRIh","9577305ce41cefa4":"lzfqX","3b21e783177d5ba":"eOG6x","96cd99eb04dc7037":"hJ08I","8527d8b8675c0fa0":"jqjVQ","f3947e4a1159cf05":"11Tqa","7556d769d6bb0c11":"1rIKi","79cf741e3efc8956":"6DHLv"}],"hJ08I":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("f38eac36302e989f");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("484d0714050b5c33"));
/**
 * Get ligature offset by index
 *
 * Ex. ffi ligature
 *
 *   glyphs:         l  o  f  f  i  m
 *   glyphIndices:   0  1  2  2  2  3
 *   offset:         0  0  0  1  2  0
 *
 * @param  {number}  index
 * @param  {Object}  run
 * @return {number} ligature offset
 */ var offset = function offset(index, run) {
    var value = R.pathOr(null, [
        'glyphIndices',
        index
    ], run);
    return R.compose(R.length, R.dropWhile(R.gt(value)), R.slice(0, index), R.propOr([], 'glyphIndices'))(run);
};
var _default = R.curryN(2, offset);
exports["default"] = _default;

},{"f38eac36302e989f":"fiRIh","484d0714050b5c33":"lzfqX"}],"11Tqa":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e2ca4ef65f7e1e8f");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("cc3b0b658db0fca0"));
/**
 * Slice glyph between codePoints range
 * Util for breaking ligatures
 *
 * @param  {number}  start code point index
 * @param  {number}  end code point index
 * @param  {Object}  font to generate new glyph
 * @param  {Object} glyph to be sliced
 * @return {Array} sliced glyph parts
 */ var slice = function slice(start, end, font, glyph) {
    if (!glyph) return [];
    if (start === end) return [];
    if (start === 0 && end === glyph.codePoints.length) return [
        glyph
    ];
    var codePoints = R.slice(start, end, glyph.codePoints);
    var string = String.fromCodePoint.apply(String, codePoints);
    return font ? font.layout(string).glyphs : [
        glyph
    ];
};
var _default = R.curryN(4, slice);
exports["default"] = _default;

},{"e2ca4ef65f7e1e8f":"fiRIh","cc3b0b658db0fca0":"lzfqX"}],"6DHLv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("10f85d9787d1193");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("d83208831413e6e1"));
/**
 * Returns new array starting with zero, and keeping same relation between consecutive values
 *
 * @param  {Array[number]}  list
 * @return {boolean} normalized array
 */ var normalize = function normalize(array) {
    return R.map(R.subtract(R.__, R.head(array)))(array);
};
var _default = normalize;
exports["default"] = _default;

},{"10f85d9787d1193":"fiRIh","d83208831413e6e1":"lzfqX"}],"bJOOn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("9d35c94754f97a26");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("2404e4da7834784e"));
/**
 * Returns empty attributed string
 *
 * @return {Object} empty attributed string
 */ var empty = R.always({
    string: '',
    runs: []
});
var _default = empty;
exports["default"] = _default;

},{"9d35c94754f97a26":"fiRIh","2404e4da7834784e":"lzfqX"}],"3Iz3s":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("342a7009a32ab628");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("edb406cc9448bea0"));
/**
 * Get attributed string end value
 *
 * @param  {Object}  glyph string
 * @return {number} end
 */ var end = R.ifElse(R.pathEq([
    'runs',
    'length'
], 0), R.always(0), R.compose(R.prop('end'), R.last, R.prop('runs')));
var _default = end;
exports["default"] = _default;

},{"342a7009a32ab628":"fiRIh","edb406cc9448bea0":"lzfqX"}],"dpl7E":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("90abcaeafff235f3");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("1c4d369c5527c58a"));
/**
 * Create attributed string from text fragments
 *
 * @param  {Array}  fragments
 * @return {Object} attributed string
 */ var fromFragments = function fromFragments(fragments) {
    var offset = 0;
    var getRuns = R.map(function(fragment) {
        var run = {
            start: offset,
            end: offset + fragment.string.length,
            attributes: fragment.attributes || {}
        };
        offset += fragment.string.length;
        return run;
    });
    return R.applySpec({
        runs: getRuns,
        string: R.o(R.join(''), R.pluck('string'))
    })(fragments);
};
var _default = fromFragments;
exports["default"] = _default;

},{"90abcaeafff235f3":"fiRIh","1c4d369c5527c58a":"lzfqX"}],"ip7iq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d1fddbfd4f534c46");
var _interopRequireWildcard = require("95117c73094cf9d1");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("15ed4557948fbf84"));
var _runAt = _interopRequireDefault(require("3af1daf0fb4026a"));
var _glyphIndexAt = _interopRequireDefault(require("ac0df78b683c6a6b"));
/**
 * Get glyph width at string index
 *
 * @param {number} string index
 * @param {Object} attributed string
 * @return {number} glyph width
 */ var glyphWidthAt = function glyphWidthAt(index, string) {
    var run = (0, _runAt["default"])(index, string);
    var glyphIndex = (0, _glyphIndexAt["default"])(index, run);
    return run.positions[glyphIndex].xAdvance;
};
var _default = glyphWidthAt;
exports["default"] = _default;

},{"d1fddbfd4f534c46":"kZ6eK","95117c73094cf9d1":"fiRIh","15ed4557948fbf84":"lzfqX","3af1daf0fb4026a":"8lNSx","ac0df78b683c6a6b":"1rIKi"}],"8lNSx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7899ae86d31931fd");
var _interopRequireWildcard = require("33f12399c1c21358");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("732be7b407aecc59"));
var _runIndexAt = _interopRequireDefault(require("afa8e83210e0301c"));
/**
 * Get run at char index
 *
 * @param  {number}  char index
 * @param  {Object}  attributedString
 * @return {Object} run
 */ var runAt = function runAt(n, attributedString) {
    var runIndex = (0, _runIndexAt["default"])(n)(attributedString);
    return R.path([
        'runs',
        runIndex
    ])(attributedString);
};
var _default = R.curryN(2, runAt);
exports["default"] = _default;

},{"7899ae86d31931fd":"kZ6eK","33f12399c1c21358":"fiRIh","732be7b407aecc59":"lzfqX","afa8e83210e0301c":"8oz6U"}],"8oz6U":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ee17cba7d7816b65");
var _interopRequireWildcard = require("d05fea9e06de01");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("57bf6351400a1a7c"));
var _runIndexAt = _interopRequireDefault(require("8ddf7099e2246b59"));
/**
 * Get run index at char index
 *
 * @param  {number}  char index
 * @param  {Object}  attributedString
 * @return {number} run index
 */ var runIndexAt = function runIndexAt(n, string) {
    return R.compose((0, _runIndexAt["default"])(n), R.prop('runs'))(string);
};
var _default = R.curryN(2, runIndexAt);
exports["default"] = _default;

},{"ee17cba7d7816b65":"kZ6eK","d05fea9e06de01":"fiRIh","57bf6351400a1a7c":"lzfqX","8ddf7099e2246b59":"lCX8c"}],"lkmD6":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3054a9ddafc937d0");
var _interopRequireWildcard = require("8801f60069c44c7d");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("10aa83f5c604f1ad"));
var _reduce = _interopRequireDefault(require("a382ddc12f444d21"));
var _height = _interopRequireDefault(require("d711e969a3e5dbd4"));
/**
 * Returns attributed string height
 *
 * @param {Object} attributed string
 * @return {number} height
 */ var height = (0, _reduce["default"])(R.max, _height["default"]);
var _default = height;
exports["default"] = _default;

},{"3054a9ddafc937d0":"kZ6eK","8801f60069c44c7d":"fiRIh","10aa83f5c604f1ad":"lzfqX","a382ddc12f444d21":"aagkU","d711e969a3e5dbd4":"1UdtL"}],"bwgzK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a63e0b46c82058e6");
var _interopRequireWildcard = require("976917eef8b03519");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("f76affd21d68ba89"));
var _length = _interopRequireDefault(require("7a4e597bf405ecb0"));
var _advanceWidth = _interopRequireDefault(require("9bd4e9883f380ecd"));
var _indexAtOffset = _interopRequireDefault(require("1aa5c234568df11d"));
/**
 * Get string index at offset
 *
 * @param  {Object}  attributed string
 * @param  {number}  offset
 * @return {number} string index at offset N
 */ var indexAtOffset = function indexAtOffset(offset, string) {
    var index = 0;
    var counter = 0;
    var runs = R.propOr([], 'runs', string);
    for(var _iterator = runs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var run = _ref;
        var advanceWidth = (0, _advanceWidth["default"])(run);
        if (counter + advanceWidth > offset) return index + (0, _indexAtOffset["default"])(offset - counter, run);
        counter += advanceWidth;
        index += (0, _length["default"])(run);
    }
    return index;
};
var _default = R.curryN(2, indexAtOffset);
exports["default"] = _default;

},{"a63e0b46c82058e6":"kZ6eK","976917eef8b03519":"fiRIh","f76affd21d68ba89":"lzfqX","7a4e597bf405ecb0":"7EFEx","9bd4e9883f380ecd":"1J9lT","1aa5c234568df11d":"3PNMY"}],"7EFEx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("254261c1f92e4b24");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("e7089a674a6f61d3"));
/**
 * Get run length
 *
 * @param  {Object}  run
 * @return {number} length
 */ var length = R.converge(R.subtract, [
    R.prop('end'),
    R.prop('start')
]);
var _default = length;
exports["default"] = _default;

},{"254261c1f92e4b24":"fiRIh","e7089a674a6f61d3":"lzfqX"}],"3PNMY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("66576ea5cc7ddc94");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("c901cf41f5ed5d55"));
/**
 * Get string index at offset
 *
 * @param  {Object}  run
 * @param  {number}  offset
 * @return {number} string index at offset N
 */ var indexAtOffset = function indexAtOffset(offset, run) {
    var counter = 0;
    var index = 0;
    var glyphs = R.propOr([], 'glyphs', run);
    var positions = R.propOr([], 'positions', run);
    for(var i = 0; i < positions.length; i++){
        var xAdvance = positions[i].xAdvance;
        if (counter + xAdvance > offset) return index;
        counter += xAdvance;
        index += R.pathOr(0, [
            i,
            'codePoints',
            'length'
        ], glyphs);
    }
    return index;
};
var _default = R.curryN(2, indexAtOffset);
exports["default"] = _default;

},{"66576ea5cc7ddc94":"fiRIh","c901cf41f5ed5d55":"lzfqX"}],"37qVT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c16f701e89b16019");
var _interopRequireWildcard = require("da1eb6911eb8dd");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("b1925214f3d932c8"));
var _append = _interopRequireDefault(require("49bd976e28c02181"));
var _copy = _interopRequireDefault(require("21a0fcb98167492f"));
var _insert = _interopRequireDefault(require("1324fcd0f44585a3"));
var _runIndexAt = _interopRequireDefault(require("6d6b87710c1d5c24"));
var _stringFromCodePoints = _interopRequireDefault(require("c4b43efe120f30be"));
var mapCond = function mapCond(conds) {
    return R.addIndex(R.map)(R.cond(conds));
};
var idxEquals = function idxEquals(idx) {
    return R.compose(R.equals(idx), R.nthArg(1));
};
var idxGt = function idxGt(idx) {
    return R.compose(R.gt(R.__, idx), R.nthArg(1));
};
/**
 * Insert glyph into attributed string
 *
 * @param {number} index
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var insertGlyph = function insertGlyph(index, glyph, string) {
    var runIndex = (0, _runIndexAt["default"])(index, string); // Add glyph to the end if run index invalid
    if (runIndex === -1) return (0, _append["default"])(glyph, string);
    var codePoints = R.propOr([], 'codePoints')(glyph);
    var incRange = R.add(R.length(codePoints));
    return R.evolve({
        string: R.compose(R.join(''), R.insert(index, (0, _stringFromCodePoints["default"])(codePoints))),
        runs: mapCond([
            [
                idxEquals(runIndex),
                function(run) {
                    return (0, _insert["default"])(index - run.start, glyph, run);
                }
            ],
            [
                idxGt(runIndex),
                R.evolve({
                    start: incRange,
                    end: incRange
                })
            ],
            [
                R.T,
                _copy["default"]
            ]
        ])
    })(string);
};
var _default = R.curryN(3, insertGlyph);
exports["default"] = _default;

},{"c16f701e89b16019":"kZ6eK","da1eb6911eb8dd":"fiRIh","b1925214f3d932c8":"lzfqX","49bd976e28c02181":"677Va","21a0fcb98167492f":"diPRw","1324fcd0f44585a3":"aYLGq","6d6b87710c1d5c24":"8oz6U","c4b43efe120f30be":"ev4bJ"}],"aYLGq":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a511ba120b7a7a5");
var _interopRequireWildcard = require("c55ef8446f62ee3f");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("6f5aa08cb624c314"));
var _copy = _interopRequireDefault(require("80df2581f2f61f99"));
var _slice = _interopRequireDefault(require("69f7186978a4f995"));
var _concat = _interopRequireDefault(require("bc1c13c12adf5e3"));
var _append = _interopRequireDefault(require("102b01dd4d9ff51c"));
var _getFont = _interopRequireDefault(require("63c436ab261d319d"));
var _isNumber = _interopRequireDefault(require("cbbda08a0cb4a237"));
var _fromCodePoint = _interopRequireDefault(require("acb354671547613f"));
/**
 * Insert glyph to run in the given index
 *
 * @param  {number}  string index
 * @param  {Object}  glyph
 * @param  {Object}  run
 * @return {Object}  run with glyph
 */ var insertGlyph = function insertGlyph(index, glyph, run) {
    if (!glyph) return (0, _copy["default"])(run); // Split resolves ligature splitting in case new glyph breaks some
    var leadingRun = (0, _slice["default"])(0, index, run);
    var trailingRun = (0, _slice["default"])(index, Infinity, run);
    return (0, _concat["default"])((0, _append["default"])(glyph, leadingRun), trailingRun);
};
/**
 * Insert either glyph or code point to run in the given index
 *
 * @param  {number}  string index
 * @param  {Object | number}  glyph | codePoint
 * @param  {Object}  run
 * @return {Object}  run with glyph
 */ var insert = function insert(index, value, run) {
    var font = (0, _getFont["default"])(run);
    var glyph = (0, _isNumber["default"])(value) ? (0, _fromCodePoint["default"])(value, font) : value;
    return insertGlyph(index, glyph, run);
};
var _default = R.curryN(3, insert);
exports["default"] = _default;

},{"a511ba120b7a7a5":"kZ6eK","c55ef8446f62ee3f":"fiRIh","6f5aa08cb624c314":"lzfqX","80df2581f2f61f99":"diPRw","69f7186978a4f995":"02clA","bc1c13c12adf5e3":"hZSlL","102b01dd4d9ff51c":"9bLgy","63c436ab261d319d":"jqjVQ","cbbda08a0cb4a237":"ilX8l","acb354671547613f":"3ghfj"}],"hZSlL":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c6a3651ef43c00ab");
var _interopRequireWildcard = require("5855086de0d9488b");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("b76431894f144e75"));
var _length = _interopRequireDefault(require("f9d04e4549af08c5"));
var _normalize = _interopRequireDefault(require("6e55e9dd9595129e"));
var reverseMerge = R.flip(R.merge);
var reverseConcat = R.flip(R.concat);
/**
 * Concats two runs into one
 *
 * @param  {Object}  first run
 * @param  {Object}  second run
 * @return {Object}  concatenated run
 */ var concat = function concat(runA, runB) {
    return R.evolve({
        end: R.add((0, _length["default"])(runB)),
        glyphs: reverseConcat(R.prop('glyphs', runB)),
        positions: reverseConcat(R.prop('positions', runB)),
        attributes: reverseMerge(R.prop('attributes', runB)),
        glyphIndices: R.compose(_normalize["default"], reverseConcat(R.map(R.compose(R.inc, R.add(R.last(R.propOr([], 'glyphIndices', runA)) || 0)), R.propOr([], 'glyphIndices', runB))))
    })(runA);
};
var _default = R.curryN(2, concat);
exports["default"] = _default;

},{"c6a3651ef43c00ab":"kZ6eK","5855086de0d9488b":"fiRIh","b76431894f144e75":"lzfqX","f9d04e4549af08c5":"7EFEx","6e55e9dd9595129e":"6DHLv"}],"lB4Yp":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ba240b073658dca8");
var _interopRequireWildcard = require("7979db6ed8dc97de");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("f545704572fa6743"));
var _leadingOffset = _interopRequireDefault(require("2d7197fd65fabd28"));
/**
 * Get attributed string leading white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} leading white space offset
 */ var leadingOffset = R.compose(_leadingOffset["default"], R.head, R.propOr([], 'runs'));
var _default = leadingOffset;
exports["default"] = _default;

},{"ba240b073658dca8":"kZ6eK","7979db6ed8dc97de":"fiRIh","f545704572fa6743":"lzfqX","2d7197fd65fabd28":"4sqYS"}],"4sqYS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ea5c9ac60d4a860a");
var _interopRequireWildcard = require("2d4033b866760789");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("f1302a628e2b4bbf"));
var _isWhiteSpace = _interopRequireDefault(require("8bc9bbda91325078"));
/**
 * Get white space leading positions
 *
 * @param  {Object}  run
 * @return {Array} white space leading positions
 */ var leadingPositions = R.converge(R.slice(0), [
    R.compose(R.length, R.takeWhile(_isWhiteSpace["default"]), R.propOr([], 'glyphs')),
    R.propOr([], 'positions')
]);
/**
 * Get run leading white space offset
 *
 * @param  {Object}  run
 * @return {number} leading white space offset
 */ var leadingOffset = R.compose(R.ifElse(R.isEmpty, R.always(0), R.compose(R.sum, R.map(R.propOr(0, 'xAdvance')))), leadingPositions);
var _default = leadingOffset;
exports["default"] = _default;

},{"ea5c9ac60d4a860a":"kZ6eK","2d4033b866760789":"fiRIh","f1302a628e2b4bbf":"lzfqX","8bc9bbda91325078":"9lW3u"}],"9lW3u":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("5f1b4126eb99acb1");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("d3e7b69b4448f7e3"));
var WHITE_SPACES_CODES = [
    32
];
/**
 * Check if glyph is white space
 *
 * @param  {Object}  glyph
 * @return {Boolean}  is white space
 * */ var isWhiteSpace = R.compose(R.not, R.isEmpty, R.intersection(WHITE_SPACES_CODES), R.propOr([], 'codePoints'));
var _default = isWhiteSpace;
exports["default"] = _default;

},{"5f1b4126eb99acb1":"fiRIh","d3e7b69b4448f7e3":"lzfqX"}],"fi9n8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("754ceab03af50a85");
var _interopRequireWildcard = require("fdcd24c55eca7087");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("3f4587b0fb55d0d9"));
var _start = _interopRequireDefault(require("ae8f53c4e977baa5"));
var _end = _interopRequireDefault(require("ca8ac31c9492537d"));
/**
 * Get attributed string length
 *
 * @param  {Object}  glyph string
 * @return {number} end
 */ var length = R.converge(R.subtract, [
    _end["default"],
    _start["default"]
]);
var _default = length;
exports["default"] = _default;

},{"754ceab03af50a85":"kZ6eK","fdcd24c55eca7087":"fiRIh","3f4587b0fb55d0d9":"lzfqX","ae8f53c4e977baa5":"hFLv7","ca8ac31c9492537d":"3Iz3s"}],"hFLv7":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("7c5002f0e1ac67d9");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("4dd2e455166e51c6"));
/**
 * Get attributed string start value
 *
 * @param  {Object}  glyph string
 * @return {number} start
 */ var start = R.ifElse(R.pathEq([
    'runs',
    'length'
], 0), R.always(0), R.path([
    'runs',
    0,
    'start'
]));
var _default = start;
exports["default"] = _default;

},{"7c5002f0e1ac67d9":"fiRIh","4dd2e455166e51c6":"lzfqX"}],"2doIT":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("9bf22fbec5a107ea");
var _interopRequireWildcard = require("8eb6a0ed4ddf273b");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("e69d4c094f8eb341"));
var _add = _interopRequireDefault(require("898944e41eaed0fb"));
var _empty = _interopRequireDefault(require("c7b78993d3aca6ff"));
var _prepend = _interopRequireDefault(require("37fefd2e9df958e2"));
var _stringFromCodePoints = _interopRequireDefault(require("cf23d53fda820fc8"));
/**
 * prepend glyph into last run of attributed string
 *
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */ var prepend = function prepend(glyph, string) {
    var codePoints = R.propOr([], 'codePoints')(glyph);
    return R.evolve({
        string: R.concat((0, _stringFromCodePoints["default"])(codePoints)),
        runs: R.converge(R.concat, [
            R.compose(R.unapply(R.identity), (0, _prepend["default"])(glyph), R.either(R.head, _empty["default"])),
            R.compose(R.map((0, _add["default"])(codePoints.length)), R.tail)
        ])
    })(string);
};
var _default = R.curryN(2, prepend);
exports["default"] = _default;

},{"9bf22fbec5a107ea":"kZ6eK","8eb6a0ed4ddf273b":"fiRIh","e69d4c094f8eb341":"lzfqX","898944e41eaed0fb":"39IaK","c7b78993d3aca6ff":"ah8au","37fefd2e9df958e2":"lVXz2","cf23d53fda820fc8":"ev4bJ"}],"39IaK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3a35cbcb78220a57");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("85d7ae56e3059cde"));
/**
 * Add scalar to run
 *
 * @param  {number}  scalar
 * @param  {Object}  run
 * @return {Object} added run
 */ var add = function add(n, run) {
    return R.evolve({
        start: R.add(n),
        end: R.add(n)
    })(run);
};
var _default = R.curryN(2, add);
exports["default"] = _default;

},{"3a35cbcb78220a57":"fiRIh","85d7ae56e3059cde":"lzfqX"}],"lVXz2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("8d563d01d3345dd0");
var _interopRequireWildcard = require("71a32993f0ca2d7");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("226881aa8436874a"));
var _copy = _interopRequireDefault(require("9c4f339e56c7f24d"));
var _scale = _interopRequireDefault(require("ee21b74c42162e27"));
var _getFont = _interopRequireDefault(require("502510ac2015396b"));
var _isNumber = _interopRequireDefault(require("2f1861aea6195548"));
var _prepend = _interopRequireDefault(require("539480afef77e90e"));
var _fromCodePoint = _interopRequireDefault(require("5d4e64e4eacec933"));
/**
 * Prepend glyph to run
 *
 * @param  {Object}  glyph
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var prependGlyph = function prependGlyph(glyph, run) {
    var runScale = (0, _scale["default"])(run);
    var glyphLength = R.length(glyph.codePoints);
    return R.evolve({
        end: R.add(glyphLength),
        glyphIndices: (0, _prepend["default"])(glyphLength),
        glyphs: R.prepend(glyph),
        positions: R.prepend({
            xAdvance: glyph.advanceWidth * runScale
        })
    })(run);
};
/**
 * Prepend glyph or code point on run
 *
 * @param  {Object | number}  glyph | codePoint
 * @param  {Object}  run
 * @return {Object} run with glyph
 */ var prepend = function prepend(value, run) {
    if (!value) return (0, _copy["default"])(run);
    var font = (0, _getFont["default"])(run);
    var glyph = (0, _isNumber["default"])(value) ? (0, _fromCodePoint["default"])(value, font) : value;
    return prependGlyph(glyph, run);
};
var _default = R.curryN(2, prepend);
exports["default"] = _default;

},{"8d563d01d3345dd0":"kZ6eK","71a32993f0ca2d7":"fiRIh","226881aa8436874a":"lzfqX","9c4f339e56c7f24d":"diPRw","ee21b74c42162e27":"eOG6x","502510ac2015396b":"jqjVQ","2f1861aea6195548":"ilX8l","539480afef77e90e":"6B8sh","5d4e64e4eacec933":"3ghfj"}],"6B8sh":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e2bbb02bc75906e5");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("99d750825214bba0"));
/**
 * Prepend glyph indices with given length
 *
 * Ex. prepend(3, [0, 1, 2, 2]) => [0, 0, 0, 1, 2, 3, 3]
 *
 * @param  {number}  length
 * @param  {Array}  glyph indices
 * @return {Array}  extended glyph indices
 */ var prepend = function prepend(length, indices) {
    if (length === 0) return indices;
    return R.converge(R.concat, [
        R.converge(R.repeat, [
            R.always(0),
            R.always(length)
        ]),
        R.map(R.inc)
    ])(indices);
};
var _default = R.curryN(2, prepend);
exports["default"] = _default;

},{"e2bbb02bc75906e5":"fiRIh","99d750825214bba0":"lzfqX"}],"eSCNP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("63827fe0fa606276");
var _interopRequireWildcard = require("c6d61070693f57df");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("2c8ac5b6e9e448a7"));
var _slice = _interopRequireDefault(require("9bd89045d6befc8a"));
var _filter = _interopRequireDefault(require("a4b3391ea4abd85"));
var _subtract = _interopRequireDefault(require("f2e529537ca52ef2"));
var _mapIndexed = _interopRequireDefault(require("99cd5c0fbedf8f60"));
/**
 * Slice array of runs
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Array}  runs
 * @return {Array} sliced runs
 */ var sliceRuns = function sliceRuns(start, end) {
    return function(runs) {
        var firstRun = function firstRun(a) {
            return (0, _slice["default"])(start - a.start, end - a.start, a);
        };
        var lastRun = function lastRun(a) {
            return (0, _slice["default"])(0, end - a.start, a);
        };
        var intermediateRun = R.identity;
        var res = (0, _mapIndexed["default"])([
            R.o((0, _subtract["default"])(start), firstRun),
            R.o((0, _subtract["default"])(start), intermediateRun),
            R.o((0, _subtract["default"])(start), lastRun) // Slice last run
        ])(runs);
        return res;
    };
};
/**
 * Slice attributed string between two indices
 *
 * @param  {number}  start offset
 * @param  {number}  end offset
 * @param  {Object}  attributedString
 * @return {Object} attributedString
 */ var slice = function slice(start, end, string) {
    return R.ifElse(R.pathEq([
        'string',
        'length'
    ], 0), R.identity, R.evolve({
        string: R.slice(start, end),
        runs: R.compose(sliceRuns(start, end), (0, _filter["default"])(start, end))
    }))(string);
};
var _default = R.curryN(3, slice);
exports["default"] = _default;

},{"63827fe0fa606276":"kZ6eK","c6d61070693f57df":"fiRIh","2c8ac5b6e9e448a7":"lzfqX","9bd89045d6befc8a":"02clA","a4b3391ea4abd85":"lYk4C","f2e529537ca52ef2":"egWEZ","99cd5c0fbedf8f60":"cJRkP"}],"egWEZ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("43f97c34b3cf2831");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("ed884a4948b5bf16"));
/**
 * Subtract scalar to run
 *
 * @param  {number}  scalar
 * @param  {Object}  run
 * @return {Object} subtracted run
 */ var subtract = function subtract(n, run) {
    return R.evolve({
        start: R.subtract(R.__, n),
        end: R.subtract(R.__, n)
    })(run);
};
var _default = R.curryN(2, subtract);
exports["default"] = _default;

},{"43f97c34b3cf2831":"fiRIh","ed884a4948b5bf16":"lzfqX"}],"cJRkP":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e973c7537801ceb");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("54516bcd70fb7ece"));
/**
 * Map list by index
 * Accepts up to 3 functions:
 *   - Will apply first function to first value
 *   - Will apply last function to last value
 *   - Will apply the other function to the rest of values
 *
 * @param  {Array}  list
 * @param  {Array}  functions
 * @return {Array} mapped array
 */ var mapIndexed = function mapIndexed(fns, list) {
    if (fns === void 0) fns = [];
    if (list === void 0) list = [];
    var length = list.length - 1;
    return R.addIndex(R.map)(function(value, idx) {
        if (idx === 0) return R.head(fns)(value, idx);
        if (idx === length) return R.last(fns)(value, idx);
        return (fns[1] || fns[0])(value, idx);
    })(list);
};
var _default = R.curryN(2, mapIndexed);
exports["default"] = _default;

},{"e973c7537801ceb":"fiRIh","54516bcd70fb7ece":"lzfqX"}],"3PBI3":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d52567b35a86fcc7");
var _interopRequireWildcard = require("9e71432c267c7d60");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("cb16e596115f5606"));
var _slice = _interopRequireDefault(require("99ac5e0a4dc870ef"));
var _indexAtOffset = _interopRequireDefault(require("21fe09861626e0e6"));
/**
 * Slice attributed string at given offset
 *
 * @param  {number}  offset
 * @param  {Object}  attributedString
 * @return {Object} attributedString
 */ var sliceAtOffset = function sliceAtOffset(offset, string) {
    var index = (0, _indexAtOffset["default"])(offset, string);
    return (0, _slice["default"])(0, index, string);
};
var _default = R.curryN(2, sliceAtOffset);
exports["default"] = _default;

},{"d52567b35a86fcc7":"kZ6eK","9e71432c267c7d60":"fiRIh","cb16e596115f5606":"lzfqX","99ac5e0a4dc870ef":"eSCNP","21fe09861626e0e6":"bwgzK"}],"fo2bo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7e6b9bd3135b9484");
var _interopRequireWildcard = require("b68f98c14ab55871");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("beaa6a13dc26cc87"));
var _trailingOffset = _interopRequireDefault(require("9e588e61b2a20eef"));
/**
 * Get attributed string trailing white space offset
 *
 * @param  {Object}  attributed string
 * @return {number} trailing white space offset
 */ var trailingOffset = R.compose(_trailingOffset["default"], R.last, R.propOr([], 'runs'));
var _default = trailingOffset;
exports["default"] = _default;

},{"7e6b9bd3135b9484":"kZ6eK","b68f98c14ab55871":"fiRIh","beaa6a13dc26cc87":"lzfqX","9e588e61b2a20eef":"pRbcC"}],"pRbcC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cd15f3c26b8aa149");
var _interopRequireWildcard = require("aab5e111b8de8689");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("f80f6753872a4a05"));
var _isWhiteSpace = _interopRequireDefault(require("52dbffc46c0a7998"));
/**
 * Get white space trailing positions
 *
 * @param  {Object}  run
 * @return {Array} white space trailing positions
 */ var trailingPositions = R.converge(R.slice(0), [
    R.compose(R.length, R.takeWhile(_isWhiteSpace["default"]), R.reverse, R.propOr([], 'glyphs')),
    R.compose(R.reverse, R.propOr([], 'positions'))
]);
/**
 * Get run trailing white space offset
 *
 * @param  {Object}  run
 * @return {number} trailing white space offset
 */ var trailingOffset = R.compose(R.ifElse(R.isEmpty, R.always(0), R.compose(R.sum, R.map(R.propOr(0, 'xAdvance')))), trailingPositions);
var _default = trailingOffset;
exports["default"] = _default;

},{"cd15f3c26b8aa149":"kZ6eK","aab5e111b8de8689":"fiRIh","f80f6753872a4a05":"lzfqX","52dbffc46c0a7998":"9lW3u"}],"dyq8z":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("64ad9a016b652612");
var _interopRequireWildcard = require("cd6682aa5c588bd9");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("f6584e506d1e5393"));
var _slice = _interopRequireDefault(require("d07b07ca990159f5"));
var testChar = R.test(/\S/g);
var findCharIndex = R.findIndex(testChar);
var findLastCharIndex = R.o(R.inc, R.findLastIndex(testChar));
/**
 * Removes (strips) whitespace from both ends of the attributted string.
 *
 * @param  {Object}  attributedString
 * @return {Object} attributedString
 */ var trim = R.chain(R.apply(_slice["default"]), R.compose(R.juxt([
    findCharIndex,
    findLastCharIndex
]), R.prop('string')));
var _default = trim;
exports["default"] = _default;

},{"64ad9a016b652612":"kZ6eK","cd6682aa5c588bd9":"fiRIh","f6584e506d1e5393":"lzfqX","d07b07ca990159f5":"eSCNP"}],"law2T":[function(require,module,exports,__globalThis) {
/**
 * Expose `isUrl`.
 */ module.exports = isUrl;
/**
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */ var protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
var nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
/**
 * Loosely validate a URL `string`.
 *
 * @param {String} string
 * @return {Boolean}
 */ function isUrl(string) {
    if (typeof string !== 'string') return false;
    var match = string.match(protocolAndDomainRE);
    if (!match) return false;
    var everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) return false;
    if (localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol)) return true;
    return false;
}

},{}],"elqs3":[function(require,module,exports,__globalThis) {
// Save global object in a variable
var global = arguments[3];
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof global !== 'undefined' && global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof global !== 'undefined' && global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

},{}],"crpPy":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e447e2dd327c2091");
var _interopRequireWildcard = require("88781ef1be931db8");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("69af305bf05c68de"));
var _wrapWords = _interopRequireDefault(require("958686dd6962e6e5"));
var _typesetter = _interopRequireDefault(require("93592b839429153a"));
var _generateGlyphs = _interopRequireDefault(require("73b45b9c413f8402"));
var _resolveYOffset = _interopRequireDefault(require("396cbe59f78500ab"));
var _preprocessRuns = _interopRequireDefault(require("5409a99f9ed1ce15"));
var _splitParagraphs = _interopRequireDefault(require("4459192dcb89e4e3"));
var _finalizeFragments = _interopRequireDefault(require("d390c461605ab31e"));
var _resolveAttachments = _interopRequireDefault(require("476ce4839e819802"));
var _applyDefaultStyles = _interopRequireDefault(require("ab4a04c1f722658"));
/**
 * A LayoutEngine is the main object that performs text layout.
 * It accepts an AttributedString and a Container object
 * to layout text into, and uses several helper objects to perform
 * various layout tasks. These objects can be overridden to customize
 * layout behavior.
 *
 * @param  {Object}  engines
 * @param  {Object}  attributted string
 * @param  {Object}  container rect
 * @param  {Object}  layout options
 * @return {Array} paragraph blocks
 */ var layoutEngine = function layoutEngine(engines, attributedString, container, options) {
    if (options === void 0) options = {};
    var processParagraphs = R.compose((0, _resolveYOffset["default"])(engines, options), (0, _resolveAttachments["default"])(engines, options), (0, _generateGlyphs["default"])(engines, options), (0, _wrapWords["default"])(engines, options));
    return R.compose((0, _finalizeFragments["default"])(engines, options), (0, _typesetter["default"])(engines, options, container), R.map(processParagraphs), (0, _splitParagraphs["default"])(engines, options), (0, _preprocessRuns["default"])(engines, options), (0, _applyDefaultStyles["default"])(engines, options))(attributedString);
};
var _default = R.curryN(3, layoutEngine);
exports["default"] = _default;

},{"e447e2dd327c2091":"kZ6eK","88781ef1be931db8":"fiRIh","69af305bf05c68de":"lzfqX","958686dd6962e6e5":"bZBgS","93592b839429153a":"gKTXb","73b45b9c413f8402":"gKxEd","396cbe59f78500ab":"cX1aN","5409a99f9ed1ce15":"g8ivh","4459192dcb89e4e3":"2zXXs","d390c461605ab31e":"7owwy","476ce4839e819802":"ltAii","ab4a04c1f722658":"6Gr6x"}],"bZBgS":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("2bcb11006bdb038d");
var _interopRequireDefault = require("6bac8bcb3d4446f9");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("f24f7364083b5092"));
var R = _interopRequireWildcard(require("1947645eb367b8ec"));
var _fromFragments = _interopRequireDefault(require("e80220d302401c8a"));
/**
 * Default word hyphenation engine used when no one provided.
 * Does not perform word hyphenation at all
 *
 * @param  {String} word
 * @return {Array} same word
 */ var defaultHyphenationEngine = function defaultHyphenationEngine(word) {
    return [
        word
    ];
};
/**
 * Wrap words of attribute string
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string including syllables
 */ var wrapWords = function wrapWords(engines, options, attributedString) {
    if (engines === void 0) engines = {};
    if (options === void 0) options = {};
    var syllables = [];
    var fragments = [];
    var hyphenateWord = options.hyphenationCallback || engines.wordHyphenation && engines.wordHyphenation(options) || defaultHyphenationEngine;
    for(var _iterator = attributedString.runs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var run = _ref;
        var string = '';
        var words = attributedString.string.slice(run.start, run.end).split(/([ ]+)/g).filter(Boolean);
        for(var _iterator2 = words, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var word = _ref2;
            var parts = hyphenateWord(word);
            syllables.push.apply(syllables, parts);
            string += parts.join('');
        }
        fragments.push({
            string: string,
            attributes: run.attributes
        });
    }
    return (0, _extends2["default"])({}, (0, _fromFragments["default"])(fragments), {
        syllables: syllables
    });
};
var _default = R.curryN(3, wrapWords);
exports["default"] = _default;

},{"2bcb11006bdb038d":"fiRIh","6bac8bcb3d4446f9":"kZ6eK","f24f7364083b5092":"ktcBy","1947645eb367b8ec":"lzfqX","e80220d302401c8a":"dpl7E"}],"gKTXb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("327db17cb12f5f3a");
var _interopRequireWildcard = require("c49250ff0b681f08");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("a6eb377121f68b7f"));
var _copy = _interopRequireDefault(require("af93724f15b98074"));
var _crop = _interopRequireDefault(require("9ba15b78cd0d3101"));
var _slice = _interopRequireDefault(require("1fee5cfd5efb7100"));
var _height = _interopRequireDefault(require("95fc08ef80a7dbd7"));
var _truncate = _interopRequireDefault(require("f707f690260301ad"));
var _layoutParagraph = _interopRequireDefault(require("3d0e1e75465d3cec"));
var _sliceAtHeight = _interopRequireDefault(require("58ed3ec1c8a0e278"));
/**
 * Layout paragraphs inside container until it does not
 * fit anymore, performing line wrapping in the process.
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  container rect
 * @param  {Object}  attributed strings (paragraphs)
 * @return {Array} paragraph blocks
 */ var typesetter = function typesetter(engines, options, container, attributedStrings) {
    var blocks = [];
    var paragraphs = [].concat(attributedStrings);
    var maxLines = R.propOr(Infinity, 'maxLines', container);
    var truncateEllipsis = container.truncateMode === 'ellipsis';
    var linesCount = maxLines;
    var paragraphRect = (0, _copy["default"])(container);
    var nextParagraph = paragraphs.shift();
    while(linesCount > 0 && nextParagraph){
        var block = (0, _layoutParagraph["default"])(engines, options)(paragraphRect, nextParagraph);
        var slicedBlock = (0, _slice["default"])(linesCount, block);
        var linesHeight = (0, _height["default"])(slicedBlock);
        var shouldTruncate = truncateEllipsis && block.length !== slicedBlock.length;
        linesCount -= slicedBlock.length;
        if (paragraphRect.height >= linesHeight) {
            blocks.push(R.when(R.always(shouldTruncate), _truncate["default"])(slicedBlock));
            paragraphRect = (0, _crop["default"])(linesHeight, paragraphRect);
            nextParagraph = paragraphs.shift();
        } else {
            blocks.push(R.compose(_truncate["default"], (0, _sliceAtHeight["default"])(paragraphRect.height))(slicedBlock));
            break;
        }
    }
    return blocks;
};
var _default = R.curryN(4, typesetter);
exports["default"] = _default;

},{"327db17cb12f5f3a":"kZ6eK","c49250ff0b681f08":"fiRIh","a6eb377121f68b7f":"lzfqX","af93724f15b98074":"htuWb","9ba15b78cd0d3101":"bqYkz","1fee5cfd5efb7100":"68Ly1","95fc08ef80a7dbd7":"dnpwx","f707f690260301ad":"99HH9","3d0e1e75465d3cec":"ao3Oo","58ed3ec1c8a0e278":"fS0jA"}],"htuWb":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("2e1dda619e6283b8");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("cc7add31c9709f49"));
/**
 * Clone rect
 *
 * @param  {Object}  rect
 * @return {Object} cloned rect
 */ var copy = R.clone;
var _default = copy;
exports["default"] = _default;

},{"2e1dda619e6283b8":"fiRIh","cc7add31c9709f49":"lzfqX"}],"bqYkz":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("70ec34760fbb9be9");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("3ba9d218ecdc14ea"));
/**
 * Crop upper section of rect
 *
 * @param  {Object}  rect
 * @return {Object} cropped rect
 */ var crop = function crop(height, rect) {
    return R.evolve({
        y: R.add(height),
        height: R.subtract(R.__, height)
    })(rect);
};
var _default = R.curryN(2, crop);
exports["default"] = _default;

},{"70ec34760fbb9be9":"fiRIh","3ba9d218ecdc14ea":"lzfqX"}],"68Ly1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e50eadf60af4ce16");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("ded5dbcee2e7c52e"));
/**
 * Slice block lines
 *
 * @param  {number}  lines quantity
 * @param  {Object}  paragraph block
 * @return {Object} sliced paragraph block
 */ var sliceBlock = function sliceBlock(lines, block) {
    return R.slice(0, lines, block);
};
var _default = sliceBlock;
exports["default"] = _default;

},{"e50eadf60af4ce16":"fiRIh","ded5dbcee2e7c52e":"lzfqX"}],"dnpwx":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("e8f8d9b467268904");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("ebe19c3e205d2543"));
/**
 * Get paragrpah block height
 *
 * @param  {Object}  paragraph block
 * @return {number} paragraph block height
 */ var height = R.compose(R.sum, R.map(R.prop('height')), R.pluck('box'));
var _default = height;
exports["default"] = _default;

},{"e8f8d9b467268904":"fiRIh","ebe19c3e205d2543":"lzfqX"}],"99HH9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("6816008ec1a28663");
var _interopRequireWildcard = require("b5e74bda52746957");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("4df70721861973c4"));
var _append = _interopRequireDefault(require("bee815831ba879c2"));
var _trim = _interopRequireDefault(require("d384607fe602afee"));
/**
 * Trucante block with ellipsis
 *
 * @param  {number}  lines quantity
 * @param  {Object}  paragraph block
 * @return {Object} sliced paragraph block
 */ var truncate = function truncate(block) {
    var runs = R.propOr([], 'runs', R.last(block));
    var font = R.path([
        'attributes',
        'font'
    ], R.last(runs));
    if (font) return R.adjust(-1, R.compose((0, _append["default"])(font.glyphForCodePoint(8230)), _trim["default"]))(block);
    return block;
};
var _default = truncate;
exports["default"] = _default;

},{"6816008ec1a28663":"kZ6eK","b5e74bda52746957":"fiRIh","4df70721861973c4":"lzfqX","bee815831ba879c2":"677Va","d384607fe602afee":"dyq8z"}],"ao3Oo":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("96715f4ccdd94d39");
var _interopRequireWildcard = require("8e18a8ca3d78a4b7");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("70b12dfc2e80a1a5"));
var _omit = _interopRequireDefault(require("ccf4323991ad8c35"));
var _height = _interopRequireDefault(require("37ddab1b1e7701dc"));
var ATTACHMENT_CODE = "\uFFFC"; // 65532
/**
 * Remove attachment attribute if no char present
 *
 * @param  {Object} attributed string
 * @return {Object} attributed string
 */ var purgeAttachments = R.when(R.compose(R.not, R.includes(ATTACHMENT_CODE), R.prop('string')), R.evolve({
    runs: R.map((0, _omit["default"])('attachment'))
}));
/**
 * Layout paragraphs inside rectangle
 *
 * @param  {Object} rect
 * @param  {Array} attributed strings
 * @return {Object} layout blocks
 */ var layoutLines = function layoutLines(rect, lines, indent) {
    var currentY = rect.y;
    return R.addIndex(R.map)(R.compose(purgeAttachments, function(line, i) {
        var lineIndent = i === 0 ? indent : 0;
        var style = R.pathOr({}, [
            'runs',
            0,
            'attributes'
        ], line);
        var height = Math.max((0, _height["default"])(line), style.lineHeight);
        var box = {
            x: rect.x + lineIndent,
            y: currentY,
            width: rect.width - lineIndent,
            height: height
        };
        currentY += height;
        return R.compose(R.assoc('box', box), R.omit([
            'syllables'
        ]))(line);
    }))(lines);
};
/**
 * Performs line breaking and layout
 *
 * @param  {Object} engines
 * @param  {Object}  layout options
 * @param  {Object} rect
 * @param  {Object} attributed string
 * @return {Object} layout block
 */ var layoutParagraph = function layoutParagraph(engines, options) {
    return function(rect, paragraph) {
        var indent = R.pathOr(0, [
            'runs',
            0,
            'attributes',
            'indent'
        ], paragraph);
        var lines = engines.linebreaker(options)(paragraph, [
            rect.width - indent,
            rect.width
        ]);
        var lineFragments = layoutLines(rect, lines, indent);
        return lineFragments;
    };
};
var _default = layoutParagraph;
exports["default"] = _default;

},{"96715f4ccdd94d39":"kZ6eK","8e18a8ca3d78a4b7":"fiRIh","70b12dfc2e80a1a5":"lzfqX","ccf4323991ad8c35":"gGsCX","37ddab1b1e7701dc":"lkmD6"}],"gGsCX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3058f042f1b7af9c");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("f6464729a6384101"));
/**
 * Omit attribute from run
 *
 * @param  {Object}  run
 * @return {Object} run without ommited attribute
 */ var omit = function omit(value, run) {
    return R.evolve({
        attributes: R.dissoc(value)
    })(run);
};
var _default = R.curryN(2, omit);
exports["default"] = _default;

},{"3058f042f1b7af9c":"fiRIh","f6464729a6384101":"lzfqX"}],"fS0jA":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports["default"] = void 0;
/**
 * Slice block at given height
 *
 * @param  {number}  height
 * @param  {Object}  paragraph block
 * @return {number} sliced paragraph block
 */ var sliceAtHeight = function sliceAtHeight(height) {
    return function(block) {
        var newBlock = [];
        var counter = 0;
        for(var _iterator = block, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var line = _ref;
            counter += line.box.height;
            if (counter < height) newBlock.push(line);
            else break;
        }
        return newBlock;
    };
};
var _default = sliceAtHeight;
exports["default"] = _default;

},{}],"gKxEd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("21560257cab3578f");
var _interopRequireDefault = require("35e9e0fbec46f276");
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("de7d810d0622c173"));
var R = _interopRequireWildcard(require("f372d77355e30026"));
var _scale = _interopRequireDefault(require("a37f65147f2d281a"));
var _resolve = _interopRequireDefault(require("37f06410f0d8bb39"));
var getCharacterSpacing = R.pathOr(0, [
    'attributes',
    'characterSpacing'
]);
/**
 * Scale run positions
 *
 * @param  {Object}  run
 * @param  {Array}  positions
 * @return {Array} scaled positions
 */ var scalePositions = function scalePositions(run, positions) {
    var multScale = R.multiply((0, _scale["default"])(run));
    var characterSpacing = getCharacterSpacing(run);
    var scalePosition = R.evolve({
        xAdvance: R.o(R.add(characterSpacing), multScale),
        yAdvance: multScale,
        xOffset: multScale,
        yOffset: multScale
    });
    var subCharacterSpacing = R.evolve({
        xAdvance: R.subtract(R.__, characterSpacing)
    });
    return R.compose(R.adjust(-1, subCharacterSpacing), R.map(scalePosition))(positions);
};
/**
 * Create glyph run
 *
 * @param  {String}  string
 * @param  {Object}  run
 * @return {Object}  glyph run
 */ var layoutRun = function layoutRun(string) {
    return function(run) {
        var start = run.start, end = run.end, _run$attributes = run.attributes, attributes = _run$attributes === void 0 ? {} : _run$attributes;
        var font = attributes.font;
        if (!font) return (0, _extends2["default"])({}, run, {
            glyphs: [],
            glyphIndices: [],
            positions: []
        });
        var runString = string.slice(start, end);
        var glyphRun = font.layout(runString);
        var positions = scalePositions(run, glyphRun.positions);
        var glyphIndices = (0, _resolve["default"])(runString, glyphRun.stringIndices || []);
        return (0, _extends2["default"])({}, run, {
            positions: positions,
            glyphIndices: glyphIndices,
            glyphs: glyphRun.glyphs
        });
    };
};
/**
 * Generate glyphs for single attributed string
 *
 * @param  {Object}  layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings
 * @return {Array} attributed string with glyphs
 */ var generateGlyphs = function generateGlyphs() {
    return function(attributedString) {
        return R.evolve({
            runs: R.map(layoutRun(attributedString.string))
        })(attributedString);
    };
};
var _default = generateGlyphs;
exports["default"] = _default;

},{"21560257cab3578f":"fiRIh","35e9e0fbec46f276":"kZ6eK","de7d810d0622c173":"ktcBy","f372d77355e30026":"lzfqX","a37f65147f2d281a":"eOG6x","37f06410f0d8bb39":"6eG7h"}],"6eG7h":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1006ed1b1cd5e8f6");
var _interopRequireWildcard = require("ae001c369ee4bb02");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("e0f36a5841af6651"));
var _isNumber = _interopRequireDefault(require("d6cbd5eda6f2645d"));
/**
 * Generate glyphs indices from string indices
 *
 * ex. resolve([[0, 1, 2, 4]]) => [0, 1, 2, 2, 3]
 *
 * @param  {String}  string
 * @param  {Array}  string indices
 * @return {Array} glyph indices
 */ var resolve = function resolve(string, stringIndices) {
    if (stringIndices === void 0) stringIndices = [];
    var counter = 0;
    var glyphIndices = [];
    for(var i = 0; i < stringIndices.length; i++){
        var current = stringIndices[i];
        var prevValue = stringIndices[i - 1];
        var stringIndex = (0, _isNumber["default"])(current) ? current : prevValue + 1 || 0;
        var nextValue = stringIndices[i + 1] || stringIndex + 1;
        var diff = Math.abs(nextValue - stringIndex);
        glyphIndices.push.apply(glyphIndices, R.repeat(counter, diff));
        counter += 1;
    } // Append ending ligature glyph indices
    if (string.length !== glyphIndices.length) {
        var _diff = Math.max(0, string.length - glyphIndices.length);
        var lastValue = R.last(glyphIndices);
        glyphIndices.push.apply(glyphIndices, R.repeat(lastValue, _diff));
    }
    return glyphIndices;
};
var _default = resolve;
exports["default"] = _default;

},{"1006ed1b1cd5e8f6":"kZ6eK","ae001c369ee4bb02":"fiRIh","e0f36a5841af6651":"lzfqX","d6cbd5eda6f2645d":"ilX8l"}],"cX1aN":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("1f1fd6a63f0c80a2");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("a13f5557fcd0c521"));
var getYOffset = R.pathOr(0, [
    'attributes',
    'yOffset'
]);
var getUnitsPerEm = R.pathOr(0, [
    'attributes',
    'font',
    'unitsPerEm'
]);
/**
 * Resolves yOffset for run
 *
 * @param  {Object}  run
 * @return {Object} run
 */ var resolveRunYOffset = function resolveRunYOffset(run) {
    var unitsPerEm = getUnitsPerEm(run);
    var yOffset = getYOffset(run);
    var mult = yOffset * unitsPerEm;
    return R.evolve({
        positions: R.map(R.assoc('yOffset', mult))
    })(run);
};
/**
 * Resolves yOffset for multiple paragraphs
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings (paragraphs)
 * @return {Array} attributed strings (paragraphs)
 */ var resolveYOffset = function resolveYOffset() {
    return R.evolve({
        runs: R.map(resolveRunYOffset)
    });
};
var _default = resolveYOffset;
exports["default"] = _default;

},{"1f1fd6a63f0c80a2":"fiRIh","a13f5557fcd0c521":"lzfqX"}],"g8ivh":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c36b690082103a52");
var _interopRequireWildcard = require("484af5f013c00e0a");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("113b57063790caa6"));
var _omit = _interopRequireDefault(require("89826a1f93db0738"));
var _flatten = _interopRequireDefault(require("363cfc7e39704e71"));
var _empty = _interopRequireDefault(require("7fc094387cc372a5"));
var omitFont = R.evolve({
    runs: R.map((0, _omit["default"])('font'))
});
/**
 * Performs font substitution and script itemization on attributed string
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} processed attributed string
 */ var preprocessRuns = function preprocessRuns(engines, options) {
    return R.ifElse(R.isNil, _empty["default"], R.applySpec({
        string: R.prop('string'),
        runs: R.compose(_flatten["default"], R.flatten, R.pluck('runs'), R.juxt([
            engines.fontSubstitution(options),
            engines.scriptItemizer(options),
            omitFont
        ]))
    }));
};
var _default = preprocessRuns;
exports["default"] = _default;

},{"c36b690082103a52":"kZ6eK","484af5f013c00e0a":"fiRIh","113b57063790caa6":"lzfqX","89826a1f93db0738":"gGsCX","363cfc7e39704e71":"6ZDrM","7fc094387cc372a5":"bJOOn"}],"6ZDrM":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d155ac2054f915ac");
var _interopRequireWildcard = require("96a444ac47fae2c");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("74defdb5cca6d539"));
var _sort = _interopRequireDefault(require("47ad5f671d1a6144"));
var _isEmpty = _interopRequireDefault(require("8ca973492cf92f13"));
var sortPoints = function sortPoints(a, b) {
    return a[1] - b[1] || a[3] - b[3];
};
var mergeAttributes = function mergeAttributes(key, left, right) {
    return key === 'attributes' ? R.merge(left, right) : right;
};
var generatePoints = R.o(R.sort(sortPoints), R.addIndex(R.chain)(function(run, i) {
    return [
        [
            'start',
            run.start,
            run.attributes,
            i
        ],
        [
            'end',
            run.end,
            run.attributes,
            i
        ]
    ];
}));
var flattenEmptyRuns = R.compose(R.map(R.reduce(R.mergeDeepWithKey(mergeAttributes), {})), R.groupWith(R.eqProps('start')));
var flattenRegularRuns = function flattenRegularRuns(runs) {
    var res = [];
    var points = generatePoints(runs);
    var start = -1;
    var attrs = {};
    var stack = [];
    for(var _iterator = points, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var _ref2 = _ref, type = _ref2[0], offset = _ref2[1], attributes = _ref2[2];
        if (start !== -1 && start < offset) res.push({
            start: start,
            end: offset,
            attributes: attrs
        });
        if (type === 'start') {
            stack.push(attributes);
            attrs = R.merge(attrs, attributes);
        } else {
            attrs = {};
            for(var i = 0; i < stack.length; i++)if (stack[i] === attributes) stack.splice(i--, 1);
            else attrs = R.merge(attrs, stack[i]);
        }
        start = offset;
    }
    return res;
};
/**
 * Flatten many runs
 *
 * @param  {Array}  runs
 * @return {Array} flatten runs
 */ var flatten = function flatten(runs) {
    if (runs === void 0) runs = [];
    return R.compose(_sort["default"], R.apply(R.useWith(R.concat, [
        flattenEmptyRuns,
        flattenRegularRuns
    ])), R.partition(_isEmpty["default"]))(runs);
};
var _default = flatten;
exports["default"] = _default;

},{"d155ac2054f915ac":"kZ6eK","96a444ac47fae2c":"fiRIh","74defdb5cca6d539":"lzfqX","47ad5f671d1a6144":"9i0KC","8ca973492cf92f13":"aro2H"}],"9i0KC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("a017426f2ffc808b");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("bb47f0078542cdc4"));
/**
 * Sort runs in ascending order
 *
 * @param  {Array}  runs
 * @return {Array} sorted runs
 */ var sort = function sort(a, b) {
    return a.start - b.start || a.end - b.end;
};
var _default = R.sort(sort);
exports["default"] = _default;

},{"a017426f2ffc808b":"fiRIh","bb47f0078542cdc4":"lzfqX"}],"aro2H":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("dcc69bf513d0f2d6");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("ceb3728557d2c799"));
/**
 * Is run empty (start === end)
 *
 * @param  {Object}  run
 * @return {Object} is run empty
 */ var isEmpty = R.converge(R.equals, [
    R.prop('start'),
    R.prop('end')
]);
var _default = isEmpty;
exports["default"] = _default;

},{"dcc69bf513d0f2d6":"fiRIh","ceb3728557d2c799":"lzfqX"}],"2zXXs":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e6f6ff8805c0d7a0");
exports.__esModule = true;
exports["default"] = void 0;
var _length = _interopRequireDefault(require("4627ddfde5970753"));
var _slice = _interopRequireDefault(require("6adea4e2cd4caeb3"));
/**
 * Breaks attributed string into paragraphs
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Array} attributed string array
 */ var splitParagraphs = function splitParagraphs() {
    return function(attributedString) {
        var res = [];
        var start = 0;
        var breakPoint = attributedString.string.indexOf('\n') + 1;
        while(breakPoint > 0){
            res.push((0, _slice["default"])(start, breakPoint, attributedString));
            start = breakPoint;
            breakPoint = attributedString.string.indexOf('\n', breakPoint) + 1;
        }
        if (start === 0) res.push(attributedString);
        else if (start < attributedString.string.length) res.push((0, _slice["default"])(start, (0, _length["default"])(attributedString), attributedString));
        return res;
    };
};
var _default = splitParagraphs;
exports["default"] = _default;

},{"e6f6ff8805c0d7a0":"kZ6eK","4627ddfde5970753":"fi9n8","6adea4e2cd4caeb3":"eSCNP"}],"7owwy":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a362fb4fc1b52c17");
var _interopRequireWildcard = require("eecfbfddf0bcfa73");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("d23cb3e6b1d21df1"));
var _advanceWidth = _interopRequireDefault(require("bbce24b1b8bab704"));
var _leadingOffset = _interopRequireDefault(require("221a57b318dd084b"));
var _trailingOffset = _interopRequireDefault(require("45bfbc39da953080"));
var _dropLast = _interopRequireDefault(require("8f08f3a93d678cce"));
var ALIGNMENT_FACTORS = {
    left: 0,
    center: 0.5,
    right: 1,
    justify: 0
};
/**
 * Remove new line char at the end of line if present
 *
 * @param  {Object}  line
 * @return {Object} line
 */ var removeNewLine = R.when(R.compose(R.equals('\n'), R.last, R.prop('string')), _dropLast["default"]);
var getOverflowLeft = R.converge(R.add, [
    R.propOr(0, 'overflowLeft'),
    _leadingOffset["default"]
]);
var getOverflowRight = R.converge(R.add, [
    R.propOr(0, 'overflowRight'),
    _trailingOffset["default"]
]);
/**
 * Ignore whitespace at the start and end of a line for alignment
 *
 * @param  {Object}  line
 * @return {Object} line
 */ var adjustOverflow = function adjustOverflow(line) {
    var overflowLeft = getOverflowLeft(line);
    var overflowRight = getOverflowRight(line);
    return R.compose(R.assoc('overflowLeft', overflowLeft), R.assoc('overflowRight', overflowRight), R.evolve({
        box: R.evolve({
            x: R.subtract(R.__, overflowLeft),
            width: R.add(overflowLeft + overflowRight)
        })
    }))(line);
};
/**
 * Performs line justification by calling appropiate engine
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {string}  text align
 * @param  {Object}  line
 * @return {Object} line
 */ var justifyLine = function justifyLine(engines, options, align) {
    return function(line) {
        var lineAdvanceWidth = (0, _advanceWidth["default"])(line);
        var remainingWidth = Math.max(0, line.box.width - lineAdvanceWidth);
        var shouldJustify = align === 'justify' || lineAdvanceWidth > line.box.width;
        return R.compose(R.when(R.always(shouldJustify), engines.justification(options)), R.evolve({
            box: R.evolve({
                x: R.add(remainingWidth * ALIGNMENT_FACTORS[align])
            })
        }))(line);
    };
};
/**
 * Finalize line by performing line justification
 * and text decoration (using appropiate engines)
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  line
 * @param  {number}  line index
 * @param  {Array}  total lines
 * @return {Object} line
 */ var finalizeBlock = function finalizeBlock(engines, options) {
    if (engines === void 0) engines = {};
    return function(line, i, lines) {
        var isLastFragment = i === lines.length - 1;
        var style = R.pathOr({}, [
            'runs',
            0,
            'attributes'
        ], line);
        var align = isLastFragment ? style.alignLastLine : style.align;
        return R.compose(engines.textDecoration(options), justifyLine(engines, options, align), adjustOverflow, removeNewLine)(line);
    };
};
/**
 * Finalize line block by performing line justification
 * and text decoration (using appropiate engines)
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Array}  line blocks
 * @return {Array} line blocks
 */ var finalizeFragments = function finalizeFragments(engines, options, blocks) {
    return R.map(R.addIndex(R.map)(finalizeBlock(engines, options)), blocks);
};
var _default = R.curryN(3, finalizeFragments);
exports["default"] = _default;

},{"a362fb4fc1b52c17":"kZ6eK","eecfbfddf0bcfa73":"fiRIh","d23cb3e6b1d21df1":"lzfqX","bbce24b1b8bab704":"bqw7C","221a57b318dd084b":"lB4Yp","45bfbc39da953080":"fo2bo","8f08f3a93d678cce":"MTB7g"}],"ltAii":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("56610a337c553dec");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("fec11062fe8734ec"));
var ATTACHMENT_CODE = 0xfffc; // 65532
var mapIndexed = R.addIndex(R.map);
var getGlyphs = R.propOr([], 'glyphs');
var getAttachment = R.pathOr({}, [
    'attributes',
    'attachment'
]);
var isReplaceGlyph = R.o(R.includes(ATTACHMENT_CODE), R.propOr([], 'codePoints'));
/**
 * Resolve attachments of run
 *
 * @param  {Object}  run
 * @return {Object} run
 */ var resolveRunAttachments = function resolveRunAttachments(run) {
    var glyphs = getGlyphs(run);
    var attachment = getAttachment(run);
    var attachmentWidth = R.always(attachment.width);
    return R.evolve({
        positions: mapIndexed(function(position, i) {
            var glyph = glyphs[i];
            if (attachment && attachment.width && isReplaceGlyph(glyph)) return R.evolve({
                xAdvance: attachmentWidth
            }, position);
            return R.clone(position);
        })
    })(run);
};
/**
 * Resolve attachments for multiple paragraphs
 *
 * @param  {Object} layout engines
 * @param  {Object}  layout options
 * @param  {Array}  attributed strings (paragraphs)
 * @return {Array} attributed strings (paragraphs)
 */ var resolveAttachments = function resolveAttachments() {
    return R.evolve({
        runs: R.map(resolveRunAttachments)
    });
};
var _default = resolveAttachments;
exports["default"] = _default;

},{"56610a337c553dec":"fiRIh","fec11062fe8734ec":"lzfqX"}],"6Gr6x":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireWildcard = require("3c8059667bfc4cdd");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("b6e2d95a7e1dbe67"));
/**
 * Apply default style to run
 *
 * @param  {Object}  run
 * @return {Object} run with styles
 */ var applyRunStyles = R.evolve({
    attributes: function attributes(a) {
        return {
            align: a.align || 'left',
            alignLastLine: a.alignLastLine || (a.align === 'justify' ? 'left' : a.align || 'left'),
            attachment: a.attachment || null,
            backgroundColor: a.backgroundColor || null,
            bidiLevel: a.bidiLevel || null,
            bullet: a.bullet || null,
            characterSpacing: a.characterSpacing || 0,
            color: a.color || 'black',
            features: a.features || [],
            fill: a.fill !== false,
            font: a.font || null,
            fontSize: a.fontSize || 12,
            hangingPunctuation: a.hangingPunctuation || false,
            hyphenationFactor: a.hyphenationFactor || 0,
            indent: a.indent || 0,
            justificationFactor: a.justificationFactor || 1,
            lineHeight: a.lineHeight || null,
            lineSpacing: a.lineSpacing || 0,
            link: a.link || null,
            marginLeft: a.marginLeft || a.margin || 0,
            marginRight: a.marginRight || a.margin || 0,
            opacity: R.isNil(a.opacity) ? 1 : a.opacity,
            paddingTop: a.paddingTop || a.padding || 0,
            paragraphSpacing: a.paragraphSpacing || 0,
            underline: a.underline || false,
            underlineColor: a.underlineColor || a.color || 'black',
            underlineStyle: a.underlineStyle || 'solid',
            script: a.script || null,
            shrinkFactor: a.shrinkFactor || 0,
            strike: a.strike || false,
            strikeColor: a.strikeColor || a.color || 'black',
            strikeStyle: a.strikeStyle || 'solid',
            stroke: a.stroke || false,
            wordSpacing: a.wordSpacing || 0,
            yOffset: a.yOffset || 0
        };
    }
});
/**
 * Apply default attributes for an attributed string
 *
 * @param  {Object}  engines
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var applyDefaultStyles = function applyDefaultStyles() {
    return R.applySpec({
        string: R.propOr('', 'string'),
        runs: R.compose(R.map(applyRunStyles), R.defaultTo([]), R.prop('runs'))
    });
};
var _default = applyDefaultStyles;
exports["default"] = _default;

},{"3c8059667bfc4cdd":"fiRIh","b6e2d95a7e1dbe67":"lzfqX"}],"7m3Wj":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e697219c4512d229");
var _interopRequireWildcard = require("13d4c1d23de0f6c6");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("9b85956aecc37b41"));
var _bestFit = _interopRequireDefault(require("8f0baa869ebeef40"));
var _linebreak = _interopRequireDefault(require("560fee59c26625f9"));
var _slice = _interopRequireDefault(require("4b6177bb587a9c09"));
var _insertGlyph = _interopRequireDefault(require("5e023006a5dc203c"));
var _advanceWidthBetween = _interopRequireDefault(require("efc74bf68d94dfb5"));
var HYPHEN = 0x002d;
var TOLERANCE_STEPS = 5;
var TOLERANCE_LIMIT = 50;
var opts = {
    width: 3,
    stretch: 6,
    shrink: 9
};
/**
 * Slice attributed string to many lines
 *
 * @param {Object} attributed string
 * @param  {Array}  nodes
 * @param  {Array}  breaks
 * @return {Array} attributed strings
 */ var breakLines = function breakLines(string, nodes, breaks) {
    var start = 0;
    var end = null;
    var lines = breaks.reduce(function(acc, breakPoint) {
        var node = nodes[breakPoint.position];
        var prevNode = nodes[breakPoint.position - 1]; // Last breakpoint corresponds to K&P mandatory final glue
        if (breakPoint.position === nodes.length - 1) return acc;
        var line;
        if (node.type === 'penalty') {
            end = prevNode.value.end;
            line = (0, _slice["default"])(start, end, string);
            line = (0, _insertGlyph["default"])(line.length, HYPHEN, line);
        } else {
            end = node.value.end;
            line = (0, _slice["default"])(start, end, string);
        }
        start = end;
        return [].concat(acc, [
            line
        ]);
    }, []); // Last line
    lines.push((0, _slice["default"])(start, string.string.length, string));
    return lines;
};
/**
 * Return Knuth & Plass nodes based on line and previously calculated syllables
 *
 * @param {Object} attributed string
 * @param  {Object}  attributed string
 * @param  {Object}  layout options
 * @return {Array} attributed strings
 */ var getNodes = function getNodes(attributedString, _ref, options) {
    var align = _ref.align;
    var start = 0;
    var hyphenWidth = 5;
    var syllables = attributedString.syllables;
    var hyphenPenalty = options.hyphenationPenalty || (align === 'justify' ? 100 : 600);
    var result = syllables.reduce(function(acc, s, index) {
        var width = (0, _advanceWidthBetween["default"])(start, start + s.length, attributedString);
        if (s.trim() === '') {
            var stretch = width * opts.width / opts.stretch;
            var shrink = width * opts.width / opts.shrink;
            var value = {
                start: start,
                end: start + s.length
            };
            acc.push(_linebreak["default"].glue(width, value, stretch, shrink));
        } else {
            var hyphenated = syllables[index + 1] !== ' ';
            var _value = {
                start: start,
                end: start + s.length
            };
            acc.push(_linebreak["default"].box(width, _value, hyphenated));
            if (syllables[index + 1] && hyphenated) acc.push(_linebreak["default"].penalty(hyphenWidth, hyphenPenalty, 1));
        }
        start += s.length;
        return acc;
    }, []);
    result.push(_linebreak["default"].glue(0, null, _linebreak["default"].infinity, 0));
    result.push(_linebreak["default"].penalty(0, -_linebreak["default"].infinity, 1));
    return result;
};
var getStyles = R.pathOr({}, [
    'attributedString',
    'runs',
    0,
    'attributes'
]);
/**
 * Performs Knuth & Plass line breaking algorithm
 * Fallbacks to best fit algorithm if latter not successful
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @param {Object} attributed string
 * @return {Array} attributed strings
 */ var lineBreaker = function lineBreaker(options, attributedString, availableWidths) {
    var tolerance = options.tolerance || 4;
    var style = getStyles(attributedString);
    var nodes = getNodes(attributedString, style, options);
    var breaks = (0, _linebreak["default"])(nodes, availableWidths, {
        tolerance: tolerance
    }); // Try again with a higher tolerance if the line breaking failed.
    while(breaks.length === 0 && tolerance < TOLERANCE_LIMIT){
        tolerance += TOLERANCE_STEPS;
        breaks = (0, _linebreak["default"])(nodes, availableWidths, {
            tolerance: tolerance
        });
    }
    if (breaks.length === 0 || breaks.length === 1 && breaks[0].position === 0) breaks = (0, _bestFit["default"])(nodes, availableWidths);
    return breakLines(attributedString, nodes, breaks.slice(1));
};
var _default = R.curryN(3, lineBreaker);
exports["default"] = _default;

},{"e697219c4512d229":"kZ6eK","13d4c1d23de0f6c6":"fiRIh","9b85956aecc37b41":"lzfqX","8f0baa869ebeef40":"9d6G7","560fee59c26625f9":"ilOV9","4b6177bb587a9c09":"eSCNP","5e023006a5dc203c":"37qVT","efc74bf68d94dfb5":"iaHWm"}],"9d6G7":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports["default"] = void 0;
var INFINITY = 10000;
var getNextBreakpoint = function getNextBreakpoint(subnodes, widths, lineNumber) {
    var position = null;
    var minimumBadness = Infinity;
    var sum = {
        width: 0,
        stretch: 0,
        shrink: 0
    };
    var lineLength = widths[Math.min(lineNumber, widths.length - 1)];
    var calculateRatio = function calculateRatio(node) {
        if (sum.width < lineLength) return sum.stretch - node.stretch > 0 ? (lineLength - sum.width) / sum.stretch : INFINITY;
        else if (sum.width > lineLength) return sum.shrink - node.shrink > 0 ? (lineLength - sum.width) / sum.shrink : INFINITY;
        return 0;
    };
    for(var i = 0; i < subnodes.length; i++){
        var node = subnodes[i];
        if (node.type === 'box') sum.width += node.width;
        else if (node.type === 'glue') {
            sum.width += node.width;
            sum.stretch += node.stretch;
            sum.shrink += node.shrink;
        }
        if (sum.width - sum.shrink > lineLength) break;
        if (node.type === 'penalty' || node.type === 'glue') {
            var ratio = calculateRatio(node);
            var penalty = node.type === 'penalty' ? node.penalty : 0;
            var badness = 100 * Math.pow(Math.abs(ratio), 3) + penalty;
            if (minimumBadness >= badness) {
                position = i;
                minimumBadness = badness;
            }
        }
    }
    return sum.width - sum.shrink > lineLength ? position : null;
};
var applyBestFit = function applyBestFit(nodes, widths) {
    var count = 0;
    var lineNumber = 0;
    var subnodes = nodes;
    var breakpoints = [
        {
            position: 0
        }
    ];
    while(subnodes.length > 0){
        var breakpoint = getNextBreakpoint(subnodes, widths, lineNumber);
        if (breakpoint) {
            count += breakpoint;
            breakpoints.push({
                position: count
            });
            subnodes = subnodes.slice(breakpoint + 1, subnodes.length);
            count++;
            lineNumber++;
        } else subnodes = [];
    }
    return breakpoints;
};
var _default = applyBestFit;
exports["default"] = _default;

},{}],"ilOV9":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("73c74e77b49535bc");
exports.__esModule = true;
exports["default"] = void 0;
var _linkedList = _interopRequireDefault(require("16812080264fa1e8"));
/**
 * @preserve Knuth and Plass line breaking algorithm in JavaScript
 *
 * Licensed under the new BSD License.
 * Copyright 2009-2010, Bram Stein
 * All rights reserved.
 */ var linebreak = function linebreak(nodes, lines, settings) {
    var options = {
        demerits: {
            line: settings && settings.demerits && settings.demerits.line || 10,
            flagged: settings && settings.demerits && settings.demerits.flagged || 100,
            fitness: settings && settings.demerits && settings.demerits.fitness || 3000
        },
        tolerance: settings && settings.tolerance || 3
    };
    var activeNodes = new _linkedList["default"]();
    var sum = {
        width: 0,
        stretch: 0,
        shrink: 0
    };
    var lineLengths = lines;
    var breaks = [];
    var tmp = {
        data: {
            demerits: Infinity
        }
    };
    function breakpoint(position, demerits, ratio, line, fitnessClass, totals, previous) {
        return {
            position: position,
            demerits: demerits,
            ratio: ratio,
            line: line,
            fitnessClass: fitnessClass,
            totals: totals || {
                width: 0,
                stretch: 0,
                shrink: 0
            },
            previous: previous
        };
    }
    function computeCost(start, end, active, currentLine) {
        var width = sum.width - active.totals.width;
        var stretch = 0;
        var shrink = 0; // If the current line index is within the list of linelengths, use it, otherwise use
        // the last line length of the list.
        var lineLength = currentLine < lineLengths.length ? lineLengths[currentLine - 1] : lineLengths[lineLengths.length - 1];
        if (nodes[end].type === 'penalty') width += nodes[end].width;
        if (width < lineLength) {
            // Calculate the stretch ratio
            stretch = sum.stretch - active.totals.stretch;
            if (stretch > 0) return (lineLength - width) / stretch;
            return linebreak.infinity;
        } else if (width > lineLength) {
            // Calculate the shrink ratio
            shrink = sum.shrink - active.totals.shrink;
            if (shrink > 0) return (lineLength - width) / shrink;
            return linebreak.infinity;
        } // perfect match
        return 0;
    } // Add width, stretch and shrink values from the current
    // break point up to the next box or forced penalty.
    function computeSum(breakPointIndex) {
        var result = {
            width: sum.width,
            stretch: sum.stretch,
            shrink: sum.shrink
        };
        for(var i = breakPointIndex; i < nodes.length; i += 1){
            if (nodes[i].type === 'glue') {
                result.width += nodes[i].width;
                result.stretch += nodes[i].stretch;
                result.shrink += nodes[i].shrink;
            } else if (nodes[i].type === 'box' || nodes[i].type === 'penalty' && nodes[i].penalty === -linebreak.infinity && i > breakPointIndex) break;
        }
        return result;
    } // The main loop of the algorithm
    function mainLoop(node, index, nodes) {
        var active = activeNodes.first();
        var next = null;
        var ratio = 0;
        var demerits = 0;
        var candidates = [];
        var badness;
        var currentLine = 0;
        var tmpSum;
        var currentClass = 0;
        var fitnessClass;
        var candidate;
        var newNode; // The inner loop iterates through all the active nodes with line < currentLine and then
        // breaks out to insert the new active node candidates before looking at the next active
        // nodes for the next lines. The result of this is that the active node list is always
        // sorted by line number.
        while(active !== null){
            candidates = [
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                },
                {
                    demerits: Infinity
                }
            ]; // Iterate through the linked list of active nodes to find new potential active nodes
            // and deactivate current active nodes.
            while(active !== null){
                next = active.next;
                currentLine = active.data.line + 1;
                ratio = computeCost(active.data.position, index, active.data, currentLine); // Deactive nodes when the distance between the current active node and the
                // current node becomes too large (i.e. it exceeds the stretch limit and the stretch
                // ratio becomes negative) or when the current node is a forced break (i.e. the end
                // of the paragraph when we want to remove all active nodes, but possibly have a final
                // candidate active node---if the paragraph can be set using the given tolerance value.)
                if (ratio < -1 || node.type === 'penalty' && node.penalty === -linebreak.infinity) activeNodes.remove(active);
                 // If the ratio is within the valid range of -1 <= ratio <= tolerance calculate the
                // total demerits and record a candidate active node.
                if (ratio >= -1 && ratio <= options.tolerance) {
                    badness = 100 * Math.pow(Math.abs(ratio), 3); // Positive penalty
                    if (node.type === 'penalty' && node.penalty >= 0) demerits = Math.pow(options.demerits.line + badness, 2) + Math.pow(node.penalty, 2); // Negative penalty but not a forced break
                    else if (node.type === 'penalty' && node.penalty !== -linebreak.infinity) demerits = Math.pow(options.demerits.line + badness, 2) - Math.pow(node.penalty, 2); // All other cases
                    else demerits = Math.pow(options.demerits.line + badness, 2);
                    if (node.type === 'penalty' && nodes[active.data.position].type === 'penalty') demerits += options.demerits.flagged * node.flagged * nodes[active.data.position].flagged;
                     // Calculate the fitness class for this candidate active node.
                    if (ratio < -0.5) currentClass = 0;
                    else if (ratio <= 0.5) currentClass = 1;
                    else if (ratio <= 1) currentClass = 2;
                    else currentClass = 3;
                     // Add a fitness penalty to the demerits if the fitness classes of two adjacent lines
                    // differ too much.
                    if (Math.abs(currentClass - active.data.fitnessClass) > 1) demerits += options.demerits.fitness;
                     // Add the total demerits of the active node to get the total demerits of this candidate node.
                    demerits += active.data.demerits; // Only store the best candidate for each fitness class
                    if (demerits < candidates[currentClass].demerits) candidates[currentClass] = {
                        active: active,
                        demerits: demerits,
                        ratio: ratio
                    };
                }
                active = next; // Stop iterating through active nodes to insert new candidate active nodes in the active list
                // before moving on to the active nodes for the next line.
                // TODO: The Knuth and Plass paper suggests a conditional for currentLine < j0. This means paragraphs
                // with identical line lengths will not be sorted by line number. Find out if that is a desirable outcome.
                // For now I left this out, as it only adds minimal overhead to the algorithm and keeping the active node
                // list sorted has a higher priority.
                if (active !== null && active.data.line >= currentLine) break;
            }
            tmpSum = computeSum(index);
            for(fitnessClass = 0; fitnessClass < candidates.length; fitnessClass += 1){
                candidate = candidates[fitnessClass];
                if (candidate.demerits < Infinity) {
                    newNode = new _linkedList["default"].Node(breakpoint(index, candidate.demerits, candidate.ratio, candidate.active.data.line + 1, fitnessClass, tmpSum, candidate.active));
                    if (active !== null) activeNodes.insertBefore(active, newNode);
                    else activeNodes.push(newNode);
                }
            }
        }
    } // Add an active node for the start of the paragraph.
    activeNodes.push(new _linkedList["default"].Node(breakpoint(0, 0, 0, 0, 0, undefined, null)));
    nodes.forEach(function(node, index, nodes) {
        if (node.type === 'box') sum.width += node.width;
        else if (node.type === 'glue') {
            if (index > 0 && nodes[index - 1].type === 'box') mainLoop(node, index, nodes);
            sum.width += node.width;
            sum.stretch += node.stretch;
            sum.shrink += node.shrink;
        } else if (node.type === 'penalty' && node.penalty !== linebreak.infinity) mainLoop(node, index, nodes);
    });
    if (activeNodes.size() !== 0) {
        // Find the best active node (the one with the least total demerits.)
        activeNodes.forEach(function(node) {
            if (node.data.demerits < tmp.data.demerits) tmp = node;
        });
        while(tmp !== null){
            breaks.push({
                position: tmp.data.position,
                ratio: tmp.data.ratio
            });
            tmp = tmp.data.previous;
        }
        return breaks.reverse();
    }
    return [];
};
linebreak.infinity = 10000;
linebreak.glue = function(width, value, stretch, shrink) {
    return {
        type: 'glue',
        value: value,
        width: width,
        stretch: stretch,
        shrink: shrink
    };
};
linebreak.box = function(width, value, hyphenated) {
    if (hyphenated === void 0) hyphenated = false;
    return {
        type: 'box',
        width: width,
        value: value,
        hyphenated: hyphenated
    };
};
linebreak.penalty = function(width, penalty, flagged) {
    return {
        type: 'penalty',
        width: width,
        penalty: penalty,
        flagged: flagged
    };
};
var _default = linebreak;
exports["default"] = _default;

},{"73c74e77b49535bc":"kZ6eK","16812080264fa1e8":"gCYXX"}],"gCYXX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f5bbe8f70effda2b");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("7f42ced379568d84"));
var Node = /*#__PURE__*/ function() {
    function Node(data) {
        this.prev = null;
        this.next = null;
        this.data = data;
    }
    var _proto = Node.prototype;
    _proto.toString = function toString() {
        return this.data.toString();
    };
    return Node;
}();
var LinkedList = /*#__PURE__*/ function() {
    function LinkedList() {
        this.head = null;
        this.tail = null;
        this.listSize = 0;
    }
    var _proto2 = LinkedList.prototype;
    _proto2.isLinked = function isLinked(node) {
        return !(node && node.prev === null && node.next === null && this.tail !== node && this.head !== node || this.isEmpty());
    };
    _proto2.size = function size() {
        return this.listSize;
    };
    _proto2.isEmpty = function isEmpty() {
        return this.listSize === 0;
    };
    _proto2.first = function first() {
        return this.head;
    };
    _proto2.last = function last() {
        return this.last;
    };
    _proto2.toString = function toString() {
        return this.toArray().toString();
    };
    _proto2.toArray = function toArray() {
        var node = this.head;
        var result = [];
        while(node !== null){
            result.push(node);
            node = node.next;
        }
        return result;
    };
    _proto2.forEach = function forEach(fun) {
        var node = this.head;
        while(node !== null){
            fun(node);
            node = node.next;
        }
    };
    _proto2.contains = function contains(n) {
        var node = this.head;
        if (!this.isLinked(n)) return false;
        while(node !== null){
            if (node === n) return true;
            node = node.next;
        }
        return false;
    };
    _proto2.at = function at(i) {
        var node = this.head;
        var index = 0;
        if (i >= this.listLength || i < 0) return null;
        while(node !== null){
            if (i === index) return node;
            node = node.next;
            index += 1;
        }
        return null;
    };
    _proto2.insertAfter = function insertAfter(node, newNode) {
        if (!this.isLinked(node)) return this;
        newNode.prev = node;
        newNode.next = node.next;
        if (node.next === null) this.tail = newNode;
        else node.next.prev = newNode;
        node.next = newNode;
        this.listSize += 1;
        return this;
    };
    _proto2.insertBefore = function insertBefore(node, newNode) {
        if (!this.isLinked(node)) return this;
        newNode.prev = node.prev;
        newNode.next = node;
        if (node.prev === null) this.head = newNode;
        else node.prev.next = newNode;
        node.prev = newNode;
        this.listSize += 1;
        return this;
    };
    _proto2.push = function push(node) {
        if (this.head === null) this.unshift(node);
        else this.insertAfter(this.tail, node);
        return this;
    };
    _proto2.unshift = function unshift(node) {
        if (this.head === null) {
            this.head = node;
            this.tail = node;
            node.prev = null;
            node.next = null;
            this.listSize += 1;
        } else this.insertBefore(this.head, node);
        return this;
    };
    _proto2.remove = function remove(node) {
        if (!this.isLinked(node)) return this;
        if (node.prev === null) this.head = node.next;
        else node.prev.next = node.next;
        if (node.next === null) this.tail = node.prev;
        else node.next.prev = node.prev;
        this.listSize -= 1;
        return this;
    };
    _proto2.pop = function pop() {
        var node = this.tail;
        this.tail.prev.next = null;
        this.tail = this.tail.prev;
        this.listSize -= 1;
        node.prev = null;
        node.next = null;
        return node;
    };
    _proto2.shift = function shift() {
        var node = this.head;
        this.head.next.prev = null;
        this.head = this.head.next;
        this.listSize -= 1;
        node.prev = null;
        node.next = null;
        return node;
    };
    return LinkedList;
}();
(0, _defineProperty2["default"])(LinkedList, "Node", Node);
var _default = LinkedList;
exports["default"] = _default;

},{"f5bbe8f70effda2b":"kZ6eK","7f42ced379568d84":"hjdoh"}],"9I486":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2f8735bb27df8c51");
var _interopRequireWildcard = require("4162701a0fc4d17b");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("b2db2af34b775511"));
var _getFactors = _interopRequireDefault(require("73f4137a7f76f1c7"));
var _getDistances = _interopRequireDefault(require("f8677f7e882b148e"));
var _advanceWidth = _interopRequireDefault(require("ee211275f4e7e724"));
/**
 * Adjust run positions by given distances
 *
 * @param {Array} distances
 * @param {Object} line
 * @returns {Object} line
 */ var justifyLine = function justifyLine(distances, line) {
    var index = 0;
    for(var _iterator = line.runs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var run = _ref;
        for(var _iterator2 = run.positions, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;){
            var _ref2;
            if (_isArray2) {
                if (_i2 >= _iterator2.length) break;
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) break;
                _ref2 = _i2.value;
            }
            var position = _ref2;
            position.xAdvance += distances[index++];
        }
    }
    return line;
};
/**
 * A JustificationEngine is used by a Typesetter to perform line fragment
 * justification. This implementation is based on a description of Apple's
 * justification algorithm from a PDF in the Apple Font Tools package.
 *
 * //TODO: Make it immutable
 *
 * @param {Object} layout options
 * @param {Object} line
 * @returns {Object} line
 */ var justification = function justification(options, line) {
    var gap = line.box.width - (0, _advanceWidth["default"])(line);
    if (gap === 0) return; // Exact fit
    var factors = (0, _getFactors["default"])(gap, line, options);
    var distances = (0, _getDistances["default"])(gap, factors);
    return justifyLine(distances, line);
};
var _default = R.curryN(2, justification);
exports["default"] = _default;

},{"2f8735bb27df8c51":"kZ6eK","4162701a0fc4d17b":"fiRIh","b2db2af34b775511":"lzfqX","73f4137a7f76f1c7":"lt1ZX","f8677f7e882b148e":"9NLQA","ee211275f4e7e724":"bqw7C"}],"lt1ZX":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("94f52ec28197f204");
var _interopRequireWildcard = require("914e885c2f71f2a4");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("9fdc0620eccd4fc3"));
var _isWhiteSpace = _interopRequireDefault(require("897b09dc8d329d81"));
var WHITESPACE_PRIORITY = 1;
var LETTER_PRIORITY = 2;
var EXPAND_WHITESPACE_FACTOR = {
    before: 0.5,
    after: 0.5,
    priority: WHITESPACE_PRIORITY,
    unconstrained: false
};
var EXPAND_CHAR_FACTOR = {
    before: 0.14453125,
    // 37/256
    after: 0.14453125,
    priority: LETTER_PRIORITY,
    unconstrained: false
};
var SHRINK_WHITESPACE_FACTOR = {
    before: -0.04296875,
    // -11/256
    after: -0.04296875,
    priority: WHITESPACE_PRIORITY,
    unconstrained: false
};
var SHRINK_CHAR_FACTOR = {
    before: -0.04296875,
    after: -0.04296875,
    priority: LETTER_PRIORITY,
    unconstrained: false
};
var getCharFactor = function getCharFactor(direction, options) {
    var expandCharFactor = R.propOr({}, 'expandCharFactor', options);
    var shrinkCharFactor = R.propOr({}, 'shrinkCharFactor', options);
    return direction === 'GROW' ? R.merge(EXPAND_CHAR_FACTOR, expandCharFactor) : R.merge(SHRINK_CHAR_FACTOR, shrinkCharFactor);
};
var getWhitespaceFactor = function getWhitespaceFactor(direction, options) {
    var expandWhitespaceFactor = R.propOr({}, 'expandWhitespaceFactor', options);
    var shrinkWhitespaceFactor = R.propOr({}, 'shrinkWhitespaceFactor', options);
    return direction === 'GROW' ? R.merge(EXPAND_WHITESPACE_FACTOR, expandWhitespaceFactor) : R.merge(SHRINK_WHITESPACE_FACTOR, shrinkWhitespaceFactor);
};
var factor = function factor(direction, options) {
    return function(glyphs) {
        var charFactor = getCharFactor(direction, options);
        var whitespaceFactor = getWhitespaceFactor(direction, options);
        var factors = [];
        for(var index = 0; index < glyphs.length; index++){
            var f = void 0;
            var glyph = glyphs[index];
            if ((0, _isWhiteSpace["default"])(glyph)) {
                f = R.clone(whitespaceFactor);
                if (index === glyphs.length - 1) {
                    f.before = 0;
                    if (index > 0) factors[index - 1].after = 0;
                }
            } else if (glyph.isMark && index > 0) {
                f = R.clone(factors[index - 1]);
                f.before = 0;
                factors[index - 1].after = 0;
            } else f = R.clone(charFactor);
            factors.push(f);
        }
        return factors;
    };
};
var getFactors = function getFactors(gap, line, options) {
    var direction = gap > 0 ? 'GROW' : 'SHRINK';
    var getFactor = factor(direction, options);
    var concatFactors = R.useWith(R.concat, [
        R.identity,
        R.compose(getFactor, R.prop('glyphs'))
    ]);
    return R.compose(R.adjust(-1, R.assoc('after', 0)), R.adjust(0, R.assoc('before', 0)), R.reduce(concatFactors, []), R.prop('runs'))(line);
};
var _default = getFactors;
exports["default"] = _default;

},{"94f52ec28197f204":"kZ6eK","914e885c2f71f2a4":"fiRIh","9fdc0620eccd4fc3":"lzfqX","897b09dc8d329d81":"9lW3u"}],"9NLQA":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports["default"] = void 0;
var KASHIDA_PRIORITY = 0;
var NULL_PRIORITY = 3;
var getDistances = function getDistances(gap, factors) {
    var total = 0;
    var priorities = [];
    var unconstrained = [];
    for(var _priority = KASHIDA_PRIORITY; _priority <= NULL_PRIORITY; _priority++)priorities[_priority] = unconstrained[_priority] = 0;
     // sum the factors at each priority
    for(var j = 0; j < factors.length; j++){
        var f = factors[j];
        var sum = f.before + f.after;
        total += sum;
        priorities[f.priority] += sum;
        if (f.unconstrained) unconstrained[f.priority] += sum;
    } // choose the priorities that need to be applied
    var highestPriority = -1;
    var highestPrioritySum = 0;
    var remainingGap = gap;
    var priority;
    for(priority = KASHIDA_PRIORITY; priority <= NULL_PRIORITY; priority++){
        var prioritySum = priorities[priority];
        if (prioritySum !== 0) {
            if (highestPriority === -1) {
                highestPriority = priority;
                highestPrioritySum = prioritySum;
            } // if this priority covers the remaining gap, we're done
            if (Math.abs(remainingGap) <= Math.abs(prioritySum)) {
                priorities[priority] = remainingGap / prioritySum;
                unconstrained[priority] = 0;
                remainingGap = 0;
                break;
            } // mark that we need to use 100% of the adjustment from
            // this priority, and subtract the space that it consumes
            priorities[priority] = 1;
            remainingGap -= prioritySum; // if this priority has unconstrained glyphs, let them consume the remaining space
            if (unconstrained[priority] !== 0) {
                unconstrained[priority] = remainingGap / unconstrained[priority];
                remainingGap = 0;
                break;
            }
        }
    } // zero out remaining priorities (if any)
    for(var p = priority + 1; p <= NULL_PRIORITY; p++){
        priorities[p] = 0;
        unconstrained[p] = 0;
    } // if there is still space left over, assign it to the highest priority that we saw.
    // this violates their factors, but it only happens in extreme cases
    if (remainingGap > 0 && highestPriority > -1) priorities[highestPriority] = (highestPrioritySum + (gap - total)) / highestPrioritySum;
     // create and return an array of distances to add to each glyph's advance
    var distances = [];
    for(var index = 0; index < factors.length; index++){
        // the distance to add to this glyph is the sum of the space to add
        // after this glyph, and the space to add before the next glyph
        var _f = factors[index];
        var next = factors[index + 1];
        var dist = _f.after * priorities[_f.priority];
        if (next) dist += next.before * priorities[next.priority];
         // if this glyph is unconstrained, add the unconstrained distance as well
        if (_f.unconstrained) {
            dist += _f.after * unconstrained[_f.priority];
            if (next) dist += next.before * unconstrained[next.priority];
        }
        distances.push(dist);
    }
    return distances;
};
var _default = getDistances;
exports["default"] = _default;

},{}],"4GBoE":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cb9fae61502dca00");
var _interopRequireWildcard = require("8b31476572f16abe");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("7c87ad52b0a9445e"));
var _ascent = _interopRequireDefault(require("54d64c4d5dada8a7"));
var _ascent2 = _interopRequireDefault(require("2308a0ab293c492b"));
var _advanceWidth = _interopRequireDefault(require("b6e6f6cc644f33f1"));
var _advanceWidth2 = _interopRequireDefault(require("b8829660d8396dea"));
// The base font size used for calculating underline thickness.
var BASE_FONT_SIZE = 12;
/**
 * Computes the intersections between an underline and the glyphs in
 * a line fragment. Returns an array of DecorationLines omitting the
 * intersections.
 */ // const intersectWithGlyphs = (line, lineFragment) => {
//   // Find intersection ranges between underline and glyphs
//   let x = 0;
//   let y = lineFragment.ascent;
//   const ranges = [];
//   for (const run of lineFragment.runs) {
//     if (!run.attributes.underline) {
//       x += run.advanceWidth;
//       continue;
//     }
//     for (let i = 0; i < run.glyphs.length; i++) {
//       const position = run.positions[i];
//       if (x >= line.rect.x && x <= line.rect.maxX) {
//         const gx = x + position.xOffset;
//         const gy = y + position.yOffset;
//         // Standard fonts may not have a path to intersect with
//         if (run.glyphs[i].path) {
//           const path = run.glyphs[i].path.scale(run.scale, -run.scale).translate(gx, gy);
//           const range = findPathIntersections(path, line.rect);
//           if (range) {
//             ranges.push(range);
//           }
//         }
//       }
//       x += position.xAdvance;
//       y += position.yAdvance;
//     }
//   }
//   if (ranges.length === 0) {
//     // No intersections. Return the original line.
//     return [line];
//   }
//   const merged = Range.merge(ranges);
//   // Generate underline segments omitting the intersections,
//   // but only if the space warrents an underline.
//   const lines = [];
//   x = line.rect.x;
//   for (const { start, end } of merged) {
//     if (start - x > line.rect.height) {
//       lines.push(line.slice(x, start));
//     }
//     x = end;
//   }
//   if (line.rect.maxX - x > line.rect.height) {
//     lines.push(line.slice(x, line.rect.maxX));
//   }
//   return lines;
// };
// const findIntersectionPoint = (y, x1, y1, x2, y2, range) => {
//   if ((y1 < y && y2 > y) || (y1 > y && y2 < y)) {
//     const x = x1 + ((y - y1) * (x2 - x1)) / (y2 - y1);
//     range.extend(x);
//   }
// };
/**
 * Finds the intersections between a glyph path and an underline rectangle.
 * It models each contour of the path a straight line, and returns a range
 * containing the leftmost and rightmost intersection points, if any.
 */ // const findPathIntersections = (path, rect) => {
//   let sx = 0;
//   let sy = 0;
//   let cx = 0;
//   let cy = 0;
//   let px = 0;
//   let py = 0;
//   const range = new Range(Infinity, -Infinity);
//   const y1 = rect.y;
//   const y2 = rect.maxY;
//   const dialation = Math.ceil(rect.height);
//   for (const { command, args } of path.commands) {
//     switch (command) {
//       case 'moveTo':
//         sx = cx = args[0];
//         sy = cy = args[1];
//         continue;
//       case 'lineTo':
//         px = args[0];
//         py = args[1];
//         break;
//       case 'quadraticCurveTo':
//         px = args[2];
//         py = args[3];
//         break;
//       case 'bezierCurveTo':
//         px = args[4];
//         py = args[5];
//         break;
//       case 'closePath':
//         px = sx;
//         py = sy;
//         break;
//       default:
//         break;
//     }
//     findIntersectionPoint(y1, cx, cy, px, py, range);
//     findIntersectionPoint(y2, cx, cy, px, py, range);
//     if ((cy >= y1 && cy <= y2) || (cy <= y1 && cy >= y2)) {
//       range.extend(cx);
//     }
//     cx = px;
//     cy = py;
//   }
//   if (range.start < range.end) {
//     range.start -= dialation;
//     range.end += dialation;
//     return range;
//   }
//   return null;
// };
/**
 * A TextDecorationEngine is used by a Typesetter to generate
 * DecorationLines for a line fragment, including underlines
 * and strikes.
 */ var textDecoration = function textDecoration() {
    return function(lineFragment) {
        var x = R.propOr(0, 'overflowLeft', lineFragment);
        var overflowRight = R.propOr(0, 'overflowRight', lineFragment);
        var maxX = (0, _advanceWidth2["default"])(lineFragment) - overflowRight;
        lineFragment.decorationLines = [];
        for(var _iterator = lineFragment.runs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var run = _ref;
            var width = Math.min(maxX - x, (0, _advanceWidth["default"])(run));
            var thickness = Math.max(0.5, Math.floor(run.attributes.fontSize / BASE_FONT_SIZE));
            if (run.attributes.underline) {
                var rect = {
                    x: x,
                    y: (0, _ascent2["default"])(lineFragment) + thickness * 2,
                    width: width,
                    height: thickness
                };
                var line = {
                    rect: rect,
                    opacity: run.attributes.opacity,
                    color: run.attributes.underlineColor || 'black',
                    style: run.attributes.underlineStyle || 'solid'
                };
                lineFragment.decorationLines.push(line);
            }
            if (run.attributes.strike) {
                var y = (0, _ascent2["default"])(lineFragment) - (0, _ascent["default"])(run) / 3;
                var _rect = {
                    x: x,
                    y: y,
                    width: width,
                    height: thickness
                };
                var _line = {
                    rect: _rect,
                    opacity: run.attributes.opacity,
                    color: run.attributes.strikeColor || 'black',
                    style: run.attributes.strikeStyle || 'solid'
                };
                lineFragment.decorationLines.push(_line);
            }
            x += width;
        } // Adjust underline y positions, and intersect with glyph descenders.
        // for (const line of underlines) {
        //   lineFragment.decorationLines.push(...intersectWithGlyphs(line, lineFragment));
        // }
        return lineFragment;
    };
};
var _default = textDecoration;
exports["default"] = _default;

},{"cb9fae61502dca00":"kZ6eK","8b31476572f16abe":"fiRIh","7c87ad52b0a9445e":"lzfqX","54d64c4d5dada8a7":"1j5S7","2308a0ab293c492b":"1ijen","b6e6f6cc644f33f1":"1J9lT","b8829660d8396dea":"bqw7C"}],"a5Law":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("35cbe32cc4ef6a86");
var _interopRequireWildcard = require("91736ce6f792989b");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("2aae488983213436"));
var _unicodeProperties = _interopRequireDefault(require("a21ae48f290f77e4"));
var _empty = _interopRequireDefault(require("a995827ed2ca2c59"));
var ignoredScripts = [
    'Common',
    'Inherited',
    'Unknown'
];
/**
 * Resolves unicode script in runs, grouping equal runs together
 *
 * @param  {Object}  layout options
 * @param  {Object}  attributed string
 * @return {Object} attributed string
 */ var scriptItemizer = function scriptItemizer(options, attributedString) {
    var string = attributedString.string;
    var lastScript = 'Unknown';
    var lastIndex = 0;
    var index = 0;
    var res = [];
    if (!string) return (0, _empty["default"])();
    for(var _iterator = string, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
        var _ref;
        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }
        var _char = _ref;
        var codePoint = _char.codePointAt();
        var script = _unicodeProperties["default"].getScript(codePoint);
        if (script !== lastScript && !ignoredScripts.includes(script)) {
            if (lastScript !== 'Unknown') res.push({
                start: lastIndex,
                end: index,
                attributes: {
                    script: lastScript
                }
            });
            lastIndex = index;
            lastScript = script;
        }
        index += _char.length;
    }
    if (lastIndex < string.length) res.push({
        start: lastIndex,
        end: string.length,
        attributes: {
            script: lastScript
        }
    });
    return {
        string: string,
        runs: res
    };
};
var _default = R.curryN(2, scriptItemizer);
exports["default"] = _default;

},{"35cbe32cc4ef6a86":"kZ6eK","91736ce6f792989b":"fiRIh","2aae488983213436":"lzfqX","a21ae48f290f77e4":"itgDl","a995827ed2ca2c59":"bJOOn"}],"iB4R0":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c61d84b5b7c44ac2");
var _interopRequireWildcard = require("cebc6522da02aac9");
exports.__esModule = true;
exports["default"] = void 0;
var R = _interopRequireWildcard(require("b6470a03eec649a2"));
var _hyphen = _interopRequireDefault(require("3a4e7f4fd4eca4cd"));
var _enUs = _interopRequireDefault(require("b186772ff263b1e7"));
var SOFT_HYPHEN = "\xAD";
var hyphenator = (0, _hyphen["default"])(_enUs["default"]);
var splitHyphen = R.split(SOFT_HYPHEN);
var cache = {};
var getParts = R.ifElse(R.contains(SOFT_HYPHEN), splitHyphen, R.o(splitHyphen, hyphenator));
var wordHyphenation = function wordHyphenation(options, word) {
    if (R.isNil(word)) return [];
    if (cache[word]) return cache[word];
    cache[word] = getParts(word);
    return cache[word];
};
var _default = R.curryN(2, wordHyphenation);
exports["default"] = _default;

},{"c61d84b5b7c44ac2":"kZ6eK","cebc6522da02aac9":"fiRIh","b6470a03eec649a2":"lzfqX","3a4e7f4fd4eca4cd":"95PsD","b186772ff263b1e7":"gHVwa"}],"95PsD":[function(require,module,exports,__globalThis) {
var global = arguments[3];
/** Text hyphenation in Javascript.
 *  Copyright (C) 2024 Yevhen Tiurin (yevhentiurin@gmail.com)
 *  https://github.com/ytiurin/hyphen
 *
 *  Released under the ISC license
 *  https://github.com/ytiurin/hyphen/blob/master/LICENSE
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.createHyphenator = factory();
})(this, function() {
    function createTextReader(setup) {
        var char1 = "";
        var char2 = "";
        var i = 0;
        var verifier = setup();
        return function(text) {
            while(i < text.length){
                char1 = text.charAt(i++);
                char2 = text.charAt(i);
                var verified = verifier(char1, char2);
                if (verified !== void 0) return verified;
            }
        };
    }
    var isNotLetter = RegExp.prototype.test.bind(/\s|(?![\'])[\!-\@\[-\`\{-\~\u2013-\u203C]/);
    function createHTMLVerifier() {
        var skip = false;
        return function(accumulate, chars) {
            if (skip) {
                if (chars[0] === ">") {
                    accumulate();
                    skip = false;
                }
            } else if (chars[0] === "<" && (!isNotLetter(chars[1]) || chars[1] === "/")) skip = true;
            return skip;
        };
    }
    function createHyphenCharVerifier(hyphenChar) {
        var skip = false;
        return function(accumulate, chars) {
            if (skip) {
                if (!isNotLetter(chars[0]) && isNotLetter(chars[1])) {
                    accumulate();
                    skip = false;
                }
            } else if (!isNotLetter(chars[0]) && chars[1] === hyphenChar) skip = true;
            return skip;
        };
    }
    function createHyphenationVerifier(verifiers, minWordLength) {
        return function() {
            var accum0 = "";
            var accum = "";
            function accumulate() {
                accum0 += accum;
                accum = "";
            }
            function resolveWith(value) {
                accum0 = "";
                accum = "";
                return value;
            }
            return function(char1, char2) {
                accum += char1;
                var skip = verifiers.reduce(function(skip2, verify) {
                    return skip2 || verify(accumulate, [
                        char1,
                        char2
                    ]);
                }, false);
                if (!skip) {
                    if (isNotLetter(char1) && !isNotLetter(char2)) accumulate();
                    if (!isNotLetter(char1) && isNotLetter(char2)) {
                        if (accum.length >= minWordLength) return resolveWith([
                            accum0,
                            accum
                        ]);
                        else accumulate();
                    }
                }
                if (char2 === "") {
                    if (accum.length < minWordLength || skip) accumulate();
                    return resolveWith([
                        accum0,
                        accum
                    ]);
                }
            };
        };
    }
    function createCharIterator(str) {
        var i = 0;
        function nextChar() {
            return str[i++];
        }
        return nextChar;
    }
    function createStringSlicer(str) {
        var i = 0, slice = str;
        function next() {
            slice = str.slice(i++);
            if (slice.length < 3) return;
            return slice;
        }
        function isFirstCharacter() {
            return i === 2;
        }
        return [
            next,
            isFirstCharacter
        ];
    }
    function hyphenateWord(text, levelsTable, patternTrie, debug, hyphenChar) {
        var levels = new Array(text.length + 1), loweredText = ("." + text.toLocaleLowerCase() + ".").split(""), wordSlice, letter, triePtr, trieNode, patternLevelsIndex, patternLevels, patternEntityIndex = -1, slicer, nextSlice, isFirstCharacter, nextLetter;
        for(var i = levels.length; i--;)levels[i] = 0;
        slicer = createStringSlicer(loweredText);
        nextSlice = slicer[0];
        isFirstCharacter = slicer[1];
        while(wordSlice = nextSlice()){
            patternEntityIndex++;
            if (isFirstCharacter()) patternEntityIndex--;
            triePtr = patternTrie;
            nextLetter = createCharIterator(wordSlice);
            while(letter = nextLetter()){
                if ((trieNode = triePtr[letter]) === void 0) break;
                triePtr = {};
                patternLevelsIndex = -1;
                switch(Object.prototype.toString.call(trieNode)){
                    case "[object Array]":
                        triePtr = trieNode[0];
                        patternLevelsIndex = trieNode[1];
                        break;
                    case "[object Object]":
                        triePtr = trieNode;
                        break;
                    case "[object Number]":
                        patternLevelsIndex = trieNode;
                        break;
                }
                if (patternLevelsIndex < 0) continue;
                if (!levelsTable[patternLevelsIndex].splice) levelsTable[patternLevelsIndex] = levelsTable[patternLevelsIndex].slice("");
                patternLevels = levelsTable[patternLevelsIndex];
                for(var k = 0; k < patternLevels.length; k++)levels[patternEntityIndex + k] = Math.max(patternLevels[k], levels[patternEntityIndex + k]);
            }
        }
        levels[0] = levels[1] = levels[levels.length - 1] = levels[levels.length - 2] = 0;
        var hyphenatedText = "";
        for(var i = 0; i < levels.length; i++)hyphenatedText += (levels[i] % 2 === 1 ? hyphenChar : "") + text.charAt(i);
        return hyphenatedText;
    }
    function start(text, levelsTable, patterns, cache, debug, hyphenChar, skipHTML, minWordLength, isAsync) {
        function done() {
            resolveNewText(newText);
        }
        var newText = "", fragments, readText = createTextReader(createHyphenationVerifier((skipHTML ? [
            createHTMLVerifier()
        ] : []).concat(createHyphenCharVerifier(hyphenChar)), minWordLength)), resolveNewText = function() {};
        function nextTick() {
            var loopStart = /* @__PURE__ */ new Date();
            while((!isAsync || /* @__PURE__ */ new Date() - loopStart < 10) && (fragments = readText(text))){
                if (fragments[1]) {
                    var cacheKey = fragments[1].length ? "~" + fragments[1] : "";
                    if (cache[cacheKey] === void 0) cache[cacheKey] = hyphenateWord(fragments[1], levelsTable, patterns, debug, hyphenChar);
                    fragments[1] = cache[cacheKey];
                }
                newText += fragments[0] + fragments[1];
            }
            if (!fragments) done();
            else setTimeout(nextTick);
        }
        if (isAsync) {
            setTimeout(nextTick);
            return new Promise(function(resolve) {
                resolveNewText = resolve;
            });
        } else {
            nextTick();
            return newText;
        }
    }
    var SETTING_DEFAULT_ASYNC = false;
    var SETTING_DEFAULT_DEBUG = false;
    var SETTING_DEFAULT_EXCEPTIONS = [];
    var SETTING_DEFAULT_HTML = true;
    var SETTING_DEFAULT_HYPH_CHAR = "\xAD";
    var SETTING_DEFAULT_MIN_WORD_LENGTH = 5;
    var SETTING_NAME_ASYNC = "async";
    var SETTING_NAME_DEBUG = "debug";
    var SETTING_NAME_EXCEPTIONS = "exceptions";
    var SETTING_NAME_HTML = "html";
    var SETTING_NAME_HYPH_CHAR = "hyphenChar";
    var SETTING_NAME_MIN_WORD_LENGTH = "minWordLength";
    var _global = typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : {};
    function extend(target, source) {
        target = target || {};
        for(var key in source)target[key] = source[key];
        return target;
    }
    function validateArray(value) {
        return value instanceof Array;
    }
    function keyOrDefault(object, key, defaultValue, test) {
        if (key in object && (test ? test(object[key]) : true)) return object[key];
        return defaultValue;
    }
    function exceptionsFromDefinition(excetionsList, hyphenChar) {
        return excetionsList.reduce(function(exceptions, exception) {
            exceptions["~" + exception.replace(/\-/g, "")] = exception.replace(/\-/g, hyphenChar);
            return exceptions;
        }, {});
    }
    function createHyphenator(patternsDefinition, options) {
        options = options || {};
        var asyncMode = keyOrDefault(options, SETTING_NAME_ASYNC, SETTING_DEFAULT_ASYNC), caches = {}, debug = keyOrDefault(options, SETTING_NAME_DEBUG, SETTING_DEFAULT_DEBUG), exceptions = {}, hyphenChar = keyOrDefault(options, SETTING_NAME_HYPH_CHAR, SETTING_DEFAULT_HYPH_CHAR), levelsTable = patternsDefinition[0].split(","), patterns = JSON.parse(patternsDefinition[1]), minWordLength = keyOrDefault(options, SETTING_NAME_MIN_WORD_LENGTH, SETTING_DEFAULT_MIN_WORD_LENGTH) >> 0, skipHTML = keyOrDefault(options, SETTING_NAME_HTML, SETTING_DEFAULT_HTML), userExceptions = keyOrDefault(options, SETTING_NAME_EXCEPTIONS, SETTING_DEFAULT_EXCEPTIONS, validateArray);
        var cacheKey = hyphenChar + minWordLength;
        exceptions[cacheKey] = {};
        if (patternsDefinition[2]) exceptions[cacheKey] = exceptionsFromDefinition(patternsDefinition[2], hyphenChar);
        if (userExceptions && userExceptions.length) exceptions[cacheKey] = extend(exceptions[cacheKey], exceptionsFromDefinition(userExceptions, hyphenChar));
        caches[cacheKey] = extend({}, exceptions[cacheKey]);
        if (asyncMode && !("Promise" in _global)) throw new Error("Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode");
        return function(text, options2) {
            options2 = options2 || {};
            var localDebug = keyOrDefault(options2, SETTING_NAME_DEBUG, debug), localHyphenChar = keyOrDefault(options2, SETTING_NAME_HYPH_CHAR, hyphenChar), localMinWordLength = keyOrDefault(options2, SETTING_NAME_MIN_WORD_LENGTH, minWordLength) >> 0, localUserExceptions = keyOrDefault(options2, SETTING_NAME_EXCEPTIONS, SETTING_DEFAULT_EXCEPTIONS, validateArray), cacheKey2 = localHyphenChar + localMinWordLength;
            if (!exceptions[cacheKey2] && patternsDefinition[2]) {
                exceptions[cacheKey2] = exceptionsFromDefinition(patternsDefinition[2], localHyphenChar);
                caches[cacheKey2] = extend(caches[cacheKey2], exceptions[cacheKey2]);
            }
            if (localUserExceptions && localUserExceptions.length) {
                exceptions[cacheKey2] = extend(exceptions[cacheKey2], exceptionsFromDefinition(localUserExceptions, localHyphenChar));
                caches[cacheKey2] = extend(caches[cacheKey2], exceptions[cacheKey2]);
            }
            return start(text, levelsTable, patterns, caches[cacheKey2], localDebug, localHyphenChar, skipHTML, localMinWordLength, asyncMode);
        };
    }
    return createHyphenator;
});

},{}],"gHVwa":[function(require,module,exports,__globalThis) {
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, module.exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
    else // Browser globals (root is window)
    root.hyphenationPatternsEnUs = factory();
})(this, function() {
    return [
        "0004,004,001,003,005,0005,00005,000005,0002,002,0000005,0003,00003,00505,00034,0001,00055,00004,4,05,0055,04,42,03,02,2,404,3,044,01,0505,55,5,045,041,0033,000004,22,00504,5504,0042,1,21,41,402,405,4004,43,23,000054,303,3005,022,5004,000003,252,45,25,2004,000505,054,403,401,3002,0025,144,432,00054,34,12,234,0022,014,0304,012,143,503,0403,101,052,414,212,011,043,00002,0041,0024,05005,03003,00102,0404,04303,01004,0034,025,0044,00404,00025,0103,042,0205,412,104,54,344,433,5005,253,055,0402,3004,0043,204,505,454,0000004,00303,04004,552,201,4005,0255,52,444,14,44,02004,033,05004,00045,00013,0021,0405,00044,0054,50055,000303,00001,304,0204,11,301,232,122,00305,504,000043,0104,00052,000045,50004,0023,00033,00032,00202,5003,202,0401,0000505,214,102,032,000161,004101,00501,00301,0036,0052,00023,006101,006,00401,000521,0014,0063,00012,000501,000006,000604,000601,005001,005005,0010305,00006,003012,003005,0003011,0061,013,000021,000022,000105,00211,00062,00051,000112,006013,000011,0200306,1021,0050001,003003,2102,305,000015,01030005,000035,001011,00021,16330001,0234,030006,5020001,000001,00016,0031,021,21431,002305,0350014,0000012,000063,00101,106,105,00435,00063,0300061,00041,100306,003602,023,0503,0010011,10003,1005,30011,00031,0001001,0000061,0030003,30305,001201,0301,5000101,500101,00015,000401,000065,000016,0000402,0500002,000205,030201,500301,00014,5001,000002,00030011,01034,0300006,030213,00400304,050001,05003,000311,0634,00061,0006,00000604,00050013,00213,0030001,100003,000033,30002,00003632,0003004,050003,0000021,006303,0000006,00005005,30451,03001,00231,00056,00011,6,001001,00500001,03005,503005,0000010001,1002,003001,001065,300001,32011,32,0000003,0213001,0500053,021005,10001,0000011,0001041,0020016,100032,50011,0606,5002,3001,03002,0015001,0102,00003001,000000033,0000001,300101,300015,0101003,00000101,0100501,0101,0010033,00000362,000014,0005001,031",
        '{".":{"a":{"c":{"h":0},"d":{"d":{"e":{"r":1}}},"f":{"t":2},"l":{"t":3},"m":{"a":{"t":4}},"n":{"c":4,"g":0,"i":{"m":5},"t":[{"e":3,"i":{"s":6}},0]},"r":{"s":4,"t":{"i":{"e":1},"y":1}},"s":{"c":3,"p":2,"s":2,"t":{"e":{"r":7}}},"t":{"o":{"m":6}},"u":{"d":2},"v":{"i":1},"w":{"n":0}},"b":{"a":{"g":1,"n":{"a":4},"s":{"e":0}},"e":{"r":[{"a":4},0],"s":{"m":3,"t":{"o":4}}},"r":{"i":8},"u":{"t":{"t":{"i":0}}}},"c":{"a":{"m":{"p":{"e":0}},"n":{"c":5},"p":{"a":{"b":6}},"r":{"o":{"l":5}},"t":1},"e":{"l":{"a":1}},"h":[{"i":{"l":{"l":{"i":7}}}},1],"i":[{"t":{"r":5}},9],"o":{"e":3,"r":[{"n":{"e":{"r":5}}},1],"n":{"g":{"r":5}}}},"d":{"e":{"m":{"o":{"i":1}},"o":3,"r":{"a":3,"i":[{"v":{"a":4}},3]},"s":{"c":0}},"i":{"c":{"t":{"i":{"o":10}}}},"o":{"t":1},"u":{"c":1,"m":{"b":6}},"r":{"i":{"v":67}}},"e":{"a":{"r":{"t":{"h":7}},"s":{"i":11}},"b":1,"e":{"r":0},"g":9,"l":{"d":4,"e":{"m":3}},"n":{"a":{"m":12},"g":3,"s":3},"q":{"u":{"i":{"t":13}}},"r":{"r":{"i":1}},"s":3,"u":[{"l":{"e":{"r":1}}},3],"y":{"e":5},"t":{"h":{"y":{"l":162}}},"v":[{"e":{"r":{"s":{"i":{"b":158}}}}},9]},"f":{"e":{"s":11},"o":{"r":{"m":{"e":{"r":5}}}}},"g":{"a":[{"s":{"o":{"m":163}}},9],"e":[{"n":{"t":14},"o":{"g":4,"m":{"e":1},"t":164}},9],"i":{"a":4,"b":1},"o":{"r":1}},"h":{"a":{"n":{"d":{"i":6},"k":5}},"e":[{"r":{"o":{"i":6,"e":3}},"s":11,"t":11,"m":{"o":165},"p":{"a":166}},9],"i":{"b":3,"e":{"r":3}},"o":{"n":{"e":{"y":5},"o":11},"v":5}},"i":{"d":{"l":1,"o":{"l":12}},"m":{"m":3,"p":{"i":{"n":4}}},"n":[{"c":{"i":3},"e":8,"k":9,"s":3,"u":{"t":167}},2],"r":{"r":4},"s":{"i":1}},"j":{"u":{"r":3}},"l":{"a":{"c":{"y":1},"m":1,"t":{"e":{"r":5},"h":6}},"e":[{"g":{"e":5},"n":0,"p":5,"v":15,"i":{"c":{"e":{"s":170}}}},9],"i":{"g":[{"a":5},1],"n":9,"o":3,"t":1}},"m":{"a":{"g":{"a":16},"l":{"o":5},"n":{"a":5},"r":{"t":{"i":5}}},"e":[{"r":{"c":11},"t":{"e":{"r":4},"a":{"l":{"a":0}}},"g":{"a":{"l":171}}},9],"i":{"s":[{"t":{"i":6},"e":{"r":{"s":173}}},15],"m":{"i":{"c":172}}},"o":{"n":{"e":11},"r":{"o":3}},"u":{"t":{"a":[{"b":6},4]}}},"n":{"i":{"c":1},"e":{"o":{"f":174}},"o":{"e":{"t":{"h":15}},"n":{"e":{"m":175}}}},"o":{"d":[{"d":5},9],"f":{"t":{"e":4}},"r":{"a":{"t":{"o":4}},"c":3,"d":2,"t":3},"s":[{"t":{"l":1}},3],"t":{"h":11},"u":{"t":11}},"p":{"e":{"d":{"a":{"l":5}},"t":{"e":4,"i":{"t":4}}},"i":{"e":1,"o":{"n":5},"t":9},"r":{"e":{"m":11,"a":{"m":15}}},"o":{"l":{"y":{"s":137}},"s":{"t":{"a":{"m":137}}}}},"r":{"a":{"c":1,"n":{"t":0},"t":{"i":{"o":{"n":{"a":7}}}},"v":{"e":{"n":{"o":176}}}},"e":{"e":[{"c":173},8],"m":{"i":{"t":4}},"s":[{"t":{"a":{"t":4}}},8]},"i":{"g":1,"t":{"u":5}},"o":{"q":1,"s":{"t":5},"w":{"d":5}},"u":{"d":1}},"s":{"c":{"i":{"e":11}},"e":{"l":{"f":6,"l":6},"n":9,"r":{"i":{"e":4}},"m":{"i":[{"c":0,"d":177,"p":36,"r":36,"s":178,"v":36},6]}},"h":9,"i":[{"n":{"g":17}},9],"t":[{"a":{"b":{"l":5}}},1],"y":9,"p":{"h":{"i":{"n":179}},"i":{"n":{"o":137}}}},"t":{"a":[{"p":{"e":{"s":{"t":{"r":180}}}}},1],"e":[{"n":{"a":{"n":5}},"l":{"e":{"g":{"r":3}}}},1],"h":9,"i":[{"l":0,"m":{"o":16},"n":{"g":17,"k":5}},9],"o":{"n":{"a":0},"p":[{"i":5,"o":{"g":170}},1],"u":{"s":5},"q":9},"r":{"i":{"b":{"u":{"t":6}}}}},"u":{"n":{"a":[{"t":{"t":144}},2],"c":{"e":3},"d":{"e":{"r":7}},"e":[{"r":{"r":181}},2],"k":4,"o":4,"u":3},"p":3,"r":{"e":11},"s":{"a":4}},"v":{"e":{"n":{"d":{"e":0}},"r":{"a":4}},"i":{"c":{"a":{"r":151}}}},"w":{"i":{"l":{"i":5}},"e":{"b":{"l":131}}},"y":{"e":1},"k":{"i":{"l":{"n":{"i":168}}},"o":{"r":{"t":{"e":169}}}}},"a":{"b":{".":18,"a":{"l":19,"n":19},"e":[{"r":{"d":4}},8],"i":{"a":5,"t":{"a":{"b":13}}},"l":{"a":{"t":4}},"o":{"l":{"i":{"z":20,"c":19}}},"r":[{"o":{"g":4}},18],"u":{"l":3}},"c":{"a":{"r":[{"d":4,"o":4},21],"b":{"l":24}},"e":{"o":{"u":19},"r":2},"h":{"e":{"t":19}},"i":[{"e":23,"n":2,"o":23},22],"r":{"o":{"b":4}},"t":{"i":{"f":5}},"u":{"l":3,"m":1}},"d":[{"d":{"i":{"n":1}},"e":{"r":{".":4}},"i":[{"a":23,"c":{"a":3},"e":{"r":0},"o":23,"t":23,"u":19},25],"l":{"e":1},"o":{"w":3},"r":{"a":{"n":4}},"s":{"u":1},"u":[{"c":23,"m":4},18]},24],"e":{"r":[{"i":{"e":17}},1]},"f":[{"f":[{"i":{"s":{"h":170}}},0]},24],"g":{"a":{"b":21,"n":0},"e":{"l":{"l":4},"o":0,"u":18},"i":2,"l":26,"n":2,"o":[{"g":27,"n":{"i":3}},24],"u":{"e":{"r":19},"l":4},"y":21},"h":{"a":23,"e":23,"l":1,"o":23},"i":[{"a":19,"c":{".":23},"l":{"y":4},"n":[{"i":{"n":5},"o":5},28],"t":{"e":{"n":5}}},9],"j":29,"k":{"e":{"n":2}},"l":{"a":{"b":4,"d":3,"r":21},"d":{"i":18},"e":[{"n":{"d":3,"t":{"i":21}},"o":30},25],"i":[{"a":{".":1},"e":0},2],"l":{"e":{"v":4},"i":{"c":18}},"m":18,"o":{"g":{".":19}},"y":{".":21,"s":[{"t":31},18],"t":32,"z":27}},"m":{"a":[{"b":4,"g":3,"r":{"a":5},"s":{"c":4},"t":{"i":{"s":21},"o":33}},18],"e":{"r":{"a":4},"n":{"t":{"a":{"b":182}}}},"i":{"c":3,"f":4,"l":{"y":4},"n":[{"o":0},2]},"o":[{"n":19,"r":{"i":6}},24],"p":{"e":{"n":5}}},"n":[{"a":{"g":{"e":3},"l":{"y":[{"s":183},27]},"r":[{"c":3,"i":17},23],"t":{"i":23}},"d":[{"e":{"s":17},"i":{"s":3},"l":2,"o":{"w":1}},18],"e":{"e":19,"n":23,"s":{"t":{".":4}},"u":23},"g":[{"i":{"e":5},"l":2},25],"i":{"c":34,"e":{"s":23},"f":35,"m":{"e":1,"i":19},"n":{"e":19},"o":3,"p":23,"s":{"h":3},"t":3,"u":23},"k":{"l":{"i":1}},"n":{"i":{"z":32}},"o":[{"t":[{"h":7},4],"a":{"c":148}},0],"s":{"a":9,"c":{"o":1},"n":1,"p":[{"o":11},9],"t":1,"u":{"r":1},"g":{"r":5},"v":11},"t":{"a":{"l":36},"i":{"e":1,"d":137,"n":184,"r":{"e":137}},"o":18,"r":9,"w":1},"u":{"a":3,"l":3,"r":19}},24],"o":18,"p":{"a":{"r":17,"t":4},"e":{"r":{"o":4},"a":{"b":{"l":{"e":132}}}},"h":{"e":{"r":23},"i":18},"i":{"l":{"l":{"a":[{"r":4},21]}},"n":3,"t":{"a":3,"u":23}},"l":24,"o":{"c":6,"l":{"a":4},"r":{"i":6},"s":{"t":12}},"s":{"e":{"s":5}},"u":23},"q":{"u":{"e":6}},"r":[{"a":{"c":{"t":3},"d":{"e":19,"i":{"s":4}},"l":3,"m":{"e":{"t":{"e":19}}},"n":{"g":17},"p":11,"t":[{"i":{"o":19,"v":4}},1],"u":19,"v":38,"w":17},"b":{"a":{"l":36}},"c":{"h":{"a":{"n":1},"e":{"t":185}}},"d":{"i":{"n":{"e":4}},"r":1},"e":{"a":{"s":4},"e":23,"n":{"t":3},"s":{"s":19}},"f":{"i":1,"l":1},"i":[{"a":{"l":4,"n":3},"e":{"t":23},"m":1,"n":{"a":{"t":4}},"o":3,"z":9},2],"m":{"i":9},"o":{"d":20,"n":{"i":19},"o":23},"p":9,"q":3,"r":{"e":17,"a":{"n":{"g":{"e":9}}}},"s":{"a":1,"h":9}},37],"s":{".":18,"a":{"b":1,"n":{"t":3}},"h":{"i":17},"i":{"a":{".":19},"b":23,"c":23,"t":39},"k":{"i":11},"l":1,"o":{"c":21},"p":{"h":4},"s":{"h":1},"t":{"e":{"n":3},"r":2},"u":{"r":{"a":6}},"y":{"m":{"p":{"t":{"o":{"t":4}}}}}},"t":{"a":[{"b":{"l":3},"c":4,"l":{"o":3},"p":4},24],"e":{"c":[{"h":4},5],"g":{"o":3},"n":{".":3},"r":{"a":3,"n":[{"a":19},6]},"s":{"t":3},"v":4},"h":[{"e":{"m":5,"n":19,"r":{"o":{"s":186}}},"o":[{"m":5},1]},18],"i":{".":18,"a":19,"b":20,"c":2,"f":3,"o":{"n":{"a":{"r":7}}},"t":{"u":3}},"o":{"g":21,"m":[{"i":{"z":4}},24],"p":21,"s":21},"r":[{"o":{"p":4}},29],"s":{"k":1},"t":{"a":{"g":1},"e":[{"s":{".":170}},4],"h":1},"u":[{"a":4,"e":4,"l":3,"r":{"a":3}},24],"y":24},"u":{"b":1,"g":{"h":[{"t":{"l":17}},12],"u":3},"l":[{"i":{"f":13}},40],"n":{"d":5},"r":3,"s":{"i":{"b":4}},"t":{"e":{"n":5},"h":2}},"v":{"a":[{"g":3,"n":19},24],"e":{"n":{"o":0},"r":{"a":3,"n":4,"y":4}},"i":[{"e":{"r":0},"g":3,"o":{"u":3}},2],"o":{"c":4,"r":29}},"w":{"a":{"y":27},"i":3,"l":{"y":1},"s":0},"x":{"i":{"c":1,"d":1}},"y":{"a":{"l":4},"e":0,"s":0},"z":{"i":{"e":{"r":0}},"z":{"i":5}}},"b":{"a":{".":32,"d":{"g":{"e":{"r":5}}},"g":{"e":1},"l":{"a":15},"n":{"d":{"a":{"g":5}},"e":0,"i":11},"r":{"b":{"i":7},"i":{"a":17},"o":{"n":{"i":{"e":187}}}},"s":{"s":{"i":0}},"t":[{"h":{"y":2}},41],"z":1,"c":{"k":{"e":{"r":{".":84}}}}},"b":[{"e":[{"r":23},24],"i":{"n":{"a":0},"t":0}},42],"d":43,"e":{".":18,"a":{"k":17,"t":12},"d":[{"a":3,"e":3,"i":3},44],"g":{"i":3,"u":4},"l":[{"i":2,"o":3},41],"m":45,"n":{"i":{"g":4},"u":4},"s":[{"p":3,"t":{"r":4}},46],"t":[{"i":{"z":5},"r":4,"w":3},27],"w":3,"y":{"o":4},"v":{"i":{"e":9}}},"f":25,"h":47,"i":{"b":9,"d":[{"i":{"f":167}},1],"e":[{"n":4,"r":1},27],"f":48,"l":[{"i":{"z":3},"l":{"a":{"b":8}}},41],"n":{"a":{"r":49},"d":0,"e":{"t":4}},"o":{"g":{"r":3},"u":4,"m":5,"r":{"b":2,"h":15}},"t":[{"i":{"o":50,"v":{"e":188}},"r":3,"u":{"a":51},"z":19},9]},"j":29,"k":1,"l":[{"a":{"t":{"h":7},"n":{"d":189}},"e":{".":21,"n":17,"s":{"p":32}},"i":{"s":23,"n":{"d":189}},"o":[{"n":{"d":190}},21],"u":{"n":{"t":17}}},52],"m":43,"n":[{"e":{"g":5}},47],"o":{"d":[{"i":11},27],"e":1,"l":{"i":{"c":11}},"m":{"b":{"i":0}},"n":{"a":[{"t":5},0]},"o":27,"r":{".":32,"a":43,"d":5,"e":32,"i":32,"n":{"o":191}},"s":53,"t":{"a":19,"h":6,"o":1,"u":{"l":192}},"u":{"n":{"d":54}}},"p":18,"r":{"i":{"t":18},"o":{"t":{"h":54}},"u":{"s":{"q":17}}},"s":[{"o":{"r":17}},55],"t":[{"l":1,"o":21,"r":23},25],"u":{"f":{"f":{"e":{"r":0}}},"g":{"a":1},"l":{"i":3},"m":{"i":17},"n":[{"t":{"i":17}},1],"r":{"e":3},"s":{"i":{"e":[{"r":193,"s":193},5]},"s":{"e":17,"i":{"n":{"g":17}}},"t":32},"t":{"a":18,"i":{"o":27},"o":19,"e":{"d":{".":8}},"t":{"e":{"d":0}}}},"v":29,"w":56,"y":{".":32,"s":0}},"c":{"a":[{"b":{"i":{"n":11},"l":2},"c":{"h":17},"d":{"e":{"n":4,"m":194}},"g":46,"h":57,"l":{"a":{"t":3},"l":{"a":0,"i":{"n":6}},"o":18},"n":{"d":5,"e":0,"i":{"c":0,"s":5,"z":11},"t":{"y":0},"y":17},"p":{"e":{"r":4}},"r":{"o":{"m":5}},"s":{"t":{"e":{"r":6},"i":{"g":5}},"y":18},"t":{"h":1,"i":{"v":18},"a":{"s":195}},"v":{"a":{"l":5}}},41],"c":[{"h":{"a":6},"i":{"a":0},"o":{"m":{"p":{"a":10}},"n":17,"u":{"t":12}}},23],"e":{".":25,"d":{".":18,"e":{"n":18}},"i":27,"l":{".":32,"l":27},"n":[{"c":27,"e":58,"i":18,"t":27},41],"p":27,"r":{"a":{"m":4}},"s":{"a":18,"s":{"i":[{"b":59},27]},"t":5},"t":[{"a":60},0],"w":0},"h":[{".":18,"a":{"b":61,"n":{"i":{"c":32,"s":20}}},"e":[{"a":{"p":54},"d":18,"l":{"o":5},"m":{"i":27},"n":{"e":4},"r":{".":3,"s":3}},8],"i":{"n":[{"e":{".":32,"s":{"s":4}},"i":32},62],"o":32,"t":27,"z":8,"e":{"v":{"o":6}}},"o":63,"t":{"i":1},"s":{".":18,"h":{"u":11}}},25],"i":[{"a":[{"b":64,"r":5},27],"c":4,"e":{"r":18},"f":{"i":{"c":{".":32}}},"i":18,"l":{"a":1,"i":27},"m":25,"n":[{"a":[{"t":27},21],"e":{"m":11},"g":[{".":19},29],"o":32,"q":8},25],"o":{"n":17},"p":{"e":18,"h":3,"i":{"c":18}},"s":{"t":{"a":18,"i":18}},"t":[{"i":{"z":11}},42],"z":32,"g":{"a":{"r":152}}},41],"k":[{"i":3},2],"l":[{"a":{"r":[{"a":{"t":{"i":{"o":19}}},"e":32},18]},"e":{"m":0,"a":{"r":0}},"i":{"c":18,"m":17},"y":0},65],"n":19,"o":[{"a":{"g":4},"e":8,"g":[{"r":1},25],"i":[{"n":{"c":3}},0],"l":{"i":5,"o":[{"r":11},32]},"m":{"e":{"r":5}},"n":{"a":0,"e":21,"g":11,"t":5},"p":{"a":3,"i":{"c":11},"l":1,"h":{"o":{"n":196}}},"r":{"b":18,"o":{"n":12}},"s":{"e":0},"v":[{"e":17},15],"w":{"a":5},"z":{"e":5,"i":4},"u":{"s":{"t":{"i":84}}}},41],"q":29,"r":{"a":{"s":{"t":6},"t":{".":32,"i":{"c":32}}},"e":{"a":{"t":11},"d":32,"t":{"a":47},"v":0},"i":[{"f":5,"n":21,"s":17,"t":{"i":[{"e":11},32]}},8],"o":{"p":{"l":0,"o":6},"s":{"e":17},"c":{"o":{"d":197}},"e":{"c":{"o":148}}},"u":{"d":0}},"s":66,"t":[{"a":{"b":0,"n":{"g":4,"t":19}},"e":[{"r":23},24],"i":{"c":{"u":21},"m":{"i":12}},"u":{"r":0},"w":21,"r":{"o":{"m":{"e":{"c":198}}}}},42],"u":{"d":5,"f":21,"i":[{"t":{"y":4}},21],"l":{"i":32,"t":{"i":{"s":0},"u":27}},"m":{"a":9,"e":23,"i":1},"n":27,"p":{"i":3,"y":4},"r":{"a":{"b":67,"n":{"c":{"e":199}}},"i":{"a":4}},"s":[{"s":{"i":17}},41],"t":[{"i":{"e":1,"v":56},"r":18},68]},"y":41,"z":{"e":0}},"d":{"a":[{".":32,"b":70,"c":{"h":17},"f":18,"g":25,"m":71,"n":{"g":11},"r":{"d":6,"k":6,"y":18},"t":[{"i":{"v":18},"o":18,"a":{"b":137}},27],"v":[{"e":5},53],"y":32,"l":{"o":{"n":{"e":48}}}},69],"b":29,"c":19,"d":[{"a":{"b":20},"i":{"b":94}},72],"e":{".":25,"a":{"f":6,"l":{"s":{".":1}}},"b":{"i":{"t":5},"o":{"n":1}},"c":{"a":{"n":36},"i":{"l":1},"o":{"m":4},"l":{"a":{"r":200},"i":{"n":{"a":64}}}},"d":42,"e":{".":18},"i":{"f":4},"l":{"i":{"e":17,"q":16},"o":4},"m":[{".":32,"i":{"c":[{".":5},27],"l":4},"o":{"n":{"s":1},"r":7,"s":9}},21],"n":[{"a":{"r":1},"o":3,"t":{"i":{"f":7}},"u":3},41],"p":[{"a":3,"i":17,"u":9},2],"q":23,"r":{"h":21,"m":32,"n":{"i":{"z":6}},"s":5},"s":[{".":24,"c":2,"o":64,"t":{"i":11,"r":3},"u":1,"i":{"c":11}},8],"t":[{"o":9,"i":{"c":9}},2],"v":[{"i":{"l":11}},2],"y":18,"f":{"i":{"n":{"i":{"t":{"i":201}}}}}},"f":43,"g":{"a":21,"e":{"t":73},"i":2,"y":24},"h":74,"i":{".":32,"a":[{"b":5},75],"c":{"a":{"m":1,"i":{"d":15}},"e":21,"t":27},"d":27,"e":{"n":76},"f":[{"f":{"r":{"a":5}}},29],"g":{"e":3},"l":{"a":{"t":{"o":1}}},"n":[{"a":41,"e":{".":27},"i":[{"z":4},32]},29],"o":[{"g":5},41],"p":{"l":1},"r":[{"e":[{"n":9,"r":9},2],"t":{"i":6}},8],"s":[{"i":32,"t":77},15],"t":{"i":24},"v":78,"m":{"e":{"t":{"h":{"y":141}}}}},"j":29,"k":79,"l":{"a":56,"e":{".":27,"d":27,"s":{".":27,"s":18},"a":{"d":42}},"o":48,"u":56,"y":25,"i":{"e":202}},"m":29,"n":80,"o":[{".":27,"d":{"e":4},"e":32,"f":57,"g":21,"l":{"a":1,"i":17,"o":{"r":4}},"m":{"i":{"z":5}},"n":{"a":{"t":3},"i":17},"o":{"d":11},"p":{"p":0},"r":21,"s":27,"u":{"t":56},"v":1,"x":27,"w":{"o":{"r":{"d":203}}}},41],"p":29,"r":[{"a":{"g":{"o":{"n":6}},"i":18},"e":[{"a":{"r":6},"n":[{"a":{"l":204}},32]},0],"i":{"b":0,"l":17,"f":{"t":{"a":189}},"p":{"l":{"e":{"g":205}}}},"o":{"p":0,"w":18,"m":{"e":{"d":206}}},"u":{"p":{"l":{"i":32}}},"y":18},41],"s":[{"p":1,"w":21,"y":21},81],"t":{"h":24,"a":{"b":23}},"u":[{"a":[{"l":{".":9}},82],"c":[{"a":29,"e":{"r":5},"t":{".":18,"s":18}},9],"e":{"l":4},"g":1,"l":{"e":23},"m":{"b":{"e":0}},"n":1,"p":[{"e":1},18],"o":{"p":{"o":{"l":207}}}},41],"v":29,"w":29,"y":[{"n":32,"s":{"e":1,"p":5}},24]},"e":{"a":{"b":72,"c":{"t":23},"d":[{"i":{"e":5}},15],"g":{"e":[{"r":4},1]},"l":[{"e":{"r":5},"o":{"u":11}},1],"m":{"e":{"r":11}},"n":{"d":19,"i":{"e":{"s":111}}},"r":{"a":11,"c":0,"e":{"s":5},"i":{"c":0,"l":0},"k":5,"t":[{"e":12},8]},"s":{"p":4,"s":23,"t":12},"t":[{"e":{"n":5},"h":{"i":12},"i":{"f":19},"u":83},9],"v":[{"e":{"n":11},"i":5,"o":5},9]},"b":[{"e":{"l":{".":21,"s":21},"n":21},"i":{"t":21},"r":23},42],"c":{"a":{"d":21,"n":{"c":6}},"c":{"a":6},"e":[{"s":{"s":{"a":4}}},29],"i":[{"b":21,"f":{"i":{"c":{"a":{"t":4}},"e":4},"y":4},"m":3,"t":[{"e":19},0]},9],"l":{"a":{"m":21},"u":{"s":21}},"o":{"l":24,"m":{"m":21,"p":{"e":21}},"n":{"c":21},"r":[{"a":3,"o":5},24]},"r":[{"e":{"m":21}},29],"t":{"a":{"n":1},"e":1},"u":[{"l":[{"a":3},21]},29],"h":{"a":{"s":23}}},"d":{"a":37,"d":61,"e":{"r":34,"s":0},"i":[{"a":23,"b":3,"c":{"a":3},"m":3,"t":2,"z":5},18],"o":[{"l":21,"n":84},18],"r":{"i":21},"u":{"l":[{"o":4,"i":{"n":{"g":2}}},21]},"g":{"l":15}},"e":{"c":9,"d":{"i":11},"f":9,"l":{"i":11,"y":1},"m":9,"n":{"a":1},"p":85,"s":[{"t":17},86],"t":{"y":1},"x":19},"f":[{"e":{"r":{"e":83}},"f":41,"i":{"c":[{"i":32},21],"l":17,"n":{"e":23,"i":{"t":{"e":20}}},"t":27},"o":{"r":{"e":{"s":6}}},"u":{"s":{"e":{".":21}}}},29],"g":{"a":{"l":18},"e":{"r":17},"i":{"b":4,"c":1,"n":{"g":4},"t":87},"n":4,"o":{".":21,"s":21},"u":{"l":2,"r":19},"y":32},"h":[{"e":{"r":17}},72],"i":[{"c":19,"d":4,"g":[{"l":4},8],"m":{"b":23},"n":{"f":23,"g":29,"s":{"t":19}},"r":{"d":0},"t":{"e":11,"h":3,"y":19}},9],"j":[{"u":{"d":[{"i":4},21]}},29],"k":{"i":{"n":0},"l":{"a":1}},"l":{"a":[{".":21,"c":21,"n":{"d":17},"t":{"i":{"v":4}},"w":21,"x":{"a":36}},29],"e":{"a":23,"b":{"r":{"a":4}},"c":32,"d":21,"g":{"a":3},"n":19,"r":34,"s":29},"f":9,"i":[{"b":{"e":23},"c":{".":33,"a":3},"e":{"r":23},"g":{"i":{"b":4}},"m":19,"n":{"g":83},"o":23,"s":[{"h":4},24],"v":88,"t":{"i":{"s":208}}},9],"l":{"a":[{"b":1},18],"o":17},"o":{"c":19,"g":4,"p":{".":3},"a":29},"s":{"h":9},"t":{"a":1},"u":{"d":19,"g":4}},"m":{"a":{"c":21,"g":21,"n":[{"a":4},19]},"b":4,"e":[{"l":24,"t":21},29],"i":{"c":{"a":3},"e":0,"g":{"r":{"a":4}},"n":[{"e":4,"i":35},89],"s":[{"h":4,"s":19},21],"z":3},"n":{"i":{"z":32}},"o":{"g":0,"n":{"i":{"o":7}}},"p":{"i":3},"u":{"l":[{"a":4},21],"n":11},"y":23},"n":{"a":{"m":{"o":4},"n":{"t":21}},"c":{"h":{"e":{"r":17}}},"d":{"i":{"c":3,"x":2}},"e":{"a":19,"e":19,"m":3,"r":{"o":4},"s":{"i":4,"t":4},"t":{"r":3},"w":23},"i":{"c":{"s":4},"e":19,"l":19,"o":23,"s":{"h":3},"t":3,"u":19,"z":32},"n":18,"o":[{"g":0,"s":21,"v":3},18],"s":{"w":1},"t":{"a":{"g":{"e":5}},"h":{"e":{"s":18}}},"u":{"a":3,"f":4},"y":{".":23},"z":61},"o":{"f":19,"g":[{"r":{"a":{"p":3}}},9],"i":90,"l":23,"p":{"a":{"r":11}},"r":[{"e":3,"o":{"l":4}},29],"s":0,"t":[{"o":1},21],"u":{"t":19},"w":19},"p":{"a":[{"i":23,"n":{"c":4}},24],"e":{"l":19,"n":{"t":23},"t":{"i":{"t":{"i":{"o":4}}}}},"h":{"e":17},"l":{"i":21},"o":29,"r":{"e":{"c":[{"a":4},21],"d":21,"h":3},"o":[{"b":21},23]},"s":{"h":1},"t":{"i":{"b":13}},"u":{"t":[{"a":4},21]},"i":{"n":{"e":{"p":{"h":209}}}}},"q":[{"u":{"i":{"l":12,"s":91}}},29],"r":{"a":[{"b":0,"n":{"d":18},"r":3,"t":{"i":{".":18}}},2],"b":[{"l":1},25],"c":{"h":[{"e":1},3]},"e":{".":25,"a":{"l":23},"c":{"o":5},"i":{"n":11},"l":{".":4},"m":{"o":3},"n":{"a":4,"c":{"e":4},"e":18,"t":3},"q":0,"s":{"s":4,"t":3},"t":17},"h":2,"i":[{"a":[{"n":{".":210}},92],"c":{"k":32},"e":{"n":23,"r":0},"n":{"e":3},"o":29,"t":18,"u":1,"v":[{"a":21},0]},2],"m":93,"n":{"i":{"s":1,"t":18,"z":32},"o":3},"o":[{"b":4,"c":19,"r":0,"u":2},25],"s":[{"e":{"t":3}},2],"t":{"e":{"r":11},"l":18,"w":3},"u":[{"t":0},18],"w":{"a":{"u":32}}},"s":{"a":[{"g":{"e":{".":21,"s":21}}},72],"c":[{"a":[{"n":4},24],"r":23,"u":4},9],"e":[{"c":[{"r":4},24],"n":{"c":4},"r":{"t":{".":21,"s":21},"v":{"a":21}}},74],"h":[{"a":23,"e":{"n":5}},18],"i":[{"c":24,"d":[{"e":{"n":4}},24],"g":{"n":{"a":4}},"m":94,"n":95,"s":{"t":{"e":17}},"u":0},29],"k":{"i":{"n":19}},"m":{"i":1},"o":{"l":[{"u":3},24],"n":[{"a":4},24]},"p":[{"e":{"r":3},"i":{"r":{"a":4}},"r":{"e":1},"a":{"c":{"i":211}}},29],"s":[{"i":{"b":96}},25],"t":{"a":{"n":36},"i":{"g":3,"m":4},"o":[{"n":23},44],"r":[{"o":19,"u":{"c":10}},25]},"u":{"r":[{"r":4},24]},"w":1},"t":{"a":{"b":0},"e":{"n":{"d":17},"o":23},"h":{"o":{"d":54},"y":{"l":{"e":{"n":{"e":162}}}}},"i":{"c":2,"d":{"e":19},"n":[{"o":0},17],"r":19,"t":{"i":{"o":19,"v":4}}},"n":18,"o":{"n":{"a":4}},"r":{"a":23,"e":23,"i":{"c":3,"f":4},"o":{"g":3,"s":4}},"u":{"a":3},"y":{"m":4},"z":4},"u":[{"n":19,"p":23,"r":{"o":3},"s":0,"t":{"e":17,"i":{"l":6},"r":4},"c":{"l":{"i":{"d":212}}}},18],"v":{"a":{"p":97,"s":[{"t":4},24]},"e":{"a":19,"l":{"l":3,"o":12},"n":{"g":19,"i":17},"r":[{"b":19},2]},"i":[{"d":3,"l":0,"n":21,"v":0},29],"o":{"c":19},"u":19},"w":{"a":[{"g":21},29],"e":{"e":19},"h":23,"i":{"l":6,"n":{"g":3},"t":23}},"x":{"p":41},"y":{"c":32,"e":{".":32},"s":0}},"f":{"a":[{"b":{"l":3,"r":11},"c":{"e":1},"g":18,"i":{"n":17},"l":{"l":{"e":6}},"m":{"a":26,"i":{"s":5}},"r":[{"t":{"h":5}},32],"t":{"a":3,"h":{"e":3},"o":18},"u":{"l":{"t":7}}},41],"b":56,"d":18,"e":{".":18,"a":{"s":17,"t":{"h":54}},"b":[{"r":{"u":{"a":15}}},1],"c":{"a":18,"t":32},"d":25,"l":{"i":3},"m":{"o":1},"n":{"d":[{"e":6},8]},"r":[{"r":32,"m":{"i":{"o":213}}},15],"v":0},"f":[{"e":{"s":21},"i":{"e":21,"n":{".":19},"s":94},"l":{"y":21},"y":24},43],"h":18,"i":[{"a":3,"c":{".":48,"a":{"l":47,"n":23,"t":{"e":18}},"e":{"n":23,"r":3},"i":[{"a":32,"e":32},0],"s":18,"u":3,"h":27},"d":{"e":{"l":4}},"g":{"h":{"t":7}},"l":{"i":5,"l":{"i":{"n":6}},"y":18},"n":[{"a":32,"d":97,"e":9,"g":98,"n":0},25],"s":{"t":{"i":0}},"t":{"t":{"e":{"d":{".":5}}}}},41],"l":[{"e":{"s":{"s":19}},"i":{"n":17},"o":{"r":{"e":11},"w":{"e":{"r":{".":84}}}},"y":100,"a":{"g":{"e":{"l":214}}},"u":{"o":{"r":27}}},99],"m":18,"n":18,"o":[{"n":[{"d":{"e":0},"t":0},32],"r":[{"a":{"t":4,"y":5},"e":{"t":6},"i":0,"t":{"a":6}},9],"s":5},41],"p":56,"r":{"a":{"t":0},"e":{"a":19,"s":{"c":6}},"i":[{"l":17},8],"o":{"l":6}},"s":48,"t":[{"o":21,"y":24},25],"u":[{"e":{"l":4},"g":18,"m":{"i":{"n":1}},"n":{"e":4},"r":{"i":3},"s":{"i":17,"s":0},"t":{"a":18}},27],"y":41},"g":{"a":[{"f":0,"l":{".":32,"i":27,"o":3},"m":[{"e":{"t":4},"o":19},25],"n":{"i":{"s":5,"z":[{"a":6},3]},"o":18},"r":{"n":67},"s":{"s":17},"t":{"h":12,"i":{"v":18}},"z":18},41],"b":23,"d":1,"e":{".":25,"d":25,"e":{"z":17},"l":{"i":{"n":0,"s":4,"z":4},"y":18},"n":[{"a":{"t":1},"i":{"z":4},"o":18,"y":18,"c":{"y":{".":8}}},41],"o":[{"m":3,"d":215},41],"r":{"y":21},"s":{"i":32},"t":{"h":6,"o":18,"y":1,"i":{"c":{".":8}}},"v":1},"g":[{"e":[{"r":23},24],"l":{"u":6},"o":0},101],"h":{"i":{"n":3},"o":{"u":{"t":4}},"t":{"o":1,"w":{"e":15}}},"i":{".":32,"a":[{"r":5},102],"c":[{"i":{"a":32},"o":21},29],"e":{"n":6,"s":{".":32}},"l":0,"m":{"e":{"n":23}},"n":{".":68,"g":{"e":5},"s":103},"o":32,"r":[{"l":0},27],"s":{"l":23},"u":1,"v":32,"z":27},"l":[{"a":[{"d":{"i":6},"s":32},0],"e":[{"a":{"d":29}},41],"i":{"b":0,"g":23,"s":{"h":43}},"o":[{"r":11,"b":{"i":{"n":106}}},27]},9],"m":[{"y":21},29],"n":{"a":[{".":21,"c":69},1],"e":{"t":{"t":17,"i":{"s":{"m":137}}}},"i":[{"n":24,"o":21},29],"o":[{"n":21,"m":{"o":5},"r":{".":216,"e":{"s":{"p":24}}}},29]},"o":[{".":27,"b":5,"e":32,"g":104,"i":{"s":3},"n":[{"a":105,"d":{"o":7},"i":[{"z":{"a":217}},3]},8],"o":32,"r":{"i":{"z":4},"o":{"u":5}},"s":{".":32},"v":15},41],"p":23,"r":[{"a":{"d":{"a":18},"i":21,"n":84,"p":{"h":{".":32,"e":{"r":[{".":7},19]},"i":{"c":32},"y":18}},"y":18},"e":{"n":0,"s":{"s":{".":18}}},"i":{"t":18,"e":{"v":213}},"o":21,"u":{"f":17}},41],"s":[{"t":{"e":19}},9],"t":{"h":11},"u":{"a":[{"r":{"d":27}},1],"e":25,"i":{"t":106},"n":27,"s":27,"t":[{"a":{"n":29}},26]},"w":23,"y":[{"n":107,"r":{"a":4}},41]},"h":{"a":{"b":{"l":73},"c":{"h":17},"e":{"m":0,"t":0},"g":{"u":19},"l":{"a":[{"m":12},3]},"m":1,"n":{"c":{"i":0,"y":0},"d":{".":32},"g":[{"e":{"r":6},"o":6},0],"i":{"z":108},"k":0,"t":{"e":0}},"p":{"l":11,"t":5,"a":{"r":{"r":218}}},"r":{"a":{"n":3,"s":4},"d":[{"e":12},8],"l":{"e":0},"p":{"e":{"n":6}},"t":{"e":{"r":5}}},"s":{"s":5},"u":{"n":17},"z":[{"a":11},32],"i":{"r":{"s":137}},"t":{"c":{"h":213}}},"b":29,"e":{"a":{"d":41,"r":27},"c":{"a":{"n":1,"t":19}},"d":[{"o":13},21],"l":{"i":93,"l":{"i":{"s":0},"y":0},"o":19},"m":{"p":0},"n":[{"a":[{"t":5},17]},9],"o":{"r":5},"p":5,"r":{"a":[{"p":12},21],"b":{"a":0},"e":{"a":6},"n":23,"o":{"u":19},"y":23},"s":[{"p":64},29],"t":[{"e":{"d":0}},1],"u":0,"x":{"a":168}},"f":29,"h":29,"i":{"a":{"n":4},"c":{"o":1},"g":{"h":6},"l":109,"m":{"e":{"r":36}},"n":{"a":21},"o":{"n":{"e":17}},"p":[{"e":{"l":{"a":219}}},1],"r":{"l":0,"o":3,"p":0,"r":0},"s":{"e":{"l":11},"s":0},"t":{"h":{"e":{"r":6}},"e":{"s":{"i":{"d":12}}}},"v":9},"k":18,"l":[{"a":{"n":17},"o":[{"r":{"i":11}},24]},80],"m":[{"e":{"t":17}},43],"n":[{"a":{"u":{"z":12}}},42],"o":{"d":{"i":{"z":19},"s":19},"g":[{"e":17},1],"l":{"a":{"r":5},"e":110},"m":{"a":1,"e":12},"n":{"a":0,"y":4},"o":{"d":27,"n":17},"r":{"a":{"t":5},"i":{"s":4,"c":{".":187}},"t":{"e":12},"u":4},"s":{"e":[{"n":4},0],"p":15},"u":{"s":[{"e":54},41]},"v":{"e":{"l":5}}},"p":56,"r":[{"e":{"e":6},"o":{"n":{"i":{"z":5}},"p":{"o":11}}},26],"s":[{"h":21},101],"t":{"a":{"r":21},"e":{"n":2,"s":4,"o":{"u":216}},"y":21},"u":{"g":1,"m":{"i":{"n":1}},"n":{"k":{"e":5},"t":0},"s":{"t":14},"t":1},"w":[{"a":{"r":{"t":21}}},29],"y":{"p":{"e":3,"h":3,"o":{"t":{"h":{"a":137}}}},"s":9}},"i":{"a":[{"l":24,"m":[{"e":{"t":{"e":5}}},0],"n":[{"c":18,"i":11,"t":46},24],"p":{"e":4},"s":{"s":17},"t":{"i":{"v":21},"r":{"i":{"c":1}},"u":21}},42],"b":{"e":[{"r":{"a":3,"t":4}},0],"i":{"a":4,"n":3,"t":{".":4,"e":4}},"l":[{"i":3},29],"o":19,"r":[{"i":94},29],"u":{"n":19}},"c":{"a":{"m":18,"p":32,"r":[{".":21,"a":21},18],"s":6,"y":21},"c":{"u":17},"e":{"o":18},"h":18,"i":[{"d":19,"n":{"a":4},"p":[{"a":3},24]},25],"l":{"y":21},"o":{"c":94},"r":[{"a":32,"y":21},43],"t":{"e":1,"u":[{"a":111},84]},"u":{"l":{"a":3},"m":1,"o":4,"r":23}},"d":[{"a":{"i":21,"n":{"c":4}},"d":4,"e":{"a":{"l":11},"s":0},"i":[{"a":{"n":4,"r":0},"e":19,"o":[{"u":5,"s":1},3],"t":2,"u":4},24],"l":{"e":23},"o":{"m":21,"w":3},"r":21,"u":[{"o":4},24]},25],"e":[{"d":{"e":0},"g":{"a":113},"l":{"d":12},"n":{"a":67,"e":0,"n":19,"t":{"i":23}},"r":{".":29},"s":{"c":23,"t":29},"t":23},112],"f":{".":18,"e":{"r":{"o":4}},"f":{"e":{"n":5},"r":1},"i":{"c":{".":18},"e":23},"l":23,"t":18,"a":{"c":{"e":{"t":137}}}},"g":[{"a":{"b":5},"e":{"r":{"a":3}},"h":{"t":{"i":12}},"i":[{"b":23,"l":3,"n":3,"t":3},18],"l":28,"o":[{"r":3,"t":4},24],"r":{"e":19},"u":{"i":5,"r":2},"n":{"i":{"t":[{"e":{"r":213}},0]}}},25],"h":23,"i":114,"j":[{"k":21},23],"k":18,"l":{"a":[{"b":93,"d":{"e":21},"m":94,"r":{"a":5}},29],"e":{"g":23,"r":2,"v":17},"f":4,"i":[{"a":3,"b":9,"o":3,"s":{"t":1},"t":25,"z":9},2],"l":{"a":{"b":5}},"n":18,"o":{"q":3},"t":{"y":1},"u":{"r":4},"v":3},"m":{"a":{"g":[{"e":3},21],"r":{"y":5}},"e":{"n":{"t":{"a":{"r":10}}},"t":18},"i":[{"d":{"a":4},"l":{"e":5},"n":{"i":19},"t":18},2],"n":{"i":1},"o":{"n":23},"u":[{"l":{"a":3}},24],"p":{"e":{"d":{"a":201}}}},"n":{".":25,"a":{"u":83,"v":18},"c":{"e":{"l":36,"r":3}},"d":[{"l":{"i":{"n":{"g":4}}}},18],"e":[{"e":23,"r":{"a":{"r":17}},"s":{"s":19}},25],"g":{"a":18,"e":[{"n":4},18],"i":18,"l":{"i":{"n":{"g":4}}},"o":18,"u":18},"i":[{".":19,"a":21,"o":3,"s":2,"t":{"e":{".":19,"l":{"y":{".":19}}},"i":{"o":32},"y":3}},25],"k":18,"l":18,"n":25,"o":[{"c":90,"s":0,"t":21},42],"s":[{"e":3,"u":{"r":{"a":7}}},25],"t":{".":25,"h":112},"u":[{"s":19},2],"y":18,"f":{"r":{"a":{"s":220}}}},"o":[{".":18,"g":{"e":17,"r":9},"l":29,"m":1,"n":{"a":{"t":11},"e":{"r":{"y":0}},"i":11},"p":{"h":4},"r":{"i":11},"s":21,"t":{"h":4,"i":19,"o":1},"u":{"r":21}},25],"p":[{"e":0,"h":{"r":{"a":{"s":115}}},"i":[{"c":1},3],"r":{"e":96},"u":{"l":3}},25],"q":{"u":{"a":23,"e":{"f":4},"i":{"d":3,"t":116}}},"r":[{"a":[{"b":0,"c":21},29],"d":{"e":5},"e":{"d":{"e":0},"f":21,"l":117,"s":21},"g":{"i":4},"i":[{"d":{"e":5},"s":1,"t":{"u":11},"z":118},2],"m":{"i":{"n":1}},"o":{"g":0,"n":{".":32}},"u":{"l":4},"r":{"e":{"v":{"o":{"c":221}}}}},18],"s":{".":25,"a":{"g":4,"r":3,"s":6},"c":[{"h":3},119],"e":[{"r":3},18],"f":27,"h":{"a":{"n":4},"o":{"n":3,"p":5}},"i":{"b":3,"d":0,"s":19,"t":{"i":{"v":4}}},"k":26,"l":{"a":{"n":36}},"m":{"s":18},"o":[{"m":{"e":{"r":5}}},24],"p":[{"i":9,"y":1},2],"s":[{"a":{"l":1},"e":{"n":36,"s":1}},62],"t":{"a":{".":1},"e":2,"i":2,"l":{"y":0},"r":{"a":{"l":18}}},"u":[{"s":4},24]},"t":{"a":{".":18,"b":{"i":0},"g":21,"m":120,"n":23,"t":23},"e":[{"r":{"a":3,"i":19},"s":[{"i":{"m":{"a":29}}},1]},25],"h":[{"i":{"l":148}},25],"i":[{"a":18,"c":[{"a":3,"k":31},22],"g":3,"l":{"l":4},"m":24,"o":25,"s":[{"m":21},18],"n":{"e":{"r":{"a":{"r":158}}}}},29],"o":{"m":121,"n":18},"r":{"a":{"m":21},"y":4},"t":18,"u":{"a":{"t":3},"d":19,"l":3},"z":{".":18}},"u":29,"v":[{"e":{"l":{"l":3},"n":{".":3},"r":{".":83,"s":{".":21}}},"i":{"l":{".":4},"o":4,"t":2},"o":{"r":{"e":19,"o":35},"t":83}},25],"w":56,"x":{"o":1},"y":18,"z":{"a":{"r":18},"i":0,"o":{"n":{"t":32}}}},"j":{"a":[{"c":{"q":0},"p":[{"a":{"n":{"e":{"s":220}}}},1],"n":{"u":{"a":12}}},32],"e":[{"r":{"s":5,"e":{"m":222}},"s":{"t":{"i":{"e":18},"y":18}},"w":11},41],"o":{"p":1},"u":{"d":{"g":32}}},"k":{"a":{".":27,"b":23,"g":19,"i":{"s":17},"l":0},"b":29,"e":{"d":24,"e":41,"g":1,"l":{"i":[{"n":{"g":223}},4]},"n":{"d":73},"r":29,"s":[{"t":{".":23}},0],"t":{"y":1}},"f":23,"h":1,"i":[{".":32,"c":122,"l":{"l":21,"o":6},"m":21,"n":{".":21,"d":{"e":0},"e":{"s":{"s":19},"t":{"i":{"c":224}}},"g":0},"p":1,"s":[{"h":19},0]},29],"k":1,"l":[{"e":{"y":18},"y":18},29],"m":29,"n":{"e":{"s":19},"o":69},"o":{"r":4,"s":{"h":17},"u":23,"v":{"i":{"a":{"n":41}}}},"r":{"o":{"n":5}},"s":[{"c":21,"l":1,"y":21,"h":{"a":23}},101],"t":19,"w":29},"l":{"a":{"b":{"i":{"c":11},"o":21},"c":{"i":[{"e":225},17]},"d":{"e":21,"y":3},"g":{"n":0},"m":{"o":11},"n":{"d":[{"l":0},27],"e":{"t":5},"t":{"e":0}},"r":{"g":0,"i":11,"c":{"e":{"n":176}}},"s":{"e":0},"t":{"a":{"n":4},"e":{"l":{"i":18}},"i":{"v":18}},"v":[{"a":95},18],"i":{"n":{"e":{"s":{"s":226}}}}},"b":[{"i":{"n":17}},42],"c":[{"e":0,"i":23,"h":{"a":{"i":23},"i":{"l":{"d":227}}}},101],"d":[{"e":[{"r":{"e":1,"i":1}},24],"i":[{"s":4},0],"r":[{"i":21},23]},25],"e":{"a":[{"d":{"e":{"r":{".":183}}},"s":{"a":228}},9],"b":{"i":1},"f":{"t":6},"g":{".":32,"g":32,"e":{"n":{"d":{"r":{"e":230}}}}},"m":{"a":{"t":[{"i":{"c":5}},1]}},"n":{".":18,"c":27,"e":{".":32},"t":41,"o":{"i":{"d":78}}},"p":{"h":3,"r":1},"r":{"a":{"b":6},"e":0,"g":27,"i":68,"o":21},"s":[{"c":{"o":4},"q":32,"s":[{".":32},27]},8],"v":{"a":23,"e":{"r":{".":0,"a":0,"s":0}}},"y":[{"e":18},27],"c":{"t":{"a":{"b":229}}}},"f":[{"r":19},25],"g":[{"a":[{"r":12},19],"e":{"s":21},"o":11},80],"h":48,"i":{"a":{"g":1,"m":9,"r":{"i":{"z":6}},"s":1,"t":{"o":1}},"b":{"i":4},"c":{"i":{"o":32},"o":{"r":1},"s":18,"t":{".":18},"u":21,"y":23},"d":{"a":23,"e":{"r":5},"i":27},"f":{"e":{"r":11},"f":21,"l":1},"g":{"a":{"t":{"e":32}},"h":27,"r":{"a":1}},"k":27,"l":123,"m":{"b":{"l":0},"i":11,"o":1,"p":90},"n":{"a":21,"e":[{"a":11},124],"i":11,"k":{"e":{"r":6}}},"o":{"g":4},"q":125,"s":{"p":0},"t":[{".":24,"i":{"c":{"a":32,"s":108}},"h":{"o":{"g":204}}},29],"v":{"e":{"r":11}},"z":29},"j":18,"k":{"a":[{"l":23,"t":0},11]},"l":[{"a":{"w":21},"e":[{"a":19,"c":23,"g":23,"l":23,"n":73,"t":73},24],"i":[{"n":[{"a":19},126],"s":{"h":231}},9],"o":[{"q":{"u":{"i":10}},"u":{"t":4},"w":19},1],"f":{"l":2}},29],"m":[{"e":{"t":19},"i":{"n":{"g":3}},"o":{"d":21,"n":[{"e":{"l":{"l":232}}},17]}},25],"n":81,"o":{".":27,"b":{"a":{"l":5},"o":{"t":{"o":233}}},"c":{"i":1},"f":18,"g":{"i":{"c":27},"o":19,"u":27,"e":{"s":{".":9}}},"m":{"e":{"r":11}},"n":{"g":32,"i":[{"z":127},0]},"o":{"d":6},"p":{"e":{".":32},"i":11,"m":23},"r":{"a":[{"t":{"o":1}},17],"i":{"e":4},"o":{"u":5}},"s":{".":32,"e":{"t":5},"o":{"p":{"h":{"i":{"z":32},"y":32}}},"t":0},"t":{"a":1},"u":{"n":{"d":6},"t":25},"v":18,"a":{"d":{"e":{"d":{".":17},"r":{".":183}}}}},"p":[{"a":{"b":5},"h":{"a":23,"i":19},"i":{"n":{"g":4},"t":23},"l":21,"r":19},25],"r":43,"s":[{"c":21,"e":24,"i":{"e":21}},81],"t":[{"a":{"g":4,"n":{"e":7}},"e":[{"n":17,"r":{"a":36},"a":23},29],"h":{"i":[{"l":{"y":148}},11]},"i":{"e":{"s":{".":19}},"s":17},"r":29,"u":[{"r":{"a":12}},8]},18],"u":{"a":4,"b":{"r":3},"c":{"h":17,"i":3},"e":{"n":3,"p":15},"f":0,"i":{"d":4},"m":{"a":1,"i":32,"n":{".":19,"i":{"a":32}},"b":{"i":{"a":{".":235}}}},"o":[{"r":11},3],"p":18,"s":{"s":17,"t":{"e":11}},"t":41,"n":{"k":{"e":{"r":234}}}},"v":{"e":{"n":19,"t":128}},"w":42,"y":[{"a":18,"b":18,"m":{"e":4},"n":{"o":3},"s":[{"e":19,"t":{"y":{"r":4}}},58],"g":{"a":{"m":{"i":236}}}},41]},"m":{"a":[{"b":25,"c":{"a":9,"h":{"i":{"n":{"e":4}}},"l":1},"g":{"i":{"n":5},"n":32},"h":25,"i":{"d":6},"l":{"d":18,"i":{"g":3,"n":4},"l":{"i":0},"t":{"y":0},"a":{"p":222}},"n":{"i":{"a":32,"s":5,"z":11},".":24,"u":{"s":{"c":237}}},"p":[{"h":{"r":{"o":244}}},18],"r":{"i":{"n":{"e":{".":4}},"z":4},"l":{"y":0},"v":11,"g":{"i":{"n":238}}},"s":{"c":{"e":4},"e":0,"t":15},"t":{"e":32,"h":12,"i":{"s":3,"z":{"a":18}}}},41],"b":[{"a":{"t":129},"i":{"l":19,"n":{"g":83},"v":0}},43],"c":56,"e":{".":18,"d":[{".":18,"i":{"a":32,"e":3,"c":[{"i":{"n":152}},84],"o":{"c":239}},"y":108},25],"g":[{"r":{"a":{"n":240}}},9],"l":{"o":{"n":5},"t":0},"m":[{"o":130},9],"n":[{"a":[{"c":5},0],"d":{"e":0},"e":18,"i":0,"s":[{"u":7},17],"t":[{"e":0},27],".":24},41],"o":{"n":4},"r":{"s":{"a":19}},"s":[{"t":{"i":27}},25],"t":{"a":[{"l":11},1],"e":2,"h":{"i":4},"r":[{"i":{"c":32,"e":4},"y":3},21]},"v":1},"f":43,"h":25,"i":{".":32,"a":3,"d":{"a":[{"b":241},0],"g":0},"g":0,"l":{"i":{"a":27,"e":108,"t":{"a":27}},"l":[{"a":{"g":208},"i":{"l":{"i":59}}},21]},"n":{"a":0,"d":27,"e":{"e":19},"g":{"l":[{"i":5,"y":19},21]},"t":0,"u":[{"t":{"e":{"r":242,"s":{"t":242}}}},21],"i":{"s":{".":174}}},"o":{"t":17},"s":[{"e":{"r":{".":0}},"l":5,"t":{"i":0,"r":{"y":19}}},24],"t":{"h":18},"z":24},"k":18,"l":43,"m":[{"a":{"r":{"y":5},"b":243}},29],"n":[{"a":1,"i":{"n":21},"o":1},43],"o":[{"c":{"r":[{"a":{"t":[{"i":{"z":32}},245]}},18]},"d":131,"g":{"o":1},"i":{"s":[{"e":5},84]},"k":18,"l":{"e":{"s":{"t":4},"c":246}},"m":{"e":3},"n":{"e":{"t":5,"y":{"l":247}},"g":{"e":5},"i":{"a":12,"s":{"m":0,"t":0},"z":3},"o":{"l":36,"c":{"h":12},"e":{"n":171},"s":249},"y":{".":3}},"r":[{"a":{".":18},"o":{"n":{"i":{"s":248}}}},9],"s":[{"e":{"y":4},"p":3},8],"t":{"h":[{"e":{"t":250}},12]},"u":{"f":19,"s":[{"i":{"n":98}},27]},"v":9,"e":{"l":{"a":{"s":167}}}},41],"p":[{"a":{"r":{"a":[{"b":5},7],"i":6}},"e":{"t":23},"h":{"a":{"s":36}},"i":[{"a":0,"e":{"s":4},"n":34,"r":19,"s":4},24],"o":{"r":{"i":11},"s":{"i":{"t":{"e":6}}},"u":{"s":21},"v":6},"t":{"r":1},"y":24},43],"r":47,"s":[{"h":[{"a":{"c":{"k":251}}},21],"i":19},101],"t":18,"u":[{"l":{"a":{"r":49},"t":[{"i":[{"u":252},54]},32]},"m":27,"n":8,"p":18,"u":1,"d":{"r":{"o":9}}},41],"w":18},"n":{"a":[{"b":[{"u":21},81],"c":{".":18,"a":1,"t":19},"g":{"e":{"r":{".":5}}},"k":0,"l":{"i":[{"a":4},1],"t":18},"m":{"i":{"t":4}},"n":[{"c":{"i":36},"i":{"t":0},"k":17},24],"r":{"c":[{"h":{"s":{".":73}}},11],"e":18,"i":11,"l":0,"m":19},"s":[{"c":0,"t":{"i":5}},21],"t":[{"a":{"l":3},"o":{"m":{"i":{"z":6}}}},24],"u":[{"s":{"e":11},"t":27},24],"v":{"e":0}},41],"b":80,"c":{"a":{"r":6},"e":{"s":{".":21}},"h":{"a":23,"e":{"o":19,"s":{"t":253}},"i":{"l":19,"s":23}},"i":{"n":2,"t":1},"o":{"u":{"r":{"a":7}}},"r":29,"u":29},"d":{"a":{"i":21,"n":19},"e":[{"s":{"t":{".":4}}},29],"i":{"b":0,"f":79,"t":29,"z":23,"e":{"c":{"k":29}}},"u":{"c":19,"r":0},"w":{"e":9},"t":{"h":{"r":3}}},"e":{".":25,"a":{"r":23},"b":[{"u":11,"a":{"c":{"k":3}}},9],"c":[{"k":32},9],"d":25,"g":{"a":{"t":[{"i":{"v":5}},1]},"e":32},"l":{"a":1,"i":{"z":5}},"m":{"i":4,"o":1},"n":[{"e":18},41],"o":27,"p":{"o":1},"q":9,"r":[{"a":{"b":6,"r":21},"e":24,"i":132,"r":0},29],"s":[{".":25,"p":18,"t":25,"w":18,"k":{"i":119}},41],"t":{"i":{"c":27}},"v":[{"e":19},1],"w":1},"f":[{"i":{"n":{"i":{"t":{"e":{"s":226}}}}}},23],"g":{"a":{"b":21},"e":{"l":23,"n":{"e":[{"s":5},133]},"r":{"e":19,"i":23}},"h":{"a":4,"o":2},"i":{"b":23,"n":2,"t":19},"l":{"a":21},"o":{"v":17},"s":{"h":4,"p":{"r":2}},"u":[{"m":21},29],"y":24},"h":[{"a":[{"b":12},0],"e":0},80],"i":{"a":[{"n":[{".":114},3],"p":1},68],"b":{"a":3,"l":1},"d":[{"i":4},1],"e":{"r":1},"f":{"i":[{"c":{"a":{"t":4}}},9]},"g":{"r":19},"k":0,"m":[{"i":{"z":3}},29],"n":[{"e":{".":32},"g":0},29],"o":1,"s":{".":32,"t":{"a":0}},"t":[{"h":21,"i":{"o":27},"o":{"r":23},"r":3},24]},"j":29,"k":[{"e":{"r":{"o":19},"t":23},"i":{"n":3},"l":29,"r":{"u":{"p":3}}},44],"l":[{"e":{"s":{"s":19}}},43],"m":[{"e":[{"t":17},0]},19],"n":[{"e":0,"i":{"a":{"l":11},"v":0}},101],"o":{"b":{"l":[{"e":3},0]},"c":{"l":19,"e":{"r":{"o":{"s":254}}}},"d":66,"e":27,"g":[{"e":17},18],"i":{"s":{"i":6}},"l":{"i":134,"o":{"g":{"i":{"s":32}}}},"m":{"i":{"c":27,"z":108,"s":{"t":82}},"o":1,"y":3,"a":{"l":214},"e":{"n":{"o":194}}},"n":[{"a":{"g":0},"i":[{"z":19,"s":{"o":255}},5],"e":{"q":15}},1],"p":[{"o":{"l":{"i":135,"y":{".":256}}}},18],"r":{"a":{"b":5,"r":{"y":1}}},"s":{"c":18,"e":0,"t":5},"t":{"a":4},"u":[{"n":27},41],"v":{"e":{"l":136,"m":{"b":2}}},"w":{"l":12}},"p":[{"i":0,"r":{"e":{"c":17}}},72],"q":29,"r":[{"u":0},29],"s":[{"a":{"b":4,"t":{"i":36}},"c":[{"e":{"i":{"v":4}}},1],"e":[{"s":83},24],"i":{"d":137,"g":17},"l":24,"m":[{"o":{"o":1}},3],"o":{"c":21},"p":{"e":1,"i":19},"t":{"a":{"b":{"l":6}}}},81],"t":[{"a":{"b":0},"e":{"r":{"s":12}},"i":[{"b":19,"e":{"r":0},"f":8,"n":{"e":23,"g":83},"p":0},9],"r":{"o":{"l":{"l":{"i":7}}},"e":{"p":137}},"s":1,"u":{"m":{"e":11}}},29],"u":{"a":2,"d":1,"e":{"n":4},"f":{"f":{"e":0}},"i":{"n":23,"t":50},"m":[{"e":2,"i":19},21],"n":138,"o":23,"t":{"r":3}},"v":74,"w":72,"y":{"m":0,"p":0},"z":[{"a":23},18]},"o":{"a":[{"d":11,"l":{"e":{"s":108}},"r":{"d":12},"s":{"e":0,"t":{"e":6}},"t":{"i":5}},18],"b":{"a":{"b":35,"r":19},"e":{"l":0},"i":[{"n":[{"g":4},24]},29],"r":23,"u":{"l":3},"l":{"i":{"g":189}}},"c":{"e":29,"h":[{"e":{"t":23},"a":{"s":23}},0],"i":{"f":12,"l":21},"l":{"a":{"m":21}},"o":{"d":21},"r":{"a":{"c":3,"t":{"i":{"z":4}}},"e":12,"i":{"t":32}},"t":{"o":{"r":{"a":7}}},"u":{"l":{"a":3},"r":{"e":19}}},"d":{"d":{"e":{"d":4}},"i":{"c":3,"o":11,"t":{"i":{"c":137}}},"o":[{"r":12},139],"u":{"c":{"t":{".":4,"s":4}}},"e":{"l":{"l":{"i":12}}}},"e":{"l":21,"n":{"g":19},"r":[{"s":{"t":257}},23],"t":{"a":1},"v":23},"f":{"i":[{"t":{"e":4,"t":17}},24]},"g":{"a":{"r":121,"t":{"i":{"v":4},"o":21}},"e":[{"n":{"e":19},"o":19,"r":21},29],"i":{"e":23,"s":140,"t":3},"l":[{"y":79},21],"n":{"i":{"z":27}},"r":{"o":21},"u":{"i":5},"y":[{"n":25},41]},"h":[{"a":{"b":6}},74],"i":[{"c":{"e":{"s":11}},"d":{"e":{"r":3}},"f":{"f":17},"g":0,"l":{"e":{"t":4}},"n":{"g":23,"t":{"e":{"r":6}}},"s":{"m":19,"o":{"n":4},"t":{"e":{"n":6}}},"t":{"e":{"r":3}}},9],"j":19,"k":[{"e":{"n":23,"s":{"t":15}},"i":{"e":4}},25],"l":{"a":[{"n":21,"s":{"s":36}},29],"d":[{"e":15},9],"e":{"r":3,"s":{"c":23,"t":{"e":{"r":88}}},"t":23},"f":{"i":1},"i":[{"a":23,"c":{"e":23},"d":{".":4},"f":73,"l":19,"n":{"g":3},"o":19,"s":{".":19,"h":3},"t":{"e":19,"i":{"o":19}},"v":19,"g":{"o":{"p":{"o":258}}}},9],"l":{"i":{"e":17}},"o":{"g":{"i":{"z":4}},"r":0,"n":{"o":{"m":259}}},"p":{"l":4},"t":9,"u":{"b":3,"m":{"e":3},"n":3,"s":19},"v":9,"y":24},"m":{"a":{"h":4,"l":5,"t":{"i":{"z":4}}},"b":{"e":9,"l":1},"e":[{"n":{"a":3},"r":{"s":{"e":4}},"t":[{"r":{"y":4}},21],"c":{"h":{"a":260}}},24],"i":{"a":23,"c":{".":3,"a":3},"d":19,"n":[{"i":19},2]},"m":{"e":{"n":{"d":32}}},"o":{"g":{"e":0},"n":21},"p":{"i":3,"r":{"o":7}}},"n":[{"a":[{"c":1,"n":23},2],"c":[{"i":{"l":27}},2],"d":[{"o":4},25],"e":{"n":23,"s":{"t":4}},"g":{"u":1},"i":{"c":2,"o":23,"s":2,"u":19},"k":{"e":{"y":3}},"o":{"d":{"i":1},"m":{"y":3,"i":{"c":137}},"r":{"m":{"a":23}},"t":{"o":{"n":261}},"u":23},"s":[{"p":{"i":[{"r":{"a":10}},36]},"u":17},3],"t":{"e":{"n":36},"i":[{"f":7},93]},"u":{"m":4},"v":{"a":6}},24],"o":[{"d":{"e":5,"i":5},"k":1,"p":{"i":11},"r":{"d":23},"s":{"t":6}},9],"p":{"a":24,"e":{"d":5,"r":[{"a":[{"g":18},27]},2]},"h":[{"a":{"n":19},"e":{"r":19}},25],"i":{"n":{"g":3},"t":23,"s":{"m":{".":2}}},"o":{"n":19,"s":{"i":21}},"r":29,"u":2,"y":5},"q":29,"r":{"a":[{".":19,"g":83,"l":{"i":{"z":4}},"n":{"g":{"e":4}}},29],"e":{"a":[{"l":19},5],"i":3,"s":{"h":5,"t":{".":4}},"w":17},"g":{"u":1},"i":{"a":56,"c":{"a":3},"l":19,"n":2,"o":29,"t":{"y":3},"u":23},"m":{"i":9},"n":{"e":8},"o":{"f":19,"u":{"g":3}},"p":{"e":4},"r":{"h":27},"s":{"e":[{"n":5},1],"t":17},"t":{"h":{"i":3,"y":3,"o":{"n":{"i":{"t":262}}},"r":{"i":137}},"y":1,"i":{"v":{"e":{"l":{"y":4}}}}},"u":{"m":19},"y":29},"s":{"a":{"l":3},"c":[{"e":1,"o":{"p":[{"i":18},23]},"r":19},9],"i":{"e":95,"t":{"i":{"v":4},"o":3,"y":3},"u":0},"l":1,"o":24,"p":{"a":1,"o":1,"h":{"e":{"r":83}}},"t":{"a":[{"t":{"i":19}},9],"i":{"l":4,"t":4}}},"t":{"a":{"n":21},"e":{"l":{"e":{"g":36}},"r":{".":3,"s":4},"s":[{"t":{"e":{"r":263},"o":{"r":264}}},21]},"h":[{"e":{"s":{"i":5},"o":{"s":265}},"i":14},18],"i":{"c":{".":3,"a":4,"e":23},"f":23,"s":23},"o":{"s":5}},"u":[{"b":{"l":3,"a":{"d":{"o":116}}},"c":{"h":{"i":6}},"e":{"t":4},"l":1,"n":{"c":{"e":{"r":6}},"d":8},"v":4},9],"v":{"e":{"n":1,"r":{"n":{"e":17},"s":12,"t":1}},"i":{"s":23,"t":{"i":36},"a":{"n":{".":266}}},"o":{"l":60}},"w":{"d":{"e":{"r":3}},"e":{"l":3,"s":{"t":4}},"i":2,"n":{"i":5},"o":21},"y":{"a":2},"x":{"i":{"d":{"i":{"c":267}}}}},"p":{"a":[{"c":{"a":1,"e":1,"t":0},"d":21,"g":{"a":{"n":32,"t":23}},"i":[{"n":17},21],"l":[{"m":{"a":{"t":268}}},21],"n":{"a":0,"e":{"l":11},"t":{"y":0},"y":3},"p":[{"u":1},2],"r":{"a":{"b":{"l":6},"g":{"e":5,"r":{"a":269}},"l":{"e":228},"m":[{"e":12},36]},"d":{"i":5},"e":[{"l":5},27],"i":[{"s":0},28]},"t":{"e":[{"r":4},9],"h":{"i":{"c":32},"y":4},"r":{"i":{"c":1}}},"v":0,"y":27},41],"b":43,"d":1,"e":{".":18,"a":[{"r":{"l":17}},138],"c":9,"d":[{"e":27,"i":[{"a":36,"c":0},27]},37],"e":[{"d":0,"v":208},21],"k":0,"l":{"a":1,"i":{"e":17}},"n":{"a":{"n":1},"c":21,"t":{"h":0}},"o":{"n":4},"r":{"a":{".":21,"b":{"l":6},"g":21},"i":[{"s":{"t":6}},21],"m":{"a":{"l":0},"e":7},"n":21,"o":11,"t":{"i":11},"u":4,"v":15},"t":[{"e":{"n":4},"i":{"z":4}},9]},"f":18,"g":18,"h":{".":18,"a":{"r":{"i":6}},"e":{"n":{"o":11},"r":1,"s":{".":1}},"i":{"c":2,"e":32,"n":{"g":4},"s":{"t":{"i":32}},"z":27,"l":{"a":{"n":{"t":168},"t":{"e":{"l":270}}}}},"l":9,"o":{"b":27,"n":{"e":27,"i":32},"r":0},"s":18,"t":3,"u":32,"y":41},"i":{"a":[{"n":17},3],"c":{"i":{"e":1},"y":1,"a":{"d":271}},"d":[{"a":19,"e":3,"i":32},21],"e":{"c":27,"n":3},"g":{"r":{"a":{"p":1}}},"l":{"o":3},"n":[{".":21,"d":17,"o":21},9],"o":[{"n":17},141],"t":{"h":[{"a":4},23],"u":9}},"k":142,"l":[{"a":{"n":27,"s":{"t":6}},"i":{"a":11,"e":{"r":5},"g":18,"n":[{"a":{"r":5}},0],"c":{"a":{"b":208}}},"o":{"i":17},"u":{"m":[{"b":17},0]}},143],"m":43,"n":48,"o":{"c":1,"d":{".":32},"e":{"m":4,"t":144},"g":145,"i":{"n":[{"t":32,"c":{"a":12}},84]},"l":{"y":{"t":6,"e":137,"p":{"h":{"o":{"n":{"o":272}}}}},"e":{".":41}},"n":{"i":1},"p":1,"r":[{"y":1},124],"s":[{"s":15},41],"t":[{"a":1},21],"u":{"n":32}},"p":[{"a":{"r":{"a":5}},"e":[{"d":21,"l":19,"n":23,"r":23,"t":23},24],"o":{"s":{"i":{"t":{"e":5}}}}},43],"r":[{"a":{"y":{"e":17}},"e":{"c":{"i":32,"o":5},"e":{"m":11},"f":{"a":{"c":6}},"l":{"a":0},"r":11,"s":{"e":23,"s":27,"p":{"l":{"i":84}}},"t":{"e":{"n":5}},"v":11,"m":{"a":{"c":273}},"n":{"e":{"u":15}}},"i":{"e":53,"n":{"t":146},"s":[{"o":12},0]},"o":{"c":{"a":23,"e":{"s":{"s":8}},"i":{"t":{"y":{".":274}}}},"f":{"i":{"t":6}},"l":11,"s":{"e":12},"t":15,"g":{"e":208}}},9],"s":[{"e":[{"u":{"d":[{"o":{"d":276,"f":276}},275]}},24],"h":1,"i":{"b":21}},81],"t":[{"a":{"b":134},"e":24,"h":24,"i":{"m":11},"u":{"r":0},"w":21,"o":{"m":{"a":{"t":277}}},"r":{"o":{"l":278}}},42],"u":{"b":[{"e":{"s":{"c":181}}},11],"e":0,"f":0,"l":{"c":11},"m":1,"n":9,"r":{"r":0},"s":32,"t":[{"e":[{"r":11},32],"r":3,"t":{"e":{"d":0},"i":{"n":0}}},9]},"w":23},"q":{"u":[{"a":{"v":5,"i":{"n":{"t":{"e":279}}},"s":{"i":[{"r":281,"s":281},280]}},"e":{".":25,"r":27,"t":27},"i":{"n":{"t":{"e":{"s":{"s":282}}}},"v":{"a":{"r":14}}}},9]},"r":{"a":{"b":[{"i":3,"o":{"l":{"i":{"c":29},"o":{"i":236}}}},25],"c":{"h":{"e":17,"u":3},"l":19},"f":{"f":{"i":5},"t":0},"i":24,"l":{"o":1},"m":{"e":{"t":[{"r":{"i":{"z":283}}},11],"n":24},"i":24,"o":{"u":3}},"n":{"e":{"o":6},"g":{"e":0},"i":21,"o":4,"h":{"a":{"s":167}}},"p":{"e":{"r":11},"h":{"y":27}},"r":{"c":5,"e":[{"f":5},17],"i":{"l":18}},"s":24,"t":{"i":{"o":{"n":115}}},"u":{"t":0},"v":{"a":{"i":4},"e":{"l":11}},"z":{"i":{"e":4}},"d":{"i":{"g":127,"o":{"g":249}}},"o":{"r":2}},"b":[{"a":{"b":21,"g":21},"i":[{"f":0,"n":[{"e":19,"g":{".":4,"e":284}},24]},8],"o":1},29],"c":[{"e":[{"n":17},24],"h":{"a":23,"e":{"r":0}},"i":{"b":90,"t":1},"u":{"m":12}},29],"d":{"a":{"l":21},"i":[{"a":0,"e":{"r":0},"n":[{"g":3},17]},9]},"e":{".":25,"a":{"l":2,"n":3,"r":{"r":4},"v":32,"w":1},"b":{"r":{"a":{"t":19}}},"c":{"o":{"l":{"l":5},"m":{"p":{"e":5}}},"r":{"e":1},"i":{"p":{"r":285}},"t":{"a":{"n":{"g":286}}}},"d":[{"e":2,"i":{"s":3,"t":5}},37],"f":{"a":{"c":1},"e":[{"r":{".":4}},9],"i":3,"y":1},"g":{"i":{"s":11}},"i":{"t":4},"l":{"i":2,"u":4},"n":{"t":{"a":90,"e":0}},"o":2,"p":{"i":{"n":4},"o":{"s":{"i":1}},"u":2},"r":[{"i":21,"o":17,"u":4},147],"s":{".":21,"p":{"i":1},"s":{"i":{"b":6}},"t":[{"a":{"l":4},"r":3},8]},"t":{"e":{"r":1},"i":{"z":96},"r":{"i":[{"b":{"u":85}},3]}},"u":[{"t":{"i":4}},8],"v":[{"a":{"l":1},"e":{"l":11,"r":{".":30,"s":4,"t":4}},"i":{"l":4},"o":{"l":{"u":5}}},8],"w":{"h":1}},"f":[{"u":0,"y":21},29],"g":[{"e":{"r":3,"t":23},"i":{"c":23,"n":[{"g":3},0],"s":19,"t":19},"l":29,"o":{"n":0},"u":23},9],"h":[{".":18,"a":{"l":18}},1],"i":{"a":[{"b":0,"g":1,"l":{".":23}},3],"b":[{"a":11},21],"c":{"a":{"s":5},"e":21,"i":[{"d":32,"e":1},18],"o":21},"d":{"e":{"r":5}},"e":{"n":{"c":3,"t":3},"r":2,"t":4},"g":{"a":{"n":5},"i":32},"l":{"i":{"z":11}},"m":{"a":{"n":32},"i":5,"o":27,"p":{"e":0}},"n":{"a":[{".":32},24],"d":0,"e":0,"g":0},"o":2,"p":{"h":[{"e":6},32],"l":[{"i":{"c":5}},9]},"q":21,"s":[{".":21,"c":0,"h":23,"p":0},24],"t":{"a":{"b":116},"e":{"d":{".":19},"r":{".":5,"s":5}},"i":{"c":11},"u":[{"r":5},9]},"v":{"e":{"l":5,"t":11},"i":11,"o":{"l":287}}},"j":23,"k":{"e":{"t":23},"l":{"e":1,"i":{"n":1}},".":288,"h":{"o":2},"r":{"a":{"u":29}},"s":{".":288}},"l":[{"e":[{"d":24,"q":{"u":30}},0],"i":{"g":21,"s":[{"h":4},21]},"o":73},29],"m":[{"a":{"c":5},"e":[{"n":23,"r":{"s":4}},24],"i":{"n":{"g":[{".":21},3]},"o":21,"t":23},"y":21},29],"n":{"a":{"r":21},"e":{"l":23,"r":21,"t":19,"y":23},"i":{"c":19,"s":92,"t":23,"v":23},"o":[{"u":21},0],"u":23},"o":{"b":{"l":11,"o":{"t":289}},"c":[{"r":3},24],"e":[{"l":{"a":{"s":167}},"p":{"i":{"d":{"e":290}}}},1],"f":{"e":2,"i":{"l":4}},"k":[{"e":{"r":4}},8],"l":{"e":{".":32}},"m":{"e":{"t":{"e":5},"s":{"h":3}},"i":0,"p":0},"n":{"a":{"l":0},"e":0,"i":{"s":134},"t":{"a":0}},"o":{"m":41,"t":32},"p":{"e":{"l":3},"i":{"c":11}},"r":{"i":11,"o":4},"s":{"p":{"e":{"r":5}},"s":0},"t":{"h":{"e":1},"y":1,"r":{"o":{"n":2}}},"v":{"a":1,"e":{"l":5}},"x":5},"p":[{"e":{"a":21,"n":{"t":19},"r":{".":4},"t":23},"h":95,"i":{"n":{"g":3}},"o":23,"a":{"u":{"l":{"i":291}}}},29],"r":[{"e":{"c":0,"f":0,"o":21,"s":{"t":0}},"i":{"o":0,"v":0},"o":{"n":17,"s":17},"y":{"s":17}},72],"s":[{"a":[{"t":{"i":5}},29],"c":1,"e":[{"c":[{"r":0},23],"r":{".":4,"a":{"d":{"i":238}}},"s":3,"v":148},24],"h":[{"a":19},29],"i":[{"b":90},29],"o":{"n":12},"p":29,"w":19},44],"t":{"a":{"c":{"h":36},"g":21},"e":{"b":23,"n":{"d":17},"o":5},"i":[{"b":4,"d":0,"e":{"r":21},"g":23,"l":{"i":12,"l":17,"y":21},"s":{"t":21},"v":21},29],"r":{"i":23,"o":{"p":{"h":115}},"e":{"u":29}},"s":{"h":1},"h":{"o":{"u":29}}},"u":{"a":3,"e":{"l":93,"n":3},"g":{"l":1},"i":{"n":3},"m":{"p":{"l":11}},"n":[{"k":6,"t":{"y":0}},9],"s":{"c":19},"t":{"i":{"n":6}}},"v":{"e":[{"l":{"i":17},"n":23,"r":{".":4},"s":{"t":19},"y":23,"i":{"l":29}},1],"i":{"c":23,"v":0},"o":23},"w":29,"y":{"c":1,"n":{"g":{"e":32}},"t":3},"z":{"s":{"c":2}}},"s":{"a":[{"b":42,"c":{"k":32,"r":{"i":11},"t":23},"i":32,"l":{"a":{"r":36},"m":0,"o":4,"t":0,"e":{"s":{"c":54,"w":7}}},"n":{"c":27,"d":{"e":0}},"p":[{"a":{"r":{"i":{"l":292}}}},29],"t":{"a":4,"i":{"o":76},"u":11},"u":0,"v":{"o":{"r":4}},"w":32},9],"b":56,"c":{"a":{"n":{"t":149},"p":[{"e":{"r":267}},0],"v":6,"t":{"o":{"l":208}}},"e":{"d":21,"i":18,"s":21},"h":[{"o":21,"i":{"t":{"z":21}},"r":{"o":{"d":{"i":{"n":{"g":293}}}}}},8],"i":{"e":68,"n":{"d":150},"u":{"t":{"t":294}}},"l":{"e":6,"i":21},"o":{"f":17,"p":{"y":18},"u":{"r":{"a":7}}},"u":29,"r":{"a":{"p":{"e":{"r":{".":36}}}}},"y":{"t":{"h":247}}},"d":56,"e":{".":18,"a":[{"s":17,"w":5},1],"c":{"o":151,"t":27},"d":[{"e":95,"l":19},125],"g":[{"r":11},9],"i":32,"l":{"e":2,"f":32,"v":32},"m":{"e":[{"s":{"t":295}},18],"o":{"l":1},"a":{"p":{"h":287}},"i":{"t":{"i":{"c":296}}}},"n":{"a":{"t":5},"c":18,"d":0,"e":{"d":19},"g":5,"i":{"n":19},"t":{"d":18,"l":18}},"p":{"a":152,"t":{"e":{"m":{"b":11}}}},"r":{".":43,"l":21,"o":0,"v":{"o":18}},"s":[{"h":4,"t":5},72],"u":{"m":113},"v":[{"e":{"n":11}},32],"w":{"i":0},"x":32},"f":47,"g":48,"h":[{".":25,"e":{"r":2,"v":32},"i":{"n":2,"o":3,"p":27,"v":6},"o":[{"l":{"d":4},"n":12,"r":[{"t":7},17],"e":{"s":{"t":137}}},0],"w":18},24],"i":{"b":2,"c":{"c":19},"d":{"e":{".":27,"s":[{"t":6,"w":6},32],"d":{".":8}},"i":[{"z":4},32]},"g":{"n":{"a":18}},"l":{"e":0,"y":18},"n":[{"a":24,"e":{".":32},"g":23},42],"o":[{"n":[{"a":6},32]},41],"r":[{"a":5,"e":{"s":{"i":{"d":4}}}},9],"s":41,"t":{"i":{"o":27}},"u":32,"v":41,"z":32},"k":[{"e":[{"t":23},18],"i":{"n":{"e":4,"g":4}},"y":{"s":{"c":15}}},9],"l":[{"a":{"t":23},"e":24,"i":{"t":{"h":7}},"o":{"v":{"a":{"k":{"i":{"a":297}}}}}},74],"m":[{"a":[{"l":{"l":54},"n":12},23],"e":{"l":17,"n":19},"i":{"t":{"h":32}},"o":{"l":{"d":49}}},42],"n":72,"o":[{"c":{"e":1},"f":{"t":12},"l":{"a":{"b":1},"d":153,"i":{"c":3},"v":32,"u":{"t":{"e":9}}},"m":27,"n":{".":68,"a":17,"g":0},"p":[{"h":{"i":{"c":32,"z":19},"y":19}},21],"r":{"c":5,"d":5},"v":[{"i":4},18],"g":{"a":{"m":{"y":298}}}},41],"p":{"a":[{"i":32,"n":0,"c":{"e":299,"i":{"n":69}}},25],"e":{"n":{"d":17},"o":57,"r":25,"c":{"i":{"o":11}}},"h":{"e":[{"r":[{"o":213},27]},24],"o":6},"i":{"l":17,"n":{"g":4},"o":18,"c":{"i":{"l":208}}},"l":{"y":21},"o":{"n":21,"r":[{"t":{"s":{"c":300,"w":300}}},17],"t":18,"k":{"e":{"s":{"w":10}}}}},"q":{"u":{"a":{"l":{"l":36}},"i":{"t":{"o":88}}}},"r":29,"s":[{"a":[{"s":12,"c":{"h":{"u":301}}},29],"c":94,"e":{"l":23,"n":{"g":19},"s":{".":21},"t":19},"i":[{"e":[{"r":0},21],"l":{"y":4},"a":{"n":{".":210}},"g":{"n":{"a":{"b":302}}}},29],"l":[{"i":1},21],"n":21,"p":{"e":{"n":{"d":115}}},"t":9,"u":{"r":{"a":6}},"w":4,"h":{"a":{"t":3}}},25],"t":{".":25,"a":{"g":24,"l":24,"m":{"i":17,"p":69},"n":{"d":32,"t":{"s":{"h":{"i":303}}}},"p":90,"t":{".":32,"i":15},"r":{"t":{"l":{"i":12}}}},"e":{"d":21,"r":{"n":{"i":7},"o":19},"w":[{"a":6},8]},"h":{"e":23},"i":[{".":21,"a":19,"c":[{"k":32},29],"e":21,"f":23,"n":{"g":3},"r":32},9],"l":{"e":29},"o":{"c":{"k":32},"m":{"a":12},"n":{"e":32},"p":21,"r":{"e":27,"a":{"b":304}}},"r":[{"a":{"d":21,"t":{"u":32,"a":{"g":305}},"y":21},"i":{"d":21,"b":{"u":{"t":7}}},"y":18},1],"w":61,"y":[{"l":{"i":{"s":137}}},24],"b":4,"s":{"c":{"r":4}},"u":{"p":{"i":{"d":306}}}},"u":[{"a":{"l":2},"b":111,"g":151,"i":{"s":4,"t":12},"l":21,"m":[{"i":11},9],"n":9,"r":9,"p":{"e":{"r":{"e":307}}}},41],"v":18,"w":[{"o":18,"i":{"m":{"m":177}}},9],"y":[{"c":18,"l":27,"n":{"o":5,"c":41},"r":{"i":{"n":4}},"t":{"h":{"i":308}}},21]},"t":{"a":[{".":27,"b":[{"l":{"e":{"s":4}},"o":{"l":{"i":{"z":32,"s":{"m":309}}}}},25],"c":{"i":18},"d":{"o":4},"f":46,"i":{"l":{"o":5}},"l":[{"a":4,"e":{"n":5},"i":11,"k":[{"a":204},18],"l":{"i":{"s":0}},"o":{"g":4}},9],"m":{"o":4,"i":{"n":82}},"n":{"d":{"e":0},"t":{"a":54}},"p":{"e":{"r":4},"l":4,"a":{"t":{"h":310}}},"r":{"a":0,"c":18,"e":18,"i":{"z":3},"r":{"h":311}},"s":{"e":0,"y":4},"t":{"i":{"c":18},"u":{"r":1}},"u":{"n":17},"v":0,"w":25,"x":{"i":{"s":0}},"g":{"o":{"n":{".":3}}}},41],"b":42,"c":[{"h":[{"e":{"t":5},"c":15,"i":{"e":{"r":237}}},21],"r":29},18],"d":43,"e":{".":18,"a":{"d":{"i":17},"t":18,"c":{"h":{"e":{"r":{".":36}}}}},"c":{"e":17,"t":32},"d":[{"i":4},42],"e":41,"g":[{"e":{"r":4},"i":4},0],"l":{".":27,"i":17,"s":32,"e":{"g":84,"r":{"o":249}}},"m":{"a":[{"t":11},154]},"n":{"a":{"n":27},"c":27,"d":27,"e":{"s":18},"t":[{"a":{"g":0}},41]},"o":41,"p":[{"e":4},1],"r":{"c":11,"d":155,"i":[{"e":{"s":5},"s":11,"z":{"a":6},"c":{".":8}},41],"n":{"i":{"t":32}},"v":5,"g":{"e":{"i":312}}},"s":{".":18,"s":[{".":23,"e":{"s":313}},18]},"t":{"h":{"e":6}},"u":27,"x":27,"y":18},"f":42,"g":43,"h":{".":25,"a":{"n":17,"l":{"a":{"m":228}}},"e":[{"a":[{"s":3,"t":5},18],"i":{"s":11},"t":27},9],"i":{"c":{".":4,"a":4},"l":18,"n":{"k":32}},"l":18,"o":{"d":{"e":4,"i":{"c":32},"o":{"n":11}},"o":18,"r":{"i":{"t":6,"z":5}},"g":{"e":{"n":{"i":314}}},"k":{"e":{"r":175}}},"s":25,"y":{"l":{"a":{"n":228}},"s":{"c":11}}},"i":{"a":[{"b":1,"t":{"o":1},"n":{".":70}},41],"b":156,"c":{"k":18,"o":21,"u":157},"d":{"i":32},"e":{"n":27},"f":[{"y":4},8],"g":[{"u":32},25],"l":{"l":{"i":{"n":6}}},"m":[{"p":18,"u":{"l":5}},41],"n":[{"a":24,"e":{".":27},"i":27,"o":{"m":285}},42],"o":[{"c":4,"n":{"e":{"e":6}}},41],"q":32,"s":{"a":3,"e":27,"m":0,"o":4,"p":0,"t":{"i":{"c":{"a":32}}}},"t":{"l":3},"u":1,"v":[{"a":0},41],"z":[{"a":3,"e":{"n":3}},41]},"l":[{"a":[{"n":17},19],"e":{".":27,"d":27,"s":{".":27},"t":{".":19}},"o":19,"i":{"e":{"r":315}}},25],"m":[{"e":0},43],"n":81,"o":[{"b":3,"c":{"r":{"a":{"t":4}}},"d":{"o":18},"f":25,"g":{"r":9},"i":{"c":4},"m":{"a":9,"b":0,"y":3},"n":{"a":{"l":{"i":0},"t":3},"o":18,"y":18},"r":{"a":9,"i":{"e":3,"z":5}},"s":8,"u":{"r":32,"t":18},"w":{"a":{"r":3}},"l":{"o":{"g":{"y":84}}},"t":{"i":{"c":11}}},41],"p":43,"r":{"a":[{"b":11,"c":{"h":5,"i":[{"t":17},36],"t":{"e":17}},"s":17,"v":{"e":{"n":5,"s":158,"r":{"s":[{"a":{"b":317}},15]}}},"i":{"t":{"o":{"r":316}}}},41],"e":{"f":5,"m":[{"i":6},0],"a":{"c":{"h":{"e":318}}}},"i":{"a":[{"l":{".":1}},32],"c":{"e":{"s":5},"i":{"a":32},"s":18},"m":25,"v":0},"o":{"m":{"i":5},"n":{"i":6,"y":18},"p":{"h":{"e":5},"i":{"s":175},"o":{"l":{"e":{"s":320},"i":{"s":320,"t":321}}}},"s":{"p":11},"v":11,"l":{"e":{"u":{"m":319}}},"f":{"i":{"c":{".":17},"t":11}}},"u":{"i":5,"s":17}},"s":[{"c":[{"h":{"i":{"e":12}}},21],"h":0,"w":21},101],"t":[{"e":{"s":21},"o":19,"u":0,"r":{"i":{"b":{"u":{"t":322}}}}},66],"u":[{"a":[{"r":3},2],"b":{"i":1},"d":8,"e":18,"f":46,"i":76,"m":27,"n":{"i":{"s":1}},"p":{".":48},"r":{"e":27,"i":[{"s":11},32],"o":5,"y":4,"n":{"a":{"r":12}}},"s":27},41],"v":18,"w":[{"a":43,"i":{"s":17},"o":18,"h":29},1],"y":[{"a":18,"l":25,"p":{"e":12,"h":4,"a":{"l":64}}},41],"z":[{"e":1},18]},"u":{"a":{"b":18,"c":0,"n":{"a":4,"i":0},"r":{"a":{"n":{"t":5}},"d":8,"i":11,"t":11},"t":29,"v":0,"d":{"r":{"a":{"t":{"i":3,"u":15}}}}},"b":{"e":[{"l":21,"r":[{"o":21},23]},1],"i":[{"n":{"g":33}},72],"l":{"e":{".":23}}},"c":{"a":23,"i":{"b":0,"t":1},"l":{"e":12},"r":23,"u":23,"y":21},"d":{"d":4,"e":{"r":3,"s":{"t":4},"v":17},"i":{"c":29,"e":{"d":3,"s":3},"s":4,"t":19},"o":{"n":[{"y":232},21]},"s":{"i":1},"u":21},"e":{"n":{"e":21,"s":17,"t":{"e":0}},"r":{"i":{"l":0}},"a":{"m":15}},"f":{"a":27,"l":23},"g":{"h":{"e":{"n":11}},"i":{"n":4}},"i":[{"l":{"i":{"z":5}},"n":[{"g":29},1],"r":{"m":0},"t":{"a":17},"v":[{"e":{"r":{".":0}}},11]},156],"j":19,"k":18,"l":{"a":[{"b":5,"t":{"i":19}},29],"c":{"h":[{"e":32},17]},"d":{"e":{"r":3}},"e":[{"n":29},1],"g":{"i":1},"i":[{"a":19,"n":{"g":3},"s":{"h":4}},9],"l":{"a":{"r":1},"i":{"b":96,"s":1}},"m":61,"o":72,"s":[{"e":{"s":5}},18],"t":{"i":2,"r":{"a":54},"u":18},"u":[{"l":4},23],"v":4},"m":{"a":{"b":4},"b":{"i":1,"l":{"y":1}},"i":[{"n":{"g":83}},29],"o":{"r":{"o":6}},"p":9},"n":{"a":{"t":17},"e":[{"r":1},24],"i":[{"m":1,"n":24,"s":{"h":4},"v":11},29],"s":[{"w":1},93],"t":{"a":{"b":11},"e":{"r":{".":1},"s":1}},"u":0,"y":4,"z":4},"o":{"r":{"s":21},"s":19,"u":29},"p":{"e":[{"r":{"s":6}},29],"i":{"a":19,"n":{"g":3}},"l":23,"p":[{"o":{"r":{"t":10}}},3],"t":{"i":{"b":5},"u":17}},"r":{"a":[{".":18,"g":21,"s":21,"l":{".":216}},29],"b":{"e":1},"c":0,"d":2,"e":{"a":{"t":5}},"f":{"e":{"r":1},"r":1},"i":{"f":[{"i":{"c":0}},23],"n":2,"o":23,"t":29,"z":3,"a":{"l":{".":0}}},"l":[{"i":{"n":{"g":{".":5}}}},9],"n":{"o":1},"o":{"s":17},"p":{"e":1,"i":1},"s":{"e":{"r":5}},"t":{"e":{"s":4},"h":{"e":3},"i":[{"e":1},17]},"u":23},"s":[{"a":{"d":19,"n":19,"p":1},"c":[{"i":3},8],"e":{"a":5,"r":{".":9}},"i":{"a":19,"c":23},"l":{"i":{"n":1}},"p":2,"s":{"l":4},"t":{"e":{"r":{"e":4}},"r":2},"u":[{"r":17},24]},25],"t":{"a":{"b":0,"t":23},"e":{".":18,"l":18,"n":[{"i":17},18]},"i":[{"l":{"i":{"z":5}},"n":{"e":23,"g":3},"o":{"n":{"a":7}},"s":21,"z":31},101],"l":34,"o":{"f":4,"g":5,"m":{"a":{"t":{"i":{"c":5}}}},"n":19,"u":21},"s":0},"u":[{"m":1},23],"v":74,"x":{"u":11},"z":{"e":1}},"v":{"a":[{".":32,"b":159,"c":{"i":{"l":5},"u":11},"g":[{"e":1,"u":{"e":{"r":170}}},0],"l":{"i":{"e":4},"o":5,"u":15},"m":{"o":4},"n":{"i":{"z":4}},"p":{"i":4},"r":{"i":{"e":{"d":5}}},"t":[{"i":{"v":29}},27],"u":{"d":{"e":{"v":54}}}},41],"e":{".":18,"d":18,"g":11,"l":{".":23,"l":{"i":11},"o":1,"y":21},"n":{"o":{"m":11},"u":{"e":19}},"r":{"d":21,"e":{".":32,"l":[{"y":{".":41}},21],"n":[{"c":5},23],"s":21,"i":{"g":324}},"i":{"e":11},"m":{"i":{"n":36}},"s":{"e":27},"t":{"h":11}},"s":[{".":18,"t":{"e":0,"i":{"t":{"e":15}}}},99],"t":{"e":[{"r":11},1],"y":1}},"i":{"a":{"l":{"i":4},"n":32},"d":{"e":{".":32,"d":32,"n":47,"s":32},"i":32},"f":23,"g":{"n":4},"k":0,"l":[{"i":{"t":32,"z":127}},25],"n":[{"a":26,"c":24,"d":5,"g":18},29],"o":{"l":11,"r":73,"u":2},"p":1,"r":{"o":4},"s":{"i":{"t":11},"o":3,"u":3},"t":{"i":18,"r":11,"y":18},"v":[{"i":{"p":{"a":{"r":325}}}},27]},"o":{".":32,"i":[{"r":{"d":{"u":323}},"c":{"e":{"p":213}}},0],"k":27,"l":{"a":1,"e":19,"t":32,"v":27},"m":{"i":5},"r":{"a":{"b":5},"i":17,"y":1},"t":{"a":1,"e":{"e":18}}},"v":26,"y":21},"w":{"a":{"b":{"l":19},"c":25,"g":{"e":{"r":4},"o":5},"i":{"t":6},"l":{".":19},"m":0,"r":{"t":0},"s":{"t":[{"e":{"w":{"a":326}}},0]},"t":{"e":2},"v":{"e":{"r":4,"g":327}}},"b":29,"e":{"a":{"r":{"i":{"e":5}},"t":{"h":54}},"d":{"n":0},"e":{"t":12,"v":5,"k":{"n":137}},"l":{"l":0},"r":29,"s":{"t":12},"v":23},"h":{"i":0},"i":[{"l":[{"l":{"i":{"n":6}}},8],"n":{"d":{"e":0},"g":0},"r":0,"s":{"e":27},"t":{"h":12},"z":5,"d":{"e":{"s":{"p":6}}}},9],"k":21,"l":{"e":{"s":1},"i":{"n":3}},"n":{"o":21},"o":[{"m":15,"v":{"e":{"n":4}},"k":{"e":{"n":85}}},160],"p":19,"r":{"a":[{"p":{"a":{"r":{"o":12}}}},0],"i":[{"t":{"a":36,"e":{"r":{".":183}}}},0]},"s":{"h":23,"l":1,"p":{"e":1},"t":60},"t":18,"y":1,"c":23},"x":{"a":[{"c":{"e":5},"g":{"o":21},"m":11,"p":21,"s":5},29],"c":161,"e":[{"c":{"u":{"t":{"o":1}}},"d":24,"r":{"i":0,"o":4}},29],"h":[{"i":[{"l":6},8],"u":0},29],"i":[{"a":4,"c":4,"d":{"i":4},"m":{"e":21,"i":{"z":4}}},23],"o":[{"b":21},23],"p":[{"a":{"n":{"d":17}},"e":{"c":{"t":{"o":10}},"d":11}},23],"t":[{"i":23},74],"u":[{"a":3},29],"x":1,"q":[{"u":{"i":{"s":54}}},29]},"y":{"a":{"c":19,"r":110,"t":19},"b":29,"c":[{"e":[{"r":4},24],"h":[{"e":[{"d":264},0]},23],"o":{"m":17,"t":17}},29],"d":29,"e":{"e":19,"r":[{"f":21},29],"s":[{"t":{"e":{"r":{"y":328}}}},0],"t":1},"g":{"i":19},"h":47,"i":29,"l":{"a":23,"l":{"a":{"b":{"l":6}}},"o":23,"u":19},"m":{"b":{"o":{"l":7}},"e":[{"t":{"r":{"y":20}}},0],"p":{"a":12}},"n":{"c":{"h":{"r":3}},"d":4,"g":4,"i":{"c":4},"x":32},"o":[{"d":4,"g":33,"m":0,"n":{"e":{"t":4},"s":21},"s":21},72],"p":{"e":{"d":21,"r":6},"i":3,"o":[{"c":21},23],"t":{"a":9},"u":19},"r":{"a":{"m":5},"i":{"a":4},"o":23,"r":1},"s":{"c":1,"e":161,"i":{"c":{"a":3},"o":3,"s":27},"o":21,"s":0,"t":[{"a":3,"r":{"o":29}},2],"u":{"r":17}},"t":{"h":{"i":{"n":23}},"i":{"c":3}},"w":29},"z":{"a":[{"b":79,"r":8},2],"b":18,"e":[{"n":1,"p":1,"r":[{"o":3},29],"t":0},25],"i":[{"l":21,"s":21,"a":{"n":{".":23}}},42],"l":32,"m":18,"o":[{"m":1,"o":{"l":4},"p":{"h":{"r":329}}},41],"t":{"e":0},"z":[{"y":21,"w":231},101]}}',
        [
            "as-so-ciate",
            "as-so-ciates",
            "dec-li-na-tion",
            "oblig-a-tory",
            "phil-an-thropic",
            "present",
            "presents",
            "project",
            "projects",
            "reci-procity",
            "re-cog-ni-zance",
            "ref-or-ma-tion",
            "ret-ri-bu-tion",
            "ta-ble"
        ]
    ];
});

},{}],"bUaMF":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = function() {
    // https://mths.be/emoji
    return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F|\uD83D\uDC68(?:\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C[\uDFFB-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)\uD83C\uDFFB|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB\uDFFC])|\uD83D\uDC69(?:\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69)(?:\uD83C[\uDFFB-\uDFFD])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620)\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF6\uD83C\uDDE6|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5\uDEEB\uDEEC\uDEF4-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFA\uDFE0-\uDFEB]|\uD83E[\uDD0D-\uDD3A\uDD3C-\uDD45\uDD47-\uDD71\uDD73-\uDD76\uDD7A-\uDDA2\uDDA5-\uDDAA\uDDAE-\uDDCA\uDDCD-\uDDFF\uDE70-\uDE73\uDE78-\uDE7A\uDE80-\uDE82\uDE90-\uDE95])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;
};

},{}],"2jweM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Title", ()=>Title);
parcelHelpers.export(exports, "LabeledInfo", ()=>LabeledInfo);
parcelHelpers.export(exports, "Header", ()=>Header);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function fixedView(style) {
    return ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
            style: style,
            fixed: true,
            children: children
        });
}
function Title(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
        style: [
            (0, _stylesDefault.default).title,
            ...props.styles || []
        ],
        wrap: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
            children: props.title
        })
    });
}
function LabeledInfo(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: [
            (0, _stylesDefault.default).labeledInfo,
            ...props.styles || []
        ],
        wrap: false,
        children: [
            props.label && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                style: (0, _stylesDefault.default).labeledInfoLabel,
                children: [
                    props.label,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).labeledInfoContent,
                children: props.children
            })
        ]
    });
}
const Header = fixedView((0, _stylesDefault.default).header);
const Footer = fixedView((0, _stylesDefault.default).footer);

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@react-pdf/renderer":"3NU82","./styles":"34LkF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34LkF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>styles);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _robotoRegularTtf = require("url:../../../resources/fonts/Roboto-Regular.ttf");
var _robotoRegularTtfDefault = parcelHelpers.interopDefault(_robotoRegularTtf);
var _robotoBlackTtf = require("url:../../../resources/fonts/Roboto-Black.ttf");
var _robotoBlackTtfDefault = parcelHelpers.interopDefault(_robotoBlackTtf);
(0, _renderer.Font).register({
    family: 'Roboto',
    src: (0, _robotoRegularTtfDefault.default)
});
(0, _renderer.Font).register({
    family: 'RobotoBlack',
    src: (0, _robotoBlackTtfDefault.default)
});
const activityStyles = (name)=>({
        [`activity${name}Select`]: {
            marginTop: 7
        },
        [`activity${name}Textarea`]: {
            marginTop: 10,
            marginBottom: 10
        }
    });
const activity = {
    ...activityStyles('beginning'),
    ...activityStyles('development'),
    ...activityStyles('ending')
};
const field = {
    field: {
        marginTop: -1,
        padding: '10',
        borderColor: '#2c75bd',
        borderWidth: 1,
        borderStyle: 'solid',
        borderTopWidth: 0
    },
    checkmark: {
        marginTop: 0,
        width: 15,
        height: 15
    },
    selectLabel: {
        fontSize: 11,
        color: '#2c75bd'
    },
    selectText: {
        paddingLeft: 3
    },
    checkbox: {
        flexDirection: 'row'
    },
    textareaText: {
        color: 'grey',
        textAlign: 'justify'
    },
    levelField: {
        flexDirection: 'row'
    },
    levelCheckbox: {
        flexGrow: 1,
        flexWrap: 'wrap'
    },
    assignmentField: {
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    assignmentCheckbox: {
        flexGrow: 1
    },
    assignmentTextarea: {
        width: '100%',
        margin: '10 0'
    },
    objectivesPanel: {
        marginTop: 8
    },
    objectivesSelectText: {
        paddingLeft: '0 !important'
    },
    objectivesPanel0: {
        martinTop: '0 !important'
    },
    objectivesDropdown0: {
        fontFamily: 'RobotoBlack',
        marginRight: 3
    },
    objectivesPanelChildren: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        paddingTop: 8
    },
    objectivesTextarea: {
        margin: '8 0 15 0',
        width: '100%'
    },
    objectivesDropdown: {
        flexGrow: 0
    },
    strategiesSelects: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        padding: '5 5 10 5'
    },
    strategiesSelect: {
        flexGrow: 1
    },
    materialsSelects: {
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    materialsSelect: {
        flexGrow: 1
    },
    materialsTextarea: {
        margin: '10 0'
    },
    technologyresourcesSelects: {
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    technologyresourcesSelect: {
        flexGrow: 1
    },
    technologyresourcesTextarea: {
        margin: '10 0'
    },
    connectionPanel: {
        marginTop: 10
    },
    differentiatedstrategyPanel: {
        marginTop: 10
    },
    differentiatedstrategySelect: {
        marginTop: 8,
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    differentiatedstrategySelectLabel: {
        marginRight: 5
    },
    differentiatedstrategyTextarea: {
        marginTop: 10,
        marginBottom: 10
    },
    evaluationSelects: {
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    evaluationSelect: {
        flexGrow: 1,
        marginRight: 8
    },
    evaluationTextarea: {
        marginTop: 10,
        marginBottom: 10
    }
};
const labeledInfo = {
    labeledInfo: {
        flexGrow: 1
    },
    labeledInfoLabel: {
        fontSize: 11.5,
        color: '#2c75bd'
    },
    labeledInfoContent: {
        paddingLeft: 3
    }
};
const standards = {
    editionGroup: {
        marginBottom: 16
    },
    editionHeading: {
        fontSize: 13,
        fontWeight: 'bold',
        color: '#294e73',
        backgroundColor: '#eaf2fa',
        paddingVertical: 8,
        paddingHorizontal: 10,
        borderLeftWidth: 4,
        borderLeftColor: '#477eaf',
        marginBottom: 0
    },
    standard: {
        flexDirection: 'column'
    },
    expectation: {
        padding: '4 5'
    },
    expectationTitle: {
        fontSize: 11.5,
        color: '#787B7B'
    },
    indicator: {
        paddingTop: '4'
    },
    indicators: {
        padding: '4 5'
    },
    standardLabel: {
        fontSize: 11,
        color: '#2c75bd'
    },
    indicatorCode: {
        fontFamily: 'RobotoBlack'
    },
    indicatorName: {
        fontSize: 10.5,
        padding: '5 0',
        color: '#787B7B'
    }
};
const styles = (0, _renderer.StyleSheet).create({
    page: {
        fontFamily: 'Roboto',
        fontSize: 12,
        padding: '35 20',
        color: '#787b7b'
    },
    header: {
        position: 'absolute',
        fontSize: 10,
        left: 20,
        right: 20,
        top: 10
    },
    headerTitle: {
        position: 'absolute',
        left: 0
    },
    groupRange: {
        position: 'absolute',
        right: 0
    },
    footer: {
        position: 'absolute',
        bottom: 15,
        fontSize: 10
    },
    author: {
        position: 'absolute',
        left: 15
    },
    paging: {
        position: 'absolute',
        right: 15
    },
    plan: {
        marginBottom: 30
    },
    content: {
        borderWidth: 1,
        borderColor: '#2c75bd',
        borderStyle: 'solid',
        borderBottomWidth: 0,
        borderRightWidth: 0,
        borderLeftWidth: 0
    },
    info: {
        flexDirection: 'row',
        padding: '5 10',
        borderWidth: 1,
        borderColor: '#2c75bd',
        borderStyle: 'solid',
        borderTopWidth: 0
    },
    title: {
        marginTop: -1,
        fontSize: 13,
        padding: '5 10',
        border: 'none',
        backgroundColor: '#2c75bd',
        color: '#fff'
    },
    ...labeledInfo,
    ...standards,
    ...field,
    ...activity
});

},{"react":"9njXz","@react-pdf/renderer":"3NU82","url:../../../resources/fonts/Roboto-Regular.ttf":"c9i4A","url:../../../resources/fonts/Roboto-Black.ttf":"9uG8C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"c9i4A":[function(require,module,exports,__globalThis) {
module.exports = require("912c9e2f32334536").getBundleURL('eAbh3') + "Roboto-Regular.6958d21f.ttf";

},{"912c9e2f32334536":"a2ypy"}],"9uG8C":[function(require,module,exports,__globalThis) {
module.exports = require("414743cc6727a48").getBundleURL('eAbh3') + "Roboto-Black.06dcdaf2.ttf";

},{"414743cc6727a48":"a2ypy"}],"dICJ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _common = require("./common");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function PlanInfo(plan) {
    const { translate, institution, author, planStart, planEnd, grade, subject, group, title = "", unit = "", lessons = [], resources = [] } = plan;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: (0, _stylesDefault.default).info,
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                        label: translate('school'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                            style: (0, _stylesDefault.default).schoolName,
                            children: institution.name
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                        label: translate('teacher'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                            style: (0, _stylesDefault.default).authorName,
                            children: [
                                author.lastName,
                                ", ",
                                author.name
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Title), {
                title: translate('details-title')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                style: (0, _stylesDefault.default).info,
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _common.LabeledInfo), {
                        label: translate('assigned-date'),
                        children: [
                            planStart == planEnd && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                children: `${planStart}`
                            }),
                            planStart != planEnd && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                                children: `${planStart} - ${planEnd}`
                            })
                        ]
                    }),
                    group && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                        label: translate('group_label'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                            children: group.name
                        })
                    }),
                    grade && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                        label: translate('grade'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                            children: grade.name
                        })
                    }),
                    subject && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                        label: translate('subject'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                            children: subject.name
                        })
                    })
                ]
            }),
            title.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).info,
                wrap: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                    label: translate('content-title'),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: title
                    })
                })
            }),
            unit.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).info,
                wrap: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                    label: translate('unit'),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                        children: unit
                    })
                })
            }),
            lessons.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).info,
                wrap: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                    label: translate('lessons_label'),
                    children: lessons.map((lesson)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                            style: (0, _stylesDefault.default).lesson,
                            children: `${lesson.id}: ${lesson.name}`
                        }, lesson.id))
                })
            }),
            resources.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).info,
                wrap: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                    label: translate('digital-resources'),
                    children: resources.map((resource, id)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                            style: (0, _stylesDefault.default).resources,
                            children: [
                                resource.title,
                                ": ",
                                resource.href
                            ]
                        }, id);
                    })
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@react-pdf/renderer":"3NU82","./common":"2jweM","./styles":"34LkF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"pHJIV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Standards);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _common = require("./common");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function Indicator(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
        style: (0, _stylesDefault.default).indicator,
        wrap: false,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
            style: (0, _stylesDefault.default).indicatorName,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                    style: (0, _stylesDefault.default).indicatorCode,
                    children: [
                        props.code,
                        '\n'
                    ]
                }),
                props.description
            ]
        })
    });
}
function Expectation(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: (0, _stylesDefault.default).expectation,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: (0, _stylesDefault.default).expectationTitle,
                children: props.name || props.description
            }),
            props.indicators && props.indicators.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).indicators,
                children: props.indicators.map((indicator)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Indicator, {
                        ...indicator
                    }, indicator.id))
            })
        ]
    });
}
function Standard(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: [
            (0, _stylesDefault.default).info,
            (0, _stylesDefault.default).standard
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                style: (0, _stylesDefault.default).standardLabel,
                children: props.name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).expectations,
                children: props.expectations.map((expectation)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Expectation, {
                        ...expectation
                    }, expectation.id))
            })
        ]
    });
}
function Standards(plan) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Title), {
                title: plan.translate('planning-pdf-standards-title')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: (0, _stylesDefault.default).standards,
                wrap: true,
                children: plan.groupedStandards.map((edition)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
                        style: (0, _stylesDefault.default).editionGroup,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                                style: (0, _stylesDefault.default).editionHeading,
                                children: [
                                    plan.translate('standards'),
                                    " \xb7 ",
                                    edition.year
                                ]
                            }),
                            edition.standards.map((standard)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Standard, {
                                    ...standard
                                }, `${edition.id}:${standard.id}`))
                        ]
                    }, edition.id))
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@react-pdf/renderer":"3NU82","./common":"2jweM","./styles":"34LkF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6EUvL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Field);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _common = require("./common");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
var _fieldContent = require("./field-content");
var _fieldContentDefault = parcelHelpers.interopDefault(_fieldContent);
var _utils = require("../../../helpers/utils");
function Field(props) {
    const { id, name, context } = props;
    const className = props.className.replace('-', '');
    const sections = props.sections.map((props, contentId)=>({
            props,
            Element: (0, _fieldContentDefault.default)[props.type],
            contentId
        })).filter(({ Element, props })=>Element && !(0, _utils.isFieldEmpty)(props)).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            index: index,
            className: className,
            ...props,
            id: id,
            contentId: contentId,
            context: context
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: sections.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
            wrap: false,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.Title), {
                    style: [
                        (0, _stylesDefault.default)[className]
                    ],
                    title: name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    style: [
                        (0, _stylesDefault.default)[`${className}Field`],
                        (0, _stylesDefault.default).field
                    ],
                    children: sections
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","@react-pdf/renderer":"3NU82","./common":"2jweM","./styles":"34LkF","./field-content":"gcPym","../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gcPym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _renderer = require("@react-pdf/renderer");
var _utils = require("../../../helpers/utils");
var _checkmarkPng = require("../../../resources/checkmark.png");
var _checkmarkPngDefault = parcelHelpers.interopDefault(_checkmarkPng);
var _common = require("./common");
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
const types = {
    checkbox: Checkbox,
    textarea: Textarea,
    panel: Panel,
    dropdown: Dropdown,
    radiopanel: RadioPanel
};
function Dropdown(props) {
    const { name, count, grouped, value, options, context } = props;
    const selects = value.filter((val)=>val != '').map((text, index)=>{
        const label = value.length < 2 ? name : `${name} ${index + 1}`;
        const val = props.className == 'objectives' && /^Nivel*/.test(text) ? `${text}:` : text;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
            style: [
                (0, _stylesDefault.default).select,
                (0, _stylesDefault.default)[`${props.className}Select`],
                (0, _stylesDefault.default)[`${props.className}Select${index}`]
            ],
            children: [
                !grouped && name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                    style: [
                        (0, _stylesDefault.default).selectLabel,
                        (0, _stylesDefault.default)[`${props.className}SelectLabel`],
                        (0, _stylesDefault.default)[`${props.className}SelectLabel${props.index}`]
                    ],
                    children: [
                        label,
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                    style: [
                        (0, _stylesDefault.default).selectText,
                        (0, _stylesDefault.default)[`${props.className}SelectText`],
                        (0, _stylesDefault.default)[`${props.className}SelectText${index}`]
                    ],
                    children: val
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
        styles: [
            (0, _stylesDefault.default)[`${props.className}Dropdown${props.index}`],
            (0, _stylesDefault.default)[`${props.className}Dropdown`],
            (0, _stylesDefault.default).dropdown
        ],
        label: grouped ? name : undefined,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
            style: [
                (0, _stylesDefault.default)[`${props.className}Selects${props.index}`],
                (0, _stylesDefault.default)[`${props.className}Selects`],
                (0, _stylesDefault.default).dropdown
            ],
            children: selects
        })
    });
}
function Checkbox(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: [
            (0, _stylesDefault.default)[`${props.className}Checkbox`],
            (0, _stylesDefault.default).checkbox
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Image), {
                src: (0, _checkmarkPngDefault.default),
                style: (0, _stylesDefault.default).checkmark
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                children: props.name
            })
        ]
    });
}
function Textarea(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
        styles: [
            (0, _stylesDefault.default)[`${props.className}Textarea`],
            (0, _stylesDefault.default).textarea
        ],
        label: props.name,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
            style: [
                (0, _stylesDefault.default).textareaText,
                (0, _stylesDefault.default)[`${props.className}TextareaText`]
            ],
            children: props.value
        })
    });
}
function Panel(panelProps) {
    const { id, name, context, className } = panelProps;
    const children = panelProps.children.map((props, contentId)=>({
            props,
            Element: types[props.type],
            contentId
        })).filter(({ Element, props })=>Element && !(0, _utils.isFieldEmpty)(props)).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            id: id,
            index: index,
            className: className,
            panelId: panelProps.contentId,
            contentId: contentId,
            context: context,
            ...props
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
            styles: [
                (0, _stylesDefault.default)[`${className}Panel`],
                (0, _stylesDefault.default)[`${className}Panel${panelProps.index}`]
            ],
            label: name,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: [
                    (0, _stylesDefault.default)[`${className}PanelChildren`],
                    (0, _stylesDefault.default).children
                ],
                children: children
            })
        })
    });
}
function RadioPanel(panelProps) {
    const { id, name, context, className } = panelProps;
    const children = panelProps.children.filter((props)=>props.name === panelProps.value).map((props, contentId)=>{
        const radioId = `${id}-radio-${contentId}`;
        const checked = panelProps.value === props.name;
        const children = checked && props.value.filter((props)=>props.value).map((props, index)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Checkbox, {
                className: className,
                ...props
            }, index);
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
            children: children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
                styles: [
                    (0, _stylesDefault.default)[`${className}RadioPanelOption`],
                    (0, _stylesDefault.default)[`${className}RadioPanelOption${panelProps.index}`]
                ],
                label: props.name,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    style: [
                        (0, _stylesDefault.default)[`${className}RadioPanelOptionChildren`],
                        (0, _stylesDefault.default).children
                    ],
                    children: children
                })
            })
        }, contentId);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _common.LabeledInfo), {
            styles: [
                (0, _stylesDefault.default)[`${className}Panel`],
                (0, _stylesDefault.default)[`${className}Panel${panelProps.index}`]
            ],
            label: name,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                style: [
                    (0, _stylesDefault.default)[`${className}PanelChildren`],
                    (0, _stylesDefault.default).children
                ],
                children: children
            })
        })
    });
}
exports.default = types;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-select":"j36cq","@react-pdf/renderer":"3NU82","../../../helpers/utils":"gGc98","../../../resources/checkmark.png":"46Chp","./common":"2jweM","./styles":"34LkF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"46Chp":[function(require,module,exports,__globalThis) {
module.exports = require("25a1030600fcc3b4").getBundleURL('eAbh3') + "checkmark.12d648d8.png";

},{"25a1030600fcc3b4":"a2ypy"}],"cjMlE":[function() {},{}],"afEIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PreviewRD);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _pdf = require("external/pdf");
var _pdfRd = require("./pdf/PdfRd");
var _pdfRdDefault = parcelHelpers.interopDefault(_pdfRd);
var _context = require("teacher/context");
var _utils = require("helpers/utils");
var _material = require("external/material");
const PreviewRD = (props)=>{
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const fileName = (0, _react.useMemo)(()=>(0, _utils.isUUID)(context.newPlan.id) ? (0, _utils.toDownloadableFileName)(context.newPlan.title || context.newPlan?.content?.titulo || 'planificacion-rd') : false, [
        context.newPlan
    ]);
    const document = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdfRdDefault.default), {
        newPlan: context.newPlan,
        profile: context.profile,
        subjects: context.subjects,
        grades: context.grades,
        translate: context.translate
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            width: '100%',
            height: '100%',
            padding: 20,
            display: 'flex',
            flexDirection: 'column',
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between'
                },
                children: [
                    fileName && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.PDFDownloadLink), {
                        document: document,
                        fileName: fileName,
                        children: ({ loading, error })=>error ? `Error al generar PDF: ${String(error)}` : loading ? 'Generando PDF...' : 'Descargar PDF'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                        onClick: ()=>context.navigate({
                                view: context.newPlanFrom
                            }, '/:languageId/:role/:page/:view', {
                                query: context.newPlanFromQuery
                            }),
                        size: "large",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CloseIcon), {})
                    })
                ]
            }),
            fileName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.PDFViewer), {
                style: {
                    width: '100%',
                    height: '75vh',
                    border: 'none'
                },
                children: document
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: "No hay planificaci\xf3n guardada para previsualizar."
            })
        ]
    });
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/pdf":"bPfKe","./pdf/PdfRd":"gWk4v","teacher/context":"5LKDx","helpers/utils":"gGc98","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bPfKe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Document", ()=>(0, _renderer.Document));
parcelHelpers.export(exports, "Page", ()=>(0, _renderer.Page));
parcelHelpers.export(exports, "Text", ()=>(0, _renderer.Text));
parcelHelpers.export(exports, "View", ()=>(0, _renderer.View));
parcelHelpers.export(exports, "StyleSheet", ()=>(0, _renderer.StyleSheet));
parcelHelpers.export(exports, "PDFDownloadLink", ()=>(0, _renderer.PDFDownloadLink));
parcelHelpers.export(exports, "PDFViewer", ()=>(0, _renderer.PDFViewer));
parcelHelpers.export(exports, "Font", ()=>(0, _renderer.Font));
var _renderer = require("@react-pdf/renderer");

},{"@react-pdf/renderer":"3NU82","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gWk4v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _pdf = require("external/pdf");
var _react = require("external/react");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _utils = require("helpers/utils");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const styles = (0, _pdf.StyleSheet).create({
    page: {
        padding: 10,
        fontFamily: 'Helvetica',
        fontSize: 12,
        lineHeight: 1.5,
        backgroundColor: '#fff'
    },
    sectionHeader: {
        backgroundColor: '#2c75bd',
        padding: 10,
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: 13,
        color: '#fff'
    },
    sectionTitle: {
        flexGrow: 1
    },
    rightTitle: {
        flexShrink: 0
    },
    sectionContent: {
        backgroundColor: '#fff',
        padding: 10,
        width: '100%',
        display: 'flex',
        // alignItems: 'center',
        // minHeight: '100px',
        flexDirection: 'column'
    },
    mainContainer: {
        flexDirection: 'column',
        borderWidth: 2,
        borderColor: '#2c75bd',
        padding: 0
    },
    title: {
        fontSize: 10.5,
        color: '#2c75bd'
    },
    text: {
        fontSize: 12,
        color: '#787b7b',
        marginTop: 3,
        marginBottom: 0,
        marginLeft: 5
    },
    subsection: {
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 10,
        backgroundColor: '#fff',
        width: '100%'
    },
    value: {},
    section: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        // padding: 10,
        backgroundColor: '#fff',
        width: '100%',
        display: 'flex',
        // flex: 1,
        height: 'auto'
    },
    strategyHeader: {
        backgroundColor: '#fff',
        border: 'solid 1px #2c75bd',
        marginTop: 10,
        // padding: 10,
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: 13,
        color: '#2c75bd'
    }
});
const keyTranslations = {
    'dailyPlanning': "Planificaci\xf3n diaria",
    'teacher': 'teacher',
    'learningUnit': 'Unidad de aprendizaje',
    'unitPlan': 'Plan de unidad',
    'communicative': 'Competencia comunicativa'
};
function filterDailyStrategy(props) {
    const [_, value = {}] = props = [];
    return !Object.values(value).every((value)=>(0, _utils.isEmptyOrWhiteSpace)(value));
}
const DailyPlanningPDF = (props)=>{
    const { translate, content } = props;
    const strategies = Array.isArray(content?.strategies) ? content.strategies : [];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.View), {
        style: {
            ...styles.subsection,
            padding: '5px 0 0 10px'
        },
        children: strategies.filter(Boolean).map(({ strategy, phase }, indexX)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Strategy, {
                indexX: indexX,
                translate: translate,
                strategy: strategy,
                phase: phase
            }, indexX))
    });
};
function Strategy(props) {
    const { strategy, phase, translate, indexX } = props;
    const order = [
        'start',
        'development',
        'end'
    ];
    const phases = phase && typeof phase === 'object' && !Array.isArray(phase) ? Object.entries(phase) : [];
    phases.sort(([keyA], [keyB])=>{
        return order.indexOf(keyA) - order.indexOf(keyB);
    });
    const shouldRenderPhases = phases.length > 0;
    const shouldRenderName = !(0, _utils.isEmptyOrWhiteSpace)(strategy);
    const shouldRender = shouldRenderName || shouldRenderPhases;
    return shouldRender ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
        children: [
            shouldRenderName && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                style: styles.strategyHeader,
                children: `Estrategia ${indexX + 1}: ${String(strategy)}`
            }),
            shouldRenderPhases && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.Text), {
                        style: {
                            ...styles.title,
                            padding: '5px 0 0 10px',
                            fontSize: 12
                        },
                        children: [
                            translate('Fases'),
                            ":"
                        ]
                    }),
                    phases.map((props)=>{
                        const [key, value] = props;
                        const phaseValues = value && typeof value === 'object' && !Array.isArray(value) ? Object.entries(value) : [];
                        const valuesToRender = phaseValues.filter(([_, valuePhase])=>typeof valuePhase === 'string' && !(0, _utils.isEmptyOrWhiteSpace)(valuePhase));
                        return valuesToRender.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.Text), {
                                    style: {
                                        ...styles.title,
                                        padding: '5px 0 0 30px'
                                    },
                                    children: [
                                        translate(key),
                                        ":"
                                    ]
                                }),
                                valuesToRender.map(([keyPhase, valuePhase], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Phase, {
                                        translate: translate,
                                        keyPhase: keyPhase,
                                        valuePhase: valuePhase
                                    }, index))
                            ]
                        });
                    })
                ]
            })
        ]
    }) : null;
}
function Phase(props) {
    const { translate, keyPhase, valuePhase } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
        wrap: false,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.Text), {
                style: {
                    ...styles.title,
                    padding: '5px 0 0 40px'
                },
                children: [
                    translate(keyPhase),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                style: {
                    ...styles.text,
                    paddingLeft: '40px'
                },
                children: translate(valuePhase)
            })
        ]
    });
}
const UnitPlanPDF = (props)=>{
    const { translate, content = {} } = props;
    const order = [
        'cicleSkill',
        'gradeSkill',
        "communicative",
        "ethical",
        "logicalThinking",
        "problemSolving",
        "scientific",
        "environmental",
        "personalDevelopment"
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: Object.entries(content || {}).sort(([keyA], [keyB])=>{
            return order.indexOf(keyA) - order.indexOf(keyB);
        }).map(([key, value], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
                style: {
                    ...styles.subsection,
                    marginTop: '10px'
                },
                wrap: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.Text), {
                        style: {
                            ...styles.title,
                            fontSize: 13
                        },
                        children: [
                            keyTranslations[translate(key)] ?? key,
                            ":"
                        ]
                    }),
                    typeof value === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                        style: styles.text,
                        children: String(value)
                    }) : Object.entries(value && typeof value === 'object' ? value : {}).map(([keySkill, valueSkill])=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
                            style: {
                                ...styles.subsection
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.Text), {
                                    style: {
                                        ...styles.title,
                                        fontSize: 11,
                                        paddingLeft: '10px'
                                    },
                                    children: [
                                        keySkill,
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                                    style: {
                                        ...styles.text,
                                        paddingLeft: '10px'
                                    },
                                    children: String(valueSkill)
                                })
                            ]
                        }, keySkill);
                    })
                ]
            }, index))
    });
};
const shouldRenderByType = (content)=>{
    switch(typeof content){
        case 'string':
            return !(0, _utils.isEmptyOrWhiteSpace)(content);
        case 'object':
            return content !== null && Object.entries(content).length > 0;
        default:
            return false;
    }
};
function shouldRenderSubSectionByType(props) {
    switch(typeof props.value){
        case 'string':
            return !(0, _utils.isEmptyOrWhiteSpace)(props.value);
        default:
            return false;
    }
}
const renderContentByType = (content)=>{
    if (typeof content === 'string') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
        style: styles.text,
        children: content.toUpperCase()
    });
    else if (Array.isArray(content)) return content.map((item)=>{
        return typeof item === 'object' ? Object.entries(item).map(([k, v])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.Text), {
                style: styles.value,
                children: [
                    k,
                    ": ",
                    String(v)
                ]
            }, k)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
            children: String(item)
        });
    });
    else if (content !== null && typeof content === 'object') return Object.entries(content).map(([key, value])=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                    style: styles.text,
                    children: String(key)
                }, key),
                renderContentByType(value)
            ]
        });
    });
    return null;
};
const PdfSubSection = (props)=>{
    const { keyS, value } = props;
    const display = (0, _react.useMemo)(()=>shouldRenderSubSectionByType(props) ? {} : {
            'display': 'none'
        }, [
        props
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
        style: {
            ...styles.subsection,
            ...display
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.Text), {
                style: styles.title,
                children: [
                    keyS,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                style: styles.text,
                children: value
            })
        ]
    });
};
const keyNameTranslations = {
    'dailyPlanning': DailyPlanningPDF,
    'unitPlan': UnitPlanPDF
};
const PdfSection = ({ sectionTitle, content, keyName, translate, rightTitle, shouldBreak })=>{
    const ContentComponent = keyNameTranslations[keyName];
    const display = (0, _react.useMemo)(()=>shouldRenderByType(content) ? {} : {
            'display': 'none'
        }, [
        content
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
        style: {
            ...styles.section,
            ...display
        },
        break: shouldBreak,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
                style: styles.sectionHeader,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                        style: styles.sectionTitle,
                        children: sectionTitle
                    }),
                    rightTitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                        style: styles.rightTitle,
                        children: rightTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.View), {
                style: styles.sectionContent,
                children: ContentComponent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContentComponent, {
                    translate: translate,
                    content: content
                }) : renderContentByType(content)
            })
        ]
    });
};
const PdfHeader = ({ values })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.View), {
        style: styles.header,
        children: Object.keys(values).map((value, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PdfSubSection, {
                value: values[value],
                keyS: value
            }, index))
    });
};
const RdPreviewPDFDocument = ({ newPlan, translate, profile })=>{
    const { finishTime, startTime, title, subject, unit, content } = newPlan;
    const dailyPlans = Array.isArray(newPlan?.content?.dailyPlanning) ? [
        ...newPlan.content.dailyPlanning
    ] : [];
    dailyPlans.sort((a, b)=>(0, _momentDefault.default)(a.date).isBefore((0, _momentDefault.default)(b.date)) ? -1 : 1);
    const dailyPlanSections = dailyPlans.map((props, index)=>({
            content: props,
            title: `${keyTranslations.dailyPlanning} ${index + 1}`,
            rightTitle: props.date
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Document), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Page), {
            size: "A4",
            style: styles.page,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
                style: styles.mainContainer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PdfHeader, {
                        values: {
                            [translate('school')]: profile?.institution.name,
                            [translate('teacher')]: `${profile?.individual.last_name}, ${profile?.individual.first_name}`
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _pdf.View), {
                        style: {
                            ...styles.section
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.View), {
                                style: styles.sectionHeader,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.Text), {
                                    style: styles.sectionTitle,
                                    children: translate('Detalles del contenido')
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pdf.View), {
                                style: styles.sectionContent,
                                children: Object.entries({
                                    title,
                                    startTime: (0, _dayjsDefault.default)(startTime).format('YYYY/MM/DD [a las] hh:mm a'),
                                    finishTime: (0, _dayjsDefault.default)(finishTime).format('YYYY/MM/DD [a las] hh:mm a'),
                                    subject,
                                    unit,
                                    estimatedTime: content?.estimatedTime || '',
                                    learningSituation: content?.learningSituation || '',
                                    thematicAxis: content?.thematicAxis || '',
                                    teacher: content?.teacher || '',
                                    section: content?.section || ''
                                }).filter(([_, value])=>value !== '').map(([key, value], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PdfSubSection, {
                                        keyS: key,
                                        value: String(value)
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PdfSection, {
                        keyName: "unitPlan",
                        // shouldBreak
                        sectionTitle: translate(keyTranslations.unitPlan),
                        content: newPlan?.content?.unitPlan,
                        translate: translate
                    }),
                    dailyPlanSections.map((props, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(PdfSection, {
                            keyName: "dailyPlanning",
                            translate: translate,
                            sectionTitle: props.title,
                            rightTitle: props.rightTitle,
                            content: props.content
                        }, index))
                ]
            })
        })
    });
};
exports.default = RdPreviewPDFDocument;

},{"react/jsx-runtime":"1dlk8","external/pdf":"bPfKe","external/react":"k16GP","dayjs":"9FMDe","helpers/utils":"gGc98","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4uhq8":[function() {},{}],"l7ja5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Resources);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _resourceTable = require("teacher/components/resourceTable");
var _resourceTableDefault = parcelHelpers.interopDefault(_resourceTable);
var _indexStyl = require("./index.styl");
const tools = [
    'viewer',
    'multi-touch'
];
function Resources() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "resources",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourceTableDefault.default), {
            kind: "tools",
            resources: tools
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","teacher/components/resourceTable":"4e7b1","./index.styl":"hvoZn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4e7b1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResourceTable);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _resourceRow = require("./resourceRow");
var _resourceRowDefault = parcelHelpers.interopDefault(_resourceRow);
var _resourceTableStyl = require("./resourceTable.styl");
function ResourceTable({ kind, resources }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `${kind} resource-table`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                        id: kind
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "name",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: `${kind}_product`
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "description",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        id: `${kind}_description`
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                    className: "download",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                        link: true
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                        children: resources.map((id, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourceRowDefault.default), {
                                key,
                                id,
                                kind
                            }))
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","./resourceRow":"9wO66","./resourceTable.styl":"gqXg2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9wO66":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ResourceRow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../../context");
var _url = require("helpers/url");
function ResourceRow({ kind, id }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translate, translations, profile } = context;
            const { project } = profile.institution;
            const name = (part)=>[
                    'viewer',
                    'viewer-student'
                ].indexOf(id) >= 0 ? `${kind}_${project}_${id}_${part}` : `${kind}_${id}_${part}`;
            const downloadLink = translate(name('download'));
            const href = /^http[s]*:\/\//.test(downloadLink) ? downloadLink : `//${(0, _url.subdomainResource)('www', downloadLink)}`;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                className: kind,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "name",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: name('name')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "description",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: name('description')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                        className: "download",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            ...(0, _url.viewerGuard)({
                                target: "_blank",
                                href
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                link: true
                            })
                        })
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","../../../context":"iUP37","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gqXg2":[function() {},{}],"hvoZn":[function() {},{}],"ui2Ft":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PremiumRequired);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../../context");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _premiumRequiredStyl = require("./premium-required.styl");
function PremiumRequired() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translate } = context;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: translate('premium-required-message')
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","../../context":"iUP37","@mui/material/Box":"73kto","./premium-required.styl":"huukE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"huukE":[function() {},{}],"9ewWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Help);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _resourceTable = require("../components/resourceTable");
var _resourceTableDefault = parcelHelpers.interopDefault(_resourceTable);
var _material = require("external/material");
var _context = require("teacher/context");
var _react1 = require("external/react");
var _scheduleSpecialistMeeting = require("./ScheduleSpecialistMeeting");
var _scheduleSpecialistMeetingDefault = parcelHelpers.interopDefault(_scheduleSpecialistMeeting);
const manuals = {
    'dgenius': [
        'eduboard',
        'viewer',
        'viewer-student'
    ],
    'de': [
        'eduboard',
        'viewer',
        'viewer-student'
    ],
    'edusystem': [
        'eduboard',
        'viewer',
        'viewer-student'
    ]
};
const tools = [
    'viewer',
    'multi-touch'
];
const StyledHelp = (0, _material.styled)('div')(helpStyles);
function Help() {
    const context = (0, _react1.useContext)((0, _context.TeacherContext));
    const { profile, displayingScheduleMeeting } = context;
    const { project } = profile.institution;
    const isDreyfous = (0, _react1.useMemo)(()=>profile.domain === 'dreyfous', [
        profile.domain
    ]);
    const manual = manuals[project] || manuals['edusystem'];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledHelp, {
        className: (0, _material.clsx)({
            displayingMeeting: displayingScheduleMeeting
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "resource-tables",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourceTableDefault.default), {
                        kind: "manuals",
                        resources: manual
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resourceTableDefault.default), {
                        kind: "tools",
                        resources: tools
                    })
                ]
            }),
            isDreyfous && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scheduleSpecialistMeetingDefault.default), {})
        ]
    });
}
function helpStyles() {
    return {
        display: 'flex',
        padding: 20,
        flexDirection: 'column',
        marginTop: 10,
        flexGrow: 1,
        '&.displayingMeeting': {
            '& .resource-tables': {
                display: 'none'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","../components/resourceTable":"4e7b1","external/material":"6yEDE","teacher/context":"5LKDx","external/react":"k16GP","./ScheduleSpecialistMeeting":"7fJcl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7fJcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScheduleSpecialistMeeting);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
const StyledMeeting = (0, _material.styled)('div')(meetingStyles);
function ScheduleSpecialistMeeting() {
    const { updateState, displayingScheduleMeeting, translate } = (0, _react1.useContext)((0, _context.TeacherContext));
    const displayScheduleMeeting = (0, _react1.useCallback)(()=>{
        updateState({
            displayingScheduleMeeting: {
                $apply: (a)=>!a
            }
        });
    }, [
        updateState
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledMeeting, {
        className: (0, _material.clsx)({
            displaying: displayingScheduleMeeting
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "meeting-head",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        onClick: displayScheduleMeeting,
                        className: "meeting-label",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: translate('schedule-specialist-meeting-label')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.IconButton), {
                        onClick: displayScheduleMeeting,
                        className: "close-meeting",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CloseIcon), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "meeting-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                    src: "https://outlook.office365.com/owa/calendar/ReuninconEspecialistadeMatemticas@dreyfous.com/bookings/",
                    width: "100%",
                    height: "100%"
                })
            })
        ]
    });
}
function meetingStyles() {
    return {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        '& .meeting-head': {
            flexShrink: 0,
            display: 'flex',
            '& .meeting-label': {
                marginTop: 20,
                flexGrow: 1,
                cursor: 'pointer',
                color: '#1c4b90'
            },
            '& .close-meeting': {
                display: 'none'
            }
        },
        '& .meeting-content': {
            display: 'none'
        },
        '&.displaying': {
            '& .meeting-label': {
                marginTop: 0
            },
            "& .close-meeting": {
                display: 'block'
            },
            '& .meeting-content': {
                display: 'block',
                flexGrow: 1,
                "& iframe": {
                    border: 0
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ddew":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradebookPage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _gradebook = require("components/gradebook");
var _gradebookStyl = require("./gradebook.styl");
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
const gradebookPath = '/:languageId/:role/:page(gradebook)';
function GradebookPage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Switch), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Route), {
                exact: true,
                path: gradebookPath,
                component: (0, _gradebook.RedirectToFirstGroup)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Route), {
                exact: true,
                path: `${gradebookPath}/:groupId(${UUID})`,
                component: (0, _gradebook.GradeBook)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Route), {
                exact: true,
                path: `${gradebookPath}/:groupId(${UUID})/:studentId(${UUID})`,
                component: (0, _gradebook.StudentGrades)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","components/gradebook":"2Ycko","./gradebook.styl":"jkOip","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2Ycko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GradeBook", ()=>(0, _gradeBookDefault.default));
parcelHelpers.export(exports, "RedirectToFirstGroup", ()=>(0, _gradeBook.RedirectToFirstGroup));
parcelHelpers.export(exports, "StudentGrades", ()=>(0, _studentGradesDefault.default));
var _gradeBook = require("./GradeBook");
var _gradeBookDefault = parcelHelpers.interopDefault(_gradeBook);
var _studentGrades = require("./StudentGrades");
var _studentGradesDefault = parcelHelpers.interopDefault(_studentGrades);

},{"./GradeBook":"FSvJu","./StudentGrades":"grtv8","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"FSvJu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeBook);
parcelHelpers.export(exports, "RedirectToFirstGroup", ()=>RedirectToFirstGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _url = require("helpers/url");
var _gradebook = require("helpers/gradebook");
var _infoBar = require("./InfoBar");
var _infoBarDefault = parcelHelpers.interopDefault(_infoBar);
var _filters = require("./Filters");
var _filtersDefault = parcelHelpers.interopDefault(_filters);
var _head = require("./Head");
var _headDefault = parcelHelpers.interopDefault(_head);
var _body = require("./Body");
var _bodyDefault = parcelHelpers.interopDefault(_body);
var _deleteExternalGrade = require("./DeleteExternalGrade");
var _deleteExternalGradeDefault = parcelHelpers.interopDefault(_deleteExternalGrade);
var _context = require("teacher/context");
var _loader = require("components/loader");
const StyledGradebook = (0, _material.styled)((0, _material.Box))(gradebookStyles);
function GradeBook() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, groupId, groups, navigate } = context;
    const { items: periods } = context.rollbookContextPeriods;
    const selectedPeriod = (0, _react.useMemo)(()=>(0, _gradebook.getSelectedPeriod)(periods, query.periodId), [
        periods,
        query.periodId
    ]);
    const orderBy = (0, _react.useMemo)(()=>(0, _url.parseOrderColumn)(query.orderBy, 'student'), [
        query.orderBy
    ]);
    const findStudentGrades = (0, _react.useMemo)(()=>(0, _gradebook.getGroupGrades)(context.rollbookContextGrades.items), [
        context.rollbookContextGrades.items
    ]);
    const groupMembers = (0, _react.useMemo)(()=>(0, _gradebook.getGroupMembers)(groupId, groups), [
        groups,
        groupId
    ]);
    const columnsFilteredByPeriod = (0, _react.useMemo)(()=>(0, _gradebook.filterGradeColumnsByPeriod)(context.rollbookContextGradeColumns.items, selectedPeriod), [
        context.rollbookContextGradeColumns.items,
        selectedPeriod
    ]);
    const filteredStudents = (0, _react.useMemo)(()=>(0, _gradebook.filterStudentsByPattern)(groupMembers, query.pattern), [
        groupMembers,
        query.pattern
    ]);
    const studentGrades = (0, _react.useMemo)(()=>(0, _gradebook.getStudentGrades)(filteredStudents, columnsFilteredByPeriod, findStudentGrades, context.rollbookContextStudentAssignmentProperties), [
        filteredStudents,
        columnsFilteredByPeriod,
        findStudentGrades,
        context.rollbookContextStudentAssignmentProperties
    ]);
    const sortedStudents = (0, _react.useMemo)(()=>(0, _gradebook.sortStudentGrades)(orderBy, studentGrades), [
        orderBy,
        studentGrades
    ]);
    const createSortHandler = (0, _react.useMemo)(()=>(property)=>()=>navigate({
                    groupId
                }, undefined, {
                    preserveQuery: true,
                    query: {
                        orderBy: `${orderBy.orderColumn == property && orderBy.order == 'asc' ? '-' : ''}${property}`
                    }
                }), [
        groupId,
        navigate,
        orderBy
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledGradebook, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBarDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteExternalGradeDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "filters",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filtersDefault.default), {
                    grades: sortedStudents
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TableContainer), {
                    className: "container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Table), {
                        className: "table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headDefault.default), {
                                columns: columnsFilteredByPeriod,
                                orderBy: orderBy,
                                createSortHandler: createSortHandler
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bodyDefault.default), {
                                rows: sortedStudents,
                                columns: columnsFilteredByPeriod
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function RedirectToFirstGroup() {
    const { groups, groupsLoaded, link } = (0, _react.useContext)((0, _context.TeacherContext));
    const [firstGroup] = groups;
    const to = firstGroup ? link({
        groupId: firstGroup.id
    }) : link({
        page: 'dashboard'
    }, '/:languageId/:role/:page');
    return groupsLoaded ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Redirect), {
        to: to
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loader.Loader), {
        isLoading: !groupsLoaded
    });
}
function gradebookStyles({ theme }) {
    return {
        flexGrow: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        borderRadius: '4px',
        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        overflowY: 'hidden',
        "& >.filters": {
            display: 'flex',
            padding: '0 20px',
            paddingBottom: 0,
            [theme.breakpoints.down('xs')]: {
                padding: 0
            }
        },
        "& > .content": {
            display: 'flex',
            flexGrow: 1,
            overflow: 'hidden',
            padding: 20,
            paddingTop: 0,
            overflowY: 'auto',
            [theme.breakpoints.down('xs')]: {
                padding: 0
            },
            "& > .container": {
                flexGrow: 1,
                overflow: 'auto',
                border: 'solid 1px #d8dbe0',
                borderTop: 0,
                [theme.breakpoints.down('xs')]: {
                    border: 0
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/url":"65SQD","helpers/gradebook":"6ehCA","./InfoBar":"9RGdC","./Filters":"dKOOM","./Head":"dYdgC","./Body":"avNcH","./DeleteExternalGrade":"dyWky","teacher/context":"5LKDx","components/loader":"dF5cj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ehCA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGroupGrades", ()=>getGroupGrades);
parcelHelpers.export(exports, "getGroupMembers", ()=>getGroupMembers);
parcelHelpers.export(exports, "filterGradeColumnsByPeriod", ()=>filterGradeColumnsByPeriod);
parcelHelpers.export(exports, "gradeMatchesPeriod", ()=>gradeMatchesPeriod);
parcelHelpers.export(exports, "filterStudentsByPattern", ()=>filterStudentsByPattern);
parcelHelpers.export(exports, "getStudentGrades", ()=>getStudentGrades);
parcelHelpers.export(exports, "sortStudentGrades", ()=>sortStudentGrades);
parcelHelpers.export(exports, "getSelectedPeriod", ()=>getSelectedPeriod);
parcelHelpers.export(exports, "getAllGrades", ()=>getAllGrades);
parcelHelpers.export(exports, "displayPoints", ()=>displayPoints);
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _lodash = require("external/lodash");
var _dateFns = require("external/date-fns");
function getGroupGrades(items = []) {
    const groupGrades = items.reduce((students, grade)=>{
        if (!students[grade.student]) students[grade.student] = {};
        const student = students[grade.student];
        const id = grade.makeupFor || grade.assignment || grade.grade;
        const grades = student[id] || (student[id] = []);
        grades.push(grade);
        return students;
    }, {});
    return (studentId, columnId)=>groupGrades[studentId] && groupGrades[studentId][columnId] || [];
}
function getGroupMembers(groupId, groups = []) {
    const group = groups.find((group)=>group.id === groupId) || {};
    return group && group.students || [];
}
function filterGradeColumnsByPeriod(columns, period) {
    return columns.filter((column)=>{
        if (!period) return true;
        const isSameOrAfterPeriod = (0, _dateFns.isSameOrAfter)(column.start, period.start);
        const isSameOrBeforePeriod = (0, _dateFns.isSameOrBefore)(column.start, period.finish);
        return isSameOrAfterPeriod && isSameOrBeforePeriod;
    });
}
function gradeMatchesPeriod(column) {
    return (period)=>{
        const isSameOrAfterPeriod = (0, _dateFns.isSameOrAfter)(column.start, period.start);
        const isSameOrBeforePeriod = (0, _dateFns.isSameOrBefore)(column.start, period.finish);
        return isSameOrAfterPeriod && isSameOrBeforePeriod;
    };
}
function filterStudentsByPattern(students = [], pattern) {
    if (!pattern) return students;
    const filter = ({ name })=>name.normalize().toLowerCase().indexOf(pattern.normalize().toLowerCase()) >= 0;
    return students.filter(filter);
}
function getStudentGrades(students, gradeColumns, findStudentGrades, assignmentProperties) {
    return students.map((student)=>{
        const name = student.name;
        const columns = gradeColumns.map((column)=>{
            const grades = findStudentGrades(student.id, column.id);
            const { properties } = (assignmentProperties[student.id] || {})[column.id] || {
                properties: {
                    ignore: column.external ? false : true
                }
            };
            const ignore = column.properties.ignore || properties.ignore;
            const assigned = column.external || !!(assignmentProperties[student.id] && assignmentProperties[student.id][column.id]);
            const parseColumn = column.external ? parseExternalGrade : column.type == 'homework' ? parseHomeworkGrade : parseAssessmentGrade;
            const parsed = parseColumn({
                ...column,
                ignore,
                assigned
            }, grades);
            return parsed;
        });
        const columnSorting = columns.reduce((sorting, column)=>{
            const isExternal = !!column.external;
            const isHomework = column.type == 'homework';
            const isCorrectedAssessment = column.answered && !column.pending;
            sorting[column.label] = isExternal || isHomework || isCorrectedAssessment ? column.points : 0;
            return sorting;
        }, {});
        const points = columns.filter((c)=>!c.ignore).reduce((points, column)=>points + column.points, 0);
        const total = columns.filter((c)=>!c.ignore).reduce((total, column)=>total + column.total, 0);
        const summary = (total == 0 ? 0 : points / total * 100).toFixed(2);
        return {
            ...student,
            name,
            summary,
            points,
            total,
            columns,
            ...columnSorting
        };
    });
}
function parseAssessmentGrade(column, grades) {
    const answered = grades.filter((g)=>g.answeredAssessment != null);
    let selectedAnswer = answered.find((a)=>a.properties && a.properties.selected);
    if (!selectedAnswer) selectedAnswer = answered.find((a)=>a.makeupFor == null);
    const points = selectedAnswer ? selectedAnswer.points + (selectedAnswer.properties.bonus || 0) : 0;
    return {
        ...column,
        selectedAnswer,
        answered: answered.length > 0,
        pending: selectedAnswer && selectedAnswer.pending,
        points,
        grades
    };
}
function parseExternalGrade(column, grades) {
    const [grade] = grades;
    const pending = grades.length <= 0;
    const notGraded = pending || grade.value === null;
    const points = grade ? grade.value : null;
    return {
        ...column,
        grades,
        pending,
        notGraded,
        points
    };
}
function parseHomeworkGrade(column, grades) {
    const [grade = {}] = grades;
    const pending = grades.length <= 0;
    const notGraded = pending || grade.notGraded;
    const points = grade.points || 0;
    return {
        ...column,
        grades,
        pending,
        notGraded,
        points
    };
}
const sorters = {
    student: (items, order)=>(0, _lodash.orderBy)(items, [
            'name'
        ], [
            order
        ]),
    summary: (items, order)=>(0, _lodash.orderBy)(items, [
            'summary'
        ], [
            order
        ]),
    grade: (items, order, orderColumn)=>(0, _lodash.orderBy)(items, [
            orderColumn
        ], [
            order
        ])
};
function sortStudentGrades({ order, orderColumn }, studentGrades) {
    const sorter = sorters[orderColumn] || (orderColumn ? sorters.grade : sorters.student);
    return sorter(studentGrades, order, orderColumn);
}
function getSelectedPeriod(periods, periodId) {
    return periods.length == 0 ? undefined : periods.find(periodId ? (p)=>p.id == periodId : (p)=>(0, _dateFns.isSameOrAfter)(new Date(), p.start) && (0, _dateFns.isSameOrBefore)(new Date(), p.finish)) || periods[0];
}
async function getAllGrades({ translate, gradingCategoryMap, quizTypesMap, homeworkStatus }) {
    const data = await (0, _commandDefault.default)('grading', 'getAllGrades')();
    const grades = data.filter((i)=>i.recordType == 'grade');
    const gradeColumns = data.filter((i)=>i.recordType == 'column');
    const assignmentProperties = data.filter((i)=>i.recordType == 'properties');
    const processedGrades = grades.map((grade)=>{
        if (grade.type != 'homework') return grade;
        const [reviewed = {}] = (0, _lodash.orderBy)((grade.log || []).filter((e)=>homeworkStatus[e.status] == 'completed'), (e)=>(0, _dateFns.getValue)(e.created), [
            'desc'
        ]);
        const [turned = {}] = (0, _lodash.orderBy)((grade.log || []).filter((e)=>homeworkStatus[e.status] == 'pending'), (e)=>(0, _dateFns.getValue)(e.created), [
            'desc'
        ]);
        return {
            ...grade,
            finished: turned.created,
            points: reviewed.score || 0,
            notGraded: reviewed.score == undefined
        };
    });
    const typeCounts = {};
    const columnLabel = (groupId, type)=>{
        const groupCounts = typeCounts[groupId] ? typeCounts[groupId] : typeCounts[groupId] = {};
        groupCounts[type] = groupCounts[type] ? groupCounts[type] + 1 : 1;
        return `${type}${groupCounts[type]}`;
    };
    const sortedByDate = (0, _lodash.orderBy)(gradeColumns, [
        (p)=>(0, _dateFns.getValue)(p.start)
    ]);
    const columns = sortedByDate.map((column)=>{
        const type = column.type == 'homework' ? 'homework' : column.external ? gradingCategoryMap[column.type] : quizTypesMap[column.type];
        return {
            ...column,
            type,
            label: columnLabel(column.group, translate(`${type}-label`)[0])
        };
    });
    const properties = assignmentProperties.reduce((acc, { id, assignment, student, properties })=>{
        const students = acc[student] || (acc[student] = {});
        students[assignment] = {
            id,
            properties
        };
        return acc;
    }, {});
    return {
        grades: processedGrades,
        gradeColumns: columns,
        properties
    };
}
function displayPoints(grade) {
    const raw = (grade.points || 0) + (grade.properties?.bonus || 0);
    return raw % 1 === 0 ? raw : parseFloat(raw.toFixed(2));
}

},{"helpers/command":"f3cbG","external/lodash":"5bCAQ","external/date-fns":"kwxNe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9RGdC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _dateFns = require("external/date-fns");
var _context = require("teacher/context");
var _exportRollbook = require("./ExportRollbook");
var _exportRollbookDefault = parcelHelpers.interopDefault(_exportRollbook);
const StyledInfoBar = (0, _material.styled)((0, _material.Box))(infoBarStyles);
function InfoBar() {
    const { profile, translate, rollbookContextPeriods } = (0, _react.useContext)((0, _context.TeacherContext));
    const { loaded, items } = rollbookContextPeriods;
    const firstAndLast = loaded && items.length > 0 ? [
        items[0],
        items[items.length - 1]
    ] : [
        {
            start: ''
        },
        {
            finish: ''
        }
    ];
    const [{ start }, { finish }] = firstAndLast;
    const startYear = (0, _dateFns.getYear)(start);
    const finishYear = (0, _dateFns.getYear)(finish);
    const label = `${translate('rollbook')} ${startYear} - ${finishYear}`;
    const validYear = !(isNaN(startYear) || isNaN(finishYear));
    //const isDreyfous = profile.domain === 'dreyfous' || profile.domain === 'dreyfous-dg'
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledInfoBar, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: validYear,
                timeout: {
                    exit: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    className: (0, _material.clsx)('container', 'label'),
                    children: label
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                sx: {
                    flexGrow: 1
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: (0, _material.clsx)('container', 'export-button'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exportRollbookDefault.default), {
                    rollbookLabel: label
                })
            })
        ]
    });
}
function infoBarStyles() {
    return {
        display: 'flex',
        padding: '5px 20px',
        borderBottom: 'solid 1px #dbe3e6',
        minHeight: 60,
        '& > .container': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        '& .label': {
            color: '#636b80',
            fontWeight: 'bold',
            fontSize: '12pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/date-fns":"kwxNe","teacher/context":"5LKDx","./ExportRollbook":"jR0aw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jR0aw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExportRollbookButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _gradebook = require("helpers/gradebook");
var _context = require("teacher/context");
const StyledExportRoolbookButton = (0, _material.styleAndCapture)((0, _material.Button), 'rollbookLabel')(exportRollbookStyles);
function ExportRollbookButton(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const [exporting, setExporting] = (0, _react.useState)(false);
    const { translate } = context;
    const endIcon = (0, _react.useMemo)(()=>{
        return exporting ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CircularProgress), {
            size: 20,
            sx: {
                color: "white"
            }
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FileDownloadIcon), {});
    }, [
        exporting
    ]);
    function handleExportClick() {
        if (!exporting) {
            setExporting(true);
            (0, _gradebook.getAllGrades)(context).then((data)=>{
                context.updateState({
                    rollbookContextGradingDialogs: {
                        'export-rollbook': {
                            $set: true
                        }
                    },
                    rollbookContextGradesToExport: {
                        $set: data
                    }
                });
                setTimeout(setExporting, 500, false);
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledExportRoolbookButton, {
                size: "small",
                variant: "contained",
                endIcon: endIcon,
                onClick: handleExportClick,
                ...props,
                children: translate('export-rollbook')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {
                rollbookLabel: props.rollbookLabel
            })
        ]
    });
}
function exportRollbookStyles() {
    return {
        height: 40,
        width: 150,
        fontSize: '12pt',
        backgroundColor: '#2ca5ec',
        textTransform: 'capitalize'
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","./Form":"2qdjv","helpers/gradebook":"6ehCA","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2qdjv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ExportRollbookForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _export = require("components/gradebook/export");
var _material = require("external/material");
var _checkBoxList = require("components/CheckBoxList");
var _checkBoxListDefault = parcelHelpers.interopDefault(_checkBoxList);
var _formHook = require("helpers/form-hook");
var _gradebook = require("helpers/gradebook");
var _toggleExportFormat = require("./ToggleExportFormat");
var _toggleExportFormatDefault = parcelHelpers.interopDefault(_toggleExportFormat);
var _context = require("teacher/context");
const initialState = {
    includeIgnored: false,
    exportType: 'xlsx',
    rollbookLabel: '',
    periods: [],
    groups: []
};
const StyledDialog = (0, _material.styled)((0, _material.Dialog))(formStyles);
function ExportRollbookForm(props) {
    const { rollbookLabel } = props;
    const theme = (0, _material.useTheme)();
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { state: form, updateState: updateForm, resetState: resetForm } = (0, _formHook.useImmutableForm)({
        ...initialState,
        rollbookLabel
    });
    const { groups, translate, updateState, rollbookContextGradingDialogs: gradingDialogs, rollbookContextPeriods: { items: periods }, rollbookContextGradesToExport: gradesToExport } = context;
    const isOpen = periods.length > 0 && groups.length > 0 && gradingDialogs['export-rollbook'];
    function closeDialog() {
        updateState({
            rollbookContextGradingDialogs: {
                'export-rollbook': {
                    $set: false
                }
            }
        });
        resetForm();
    }
    function exportRollbook() {
        const filteredGroups = form.groups.length != groups.length ? groups.filter((g)=>form.groups.indexOf(g.id) >= 0) : groups;
        const exportData = form.periods.length != periods.length ? {
            ...gradesToExport,
            gradeColumns: gradesToExport.gradeColumns.filter((column)=>periods.filter((p)=>form.periods.indexOf(p.id) >= 0).find((0, _gradebook.gradeMatchesPeriod)(column)))
        } : gradesToExport;
        (0, _export.exportYearRollbook)(context, exportData, filteredGroups, rollbookLabel, form.exportType, form.includeIgnored);
    //closeDialog()
    }
    const canExport = form.groups.length > 0 && form.periods.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDialog, {
        fullScreen: fullScreen,
        open: isOpen,
        onClose: closeDialog,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                className: "title",
                children: translate('export-rollbook-dialog-title', {
                    rollbookLabel
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogContent), {
                className: "content-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _material.clsx)("row", "toggle-format"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toggleExportFormatDefault.default), {
                            translate: translate,
                            format: form.exportType,
                            handleFormatChange: (format)=>updateForm({
                                    exportType: {
                                        $set: format
                                    }
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        className: (0, _material.clsx)("row", "selection-lists"),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                className: (0, _material.clsx)("periods", "selection-list"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBoxListDefault.default), {
                                    mapLabel: (g)=>g.properties.name,
                                    mapValue: (g)=>g.id,
                                    checked: form.periods,
                                    options: periods,
                                    selectAllLabel: translate('all'),
                                    handleSelectAll: (selected)=>updateForm({
                                            periods: {
                                                $set: selected
                                            }
                                        }),
                                    handleToggle: (selected)=>{
                                        const selectedIndex = form.periods.indexOf(selected);
                                        const command = selectedIndex < 0 ? {
                                            $push: [
                                                selected
                                            ]
                                        } : {
                                            $splice: [
                                                [
                                                    selectedIndex,
                                                    1
                                                ]
                                            ]
                                        };
                                        updateForm({
                                            periods: command
                                        });
                                    },
                                    canSelectAll: true
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                className: (0, _material.clsx)("groups", "selection-list"),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBoxListDefault.default), {
                                    mapLabel: (g)=>g.name,
                                    mapValue: (g)=>g.id,
                                    checked: form.groups,
                                    options: groups,
                                    selectAllLabel: translate('all'),
                                    handleSelectAll: (selected)=>updateForm({
                                            groups: {
                                                $set: selected
                                            }
                                        }),
                                    handleToggle: (selected)=>{
                                        const selectedIndex = form.groups.indexOf(selected);
                                        const command = selectedIndex < 0 ? {
                                            $push: [
                                                selected
                                            ]
                                        } : {
                                            $splice: [
                                                [
                                                    selectedIndex,
                                                    1
                                                ]
                                            ]
                                        };
                                        updateForm({
                                            groups: command
                                        });
                                    },
                                    canSelectAll: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _material.clsx)("row", "include-ignored"),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                                color: "primary",
                                checked: form.includeIgnored,
                                onChange: ()=>{
                                    updateForm({
                                        includeIgnored: {
                                            $apply: (a)=>!a
                                        }
                                    });
                                }
                            }),
                            label: translate('export-rollbook-include-ignored-label')
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                className: "actions",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                        variant: "contained",
                        className: (0, _material.clsx)("button", "cancel"),
                        onClick: closeDialog,
                        children: translate('cancel')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                        variant: "contained",
                        disabled: !canExport,
                        className: (0, _material.clsx)("button", "export"),
                        onClick: exportRollbook,
                        children: translate('export-rollbook')
                    })
                ]
            })
        ]
    });
}
function formStyles() {
    return {
        "& .MuiPaper-root": {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 800,
            maxWidth: 1200,
            "& .title": {
                backgroundColor: '#efefefb8',
                borderBottom: 'solid 1px #ccc',
                fontSize: '14pt',
                fontWeight: 600,
                color: '#4c4c4c'
            },
            "& .actions": {
                padding: 20,
                "& .button": {
                    textTransform: 'capitalize',
                    "&.cancel": {
                        marginRight: 10,
                        backgroundColor: '#ccc',
                        color: '#4e4848d9'
                    }
                }
            },
            "& .content-container": {
                display: 'flex',
                flexDirection: 'column',
                padding: 0,
                "& .row": {
                    padding: '0 20px',
                    borderBottom: 'solid 1px #ccc',
                    "& .MuiFormControlLabel-root": {
                        marginLeft: 0
                    },
                    "& .MuiCheckbox-root": {
                        padding: 0,
                        margin: 0,
                        marginRight: 10
                    },
                    "&.toggle-format": {
                        padding: '15px 20px'
                    },
                    "&.include-ignored": {
                        display: 'flex',
                        padding: '15px 20px'
                    },
                    "&.selection-lists": {
                        display: 'flex',
                        flexGrow: 1,
                        padding: 0,
                        "& .selection-list": {
                            flexGrow: 1,
                            "& ul": {
                                padding: '20px 0',
                                "& li": {
                                    padding: '5px 20px',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        backgroundColor: '#efefef69'
                                    },
                                    '&.selected': {
                                        backgroundColor: '#efefef69'
                                    },
                                    "& .MuiListItemIcon-root": {
                                        minWidth: 20
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","components/gradebook/export":"gORxp","external/material":"6yEDE","components/CheckBoxList":"8FZw3","helpers/form-hook":"8O4Ar","helpers/gradebook":"6ehCA","./ToggleExportFormat":"hPYEt","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gORxp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportYearRollbook", ()=>exportYearRollbook);
parcelHelpers.export(exports, "exportGroupRollbook", ()=>exportGroupRollbook);
var _gradebook = require("helpers/gradebook");
var _sheetjs = require("external/sheetjs");
var _dateFns = require("external/date-fns");
function exportYearRollbook(context, data, groups, rollbookLabel, format = 'xlsx', includeIgnored = false) {
    const { grades = [], gradeColumns = [], properties = {} } = data;
    const studentGrades = groups.map((group)=>{
        const groupGrades = grades.filter((g)=>g.group == group.id) || [];
        const groupColumns = gradeColumns.filter((g)=>g.group == group.id) || [];
        const findStudentGrades = (0, _gradebook.getGroupGrades)(groupGrades);
        const filteredColumns = includeIgnored ? groupColumns : groupColumns.filter((c)=>!c.properties.ignore);
        return {
            ...group,
            grades: (0, _gradebook.getStudentGrades)(group.students, filteredColumns, findStudentGrades, properties)
        };
    });
    const bookFile = `${rollbookLabel}-${(0, _dateFns.formatDate)(new Date(), 'yyyy-MM-dd')}.${format}`;
    const sheets = studentGrades.map((group)=>groupSheet(context, group.grades, group.id));
    switch(format){
        case 'csv':
            const jsonCSV = flattenStudentGrades(context, sheets);
            return (0, _sheetjs.exportCSV)(jsonCSV, {
                filename: bookFile
            });
        default:
            return (0, _sheetjs.exportBook)(bookFile, sheets, handleRollbookProcessing);
    }
}
async function exportGroupRollbook(context, grades) {
    const [name, sheet] = groupSheet(context, grades, context.groupId);
    const bookName = `${name}-${(0, _dateFns.formatDate)(new Date(), 'yyyy-MM-dd')}`;
    const bookFile = `${bookName}.xlsx`;
    return (0, _sheetjs.exportBook)(bookFile, [
        [
            name,
            sheet
        ]
    ], handleRollbookProcessing);
}
function flattenStudentGrades(context, sheets) {
    const groupHeader = context.translate('export-rollbook-csv-group-header');
    const periodHeader = context.translate('export-rollbook-csv-period-header');
    const dateHeader = context.translate('export-rollbook-csv-date-header');
    const nameHeader = context.translate('export-rollbook-csv-name-header');
    const totalHeader = context.translate('export-rollbook-csv-total-header');
    const studentHeader = context.translate('export-rollbook-csv-student-header');
    const pointsHeader = context.translate('export-rollbook-csv-points-header');
    const jsonCSV = sheets.reduce((csv, [groupName, rows])=>{
        const [_, periodRow, dateRow, titleRow, totalPointsRow, ...studentRows] = rows;
        const findPeriod = (index)=>{
            for(let i = index + 1; i > 0; i--){
                const period = periodRow[i] || {
                    set: ''
                };
                if (!/^\s*$/.test(period.set)) return period.set;
            }
            return '';
        };
        return csv.concat(studentRows.reduce((sheet, [studentName, ...studentGrades])=>{
            return sheet.concat(studentGrades.reduce((grades, points, index)=>{
                const row = {
                    [groupHeader]: groupName,
                    [periodHeader]: findPeriod(index),
                    [dateHeader]: dateRow[index + 1].set,
                    [nameHeader]: titleRow[index + 1].set,
                    [totalHeader]: totalPointsRow[index + 1].set,
                    [studentHeader]: studentName.set,
                    [pointsHeader]: points.set
                };
                return [
                    ...grades,
                    row
                ];
            }, []));
        }, []));
    }, []);
    return jsonCSV;
}
function groupSheet(context, grades, groupId) {
    const { translate, groups } = context;
    const sheetGroup = groups.find((group)=>group.id == groupId);
    const sheetGroupName = sheetGroup && sheetGroup.name;
    const [firstGrade] = grades;
    const sheet = sheetHeaders(translate, sheetGroupName);
    if (!firstGrade) return [
        sheetGroupName,
        sheet
    ];
    const withPeriods = (0, _sheetjs.addRange)(sheet, periodColumns(context, firstGrade), {
        column: 1,
        row: 1
    });
    const withGradeColumns = (0, _sheetjs.addRange)(withPeriods, sheetGradeColumns(context, firstGrade), {
        column: 1,
        row: 2
    });
    const withGrades = (0, _sheetjs.addRange)(withGradeColumns, sheetGradeRows(context, grades), {
        column: 0,
        row: 5
    });
    return [
        sheetGroupName,
        withGrades
    ];
}
function periodColumns(context, firstGrade) {
    const { items: periods } = context.rollbookContextPeriods;
    const defaults = {
        align: 'left',
        valign: 'center',
        font: {
            name: 'Verdana',
            sz: 11,
            bold: true,
            iter: true
        }
    };
    const cell = (set, styles)=>({
            set,
            ...defaults,
            ...styles
        });
    return [
        firstGrade.columns.reduce((range, column)=>{
            const period = periods.find((0, _gradebook.gradeMatchesPeriod)(column));
            const missingName = period && !range.find((a)=>a.set == period.properties.name);
            range.push(missingName ? cell(period.properties.name) : '');
            return range;
        }, [])
    ];
}
function sheetHeaders(translate, groupName) {
    const fontStyles = (sz = 11)=>({
            font: {
                bold: true,
                sz,
                name: 'Verdana'
            }
        });
    const valign = 'center';
    const height = 30;
    return [
        [
            {
                set: groupName,
                ...fontStyles(12),
                align: 'center',
                valign: 'center'
            }
        ],
        [
            {
                height,
                valign,
                set: translate('export-rollbook-group-period'),
                ...fontStyles()
            }
        ],
        [
            {
                height,
                valign,
                set: translate('export-rollbook-group-date'),
                ...fontStyles()
            }
        ],
        [
            {
                height,
                valign,
                set: translate('export-rollbook-group-name'),
                ...fontStyles()
            }
        ],
        [
            {
                height,
                valign,
                set: translate('export-rollbook-group-total-score'),
                ...fontStyles()
            }
        ]
    ];
}
const ignoreFontStyles = {
    color: 'aea5a5'
};
const ignoreBackgroundStyles = {
    fill: {
        type: 'solid',
        fgColor: 'd6d6d6'
    }
};
function sheetGradeColumns(context, firstGrade) {
    const { columns = [] } = firstGrade;
    const defaults = {
        align: 'center',
        valign: 'center'
    };
    const cell = (set, styles)=>({
            set,
            ...defaults,
            ...styles
        });
    return columns.reduce((range, column)=>{
        const { ignore } = column.properties;
        const [dates, names, scores] = range;
        dates.push(cell((0, _dateFns.formatDate)(column.start, 'yyyy-MM-dd'), {
            font: {
                name: 'Roboto',
                sz: 10.5,
                bold: true,
                ...ignore ? ignoreFontStyles : {}
            },
            ...ignore ? ignoreBackgroundStyles : {}
        }));
        names.push(cell(`${column.label}: ${column.title}`, {
            align: 'left',
            ...ignore ? {
                font: ignoreFontStyles,
                ...ignoreBackgroundStyles
            } : {}
        }));
        scores.push(cell(column.total, {
            font: {
                name: 'Roboto',
                sz: 11,
                bold: true
            }
        }));
        return range;
    }, [
        [],
        [],
        []
    ]);
}
function sheetGradeRows(context, grades) {
    const defaults = {
        align: 'center',
        valign: 'center',
        font: {
            name: 'Roboto',
            sz: 11
        }
    };
    const cell = (set, styles)=>({
            set,
            ...defaults,
            ...styles
        });
    return grades.reduce((range, student)=>{
        range.push([
            cell(student.name, {
                font: {
                    name: 'Verdana',
                    sz: 11,
                    iter: true
                },
                align: 'left'
            })
        ].concat(student.columns.map((c)=>cell(c.points))));
        return range;
    }, []);
}
function handleRollbookProcessing({ type, target, context }) {
    if (type == 'pre' && target == 'row') {
        const { sheet, rowIndex } = context;
        const rowHeight = rowIndex < 5 ? 30 : 25;
        sheet.height(rowIndex + 1, rowHeight);
    }
    if (type == 'post' && target == 'column') {
        const { columnIndex, rowIndex, sheet } = context;
        if (columnIndex == 0) sheet.width(columnIndex + 1, 30);
        else sheet.width(columnIndex + 1, 20);
        if (rowIndex == 2) sheet.wrap(columnIndex + 1, rowIndex + 1, 'true');
    }
    if (type == 'post' && target == 'sheet') {
        const { sheet } = context;
        sheet.height(1, 35);
    }
}

},{"helpers/gradebook":"6ehCA","external/sheetjs":"bCNhb","external/date-fns":"kwxNe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bCNhb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exportCSV", ()=>(0, _saveCsvDefault.default));
parcelHelpers.export(exports, "exportBook", ()=>exportBook);
parcelHelpers.export(exports, "addRange", ()=>addRange);
var _protobiMsexcelBuilder = require("protobi-msexcel-builder");
var _bowser = require("external/bowser");
var _saveCsv = require("save-csv");
var _saveCsvDefault = parcelHelpers.interopDefault(_saveCsv);
async function exportBook(filename, sheets = [], cb) {
    const workbook = (0, _protobiMsexcelBuilder.createWorkbook)();
    cb && cb({
        type: 'pre',
        target: 'workbook',
        context: {
            workbook
        }
    });
    sheets.forEach(([name, rows])=>{
        const sheet = workbook.createSheet(name, rows[0].length, rows.length);
        cb && cb({
            type: 'pre',
            target: 'sheet',
            context: {
                workbook,
                sheet,
                name,
                rows
            }
        });
        rows.forEach((columns, rowIndex)=>{
            cb && cb({
                type: 'pre',
                target: 'row',
                context: {
                    workbook,
                    sheet,
                    name,
                    rows,
                    columns,
                    rowIndex
                }
            });
            columns.forEach((column, columnIndex)=>{
                cb && cb({
                    type: 'pre',
                    target: 'column',
                    context: {
                        workbook,
                        sheet,
                        name,
                        rows,
                        columns,
                        rowIndex,
                        column,
                        columnIndex
                    }
                });
                sheet.set(columnIndex + 1, rowIndex + 1, column);
                cb && cb({
                    type: 'post',
                    target: 'column',
                    context: {
                        workbook,
                        sheet,
                        name,
                        rows,
                        columns,
                        rowIndex,
                        column,
                        columnIndex
                    }
                });
            });
            cb && cb({
                type: 'post',
                target: 'row',
                context: {
                    workbook,
                    sheet,
                    name,
                    rows,
                    columns,
                    rowIndex
                }
            });
        });
        cb && cb({
            type: 'post',
            target: 'sheet',
            context: {
                workbook,
                sheet,
                name,
                rows
            }
        });
    });
    cb && cb({
        type: 'post',
        target: 'workbook',
        context: {
            workbook
        }
    });
    const jszip = await workbook.generate();
    const blob = await jszip.generateAsync({
        type: "blob",
        mimeType: 'application/vnd.ms-excel;'
    });
    (0, _bowser.downloadBlob)(filename, blob);
}
function addRange(sheet, range, origin = {}) {
    const { column: startColumn = 0, row: startRow = 0 } = origin;
    const [firstRow] = sheet;
    const [firstRangeRow] = range;
    const maxRow = sheet.length;
    const maxColumn = firstRow.length;
    const maxRangeRow = startRow + range.length;
    const maxRangeColumn = startColumn + firstRangeRow.length;
    const missingRows = maxRangeRow - maxRow;
    const missingColumns = maxRangeColumn - maxColumn;
    const enoughRows = missingRows > 0 ? sheet.concat(Array(missingRows).fill().map(()=>Array(firstRow.length).fill({
            set: ''
        }))) : sheet;
    const enoughColumns = missingColumns > 0 ? enoughRows.map((columns)=>columns.concat(Array(missingColumns).fill({
            set: ''
        }))) : enoughRows;
    range.forEach((columns, rowIndex)=>{
        const currentRow = enoughColumns[startRow + rowIndex];
        columns.forEach((value, columnIndex)=>{
            currentRow[startColumn + columnIndex] = value;
        });
    });
    return enoughColumns;
}

},{"protobi-msexcel-builder":"37535","external/bowser":"e43Gj","save-csv":"lGcYj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"37535":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 1.11.1
/*
  MS Excel 2007 Creameater v0.0.1
  Author : chuanyi.zheng@gmail.com
  Extended: pieter@protobi.com
  History: 2012/11/07 first created
 */ (function() {
    var Anchor, CalcChain, ContentTypes, DocPropsApp, Image, ImageType, JSDateToExcel, JSZip, SharedStrings, Sheet, Style, Workbook, WorksheetComments, WorksheetCommentsDrawings, XlDrawingRels, XlWorkbook, XlWorkbookRels, XlWorksheetRels, addressRegex, baseXl, colCache, excelbuilder, fs, tool, xml, bind = function(fn, me) {
        return function() {
            return fn.apply(me, arguments);
        };
    };
    if (typeof window !== "undefined" && window !== null && window.JSZip != null) JSZip = window.JSZip;
    else JSZip = require("1613cb6b6f2d38f");
    if (typeof window !== "undefined" && window !== null && window.xmlbuilder != null) xml = window.xmlbuilder;
    else xml = require("8268c8dbe790e0da");
    if (typeof window !== "undefined" && window !== null && window.xmlbuilder != null) fs = window.xmlbuilder;
    else fs = require("1c6cbb1f4501a847");
    tool = {
        i2a: function(column) {
            var letter, temp;
            temp = void 0;
            letter = '';
            while(column > 0){
                temp = (column - 1) % 26;
                letter = String.fromCharCode(temp + 65) + letter;
                column = (column - temp - 1) / 26;
            }
            return letter;
        },
        cell: function(col1, row1) {
            return this.i2a(col1) + row1;
        }
    };
    ImageType = {
        SVG: "image/svg+xml",
        PNG: "image/png"
    };
    addressRegex = /^[A-Z]+\d+$/;
    colCache = {
        _dictionary: [
            'A',
            'B',
            'C',
            'D',
            'E',
            'F',
            'G',
            'H',
            'I',
            'J',
            'K',
            'L',
            'M',
            'N',
            'O',
            'P',
            'Q',
            'R',
            'S',
            'T',
            'U',
            'V',
            'W',
            'X',
            'Y',
            'Z'
        ],
        _l2nFill: 0,
        _l2n: {},
        _n2l: [],
        _level: function(n) {
            if (n <= 26) return 1;
            if (n <= 676) return 2;
            return 3;
        },
        _fill: function(level) {
            var c, l1, l2, l3, n, v;
            c = void 0;
            v = void 0;
            l1 = void 0;
            l2 = void 0;
            l3 = void 0;
            n = 1;
            if (level >= 4) throw new Error('Out of bounds. Excel supports columns from 1 to 16384');
            if (this._l2nFill < 1 && level >= 1) {
                while(n <= 26){
                    c = this._dictionary[n - 1];
                    this._n2l[n] = c;
                    this._l2n[c] = n;
                    n++;
                }
                this._l2nFill = 1;
            }
            if (this._l2nFill < 2 && level >= 2) {
                n = 27;
                while(n <= 702){
                    v = n - 27;
                    l1 = v % 26;
                    l2 = Math.floor(v / 26);
                    c = this._dictionary[l2] + this._dictionary[l1];
                    this._n2l[n] = c;
                    this._l2n[c] = n;
                    n++;
                }
                this._l2nFill = 2;
            }
            if (this._l2nFill < 3 && level >= 3) {
                n = 703;
                while(n <= 16384){
                    v = n - 703;
                    l1 = v % 26;
                    l2 = Math.floor(v / 26) % 26;
                    l3 = Math.floor(v / 676);
                    c = this._dictionary[l3] + this._dictionary[l2] + this._dictionary[l1];
                    this._n2l[n] = c;
                    this._l2n[c] = n;
                    n++;
                }
                this._l2nFill = 3;
            }
        },
        l2n: function(l) {
            if (!this._l2n[l]) this._fill(l.length);
            if (!this._l2n[l]) throw new Error('Out of bounds. Invalid column letter: ' + l);
            return this._l2n[l];
        },
        n2l: function(n) {
            if (n < 1 || n > 16384) throw new Error(n + ' is out of bounds. Excel supports columns from 1 to 16384');
            if (!this._n2l[n]) this._fill(this._level(n));
            return this._n2l[n];
        },
        _hash: {},
        validateAddress: function(value) {
            if (!addressRegex.test(value)) throw new Error('Invalid Address: ' + value);
            return true;
        },
        decodeAddress: function(value) {
            var addr, address, char, col1, colNumber, hasCol, hasRow, i, row1, rowNumber;
            addr = value.length < 5 && this._hash[value];
            if (addr) return addr;
            hasCol = false;
            col1 = '';
            colNumber = 0;
            hasRow = false;
            row1 = '';
            rowNumber = 0;
            i = 0;
            char = void 0;
            while(i < value.length){
                char = value.charCodeAt(i);
                if (!hasRow && char >= 65 && char <= 90) {
                    hasCol = true;
                    col1 += value[i];
                    colNumber = colNumber * 26 + char - 64;
                } else if (char >= 48 && char <= 57) {
                    hasRow = true;
                    row1 += value[i];
                    rowNumber = rowNumber * 10 + char - 48;
                } else if (hasRow && hasCol && char !== 36) break;
                i++;
            }
            if (!hasCol) colNumber = void 0;
            else if (colNumber > 16384) throw new Error('Out of bounds. Invalid column letter: ' + col1);
            if (!hasRow) rowNumber = void 0;
            value = col1 + row1;
            address = {
                address: value,
                col: colNumber,
                row: rowNumber,
                $col$row: '$' + col1 + '$' + row1
            };
            if (colNumber <= 100 && rowNumber <= 100) {
                this._hash[value] = address;
                this._hash[address.$col$row] = address;
            }
            return address;
        },
        getAddress: function(r, c) {
            var address;
            if (c) {
                address = this.n2l(c) + r;
                return this.decodeAddress(address);
            }
            return this.decodeAddress(r);
        },
        decode: function(value) {
            var br, parts, result, tl;
            parts = value.split(':');
            if (parts.length === 2) {
                tl = this.decodeAddress(parts[0]);
                br = this.decodeAddress(parts[1]);
                result = {
                    top: Math.min(tl.row, br.row),
                    left: Math.min(tl.col, br.col),
                    bottom: Math.max(tl.row, br.row),
                    right: Math.max(tl.col, br.col)
                };
                result.tl = this.n2l(result.left) + result.top;
                result.br = this.n2l(result.right) + result.bottom;
                result.dimensions = result.tl + ':' + result.br;
                return result;
            }
            return this.decodeAddress(value);
        },
        decodeEx: function(value) {
            var address, bottom, br, groups, left, parts, reference, right, sheetName, tl, top;
            groups = value.match(/(?:(?:(?:'((?:[^']|'')*)')|([^'^ !]*))!)?(.*)/);
            sheetName = groups[1] || groups[2];
            reference = groups[3];
            parts = reference.split(':');
            if (parts.length > 1) {
                tl = this.decodeAddress(parts[0]);
                br = this.decodeAddress(parts[1]);
                top = Math.min(tl.row, br.row);
                left = Math.min(tl.col, br.col);
                bottom = Math.max(tl.row, br.row);
                right = Math.max(tl.col, br.col);
                tl = this.n2l(left) + top;
                br = this.n2l(right) + bottom;
                return {
                    top: top,
                    left: left,
                    bottom: bottom,
                    right: right,
                    sheetName: sheetName,
                    tl: {
                        address: tl,
                        col: left,
                        row: top,
                        $col$row: '$' + this.n2l(left) + '$' + top,
                        sheetName: sheetName
                    },
                    br: {
                        address: br,
                        col: right,
                        row: bottom,
                        $col$row: '$' + this.n2l(right) + '$' + bottom,
                        sheetName: sheetName
                    },
                    dimensions: tl + ':' + br
                };
            }
            if (reference.startsWith('#')) {
                if (sheetName) return {
                    sheetName: sheetName,
                    error: reference
                };
                else return {
                    error: reference
                };
            }
            address = this.decodeAddress(reference);
            if (sheetName) return {
                sheetName: sheetName,
                address: address.address,
                col: address.col,
                row: address.row,
                $col$row: '$' + col + '$' + row
            };
            else return address;
        },
        encodeAddress: function(row1, col1) {
            return colCache.n2l(col1) + row1;
        },
        encode: function() {
            switch(arguments.length){
                case 2:
                    return colCache.encodeAddress(arguments[0], arguments[1]);
                case 4:
                    return colCache.encodeAddress(arguments[0], arguments[1]) + ':' + colCache.encodeAddress(arguments[2], arguments[3]);
                default:
                    throw new Error('Can only encode with 2 or 4 arguments');
            }
        },
        inRange: function(range, address) {
            var bottom, col1, left, right, row1, top;
            left = range[0];
            top = range[1];
            right = range[range.length - 2];
            bottom = range[range.length - 1];
            col1 = address[0];
            row1 = address[1];
            return col1 >= left && col1 <= right && row1 >= top && row1 <= bottom;
        }
    };
    ContentTypes = function() {
        function ContentTypes(book) {
            this.book = book;
        }
        ContentTypes.prototype._getKnowImageTypes = function() {
            var image, imagesToAdd, imagesToAddDistinct, len, len1, p, q, ref, ref1, sheet;
            imagesToAdd = [];
            debugger;
            imagesToAddDistinct = {};
            ref = this.book.sheets;
            for(p = 0, len = ref.length; p < len; p++){
                sheet = ref[p];
                ref1 = sheet.images;
                for(q = 0, len1 = ref1.length; q < len1; q++){
                    image = ref1[q];
                    if (!!imagesToAddDistinct[image.extension]) imagesToAdd.push({
                        Extension: image.extension,
                        ContentType: image.contentType
                    });
                }
            }
            return imagesToAdd;
        };
        ContentTypes.prototype.toxml = function() {
            var i, image, len, len1, p, q, ref, ref1, ref2, sheet, t, types;
            types = xml.create('Types', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            types.att('xmlns', 'http://schemas.openxmlformats.org/package/2006/content-types');
            types.ele('Default', {
                Extension: 'png',
                ContentType: 'image/png'
            });
            types.ele('Default', {
                Extension: 'svg',
                ContentType: 'image/svg+xml'
            });
            types.ele('Default', {
                Extension: 'rels',
                ContentType: 'application/vnd.openxmlformats-package.relationships+xml'
            });
            types.ele('Default', {
                Extension: 'xml',
                ContentType: 'application/xml'
            });
            types.ele('Default', {
                Extension: 'vml',
                ContentType: 'application/vnd.openxmlformats-officedocument.vmlDrawing'
            });
            types.ele('Override', {
                PartName: '/xl/workbook.xml',
                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml'
            });
            for(i = p = 1, ref = this.book.sheets.length; 1 <= ref ? p <= ref : p >= ref; i = 1 <= ref ? ++p : --p){
                types.ele('Override', {
                    PartName: '/xl/worksheets/sheet' + i + '.xml',
                    ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml'
                });
                types.ele('Override', {
                    PartName: '/xl/comments' + i + '.xml',
                    ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml'
                });
            }
            types.ele('Override', {
                PartName: '/xl/theme/theme1.xml',
                ContentType: 'application/vnd.openxmlformats-officedocument.theme+xml'
            });
            types.ele('Override', {
                PartName: '/xl/calcChain.xml',
                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml'
            });
            types.ele('Override', {
                PartName: '/xl/styles.xml',
                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml'
            });
            ref1 = this.book.sheets;
            for(q = 0, len = ref1.length; q < len; q++){
                sheet = ref1[q];
                ref2 = sheet.images;
                for(t = 0, len1 = ref2.length; t < len1; t++){
                    image = ref2[t];
                    types.ele('Override', {
                        PartName: '/xl/drawings/drawing' + image.id + '.xml',
                        ContentType: 'application/vnd.openxmlformats-officedocument.drawing+xml'
                    });
                }
            }
            types.ele('Override', {
                PartName: '/docProps/core.xml',
                ContentType: 'application/vnd.openxmlformats-package.core-properties+xml'
            });
            types.ele('Override', {
                PartName: '/docProps/app.xml',
                ContentType: 'application/vnd.openxmlformats-officedocument.extended-properties+xml'
            });
            types.ele('Override', {
                PartName: '/xl/sharedStrings.xml',
                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml'
            });
            return types.end({
                pretty: false
            });
        };
        return ContentTypes;
    }();
    DocPropsApp = function() {
        function DocPropsApp(book) {
            this.book = book;
        }
        DocPropsApp.prototype.toxml = function() {
            var i, p, props, ref, tmp;
            props = xml.create('Properties', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            props.att('xmlns', 'http://schemas.openxmlformats.org/officeDocument/2006/extended-properties');
            props.att('xmlns:vt', 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes');
            props.ele('Application', 'Microsoft Excel');
            props.ele('DocSecurity', '0');
            props.ele('ScaleCrop', 'false');
            tmp = props.ele('HeadingPairs').ele('vt:vector', {
                size: 2,
                baseType: 'variant'
            });
            tmp.ele('vt:variant').ele('vt:lpstr', 'Worksheets');
            tmp.ele('vt:variant').ele('vt:i4', '' + this.book.sheets.length);
            tmp = props.ele('TitlesOfParts').ele('vt:vector', {
                size: this.book.sheets.length,
                baseType: 'lpstr'
            });
            for(i = p = 1, ref = this.book.sheets.length; 1 <= ref ? p <= ref : p >= ref; i = 1 <= ref ? ++p : --p)tmp.ele('vt:lpstr', this.book.sheets[i - 1].name);
            props.ele('Company');
            props.ele('LinksUpToDate', 'false');
            props.ele('SharedDoc', 'false');
            props.ele('HyperlinksChanged', 'false');
            props.ele('AppVersion', '12.0000');
            return props.end({
                pretty: false
            });
        };
        return DocPropsApp;
    }();
    XlWorkbook = function() {
        function XlWorkbook(book) {
            this.book = book;
        }
        XlWorkbook.prototype.toxml = function() {
            var definedNames, i, p, ref, tmp, wb;
            wb = xml.create('workbook', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            wb.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            wb.att('xmlns:r', 'http://schemas.openxmlformats.org/officeDocument/2006/relationships');
            wb.att('xmlns:mc', 'http://schemas.openxmlformats.org/markup-compatibility/2006');
            wb.att('mc:Ignorable', "x15 xr xr6 xr10 xr2");
            wb.att('xmlns:x15', "http://schemas.microsoft.com/office/spreadsheetml/2010/11/main");
            wb.att('xmlns:xr', "http://schemas.microsoft.com/office/spreadsheetml/2014/revision");
            wb.att('xmlns:xr6', "http://schemas.microsoft.com/office/spreadsheetml/2016/revision6");
            wb.att('xmlns:xr10', "http://schemas.microsoft.com/office/spreadsheetml/2016/revision10");
            wb.att('xmlns:xr2', "http://schemas.microsoft.com/office/spreadsheetml/2015/revision2");
            wb.ele('fileVersion', {
                appName: 'xl',
                lastEdited: '4',
                lowestEdited: '4',
                rupBuild: '4505'
            });
            wb.ele('workbookPr', {
                filterPrivacy: '1',
                defaultThemeVersion: '124226'
            });
            wb.ele('bookViews').ele('workbookView', {
                xWindow: '0',
                yWindow: '90',
                windowWidth: '19200',
                windowHeight: '11640'
            });
            tmp = wb.ele('sheets');
            for(i = p = 1, ref = this.book.sheets.length; 1 <= ref ? p <= ref : p >= ref; i = 1 <= ref ? ++p : --p)tmp.ele('sheet', {
                name: this.book.sheets[i - 1].name,
                sheetId: '' + i,
                'r:id': 'rId' + i
            });
            definedNames = wb.ele('definedNames');
            this.book.sheets.forEach(function(sheet, idx) {
                var range;
                if (sheet.autofilter) definedNames.ele('definedName', {
                    name: '_xlnm._FilterDatabase',
                    hidden: '1',
                    localSheetId: idx
                }).raw("'" + sheet.name + "'!" + sheet.getRange());
                if (sheet._repeatRows || sheet._repeatCols) {
                    range = '';
                    if (sheet._repeatCols) range += "'" + sheet.name + "'!$" + tool.i2a(sheet._repeatCols.start) + ":$" + tool.i2a(sheet._repeatCols.end);
                    if (sheet._repeatRows) range += ",'" + sheet.name + "'!$" + sheet._repeatRows.start + ":$" + sheet._repeatRows.end;
                    return definedNames.ele('definedName', {
                        name: "_xlnm.Print_Titles",
                        localSheetId: idx
                    }).raw(range);
                }
            });
            wb.ele('calcPr', {
                calcId: '124519'
            });
            return wb.end({
                pretty: false
            });
        };
        return XlWorkbook;
    }();
    XlWorkbookRels = function() {
        function XlWorkbookRels(book) {
            this.book = book;
        }
        XlWorkbookRels.prototype.toxml = function() {
            var i, p, ref, rs;
            rs = xml.create('Relationships', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            rs.att('xmlns', 'http://schemas.openxmlformats.org/package/2006/relationships');
            for(i = p = 1, ref = this.book.sheets.length; 1 <= ref ? p <= ref : p >= ref; i = 1 <= ref ? ++p : --p)rs.ele('Relationship', {
                Id: 'rId' + i,
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet',
                Target: 'worksheets/sheet' + i + '.xml'
            });
            rs.ele('Relationship', {
                Id: 'rId' + (this.book.sheets.length + 1),
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme',
                Target: 'theme/theme1.xml'
            });
            rs.ele('Relationship', {
                Id: 'rId' + (this.book.sheets.length + 2),
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles',
                Target: 'styles.xml'
            });
            rs.ele('Relationship', {
                Id: 'rId' + (this.book.sheets.length + 3),
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings',
                Target: 'sharedStrings.xml'
            });
            rs.ele('Relationship', {
                Id: 'rId' + (this.book.sheets.length + 4),
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/calcChain',
                Target: 'calcChain.xml'
            });
            return rs.end();
        };
        return XlWorkbookRels;
    }();
    XlWorksheetRels = function() {
        function XlWorksheetRels(wsRels) {
            this.wsRels = wsRels;
        }
        XlWorksheetRels.prototype.generate = function() {};
        XlWorksheetRels.prototype.toxml = function() {
            var len, p, ref, rs, wsRel;
            rs = xml.create('Relationships', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            rs.att('xmlns', 'http://schemas.openxmlformats.org/package/2006/relationships');
            ref = this.wsRels;
            for(p = 0, len = ref.length; p < len; p++){
                wsRel = ref[p];
                rs.ele('Relationship', {
                    Id: wsRel.id,
                    Type: wsRel.type,
                    Target: wsRel.target
                });
            }
            return rs.end({
                pretty: false
            });
        };
        return XlWorksheetRels;
    }();
    WorksheetComments = function() {
        function WorksheetComments(comments) {
            this.comments = comments;
        }
        WorksheetComments.prototype.generate = function() {};
        WorksheetComments.prototype.toxml = function() {
            var cellRef, col1, comment, commentList, entry, i, len, n, note, nstr, p, props, rPr, ref, row1, rs, run, text;
            rs = xml.create('comments', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            rs.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            rs.att('xmlns:mc', 'http://schemas.openxmlformats.org/markup-compatibility/2006');
            rs.att('mc:Ignorable', 'xr');
            rs.att('xmlns:xr', 'http://schemas.microsoft.com/office/spreadsheetml/2014/revision');
            rs.ele('authors').ele('author', 'Author');
            commentList = rs.ele('commentList');
            ref = this.comments;
            for(col1 in ref){
                entry = ref[col1];
                for(row1 in entry){
                    note = entry[row1];
                    cellRef = tool.cell(col1, row1);
                    comment = commentList.ele('comment').att('ref', cellRef).att('authorId', '0').att('shapeId', '0');
                    text = comment.ele('text');
                    if (note && !Array.isArray(note)) note = [
                        note
                    ];
                    for(i = p = 0, len = note.length; p < len; i = ++p){
                        n = note[i];
                        nstr = n && typeof n === 'string' ? n : n.text;
                        props = n && typeof n === 'string' ? null : n.props;
                        run = text.ele('r');
                        rPr = run.ele('rPr');
                        if (props) {
                            if (props.bold) rPr.ele('b');
                            if (props.fontSize) rPr.ele('sz').att('va', props.fontSize);
                            if (props.fontFamily) rPr.ele('rFont').att('va', props.fontFamily);
                        }
                        run.ele('t', nstr + '\n').att('xml:space', 'preserve');
                    }
                }
            }
            return rs.end({
                pretty: false
            });
        };
        return WorksheetComments;
    }();
    WorksheetCommentsDrawings = function() {
        function WorksheetCommentsDrawings(notes) {
            this.notes = notes;
        }
        WorksheetCommentsDrawings.prototype.generate = function() {};
        WorksheetCommentsDrawings.prototype.toxml = function() {
            var anchors, cd, cellRef, col1, entry, note, num_cols, num_lines, num_rows, padding, ref, row1, rs, shape;
            rs = xml.create('xml');
            rs.att('xmlns:v', "urn:schemas-microsoft-com:vml");
            rs.att('xlmns:o', "urn:schemas-microsoft-com:office:office");
            rs.att('xmlns:x', "urn:schemas-microsoft-com:office:excel");
            rs.ele('o:shapelayout').att('v:ext', 'edit').ele('o:idmap').att('v:ext', 'edit').att('data', '2');
            rs.ele('v:shapetype');
            ref = this.notes;
            for(col1 in ref){
                entry = ref[col1];
                for(row1 in entry){
                    note = entry[row1];
                    cellRef = tool.cell(col1, row1);
                    padding = 5;
                    num_rows = 5;
                    num_cols = 5;
                    if (Array.isArray(note)) num_lines = note.length + 1;
                    anchors = [
                        +col1,
                        padding,
                        +row1 - 1,
                        padding,
                        +col1 + num_cols,
                        padding,
                        +row1 + num_rows + 1,
                        padding
                    ];
                    shape = rs.ele('v:shape', {
                        "id": cellRef,
                        "type": "#_x0000_t202",
                        "style": 'visibility:hidden',
                        "fillcolor": "#EEEEEE [80]",
                        "strokecolor": "#3399CC",
                        "o:insetmode": "auto"
                    });
                    shape.ele('v:fill').att("color2", "#EEEEEE [80]");
                    shape.ele('v:shadow').att("color", "none").att("obscured", "t");
                    shape.ele('v:path').att('o:connecttype', 'none');
                    shape.ele("v:textbox").att("style", "mso-direction-alt:auto").ele("div").att('style', 'text-align: left');
                    cd = shape.ele('x:ClientData').att('ObjectType', 'Note');
                    cd.ele('x:MoveWithCells');
                    cd.ele('x:SizeWithCells');
                    cd.ele('x:Anchor', '\n' + anchors.join(',') + '\n');
                    cd.ele('x:AutoFill', 'False');
                    cd.ele('x:Row', row1 - 1);
                    cd.ele('x:Column', col1 - 1);
                }
            }
            return rs.end({
                pretty: false
            });
        };
        return WorksheetCommentsDrawings;
    }();
    XlDrawingRels = function() {
        function XlDrawingRels(dwRels1) {
            this.dwRels = dwRels1;
        }
        XlDrawingRels.prototype.generate = function() {};
        XlDrawingRels.prototype.toxml = function() {
            var dwRel, len, p, ref, rs;
            rs = xml.create('Relationships', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            rs.att('xmlns', 'http://schemas.openxmlformats.org/package/2006/relationships');
            ref = this.dwRels;
            for(p = 0, len = ref.length; p < len; p++){
                dwRel = ref[p];
                rs.ele('Relationship', {
                    Id: dwRel.id,
                    Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/image',
                    Target: dwRel.target
                });
            }
            return rs.end({
                pretty: false
            });
        };
        return XlDrawingRels;
    }();
    SharedStrings = function() {
        function SharedStrings() {
            this.cache = {};
            this.arr = [];
        }
        SharedStrings.prototype.str2id = function(s) {
            var id;
            id = this.cache[s];
            if (id) return id;
            else {
                this.arr.push(s);
                this.cache[s] = this.arr.length;
                return this.arr.length;
            }
        };
        SharedStrings.prototype.toxml = function() {
            var i, p, ref, si, sst;
            sst = xml.create('sst', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            sst.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            sst.att('count', '' + this.arr.length);
            sst.att('uniqueCount', '' + this.arr.length);
            for(i = p = 0, ref = this.arr.length; 0 <= ref ? p < ref : p > ref; i = 0 <= ref ? ++p : --p){
                si = sst.ele('si');
                si.ele('t', this.arr[i]);
                si.ele('phoneticPr', {
                    fontId: 1,
                    type: 'noConversion'
                });
            }
            return sst.end({
                pretty: false
            });
        };
        return SharedStrings;
    }();
    Anchor = function() {
        var asInstance;
        function Anchor(worksheet, address, offset) {
            var decoded;
            this.worksheet = worksheet;
            if (offset === void 0) offset = 0;
            if (!address) {
                this.nativeCol = 0;
                this.nativeColOff = 0;
                this.nativeRow = 0;
                this.nativeRowOff = 0;
            } else if (typeof address === 'string') {
                decoded = colCache.decodeAddress(address);
                this.nativeCol = decoded.col + offset;
                this.nativeColOff = 0;
                this.nativeRow = decoded.row + offset;
                this.nativeRowOff = 0;
            } else if (address.nativeCol !== void 0) {
                this.nativeCol = address.nativeCol || 0;
                this.nativeColOff = address.nativeColOff || 0;
                this.nativeRow = address.nativeRow || 0;
                this.nativeRowOff = address.nativeRowOff || 0;
            } else if (address.col !== void 0) {
                this.col = address.col + offset;
                this.row = address.row + offset;
            } else {
                this.nativeCol = 0;
                this.nativeColOff = 0;
                this.nativeRow = 0;
                this.nativeRowOff = 0;
            }
            return;
        }
        Object.defineProperty(Anchor.prototype, 'col', {
            get: function() {
                return this.nativeCol + Math.min(this.colWidth - 1, this.nativeColOff) / this.colWidth;
            },
            set: function(v) {
                this.nativeCol = Math.floor(v);
                this.nativeColOff = Math.floor((v - this.nativeCol) * this.colWidth);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Anchor.prototype, 'row', {
            get: function() {
                return this.nativeRow + Math.min(this.rowHeight - 1, this.nativeRowOff) / this.rowHeight;
            },
            set: function(v) {
                this.nativeRow = Math.floor(v);
                this.nativeRowOff = Math.floor((v - this.nativeRow) * this.rowHeight);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Anchor.prototype, 'colWidth', {
            get: function() {
                this.worksheet && this.worksheet.width(this.nativeCol, this.nativeCol + 1);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Anchor.prototype, 'rowHeight', {
            get: function() {
                if (this.worksheet && this.worksheet.getRow(this.nativeRow + 1) && this.worksheet.getRow(this.nativeRow + 1).height) return Math.floor(this.worksheet.getRow(this.nativeRow + 1).height * 10000);
                else return 180000;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Anchor.prototype, 'model', {
            get: function() {
                return {
                    nativeCol: this.nativeCol,
                    nativeColOff: this.nativeColOff,
                    nativeRow: this.nativeRow,
                    nativeRowOff: this.nativeRowOff
                };
            },
            set: function(value) {
                this.nativeCol = value.nativeCol;
                this.nativeColOff = value.nativeColOff;
                this.nativeRow = value.nativeRow;
                this.nativeRowOff = value.nativeRowOff;
            },
            enumerable: true,
            configurable: true
        });
        asInstance = function(model) {
            if (model instanceof Anchor || model === null) return model;
            else return new Anchor(model);
        };
        Anchor.prototype.toxml = function(xml) {
            var wb;
            wb = xml.create('workbook', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            wb.ele('from').ele('workbookView', {
                xWindow: '0',
                yWindow: '90',
                windowWidth: '19200',
                windowHeight: '11640'
            });
            wb.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            wb.att('xmlns:r', 'http://schemas.openxmlformats.org/officeDocument/2006/relationships');
            wb.ele('fileVersion', {
                appName: 'xl',
                lastEdited: '4',
                lowestEdited: '4',
                rupBuild: '4505'
            });
            wb.ele('workbookPr', {
                filterPrivacy: '1',
                defaultThemeVersion: '124226'
            });
            return wb.ele('bookViews').ele('workbookView', {
                xWindow: '0',
                yWindow: '90',
                windowWidth: '19200',
                windowHeight: '11640'
            });
        };
        return Anchor;
    }();
    Sheet = function() {
        function Sheet(book, name1, cols1, rows1) {
            var i, j, p, q, ref, ref1;
            this.book = book;
            this.name = name1;
            this.cols = cols1;
            this.rows = rows1;
            this.name = this.name.replace(/[\/*:?\[\]]/g, '-');
            this.data = {};
            for(i = p = 1, ref = this.rows; 1 <= ref ? p <= ref : p >= ref; i = 1 <= ref ? ++p : --p){
                this.data[i] = {};
                for(j = q = 1, ref1 = this.cols; 1 <= ref1 ? q <= ref1 : q >= ref1; j = 1 <= ref1 ? ++q : --q)this.data[i][j] = {
                    v: 0
                };
            }
            this.merges = [];
            this.col_wd = [];
            this.row_ht = {};
            this.styles = {};
            this.formulas = [];
            this._pageMargins = {
                left: '0.7',
                right: '0.7',
                top: '0.75',
                bottom: '0.75',
                header: '0.3',
                footer: '0.3'
            };
            this.images = [];
        }
        Sheet.prototype.addImage = function(image) {
            var decoded, id, imageToAdd, media;
            if (!image || !image.range || !image.base64 || !image.extension) throw Error('please verify your image format');
            if (typeof image.range !== 'string' || !/\w+\d+:\w+\d/i.test(image.range)) throw Error('Please provide range parameter like `B2:F6`.');
            decoded = colCache.decode(image.range);
            this.range = {
                from: new Anchor(this.worksheet, decoded.tl, -1),
                to: new Anchor(this.worksheet, decoded.br, 0),
                editAs: 'oneCell'
            };
            id = this.book.medias.length + 1;
            imageToAdd = new Image(id, image.extension, image.base64, this.range, image.options || {});
            media = this.book._addMediaFromImage(imageToAdd);
            this.images.push(imageToAdd);
            return id;
        };
        Sheet.prototype.getImage = function(id) {
            return this.images[id];
        };
        Sheet.prototype.getImages = function() {
            return this.images;
        };
        Sheet.prototype.removeImage = function(id) {
            var foundIndex, image, index, len, p, ref;
            foundIndex = -1;
            ref = this.images;
            for(index = p = 0, len = ref.length; p < len; index = ++p){
                image = ref[index];
                if (image.id === id) {
                    foundIndex = index;
                    break;
                }
            }
            if (foundIndex > -1) return this.images.splice(foundIndex, 1);
        };
        /* old approach for adding background images.
      addBackgroundImage: (imageId) ->
        model = {
          type: 'background',
          imageId,
        }
        @_media.push(new Image(this, model))
    
      getBackgroundImageId: ()->
        image = @_media.find(m => m.type == 'background')
        return image && image.imageId
     */ Sheet.prototype.cells = function(rows) {
            var c, cell, len, p, r, results, row1;
            results = [];
            for(r = p = 0, len = rows.length; p < len; r = ++p){
                row1 = rows[r];
                results.push((function() {
                    var len1, q, results1;
                    results1 = [];
                    for(c = q = 0, len1 = row1.length; q < len1; c = ++q){
                        cell = row1[c];
                        if (cell !== null && cell !== void 0) results1.push(this.set(+c + 1, +r + 1, cell));
                        else results1.push(void 0);
                    }
                    return results1;
                }).call(this));
            }
            return results;
        };
        Sheet.prototype.set = function(col1, row1, str) {
            var arg, c, cell, cells, key, r;
            if (arguments.length === 1 && col1 && typeof col1 === 'object') {
                cells = col1;
                for(r in cells){
                    row1 = cells[r];
                    for(c in row1){
                        cell = row1[c];
                        if (cell !== null && cell !== void 0) this.set(+c + 1, +r + 1, cell);
                    }
                }
                return this;
            } else {
                if (!this.data[row1] || !this.data[row1][col1]) return this;
                if (str instanceof Date) {
                    this.set(col1, row1, JSDateToExcel(str));
                    this.fill(col1, row1, {
                        type: "solid",
                        fgColor: "FFFFFF"
                    });
                    this.numberFormat(col1, row1, 'd-mmm');
                } else if (typeof str === 'object' && !Array.isArray(str)) for(key in str){
                    arg = str[key];
                    if (typeof this[key] === 'function') {
                        if (key === 'width') this[key](col1, str[key]);
                        else this[key](col1, row1, str[key]);
                    } else console.error('Ignoring ', key, col1, row1, str[key]);
                }
                else if (typeof str === 'string') {
                    if (str !== null && str !== '' && str !== void 0) {
                        str = str.replace(/[\u0000-\u001F\u007F-\u009F\u200b]/g, "");
                        this.data[row1][col1].v = this.book.ss.str2id('' + str);
                        return this.data[row1][col1].dataType = 'string';
                    }
                } else if (typeof str === 'number') {
                    this.data[row1][col1].v = str;
                    return this.data[row1][col1].dataType = 'number';
                } else this.data[row1][col1].v = str;
            }
            return this;
        };
        Sheet.prototype.text = function(col1, row1, str) {
            if (typeof str === 'string') {
                if (str !== null && str !== '' && str !== void 0) {
                    str = str.replace(/[\u0000-\u001F\u007F-\u009F\u200b]/g, "");
                    this.data[row1][col1].v = this.book.ss.str2id('' + str);
                    return this.data[row1][col1].dataType = 'string';
                }
            }
        };
        Sheet.prototype.formula = function(col1, row1, str) {
            var i, len, p, ref, sheet, sheet_idx;
            if (typeof str === 'string') {
                this.formulas = this.formulas || [];
                this.formulas[row1] = this.formulas[row1] || [];
                ref = this.book.sheets;
                for(i = p = 0, len = ref.length; p < len; i = ++p){
                    sheet = ref[i];
                    if (sheet.name === this.name) sheet_idx = i;
                }
                this.book.cc.add_ref(sheet_idx, col1, row1);
                return this.formulas[row1][col1] = str;
            }
        };
        Sheet.prototype.note = function(col1, row1, note) {
            if (note && (typeof note === 'string' || typeof note === 'object' && (note.length || note.text))) {
                this.notes = this.notes || {};
                this.notes[col1] = this.notes[col1] || {};
                return this.notes[col1][row1] = note;
            }
        };
        Sheet.prototype.merge = function(from_cell, to_cell) {
            return this.merges.push({
                from: from_cell,
                to: to_cell
            });
        };
        Sheet.prototype.width = function(col1, wd) {
            return this.col_wd.push({
                c: col1,
                cw: wd
            });
        };
        Sheet.prototype.getColWidth = function(col1) {
            var _col, len, p, ref;
            ref = this.col_wd;
            for(p = 0, len = ref.length; p < len; p++){
                _col = ref[p];
                if (_col.c === col1) return Math.floor(_col.cw * 10000);
            }
            return 640000;
        };
        Sheet.prototype.height = function(row1, ht) {
            return this.row_ht[row1] = ht;
        };
        Sheet.prototype.font = function(col1, row1, font_s) {
            return this.styles['font_' + col1 + '_' + row1] = this.book.st.font2id(font_s);
        };
        Sheet.prototype.fill = function(col1, row1, fill_s) {
            return this.styles['fill_' + col1 + '_' + row1] = this.book.st.fill2id(fill_s);
        };
        Sheet.prototype.border = function(col1, row1, bder_s) {
            return this.styles['bder_' + col1 + '_' + row1] = this.book.st.bder2id(bder_s);
        };
        Sheet.prototype.numberFormat = function(col1, row1, numfmt_s) {
            return this.styles['numfmt_' + col1 + '_' + row1] = this.book.st.numfmt2id(numfmt_s);
        };
        Sheet.prototype.align = function(col1, row1, align_s) {
            return this.styles['algn_' + col1 + '_' + row1] = align_s;
        };
        Sheet.prototype.valign = function(col1, row1, valign_s) {
            return this.styles['valgn_' + col1 + '_' + row1] = valign_s;
        };
        Sheet.prototype.rotate = function(col1, row1, textRotation) {
            return this.styles['rotate_' + col1 + '_' + row1] = textRotation;
        };
        Sheet.prototype.wrap = function(col1, row1, wrap_s) {
            return this.styles['wrap_' + col1 + '_' + row1] = wrap_s;
        };
        Sheet.prototype.autoFilter = function(filter_s) {
            return this.autofilter = typeof filter_s === 'string' ? filter_s : this.getRange();
        };
        Sheet.prototype._sheetViews = {
            workbookViewId: '0'
        };
        Sheet.prototype._sheetViewsPane = {};
        Sheet.prototype._pageSetup = {
            paperSize: '9',
            orientation: 'portrait',
            horizontalDpi: '200',
            verticalDpi: '200'
        };
        Sheet.prototype.sheetViews = function(obj) {
            var key, results, val;
            results = [];
            for(key in obj){
                val = obj[key];
                if (typeof this[key] === 'function') results.push(this[key](obj[key]));
                else results.push(this._sheetViews[key] = val);
            }
            return results;
        };
        Sheet.prototype.split = function(ncols, nrows, state, activePane, topLeftCell) {
            state = state || "frozen";
            activePane = activePane || "bottomRight";
            topLeftCell = topLeftCell || tool.i2a((ncols || 0) + 1) + ((nrows || 0) + 1);
            if (ncols) this._sheetViewsPane.xSplit = '' + ncols;
            if (nrows) this._sheetViewsPane.ySplit = '' + nrows;
            if (state) this._sheetViewsPane.state = state;
            if (activePane) this._sheetViewsPane.activePane = activePane;
            if (topLeftCell) return this._sheetViewsPane.topLeftCell = topLeftCell;
        };
        Sheet.prototype.printBreakRows = function(arr) {
            return this._rowBreaks = arr;
        };
        Sheet.prototype.printBreakColumns = function(arr) {
            return this._colBreaks = arr;
        };
        Sheet.prototype.printRepeatRows = function(start, end) {
            if (Array.isArray(start)) return this._repeatRows = {
                start: start[0],
                end: start[1]
            };
            else return this._repeatRows = {
                start: start,
                end: end
            };
        };
        Sheet.prototype.printRepeatColumns = function(start, end) {
            if (Array.isArray(start)) return this._repeatCols = {
                start: start[0],
                end: start[1]
            };
            else return this._repeatCols = {
                start: start,
                end: end
            };
        };
        Sheet.prototype.pageSetup = function(obj) {
            var key, results, val;
            results = [];
            for(key in obj){
                val = obj[key];
                results.push(this._pageSetup[key] = val);
            }
            return results;
        };
        Sheet.prototype.pageMargins = function(obj) {
            var key, results, val;
            results = [];
            for(key in obj){
                val = obj[key];
                results.push(this._pageMargins[key] = val);
            }
            return results;
        };
        Sheet.prototype.style_id = function(col1, row1) {
            var id, inx, style;
            inx = '_' + col1 + '_' + row1;
            style = {
                numfmt_id: this.styles['numfmt' + inx],
                font_id: this.styles['font' + inx],
                fill_id: this.styles['fill' + inx],
                bder_id: this.styles['bder' + inx],
                align: this.styles['algn' + inx],
                valign: this.styles['valgn' + inx],
                rotate: this.styles['rotate' + inx],
                wrap: this.styles['wrap' + inx]
            };
            id = this.book.st.style2id(style);
            return id;
        };
        Sheet.prototype.getRange = function() {
            return '$A$1:$' + tool.i2a(this.cols) + '$' + this.rows;
        };
        Sheet.prototype.toxml = function() {
            var c, cb, cols, cw, ht, i, ix, j, len, len1, len2, len3, len4, m, mc, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, sd, sid, t, u, w, ws, wsRel, x, y;
            ws = xml.create('worksheet', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            ws.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            ws.att('xmlns:r', 'http://schemas.openxmlformats.org/officeDocument/2006/relationships');
            ws.ele('dimension', {
                ref: 'A1'
            });
            ws.ele('sheetViews').ele('sheetView', this._sheetViews).ele('pane', this._sheetViewsPane);
            ws.ele('sheetFormatPr', {
                defaultRowHeight: '13.5'
            });
            if (this.col_wd.length > 0) {
                cols = ws.ele('cols');
                ref = this.col_wd;
                for(p = 0, len = ref.length; p < len; p++){
                    cw = ref[p];
                    cols.ele('col', {
                        min: '' + cw.c,
                        max: '' + cw.c,
                        width: cw.cw,
                        customWidth: '1'
                    });
                }
            }
            sd = ws.ele('sheetData');
            for(i = q = 1, ref1 = this.rows; 1 <= ref1 ? q <= ref1 : q >= ref1; i = 1 <= ref1 ? ++q : --q){
                r = sd.ele('row', {
                    r: '' + i,
                    spans: '1:' + this.cols
                });
                ht = this.row_ht[i];
                if (ht) {
                    r.att('ht', ht);
                    r.att('customHeight', '1');
                }
                for(j = t = 1, ref2 = this.cols; 1 <= ref2 ? t <= ref2 : t >= ref2; j = 1 <= ref2 ? ++t : --t){
                    ix = this.data[i][j];
                    sid = this.style_id(j, i);
                    if (ix.v !== null && ix.v !== void 0 || sid !== 1) {
                        c = r.ele('c', {
                            r: '' + tool.i2a(j) + i
                        });
                        if (sid !== 1) c.att('s', '' + (sid - 1));
                        if (this.formulas[i] && this.formulas[i][j]) {
                            c.ele('f', '' + this.formulas[i][j]);
                            c.ele('v');
                        } else if (ix.dataType === 'string') {
                            c.att('t', 's');
                            c.ele('v', '' + (ix.v - 1));
                        } else if (ix.dataType === 'number') c.ele('v', '' + ix.v);
                    }
                }
            }
            if (this.merges.length > 0) {
                mc = ws.ele('mergeCells', {
                    count: this.merges.length
                });
                ref3 = this.merges;
                for(u = 0, len1 = ref3.length; u < len1; u++){
                    m = ref3[u];
                    mc.ele('mergeCell', {
                        ref: '' + tool.i2a(m.from.col) + m.from.row + ':' + tool.i2a(m.to.col) + m.to.row
                    });
                }
            }
            if (typeof this.autofilter === 'string') ws.ele('autoFilter', {
                ref: this.autofilter
            });
            ws.ele('phoneticPr', {
                fontId: '1',
                type: 'noConversion'
            });
            ws.ele('pageMargins', this._pageMargins);
            ws.ele('pageSetup', this._pageSetup);
            if (this._rowBreaks && this._rowBreaks.length) {
                cb = ws.ele('rowBreaks', {
                    count: this._rowBreaks.length,
                    manualBreakCount: this._rowBreaks.length
                });
                ref4 = this._rowBreaks;
                for(w = 0, len2 = ref4.length; w < len2; w++){
                    i = ref4[w];
                    cb.ele('brk', {
                        id: i,
                        man: '1',
                        max: "1048575"
                    });
                }
            }
            if (this._colBreaks && this._colBreaks.length) {
                cb = ws.ele('colBreaks', {
                    count: this._colBreaks.length,
                    manualBreakCount: this._colBreaks.length
                });
                ref5 = this._colBreaks;
                for(x = 0, len3 = ref5.length; x < len3; x++){
                    i = ref5[x];
                    cb.ele('brk', {
                        id: i,
                        man: '1',
                        max: "1048575"
                    });
                }
            }
            ref6 = this.wsRels;
            for(y = 0, len4 = ref6.length; y < len4; y++){
                wsRel = ref6[y];
                if (wsRel.type === 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing') ws.ele('legacyDrawing', {
                    'r:id': wsRel.id
                });
            }
            return ws.end({
                pretty: false
            });
        };
        return Sheet;
    }();
    CalcChain = function() {
        function CalcChain(book) {
            this.book = book;
            this.cache = {};
        }
        CalcChain.prototype.add_ref = function(idx, col1, row1) {
            var num;
            num = idx + 1;
            if (!this.cache.hasOwnProperty(num)) this.cache[num] = [];
            return this.cache[num].push(tool.i2a(col1) + row1);
        };
        CalcChain.prototype.toxml = function() {
            var cc, el, key, len, p, ref, val;
            cc = xml.create('calcChain', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            cc.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            ref = this.cache;
            for(key in ref){
                val = ref[key];
                for(p = 0, len = val.length; p < len; p++){
                    el = val[p];
                    cc.ele('c', {
                        r: '' + el,
                        i: '' + key
                    });
                }
            }
            return cc.end({
                pretty: false
            });
        };
        return CalcChain;
    }();
    CalcChain = function() {
        function CalcChain(book) {
            this.book = book;
            this.cache = {};
        }
        CalcChain.prototype.add_ref = function(idx, col1, row1) {
            var num;
            num = idx + 1;
            if (!this.cache.hasOwnProperty(num)) this.cache[num] = [];
            return this.cache[num].push(tool.i2a(col1) + row1);
        };
        CalcChain.prototype.toxml = function() {
            var cc, el, key, len, p, ref, val;
            cc = xml.create('calcChain', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            cc.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            ref = this.cache;
            for(key in ref){
                val = ref[key];
                for(p = 0, len = val.length; p < len; p++){
                    el = val[p];
                    cc.ele('c', {
                        r: '' + el,
                        i: '' + key
                    });
                }
            }
            return cc.end();
        };
        return CalcChain;
    }();
    Style = function() {
        function Style(book) {
            this.book = book;
            this.cache = {};
            this.mfonts = [];
            this.mfills = [];
            this.mbders = [];
            this.mstyle = [];
            this.numberFormats = {
                0: 'General',
                1: '0',
                2: '0.00',
                3: '#,##0',
                4: '#,##0.00',
                9: '0%',
                10: '0.00%',
                11: '0.00E+00',
                12: '# ?/?',
                13: '# ??/??',
                14: 'm/d/yy',
                15: 'd-mmm-yy',
                16: 'd-mmm',
                17: 'mmm-yy',
                18: 'h:mm AM/PM',
                19: 'h:mm:ss AM/PM',
                20: 'h:mm',
                21: 'h:mm:ss',
                22: 'm/d/yy h:mm',
                37: '#,##0 ;(#,##0)',
                38: '#,##0 ;[Red](#,##0)',
                39: '#,##0.00;(#,##0.00)',
                40: '#,##0.00;[Red](#,##0.00)',
                45: 'mm:ss',
                46: '[h]:mm:ss',
                47: 'mmss.0',
                48: '##0.0E+0',
                49: '@',
                56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
            };
            this.numFmtNextId = 164;
            this.with_default();
        }
        Style.prototype.with_default = function() {
            this.def_font_id = this.font2id(null);
            this.def_fill_id = this.fill2id(null);
            this.def_bder_id = this.bder2id(null);
            this.def_align = '-';
            this.def_valign = '-';
            this.def_rotate = '-';
            this.def_wrap = '-';
            this.def_numfmt_id = 0;
            return this.def_style_id = this.style2id({
                font_id: this.def_font_id,
                fill_id: this.def_fill_id,
                bder_id: this.def_bder_id,
                align: this.def_align,
                valign: this.def_valign,
                rotate: this.def_rotate
            });
        };
        Style.prototype.font2id = function(font) {
            var id, k;
            font || (font = {});
            font.bold || (font.bold = '-');
            font.iter || (font.iter = '-');
            font.sz || (font.sz = '11');
            font.color || (font.color = '-');
            font.name || (font.name = 'Calibri');
            font.scheme || (font.scheme = 'minor');
            font.family || (font.family = '2');
            font.underline || (font.underline = '-');
            font.strike || (font.strike = '-');
            font.outline || (font.outline = '-');
            font.shadow || (font.shadow = '-');
            k = 'font_' + font.bold + font.iter + font.sz + font.color + font.name + font.scheme + font.family + font.underline + font.strike + font.outline + font.shadow;
            id = this.cache[k];
            if (id) return id;
            else {
                this.mfonts.push(font);
                this.cache[k] = this.mfonts.length;
                return this.mfonts.length;
            }
        };
        Style.prototype.fill2id = function(fill) {
            var id, k;
            fill || (fill = {});
            fill.type || (fill.type = 'none');
            fill.bgColor || (fill.bgColor = '-');
            fill.fgColor || (fill.fgColor = '-');
            k = 'fill_' + fill.type + fill.bgColor + fill.fgColor;
            id = this.cache[k];
            if (id) return id;
            else {
                this.mfills.push(fill);
                this.cache[k] = this.mfills.length;
                return this.mfills.length;
            }
        };
        Style.prototype.bder2id = function(bder) {
            var id, k;
            bder || (bder = {});
            bder.left || (bder.left = '-');
            bder.right || (bder.right = '-');
            bder.top || (bder.top = '-');
            bder.bottom || (bder.bottom = '-');
            k = JSON.stringify([
                "bder_",
                bder.left,
                bder.right,
                bder.top,
                bder.bottom
            ]);
            id = this.cache[k];
            if (id) return id;
            else {
                this.mbders.push(bder);
                this.cache[k] = this.mbders.length;
                return this.mbders.length;
            }
        };
        Style.prototype.numfmt2id = function(numfmt) {
            var key;
            if (typeof numfmt === 'number') return numfmt;
            else if (typeof numfmt === 'string') {
                for(key in this.numberFormats){
                    if (this.numberFormats[key] === numfmt) return parseInt(key);
                }
                if (!numfmt) throw "Invalid format specification";
                this.numberFormats[++this.numFmtNextId] = numfmt;
                return this.numFmtNextId;
            }
        };
        Style.prototype.style2id = function(style) {
            var id, k;
            style.align || (style.align = this.def_align);
            style.valign || (style.valign = this.def_valign);
            style.rotate || (style.rotate = this.def_rotate);
            style.wrap || (style.wrap = this.def_wrap);
            style.font_id || (style.font_id = this.def_font_id);
            style.fill_id || (style.fill_id = this.def_fill_id);
            style.bder_id || (style.bder_id = this.def_bder_id);
            style.numfmt_id || (style.numfmt_id = this.def_numfmt_id);
            k = 's_' + [
                style.font_id,
                style.fill_id,
                style.bder_id,
                style.align,
                style.valign,
                style.wrap,
                style.rotate,
                style.numfmt_id
            ].join('_');
            id = this.cache[k];
            if (id) return id;
            else {
                this.mstyle.push(style);
                this.cache[k] = this.mstyle.length;
                return this.mstyle.length;
            }
        };
        Style.prototype.toxml = function() {
            var bders, cs, customNumFmts, e, ea, es, fills, fmt, fonts, key, len, len1, len2, len3, len4, numFmts, o, p, q, ref, ref1, ref2, ref3, ref4, ss, t, u, w;
            ss = xml.create('styleSheet', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            ss.att('xmlns', 'http://schemas.openxmlformats.org/spreadsheetml/2006/main');
            customNumFmts = [];
            ref = this.numberFormats;
            for(key in ref){
                fmt = ref[key];
                if (parseInt(key) >= 164) customNumFmts.push({
                    numFmtId: key,
                    formatCode: fmt
                });
            }
            if (customNumFmts.length > 0) {
                numFmts = ss.ele('numFmts', {
                    count: customNumFmts.length
                });
                for(p = 0, len = customNumFmts.length; p < len; p++){
                    o = customNumFmts[p];
                    numFmts.ele('numFmt', o);
                }
            }
            fonts = ss.ele('fonts', {
                count: this.mfonts.length
            });
            ref1 = this.mfonts;
            for(q = 0, len1 = ref1.length; q < len1; q++){
                o = ref1[q];
                e = fonts.ele('font');
                if (o.bold !== '-') e.ele('b');
                if (o.iter !== '-') e.ele('i');
                if (o.underline !== '-') e.ele('u');
                if (o.strike !== '-') e.ele('strike');
                if (o.outline !== '-') e.ele('outline');
                if (o.shadow !== '-') e.ele('shadow');
                e.ele('sz', {
                    val: o.sz
                });
                if (o.color !== '-') e.ele('color', {
                    rgb: o.color
                });
                e.ele('name', {
                    val: o.name
                });
                e.ele('family', {
                    val: o.family
                });
                e.ele('charset', {
                    val: '134'
                });
                if (o.scheme !== '-') e.ele('scheme', {
                    val: 'minor'
                });
            }
            fills = ss.ele('fills', {
                count: this.mfills.length + 2
            });
            fills.ele('fill').ele('patternFill', {
                patternType: 'none'
            });
            fills.ele('fill').ele('patternFill', {
                patternType: 'gray125'
            });
            ref2 = this.mfills;
            for(t = 0, len2 = ref2.length; t < len2; t++){
                o = ref2[t];
                e = fills.ele('fill');
                es = e.ele('patternFill', {
                    patternType: o.type
                });
                if (o.fgColor !== '-') es.ele('fgColor', {
                    rgb: o.fgColor
                });
                if (o.bgColor !== '-') es.ele('bgColor', {
                    indexed: o.bgColor
                });
            }
            bders = ss.ele('borders', {
                count: this.mbders.length
            });
            ref3 = this.mbders;
            for(u = 0, len3 = ref3.length; u < len3; u++){
                o = ref3[u];
                e = bders.ele('border');
                if (o.left !== '-') {
                    if (typeof o.left === 'string') e.ele('left', {
                        style: o.left
                    }).ele('color', {
                        auto: '1'
                    });
                    else e.ele('left', {
                        style: o.left.style
                    }).ele('color', o.left.color);
                } else e.ele('left');
                if (o.right !== '-') {
                    if (typeof o.right === 'string') e.ele('right', {
                        style: o.right
                    }).ele('color', {
                        auto: '1'
                    });
                    else e.ele('right', {
                        style: o.right.style
                    }).ele('color', o.right.color);
                } else e.ele('right');
                if (o.top !== '-') {
                    if (typeof o.top === 'string') e.ele('top', {
                        style: o.top
                    }).ele('color', {
                        auto: '1'
                    });
                    else e.ele('top', {
                        style: o.top.style
                    }).ele('color', o.top.color);
                } else e.ele('top');
                if (o.bottom !== '-') {
                    if (typeof o.bottom === 'string') e.ele('bottom', {
                        style: o.bottom
                    }).ele('color', {
                        auto: '1'
                    });
                    else e.ele('bottom', {
                        style: o.bottom.style
                    }).ele('color', o.bottom.color);
                } else e.ele('bottom');
                e.ele('diagonal');
            }
            ss.ele('cellStyleXfs', {
                count: '1'
            }).ele('xf', {
                numFmtId: '0',
                fontId: '0',
                fillId: '0',
                borderId: '0'
            }).ele('alignment', {
                vertical: 'center'
            });
            cs = ss.ele('cellXfs', {
                count: this.mstyle.length
            });
            ref4 = this.mstyle;
            for(w = 0, len4 = ref4.length; w < len4; w++){
                o = ref4[w];
                e = cs.ele('xf', {
                    numFmtId: o.numfmt_id || '0',
                    fontId: o.font_id - 1,
                    fillId: o.fill_id + 1,
                    borderId: o.bder_id - 1,
                    xfId: '0'
                });
                if (o.font_id !== 1) e.att('applyFont', '1');
                if (o.fill_id !== 1) e.att('applyFill', '1');
                if (o.numfmt_id !== void 0) e.att('applyNumberFormat', '1');
                if (o.bder_id !== 1) e.att('applyBorder', '1');
                if (o.align !== '-' || o.valign !== '-' || o.wrap !== '-') {
                    e.att('applyAlignment', '1');
                    ea = e.ele('alignment', {
                        textRotation: o.rotate === '-' ? '0' : o.rotate,
                        horizontal: o.align === '-' ? 'left' : o.align,
                        vertical: o.valign === '-' ? 'bottom' : o.valign
                    });
                    if (o.wrap !== '-') ea.att('wrapText', '1');
                }
            }
            ss.ele('cellStyles', {
                count: '1'
            }).ele('cellStyle', {
                name: 'Normal',
                xfId: '0',
                builtinId: '0'
            });
            ss.ele('dxfs', {
                count: '0'
            });
            ss.ele('tableStyles', {
                count: '0',
                defaultTableStyle: 'TableStyleMedium9',
                defaultPivotStyle: 'PivotStyleLight16'
            });
            return ss.end({
                pretty: false
            });
        };
        return Style;
    }();
    Image = function() {
        function Image(id1, extension, content, range1, options) {
            this.id = id1;
            this.extension = extension;
            this.content = content;
            this.range = range1;
            this.options = options;
            this.editAs = 'oneCell';
        }
        Image.prototype.publish = function(sheet, zip, media) {};
        Image.prototype.toDrawingXml = function(relId, spec) {
            var _from, _to, blip, blipFill, blipModel, cNvPr, dr, ext, extLst, graphic_index, nvPicPr, pic, spPr, twoCellAnchor, xfrm;
            dr = xml.create('xdr:wsDr', {
                version: '1.0',
                encoding: 'UTF-8',
                standalone: true
            });
            dr.att('xmlns:xdr', 'http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing');
            dr.att('xmlns:a', 'http://schemas.openxmlformats.org/drawingml/2006/main');
            twoCellAnchor = dr.ele('xdr:twoCellAnchor', {
                editAs: this.editAs
            });
            _from = twoCellAnchor.ele('xdr:from');
            _from.ele('xdr:col', this.range.from.model.nativeCol);
            _from.ele('xdr:colOff', this.range.from.model.nativeColOff);
            _from.ele('xdr:row', this.range.from.model.nativeRow);
            _from.ele('xdr:rowOff', this.range.from.model.nativeRowOff);
            _to = twoCellAnchor.ele('xdr:to');
            _to.ele('xdr:col', this.range.to.model.nativeCol);
            _to.ele('xdr:colOff', this.range.to.model.nativeColOff);
            _to.ele('xdr:row', this.range.to.model.nativeRow);
            _to.ele('xdr:rowOff', this.range.to.model.nativeRowOff);
            pic = twoCellAnchor.ele('xdr:pic');
            nvPicPr = pic.ele('xdr:nvPicPr');
            graphic_index = 30924;
            cNvPr = nvPicPr.ele('xdr:cNvPr', {
                id: 3,
                name: 'Graphic ' + graphic_index
            });
            cNvPr.ele('a:extLst').ele('a:ext', {
                uri: '{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}'
            }).ele('a16:creationId', {
                'xmlns:a16': 'http://schemas.microsoft.com/office/drawing/2014/main',
                'id': '{9D66B5F7-2553-484C-A5BE-4D0B8D57E08B}'
            });
            nvPicPr.ele('xdr:cNvPicPr').ele('a:picLocks', {
                noChangeAspect: 1
            });
            blipFill = pic.ele('xdr:blipFill');
            blipModel = {
                'xmlns:r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships'
            };
            if (relId) blipModel["r:embed"] = relId;
            blipModel['cstate'] = "print";
            blip = blipFill.ele('a:blip', blipModel);
            extLst = blip.ele('a:extLst');
            ext = extLst.ele('a:ext', {
                'uri': '{28A0092B-C50C-407E-A947-70E740481C1C}'
            });
            ext.ele('a14:useLocalDpi', {
                'xmlns:a14': 'http://schemas.microsoft.com/office/drawing/2010/main',
                'val': 0
            });
            if (this.extension === 'svg') {
                ext = extLst.ele('a:ext', {
                    'uri': '{96DAC541-7B7A-43D3-8B79-37D633B846F1}'
                });
                ext.ele('asvg:svgBlip', {
                    'xmlns:asvg': 'http://schemas.microsoft.com/office/drawing/2016/SVG/main',
                    'r:embed': relId
                });
            }
            if (this.options.stretch) blipFill.ele('a:stretch');
            blipFill.ele('srcRect');
            spPr = pic.ele('xdr:spPr');
            xfrm = spPr.ele('a:xfrm');
            xfrm.ele('a:off', {
                'x': 609600,
                'y': 190500
            });
            xfrm.ele('a:ext', {
                'cx': 2857500,
                'cy': 2857500
            });
            spPr.ele('a:prstGeom', {
                'prst': 'rect'
            }).ele('a:avLst');
            twoCellAnchor.ele('xdr:clientData');
            return dr.end({
                pretty: false
            });
        };
        return Image;
    }();
    Workbook = function() {
        function Workbook(fpath1, fname1) {
            var args;
            this.fpath = fpath1;
            this.fname = fname1;
            this.generate = bind(this.generate, this);
            if (typeof this.fpath === 'object') {
                args = this.fpath;
                this.fname = args.name;
                this.fpath = args.path;
            }
            this.id = '' + parseInt(Math.random() * 9999999);
            this.sheets = [];
            this.medias = [];
            this.ss = new SharedStrings;
            this.ct = new ContentTypes(this);
            this.da = new DocPropsApp(this);
            this.wb = new XlWorkbook(this);
            this.wbre = new XlWorkbookRels(this);
            this.st = new Style(this);
            this.cc = new CalcChain(this);
            this.cc = new CalcChain(this);
        }
        Workbook.prototype.set = function(obj) {
            var key, val;
            if (obj && typeof obj === 'object') for(key in obj){
                val = obj[key];
                if (typeof this[key] === 'function') this[key](val);
            }
            return this;
        };
        Workbook.prototype.createSheet = function(name, cols, rows) {
            var args, sheet;
            if (name && typeof name === 'object') {
                args = name;
                return this.createSheet(args.name, args.cols, args.rows).set(args.set);
            }
            sheet = new Sheet(this, name, cols, rows);
            this.sheets.push(sheet);
            return sheet;
        };
        Workbook.prototype.worksheets = function(arr) {
            var idx, key, len, len1, ncols, nrows, p, q, ref, results, row1, rowIdx, sheet, spec, val;
            results = [];
            for(idx = p = 0, len = arr.length; p < len; idx = ++p){
                spec = arr[idx];
                nrows = spec.cells.length;
                ncols = 0;
                ref = spec.cells;
                for(rowIdx = q = 0, len1 = ref.length; q < len1; rowIdx = ++q){
                    row1 = ref[rowIdx];
                    ncols = Math.max(ncols, row1.length);
                }
                sheet = this.createSheet(spec.name, ncols, nrows);
                results.push(function() {
                    var results1;
                    results1 = [];
                    for(key in spec){
                        val = spec[key];
                        if (typeof sheet[key] === 'function') results1.push(sheet[key](val));
                        else results1.push(void 0);
                    }
                    return results1;
                }());
            }
            return results;
        };
        Workbook.prototype._addMediaFromImage = function(image) {
            return this.medias.push({
                image: image
            });
        };
        Workbook.prototype._removeMediaFromImage = function(image) {
            var foundIndex, i, len, media, p, ref;
            foundIndex = -1;
            ref = this.medias;
            for(i = p = 0, len = ref.length; p < len; i = ++p){
                media = ref[i];
                if (media.image.id = image.id) {
                    foundIndex = i;
                    break;
                }
            }
            if (!(foundIndex > -1)) return this.medias.splice(foundIndex, 1);
        };
        Workbook.prototype.save = function(target, opts, cb) {
            var self;
            if (arguments.length === 1 && typeof target === 'function') {
                cb = target;
                target = this.fpath + '/' + this.fname;
                opts = {};
            } else if (arguments.length === 2 && typeof opts === 'function') {
                cb = opts;
                opts = {};
            }
            self = this;
            if (!cb) return new Promise(function(resolve, reject) {
                return self.save(function(err, zip) {
                    if (err) return reject(err);
                    return resolve(zip);
                });
            });
            return this.generate(function(err, zip) {
                var args, buffer;
                buffer = void 0;
                args = {
                    type: 'nodebuffer'
                };
                if (opts.compressed) args.compressed = "DEFLATE";
                return buffer = zip.generateAsync(args).then(function(buffer) {
                    if (err) return cb(err);
                    return fs.writeFile(target, buffer, cb);
                });
            });
        };
        Workbook.prototype.generate = function(cb) {
            var drawingFilename, dwRels, i, image, j, key, len, len1, mediaFilename, p, q, ref, ref1, relId, self, sheet, wbMediaCounter, zip;
            self = this;
            if (!cb) return new Promise(function(resolve, reject) {
                return self.generate(function(err, zip) {
                    if (err) return reject(err);
                    return resolve(zip);
                });
            });
            zip = new JSZip();
            for(key in baseXl)zip.file(key, baseXl[key]);
            zip.file('[Content_Types].xml', this.ct.toxml());
            zip.file('docProps/app.xml', this.da.toxml());
            zip.file('xl/workbook.xml', this.wb.toxml());
            zip.file('xl/sharedStrings.xml', this.ss.toxml());
            zip.file('xl/_rels/workbook.xml.rels', this.wbre.toxml());
            wbMediaCounter = 1;
            ref = this.sheets;
            for(i = p = 0, len = ref.length; p < len; i = ++p){
                sheet = ref[i];
                sheet.wsRels = [];
                sheet.wsComments = {};
                if (sheet.notes) {
                    relId = 'rId' + (sheet.wsRels.length + 1);
                    drawingFilename = '../drawings/vmlDrawing' + (i + 1) + '.vml';
                    sheet.wsRels.push({
                        id: relId,
                        target: drawingFilename,
                        type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing'
                    });
                    relId = 'rId' + (sheet.wsRels.length + 1);
                    sheet.wsRels.push({
                        id: relId,
                        target: '../comments' + (i + 1) + '.xml',
                        type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments'
                    });
                    zip.file('xl/drawings/vmlDrawing' + (i + 1) + '.vml', new WorksheetCommentsDrawings(sheet.notes).toxml());
                }
                ref1 = sheet.images;
                for(j = q = 0, len1 = ref1.length; q < len1; j = ++q){
                    image = ref1[j];
                    dwRels = [];
                    relId = 'rId' + (sheet.wsRels.length + 1);
                    mediaFilename = [
                        wbMediaCounter,
                        '.',
                        image.extension
                    ].join('');
                    zip.file('xl/media/image' + mediaFilename, image.content, {
                        base64: true
                    });
                    dwRels.push({
                        id: relId,
                        target: '../media/image' + mediaFilename
                    });
                    drawingFilename = wbMediaCounter + '.xml';
                    sheet.wsRels.push({
                        id: relId,
                        target: '../drawings/drawing' + drawingFilename,
                        type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing'
                    });
                    zip.file('xl/drawings/drawing' + drawingFilename, image.toDrawingXml(relId, image));
                    zip.file('xl/drawings/_rels/drawing' + wbMediaCounter + '.xml.rels', new XlDrawingRels(dwRels).toxml());
                    wbMediaCounter++;
                }
                zip.file('xl/worksheets/_rels/sheet' + (i + 1) + '.xml.rels', new XlWorksheetRels(sheet.wsRels).toxml());
                if (sheet.notes) zip.file('xl/comments' + (i + 1) + '.xml', new WorksheetComments(sheet.notes).toxml());
                zip.file('xl/worksheets/sheet' + (i + 1) + '.xml', this.sheets[i].toxml());
            }
            zip.file('xl/styles.xml', this.st.toxml());
            if (Object.getOwnPropertyNames(this.cc.cache).length > 0) zip.file('xl/calcChain.xml', this.cc.toxml());
            return cb(null, zip);
        };
        Workbook.prototype.cancel = function() {
            return console.error("workbook.cancel() is deprecated");
        };
        return Workbook;
    }();
    excelbuilder = {
        createWorkbook: function(fpath, fname) {
            return new Workbook(fpath, fname);
        },
        set: function(obj) {
            var key, val;
            if (obj && typeof obj === 'object') for(val in obj){
                key = obj[val];
                if (typeof this[key] === 'function') this[key](val);
            }
            return this;
        }
    };
    JSDateToExcel = function(dt) {
        return dt.valueOf() / 86400000 + 25569;
    };
    if (module !== null && module.exports != null) module.exports = excelbuilder;
    if (typeof window !== "undefined" && window !== null) window.excelbuilder = excelbuilder;
    baseXl = {
        '_rels/.rels': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>',
        'docProps/core.xml': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/" xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"><dc:creator>Administrator</dc:creator><cp:lastModifiedBy></cp:lastModifiedBy><dcterms:created xsi:type="dcterms:W3CDTF">2006-09-13T11:21:51Z</dcterms:created><dcterms:modified xsi:type="dcterms:W3CDTF">2006-09-13T11:21:55Z</dcterms:modified></cp:coreProperties>',
        'xl/theme/theme1.xml': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office \u4E3B\u9898"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="1F497D"/></a:dk2><a:lt2><a:srgbClr val="EEECE1"/></a:lt2><a:accent1><a:srgbClr val="4F81BD"/></a:accent1><a:accent2><a:srgbClr val="C0504D"/></a:accent2><a:accent3><a:srgbClr val="9BBB59"/></a:accent3><a:accent4><a:srgbClr val="8064A2"/></a:accent4><a:accent5><a:srgbClr val="4BACC6"/></a:accent5><a:accent6><a:srgbClr val="F79646"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/><a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/><a:font script="Hans" typeface="\u5B8B\u4F53"/><a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/><a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/><a:font script="Hans" typeface="\u5B8B\u4F53"/><a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="1"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:shade val="51000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="80000"><a:schemeClr val="phClr"><a:shade val="93000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="94000"/><a:satMod val="135000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults/><a:extraClrSchemeLst/></a:theme>',
        'xl/styles.xml': '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><fonts count="2"><font><sz val="11"/><color theme="1"/><name val="\u5B8B\u4F53"/><family val="2"/><charset val="134"/><scheme val="minor"/></font><font><sz val="9"/><name val="\u5B8B\u4F53"/><family val="2"/><charset val="134"/><scheme val="minor"/></font></fonts><fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills><borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"><alignment vertical="center"/></xf></cellStyleXfs><cellXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"><alignment vertical="center"/></xf></cellXfs><cellStyles count="1"><cellStyle name="\u5E38\u89C4" xfId="0" builtinId="0"/></cellStyles><dxfs count="0"/><tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleLight16"/></styleSheet>'
    };
}).call(this);

},{"1613cb6b6f2d38f":"eGCrE","8268c8dbe790e0da":"lUKCm","1c6cbb1f4501a847":"aBjM4"}],"eGCrE":[function(require,module,exports,__globalThis) {
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/ var Buffer = require("f7295d6075386111").Buffer;
var global = arguments[3];
var process = require("cf30dbb97a1d82ba");
!function(e) {
    module.exports = e();
}(function() {
    return (function s(a, o, h) {
        function u(r, e) {
            if (!o[r]) {
                if (!a[r]) {
                    var t = undefined;
                    if (!e && t) return t(r, !0);
                    if (l) return l(r, !0);
                    var n = new Error("Cannot find module '" + r + "'");
                    throw n.code = "MODULE_NOT_FOUND", n;
                }
                var i = o[r] = {
                    exports: {}
                };
                a[r][0].call(i.exports, function(e) {
                    var t = a[r][1][e];
                    return u(t || e);
                }, i, i.exports, s, a, o, h);
            }
            return o[r].exports;
        }
        for(var l = undefined, e = 0; e < h.length; e++)u(h[e]);
        return u;
    })({
        1: [
            function(e, t, r) {
                "use strict";
                var d = e("./utils"), c = e("./support"), p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                r.encode = function(e) {
                    for(var t, r, n, i, s, a, o, h = [], u = 0, l = e.length, f = l, c = "string" !== d.getTypeOf(e); u < e.length;)f = l - u, n = c ? (t = e[u++], r = u < l ? e[u++] : 0, u < l ? e[u++] : 0) : (t = e.charCodeAt(u++), r = u < l ? e.charCodeAt(u++) : 0, u < l ? e.charCodeAt(u++) : 0), i = t >> 2, s = (3 & t) << 4 | r >> 4, a = 1 < f ? (15 & r) << 2 | n >> 6 : 64, o = 2 < f ? 63 & n : 64, h.push(p.charAt(i) + p.charAt(s) + p.charAt(a) + p.charAt(o));
                    return h.join("");
                }, r.decode = function(e) {
                    var t, r, n, i, s, a, o = 0, h = 0, u = "data:";
                    if (e.substr(0, u.length) === u) throw new Error("Invalid base64 input, it looks like a data url.");
                    var l, f = 3 * (e = e.replace(/[^A-Za-z0-9+/=]/g, "")).length / 4;
                    if (e.charAt(e.length - 1) === p.charAt(64) && f--, e.charAt(e.length - 2) === p.charAt(64) && f--, f % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
                    for(l = c.uint8array ? new Uint8Array(0 | f) : new Array(0 | f); o < e.length;)t = p.indexOf(e.charAt(o++)) << 2 | (i = p.indexOf(e.charAt(o++))) >> 4, r = (15 & i) << 4 | (s = p.indexOf(e.charAt(o++))) >> 2, n = (3 & s) << 6 | (a = p.indexOf(e.charAt(o++))), l[h++] = t, 64 !== s && (l[h++] = r), 64 !== a && (l[h++] = n);
                    return l;
                };
            },
            {
                "./support": 30,
                "./utils": 32
            }
        ],
        2: [
            function(e, t, r) {
                "use strict";
                var n = e("./external"), i = e("./stream/DataWorker"), s = e("./stream/Crc32Probe"), a = e("./stream/DataLengthProbe");
                function o(e, t, r, n, i) {
                    this.compressedSize = e, this.uncompressedSize = t, this.crc32 = r, this.compression = n, this.compressedContent = i;
                }
                o.prototype = {
                    getContentWorker: function() {
                        var e = new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")), t = this;
                        return e.on("end", function() {
                            if (this.streamInfo.data_length !== t.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch");
                        }), e;
                    },
                    getCompressedWorker: function() {
                        return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
                    }
                }, o.createWorkerFrom = function(e, t, r) {
                    return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression", t);
                }, t.exports = o;
            },
            {
                "./external": 6,
                "./stream/Crc32Probe": 25,
                "./stream/DataLengthProbe": 26,
                "./stream/DataWorker": 27
            }
        ],
        3: [
            function(e, t, r) {
                "use strict";
                var n = e("./stream/GenericWorker");
                r.STORE = {
                    magic: "\0\0",
                    compressWorker: function() {
                        return new n("STORE compression");
                    },
                    uncompressWorker: function() {
                        return new n("STORE decompression");
                    }
                }, r.DEFLATE = e("./flate");
            },
            {
                "./flate": 7,
                "./stream/GenericWorker": 28
            }
        ],
        4: [
            function(e, t, r) {
                "use strict";
                var n = e("./utils");
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t) {
                    return void 0 !== e && e.length ? "string" !== n.getTypeOf(e) ? function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : function(e, t, r, n) {
                        var i = o, s = n + r;
                        e ^= -1;
                        for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t.charCodeAt(a))];
                        return -1 ^ e;
                    }(0 | t, e, e.length, 0) : 0;
                };
            },
            {
                "./utils": 32
            }
        ],
        5: [
            function(e, t, r) {
                "use strict";
                r.base64 = !1, r.binary = !1, r.dir = !1, r.createFolders = !0, r.date = null, r.compression = null, r.compressionOptions = null, r.comment = null, r.unixPermissions = null, r.dosPermissions = null;
            },
            {}
        ],
        6: [
            function(e, t, r) {
                "use strict";
                var n = null;
                n = "undefined" != typeof Promise ? Promise : e("lie"), t.exports = {
                    Promise: n
                };
            },
            {
                lie: 37
            }
        ],
        7: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array, i = e("pako"), s = e("./utils"), a = e("./stream/GenericWorker"), o = n ? "uint8array" : "array";
                function h(e, t) {
                    a.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = t, this.meta = {};
                }
                r.magic = "\b\0", s.inherits(h, a), h.prototype.processChunk = function(e) {
                    this.meta = e.meta, null === this._pako && this._createPako(), this._pako.push(s.transformTo(o, e.data), !1);
                }, h.prototype.flush = function() {
                    a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0);
                }, h.prototype.cleanUp = function() {
                    a.prototype.cleanUp.call(this), this._pako = null;
                }, h.prototype._createPako = function() {
                    this._pako = new i[this._pakoAction]({
                        raw: !0,
                        level: this._pakoOptions.level || -1
                    });
                    var t = this;
                    this._pako.onData = function(e) {
                        t.push({
                            data: e,
                            meta: t.meta
                        });
                    };
                }, r.compressWorker = function(e) {
                    return new h("Deflate", e);
                }, r.uncompressWorker = function() {
                    return new h("Inflate", {});
                };
            },
            {
                "./stream/GenericWorker": 28,
                "./utils": 32,
                pako: 38
            }
        ],
        8: [
            function(e, t, r) {
                "use strict";
                function A(e, t) {
                    var r, n = "";
                    for(r = 0; r < t; r++)n += String.fromCharCode(255 & e), e >>>= 8;
                    return n;
                }
                function n(e, t, r, n, i, s) {
                    var a, o, h = e.file, u = e.compression, l = s !== O.utf8encode, f = I.transformTo("string", s(h.name)), c = I.transformTo("string", O.utf8encode(h.name)), d = h.comment, p = I.transformTo("string", s(d)), m = I.transformTo("string", O.utf8encode(d)), _ = c.length !== h.name.length, g = m.length !== d.length, b = "", v = "", y = "", w = h.dir, k = h.date, x = {
                        crc32: 0,
                        compressedSize: 0,
                        uncompressedSize: 0
                    };
                    t && !r || (x.crc32 = e.crc32, x.compressedSize = e.compressedSize, x.uncompressedSize = e.uncompressedSize);
                    var S = 0;
                    t && (S |= 8), l || !_ && !g || (S |= 2048);
                    var z = 0, C = 0;
                    w && (z |= 16), "UNIX" === i ? (C = 798, z |= function(e, t) {
                        var r = e;
                        return e || (r = t ? 16893 : 33204), (65535 & r) << 16;
                    }(h.unixPermissions, w)) : (C = 20, z |= function(e) {
                        return 63 & (e || 0);
                    }(h.dosPermissions)), a = k.getUTCHours(), a <<= 6, a |= k.getUTCMinutes(), a <<= 5, a |= k.getUTCSeconds() / 2, o = k.getUTCFullYear() - 1980, o <<= 4, o |= k.getUTCMonth() + 1, o <<= 5, o |= k.getUTCDate(), _ && (v = A(1, 1) + A(B(f), 4) + c, b += "up" + A(v.length, 2) + v), g && (y = A(1, 1) + A(B(p), 4) + m, b += "uc" + A(y.length, 2) + y);
                    var E = "";
                    return E += "\n\0", E += A(S, 2), E += u.magic, E += A(a, 2), E += A(o, 2), E += A(x.crc32, 4), E += A(x.compressedSize, 4), E += A(x.uncompressedSize, 4), E += A(f.length, 2), E += A(b.length, 2), {
                        fileRecord: R.LOCAL_FILE_HEADER + E + f + b,
                        dirRecord: R.CENTRAL_FILE_HEADER + A(C, 2) + E + A(p.length, 2) + "\0\0\0\0" + A(z, 4) + A(n, 4) + f + b + p
                    };
                }
                var I = e("../utils"), i = e("../stream/GenericWorker"), O = e("../utf8"), B = e("../crc32"), R = e("../signature");
                function s(e, t, r, n) {
                    i.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = t, this.zipPlatform = r, this.encodeFileName = n, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
                }
                I.inherits(s, i), s.prototype.push = function(e) {
                    var t = e.meta.percent || 0, r = this.entriesCount, n = this._sources.length;
                    this.accumulate ? this.contentBuffer.push(e) : (this.bytesWritten += e.data.length, i.prototype.push.call(this, {
                        data: e.data,
                        meta: {
                            currentFile: this.currentFile,
                            percent: r ? (t + 100 * (r - n - 1)) / r : 100
                        }
                    }));
                }, s.prototype.openedSource = function(e) {
                    this.currentSourceOffset = this.bytesWritten, this.currentFile = e.file.name;
                    var t = this.streamFiles && !e.file.dir;
                    if (t) {
                        var r = n(e, t, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                        this.push({
                            data: r.fileRecord,
                            meta: {
                                percent: 0
                            }
                        });
                    } else this.accumulate = !0;
                }, s.prototype.closedSource = function(e) {
                    this.accumulate = !1;
                    var t = this.streamFiles && !e.file.dir, r = n(e, t, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
                    if (this.dirRecords.push(r.dirRecord), t) this.push({
                        data: function(e) {
                            return R.DATA_DESCRIPTOR + A(e.crc32, 4) + A(e.compressedSize, 4) + A(e.uncompressedSize, 4);
                        }(e),
                        meta: {
                            percent: 100
                        }
                    });
                    else for(this.push({
                        data: r.fileRecord,
                        meta: {
                            percent: 0
                        }
                    }); this.contentBuffer.length;)this.push(this.contentBuffer.shift());
                    this.currentFile = null;
                }, s.prototype.flush = function() {
                    for(var e = this.bytesWritten, t = 0; t < this.dirRecords.length; t++)this.push({
                        data: this.dirRecords[t],
                        meta: {
                            percent: 100
                        }
                    });
                    var r = this.bytesWritten - e, n = function(e, t, r, n, i) {
                        var s = I.transformTo("string", i(n));
                        return R.CENTRAL_DIRECTORY_END + "\0\0\0\0" + A(e, 2) + A(e, 2) + A(t, 4) + A(r, 4) + A(s.length, 2) + s;
                    }(this.dirRecords.length, r, e, this.zipComment, this.encodeFileName);
                    this.push({
                        data: n,
                        meta: {
                            percent: 100
                        }
                    });
                }, s.prototype.prepareNextSource = function() {
                    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
                }, s.prototype.registerPrevious = function(e) {
                    this._sources.push(e);
                    var t = this;
                    return e.on("data", function(e) {
                        t.processChunk(e);
                    }), e.on("end", function() {
                        t.closedSource(t.previous.streamInfo), t._sources.length ? t.prepareNextSource() : t.end();
                    }), e.on("error", function(e) {
                        t.error(e);
                    }), this;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0));
                }, s.prototype.error = function(e) {
                    var t = this._sources;
                    if (!i.prototype.error.call(this, e)) return !1;
                    for(var r = 0; r < t.length; r++)try {
                        t[r].error(e);
                    } catch (e) {}
                    return !0;
                }, s.prototype.lock = function() {
                    i.prototype.lock.call(this);
                    for(var e = this._sources, t = 0; t < e.length; t++)e[t].lock();
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../signature": 23,
                "../stream/GenericWorker": 28,
                "../utf8": 31,
                "../utils": 32
            }
        ],
        9: [
            function(e, t, r) {
                "use strict";
                var u = e("../compressions"), n = e("./ZipFileWorker");
                r.generateWorker = function(e, a, t) {
                    var o = new n(a.streamFiles, t, a.platform, a.encodeFileName), h = 0;
                    try {
                        e.forEach(function(e, t) {
                            h++;
                            var r = function(e, t) {
                                var r = e || t, n = u[r];
                                if (!n) throw new Error(r + " is not a valid compression method !");
                                return n;
                            }(t.options.compression, a.compression), n = t.options.compressionOptions || a.compressionOptions || {}, i = t.dir, s = t.date;
                            t._compressWorker(r, n).withStreamInfo("file", {
                                name: e,
                                dir: i,
                                date: s,
                                comment: t.comment || "",
                                unixPermissions: t.unixPermissions,
                                dosPermissions: t.dosPermissions
                            }).pipe(o);
                        }), o.entriesCount = h;
                    } catch (e) {
                        o.error(e);
                    }
                    return o;
                };
            },
            {
                "../compressions": 3,
                "./ZipFileWorker": 8
            }
        ],
        10: [
            function(e, t, r) {
                "use strict";
                function n() {
                    if (!(this instanceof n)) return new n;
                    if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
                    this.files = Object.create(null), this.comment = null, this.root = "", this.clone = function() {
                        var e = new n;
                        for(var t in this)"function" != typeof this[t] && (e[t] = this[t]);
                        return e;
                    };
                }
                (n.prototype = e("./object")).loadAsync = e("./load"), n.support = e("./support"), n.defaults = e("./defaults"), n.version = "3.10.1", n.loadAsync = function(e, t) {
                    return (new n).loadAsync(e, t);
                }, n.external = e("./external"), t.exports = n;
            },
            {
                "./defaults": 5,
                "./external": 6,
                "./load": 11,
                "./object": 15,
                "./support": 30
            }
        ],
        11: [
            function(e, t, r) {
                "use strict";
                var u = e("./utils"), i = e("./external"), n = e("./utf8"), s = e("./zipEntries"), a = e("./stream/Crc32Probe"), l = e("./nodejsUtils");
                function f(n) {
                    return new i.Promise(function(e, t) {
                        var r = n.decompressed.getContentWorker().pipe(new a);
                        r.on("error", function(e) {
                            t(e);
                        }).on("end", function() {
                            r.streamInfo.crc32 !== n.decompressed.crc32 ? t(new Error("Corrupted zip : CRC32 mismatch")) : e();
                        }).resume();
                    });
                }
                t.exports = function(e, o) {
                    var h = this;
                    return o = u.extend(o || {}, {
                        base64: !1,
                        checkCRC32: !1,
                        optimizedBinaryString: !1,
                        createFolders: !1,
                        decodeFileName: n.utf8decode
                    }), l.isNode && l.isStream(e) ? i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : u.prepareContent("the loaded zip file", e, !0, o.optimizedBinaryString, o.base64).then(function(e) {
                        var t = new s(o);
                        return t.load(e), t;
                    }).then(function(e) {
                        var t = [
                            i.Promise.resolve(e)
                        ], r = e.files;
                        if (o.checkCRC32) for(var n = 0; n < r.length; n++)t.push(f(r[n]));
                        return i.Promise.all(t);
                    }).then(function(e) {
                        for(var t = e.shift(), r = t.files, n = 0; n < r.length; n++){
                            var i = r[n], s = i.fileNameStr, a = u.resolve(i.fileNameStr);
                            h.file(a, i.decompressed, {
                                binary: !0,
                                optimizedBinaryString: !0,
                                date: i.date,
                                dir: i.dir,
                                comment: i.fileCommentStr.length ? i.fileCommentStr : null,
                                unixPermissions: i.unixPermissions,
                                dosPermissions: i.dosPermissions,
                                createFolders: o.createFolders
                            }), i.dir || (h.file(a).unsafeOriginalName = s);
                        }
                        return t.zipComment.length && (h.comment = t.zipComment), h;
                    });
                };
            },
            {
                "./external": 6,
                "./nodejsUtils": 14,
                "./stream/Crc32Probe": 25,
                "./utf8": 31,
                "./utils": 32,
                "./zipEntries": 33
            }
        ],
        12: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../stream/GenericWorker");
                function s(e, t) {
                    i.call(this, "Nodejs stream input adapter for " + e), this._upstreamEnded = !1, this._bindStream(t);
                }
                n.inherits(s, i), s.prototype._bindStream = function(e) {
                    var t = this;
                    (this._stream = e).pause(), e.on("data", function(e) {
                        t.push({
                            data: e,
                            meta: {
                                percent: 0
                            }
                        });
                    }).on("error", function(e) {
                        t.isPaused ? this.generatedError = e : t.error(e);
                    }).on("end", function() {
                        t.isPaused ? t._upstreamEnded = !0 : t.end();
                    });
                }, s.prototype.pause = function() {
                    return !!i.prototype.pause.call(this) && (this._stream.pause(), !0);
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0);
                }, t.exports = s;
            },
            {
                "../stream/GenericWorker": 28,
                "../utils": 32
            }
        ],
        13: [
            function(e, t, r) {
                "use strict";
                var i = e("readable-stream").Readable;
                function n(e, t, r) {
                    i.call(this, t), this._helper = e;
                    var n = this;
                    e.on("data", function(e, t) {
                        n.push(e) || n._helper.pause(), r && r(t);
                    }).on("error", function(e) {
                        n.emit("error", e);
                    }).on("end", function() {
                        n.push(null);
                    });
                }
                e("../utils").inherits(n, i), n.prototype._read = function() {
                    this._helper.resume();
                }, t.exports = n;
            },
            {
                "../utils": 32,
                "readable-stream": 16
            }
        ],
        14: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    isNode: "undefined" != typeof Buffer,
                    newBufferFrom: function(e, t) {
                        if (Buffer.from && Buffer.from !== Uint8Array.from) return Buffer.from(e, t);
                        if ("number" == typeof e) throw new Error('The "data" argument must not be a number');
                        return new Buffer(e, t);
                    },
                    allocBuffer: function(e) {
                        if (Buffer.alloc) return Buffer.alloc(e);
                        var t = new Buffer(e);
                        return t.fill(0), t;
                    },
                    isBuffer: function(e) {
                        return Buffer.isBuffer(e);
                    },
                    isStream: function(e) {
                        return e && "function" == typeof e.on && "function" == typeof e.pause && "function" == typeof e.resume;
                    }
                };
            },
            {}
        ],
        15: [
            function(e, t, r) {
                "use strict";
                function s(e, t, r) {
                    var n, i = u.getTypeOf(t), s = u.extend(r || {}, f);
                    s.date = s.date || new Date, null !== s.compression && (s.compression = s.compression.toUpperCase()), "string" == typeof s.unixPermissions && (s.unixPermissions = parseInt(s.unixPermissions, 8)), s.unixPermissions && 16384 & s.unixPermissions && (s.dir = !0), s.dosPermissions && 16 & s.dosPermissions && (s.dir = !0), s.dir && (e = g(e)), s.createFolders && (n = _(e)) && b.call(this, n, !0);
                    var a = "string" === i && !1 === s.binary && !1 === s.base64;
                    r && void 0 !== r.binary || (s.binary = !a), (t instanceof c && 0 === t.uncompressedSize || s.dir || !t || 0 === t.length) && (s.base64 = !1, s.binary = !0, t = "", s.compression = "STORE", i = "string");
                    var o = null;
                    o = t instanceof c || t instanceof l ? t : p.isNode && p.isStream(t) ? new m(e, t) : u.prepareContent(e, t, s.binary, s.optimizedBinaryString, s.base64);
                    var h = new d(e, o, s);
                    this.files[e] = h;
                }
                var i = e("./utf8"), u = e("./utils"), l = e("./stream/GenericWorker"), a = e("./stream/StreamHelper"), f = e("./defaults"), c = e("./compressedObject"), d = e("./zipObject"), o = e("./generate"), p = e("./nodejsUtils"), m = e("./nodejs/NodejsStreamInputAdapter"), _ = function(e) {
                    "/" === e.slice(-1) && (e = e.substring(0, e.length - 1));
                    var t = e.lastIndexOf("/");
                    return 0 < t ? e.substring(0, t) : "";
                }, g = function(e) {
                    return "/" !== e.slice(-1) && (e += "/"), e;
                }, b = function(e, t) {
                    return t = void 0 !== t ? t : f.createFolders, e = g(e), this.files[e] || s.call(this, e, null, {
                        dir: !0,
                        createFolders: t
                    }), this.files[e];
                };
                function h(e) {
                    return "[object RegExp]" === Object.prototype.toString.call(e);
                }
                var n = {
                    load: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    forEach: function(e) {
                        var t, r, n;
                        for(t in this.files)n = this.files[t], (r = t.slice(this.root.length, t.length)) && t.slice(0, this.root.length) === this.root && e(r, n);
                    },
                    filter: function(r) {
                        var n = [];
                        return this.forEach(function(e, t) {
                            r(e, t) && n.push(t);
                        }), n;
                    },
                    file: function(e, t, r) {
                        if (1 !== arguments.length) return e = this.root + e, s.call(this, e, t, r), this;
                        if (h(e)) {
                            var n = e;
                            return this.filter(function(e, t) {
                                return !t.dir && n.test(e);
                            });
                        }
                        var i = this.files[this.root + e];
                        return i && !i.dir ? i : null;
                    },
                    folder: function(r) {
                        if (!r) return this;
                        if (h(r)) return this.filter(function(e, t) {
                            return t.dir && r.test(e);
                        });
                        var e = this.root + r, t = b.call(this, e), n = this.clone();
                        return n.root = t.name, n;
                    },
                    remove: function(r) {
                        r = this.root + r;
                        var e = this.files[r];
                        if (e || ("/" !== r.slice(-1) && (r += "/"), e = this.files[r]), e && !e.dir) delete this.files[r];
                        else for(var t = this.filter(function(e, t) {
                            return t.name.slice(0, r.length) === r;
                        }), n = 0; n < t.length; n++)delete this.files[t[n].name];
                        return this;
                    },
                    generate: function() {
                        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                    },
                    generateInternalStream: function(e) {
                        var t, r = {};
                        try {
                            if ((r = u.extend(e || {}, {
                                streamFiles: !1,
                                compression: "STORE",
                                compressionOptions: null,
                                type: "",
                                platform: "DOS",
                                comment: null,
                                mimeType: "application/zip",
                                encodeFileName: i.utf8encode
                            })).type = r.type.toLowerCase(), r.compression = r.compression.toUpperCase(), "binarystring" === r.type && (r.type = "string"), !r.type) throw new Error("No output type specified.");
                            u.checkSupport(r.type), "darwin" !== r.platform && "freebsd" !== r.platform && "linux" !== r.platform && "sunos" !== r.platform || (r.platform = "UNIX"), "win32" === r.platform && (r.platform = "DOS");
                            var n = r.comment || this.comment || "";
                            t = o.generateWorker(this, r, n);
                        } catch (e) {
                            (t = new l("error")).error(e);
                        }
                        return new a(t, r.type || "string", r.mimeType);
                    },
                    generateAsync: function(e, t) {
                        return this.generateInternalStream(e).accumulate(t);
                    },
                    generateNodeStream: function(e, t) {
                        return (e = e || {}).type || (e.type = "nodebuffer"), this.generateInternalStream(e).toNodejsStream(t);
                    }
                };
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./defaults": 5,
                "./generate": 9,
                "./nodejs/NodejsStreamInputAdapter": 12,
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31,
                "./utils": 32,
                "./zipObject": 35
            }
        ],
        16: [
            function(e, t, r) {
                "use strict";
                t.exports = e("stream");
            },
            {
                stream: void 0
            }
        ],
        17: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                    for(var t = 0; t < this.data.length; t++)e[t] = 255 & e[t];
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data[this.zero + e];
                }, i.prototype.lastIndexOfSignature = function(e) {
                    for(var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.length - 4; 0 <= s; --s)if (this.data[s] === t && this.data[s + 1] === r && this.data[s + 2] === n && this.data[s + 3] === i) return s - this.zero;
                    return -1;
                }, i.prototype.readAndCheckSignature = function(e) {
                    var t = e.charCodeAt(0), r = e.charCodeAt(1), n = e.charCodeAt(2), i = e.charCodeAt(3), s = this.readData(4);
                    return t === s[0] && r === s[1] && n === s[2] && i === s[3];
                }, i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return [];
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        18: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils");
                function i(e) {
                    this.data = e, this.length = e.length, this.index = 0, this.zero = 0;
                }
                i.prototype = {
                    checkOffset: function(e) {
                        this.checkIndex(this.index + e);
                    },
                    checkIndex: function(e) {
                        if (this.length < this.zero + e || e < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + e + "). Corrupted zip ?");
                    },
                    setIndex: function(e) {
                        this.checkIndex(e), this.index = e;
                    },
                    skip: function(e) {
                        this.setIndex(this.index + e);
                    },
                    byteAt: function() {},
                    readInt: function(e) {
                        var t, r = 0;
                        for(this.checkOffset(e), t = this.index + e - 1; t >= this.index; t--)r = (r << 8) + this.byteAt(t);
                        return this.index += e, r;
                    },
                    readString: function(e) {
                        return n.transformTo("string", this.readData(e));
                    },
                    readData: function() {},
                    lastIndexOfSignature: function() {},
                    readAndCheckSignature: function() {},
                    readDate: function() {
                        var e = this.readInt(4);
                        return new Date(Date.UTC(1980 + (e >> 25 & 127), (e >> 21 & 15) - 1, e >> 16 & 31, e >> 11 & 31, e >> 5 & 63, (31 & e) << 1));
                    }
                }, t.exports = i;
            },
            {
                "../utils": 32
            }
        ],
        19: [
            function(e, t, r) {
                "use strict";
                var n = e("./Uint8ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./Uint8ArrayReader": 21
            }
        ],
        20: [
            function(e, t, r) {
                "use strict";
                var n = e("./DataReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.byteAt = function(e) {
                    return this.data.charCodeAt(this.zero + e);
                }, i.prototype.lastIndexOfSignature = function(e) {
                    return this.data.lastIndexOf(e) - this.zero;
                }, i.prototype.readAndCheckSignature = function(e) {
                    return e === this.readData(4);
                }, i.prototype.readData = function(e) {
                    this.checkOffset(e);
                    var t = this.data.slice(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./DataReader": 18
            }
        ],
        21: [
            function(e, t, r) {
                "use strict";
                var n = e("./ArrayReader");
                function i(e) {
                    n.call(this, e);
                }
                e("../utils").inherits(i, n), i.prototype.readData = function(e) {
                    if (this.checkOffset(e), 0 === e) return new Uint8Array(0);
                    var t = this.data.subarray(this.zero + this.index, this.zero + this.index + e);
                    return this.index += e, t;
                }, t.exports = i;
            },
            {
                "../utils": 32,
                "./ArrayReader": 17
            }
        ],
        22: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("../support"), s = e("./ArrayReader"), a = e("./StringReader"), o = e("./NodeBufferReader"), h = e("./Uint8ArrayReader");
                t.exports = function(e) {
                    var t = n.getTypeOf(e);
                    return n.checkSupport(t), "string" !== t || i.uint8array ? "nodebuffer" === t ? new o(e) : i.uint8array ? new h(n.transformTo("uint8array", e)) : new s(n.transformTo("array", e)) : new a(e);
                };
            },
            {
                "../support": 30,
                "../utils": 32,
                "./ArrayReader": 17,
                "./NodeBufferReader": 19,
                "./StringReader": 20,
                "./Uint8ArrayReader": 21
            }
        ],
        23: [
            function(e, t, r) {
                "use strict";
                r.LOCAL_FILE_HEADER = "PK", r.CENTRAL_FILE_HEADER = "PK", r.CENTRAL_DIRECTORY_END = "PK", r.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", r.ZIP64_CENTRAL_DIRECTORY_END = "PK", r.DATA_DESCRIPTOR = "PK\b";
            },
            {}
        ],
        24: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../utils");
                function s(e) {
                    n.call(this, "ConvertWorker to " + e), this.destType = e;
                }
                i.inherits(s, n), s.prototype.processChunk = function(e) {
                    this.push({
                        data: i.transformTo(this.destType, e.data),
                        meta: e.meta
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        25: [
            function(e, t, r) {
                "use strict";
                var n = e("./GenericWorker"), i = e("../crc32");
                function s() {
                    n.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
                }
                e("../utils").inherits(s, n), s.prototype.processChunk = function(e) {
                    this.streamInfo.crc32 = i(e.data, this.streamInfo.crc32 || 0), this.push(e);
                }, t.exports = s;
            },
            {
                "../crc32": 4,
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        26: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
                }
                n.inherits(s, i), s.prototype.processChunk = function(e) {
                    if (e) {
                        var t = this.streamInfo[this.propName] || 0;
                        this.streamInfo[this.propName] = t + e.data.length;
                    }
                    i.prototype.processChunk.call(this, e);
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        27: [
            function(e, t, r) {
                "use strict";
                var n = e("../utils"), i = e("./GenericWorker");
                function s(e) {
                    i.call(this, "DataWorker");
                    var t = this;
                    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(e) {
                        t.dataIsReady = !0, t.data = e, t.max = e && e.length || 0, t.type = n.getTypeOf(e), t.isPaused || t._tickAndRepeat();
                    }, function(e) {
                        t.error(e);
                    });
                }
                n.inherits(s, i), s.prototype.cleanUp = function() {
                    i.prototype.cleanUp.call(this), this.data = null;
                }, s.prototype.resume = function() {
                    return !!i.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, n.delay(this._tickAndRepeat, [], this)), !0);
                }, s.prototype._tickAndRepeat = function() {
                    this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (n.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0));
                }, s.prototype._tick = function() {
                    if (this.isPaused || this.isFinished) return !1;
                    var e = null, t = Math.min(this.max, this.index + 16384);
                    if (this.index >= this.max) return this.end();
                    switch(this.type){
                        case "string":
                            e = this.data.substring(this.index, t);
                            break;
                        case "uint8array":
                            e = this.data.subarray(this.index, t);
                            break;
                        case "array":
                        case "nodebuffer":
                            e = this.data.slice(this.index, t);
                    }
                    return this.index = t, this.push({
                        data: e,
                        meta: {
                            percent: this.max ? this.index / this.max * 100 : 0
                        }
                    });
                }, t.exports = s;
            },
            {
                "../utils": 32,
                "./GenericWorker": 28
            }
        ],
        28: [
            function(e, t, r) {
                "use strict";
                function n(e) {
                    this.name = e || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
                        data: [],
                        end: [],
                        error: []
                    }, this.previous = null;
                }
                n.prototype = {
                    push: function(e) {
                        this.emit("data", e);
                    },
                    end: function() {
                        if (this.isFinished) return !1;
                        this.flush();
                        try {
                            this.emit("end"), this.cleanUp(), this.isFinished = !0;
                        } catch (e) {
                            this.emit("error", e);
                        }
                        return !0;
                    },
                    error: function(e) {
                        return !this.isFinished && (this.isPaused ? this.generatedError = e : (this.isFinished = !0, this.emit("error", e), this.previous && this.previous.error(e), this.cleanUp()), !0);
                    },
                    on: function(e, t) {
                        return this._listeners[e].push(t), this;
                    },
                    cleanUp: function() {
                        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
                    },
                    emit: function(e, t) {
                        if (this._listeners[e]) for(var r = 0; r < this._listeners[e].length; r++)this._listeners[e][r].call(this, t);
                    },
                    pipe: function(e) {
                        return e.registerPrevious(this);
                    },
                    registerPrevious: function(e) {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.streamInfo = e.streamInfo, this.mergeStreamInfo(), this.previous = e;
                        var t = this;
                        return e.on("data", function(e) {
                            t.processChunk(e);
                        }), e.on("end", function() {
                            t.end();
                        }), e.on("error", function(e) {
                            t.error(e);
                        }), this;
                    },
                    pause: function() {
                        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0);
                    },
                    resume: function() {
                        if (!this.isPaused || this.isFinished) return !1;
                        var e = this.isPaused = !1;
                        return this.generatedError && (this.error(this.generatedError), e = !0), this.previous && this.previous.resume(), !e;
                    },
                    flush: function() {},
                    processChunk: function(e) {
                        this.push(e);
                    },
                    withStreamInfo: function(e, t) {
                        return this.extraStreamInfo[e] = t, this.mergeStreamInfo(), this;
                    },
                    mergeStreamInfo: function() {
                        for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo, e) && (this.streamInfo[e] = this.extraStreamInfo[e]);
                    },
                    lock: function() {
                        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
                        this.isLocked = !0, this.previous && this.previous.lock();
                    },
                    toString: function() {
                        var e = "Worker " + this.name;
                        return this.previous ? this.previous + " -> " + e : e;
                    }
                }, t.exports = n;
            },
            {}
        ],
        29: [
            function(e, t, r) {
                "use strict";
                var h = e("../utils"), i = e("./ConvertWorker"), s = e("./GenericWorker"), u = e("../base64"), n = e("../support"), a = e("../external"), o = null;
                if (n.nodestream) try {
                    o = e("../nodejs/NodejsStreamOutputAdapter");
                } catch (e) {}
                function l(e, o) {
                    return new a.Promise(function(t, r) {
                        var n = [], i = e._internalType, s = e._outputType, a = e._mimeType;
                        e.on("data", function(e, t) {
                            n.push(e), o && o(t);
                        }).on("error", function(e) {
                            n = [], r(e);
                        }).on("end", function() {
                            try {
                                var e = function(e, t, r) {
                                    switch(e){
                                        case "blob":
                                            return h.newBlob(h.transformTo("arraybuffer", t), r);
                                        case "base64":
                                            return u.encode(t);
                                        default:
                                            return h.transformTo(e, t);
                                    }
                                }(s, function(e, t) {
                                    var r, n = 0, i = null, s = 0;
                                    for(r = 0; r < t.length; r++)s += t[r].length;
                                    switch(e){
                                        case "string":
                                            return t.join("");
                                        case "array":
                                            return Array.prototype.concat.apply([], t);
                                        case "uint8array":
                                            for(i = new Uint8Array(s), r = 0; r < t.length; r++)i.set(t[r], n), n += t[r].length;
                                            return i;
                                        case "nodebuffer":
                                            return Buffer.concat(t);
                                        default:
                                            throw new Error("concat : unsupported type '" + e + "'");
                                    }
                                }(i, n), a);
                                t(e);
                            } catch (e) {
                                r(e);
                            }
                            n = [];
                        }).resume();
                    });
                }
                function f(e, t, r) {
                    var n = t;
                    switch(t){
                        case "blob":
                        case "arraybuffer":
                            n = "uint8array";
                            break;
                        case "base64":
                            n = "string";
                    }
                    try {
                        this._internalType = n, this._outputType = t, this._mimeType = r, h.checkSupport(n), this._worker = e.pipe(new i(n)), e.lock();
                    } catch (e) {
                        this._worker = new s("error"), this._worker.error(e);
                    }
                }
                f.prototype = {
                    accumulate: function(e) {
                        return l(this, e);
                    },
                    on: function(e, t) {
                        var r = this;
                        return "data" === e ? this._worker.on(e, function(e) {
                            t.call(r, e.data, e.meta);
                        }) : this._worker.on(e, function() {
                            h.delay(t, arguments, r);
                        }), this;
                    },
                    resume: function() {
                        return h.delay(this._worker.resume, [], this._worker), this;
                    },
                    pause: function() {
                        return this._worker.pause(), this;
                    },
                    toNodejsStream: function(e) {
                        if (h.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
                        return new o(this, {
                            objectMode: "nodebuffer" !== this._outputType
                        }, e);
                    }
                }, t.exports = f;
            },
            {
                "../base64": 1,
                "../external": 6,
                "../nodejs/NodejsStreamOutputAdapter": 13,
                "../support": 30,
                "../utils": 32,
                "./ConvertWorker": 24,
                "./GenericWorker": 28
            }
        ],
        30: [
            function(e, t, r) {
                "use strict";
                if (r.base64 = !0, r.array = !0, r.string = !0, r.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, r.nodebuffer = "undefined" != typeof Buffer, r.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) r.blob = !1;
                else {
                    var n = new ArrayBuffer(0);
                    try {
                        r.blob = 0 === new Blob([
                            n
                        ], {
                            type: "application/zip"
                        }).size;
                    } catch (e) {
                        try {
                            var i = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            i.append(n), r.blob = 0 === i.getBlob("application/zip").size;
                        } catch (e) {
                            r.blob = !1;
                        }
                    }
                }
                try {
                    r.nodestream = !!e("readable-stream").Readable;
                } catch (e) {
                    r.nodestream = !1;
                }
            },
            {
                "readable-stream": 16
            }
        ],
        31: [
            function(e, t, s) {
                "use strict";
                for(var o = e("./utils"), h = e("./support"), r = e("./nodejsUtils"), n = e("./stream/GenericWorker"), u = new Array(256), i = 0; i < 256; i++)u[i] = 252 <= i ? 6 : 248 <= i ? 5 : 240 <= i ? 4 : 224 <= i ? 3 : 192 <= i ? 2 : 1;
                u[254] = u[254] = 1;
                function a() {
                    n.call(this, "utf-8 decode"), this.leftOver = null;
                }
                function l() {
                    n.call(this, "utf-8 encode");
                }
                s.utf8encode = function(e) {
                    return h.nodebuffer ? r.newBufferFrom(e, "utf-8") : function(e) {
                        var t, r, n, i, s, a = e.length, o = 0;
                        for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                        for(t = h.uint8array ? new Uint8Array(o) : new Array(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                        return t;
                    }(e);
                }, s.utf8decode = function(e) {
                    return h.nodebuffer ? o.transformTo("nodebuffer", e).toString("utf-8") : function(e) {
                        var t, r, n, i, s = e.length, a = new Array(2 * s);
                        for(t = r = 0; t < s;)if ((n = e[t++]) < 128) a[r++] = n;
                        else if (4 < (i = u[n])) a[r++] = 65533, t += i - 1;
                        else {
                            for(n &= 2 === i ? 31 : 3 === i ? 15 : 7; 1 < i && t < s;)n = n << 6 | 63 & e[t++], i--;
                            1 < i ? a[r++] = 65533 : n < 65536 ? a[r++] = n : (n -= 65536, a[r++] = 55296 | n >> 10 & 1023, a[r++] = 56320 | 1023 & n);
                        }
                        return a.length !== r && (a.subarray ? a = a.subarray(0, r) : a.length = r), o.applyFromCharCode(a);
                    }(e = o.transformTo(h.uint8array ? "uint8array" : "array", e));
                }, o.inherits(a, n), a.prototype.processChunk = function(e) {
                    var t = o.transformTo(h.uint8array ? "uint8array" : "array", e.data);
                    if (this.leftOver && this.leftOver.length) {
                        if (h.uint8array) {
                            var r = t;
                            (t = new Uint8Array(r.length + this.leftOver.length)).set(this.leftOver, 0), t.set(r, this.leftOver.length);
                        } else t = this.leftOver.concat(t);
                        this.leftOver = null;
                    }
                    var n = function(e, t) {
                        var r;
                        for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                        return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                    }(t), i = t;
                    n !== t.length && (h.uint8array ? (i = t.subarray(0, n), this.leftOver = t.subarray(n, t.length)) : (i = t.slice(0, n), this.leftOver = t.slice(n, t.length))), this.push({
                        data: s.utf8decode(i),
                        meta: e.meta
                    });
                }, a.prototype.flush = function() {
                    this.leftOver && this.leftOver.length && (this.push({
                        data: s.utf8decode(this.leftOver),
                        meta: {}
                    }), this.leftOver = null);
                }, s.Utf8DecodeWorker = a, o.inherits(l, n), l.prototype.processChunk = function(e) {
                    this.push({
                        data: s.utf8encode(e.data),
                        meta: e.meta
                    });
                }, s.Utf8EncodeWorker = l;
            },
            {
                "./nodejsUtils": 14,
                "./stream/GenericWorker": 28,
                "./support": 30,
                "./utils": 32
            }
        ],
        32: [
            function(e, t, a) {
                "use strict";
                var o = e("./support"), h = e("./base64"), r = e("./nodejsUtils"), u = e("./external");
                function n(e) {
                    return e;
                }
                function l(e, t) {
                    for(var r = 0; r < e.length; ++r)t[r] = 255 & e.charCodeAt(r);
                    return t;
                }
                e("setimmediate"), a.newBlob = function(t, r) {
                    a.checkSupport("blob");
                    try {
                        return new Blob([
                            t
                        ], {
                            type: r
                        });
                    } catch (e) {
                        try {
                            var n = new (self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
                            return n.append(t), n.getBlob(r);
                        } catch (e) {
                            throw new Error("Bug : can't construct the Blob.");
                        }
                    }
                };
                var i = {
                    stringifyByChunk: function(e, t, r) {
                        var n = [], i = 0, s = e.length;
                        if (s <= r) return String.fromCharCode.apply(null, e);
                        for(; i < s;)"array" === t || "nodebuffer" === t ? n.push(String.fromCharCode.apply(null, e.slice(i, Math.min(i + r, s)))) : n.push(String.fromCharCode.apply(null, e.subarray(i, Math.min(i + r, s)))), i += r;
                        return n.join("");
                    },
                    stringifyByChar: function(e) {
                        for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                        return t;
                    },
                    applyCanBeUsed: {
                        uint8array: function() {
                            try {
                                return o.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }(),
                        nodebuffer: function() {
                            try {
                                return o.nodebuffer && 1 === String.fromCharCode.apply(null, r.allocBuffer(1)).length;
                            } catch (e) {
                                return !1;
                            }
                        }()
                    }
                };
                function s(e) {
                    var t = 65536, r = a.getTypeOf(e), n = !0;
                    if ("uint8array" === r ? n = i.applyCanBeUsed.uint8array : "nodebuffer" === r && (n = i.applyCanBeUsed.nodebuffer), n) for(; 1 < t;)try {
                        return i.stringifyByChunk(e, r, t);
                    } catch (e) {
                        t = Math.floor(t / 2);
                    }
                    return i.stringifyByChar(e);
                }
                function f(e, t) {
                    for(var r = 0; r < e.length; r++)t[r] = e[r];
                    return t;
                }
                a.applyFromCharCode = s;
                var c = {};
                c.string = {
                    string: n,
                    array: function(e) {
                        return l(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.string.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return l(e, new Uint8Array(e.length));
                    },
                    nodebuffer: function(e) {
                        return l(e, r.allocBuffer(e.length));
                    }
                }, c.array = {
                    string: s,
                    array: n,
                    arraybuffer: function(e) {
                        return new Uint8Array(e).buffer;
                    },
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.arraybuffer = {
                    string: function(e) {
                        return s(new Uint8Array(e));
                    },
                    array: function(e) {
                        return f(new Uint8Array(e), new Array(e.byteLength));
                    },
                    arraybuffer: n,
                    uint8array: function(e) {
                        return new Uint8Array(e);
                    },
                    nodebuffer: function(e) {
                        return r.newBufferFrom(new Uint8Array(e));
                    }
                }, c.uint8array = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return e.buffer;
                    },
                    uint8array: n,
                    nodebuffer: function(e) {
                        return r.newBufferFrom(e);
                    }
                }, c.nodebuffer = {
                    string: s,
                    array: function(e) {
                        return f(e, new Array(e.length));
                    },
                    arraybuffer: function(e) {
                        return c.nodebuffer.uint8array(e).buffer;
                    },
                    uint8array: function(e) {
                        return f(e, new Uint8Array(e.length));
                    },
                    nodebuffer: n
                }, a.transformTo = function(e, t) {
                    if (t = t || "", !e) return t;
                    a.checkSupport(e);
                    var r = a.getTypeOf(t);
                    return c[r][e](t);
                }, a.resolve = function(e) {
                    for(var t = e.split("/"), r = [], n = 0; n < t.length; n++){
                        var i = t[n];
                        "." === i || "" === i && 0 !== n && n !== t.length - 1 || (".." === i ? r.pop() : r.push(i));
                    }
                    return r.join("/");
                }, a.getTypeOf = function(e) {
                    return "string" == typeof e ? "string" : "[object Array]" === Object.prototype.toString.call(e) ? "array" : o.nodebuffer && r.isBuffer(e) ? "nodebuffer" : o.uint8array && e instanceof Uint8Array ? "uint8array" : o.arraybuffer && e instanceof ArrayBuffer ? "arraybuffer" : void 0;
                }, a.checkSupport = function(e) {
                    if (!o[e.toLowerCase()]) throw new Error(e + " is not supported by this platform");
                }, a.MAX_VALUE_16BITS = 65535, a.MAX_VALUE_32BITS = -1, a.pretty = function(e) {
                    var t, r, n = "";
                    for(r = 0; r < (e || "").length; r++)n += "\\x" + ((t = e.charCodeAt(r)) < 16 ? "0" : "") + t.toString(16).toUpperCase();
                    return n;
                }, a.delay = function(e, t, r) {
                    setImmediate(function() {
                        e.apply(r || null, t || []);
                    });
                }, a.inherits = function(e, t) {
                    function r() {}
                    r.prototype = t.prototype, e.prototype = new r;
                }, a.extend = function() {
                    var e, t, r = {};
                    for(e = 0; e < arguments.length; e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e], t) && void 0 === r[t] && (r[t] = arguments[e][t]);
                    return r;
                }, a.prepareContent = function(r, e, n, i, s) {
                    return u.Promise.resolve(e).then(function(n) {
                        return o.blob && (n instanceof Blob || -1 !== [
                            "[object File]",
                            "[object Blob]"
                        ].indexOf(Object.prototype.toString.call(n))) && "undefined" != typeof FileReader ? new u.Promise(function(t, r) {
                            var e = new FileReader;
                            e.onload = function(e) {
                                t(e.target.result);
                            }, e.onerror = function(e) {
                                r(e.target.error);
                            }, e.readAsArrayBuffer(n);
                        }) : n;
                    }).then(function(e) {
                        var t = a.getTypeOf(e);
                        return t ? ("arraybuffer" === t ? e = a.transformTo("uint8array", e) : "string" === t && (s ? e = h.decode(e) : n && !0 !== i && (e = function(e) {
                            return l(e, o.uint8array ? new Uint8Array(e.length) : new Array(e.length));
                        }(e))), e) : u.Promise.reject(new Error("Can't read the data of '" + r + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
                    });
                };
            },
            {
                "./base64": 1,
                "./external": 6,
                "./nodejsUtils": 14,
                "./support": 30,
                setimmediate: 54
            }
        ],
        33: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), i = e("./utils"), s = e("./signature"), a = e("./zipEntry"), o = e("./support");
                function h(e) {
                    this.files = [], this.loadOptions = e;
                }
                h.prototype = {
                    checkSignature: function(e) {
                        if (!this.reader.readAndCheckSignature(e)) {
                            this.reader.index -= 4;
                            var t = this.reader.readString(4);
                            throw new Error("Corrupted zip or bug: unexpected signature (" + i.pretty(t) + ", expected " + i.pretty(e) + ")");
                        }
                    },
                    isSignature: function(e, t) {
                        var r = this.reader.index;
                        this.reader.setIndex(e);
                        var n = this.reader.readString(4) === t;
                        return this.reader.setIndex(r), n;
                    },
                    readBlockEndOfCentral: function() {
                        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
                        var e = this.reader.readData(this.zipCommentLength), t = o.uint8array ? "uint8array" : "array", r = i.transformTo(t, e);
                        this.zipComment = this.loadOptions.decodeFileName(r);
                    },
                    readBlockZip64EndOfCentral: function() {
                        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
                        for(var e, t, r, n = this.zip64EndOfCentralSize - 44; 0 < n;)e = this.reader.readInt(2), t = this.reader.readInt(4), r = this.reader.readData(t), this.zip64ExtensibleData[e] = {
                            id: e,
                            length: t,
                            value: r
                        };
                    },
                    readBlockZip64EndOfCentralLocator: function() {
                        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), 1 < this.disksCount) throw new Error("Multi-volumes zip are not supported");
                    },
                    readLocalFiles: function() {
                        var e, t;
                        for(e = 0; e < this.files.length; e++)t = this.files[e], this.reader.setIndex(t.localHeaderOffset), this.checkSignature(s.LOCAL_FILE_HEADER), t.readLocalPart(this.reader), t.handleUTF8(), t.processAttributes();
                    },
                    readCentralDir: function() {
                        var e;
                        for(this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e = new a({
                            zip64: this.zip64
                        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(e);
                        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
                    },
                    readEndOfCentral: function() {
                        var e = this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);
                        if (e < 0) throw !this.isSignature(0, s.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
                        this.reader.setIndex(e);
                        var t = e;
                        if (this.checkSignature(s.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === i.MAX_VALUE_16BITS || this.diskWithCentralDirStart === i.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === i.MAX_VALUE_16BITS || this.centralDirRecords === i.MAX_VALUE_16BITS || this.centralDirSize === i.MAX_VALUE_32BITS || this.centralDirOffset === i.MAX_VALUE_32BITS) {
                            if (this.zip64 = !0, (e = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
                            if (this.reader.setIndex(e), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, s.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
                            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral();
                        }
                        var r = this.centralDirOffset + this.centralDirSize;
                        this.zip64 && (r += 20, r += 12 + this.zip64EndOfCentralSize);
                        var n = t - r;
                        if (0 < n) this.isSignature(t, s.CENTRAL_FILE_HEADER) || (this.reader.zero = n);
                        else if (n < 0) throw new Error("Corrupted zip: missing " + Math.abs(n) + " bytes.");
                    },
                    prepareReader: function(e) {
                        this.reader = n(e);
                    },
                    load: function(e) {
                        this.prepareReader(e), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
                    }
                }, t.exports = h;
            },
            {
                "./reader/readerFor": 22,
                "./signature": 23,
                "./support": 30,
                "./utils": 32,
                "./zipEntry": 34
            }
        ],
        34: [
            function(e, t, r) {
                "use strict";
                var n = e("./reader/readerFor"), s = e("./utils"), i = e("./compressedObject"), a = e("./crc32"), o = e("./utf8"), h = e("./compressions"), u = e("./support");
                function l(e, t) {
                    this.options = e, this.loadOptions = t;
                }
                l.prototype = {
                    isEncrypted: function() {
                        return 1 == (1 & this.bitFlag);
                    },
                    useUTF8: function() {
                        return 2048 == (2048 & this.bitFlag);
                    },
                    readLocalPart: function(e) {
                        var t, r;
                        if (e.skip(22), this.fileNameLength = e.readInt(2), r = e.readInt(2), this.fileName = e.readData(this.fileNameLength), e.skip(r), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
                        if (null === (t = function(e) {
                            for(var t in h)if (Object.prototype.hasOwnProperty.call(h, t) && h[t].magic === e) return h[t];
                            return null;
                        }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
                        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, t, e.readData(this.compressedSize));
                    },
                    readCentralPart: function(e) {
                        this.versionMadeBy = e.readInt(2), e.skip(2), this.bitFlag = e.readInt(2), this.compressionMethod = e.readString(2), this.date = e.readDate(), this.crc32 = e.readInt(4), this.compressedSize = e.readInt(4), this.uncompressedSize = e.readInt(4);
                        var t = e.readInt(2);
                        if (this.extraFieldsLength = e.readInt(2), this.fileCommentLength = e.readInt(2), this.diskNumberStart = e.readInt(2), this.internalFileAttributes = e.readInt(2), this.externalFileAttributes = e.readInt(4), this.localHeaderOffset = e.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
                        e.skip(t), this.readExtraFields(e), this.parseZIP64ExtraField(e), this.fileComment = e.readData(this.fileCommentLength);
                    },
                    processAttributes: function() {
                        this.unixPermissions = null, this.dosPermissions = null;
                        var e = this.versionMadeBy >> 8;
                        this.dir = !!(16 & this.externalFileAttributes), 0 == e && (this.dosPermissions = 63 & this.externalFileAttributes), 3 == e && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0);
                    },
                    parseZIP64ExtraField: function() {
                        if (this.extraFields[1]) {
                            var e = n(this.extraFields[1].value);
                            this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4));
                        }
                    },
                    readExtraFields: function(e) {
                        var t, r, n, i = e.index + this.extraFieldsLength;
                        for(this.extraFields || (this.extraFields = {}); e.index + 4 < i;)t = e.readInt(2), r = e.readInt(2), n = e.readData(r), this.extraFields[t] = {
                            id: t,
                            length: r,
                            value: n
                        };
                        e.setIndex(i);
                    },
                    handleUTF8: function() {
                        var e = u.uint8array ? "uint8array" : "array";
                        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
                        else {
                            var t = this.findExtraFieldUnicodePath();
                            if (null !== t) this.fileNameStr = t;
                            else {
                                var r = s.transformTo(e, this.fileName);
                                this.fileNameStr = this.loadOptions.decodeFileName(r);
                            }
                            var n = this.findExtraFieldUnicodeComment();
                            if (null !== n) this.fileCommentStr = n;
                            else {
                                var i = s.transformTo(e, this.fileComment);
                                this.fileCommentStr = this.loadOptions.decodeFileName(i);
                            }
                        }
                    },
                    findExtraFieldUnicodePath: function() {
                        var e = this.extraFields[28789];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileName) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    },
                    findExtraFieldUnicodeComment: function() {
                        var e = this.extraFields[25461];
                        if (e) {
                            var t = n(e.value);
                            return 1 !== t.readInt(1) ? null : a(this.fileComment) !== t.readInt(4) ? null : o.utf8decode(t.readData(e.length - 5));
                        }
                        return null;
                    }
                }, t.exports = l;
            },
            {
                "./compressedObject": 2,
                "./compressions": 3,
                "./crc32": 4,
                "./reader/readerFor": 22,
                "./support": 30,
                "./utf8": 31,
                "./utils": 32
            }
        ],
        35: [
            function(e, t, r) {
                "use strict";
                function n(e, t, r) {
                    this.name = e, this.dir = r.dir, this.date = r.date, this.comment = r.comment, this.unixPermissions = r.unixPermissions, this.dosPermissions = r.dosPermissions, this._data = t, this._dataBinary = r.binary, this.options = {
                        compression: r.compression,
                        compressionOptions: r.compressionOptions
                    };
                }
                var s = e("./stream/StreamHelper"), i = e("./stream/DataWorker"), a = e("./utf8"), o = e("./compressedObject"), h = e("./stream/GenericWorker");
                n.prototype = {
                    internalStream: function(e) {
                        var t = null, r = "string";
                        try {
                            if (!e) throw new Error("No output type specified.");
                            var n = "string" === (r = e.toLowerCase()) || "text" === r;
                            "binarystring" !== r && "text" !== r || (r = "string"), t = this._decompressWorker();
                            var i = !this._dataBinary;
                            i && !n && (t = t.pipe(new a.Utf8EncodeWorker)), !i && n && (t = t.pipe(new a.Utf8DecodeWorker));
                        } catch (e) {
                            (t = new h("error")).error(e);
                        }
                        return new s(t, r, "");
                    },
                    async: function(e, t) {
                        return this.internalStream(e).accumulate(t);
                    },
                    nodeStream: function(e, t) {
                        return this.internalStream(e || "nodebuffer").toNodejsStream(t);
                    },
                    _compressWorker: function(e, t) {
                        if (this._data instanceof o && this._data.compression.magic === e.magic) return this._data.getCompressedWorker();
                        var r = this._decompressWorker();
                        return this._dataBinary || (r = r.pipe(new a.Utf8EncodeWorker)), o.createWorkerFrom(r, e, t);
                    },
                    _decompressWorker: function() {
                        return this._data instanceof o ? this._data.getContentWorker() : this._data instanceof h ? this._data : new i(this._data);
                    }
                };
                for(var u = [
                    "asText",
                    "asBinary",
                    "asNodeBuffer",
                    "asUint8Array",
                    "asArrayBuffer"
                ], l = function() {
                    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
                }, f = 0; f < u.length; f++)n.prototype[u[f]] = l;
                t.exports = n;
            },
            {
                "./compressedObject": 2,
                "./stream/DataWorker": 27,
                "./stream/GenericWorker": 28,
                "./stream/StreamHelper": 29,
                "./utf8": 31
            }
        ],
        36: [
            function(e, l, t) {
                (function(t) {
                    "use strict";
                    var r, n, e = t.MutationObserver || t.WebKitMutationObserver;
                    if (e) {
                        var i = 0, s = new e(u), a = t.document.createTextNode("");
                        s.observe(a, {
                            characterData: !0
                        }), r = function() {
                            a.data = i = ++i % 2;
                        };
                    } else if (t.setImmediate || void 0 === t.MessageChannel) r = "document" in t && "onreadystatechange" in t.document.createElement("script") ? function() {
                        var e = t.document.createElement("script");
                        e.onreadystatechange = function() {
                            u(), e.onreadystatechange = null, e.parentNode.removeChild(e), e = null;
                        }, t.document.documentElement.appendChild(e);
                    } : function() {
                        setTimeout(u, 0);
                    };
                    else {
                        var o = new t.MessageChannel;
                        o.port1.onmessage = u, r = function() {
                            o.port2.postMessage(0);
                        };
                    }
                    var h = [];
                    function u() {
                        var e, t;
                        n = !0;
                        for(var r = h.length; r;){
                            for(t = h, h = [], e = -1; ++e < r;)t[e]();
                            r = h.length;
                        }
                        n = !1;
                    }
                    l.exports = function(e) {
                        1 !== h.push(e) || n || r();
                    };
                }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ],
        37: [
            function(e, t, r) {
                "use strict";
                var i = e("immediate");
                function u() {}
                var l = {}, s = [
                    "REJECTED"
                ], a = [
                    "FULFILLED"
                ], n = [
                    "PENDING"
                ];
                function o(e) {
                    if ("function" != typeof e) throw new TypeError("resolver must be a function");
                    this.state = n, this.queue = [], this.outcome = void 0, e !== u && d(this, e);
                }
                function h(e, t, r) {
                    this.promise = e, "function" == typeof t && (this.onFulfilled = t, this.callFulfilled = this.otherCallFulfilled), "function" == typeof r && (this.onRejected = r, this.callRejected = this.otherCallRejected);
                }
                function f(t, r, n) {
                    i(function() {
                        var e;
                        try {
                            e = r(n);
                        } catch (e) {
                            return l.reject(t, e);
                        }
                        e === t ? l.reject(t, new TypeError("Cannot resolve promise with itself")) : l.resolve(t, e);
                    });
                }
                function c(e) {
                    var t = e && e.then;
                    if (e && ("object" == typeof e || "function" == typeof e) && "function" == typeof t) return function() {
                        t.apply(e, arguments);
                    };
                }
                function d(t, e) {
                    var r = !1;
                    function n(e) {
                        r || (r = !0, l.reject(t, e));
                    }
                    function i(e) {
                        r || (r = !0, l.resolve(t, e));
                    }
                    var s = p(function() {
                        e(i, n);
                    });
                    "error" === s.status && n(s.value);
                }
                function p(e, t) {
                    var r = {};
                    try {
                        r.value = e(t), r.status = "success";
                    } catch (e) {
                        r.status = "error", r.value = e;
                    }
                    return r;
                }
                (t.exports = o).prototype.finally = function(t) {
                    if ("function" != typeof t) return this;
                    var r = this.constructor;
                    return this.then(function(e) {
                        return r.resolve(t()).then(function() {
                            return e;
                        });
                    }, function(e) {
                        return r.resolve(t()).then(function() {
                            throw e;
                        });
                    });
                }, o.prototype.catch = function(e) {
                    return this.then(null, e);
                }, o.prototype.then = function(e, t) {
                    if ("function" != typeof e && this.state === a || "function" != typeof t && this.state === s) return this;
                    var r = new this.constructor(u);
                    this.state !== n ? f(r, this.state === a ? e : t, this.outcome) : this.queue.push(new h(r, e, t));
                    return r;
                }, h.prototype.callFulfilled = function(e) {
                    l.resolve(this.promise, e);
                }, h.prototype.otherCallFulfilled = function(e) {
                    f(this.promise, this.onFulfilled, e);
                }, h.prototype.callRejected = function(e) {
                    l.reject(this.promise, e);
                }, h.prototype.otherCallRejected = function(e) {
                    f(this.promise, this.onRejected, e);
                }, l.resolve = function(e, t) {
                    var r = p(c, t);
                    if ("error" === r.status) return l.reject(e, r.value);
                    var n = r.value;
                    if (n) d(e, n);
                    else {
                        e.state = a, e.outcome = t;
                        for(var i = -1, s = e.queue.length; ++i < s;)e.queue[i].callFulfilled(t);
                    }
                    return e;
                }, l.reject = function(e, t) {
                    e.state = s, e.outcome = t;
                    for(var r = -1, n = e.queue.length; ++r < n;)e.queue[r].callRejected(t);
                    return e;
                }, o.resolve = function(e) {
                    if (e instanceof this) return e;
                    return l.resolve(new this(u), e);
                }, o.reject = function(e) {
                    var t = new this(u);
                    return l.reject(t, e);
                }, o.all = function(e) {
                    var r = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var n = e.length, i = !1;
                    if (!n) return this.resolve([]);
                    var s = new Array(n), a = 0, t = -1, o = new this(u);
                    for(; ++t < n;)h(e[t], t);
                    return o;
                    function h(e, t) {
                        r.resolve(e).then(function(e) {
                            s[t] = e, ++a !== n || i || (i = !0, l.resolve(o, s));
                        }, function(e) {
                            i || (i = !0, l.reject(o, e));
                        });
                    }
                }, o.race = function(e) {
                    var t = this;
                    if ("[object Array]" !== Object.prototype.toString.call(e)) return this.reject(new TypeError("must be an array"));
                    var r = e.length, n = !1;
                    if (!r) return this.resolve([]);
                    var i = -1, s = new this(u);
                    for(; ++i < r;)a = e[i], t.resolve(a).then(function(e) {
                        n || (n = !0, l.resolve(s, e));
                    }, function(e) {
                        n || (n = !0, l.reject(s, e));
                    });
                    var a;
                    return s;
                };
            },
            {
                immediate: 36
            }
        ],
        38: [
            function(e, t, r) {
                "use strict";
                var n = {};
                (0, e("./lib/utils/common").assign)(n, e("./lib/deflate"), e("./lib/inflate"), e("./lib/zlib/constants")), t.exports = n;
            },
            {
                "./lib/deflate": 39,
                "./lib/inflate": 40,
                "./lib/utils/common": 41,
                "./lib/zlib/constants": 44
            }
        ],
        39: [
            function(e, t, r) {
                "use strict";
                var a = e("./zlib/deflate"), o = e("./utils/common"), h = e("./utils/strings"), i = e("./zlib/messages"), s = e("./zlib/zstream"), u = Object.prototype.toString, l = 0, f = -1, c = 0, d = 8;
                function p(e) {
                    if (!(this instanceof p)) return new p(e);
                    this.options = o.assign({
                        level: f,
                        method: d,
                        chunkSize: 16384,
                        windowBits: 15,
                        memLevel: 8,
                        strategy: c,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 < t.windowBits ? t.windowBits = -t.windowBits : t.gzip && 0 < t.windowBits && t.windowBits < 16 && (t.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s, this.strm.avail_out = 0;
                    var r = a.deflateInit2(this.strm, t.level, t.method, t.windowBits, t.memLevel, t.strategy);
                    if (r !== l) throw new Error(i[r]);
                    if (t.header && a.deflateSetHeader(this.strm, t.header), t.dictionary) {
                        var n;
                        if (n = "string" == typeof t.dictionary ? h.string2buf(t.dictionary) : "[object ArrayBuffer]" === u.call(t.dictionary) ? new Uint8Array(t.dictionary) : t.dictionary, (r = a.deflateSetDictionary(this.strm, n)) !== l) throw new Error(i[r]);
                        this._dict_set = !0;
                    }
                }
                function n(e, t) {
                    var r = new p(t);
                    if (r.push(e, !0), r.err) throw r.msg || i[r.err];
                    return r.result;
                }
                p.prototype.push = function(e, t) {
                    var r, n, i = this.strm, s = this.options.chunkSize;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? 4 : 0, "string" == typeof e ? i.input = h.string2buf(e) : "[object ArrayBuffer]" === u.call(e) ? i.input = new Uint8Array(e) : i.input = e, i.next_in = 0, i.avail_in = i.input.length;
                    do {
                        if (0 === i.avail_out && (i.output = new o.Buf8(s), i.next_out = 0, i.avail_out = s), 1 !== (r = a.deflate(i, n)) && r !== l) return this.onEnd(r), this.ended = !0, false;
                        0 !== i.avail_out && (0 !== i.avail_in || 4 !== n && 2 !== n) || ("string" === this.options.to ? this.onData(h.buf2binstring(o.shrinkBuf(i.output, i.next_out))) : this.onData(o.shrinkBuf(i.output, i.next_out)));
                    }while ((0 < i.avail_in || 0 === i.avail_out) && 1 !== r);
                    return 4 === n ? (r = a.deflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === l) : 2 !== n || (this.onEnd(l), i.avail_out = 0, true);
                }, p.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, p.prototype.onEnd = function(e) {
                    e === l && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = o.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Deflate = p, r.deflate = n, r.deflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, n(e, t);
                }, r.gzip = function(e, t) {
                    return (t = t || {}).gzip = !0, n(e, t);
                };
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/deflate": 46,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        40: [
            function(e, t, r) {
                "use strict";
                var c = e("./zlib/inflate"), d = e("./utils/common"), p = e("./utils/strings"), m = e("./zlib/constants"), n = e("./zlib/messages"), i = e("./zlib/zstream"), s = e("./zlib/gzheader"), _ = Object.prototype.toString;
                function a(e) {
                    if (!(this instanceof a)) return new a(e);
                    this.options = d.assign({
                        chunkSize: 16384,
                        windowBits: 0,
                        to: ""
                    }, e || {});
                    var t = this.options;
                    t.raw && 0 <= t.windowBits && t.windowBits < 16 && (t.windowBits = -t.windowBits, 0 === t.windowBits && (t.windowBits = -15)), !(0 <= t.windowBits && t.windowBits < 16) || e && e.windowBits || (t.windowBits += 32), 15 < t.windowBits && t.windowBits < 48 && 0 == (15 & t.windowBits) && (t.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i, this.strm.avail_out = 0;
                    var r = c.inflateInit2(this.strm, t.windowBits);
                    if (r !== m.Z_OK) throw new Error(n[r]);
                    this.header = new s, c.inflateGetHeader(this.strm, this.header);
                }
                function o(e, t) {
                    var r = new a(t);
                    if (r.push(e, !0), r.err) throw r.msg || n[r.err];
                    return r.result;
                }
                a.prototype.push = function(e, t) {
                    var r, n, i, s, a, o, h = this.strm, u = this.options.chunkSize, l = this.options.dictionary, f = !1;
                    if (this.ended) return !1;
                    n = t === ~~t ? t : !0 === t ? m.Z_FINISH : m.Z_NO_FLUSH, "string" == typeof e ? h.input = p.binstring2buf(e) : "[object ArrayBuffer]" === _.call(e) ? h.input = new Uint8Array(e) : h.input = e, h.next_in = 0, h.avail_in = h.input.length;
                    do {
                        if (0 === h.avail_out && (h.output = new d.Buf8(u), h.next_out = 0, h.avail_out = u), (r = c.inflate(h, m.Z_NO_FLUSH)) === m.Z_NEED_DICT && l && (o = "string" == typeof l ? p.string2buf(l) : "[object ArrayBuffer]" === _.call(l) ? new Uint8Array(l) : l, r = c.inflateSetDictionary(this.strm, o)), r === m.Z_BUF_ERROR && !0 === f && (r = m.Z_OK, f = !1), r !== m.Z_STREAM_END && r !== m.Z_OK) return this.onEnd(r), this.ended = !0, false;
                        h.next_out && (0 !== h.avail_out && r !== m.Z_STREAM_END && (0 !== h.avail_in || n !== m.Z_FINISH && n !== m.Z_SYNC_FLUSH) || ("string" === this.options.to ? (i = p.utf8border(h.output, h.next_out), s = h.next_out - i, a = p.buf2string(h.output, i), h.next_out = s, h.avail_out = u - s, s && d.arraySet(h.output, h.output, i, s, 0), this.onData(a)) : this.onData(d.shrinkBuf(h.output, h.next_out)))), 0 === h.avail_in && 0 === h.avail_out && (f = !0);
                    }while ((0 < h.avail_in || 0 === h.avail_out) && r !== m.Z_STREAM_END);
                    return r === m.Z_STREAM_END && (n = m.Z_FINISH), n === m.Z_FINISH ? (r = c.inflateEnd(this.strm), this.onEnd(r), this.ended = !0, r === m.Z_OK) : n !== m.Z_SYNC_FLUSH || (this.onEnd(m.Z_OK), h.avail_out = 0, true);
                }, a.prototype.onData = function(e) {
                    this.chunks.push(e);
                }, a.prototype.onEnd = function(e) {
                    e === m.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = d.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
                }, r.Inflate = a, r.inflate = o, r.inflateRaw = function(e, t) {
                    return (t = t || {}).raw = !0, o(e, t);
                }, r.ungzip = o;
            },
            {
                "./utils/common": 41,
                "./utils/strings": 42,
                "./zlib/constants": 44,
                "./zlib/gzheader": 47,
                "./zlib/inflate": 49,
                "./zlib/messages": 51,
                "./zlib/zstream": 53
            }
        ],
        41: [
            function(e, t, r) {
                "use strict";
                var n = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;
                r.assign = function(e) {
                    for(var t = Array.prototype.slice.call(arguments, 1); t.length;){
                        var r = t.shift();
                        if (r) {
                            if ("object" != typeof r) throw new TypeError(r + "must be non-object");
                            for(var n in r)r.hasOwnProperty(n) && (e[n] = r[n]);
                        }
                    }
                    return e;
                }, r.shrinkBuf = function(e, t) {
                    return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
                };
                var i = {
                    arraySet: function(e, t, r, n, i) {
                        if (t.subarray && e.subarray) e.set(t.subarray(r, r + n), i);
                        else for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        var t, r, n, i, s, a;
                        for(t = n = 0, r = e.length; t < r; t++)n += e[t].length;
                        for(a = new Uint8Array(n), t = i = 0, r = e.length; t < r; t++)s = e[t], a.set(s, i), i += s.length;
                        return a;
                    }
                }, s = {
                    arraySet: function(e, t, r, n, i) {
                        for(var s = 0; s < n; s++)e[i + s] = t[r + s];
                    },
                    flattenChunks: function(e) {
                        return [].concat.apply([], e);
                    }
                };
                r.setTyped = function(e) {
                    e ? (r.Buf8 = Uint8Array, r.Buf16 = Uint16Array, r.Buf32 = Int32Array, r.assign(r, i)) : (r.Buf8 = Array, r.Buf16 = Array, r.Buf32 = Array, r.assign(r, s));
                }, r.setTyped(n);
            },
            {}
        ],
        42: [
            function(e, t, r) {
                "use strict";
                var h = e("./common"), i = !0, s = !0;
                try {
                    String.fromCharCode.apply(null, [
                        0
                    ]);
                } catch (e) {
                    i = !1;
                }
                try {
                    String.fromCharCode.apply(null, new Uint8Array(1));
                } catch (e) {
                    s = !1;
                }
                for(var u = new h.Buf8(256), n = 0; n < 256; n++)u[n] = 252 <= n ? 6 : 248 <= n ? 5 : 240 <= n ? 4 : 224 <= n ? 3 : 192 <= n ? 2 : 1;
                function l(e, t) {
                    if (t < 65537 && (e.subarray && s || !e.subarray && i)) return String.fromCharCode.apply(null, h.shrinkBuf(e, t));
                    for(var r = "", n = 0; n < t; n++)r += String.fromCharCode(e[n]);
                    return r;
                }
                u[254] = u[254] = 1, r.string2buf = function(e) {
                    var t, r, n, i, s, a = e.length, o = 0;
                    for(i = 0; i < a; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), o += r < 128 ? 1 : r < 2048 ? 2 : r < 65536 ? 3 : 4;
                    for(t = new h.Buf8(o), i = s = 0; s < o; i++)55296 == (64512 & (r = e.charCodeAt(i))) && i + 1 < a && 56320 == (64512 & (n = e.charCodeAt(i + 1))) && (r = 65536 + (r - 55296 << 10) + (n - 56320), i++), r < 128 ? t[s++] = r : (r < 2048 ? t[s++] = 192 | r >>> 6 : (r < 65536 ? t[s++] = 224 | r >>> 12 : (t[s++] = 240 | r >>> 18, t[s++] = 128 | r >>> 12 & 63), t[s++] = 128 | r >>> 6 & 63), t[s++] = 128 | 63 & r);
                    return t;
                }, r.buf2binstring = function(e) {
                    return l(e, e.length);
                }, r.binstring2buf = function(e) {
                    for(var t = new h.Buf8(e.length), r = 0, n = t.length; r < n; r++)t[r] = e.charCodeAt(r);
                    return t;
                }, r.buf2string = function(e, t) {
                    var r, n, i, s, a = t || e.length, o = new Array(2 * a);
                    for(r = n = 0; r < a;)if ((i = e[r++]) < 128) o[n++] = i;
                    else if (4 < (s = u[i])) o[n++] = 65533, r += s - 1;
                    else {
                        for(i &= 2 === s ? 31 : 3 === s ? 15 : 7; 1 < s && r < a;)i = i << 6 | 63 & e[r++], s--;
                        1 < s ? o[n++] = 65533 : i < 65536 ? o[n++] = i : (i -= 65536, o[n++] = 55296 | i >> 10 & 1023, o[n++] = 56320 | 1023 & i);
                    }
                    return l(o, n);
                }, r.utf8border = function(e, t) {
                    var r;
                    for((t = t || e.length) > e.length && (t = e.length), r = t - 1; 0 <= r && 128 == (192 & e[r]);)r--;
                    return r < 0 ? t : 0 === r ? t : r + u[e[r]] > t ? r : t;
                };
            },
            {
                "./common": 41
            }
        ],
        43: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t, r, n) {
                    for(var i = 65535 & e | 0, s = e >>> 16 & 65535 | 0, a = 0; 0 !== r;){
                        for(r -= a = 2e3 < r ? 2e3 : r; s = s + (i = i + t[n++] | 0) | 0, --a;);
                        i %= 65521, s %= 65521;
                    }
                    return i | s << 16 | 0;
                };
            },
            {}
        ],
        44: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    Z_NO_FLUSH: 0,
                    Z_PARTIAL_FLUSH: 1,
                    Z_SYNC_FLUSH: 2,
                    Z_FULL_FLUSH: 3,
                    Z_FINISH: 4,
                    Z_BLOCK: 5,
                    Z_TREES: 6,
                    Z_OK: 0,
                    Z_STREAM_END: 1,
                    Z_NEED_DICT: 2,
                    Z_ERRNO: -1,
                    Z_STREAM_ERROR: -2,
                    Z_DATA_ERROR: -3,
                    Z_BUF_ERROR: -5,
                    Z_NO_COMPRESSION: 0,
                    Z_BEST_SPEED: 1,
                    Z_BEST_COMPRESSION: 9,
                    Z_DEFAULT_COMPRESSION: -1,
                    Z_FILTERED: 1,
                    Z_HUFFMAN_ONLY: 2,
                    Z_RLE: 3,
                    Z_FIXED: 4,
                    Z_DEFAULT_STRATEGY: 0,
                    Z_BINARY: 0,
                    Z_TEXT: 1,
                    Z_UNKNOWN: 2,
                    Z_DEFLATED: 8
                };
            },
            {}
        ],
        45: [
            function(e, t, r) {
                "use strict";
                var o = function() {
                    for(var e, t = [], r = 0; r < 256; r++){
                        e = r;
                        for(var n = 0; n < 8; n++)e = 1 & e ? 3988292384 ^ e >>> 1 : e >>> 1;
                        t[r] = e;
                    }
                    return t;
                }();
                t.exports = function(e, t, r, n) {
                    var i = o, s = n + r;
                    e ^= -1;
                    for(var a = n; a < s; a++)e = e >>> 8 ^ i[255 & (e ^ t[a])];
                    return -1 ^ e;
                };
            },
            {}
        ],
        46: [
            function(e, t, r) {
                "use strict";
                var h, c = e("../utils/common"), u = e("./trees"), d = e("./adler32"), p = e("./crc32"), n = e("./messages"), l = 0, f = 4, m = 0, _ = -2, g = -1, b = 4, i = 2, v = 8, y = 9, s = 286, a = 30, o = 19, w = 2 * s + 1, k = 15, x = 3, S = 258, z = S + x + 1, C = 42, E = 113, A = 1, I = 2, O = 3, B = 4;
                function R(e, t) {
                    return e.msg = n[t], t;
                }
                function T(e) {
                    return (e << 1) - (4 < e ? 9 : 0);
                }
                function D(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                function F(e) {
                    var t = e.state, r = t.pending;
                    r > e.avail_out && (r = e.avail_out), 0 !== r && (c.arraySet(e.output, t.pending_buf, t.pending_out, r, e.next_out), e.next_out += r, t.pending_out += r, e.total_out += r, e.avail_out -= r, t.pending -= r, 0 === t.pending && (t.pending_out = 0));
                }
                function N(e, t) {
                    u._tr_flush_block(e, 0 <= e.block_start ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, F(e.strm);
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = t;
                }
                function P(e, t) {
                    e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = 255 & t;
                }
                function L(e, t) {
                    var r, n, i = e.max_chain_length, s = e.strstart, a = e.prev_length, o = e.nice_match, h = e.strstart > e.w_size - z ? e.strstart - (e.w_size - z) : 0, u = e.window, l = e.w_mask, f = e.prev, c = e.strstart + S, d = u[s + a - 1], p = u[s + a];
                    e.prev_length >= e.good_match && (i >>= 2), o > e.lookahead && (o = e.lookahead);
                    do if (u[(r = t) + a] === p && u[r + a - 1] === d && u[r] === u[s] && u[++r] === u[s + 1]) {
                        s += 2, r++;
                        do ;
                        while (u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && u[++s] === u[++r] && s < c);
                        if (n = S - (c - s), s = c - S, a < n) {
                            if (e.match_start = t, o <= (a = n)) break;
                            d = u[s + a - 1], p = u[s + a];
                        }
                    }
                    while ((t = f[t & l]) > h && 0 != --i);
                    return a <= e.lookahead ? a : e.lookahead;
                }
                function j(e) {
                    var t, r, n, i, s, a, o, h, u, l, f = e.w_size;
                    do {
                        if (i = e.window_size - e.lookahead - e.strstart, e.strstart >= f + (f - z)) {
                            for(c.arraySet(e.window, e.window, f, f, 0), e.match_start -= f, e.strstart -= f, e.block_start -= f, t = r = e.hash_size; n = e.head[--t], e.head[t] = f <= n ? n - f : 0, --r;);
                            for(t = r = f; n = e.prev[--t], e.prev[t] = f <= n ? n - f : 0, --r;);
                            i += f;
                        }
                        if (0 === e.strm.avail_in) break;
                        if (a = e.strm, o = e.window, h = e.strstart + e.lookahead, u = i, l = void 0, l = a.avail_in, u < l && (l = u), r = 0 === l ? 0 : (a.avail_in -= l, c.arraySet(o, a.input, a.next_in, l, h), 1 === a.state.wrap ? a.adler = d(a.adler, o, l, h) : 2 === a.state.wrap && (a.adler = p(a.adler, o, l, h)), a.next_in += l, a.total_in += l, l), e.lookahead += r, e.lookahead + e.insert >= x) for(s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + x - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < x)););
                    }while (e.lookahead < z && 0 !== e.strm.avail_in);
                }
                function Z(e, t) {
                    for(var r, n;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 !== r && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r)), e.match_length >= x) {
                            if (n = u._tr_tally(e, e.strstart - e.match_start, e.match_length - x), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= x) {
                                for(e.match_length--; e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart, 0 != --e.match_length;);
                                e.strstart++;
                            } else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
                        } else n = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
                        if (n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                    }
                    return e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function W(e, t) {
                    for(var r, n, i;;){
                        if (e.lookahead < z) {
                            if (j(e), e.lookahead < z && t === l) return A;
                            if (0 === e.lookahead) break;
                        }
                        if (r = 0, e.lookahead >= x && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = x - 1, 0 !== r && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - z && (e.match_length = L(e, r), e.match_length <= 5 && (1 === e.strategy || e.match_length === x && 4096 < e.strstart - e.match_start) && (e.match_length = x - 1)), e.prev_length >= x && e.match_length <= e.prev_length) {
                            for(i = e.strstart + e.lookahead - x, n = u._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - x), e.lookahead -= e.prev_length - 1, e.prev_length -= 2; ++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + x - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), 0 != --e.prev_length;);
                            if (e.match_available = 0, e.match_length = x - 1, e.strstart++, n && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        } else if (e.match_available) {
                            if ((n = u._tr_tally(e, 0, e.window[e.strstart - 1])) && N(e, !1), e.strstart++, e.lookahead--, 0 === e.strm.avail_out) return A;
                        } else e.match_available = 1, e.strstart++, e.lookahead--;
                    }
                    return e.match_available && (n = u._tr_tally(e, 0, e.window[e.strstart - 1]), e.match_available = 0), e.insert = e.strstart < x - 1 ? e.strstart : x - 1, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                }
                function M(e, t, r, n, i) {
                    this.good_length = e, this.max_lazy = t, this.nice_length = r, this.max_chain = n, this.func = i;
                }
                function H() {
                    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = v, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new c.Buf16(2 * w), this.dyn_dtree = new c.Buf16(2 * (2 * a + 1)), this.bl_tree = new c.Buf16(2 * (2 * o + 1)), D(this.dyn_ltree), D(this.dyn_dtree), D(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new c.Buf16(k + 1), this.heap = new c.Buf16(2 * s + 1), D(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new c.Buf16(2 * s + 1), D(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
                }
                function G(e) {
                    var t;
                    return e && e.state ? (e.total_in = e.total_out = 0, e.data_type = i, (t = e.state).pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? C : E, e.adler = 2 === t.wrap ? 0 : 1, t.last_flush = l, u._tr_init(t), m) : R(e, _);
                }
                function K(e) {
                    var t = G(e);
                    return t === m && function(e) {
                        e.window_size = 2 * e.w_size, D(e.head), e.max_lazy_match = h[e.level].max_lazy, e.good_match = h[e.level].good_length, e.nice_match = h[e.level].nice_length, e.max_chain_length = h[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = x - 1, e.match_available = 0, e.ins_h = 0;
                    }(e.state), t;
                }
                function Y(e, t, r, n, i, s) {
                    if (!e) return _;
                    var a = 1;
                    if (t === g && (t = 6), n < 0 ? (a = 0, n = -n) : 15 < n && (a = 2, n -= 16), i < 1 || y < i || r !== v || n < 8 || 15 < n || t < 0 || 9 < t || s < 0 || b < s) return R(e, _);
                    8 === n && (n = 9);
                    var o = new H;
                    return (e.state = o).strm = e, o.wrap = a, o.gzhead = null, o.w_bits = n, o.w_size = 1 << o.w_bits, o.w_mask = o.w_size - 1, o.hash_bits = i + 7, o.hash_size = 1 << o.hash_bits, o.hash_mask = o.hash_size - 1, o.hash_shift = ~~((o.hash_bits + x - 1) / x), o.window = new c.Buf8(2 * o.w_size), o.head = new c.Buf16(o.hash_size), o.prev = new c.Buf16(o.w_size), o.lit_bufsize = 1 << i + 6, o.pending_buf_size = 4 * o.lit_bufsize, o.pending_buf = new c.Buf8(o.pending_buf_size), o.d_buf = 1 * o.lit_bufsize, o.l_buf = 3 * o.lit_bufsize, o.level = t, o.strategy = s, o.method = r, K(e);
                }
                h = [
                    new M(0, 0, 0, 0, function(e, t) {
                        var r = 65535;
                        for(r > e.pending_buf_size - 5 && (r = e.pending_buf_size - 5);;){
                            if (e.lookahead <= 1) {
                                if (j(e), 0 === e.lookahead && t === l) return A;
                                if (0 === e.lookahead) break;
                            }
                            e.strstart += e.lookahead, e.lookahead = 0;
                            var n = e.block_start + r;
                            if ((0 === e.strstart || e.strstart >= n) && (e.lookahead = e.strstart - n, e.strstart = n, N(e, !1), 0 === e.strm.avail_out)) return A;
                            if (e.strstart - e.block_start >= e.w_size - z && (N(e, !1), 0 === e.strm.avail_out)) return A;
                        }
                        return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : (e.strstart > e.block_start && (N(e, !1), e.strm.avail_out), A);
                    }),
                    new M(4, 4, 8, 4, Z),
                    new M(4, 5, 16, 8, Z),
                    new M(4, 6, 32, 32, Z),
                    new M(4, 4, 16, 16, W),
                    new M(8, 16, 32, 32, W),
                    new M(8, 16, 128, 128, W),
                    new M(8, 32, 128, 256, W),
                    new M(32, 128, 258, 1024, W),
                    new M(32, 258, 258, 4096, W)
                ], r.deflateInit = function(e, t) {
                    return Y(e, t, v, 15, 8, 0);
                }, r.deflateInit2 = Y, r.deflateReset = K, r.deflateResetKeep = G, r.deflateSetHeader = function(e, t) {
                    return e && e.state ? 2 !== e.state.wrap ? _ : (e.state.gzhead = t, m) : _;
                }, r.deflate = function(e, t) {
                    var r, n, i, s;
                    if (!e || !e.state || 5 < t || t < 0) return e ? R(e, _) : _;
                    if (n = e.state, !e.output || !e.input && 0 !== e.avail_in || 666 === n.status && t !== f) return R(e, 0 === e.avail_out ? -5 : _);
                    if (n.strm = e, r = n.last_flush, n.last_flush = t, n.status === C) {
                        if (2 === n.wrap) e.adler = 0, U(n, 31), U(n, 139), U(n, 8), n.gzhead ? (U(n, (n.gzhead.text ? 1 : 0) + (n.gzhead.hcrc ? 2 : 0) + (n.gzhead.extra ? 4 : 0) + (n.gzhead.name ? 8 : 0) + (n.gzhead.comment ? 16 : 0)), U(n, 255 & n.gzhead.time), U(n, n.gzhead.time >> 8 & 255), U(n, n.gzhead.time >> 16 & 255), U(n, n.gzhead.time >> 24 & 255), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 255 & n.gzhead.os), n.gzhead.extra && n.gzhead.extra.length && (U(n, 255 & n.gzhead.extra.length), U(n, n.gzhead.extra.length >> 8 & 255)), n.gzhead.hcrc && (e.adler = p(e.adler, n.pending_buf, n.pending, 0)), n.gzindex = 0, n.status = 69) : (U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 0), U(n, 9 === n.level ? 2 : 2 <= n.strategy || n.level < 2 ? 4 : 0), U(n, 3), n.status = E);
                        else {
                            var a = v + (n.w_bits - 8 << 4) << 8;
                            a |= (2 <= n.strategy || n.level < 2 ? 0 : n.level < 6 ? 1 : 6 === n.level ? 2 : 3) << 6, 0 !== n.strstart && (a |= 32), a += 31 - a % 31, n.status = E, P(n, a), 0 !== n.strstart && (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), e.adler = 1;
                        }
                    }
                    if (69 === n.status) {
                        if (n.gzhead.extra) {
                            for(i = n.pending; n.gzindex < (65535 & n.gzhead.extra.length) && (n.pending !== n.pending_buf_size || (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending !== n.pending_buf_size));)U(n, 255 & n.gzhead.extra[n.gzindex]), n.gzindex++;
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), n.gzindex === n.gzhead.extra.length && (n.gzindex = 0, n.status = 73);
                        } else n.status = 73;
                    }
                    if (73 === n.status) {
                        if (n.gzhead.name) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.name.length ? 255 & n.gzhead.name.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.gzindex = 0, n.status = 91);
                        } else n.status = 91;
                    }
                    if (91 === n.status) {
                        if (n.gzhead.comment) {
                            i = n.pending;
                            do {
                                if (n.pending === n.pending_buf_size && (n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), F(e), i = n.pending, n.pending === n.pending_buf_size)) {
                                    s = 1;
                                    break;
                                }
                                s = n.gzindex < n.gzhead.comment.length ? 255 & n.gzhead.comment.charCodeAt(n.gzindex++) : 0, U(n, s);
                            }while (0 !== s);
                            n.gzhead.hcrc && n.pending > i && (e.adler = p(e.adler, n.pending_buf, n.pending - i, i)), 0 === s && (n.status = 103);
                        } else n.status = 103;
                    }
                    if (103 === n.status && (n.gzhead.hcrc ? (n.pending + 2 > n.pending_buf_size && F(e), n.pending + 2 <= n.pending_buf_size && (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), e.adler = 0, n.status = E)) : n.status = E), 0 !== n.pending) {
                        if (F(e), 0 === e.avail_out) return n.last_flush = -1, m;
                    } else if (0 === e.avail_in && T(t) <= T(r) && t !== f) return R(e, -5);
                    if (666 === n.status && 0 !== e.avail_in) return R(e, -5);
                    if (0 !== e.avail_in || 0 !== n.lookahead || t !== l && 666 !== n.status) {
                        var o = 2 === n.strategy ? function(e, t) {
                            for(var r;;){
                                if (0 === e.lookahead && (j(e), 0 === e.lookahead)) {
                                    if (t === l) return A;
                                    break;
                                }
                                if (e.match_length = 0, r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : 3 === n.strategy ? function(e, t) {
                            for(var r, n, i, s, a = e.window;;){
                                if (e.lookahead <= S) {
                                    if (j(e), e.lookahead <= S && t === l) return A;
                                    if (0 === e.lookahead) break;
                                }
                                if (e.match_length = 0, e.lookahead >= x && 0 < e.strstart && (n = a[i = e.strstart - 1]) === a[++i] && n === a[++i] && n === a[++i]) {
                                    s = e.strstart + S;
                                    do ;
                                    while (n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && n === a[++i] && i < s);
                                    e.match_length = S - (s - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
                                }
                                if (e.match_length >= x ? (r = u._tr_tally(e, 1, e.match_length - x), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = u._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (N(e, !1), 0 === e.strm.avail_out)) return A;
                            }
                            return e.insert = 0, t === f ? (N(e, !0), 0 === e.strm.avail_out ? O : B) : e.last_lit && (N(e, !1), 0 === e.strm.avail_out) ? A : I;
                        }(n, t) : h[n.level].func(n, t);
                        if (o !== O && o !== B || (n.status = 666), o === A || o === O) return 0 === e.avail_out && (n.last_flush = -1), m;
                        if (o === I && (1 === t ? u._tr_align(n) : 5 !== t && (u._tr_stored_block(n, 0, 0, !1), 3 === t && (D(n.head), 0 === n.lookahead && (n.strstart = 0, n.block_start = 0, n.insert = 0))), F(e), 0 === e.avail_out)) return n.last_flush = -1, m;
                    }
                    return t !== f ? m : n.wrap <= 0 ? 1 : (2 === n.wrap ? (U(n, 255 & e.adler), U(n, e.adler >> 8 & 255), U(n, e.adler >> 16 & 255), U(n, e.adler >> 24 & 255), U(n, 255 & e.total_in), U(n, e.total_in >> 8 & 255), U(n, e.total_in >> 16 & 255), U(n, e.total_in >> 24 & 255)) : (P(n, e.adler >>> 16), P(n, 65535 & e.adler)), F(e), 0 < n.wrap && (n.wrap = -n.wrap), 0 !== n.pending ? m : 1);
                }, r.deflateEnd = function(e) {
                    var t;
                    return e && e.state ? (t = e.state.status) !== C && 69 !== t && 73 !== t && 91 !== t && 103 !== t && t !== E && 666 !== t ? R(e, _) : (e.state = null, t === E ? R(e, -3) : m) : _;
                }, r.deflateSetDictionary = function(e, t) {
                    var r, n, i, s, a, o, h, u, l = t.length;
                    if (!e || !e.state) return _;
                    if (2 === (s = (r = e.state).wrap) || 1 === s && r.status !== C || r.lookahead) return _;
                    for(1 === s && (e.adler = d(e.adler, t, l, 0)), r.wrap = 0, l >= r.w_size && (0 === s && (D(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new c.Buf8(r.w_size), c.arraySet(u, t, l - r.w_size, r.w_size, 0), t = u, l = r.w_size), a = e.avail_in, o = e.next_in, h = e.input, e.avail_in = l, e.next_in = 0, e.input = t, j(r); r.lookahead >= x;){
                        for(n = r.strstart, i = r.lookahead - (x - 1); r.ins_h = (r.ins_h << r.hash_shift ^ r.window[n + x - 1]) & r.hash_mask, r.prev[n & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = n, n++, --i;);
                        r.strstart = n, r.lookahead = x - 1, j(r);
                    }
                    return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = x - 1, r.match_available = 0, e.next_in = o, e.input = h, e.avail_in = a, r.wrap = s, m;
                }, r.deflateInfo = "pako deflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./messages": 51,
                "./trees": 52
            }
        ],
        47: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
                };
            },
            {}
        ],
        48: [
            function(e, t, r) {
                "use strict";
                t.exports = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C;
                    r = e.state, n = e.next_in, z = e.input, i = n + (e.avail_in - 5), s = e.next_out, C = e.output, a = s - (t - e.avail_out), o = s + (e.avail_out - 257), h = r.dmax, u = r.wsize, l = r.whave, f = r.wnext, c = r.window, d = r.hold, p = r.bits, m = r.lencode, _ = r.distcode, g = (1 << r.lenbits) - 1, b = (1 << r.distbits) - 1;
                    e: do {
                        p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = m[d & g];
                        t: for(;;){
                            if (d >>>= y = v >>> 24, p -= y, 0 === (y = v >>> 16 & 255)) C[s++] = 65535 & v;
                            else {
                                if (!(16 & y)) {
                                    if (0 == (64 & y)) {
                                        v = m[(65535 & v) + (d & (1 << y) - 1)];
                                        continue t;
                                    }
                                    if (32 & y) {
                                        r.mode = 12;
                                        break e;
                                    }
                                    e.msg = "invalid literal/length code", r.mode = 30;
                                    break e;
                                }
                                w = 65535 & v, (y &= 15) && (p < y && (d += z[n++] << p, p += 8), w += d & (1 << y) - 1, d >>>= y, p -= y), p < 15 && (d += z[n++] << p, p += 8, d += z[n++] << p, p += 8), v = _[d & b];
                                r: for(;;){
                                    if (d >>>= y = v >>> 24, p -= y, !(16 & (y = v >>> 16 & 255))) {
                                        if (0 == (64 & y)) {
                                            v = _[(65535 & v) + (d & (1 << y) - 1)];
                                            continue r;
                                        }
                                        e.msg = "invalid distance code", r.mode = 30;
                                        break e;
                                    }
                                    if (k = 65535 & v, p < (y &= 15) && (d += z[n++] << p, (p += 8) < y && (d += z[n++] << p, p += 8)), h < (k += d & (1 << y) - 1)) {
                                        e.msg = "invalid distance too far back", r.mode = 30;
                                        break e;
                                    }
                                    if (d >>>= y, p -= y, (y = s - a) < k) {
                                        if (l < (y = k - y) && r.sane) {
                                            e.msg = "invalid distance too far back", r.mode = 30;
                                            break e;
                                        }
                                        if (S = c, (x = 0) === f) {
                                            if (x += u - y, y < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                x = s - k, S = C;
                                            }
                                        } else if (f < y) {
                                            if (x += u + f - y, (y -= f) < w) {
                                                for(w -= y; C[s++] = c[x++], --y;);
                                                if (x = 0, f < w) {
                                                    for(w -= y = f; C[s++] = c[x++], --y;);
                                                    x = s - k, S = C;
                                                }
                                            }
                                        } else if (x += f - y, y < w) {
                                            for(w -= y; C[s++] = c[x++], --y;);
                                            x = s - k, S = C;
                                        }
                                        for(; 2 < w;)C[s++] = S[x++], C[s++] = S[x++], C[s++] = S[x++], w -= 3;
                                        w && (C[s++] = S[x++], 1 < w && (C[s++] = S[x++]));
                                    } else {
                                        for(x = s - k; C[s++] = C[x++], C[s++] = C[x++], C[s++] = C[x++], 2 < (w -= 3););
                                        w && (C[s++] = C[x++], 1 < w && (C[s++] = C[x++]));
                                    }
                                    break;
                                }
                            }
                            break;
                        }
                    }while (n < i && s < o);
                    n -= w = p >> 3, d &= (1 << (p -= w << 3)) - 1, e.next_in = n, e.next_out = s, e.avail_in = n < i ? i - n + 5 : 5 - (n - i), e.avail_out = s < o ? o - s + 257 : 257 - (s - o), r.hold = d, r.bits = p;
                };
            },
            {}
        ],
        49: [
            function(e, t, r) {
                "use strict";
                var I = e("../utils/common"), O = e("./adler32"), B = e("./crc32"), R = e("./inffast"), T = e("./inftrees"), D = 1, F = 2, N = 0, U = -2, P = 1, n = 852, i = 592;
                function L(e) {
                    return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((65280 & e) << 8) + ((255 & e) << 24);
                }
                function s() {
                    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new I.Buf16(320), this.work = new I.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
                }
                function a(e) {
                    var t;
                    return e && e.state ? (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = 1 & t.wrap), t.mode = P, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new I.Buf32(n), t.distcode = t.distdyn = new I.Buf32(i), t.sane = 1, t.back = -1, N) : U;
                }
                function o(e) {
                    var t;
                    return e && e.state ? ((t = e.state).wsize = 0, t.whave = 0, t.wnext = 0, a(e)) : U;
                }
                function h(e, t) {
                    var r, n;
                    return e && e.state ? (n = e.state, t < 0 ? (r = 0, t = -t) : (r = 1 + (t >> 4), t < 48 && (t &= 15)), t && (t < 8 || 15 < t) ? U : (null !== n.window && n.wbits !== t && (n.window = null), n.wrap = r, n.wbits = t, o(e))) : U;
                }
                function u(e, t) {
                    var r, n;
                    return e ? (n = new s, (e.state = n).window = null, (r = h(e, t)) !== N && (e.state = null), r) : U;
                }
                var l, f, c = !0;
                function j(e) {
                    if (c) {
                        var t;
                        for(l = new I.Buf32(512), f = new I.Buf32(32), t = 0; t < 144;)e.lens[t++] = 8;
                        for(; t < 256;)e.lens[t++] = 9;
                        for(; t < 280;)e.lens[t++] = 7;
                        for(; t < 288;)e.lens[t++] = 8;
                        for(T(D, e.lens, 0, 288, l, 0, e.work, {
                            bits: 9
                        }), t = 0; t < 32;)e.lens[t++] = 5;
                        T(F, e.lens, 0, 32, f, 0, e.work, {
                            bits: 5
                        }), c = !1;
                    }
                    e.lencode = l, e.lenbits = 9, e.distcode = f, e.distbits = 5;
                }
                function Z(e, t, r, n) {
                    var i, s = e.state;
                    return null === s.window && (s.wsize = 1 << s.wbits, s.wnext = 0, s.whave = 0, s.window = new I.Buf8(s.wsize)), n >= s.wsize ? (I.arraySet(s.window, t, r - s.wsize, s.wsize, 0), s.wnext = 0, s.whave = s.wsize) : (n < (i = s.wsize - s.wnext) && (i = n), I.arraySet(s.window, t, r - n, i, s.wnext), (n -= i) ? (I.arraySet(s.window, t, r - n, n, 0), s.wnext = n, s.whave = s.wsize) : (s.wnext += i, s.wnext === s.wsize && (s.wnext = 0), s.whave < s.wsize && (s.whave += i))), 0;
                }
                r.inflateReset = o, r.inflateReset2 = h, r.inflateResetKeep = a, r.inflateInit = function(e) {
                    return u(e, 15);
                }, r.inflateInit2 = u, r.inflate = function(e, t) {
                    var r, n, i, s, a, o, h, u, l, f, c, d, p, m, _, g, b, v, y, w, k, x, S, z, C = 0, E = new I.Buf8(4), A = [
                        16,
                        17,
                        18,
                        0,
                        8,
                        7,
                        9,
                        6,
                        10,
                        5,
                        11,
                        4,
                        12,
                        3,
                        13,
                        2,
                        14,
                        1,
                        15
                    ];
                    if (!e || !e.state || !e.output || !e.input && 0 !== e.avail_in) return U;
                    12 === (r = e.state).mode && (r.mode = 13), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, f = o, c = h, x = N;
                    e: for(;;)switch(r.mode){
                        case P:
                            if (0 === r.wrap) {
                                r.mode = 13;
                                break;
                            }
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (2 & r.wrap && 35615 === u) {
                                E[r.check = 0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0), l = u = 0, r.mode = 2;
                                break;
                            }
                            if (r.flags = 0, r.head && (r.head.done = !1), !(1 & r.wrap) || (((255 & u) << 8) + (u >> 8)) % 31) {
                                e.msg = "incorrect header check", r.mode = 30;
                                break;
                            }
                            if (8 != (15 & u)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (l -= 4, k = 8 + (15 & (u >>>= 4)), 0 === r.wbits) r.wbits = k;
                            else if (k > r.wbits) {
                                e.msg = "invalid window size", r.mode = 30;
                                break;
                            }
                            r.dmax = 1 << k, e.adler = r.check = 1, r.mode = 512 & u ? 10 : 12, l = u = 0;
                            break;
                        case 2:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.flags = u, 8 != (255 & r.flags)) {
                                e.msg = "unknown compression method", r.mode = 30;
                                break;
                            }
                            if (57344 & r.flags) {
                                e.msg = "unknown header flags set", r.mode = 30;
                                break;
                            }
                            r.head && (r.head.text = u >> 8 & 1), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 3;
                        case 3:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.time = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, E[2] = u >>> 16 & 255, E[3] = u >>> 24 & 255, r.check = B(r.check, E, 4, 0)), l = u = 0, r.mode = 4;
                        case 4:
                            for(; l < 16;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            r.head && (r.head.xflags = 255 & u, r.head.os = u >> 8), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0, r.mode = 5;
                        case 5:
                            if (1024 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length = u, r.head && (r.head.extra_len = u), 512 & r.flags && (E[0] = 255 & u, E[1] = u >>> 8 & 255, r.check = B(r.check, E, 2, 0)), l = u = 0;
                            } else r.head && (r.head.extra = null);
                            r.mode = 6;
                        case 6:
                            if (1024 & r.flags && (o < (d = r.length) && (d = o), d && (r.head && (k = r.head.extra_len - r.length, r.head.extra || (r.head.extra = new Array(r.head.extra_len)), I.arraySet(r.head.extra, n, s, d, k)), 512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, r.length -= d), r.length)) break e;
                            r.length = 0, r.mode = 7;
                        case 7:
                            if (2048 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.name += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.name = null);
                            r.length = 0, r.mode = 8;
                        case 8:
                            if (4096 & r.flags) {
                                if (0 === o) break e;
                                for(d = 0; k = n[s + d++], r.head && k && r.length < 65536 && (r.head.comment += String.fromCharCode(k)), k && d < o;);
                                if (512 & r.flags && (r.check = B(r.check, n, d, s)), o -= d, s += d, k) break e;
                            } else r.head && (r.head.comment = null);
                            r.mode = 9;
                        case 9:
                            if (512 & r.flags) {
                                for(; l < 16;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (65535 & r.check)) {
                                    e.msg = "header crc mismatch", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.head && (r.head.hcrc = r.flags >> 9 & 1, r.head.done = !0), e.adler = r.check = 0, r.mode = 12;
                            break;
                        case 10:
                            for(; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            e.adler = r.check = L(u), l = u = 0, r.mode = 11;
                        case 11:
                            if (0 === r.havedict) return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, 2;
                            e.adler = r.check = 1, r.mode = 12;
                        case 12:
                            if (5 === t || 6 === t) break e;
                        case 13:
                            if (r.last) {
                                u >>>= 7 & l, l -= 7 & l, r.mode = 27;
                                break;
                            }
                            for(; l < 3;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            switch(r.last = 1 & u, l -= 1, 3 & (u >>>= 1)){
                                case 0:
                                    r.mode = 14;
                                    break;
                                case 1:
                                    if (j(r), r.mode = 20, 6 !== t) break;
                                    u >>>= 2, l -= 2;
                                    break e;
                                case 2:
                                    r.mode = 17;
                                    break;
                                case 3:
                                    e.msg = "invalid block type", r.mode = 30;
                            }
                            u >>>= 2, l -= 2;
                            break;
                        case 14:
                            for(u >>>= 7 & l, l -= 7 & l; l < 32;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if ((65535 & u) != (u >>> 16 ^ 65535)) {
                                e.msg = "invalid stored block lengths", r.mode = 30;
                                break;
                            }
                            if (r.length = 65535 & u, l = u = 0, r.mode = 15, 6 === t) break e;
                        case 15:
                            r.mode = 16;
                        case 16:
                            if (d = r.length) {
                                if (o < d && (d = o), h < d && (d = h), 0 === d) break e;
                                I.arraySet(i, n, s, d, a), o -= d, s += d, h -= d, a += d, r.length -= d;
                                break;
                            }
                            r.mode = 12;
                            break;
                        case 17:
                            for(; l < 14;){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (r.nlen = 257 + (31 & u), u >>>= 5, l -= 5, r.ndist = 1 + (31 & u), u >>>= 5, l -= 5, r.ncode = 4 + (15 & u), u >>>= 4, l -= 4, 286 < r.nlen || 30 < r.ndist) {
                                e.msg = "too many length or distance symbols", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 18;
                        case 18:
                            for(; r.have < r.ncode;){
                                for(; l < 3;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.lens[A[r.have++]] = 7 & u, u >>>= 3, l -= 3;
                            }
                            for(; r.have < 19;)r.lens[A[r.have++]] = 0;
                            if (r.lencode = r.lendyn, r.lenbits = 7, S = {
                                bits: r.lenbits
                            }, x = T(0, r.lens, 0, 19, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid code lengths set", r.mode = 30;
                                break;
                            }
                            r.have = 0, r.mode = 19;
                        case 19:
                            for(; r.have < r.nlen + r.ndist;){
                                for(; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (b < 16) u >>>= _, l -= _, r.lens[r.have++] = b;
                                else {
                                    if (16 === b) {
                                        for(z = _ + 2; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        if (u >>>= _, l -= _, 0 === r.have) {
                                            e.msg = "invalid bit length repeat", r.mode = 30;
                                            break;
                                        }
                                        k = r.lens[r.have - 1], d = 3 + (3 & u), u >>>= 2, l -= 2;
                                    } else if (17 === b) {
                                        for(z = _ + 3; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 3 + (7 & (u >>>= _)), u >>>= 3, l -= 3;
                                    } else {
                                        for(z = _ + 7; l < z;){
                                            if (0 === o) break e;
                                            o--, u += n[s++] << l, l += 8;
                                        }
                                        l -= _, k = 0, d = 11 + (127 & (u >>>= _)), u >>>= 7, l -= 7;
                                    }
                                    if (r.have + d > r.nlen + r.ndist) {
                                        e.msg = "invalid bit length repeat", r.mode = 30;
                                        break;
                                    }
                                    for(; d--;)r.lens[r.have++] = k;
                                }
                            }
                            if (30 === r.mode) break;
                            if (0 === r.lens[256]) {
                                e.msg = "invalid code -- missing end-of-block", r.mode = 30;
                                break;
                            }
                            if (r.lenbits = 9, S = {
                                bits: r.lenbits
                            }, x = T(D, r.lens, 0, r.nlen, r.lencode, 0, r.work, S), r.lenbits = S.bits, x) {
                                e.msg = "invalid literal/lengths set", r.mode = 30;
                                break;
                            }
                            if (r.distbits = 6, r.distcode = r.distdyn, S = {
                                bits: r.distbits
                            }, x = T(F, r.lens, r.nlen, r.ndist, r.distcode, 0, r.work, S), r.distbits = S.bits, x) {
                                e.msg = "invalid distances set", r.mode = 30;
                                break;
                            }
                            if (r.mode = 20, 6 === t) break e;
                        case 20:
                            r.mode = 21;
                        case 21:
                            if (6 <= o && 258 <= h) {
                                e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, R(e, c), a = e.next_out, i = e.output, h = e.avail_out, s = e.next_in, n = e.input, o = e.avail_in, u = r.hold, l = r.bits, 12 === r.mode && (r.back = -1);
                                break;
                            }
                            for(r.back = 0; g = (C = r.lencode[u & (1 << r.lenbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (g && 0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.lencode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, r.length = b, 0 === g) {
                                r.mode = 26;
                                break;
                            }
                            if (32 & g) {
                                r.back = -1, r.mode = 12;
                                break;
                            }
                            if (64 & g) {
                                e.msg = "invalid literal/length code", r.mode = 30;
                                break;
                            }
                            r.extra = 15 & g, r.mode = 22;
                        case 22:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.length += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            r.was = r.length, r.mode = 23;
                        case 23:
                            for(; g = (C = r.distcode[u & (1 << r.distbits) - 1]) >>> 16 & 255, b = 65535 & C, !((_ = C >>> 24) <= l);){
                                if (0 === o) break e;
                                o--, u += n[s++] << l, l += 8;
                            }
                            if (0 == (240 & g)) {
                                for(v = _, y = g, w = b; g = (C = r.distcode[w + ((u & (1 << v + y) - 1) >> v)]) >>> 16 & 255, b = 65535 & C, !(v + (_ = C >>> 24) <= l);){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                u >>>= v, l -= v, r.back += v;
                            }
                            if (u >>>= _, l -= _, r.back += _, 64 & g) {
                                e.msg = "invalid distance code", r.mode = 30;
                                break;
                            }
                            r.offset = b, r.extra = 15 & g, r.mode = 24;
                        case 24:
                            if (r.extra) {
                                for(z = r.extra; l < z;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                r.offset += u & (1 << r.extra) - 1, u >>>= r.extra, l -= r.extra, r.back += r.extra;
                            }
                            if (r.offset > r.dmax) {
                                e.msg = "invalid distance too far back", r.mode = 30;
                                break;
                            }
                            r.mode = 25;
                        case 25:
                            if (0 === h) break e;
                            if (d = c - h, r.offset > d) {
                                if ((d = r.offset - d) > r.whave && r.sane) {
                                    e.msg = "invalid distance too far back", r.mode = 30;
                                    break;
                                }
                                p = d > r.wnext ? (d -= r.wnext, r.wsize - d) : r.wnext - d, d > r.length && (d = r.length), m = r.window;
                            } else m = i, p = a - r.offset, d = r.length;
                            for(h < d && (d = h), h -= d, r.length -= d; i[a++] = m[p++], --d;);
                            0 === r.length && (r.mode = 21);
                            break;
                        case 26:
                            if (0 === h) break e;
                            i[a++] = r.length, h--, r.mode = 21;
                            break;
                        case 27:
                            if (r.wrap) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u |= n[s++] << l, l += 8;
                                }
                                if (c -= h, e.total_out += c, r.total += c, c && (e.adler = r.check = r.flags ? B(r.check, i, c, a - c) : O(r.check, i, c, a - c)), c = h, (r.flags ? u : L(u)) !== r.check) {
                                    e.msg = "incorrect data check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 28;
                        case 28:
                            if (r.wrap && r.flags) {
                                for(; l < 32;){
                                    if (0 === o) break e;
                                    o--, u += n[s++] << l, l += 8;
                                }
                                if (u !== (4294967295 & r.total)) {
                                    e.msg = "incorrect length check", r.mode = 30;
                                    break;
                                }
                                l = u = 0;
                            }
                            r.mode = 29;
                        case 29:
                            x = 1;
                            break e;
                        case 30:
                            x = -3;
                            break e;
                        case 31:
                            return -4;
                        case 32:
                        default:
                            return U;
                    }
                    return e.next_out = a, e.avail_out = h, e.next_in = s, e.avail_in = o, r.hold = u, r.bits = l, (r.wsize || c !== e.avail_out && r.mode < 30 && (r.mode < 27 || 4 !== t)) && Z(e, e.output, e.next_out, c - e.avail_out) ? (r.mode = 31, -4) : (f -= e.avail_in, c -= e.avail_out, e.total_in += f, e.total_out += c, r.total += c, r.wrap && c && (e.adler = r.check = r.flags ? B(r.check, i, c, e.next_out - c) : O(r.check, i, c, e.next_out - c)), e.data_type = r.bits + (r.last ? 64 : 0) + (12 === r.mode ? 128 : 0) + (20 === r.mode || 15 === r.mode ? 256 : 0), (0 == f && 0 === c || 4 === t) && x === N && (x = -5), x);
                }, r.inflateEnd = function(e) {
                    if (!e || !e.state) return U;
                    var t = e.state;
                    return t.window && (t.window = null), e.state = null, N;
                }, r.inflateGetHeader = function(e, t) {
                    var r;
                    return e && e.state ? 0 == (2 & (r = e.state).wrap) ? U : ((r.head = t).done = !1, N) : U;
                }, r.inflateSetDictionary = function(e, t) {
                    var r, n = t.length;
                    return e && e.state ? 0 !== (r = e.state).wrap && 11 !== r.mode ? U : 11 === r.mode && O(1, t, n, 0) !== r.check ? -3 : Z(e, t, n, n) ? (r.mode = 31, -4) : (r.havedict = 1, N) : U;
                }, r.inflateInfo = "pako inflate (from Nodeca project)";
            },
            {
                "../utils/common": 41,
                "./adler32": 43,
                "./crc32": 45,
                "./inffast": 48,
                "./inftrees": 50
            }
        ],
        50: [
            function(e, t, r) {
                "use strict";
                var D = e("../utils/common"), F = [
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    13,
                    15,
                    17,
                    19,
                    23,
                    27,
                    31,
                    35,
                    43,
                    51,
                    59,
                    67,
                    83,
                    99,
                    115,
                    131,
                    163,
                    195,
                    227,
                    258,
                    0,
                    0
                ], N = [
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    17,
                    17,
                    18,
                    18,
                    18,
                    18,
                    19,
                    19,
                    19,
                    19,
                    20,
                    20,
                    20,
                    20,
                    21,
                    21,
                    21,
                    21,
                    16,
                    72,
                    78
                ], U = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    7,
                    9,
                    13,
                    17,
                    25,
                    33,
                    49,
                    65,
                    97,
                    129,
                    193,
                    257,
                    385,
                    513,
                    769,
                    1025,
                    1537,
                    2049,
                    3073,
                    4097,
                    6145,
                    8193,
                    12289,
                    16385,
                    24577,
                    0,
                    0
                ], P = [
                    16,
                    16,
                    16,
                    16,
                    17,
                    17,
                    18,
                    18,
                    19,
                    19,
                    20,
                    20,
                    21,
                    21,
                    22,
                    22,
                    23,
                    23,
                    24,
                    24,
                    25,
                    25,
                    26,
                    26,
                    27,
                    27,
                    28,
                    28,
                    29,
                    29,
                    64,
                    64
                ];
                t.exports = function(e, t, r, n, i, s, a, o) {
                    var h, u, l, f, c, d, p, m, _, g = o.bits, b = 0, v = 0, y = 0, w = 0, k = 0, x = 0, S = 0, z = 0, C = 0, E = 0, A = null, I = 0, O = new D.Buf16(16), B = new D.Buf16(16), R = null, T = 0;
                    for(b = 0; b <= 15; b++)O[b] = 0;
                    for(v = 0; v < n; v++)O[t[r + v]]++;
                    for(k = g, w = 15; 1 <= w && 0 === O[w]; w--);
                    if (w < k && (k = w), 0 === w) return i[s++] = 20971520, i[s++] = 20971520, o.bits = 1, 0;
                    for(y = 1; y < w && 0 === O[y]; y++);
                    for(k < y && (k = y), b = z = 1; b <= 15; b++)if (z <<= 1, (z -= O[b]) < 0) return -1;
                    if (0 < z && (0 === e || 1 !== w)) return -1;
                    for(B[1] = 0, b = 1; b < 15; b++)B[b + 1] = B[b] + O[b];
                    for(v = 0; v < n; v++)0 !== t[r + v] && (a[B[t[r + v]]++] = v);
                    if (d = 0 === e ? (A = R = a, 19) : 1 === e ? (A = F, I -= 257, R = N, T -= 257, 256) : (A = U, R = P, -1), b = y, c = s, S = v = E = 0, l = -1, f = (C = 1 << (x = k)) - 1, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                    for(;;){
                        for(p = b - S, _ = a[v] < d ? (m = 0, a[v]) : a[v] > d ? (m = R[T + a[v]], A[I + a[v]]) : (m = 96, 0), h = 1 << b - S, y = u = 1 << x; i[c + (E >> S) + (u -= h)] = p << 24 | m << 16 | _ | 0, 0 !== u;);
                        for(h = 1 << b - 1; E & h;)h >>= 1;
                        if (0 !== h ? (E &= h - 1, E += h) : E = 0, v++, 0 == --O[b]) {
                            if (b === w) break;
                            b = t[r + a[v]];
                        }
                        if (k < b && (E & f) !== l) {
                            for(0 === S && (S = k), c += y, z = 1 << (x = b - S); x + S < w && !((z -= O[x + S]) <= 0);)x++, z <<= 1;
                            if (C += 1 << x, 1 === e && 852 < C || 2 === e && 592 < C) return 1;
                            i[l = E & f] = k << 24 | x << 16 | c - s | 0;
                        }
                    }
                    return 0 !== E && (i[c + E] = b - S << 24 | 4194304), o.bits = k, 0;
                };
            },
            {
                "../utils/common": 41
            }
        ],
        51: [
            function(e, t, r) {
                "use strict";
                t.exports = {
                    2: "need dictionary",
                    1: "stream end",
                    0: "",
                    "-1": "file error",
                    "-2": "stream error",
                    "-3": "data error",
                    "-4": "insufficient memory",
                    "-5": "buffer error",
                    "-6": "incompatible version"
                };
            },
            {}
        ],
        52: [
            function(e, t, r) {
                "use strict";
                var i = e("../utils/common"), o = 0, h = 1;
                function n(e) {
                    for(var t = e.length; 0 <= --t;)e[t] = 0;
                }
                var s = 0, a = 29, u = 256, l = u + 1 + a, f = 30, c = 19, _ = 2 * l + 1, g = 15, d = 16, p = 7, m = 256, b = 16, v = 17, y = 18, w = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0
                ], k = [
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13
                ], x = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    3,
                    7
                ], S = [
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ], z = new Array(2 * (l + 2));
                n(z);
                var C = new Array(2 * f);
                n(C);
                var E = new Array(512);
                n(E);
                var A = new Array(256);
                n(A);
                var I = new Array(a);
                n(I);
                var O, B, R, T = new Array(f);
                function D(e, t, r, n, i) {
                    this.static_tree = e, this.extra_bits = t, this.extra_base = r, this.elems = n, this.max_length = i, this.has_stree = e && e.length;
                }
                function F(e, t) {
                    this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
                }
                function N(e) {
                    return e < 256 ? E[e] : E[256 + (e >>> 7)];
                }
                function U(e, t) {
                    e.pending_buf[e.pending++] = 255 & t, e.pending_buf[e.pending++] = t >>> 8 & 255;
                }
                function P(e, t, r) {
                    e.bi_valid > d - r ? (e.bi_buf |= t << e.bi_valid & 65535, U(e, e.bi_buf), e.bi_buf = t >> d - e.bi_valid, e.bi_valid += r - d) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += r);
                }
                function L(e, t, r) {
                    P(e, r[2 * t], r[2 * t + 1]);
                }
                function j(e, t) {
                    for(var r = 0; r |= 1 & e, e >>>= 1, r <<= 1, 0 < --t;);
                    return r >>> 1;
                }
                function Z(e, t, r) {
                    var n, i, s = new Array(g + 1), a = 0;
                    for(n = 1; n <= g; n++)s[n] = a = a + r[n - 1] << 1;
                    for(i = 0; i <= t; i++){
                        var o = e[2 * i + 1];
                        0 !== o && (e[2 * i] = j(s[o]++, o));
                    }
                }
                function W(e) {
                    var t;
                    for(t = 0; t < l; t++)e.dyn_ltree[2 * t] = 0;
                    for(t = 0; t < f; t++)e.dyn_dtree[2 * t] = 0;
                    for(t = 0; t < c; t++)e.bl_tree[2 * t] = 0;
                    e.dyn_ltree[2 * m] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
                }
                function M(e) {
                    8 < e.bi_valid ? U(e, e.bi_buf) : 0 < e.bi_valid && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
                }
                function H(e, t, r, n) {
                    var i = 2 * t, s = 2 * r;
                    return e[i] < e[s] || e[i] === e[s] && n[t] <= n[r];
                }
                function G(e, t, r) {
                    for(var n = e.heap[r], i = r << 1; i <= e.heap_len && (i < e.heap_len && H(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !H(t, n, e.heap[i], e.depth));)e.heap[r] = e.heap[i], r = i, i <<= 1;
                    e.heap[r] = n;
                }
                function K(e, t, r) {
                    var n, i, s, a, o = 0;
                    if (0 !== e.last_lit) for(; n = e.pending_buf[e.d_buf + 2 * o] << 8 | e.pending_buf[e.d_buf + 2 * o + 1], i = e.pending_buf[e.l_buf + o], o++, 0 === n ? L(e, i, t) : (L(e, (s = A[i]) + u + 1, t), 0 !== (a = w[s]) && P(e, i -= I[s], a), L(e, s = N(--n), r), 0 !== (a = k[s]) && P(e, n -= T[s], a)), o < e.last_lit;);
                    L(e, m, t);
                }
                function Y(e, t) {
                    var r, n, i, s = t.dyn_tree, a = t.stat_desc.static_tree, o = t.stat_desc.has_stree, h = t.stat_desc.elems, u = -1;
                    for(e.heap_len = 0, e.heap_max = _, r = 0; r < h; r++)0 !== s[2 * r] ? (e.heap[++e.heap_len] = u = r, e.depth[r] = 0) : s[2 * r + 1] = 0;
                    for(; e.heap_len < 2;)s[2 * (i = e.heap[++e.heap_len] = u < 2 ? ++u : 0)] = 1, e.depth[i] = 0, e.opt_len--, o && (e.static_len -= a[2 * i + 1]);
                    for(t.max_code = u, r = e.heap_len >> 1; 1 <= r; r--)G(e, s, r);
                    for(i = h; r = e.heap[1], e.heap[1] = e.heap[e.heap_len--], G(e, s, 1), n = e.heap[1], e.heap[--e.heap_max] = r, e.heap[--e.heap_max] = n, s[2 * i] = s[2 * r] + s[2 * n], e.depth[i] = (e.depth[r] >= e.depth[n] ? e.depth[r] : e.depth[n]) + 1, s[2 * r + 1] = s[2 * n + 1] = i, e.heap[1] = i++, G(e, s, 1), 2 <= e.heap_len;);
                    e.heap[--e.heap_max] = e.heap[1], function(e, t) {
                        var r, n, i, s, a, o, h = t.dyn_tree, u = t.max_code, l = t.stat_desc.static_tree, f = t.stat_desc.has_stree, c = t.stat_desc.extra_bits, d = t.stat_desc.extra_base, p = t.stat_desc.max_length, m = 0;
                        for(s = 0; s <= g; s++)e.bl_count[s] = 0;
                        for(h[2 * e.heap[e.heap_max] + 1] = 0, r = e.heap_max + 1; r < _; r++)p < (s = h[2 * h[2 * (n = e.heap[r]) + 1] + 1] + 1) && (s = p, m++), h[2 * n + 1] = s, u < n || (e.bl_count[s]++, a = 0, d <= n && (a = c[n - d]), o = h[2 * n], e.opt_len += o * (s + a), f && (e.static_len += o * (l[2 * n + 1] + a)));
                        if (0 !== m) {
                            do {
                                for(s = p - 1; 0 === e.bl_count[s];)s--;
                                e.bl_count[s]--, e.bl_count[s + 1] += 2, e.bl_count[p]--, m -= 2;
                            }while (0 < m);
                            for(s = p; 0 !== s; s--)for(n = e.bl_count[s]; 0 !== n;)u < (i = e.heap[--r]) || (h[2 * i + 1] !== s && (e.opt_len += (s - h[2 * i + 1]) * h[2 * i], h[2 * i + 1] = s), n--);
                        }
                    }(e, t), Z(s, u, e.bl_count);
                }
                function X(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), t[2 * (r + 1) + 1] = 65535, n = 0; n <= r; n++)i = a, a = t[2 * (n + 1) + 1], ++o < h && i === a || (o < u ? e.bl_tree[2 * i] += o : 0 !== i ? (i !== s && e.bl_tree[2 * i]++, e.bl_tree[2 * b]++) : o <= 10 ? e.bl_tree[2 * v]++ : e.bl_tree[2 * y]++, s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4));
                }
                function V(e, t, r) {
                    var n, i, s = -1, a = t[1], o = 0, h = 7, u = 4;
                    for(0 === a && (h = 138, u = 3), n = 0; n <= r; n++)if (i = a, a = t[2 * (n + 1) + 1], !(++o < h && i === a)) {
                        if (o < u) for(; L(e, i, e.bl_tree), 0 != --o;);
                        else 0 !== i ? (i !== s && (L(e, i, e.bl_tree), o--), L(e, b, e.bl_tree), P(e, o - 3, 2)) : o <= 10 ? (L(e, v, e.bl_tree), P(e, o - 3, 3)) : (L(e, y, e.bl_tree), P(e, o - 11, 7));
                        s = i, u = (o = 0) === a ? (h = 138, 3) : i === a ? (h = 6, 3) : (h = 7, 4);
                    }
                }
                n(T);
                var q = !1;
                function J(e, t, r, n) {
                    P(e, (s << 1) + (n ? 1 : 0), 3), function(e, t, r, n) {
                        M(e), n && (U(e, r), U(e, ~r)), i.arraySet(e.pending_buf, e.window, t, r, e.pending), e.pending += r;
                    }(e, t, r, !0);
                }
                r._tr_init = function(e) {
                    q || (function() {
                        var e, t, r, n, i, s = new Array(g + 1);
                        for(n = r = 0; n < a - 1; n++)for(I[n] = r, e = 0; e < 1 << w[n]; e++)A[r++] = n;
                        for(A[r - 1] = n, n = i = 0; n < 16; n++)for(T[n] = i, e = 0; e < 1 << k[n]; e++)E[i++] = n;
                        for(i >>= 7; n < f; n++)for(T[n] = i << 7, e = 0; e < 1 << k[n] - 7; e++)E[256 + i++] = n;
                        for(t = 0; t <= g; t++)s[t] = 0;
                        for(e = 0; e <= 143;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(; e <= 255;)z[2 * e + 1] = 9, e++, s[9]++;
                        for(; e <= 279;)z[2 * e + 1] = 7, e++, s[7]++;
                        for(; e <= 287;)z[2 * e + 1] = 8, e++, s[8]++;
                        for(Z(z, l + 1, s), e = 0; e < f; e++)C[2 * e + 1] = 5, C[2 * e] = j(e, 5);
                        O = new D(z, w, u + 1, l, g), B = new D(C, k, 0, f, g), R = new D(new Array(0), x, 0, c, p);
                    }(), q = !0), e.l_desc = new F(e.dyn_ltree, O), e.d_desc = new F(e.dyn_dtree, B), e.bl_desc = new F(e.bl_tree, R), e.bi_buf = 0, e.bi_valid = 0, W(e);
                }, r._tr_stored_block = J, r._tr_flush_block = function(e, t, r, n) {
                    var i, s, a = 0;
                    0 < e.level ? (2 === e.strm.data_type && (e.strm.data_type = function(e) {
                        var t, r = 4093624447;
                        for(t = 0; t <= 31; t++, r >>>= 1)if (1 & r && 0 !== e.dyn_ltree[2 * t]) return o;
                        if (0 !== e.dyn_ltree[18] || 0 !== e.dyn_ltree[20] || 0 !== e.dyn_ltree[26]) return h;
                        for(t = 32; t < u; t++)if (0 !== e.dyn_ltree[2 * t]) return h;
                        return o;
                    }(e)), Y(e, e.l_desc), Y(e, e.d_desc), a = function(e) {
                        var t;
                        for(X(e, e.dyn_ltree, e.l_desc.max_code), X(e, e.dyn_dtree, e.d_desc.max_code), Y(e, e.bl_desc), t = c - 1; 3 <= t && 0 === e.bl_tree[2 * S[t] + 1]; t--);
                        return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
                    }(e), i = e.opt_len + 3 + 7 >>> 3, (s = e.static_len + 3 + 7 >>> 3) <= i && (i = s)) : i = s = r + 5, r + 4 <= i && -1 !== t ? J(e, t, r, n) : 4 === e.strategy || s === i ? (P(e, 2 + (n ? 1 : 0), 3), K(e, z, C)) : (P(e, 4 + (n ? 1 : 0), 3), function(e, t, r, n) {
                        var i;
                        for(P(e, t - 257, 5), P(e, r - 1, 5), P(e, n - 4, 4), i = 0; i < n; i++)P(e, e.bl_tree[2 * S[i] + 1], 3);
                        V(e, e.dyn_ltree, t - 1), V(e, e.dyn_dtree, r - 1);
                    }(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, a + 1), K(e, e.dyn_ltree, e.dyn_dtree)), W(e), n && M(e);
                }, r._tr_tally = function(e, t, r) {
                    return e.pending_buf[e.d_buf + 2 * e.last_lit] = t >>> 8 & 255, e.pending_buf[e.d_buf + 2 * e.last_lit + 1] = 255 & t, e.pending_buf[e.l_buf + e.last_lit] = 255 & r, e.last_lit++, 0 === t ? e.dyn_ltree[2 * r]++ : (e.matches++, t--, e.dyn_ltree[2 * (A[r] + u + 1)]++, e.dyn_dtree[2 * N(t)]++), e.last_lit === e.lit_bufsize - 1;
                }, r._tr_align = function(e) {
                    P(e, 2, 3), L(e, m, z), function(e) {
                        16 === e.bi_valid ? (U(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : 8 <= e.bi_valid && (e.pending_buf[e.pending++] = 255 & e.bi_buf, e.bi_buf >>= 8, e.bi_valid -= 8);
                    }(e);
                };
            },
            {
                "../utils/common": 41
            }
        ],
        53: [
            function(e, t, r) {
                "use strict";
                t.exports = function() {
                    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
                };
            },
            {}
        ],
        54: [
            function(e, t, r) {
                (function(e) {
                    !function(r, n) {
                        "use strict";
                        if (!r.setImmediate) {
                            var i, s, t, a, o = 1, h = {}, u = !1, l = r.document, e = Object.getPrototypeOf && Object.getPrototypeOf(r);
                            e = e && e.setTimeout ? e : r, i = "[object process]" === ({}).toString.call(r.process) ? function(e) {
                                process.nextTick(function() {
                                    c(e);
                                });
                            } : function() {
                                if (r.postMessage && !r.importScripts) {
                                    var e = !0, t = r.onmessage;
                                    return r.onmessage = function() {
                                        e = !1;
                                    }, r.postMessage("", "*"), r.onmessage = t, e;
                                }
                            }() ? (a = "setImmediate$" + Math.random() + "$", r.addEventListener ? r.addEventListener("message", d, !1) : r.attachEvent("onmessage", d), function(e) {
                                r.postMessage(a + e, "*");
                            }) : r.MessageChannel ? ((t = new MessageChannel).port1.onmessage = function(e) {
                                c(e.data);
                            }, function(e) {
                                t.port2.postMessage(e);
                            }) : l && "onreadystatechange" in l.createElement("script") ? (s = l.documentElement, function(e) {
                                var t = l.createElement("script");
                                t.onreadystatechange = function() {
                                    c(e), t.onreadystatechange = null, s.removeChild(t), t = null;
                                }, s.appendChild(t);
                            }) : function(e) {
                                setTimeout(c, 0, e);
                            }, e.setImmediate = function(e) {
                                "function" != typeof e && (e = new Function("" + e));
                                for(var t = new Array(arguments.length - 1), r = 0; r < t.length; r++)t[r] = arguments[r + 1];
                                var n = {
                                    callback: e,
                                    args: t
                                };
                                return h[o] = n, i(o), o++;
                            }, e.clearImmediate = f;
                        }
                        function f(e) {
                            delete h[e];
                        }
                        function c(e) {
                            if (u) setTimeout(c, 0, e);
                            else {
                                var t = h[e];
                                if (t) {
                                    u = !0;
                                    try {
                                        !function(e) {
                                            var t = e.callback, r = e.args;
                                            switch(r.length){
                                                case 0:
                                                    t();
                                                    break;
                                                case 1:
                                                    t(r[0]);
                                                    break;
                                                case 2:
                                                    t(r[0], r[1]);
                                                    break;
                                                case 3:
                                                    t(r[0], r[1], r[2]);
                                                    break;
                                                default:
                                                    t.apply(n, r);
                                            }
                                        }(t);
                                    } finally{
                                        f(e), u = !1;
                                    }
                                }
                            }
                        }
                        function d(e) {
                            e.source === r && "string" == typeof e.data && 0 === e.data.indexOf(a) && c(+e.data.slice(a.length));
                        }
                    }("undefined" == typeof self ? void 0 === e ? this : e : self);
                }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
            },
            {}
        ]
    }, {}, [
        10
    ])(10);
});

},{"f7295d6075386111":"dB11O","cf30dbb97a1d82ba":"5jT8D"}],"lUKCm":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, WriterState, XMLDOMImplementation, XMLDocument, XMLDocumentCB, XMLStreamWriter, XMLStringWriter, assign, isFunction;
    ({ assign, isFunction } = require("2647794ec6919cf8"));
    XMLDOMImplementation = require("204f3257bd042cb8");
    XMLDocument = require("1984b650bfe70c70");
    XMLDocumentCB = require("9dbd1ebdb6a95fc3");
    XMLStringWriter = require("69100afb0dfc47f2");
    XMLStreamWriter = require("fd0f26d6534ce99d");
    NodeType = require("fcf823ff2587a9f2");
    WriterState = require("bba57db33f4cadd6");
    // Creates a new document and returns the root node for
    // chain-building the document tree
    // `name` name of the root element
    // `xmldec.version` A version number string, e.g. 1.0
    // `xmldec.encoding` Encoding declaration, e.g. UTF-8
    // `xmldec.standalone` standalone document declaration: true or false
    // `doctype.pubID` public identifier of the external subset
    // `doctype.sysID` system identifier of the external subset
    // `options.headless` whether XML declaration and doctype will be included:
    //     true or false
    // `options.keepNullNodes` whether nodes with null values will be kept
    //     or ignored: true or false
    // `options.keepNullAttributes` whether attributes with null values will be
    //     kept or ignored: true or false
    // `options.ignoreDecorators` whether decorator strings will be ignored when
    //     converting JS objects: true or false
    // `options.separateArrayItems` whether array items are created as separate
    //     nodes when passed as an object value: true or false
    // `options.noDoubleEncoding` whether existing html entities are encoded:
    //     true or false
    // `options.stringify` a set of functions to use for converting values to
    //     strings
    // `options.writer` the default XML writer to use for converting nodes to
    //     string. If the default writer is not set, the built-in XMLStringWriter
    //     will be used instead.
    module.exports.create = function(name, xmldec, doctype, options) {
        var doc, root;
        if (name == null) throw new Error("Root element needs a name.");
        options = assign({}, xmldec, doctype, options);
        // create the document node
        doc = new XMLDocument(options);
        // add the root node
        root = doc.element(name);
        // prolog
        if (!options.headless) {
            doc.declaration(options);
            if (options.pubID != null || options.sysID != null) doc.dtd(options);
        }
        return root;
    };
    // Creates a new document and returns the document node for
    // chain-building the document tree
    // `options.keepNullNodes` whether nodes with null values will be kept
    //     or ignored: true or false
    // `options.keepNullAttributes` whether attributes with null values will be
    //     kept or ignored: true or false
    // `options.ignoreDecorators` whether decorator strings will be ignored when
    //     converting JS objects: true or false
    // `options.separateArrayItems` whether array items are created as separate
    //     nodes when passed as an object value: true or false
    // `options.noDoubleEncoding` whether existing html entities are encoded:
    //     true or false
    // `options.stringify` a set of functions to use for converting values to
    //     strings
    // `options.writer` the default XML writer to use for converting nodes to
    //     string. If the default writer is not set, the built-in XMLStringWriter
    //     will be used instead.
    // `onData` the function to be called when a new chunk of XML is output. The
    //          string containing the XML chunk is passed to `onData` as its single
    //          argument.
    // `onEnd`  the function to be called when the XML document is completed with
    //          `end`. `onEnd` does not receive any arguments.
    module.exports.begin = function(options, onData, onEnd) {
        if (isFunction(options)) {
            [onData, onEnd] = [
                options,
                onData
            ];
            options = {};
        }
        if (onData) return new XMLDocumentCB(options, onData, onEnd);
        else return new XMLDocument(options);
    };
    module.exports.stringWriter = function(options) {
        return new XMLStringWriter(options);
    };
    module.exports.streamWriter = function(stream, options) {
        return new XMLStreamWriter(stream, options);
    };
    module.exports.implementation = new XMLDOMImplementation();
    module.exports.nodeType = NodeType;
    module.exports.writerState = WriterState;
}).call(this);

},{"2647794ec6919cf8":"ciE88","204f3257bd042cb8":"lJo2v","1984b650bfe70c70":"bS6pz","9dbd1ebdb6a95fc3":"pyTHg","69100afb0dfc47f2":"6ruW9","fd0f26d6534ce99d":"hqczL","fcf823ff2587a9f2":"jTDqp","bba57db33f4cadd6":"dP9hm"}],"ciE88":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    // Copies all enumerable own properties from `sources` to `target`
    var assign, getValue, isArray, isEmpty, isFunction, isObject, isPlainObject, hasProp = {}.hasOwnProperty;
    assign = function(target, ...sources) {
        var i, key, len, source;
        if (isFunction(Object.assign)) Object.assign.apply(null, arguments);
        else for(i = 0, len = sources.length; i < len; i++){
            source = sources[i];
            if (source != null) for(key in source){
                if (!hasProp.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    };
    // Determines if `val` is a Function object
    isFunction = function(val) {
        return !!val && Object.prototype.toString.call(val) === '[object Function]';
    };
    // Determines if `val` is an Object
    isObject = function(val) {
        var ref;
        return !!val && ((ref = typeof val) === 'function' || ref === 'object');
    };
    // Determines if `val` is an Array
    isArray = function(val) {
        if (isFunction(Array.isArray)) return Array.isArray(val);
        else return Object.prototype.toString.call(val) === '[object Array]';
    };
    // Determines if `val` is an empty Array or an Object with no own properties
    isEmpty = function(val) {
        var key;
        if (isArray(val)) return !val.length;
        else {
            for(key in val){
                if (!hasProp.call(val, key)) continue;
                return false;
            }
            return true;
        }
    };
    // Determines if `val` is a plain Object
    isPlainObject = function(val) {
        var ctor, proto;
        return isObject(val) && (proto = Object.getPrototypeOf(val)) && (ctor = proto.constructor) && typeof ctor === 'function' && ctor instanceof ctor && Function.prototype.toString.call(ctor) === Function.prototype.toString.call(Object);
    };
    // Gets the primitive value of an object
    getValue = function(obj) {
        if (isFunction(obj.valueOf)) return obj.valueOf();
        else return obj;
    };
    module.exports.assign = assign;
    module.exports.isFunction = isFunction;
    module.exports.isObject = isObject;
    module.exports.isArray = isArray;
    module.exports.isEmpty = isEmpty;
    module.exports.isPlainObject = isPlainObject;
    module.exports.getValue = getValue;
}).call(this);

},{}],"lJo2v":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    // Implements the DOMImplementation interface
    var XMLDOMImplementation;
    module.exports = XMLDOMImplementation = class XMLDOMImplementation {
        // Tests if the DOM implementation implements a specific feature.
        // `feature` package name of the feature to test. In Level 1, the
        //           legal values are "HTML" and "XML" (case-insensitive).
        // `version` version number of the package name to test. 
        //           In Level 1, this is the string "1.0". If the version is 
        //           not specified, supporting any version of the feature will 
        //           cause the method to return true.
        hasFeature(feature, version) {
            return true;
        }
        // Creates a new document type declaration.
        // `qualifiedName` qualified name of the document type to be created
        // `publicId` public identifier of the external subset
        // `systemId` system identifier of the external subset
        createDocumentType(qualifiedName, publicId, systemId) {
            throw new Error("This DOM method is not implemented.");
        }
        // Creates a new document.
        // `namespaceURI` namespace URI of the document element to create
        // `qualifiedName` the qualified name of the document to be created
        // `doctype` the type of document to be created or null
        createDocument(namespaceURI, qualifiedName, doctype) {
            throw new Error("This DOM method is not implemented.");
        }
        // Creates a new HTML document.
        // `title` document title
        createHTMLDocument(title) {
            throw new Error("This DOM method is not implemented.");
        }
        // Returns a specialized object which implements the specialized APIs 
        // of the specified feature and version.
        // `feature` name of the feature requested.
        // `version` version number of the feature to test
        getFeature(feature, version) {
            throw new Error("This DOM method is not implemented.");
        }
    };
}).call(this);

},{}],"bS6pz":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDOMConfiguration, XMLDOMImplementation, XMLDocument, XMLNode, XMLStringWriter, XMLStringifier, isPlainObject;
    ({ isPlainObject } = require("13a5a3baabce41d8"));
    XMLDOMImplementation = require("b6961c96ff36d753");
    XMLDOMConfiguration = require("1f23d28cae8a60a5");
    XMLNode = require("cd39268a029bdce2");
    NodeType = require("ee7140c760116731");
    XMLStringifier = require("f050dc0a62284d96");
    XMLStringWriter = require("1c368e88d7130ef6");
    // Represents an XML builder
    module.exports = XMLDocument = (function() {
        class XMLDocument extends XMLNode {
            // Initializes a new instance of `XMLDocument`
            // `options.keepNullNodes` whether nodes with null values will be kept
            //     or ignored: true or false
            // `options.keepNullAttributes` whether attributes with null values will be
            //     kept or ignored: true or false
            // `options.ignoreDecorators` whether decorator strings will be ignored when
            //     converting JS objects: true or false
            // `options.separateArrayItems` whether array items are created as separate
            //     nodes when passed as an object value: true or false
            // `options.noDoubleEncoding` whether existing html entities are encoded:
            //     true or false
            // `options.stringify` a set of functions to use for converting values to
            //     strings
            // `options.writer` the default XML writer to use for converting nodes to
            //     string. If the default writer is not set, the built-in XMLStringWriter
            //     will be used instead.
            constructor(options){
                super(null);
                this.name = "#document";
                this.type = NodeType.Document;
                this.documentURI = null;
                this.domConfig = new XMLDOMConfiguration();
                options || (options = {});
                if (!options.writer) options.writer = new XMLStringWriter();
                this.options = options;
                this.stringify = new XMLStringifier(options);
            }
            // Ends the document and passes it to the given XML writer
            // `writer` is either an XML writer or a plain object to pass to the
            // constructor of the default XML writer. The default writer is assigned when
            // creating the XML document. Following flags are recognized by the
            // built-in XMLStringWriter:
            //   `writer.pretty` pretty prints the result
            //   `writer.indent` indentation for pretty print
            //   `writer.offset` how many indentations to add to every line for pretty print
            //   `writer.newline` newline sequence for pretty print
            end(writer) {
                var writerOptions;
                writerOptions = {};
                if (!writer) writer = this.options.writer;
                else if (isPlainObject(writer)) {
                    writerOptions = writer;
                    writer = this.options.writer;
                }
                return writer.document(this, writer.filterOptions(writerOptions));
            }
            // Converts the XML document to string
            // `options.pretty` pretty prints the result
            // `options.indent` indentation for pretty print
            // `options.offset` how many indentations to add to every line for pretty print
            // `options.newline` newline sequence for pretty print
            toString(options) {
                return this.options.writer.document(this, this.options.writer.filterOptions(options));
            }
            // DOM level 1 functions to be implemented later
            createElement(tagName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createDocumentFragment() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createTextNode(data) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createComment(data) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createCDATASection(data) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createProcessingInstruction(target, data) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createAttribute(name) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createEntityReference(name) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getElementsByTagName(tagname) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM level 2 functions to be implemented later
            importNode(importedNode, deep) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createElementNS(namespaceURI, qualifiedName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createAttributeNS(namespaceURI, qualifiedName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getElementsByTagNameNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getElementById(elementId) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM level 3 functions to be implemented later
            adoptNode(source) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            normalizeDocument() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            renameNode(node, namespaceURI, qualifiedName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM level 4 functions to be implemented later
            getElementsByClassName(classNames) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createEvent(eventInterface) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createRange() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createNodeIterator(root, whatToShow, filter) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            createTreeWalker(root, whatToShow, filter) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        }
        // DOM level 1
        Object.defineProperty(XMLDocument.prototype, 'implementation', {
            value: new XMLDOMImplementation()
        });
        Object.defineProperty(XMLDocument.prototype, 'doctype', {
            get: function() {
                var child, i, len, ref;
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.DocType) return child;
                }
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'documentElement', {
            get: function() {
                return this.rootObject || null;
            }
        });
        // DOM level 3
        Object.defineProperty(XMLDocument.prototype, 'inputEncoding', {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'strictErrorChecking', {
            get: function() {
                return false;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'xmlEncoding', {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].encoding;
                else return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'xmlStandalone', {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].standalone === 'yes';
                else return false;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'xmlVersion', {
            get: function() {
                if (this.children.length !== 0 && this.children[0].type === NodeType.Declaration) return this.children[0].version;
                else return "1.0";
            }
        });
        // DOM level 4
        Object.defineProperty(XMLDocument.prototype, 'URL', {
            get: function() {
                return this.documentURI;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'origin', {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'compatMode', {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'characterSet', {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDocument.prototype, 'contentType', {
            get: function() {
                return null;
            }
        });
        return XMLDocument;
    }).call(this);
}).call(this);

},{"13a5a3baabce41d8":"ciE88","b6961c96ff36d753":"lJo2v","1f23d28cae8a60a5":"4aUcD","cd39268a029bdce2":"8FQY3","ee7140c760116731":"jTDqp","f050dc0a62284d96":"dKezJ","1c368e88d7130ef6":"6ruW9"}],"4aUcD":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var XMLDOMConfiguration, XMLDOMErrorHandler, XMLDOMStringList;
    XMLDOMErrorHandler = require("c72a8151611a34e9");
    XMLDOMStringList = require("6710741fe0d16dae");
    // Implements the DOMConfiguration interface
    module.exports = XMLDOMConfiguration = (function() {
        class XMLDOMConfiguration {
            constructor(){
                var clonedSelf;
                this.defaultParams = {
                    "canonical-form": false,
                    "cdata-sections": false,
                    "comments": false,
                    "datatype-normalization": false,
                    "element-content-whitespace": true,
                    "entities": true,
                    "error-handler": new XMLDOMErrorHandler(),
                    "infoset": true,
                    "validate-if-schema": false,
                    "namespaces": true,
                    "namespace-declarations": true,
                    "normalize-characters": false,
                    "schema-location": '',
                    "schema-type": '',
                    "split-cdata-sections": true,
                    "validate": false,
                    "well-formed": true
                };
                this.params = clonedSelf = Object.create(this.defaultParams);
            }
            // Gets the value of a parameter.
            // `name` name of the parameter
            getParameter(name) {
                if (this.params.hasOwnProperty(name)) return this.params[name];
                else return null;
            }
            // Checks if setting a parameter to a specific value is supported.
            // `name` name of the parameter
            // `value` parameter value
            canSetParameter(name, value) {
                return true;
            }
            // Sets the value of a parameter.
            // `name` name of the parameter
            // `value` new value or null if the user wishes to unset the parameter
            setParameter(name, value) {
                if (value != null) return this.params[name] = value;
                else return delete this.params[name];
            }
        }
        // Returns the list of parameter names
        Object.defineProperty(XMLDOMConfiguration.prototype, 'parameterNames', {
            get: function() {
                return new XMLDOMStringList(Object.keys(this.defaultParams));
            }
        });
        return XMLDOMConfiguration;
    }).call(this);
}).call(this);

},{"c72a8151611a34e9":"i3tA2","6710741fe0d16dae":"6PTiC"}],"i3tA2":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    // Represents the error handler for DOM operations
    var XMLDOMErrorHandler;
    module.exports = XMLDOMErrorHandler = class XMLDOMErrorHandler {
        // Initializes a new instance of `XMLDOMErrorHandler`
        constructor(){}
        // Called on the error handler when an error occurs.
        // `error` the error message as a string
        handleError(error) {
            throw new Error(error);
        }
    };
}).call(this);

},{}],"6PTiC":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    // Represents a list of string entries
    var XMLDOMStringList;
    module.exports = XMLDOMStringList = (function() {
        class XMLDOMStringList {
            // Initializes a new instance of `XMLDOMStringList`
            // This is just a wrapper around an ordinary
            // JS array.
            // `arr` the array of string values
            constructor(arr){
                this.arr = arr || [];
            }
            // Returns the indexth item in the collection.
            // `index` index into the collection
            item(index) {
                return this.arr[index] || null;
            }
            // Test if a string is part of this DOMStringList.
            // `str` the string to look for
            contains(str) {
                return this.arr.indexOf(str) !== -1;
            }
        }
        // Returns the number of strings in the list.
        Object.defineProperty(XMLDOMStringList.prototype, 'length', {
            get: function() {
                return this.arr.length;
            }
        });
        return XMLDOMStringList;
    }).call(this);
}).call(this);

},{}],"8FQY3":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var DocumentPosition, NodeType, XMLCData, XMLComment, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLNamedNodeMap, XMLNode, XMLNodeList, XMLProcessingInstruction, XMLRaw, XMLText, getValue, isEmpty, isFunction, isObject, hasProp = {}.hasOwnProperty, splice = [].splice;
    ({ isObject, isFunction, isEmpty, getValue } = require("704f24b4c9ed0254"));
    XMLElement = null;
    XMLCData = null;
    XMLComment = null;
    XMLDeclaration = null;
    XMLDocType = null;
    XMLRaw = null;
    XMLText = null;
    XMLProcessingInstruction = null;
    XMLDummy = null;
    NodeType = null;
    XMLNodeList = null;
    XMLNamedNodeMap = null;
    DocumentPosition = null;
    // Represents a generic XMl element
    module.exports = XMLNode = (function() {
        class XMLNode {
            // Initializes a new instance of `XMLNode`
            // `parent` the parent node
            constructor(parent1){
                this.parent = parent1;
                if (this.parent) {
                    this.options = this.parent.options;
                    this.stringify = this.parent.stringify;
                }
                this.value = null;
                this.children = [];
                this.baseURI = null;
                // first execution, load dependencies that are otherwise
                // circular (so we can't load them at the top)
                if (!XMLElement) {
                    XMLElement = require("bb9f43b93220ad7a");
                    XMLCData = require("4c7d896cb6b56d63");
                    XMLComment = require("91ed1f62eb89b645");
                    XMLDeclaration = require("f449ccd8348c817c");
                    XMLDocType = require("8ee4082395714d35");
                    XMLRaw = require("f9c5b1d6679a33d5");
                    XMLText = require("65d90f77c6196668");
                    XMLProcessingInstruction = require("8e2e2e7d9c99b0f1");
                    XMLDummy = require("f80ef020b5f168cc");
                    NodeType = require("7c33a03644563158");
                    XMLNodeList = require("ff2b0673a3f10f56");
                    XMLNamedNodeMap = require("dbaafd3117e37a72");
                    DocumentPosition = require("6214827e72f53399");
                }
            }
            // Sets the parent node of this node and its children recursively
            // `parent` the parent node
            setParent(parent) {
                var child, j, len, ref1, results;
                this.parent = parent;
                if (parent) {
                    this.options = parent.options;
                    this.stringify = parent.stringify;
                }
                ref1 = this.children;
                results = [];
                for(j = 0, len = ref1.length; j < len; j++){
                    child = ref1[j];
                    results.push(child.setParent(this));
                }
                return results;
            }
            // Creates a child element node
            // `name` node name or an object describing the XML tree
            // `attributes` an object containing name/value pairs of attributes
            // `text` element text
            element(name, attributes, text) {
                var childNode, item, j, k, key, lastChild, len, len1, val;
                lastChild = null;
                if (attributes === null && text == null) [attributes, text] = [
                    {},
                    null
                ];
                if (attributes == null) attributes = {};
                attributes = getValue(attributes);
                // swap argument order: text <-> attributes
                if (!isObject(attributes)) [text, attributes] = [
                    attributes,
                    text
                ];
                if (name != null) name = getValue(name);
                // expand if array
                if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                    item = name[j];
                    lastChild = this.element(item);
                }
                else if (isFunction(name)) lastChild = this.element(name.apply());
                else if (isObject(name)) for(key in name){
                    if (!hasProp.call(name, key)) continue;
                    val = name[key];
                    if (isFunction(val)) // evaluate if function
                    val = val.apply();
                    // assign attributes
                    if (!this.options.ignoreDecorators && this.stringify.convertAttKey && key.indexOf(this.stringify.convertAttKey) === 0) lastChild = this.attribute(key.substr(this.stringify.convertAttKey.length), val);
                    else if (!this.options.separateArrayItems && Array.isArray(val) && isEmpty(val)) lastChild = this.dummy();
                    else if (isObject(val) && isEmpty(val)) lastChild = this.element(key);
                    else if (!this.options.keepNullNodes && val == null) lastChild = this.dummy();
                    else if (!this.options.separateArrayItems && Array.isArray(val)) for(k = 0, len1 = val.length; k < len1; k++){
                        item = val[k];
                        childNode = {};
                        childNode[key] = item;
                        lastChild = this.element(childNode);
                    }
                    else if (isObject(val)) {
                        // if the key is #text expand child nodes under this node to support mixed content
                        if (!this.options.ignoreDecorators && this.stringify.convertTextKey && key.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.element(val);
                        else {
                            lastChild = this.element(key);
                            lastChild.element(val);
                        }
                    } else // text node
                    lastChild = this.element(key, val);
                }
                else if (!this.options.keepNullNodes && text === null) lastChild = this.dummy();
                else {
                    // text node
                    if (!this.options.ignoreDecorators && this.stringify.convertTextKey && name.indexOf(this.stringify.convertTextKey) === 0) lastChild = this.text(text);
                    else if (!this.options.ignoreDecorators && this.stringify.convertCDataKey && name.indexOf(this.stringify.convertCDataKey) === 0) lastChild = this.cdata(text);
                    else if (!this.options.ignoreDecorators && this.stringify.convertCommentKey && name.indexOf(this.stringify.convertCommentKey) === 0) lastChild = this.comment(text);
                    else if (!this.options.ignoreDecorators && this.stringify.convertRawKey && name.indexOf(this.stringify.convertRawKey) === 0) lastChild = this.raw(text);
                    else if (!this.options.ignoreDecorators && this.stringify.convertPIKey && name.indexOf(this.stringify.convertPIKey) === 0) lastChild = this.instruction(name.substr(this.stringify.convertPIKey.length), text);
                    else // element node
                    lastChild = this.node(name, attributes, text);
                }
                if (lastChild == null) throw new Error("Could not create any elements with: " + name + ". " + this.debugInfo());
                return lastChild;
            }
            // Creates a child element node before the current node
            // `name` node name or an object describing the XML tree
            // `attributes` an object containing name/value pairs of attributes
            // `text` element text
            insertBefore(name, attributes, text) {
                var child, i, newChild, refChild, removed;
                // DOM level 1
                // insertBefore(newChild, refChild) inserts the child node newChild before refChild
                if (name != null ? name.type : void 0) {
                    newChild = name;
                    refChild = attributes;
                    newChild.setParent(this);
                    if (refChild) {
                        // temporarily remove children starting *with* refChild
                        i = children.indexOf(refChild);
                        removed = children.splice(i);
                        // add the new child
                        children.push(newChild);
                        // add back removed children after new child
                        Array.prototype.push.apply(children, removed);
                    } else children.push(newChild);
                    return newChild;
                } else {
                    if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
                    // temporarily remove children starting *with* this
                    i = this.parent.children.indexOf(this);
                    removed = this.parent.children.splice(i);
                    // add the new child
                    child = this.parent.element(name, attributes, text);
                    // add back removed children after new child
                    Array.prototype.push.apply(this.parent.children, removed);
                    return child;
                }
            }
            // Creates a child element node after the current node
            // `name` node name or an object describing the XML tree
            // `attributes` an object containing name/value pairs of attributes
            // `text` element text
            insertAfter(name, attributes, text) {
                var child, i, removed;
                if (this.isRoot) throw new Error("Cannot insert elements at root level. " + this.debugInfo(name));
                // temporarily remove children starting *after* this
                i = this.parent.children.indexOf(this);
                removed = this.parent.children.splice(i + 1);
                // add the new child
                child = this.parent.element(name, attributes, text);
                // add back removed children after new child
                Array.prototype.push.apply(this.parent.children, removed);
                return child;
            }
            // Deletes a child element node
            remove() {
                var i, ref1;
                if (this.isRoot) throw new Error("Cannot remove the root element. " + this.debugInfo());
                i = this.parent.children.indexOf(this);
                splice.apply(this.parent.children, [
                    i,
                    i - i + 1
                ].concat(ref1 = [])), ref1;
                return this.parent;
            }
            // Creates a node
            // `name` name of the node
            // `attributes` an object containing name/value pairs of attributes
            // `text` element text
            node(name, attributes, text) {
                var child;
                if (name != null) name = getValue(name);
                attributes || (attributes = {});
                attributes = getValue(attributes);
                // swap argument order: text <-> attributes
                if (!isObject(attributes)) [text, attributes] = [
                    attributes,
                    text
                ];
                child = new XMLElement(this, name, attributes);
                if (text != null) child.text(text);
                this.children.push(child);
                return child;
            }
            // Creates a text node
            // `value` element text
            text(value) {
                var child;
                if (isObject(value)) this.element(value);
                child = new XMLText(this, value);
                this.children.push(child);
                return this;
            }
            // Creates a CDATA node
            // `value` element text without CDATA delimiters
            cdata(value) {
                var child;
                child = new XMLCData(this, value);
                this.children.push(child);
                return this;
            }
            // Creates a comment node
            // `value` comment text
            comment(value) {
                var child;
                child = new XMLComment(this, value);
                this.children.push(child);
                return this;
            }
            // Creates a comment node before the current node
            // `value` comment text
            commentBefore(value) {
                var child, i, removed;
                // temporarily remove children starting *with* this
                i = this.parent.children.indexOf(this);
                removed = this.parent.children.splice(i);
                // add the new child
                child = this.parent.comment(value);
                // add back removed children after new child
                Array.prototype.push.apply(this.parent.children, removed);
                return this;
            }
            // Creates a comment node after the current node
            // `value` comment text
            commentAfter(value) {
                var child, i, removed;
                // temporarily remove children starting *after* this
                i = this.parent.children.indexOf(this);
                removed = this.parent.children.splice(i + 1);
                // add the new child
                child = this.parent.comment(value);
                // add back removed children after new child
                Array.prototype.push.apply(this.parent.children, removed);
                return this;
            }
            // Adds unescaped raw text
            // `value` text
            raw(value) {
                var child;
                child = new XMLRaw(this, value);
                this.children.push(child);
                return this;
            }
            // Adds a dummy node
            dummy() {
                var child;
                child = new XMLDummy(this);
                // Normally when a new node is created it is added to the child node collection.
                // However, dummy nodes are never added to the XML tree. They are created while
                // converting JS objects to XML nodes in order not to break the recursive function
                // chain. They can be thought of as invisible nodes. They can be traversed through
                // by using prev(), next(), up(), etc. functions but they do not exists in the tree.
                // @children.push child
                return child;
            }
            // Adds a processing instruction
            // `target` instruction target
            // `value` instruction value
            instruction(target, value) {
                var insTarget, insValue, instruction, j, len;
                if (target != null) target = getValue(target);
                if (value != null) value = getValue(value);
                if (Array.isArray(target)) for(j = 0, len = target.length; j < len; j++){
                    insTarget = target[j];
                    this.instruction(insTarget);
                }
                else if (isObject(target)) for(insTarget in target){
                    if (!hasProp.call(target, insTarget)) continue;
                    insValue = target[insTarget];
                    this.instruction(insTarget, insValue);
                }
                else {
                    if (isFunction(value)) value = value.apply();
                    instruction = new XMLProcessingInstruction(this, target, value);
                    this.children.push(instruction);
                }
                return this;
            }
            // Creates a processing instruction node before the current node
            // `target` instruction target
            // `value` instruction value
            instructionBefore(target, value) {
                var child, i, removed;
                // temporarily remove children starting *with* this
                i = this.parent.children.indexOf(this);
                removed = this.parent.children.splice(i);
                // add the new child
                child = this.parent.instruction(target, value);
                // add back removed children after new child
                Array.prototype.push.apply(this.parent.children, removed);
                return this;
            }
            // Creates a processing instruction node after the current node
            // `target` instruction target
            // `value` instruction value
            instructionAfter(target, value) {
                var child, i, removed;
                // temporarily remove children starting *after* this
                i = this.parent.children.indexOf(this);
                removed = this.parent.children.splice(i + 1);
                // add the new child
                child = this.parent.instruction(target, value);
                // add back removed children after new child
                Array.prototype.push.apply(this.parent.children, removed);
                return this;
            }
            // Creates the xml declaration
            // `version` A version number string, e.g. 1.0
            // `encoding` Encoding declaration, e.g. UTF-8
            // `standalone` standalone document declaration: true or false
            declaration(version, encoding, standalone) {
                var doc, xmldec;
                doc = this.document();
                xmldec = new XMLDeclaration(doc, version, encoding, standalone);
                // Replace XML declaration if exists, otherwise insert at top
                if (doc.children.length === 0) doc.children.unshift(xmldec);
                else if (doc.children[0].type === NodeType.Declaration) doc.children[0] = xmldec;
                else doc.children.unshift(xmldec);
                return doc.root() || doc;
            }
            // Creates the document type declaration
            // `pubID` the public identifier of the external subset
            // `sysID` the system identifier of the external subset
            dtd(pubID, sysID) {
                var child, doc, doctype, i, j, k, len, len1, ref1, ref2;
                doc = this.document();
                doctype = new XMLDocType(doc, pubID, sysID);
                ref1 = doc.children;
                // Replace DTD if exists
                for(i = j = 0, len = ref1.length; j < len; i = ++j){
                    child = ref1[i];
                    if (child.type === NodeType.DocType) {
                        doc.children[i] = doctype;
                        return doctype;
                    }
                }
                ref2 = doc.children;
                // insert before root node if the root node exists
                for(i = k = 0, len1 = ref2.length; k < len1; i = ++k){
                    child = ref2[i];
                    if (child.isRoot) {
                        doc.children.splice(i, 0, doctype);
                        return doctype;
                    }
                }
                // otherwise append to end
                doc.children.push(doctype);
                return doctype;
            }
            // Gets the parent node
            up() {
                if (this.isRoot) throw new Error("The root node has no parent. Use doc() if you need to get the document object.");
                return this.parent;
            }
            // Gets the root node
            root() {
                var node;
                node = this;
                while(node){
                    if (node.type === NodeType.Document) return node.rootObject;
                    else if (node.isRoot) return node;
                    else node = node.parent;
                }
            }
            // Gets the node representing the XML document
            document() {
                var node;
                node = this;
                while(node){
                    if (node.type === NodeType.Document) return node;
                    else node = node.parent;
                }
            }
            // Ends the document and converts string
            end(options) {
                return this.document().end(options);
            }
            // Gets the previous node
            prev() {
                var i;
                i = this.parent.children.indexOf(this);
                if (i < 1) throw new Error("Already at the first node. " + this.debugInfo());
                return this.parent.children[i - 1];
            }
            // Gets the next node
            next() {
                var i;
                i = this.parent.children.indexOf(this);
                if (i === -1 || i === this.parent.children.length - 1) throw new Error("Already at the last node. " + this.debugInfo());
                return this.parent.children[i + 1];
            }
            // Imports cloned root from another XML document
            // `doc` the XML document to insert nodes from
            importDocument(doc) {
                var child, clonedRoot, j, len, ref1;
                clonedRoot = doc.root().clone();
                clonedRoot.parent = this;
                clonedRoot.isRoot = false;
                this.children.push(clonedRoot);
                // set properties if imported element becomes the root node
                if (this.type === NodeType.Document) {
                    clonedRoot.isRoot = true;
                    clonedRoot.documentObject = this;
                    this.rootObject = clonedRoot;
                    // set dtd name
                    if (this.children) {
                        ref1 = this.children;
                        for(j = 0, len = ref1.length; j < len; j++){
                            child = ref1[j];
                            if (child.type === NodeType.DocType) {
                                child.name = clonedRoot.name;
                                break;
                            }
                        }
                    }
                }
                return this;
            }
            // Returns debug string for this node
            debugInfo(name) {
                var ref1, ref2;
                name = name || this.name;
                if (name == null && !((ref1 = this.parent) != null ? ref1.name : void 0)) return "";
                else if (name == null) return "parent: <" + this.parent.name + ">";
                else if (!((ref2 = this.parent) != null ? ref2.name : void 0)) return "node: <" + name + ">";
                else return "node: <" + name + ">, parent: <" + this.parent.name + ">";
            }
            // Aliases
            ele(name, attributes, text) {
                return this.element(name, attributes, text);
            }
            nod(name, attributes, text) {
                return this.node(name, attributes, text);
            }
            txt(value) {
                return this.text(value);
            }
            dat(value) {
                return this.cdata(value);
            }
            com(value) {
                return this.comment(value);
            }
            ins(target, value) {
                return this.instruction(target, value);
            }
            doc() {
                return this.document();
            }
            dec(version, encoding, standalone) {
                return this.declaration(version, encoding, standalone);
            }
            e(name, attributes, text) {
                return this.element(name, attributes, text);
            }
            n(name, attributes, text) {
                return this.node(name, attributes, text);
            }
            t(value) {
                return this.text(value);
            }
            d(value) {
                return this.cdata(value);
            }
            c(value) {
                return this.comment(value);
            }
            r(value) {
                return this.raw(value);
            }
            i(target, value) {
                return this.instruction(target, value);
            }
            u() {
                return this.up();
            }
            // can be deprecated in a future release
            importXMLBuilder(doc) {
                return this.importDocument(doc);
            }
            // Adds or modifies an attribute.
            // `name` attribute name
            // `value` attribute value
            attribute(name, value) {
                throw new Error("attribute() applies to element nodes only.");
            }
            att(name, value) {
                return this.attribute(name, value);
            }
            a(name, value) {
                return this.attribute(name, value);
            }
            // Removes an attribute
            // `name` attribute name
            removeAttribute(name) {
                throw new Error("attribute() applies to element nodes only.");
            }
            // DOM level 1 functions to be implemented later
            replaceChild(newChild, oldChild) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            removeChild(oldChild) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            appendChild(newChild) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            hasChildNodes() {
                return this.children.length !== 0;
            }
            cloneNode(deep) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            normalize() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM level 2
            isSupported(feature, version) {
                return true;
            }
            hasAttributes() {
                return this.attribs.length !== 0;
            }
            // DOM level 3 functions to be implemented later
            compareDocumentPosition(other) {
                var ref, res;
                ref = this;
                if (ref === other) return 0;
                else if (this.document() !== other.document()) {
                    res = DocumentPosition.Disconnected | DocumentPosition.ImplementationSpecific;
                    if (Math.random() < 0.5) res |= DocumentPosition.Preceding;
                    else res |= DocumentPosition.Following;
                    return res;
                } else if (ref.isAncestor(other)) return DocumentPosition.Contains | DocumentPosition.Preceding;
                else if (ref.isDescendant(other)) return DocumentPosition.Contains | DocumentPosition.Following;
                else if (ref.isPreceding(other)) return DocumentPosition.Preceding;
                else return DocumentPosition.Following;
            }
            isSameNode(other) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            lookupPrefix(namespaceURI) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            isDefaultNamespace(namespaceURI) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            lookupNamespaceURI(prefix) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            isEqualNode(node) {
                var i, j, ref1;
                if (node.nodeType !== this.nodeType) return false;
                if (node.children.length !== this.children.length) return false;
                for(i = j = 0, ref1 = this.children.length - 1; 0 <= ref1 ? j <= ref1 : j >= ref1; i = 0 <= ref1 ? ++j : --j){
                    if (!this.children[i].isEqualNode(node.children[i])) return false;
                }
                return true;
            }
            getFeature(feature, version) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            setUserData(key, data, handler) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getUserData(key) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // Returns true if other is an inclusive descendant of node,
            // and false otherwise.
            contains(other) {
                if (!other) return false;
                return other === this || this.isDescendant(other);
            }
            // An object A is called a descendant of an object B, if either A is 
            // a child of B or A is a child of an object C that is a descendant of B.
            isDescendant(node) {
                var child, isDescendantChild, j, len, ref1;
                ref1 = this.children;
                for(j = 0, len = ref1.length; j < len; j++){
                    child = ref1[j];
                    if (node === child) return true;
                    isDescendantChild = child.isDescendant(node);
                    if (isDescendantChild) return true;
                }
                return false;
            }
            // An object A is called an ancestor of an object B if and only if
            // B is a descendant of A.
            isAncestor(node) {
                return node.isDescendant(this);
            }
            // An object A is preceding an object B if A and B are in the 
            // same tree and A comes before B in tree order.
            isPreceding(node) {
                var nodePos, thisPos;
                nodePos = this.treePosition(node);
                thisPos = this.treePosition(this);
                if (nodePos === -1 || thisPos === -1) return false;
                else return nodePos < thisPos;
            }
            // An object A is folllowing an object B if A and B are in the 
            // same tree and A comes after B in tree order.
            isFollowing(node) {
                var nodePos, thisPos;
                nodePos = this.treePosition(node);
                thisPos = this.treePosition(this);
                if (nodePos === -1 || thisPos === -1) return false;
                else return nodePos > thisPos;
            }
            // Returns the preorder position of the given node in the tree, or -1
            // if the node is not in the tree.
            treePosition(node) {
                var found, pos;
                pos = 0;
                found = false;
                this.foreachTreeNode(this.document(), function(childNode) {
                    pos++;
                    if (!found && childNode === node) return found = true;
                });
                if (found) return pos;
                else return -1;
            }
            // Depth-first preorder traversal through the XML tree
            foreachTreeNode(node, func) {
                var child, j, len, ref1, res;
                node || (node = this.document());
                ref1 = node.children;
                for(j = 0, len = ref1.length; j < len; j++){
                    child = ref1[j];
                    if (res = func(child)) return res;
                    else {
                        res = this.foreachTreeNode(child, func);
                        if (res) return res;
                    }
                }
            }
        }
        // DOM level 1
        Object.defineProperty(XMLNode.prototype, 'nodeName', {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'nodeType', {
            get: function() {
                return this.type;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'nodeValue', {
            get: function() {
                return this.value;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'parentNode', {
            get: function() {
                return this.parent;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'childNodes', {
            get: function() {
                if (!this.childNodeList || !this.childNodeList.nodes) this.childNodeList = new XMLNodeList(this.children);
                return this.childNodeList;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'firstChild', {
            get: function() {
                return this.children[0] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'lastChild', {
            get: function() {
                return this.children[this.children.length - 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'previousSibling', {
            get: function() {
                var i;
                i = this.parent.children.indexOf(this);
                return this.parent.children[i - 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'nextSibling', {
            get: function() {
                var i;
                i = this.parent.children.indexOf(this);
                return this.parent.children[i + 1] || null;
            }
        });
        Object.defineProperty(XMLNode.prototype, 'ownerDocument', {
            get: function() {
                return this.document() || null;
            }
        });
        // DOM level 3
        Object.defineProperty(XMLNode.prototype, 'textContent', {
            get: function() {
                var child, j, len, ref1, str;
                if (this.nodeType === NodeType.Element || this.nodeType === NodeType.DocumentFragment) {
                    str = '';
                    ref1 = this.children;
                    for(j = 0, len = ref1.length; j < len; j++){
                        child = ref1[j];
                        if (child.textContent) str += child.textContent;
                    }
                    return str;
                } else return null;
            },
            set: function(value) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        return XMLNode;
    }).call(this);
}).call(this);

},{"704f24b4c9ed0254":"ciE88","bb9f43b93220ad7a":"cR4iw","4c7d896cb6b56d63":"c2bnB","91ed1f62eb89b645":"heMmo","f449ccd8348c817c":"2xV8n","8ee4082395714d35":"9ORSa","f9c5b1d6679a33d5":"3TALW","65d90f77c6196668":"fHsyt","8e2e2e7d9c99b0f1":"bTUB6","f80ef020b5f168cc":"lXqE7","7c33a03644563158":"jTDqp","ff2b0673a3f10f56":"clZPM","dbaafd3117e37a72":"4GsnY","6214827e72f53399":"1l2YL"}],"cR4iw":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLAttribute, XMLElement, XMLNamedNodeMap, XMLNode, getValue, isFunction, isObject, hasProp = {}.hasOwnProperty;
    ({ isObject, isFunction, getValue } = require("760e1e681b3efb5e"));
    XMLNode = require("b30d72617b2d0e");
    NodeType = require("b548af19154e188f");
    XMLAttribute = require("91ce844474972b76");
    XMLNamedNodeMap = require("1a2db5acef6e9ab2");
    // Represents an element of the XML document
    module.exports = XMLElement = (function() {
        class XMLElement extends XMLNode {
            // Initializes a new instance of `XMLElement`
            // `parent` the parent node
            // `name` element name
            // `attributes` an object containing name/value pairs of attributes
            constructor(parent, name, attributes){
                var child, j, len, ref;
                super(parent);
                if (name == null) throw new Error("Missing element name. " + this.debugInfo());
                this.name = this.stringify.name(name);
                this.type = NodeType.Element;
                this.attribs = {};
                this.schemaTypeInfo = null;
                if (attributes != null) this.attribute(attributes);
                // set properties if this is the root node
                if (parent.type === NodeType.Document) {
                    this.isRoot = true;
                    this.documentObject = parent;
                    parent.rootObject = this;
                    // set dtd name
                    if (parent.children) {
                        ref = parent.children;
                        for(j = 0, len = ref.length; j < len; j++){
                            child = ref[j];
                            if (child.type === NodeType.DocType) {
                                child.name = this.name;
                                break;
                            }
                        }
                    }
                }
            }
            // Creates and returns a deep clone of `this`
            clone() {
                var att, attName, clonedSelf, ref;
                clonedSelf = Object.create(this);
                // remove document element
                if (clonedSelf.isRoot) clonedSelf.documentObject = null;
                // clone attributes
                clonedSelf.attribs = {};
                ref = this.attribs;
                for(attName in ref){
                    if (!hasProp.call(ref, attName)) continue;
                    att = ref[attName];
                    clonedSelf.attribs[attName] = att.clone();
                }
                // clone child nodes
                clonedSelf.children = [];
                this.children.forEach(function(child) {
                    var clonedChild;
                    clonedChild = child.clone();
                    clonedChild.parent = clonedSelf;
                    return clonedSelf.children.push(clonedChild);
                });
                return clonedSelf;
            }
            // Adds or modifies an attribute
            // `name` attribute name
            // `value` attribute value
            attribute(name, value) {
                var attName, attValue;
                if (name != null) name = getValue(name);
                if (isObject(name)) for(attName in name){
                    if (!hasProp.call(name, attName)) continue;
                    attValue = name[attName];
                    this.attribute(attName, attValue);
                }
                else {
                    if (isFunction(value)) value = value.apply();
                    if (this.options.keepNullAttributes && value == null) this.attribs[name] = new XMLAttribute(this, name, "");
                    else if (value != null) this.attribs[name] = new XMLAttribute(this, name, value);
                }
                return this;
            }
            // Removes an attribute
            // `name` attribute name
            removeAttribute(name) {
                var attName, j, len;
                // Also defined in DOM level 1
                // removeAttribute(name) removes an attribute by name.
                if (name == null) throw new Error("Missing attribute name. " + this.debugInfo());
                name = getValue(name);
                if (Array.isArray(name)) for(j = 0, len = name.length; j < len; j++){
                    attName = name[j];
                    delete this.attribs[attName];
                }
                else delete this.attribs[name];
                return this;
            }
            // Converts the XML fragment to string
            // `options.pretty` pretty prints the result
            // `options.indent` indentation for pretty print
            // `options.offset` how many indentations to add to every line for pretty print
            // `options.newline` newline sequence for pretty print
            // `options.allowEmpty` do not self close empty element tags
            toString(options) {
                return this.options.writer.element(this, this.options.writer.filterOptions(options));
            }
            // Aliases
            att(name, value) {
                return this.attribute(name, value);
            }
            a(name, value) {
                return this.attribute(name, value);
            }
            // DOM Level 1
            getAttribute(name) {
                if (this.attribs.hasOwnProperty(name)) return this.attribs[name].value;
                else return null;
            }
            setAttribute(name, value) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getAttributeNode(name) {
                if (this.attribs.hasOwnProperty(name)) return this.attribs[name];
                else return null;
            }
            setAttributeNode(newAttr) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            removeAttributeNode(oldAttr) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getElementsByTagName(name) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM Level 2
            getAttributeNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            setAttributeNS(namespaceURI, qualifiedName, value) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            removeAttributeNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getAttributeNodeNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            setAttributeNodeNS(newAttr) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getElementsByTagNameNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            hasAttribute(name) {
                return this.attribs.hasOwnProperty(name);
            }
            hasAttributeNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM Level 3
            setIdAttribute(name, isId) {
                if (this.attribs.hasOwnProperty(name)) return this.attribs[name].isId;
                else return isId;
            }
            setIdAttributeNS(namespaceURI, localName, isId) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            setIdAttributeNode(idAttr, isId) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM Level 4
            getElementsByTagName(tagname) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getElementsByTagNameNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            getElementsByClassName(classNames) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            isEqualNode(node) {
                var i, j, ref;
                if (!super.isEqualNode(node)) return false;
                if (node.namespaceURI !== this.namespaceURI) return false;
                if (node.prefix !== this.prefix) return false;
                if (node.localName !== this.localName) return false;
                if (node.attribs.length !== this.attribs.length) return false;
                for(i = j = 0, ref = this.attribs.length - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j){
                    if (!this.attribs[i].isEqualNode(node.attribs[i])) return false;
                }
                return true;
            }
        }
        // DOM level 1
        Object.defineProperty(XMLElement.prototype, 'tagName', {
            get: function() {
                return this.name;
            }
        });
        // DOM level 4
        Object.defineProperty(XMLElement.prototype, 'namespaceURI', {
            get: function() {
                return '';
            }
        });
        Object.defineProperty(XMLElement.prototype, 'prefix', {
            get: function() {
                return '';
            }
        });
        Object.defineProperty(XMLElement.prototype, 'localName', {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLElement.prototype, 'id', {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, 'className', {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, 'classList', {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLElement.prototype, 'attributes', {
            get: function() {
                if (!this.attributeMap || !this.attributeMap.nodes) this.attributeMap = new XMLNamedNodeMap(this.attribs);
                return this.attributeMap;
            }
        });
        return XMLElement;
    }).call(this);
}).call(this);

},{"760e1e681b3efb5e":"ciE88","b30d72617b2d0e":"8FQY3","b548af19154e188f":"jTDqp","91ce844474972b76":"7DdyK","1a2db5acef6e9ab2":"4GsnY"}],"jTDqp":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    module.exports = {
        Element: 1,
        Attribute: 2,
        Text: 3,
        CData: 4,
        EntityReference: 5,
        EntityDeclaration: 6,
        ProcessingInstruction: 7,
        Comment: 8,
        Document: 9,
        DocType: 10,
        DocumentFragment: 11,
        NotationDeclaration: 12,
        // Numeric codes up to 200 are reserved to W3C for possible future use.
        // Following are types internal to this library:
        Declaration: 201,
        Raw: 202,
        AttributeDeclaration: 203,
        ElementDeclaration: 204,
        Dummy: 205
    };
}).call(this);

},{}],"7DdyK":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLAttribute, XMLNode;
    NodeType = require("2ac94b791509906a");
    XMLNode = require("4460ed8c305de0cc");
    // Represents an attribute
    module.exports = XMLAttribute = (function() {
        class XMLAttribute {
            // Initializes a new instance of `XMLAttribute`
            // `parent` the parent node
            // `name` attribute target
            // `value` attribute value
            constructor(parent, name, value){
                this.parent = parent;
                if (this.parent) {
                    this.options = this.parent.options;
                    this.stringify = this.parent.stringify;
                }
                if (name == null) throw new Error("Missing attribute name. " + this.debugInfo(name));
                this.name = this.stringify.name(name);
                this.value = this.stringify.attValue(value);
                this.type = NodeType.Attribute;
                // DOM level 3
                this.isId = false;
                this.schemaTypeInfo = null;
            }
            // Creates and returns a deep clone of `this`
            clone() {
                return Object.create(this);
            }
            // Converts the XML fragment to string
            // `options.pretty` pretty prints the result
            // `options.indent` indentation for pretty print
            // `options.offset` how many indentations to add to every line for pretty print
            // `options.newline` newline sequence for pretty print
            toString(options) {
                return this.options.writer.attribute(this, this.options.writer.filterOptions(options));
            }
            // Returns debug string for this node
            debugInfo(name) {
                name = name || this.name;
                if (name == null) return "parent: <" + this.parent.name + ">";
                else return "attribute: {" + name + "}, parent: <" + this.parent.name + ">";
            }
            isEqualNode(node) {
                if (node.namespaceURI !== this.namespaceURI) return false;
                if (node.prefix !== this.prefix) return false;
                if (node.localName !== this.localName) return false;
                if (node.value !== this.value) return false;
                return true;
            }
        }
        // DOM level 1
        Object.defineProperty(XMLAttribute.prototype, 'nodeType', {
            get: function() {
                return this.type;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, 'ownerElement', {
            get: function() {
                return this.parent;
            }
        });
        // DOM level 3
        Object.defineProperty(XMLAttribute.prototype, 'textContent', {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || '';
            }
        });
        // DOM level 4
        Object.defineProperty(XMLAttribute.prototype, 'namespaceURI', {
            get: function() {
                return '';
            }
        });
        Object.defineProperty(XMLAttribute.prototype, 'prefix', {
            get: function() {
                return '';
            }
        });
        Object.defineProperty(XMLAttribute.prototype, 'localName', {
            get: function() {
                return this.name;
            }
        });
        Object.defineProperty(XMLAttribute.prototype, 'specified', {
            get: function() {
                return true;
            }
        });
        return XMLAttribute;
    }).call(this);
}).call(this);

},{"2ac94b791509906a":"jTDqp","4460ed8c305de0cc":"8FQY3"}],"4GsnY":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    // Represents a map of nodes accessed by a string key
    var XMLNamedNodeMap;
    module.exports = XMLNamedNodeMap = (function() {
        class XMLNamedNodeMap {
            // Initializes a new instance of `XMLNamedNodeMap`
            // This is just a wrapper around an ordinary
            // JS object.
            // `nodes` the object containing nodes.
            constructor(nodes){
                this.nodes = nodes;
            }
            // Creates and returns a deep clone of `this`
            clone() {
                // this class should not be cloned since it wraps
                // around a given object. The calling function should check
                // whether the wrapped object is null and supply a new object
                // (from the clone).
                return this.nodes = null;
            }
            // DOM Level 1
            getNamedItem(name) {
                return this.nodes[name];
            }
            setNamedItem(node) {
                var oldNode;
                oldNode = this.nodes[node.nodeName];
                this.nodes[node.nodeName] = node;
                return oldNode || null;
            }
            removeNamedItem(name) {
                var oldNode;
                oldNode = this.nodes[name];
                delete this.nodes[name];
                return oldNode || null;
            }
            item(index) {
                return this.nodes[Object.keys(this.nodes)[index]] || null;
            }
            // DOM level 2 functions to be implemented later
            getNamedItemNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented.");
            }
            setNamedItemNS(node) {
                throw new Error("This DOM method is not implemented.");
            }
            removeNamedItemNS(namespaceURI, localName) {
                throw new Error("This DOM method is not implemented.");
            }
        }
        // DOM level 1
        Object.defineProperty(XMLNamedNodeMap.prototype, 'length', {
            get: function() {
                return Object.keys(this.nodes).length || 0;
            }
        });
        return XMLNamedNodeMap;
    }).call(this);
}).call(this);

},{}],"c2bnB":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLCData, XMLCharacterData;
    NodeType = require("1d10efe8d12710ca");
    XMLCharacterData = require("da41985d18d84bf2");
    // Represents a  CDATA node
    module.exports = XMLCData = class XMLCData extends XMLCharacterData {
        // Initializes a new instance of `XMLCData`
        // `text` CDATA text
        constructor(parent, text){
            super(parent);
            if (text == null) throw new Error("Missing CDATA text. " + this.debugInfo());
            this.name = "#cdata-section";
            this.type = NodeType.CData;
            this.value = this.stringify.cdata(text);
        }
        // Creates and returns a deep clone of `this`
        clone() {
            return Object.create(this);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return this.options.writer.cdata(this, this.options.writer.filterOptions(options));
        }
    };
}).call(this);

},{"1d10efe8d12710ca":"jTDqp","da41985d18d84bf2":"6LVLP"}],"6LVLP":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var XMLCharacterData, XMLNode;
    XMLNode = require("d99443ca7fe2d67d");
    // Represents a character data node
    module.exports = XMLCharacterData = (function() {
        class XMLCharacterData extends XMLNode {
            // Initializes a new instance of `XMLCharacterData`
            constructor(parent){
                super(parent);
                this.value = '';
            }
            // Creates and returns a deep clone of `this`
            clone() {
                return Object.create(this);
            }
            // DOM level 1 functions to be implemented later
            substringData(offset, count) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            appendData(arg) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            insertData(offset, arg) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            deleteData(offset, count) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            replaceData(offset, count, arg) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            isEqualNode(node) {
                if (!super.isEqualNode(node)) return false;
                if (node.data !== this.data) return false;
                return true;
            }
        }
        // DOM level 1
        Object.defineProperty(XMLCharacterData.prototype, 'data', {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || '';
            }
        });
        Object.defineProperty(XMLCharacterData.prototype, 'length', {
            get: function() {
                return this.value.length;
            }
        });
        // DOM level 3
        Object.defineProperty(XMLCharacterData.prototype, 'textContent', {
            get: function() {
                return this.value;
            },
            set: function(value) {
                return this.value = value || '';
            }
        });
        return XMLCharacterData;
    }).call(this);
}).call(this);

},{"d99443ca7fe2d67d":"8FQY3"}],"heMmo":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLCharacterData, XMLComment;
    NodeType = require("b0dbe926c1622528");
    XMLCharacterData = require("d18aaaf3ab58e603");
    // Represents a comment node
    module.exports = XMLComment = class XMLComment extends XMLCharacterData {
        // Initializes a new instance of `XMLComment`
        // `text` comment text
        constructor(parent, text){
            super(parent);
            if (text == null) throw new Error("Missing comment text. " + this.debugInfo());
            this.name = "#comment";
            this.type = NodeType.Comment;
            this.value = this.stringify.comment(text);
        }
        // Creates and returns a deep clone of `this`
        clone() {
            return Object.create(this);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return this.options.writer.comment(this, this.options.writer.filterOptions(options));
        }
    };
}).call(this);

},{"b0dbe926c1622528":"jTDqp","d18aaaf3ab58e603":"6LVLP"}],"2xV8n":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDeclaration, XMLNode, isObject;
    ({ isObject } = require("cf2a3ddbe00c2bec"));
    XMLNode = require("b70b0f72196be228");
    NodeType = require("7910f9e4e0ec2b8c");
    // Represents the XML declaration
    module.exports = XMLDeclaration = class XMLDeclaration extends XMLNode {
        // Initializes a new instance of `XMLDeclaration`
        // `parent` the document object
        // `version` A version number string, e.g. 1.0
        // `encoding` Encoding declaration, e.g. UTF-8
        // `standalone` standalone document declaration: true or false
        constructor(parent, version, encoding, standalone){
            super(parent);
            // arguments may also be passed as an object
            if (isObject(version)) ({ version, encoding, standalone } = version);
            if (!version) version = '1.0';
            this.type = NodeType.Declaration;
            this.version = this.stringify.xmlVersion(version);
            if (encoding != null) this.encoding = this.stringify.xmlEncoding(encoding);
            if (standalone != null) this.standalone = this.stringify.xmlStandalone(standalone);
        }
        // Converts to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return this.options.writer.declaration(this, this.options.writer.filterOptions(options));
        }
    };
}).call(this);

},{"cf2a3ddbe00c2bec":"ciE88","b70b0f72196be228":"8FQY3","7910f9e4e0ec2b8c":"jTDqp"}],"9ORSa":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDocType, XMLNamedNodeMap, XMLNode, isObject;
    ({ isObject } = require("2d96570e9ce5a61a"));
    XMLNode = require("10eff02d526f1f13");
    NodeType = require("9167240c545a1251");
    XMLDTDAttList = require("364c364aa3224d14");
    XMLDTDEntity = require("f24de147ed1d6fb5");
    XMLDTDElement = require("a588b70eba73aefb");
    XMLDTDNotation = require("6f9e9e9353c73e81");
    XMLNamedNodeMap = require("dbb2e06d6fd270ad");
    // Represents doctype declaration
    module.exports = XMLDocType = (function() {
        class XMLDocType extends XMLNode {
            // Initializes a new instance of `XMLDocType`
            // `parent` the document object
            // `pubID` public identifier of the external subset
            // `sysID` system identifier of the external subset
            constructor(parent, pubID, sysID){
                var child, i, len, ref;
                super(parent);
                this.type = NodeType.DocType;
                // set DTD name to the name of the root node
                if (parent.children) {
                    ref = parent.children;
                    for(i = 0, len = ref.length; i < len; i++){
                        child = ref[i];
                        if (child.type === NodeType.Element) {
                            this.name = child.name;
                            break;
                        }
                    }
                }
                this.documentObject = parent;
                // arguments may also be passed as an object
                if (isObject(pubID)) ({ pubID, sysID } = pubID);
                if (sysID == null) [sysID, pubID] = [
                    pubID,
                    sysID
                ];
                if (pubID != null) this.pubID = this.stringify.dtdPubID(pubID);
                if (sysID != null) this.sysID = this.stringify.dtdSysID(sysID);
            }
            // Creates an element type declaration
            // `name` element name
            // `value` element content (defaults to #PCDATA)
            element(name, value) {
                var child;
                child = new XMLDTDElement(this, name, value);
                this.children.push(child);
                return this;
            }
            // Creates an attribute declaration
            // `elementName` the name of the element containing this attribute
            // `attributeName` attribute name
            // `attributeType` type of the attribute (defaults to CDATA)
            // `defaultValueType` default value type (either #REQUIRED, #IMPLIED, #FIXED or
            //                    #DEFAULT) (defaults to #IMPLIED)
            // `defaultValue` default value of the attribute
            //                (only used for #FIXED or #DEFAULT)
            attList(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
                var child;
                child = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
                this.children.push(child);
                return this;
            }
            // Creates a general entity declaration
            // `name` the name of the entity
            // `value` internal entity value or an object with external entity details
            // `value.pubID` public identifier
            // `value.sysID` system identifier
            // `value.nData` notation declaration
            entity(name, value) {
                var child;
                child = new XMLDTDEntity(this, false, name, value);
                this.children.push(child);
                return this;
            }
            // Creates a parameter entity declaration
            // `name` the name of the entity
            // `value` internal entity value or an object with external entity details
            // `value.pubID` public identifier
            // `value.sysID` system identifier
            pEntity(name, value) {
                var child;
                child = new XMLDTDEntity(this, true, name, value);
                this.children.push(child);
                return this;
            }
            // Creates a NOTATION declaration
            // `name` the name of the notation
            // `value` an object with external entity details
            // `value.pubID` public identifier
            // `value.sysID` system identifier
            notation(name, value) {
                var child;
                child = new XMLDTDNotation(this, name, value);
                this.children.push(child);
                return this;
            }
            // Converts to string
            // `options.pretty` pretty prints the result
            // `options.indent` indentation for pretty print
            // `options.offset` how many indentations to add to every line for pretty print
            // `options.newline` newline sequence for pretty print
            toString(options) {
                return this.options.writer.docType(this, this.options.writer.filterOptions(options));
            }
            // Aliases
            ele(name, value) {
                return this.element(name, value);
            }
            att(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
                return this.attList(elementName, attributeName, attributeType, defaultValueType, defaultValue);
            }
            ent(name, value) {
                return this.entity(name, value);
            }
            pent(name, value) {
                return this.pEntity(name, value);
            }
            not(name, value) {
                return this.notation(name, value);
            }
            up() {
                return this.root() || this.documentObject;
            }
            isEqualNode(node) {
                if (!super.isEqualNode(node)) return false;
                if (node.name !== this.name) return false;
                if (node.publicId !== this.publicId) return false;
                if (node.systemId !== this.systemId) return false;
                return true;
            }
        }
        // DOM level 1
        Object.defineProperty(XMLDocType.prototype, 'entities', {
            get: function() {
                var child, i, len, nodes, ref;
                nodes = {};
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.EntityDeclaration && !child.pe) nodes[child.name] = child;
                }
                return new XMLNamedNodeMap(nodes);
            }
        });
        Object.defineProperty(XMLDocType.prototype, 'notations', {
            get: function() {
                var child, i, len, nodes, ref;
                nodes = {};
                ref = this.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    if (child.type === NodeType.NotationDeclaration) nodes[child.name] = child;
                }
                return new XMLNamedNodeMap(nodes);
            }
        });
        // DOM level 2
        Object.defineProperty(XMLDocType.prototype, 'publicId', {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDocType.prototype, 'systemId', {
            get: function() {
                return this.sysID;
            }
        });
        Object.defineProperty(XMLDocType.prototype, 'internalSubset', {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        return XMLDocType;
    }).call(this);
}).call(this);

},{"2d96570e9ce5a61a":"ciE88","10eff02d526f1f13":"8FQY3","9167240c545a1251":"jTDqp","364c364aa3224d14":"jiQze","f24de147ed1d6fb5":"48Zd0","a588b70eba73aefb":"8NRpI","6f9e9e9353c73e81":"6ELKn","dbb2e06d6fd270ad":"4GsnY"}],"jiQze":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDTDAttList, XMLNode;
    XMLNode = require("e63acd90dbde9d27");
    NodeType = require("e38e2d5ce2a0a55");
    // Represents an attribute list
    module.exports = XMLDTDAttList = class XMLDTDAttList extends XMLNode {
        // Initializes a new instance of `XMLDTDAttList`
        // `parent` the parent `XMLDocType` element
        // `elementName` the name of the element containing this attribute
        // `attributeName` attribute name
        // `attributeType` type of the attribute
        // `defaultValueType` default value type (either #REQUIRED, #IMPLIED,
        //                    #FIXED or #DEFAULT)
        // `defaultValue` default value of the attribute
        //                (only used for #FIXED or #DEFAULT)
        constructor(parent, elementName, attributeName, attributeType, defaultValueType, defaultValue){
            super(parent);
            if (elementName == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (attributeName == null) throw new Error("Missing DTD attribute name. " + this.debugInfo(elementName));
            if (!attributeType) throw new Error("Missing DTD attribute type. " + this.debugInfo(elementName));
            if (!defaultValueType) throw new Error("Missing DTD attribute default. " + this.debugInfo(elementName));
            if (defaultValueType.indexOf('#') !== 0) defaultValueType = '#' + defaultValueType;
            if (!defaultValueType.match(/^(#REQUIRED|#IMPLIED|#FIXED|#DEFAULT)$/)) throw new Error("Invalid default value type; expected: #REQUIRED, #IMPLIED, #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            if (defaultValue && !defaultValueType.match(/^(#FIXED|#DEFAULT)$/)) throw new Error("Default value only applies to #FIXED or #DEFAULT. " + this.debugInfo(elementName));
            this.elementName = this.stringify.name(elementName);
            this.type = NodeType.AttributeDeclaration;
            this.attributeName = this.stringify.name(attributeName);
            this.attributeType = this.stringify.dtdAttType(attributeType);
            if (defaultValue) this.defaultValue = this.stringify.dtdAttDefault(defaultValue);
            this.defaultValueType = defaultValueType;
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return this.options.writer.dtdAttList(this, this.options.writer.filterOptions(options));
        }
    };
}).call(this);

},{"e63acd90dbde9d27":"8FQY3","e38e2d5ce2a0a55":"jTDqp"}],"48Zd0":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDTDEntity, XMLNode, isObject;
    ({ isObject } = require("6b00c2638d6cff6e"));
    XMLNode = require("5619e8138a9444ca");
    NodeType = require("2e642c53b1846a5e");
    // Represents an entity declaration in the DTD
    module.exports = XMLDTDEntity = (function() {
        class XMLDTDEntity extends XMLNode {
            // Initializes a new instance of `XMLDTDEntity`
            // `parent` the parent `XMLDocType` element
            // `pe` whether this is a parameter entity or a general entity
            //      defaults to `false` (general entity)
            // `name` the name of the entity
            // `value` internal entity value or an object with external entity details
            // `value.pubID` public identifier
            // `value.sysID` system identifier
            // `value.nData` notation declaration
            constructor(parent, pe, name, value){
                super(parent);
                if (name == null) throw new Error("Missing DTD entity name. " + this.debugInfo(name));
                if (value == null) throw new Error("Missing DTD entity value. " + this.debugInfo(name));
                this.pe = !!pe;
                this.name = this.stringify.name(name);
                this.type = NodeType.EntityDeclaration;
                if (!isObject(value)) {
                    this.value = this.stringify.dtdEntityValue(value);
                    this.internal = true;
                } else {
                    if (!value.pubID && !value.sysID) throw new Error("Public and/or system identifiers are required for an external entity. " + this.debugInfo(name));
                    if (value.pubID && !value.sysID) throw new Error("System identifier is required for a public external entity. " + this.debugInfo(name));
                    this.internal = false;
                    if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
                    if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
                    if (value.nData != null) this.nData = this.stringify.dtdNData(value.nData);
                    if (this.pe && this.nData) throw new Error("Notation declaration is not allowed in a parameter entity. " + this.debugInfo(name));
                }
            }
            // Converts the XML fragment to string
            // `options.pretty` pretty prints the result
            // `options.indent` indentation for pretty print
            // `options.offset` how many indentations to add to every line for pretty print
            // `options.newline` newline sequence for pretty print
            toString(options) {
                return this.options.writer.dtdEntity(this, this.options.writer.filterOptions(options));
            }
        }
        // DOM level 1
        Object.defineProperty(XMLDTDEntity.prototype, 'publicId', {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, 'systemId', {
            get: function() {
                return this.sysID;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, 'notationName', {
            get: function() {
                return this.nData || null;
            }
        });
        // DOM level 3
        Object.defineProperty(XMLDTDEntity.prototype, 'inputEncoding', {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, 'xmlEncoding', {
            get: function() {
                return null;
            }
        });
        Object.defineProperty(XMLDTDEntity.prototype, 'xmlVersion', {
            get: function() {
                return null;
            }
        });
        return XMLDTDEntity;
    }).call(this);
}).call(this);

},{"6b00c2638d6cff6e":"ciE88","5619e8138a9444ca":"8FQY3","2e642c53b1846a5e":"jTDqp"}],"8NRpI":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDTDElement, XMLNode;
    XMLNode = require("58f833e8788221ff");
    NodeType = require("bd936b22ecaf9e3e");
    // Represents an attribute
    module.exports = XMLDTDElement = class XMLDTDElement extends XMLNode {
        // Initializes a new instance of `XMLDTDElement`
        // `parent` the parent `XMLDocType` element
        // `name` element name
        // `value` element content (defaults to #PCDATA)
        constructor(parent, name, value){
            super(parent);
            if (name == null) throw new Error("Missing DTD element name. " + this.debugInfo());
            if (!value) value = '(#PCDATA)';
            if (Array.isArray(value)) value = '(' + value.join(',') + ')';
            this.name = this.stringify.name(name);
            this.type = NodeType.ElementDeclaration;
            this.value = this.stringify.dtdElementValue(value);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return this.options.writer.dtdElement(this, this.options.writer.filterOptions(options));
        }
    };
}).call(this);

},{"58f833e8788221ff":"8FQY3","bd936b22ecaf9e3e":"jTDqp"}],"6ELKn":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDTDNotation, XMLNode;
    XMLNode = require("30e258c5f358ba86");
    NodeType = require("3458890a6746c52e");
    // Represents a NOTATION entry in the DTD
    module.exports = XMLDTDNotation = (function() {
        class XMLDTDNotation extends XMLNode {
            // Initializes a new instance of `XMLDTDNotation`
            // `parent` the parent `XMLDocType` element
            // `name` the name of the notation
            // `value` an object with external entity details
            // `value.pubID` public identifier
            // `value.sysID` system identifier
            constructor(parent, name, value){
                super(parent);
                if (name == null) throw new Error("Missing DTD notation name. " + this.debugInfo(name));
                if (!value.pubID && !value.sysID) throw new Error("Public or system identifiers are required for an external entity. " + this.debugInfo(name));
                this.name = this.stringify.name(name);
                this.type = NodeType.NotationDeclaration;
                if (value.pubID != null) this.pubID = this.stringify.dtdPubID(value.pubID);
                if (value.sysID != null) this.sysID = this.stringify.dtdSysID(value.sysID);
            }
            // Converts the XML fragment to string
            // `options.pretty` pretty prints the result
            // `options.indent` indentation for pretty print
            // `options.offset` how many indentations to add to every line for pretty print
            // `options.newline` newline sequence for pretty print
            toString(options) {
                return this.options.writer.dtdNotation(this, this.options.writer.filterOptions(options));
            }
        }
        // DOM level 1
        Object.defineProperty(XMLDTDNotation.prototype, 'publicId', {
            get: function() {
                return this.pubID;
            }
        });
        Object.defineProperty(XMLDTDNotation.prototype, 'systemId', {
            get: function() {
                return this.sysID;
            }
        });
        return XMLDTDNotation;
    }).call(this);
}).call(this);

},{"30e258c5f358ba86":"8FQY3","3458890a6746c52e":"jTDqp"}],"3TALW":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLNode, XMLRaw;
    NodeType = require("dcd9ea319a520167");
    XMLNode = require("47e90ce7f40a2f89");
    // Represents a  raw node
    module.exports = XMLRaw = class XMLRaw extends XMLNode {
        // Initializes a new instance of `XMLRaw`
        // `text` raw text
        constructor(parent, text){
            super(parent);
            if (text == null) throw new Error("Missing raw text. " + this.debugInfo());
            this.type = NodeType.Raw;
            this.value = this.stringify.raw(text);
        }
        // Creates and returns a deep clone of `this`
        clone() {
            return Object.create(this);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return this.options.writer.raw(this, this.options.writer.filterOptions(options));
        }
    };
}).call(this);

},{"dcd9ea319a520167":"jTDqp","47e90ce7f40a2f89":"8FQY3"}],"fHsyt":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLCharacterData, XMLText;
    NodeType = require("e16b55d7b9ae6110");
    XMLCharacterData = require("6951a1495b9b2aef");
    // Represents a text node
    module.exports = XMLText = (function() {
        class XMLText extends XMLCharacterData {
            // Initializes a new instance of `XMLText`
            // `text` element text
            constructor(parent, text){
                super(parent);
                if (text == null) throw new Error("Missing element text. " + this.debugInfo());
                this.name = "#text";
                this.type = NodeType.Text;
                this.value = this.stringify.text(text);
            }
            // Creates and returns a deep clone of `this`
            clone() {
                return Object.create(this);
            }
            // Converts the XML fragment to string
            // `options.pretty` pretty prints the result
            // `options.indent` indentation for pretty print
            // `options.offset` how many indentations to add to every line for pretty print
            // `options.newline` newline sequence for pretty print
            toString(options) {
                return this.options.writer.text(this, this.options.writer.filterOptions(options));
            }
            // DOM level 1 functions to be implemented later
            splitText(offset) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
            // DOM level 3 functions to be implemented later
            replaceWholeText(content) {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        }
        // DOM level 3
        Object.defineProperty(XMLText.prototype, 'isElementContentWhitespace', {
            get: function() {
                throw new Error("This DOM method is not implemented." + this.debugInfo());
            }
        });
        Object.defineProperty(XMLText.prototype, 'wholeText', {
            get: function() {
                var next, prev, str;
                str = '';
                prev = this.previousSibling;
                while(prev){
                    str = prev.data + str;
                    prev = prev.previousSibling;
                }
                str += this.data;
                next = this.nextSibling;
                while(next){
                    str = str + next.data;
                    next = next.nextSibling;
                }
                return str;
            }
        });
        return XMLText;
    }).call(this);
}).call(this);

},{"e16b55d7b9ae6110":"jTDqp","6951a1495b9b2aef":"6LVLP"}],"bTUB6":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLCharacterData, XMLProcessingInstruction;
    NodeType = require("dc0d646c907512fa");
    XMLCharacterData = require("3417ec217a826ec8");
    // Represents a processing instruction
    module.exports = XMLProcessingInstruction = class XMLProcessingInstruction extends XMLCharacterData {
        // Initializes a new instance of `XMLProcessingInstruction`
        // `parent` the parent node
        // `target` instruction target
        // `value` instruction value
        constructor(parent, target, value){
            super(parent);
            if (target == null) throw new Error("Missing instruction target. " + this.debugInfo());
            this.type = NodeType.ProcessingInstruction;
            this.target = this.stringify.insTarget(target);
            this.name = this.target;
            if (value) this.value = this.stringify.insValue(value);
        }
        // Creates and returns a deep clone of `this`
        clone() {
            return Object.create(this);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return this.options.writer.processingInstruction(this, this.options.writer.filterOptions(options));
        }
        isEqualNode(node) {
            if (!super.isEqualNode(node)) return false;
            if (node.target !== this.target) return false;
            return true;
        }
    };
}).call(this);

},{"dc0d646c907512fa":"jTDqp","3417ec217a826ec8":"6LVLP"}],"lXqE7":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, XMLDummy, XMLNode;
    XMLNode = require("a213921cd91c2245");
    NodeType = require("47cd197d16eee265");
    // Represents a  raw node
    module.exports = XMLDummy = class XMLDummy extends XMLNode {
        // Initializes a new instance of `XMLDummy`
        // `XMLDummy` is a special node representing a node with 
        // a null value. Dummy nodes are created while recursively
        // building the XML tree. Simply skipping null values doesn't
        // work because that would break the recursive chain.
        constructor(parent){
            super(parent);
            this.type = NodeType.Dummy;
        }
        // Creates and returns a deep clone of `this`
        clone() {
            return Object.create(this);
        }
        // Converts the XML fragment to string
        // `options.pretty` pretty prints the result
        // `options.indent` indentation for pretty print
        // `options.offset` how many indentations to add to every line for pretty print
        // `options.newline` newline sequence for pretty print
        toString(options) {
            return '';
        }
    };
}).call(this);

},{"a213921cd91c2245":"8FQY3","47cd197d16eee265":"jTDqp"}],"clZPM":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    // Represents a list of nodes
    var XMLNodeList;
    module.exports = XMLNodeList = (function() {
        class XMLNodeList {
            // Initializes a new instance of `XMLNodeList`
            // This is just a wrapper around an ordinary
            // JS array.
            // `nodes` the array containing nodes.
            constructor(nodes){
                this.nodes = nodes;
            }
            // Creates and returns a deep clone of `this`
            clone() {
                // this class should not be cloned since it wraps
                // around a given array. The calling function should check
                // whether the wrapped array is null and supply a new array
                // (from the clone).
                return this.nodes = null;
            }
            // DOM Level 1
            item(index) {
                return this.nodes[index] || null;
            }
        }
        // DOM level 1
        Object.defineProperty(XMLNodeList.prototype, 'length', {
            get: function() {
                return this.nodes.length || 0;
            }
        });
        return XMLNodeList;
    }).call(this);
}).call(this);

},{}],"1l2YL":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    module.exports = {
        Disconnected: 1,
        Preceding: 2,
        Following: 4,
        Contains: 8,
        ContainedBy: 16,
        ImplementationSpecific: 32
    };
}).call(this);

},{}],"dKezJ":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    // Converts values to strings
    var XMLStringifier, hasProp = {}.hasOwnProperty;
    module.exports = XMLStringifier = (function() {
        class XMLStringifier {
            // Initializes a new instance of `XMLStringifier`
            // `options.version` The version number string of the XML spec to validate against, e.g. 1.0
            // `options.noDoubleEncoding` whether existing html entities are encoded: true or false
            // `options.stringify` a set of functions to use for converting values to strings
            // `options.noValidation` whether values will be validated and escaped or returned as is
            // `options.invalidCharReplacement` a character to replace invalid characters and disable character validation
            constructor(options){
                var key, ref, value;
                // Checks whether the given string contains legal characters
                // Fails with an exception on error
                // `str` the string to check
                this.assertLegalChar = this.assertLegalChar.bind(this);
                // Checks whether the given string contains legal characters for a name
                // Fails with an exception on error
                // `str` the string to check
                this.assertLegalName = this.assertLegalName.bind(this);
                options || (options = {});
                this.options = options;
                if (!this.options.version) this.options.version = '1.0';
                ref = options.stringify || {};
                for(key in ref){
                    if (!hasProp.call(ref, key)) continue;
                    value = ref[key];
                    this[key] = value;
                }
            }
            // Defaults
            name(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalName('' + val || '');
            }
            text(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar(this.textEscape('' + val || ''));
            }
            cdata(val) {
                if (this.options.noValidation) return val;
                val = '' + val || '';
                val = val.replace(']]>', ']]]]><![CDATA[>');
                return this.assertLegalChar(val);
            }
            comment(val) {
                if (this.options.noValidation) return val;
                val = '' + val || '';
                if (val.match(/--/)) throw new Error("Comment text cannot contain double-hypen: " + val);
                return this.assertLegalChar(val);
            }
            raw(val) {
                if (this.options.noValidation) return val;
                return '' + val || '';
            }
            attValue(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar(this.attEscape(val = '' + val || ''));
            }
            insTarget(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            insValue(val) {
                if (this.options.noValidation) return val;
                val = '' + val || '';
                if (val.match(/\?>/)) throw new Error("Invalid processing instruction value: " + val);
                return this.assertLegalChar(val);
            }
            xmlVersion(val) {
                if (this.options.noValidation) return val;
                val = '' + val || '';
                if (!val.match(/1\.[0-9]+/)) throw new Error("Invalid version number: " + val);
                return val;
            }
            xmlEncoding(val) {
                if (this.options.noValidation) return val;
                val = '' + val || '';
                if (!val.match(/^[A-Za-z](?:[A-Za-z0-9._-])*$/)) throw new Error("Invalid encoding: " + val);
                return this.assertLegalChar(val);
            }
            xmlStandalone(val) {
                if (this.options.noValidation) return val;
                if (val) return "yes";
                else return "no";
            }
            dtdPubID(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            dtdSysID(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            dtdElementValue(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            dtdAttType(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            dtdAttDefault(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            dtdEntityValue(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            dtdNData(val) {
                if (this.options.noValidation) return val;
                return this.assertLegalChar('' + val || '');
            }
            assertLegalChar(str) {
                var regex, res;
                if (this.options.noValidation) return str;
                if (this.options.version === '1.0') {
                    // Valid characters from https://www.w3.org/TR/xml/#charsets
                    // any Unicode character, excluding the surrogate blocks, FFFE, and FFFF.
                    // #x9 | #xA | #xD | [#x20-#xD7FF] | [#xE000-#xFFFD] | [#x10000-#x10FFFF]
                    // This ES5 compatible Regexp has been generated using the "regenerate" NPM module:
                    //   let xml_10_InvalidChars = regenerate()
                    //     .addRange(0x0000, 0x0008)
                    //     .add(0x000B, 0x000C)
                    //     .addRange(0x000E, 0x001F)
                    //     .addRange(0xD800, 0xDFFF)
                    //     .addRange(0xFFFE, 0xFFFF)
                    regex = /[\0-\x08\x0B\f\x0E-\x1F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g;
                    if (this.options.invalidCharReplacement !== void 0) str = str.replace(regex, this.options.invalidCharReplacement);
                    else if (res = str.match(regex)) throw new Error(`Invalid character in string: ${str} at index ${res.index}`);
                } else if (this.options.version === '1.1') {
                    // Valid characters from https://www.w3.org/TR/xml11/#charsets
                    // any Unicode character, excluding the surrogate blocks, FFFE, and FFFF.
                    // [#x1-#xD7FF] | [#xE000-#xFFFD] | [#x10000-#x10FFFF]
                    // This ES5 compatible Regexp has been generated using the "regenerate" NPM module:
                    //   let xml_11_InvalidChars = regenerate()
                    //     .add(0x0000)
                    //     .addRange(0xD800, 0xDFFF)
                    //     .addRange(0xFFFE, 0xFFFF)
                    regex = /[\0\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g;
                    if (this.options.invalidCharReplacement !== void 0) str = str.replace(regex, this.options.invalidCharReplacement);
                    else if (res = str.match(regex)) throw new Error(`Invalid character in string: ${str} at index ${res.index}`);
                }
                return str;
            }
            assertLegalName(str) {
                var regex;
                if (this.options.noValidation) return str;
                str = this.assertLegalChar(str);
                regex = /^([:A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])([\x2D\.0-:A-Z_a-z\xB7\xC0-\xD6\xD8-\xF6\xF8-\u037D\u037F-\u1FFF\u200C\u200D\u203F\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])*$/;
                if (!str.match(regex)) throw new Error(`Invalid character in name: ${str}`);
                return str;
            }
            // Escapes special characters in text
            // See http://www.w3.org/TR/2000/WD-xml-c14n-20000119.html#charescaping
            // `str` the string to escape
            textEscape(str) {
                var ampregex;
                if (this.options.noValidation) return str;
                ampregex = this.options.noDoubleEncoding ? /(?!&(lt|gt|amp|apos|quot);)&/g : /&/g;
                return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\r/g, '&#xD;');
            }
            // Escapes special characters in attribute values
            // See http://www.w3.org/TR/2000/WD-xml-c14n-20000119.html#charescaping
            // `str` the string to escape
            attEscape(str) {
                var ampregex;
                if (this.options.noValidation) return str;
                ampregex = this.options.noDoubleEncoding ? /(?!&(lt|gt|amp|apos|quot);)&/g : /&/g;
                return str.replace(ampregex, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\t/g, '&#x9;').replace(/\n/g, '&#xA;').replace(/\r/g, '&#xD;');
            }
        }
        // strings to match while converting from JS objects
        XMLStringifier.prototype.convertAttKey = '@';
        XMLStringifier.prototype.convertPIKey = '?';
        XMLStringifier.prototype.convertTextKey = '#text';
        XMLStringifier.prototype.convertCDataKey = '#cdata';
        XMLStringifier.prototype.convertCommentKey = '#comment';
        XMLStringifier.prototype.convertRawKey = '#raw';
        return XMLStringifier;
    }).call(this);
}).call(this);

},{}],"6ruW9":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var XMLStringWriter, XMLWriterBase;
    XMLWriterBase = require("9d52dc0ac6724da0");
    // Prints XML nodes as plain text
    module.exports = XMLStringWriter = class XMLStringWriter extends XMLWriterBase {
        // Initializes a new instance of `XMLStringWriter`
        // `options.pretty` pretty prints the result
        // `options.indent` indentation string
        // `options.newline` newline sequence
        // `options.offset` a fixed number of indentations to add to every line
        // `options.allowEmpty` do not self close empty element tags
        // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
        // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
        constructor(options){
            super(options);
        }
        document(doc, options) {
            var child, i, len, r, ref;
            options = this.filterOptions(options);
            r = '';
            ref = doc.children;
            for(i = 0, len = ref.length; i < len; i++){
                child = ref[i];
                r += this.writeChildNode(child, options, 0);
            }
            // remove trailing newline
            if (options.pretty && r.slice(-options.newline.length) === options.newline) r = r.slice(0, -options.newline.length);
            return r;
        }
    };
}).call(this);

},{"9d52dc0ac6724da0":"2g2zB"}],"2g2zB":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, WriterState, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDummy, XMLElement, XMLProcessingInstruction, XMLRaw, XMLText, XMLWriterBase, assign, hasProp = {}.hasOwnProperty;
    ({ assign } = require("75817c14e3dd56ca"));
    NodeType = require("d6d53251a09a6ee1");
    XMLDeclaration = require("9730194a8c0c4783");
    XMLDocType = require("ede7c141272b1dd5");
    XMLCData = require("a57838031903ea3f");
    XMLComment = require("f7ead1ad3653d490");
    XMLElement = require("dcc173f9e43bfc0a");
    XMLRaw = require("349c9f4a67644a6d");
    XMLText = require("6db0cc37b41855c3");
    XMLProcessingInstruction = require("167c0e9fd7f100e6");
    XMLDummy = require("15cae005a9a3ed5a");
    XMLDTDAttList = require("ce8d6b343d31d749");
    XMLDTDElement = require("2cddea69d2f73295");
    XMLDTDEntity = require("5bcc55fbd5532354");
    XMLDTDNotation = require("8beeee48423bc83");
    WriterState = require("dd94c2394fe6b644");
    // Base class for XML writers
    module.exports = XMLWriterBase = class XMLWriterBase {
        // Initializes a new instance of `XMLWriterBase`
        // `options.pretty` pretty prints the result
        // `options.indent` indentation string
        // `options.newline` newline sequence
        // `options.offset` a fixed number of indentations to add to every line
        // `options.width` maximum column width
        // `options.allowEmpty` do not self close empty element tags
        // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
        // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
        constructor(options){
            var key, ref, value;
            options || (options = {});
            this.options = options;
            ref = options.writer || {};
            for(key in ref){
                if (!hasProp.call(ref, key)) continue;
                value = ref[key];
                this["_" + key] = this[key];
                this[key] = value;
            }
        }
        // Filters writer options and provides defaults
        // `options` writer options
        filterOptions(options) {
            var filteredOptions, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            options || (options = {});
            options = assign({}, this.options, options);
            filteredOptions = {
                writer: this
            };
            filteredOptions.pretty = options.pretty || false;
            filteredOptions.allowEmpty = options.allowEmpty || false;
            filteredOptions.indent = (ref = options.indent) != null ? ref : '  ';
            filteredOptions.newline = (ref1 = options.newline) != null ? ref1 : '\n';
            filteredOptions.offset = (ref2 = options.offset) != null ? ref2 : 0;
            filteredOptions.width = (ref3 = options.width) != null ? ref3 : 0;
            filteredOptions.dontPrettyTextNodes = (ref4 = (ref5 = options.dontPrettyTextNodes) != null ? ref5 : options.dontprettytextnodes) != null ? ref4 : 0;
            filteredOptions.spaceBeforeSlash = (ref6 = (ref7 = options.spaceBeforeSlash) != null ? ref7 : options.spacebeforeslash) != null ? ref6 : '';
            if (filteredOptions.spaceBeforeSlash === true) filteredOptions.spaceBeforeSlash = ' ';
            filteredOptions.suppressPrettyCount = 0;
            filteredOptions.user = {};
            filteredOptions.state = WriterState.None;
            return filteredOptions;
        }
        // Returns the indentation string for the current level
        // `node` current node
        // `options` writer options
        // `level` current indentation level
        indent(node, options, level) {
            var indentLevel;
            if (!options.pretty || options.suppressPrettyCount) return '';
            else if (options.pretty) {
                indentLevel = (level || 0) + options.offset + 1;
                if (indentLevel > 0) return new Array(indentLevel).join(options.indent);
            }
            return '';
        }
        // Returns the newline string
        // `node` current node
        // `options` writer options
        // `level` current indentation level
        endline(node, options, level) {
            if (!options.pretty || options.suppressPrettyCount) return '';
            else return options.newline;
        }
        attribute(att, options, level) {
            var r;
            this.openAttribute(att, options, level);
            if (options.pretty && options.width > 0) r = att.name + '="' + att.value + '"';
            else r = ' ' + att.name + '="' + att.value + '"';
            this.closeAttribute(att, options, level);
            return r;
        }
        cdata(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<![CDATA[';
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += ']]>' + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        comment(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<!-- ';
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += ' -->' + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        declaration(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<?xml';
            options.state = WriterState.InsideTag;
            r += ' version="' + node.version + '"';
            if (node.encoding != null) r += ' encoding="' + node.encoding + '"';
            if (node.standalone != null) r += ' standalone="' + node.standalone + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + '?>';
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        docType(node, options, level) {
            var child, i, len1, r, ref;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            r += '<!DOCTYPE ' + node.root().name;
            // external identifier
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            // internal subset
            if (node.children.length > 0) {
                r += ' [';
                r += this.endline(node, options, level);
                options.state = WriterState.InsideTag;
                ref = node.children;
                for(i = 0, len1 = ref.length; i < len1; i++){
                    child = ref[i];
                    r += this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                r += ']';
            }
            // close tag
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + '>';
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        element(node, options, level) {
            var att, attLen, child, childNodeCount, firstChildNode, i, j, len, len1, len2, name, prettySuppressed, r, ratt, ref, ref1, ref2, ref3, rline;
            level || (level = 0);
            prettySuppressed = false;
            // open tag
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<' + node.name;
            // attributes
            if (options.pretty && options.width > 0) {
                len = r.length;
                ref = node.attribs;
                for(name in ref){
                    if (!hasProp.call(ref, name)) continue;
                    att = ref[name];
                    ratt = this.attribute(att, options, level);
                    attLen = ratt.length;
                    if (len + attLen > options.width) {
                        rline = this.indent(node, options, level + 1) + ratt;
                        r += this.endline(node, options, level) + rline;
                        len = rline.length;
                    } else {
                        rline = ' ' + ratt;
                        r += rline;
                        len += rline.length;
                    }
                }
            } else {
                ref1 = node.attribs;
                for(name in ref1){
                    if (!hasProp.call(ref1, name)) continue;
                    att = ref1[name];
                    r += this.attribute(att, options, level);
                }
            }
            childNodeCount = node.children.length;
            firstChildNode = childNodeCount === 0 ? null : node.children[0];
            if (childNodeCount === 0 || node.children.every(function(e) {
                return (e.type === NodeType.Text || e.type === NodeType.Raw || e.type === NodeType.CData) && e.value === '';
            })) {
                // empty element
                if (options.allowEmpty) {
                    r += '>';
                    options.state = WriterState.CloseTag;
                    r += '</' + node.name + '>' + this.endline(node, options, level);
                } else {
                    options.state = WriterState.CloseTag;
                    r += options.spaceBeforeSlash + '/>' + this.endline(node, options, level);
                }
            } else if (options.pretty && childNodeCount === 1 && (firstChildNode.type === NodeType.Text || firstChildNode.type === NodeType.Raw || firstChildNode.type === NodeType.CData) && firstChildNode.value != null) {
                // do not indent text-only nodes
                r += '>';
                options.state = WriterState.InsideTag;
                options.suppressPrettyCount++;
                prettySuppressed = true;
                r += this.writeChildNode(firstChildNode, options, level + 1);
                options.suppressPrettyCount--;
                prettySuppressed = false;
                options.state = WriterState.CloseTag;
                r += '</' + node.name + '>' + this.endline(node, options, level);
            } else {
                // if ANY are a text node, then suppress pretty now
                if (options.dontPrettyTextNodes) {
                    ref2 = node.children;
                    for(i = 0, len1 = ref2.length; i < len1; i++){
                        child = ref2[i];
                        if ((child.type === NodeType.Text || child.type === NodeType.Raw || child.type === NodeType.CData) && child.value != null) {
                            options.suppressPrettyCount++;
                            prettySuppressed = true;
                            break;
                        }
                    }
                }
                // close the opening tag, after dealing with newline
                r += '>' + this.endline(node, options, level);
                options.state = WriterState.InsideTag;
                ref3 = node.children;
                // inner tags
                for(j = 0, len2 = ref3.length; j < len2; j++){
                    child = ref3[j];
                    r += this.writeChildNode(child, options, level + 1);
                }
                // close tag
                options.state = WriterState.CloseTag;
                r += this.indent(node, options, level) + '</' + node.name + '>';
                if (prettySuppressed) options.suppressPrettyCount--;
                r += this.endline(node, options, level);
                options.state = WriterState.None;
            }
            this.closeNode(node, options, level);
            return r;
        }
        writeChildNode(node, options, level) {
            switch(node.type){
                case NodeType.CData:
                    return this.cdata(node, options, level);
                case NodeType.Comment:
                    return this.comment(node, options, level);
                case NodeType.Element:
                    return this.element(node, options, level);
                case NodeType.Raw:
                    return this.raw(node, options, level);
                case NodeType.Text:
                    return this.text(node, options, level);
                case NodeType.ProcessingInstruction:
                    return this.processingInstruction(node, options, level);
                case NodeType.Dummy:
                    return '';
                case NodeType.Declaration:
                    return this.declaration(node, options, level);
                case NodeType.DocType:
                    return this.docType(node, options, level);
                case NodeType.AttributeDeclaration:
                    return this.dtdAttList(node, options, level);
                case NodeType.ElementDeclaration:
                    return this.dtdElement(node, options, level);
                case NodeType.EntityDeclaration:
                    return this.dtdEntity(node, options, level);
                case NodeType.NotationDeclaration:
                    return this.dtdNotation(node, options, level);
                default:
                    throw new Error("Unknown XML node type: " + node.constructor.name);
            }
        }
        processingInstruction(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<?';
            options.state = WriterState.InsideTag;
            r += node.target;
            if (node.value) r += ' ' + node.value;
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + '?>';
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        raw(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        text(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level);
            options.state = WriterState.InsideTag;
            r += node.value;
            options.state = WriterState.CloseTag;
            r += this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        dtdAttList(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<!ATTLIST';
            options.state = WriterState.InsideTag;
            r += ' ' + node.elementName + ' ' + node.attributeName + ' ' + node.attributeType;
            if (node.defaultValueType !== '#DEFAULT') r += ' ' + node.defaultValueType;
            if (node.defaultValue) r += ' "' + node.defaultValue + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + '>' + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        dtdElement(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<!ELEMENT';
            options.state = WriterState.InsideTag;
            r += ' ' + node.name + ' ' + node.value;
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + '>' + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        dtdEntity(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<!ENTITY';
            options.state = WriterState.InsideTag;
            if (node.pe) r += ' %';
            r += ' ' + node.name;
            if (node.value) r += ' "' + node.value + '"';
            else {
                if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
                if (node.nData) r += ' NDATA ' + node.nData;
            }
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + '>' + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        dtdNotation(node, options, level) {
            var r;
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<!NOTATION';
            options.state = WriterState.InsideTag;
            r += ' ' + node.name;
            if (node.pubID && node.sysID) r += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
            else if (node.pubID) r += ' PUBLIC "' + node.pubID + '"';
            else if (node.sysID) r += ' SYSTEM "' + node.sysID + '"';
            options.state = WriterState.CloseTag;
            r += options.spaceBeforeSlash + '>' + this.endline(node, options, level);
            options.state = WriterState.None;
            this.closeNode(node, options, level);
            return r;
        }
        openNode(node, options, level) {}
        closeNode(node, options, level) {}
        openAttribute(att, options, level) {}
        closeAttribute(att, options, level) {}
    };
}).call(this);

},{"75817c14e3dd56ca":"ciE88","d6d53251a09a6ee1":"jTDqp","9730194a8c0c4783":"2xV8n","ede7c141272b1dd5":"9ORSa","a57838031903ea3f":"c2bnB","f7ead1ad3653d490":"heMmo","dcc173f9e43bfc0a":"cR4iw","349c9f4a67644a6d":"3TALW","6db0cc37b41855c3":"fHsyt","167c0e9fd7f100e6":"bTUB6","15cae005a9a3ed5a":"lXqE7","ce8d6b343d31d749":"jiQze","2cddea69d2f73295":"8NRpI","5bcc55fbd5532354":"48Zd0","8beeee48423bc83":"6ELKn","dd94c2394fe6b644":"dP9hm"}],"dP9hm":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    module.exports = {
        None: 0,
        OpenTag: 1,
        InsideTag: 2,
        CloseTag: 3
    };
}).call(this);

},{}],"pyTHg":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, WriterState, XMLAttribute, XMLCData, XMLComment, XMLDTDAttList, XMLDTDElement, XMLDTDEntity, XMLDTDNotation, XMLDeclaration, XMLDocType, XMLDocument, XMLDocumentCB, XMLElement, XMLProcessingInstruction, XMLRaw, XMLStringWriter, XMLStringifier, XMLText, getValue, isFunction, isObject, isPlainObject, hasProp = {}.hasOwnProperty;
    ({ isObject, isFunction, isPlainObject, getValue } = require("4a0b6b137d547786"));
    NodeType = require("97c418eb43415d1");
    XMLDocument = require("bbdde255e9b44c2a");
    XMLElement = require("7caa93eaeb2c96a7");
    XMLCData = require("e6175a20b2232a77");
    XMLComment = require("b035b3e1bd26442f");
    XMLRaw = require("526deec19abea5fe");
    XMLText = require("55ab1233b224d930");
    XMLProcessingInstruction = require("d22472ac05d87f1c");
    XMLDeclaration = require("39cdad257f5d6100");
    XMLDocType = require("9cbc536e76baf6e7");
    XMLDTDAttList = require("f30e4e8b2fd7fcd0");
    XMLDTDEntity = require("191528b53de83946");
    XMLDTDElement = require("1817e86507e2f1b4");
    XMLDTDNotation = require("26d62c2b781ea9d6");
    XMLAttribute = require("8e92d10ad0cfdf87");
    XMLStringifier = require("d654416cbe0a799d");
    XMLStringWriter = require("bb156ac07b50c66a");
    WriterState = require("ba39b9e659007a91");
    // Represents an XML builder
    module.exports = XMLDocumentCB = class XMLDocumentCB {
        // Initializes a new instance of `XMLDocumentCB`
        // `options.keepNullNodes` whether nodes with null values will be kept
        //     or ignored: true or false
        // `options.keepNullAttributes` whether attributes with null values will be
        //     kept or ignored: true or false
        // `options.ignoreDecorators` whether decorator strings will be ignored when
        //     converting JS objects: true or false
        // `options.separateArrayItems` whether array items are created as separate
        //     nodes when passed as an object value: true or false
        // `options.noDoubleEncoding` whether existing html entities are encoded:
        //     true or false
        // `options.stringify` a set of functions to use for converting values to
        //     strings
        // `options.writer` the default XML writer to use for converting nodes to
        //     string. If the default writer is not set, the built-in XMLStringWriter
        //     will be used instead.
        // `onData` the function to be called when a new chunk of XML is output. The
        //          string containing the XML chunk is passed to `onData` as its first
        //          argument, and the current indentation level as its second argument.
        // `onEnd`  the function to be called when the XML document is completed with
        //          `end`. `onEnd` does not receive any arguments.
        constructor(options, onData, onEnd){
            var writerOptions;
            this.name = "?xml";
            this.type = NodeType.Document;
            options || (options = {});
            writerOptions = {};
            if (!options.writer) options.writer = new XMLStringWriter();
            else if (isPlainObject(options.writer)) {
                writerOptions = options.writer;
                options.writer = new XMLStringWriter();
            }
            this.options = options;
            this.writer = options.writer;
            this.writerOptions = this.writer.filterOptions(writerOptions);
            this.stringify = new XMLStringifier(options);
            this.onDataCallback = onData || function() {};
            this.onEndCallback = onEnd || function() {};
            this.currentNode = null;
            this.currentLevel = -1;
            this.openTags = {};
            this.documentStarted = false;
            this.documentCompleted = false;
            this.root = null;
        }
        // Creates a child element node from the given XMLNode
        // `node` the child node
        createChildNode(node) {
            var att, attName, attributes, child, i, len, ref, ref1;
            switch(node.type){
                case NodeType.CData:
                    this.cdata(node.value);
                    break;
                case NodeType.Comment:
                    this.comment(node.value);
                    break;
                case NodeType.Element:
                    attributes = {};
                    ref = node.attribs;
                    for(attName in ref){
                        if (!hasProp.call(ref, attName)) continue;
                        att = ref[attName];
                        attributes[attName] = att.value;
                    }
                    this.node(node.name, attributes);
                    break;
                case NodeType.Dummy:
                    this.dummy();
                    break;
                case NodeType.Raw:
                    this.raw(node.value);
                    break;
                case NodeType.Text:
                    this.text(node.value);
                    break;
                case NodeType.ProcessingInstruction:
                    this.instruction(node.target, node.value);
                    break;
                default:
                    throw new Error("This XML node type is not supported in a JS object: " + node.constructor.name);
            }
            ref1 = node.children;
            // write child nodes recursively
            for(i = 0, len = ref1.length; i < len; i++){
                child = ref1[i];
                this.createChildNode(child);
                if (child.type === NodeType.Element) this.up();
            }
            return this;
        }
        // Creates a dummy node
        dummy() {
            // no-op, just return this
            return this;
        }
        // Creates a node
        // `name` name of the node
        // `attributes` an object containing name/value pairs of attributes
        // `text` element text
        node(name, attributes, text) {
            if (name == null) throw new Error("Missing node name.");
            if (this.root && this.currentLevel === -1) throw new Error("Document can only have one root node. " + this.debugInfo(name));
            this.openCurrent();
            name = getValue(name);
            if (attributes == null) attributes = {};
            attributes = getValue(attributes);
            // swap argument order: text <-> attributes
            if (!isObject(attributes)) [text, attributes] = [
                attributes,
                text
            ];
            this.currentNode = new XMLElement(this, name, attributes);
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            if (text != null) this.text(text);
            return this;
        }
        // Creates a child element node or an element type declaration when called
        // inside the DTD
        // `name` name of the node
        // `attributes` an object containing name/value pairs of attributes
        // `text` element text
        element(name, attributes, text) {
            var child, i, len, oldValidationFlag, ref, root;
            if (this.currentNode && this.currentNode.type === NodeType.DocType) this.dtdElement(...arguments);
            else if (Array.isArray(name) || isObject(name) || isFunction(name)) {
                oldValidationFlag = this.options.noValidation;
                this.options.noValidation = true;
                root = new XMLDocument(this.options).element('TEMP_ROOT');
                root.element(name);
                this.options.noValidation = oldValidationFlag;
                ref = root.children;
                for(i = 0, len = ref.length; i < len; i++){
                    child = ref[i];
                    this.createChildNode(child);
                    if (child.type === NodeType.Element) this.up();
                }
            } else this.node(name, attributes, text);
            return this;
        }
        // Adds or modifies an attribute
        // `name` attribute name
        // `value` attribute value
        attribute(name, value) {
            var attName, attValue;
            if (!this.currentNode || this.currentNode.children) throw new Error("att() can only be used immediately after an ele() call in callback mode. " + this.debugInfo(name));
            if (name != null) name = getValue(name);
            if (isObject(name)) for(attName in name){
                if (!hasProp.call(name, attName)) continue;
                attValue = name[attName];
                this.attribute(attName, attValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                if (this.options.keepNullAttributes && value == null) this.currentNode.attribs[name] = new XMLAttribute(this, name, "");
                else if (value != null) this.currentNode.attribs[name] = new XMLAttribute(this, name, value);
            }
            return this;
        }
        // Creates a text node
        // `value` element text
        text(value) {
            var node;
            this.openCurrent();
            node = new XMLText(this, value);
            this.onData(this.writer.text(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Creates a CDATA node
        // `value` element text without CDATA delimiters
        cdata(value) {
            var node;
            this.openCurrent();
            node = new XMLCData(this, value);
            this.onData(this.writer.cdata(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Creates a comment node
        // `value` comment text
        comment(value) {
            var node;
            this.openCurrent();
            node = new XMLComment(this, value);
            this.onData(this.writer.comment(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Adds unescaped raw text
        // `value` text
        raw(value) {
            var node;
            this.openCurrent();
            node = new XMLRaw(this, value);
            this.onData(this.writer.raw(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Adds a processing instruction
        // `target` instruction target
        // `value` instruction value
        instruction(target, value) {
            var i, insTarget, insValue, len, node;
            this.openCurrent();
            if (target != null) target = getValue(target);
            if (value != null) value = getValue(value);
            if (Array.isArray(target)) for(i = 0, len = target.length; i < len; i++){
                insTarget = target[i];
                this.instruction(insTarget);
            }
            else if (isObject(target)) for(insTarget in target){
                if (!hasProp.call(target, insTarget)) continue;
                insValue = target[insTarget];
                this.instruction(insTarget, insValue);
            }
            else {
                if (isFunction(value)) value = value.apply();
                node = new XMLProcessingInstruction(this, target, value);
                this.onData(this.writer.processingInstruction(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            }
            return this;
        }
        // Creates the xml declaration
        // `version` A version number string, e.g. 1.0
        // `encoding` Encoding declaration, e.g. UTF-8
        // `standalone` standalone document declaration: true or false
        declaration(version, encoding, standalone) {
            var node;
            this.openCurrent();
            if (this.documentStarted) throw new Error("declaration() must be the first node.");
            node = new XMLDeclaration(this, version, encoding, standalone);
            this.onData(this.writer.declaration(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Creates the document type declaration
        // `root`  the name of the root node
        // `pubID` the public identifier of the external subset
        // `sysID` the system identifier of the external subset
        doctype(root, pubID, sysID) {
            this.openCurrent();
            if (root == null) throw new Error("Missing root node name.");
            if (this.root) throw new Error("dtd() must come before the root node.");
            this.currentNode = new XMLDocType(this, pubID, sysID);
            this.currentNode.rootNodeName = root;
            this.currentNode.children = false;
            this.currentLevel++;
            this.openTags[this.currentLevel] = this.currentNode;
            return this;
        }
        // Creates an element type declaration
        // `name` element name
        // `value` element content (defaults to #PCDATA)
        dtdElement(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDElement(this, name, value);
            this.onData(this.writer.dtdElement(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Creates an attribute declaration
        // `elementName` the name of the element containing this attribute
        // `attributeName` attribute name
        // `attributeType` type of the attribute (defaults to CDATA)
        // `defaultValueType` default value type (either #REQUIRED, #IMPLIED, #FIXED or
        //                    #DEFAULT) (defaults to #IMPLIED)
        // `defaultValue` default value of the attribute
        //                (only used for #FIXED or #DEFAULT)
        attList(elementName, attributeName, attributeType, defaultValueType, defaultValue) {
            var node;
            this.openCurrent();
            node = new XMLDTDAttList(this, elementName, attributeName, attributeType, defaultValueType, defaultValue);
            this.onData(this.writer.dtdAttList(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Creates a general entity declaration
        // `name` the name of the entity
        // `value` internal entity value or an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        // `value.nData` notation declaration
        entity(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, false, name, value);
            this.onData(this.writer.dtdEntity(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Creates a parameter entity declaration
        // `name` the name of the entity
        // `value` internal entity value or an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        pEntity(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDEntity(this, true, name, value);
            this.onData(this.writer.dtdEntity(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Creates a NOTATION declaration
        // `name` the name of the notation
        // `value` an object with external entity details
        // `value.pubID` public identifier
        // `value.sysID` system identifier
        notation(name, value) {
            var node;
            this.openCurrent();
            node = new XMLDTDNotation(this, name, value);
            this.onData(this.writer.dtdNotation(node, this.writerOptions, this.currentLevel + 1), this.currentLevel + 1);
            return this;
        }
        // Gets the parent node
        up() {
            if (this.currentLevel < 0) throw new Error("The document node has no parent.");
            if (this.currentNode) {
                if (this.currentNode.children) this.closeNode(this.currentNode);
                else this.openNode(this.currentNode);
                this.currentNode = null;
            } else this.closeNode(this.openTags[this.currentLevel]);
            delete this.openTags[this.currentLevel];
            this.currentLevel--;
            return this;
        }
        // Ends the document
        end() {
            while(this.currentLevel >= 0)this.up();
            return this.onEnd();
        }
        // Opens the current parent node
        openCurrent() {
            if (this.currentNode) {
                this.currentNode.children = true;
                return this.openNode(this.currentNode);
            }
        }
        // Writes the opening tag of the current node or the entire node if it has
        // no child nodes
        openNode(node) {
            var att, chunk, name, ref;
            if (!node.isOpen) {
                if (!this.root && this.currentLevel === 0 && node.type === NodeType.Element) this.root = node;
                chunk = '';
                if (node.type === NodeType.Element) {
                    this.writerOptions.state = WriterState.OpenTag;
                    chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + '<' + node.name;
                    ref = node.attribs;
                    for(name in ref){
                        if (!hasProp.call(ref, name)) continue;
                        att = ref[name];
                        chunk += this.writer.attribute(att, this.writerOptions, this.currentLevel);
                    }
                    chunk += (node.children ? '>' : '/>') + this.writer.endline(node, this.writerOptions, this.currentLevel);
                    this.writerOptions.state = WriterState.InsideTag; // if node.type is NodeType.DocType
                } else {
                    this.writerOptions.state = WriterState.OpenTag;
                    chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + '<!DOCTYPE ' + node.rootNodeName;
                    // external identifier
                    if (node.pubID && node.sysID) chunk += ' PUBLIC "' + node.pubID + '" "' + node.sysID + '"';
                    else if (node.sysID) chunk += ' SYSTEM "' + node.sysID + '"';
                    // internal subset
                    if (node.children) {
                        chunk += ' [';
                        this.writerOptions.state = WriterState.InsideTag;
                    } else {
                        this.writerOptions.state = WriterState.CloseTag;
                        chunk += '>';
                    }
                    chunk += this.writer.endline(node, this.writerOptions, this.currentLevel);
                }
                this.onData(chunk, this.currentLevel);
                return node.isOpen = true;
            }
        }
        // Writes the closing tag of the current node
        closeNode(node) {
            var chunk;
            if (!node.isClosed) {
                chunk = '';
                this.writerOptions.state = WriterState.CloseTag;
                if (node.type === NodeType.Element) chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + '</' + node.name + '>' + this.writer.endline(node, this.writerOptions, this.currentLevel); // if node.type is NodeType.DocType
                else chunk = this.writer.indent(node, this.writerOptions, this.currentLevel) + ']>' + this.writer.endline(node, this.writerOptions, this.currentLevel);
                this.writerOptions.state = WriterState.None;
                this.onData(chunk, this.currentLevel);
                return node.isClosed = true;
            }
        }
        // Called when a new chunk of XML is output
        // `chunk` a string containing the XML chunk
        // `level` current indentation level
        onData(chunk, level) {
            this.documentStarted = true;
            return this.onDataCallback(chunk, level + 1);
        }
        // Called when the XML document is completed
        onEnd() {
            this.documentCompleted = true;
            return this.onEndCallback();
        }
        // Returns debug string
        debugInfo(name) {
            if (name == null) return "";
            else return "node: <" + name + ">";
        }
        // Node aliases
        ele() {
            return this.element(...arguments);
        }
        nod(name, attributes, text) {
            return this.node(name, attributes, text);
        }
        txt(value) {
            return this.text(value);
        }
        dat(value) {
            return this.cdata(value);
        }
        com(value) {
            return this.comment(value);
        }
        ins(target, value) {
            return this.instruction(target, value);
        }
        dec(version, encoding, standalone) {
            return this.declaration(version, encoding, standalone);
        }
        dtd(root, pubID, sysID) {
            return this.doctype(root, pubID, sysID);
        }
        e(name, attributes, text) {
            return this.element(name, attributes, text);
        }
        n(name, attributes, text) {
            return this.node(name, attributes, text);
        }
        t(value) {
            return this.text(value);
        }
        d(value) {
            return this.cdata(value);
        }
        c(value) {
            return this.comment(value);
        }
        r(value) {
            return this.raw(value);
        }
        i(target, value) {
            return this.instruction(target, value);
        }
        // Attribute aliases
        att() {
            if (this.currentNode && this.currentNode.type === NodeType.DocType) return this.attList(...arguments);
            else return this.attribute(...arguments);
        }
        a() {
            if (this.currentNode && this.currentNode.type === NodeType.DocType) return this.attList(...arguments);
            else return this.attribute(...arguments);
        }
        // DTD aliases
        // att() and ele() are defined above
        ent(name, value) {
            return this.entity(name, value);
        }
        pent(name, value) {
            return this.pEntity(name, value);
        }
        not(name, value) {
            return this.notation(name, value);
        }
    };
}).call(this);

},{"4a0b6b137d547786":"ciE88","97c418eb43415d1":"jTDqp","bbdde255e9b44c2a":"bS6pz","7caa93eaeb2c96a7":"cR4iw","e6175a20b2232a77":"c2bnB","b035b3e1bd26442f":"heMmo","526deec19abea5fe":"3TALW","55ab1233b224d930":"fHsyt","d22472ac05d87f1c":"bTUB6","39cdad257f5d6100":"2xV8n","9cbc536e76baf6e7":"9ORSa","f30e4e8b2fd7fcd0":"jiQze","191528b53de83946":"48Zd0","1817e86507e2f1b4":"8NRpI","26d62c2b781ea9d6":"6ELKn","8e92d10ad0cfdf87":"7DdyK","d654416cbe0a799d":"dKezJ","bb156ac07b50c66a":"6ruW9","ba39b9e659007a91":"dP9hm"}],"hqczL":[function(require,module,exports,__globalThis) {
// Generated by CoffeeScript 2.4.1
(function() {
    var NodeType, WriterState, XMLStreamWriter, XMLWriterBase, hasProp = {}.hasOwnProperty;
    NodeType = require("2724c4fa3231a13e");
    XMLWriterBase = require("b06c90945fd90755");
    WriterState = require("f344b6746962647f");
    // Prints XML nodes to a stream
    module.exports = XMLStreamWriter = class XMLStreamWriter extends XMLWriterBase {
        // Initializes a new instance of `XMLStreamWriter`
        // `stream` output stream
        // `options.pretty` pretty prints the result
        // `options.indent` indentation string
        // `options.newline` newline sequence
        // `options.offset` a fixed number of indentations to add to every line
        // `options.allowEmpty` do not self close empty element tags
        // 'options.dontPrettyTextNodes' if any text is present in node, don't indent or LF
        // `options.spaceBeforeSlash` add a space before the closing slash of empty elements
        constructor(stream, options){
            super(options);
            this.stream = stream;
        }
        endline(node, options, level) {
            if (node.isLastRootNode && options.state === WriterState.CloseTag) return '';
            else return super.endline(node, options, level);
        }
        document(doc, options) {
            var child, i, j, k, len1, len2, ref, ref1, results;
            ref = doc.children;
            // set a flag so that we don't insert a newline after the last root level node 
            for(i = j = 0, len1 = ref.length; j < len1; i = ++j){
                child = ref[i];
                child.isLastRootNode = i === doc.children.length - 1;
            }
            options = this.filterOptions(options);
            ref1 = doc.children;
            results = [];
            for(k = 0, len2 = ref1.length; k < len2; k++){
                child = ref1[k];
                results.push(this.writeChildNode(child, options, 0));
            }
            return results;
        }
        cdata(node, options, level) {
            return this.stream.write(super.cdata(node, options, level));
        }
        comment(node, options, level) {
            return this.stream.write(super.comment(node, options, level));
        }
        declaration(node, options, level) {
            return this.stream.write(super.declaration(node, options, level));
        }
        docType(node, options, level) {
            var child, j, len1, ref;
            level || (level = 0);
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            this.stream.write(this.indent(node, options, level));
            this.stream.write('<!DOCTYPE ' + node.root().name);
            // external identifier
            if (node.pubID && node.sysID) this.stream.write(' PUBLIC "' + node.pubID + '" "' + node.sysID + '"');
            else if (node.sysID) this.stream.write(' SYSTEM "' + node.sysID + '"');
            // internal subset
            if (node.children.length > 0) {
                this.stream.write(' [');
                this.stream.write(this.endline(node, options, level));
                options.state = WriterState.InsideTag;
                ref = node.children;
                for(j = 0, len1 = ref.length; j < len1; j++){
                    child = ref[j];
                    this.writeChildNode(child, options, level + 1);
                }
                options.state = WriterState.CloseTag;
                this.stream.write(']');
            }
            // close tag
            options.state = WriterState.CloseTag;
            this.stream.write(options.spaceBeforeSlash + '>');
            this.stream.write(this.endline(node, options, level));
            options.state = WriterState.None;
            return this.closeNode(node, options, level);
        }
        element(node, options, level) {
            var att, attLen, child, childNodeCount, firstChildNode, j, len, len1, name, prettySuppressed, r, ratt, ref, ref1, ref2, rline;
            level || (level = 0);
            // open tag
            this.openNode(node, options, level);
            options.state = WriterState.OpenTag;
            r = this.indent(node, options, level) + '<' + node.name;
            // attributes
            if (options.pretty && options.width > 0) {
                len = r.length;
                ref = node.attribs;
                for(name in ref){
                    if (!hasProp.call(ref, name)) continue;
                    att = ref[name];
                    ratt = this.attribute(att, options, level);
                    attLen = ratt.length;
                    if (len + attLen > options.width) {
                        rline = this.indent(node, options, level + 1) + ratt;
                        r += this.endline(node, options, level) + rline;
                        len = rline.length;
                    } else {
                        rline = ' ' + ratt;
                        r += rline;
                        len += rline.length;
                    }
                }
            } else {
                ref1 = node.attribs;
                for(name in ref1){
                    if (!hasProp.call(ref1, name)) continue;
                    att = ref1[name];
                    r += this.attribute(att, options, level);
                }
            }
            this.stream.write(r);
            childNodeCount = node.children.length;
            firstChildNode = childNodeCount === 0 ? null : node.children[0];
            if (childNodeCount === 0 || node.children.every(function(e) {
                return (e.type === NodeType.Text || e.type === NodeType.Raw || e.type === NodeType.CData) && e.value === '';
            })) {
                // empty element
                if (options.allowEmpty) {
                    this.stream.write('>');
                    options.state = WriterState.CloseTag;
                    this.stream.write('</' + node.name + '>');
                } else {
                    options.state = WriterState.CloseTag;
                    this.stream.write(options.spaceBeforeSlash + '/>');
                }
            } else if (options.pretty && childNodeCount === 1 && (firstChildNode.type === NodeType.Text || firstChildNode.type === NodeType.Raw || firstChildNode.type === NodeType.CData) && firstChildNode.value != null) {
                // do not indent text-only nodes
                this.stream.write('>');
                options.state = WriterState.InsideTag;
                options.suppressPrettyCount++;
                prettySuppressed = true;
                this.writeChildNode(firstChildNode, options, level + 1);
                options.suppressPrettyCount--;
                prettySuppressed = false;
                options.state = WriterState.CloseTag;
                this.stream.write('</' + node.name + '>');
            } else {
                this.stream.write('>' + this.endline(node, options, level));
                options.state = WriterState.InsideTag;
                ref2 = node.children;
                // inner tags
                for(j = 0, len1 = ref2.length; j < len1; j++){
                    child = ref2[j];
                    this.writeChildNode(child, options, level + 1);
                }
                // close tag
                options.state = WriterState.CloseTag;
                this.stream.write(this.indent(node, options, level) + '</' + node.name + '>');
            }
            this.stream.write(this.endline(node, options, level));
            options.state = WriterState.None;
            return this.closeNode(node, options, level);
        }
        processingInstruction(node, options, level) {
            return this.stream.write(super.processingInstruction(node, options, level));
        }
        raw(node, options, level) {
            return this.stream.write(super.raw(node, options, level));
        }
        text(node, options, level) {
            return this.stream.write(super.text(node, options, level));
        }
        dtdAttList(node, options, level) {
            return this.stream.write(super.dtdAttList(node, options, level));
        }
        dtdElement(node, options, level) {
            return this.stream.write(super.dtdElement(node, options, level));
        }
        dtdEntity(node, options, level) {
            return this.stream.write(super.dtdEntity(node, options, level));
        }
        dtdNotation(node, options, level) {
            return this.stream.write(super.dtdNotation(node, options, level));
        }
    };
}).call(this);

},{"2724c4fa3231a13e":"jTDqp","b06c90945fd90755":"2g2zB","f344b6746962647f":"dP9hm"}],"e43Gj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadBlob", ()=>downloadBlob);
function downloadBlob(filename, blob) {
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lGcYj":[function(require,module,exports,__globalThis) {
/*! save-csv v4.1.0 | (c) silverwind | BSD license */ (function(root, m) {
    if (typeof define === "function" && define.amd) define([], m);
    else if (0, module.exports) module.exports = m();
    else root.saveCsv = m();
})(typeof self !== "undefined" ? self : this, function() {
    "use strict";
    return function(arr, opts) {
        if (!Array.isArray(arr) || !arr.length) throw new Error("Expected an array of values, got " + arr);
        opts = opts || {};
        opts.filename = opts.filename || "export.csv";
        opts.sep = opts.sep || "auto";
        opts.eol = opts.eol || "\r\n";
        opts.bom = typeof opts.bom === "boolean" ? opts.bom : true;
        opts.quote = opts.quote || '"';
        opts.mime = opts.mime || "text/csv;charset=utf-8";
        // This is not ideal, but given that Array.prototype.toLocaleString is
        // rather unreliable, it's a good compromise.
        // https://bugzilla.mozilla.org/show_bug.cgi?id=1388777
        // https://bugs.chromium.org/p/chromium/issues/detail?id=753841
        if (opts.sep === "auto") {
            if ("toLocaleString" in Number.prototype) opts.sep = 1.2.toLocaleString().substring(1, 2) === "," ? ";" : ",";
            else opts.sep = ",";
        }
        var quoteRe = new RegExp(opts.quote, "g");
        var sepRe = new RegExp(opts.sep, "g");
        opts.formatter = opts.formatter || function(value) {
            var quoted = false;
            if (typeof value !== "string") value = JSON.stringify(value) || "";
            // escape quotes by doubling the quotes and wrapping in quotes
            if (quoteRe.test(value)) {
                value = opts.quote + value.replace(quoteRe, opts.quote + opts.quote) + opts.quote;
                quoted = true;
            }
            // escape separator by wrapping in quotes
            if (sepRe.test(value) && !quoted) value = opts.quote + value + opts.quote;
            return value;
        };
        // build headers from first element in array
        var paths = [];
        (function scan(prefix, obj, keys) {
            keys.forEach(function(key) {
                var path = prefix ? prefix + "." + key : key;
                if (typeof obj[key] === "object" && obj[key] !== null) scan(path, obj[key], Object.keys(obj[key]));
                else paths.push(opts.formatter(path));
            });
        })(null, arr[0], Object.keys(arr[0]));
        var header = paths.join(opts.sep) + opts.eol;
        // build body
        var body = arr.map(function(obj) {
            var row = [];
            (function scan(obj, keys) {
                keys.forEach(function(key) {
                    if (typeof obj[key] === "object" && obj[key] !== null) scan(obj[key], Object.keys(obj[key]));
                    else row.push(opts.formatter(obj[key]));
                });
            })(obj, Object.keys(obj));
            return row.join(opts.sep);
        }).join(opts.eol);
        // build a link and trigger a download
        var text = header + body;
        var blob = new Blob([
            opts.bom ? "\ufeff" + text : text
        ]);
        if (window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(blob, opts.filename);
        else {
            var a = document.createElement("a");
            a.setAttribute("href", URL.createObjectURL(blob, {
                type: opts.mime
            }));
            a.setAttribute("download", opts.filename);
            a.setAttribute("target", "_blank");
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
                document.body.removeChild(a);
            }, 0);
        }
    };
});

},{}],"8FZw3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckboxList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
function CheckboxList(props) {
    const { options, canSelectAll, selectAllLabel, checked, handleToggle, handleSelectAll, mapLabel = (o)=>o.label, mapValue = (o)=>o.value, Secondary, Text, disabled } = props;
    const allSelected = checked.length == options.length;
    const someSelected = !allSelected && checked.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.List), {
        className: "checkboxlist",
        children: [
            canSelectAll && options.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.ListItem), {
                role: undefined,
                dense: true,
                onClick: ()=>handleSelectAll(allSelected ? [] : options.map((o)=>mapValue(o))),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemIcon), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                            disabled: disabled,
                            edge: "start",
                            checked: allSelected,
                            indeterminate: someSelected,
                            tabIndex: -1,
                            disableRipple: true,
                            inputProps: {
                                'aria-labelledby': 'checkbox-list-label-selectAll'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                        id: "checkbox-list-label-selectAll",
                        primary: selectAllLabel
                    })
                ]
            }),
            options.map((option)=>{
                const label = mapLabel(option);
                const value = mapValue(option);
                const labelId = `checkbox-list-label-${value}`;
                const selected = checked.indexOf(value) !== -1;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.ListItem), {
                    role: undefined,
                    dense: true,
                    className: (0, _material.clsx)('checkboxlist-item', {
                        selected
                    }),
                    onClick: ()=>!disabled && handleToggle(value, option),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemIcon), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                                disabled: disabled,
                                edge: "start",
                                checked: selected,
                                tabIndex: -1,
                                disableRipple: true,
                                inputProps: {
                                    'aria-labelledby': labelId
                                }
                            })
                        }),
                        !Text && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                            id: labelId,
                            primary: label
                        }),
                        Text && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Text, {
                            option: option
                        }),
                        Secondary && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Secondary, {
                            option: option
                        })
                    ]
                }, value);
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hPYEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ToggleExportFormat);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _fontAwesome = require("external/font-awesome");
var _fontAwesomeDefault = parcelHelpers.interopDefault(_fontAwesome);
var _material = require("external/material");
const validFormats = [
    "xlsx",
    "csv"
];
const formatIcons = {
    xlsx: 'faFileExcel',
    csv: 'faFileCsv'
};
const StyledTogleExportFormat = (0, _material.styled)((0, _material.ToggleButtonGroup))(toogleExportFormats);
function ToggleExportFormat(props) {
    const { format, handleFormatChange, translate } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTogleExportFormat, {
        color: "primary",
        value: format,
        exclusive: true,
        onChange: (_, format)=>handleFormatChange(format),
        "aria-label": "Platform",
        children: validFormats.map((value, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.ToggleButton), {
                className: "button",
                value: value,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "label",
                        children: translate(`export-rollbook-format-${value}`)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fontAwesomeDefault.default), {
                            name: formatIcons[value]
                        })
                    })
                ]
            }, index))
    });
}
function toogleExportFormats() {
    return {
        "& .button": {
            padding: "5px 15px",
            "& .label": {
                textTransform: 'capitalize',
                marginRight: 8,
                fontSize: '12pt'
            },
            "& .icon": {
                fontSize: '18px'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/font-awesome":"9El8q","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9El8q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
const icons = {
    faFileExcel: (0, _freeSolidSvgIcons.faFileExcel),
    faFileCsv: (0, _freeSolidSvgIcons.faFileCsv)
};
function Icon({ name }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
        icon: icons[name]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","@fortawesome/react-fontawesome":"32SD5","@fortawesome/free-solid-svg-icons":"joPR3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dKOOM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _searchPattern = require("components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _chip = require("./Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
var _gradeFilter = require("./GradeFilter");
var _gradeFilterDefault = parcelHelpers.interopDefault(_gradeFilter);
var _selectGroup = require("./SelectGroup");
var _selectGroupDefault = parcelHelpers.interopDefault(_selectGroup);
var _periodFilter = require("./PeriodFilter");
var _periodFilterDefault = parcelHelpers.interopDefault(_periodFilter);
var _addExternalGrade = require("../AddExternalGrade");
var _addExternalGradeDefault = parcelHelpers.interopDefault(_addExternalGrade);
var _leyend = require("./Leyend");
var _leyendDefault = parcelHelpers.interopDefault(_leyend);
const StyledFilters = (0, _material.styled)((0, _material.Box))(filterStyles);
function GradeFilters(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, link, groupId, translate } = context;
    const isDreyfous = context.profile.domain === 'dreyfous' || context.profile.domain === 'dreyfous-dg';
    const path = link({
        page: 'gradebook',
        groupId
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledFilters, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                className: (0, _material.clsx)('filter-row', 'group'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _material.clsx)('container', 'select-group'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectGroupDefault.default), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        sx: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _material.clsx)('container', 'add-external-grade'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addExternalGradeDefault.default), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                className: (0, _material.clsx)('filter-row', 'period'),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        className: (0, _material.clsx)('container', 'select-period'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _periodFilterDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradeFilterDefault.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        sx: {
                            flexGrow: 1
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        sx: {
                            display: 'flex',
                            gap: '16px',
                            marginRight: '16px'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leyendDefault.default), {
                                color: "rgba(234, 185, 237, 1)",
                                label: translate('adjust-grade')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _leyendDefault.default), {
                                color: "rgba(205, 240, 192, 1)",
                                label: translate('manual-grade')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _material.clsx)('container', 'chips'),
                        children: query.pattern && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
                            name: "pattern",
                            path: path
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: (0, _material.clsx)('container', 'pattern'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                            path: path,
                            context: context
                        })
                    })
                ]
            })
        ]
    });
}
function filterStyles() {
    return {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        "& .filter-row": {
            display: 'flex',
            padding: '15px 0',
            justifyContent: 'center',
            alignItems: 'center',
            "&.period": {
                border: 'solid 1px #dbe3e6',
                borderBottom: 0,
                borderRadius: 4,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                padding: 15
            }
        },
        "& .container": {
            display: 'flex',
            gap: '16px',
            // flexDirection: 'column',
            justifyContent: 'center',
            "&.export-group": {
                marginLeft: 11
            }
        },
        "& .chips": {
            display: "flex",
            flexDirection: "column",
            justifyContent: 'center',
            marginRight: 10,
            '& .filter-chip': {
                backgroundColor: '#de3434',
                color: '#fff',
                '& .MuiChip-label': {
                    padding: '0 20px'
                },
                '& .MuiChip-deleteIcon': {}
            }
        },
        "& .pattern": {
            border: 'solid 1px #bec4d2',
            display: 'flex',
            flexWrap: 'nowrap',
            borderRadius: '5px',
            backgroundColor: '#fff',
            padding: 0,
            height: '38px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","components/search-pattern":"lUZFT","./Chip":"gZWbh","./GradeFilter":"aTzgN","./SelectGroup":"9VotH","./PeriodFilter":"7lK2g","../AddExternalGrade":"jIGzl","./Leyend":"lvwQX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gZWbh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilterChip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
function FilterChip(props) {
    const history = (0, _react.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { name, createLabel = (a)=>a, path } = props;
    const label = createLabel(context.query[name]);
    function handleDelete() {
        history.push(context.linkQuery(path, {
            ...context.query,
            [name]: undefined
        }));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Chip), {
        label: label,
        onDelete: handleDelete,
        className: "filter-chip"
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aTzgN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
var _react = require("external/react");
var _context = require("teacher/context");
const StyledSelect = (0, _material.styled)((0, _material.FormControl))(selectStyles);
const baseFilters = [
    {
        name: 'all',
        value: 'all'
    },
    {
        name: 'manual-grade',
        value: 'manual'
    },
    {
        name: 'adjust-grade',
        value: 'adjust'
    },
    {
        name: 'homework',
        value: 'homework'
    },
    {
        name: 'test',
        value: 'test'
    },
    {
        name: 'short-test',
        value: 'quiz'
    },
    {
        name: 'practice',
        value: 'practice'
    }
];
const GradeFilter = ()=>{
    const history = (0, _react.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { link, linkQuery, periodTypesMap, groupId, query, translate } = context;
    const { gradeFilter: queryFilters } = query;
    const queryFiltersValue = queryFilters ?? [];
    const [filters, setFilters] = (0, _react.useState)(Array.isArray(queryFiltersValue) ? queryFiltersValue : [
        queryFiltersValue
    ]);
    // const {items, loaded} = context.rollbookContextPeriods
    const handleGradeFilterChange = (event)=>{
        const { value: gradeFilter } = event.target;
        if (gradeFilter.includes('all')) {
            const allFilters = baseFilters.map((val)=>val.value);
            setFilters(allFilters);
            history.push(linkQuery(link({
                groupId
            }), {
                gradeFilter: allFilters
            }));
            return;
        }
        if (!gradeFilter.includes('all') && filters.includes('all')) {
            setFilters([]);
            history.push(linkQuery(link({
                groupId
            }), {
                gradeFilter: []
            }));
            return;
        }
        setFilters(gradeFilter);
        history.push(linkQuery(link({
            groupId
        }), {
            gradeFilter
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSelect, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Select), {
            multiple: true,
            variant: "outlined",
            onChange: handleGradeFilterChange,
            value: filters,
            IconComponent: (0, _material.ArrowDropDownIcon),
            renderValue: (selected)=>selected.filter((val)=>val !== 'all').join(', '),
            children: baseFilters.map((period, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.MenuItem), {
                    value: period.value,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                            checked: filters.includes(period.value)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ListItemText), {
                            primary: translate(period.name)
                        })
                    ]
                }, index))
        })
    });
};
function selectStyles() {
    return {
        "& > .MuiInputBase-root": {
            width: 150,
            height: 40
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","external/react":"k16GP","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9VotH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
const StyledSelectGroup = (0, _material.styled)((0, _material.Box))(groupStyles);
function SelectGroup() {
    const history = (0, _react.useHistory)();
    const { link, linkQuery, groups, groupId } = (0, _react.useContext)((0, _context.TeacherContext));
    const handleGroupChange = (0, _react.useCallback)((event)=>{
        history.push(linkQuery(link({
            groupId: event.target.value
        }), {}));
    }, []);
    const group = groups.length > 0 && groupId == undefined ? groups[0].id : groupId;
    const value = groups.length == 0 || group == undefined ? '' : group;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledSelectGroup, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: (0, _material.clsx)('container', 'icon'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FAIcon), {
                    icon: "users"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: (0, _material.clsx)('container', 'select'),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Select), {
                    onChange: handleGroupChange,
                    value: value,
                    IconComponent: (0, _material.ArrowDropDownIcon),
                    children: groups.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                            value: group.id,
                            children: group.name
                        }, group.id))
                })
            })
        ]
    });
}
function groupStyles() {
    return {
        display: 'flex',
        color: '#4f576e',
        fontWeight: 'bold',
        '&:focus': {
            backgroundColor: 'transparent'
        },
        "& .container": {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            "&.icon": {
                color: '#4f576e',
                fontWeight: 'bold',
                color: '#3295ce',
                width: '50px !important',
                fontSize: 24,
                marginRight: 12
            },
            "&.select": {
                "& > .MuiInputBase-root": {
                    width: 250,
                    height: 40
                },
                '& .MuiInput-underline:before': {
                    content: 'none',
                    border: 'none'
                },
                '& .MuiInput-underline:after': {
                    content: 'none',
                    border: 'none'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7lK2g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectPeriod);
var _jsxRuntime = require("react/jsx-runtime");
var _dateFns = require("external/date-fns");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
const StyledSelect = (0, _material.styled)((0, _material.FormControl))(selectStyles);
function SelectPeriod() {
    const history = (0, _react.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { link, linkQuery, periodTypesMap, groupId, query, translate } = context;
    const { items, loaded } = context.rollbookContextPeriods;
    const periods = items.map((period, i)=>({
            ...period,
            name: `${translate(periodTypesMap[period.type])} ${i + 1}`
        }));
    const { periodId } = query;
    const handlePeriodChange = (event)=>{
        const { value: periodId } = event.target;
        history.push(linkQuery(link({
            groupId
        }), {
            periodId
        }));
    };
    const selectedPeriod = periods.length == 0 ? '' : periodId || (periods.find(({ start, finish })=>(0, _dateFns.isWithinInterval)(new Date(), {
            start,
            end: finish
        })) || {}).id || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledSelect, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Select), {
            variant: "outlined",
            onChange: handlePeriodChange,
            value: selectedPeriod,
            IconComponent: (0, _material.ArrowDropDownIcon),
            children: periods.map((period, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                    value: period.id,
                    children: period.name
                }, index))
        })
    });
}
function selectStyles() {
    return {
        "& > .MuiInputBase-root": {
            width: 200,
            height: 40
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/date-fns":"kwxNe","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jIGzl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddExternalGrade);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _context = require("teacher/context");
const AddButton = (0, _material.styled)((0, _material.Button))(()=>({
        backgroundColor: '#2ca5ec',
        width: 150,
        textTransform: 'none',
        fontSize: '12pt',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#0069d9',
            borderColor: '#0062cc',
            boxShadow: 'none'
        }
    }));
function AddExternalGrade() {
    const { translate, updateState } = (0, _react.useContext)((0, _context.TeacherContext));
    function handleClick() {
        updateState({
            rollbookContextGradingDialogs: {
                'add-external-grade': {
                    $set: true
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddButton, {
                "aria-haspopup": "true",
                variant: "contained",
                color: "primary",
                onClick: handleClick,
                startIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.AddIcon), {}),
                children: translate('add-grade')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {})
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","./Form":"iWkdP","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iWkdP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddExternalGradeForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _formHook = require("helpers/form-hook");
var _formHookDefault = parcelHelpers.interopDefault(_formHook);
var _responsiveFullscreenDialog = require("components/responsive-fullscreen-dialog");
var _responsiveFullscreenDialogDefault = parcelHelpers.interopDefault(_responsiveFullscreenDialog);
var _validationsHook = require("helpers/validations-hook");
var _validationsHookDefault = parcelHelpers.interopDefault(_validationsHook);
var _command = require("helpers/command");
var _gradebook = require("helpers/gradebook");
var _validations = require("helpers/validations");
var _dateFns = require("external/date-fns");
var _textInput = require("./TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _context = require("teacher/context");
const initialState = {
    attempted: false,
    type: '',
    title: '',
    value: '',
    date: ''
};
const validations = {
    title: [
        (0, _validations.requiredTextAfterAttempt)('title', 'required-external-grade-name')
    ],
    value: [
        (0, _validations.requiredTextAfterAttempt)('value', 'required-external-grade-value')
    ],
    type: [
        ({ attempted, type })=>{
            return !attempted || type != '' ? '' : 'required-external-grade-type';
        }
    ]
};
Object.entries((0, _dateFns.locales)).forEach(([languages, locale])=>(0, _react.registerDatePickerLocale)(languages, locale));
const StyledForm = (0, _material.styled)((0, _responsiveFullscreenDialogDefault.default))(formStyles);
function AddExternalGradeForm(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, groupId, gradingCategories, translate, updateState, rollbookContextGradingDialogs: gradingDialogs, languageId } = context;
    const { items: periods } = context.rollbookContextPeriods;
    const [periodName, periodStart, periodFinish] = (0, _react.useMemo)(()=>{
        const period = (0, _gradebook.getSelectedPeriod)(periods, query.periodId);
        if (!period) return [
            '',
            false,
            false
        ];
        return [
            period.properties.name,
            (0, _dateFns.parseDate)(period.start),
            (0, _dateFns.parseDate)(period.finish)
        ];
    }, [
        periods,
        query.periodId
    ]);
    const isOpen = gradingDialogs['add-external-grade'];
    const { state, setState, handleChange, resetState } = (0, _formHookDefault.default)(initialState);
    const { errors, validate, resetErrors } = (0, _validationsHookDefault.default)(validations);
    function closeDialog(refresh) {
        const command = refresh ? {
            rollbookContextGradingDialogs: {
                'add-external-grade': {
                    $set: false
                }
            },
            rollbookContextGradeColumns: {
                refreshes: {
                    $apply: (i)=>i + 1
                }
            }
        } : {
            rollbookContextGradingDialogs: {
                'add-external-grade': {
                    $set: false
                }
            }
        };
        updateState(command);
        resetState();
        resetErrors();
    }
    async function addExternalGrade() {
        if (validate({
            ...state,
            attempted: true
        })) try {
            const [created] = await (0, _command.createPost)('grading', 'addExternalGrade')({
                clique: groupId,
                title: state.title,
                category: state.type,
                value: parseInt(state.value),
                date: state.date
            });
            if (created) closeDialog(true);
            else setState({
                ...state,
                attempted: true
            });
        } catch (e) {}
        else setState({
            ...state,
            attempted: true
        });
    }
    const assignDate = (newDate)=>{
        setState({
            ...state,
            date: newDate
        });
    };
    const getValueErrorMessage = ()=>{
        if (state.value && parseInt(state.value) < 0) return translate('value-not-in-range', {
            min: 0
        });
        return errors.value.length > 0 ? translate(errors.value) : '';
    };
    (0, _react.React).useEffect(()=>{
        validate(state);
    }, [
        state
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledForm, {
        open: isOpen,
        close: closeDialog,
        actionsClassName: "actions",
        confirm: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
            variant: "contained",
            className: (0, _material.clsx)("button", "create"),
            onClick: addExternalGrade,
            children: translate('add-grade')
        }),
        cancel: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
            variant: "contained",
            className: (0, _material.clsx)("button", "cancel"),
            onClick: ()=>closeDialog(false),
            children: translate('cancel')
        }),
        title: translate('add-external-grade-dialog-title'),
        subtitle: periodName,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
            className: "root",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    className: (0, _material.clsx)("field", "title"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        customClassName: "box-field-input",
                        controlMargin: "dense",
                        inputPlaceholder: "Ej. Proyecto final",
                        id: "title",
                        inputAutoComplete: "title",
                        labelRequired: true,
                        inputAutoFocus: true,
                        caption: translate('title'),
                        value: state.title,
                        inputOnChange: handleChange('title'),
                        controlError: errors.title.length > 0,
                        errorMessage: errors.title.length > 0 ? translate(errors.title) : undefined
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    className: (0, _material.clsx)("field", "type"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                        controlFullWidth: true,
                        controlVariant: "outlined",
                        customClassName: "box-field-input",
                        controlMargin: "dense",
                        id: "type",
                        labelRequired: true,
                        caption: translate('type_label'),
                        selectValue: state.type,
                        selectOnChange: handleChange('type', (e)=>parseInt(e.target.value)),
                        controlError: errors.type.length > 0,
                        errorMessage: errors.type.length > 0 ? translate(errors.type) : undefined,
                        mapValue: (o)=>o.id,
                        mapText: (o)=>translate(`${o.name}-label`),
                        options: gradingCategories
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    className: (0, _material.clsx)("field", "value"),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                        controlFullWidth: true,
                        customClassName: "box-field-input",
                        controlVariant: "outlined",
                        controlMargin: "dense",
                        inputPlaceholder: "0",
                        inputendAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.InputAdornment), {
                            position: "end",
                            children: "pts"
                        }),
                        labelRequired: true,
                        id: "value",
                        inputAutoComplete: "value",
                        caption: translate('value'),
                        value: state.value,
                        inputOnChange: (e)=>{
                            if (isNaN(e.target.value)) return;
                            handleChange('value')(e);
                        },
                        controlError: errors.value.length > 0 || getValueErrorMessage() !== '',
                        errorMessage: getValueErrorMessage()
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                    className: (0, _material.clsx)("field", "date"),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            className: "label",
                            children: translate('date')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.DatePicker), {
                            customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.CustomDateInput), {}),
                            selected: state.date || periodStart,
                            onChange: assignDate,
                            minDate: periodStart,
                            maxDate: periodFinish,
                            locale: languageId,
                            popperPlacement: "auto-start"
                        })
                    ]
                })
            ]
        })
    });
}
function formStyles() {
    return {
        '& .MuiDialog-paper': {
            padding: '24px',
            width: '410px',
            boxSizing: 'border-box'
        },
        '& .MuiDialogContent-root': {
            marginTop: '18px',
            padding: 0
        },
        '& .field.date': {
            gap: '4px',
            display: 'flex',
            flexDirection: 'column'
        },
        '& .MuiDialogActions-root': {
            gap: '8px',
            marginTop: '40px',
            padding: 0
        },
        '& .root': {
            gap: '12px',
            display: 'flex',
            flexDirection: 'column'
        },
        '& .MuiInputBase-input': {
            height: '35px',
            boxSizing: 'border-box'
        },
        '& .MuiSelect-select': {
            height: '35px',
            boxSizing: 'border-box',
            padding: '6px 10px'
        },
        '& .label': {
            color: '#374151',
            fontSize: '14px',
            fontWeight: 500
        },
        '& .box-field-input': {
            gap: '4px',
            display: 'flex',
            flexDirection: 'column'
        },
        '& .MuiTypography-root': {
            padding: 0
        },
        '& .button': {
            boxShadow: 'none',
            textTransform: 'none'
        },
        '& .cancel': {
            backgroundColor: 'white',
            color: 'black',
            border: '1px solid #a7aaaf'
        },
        "& .date-input": {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            cursor: 'pointer',
            paddingLeft: '10px',
            border: 'solid 1px #b8c1c7',
            height: '35px',
            boxSizing: 'border-box',
            borderRadius: '4px'
        }
    };
// const verticalCentering = {
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'center'
// }
// return {
//   "& .date-input": {
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     cursor: 'pointer',
//     width: '110px',
//     padding: 0,
//     textAlign: 'center',
//     border: 'solid 1px #b8c1c7',
//     height: '28px'
//   },
//   "& .root": {
//     display: 'flex',
//     flexDirection: 'column',
//   },
//   "& .field": {
//     flexGrow: 1,
//     display: 'flex',
//     marginBottom: 25,
//     minWidth: 500,
//     "& > div": {
//       display: 'flex',
//       flexGrow: 1,
//       "& .label": {
//         width: 90,
//         fontSize: '12pt',
//         fontWeight: 'bold',
//         color: '#878ea1',
//         ...verticalCentering
//       },
//       "& .input": {
//         flexGrow: 1,
//         ...verticalCentering,
//         "& input": {
//           borderRadius: 4,
//           border: 'solid 1px #aab7bf !important',
//         },
//         "& .select": {
//           "& .MuiInput-underline:before": {
//             content: 'none',
//             border: 'none'
//           },
//           "& .MuiSelect-select": {
//             border: 'solid 1px #aab7bf',
//             borderRadius: 4,
//             padding: 10,
//             paddingRight: 24
//           },
//         }
//       }
//     }
//   },
//   "& .button": {
//     width: 150,
//     fontSize: "13pt",
//     textTransform: "none",
//     boxShadow: 'none',
//     borderRadius: 4,
//     "&:first-of-type": {
//       marginRight: 10
//     },
//     "&:last-child": {
//       marginLeft: 10
//     },
//     "&.cancel": {
//       border: "solid 1px #3d4556",
//       backgroundColor: '#fff',
//       color: "#3d4556",
//       '&:hover': {
//         color: "#000",
//         border: "solid 1px #000",
//         backgroundColor: '#eaf5ff',
//       },
//     },
//     "&.create" : {
//       color: "#fff",
//       border: 'solid 1px #1d9be5',
//       backgroundColor: '#1d9be5',
//       '&:hover': {
//         backgroundColor: '#29739f',
//         borderColor: '#29739f',
//         boxShadow: 'none',
//       },
//     }
//   },
//   "& .actions": {
//     padding: '8px 24px 30px 24px',
//   }
// }
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/form-hook":"8O4Ar","components/responsive-fullscreen-dialog":"9pRHY","helpers/validations-hook":"r624y","helpers/command":"f3cbG","helpers/gradebook":"6ehCA","helpers/validations":"lg1Ji","external/date-fns":"kwxNe","./TextInput":"lgpF3","./Select":"7PIKy","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lgpF3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _utils = require("helpers/utils");
const StyledTextInput = (0, _material.styled)((0, _material.Box))(textStyles);
function TextInput(props) {
    const errorId = `${props.id}-error-text`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledTextInput, {
        className: props?.customClassName ?? '',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "label",
                children: props.caption
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.FormControl), {
                    ...(0, _utils.pickAttributes)(props, 'control'),
                    className: "control",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.OutlineInput), {
                            id: props.id,
                            "aria-describedby": errorId,
                            value: props.value,
                            ...(0, _utils.pickAttributes)(props, 'input'),
                            className: "input"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormHelperText), {
                            id: errorId,
                            ...(0, _utils.pickAttributes)(props, 'error'),
                            children: props.errorMessage
                        })
                    ]
                })
            })
        ]
    });
}
function textStyles() {
    return {
        "& .control": {
            margin: 0,
            flexGrow: 1
        },
        "& .input": {
            "& input": {
                padding: 10
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7PIKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _utils = require("helpers/utils");
const StyledSelect = (0, _material.styled)((0, _material.Box))(selectStyles);
function Select(props) {
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    const errorId = `${props.id}-error-text`;
    const labelId = `${props.id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledSelect, {
        className: props?.customClassName ?? '',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "label",
                children: props.caption
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "input",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.FormControl), {
                    ...controlAttributes,
                    className: "control",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Select), {
                            labelId: labelId,
                            id: props.id,
                            ...selectAttributes,
                            className: "select",
                            children: props.options.map((option, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                                    value: props.mapValue(option),
                                    children: props.mapText(option)
                                }, key))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormHelperText), {
                            id: errorId,
                            ...(0, _utils.pickAttributes)(props, 'error'),
                            children: props.errorMessage
                        })
                    ]
                })
            })
        ]
    });
}
function selectStyles(theme) {
    return {
        "& .control": {
            margin: 0,
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lvwQX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Leyend);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
const StyledBox = (0, _material.styled)((0, _material.Box))(leyendStyles);
const Leyend = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _material.clsx)('circle-leyend')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: (0, _material.clsx)('label-leyend'),
                children: props.label
            })
        ]
    });
};
function leyendStyles(props) {
    const { theme, ...rest } = props;
    const { color } = rest;
    return {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        '& .circle-leyend': {
            backgroundColor: color,
            height: '17px',
            width: '17px',
            borderRadius: '100%'
        },
        '& .label-leyend': {
            color: 'rgba(0,0,0,0.5)'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dYdgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradesHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _dayjs = require("external/dayjs");
var _context = require("teacher/context");
var _headerOptions = require("./HeaderOptions");
var _headerOptionsDefault = parcelHelpers.interopDefault(_headerOptions);
const StyledTableHead = (0, _material.styled)((0, _material.TableHead))(tableHeadStyles);
function GradesHead(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { columns, createSortHandler, orderBy } = props;
    const { translate, query } = context;
    const { gradeFilter: queryGradeFilters } = query;
    const filterGrades = (column)=>{
        const queryFiltersValue = queryGradeFilters ?? [];
        const queryFilters = Array.isArray(queryFiltersValue) ? queryFiltersValue : [
            queryFiltersValue
        ];
        if (queryFilters.includes('all') || queryFilters.length === 0) return true;
        const dateAssigned = (0, _dayjs.dayjs)(new Date(column.date));
        const creationDate = (0, _dayjs.dayjs)(new Date(column.start));
        if (queryFilters.includes(column.type)) return true;
        const isManual = dateAssigned.isAfter(creationDate);
        const isAdjust = dateAssigned.isBefore(creationDate);
        if (isManual && queryFilters.includes('manual')) return true;
        if (isAdjust && queryFilters.includes('adjust')) return true;
        return false;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableHead, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.TableRow), {
            className: "headersRow",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCell, {
                    id: "student-name-cell",
                    description: translate('student'),
                    sortDirection: orderBy.order,
                    activeSort: orderBy.column == 'student',
                    sortHandler: createSortHandler('student'),
                    cellClass: "student",
                    labelClass: "studentLabel",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: translate('student')
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCell, {
                    id: "global-summary-cell",
                    align: "center",
                    description: translate('grade-summary-header'),
                    sortDirection: orderBy.order,
                    activeSort: orderBy.column == 'summary',
                    sortHandler: createSortHandler('summary'),
                    cellClass: "summary",
                    labelClass: "summaryLabel",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: translate('grade-summary-header')
                    })
                }),
                columns.filter(filterGrades).map((column)=>{
                    const creationDate = (0, _dayjs.dayjs)(new Date(column.start));
                    const dateAssigned = (0, _dayjs.dayjs)(new Date(column.date || column.start));
                    const description = `${column.title} [${dateAssigned.format('MM/DD/YYYY')}]`;
                    const isExternal = Boolean(column?.external);
                    const classNameDate = dateAssigned.isBefore(creationDate) ? 'gradeLabelPastDate' : 'gradeLabelPresentDate';
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCell, {
                        id: `${column.label}-cell`,
                        description: description,
                        sortDirection: orderBy.order,
                        activeSort: orderBy.column == column.label,
                        sortHandler: createSortHandler(column.label),
                        cellClass: "grade",
                        labelClass: `gradeLabel ${isExternal ? classNameDate : ''}`,
                        column: column,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "gradeText",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "gradeName",
                                    children: column.label
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "gradeTotal",
                                    children: column.total
                                })
                            ]
                        })
                    }, column.id);
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TableCell), {
                    className: "filler",
                    style: {
                        top: 92
                    },
                    align: "right"
                })
            ]
        })
    });
}
function TableCell(props) {
    const { align, disablePadding, description, sortDirection, activeSort, sortHandler, column, cellClass, labelClass, containerClass } = props;
    const { properties: { ignore } } = column || {
        properties: {
            ignore: false
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TableCell), {
        align: align || 'left',
        padding: disablePadding ? 'none' : 'normal',
        className: (0, _material.clsx)("headerCell", cellClass),
        sortDirection: sortDirection,
        style: {
            top: 92
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _material.clsx)("container", {
                ignore
            }),
            children: [
                column && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _headerOptionsDefault.default), {
                    column
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "cellContainer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TableSortLabel), {
                        className: labelClass,
                        active: activeSort,
                        direction: sortDirection,
                        onClick: sortHandler,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Tooltip), {
                            title: description,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: (0, _material.clsx)("label", containerClass),
                                children: [
                                    props.children,
                                    activeSort && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "visuallyHidden"
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}
function tableHeadStyles() {
    return {
        "& .gradeName": {
            fontWeight: 'bold'
        },
        "& .gradeText": {
            display: 'flex',
            flexDirection: 'column'
        },
        "& .center": {
            textAlign: 'center'
        },
        "& .headersRow": {
            color: '#50566e',
            '& > th': {
                borderTop: 'solid 1px #d8dbe0',
                backgroundColor: '#f1faff'
            }
        },
        "& .headerCell": {
            padding: 0,
            color: '#4f576e',
            fontWeight: 'bold',
            borderLeft: 'solid 1px #d8dbe0',
            borderRight: 'solid 1px #d8dbe0',
            '&:first-of-type': {
                borderLeft: 0
            },
            '& .MuiTableSortLabel-active': {
                color: '#4f576e'
            }
        },
        "& .student": {
            padding: '0 12px',
            width: 250,
            minWidth: 200,
            maxWidth: 300
        },
        "& .summary": {
            minWidth: 100,
            width: 200,
            padding: '0 12px',
            maxWidth: 250,
            '& .cellContainer': {
                paddingLeft: 12,
                justifyContent: 'center'
            }
        },
        "& .grade": {
            minWidth: 70,
            maxWidth: 70,
            padding: 0
        },
        "& .gradeTotal": {
            fontWeight: 500
        },
        "& .gradeLabel": {
            width: '100%',
            justifyContent: 'center',
            paddingLeft: 20
        },
        "& .gradeLabelPastDate": {
            backgroundColor: 'rgba(234, 185, 237, 0.4)'
        },
        "& .gradeLabelPresentDate": {
            backgroundColor: 'rgba(205, 240, 192, 0.4)'
        },
        "& .container": {
            position: 'relative',
            top: 0,
            height: 60,
            '&.ignore': {
                background: 'repeating-linear-gradient(110deg, rgb(160 156 156) 5px, rgb(150 136 136 / 69%) 9%)'
            }
        },
        "& .cellContainer": {
            position: 'absolute',
            zIndex: 10,
            top: 0,
            width: '100%',
            height: '100%',
            display: 'flex'
        },
        "& .visuallyHidden": {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/dayjs":"kdp5L","teacher/context":"5LKDx","./HeaderOptions":"7efAo","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7efAo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeCellOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
const StyledHeaderOption = (0, _material.styled)('span')(gradeCellOptionStyles);
function GradeCellOptions({ column }) {
    const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
    const open = Boolean(anchorEl);
    const handleOpenOptions = (event)=>setAnchorEl(event.currentTarget);
    const handleCloseOptions = ()=>setAnchorEl(null);
    const options = createColumnOptions(column);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledHeaderOption, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "optionsButton",
                onClick: handleOpenOptions,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ArrowDropDownIcon), {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Menu), {
                id: "long-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: open,
                onClose: handleCloseOptions,
                children: options.map(({ selected, Option }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                        selected: selected,
                        onClick: handleCloseOptions,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Option, {
                            column: column
                        })
                    }, index))
            })
        ]
    });
}
function createColumnOptions(column) {
    const isExternal = !!column.external;
    if (isExternal) return [
        {
            Option: PublishAllGrades
        },
        {
            Option: IgnoreGrade
        },
        {
            Option: DeleteExternalGrade
        }
    ];
    return [
        {
            Option: PublishAllGrades
        },
        {
            Option: IgnoreGrade
        }
    ];
}
function PublishAllGrades({ column }) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const { published = false } = column.properties || {};
    async function handleChange(e) {
        const index = context.rollbookContextGradeColumns.items.findIndex((a)=>a.id == column.id);
        const published = e.target.checked;
        if (index < 0) return;
        //updateState({rollbookContextGradeColumns: {items: {[index]: {properties: {published: {$set: published}}}}}})
        const schema = column.external ? 'grading' : column.type == 'homework' ? 'homework' : 'quiz';
        await (0, _commandDefault.default)(schema, 'publishAllGrades')({
            id: column.id,
            published
        });
        updateState({
            rollbookRefresh: {
                $apply: (i)=>i + 1
            }
        });
    //updateState({rollbookContextGradeColumns: {refreshes: {$apply: i => i + 1}}, rollbookContextGrades: {refreshes: {$apply: i => i+1 }}})
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: published,
            onChange: handleChange
        }),
        label: translate(published ? 'grade-published' : 'publish-grade')
    });
}
function IgnoreGrade({ column }) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const { ignore = false } = column.properties || {};
    async function handleChange(e) {
        const index = context.rollbookContextGradeColumns.items.findIndex((a)=>a.id == column.id);
        const ignore = e.target.checked;
        if (index < 0) return;
        //updateState({rollbookContextGradeColumns: {items: {[index]: {properties: {ignore: {$set: ignore}}}}}})
        const schema = column.external ? 'grading' : column.type == 'homework' ? 'homework' : 'quiz';
        await (0, _commandDefault.default)(schema, 'ignoreAssignment')({
            id: column.id,
            ignore
        });
        updateState({
            rollbookRefresh: {
                $apply: (i)=>i + 1
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: ignore,
            onChange: handleChange
        }),
        label: translate('ignore-assessment')
    });
}
function DeleteExternalGrade({ column }) {
    const { translate, updateState } = (0, _react.useContext)((0, _context.TeacherContext));
    function handleDelete(e) {
        updateState({
            rollbookContextDeleteGrade: {
                open: {
                    $set: true
                },
                grade: {
                    $set: column
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        onClick: handleDelete,
        children: translate('delete-grade-tooltip')
    });
}
function gradeCellOptionStyles() {
    return {
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 100,
        color: '#4f576e',
        "& .optionsButton": {
            cursor: 'pointer',
            padding: 2
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","helpers/command":"f3cbG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"avNcH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradesBody);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _dayjs = require("external/dayjs");
var _context = require("teacher/context");
var _gradeCell = require("./GradeCell");
var _gradeCellDefault = parcelHelpers.interopDefault(_gradeCell);
const StyledTableBody = (0, _material.styled)((0, _material.TableBody))(gradeBodyStyles);
function GradesBody(props) {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { rows, columns } = props;
    const { query, link, groupId } = context;
    const { gradeFilter: queryGradeFilters } = query;
    const location = (0, _react.useLocation)();
    const handleStudentLinkClick = ()=>{
        context.updateState({
            rollbookContextStudentGradesNavigation: {
                origin: {
                    $set: location.pathname
                },
                query: {
                    $set: query
                }
            }
        });
    };
    const filterGrades = (column)=>{
        const queryFiltersValue = queryGradeFilters ?? [];
        const queryFilters = Array.isArray(queryFiltersValue) ? queryFiltersValue : [
            queryFiltersValue
        ];
        if (queryFilters.includes('all') || queryFilters.length === 0) return true;
        const dateAssigned = (0, _dayjs.dayjs)(new Date(column.date));
        const creationDate = (0, _dayjs.dayjs)(new Date(column.start));
        if (queryFilters.includes(column.type)) return true;
        const isManual = dateAssigned.isAfter(creationDate);
        const isAdjust = dateAssigned.isBefore(creationDate);
        if (isManual && queryFilters.includes('manual')) return true;
        if (isAdjust && queryFilters.includes('adjust')) return true;
        return false;
    };
    const studentLink = (0, _react.useMemo)(()=>(student)=>link({
                page: 'gradebook',
                groupId,
                studentId: student.id
            }), [
        groupId,
        link
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTableBody, {
        children: rows.map((student)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.TableRow), {
                className: "row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TableCell), {
                        align: "left",
                        className: "cell",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Link), {
                            to: studentLink(student),
                            onClick: handleStudentLinkClick,
                            className: "studentLink",
                            children: student.name
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.TableCell), {
                        align: "center",
                        className: (0, _material.clsx)("cell", 'summary'),
                        children: [
                            student.summary,
                            "%"
                        ]
                    }),
                    student.columns.filter(filterGrades).map((column, index)=>{
                        const dateAssigned = (0, _dayjs.dayjs)(new Date(column.date));
                        const creationDate = (0, _dayjs.dayjs)(new Date(column.start));
                        const isExternal = Boolean(column?.external);
                        const classNameDate = dateAssigned.isBefore(creationDate) ? 'gradeLabelPastDate' : 'gradeLabelPresentDate';
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradeCellDefault.default), {
                            classname: `${isExternal ? classNameDate : ''}`,
                            student: student,
                            column: column
                        }, index);
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TableCell), {
                        className: "filler",
                        style: {
                            top: 92
                        },
                        align: "right"
                    })
                ]
            }, student.id);
        })
    });
}
function gradeBodyStyles() {
    return {
        "& .cell": {
            padding: 0,
            color: '#4f576e',
            height: 60,
            fontWeight: 500,
            borderLeft: 'solid 1px #d8dbe0',
            borderRight: 'solid 1px #d8dbe0',
            '&:first-of-type': {
                borderLeft: 0,
                paddingLeft: 12
            },
            '&.summary': {
                backgroundColor: '#f5fff6'
            }
        },
        "& .studentLink": {
            color: '#4f576e',
            fontWeight: 'bold',
            textDecoration: 'none'
        },
        "& .gradeLabelPastDate": {
            backgroundColor: 'rgba(234, 185, 237, 0.2)'
        },
        "& .gradeLabelPresentDate": {
            backgroundColor: 'rgba(205, 240, 192, 0.2)'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/dayjs":"kdp5L","teacher/context":"5LKDx","./GradeCell":"czR04","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"czR04":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeCell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _context = require("teacher/context");
var _command = require("helpers/command");
var _gradebook = require("helpers/gradebook");
var _gradeCellOptions = require("./GradeCellOptions");
var _gradeCellOptionsDefault = parcelHelpers.interopDefault(_gradeCellOptions);
var _gradeInput = require("components/gradebook/GradeInput");
var _gradeInputDefault = parcelHelpers.interopDefault(_gradeInput);
const StyledCell = (0, _material.styled)((0, _material.TableCell))(gradeCellStyles);
function GradeCell(props) {
    const { student = {}, column = {}, classname = '' } = props;
    const { Cell, cssClass } = pickCellHandler(column);
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { grades = [] } = column;
    const [homework = {}] = grades;
    const { properties = {} } = column.type == 'homework' && homework.points || column.external ? (context.rollbookContextStudentAssignmentProperties[student.id] || {})[column.id] || {
        properties: {}
    } : column.selectedAnswer || {};
    const { published } = properties;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCell, {
        align: "center",
        className: (0, _material.clsx)("root", cssClass, classname),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: (0, _material.clsx)("container", {
                ignore: column.ignore,
                'not-assigned': !column.assigned
            }),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradeCellOptionsDefault.default), {
                    column,
                    student
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "cellContainer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                        column,
                        student
                    })
                }),
                published && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "published",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.CheckCircleIcon), {
                        size: "small"
                    })
                })
            ]
        })
    });
}
function pickCellHandler({ external, type, answered, pending, selectedAnswer, grades = [] }) {
    if (external) return {
        Cell: ExternalCell,
        cssClass: 'external'
    };
    if (type == 'homework') return {
        Cell: HomeworkCell,
        cssClass: 'homework'
    };
    // Fall back to single grade when no explicit selectedAnswer exists
    const effectiveAnswer = selectedAnswer ?? (grades.length === 1 ? grades[0] : null);
    if (!answered || !effectiveAnswer) return {
        Cell: NoGradeCell,
        cssClass: 'nograde'
    };
    if (pending) return {
        Cell: PendingReviewCell,
        cssClass: 'pending'
    };
    return {
        Cell: ReviewedCell,
        cssClass: effectiveAnswer.properties?.published ? 'published' : 'reviewed'
    };
}
function HomeworkCell({ column }) {
    const { grades = [] } = column;
    const { updateState, link, query } = (0, _react.useContext)((0, _context.TeacherContext));
    const location = (0, _react.useLocation)();
    const [homework = {}] = grades;
    const reviewPath = homework.id && '/:languageId/:role/:page/:id';
    const reviewLink = homework.id && link({
        page: 'homework',
        id: homework.assignment
    }, reviewPath);
    function homeworkClickHandler() {
        updateState({
            homeworkContext: {
                review: {
                    from: {
                        $set: location.pathname
                    },
                    query: {
                        $set: query
                    }
                }
            }
        });
    }
    return homework.points ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Link), {
        to: reviewLink,
        onClick: homeworkClickHandler,
        className: (0, _material.clsx)('fill', 'centered', 'link'),
        children: homework.points
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _material.clsx)('fill', 'centered', 'empty'),
        children: "-"
    });
}
function ExternalCell({ student, column }) {
    const { external, points, total } = column;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    async function handleGradeChange(value) {
        const [grade] = await (0, _command.createPost)('grading', 'updateExternalStudentGrade')({
            student: student.id,
            external,
            value: value || 0
        });
        if (grade) {
            const index = context.rollbookContextGrades.items.findIndex((g)=>g.id === grade.id);
            if (index >= 0) context.updateState({
                rollbookContextGrades: {
                    items: {
                        [index]: {
                            $set: grade
                        }
                    }
                }
            });
            else context.updateState({
                rollbookContextGrades: {
                    items: {
                        $push: [
                            grade
                        ]
                    }
                }
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradeInputDefault.default), {
        total: total,
        value: points,
        onGradeChange: handleGradeChange
    });
}
function NoGradeCell({ column }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: (0, _material.clsx)('fill', 'centered', 'empty'),
        children: column.assigned ? '-' : 'NA'
    });
}
function ReviewedCell({ column }) {
    const { selectedAnswer, grades = [] } = column;
    const effectiveAnswer = selectedAnswer ?? grades[0];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReviewLink, {
        answeredAssessment: effectiveAnswer?.answeredAssessment,
        children: (0, _gradebook.displayPoints)(effectiveAnswer || {
            points: column.points
        })
    });
}
function PendingReviewCell({ column }) {
    const { selectedAnswer, grades = [] } = column;
    const effectiveAnswer = selectedAnswer ?? grades[0];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ReviewLink, {
        answeredAssessment: effectiveAnswer?.answeredAssessment,
        children: "R"
    });
}
function ReviewLink({ answeredAssessment, children }) {
    const { updateState, link, query } = (0, _react.useContext)((0, _context.TeacherContext));
    const location = (0, _react.useLocation)();
    const reviewPath = '/:languageId/:role/:page(quiz)/:assessment/:action(review)';
    const reviewLink = link({
        page: 'quiz',
        assessment: answeredAssessment,
        action: 'review'
    }, reviewPath);
    function reviewClickHandler() {
        updateState({
            quizEditFrom: {
                $set: location.pathname
            },
            quizEditFromQuery: {
                $set: query
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Link), {
        onClick: reviewClickHandler,
        to: reviewLink,
        className: (0, _material.clsx)('fill', 'centered', 'link'),
        children: children
    });
}
function gradeCellStyles(theme) {
    return {
        "&.root": {
            width: 40,
            padding: 0,
            color: '#4f576e',
            fontWeight: 500,
            borderLeft: 'solid 1px #d8dbe0',
            borderRight: 'solid 1px #d8dbe0',
            '&.pending': {
                backgroundColor: '#ffeae9',
                '& .link': {
                    color: '#da1617'
                }
            }
        },
        "& .container": {
            position: 'relative',
            top: 0,
            height: 60,
            '&.ignore': {
                background: 'repeating-linear-gradient(110deg, rgb(160 156 156) 5px, rgb(150 136 136 / 69%) 9%)',
                '& .published svg': {
                    backgroundColor: '#fff',
                    borderRadius: '100%'
                }
            }
        },
        "& .published": {
            color: '#70c44b',
            position: 'absolute',
            top: 43,
            left: 2,
            zIndex: 20,
            '& svg': {
                fontSize: '8pt'
            }
        },
        "& .cellContainer": {
            position: 'absolute',
            zIndex: 10,
            justifyContent: 'center',
            top: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            '& .centered': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            '& .fill': {
                flexGrow: 1
            },
            '& .empty': {
                marginLeft: -5
            },
            '& .link': {
                fontSize: '11pt',
                marginLeft: -5,
                textDecoration: 'none',
                color: '#555c76',
                '&:hover': {
                    fontWeight: 'bold'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","teacher/context":"5LKDx","helpers/command":"f3cbG","helpers/gradebook":"6ehCA","./GradeCellOptions":"9yWdt","components/gradebook/GradeInput":"6O1CV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9yWdt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeCellOptions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _dateFns = require("external/date-fns");
var _context = require("teacher/context");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _gradebook = require("helpers/gradebook");
const StyledCellOptions = (0, _material.styled)('span')(gradeCellOptionStyles);
function GradeCellOptions({ student, column }) {
    const [anchorEl, setAnchorEl] = (0, _react.React).useState(null);
    const open = Boolean(anchorEl);
    const handleOpenOptions = (event)=>setAnchorEl(event.currentTarget);
    const handleCloseOptions = ()=>setAnchorEl(null);
    const options = createColumnOptions(column);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCellOptions, {
        className: "options",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _material.clsx)('optionsButton', {
                    "not-assigned": !column.assigned
                }),
                onClick: handleOpenOptions,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ArrowDropDownIcon), {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Menu), {
                id: "long-menu",
                anchorEl: anchorEl,
                keepMounted: true,
                open: open,
                onClose: handleCloseOptions,
                children: options.map(({ selected, Option, grade, disabled }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.MenuItem), {
                        selected: selected,
                        disabled: disabled,
                        onClick: handleCloseOptions,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Option, {
                            selected: selected,
                            student: student,
                            column: column,
                            grade: grade
                        })
                    }, index))
            })
        ]
    });
}
function createColumnOptions(column) {
    const { selectedAnswer, type, external, grades = [] } = column;
    const { properties = {} } = selectedAnswer || {};
    const disabled = properties.published;
    const gradeOptions = grades.map((grade)=>{
        const selected = column.selectedAnswer && column.selectedAnswer.answeredAssessment == grade.answeredAssessment;
        return {
            selected,
            Option: GradeOption,
            grade,
            disabled
        };
    });
    return external ? [
        {
            Option: PublishExternalGrade
        },
        {
            Option: IgnoreExternalGrade
        }
    ] : type == 'homework' ? [
        {
            Option: PublishHomework
        },
        {
            Option: IgnoreGrade
        }
    ] : [
        {
            Option: PublishGrade
        },
        {
            Option: IgnoreGrade
        }
    ].concat(gradeOptions);
}
function GradeOption({ selected, grade }) {
    const { link, translate, updateState, rollbookContextGrades, query } = (0, _react.useContext)((0, _context.TeacherContext));
    const location = (0, _react.useLocation)();
    function handleChange(e) {
        if (selected) return;
        const index = rollbookContextGrades.items.findIndex((g)=>g.answeredAssessment == grade.answeredAssessment);
        if (index < 0) return;
        const selectedIndex = rollbookContextGrades.items.findIndex((g)=>g.properties?.selected);
        const update = {
            [index]: {
                properties: {
                    selected: {
                        $set: true
                    }
                }
            }
        };
        if (selectedIndex >= 0) update[selectedIndex] = {
            properties: {
                selected: {
                    $set: false
                }
            }
        };
        updateState({
            rollbookContextGrades: {
                items: update
            }
        });
        (0, _commandDefault.default)('grading', 'selectStudentAssessment')({
            assessment: grade.answeredAssessment
        });
    }
    const dateFormat = 'yyyy-MM-dd';
    const label = `${(0, _gradebook.displayPoints)(grade)} - ${(0, _dateFns.formatDate)(grade.started || grade.start, dateFormat)}`;
    const reviewPath = '/:languageId/:role/:page(quiz)/:assessment/:action(review)';
    const reviewLink = link({
        page: 'quiz',
        assessment: grade.answeredAssessment,
        action: 'review'
    }, reviewPath);
    function reviewClickHandler() {
        updateState({
            quizEditFrom: {
                $set: location.pathname
            },
            quizEditFromQuery: {
                $set: query
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: selected,
            onChange: handleChange
        }),
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Link), {
            onClick: reviewClickHandler,
            to: reviewLink,
            className: (0, _material.clsx)('fill', 'centered', 'link'),
            children: label
        })
    });
}
function PublishGrade(props) {
    const { column = {} } = props;
    const { translate, updateState, rollbookContextGrades } = (0, _react.useContext)((0, _context.TeacherContext));
    const { selectedAnswer } = column;
    const { properties = {} } = selectedAnswer || {};
    function handleChange(e) {
        const published = e.target.checked;
        if (!selectedAnswer) return;
        const index = rollbookContextGrades.items.findIndex((g)=>g.answeredAssessment == selectedAnswer.answeredAssessment);
        if (index < 0) return;
        updateState({
            rollbookContextGrades: {
                items: {
                    [index]: {
                        properties: {
                            published: {
                                $set: published
                            }
                        }
                    }
                }
            }
        });
        (0, _commandDefault.default)('grading', 'publishStudentAssessment')({
            assessment: selectedAnswer.answeredAssessment,
            published
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: properties.published || false,
            onChange: handleChange
        }),
        label: translate(properties.published ? 'grade-published' : 'publish-grade')
    });
}
function IgnoreGrade(props) {
    const { student = {}, column = {} } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const { id, properties: { ignore = false } } = (context.rollbookContextStudentAssignmentProperties[student.id] || {})[column.id] || {
        properties: {}
    };
    function handleChange(e) {
        if (!id) return;
        const ignore = e.target.checked;
        updateState({
            rollbookContextStudentAssignmentProperties: {
                [student.id]: {
                    [column.id]: {
                        properties: {
                            ignore: {
                                $set: ignore
                            }
                        }
                    }
                }
            }
        });
        const schema = column.type == 'homework' ? 'homework' : 'quiz';
        (0, _commandDefault.default)(schema, 'ignoreStudentAssignment')({
            id,
            ignore
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: ignore,
            onChange: handleChange
        }),
        label: translate('ignore-grade')
    });
}
function IgnoreExternalGrade(props) {
    const { student = {}, column = {} } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const { id, properties: { ignore = false } } = (context.rollbookContextStudentAssignmentProperties[student.id] || {})[column.id] || {
        properties: {}
    };
    async function handleChange(e) {
        const ignore = e.target.checked;
        const update = (0, _commandDefault.default)('grading', 'ignoreExternalGrade')({
            assignment: column.id,
            student: student.id,
            id,
            ignore
        });
        if (id) updateState({
            rollbookContextStudentAssignmentProperties: {
                [student.id]: {
                    [column.id]: {
                        properties: {
                            ignore: {
                                $set: ignore
                            }
                        }
                    }
                }
            }
        });
        else {
            const [assignment] = await update;
            updateState({
                rollbookContextStudentAssignmentProperties: {
                    $auto: {
                        [student.id]: {
                            $auto: {
                                [assignment.assignment]: {
                                    $set: assignment
                                }
                            }
                        }
                    }
                }
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: ignore,
            onChange: handleChange
        }),
        label: translate('ignore-grade')
    });
}
function PublishExternalGrade(props) {
    const { student = {}, column = {} } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const { id, properties: { published = false } } = (context.rollbookContextStudentAssignmentProperties[student.id] || {})[column.id] || {
        properties: {}
    };
    async function handleChange(e) {
        const published = e.target.checked;
        const update = (0, _commandDefault.default)('grading', 'publishExternalGrade')({
            assignment: column.id,
            student: student.id,
            id,
            published
        });
        if (id) updateState({
            rollbookContextStudentAssignmentProperties: {
                [student.id]: {
                    [column.id]: {
                        properties: {
                            published: {
                                $set: published
                            }
                        }
                    }
                }
            }
        });
        else {
            const [assignment] = await update;
            updateState({
                rollbookContextStudentAssignmentProperties: {
                    $auto: {
                        [student.id]: {
                            $auto: {
                                [assignment.assignment]: {
                                    $set: assignment
                                }
                            }
                        }
                    }
                }
            });
        }
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: published || false,
            onChange: handleChange
        }),
        label: translate(published ? 'grade-published' : 'publish-grade')
    });
}
function PublishHomework(props) {
    const { student = {}, column = {} } = props;
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, updateState } = context;
    const { id, properties: { published = false } } = (context.rollbookContextStudentAssignmentProperties[student.id] || {})[column.id] || {
        properties: {}
    };
    function handleChange(e) {
        if (!id) return;
        const published = e.target.checked;
        updateState({
            rollbookContextStudentAssignmentProperties: {
                [student.id]: {
                    [column.id]: {
                        properties: {
                            published: {
                                $set: published
                            }
                        }
                    }
                }
            }
        });
        (0, _commandDefault.default)('homework', 'publishStudentAssignment')({
            id,
            published
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
        control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
            color: "primary",
            checked: published || false,
            onChange: handleChange
        }),
        label: translate(published ? 'grade-published' : 'publish-grade')
    });
}
function gradeCellOptionStyles() {
    return {
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 100,
        color: '#4f576e',
        "& .optionsButton": {
            cursor: 'pointer',
            padding: 2,
            "&.not-assigned": {
                visibility: 'hidden'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","external/date-fns":"kwxNe","teacher/context":"5LKDx","helpers/command":"f3cbG","helpers/gradebook":"6ehCA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6O1CV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradeInput);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const StyledField = (0, _material.styled)((0, _material.TextField))(gardeInputStyles);
function GradeInput(props) {
    const { total, onGradeChange, className } = props;
    const [state, setState] = (0, _react.useState)({
        value: props.value === null ? null : props.value,
        sentValue: props.value
    });
    function handleBlur() {
        if (state.value != state.sentValue) {
            onGradeChange && onGradeChange(state.value);
            setState({
                ...state,
                sentValue: state.value
            });
        }
    }
    function handleChange(e) {
        const value = e.target.value == '' ? null : parseInt(e.target.value);
        setState({
            ...state,
            value
        });
    }
    (0, _react.useEffect)(()=>{
        if (props.value != state.value) setState({
            value: props.value || null,
            sentValue: props.value
        });
    }, [
        props.value
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledField, {
        className: (0, _material.clsx)('gradeInput', className),
        InputProps: {
            inputProps: {
                min: 0,
                max: total
            }
        },
        value: state.value === null ? '' : state.value,
        type: "number",
        onChange: handleChange,
        onBlur: handleBlur
    });
}
function gardeInputStyles() {
    return {
        "& fieldset": {
            marginTop: 3,
            borderWidth: 0
        },
        "& input": {
            textAlign: 'center',
            padding: 0,
            marginRight: 5,
            paddingLeft: 11
        },
        "& .MuiOutlinedInput-root": {
            marginTop: '15px',
            fontSize: '10.5pt',
            height: '35px',
            width: '65px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dyWky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DeleteExternalGrade);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
var _command = require("helpers/command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _dialog = require("./Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _context = require("teacher/context");
const StyledDeleteGrade = (0, _material.styled)((0, _dialogDefault.default))(deleteGradeStyles);
function DeleteExternalGrade() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { updateState, rollbookContextDeleteGrade: { open, grade } } = context;
    function onClose() {
        updateState({
            rollbookContextDeleteGrade: {
                open: {
                    $set: false
                },
                grade: {
                    $set: undefined
                }
            }
        });
    }
    async function onConfirm() {
        const [deletedId] = await (0, _commandDefault.default)('grading', 'deleteExternalGrade')({
            id: grade.id
        });
        context.updateState({
            rollbookContext: {
                gradeColumns: {
                    refreshes: {
                        $apply: (i)=>i + 1
                    }
                },
                grades: {
                    refreshes: {
                        $apply: (i)=>i + 1
                    }
                }
            }
        });
        onClose();
    }
    const shouldConfirm = grade ? grade.turnIns > 0 : false;
    const notificationId = shouldConfirm ? 'new-grade-delete' : 'grade-delete';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDeleteGrade, {
        open,
        context,
        onClose,
        onConfirm,
        shouldConfirm,
        notificationId
    });
}
function deleteGradeStyles() {
    return {};
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","helpers/command":"f3cbG","./Dialog":"lrFMV","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lrFMV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>NotificationDialog);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const StyledDialog = (0, _material.styled)((0, _material.Dialog))(notificationStyles);
const StyledTitle = (0, _material.styled)((0, _material.DialogTitle))(titleStyles);
function NotificationDialog(props) {
    const { open, onClose, onConfirm, context, notificationId: id, shouldConfirm = false } = props;
    const { translate } = context;
    const theme = (0, _material.useTheme)();
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('md'));
    const [confirmed, setConfirmed] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!open) setConfirmed(false);
    }, [
        open
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDialog, {
        fullScreen: fullScreen,
        open: open,
        onClose: onClose,
        "aria-labelledby": "notification-dialog-title",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: open,
                timeout: {
                    exit: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledTitle, {
                    id: "notification-dialog-title",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            className: "icon",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ErrorIcon), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            children: translate(`${id}-title`)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: open,
                timeout: {
                    exit: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogContent), {
                    className: "content",
                    children: [
                        shouldConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                            size: "small",
                            className: (0, _material.clsx)('notification', {
                                shouldConfirm
                            }),
                            control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                                size: "small",
                                color: "primary",
                                checked: confirmed,
                                onChange: (e)=>setConfirmed(e.target.checked)
                            }),
                            label: translate(`${id}-message`)
                        }),
                        !shouldConfirm && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: (0, _material.clsx)('notification', {
                                shouldConfirm
                            }),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                children: translate(`${id}-message`)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: open,
                timeout: {
                    exit: 0
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogActions), {
                    className: "actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            color: "background",
                            className: (0, _material.clsx)('button', "cancel"),
                            onClick: onClose,
                            children: translate(`${id}-cancel`)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                            variant: "contained",
                            color: "error",
                            className: (0, _material.clsx)('button', "confirm"),
                            onClick: onConfirm,
                            ...!shouldConfirm || confirmed ? {} : {
                                disabled: true
                            },
                            children: translate(`${id}-confirm`)
                        })
                    ]
                })
            })
        ]
    });
}
function titleStyles() {
    return {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '14pt',
        fontWeight: 'bold',
        borderBottom: 'solid 1px #f3f3f3',
        background: '#fdfdfd'
    };
}
function notificationStyles(theme) {
    return {
        "& .content": {
            display: 'flex',
            paddingTop: '20px !important',
            flexGrow: 1,
            flexDirection: 'column',
            justifyContent: 'center',
            minWidth: 280,
            maxWidth: 350
        },
        "& .icon": {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            color: '#f4cc2c',
            fontSize: '15pt',
            marginTop: -1,
            marginRight: 10
        },
        "& .notification": {
            color: '79797b',
            fontSize: '11.5pt',
            textAlign: 'center',
            '& .MuiFormControlLabel-label': {
                lineHeight: '1.1',
                fontSize: '11.5pt'
            },
            '&.shouldConfirm': {
                textAlign: 'justify'
            }
        },
        "& .actions": {
            padding: 12,
            display: 'flex',
            justifyContent: 'center',
            borderTop: 'solid 1px #f3f3f3',
            background: '#fdfdfd'
        },
        "& .filler": {
            flexGrow: 1
        },
        "& .button": {
            textTransform: 'none',
            '&.cancel': {
                marginLeft: 0,
                marginRight: 0
            },
            '&.confirm': {
                marginLeft: 16
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"grtv8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentGrades);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _studentGradesInfoBar = require("./student-grades-info-bar");
var _studentGradesInfoBarDefault = parcelHelpers.interopDefault(_studentGradesInfoBar);
var _studentGradesFilters = require("./student-grades-filters");
var _studentGradesFiltersDefault = parcelHelpers.interopDefault(_studentGradesFilters);
var _studentGradesSummary = require("./student-grades-summary");
var _studentGradesSummaryDefault = parcelHelpers.interopDefault(_studentGradesSummary);
var _studentAnsweredAssessments = require("./student-answered-assessments");
var _studentAnsweredAssessmentsDefault = parcelHelpers.interopDefault(_studentAnsweredAssessments);
const useStyles = (0, _material.makeStyles)(gradesStyles);
function StudentGrades({ context }) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.infoBar,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentGradesInfoBarDefault.default), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.content,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentGradesFiltersDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentGradesSummaryDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentAnsweredAssessmentsDefault.default), {})
                ]
            })
        ]
    });
}
function gradesStyles(theme) {
    return {
        root: {
            flexGrow: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            borderRadius: '4px',
            boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
        },
        content: {
            padding: '25px 20px',
            overflowY: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","./student-grades-info-bar":"1zuzz","./student-grades-filters":"fJmTl","./student-grades-summary":"3fNb6","./student-answered-assessments":"keGh9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1zuzz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentGradesInfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _context = require("teacher/context");
var _backButton = require("components/back-button");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const useStyles = (0, _material.makeStyles)(studentGradesInfoBarStyles);
function StudentGradesInfoBar() {
    const classes = useStyles();
    const { translate, rollbookContextPeriods, rollbookContextStudentGradesNavigation, link, linkQuery } = (0, _react.useContext)((0, _context.TeacherContext));
    const defaulBackLink = link({
        page: 'gradebook'
    }, '/:languageId/:role/:page');
    const [backLink, setBackLink] = (0, _react.useState)(defaulBackLink);
    const { loaded, items } = rollbookContextPeriods;
    const firstAndLast = loaded && items.length > 0 ? [
        items[0],
        items[items.length - 1]
    ] : [
        {
            start: ''
        },
        {
            finish: ''
        }
    ];
    const [{ start }, { finish }] = firstAndLast;
    const label = `${translate('rollbook')} ${(0, _momentDefault.default)(start).year()} - ${(0, _momentDefault.default)(finish).year()}`;
    function updateBackLink() {
        if (rollbookContextStudentGradesNavigation) {
            const { origin = defaulBackLink, query } = rollbookContextStudentGradesNavigation;
            setBackLink(linkQuery(origin, query, true));
        }
    }
    (0, _react.useEffect)(updateBackLink, []);
    (0, _react.useEffect)(updateBackLink, [
        rollbookContextStudentGradesNavigation
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                link: backLink
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: `${classes.middle} ${classes.label}`,
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                style: {
                    flexGrow: 1
                }
            })
        ]
    });
}
function studentGradesInfoBarStyles(theme) {
    return {
        root: {
            display: 'flex',
            borderBottom: 'solid 1px #dbe3e6',
            minHeight: '60px'
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        label: {
            marginLeft: 10,
            color: '#636b80',
            fontWeight: 'bold',
            [theme.breakpoints.down('xs')]: {
                marginLeft: 5
            },
            fontSize: '12pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","teacher/context":"5LKDx","components/back-button":"nQlBv","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"nQlBv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>BackButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _material = require("external/material");
const StyledBackButton = (0, _material.styled)((0, _material.IconButton))(backButtonStyles);
function BackButton({ link = '#', onClick }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBackButton, {
        component: (0, _react.Link),
        to: link,
        onClick: onClick,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.ArrowBackIosIcon), {
            className: "icon"
        })
    });
}
function backButtonStyles({ theme }) {
    return {
        borderRadius: 0,
        backgroundColor: '#fff',
        marginRight: theme.spacing(2),
        borderRight: 'solid 1px #dbe3e6',
        '&:hover': {
            backgroundColor: '#ccc',
            '& .icon': {
                transform: 'scale(1.1)',
                fill: '#000'
            }
        },
        "& .icon": {
            margin: '0 0 0 6px',
            fill: '#4f556d'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fJmTl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentGradesFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("teacher/context");
var _selectStudent = require("./select-student");
var _selectStudentDefault = parcelHelpers.interopDefault(_selectStudent);
const useStyles = (0, _material.makeStyles)(filterStyles);
function StudentGradesFilters() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { link, groupId, groups } = context;
    const path = link({
        page: 'gradebook',
        groupId
    });
    const group = groups.find((g)=>g.id == groupId) || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)(classes.groupContainer, classes.middle),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: classes.group,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.groupIcon,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                icon: (0, _freeSolidSvgIcons.faUsers)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.groupName,
                            children: group.name
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)(classes.studentContainer, classes.middle),
                children: group.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectStudentDefault.default), {
                    group: group
                })
            })
        ]
    });
}
function filterStyles() {
    return {
        root: {
            display: "flex",
            marginBottom: 10
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        group: {
            display: 'flex',
            marginRight: 25
        },
        groupName: {
            fontSize: '11pt',
            fontWeight: 'bold',
            color: '#4f576e'
        },
        groupIcon: {
            marginRight: 8,
            color: '#3295ce',
            fontSize: '12pt'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","teacher/context":"5LKDx","./select-student":"jbpNL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jbpNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>SelectStudent);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _arrowDropDown = require("@mui/icons-material/ArrowDropDown");
var _arrowDropDownDefault = parcelHelpers.interopDefault(_arrowDropDown);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _material = require("external/material");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _context = require("teacher/context");
const useSelectStyles = (0, _material.makeStyles)(selectStyles);
const useStyles = (0, _material.makeStyles)(studentStyles);
function SelectStudent(props) {
    const { group: { students = [] } } = props;
    const history = (0, _reactRouterDom.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const selectClasses = useSelectStyles();
    const classes = useStyles();
    const { link, linkQuery, groupMembers, groupId, studentId } = context;
    const handleStudentChange = (event)=>history.push(linkQuery(link({
            groupId,
            studentId: event.target.value
        }), {}));
    const value = students.length == 0 || studentId == undefined ? '' : studentId;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _clsxDefault.default)(classes.icon, classes.middle),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faUser)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: (0, _clsxDefault.default)(classes.select, classes.middle),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                    classes: selectClasses,
                    onChange: handleStudentChange,
                    value: value,
                    IconComponent: (0, _arrowDropDownDefault.default),
                    children: students.map((student)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            value: student.id,
                            children: student.name
                        }, student.id))
                })
            })
        ]
    });
}
function studentStyles() {
    return {
        container: {
            display: 'flex'
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        select: {
            '& .MuiInput-underline:before': {
                content: 'none',
                border: 'none'
            },
            '& .MuiInput-underline:after': {
                content: 'none',
                border: 'none'
            }
        },
        icon: {
            marginRight: 8,
            color: '#3295ce',
            marginTop: -2
        }
    };
}
function selectStyles() {
    return {
        root: {
            color: '#4f576e',
            fontSize: '11pt',
            '&:focus': {
                backgroundColor: 'transparent'
            }
        },
        icon: {
            color: '#4f576e',
            fontWeight: 'bold'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","@mui/icons-material/ArrowDropDown":"6qreH","@mui/material/MenuItem":"a18vm","@mui/material/Select":"aY7hn","external/material":"6yEDE","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3fNb6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentGradesSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _context = require("teacher/context");
var _studentGradesSummaryHead = require("./student-grades-summary-head");
var _studentGradesSummaryHeadDefault = parcelHelpers.interopDefault(_studentGradesSummaryHead);
var _studentGradesSummaryBody = require("./student-grades-summary-body");
var _studentGradesSummaryBodyDefault = parcelHelpers.interopDefault(_studentGradesSummaryBody);
const useStyles = (0, _material.makeStyles)(studentGradesSummaryStyles);
function StudentGradesSummary() {
    const { query, rollbookContextGrades: grades, groupsLoaded } = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
            className: classes.container,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                in: groupsLoaded && grades.loaded,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                    className: classes.table,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentGradesSummaryHeadDefault.default), {}),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentGradesSummaryBodyDefault.default), {})
                    ]
                })
            })
        })
    });
}
function studentGradesSummaryStyles(theme) {
    return {
        root: {},
        container: {
            flexGrow: 1,
            flexShrink: 0,
            overflow: 'auto',
            border: 'solid 1px #d8dbe0',
            borderTop: 0,
            borderBottom: 0,
            [theme.breakpoints.down('xs')]: {
                border: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","helpers/moment":"jwdju","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Fade":"8DwqP","@mui/material/TableContainer":"2Kmn7","@mui/material/Table":"if4Vw","teacher/context":"5LKDx","./student-grades-summary-head":"gfgel","./student-grades-summary-body":"cAaEf","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gfgel":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentGradesSummaryHead);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(studentGradesSummaryHeadStyles);
function StudentGradesSummaryHead() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, groupId } = context;
    const { items: periods } = context.rollbookContextPeriods;
    const columns = (0, _lodash.orderBy)(periods, [
        (p)=>(0, _momentDefault.default)(p.start).valueOf()
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
            className: classes.headersRow,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.headerCell,
                    style: {
                        top: 92
                    },
                    align: "left"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCell, {
                    id: "global-summary-cell",
                    align: "center",
                    classes: classes,
                    cellClass: classes.summary,
                    labelClass: classes.summaryLabel,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: translate('student-grades-summary-global-header')
                    })
                }),
                columns.map((column)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TableCell, {
                        id: `${column.label}-cell`,
                        description: column.title,
                        classes: classes,
                        cellClass: classes.period,
                        labelClass: classes.periodLabel,
                        column: column,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: classes.periodName,
                            children: column.properties.name
                        })
                    }, column.id);
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.filler,
                    style: {
                        top: 92
                    },
                    align: "right"
                })
            ]
        })
    });
}
function TableCell(props) {
    const { id, label, align, disablePadding, column, classes, cellClass, labelClass, containerClass } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
        align: align || 'left',
        padding: disablePadding ? 'none' : 'normal',
        className: (0, _clsxDefault.default)(classes.headerCell, cellClass),
        style: {
            top: 92
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: classes.cellContainer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)("label", containerClass),
                children: props.children
            })
        })
    });
}
function studentGradesSummaryHeadStyles() {
    return {
        center: {
            textAlign: 'center'
        },
        headersRow: {
            color: '#50566e',
            '& > th': {
                borderTop: 'solid 1px #d8dbe0',
                backgroundColor: '#f1faff'
            }
        },
        headerCell: {
            padding: 0,
            width: 170,
            color: '#4f576e',
            fontWeight: 'bold',
            borderLeft: 'solid 1px #d8dbe0',
            borderRight: 'solid 1px #d8dbe0',
            '&:first-child': {
                borderLeft: 0
            },
            "& .label": {
                padding: '0 10px',
                textAlign: 'center'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","helpers/moment":"jwdju","react":"9njXz","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cAaEf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentGradesSummaryBody);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(studentGradesSummaryBodyStyles);
function StudentGradesSummaryBody() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, groupId, studentId, gradingCategories } = context;
    const grades = context.rollbookContextGrades.items.filter((g)=>g.student == studentId);
    const gradeColumns = context.rollbookContextGradeColumns.items.reduce((columns, column)=>{
        columns[column.id] = column;
        return columns;
    }, {});
    const periods = context.rollbookContextPeriods.items.map((period)=>({
            ...period,
            grades: grades.filter((g)=>(0, _momentDefault.default)(g.start).isSameOrAfter(period.start) && (0, _momentDefault.default)(g.start).isSameOrBefore(period.finish)).reduce((acc, grade)=>{
                const type = acc[grade.type] || (acc[grade.type] = {});
                const selected = grade.properties && grade.properties.selected;
                const original = !grade.makeupFor;
                const id = grade.makeupFor || grade.assignment;
                const gradeColumn = gradeColumns[id] || {
                    properties: {
                        ignore: false
                    }
                };
                const assignment = (context.rollbookContextStudentAssignmentProperties[studentId] || {})[id] || {
                    properties: {
                        ignore: false
                    }
                };
                const ignore = gradeColumn.properties.ignore || assignment.properties.ignore;
                if (ignore || !original && !selected) return acc;
                if (!type[id] || type[id] && type[id].properties && !type[id].properties.selected) type[id] = grade;
                return acc;
            }, {})
        }));
    const columns = (0, _lodash.orderBy)(periods, [
        (p)=>(0, _momentDefault.default)(p.start).valueOf()
    ]);
    const quizRows = gradingCategories.filter((t)=>t.name != 'practice2').map((t)=>{
        const gradeColumns = columns.map((c)=>{
            const typeGrades = Object.values(c.grades[t.id] || {});
            const points = typeGrades.reduce((points, grade)=>points + grade.points, 0);
            const total = typeGrades.reduce((total, grade)=>total + grade.total, 0);
            return {
                points,
                total
            };
        });
        const summaryColumn = gradeColumns.reduce((acc, column)=>({
                total: acc.total + column.total,
                points: acc.points + column.points
            }), {
            total: 0,
            points: 0
        });
        return [
            translate(`${t.name}-label`),
            summaryColumn
        ].concat(gradeColumns);
    });
    const globalRow = quizRows.reduce((acc, row)=>{
        const [_, summaryColumn, ...gradeColumns] = row;
        const [name, globalColumn, ...globalColumns] = acc;
        return [
            name,
            {
                total: globalColumn.total + summaryColumn.total,
                points: globalColumn.points + summaryColumn.points
            },
            ...gradeColumns.map((c, i)=>{
                const g = globalColumns[i] || {
                    total: 0,
                    points: 0
                };
                return {
                    total: c.total + g.total,
                    points: c.points + g.points
                };
            })
        ];
    }, [
        translate('global-grade'),
        {
            total: 0,
            points: 0
        }
    ]);
    const rows = [
        globalRow
    ].concat(quizRows);
    const summary = ({ total, points })=>total == 0 ? 0 : `${(points / total * 100).toFixed(2)}%`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
        children: rows.map((row, index)=>{
            const [nameColumn, summaryColumn, ...gradeColumns] = row;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                className: classes.row,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "left",
                        className: classes.cell,
                        children: nameColumn
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        className: (0, _clsxDefault.default)(classes.cell, 'summary'),
                        children: summary(summaryColumn)
                    }),
                    gradeColumns.map((column, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "center",
                            className: (0, _clsxDefault.default)(classes.cell),
                            children: summary(column)
                        }, index)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        className: classes.filler,
                        style: {
                            top: 92
                        },
                        align: "right"
                    })
                ]
            }, index);
        })
    });
}
function studentGradesSummaryBodyStyles() {
    return {
        cell: {
            padding: 0,
            color: '#4f576e',
            fontWeight: 500,
            borderLeft: 'solid 1px #d8dbe0',
            borderRight: 'solid 1px #d8dbe0',
            '&:first-child': {
                borderLeft: 0,
                paddingLeft: 10
            },
            '&.summary': {
                backgroundColor: '#f5fff6'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","lodash":"1qc47","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableRow":"4f4VX","@mui/material/TableBody":"bPEEy","helpers/moment":"jwdju","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"keGh9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentGradesSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _context = require("teacher/context");
var _studentAnsweredAssessmentsHead = require("./student-answered-assessments-head");
var _studentAnsweredAssessmentsHeadDefault = parcelHelpers.interopDefault(_studentAnsweredAssessmentsHead);
var _studentAnsweredAssessmentsBody = require("./student-answered-assessments-body");
var _studentAnsweredAssessmentsBodyDefault = parcelHelpers.interopDefault(_studentAnsweredAssessmentsBody);
var _studentAnsweredAssessmentsFilters = require("./student-answered-assessments-filters");
var _studentAnsweredAssessmentsFiltersDefault = parcelHelpers.interopDefault(_studentAnsweredAssessmentsFilters);
const useStyles = (0, _material.makeStyles)(studentAnsweredAssessmentsStyles);
function StudentGradesSummary() {
    const { groupsLoaded, rollbookContextGrades: grades } = (0, _react.useContext)((0, _context.TeacherContext));
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentAnsweredAssessmentsFiltersDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                className: classes.container,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fadeDefault.default), {
                    in: groupsLoaded && grades.loaded,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                        className: classes.table,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentAnsweredAssessmentsHeadDefault.default), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _studentAnsweredAssessmentsBodyDefault.default), {})
                        ]
                    })
                })
            })
        ]
    });
}
function studentAnsweredAssessmentsStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            marginTop: 30,
            flexGrow: 1,
            overflow: 'hidden'
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            overflow: 'auto',
            border: 'solid 1px #d8dbe0',
            borderTop: 0,
            [theme.breakpoints.down('xs')]: {
                border: 0
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","helpers/moment":"jwdju","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Fade":"8DwqP","@mui/material/TableContainer":"2Kmn7","@mui/material/Table":"if4Vw","teacher/context":"5LKDx","./student-answered-assessments-head":"7EcLK","./student-answered-assessments-body":"iJT1b","./student-answered-assessments-filters":"bsgWr","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7EcLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>GradesHead);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(studentAnsweredAssessmentsHeadStyles);
const headCells = [
    {
        id: 'date',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'title',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'period',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'type',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'total',
        align: 'center',
        disablePadding: false
    },
    {
        id: 'points',
        align: 'center',
        disablePadding: false
    },
    {
        id: 'grade',
        align: 'center',
        disablePadding: false
    }
];
function GradesHead(props) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const location = (0, _reactRouterDom.useLocation)();
    const { query, translate, linkQuery } = context;
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderBy = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    const createSortHandler = (property)=>(event)=>{
            history.push(linkQuery(location.pathname, {
                ...query,
                orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`
            }));
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
            className: classes.headersRow,
            children: [
                headCells.map(({ id, align, disablePadding })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        padding: disablePadding ? 'none' : 'normal',
                        className: classes.headerCell,
                        sortDirection: order,
                        onClick: createSortHandler(id),
                        style: {
                            top: 92
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableSortLabelDefault.default), {
                            className: (0, _clsxDefault.default)(classes.headerLabel, align),
                            active: orderBy === id,
                            direction: order,
                            children: [
                                translate(`${id}-student-answered-assessment-header`),
                                orderBy === id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: classes.visuallyHidden,
                                    children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                                }) : null
                            ]
                        })
                    }, id)),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.filler,
                    style: {
                        top: 92
                    },
                    align: "right"
                })
            ]
        })
    });
}
function studentAnsweredAssessmentsHeadStyles() {
    return {
        headersRow: {
            color: '#50566e',
            '& > th': {
                backgroundColor: '#f1faff'
            }
        },
        headerCell: {
            padding: 0,
            paddingLeft: 16,
            color: '#4f576e',
            borderLeft: 'solid 1px #d8dbe0',
            borderRight: 'solid 1px #d8dbe0',
            '&:first-child': {
                borderLeft: 0
            },
            "& .label": {
                padding: '0 10px',
                textAlign: 'center'
            },
            "&.filler": {
                borderLeft: 'solid 1px #d8dbe0',
                width: 0,
                padding: 0
            }
        },
        headerLabel: {
            color: '#4f576e',
            fontWeight: 'bold',
            '&.center': {
                display: 'flex',
                justifyContent: 'center'
            }
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","helpers/moment":"jwdju","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/TableSortLabel":"3xCAT","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iJT1b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentAnsweredAssessmentsBody);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _lodash = require("lodash");
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _gradeInput = require("components/gradebook/GradeInput");
var _gradeInputDefault = parcelHelpers.interopDefault(_gradeInput);
var _command = require("helpers/command");
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _context = require("teacher/context");
var _gradebook = require("helpers/gradebook");
const useStyles = (0, _material.makeStyles)(studentAnsweredAssessmentsBodyStyles);
const sorters = {
    date: (items, order)=>(0, _lodash.orderBy)(items, [
            (a)=>(0, _momentDefault.default)(a.finished).valueOf()
        ], [
            order
        ]),
    title: (items, order)=>(0, _lodash.orderBy)(items, [
            'title'
        ], [
            order
        ]),
    period: (items, order)=>(0, _lodash.orderBy)(items, [
            (a)=>a.period && a.period.properties && a.period.properties.name || ''
        ], [
            order
        ]),
    type: (items, order)=>(0, _lodash.orderBy)(items, [
            'typeName'
        ], [
            order
        ]),
    total: (items, order)=>(0, _lodash.orderBy)(items, [
            'total'
        ], [
            order
        ]),
    points: (items, order)=>(0, _lodash.orderBy)(items, [
            'points'
        ], [
            order
        ]),
    grade: (items, order)=>(0, _lodash.orderBy)(items, [
            'grade'
        ], [
            order
        ])
};
function StudentAnsweredAssessmentsBody() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { query, translate, link, gradingCategoryMap, studentId, updateState } = context;
    const location = (0, _reactRouterDom.useLocation)();
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderColumn = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    const studentAssessmnents = context.rollbookContextGrades.items.filter((g)=>g.student == studentId);
    const dateFormat = translate('assessment-list-date-format');
    const summary = ({ total, points, properties })=>{
        const adjusted = points + (properties?.bonus || 0);
        return total == 0 ? '0%' : `${(adjusted / total * 100).toFixed(2)}%`;
    };
    const getPeriod = (a)=>context.rollbookContextPeriods.items.find((period)=>(0, _momentDefault.default)(a.start).isSameOrAfter(period.start) && (0, _momentDefault.default)(a.start).isSameOrBefore(period.finish)) || {};
    const translatedItems = studentAssessmnents.map((i)=>({
            ...i,
            typeName: translate(`${i.type == 'homework' ? 'homework' : gradingCategoryMap[i.type]}-label`),
            statusName: translate(i.status),
            period: getPeriod(i),
            grade: summary(i)
        }));
    let filteredItems = translatedItems;
    if (query.periodId) filteredItems = filteredItems.filter((i)=>i.period.id == query.periodId);
    if (query.typeId) filteredItems = filteredItems.filter((i)=>i.type == query.typeId);
    const sorter = sorters[orderColumn];
    const assessments = sorter ? sorter(filteredItems, order) : filteredItems;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
        children: assessments.map((assessment, index)=>{
            const { typeName, external, type, period, title, finished, total, points, grade, answeredAssessment } = assessment;
            const reviewLink = type == 'homework' ? link({
                page: 'homework',
                id: assessment.assignment
            }, '/:languageId/:role/:page/:id') : link({
                page: 'quiz',
                assessmentId: answeredAssessment,
                action: 'review'
            }, '/:languageId/:role/:page/:assessmentId/:action');
            function reviewClickHandler() {
                const commands = type == 'homework' ? {
                    homeworkContext: {
                        review: {
                            from: {
                                $set: location.pathname
                            },
                            query: {
                                $set: query
                            }
                        }
                    }
                } : {
                    quizEditFrom: {
                        $set: location.pathname
                    },
                    quizEditFromQuery: {
                        $set: query
                    }
                };
                updateState(commands);
            }
            const periodName = period.properties && period.properties.name;
            async function handleGradeChange(value) {
                const [grade] = await (0, _command.createPost)('grading', 'updateExternalStudentGrade')({
                    student: studentId,
                    external,
                    value: value || 0
                });
                if (grade) {
                    const index = rollbookContextGrades.items.findIndex((g)=>g.id === grade.id);
                    if (index >= 0) updateState({
                        rollbookContextGrades: {
                            items: {
                                [index]: {
                                    $set: grade
                                }
                            }
                        }
                    });
                    else updateState({
                        rollbookContextGrades: {
                            items: {
                                $push: [
                                    grade
                                ]
                            }
                        }
                    });
                }
            }
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                className: classes.assessmentRow,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "left",
                        className: (0, _clsxDefault.default)(classes.cell, classes.dateCell),
                        children: (0, _momentDefault.default)(finished).format(dateFormat)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "left",
                        className: (0, _clsxDefault.default)(classes.cell, classes.titleCell),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "label",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "left",
                        className: (0, _clsxDefault.default)(classes.cell, classes.periodCell),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "label",
                            children: periodName
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "left",
                        className: (0, _clsxDefault.default)(classes.cell, classes.typeCell),
                        children: typeName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        className: (0, _clsxDefault.default)(classes.cell, classes.totalCell),
                        children: total
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        className: (0, _clsxDefault.default)(classes.cell, classes.pointsCell),
                        children: external ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gradeInputDefault.default), {
                            total: total,
                            value: (0, _gradebook.displayPoints)(assessment),
                            onGradeChange: handleGradeChange,
                            className: classes.gradeInput
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                            to: reviewLink,
                            onClick: reviewClickHandler,
                            className: classes.link,
                            children: (0, _gradebook.displayPoints)(assessment)
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        className: (0, _clsxDefault.default)(classes.cell, classes.gradeCell),
                        children: grade
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        className: (0, _clsxDefault.default)(classes.cell, classes.filler)
                    })
                ]
            }, index);
        })
    });
}
function studentAnsweredAssessmentsBodyStyles() {
    return {
        gradeInput: {
            marginTop: -15
        },
        assessmentRow: {
            transition: 'background-color .5s',
            '&:hover': {
                backgroundColor: '#f8f8f8'
            }
        },
        cell: {
            borderLeft: 'solid 1px #d8dbe0',
            borderRight: 'solid 1px #d8dbe0',
            '&:first-child': {
                borderLeft: 0
            },
            '&.filler': {
                borderLeft: 'solid 1px #d8dbe0',
                width: 0,
                padding: 0
            }
        },
        link: {
            color: '#009dd8',
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': {
                fontWeight: 'bold',
                textDecoration: 'underline'
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","lodash":"1qc47","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableRow":"4f4VX","@mui/material/TableBody":"bPEEy","components/gradebook/GradeInput":"6O1CV","helpers/command":"f3cbG","helpers/moment":"jwdju","teacher/context":"5LKDx","helpers/gradebook":"6ehCA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bsgWr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>StudentAnsweredAssessmentsFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _context = require("teacher/context");
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
const useStyles = (0, _material.makeStyles)(filterStyles);
function StudentAnsweredAssessmentsFilters() {
    const classes = useStyles();
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, query, linkQuery, groupId, gradingCategories } = context;
    const location = (0, _reactRouterDom.useLocation)();
    const { items: periods } = context.rollbookContextPeriods;
    const createFilterHandler = (name, mapQuery)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            const query = mapQuery ? mapQuery(context.query, value) : {
                ...context.query,
                [name]: value
            };
            history.push(linkQuery(location.pathname, {
                ...query
            }));
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            periods.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                id: "student-answered-assessment-period-filter",
                className: (0, _clsxDefault.default)(classes.select, "period"),
                value: context.query.periodId || "",
                onChange: createFilterHandler('periodId'),
                caption: translate('period-filter'),
                children: periods.map((period, key)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: period.id,
                        children: period.properties.name
                    }, key);
                })
            }),
            gradingCategories.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                id: "student-answered-assessment-category-filter",
                className: (0, _clsxDefault.default)(classes.select, "type"),
                value: context.query.typeId || "",
                onChange: createFilterHandler('typeId'),
                caption: translate('category-filter'),
                children: gradingCategories.map((type, key)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                        value: type.id,
                        children: translate(`${type.name}-label`)
                    }, key);
                })
            })
        ]
    });
}
function filterStyles() {
    return {
        root: {
            display: "flex",
            padding: '0 15px 15px 15px',
            display: 'flex',
            border: 'solid 1px #dbe3e6',
            borderRadius: 4,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        select: {
            width: 200,
            '&.type': {
                marginLeft: 30
            }
        },
        filler: {
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","teacher/context":"5LKDx","components/clearable-select":"jWvEj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jkOip":[function() {},{}],"jvdQi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworkRouter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _homeworks = require("./homeworks");
var _homeworksDefault = parcelHelpers.interopDefault(_homeworks);
var _homeworkStudents = require("./homework-students");
var _homeworkStudentsDefault = parcelHelpers.interopDefault(_homeworkStudents);
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
const homeworkPath = '/:languageId/:role/:page(homework)';
function HomeworkRouter() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Switch), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                exact: true,
                path: `${homeworkPath}`,
                component: (0, _homeworksDefault.default)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                exact: true,
                path: `${homeworkPath}/:homeworkId(${UUID})`,
                component: (0, _homeworkStudentsDefault.default)
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","./homeworks":"7qlS5","./homework-students":"hgJ7l","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7qlS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Homeworks);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _filterChip = require("./components/filter-chip");
var _filterChipDefault = parcelHelpers.interopDefault(_filterChip);
var _homeworkFilters = require("./components/homework-filters");
var _homeworkFiltersDefault = parcelHelpers.interopDefault(_homeworkFilters);
var _homeworksHead = require("./components/homeworks-head");
var _homeworksHeadDefault = parcelHelpers.interopDefault(_homeworksHead);
var _homeworksBody = require("./components/homeworks-body");
var _homeworksBodyDefault = parcelHelpers.interopDefault(_homeworksBody);
var _createHomework = require("./components/create-homework");
var _createHomeworkDefault = parcelHelpers.interopDefault(_createHomework);
var _deleteHomework = require("./components/delete-homework");
var _deleteHomeworkDefault = parcelHelpers.interopDefault(_deleteHomework);
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(homeworkStyles);
function Homeworks() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate } = context;
    const classes = useStyles();
    const path = context.link('homeworks');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.filters,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworkFiltersDefault.default), {
                        context: context
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createHomeworkDefault.default), {
                        context: context
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteHomeworkDefault.default), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: classes.chips,
                children: [
                    context.query.pattern && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "pattern",
                        context: context,
                        path: path
                    }),
                    context.query.id && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterChipDefault.default), {
                        name: "id",
                        context: context,
                        createLabel: ()=>translate('new-homework'),
                        path: path
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                    className: classes.container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                        className: classes.table,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworksHeadDefault.default), {
                                context: context
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworksBodyDefault.default), {
                                context: context
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function homeworkStyles() {
    return {
        root: {
            flexGrow: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            borderRadius: '4px',
            boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
        },
        content: {
            display: 'flex',
            flexGrow: 1,
            overflow: 'hidden'
        },
        container: {
            flexGrow: 1,
            overflow: 'auto'
        },
        chips: {
            padding: 10,
            '& .filter-chip': {
                backgroundColor: '#de3434',
                color: '#fff',
                '& .MuiChip-label': {
                    padding: '0 20px'
                },
                '& .MuiChip-deleteIcon': {}
            }
        },
        filters: {
            display: 'flex',
            padding: '0 15px 8px 15px',
            "& .create-quiz-wrapper": {
                display: "flex",
                marginTop: 15,
                flexDirection: "column",
                justifyContent: "center",
                paddingLeft: 15
            }
        },
        createButton: {
            margin: '10px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TableContainer":"2Kmn7","@mui/material/Table":"if4Vw","./components/filter-chip":"9mexF","./components/homework-filters":"6pUE5","./components/homeworks-head":"5pjrN","./components/homeworks-body":"gikAd","./components/create-homework":"etcQs","./components/delete-homework":"5p0uh","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9mexF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>FilterChip);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _chip = require("@mui/material/Chip");
var _chipDefault = parcelHelpers.interopDefault(_chip);
function FilterChip(props) {
    const history = (0, _reactRouterDom.useHistory)();
    const { name, createLabel = (a)=>a, context, path } = props;
    const label = createLabel(context.query[name]);
    function handleDelete() {
        const query = {
            ...context.query,
            [name]: undefined
        };
        history.push(context.linkQuery(path, {
            ...context.query,
            [name]: undefined
        }));
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chipDefault.default), {
        label: label,
        onDelete: handleDelete,
        className: "filter-chip"
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","@mui/material/Chip":"eSSCi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6pUE5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworkFilters);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _searchPattern = require("components/search-pattern");
var _searchPatternDefault = parcelHelpers.interopDefault(_searchPattern);
var _clearableSelect = require("components/clearable-select");
var _clearableSelectDefault = parcelHelpers.interopDefault(_clearableSelect);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
const useStyles = (0, _material.makeStyles)(filterStyles);
function HomeworkFilters({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { translate, link, linkQuery, tab, myCourses, groups } = context;
    const createFilterHandler = (name, mapQuery)=>(event)=>{
            const value = event.target.value == '' ? undefined : event.target.value;
            const query = mapQuery ? mapQuery(context.query, value) : {
                ...context.query,
                [name]: value
            };
            history.push(linkQuery(link(), {
                ...query
            }));
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.root,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
            className: classes.filters,
            children: [
                groups.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearableSelectDefault.default), {
                    id: "homework-group-filter",
                    className: (0, _clsxDefault.default)(classes.select, "group"),
                    value: context.query.group || "",
                    onChange: createFilterHandler('group'),
                    caption: translate('group_label'),
                    children: groups.map((group)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                            value: group.id,
                            children: group.name
                        }, group.id);
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.pattern,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchPatternDefault.default), {
                        path: context.link(),
                        context: context
                    })
                })
            ]
        })
    });
}
function filterStyles() {
    return {
        root: {
            display: "flex",
            flexGrow: 1,
            flexDirection: "column"
        },
        filters: {
            flexGrow: 1,
            marginTop: 10,
            display: "flex"
        },
        select: {
            marginLeft: 15,
            '&:first-child': {
                marginLeft: 0
            },
            '&:last-child': {
                marginRight: 15
            },
            '&.type': {
                flexGrow: 1,
                minWidth: 120
            },
            '&.group': {
                flexGrow: 1,
                minWidth: 120,
                maxWidth: 300
            },
            '&.course': {
                flexGrow: 1,
                minWidth: 120,
                maxWidth: 300
            }
        },
        filler: {
            flexGrow: 1
        },
        pattern: {
            marginLeft: 15,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            border: 'solid 1px #bec4d2',
            display: 'flex',
            flexWrap: 'nowrap',
            borderRadius: '3px',
            backgroundColor: '#fff',
            padding: 0,
            height: 39,
            marginTop: 16
        }
    };
} /*


      {context.subjects.length > 0 && (
        <ClearableSelect
          id="quiz-subject-filter"
          className={clsx(classes.select, "subject")}
          value={context.query.subject || ""}
          onChange={createFilterHandler('subject', (query, subject) => ({...query, course: undefined, subject}))}
          caption={translate('subject_label')}
        >
          {context.subjects.map((subject, key) => {
            return (<MenuItem value={subject.id} key={key}>{subject.name}</MenuItem>)
          })}
        </ClearableSelect>
      )}
      

*/ 

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","clsx":"5PNR8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","components/search-pattern":"lUZFT","components/clearable-select":"jWvEj","@mui/material/Box":"73kto","@mui/material/MenuItem":"a18vm","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5pjrN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworksHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
const headCells = [
    // { id: 'created', align: 'left', disablePadding: false},
    {
        id: 'title',
        align: 'left',
        disablePadding: false
    },
    // { id: 'courseName', align: 'left', disablePadding: false},
    {
        id: 'groupName',
        align: 'left',
        disablePadding: true
    },
    {
        id: 'startDate',
        align: 'center',
        disablePadding: false
    },
    {
        id: 'endDate',
        align: 'center',
        disablePadding: false
    },
    {
        id: 'score',
        align: 'center',
        disablePadding: false
    },
    {
        id: 'files',
        align: 'center',
        disablePadding: false,
        visuallyHidden: true
    },
    {
        id: 'received',
        align: 'left',
        disablePadding: false
    }
];
const useStyles = (0, _material.makeStyles)(homeworkHeadStyles);
function HomeworksHead({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { query, translate, link, linkQuery } = context;
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderBy = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    const createSortHandler = (property)=>(event)=>{
            history.push(linkQuery(link('homeworks'), {
                ...query,
                orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`
            }));
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
            className: classes.headersRow,
            children: [
                headCells.map(({ id, align, disablePadding })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: align,
                        padding: disablePadding ? 'none' : 'normal',
                        sortDirection: order,
                        style: {
                            top: 92
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableSortLabelDefault.default), {
                            className: (0, _clsxDefault.default)(classes.headerLabel, id),
                            active: orderBy === id,
                            direction: order,
                            onClick: createSortHandler(id),
                            children: [
                                translate(`${id}-header`),
                                orderBy === id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: classes.visuallyHidden,
                                    children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                                }) : null
                            ]
                        })
                    }, id)),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.actions,
                    style: {
                        top: 92
                    },
                    align: "right"
                })
            ]
        })
    });
}
function homeworkHeadStyles() {
    return {
        headersRow: {
            color: '#50566e',
            '& > th': {
                borderTop: 'solid 1px #becfd7',
                backgroundColor: '#ffffff'
            }
        },
        headerLabel: {
            marginLeft: 18,
            color: '#4f576e',
            fontWeight: 500
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/TableSortLabel":"3xCAT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gikAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworksBody);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _person = require("@mui/icons-material/Person");
var _personDefault = parcelHelpers.interopDefault(_person);
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _homeworkFiles = require("./homework-files");
var _homeworkFilesDefault = parcelHelpers.interopDefault(_homeworkFiles);
const useStyles = (0, _material.makeStyles)(homeworkBodyStyles);
function HomeworksBody({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { query, translate, link, linkQuery, homeworkContext, groups, profile } = context;
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderBy = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    function formatDate(date) {
        return (0, _momentDefault.default)(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
    }
    function formatTime(date) {
        return (0, _momentDefault.default)(date).format('hh:mm A');
    }
    function editHomework(homework) {
        context.updateState({
            homeworkContext: {
                createHomework: {
                    open: {
                        $set: true
                    },
                    editing: {
                        $set: true
                    },
                    editState: {
                        $set: homework
                    }
                }
            }
        });
    }
    function deleteHomework(homework) {
        context.updateState({
            homeworkContext: {
                deleteHomework: {
                    open: {
                        $set: true
                    },
                    homework: {
                        $set: homework
                    }
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
        children: homeworkContext.homeworks.items.map((row)=>{
            const group = groups.find((x)=>x.id == row.group) || {};
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                className: classes.row,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "left",
                        className: classes.title,
                        children: row.title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: (0, _clsxDefault.default)(classes.group),
                            children: group.name
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _clsxDefault.default)(classes.startDate, classes.dateCell),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "date",
                                    children: formatDate(row.startDate)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "time",
                                    children: formatTime(row.startDate)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: (0, _clsxDefault.default)(classes.endDate, classes.dateCell),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "date",
                                    children: formatDate(row.endDate)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "time",
                                    children: formatTime(row.endDate)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: (0, _clsxDefault.default)(classes.score),
                            children: row.properties.score
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: "center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: (0, _clsxDefault.default)(classes.files),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworkFilesDefault.default), {
                                context: context,
                                passport: profile.Passport.id,
                                files: row.properties.files
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        className: classes.students,
                        align: "center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                            title: translate('view-homework-tooltip'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Link), {
                                to: link({
                                    page: 'homework',
                                    homeworkId: row.id
                                }),
                                className: (0, _clsxDefault.default)(classes.link, classes.textLink),
                                children: [
                                    row.turnIns,
                                    " / ",
                                    row.students.length,
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _personDefault.default), {
                                        className: classes.personIcon
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableCellDefault.default), {
                        className: classes.actions,
                        style: {
                            top: 92
                        },
                        align: "right",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                title: translate('edit-homework-tooltip'),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    onClick: ()=>editHomework(row),
                                    className: (0, _clsxDefault.default)(classes.link, classes.editLink),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faEdit)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tooltipDefault.default), {
                                title: translate('delete-homework-tooltip'),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    onClick: ()=>deleteHomework(row),
                                    className: (0, _clsxDefault.default)(classes.link, classes.deleteLink),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                                        icon: (0, _freeSolidSvgIcons.faTrash)
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, row.id);
        })
    });
}
function homeworkBodyStyles() {
    return {
        title: {
            paddingLeft: 33
        },
        row: {
            color: '#4f576e'
        },
        actions: {
            width: 100,
            minWidth: 100
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        },
        personIcon: {
            color: '#009dd8',
            position: 'relative',
            top: 5,
            left: 6
        },
        textLink: {
            color: '#009dd8',
            fontSize: '12pt !important',
            marginRight: 20,
            cursor: 'pointer',
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline'
            }
        },
        link: {
            color: '#009dd8',
            fontSize: '16pt',
            marginRight: 20,
            cursor: 'pointer'
        },
        deleteLink: {
            fontSize: '15.5pt',
            color: '#e56666'
        },
        group: {},
        score: {
            marginLeft: '-15px'
        },
        dateCell: {
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            fontSize: '0.875rem',
            "& .date": {
                display: 'flex',
                justifyContent: 'flex-start',
                marginRight: 10
            },
            "& .time": {
                display: 'flex',
                justifyContent: 'flex-end'
            }
        },
        files: {
            marginLeft: '-10px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableRow":"4f4VX","@mui/material/TableBody":"bPEEy","helpers/moment":"jwdju","@mui/icons-material/Person":"6tc0D","@mui/material/Tooltip":"7bRLE","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","./homework-files":"5fg2m","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6tc0D":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("ffa2e5f361de2684");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("7ba8b00450bd1ab6"));
var _jsxRuntime = require("8bc838c1ac3a31d0");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'Person');

},{"ffa2e5f361de2684":"kZ6eK","7ba8b00450bd1ab6":"2vOnF","8bc838c1ac3a31d0":"1dlk8"}],"5fg2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworkFiles);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _popover = require("@mui/material/Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _attachFile = require("@mui/icons-material/AttachFile");
var _attachFileDefault = parcelHelpers.interopDefault(_attachFile);
var _insertDriveFile = require("@mui/icons-material/InsertDriveFile");
var _insertDriveFileDefault = parcelHelpers.interopDefault(_insertDriveFile);
var _url = require("helpers/url");
const useStyles = (0, _material.makeStyles)(homeworkBodyStyles);
function HomeworkFiles({ passport, files = [] }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const handleViewFilesClick = (event)=>{
        if (!files.length) return;
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const openPopOver = Boolean(anchorEl);
    const id = openPopOver ? 'popover' : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                onClick: (e)=>{
                    handleViewFilesClick(e);
                },
                className: (0, _clsxDefault.default)(classes.attachedFiles),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachFileDefault.default), {
                    className: (0, _clsxDefault.default)(classes.attachedFiles, {
                        disabled: files.length == 0
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverDefault.default), {
                id: id,
                open: openPopOver,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.fileDownload,
                    children: files.map((f, i)=>{
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _insertDriveFileDefault.default), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    ...(0, _url.viewerGuard)({
                                        href: (0, _url.contentLink)(passport, f.folder, f.name),
                                        target: "_blank"
                                    }),
                                    children: f.name
                                })
                            ]
                        }, i);
                    })
                })
            })
        ]
    });
}
function homeworkBodyStyles() {
    return {
        statusIndicator: {
            '&.available': {
                backgroundColor: 'orange',
                borderRadius: '100%',
                width: 15,
                height: 15,
                display: 'inline-block',
                marginRight: 10
            }
        },
        title: {
            cursor: 'pointer',
            width: '30%',
            '&:hover': {
                color: '#127e7e',
                textDecoration: 'underline'
            }
        },
        statusName: {
            padding: '5px',
            color: '#fff',
            borderRadius: '20px',
            display: 'inline-block',
            width: 100,
            textAlign: 'center',
            '&.assigned': {
                backgroundColor: '#f78d43'
            },
            '&.completed': {
                backgroundColor: '#06b71c'
            },
            '&.pending': {
                backgroundColor: '#0ac7ff'
            },
            '&.returned': {
                backgroundColor: '#ff0a0a'
            }
        },
        scoreField: {
            fontSize: '14pt',
            fontWeight: 'bold'
        },
        scoreTextBox: {
            width: 70,
            height: 30,
            border: '1px solid #ccc',
            marginRight: 15,
            textAlign: 'center',
            padding: '0 5px',
            borderRadious: 4
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        },
        personIcon: {
            color: '#128080',
            position: 'relative',
            top: 6
        },
        link: {
            color: '#009dd8',
            fontSize: '16pt',
            marginRight: 20,
            cursor: 'pointer'
        },
        attachedFiles: {
            color: '#009dd',
            cursor: 'pointer',
            '&.disabled': {
                fill: '#ccc',
                cursor: 'default'
            },
            '& > svg': {
                fill: "#009dd8"
            }
        },
        fileDownload: {
            padding: 25,
            '& > div': {
                borderBottom: '1px dotted #ccc',
                padding: '10px 0'
            },
            '& > div:last-child': {
                borderBottom: 'none'
            },
            '& > div > svg': {
                fill: '#ccc',
                height: 20
            },
            '& > div > a': {
                position: 'relative',
                top: -3,
                color: '#009dd8',
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'underline'
                }
            }
        },
        feedbackBox: {
            display: 'block',
            margin: '10px 0',
            backgroundColor: '#e8e8e8',
            padding: 5,
            borderRadius: 3,
            '& label': {
                fontSize: '12px'
            }
        },
        feedbackText: {
            fontSize: '12px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: 10,
            borderRadius: 4,
            border: '1px solid #ccc',
            width: '100%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/Popover":"keu0V","@mui/icons-material/AttachFile":"7ucfJ","@mui/icons-material/InsertDriveFile":"elo1T","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7ucfJ":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("9baac12b24a4e8c7");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("96215313462bf25"));
var _jsxRuntime = require("cad3608c8d49d0f2");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6z"
}), 'AttachFile');

},{"9baac12b24a4e8c7":"kZ6eK","96215313462bf25":"2vOnF","cad3608c8d49d0f2":"1dlk8"}],"elo1T":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("5af2c18be9cb02a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("312341b9c7042b17"));
var _jsxRuntime = require("fb725c84ade380c8");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm7 7V3.5L18.5 9z"
}), 'InsertDriveFile');

},{"5af2c18be9cb02a":"kZ6eK","312341b9c7042b17":"2vOnF","fb725c84ade380c8":"1dlk8"}],"etcQs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateHomework);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _form = require("./form");
var _formDefault = parcelHelpers.interopDefault(_form);
const AddButton = (0, _material.withStyles)(addButtonStyles)((0, _buttonDefault.default));
const useStyles = (0, _material.makeStyles)(createHomeworkStyles);
function CreateHomework({ context, hidden }) {
    const classes = useStyles();
    function handleOpenDialog() {
        context.updateState({
            homeworkContext: {
                createHomework: {
                    open: {
                        $set: true
                    },
                    editing: {
                        $set: false
                    },
                    editState: {
                        $set: undefined
                    }
                }
            }
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, {
            hidden
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(AddButton, {
                "aria-haspopup": "true",
                variant: "contained",
                color: "primary",
                onClick: handleOpenDialog,
                className: classes.button,
                children: context.translate('create-homework')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDefault.default), {
                context: context
            })
        ]
    });
}
function addButtonStyles() {
    return {
        root: {
            fontSize: '13pt',
            textTransform: 'capitalize',
            backgroundColor: '#2ca5ec',
            color: '#fff',
            '& svg': {},
            '&:hover': {
                backgroundColor: '#0069d9',
                borderColor: '#0062cc',
                boxShadow: 'none'
            }
        }
    };
}
function createHomeworkStyles() {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            '&.hidden': {
                display: 'none'
            }
        },
        button: {
            flexGrow: 1,
            margin: 15,
            marginTop: 24,
            paddingLeft: 30,
            paddingRight: 30
        },
        menu: {}
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Button":"c6Y0y","@mui/material/Box":"73kto","./form":"i2gt9","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i2gt9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CreateHomeworkForm);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("external/moment");
var _lodash = require("external/lodash");
var _react = require("external/react");
var _material = require("external/material");
var _url = require("helpers/url");
var _formHook = require("helpers/form-hook");
var _validationsHook = require("helpers/validations-hook");
var _validationsHookDefault = parcelHelpers.interopDefault(_validationsHook);
var _command = require("helpers/command");
var _utils = require("helpers/utils");
var _datePicker = require("../date-picker");
var _datePickerDefault = parcelHelpers.interopDefault(_datePicker);
var _checkboxlist = require("../checkboxlist");
var _checkboxlistDefault = parcelHelpers.interopDefault(_checkboxlist);
var _textInput = require("./TextInput");
var _textInputDefault = parcelHelpers.interopDefault(_textInput);
var _select = require("./Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _validations = require("./validations");
var _validationsDefault = parcelHelpers.interopDefault(_validations);
var _uploadFiles = require("uploads/UploadFiles");
var _uploadFilesDefault = parcelHelpers.interopDefault(_uploadFiles);
var _store = require("uploads/redux/store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const initialState = {
    attempted: false,
    title: '',
    group: '',
    startDate: new Date(),
    endDate: (0, _moment.moment)().endOf('day').toDate(),
    instructions: '',
    students: [],
    includeInRollbook: false,
    score: '0',
    files: [],
    folderId: (0, _utils.uuid)(),
    disableEditGroups: false
};
const useStyles = (0, _material.makeStyles)(createStyles);
const useStudentListStyles = (0, _material.makeStyles)(studentListStyles);
function CreateHomeworkForm({ context }) {
    const classes = useStyles();
    const studentListClasses = useStudentListStyles();
    const history = (0, _react.useHistory)();
    const theme = (0, _material.useTheme)();
    //const notificationsContext = useContext(NotificationsContext)
    const fullScreen = (0, _material.useMediaQuery)(theme.breakpoints.down('sm'));
    const { translate, homeworkContext, link, linkQuery, groups, profile: { Passport: passport } } = context;
    const { open, editing, editState } = homeworkContext.createHomework;
    const { state, setState, handleChange, resetState, createHandler, updateState: updateFormState, hasStateChanged } = (0, _formHook.useImmutableForm)(initialState);
    const { errors, errorCount, validate, resetErrors } = (0, _validationsHookDefault.default)((0, _validationsDefault.default));
    const { students: myStudents = [] } = groups.find((g)=>g.id == state.group) || {};
    function closeDialog() {
        context.updateState({
            homeworkContext: {
                createHomework: {
                    open: {
                        $set: false
                    },
                    editing: {
                        $set: false
                    },
                    editState: {
                        $set: undefined
                    }
                }
            }
        });
        resetState({
            folderId: false
        });
        resetErrors();
        (0, _storeDefault.default).dispatch(resetUploads());
    }
    const resetUploads = ()=>(dispatch)=>{
            dispatch({
                type: 'RESET_UPLOADS'
            });
        };
    function loadUploads() {
        if (!editState.properties.files) return;
        editState.properties.files.map((f)=>{
            f.server = `${0, _url.apiProtocol}://${0, _url.contentHost}.${(0, _url.parentDomain)()}/files`;
        });
        const loadUploads = ()=>(dispatch)=>{
                dispatch({
                    type: 'LOAD_UPLOADS',
                    payload: editState.properties.files
                });
            };
        (0, _storeDefault.default).dispatch(loadUploads());
    }
    async function save() {
        if (!hasStateChanged()) return;
        let files = (0, _lodash.toArray)((0, _storeDefault.default).getState().UploadFile.fileProgress).filter((f)=>!f.deleted && f.progress == 100).map((file)=>{
            return {
                name: file.file.name,
                folder: file.folder
            };
        });
        if (validate({
            ...state,
            attempted: true
        })) {
            const { title, group, startDate, endDate, instructions, students, score, includeInRollbook } = state;
            const homework = {
                title,
                group,
                startDate: (0, _moment.moment)(startDate).toISOString(),
                endDate: (0, _moment.moment)(endDate).toISOString(),
                students,
                properties: {
                    instructions,
                    score,
                    files,
                    includeInRollbook
                }
            };
            const saveCommand = (0, _command.createPost)('homework', 'saveHomework')({
                id: editing ? editState.id : undefined,
                ...homework
            });
            const [homeworkId] = await saveCommand;
            if (homeworkId) {
                //createHomeworkNotification(context, {group, id: homeworkId, students})
                await context.updateState({
                    homeworkContext: {
                        homeworks: {
                            refreshes: {
                                $apply: (i)=>i + 1
                            }
                        }
                    }
                });
                closeDialog();
            } else setState({
                ...state,
                attempted: true
            });
        } else setState({
            ...state,
            attempted: true
        });
    }
    (0, _react.React).useEffect(()=>{
        if (!editing && state.group != context.query.group) setState({
            ...state,
            group: context.query.group
        });
    }, [
        context.query.group
    ]);
    (0, _react.React).useEffect(()=>{
        validate(state);
    }, [
        state
    ]);
    (0, _react.React).useEffect(()=>{
        if (!editing && open) setState({
            ...state,
            folderId: (0, _utils.uuid)()
        });
    }, [
        open
    ]);
    (0, _react.React).useEffect(()=>{
        if (editState) {
            const { title, group, startDate, endDate, properties } = editState;
            const includeInRollbook = properties.includeInRollbook || false;
            const students = editState.students.map((s)=>s.student);
            const disableEditGroups = editState.students.some((s)=>s.properties.files && s.properties.files.length > 0);
            const folderId = properties.files && properties.files.length > 0 ? properties.files[0].folder.substring(properties.files[0].folder.indexOf('/') + 1) : (0, _utils.uuid)();
            setState({
                title,
                group,
                startDate,
                endDate,
                students,
                disableEditGroups,
                folderId,
                ...properties,
                includeInRollbook
            });
            loadUploads();
        } else resetState({
            folderId: (0, _utils.uuid)()
        });
    }, [
        editState
    ]);
    // console.log('state', state)
    // console.log('files', editState?JSON.stringify(editState.properties.files):'')
    // console.log('myStudents', myStudents)
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Dialog), {
        className: classes.dialog,
        fullScreen: fullScreen,
        maxWidth: "lg",
        open: open,
        onClose: closeDialog,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.DialogTitle), {
                className: classes.title,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                        className: classes.titleText,
                        children: editing ? translate('edit-homework') : translate('new-homework')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        className: classes.titleActions,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                                variant: "contained",
                                className: (0, _material.clsx)(classes.button, "cancel"),
                                onClick: closeDialog,
                                children: translate('cancel')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                                variant: "contained",
                                className: (0, _material.clsx)(classes.button, "create"),
                                onClick: save,
                                children: translate(editing ? 'save' : 'assign')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                    display: "flex",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                            className: (0, _material.clsx)(classes.leftColumn),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                    className: (0, _material.clsx)(classes.field, "title"),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                                        controlFullWidth: true,
                                        controlVariant: "outlined",
                                        controlMargin: "dense",
                                        id: "title",
                                        inputAutoComplete: "title",
                                        labelRequired: true,
                                        inputAutoFocus: true,
                                        caption: translate('title'),
                                        value: state.title,
                                        inputOnChange: handleChange('title'),
                                        controlError: errors.title.length > 0,
                                        errorMessage: errors.title.length > 0 ? translate(errors.title) : undefined
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                    className: (0, _material.clsx)(classes.instructions, classes.field, {
                                        error: errors.instructions.length > 0
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                            className: (0, _material.clsx)("description", "label"),
                                            children: [
                                                translate('instructions'),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "homeworkInstructions",
                                            value: state.instructions,
                                            onChange: handleChange('instructions')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "homeworkInstructions",
                                            children: translate(errors.instructions)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                    className: (0, _material.clsx)(classes.scoreRollbook, "score-rollbook"),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                            className: (0, _material.clsx)(classes.field, "score"),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInputDefault.default), {
                                                controlFullWidth: true,
                                                controlVariant: "outlined",
                                                controlMargin: "dense",
                                                id: "score",
                                                inputAutoComplete: "score",
                                                labelRequired: true,
                                                inputAutoFocus: true,
                                                caption: translate('score'),
                                                value: state.score,
                                                inputType: "number",
                                                inputInputProps: {
                                                    min: 0,
                                                    max: 1000
                                                },
                                                inputOnChange: handleChange('score')
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                            className: (0, _material.clsx)(classes.field, 'rollbook'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.FormControlLabel), {
                                                control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                                                    color: "primary",
                                                    checked: state.includeInRollbook,
                                                    onChange: handleChange('includeInRollbook', (e)=>e.target.checked)
                                                }),
                                                label: `${translate('include-in-rollbook')}:`,
                                                labelPlacement: "start"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                    className: (0, _material.clsx)(classes.dates),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                            className: (0, _material.clsx)(classes.dates, 'dateField'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                                    className: (0, _material.clsx)(classes.dates, "labelName"),
                                                    children: [
                                                        translate('homework-from-date'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                                    date: (0, _moment.moment)(state.startDate).toDate(),
                                                    minDate: new Date(),
                                                    maxDate: (0, _moment.moment)().add(1, 'year').toDate(),
                                                    context: context,
                                                    onChange: createHandler((startDate)=>{
                                                        const endDate = (0, _moment.moment)(state.endDate).isAfter(startDate) ? state.endDate : (0, _moment.moment)(startDate).endOf('day').toDate();
                                                        return {
                                                            startDate,
                                                            endDate
                                                        };
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                            className: (0, _material.clsx)(classes.dates, 'dateField'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                                    className: (0, _material.clsx)(classes.dates, "labelName"),
                                                    children: [
                                                        translate('homework-to-date'),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _datePickerDefault.default), {
                                                    date: (0, _moment.moment)(state.endDate).toDate(),
                                                    minDate: (0, _moment.moment)(state.startDate).toDate(),
                                                    maxDate: (0, _moment.moment)().add(1, 'year').toDate(),
                                                    context: context,
                                                    onChange: createHandler((endDate)=>({
                                                            endDate
                                                        }))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                    className: (0, _material.clsx)(classes.resources),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                            className: (0, _material.clsx)(classes.resources, 'label'),
                                            children: translate('homework-material')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                            className: (0, _material.clsx)(classes.resources, 'container'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadFilesDefault.default), {
                                                server: `${(0, _url.apiProtocol)}://${(0, _url.contentHost)}.${(0, _url.parentDomain)()}/files`,
                                                folder: `homeworks/${state.folderId}`,
                                                translate: translate,
                                                buttonText: translate('agregar-recurso'),
                                                readOnly: false,
                                                downloadServer: (0, _url.contentLink)(passport.id)
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                            className: (0, _material.clsx)("rightColumn"),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                        className: (0, _material.clsx)(classes.field, "group"),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                                            controlFullWidth: true,
                                            controlVariant: "outlined",
                                            controlMargin: "dense",
                                            selectValue: state.group,
                                            selectOnChange: createHandler((event)=>({
                                                    group: event.target.value,
                                                    students: []
                                                })),
                                            caption: translate('groups_label'),
                                            controlError: errors.group.length > 0,
                                            errorMessage: errors.group.length > 0 ? translate(errors.group) : undefined,
                                            mapValue: (o)=>o.id,
                                            mapText: (o)=>o.name,
                                            options: groups,
                                            selectDisabled: state.disableEditGroups
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                        className: (0, _material.clsx)(studentListClasses.wrapper, {
                                            error: errors.students.length > 0
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                                                className: (0, _material.clsx)("students"),
                                                children: [
                                                    translate('students'),
                                                    ":"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxlistDefault.default), {
                                                classes: studentListClasses,
                                                canSelectAll: true,
                                                selectAllLabel: translate('select-all'),
                                                handleSelectAll: (students)=>updateFormState({
                                                        students: {
                                                            $set: students
                                                        }
                                                    }),
                                                options: myStudents,
                                                checked: state.students,
                                                mapLabel: (o)=>o.name,
                                                mapValue: (o)=>o.id,
                                                // disabled={state.disableEditGroups}
                                                handleToggle: (student)=>{
                                                    const index = state.students.indexOf(student);
                                                    updateFormState(index < 0 ? {
                                                        students: {
                                                            $push: [
                                                                student
                                                            ]
                                                        }
                                                    } : {
                                                        students: {
                                                            $splice: [
                                                                [
                                                                    index,
                                                                    1
                                                                ]
                                                            ]
                                                        }
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    children: translate(errors.students)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
function createStyles(theme) {
    return {
        root: {
            display: 'flex'
        },
        leftColumn: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            marginRight: 30
        },
        rightColumn: {
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column'
        },
        titleText: {
            textTransform: 'capitalize',
            fontWeight: 'bold',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            position: 'absolute',
            color: '#4e576e',
            marginTop: 10
        },
        titleActions: {
            float: 'right'
        },
        title: {
            borderBottom: '1px solid #ccc',
            clear: 'both',
            marginBottom: 35
        },
        instructions: {
            minHeight: '100px',
            marginBottom: 35,
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            '& .description': {
                fontSize: '12pt',
                fontWeight: 'bold',
                marginBottom: 5,
                color: '#878ea1',
                display: 'block',
                whiteSpace: 'nowrap',
                textTransform: 'capitalize'
            },
            '& > textarea': {
                resize: 'none',
                flexGrow: 1,
                borderRadius: '4px',
                border: 'solid 1px #888',
                fontSize: '16px',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                width: '100%',
                minHeight: 100,
                padding: 10
            },
            '& > label': {
                visibility: 'hidden',
                color: '#f44336',
                fontSize: '12px'
            },
            '&.error': {
                '& > textarea': {
                    border: 'solid 1px #f44336'
                },
                '& > label': {
                    visibility: 'visible'
                }
            }
        },
        dates: {
            display: 'flex',
            '& .dateField': {
                flexDirection: 'column',
                flexGrow: 1,
                marginBottom: 35,
                '&:first-of-type': {
                    marginRight: 10
                },
                '&:last-of-type': {
                    marginLeft: 10
                },
                fontSize: '14px',
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                '& .labelName': {
                    marginBottom: 5,
                    fontSize: '12pt',
                    fontWeight: 'bold',
                    color: '#878ea1',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    textTransform: 'capitalize'
                },
                '& .date-input': {
                    border: '1px solid #999',
                    padding: '14px 10px',
                    borderRadius: 4
                },
                '& svg': {
                    marginRight: 10
                }
            }
        },
        scoreRollbook: {
            display: 'flex'
        },
        resources: {
            '& .container': {},
            "& .label": {
                fontSize: '12pt',
                fontWeight: 'bold',
                color: '#878ea1',
                display: 'block',
                whiteSpace: 'nowrap',
                textTransform: 'capitalize',
                margin: '5px 0'
            }
        },
        field: {
            marginBottom: 35,
            minWidth: 500,
            '&.group': {
                minWidth: 300,
                paddingRight: 200
            },
            '&.score': {
                minWidth: 150,
                '& div': {
                    maxWidth: 150
                }
            },
            '&.rollbook': {
                marginLeft: 20,
                marginTop: 12,
                minWidth: 200,
                '& div': {
                    maxWidth: 150
                }
            },
            "& label": {
                marginLeft: 0,
                whiteSpace: 'nowrap',
                "& .MuiFormControlLabel-label": {
                    color: '#878ea1',
                    fontSize: '12pt',
                    fontWeight: 'bold'
                }
            },
            "& > div": {
                "& .label": {
                    marginBottom: 5,
                    fontSize: '12pt',
                    fontWeight: 'bold',
                    color: '#878ea1',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    textTransform: 'capitalize'
                },
                "& .input": {
                    flexGrow: 1,
                    "& input": {
                        borderRadius: 4,
                        border: 'solid 1px #aab7bf !important'
                    },
                    "& .select": {
                        "& .MuiInput-underline:before": {
                            content: 'none',
                            border: 'none'
                        },
                        "& .MuiSelect-select": {
                            border: 'solid 1px #aab7bf',
                            borderRadius: 4,
                            padding: 10,
                            paddingRight: 24
                        }
                    }
                }
            }
        },
        button: {
            width: 120,
            fontSize: "13pt",
            textTransform: "none",
            boxShadow: 'none',
            borderRadius: 4,
            "&:first-child": {
                marginRight: 10
            },
            "&:last-child": {
                marginLeft: 10
            },
            "&.cancel": {
                border: "solid 1px #3d4556",
                backgroundColor: '#fff',
                color: "#3d4556",
                '&:hover': {
                    color: "#000",
                    border: "solid 1px #000",
                    backgroundColor: '#eaf5ff'
                }
            },
            "&.create": {
                color: "#fff",
                border: 'solid 1px #09b2b2',
                backgroundColor: '#2c75bd',
                color: '#fff',
                textTransform: 'capitalize',
                '&:hover': {
                    backgroundColor: '#29739f',
                    borderColor: '#29739f',
                    boxShadow: 'none'
                }
            }
        },
        actions: {
            padding: '8px 24px 30px 24px'
        }
    };
}
function studentListStyles(theme) {
    return {
        root: {
            display: 'flex',
            flexDirection: 'column'
        },
        wrapper: {
            '& label': {
                visibility: 'hidden',
                color: '#f44336',
                fontSize: '12px'
            },
            '&.error': {
                '& label': {
                    visibility: 'visible'
                }
            },
            "& .students": {
                marginBottom: 5,
                fontSize: '12pt',
                fontWeight: 'bold',
                color: '#878ea1',
                display: 'block',
                whiteSpace: 'nowrap',
                textTransform: 'capitalize'
            },
            '& > ul': {
                border: '1px solid #888',
                borderRadius: 3,
                minHeight: 500
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/moment":"mpofx","external/lodash":"5bCAQ","external/react":"k16GP","external/material":"6yEDE","helpers/url":"65SQD","helpers/form-hook":"8O4Ar","helpers/validations-hook":"r624y","helpers/command":"f3cbG","helpers/utils":"gGc98","../date-picker":"bhDks","../checkboxlist":"3OHp7","./TextInput":"9AGi9","./Select":"3MUzC","./validations":"1vrIc","uploads/UploadFiles":"cWlM7","uploads/redux/store":"l92tZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bhDks":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DatePicker);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _locale = require("date-fns/locale");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _reactDatepickerCss = require("react-datepicker/dist/react-datepicker.css");
const useStyles = (0, _material.makeStyles)(datePickerStyles);
function DatePicker({ date, minDate, maxDate, onChange, context, popperProps }) {
    const classes = useStyles();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDatepickerDefault.default), {
        className: classes.datePicker,
        customInput: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DateInput, {}),
        PopperProps: popperProps,
        locale: context.languageId == 'en' ? _locale.enUS : _locale.es,
        selected: (0, _momentDefault.default)(date).toDate(),
        minDate: minDate,
        maxDate: maxDate,
        showTimeInput: true,
        dateFormat: "MM/dd/yyyy h:mm aa",
        onChange: onChange,
        popperPlacement: "top",
        popperModifiers: {
            preventOverflow: {
                enabled: true,
                escapeWithReference: false,
                // force popper to stay in viewport (even when input is scrolled out of view)
                boundariesElement: 'viewport'
            }
        }
    });
}
class DateInput extends (0, _reactDefault.default).Component {
    render() {
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "date-input",
            onClick: this.props.onClick,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faCalendarAlt)
                }),
                this.props.value
            ]
        });
    }
}
function datePickerStyles() {
    return {
        datePicker: {
            marginTop: 10,
            marginRight: 20,
            "& .date-input": {
                border: 'solid 1px #4F576E',
                borderRadius: 2,
                padding: 5
            },
            "& svg": {
                marginRight: 5
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","date-fns/locale":"dElgW","react":"9njXz","external/material":"6yEDE","react-datepicker":"cGh5X","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","react-datepicker/dist/react-datepicker.css":"chsuV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"chsuV":[function() {},{}],"3OHp7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CheckboxList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _list = require("@mui/material/List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _listItem = require("@mui/material/ListItem");
var _listItemDefault = parcelHelpers.interopDefault(_listItem);
var _listItemIcon = require("@mui/material/ListItemIcon");
var _listItemIconDefault = parcelHelpers.interopDefault(_listItemIcon);
var _listItemSecondaryAction = require("@mui/material/ListItemSecondaryAction");
var _listItemSecondaryActionDefault = parcelHelpers.interopDefault(_listItemSecondaryAction);
var _listItemText = require("@mui/material/ListItemText");
var _listItemTextDefault = parcelHelpers.interopDefault(_listItemText);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
function CheckboxList(props) {
    const { options, canSelectAll, selectAllLabel, checked, handleToggle, handleSelectAll, mapLabel = (o)=>o.label, mapValue = (o)=>o.value, Secondary, Text, classes, disabled } = props;
    const allSelected = checked.length == options.length;
    const someSelected = !allSelected && checked.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listDefault.default), {
        className: classes.root,
        children: [
            canSelectAll && options.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
                role: undefined,
                dense: true,
                button: true,
                onClick: ()=>handleSelectAll(allSelected ? [] : options.map((o)=>mapValue(o))),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                            disabled: disabled,
                            edge: "start",
                            checked: allSelected,
                            indeterminate: someSelected,
                            tabIndex: -1,
                            disableRipple: true,
                            inputProps: {
                                'aria-labelledby': 'checkbox-list-label-selectAll'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                        id: "checkbox-list-label-selectAll",
                        primary: selectAllLabel
                    })
                ]
            }),
            options.map((option)=>{
                const label = mapLabel(option);
                const value = mapValue(option);
                const labelId = `checkbox-list-label-${value}`;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listItemDefault.default), {
                    role: undefined,
                    dense: true,
                    button: true,
                    onClick: ()=>!disabled && handleToggle(value, option),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemIconDefault.default), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                disabled: disabled,
                                edge: "start",
                                checked: checked.indexOf(value) !== -1,
                                tabIndex: -1,
                                disableRipple: true,
                                inputProps: {
                                    'aria-labelledby': labelId
                                }
                            })
                        }),
                        !Text && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listItemTextDefault.default), {
                            id: labelId,
                            primary: label
                        }),
                        Text && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Text, {
                            option: option
                        }),
                        Secondary && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Secondary, {
                            option: option
                        })
                    ]
                }, value);
            })
        ]
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","@mui/material/List":"4j4o2","@mui/material/ListItem":"2EejF","@mui/material/ListItemIcon":"fp9B2","@mui/material/ListItemSecondaryAction":"fztfw","@mui/material/ListItemText":"8IBhx","@mui/material/Checkbox":"4sdMA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9AGi9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TextInput);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _outlinedInput = require("@mui/material/OutlinedInput");
var _outlinedInputDefault = parcelHelpers.interopDefault(_outlinedInput);
var _inputLabel = require("@mui/material/InputLabel");
var _inputLabelDefault = parcelHelpers.interopDefault(_inputLabel);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _utils = require("../../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(textStyles);
function TextInput(props) {
    const classes = useStyles();
    const errorId = `${props.id}-error-text`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                    ...(0, _utils.pickAttributes)(props, 'control'),
                    className: classes.control,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _outlinedInputDefault.default), {
                            id: props.id,
                            "aria-describedby": errorId,
                            value: props.value,
                            ...(0, _utils.pickAttributes)(props, 'input'),
                            className: classes.input
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                            id: errorId,
                            ...(0, _utils.pickAttributes)(props, 'error'),
                            children: props.errorMessage
                        })
                    ]
                })
            })
        ]
    });
}
function textStyles(theme) {
    return {
        root: {},
        control: {
            margin: 0,
            flexGrow: 1
        },
        input: {
            "& input": {
                padding: 10
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/OutlinedInput":"8eUp2","@mui/material/InputLabel":"iTW3B","@mui/material/Box":"73kto","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","../../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3MUzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Select);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _select = require("@mui/material/Select");
var _selectDefault = parcelHelpers.interopDefault(_select);
var _formControl = require("@mui/material/FormControl");
var _formControlDefault = parcelHelpers.interopDefault(_formControl);
var _formHelperText = require("@mui/material/FormHelperText");
var _formHelperTextDefault = parcelHelpers.interopDefault(_formHelperText);
var _menuItem = require("@mui/material/MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _utils = require("../../../../../helpers/utils");
const useStyles = (0, _material.makeStyles)(selectStyles);
function Select(props) {
    const classes = useStyles();
    const controlAttributes = (0, _utils.pickAttributes)(props, 'control');
    const selectAttributes = (0, _utils.pickAttributes)(props, 'select');
    const errorId = `${props.id}-error-text`;
    const labelId = `${props.id}-label`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: (0, _clsxDefault.default)(classes.root, props.className),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.label, "label"),
                children: [
                    props.caption,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.input, "input"),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _formControlDefault.default), {
                    ...controlAttributes,
                    className: classes.control,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectDefault.default), {
                            labelId: labelId,
                            id: props.id,
                            ...selectAttributes,
                            className: (0, _clsxDefault.default)(classes.select, "select"),
                            children: props.options.map((option, key)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuItemDefault.default), {
                                    value: props.mapValue(option),
                                    children: props.mapText(option)
                                }, key))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formHelperTextDefault.default), {
                            id: errorId,
                            ...(0, _utils.pickAttributes)(props, 'error'),
                            children: props.errorMessage
                        })
                    ]
                })
            })
        ]
    });
}
function selectStyles(theme) {
    return {
        root: {},
        control: {
            margin: 0,
            flexGrow: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Select":"aY7hn","@mui/material/FormControl":"kkska","@mui/material/FormHelperText":"dlh9L","@mui/material/MenuItem":"a18vm","@mui/material/Box":"73kto","../../../../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1vrIc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validations = require("../../../../../helpers/validations");
const validations = {
    title: [
        (0, _validations.requiredTextAfterAttempt)('title', 'homework-title-required')
    ],
    instructions: [
        (0, _validations.requiredTextAfterAttempt)('instructions', 'homework-instructions-required')
    ],
    group: [
        (0, _validations.requiredTextAfterAttempt)('group', 'homework-group-required')
    ],
    students: [
        ({ attempted, students })=>{
            return !attempted || students.length > 0 ? '' : 'homework-student-required';
        }
    ]
};
exports.default = validations;

},{"../../../../../helpers/validations":"lg1Ji","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cWlM7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _lodash = require("lodash");
var _reactRedux = require("react-redux");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _button = require("@mui/material/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _add = require("@mui/icons-material/Add");
var _addDefault = parcelHelpers.interopDefault(_add);
var _material = require("external/material");
var _uploadedFiles = require("uploads/UploadedFiles");
var _uploadedFilesDefault = parcelHelpers.interopDefault(_uploadedFiles);
var _uploadProgress = require("uploads/UploadProgress");
var _uploadProgressDefault = parcelHelpers.interopDefault(_uploadProgress);
var _actions = require("uploads/redux/actions");
var _store = require("uploads/redux/store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const useStyles = (0, _material.makeStyles)(createStyles);
function testReset() {
    const resetUploads = ()=>(dispatch)=>{
            dispatch({
                type: 'RESET_UPLOADS'
            });
        };
    (0, _storeDefault.default).dispatch(resetUploads());
}
function testSave() {
    console.log('fileProgress', (0, _storeDefault.default).getState().UploadFile.fileProgress);
}
function loadTestData() {
    const data = [
        {
            "name": "Teacher document.pdf",
            "folder": "homeworks/00000000-4ff7-4e2a-bba9-da0f0e219bae/",
            "server": "https://api.edusystem.local/files"
        }
    ];
    const loadUploads = ()=>(dispatch)=>{
            dispatch({
                type: 'LOAD_UPLOADS',
                payload: data
            });
        };
    (0, _storeDefault.default).dispatch(loadUploads());
}
function UploadFiles(props) {
    const { server, folder, setUploadFile, translate = (a)=>a, buttonText, readOnly, downloadServer } = props;
    const classes = useStyles();
    const handleAttachFile = (e)=>{
        setUploadFile((0, _lodash.toArray)(e.target.files).map((file)=>({
                file,
                server,
                folder
            })));
        e.target.value = ''; // to clear the current file
    };
    if (readOnly) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
        className: classes.uploads,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadedFilesDefault.default), {
            translate: translate,
            downloadServer: downloadServer
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.uploads,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonDefault.default), {
                className: (0, _clsxDefault.default)(classes.root, 'button'),
                variant: "contained",
                component: "label",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addDefault.default), {
                        fontSize: 'small',
                        focusable: false
                    }),
                    buttonText ?? 'Upload',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "file",
                        multiple: true,
                        hidden: true,
                        onChange: handleAttachFile
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadProgressDefault.default), {
                translate: translate,
                downloadServer: downloadServer
            })
        ]
    });
}
const mapDispatchToProps = (dispatch)=>({
        setUploadFile: (files)=>dispatch((0, _actions.setUploadFile)(files))
    });
exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(UploadFiles);
function createStyles(theme) {
    return {
        uploads: {
            display: 'flex',
            flexDirection: 'column',
            fontSize: '14px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            '& a': {
                color: '#639de2',
                textDecoration: 'none',
                cursor: 'pointer',
                position: 'relative',
                top: -7,
                '&:hover': {
                    textDecoration: 'underline'
                }
            },
            '& span.MuiButton-label': {
                textTransform: 'capitalize',
                textAalign: 'left',
                justifyContent: 'flex-start'
            },
            '& .button': {
                textTransform: 'capitalize',
                color: '#639de2',
                fontWeight: '600',
                fontSize: '14pt',
                backgroundColor: 'transparent',
                border: 'solid 1px #93c4ed',
                boxShadow: 'none',
                textAlign: 'left',
                padding: 8,
                margin: 0,
                "&:hover": {
                    backgroundColor: "transparent"
                },
                "&:active": {
                    backgroundColor: "transparent"
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","lodash":"1qc47","react-redux":"5DyKE","@mui/material/Box":"73kto","@mui/material/Button":"c6Y0y","@mui/icons-material/Add":"jrNj7","external/material":"6yEDE","uploads/UploadedFiles":"3Ve32","uploads/UploadProgress":"2o17u","uploads/redux/actions":"bhmtF","uploads/redux/store":"l92tZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Ve32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _material = require("external/material");
var _attachFile = require("@mui/icons-material/AttachFile");
var _attachFileDefault = parcelHelpers.interopDefault(_attachFile);
var _url = require("helpers/url");
const useStyles = (0, _material.makeStyles)(createStyles);
const UploadedFiles = (props)=>{
    const { fileProgress, uploadFile, retryUpload, deleteUpload, resetUploads, translate = (a)=>a, downloadServer } = props;
    const uploadedFileAmount = (0, _lodash.size)(fileProgress);
    const classes = useStyles();
    const contentLink = (file)=>{
        return `${downloadServer}/${file.folder}/${file.file.name}`;
    };
    return uploadedFileAmount > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsxDefault.default)(classes.wrapper),
        children: (0, _lodash.size)(fileProgress) ? (0, _lodash.toArray)(fileProgress).filter((f)=>!f.deleted).map((file)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachFileDefault.default), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                        ...(0, _url.viewerGuard)({
                            href: contentLink(file),
                            target: "_blank"
                        }),
                        children: file.file.name
                    })
                ]
            }, file.id);
        }) : null
    }) : null;
};
const mapStateToProps = (state)=>({
        fileProgress: state.UploadFile.fileProgress
    });
exports.default = (0, _reactRedux.connect)(mapStateToProps)(UploadedFiles);
function createStyles(theme) {
    return {
        root: {},
        wrapper: {}
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-redux":"5DyKE","lodash":"1qc47","external/material":"6yEDE","@mui/icons-material/AttachFile":"7ucfJ","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2o17u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _lodash = require("lodash");
var _material = require("external/material");
var _actions = require("uploads/redux/actions");
var _uploadItem = require("uploads/UploadItem");
var _uploadItemDefault = parcelHelpers.interopDefault(_uploadItem);
var _store = require("uploads/redux/store");
var _storeDefault = parcelHelpers.interopDefault(_store);
const useStyles = (0, _material.makeStyles)(createStyles);
const UploadProgress = (props)=>{
    const { fileProgress, uploadFile, retryUpload, deleteUpload, resetUploads, translate = (a)=>a, downloadServer } = props;
    const uploadedFileAmount = (0, _lodash.size)(fileProgress);
    const classes = useStyles();
    (0, _react.useEffect)(()=>{
        const fileToUpload = (0, _lodash.toArray)(fileProgress).filter((file)=>file.progress === 0);
        uploadFile(fileToUpload);
    }, [
        uploadedFileAmount
    ]);
    return uploadedFileAmount > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: (0, _clsxDefault.default)(classes.wrapper),
        children: (0, _lodash.size)(fileProgress) ? (0, _lodash.toArray)(fileProgress).filter((f)=>!f.deleted).map((file)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadItemDefault.default), {
                file: file,
                retryUpload: ()=>retryUpload(file.id),
                deleteUpload: ()=>deleteUpload(file.id),
                downloadServer: downloadServer
            }, file.id);
        }) : null
    }) : null;
};
const mapStateToProps = (state)=>({
        fileProgress: state.UploadFile.fileProgress
    });
const mapDispatchToProps = (dispatch)=>({
        uploadFile: (files)=>dispatch((0, _actions.uploadFile)(files)),
        retryUpload: (id)=>dispatch((0, _actions.retryUpload)(id)),
        deleteUpload: (id)=>dispatch((0, _actions.deleteUpload)(id)),
        resetUploads: ()=>dispatch((0, _actions.resetUploads)())
    });
exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UploadProgress);
function createStyles(theme) {
    return {
        wrapper: {
            padding: 5,
            marginTop: 10,
            backgroundColor: '#f7f5f7'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","react-redux":"5DyKE","lodash":"1qc47","external/material":"6yEDE","uploads/redux/actions":"bhmtF","uploads/UploadItem":"kk2ab","uploads/redux/store":"l92tZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bhmtF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setUploadFile", ()=>setUploadFile);
parcelHelpers.export(exports, "setUploadProgress", ()=>setUploadProgress);
parcelHelpers.export(exports, "successUploadFile", ()=>successUploadFile);
parcelHelpers.export(exports, "failureUploadFile", ()=>failureUploadFile);
parcelHelpers.export(exports, "uploadFile", ()=>uploadFile);
parcelHelpers.export(exports, "retryUpload", ()=>retryUpload);
parcelHelpers.export(exports, "deleteUpload", ()=>deleteUpload);
parcelHelpers.export(exports, "cancelUpload", ()=>cancelUpload);
parcelHelpers.export(exports, "resetUploads", ()=>resetUploads);
parcelHelpers.export(exports, "loadUploads", ()=>loadUploads);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _sentimentSatisfied = require("@mui/icons-material/SentimentSatisfied");
var _sentimentSatisfiedDefault = parcelHelpers.interopDefault(_sentimentSatisfied);
var _types = require("uploads/redux/types");
var _typesDefault = parcelHelpers.interopDefault(_types);
const setUploadFile = (data)=>({
        type: (0, _typesDefault.default).SET_UPLOAD_FILE,
        payload: data
    });
const setUploadProgress = (id, progress)=>({
        type: (0, _typesDefault.default).SET_UPLOAD_PROGRESS,
        payload: {
            id,
            progress
        }
    });
const successUploadFile = (file)=>({
        type: (0, _typesDefault.default).SUCCESS_UPLOAD_FILE,
        payload: file.id
    });
const failureUploadFile = (id)=>({
        type: (0, _typesDefault.default).FAILURE_UPLOAD_FILE,
        payload: id
    });
const uploadFile = (files)=>(dispatch)=>{
        if (files.length) files.forEach(async (file)=>{
            const formPayload = new FormData();
            formPayload.append('file', file.file);
            try {
                (0, _axiosDefault.default).defaults.withCredentials = true;
                await (0, _axiosDefault.default)({
                    baseURL: file.server,
                    url: `/${file.folder}/${file.file.name}`,
                    method: 'post',
                    data: formPayload,
                    cancelToken: file.cancelSource.token,
                    onUploadProgress: (progress)=>{
                        const { loaded, total } = progress;
                        const percentageProgress = Math.floor(loaded / total * 100);
                        dispatch(setUploadProgress(file.id, percentageProgress));
                    }
                });
                dispatch(successUploadFile(file));
            } catch (error) {
                if ((0, _axiosDefault.default).isCancel(error)) // cancelled by user
                dispatch(cancelUpload(file.id));
                else // regular connection error
                dispatch(failureUploadFile(file.id));
            }
        });
    };
const retryUpload = (id)=>(dispatch, getState)=>{
        dispatch({
            type: (0, _typesDefault.default).RETRY_UPLOAD_FILE,
            payload: id
        });
        const { fileProgress } = getState().UploadFile;
        const reuploadFile = [
            fileProgress[id]
        ];
        dispatch(uploadFile(reuploadFile));
    };
const deleteUpload = (id)=>async (dispatch, getState)=>{
        const { fileProgress } = getState().UploadFile;
        const file = fileProgress[id];
        const folderParts = file.folder.split('/');
        file.deleted = true;
        console.log(file);
        (0, _axiosDefault.default).defaults.withCredentials = true;
        await (0, _axiosDefault.default)({
            baseURL: file.server,
            url: `/${file.folder}/${file.file.name}`,
            method: 'delete'
        });
        dispatch({
            type: (0, _typesDefault.default).DELETE_UPLOAD_FILE,
            payload: id
        });
    };
const cancelUpload = (id)=>(dispatch, getState)=>{
        const { fileProgress } = getState().UploadFile;
        fileProgress[id].deleted = true;
        dispatch({
            type: (0, _typesDefault.default).DELETE_UPLOAD_FILE,
            payload: id
        });
    };
const resetUploads = ()=>(dispatch, getState)=>{
        dispatch({
            type: (0, _typesDefault.default).RESET_UPLOADS
        });
    };
const loadUploads = (filesData)=>(dispatch)=>{
        dispatch({
            type: 'LOAD_UPLOADS',
            payload: filesData
        });
    };

},{"axios":"ffpgq","@mui/icons-material/SentimentSatisfied":"gAto4","uploads/redux/types":"lDTsl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ffpgq":[function(require,module,exports,__globalThis) {
module.exports = require("9f37cef8b0e13afc");

},{"9f37cef8b0e13afc":"lHA81"}],"lHA81":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("1137fef34918bf53");
var bind = require("ce63a8247a300202");
var Axios = require("c14c66f4c3ec48a2");
var mergeConfig = require("345f9ec0ee8efc80");
var defaults = require("27bdb15d131780c5");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);
    // Copy axios.prototype to instance
    utils.extend(instance, Axios.prototype, context);
    // Copy context to instance
    utils.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var axios = createInstance(defaults);
// Expose Axios class to allow class inheritance
axios.Axios = Axios;
// Expose Cancel & CancelToken
axios.CanceledError = require("99821b4fc0ba2f69");
axios.CancelToken = require("853fec7db7d524b4");
axios.isCancel = require("322a636c3e2325e1");
axios.VERSION = require("3d6b2db6c802d85d").version;
axios.toFormData = require("ef33bb7abb9fa67d");
// Expose AxiosError class
axios.AxiosError = require("a5206ee4d751b44");
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = require("75c7c70e55d88256");
// Expose isAxiosError
axios.isAxiosError = require("543a1da09311ae9b");
module.exports = axios;
// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"1137fef34918bf53":"4uo9i","ce63a8247a300202":"gKyRf","c14c66f4c3ec48a2":"dXDNP","345f9ec0ee8efc80":"1xY8J","27bdb15d131780c5":"gguXD","99821b4fc0ba2f69":"lfAwZ","853fec7db7d524b4":"fa4h3","322a636c3e2325e1":"5w9uS","3d6b2db6c802d85d":"hl0B4","ef33bb7abb9fa67d":"kISIL","a5206ee4d751b44":"kinyp","75c7c70e55d88256":"kQZVl","543a1da09311ae9b":"98mQL"}],"4uo9i":[function(require,module,exports,__globalThis) {
'use strict';
var bind = require("a7c7b4094caa86ac");
// utils is a library of generic helper functions non-specific to axios
var toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function isPlainObject(val) {
    if (kindOf(val) !== 'object') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function isFunction(val) {
    return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function isStream(val) {
    return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function isFormData(thing) {
    var pattern = '[object FormData]';
    return thing && (typeof FormData === 'function' && thing instanceof FormData || toString.call(thing) === pattern || isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var isURLSearchParams = kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function merge() {
    var result = {};
    function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) result[key] = merge(result[key], val);
        else if (isPlainObject(val)) result[key] = merge({}, val);
        else if (isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = bind(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if (isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM,
    inherits: inherits,
    toFlatObject: toFlatObject,
    kindOf: kindOf,
    kindOfTest: kindOfTest,
    endsWith: endsWith,
    toArray: toArray,
    isTypedArray: isTypedArray,
    isFileList: isFileList
};

},{"a7c7b4094caa86ac":"gKyRf"}],"gKyRf":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

},{}],"dXDNP":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("2cd2d0baba832579");
var buildURL = require("945ebba9256ed84f");
var InterceptorManager = require("fc2d71ae77ba798e");
var dispatchRequest = require("77b4f57f4d663a9b");
var mergeConfig = require("5db81a4f62f8927d");
var buildFullPath = require("bba783c05a4f93f7");
var validator = require("d0f5147a00cee7c5");
var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = mergeConfig(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            dispatchRequest,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = dispatchRequest(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
Axios.prototype.getUri = function getUri(config) {
    config = mergeConfig(this.defaults, config);
    var fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
utils.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request(mergeConfig(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
utils.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request(mergeConfig(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
module.exports = Axios;

},{"2cd2d0baba832579":"4uo9i","945ebba9256ed84f":"2yc3i","fc2d71ae77ba798e":"gBR9v","77b4f57f4d663a9b":"9BYjJ","5db81a4f62f8927d":"1xY8J","bba783c05a4f93f7":"dqGPZ","d0f5147a00cee7c5":"jxy99"}],"2yc3i":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("d198994ea2a45305");
function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if (utils.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if (utils.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            utils.forEach(val, function parseValue(v) {
                if (utils.isDate(v)) v = v.toISOString();
                else if (utils.isObject(v)) v = JSON.stringify(v);
                parts.push(encode(key) + '=' + encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

},{"d198994ea2a45305":"4uo9i"}],"gBR9v":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("982be9ba543c1801");
function InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ InterceptorManager.prototype.forEach = function forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = InterceptorManager;

},{"982be9ba543c1801":"4uo9i"}],"9BYjJ":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("dccb83262660ba2a");
var transformData = require("670a836c9c5a1abe");
var isCancel = require("9b938a75c8452b2f");
var defaults = require("293260d2186f65fb");
var CanceledError = require("babe605ae6871369");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new CanceledError();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = transformData.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    utils.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || defaults.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

},{"dccb83262660ba2a":"4uo9i","670a836c9c5a1abe":"kzWBF","9b938a75c8452b2f":"5w9uS","293260d2186f65fb":"gguXD","babe605ae6871369":"lfAwZ"}],"kzWBF":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("506225f7f22ee5b3");
var defaults = require("933dc4966aff4cbe");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || defaults;
    /*eslint no-param-reassign:0*/ utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

},{"506225f7f22ee5b3":"4uo9i","933dc4966aff4cbe":"gguXD"}],"gguXD":[function(require,module,exports,__globalThis) {
var process = require("8191483f14ddb73c");
'use strict';
var utils = require("e81e3dbd1959aa01");
var normalizeHeaderName = require("753007ee6e6399c7");
var AxiosError = require("e9c38e32fac9e03e");
var transitionalDefaults = require("5a1b45724cbabfe9");
var toFormData = require("ce7605268fbf7e42");
var DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset(headers, value) {
    if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}
function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = require("96a55d646cd53040");
    else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') // For node use HTTP adapter
    adapter = require("3d0364fd0ce54db5");
    return adapter;
}
function stringifySafely(rawValue, parser, encoder) {
    if (utils.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return utils.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var defaults = {
    transitional: transitionalDefaults,
    adapter: getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            normalizeHeaderName(headers, 'Accept');
            normalizeHeaderName(headers, 'Content-Type');
            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) return data;
            if (utils.isArrayBufferView(data)) return data.buffer;
            if (utils.isURLSearchParams(data)) {
                setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            var isObjectPayload = utils.isObject(data);
            var contentType = headers && headers['Content-Type'];
            var isFileList;
            if ((isFileList = utils.isFileList(data)) || isObjectPayload && contentType === 'multipart/form-data') {
                var _FormData = this.env && this.env.FormData;
                return toFormData(isFileList ? {
                    'files[]': data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === 'application/json') {
                setContentTypeIfUnset(headers, 'application/json');
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: require("2c6a31d8df55e92a")
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
utils.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    defaults.headers[method] = {};
});
utils.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
module.exports = defaults;

},{"8191483f14ddb73c":"5jT8D","e81e3dbd1959aa01":"4uo9i","753007ee6e6399c7":"jWVQJ","e9c38e32fac9e03e":"kinyp","5a1b45724cbabfe9":"fnl8o","ce7605268fbf7e42":"kISIL","96a55d646cd53040":"i0pe0","3d0364fd0ce54db5":"i0pe0","2c6a31d8df55e92a":"3nCRV"}],"jWVQJ":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("5f8afca0889a63e1");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

},{"5f8afca0889a63e1":"4uo9i"}],"kinyp":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("90d7c965e732ce33");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
utils.inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var prototype = AxiosError.prototype;
var descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED'
].forEach(function(code) {
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create(prototype);
    utils.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = AxiosError;

},{"90d7c965e732ce33":"4uo9i"}],"fnl8o":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{}],"kISIL":[function(require,module,exports,__globalThis) {
var Buffer = require("adfd9b103875c2dd").Buffer;
'use strict';
var utils = require("3a99ebcd36a8733f");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return '';
        if (utils.isDate(value)) return value.toISOString();
        if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) return typeof Blob === 'function' ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if (utils.isPlainObject(data) || utils.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error('Circular reference detected in ' + parentKey);
            stack.push(data);
            utils.forEach(data, function each(value, key) {
                if (utils.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + '.' + key : key;
                var arr;
                if (value && !parentKey && typeof value === 'object') {
                    if (utils.endsWith(key, '{}')) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = toFormData;

},{"adfd9b103875c2dd":"dB11O","3a99ebcd36a8733f":"4uo9i"}],"i0pe0":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("2bb8b5f6db10dd6d");
var settle = require("a7b983c12bb9f77f");
var cookies = require("19bdb320f45f036e");
var buildURL = require("568f70ee55491398");
var buildFullPath = require("a1fd5a6807469b6d");
var parseHeaders = require("f197d20bdfdcd5a4");
var isURLSameOrigin = require("32737c301de74bf5");
var transitionalDefaults = require("acf3ae0da9073396");
var AxiosError = require("5cdb5bed725b4b9d");
var CanceledError = require("4bb5ca1319af05c5");
var parseProtocol = require("edff7382320539d7");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            settle(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || transitionalDefaults;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new AxiosError(timeoutErrorMessage, transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if (utils.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!utils.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new CanceledError() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = parseProtocol(fullPath);
        if (protocol && [
            'http',
            'https',
            'file'
        ].indexOf(protocol) === -1) {
            reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

},{"2bb8b5f6db10dd6d":"4uo9i","a7b983c12bb9f77f":"bYbho","19bdb320f45f036e":"fq1CU","568f70ee55491398":"2yc3i","a1fd5a6807469b6d":"dqGPZ","f197d20bdfdcd5a4":"7iHXN","32737c301de74bf5":"3wNi6","acf3ae0da9073396":"fnl8o","5cdb5bed725b4b9d":"kinyp","4bb5ca1319af05c5":"lfAwZ","edff7382320539d7":"96o7u"}],"bYbho":[function(require,module,exports,__globalThis) {
'use strict';
var AxiosError = require("99b767d0f87e1d33");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new AxiosError('Request failed with status code ' + response.status, [
        AxiosError.ERR_BAD_REQUEST,
        AxiosError.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

},{"99b767d0f87e1d33":"kinyp"}],"fq1CU":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("c987331427b8b2ad");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if (utils.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if (utils.isString(path)) cookie.push('path=' + path);
            if (utils.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

},{"c987331427b8b2ad":"4uo9i"}],"dqGPZ":[function(require,module,exports,__globalThis) {
'use strict';
var isAbsoluteURL = require("5ff0e8c05aa13380");
var combineURLs = require("e1ac36eef7d02fa4");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) return combineURLs(baseURL, requestedURL);
    return requestedURL;
};

},{"5ff0e8c05aa13380":"kKGFA","e1ac36eef7d02fa4":"aIa5z"}],"kKGFA":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

},{}],"aIa5z":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

},{}],"7iHXN":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("5802dc5113a634d0");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    utils.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = utils.trim(line.substr(0, i)).toLowerCase();
        val = utils.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

},{"5802dc5113a634d0":"4uo9i"}],"3wNi6":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("c8f79893fd676b4c");
module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

},{"c8f79893fd676b4c":"4uo9i"}],"lfAwZ":[function(require,module,exports,__globalThis) {
'use strict';
var AxiosError = require("d49629127e21c372");
var utils = require("a3a18563c2683e33");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
    this.name = 'CanceledError';
}
utils.inherits(CanceledError, AxiosError, {
    __CANCEL__: true
});
module.exports = CanceledError;

},{"d49629127e21c372":"kinyp","a3a18563c2683e33":"4uo9i"}],"96o7u":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
};

},{}],"3nCRV":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
module.exports = null;

},{}],"5w9uS":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

},{}],"1xY8J":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("99adbff39af8f677");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) return utils.merge(target, source);
        else if (utils.isPlainObject(source)) return utils.merge({}, source);
        else if (utils.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!utils.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!utils.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'beforeRedirect': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

},{"99adbff39af8f677":"4uo9i"}],"jxy99":[function(require,module,exports,__globalThis) {
'use strict';
var VERSION = require("e9aa819e853e8a05").version;
var AxiosError = require("d650eba95d68de74");
var validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new AxiosError(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), AxiosError.ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: assertOptions,
    validators: validators
};

},{"e9aa819e853e8a05":"hl0B4","d650eba95d68de74":"kinyp"}],"hl0B4":[function(require,module,exports,__globalThis) {
module.exports = {
    "version": "0.27.2"
};

},{}],"fa4h3":[function(require,module,exports,__globalThis) {
'use strict';
var CanceledError = require("b6a43aee12b81881");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new CanceledError(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = CancelToken;

},{"b6a43aee12b81881":"lfAwZ"}],"kQZVl":[function(require,module,exports,__globalThis) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

},{}],"98mQL":[function(require,module,exports,__globalThis) {
'use strict';
var utils = require("231ee4a1ecb1dc47");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return utils.isObject(payload) && payload.isAxiosError === true;
};

},{"231ee4a1ecb1dc47":"4uo9i"}],"gAto4":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("cb25f3fbf913cbef");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("5200d95a8b894530"));
var _jsxRuntime = require("91cded0b072a06ce");
var _default = exports.default = (0, _createSvgIcon.default)([
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "15.5",
        cy: "9.5",
        r: "1.5"
    }, "0"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
        cx: "8.5",
        cy: "9.5",
        r: "1.5"
    }, "1"),
    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15.86.55 1.87.87 2.97.87 1.11 0 2.12-.33 2.98-.88-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53"
    }, "2")
], 'SentimentSatisfied');

},{"cb25f3fbf913cbef":"kZ6eK","5200d95a8b894530":"2vOnF","91cded0b072a06ce":"1dlk8"}],"lDTsl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const uploadFileTypes = {
    SET_UPLOAD_FILE: 'SET_UPLOAD_FILE',
    SET_UPLOAD_PROGRESS: 'SET_UPLOAD_PROGRESS',
    SUCCESS_UPLOAD_FILE: 'SUCCESS_UPLOAD_FILE',
    FAILURE_UPLOAD_FILE: 'FAILURE_UPLOAD_FILE',
    RETRY_UPLOAD_FILE: 'RETRY_UPLOAD_FILE',
    DELETE_UPLOAD_FILE: 'DELETE_UPLOAD_FILE',
    RESET_UPLOADS: 'RESET_UPLOADS',
    LOAD_UPLOADS: 'LOAD_UPLOADS'
};
exports.default = uploadFileTypes;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kk2ab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _deleteOutlined = require("@mui/icons-material/DeleteOutlined");
var _deleteOutlinedDefault = parcelHelpers.interopDefault(_deleteOutlined);
var _cancel = require("@mui/icons-material/Cancel");
var _cancelDefault = parcelHelpers.interopDefault(_cancel);
var _replay = require("@mui/icons-material/Replay");
var _replayDefault = parcelHelpers.interopDefault(_replay);
var _attachFile = require("@mui/icons-material/AttachFile");
var _attachFileDefault = parcelHelpers.interopDefault(_attachFile);
var _error = require("@mui/icons-material/Error");
var _errorDefault = parcelHelpers.interopDefault(_error);
var _constants = require("uploads/redux/constants");
var _url = require("helpers/url");
const useStyles = (0, _material.makeStyles)(createStyles);
const UploadItem = (props)=>{
    const { id, file, folder, progress, cancelSource, status } = props.file;
    const { downloadServer } = props;
    const contentLink = ()=>{
        return `${downloadServer}/${folder}/${file.name}`;
    };
    const classes = useStyles();
    const renderIcon = (0, _react.useMemo)(()=>{
        const cancelUpload = ()=>{
            cancelSource.cancel('Cancelled by user');
        };
        if (status === (0, _constants.STATUS_UPLOAD).uploading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            title: "Cancel upload",
            onClick: cancelUpload,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelDefault.default), {
                className: (0, _clsxDefault.default)(classes.wrapperItem, 'cancel'),
                focusable: true
            })
        });
        else if (status === (0, _constants.STATUS_UPLOAD).success) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            title: "Success upload",
            onClick: props.deleteUpload,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteOutlinedDefault.default), {
                className: (0, _clsxDefault.default)(classes.wrapperItem, 'trash'),
                focusable: true
            })
        });
        else if (status === (0, _constants.STATUS_UPLOAD).failed) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            title: "Retry upload",
            style: {
                color: 'orange'
            },
            onClick: props.retryUpload,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _replayDefault.default), {
                className: (0, _clsxDefault.default)(classes.wrapperItem, 'retry'),
                focusable: true
            })
        });
        else if (status === (0, _constants.STATUS_UPLOAD).deleted) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            title: "Deleted upload",
            style: {
                color: 'orange'
            },
            children: "(DELETED)"
        });
        return null;
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: (0, _clsxDefault.default)(classes.wrapperItem, {
            done: progress == 100
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: (0, _clsxDefault.default)(classes.wrapperItem, 'leftside'),
                children: [
                    progress == 100 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachFileDefault.default), {
                                    style: {
                                        fill: '#10b1b2',
                                        height: 20
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                    ...(0, _url.viewerGuard)({
                                        href: contentLink(),
                                        target: "_blank"
                                    }),
                                    children: file.name
                                })
                            ]
                        })
                    }),
                    progress < 100 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            className: classes.error,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorDefault.default), {
                                    style: {
                                        fill: 'red',
                                        height: 20,
                                        position: 'relative',
                                        height: 12
                                    }
                                }),
                                file.name
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: (0, _clsxDefault.default)(classes.wrapperItem, 'progressBar'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                width: `${progress}%`
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: (0, _clsxDefault.default)(classes.wrapperItem, 'rightside'),
                children: renderIcon
            })
        ]
    });
};
exports.default = UploadItem;
function createStyles(theme) {
    return {
        root: {},
        error: {
            color: 'red'
        },
        wrapperItem: {
            display: 'grid',
            gridTemplateColumns: 'calc(100% - 50px) 50px',
            padding: '2px 0',
            '& .leftSide': {
                display: 'grid',
                gridTemplateColumns: '100%',
                rowGap: '6px',
                marginRight: '12px',
                '& > label': {
                    width: '100%',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textAlign: 'left',
                    padding: 0
                }
            },
            '& .rightSide': {
                display: 'grid',
                gridTemplateColumns: '100%',
                rowGap: '6px',
                marginRight: '12px',
                '& > span:first-child': {
                    fontSize: '18px',
                    cursor: 'pointer'
                }
            },
            '& .progressBar': {
                display: 'block',
                width: '100%',
                height: '15px',
                backgroundColor: 'lightgray',
                borderRadius: '20px',
                padding: '1px',
                marginTop: 3,
                '& > div': {
                    height: '15px',
                    backgroundColor: 'lightgreen',
                    borderRadius: '20px',
                    transition: 'width 1s'
                }
            },
            '&.done': {
                '& label': {
                    padding: '0px !important',
                    backgroundColor: 'transparent',
                    boxSizing: 'border-box'
                },
                '& .progressBar, & .percent': {
                    display: 'none'
                }
            },
            '& .trash': {
                cursor: 'pointer',
                fontSize: 32,
                color: 'red'
            },
            '& .cancel': {
                cursor: 'pointer',
                fontSize: 32,
                color: 'red'
            },
            '& .retry': {
                cursor: 'pointer',
                fontSize: 32,
                color: 'orange'
            },
            '& svg': {
                height: 22
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/icons-material/DeleteOutlined":"ehsN6","@mui/icons-material/Cancel":"lMa52","@mui/icons-material/Replay":"hTiAI","@mui/icons-material/AttachFile":"7ucfJ","@mui/icons-material/Error":"4XfdO","uploads/redux/constants":"bNEG4","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ehsN6":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("bd6cba596898328a");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("e9803d4c9d2d64cf"));
var _jsxRuntime = require("f0ebcb1eb67a5e1c");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M16 9v10H8V9zm-1.5-6h-5l-1 1H5v2h14V4h-3.5zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2z"
}), 'DeleteOutlined');

},{"bd6cba596898328a":"kZ6eK","e9803d4c9d2d64cf":"2vOnF","f0ebcb1eb67a5e1c":"1dlk8"}],"hTiAI":[function(require,module,exports,__globalThis) {
"use strict";
"use client";
var _interopRequireDefault = require("367a3397542040f2");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("1d7b7053005c7c01"));
var _jsxRuntime = require("f246e022b9ce1cf6");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8"
}), 'Replay');

},{"367a3397542040f2":"kZ6eK","1d7b7053005c7c01":"2vOnF","f246e022b9ce1cf6":"1dlk8"}],"bNEG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STATUS_UPLOAD", ()=>STATUS_UPLOAD);
const STATUS_UPLOAD = {
    uploading: 0,
    success: 1,
    failed: 2,
    deleted: 3,
    canceled: 4
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"l92tZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("external/react");
var _redux = require("uploads/redux");
var _reduxDefault = parcelHelpers.interopDefault(_redux);
const middleware = [
    (0, _react.thunk)
];
const composeEnchancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, _react.compose);
const store = (0, _react.createStore)((0, _reduxDefault.default), composeEnchancers((0, _react.applyMiddleware)(...middleware)));
exports.default = store;

},{"external/react":"k16GP","uploads/redux":"5XOnZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5XOnZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _redux = require("redux");
var _reducer = require("uploads/redux/reducer");
var _reducerDefault = parcelHelpers.interopDefault(_reducer);
const rootReducer = (0, _redux.combineReducers)({
    UploadFile: (0, _reducerDefault.default)
});
exports.default = rootReducer;

},{"redux":"ikKU1","uploads/redux/reducer":"2CRMA","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2CRMA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _types = require("uploads/redux/types");
var _typesDefault = parcelHelpers.interopDefault(_types);
var _utils = require("uploads/redux/utils");
var _constants = require("uploads/redux/constants");
const INITIAL_STATE = {
    fileProgress: {
    }
};
const fileProgressReducer = (state = INITIAL_STATE, action)=>{
    switch(action.type){
        case (0, _typesDefault.default).RESET_UPLOADS:
            console.log('reset state');
            return {
                ...INITIAL_STATE
            };
        case (0, _typesDefault.default).SET_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    ...(0, _utils.modifyFiles)(state.fileProgress, action.payload)
                }
            };
        case (0, _typesDefault.default).SET_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    ...(0, _utils.modifyFiles)(state.fileProgress, action.payload)
                }
            };
        case (0, _typesDefault.default).SET_UPLOAD_PROGRESS:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload.id]: {
                        ...state.fileProgress[action.payload.id],
                        progress: action.payload.progress
                    }
                }
            };
        case (0, _typesDefault.default).SUCCESS_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: (0, _constants.STATUS_UPLOAD).success
                    }
                }
            };
        case (0, _typesDefault.default).FAILURE_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: (0, _constants.STATUS_UPLOAD).failed,
                        progress: 0
                    }
                }
            };
        case (0, _typesDefault.default).DELETE_UPLOAD_FILE:
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: (0, _constants.STATUS_UPLOAD).deleted,
                        progress: 0
                    }
                }
            };
        case (0, _typesDefault.default).RETRY_UPLOAD_FILE:
            const CancelToken = (0, _axiosDefault.default).CancelToken;
            const cancelSource = CancelToken.source();
            return {
                ...state,
                fileProgress: {
                    ...state.fileProgress,
                    [action.payload]: {
                        ...state.fileProgress[action.payload],
                        status: (0, _constants.STATUS_UPLOAD).uploading,
                        progress: 0,
                        cancelSource
                    }
                }
            };
        case (0, _typesDefault.default).LOAD_UPLOADS:
            let files = {};
            action.payload.map((f, i)=>{
                let id = '' + (i + 1);
                files[id] = {
                    id: id,
                    file: {
                        name: f.name,
                        size: 0
                    },
                    server: f.server,
                    folder: f.folder,
                    progress: 100,
                    status: 1
                };
            });
            // console.log('payload',action.payload)
            return {
                ...state,
                fileProgress: files
            };
        default:
            return state;
    }
};
exports.default = fileProgressReducer;

},{"axios":"ffpgq","uploads/redux/types":"lDTsl","uploads/redux/utils":"jEVJB","uploads/redux/constants":"bNEG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jEVJB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "modifyFiles", ()=>modifyFiles);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _lodash = require("lodash");
var _constants = require("uploads/redux/constants");
const modifyFiles = (existingFiles, files)=>{
    let fileToUpload = {};
    for(let i = 0; i < files.length; i++){
        const id = (0, _lodash.size)(existingFiles) + i + 1;
        const CancelToken = (0, _axiosDefault.default).CancelToken;
        const source = CancelToken.source();
        fileToUpload = {
            ...fileToUpload,
            [id]: {
                id,
                ...files[i],
                progress: 0,
                cancelSource: source,
                status: (0, _constants.STATUS_UPLOAD).uploading,
                deleted: false
            }
        };
    }
    return fileToUpload;
};

},{"axios":"ffpgq","lodash":"1qc47","uploads/redux/constants":"bNEG4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hgJ7l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworkStudents);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _immutabilityHelper = require("immutability-helper");
var _immutabilityHelperDefault = parcelHelpers.interopDefault(_immutabilityHelper);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _tableContainer = require("@mui/material/TableContainer");
var _tableContainerDefault = parcelHelpers.interopDefault(_tableContainer);
var _table = require("@mui/material/Table");
var _tableDefault = parcelHelpers.interopDefault(_table);
var _infoBar = require("./components/homework-students/info-bar");
var _infoBarDefault = parcelHelpers.interopDefault(_infoBar);
var _homeworkStudentsHead = require("./components/homework-students/homework-students-head");
var _homeworkStudentsHeadDefault = parcelHelpers.interopDefault(_homeworkStudentsHead);
var _homeworkStudentsBody = require("./components/homework-students/homework-students-body");
var _homeworkStudentsBodyDefault = parcelHelpers.interopDefault(_homeworkStudentsBody);
var _command = require("helpers/command");
var _context = require("teacher/context");
const useStyles = (0, _material.makeStyles)(homeworkStyles);
function HomeworkStudents() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { homeworkStatusMap, homeworkId } = context;
    const classes = useStyles();
    const [state, setState] = (0, _reactDefault.default).useState({
        feedback: []
    });
    function selectStudentForFeedback(id, selected, initial) {
        let cmd = {
            $push: [
                {
                    id,
                    message: '',
                    score: "",
                    returned: false,
                    ...initial
                }
            ]
        };
        if (!selected) {
            const index = state.feedback.findIndex((i)=>i.id == id);
            cmd = {
                $splice: [
                    [
                        index,
                        1
                    ]
                ]
            };
        }
        setState((0, _immutabilityHelperDefault.default)(state, {
            feedback: cmd
        }));
    }
    function updateFeedback(id, property, value) {
        const index = state.feedback.findIndex((i)=>i.id == id);
        const cmd = {
            [index]: {
                [property]: {
                    $set: value
                }
            }
        };
        setState((0, _immutabilityHelperDefault.default)(state, {
            feedback: cmd
        }));
    }
    const save = async ()=>{
        const students = state.feedback.map((f)=>{
            return {
                id: f.id,
                status: homeworkStatusMap[f.returned ? 'returned' : 'completed'],
                score: f.score === '' ? undefined : parseInt(f.score),
                message: f.message
            };
        });
        const result = await (0, _command.createPost)('homework', 'saveStudentsFeedback')({
            id: homeworkId,
            students
        });
        setState((0, _immutabilityHelperDefault.default)(state, {
            feedback: {
                $set: []
            }
        }));
        context.updateState({
            homeworkContext: {
                studentHomeworkStatus: {
                    refreshes: {
                        $apply: (r)=>r + 1
                    }
                }
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBarDefault.default), {
                context,
                save,
                showSave: state.feedback.length > 0
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                className: classes.content,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableContainerDefault.default), {
                    className: classes.container,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableDefault.default), {
                        className: classes.table,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworkStudentsHeadDefault.default), {
                                context: context
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworkStudentsBodyDefault.default), {
                                context,
                                feedback: state.feedback,
                                selectStudentForFeedback,
                                updateFeedback
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function homeworkStyles() {
    return {
        root: {
            flexGrow: 1,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            borderRadius: '4px',
            boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
        },
        content: {
            display: 'flex',
            flexGrow: 1,
            overflow: 'hidden'
        },
        container: {
            flexGrow: 1,
            overflow: 'auto'
        },
        chips: {
            padding: 10,
            '& .filter-chip': {
                backgroundColor: '#de3434',
                color: '#fff',
                '& .MuiChip-label': {
                    padding: '0 20px'
                },
                '& .MuiChip-deleteIcon': {}
            }
        },
        filters: {
            display: 'flex',
            padding: '0 15px 8px 15px',
            "& .create-quiz-wrapper": {
                display: "flex",
                marginTop: 15,
                flexDirection: "column",
                justifyContent: "center",
                paddingLeft: 15
            }
        },
        createButton: {
            margin: '10px'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","immutability-helper":"hwjCt","external/material":"6yEDE","@mui/material/Box":"73kto","@mui/material/TableContainer":"2Kmn7","@mui/material/Table":"if4Vw","./components/homework-students/info-bar":"ivg0V","./components/homework-students/homework-students-head":"euV1V","./components/homework-students/homework-students-body":"fb8EB","helpers/command":"f3cbG","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ivg0V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfoBar);
var _jsxRuntime = require("react/jsx-runtime");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _backButton = require("components/back-button");
var _backButtonDefault = parcelHelpers.interopDefault(_backButton);
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const useStyles = (0, _material.makeStyles)(infoBarStyles);
function InfoBar({ context, save, showSave }) {
    const classes = useStyles();
    const { homeworkContext, translate, link, linkQuery, homeworkId, updateState } = context;
    const { review } = homeworkContext;
    const homework = homeworkContext.homeworks ? homeworkContext.homeworks.items.find((h)=>h.id == homeworkId) : {};
    function formatDate(date) {
        return (0, _momentDefault.default)(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
    }
    function handleBackButton(e) {
        updateState({
            homeworkContext: {
                review: {
                    from: {
                        $set: undefined
                    },
                    query: {
                        $set: undefined
                    }
                }
            }
        });
    }
    if (!homework) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    const backLink = review.from ? linkQuery(review.from, review.query) : link({
        homeworkId: undefined
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backButtonDefault.default), {
                    onClick: handleBackButton,
                    link: backLink
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.middle, classes.label),
                children: [
                    translate('homework'),
                    ": ",
                    homework ? homework.title : ''
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                className: (0, _clsxDefault.default)(classes.homeworkDates),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: translate('homework-from-date')
                            }),
                            ": \xa0 ",
                            formatDate(homework.startDate)
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: translate('homework-to-date')
                            }),
                            ": \xa0 ",
                            formatDate(homework.startDate)
                        ]
                    })
                ]
            }),
            showSave && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                variant: "contained",
                className: (0, _clsxDefault.default)(classes.button, "save"),
                onClick: save,
                children: translate('save')
            })
        ]
    });
}
function infoBarStyles() {
    return {
        root: {
            display: 'flex',
            minHeight: '60px',
            maxHeight: '60px',
            '& svg': {
                fill: '#4f556d'
            },
            '& a.MuiIconButton-root': {
                margin: 0,
                padding: '17px 12px',
                borderRight: '1px solid #ddd',
                borderRadius: 0
            }
        },
        avatar: {
            fontSize: '25pt',
            color: '#09b1b2'
        },
        middle: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        label: {
            marginLeft: '10px',
            fontSize: '14pt',
            flexGrow: 1
        },
        homeworkDates: {
            padding: 10,
            '& div': {
                textAlign: 'right'
            },
            '& span': {
                fontWeight: 'bold'
            }
        },
        button: {
            width: 120,
            fontSize: "13pt",
            textTransform: "none",
            boxShadow: 'none',
            borderRadius: 4,
            margin: 10,
            textAlign: 'center',
            padding: 7,
            cursor: 'pointer',
            "&.save": {
                color: "#fff",
                border: 'solid 1px #2c75bd',
                backgroundColor: '#2c75bd',
                color: '#fff',
                textTransform: 'capitalize',
                '&:hover': {
                    backgroundColor: '#29739f',
                    borderColor: '#29739f',
                    boxShadow: 'none'
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","clsx":"5PNR8","react":"9njXz","external/material":"6yEDE","@mui/material/Box":"73kto","components/back-button":"nQlBv","helpers/moment":"jwdju","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"euV1V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworksHead);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableHead = require("@mui/material/TableHead");
var _tableHeadDefault = parcelHelpers.interopDefault(_tableHead);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableSortLabel = require("@mui/material/TableSortLabel");
var _tableSortLabelDefault = parcelHelpers.interopDefault(_tableSortLabel);
const headCells = [
    {
        id: 'student',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'status',
        align: 'center',
        disablePadding: false
    },
    {
        id: 'turnedIn',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'files',
        align: 'center',
        disablePadding: false
    },
    {
        id: 'score',
        align: 'left',
        disablePadding: false
    },
    {
        id: 'feedback',
        align: 'center',
        disablePadding: false
    }
];
const useStyles = (0, _material.makeStyles)(homeworkHeadStyles);
function HomeworksHead({ context }) {
    const classes = useStyles();
    const history = (0, _reactRouterDom.useHistory)();
    const { query, translate, link, linkQuery, homeworkId } = context;
    const order = query.orderBy ? query.orderBy.startsWith('-') ? 'desc' : 'asc' : undefined;
    const orderBy = order ? order == 'asc' ? query.orderBy : query.orderBy.substring(1) : undefined;
    const createSortHandler = (property)=>(event)=>{
            history.push(linkQuery(link('homeworks', homeworkId), {
                ...query,
                orderBy: `${orderBy == property && order == 'asc' ? '-' : ''}${property}`
            }));
        };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableHeadDefault.default), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
            className: classes.headersRow,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.actions,
                    style: {
                        top: 92
                    },
                    align: "center"
                }),
                headCells.map(({ id, align, disablePadding })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                        align: align,
                        padding: disablePadding ? 'none' : 'normal',
                        sortDirection: order,
                        style: {
                            top: 92
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableSortLabelDefault.default), {
                            className: classes.headerLabel,
                            active: orderBy === id,
                            direction: order,
                            onClick: createSortHandler(id),
                            children: [
                                translate(`${id}-header`),
                                orderBy === id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: classes.visuallyHidden,
                                    children: order === 'desc' ? 'sorted descending' : 'sorted ascending'
                                }) : null
                            ]
                        })
                    }, id)),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                    className: classes.actions,
                    style: {
                        top: 92
                    },
                    align: "right"
                })
            ]
        })
    });
}
function homeworkHeadStyles() {
    return {
        headersRow: {
            color: '#50566e',
            '& > th': {
                borderTop: 'solid 1px #becfd7',
                backgroundColor: '#ffffff',
                padding: 6
            }
        },
        headerLabel: {
            color: '#4f576e',
            fontWeight: 500
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-router-dom":"3uzXR","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableHead":"inilD","@mui/material/TableRow":"4f4VX","@mui/material/TableSortLabel":"3xCAT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fb8EB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworkStudentsBody);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _tableCell = require("@mui/material/TableCell");
var _tableCellDefault = parcelHelpers.interopDefault(_tableCell);
var _tableRow = require("@mui/material/TableRow");
var _tableRowDefault = parcelHelpers.interopDefault(_tableRow);
var _tableBody = require("@mui/material/TableBody");
var _tableBodyDefault = parcelHelpers.interopDefault(_tableBody);
var _moment = require("helpers/moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _checkbox = require("@mui/material/Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _homeworkFeedback = require("./homework-feedback");
var _homeworkFeedbackDefault = parcelHelpers.interopDefault(_homeworkFeedback);
var _homeworkFiles = require("../homework-files");
var _homeworkFilesDefault = parcelHelpers.interopDefault(_homeworkFiles);
var _homeworkComments = require("./homework-comments");
var _homeworkCommentsDefault = parcelHelpers.interopDefault(_homeworkComments);
var _dateFns = require("external/date-fns");
const useStyles = (0, _material.makeStyles)(homeworkBodyStyles);
const initialState = {
    studentFiles: [],
    student: {}
};
function HomeworkStudentsBody({ context, feedback, selectStudentForFeedback, updateFeedback }) {
    const classes = useStyles();
    const { translate, homeworkContext, groups } = context;
    const homework = homeworkContext.homeworks.items.find((h)=>h.id == context.homeworkId) || {
        students: []
    };
    const groupMembers = groups.reduce((acc, { id, students })=>({
            ...acc,
            [id]: students
        }), {});
    const studentRecords = groupMembers[homework.group] || [];
    const students = homework.students.map((s)=>{
        const studentRecord = studentRecords.find((r)=>r.id == s.student) || {};
        return {
            ...s,
            studentRecord
        };
    });
    const { studentHomeworkStatus } = homeworkContext;
    function formatDate(date) {
        return (0, _momentDefault.default)(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
    }
    if (students.length == 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableBodyDefault.default), {
            children: students.map((s)=>{
                const status = studentHomeworkStatus.items.find((studentStatus)=>studentStatus.id == s.id);
                const lastStatus = status != undefined ? status.status[status.status.length - 1] : {};
                const expiredHomework = (0, _dateFns.isAfter)(new Date(), homework.endDate);
                const statusName = context.homeworkStatus[lastStatus.status];
                const homeworkStatus = expiredHomework && statusName != 'completed' ? 'expired' : statusName;
                const statusDate = [
                    'pending',
                    'completed'
                ].indexOf(statusName) > -1 ? formatDate(lastStatus.created) : '';
                const studentFeedback = feedback.find((f)=>f.id == s.id);
                const studentSelected = studentFeedback != undefined;
                const hasScore = lastStatus.score != undefined;
                const isLate = (0, _momentDefault.default)(lastStatus.created).diff(homework.endDate, 'hours') > 0;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tableRowDefault.default), {
                    className: classes.tableRow,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "center",
                            children: status != undefined && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkboxDefault.default), {
                                onChange: (e)=>selectStudentForFeedback(s.id, !studentSelected, studentSelected && hasScore ? lastStatus.score : {}),
                                checked: studentSelected
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "left",
                            children: s.studentRecord.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "left",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _clsxDefault.default)(classes.statusName, `${homeworkStatus}`),
                                children: translate('homework-status-' + homeworkStatus)
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "left",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: (0, _clsxDefault.default)(classes.statusDate, {
                                    'late': isLate
                                }),
                                children: statusDate
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                className: classes.filesContainer,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworkFilesDefault.default), {
                                    context: context,
                                    passport: s.studentRecord.studentId,
                                    files: s.properties.files
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "left",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                children: [
                                    studentSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworkFeedbackDefault.default), {
                                        context,
                                        homework,
                                        studentFeedback,
                                        updateFeedback,
                                        homeworkStatus
                                    }),
                                    !studentSelected && hasScore && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        children: [
                                            lastStatus.score,
                                            " / ",
                                            homework.properties.score
                                        ]
                                    }),
                                    !studentSelected && !hasScore && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                        children: [
                                            "- / ",
                                            homework.properties.score
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            className: classes.actions,
                            style: {
                                top: 92
                            },
                            align: "center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homeworkCommentsDefault.default), {
                                context: context,
                                status: status,
                                score: homework.properties.score
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tableCellDefault.default), {
                            align: "left"
                        })
                    ]
                }, s.id);
            })
        })
    });
}
function homeworkBodyStyles() {
    return {
        statusIndicator: {
            '&.available': {
                backgroundColor: 'orange',
                borderRadius: '100%',
                width: 15,
                height: 15,
                display: 'inline-block',
                marginRight: 10
            }
        },
        title: {
            cursor: 'pointer',
            width: '30%',
            '&:hover': {
                color: '#127e7e',
                textDecoration: 'underline'
            }
        },
        tableRow: {
            '& > td': {
                padding: 6
            }
        },
        statusName: {
            padding: '5px',
            color: '#fff',
            borderRadius: '20px',
            display: 'block',
            width: 100,
            margin: 'auto',
            textAlign: 'center',
            '&.assigned': {
                display: 'none',
                backgroundColor: '#f78d43'
            },
            '&.completed': {
                backgroundColor: '#06b71c'
            },
            '&.pending': {
                backgroundColor: '#0ac7ff'
            },
            '&.expired': {
                backgroundColor: '#afafaf'
            },
            '&.returned': {
                backgroundColor: '#ff0a0a'
            },
            '&.undefined': {
                display: 'none'
            }
        },
        statusDate: {
            '&.late': {
                color: 'red'
            }
        },
        scoreField: {
            fontSize: '14pt',
            fontWeight: 'bold'
        },
        scoreTextBox: {
            width: 70,
            height: 30,
            border: '1px solid #ccc',
            marginRight: 15,
            textAlign: 'center',
            padding: '0 5px',
            borderRadious: 4
        },
        filesContainer: {
            marginRight: 20
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        },
        personIcon: {
            color: '#128080',
            position: 'relative',
            top: 6
        },
        link: {
            color: '#2c75bd',
            fontSize: '16pt',
            marginRight: 20,
            cursor: 'pointer'
        },
        feedbackBox: {
            display: 'block',
            margin: '10px 0',
            backgroundColor: '#e8e8e8',
            padding: 5,
            borderRadius: 3,
            '& label': {
                fontSize: '12px'
            }
        },
        feedbackText: {
            fontSize: '12px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: 10,
            borderRadius: 4,
            border: '1px solid #ccc',
            width: '100%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","external/material":"6yEDE","@mui/material/TableCell":"8Htaw","@mui/material/TableRow":"4f4VX","@mui/material/TableBody":"bPEEy","helpers/moment":"jwdju","@mui/material/Box":"73kto","@mui/material/Checkbox":"4sdMA","./homework-feedback":"dEQqf","../homework-files":"5fg2m","./homework-comments":"iOgqU","external/date-fns":"kwxNe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dEQqf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworkFeedback);
var _jsxRuntime = require("react/jsx-runtime");
var _material = require("external/material");
const useStyles = (0, _material.makeStyles)(homeworkBodyStyles);
const ScoreField = (0, _material.styled)((0, _material.InputUnstyled))(scoreStyles);
function HomeworkFeedback({ context, studentFeedback, updateFeedback, homework, homeworkStatus }) {
    const { translate } = context;
    const classes = useStyles();
    function createHandler(prop, mapper = (e)=>e.target.value) {
        return (e)=>{
            updateFeedback(studentFeedback.id, prop, mapper(e));
        };
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                className: classes.scoreField,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(ScoreField, {
                        type: "number",
                        className: "scoreTextBox",
                        onKeyDown: (e)=>{
                            if (/\d/.test(e.key)) return;
                            if (e.key == '.' && e.target.value.indexOf('.') < 0) return;
                            if (e.key.length > 1) return;
                            e.preventDefault();
                        },
                        value: studentFeedback.score,
                        onChange: createHandler('score')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            "/ ",
                            homework.properties.score
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                className: classes.feedbackBox,
                children: [
                    homeworkStatus != 'expired' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Checkbox), {
                                checked: studentFeedback.returned,
                                onChange: createHandler('returned', ()=>!studentFeedback.returned)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: translate('homework-return')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.TextareaAutosize), {
                        className: classes.feedbackText,
                        rows: 2,
                        maxRows: 4,
                        placeholder: translate('feedback-header'),
                        value: studentFeedback.message,
                        onChange: createHandler('message')
                    })
                ]
            })
        ]
    });
}
function scoreStyles() {
    return {
        "&.scoreTextBox input": {
            width: 70,
            height: 30,
            border: '1px solid #ccc',
            marginRight: 15,
            textAlign: 'center',
            padding: '0 5px',
            borderRadious: 4
        }
    };
}
function homeworkBodyStyles() {
    return {
        scoreField: {
            fontSize: '14pt',
            fontWeight: 'bold',
            display: 'flex',
            "& > div": {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }
        },
        feedbackBox: {
            display: 'block',
            margin: '10px 0',
            backgroundColor: '#e8e8e8',
            padding: 5,
            borderRadius: 3,
            '& label': {
                fontSize: '12px'
            }
        },
        feedbackText: {
            fontSize: '12px',
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            padding: 10,
            borderRadius: 4,
            border: '1px solid #ccc',
            width: '100%'
        }
    };
}

},{"react/jsx-runtime":"1dlk8","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iOgqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>HomeworkComments);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _material = require("external/material");
var _url = require("helpers/url");
var _tooltip = require("@mui/material/Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _box = require("@mui/material/Box");
var _boxDefault = parcelHelpers.interopDefault(_box);
var _popover = require("@mui/material/Popover");
var _popoverDefault = parcelHelpers.interopDefault(_popover);
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
const useStyles = (0, _material.makeStyles)(homeworkBodyStyles);
function HomeworkComments({ context, status, score }) {
    const classes = useStyles();
    const { translate } = context;
    const [anchorEl, setAnchorEl] = (0, _reactDefault.default).useState(null);
    const handleViewFilesClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const openPopOver = Boolean(anchorEl);
    const id = openPopOver ? 'popover' : undefined;
    if (status == undefined) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    function formatDate(date) {
        return (0, _momentDefault.default)(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY');
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                onClick: (e)=>{
                    handleViewFilesClick(e);
                },
                className: (0, _clsxDefault.default)(classes.commentsIcon, {
                    hide: status.length == 0
                }),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactFontawesome.FontAwesomeIcon), {
                    icon: (0, _freeSolidSvgIcons.faHistory)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popoverDefault.default), {
                id: id,
                open: openPopOver,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                    className: classes.commentsPopover,
                    children: status != undefined && status.status.map((s, i)=>{
                        const status = context.homeworkStatus[s.status];
                        const statusName = translate(`homework-status-${status}`);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                            className: classes.comment,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _boxDefault.default), {
                                    className: "header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: (0, _clsxDefault.default)('status-date'),
                                            children: formatDate(s.created)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "status-score",
                                            children: `${s.score || '-'} / ${score}`
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: (0, _clsxDefault.default)('status-name', status),
                                            children: statusName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _boxDefault.default), {
                                    className: "message",
                                    children: s.message
                                })
                            ]
                        }, i);
                    })
                })
            })
        ]
    });
}
function homeworkBodyStyles() {
    return {
        comment: {
            padding: '5px 0',
            borderBottom: '1px dotted #ccc',
            color: '#555',
            '& .header': {
                display: 'flex',
                '& .status-date': {
                    flexGrow: 1
                },
                '& .status-score': {
                    marginRight: 20
                }
            }
        },
        commentsPopover: {
            minWidth: 400,
            display: 'flex',
            flexDirection: 'column',
            padding: '20px 20px',
            '& .status-name': {
                padding: '0',
                color: '#fff',
                borderRadius: '20px',
                width: 80,
                textAlign: 'center',
                fontSize: '.8em',
                '&.assigned': {
                    backgroundColor: '#f78d43'
                },
                '&.completed': {
                    backgroundColor: '#06b71c'
                },
                '&.pending': {
                    backgroundColor: '#0ac7ff'
                },
                '&.returned': {
                    backgroundColor: '#ff0a0a'
                }
            }
        },
        commentsIcon: {
            color: '#128080',
            fontSize: '16pt',
            cursor: 'pointer',
            paddingRight: 26
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","clsx":"5PNR8","external/material":"6yEDE","helpers/url":"65SQD","@mui/material/Tooltip":"7bRLE","@mui/material/Box":"73kto","@mui/material/Popover":"keu0V","@fortawesome/free-solid-svg-icons":"joPR3","@fortawesome/react-fontawesome":"32SD5","moment":"1e4qG","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9LvLu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CarruselVideos);
var _jsxRuntime = require("react/jsx-runtime");
var _videoGridContainer = require("./VideoGridContainer");
var _react = require("external/react");
var _context = require("teacher/context");
var _material = require("external/material");
const StyledVideoContainer = (0, _material.styled)('div')(videoStyles);
function CarruselVideos() {
    const context = (0, _react.useContext)((0, _context.TeacherContext));
    const { translate, profile, navigate } = context;
    const isDreyfous = (0, _react.useMemo)(()=>/^dreyfous.*/.test(profile.domain), [
        profile.domain
    ]);
    const isDgenius = (0, _react.useMemo)(()=>profile.institution.project == 'dgenius', [
        profile.institution.project
    ]);
    const [search, setSearch] = (0, _react.useState)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledVideoContainer, {
        className: "main-video-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "search-bar-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    onChange: (e)=>setSearch(e.target.value),
                    className: "search-bar",
                    placeholder: translate('search')
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoGridContainer.VideoGridContainer), {
                searchCriteria: search
            })
        ]
    });
}
function videoStyles() {
    return {
        "&.main-video-container": {
            display: "flex",
            width: "100%",
            padding: "50px 190px",
            flexDirection: "column",
            gap: "16px",
            marginBottom: "10px"
        },
        "& .carousel-grid-container": {
            display: "grid",
            width: "100%",
            gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
            gap: "22px",
            boxSizing: "border-box",
            overflowY: "auto",
            paddingRight: "10px"
        },
        "& .search-bar-container": {
            display: "flex",
            width: "100%",
            height: "60px",
            backgroundColor: "white",
            boxSizing: "border-box",
            padding: "15px",
            borderRadius: "4px",
            border: "1px solid rgb(200, 200, 200)"
        },
        "& .search-bar": {
            height: "30px",
            width: "250px",
            borderRadius: "50px",
            border: "1px solid rgb(200, 200, 200)",
            paddingLeft: "10px"
        },
        "& .carousel-item": {
            width: "100%",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "transform 0.2s",
            backgroundColor: "white",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px"
        },
        "& .carousel-item:hover": {
            transform: "scale(1.05)"
        },
        "& .carousel-item img": {
            width: "100%",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            aspectRatio: "16/11",
            objectFit: "cover"
        },
        "& .video-title": {
            fontSize: "14px",
            marginTop: "6px",
            color: "#2c7cbd",
            padding: "16px",
            margin: 0,
            boxSizing: "border-box",
            width: "100%"
        },
        "& .video-description": {
            fontSize: "11px",
            padding: "0px 16px 16px 16px",
            margin: 0,
            boxSizing: "border-box",
            width: "100%"
        },
        "& .modal-overlay": {
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.75)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 99999999
        },
        "& .modal-content": {
            position: "relative",
            width: "90%",
            maxWidth: "800px",
            background: "#000",
            borderRadius: "10px",
            padding: "12px"
        },
        "& .modal-content iframe": {
            width: "100%",
            height: "450px",
            borderRadius: "6px"
        },
        "& .modal-content h3": {
            color: "white",
            marginTop: "10px",
            fontSize: "16px"
        },
        "& .close-button": {
            position: "absolute",
            top: "6px",
            right: "8px",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "22px",
            cursor: "pointer"
        }
    };
}

},{"react/jsx-runtime":"1dlk8","./VideoGridContainer":"lVa6H","external/react":"k16GP","teacher/context":"5LKDx","external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lVa6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VideoGridContainer", ()=>VideoGridContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("external/react");
var _context = require("teacher/context");
const VideoGridContainer = ({ searchCriteria })=>{
    const { dashboard, updateState } = (0, _react.useContext)((0, _context.TeacherContext));
    const activeVideo = (0, _react.useMemo)(()=>dashboard.activeVideo, [
        dashboard.activeVideo
    ]);
    const videos = (0, _react.useMemo)(()=>dashboard.videos, [
        dashboard.videos
    ]);
    const setActiveVideo = (0, _react.useMemo)(()=>(video)=>updateState({
                dashboard: {
                    activeVideo: {
                        $set: video
                    }
                }
            }), []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "carousel-grid-container",
        children: [
            videos?.filter((video)=>!searchCriteria || video.snippet.title.toLowerCase().includes(searchCriteria)).map((video)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(VideoContainer, {
                    video: video,
                    setActiveVideo: setActiveVideo
                }, video.id)),
            activeVideo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "modal-overlay",
                onClick: ()=>setActiveVideo(null),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-content",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "close-button",
                            onClick: ()=>setActiveVideo(null),
                            children: "\u2715"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                            src: `https://www.youtube.com/embed/${activeVideo.snippet.resourceId.videoId}?autoplay=1`,
                            title: activeVideo.snippet.title,
                            allow: "autoplay; encrypted-media",
                            allowFullScreen: true
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: activeVideo.snippet.title
                        })
                    ]
                })
            })
        ]
    });
};
const VideoContainer = ({ video, setActiveVideo })=>{
    const thumbnail = video.snippet.thumbnails.maxres ?? video.snippet.thumbnails.high;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "carousel-item",
        onClick: ()=>setActiveVideo(video),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: thumbnail?.url,
                alt: video.snippet.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "video-title",
                children: video.snippet.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "video-description",
                children: video.snippet.description.split(' ').slice(0, 10).join(' ').concat('...')
            })
        ]
    }, video.id);
};

},{"react/jsx-runtime":"1dlk8","external/react":"k16GP","teacher/context":"5LKDx","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"asbbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lodash = require("lodash");
var _page = require("../../components/page");
var _groups = require("./groups");
var _groupsDefault = parcelHelpers.interopDefault(_groups);
const pages = (0, _lodash.mapValues)({
    "groups": (0, _groupsDefault.default)
}, (0, _page.animatedPage));
exports.default = pages;

},{"lodash":"1qc47","../../components/page":"6ShgF","./groups":"kGok1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kGok1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Groups);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexStyl = require("./index.styl");
function Groups() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "groups",
        children: "Groups"
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./index.styl":"5jLiL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5jLiL":[function() {},{}],"agZfc":[function() {},{}],"lruE9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PlanningPdf);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactUse = require("react-use");
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _command = require("../../helpers/command");
var _group = require("./group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _planningFilenameCjs = require("components/standards-selector/domain/planning-filename.cjs");
var _plan = require("../planning/pdf/plan");
var _groups = require("../planning/pdf/groups");
var _groupsDefault = parcelHelpers.interopDefault(_groups);
var _fade = require("@mui/material/Fade");
var _fadeDefault = parcelHelpers.interopDefault(_fade);
var _printStyleJs = require("./print-style.js");
var _printStyleJsDefault = parcelHelpers.interopDefault(_printStyleJs);
var _indexStyl = require("./index.styl");
function SavePDF(props) {
    const { context, author, range, title } = props;
    const [groupMap, setGroupMap] = (0, _reactDefault.default).useState(undefined);
    (0, _reactDefault.default).useEffect(()=>{
        setGroupMap(context.pdfPlans.reduce((acc, plan)=>{
            const id = plan.clique || 'all';
            const plans = acc[id] = acc[id] || [];
            const parsedPlan = (0, _plan.parseContext)(context, plan);
            plans.push(parsedPlan);
            return acc;
        }, {}));
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "save",
        children: groupMap && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupsDefault.default), {
            className: "button",
            fileName: props.filename,
            groupMap: groupMap,
            author: props.author,
            range: props.range,
            document: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groups.PDFDocument), {
                groupMap,
                author,
                range,
                title
            }),
            children: context.translate("download-planning")
        })
    });
}
function PlanningPdf() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { query, profile, pdfPlans, translate } = context;
            const { first_name, last_name } = profile.individual;
            const { project, startDate, endDate } = profile.institution;
            const { start = startDate, end = endDate } = query;
            const format = (date)=>(0, _momentDefault.default)(date).format('MM/DD/YYYY');
            const author = {
                name: first_name,
                lastName: last_name
            };
            const range = `${format(start)} - ${format(end)}`;
            const filename = (0, _planningFilenameCjs.planningFilename)([
                translate('planning'),
                first_name,
                last_name
            ]);
            const title = `${translate(`${project}_project_title`)} - ${translate("planning_title")}`;
            const groupMap = pdfPlans.reduce((acc, plan)=>{
                const id = plan.clique || 'all';
                const plans = acc[id] = acc[id] || [];
                plans.push(plan);
                return acc;
            }, {});
            const groups = Object.entries(groupMap).map(([key, plans])=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupDefault.default), {
                    id: key,
                    plans: plans
                }, key));
            const pdfDataReady = context.pdfPlansLoaded && context.teacherExpectationsLoaded && context.teacherStandardsLoaded && context.grades.length > 1 && context.subjects.length > 1 && context.groups.length > 1;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "pdfWrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pdfHtml",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "save",
                                    children: pdfDataReady && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SavePDF, {
                                        context,
                                        filename,
                                        author,
                                        range,
                                        title
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "date",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "generated",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                            id: "generated"
                                                        }),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: format()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "date-range",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                            id: "date-range"
                                                        }),
                                                        ":"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: range
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "groups",
                            children: groups
                        })
                    ]
                })
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-use":"65q4H","react-text":"lEpdJ","../../context":"iUP37","../../helpers/command":"f3cbG","./group":"8uni1","components/standards-selector/domain/planning-filename.cjs":"9iiNb","../planning/pdf/plan":"h2quG","../planning/pdf/groups":"9s8Ix","@mui/material/Fade":"8DwqP","./print-style.js":"aaJDy","./index.styl":"QRFF0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"65q4H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMemo", ()=>(0, _createMemoDefault.default));
parcelHelpers.export(exports, "createReducerContext", ()=>(0, _createReducerContextDefault.default));
parcelHelpers.export(exports, "createReducer", ()=>(0, _createReducerDefault.default));
parcelHelpers.export(exports, "createStateContext", ()=>(0, _createStateContextDefault.default));
parcelHelpers.export(exports, "useAsync", ()=>(0, _useAsyncDefault.default));
parcelHelpers.export(exports, "useAsyncFn", ()=>(0, _useAsyncFnDefault.default));
parcelHelpers.export(exports, "useAsyncRetry", ()=>(0, _useAsyncRetryDefault.default));
parcelHelpers.export(exports, "useAudio", ()=>(0, _useAudioDefault.default));
parcelHelpers.export(exports, "useBattery", ()=>(0, _useBatteryDefault.default));
parcelHelpers.export(exports, "useBeforeUnload", ()=>(0, _useBeforeUnloadDefault.default));
parcelHelpers.export(exports, "useBoolean", ()=>(0, _useBooleanDefault.default));
parcelHelpers.export(exports, "useClickAway", ()=>(0, _useClickAwayDefault.default));
parcelHelpers.export(exports, "useCookie", ()=>(0, _useCookieDefault.default));
parcelHelpers.export(exports, "useCopyToClipboard", ()=>(0, _useCopyToClipboardDefault.default));
parcelHelpers.export(exports, "useCounter", ()=>(0, _useCounterDefault.default));
parcelHelpers.export(exports, "useCss", ()=>(0, _useCssDefault.default));
parcelHelpers.export(exports, "useCustomCompareEffect", ()=>(0, _useCustomCompareEffectDefault.default));
parcelHelpers.export(exports, "useDebounce", ()=>(0, _useDebounceDefault.default));
parcelHelpers.export(exports, "useDeepCompareEffect", ()=>(0, _useDeepCompareEffectDefault.default));
parcelHelpers.export(exports, "useDefault", ()=>(0, _useDefaultDefault.default));
parcelHelpers.export(exports, "useDrop", ()=>(0, _useDropDefault.default));
parcelHelpers.export(exports, "useDropArea", ()=>(0, _useDropAreaDefault.default));
parcelHelpers.export(exports, "useEffectOnce", ()=>(0, _useEffectOnceDefault.default));
parcelHelpers.export(exports, "useEnsuredForwardedRef", ()=>(0, _useEnsuredForwardedRefDefault.default));
parcelHelpers.export(exports, "ensuredForwardRef", ()=>(0, _useEnsuredForwardedRef.ensuredForwardRef));
parcelHelpers.export(exports, "useEvent", ()=>(0, _useEventDefault.default));
parcelHelpers.export(exports, "useError", ()=>(0, _useErrorDefault.default));
parcelHelpers.export(exports, "useFavicon", ()=>(0, _useFaviconDefault.default));
parcelHelpers.export(exports, "useFullscreen", ()=>(0, _useFullscreenDefault.default));
parcelHelpers.export(exports, "useGeolocation", ()=>(0, _useGeolocationDefault.default));
parcelHelpers.export(exports, "useGetSet", ()=>(0, _useGetSetDefault.default));
parcelHelpers.export(exports, "useGetSetState", ()=>(0, _useGetSetStateDefault.default));
parcelHelpers.export(exports, "useHarmonicIntervalFn", ()=>(0, _useHarmonicIntervalFnDefault.default));
parcelHelpers.export(exports, "useHover", ()=>(0, _useHoverDefault.default));
parcelHelpers.export(exports, "useHoverDirty", ()=>(0, _useHoverDirtyDefault.default));
parcelHelpers.export(exports, "useIdle", ()=>(0, _useIdleDefault.default));
parcelHelpers.export(exports, "useIntersection", ()=>(0, _useIntersectionDefault.default));
parcelHelpers.export(exports, "useInterval", ()=>(0, _useIntervalDefault.default));
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>(0, _useIsomorphicLayoutEffectDefault.default));
parcelHelpers.export(exports, "useKey", ()=>(0, _useKeyDefault.default));
parcelHelpers.export(exports, "createBreakpoint", ()=>(0, _createBreakpointDefault.default));
// not exported because of peer dependency
// export { default as useKeyboardJs } from './useKeyboardJs';
parcelHelpers.export(exports, "useKeyPress", ()=>(0, _useKeyPressDefault.default));
parcelHelpers.export(exports, "useKeyPressEvent", ()=>(0, _useKeyPressEventDefault.default));
parcelHelpers.export(exports, "useLifecycles", ()=>(0, _useLifecyclesDefault.default));
parcelHelpers.export(exports, "useList", ()=>(0, _useListDefault.default));
parcelHelpers.export(exports, "useLocalStorage", ()=>(0, _useLocalStorageDefault.default));
parcelHelpers.export(exports, "useLocation", ()=>(0, _useLocationDefault.default));
parcelHelpers.export(exports, "useLockBodyScroll", ()=>(0, _useLockBodyScrollDefault.default));
parcelHelpers.export(exports, "useLogger", ()=>(0, _useLoggerDefault.default));
parcelHelpers.export(exports, "useLongPress", ()=>(0, _useLongPressDefault.default));
parcelHelpers.export(exports, "useMap", ()=>(0, _useMapDefault.default));
parcelHelpers.export(exports, "useMedia", ()=>(0, _useMediaDefault.default));
parcelHelpers.export(exports, "useMediaDevices", ()=>(0, _useMediaDevicesDefault.default));
parcelHelpers.export(exports, "useMediatedState", ()=>(0, _useMediatedState.useMediatedState));
parcelHelpers.export(exports, "useMethods", ()=>(0, _useMethodsDefault.default));
parcelHelpers.export(exports, "useMotion", ()=>(0, _useMotionDefault.default));
parcelHelpers.export(exports, "useMount", ()=>(0, _useMountDefault.default));
parcelHelpers.export(exports, "useMountedState", ()=>(0, _useMountedStateDefault.default));
parcelHelpers.export(exports, "useMouse", ()=>(0, _useMouseDefault.default));
parcelHelpers.export(exports, "useMouseHovered", ()=>(0, _useMouseHoveredDefault.default));
parcelHelpers.export(exports, "useNetwork", ()=>(0, _useNetworkDefault.default));
parcelHelpers.export(exports, "useNumber", ()=>(0, _useNumberDefault.default));
parcelHelpers.export(exports, "useObservable", ()=>(0, _useObservableDefault.default));
parcelHelpers.export(exports, "useOrientation", ()=>(0, _useOrientationDefault.default));
parcelHelpers.export(exports, "usePageLeave", ()=>(0, _usePageLeaveDefault.default));
parcelHelpers.export(exports, "usePermission", ()=>(0, _usePermissionDefault.default));
parcelHelpers.export(exports, "usePrevious", ()=>(0, _usePreviousDefault.default));
parcelHelpers.export(exports, "usePreviousDistinct", ()=>(0, _usePreviousDistinctDefault.default));
parcelHelpers.export(exports, "usePromise", ()=>(0, _usePromiseDefault.default));
parcelHelpers.export(exports, "useQueue", ()=>(0, _useQueueDefault.default));
parcelHelpers.export(exports, "useRaf", ()=>(0, _useRafDefault.default));
parcelHelpers.export(exports, "useRafLoop", ()=>(0, _useRafLoopDefault.default));
parcelHelpers.export(exports, "useRafState", ()=>(0, _useRafStateDefault.default));
parcelHelpers.export(exports, "useSearchParam", ()=>(0, _useSearchParamDefault.default));
parcelHelpers.export(exports, "useScratch", ()=>(0, _useScratchDefault.default));
parcelHelpers.export(exports, "useScroll", ()=>(0, _useScrollDefault.default));
parcelHelpers.export(exports, "useScrolling", ()=>(0, _useScrollingDefault.default));
parcelHelpers.export(exports, "useSessionStorage", ()=>(0, _useSessionStorageDefault.default));
parcelHelpers.export(exports, "useSetState", ()=>(0, _useSetStateDefault.default));
parcelHelpers.export(exports, "useShallowCompareEffect", ()=>(0, _useShallowCompareEffectDefault.default));
parcelHelpers.export(exports, "useSize", ()=>(0, _useSizeDefault.default));
parcelHelpers.export(exports, "useSlider", ()=>(0, _useSliderDefault.default));
parcelHelpers.export(exports, "useSpeech", ()=>(0, _useSpeechDefault.default));
// not exported because of peer dependency
// export { default as useSpring } from './useSpring';
parcelHelpers.export(exports, "useStartTyping", ()=>(0, _useStartTypingDefault.default));
parcelHelpers.export(exports, "useStateWithHistory", ()=>(0, _useStateWithHistory.useStateWithHistory));
parcelHelpers.export(exports, "useStateList", ()=>(0, _useStateListDefault.default));
parcelHelpers.export(exports, "useThrottle", ()=>(0, _useThrottleDefault.default));
parcelHelpers.export(exports, "useThrottleFn", ()=>(0, _useThrottleFnDefault.default));
parcelHelpers.export(exports, "useTimeout", ()=>(0, _useTimeoutDefault.default));
parcelHelpers.export(exports, "useTimeoutFn", ()=>(0, _useTimeoutFnDefault.default));
parcelHelpers.export(exports, "useTitle", ()=>(0, _useTitleDefault.default));
parcelHelpers.export(exports, "useToggle", ()=>(0, _useToggleDefault.default));
parcelHelpers.export(exports, "useTween", ()=>(0, _useTweenDefault.default));
parcelHelpers.export(exports, "useUnmount", ()=>(0, _useUnmountDefault.default));
parcelHelpers.export(exports, "useUnmountPromise", ()=>(0, _useUnmountPromiseDefault.default));
parcelHelpers.export(exports, "useUpdate", ()=>(0, _useUpdateDefault.default));
parcelHelpers.export(exports, "useUpdateEffect", ()=>(0, _useUpdateEffectDefault.default));
parcelHelpers.export(exports, "useUpsert", ()=>(0, _useUpsertDefault.default));
parcelHelpers.export(exports, "useVibrate", ()=>(0, _useVibrateDefault.default));
parcelHelpers.export(exports, "useVideo", ()=>(0, _useVideoDefault.default));
parcelHelpers.export(exports, "useStateValidator", ()=>(0, _useStateValidatorDefault.default));
parcelHelpers.export(exports, "useScrollbarWidth", ()=>(0, _useScrollbarWidth.useScrollbarWidth));
parcelHelpers.export(exports, "useMultiStateValidator", ()=>(0, _useMultiStateValidator.useMultiStateValidator));
parcelHelpers.export(exports, "useWindowScroll", ()=>(0, _useWindowScrollDefault.default));
parcelHelpers.export(exports, "useWindowSize", ()=>(0, _useWindowSizeDefault.default));
parcelHelpers.export(exports, "useMeasure", ()=>(0, _useMeasureDefault.default));
parcelHelpers.export(exports, "useRendersCount", ()=>(0, _useRendersCount.useRendersCount));
parcelHelpers.export(exports, "useFirstMountState", ()=>(0, _useFirstMountState.useFirstMountState));
parcelHelpers.export(exports, "useSet", ()=>(0, _useSetDefault.default));
parcelHelpers.export(exports, "createGlobalState", ()=>(0, _createGlobalState.createGlobalState));
parcelHelpers.export(exports, "useHash", ()=>(0, _useHash.useHash));
var _createMemo = require("./createMemo");
var _createMemoDefault = parcelHelpers.interopDefault(_createMemo);
var _createReducerContext = require("./createReducerContext");
var _createReducerContextDefault = parcelHelpers.interopDefault(_createReducerContext);
var _createReducer = require("./createReducer");
var _createReducerDefault = parcelHelpers.interopDefault(_createReducer);
var _createStateContext = require("./createStateContext");
var _createStateContextDefault = parcelHelpers.interopDefault(_createStateContext);
var _useAsync = require("./useAsync");
var _useAsyncDefault = parcelHelpers.interopDefault(_useAsync);
var _useAsyncFn = require("./useAsyncFn");
var _useAsyncFnDefault = parcelHelpers.interopDefault(_useAsyncFn);
var _useAsyncRetry = require("./useAsyncRetry");
var _useAsyncRetryDefault = parcelHelpers.interopDefault(_useAsyncRetry);
var _useAudio = require("./useAudio");
var _useAudioDefault = parcelHelpers.interopDefault(_useAudio);
var _useBattery = require("./useBattery");
var _useBatteryDefault = parcelHelpers.interopDefault(_useBattery);
var _useBeforeUnload = require("./useBeforeUnload");
var _useBeforeUnloadDefault = parcelHelpers.interopDefault(_useBeforeUnload);
var _useBoolean = require("./useBoolean");
var _useBooleanDefault = parcelHelpers.interopDefault(_useBoolean);
var _useClickAway = require("./useClickAway");
var _useClickAwayDefault = parcelHelpers.interopDefault(_useClickAway);
var _useCookie = require("./useCookie");
var _useCookieDefault = parcelHelpers.interopDefault(_useCookie);
var _useCopyToClipboard = require("./useCopyToClipboard");
var _useCopyToClipboardDefault = parcelHelpers.interopDefault(_useCopyToClipboard);
var _useCounter = require("./useCounter");
var _useCounterDefault = parcelHelpers.interopDefault(_useCounter);
var _useCss = require("./useCss");
var _useCssDefault = parcelHelpers.interopDefault(_useCss);
var _useCustomCompareEffect = require("./useCustomCompareEffect");
var _useCustomCompareEffectDefault = parcelHelpers.interopDefault(_useCustomCompareEffect);
var _useDebounce = require("./useDebounce");
var _useDebounceDefault = parcelHelpers.interopDefault(_useDebounce);
var _useDeepCompareEffect = require("./useDeepCompareEffect");
var _useDeepCompareEffectDefault = parcelHelpers.interopDefault(_useDeepCompareEffect);
var _useDefault = require("./useDefault");
var _useDefaultDefault = parcelHelpers.interopDefault(_useDefault);
var _useDrop = require("./useDrop");
var _useDropDefault = parcelHelpers.interopDefault(_useDrop);
var _useDropArea = require("./useDropArea");
var _useDropAreaDefault = parcelHelpers.interopDefault(_useDropArea);
var _useEffectOnce = require("./useEffectOnce");
var _useEffectOnceDefault = parcelHelpers.interopDefault(_useEffectOnce);
var _useEnsuredForwardedRef = require("./useEnsuredForwardedRef");
var _useEnsuredForwardedRefDefault = parcelHelpers.interopDefault(_useEnsuredForwardedRef);
var _useEvent = require("./useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useError = require("./useError");
var _useErrorDefault = parcelHelpers.interopDefault(_useError);
var _useFavicon = require("./useFavicon");
var _useFaviconDefault = parcelHelpers.interopDefault(_useFavicon);
var _useFullscreen = require("./useFullscreen");
var _useFullscreenDefault = parcelHelpers.interopDefault(_useFullscreen);
var _useGeolocation = require("./useGeolocation");
var _useGeolocationDefault = parcelHelpers.interopDefault(_useGeolocation);
var _useGetSet = require("./useGetSet");
var _useGetSetDefault = parcelHelpers.interopDefault(_useGetSet);
var _useGetSetState = require("./useGetSetState");
var _useGetSetStateDefault = parcelHelpers.interopDefault(_useGetSetState);
var _useHarmonicIntervalFn = require("./useHarmonicIntervalFn");
var _useHarmonicIntervalFnDefault = parcelHelpers.interopDefault(_useHarmonicIntervalFn);
var _useHover = require("./useHover");
var _useHoverDefault = parcelHelpers.interopDefault(_useHover);
var _useHoverDirty = require("./useHoverDirty");
var _useHoverDirtyDefault = parcelHelpers.interopDefault(_useHoverDirty);
var _useIdle = require("./useIdle");
var _useIdleDefault = parcelHelpers.interopDefault(_useIdle);
var _useIntersection = require("./useIntersection");
var _useIntersectionDefault = parcelHelpers.interopDefault(_useIntersection);
var _useInterval = require("./useInterval");
var _useIntervalDefault = parcelHelpers.interopDefault(_useInterval);
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _useKey = require("./useKey");
var _useKeyDefault = parcelHelpers.interopDefault(_useKey);
var _createBreakpoint = require("./createBreakpoint");
var _createBreakpointDefault = parcelHelpers.interopDefault(_createBreakpoint);
var _useKeyPress = require("./useKeyPress");
var _useKeyPressDefault = parcelHelpers.interopDefault(_useKeyPress);
var _useKeyPressEvent = require("./useKeyPressEvent");
var _useKeyPressEventDefault = parcelHelpers.interopDefault(_useKeyPressEvent);
var _useLifecycles = require("./useLifecycles");
var _useLifecyclesDefault = parcelHelpers.interopDefault(_useLifecycles);
var _useList = require("./useList");
var _useListDefault = parcelHelpers.interopDefault(_useList);
var _useLocalStorage = require("./useLocalStorage");
var _useLocalStorageDefault = parcelHelpers.interopDefault(_useLocalStorage);
var _useLocation = require("./useLocation");
var _useLocationDefault = parcelHelpers.interopDefault(_useLocation);
var _useLockBodyScroll = require("./useLockBodyScroll");
var _useLockBodyScrollDefault = parcelHelpers.interopDefault(_useLockBodyScroll);
var _useLogger = require("./useLogger");
var _useLoggerDefault = parcelHelpers.interopDefault(_useLogger);
var _useLongPress = require("./useLongPress");
var _useLongPressDefault = parcelHelpers.interopDefault(_useLongPress);
var _useMap = require("./useMap");
var _useMapDefault = parcelHelpers.interopDefault(_useMap);
var _useMedia = require("./useMedia");
var _useMediaDefault = parcelHelpers.interopDefault(_useMedia);
var _useMediaDevices = require("./useMediaDevices");
var _useMediaDevicesDefault = parcelHelpers.interopDefault(_useMediaDevices);
var _useMediatedState = require("./useMediatedState");
var _useMethods = require("./useMethods");
var _useMethodsDefault = parcelHelpers.interopDefault(_useMethods);
var _useMotion = require("./useMotion");
var _useMotionDefault = parcelHelpers.interopDefault(_useMotion);
var _useMount = require("./useMount");
var _useMountDefault = parcelHelpers.interopDefault(_useMount);
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
var _useMouse = require("./useMouse");
var _useMouseDefault = parcelHelpers.interopDefault(_useMouse);
var _useMouseHovered = require("./useMouseHovered");
var _useMouseHoveredDefault = parcelHelpers.interopDefault(_useMouseHovered);
var _useNetwork = require("./useNetwork");
var _useNetworkDefault = parcelHelpers.interopDefault(_useNetwork);
var _useNumber = require("./useNumber");
var _useNumberDefault = parcelHelpers.interopDefault(_useNumber);
var _useObservable = require("./useObservable");
var _useObservableDefault = parcelHelpers.interopDefault(_useObservable);
var _useOrientation = require("./useOrientation");
var _useOrientationDefault = parcelHelpers.interopDefault(_useOrientation);
var _usePageLeave = require("./usePageLeave");
var _usePageLeaveDefault = parcelHelpers.interopDefault(_usePageLeave);
var _usePermission = require("./usePermission");
var _usePermissionDefault = parcelHelpers.interopDefault(_usePermission);
var _usePrevious = require("./usePrevious");
var _usePreviousDefault = parcelHelpers.interopDefault(_usePrevious);
var _usePreviousDistinct = require("./usePreviousDistinct");
var _usePreviousDistinctDefault = parcelHelpers.interopDefault(_usePreviousDistinct);
var _usePromise = require("./usePromise");
var _usePromiseDefault = parcelHelpers.interopDefault(_usePromise);
var _useQueue = require("./useQueue");
var _useQueueDefault = parcelHelpers.interopDefault(_useQueue);
var _useRaf = require("./useRaf");
var _useRafDefault = parcelHelpers.interopDefault(_useRaf);
var _useRafLoop = require("./useRafLoop");
var _useRafLoopDefault = parcelHelpers.interopDefault(_useRafLoop);
var _useRafState = require("./useRafState");
var _useRafStateDefault = parcelHelpers.interopDefault(_useRafState);
var _useSearchParam = require("./useSearchParam");
var _useSearchParamDefault = parcelHelpers.interopDefault(_useSearchParam);
var _useScratch = require("./useScratch");
var _useScratchDefault = parcelHelpers.interopDefault(_useScratch);
var _useScroll = require("./useScroll");
var _useScrollDefault = parcelHelpers.interopDefault(_useScroll);
var _useScrolling = require("./useScrolling");
var _useScrollingDefault = parcelHelpers.interopDefault(_useScrolling);
var _useSessionStorage = require("./useSessionStorage");
var _useSessionStorageDefault = parcelHelpers.interopDefault(_useSessionStorage);
var _useSetState = require("./useSetState");
var _useSetStateDefault = parcelHelpers.interopDefault(_useSetState);
var _useShallowCompareEffect = require("./useShallowCompareEffect");
var _useShallowCompareEffectDefault = parcelHelpers.interopDefault(_useShallowCompareEffect);
var _useSize = require("./useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _useSlider = require("./useSlider");
var _useSliderDefault = parcelHelpers.interopDefault(_useSlider);
var _useSpeech = require("./useSpeech");
var _useSpeechDefault = parcelHelpers.interopDefault(_useSpeech);
var _useStartTyping = require("./useStartTyping");
var _useStartTypingDefault = parcelHelpers.interopDefault(_useStartTyping);
var _useStateWithHistory = require("./useStateWithHistory");
var _useStateList = require("./useStateList");
var _useStateListDefault = parcelHelpers.interopDefault(_useStateList);
var _useThrottle = require("./useThrottle");
var _useThrottleDefault = parcelHelpers.interopDefault(_useThrottle);
var _useThrottleFn = require("./useThrottleFn");
var _useThrottleFnDefault = parcelHelpers.interopDefault(_useThrottleFn);
var _useTimeout = require("./useTimeout");
var _useTimeoutDefault = parcelHelpers.interopDefault(_useTimeout);
var _useTimeoutFn = require("./useTimeoutFn");
var _useTimeoutFnDefault = parcelHelpers.interopDefault(_useTimeoutFn);
var _useTitle = require("./useTitle");
var _useTitleDefault = parcelHelpers.interopDefault(_useTitle);
var _useToggle = require("./useToggle");
var _useToggleDefault = parcelHelpers.interopDefault(_useToggle);
var _useTween = require("./useTween");
var _useTweenDefault = parcelHelpers.interopDefault(_useTween);
var _useUnmount = require("./useUnmount");
var _useUnmountDefault = parcelHelpers.interopDefault(_useUnmount);
var _useUnmountPromise = require("./useUnmountPromise");
var _useUnmountPromiseDefault = parcelHelpers.interopDefault(_useUnmountPromise);
var _useUpdate = require("./useUpdate");
var _useUpdateDefault = parcelHelpers.interopDefault(_useUpdate);
var _useUpdateEffect = require("./useUpdateEffect");
var _useUpdateEffectDefault = parcelHelpers.interopDefault(_useUpdateEffect);
var _useUpsert = require("./useUpsert");
var _useUpsertDefault = parcelHelpers.interopDefault(_useUpsert);
var _useVibrate = require("./useVibrate");
var _useVibrateDefault = parcelHelpers.interopDefault(_useVibrate);
var _useVideo = require("./useVideo");
var _useVideoDefault = parcelHelpers.interopDefault(_useVideo);
var _useStateValidator = require("./useStateValidator");
var _useStateValidatorDefault = parcelHelpers.interopDefault(_useStateValidator);
var _useScrollbarWidth = require("./useScrollbarWidth");
var _useMultiStateValidator = require("./useMultiStateValidator");
var _useWindowScroll = require("./useWindowScroll");
var _useWindowScrollDefault = parcelHelpers.interopDefault(_useWindowScroll);
var _useWindowSize = require("./useWindowSize");
var _useWindowSizeDefault = parcelHelpers.interopDefault(_useWindowSize);
var _useMeasure = require("./useMeasure");
var _useMeasureDefault = parcelHelpers.interopDefault(_useMeasure);
var _useRendersCount = require("./useRendersCount");
var _useFirstMountState = require("./useFirstMountState");
var _useSet = require("./useSet");
var _useSetDefault = parcelHelpers.interopDefault(_useSet);
var _createGlobalState = require("./createGlobalState");
var _useHash = require("./useHash");

},{"./createMemo":"iDOyC","./createReducerContext":"4SdFH","./createReducer":"68R4d","./createStateContext":"kiWTu","./useAsync":"i0u2A","./useAsyncFn":"bcVdw","./useAsyncRetry":"9u9tN","./useAudio":"3tRhD","./useBattery":"2V2Cx","./useBeforeUnload":"sVK9O","./useBoolean":"71wo7","./useClickAway":"7n130","./useCookie":"eqz8E","./useCopyToClipboard":"2S8XH","./useCounter":"epYoj","./useCss":"lD2DB","./useCustomCompareEffect":"2rnbE","./useDebounce":"4UiLA","./useDeepCompareEffect":"iH6vn","./useDefault":"36tH6","./useDrop":"5VUxV","./useDropArea":"2F1qy","./useEffectOnce":"3RRde","./useEnsuredForwardedRef":"3B0oR","./useEvent":"fMYXX","./useError":"ju4QR","./useFavicon":"2BAf3","./useFullscreen":"iQPkH","./useGeolocation":"d519i","./useGetSet":"4U5Xn","./useGetSetState":"jMdad","./useHarmonicIntervalFn":"j5UcT","./useHover":"fDXmM","./useHoverDirty":"F6Psq","./useIdle":"fjIjD","./useIntersection":"kkuJL","./useInterval":"argj2","./useIsomorphicLayoutEffect":"d3vAM","./useKey":"iI5LJ","./createBreakpoint":"5hQOl","./useKeyPress":"6OpsJ","./useKeyPressEvent":"2HC7p","./useLifecycles":"iPmF4","./useList":"hREI3","./useLocalStorage":"9hFML","./useLocation":"gw4pD","./useLockBodyScroll":"gXNQ9","./useLogger":"3ttCt","./useLongPress":"6ZdAD","./useMap":"i9kCA","./useMedia":"8YAyf","./useMediaDevices":"5tj1v","./useMediatedState":"5OVGX","./useMethods":"hppOH","./useMotion":"hRW18","./useMount":"4EVfq","./useMountedState":"8WCZ5","./useMouse":"4Yvyq","./useMouseHovered":"6pPBO","./useNetwork":"gPoEz","./useNumber":"6koEM","./useObservable":"5lWe1","./useOrientation":"f8sPX","./usePageLeave":"hR2Js","./usePermission":"9SxUl","./usePrevious":"751g7","./usePreviousDistinct":"ddCtn","./usePromise":"4ZafO","./useQueue":"mJEsF","./useRaf":"1z7RK","./useRafLoop":"f1xft","./useRafState":"k3hEp","./useSearchParam":"4uSvh","./useScratch":"3SLFB","./useScroll":"4HZqS","./useScrolling":"kV0Fj","./useSessionStorage":"21KMe","./useSetState":"5uBBR","./useShallowCompareEffect":"goOMR","./useSize":"3kbw0","./useSlider":"1uYT7","./useSpeech":"6l37s","./useStartTyping":"g4x4l","./useStateWithHistory":"14FFh","./useStateList":"55rWJ","./useThrottle":"hx80t","./useThrottleFn":"gAAPH","./useTimeout":"gH5FZ","./useTimeoutFn":"55Xtg","./useTitle":"eVfZQ","./useToggle":"aek0n","./useTween":"axPFO","./useUnmount":"7LKP4","./useUnmountPromise":"lWrWj","./useUpdate":"g3F6e","./useUpdateEffect":"f7d80","./useUpsert":"hHGXx","./useVibrate":"6I3c8","./useVideo":"4ls3w","./useStateValidator":"5hzbd","./useScrollbarWidth":"58M53","./useMultiStateValidator":"3bzGJ","./useWindowScroll":"3jkCa","./useWindowSize":"902mx","./useMeasure":"3kBMN","./useRendersCount":"audQz","./useFirstMountState":"6yQkq","./useSet":"59tH5","./createGlobalState":"gJozl","./useHash":"8IL23","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iDOyC":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var createMemo = function(fn) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return (0, _react.useMemo)(function() {
            return fn.apply(void 0, args);
        }, args);
    };
};
exports.default = createMemo;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4SdFH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var createReducerContext = function(reducer, defaultInitialState) {
    var context = (0, _react.createContext)(undefined);
    var providerFactory = (0, _react.createFactory)(context.Provider);
    var ReducerProvider = function(_a) {
        var children = _a.children, initialState = _a.initialState;
        var state = (0, _react.useReducer)(reducer, initialState !== undefined ? initialState : defaultInitialState);
        return providerFactory({
            value: state
        }, children);
    };
    var useReducerContext = function() {
        var state = (0, _react.useContext)(context);
        if (state == null) throw new Error("useReducerContext must be used inside a ReducerProvider.");
        return state;
    };
    return [
        useReducerContext,
        ReducerProvider,
        context
    ];
};
exports.default = createReducerContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"68R4d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useUpdateEffect = require("./useUpdateEffect");
var _useUpdateEffectDefault = parcelHelpers.interopDefault(_useUpdateEffect);
function composeMiddleware(chain) {
    return function(context, dispatch) {
        return chain.reduceRight(function(res, middleware) {
            return middleware(context)(res);
        }, dispatch);
    };
}
var createReducer = function() {
    var middlewares = [];
    for(var _i = 0; _i < arguments.length; _i++)middlewares[_i] = arguments[_i];
    var composedMiddleware = composeMiddleware(middlewares);
    return function(reducer, initialState, initializer) {
        if (initializer === void 0) initializer = function(value) {
            return value;
        };
        var ref = (0, _react.useRef)(initializer(initialState));
        var _a = (0, _react.useState)(ref.current), setState = _a[1];
        var dispatch = (0, _react.useCallback)(function(action) {
            ref.current = reducer(ref.current, action);
            setState(ref.current);
            return action;
        }, [
            reducer
        ]);
        var dispatchRef = (0, _react.useRef)(composedMiddleware({
            getState: function() {
                return ref.current;
            },
            dispatch: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                return dispatchRef.current.apply(dispatchRef, args);
            }
        }, dispatch));
        (0, _useUpdateEffectDefault.default)(function() {
            dispatchRef.current = composedMiddleware({
                getState: function() {
                    return ref.current;
                },
                dispatch: function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    return dispatchRef.current.apply(dispatchRef, args);
                }
            }, dispatch);
        }, [
            dispatch
        ]);
        return [
            ref.current,
            dispatchRef.current
        ];
    };
};
exports.default = createReducer;

},{"react":"9njXz","./useUpdateEffect":"f7d80","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f7d80":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useFirstMountState = require("./useFirstMountState");
var useUpdateEffect = function(effect, deps) {
    var isFirstMount = (0, _useFirstMountState.useFirstMountState)();
    (0, _react.useEffect)(function() {
        if (!isFirstMount) return effect();
    }, deps);
};
exports.default = useUpdateEffect;

},{"react":"9njXz","./useFirstMountState":"6yQkq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6yQkq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFirstMountState", ()=>useFirstMountState);
var _react = require("react");
function useFirstMountState() {
    var isFirst = (0, _react.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kiWTu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var createStateContext = function(defaultInitialValue) {
    var context = (0, _react.createContext)(undefined);
    var providerFactory = (0, _react.createFactory)(context.Provider);
    var StateProvider = function(_a) {
        var children = _a.children, initialValue = _a.initialValue;
        var state = (0, _react.useState)(initialValue !== undefined ? initialValue : defaultInitialValue);
        return providerFactory({
            value: state
        }, children);
    };
    var useStateContext = function() {
        var state = (0, _react.useContext)(context);
        if (state == null) throw new Error("useStateContext must be used inside a StateProvider.");
        return state;
    };
    return [
        useStateContext,
        StateProvider,
        context
    ];
};
exports.default = createStateContext;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i0u2A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAsync);
var _react = require("react");
var _useAsyncFn = require("./useAsyncFn");
var _useAsyncFnDefault = parcelHelpers.interopDefault(_useAsyncFn);
function useAsync(fn, deps) {
    if (deps === void 0) deps = [];
    var _a = (0, _useAsyncFnDefault.default)(fn, deps, {
        loading: true
    }), state = _a[0], callback = _a[1];
    (0, _react.useEffect)(function() {
        callback();
    }, [
        callback
    ]);
    return state;
}

},{"react":"9njXz","./useAsyncFn":"bcVdw","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bcVdw":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAsyncFn);
var _react = require("react");
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
function useAsyncFn(fn, deps, initialState) {
    if (deps === void 0) deps = [];
    if (initialState === void 0) initialState = {
        loading: false
    };
    var lastCallId = (0, _react.useRef)(0);
    var _a = (0, _react.useState)(initialState), state = _a[0], set = _a[1];
    var isMounted = (0, _useMountedStateDefault.default)();
    var callback = (0, _react.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var callId = ++lastCallId.current;
        set({
            loading: true
        });
        return fn.apply(void 0, args).then(function(value) {
            isMounted() && callId === lastCallId.current && set({
                value: value,
                loading: false
            });
            return value;
        }, function(error) {
            isMounted() && callId === lastCallId.current && set({
                error: error,
                loading: false
            });
            return error;
        });
    }, deps);
    return [
        state,
        callback
    ];
}

},{"react":"9njXz","./useMountedState":"8WCZ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8WCZ5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMountedState);
var _react = require("react");
function useMountedState() {
    var mountedRef = (0, _react.useRef)(false);
    var get = (0, _react.useCallback)(function() {
        return mountedRef.current;
    }, []);
    (0, _react.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    });
    return get;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9u9tN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var _useAsync = require("./useAsync");
var _useAsyncDefault = parcelHelpers.interopDefault(_useAsync);
var useAsyncRetry = function(fn, deps) {
    if (deps === void 0) deps = [];
    var _a = (0, _react.useState)(0), attempt = _a[0], setAttempt = _a[1];
    var state = (0, _useAsyncDefault.default)(fn, (0, _tslib.__spreadArrays)(deps, [
        attempt
    ]));
    var stateLoading = state.loading;
    var retry = (0, _react.useCallback)(function() {
        if (stateLoading) return;
        setAttempt(function(currentAttempt) {
            return currentAttempt + 1;
        });
    }, (0, _tslib.__spreadArrays)(deps, [
        stateLoading
    ]));
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
        retry: retry
    });
};
exports.default = useAsyncRetry;

},{"tslib":"b4wpY","react":"9njXz","./useAsync":"i0u2A","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b4wpY":[function(require,module,exports,__globalThis) {
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
parcelHelpers.export(exports, "__spread", ()=>__spread);
parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function __exportStar(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3tRhD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createHTMLMediaHook = require("./util/createHTMLMediaHook");
var _createHTMLMediaHookDefault = parcelHelpers.interopDefault(_createHTMLMediaHook);
var useAudio = (0, _createHTMLMediaHookDefault.default)('audio');
exports.default = useAudio;

},{"./util/createHTMLMediaHook":"kP2VX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kP2VX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var _useSetState = require("../useSetState");
var _useSetStateDefault = parcelHelpers.interopDefault(_useSetState);
var _parseTimeRanges = require("./parseTimeRanges");
var _parseTimeRangesDefault = parcelHelpers.interopDefault(_parseTimeRanges);
var createHTMLMediaHook = function(tag) {
    var hook = function(elOrProps) {
        var element;
        var props;
        if (_react.isValidElement(elOrProps)) {
            element = elOrProps;
            props = element.props;
        } else props = elOrProps;
        var _a = (0, _useSetStateDefault.default)({
            buffered: [],
            time: 0,
            duration: 0,
            paused: true,
            muted: false,
            volume: 1
        }), state = _a[0], setState = _a[1];
        var ref = (0, _react.useRef)(null);
        var wrapEvent = function(userEvent, proxyEvent) {
            return function(event) {
                try {
                    proxyEvent && proxyEvent(event);
                } finally{
                    userEvent && userEvent(event);
                }
            };
        };
        var onPlay = function() {
            return setState({
                paused: false
            });
        };
        var onPause = function() {
            return setState({
                paused: true
            });
        };
        var onVolumeChange = function() {
            var el = ref.current;
            if (!el) return;
            setState({
                muted: el.muted,
                volume: el.volume
            });
        };
        var onDurationChange = function() {
            var el = ref.current;
            if (!el) return;
            var duration = el.duration, buffered = el.buffered;
            setState({
                duration: duration,
                buffered: (0, _parseTimeRangesDefault.default)(buffered)
            });
        };
        var onTimeUpdate = function() {
            var el = ref.current;
            if (!el) return;
            setState({
                time: el.currentTime
            });
        };
        var onProgress = function() {
            var el = ref.current;
            if (!el) return;
            setState({
                buffered: (0, _parseTimeRangesDefault.default)(el.buffered)
            });
        };
        if (element) element = _react.cloneElement(element, (0, _tslib.__assign)((0, _tslib.__assign)({
            controls: false
        }, props), {
            ref: ref,
            onPlay: wrapEvent(props.onPlay, onPlay),
            onPause: wrapEvent(props.onPause, onPause),
            onVolumeChange: wrapEvent(props.onVolumeChange, onVolumeChange),
            onDurationChange: wrapEvent(props.onDurationChange, onDurationChange),
            onTimeUpdate: wrapEvent(props.onTimeUpdate, onTimeUpdate),
            onProgress: wrapEvent(props.onProgress, onProgress)
        }));
        else element = _react.createElement(tag, (0, _tslib.__assign)((0, _tslib.__assign)({
            controls: false
        }, props), {
            ref: ref,
            onPlay: wrapEvent(props.onPlay, onPlay),
            onPause: wrapEvent(props.onPause, onPause),
            onVolumeChange: wrapEvent(props.onVolumeChange, onVolumeChange),
            onDurationChange: wrapEvent(props.onDurationChange, onDurationChange),
            onTimeUpdate: wrapEvent(props.onTimeUpdate, onTimeUpdate),
            onProgress: wrapEvent(props.onProgress, onProgress)
        })); // TODO: fix this typing.
        // Some browsers return `Promise` on `.play()` and may throw errors
        // if one tries to execute another `.play()` or `.pause()` while that
        // promise is resolving. So we prevent that with this lock.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=593273
        var lockPlay = false;
        var controls = {
            play: function() {
                var el = ref.current;
                if (!el) return undefined;
                if (!lockPlay) {
                    var promise = el.play();
                    var isPromise = typeof promise === 'object';
                    if (isPromise) {
                        lockPlay = true;
                        var resetLock = function() {
                            lockPlay = false;
                        };
                        promise.then(resetLock, resetLock);
                    }
                    return promise;
                }
                return undefined;
            },
            pause: function() {
                var el = ref.current;
                if (el && !lockPlay) return el.pause();
            },
            seek: function(time) {
                var el = ref.current;
                if (!el || state.duration === undefined) return;
                time = Math.min(state.duration, Math.max(0, time));
                el.currentTime = time;
            },
            volume: function(volume) {
                var el = ref.current;
                if (!el) return;
                volume = Math.min(1, Math.max(0, volume));
                el.volume = volume;
                setState({
                    volume: volume
                });
            },
            mute: function() {
                var el = ref.current;
                if (!el) return;
                el.muted = true;
            },
            unmute: function() {
                var el = ref.current;
                if (!el) return;
                el.muted = false;
            }
        };
        (0, _react.useEffect)(function() {
            var el = ref.current;
            if (!el) return;
            setState({
                volume: el.volume,
                muted: el.muted,
                paused: el.paused
            });
            // Start media, if autoPlay requested.
            if (props.autoPlay && el.paused) controls.play();
        }, [
            props.src
        ]);
        return [
            element,
            state,
            controls,
            ref
        ];
    };
    return hook;
};
exports.default = createHTMLMediaHook;

},{"tslib":"b4wpY","react":"9njXz","../useSetState":"5uBBR","./parseTimeRanges":"lOtaQ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5uBBR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = (0, _react.useState)(initialState), state = _a[0], set = _a[1];
    var setState = (0, _react.useCallback)(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, [
        set
    ]);
    return [
        state,
        setState
    ];
};
exports.default = useSetState;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lOtaQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var parseTimeRanges = function(ranges) {
    var result = [];
    for(var i = 0; i < ranges.length; i++)result.push({
        start: ranges.start(i),
        end: ranges.end(i)
    });
    return result;
};
exports.default = parseTimeRanges;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2V2Cx":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var useState = _react.useState, useEffect = _react.useEffect;
var nav = typeof navigator === 'object' ? navigator : undefined;
var isBatteryApiSupported = nav && typeof nav.getBattery === 'function';
function useBatteryMock() {
    return {
        isSupported: false
    };
}
function useBattery() {
    var _a = useState({
        isSupported: true,
        fetched: false
    }), state = _a[0], setState = _a[1];
    useEffect(function() {
        var isMounted = true;
        var battery = null;
        var handleChange = function() {
            if (!isMounted || !battery) return;
            var newState = {
                isSupported: true,
                fetched: true,
                level: battery.level,
                charging: battery.charging,
                dischargingTime: battery.dischargingTime,
                chargingTime: battery.chargingTime
            };
            !(0, _util.isDeepEqual)(state, newState) && setState(newState);
        };
        nav.getBattery().then(function(bat) {
            if (!isMounted) return;
            battery = bat;
            (0, _util.on)(battery, 'chargingchange', handleChange);
            (0, _util.on)(battery, 'chargingtimechange', handleChange);
            (0, _util.on)(battery, 'dischargingtimechange', handleChange);
            (0, _util.on)(battery, 'levelchange', handleChange);
            handleChange();
        });
        return function() {
            isMounted = false;
            if (battery) {
                (0, _util.off)(battery, 'chargingchange', handleChange);
                (0, _util.off)(battery, 'chargingtimechange', handleChange);
                (0, _util.off)(battery, 'dischargingtimechange', handleChange);
                (0, _util.off)(battery, 'levelchange', handleChange);
            }
        };
    }, []);
    return state;
}
exports.default = isBatteryApiSupported ? useBattery : useBatteryMock;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hB491":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isClient", ()=>isClient);
parcelHelpers.export(exports, "on", ()=>on);
parcelHelpers.export(exports, "off", ()=>off);
parcelHelpers.export(exports, "isDeepEqual", ()=>isDeepEqual);
var isClient = typeof window === 'object';
var on = function(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return obj.addEventListener.apply(obj, args);
};
var off = function(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return obj.removeEventListener.apply(obj, args);
};
var isDeepEqual = require("5a532cba4a9ace8f");

},{"5a532cba4a9ace8f":"ahnuv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ahnuv":[function(require,module,exports,__globalThis) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

},{}],"sVK9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useBeforeUnload = function(enabled, message) {
    if (enabled === void 0) enabled = true;
    var handler = (0, _react.useCallback)(function(event) {
        var finalEnabled = typeof enabled === 'function' ? enabled() : true;
        if (!finalEnabled) return;
        event.preventDefault();
        if (message) event.returnValue = message;
        return message;
    }, [
        enabled,
        message
    ]);
    (0, _react.useEffect)(function() {
        if (!enabled) return;
        window.addEventListener('beforeunload', handler);
        return function() {
            return window.removeEventListener('beforeunload', handler);
        };
    }, [
        enabled,
        handler
    ]);
};
exports.default = useBeforeUnload;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"71wo7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useToggle = require("./useToggle");
var _useToggleDefault = parcelHelpers.interopDefault(_useToggle);
exports.default = (0, _useToggleDefault.default);

},{"./useToggle":"aek0n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aek0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var toggleReducer = function(state, nextValue) {
    return typeof nextValue === 'boolean' ? nextValue : !state;
};
var useToggle = function(initialValue) {
    return (0, _react.useReducer)(toggleReducer, initialValue);
};
exports.default = useToggle;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7n130":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var defaultEvents = [
    'mousedown',
    'touchstart'
];
var useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = defaultEvents;
    var savedCallback = (0, _react.useRef)(onClickAway);
    (0, _react.useEffect)(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    (0, _react.useEffect)(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            (0, _util.on)(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                (0, _util.off)(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
exports.default = useClickAway;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eqz8E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _jsCookie = require("js-cookie");
var _jsCookieDefault = parcelHelpers.interopDefault(_jsCookie);
var useCookie = function(cookieName) {
    var _a = (0, _react.useState)(function() {
        return (0, _jsCookieDefault.default).get(cookieName) || null;
    }), value = _a[0], setValue = _a[1];
    var updateCookie = (0, _react.useCallback)(function(newValue, options) {
        (0, _jsCookieDefault.default).set(cookieName, newValue, options);
        setValue(newValue);
    }, [
        cookieName
    ]);
    var deleteCookie = (0, _react.useCallback)(function() {
        (0, _jsCookieDefault.default).remove(cookieName);
        setValue(null);
    }, [
        cookieName
    ]);
    return [
        value,
        updateCookie,
        deleteCookie
    ];
};
exports.default = useCookie;

},{"react":"9njXz","js-cookie":"2d7Fe","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2d7Fe":[function(require,module,exports,__globalThis) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

},{}],"2S8XH":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _copyToClipboard = require("copy-to-clipboard");
var _copyToClipboardDefault = parcelHelpers.interopDefault(_copyToClipboard);
var _react = require("react");
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
var _useSetState = require("./useSetState");
var _useSetStateDefault = parcelHelpers.interopDefault(_useSetState);
var useCopyToClipboard = function() {
    var isMounted = (0, _useMountedStateDefault.default)();
    var _a = (0, _useSetStateDefault.default)({
        value: undefined,
        error: undefined,
        noUserInteraction: true
    }), state = _a[0], setState = _a[1];
    var copyToClipboard = (0, _react.useCallback)(function(value) {
        try {
            var noUserInteraction = (0, _copyToClipboardDefault.default)(value);
            if (!isMounted()) return;
            setState({
                value: value,
                error: undefined,
                noUserInteraction: noUserInteraction
            });
        } catch (error) {
            if (!isMounted()) return;
            setState({
                value: undefined,
                error: error,
                noUserInteraction: true
            });
        }
    }, []);
    return [
        state,
        copyToClipboard
    ];
};
exports.default = useCopyToClipboard;

},{"copy-to-clipboard":"3Hriz","react":"9njXz","./useMountedState":"8WCZ5","./useSetState":"5uBBR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3Hriz":[function(require,module,exports,__globalThis) {
"use strict";
var deselectCurrent = require("b270149f26797c52");
var clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = deselectCurrent();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = format("message" in options ? options.message : defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = copy;

},{"b270149f26797c52":"deXU4"}],"deXU4":[function(require,module,exports,__globalThis) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

},{}],"epYoj":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCounter);
var _react = require("react");
var _useGetSet = require("./useGetSet");
var _useGetSetDefault = parcelHelpers.interopDefault(_useGetSet);
var _resolveHookState = require("./util/resolveHookState");
function useCounter(initialValue, max, min) {
    if (initialValue === void 0) initialValue = 0;
    if (max === void 0) max = null;
    if (min === void 0) min = null;
    var init = (0, _resolveHookState.resolveHookState)(initialValue);
    typeof init !== 'number' && console.error('initialValue has to be a number, got ' + typeof initialValue);
    if (typeof min === 'number') init = Math.max(init, min);
    else if (min !== null) console.error('min has to be a number, got ' + typeof min);
    if (typeof max === 'number') init = Math.min(init, max);
    else if (max !== null) console.error('max has to be a number, got ' + typeof max);
    var _a = (0, _useGetSetDefault.default)(init), get = _a[0], setInternal = _a[1];
    return [
        get(),
        (0, _react.useMemo)(function() {
            var set = function(newState) {
                var prevState = get();
                var rState = (0, _resolveHookState.resolveHookState)(newState, prevState);
                if (prevState !== rState) {
                    if (typeof min === 'number') rState = Math.max(rState, min);
                    if (typeof max === 'number') rState = Math.min(rState, max);
                    prevState !== rState && setInternal(rState);
                }
            };
            return {
                get: get,
                set: set,
                inc: function(delta) {
                    if (delta === void 0) delta = 1;
                    var rDelta = (0, _resolveHookState.resolveHookState)(delta, get());
                    if (typeof rDelta !== 'number') console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    set(function(num) {
                        return num + rDelta;
                    });
                },
                dec: function(delta) {
                    if (delta === void 0) delta = 1;
                    var rDelta = (0, _resolveHookState.resolveHookState)(delta, get());
                    if (typeof rDelta !== 'number') console.error('delta has to be a number or function returning a number, got ' + typeof rDelta);
                    set(function(num) {
                        return num - rDelta;
                    });
                },
                reset: function(value) {
                    if (value === void 0) value = init;
                    var rValue = (0, _resolveHookState.resolveHookState)(value, get());
                    if (typeof rValue !== 'number') console.error('value has to be a number or function returning a number, got ' + typeof rValue);
                    init = rValue;
                    set(rValue);
                }
            };
        }, [
            init,
            min,
            max
        ])
    ];
}

},{"react":"9njXz","./useGetSet":"4U5Xn","./util/resolveHookState":"mTVHM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4U5Xn":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGetSet);
var _react = require("react");
var _useUpdate = require("./useUpdate");
var _useUpdateDefault = parcelHelpers.interopDefault(_useUpdate);
var _resolveHookState = require("./util/resolveHookState");
function useGetSet(initialState) {
    var state = (0, _react.useRef)((0, _resolveHookState.resolveHookState)(initialState));
    var update = (0, _useUpdateDefault.default)();
    return (0, _react.useMemo)(function() {
        return [
            // get
            function() {
                return state.current;
            },
            // set
            function(newState) {
                state.current = (0, _resolveHookState.resolveHookState)(newState, state.current);
                update();
            }
        ];
    }, []);
}

},{"react":"9njXz","./useUpdate":"g3F6e","./util/resolveHookState":"mTVHM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g3F6e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var incrementParameter = function(num) {
    return ++num % 1000000;
};
var useUpdate = function() {
    var _a = (0, _react.useState)(0), setState = _a[1];
    // useCallback with empty deps as we only want to define updateCb once
    return (0, _react.useCallback)(function() {
        return setState(incrementParameter);
    }, []);
};
exports.default = useUpdate;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"mTVHM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveHookState", ()=>resolveHookState);
function resolveHookState(newState, currentState) {
    if (typeof newState === 'function') return newState(currentState);
    return newState;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lD2DB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nanoCss = require("nano-css");
var _cssom = require("nano-css/addon/cssom");
var _vcssom = require("nano-css/addon/vcssom");
var _cssToTree = require("nano-css/addon/vcssom/cssToTree");
var _react = require("react");
var nano = (0, _nanoCss.create)();
(0, _cssom.addon)(nano);
(0, _vcssom.addon)(nano);
var counter = 0;
var useCss = function(css) {
    var className = (0, _react.useMemo)(function() {
        return 'react-use-css-' + (counter++).toString(36);
    }, []);
    var sheet = (0, _react.useMemo)(function() {
        return new nano.VSheet();
    }, []);
    (0, _react.useLayoutEffect)(function() {
        var tree = {};
        (0, _cssToTree.cssToTree)(tree, css, '.' + className, '');
        sheet.diff(tree);
        return function() {
            sheet.diff({});
        };
    });
    return className;
};
exports.default = useCss;

},{"nano-css":"aYLha","nano-css/addon/cssom":"7JHKp","nano-css/addon/vcssom":"6k9mo","nano-css/addon/vcssom/cssToTree":"8xjUU","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aYLha":[function(require,module,exports,__globalThis) {
'use strict';
var KEBAB_REGEX = /[A-Z]/g;
var hash = function(str) {
    var h = 5381, i = str.length;
    while(i)h = h * 33 ^ str.charCodeAt(--i);
    return '_' + (h >>> 0).toString(36);
};
exports.create = function(config) {
    config = config || {};
    var assign = config.assign || Object.assign;
    var client = typeof window === 'object';
    var renderer = assign({
        raw: '',
        pfx: '_',
        client: client,
        assign: assign,
        stringify: JSON.stringify,
        kebab: function(prop) {
            return prop.replace(KEBAB_REGEX, '-$&').toLowerCase();
        },
        decl: function(key, value) {
            key = renderer.kebab(key);
            return key + ':' + value + ';';
        },
        hash: function(obj) {
            return hash(renderer.stringify(obj));
        },
        selector: function(parent, selector) {
            return parent + (selector[0] === ':' ? '' : ' ') + selector;
        },
        putRaw: function(rawCssRule) {
            renderer.raw += rawCssRule;
        }
    }, config);
    if (renderer.client) {
        if (!renderer.sh) document.head.appendChild(renderer.sh = document.createElement('style'));
        renderer.putRaw = function(rawCssRule) {
            var error;
            var sheet = renderer.sh.sheet;
            // Unknown pseudo-selectors will throw, this try/catch swallows all errors.
            try {
                sheet.insertRule(rawCssRule, sheet.cssRules.length);
            // eslint-disable-next-line no-empty
            } catch (error) {}
        };
    }
    renderer.put = function(selector, decls, atrule) {
        var str = '';
        var prop, value;
        var postponed = [];
        for(prop in decls){
            value = decls[prop];
            if (value instanceof Object && !(value instanceof Array)) postponed.push(prop);
            else str += renderer.decl(prop, value, selector, atrule);
        }
        if (str) {
            str = selector + '{' + str + '}';
            renderer.putRaw(atrule ? atrule + '{' + str + '}' : str);
        }
        for(var i = 0; i < postponed.length; i++){
            prop = postponed[i];
            if (prop[0] === '@' && prop !== '@font-face') renderer.putAt(selector, decls[prop], prop);
            else renderer.put(renderer.selector(selector, prop), decls[prop], atrule);
        }
    };
    renderer.putAt = renderer.put;
    return renderer;
};

},{}],"7JHKp":[function(require,module,exports,__globalThis) {
'use strict';
exports.addon = function(renderer) {
    // CSSOM support only browser environment.
    if (!renderer.client) return;
    // Style sheet for media queries.
    document.head.appendChild(renderer.msh = document.createElement('style'));
    renderer.createRule = function(selector, prelude) {
        var rawCss = selector + '{}';
        if (prelude) rawCss = prelude + '{' + rawCss + '}';
        var sheet = prelude ? renderer.msh.sheet : renderer.sh.sheet;
        var index = sheet.insertRule(rawCss, sheet.cssRules.length);
        var rule = (sheet.cssRules || sheet.rules)[index];
        // Keep track of `index` where rule was inserted in the sheet. This is
        // needed for rule deletion.
        rule.index = index;
        if (prelude) {
            // If rule has media query (it has prelude), move style (CSSStyleDeclaration)
            // object to the "top" to normalize it with a rule without the media
            // query, so that both rules have `.style` property available.
            var selectorRule = (rule.cssRules || rule.rules)[0];
            rule.style = selectorRule.style;
            rule.styleMap = selectorRule.styleMap;
        }
        return rule;
    };
};

},{}],"6k9mo":[function(require,module,exports,__globalThis) {
'use strict';
var removeRule = require("da090edb03fa814").removeRule;
exports.addon = function(renderer) {
    // VCSSOM support only browser environment.
    if (!renderer.client) return;
    var kebab = renderer.kebab;
    function VRule(selector, prelude) {
        this.rule = renderer.createRule(selector, prelude);
        this.decl = {};
    }
    VRule.prototype.diff = function(newDecl) {
        var oldDecl = this.decl;
        var style = this.rule.style;
        var property;
        for(property in oldDecl)if (newDecl[property] === undefined) style.removeProperty(property);
        for(property in newDecl)if (newDecl[property] !== oldDecl[property]) style.setProperty(kebab(property), newDecl[property]);
        this.decl = newDecl;
    };
    VRule.prototype.del = function() {
        removeRule(this.rule);
    };
    function VSheet() {
        /**
         * {
         *   '<at-rule-prelude>': {
         *     '<selector>': {
         *       color: 'red
         *     }
         *   }
         * }
         */ this.tree = {};
    }
    VSheet.prototype.diff = function(newTree) {
        var oldTree = this.tree;
        // Remove media queries not present in new tree.
        for(var prelude in oldTree)if (newTree[prelude] === undefined) {
            var rules = oldTree[prelude];
            for(var selector in rules)rules[selector].del();
        }
        for(var prelude in newTree){
            if (oldTree[prelude] === undefined) // Whole media query is new.
            for(var selector in newTree[prelude]){
                var rule = new VRule(selector, prelude);
                rule.diff(newTree[prelude][selector]);
                newTree[prelude][selector] = rule;
            }
            else {
                // Old tree already has rules with this media query.
                var oldRules = oldTree[prelude];
                var newRules = newTree[prelude];
                // Remove rules not present in new tree.
                for(var selector in oldRules)if (!newRules[selector]) oldRules[selector].del();
                // Apply new rules.
                for(var selector in newRules){
                    var rule = oldRules[selector];
                    if (rule) {
                        rule.diff(newRules[selector]);
                        newRules[selector] = rule;
                    } else {
                        rule = new VRule(selector, prelude);
                        rule.diff(newRules[selector]);
                        newRules[selector] = rule;
                    }
                }
            }
        }
        this.tree = newTree;
    };
    renderer.VRule = VRule;
    renderer.VSheet = VSheet;
};

},{"da090edb03fa814":"l1zHr"}],"l1zHr":[function(require,module,exports,__globalThis) {
function removeRule(rule) {
    var maxIndex = rule.index;
    var sh = rule.parentStyleSheet;
    var rules = sh.cssRules || sh.rules;
    maxIndex = Math.max(maxIndex, rules.length - 1);
    while(maxIndex >= 0){
        if (rules[maxIndex] === rule) {
            sh.deleteRule(maxIndex);
            break;
        }
        maxIndex--;
    }
}
exports.removeRule = removeRule;

},{}],"8xjUU":[function(require,module,exports,__globalThis) {
function cssToTree(tree, css, selector, prelude) {
    var declarations = {};
    var hasDeclarations = false;
    var key, value;
    for(key in css){
        value = css[key];
        if (typeof value !== 'object') {
            hasDeclarations = true;
            declarations[key] = value;
        }
    }
    if (hasDeclarations) {
        if (!tree[prelude]) tree[prelude] = {};
        tree[prelude][selector] = declarations;
    }
    for(key in css){
        value = css[key];
        if (typeof value === 'object') {
            if (key[0] === '@') cssToTree(tree, value, selector, key);
            else {
                var hasCurrentSymbol = key.indexOf('&') > -1;
                var selectorParts = selector.split(',');
                if (hasCurrentSymbol) for(var i = 0; i < selectorParts.length; i++)selectorParts[i] = key.replace(/&/g, selectorParts[i]);
                else for(var i = 0; i < selectorParts.length; i++)selectorParts[i] = selectorParts[i] + ' ' + key;
                cssToTree(tree, value, selectorParts.join(','), prelude);
            }
        }
    }
}
exports.cssToTree = cssToTree;

},{}],"2rnbE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var isPrimitive = function(val) {
    return val !== Object(val);
};
var useCustomCompareEffect = function(effect, deps, depsEqual) {
    var ref = (0, _react.useRef)(undefined);
    if (!ref.current || !depsEqual(deps, ref.current)) ref.current = deps;
    (0, _react.useEffect)(effect, ref.current);
};
exports.default = useCustomCompareEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4UiLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDebounce);
var _react = require("react");
var _useTimeoutFn = require("./useTimeoutFn");
var _useTimeoutFnDefault = parcelHelpers.interopDefault(_useTimeoutFn);
function useDebounce(fn, ms, deps) {
    if (ms === void 0) ms = 0;
    if (deps === void 0) deps = [];
    var _a = (0, _useTimeoutFnDefault.default)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0, _react.useEffect)(reset, deps);
    return [
        isReady,
        cancel
    ];
}

},{"react":"9njXz","./useTimeoutFn":"55Xtg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"55Xtg":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTimeoutFn);
var _react = require("react");
function useTimeoutFn(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = (0, _react.useRef)(false);
    var timeout = (0, _react.useRef)();
    var callback = (0, _react.useRef)(fn);
    var isReady = (0, _react.useCallback)(function() {
        return ready.current;
    }, []);
    var set = (0, _react.useCallback)(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = (0, _react.useCallback)(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0, _react.useEffect)(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    (0, _react.useEffect)(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iH6vn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("./util");
var _useCustomCompareEffect = require("./useCustomCompareEffect");
var _useCustomCompareEffectDefault = parcelHelpers.interopDefault(_useCustomCompareEffect);
var isPrimitive = function(val) {
    return val !== Object(val);
};
var useDeepCompareEffect = function(effect, deps) {
    (0, _useCustomCompareEffectDefault.default)(effect, deps, (0, _util.isDeepEqual));
};
exports.default = useDeepCompareEffect;

},{"./util":"hB491","./useCustomCompareEffect":"2rnbE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"36tH6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useDefault = function(defaultValue, initialValue) {
    var _a = (0, _react.useState)(initialValue), value = _a[0], setValue = _a[1];
    if (value === undefined || value === null) return [
        defaultValue,
        setValue
    ];
    return [
        value,
        setValue
    ];
};
exports.default = useDefault;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5VUxV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
var useState = _react.useState, useMemo = _react.useMemo, useCallback = _react.useCallback, useEffect = _react.useEffect;
var noop = function() {};
/*
const defaultState: DropAreaState = {
  over: false,
};
*/ var createProcess = function(options, mounted) {
    return function(dataTransfer, event) {
        var uri = dataTransfer.getData('text/uri-list');
        if (uri) {
            (options.onUri || noop)(uri, event);
            return;
        }
        if (dataTransfer.files && dataTransfer.files.length) {
            (options.onFiles || noop)(Array.from(dataTransfer.files), event);
            return;
        }
        if (dataTransfer.items && dataTransfer.items.length) dataTransfer.items[0].getAsString(function(text) {
            if (mounted) (options.onText || noop)(text, event);
        });
    };
};
var useDrop = function(options, args) {
    if (options === void 0) options = {};
    if (args === void 0) args = [];
    var onFiles = options.onFiles, onText = options.onText, onUri = options.onUri;
    var isMounted = (0, _useMountedStateDefault.default)();
    var _a = useState(false), over = _a[0], setOverRaw = _a[1];
    var setOver = useCallback(setOverRaw, []);
    var process = useMemo(function() {
        return createProcess(options, isMounted());
    }, [
        onFiles,
        onText,
        onUri
    ]);
    useEffect(function() {
        var onDragOver = function(event) {
            event.preventDefault();
            setOver(true);
        };
        var onDragEnter = function(event) {
            event.preventDefault();
            setOver(true);
        };
        var onDragLeave = function() {
            setOver(false);
        };
        var onDragExit = function() {
            setOver(false);
        };
        var onDrop = function(event) {
            event.preventDefault();
            setOver(false);
            process(event.dataTransfer, event);
        };
        var onPaste = function(event) {
            process(event.clipboardData, event);
        };
        document.addEventListener('dragover', onDragOver);
        document.addEventListener('dragenter', onDragEnter);
        document.addEventListener('dragleave', onDragLeave);
        document.addEventListener('dragexit', onDragExit);
        document.addEventListener('drop', onDrop);
        if (onText) document.addEventListener('paste', onPaste);
        return function() {
            document.removeEventListener('dragover', onDragOver);
            document.removeEventListener('dragenter', onDragEnter);
            document.removeEventListener('dragleave', onDragLeave);
            document.removeEventListener('dragexit', onDragExit);
            document.removeEventListener('drop', onDrop);
            document.removeEventListener('paste', onPaste);
        };
    }, (0, _tslib.__spreadArrays)([
        process
    ], args));
    return {
        over: over
    };
};
exports.default = useDrop;

},{"tslib":"b4wpY","react":"9njXz","./useMountedState":"8WCZ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2F1qy":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
var noop = function() {};
/*
const defaultState: DropAreaState = {
  over: false,
};
*/ var createProcess = function(options, mounted) {
    return function(dataTransfer, event) {
        var uri = dataTransfer.getData('text/uri-list');
        if (uri) {
            (options.onUri || noop)(uri, event);
            return;
        }
        if (dataTransfer.files && dataTransfer.files.length) {
            (options.onFiles || noop)(Array.from(dataTransfer.files), event);
            return;
        }
        if (dataTransfer.items && dataTransfer.items.length) dataTransfer.items[0].getAsString(function(text) {
            if (mounted) (options.onText || noop)(text, event);
        });
    };
};
var createBond = function(process, setOver) {
    return {
        onDragOver: function(event) {
            event.preventDefault();
        },
        onDragEnter: function(event) {
            event.preventDefault();
            setOver(true);
        },
        onDragLeave: function() {
            setOver(false);
        },
        onDrop: function(event) {
            event.preventDefault();
            event.persist();
            setOver(false);
            process(event.dataTransfer, event);
        },
        onPaste: function(event) {
            event.persist();
            process(event.clipboardData, event);
        }
    };
};
var useDropArea = function(options) {
    if (options === void 0) options = {};
    var onFiles = options.onFiles, onText = options.onText, onUri = options.onUri;
    var isMounted = (0, _useMountedStateDefault.default)();
    var _a = (0, _react.useState)(false), over = _a[0], setOver = _a[1];
    var process = (0, _react.useMemo)(function() {
        return createProcess(options, isMounted());
    }, [
        onFiles,
        onText,
        onUri
    ]);
    var bond = (0, _react.useMemo)(function() {
        return createBond(process, setOver);
    }, [
        process,
        setOver
    ]);
    return [
        bond,
        {
            over: over
        }
    ];
};
exports.default = useDropArea;

},{"react":"9njXz","./useMountedState":"8WCZ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3RRde":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useEffectOnce = function(effect) {
    (0, _react.useEffect)(effect, []);
};
exports.default = useEffectOnce;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3B0oR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useEnsuredForwardedRef);
parcelHelpers.export(exports, "ensuredForwardRef", ()=>ensuredForwardRef);
var _react = require("react");
function useEnsuredForwardedRef(forwardedRef) {
    var ensuredRef = (0, _react.useRef)(forwardedRef && forwardedRef.current);
    (0, _react.useEffect)(function() {
        if (!forwardedRef) return;
        forwardedRef.current = ensuredRef.current;
    }, [
        forwardedRef
    ]);
    return ensuredRef;
}
function ensuredForwardRef(Component) {
    return (0, _react.forwardRef)(function(props, ref) {
        var ensuredRef = useEnsuredForwardedRef(ref);
        return Component(props, ensuredRef);
    });
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMYXX":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var defaultTarget = (0, _util.isClient) ? window : null;
var isListenerType1 = function(target) {
    return !!target.addEventListener;
};
var isListenerType2 = function(target) {
    return !!target.on;
};
var useEvent = function(name, handler, target, options) {
    if (target === void 0) target = defaultTarget;
    (0, _react.useEffect)(function() {
        if (!handler) return;
        if (!target) return;
        if (isListenerType1(target)) target.addEventListener(name, handler, options);
        else if (isListenerType2(target)) target.on(name, handler, options);
        return function() {
            if (isListenerType1(target)) target.removeEventListener(name, handler, options);
            else if (isListenerType2(target)) target.off(name, handler, options);
        };
    }, [
        name,
        handler,
        target,
        JSON.stringify(options)
    ]);
};
exports.default = useEvent;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ju4QR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useError = function() {
    var _a = (0, _react.useState)(null), error = _a[0], setError = _a[1];
    (0, _react.useEffect)(function() {
        if (error) throw error;
    }, [
        error
    ]);
    var dispatchError = (0, _react.useCallback)(function(err) {
        setError(err);
    }, []);
    return dispatchError;
};
exports.default = useError;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2BAf3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useFavicon = function(href) {
    (0, _react.useEffect)(function() {
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = href;
        document.getElementsByTagName('head')[0].appendChild(link);
    }, [
        href
    ]);
};
exports.default = useFavicon;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQPkH":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _screenfull = require("screenfull");
var _screenfullDefault = parcelHelpers.interopDefault(_screenfull);
var noop = function() {};
var useFullscreen = function(ref, on, options) {
    if (options === void 0) options = {};
    var video = options.video, _a = options.onClose, onClose = _a === void 0 ? noop : _a;
    var _b = (0, _react.useState)(on), isFullscreen = _b[0], setIsFullscreen = _b[1];
    (0, _react.useLayoutEffect)(function() {
        if (!on) return;
        if (!ref.current) return;
        var onWebkitEndFullscreen = function() {
            video.current.removeEventListener('webkitendfullscreen', onWebkitEndFullscreen);
            onClose();
        };
        var onChange = function() {
            if ((0, _screenfullDefault.default).isEnabled) {
                var isScreenfullFullscreen = (0, _screenfullDefault.default).isFullscreen;
                setIsFullscreen(isScreenfullFullscreen);
                if (!isScreenfullFullscreen) onClose();
            }
        };
        if ((0, _screenfullDefault.default).isEnabled) {
            try {
                (0, _screenfullDefault.default).request(ref.current);
                setIsFullscreen(true);
            } catch (error) {
                onClose(error);
                setIsFullscreen(false);
            }
            (0, _screenfullDefault.default).on('change', onChange);
        } else if (video && video.current && video.current.webkitEnterFullscreen) {
            video.current.webkitEnterFullscreen();
            video.current.addEventListener('webkitendfullscreen', onWebkitEndFullscreen);
            setIsFullscreen(true);
        } else {
            onClose();
            setIsFullscreen(false);
        }
        return function() {
            setIsFullscreen(false);
            if ((0, _screenfullDefault.default).isEnabled) try {
                (0, _screenfullDefault.default).off('change', onChange);
                (0, _screenfullDefault.default).exit();
            } catch (_a) {}
            else if (video && video.current && video.current.webkitExitFullscreen) {
                video.current.removeEventListener('webkitendfullscreen', onWebkitEndFullscreen);
                video.current.webkitExitFullscreen();
            }
        };
    }, [
        on,
        video,
        ref
    ]);
    return isFullscreen;
};
exports.default = useFullscreen;

},{"react":"9njXz","screenfull":"hYCxs","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hYCxs":[function(require,module,exports,__globalThis) {
/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/ (function() {
    'use strict';
    var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
    var isCommonjs = (0, module.exports);
    var fn = function() {
        var val;
        var fnMap = [
            [
                'requestFullscreen',
                'exitFullscreen',
                'fullscreenElement',
                'fullscreenEnabled',
                'fullscreenchange',
                'fullscreenerror'
            ],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            [
                'msRequestFullscreen',
                'msExitFullscreen',
                'msFullscreenElement',
                'msFullscreenEnabled',
                'MSFullscreenChange',
                'MSFullscreenError'
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        change: fn.fullscreenchange,
        error: fn.fullscreenerror
    };
    var screenfull = {
        request: function(element, options) {
            return new Promise((function(resolve, reject) {
                var onFullScreenEntered = (function() {
                    this.off('change', onFullScreenEntered);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen](options);
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            }).bind(this));
        },
        exit: function() {
            return new Promise((function(resolve, reject) {
                if (!this.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = (function() {
                    this.off('change', onFullScreenExit);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            }).bind(this));
        },
        toggle: function(element, options) {
            return this.isFullscreen ? this.exit() : this.request(element, options);
        },
        onchange: function(callback) {
            this.on('change', callback);
        },
        onerror: function(callback) {
            this.on('error', callback);
        },
        on: function(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback, false);
        },
        off: function(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback, false);
        },
        raw: fn
    };
    if (!fn) {
        if (isCommonjs) module.exports = {
            isEnabled: false
        };
        else window.screenfull = {
            isEnabled: false
        };
        return;
    }
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    if (isCommonjs) module.exports = screenfull;
    else window.screenfull = screenfull;
})();

},{}],"d519i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var useGeolocation = function(options) {
    var _a = (0, _react.useState)({
        loading: true,
        accuracy: null,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        latitude: null,
        longitude: null,
        speed: null,
        timestamp: Date.now()
    }), state = _a[0], setState = _a[1];
    var mounted = true;
    var watchId;
    var onEvent = function(event) {
        if (mounted) setState({
            loading: false,
            accuracy: event.coords.accuracy,
            altitude: event.coords.altitude,
            altitudeAccuracy: event.coords.altitudeAccuracy,
            heading: event.coords.heading,
            latitude: event.coords.latitude,
            longitude: event.coords.longitude,
            speed: event.coords.speed,
            timestamp: event.timestamp
        });
    };
    var onEventError = function(error) {
        return mounted && setState(function(oldState) {
            return (0, _tslib.__assign)((0, _tslib.__assign)({}, oldState), {
                loading: false,
                error: error
            });
        });
    };
    (0, _react.useEffect)(function() {
        navigator.geolocation.getCurrentPosition(onEvent, onEventError, options);
        watchId = navigator.geolocation.watchPosition(onEvent, onEventError, options);
        return function() {
            mounted = false;
            navigator.geolocation.clearWatch(watchId);
        };
    }, []);
    return state;
};
exports.default = useGeolocation;

},{"tslib":"b4wpY","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jMdad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var _useUpdate = require("./useUpdate");
var _useUpdateDefault = parcelHelpers.interopDefault(_useUpdate);
var useGetSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var update = (0, _useUpdateDefault.default)();
    var state = (0, _react.useRef)((0, _tslib.__assign)({}, initialState));
    var get = (0, _react.useCallback)(function() {
        return state.current;
    }, []);
    var set = (0, _react.useCallback)(function(patch) {
        if (!patch) return;
        Object.assign(state.current, patch);
        update();
    }, []);
    return [
        get,
        set
    ];
};
exports.default = useGetSetState;

},{"tslib":"b4wpY","react":"9njXz","./useUpdate":"g3F6e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j5UcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _setHarmonicInterval = require("set-harmonic-interval");
var useHarmonicIntervalFn = function(fn, delay) {
    if (delay === void 0) delay = 0;
    var latestCallback = (0, _react.useRef)(function() {});
    (0, _react.useEffect)(function() {
        latestCallback.current = fn;
    });
    (0, _react.useEffect)(function() {
        if (delay !== null) {
            var interval_1 = (0, _setHarmonicInterval.setHarmonicInterval)(function() {
                return latestCallback.current();
            }, delay);
            return function() {
                return (0, _setHarmonicInterval.clearHarmonicInterval)(interval_1);
            };
        }
        return undefined;
    }, [
        delay
    ]);
};
exports.default = useHarmonicIntervalFn;

},{"react":"9njXz","set-harmonic-interval":"gxt0q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gxt0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearHarmonicInterval", ()=>clearHarmonicInterval);
parcelHelpers.export(exports, "setHarmonicInterval", ()=>setHarmonicInterval);
var counter = 0;
var buckets = {};
var setHarmonicInterval = function(fn, ms) {
    var _a;
    var id = counter++;
    if (buckets[ms]) buckets[ms].listeners[id] = fn;
    else {
        var timer = setInterval(function() {
            var listeners = buckets[ms].listeners;
            var didThrow = false;
            var lastError;
            for(var _i = 0, _a = Object.values(listeners); _i < _a.length; _i++){
                var listener = _a[_i];
                try {
                    listener();
                } catch (error) {
                    didThrow = true;
                    lastError = error;
                }
            }
            if (didThrow) throw lastError;
        }, ms);
        buckets[ms] = {
            ms: ms,
            timer: timer,
            listeners: (_a = {}, _a[id] = fn, _a)
        };
    }
    return {
        bucket: buckets[ms],
        id: id
    };
};
var clearHarmonicInterval = function(_a) {
    var bucket = _a.bucket, id = _a.id;
    delete bucket.listeners[id];
    var hasListeners = false;
    for(var listener in bucket.listeners){
        hasListeners = true;
        break;
    }
    if (!hasListeners) {
        clearInterval(bucket.timer);
        delete buckets[bucket.ms];
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fDXmM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useState = _react.useState;
var noop = function() {};
var useHover = function(element) {
    var _a = useState(false), state = _a[0], setState = _a[1];
    var onMouseEnter = function(originalOnMouseEnter) {
        return function(event) {
            (originalOnMouseEnter || noop)(event);
            setState(true);
        };
    };
    var onMouseLeave = function(originalOnMouseLeave) {
        return function(event) {
            (originalOnMouseLeave || noop)(event);
            setState(false);
        };
    };
    if (typeof element === 'function') element = element(state);
    var el = _react.cloneElement(element, {
        onMouseEnter: onMouseEnter(element.props.onMouseEnter),
        onMouseLeave: onMouseLeave(element.props.onMouseLeave)
    });
    return [
        el,
        state
    ];
};
exports.default = useHover;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"F6Psq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
// kudos: https://usehooks.com/
var useHoverDirty = function(ref, enabled) {
    if (enabled === void 0) enabled = true;
    var _a = (0, _react.useState)(false), value = _a[0], setValue = _a[1];
    (0, _react.useEffect)(function() {
        var onMouseOver = function() {
            return setValue(true);
        };
        var onMouseOut = function() {
            return setValue(false);
        };
        if (enabled && ref && ref.current) {
            ref.current.addEventListener('mouseover', onMouseOver);
            ref.current.addEventListener('mouseout', onMouseOut);
        }
        // fixes react-hooks/exhaustive-deps warning about stale ref elements
        var current = ref.current;
        return function() {
            if (enabled && current) {
                current.removeEventListener('mouseover', onMouseOver);
                current.removeEventListener('mouseout', onMouseOut);
            }
        };
    }, [
        enabled,
        ref
    ]);
    return value;
};
exports.default = useHoverDirty;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fjIjD":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _throttleDebounce = require("throttle-debounce");
var _util = require("./util");
var defaultEvents = [
    'mousemove',
    'mousedown',
    'resize',
    'keydown',
    'touchstart',
    'wheel'
];
var oneMinute = 60e3;
var useIdle = function(ms, initialState, events) {
    if (ms === void 0) ms = oneMinute;
    if (initialState === void 0) initialState = false;
    if (events === void 0) events = defaultEvents;
    var _a = (0, _react.useState)(initialState), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var mounted = true;
        var timeout;
        var localState = state;
        var set = function(newState) {
            if (mounted) {
                localState = newState;
                setState(newState);
            }
        };
        var onEvent = (0, _throttleDebounce.throttle)(50, function() {
            if (localState) set(false);
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                return set(true);
            }, ms);
        });
        var onVisibility = function() {
            if (!document.hidden) onEvent();
        };
        for(var i = 0; i < events.length; i++)(0, _util.on)(window, events[i], onEvent);
        (0, _util.on)(document, 'visibilitychange', onVisibility);
        timeout = setTimeout(function() {
            return set(true);
        }, ms);
        return function() {
            mounted = false;
            for(var i = 0; i < events.length; i++)(0, _util.off)(window, events[i], onEvent);
            (0, _util.off)(document, 'visibilitychange', onVisibility);
        };
    }, [
        ms,
        events
    ]);
    return state;
};
exports.default = useIdle;

},{"react":"9njXz","throttle-debounce":"45b9x","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"45b9x":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    /* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset).
	 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @returns {Function}  A new, throttled, function.
	 */ function throttle(delay, noTrailing, callback, debounceMode) {
        /*
	   * After wrapper has stopped being called, this timeout ensures that
	   * `callback` is executed at the proper times in `throttle` and `end`
	   * debounce modes.
	   */ var timeoutID;
        var cancelled = false; // Keep track of the last time `callback` was executed.
        var lastExec = 0; // Function to clear existing timeout
        function clearExistingTimeout() {
            if (timeoutID) clearTimeout(timeoutID);
        } // Function to cancel next exec
        function cancel() {
            clearExistingTimeout();
            cancelled = true;
        } // `noTrailing` defaults to falsy.
        if (typeof noTrailing !== 'boolean') {
            debounceMode = callback;
            callback = noTrailing;
            noTrailing = undefined;
        }
        /*
	   * The `wrapper` function encapsulates all of the throttling / debouncing
	   * functionality and when executed will limit the rate at which `callback`
	   * is executed.
	   */ function wrapper() {
            for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
            var self = this;
            var elapsed = Date.now() - lastExec;
            if (cancelled) return;
             // Execute `callback` and update the `lastExec` timestamp.
            function exec() {
                lastExec = Date.now();
                callback.apply(self, arguments_);
            }
            /*
	     * If `debounceMode` is true (at begin) this is used to clear the flag
	     * to allow future `callback` executions.
	     */ function clear() {
                timeoutID = undefined;
            }
            if (debounceMode && !timeoutID) /*
	       * Since `wrapper` is being called for the first time and
	       * `debounceMode` is true (at begin), execute `callback`.
	       */ exec();
            clearExistingTimeout();
            if (debounceMode === undefined && elapsed > delay) /*
	       * In throttle mode, if `delay` time has been exceeded, execute
	       * `callback`.
	       */ exec();
            else if (noTrailing !== true) /*
	       * In trailing throttle mode, since `delay` time has not been
	       * exceeded, schedule `callback` to execute `delay` ms after most
	       * recent execution.
	       *
	       * If `debounceMode` is true (at begin), schedule `clear` to execute
	       * after `delay` ms.
	       *
	       * If `debounceMode` is false (at end), schedule `callback` to
	       * execute after `delay` ms.
	       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
        }
        wrapper.cancel = cancel; // Return the wrapper function.
        return wrapper;
    }
    /* eslint-disable no-undefined */ /**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @returns {Function} A new, debounced function.
	 */ function debounce(delay, atBegin, callback) {
        return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
    }
    exports1.debounce = debounce;
    exports1.throttle = throttle;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"kkuJL":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useIntersection = function(ref, options) {
    var _a = (0, _react.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0, _react.useEffect)(function() {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function(entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function() {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function() {};
    }, [
        ref.current,
        options.threshold,
        options.root,
        options.rootMargin
    ]);
    return intersectionObserverEntry;
};
exports.default = useIntersection;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"argj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useInterval = function(callback, delay) {
    var savedCallback = (0, _react.useRef)(function() {});
    (0, _react.useEffect)(function() {
        savedCallback.current = callback;
    });
    (0, _react.useEffect)(function() {
        if (delay !== null) {
            var interval_1 = setInterval(function() {
                return savedCallback.current();
            }, delay || 0);
            return function() {
                return clearInterval(interval_1);
            };
        }
        return undefined;
    }, [
        delay
    ]);
};
exports.default = useInterval;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3vAM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
exports.default = useIsomorphicLayoutEffect;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iI5LJ":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEvent = require("./useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var noop = function() {};
var createKeyPredicate = function(keyFilter) {
    return typeof keyFilter === 'function' ? keyFilter : typeof keyFilter === 'string' ? function(event) {
        return event.key === keyFilter;
    } : keyFilter ? function() {
        return true;
    } : function() {
        return false;
    };
};
var useKey = function(key, fn, opts, deps) {
    if (fn === void 0) fn = noop;
    if (opts === void 0) opts = {};
    if (deps === void 0) deps = [
        key
    ];
    var _a = opts.event, event = _a === void 0 ? 'keydown' : _a, target = opts.target, options = opts.options;
    var useMemoHandler = (0, _react.useMemo)(function() {
        var predicate = createKeyPredicate(key);
        var handler = function(handlerEvent) {
            if (predicate(handlerEvent)) return fn(handlerEvent);
        };
        return handler;
    }, deps);
    (0, _useEventDefault.default)(event, useMemoHandler, target, options);
};
exports.default = useKey;

},{"react":"9njXz","./useEvent":"fMYXX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5hQOl":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var createBreakpoint = function(breakpoints) {
    if (breakpoints === void 0) breakpoints = {
        laptopL: 1440,
        laptop: 1024,
        tablet: 768
    };
    return function() {
        var _a = (0, _react.useState)(0), screen = _a[0], setScreen = _a[1];
        (0, _react.useEffect)(function() {
            var setSideScreen = function() {
                setScreen(window.innerWidth);
            };
            setSideScreen();
            window.addEventListener('resize', setSideScreen);
            return function() {
                window.removeEventListener('resize', setSideScreen);
            };
        });
        var sortedBreakpoints = (0, _react.useMemo)(function() {
            return Object.entries(breakpoints).sort(function(a, b) {
                return a[1] >= b[1] ? 1 : -1;
            });
        }, [
            breakpoints
        ]);
        var result = sortedBreakpoints.reduce(function(acc, _a) {
            var name = _a[0], width = _a[1];
            if (screen >= width) return name;
            else return acc;
        }, sortedBreakpoints[0][0]);
        return result;
    };
};
exports.default = createBreakpoint;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6OpsJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useKey = require("./useKey");
var _useKeyDefault = parcelHelpers.interopDefault(_useKey);
var useKeyPress = function(keyFilter) {
    var _a = (0, _react.useState)([
        false,
        null
    ]), state = _a[0], set = _a[1];
    (0, _useKeyDefault.default)(keyFilter, function(event) {
        return set([
            true,
            event
        ]);
    }, {
        event: 'keydown'
    }, [
        state
    ]);
    (0, _useKeyDefault.default)(keyFilter, function(event) {
        return set([
            false,
            event
        ]);
    }, {
        event: 'keyup'
    }, [
        state
    ]);
    return state;
};
exports.default = useKeyPress;

},{"react":"9njXz","./useKey":"iI5LJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2HC7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useKeyPress = require("./useKeyPress");
var _useKeyPressDefault = parcelHelpers.interopDefault(_useKeyPress);
var _useUpdateEffect = require("./useUpdateEffect");
var _useUpdateEffectDefault = parcelHelpers.interopDefault(_useUpdateEffect);
var useKeyPressEvent = function(key, keydown, keyup, useKeyPress) {
    if (useKeyPress === void 0) useKeyPress = (0, _useKeyPressDefault.default);
    var _a = useKeyPress(key), pressed = _a[0], event = _a[1];
    (0, _useUpdateEffectDefault.default)(function() {
        if (!pressed && keyup) keyup(event);
        else if (pressed && keydown) keydown(event);
    }, [
        pressed
    ]);
};
exports.default = useKeyPressEvent;

},{"./useKeyPress":"6OpsJ","./useUpdateEffect":"f7d80","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iPmF4":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useLifecycles = function(mount, unmount) {
    (0, _react.useEffect)(function() {
        if (mount) mount();
        return function() {
            if (unmount) unmount();
        };
    }, []);
};
exports.default = useLifecycles;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hREI3":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useUpdate = require("./useUpdate");
var _useUpdateDefault = parcelHelpers.interopDefault(_useUpdate);
var _resolveHookState = require("./util/resolveHookState");
function useList(initialList) {
    if (initialList === void 0) initialList = [];
    var list = (0, _react.useRef)((0, _resolveHookState.resolveHookState)(initialList));
    var update = (0, _useUpdateDefault.default)();
    var actions = (0, _react.useMemo)(function() {
        var a = {
            set: function(newList) {
                list.current = (0, _resolveHookState.resolveHookState)(newList, list.current);
                update();
            },
            push: function() {
                var items = [];
                for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                items.length && actions.set(function(curr) {
                    return curr.concat(items);
                });
            },
            updateAt: function(index, item) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    arr[index] = item;
                    return arr;
                });
            },
            insertAt: function(index, item) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    index > arr.length ? arr[index] = item : arr.splice(index, 0, item);
                    return arr;
                });
            },
            update: function(predicate, newItem) {
                actions.set(function(curr) {
                    return curr.map(function(item) {
                        return predicate(item, newItem) ? newItem : item;
                    });
                });
            },
            updateFirst: function(predicate, newItem) {
                var index = list.current.findIndex(function(item) {
                    return predicate(item, newItem);
                });
                index >= 0 && actions.updateAt(index, newItem);
            },
            upsert: function(predicate, newItem) {
                var index = list.current.findIndex(function(item) {
                    return predicate(item, newItem);
                });
                index >= 0 ? actions.updateAt(index, newItem) : actions.push(newItem);
            },
            sort: function(compareFn) {
                actions.set(function(curr) {
                    return curr.slice().sort(compareFn);
                });
            },
            filter: function(callbackFn, thisArg) {
                actions.set(function(curr) {
                    return curr.slice().filter(callbackFn, thisArg);
                });
            },
            removeAt: function(index) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    arr.splice(index, 1);
                    return arr;
                });
            },
            clear: function() {
                actions.set([]);
            },
            reset: function() {
                actions.set((0, _resolveHookState.resolveHookState)(initialList).slice());
            }
        };
        /**
         * @deprecated Use removeAt method instead
         */ a.remove = a.removeAt;
        return a;
    }, []);
    return [
        list.current,
        actions
    ];
}
exports.default = useList;

},{"react":"9njXz","./useUpdate":"g3F6e","./util/resolveHookState":"mTVHM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9hFML":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var useLocalStorage = function(key, initialValue, options) {
    if (!(0, _util.isClient)) return [
        initialValue,
        function() {}
    ];
    // Use provided serializer/deserializer or the default ones
    var serializer = options ? options.raw ? String : options.serializer : JSON.stringify;
    var deserializer = options ? options.raw ? String : options.deserializer : JSON.parse;
    var _a = (0, _react.useState)(function() {
        try {
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) return deserializer(localStorageValue);
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        } catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    }), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        try {
            localStorage.setItem(key, serializer(state));
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [
        state
    ]);
    return [
        state,
        setState
    ];
};
exports.default = useLocalStorage;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gw4pD":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var patchHistoryMethod = function(method) {
    var original = history[method];
    history[method] = function(state) {
        var result = original.apply(this, arguments);
        var event = new Event(method.toLowerCase());
        event.state = state;
        window.dispatchEvent(event);
        return result;
    };
};
if (0, _util.isClient) {
    patchHistoryMethod('pushState');
    patchHistoryMethod('replaceState');
}
var useLocationServer = function() {
    return {
        trigger: 'load',
        length: 1
    };
};
var buildState = function(trigger) {
    var state = history.state, length = history.length;
    var hash = location.hash, host = location.host, hostname = location.hostname, href = location.href, origin = location.origin, pathname = location.pathname, port = location.port, protocol = location.protocol, search = location.search;
    return {
        trigger: trigger,
        state: state,
        length: length,
        hash: hash,
        host: host,
        hostname: hostname,
        href: href,
        origin: origin,
        pathname: pathname,
        port: port,
        protocol: protocol,
        search: search
    };
};
var useLocationBrowser = function() {
    var _a = (0, _react.useState)(buildState('load')), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var onPopstate = function() {
            return setState(buildState('popstate'));
        };
        var onPushstate = function() {
            return setState(buildState('pushstate'));
        };
        var onReplacestate = function() {
            return setState(buildState('replacestate'));
        };
        (0, _util.on)(window, 'popstate', onPopstate);
        (0, _util.on)(window, 'pushstate', onPushstate);
        (0, _util.on)(window, 'replacestate', onReplacestate);
        return function() {
            (0, _util.off)(window, 'popstate', onPopstate);
            (0, _util.off)(window, 'pushstate', onPushstate);
            (0, _util.off)(window, 'replacestate', onReplacestate);
        };
    }, []);
    return state;
};
var hasEventConstructor = typeof Event === 'function';
exports.default = (0, _util.isClient) && hasEventConstructor ? useLocationBrowser : useLocationServer;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gXNQ9":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getClosestBody", ()=>getClosestBody);
var _react = require("react");
function getClosestBody(el) {
    if (!el) return null;
    else if (el.tagName === 'BODY') return el;
    else if (el.tagName === 'IFRAME') {
        var document_1 = el.contentDocument;
        return document_1 ? document_1.body : null;
    } else if (!el.offsetParent) return null;
    return getClosestBody(el.offsetParent);
}
function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
}
var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && /iP(ad|hone|od)/.test(window.navigator.platform);
var bodies = new Map();
var doc = typeof document === 'object' ? document : undefined;
var documentListenerAdded = false;
exports.default = !doc ? function useLockBodyMock(_locked, _elementRef) {
    if (_locked === void 0) _locked = true;
} : function useLockBody(locked, elementRef) {
    if (locked === void 0) locked = true;
    elementRef = elementRef || (0, _react.useRef)(doc.body);
    (0, _react.useEffect)(function() {
        var body = getClosestBody(elementRef.current);
        if (!body) return;
        var bodyInfo = bodies.get(body);
        if (locked) {
            if (!bodyInfo) {
                bodies.set(body, {
                    counter: 1,
                    initialOverflow: body.style.overflow
                });
                if (isIosDevice) {
                    if (!documentListenerAdded) {
                        document.addEventListener('touchmove', preventDefault, {
                            passive: false
                        });
                        documentListenerAdded = true;
                    }
                } else body.style.overflow = 'hidden';
            } else bodies.set(body, {
                counter: bodyInfo.counter + 1,
                initialOverflow: bodyInfo.initialOverflow
            });
        } else if (bodyInfo) {
            if (bodyInfo.counter === 1) {
                bodies.delete(body);
                if (isIosDevice) {
                    body.ontouchmove = null;
                    if (documentListenerAdded) {
                        document.removeEventListener('touchmove', preventDefault);
                        documentListenerAdded = false;
                    }
                } else body.style.overflow = bodyInfo.initialOverflow;
            } else bodies.set(body, {
                counter: bodyInfo.counter - 1,
                initialOverflow: bodyInfo.initialOverflow
            });
        }
    }, [
        locked,
        elementRef.current
    ]);
};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3ttCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _useEffectOnce = require("./useEffectOnce");
var _useEffectOnceDefault = parcelHelpers.interopDefault(_useEffectOnce);
var _useUpdateEffect = require("./useUpdateEffect");
var _useUpdateEffectDefault = parcelHelpers.interopDefault(_useUpdateEffect);
var useLogger = function(componentName) {
    var rest = [];
    for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
    (0, _useEffectOnceDefault.default)(function() {
        console.log.apply(console, (0, _tslib.__spreadArrays)([
            componentName + " mounted"
        ], rest));
        return function() {
            return console.log(componentName + " unmounted");
        };
    });
    (0, _useUpdateEffectDefault.default)(function() {
        console.log.apply(console, (0, _tslib.__spreadArrays)([
            componentName + " updated"
        ], rest));
    });
};
exports.default = useLogger;

},{"tslib":"b4wpY","./useEffectOnce":"3RRde","./useUpdateEffect":"f7d80","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6ZdAD":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var isTouchEvent = function(event) {
    return 'touches' in event;
};
var preventDefault = function(event) {
    if (!isTouchEvent(event)) return;
    if (event.touches.length < 2 && event.preventDefault) event.preventDefault();
};
var useLongPress = function(callback, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.isPreventDefault, isPreventDefault = _c === void 0 ? true : _c, _d = _b.delay, delay = _d === void 0 ? 300 : _d;
    var timeout = (0, _react.useRef)();
    var target = (0, _react.useRef)();
    var start = (0, _react.useCallback)(function(event) {
        // prevent ghost click on mobile devices
        if (isPreventDefault && event.target) {
            event.target.addEventListener('touchend', preventDefault, {
                passive: false
            });
            target.current = event.target;
        }
        timeout.current = setTimeout(function() {
            return callback(event);
        }, delay);
    }, [
        callback,
        delay
    ]);
    var clear = (0, _react.useCallback)(function() {
        // clearTimeout and removeEventListener
        timeout.current && clearTimeout(timeout.current);
        if (isPreventDefault && target.current) target.current.removeEventListener('touchend', preventDefault);
    }, []);
    return {
        onMouseDown: function(e) {
            return start(e);
        },
        onTouchStart: function(e) {
            return start(e);
        },
        onMouseUp: clear,
        onMouseLeave: clear,
        onTouchEnd: clear
    };
};
exports.default = useLongPress;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"i9kCA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var useMap = function(initialMap) {
    if (initialMap === void 0) initialMap = {};
    var _a = (0, _react.useState)(initialMap), map = _a[0], set = _a[1];
    var stableActions = (0, _react.useMemo)(function() {
        return {
            set: function(key, entry) {
                set(function(prevMap) {
                    var _a;
                    return (0, _tslib.__assign)((0, _tslib.__assign)({}, prevMap), (_a = {}, _a[key] = entry, _a));
                });
            },
            setAll: function(newMap) {
                set(newMap);
            },
            remove: function(key) {
                set(function(prevMap) {
                    var _a = prevMap, _b = key, omit = _a[_b], rest = (0, _tslib.__rest)(_a, [
                        typeof _b === "symbol" ? _b : _b + ""
                    ]);
                    return rest;
                });
            },
            reset: function() {
                return set(initialMap);
            }
        };
    }, [
        set
    ]);
    var utils = (0, _tslib.__assign)({
        get: (0, _react.useCallback)(function(key) {
            return map[key];
        }, [
            map
        ])
    }, stableActions);
    return [
        map,
        utils
    ];
};
exports.default = useMap;

},{"tslib":"b4wpY","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8YAyf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var useMedia = function(query, defaultState) {
    if (defaultState === void 0) defaultState = false;
    var _a = (0, _react.useState)((0, _util.isClient) ? function() {
        return window.matchMedia(query).matches;
    } : defaultState), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function() {
            if (!mounted) return;
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function() {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [
        query
    ]);
    return state;
};
exports.default = useMedia;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5tj1v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var noop = function() {};
var useMediaDevices = function() {
    var _a = (0, _react.useState)({}), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var mounted = true;
        var onChange = function() {
            navigator.mediaDevices.enumerateDevices().then(function(devices) {
                if (mounted) setState({
                    devices: devices.map(function(_a) {
                        var deviceId = _a.deviceId, groupId = _a.groupId, kind = _a.kind, label = _a.label;
                        return {
                            deviceId: deviceId,
                            groupId: groupId,
                            kind: kind,
                            label: label
                        };
                    })
                });
            }).catch(noop);
        };
        (0, _util.on)(navigator.mediaDevices, 'devicechange', onChange);
        onChange();
        return function() {
            mounted = false;
            (0, _util.off)(navigator.mediaDevices, 'devicechange', onChange);
        };
    }, []);
    return state;
};
var useMediaDevicesMock = function() {
    return {};
};
exports.default = typeof navigator === 'object' && !!navigator.mediaDevices ? useMediaDevices : useMediaDevicesMock;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5OVGX":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMediatedState", ()=>useMediatedState);
var _react = require("react");
function useMediatedState(mediator, initialState) {
    var mediatorFn = (0, _react.useRef)(mediator);
    var _a = (0, _react.useState)(initialState), state = _a[0], setMediatedState = _a[1];
    var setState = (0, _react.useCallback)(function(newState) {
        if (mediatorFn.current.length === 2) mediatorFn.current(newState, setMediatedState);
        else setMediatedState(mediatorFn.current(newState));
    }, [
        state
    ]);
    return [
        state,
        setState
    ];
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hppOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useMethods = function(createMethods, initialState) {
    var reducer = (0, _react.useMemo)(function() {
        return function(reducerState, action) {
            var _a;
            return (_a = createMethods(reducerState))[action.type].apply(_a, action.payload);
        };
    }, [
        createMethods
    ]);
    var _a = (0, _react.useReducer)(reducer, initialState), state = _a[0], dispatch = _a[1];
    var wrappedMethods = (0, _react.useMemo)(function() {
        var actionTypes = Object.keys(createMethods(initialState));
        return actionTypes.reduce(function(acc, type) {
            acc[type] = function() {
                var payload = [];
                for(var _i = 0; _i < arguments.length; _i++)payload[_i] = arguments[_i];
                return dispatch({
                    type: type,
                    payload: payload
                });
            };
            return acc;
        }, {});
    }, [
        createMethods,
        initialState
    ]);
    return [
        state,
        wrappedMethods
    ];
};
exports.default = useMethods;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hRW18":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var defaultState = {
    acceleration: {
        x: null,
        y: null,
        z: null
    },
    accelerationIncludingGravity: {
        x: null,
        y: null,
        z: null
    },
    rotationRate: {
        alpha: null,
        beta: null,
        gamma: null
    },
    interval: 16
};
var useMotion = function(initialState) {
    if (initialState === void 0) initialState = defaultState;
    var _a = (0, _react.useState)(initialState), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var handler = function(event) {
            var acceleration = event.acceleration, accelerationIncludingGravity = event.accelerationIncludingGravity, rotationRate = event.rotationRate, interval = event.interval;
            setState({
                acceleration: {
                    x: acceleration.x,
                    y: acceleration.y,
                    z: acceleration.z
                },
                accelerationIncludingGravity: {
                    x: accelerationIncludingGravity.x,
                    y: accelerationIncludingGravity.y,
                    z: accelerationIncludingGravity.z
                },
                rotationRate: {
                    alpha: rotationRate.alpha,
                    beta: rotationRate.beta,
                    gamma: rotationRate.gamma
                },
                interval: interval
            });
        };
        (0, _util.on)(window, 'devicemotion', handler);
        return function() {
            (0, _util.off)(window, 'devicemotion', handler);
        };
    }, []);
    return state;
};
exports.default = useMotion;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4EVfq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useEffectOnce = require("./useEffectOnce");
var _useEffectOnceDefault = parcelHelpers.interopDefault(_useEffectOnce);
var useMount = function(fn) {
    (0, _useEffectOnceDefault.default)(function() {
        fn();
    });
};
exports.default = useMount;

},{"./useEffectOnce":"3RRde","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Yvyq":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useRafState = require("./useRafState");
var _useRafStateDefault = parcelHelpers.interopDefault(_useRafState);
var useMouse = function(ref) {
    var _a = (0, _useRafStateDefault.default)({
        docX: 0,
        docY: 0,
        posX: 0,
        posY: 0,
        elX: 0,
        elY: 0,
        elH: 0,
        elW: 0
    }), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var moveHandler = function(event) {
            if (ref && ref.current) {
                var _a = ref.current.getBoundingClientRect(), left = _a.left, top_1 = _a.top, elW = _a.width, elH = _a.height;
                var posX = left + window.pageXOffset;
                var posY = top_1 + window.pageYOffset;
                var elX = event.pageX - posX;
                var elY = event.pageY - posY;
                setState({
                    docX: event.pageX,
                    docY: event.pageY,
                    posX: posX,
                    posY: posY,
                    elX: elX,
                    elY: elY,
                    elH: elH,
                    elW: elW
                });
            }
        };
        document.addEventListener('mousemove', moveHandler);
        return function() {
            document.removeEventListener('mousemove', moveHandler);
        };
    }, [
        ref
    ]);
    return state;
};
exports.default = useMouse;

},{"react":"9njXz","./useRafState":"k3hEp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"k3hEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useUnmount = require("./useUnmount");
var _useUnmountDefault = parcelHelpers.interopDefault(_useUnmount);
var useRafState = function(initialState) {
    var frame = (0, _react.useRef)(0);
    var _a = (0, _react.useState)(initialState), state = _a[0], setState = _a[1];
    var setRafState = (0, _react.useCallback)(function(value) {
        cancelAnimationFrame(frame.current);
        frame.current = requestAnimationFrame(function() {
            setState(value);
        });
    }, []);
    (0, _useUnmountDefault.default)(function() {
        cancelAnimationFrame(frame.current);
    });
    return [
        state,
        setRafState
    ];
};
exports.default = useRafState;

},{"react":"9njXz","./useUnmount":"7LKP4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7LKP4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEffectOnce = require("./useEffectOnce");
var _useEffectOnceDefault = parcelHelpers.interopDefault(_useEffectOnce);
var useUnmount = function(fn) {
    var fnRef = (0, _react.useRef)(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    (0, _useEffectOnceDefault.default)(function() {
        return function() {
            return fnRef.current();
        };
    });
};
exports.default = useUnmount;

},{"react":"9njXz","./useEffectOnce":"3RRde","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6pPBO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useHoverDirty = require("./useHoverDirty");
var _useHoverDirtyDefault = parcelHelpers.interopDefault(_useHoverDirty);
var _useMouse = require("./useMouse");
var _useMouseDefault = parcelHelpers.interopDefault(_useMouse);
var nullRef = {
    current: null
};
var useMouseHovered = function(ref, options) {
    if (options === void 0) options = {};
    var whenHovered = !!options.whenHovered;
    var bound = !!options.bound;
    var isHovered = (0, _useHoverDirtyDefault.default)(ref, whenHovered);
    var state = (0, _useMouseDefault.default)(whenHovered && !isHovered ? nullRef : ref);
    if (bound) {
        state.elX = Math.max(0, Math.min(state.elX, state.elW));
        state.elY = Math.max(0, Math.min(state.elY, state.elH));
    }
    return state;
};
exports.default = useMouseHovered;

},{"./useHoverDirty":"F6Psq","./useMouse":"4Yvyq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gPoEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var _util = require("./util");
var getConnection = function() {
    if (typeof navigator !== 'object') return null;
    var nav = navigator;
    return nav.connection || nav.mozConnection || nav.webkitConnection;
};
var getConnectionState = function() {
    var connection = getConnection();
    if (!connection) return {};
    var downlink = connection.downlink, downlinkMax = connection.downlinkMax, effectiveType = connection.effectiveType, type = connection.type, rtt = connection.rtt;
    return {
        downlink: downlink,
        downlinkMax: downlinkMax,
        effectiveType: effectiveType,
        type: type,
        rtt: rtt
    };
};
var useNetwork = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = (0, _react.useState)(initialState), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var localState = state;
        var localSetState = function(patch) {
            localState = (0, _tslib.__assign)((0, _tslib.__assign)({}, localState), patch);
            setState(localState);
        };
        var connection = getConnection();
        var onOnline = function() {
            localSetState({
                online: true,
                since: new Date()
            });
        };
        var onOffline = function() {
            localSetState({
                online: false,
                since: new Date()
            });
        };
        var onConnectionChange = function() {
            localSetState(getConnectionState());
        };
        (0, _util.on)(window, 'online', onOnline);
        (0, _util.on)(window, 'offline', onOffline);
        if (connection) {
            (0, _util.on)(connection, 'change', onConnectionChange);
            localSetState((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, state), {
                online: navigator.onLine,
                since: undefined
            }), getConnectionState()));
        }
        return function() {
            (0, _util.off)(window, 'online', onOnline);
            (0, _util.off)(window, 'offline', onOffline);
            if (connection) (0, _util.off)(connection, 'change', onConnectionChange);
        };
    }, []);
    return state;
};
exports.default = useNetwork;

},{"tslib":"b4wpY","react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6koEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useCounter = require("./useCounter");
var _useCounterDefault = parcelHelpers.interopDefault(_useCounter);
exports.default = (0, _useCounterDefault.default);

},{"./useCounter":"epYoj","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5lWe1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
function useObservable(observable$, initialValue) {
    var _a = (0, _react.useState)(initialValue), value = _a[0], update = _a[1];
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        var s = observable$.subscribe(update);
        return function() {
            return s.unsubscribe();
        };
    }, [
        observable$
    ]);
    return value;
}
exports.default = useObservable;

},{"react":"9njXz","./useIsomorphicLayoutEffect":"d3vAM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f8sPX":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var defaultState = {
    angle: 0,
    type: 'landscape-primary'
};
var useOrientation = function(initialState) {
    if (initialState === void 0) initialState = defaultState;
    var _a = (0, _react.useState)(initialState), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var mounted = true;
        var onChange = function() {
            if (mounted) {
                var orientation_1 = screen.orientation;
                if (orientation_1) {
                    var angle = orientation_1.angle, type = orientation_1.type;
                    setState({
                        angle: angle,
                        type: type
                    });
                } else if (window.orientation) setState({
                    angle: typeof window.orientation === 'number' ? window.orientation : 0,
                    type: ''
                });
                else setState(initialState);
            }
        };
        (0, _util.on)(window, 'orientationchange', onChange);
        onChange();
        return function() {
            mounted = false;
            (0, _util.off)(window, 'orientationchange', onChange);
        };
    }, []);
    return state;
};
exports.default = useOrientation;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hR2Js":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var usePageLeave = function(onPageLeave, args) {
    if (args === void 0) args = [];
    (0, _react.useEffect)(function() {
        if (!onPageLeave) return;
        var handler = function(event) {
            event = event ? event : window.event;
            var from = event.relatedTarget || event.toElement;
            if (!from || from.nodeName === 'HTML') onPageLeave();
        };
        document.addEventListener('mouseout', handler);
        return function() {
            document.removeEventListener('mouseout', handler);
        };
    }, args);
};
exports.default = usePageLeave;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9SxUl":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var noop = function() {};
var usePermission = function(permissionDesc) {
    var mounted = true;
    var permissionStatus = null;
    var _a = (0, _react.useState)(''), state = _a[0], setState = _a[1];
    var onChange = function() {
        if (mounted && permissionStatus) setState(permissionStatus.state);
    };
    var changeState = function() {
        onChange();
        (0, _util.on)(permissionStatus, 'change', onChange);
    };
    (0, _react.useEffect)(function() {
        navigator.permissions.query(permissionDesc).then(function(status) {
            permissionStatus = status;
            changeState();
        }).catch(noop);
        return function() {
            mounted = false;
            permissionStatus && (0, _util.off)(permissionStatus, 'change', onChange);
        };
    }, []);
    return state;
};
exports.default = usePermission;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"751g7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var usePrevious = function(state) {
    var ref = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        ref.current = state;
    });
    return ref.current;
};
exports.default = usePrevious;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ddCtn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePreviousDistinct);
var _react = require("react");
var _useFirstMountState = require("./useFirstMountState");
var strictEquals = function(prev, next) {
    return prev === next;
};
function usePreviousDistinct(value, compare) {
    if (compare === void 0) compare = strictEquals;
    var prevRef = (0, _react.useRef)();
    var curRef = (0, _react.useRef)(value);
    var isFirstMount = (0, _useFirstMountState.useFirstMountState)();
    if (!isFirstMount && !compare(curRef.current, value)) {
        prevRef.current = curRef.current;
        curRef.current = value;
    }
    return prevRef.current;
}

},{"react":"9njXz","./useFirstMountState":"6yQkq","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ZafO":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
var usePromise = function() {
    var isMounted = (0, _useMountedStateDefault.default)();
    return (0, _react.useCallback)(function(promise) {
        return new Promise(function(resolve, reject) {
            var onValue = function(value) {
                isMounted() && resolve(value);
            };
            var onError = function(error) {
                isMounted() && reject(error);
            };
            promise.then(onValue, onError);
        });
    }, []);
};
exports.default = usePromise;

},{"react":"9njXz","./useMountedState":"8WCZ5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"mJEsF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
var _react = require("react");
var useQueue = function(initialValue) {
    if (initialValue === void 0) initialValue = [];
    var _a = (0, _react.useState)(initialValue), state = _a[0], set = _a[1];
    return {
        add: function(value) {
            set(function(queue) {
                return (0, _tslib.__spreadArrays)(queue, [
                    value
                ]);
            });
        },
        remove: function() {
            var result;
            set(function(_a) {
                var first = _a[0], rest = _a.slice(1);
                result = first;
                return rest;
            });
            return result;
        },
        get first () {
            return state[0];
        },
        get last () {
            return state[state.length - 1];
        },
        get size () {
            return state.length;
        }
    };
};
exports.default = useQueue;

},{"tslib":"b4wpY","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1z7RK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useRaf = function(ms, delay) {
    if (ms === void 0) ms = 1e12;
    if (delay === void 0) delay = 0;
    var _a = (0, _react.useState)(0), elapsed = _a[0], set = _a[1];
    (0, _react.useLayoutEffect)(function() {
        var raf;
        var timerStop;
        var start;
        var onFrame = function() {
            var time = Math.min(1, (Date.now() - start) / ms);
            set(time);
            loop();
        };
        var loop = function() {
            raf = requestAnimationFrame(onFrame);
        };
        var onStart = function() {
            timerStop = setTimeout(function() {
                cancelAnimationFrame(raf);
                set(1);
            }, ms);
            start = Date.now();
            loop();
        };
        var timerDelay = setTimeout(onStart, delay);
        return function() {
            clearTimeout(timerStop);
            clearTimeout(timerDelay);
            cancelAnimationFrame(raf);
        };
    }, [
        ms,
        delay
    ]);
    return elapsed;
};
exports.default = useRaf;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"f1xft":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRafLoop);
var _react = require("react");
function useRafLoop(callback, initiallyActive) {
    if (initiallyActive === void 0) initiallyActive = true;
    var raf = (0, _react.useRef)(null);
    var rafActivity = (0, _react.useRef)(false);
    var rafCallback = (0, _react.useRef)(callback);
    rafCallback.current = callback;
    var step = (0, _react.useCallback)(function(time) {
        if (rafActivity.current) {
            rafCallback.current(time);
            raf.current = requestAnimationFrame(step);
        }
    }, []);
    var result = (0, _react.useMemo)(function() {
        return [
            function() {
                if (rafActivity.current) {
                    rafActivity.current = false;
                    raf.current && cancelAnimationFrame(raf.current);
                }
            },
            function() {
                if (!rafActivity.current) {
                    rafActivity.current = true;
                    raf.current = requestAnimationFrame(step);
                }
            },
            function() {
                return rafActivity.current;
            } // isActive
        ];
    }, []);
    (0, _react.useEffect)(function() {
        if (initiallyActive) result[1]();
        return result[0];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return result;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4uSvh":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var getValue = function(search, param) {
    return new URLSearchParams(search).get(param);
};
var useSearchParam = function(param) {
    var _a = (0, _react.useState)(function() {
        return getValue(location.search, param);
    }), value = _a[0], setValue = _a[1];
    (0, _react.useEffect)(function() {
        var onChange = function() {
            setValue(getValue(location.search, param));
        };
        window.addEventListener('popstate', onChange);
        window.addEventListener('pushstate', onChange);
        window.addEventListener('replacestate', onChange);
        return function() {
            window.removeEventListener('popstate', onChange);
            window.removeEventListener('pushstate', onChange);
            window.removeEventListener('replacestate', onChange);
        };
    }, []);
    return value;
};
var useSearchParamServer = function() {
    return null;
};
exports.default = typeof window === 'object' ? useSearchParam : useSearchParamServer;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3SLFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScratchSensor", ()=>ScratchSensor);
var _tslib = require("tslib");
var _react = require("react");
var _reactUniversalInterface = require("react-universal-interface");
var noop = function() {};
var useScratch = function(_a) {
    var _b = _a === void 0 ? {} : _a, disabled = _b.disabled, _c = _b.onScratch, onScratch = _c === void 0 ? noop : _c, _d = _b.onScratchStart, onScratchStart = _d === void 0 ? noop : _d, _e = _b.onScratchEnd, onScratchEnd = _e === void 0 ? noop : _e;
    var _f = (0, _react.useState)({
        isScratching: false
    }), state = _f[0], setState = _f[1];
    var refState = (0, _react.useRef)(state);
    var refScratching = (0, _react.useRef)(false);
    var refAnimationFrame = (0, _react.useRef)(null);
    var _g = (0, _react.useState)(null), el = _g[0], setEl = _g[1];
    (0, _react.useEffect)(function() {
        if (disabled) return;
        if (!el) return;
        var onMoveEvent = function(docX, docY) {
            cancelAnimationFrame(refAnimationFrame.current);
            refAnimationFrame.current = requestAnimationFrame(function() {
                var _a = el.getBoundingClientRect(), left = _a.left, top = _a.top;
                var elX = left + window.scrollX;
                var elY = top + window.scrollY;
                var x = docX - elX;
                var y = docY - elY;
                setState(function(oldState) {
                    var newState = (0, _tslib.__assign)((0, _tslib.__assign)({}, oldState), {
                        dx: x - (oldState.x || 0),
                        dy: y - (oldState.y || 0),
                        end: Date.now(),
                        isScratching: true
                    });
                    refState.current = newState;
                    onScratch(newState);
                    return newState;
                });
            });
        };
        var onMouseMove = function(event) {
            onMoveEvent(event.pageX, event.pageY);
        };
        var onTouchMove = function(event) {
            onMoveEvent(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
        };
        var onMouseUp;
        var onTouchEnd;
        var stopScratching = function() {
            if (!refScratching.current) return;
            refScratching.current = false;
            refState.current = (0, _tslib.__assign)((0, _tslib.__assign)({}, refState.current), {
                isScratching: false
            });
            onScratchEnd(refState.current);
            setState({
                isScratching: false
            });
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('touchmove', onTouchMove);
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('touchend', onTouchEnd);
        };
        onMouseUp = stopScratching;
        onTouchEnd = stopScratching;
        var startScratching = function(docX, docY) {
            if (!refScratching.current) return;
            var _a = el.getBoundingClientRect(), left = _a.left, top = _a.top;
            var elX = left + window.scrollX;
            var elY = top + window.scrollY;
            var x = docX - elX;
            var y = docY - elY;
            var time = Date.now();
            var newState = {
                isScratching: true,
                start: time,
                end: time,
                docX: docX,
                docY: docY,
                x: x,
                y: y,
                dx: 0,
                dy: 0,
                elH: el.offsetHeight,
                elW: el.offsetWidth,
                elX: elX,
                elY: elY
            };
            refState.current = newState;
            onScratchStart(newState);
            setState(newState);
            window.addEventListener('mousemove', onMouseMove);
            window.addEventListener('touchmove', onTouchMove);
            window.addEventListener('mouseup', onMouseUp);
            window.addEventListener('touchend', onTouchEnd);
        };
        var onMouseDown = function(event) {
            refScratching.current = true;
            startScratching(event.pageX, event.pageY);
        };
        var onTouchStart = function(event) {
            refScratching.current = true;
            startScratching(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
        };
        el.addEventListener('mousedown', onMouseDown);
        el.addEventListener('touchstart', onTouchStart);
        return function() {
            el.removeEventListener('mousedown', onMouseDown);
            el.removeEventListener('touchstart', onTouchStart);
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('touchmove', onTouchMove);
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('touchend', onTouchEnd);
            if (refAnimationFrame.current) cancelAnimationFrame(refAnimationFrame.current);
            refAnimationFrame.current = null;
            refScratching.current = false;
            refState.current = {
                isScratching: false
            };
            setState(refState.current);
        };
    }, [
        el,
        disabled,
        onScratchStart,
        onScratch,
        onScratchEnd
    ]);
    return [
        setEl,
        state
    ];
};
var ScratchSensor = function(props) {
    var children = props.children, params = (0, _tslib.__rest)(props, [
        "children"
    ]);
    var _a = useScratch(params), ref = _a[0], state = _a[1];
    var element = (0, _reactUniversalInterface.render)(props, state);
    return (0, _react.cloneElement)(element, (0, _tslib.__assign)((0, _tslib.__assign)({}, element.props), {
        ref: function(el) {
            if (element.props.ref) {
                if (typeof element.props.ref === 'object') element.props.ref.current = el;
                if (typeof element.props.ref === 'function') element.props.ref(el);
            }
            ref(el);
        }
    }));
};
exports.default = useScratch;

},{"tslib":"b4wpY","react":"9njXz","react-universal-interface":"fxkJO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fxkJO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hookToRenderProp = exports.createEnhancer = exports.render = void 0;
var tslib_1 = require("53589c6ce77323f2");
var render_1 = tslib_1.__importDefault(require("17ad8051286585ac"));
exports.render = render_1.default;
var createEnhancer_1 = tslib_1.__importDefault(require("e035781c39dbed7d"));
exports.createEnhancer = createEnhancer_1.default;
var hookToRenderProp_1 = tslib_1.__importDefault(require("acf7fd5efd826976"));
exports.hookToRenderProp = hookToRenderProp_1.default;

},{"53589c6ce77323f2":"b4wpY","17ad8051286585ac":"c8y7S","e035781c39dbed7d":"18jKe","acf7fd5efd826976":"77NwE"}],"c8y7S":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("a2c687dd00f349fa");
var react_1 = require("4683a8e858f71d2d");
var isReact16Plus = parseInt(react_1.version.substr(0, react_1.version.indexOf('.'))) > 15;
var isFn = function(fn) {
    return typeof fn === 'function';
};
var render = function(props, data) {
    var more = [];
    for(var _i = 2; _i < arguments.length; _i++)more[_i - 2] = arguments[_i];
    var children_1, render_1;
    var render = props.render, _a = props.children, children = _a === void 0 ? render : _a, component = props.component, _b = props.comp, comp = _b === void 0 ? component : _b;
    if (isFn(children)) return children.apply(void 0, tslib_1.__spreadArrays([
        data
    ], more));
    if (comp) return react_1.createElement(comp, data);
    if (children instanceof Array) return isReact16Plus ? children : react_1.createElement.apply(void 0, tslib_1.__spreadArrays([
        'div',
        null
    ], children));
    if (children && children instanceof Object) {
        if (typeof children.type === 'string') return children;
        return react_1.cloneElement(children, Object.assign({}, children.props, data));
    }
    return children || null;
};
exports.default = render;

},{"a2c687dd00f349fa":"b4wpY","4683a8e858f71d2d":"9njXz"}],"18jKe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.divWrapper = void 0;
var tslib_1 = require("97d8e27b7c2f4b0d");
var React = tslib_1.__importStar(require("5670243472b0a826"));
var addClassDecoratorSupport_1 = tslib_1.__importDefault(require("65c75cd60a22751a"));
var h = React.createElement;
var noWrap = function(Comp, propName, props, state) {
    var _a;
    return h(Comp, propName ? tslib_1.__assign((_a = {}, _a[propName] = state, _a), props) : tslib_1.__assign(tslib_1.__assign({}, state), props));
};
exports.divWrapper = function(Comp, propName, props, state) {
    return h('div', null, noWrap(Comp, propName, props, state));
};
var createEnhancer = function(Facc, prop, wrapper) {
    if (wrapper === void 0) wrapper = noWrap;
    var enhancer = function(Comp, propName, faccProps) {
        if (propName === void 0) propName = prop;
        if (faccProps === void 0) faccProps = null;
        var isClassDecoratorMethodCall = typeof Comp === 'string';
        if (isClassDecoratorMethodCall) return function(Klass) {
            return enhancer(Klass, Comp || prop, propName);
        };
        var Enhanced = function(props) {
            return h(Facc, faccProps, function(state) {
                return wrapper(Comp, propName, props, state);
            });
        };
        return isClassDecoratorMethodCall ? addClassDecoratorSupport_1.default(Enhanced) : Enhanced;
    };
    return enhancer;
};
exports.default = createEnhancer;

},{"97d8e27b7c2f4b0d":"b4wpY","5670243472b0a826":"9njXz","65c75cd60a22751a":"5M9YK"}],"5M9YK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("a67af63adc0e4788");
var wrapInStatefulComponent_1 = tslib_1.__importDefault(require("8e8238156e25e3b3"));
var addClassDecoratorSupport = function(Comp) {
    var isSFC = !Comp.prototype;
    return !isSFC ? Comp : wrapInStatefulComponent_1.default(Comp);
};
exports.default = addClassDecoratorSupport;

},{"a67af63adc0e4788":"b4wpY","8e8238156e25e3b3":"zmyxI"}],"zmyxI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("a25b6fb755f4bbdb");
var React = tslib_1.__importStar(require("7b150fb504dd330b"));
var wrapInStatefulComponent = function(Comp) {
    var Decorated = function(_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function() {
            return Comp(this.props, this.context);
        };
        return class_1;
    }(React.Component);
    return Decorated;
};
exports.default = wrapInStatefulComponent;

},{"a25b6fb755f4bbdb":"b4wpY","7b150fb504dd330b":"9njXz"}],"77NwE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var tslib_1 = require("345086361459a4cb");
var render_1 = tslib_1.__importDefault(require("fd7b058df8df4dde"));
var defaultMapPropsToArgs = function(props) {
    return [
        props
    ];
};
var hookToRenderProp = function(hook, mapPropsToArgs) {
    if (mapPropsToArgs === void 0) mapPropsToArgs = defaultMapPropsToArgs;
    return function(props) {
        return render_1.default(props, hook.apply(void 0, mapPropsToArgs(props)));
    };
};
exports.default = hookToRenderProp;

},{"345086361459a4cb":"b4wpY","fd7b058df8df4dde":"c8y7S"}],"4HZqS":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useRafState = require("./useRafState");
var _useRafStateDefault = parcelHelpers.interopDefault(_useRafState);
var useScroll = function(ref) {
    var _a = (0, _useRafStateDefault.default)({
        x: 0,
        y: 0
    }), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var handler = function() {
            if (ref.current) setState({
                x: ref.current.scrollLeft,
                y: ref.current.scrollTop
            });
        };
        if (ref.current) ref.current.addEventListener('scroll', handler, {
            capture: false,
            passive: true
        });
        return function() {
            if (ref.current) ref.current.removeEventListener('scroll', handler);
        };
    }, [
        ref
    ]);
    return state;
};
exports.default = useScroll;

},{"react":"9njXz","./useRafState":"k3hEp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kV0Fj":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useScrolling = function(ref) {
    var _a = (0, _react.useState)(false), scrolling = _a[0], setScrolling = _a[1];
    (0, _react.useEffect)(function() {
        if (ref.current) {
            var scrollingTimeout_1;
            var handleScrollEnd_1 = function() {
                setScrolling(false);
            };
            var handleScroll_1 = function() {
                setScrolling(true);
                clearTimeout(scrollingTimeout_1);
                scrollingTimeout_1 = setTimeout(function() {
                    return handleScrollEnd_1();
                }, 150);
            };
            ref.current.addEventListener('scroll', handleScroll_1, false);
            return function() {
                if (ref.current) ref.current.removeEventListener('scroll', handleScroll_1, false);
            };
        }
        return function() {};
    }, [
        ref
    ]);
    return scrolling;
};
exports.default = useScrolling;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"21KMe":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var useSessionStorage = function(key, initialValue, raw) {
    if (!(0, _util.isClient)) return [
        initialValue,
        function() {}
    ];
    var _a = (0, _react.useState)(function() {
        try {
            var sessionStorageValue = sessionStorage.getItem(key);
            if (typeof sessionStorageValue !== 'string') {
                sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
                return initialValue;
            } else return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
        } catch (_a) {
            // If user is in private mode or has storage restriction
            // sessionStorage can throw. JSON.parse and JSON.stringify
            // cat throw, too.
            return initialValue;
        }
    }), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        try {
            var serializedState = raw ? String(state) : JSON.stringify(state);
            sessionStorage.setItem(key, serializedState);
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // sessionStorage can throw. Also JSON.stringify can throw.
        }
    });
    return [
        state,
        setState
    ];
};
exports.default = useSessionStorage;

},{"react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"goOMR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fastShallowEqual = require("fast-shallow-equal");
var _useCustomCompareEffect = require("./useCustomCompareEffect");
var _useCustomCompareEffectDefault = parcelHelpers.interopDefault(_useCustomCompareEffect);
var isPrimitive = function(val) {
    return val !== Object(val);
};
var shallowEqualDepsList = function(prevDeps, nextDeps) {
    return prevDeps.every(function(dep, index) {
        return (0, _fastShallowEqual.equal)(dep, nextDeps[index]);
    });
};
var useShallowCompareEffect = function(effect, deps) {
    (0, _useCustomCompareEffectDefault.default)(effect, deps, shallowEqualDepsList);
};
exports.default = useShallowCompareEffect;

},{"fast-shallow-equal":"4Cgxn","./useCustomCompareEffect":"2rnbE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4Cgxn":[function(require,module,exports,__globalThis) {
var keyList = Object.keys;
exports.equal = function equal(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    var keys = keyList(a);
    var length = keys.length;
    for(var i = 0; i < length; i++)if (!(keys[i] in b)) return false;
    for(var i = 0; i < length; i++)if (a[keys[i]] !== b[keys[i]]) return false;
    return length === keyList(b).length;
};

},{}],"3kbw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var _util = require("./util");
var useState = _react.useState, useEffect = _react.useEffect, useRef = _react.useRef;
var DRAF = function(callback) {
    return setTimeout(callback, 35);
};
var useSize = function(element, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.width, width = _c === void 0 ? Infinity : _c, _d = _b.height, height = _d === void 0 ? Infinity : _d;
    if (!(0, _util.isClient)) return [
        typeof element === 'function' ? element({
            width: width,
            height: height
        }) : element,
        {
            width: width,
            height: height
        }
    ];
    var _e = useState({
        width: width,
        height: height
    }), state = _e[0], setState = _e[1];
    if (typeof element === 'function') element = element(state);
    var style = element.props.style || {};
    var ref = useRef(null);
    var window = null;
    var setSize = function() {
        var iframe = ref.current;
        var size = iframe ? {
            width: iframe.offsetWidth,
            height: iframe.offsetHeight
        } : {
            width: width,
            height: height
        };
        setState(size);
    };
    var onWindow = function(windowToListenOn) {
        windowToListenOn.addEventListener('resize', setSize);
        DRAF(setSize);
    };
    useEffect(function() {
        var iframe = ref.current;
        if (!iframe) // iframe will be undefined if component is already unmounted
        return;
        if (iframe.contentWindow) {
            window = iframe.contentWindow;
            onWindow(window);
        } else {
            var onLoad_1 = function() {
                iframe.removeEventListener('load', onLoad_1);
                window = iframe.contentWindow;
                onWindow(window);
            };
            iframe.addEventListener('load', onLoad_1);
        }
        return function() {
            if (window && window.removeEventListener) window.removeEventListener('resize', setSize);
        };
    }, []);
    style.position = 'relative';
    var sized = _react.cloneElement.apply(_react, (0, _tslib.__spreadArrays)([
        element,
        {
            style: style
        }
    ], (0, _tslib.__spreadArrays)([
        _react.createElement('iframe', {
            ref: ref,
            style: {
                background: 'transparent',
                border: 'none',
                height: '100%',
                left: 0,
                position: 'absolute',
                top: 0,
                width: '100%',
                zIndex: -1
            }
        })
    ], _react.Children.toArray(element.props.children))));
    return [
        sized,
        state
    ];
};
exports.default = useSize;

},{"tslib":"b4wpY","react":"9njXz","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uYT7":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
var _useSetState = require("./useSetState");
var _useSetStateDefault = parcelHelpers.interopDefault(_useSetState);
var noop = function() {};
var useSlider = function(ref, options) {
    if (options === void 0) options = {};
    var isMounted = (0, _useMountedStateDefault.default)();
    var isSliding = (0, _react.useRef)(false);
    var valueRef = (0, _react.useRef)(0);
    var frame = (0, _react.useRef)(0);
    var _a = (0, _useSetStateDefault.default)({
        isSliding: false,
        value: 0
    }), state = _a[0], setState = _a[1];
    valueRef.current = state.value;
    (0, _react.useEffect)(function() {
        if (0, _util.isClient) {
            var styles = options.styles === undefined ? true : options.styles;
            var reverse_1 = options.reverse === undefined ? false : options.reverse;
            if (ref.current && styles) ref.current.style.userSelect = 'none';
            var startScrubbing_1 = function() {
                if (!isSliding.current && isMounted()) {
                    (options.onScrubStart || noop)();
                    isSliding.current = true;
                    setState({
                        isSliding: true
                    });
                    bindEvents_1();
                }
            };
            var stopScrubbing_1 = function() {
                if (isSliding.current && isMounted()) {
                    (options.onScrubStop || noop)(valueRef.current);
                    isSliding.current = false;
                    setState({
                        isSliding: false
                    });
                    unbindEvents_1();
                }
            };
            var onMouseDown_1 = function(event) {
                startScrubbing_1();
                onMouseMove_1(event);
            };
            var onMouseMove_1 = options.vertical ? function(event) {
                return onScrub_1(event.clientY);
            } : function(event) {
                return onScrub_1(event.clientX);
            };
            var onTouchStart_1 = function(event) {
                startScrubbing_1();
                onTouchMove_1(event);
            };
            var onTouchMove_1 = options.vertical ? function(event) {
                return onScrub_1(event.changedTouches[0].clientY);
            } : function(event) {
                return onScrub_1(event.changedTouches[0].clientX);
            };
            var bindEvents_1 = function() {
                (0, _util.on)(document, 'mousemove', onMouseMove_1);
                (0, _util.on)(document, 'mouseup', stopScrubbing_1);
                (0, _util.on)(document, 'touchmove', onTouchMove_1);
                (0, _util.on)(document, 'touchend', stopScrubbing_1);
            };
            var unbindEvents_1 = function() {
                (0, _util.off)(document, 'mousemove', onMouseMove_1);
                (0, _util.off)(document, 'mouseup', stopScrubbing_1);
                (0, _util.off)(document, 'touchmove', onTouchMove_1);
                (0, _util.off)(document, 'touchend', stopScrubbing_1);
            };
            var onScrub_1 = function(clientXY) {
                cancelAnimationFrame(frame.current);
                frame.current = requestAnimationFrame(function() {
                    if (isMounted() && ref.current) {
                        var rect = ref.current.getBoundingClientRect();
                        var pos = options.vertical ? rect.top : rect.left;
                        var length_1 = options.vertical ? rect.height : rect.width;
                        // Prevent returning 0 when element is hidden by CSS
                        if (!length_1) return;
                        var value = (clientXY - pos) / length_1;
                        if (value > 1) value = 1;
                        else if (value < 0) value = 0;
                        if (reverse_1) value = 1 - value;
                        setState({
                            value: value
                        });
                        (options.onScrub || noop)(value);
                    }
                });
            };
            (0, _util.on)(ref.current, 'mousedown', onMouseDown_1);
            (0, _util.on)(ref.current, 'touchstart', onTouchStart_1);
            return function() {
                (0, _util.off)(ref.current, 'mousedown', onMouseDown_1);
                (0, _util.off)(ref.current, 'touchstart', onTouchStart_1);
            };
        } else return undefined;
    }, [
        ref,
        options.vertical
    ]);
    return state;
};
exports.default = useSlider;

},{"react":"9njXz","./util":"hB491","./useMountedState":"8WCZ5","./useSetState":"5uBBR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6l37s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useMount = require("./useMount");
var _useMountDefault = parcelHelpers.interopDefault(_useMount);
var _useSetState = require("./useSetState");
var _useSetStateDefault = parcelHelpers.interopDefault(_useSetState);
var voices = typeof window === 'object' && typeof window.speechSynthesis === 'object' ? window.speechSynthesis.getVoices() : [];
var useSpeech = function(text, opts) {
    if (opts === void 0) opts = {};
    var _a = (0, _useSetStateDefault.default)({
        isPlaying: false,
        lang: opts.lang || 'default',
        voice: opts.voice || voices[0],
        rate: opts.rate || 1,
        pitch: opts.pitch || 1,
        volume: opts.volume || 1
    }), state = _a[0], setState = _a[1];
    var uterranceRef = (0, _react.useRef)(null);
    (0, _useMountDefault.default)(function() {
        var utterance = new SpeechSynthesisUtterance(text);
        opts.lang && (utterance.lang = opts.lang);
        opts.voice && (utterance.voice = opts.voice);
        utterance.rate = opts.rate || 1;
        utterance.pitch = opts.pitch || 1;
        utterance.volume = opts.volume || 1;
        utterance.onstart = function() {
            return setState({
                isPlaying: true
            });
        };
        utterance.onresume = function() {
            return setState({
                isPlaying: true
            });
        };
        utterance.onend = function() {
            return setState({
                isPlaying: false
            });
        };
        utterance.onpause = function() {
            return setState({
                isPlaying: false
            });
        };
        uterranceRef.current = utterance;
        window.speechSynthesis.speak(uterranceRef.current);
    });
    return state;
};
exports.default = useSpeech;

},{"react":"9njXz","./useMount":"4EVfq","./useSetState":"5uBBR","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"g4x4l":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var isFocusedElementEditable = function() {
    var activeElement = document.activeElement, body = document.body;
    if (!activeElement) return false;
    // If not element has focus, we assume it is not editable, too.
    if (activeElement === body) return false;
    // Assume <input> and <textarea> elements are editable.
    switch(activeElement.tagName){
        case 'INPUT':
        case 'TEXTAREA':
            return true;
    }
    // Check if any other focused element id editable.
    return activeElement.hasAttribute('contenteditable');
};
var isTypedCharGood = function(_a) {
    var keyCode = _a.keyCode, metaKey = _a.metaKey, ctrlKey = _a.ctrlKey, altKey = _a.altKey;
    if (metaKey || ctrlKey || altKey) return false;
    // 0...9
    if (keyCode >= 48 && keyCode <= 57) return true;
    // a...z
    if (keyCode >= 65 && keyCode <= 90) return true;
    // All other keys.
    return false;
};
var useStartTyping = function(onStartTyping) {
    (0, _react.useLayoutEffect)(function() {
        var keydown = function(event) {
            !isFocusedElementEditable() && isTypedCharGood(event) && onStartTyping(event);
        };
        document.addEventListener('keydown', keydown);
        return function() {
            document.removeEventListener('keydown', keydown);
        };
    }, []);
};
exports.default = useStartTyping;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"14FFh":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStateWithHistory", ()=>useStateWithHistory);
var _react = require("react");
var _useFirstMountState = require("./useFirstMountState");
var _resolveHookState = require("./util/resolveHookState");
function useStateWithHistory(initialState, capacity, initialHistory) {
    if (capacity === void 0) capacity = 10;
    if (capacity < 1) throw new Error("Capacity has to be greater than 1, got '" + capacity + "'");
    var isFirstMount = (0, _useFirstMountState.useFirstMountState)();
    var _a = (0, _react.useState)(initialState), state = _a[0], innerSetState = _a[1];
    var history = (0, _react.useRef)(initialHistory !== null && initialHistory !== void 0 ? initialHistory : []);
    var historyPosition = (0, _react.useRef)(0);
    // do the states manipulation only on first mount, no sense to load re-renders with useless calculations
    if (isFirstMount) {
        if (history.current.length) {
            // if last element of history !== initial - push initial to history
            if (history.current[history.current.length - 1] !== initialState) history.current.push(initialState);
            // if initial history bigger that capacity - crop the first elements out
            if (history.current.length > capacity) history.current = history.current.slice(history.current.length - capacity);
        } else // initiate the history with initial state
        history.current.push(initialState);
        historyPosition.current = history.current.length && history.current.length - 1;
    }
    var setState = (0, _react.useCallback)(function(newState) {
        innerSetState(function(currentState) {
            newState = (0, _resolveHookState.resolveHookState)(newState);
            // is state has changed
            if (newState !== currentState) {
                // if current position is not the last - pop element to the right
                if (historyPosition.current < history.current.length - 1) history.current = history.current.slice(0, historyPosition.current + 1);
                historyPosition.current = history.current.push(newState) - 1;
                // if capacity is reached - shift first elements
                if (history.current.length > capacity) history.current = history.current.slice(history.current.length - capacity);
            }
            return newState;
        });
    }, [
        state,
        capacity
    ]);
    var historyState = (0, _react.useMemo)(function() {
        return {
            history: history.current,
            position: historyPosition.current,
            capacity: capacity,
            back: function(amount) {
                if (amount === void 0) amount = 1;
                // don't do anything if we already at the left border
                if (!historyPosition.current) return;
                innerSetState(function() {
                    historyPosition.current -= Math.min(amount, historyPosition.current);
                    return history.current[historyPosition.current];
                });
            },
            forward: function(amount) {
                if (amount === void 0) amount = 1;
                // don't do anything if we already at the right border
                if (historyPosition.current === history.current.length - 1) return;
                innerSetState(function() {
                    historyPosition.current = Math.min(historyPosition.current + amount, history.current.length - 1);
                    return history.current[historyPosition.current];
                });
            },
            go: function(position) {
                if (position === historyPosition.current) return;
                innerSetState(function() {
                    historyPosition.current = position < 0 ? Math.max(history.current.length + position, 0) : Math.min(history.current.length - 1, position);
                    return history.current[historyPosition.current];
                });
            }
        };
    }, [
        state
    ]);
    return [
        state,
        setState,
        historyState
    ];
}

},{"react":"9njXz","./useFirstMountState":"6yQkq","./util/resolveHookState":"mTVHM","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"55rWJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStateList);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var _useMountedState = require("./useMountedState");
var _useMountedStateDefault = parcelHelpers.interopDefault(_useMountedState);
var _useUpdate = require("./useUpdate");
var _useUpdateDefault = parcelHelpers.interopDefault(_useUpdate);
var _useUpdateEffect = require("./useUpdateEffect");
var _useUpdateEffectDefault = parcelHelpers.interopDefault(_useUpdateEffect);
function useStateList(stateSet) {
    if (stateSet === void 0) stateSet = [];
    var isMounted = (0, _useMountedStateDefault.default)();
    var update = (0, _useUpdateDefault.default)();
    var index = (0, _react.useRef)(0);
    // If new state list is shorter that before - switch to the last element
    (0, _useUpdateEffectDefault.default)(function() {
        if (stateSet.length <= index.current) {
            index.current = stateSet.length - 1;
            update();
        }
    }, [
        stateSet.length
    ]);
    var actions = (0, _react.useMemo)(function() {
        return {
            next: function() {
                return actions.setStateAt(index.current + 1);
            },
            prev: function() {
                return actions.setStateAt(index.current - 1);
            },
            setStateAt: function(newIndex) {
                // do nothing on unmounted component
                if (!isMounted()) return;
                // do nothing on empty states list
                if (!stateSet.length) return;
                // in case new index is equal current - do nothing
                if (newIndex === index.current) return;
                // it gives the ability to travel through the left and right borders.
                // 4ex: if list contains 5 elements, attempt to set index 9 will bring use to 5th element
                // in case of negative index it will start counting from the right, so -17 will bring us to 4th element
                index.current = newIndex >= 0 ? newIndex % stateSet.length : stateSet.length + newIndex % stateSet.length;
                update();
            },
            setState: function(state) {
                // do nothing on unmounted component
                if (!isMounted()) return;
                var newIndex = stateSet.length ? stateSet.indexOf(state) : -1;
                if (newIndex === -1) throw new Error("State '" + state + "' is not a valid state (does not exist in state list)");
                index.current = newIndex;
                update();
            }
        };
    }, [
        stateSet
    ]);
    return (0, _tslib.__assign)({
        state: stateSet[index.current],
        currentIndex: index.current
    }, actions);
}

},{"tslib":"b4wpY","react":"9njXz","./useMountedState":"8WCZ5","./useUpdate":"g3F6e","./useUpdateEffect":"f7d80","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hx80t":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useUnmount = require("./useUnmount");
var _useUnmountDefault = parcelHelpers.interopDefault(_useUnmount);
var useThrottle = function(value, ms) {
    if (ms === void 0) ms = 200;
    var _a = (0, _react.useState)(value), state = _a[0], setState = _a[1];
    var timeout = (0, _react.useRef)();
    var nextValue = (0, _react.useRef)(null);
    var hasNextValue = (0, _react.useRef)(0);
    (0, _react.useEffect)(function() {
        if (!timeout.current) {
            setState(value);
            var timeoutCallback_1 = function() {
                if (hasNextValue.current) {
                    hasNextValue.current = false;
                    setState(nextValue.current);
                    timeout.current = setTimeout(timeoutCallback_1, ms);
                } else timeout.current = undefined;
            };
            timeout.current = setTimeout(timeoutCallback_1, ms);
        } else {
            nextValue.current = value;
            hasNextValue.current = true;
        }
    }, [
        value
    ]);
    (0, _useUnmountDefault.default)(function() {
        timeout.current && clearTimeout(timeout.current);
    });
    return state;
};
exports.default = useThrottle;

},{"react":"9njXz","./useUnmount":"7LKP4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gAAPH":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useUnmount = require("./useUnmount");
var _useUnmountDefault = parcelHelpers.interopDefault(_useUnmount);
var useThrottleFn = function(fn, ms, args) {
    if (ms === void 0) ms = 200;
    var _a = (0, _react.useState)(null), state = _a[0], setState = _a[1];
    var timeout = (0, _react.useRef)();
    var nextArgs = (0, _react.useRef)();
    (0, _react.useEffect)(function() {
        if (!timeout.current) {
            setState(fn.apply(void 0, args));
            var timeoutCallback_1 = function() {
                if (nextArgs.current) {
                    setState(fn.apply(void 0, nextArgs.current));
                    nextArgs.current = undefined;
                    timeout.current = setTimeout(timeoutCallback_1, ms);
                } else timeout.current = undefined;
            };
            timeout.current = setTimeout(timeoutCallback_1, ms);
        } else nextArgs.current = args;
    }, args);
    (0, _useUnmountDefault.default)(function() {
        timeout.current && clearTimeout(timeout.current);
    });
    return state;
};
exports.default = useThrottleFn;

},{"react":"9njXz","./useUnmount":"7LKP4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gH5FZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTimeout);
var _useTimeoutFn = require("./useTimeoutFn");
var _useTimeoutFnDefault = parcelHelpers.interopDefault(_useTimeoutFn);
var _useUpdate = require("./useUpdate");
var _useUpdateDefault = parcelHelpers.interopDefault(_useUpdate);
function useTimeout(ms) {
    if (ms === void 0) ms = 0;
    var update = (0, _useUpdateDefault.default)();
    return (0, _useTimeoutFnDefault.default)(update, ms);
}

},{"./useTimeoutFn":"55Xtg","./useUpdate":"g3F6e","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eVfZQ":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var DEFAULT_USE_TITLE_OPTIONS = {
    restoreOnUnmount: false
};
function useTitle(title, options) {
    if (options === void 0) options = DEFAULT_USE_TITLE_OPTIONS;
    var prevTitleRef = (0, _react.useRef)(document.title);
    document.title = title;
    (0, _react.useEffect)(function() {
        if (options && options.restoreOnUnmount) return function() {
            document.title = prevTitleRef.current;
        };
        else return;
    }, []);
}
exports.default = typeof document !== 'undefined' ? useTitle : function(_title) {};

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"axPFO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tsEasing = require("ts-easing");
var _useRaf = require("./useRaf");
var _useRafDefault = parcelHelpers.interopDefault(_useRaf);
var useTween = function(easingName, ms, delay) {
    if (easingName === void 0) easingName = 'inCirc';
    if (ms === void 0) ms = 200;
    if (delay === void 0) delay = 0;
    var fn = (0, _tsEasing.easing)[easingName];
    var t = (0, _useRafDefault.default)(ms, delay);
    return fn(t);
};
exports.default = useTween;

},{"ts-easing":"13VIv","./useRaf":"1z7RK","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"13VIv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.easing = {
    // No easing, no acceleration
    linear: function(t) {
        return t;
    },
    // Accelerates fast, then slows quickly towards end.
    quadratic: function(t) {
        return t * (-(t * t) * t + 4 * t * t - 6 * t + 4);
    },
    // Overshoots over 1 and then returns to 1 towards end.
    cubic: function(t) {
        return t * (4 * t * t - 9 * t + 6);
    },
    // Overshoots over 1 multiple times - wiggles around 1.
    elastic: function(t) {
        return t * (33 * t * t * t * t - 106 * t * t * t + 126 * t * t - 67 * t + 15);
    },
    // Accelerating from zero velocity
    inQuad: function(t) {
        return t * t;
    },
    // Decelerating to zero velocity
    outQuad: function(t) {
        return t * (2 - t);
    },
    // Acceleration until halfway, then deceleration
    inOutQuad: function(t) {
        return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    // Accelerating from zero velocity
    inCubic: function(t) {
        return t * t * t;
    },
    // Decelerating to zero velocity
    outCubic: function(t) {
        return --t * t * t + 1;
    },
    // Acceleration until halfway, then deceleration
    inOutCubic: function(t) {
        return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    // Accelerating from zero velocity
    inQuart: function(t) {
        return t * t * t * t;
    },
    // Decelerating to zero velocity
    outQuart: function(t) {
        return 1 - --t * t * t * t;
    },
    // Acceleration until halfway, then deceleration
    inOutQuart: function(t) {
        return t < .5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    // Accelerating from zero velocity
    inQuint: function(t) {
        return t * t * t * t * t;
    },
    // Decelerating to zero velocity
    outQuint: function(t) {
        return 1 + --t * t * t * t * t;
    },
    // Acceleration until halfway, then deceleration
    inOutQuint: function(t) {
        return t < .5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
    // Accelerating from zero velocity
    inSine: function(t) {
        return -Math.cos(t * (Math.PI / 2)) + 1;
    },
    // Decelerating to zero velocity
    outSine: function(t) {
        return Math.sin(t * (Math.PI / 2));
    },
    // Accelerating until halfway, then decelerating
    inOutSine: function(t) {
        return -(Math.cos(Math.PI * t) - 1) / 2;
    },
    // Exponential accelerating from zero velocity
    inExpo: function(t) {
        return Math.pow(2, 10 * (t - 1));
    },
    // Exponential decelerating to zero velocity
    outExpo: function(t) {
        return -Math.pow(2, -10 * t) + 1;
    },
    // Exponential accelerating until halfway, then decelerating
    inOutExpo: function(t) {
        t /= .5;
        if (t < 1) return Math.pow(2, 10 * (t - 1)) / 2;
        t--;
        return (-Math.pow(2, -10 * t) + 2) / 2;
    },
    // Circular accelerating from zero velocity
    inCirc: function(t) {
        return -Math.sqrt(1 - t * t) + 1;
    },
    // Circular decelerating to zero velocity Moves VERY fast at the beginning and
    // then quickly slows down in the middle. This tween can actually be used
    // in continuous transitions where target value changes all the time,
    // because of the very quick start, it hides the jitter between target value changes.
    outCirc: function(t) {
        return Math.sqrt(1 - (t = t - 1) * t);
    },
    // Circular acceleration until halfway, then deceleration
    inOutCirc: function(t) {
        t /= .5;
        if (t < 1) return -(Math.sqrt(1 - t * t) - 1) / 2;
        t -= 2;
        return (Math.sqrt(1 - t * t) + 1) / 2;
    }
};

},{}],"lWrWj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var useUnmountPromise = function() {
    var refUnmounted = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        return function() {
            refUnmounted.current = true;
        };
    });
    var wrapper = (0, _react.useMemo)(function() {
        var race = function(promise, onError) {
            var newPromise = new Promise(function(resolve, reject) {
                promise.then(function(result) {
                    if (!refUnmounted.current) resolve(result);
                }, function(error) {
                    if (!refUnmounted.current) reject(error);
                    else if (onError) onError(error);
                    else console.error('useUnmountPromise', error);
                });
            });
            return newPromise;
        };
        return race;
    }, []);
    return wrapper;
};
exports.default = useUnmountPromise;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"hHGXx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useUpsert);
var _tslib = require("tslib");
var _useList = require("./useList");
var _useListDefault = parcelHelpers.interopDefault(_useList);
function useUpsert(predicate, initialList) {
    if (initialList === void 0) initialList = [];
    var _a = (0, _useListDefault.default)(initialList), list = _a[0], listActions = _a[1];
    return [
        list,
        (0, _tslib.__assign)((0, _tslib.__assign)({}, listActions), {
            upsert: function(newItem) {
                listActions.upsert(predicate, newItem);
            }
        })
    ];
}

},{"tslib":"b4wpY","./useList":"hREI3","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6I3c8":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var isVibrationApiSupported = typeof navigator === 'object' && 'vibrate' in navigator;
var useVibrateMock = function() {};
function useVibrate(enabled, pattern, loop) {
    if (enabled === void 0) enabled = true;
    if (pattern === void 0) pattern = [
        1000,
        1000
    ];
    if (loop === void 0) loop = true;
    (0, _react.useEffect)(function() {
        var interval;
        if (enabled) {
            navigator.vibrate(pattern);
            if (loop) {
                var duration = pattern instanceof Array ? pattern.reduce(function(a, b) {
                    return a + b;
                }) : pattern;
                interval = setInterval(function() {
                    navigator.vibrate(pattern);
                }, duration);
            }
        }
        return function() {
            if (enabled) {
                navigator.vibrate(0);
                if (loop) clearInterval(interval);
            }
        };
    }, [
        enabled
    ]);
}
exports.default = isVibrationApiSupported ? useVibrate : useVibrateMock;

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4ls3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createHTMLMediaHook = require("./util/createHTMLMediaHook");
var _createHTMLMediaHookDefault = parcelHelpers.interopDefault(_createHTMLMediaHook);
var useVideo = (0, _createHTMLMediaHookDefault.default)('video');
exports.default = useVideo;

},{"./util/createHTMLMediaHook":"kP2VX","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5hzbd":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStateValidator);
var _react = require("react");
function useStateValidator(state, validator, initialState) {
    if (initialState === void 0) initialState = [
        undefined
    ];
    var validatorInner = (0, _react.useRef)(validator);
    var stateInner = (0, _react.useRef)(state);
    validatorInner.current = validator;
    stateInner.current = state;
    var _a = (0, _react.useState)(initialState), validity = _a[0], setValidity = _a[1];
    var validate = (0, _react.useCallback)(function() {
        if (validatorInner.current.length >= 2) validatorInner.current(stateInner.current, setValidity);
        else setValidity(validatorInner.current(stateInner.current));
    }, [
        setValidity
    ]);
    (0, _react.useEffect)(function() {
        validate();
    }, [
        state
    ]);
    return [
        validity,
        validate
    ];
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"58M53":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollbarWidth", ()=>useScrollbarWidth);
var _scrollbarWidth = require("@xobotyi/scrollbar-width");
var _react = require("react");
function useScrollbarWidth() {
    var _a = (0, _react.useState)((0, _scrollbarWidth.scrollbarWidth)()), sbw = _a[0], setSbw = _a[1];
    // this needed to ensure the scrollbar width in case hook called before the DOM is ready
    (0, _react.useEffect)(function() {
        if (typeof sbw !== 'undefined') return;
        var raf = requestAnimationFrame(function() {
            setSbw((0, _scrollbarWidth.scrollbarWidth)());
        });
        return function() {
            return cancelAnimationFrame(raf);
        };
    }, []);
    return sbw;
}

},{"@xobotyi/scrollbar-width":"1ZBB6","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1ZBB6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrollbarWidth", ()=>e);
var e = function(t) {
    if ("undefined" == typeof document) return 0;
    if (document.body && (!document.readyState || "loading" !== document.readyState)) {
        if (!0 !== t && "number" == typeof e.__cache) return e.__cache;
        var o = document.createElement("div"), d = o.style;
        d.display = "block", d.position = "absolute", d.width = "100px", d.height = "100px", d.left = "-999px", d.top = "-999px", d.overflow = "scroll", document.body.insertBefore(o, null);
        var n = o.clientWidth;
        if (0 !== n) return e.__cache = 100 - n, document.body.removeChild(o), e.__cache;
        document.body.removeChild(o);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3bzGJ":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMultiStateValidator", ()=>useMultiStateValidator);
var _react = require("react");
function useMultiStateValidator(states, validator, initialValidity) {
    if (initialValidity === void 0) initialValidity = [
        undefined
    ];
    if (typeof states !== 'object') throw new Error('states expected to be an object or array, got ' + typeof states);
    var validatorInner = (0, _react.useRef)(validator);
    var statesInner = (0, _react.useRef)(states);
    validatorInner.current = validator;
    statesInner.current = states;
    var _a = (0, _react.useState)(initialValidity), validity = _a[0], setValidity = _a[1];
    var validate = (0, _react.useCallback)(function() {
        if (validatorInner.current.length >= 2) validatorInner.current(statesInner.current, setValidity);
        else setValidity(validatorInner.current(statesInner.current));
    }, [
        setValidity
    ]);
    (0, _react.useEffect)(function() {
        validate();
    }, Object.values(states));
    return [
        validity,
        validate
    ];
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3jkCa":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("./util");
var _useRafState = require("./useRafState");
var _useRafStateDefault = parcelHelpers.interopDefault(_useRafState);
var useWindowScroll = function() {
    var _a = (0, _useRafStateDefault.default)({
        x: (0, _util.isClient) ? window.pageXOffset : 0,
        y: (0, _util.isClient) ? window.pageYOffset : 0
    }), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        var handler = function() {
            setState({
                x: window.pageXOffset,
                y: window.pageYOffset
            });
        };
        window.addEventListener('scroll', handler, {
            capture: false,
            passive: true
        });
        return function() {
            window.removeEventListener('scroll', handler);
        };
    }, []);
    return state;
};
exports.default = useWindowScroll;

},{"react":"9njXz","./util":"hB491","./useRafState":"k3hEp","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"902mx":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useRafState = require("./useRafState");
var _useRafStateDefault = parcelHelpers.interopDefault(_useRafState);
var _util = require("./util");
var useWindowSize = function(initialWidth, initialHeight) {
    if (initialWidth === void 0) initialWidth = Infinity;
    if (initialHeight === void 0) initialHeight = Infinity;
    var _a = (0, _useRafStateDefault.default)({
        width: (0, _util.isClient) ? window.innerWidth : initialWidth,
        height: (0, _util.isClient) ? window.innerHeight : initialHeight
    }), state = _a[0], setState = _a[1];
    (0, _react.useEffect)(function() {
        if (0, _util.isClient) {
            var handler_1 = function() {
                setState({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            window.addEventListener('resize', handler_1);
            return function() {
                window.removeEventListener('resize', handler_1);
            };
        }
    }, []);
    return state;
};
exports.default = useWindowSize;

},{"react":"9njXz","./useRafState":"k3hEp","./util":"hB491","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3kBMN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _resizeObserverPolyfill = require("resize-observer-polyfill");
var _resizeObserverPolyfillDefault = parcelHelpers.interopDefault(_resizeObserverPolyfill);
var useMeasure = function() {
    var _a = (0, _react.useState)({
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    }), rect = _a[0], set = _a[1];
    var observer = (0, _react.useState)(function() {
        return new (0, _resizeObserverPolyfillDefault.default)(function(entries) {
            var entry = entries[0];
            if (entry) set(entry.contentRect);
        });
    })[0];
    var ref = (0, _react.useCallback)(function(node) {
        observer.disconnect();
        if (node) observer.observe(node);
    }, [
        observer
    ]);
    return [
        ref,
        rect
    ];
};
exports.default = useMeasure;

},{"react":"9njXz","resize-observer-polyfill":"69ukd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"69ukd":[function(require,module,exports,__globalThis) {
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var global = arguments[3];
var MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var global$1 = function() {
    if (typeof global !== 'undefined' && global.Math === Math) return global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind(global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};
// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return emptyRect;
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function getContentRect(target) {
    if (!isBrowser) return emptyRect;
    if (isSVGGraphicsElement(target)) return getSVGContentRect(target);
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});
var index = function() {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') return global$1.ResizeObserver;
    return ResizeObserver;
}();
exports.default = index;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"audQz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRendersCount", ()=>useRendersCount);
var _react = require("react");
function useRendersCount() {
    return ++(0, _react.useRef)(0).current;
}

},{"react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"59tH5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tslib = require("tslib");
/* eslint-disable */ var _react = require("react");
var useSet = function(initialSet) {
    if (initialSet === void 0) initialSet = new Set();
    var _a = (0, _react.useState)(initialSet), set = _a[0], setSet = _a[1];
    var stableActions = (0, _react.useMemo)(function() {
        var add = function(item) {
            return setSet(function(prevSet) {
                return new Set((0, _tslib.__spreadArrays)(Array.from(prevSet), [
                    item
                ]));
            });
        };
        var remove = function(item) {
            return setSet(function(prevSet) {
                return new Set(Array.from(prevSet).filter(function(i) {
                    return i !== item;
                }));
            });
        };
        var toggle = function(item) {
            return setSet(function(prevSet) {
                return prevSet.has(item) ? new Set(Array.from(prevSet).filter(function(i) {
                    return i !== item;
                })) : new Set((0, _tslib.__spreadArrays)(Array.from(prevSet), [
                    item
                ]));
            });
        };
        return {
            add: add,
            remove: remove,
            toggle: toggle,
            reset: function() {
                return setSet(initialSet);
            }
        };
    }, [
        setSet
    ]);
    var utils = (0, _tslib.__assign)({
        has: (0, _react.useCallback)(function(item) {
            return set.has(item);
        }, [
            set
        ])
    }, stableActions);
    return [
        set,
        utils
    ];
};
exports.default = useSet;

},{"tslib":"b4wpY","react":"9njXz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gJozl":[function(require,module,exports,__globalThis) {
/* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGlobalState", ()=>createGlobalState);
var _react = require("react");
var _useEffectOnce = require("./useEffectOnce");
var _useEffectOnceDefault = parcelHelpers.interopDefault(_useEffectOnce);
function createGlobalState(initialState) {
    var store = {
        state: initialState,
        setState: function(state) {
            store.state = state;
            store.setters.forEach(function(setter) {
                return setter(store.state);
            });
        },
        setters: []
    };
    return function() {
        var _a = (0, _react.useState)(store.state), globalState = _a[0], stateSetter = _a[1];
        (0, _useEffectOnceDefault.default)(function() {
            return function() {
                store.setters = store.setters.filter(function(setter) {
                    return setter !== stateSetter;
                });
            };
        });
        (0, _react.useLayoutEffect)(function() {
            if (!store.setters.includes(stateSetter)) store.setters.push(stateSetter);
        });
        return [
            globalState,
            store.setState
        ];
    };
}
exports.default = createGlobalState;

},{"react":"9njXz","./useEffectOnce":"3RRde","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8IL23":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHash", ()=>useHash);
var _react = require("react");
var _useLifecycles = require("./useLifecycles");
var _useLifecyclesDefault = parcelHelpers.interopDefault(_useLifecycles);
var useHash = function() {
    var _a = (0, _react.useState)(function() {
        return window.location.hash;
    }), hash = _a[0], setHash = _a[1];
    var onHashChange = (0, _react.useCallback)(function() {
        setHash(window.location.hash);
    }, []);
    (0, _useLifecyclesDefault.default)(function() {
        window.addEventListener('hashchange', onHashChange);
    }, function() {
        window.removeEventListener('hashchange', onHashChange);
    });
    var _setHash = (0, _react.useCallback)(function(newHash) {
        if (newHash !== hash) window.location.hash = newHash;
    }, [
        hash
    ]);
    return [
        hash,
        _setHash
    ];
};

},{"react":"9njXz","./useLifecycles":"iPmF4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8uni1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Group);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _plan = require("./plan");
var _planDefault = parcelHelpers.interopDefault(_plan);
var _context = require("../../context");
function Group(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translate, groups } = context;
            const plans = props.plans.map((plan)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planDefault.default), {
                    ...plan
                }, plan.id));
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "plans",
                children: plans
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-text":"lEpdJ","./plan":"iljWz","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iljWz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Plan);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _context = require("../../context");
var _standards = require("./standards");
var _standardsDefault = parcelHelpers.interopDefault(_standards);
var _items = require("./items");
var _itemsDefault = parcelHelpers.interopDefault(_items);
var _url = require("helpers/url");
function Plan(props) {
    const format = (date)=>(0, _momentDefault.default)(date).format('MM/DD/YYYY');
    const { content, items } = props;
    const { lessons, standards, resources } = content;
    const start = format(props.start);
    const end = format(props.finish);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            const { translate, profile, subjects, grades, groups } = context;
            const { institution, individual } = profile;
            const subject = subjects.find((subject)=>subject.id == props.subject);
            const grade = grades.find((grade)=>grade.id == props.grade);
            const group = groups.find((group)=>group.id == props.clique);
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "plan",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "plan-school info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "school",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "school"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: institution.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "teacher",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "teacher"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: `${individual.last_name}, ${individual.first_name}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "details title",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                            id: "details-title"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "plan-date info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "assigned-date"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    start == end && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: `${start}`
                                    }),
                                    start != end && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: `${start} - ${end}`
                                    })
                                ]
                            }),
                            group && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "group_label"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: group ? group.name : translate('unspecified')
                                    })
                                ]
                            }),
                            grade && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "grade",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "grade"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: grade.name
                                    })
                                ]
                            }),
                            subject && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "subject",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                                id: "subject"
                                            }),
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: subject.name
                                    })
                                ]
                            })
                        ]
                    }),
                    props.title && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-title info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "content-title"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: props.title
                                })
                            ]
                        })
                    }),
                    props.unit && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-unit info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "unit"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: props.unit
                                })
                            ]
                        })
                    }),
                    lessons && lessons.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-lessons info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactTextDefault.default), {
                                            id: "lessons_label"
                                        }),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: lessons.map((lesson)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "lesson",
                                            children: `${lesson.id}: ${lesson.name}`
                                        }, lesson.id))
                                })
                            ]
                        })
                    }),
                    resources && resources.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "plan-resources info",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        context.translate("digital-resources"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: resources.map((resource, id)=>{
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "resource",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                ...(0, _url.viewerGuard)({
                                                    href: resource.href,
                                                    target: "_blank"
                                                }),
                                                children: [
                                                    resource.title,
                                                    ": ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: resource.href
                                                    })
                                                ]
                                            })
                                        }, id);
                                    })
                                })
                            ]
                        })
                    }),
                    standards && standards.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsDefault.default), {
                        standards: standards
                    }),
                    items && items.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itemsDefault.default), {
                        items: items
                    })
                ]
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","react-text":"lEpdJ","../../context":"iUP37","./standards":"lJAod","./items":"7UYNf","helpers/url":"65SQD","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lJAod":[function(require,module,exports,__globalThis) {
// Both the planning preview and the printable HTML use the same edition-aware hierarchy.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _standardsDefault.default));
var _standards = require("../planning/preview/standards");
var _standardsDefault = parcelHelpers.interopDefault(_standards);

},{"../planning/preview/standards":"lRZc5","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7UYNf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Items);
var _jsxRuntime = require("react/jsx-runtime");
var _lodash = require("lodash");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactText = require("react-text");
var _reactTextDefault = parcelHelpers.interopDefault(_reactText);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _context = require("../../context");
function Items(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _context.Consumer), {
        children: (context)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                children: props.items.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldDefault.default), {
                        className: field.name,
                        name: field.content.name,
                        context: context,
                        sections: field.content.sections
                    }, field.id))
            });
        }
    });
}

},{"react/jsx-runtime":"1dlk8","lodash":"1qc47","react":"9njXz","react-text":"lEpdJ","./field":"5fZg2","../../context":"iUP37","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5fZg2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Field);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fieldContent = require("./field-content");
var _fieldContentDefault = parcelHelpers.interopDefault(_fieldContent);
var _utils = require("../../helpers/utils");
function Field(props) {
    const { id, name, className, context } = props;
    const sections = props.sections.map((props, contentId)=>({
            props,
            Element: (0, _fieldContentDefault.default)[props.type],
            contentId
        })).filter(({ Element, props })=>Element && !(0, _utils.isFieldEmpty)(props)).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            ...props,
            id: id,
            contentId: contentId,
            context: context
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
        children: sections.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: `${className} field-title title`,
                    children: name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "field-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        id: id,
                        className: `${className} field`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "content",
                            children: sections
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./field-content":"dcrlH","../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dcrlH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactSelect = require("react-select");
var _reactSelectDefault = parcelHelpers.interopDefault(_reactSelect);
var _utils = require("../../helpers/utils");
const types = {
    checkbox: Checkbox,
    textarea: Textarea,
    panel: Panel,
    dropdown: Dropdown
};
function Dropdown(props) {
    const { name, count, grouped, value, options, context } = props;
    const selects = value.filter((val)=>val != '').map((val, index)=>{
        const label = value.length < 2 ? name : `${name} ${index + 1}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "select",
            children: [
                !grouped && name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: label
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "control",
                    children: val || " "
                })
            ]
        }, index);
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            grouped && /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            selects
        ]
    });
}
function Checkbox(props) {
    const { context } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "checkbox",
                    checked: props.value,
                    readOnly: true
                }),
                props.name
            ]
        })
    });
}
function Textarea(props) {
    const { context, name, maxlength, value, id, panelId, contentId } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "textarea",
                children: value
            })
        ]
    });
}
function Panel(panelProps) {
    const { id, name, context } = panelProps;
    const children = panelProps.children.map((props, contentId)=>({
            props,
            Element: types[props.type],
            contentId
        })).filter(({ Element, props })=>Element && !(0, _utils.isFieldEmpty)(props)).map(({ Element, props, contentId }, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Element, {
            id: id,
            panelId: panelProps.contentId,
            contentId: contentId,
            context: context,
            ...props
        }, index));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        children: children.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                    children: name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "children",
                    children: children
                })
            ]
        })
    });
}
exports.default = types;

},{"react/jsx-runtime":"1dlk8","react":"9njXz","react-select":"j36cq","../../helpers/utils":"gGc98","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9s8Ix":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DownloadLink);
parcelHelpers.export(exports, "PDFDocument", ()=>PDFDocument);
var _jsxRuntime = require("react/jsx-runtime");
var _moment = require("moment");
var _momentDefault = parcelHelpers.interopDefault(_moment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _renderer = require("@react-pdf/renderer");
var _common = require("./common");
var _planInfo = require("./plan-info");
var _planInfoDefault = parcelHelpers.interopDefault(_planInfo);
var _standards = require("./standards");
var _standardsDefault = parcelHelpers.interopDefault(_standards);
var _field = require("./field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _styles = require("./styles");
var _stylesDefault = parcelHelpers.interopDefault(_styles);
function DownloadLink({ document, fileName, className, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.PDFDownloadLink), {
        className: className,
        fileName: fileName,
        document: document,
        children: children
    });
}
function Plan(plan) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.View), {
        style: [
            (0, _stylesDefault.default).content,
            (0, _stylesDefault.default).plan
        ],
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planInfoDefault.default), {
                ...plan
            }),
            plan.groupedStandards.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _standardsDefault.default), {
                ...plan
            }),
            plan.items.length > 0 && plan.items.map((field)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fieldDefault.default), {
                    className: field.name,
                    name: field.content.name,
                    context: plan,
                    sections: field.content.sections
                }, field.id))
        ]
    });
}
function Group({ plans, index }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
        style: [
            (0, _stylesDefault.default).group,
            (0, _stylesDefault.default)[`group${index}`]
        ],
        children: plans.length > 0 && plans.map((plan)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Plan, {
                ...plan
            }, plan.id))
    });
}
function PDFDocument({ groupMap, author, range, title }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Document), {
        style: (0, _stylesDefault.default).document,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Page), {
            size: "A4",
            style: (0, _stylesDefault.default).page,
            wrap: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _common.Header), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                            style: (0, _stylesDefault.default).headerTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                            style: (0, _stylesDefault.default).groupRange,
                            children: range
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.View), {
                    style: (0, _stylesDefault.default).groups,
                    children: Object.entries(groupMap).map(([key, plans], index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Group, {
                            plans,
                            index
                        }, key))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _renderer.Text), {
                    style: [
                        (0, _stylesDefault.default).author,
                        (0, _stylesDefault.default).footer
                    ],
                    fixed: true,
                    children: [
                        author.name,
                        " ",
                        author.lastName
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _renderer.Text), {
                    style: [
                        (0, _stylesDefault.default).paging,
                        (0, _stylesDefault.default).footer
                    ],
                    fixed: true,
                    render: (props)=>{
                        const { pageNumber, totalPages } = props;
                        return totalPages ? `${pageNumber} / ${totalPages}` : `${pageNumber}`;
                    }
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"1dlk8","moment":"1e4qG","react":"9njXz","@react-pdf/renderer":"3NU82","./common":"2jweM","./plan-info":"dICJ5","./standards":"pHJIV","./field":"6EUvL","./styles":"34LkF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aaJDy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fs = require("fs");
var _fsDefault = parcelHelpers.interopDefault(_fs);
const style = "@media screen {\n  br {\n    display: none;\n  }\n  .pdfWrapper .save {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0 10px;\n  }\n  .pdfWrapper .save .button {\n    color: #fff;\n    padding: 10px;\n    border-radius: 5px;\n    cursor: pointer;\n    background-color: #2c75bd;\n  }\n  .pdfWrapper .save .button:hover {\n    transform: scale(1.02);\n  }\n}\n.pdfWrapper {\n  width: 100%;\n  display: flex;\n  background-color: #fff;\n}\n.pdfWrapper {\n  max-width: 1280px;\n  margin: 20px auto;\n  padding: 10px;\n  background-color: #fff;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.pdfWrapper .pdfHtml {\n  padding: 5px 10px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n.pdfWrapper .pdfHtml .header {\n  display: flex;\n  border-bottom: solid 2px #2c75bd;\n  padding-bottom: 10px;\n  font-size: 12pt;\n  color: #2c75bd;\n}\n.pdfWrapper .pdfHtml .header > .title {\n  flex-grow: 1;\n  font-size: 18pt;\n}\n.pdfWrapper .pdfHtml .header .date {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.pdfWrapper .pdfHtml .header .date div {\n  display: flex;\n}\n.pdfWrapper .pdfHtml .header .date label {\n  display: inline-block;\n  width: 120px;\n  text-align: right;\n}\n.pdfWrapper .pdfHtml .header .date span {\n  margin-left: 5px;\n  flex-grow: 1;\n}\n.pdfWrapper .pdfHtml .header .date .date-range {\n  margin-top: 2px;\n}\n.pdfWrapper .pdfHtml .plan {\n  margin-top: 50px;\n  display: flex;\n  flex-direction: column;\n  border: solid 2px #2c75bd;\n}\n.pdfWrapper .pdfHtml .plan > .info {\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom: solid 2px #2c75bd;\n}\n.pdfWrapper .pdfHtml .plan > .info label {\n  font-size: 10.5pt;\n  color: #2c75bd;\n}\n.pdfWrapper .pdfHtml .plan > .info span {\n  margin-top: 3px;\n  margin-left: 5px;\n  text-transform: uppercase;\n  font-size: 12pt;\n  color: #787b7b;\n}\n.pdfWrapper .pdfHtml .plan > .info > div {\n  padding: 10px;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n.pdfWrapper .pdfHtml .plan .title {\n  font-size: 13pt;\n  padding: 10px;\n  background-color: #2c75bd;\n  color: #fff;\n}\n.pdfWrapper .pdfHtml .plan .standards,\n.pdfWrapper .pdfHtml .plan .standard,\n.pdfWrapper .pdfHtml .plan .expectations,\n.pdfWrapper .pdfHtml .plan .expectation,\n.pdfWrapper .pdfHtml .plan .indicators {\n  display: flex;\n  flex-direction: column;\n}\n.pdfWrapper .pdfHtml .plan .standards .standard {\n  padding: 10px;\n}\n.pdfWrapper .pdfHtml .plan .standards .standard .standard-title {\n  font-size: 10.5pt;\n  color: #2c75bd;\n}\n.pdfWrapper .pdfHtml .plan .standards .standard .expectations {\n  color: #787b7b;\n}\n.pdfWrapper .pdfHtml .plan .standards .standard .expectations .expectation {\n  padding: 10px;\n}\n.pdfWrapper .pdfHtml .plan .standards .standard .expectations .expectation .indicator {\n  padding: 10px;\n}\n.pdfWrapper .pdfHtml .plan .standards .standard .expectations .expectation .indicator .indicator-code {\n  font-weight: bold;\n}\n.pdfWrapper .pdfHtml .plan .standards .standard .expectations .expectation .indicator .indicator-name {\n  margin-top: 5px;\n}\n.pdfWrapper .field-wrapper {\n  padding: 0 15px;\n}\n.pdfWrapper .field {\n  color: #787b7b;\n}\n.pdfWrapper .field .content {\n  display: flex;\n  flex-wrap: wrap;\n}\n.pdfWrapper .field.objectives .content {\n  display: flex;\n  flex-direction: column;\n}\n.pdfWrapper .field.objectives .content > div {\n  display: flex;\n  flex-direction: column;\n}\n.pdfWrapper .field.objectives .content > div > label {\n  color: #2c75bd;\n  margin-top: 20px;\n  margin-bottom: 5px;\n}\n.pdfWrapper .field.objectives .content > div .children {\n  display: flex;\n  padding: 0 10px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n.pdfWrapper .field.objectives .content > div .children > div:first-child {\n  font-weight: bold;\n}\n.pdfWrapper .field.objectives .content > div .children > div:first-child .control:after {\n  margin-left: 2px;\n  margin-right: 5px;\n  content: ':';\n}\n.pdfWrapper .field.objectives .content > div .children > div:last-child {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-right: 15px;\n  width: 100%;\n  text-align: justify;\n}\n.pdfWrapper .field.concepts .content {\n  margin: 20px 0;\n}\n.pdfWrapper .field.concepts .content > div > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.concepts .content > div > .textarea {\n  padding: 10px 0 0 10px;\n  text-align: justify;\n}\n.pdfWrapper .field.strategies .content {\n  margin: 10px 0 20px 0;\n}\n.pdfWrapper .field.strategies .content > div:first-child {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.pdfWrapper .field.strategies .content > div:first-child > div {\n  margin-top: 10px;\n  flex-grow: 1;\n}\n.pdfWrapper .field.strategies .content > div:first-child > div > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.strategies .content > div:first-child > div > div {\n  margin-top: 8px;\n}\n.pdfWrapper .field.strategies .content > div:last-child {\n  margin-top: 20px;\n}\n.pdfWrapper .field.strategies .content > div:last-child > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.strategies .content > div:last-child > .textarea {\n  padding: 10px 0 0 10px;\n  text-align: justify;\n}\n.pdfWrapper .field.level .content {\n  margin: 10px 0 20px 0;\n  justify-content: flex-start;\n}\n.pdfWrapper .field.level .content > div {\n  flex-grow: 1;\n  margin-top: 10px;\n  margin-right: 10px;\n}\n.pdfWrapper .field.activity-beginning,\n.pdfWrapper .field.activity-development,\n.pdfWrapper .field.activity-ending {\n  margin: 10px 0 20px 0;\n}\n.pdfWrapper .field.activity-beginning .content > div,\n.pdfWrapper .field.activity-development .content > div,\n.pdfWrapper .field.activity-ending .content > div {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.pdfWrapper .field.activity-beginning .content > div:first-child,\n.pdfWrapper .field.activity-development .content > div:first-child,\n.pdfWrapper .field.activity-ending .content > div:first-child {\n  margin-top: 10px;\n}\n.pdfWrapper .field.activity-beginning .content > div:first-child > label,\n.pdfWrapper .field.activity-development .content > div:first-child > label,\n.pdfWrapper .field.activity-ending .content > div:first-child > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.activity-beginning .content > div:first-child > .select,\n.pdfWrapper .field.activity-development .content > div:first-child > .select,\n.pdfWrapper .field.activity-ending .content > div:first-child > .select {\n  margin-top: 10px;\n  margin-left: 10px;\n}\n.pdfWrapper .field.activity-beginning .content > div:last-child,\n.pdfWrapper .field.activity-development .content > div:last-child,\n.pdfWrapper .field.activity-ending .content > div:last-child {\n  margin-top: 20px;\n}\n.pdfWrapper .field.activity-beginning .content > div:last-child > label,\n.pdfWrapper .field.activity-development .content > div:last-child > label,\n.pdfWrapper .field.activity-ending .content > div:last-child > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.activity-beginning .content > div:last-child > .textarea,\n.pdfWrapper .field.activity-development .content > div:last-child > .textarea,\n.pdfWrapper .field.activity-ending .content > div:last-child > .textarea {\n  padding: 10px 0 0 10px;\n  text-align: justify;\n}\n.pdfWrapper .field.connection {\n  margin: 0 0 20px 0;\n}\n.pdfWrapper .field.connection .content {\n  display: flex;\n  flex-direction: column;\n}\n.pdfWrapper .field.connection .content > div {\n  margin-top: 20px;\n}\n.pdfWrapper .field.connection .content > div > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.connection .content > div > .children {\n  padding-left: 10px;\n}\n.pdfWrapper .field.connection .content > div > .children > div {\n  margin-top: 8px;\n}\n.pdfWrapper .field.differentiated-strategy {\n  margin: 10px 0 20px 0;\n}\n.pdfWrapper .field.differentiated-strategy .content > div {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child {\n  margin-top: 10px;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child > .children {\n  padding-left: 10px;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child > .children > div {\n  margin-top: 10px;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child > .children > div .select {\n  display: flex;\n  flex-wrap: wrap;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child > .children > div .select label {\n  font-weight: bold;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child > .children > div .select label:after {\n  content: ':';\n}\n.pdfWrapper .field.differentiated-strategy .content > div:first-child > .children > div .select .control {\n  margin-left: 5px;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:last-child {\n  margin-top: 20px;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:last-child > label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:last-child > .children {\n  padding-left: 10px;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:last-child > .children > div {\n  margin-top: 10px;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:last-child > .children > div:last-child label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.differentiated-strategy .content > div:last-child > .children > div:last-child .textarea {\n  padding: 10px 0 0 10px;\n  text-align: justify;\n}\n.pdfWrapper .field.evaluation,\n.pdfWrapper .field.materials,\n.pdfWrapper .field.technology-resources {\n  margin: 10px 0 20px 0;\n}\n.pdfWrapper .field.evaluation .content > div,\n.pdfWrapper .field.materials .content > div,\n.pdfWrapper .field.technology-resources .content > div {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.pdfWrapper .field.evaluation .content > div:first-child .select,\n.pdfWrapper .field.materials .content > div:first-child .select,\n.pdfWrapper .field.technology-resources .content > div:first-child .select {\n  margin-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.pdfWrapper .field.evaluation .content > div:first-child .select label,\n.pdfWrapper .field.materials .content > div:first-child .select label,\n.pdfWrapper .field.technology-resources .content > div:first-child .select label {\n  font-weight: bold;\n}\n.pdfWrapper .field.evaluation .content > div:first-child .select label:after,\n.pdfWrapper .field.materials .content > div:first-child .select label:after,\n.pdfWrapper .field.technology-resources .content > div:first-child .select label:after {\n  content: ':';\n}\n.pdfWrapper .field.evaluation .content > div:first-child .select .control,\n.pdfWrapper .field.materials .content > div:first-child .select .control,\n.pdfWrapper .field.technology-resources .content > div:first-child .select .control {\n  margin-left: 5px;\n}\n.pdfWrapper .field.evaluation .content > div:last-child,\n.pdfWrapper .field.materials .content > div:last-child,\n.pdfWrapper .field.technology-resources .content > div:last-child {\n  margin-top: 20px;\n}\n.pdfWrapper .field.evaluation .content > div:last-child label,\n.pdfWrapper .field.materials .content > div:last-child label,\n.pdfWrapper .field.technology-resources .content > div:last-child label {\n  color: #2c75bd;\n}\n.pdfWrapper .field.evaluation .content > div:last-child .textarea,\n.pdfWrapper .field.materials .content > div:last-child .textarea,\n.pdfWrapper .field.technology-resources .content > div:last-child .textarea {\n  padding: 10px 0 0 10px;\n  text-align: justify;\n}\n.pdfWrapper .field.assignment .content {\n  margin: 10px 0 20px 0;\n  justify-content: flex-start;\n}\n.pdfWrapper .field.assignment .content > div {\n  flex-grow: 1;\n  margin-top: 10px;\n  margin-right: 10px;\n}\n.pdfWrapper .field.assignment .content > div:last-child {\n  margin-left: 4px;\n  width: 100%;\n}\n.pdfWrapper .field.annotations {\n  margin: 10px 0 20px 0;\n}\n.pdfWrapper .field.annotations > div .textarea {\n  padding: 10px 0 0 10px;\n  text-align: justify;\n}\n@media print {\n  div {\n    position: relative !important;\n    width: auto !important;\n    height: auto !important;\n    display: block !important;\n    overflow: visible !important;\n    margin-left: 0 !important;\n    background-color: none;\n  }\n  html,\n  body,\n  #root {\n    -webkit-print-color-adjust: exact !important;\n    overflow: visible !important;\n    background-color: #fff !important;\n    width: 100%;\n  }\n  #root {\n    width: 100%;\n    overflow: visible !important;\n    background-color: none;\n  }\n  .pdfWrapper {\n    padding: 0 !important;\n    margin: 0 auto !important;\n    background-color: #fff !important;\n    overflow: visible !important;\n    position: absolute !important;\n    display: flex !important;\n    width: 100% !important;\n    top: 0 !important;\n  }\n  .pdfWrapper .save {\n    display: none !important;\n  }\n  .pdfWrapper .header {\n    padding: 20px;\n  }\n  .pdfHtml {\n    background-color: none;\n    border: none;\n    height: 100%;\n    width: 100%;\n    max-width: 100%;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  .pdfHtml .plans {\n    overflow: visible !important;\n    background-color: none;\n    padding: 0;\n  }\n  .pdfHtml .plans .plan {\n    border: none !important;\n    background-color: none;\n  }\n}\n";
exports.default = style;

},{"fs":"aBjM4","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"QRFF0":[function() {},{}],"lQMWj":[function(require,module,exports,__globalThis) {
/* global window, exports, define */ !function() {
    'use strict';
    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    };
    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments);
    }
    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [
            fmt
        ].concat(argv || []));
    }
    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign;
        for(i = 0; i < tree_length; i++){
            if (typeof parse_tree[i] === 'string') output += parse_tree[i];
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                ;
                if (ph.keys) {
                    arg = argv[cursor];
                    for(k = 0; k < ph.keys.length; k++){
                        if (arg == undefined) throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k - 1]));
                        arg = arg[ph.keys[k]];
                    }
                } else if (ph.param_no) arg = argv[ph.param_no];
                else arg = argv[cursor++];
                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) arg = arg();
                if (re.numeric_arg.test(ph.type) && typeof arg !== 'number' && isNaN(arg)) throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg));
                if (re.number.test(ph.type)) is_positive = arg >= 0;
                switch(ph.type){
                    case 'b':
                        arg = parseInt(arg, 10).toString(2);
                        break;
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10));
                        break;
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10);
                        break;
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0);
                        break;
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential();
                        break;
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg);
                        break;
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg);
                        break;
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8);
                        break;
                    case 's':
                        arg = String(arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 't':
                        arg = String(!!arg);
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0;
                        break;
                    case 'v':
                        arg = arg.valueOf();
                        arg = ph.precision ? arg.substring(0, ph.precision) : arg;
                        break;
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16);
                        break;
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase();
                        break;
                }
                if (re.json.test(ph.type)) output += arg;
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-';
                        arg = arg.toString().replace(re.sign, '');
                    } else sign = '';
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' ';
                    pad_length = ph.width - (sign + arg).length;
                    pad = ph.width ? pad_length > 0 ? pad_character.repeat(pad_length) : '' : '';
                    output += ph.align ? sign + arg + pad : pad_character === '0' ? sign + pad + arg : pad + sign + arg;
                }
            }
        }
        return output;
    }
    var sprintf_cache = Object.create(null);
    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) return sprintf_cache[fmt];
        var _fmt = fmt, match, parse_tree = [], arg_names = 0;
        while(_fmt){
            if ((match = re.text.exec(_fmt)) !== null) parse_tree.push(match[0]);
            else if ((match = re.modulo.exec(_fmt)) !== null) parse_tree.push('%');
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1;
                    var field_list = [], replacement_field = match[2], field_match = [];
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1]);
                        while((replacement_field = replacement_field.substring(field_match[0].length)) !== ''){
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) field_list.push(field_match[1]);
                            else throw new SyntaxError('[sprintf] failed to parse named argument key');
                        }
                    } else throw new SyntaxError('[sprintf] failed to parse named argument key');
                    match[2] = field_list;
                } else arg_names |= 2;
                if (arg_names === 3) throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported');
                parse_tree.push({
                    placeholder: match[0],
                    param_no: match[1],
                    keys: match[2],
                    sign: match[3],
                    pad_char: match[4],
                    align: match[5],
                    width: match[6],
                    precision: match[7],
                    type: match[8]
                });
            } else throw new SyntaxError('[sprintf] unexpected placeholder');
            _fmt = _fmt.substring(match[0].length);
        }
        return sprintf_cache[fmt] = parse_tree;
    }
    exports['sprintf'] = sprintf;
    exports['vsprintf'] = vsprintf;
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf;
        window['vsprintf'] = vsprintf;
        if (typeof define === 'function' && define['amd']) define(function() {
            return {
                'sprintf': sprintf,
                'vsprintf': vsprintf
            };
        });
    }
/* eslint-enable quote-props */ }(); // eslint-disable-line

},{}],"6e0eV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Chat);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexStyl = require("./index.styl");
const disabled = true;
function Chat(props) {
    const htmlRef = /*#__PURE__*/ (0, _reactDefault.default).createRef();
    //const [initialized, setInitialized] = React.useState(false)
    /*
  React.useEffect(() => {
    if (!disabled && converse && props.settings && htmlRef.current && props.loaded && !initialized) {
      const view_mode = 'embedded' //props.width >= 950 ? 'embedded' : 'mobile'
      converse.initialize({
        ...props.settings,
        view_mode,
        i18n: props.languageId,
        refresh_profile_handler: async (user,_converse) => {
          _converse.roster.data.save('version', null);
          props.reloadSettings()
          await user.logout()
          setInitialized(false)
        }
      })
      setInitialized(true)
    }
  }, [htmlRef, props.loaded, initialized])
  */ (0, _reactDefault.default).useEffect(()=>{
        if (htmlRef.current) {
            window.chatContainer = htmlRef.current;
            window.onChatContainer && window.onChatContainer(htmlRef.current, props.pageName);
        }
    }, [
        props.pageName,
        htmlRef
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: "conversejs",
        ref: htmlRef,
        style: props.style
    });
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","./index.styl":"cyT6Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cyT6Q":[function() {},{}],"jxjTT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>theme);
parcelHelpers.export(exports, "ThemeProvider", ()=>(0, _material.ThemeProvider));
parcelHelpers.export(exports, "StyledEngineProvider", ()=>(0, _material.StyledEngineProvider));
parcelHelpers.export(exports, "LegacyThemeProvider", ()=>(0, _material.LegacyThemeProvider));
var _material = require("external/material");
const theme = (0, _material.createTheme)();

},{"external/material":"6yEDE","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"43gbr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getProfile", ()=>getProfile);
parcelHelpers.export(exports, "getFullName", ()=>getFullName);
parcelHelpers.export(exports, "createLogoutHandler", ()=>createLogoutHandler);
parcelHelpers.export(exports, "keepAlive", ()=>keepAlive);
var _url = require("./url");
var _command = require("./command");
var _commandDefault = parcelHelpers.interopDefault(_command);
var _post = require("context/post");
const getProfile = (0, _command.createPublic)('myinfo');
function getFullName({ first_name, middle_name, last_name, maiden_name }) {
    return `${first_name} ${middle_name || ''} ${last_name} ${maiden_name || ''}`;
}
function createLogoutHandler(language, project) {
    return async ()=>{
        await (0, _post.logout)();
        const url = (0, _url.inViewer) ? '//logout' : (0, _url.subdomainLink)(project == 'de' ? 'de' : 'www', language, 'login.html');
        location.replace(url);
    };
}
async function keepAlive() {
    return (0, _commandDefault.default)('security', 'keepAlive')();
}

},{"./url":"65SQD","./command":"f3cbG","context/post":"8rmpk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lu9ca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>KeepAliveForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _dateFns = require("external/date-fns");
var _intervalCallback = require("hooks/interval-callback");
var _intervalCallbackDefault = parcelHelpers.interopDefault(_intervalCallback);
var _context = require("teacher/context");
var _users = require("helpers/users");
var _timer = require("components/Timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
const StyledDialog = (0, _material.styled)((0, _material.Dialog))(dialogStyles);
const id = 'keep-alive-form';
const keepAliveLeeway = 60;
function KeepAliveForm() {
    const { translate, refreshProfile, profile, languageId } = (0, _react.useContext)((0, _context.TeacherContext));
    const { institution: { project }, expiration } = profile || {
        institution: {},
        expiration: 0
    };
    const [open, setOpen] = (0, _react.useState)(false);
    const target = (0, _react.useMemo)(()=>(0, _dateFns.subSeconds)(expiration, keepAliveLeeway), [
        expiration
    ]);
    (0, _intervalCallbackDefault.default)(()=>{
        setOpen(true);
    }, target);
    const handleLogout = (0, _react.useMemo)(()=>(0, _users.createLogoutHandler)(languageId, project), [
        project,
        languageId
    ]);
    const handleKeepAlive = (0, _react.useCallback)(()=>{
        (0, _users.keepAlive)().then(async ()=>{
            await refreshProfile();
            setOpen(false);
        }).catch(handleLogout);
    }, []);
    const titleId = `${id}-title`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDialog, {
        open: open,
        "aria-labelledby": titleId,
        disableEscapeKeyDown: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogTitle), {
                id: titleId,
                className: "title-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    className: "title",
                    children: translate(`${id}-title`)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogContent), {
                className: "content-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                    className: "content",
                    children: translate(`${id}-message`, {
                        project: translate(`${project}_project_title`)
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Fade), {
                in: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.DialogActions), {
                    className: "actions-container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
                        className: "actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Button), {
                                variant: "contained",
                                color: "background",
                                className: (0, _material.clsx)('button', 'keep-alive'),
                                onClick: handleKeepAlive,
                                children: translate(`${id}-keep-alive`)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Button), {
                                variant: "contained",
                                color: "error",
                                className: (0, _material.clsx)('button', "logout"),
                                onClick: handleLogout,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "label",
                                        children: translate(`${id}-logout`)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timerDefault.default), {
                                        className: "logout-timer",
                                        startWrapper: "(",
                                        endWrapper: ")",
                                        startsAt: expiration,
                                        onExpiration: handleLogout,
                                        format: (i)=>i
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function dialogStyles() {
    return {
        display: 'flex',
        justifyContent: 'center',
        "& .MuiPaper-root": {
            maxWidth: 600
        },
        "& .title-container": {
            display: 'flex',
            justifyContent: 'center'
        },
        "& .content-container": {
            display: 'flex',
            padding: '0px 15px 15px 15px',
            justifyContent: 'center',
            "& .content": {
                maxWidth: 400,
                textAlign: 'justify'
            }
        },
        "& .actions-container": {
            display: 'flex',
            padding: '0px 15px 15px 15px',
            '& .actions': {
                flexGrow: 1,
                display: 'flex',
                justifyContent: 'flex-end',
                '& .button': {
                    width: 100,
                    display: 'flex',
                    "& .label": {
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center'
                    },
                    "&.logout": {
                        marginLeft: 20
                    },
                    "& .logout-timer": {
                        marginLeft: 5,
                        display: "flex"
                    }
                }
            }
        }
    };
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","external/date-fns":"kwxNe","hooks/interval-callback":"azmBK","teacher/context":"5LKDx","helpers/users":"43gbr","components/Timer":"iV4hO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"azmBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useIntervalCallback);
var _dateFns = require("external/date-fns");
var _react = require("external/react");
function useIntervalCallback(callback, target) {
    const savedCallback = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, _react.useEffect)(()=>{
        const delay = getMilliseconds(target);
        function tick() {
            savedCallback.current();
        }
        if (!isNaN(delay)) {
            let id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        target
    ]);
}
function getMilliseconds(delay) {
    if ((0, _dateFns.isDate)(delay)) return Math.max((0, _dateFns.secondsToDate)(delay), 1) * 1000;
    return NaN;
}

},{"external/date-fns":"kwxNe","external/react":"k16GP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iV4hO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Timer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _material = require("external/material");
var _dateFns = require("external/date-fns");
var _interval = require("hooks/interval");
var _intervalDefault = parcelHelpers.interopDefault(_interval);
function Timer(props) {
    const { onExpiration, startsAt, className, format = formatCountDown, startWrapper, endWrapper } = props;
    const [count, setCount] = (0, _react.useState)(0);
    (0, _intervalDefault.default)(()=>{
        const newCount = count - 1;
        setCount(newCount);
        if (newCount <= 0) onExpiration && onExpiration();
    }, count > 0 ? 1000 : null);
    (0, _react.useEffect)(()=>{
        if (startsAt) {
            const remaining = (0, _dateFns.secondsToDate)(startsAt);
            setCount(remaining);
        }
    }, [
        startsAt
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _material.Box), {
        className: (0, _material.clsx)("timer-wrapper", className),
        children: [
            startWrapper && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "start-wrapper",
                children: startWrapper
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "timer-container",
                children: format(count)
            }),
            endWrapper && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _material.Box), {
                className: "end-wrapper",
                children: endWrapper
            })
        ]
    });
}
function formatCountDown(time) {
    const hours = Math.floor(time / 3600).toString().padStart(2, 0);
    const minutes = Math.floor(time % 3600 / 60).toString().padStart(2, 0);
    const seconds = Math.floor(time % 60).toString().padStart(2, 0);
    return `${hours}:${minutes}:${seconds}`;
}

},{"react/jsx-runtime":"1dlk8","react":"9njXz","external/material":"6yEDE","external/date-fns":"kwxNe","hooks/interval":"9KMse","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9KMse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useInterval);
var _react = require("external/react");
function useInterval(callback, delay) {
    const savedCallback = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, _react.useEffect)(()=>{
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return ()=>clearInterval(id);
        }
    }, [
        delay
    ]);
}

},{"external/react":"k16GP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aBKOk":[function() {},{}]},["dP88C","3GKxx"], "3GKxx", "parcelRequire94c2")

//# sourceMappingURL=index.3d203811.js.map
